(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirec080"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirec080"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("1tQWc", function(module, exports) {

$parcel$export(module.exports, "Color", function () { return Color; });
$parcel$export(module.exports, "darker", function () { return darker; });
$parcel$export(module.exports, "brighter", function () { return brighter; });
$parcel$export(module.exports, "default", function () { return color; });
$parcel$export(module.exports, "hslConvert", function () { return hslConvert; });
$parcel$export(module.exports, "Rgb", function () { return Rgb; });
$parcel$export(module.exports, "rgbConvert", function () { return rgbConvert; });
$parcel$export(module.exports, "rgb", function () { return rgb; });
$parcel$export(module.exports, "hsl", function () { return hsl; });

var $imKCb = parcelRequire("imKCb");
function Color() {}
var darker = 0.7;
var brighter = 1 / darker;
var reI = "\\s*([+-]?\\d+)\\s*", reN = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex = /^#([0-9a-f]{3,8})$/, reRgbInteger = new RegExp(`^rgb\\(${reI},${reI},${reI}\\)$`), reRgbPercent = new RegExp(`^rgb\\(${reP},${reP},${reP}\\)$`), reRgbaInteger = new RegExp(`^rgba\\(${reI},${reI},${reI},${reN}\\)$`), reRgbaPercent = new RegExp(`^rgba\\(${reP},${reP},${reP},${reN}\\)$`), reHslPercent = new RegExp(`^hsl\\(${reN},${reP},${reP}\\)$`), reHslaPercent = new RegExp(`^hsla\\(${reN},${reP},${reP},${reN}\\)$`);
var named = {
    aliceblue: 0xf0f8ff,
    antiquewhite: 0xfaebd7,
    aqua: 0x00ffff,
    aquamarine: 0x7fffd4,
    azure: 0xf0ffff,
    beige: 0xf5f5dc,
    bisque: 0xffe4c4,
    black: 0x000000,
    blanchedalmond: 0xffebcd,
    blue: 0x0000ff,
    blueviolet: 0x8a2be2,
    brown: 0xa52a2a,
    burlywood: 0xdeb887,
    cadetblue: 0x5f9ea0,
    chartreuse: 0x7fff00,
    chocolate: 0xd2691e,
    coral: 0xff7f50,
    cornflowerblue: 0x6495ed,
    cornsilk: 0xfff8dc,
    crimson: 0xdc143c,
    cyan: 0x00ffff,
    darkblue: 0x00008b,
    darkcyan: 0x008b8b,
    darkgoldenrod: 0xb8860b,
    darkgray: 0xa9a9a9,
    darkgreen: 0x006400,
    darkgrey: 0xa9a9a9,
    darkkhaki: 0xbdb76b,
    darkmagenta: 0x8b008b,
    darkolivegreen: 0x556b2f,
    darkorange: 0xff8c00,
    darkorchid: 0x9932cc,
    darkred: 0x8b0000,
    darksalmon: 0xe9967a,
    darkseagreen: 0x8fbc8f,
    darkslateblue: 0x483d8b,
    darkslategray: 0x2f4f4f,
    darkslategrey: 0x2f4f4f,
    darkturquoise: 0x00ced1,
    darkviolet: 0x9400d3,
    deeppink: 0xff1493,
    deepskyblue: 0x00bfff,
    dimgray: 0x696969,
    dimgrey: 0x696969,
    dodgerblue: 0x1e90ff,
    firebrick: 0xb22222,
    floralwhite: 0xfffaf0,
    forestgreen: 0x228b22,
    fuchsia: 0xff00ff,
    gainsboro: 0xdcdcdc,
    ghostwhite: 0xf8f8ff,
    gold: 0xffd700,
    goldenrod: 0xdaa520,
    gray: 0x808080,
    green: 0x008000,
    greenyellow: 0xadff2f,
    grey: 0x808080,
    honeydew: 0xf0fff0,
    hotpink: 0xff69b4,
    indianred: 0xcd5c5c,
    indigo: 0x4b0082,
    ivory: 0xfffff0,
    khaki: 0xf0e68c,
    lavender: 0xe6e6fa,
    lavenderblush: 0xfff0f5,
    lawngreen: 0x7cfc00,
    lemonchiffon: 0xfffacd,
    lightblue: 0xadd8e6,
    lightcoral: 0xf08080,
    lightcyan: 0xe0ffff,
    lightgoldenrodyellow: 0xfafad2,
    lightgray: 0xd3d3d3,
    lightgreen: 0x90ee90,
    lightgrey: 0xd3d3d3,
    lightpink: 0xffb6c1,
    lightsalmon: 0xffa07a,
    lightseagreen: 0x20b2aa,
    lightskyblue: 0x87cefa,
    lightslategray: 0x778899,
    lightslategrey: 0x778899,
    lightsteelblue: 0xb0c4de,
    lightyellow: 0xffffe0,
    lime: 0x00ff00,
    limegreen: 0x32cd32,
    linen: 0xfaf0e6,
    magenta: 0xff00ff,
    maroon: 0x800000,
    mediumaquamarine: 0x66cdaa,
    mediumblue: 0x0000cd,
    mediumorchid: 0xba55d3,
    mediumpurple: 0x9370db,
    mediumseagreen: 0x3cb371,
    mediumslateblue: 0x7b68ee,
    mediumspringgreen: 0x00fa9a,
    mediumturquoise: 0x48d1cc,
    mediumvioletred: 0xc71585,
    midnightblue: 0x191970,
    mintcream: 0xf5fffa,
    mistyrose: 0xffe4e1,
    moccasin: 0xffe4b5,
    navajowhite: 0xffdead,
    navy: 0x000080,
    oldlace: 0xfdf5e6,
    olive: 0x808000,
    olivedrab: 0x6b8e23,
    orange: 0xffa500,
    orangered: 0xff4500,
    orchid: 0xda70d6,
    palegoldenrod: 0xeee8aa,
    palegreen: 0x98fb98,
    paleturquoise: 0xafeeee,
    palevioletred: 0xdb7093,
    papayawhip: 0xffefd5,
    peachpuff: 0xffdab9,
    peru: 0xcd853f,
    pink: 0xffc0cb,
    plum: 0xdda0dd,
    powderblue: 0xb0e0e6,
    purple: 0x800080,
    rebeccapurple: 0x663399,
    red: 0xff0000,
    rosybrown: 0xbc8f8f,
    royalblue: 0x4169e1,
    saddlebrown: 0x8b4513,
    salmon: 0xfa8072,
    sandybrown: 0xf4a460,
    seagreen: 0x2e8b57,
    seashell: 0xfff5ee,
    sienna: 0xa0522d,
    silver: 0xc0c0c0,
    skyblue: 0x87ceeb,
    slateblue: 0x6a5acd,
    slategray: 0x708090,
    slategrey: 0x708090,
    snow: 0xfffafa,
    springgreen: 0x00ff7f,
    steelblue: 0x4682b4,
    tan: 0xd2b48c,
    teal: 0x008080,
    thistle: 0xd8bfd8,
    tomato: 0xff6347,
    turquoise: 0x40e0d0,
    violet: 0xee82ee,
    wheat: 0xf5deb3,
    white: 0xffffff,
    whitesmoke: 0xf5f5f5,
    yellow: 0xffff00,
    yellowgreen: 0x9acd32
};
(0, $imKCb.default)(Color, color, {
    copy (channels) {
        return Object.assign(new this.constructor, this, channels);
    },
    displayable () {
        return this.rgb().displayable();
    },
    hex: color_formatHex,
    formatHex: color_formatHex,
    formatHex8: color_formatHex8,
    formatHsl: color_formatHsl,
    formatRgb: color_formatRgb,
    toString: color_formatRgb
});
function color_formatHex() {
    return this.rgb().formatHex();
}
function color_formatHex8() {
    return this.rgb().formatHex8();
}
function color_formatHsl() {
    return hslConvert(this).formatHsl();
}
function color_formatRgb() {
    return this.rgb().formatRgb();
}
function color(format) {
    var m, l;
    format = (format + "").trim().toLowerCase();
    return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
     : l === 3 ? new Rgb(m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
     : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
     : l === 4 ? rgba(m >> 12 & 0xf | m >> 8 & 0xf0, m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, ((m & 0xf) << 4 | m & 0xf) / 0xff) // #f000
     : null // invalid hex
    ) : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
     : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
     : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
     : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
     : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
     : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
     : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
     : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}
function rgbn(n) {
    return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}
function rgba(r, g, b, a) {
    if (a <= 0) r = g = b = NaN;
    return new Rgb(r, g, b, a);
}
function rgbConvert(o) {
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Rgb;
    o = o.rgb();
    return new Rgb(o.r, o.g, o.b, o.opacity);
}
function rgb(r, g, b, opacity) {
    return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}
function Rgb(r, g, b, opacity) {
    this.r = +r;
    this.g = +g;
    this.b = +b;
    this.opacity = +opacity;
}
(0, $imKCb.default)(Rgb, rgb, (0, $imKCb.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    rgb () {
        return this;
    },
    clamp () {
        return new Rgb(clampi(this.r), clampi(this.g), clampi(this.b), clampa(this.opacity));
    },
    displayable () {
        return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
    },
    hex: rgb_formatHex,
    formatHex: rgb_formatHex,
    formatHex8: rgb_formatHex8,
    formatRgb: rgb_formatRgb,
    toString: rgb_formatRgb
}));
function rgb_formatHex() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}`;
}
function rgb_formatHex8() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}${hex((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function rgb_formatRgb() {
    const a = clampa(this.opacity);
    return `${a === 1 ? "rgb(" : "rgba("}${clampi(this.r)}, ${clampi(this.g)}, ${clampi(this.b)}${a === 1 ? ")" : `, ${a})`}`;
}
function clampa(opacity) {
    return isNaN(opacity) ? 1 : Math.max(0, Math.min(1, opacity));
}
function clampi(value) {
    return Math.max(0, Math.min(255, Math.round(value) || 0));
}
function hex(value) {
    value = clampi(value);
    return (value < 16 ? "0" : "") + value.toString(16);
}
function hsla(h, s, l, a) {
    if (a <= 0) h = s = l = NaN;
    else if (l <= 0 || l >= 1) h = s = NaN;
    else if (s <= 0) h = NaN;
    return new Hsl(h, s, l, a);
}
function hslConvert(o) {
    if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Hsl;
    if (o instanceof Hsl) return o;
    o = o.rgb();
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), h = NaN, s = max - min, l = (max + min) / 2;
    if (s) {
        if (r === max) h = (g - b) / s + (g < b) * 6;
        else if (g === max) h = (b - r) / s + 2;
        else h = (r - g) / s + 4;
        s /= l < 0.5 ? max + min : 2 - max - min;
        h *= 60;
    } else s = l > 0 && l < 1 ? 0 : h;
    return new Hsl(h, s, l, o.opacity);
}
function hsl(h, s, l, opacity) {
    return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}
function Hsl(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, $imKCb.default)(Hsl, hsl, (0, $imKCb.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    rgb () {
        var h = this.h % 360 + (this.h < 0) * 360, s = isNaN(h) || isNaN(this.s) ? 0 : this.s, l = this.l, m2 = l + (l < 0.5 ? l : 1 - l) * s, m1 = 2 * l - m2;
        return new Rgb(hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb(h, m1, m2), hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
    },
    clamp () {
        return new Hsl(clamph(this.h), clampt(this.s), clampt(this.l), clampa(this.opacity));
    },
    displayable () {
        return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
    },
    formatHsl () {
        const a = clampa(this.opacity);
        return `${a === 1 ? "hsl(" : "hsla("}${clamph(this.h)}, ${clampt(this.s) * 100}%, ${clampt(this.l) * 100}%${a === 1 ? ")" : `, ${a})`}`;
    }
}));
function clamph(value) {
    value = (value || 0) % 360;
    return value < 0 ? value + 360 : value;
}
function clampt(value) {
    return Math.max(0, Math.min(1, value || 0));
}
/* From FvD 13.37, CSS Color Module Level 3 */ function hsl2rgb(h, m1, m2) {
    return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}

});
parcelRegister("imKCb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d5ee70cd754aa323$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "extend", function () { return $d5ee70cd754aa323$export$8b58be045bf06082; });
function $d5ee70cd754aa323$export$2e2bcd8739ae039(constructor, factory, prototype) {
    constructor.prototype = factory.prototype = prototype;
    prototype.constructor = constructor;
}
function $d5ee70cd754aa323$export$8b58be045bf06082(parent, definition) {
    var prototype = Object.create(parent.prototype);
    for(var key in definition)prototype[key] = definition[key];
    return prototype;
}

});


parcelRegister("iLKzi", function(module, exports) {
/* @preserve
 * Leaflet 1.9.4, a JS library for interactive maps. https://leafletjs.com
 * (c) 2010-2023 Vladimir Agafonkin, (c) 2010-2011 CloudMade
 */ (function(global, factory) {
    factory(module.exports);
})(module.exports, function(exports1) {
    "use strict";
    var version = "1.9.4";
    /*
   * @namespace Util
   *
   * Various utility functions, used by Leaflet internally.
   */ // @function extend(dest: Object, src?: Object): Object
    // Merges the properties of the `src` object (or multiple objects) into `dest` object and returns the latter. Has an `L.extend` shortcut.
    function extend(dest) {
        var i, j, len, src;
        for(j = 1, len = arguments.length; j < len; j++){
            src = arguments[j];
            for(i in src)dest[i] = src[i];
        }
        return dest;
    }
    // @function create(proto: Object, properties?: Object): Object
    // Compatibility polyfill for [Object.create](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/create)
    var create$2 = Object.create || function() {
        function F() {}
        return function(proto) {
            F.prototype = proto;
            return new F();
        };
    }();
    // @function bind(fn: Function, …): Function
    // Returns a new function bound to the arguments passed, like [Function.prototype.bind](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Function/bind).
    // Has a `L.bind()` shortcut.
    function bind(fn, obj) {
        var slice = Array.prototype.slice;
        if (fn.bind) return fn.bind.apply(fn, slice.call(arguments, 1));
        var args = slice.call(arguments, 2);
        return function() {
            return fn.apply(obj, args.length ? args.concat(slice.call(arguments)) : arguments);
        };
    }
    // @property lastId: Number
    // Last unique ID used by [`stamp()`](#util-stamp)
    var lastId = 0;
    // @function stamp(obj: Object): Number
    // Returns the unique ID of an object, assigning it one if it doesn't have it.
    function stamp(obj) {
        if (!("_leaflet_id" in obj)) obj["_leaflet_id"] = ++lastId;
        return obj._leaflet_id;
    }
    // @function throttle(fn: Function, time: Number, context: Object): Function
    // Returns a function which executes function `fn` with the given scope `context`
    // (so that the `this` keyword refers to `context` inside `fn`'s code). The function
    // `fn` will be called no more than one time per given amount of `time`. The arguments
    // received by the bound function will be any arguments passed when binding the
    // function, followed by any arguments passed when invoking the bound function.
    // Has an `L.throttle` shortcut.
    function throttle(fn, time, context) {
        var lock, args, wrapperFn, later;
        later = function() {
            // reset lock and call if queued
            lock = false;
            if (args) {
                wrapperFn.apply(context, args);
                args = false;
            }
        };
        wrapperFn = function() {
            if (lock) // called too soon, queue to call later
            args = arguments;
            else {
                // call and lock until later
                fn.apply(context, arguments);
                setTimeout(later, time);
                lock = true;
            }
        };
        return wrapperFn;
    }
    // @function wrapNum(num: Number, range: Number[], includeMax?: Boolean): Number
    // Returns the number `num` modulo `range` in such a way so it lies within
    // `range[0]` and `range[1]`. The returned value will be always smaller than
    // `range[1]` unless `includeMax` is set to `true`.
    function wrapNum(x, range, includeMax) {
        var max = range[1], min = range[0], d = max - min;
        return x === max && includeMax ? x : ((x - min) % d + d) % d + min;
    }
    // @function falseFn(): Function
    // Returns a function which always returns `false`.
    function falseFn() {
        return false;
    }
    // @function formatNum(num: Number, precision?: Number|false): Number
    // Returns the number `num` rounded with specified `precision`.
    // The default `precision` value is 6 decimal places.
    // `false` can be passed to skip any processing (can be useful to avoid round-off errors).
    function formatNum(num, precision) {
        if (precision === false) return num;
        var pow = Math.pow(10, precision === undefined ? 6 : precision);
        return Math.round(num * pow) / pow;
    }
    // @function trim(str: String): String
    // Compatibility polyfill for [String.prototype.trim](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/Trim)
    function trim(str) {
        return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, "");
    }
    // @function splitWords(str: String): String[]
    // Trims and splits the string on whitespace and returns the array of parts.
    function splitWords(str) {
        return trim(str).split(/\s+/);
    }
    // @function setOptions(obj: Object, options: Object): Object
    // Merges the given properties to the `options` of the `obj` object, returning the resulting options. See `Class options`. Has an `L.setOptions` shortcut.
    function setOptions(obj, options) {
        if (!Object.prototype.hasOwnProperty.call(obj, "options")) obj.options = obj.options ? create$2(obj.options) : {};
        for(var i in options)obj.options[i] = options[i];
        return obj.options;
    }
    // @function getParamString(obj: Object, existingUrl?: String, uppercase?: Boolean): String
    // Converts an object into a parameter URL string, e.g. `{a: "foo", b: "bar"}`
    // translates to `'?a=foo&b=bar'`. If `existingUrl` is set, the parameters will
    // be appended at the end. If `uppercase` is `true`, the parameter names will
    // be uppercased (e.g. `'?A=foo&B=bar'`)
    function getParamString(obj, existingUrl, uppercase) {
        var params = [];
        for(var i in obj)params.push(encodeURIComponent(uppercase ? i.toUpperCase() : i) + "=" + encodeURIComponent(obj[i]));
        return (!existingUrl || existingUrl.indexOf("?") === -1 ? "?" : "&") + params.join("&");
    }
    var templateRe = /\{ *([\w_ -]+) *\}/g;
    // @function template(str: String, data: Object): String
    // Simple templating facility, accepts a template string of the form `'Hello {a}, {b}'`
    // and a data object like `{a: 'foo', b: 'bar'}`, returns evaluated string
    // `('Hello foo, bar')`. You can also specify functions instead of strings for
    // data values — they will be evaluated passing `data` as an argument.
    function template(str, data) {
        return str.replace(templateRe, function(str, key) {
            var value = data[key];
            if (value === undefined) throw new Error("No value provided for variable " + str);
            else if (typeof value === "function") value = value(data);
            return value;
        });
    }
    // @function isArray(obj): Boolean
    // Compatibility polyfill for [Array.isArray](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/isArray)
    var isArray = Array.isArray || function(obj) {
        return Object.prototype.toString.call(obj) === "[object Array]";
    };
    // @function indexOf(array: Array, el: Object): Number
    // Compatibility polyfill for [Array.prototype.indexOf](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/indexOf)
    function indexOf(array, el) {
        for(var i = 0; i < array.length; i++){
            if (array[i] === el) return i;
        }
        return -1;
    }
    // @property emptyImageUrl: String
    // Data URI string containing a base64-encoded empty GIF image.
    // Used as a hack to free memory from unused images on WebKit-powered
    // mobile devices (by setting image `src` to this string).
    var emptyImageUrl = "data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=";
    // inspired by https://paulirish.com/2011/requestanimationframe-for-smart-animating/
    function getPrefixed(name) {
        return window["webkit" + name] || window["moz" + name] || window["ms" + name];
    }
    var lastTime = 0;
    // fallback for IE 7-8
    function timeoutDefer(fn) {
        var time = +new Date(), timeToCall = Math.max(0, 16 - (time - lastTime));
        lastTime = time + timeToCall;
        return window.setTimeout(fn, timeToCall);
    }
    var requestFn = window.requestAnimationFrame || getPrefixed("RequestAnimationFrame") || timeoutDefer;
    var cancelFn = window.cancelAnimationFrame || getPrefixed("CancelAnimationFrame") || getPrefixed("CancelRequestAnimationFrame") || function(id) {
        window.clearTimeout(id);
    };
    // @function requestAnimFrame(fn: Function, context?: Object, immediate?: Boolean): Number
    // Schedules `fn` to be executed when the browser repaints. `fn` is bound to
    // `context` if given. When `immediate` is set, `fn` is called immediately if
    // the browser doesn't have native support for
    // [`window.requestAnimationFrame`](https://developer.mozilla.org/docs/Web/API/window/requestAnimationFrame),
    // otherwise it's delayed. Returns a request ID that can be used to cancel the request.
    function requestAnimFrame(fn, context, immediate) {
        if (immediate && requestFn === timeoutDefer) fn.call(context);
        else return requestFn.call(window, bind(fn, context));
    }
    // @function cancelAnimFrame(id: Number): undefined
    // Cancels a previous `requestAnimFrame`. See also [window.cancelAnimationFrame](https://developer.mozilla.org/docs/Web/API/window/cancelAnimationFrame).
    function cancelAnimFrame(id) {
        if (id) cancelFn.call(window, id);
    }
    var Util = {
        __proto__: null,
        extend: extend,
        create: create$2,
        bind: bind,
        get lastId () {
            return lastId;
        },
        stamp: stamp,
        throttle: throttle,
        wrapNum: wrapNum,
        falseFn: falseFn,
        formatNum: formatNum,
        trim: trim,
        splitWords: splitWords,
        setOptions: setOptions,
        getParamString: getParamString,
        template: template,
        isArray: isArray,
        indexOf: indexOf,
        emptyImageUrl: emptyImageUrl,
        requestFn: requestFn,
        cancelFn: cancelFn,
        requestAnimFrame: requestAnimFrame,
        cancelAnimFrame: cancelAnimFrame
    };
    // @class Class
    // @aka L.Class
    // @section
    // @uninheritable
    // Thanks to John Resig and Dean Edwards for inspiration!
    function Class() {}
    Class.extend = function(props) {
        // @function extend(props: Object): Function
        // [Extends the current class](#class-inheritance) given the properties to be included.
        // Returns a Javascript function that is a class constructor (to be called with `new`).
        var NewClass = function() {
            setOptions(this);
            // call the constructor
            if (this.initialize) this.initialize.apply(this, arguments);
            // call all constructor hooks
            this.callInitHooks();
        };
        var parentProto = NewClass.__super__ = this.prototype;
        var proto = create$2(parentProto);
        proto.constructor = NewClass;
        NewClass.prototype = proto;
        // inherit parent's statics
        for(var i in this)if (Object.prototype.hasOwnProperty.call(this, i) && i !== "prototype" && i !== "__super__") NewClass[i] = this[i];
        // mix static properties into the class
        if (props.statics) extend(NewClass, props.statics);
        // mix includes into the prototype
        if (props.includes) {
            checkDeprecatedMixinEvents(props.includes);
            extend.apply(null, [
                proto
            ].concat(props.includes));
        }
        // mix given properties into the prototype
        extend(proto, props);
        delete proto.statics;
        delete proto.includes;
        // merge options
        if (proto.options) {
            proto.options = parentProto.options ? create$2(parentProto.options) : {};
            extend(proto.options, props.options);
        }
        proto._initHooks = [];
        // add method for calling all hooks
        proto.callInitHooks = function() {
            if (this._initHooksCalled) return;
            if (parentProto.callInitHooks) parentProto.callInitHooks.call(this);
            this._initHooksCalled = true;
            for(var i = 0, len = proto._initHooks.length; i < len; i++)proto._initHooks[i].call(this);
        };
        return NewClass;
    };
    // @function include(properties: Object): this
    // [Includes a mixin](#class-includes) into the current class.
    Class.include = function(props) {
        var parentOptions = this.prototype.options;
        extend(this.prototype, props);
        if (props.options) {
            this.prototype.options = parentOptions;
            this.mergeOptions(props.options);
        }
        return this;
    };
    // @function mergeOptions(options: Object): this
    // [Merges `options`](#class-options) into the defaults of the class.
    Class.mergeOptions = function(options) {
        extend(this.prototype.options, options);
        return this;
    };
    // @function addInitHook(fn: Function): this
    // Adds a [constructor hook](#class-constructor-hooks) to the class.
    Class.addInitHook = function(fn) {
        var args = Array.prototype.slice.call(arguments, 1);
        var init = typeof fn === "function" ? fn : function() {
            this[fn].apply(this, args);
        };
        this.prototype._initHooks = this.prototype._initHooks || [];
        this.prototype._initHooks.push(init);
        return this;
    };
    function checkDeprecatedMixinEvents(includes) {
        /* global L: true */ if (typeof L === "undefined" || !L || !L.Mixin) return;
        includes = isArray(includes) ? includes : [
            includes
        ];
        for(var i = 0; i < includes.length; i++)if (includes[i] === L.Mixin.Events) console.warn("Deprecated include of L.Mixin.Events: this property will be removed in future releases, please inherit from L.Evented instead.", new Error().stack);
    }
    /*
   * @class Evented
   * @aka L.Evented
   * @inherits Class
   *
   * A set of methods shared between event-powered classes (like `Map` and `Marker`). Generally, events allow you to execute some function when something happens with an object (e.g. the user clicks on the map, causing the map to fire `'click'` event).
   *
   * @example
   *
   * ```js
   * map.on('click', function(e) {
   * 	alert(e.latlng);
   * } );
   * ```
   *
   * Leaflet deals with event listeners by reference, so if you want to add a listener and then remove it, define it as a function:
   *
   * ```js
   * function onClick(e) { ... }
   *
   * map.on('click', onClick);
   * map.off('click', onClick);
   * ```
   */ var Events = {
        /* @method on(type: String, fn: Function, context?: Object): this
  	 * Adds a listener function (`fn`) to a particular event type of the object. You can optionally specify the context of the listener (object the this keyword will point to). You can also pass several space-separated types (e.g. `'click dblclick'`).
  	 *
  	 * @alternative
  	 * @method on(eventMap: Object): this
  	 * Adds a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
  	 */ on: function(types, fn, context) {
            // types can be a map of types/handlers
            if (typeof types === "object") for(var type in types)// we don't process space-separated events here for performance;
            // it's a hot path since Layer uses the on(obj) syntax
            this._on(type, types[type], fn);
            else {
                // types can be a string of space-separated words
                types = splitWords(types);
                for(var i = 0, len = types.length; i < len; i++)this._on(types[i], fn, context);
            }
            return this;
        },
        /* @method off(type: String, fn?: Function, context?: Object): this
  	 * Removes a previously added listener function. If no function is specified, it will remove all the listeners of that particular event from the object. Note that if you passed a custom context to `on`, you must pass the same context to `off` in order to remove the listener.
  	 *
  	 * @alternative
  	 * @method off(eventMap: Object): this
  	 * Removes a set of type/listener pairs.
  	 *
  	 * @alternative
  	 * @method off: this
  	 * Removes all listeners to all events on the object. This includes implicitly attached events.
  	 */ off: function(types, fn, context) {
            if (!arguments.length) // clear all listeners if called without arguments
            delete this._events;
            else if (typeof types === "object") for(var type in types)this._off(type, types[type], fn);
            else {
                types = splitWords(types);
                var removeAll = arguments.length === 1;
                for(var i = 0, len = types.length; i < len; i++)if (removeAll) this._off(types[i]);
                else this._off(types[i], fn, context);
            }
            return this;
        },
        // attach listener (without syntactic sugar now)
        _on: function(type, fn, context, _once) {
            if (typeof fn !== "function") {
                console.warn("wrong listener type: " + typeof fn);
                return;
            }
            // check if fn already there
            if (this._listens(type, fn, context) !== false) return;
            if (context === this) // Less memory footprint.
            context = undefined;
            var newListener = {
                fn: fn,
                ctx: context
            };
            if (_once) newListener.once = true;
            this._events = this._events || {};
            this._events[type] = this._events[type] || [];
            this._events[type].push(newListener);
        },
        _off: function(type, fn, context) {
            var listeners, i, len;
            if (!this._events) return;
            listeners = this._events[type];
            if (!listeners) return;
            if (arguments.length === 1) {
                if (this._firingCount) // Set all removed listeners to noop
                // so they are not called if remove happens in fire
                for(i = 0, len = listeners.length; i < len; i++)listeners[i].fn = falseFn;
                // clear all listeners for a type if function isn't specified
                delete this._events[type];
                return;
            }
            if (typeof fn !== "function") {
                console.warn("wrong listener type: " + typeof fn);
                return;
            }
            // find fn and remove it
            var index = this._listens(type, fn, context);
            if (index !== false) {
                var listener = listeners[index];
                if (this._firingCount) {
                    // set the removed listener to noop so that's not called if remove happens in fire
                    listener.fn = falseFn;
                    /* copy array in case events are being fired */ this._events[type] = listeners = listeners.slice();
                }
                listeners.splice(index, 1);
            }
        },
        // @method fire(type: String, data?: Object, propagate?: Boolean): this
        // Fires an event of the specified type. You can optionally provide a data
        // object — the first argument of the listener function will contain its
        // properties. The event can optionally be propagated to event parents.
        fire: function(type, data, propagate) {
            if (!this.listens(type, propagate)) return this;
            var event = extend({}, data, {
                type: type,
                target: this,
                sourceTarget: data && data.sourceTarget || this
            });
            if (this._events) {
                var listeners = this._events[type];
                if (listeners) {
                    this._firingCount = this._firingCount + 1 || 1;
                    for(var i = 0, len = listeners.length; i < len; i++){
                        var l = listeners[i];
                        // off overwrites l.fn, so we need to copy fn to a var
                        var fn = l.fn;
                        if (l.once) this.off(type, fn, l.ctx);
                        fn.call(l.ctx || this, event);
                    }
                    this._firingCount--;
                }
            }
            if (propagate) // propagate the event to parents (set with addEventParent)
            this._propagateEvent(event);
            return this;
        },
        // @method listens(type: String, propagate?: Boolean): Boolean
        // @method listens(type: String, fn: Function, context?: Object, propagate?: Boolean): Boolean
        // Returns `true` if a particular event type has any listeners attached to it.
        // The verification can optionally be propagated, it will return `true` if parents have the listener attached to it.
        listens: function(type, fn, context, propagate) {
            if (typeof type !== "string") console.warn('"string" type argument expected');
            // we don't overwrite the input `fn` value, because we need to use it for propagation
            var _fn = fn;
            if (typeof fn !== "function") {
                propagate = !!fn;
                _fn = undefined;
                context = undefined;
            }
            var listeners = this._events && this._events[type];
            if (listeners && listeners.length) {
                if (this._listens(type, _fn, context) !== false) return true;
            }
            if (propagate) // also check parents for listeners if event propagates
            for(var id in this._eventParents){
                if (this._eventParents[id].listens(type, fn, context, propagate)) return true;
            }
            return false;
        },
        // returns the index (number) or false
        _listens: function(type, fn, context) {
            if (!this._events) return false;
            var listeners = this._events[type] || [];
            if (!fn) return !!listeners.length;
            if (context === this) // Less memory footprint.
            context = undefined;
            for(var i = 0, len = listeners.length; i < len; i++){
                if (listeners[i].fn === fn && listeners[i].ctx === context) return i;
            }
            return false;
        },
        // @method once(…): this
        // Behaves as [`on(…)`](#evented-on), except the listener will only get fired once and then removed.
        once: function(types, fn, context) {
            // types can be a map of types/handlers
            if (typeof types === "object") for(var type in types)// we don't process space-separated events here for performance;
            // it's a hot path since Layer uses the on(obj) syntax
            this._on(type, types[type], fn, true);
            else {
                // types can be a string of space-separated words
                types = splitWords(types);
                for(var i = 0, len = types.length; i < len; i++)this._on(types[i], fn, context, true);
            }
            return this;
        },
        // @method addEventParent(obj: Evented): this
        // Adds an event parent - an `Evented` that will receive propagated events
        addEventParent: function(obj) {
            this._eventParents = this._eventParents || {};
            this._eventParents[stamp(obj)] = obj;
            return this;
        },
        // @method removeEventParent(obj: Evented): this
        // Removes an event parent, so it will stop receiving propagated events
        removeEventParent: function(obj) {
            if (this._eventParents) delete this._eventParents[stamp(obj)];
            return this;
        },
        _propagateEvent: function(e) {
            for(var id in this._eventParents)this._eventParents[id].fire(e.type, extend({
                layer: e.target,
                propagatedFrom: e.target
            }, e), true);
        }
    };
    // aliases; we should ditch those eventually
    // @method addEventListener(…): this
    // Alias to [`on(…)`](#evented-on)
    Events.addEventListener = Events.on;
    // @method removeEventListener(…): this
    // Alias to [`off(…)`](#evented-off)
    // @method clearAllEventListeners(…): this
    // Alias to [`off()`](#evented-off)
    Events.removeEventListener = Events.clearAllEventListeners = Events.off;
    // @method addOneTimeEventListener(…): this
    // Alias to [`once(…)`](#evented-once)
    Events.addOneTimeEventListener = Events.once;
    // @method fireEvent(…): this
    // Alias to [`fire(…)`](#evented-fire)
    Events.fireEvent = Events.fire;
    // @method hasEventListeners(…): Boolean
    // Alias to [`listens(…)`](#evented-listens)
    Events.hasEventListeners = Events.listens;
    var Evented = Class.extend(Events);
    /*
   * @class Point
   * @aka L.Point
   *
   * Represents a point with `x` and `y` coordinates in pixels.
   *
   * @example
   *
   * ```js
   * var point = L.point(200, 300);
   * ```
   *
   * All Leaflet methods and options that accept `Point` objects also accept them in a simple Array form (unless noted otherwise), so these lines are equivalent:
   *
   * ```js
   * map.panBy([200, 300]);
   * map.panBy(L.point(200, 300));
   * ```
   *
   * Note that `Point` does not inherit from Leaflet's `Class` object,
   * which means new classes can't inherit from it, and new methods
   * can't be added to it with the `include` function.
   */ function Point(x, y, round) {
        // @property x: Number; The `x` coordinate of the point
        this.x = round ? Math.round(x) : x;
        // @property y: Number; The `y` coordinate of the point
        this.y = round ? Math.round(y) : y;
    }
    var trunc = Math.trunc || function(v) {
        return v > 0 ? Math.floor(v) : Math.ceil(v);
    };
    Point.prototype = {
        // @method clone(): Point
        // Returns a copy of the current point.
        clone: function() {
            return new Point(this.x, this.y);
        },
        // @method add(otherPoint: Point): Point
        // Returns the result of addition of the current and the given points.
        add: function(point) {
            // non-destructive, returns a new point
            return this.clone()._add(toPoint(point));
        },
        _add: function(point) {
            // destructive, used directly for performance in situations where it's safe to modify existing point
            this.x += point.x;
            this.y += point.y;
            return this;
        },
        // @method subtract(otherPoint: Point): Point
        // Returns the result of subtraction of the given point from the current.
        subtract: function(point) {
            return this.clone()._subtract(toPoint(point));
        },
        _subtract: function(point) {
            this.x -= point.x;
            this.y -= point.y;
            return this;
        },
        // @method divideBy(num: Number): Point
        // Returns the result of division of the current point by the given number.
        divideBy: function(num) {
            return this.clone()._divideBy(num);
        },
        _divideBy: function(num) {
            this.x /= num;
            this.y /= num;
            return this;
        },
        // @method multiplyBy(num: Number): Point
        // Returns the result of multiplication of the current point by the given number.
        multiplyBy: function(num) {
            return this.clone()._multiplyBy(num);
        },
        _multiplyBy: function(num) {
            this.x *= num;
            this.y *= num;
            return this;
        },
        // @method scaleBy(scale: Point): Point
        // Multiply each coordinate of the current point by each coordinate of
        // `scale`. In linear algebra terms, multiply the point by the
        // [scaling matrix](https://en.wikipedia.org/wiki/Scaling_%28geometry%29#Matrix_representation)
        // defined by `scale`.
        scaleBy: function(point) {
            return new Point(this.x * point.x, this.y * point.y);
        },
        // @method unscaleBy(scale: Point): Point
        // Inverse of `scaleBy`. Divide each coordinate of the current point by
        // each coordinate of `scale`.
        unscaleBy: function(point) {
            return new Point(this.x / point.x, this.y / point.y);
        },
        // @method round(): Point
        // Returns a copy of the current point with rounded coordinates.
        round: function() {
            return this.clone()._round();
        },
        _round: function() {
            this.x = Math.round(this.x);
            this.y = Math.round(this.y);
            return this;
        },
        // @method floor(): Point
        // Returns a copy of the current point with floored coordinates (rounded down).
        floor: function() {
            return this.clone()._floor();
        },
        _floor: function() {
            this.x = Math.floor(this.x);
            this.y = Math.floor(this.y);
            return this;
        },
        // @method ceil(): Point
        // Returns a copy of the current point with ceiled coordinates (rounded up).
        ceil: function() {
            return this.clone()._ceil();
        },
        _ceil: function() {
            this.x = Math.ceil(this.x);
            this.y = Math.ceil(this.y);
            return this;
        },
        // @method trunc(): Point
        // Returns a copy of the current point with truncated coordinates (rounded towards zero).
        trunc: function() {
            return this.clone()._trunc();
        },
        _trunc: function() {
            this.x = trunc(this.x);
            this.y = trunc(this.y);
            return this;
        },
        // @method distanceTo(otherPoint: Point): Number
        // Returns the cartesian distance between the current and the given points.
        distanceTo: function(point) {
            point = toPoint(point);
            var x = point.x - this.x, y = point.y - this.y;
            return Math.sqrt(x * x + y * y);
        },
        // @method equals(otherPoint: Point): Boolean
        // Returns `true` if the given point has the same coordinates.
        equals: function(point) {
            point = toPoint(point);
            return point.x === this.x && point.y === this.y;
        },
        // @method contains(otherPoint: Point): Boolean
        // Returns `true` if both coordinates of the given point are less than the corresponding current point coordinates (in absolute values).
        contains: function(point) {
            point = toPoint(point);
            return Math.abs(point.x) <= Math.abs(this.x) && Math.abs(point.y) <= Math.abs(this.y);
        },
        // @method toString(): String
        // Returns a string representation of the point for debugging purposes.
        toString: function() {
            return "Point(" + formatNum(this.x) + ", " + formatNum(this.y) + ")";
        }
    };
    // @factory L.point(x: Number, y: Number, round?: Boolean)
    // Creates a Point object with the given `x` and `y` coordinates. If optional `round` is set to true, rounds the `x` and `y` values.
    // @alternative
    // @factory L.point(coords: Number[])
    // Expects an array of the form `[x, y]` instead.
    // @alternative
    // @factory L.point(coords: Object)
    // Expects a plain object of the form `{x: Number, y: Number}` instead.
    function toPoint(x, y, round) {
        if (x instanceof Point) return x;
        if (isArray(x)) return new Point(x[0], x[1]);
        if (x === undefined || x === null) return x;
        if (typeof x === "object" && "x" in x && "y" in x) return new Point(x.x, x.y);
        return new Point(x, y, round);
    }
    /*
   * @class Bounds
   * @aka L.Bounds
   *
   * Represents a rectangular area in pixel coordinates.
   *
   * @example
   *
   * ```js
   * var p1 = L.point(10, 10),
   * p2 = L.point(40, 60),
   * bounds = L.bounds(p1, p2);
   * ```
   *
   * All Leaflet methods that accept `Bounds` objects also accept them in a simple Array form (unless noted otherwise), so the bounds example above can be passed like this:
   *
   * ```js
   * otherBounds.intersects([[10, 10], [40, 60]]);
   * ```
   *
   * Note that `Bounds` does not inherit from Leaflet's `Class` object,
   * which means new classes can't inherit from it, and new methods
   * can't be added to it with the `include` function.
   */ function Bounds(a, b) {
        if (!a) return;
        var points = b ? [
            a,
            b
        ] : a;
        for(var i = 0, len = points.length; i < len; i++)this.extend(points[i]);
    }
    Bounds.prototype = {
        // @method extend(point: Point): this
        // Extends the bounds to contain the given point.
        // @alternative
        // @method extend(otherBounds: Bounds): this
        // Extend the bounds to contain the given bounds
        extend: function(obj) {
            var min2, max2;
            if (!obj) return this;
            if (obj instanceof Point || typeof obj[0] === "number" || "x" in obj) min2 = max2 = toPoint(obj);
            else {
                obj = toBounds(obj);
                min2 = obj.min;
                max2 = obj.max;
                if (!min2 || !max2) return this;
            }
            // @property min: Point
            // The top left corner of the rectangle.
            // @property max: Point
            // The bottom right corner of the rectangle.
            if (!this.min && !this.max) {
                this.min = min2.clone();
                this.max = max2.clone();
            } else {
                this.min.x = Math.min(min2.x, this.min.x);
                this.max.x = Math.max(max2.x, this.max.x);
                this.min.y = Math.min(min2.y, this.min.y);
                this.max.y = Math.max(max2.y, this.max.y);
            }
            return this;
        },
        // @method getCenter(round?: Boolean): Point
        // Returns the center point of the bounds.
        getCenter: function(round) {
            return toPoint((this.min.x + this.max.x) / 2, (this.min.y + this.max.y) / 2, round);
        },
        // @method getBottomLeft(): Point
        // Returns the bottom-left point of the bounds.
        getBottomLeft: function() {
            return toPoint(this.min.x, this.max.y);
        },
        // @method getTopRight(): Point
        // Returns the top-right point of the bounds.
        getTopRight: function() {
            return toPoint(this.max.x, this.min.y);
        },
        // @method getTopLeft(): Point
        // Returns the top-left point of the bounds (i.e. [`this.min`](#bounds-min)).
        getTopLeft: function() {
            return this.min; // left, top
        },
        // @method getBottomRight(): Point
        // Returns the bottom-right point of the bounds (i.e. [`this.max`](#bounds-max)).
        getBottomRight: function() {
            return this.max; // right, bottom
        },
        // @method getSize(): Point
        // Returns the size of the given bounds
        getSize: function() {
            return this.max.subtract(this.min);
        },
        // @method contains(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle contains the given one.
        // @alternative
        // @method contains(point: Point): Boolean
        // Returns `true` if the rectangle contains the given point.
        contains: function(obj) {
            var min, max;
            if (typeof obj[0] === "number" || obj instanceof Point) obj = toPoint(obj);
            else obj = toBounds(obj);
            if (obj instanceof Bounds) {
                min = obj.min;
                max = obj.max;
            } else min = max = obj;
            return min.x >= this.min.x && max.x <= this.max.x && min.y >= this.min.y && max.y <= this.max.y;
        },
        // @method intersects(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle intersects the given bounds. Two bounds
        // intersect if they have at least one point in common.
        intersects: function(bounds) {
            bounds = toBounds(bounds);
            var min = this.min, max = this.max, min2 = bounds.min, max2 = bounds.max, xIntersects = max2.x >= min.x && min2.x <= max.x, yIntersects = max2.y >= min.y && min2.y <= max.y;
            return xIntersects && yIntersects;
        },
        // @method overlaps(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle overlaps the given bounds. Two bounds
        // overlap if their intersection is an area.
        overlaps: function(bounds) {
            bounds = toBounds(bounds);
            var min = this.min, max = this.max, min2 = bounds.min, max2 = bounds.max, xOverlaps = max2.x > min.x && min2.x < max.x, yOverlaps = max2.y > min.y && min2.y < max.y;
            return xOverlaps && yOverlaps;
        },
        // @method isValid(): Boolean
        // Returns `true` if the bounds are properly initialized.
        isValid: function() {
            return !!(this.min && this.max);
        },
        // @method pad(bufferRatio: Number): Bounds
        // Returns bounds created by extending or retracting the current bounds by a given ratio in each direction.
        // For example, a ratio of 0.5 extends the bounds by 50% in each direction.
        // Negative values will retract the bounds.
        pad: function(bufferRatio) {
            var min = this.min, max = this.max, heightBuffer = Math.abs(min.x - max.x) * bufferRatio, widthBuffer = Math.abs(min.y - max.y) * bufferRatio;
            return toBounds(toPoint(min.x - heightBuffer, min.y - widthBuffer), toPoint(max.x + heightBuffer, max.y + widthBuffer));
        },
        // @method equals(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle is equivalent to the given bounds.
        equals: function(bounds) {
            if (!bounds) return false;
            bounds = toBounds(bounds);
            return this.min.equals(bounds.getTopLeft()) && this.max.equals(bounds.getBottomRight());
        }
    };
    // @factory L.bounds(corner1: Point, corner2: Point)
    // Creates a Bounds object from two corners coordinate pairs.
    // @alternative
    // @factory L.bounds(points: Point[])
    // Creates a Bounds object from the given array of points.
    function toBounds(a, b) {
        if (!a || a instanceof Bounds) return a;
        return new Bounds(a, b);
    }
    /*
   * @class LatLngBounds
   * @aka L.LatLngBounds
   *
   * Represents a rectangular geographical area on a map.
   *
   * @example
   *
   * ```js
   * var corner1 = L.latLng(40.712, -74.227),
   * corner2 = L.latLng(40.774, -74.125),
   * bounds = L.latLngBounds(corner1, corner2);
   * ```
   *
   * All Leaflet methods that accept LatLngBounds objects also accept them in a simple Array form (unless noted otherwise), so the bounds example above can be passed like this:
   *
   * ```js
   * map.fitBounds([
   * 	[40.712, -74.227],
   * 	[40.774, -74.125]
   * ]);
   * ```
   *
   * Caution: if the area crosses the antimeridian (often confused with the International Date Line), you must specify corners _outside_ the [-180, 180] degrees longitude range.
   *
   * Note that `LatLngBounds` does not inherit from Leaflet's `Class` object,
   * which means new classes can't inherit from it, and new methods
   * can't be added to it with the `include` function.
   */ function LatLngBounds(corner1, corner2) {
        if (!corner1) return;
        var latlngs = corner2 ? [
            corner1,
            corner2
        ] : corner1;
        for(var i = 0, len = latlngs.length; i < len; i++)this.extend(latlngs[i]);
    }
    LatLngBounds.prototype = {
        // @method extend(latlng: LatLng): this
        // Extend the bounds to contain the given point
        // @alternative
        // @method extend(otherBounds: LatLngBounds): this
        // Extend the bounds to contain the given bounds
        extend: function(obj) {
            var sw = this._southWest, ne = this._northEast, sw2, ne2;
            if (obj instanceof LatLng) {
                sw2 = obj;
                ne2 = obj;
            } else if (obj instanceof LatLngBounds) {
                sw2 = obj._southWest;
                ne2 = obj._northEast;
                if (!sw2 || !ne2) return this;
            } else return obj ? this.extend(toLatLng(obj) || toLatLngBounds(obj)) : this;
            if (!sw && !ne) {
                this._southWest = new LatLng(sw2.lat, sw2.lng);
                this._northEast = new LatLng(ne2.lat, ne2.lng);
            } else {
                sw.lat = Math.min(sw2.lat, sw.lat);
                sw.lng = Math.min(sw2.lng, sw.lng);
                ne.lat = Math.max(ne2.lat, ne.lat);
                ne.lng = Math.max(ne2.lng, ne.lng);
            }
            return this;
        },
        // @method pad(bufferRatio: Number): LatLngBounds
        // Returns bounds created by extending or retracting the current bounds by a given ratio in each direction.
        // For example, a ratio of 0.5 extends the bounds by 50% in each direction.
        // Negative values will retract the bounds.
        pad: function(bufferRatio) {
            var sw = this._southWest, ne = this._northEast, heightBuffer = Math.abs(sw.lat - ne.lat) * bufferRatio, widthBuffer = Math.abs(sw.lng - ne.lng) * bufferRatio;
            return new LatLngBounds(new LatLng(sw.lat - heightBuffer, sw.lng - widthBuffer), new LatLng(ne.lat + heightBuffer, ne.lng + widthBuffer));
        },
        // @method getCenter(): LatLng
        // Returns the center point of the bounds.
        getCenter: function() {
            return new LatLng((this._southWest.lat + this._northEast.lat) / 2, (this._southWest.lng + this._northEast.lng) / 2);
        },
        // @method getSouthWest(): LatLng
        // Returns the south-west point of the bounds.
        getSouthWest: function() {
            return this._southWest;
        },
        // @method getNorthEast(): LatLng
        // Returns the north-east point of the bounds.
        getNorthEast: function() {
            return this._northEast;
        },
        // @method getNorthWest(): LatLng
        // Returns the north-west point of the bounds.
        getNorthWest: function() {
            return new LatLng(this.getNorth(), this.getWest());
        },
        // @method getSouthEast(): LatLng
        // Returns the south-east point of the bounds.
        getSouthEast: function() {
            return new LatLng(this.getSouth(), this.getEast());
        },
        // @method getWest(): Number
        // Returns the west longitude of the bounds
        getWest: function() {
            return this._southWest.lng;
        },
        // @method getSouth(): Number
        // Returns the south latitude of the bounds
        getSouth: function() {
            return this._southWest.lat;
        },
        // @method getEast(): Number
        // Returns the east longitude of the bounds
        getEast: function() {
            return this._northEast.lng;
        },
        // @method getNorth(): Number
        // Returns the north latitude of the bounds
        getNorth: function() {
            return this._northEast.lat;
        },
        // @method contains(otherBounds: LatLngBounds): Boolean
        // Returns `true` if the rectangle contains the given one.
        // @alternative
        // @method contains (latlng: LatLng): Boolean
        // Returns `true` if the rectangle contains the given point.
        contains: function(obj) {
            if (typeof obj[0] === "number" || obj instanceof LatLng || "lat" in obj) obj = toLatLng(obj);
            else obj = toLatLngBounds(obj);
            var sw = this._southWest, ne = this._northEast, sw2, ne2;
            if (obj instanceof LatLngBounds) {
                sw2 = obj.getSouthWest();
                ne2 = obj.getNorthEast();
            } else sw2 = ne2 = obj;
            return sw2.lat >= sw.lat && ne2.lat <= ne.lat && sw2.lng >= sw.lng && ne2.lng <= ne.lng;
        },
        // @method intersects(otherBounds: LatLngBounds): Boolean
        // Returns `true` if the rectangle intersects the given bounds. Two bounds intersect if they have at least one point in common.
        intersects: function(bounds) {
            bounds = toLatLngBounds(bounds);
            var sw = this._southWest, ne = this._northEast, sw2 = bounds.getSouthWest(), ne2 = bounds.getNorthEast(), latIntersects = ne2.lat >= sw.lat && sw2.lat <= ne.lat, lngIntersects = ne2.lng >= sw.lng && sw2.lng <= ne.lng;
            return latIntersects && lngIntersects;
        },
        // @method overlaps(otherBounds: LatLngBounds): Boolean
        // Returns `true` if the rectangle overlaps the given bounds. Two bounds overlap if their intersection is an area.
        overlaps: function(bounds) {
            bounds = toLatLngBounds(bounds);
            var sw = this._southWest, ne = this._northEast, sw2 = bounds.getSouthWest(), ne2 = bounds.getNorthEast(), latOverlaps = ne2.lat > sw.lat && sw2.lat < ne.lat, lngOverlaps = ne2.lng > sw.lng && sw2.lng < ne.lng;
            return latOverlaps && lngOverlaps;
        },
        // @method toBBoxString(): String
        // Returns a string with bounding box coordinates in a 'southwest_lng,southwest_lat,northeast_lng,northeast_lat' format. Useful for sending requests to web services that return geo data.
        toBBoxString: function() {
            return [
                this.getWest(),
                this.getSouth(),
                this.getEast(),
                this.getNorth()
            ].join(",");
        },
        // @method equals(otherBounds: LatLngBounds, maxMargin?: Number): Boolean
        // Returns `true` if the rectangle is equivalent (within a small margin of error) to the given bounds. The margin of error can be overridden by setting `maxMargin` to a small number.
        equals: function(bounds, maxMargin) {
            if (!bounds) return false;
            bounds = toLatLngBounds(bounds);
            return this._southWest.equals(bounds.getSouthWest(), maxMargin) && this._northEast.equals(bounds.getNorthEast(), maxMargin);
        },
        // @method isValid(): Boolean
        // Returns `true` if the bounds are properly initialized.
        isValid: function() {
            return !!(this._southWest && this._northEast);
        }
    };
    // TODO International date line?
    // @factory L.latLngBounds(corner1: LatLng, corner2: LatLng)
    // Creates a `LatLngBounds` object by defining two diagonally opposite corners of the rectangle.
    // @alternative
    // @factory L.latLngBounds(latlngs: LatLng[])
    // Creates a `LatLngBounds` object defined by the geographical points it contains. Very useful for zooming the map to fit a particular set of locations with [`fitBounds`](#map-fitbounds).
    function toLatLngBounds(a, b) {
        if (a instanceof LatLngBounds) return a;
        return new LatLngBounds(a, b);
    }
    /* @class LatLng
   * @aka L.LatLng
   *
   * Represents a geographical point with a certain latitude and longitude.
   *
   * @example
   *
   * ```
   * var latlng = L.latLng(50.5, 30.5);
   * ```
   *
   * All Leaflet methods that accept LatLng objects also accept them in a simple Array form and simple object form (unless noted otherwise), so these lines are equivalent:
   *
   * ```
   * map.panTo([50, 30]);
   * map.panTo({lon: 30, lat: 50});
   * map.panTo({lat: 50, lng: 30});
   * map.panTo(L.latLng(50, 30));
   * ```
   *
   * Note that `LatLng` does not inherit from Leaflet's `Class` object,
   * which means new classes can't inherit from it, and new methods
   * can't be added to it with the `include` function.
   */ function LatLng(lat, lng, alt) {
        if (isNaN(lat) || isNaN(lng)) throw new Error("Invalid LatLng object: (" + lat + ", " + lng + ")");
        // @property lat: Number
        // Latitude in degrees
        this.lat = +lat;
        // @property lng: Number
        // Longitude in degrees
        this.lng = +lng;
        // @property alt: Number
        // Altitude in meters (optional)
        if (alt !== undefined) this.alt = +alt;
    }
    LatLng.prototype = {
        // @method equals(otherLatLng: LatLng, maxMargin?: Number): Boolean
        // Returns `true` if the given `LatLng` point is at the same position (within a small margin of error). The margin of error can be overridden by setting `maxMargin` to a small number.
        equals: function(obj, maxMargin) {
            if (!obj) return false;
            obj = toLatLng(obj);
            var margin = Math.max(Math.abs(this.lat - obj.lat), Math.abs(this.lng - obj.lng));
            return margin <= (maxMargin === undefined ? 1.0E-9 : maxMargin);
        },
        // @method toString(): String
        // Returns a string representation of the point (for debugging purposes).
        toString: function(precision) {
            return "LatLng(" + formatNum(this.lat, precision) + ", " + formatNum(this.lng, precision) + ")";
        },
        // @method distanceTo(otherLatLng: LatLng): Number
        // Returns the distance (in meters) to the given `LatLng` calculated using the [Spherical Law of Cosines](https://en.wikipedia.org/wiki/Spherical_law_of_cosines).
        distanceTo: function(other) {
            return Earth.distance(this, toLatLng(other));
        },
        // @method wrap(): LatLng
        // Returns a new `LatLng` object with the longitude wrapped so it's always between -180 and +180 degrees.
        wrap: function() {
            return Earth.wrapLatLng(this);
        },
        // @method toBounds(sizeInMeters: Number): LatLngBounds
        // Returns a new `LatLngBounds` object in which each boundary is `sizeInMeters/2` meters apart from the `LatLng`.
        toBounds: function(sizeInMeters) {
            var latAccuracy = 180 * sizeInMeters / 40075017, lngAccuracy = latAccuracy / Math.cos(Math.PI / 180 * this.lat);
            return toLatLngBounds([
                this.lat - latAccuracy,
                this.lng - lngAccuracy
            ], [
                this.lat + latAccuracy,
                this.lng + lngAccuracy
            ]);
        },
        clone: function() {
            return new LatLng(this.lat, this.lng, this.alt);
        }
    };
    // @factory L.latLng(latitude: Number, longitude: Number, altitude?: Number): LatLng
    // Creates an object representing a geographical point with the given latitude and longitude (and optionally altitude).
    // @alternative
    // @factory L.latLng(coords: Array): LatLng
    // Expects an array of the form `[Number, Number]` or `[Number, Number, Number]` instead.
    // @alternative
    // @factory L.latLng(coords: Object): LatLng
    // Expects an plain object of the form `{lat: Number, lng: Number}` or `{lat: Number, lng: Number, alt: Number}` instead.
    function toLatLng(a, b, c) {
        if (a instanceof LatLng) return a;
        if (isArray(a) && typeof a[0] !== "object") {
            if (a.length === 3) return new LatLng(a[0], a[1], a[2]);
            if (a.length === 2) return new LatLng(a[0], a[1]);
            return null;
        }
        if (a === undefined || a === null) return a;
        if (typeof a === "object" && "lat" in a) return new LatLng(a.lat, "lng" in a ? a.lng : a.lon, a.alt);
        if (b === undefined) return null;
        return new LatLng(a, b, c);
    }
    /*
   * @namespace CRS
   * @crs L.CRS.Base
   * Object that defines coordinate reference systems for projecting
   * geographical points into pixel (screen) coordinates and back (and to
   * coordinates in other units for [WMS](https://en.wikipedia.org/wiki/Web_Map_Service) services). See
   * [spatial reference system](https://en.wikipedia.org/wiki/Spatial_reference_system).
   *
   * Leaflet defines the most usual CRSs by default. If you want to use a
   * CRS not defined by default, take a look at the
   * [Proj4Leaflet](https://github.com/kartena/Proj4Leaflet) plugin.
   *
   * Note that the CRS instances do not inherit from Leaflet's `Class` object,
   * and can't be instantiated. Also, new classes can't inherit from them,
   * and methods can't be added to them with the `include` function.
   */ var CRS = {
        // @method latLngToPoint(latlng: LatLng, zoom: Number): Point
        // Projects geographical coordinates into pixel coordinates for a given zoom.
        latLngToPoint: function(latlng, zoom) {
            var projectedPoint = this.projection.project(latlng), scale = this.scale(zoom);
            return this.transformation._transform(projectedPoint, scale);
        },
        // @method pointToLatLng(point: Point, zoom: Number): LatLng
        // The inverse of `latLngToPoint`. Projects pixel coordinates on a given
        // zoom into geographical coordinates.
        pointToLatLng: function(point, zoom) {
            var scale = this.scale(zoom), untransformedPoint = this.transformation.untransform(point, scale);
            return this.projection.unproject(untransformedPoint);
        },
        // @method project(latlng: LatLng): Point
        // Projects geographical coordinates into coordinates in units accepted for
        // this CRS (e.g. meters for EPSG:3857, for passing it to WMS services).
        project: function(latlng) {
            return this.projection.project(latlng);
        },
        // @method unproject(point: Point): LatLng
        // Given a projected coordinate returns the corresponding LatLng.
        // The inverse of `project`.
        unproject: function(point) {
            return this.projection.unproject(point);
        },
        // @method scale(zoom: Number): Number
        // Returns the scale used when transforming projected coordinates into
        // pixel coordinates for a particular zoom. For example, it returns
        // `256 * 2^zoom` for Mercator-based CRS.
        scale: function(zoom) {
            return 256 * Math.pow(2, zoom);
        },
        // @method zoom(scale: Number): Number
        // Inverse of `scale()`, returns the zoom level corresponding to a scale
        // factor of `scale`.
        zoom: function(scale) {
            return Math.log(scale / 256) / Math.LN2;
        },
        // @method getProjectedBounds(zoom: Number): Bounds
        // Returns the projection's bounds scaled and transformed for the provided `zoom`.
        getProjectedBounds: function(zoom) {
            if (this.infinite) return null;
            var b = this.projection.bounds, s = this.scale(zoom), min = this.transformation.transform(b.min, s), max = this.transformation.transform(b.max, s);
            return new Bounds(min, max);
        },
        // @method distance(latlng1: LatLng, latlng2: LatLng): Number
        // Returns the distance between two geographical coordinates.
        // @property code: String
        // Standard code name of the CRS passed into WMS services (e.g. `'EPSG:3857'`)
        //
        // @property wrapLng: Number[]
        // An array of two numbers defining whether the longitude (horizontal) coordinate
        // axis wraps around a given range and how. Defaults to `[-180, 180]` in most
        // geographical CRSs. If `undefined`, the longitude axis does not wrap around.
        //
        // @property wrapLat: Number[]
        // Like `wrapLng`, but for the latitude (vertical) axis.
        // wrapLng: [min, max],
        // wrapLat: [min, max],
        // @property infinite: Boolean
        // If true, the coordinate space will be unbounded (infinite in both axes)
        infinite: false,
        // @method wrapLatLng(latlng: LatLng): LatLng
        // Returns a `LatLng` where lat and lng has been wrapped according to the
        // CRS's `wrapLat` and `wrapLng` properties, if they are outside the CRS's bounds.
        wrapLatLng: function(latlng) {
            var lng = this.wrapLng ? wrapNum(latlng.lng, this.wrapLng, true) : latlng.lng, lat = this.wrapLat ? wrapNum(latlng.lat, this.wrapLat, true) : latlng.lat, alt = latlng.alt;
            return new LatLng(lat, lng, alt);
        },
        // @method wrapLatLngBounds(bounds: LatLngBounds): LatLngBounds
        // Returns a `LatLngBounds` with the same size as the given one, ensuring
        // that its center is within the CRS's bounds.
        // Only accepts actual `L.LatLngBounds` instances, not arrays.
        wrapLatLngBounds: function(bounds) {
            var center = bounds.getCenter(), newCenter = this.wrapLatLng(center), latShift = center.lat - newCenter.lat, lngShift = center.lng - newCenter.lng;
            if (latShift === 0 && lngShift === 0) return bounds;
            var sw = bounds.getSouthWest(), ne = bounds.getNorthEast(), newSw = new LatLng(sw.lat - latShift, sw.lng - lngShift), newNe = new LatLng(ne.lat - latShift, ne.lng - lngShift);
            return new LatLngBounds(newSw, newNe);
        }
    };
    /*
   * @namespace CRS
   * @crs L.CRS.Earth
   *
   * Serves as the base for CRS that are global such that they cover the earth.
   * Can only be used as the base for other CRS and cannot be used directly,
   * since it does not have a `code`, `projection` or `transformation`. `distance()` returns
   * meters.
   */ var Earth = extend({}, CRS, {
        wrapLng: [
            -180,
            180
        ],
        // Mean Earth Radius, as recommended for use by
        // the International Union of Geodesy and Geophysics,
        // see https://rosettacode.org/wiki/Haversine_formula
        R: 6371000,
        // distance between two geographical points using spherical law of cosines approximation
        distance: function(latlng1, latlng2) {
            var rad = Math.PI / 180, lat1 = latlng1.lat * rad, lat2 = latlng2.lat * rad, sinDLat = Math.sin((latlng2.lat - latlng1.lat) * rad / 2), sinDLon = Math.sin((latlng2.lng - latlng1.lng) * rad / 2), a = sinDLat * sinDLat + Math.cos(lat1) * Math.cos(lat2) * sinDLon * sinDLon, c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
            return this.R * c;
        }
    });
    /*
   * @namespace Projection
   * @projection L.Projection.SphericalMercator
   *
   * Spherical Mercator projection — the most common projection for online maps,
   * used by almost all free and commercial tile providers. Assumes that Earth is
   * a sphere. Used by the `EPSG:3857` CRS.
   */ var earthRadius = 6378137;
    var SphericalMercator = {
        R: earthRadius,
        MAX_LATITUDE: 85.0511287798,
        project: function(latlng) {
            var d = Math.PI / 180, max = this.MAX_LATITUDE, lat = Math.max(Math.min(max, latlng.lat), -max), sin = Math.sin(lat * d);
            return new Point(this.R * latlng.lng * d, this.R * Math.log((1 + sin) / (1 - sin)) / 2);
        },
        unproject: function(point) {
            var d = 180 / Math.PI;
            return new LatLng((2 * Math.atan(Math.exp(point.y / this.R)) - Math.PI / 2) * d, point.x * d / this.R);
        },
        bounds: function() {
            var d = earthRadius * Math.PI;
            return new Bounds([
                -d,
                -d
            ], [
                d,
                d
            ]);
        }()
    };
    /*
   * @class Transformation
   * @aka L.Transformation
   *
   * Represents an affine transformation: a set of coefficients `a`, `b`, `c`, `d`
   * for transforming a point of a form `(x, y)` into `(a*x + b, c*y + d)` and doing
   * the reverse. Used by Leaflet in its projections code.
   *
   * @example
   *
   * ```js
   * var transformation = L.transformation(2, 5, -1, 10),
   * 	p = L.point(1, 2),
   * 	p2 = transformation.transform(p), //  L.point(7, 8)
   * 	p3 = transformation.untransform(p2); //  L.point(1, 2)
   * ```
   */ // factory new L.Transformation(a: Number, b: Number, c: Number, d: Number)
    // Creates a `Transformation` object with the given coefficients.
    function Transformation(a, b, c, d) {
        if (isArray(a)) {
            // use array properties
            this._a = a[0];
            this._b = a[1];
            this._c = a[2];
            this._d = a[3];
            return;
        }
        this._a = a;
        this._b = b;
        this._c = c;
        this._d = d;
    }
    Transformation.prototype = {
        // @method transform(point: Point, scale?: Number): Point
        // Returns a transformed point, optionally multiplied by the given scale.
        // Only accepts actual `L.Point` instances, not arrays.
        transform: function(point, scale) {
            return this._transform(point.clone(), scale);
        },
        // destructive transform (faster)
        _transform: function(point, scale) {
            scale = scale || 1;
            point.x = scale * (this._a * point.x + this._b);
            point.y = scale * (this._c * point.y + this._d);
            return point;
        },
        // @method untransform(point: Point, scale?: Number): Point
        // Returns the reverse transformation of the given point, optionally divided
        // by the given scale. Only accepts actual `L.Point` instances, not arrays.
        untransform: function(point, scale) {
            scale = scale || 1;
            return new Point((point.x / scale - this._b) / this._a, (point.y / scale - this._d) / this._c);
        }
    };
    // factory L.transformation(a: Number, b: Number, c: Number, d: Number)
    // @factory L.transformation(a: Number, b: Number, c: Number, d: Number)
    // Instantiates a Transformation object with the given coefficients.
    // @alternative
    // @factory L.transformation(coefficients: Array): Transformation
    // Expects an coefficients array of the form
    // `[a: Number, b: Number, c: Number, d: Number]`.
    function toTransformation(a, b, c, d) {
        return new Transformation(a, b, c, d);
    }
    /*
   * @namespace CRS
   * @crs L.CRS.EPSG3857
   *
   * The most common CRS for online maps, used by almost all free and commercial
   * tile providers. Uses Spherical Mercator projection. Set in by default in
   * Map's `crs` option.
   */ var EPSG3857 = extend({}, Earth, {
        code: "EPSG:3857",
        projection: SphericalMercator,
        transformation: function() {
            var scale = 0.5 / (Math.PI * SphericalMercator.R);
            return toTransformation(scale, 0.5, -scale, 0.5);
        }()
    });
    var EPSG900913 = extend({}, EPSG3857, {
        code: "EPSG:900913"
    });
    // @namespace SVG; @section
    // There are several static functions which can be called without instantiating L.SVG:
    // @function create(name: String): SVGElement
    // Returns a instance of [SVGElement](https://developer.mozilla.org/docs/Web/API/SVGElement),
    // corresponding to the class name passed. For example, using 'line' will return
    // an instance of [SVGLineElement](https://developer.mozilla.org/docs/Web/API/SVGLineElement).
    function svgCreate(name) {
        return document.createElementNS("http://www.w3.org/2000/svg", name);
    }
    // @function pointsToPath(rings: Point[], closed: Boolean): String
    // Generates a SVG path string for multiple rings, with each ring turning
    // into "M..L..L.." instructions
    function pointsToPath(rings, closed) {
        var str = "", i, j, len, len2, points, p;
        for(i = 0, len = rings.length; i < len; i++){
            points = rings[i];
            for(j = 0, len2 = points.length; j < len2; j++){
                p = points[j];
                str += (j ? "L" : "M") + p.x + " " + p.y;
            }
            // closes the ring for polygons; "x" is VML syntax
            str += closed ? Browser.svg ? "z" : "x" : "";
        }
        // SVG complains about empty path strings
        return str || "M0 0";
    }
    /*
   * @namespace Browser
   * @aka L.Browser
   *
   * A namespace with static properties for browser/feature detection used by Leaflet internally.
   *
   * @example
   *
   * ```js
   * if (L.Browser.ielt9) {
   *   alert('Upgrade your browser, dude!');
   * }
   * ```
   */ var style = document.documentElement.style;
    // @property ie: Boolean; `true` for all Internet Explorer versions (not Edge).
    var ie = "ActiveXObject" in window;
    // @property ielt9: Boolean; `true` for Internet Explorer versions less than 9.
    var ielt9 = ie && !document.addEventListener;
    // @property edge: Boolean; `true` for the Edge web browser.
    var edge = "msLaunchUri" in navigator && !("documentMode" in document);
    // @property webkit: Boolean;
    // `true` for webkit-based browsers like Chrome and Safari (including mobile versions).
    var webkit = userAgentContains("webkit");
    // @property android: Boolean
    // **Deprecated.** `true` for any browser running on an Android platform.
    var android = userAgentContains("android");
    // @property android23: Boolean; **Deprecated.** `true` for browsers running on Android 2 or Android 3.
    var android23 = userAgentContains("android 2") || userAgentContains("android 3");
    /* See https://stackoverflow.com/a/17961266 for details on detecting stock Android */ var webkitVer = parseInt(/WebKit\/([0-9]+)|$/.exec(navigator.userAgent)[1], 10); // also matches AppleWebKit
    // @property androidStock: Boolean; **Deprecated.** `true` for the Android stock browser (i.e. not Chrome)
    var androidStock = android && userAgentContains("Google") && webkitVer < 537 && !("AudioNode" in window);
    // @property opera: Boolean; `true` for the Opera browser
    var opera = !!window.opera;
    // @property chrome: Boolean; `true` for the Chrome browser.
    var chrome = !edge && userAgentContains("chrome");
    // @property gecko: Boolean; `true` for gecko-based browsers like Firefox.
    var gecko = userAgentContains("gecko") && !webkit && !opera && !ie;
    // @property safari: Boolean; `true` for the Safari browser.
    var safari = !chrome && userAgentContains("safari");
    var phantom = userAgentContains("phantom");
    // @property opera12: Boolean
    // `true` for the Opera browser supporting CSS transforms (version 12 or later).
    var opera12 = "OTransition" in style;
    // @property win: Boolean; `true` when the browser is running in a Windows platform
    var win = navigator.platform.indexOf("Win") === 0;
    // @property ie3d: Boolean; `true` for all Internet Explorer versions supporting CSS transforms.
    var ie3d = ie && "transition" in style;
    // @property webkit3d: Boolean; `true` for webkit-based browsers supporting CSS transforms.
    var webkit3d = "WebKitCSSMatrix" in window && "m11" in new window.WebKitCSSMatrix() && !android23;
    // @property gecko3d: Boolean; `true` for gecko-based browsers supporting CSS transforms.
    var gecko3d = "MozPerspective" in style;
    // @property any3d: Boolean
    // `true` for all browsers supporting CSS transforms.
    var any3d = !window.L_DISABLE_3D && (ie3d || webkit3d || gecko3d) && !opera12 && !phantom;
    // @property mobile: Boolean; `true` for all browsers running in a mobile device.
    var mobile = typeof orientation !== "undefined" || userAgentContains("mobile");
    // @property mobileWebkit: Boolean; `true` for all webkit-based browsers in a mobile device.
    var mobileWebkit = mobile && webkit;
    // @property mobileWebkit3d: Boolean
    // `true` for all webkit-based browsers in a mobile device supporting CSS transforms.
    var mobileWebkit3d = mobile && webkit3d;
    // @property msPointer: Boolean
    // `true` for browsers implementing the Microsoft touch events model (notably IE10).
    var msPointer = !window.PointerEvent && window.MSPointerEvent;
    // @property pointer: Boolean
    // `true` for all browsers supporting [pointer events](https://msdn.microsoft.com/en-us/library/dn433244%28v=vs.85%29.aspx).
    var pointer = !!(window.PointerEvent || msPointer);
    // @property touchNative: Boolean
    // `true` for all browsers supporting [touch events](https://developer.mozilla.org/docs/Web/API/Touch_events).
    // **This does not necessarily mean** that the browser is running in a computer with
    // a touchscreen, it only means that the browser is capable of understanding
    // touch events.
    var touchNative = "ontouchstart" in window || !!window.TouchEvent;
    // @property touch: Boolean
    // `true` for all browsers supporting either [touch](#browser-touch) or [pointer](#browser-pointer) events.
    // Note: pointer events will be preferred (if available), and processed for all `touch*` listeners.
    var touch = !window.L_NO_TOUCH && (touchNative || pointer);
    // @property mobileOpera: Boolean; `true` for the Opera browser in a mobile device.
    var mobileOpera = mobile && opera;
    // @property mobileGecko: Boolean
    // `true` for gecko-based browsers running in a mobile device.
    var mobileGecko = mobile && gecko;
    // @property retina: Boolean
    // `true` for browsers on a high-resolution "retina" screen or on any screen when browser's display zoom is more than 100%.
    var retina = (window.devicePixelRatio || window.screen.deviceXDPI / window.screen.logicalXDPI) > 1;
    // @property passiveEvents: Boolean
    // `true` for browsers that support passive events.
    var passiveEvents = function() {
        var supportsPassiveOption = false;
        try {
            var opts = Object.defineProperty({}, "passive", {
                get: function() {
                    supportsPassiveOption = true;
                }
            });
            window.addEventListener("testPassiveEventSupport", falseFn, opts);
            window.removeEventListener("testPassiveEventSupport", falseFn, opts);
        } catch (e) {
        // Errors can safely be ignored since this is only a browser support test.
        }
        return supportsPassiveOption;
    }();
    // @property canvas: Boolean
    // `true` when the browser supports [`<canvas>`](https://developer.mozilla.org/docs/Web/API/Canvas_API).
    var canvas$1 = function() {
        return !!document.createElement("canvas").getContext;
    }();
    // @property svg: Boolean
    // `true` when the browser supports [SVG](https://developer.mozilla.org/docs/Web/SVG).
    var svg$1 = !!(document.createElementNS && svgCreate("svg").createSVGRect);
    var inlineSvg = !!svg$1 && function() {
        var div = document.createElement("div");
        div.innerHTML = "<svg/>";
        return (div.firstChild && div.firstChild.namespaceURI) === "http://www.w3.org/2000/svg";
    }();
    // @property vml: Boolean
    // `true` if the browser supports [VML](https://en.wikipedia.org/wiki/Vector_Markup_Language).
    var vml = !svg$1 && function() {
        try {
            var div = document.createElement("div");
            div.innerHTML = '<v:shape adj="1"/>';
            var shape = div.firstChild;
            shape.style.behavior = "url(#default#VML)";
            return shape && typeof shape.adj === "object";
        } catch (e) {
            return false;
        }
    }();
    // @property mac: Boolean; `true` when the browser is running in a Mac platform
    var mac = navigator.platform.indexOf("Mac") === 0;
    // @property mac: Boolean; `true` when the browser is running in a Linux platform
    var linux = navigator.platform.indexOf("Linux") === 0;
    function userAgentContains(str) {
        return navigator.userAgent.toLowerCase().indexOf(str) >= 0;
    }
    var Browser = {
        ie: ie,
        ielt9: ielt9,
        edge: edge,
        webkit: webkit,
        android: android,
        android23: android23,
        androidStock: androidStock,
        opera: opera,
        chrome: chrome,
        gecko: gecko,
        safari: safari,
        phantom: phantom,
        opera12: opera12,
        win: win,
        ie3d: ie3d,
        webkit3d: webkit3d,
        gecko3d: gecko3d,
        any3d: any3d,
        mobile: mobile,
        mobileWebkit: mobileWebkit,
        mobileWebkit3d: mobileWebkit3d,
        msPointer: msPointer,
        pointer: pointer,
        touch: touch,
        touchNative: touchNative,
        mobileOpera: mobileOpera,
        mobileGecko: mobileGecko,
        retina: retina,
        passiveEvents: passiveEvents,
        canvas: canvas$1,
        svg: svg$1,
        vml: vml,
        inlineSvg: inlineSvg,
        mac: mac,
        linux: linux
    };
    /*
   * Extends L.DomEvent to provide touch support for Internet Explorer and Windows-based devices.
   */ var POINTER_DOWN = Browser.msPointer ? "MSPointerDown" : "pointerdown";
    var POINTER_MOVE = Browser.msPointer ? "MSPointerMove" : "pointermove";
    var POINTER_UP = Browser.msPointer ? "MSPointerUp" : "pointerup";
    var POINTER_CANCEL = Browser.msPointer ? "MSPointerCancel" : "pointercancel";
    var pEvent = {
        touchstart: POINTER_DOWN,
        touchmove: POINTER_MOVE,
        touchend: POINTER_UP,
        touchcancel: POINTER_CANCEL
    };
    var handle = {
        touchstart: _onPointerStart,
        touchmove: _handlePointer,
        touchend: _handlePointer,
        touchcancel: _handlePointer
    };
    var _pointers = {};
    var _pointerDocListener = false;
    // Provides a touch events wrapper for (ms)pointer events.
    // ref https://www.w3.org/TR/pointerevents/ https://www.w3.org/Bugs/Public/show_bug.cgi?id=22890
    function addPointerListener(obj, type, handler) {
        if (type === "touchstart") _addPointerDocListener();
        if (!handle[type]) {
            console.warn("wrong event specified:", type);
            return falseFn;
        }
        handler = handle[type].bind(this, handler);
        obj.addEventListener(pEvent[type], handler, false);
        return handler;
    }
    function removePointerListener(obj, type, handler) {
        if (!pEvent[type]) {
            console.warn("wrong event specified:", type);
            return;
        }
        obj.removeEventListener(pEvent[type], handler, false);
    }
    function _globalPointerDown(e) {
        _pointers[e.pointerId] = e;
    }
    function _globalPointerMove(e) {
        if (_pointers[e.pointerId]) _pointers[e.pointerId] = e;
    }
    function _globalPointerUp(e) {
        delete _pointers[e.pointerId];
    }
    function _addPointerDocListener() {
        // need to keep track of what pointers and how many are active to provide e.touches emulation
        if (!_pointerDocListener) {
            // we listen document as any drags that end by moving the touch off the screen get fired there
            document.addEventListener(POINTER_DOWN, _globalPointerDown, true);
            document.addEventListener(POINTER_MOVE, _globalPointerMove, true);
            document.addEventListener(POINTER_UP, _globalPointerUp, true);
            document.addEventListener(POINTER_CANCEL, _globalPointerUp, true);
            _pointerDocListener = true;
        }
    }
    function _handlePointer(handler, e) {
        if (e.pointerType === (e.MSPOINTER_TYPE_MOUSE || "mouse")) return;
        e.touches = [];
        for(var i in _pointers)e.touches.push(_pointers[i]);
        e.changedTouches = [
            e
        ];
        handler(e);
    }
    function _onPointerStart(handler, e) {
        // IE10 specific: MsTouch needs preventDefault. See #2000
        if (e.MSPOINTER_TYPE_TOUCH && e.pointerType === e.MSPOINTER_TYPE_TOUCH) preventDefault(e);
        _handlePointer(handler, e);
    }
    /*
   * Extends the event handling code with double tap support for mobile browsers.
   *
   * Note: currently most browsers fire native dblclick, with only a few exceptions
   * (see https://github.com/Leaflet/Leaflet/issues/7012#issuecomment-595087386)
   */ function makeDblclick(event) {
        // in modern browsers `type` cannot be just overridden:
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Errors/Getter_only
        var newEvent = {}, prop, i;
        for(i in event){
            prop = event[i];
            newEvent[i] = prop && prop.bind ? prop.bind(event) : prop;
        }
        event = newEvent;
        newEvent.type = "dblclick";
        newEvent.detail = 2;
        newEvent.isTrusted = false;
        newEvent._simulated = true; // for debug purposes
        return newEvent;
    }
    var delay = 200;
    function addDoubleTapListener(obj, handler) {
        // Most browsers handle double tap natively
        obj.addEventListener("dblclick", handler);
        // On some platforms the browser doesn't fire native dblclicks for touch events.
        // It seems that in all such cases `detail` property of `click` event is always `1`.
        // So here we rely on that fact to avoid excessive 'dblclick' simulation when not needed.
        var last = 0, detail;
        function simDblclick(e) {
            if (e.detail !== 1) {
                detail = e.detail; // keep in sync to avoid false dblclick in some cases
                return;
            }
            if (e.pointerType === "mouse" || e.sourceCapabilities && !e.sourceCapabilities.firesTouchEvents) return;
            // When clicking on an <input>, the browser generates a click on its
            // <label> (and vice versa) triggering two clicks in quick succession.
            // This ignores clicks on elements which are a label with a 'for'
            // attribute (or children of such a label), but not children of
            // a <input>.
            var path = getPropagationPath(e);
            if (path.some(function(el) {
                return el instanceof HTMLLabelElement && el.attributes.for;
            }) && !path.some(function(el) {
                return el instanceof HTMLInputElement || el instanceof HTMLSelectElement;
            })) return;
            var now = Date.now();
            if (now - last <= delay) {
                detail++;
                if (detail === 2) handler(makeDblclick(e));
            } else detail = 1;
            last = now;
        }
        obj.addEventListener("click", simDblclick);
        return {
            dblclick: handler,
            simDblclick: simDblclick
        };
    }
    function removeDoubleTapListener(obj, handlers) {
        obj.removeEventListener("dblclick", handlers.dblclick);
        obj.removeEventListener("click", handlers.simDblclick);
    }
    /*
   * @namespace DomUtil
   *
   * Utility functions to work with the [DOM](https://developer.mozilla.org/docs/Web/API/Document_Object_Model)
   * tree, used by Leaflet internally.
   *
   * Most functions expecting or returning a `HTMLElement` also work for
   * SVG elements. The only difference is that classes refer to CSS classes
   * in HTML and SVG classes in SVG.
   */ // @property TRANSFORM: String
    // Vendor-prefixed transform style name (e.g. `'webkitTransform'` for WebKit).
    var TRANSFORM = testProp([
        "transform",
        "webkitTransform",
        "OTransform",
        "MozTransform",
        "msTransform"
    ]);
    // webkitTransition comes first because some browser versions that drop vendor prefix don't do
    // the same for the transitionend event, in particular the Android 4.1 stock browser
    // @property TRANSITION: String
    // Vendor-prefixed transition style name.
    var TRANSITION = testProp([
        "webkitTransition",
        "transition",
        "OTransition",
        "MozTransition",
        "msTransition"
    ]);
    // @property TRANSITION_END: String
    // Vendor-prefixed transitionend event name.
    var TRANSITION_END = TRANSITION === "webkitTransition" || TRANSITION === "OTransition" ? TRANSITION + "End" : "transitionend";
    // @function get(id: String|HTMLElement): HTMLElement
    // Returns an element given its DOM id, or returns the element itself
    // if it was passed directly.
    function get(id) {
        return typeof id === "string" ? document.getElementById(id) : id;
    }
    // @function getStyle(el: HTMLElement, styleAttrib: String): String
    // Returns the value for a certain style attribute on an element,
    // including computed values or values set through CSS.
    function getStyle(el, style) {
        var value = el.style[style] || el.currentStyle && el.currentStyle[style];
        if ((!value || value === "auto") && document.defaultView) {
            var css = document.defaultView.getComputedStyle(el, null);
            value = css ? css[style] : null;
        }
        return value === "auto" ? null : value;
    }
    // @function create(tagName: String, className?: String, container?: HTMLElement): HTMLElement
    // Creates an HTML element with `tagName`, sets its class to `className`, and optionally appends it to `container` element.
    function create$1(tagName, className, container) {
        var el = document.createElement(tagName);
        el.className = className || "";
        if (container) container.appendChild(el);
        return el;
    }
    // @function remove(el: HTMLElement)
    // Removes `el` from its parent element
    function remove(el) {
        var parent = el.parentNode;
        if (parent) parent.removeChild(el);
    }
    // @function empty(el: HTMLElement)
    // Removes all of `el`'s children elements from `el`
    function empty(el) {
        while(el.firstChild)el.removeChild(el.firstChild);
    }
    // @function toFront(el: HTMLElement)
    // Makes `el` the last child of its parent, so it renders in front of the other children.
    function toFront(el) {
        var parent = el.parentNode;
        if (parent && parent.lastChild !== el) parent.appendChild(el);
    }
    // @function toBack(el: HTMLElement)
    // Makes `el` the first child of its parent, so it renders behind the other children.
    function toBack(el) {
        var parent = el.parentNode;
        if (parent && parent.firstChild !== el) parent.insertBefore(el, parent.firstChild);
    }
    // @function hasClass(el: HTMLElement, name: String): Boolean
    // Returns `true` if the element's class attribute contains `name`.
    function hasClass(el, name) {
        if (el.classList !== undefined) return el.classList.contains(name);
        var className = getClass(el);
        return className.length > 0 && new RegExp("(^|\\s)" + name + "(\\s|$)").test(className);
    }
    // @function addClass(el: HTMLElement, name: String)
    // Adds `name` to the element's class attribute.
    function addClass(el, name) {
        if (el.classList !== undefined) {
            var classes = splitWords(name);
            for(var i = 0, len = classes.length; i < len; i++)el.classList.add(classes[i]);
        } else if (!hasClass(el, name)) {
            var className = getClass(el);
            setClass(el, (className ? className + " " : "") + name);
        }
    }
    // @function removeClass(el: HTMLElement, name: String)
    // Removes `name` from the element's class attribute.
    function removeClass(el, name) {
        if (el.classList !== undefined) el.classList.remove(name);
        else setClass(el, trim((" " + getClass(el) + " ").replace(" " + name + " ", " ")));
    }
    // @function setClass(el: HTMLElement, name: String)
    // Sets the element's class.
    function setClass(el, name) {
        if (el.className.baseVal === undefined) el.className = name;
        else // in case of SVG element
        el.className.baseVal = name;
    }
    // @function getClass(el: HTMLElement): String
    // Returns the element's class.
    function getClass(el) {
        // Check if the element is an SVGElementInstance and use the correspondingElement instead
        // (Required for linked SVG elements in IE11.)
        if (el.correspondingElement) el = el.correspondingElement;
        return el.className.baseVal === undefined ? el.className : el.className.baseVal;
    }
    // @function setOpacity(el: HTMLElement, opacity: Number)
    // Set the opacity of an element (including old IE support).
    // `opacity` must be a number from `0` to `1`.
    function setOpacity(el, value) {
        if ("opacity" in el.style) el.style.opacity = value;
        else if ("filter" in el.style) _setOpacityIE(el, value);
    }
    function _setOpacityIE(el, value) {
        var filter = false, filterName = "DXImageTransform.Microsoft.Alpha";
        // filters collection throws an error if we try to retrieve a filter that doesn't exist
        try {
            filter = el.filters.item(filterName);
        } catch (e) {
            // don't set opacity to 1 if we haven't already set an opacity,
            // it isn't needed and breaks transparent pngs.
            if (value === 1) return;
        }
        value = Math.round(value * 100);
        if (filter) {
            filter.Enabled = value !== 100;
            filter.Opacity = value;
        } else el.style.filter += " progid:" + filterName + "(opacity=" + value + ")";
    }
    // @function testProp(props: String[]): String|false
    // Goes through the array of style names and returns the first name
    // that is a valid style name for an element. If no such name is found,
    // it returns false. Useful for vendor-prefixed styles like `transform`.
    function testProp(props) {
        var style = document.documentElement.style;
        for(var i = 0; i < props.length; i++){
            if (props[i] in style) return props[i];
        }
        return false;
    }
    // @function setTransform(el: HTMLElement, offset: Point, scale?: Number)
    // Resets the 3D CSS transform of `el` so it is translated by `offset` pixels
    // and optionally scaled by `scale`. Does not have an effect if the
    // browser doesn't support 3D CSS transforms.
    function setTransform(el, offset, scale) {
        var pos = offset || new Point(0, 0);
        el.style[TRANSFORM] = (Browser.ie3d ? "translate(" + pos.x + "px," + pos.y + "px)" : "translate3d(" + pos.x + "px," + pos.y + "px,0)") + (scale ? " scale(" + scale + ")" : "");
    }
    // @function setPosition(el: HTMLElement, position: Point)
    // Sets the position of `el` to coordinates specified by `position`,
    // using CSS translate or top/left positioning depending on the browser
    // (used by Leaflet internally to position its layers).
    function setPosition(el, point) {
        /*eslint-disable */ el._leaflet_pos = point;
        /* eslint-enable */ if (Browser.any3d) setTransform(el, point);
        else {
            el.style.left = point.x + "px";
            el.style.top = point.y + "px";
        }
    }
    // @function getPosition(el: HTMLElement): Point
    // Returns the coordinates of an element previously positioned with setPosition.
    function getPosition(el) {
        // this method is only used for elements previously positioned using setPosition,
        // so it's safe to cache the position for performance
        return el._leaflet_pos || new Point(0, 0);
    }
    // @function disableTextSelection()
    // Prevents the user from generating `selectstart` DOM events, usually generated
    // when the user drags the mouse through a page with text. Used internally
    // by Leaflet to override the behaviour of any click-and-drag interaction on
    // the map. Affects drag interactions on the whole document.
    // @function enableTextSelection()
    // Cancels the effects of a previous [`L.DomUtil.disableTextSelection`](#domutil-disabletextselection).
    var disableTextSelection;
    var enableTextSelection;
    var _userSelect;
    if ("onselectstart" in document) {
        disableTextSelection = function() {
            on(window, "selectstart", preventDefault);
        };
        enableTextSelection = function() {
            off(window, "selectstart", preventDefault);
        };
    } else {
        var userSelectProperty = testProp([
            "userSelect",
            "WebkitUserSelect",
            "OUserSelect",
            "MozUserSelect",
            "msUserSelect"
        ]);
        disableTextSelection = function() {
            if (userSelectProperty) {
                var style = document.documentElement.style;
                _userSelect = style[userSelectProperty];
                style[userSelectProperty] = "none";
            }
        };
        enableTextSelection = function() {
            if (userSelectProperty) {
                document.documentElement.style[userSelectProperty] = _userSelect;
                _userSelect = undefined;
            }
        };
    }
    // @function disableImageDrag()
    // As [`L.DomUtil.disableTextSelection`](#domutil-disabletextselection), but
    // for `dragstart` DOM events, usually generated when the user drags an image.
    function disableImageDrag() {
        on(window, "dragstart", preventDefault);
    }
    // @function enableImageDrag()
    // Cancels the effects of a previous [`L.DomUtil.disableImageDrag`](#domutil-disabletextselection).
    function enableImageDrag() {
        off(window, "dragstart", preventDefault);
    }
    var _outlineElement, _outlineStyle;
    // @function preventOutline(el: HTMLElement)
    // Makes the [outline](https://developer.mozilla.org/docs/Web/CSS/outline)
    // of the element `el` invisible. Used internally by Leaflet to prevent
    // focusable elements from displaying an outline when the user performs a
    // drag interaction on them.
    function preventOutline(element) {
        while(element.tabIndex === -1)element = element.parentNode;
        if (!element.style) return;
        restoreOutline();
        _outlineElement = element;
        _outlineStyle = element.style.outlineStyle;
        element.style.outlineStyle = "none";
        on(window, "keydown", restoreOutline);
    }
    // @function restoreOutline()
    // Cancels the effects of a previous [`L.DomUtil.preventOutline`]().
    function restoreOutline() {
        if (!_outlineElement) return;
        _outlineElement.style.outlineStyle = _outlineStyle;
        _outlineElement = undefined;
        _outlineStyle = undefined;
        off(window, "keydown", restoreOutline);
    }
    // @function getSizedParentNode(el: HTMLElement): HTMLElement
    // Finds the closest parent node which size (width and height) is not null.
    function getSizedParentNode(element) {
        do element = element.parentNode;
        while ((!element.offsetWidth || !element.offsetHeight) && element !== document.body);
        return element;
    }
    // @function getScale(el: HTMLElement): Object
    // Computes the CSS scale currently applied on the element.
    // Returns an object with `x` and `y` members as horizontal and vertical scales respectively,
    // and `boundingClientRect` as the result of [`getBoundingClientRect()`](https://developer.mozilla.org/en-US/docs/Web/API/Element/getBoundingClientRect).
    function getScale(element) {
        var rect = element.getBoundingClientRect(); // Read-only in old browsers.
        return {
            x: rect.width / element.offsetWidth || 1,
            y: rect.height / element.offsetHeight || 1,
            boundingClientRect: rect
        };
    }
    var DomUtil = {
        __proto__: null,
        TRANSFORM: TRANSFORM,
        TRANSITION: TRANSITION,
        TRANSITION_END: TRANSITION_END,
        get: get,
        getStyle: getStyle,
        create: create$1,
        remove: remove,
        empty: empty,
        toFront: toFront,
        toBack: toBack,
        hasClass: hasClass,
        addClass: addClass,
        removeClass: removeClass,
        setClass: setClass,
        getClass: getClass,
        setOpacity: setOpacity,
        testProp: testProp,
        setTransform: setTransform,
        setPosition: setPosition,
        getPosition: getPosition,
        get disableTextSelection () {
            return disableTextSelection;
        },
        get enableTextSelection () {
            return enableTextSelection;
        },
        disableImageDrag: disableImageDrag,
        enableImageDrag: enableImageDrag,
        preventOutline: preventOutline,
        restoreOutline: restoreOutline,
        getSizedParentNode: getSizedParentNode,
        getScale: getScale
    };
    /*
   * @namespace DomEvent
   * Utility functions to work with the [DOM events](https://developer.mozilla.org/docs/Web/API/Event), used by Leaflet internally.
   */ // Inspired by John Resig, Dean Edwards and YUI addEvent implementations.
    // @function on(el: HTMLElement, types: String, fn: Function, context?: Object): this
    // Adds a listener function (`fn`) to a particular DOM event type of the
    // element `el`. You can optionally specify the context of the listener
    // (object the `this` keyword will point to). You can also pass several
    // space-separated types (e.g. `'click dblclick'`).
    // @alternative
    // @function on(el: HTMLElement, eventMap: Object, context?: Object): this
    // Adds a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
    function on(obj, types, fn, context) {
        if (types && typeof types === "object") for(var type in types)addOne(obj, type, types[type], fn);
        else {
            types = splitWords(types);
            for(var i = 0, len = types.length; i < len; i++)addOne(obj, types[i], fn, context);
        }
        return this;
    }
    var eventsKey = "_leaflet_events";
    // @function off(el: HTMLElement, types: String, fn: Function, context?: Object): this
    // Removes a previously added listener function.
    // Note that if you passed a custom context to on, you must pass the same
    // context to `off` in order to remove the listener.
    // @alternative
    // @function off(el: HTMLElement, eventMap: Object, context?: Object): this
    // Removes a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
    // @alternative
    // @function off(el: HTMLElement, types: String): this
    // Removes all previously added listeners of given types.
    // @alternative
    // @function off(el: HTMLElement): this
    // Removes all previously added listeners from given HTMLElement
    function off(obj, types, fn, context) {
        if (arguments.length === 1) {
            batchRemove(obj);
            delete obj[eventsKey];
        } else if (types && typeof types === "object") for(var type in types)removeOne(obj, type, types[type], fn);
        else {
            types = splitWords(types);
            if (arguments.length === 2) batchRemove(obj, function(type) {
                return indexOf(types, type) !== -1;
            });
            else for(var i = 0, len = types.length; i < len; i++)removeOne(obj, types[i], fn, context);
        }
        return this;
    }
    function batchRemove(obj, filterFn) {
        for(var id in obj[eventsKey]){
            var type = id.split(/\d/)[0];
            if (!filterFn || filterFn(type)) removeOne(obj, type, null, null, id);
        }
    }
    var mouseSubst = {
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        wheel: !("onwheel" in window) && "mousewheel"
    };
    function addOne(obj, type, fn, context) {
        var id = type + stamp(fn) + (context ? "_" + stamp(context) : "");
        if (obj[eventsKey] && obj[eventsKey][id]) return this;
        var handler = function(e) {
            return fn.call(context || obj, e || window.event);
        };
        var originalHandler = handler;
        if (!Browser.touchNative && Browser.pointer && type.indexOf("touch") === 0) // Needs DomEvent.Pointer.js
        handler = addPointerListener(obj, type, handler);
        else if (Browser.touch && type === "dblclick") handler = addDoubleTapListener(obj, handler);
        else if ("addEventListener" in obj) {
            if (type === "touchstart" || type === "touchmove" || type === "wheel" || type === "mousewheel") obj.addEventListener(mouseSubst[type] || type, handler, Browser.passiveEvents ? {
                passive: false
            } : false);
            else if (type === "mouseenter" || type === "mouseleave") {
                handler = function(e) {
                    e = e || window.event;
                    if (isExternalTarget(obj, e)) originalHandler(e);
                };
                obj.addEventListener(mouseSubst[type], handler, false);
            } else obj.addEventListener(type, originalHandler, false);
        } else obj.attachEvent("on" + type, handler);
        obj[eventsKey] = obj[eventsKey] || {};
        obj[eventsKey][id] = handler;
    }
    function removeOne(obj, type, fn, context, id) {
        id = id || type + stamp(fn) + (context ? "_" + stamp(context) : "");
        var handler = obj[eventsKey] && obj[eventsKey][id];
        if (!handler) return this;
        if (!Browser.touchNative && Browser.pointer && type.indexOf("touch") === 0) removePointerListener(obj, type, handler);
        else if (Browser.touch && type === "dblclick") removeDoubleTapListener(obj, handler);
        else if ("removeEventListener" in obj) obj.removeEventListener(mouseSubst[type] || type, handler, false);
        else obj.detachEvent("on" + type, handler);
        obj[eventsKey][id] = null;
    }
    // @function stopPropagation(ev: DOMEvent): this
    // Stop the given event from propagation to parent elements. Used inside the listener functions:
    // ```js
    // L.DomEvent.on(div, 'click', function (ev) {
    // 	L.DomEvent.stopPropagation(ev);
    // });
    // ```
    function stopPropagation(e) {
        if (e.stopPropagation) e.stopPropagation();
        else if (e.originalEvent) e.originalEvent._stopped = true;
        else e.cancelBubble = true;
        return this;
    }
    // @function disableScrollPropagation(el: HTMLElement): this
    // Adds `stopPropagation` to the element's `'wheel'` events (plus browser variants).
    function disableScrollPropagation(el) {
        addOne(el, "wheel", stopPropagation);
        return this;
    }
    // @function disableClickPropagation(el: HTMLElement): this
    // Adds `stopPropagation` to the element's `'click'`, `'dblclick'`, `'contextmenu'`,
    // `'mousedown'` and `'touchstart'` events (plus browser variants).
    function disableClickPropagation(el) {
        on(el, "mousedown touchstart dblclick contextmenu", stopPropagation);
        el["_leaflet_disable_click"] = true;
        return this;
    }
    // @function preventDefault(ev: DOMEvent): this
    // Prevents the default action of the DOM Event `ev` from happening (such as
    // following a link in the href of the a element, or doing a POST request
    // with page reload when a `<form>` is submitted).
    // Use it inside listener functions.
    function preventDefault(e) {
        if (e.preventDefault) e.preventDefault();
        else e.returnValue = false;
        return this;
    }
    // @function stop(ev: DOMEvent): this
    // Does `stopPropagation` and `preventDefault` at the same time.
    function stop(e) {
        preventDefault(e);
        stopPropagation(e);
        return this;
    }
    // @function getPropagationPath(ev: DOMEvent): Array
    // Compatibility polyfill for [`Event.composedPath()`](https://developer.mozilla.org/en-US/docs/Web/API/Event/composedPath).
    // Returns an array containing the `HTMLElement`s that the given DOM event
    // should propagate to (if not stopped).
    function getPropagationPath(ev) {
        if (ev.composedPath) return ev.composedPath();
        var path = [];
        var el = ev.target;
        while(el){
            path.push(el);
            el = el.parentNode;
        }
        return path;
    }
    // @function getMousePosition(ev: DOMEvent, container?: HTMLElement): Point
    // Gets normalized mouse position from a DOM event relative to the
    // `container` (border excluded) or to the whole page if not specified.
    function getMousePosition(e, container) {
        if (!container) return new Point(e.clientX, e.clientY);
        var scale = getScale(container), offset = scale.boundingClientRect; // left and top  values are in page scale (like the event clientX/Y)
        return new Point(// offset.left/top values are in page scale (like clientX/Y),
        // whereas clientLeft/Top (border width) values are the original values (before CSS scale applies).
        (e.clientX - offset.left) / scale.x - container.clientLeft, (e.clientY - offset.top) / scale.y - container.clientTop);
    }
    //  except , Safari and
    // We need double the scroll pixels (see #7403 and #4538) for all Browsers
    // except OSX (Mac) -> 3x, Chrome running on Linux 1x
    var wheelPxFactor = Browser.linux && Browser.chrome ? window.devicePixelRatio : Browser.mac ? window.devicePixelRatio * 3 : window.devicePixelRatio > 0 ? 2 * window.devicePixelRatio : 1;
    // @function getWheelDelta(ev: DOMEvent): Number
    // Gets normalized wheel delta from a wheel DOM event, in vertical
    // pixels scrolled (negative if scrolling down).
    // Events from pointing devices without precise scrolling are mapped to
    // a best guess of 60 pixels.
    function getWheelDelta(e) {
        return Browser.edge ? e.wheelDeltaY / 2 : e.deltaY && e.deltaMode === 0 ? -e.deltaY / wheelPxFactor : e.deltaY && e.deltaMode === 1 ? -e.deltaY * 20 : e.deltaY && e.deltaMode === 2 ? -e.deltaY * 60 : e.deltaX || e.deltaZ ? 0 : e.wheelDelta ? (e.wheelDeltaY || e.wheelDelta) / 2 : e.detail && Math.abs(e.detail) < 32765 ? -e.detail * 20 : e.detail ? e.detail / -32765 * 60 : 0;
    }
    // check if element really left/entered the event target (for mouseenter/mouseleave)
    function isExternalTarget(el, e) {
        var related = e.relatedTarget;
        if (!related) return true;
        try {
            while(related && related !== el)related = related.parentNode;
        } catch (err) {
            return false;
        }
        return related !== el;
    }
    var DomEvent = {
        __proto__: null,
        on: on,
        off: off,
        stopPropagation: stopPropagation,
        disableScrollPropagation: disableScrollPropagation,
        disableClickPropagation: disableClickPropagation,
        preventDefault: preventDefault,
        stop: stop,
        getPropagationPath: getPropagationPath,
        getMousePosition: getMousePosition,
        getWheelDelta: getWheelDelta,
        isExternalTarget: isExternalTarget,
        addListener: on,
        removeListener: off
    };
    /*
   * @class PosAnimation
   * @aka L.PosAnimation
   * @inherits Evented
   * Used internally for panning animations, utilizing CSS3 Transitions for modern browsers and a timer fallback for IE6-9.
   *
   * @example
   * ```js
   * var myPositionMarker = L.marker([48.864716, 2.294694]).addTo(map);
   *
   * myPositionMarker.on("click", function() {
   * 	var pos = map.latLngToLayerPoint(myPositionMarker.getLatLng());
   * 	pos.y -= 25;
   * 	var fx = new L.PosAnimation();
   *
   * 	fx.once('end',function() {
   * 		pos.y += 25;
   * 		fx.run(myPositionMarker._icon, pos, 0.8);
   * 	});
   *
   * 	fx.run(myPositionMarker._icon, pos, 0.3);
   * });
   *
   * ```
   *
   * @constructor L.PosAnimation()
   * Creates a `PosAnimation` object.
   *
   */ var PosAnimation = Evented.extend({
        // @method run(el: HTMLElement, newPos: Point, duration?: Number, easeLinearity?: Number)
        // Run an animation of a given element to a new position, optionally setting
        // duration in seconds (`0.25` by default) and easing linearity factor (3rd
        // argument of the [cubic bezier curve](https://cubic-bezier.com/#0,0,.5,1),
        // `0.5` by default).
        run: function(el, newPos, duration, easeLinearity) {
            this.stop();
            this._el = el;
            this._inProgress = true;
            this._duration = duration || 0.25;
            this._easeOutPower = 1 / Math.max(easeLinearity || 0.5, 0.2);
            this._startPos = getPosition(el);
            this._offset = newPos.subtract(this._startPos);
            this._startTime = +new Date();
            // @event start: Event
            // Fired when the animation starts
            this.fire("start");
            this._animate();
        },
        // @method stop()
        // Stops the animation (if currently running).
        stop: function() {
            if (!this._inProgress) return;
            this._step(true);
            this._complete();
        },
        _animate: function() {
            // animation loop
            this._animId = requestAnimFrame(this._animate, this);
            this._step();
        },
        _step: function(round) {
            var elapsed = +new Date() - this._startTime, duration = this._duration * 1000;
            if (elapsed < duration) this._runFrame(this._easeOut(elapsed / duration), round);
            else {
                this._runFrame(1);
                this._complete();
            }
        },
        _runFrame: function(progress, round) {
            var pos = this._startPos.add(this._offset.multiplyBy(progress));
            if (round) pos._round();
            setPosition(this._el, pos);
            // @event step: Event
            // Fired continuously during the animation.
            this.fire("step");
        },
        _complete: function() {
            cancelAnimFrame(this._animId);
            this._inProgress = false;
            // @event end: Event
            // Fired when the animation ends.
            this.fire("end");
        },
        _easeOut: function(t) {
            return 1 - Math.pow(1 - t, this._easeOutPower);
        }
    });
    /*
   * @class Map
   * @aka L.Map
   * @inherits Evented
   *
   * The central class of the API — it is used to create a map on a page and manipulate it.
   *
   * @example
   *
   * ```js
   * // initialize the map on the "map" div with a given center and zoom
   * var map = L.map('map', {
   * 	center: [51.505, -0.09],
   * 	zoom: 13
   * });
   * ```
   *
   */ var Map = Evented.extend({
        options: {
            // @section Map State Options
            // @option crs: CRS = L.CRS.EPSG3857
            // The [Coordinate Reference System](#crs) to use. Don't change this if you're not
            // sure what it means.
            crs: EPSG3857,
            // @option center: LatLng = undefined
            // Initial geographic center of the map
            center: undefined,
            // @option zoom: Number = undefined
            // Initial map zoom level
            zoom: undefined,
            // @option minZoom: Number = *
            // Minimum zoom level of the map.
            // If not specified and at least one `GridLayer` or `TileLayer` is in the map,
            // the lowest of their `minZoom` options will be used instead.
            minZoom: undefined,
            // @option maxZoom: Number = *
            // Maximum zoom level of the map.
            // If not specified and at least one `GridLayer` or `TileLayer` is in the map,
            // the highest of their `maxZoom` options will be used instead.
            maxZoom: undefined,
            // @option layers: Layer[] = []
            // Array of layers that will be added to the map initially
            layers: [],
            // @option maxBounds: LatLngBounds = null
            // When this option is set, the map restricts the view to the given
            // geographical bounds, bouncing the user back if the user tries to pan
            // outside the view. To set the restriction dynamically, use
            // [`setMaxBounds`](#map-setmaxbounds) method.
            maxBounds: undefined,
            // @option renderer: Renderer = *
            // The default method for drawing vector layers on the map. `L.SVG`
            // or `L.Canvas` by default depending on browser support.
            renderer: undefined,
            // @section Animation Options
            // @option zoomAnimation: Boolean = true
            // Whether the map zoom animation is enabled. By default it's enabled
            // in all browsers that support CSS3 Transitions except Android.
            zoomAnimation: true,
            // @option zoomAnimationThreshold: Number = 4
            // Won't animate zoom if the zoom difference exceeds this value.
            zoomAnimationThreshold: 4,
            // @option fadeAnimation: Boolean = true
            // Whether the tile fade animation is enabled. By default it's enabled
            // in all browsers that support CSS3 Transitions except Android.
            fadeAnimation: true,
            // @option markerZoomAnimation: Boolean = true
            // Whether markers animate their zoom with the zoom animation, if disabled
            // they will disappear for the length of the animation. By default it's
            // enabled in all browsers that support CSS3 Transitions except Android.
            markerZoomAnimation: true,
            // @option transform3DLimit: Number = 2^23
            // Defines the maximum size of a CSS translation transform. The default
            // value should not be changed unless a web browser positions layers in
            // the wrong place after doing a large `panBy`.
            transform3DLimit: 8388608,
            // @section Interaction Options
            // @option zoomSnap: Number = 1
            // Forces the map's zoom level to always be a multiple of this, particularly
            // right after a [`fitBounds()`](#map-fitbounds) or a pinch-zoom.
            // By default, the zoom level snaps to the nearest integer; lower values
            // (e.g. `0.5` or `0.1`) allow for greater granularity. A value of `0`
            // means the zoom level will not be snapped after `fitBounds` or a pinch-zoom.
            zoomSnap: 1,
            // @option zoomDelta: Number = 1
            // Controls how much the map's zoom level will change after a
            // [`zoomIn()`](#map-zoomin), [`zoomOut()`](#map-zoomout), pressing `+`
            // or `-` on the keyboard, or using the [zoom controls](#control-zoom).
            // Values smaller than `1` (e.g. `0.5`) allow for greater granularity.
            zoomDelta: 1,
            // @option trackResize: Boolean = true
            // Whether the map automatically handles browser window resize to update itself.
            trackResize: true
        },
        initialize: function(id, options) {
            options = setOptions(this, options);
            // Make sure to assign internal flags at the beginning,
            // to avoid inconsistent state in some edge cases.
            this._handlers = [];
            this._layers = {};
            this._zoomBoundLayers = {};
            this._sizeChanged = true;
            this._initContainer(id);
            this._initLayout();
            // hack for https://github.com/Leaflet/Leaflet/issues/1980
            this._onResize = bind(this._onResize, this);
            this._initEvents();
            if (options.maxBounds) this.setMaxBounds(options.maxBounds);
            if (options.zoom !== undefined) this._zoom = this._limitZoom(options.zoom);
            if (options.center && options.zoom !== undefined) this.setView(toLatLng(options.center), options.zoom, {
                reset: true
            });
            this.callInitHooks();
            // don't animate on browsers without hardware-accelerated transitions or old Android/Opera
            this._zoomAnimated = TRANSITION && Browser.any3d && !Browser.mobileOpera && this.options.zoomAnimation;
            // zoom transitions run with the same duration for all layers, so if one of transitionend events
            // happens after starting zoom animation (propagating to the map pane), we know that it ended globally
            if (this._zoomAnimated) {
                this._createAnimProxy();
                on(this._proxy, TRANSITION_END, this._catchTransitionEnd, this);
            }
            this._addLayers(this.options.layers);
        },
        // @section Methods for modifying map state
        // @method setView(center: LatLng, zoom: Number, options?: Zoom/pan options): this
        // Sets the view of the map (geographical center and zoom) with the given
        // animation options.
        setView: function(center, zoom, options) {
            zoom = zoom === undefined ? this._zoom : this._limitZoom(zoom);
            center = this._limitCenter(toLatLng(center), zoom, this.options.maxBounds);
            options = options || {};
            this._stop();
            if (this._loaded && !options.reset && options !== true) {
                if (options.animate !== undefined) {
                    options.zoom = extend({
                        animate: options.animate
                    }, options.zoom);
                    options.pan = extend({
                        animate: options.animate,
                        duration: options.duration
                    }, options.pan);
                }
                // try animating pan or zoom
                var moved = this._zoom !== zoom ? this._tryAnimatedZoom && this._tryAnimatedZoom(center, zoom, options.zoom) : this._tryAnimatedPan(center, options.pan);
                if (moved) {
                    // prevent resize handler call, the view will refresh after animation anyway
                    clearTimeout(this._sizeTimer);
                    return this;
                }
            }
            // animation didn't start, just reset the map view
            this._resetView(center, zoom, options.pan && options.pan.noMoveStart);
            return this;
        },
        // @method setZoom(zoom: Number, options?: Zoom/pan options): this
        // Sets the zoom of the map.
        setZoom: function(zoom, options) {
            if (!this._loaded) {
                this._zoom = zoom;
                return this;
            }
            return this.setView(this.getCenter(), zoom, {
                zoom: options
            });
        },
        // @method zoomIn(delta?: Number, options?: Zoom options): this
        // Increases the zoom of the map by `delta` ([`zoomDelta`](#map-zoomdelta) by default).
        zoomIn: function(delta, options) {
            delta = delta || (Browser.any3d ? this.options.zoomDelta : 1);
            return this.setZoom(this._zoom + delta, options);
        },
        // @method zoomOut(delta?: Number, options?: Zoom options): this
        // Decreases the zoom of the map by `delta` ([`zoomDelta`](#map-zoomdelta) by default).
        zoomOut: function(delta, options) {
            delta = delta || (Browser.any3d ? this.options.zoomDelta : 1);
            return this.setZoom(this._zoom - delta, options);
        },
        // @method setZoomAround(latlng: LatLng, zoom: Number, options: Zoom options): this
        // Zooms the map while keeping a specified geographical point on the map
        // stationary (e.g. used internally for scroll zoom and double-click zoom).
        // @alternative
        // @method setZoomAround(offset: Point, zoom: Number, options: Zoom options): this
        // Zooms the map while keeping a specified pixel on the map (relative to the top-left corner) stationary.
        setZoomAround: function(latlng, zoom, options) {
            var scale = this.getZoomScale(zoom), viewHalf = this.getSize().divideBy(2), containerPoint = latlng instanceof Point ? latlng : this.latLngToContainerPoint(latlng), centerOffset = containerPoint.subtract(viewHalf).multiplyBy(1 - 1 / scale), newCenter = this.containerPointToLatLng(viewHalf.add(centerOffset));
            return this.setView(newCenter, zoom, {
                zoom: options
            });
        },
        _getBoundsCenterZoom: function(bounds, options) {
            options = options || {};
            bounds = bounds.getBounds ? bounds.getBounds() : toLatLngBounds(bounds);
            var paddingTL = toPoint(options.paddingTopLeft || options.padding || [
                0,
                0
            ]), paddingBR = toPoint(options.paddingBottomRight || options.padding || [
                0,
                0
            ]), zoom = this.getBoundsZoom(bounds, false, paddingTL.add(paddingBR));
            zoom = typeof options.maxZoom === "number" ? Math.min(options.maxZoom, zoom) : zoom;
            if (zoom === Infinity) return {
                center: bounds.getCenter(),
                zoom: zoom
            };
            var paddingOffset = paddingBR.subtract(paddingTL).divideBy(2), swPoint = this.project(bounds.getSouthWest(), zoom), nePoint = this.project(bounds.getNorthEast(), zoom), center = this.unproject(swPoint.add(nePoint).divideBy(2).add(paddingOffset), zoom);
            return {
                center: center,
                zoom: zoom
            };
        },
        // @method fitBounds(bounds: LatLngBounds, options?: fitBounds options): this
        // Sets a map view that contains the given geographical bounds with the
        // maximum zoom level possible.
        fitBounds: function(bounds, options) {
            bounds = toLatLngBounds(bounds);
            if (!bounds.isValid()) throw new Error("Bounds are not valid.");
            var target = this._getBoundsCenterZoom(bounds, options);
            return this.setView(target.center, target.zoom, options);
        },
        // @method fitWorld(options?: fitBounds options): this
        // Sets a map view that mostly contains the whole world with the maximum
        // zoom level possible.
        fitWorld: function(options) {
            return this.fitBounds([
                [
                    -90,
                    -180
                ],
                [
                    90,
                    180
                ]
            ], options);
        },
        // @method panTo(latlng: LatLng, options?: Pan options): this
        // Pans the map to a given center.
        panTo: function(center, options) {
            return this.setView(center, this._zoom, {
                pan: options
            });
        },
        // @method panBy(offset: Point, options?: Pan options): this
        // Pans the map by a given number of pixels (animated).
        panBy: function(offset, options) {
            offset = toPoint(offset).round();
            options = options || {};
            if (!offset.x && !offset.y) return this.fire("moveend");
            // If we pan too far, Chrome gets issues with tiles
            // and makes them disappear or appear in the wrong place (slightly offset) #2602
            if (options.animate !== true && !this.getSize().contains(offset)) {
                this._resetView(this.unproject(this.project(this.getCenter()).add(offset)), this.getZoom());
                return this;
            }
            if (!this._panAnim) {
                this._panAnim = new PosAnimation();
                this._panAnim.on({
                    "step": this._onPanTransitionStep,
                    "end": this._onPanTransitionEnd
                }, this);
            }
            // don't fire movestart if animating inertia
            if (!options.noMoveStart) this.fire("movestart");
            // animate pan unless animate: false specified
            if (options.animate !== false) {
                addClass(this._mapPane, "leaflet-pan-anim");
                var newPos = this._getMapPanePos().subtract(offset).round();
                this._panAnim.run(this._mapPane, newPos, options.duration || 0.25, options.easeLinearity);
            } else {
                this._rawPanBy(offset);
                this.fire("move").fire("moveend");
            }
            return this;
        },
        // @method flyTo(latlng: LatLng, zoom?: Number, options?: Zoom/pan options): this
        // Sets the view of the map (geographical center and zoom) performing a smooth
        // pan-zoom animation.
        flyTo: function(targetCenter, targetZoom, options) {
            options = options || {};
            if (options.animate === false || !Browser.any3d) return this.setView(targetCenter, targetZoom, options);
            this._stop();
            var from = this.project(this.getCenter()), to = this.project(targetCenter), size = this.getSize(), startZoom = this._zoom;
            targetCenter = toLatLng(targetCenter);
            targetZoom = targetZoom === undefined ? startZoom : targetZoom;
            var w0 = Math.max(size.x, size.y), w1 = w0 * this.getZoomScale(startZoom, targetZoom), u1 = to.distanceTo(from) || 1, rho = 1.42, rho2 = rho * rho;
            function r(i) {
                var s1 = i ? -1 : 1, s2 = i ? w1 : w0, t1 = w1 * w1 - w0 * w0 + s1 * rho2 * rho2 * u1 * u1, b1 = 2 * s2 * rho2 * u1, b = t1 / b1, sq = Math.sqrt(b * b + 1) - b;
                // workaround for floating point precision bug when sq = 0, log = -Infinite,
                // thus triggering an infinite loop in flyTo
                var log = sq < 0.000000001 ? -18 : Math.log(sq);
                return log;
            }
            function sinh(n) {
                return (Math.exp(n) - Math.exp(-n)) / 2;
            }
            function cosh(n) {
                return (Math.exp(n) + Math.exp(-n)) / 2;
            }
            function tanh(n) {
                return sinh(n) / cosh(n);
            }
            var r0 = r(0);
            function w(s) {
                return w0 * (cosh(r0) / cosh(r0 + rho * s));
            }
            function u(s) {
                return w0 * (cosh(r0) * tanh(r0 + rho * s) - sinh(r0)) / rho2;
            }
            function easeOut(t) {
                return 1 - Math.pow(1 - t, 1.5);
            }
            var start = Date.now(), S = (r(1) - r0) / rho, duration = options.duration ? 1000 * options.duration : 1000 * S * 0.8;
            function frame() {
                var t = (Date.now() - start) / duration, s = easeOut(t) * S;
                if (t <= 1) {
                    this._flyToFrame = requestAnimFrame(frame, this);
                    this._move(this.unproject(from.add(to.subtract(from).multiplyBy(u(s) / u1)), startZoom), this.getScaleZoom(w0 / w(s), startZoom), {
                        flyTo: true
                    });
                } else this._move(targetCenter, targetZoom)._moveEnd(true);
            }
            this._moveStart(true, options.noMoveStart);
            frame.call(this);
            return this;
        },
        // @method flyToBounds(bounds: LatLngBounds, options?: fitBounds options): this
        // Sets the view of the map with a smooth animation like [`flyTo`](#map-flyto),
        // but takes a bounds parameter like [`fitBounds`](#map-fitbounds).
        flyToBounds: function(bounds, options) {
            var target = this._getBoundsCenterZoom(bounds, options);
            return this.flyTo(target.center, target.zoom, options);
        },
        // @method setMaxBounds(bounds: LatLngBounds): this
        // Restricts the map view to the given bounds (see the [maxBounds](#map-maxbounds) option).
        setMaxBounds: function(bounds) {
            bounds = toLatLngBounds(bounds);
            if (this.listens("moveend", this._panInsideMaxBounds)) this.off("moveend", this._panInsideMaxBounds);
            if (!bounds.isValid()) {
                this.options.maxBounds = null;
                return this;
            }
            this.options.maxBounds = bounds;
            if (this._loaded) this._panInsideMaxBounds();
            return this.on("moveend", this._panInsideMaxBounds);
        },
        // @method setMinZoom(zoom: Number): this
        // Sets the lower limit for the available zoom levels (see the [minZoom](#map-minzoom) option).
        setMinZoom: function(zoom) {
            var oldZoom = this.options.minZoom;
            this.options.minZoom = zoom;
            if (this._loaded && oldZoom !== zoom) {
                this.fire("zoomlevelschange");
                if (this.getZoom() < this.options.minZoom) return this.setZoom(zoom);
            }
            return this;
        },
        // @method setMaxZoom(zoom: Number): this
        // Sets the upper limit for the available zoom levels (see the [maxZoom](#map-maxzoom) option).
        setMaxZoom: function(zoom) {
            var oldZoom = this.options.maxZoom;
            this.options.maxZoom = zoom;
            if (this._loaded && oldZoom !== zoom) {
                this.fire("zoomlevelschange");
                if (this.getZoom() > this.options.maxZoom) return this.setZoom(zoom);
            }
            return this;
        },
        // @method panInsideBounds(bounds: LatLngBounds, options?: Pan options): this
        // Pans the map to the closest view that would lie inside the given bounds (if it's not already), controlling the animation using the options specific, if any.
        panInsideBounds: function(bounds, options) {
            this._enforcingBounds = true;
            var center = this.getCenter(), newCenter = this._limitCenter(center, this._zoom, toLatLngBounds(bounds));
            if (!center.equals(newCenter)) this.panTo(newCenter, options);
            this._enforcingBounds = false;
            return this;
        },
        // @method panInside(latlng: LatLng, options?: padding options): this
        // Pans the map the minimum amount to make the `latlng` visible. Use
        // padding options to fit the display to more restricted bounds.
        // If `latlng` is already within the (optionally padded) display bounds,
        // the map will not be panned.
        panInside: function(latlng, options) {
            options = options || {};
            var paddingTL = toPoint(options.paddingTopLeft || options.padding || [
                0,
                0
            ]), paddingBR = toPoint(options.paddingBottomRight || options.padding || [
                0,
                0
            ]), pixelCenter = this.project(this.getCenter()), pixelPoint = this.project(latlng), pixelBounds = this.getPixelBounds(), paddedBounds = toBounds([
                pixelBounds.min.add(paddingTL),
                pixelBounds.max.subtract(paddingBR)
            ]), paddedSize = paddedBounds.getSize();
            if (!paddedBounds.contains(pixelPoint)) {
                this._enforcingBounds = true;
                var centerOffset = pixelPoint.subtract(paddedBounds.getCenter());
                var offset = paddedBounds.extend(pixelPoint).getSize().subtract(paddedSize);
                pixelCenter.x += centerOffset.x < 0 ? -offset.x : offset.x;
                pixelCenter.y += centerOffset.y < 0 ? -offset.y : offset.y;
                this.panTo(this.unproject(pixelCenter), options);
                this._enforcingBounds = false;
            }
            return this;
        },
        // @method invalidateSize(options: Zoom/pan options): this
        // Checks if the map container size changed and updates the map if so —
        // call it after you've changed the map size dynamically, also animating
        // pan by default. If `options.pan` is `false`, panning will not occur.
        // If `options.debounceMoveend` is `true`, it will delay `moveend` event so
        // that it doesn't happen often even if the method is called many
        // times in a row.
        // @alternative
        // @method invalidateSize(animate: Boolean): this
        // Checks if the map container size changed and updates the map if so —
        // call it after you've changed the map size dynamically, also animating
        // pan by default.
        invalidateSize: function(options) {
            if (!this._loaded) return this;
            options = extend({
                animate: false,
                pan: true
            }, options === true ? {
                animate: true
            } : options);
            var oldSize = this.getSize();
            this._sizeChanged = true;
            this._lastCenter = null;
            var newSize = this.getSize(), oldCenter = oldSize.divideBy(2).round(), newCenter = newSize.divideBy(2).round(), offset = oldCenter.subtract(newCenter);
            if (!offset.x && !offset.y) return this;
            if (options.animate && options.pan) this.panBy(offset);
            else {
                if (options.pan) this._rawPanBy(offset);
                this.fire("move");
                if (options.debounceMoveend) {
                    clearTimeout(this._sizeTimer);
                    this._sizeTimer = setTimeout(bind(this.fire, this, "moveend"), 200);
                } else this.fire("moveend");
            }
            // @section Map state change events
            // @event resize: ResizeEvent
            // Fired when the map is resized.
            return this.fire("resize", {
                oldSize: oldSize,
                newSize: newSize
            });
        },
        // @section Methods for modifying map state
        // @method stop(): this
        // Stops the currently running `panTo` or `flyTo` animation, if any.
        stop: function() {
            this.setZoom(this._limitZoom(this._zoom));
            if (!this.options.zoomSnap) this.fire("viewreset");
            return this._stop();
        },
        // @section Geolocation methods
        // @method locate(options?: Locate options): this
        // Tries to locate the user using the Geolocation API, firing a [`locationfound`](#map-locationfound)
        // event with location data on success or a [`locationerror`](#map-locationerror) event on failure,
        // and optionally sets the map view to the user's location with respect to
        // detection accuracy (or to the world view if geolocation failed).
        // Note that, if your page doesn't use HTTPS, this method will fail in
        // modern browsers ([Chrome 50 and newer](https://sites.google.com/a/chromium.org/dev/Home/chromium-security/deprecating-powerful-features-on-insecure-origins))
        // See `Locate options` for more details.
        locate: function(options) {
            options = this._locateOptions = extend({
                timeout: 10000,
                watch: false
            }, options);
            if (!("geolocation" in navigator)) {
                this._handleGeolocationError({
                    code: 0,
                    message: "Geolocation not supported."
                });
                return this;
            }
            var onResponse = bind(this._handleGeolocationResponse, this), onError = bind(this._handleGeolocationError, this);
            if (options.watch) this._locationWatchId = navigator.geolocation.watchPosition(onResponse, onError, options);
            else navigator.geolocation.getCurrentPosition(onResponse, onError, options);
            return this;
        },
        // @method stopLocate(): this
        // Stops watching location previously initiated by `map.locate({watch: true})`
        // and aborts resetting the map view if map.locate was called with
        // `{setView: true}`.
        stopLocate: function() {
            if (navigator.geolocation && navigator.geolocation.clearWatch) navigator.geolocation.clearWatch(this._locationWatchId);
            if (this._locateOptions) this._locateOptions.setView = false;
            return this;
        },
        _handleGeolocationError: function(error) {
            if (!this._container._leaflet_id) return;
            var c = error.code, message = error.message || (c === 1 ? "permission denied" : c === 2 ? "position unavailable" : "timeout");
            if (this._locateOptions.setView && !this._loaded) this.fitWorld();
            // @section Location events
            // @event locationerror: ErrorEvent
            // Fired when geolocation (using the [`locate`](#map-locate) method) failed.
            this.fire("locationerror", {
                code: c,
                message: "Geolocation error: " + message + "."
            });
        },
        _handleGeolocationResponse: function(pos) {
            if (!this._container._leaflet_id) return;
            var lat = pos.coords.latitude, lng = pos.coords.longitude, latlng = new LatLng(lat, lng), bounds = latlng.toBounds(pos.coords.accuracy * 2), options = this._locateOptions;
            if (options.setView) {
                var zoom = this.getBoundsZoom(bounds);
                this.setView(latlng, options.maxZoom ? Math.min(zoom, options.maxZoom) : zoom);
            }
            var data = {
                latlng: latlng,
                bounds: bounds,
                timestamp: pos.timestamp
            };
            for(var i in pos.coords)if (typeof pos.coords[i] === "number") data[i] = pos.coords[i];
            // @event locationfound: LocationEvent
            // Fired when geolocation (using the [`locate`](#map-locate) method)
            // went successfully.
            this.fire("locationfound", data);
        },
        // TODO Appropriate docs section?
        // @section Other Methods
        // @method addHandler(name: String, HandlerClass: Function): this
        // Adds a new `Handler` to the map, given its name and constructor function.
        addHandler: function(name, HandlerClass) {
            if (!HandlerClass) return this;
            var handler = this[name] = new HandlerClass(this);
            this._handlers.push(handler);
            if (this.options[name]) handler.enable();
            return this;
        },
        // @method remove(): this
        // Destroys the map and clears all related event listeners.
        remove: function() {
            this._initEvents(true);
            if (this.options.maxBounds) this.off("moveend", this._panInsideMaxBounds);
            if (this._containerId !== this._container._leaflet_id) throw new Error("Map container is being reused by another instance");
            try {
                // throws error in IE6-8
                delete this._container._leaflet_id;
                delete this._containerId;
            } catch (e) {
                /*eslint-disable */ this._container._leaflet_id = undefined;
                /* eslint-enable */ this._containerId = undefined;
            }
            if (this._locationWatchId !== undefined) this.stopLocate();
            this._stop();
            remove(this._mapPane);
            if (this._clearControlPos) this._clearControlPos();
            if (this._resizeRequest) {
                cancelAnimFrame(this._resizeRequest);
                this._resizeRequest = null;
            }
            this._clearHandlers();
            if (this._loaded) // @section Map state change events
            // @event unload: Event
            // Fired when the map is destroyed with [remove](#map-remove) method.
            this.fire("unload");
            var i;
            for(i in this._layers)this._layers[i].remove();
            for(i in this._panes)remove(this._panes[i]);
            this._layers = [];
            this._panes = [];
            delete this._mapPane;
            delete this._renderer;
            return this;
        },
        // @section Other Methods
        // @method createPane(name: String, container?: HTMLElement): HTMLElement
        // Creates a new [map pane](#map-pane) with the given name if it doesn't exist already,
        // then returns it. The pane is created as a child of `container`, or
        // as a child of the main map pane if not set.
        createPane: function(name, container) {
            var className = "leaflet-pane" + (name ? " leaflet-" + name.replace("Pane", "") + "-pane" : ""), pane = create$1("div", className, container || this._mapPane);
            if (name) this._panes[name] = pane;
            return pane;
        },
        // @section Methods for Getting Map State
        // @method getCenter(): LatLng
        // Returns the geographical center of the map view
        getCenter: function() {
            this._checkIfLoaded();
            if (this._lastCenter && !this._moved()) return this._lastCenter.clone();
            return this.layerPointToLatLng(this._getCenterLayerPoint());
        },
        // @method getZoom(): Number
        // Returns the current zoom level of the map view
        getZoom: function() {
            return this._zoom;
        },
        // @method getBounds(): LatLngBounds
        // Returns the geographical bounds visible in the current map view
        getBounds: function() {
            var bounds = this.getPixelBounds(), sw = this.unproject(bounds.getBottomLeft()), ne = this.unproject(bounds.getTopRight());
            return new LatLngBounds(sw, ne);
        },
        // @method getMinZoom(): Number
        // Returns the minimum zoom level of the map (if set in the `minZoom` option of the map or of any layers), or `0` by default.
        getMinZoom: function() {
            return this.options.minZoom === undefined ? this._layersMinZoom || 0 : this.options.minZoom;
        },
        // @method getMaxZoom(): Number
        // Returns the maximum zoom level of the map (if set in the `maxZoom` option of the map or of any layers).
        getMaxZoom: function() {
            return this.options.maxZoom === undefined ? this._layersMaxZoom === undefined ? Infinity : this._layersMaxZoom : this.options.maxZoom;
        },
        // @method getBoundsZoom(bounds: LatLngBounds, inside?: Boolean, padding?: Point): Number
        // Returns the maximum zoom level on which the given bounds fit to the map
        // view in its entirety. If `inside` (optional) is set to `true`, the method
        // instead returns the minimum zoom level on which the map view fits into
        // the given bounds in its entirety.
        getBoundsZoom: function(bounds, inside, padding) {
            bounds = toLatLngBounds(bounds);
            padding = toPoint(padding || [
                0,
                0
            ]);
            var zoom = this.getZoom() || 0, min = this.getMinZoom(), max = this.getMaxZoom(), nw = bounds.getNorthWest(), se = bounds.getSouthEast(), size = this.getSize().subtract(padding), boundsSize = toBounds(this.project(se, zoom), this.project(nw, zoom)).getSize(), snap = Browser.any3d ? this.options.zoomSnap : 1, scalex = size.x / boundsSize.x, scaley = size.y / boundsSize.y, scale = inside ? Math.max(scalex, scaley) : Math.min(scalex, scaley);
            zoom = this.getScaleZoom(scale, zoom);
            if (snap) {
                zoom = Math.round(zoom / (snap / 100)) * (snap / 100); // don't jump if within 1% of a snap level
                zoom = inside ? Math.ceil(zoom / snap) * snap : Math.floor(zoom / snap) * snap;
            }
            return Math.max(min, Math.min(max, zoom));
        },
        // @method getSize(): Point
        // Returns the current size of the map container (in pixels).
        getSize: function() {
            if (!this._size || this._sizeChanged) {
                this._size = new Point(this._container.clientWidth || 0, this._container.clientHeight || 0);
                this._sizeChanged = false;
            }
            return this._size.clone();
        },
        // @method getPixelBounds(): Bounds
        // Returns the bounds of the current map view in projected pixel
        // coordinates (sometimes useful in layer and overlay implementations).
        getPixelBounds: function(center, zoom) {
            var topLeftPoint = this._getTopLeftPoint(center, zoom);
            return new Bounds(topLeftPoint, topLeftPoint.add(this.getSize()));
        },
        // TODO: Check semantics - isn't the pixel origin the 0,0 coord relative to
        // the map pane? "left point of the map layer" can be confusing, specially
        // since there can be negative offsets.
        // @method getPixelOrigin(): Point
        // Returns the projected pixel coordinates of the top left point of
        // the map layer (useful in custom layer and overlay implementations).
        getPixelOrigin: function() {
            this._checkIfLoaded();
            return this._pixelOrigin;
        },
        // @method getPixelWorldBounds(zoom?: Number): Bounds
        // Returns the world's bounds in pixel coordinates for zoom level `zoom`.
        // If `zoom` is omitted, the map's current zoom level is used.
        getPixelWorldBounds: function(zoom) {
            return this.options.crs.getProjectedBounds(zoom === undefined ? this.getZoom() : zoom);
        },
        // @section Other Methods
        // @method getPane(pane: String|HTMLElement): HTMLElement
        // Returns a [map pane](#map-pane), given its name or its HTML element (its identity).
        getPane: function(pane) {
            return typeof pane === "string" ? this._panes[pane] : pane;
        },
        // @method getPanes(): Object
        // Returns a plain object containing the names of all [panes](#map-pane) as keys and
        // the panes as values.
        getPanes: function() {
            return this._panes;
        },
        // @method getContainer: HTMLElement
        // Returns the HTML element that contains the map.
        getContainer: function() {
            return this._container;
        },
        // @section Conversion Methods
        // @method getZoomScale(toZoom: Number, fromZoom: Number): Number
        // Returns the scale factor to be applied to a map transition from zoom level
        // `fromZoom` to `toZoom`. Used internally to help with zoom animations.
        getZoomScale: function(toZoom, fromZoom) {
            // TODO replace with universal implementation after refactoring projections
            var crs = this.options.crs;
            fromZoom = fromZoom === undefined ? this._zoom : fromZoom;
            return crs.scale(toZoom) / crs.scale(fromZoom);
        },
        // @method getScaleZoom(scale: Number, fromZoom: Number): Number
        // Returns the zoom level that the map would end up at, if it is at `fromZoom`
        // level and everything is scaled by a factor of `scale`. Inverse of
        // [`getZoomScale`](#map-getZoomScale).
        getScaleZoom: function(scale, fromZoom) {
            var crs = this.options.crs;
            fromZoom = fromZoom === undefined ? this._zoom : fromZoom;
            var zoom = crs.zoom(scale * crs.scale(fromZoom));
            return isNaN(zoom) ? Infinity : zoom;
        },
        // @method project(latlng: LatLng, zoom: Number): Point
        // Projects a geographical coordinate `LatLng` according to the projection
        // of the map's CRS, then scales it according to `zoom` and the CRS's
        // `Transformation`. The result is pixel coordinate relative to
        // the CRS origin.
        project: function(latlng, zoom) {
            zoom = zoom === undefined ? this._zoom : zoom;
            return this.options.crs.latLngToPoint(toLatLng(latlng), zoom);
        },
        // @method unproject(point: Point, zoom: Number): LatLng
        // Inverse of [`project`](#map-project).
        unproject: function(point, zoom) {
            zoom = zoom === undefined ? this._zoom : zoom;
            return this.options.crs.pointToLatLng(toPoint(point), zoom);
        },
        // @method layerPointToLatLng(point: Point): LatLng
        // Given a pixel coordinate relative to the [origin pixel](#map-getpixelorigin),
        // returns the corresponding geographical coordinate (for the current zoom level).
        layerPointToLatLng: function(point) {
            var projectedPoint = toPoint(point).add(this.getPixelOrigin());
            return this.unproject(projectedPoint);
        },
        // @method latLngToLayerPoint(latlng: LatLng): Point
        // Given a geographical coordinate, returns the corresponding pixel coordinate
        // relative to the [origin pixel](#map-getpixelorigin).
        latLngToLayerPoint: function(latlng) {
            var projectedPoint = this.project(toLatLng(latlng))._round();
            return projectedPoint._subtract(this.getPixelOrigin());
        },
        // @method wrapLatLng(latlng: LatLng): LatLng
        // Returns a `LatLng` where `lat` and `lng` has been wrapped according to the
        // map's CRS's `wrapLat` and `wrapLng` properties, if they are outside the
        // CRS's bounds.
        // By default this means longitude is wrapped around the dateline so its
        // value is between -180 and +180 degrees.
        wrapLatLng: function(latlng) {
            return this.options.crs.wrapLatLng(toLatLng(latlng));
        },
        // @method wrapLatLngBounds(bounds: LatLngBounds): LatLngBounds
        // Returns a `LatLngBounds` with the same size as the given one, ensuring that
        // its center is within the CRS's bounds.
        // By default this means the center longitude is wrapped around the dateline so its
        // value is between -180 and +180 degrees, and the majority of the bounds
        // overlaps the CRS's bounds.
        wrapLatLngBounds: function(latlng) {
            return this.options.crs.wrapLatLngBounds(toLatLngBounds(latlng));
        },
        // @method distance(latlng1: LatLng, latlng2: LatLng): Number
        // Returns the distance between two geographical coordinates according to
        // the map's CRS. By default this measures distance in meters.
        distance: function(latlng1, latlng2) {
            return this.options.crs.distance(toLatLng(latlng1), toLatLng(latlng2));
        },
        // @method containerPointToLayerPoint(point: Point): Point
        // Given a pixel coordinate relative to the map container, returns the corresponding
        // pixel coordinate relative to the [origin pixel](#map-getpixelorigin).
        containerPointToLayerPoint: function(point) {
            return toPoint(point).subtract(this._getMapPanePos());
        },
        // @method layerPointToContainerPoint(point: Point): Point
        // Given a pixel coordinate relative to the [origin pixel](#map-getpixelorigin),
        // returns the corresponding pixel coordinate relative to the map container.
        layerPointToContainerPoint: function(point) {
            return toPoint(point).add(this._getMapPanePos());
        },
        // @method containerPointToLatLng(point: Point): LatLng
        // Given a pixel coordinate relative to the map container, returns
        // the corresponding geographical coordinate (for the current zoom level).
        containerPointToLatLng: function(point) {
            var layerPoint = this.containerPointToLayerPoint(toPoint(point));
            return this.layerPointToLatLng(layerPoint);
        },
        // @method latLngToContainerPoint(latlng: LatLng): Point
        // Given a geographical coordinate, returns the corresponding pixel coordinate
        // relative to the map container.
        latLngToContainerPoint: function(latlng) {
            return this.layerPointToContainerPoint(this.latLngToLayerPoint(toLatLng(latlng)));
        },
        // @method mouseEventToContainerPoint(ev: MouseEvent): Point
        // Given a MouseEvent object, returns the pixel coordinate relative to the
        // map container where the event took place.
        mouseEventToContainerPoint: function(e) {
            return getMousePosition(e, this._container);
        },
        // @method mouseEventToLayerPoint(ev: MouseEvent): Point
        // Given a MouseEvent object, returns the pixel coordinate relative to
        // the [origin pixel](#map-getpixelorigin) where the event took place.
        mouseEventToLayerPoint: function(e) {
            return this.containerPointToLayerPoint(this.mouseEventToContainerPoint(e));
        },
        // @method mouseEventToLatLng(ev: MouseEvent): LatLng
        // Given a MouseEvent object, returns geographical coordinate where the
        // event took place.
        mouseEventToLatLng: function(e) {
            return this.layerPointToLatLng(this.mouseEventToLayerPoint(e));
        },
        // map initialization methods
        _initContainer: function(id) {
            var container = this._container = get(id);
            if (!container) throw new Error("Map container not found.");
            else if (container._leaflet_id) throw new Error("Map container is already initialized.");
            on(container, "scroll", this._onScroll, this);
            this._containerId = stamp(container);
        },
        _initLayout: function() {
            var container = this._container;
            this._fadeAnimated = this.options.fadeAnimation && Browser.any3d;
            addClass(container, "leaflet-container" + (Browser.touch ? " leaflet-touch" : "") + (Browser.retina ? " leaflet-retina" : "") + (Browser.ielt9 ? " leaflet-oldie" : "") + (Browser.safari ? " leaflet-safari" : "") + (this._fadeAnimated ? " leaflet-fade-anim" : ""));
            var position = getStyle(container, "position");
            if (position !== "absolute" && position !== "relative" && position !== "fixed" && position !== "sticky") container.style.position = "relative";
            this._initPanes();
            if (this._initControlPos) this._initControlPos();
        },
        _initPanes: function() {
            var panes = this._panes = {};
            this._paneRenderers = {};
            // @section
            //
            // Panes are DOM elements used to control the ordering of layers on the map. You
            // can access panes with [`map.getPane`](#map-getpane) or
            // [`map.getPanes`](#map-getpanes) methods. New panes can be created with the
            // [`map.createPane`](#map-createpane) method.
            //
            // Every map has the following default panes that differ only in zIndex.
            //
            // @pane mapPane: HTMLElement = 'auto'
            // Pane that contains all other map panes
            this._mapPane = this.createPane("mapPane", this._container);
            setPosition(this._mapPane, new Point(0, 0));
            // @pane tilePane: HTMLElement = 200
            // Pane for `GridLayer`s and `TileLayer`s
            this.createPane("tilePane");
            // @pane overlayPane: HTMLElement = 400
            // Pane for vectors (`Path`s, like `Polyline`s and `Polygon`s), `ImageOverlay`s and `VideoOverlay`s
            this.createPane("overlayPane");
            // @pane shadowPane: HTMLElement = 500
            // Pane for overlay shadows (e.g. `Marker` shadows)
            this.createPane("shadowPane");
            // @pane markerPane: HTMLElement = 600
            // Pane for `Icon`s of `Marker`s
            this.createPane("markerPane");
            // @pane tooltipPane: HTMLElement = 650
            // Pane for `Tooltip`s.
            this.createPane("tooltipPane");
            // @pane popupPane: HTMLElement = 700
            // Pane for `Popup`s.
            this.createPane("popupPane");
            if (!this.options.markerZoomAnimation) {
                addClass(panes.markerPane, "leaflet-zoom-hide");
                addClass(panes.shadowPane, "leaflet-zoom-hide");
            }
        },
        // private methods that modify map state
        // @section Map state change events
        _resetView: function(center, zoom, noMoveStart) {
            setPosition(this._mapPane, new Point(0, 0));
            var loading = !this._loaded;
            this._loaded = true;
            zoom = this._limitZoom(zoom);
            this.fire("viewprereset");
            var zoomChanged = this._zoom !== zoom;
            this._moveStart(zoomChanged, noMoveStart)._move(center, zoom)._moveEnd(zoomChanged);
            // @event viewreset: Event
            // Fired when the map needs to redraw its content (this usually happens
            // on map zoom or load). Very useful for creating custom overlays.
            this.fire("viewreset");
            // @event load: Event
            // Fired when the map is initialized (when its center and zoom are set
            // for the first time).
            if (loading) this.fire("load");
        },
        _moveStart: function(zoomChanged, noMoveStart) {
            // @event zoomstart: Event
            // Fired when the map zoom is about to change (e.g. before zoom animation).
            // @event movestart: Event
            // Fired when the view of the map starts changing (e.g. user starts dragging the map).
            if (zoomChanged) this.fire("zoomstart");
            if (!noMoveStart) this.fire("movestart");
            return this;
        },
        _move: function(center, zoom, data, supressEvent) {
            if (zoom === undefined) zoom = this._zoom;
            var zoomChanged = this._zoom !== zoom;
            this._zoom = zoom;
            this._lastCenter = center;
            this._pixelOrigin = this._getNewPixelOrigin(center);
            if (!supressEvent) {
                // @event zoom: Event
                // Fired repeatedly during any change in zoom level,
                // including zoom and fly animations.
                if (zoomChanged || data && data.pinch) this.fire("zoom", data);
                // @event move: Event
                // Fired repeatedly during any movement of the map,
                // including pan and fly animations.
                this.fire("move", data);
            } else if (data && data.pinch) this.fire("zoom", data);
            return this;
        },
        _moveEnd: function(zoomChanged) {
            // @event zoomend: Event
            // Fired when the map zoom changed, after any animations.
            if (zoomChanged) this.fire("zoomend");
            // @event moveend: Event
            // Fired when the center of the map stops changing
            // (e.g. user stopped dragging the map or after non-centered zoom).
            return this.fire("moveend");
        },
        _stop: function() {
            cancelAnimFrame(this._flyToFrame);
            if (this._panAnim) this._panAnim.stop();
            return this;
        },
        _rawPanBy: function(offset) {
            setPosition(this._mapPane, this._getMapPanePos().subtract(offset));
        },
        _getZoomSpan: function() {
            return this.getMaxZoom() - this.getMinZoom();
        },
        _panInsideMaxBounds: function() {
            if (!this._enforcingBounds) this.panInsideBounds(this.options.maxBounds);
        },
        _checkIfLoaded: function() {
            if (!this._loaded) throw new Error("Set map center and zoom first.");
        },
        // DOM event handling
        // @section Interaction events
        _initEvents: function(remove) {
            this._targets = {};
            this._targets[stamp(this._container)] = this;
            var onOff = remove ? off : on;
            // @event click: MouseEvent
            // Fired when the user clicks (or taps) the map.
            // @event dblclick: MouseEvent
            // Fired when the user double-clicks (or double-taps) the map.
            // @event mousedown: MouseEvent
            // Fired when the user pushes the mouse button on the map.
            // @event mouseup: MouseEvent
            // Fired when the user releases the mouse button on the map.
            // @event mouseover: MouseEvent
            // Fired when the mouse enters the map.
            // @event mouseout: MouseEvent
            // Fired when the mouse leaves the map.
            // @event mousemove: MouseEvent
            // Fired while the mouse moves over the map.
            // @event contextmenu: MouseEvent
            // Fired when the user pushes the right mouse button on the map, prevents
            // default browser context menu from showing if there are listeners on
            // this event. Also fired on mobile when the user holds a single touch
            // for a second (also called long press).
            // @event keypress: KeyboardEvent
            // Fired when the user presses a key from the keyboard that produces a character value while the map is focused.
            // @event keydown: KeyboardEvent
            // Fired when the user presses a key from the keyboard while the map is focused. Unlike the `keypress` event,
            // the `keydown` event is fired for keys that produce a character value and for keys
            // that do not produce a character value.
            // @event keyup: KeyboardEvent
            // Fired when the user releases a key from the keyboard while the map is focused.
            onOff(this._container, "click dblclick mousedown mouseup mouseover mouseout mousemove contextmenu keypress keydown keyup", this._handleDOMEvent, this);
            if (this.options.trackResize) onOff(window, "resize", this._onResize, this);
            if (Browser.any3d && this.options.transform3DLimit) (remove ? this.off : this.on).call(this, "moveend", this._onMoveEnd);
        },
        _onResize: function() {
            cancelAnimFrame(this._resizeRequest);
            this._resizeRequest = requestAnimFrame(function() {
                this.invalidateSize({
                    debounceMoveend: true
                });
            }, this);
        },
        _onScroll: function() {
            this._container.scrollTop = 0;
            this._container.scrollLeft = 0;
        },
        _onMoveEnd: function() {
            var pos = this._getMapPanePos();
            if (Math.max(Math.abs(pos.x), Math.abs(pos.y)) >= this.options.transform3DLimit) // https://bugzilla.mozilla.org/show_bug.cgi?id=1203873 but Webkit also have
            // a pixel offset on very high values, see: https://jsfiddle.net/dg6r5hhb/
            this._resetView(this.getCenter(), this.getZoom());
        },
        _findEventTargets: function(e, type) {
            var targets = [], target, isHover = type === "mouseout" || type === "mouseover", src = e.target || e.srcElement, dragging = false;
            while(src){
                target = this._targets[stamp(src)];
                if (target && (type === "click" || type === "preclick") && this._draggableMoved(target)) {
                    // Prevent firing click after you just dragged an object.
                    dragging = true;
                    break;
                }
                if (target && target.listens(type, true)) {
                    if (isHover && !isExternalTarget(src, e)) break;
                    targets.push(target);
                    if (isHover) break;
                }
                if (src === this._container) break;
                src = src.parentNode;
            }
            if (!targets.length && !dragging && !isHover && this.listens(type, true)) targets = [
                this
            ];
            return targets;
        },
        _isClickDisabled: function(el) {
            while(el && el !== this._container){
                if (el["_leaflet_disable_click"]) return true;
                el = el.parentNode;
            }
        },
        _handleDOMEvent: function(e) {
            var el = e.target || e.srcElement;
            if (!this._loaded || el["_leaflet_disable_events"] || e.type === "click" && this._isClickDisabled(el)) return;
            var type = e.type;
            if (type === "mousedown") // prevents outline when clicking on keyboard-focusable element
            preventOutline(el);
            this._fireDOMEvent(e, type);
        },
        _mouseEvents: [
            "click",
            "dblclick",
            "mouseover",
            "mouseout",
            "contextmenu"
        ],
        _fireDOMEvent: function(e, type, canvasTargets) {
            if (e.type === "click") {
                // Fire a synthetic 'preclick' event which propagates up (mainly for closing popups).
                // @event preclick: MouseEvent
                // Fired before mouse click on the map (sometimes useful when you
                // want something to happen on click before any existing click
                // handlers start running).
                var synth = extend({}, e);
                synth.type = "preclick";
                this._fireDOMEvent(synth, synth.type, canvasTargets);
            }
            // Find the layer the event is propagating from and its parents.
            var targets = this._findEventTargets(e, type);
            if (canvasTargets) {
                var filtered = []; // pick only targets with listeners
                for(var i = 0; i < canvasTargets.length; i++)if (canvasTargets[i].listens(type, true)) filtered.push(canvasTargets[i]);
                targets = filtered.concat(targets);
            }
            if (!targets.length) return;
            if (type === "contextmenu") preventDefault(e);
            var target = targets[0];
            var data = {
                originalEvent: e
            };
            if (e.type !== "keypress" && e.type !== "keydown" && e.type !== "keyup") {
                var isMarker = target.getLatLng && (!target._radius || target._radius <= 10);
                data.containerPoint = isMarker ? this.latLngToContainerPoint(target.getLatLng()) : this.mouseEventToContainerPoint(e);
                data.layerPoint = this.containerPointToLayerPoint(data.containerPoint);
                data.latlng = isMarker ? target.getLatLng() : this.layerPointToLatLng(data.layerPoint);
            }
            for(i = 0; i < targets.length; i++){
                targets[i].fire(type, data, true);
                if (data.originalEvent._stopped || targets[i].options.bubblingMouseEvents === false && indexOf(this._mouseEvents, type) !== -1) return;
            }
        },
        _draggableMoved: function(obj) {
            obj = obj.dragging && obj.dragging.enabled() ? obj : this;
            return obj.dragging && obj.dragging.moved() || this.boxZoom && this.boxZoom.moved();
        },
        _clearHandlers: function() {
            for(var i = 0, len = this._handlers.length; i < len; i++)this._handlers[i].disable();
        },
        // @section Other Methods
        // @method whenReady(fn: Function, context?: Object): this
        // Runs the given function `fn` when the map gets initialized with
        // a view (center and zoom) and at least one layer, or immediately
        // if it's already initialized, optionally passing a function context.
        whenReady: function(callback, context) {
            if (this._loaded) callback.call(context || this, {
                target: this
            });
            else this.on("load", callback, context);
            return this;
        },
        // private methods for getting map state
        _getMapPanePos: function() {
            return getPosition(this._mapPane) || new Point(0, 0);
        },
        _moved: function() {
            var pos = this._getMapPanePos();
            return pos && !pos.equals([
                0,
                0
            ]);
        },
        _getTopLeftPoint: function(center, zoom) {
            var pixelOrigin = center && zoom !== undefined ? this._getNewPixelOrigin(center, zoom) : this.getPixelOrigin();
            return pixelOrigin.subtract(this._getMapPanePos());
        },
        _getNewPixelOrigin: function(center, zoom) {
            var viewHalf = this.getSize()._divideBy(2);
            return this.project(center, zoom)._subtract(viewHalf)._add(this._getMapPanePos())._round();
        },
        _latLngToNewLayerPoint: function(latlng, zoom, center) {
            var topLeft = this._getNewPixelOrigin(center, zoom);
            return this.project(latlng, zoom)._subtract(topLeft);
        },
        _latLngBoundsToNewLayerBounds: function(latLngBounds, zoom, center) {
            var topLeft = this._getNewPixelOrigin(center, zoom);
            return toBounds([
                this.project(latLngBounds.getSouthWest(), zoom)._subtract(topLeft),
                this.project(latLngBounds.getNorthWest(), zoom)._subtract(topLeft),
                this.project(latLngBounds.getSouthEast(), zoom)._subtract(topLeft),
                this.project(latLngBounds.getNorthEast(), zoom)._subtract(topLeft)
            ]);
        },
        // layer point of the current center
        _getCenterLayerPoint: function() {
            return this.containerPointToLayerPoint(this.getSize()._divideBy(2));
        },
        // offset of the specified place to the current center in pixels
        _getCenterOffset: function(latlng) {
            return this.latLngToLayerPoint(latlng).subtract(this._getCenterLayerPoint());
        },
        // adjust center for view to get inside bounds
        _limitCenter: function(center, zoom, bounds) {
            if (!bounds) return center;
            var centerPoint = this.project(center, zoom), viewHalf = this.getSize().divideBy(2), viewBounds = new Bounds(centerPoint.subtract(viewHalf), centerPoint.add(viewHalf)), offset = this._getBoundsOffset(viewBounds, bounds, zoom);
            // If offset is less than a pixel, ignore.
            // This prevents unstable projections from getting into
            // an infinite loop of tiny offsets.
            if (Math.abs(offset.x) <= 1 && Math.abs(offset.y) <= 1) return center;
            return this.unproject(centerPoint.add(offset), zoom);
        },
        // adjust offset for view to get inside bounds
        _limitOffset: function(offset, bounds) {
            if (!bounds) return offset;
            var viewBounds = this.getPixelBounds(), newBounds = new Bounds(viewBounds.min.add(offset), viewBounds.max.add(offset));
            return offset.add(this._getBoundsOffset(newBounds, bounds));
        },
        // returns offset needed for pxBounds to get inside maxBounds at a specified zoom
        _getBoundsOffset: function(pxBounds, maxBounds, zoom) {
            var projectedMaxBounds = toBounds(this.project(maxBounds.getNorthEast(), zoom), this.project(maxBounds.getSouthWest(), zoom)), minOffset = projectedMaxBounds.min.subtract(pxBounds.min), maxOffset = projectedMaxBounds.max.subtract(pxBounds.max), dx = this._rebound(minOffset.x, -maxOffset.x), dy = this._rebound(minOffset.y, -maxOffset.y);
            return new Point(dx, dy);
        },
        _rebound: function(left, right) {
            return left + right > 0 ? Math.round(left - right) / 2 : Math.max(0, Math.ceil(left)) - Math.max(0, Math.floor(right));
        },
        _limitZoom: function(zoom) {
            var min = this.getMinZoom(), max = this.getMaxZoom(), snap = Browser.any3d ? this.options.zoomSnap : 1;
            if (snap) zoom = Math.round(zoom / snap) * snap;
            return Math.max(min, Math.min(max, zoom));
        },
        _onPanTransitionStep: function() {
            this.fire("move");
        },
        _onPanTransitionEnd: function() {
            removeClass(this._mapPane, "leaflet-pan-anim");
            this.fire("moveend");
        },
        _tryAnimatedPan: function(center, options) {
            // difference between the new and current centers in pixels
            var offset = this._getCenterOffset(center)._trunc();
            // don't animate too far unless animate: true specified in options
            if ((options && options.animate) !== true && !this.getSize().contains(offset)) return false;
            this.panBy(offset, options);
            return true;
        },
        _createAnimProxy: function() {
            var proxy = this._proxy = create$1("div", "leaflet-proxy leaflet-zoom-animated");
            this._panes.mapPane.appendChild(proxy);
            this.on("zoomanim", function(e) {
                var prop = TRANSFORM, transform = this._proxy.style[prop];
                setTransform(this._proxy, this.project(e.center, e.zoom), this.getZoomScale(e.zoom, 1));
                // workaround for case when transform is the same and so transitionend event is not fired
                if (transform === this._proxy.style[prop] && this._animatingZoom) this._onZoomTransitionEnd();
            }, this);
            this.on("load moveend", this._animMoveEnd, this);
            this._on("unload", this._destroyAnimProxy, this);
        },
        _destroyAnimProxy: function() {
            remove(this._proxy);
            this.off("load moveend", this._animMoveEnd, this);
            delete this._proxy;
        },
        _animMoveEnd: function() {
            var c = this.getCenter(), z = this.getZoom();
            setTransform(this._proxy, this.project(c, z), this.getZoomScale(z, 1));
        },
        _catchTransitionEnd: function(e) {
            if (this._animatingZoom && e.propertyName.indexOf("transform") >= 0) this._onZoomTransitionEnd();
        },
        _nothingToAnimate: function() {
            return !this._container.getElementsByClassName("leaflet-zoom-animated").length;
        },
        _tryAnimatedZoom: function(center, zoom, options) {
            if (this._animatingZoom) return true;
            options = options || {};
            // don't animate if disabled, not supported or zoom difference is too large
            if (!this._zoomAnimated || options.animate === false || this._nothingToAnimate() || Math.abs(zoom - this._zoom) > this.options.zoomAnimationThreshold) return false;
            // offset is the pixel coords of the zoom origin relative to the current center
            var scale = this.getZoomScale(zoom), offset = this._getCenterOffset(center)._divideBy(1 - 1 / scale);
            // don't animate if the zoom origin isn't within one screen from the current center, unless forced
            if (options.animate !== true && !this.getSize().contains(offset)) return false;
            requestAnimFrame(function() {
                this._moveStart(true, options.noMoveStart || false)._animateZoom(center, zoom, true);
            }, this);
            return true;
        },
        _animateZoom: function(center, zoom, startAnim, noUpdate) {
            if (!this._mapPane) return;
            if (startAnim) {
                this._animatingZoom = true;
                // remember what center/zoom to set after animation
                this._animateToCenter = center;
                this._animateToZoom = zoom;
                addClass(this._mapPane, "leaflet-zoom-anim");
            }
            // @section Other Events
            // @event zoomanim: ZoomAnimEvent
            // Fired at least once per zoom animation. For continuous zoom, like pinch zooming, fired once per frame during zoom.
            this.fire("zoomanim", {
                center: center,
                zoom: zoom,
                noUpdate: noUpdate
            });
            if (!this._tempFireZoomEvent) this._tempFireZoomEvent = this._zoom !== this._animateToZoom;
            this._move(this._animateToCenter, this._animateToZoom, undefined, true);
            // Work around webkit not firing 'transitionend', see https://github.com/Leaflet/Leaflet/issues/3689, 2693
            setTimeout(bind(this._onZoomTransitionEnd, this), 250);
        },
        _onZoomTransitionEnd: function() {
            if (!this._animatingZoom) return;
            if (this._mapPane) removeClass(this._mapPane, "leaflet-zoom-anim");
            this._animatingZoom = false;
            this._move(this._animateToCenter, this._animateToZoom, undefined, true);
            if (this._tempFireZoomEvent) this.fire("zoom");
            delete this._tempFireZoomEvent;
            this.fire("move");
            this._moveEnd(true);
        }
    });
    // @section
    // @factory L.map(id: String, options?: Map options)
    // Instantiates a map object given the DOM ID of a `<div>` element
    // and optionally an object literal with `Map options`.
    //
    // @alternative
    // @factory L.map(el: HTMLElement, options?: Map options)
    // Instantiates a map object given an instance of a `<div>` HTML element
    // and optionally an object literal with `Map options`.
    function createMap(id, options) {
        return new Map(id, options);
    }
    /*
   * @class Control
   * @aka L.Control
   * @inherits Class
   *
   * L.Control is a base class for implementing map controls. Handles positioning.
   * All other controls extend from this class.
   */ var Control = Class.extend({
        // @section
        // @aka Control Options
        options: {
            // @option position: String = 'topright'
            // The position of the control (one of the map corners). Possible values are `'topleft'`,
            // `'topright'`, `'bottomleft'` or `'bottomright'`
            position: "topright"
        },
        initialize: function(options) {
            setOptions(this, options);
        },
        /* @section
  	 * Classes extending L.Control will inherit the following methods:
  	 *
  	 * @method getPosition: string
  	 * Returns the position of the control.
  	 */ getPosition: function() {
            return this.options.position;
        },
        // @method setPosition(position: string): this
        // Sets the position of the control.
        setPosition: function(position) {
            var map = this._map;
            if (map) map.removeControl(this);
            this.options.position = position;
            if (map) map.addControl(this);
            return this;
        },
        // @method getContainer: HTMLElement
        // Returns the HTMLElement that contains the control.
        getContainer: function() {
            return this._container;
        },
        // @method addTo(map: Map): this
        // Adds the control to the given map.
        addTo: function(map) {
            this.remove();
            this._map = map;
            var container = this._container = this.onAdd(map), pos = this.getPosition(), corner = map._controlCorners[pos];
            addClass(container, "leaflet-control");
            if (pos.indexOf("bottom") !== -1) corner.insertBefore(container, corner.firstChild);
            else corner.appendChild(container);
            this._map.on("unload", this.remove, this);
            return this;
        },
        // @method remove: this
        // Removes the control from the map it is currently active on.
        remove: function() {
            if (!this._map) return this;
            remove(this._container);
            if (this.onRemove) this.onRemove(this._map);
            this._map.off("unload", this.remove, this);
            this._map = null;
            return this;
        },
        _refocusOnMap: function(e) {
            // if map exists and event is not a keyboard event
            if (this._map && e && e.screenX > 0 && e.screenY > 0) this._map.getContainer().focus();
        }
    });
    var control = function(options) {
        return new Control(options);
    };
    /* @section Extension methods
   * @uninheritable
   *
   * Every control should extend from `L.Control` and (re-)implement the following methods.
   *
   * @method onAdd(map: Map): HTMLElement
   * Should return the container DOM element for the control and add listeners on relevant map events. Called on [`control.addTo(map)`](#control-addTo).
   *
   * @method onRemove(map: Map)
   * Optional method. Should contain all clean up code that removes the listeners previously added in [`onAdd`](#control-onadd). Called on [`control.remove()`](#control-remove).
   */ /* @namespace Map
   * @section Methods for Layers and Controls
   */ Map.include({
        // @method addControl(control: Control): this
        // Adds the given control to the map
        addControl: function(control) {
            control.addTo(this);
            return this;
        },
        // @method removeControl(control: Control): this
        // Removes the given control from the map
        removeControl: function(control) {
            control.remove();
            return this;
        },
        _initControlPos: function() {
            var corners = this._controlCorners = {}, l = "leaflet-", container = this._controlContainer = create$1("div", l + "control-container", this._container);
            function createCorner(vSide, hSide) {
                var className = l + vSide + " " + l + hSide;
                corners[vSide + hSide] = create$1("div", className, container);
            }
            createCorner("top", "left");
            createCorner("top", "right");
            createCorner("bottom", "left");
            createCorner("bottom", "right");
        },
        _clearControlPos: function() {
            for(var i in this._controlCorners)remove(this._controlCorners[i]);
            remove(this._controlContainer);
            delete this._controlCorners;
            delete this._controlContainer;
        }
    });
    /*
   * @class Control.Layers
   * @aka L.Control.Layers
   * @inherits Control
   *
   * The layers control gives users the ability to switch between different base layers and switch overlays on/off (check out the [detailed example](https://leafletjs.com/examples/layers-control/)). Extends `Control`.
   *
   * @example
   *
   * ```js
   * var baseLayers = {
   * 	"Mapbox": mapbox,
   * 	"OpenStreetMap": osm
   * };
   *
   * var overlays = {
   * 	"Marker": marker,
   * 	"Roads": roadsLayer
   * };
   *
   * L.control.layers(baseLayers, overlays).addTo(map);
   * ```
   *
   * The `baseLayers` and `overlays` parameters are object literals with layer names as keys and `Layer` objects as values:
   *
   * ```js
   * {
   *     "<someName1>": layer1,
   *     "<someName2>": layer2
   * }
   * ```
   *
   * The layer names can contain HTML, which allows you to add additional styling to the items:
   *
   * ```js
   * {"<img src='my-layer-icon' /> <span class='my-layer-item'>My Layer</span>": myLayer}
   * ```
   */ var Layers = Control.extend({
        // @section
        // @aka Control.Layers options
        options: {
            // @option collapsed: Boolean = true
            // If `true`, the control will be collapsed into an icon and expanded on mouse hover, touch, or keyboard activation.
            collapsed: true,
            position: "topright",
            // @option autoZIndex: Boolean = true
            // If `true`, the control will assign zIndexes in increasing order to all of its layers so that the order is preserved when switching them on/off.
            autoZIndex: true,
            // @option hideSingleBase: Boolean = false
            // If `true`, the base layers in the control will be hidden when there is only one.
            hideSingleBase: false,
            // @option sortLayers: Boolean = false
            // Whether to sort the layers. When `false`, layers will keep the order
            // in which they were added to the control.
            sortLayers: false,
            // @option sortFunction: Function = *
            // A [compare function](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/sort)
            // that will be used for sorting the layers, when `sortLayers` is `true`.
            // The function receives both the `L.Layer` instances and their names, as in
            // `sortFunction(layerA, layerB, nameA, nameB)`.
            // By default, it sorts layers alphabetically by their name.
            sortFunction: function(layerA, layerB, nameA, nameB) {
                return nameA < nameB ? -1 : nameB < nameA ? 1 : 0;
            }
        },
        initialize: function(baseLayers, overlays, options) {
            setOptions(this, options);
            this._layerControlInputs = [];
            this._layers = [];
            this._lastZIndex = 0;
            this._handlingClick = false;
            this._preventClick = false;
            for(var i in baseLayers)this._addLayer(baseLayers[i], i);
            for(i in overlays)this._addLayer(overlays[i], i, true);
        },
        onAdd: function(map) {
            this._initLayout();
            this._update();
            this._map = map;
            map.on("zoomend", this._checkDisabledLayers, this);
            for(var i = 0; i < this._layers.length; i++)this._layers[i].layer.on("add remove", this._onLayerChange, this);
            return this._container;
        },
        addTo: function(map) {
            Control.prototype.addTo.call(this, map);
            // Trigger expand after Layers Control has been inserted into DOM so that is now has an actual height.
            return this._expandIfNotCollapsed();
        },
        onRemove: function() {
            this._map.off("zoomend", this._checkDisabledLayers, this);
            for(var i = 0; i < this._layers.length; i++)this._layers[i].layer.off("add remove", this._onLayerChange, this);
        },
        // @method addBaseLayer(layer: Layer, name: String): this
        // Adds a base layer (radio button entry) with the given name to the control.
        addBaseLayer: function(layer, name) {
            this._addLayer(layer, name);
            return this._map ? this._update() : this;
        },
        // @method addOverlay(layer: Layer, name: String): this
        // Adds an overlay (checkbox entry) with the given name to the control.
        addOverlay: function(layer, name) {
            this._addLayer(layer, name, true);
            return this._map ? this._update() : this;
        },
        // @method removeLayer(layer: Layer): this
        // Remove the given layer from the control.
        removeLayer: function(layer) {
            layer.off("add remove", this._onLayerChange, this);
            var obj = this._getLayer(stamp(layer));
            if (obj) this._layers.splice(this._layers.indexOf(obj), 1);
            return this._map ? this._update() : this;
        },
        // @method expand(): this
        // Expand the control container if collapsed.
        expand: function() {
            addClass(this._container, "leaflet-control-layers-expanded");
            this._section.style.height = null;
            var acceptableHeight = this._map.getSize().y - (this._container.offsetTop + 50);
            if (acceptableHeight < this._section.clientHeight) {
                addClass(this._section, "leaflet-control-layers-scrollbar");
                this._section.style.height = acceptableHeight + "px";
            } else removeClass(this._section, "leaflet-control-layers-scrollbar");
            this._checkDisabledLayers();
            return this;
        },
        // @method collapse(): this
        // Collapse the control container if expanded.
        collapse: function() {
            removeClass(this._container, "leaflet-control-layers-expanded");
            return this;
        },
        _initLayout: function() {
            var className = "leaflet-control-layers", container = this._container = create$1("div", className), collapsed = this.options.collapsed;
            // makes this work on IE touch devices by stopping it from firing a mouseout event when the touch is released
            container.setAttribute("aria-haspopup", true);
            disableClickPropagation(container);
            disableScrollPropagation(container);
            var section = this._section = create$1("section", className + "-list");
            if (collapsed) {
                this._map.on("click", this.collapse, this);
                on(container, {
                    mouseenter: this._expandSafely,
                    mouseleave: this.collapse
                }, this);
            }
            var link = this._layersLink = create$1("a", className + "-toggle", container);
            link.href = "#";
            link.title = "Layers";
            link.setAttribute("role", "button");
            on(link, {
                keydown: function(e) {
                    if (e.keyCode === 13) this._expandSafely();
                },
                // Certain screen readers intercept the key event and instead send a click event
                click: function(e) {
                    preventDefault(e);
                    this._expandSafely();
                }
            }, this);
            if (!collapsed) this.expand();
            this._baseLayersList = create$1("div", className + "-base", section);
            this._separator = create$1("div", className + "-separator", section);
            this._overlaysList = create$1("div", className + "-overlays", section);
            container.appendChild(section);
        },
        _getLayer: function(id) {
            for(var i = 0; i < this._layers.length; i++){
                if (this._layers[i] && stamp(this._layers[i].layer) === id) return this._layers[i];
            }
        },
        _addLayer: function(layer, name, overlay) {
            if (this._map) layer.on("add remove", this._onLayerChange, this);
            this._layers.push({
                layer: layer,
                name: name,
                overlay: overlay
            });
            if (this.options.sortLayers) this._layers.sort(bind(function(a, b) {
                return this.options.sortFunction(a.layer, b.layer, a.name, b.name);
            }, this));
            if (this.options.autoZIndex && layer.setZIndex) {
                this._lastZIndex++;
                layer.setZIndex(this._lastZIndex);
            }
            this._expandIfNotCollapsed();
        },
        _update: function() {
            if (!this._container) return this;
            empty(this._baseLayersList);
            empty(this._overlaysList);
            this._layerControlInputs = [];
            var baseLayersPresent, overlaysPresent, i, obj, baseLayersCount = 0;
            for(i = 0; i < this._layers.length; i++){
                obj = this._layers[i];
                this._addItem(obj);
                overlaysPresent = overlaysPresent || obj.overlay;
                baseLayersPresent = baseLayersPresent || !obj.overlay;
                baseLayersCount += !obj.overlay ? 1 : 0;
            }
            // Hide base layers section if there's only one layer.
            if (this.options.hideSingleBase) {
                baseLayersPresent = baseLayersPresent && baseLayersCount > 1;
                this._baseLayersList.style.display = baseLayersPresent ? "" : "none";
            }
            this._separator.style.display = overlaysPresent && baseLayersPresent ? "" : "none";
            return this;
        },
        _onLayerChange: function(e) {
            if (!this._handlingClick) this._update();
            var obj = this._getLayer(stamp(e.target));
            // @namespace Map
            // @section Layer events
            // @event baselayerchange: LayersControlEvent
            // Fired when the base layer is changed through the [layers control](#control-layers).
            // @event overlayadd: LayersControlEvent
            // Fired when an overlay is selected through the [layers control](#control-layers).
            // @event overlayremove: LayersControlEvent
            // Fired when an overlay is deselected through the [layers control](#control-layers).
            // @namespace Control.Layers
            var type = obj.overlay ? e.type === "add" ? "overlayadd" : "overlayremove" : e.type === "add" ? "baselayerchange" : null;
            if (type) this._map.fire(type, obj);
        },
        // IE7 bugs out if you create a radio dynamically, so you have to do it this hacky way (see https://stackoverflow.com/a/119079)
        _createRadioElement: function(name, checked) {
            var radioHtml = '<input type="radio" class="leaflet-control-layers-selector" name="' + name + '"' + (checked ? ' checked="checked"' : "") + "/>";
            var radioFragment = document.createElement("div");
            radioFragment.innerHTML = radioHtml;
            return radioFragment.firstChild;
        },
        _addItem: function(obj) {
            var label = document.createElement("label"), checked = this._map.hasLayer(obj.layer), input;
            if (obj.overlay) {
                input = document.createElement("input");
                input.type = "checkbox";
                input.className = "leaflet-control-layers-selector";
                input.defaultChecked = checked;
            } else input = this._createRadioElement("leaflet-base-layers_" + stamp(this), checked);
            this._layerControlInputs.push(input);
            input.layerId = stamp(obj.layer);
            on(input, "click", this._onInputClick, this);
            var name = document.createElement("span");
            name.innerHTML = " " + obj.name;
            // Helps from preventing layer control flicker when checkboxes are disabled
            // https://github.com/Leaflet/Leaflet/issues/2771
            var holder = document.createElement("span");
            label.appendChild(holder);
            holder.appendChild(input);
            holder.appendChild(name);
            var container = obj.overlay ? this._overlaysList : this._baseLayersList;
            container.appendChild(label);
            this._checkDisabledLayers();
            return label;
        },
        _onInputClick: function() {
            // expanding the control on mobile with a click can cause adding a layer - we don't want this
            if (this._preventClick) return;
            var inputs = this._layerControlInputs, input, layer;
            var addedLayers = [], removedLayers = [];
            this._handlingClick = true;
            for(var i = inputs.length - 1; i >= 0; i--){
                input = inputs[i];
                layer = this._getLayer(input.layerId).layer;
                if (input.checked) addedLayers.push(layer);
                else if (!input.checked) removedLayers.push(layer);
            }
            // Bugfix issue 2318: Should remove all old layers before readding new ones
            for(i = 0; i < removedLayers.length; i++)if (this._map.hasLayer(removedLayers[i])) this._map.removeLayer(removedLayers[i]);
            for(i = 0; i < addedLayers.length; i++)if (!this._map.hasLayer(addedLayers[i])) this._map.addLayer(addedLayers[i]);
            this._handlingClick = false;
            this._refocusOnMap();
        },
        _checkDisabledLayers: function() {
            var inputs = this._layerControlInputs, input, layer, zoom = this._map.getZoom();
            for(var i = inputs.length - 1; i >= 0; i--){
                input = inputs[i];
                layer = this._getLayer(input.layerId).layer;
                input.disabled = layer.options.minZoom !== undefined && zoom < layer.options.minZoom || layer.options.maxZoom !== undefined && zoom > layer.options.maxZoom;
            }
        },
        _expandIfNotCollapsed: function() {
            if (this._map && !this.options.collapsed) this.expand();
            return this;
        },
        _expandSafely: function() {
            var section = this._section;
            this._preventClick = true;
            on(section, "click", preventDefault);
            this.expand();
            var that = this;
            setTimeout(function() {
                off(section, "click", preventDefault);
                that._preventClick = false;
            });
        }
    });
    // @factory L.control.layers(baselayers?: Object, overlays?: Object, options?: Control.Layers options)
    // Creates a layers control with the given layers. Base layers will be switched with radio buttons, while overlays will be switched with checkboxes. Note that all base layers should be passed in the base layers object, but only one should be added to the map during map instantiation.
    var layers = function(baseLayers, overlays, options) {
        return new Layers(baseLayers, overlays, options);
    };
    /*
   * @class Control.Zoom
   * @aka L.Control.Zoom
   * @inherits Control
   *
   * A basic zoom control with two buttons (zoom in and zoom out). It is put on the map by default unless you set its [`zoomControl` option](#map-zoomcontrol) to `false`. Extends `Control`.
   */ var Zoom = Control.extend({
        // @section
        // @aka Control.Zoom options
        options: {
            position: "topleft",
            // @option zoomInText: String = '<span aria-hidden="true">+</span>'
            // The text set on the 'zoom in' button.
            zoomInText: '<span aria-hidden="true">+</span>',
            // @option zoomInTitle: String = 'Zoom in'
            // The title set on the 'zoom in' button.
            zoomInTitle: "Zoom in",
            // @option zoomOutText: String = '<span aria-hidden="true">&#x2212;</span>'
            // The text set on the 'zoom out' button.
            zoomOutText: '<span aria-hidden="true">&#x2212;</span>',
            // @option zoomOutTitle: String = 'Zoom out'
            // The title set on the 'zoom out' button.
            zoomOutTitle: "Zoom out"
        },
        onAdd: function(map) {
            var zoomName = "leaflet-control-zoom", container = create$1("div", zoomName + " leaflet-bar"), options = this.options;
            this._zoomInButton = this._createButton(options.zoomInText, options.zoomInTitle, zoomName + "-in", container, this._zoomIn);
            this._zoomOutButton = this._createButton(options.zoomOutText, options.zoomOutTitle, zoomName + "-out", container, this._zoomOut);
            this._updateDisabled();
            map.on("zoomend zoomlevelschange", this._updateDisabled, this);
            return container;
        },
        onRemove: function(map) {
            map.off("zoomend zoomlevelschange", this._updateDisabled, this);
        },
        disable: function() {
            this._disabled = true;
            this._updateDisabled();
            return this;
        },
        enable: function() {
            this._disabled = false;
            this._updateDisabled();
            return this;
        },
        _zoomIn: function(e) {
            if (!this._disabled && this._map._zoom < this._map.getMaxZoom()) this._map.zoomIn(this._map.options.zoomDelta * (e.shiftKey ? 3 : 1));
        },
        _zoomOut: function(e) {
            if (!this._disabled && this._map._zoom > this._map.getMinZoom()) this._map.zoomOut(this._map.options.zoomDelta * (e.shiftKey ? 3 : 1));
        },
        _createButton: function(html, title, className, container, fn) {
            var link = create$1("a", className, container);
            link.innerHTML = html;
            link.href = "#";
            link.title = title;
            /*
  		 * Will force screen readers like VoiceOver to read this as "Zoom in - button"
  		 */ link.setAttribute("role", "button");
            link.setAttribute("aria-label", title);
            disableClickPropagation(link);
            on(link, "click", stop);
            on(link, "click", fn, this);
            on(link, "click", this._refocusOnMap, this);
            return link;
        },
        _updateDisabled: function() {
            var map = this._map, className = "leaflet-disabled";
            removeClass(this._zoomInButton, className);
            removeClass(this._zoomOutButton, className);
            this._zoomInButton.setAttribute("aria-disabled", "false");
            this._zoomOutButton.setAttribute("aria-disabled", "false");
            if (this._disabled || map._zoom === map.getMinZoom()) {
                addClass(this._zoomOutButton, className);
                this._zoomOutButton.setAttribute("aria-disabled", "true");
            }
            if (this._disabled || map._zoom === map.getMaxZoom()) {
                addClass(this._zoomInButton, className);
                this._zoomInButton.setAttribute("aria-disabled", "true");
            }
        }
    });
    // @namespace Map
    // @section Control options
    // @option zoomControl: Boolean = true
    // Whether a [zoom control](#control-zoom) is added to the map by default.
    Map.mergeOptions({
        zoomControl: true
    });
    Map.addInitHook(function() {
        if (this.options.zoomControl) {
            // @section Controls
            // @property zoomControl: Control.Zoom
            // The default zoom control (only available if the
            // [`zoomControl` option](#map-zoomcontrol) was `true` when creating the map).
            this.zoomControl = new Zoom();
            this.addControl(this.zoomControl);
        }
    });
    // @namespace Control.Zoom
    // @factory L.control.zoom(options: Control.Zoom options)
    // Creates a zoom control
    var zoom = function(options) {
        return new Zoom(options);
    };
    /*
   * @class Control.Scale
   * @aka L.Control.Scale
   * @inherits Control
   *
   * A simple scale control that shows the scale of the current center of screen in metric (m/km) and imperial (mi/ft) systems. Extends `Control`.
   *
   * @example
   *
   * ```js
   * L.control.scale().addTo(map);
   * ```
   */ var Scale = Control.extend({
        // @section
        // @aka Control.Scale options
        options: {
            position: "bottomleft",
            // @option maxWidth: Number = 100
            // Maximum width of the control in pixels. The width is set dynamically to show round values (e.g. 100, 200, 500).
            maxWidth: 100,
            // @option metric: Boolean = True
            // Whether to show the metric scale line (m/km).
            metric: true,
            // @option imperial: Boolean = True
            // Whether to show the imperial scale line (mi/ft).
            imperial: true
        },
        onAdd: function(map) {
            var className = "leaflet-control-scale", container = create$1("div", className), options = this.options;
            this._addScales(options, className + "-line", container);
            map.on(options.updateWhenIdle ? "moveend" : "move", this._update, this);
            map.whenReady(this._update, this);
            return container;
        },
        onRemove: function(map) {
            map.off(this.options.updateWhenIdle ? "moveend" : "move", this._update, this);
        },
        _addScales: function(options, className, container) {
            if (options.metric) this._mScale = create$1("div", className, container);
            if (options.imperial) this._iScale = create$1("div", className, container);
        },
        _update: function() {
            var map = this._map, y = map.getSize().y / 2;
            var maxMeters = map.distance(map.containerPointToLatLng([
                0,
                y
            ]), map.containerPointToLatLng([
                this.options.maxWidth,
                y
            ]));
            this._updateScales(maxMeters);
        },
        _updateScales: function(maxMeters) {
            if (this.options.metric && maxMeters) this._updateMetric(maxMeters);
            if (this.options.imperial && maxMeters) this._updateImperial(maxMeters);
        },
        _updateMetric: function(maxMeters) {
            var meters = this._getRoundNum(maxMeters), label = meters < 1000 ? meters + " m" : meters / 1000 + " km";
            this._updateScale(this._mScale, label, meters / maxMeters);
        },
        _updateImperial: function(maxMeters) {
            var maxFeet = maxMeters * 3.2808399, maxMiles, miles, feet;
            if (maxFeet > 5280) {
                maxMiles = maxFeet / 5280;
                miles = this._getRoundNum(maxMiles);
                this._updateScale(this._iScale, miles + " mi", miles / maxMiles);
            } else {
                feet = this._getRoundNum(maxFeet);
                this._updateScale(this._iScale, feet + " ft", feet / maxFeet);
            }
        },
        _updateScale: function(scale, text, ratio) {
            scale.style.width = Math.round(this.options.maxWidth * ratio) + "px";
            scale.innerHTML = text;
        },
        _getRoundNum: function(num) {
            var pow10 = Math.pow(10, (Math.floor(num) + "").length - 1), d = num / pow10;
            d = d >= 10 ? 10 : d >= 5 ? 5 : d >= 3 ? 3 : d >= 2 ? 2 : 1;
            return pow10 * d;
        }
    });
    // @factory L.control.scale(options?: Control.Scale options)
    // Creates an scale control with the given options.
    var scale = function(options) {
        return new Scale(options);
    };
    var ukrainianFlag = '<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="12" height="8" viewBox="0 0 12 8" class="leaflet-attribution-flag"><path fill="#4C7BE1" d="M0 0h12v4H0z"/><path fill="#FFD500" d="M0 4h12v3H0z"/><path fill="#E0BC00" d="M0 7h12v1H0z"/></svg>';
    /*
   * @class Control.Attribution
   * @aka L.Control.Attribution
   * @inherits Control
   *
   * The attribution control allows you to display attribution data in a small text box on a map. It is put on the map by default unless you set its [`attributionControl` option](#map-attributioncontrol) to `false`, and it fetches attribution texts from layers with the [`getAttribution` method](#layer-getattribution) automatically. Extends Control.
   */ var Attribution = Control.extend({
        // @section
        // @aka Control.Attribution options
        options: {
            position: "bottomright",
            // @option prefix: String|false = 'Leaflet'
            // The HTML text shown before the attributions. Pass `false` to disable.
            prefix: '<a href="https://leafletjs.com" title="A JavaScript library for interactive maps">' + (Browser.inlineSvg ? ukrainianFlag + " " : "") + "Leaflet</a>"
        },
        initialize: function(options) {
            setOptions(this, options);
            this._attributions = {};
        },
        onAdd: function(map) {
            map.attributionControl = this;
            this._container = create$1("div", "leaflet-control-attribution");
            disableClickPropagation(this._container);
            // TODO ugly, refactor
            for(var i in map._layers)if (map._layers[i].getAttribution) this.addAttribution(map._layers[i].getAttribution());
            this._update();
            map.on("layeradd", this._addAttribution, this);
            return this._container;
        },
        onRemove: function(map) {
            map.off("layeradd", this._addAttribution, this);
        },
        _addAttribution: function(ev) {
            if (ev.layer.getAttribution) {
                this.addAttribution(ev.layer.getAttribution());
                ev.layer.once("remove", function() {
                    this.removeAttribution(ev.layer.getAttribution());
                }, this);
            }
        },
        // @method setPrefix(prefix: String|false): this
        // The HTML text shown before the attributions. Pass `false` to disable.
        setPrefix: function(prefix) {
            this.options.prefix = prefix;
            this._update();
            return this;
        },
        // @method addAttribution(text: String): this
        // Adds an attribution text (e.g. `'&copy; OpenStreetMap contributors'`).
        addAttribution: function(text) {
            if (!text) return this;
            if (!this._attributions[text]) this._attributions[text] = 0;
            this._attributions[text]++;
            this._update();
            return this;
        },
        // @method removeAttribution(text: String): this
        // Removes an attribution text.
        removeAttribution: function(text) {
            if (!text) return this;
            if (this._attributions[text]) {
                this._attributions[text]--;
                this._update();
            }
            return this;
        },
        _update: function() {
            if (!this._map) return;
            var attribs = [];
            for(var i in this._attributions)if (this._attributions[i]) attribs.push(i);
            var prefixAndAttribs = [];
            if (this.options.prefix) prefixAndAttribs.push(this.options.prefix);
            if (attribs.length) prefixAndAttribs.push(attribs.join(", "));
            this._container.innerHTML = prefixAndAttribs.join(' <span aria-hidden="true">|</span> ');
        }
    });
    // @namespace Map
    // @section Control options
    // @option attributionControl: Boolean = true
    // Whether a [attribution control](#control-attribution) is added to the map by default.
    Map.mergeOptions({
        attributionControl: true
    });
    Map.addInitHook(function() {
        if (this.options.attributionControl) new Attribution().addTo(this);
    });
    // @namespace Control.Attribution
    // @factory L.control.attribution(options: Control.Attribution options)
    // Creates an attribution control.
    var attribution = function(options) {
        return new Attribution(options);
    };
    Control.Layers = Layers;
    Control.Zoom = Zoom;
    Control.Scale = Scale;
    Control.Attribution = Attribution;
    control.layers = layers;
    control.zoom = zoom;
    control.scale = scale;
    control.attribution = attribution;
    /*
  	L.Handler is a base class for handler classes that are used internally to inject
  	interaction features like dragging to classes like Map and Marker.
  */ // @class Handler
    // @aka L.Handler
    // Abstract class for map interaction handlers
    var Handler = Class.extend({
        initialize: function(map) {
            this._map = map;
        },
        // @method enable(): this
        // Enables the handler
        enable: function() {
            if (this._enabled) return this;
            this._enabled = true;
            this.addHooks();
            return this;
        },
        // @method disable(): this
        // Disables the handler
        disable: function() {
            if (!this._enabled) return this;
            this._enabled = false;
            this.removeHooks();
            return this;
        },
        // @method enabled(): Boolean
        // Returns `true` if the handler is enabled
        enabled: function() {
            return !!this._enabled;
        }
    });
    // @section There is static function which can be called without instantiating L.Handler:
    // @function addTo(map: Map, name: String): this
    // Adds a new Handler to the given map with the given name.
    Handler.addTo = function(map, name) {
        map.addHandler(name, this);
        return this;
    };
    var Mixin = {
        Events: Events
    };
    /*
   * @class Draggable
   * @aka L.Draggable
   * @inherits Evented
   *
   * A class for making DOM elements draggable (including touch support).
   * Used internally for map and marker dragging. Only works for elements
   * that were positioned with [`L.DomUtil.setPosition`](#domutil-setposition).
   *
   * @example
   * ```js
   * var draggable = new L.Draggable(elementToDrag);
   * draggable.enable();
   * ```
   */ var START = Browser.touch ? "touchstart mousedown" : "mousedown";
    var Draggable = Evented.extend({
        options: {
            // @section
            // @aka Draggable options
            // @option clickTolerance: Number = 3
            // The max number of pixels a user can shift the mouse pointer during a click
            // for it to be considered a valid click (as opposed to a mouse drag).
            clickTolerance: 3
        },
        // @constructor L.Draggable(el: HTMLElement, dragHandle?: HTMLElement, preventOutline?: Boolean, options?: Draggable options)
        // Creates a `Draggable` object for moving `el` when you start dragging the `dragHandle` element (equals `el` itself by default).
        initialize: function(element, dragStartTarget, preventOutline, options) {
            setOptions(this, options);
            this._element = element;
            this._dragStartTarget = dragStartTarget || element;
            this._preventOutline = preventOutline;
        },
        // @method enable()
        // Enables the dragging ability
        enable: function() {
            if (this._enabled) return;
            on(this._dragStartTarget, START, this._onDown, this);
            this._enabled = true;
        },
        // @method disable()
        // Disables the dragging ability
        disable: function() {
            if (!this._enabled) return;
            // If we're currently dragging this draggable,
            // disabling it counts as first ending the drag.
            if (Draggable._dragging === this) this.finishDrag(true);
            off(this._dragStartTarget, START, this._onDown, this);
            this._enabled = false;
            this._moved = false;
        },
        _onDown: function(e) {
            // Ignore the event if disabled; this happens in IE11
            // under some circumstances, see #3666.
            if (!this._enabled) return;
            this._moved = false;
            if (hasClass(this._element, "leaflet-zoom-anim")) return;
            if (e.touches && e.touches.length !== 1) {
                // Finish dragging to avoid conflict with touchZoom
                if (Draggable._dragging === this) this.finishDrag();
                return;
            }
            if (Draggable._dragging || e.shiftKey || e.which !== 1 && e.button !== 1 && !e.touches) return;
            Draggable._dragging = this; // Prevent dragging multiple objects at once.
            if (this._preventOutline) preventOutline(this._element);
            disableImageDrag();
            disableTextSelection();
            if (this._moving) return;
            // @event down: Event
            // Fired when a drag is about to start.
            this.fire("down");
            var first = e.touches ? e.touches[0] : e, sizedParent = getSizedParentNode(this._element);
            this._startPoint = new Point(first.clientX, first.clientY);
            this._startPos = getPosition(this._element);
            // Cache the scale, so that we can continuously compensate for it during drag (_onMove).
            this._parentScale = getScale(sizedParent);
            var mouseevent = e.type === "mousedown";
            on(document, mouseevent ? "mousemove" : "touchmove", this._onMove, this);
            on(document, mouseevent ? "mouseup" : "touchend touchcancel", this._onUp, this);
        },
        _onMove: function(e) {
            // Ignore the event if disabled; this happens in IE11
            // under some circumstances, see #3666.
            if (!this._enabled) return;
            if (e.touches && e.touches.length > 1) {
                this._moved = true;
                return;
            }
            var first = e.touches && e.touches.length === 1 ? e.touches[0] : e, offset = new Point(first.clientX, first.clientY)._subtract(this._startPoint);
            if (!offset.x && !offset.y) return;
            if (Math.abs(offset.x) + Math.abs(offset.y) < this.options.clickTolerance) return;
            // We assume that the parent container's position, border and scale do not change for the duration of the drag.
            // Therefore there is no need to account for the position and border (they are eliminated by the subtraction)
            // and we can use the cached value for the scale.
            offset.x /= this._parentScale.x;
            offset.y /= this._parentScale.y;
            preventDefault(e);
            if (!this._moved) {
                // @event dragstart: Event
                // Fired when a drag starts
                this.fire("dragstart");
                this._moved = true;
                addClass(document.body, "leaflet-dragging");
                this._lastTarget = e.target || e.srcElement;
                // IE and Edge do not give the <use> element, so fetch it
                // if necessary
                if (window.SVGElementInstance && this._lastTarget instanceof window.SVGElementInstance) this._lastTarget = this._lastTarget.correspondingUseElement;
                addClass(this._lastTarget, "leaflet-drag-target");
            }
            this._newPos = this._startPos.add(offset);
            this._moving = true;
            this._lastEvent = e;
            this._updatePosition();
        },
        _updatePosition: function() {
            var e = {
                originalEvent: this._lastEvent
            };
            // @event predrag: Event
            // Fired continuously during dragging *before* each corresponding
            // update of the element's position.
            this.fire("predrag", e);
            setPosition(this._element, this._newPos);
            // @event drag: Event
            // Fired continuously during dragging.
            this.fire("drag", e);
        },
        _onUp: function() {
            // Ignore the event if disabled; this happens in IE11
            // under some circumstances, see #3666.
            if (!this._enabled) return;
            this.finishDrag();
        },
        finishDrag: function(noInertia) {
            removeClass(document.body, "leaflet-dragging");
            if (this._lastTarget) {
                removeClass(this._lastTarget, "leaflet-drag-target");
                this._lastTarget = null;
            }
            off(document, "mousemove touchmove", this._onMove, this);
            off(document, "mouseup touchend touchcancel", this._onUp, this);
            enableImageDrag();
            enableTextSelection();
            var fireDragend = this._moved && this._moving;
            this._moving = false;
            Draggable._dragging = false;
            if (fireDragend) // @event dragend: DragEndEvent
            // Fired when the drag ends.
            this.fire("dragend", {
                noInertia: noInertia,
                distance: this._newPos.distanceTo(this._startPos)
            });
        }
    });
    /*
   * @namespace PolyUtil
   * Various utility functions for polygon geometries.
   */ /* @function clipPolygon(points: Point[], bounds: Bounds, round?: Boolean): Point[]
   * Clips the polygon geometry defined by the given `points` by the given bounds (using the [Sutherland-Hodgman algorithm](https://en.wikipedia.org/wiki/Sutherland%E2%80%93Hodgman_algorithm)).
   * Used by Leaflet to only show polygon points that are on the screen or near, increasing
   * performance. Note that polygon points needs different algorithm for clipping
   * than polyline, so there's a separate method for it.
   */ function clipPolygon(points, bounds, round) {
        var clippedPoints, edges = [
            1,
            4,
            2,
            8
        ], i, j, k, a, b, len, edge, p;
        for(i = 0, len = points.length; i < len; i++)points[i]._code = _getBitCode(points[i], bounds);
        // for each edge (left, bottom, right, top)
        for(k = 0; k < 4; k++){
            edge = edges[k];
            clippedPoints = [];
            for(i = 0, len = points.length, j = len - 1; i < len; j = i++){
                a = points[i];
                b = points[j];
                // if a is inside the clip window
                if (!(a._code & edge)) {
                    // if b is outside the clip window (a->b goes out of screen)
                    if (b._code & edge) {
                        p = _getEdgeIntersection(b, a, edge, bounds, round);
                        p._code = _getBitCode(p, bounds);
                        clippedPoints.push(p);
                    }
                    clippedPoints.push(a);
                // else if b is inside the clip window (a->b enters the screen)
                } else if (!(b._code & edge)) {
                    p = _getEdgeIntersection(b, a, edge, bounds, round);
                    p._code = _getBitCode(p, bounds);
                    clippedPoints.push(p);
                }
            }
            points = clippedPoints;
        }
        return points;
    }
    /* @function polygonCenter(latlngs: LatLng[], crs: CRS): LatLng
   * Returns the center ([centroid](http://en.wikipedia.org/wiki/Centroid)) of the passed LatLngs (first ring) from a polygon.
   */ function polygonCenter(latlngs, crs) {
        var i, j, p1, p2, f, area, x, y, center;
        if (!latlngs || latlngs.length === 0) throw new Error("latlngs not passed");
        if (!isFlat(latlngs)) {
            console.warn("latlngs are not flat! Only the first ring will be used");
            latlngs = latlngs[0];
        }
        var centroidLatLng = toLatLng([
            0,
            0
        ]);
        var bounds = toLatLngBounds(latlngs);
        var areaBounds = bounds.getNorthWest().distanceTo(bounds.getSouthWest()) * bounds.getNorthEast().distanceTo(bounds.getNorthWest());
        // tests showed that below 1700 rounding errors are happening
        if (areaBounds < 1700) // getting a inexact center, to move the latlngs near to [0, 0] to prevent rounding errors
        centroidLatLng = centroid(latlngs);
        var len = latlngs.length;
        var points = [];
        for(i = 0; i < len; i++){
            var latlng = toLatLng(latlngs[i]);
            points.push(crs.project(toLatLng([
                latlng.lat - centroidLatLng.lat,
                latlng.lng - centroidLatLng.lng
            ])));
        }
        area = x = y = 0;
        // polygon centroid algorithm;
        for(i = 0, j = len - 1; i < len; j = i++){
            p1 = points[i];
            p2 = points[j];
            f = p1.y * p2.x - p2.y * p1.x;
            x += (p1.x + p2.x) * f;
            y += (p1.y + p2.y) * f;
            area += f * 3;
        }
        if (area === 0) // Polygon is so small that all points are on same pixel.
        center = points[0];
        else center = [
            x / area,
            y / area
        ];
        var latlngCenter = crs.unproject(toPoint(center));
        return toLatLng([
            latlngCenter.lat + centroidLatLng.lat,
            latlngCenter.lng + centroidLatLng.lng
        ]);
    }
    /* @function centroid(latlngs: LatLng[]): LatLng
   * Returns the 'center of mass' of the passed LatLngs.
   */ function centroid(coords) {
        var latSum = 0;
        var lngSum = 0;
        var len = 0;
        for(var i = 0; i < coords.length; i++){
            var latlng = toLatLng(coords[i]);
            latSum += latlng.lat;
            lngSum += latlng.lng;
            len++;
        }
        return toLatLng([
            latSum / len,
            lngSum / len
        ]);
    }
    var PolyUtil = {
        __proto__: null,
        clipPolygon: clipPolygon,
        polygonCenter: polygonCenter,
        centroid: centroid
    };
    /*
   * @namespace LineUtil
   *
   * Various utility functions for polyline points processing, used by Leaflet internally to make polylines lightning-fast.
   */ // Simplify polyline with vertex reduction and Douglas-Peucker simplification.
    // Improves rendering performance dramatically by lessening the number of points to draw.
    // @function simplify(points: Point[], tolerance: Number): Point[]
    // Dramatically reduces the number of points in a polyline while retaining
    // its shape and returns a new array of simplified points, using the
    // [Ramer-Douglas-Peucker algorithm](https://en.wikipedia.org/wiki/Ramer-Douglas-Peucker_algorithm).
    // Used for a huge performance boost when processing/displaying Leaflet polylines for
    // each zoom level and also reducing visual noise. tolerance affects the amount of
    // simplification (lesser value means higher quality but slower and with more points).
    // Also released as a separated micro-library [Simplify.js](https://mourner.github.io/simplify-js/).
    function simplify(points, tolerance) {
        if (!tolerance || !points.length) return points.slice();
        var sqTolerance = tolerance * tolerance;
        // stage 1: vertex reduction
        points = _reducePoints(points, sqTolerance);
        // stage 2: Douglas-Peucker simplification
        points = _simplifyDP(points, sqTolerance);
        return points;
    }
    // @function pointToSegmentDistance(p: Point, p1: Point, p2: Point): Number
    // Returns the distance between point `p` and segment `p1` to `p2`.
    function pointToSegmentDistance(p, p1, p2) {
        return Math.sqrt(_sqClosestPointOnSegment(p, p1, p2, true));
    }
    // @function closestPointOnSegment(p: Point, p1: Point, p2: Point): Number
    // Returns the closest point from a point `p` on a segment `p1` to `p2`.
    function closestPointOnSegment(p, p1, p2) {
        return _sqClosestPointOnSegment(p, p1, p2);
    }
    // Ramer-Douglas-Peucker simplification, see https://en.wikipedia.org/wiki/Ramer-Douglas-Peucker_algorithm
    function _simplifyDP(points, sqTolerance) {
        var len = points.length, ArrayConstructor = typeof Uint8Array !== "undefined" ? Uint8Array : Array, markers = new ArrayConstructor(len);
        markers[0] = markers[len - 1] = 1;
        _simplifyDPStep(points, markers, sqTolerance, 0, len - 1);
        var i, newPoints = [];
        for(i = 0; i < len; i++)if (markers[i]) newPoints.push(points[i]);
        return newPoints;
    }
    function _simplifyDPStep(points, markers, sqTolerance, first, last) {
        var maxSqDist = 0, index, i, sqDist;
        for(i = first + 1; i <= last - 1; i++){
            sqDist = _sqClosestPointOnSegment(points[i], points[first], points[last], true);
            if (sqDist > maxSqDist) {
                index = i;
                maxSqDist = sqDist;
            }
        }
        if (maxSqDist > sqTolerance) {
            markers[index] = 1;
            _simplifyDPStep(points, markers, sqTolerance, first, index);
            _simplifyDPStep(points, markers, sqTolerance, index, last);
        }
    }
    // reduce points that are too close to each other to a single point
    function _reducePoints(points, sqTolerance) {
        var reducedPoints = [
            points[0]
        ];
        for(var i = 1, prev = 0, len = points.length; i < len; i++)if (_sqDist(points[i], points[prev]) > sqTolerance) {
            reducedPoints.push(points[i]);
            prev = i;
        }
        if (prev < len - 1) reducedPoints.push(points[len - 1]);
        return reducedPoints;
    }
    var _lastCode;
    // @function clipSegment(a: Point, b: Point, bounds: Bounds, useLastCode?: Boolean, round?: Boolean): Point[]|Boolean
    // Clips the segment a to b by rectangular bounds with the
    // [Cohen-Sutherland algorithm](https://en.wikipedia.org/wiki/Cohen%E2%80%93Sutherland_algorithm)
    // (modifying the segment points directly!). Used by Leaflet to only show polyline
    // points that are on the screen or near, increasing performance.
    function clipSegment(a, b, bounds, useLastCode, round) {
        var codeA = useLastCode ? _lastCode : _getBitCode(a, bounds), codeB = _getBitCode(b, bounds), codeOut, p, newCode;
        // save 2nd code to avoid calculating it on the next segment
        _lastCode = codeB;
        while(true){
            // if a,b is inside the clip window (trivial accept)
            if (!(codeA | codeB)) return [
                a,
                b
            ];
            // if a,b is outside the clip window (trivial reject)
            if (codeA & codeB) return false;
            // other cases
            codeOut = codeA || codeB;
            p = _getEdgeIntersection(a, b, codeOut, bounds, round);
            newCode = _getBitCode(p, bounds);
            if (codeOut === codeA) {
                a = p;
                codeA = newCode;
            } else {
                b = p;
                codeB = newCode;
            }
        }
    }
    function _getEdgeIntersection(a, b, code, bounds, round) {
        var dx = b.x - a.x, dy = b.y - a.y, min = bounds.min, max = bounds.max, x, y;
        if (code & 8) {
            x = a.x + dx * (max.y - a.y) / dy;
            y = max.y;
        } else if (code & 4) {
            x = a.x + dx * (min.y - a.y) / dy;
            y = min.y;
        } else if (code & 2) {
            x = max.x;
            y = a.y + dy * (max.x - a.x) / dx;
        } else if (code & 1) {
            x = min.x;
            y = a.y + dy * (min.x - a.x) / dx;
        }
        return new Point(x, y, round);
    }
    function _getBitCode(p, bounds) {
        var code = 0;
        if (p.x < bounds.min.x) code |= 1;
        else if (p.x > bounds.max.x) code |= 2;
        if (p.y < bounds.min.y) code |= 4;
        else if (p.y > bounds.max.y) code |= 8;
        return code;
    }
    // square distance (to avoid unnecessary Math.sqrt calls)
    function _sqDist(p1, p2) {
        var dx = p2.x - p1.x, dy = p2.y - p1.y;
        return dx * dx + dy * dy;
    }
    // return closest point on segment or distance to that point
    function _sqClosestPointOnSegment(p, p1, p2, sqDist) {
        var x = p1.x, y = p1.y, dx = p2.x - x, dy = p2.y - y, dot = dx * dx + dy * dy, t;
        if (dot > 0) {
            t = ((p.x - x) * dx + (p.y - y) * dy) / dot;
            if (t > 1) {
                x = p2.x;
                y = p2.y;
            } else if (t > 0) {
                x += dx * t;
                y += dy * t;
            }
        }
        dx = p.x - x;
        dy = p.y - y;
        return sqDist ? dx * dx + dy * dy : new Point(x, y);
    }
    // @function isFlat(latlngs: LatLng[]): Boolean
    // Returns true if `latlngs` is a flat array, false is nested.
    function isFlat(latlngs) {
        return !isArray(latlngs[0]) || typeof latlngs[0][0] !== "object" && typeof latlngs[0][0] !== "undefined";
    }
    function _flat(latlngs) {
        console.warn("Deprecated use of _flat, please use L.LineUtil.isFlat instead.");
        return isFlat(latlngs);
    }
    /* @function polylineCenter(latlngs: LatLng[], crs: CRS): LatLng
   * Returns the center ([centroid](http://en.wikipedia.org/wiki/Centroid)) of the passed LatLngs (first ring) from a polyline.
   */ function polylineCenter(latlngs, crs) {
        var i, halfDist, segDist, dist, p1, p2, ratio, center;
        if (!latlngs || latlngs.length === 0) throw new Error("latlngs not passed");
        if (!isFlat(latlngs)) {
            console.warn("latlngs are not flat! Only the first ring will be used");
            latlngs = latlngs[0];
        }
        var centroidLatLng = toLatLng([
            0,
            0
        ]);
        var bounds = toLatLngBounds(latlngs);
        var areaBounds = bounds.getNorthWest().distanceTo(bounds.getSouthWest()) * bounds.getNorthEast().distanceTo(bounds.getNorthWest());
        // tests showed that below 1700 rounding errors are happening
        if (areaBounds < 1700) // getting a inexact center, to move the latlngs near to [0, 0] to prevent rounding errors
        centroidLatLng = centroid(latlngs);
        var len = latlngs.length;
        var points = [];
        for(i = 0; i < len; i++){
            var latlng = toLatLng(latlngs[i]);
            points.push(crs.project(toLatLng([
                latlng.lat - centroidLatLng.lat,
                latlng.lng - centroidLatLng.lng
            ])));
        }
        for(i = 0, halfDist = 0; i < len - 1; i++)halfDist += points[i].distanceTo(points[i + 1]) / 2;
        // The line is so small in the current view that all points are on the same pixel.
        if (halfDist === 0) center = points[0];
        else for(i = 0, dist = 0; i < len - 1; i++){
            p1 = points[i];
            p2 = points[i + 1];
            segDist = p1.distanceTo(p2);
            dist += segDist;
            if (dist > halfDist) {
                ratio = (dist - halfDist) / segDist;
                center = [
                    p2.x - ratio * (p2.x - p1.x),
                    p2.y - ratio * (p2.y - p1.y)
                ];
                break;
            }
        }
        var latlngCenter = crs.unproject(toPoint(center));
        return toLatLng([
            latlngCenter.lat + centroidLatLng.lat,
            latlngCenter.lng + centroidLatLng.lng
        ]);
    }
    var LineUtil = {
        __proto__: null,
        simplify: simplify,
        pointToSegmentDistance: pointToSegmentDistance,
        closestPointOnSegment: closestPointOnSegment,
        clipSegment: clipSegment,
        _getEdgeIntersection: _getEdgeIntersection,
        _getBitCode: _getBitCode,
        _sqClosestPointOnSegment: _sqClosestPointOnSegment,
        isFlat: isFlat,
        _flat: _flat,
        polylineCenter: polylineCenter
    };
    /*
   * @namespace Projection
   * @section
   * Leaflet comes with a set of already defined Projections out of the box:
   *
   * @projection L.Projection.LonLat
   *
   * Equirectangular, or Plate Carree projection — the most simple projection,
   * mostly used by GIS enthusiasts. Directly maps `x` as longitude, and `y` as
   * latitude. Also suitable for flat worlds, e.g. game maps. Used by the
   * `EPSG:4326` and `Simple` CRS.
   */ var LonLat = {
        project: function(latlng) {
            return new Point(latlng.lng, latlng.lat);
        },
        unproject: function(point) {
            return new LatLng(point.y, point.x);
        },
        bounds: new Bounds([
            -180,
            -90
        ], [
            180,
            90
        ])
    };
    /*
   * @namespace Projection
   * @projection L.Projection.Mercator
   *
   * Elliptical Mercator projection — more complex than Spherical Mercator. Assumes that Earth is an ellipsoid. Used by the EPSG:3395 CRS.
   */ var Mercator = {
        R: 6378137,
        R_MINOR: 6356752.314245179,
        bounds: new Bounds([
            -20037508.34279,
            -15496570.73972
        ], [
            20037508.34279,
            18764656.23138
        ]),
        project: function(latlng) {
            var d = Math.PI / 180, r = this.R, y = latlng.lat * d, tmp = this.R_MINOR / r, e = Math.sqrt(1 - tmp * tmp), con = e * Math.sin(y);
            var ts = Math.tan(Math.PI / 4 - y / 2) / Math.pow((1 - con) / (1 + con), e / 2);
            y = -r * Math.log(Math.max(ts, 1E-10));
            return new Point(latlng.lng * d * r, y);
        },
        unproject: function(point) {
            var d = 180 / Math.PI, r = this.R, tmp = this.R_MINOR / r, e = Math.sqrt(1 - tmp * tmp), ts = Math.exp(-point.y / r), phi = Math.PI / 2 - 2 * Math.atan(ts);
            for(var i = 0, dphi = 0.1, con; i < 15 && Math.abs(dphi) > 1e-7; i++){
                con = e * Math.sin(phi);
                con = Math.pow((1 - con) / (1 + con), e / 2);
                dphi = Math.PI / 2 - 2 * Math.atan(ts * con) - phi;
                phi += dphi;
            }
            return new LatLng(phi * d, point.x * d / r);
        }
    };
    /*
   * @class Projection

   * An object with methods for projecting geographical coordinates of the world onto
   * a flat surface (and back). See [Map projection](https://en.wikipedia.org/wiki/Map_projection).

   * @property bounds: Bounds
   * The bounds (specified in CRS units) where the projection is valid

   * @method project(latlng: LatLng): Point
   * Projects geographical coordinates into a 2D point.
   * Only accepts actual `L.LatLng` instances, not arrays.

   * @method unproject(point: Point): LatLng
   * The inverse of `project`. Projects a 2D point into a geographical location.
   * Only accepts actual `L.Point` instances, not arrays.

   * Note that the projection instances do not inherit from Leaflet's `Class` object,
   * and can't be instantiated. Also, new classes can't inherit from them,
   * and methods can't be added to them with the `include` function.

   */ var index = {
        __proto__: null,
        LonLat: LonLat,
        Mercator: Mercator,
        SphericalMercator: SphericalMercator
    };
    /*
   * @namespace CRS
   * @crs L.CRS.EPSG3395
   *
   * Rarely used by some commercial tile providers. Uses Elliptical Mercator projection.
   */ var EPSG3395 = extend({}, Earth, {
        code: "EPSG:3395",
        projection: Mercator,
        transformation: function() {
            var scale = 0.5 / (Math.PI * Mercator.R);
            return toTransformation(scale, 0.5, -scale, 0.5);
        }()
    });
    /*
   * @namespace CRS
   * @crs L.CRS.EPSG4326
   *
   * A common CRS among GIS enthusiasts. Uses simple Equirectangular projection.
   *
   * Leaflet 1.0.x complies with the [TMS coordinate scheme for EPSG:4326](https://wiki.osgeo.org/wiki/Tile_Map_Service_Specification#global-geodetic),
   * which is a breaking change from 0.7.x behaviour.  If you are using a `TileLayer`
   * with this CRS, ensure that there are two 256x256 pixel tiles covering the
   * whole earth at zoom level zero, and that the tile coordinate origin is (-180,+90),
   * or (-180,-90) for `TileLayer`s with [the `tms` option](#tilelayer-tms) set.
   */ var EPSG4326 = extend({}, Earth, {
        code: "EPSG:4326",
        projection: LonLat,
        transformation: toTransformation(1 / 180, 1, -1 / 180, 0.5)
    });
    /*
   * @namespace CRS
   * @crs L.CRS.Simple
   *
   * A simple CRS that maps longitude and latitude into `x` and `y` directly.
   * May be used for maps of flat surfaces (e.g. game maps). Note that the `y`
   * axis should still be inverted (going from bottom to top). `distance()` returns
   * simple euclidean distance.
   */ var Simple = extend({}, CRS, {
        projection: LonLat,
        transformation: toTransformation(1, 0, -1, 0),
        scale: function(zoom) {
            return Math.pow(2, zoom);
        },
        zoom: function(scale) {
            return Math.log(scale) / Math.LN2;
        },
        distance: function(latlng1, latlng2) {
            var dx = latlng2.lng - latlng1.lng, dy = latlng2.lat - latlng1.lat;
            return Math.sqrt(dx * dx + dy * dy);
        },
        infinite: true
    });
    CRS.Earth = Earth;
    CRS.EPSG3395 = EPSG3395;
    CRS.EPSG3857 = EPSG3857;
    CRS.EPSG900913 = EPSG900913;
    CRS.EPSG4326 = EPSG4326;
    CRS.Simple = Simple;
    /*
   * @class Layer
   * @inherits Evented
   * @aka L.Layer
   * @aka ILayer
   *
   * A set of methods from the Layer base class that all Leaflet layers use.
   * Inherits all methods, options and events from `L.Evented`.
   *
   * @example
   *
   * ```js
   * var layer = L.marker(latlng).addTo(map);
   * layer.addTo(map);
   * layer.remove();
   * ```
   *
   * @event add: Event
   * Fired after the layer is added to a map
   *
   * @event remove: Event
   * Fired after the layer is removed from a map
   */ var Layer = Evented.extend({
        // Classes extending `L.Layer` will inherit the following options:
        options: {
            // @option pane: String = 'overlayPane'
            // By default the layer will be added to the map's [overlay pane](#map-overlaypane). Overriding this option will cause the layer to be placed on another pane by default.
            pane: "overlayPane",
            // @option attribution: String = null
            // String to be shown in the attribution control, e.g. "© OpenStreetMap contributors". It describes the layer data and is often a legal obligation towards copyright holders and tile providers.
            attribution: null,
            bubblingMouseEvents: true
        },
        /* @section
  	 * Classes extending `L.Layer` will inherit the following methods:
  	 *
  	 * @method addTo(map: Map|LayerGroup): this
  	 * Adds the layer to the given map or layer group.
  	 */ addTo: function(map) {
            map.addLayer(this);
            return this;
        },
        // @method remove: this
        // Removes the layer from the map it is currently active on.
        remove: function() {
            return this.removeFrom(this._map || this._mapToAdd);
        },
        // @method removeFrom(map: Map): this
        // Removes the layer from the given map
        //
        // @alternative
        // @method removeFrom(group: LayerGroup): this
        // Removes the layer from the given `LayerGroup`
        removeFrom: function(obj) {
            if (obj) obj.removeLayer(this);
            return this;
        },
        // @method getPane(name? : String): HTMLElement
        // Returns the `HTMLElement` representing the named pane on the map. If `name` is omitted, returns the pane for this layer.
        getPane: function(name) {
            return this._map.getPane(name ? this.options[name] || name : this.options.pane);
        },
        addInteractiveTarget: function(targetEl) {
            this._map._targets[stamp(targetEl)] = this;
            return this;
        },
        removeInteractiveTarget: function(targetEl) {
            delete this._map._targets[stamp(targetEl)];
            return this;
        },
        // @method getAttribution: String
        // Used by the `attribution control`, returns the [attribution option](#gridlayer-attribution).
        getAttribution: function() {
            return this.options.attribution;
        },
        _layerAdd: function(e) {
            var map = e.target;
            // check in case layer gets added and then removed before the map is ready
            if (!map.hasLayer(this)) return;
            this._map = map;
            this._zoomAnimated = map._zoomAnimated;
            if (this.getEvents) {
                var events = this.getEvents();
                map.on(events, this);
                this.once("remove", function() {
                    map.off(events, this);
                }, this);
            }
            this.onAdd(map);
            this.fire("add");
            map.fire("layeradd", {
                layer: this
            });
        }
    });
    /* @section Extension methods
   * @uninheritable
   *
   * Every layer should extend from `L.Layer` and (re-)implement the following methods.
   *
   * @method onAdd(map: Map): this
   * Should contain code that creates DOM elements for the layer, adds them to `map panes` where they should belong and puts listeners on relevant map events. Called on [`map.addLayer(layer)`](#map-addlayer).
   *
   * @method onRemove(map: Map): this
   * Should contain all clean up code that removes the layer's elements from the DOM and removes listeners previously added in [`onAdd`](#layer-onadd). Called on [`map.removeLayer(layer)`](#map-removelayer).
   *
   * @method getEvents(): Object
   * This optional method should return an object like `{ viewreset: this._reset }` for [`addEventListener`](#evented-addeventlistener). The event handlers in this object will be automatically added and removed from the map with your layer.
   *
   * @method getAttribution(): String
   * This optional method should return a string containing HTML to be shown on the `Attribution control` whenever the layer is visible.
   *
   * @method beforeAdd(map: Map): this
   * Optional method. Called on [`map.addLayer(layer)`](#map-addlayer), before the layer is added to the map, before events are initialized, without waiting until the map is in a usable state. Use for early initialization only.
   */ /* @namespace Map
   * @section Layer events
   *
   * @event layeradd: LayerEvent
   * Fired when a new layer is added to the map.
   *
   * @event layerremove: LayerEvent
   * Fired when some layer is removed from the map
   *
   * @section Methods for Layers and Controls
   */ Map.include({
        // @method addLayer(layer: Layer): this
        // Adds the given layer to the map
        addLayer: function(layer) {
            if (!layer._layerAdd) throw new Error("The provided object is not a Layer.");
            var id = stamp(layer);
            if (this._layers[id]) return this;
            this._layers[id] = layer;
            layer._mapToAdd = this;
            if (layer.beforeAdd) layer.beforeAdd(this);
            this.whenReady(layer._layerAdd, layer);
            return this;
        },
        // @method removeLayer(layer: Layer): this
        // Removes the given layer from the map.
        removeLayer: function(layer) {
            var id = stamp(layer);
            if (!this._layers[id]) return this;
            if (this._loaded) layer.onRemove(this);
            delete this._layers[id];
            if (this._loaded) {
                this.fire("layerremove", {
                    layer: layer
                });
                layer.fire("remove");
            }
            layer._map = layer._mapToAdd = null;
            return this;
        },
        // @method hasLayer(layer: Layer): Boolean
        // Returns `true` if the given layer is currently added to the map
        hasLayer: function(layer) {
            return stamp(layer) in this._layers;
        },
        /* @method eachLayer(fn: Function, context?: Object): this
  	 * Iterates over the layers of the map, optionally specifying context of the iterator function.
  	 * ```
  	 * map.eachLayer(function(layer){
  	 *     layer.bindPopup('Hello');
  	 * });
  	 * ```
  	 */ eachLayer: function(method, context) {
            for(var i in this._layers)method.call(context, this._layers[i]);
            return this;
        },
        _addLayers: function(layers) {
            layers = layers ? isArray(layers) ? layers : [
                layers
            ] : [];
            for(var i = 0, len = layers.length; i < len; i++)this.addLayer(layers[i]);
        },
        _addZoomLimit: function(layer) {
            if (!isNaN(layer.options.maxZoom) || !isNaN(layer.options.minZoom)) {
                this._zoomBoundLayers[stamp(layer)] = layer;
                this._updateZoomLevels();
            }
        },
        _removeZoomLimit: function(layer) {
            var id = stamp(layer);
            if (this._zoomBoundLayers[id]) {
                delete this._zoomBoundLayers[id];
                this._updateZoomLevels();
            }
        },
        _updateZoomLevels: function() {
            var minZoom = Infinity, maxZoom = -Infinity, oldZoomSpan = this._getZoomSpan();
            for(var i in this._zoomBoundLayers){
                var options = this._zoomBoundLayers[i].options;
                minZoom = options.minZoom === undefined ? minZoom : Math.min(minZoom, options.minZoom);
                maxZoom = options.maxZoom === undefined ? maxZoom : Math.max(maxZoom, options.maxZoom);
            }
            this._layersMaxZoom = maxZoom === -Infinity ? undefined : maxZoom;
            this._layersMinZoom = minZoom === Infinity ? undefined : minZoom;
            // @section Map state change events
            // @event zoomlevelschange: Event
            // Fired when the number of zoomlevels on the map is changed due
            // to adding or removing a layer.
            if (oldZoomSpan !== this._getZoomSpan()) this.fire("zoomlevelschange");
            if (this.options.maxZoom === undefined && this._layersMaxZoom && this.getZoom() > this._layersMaxZoom) this.setZoom(this._layersMaxZoom);
            if (this.options.minZoom === undefined && this._layersMinZoom && this.getZoom() < this._layersMinZoom) this.setZoom(this._layersMinZoom);
        }
    });
    /*
   * @class LayerGroup
   * @aka L.LayerGroup
   * @inherits Interactive layer
   *
   * Used to group several layers and handle them as one. If you add it to the map,
   * any layers added or removed from the group will be added/removed on the map as
   * well. Extends `Layer`.
   *
   * @example
   *
   * ```js
   * L.layerGroup([marker1, marker2])
   * 	.addLayer(polyline)
   * 	.addTo(map);
   * ```
   */ var LayerGroup = Layer.extend({
        initialize: function(layers, options) {
            setOptions(this, options);
            this._layers = {};
            var i, len;
            if (layers) for(i = 0, len = layers.length; i < len; i++)this.addLayer(layers[i]);
        },
        // @method addLayer(layer: Layer): this
        // Adds the given layer to the group.
        addLayer: function(layer) {
            var id = this.getLayerId(layer);
            this._layers[id] = layer;
            if (this._map) this._map.addLayer(layer);
            return this;
        },
        // @method removeLayer(layer: Layer): this
        // Removes the given layer from the group.
        // @alternative
        // @method removeLayer(id: Number): this
        // Removes the layer with the given internal ID from the group.
        removeLayer: function(layer) {
            var id = layer in this._layers ? layer : this.getLayerId(layer);
            if (this._map && this._layers[id]) this._map.removeLayer(this._layers[id]);
            delete this._layers[id];
            return this;
        },
        // @method hasLayer(layer: Layer): Boolean
        // Returns `true` if the given layer is currently added to the group.
        // @alternative
        // @method hasLayer(id: Number): Boolean
        // Returns `true` if the given internal ID is currently added to the group.
        hasLayer: function(layer) {
            var layerId = typeof layer === "number" ? layer : this.getLayerId(layer);
            return layerId in this._layers;
        },
        // @method clearLayers(): this
        // Removes all the layers from the group.
        clearLayers: function() {
            return this.eachLayer(this.removeLayer, this);
        },
        // @method invoke(methodName: String, …): this
        // Calls `methodName` on every layer contained in this group, passing any
        // additional parameters. Has no effect if the layers contained do not
        // implement `methodName`.
        invoke: function(methodName) {
            var args = Array.prototype.slice.call(arguments, 1), i, layer;
            for(i in this._layers){
                layer = this._layers[i];
                if (layer[methodName]) layer[methodName].apply(layer, args);
            }
            return this;
        },
        onAdd: function(map) {
            this.eachLayer(map.addLayer, map);
        },
        onRemove: function(map) {
            this.eachLayer(map.removeLayer, map);
        },
        // @method eachLayer(fn: Function, context?: Object): this
        // Iterates over the layers of the group, optionally specifying context of the iterator function.
        // ```js
        // group.eachLayer(function (layer) {
        // 	layer.bindPopup('Hello');
        // });
        // ```
        eachLayer: function(method, context) {
            for(var i in this._layers)method.call(context, this._layers[i]);
            return this;
        },
        // @method getLayer(id: Number): Layer
        // Returns the layer with the given internal ID.
        getLayer: function(id) {
            return this._layers[id];
        },
        // @method getLayers(): Layer[]
        // Returns an array of all the layers added to the group.
        getLayers: function() {
            var layers = [];
            this.eachLayer(layers.push, layers);
            return layers;
        },
        // @method setZIndex(zIndex: Number): this
        // Calls `setZIndex` on every layer contained in this group, passing the z-index.
        setZIndex: function(zIndex) {
            return this.invoke("setZIndex", zIndex);
        },
        // @method getLayerId(layer: Layer): Number
        // Returns the internal ID for a layer
        getLayerId: function(layer) {
            return stamp(layer);
        }
    });
    // @factory L.layerGroup(layers?: Layer[], options?: Object)
    // Create a layer group, optionally given an initial set of layers and an `options` object.
    var layerGroup = function(layers, options) {
        return new LayerGroup(layers, options);
    };
    /*
   * @class FeatureGroup
   * @aka L.FeatureGroup
   * @inherits LayerGroup
   *
   * Extended `LayerGroup` that makes it easier to do the same thing to all its member layers:
   *  * [`bindPopup`](#layer-bindpopup) binds a popup to all of the layers at once (likewise with [`bindTooltip`](#layer-bindtooltip))
   *  * Events are propagated to the `FeatureGroup`, so if the group has an event
   * handler, it will handle events from any of the layers. This includes mouse events
   * and custom events.
   *  * Has `layeradd` and `layerremove` events
   *
   * @example
   *
   * ```js
   * L.featureGroup([marker1, marker2, polyline])
   * 	.bindPopup('Hello world!')
   * 	.on('click', function() { alert('Clicked on a member of the group!'); })
   * 	.addTo(map);
   * ```
   */ var FeatureGroup = LayerGroup.extend({
        addLayer: function(layer) {
            if (this.hasLayer(layer)) return this;
            layer.addEventParent(this);
            LayerGroup.prototype.addLayer.call(this, layer);
            // @event layeradd: LayerEvent
            // Fired when a layer is added to this `FeatureGroup`
            return this.fire("layeradd", {
                layer: layer
            });
        },
        removeLayer: function(layer) {
            if (!this.hasLayer(layer)) return this;
            if (layer in this._layers) layer = this._layers[layer];
            layer.removeEventParent(this);
            LayerGroup.prototype.removeLayer.call(this, layer);
            // @event layerremove: LayerEvent
            // Fired when a layer is removed from this `FeatureGroup`
            return this.fire("layerremove", {
                layer: layer
            });
        },
        // @method setStyle(style: Path options): this
        // Sets the given path options to each layer of the group that has a `setStyle` method.
        setStyle: function(style) {
            return this.invoke("setStyle", style);
        },
        // @method bringToFront(): this
        // Brings the layer group to the top of all other layers
        bringToFront: function() {
            return this.invoke("bringToFront");
        },
        // @method bringToBack(): this
        // Brings the layer group to the back of all other layers
        bringToBack: function() {
            return this.invoke("bringToBack");
        },
        // @method getBounds(): LatLngBounds
        // Returns the LatLngBounds of the Feature Group (created from bounds and coordinates of its children).
        getBounds: function() {
            var bounds = new LatLngBounds();
            for(var id in this._layers){
                var layer = this._layers[id];
                bounds.extend(layer.getBounds ? layer.getBounds() : layer.getLatLng());
            }
            return bounds;
        }
    });
    // @factory L.featureGroup(layers?: Layer[], options?: Object)
    // Create a feature group, optionally given an initial set of layers and an `options` object.
    var featureGroup = function(layers, options) {
        return new FeatureGroup(layers, options);
    };
    /*
   * @class Icon
   * @aka L.Icon
   *
   * Represents an icon to provide when creating a marker.
   *
   * @example
   *
   * ```js
   * var myIcon = L.icon({
   *     iconUrl: 'my-icon.png',
   *     iconRetinaUrl: 'my-icon@2x.png',
   *     iconSize: [38, 95],
   *     iconAnchor: [22, 94],
   *     popupAnchor: [-3, -76],
   *     shadowUrl: 'my-icon-shadow.png',
   *     shadowRetinaUrl: 'my-icon-shadow@2x.png',
   *     shadowSize: [68, 95],
   *     shadowAnchor: [22, 94]
   * });
   *
   * L.marker([50.505, 30.57], {icon: myIcon}).addTo(map);
   * ```
   *
   * `L.Icon.Default` extends `L.Icon` and is the blue icon Leaflet uses for markers by default.
   *
   */ var Icon = Class.extend({
        /* @section
  	 * @aka Icon options
  	 *
  	 * @option iconUrl: String = null
  	 * **(required)** The URL to the icon image (absolute or relative to your script path).
  	 *
  	 * @option iconRetinaUrl: String = null
  	 * The URL to a retina sized version of the icon image (absolute or relative to your
  	 * script path). Used for Retina screen devices.
  	 *
  	 * @option iconSize: Point = null
  	 * Size of the icon image in pixels.
  	 *
  	 * @option iconAnchor: Point = null
  	 * The coordinates of the "tip" of the icon (relative to its top left corner). The icon
  	 * will be aligned so that this point is at the marker's geographical location. Centered
  	 * by default if size is specified, also can be set in CSS with negative margins.
  	 *
  	 * @option popupAnchor: Point = [0, 0]
  	 * The coordinates of the point from which popups will "open", relative to the icon anchor.
  	 *
  	 * @option tooltipAnchor: Point = [0, 0]
  	 * The coordinates of the point from which tooltips will "open", relative to the icon anchor.
  	 *
  	 * @option shadowUrl: String = null
  	 * The URL to the icon shadow image. If not specified, no shadow image will be created.
  	 *
  	 * @option shadowRetinaUrl: String = null
  	 *
  	 * @option shadowSize: Point = null
  	 * Size of the shadow image in pixels.
  	 *
  	 * @option shadowAnchor: Point = null
  	 * The coordinates of the "tip" of the shadow (relative to its top left corner) (the same
  	 * as iconAnchor if not specified).
  	 *
  	 * @option className: String = ''
  	 * A custom class name to assign to both icon and shadow images. Empty by default.
  	 */ options: {
            popupAnchor: [
                0,
                0
            ],
            tooltipAnchor: [
                0,
                0
            ],
            // @option crossOrigin: Boolean|String = false
            // Whether the crossOrigin attribute will be added to the tiles.
            // If a String is provided, all tiles will have their crossOrigin attribute set to the String provided. This is needed if you want to access tile pixel data.
            // Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
            crossOrigin: false
        },
        initialize: function(options) {
            setOptions(this, options);
        },
        // @method createIcon(oldIcon?: HTMLElement): HTMLElement
        // Called internally when the icon has to be shown, returns a `<img>` HTML element
        // styled according to the options.
        createIcon: function(oldIcon) {
            return this._createIcon("icon", oldIcon);
        },
        // @method createShadow(oldIcon?: HTMLElement): HTMLElement
        // As `createIcon`, but for the shadow beneath it.
        createShadow: function(oldIcon) {
            return this._createIcon("shadow", oldIcon);
        },
        _createIcon: function(name, oldIcon) {
            var src = this._getIconUrl(name);
            if (!src) {
                if (name === "icon") throw new Error("iconUrl not set in Icon options (see the docs).");
                return null;
            }
            var img = this._createImg(src, oldIcon && oldIcon.tagName === "IMG" ? oldIcon : null);
            this._setIconStyles(img, name);
            if (this.options.crossOrigin || this.options.crossOrigin === "") img.crossOrigin = this.options.crossOrigin === true ? "" : this.options.crossOrigin;
            return img;
        },
        _setIconStyles: function(img, name) {
            var options = this.options;
            var sizeOption = options[name + "Size"];
            if (typeof sizeOption === "number") sizeOption = [
                sizeOption,
                sizeOption
            ];
            var size = toPoint(sizeOption), anchor = toPoint(name === "shadow" && options.shadowAnchor || options.iconAnchor || size && size.divideBy(2, true));
            img.className = "leaflet-marker-" + name + " " + (options.className || "");
            if (anchor) {
                img.style.marginLeft = -anchor.x + "px";
                img.style.marginTop = -anchor.y + "px";
            }
            if (size) {
                img.style.width = size.x + "px";
                img.style.height = size.y + "px";
            }
        },
        _createImg: function(src, el) {
            el = el || document.createElement("img");
            el.src = src;
            return el;
        },
        _getIconUrl: function(name) {
            return Browser.retina && this.options[name + "RetinaUrl"] || this.options[name + "Url"];
        }
    });
    // @factory L.icon(options: Icon options)
    // Creates an icon instance with the given options.
    function icon(options) {
        return new Icon(options);
    }
    /*
   * @miniclass Icon.Default (Icon)
   * @aka L.Icon.Default
   * @section
   *
   * A trivial subclass of `Icon`, represents the icon to use in `Marker`s when
   * no icon is specified. Points to the blue marker image distributed with Leaflet
   * releases.
   *
   * In order to customize the default icon, just change the properties of `L.Icon.Default.prototype.options`
   * (which is a set of `Icon options`).
   *
   * If you want to _completely_ replace the default icon, override the
   * `L.Marker.prototype.options.icon` with your own icon instead.
   */ var IconDefault = Icon.extend({
        options: {
            iconUrl: "marker-icon.png",
            iconRetinaUrl: "marker-icon-2x.png",
            shadowUrl: "marker-shadow.png",
            iconSize: [
                25,
                41
            ],
            iconAnchor: [
                12,
                41
            ],
            popupAnchor: [
                1,
                -34
            ],
            tooltipAnchor: [
                16,
                -28
            ],
            shadowSize: [
                41,
                41
            ]
        },
        _getIconUrl: function(name) {
            if (typeof IconDefault.imagePath !== "string") IconDefault.imagePath = this._detectIconPath();
            // @option imagePath: String
            // `Icon.Default` will try to auto-detect the location of the
            // blue icon images. If you are placing these images in a non-standard
            // way, set this option to point to the right path.
            return (this.options.imagePath || IconDefault.imagePath) + Icon.prototype._getIconUrl.call(this, name);
        },
        _stripUrl: function(path) {
            var strip = function(str, re, idx) {
                var match = re.exec(str);
                return match && match[idx];
            };
            path = strip(path, /^url\((['"])?(.+)\1\)$/, 2);
            return path && strip(path, /^(.*)marker-icon\.png$/, 1);
        },
        _detectIconPath: function() {
            var el = create$1("div", "leaflet-default-icon-path", document.body);
            var path = getStyle(el, "background-image") || getStyle(el, "backgroundImage"); // IE8
            document.body.removeChild(el);
            path = this._stripUrl(path);
            if (path) return path;
            var link = document.querySelector('link[href$="leaflet.css"]');
            if (!link) return "";
            return link.href.substring(0, link.href.length - 11 - 1);
        }
    });
    /*
   * L.Handler.MarkerDrag is used internally by L.Marker to make the markers draggable.
   */ /* @namespace Marker
   * @section Interaction handlers
   *
   * Interaction handlers are properties of a marker instance that allow you to control interaction behavior in runtime, enabling or disabling certain features such as dragging (see `Handler` methods). Example:
   *
   * ```js
   * marker.dragging.disable();
   * ```
   *
   * @property dragging: Handler
   * Marker dragging handler (by both mouse and touch). Only valid when the marker is on the map (Otherwise set [`marker.options.draggable`](#marker-draggable)).
   */ var MarkerDrag = Handler.extend({
        initialize: function(marker) {
            this._marker = marker;
        },
        addHooks: function() {
            var icon = this._marker._icon;
            if (!this._draggable) this._draggable = new Draggable(icon, icon, true);
            this._draggable.on({
                dragstart: this._onDragStart,
                predrag: this._onPreDrag,
                drag: this._onDrag,
                dragend: this._onDragEnd
            }, this).enable();
            addClass(icon, "leaflet-marker-draggable");
        },
        removeHooks: function() {
            this._draggable.off({
                dragstart: this._onDragStart,
                predrag: this._onPreDrag,
                drag: this._onDrag,
                dragend: this._onDragEnd
            }, this).disable();
            if (this._marker._icon) removeClass(this._marker._icon, "leaflet-marker-draggable");
        },
        moved: function() {
            return this._draggable && this._draggable._moved;
        },
        _adjustPan: function(e) {
            var marker = this._marker, map = marker._map, speed = this._marker.options.autoPanSpeed, padding = this._marker.options.autoPanPadding, iconPos = getPosition(marker._icon), bounds = map.getPixelBounds(), origin = map.getPixelOrigin();
            var panBounds = toBounds(bounds.min._subtract(origin).add(padding), bounds.max._subtract(origin).subtract(padding));
            if (!panBounds.contains(iconPos)) {
                // Compute incremental movement
                var movement = toPoint((Math.max(panBounds.max.x, iconPos.x) - panBounds.max.x) / (bounds.max.x - panBounds.max.x) - (Math.min(panBounds.min.x, iconPos.x) - panBounds.min.x) / (bounds.min.x - panBounds.min.x), (Math.max(panBounds.max.y, iconPos.y) - panBounds.max.y) / (bounds.max.y - panBounds.max.y) - (Math.min(panBounds.min.y, iconPos.y) - panBounds.min.y) / (bounds.min.y - panBounds.min.y)).multiplyBy(speed);
                map.panBy(movement, {
                    animate: false
                });
                this._draggable._newPos._add(movement);
                this._draggable._startPos._add(movement);
                setPosition(marker._icon, this._draggable._newPos);
                this._onDrag(e);
                this._panRequest = requestAnimFrame(this._adjustPan.bind(this, e));
            }
        },
        _onDragStart: function() {
            // @section Dragging events
            // @event dragstart: Event
            // Fired when the user starts dragging the marker.
            // @event movestart: Event
            // Fired when the marker starts moving (because of dragging).
            this._oldLatLng = this._marker.getLatLng();
            // When using ES6 imports it could not be set when `Popup` was not imported as well
            this._marker.closePopup && this._marker.closePopup();
            this._marker.fire("movestart").fire("dragstart");
        },
        _onPreDrag: function(e) {
            if (this._marker.options.autoPan) {
                cancelAnimFrame(this._panRequest);
                this._panRequest = requestAnimFrame(this._adjustPan.bind(this, e));
            }
        },
        _onDrag: function(e) {
            var marker = this._marker, shadow = marker._shadow, iconPos = getPosition(marker._icon), latlng = marker._map.layerPointToLatLng(iconPos);
            // update shadow position
            if (shadow) setPosition(shadow, iconPos);
            marker._latlng = latlng;
            e.latlng = latlng;
            e.oldLatLng = this._oldLatLng;
            // @event drag: Event
            // Fired repeatedly while the user drags the marker.
            marker.fire("move", e).fire("drag", e);
        },
        _onDragEnd: function(e) {
            // @event dragend: DragEndEvent
            // Fired when the user stops dragging the marker.
            cancelAnimFrame(this._panRequest);
            // @event moveend: Event
            // Fired when the marker stops moving (because of dragging).
            delete this._oldLatLng;
            this._marker.fire("moveend").fire("dragend", e);
        }
    });
    /*
   * @class Marker
   * @inherits Interactive layer
   * @aka L.Marker
   * L.Marker is used to display clickable/draggable icons on the map. Extends `Layer`.
   *
   * @example
   *
   * ```js
   * L.marker([50.5, 30.5]).addTo(map);
   * ```
   */ var Marker = Layer.extend({
        // @section
        // @aka Marker options
        options: {
            // @option icon: Icon = *
            // Icon instance to use for rendering the marker.
            // See [Icon documentation](#L.Icon) for details on how to customize the marker icon.
            // If not specified, a common instance of `L.Icon.Default` is used.
            icon: new IconDefault(),
            // Option inherited from "Interactive layer" abstract class
            interactive: true,
            // @option keyboard: Boolean = true
            // Whether the marker can be tabbed to with a keyboard and clicked by pressing enter.
            keyboard: true,
            // @option title: String = ''
            // Text for the browser tooltip that appear on marker hover (no tooltip by default).
            // [Useful for accessibility](https://leafletjs.com/examples/accessibility/#markers-must-be-labelled).
            title: "",
            // @option alt: String = 'Marker'
            // Text for the `alt` attribute of the icon image.
            // [Useful for accessibility](https://leafletjs.com/examples/accessibility/#markers-must-be-labelled).
            alt: "Marker",
            // @option zIndexOffset: Number = 0
            // By default, marker images zIndex is set automatically based on its latitude. Use this option if you want to put the marker on top of all others (or below), specifying a high value like `1000` (or high negative value, respectively).
            zIndexOffset: 0,
            // @option opacity: Number = 1.0
            // The opacity of the marker.
            opacity: 1,
            // @option riseOnHover: Boolean = false
            // If `true`, the marker will get on top of others when you hover the mouse over it.
            riseOnHover: false,
            // @option riseOffset: Number = 250
            // The z-index offset used for the `riseOnHover` feature.
            riseOffset: 250,
            // @option pane: String = 'markerPane'
            // `Map pane` where the markers icon will be added.
            pane: "markerPane",
            // @option shadowPane: String = 'shadowPane'
            // `Map pane` where the markers shadow will be added.
            shadowPane: "shadowPane",
            // @option bubblingMouseEvents: Boolean = false
            // When `true`, a mouse event on this marker will trigger the same event on the map
            // (unless [`L.DomEvent.stopPropagation`](#domevent-stoppropagation) is used).
            bubblingMouseEvents: false,
            // @option autoPanOnFocus: Boolean = true
            // When `true`, the map will pan whenever the marker is focused (via
            // e.g. pressing `tab` on the keyboard) to ensure the marker is
            // visible within the map's bounds
            autoPanOnFocus: true,
            // @section Draggable marker options
            // @option draggable: Boolean = false
            // Whether the marker is draggable with mouse/touch or not.
            draggable: false,
            // @option autoPan: Boolean = false
            // Whether to pan the map when dragging this marker near its edge or not.
            autoPan: false,
            // @option autoPanPadding: Point = Point(50, 50)
            // Distance (in pixels to the left/right and to the top/bottom) of the
            // map edge to start panning the map.
            autoPanPadding: [
                50,
                50
            ],
            // @option autoPanSpeed: Number = 10
            // Number of pixels the map should pan by.
            autoPanSpeed: 10
        },
        /* @section
  	 *
  	 * In addition to [shared layer methods](#Layer) like `addTo()` and `remove()` and [popup methods](#Popup) like bindPopup() you can also use the following methods:
  	 */ initialize: function(latlng, options) {
            setOptions(this, options);
            this._latlng = toLatLng(latlng);
        },
        onAdd: function(map) {
            this._zoomAnimated = this._zoomAnimated && map.options.markerZoomAnimation;
            if (this._zoomAnimated) map.on("zoomanim", this._animateZoom, this);
            this._initIcon();
            this.update();
        },
        onRemove: function(map) {
            if (this.dragging && this.dragging.enabled()) {
                this.options.draggable = true;
                this.dragging.removeHooks();
            }
            delete this.dragging;
            if (this._zoomAnimated) map.off("zoomanim", this._animateZoom, this);
            this._removeIcon();
            this._removeShadow();
        },
        getEvents: function() {
            return {
                zoom: this.update,
                viewreset: this.update
            };
        },
        // @method getLatLng: LatLng
        // Returns the current geographical position of the marker.
        getLatLng: function() {
            return this._latlng;
        },
        // @method setLatLng(latlng: LatLng): this
        // Changes the marker position to the given point.
        setLatLng: function(latlng) {
            var oldLatLng = this._latlng;
            this._latlng = toLatLng(latlng);
            this.update();
            // @event move: Event
            // Fired when the marker is moved via [`setLatLng`](#marker-setlatlng) or by [dragging](#marker-dragging). Old and new coordinates are included in event arguments as `oldLatLng`, `latlng`.
            return this.fire("move", {
                oldLatLng: oldLatLng,
                latlng: this._latlng
            });
        },
        // @method setZIndexOffset(offset: Number): this
        // Changes the [zIndex offset](#marker-zindexoffset) of the marker.
        setZIndexOffset: function(offset) {
            this.options.zIndexOffset = offset;
            return this.update();
        },
        // @method getIcon: Icon
        // Returns the current icon used by the marker
        getIcon: function() {
            return this.options.icon;
        },
        // @method setIcon(icon: Icon): this
        // Changes the marker icon.
        setIcon: function(icon) {
            this.options.icon = icon;
            if (this._map) {
                this._initIcon();
                this.update();
            }
            if (this._popup) this.bindPopup(this._popup, this._popup.options);
            return this;
        },
        getElement: function() {
            return this._icon;
        },
        update: function() {
            if (this._icon && this._map) {
                var pos = this._map.latLngToLayerPoint(this._latlng).round();
                this._setPos(pos);
            }
            return this;
        },
        _initIcon: function() {
            var options = this.options, classToAdd = "leaflet-zoom-" + (this._zoomAnimated ? "animated" : "hide");
            var icon = options.icon.createIcon(this._icon), addIcon = false;
            // if we're not reusing the icon, remove the old one and init new one
            if (icon !== this._icon) {
                if (this._icon) this._removeIcon();
                addIcon = true;
                if (options.title) icon.title = options.title;
                if (icon.tagName === "IMG") icon.alt = options.alt || "";
            }
            addClass(icon, classToAdd);
            if (options.keyboard) {
                icon.tabIndex = "0";
                icon.setAttribute("role", "button");
            }
            this._icon = icon;
            if (options.riseOnHover) this.on({
                mouseover: this._bringToFront,
                mouseout: this._resetZIndex
            });
            if (this.options.autoPanOnFocus) on(icon, "focus", this._panOnFocus, this);
            var newShadow = options.icon.createShadow(this._shadow), addShadow = false;
            if (newShadow !== this._shadow) {
                this._removeShadow();
                addShadow = true;
            }
            if (newShadow) {
                addClass(newShadow, classToAdd);
                newShadow.alt = "";
            }
            this._shadow = newShadow;
            if (options.opacity < 1) this._updateOpacity();
            if (addIcon) this.getPane().appendChild(this._icon);
            this._initInteraction();
            if (newShadow && addShadow) this.getPane(options.shadowPane).appendChild(this._shadow);
        },
        _removeIcon: function() {
            if (this.options.riseOnHover) this.off({
                mouseover: this._bringToFront,
                mouseout: this._resetZIndex
            });
            if (this.options.autoPanOnFocus) off(this._icon, "focus", this._panOnFocus, this);
            remove(this._icon);
            this.removeInteractiveTarget(this._icon);
            this._icon = null;
        },
        _removeShadow: function() {
            if (this._shadow) remove(this._shadow);
            this._shadow = null;
        },
        _setPos: function(pos) {
            if (this._icon) setPosition(this._icon, pos);
            if (this._shadow) setPosition(this._shadow, pos);
            this._zIndex = pos.y + this.options.zIndexOffset;
            this._resetZIndex();
        },
        _updateZIndex: function(offset) {
            if (this._icon) this._icon.style.zIndex = this._zIndex + offset;
        },
        _animateZoom: function(opt) {
            var pos = this._map._latLngToNewLayerPoint(this._latlng, opt.zoom, opt.center).round();
            this._setPos(pos);
        },
        _initInteraction: function() {
            if (!this.options.interactive) return;
            addClass(this._icon, "leaflet-interactive");
            this.addInteractiveTarget(this._icon);
            if (MarkerDrag) {
                var draggable = this.options.draggable;
                if (this.dragging) {
                    draggable = this.dragging.enabled();
                    this.dragging.disable();
                }
                this.dragging = new MarkerDrag(this);
                if (draggable) this.dragging.enable();
            }
        },
        // @method setOpacity(opacity: Number): this
        // Changes the opacity of the marker.
        setOpacity: function(opacity) {
            this.options.opacity = opacity;
            if (this._map) this._updateOpacity();
            return this;
        },
        _updateOpacity: function() {
            var opacity = this.options.opacity;
            if (this._icon) setOpacity(this._icon, opacity);
            if (this._shadow) setOpacity(this._shadow, opacity);
        },
        _bringToFront: function() {
            this._updateZIndex(this.options.riseOffset);
        },
        _resetZIndex: function() {
            this._updateZIndex(0);
        },
        _panOnFocus: function() {
            var map = this._map;
            if (!map) return;
            var iconOpts = this.options.icon.options;
            var size = iconOpts.iconSize ? toPoint(iconOpts.iconSize) : toPoint(0, 0);
            var anchor = iconOpts.iconAnchor ? toPoint(iconOpts.iconAnchor) : toPoint(0, 0);
            map.panInside(this._latlng, {
                paddingTopLeft: anchor,
                paddingBottomRight: size.subtract(anchor)
            });
        },
        _getPopupAnchor: function() {
            return this.options.icon.options.popupAnchor;
        },
        _getTooltipAnchor: function() {
            return this.options.icon.options.tooltipAnchor;
        }
    });
    // factory L.marker(latlng: LatLng, options? : Marker options)
    // @factory L.marker(latlng: LatLng, options? : Marker options)
    // Instantiates a Marker object given a geographical point and optionally an options object.
    function marker(latlng, options) {
        return new Marker(latlng, options);
    }
    /*
   * @class Path
   * @aka L.Path
   * @inherits Interactive layer
   *
   * An abstract class that contains options and constants shared between vector
   * overlays (Polygon, Polyline, Circle). Do not use it directly. Extends `Layer`.
   */ var Path = Layer.extend({
        // @section
        // @aka Path options
        options: {
            // @option stroke: Boolean = true
            // Whether to draw stroke along the path. Set it to `false` to disable borders on polygons or circles.
            stroke: true,
            // @option color: String = '#3388ff'
            // Stroke color
            color: "#3388ff",
            // @option weight: Number = 3
            // Stroke width in pixels
            weight: 3,
            // @option opacity: Number = 1.0
            // Stroke opacity
            opacity: 1,
            // @option lineCap: String= 'round'
            // A string that defines [shape to be used at the end](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-linecap) of the stroke.
            lineCap: "round",
            // @option lineJoin: String = 'round'
            // A string that defines [shape to be used at the corners](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-linejoin) of the stroke.
            lineJoin: "round",
            // @option dashArray: String = null
            // A string that defines the stroke [dash pattern](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-dasharray). Doesn't work on `Canvas`-powered layers in [some old browsers](https://developer.mozilla.org/docs/Web/API/CanvasRenderingContext2D/setLineDash#Browser_compatibility).
            dashArray: null,
            // @option dashOffset: String = null
            // A string that defines the [distance into the dash pattern to start the dash](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-dashoffset). Doesn't work on `Canvas`-powered layers in [some old browsers](https://developer.mozilla.org/docs/Web/API/CanvasRenderingContext2D/setLineDash#Browser_compatibility).
            dashOffset: null,
            // @option fill: Boolean = depends
            // Whether to fill the path with color. Set it to `false` to disable filling on polygons or circles.
            fill: false,
            // @option fillColor: String = *
            // Fill color. Defaults to the value of the [`color`](#path-color) option
            fillColor: null,
            // @option fillOpacity: Number = 0.2
            // Fill opacity.
            fillOpacity: 0.2,
            // @option fillRule: String = 'evenodd'
            // A string that defines [how the inside of a shape](https://developer.mozilla.org/docs/Web/SVG/Attribute/fill-rule) is determined.
            fillRule: "evenodd",
            // className: '',
            // Option inherited from "Interactive layer" abstract class
            interactive: true,
            // @option bubblingMouseEvents: Boolean = true
            // When `true`, a mouse event on this path will trigger the same event on the map
            // (unless [`L.DomEvent.stopPropagation`](#domevent-stoppropagation) is used).
            bubblingMouseEvents: true
        },
        beforeAdd: function(map) {
            // Renderer is set here because we need to call renderer.getEvents
            // before this.getEvents.
            this._renderer = map.getRenderer(this);
        },
        onAdd: function() {
            this._renderer._initPath(this);
            this._reset();
            this._renderer._addPath(this);
        },
        onRemove: function() {
            this._renderer._removePath(this);
        },
        // @method redraw(): this
        // Redraws the layer. Sometimes useful after you changed the coordinates that the path uses.
        redraw: function() {
            if (this._map) this._renderer._updatePath(this);
            return this;
        },
        // @method setStyle(style: Path options): this
        // Changes the appearance of a Path based on the options in the `Path options` object.
        setStyle: function(style) {
            setOptions(this, style);
            if (this._renderer) {
                this._renderer._updateStyle(this);
                if (this.options.stroke && style && Object.prototype.hasOwnProperty.call(style, "weight")) this._updateBounds();
            }
            return this;
        },
        // @method bringToFront(): this
        // Brings the layer to the top of all path layers.
        bringToFront: function() {
            if (this._renderer) this._renderer._bringToFront(this);
            return this;
        },
        // @method bringToBack(): this
        // Brings the layer to the bottom of all path layers.
        bringToBack: function() {
            if (this._renderer) this._renderer._bringToBack(this);
            return this;
        },
        getElement: function() {
            return this._path;
        },
        _reset: function() {
            // defined in child classes
            this._project();
            this._update();
        },
        _clickTolerance: function() {
            // used when doing hit detection for Canvas layers
            return (this.options.stroke ? this.options.weight / 2 : 0) + (this._renderer.options.tolerance || 0);
        }
    });
    /*
   * @class CircleMarker
   * @aka L.CircleMarker
   * @inherits Path
   *
   * A circle of a fixed size with radius specified in pixels. Extends `Path`.
   */ var CircleMarker = Path.extend({
        // @section
        // @aka CircleMarker options
        options: {
            fill: true,
            // @option radius: Number = 10
            // Radius of the circle marker, in pixels
            radius: 10
        },
        initialize: function(latlng, options) {
            setOptions(this, options);
            this._latlng = toLatLng(latlng);
            this._radius = this.options.radius;
        },
        // @method setLatLng(latLng: LatLng): this
        // Sets the position of a circle marker to a new location.
        setLatLng: function(latlng) {
            var oldLatLng = this._latlng;
            this._latlng = toLatLng(latlng);
            this.redraw();
            // @event move: Event
            // Fired when the marker is moved via [`setLatLng`](#circlemarker-setlatlng). Old and new coordinates are included in event arguments as `oldLatLng`, `latlng`.
            return this.fire("move", {
                oldLatLng: oldLatLng,
                latlng: this._latlng
            });
        },
        // @method getLatLng(): LatLng
        // Returns the current geographical position of the circle marker
        getLatLng: function() {
            return this._latlng;
        },
        // @method setRadius(radius: Number): this
        // Sets the radius of a circle marker. Units are in pixels.
        setRadius: function(radius) {
            this.options.radius = this._radius = radius;
            return this.redraw();
        },
        // @method getRadius(): Number
        // Returns the current radius of the circle
        getRadius: function() {
            return this._radius;
        },
        setStyle: function(options) {
            var radius = options && options.radius || this._radius;
            Path.prototype.setStyle.call(this, options);
            this.setRadius(radius);
            return this;
        },
        _project: function() {
            this._point = this._map.latLngToLayerPoint(this._latlng);
            this._updateBounds();
        },
        _updateBounds: function() {
            var r = this._radius, r2 = this._radiusY || r, w = this._clickTolerance(), p = [
                r + w,
                r2 + w
            ];
            this._pxBounds = new Bounds(this._point.subtract(p), this._point.add(p));
        },
        _update: function() {
            if (this._map) this._updatePath();
        },
        _updatePath: function() {
            this._renderer._updateCircle(this);
        },
        _empty: function() {
            return this._radius && !this._renderer._bounds.intersects(this._pxBounds);
        },
        // Needed by the `Canvas` renderer for interactivity
        _containsPoint: function(p) {
            return p.distanceTo(this._point) <= this._radius + this._clickTolerance();
        }
    });
    // @factory L.circleMarker(latlng: LatLng, options?: CircleMarker options)
    // Instantiates a circle marker object given a geographical point, and an optional options object.
    function circleMarker(latlng, options) {
        return new CircleMarker(latlng, options);
    }
    /*
   * @class Circle
   * @aka L.Circle
   * @inherits CircleMarker
   *
   * A class for drawing circle overlays on a map. Extends `CircleMarker`.
   *
   * It's an approximation and starts to diverge from a real circle closer to poles (due to projection distortion).
   *
   * @example
   *
   * ```js
   * L.circle([50.5, 30.5], {radius: 200}).addTo(map);
   * ```
   */ var Circle = CircleMarker.extend({
        initialize: function(latlng, options, legacyOptions) {
            if (typeof options === "number") // Backwards compatibility with 0.7.x factory (latlng, radius, options?)
            options = extend({}, legacyOptions, {
                radius: options
            });
            setOptions(this, options);
            this._latlng = toLatLng(latlng);
            if (isNaN(this.options.radius)) throw new Error("Circle radius cannot be NaN");
            // @section
            // @aka Circle options
            // @option radius: Number; Radius of the circle, in meters.
            this._mRadius = this.options.radius;
        },
        // @method setRadius(radius: Number): this
        // Sets the radius of a circle. Units are in meters.
        setRadius: function(radius) {
            this._mRadius = radius;
            return this.redraw();
        },
        // @method getRadius(): Number
        // Returns the current radius of a circle. Units are in meters.
        getRadius: function() {
            return this._mRadius;
        },
        // @method getBounds(): LatLngBounds
        // Returns the `LatLngBounds` of the path.
        getBounds: function() {
            var half = [
                this._radius,
                this._radiusY || this._radius
            ];
            return new LatLngBounds(this._map.layerPointToLatLng(this._point.subtract(half)), this._map.layerPointToLatLng(this._point.add(half)));
        },
        setStyle: Path.prototype.setStyle,
        _project: function() {
            var lng = this._latlng.lng, lat = this._latlng.lat, map = this._map, crs = map.options.crs;
            if (crs.distance === Earth.distance) {
                var d = Math.PI / 180, latR = this._mRadius / Earth.R / d, top = map.project([
                    lat + latR,
                    lng
                ]), bottom = map.project([
                    lat - latR,
                    lng
                ]), p = top.add(bottom).divideBy(2), lat2 = map.unproject(p).lat, lngR = Math.acos((Math.cos(latR * d) - Math.sin(lat * d) * Math.sin(lat2 * d)) / (Math.cos(lat * d) * Math.cos(lat2 * d))) / d;
                if (isNaN(lngR) || lngR === 0) lngR = latR / Math.cos(Math.PI / 180 * lat); // Fallback for edge case, #2425
                this._point = p.subtract(map.getPixelOrigin());
                this._radius = isNaN(lngR) ? 0 : p.x - map.project([
                    lat2,
                    lng - lngR
                ]).x;
                this._radiusY = p.y - top.y;
            } else {
                var latlng2 = crs.unproject(crs.project(this._latlng).subtract([
                    this._mRadius,
                    0
                ]));
                this._point = map.latLngToLayerPoint(this._latlng);
                this._radius = this._point.x - map.latLngToLayerPoint(latlng2).x;
            }
            this._updateBounds();
        }
    });
    // @factory L.circle(latlng: LatLng, options?: Circle options)
    // Instantiates a circle object given a geographical point, and an options object
    // which contains the circle radius.
    // @alternative
    // @factory L.circle(latlng: LatLng, radius: Number, options?: Circle options)
    // Obsolete way of instantiating a circle, for compatibility with 0.7.x code.
    // Do not use in new applications or plugins.
    function circle(latlng, options, legacyOptions) {
        return new Circle(latlng, options, legacyOptions);
    }
    /*
   * @class Polyline
   * @aka L.Polyline
   * @inherits Path
   *
   * A class for drawing polyline overlays on a map. Extends `Path`.
   *
   * @example
   *
   * ```js
   * // create a red polyline from an array of LatLng points
   * var latlngs = [
   * 	[45.51, -122.68],
   * 	[37.77, -122.43],
   * 	[34.04, -118.2]
   * ];
   *
   * var polyline = L.polyline(latlngs, {color: 'red'}).addTo(map);
   *
   * // zoom the map to the polyline
   * map.fitBounds(polyline.getBounds());
   * ```
   *
   * You can also pass a multi-dimensional array to represent a `MultiPolyline` shape:
   *
   * ```js
   * // create a red polyline from an array of arrays of LatLng points
   * var latlngs = [
   * 	[[45.51, -122.68],
   * 	 [37.77, -122.43],
   * 	 [34.04, -118.2]],
   * 	[[40.78, -73.91],
   * 	 [41.83, -87.62],
   * 	 [32.76, -96.72]]
   * ];
   * ```
   */ var Polyline = Path.extend({
        // @section
        // @aka Polyline options
        options: {
            // @option smoothFactor: Number = 1.0
            // How much to simplify the polyline on each zoom level. More means
            // better performance and smoother look, and less means more accurate representation.
            smoothFactor: 1.0,
            // @option noClip: Boolean = false
            // Disable polyline clipping.
            noClip: false
        },
        initialize: function(latlngs, options) {
            setOptions(this, options);
            this._setLatLngs(latlngs);
        },
        // @method getLatLngs(): LatLng[]
        // Returns an array of the points in the path, or nested arrays of points in case of multi-polyline.
        getLatLngs: function() {
            return this._latlngs;
        },
        // @method setLatLngs(latlngs: LatLng[]): this
        // Replaces all the points in the polyline with the given array of geographical points.
        setLatLngs: function(latlngs) {
            this._setLatLngs(latlngs);
            return this.redraw();
        },
        // @method isEmpty(): Boolean
        // Returns `true` if the Polyline has no LatLngs.
        isEmpty: function() {
            return !this._latlngs.length;
        },
        // @method closestLayerPoint(p: Point): Point
        // Returns the point closest to `p` on the Polyline.
        closestLayerPoint: function(p) {
            var minDistance = Infinity, minPoint = null, closest = _sqClosestPointOnSegment, p1, p2;
            for(var j = 0, jLen = this._parts.length; j < jLen; j++){
                var points = this._parts[j];
                for(var i = 1, len = points.length; i < len; i++){
                    p1 = points[i - 1];
                    p2 = points[i];
                    var sqDist = closest(p, p1, p2, true);
                    if (sqDist < minDistance) {
                        minDistance = sqDist;
                        minPoint = closest(p, p1, p2);
                    }
                }
            }
            if (minPoint) minPoint.distance = Math.sqrt(minDistance);
            return minPoint;
        },
        // @method getCenter(): LatLng
        // Returns the center ([centroid](https://en.wikipedia.org/wiki/Centroid)) of the polyline.
        getCenter: function() {
            // throws error when not yet added to map as this center calculation requires projected coordinates
            if (!this._map) throw new Error("Must add layer to map before using getCenter()");
            return polylineCenter(this._defaultShape(), this._map.options.crs);
        },
        // @method getBounds(): LatLngBounds
        // Returns the `LatLngBounds` of the path.
        getBounds: function() {
            return this._bounds;
        },
        // @method addLatLng(latlng: LatLng, latlngs?: LatLng[]): this
        // Adds a given point to the polyline. By default, adds to the first ring of
        // the polyline in case of a multi-polyline, but can be overridden by passing
        // a specific ring as a LatLng array (that you can earlier access with [`getLatLngs`](#polyline-getlatlngs)).
        addLatLng: function(latlng, latlngs) {
            latlngs = latlngs || this._defaultShape();
            latlng = toLatLng(latlng);
            latlngs.push(latlng);
            this._bounds.extend(latlng);
            return this.redraw();
        },
        _setLatLngs: function(latlngs) {
            this._bounds = new LatLngBounds();
            this._latlngs = this._convertLatLngs(latlngs);
        },
        _defaultShape: function() {
            return isFlat(this._latlngs) ? this._latlngs : this._latlngs[0];
        },
        // recursively convert latlngs input into actual LatLng instances; calculate bounds along the way
        _convertLatLngs: function(latlngs) {
            var result = [], flat = isFlat(latlngs);
            for(var i = 0, len = latlngs.length; i < len; i++)if (flat) {
                result[i] = toLatLng(latlngs[i]);
                this._bounds.extend(result[i]);
            } else result[i] = this._convertLatLngs(latlngs[i]);
            return result;
        },
        _project: function() {
            var pxBounds = new Bounds();
            this._rings = [];
            this._projectLatlngs(this._latlngs, this._rings, pxBounds);
            if (this._bounds.isValid() && pxBounds.isValid()) {
                this._rawPxBounds = pxBounds;
                this._updateBounds();
            }
        },
        _updateBounds: function() {
            var w = this._clickTolerance(), p = new Point(w, w);
            if (!this._rawPxBounds) return;
            this._pxBounds = new Bounds([
                this._rawPxBounds.min.subtract(p),
                this._rawPxBounds.max.add(p)
            ]);
        },
        // recursively turns latlngs into a set of rings with projected coordinates
        _projectLatlngs: function(latlngs, result, projectedBounds) {
            var flat = latlngs[0] instanceof LatLng, len = latlngs.length, i, ring;
            if (flat) {
                ring = [];
                for(i = 0; i < len; i++){
                    ring[i] = this._map.latLngToLayerPoint(latlngs[i]);
                    projectedBounds.extend(ring[i]);
                }
                result.push(ring);
            } else for(i = 0; i < len; i++)this._projectLatlngs(latlngs[i], result, projectedBounds);
        },
        // clip polyline by renderer bounds so that we have less to render for performance
        _clipPoints: function() {
            var bounds = this._renderer._bounds;
            this._parts = [];
            if (!this._pxBounds || !this._pxBounds.intersects(bounds)) return;
            if (this.options.noClip) {
                this._parts = this._rings;
                return;
            }
            var parts = this._parts, i, j, k, len, len2, segment, points;
            for(i = 0, k = 0, len = this._rings.length; i < len; i++){
                points = this._rings[i];
                for(j = 0, len2 = points.length; j < len2 - 1; j++){
                    segment = clipSegment(points[j], points[j + 1], bounds, j, true);
                    if (!segment) continue;
                    parts[k] = parts[k] || [];
                    parts[k].push(segment[0]);
                    // if segment goes out of screen, or it's the last one, it's the end of the line part
                    if (segment[1] !== points[j + 1] || j === len2 - 2) {
                        parts[k].push(segment[1]);
                        k++;
                    }
                }
            }
        },
        // simplify each clipped part of the polyline for performance
        _simplifyPoints: function() {
            var parts = this._parts, tolerance = this.options.smoothFactor;
            for(var i = 0, len = parts.length; i < len; i++)parts[i] = simplify(parts[i], tolerance);
        },
        _update: function() {
            if (!this._map) return;
            this._clipPoints();
            this._simplifyPoints();
            this._updatePath();
        },
        _updatePath: function() {
            this._renderer._updatePoly(this);
        },
        // Needed by the `Canvas` renderer for interactivity
        _containsPoint: function(p, closed) {
            var i, j, k, len, len2, part, w = this._clickTolerance();
            if (!this._pxBounds || !this._pxBounds.contains(p)) return false;
            // hit detection for polylines
            for(i = 0, len = this._parts.length; i < len; i++){
                part = this._parts[i];
                for(j = 0, len2 = part.length, k = len2 - 1; j < len2; k = j++){
                    if (!closed && j === 0) continue;
                    if (pointToSegmentDistance(p, part[k], part[j]) <= w) return true;
                }
            }
            return false;
        }
    });
    // @factory L.polyline(latlngs: LatLng[], options?: Polyline options)
    // Instantiates a polyline object given an array of geographical points and
    // optionally an options object. You can create a `Polyline` object with
    // multiple separate lines (`MultiPolyline`) by passing an array of arrays
    // of geographic points.
    function polyline(latlngs, options) {
        return new Polyline(latlngs, options);
    }
    // Retrocompat. Allow plugins to support Leaflet versions before and after 1.1.
    Polyline._flat = _flat;
    /*
   * @class Polygon
   * @aka L.Polygon
   * @inherits Polyline
   *
   * A class for drawing polygon overlays on a map. Extends `Polyline`.
   *
   * Note that points you pass when creating a polygon shouldn't have an additional last point equal to the first one — it's better to filter out such points.
   *
   *
   * @example
   *
   * ```js
   * // create a red polygon from an array of LatLng points
   * var latlngs = [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]];
   *
   * var polygon = L.polygon(latlngs, {color: 'red'}).addTo(map);
   *
   * // zoom the map to the polygon
   * map.fitBounds(polygon.getBounds());
   * ```
   *
   * You can also pass an array of arrays of latlngs, with the first array representing the outer shape and the other arrays representing holes in the outer shape:
   *
   * ```js
   * var latlngs = [
   *   [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]], // outer ring
   *   [[37.29, -108.58],[40.71, -108.58],[40.71, -102.50],[37.29, -102.50]] // hole
   * ];
   * ```
   *
   * Additionally, you can pass a multi-dimensional array to represent a MultiPolygon shape.
   *
   * ```js
   * var latlngs = [
   *   [ // first polygon
   *     [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]], // outer ring
   *     [[37.29, -108.58],[40.71, -108.58],[40.71, -102.50],[37.29, -102.50]] // hole
   *   ],
   *   [ // second polygon
   *     [[41, -111.03],[45, -111.04],[45, -104.05],[41, -104.05]]
   *   ]
   * ];
   * ```
   */ var Polygon = Polyline.extend({
        options: {
            fill: true
        },
        isEmpty: function() {
            return !this._latlngs.length || !this._latlngs[0].length;
        },
        // @method getCenter(): LatLng
        // Returns the center ([centroid](http://en.wikipedia.org/wiki/Centroid)) of the Polygon.
        getCenter: function() {
            // throws error when not yet added to map as this center calculation requires projected coordinates
            if (!this._map) throw new Error("Must add layer to map before using getCenter()");
            return polygonCenter(this._defaultShape(), this._map.options.crs);
        },
        _convertLatLngs: function(latlngs) {
            var result = Polyline.prototype._convertLatLngs.call(this, latlngs), len = result.length;
            // remove last point if it equals first one
            if (len >= 2 && result[0] instanceof LatLng && result[0].equals(result[len - 1])) result.pop();
            return result;
        },
        _setLatLngs: function(latlngs) {
            Polyline.prototype._setLatLngs.call(this, latlngs);
            if (isFlat(this._latlngs)) this._latlngs = [
                this._latlngs
            ];
        },
        _defaultShape: function() {
            return isFlat(this._latlngs[0]) ? this._latlngs[0] : this._latlngs[0][0];
        },
        _clipPoints: function() {
            // polygons need a different clipping algorithm so we redefine that
            var bounds = this._renderer._bounds, w = this.options.weight, p = new Point(w, w);
            // increase clip padding by stroke width to avoid stroke on clip edges
            bounds = new Bounds(bounds.min.subtract(p), bounds.max.add(p));
            this._parts = [];
            if (!this._pxBounds || !this._pxBounds.intersects(bounds)) return;
            if (this.options.noClip) {
                this._parts = this._rings;
                return;
            }
            for(var i = 0, len = this._rings.length, clipped; i < len; i++){
                clipped = clipPolygon(this._rings[i], bounds, true);
                if (clipped.length) this._parts.push(clipped);
            }
        },
        _updatePath: function() {
            this._renderer._updatePoly(this, true);
        },
        // Needed by the `Canvas` renderer for interactivity
        _containsPoint: function(p) {
            var inside = false, part, p1, p2, i, j, k, len, len2;
            if (!this._pxBounds || !this._pxBounds.contains(p)) return false;
            // ray casting algorithm for detecting if point is in polygon
            for(i = 0, len = this._parts.length; i < len; i++){
                part = this._parts[i];
                for(j = 0, len2 = part.length, k = len2 - 1; j < len2; k = j++){
                    p1 = part[j];
                    p2 = part[k];
                    if (p1.y > p.y !== p2.y > p.y && p.x < (p2.x - p1.x) * (p.y - p1.y) / (p2.y - p1.y) + p1.x) inside = !inside;
                }
            }
            // also check if it's on polygon stroke
            return inside || Polyline.prototype._containsPoint.call(this, p, true);
        }
    });
    // @factory L.polygon(latlngs: LatLng[], options?: Polyline options)
    function polygon(latlngs, options) {
        return new Polygon(latlngs, options);
    }
    /*
   * @class GeoJSON
   * @aka L.GeoJSON
   * @inherits FeatureGroup
   *
   * Represents a GeoJSON object or an array of GeoJSON objects. Allows you to parse
   * GeoJSON data and display it on the map. Extends `FeatureGroup`.
   *
   * @example
   *
   * ```js
   * L.geoJSON(data, {
   * 	style: function (feature) {
   * 		return {color: feature.properties.color};
   * 	}
   * }).bindPopup(function (layer) {
   * 	return layer.feature.properties.description;
   * }).addTo(map);
   * ```
   */ var GeoJSON = FeatureGroup.extend({
        /* @section
  	 * @aka GeoJSON options
  	 *
  	 * @option pointToLayer: Function = *
  	 * A `Function` defining how GeoJSON points spawn Leaflet layers. It is internally
  	 * called when data is added, passing the GeoJSON point feature and its `LatLng`.
  	 * The default is to spawn a default `Marker`:
  	 * ```js
  	 * function(geoJsonPoint, latlng) {
  	 * 	return L.marker(latlng);
  	 * }
  	 * ```
  	 *
  	 * @option style: Function = *
  	 * A `Function` defining the `Path options` for styling GeoJSON lines and polygons,
  	 * called internally when data is added.
  	 * The default value is to not override any defaults:
  	 * ```js
  	 * function (geoJsonFeature) {
  	 * 	return {}
  	 * }
  	 * ```
  	 *
  	 * @option onEachFeature: Function = *
  	 * A `Function` that will be called once for each created `Feature`, after it has
  	 * been created and styled. Useful for attaching events and popups to features.
  	 * The default is to do nothing with the newly created layers:
  	 * ```js
  	 * function (feature, layer) {}
  	 * ```
  	 *
  	 * @option filter: Function = *
  	 * A `Function` that will be used to decide whether to include a feature or not.
  	 * The default is to include all features:
  	 * ```js
  	 * function (geoJsonFeature) {
  	 * 	return true;
  	 * }
  	 * ```
  	 * Note: dynamically changing the `filter` option will have effect only on newly
  	 * added data. It will _not_ re-evaluate already included features.
  	 *
  	 * @option coordsToLatLng: Function = *
  	 * A `Function` that will be used for converting GeoJSON coordinates to `LatLng`s.
  	 * The default is the `coordsToLatLng` static method.
  	 *
  	 * @option markersInheritOptions: Boolean = false
  	 * Whether default Markers for "Point" type Features inherit from group options.
  	 */ initialize: function(geojson, options) {
            setOptions(this, options);
            this._layers = {};
            if (geojson) this.addData(geojson);
        },
        // @method addData( <GeoJSON> data ): this
        // Adds a GeoJSON object to the layer.
        addData: function(geojson) {
            var features = isArray(geojson) ? geojson : geojson.features, i, len, feature;
            if (features) {
                for(i = 0, len = features.length; i < len; i++){
                    // only add this if geometry or geometries are set and not null
                    feature = features[i];
                    if (feature.geometries || feature.geometry || feature.features || feature.coordinates) this.addData(feature);
                }
                return this;
            }
            var options = this.options;
            if (options.filter && !options.filter(geojson)) return this;
            var layer = geometryToLayer(geojson, options);
            if (!layer) return this;
            layer.feature = asFeature(geojson);
            layer.defaultOptions = layer.options;
            this.resetStyle(layer);
            if (options.onEachFeature) options.onEachFeature(geojson, layer);
            return this.addLayer(layer);
        },
        // @method resetStyle( <Path> layer? ): this
        // Resets the given vector layer's style to the original GeoJSON style, useful for resetting style after hover events.
        // If `layer` is omitted, the style of all features in the current layer is reset.
        resetStyle: function(layer) {
            if (layer === undefined) return this.eachLayer(this.resetStyle, this);
            // reset any custom styles
            layer.options = extend({}, layer.defaultOptions);
            this._setLayerStyle(layer, this.options.style);
            return this;
        },
        // @method setStyle( <Function> style ): this
        // Changes styles of GeoJSON vector layers with the given style function.
        setStyle: function(style) {
            return this.eachLayer(function(layer) {
                this._setLayerStyle(layer, style);
            }, this);
        },
        _setLayerStyle: function(layer, style) {
            if (layer.setStyle) {
                if (typeof style === "function") style = style(layer.feature);
                layer.setStyle(style);
            }
        }
    });
    // @section
    // There are several static functions which can be called without instantiating L.GeoJSON:
    // @function geometryToLayer(featureData: Object, options?: GeoJSON options): Layer
    // Creates a `Layer` from a given GeoJSON feature. Can use a custom
    // [`pointToLayer`](#geojson-pointtolayer) and/or [`coordsToLatLng`](#geojson-coordstolatlng)
    // functions if provided as options.
    function geometryToLayer(geojson, options) {
        var geometry = geojson.type === "Feature" ? geojson.geometry : geojson, coords = geometry ? geometry.coordinates : null, layers = [], pointToLayer = options && options.pointToLayer, _coordsToLatLng = options && options.coordsToLatLng || coordsToLatLng, latlng, latlngs, i, len;
        if (!coords && !geometry) return null;
        switch(geometry.type){
            case "Point":
                latlng = _coordsToLatLng(coords);
                return _pointToLayer(pointToLayer, geojson, latlng, options);
            case "MultiPoint":
                for(i = 0, len = coords.length; i < len; i++){
                    latlng = _coordsToLatLng(coords[i]);
                    layers.push(_pointToLayer(pointToLayer, geojson, latlng, options));
                }
                return new FeatureGroup(layers);
            case "LineString":
            case "MultiLineString":
                latlngs = coordsToLatLngs(coords, geometry.type === "LineString" ? 0 : 1, _coordsToLatLng);
                return new Polyline(latlngs, options);
            case "Polygon":
            case "MultiPolygon":
                latlngs = coordsToLatLngs(coords, geometry.type === "Polygon" ? 1 : 2, _coordsToLatLng);
                return new Polygon(latlngs, options);
            case "GeometryCollection":
                for(i = 0, len = geometry.geometries.length; i < len; i++){
                    var geoLayer = geometryToLayer({
                        geometry: geometry.geometries[i],
                        type: "Feature",
                        properties: geojson.properties
                    }, options);
                    if (geoLayer) layers.push(geoLayer);
                }
                return new FeatureGroup(layers);
            case "FeatureCollection":
                for(i = 0, len = geometry.features.length; i < len; i++){
                    var featureLayer = geometryToLayer(geometry.features[i], options);
                    if (featureLayer) layers.push(featureLayer);
                }
                return new FeatureGroup(layers);
            default:
                throw new Error("Invalid GeoJSON object.");
        }
    }
    function _pointToLayer(pointToLayerFn, geojson, latlng, options) {
        return pointToLayerFn ? pointToLayerFn(geojson, latlng) : new Marker(latlng, options && options.markersInheritOptions && options);
    }
    // @function coordsToLatLng(coords: Array): LatLng
    // Creates a `LatLng` object from an array of 2 numbers (longitude, latitude)
    // or 3 numbers (longitude, latitude, altitude) used in GeoJSON for points.
    function coordsToLatLng(coords) {
        return new LatLng(coords[1], coords[0], coords[2]);
    }
    // @function coordsToLatLngs(coords: Array, levelsDeep?: Number, coordsToLatLng?: Function): Array
    // Creates a multidimensional array of `LatLng`s from a GeoJSON coordinates array.
    // `levelsDeep` specifies the nesting level (0 is for an array of points, 1 for an array of arrays of points, etc., 0 by default).
    // Can use a custom [`coordsToLatLng`](#geojson-coordstolatlng) function.
    function coordsToLatLngs(coords, levelsDeep, _coordsToLatLng) {
        var latlngs = [];
        for(var i = 0, len = coords.length, latlng; i < len; i++){
            latlng = levelsDeep ? coordsToLatLngs(coords[i], levelsDeep - 1, _coordsToLatLng) : (_coordsToLatLng || coordsToLatLng)(coords[i]);
            latlngs.push(latlng);
        }
        return latlngs;
    }
    // @function latLngToCoords(latlng: LatLng, precision?: Number|false): Array
    // Reverse of [`coordsToLatLng`](#geojson-coordstolatlng)
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function.
    function latLngToCoords(latlng, precision) {
        latlng = toLatLng(latlng);
        return latlng.alt !== undefined ? [
            formatNum(latlng.lng, precision),
            formatNum(latlng.lat, precision),
            formatNum(latlng.alt, precision)
        ] : [
            formatNum(latlng.lng, precision),
            formatNum(latlng.lat, precision)
        ];
    }
    // @function latLngsToCoords(latlngs: Array, levelsDeep?: Number, closed?: Boolean, precision?: Number|false): Array
    // Reverse of [`coordsToLatLngs`](#geojson-coordstolatlngs)
    // `closed` determines whether the first point should be appended to the end of the array to close the feature, only used when `levelsDeep` is 0. False by default.
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function.
    function latLngsToCoords(latlngs, levelsDeep, closed, precision) {
        var coords = [];
        for(var i = 0, len = latlngs.length; i < len; i++)// Check for flat arrays required to ensure unbalanced arrays are correctly converted in recursion
        coords.push(levelsDeep ? latLngsToCoords(latlngs[i], isFlat(latlngs[i]) ? 0 : levelsDeep - 1, closed, precision) : latLngToCoords(latlngs[i], precision));
        if (!levelsDeep && closed && coords.length > 0) coords.push(coords[0].slice());
        return coords;
    }
    function getFeature(layer, newGeometry) {
        return layer.feature ? extend({}, layer.feature, {
            geometry: newGeometry
        }) : asFeature(newGeometry);
    }
    // @function asFeature(geojson: Object): Object
    // Normalize GeoJSON geometries/features into GeoJSON features.
    function asFeature(geojson) {
        if (geojson.type === "Feature" || geojson.type === "FeatureCollection") return geojson;
        return {
            type: "Feature",
            properties: {},
            geometry: geojson
        };
    }
    var PointToGeoJSON = {
        toGeoJSON: function(precision) {
            return getFeature(this, {
                type: "Point",
                coordinates: latLngToCoords(this.getLatLng(), precision)
            });
        }
    };
    // @namespace Marker
    // @section Other methods
    // @method toGeoJSON(precision?: Number|false): Object
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
    // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the marker (as a GeoJSON `Point` Feature).
    Marker.include(PointToGeoJSON);
    // @namespace CircleMarker
    // @method toGeoJSON(precision?: Number|false): Object
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
    // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the circle marker (as a GeoJSON `Point` Feature).
    Circle.include(PointToGeoJSON);
    CircleMarker.include(PointToGeoJSON);
    // @namespace Polyline
    // @method toGeoJSON(precision?: Number|false): Object
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
    // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the polyline (as a GeoJSON `LineString` or `MultiLineString` Feature).
    Polyline.include({
        toGeoJSON: function(precision) {
            var multi = !isFlat(this._latlngs);
            var coords = latLngsToCoords(this._latlngs, multi ? 1 : 0, false, precision);
            return getFeature(this, {
                type: (multi ? "Multi" : "") + "LineString",
                coordinates: coords
            });
        }
    });
    // @namespace Polygon
    // @method toGeoJSON(precision?: Number|false): Object
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
    // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the polygon (as a GeoJSON `Polygon` or `MultiPolygon` Feature).
    Polygon.include({
        toGeoJSON: function(precision) {
            var holes = !isFlat(this._latlngs), multi = holes && !isFlat(this._latlngs[0]);
            var coords = latLngsToCoords(this._latlngs, multi ? 2 : holes ? 1 : 0, true, precision);
            if (!holes) coords = [
                coords
            ];
            return getFeature(this, {
                type: (multi ? "Multi" : "") + "Polygon",
                coordinates: coords
            });
        }
    });
    // @namespace LayerGroup
    LayerGroup.include({
        toMultiPoint: function(precision) {
            var coords = [];
            this.eachLayer(function(layer) {
                coords.push(layer.toGeoJSON(precision).geometry.coordinates);
            });
            return getFeature(this, {
                type: "MultiPoint",
                coordinates: coords
            });
        },
        // @method toGeoJSON(precision?: Number|false): Object
        // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
        // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the layer group (as a GeoJSON `FeatureCollection`, `GeometryCollection`, or `MultiPoint`).
        toGeoJSON: function(precision) {
            var type = this.feature && this.feature.geometry && this.feature.geometry.type;
            if (type === "MultiPoint") return this.toMultiPoint(precision);
            var isGeometryCollection = type === "GeometryCollection", jsons = [];
            this.eachLayer(function(layer) {
                if (layer.toGeoJSON) {
                    var json = layer.toGeoJSON(precision);
                    if (isGeometryCollection) jsons.push(json.geometry);
                    else {
                        var feature = asFeature(json);
                        // Squash nested feature collections
                        if (feature.type === "FeatureCollection") jsons.push.apply(jsons, feature.features);
                        else jsons.push(feature);
                    }
                }
            });
            if (isGeometryCollection) return getFeature(this, {
                geometries: jsons,
                type: "GeometryCollection"
            });
            return {
                type: "FeatureCollection",
                features: jsons
            };
        }
    });
    // @namespace GeoJSON
    // @factory L.geoJSON(geojson?: Object, options?: GeoJSON options)
    // Creates a GeoJSON layer. Optionally accepts an object in
    // [GeoJSON format](https://tools.ietf.org/html/rfc7946) to display on the map
    // (you can alternatively add it later with `addData` method) and an `options` object.
    function geoJSON(geojson, options) {
        return new GeoJSON(geojson, options);
    }
    // Backward compatibility.
    var geoJson = geoJSON;
    /*
   * @class ImageOverlay
   * @aka L.ImageOverlay
   * @inherits Interactive layer
   *
   * Used to load and display a single image over specific bounds of the map. Extends `Layer`.
   *
   * @example
   *
   * ```js
   * var imageUrl = 'https://maps.lib.utexas.edu/maps/historical/newark_nj_1922.jpg',
   * 	imageBounds = [[40.712216, -74.22655], [40.773941, -74.12544]];
   * L.imageOverlay(imageUrl, imageBounds).addTo(map);
   * ```
   */ var ImageOverlay = Layer.extend({
        // @section
        // @aka ImageOverlay options
        options: {
            // @option opacity: Number = 1.0
            // The opacity of the image overlay.
            opacity: 1,
            // @option alt: String = ''
            // Text for the `alt` attribute of the image (useful for accessibility).
            alt: "",
            // @option interactive: Boolean = false
            // If `true`, the image overlay will emit [mouse events](#interactive-layer) when clicked or hovered.
            interactive: false,
            // @option crossOrigin: Boolean|String = false
            // Whether the crossOrigin attribute will be added to the image.
            // If a String is provided, the image will have its crossOrigin attribute set to the String provided. This is needed if you want to access image pixel data.
            // Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
            crossOrigin: false,
            // @option errorOverlayUrl: String = ''
            // URL to the overlay image to show in place of the overlay that failed to load.
            errorOverlayUrl: "",
            // @option zIndex: Number = 1
            // The explicit [zIndex](https://developer.mozilla.org/docs/Web/CSS/CSS_Positioning/Understanding_z_index) of the overlay layer.
            zIndex: 1,
            // @option className: String = ''
            // A custom class name to assign to the image. Empty by default.
            className: ""
        },
        initialize: function(url, bounds, options) {
            this._url = url;
            this._bounds = toLatLngBounds(bounds);
            setOptions(this, options);
        },
        onAdd: function() {
            if (!this._image) {
                this._initImage();
                if (this.options.opacity < 1) this._updateOpacity();
            }
            if (this.options.interactive) {
                addClass(this._image, "leaflet-interactive");
                this.addInteractiveTarget(this._image);
            }
            this.getPane().appendChild(this._image);
            this._reset();
        },
        onRemove: function() {
            remove(this._image);
            if (this.options.interactive) this.removeInteractiveTarget(this._image);
        },
        // @method setOpacity(opacity: Number): this
        // Sets the opacity of the overlay.
        setOpacity: function(opacity) {
            this.options.opacity = opacity;
            if (this._image) this._updateOpacity();
            return this;
        },
        setStyle: function(styleOpts) {
            if (styleOpts.opacity) this.setOpacity(styleOpts.opacity);
            return this;
        },
        // @method bringToFront(): this
        // Brings the layer to the top of all overlays.
        bringToFront: function() {
            if (this._map) toFront(this._image);
            return this;
        },
        // @method bringToBack(): this
        // Brings the layer to the bottom of all overlays.
        bringToBack: function() {
            if (this._map) toBack(this._image);
            return this;
        },
        // @method setUrl(url: String): this
        // Changes the URL of the image.
        setUrl: function(url) {
            this._url = url;
            if (this._image) this._image.src = url;
            return this;
        },
        // @method setBounds(bounds: LatLngBounds): this
        // Update the bounds that this ImageOverlay covers
        setBounds: function(bounds) {
            this._bounds = toLatLngBounds(bounds);
            if (this._map) this._reset();
            return this;
        },
        getEvents: function() {
            var events = {
                zoom: this._reset,
                viewreset: this._reset
            };
            if (this._zoomAnimated) events.zoomanim = this._animateZoom;
            return events;
        },
        // @method setZIndex(value: Number): this
        // Changes the [zIndex](#imageoverlay-zindex) of the image overlay.
        setZIndex: function(value) {
            this.options.zIndex = value;
            this._updateZIndex();
            return this;
        },
        // @method getBounds(): LatLngBounds
        // Get the bounds that this ImageOverlay covers
        getBounds: function() {
            return this._bounds;
        },
        // @method getElement(): HTMLElement
        // Returns the instance of [`HTMLImageElement`](https://developer.mozilla.org/docs/Web/API/HTMLImageElement)
        // used by this overlay.
        getElement: function() {
            return this._image;
        },
        _initImage: function() {
            var wasElementSupplied = this._url.tagName === "IMG";
            var img = this._image = wasElementSupplied ? this._url : create$1("img");
            addClass(img, "leaflet-image-layer");
            if (this._zoomAnimated) addClass(img, "leaflet-zoom-animated");
            if (this.options.className) addClass(img, this.options.className);
            img.onselectstart = falseFn;
            img.onmousemove = falseFn;
            // @event load: Event
            // Fired when the ImageOverlay layer has loaded its image
            img.onload = bind(this.fire, this, "load");
            img.onerror = bind(this._overlayOnError, this, "error");
            if (this.options.crossOrigin || this.options.crossOrigin === "") img.crossOrigin = this.options.crossOrigin === true ? "" : this.options.crossOrigin;
            if (this.options.zIndex) this._updateZIndex();
            if (wasElementSupplied) {
                this._url = img.src;
                return;
            }
            img.src = this._url;
            img.alt = this.options.alt;
        },
        _animateZoom: function(e) {
            var scale = this._map.getZoomScale(e.zoom), offset = this._map._latLngBoundsToNewLayerBounds(this._bounds, e.zoom, e.center).min;
            setTransform(this._image, offset, scale);
        },
        _reset: function() {
            var image = this._image, bounds = new Bounds(this._map.latLngToLayerPoint(this._bounds.getNorthWest()), this._map.latLngToLayerPoint(this._bounds.getSouthEast())), size = bounds.getSize();
            setPosition(image, bounds.min);
            image.style.width = size.x + "px";
            image.style.height = size.y + "px";
        },
        _updateOpacity: function() {
            setOpacity(this._image, this.options.opacity);
        },
        _updateZIndex: function() {
            if (this._image && this.options.zIndex !== undefined && this.options.zIndex !== null) this._image.style.zIndex = this.options.zIndex;
        },
        _overlayOnError: function() {
            // @event error: Event
            // Fired when the ImageOverlay layer fails to load its image
            this.fire("error");
            var errorUrl = this.options.errorOverlayUrl;
            if (errorUrl && this._url !== errorUrl) {
                this._url = errorUrl;
                this._image.src = errorUrl;
            }
        },
        // @method getCenter(): LatLng
        // Returns the center of the ImageOverlay.
        getCenter: function() {
            return this._bounds.getCenter();
        }
    });
    // @factory L.imageOverlay(imageUrl: String, bounds: LatLngBounds, options?: ImageOverlay options)
    // Instantiates an image overlay object given the URL of the image and the
    // geographical bounds it is tied to.
    var imageOverlay = function(url, bounds, options) {
        return new ImageOverlay(url, bounds, options);
    };
    /*
   * @class VideoOverlay
   * @aka L.VideoOverlay
   * @inherits ImageOverlay
   *
   * Used to load and display a video player over specific bounds of the map. Extends `ImageOverlay`.
   *
   * A video overlay uses the [`<video>`](https://developer.mozilla.org/docs/Web/HTML/Element/video)
   * HTML5 element.
   *
   * @example
   *
   * ```js
   * var videoUrl = 'https://www.mapbox.com/bites/00188/patricia_nasa.webm',
   * 	videoBounds = [[ 32, -130], [ 13, -100]];
   * L.videoOverlay(videoUrl, videoBounds ).addTo(map);
   * ```
   */ var VideoOverlay = ImageOverlay.extend({
        // @section
        // @aka VideoOverlay options
        options: {
            // @option autoplay: Boolean = true
            // Whether the video starts playing automatically when loaded.
            // On some browsers autoplay will only work with `muted: true`
            autoplay: true,
            // @option loop: Boolean = true
            // Whether the video will loop back to the beginning when played.
            loop: true,
            // @option keepAspectRatio: Boolean = true
            // Whether the video will save aspect ratio after the projection.
            // Relevant for supported browsers. See [browser compatibility](https://developer.mozilla.org/en-US/docs/Web/CSS/object-fit)
            keepAspectRatio: true,
            // @option muted: Boolean = false
            // Whether the video starts on mute when loaded.
            muted: false,
            // @option playsInline: Boolean = true
            // Mobile browsers will play the video right where it is instead of open it up in fullscreen mode.
            playsInline: true
        },
        _initImage: function() {
            var wasElementSupplied = this._url.tagName === "VIDEO";
            var vid = this._image = wasElementSupplied ? this._url : create$1("video");
            addClass(vid, "leaflet-image-layer");
            if (this._zoomAnimated) addClass(vid, "leaflet-zoom-animated");
            if (this.options.className) addClass(vid, this.options.className);
            vid.onselectstart = falseFn;
            vid.onmousemove = falseFn;
            // @event load: Event
            // Fired when the video has finished loading the first frame
            vid.onloadeddata = bind(this.fire, this, "load");
            if (wasElementSupplied) {
                var sourceElements = vid.getElementsByTagName("source");
                var sources = [];
                for(var j = 0; j < sourceElements.length; j++)sources.push(sourceElements[j].src);
                this._url = sourceElements.length > 0 ? sources : [
                    vid.src
                ];
                return;
            }
            if (!isArray(this._url)) this._url = [
                this._url
            ];
            if (!this.options.keepAspectRatio && Object.prototype.hasOwnProperty.call(vid.style, "objectFit")) vid.style["objectFit"] = "fill";
            vid.autoplay = !!this.options.autoplay;
            vid.loop = !!this.options.loop;
            vid.muted = !!this.options.muted;
            vid.playsInline = !!this.options.playsInline;
            for(var i = 0; i < this._url.length; i++){
                var source = create$1("source");
                source.src = this._url[i];
                vid.appendChild(source);
            }
        }
    });
    // @factory L.videoOverlay(video: String|Array|HTMLVideoElement, bounds: LatLngBounds, options?: VideoOverlay options)
    // Instantiates an image overlay object given the URL of the video (or array of URLs, or even a video element) and the
    // geographical bounds it is tied to.
    function videoOverlay(video, bounds, options) {
        return new VideoOverlay(video, bounds, options);
    }
    /*
   * @class SVGOverlay
   * @aka L.SVGOverlay
   * @inherits ImageOverlay
   *
   * Used to load, display and provide DOM access to an SVG file over specific bounds of the map. Extends `ImageOverlay`.
   *
   * An SVG overlay uses the [`<svg>`](https://developer.mozilla.org/docs/Web/SVG/Element/svg) element.
   *
   * @example
   *
   * ```js
   * var svgElement = document.createElementNS("http://www.w3.org/2000/svg", "svg");
   * svgElement.setAttribute('xmlns', "http://www.w3.org/2000/svg");
   * svgElement.setAttribute('viewBox', "0 0 200 200");
   * svgElement.innerHTML = '<rect width="200" height="200"/><rect x="75" y="23" width="50" height="50" style="fill:red"/><rect x="75" y="123" width="50" height="50" style="fill:#0013ff"/>';
   * var svgElementBounds = [ [ 32, -130 ], [ 13, -100 ] ];
   * L.svgOverlay(svgElement, svgElementBounds).addTo(map);
   * ```
   */ var SVGOverlay = ImageOverlay.extend({
        _initImage: function() {
            var el = this._image = this._url;
            addClass(el, "leaflet-image-layer");
            if (this._zoomAnimated) addClass(el, "leaflet-zoom-animated");
            if (this.options.className) addClass(el, this.options.className);
            el.onselectstart = falseFn;
            el.onmousemove = falseFn;
        }
    });
    // @factory L.svgOverlay(svg: String|SVGElement, bounds: LatLngBounds, options?: SVGOverlay options)
    // Instantiates an image overlay object given an SVG element and the geographical bounds it is tied to.
    // A viewBox attribute is required on the SVG element to zoom in and out properly.
    function svgOverlay(el, bounds, options) {
        return new SVGOverlay(el, bounds, options);
    }
    /*
   * @class DivOverlay
   * @inherits Interactive layer
   * @aka L.DivOverlay
   * Base model for L.Popup and L.Tooltip. Inherit from it for custom overlays like plugins.
   */ // @namespace DivOverlay
    var DivOverlay = Layer.extend({
        // @section
        // @aka DivOverlay options
        options: {
            // @option interactive: Boolean = false
            // If true, the popup/tooltip will listen to the mouse events.
            interactive: false,
            // @option offset: Point = Point(0, 0)
            // The offset of the overlay position.
            offset: [
                0,
                0
            ],
            // @option className: String = ''
            // A custom CSS class name to assign to the overlay.
            className: "",
            // @option pane: String = undefined
            // `Map pane` where the overlay will be added.
            pane: undefined,
            // @option content: String|HTMLElement|Function = ''
            // Sets the HTML content of the overlay while initializing. If a function is passed the source layer will be
            // passed to the function. The function should return a `String` or `HTMLElement` to be used in the overlay.
            content: ""
        },
        initialize: function(options, source) {
            if (options && (options instanceof LatLng || isArray(options))) {
                this._latlng = toLatLng(options);
                setOptions(this, source);
            } else {
                setOptions(this, options);
                this._source = source;
            }
            if (this.options.content) this._content = this.options.content;
        },
        // @method openOn(map: Map): this
        // Adds the overlay to the map.
        // Alternative to `map.openPopup(popup)`/`.openTooltip(tooltip)`.
        openOn: function(map) {
            map = arguments.length ? map : this._source._map; // experimental, not the part of public api
            if (!map.hasLayer(this)) map.addLayer(this);
            return this;
        },
        // @method close(): this
        // Closes the overlay.
        // Alternative to `map.closePopup(popup)`/`.closeTooltip(tooltip)`
        // and `layer.closePopup()`/`.closeTooltip()`.
        close: function() {
            if (this._map) this._map.removeLayer(this);
            return this;
        },
        // @method toggle(layer?: Layer): this
        // Opens or closes the overlay bound to layer depending on its current state.
        // Argument may be omitted only for overlay bound to layer.
        // Alternative to `layer.togglePopup()`/`.toggleTooltip()`.
        toggle: function(layer) {
            if (this._map) this.close();
            else {
                if (arguments.length) this._source = layer;
                else layer = this._source;
                this._prepareOpen();
                // open the overlay on the map
                this.openOn(layer._map);
            }
            return this;
        },
        onAdd: function(map) {
            this._zoomAnimated = map._zoomAnimated;
            if (!this._container) this._initLayout();
            if (map._fadeAnimated) setOpacity(this._container, 0);
            clearTimeout(this._removeTimeout);
            this.getPane().appendChild(this._container);
            this.update();
            if (map._fadeAnimated) setOpacity(this._container, 1);
            this.bringToFront();
            if (this.options.interactive) {
                addClass(this._container, "leaflet-interactive");
                this.addInteractiveTarget(this._container);
            }
        },
        onRemove: function(map) {
            if (map._fadeAnimated) {
                setOpacity(this._container, 0);
                this._removeTimeout = setTimeout(bind(remove, undefined, this._container), 200);
            } else remove(this._container);
            if (this.options.interactive) {
                removeClass(this._container, "leaflet-interactive");
                this.removeInteractiveTarget(this._container);
            }
        },
        // @namespace DivOverlay
        // @method getLatLng: LatLng
        // Returns the geographical point of the overlay.
        getLatLng: function() {
            return this._latlng;
        },
        // @method setLatLng(latlng: LatLng): this
        // Sets the geographical point where the overlay will open.
        setLatLng: function(latlng) {
            this._latlng = toLatLng(latlng);
            if (this._map) {
                this._updatePosition();
                this._adjustPan();
            }
            return this;
        },
        // @method getContent: String|HTMLElement
        // Returns the content of the overlay.
        getContent: function() {
            return this._content;
        },
        // @method setContent(htmlContent: String|HTMLElement|Function): this
        // Sets the HTML content of the overlay. If a function is passed the source layer will be passed to the function.
        // The function should return a `String` or `HTMLElement` to be used in the overlay.
        setContent: function(content) {
            this._content = content;
            this.update();
            return this;
        },
        // @method getElement: String|HTMLElement
        // Returns the HTML container of the overlay.
        getElement: function() {
            return this._container;
        },
        // @method update: null
        // Updates the overlay content, layout and position. Useful for updating the overlay after something inside changed, e.g. image loaded.
        update: function() {
            if (!this._map) return;
            this._container.style.visibility = "hidden";
            this._updateContent();
            this._updateLayout();
            this._updatePosition();
            this._container.style.visibility = "";
            this._adjustPan();
        },
        getEvents: function() {
            var events = {
                zoom: this._updatePosition,
                viewreset: this._updatePosition
            };
            if (this._zoomAnimated) events.zoomanim = this._animateZoom;
            return events;
        },
        // @method isOpen: Boolean
        // Returns `true` when the overlay is visible on the map.
        isOpen: function() {
            return !!this._map && this._map.hasLayer(this);
        },
        // @method bringToFront: this
        // Brings this overlay in front of other overlays (in the same map pane).
        bringToFront: function() {
            if (this._map) toFront(this._container);
            return this;
        },
        // @method bringToBack: this
        // Brings this overlay to the back of other overlays (in the same map pane).
        bringToBack: function() {
            if (this._map) toBack(this._container);
            return this;
        },
        // prepare bound overlay to open: update latlng pos / content source (for FeatureGroup)
        _prepareOpen: function(latlng) {
            var source = this._source;
            if (!source._map) return false;
            if (source instanceof FeatureGroup) {
                source = null;
                var layers = this._source._layers;
                for(var id in layers)if (layers[id]._map) {
                    source = layers[id];
                    break;
                }
                if (!source) return false;
                 // Unable to get source layer.
                // set overlay source to this layer
                this._source = source;
            }
            if (!latlng) {
                if (source.getCenter) latlng = source.getCenter();
                else if (source.getLatLng) latlng = source.getLatLng();
                else if (source.getBounds) latlng = source.getBounds().getCenter();
                else throw new Error("Unable to get source layer LatLng.");
            }
            this.setLatLng(latlng);
            if (this._map) // update the overlay (content, layout, etc...)
            this.update();
            return true;
        },
        _updateContent: function() {
            if (!this._content) return;
            var node = this._contentNode;
            var content = typeof this._content === "function" ? this._content(this._source || this) : this._content;
            if (typeof content === "string") node.innerHTML = content;
            else {
                while(node.hasChildNodes())node.removeChild(node.firstChild);
                node.appendChild(content);
            }
            // @namespace DivOverlay
            // @section DivOverlay events
            // @event contentupdate: Event
            // Fired when the content of the overlay is updated
            this.fire("contentupdate");
        },
        _updatePosition: function() {
            if (!this._map) return;
            var pos = this._map.latLngToLayerPoint(this._latlng), offset = toPoint(this.options.offset), anchor = this._getAnchor();
            if (this._zoomAnimated) setPosition(this._container, pos.add(anchor));
            else offset = offset.add(pos).add(anchor);
            var bottom = this._containerBottom = -offset.y, left = this._containerLeft = -Math.round(this._containerWidth / 2) + offset.x;
            // bottom position the overlay in case the height of the overlay changes (images loading etc)
            this._container.style.bottom = bottom + "px";
            this._container.style.left = left + "px";
        },
        _getAnchor: function() {
            return [
                0,
                0
            ];
        }
    });
    Map.include({
        _initOverlay: function(OverlayClass, content, latlng, options) {
            var overlay = content;
            if (!(overlay instanceof OverlayClass)) overlay = new OverlayClass(options).setContent(content);
            if (latlng) overlay.setLatLng(latlng);
            return overlay;
        }
    });
    Layer.include({
        _initOverlay: function(OverlayClass, old, content, options) {
            var overlay = content;
            if (overlay instanceof OverlayClass) {
                setOptions(overlay, options);
                overlay._source = this;
            } else {
                overlay = old && !options ? old : new OverlayClass(options, this);
                overlay.setContent(content);
            }
            return overlay;
        }
    });
    /*
   * @class Popup
   * @inherits DivOverlay
   * @aka L.Popup
   * Used to open popups in certain places of the map. Use [Map.openPopup](#map-openpopup) to
   * open popups while making sure that only one popup is open at one time
   * (recommended for usability), or use [Map.addLayer](#map-addlayer) to open as many as you want.
   *
   * @example
   *
   * If you want to just bind a popup to marker click and then open it, it's really easy:
   *
   * ```js
   * marker.bindPopup(popupContent).openPopup();
   * ```
   * Path overlays like polylines also have a `bindPopup` method.
   *
   * A popup can be also standalone:
   *
   * ```js
   * var popup = L.popup()
   * 	.setLatLng(latlng)
   * 	.setContent('<p>Hello world!<br />This is a nice popup.</p>')
   * 	.openOn(map);
   * ```
   * or
   * ```js
   * var popup = L.popup(latlng, {content: '<p>Hello world!<br />This is a nice popup.</p>')
   * 	.openOn(map);
   * ```
   */ // @namespace Popup
    var Popup = DivOverlay.extend({
        // @section
        // @aka Popup options
        options: {
            // @option pane: String = 'popupPane'
            // `Map pane` where the popup will be added.
            pane: "popupPane",
            // @option offset: Point = Point(0, 7)
            // The offset of the popup position.
            offset: [
                0,
                7
            ],
            // @option maxWidth: Number = 300
            // Max width of the popup, in pixels.
            maxWidth: 300,
            // @option minWidth: Number = 50
            // Min width of the popup, in pixels.
            minWidth: 50,
            // @option maxHeight: Number = null
            // If set, creates a scrollable container of the given height
            // inside a popup if its content exceeds it.
            // The scrollable container can be styled using the
            // `leaflet-popup-scrolled` CSS class selector.
            maxHeight: null,
            // @option autoPan: Boolean = true
            // Set it to `false` if you don't want the map to do panning animation
            // to fit the opened popup.
            autoPan: true,
            // @option autoPanPaddingTopLeft: Point = null
            // The margin between the popup and the top left corner of the map
            // view after autopanning was performed.
            autoPanPaddingTopLeft: null,
            // @option autoPanPaddingBottomRight: Point = null
            // The margin between the popup and the bottom right corner of the map
            // view after autopanning was performed.
            autoPanPaddingBottomRight: null,
            // @option autoPanPadding: Point = Point(5, 5)
            // Equivalent of setting both top left and bottom right autopan padding to the same value.
            autoPanPadding: [
                5,
                5
            ],
            // @option keepInView: Boolean = false
            // Set it to `true` if you want to prevent users from panning the popup
            // off of the screen while it is open.
            keepInView: false,
            // @option closeButton: Boolean = true
            // Controls the presence of a close button in the popup.
            closeButton: true,
            // @option autoClose: Boolean = true
            // Set it to `false` if you want to override the default behavior of
            // the popup closing when another popup is opened.
            autoClose: true,
            // @option closeOnEscapeKey: Boolean = true
            // Set it to `false` if you want to override the default behavior of
            // the ESC key for closing of the popup.
            closeOnEscapeKey: true,
            // @option closeOnClick: Boolean = *
            // Set it if you want to override the default behavior of the popup closing when user clicks
            // on the map. Defaults to the map's [`closePopupOnClick`](#map-closepopuponclick) option.
            // @option className: String = ''
            // A custom CSS class name to assign to the popup.
            className: ""
        },
        // @namespace Popup
        // @method openOn(map: Map): this
        // Alternative to `map.openPopup(popup)`.
        // Adds the popup to the map and closes the previous one.
        openOn: function(map) {
            map = arguments.length ? map : this._source._map; // experimental, not the part of public api
            if (!map.hasLayer(this) && map._popup && map._popup.options.autoClose) map.removeLayer(map._popup);
            map._popup = this;
            return DivOverlay.prototype.openOn.call(this, map);
        },
        onAdd: function(map) {
            DivOverlay.prototype.onAdd.call(this, map);
            // @namespace Map
            // @section Popup events
            // @event popupopen: PopupEvent
            // Fired when a popup is opened in the map
            map.fire("popupopen", {
                popup: this
            });
            if (this._source) {
                // @namespace Layer
                // @section Popup events
                // @event popupopen: PopupEvent
                // Fired when a popup bound to this layer is opened
                this._source.fire("popupopen", {
                    popup: this
                }, true);
                // For non-path layers, we toggle the popup when clicking
                // again the layer, so prevent the map to reopen it.
                if (!(this._source instanceof Path)) this._source.on("preclick", stopPropagation);
            }
        },
        onRemove: function(map) {
            DivOverlay.prototype.onRemove.call(this, map);
            // @namespace Map
            // @section Popup events
            // @event popupclose: PopupEvent
            // Fired when a popup in the map is closed
            map.fire("popupclose", {
                popup: this
            });
            if (this._source) {
                // @namespace Layer
                // @section Popup events
                // @event popupclose: PopupEvent
                // Fired when a popup bound to this layer is closed
                this._source.fire("popupclose", {
                    popup: this
                }, true);
                if (!(this._source instanceof Path)) this._source.off("preclick", stopPropagation);
            }
        },
        getEvents: function() {
            var events = DivOverlay.prototype.getEvents.call(this);
            if (this.options.closeOnClick !== undefined ? this.options.closeOnClick : this._map.options.closePopupOnClick) events.preclick = this.close;
            if (this.options.keepInView) events.moveend = this._adjustPan;
            return events;
        },
        _initLayout: function() {
            var prefix = "leaflet-popup", container = this._container = create$1("div", prefix + " " + (this.options.className || "") + " leaflet-zoom-animated");
            var wrapper = this._wrapper = create$1("div", prefix + "-content-wrapper", container);
            this._contentNode = create$1("div", prefix + "-content", wrapper);
            disableClickPropagation(container);
            disableScrollPropagation(this._contentNode);
            on(container, "contextmenu", stopPropagation);
            this._tipContainer = create$1("div", prefix + "-tip-container", container);
            this._tip = create$1("div", prefix + "-tip", this._tipContainer);
            if (this.options.closeButton) {
                var closeButton = this._closeButton = create$1("a", prefix + "-close-button", container);
                closeButton.setAttribute("role", "button"); // overrides the implicit role=link of <a> elements #7399
                closeButton.setAttribute("aria-label", "Close popup");
                closeButton.href = "#close";
                closeButton.innerHTML = '<span aria-hidden="true">&#215;</span>';
                on(closeButton, "click", function(ev) {
                    preventDefault(ev);
                    this.close();
                }, this);
            }
        },
        _updateLayout: function() {
            var container = this._contentNode, style = container.style;
            style.width = "";
            style.whiteSpace = "nowrap";
            var width = container.offsetWidth;
            width = Math.min(width, this.options.maxWidth);
            width = Math.max(width, this.options.minWidth);
            style.width = width + 1 + "px";
            style.whiteSpace = "";
            style.height = "";
            var height = container.offsetHeight, maxHeight = this.options.maxHeight, scrolledClass = "leaflet-popup-scrolled";
            if (maxHeight && height > maxHeight) {
                style.height = maxHeight + "px";
                addClass(container, scrolledClass);
            } else removeClass(container, scrolledClass);
            this._containerWidth = this._container.offsetWidth;
        },
        _animateZoom: function(e) {
            var pos = this._map._latLngToNewLayerPoint(this._latlng, e.zoom, e.center), anchor = this._getAnchor();
            setPosition(this._container, pos.add(anchor));
        },
        _adjustPan: function() {
            if (!this.options.autoPan) return;
            if (this._map._panAnim) this._map._panAnim.stop();
            // We can endlessly recurse if keepInView is set and the view resets.
            // Let's guard against that by exiting early if we're responding to our own autopan.
            if (this._autopanning) {
                this._autopanning = false;
                return;
            }
            var map = this._map, marginBottom = parseInt(getStyle(this._container, "marginBottom"), 10) || 0, containerHeight = this._container.offsetHeight + marginBottom, containerWidth = this._containerWidth, layerPos = new Point(this._containerLeft, -containerHeight - this._containerBottom);
            layerPos._add(getPosition(this._container));
            var containerPos = map.layerPointToContainerPoint(layerPos), padding = toPoint(this.options.autoPanPadding), paddingTL = toPoint(this.options.autoPanPaddingTopLeft || padding), paddingBR = toPoint(this.options.autoPanPaddingBottomRight || padding), size = map.getSize(), dx = 0, dy = 0;
            if (containerPos.x + containerWidth + paddingBR.x > size.x) dx = containerPos.x + containerWidth - size.x + paddingBR.x;
            if (containerPos.x - dx - paddingTL.x < 0) dx = containerPos.x - paddingTL.x;
            if (containerPos.y + containerHeight + paddingBR.y > size.y) dy = containerPos.y + containerHeight - size.y + paddingBR.y;
            if (containerPos.y - dy - paddingTL.y < 0) dy = containerPos.y - paddingTL.y;
            // @namespace Map
            // @section Popup events
            // @event autopanstart: Event
            // Fired when the map starts autopanning when opening a popup.
            if (dx || dy) {
                // Track that we're autopanning, as this function will be re-ran on moveend
                if (this.options.keepInView) this._autopanning = true;
                map.fire("autopanstart").panBy([
                    dx,
                    dy
                ]);
            }
        },
        _getAnchor: function() {
            // Where should we anchor the popup on the source layer?
            return toPoint(this._source && this._source._getPopupAnchor ? this._source._getPopupAnchor() : [
                0,
                0
            ]);
        }
    });
    // @namespace Popup
    // @factory L.popup(options?: Popup options, source?: Layer)
    // Instantiates a `Popup` object given an optional `options` object that describes its appearance and location and an optional `source` object that is used to tag the popup with a reference to the Layer to which it refers.
    // @alternative
    // @factory L.popup(latlng: LatLng, options?: Popup options)
    // Instantiates a `Popup` object given `latlng` where the popup will open and an optional `options` object that describes its appearance and location.
    var popup = function(options, source) {
        return new Popup(options, source);
    };
    /* @namespace Map
   * @section Interaction Options
   * @option closePopupOnClick: Boolean = true
   * Set it to `false` if you don't want popups to close when user clicks the map.
   */ Map.mergeOptions({
        closePopupOnClick: true
    });
    // @namespace Map
    // @section Methods for Layers and Controls
    Map.include({
        // @method openPopup(popup: Popup): this
        // Opens the specified popup while closing the previously opened (to make sure only one is opened at one time for usability).
        // @alternative
        // @method openPopup(content: String|HTMLElement, latlng: LatLng, options?: Popup options): this
        // Creates a popup with the specified content and options and opens it in the given point on a map.
        openPopup: function(popup, latlng, options) {
            this._initOverlay(Popup, popup, latlng, options).openOn(this);
            return this;
        },
        // @method closePopup(popup?: Popup): this
        // Closes the popup previously opened with [openPopup](#map-openpopup) (or the given one).
        closePopup: function(popup) {
            popup = arguments.length ? popup : this._popup;
            if (popup) popup.close();
            return this;
        }
    });
    /*
   * @namespace Layer
   * @section Popup methods example
   *
   * All layers share a set of methods convenient for binding popups to it.
   *
   * ```js
   * var layer = L.Polygon(latlngs).bindPopup('Hi There!').addTo(map);
   * layer.openPopup();
   * layer.closePopup();
   * ```
   *
   * Popups will also be automatically opened when the layer is clicked on and closed when the layer is removed from the map or another popup is opened.
   */ // @section Popup methods
    Layer.include({
        // @method bindPopup(content: String|HTMLElement|Function|Popup, options?: Popup options): this
        // Binds a popup to the layer with the passed `content` and sets up the
        // necessary event listeners. If a `Function` is passed it will receive
        // the layer as the first argument and should return a `String` or `HTMLElement`.
        bindPopup: function(content, options) {
            this._popup = this._initOverlay(Popup, this._popup, content, options);
            if (!this._popupHandlersAdded) {
                this.on({
                    click: this._openPopup,
                    keypress: this._onKeyPress,
                    remove: this.closePopup,
                    move: this._movePopup
                });
                this._popupHandlersAdded = true;
            }
            return this;
        },
        // @method unbindPopup(): this
        // Removes the popup previously bound with `bindPopup`.
        unbindPopup: function() {
            if (this._popup) {
                this.off({
                    click: this._openPopup,
                    keypress: this._onKeyPress,
                    remove: this.closePopup,
                    move: this._movePopup
                });
                this._popupHandlersAdded = false;
                this._popup = null;
            }
            return this;
        },
        // @method openPopup(latlng?: LatLng): this
        // Opens the bound popup at the specified `latlng` or at the default popup anchor if no `latlng` is passed.
        openPopup: function(latlng) {
            if (this._popup) {
                if (!(this instanceof FeatureGroup)) this._popup._source = this;
                if (this._popup._prepareOpen(latlng || this._latlng)) // open the popup on the map
                this._popup.openOn(this._map);
            }
            return this;
        },
        // @method closePopup(): this
        // Closes the popup bound to this layer if it is open.
        closePopup: function() {
            if (this._popup) this._popup.close();
            return this;
        },
        // @method togglePopup(): this
        // Opens or closes the popup bound to this layer depending on its current state.
        togglePopup: function() {
            if (this._popup) this._popup.toggle(this);
            return this;
        },
        // @method isPopupOpen(): boolean
        // Returns `true` if the popup bound to this layer is currently open.
        isPopupOpen: function() {
            return this._popup ? this._popup.isOpen() : false;
        },
        // @method setPopupContent(content: String|HTMLElement|Popup): this
        // Sets the content of the popup bound to this layer.
        setPopupContent: function(content) {
            if (this._popup) this._popup.setContent(content);
            return this;
        },
        // @method getPopup(): Popup
        // Returns the popup bound to this layer.
        getPopup: function() {
            return this._popup;
        },
        _openPopup: function(e) {
            if (!this._popup || !this._map) return;
            // prevent map click
            stop(e);
            var target = e.layer || e.target;
            if (this._popup._source === target && !(target instanceof Path)) {
                // treat it like a marker and figure out
                // if we should toggle it open/closed
                if (this._map.hasLayer(this._popup)) this.closePopup();
                else this.openPopup(e.latlng);
                return;
            }
            this._popup._source = target;
            this.openPopup(e.latlng);
        },
        _movePopup: function(e) {
            this._popup.setLatLng(e.latlng);
        },
        _onKeyPress: function(e) {
            if (e.originalEvent.keyCode === 13) this._openPopup(e);
        }
    });
    /*
   * @class Tooltip
   * @inherits DivOverlay
   * @aka L.Tooltip
   * Used to display small texts on top of map layers.
   *
   * @example
   * If you want to just bind a tooltip to marker:
   *
   * ```js
   * marker.bindTooltip("my tooltip text").openTooltip();
   * ```
   * Path overlays like polylines also have a `bindTooltip` method.
   *
   * A tooltip can be also standalone:
   *
   * ```js
   * var tooltip = L.tooltip()
   * 	.setLatLng(latlng)
   * 	.setContent('Hello world!<br />This is a nice tooltip.')
   * 	.addTo(map);
   * ```
   * or
   * ```js
   * var tooltip = L.tooltip(latlng, {content: 'Hello world!<br />This is a nice tooltip.'})
   * 	.addTo(map);
   * ```
   *
   *
   * Note about tooltip offset. Leaflet takes two options in consideration
   * for computing tooltip offsetting:
   * - the `offset` Tooltip option: it defaults to [0, 0], and it's specific to one tooltip.
   *   Add a positive x offset to move the tooltip to the right, and a positive y offset to
   *   move it to the bottom. Negatives will move to the left and top.
   * - the `tooltipAnchor` Icon option: this will only be considered for Marker. You
   *   should adapt this value if you use a custom icon.
   */ // @namespace Tooltip
    var Tooltip = DivOverlay.extend({
        // @section
        // @aka Tooltip options
        options: {
            // @option pane: String = 'tooltipPane'
            // `Map pane` where the tooltip will be added.
            pane: "tooltipPane",
            // @option offset: Point = Point(0, 0)
            // Optional offset of the tooltip position.
            offset: [
                0,
                0
            ],
            // @option direction: String = 'auto'
            // Direction where to open the tooltip. Possible values are: `right`, `left`,
            // `top`, `bottom`, `center`, `auto`.
            // `auto` will dynamically switch between `right` and `left` according to the tooltip
            // position on the map.
            direction: "auto",
            // @option permanent: Boolean = false
            // Whether to open the tooltip permanently or only on mouseover.
            permanent: false,
            // @option sticky: Boolean = false
            // If true, the tooltip will follow the mouse instead of being fixed at the feature center.
            sticky: false,
            // @option opacity: Number = 0.9
            // Tooltip container opacity.
            opacity: 0.9
        },
        onAdd: function(map) {
            DivOverlay.prototype.onAdd.call(this, map);
            this.setOpacity(this.options.opacity);
            // @namespace Map
            // @section Tooltip events
            // @event tooltipopen: TooltipEvent
            // Fired when a tooltip is opened in the map.
            map.fire("tooltipopen", {
                tooltip: this
            });
            if (this._source) {
                this.addEventParent(this._source);
                // @namespace Layer
                // @section Tooltip events
                // @event tooltipopen: TooltipEvent
                // Fired when a tooltip bound to this layer is opened.
                this._source.fire("tooltipopen", {
                    tooltip: this
                }, true);
            }
        },
        onRemove: function(map) {
            DivOverlay.prototype.onRemove.call(this, map);
            // @namespace Map
            // @section Tooltip events
            // @event tooltipclose: TooltipEvent
            // Fired when a tooltip in the map is closed.
            map.fire("tooltipclose", {
                tooltip: this
            });
            if (this._source) {
                this.removeEventParent(this._source);
                // @namespace Layer
                // @section Tooltip events
                // @event tooltipclose: TooltipEvent
                // Fired when a tooltip bound to this layer is closed.
                this._source.fire("tooltipclose", {
                    tooltip: this
                }, true);
            }
        },
        getEvents: function() {
            var events = DivOverlay.prototype.getEvents.call(this);
            if (!this.options.permanent) events.preclick = this.close;
            return events;
        },
        _initLayout: function() {
            var prefix = "leaflet-tooltip", className = prefix + " " + (this.options.className || "") + " leaflet-zoom-" + (this._zoomAnimated ? "animated" : "hide");
            this._contentNode = this._container = create$1("div", className);
            this._container.setAttribute("role", "tooltip");
            this._container.setAttribute("id", "leaflet-tooltip-" + stamp(this));
        },
        _updateLayout: function() {},
        _adjustPan: function() {},
        _setPosition: function(pos) {
            var subX, subY, map = this._map, container = this._container, centerPoint = map.latLngToContainerPoint(map.getCenter()), tooltipPoint = map.layerPointToContainerPoint(pos), direction = this.options.direction, tooltipWidth = container.offsetWidth, tooltipHeight = container.offsetHeight, offset = toPoint(this.options.offset), anchor = this._getAnchor();
            if (direction === "top") {
                subX = tooltipWidth / 2;
                subY = tooltipHeight;
            } else if (direction === "bottom") {
                subX = tooltipWidth / 2;
                subY = 0;
            } else if (direction === "center") {
                subX = tooltipWidth / 2;
                subY = tooltipHeight / 2;
            } else if (direction === "right") {
                subX = 0;
                subY = tooltipHeight / 2;
            } else if (direction === "left") {
                subX = tooltipWidth;
                subY = tooltipHeight / 2;
            } else if (tooltipPoint.x < centerPoint.x) {
                direction = "right";
                subX = 0;
                subY = tooltipHeight / 2;
            } else {
                direction = "left";
                subX = tooltipWidth + (offset.x + anchor.x) * 2;
                subY = tooltipHeight / 2;
            }
            pos = pos.subtract(toPoint(subX, subY, true)).add(offset).add(anchor);
            removeClass(container, "leaflet-tooltip-right");
            removeClass(container, "leaflet-tooltip-left");
            removeClass(container, "leaflet-tooltip-top");
            removeClass(container, "leaflet-tooltip-bottom");
            addClass(container, "leaflet-tooltip-" + direction);
            setPosition(container, pos);
        },
        _updatePosition: function() {
            var pos = this._map.latLngToLayerPoint(this._latlng);
            this._setPosition(pos);
        },
        setOpacity: function(opacity) {
            this.options.opacity = opacity;
            if (this._container) setOpacity(this._container, opacity);
        },
        _animateZoom: function(e) {
            var pos = this._map._latLngToNewLayerPoint(this._latlng, e.zoom, e.center);
            this._setPosition(pos);
        },
        _getAnchor: function() {
            // Where should we anchor the tooltip on the source layer?
            return toPoint(this._source && this._source._getTooltipAnchor && !this.options.sticky ? this._source._getTooltipAnchor() : [
                0,
                0
            ]);
        }
    });
    // @namespace Tooltip
    // @factory L.tooltip(options?: Tooltip options, source?: Layer)
    // Instantiates a `Tooltip` object given an optional `options` object that describes its appearance and location and an optional `source` object that is used to tag the tooltip with a reference to the Layer to which it refers.
    // @alternative
    // @factory L.tooltip(latlng: LatLng, options?: Tooltip options)
    // Instantiates a `Tooltip` object given `latlng` where the tooltip will open and an optional `options` object that describes its appearance and location.
    var tooltip = function(options, source) {
        return new Tooltip(options, source);
    };
    // @namespace Map
    // @section Methods for Layers and Controls
    Map.include({
        // @method openTooltip(tooltip: Tooltip): this
        // Opens the specified tooltip.
        // @alternative
        // @method openTooltip(content: String|HTMLElement, latlng: LatLng, options?: Tooltip options): this
        // Creates a tooltip with the specified content and options and open it.
        openTooltip: function(tooltip, latlng, options) {
            this._initOverlay(Tooltip, tooltip, latlng, options).openOn(this);
            return this;
        },
        // @method closeTooltip(tooltip: Tooltip): this
        // Closes the tooltip given as parameter.
        closeTooltip: function(tooltip) {
            tooltip.close();
            return this;
        }
    });
    /*
   * @namespace Layer
   * @section Tooltip methods example
   *
   * All layers share a set of methods convenient for binding tooltips to it.
   *
   * ```js
   * var layer = L.Polygon(latlngs).bindTooltip('Hi There!').addTo(map);
   * layer.openTooltip();
   * layer.closeTooltip();
   * ```
   */ // @section Tooltip methods
    Layer.include({
        // @method bindTooltip(content: String|HTMLElement|Function|Tooltip, options?: Tooltip options): this
        // Binds a tooltip to the layer with the passed `content` and sets up the
        // necessary event listeners. If a `Function` is passed it will receive
        // the layer as the first argument and should return a `String` or `HTMLElement`.
        bindTooltip: function(content, options) {
            if (this._tooltip && this.isTooltipOpen()) this.unbindTooltip();
            this._tooltip = this._initOverlay(Tooltip, this._tooltip, content, options);
            this._initTooltipInteractions();
            if (this._tooltip.options.permanent && this._map && this._map.hasLayer(this)) this.openTooltip();
            return this;
        },
        // @method unbindTooltip(): this
        // Removes the tooltip previously bound with `bindTooltip`.
        unbindTooltip: function() {
            if (this._tooltip) {
                this._initTooltipInteractions(true);
                this.closeTooltip();
                this._tooltip = null;
            }
            return this;
        },
        _initTooltipInteractions: function(remove) {
            if (!remove && this._tooltipHandlersAdded) return;
            var onOff = remove ? "off" : "on", events = {
                remove: this.closeTooltip,
                move: this._moveTooltip
            };
            if (!this._tooltip.options.permanent) {
                events.mouseover = this._openTooltip;
                events.mouseout = this.closeTooltip;
                events.click = this._openTooltip;
                if (this._map) this._addFocusListeners();
                else events.add = this._addFocusListeners;
            } else events.add = this._openTooltip;
            if (this._tooltip.options.sticky) events.mousemove = this._moveTooltip;
            this[onOff](events);
            this._tooltipHandlersAdded = !remove;
        },
        // @method openTooltip(latlng?: LatLng): this
        // Opens the bound tooltip at the specified `latlng` or at the default tooltip anchor if no `latlng` is passed.
        openTooltip: function(latlng) {
            if (this._tooltip) {
                if (!(this instanceof FeatureGroup)) this._tooltip._source = this;
                if (this._tooltip._prepareOpen(latlng)) {
                    // open the tooltip on the map
                    this._tooltip.openOn(this._map);
                    if (this.getElement) this._setAriaDescribedByOnLayer(this);
                    else if (this.eachLayer) this.eachLayer(this._setAriaDescribedByOnLayer, this);
                }
            }
            return this;
        },
        // @method closeTooltip(): this
        // Closes the tooltip bound to this layer if it is open.
        closeTooltip: function() {
            if (this._tooltip) return this._tooltip.close();
        },
        // @method toggleTooltip(): this
        // Opens or closes the tooltip bound to this layer depending on its current state.
        toggleTooltip: function() {
            if (this._tooltip) this._tooltip.toggle(this);
            return this;
        },
        // @method isTooltipOpen(): boolean
        // Returns `true` if the tooltip bound to this layer is currently open.
        isTooltipOpen: function() {
            return this._tooltip.isOpen();
        },
        // @method setTooltipContent(content: String|HTMLElement|Tooltip): this
        // Sets the content of the tooltip bound to this layer.
        setTooltipContent: function(content) {
            if (this._tooltip) this._tooltip.setContent(content);
            return this;
        },
        // @method getTooltip(): Tooltip
        // Returns the tooltip bound to this layer.
        getTooltip: function() {
            return this._tooltip;
        },
        _addFocusListeners: function() {
            if (this.getElement) this._addFocusListenersOnLayer(this);
            else if (this.eachLayer) this.eachLayer(this._addFocusListenersOnLayer, this);
        },
        _addFocusListenersOnLayer: function(layer) {
            var el = typeof layer.getElement === "function" && layer.getElement();
            if (el) {
                on(el, "focus", function() {
                    this._tooltip._source = layer;
                    this.openTooltip();
                }, this);
                on(el, "blur", this.closeTooltip, this);
            }
        },
        _setAriaDescribedByOnLayer: function(layer) {
            var el = typeof layer.getElement === "function" && layer.getElement();
            if (el) el.setAttribute("aria-describedby", this._tooltip._container.id);
        },
        _openTooltip: function(e) {
            if (!this._tooltip || !this._map) return;
            // If the map is moving, we will show the tooltip after it's done.
            if (this._map.dragging && this._map.dragging.moving() && !this._openOnceFlag) {
                this._openOnceFlag = true;
                var that = this;
                this._map.once("moveend", function() {
                    that._openOnceFlag = false;
                    that._openTooltip(e);
                });
                return;
            }
            this._tooltip._source = e.layer || e.target;
            this.openTooltip(this._tooltip.options.sticky ? e.latlng : undefined);
        },
        _moveTooltip: function(e) {
            var latlng = e.latlng, containerPoint, layerPoint;
            if (this._tooltip.options.sticky && e.originalEvent) {
                containerPoint = this._map.mouseEventToContainerPoint(e.originalEvent);
                layerPoint = this._map.containerPointToLayerPoint(containerPoint);
                latlng = this._map.layerPointToLatLng(layerPoint);
            }
            this._tooltip.setLatLng(latlng);
        }
    });
    /*
   * @class DivIcon
   * @aka L.DivIcon
   * @inherits Icon
   *
   * Represents a lightweight icon for markers that uses a simple `<div>`
   * element instead of an image. Inherits from `Icon` but ignores the `iconUrl` and shadow options.
   *
   * @example
   * ```js
   * var myIcon = L.divIcon({className: 'my-div-icon'});
   * // you can set .my-div-icon styles in CSS
   *
   * L.marker([50.505, 30.57], {icon: myIcon}).addTo(map);
   * ```
   *
   * By default, it has a 'leaflet-div-icon' CSS class and is styled as a little white square with a shadow.
   */ var DivIcon = Icon.extend({
        options: {
            // @section
            // @aka DivIcon options
            iconSize: [
                12,
                12
            ],
            // iconAnchor: (Point),
            // popupAnchor: (Point),
            // @option html: String|HTMLElement = ''
            // Custom HTML code to put inside the div element, empty by default. Alternatively,
            // an instance of `HTMLElement`.
            html: false,
            // @option bgPos: Point = [0, 0]
            // Optional relative position of the background, in pixels
            bgPos: null,
            className: "leaflet-div-icon"
        },
        createIcon: function(oldIcon) {
            var div = oldIcon && oldIcon.tagName === "DIV" ? oldIcon : document.createElement("div"), options = this.options;
            if (options.html instanceof Element) {
                empty(div);
                div.appendChild(options.html);
            } else div.innerHTML = options.html !== false ? options.html : "";
            if (options.bgPos) {
                var bgPos = toPoint(options.bgPos);
                div.style.backgroundPosition = -bgPos.x + "px " + -bgPos.y + "px";
            }
            this._setIconStyles(div, "icon");
            return div;
        },
        createShadow: function() {
            return null;
        }
    });
    // @factory L.divIcon(options: DivIcon options)
    // Creates a `DivIcon` instance with the given options.
    function divIcon(options) {
        return new DivIcon(options);
    }
    Icon.Default = IconDefault;
    /*
   * @class GridLayer
   * @inherits Layer
   * @aka L.GridLayer
   *
   * Generic class for handling a tiled grid of HTML elements. This is the base class for all tile layers and replaces `TileLayer.Canvas`.
   * GridLayer can be extended to create a tiled grid of HTML elements like `<canvas>`, `<img>` or `<div>`. GridLayer will handle creating and animating these DOM elements for you.
   *
   *
   * @section Synchronous usage
   * @example
   *
   * To create a custom layer, extend GridLayer and implement the `createTile()` method, which will be passed a `Point` object with the `x`, `y`, and `z` (zoom level) coordinates to draw your tile.
   *
   * ```js
   * var CanvasLayer = L.GridLayer.extend({
   *     createTile: function(coords){
   *         // create a <canvas> element for drawing
   *         var tile = L.DomUtil.create('canvas', 'leaflet-tile');
   *
   *         // setup tile width and height according to the options
   *         var size = this.getTileSize();
   *         tile.width = size.x;
   *         tile.height = size.y;
   *
   *         // get a canvas context and draw something on it using coords.x, coords.y and coords.z
   *         var ctx = tile.getContext('2d');
   *
   *         // return the tile so it can be rendered on screen
   *         return tile;
   *     }
   * });
   * ```
   *
   * @section Asynchronous usage
   * @example
   *
   * Tile creation can also be asynchronous, this is useful when using a third-party drawing library. Once the tile is finished drawing it can be passed to the `done()` callback.
   *
   * ```js
   * var CanvasLayer = L.GridLayer.extend({
   *     createTile: function(coords, done){
   *         var error;
   *
   *         // create a <canvas> element for drawing
   *         var tile = L.DomUtil.create('canvas', 'leaflet-tile');
   *
   *         // setup tile width and height according to the options
   *         var size = this.getTileSize();
   *         tile.width = size.x;
   *         tile.height = size.y;
   *
   *         // draw something asynchronously and pass the tile to the done() callback
   *         setTimeout(function() {
   *             done(error, tile);
   *         }, 1000);
   *
   *         return tile;
   *     }
   * });
   * ```
   *
   * @section
   */ var GridLayer = Layer.extend({
        // @section
        // @aka GridLayer options
        options: {
            // @option tileSize: Number|Point = 256
            // Width and height of tiles in the grid. Use a number if width and height are equal, or `L.point(width, height)` otherwise.
            tileSize: 256,
            // @option opacity: Number = 1.0
            // Opacity of the tiles. Can be used in the `createTile()` function.
            opacity: 1,
            // @option updateWhenIdle: Boolean = (depends)
            // Load new tiles only when panning ends.
            // `true` by default on mobile browsers, in order to avoid too many requests and keep smooth navigation.
            // `false` otherwise in order to display new tiles _during_ panning, since it is easy to pan outside the
            // [`keepBuffer`](#gridlayer-keepbuffer) option in desktop browsers.
            updateWhenIdle: Browser.mobile,
            // @option updateWhenZooming: Boolean = true
            // By default, a smooth zoom animation (during a [touch zoom](#map-touchzoom) or a [`flyTo()`](#map-flyto)) will update grid layers every integer zoom level. Setting this option to `false` will update the grid layer only when the smooth animation ends.
            updateWhenZooming: true,
            // @option updateInterval: Number = 200
            // Tiles will not update more than once every `updateInterval` milliseconds when panning.
            updateInterval: 200,
            // @option zIndex: Number = 1
            // The explicit zIndex of the tile layer.
            zIndex: 1,
            // @option bounds: LatLngBounds = undefined
            // If set, tiles will only be loaded inside the set `LatLngBounds`.
            bounds: null,
            // @option minZoom: Number = 0
            // The minimum zoom level down to which this layer will be displayed (inclusive).
            minZoom: 0,
            // @option maxZoom: Number = undefined
            // The maximum zoom level up to which this layer will be displayed (inclusive).
            maxZoom: undefined,
            // @option maxNativeZoom: Number = undefined
            // Maximum zoom number the tile source has available. If it is specified,
            // the tiles on all zoom levels higher than `maxNativeZoom` will be loaded
            // from `maxNativeZoom` level and auto-scaled.
            maxNativeZoom: undefined,
            // @option minNativeZoom: Number = undefined
            // Minimum zoom number the tile source has available. If it is specified,
            // the tiles on all zoom levels lower than `minNativeZoom` will be loaded
            // from `minNativeZoom` level and auto-scaled.
            minNativeZoom: undefined,
            // @option noWrap: Boolean = false
            // Whether the layer is wrapped around the antimeridian. If `true`, the
            // GridLayer will only be displayed once at low zoom levels. Has no
            // effect when the [map CRS](#map-crs) doesn't wrap around. Can be used
            // in combination with [`bounds`](#gridlayer-bounds) to prevent requesting
            // tiles outside the CRS limits.
            noWrap: false,
            // @option pane: String = 'tilePane'
            // `Map pane` where the grid layer will be added.
            pane: "tilePane",
            // @option className: String = ''
            // A custom class name to assign to the tile layer. Empty by default.
            className: "",
            // @option keepBuffer: Number = 2
            // When panning the map, keep this many rows and columns of tiles before unloading them.
            keepBuffer: 2
        },
        initialize: function(options) {
            setOptions(this, options);
        },
        onAdd: function() {
            this._initContainer();
            this._levels = {};
            this._tiles = {};
            this._resetView(); // implicit _update() call
        },
        beforeAdd: function(map) {
            map._addZoomLimit(this);
        },
        onRemove: function(map) {
            this._removeAllTiles();
            remove(this._container);
            map._removeZoomLimit(this);
            this._container = null;
            this._tileZoom = undefined;
        },
        // @method bringToFront: this
        // Brings the tile layer to the top of all tile layers.
        bringToFront: function() {
            if (this._map) {
                toFront(this._container);
                this._setAutoZIndex(Math.max);
            }
            return this;
        },
        // @method bringToBack: this
        // Brings the tile layer to the bottom of all tile layers.
        bringToBack: function() {
            if (this._map) {
                toBack(this._container);
                this._setAutoZIndex(Math.min);
            }
            return this;
        },
        // @method getContainer: HTMLElement
        // Returns the HTML element that contains the tiles for this layer.
        getContainer: function() {
            return this._container;
        },
        // @method setOpacity(opacity: Number): this
        // Changes the [opacity](#gridlayer-opacity) of the grid layer.
        setOpacity: function(opacity) {
            this.options.opacity = opacity;
            this._updateOpacity();
            return this;
        },
        // @method setZIndex(zIndex: Number): this
        // Changes the [zIndex](#gridlayer-zindex) of the grid layer.
        setZIndex: function(zIndex) {
            this.options.zIndex = zIndex;
            this._updateZIndex();
            return this;
        },
        // @method isLoading: Boolean
        // Returns `true` if any tile in the grid layer has not finished loading.
        isLoading: function() {
            return this._loading;
        },
        // @method redraw: this
        // Causes the layer to clear all the tiles and request them again.
        redraw: function() {
            if (this._map) {
                this._removeAllTiles();
                var tileZoom = this._clampZoom(this._map.getZoom());
                if (tileZoom !== this._tileZoom) {
                    this._tileZoom = tileZoom;
                    this._updateLevels();
                }
                this._update();
            }
            return this;
        },
        getEvents: function() {
            var events = {
                viewprereset: this._invalidateAll,
                viewreset: this._resetView,
                zoom: this._resetView,
                moveend: this._onMoveEnd
            };
            if (!this.options.updateWhenIdle) {
                // update tiles on move, but not more often than once per given interval
                if (!this._onMove) this._onMove = throttle(this._onMoveEnd, this.options.updateInterval, this);
                events.move = this._onMove;
            }
            if (this._zoomAnimated) events.zoomanim = this._animateZoom;
            return events;
        },
        // @section Extension methods
        // Layers extending `GridLayer` shall reimplement the following method.
        // @method createTile(coords: Object, done?: Function): HTMLElement
        // Called only internally, must be overridden by classes extending `GridLayer`.
        // Returns the `HTMLElement` corresponding to the given `coords`. If the `done` callback
        // is specified, it must be called when the tile has finished loading and drawing.
        createTile: function() {
            return document.createElement("div");
        },
        // @section
        // @method getTileSize: Point
        // Normalizes the [tileSize option](#gridlayer-tilesize) into a point. Used by the `createTile()` method.
        getTileSize: function() {
            var s = this.options.tileSize;
            return s instanceof Point ? s : new Point(s, s);
        },
        _updateZIndex: function() {
            if (this._container && this.options.zIndex !== undefined && this.options.zIndex !== null) this._container.style.zIndex = this.options.zIndex;
        },
        _setAutoZIndex: function(compare) {
            // go through all other layers of the same pane, set zIndex to max + 1 (front) or min - 1 (back)
            var layers = this.getPane().children, edgeZIndex = -compare(-Infinity, Infinity); // -Infinity for max, Infinity for min
            for(var i = 0, len = layers.length, zIndex; i < len; i++){
                zIndex = layers[i].style.zIndex;
                if (layers[i] !== this._container && zIndex) edgeZIndex = compare(edgeZIndex, +zIndex);
            }
            if (isFinite(edgeZIndex)) {
                this.options.zIndex = edgeZIndex + compare(-1, 1);
                this._updateZIndex();
            }
        },
        _updateOpacity: function() {
            if (!this._map) return;
            // IE doesn't inherit filter opacity properly, so we're forced to set it on tiles
            if (Browser.ielt9) return;
            setOpacity(this._container, this.options.opacity);
            var now = +new Date(), nextFrame = false, willPrune = false;
            for(var key in this._tiles){
                var tile = this._tiles[key];
                if (!tile.current || !tile.loaded) continue;
                var fade = Math.min(1, (now - tile.loaded) / 200);
                setOpacity(tile.el, fade);
                if (fade < 1) nextFrame = true;
                else {
                    if (tile.active) willPrune = true;
                    else this._onOpaqueTile(tile);
                    tile.active = true;
                }
            }
            if (willPrune && !this._noPrune) this._pruneTiles();
            if (nextFrame) {
                cancelAnimFrame(this._fadeFrame);
                this._fadeFrame = requestAnimFrame(this._updateOpacity, this);
            }
        },
        _onOpaqueTile: falseFn,
        _initContainer: function() {
            if (this._container) return;
            this._container = create$1("div", "leaflet-layer " + (this.options.className || ""));
            this._updateZIndex();
            if (this.options.opacity < 1) this._updateOpacity();
            this.getPane().appendChild(this._container);
        },
        _updateLevels: function() {
            var zoom = this._tileZoom, maxZoom = this.options.maxZoom;
            if (zoom === undefined) return undefined;
            for(var z in this._levels){
                z = Number(z);
                if (this._levels[z].el.children.length || z === zoom) {
                    this._levels[z].el.style.zIndex = maxZoom - Math.abs(zoom - z);
                    this._onUpdateLevel(z);
                } else {
                    remove(this._levels[z].el);
                    this._removeTilesAtZoom(z);
                    this._onRemoveLevel(z);
                    delete this._levels[z];
                }
            }
            var level = this._levels[zoom], map = this._map;
            if (!level) {
                level = this._levels[zoom] = {};
                level.el = create$1("div", "leaflet-tile-container leaflet-zoom-animated", this._container);
                level.el.style.zIndex = maxZoom;
                level.origin = map.project(map.unproject(map.getPixelOrigin()), zoom).round();
                level.zoom = zoom;
                this._setZoomTransform(level, map.getCenter(), map.getZoom());
                // force the browser to consider the newly added element for transition
                falseFn(level.el.offsetWidth);
                this._onCreateLevel(level);
            }
            this._level = level;
            return level;
        },
        _onUpdateLevel: falseFn,
        _onRemoveLevel: falseFn,
        _onCreateLevel: falseFn,
        _pruneTiles: function() {
            if (!this._map) return;
            var key, tile;
            var zoom = this._map.getZoom();
            if (zoom > this.options.maxZoom || zoom < this.options.minZoom) {
                this._removeAllTiles();
                return;
            }
            for(key in this._tiles){
                tile = this._tiles[key];
                tile.retain = tile.current;
            }
            for(key in this._tiles){
                tile = this._tiles[key];
                if (tile.current && !tile.active) {
                    var coords = tile.coords;
                    if (!this._retainParent(coords.x, coords.y, coords.z, coords.z - 5)) this._retainChildren(coords.x, coords.y, coords.z, coords.z + 2);
                }
            }
            for(key in this._tiles)if (!this._tiles[key].retain) this._removeTile(key);
        },
        _removeTilesAtZoom: function(zoom) {
            for(var key in this._tiles){
                if (this._tiles[key].coords.z !== zoom) continue;
                this._removeTile(key);
            }
        },
        _removeAllTiles: function() {
            for(var key in this._tiles)this._removeTile(key);
        },
        _invalidateAll: function() {
            for(var z in this._levels){
                remove(this._levels[z].el);
                this._onRemoveLevel(Number(z));
                delete this._levels[z];
            }
            this._removeAllTiles();
            this._tileZoom = undefined;
        },
        _retainParent: function(x, y, z, minZoom) {
            var x2 = Math.floor(x / 2), y2 = Math.floor(y / 2), z2 = z - 1, coords2 = new Point(+x2, +y2);
            coords2.z = +z2;
            var key = this._tileCoordsToKey(coords2), tile = this._tiles[key];
            if (tile && tile.active) {
                tile.retain = true;
                return true;
            } else if (tile && tile.loaded) tile.retain = true;
            if (z2 > minZoom) return this._retainParent(x2, y2, z2, minZoom);
            return false;
        },
        _retainChildren: function(x, y, z, maxZoom) {
            for(var i = 2 * x; i < 2 * x + 2; i++)for(var j = 2 * y; j < 2 * y + 2; j++){
                var coords = new Point(i, j);
                coords.z = z + 1;
                var key = this._tileCoordsToKey(coords), tile = this._tiles[key];
                if (tile && tile.active) {
                    tile.retain = true;
                    continue;
                } else if (tile && tile.loaded) tile.retain = true;
                if (z + 1 < maxZoom) this._retainChildren(i, j, z + 1, maxZoom);
            }
        },
        _resetView: function(e) {
            var animating = e && (e.pinch || e.flyTo);
            this._setView(this._map.getCenter(), this._map.getZoom(), animating, animating);
        },
        _animateZoom: function(e) {
            this._setView(e.center, e.zoom, true, e.noUpdate);
        },
        _clampZoom: function(zoom) {
            var options = this.options;
            if (undefined !== options.minNativeZoom && zoom < options.minNativeZoom) return options.minNativeZoom;
            if (undefined !== options.maxNativeZoom && options.maxNativeZoom < zoom) return options.maxNativeZoom;
            return zoom;
        },
        _setView: function(center, zoom, noPrune, noUpdate) {
            var tileZoom = Math.round(zoom);
            if (this.options.maxZoom !== undefined && tileZoom > this.options.maxZoom || this.options.minZoom !== undefined && tileZoom < this.options.minZoom) tileZoom = undefined;
            else tileZoom = this._clampZoom(tileZoom);
            var tileZoomChanged = this.options.updateWhenZooming && tileZoom !== this._tileZoom;
            if (!noUpdate || tileZoomChanged) {
                this._tileZoom = tileZoom;
                if (this._abortLoading) this._abortLoading();
                this._updateLevels();
                this._resetGrid();
                if (tileZoom !== undefined) this._update(center);
                if (!noPrune) this._pruneTiles();
                // Flag to prevent _updateOpacity from pruning tiles during
                // a zoom anim or a pinch gesture
                this._noPrune = !!noPrune;
            }
            this._setZoomTransforms(center, zoom);
        },
        _setZoomTransforms: function(center, zoom) {
            for(var i in this._levels)this._setZoomTransform(this._levels[i], center, zoom);
        },
        _setZoomTransform: function(level, center, zoom) {
            var scale = this._map.getZoomScale(zoom, level.zoom), translate = level.origin.multiplyBy(scale).subtract(this._map._getNewPixelOrigin(center, zoom)).round();
            if (Browser.any3d) setTransform(level.el, translate, scale);
            else setPosition(level.el, translate);
        },
        _resetGrid: function() {
            var map = this._map, crs = map.options.crs, tileSize = this._tileSize = this.getTileSize(), tileZoom = this._tileZoom;
            var bounds = this._map.getPixelWorldBounds(this._tileZoom);
            if (bounds) this._globalTileRange = this._pxBoundsToTileRange(bounds);
            this._wrapX = crs.wrapLng && !this.options.noWrap && [
                Math.floor(map.project([
                    0,
                    crs.wrapLng[0]
                ], tileZoom).x / tileSize.x),
                Math.ceil(map.project([
                    0,
                    crs.wrapLng[1]
                ], tileZoom).x / tileSize.y)
            ];
            this._wrapY = crs.wrapLat && !this.options.noWrap && [
                Math.floor(map.project([
                    crs.wrapLat[0],
                    0
                ], tileZoom).y / tileSize.x),
                Math.ceil(map.project([
                    crs.wrapLat[1],
                    0
                ], tileZoom).y / tileSize.y)
            ];
        },
        _onMoveEnd: function() {
            if (!this._map || this._map._animatingZoom) return;
            this._update();
        },
        _getTiledPixelBounds: function(center) {
            var map = this._map, mapZoom = map._animatingZoom ? Math.max(map._animateToZoom, map.getZoom()) : map.getZoom(), scale = map.getZoomScale(mapZoom, this._tileZoom), pixelCenter = map.project(center, this._tileZoom).floor(), halfSize = map.getSize().divideBy(scale * 2);
            return new Bounds(pixelCenter.subtract(halfSize), pixelCenter.add(halfSize));
        },
        // Private method to load tiles in the grid's active zoom level according to map bounds
        _update: function(center) {
            var map = this._map;
            if (!map) return;
            var zoom = this._clampZoom(map.getZoom());
            if (center === undefined) center = map.getCenter();
            if (this._tileZoom === undefined) return;
             // if out of minzoom/maxzoom
            var pixelBounds = this._getTiledPixelBounds(center), tileRange = this._pxBoundsToTileRange(pixelBounds), tileCenter = tileRange.getCenter(), queue = [], margin = this.options.keepBuffer, noPruneRange = new Bounds(tileRange.getBottomLeft().subtract([
                margin,
                -margin
            ]), tileRange.getTopRight().add([
                margin,
                -margin
            ]));
            // Sanity check: panic if the tile range contains Infinity somewhere.
            if (!(isFinite(tileRange.min.x) && isFinite(tileRange.min.y) && isFinite(tileRange.max.x) && isFinite(tileRange.max.y))) throw new Error("Attempted to load an infinite number of tiles");
            for(var key in this._tiles){
                var c = this._tiles[key].coords;
                if (c.z !== this._tileZoom || !noPruneRange.contains(new Point(c.x, c.y))) this._tiles[key].current = false;
            }
            // _update just loads more tiles. If the tile zoom level differs too much
            // from the map's, let _setView reset levels and prune old tiles.
            if (Math.abs(zoom - this._tileZoom) > 1) {
                this._setView(center, zoom);
                return;
            }
            // create a queue of coordinates to load tiles from
            for(var j = tileRange.min.y; j <= tileRange.max.y; j++)for(var i = tileRange.min.x; i <= tileRange.max.x; i++){
                var coords = new Point(i, j);
                coords.z = this._tileZoom;
                if (!this._isValidTile(coords)) continue;
                var tile = this._tiles[this._tileCoordsToKey(coords)];
                if (tile) tile.current = true;
                else queue.push(coords);
            }
            // sort tile queue to load tiles in order of their distance to center
            queue.sort(function(a, b) {
                return a.distanceTo(tileCenter) - b.distanceTo(tileCenter);
            });
            if (queue.length !== 0) {
                // if it's the first batch of tiles to load
                if (!this._loading) {
                    this._loading = true;
                    // @event loading: Event
                    // Fired when the grid layer starts loading tiles.
                    this.fire("loading");
                }
                // create DOM fragment to append tiles in one batch
                var fragment = document.createDocumentFragment();
                for(i = 0; i < queue.length; i++)this._addTile(queue[i], fragment);
                this._level.el.appendChild(fragment);
            }
        },
        _isValidTile: function(coords) {
            var crs = this._map.options.crs;
            if (!crs.infinite) {
                // don't load tile if it's out of bounds and not wrapped
                var bounds = this._globalTileRange;
                if (!crs.wrapLng && (coords.x < bounds.min.x || coords.x > bounds.max.x) || !crs.wrapLat && (coords.y < bounds.min.y || coords.y > bounds.max.y)) return false;
            }
            if (!this.options.bounds) return true;
            // don't load tile if it doesn't intersect the bounds in options
            var tileBounds = this._tileCoordsToBounds(coords);
            return toLatLngBounds(this.options.bounds).overlaps(tileBounds);
        },
        _keyToBounds: function(key) {
            return this._tileCoordsToBounds(this._keyToTileCoords(key));
        },
        _tileCoordsToNwSe: function(coords) {
            var map = this._map, tileSize = this.getTileSize(), nwPoint = coords.scaleBy(tileSize), sePoint = nwPoint.add(tileSize), nw = map.unproject(nwPoint, coords.z), se = map.unproject(sePoint, coords.z);
            return [
                nw,
                se
            ];
        },
        // converts tile coordinates to its geographical bounds
        _tileCoordsToBounds: function(coords) {
            var bp = this._tileCoordsToNwSe(coords), bounds = new LatLngBounds(bp[0], bp[1]);
            if (!this.options.noWrap) bounds = this._map.wrapLatLngBounds(bounds);
            return bounds;
        },
        // converts tile coordinates to key for the tile cache
        _tileCoordsToKey: function(coords) {
            return coords.x + ":" + coords.y + ":" + coords.z;
        },
        // converts tile cache key to coordinates
        _keyToTileCoords: function(key) {
            var k = key.split(":"), coords = new Point(+k[0], +k[1]);
            coords.z = +k[2];
            return coords;
        },
        _removeTile: function(key) {
            var tile = this._tiles[key];
            if (!tile) return;
            remove(tile.el);
            delete this._tiles[key];
            // @event tileunload: TileEvent
            // Fired when a tile is removed (e.g. when a tile goes off the screen).
            this.fire("tileunload", {
                tile: tile.el,
                coords: this._keyToTileCoords(key)
            });
        },
        _initTile: function(tile) {
            addClass(tile, "leaflet-tile");
            var tileSize = this.getTileSize();
            tile.style.width = tileSize.x + "px";
            tile.style.height = tileSize.y + "px";
            tile.onselectstart = falseFn;
            tile.onmousemove = falseFn;
            // update opacity on tiles in IE7-8 because of filter inheritance problems
            if (Browser.ielt9 && this.options.opacity < 1) setOpacity(tile, this.options.opacity);
        },
        _addTile: function(coords, container) {
            var tilePos = this._getTilePos(coords), key = this._tileCoordsToKey(coords);
            var tile = this.createTile(this._wrapCoords(coords), bind(this._tileReady, this, coords));
            this._initTile(tile);
            // if createTile is defined with a second argument ("done" callback),
            // we know that tile is async and will be ready later; otherwise
            if (this.createTile.length < 2) // mark tile as ready, but delay one frame for opacity animation to happen
            requestAnimFrame(bind(this._tileReady, this, coords, null, tile));
            setPosition(tile, tilePos);
            // save tile in cache
            this._tiles[key] = {
                el: tile,
                coords: coords,
                current: true
            };
            container.appendChild(tile);
            // @event tileloadstart: TileEvent
            // Fired when a tile is requested and starts loading.
            this.fire("tileloadstart", {
                tile: tile,
                coords: coords
            });
        },
        _tileReady: function(coords, err, tile) {
            if (err) // @event tileerror: TileErrorEvent
            // Fired when there is an error loading a tile.
            this.fire("tileerror", {
                error: err,
                tile: tile,
                coords: coords
            });
            var key = this._tileCoordsToKey(coords);
            tile = this._tiles[key];
            if (!tile) return;
            tile.loaded = +new Date();
            if (this._map._fadeAnimated) {
                setOpacity(tile.el, 0);
                cancelAnimFrame(this._fadeFrame);
                this._fadeFrame = requestAnimFrame(this._updateOpacity, this);
            } else {
                tile.active = true;
                this._pruneTiles();
            }
            if (!err) {
                addClass(tile.el, "leaflet-tile-loaded");
                // @event tileload: TileEvent
                // Fired when a tile loads.
                this.fire("tileload", {
                    tile: tile.el,
                    coords: coords
                });
            }
            if (this._noTilesToLoad()) {
                this._loading = false;
                // @event load: Event
                // Fired when the grid layer loaded all visible tiles.
                this.fire("load");
                if (Browser.ielt9 || !this._map._fadeAnimated) requestAnimFrame(this._pruneTiles, this);
                else // Wait a bit more than 0.2 secs (the duration of the tile fade-in)
                // to trigger a pruning.
                setTimeout(bind(this._pruneTiles, this), 250);
            }
        },
        _getTilePos: function(coords) {
            return coords.scaleBy(this.getTileSize()).subtract(this._level.origin);
        },
        _wrapCoords: function(coords) {
            var newCoords = new Point(this._wrapX ? wrapNum(coords.x, this._wrapX) : coords.x, this._wrapY ? wrapNum(coords.y, this._wrapY) : coords.y);
            newCoords.z = coords.z;
            return newCoords;
        },
        _pxBoundsToTileRange: function(bounds) {
            var tileSize = this.getTileSize();
            return new Bounds(bounds.min.unscaleBy(tileSize).floor(), bounds.max.unscaleBy(tileSize).ceil().subtract([
                1,
                1
            ]));
        },
        _noTilesToLoad: function() {
            for(var key in this._tiles){
                if (!this._tiles[key].loaded) return false;
            }
            return true;
        }
    });
    // @factory L.gridLayer(options?: GridLayer options)
    // Creates a new instance of GridLayer with the supplied options.
    function gridLayer(options) {
        return new GridLayer(options);
    }
    /*
   * @class TileLayer
   * @inherits GridLayer
   * @aka L.TileLayer
   * Used to load and display tile layers on the map. Note that most tile servers require attribution, which you can set under `Layer`. Extends `GridLayer`.
   *
   * @example
   *
   * ```js
   * L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png?{foo}', {foo: 'bar', attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'}).addTo(map);
   * ```
   *
   * @section URL template
   * @example
   *
   * A string of the following form:
   *
   * ```
   * 'https://{s}.somedomain.com/blabla/{z}/{x}/{y}{r}.png'
   * ```
   *
   * `{s}` means one of the available subdomains (used sequentially to help with browser parallel requests per domain limitation; subdomain values are specified in options; `a`, `b` or `c` by default, can be omitted), `{z}` — zoom level, `{x}` and `{y}` — tile coordinates. `{r}` can be used to add "&commat;2x" to the URL to load retina tiles.
   *
   * You can use custom keys in the template, which will be [evaluated](#util-template) from TileLayer options, like this:
   *
   * ```
   * L.tileLayer('https://{s}.somedomain.com/{foo}/{z}/{x}/{y}.png', {foo: 'bar'});
   * ```
   */ var TileLayer = GridLayer.extend({
        // @section
        // @aka TileLayer options
        options: {
            // @option minZoom: Number = 0
            // The minimum zoom level down to which this layer will be displayed (inclusive).
            minZoom: 0,
            // @option maxZoom: Number = 18
            // The maximum zoom level up to which this layer will be displayed (inclusive).
            maxZoom: 18,
            // @option subdomains: String|String[] = 'abc'
            // Subdomains of the tile service. Can be passed in the form of one string (where each letter is a subdomain name) or an array of strings.
            subdomains: "abc",
            // @option errorTileUrl: String = ''
            // URL to the tile image to show in place of the tile that failed to load.
            errorTileUrl: "",
            // @option zoomOffset: Number = 0
            // The zoom number used in tile URLs will be offset with this value.
            zoomOffset: 0,
            // @option tms: Boolean = false
            // If `true`, inverses Y axis numbering for tiles (turn this on for [TMS](https://en.wikipedia.org/wiki/Tile_Map_Service) services).
            tms: false,
            // @option zoomReverse: Boolean = false
            // If set to true, the zoom number used in tile URLs will be reversed (`maxZoom - zoom` instead of `zoom`)
            zoomReverse: false,
            // @option detectRetina: Boolean = false
            // If `true` and user is on a retina display, it will request four tiles of half the specified size and a bigger zoom level in place of one to utilize the high resolution.
            detectRetina: false,
            // @option crossOrigin: Boolean|String = false
            // Whether the crossOrigin attribute will be added to the tiles.
            // If a String is provided, all tiles will have their crossOrigin attribute set to the String provided. This is needed if you want to access tile pixel data.
            // Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
            crossOrigin: false,
            // @option referrerPolicy: Boolean|String = false
            // Whether the referrerPolicy attribute will be added to the tiles.
            // If a String is provided, all tiles will have their referrerPolicy attribute set to the String provided.
            // This may be needed if your map's rendering context has a strict default but your tile provider expects a valid referrer
            // (e.g. to validate an API token).
            // Refer to [HTMLImageElement.referrerPolicy](https://developer.mozilla.org/en-US/docs/Web/API/HTMLImageElement/referrerPolicy) for valid String values.
            referrerPolicy: false
        },
        initialize: function(url, options) {
            this._url = url;
            options = setOptions(this, options);
            // detecting retina displays, adjusting tileSize and zoom levels
            if (options.detectRetina && Browser.retina && options.maxZoom > 0) {
                options.tileSize = Math.floor(options.tileSize / 2);
                if (!options.zoomReverse) {
                    options.zoomOffset++;
                    options.maxZoom = Math.max(options.minZoom, options.maxZoom - 1);
                } else {
                    options.zoomOffset--;
                    options.minZoom = Math.min(options.maxZoom, options.minZoom + 1);
                }
                options.minZoom = Math.max(0, options.minZoom);
            } else if (!options.zoomReverse) // make sure maxZoom is gte minZoom
            options.maxZoom = Math.max(options.minZoom, options.maxZoom);
            else // make sure minZoom is lte maxZoom
            options.minZoom = Math.min(options.maxZoom, options.minZoom);
            if (typeof options.subdomains === "string") options.subdomains = options.subdomains.split("");
            this.on("tileunload", this._onTileRemove);
        },
        // @method setUrl(url: String, noRedraw?: Boolean): this
        // Updates the layer's URL template and redraws it (unless `noRedraw` is set to `true`).
        // If the URL does not change, the layer will not be redrawn unless
        // the noRedraw parameter is set to false.
        setUrl: function(url, noRedraw) {
            if (this._url === url && noRedraw === undefined) noRedraw = true;
            this._url = url;
            if (!noRedraw) this.redraw();
            return this;
        },
        // @method createTile(coords: Object, done?: Function): HTMLElement
        // Called only internally, overrides GridLayer's [`createTile()`](#gridlayer-createtile)
        // to return an `<img>` HTML element with the appropriate image URL given `coords`. The `done`
        // callback is called when the tile has been loaded.
        createTile: function(coords, done) {
            var tile = document.createElement("img");
            on(tile, "load", bind(this._tileOnLoad, this, done, tile));
            on(tile, "error", bind(this._tileOnError, this, done, tile));
            if (this.options.crossOrigin || this.options.crossOrigin === "") tile.crossOrigin = this.options.crossOrigin === true ? "" : this.options.crossOrigin;
            // for this new option we follow the documented behavior
            // more closely by only setting the property when string
            if (typeof this.options.referrerPolicy === "string") tile.referrerPolicy = this.options.referrerPolicy;
            // The alt attribute is set to the empty string,
            // allowing screen readers to ignore the decorative image tiles.
            // https://www.w3.org/WAI/tutorials/images/decorative/
            // https://www.w3.org/TR/html-aria/#el-img-empty-alt
            tile.alt = "";
            tile.src = this.getTileUrl(coords);
            return tile;
        },
        // @section Extension methods
        // @uninheritable
        // Layers extending `TileLayer` might reimplement the following method.
        // @method getTileUrl(coords: Object): String
        // Called only internally, returns the URL for a tile given its coordinates.
        // Classes extending `TileLayer` can override this function to provide custom tile URL naming schemes.
        getTileUrl: function(coords) {
            var data = {
                r: Browser.retina ? "@2x" : "",
                s: this._getSubdomain(coords),
                x: coords.x,
                y: coords.y,
                z: this._getZoomForUrl()
            };
            if (this._map && !this._map.options.crs.infinite) {
                var invertedY = this._globalTileRange.max.y - coords.y;
                if (this.options.tms) data["y"] = invertedY;
                data["-y"] = invertedY;
            }
            return template(this._url, extend(data, this.options));
        },
        _tileOnLoad: function(done, tile) {
            // For https://github.com/Leaflet/Leaflet/issues/3332
            if (Browser.ielt9) setTimeout(bind(done, this, null, tile), 0);
            else done(null, tile);
        },
        _tileOnError: function(done, tile, e) {
            var errorUrl = this.options.errorTileUrl;
            if (errorUrl && tile.getAttribute("src") !== errorUrl) tile.src = errorUrl;
            done(e, tile);
        },
        _onTileRemove: function(e) {
            e.tile.onload = null;
        },
        _getZoomForUrl: function() {
            var zoom = this._tileZoom, maxZoom = this.options.maxZoom, zoomReverse = this.options.zoomReverse, zoomOffset = this.options.zoomOffset;
            if (zoomReverse) zoom = maxZoom - zoom;
            return zoom + zoomOffset;
        },
        _getSubdomain: function(tilePoint) {
            var index = Math.abs(tilePoint.x + tilePoint.y) % this.options.subdomains.length;
            return this.options.subdomains[index];
        },
        // stops loading all tiles in the background layer
        _abortLoading: function() {
            var i, tile;
            for(i in this._tiles)if (this._tiles[i].coords.z !== this._tileZoom) {
                tile = this._tiles[i].el;
                tile.onload = falseFn;
                tile.onerror = falseFn;
                if (!tile.complete) {
                    tile.src = emptyImageUrl;
                    var coords = this._tiles[i].coords;
                    remove(tile);
                    delete this._tiles[i];
                    // @event tileabort: TileEvent
                    // Fired when a tile was loading but is now not wanted.
                    this.fire("tileabort", {
                        tile: tile,
                        coords: coords
                    });
                }
            }
        },
        _removeTile: function(key) {
            var tile = this._tiles[key];
            if (!tile) return;
            // Cancels any pending http requests associated with the tile
            tile.el.setAttribute("src", emptyImageUrl);
            return GridLayer.prototype._removeTile.call(this, key);
        },
        _tileReady: function(coords, err, tile) {
            if (!this._map || tile && tile.getAttribute("src") === emptyImageUrl) return;
            return GridLayer.prototype._tileReady.call(this, coords, err, tile);
        }
    });
    // @factory L.tilelayer(urlTemplate: String, options?: TileLayer options)
    // Instantiates a tile layer object given a `URL template` and optionally an options object.
    function tileLayer(url, options) {
        return new TileLayer(url, options);
    }
    /*
   * @class TileLayer.WMS
   * @inherits TileLayer
   * @aka L.TileLayer.WMS
   * Used to display [WMS](https://en.wikipedia.org/wiki/Web_Map_Service) services as tile layers on the map. Extends `TileLayer`.
   *
   * @example
   *
   * ```js
   * var nexrad = L.tileLayer.wms("http://mesonet.agron.iastate.edu/cgi-bin/wms/nexrad/n0r.cgi", {
   * 	layers: 'nexrad-n0r-900913',
   * 	format: 'image/png',
   * 	transparent: true,
   * 	attribution: "Weather data © 2012 IEM Nexrad"
   * });
   * ```
   */ var TileLayerWMS = TileLayer.extend({
        // @section
        // @aka TileLayer.WMS options
        // If any custom options not documented here are used, they will be sent to the
        // WMS server as extra parameters in each request URL. This can be useful for
        // [non-standard vendor WMS parameters](https://docs.geoserver.org/stable/en/user/services/wms/vendor.html).
        defaultWmsParams: {
            service: "WMS",
            request: "GetMap",
            // @option layers: String = ''
            // **(required)** Comma-separated list of WMS layers to show.
            layers: "",
            // @option styles: String = ''
            // Comma-separated list of WMS styles.
            styles: "",
            // @option format: String = 'image/jpeg'
            // WMS image format (use `'image/png'` for layers with transparency).
            format: "image/jpeg",
            // @option transparent: Boolean = false
            // If `true`, the WMS service will return images with transparency.
            transparent: false,
            // @option version: String = '1.1.1'
            // Version of the WMS service to use
            version: "1.1.1"
        },
        options: {
            // @option crs: CRS = null
            // Coordinate Reference System to use for the WMS requests, defaults to
            // map CRS. Don't change this if you're not sure what it means.
            crs: null,
            // @option uppercase: Boolean = false
            // If `true`, WMS request parameter keys will be uppercase.
            uppercase: false
        },
        initialize: function(url, options) {
            this._url = url;
            var wmsParams = extend({}, this.defaultWmsParams);
            // all keys that are not TileLayer options go to WMS params
            for(var i in options)if (!(i in this.options)) wmsParams[i] = options[i];
            options = setOptions(this, options);
            var realRetina = options.detectRetina && Browser.retina ? 2 : 1;
            var tileSize = this.getTileSize();
            wmsParams.width = tileSize.x * realRetina;
            wmsParams.height = tileSize.y * realRetina;
            this.wmsParams = wmsParams;
        },
        onAdd: function(map) {
            this._crs = this.options.crs || map.options.crs;
            this._wmsVersion = parseFloat(this.wmsParams.version);
            var projectionKey = this._wmsVersion >= 1.3 ? "crs" : "srs";
            this.wmsParams[projectionKey] = this._crs.code;
            TileLayer.prototype.onAdd.call(this, map);
        },
        getTileUrl: function(coords) {
            var tileBounds = this._tileCoordsToNwSe(coords), crs = this._crs, bounds = toBounds(crs.project(tileBounds[0]), crs.project(tileBounds[1])), min = bounds.min, max = bounds.max, bbox = (this._wmsVersion >= 1.3 && this._crs === EPSG4326 ? [
                min.y,
                min.x,
                max.y,
                max.x
            ] : [
                min.x,
                min.y,
                max.x,
                max.y
            ]).join(","), url = TileLayer.prototype.getTileUrl.call(this, coords);
            return url + getParamString(this.wmsParams, url, this.options.uppercase) + (this.options.uppercase ? "&BBOX=" : "&bbox=") + bbox;
        },
        // @method setParams(params: Object, noRedraw?: Boolean): this
        // Merges an object with the new parameters and re-requests tiles on the current screen (unless `noRedraw` was set to true).
        setParams: function(params, noRedraw) {
            extend(this.wmsParams, params);
            if (!noRedraw) this.redraw();
            return this;
        }
    });
    // @factory L.tileLayer.wms(baseUrl: String, options: TileLayer.WMS options)
    // Instantiates a WMS tile layer object given a base URL of the WMS service and a WMS parameters/options object.
    function tileLayerWMS(url, options) {
        return new TileLayerWMS(url, options);
    }
    TileLayer.WMS = TileLayerWMS;
    tileLayer.wms = tileLayerWMS;
    /*
   * @class Renderer
   * @inherits Layer
   * @aka L.Renderer
   *
   * Base class for vector renderer implementations (`SVG`, `Canvas`). Handles the
   * DOM container of the renderer, its bounds, and its zoom animation.
   *
   * A `Renderer` works as an implicit layer group for all `Path`s - the renderer
   * itself can be added or removed to the map. All paths use a renderer, which can
   * be implicit (the map will decide the type of renderer and use it automatically)
   * or explicit (using the [`renderer`](#path-renderer) option of the path).
   *
   * Do not use this class directly, use `SVG` and `Canvas` instead.
   *
   * @event update: Event
   * Fired when the renderer updates its bounds, center and zoom, for example when
   * its map has moved
   */ var Renderer = Layer.extend({
        // @section
        // @aka Renderer options
        options: {
            // @option padding: Number = 0.1
            // How much to extend the clip area around the map view (relative to its size)
            // e.g. 0.1 would be 10% of map view in each direction
            padding: 0.1
        },
        initialize: function(options) {
            setOptions(this, options);
            stamp(this);
            this._layers = this._layers || {};
        },
        onAdd: function() {
            if (!this._container) {
                this._initContainer(); // defined by renderer implementations
                // always keep transform-origin as 0 0
                addClass(this._container, "leaflet-zoom-animated");
            }
            this.getPane().appendChild(this._container);
            this._update();
            this.on("update", this._updatePaths, this);
        },
        onRemove: function() {
            this.off("update", this._updatePaths, this);
            this._destroyContainer();
        },
        getEvents: function() {
            var events = {
                viewreset: this._reset,
                zoom: this._onZoom,
                moveend: this._update,
                zoomend: this._onZoomEnd
            };
            if (this._zoomAnimated) events.zoomanim = this._onAnimZoom;
            return events;
        },
        _onAnimZoom: function(ev) {
            this._updateTransform(ev.center, ev.zoom);
        },
        _onZoom: function() {
            this._updateTransform(this._map.getCenter(), this._map.getZoom());
        },
        _updateTransform: function(center, zoom) {
            var scale = this._map.getZoomScale(zoom, this._zoom), viewHalf = this._map.getSize().multiplyBy(0.5 + this.options.padding), currentCenterPoint = this._map.project(this._center, zoom), topLeftOffset = viewHalf.multiplyBy(-scale).add(currentCenterPoint).subtract(this._map._getNewPixelOrigin(center, zoom));
            if (Browser.any3d) setTransform(this._container, topLeftOffset, scale);
            else setPosition(this._container, topLeftOffset);
        },
        _reset: function() {
            this._update();
            this._updateTransform(this._center, this._zoom);
            for(var id in this._layers)this._layers[id]._reset();
        },
        _onZoomEnd: function() {
            for(var id in this._layers)this._layers[id]._project();
        },
        _updatePaths: function() {
            for(var id in this._layers)this._layers[id]._update();
        },
        _update: function() {
            // Update pixel bounds of renderer container (for positioning/sizing/clipping later)
            // Subclasses are responsible of firing the 'update' event.
            var p = this.options.padding, size = this._map.getSize(), min = this._map.containerPointToLayerPoint(size.multiplyBy(-p)).round();
            this._bounds = new Bounds(min, min.add(size.multiplyBy(1 + p * 2)).round());
            this._center = this._map.getCenter();
            this._zoom = this._map.getZoom();
        }
    });
    /*
   * @class Canvas
   * @inherits Renderer
   * @aka L.Canvas
   *
   * Allows vector layers to be displayed with [`<canvas>`](https://developer.mozilla.org/docs/Web/API/Canvas_API).
   * Inherits `Renderer`.
   *
   * Due to [technical limitations](https://caniuse.com/canvas), Canvas is not
   * available in all web browsers, notably IE8, and overlapping geometries might
   * not display properly in some edge cases.
   *
   * @example
   *
   * Use Canvas by default for all paths in the map:
   *
   * ```js
   * var map = L.map('map', {
   * 	renderer: L.canvas()
   * });
   * ```
   *
   * Use a Canvas renderer with extra padding for specific vector geometries:
   *
   * ```js
   * var map = L.map('map');
   * var myRenderer = L.canvas({ padding: 0.5 });
   * var line = L.polyline( coordinates, { renderer: myRenderer } );
   * var circle = L.circle( center, { renderer: myRenderer } );
   * ```
   */ var Canvas = Renderer.extend({
        // @section
        // @aka Canvas options
        options: {
            // @option tolerance: Number = 0
            // How much to extend the click tolerance around a path/object on the map.
            tolerance: 0
        },
        getEvents: function() {
            var events = Renderer.prototype.getEvents.call(this);
            events.viewprereset = this._onViewPreReset;
            return events;
        },
        _onViewPreReset: function() {
            // Set a flag so that a viewprereset+moveend+viewreset only updates&redraws once
            this._postponeUpdatePaths = true;
        },
        onAdd: function() {
            Renderer.prototype.onAdd.call(this);
            // Redraw vectors since canvas is cleared upon removal,
            // in case of removing the renderer itself from the map.
            this._draw();
        },
        _initContainer: function() {
            var container = this._container = document.createElement("canvas");
            on(container, "mousemove", this._onMouseMove, this);
            on(container, "click dblclick mousedown mouseup contextmenu", this._onClick, this);
            on(container, "mouseout", this._handleMouseOut, this);
            container["_leaflet_disable_events"] = true;
            this._ctx = container.getContext("2d");
        },
        _destroyContainer: function() {
            cancelAnimFrame(this._redrawRequest);
            delete this._ctx;
            remove(this._container);
            off(this._container);
            delete this._container;
        },
        _updatePaths: function() {
            if (this._postponeUpdatePaths) return;
            var layer;
            this._redrawBounds = null;
            for(var id in this._layers){
                layer = this._layers[id];
                layer._update();
            }
            this._redraw();
        },
        _update: function() {
            if (this._map._animatingZoom && this._bounds) return;
            Renderer.prototype._update.call(this);
            var b = this._bounds, container = this._container, size = b.getSize(), m = Browser.retina ? 2 : 1;
            setPosition(container, b.min);
            // set canvas size (also clearing it); use double size on retina
            container.width = m * size.x;
            container.height = m * size.y;
            container.style.width = size.x + "px";
            container.style.height = size.y + "px";
            if (Browser.retina) this._ctx.scale(2, 2);
            // translate so we use the same path coordinates after canvas element moves
            this._ctx.translate(-b.min.x, -b.min.y);
            // Tell paths to redraw themselves
            this.fire("update");
        },
        _reset: function() {
            Renderer.prototype._reset.call(this);
            if (this._postponeUpdatePaths) {
                this._postponeUpdatePaths = false;
                this._updatePaths();
            }
        },
        _initPath: function(layer) {
            this._updateDashArray(layer);
            this._layers[stamp(layer)] = layer;
            var order = layer._order = {
                layer: layer,
                prev: this._drawLast,
                next: null
            };
            if (this._drawLast) this._drawLast.next = order;
            this._drawLast = order;
            this._drawFirst = this._drawFirst || this._drawLast;
        },
        _addPath: function(layer) {
            this._requestRedraw(layer);
        },
        _removePath: function(layer) {
            var order = layer._order;
            var next = order.next;
            var prev = order.prev;
            if (next) next.prev = prev;
            else this._drawLast = prev;
            if (prev) prev.next = next;
            else this._drawFirst = next;
            delete layer._order;
            delete this._layers[stamp(layer)];
            this._requestRedraw(layer);
        },
        _updatePath: function(layer) {
            // Redraw the union of the layer's old pixel
            // bounds and the new pixel bounds.
            this._extendRedrawBounds(layer);
            layer._project();
            layer._update();
            // The redraw will extend the redraw bounds
            // with the new pixel bounds.
            this._requestRedraw(layer);
        },
        _updateStyle: function(layer) {
            this._updateDashArray(layer);
            this._requestRedraw(layer);
        },
        _updateDashArray: function(layer) {
            if (typeof layer.options.dashArray === "string") {
                var parts = layer.options.dashArray.split(/[, ]+/), dashArray = [], dashValue, i;
                for(i = 0; i < parts.length; i++){
                    dashValue = Number(parts[i]);
                    // Ignore dash array containing invalid lengths
                    if (isNaN(dashValue)) return;
                    dashArray.push(dashValue);
                }
                layer.options._dashArray = dashArray;
            } else layer.options._dashArray = layer.options.dashArray;
        },
        _requestRedraw: function(layer) {
            if (!this._map) return;
            this._extendRedrawBounds(layer);
            this._redrawRequest = this._redrawRequest || requestAnimFrame(this._redraw, this);
        },
        _extendRedrawBounds: function(layer) {
            if (layer._pxBounds) {
                var padding = (layer.options.weight || 0) + 1;
                this._redrawBounds = this._redrawBounds || new Bounds();
                this._redrawBounds.extend(layer._pxBounds.min.subtract([
                    padding,
                    padding
                ]));
                this._redrawBounds.extend(layer._pxBounds.max.add([
                    padding,
                    padding
                ]));
            }
        },
        _redraw: function() {
            this._redrawRequest = null;
            if (this._redrawBounds) {
                this._redrawBounds.min._floor();
                this._redrawBounds.max._ceil();
            }
            this._clear(); // clear layers in redraw bounds
            this._draw(); // draw layers
            this._redrawBounds = null;
        },
        _clear: function() {
            var bounds = this._redrawBounds;
            if (bounds) {
                var size = bounds.getSize();
                this._ctx.clearRect(bounds.min.x, bounds.min.y, size.x, size.y);
            } else {
                this._ctx.save();
                this._ctx.setTransform(1, 0, 0, 1, 0, 0);
                this._ctx.clearRect(0, 0, this._container.width, this._container.height);
                this._ctx.restore();
            }
        },
        _draw: function() {
            var layer, bounds = this._redrawBounds;
            this._ctx.save();
            if (bounds) {
                var size = bounds.getSize();
                this._ctx.beginPath();
                this._ctx.rect(bounds.min.x, bounds.min.y, size.x, size.y);
                this._ctx.clip();
            }
            this._drawing = true;
            for(var order = this._drawFirst; order; order = order.next){
                layer = order.layer;
                if (!bounds || layer._pxBounds && layer._pxBounds.intersects(bounds)) layer._updatePath();
            }
            this._drawing = false;
            this._ctx.restore(); // Restore state before clipping.
        },
        _updatePoly: function(layer, closed) {
            if (!this._drawing) return;
            var i, j, len2, p, parts = layer._parts, len = parts.length, ctx = this._ctx;
            if (!len) return;
            ctx.beginPath();
            for(i = 0; i < len; i++){
                for(j = 0, len2 = parts[i].length; j < len2; j++){
                    p = parts[i][j];
                    ctx[j ? "lineTo" : "moveTo"](p.x, p.y);
                }
                if (closed) ctx.closePath();
            }
            this._fillStroke(ctx, layer);
        // TODO optimization: 1 fill/stroke for all features with equal style instead of 1 for each feature
        },
        _updateCircle: function(layer) {
            if (!this._drawing || layer._empty()) return;
            var p = layer._point, ctx = this._ctx, r = Math.max(Math.round(layer._radius), 1), s = (Math.max(Math.round(layer._radiusY), 1) || r) / r;
            if (s !== 1) {
                ctx.save();
                ctx.scale(1, s);
            }
            ctx.beginPath();
            ctx.arc(p.x, p.y / s, r, 0, Math.PI * 2, false);
            if (s !== 1) ctx.restore();
            this._fillStroke(ctx, layer);
        },
        _fillStroke: function(ctx, layer) {
            var options = layer.options;
            if (options.fill) {
                ctx.globalAlpha = options.fillOpacity;
                ctx.fillStyle = options.fillColor || options.color;
                ctx.fill(options.fillRule || "evenodd");
            }
            if (options.stroke && options.weight !== 0) {
                if (ctx.setLineDash) ctx.setLineDash(layer.options && layer.options._dashArray || []);
                ctx.globalAlpha = options.opacity;
                ctx.lineWidth = options.weight;
                ctx.strokeStyle = options.color;
                ctx.lineCap = options.lineCap;
                ctx.lineJoin = options.lineJoin;
                ctx.stroke();
            }
        },
        // Canvas obviously doesn't have mouse events for individual drawn objects,
        // so we emulate that by calculating what's under the mouse on mousemove/click manually
        _onClick: function(e) {
            var point = this._map.mouseEventToLayerPoint(e), layer, clickedLayer;
            for(var order = this._drawFirst; order; order = order.next){
                layer = order.layer;
                if (layer.options.interactive && layer._containsPoint(point)) {
                    if (!(e.type === "click" || e.type === "preclick") || !this._map._draggableMoved(layer)) clickedLayer = layer;
                }
            }
            this._fireEvent(clickedLayer ? [
                clickedLayer
            ] : false, e);
        },
        _onMouseMove: function(e) {
            if (!this._map || this._map.dragging.moving() || this._map._animatingZoom) return;
            var point = this._map.mouseEventToLayerPoint(e);
            this._handleMouseHover(e, point);
        },
        _handleMouseOut: function(e) {
            var layer = this._hoveredLayer;
            if (layer) {
                // if we're leaving the layer, fire mouseout
                removeClass(this._container, "leaflet-interactive");
                this._fireEvent([
                    layer
                ], e, "mouseout");
                this._hoveredLayer = null;
                this._mouseHoverThrottled = false;
            }
        },
        _handleMouseHover: function(e, point) {
            if (this._mouseHoverThrottled) return;
            var layer, candidateHoveredLayer;
            for(var order = this._drawFirst; order; order = order.next){
                layer = order.layer;
                if (layer.options.interactive && layer._containsPoint(point)) candidateHoveredLayer = layer;
            }
            if (candidateHoveredLayer !== this._hoveredLayer) {
                this._handleMouseOut(e);
                if (candidateHoveredLayer) {
                    addClass(this._container, "leaflet-interactive"); // change cursor
                    this._fireEvent([
                        candidateHoveredLayer
                    ], e, "mouseover");
                    this._hoveredLayer = candidateHoveredLayer;
                }
            }
            this._fireEvent(this._hoveredLayer ? [
                this._hoveredLayer
            ] : false, e);
            this._mouseHoverThrottled = true;
            setTimeout(bind(function() {
                this._mouseHoverThrottled = false;
            }, this), 32);
        },
        _fireEvent: function(layers, e, type) {
            this._map._fireDOMEvent(e, type || e.type, layers);
        },
        _bringToFront: function(layer) {
            var order = layer._order;
            if (!order) return;
            var next = order.next;
            var prev = order.prev;
            if (next) next.prev = prev;
            else // Already last
            return;
            if (prev) prev.next = next;
            else if (next) // Update first entry unless this is the
            // single entry
            this._drawFirst = next;
            order.prev = this._drawLast;
            this._drawLast.next = order;
            order.next = null;
            this._drawLast = order;
            this._requestRedraw(layer);
        },
        _bringToBack: function(layer) {
            var order = layer._order;
            if (!order) return;
            var next = order.next;
            var prev = order.prev;
            if (prev) prev.next = next;
            else // Already first
            return;
            if (next) next.prev = prev;
            else if (prev) // Update last entry unless this is the
            // single entry
            this._drawLast = prev;
            order.prev = null;
            order.next = this._drawFirst;
            this._drawFirst.prev = order;
            this._drawFirst = order;
            this._requestRedraw(layer);
        }
    });
    // @factory L.canvas(options?: Renderer options)
    // Creates a Canvas renderer with the given options.
    function canvas(options) {
        return Browser.canvas ? new Canvas(options) : null;
    }
    /*
   * Thanks to Dmitry Baranovsky and his Raphael library for inspiration!
   */ var vmlCreate = function() {
        try {
            document.namespaces.add("lvml", "urn:schemas-microsoft-com:vml");
            return function(name) {
                return document.createElement("<lvml:" + name + ' class="lvml">');
            };
        } catch (e) {
        // Do not return fn from catch block so `e` can be garbage collected
        // See https://github.com/Leaflet/Leaflet/pull/7279
        }
        return function(name) {
            return document.createElement("<" + name + ' xmlns="urn:schemas-microsoft.com:vml" class="lvml">');
        };
    }();
    /*
   * @class SVG
   *
   *
   * VML was deprecated in 2012, which means VML functionality exists only for backwards compatibility
   * with old versions of Internet Explorer.
   */ // mixin to redefine some SVG methods to handle VML syntax which is similar but with some differences
    var vmlMixin = {
        _initContainer: function() {
            this._container = create$1("div", "leaflet-vml-container");
        },
        _update: function() {
            if (this._map._animatingZoom) return;
            Renderer.prototype._update.call(this);
            this.fire("update");
        },
        _initPath: function(layer) {
            var container = layer._container = vmlCreate("shape");
            addClass(container, "leaflet-vml-shape " + (this.options.className || ""));
            container.coordsize = "1 1";
            layer._path = vmlCreate("path");
            container.appendChild(layer._path);
            this._updateStyle(layer);
            this._layers[stamp(layer)] = layer;
        },
        _addPath: function(layer) {
            var container = layer._container;
            this._container.appendChild(container);
            if (layer.options.interactive) layer.addInteractiveTarget(container);
        },
        _removePath: function(layer) {
            var container = layer._container;
            remove(container);
            layer.removeInteractiveTarget(container);
            delete this._layers[stamp(layer)];
        },
        _updateStyle: function(layer) {
            var stroke = layer._stroke, fill = layer._fill, options = layer.options, container = layer._container;
            container.stroked = !!options.stroke;
            container.filled = !!options.fill;
            if (options.stroke) {
                if (!stroke) stroke = layer._stroke = vmlCreate("stroke");
                container.appendChild(stroke);
                stroke.weight = options.weight + "px";
                stroke.color = options.color;
                stroke.opacity = options.opacity;
                if (options.dashArray) stroke.dashStyle = isArray(options.dashArray) ? options.dashArray.join(" ") : options.dashArray.replace(/( *, *)/g, " ");
                else stroke.dashStyle = "";
                stroke.endcap = options.lineCap.replace("butt", "flat");
                stroke.joinstyle = options.lineJoin;
            } else if (stroke) {
                container.removeChild(stroke);
                layer._stroke = null;
            }
            if (options.fill) {
                if (!fill) fill = layer._fill = vmlCreate("fill");
                container.appendChild(fill);
                fill.color = options.fillColor || options.color;
                fill.opacity = options.fillOpacity;
            } else if (fill) {
                container.removeChild(fill);
                layer._fill = null;
            }
        },
        _updateCircle: function(layer) {
            var p = layer._point.round(), r = Math.round(layer._radius), r2 = Math.round(layer._radiusY || r);
            this._setPath(layer, layer._empty() ? "M0 0" : "AL " + p.x + "," + p.y + " " + r + "," + r2 + " 0," + 23592600);
        },
        _setPath: function(layer, path) {
            layer._path.v = path;
        },
        _bringToFront: function(layer) {
            toFront(layer._container);
        },
        _bringToBack: function(layer) {
            toBack(layer._container);
        }
    };
    var create = Browser.vml ? vmlCreate : svgCreate;
    /*
   * @class SVG
   * @inherits Renderer
   * @aka L.SVG
   *
   * Allows vector layers to be displayed with [SVG](https://developer.mozilla.org/docs/Web/SVG).
   * Inherits `Renderer`.
   *
   * Due to [technical limitations](https://caniuse.com/svg), SVG is not
   * available in all web browsers, notably Android 2.x and 3.x.
   *
   * Although SVG is not available on IE7 and IE8, these browsers support
   * [VML](https://en.wikipedia.org/wiki/Vector_Markup_Language)
   * (a now deprecated technology), and the SVG renderer will fall back to VML in
   * this case.
   *
   * @example
   *
   * Use SVG by default for all paths in the map:
   *
   * ```js
   * var map = L.map('map', {
   * 	renderer: L.svg()
   * });
   * ```
   *
   * Use a SVG renderer with extra padding for specific vector geometries:
   *
   * ```js
   * var map = L.map('map');
   * var myRenderer = L.svg({ padding: 0.5 });
   * var line = L.polyline( coordinates, { renderer: myRenderer } );
   * var circle = L.circle( center, { renderer: myRenderer } );
   * ```
   */ var SVG = Renderer.extend({
        _initContainer: function() {
            this._container = create("svg");
            // makes it possible to click through svg root; we'll reset it back in individual paths
            this._container.setAttribute("pointer-events", "none");
            this._rootGroup = create("g");
            this._container.appendChild(this._rootGroup);
        },
        _destroyContainer: function() {
            remove(this._container);
            off(this._container);
            delete this._container;
            delete this._rootGroup;
            delete this._svgSize;
        },
        _update: function() {
            if (this._map._animatingZoom && this._bounds) return;
            Renderer.prototype._update.call(this);
            var b = this._bounds, size = b.getSize(), container = this._container;
            // set size of svg-container if changed
            if (!this._svgSize || !this._svgSize.equals(size)) {
                this._svgSize = size;
                container.setAttribute("width", size.x);
                container.setAttribute("height", size.y);
            }
            // movement: update container viewBox so that we don't have to change coordinates of individual layers
            setPosition(container, b.min);
            container.setAttribute("viewBox", [
                b.min.x,
                b.min.y,
                size.x,
                size.y
            ].join(" "));
            this.fire("update");
        },
        // methods below are called by vector layers implementations
        _initPath: function(layer) {
            var path = layer._path = create("path");
            // @namespace Path
            // @option className: String = null
            // Custom class name set on an element. Only for SVG renderer.
            if (layer.options.className) addClass(path, layer.options.className);
            if (layer.options.interactive) addClass(path, "leaflet-interactive");
            this._updateStyle(layer);
            this._layers[stamp(layer)] = layer;
        },
        _addPath: function(layer) {
            if (!this._rootGroup) this._initContainer();
            this._rootGroup.appendChild(layer._path);
            layer.addInteractiveTarget(layer._path);
        },
        _removePath: function(layer) {
            remove(layer._path);
            layer.removeInteractiveTarget(layer._path);
            delete this._layers[stamp(layer)];
        },
        _updatePath: function(layer) {
            layer._project();
            layer._update();
        },
        _updateStyle: function(layer) {
            var path = layer._path, options = layer.options;
            if (!path) return;
            if (options.stroke) {
                path.setAttribute("stroke", options.color);
                path.setAttribute("stroke-opacity", options.opacity);
                path.setAttribute("stroke-width", options.weight);
                path.setAttribute("stroke-linecap", options.lineCap);
                path.setAttribute("stroke-linejoin", options.lineJoin);
                if (options.dashArray) path.setAttribute("stroke-dasharray", options.dashArray);
                else path.removeAttribute("stroke-dasharray");
                if (options.dashOffset) path.setAttribute("stroke-dashoffset", options.dashOffset);
                else path.removeAttribute("stroke-dashoffset");
            } else path.setAttribute("stroke", "none");
            if (options.fill) {
                path.setAttribute("fill", options.fillColor || options.color);
                path.setAttribute("fill-opacity", options.fillOpacity);
                path.setAttribute("fill-rule", options.fillRule || "evenodd");
            } else path.setAttribute("fill", "none");
        },
        _updatePoly: function(layer, closed) {
            this._setPath(layer, pointsToPath(layer._parts, closed));
        },
        _updateCircle: function(layer) {
            var p = layer._point, r = Math.max(Math.round(layer._radius), 1), r2 = Math.max(Math.round(layer._radiusY), 1) || r, arc = "a" + r + "," + r2 + " 0 1,0 ";
            // drawing a circle with two half-arcs
            var d = layer._empty() ? "M0 0" : "M" + (p.x - r) + "," + p.y + arc + r * 2 + ",0 " + arc + -r * 2 + ",0 ";
            this._setPath(layer, d);
        },
        _setPath: function(layer, path) {
            layer._path.setAttribute("d", path);
        },
        // SVG does not have the concept of zIndex so we resort to changing the DOM order of elements
        _bringToFront: function(layer) {
            toFront(layer._path);
        },
        _bringToBack: function(layer) {
            toBack(layer._path);
        }
    });
    if (Browser.vml) SVG.include(vmlMixin);
    // @namespace SVG
    // @factory L.svg(options?: Renderer options)
    // Creates a SVG renderer with the given options.
    function svg(options) {
        return Browser.svg || Browser.vml ? new SVG(options) : null;
    }
    Map.include({
        // @namespace Map; @method getRenderer(layer: Path): Renderer
        // Returns the instance of `Renderer` that should be used to render the given
        // `Path`. It will ensure that the `renderer` options of the map and paths
        // are respected, and that the renderers do exist on the map.
        getRenderer: function(layer) {
            // @namespace Path; @option renderer: Renderer
            // Use this specific instance of `Renderer` for this path. Takes
            // precedence over the map's [default renderer](#map-renderer).
            var renderer = layer.options.renderer || this._getPaneRenderer(layer.options.pane) || this.options.renderer || this._renderer;
            if (!renderer) renderer = this._renderer = this._createRenderer();
            if (!this.hasLayer(renderer)) this.addLayer(renderer);
            return renderer;
        },
        _getPaneRenderer: function(name) {
            if (name === "overlayPane" || name === undefined) return false;
            var renderer = this._paneRenderers[name];
            if (renderer === undefined) {
                renderer = this._createRenderer({
                    pane: name
                });
                this._paneRenderers[name] = renderer;
            }
            return renderer;
        },
        _createRenderer: function(options) {
            // @namespace Map; @option preferCanvas: Boolean = false
            // Whether `Path`s should be rendered on a `Canvas` renderer.
            // By default, all `Path`s are rendered in a `SVG` renderer.
            return this.options.preferCanvas && canvas(options) || svg(options);
        }
    });
    /*
   * L.Rectangle extends Polygon and creates a rectangle when passed a LatLngBounds object.
   */ /*
   * @class Rectangle
   * @aka L.Rectangle
   * @inherits Polygon
   *
   * A class for drawing rectangle overlays on a map. Extends `Polygon`.
   *
   * @example
   *
   * ```js
   * // define rectangle geographical bounds
   * var bounds = [[54.559322, -5.767822], [56.1210604, -3.021240]];
   *
   * // create an orange rectangle
   * L.rectangle(bounds, {color: "#ff7800", weight: 1}).addTo(map);
   *
   * // zoom the map to the rectangle bounds
   * map.fitBounds(bounds);
   * ```
   *
   */ var Rectangle = Polygon.extend({
        initialize: function(latLngBounds, options) {
            Polygon.prototype.initialize.call(this, this._boundsToLatLngs(latLngBounds), options);
        },
        // @method setBounds(latLngBounds: LatLngBounds): this
        // Redraws the rectangle with the passed bounds.
        setBounds: function(latLngBounds) {
            return this.setLatLngs(this._boundsToLatLngs(latLngBounds));
        },
        _boundsToLatLngs: function(latLngBounds) {
            latLngBounds = toLatLngBounds(latLngBounds);
            return [
                latLngBounds.getSouthWest(),
                latLngBounds.getNorthWest(),
                latLngBounds.getNorthEast(),
                latLngBounds.getSouthEast()
            ];
        }
    });
    // @factory L.rectangle(latLngBounds: LatLngBounds, options?: Polyline options)
    function rectangle(latLngBounds, options) {
        return new Rectangle(latLngBounds, options);
    }
    SVG.create = create;
    SVG.pointsToPath = pointsToPath;
    GeoJSON.geometryToLayer = geometryToLayer;
    GeoJSON.coordsToLatLng = coordsToLatLng;
    GeoJSON.coordsToLatLngs = coordsToLatLngs;
    GeoJSON.latLngToCoords = latLngToCoords;
    GeoJSON.latLngsToCoords = latLngsToCoords;
    GeoJSON.getFeature = getFeature;
    GeoJSON.asFeature = asFeature;
    /*
   * L.Handler.BoxZoom is used to add shift-drag zoom interaction to the map
   * (zoom to a selected bounding box), enabled by default.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @option boxZoom: Boolean = true
        // Whether the map can be zoomed to a rectangular area specified by
        // dragging the mouse while pressing the shift key.
        boxZoom: true
    });
    var BoxZoom = Handler.extend({
        initialize: function(map) {
            this._map = map;
            this._container = map._container;
            this._pane = map._panes.overlayPane;
            this._resetStateTimeout = 0;
            map.on("unload", this._destroy, this);
        },
        addHooks: function() {
            on(this._container, "mousedown", this._onMouseDown, this);
        },
        removeHooks: function() {
            off(this._container, "mousedown", this._onMouseDown, this);
        },
        moved: function() {
            return this._moved;
        },
        _destroy: function() {
            remove(this._pane);
            delete this._pane;
        },
        _resetState: function() {
            this._resetStateTimeout = 0;
            this._moved = false;
        },
        _clearDeferredResetState: function() {
            if (this._resetStateTimeout !== 0) {
                clearTimeout(this._resetStateTimeout);
                this._resetStateTimeout = 0;
            }
        },
        _onMouseDown: function(e) {
            if (!e.shiftKey || e.which !== 1 && e.button !== 1) return false;
            // Clear the deferred resetState if it hasn't executed yet, otherwise it
            // will interrupt the interaction and orphan a box element in the container.
            this._clearDeferredResetState();
            this._resetState();
            disableTextSelection();
            disableImageDrag();
            this._startPoint = this._map.mouseEventToContainerPoint(e);
            on(document, {
                contextmenu: stop,
                mousemove: this._onMouseMove,
                mouseup: this._onMouseUp,
                keydown: this._onKeyDown
            }, this);
        },
        _onMouseMove: function(e) {
            if (!this._moved) {
                this._moved = true;
                this._box = create$1("div", "leaflet-zoom-box", this._container);
                addClass(this._container, "leaflet-crosshair");
                this._map.fire("boxzoomstart");
            }
            this._point = this._map.mouseEventToContainerPoint(e);
            var bounds = new Bounds(this._point, this._startPoint), size = bounds.getSize();
            setPosition(this._box, bounds.min);
            this._box.style.width = size.x + "px";
            this._box.style.height = size.y + "px";
        },
        _finish: function() {
            if (this._moved) {
                remove(this._box);
                removeClass(this._container, "leaflet-crosshair");
            }
            enableTextSelection();
            enableImageDrag();
            off(document, {
                contextmenu: stop,
                mousemove: this._onMouseMove,
                mouseup: this._onMouseUp,
                keydown: this._onKeyDown
            }, this);
        },
        _onMouseUp: function(e) {
            if (e.which !== 1 && e.button !== 1) return;
            this._finish();
            if (!this._moved) return;
            // Postpone to next JS tick so internal click event handling
            // still see it as "moved".
            this._clearDeferredResetState();
            this._resetStateTimeout = setTimeout(bind(this._resetState, this), 0);
            var bounds = new LatLngBounds(this._map.containerPointToLatLng(this._startPoint), this._map.containerPointToLatLng(this._point));
            this._map.fitBounds(bounds).fire("boxzoomend", {
                boxZoomBounds: bounds
            });
        },
        _onKeyDown: function(e) {
            if (e.keyCode === 27) {
                this._finish();
                this._clearDeferredResetState();
                this._resetState();
            }
        }
    });
    // @section Handlers
    // @property boxZoom: Handler
    // Box (shift-drag with mouse) zoom handler.
    Map.addInitHook("addHandler", "boxZoom", BoxZoom);
    /*
   * L.Handler.DoubleClickZoom is used to handle double-click zoom on the map, enabled by default.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @option doubleClickZoom: Boolean|String = true
        // Whether the map can be zoomed in by double clicking on it and
        // zoomed out by double clicking while holding shift. If passed
        // `'center'`, double-click zoom will zoom to the center of the
        //  view regardless of where the mouse was.
        doubleClickZoom: true
    });
    var DoubleClickZoom = Handler.extend({
        addHooks: function() {
            this._map.on("dblclick", this._onDoubleClick, this);
        },
        removeHooks: function() {
            this._map.off("dblclick", this._onDoubleClick, this);
        },
        _onDoubleClick: function(e) {
            var map = this._map, oldZoom = map.getZoom(), delta = map.options.zoomDelta, zoom = e.originalEvent.shiftKey ? oldZoom - delta : oldZoom + delta;
            if (map.options.doubleClickZoom === "center") map.setZoom(zoom);
            else map.setZoomAround(e.containerPoint, zoom);
        }
    });
    // @section Handlers
    //
    // Map properties include interaction handlers that allow you to control
    // interaction behavior in runtime, enabling or disabling certain features such
    // as dragging or touch zoom (see `Handler` methods). For example:
    //
    // ```js
    // map.doubleClickZoom.disable();
    // ```
    //
    // @property doubleClickZoom: Handler
    // Double click zoom handler.
    Map.addInitHook("addHandler", "doubleClickZoom", DoubleClickZoom);
    /*
   * L.Handler.MapDrag is used to make the map draggable (with panning inertia), enabled by default.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @option dragging: Boolean = true
        // Whether the map is draggable with mouse/touch or not.
        dragging: true,
        // @section Panning Inertia Options
        // @option inertia: Boolean = *
        // If enabled, panning of the map will have an inertia effect where
        // the map builds momentum while dragging and continues moving in
        // the same direction for some time. Feels especially nice on touch
        // devices. Enabled by default.
        inertia: true,
        // @option inertiaDeceleration: Number = 3000
        // The rate with which the inertial movement slows down, in pixels/second².
        inertiaDeceleration: 3400,
        // @option inertiaMaxSpeed: Number = Infinity
        // Max speed of the inertial movement, in pixels/second.
        inertiaMaxSpeed: Infinity,
        // @option easeLinearity: Number = 0.2
        easeLinearity: 0.2,
        // TODO refactor, move to CRS
        // @option worldCopyJump: Boolean = false
        // With this option enabled, the map tracks when you pan to another "copy"
        // of the world and seamlessly jumps to the original one so that all overlays
        // like markers and vector layers are still visible.
        worldCopyJump: false,
        // @option maxBoundsViscosity: Number = 0.0
        // If `maxBounds` is set, this option will control how solid the bounds
        // are when dragging the map around. The default value of `0.0` allows the
        // user to drag outside the bounds at normal speed, higher values will
        // slow down map dragging outside bounds, and `1.0` makes the bounds fully
        // solid, preventing the user from dragging outside the bounds.
        maxBoundsViscosity: 0.0
    });
    var Drag = Handler.extend({
        addHooks: function() {
            if (!this._draggable) {
                var map = this._map;
                this._draggable = new Draggable(map._mapPane, map._container);
                this._draggable.on({
                    dragstart: this._onDragStart,
                    drag: this._onDrag,
                    dragend: this._onDragEnd
                }, this);
                this._draggable.on("predrag", this._onPreDragLimit, this);
                if (map.options.worldCopyJump) {
                    this._draggable.on("predrag", this._onPreDragWrap, this);
                    map.on("zoomend", this._onZoomEnd, this);
                    map.whenReady(this._onZoomEnd, this);
                }
            }
            addClass(this._map._container, "leaflet-grab leaflet-touch-drag");
            this._draggable.enable();
            this._positions = [];
            this._times = [];
        },
        removeHooks: function() {
            removeClass(this._map._container, "leaflet-grab");
            removeClass(this._map._container, "leaflet-touch-drag");
            this._draggable.disable();
        },
        moved: function() {
            return this._draggable && this._draggable._moved;
        },
        moving: function() {
            return this._draggable && this._draggable._moving;
        },
        _onDragStart: function() {
            var map = this._map;
            map._stop();
            if (this._map.options.maxBounds && this._map.options.maxBoundsViscosity) {
                var bounds = toLatLngBounds(this._map.options.maxBounds);
                this._offsetLimit = toBounds(this._map.latLngToContainerPoint(bounds.getNorthWest()).multiplyBy(-1), this._map.latLngToContainerPoint(bounds.getSouthEast()).multiplyBy(-1).add(this._map.getSize()));
                this._viscosity = Math.min(1.0, Math.max(0.0, this._map.options.maxBoundsViscosity));
            } else this._offsetLimit = null;
            map.fire("movestart").fire("dragstart");
            if (map.options.inertia) {
                this._positions = [];
                this._times = [];
            }
        },
        _onDrag: function(e) {
            if (this._map.options.inertia) {
                var time = this._lastTime = +new Date(), pos = this._lastPos = this._draggable._absPos || this._draggable._newPos;
                this._positions.push(pos);
                this._times.push(time);
                this._prunePositions(time);
            }
            this._map.fire("move", e).fire("drag", e);
        },
        _prunePositions: function(time) {
            while(this._positions.length > 1 && time - this._times[0] > 50){
                this._positions.shift();
                this._times.shift();
            }
        },
        _onZoomEnd: function() {
            var pxCenter = this._map.getSize().divideBy(2), pxWorldCenter = this._map.latLngToLayerPoint([
                0,
                0
            ]);
            this._initialWorldOffset = pxWorldCenter.subtract(pxCenter).x;
            this._worldWidth = this._map.getPixelWorldBounds().getSize().x;
        },
        _viscousLimit: function(value, threshold) {
            return value - (value - threshold) * this._viscosity;
        },
        _onPreDragLimit: function() {
            if (!this._viscosity || !this._offsetLimit) return;
            var offset = this._draggable._newPos.subtract(this._draggable._startPos);
            var limit = this._offsetLimit;
            if (offset.x < limit.min.x) offset.x = this._viscousLimit(offset.x, limit.min.x);
            if (offset.y < limit.min.y) offset.y = this._viscousLimit(offset.y, limit.min.y);
            if (offset.x > limit.max.x) offset.x = this._viscousLimit(offset.x, limit.max.x);
            if (offset.y > limit.max.y) offset.y = this._viscousLimit(offset.y, limit.max.y);
            this._draggable._newPos = this._draggable._startPos.add(offset);
        },
        _onPreDragWrap: function() {
            // TODO refactor to be able to adjust map pane position after zoom
            var worldWidth = this._worldWidth, halfWidth = Math.round(worldWidth / 2), dx = this._initialWorldOffset, x = this._draggable._newPos.x, newX1 = (x - halfWidth + dx) % worldWidth + halfWidth - dx, newX2 = (x + halfWidth + dx) % worldWidth - halfWidth - dx, newX = Math.abs(newX1 + dx) < Math.abs(newX2 + dx) ? newX1 : newX2;
            this._draggable._absPos = this._draggable._newPos.clone();
            this._draggable._newPos.x = newX;
        },
        _onDragEnd: function(e) {
            var map = this._map, options = map.options, noInertia = !options.inertia || e.noInertia || this._times.length < 2;
            map.fire("dragend", e);
            if (noInertia) map.fire("moveend");
            else {
                this._prunePositions(+new Date());
                var direction = this._lastPos.subtract(this._positions[0]), duration = (this._lastTime - this._times[0]) / 1000, ease = options.easeLinearity, speedVector = direction.multiplyBy(ease / duration), speed = speedVector.distanceTo([
                    0,
                    0
                ]), limitedSpeed = Math.min(options.inertiaMaxSpeed, speed), limitedSpeedVector = speedVector.multiplyBy(limitedSpeed / speed), decelerationDuration = limitedSpeed / (options.inertiaDeceleration * ease), offset = limitedSpeedVector.multiplyBy(-decelerationDuration / 2).round();
                if (!offset.x && !offset.y) map.fire("moveend");
                else {
                    offset = map._limitOffset(offset, map.options.maxBounds);
                    requestAnimFrame(function() {
                        map.panBy(offset, {
                            duration: decelerationDuration,
                            easeLinearity: ease,
                            noMoveStart: true,
                            animate: true
                        });
                    });
                }
            }
        }
    });
    // @section Handlers
    // @property dragging: Handler
    // Map dragging handler (by both mouse and touch).
    Map.addInitHook("addHandler", "dragging", Drag);
    /*
   * L.Map.Keyboard is handling keyboard interaction with the map, enabled by default.
   */ // @namespace Map
    // @section Keyboard Navigation Options
    Map.mergeOptions({
        // @option keyboard: Boolean = true
        // Makes the map focusable and allows users to navigate the map with keyboard
        // arrows and `+`/`-` keys.
        keyboard: true,
        // @option keyboardPanDelta: Number = 80
        // Amount of pixels to pan when pressing an arrow key.
        keyboardPanDelta: 80
    });
    var Keyboard = Handler.extend({
        keyCodes: {
            left: [
                37
            ],
            right: [
                39
            ],
            down: [
                40
            ],
            up: [
                38
            ],
            zoomIn: [
                187,
                107,
                61,
                171
            ],
            zoomOut: [
                189,
                109,
                54,
                173
            ]
        },
        initialize: function(map) {
            this._map = map;
            this._setPanDelta(map.options.keyboardPanDelta);
            this._setZoomDelta(map.options.zoomDelta);
        },
        addHooks: function() {
            var container = this._map._container;
            // make the container focusable by tabbing
            if (container.tabIndex <= 0) container.tabIndex = "0";
            on(container, {
                focus: this._onFocus,
                blur: this._onBlur,
                mousedown: this._onMouseDown
            }, this);
            this._map.on({
                focus: this._addHooks,
                blur: this._removeHooks
            }, this);
        },
        removeHooks: function() {
            this._removeHooks();
            off(this._map._container, {
                focus: this._onFocus,
                blur: this._onBlur,
                mousedown: this._onMouseDown
            }, this);
            this._map.off({
                focus: this._addHooks,
                blur: this._removeHooks
            }, this);
        },
        _onMouseDown: function() {
            if (this._focused) return;
            var body = document.body, docEl = document.documentElement, top = body.scrollTop || docEl.scrollTop, left = body.scrollLeft || docEl.scrollLeft;
            this._map._container.focus();
            window.scrollTo(left, top);
        },
        _onFocus: function() {
            this._focused = true;
            this._map.fire("focus");
        },
        _onBlur: function() {
            this._focused = false;
            this._map.fire("blur");
        },
        _setPanDelta: function(panDelta) {
            var keys = this._panKeys = {}, codes = this.keyCodes, i, len;
            for(i = 0, len = codes.left.length; i < len; i++)keys[codes.left[i]] = [
                -1 * panDelta,
                0
            ];
            for(i = 0, len = codes.right.length; i < len; i++)keys[codes.right[i]] = [
                panDelta,
                0
            ];
            for(i = 0, len = codes.down.length; i < len; i++)keys[codes.down[i]] = [
                0,
                panDelta
            ];
            for(i = 0, len = codes.up.length; i < len; i++)keys[codes.up[i]] = [
                0,
                -1 * panDelta
            ];
        },
        _setZoomDelta: function(zoomDelta) {
            var keys = this._zoomKeys = {}, codes = this.keyCodes, i, len;
            for(i = 0, len = codes.zoomIn.length; i < len; i++)keys[codes.zoomIn[i]] = zoomDelta;
            for(i = 0, len = codes.zoomOut.length; i < len; i++)keys[codes.zoomOut[i]] = -zoomDelta;
        },
        _addHooks: function() {
            on(document, "keydown", this._onKeyDown, this);
        },
        _removeHooks: function() {
            off(document, "keydown", this._onKeyDown, this);
        },
        _onKeyDown: function(e) {
            if (e.altKey || e.ctrlKey || e.metaKey) return;
            var key = e.keyCode, map = this._map, offset;
            if (key in this._panKeys) {
                if (!map._panAnim || !map._panAnim._inProgress) {
                    offset = this._panKeys[key];
                    if (e.shiftKey) offset = toPoint(offset).multiplyBy(3);
                    if (map.options.maxBounds) offset = map._limitOffset(toPoint(offset), map.options.maxBounds);
                    if (map.options.worldCopyJump) {
                        var newLatLng = map.wrapLatLng(map.unproject(map.project(map.getCenter()).add(offset)));
                        map.panTo(newLatLng);
                    } else map.panBy(offset);
                }
            } else if (key in this._zoomKeys) map.setZoom(map.getZoom() + (e.shiftKey ? 3 : 1) * this._zoomKeys[key]);
            else if (key === 27 && map._popup && map._popup.options.closeOnEscapeKey) map.closePopup();
            else return;
            stop(e);
        }
    });
    // @section Handlers
    // @section Handlers
    // @property keyboard: Handler
    // Keyboard navigation handler.
    Map.addInitHook("addHandler", "keyboard", Keyboard);
    /*
   * L.Handler.ScrollWheelZoom is used by L.Map to enable mouse scroll wheel zoom on the map.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @section Mouse wheel options
        // @option scrollWheelZoom: Boolean|String = true
        // Whether the map can be zoomed by using the mouse wheel. If passed `'center'`,
        // it will zoom to the center of the view regardless of where the mouse was.
        scrollWheelZoom: true,
        // @option wheelDebounceTime: Number = 40
        // Limits the rate at which a wheel can fire (in milliseconds). By default
        // user can't zoom via wheel more often than once per 40 ms.
        wheelDebounceTime: 40,
        // @option wheelPxPerZoomLevel: Number = 60
        // How many scroll pixels (as reported by [L.DomEvent.getWheelDelta](#domevent-getwheeldelta))
        // mean a change of one full zoom level. Smaller values will make wheel-zooming
        // faster (and vice versa).
        wheelPxPerZoomLevel: 60
    });
    var ScrollWheelZoom = Handler.extend({
        addHooks: function() {
            on(this._map._container, "wheel", this._onWheelScroll, this);
            this._delta = 0;
        },
        removeHooks: function() {
            off(this._map._container, "wheel", this._onWheelScroll, this);
        },
        _onWheelScroll: function(e) {
            var delta = getWheelDelta(e);
            var debounce = this._map.options.wheelDebounceTime;
            this._delta += delta;
            this._lastMousePos = this._map.mouseEventToContainerPoint(e);
            if (!this._startTime) this._startTime = +new Date();
            var left = Math.max(debounce - (+new Date() - this._startTime), 0);
            clearTimeout(this._timer);
            this._timer = setTimeout(bind(this._performZoom, this), left);
            stop(e);
        },
        _performZoom: function() {
            var map = this._map, zoom = map.getZoom(), snap = this._map.options.zoomSnap || 0;
            map._stop(); // stop panning and fly animations if any
            // map the delta with a sigmoid function to -4..4 range leaning on -1..1
            var d2 = this._delta / (this._map.options.wheelPxPerZoomLevel * 4), d3 = 4 * Math.log(2 / (1 + Math.exp(-Math.abs(d2)))) / Math.LN2, d4 = snap ? Math.ceil(d3 / snap) * snap : d3, delta = map._limitZoom(zoom + (this._delta > 0 ? d4 : -d4)) - zoom;
            this._delta = 0;
            this._startTime = null;
            if (!delta) return;
            if (map.options.scrollWheelZoom === "center") map.setZoom(zoom + delta);
            else map.setZoomAround(this._lastMousePos, zoom + delta);
        }
    });
    // @section Handlers
    // @property scrollWheelZoom: Handler
    // Scroll wheel zoom handler.
    Map.addInitHook("addHandler", "scrollWheelZoom", ScrollWheelZoom);
    /*
   * L.Map.TapHold is used to simulate `contextmenu` event on long hold,
   * which otherwise is not fired by mobile Safari.
   */ var tapHoldDelay = 600;
    // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @section Touch interaction options
        // @option tapHold: Boolean
        // Enables simulation of `contextmenu` event, default is `true` for mobile Safari.
        tapHold: Browser.touchNative && Browser.safari && Browser.mobile,
        // @option tapTolerance: Number = 15
        // The max number of pixels a user can shift his finger during touch
        // for it to be considered a valid tap.
        tapTolerance: 15
    });
    var TapHold = Handler.extend({
        addHooks: function() {
            on(this._map._container, "touchstart", this._onDown, this);
        },
        removeHooks: function() {
            off(this._map._container, "touchstart", this._onDown, this);
        },
        _onDown: function(e) {
            clearTimeout(this._holdTimeout);
            if (e.touches.length !== 1) return;
            var first = e.touches[0];
            this._startPos = this._newPos = new Point(first.clientX, first.clientY);
            this._holdTimeout = setTimeout(bind(function() {
                this._cancel();
                if (!this._isTapValid()) return;
                // prevent simulated mouse events https://w3c.github.io/touch-events/#mouse-events
                on(document, "touchend", preventDefault);
                on(document, "touchend touchcancel", this._cancelClickPrevent);
                this._simulateEvent("contextmenu", first);
            }, this), tapHoldDelay);
            on(document, "touchend touchcancel contextmenu", this._cancel, this);
            on(document, "touchmove", this._onMove, this);
        },
        _cancelClickPrevent: function cancelClickPrevent() {
            off(document, "touchend", preventDefault);
            off(document, "touchend touchcancel", cancelClickPrevent);
        },
        _cancel: function() {
            clearTimeout(this._holdTimeout);
            off(document, "touchend touchcancel contextmenu", this._cancel, this);
            off(document, "touchmove", this._onMove, this);
        },
        _onMove: function(e) {
            var first = e.touches[0];
            this._newPos = new Point(first.clientX, first.clientY);
        },
        _isTapValid: function() {
            return this._newPos.distanceTo(this._startPos) <= this._map.options.tapTolerance;
        },
        _simulateEvent: function(type, e) {
            var simulatedEvent = new MouseEvent(type, {
                bubbles: true,
                cancelable: true,
                view: window,
                // detail: 1,
                screenX: e.screenX,
                screenY: e.screenY,
                clientX: e.clientX,
                clientY: e.clientY
            });
            simulatedEvent._simulated = true;
            e.target.dispatchEvent(simulatedEvent);
        }
    });
    // @section Handlers
    // @property tapHold: Handler
    // Long tap handler to simulate `contextmenu` event (useful in mobile Safari).
    Map.addInitHook("addHandler", "tapHold", TapHold);
    /*
   * L.Handler.TouchZoom is used by L.Map to add pinch zoom on supported mobile browsers.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @section Touch interaction options
        // @option touchZoom: Boolean|String = *
        // Whether the map can be zoomed by touch-dragging with two fingers. If
        // passed `'center'`, it will zoom to the center of the view regardless of
        // where the touch events (fingers) were. Enabled for touch-capable web
        // browsers.
        touchZoom: Browser.touch,
        // @option bounceAtZoomLimits: Boolean = true
        // Set it to false if you don't want the map to zoom beyond min/max zoom
        // and then bounce back when pinch-zooming.
        bounceAtZoomLimits: true
    });
    var TouchZoom = Handler.extend({
        addHooks: function() {
            addClass(this._map._container, "leaflet-touch-zoom");
            on(this._map._container, "touchstart", this._onTouchStart, this);
        },
        removeHooks: function() {
            removeClass(this._map._container, "leaflet-touch-zoom");
            off(this._map._container, "touchstart", this._onTouchStart, this);
        },
        _onTouchStart: function(e) {
            var map = this._map;
            if (!e.touches || e.touches.length !== 2 || map._animatingZoom || this._zooming) return;
            var p1 = map.mouseEventToContainerPoint(e.touches[0]), p2 = map.mouseEventToContainerPoint(e.touches[1]);
            this._centerPoint = map.getSize()._divideBy(2);
            this._startLatLng = map.containerPointToLatLng(this._centerPoint);
            if (map.options.touchZoom !== "center") this._pinchStartLatLng = map.containerPointToLatLng(p1.add(p2)._divideBy(2));
            this._startDist = p1.distanceTo(p2);
            this._startZoom = map.getZoom();
            this._moved = false;
            this._zooming = true;
            map._stop();
            on(document, "touchmove", this._onTouchMove, this);
            on(document, "touchend touchcancel", this._onTouchEnd, this);
            preventDefault(e);
        },
        _onTouchMove: function(e) {
            if (!e.touches || e.touches.length !== 2 || !this._zooming) return;
            var map = this._map, p1 = map.mouseEventToContainerPoint(e.touches[0]), p2 = map.mouseEventToContainerPoint(e.touches[1]), scale = p1.distanceTo(p2) / this._startDist;
            this._zoom = map.getScaleZoom(scale, this._startZoom);
            if (!map.options.bounceAtZoomLimits && (this._zoom < map.getMinZoom() && scale < 1 || this._zoom > map.getMaxZoom() && scale > 1)) this._zoom = map._limitZoom(this._zoom);
            if (map.options.touchZoom === "center") {
                this._center = this._startLatLng;
                if (scale === 1) return;
            } else {
                // Get delta from pinch to center, so centerLatLng is delta applied to initial pinchLatLng
                var delta = p1._add(p2)._divideBy(2)._subtract(this._centerPoint);
                if (scale === 1 && delta.x === 0 && delta.y === 0) return;
                this._center = map.unproject(map.project(this._pinchStartLatLng, this._zoom).subtract(delta), this._zoom);
            }
            if (!this._moved) {
                map._moveStart(true, false);
                this._moved = true;
            }
            cancelAnimFrame(this._animRequest);
            var moveFn = bind(map._move, map, this._center, this._zoom, {
                pinch: true,
                round: false
            }, undefined);
            this._animRequest = requestAnimFrame(moveFn, this, true);
            preventDefault(e);
        },
        _onTouchEnd: function() {
            if (!this._moved || !this._zooming) {
                this._zooming = false;
                return;
            }
            this._zooming = false;
            cancelAnimFrame(this._animRequest);
            off(document, "touchmove", this._onTouchMove, this);
            off(document, "touchend touchcancel", this._onTouchEnd, this);
            // Pinch updates GridLayers' levels only when zoomSnap is off, so zoomSnap becomes noUpdate.
            if (this._map.options.zoomAnimation) this._map._animateZoom(this._center, this._map._limitZoom(this._zoom), true, this._map.options.zoomSnap);
            else this._map._resetView(this._center, this._map._limitZoom(this._zoom));
        }
    });
    // @section Handlers
    // @property touchZoom: Handler
    // Touch zoom handler.
    Map.addInitHook("addHandler", "touchZoom", TouchZoom);
    Map.BoxZoom = BoxZoom;
    Map.DoubleClickZoom = DoubleClickZoom;
    Map.Drag = Drag;
    Map.Keyboard = Keyboard;
    Map.ScrollWheelZoom = ScrollWheelZoom;
    Map.TapHold = TapHold;
    Map.TouchZoom = TouchZoom;
    exports1.Bounds = Bounds;
    exports1.Browser = Browser;
    exports1.CRS = CRS;
    exports1.Canvas = Canvas;
    exports1.Circle = Circle;
    exports1.CircleMarker = CircleMarker;
    exports1.Class = Class;
    exports1.Control = Control;
    exports1.DivIcon = DivIcon;
    exports1.DivOverlay = DivOverlay;
    exports1.DomEvent = DomEvent;
    exports1.DomUtil = DomUtil;
    exports1.Draggable = Draggable;
    exports1.Evented = Evented;
    exports1.FeatureGroup = FeatureGroup;
    exports1.GeoJSON = GeoJSON;
    exports1.GridLayer = GridLayer;
    exports1.Handler = Handler;
    exports1.Icon = Icon;
    exports1.ImageOverlay = ImageOverlay;
    exports1.LatLng = LatLng;
    exports1.LatLngBounds = LatLngBounds;
    exports1.Layer = Layer;
    exports1.LayerGroup = LayerGroup;
    exports1.LineUtil = LineUtil;
    exports1.Map = Map;
    exports1.Marker = Marker;
    exports1.Mixin = Mixin;
    exports1.Path = Path;
    exports1.Point = Point;
    exports1.PolyUtil = PolyUtil;
    exports1.Polygon = Polygon;
    exports1.Polyline = Polyline;
    exports1.Popup = Popup;
    exports1.PosAnimation = PosAnimation;
    exports1.Projection = index;
    exports1.Rectangle = Rectangle;
    exports1.Renderer = Renderer;
    exports1.SVG = SVG;
    exports1.SVGOverlay = SVGOverlay;
    exports1.TileLayer = TileLayer;
    exports1.Tooltip = Tooltip;
    exports1.Transformation = Transformation;
    exports1.Util = Util;
    exports1.VideoOverlay = VideoOverlay;
    exports1.bind = bind;
    exports1.bounds = toBounds;
    exports1.canvas = canvas;
    exports1.circle = circle;
    exports1.circleMarker = circleMarker;
    exports1.control = control;
    exports1.divIcon = divIcon;
    exports1.extend = extend;
    exports1.featureGroup = featureGroup;
    exports1.geoJSON = geoJSON;
    exports1.geoJson = geoJson;
    exports1.gridLayer = gridLayer;
    exports1.icon = icon;
    exports1.imageOverlay = imageOverlay;
    exports1.latLng = toLatLng;
    exports1.latLngBounds = toLatLngBounds;
    exports1.layerGroup = layerGroup;
    exports1.map = createMap;
    exports1.marker = marker;
    exports1.point = toPoint;
    exports1.polygon = polygon;
    exports1.polyline = polyline;
    exports1.popup = popup;
    exports1.rectangle = rectangle;
    exports1.setOptions = setOptions;
    exports1.stamp = stamp;
    exports1.svg = svg;
    exports1.svgOverlay = svgOverlay;
    exports1.tileLayer = tileLayer;
    exports1.tooltip = tooltip;
    exports1.transformation = toTransformation;
    exports1.version = version;
    exports1.videoOverlay = videoOverlay;
    var oldL = window.L;
    exports1.noConflict = function() {
        window.L = oldL;
        return this;
    };
    // Always export us to window global (see #2364)
    window.L = exports1;
});

});

parcelRegister("6RNKk", function(module, exports) {

$parcel$export(module.exports, "animator", function () { return $4ffe47e38c59be9a$export$a424a0aa8f687495; });
$parcel$export(module.exports, "Animation", function () { return $4ffe47e38c59be9a$export$c35d437ae5945fcd; });
$parcel$export(module.exports, "Animations", function () { return $4ffe47e38c59be9a$export$8ab227dac26677d; });
$parcel$export(module.exports, "DatasetController", function () { return $4ffe47e38c59be9a$export$75572ec5c55b4048; });
$parcel$export(module.exports, "BarController", function () { return $4ffe47e38c59be9a$export$e97d5dc64e999004; });
$parcel$export(module.exports, "BubbleController", function () { return $4ffe47e38c59be9a$export$19b5c4773f17abe; });
$parcel$export(module.exports, "DoughnutController", function () { return $4ffe47e38c59be9a$export$e04603e7d8b77172; });
$parcel$export(module.exports, "LineController", function () { return $4ffe47e38c59be9a$export$3c9b5d28c11cbfd0; });
$parcel$export(module.exports, "PolarAreaController", function () { return $4ffe47e38c59be9a$export$2a270b3a0d973c85; });
$parcel$export(module.exports, "PieController", function () { return $4ffe47e38c59be9a$export$b21a3f1286706191; });
$parcel$export(module.exports, "RadarController", function () { return $4ffe47e38c59be9a$export$48dbc6ac651bf8be; });
$parcel$export(module.exports, "ScatterController", function () { return $4ffe47e38c59be9a$export$b2f2bae6713db87; });
$parcel$export(module.exports, "controllers", function () { return $4ffe47e38c59be9a$export$a6506504f799c5d5; });
$parcel$export(module.exports, "_adapters", function () { return $4ffe47e38c59be9a$export$f32766ea09ec8bc4; });
$parcel$export(module.exports, "Interaction", function () { return $4ffe47e38c59be9a$export$a13296960cae0384; });
$parcel$export(module.exports, "layouts", function () { return $4ffe47e38c59be9a$export$1ecca0613f5e56d2; });
$parcel$export(module.exports, "BasePlatform", function () { return $4ffe47e38c59be9a$export$7b1aeb87f31f7da8; });
$parcel$export(module.exports, "BasicPlatform", function () { return $4ffe47e38c59be9a$export$a40a96b24b46cf35; });
$parcel$export(module.exports, "DomPlatform", function () { return $4ffe47e38c59be9a$export$f02da7f882cf6b2e; });
$parcel$export(module.exports, "Element", function () { return $4ffe47e38c59be9a$export$db77ccec0bb4ccac; });
$parcel$export(module.exports, "Ticks", function () { return $4ffe47e38c59be9a$export$27c7467594ef87bd; });
$parcel$export(module.exports, "Scale", function () { return $4ffe47e38c59be9a$export$d60cfc58d3c358b6; });
$parcel$export(module.exports, "registry", function () { return $4ffe47e38c59be9a$export$4bb7493d241fd8a5; });
$parcel$export(module.exports, "Chart", function () { return $4ffe47e38c59be9a$export$acaa6426d77a227e; });
$parcel$export(module.exports, "ArcElement", function () { return $4ffe47e38c59be9a$export$d48203c759d6a1fc; });
$parcel$export(module.exports, "LineElement", function () { return $4ffe47e38c59be9a$export$55e463fa7bcd3469; });
$parcel$export(module.exports, "PointElement", function () { return $4ffe47e38c59be9a$export$bd159b522b230b7a; });
$parcel$export(module.exports, "BarElement", function () { return $4ffe47e38c59be9a$export$a16ed71bf4b07672; });
$parcel$export(module.exports, "elements", function () { return $4ffe47e38c59be9a$export$7a5d735b2ab6389d; });
$parcel$export(module.exports, "Decimation", function () { return $4ffe47e38c59be9a$export$be17f937e9aa7533; });
$parcel$export(module.exports, "Filler", function () { return $4ffe47e38c59be9a$export$d19ba4d812bed757; });
$parcel$export(module.exports, "Legend", function () { return $4ffe47e38c59be9a$export$ed247974535929c7; });
$parcel$export(module.exports, "Title", function () { return $4ffe47e38c59be9a$export$f99233281efd08a0; });
$parcel$export(module.exports, "SubTitle", function () { return $4ffe47e38c59be9a$export$d5c56664638992a4; });
$parcel$export(module.exports, "Tooltip", function () { return $4ffe47e38c59be9a$export$28c660c63b792dea; });
$parcel$export(module.exports, "plugins", function () { return $4ffe47e38c59be9a$export$8b3ca321c77fdea6; });
$parcel$export(module.exports, "CategoryScale", function () { return $4ffe47e38c59be9a$export$29e663ba4d09fe7; });
$parcel$export(module.exports, "LinearScale", function () { return $4ffe47e38c59be9a$export$e7f4e5e8656f0b93; });
$parcel$export(module.exports, "LogarithmicScale", function () { return $4ffe47e38c59be9a$export$85295eaf7cb3ac3e; });
$parcel$export(module.exports, "RadialLinearScale", function () { return $4ffe47e38c59be9a$export$cfafc36d95386d38; });
$parcel$export(module.exports, "TimeScale", function () { return $4ffe47e38c59be9a$export$a894c72689ff3ec; });
$parcel$export(module.exports, "TimeSeriesScale", function () { return $4ffe47e38c59be9a$export$85df64a8eb6dc986; });
$parcel$export(module.exports, "scales", function () { return $4ffe47e38c59be9a$export$bcac1c16f1530ec2; });
$parcel$export(module.exports, "registerables", function () { return $4ffe47e38c59be9a$export$e8959e79e3af550f; });
$parcel$export(module.exports, "defaults", function () { return (parcelRequire("breCz")).d; });
/*!
 * Chart.js v3.4.1
 * https://www.chartjs.org
 * (c) 2021 Chart.js Contributors
 * Released under the MIT License
 */ 
var $breCz = parcelRequire("breCz");
class $4ffe47e38c59be9a$var$Animator {
    constructor(){
        this._request = null;
        this._charts = new Map();
        this._running = false;
        this._lastDate = undefined;
    }
    _notify(chart, anims, date, type) {
        const callbacks = anims.listeners[type];
        const numSteps = anims.duration;
        callbacks.forEach((fn)=>fn({
                chart: chart,
                initial: anims.initial,
                numSteps: numSteps,
                currentStep: Math.min(date - anims.start, numSteps)
            }));
    }
    _refresh() {
        const me = this;
        if (me._request) return;
        me._running = true;
        me._request = (0, $breCz.r).call(window, ()=>{
            me._update();
            me._request = null;
            if (me._running) me._refresh();
        });
    }
    _update(date = Date.now()) {
        const me = this;
        let remaining = 0;
        me._charts.forEach((anims, chart)=>{
            if (!anims.running || !anims.items.length) return;
            const items = anims.items;
            let i = items.length - 1;
            let draw = false;
            let item;
            for(; i >= 0; --i){
                item = items[i];
                if (item._active) {
                    if (item._total > anims.duration) anims.duration = item._total;
                    item.tick(date);
                    draw = true;
                } else {
                    items[i] = items[items.length - 1];
                    items.pop();
                }
            }
            if (draw) {
                chart.draw();
                me._notify(chart, anims, date, "progress");
            }
            if (!items.length) {
                anims.running = false;
                me._notify(chart, anims, date, "complete");
                anims.initial = false;
            }
            remaining += items.length;
        });
        me._lastDate = date;
        if (remaining === 0) me._running = false;
    }
    _getAnims(chart) {
        const charts = this._charts;
        let anims = charts.get(chart);
        if (!anims) {
            anims = {
                running: false,
                initial: true,
                items: [],
                listeners: {
                    complete: [],
                    progress: []
                }
            };
            charts.set(chart, anims);
        }
        return anims;
    }
    listen(chart, event, cb) {
        this._getAnims(chart).listeners[event].push(cb);
    }
    add(chart, items) {
        if (!items || !items.length) return;
        this._getAnims(chart).items.push(...items);
    }
    has(chart) {
        return this._getAnims(chart).items.length > 0;
    }
    start(chart) {
        const anims = this._charts.get(chart);
        if (!anims) return;
        anims.running = true;
        anims.start = Date.now();
        anims.duration = anims.items.reduce((acc, cur)=>Math.max(acc, cur._duration), 0);
        this._refresh();
    }
    running(chart) {
        if (!this._running) return false;
        const anims = this._charts.get(chart);
        if (!anims || !anims.running || !anims.items.length) return false;
        return true;
    }
    stop(chart) {
        const anims = this._charts.get(chart);
        if (!anims || !anims.items.length) return;
        const items = anims.items;
        let i = items.length - 1;
        for(; i >= 0; --i)items[i].cancel();
        anims.items = [];
        this._notify(chart, anims, Date.now(), "complete");
    }
    remove(chart) {
        return this._charts.delete(chart);
    }
}
var $4ffe47e38c59be9a$export$a424a0aa8f687495 = new $4ffe47e38c59be9a$var$Animator();
const $4ffe47e38c59be9a$var$transparent = "transparent";
const $4ffe47e38c59be9a$var$interpolators = {
    boolean (from, to, factor) {
        return factor > 0.5 ? to : from;
    },
    color (from, to, factor) {
        const c0 = (0, $breCz.c)(from || $4ffe47e38c59be9a$var$transparent);
        const c1 = c0.valid && (0, $breCz.c)(to || $4ffe47e38c59be9a$var$transparent);
        return c1 && c1.valid ? c1.mix(c0, factor).hexString() : to;
    },
    number (from, to, factor) {
        return from + (to - from) * factor;
    }
};
class $4ffe47e38c59be9a$export$c35d437ae5945fcd {
    constructor(cfg, target, prop, to){
        const currentValue = target[prop];
        to = (0, $breCz.a)([
            cfg.to,
            to,
            currentValue,
            cfg.from
        ]);
        const from = (0, $breCz.a)([
            cfg.from,
            currentValue,
            to
        ]);
        this._active = true;
        this._fn = cfg.fn || $4ffe47e38c59be9a$var$interpolators[cfg.type || typeof from];
        this._easing = (0, $breCz.e)[cfg.easing] || (0, $breCz.e).linear;
        this._start = Math.floor(Date.now() + (cfg.delay || 0));
        this._duration = this._total = Math.floor(cfg.duration);
        this._loop = !!cfg.loop;
        this._target = target;
        this._prop = prop;
        this._from = from;
        this._to = to;
        this._promises = undefined;
    }
    active() {
        return this._active;
    }
    update(cfg, to, date) {
        const me = this;
        if (me._active) {
            me._notify(false);
            const currentValue = me._target[me._prop];
            const elapsed = date - me._start;
            const remain = me._duration - elapsed;
            me._start = date;
            me._duration = Math.floor(Math.max(remain, cfg.duration));
            me._total += elapsed;
            me._loop = !!cfg.loop;
            me._to = (0, $breCz.a)([
                cfg.to,
                to,
                currentValue,
                cfg.from
            ]);
            me._from = (0, $breCz.a)([
                cfg.from,
                currentValue,
                to
            ]);
        }
    }
    cancel() {
        const me = this;
        if (me._active) {
            me.tick(Date.now());
            me._active = false;
            me._notify(false);
        }
    }
    tick(date) {
        const me = this;
        const elapsed = date - me._start;
        const duration = me._duration;
        const prop = me._prop;
        const from = me._from;
        const loop = me._loop;
        const to = me._to;
        let factor;
        me._active = from !== to && (loop || elapsed < duration);
        if (!me._active) {
            me._target[prop] = to;
            me._notify(true);
            return;
        }
        if (elapsed < 0) {
            me._target[prop] = from;
            return;
        }
        factor = elapsed / duration % 2;
        factor = loop && factor > 1 ? 2 - factor : factor;
        factor = me._easing(Math.min(1, Math.max(0, factor)));
        me._target[prop] = me._fn(from, to, factor);
    }
    wait() {
        const promises = this._promises || (this._promises = []);
        return new Promise((res, rej)=>{
            promises.push({
                res: res,
                rej: rej
            });
        });
    }
    _notify(resolved) {
        const method = resolved ? "res" : "rej";
        const promises = this._promises || [];
        for(let i = 0; i < promises.length; i++)promises[i][method]();
    }
}
const $4ffe47e38c59be9a$var$numbers = [
    "x",
    "y",
    "borderWidth",
    "radius",
    "tension"
];
const $4ffe47e38c59be9a$var$colors = [
    "color",
    "borderColor",
    "backgroundColor"
];
(0, $breCz.d).set("animation", {
    delay: undefined,
    duration: 1000,
    easing: "easeOutQuart",
    fn: undefined,
    from: undefined,
    loop: undefined,
    to: undefined,
    type: undefined
});
const $4ffe47e38c59be9a$var$animationOptions = Object.keys((0, $breCz.d).animation);
(0, $breCz.d).describe("animation", {
    _fallback: false,
    _indexable: false,
    _scriptable: (name)=>name !== "onProgress" && name !== "onComplete" && name !== "fn"
});
(0, $breCz.d).set("animations", {
    colors: {
        type: "color",
        properties: $4ffe47e38c59be9a$var$colors
    },
    numbers: {
        type: "number",
        properties: $4ffe47e38c59be9a$var$numbers
    }
});
(0, $breCz.d).describe("animations", {
    _fallback: "animation"
});
(0, $breCz.d).set("transitions", {
    active: {
        animation: {
            duration: 400
        }
    },
    resize: {
        animation: {
            duration: 0
        }
    },
    show: {
        animations: {
            colors: {
                from: "transparent"
            },
            visible: {
                type: "boolean",
                duration: 0
            }
        }
    },
    hide: {
        animations: {
            colors: {
                to: "transparent"
            },
            visible: {
                type: "boolean",
                easing: "linear",
                fn: (v)=>v | 0
            }
        }
    }
});
class $4ffe47e38c59be9a$export$8ab227dac26677d {
    constructor(chart, config){
        this._chart = chart;
        this._properties = new Map();
        this.configure(config);
    }
    configure(config) {
        if (!(0, $breCz.i)(config)) return;
        const animatedProps = this._properties;
        Object.getOwnPropertyNames(config).forEach((key)=>{
            const cfg = config[key];
            if (!(0, $breCz.i)(cfg)) return;
            const resolved = {};
            for (const option of $4ffe47e38c59be9a$var$animationOptions)resolved[option] = cfg[option];
            ((0, $breCz.b)(cfg.properties) && cfg.properties || [
                key
            ]).forEach((prop)=>{
                if (prop === key || !animatedProps.has(prop)) animatedProps.set(prop, resolved);
            });
        });
    }
    _animateOptions(target, values) {
        const newOptions = values.options;
        const options = $4ffe47e38c59be9a$var$resolveTargetOptions(target, newOptions);
        if (!options) return [];
        const animations = this._createAnimations(options, newOptions);
        if (newOptions.$shared) $4ffe47e38c59be9a$var$awaitAll(target.options.$animations, newOptions).then(()=>{
            target.options = newOptions;
        }, ()=>{});
        return animations;
    }
    _createAnimations(target, values) {
        const animatedProps = this._properties;
        const animations = [];
        const running = target.$animations || (target.$animations = {});
        const props = Object.keys(values);
        const date = Date.now();
        let i;
        for(i = props.length - 1; i >= 0; --i){
            const prop = props[i];
            if (prop.charAt(0) === "$") continue;
            if (prop === "options") {
                animations.push(...this._animateOptions(target, values));
                continue;
            }
            const value = values[prop];
            let animation = running[prop];
            const cfg = animatedProps.get(prop);
            if (animation) {
                if (cfg && animation.active()) {
                    animation.update(cfg, value, date);
                    continue;
                } else animation.cancel();
            }
            if (!cfg || !cfg.duration) {
                target[prop] = value;
                continue;
            }
            running[prop] = animation = new $4ffe47e38c59be9a$export$c35d437ae5945fcd(cfg, target, prop, value);
            animations.push(animation);
        }
        return animations;
    }
    update(target, values) {
        if (this._properties.size === 0) {
            Object.assign(target, values);
            return;
        }
        const animations = this._createAnimations(target, values);
        if (animations.length) {
            $4ffe47e38c59be9a$export$a424a0aa8f687495.add(this._chart, animations);
            return true;
        }
    }
}
function $4ffe47e38c59be9a$var$awaitAll(animations, properties) {
    const running = [];
    const keys = Object.keys(properties);
    for(let i = 0; i < keys.length; i++){
        const anim = animations[keys[i]];
        if (anim && anim.active()) running.push(anim.wait());
    }
    return Promise.all(running);
}
function $4ffe47e38c59be9a$var$resolveTargetOptions(target, newOptions) {
    if (!newOptions) return;
    let options = target.options;
    if (!options) {
        target.options = newOptions;
        return;
    }
    if (options.$shared) target.options = options = Object.assign({}, options, {
        $shared: false,
        $animations: {}
    });
    return options;
}
function $4ffe47e38c59be9a$var$scaleClip(scale, allowedOverflow) {
    const opts = scale && scale.options || {};
    const reverse = opts.reverse;
    const min = opts.min === undefined ? allowedOverflow : 0;
    const max = opts.max === undefined ? allowedOverflow : 0;
    return {
        start: reverse ? max : min,
        end: reverse ? min : max
    };
}
function $4ffe47e38c59be9a$var$defaultClip(xScale, yScale, allowedOverflow) {
    if (allowedOverflow === false) return false;
    const x = $4ffe47e38c59be9a$var$scaleClip(xScale, allowedOverflow);
    const y = $4ffe47e38c59be9a$var$scaleClip(yScale, allowedOverflow);
    return {
        top: y.end,
        right: x.end,
        bottom: y.start,
        left: x.start
    };
}
function $4ffe47e38c59be9a$var$toClip(value) {
    let t, r, b, l;
    if ((0, $breCz.i)(value)) {
        t = value.top;
        r = value.right;
        b = value.bottom;
        l = value.left;
    } else t = r = b = l = value;
    return {
        top: t,
        right: r,
        bottom: b,
        left: l,
        disabled: value === false
    };
}
function $4ffe47e38c59be9a$var$getSortedDatasetIndices(chart, filterVisible) {
    const keys = [];
    const metasets = chart._getSortedDatasetMetas(filterVisible);
    let i, ilen;
    for(i = 0, ilen = metasets.length; i < ilen; ++i)keys.push(metasets[i].index);
    return keys;
}
function $4ffe47e38c59be9a$var$applyStack(stack, value, dsIndex, options) {
    const keys = stack.keys;
    const singleMode = options.mode === "single";
    let i, ilen, datasetIndex, otherValue;
    if (value === null) return;
    for(i = 0, ilen = keys.length; i < ilen; ++i){
        datasetIndex = +keys[i];
        if (datasetIndex === dsIndex) {
            if (options.all) continue;
            break;
        }
        otherValue = stack.values[datasetIndex];
        if ((0, $breCz.g)(otherValue) && (singleMode || value === 0 || (0, $breCz.s)(value) === (0, $breCz.s)(otherValue))) value += otherValue;
    }
    return value;
}
function $4ffe47e38c59be9a$var$convertObjectDataToArray(data) {
    const keys = Object.keys(data);
    const adata = new Array(keys.length);
    let i, ilen, key;
    for(i = 0, ilen = keys.length; i < ilen; ++i){
        key = keys[i];
        adata[i] = {
            x: key,
            y: data[key]
        };
    }
    return adata;
}
function $4ffe47e38c59be9a$var$isStacked(scale, meta) {
    const stacked = scale && scale.options.stacked;
    return stacked || stacked === undefined && meta.stack !== undefined;
}
function $4ffe47e38c59be9a$var$getStackKey(indexScale, valueScale, meta) {
    return `${indexScale.id}.${valueScale.id}.${meta.stack || meta.type}`;
}
function $4ffe47e38c59be9a$var$getUserBounds(scale) {
    const { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = scale.getUserBounds();
    return {
        min: minDefined ? min : Number.NEGATIVE_INFINITY,
        max: maxDefined ? max : Number.POSITIVE_INFINITY
    };
}
function $4ffe47e38c59be9a$var$getOrCreateStack(stacks, stackKey, indexValue) {
    const subStack = stacks[stackKey] || (stacks[stackKey] = {});
    return subStack[indexValue] || (subStack[indexValue] = {});
}
function $4ffe47e38c59be9a$var$getLastIndexInStack(stack, vScale, positive) {
    for (const meta of vScale.getMatchingVisibleMetas("bar").reverse()){
        const value = stack[meta.index];
        if (positive && value > 0 || !positive && value < 0) return meta.index;
    }
    return null;
}
function $4ffe47e38c59be9a$var$updateStacks(controller, parsed) {
    const { chart: chart, _cachedMeta: meta } = controller;
    const stacks = chart._stacks || (chart._stacks = {});
    const { iScale: iScale, vScale: vScale, index: datasetIndex } = meta;
    const iAxis = iScale.axis;
    const vAxis = vScale.axis;
    const key = $4ffe47e38c59be9a$var$getStackKey(iScale, vScale, meta);
    const ilen = parsed.length;
    let stack;
    for(let i = 0; i < ilen; ++i){
        const item = parsed[i];
        const { [iAxis]: index, [vAxis]: value } = item;
        const itemStacks = item._stacks || (item._stacks = {});
        stack = itemStacks[vAxis] = $4ffe47e38c59be9a$var$getOrCreateStack(stacks, key, index);
        stack[datasetIndex] = value;
        stack._top = $4ffe47e38c59be9a$var$getLastIndexInStack(stack, vScale, true);
        stack._bottom = $4ffe47e38c59be9a$var$getLastIndexInStack(stack, vScale, false);
    }
}
function $4ffe47e38c59be9a$var$getFirstScaleId(chart, axis) {
    const scales = chart.scales;
    return Object.keys(scales).filter((key)=>scales[key].axis === axis).shift();
}
function $4ffe47e38c59be9a$var$createDatasetContext(parent, index) {
    return Object.assign(Object.create(parent), {
        active: false,
        dataset: undefined,
        datasetIndex: index,
        index: index,
        mode: "default",
        type: "dataset"
    });
}
function $4ffe47e38c59be9a$var$createDataContext(parent, index, element) {
    return Object.assign(Object.create(parent), {
        active: false,
        dataIndex: index,
        parsed: undefined,
        raw: undefined,
        element: element,
        index: index,
        mode: "default",
        type: "data"
    });
}
function $4ffe47e38c59be9a$var$clearStacks(meta, items) {
    const axis = meta.vScale && meta.vScale.axis;
    if (!axis) return;
    items = items || meta._parsed;
    for (const parsed of items){
        const stacks = parsed._stacks;
        if (!stacks || stacks[axis] === undefined || stacks[axis][meta.index] === undefined) return;
        delete stacks[axis][meta.index];
    }
}
const $4ffe47e38c59be9a$var$isDirectUpdateMode = (mode)=>mode === "reset" || mode === "none";
const $4ffe47e38c59be9a$var$cloneIfNotShared = (cached, shared)=>shared ? cached : Object.assign({}, cached);
class $4ffe47e38c59be9a$export$75572ec5c55b4048 {
    constructor(chart, datasetIndex){
        this.chart = chart;
        this._ctx = chart.ctx;
        this.index = datasetIndex;
        this._cachedDataOpts = {};
        this._cachedMeta = this.getMeta();
        this._type = this._cachedMeta.type;
        this.options = undefined;
        this._parsing = false;
        this._data = undefined;
        this._objectData = undefined;
        this._sharedOptions = undefined;
        this._drawStart = undefined;
        this._drawCount = undefined;
        this.enableOptionSharing = false;
        this.$context = undefined;
        this._syncList = [];
        this.initialize();
    }
    initialize() {
        const me = this;
        const meta = me._cachedMeta;
        me.configure();
        me.linkScales();
        meta._stacked = $4ffe47e38c59be9a$var$isStacked(meta.vScale, meta);
        me.addElements();
    }
    updateIndex(datasetIndex) {
        if (this.index !== datasetIndex) $4ffe47e38c59be9a$var$clearStacks(this._cachedMeta);
        this.index = datasetIndex;
    }
    linkScales() {
        const me = this;
        const chart = me.chart;
        const meta = me._cachedMeta;
        const dataset = me.getDataset();
        const chooseId = (axis, x, y, r)=>axis === "x" ? x : axis === "r" ? r : y;
        const xid = meta.xAxisID = (0, $breCz.v)(dataset.xAxisID, $4ffe47e38c59be9a$var$getFirstScaleId(chart, "x"));
        const yid = meta.yAxisID = (0, $breCz.v)(dataset.yAxisID, $4ffe47e38c59be9a$var$getFirstScaleId(chart, "y"));
        const rid = meta.rAxisID = (0, $breCz.v)(dataset.rAxisID, $4ffe47e38c59be9a$var$getFirstScaleId(chart, "r"));
        const indexAxis = meta.indexAxis;
        const iid = meta.iAxisID = chooseId(indexAxis, xid, yid, rid);
        const vid = meta.vAxisID = chooseId(indexAxis, yid, xid, rid);
        meta.xScale = me.getScaleForId(xid);
        meta.yScale = me.getScaleForId(yid);
        meta.rScale = me.getScaleForId(rid);
        meta.iScale = me.getScaleForId(iid);
        meta.vScale = me.getScaleForId(vid);
    }
    getDataset() {
        return this.chart.data.datasets[this.index];
    }
    getMeta() {
        return this.chart.getDatasetMeta(this.index);
    }
    getScaleForId(scaleID) {
        return this.chart.scales[scaleID];
    }
    _getOtherScale(scale) {
        const meta = this._cachedMeta;
        return scale === meta.iScale ? meta.vScale : meta.iScale;
    }
    reset() {
        this._update("reset");
    }
    _destroy() {
        const meta = this._cachedMeta;
        if (this._data) (0, $breCz.u)(this._data, this);
        if (meta._stacked) $4ffe47e38c59be9a$var$clearStacks(meta);
    }
    _dataCheck() {
        const me = this;
        const dataset = me.getDataset();
        const data = dataset.data || (dataset.data = []);
        const _data = me._data;
        if ((0, $breCz.i)(data)) me._data = $4ffe47e38c59be9a$var$convertObjectDataToArray(data);
        else if (_data !== data) {
            if (_data) {
                (0, $breCz.u)(_data, me);
                const meta = me._cachedMeta;
                $4ffe47e38c59be9a$var$clearStacks(meta);
                meta._parsed = [];
            }
            if (data && Object.isExtensible(data)) (0, $breCz.l)(data, me);
            me._syncList = [];
            me._data = data;
        }
    }
    addElements() {
        const me = this;
        const meta = me._cachedMeta;
        me._dataCheck();
        if (me.datasetElementType) meta.dataset = new me.datasetElementType();
    }
    buildOrUpdateElements(resetNewElements) {
        const me = this;
        const meta = me._cachedMeta;
        const dataset = me.getDataset();
        let stackChanged = false;
        me._dataCheck();
        const oldStacked = meta._stacked;
        meta._stacked = $4ffe47e38c59be9a$var$isStacked(meta.vScale, meta);
        if (meta.stack !== dataset.stack) {
            stackChanged = true;
            $4ffe47e38c59be9a$var$clearStacks(meta);
            meta.stack = dataset.stack;
        }
        me._resyncElements(resetNewElements);
        if (stackChanged || oldStacked !== meta._stacked) $4ffe47e38c59be9a$var$updateStacks(me, meta._parsed);
    }
    configure() {
        const me = this;
        const config = me.chart.config;
        const scopeKeys = config.datasetScopeKeys(me._type);
        const scopes = config.getOptionScopes(me.getDataset(), scopeKeys, true);
        me.options = config.createResolver(scopes, me.getContext());
        me._parsing = me.options.parsing;
    }
    parse(start, count) {
        const me = this;
        const { _cachedMeta: meta, _data: data } = me;
        const { iScale: iScale, _stacked: _stacked } = meta;
        const iAxis = iScale.axis;
        let sorted = start === 0 && count === data.length ? true : meta._sorted;
        let prev = start > 0 && meta._parsed[start - 1];
        let i, cur, parsed;
        if (me._parsing === false) {
            meta._parsed = data;
            meta._sorted = true;
            parsed = data;
        } else {
            if ((0, $breCz.b)(data[start])) parsed = me.parseArrayData(meta, data, start, count);
            else if ((0, $breCz.i)(data[start])) parsed = me.parseObjectData(meta, data, start, count);
            else parsed = me.parsePrimitiveData(meta, data, start, count);
            const isNotInOrderComparedToPrev = ()=>cur[iAxis] === null || prev && cur[iAxis] < prev[iAxis];
            for(i = 0; i < count; ++i){
                meta._parsed[i + start] = cur = parsed[i];
                if (sorted) {
                    if (isNotInOrderComparedToPrev()) sorted = false;
                    prev = cur;
                }
            }
            meta._sorted = sorted;
        }
        if (_stacked) $4ffe47e38c59be9a$var$updateStacks(me, parsed);
    }
    parsePrimitiveData(meta, data, start, count) {
        const { iScale: iScale, vScale: vScale } = meta;
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        const labels = iScale.getLabels();
        const singleScale = iScale === vScale;
        const parsed = new Array(count);
        let i, ilen, index;
        for(i = 0, ilen = count; i < ilen; ++i){
            index = i + start;
            parsed[i] = {
                [iAxis]: singleScale || iScale.parse(labels[index], index),
                [vAxis]: vScale.parse(data[index], index)
            };
        }
        return parsed;
    }
    parseArrayData(meta, data, start, count) {
        const { xScale: xScale, yScale: yScale } = meta;
        const parsed = new Array(count);
        let i, ilen, index, item;
        for(i = 0, ilen = count; i < ilen; ++i){
            index = i + start;
            item = data[index];
            parsed[i] = {
                x: xScale.parse(item[0], index),
                y: yScale.parse(item[1], index)
            };
        }
        return parsed;
    }
    parseObjectData(meta, data, start, count) {
        const { xScale: xScale, yScale: yScale } = meta;
        const { xAxisKey: xAxisKey = "x", yAxisKey: yAxisKey = "y" } = this._parsing;
        const parsed = new Array(count);
        let i, ilen, index, item;
        for(i = 0, ilen = count; i < ilen; ++i){
            index = i + start;
            item = data[index];
            parsed[i] = {
                x: xScale.parse((0, $breCz.f)(item, xAxisKey), index),
                y: yScale.parse((0, $breCz.f)(item, yAxisKey), index)
            };
        }
        return parsed;
    }
    getParsed(index) {
        return this._cachedMeta._parsed[index];
    }
    getDataElement(index) {
        return this._cachedMeta.data[index];
    }
    applyStack(scale, parsed, mode) {
        const chart = this.chart;
        const meta = this._cachedMeta;
        const value = parsed[scale.axis];
        const stack = {
            keys: $4ffe47e38c59be9a$var$getSortedDatasetIndices(chart, true),
            values: parsed._stacks[scale.axis]
        };
        return $4ffe47e38c59be9a$var$applyStack(stack, value, meta.index, {
            mode: mode
        });
    }
    updateRangeFromParsed(range, scale, parsed, stack) {
        const parsedValue = parsed[scale.axis];
        let value = parsedValue === null ? NaN : parsedValue;
        const values = stack && parsed._stacks[scale.axis];
        if (stack && values) {
            stack.values = values;
            range.min = Math.min(range.min, value);
            range.max = Math.max(range.max, value);
            value = $4ffe47e38c59be9a$var$applyStack(stack, parsedValue, this._cachedMeta.index, {
                all: true
            });
        }
        range.min = Math.min(range.min, value);
        range.max = Math.max(range.max, value);
    }
    getMinMax(scale, canStack) {
        const me = this;
        const meta = me._cachedMeta;
        const _parsed = meta._parsed;
        const sorted = meta._sorted && scale === meta.iScale;
        const ilen = _parsed.length;
        const otherScale = me._getOtherScale(scale);
        const stack = canStack && meta._stacked && {
            keys: $4ffe47e38c59be9a$var$getSortedDatasetIndices(me.chart, true),
            values: null
        };
        const range = {
            min: Number.POSITIVE_INFINITY,
            max: Number.NEGATIVE_INFINITY
        };
        const { min: otherMin, max: otherMax } = $4ffe47e38c59be9a$var$getUserBounds(otherScale);
        let i, value, parsed, otherValue;
        function _skip() {
            parsed = _parsed[i];
            value = parsed[scale.axis];
            otherValue = parsed[otherScale.axis];
            return !(0, $breCz.g)(value) || otherMin > otherValue || otherMax < otherValue;
        }
        for(i = 0; i < ilen; ++i){
            if (_skip()) continue;
            me.updateRangeFromParsed(range, scale, parsed, stack);
            if (sorted) break;
        }
        if (sorted) for(i = ilen - 1; i >= 0; --i){
            if (_skip()) continue;
            me.updateRangeFromParsed(range, scale, parsed, stack);
            break;
        }
        return range;
    }
    getAllParsedValues(scale) {
        const parsed = this._cachedMeta._parsed;
        const values = [];
        let i, ilen, value;
        for(i = 0, ilen = parsed.length; i < ilen; ++i){
            value = parsed[i][scale.axis];
            if ((0, $breCz.g)(value)) values.push(value);
        }
        return values;
    }
    getMaxOverflow() {
        return false;
    }
    getLabelAndValue(index) {
        const me = this;
        const meta = me._cachedMeta;
        const iScale = meta.iScale;
        const vScale = meta.vScale;
        const parsed = me.getParsed(index);
        return {
            label: iScale ? "" + iScale.getLabelForValue(parsed[iScale.axis]) : "",
            value: vScale ? "" + vScale.getLabelForValue(parsed[vScale.axis]) : ""
        };
    }
    _update(mode) {
        const me = this;
        const meta = me._cachedMeta;
        me.configure();
        me._cachedDataOpts = {};
        me.update(mode || "default");
        meta._clip = $4ffe47e38c59be9a$var$toClip((0, $breCz.v)(me.options.clip, $4ffe47e38c59be9a$var$defaultClip(meta.xScale, meta.yScale, me.getMaxOverflow())));
    }
    update(mode) {}
    draw() {
        const me = this;
        const ctx = me._ctx;
        const chart = me.chart;
        const meta = me._cachedMeta;
        const elements = meta.data || [];
        const area = chart.chartArea;
        const active = [];
        const start = me._drawStart || 0;
        const count = me._drawCount || elements.length - start;
        let i;
        if (meta.dataset) meta.dataset.draw(ctx, area, start, count);
        for(i = start; i < start + count; ++i){
            const element = elements[i];
            if (element.active) active.push(element);
            else element.draw(ctx, area);
        }
        for(i = 0; i < active.length; ++i)active[i].draw(ctx, area);
    }
    getStyle(index, active) {
        const mode = active ? "active" : "default";
        return index === undefined && this._cachedMeta.dataset ? this.resolveDatasetElementOptions(mode) : this.resolveDataElementOptions(index || 0, mode);
    }
    getContext(index, active, mode) {
        const me = this;
        const dataset = me.getDataset();
        let context;
        if (index >= 0 && index < me._cachedMeta.data.length) {
            const element = me._cachedMeta.data[index];
            context = element.$context || (element.$context = $4ffe47e38c59be9a$var$createDataContext(me.getContext(), index, element));
            context.parsed = me.getParsed(index);
            context.raw = dataset.data[index];
            context.index = context.dataIndex = index;
        } else {
            context = me.$context || (me.$context = $4ffe47e38c59be9a$var$createDatasetContext(me.chart.getContext(), me.index));
            context.dataset = dataset;
            context.index = context.datasetIndex = me.index;
        }
        context.active = !!active;
        context.mode = mode;
        return context;
    }
    resolveDatasetElementOptions(mode) {
        return this._resolveElementOptions(this.datasetElementType.id, mode);
    }
    resolveDataElementOptions(index, mode) {
        return this._resolveElementOptions(this.dataElementType.id, mode, index);
    }
    _resolveElementOptions(elementType, mode = "default", index) {
        const me = this;
        const active = mode === "active";
        const cache = me._cachedDataOpts;
        const cacheKey = elementType + "-" + mode;
        const cached = cache[cacheKey];
        const sharing = me.enableOptionSharing && (0, $breCz.h)(index);
        if (cached) return $4ffe47e38c59be9a$var$cloneIfNotShared(cached, sharing);
        const config = me.chart.config;
        const scopeKeys = config.datasetElementScopeKeys(me._type, elementType);
        const prefixes = active ? [
            `${elementType}Hover`,
            "hover",
            elementType,
            ""
        ] : [
            elementType,
            ""
        ];
        const scopes = config.getOptionScopes(me.getDataset(), scopeKeys);
        const names = Object.keys((0, $breCz.d).elements[elementType]);
        const context = ()=>me.getContext(index, active);
        const values = config.resolveNamedOptions(scopes, names, context, prefixes);
        if (values.$shared) {
            values.$shared = sharing;
            cache[cacheKey] = Object.freeze($4ffe47e38c59be9a$var$cloneIfNotShared(values, sharing));
        }
        return values;
    }
    _resolveAnimations(index, transition, active) {
        const me = this;
        const chart = me.chart;
        const cache = me._cachedDataOpts;
        const cacheKey = `animation-${transition}`;
        const cached = cache[cacheKey];
        if (cached) return cached;
        let options;
        if (chart.options.animation !== false) {
            const config = me.chart.config;
            const scopeKeys = config.datasetAnimationScopeKeys(me._type, transition);
            const scopes = config.getOptionScopes(me.getDataset(), scopeKeys);
            options = config.createResolver(scopes, me.getContext(index, active, transition));
        }
        const animations = new $4ffe47e38c59be9a$export$8ab227dac26677d(chart, options && options.animations);
        if (options && options._cacheable) cache[cacheKey] = Object.freeze(animations);
        return animations;
    }
    getSharedOptions(options) {
        if (!options.$shared) return;
        return this._sharedOptions || (this._sharedOptions = Object.assign({}, options));
    }
    includeOptions(mode, sharedOptions) {
        return !sharedOptions || $4ffe47e38c59be9a$var$isDirectUpdateMode(mode) || this.chart._animationsDisabled;
    }
    updateElement(element, index, properties, mode) {
        if ($4ffe47e38c59be9a$var$isDirectUpdateMode(mode)) Object.assign(element, properties);
        else this._resolveAnimations(index, mode).update(element, properties);
    }
    updateSharedOptions(sharedOptions, mode, newOptions) {
        if (sharedOptions && !$4ffe47e38c59be9a$var$isDirectUpdateMode(mode)) this._resolveAnimations(undefined, mode).update(sharedOptions, newOptions);
    }
    _setStyle(element, index, mode, active) {
        element.active = active;
        const options = this.getStyle(index, active);
        this._resolveAnimations(index, mode, active).update(element, {
            options: !active && this.getSharedOptions(options) || options
        });
    }
    removeHoverStyle(element, datasetIndex, index) {
        this._setStyle(element, index, "active", false);
    }
    setHoverStyle(element, datasetIndex, index) {
        this._setStyle(element, index, "active", true);
    }
    _removeDatasetHoverStyle() {
        const element = this._cachedMeta.dataset;
        if (element) this._setStyle(element, undefined, "active", false);
    }
    _setDatasetHoverStyle() {
        const element = this._cachedMeta.dataset;
        if (element) this._setStyle(element, undefined, "active", true);
    }
    _resyncElements(resetNewElements) {
        const me = this;
        const data = me._data;
        const elements = me._cachedMeta.data;
        for (const [method, arg1, arg2] of me._syncList)me[method](arg1, arg2);
        me._syncList = [];
        const numMeta = elements.length;
        const numData = data.length;
        const count = Math.min(numData, numMeta);
        if (count) me.parse(0, count);
        if (numData > numMeta) me._insertElements(numMeta, numData - numMeta, resetNewElements);
        else if (numData < numMeta) me._removeElements(numData, numMeta - numData);
    }
    _insertElements(start, count, resetNewElements = true) {
        const me = this;
        const meta = me._cachedMeta;
        const data = meta.data;
        const end = start + count;
        let i;
        const move = (arr)=>{
            arr.length += count;
            for(i = arr.length - 1; i >= end; i--)arr[i] = arr[i - count];
        };
        move(data);
        for(i = start; i < end; ++i)data[i] = new me.dataElementType();
        if (me._parsing) move(meta._parsed);
        me.parse(start, count);
        if (resetNewElements) me.updateElements(data, start, count, "reset");
    }
    updateElements(element, start, count, mode) {}
    _removeElements(start, count) {
        const me = this;
        const meta = me._cachedMeta;
        if (me._parsing) {
            const removed = meta._parsed.splice(start, count);
            if (meta._stacked) $4ffe47e38c59be9a$var$clearStacks(meta, removed);
        }
        meta.data.splice(start, count);
    }
    _onDataPush() {
        const count = arguments.length;
        this._syncList.push([
            "_insertElements",
            this.getDataset().data.length - count,
            count
        ]);
    }
    _onDataPop() {
        this._syncList.push([
            "_removeElements",
            this._cachedMeta.data.length - 1,
            1
        ]);
    }
    _onDataShift() {
        this._syncList.push([
            "_removeElements",
            0,
            1
        ]);
    }
    _onDataSplice(start, count) {
        this._syncList.push([
            "_removeElements",
            start,
            count
        ]);
        this._syncList.push([
            "_insertElements",
            start,
            arguments.length - 2
        ]);
    }
    _onDataUnshift() {
        this._syncList.push([
            "_insertElements",
            0,
            arguments.length
        ]);
    }
}
$4ffe47e38c59be9a$export$75572ec5c55b4048.defaults = {};
$4ffe47e38c59be9a$export$75572ec5c55b4048.prototype.datasetElementType = null;
$4ffe47e38c59be9a$export$75572ec5c55b4048.prototype.dataElementType = null;
function $4ffe47e38c59be9a$var$getAllScaleValues(scale) {
    if (!scale._cache.$bar) {
        const metas = scale.getMatchingVisibleMetas("bar");
        let values = [];
        for(let i = 0, ilen = metas.length; i < ilen; i++)values = values.concat(metas[i].controller.getAllParsedValues(scale));
        scale._cache.$bar = (0, $breCz._)(values.sort((a, b)=>a - b));
    }
    return scale._cache.$bar;
}
function $4ffe47e38c59be9a$var$computeMinSampleSize(scale) {
    const values = $4ffe47e38c59be9a$var$getAllScaleValues(scale);
    let min = scale._length;
    let i, ilen, curr, prev;
    const updateMinAndPrev = ()=>{
        if (curr === 32767 || curr === -32768) return;
        if ((0, $breCz.h)(prev)) min = Math.min(min, Math.abs(curr - prev) || min);
        prev = curr;
    };
    for(i = 0, ilen = values.length; i < ilen; ++i){
        curr = scale.getPixelForValue(values[i]);
        updateMinAndPrev();
    }
    prev = undefined;
    for(i = 0, ilen = scale.ticks.length; i < ilen; ++i){
        curr = scale.getPixelForTick(i);
        updateMinAndPrev();
    }
    return min;
}
function $4ffe47e38c59be9a$var$computeFitCategoryTraits(index, ruler, options, stackCount) {
    const thickness = options.barThickness;
    let size, ratio;
    if ((0, $breCz.j)(thickness)) {
        size = ruler.min * options.categoryPercentage;
        ratio = options.barPercentage;
    } else {
        size = thickness * stackCount;
        ratio = 1;
    }
    return {
        chunk: size / stackCount,
        ratio: ratio,
        start: ruler.pixels[index] - size / 2
    };
}
function $4ffe47e38c59be9a$var$computeFlexCategoryTraits(index, ruler, options, stackCount) {
    const pixels = ruler.pixels;
    const curr = pixels[index];
    let prev = index > 0 ? pixels[index - 1] : null;
    let next = index < pixels.length - 1 ? pixels[index + 1] : null;
    const percent = options.categoryPercentage;
    if (prev === null) prev = curr - (next === null ? ruler.end - ruler.start : next - curr);
    if (next === null) next = curr + curr - prev;
    const start = curr - (curr - Math.min(prev, next)) / 2 * percent;
    const size = Math.abs(next - prev) / 2 * percent;
    return {
        chunk: size / stackCount,
        ratio: options.barPercentage,
        start: start
    };
}
function $4ffe47e38c59be9a$var$parseFloatBar(entry, item, vScale, i) {
    const startValue = vScale.parse(entry[0], i);
    const endValue = vScale.parse(entry[1], i);
    const min = Math.min(startValue, endValue);
    const max = Math.max(startValue, endValue);
    let barStart = min;
    let barEnd = max;
    if (Math.abs(min) > Math.abs(max)) {
        barStart = max;
        barEnd = min;
    }
    item[vScale.axis] = barEnd;
    item._custom = {
        barStart: barStart,
        barEnd: barEnd,
        start: startValue,
        end: endValue,
        min: min,
        max: max
    };
}
function $4ffe47e38c59be9a$var$parseValue(entry, item, vScale, i) {
    if ((0, $breCz.b)(entry)) $4ffe47e38c59be9a$var$parseFloatBar(entry, item, vScale, i);
    else item[vScale.axis] = vScale.parse(entry, i);
    return item;
}
function $4ffe47e38c59be9a$var$parseArrayOrPrimitive(meta, data, start, count) {
    const iScale = meta.iScale;
    const vScale = meta.vScale;
    const labels = iScale.getLabels();
    const singleScale = iScale === vScale;
    const parsed = [];
    let i, ilen, item, entry;
    for(i = start, ilen = start + count; i < ilen; ++i){
        entry = data[i];
        item = {};
        item[iScale.axis] = singleScale || iScale.parse(labels[i], i);
        parsed.push($4ffe47e38c59be9a$var$parseValue(entry, item, vScale, i));
    }
    return parsed;
}
function $4ffe47e38c59be9a$var$isFloatBar(custom) {
    return custom && custom.barStart !== undefined && custom.barEnd !== undefined;
}
class $4ffe47e38c59be9a$export$e97d5dc64e999004 extends $4ffe47e38c59be9a$export$75572ec5c55b4048 {
    parsePrimitiveData(meta, data, start, count) {
        return $4ffe47e38c59be9a$var$parseArrayOrPrimitive(meta, data, start, count);
    }
    parseArrayData(meta, data, start, count) {
        return $4ffe47e38c59be9a$var$parseArrayOrPrimitive(meta, data, start, count);
    }
    parseObjectData(meta, data, start, count) {
        const { iScale: iScale, vScale: vScale } = meta;
        const { xAxisKey: xAxisKey = "x", yAxisKey: yAxisKey = "y" } = this._parsing;
        const iAxisKey = iScale.axis === "x" ? xAxisKey : yAxisKey;
        const vAxisKey = vScale.axis === "x" ? xAxisKey : yAxisKey;
        const parsed = [];
        let i, ilen, item, obj;
        for(i = start, ilen = start + count; i < ilen; ++i){
            obj = data[i];
            item = {};
            item[iScale.axis] = iScale.parse((0, $breCz.f)(obj, iAxisKey), i);
            parsed.push($4ffe47e38c59be9a$var$parseValue((0, $breCz.f)(obj, vAxisKey), item, vScale, i));
        }
        return parsed;
    }
    updateRangeFromParsed(range, scale, parsed, stack) {
        super.updateRangeFromParsed(range, scale, parsed, stack);
        const custom = parsed._custom;
        if (custom && scale === this._cachedMeta.vScale) {
            range.min = Math.min(range.min, custom.min);
            range.max = Math.max(range.max, custom.max);
        }
    }
    getMaxOverflow() {
        return 0;
    }
    getLabelAndValue(index) {
        const me = this;
        const meta = me._cachedMeta;
        const { iScale: iScale, vScale: vScale } = meta;
        const parsed = me.getParsed(index);
        const custom = parsed._custom;
        const value = $4ffe47e38c59be9a$var$isFloatBar(custom) ? "[" + custom.start + ", " + custom.end + "]" : "" + vScale.getLabelForValue(parsed[vScale.axis]);
        return {
            label: "" + iScale.getLabelForValue(parsed[iScale.axis]),
            value: value
        };
    }
    initialize() {
        const me = this;
        me.enableOptionSharing = true;
        super.initialize();
        const meta = me._cachedMeta;
        meta.stack = me.getDataset().stack;
    }
    update(mode) {
        const me = this;
        const meta = me._cachedMeta;
        me.updateElements(meta.data, 0, meta.data.length, mode);
    }
    updateElements(bars, start, count, mode) {
        const me = this;
        const reset = mode === "reset";
        const vScale = me._cachedMeta.vScale;
        const base = vScale.getBasePixel();
        const horizontal = vScale.isHorizontal();
        const ruler = me._getRuler();
        const firstOpts = me.resolveDataElementOptions(start, mode);
        const sharedOptions = me.getSharedOptions(firstOpts);
        const includeOptions = me.includeOptions(mode, sharedOptions);
        me.updateSharedOptions(sharedOptions, mode, firstOpts);
        for(let i = start; i < start + count; i++){
            const parsed = me.getParsed(i);
            const vpixels = reset || (0, $breCz.j)(parsed[vScale.axis]) ? {
                base: base,
                head: base
            } : me._calculateBarValuePixels(i);
            const ipixels = me._calculateBarIndexPixels(i, ruler);
            const stack = (parsed._stacks || {})[vScale.axis];
            const properties = {
                horizontal: horizontal,
                base: vpixels.base,
                enableBorderRadius: !stack || $4ffe47e38c59be9a$var$isFloatBar(parsed._custom) || me.index === stack._top || me.index === stack._bottom,
                x: horizontal ? vpixels.head : ipixels.center,
                y: horizontal ? ipixels.center : vpixels.head,
                height: horizontal ? ipixels.size : Math.abs(vpixels.size),
                width: horizontal ? Math.abs(vpixels.size) : ipixels.size
            };
            if (includeOptions) properties.options = sharedOptions || me.resolveDataElementOptions(i, bars[i].active ? "active" : mode);
            me.updateElement(bars[i], i, properties, mode);
        }
    }
    _getStacks(last, dataIndex) {
        const me = this;
        const meta = me._cachedMeta;
        const iScale = meta.iScale;
        const metasets = iScale.getMatchingVisibleMetas(me._type);
        const stacked = iScale.options.stacked;
        const ilen = metasets.length;
        const stacks = [];
        let i, item;
        for(i = 0; i < ilen; ++i){
            item = metasets[i];
            if (!item.controller.options.grouped) continue;
            if (typeof dataIndex !== "undefined") {
                const val = item.controller.getParsed(dataIndex)[item.controller._cachedMeta.vScale.axis];
                if ((0, $breCz.j)(val) || isNaN(val)) continue;
            }
            if (stacked === false || stacks.indexOf(item.stack) === -1 || stacked === undefined && item.stack === undefined) stacks.push(item.stack);
            if (item.index === last) break;
        }
        if (!stacks.length) stacks.push(undefined);
        return stacks;
    }
    _getStackCount(index) {
        return this._getStacks(undefined, index).length;
    }
    _getStackIndex(datasetIndex, name, dataIndex) {
        const stacks = this._getStacks(datasetIndex, dataIndex);
        const index = name !== undefined ? stacks.indexOf(name) : -1;
        return index === -1 ? stacks.length - 1 : index;
    }
    _getRuler() {
        const me = this;
        const opts = me.options;
        const meta = me._cachedMeta;
        const iScale = meta.iScale;
        const pixels = [];
        let i, ilen;
        for(i = 0, ilen = meta.data.length; i < ilen; ++i)pixels.push(iScale.getPixelForValue(me.getParsed(i)[iScale.axis], i));
        const barThickness = opts.barThickness;
        const min = barThickness || $4ffe47e38c59be9a$var$computeMinSampleSize(iScale);
        return {
            min: min,
            pixels: pixels,
            start: iScale._startPixel,
            end: iScale._endPixel,
            stackCount: me._getStackCount(),
            scale: iScale,
            grouped: opts.grouped,
            ratio: barThickness ? 1 : opts.categoryPercentage * opts.barPercentage
        };
    }
    _calculateBarValuePixels(index) {
        const me = this;
        const { vScale: vScale, _stacked: _stacked } = me._cachedMeta;
        const { base: baseValue, minBarLength: minBarLength } = me.options;
        const parsed = me.getParsed(index);
        const custom = parsed._custom;
        const floating = $4ffe47e38c59be9a$var$isFloatBar(custom);
        let value = parsed[vScale.axis];
        let start = 0;
        let length = _stacked ? me.applyStack(vScale, parsed, _stacked) : value;
        let head, size;
        if (length !== value) {
            start = length - value;
            length = value;
        }
        if (floating) {
            value = custom.barStart;
            length = custom.barEnd - custom.barStart;
            if (value !== 0 && (0, $breCz.s)(value) !== (0, $breCz.s)(custom.barEnd)) start = 0;
            start += value;
        }
        const startValue = !(0, $breCz.j)(baseValue) && !floating ? baseValue : start;
        let base = vScale.getPixelForValue(startValue);
        if (this.chart.getDataVisibility(index)) head = vScale.getPixelForValue(start + length);
        else head = base;
        size = head - base;
        if (minBarLength !== undefined && Math.abs(size) < minBarLength) {
            size = size < 0 ? -minBarLength : minBarLength;
            if (value === 0) base -= size / 2;
            head = base + size;
        }
        const actualBase = baseValue || 0;
        if (base === vScale.getPixelForValue(actualBase)) {
            const halfGrid = vScale.getLineWidthForValue(actualBase) / 2;
            if (size > 0) {
                base += halfGrid;
                size -= halfGrid;
            } else if (size < 0) {
                base -= halfGrid;
                size += halfGrid;
            }
        }
        return {
            size: size,
            base: base,
            head: head,
            center: head + size / 2
        };
    }
    _calculateBarIndexPixels(index, ruler) {
        const me = this;
        const scale = ruler.scale;
        const options = me.options;
        const skipNull = options.skipNull;
        const maxBarThickness = (0, $breCz.v)(options.maxBarThickness, Infinity);
        let center, size;
        if (ruler.grouped) {
            const stackCount = skipNull ? me._getStackCount(index) : ruler.stackCount;
            const range = options.barThickness === "flex" ? $4ffe47e38c59be9a$var$computeFlexCategoryTraits(index, ruler, options, stackCount) : $4ffe47e38c59be9a$var$computeFitCategoryTraits(index, ruler, options, stackCount);
            const stackIndex = me._getStackIndex(me.index, me._cachedMeta.stack, skipNull ? index : undefined);
            center = range.start + range.chunk * stackIndex + range.chunk / 2;
            size = Math.min(maxBarThickness, range.chunk * range.ratio);
        } else {
            center = scale.getPixelForValue(me.getParsed(index)[scale.axis], index);
            size = Math.min(maxBarThickness, ruler.min * ruler.ratio);
        }
        return {
            base: center - size / 2,
            head: center + size / 2,
            center: center,
            size: size
        };
    }
    draw() {
        const me = this;
        const meta = me._cachedMeta;
        const vScale = meta.vScale;
        const rects = meta.data;
        const ilen = rects.length;
        let i = 0;
        for(; i < ilen; ++i)if (me.getParsed(i)[vScale.axis] !== null) rects[i].draw(me._ctx);
    }
}
$4ffe47e38c59be9a$export$e97d5dc64e999004.id = "bar";
$4ffe47e38c59be9a$export$e97d5dc64e999004.defaults = {
    datasetElementType: false,
    dataElementType: "bar",
    categoryPercentage: 0.8,
    barPercentage: 0.9,
    grouped: true,
    animations: {
        numbers: {
            type: "number",
            properties: [
                "x",
                "y",
                "base",
                "width",
                "height"
            ]
        }
    }
};
$4ffe47e38c59be9a$export$e97d5dc64e999004.overrides = {
    interaction: {
        mode: "index"
    },
    scales: {
        _index_: {
            type: "category",
            offset: true,
            grid: {
                offset: true
            }
        },
        _value_: {
            type: "linear",
            beginAtZero: true
        }
    }
};
class $4ffe47e38c59be9a$export$19b5c4773f17abe extends $4ffe47e38c59be9a$export$75572ec5c55b4048 {
    initialize() {
        this.enableOptionSharing = true;
        super.initialize();
    }
    parseObjectData(meta, data, start, count) {
        const { xScale: xScale, yScale: yScale } = meta;
        const { xAxisKey: xAxisKey = "x", yAxisKey: yAxisKey = "y" } = this._parsing;
        const parsed = [];
        let i, ilen, item;
        for(i = start, ilen = start + count; i < ilen; ++i){
            item = data[i];
            parsed.push({
                x: xScale.parse((0, $breCz.f)(item, xAxisKey), i),
                y: yScale.parse((0, $breCz.f)(item, yAxisKey), i),
                _custom: item && item.r && +item.r
            });
        }
        return parsed;
    }
    getMaxOverflow() {
        const { data: data, _parsed: _parsed } = this._cachedMeta;
        let max = 0;
        for(let i = data.length - 1; i >= 0; --i)max = Math.max(max, data[i].size() / 2, _parsed[i]._custom);
        return max > 0 && max;
    }
    getLabelAndValue(index) {
        const me = this;
        const meta = me._cachedMeta;
        const { xScale: xScale, yScale: yScale } = meta;
        const parsed = me.getParsed(index);
        const x = xScale.getLabelForValue(parsed.x);
        const y = yScale.getLabelForValue(parsed.y);
        const r = parsed._custom;
        return {
            label: meta.label,
            value: "(" + x + ", " + y + (r ? ", " + r : "") + ")"
        };
    }
    update(mode) {
        const me = this;
        const points = me._cachedMeta.data;
        me.updateElements(points, 0, points.length, mode);
    }
    updateElements(points, start, count, mode) {
        const me = this;
        const reset = mode === "reset";
        const { iScale: iScale, vScale: vScale } = me._cachedMeta;
        const firstOpts = me.resolveDataElementOptions(start, mode);
        const sharedOptions = me.getSharedOptions(firstOpts);
        const includeOptions = me.includeOptions(mode, sharedOptions);
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        for(let i = start; i < start + count; i++){
            const point = points[i];
            const parsed = !reset && me.getParsed(i);
            const properties = {};
            const iPixel = properties[iAxis] = reset ? iScale.getPixelForDecimal(0.5) : iScale.getPixelForValue(parsed[iAxis]);
            const vPixel = properties[vAxis] = reset ? vScale.getBasePixel() : vScale.getPixelForValue(parsed[vAxis]);
            properties.skip = isNaN(iPixel) || isNaN(vPixel);
            if (includeOptions) {
                properties.options = me.resolveDataElementOptions(i, point.active ? "active" : mode);
                if (reset) properties.options.radius = 0;
            }
            me.updateElement(point, i, properties, mode);
        }
        me.updateSharedOptions(sharedOptions, mode, firstOpts);
    }
    resolveDataElementOptions(index, mode) {
        const parsed = this.getParsed(index);
        let values = super.resolveDataElementOptions(index, mode);
        if (values.$shared) values = Object.assign({}, values, {
            $shared: false
        });
        const radius = values.radius;
        if (mode !== "active") values.radius = 0;
        values.radius += (0, $breCz.v)(parsed && parsed._custom, radius);
        return values;
    }
}
$4ffe47e38c59be9a$export$19b5c4773f17abe.id = "bubble";
$4ffe47e38c59be9a$export$19b5c4773f17abe.defaults = {
    datasetElementType: false,
    dataElementType: "point",
    animations: {
        numbers: {
            type: "number",
            properties: [
                "x",
                "y",
                "borderWidth",
                "radius"
            ]
        }
    }
};
$4ffe47e38c59be9a$export$19b5c4773f17abe.overrides = {
    scales: {
        x: {
            type: "linear"
        },
        y: {
            type: "linear"
        }
    },
    plugins: {
        tooltip: {
            callbacks: {
                title () {
                    return "";
                }
            }
        }
    }
};
function $4ffe47e38c59be9a$var$getRatioAndOffset(rotation, circumference, cutout) {
    let ratioX = 1;
    let ratioY = 1;
    let offsetX = 0;
    let offsetY = 0;
    if (circumference < (0, $breCz.T)) {
        const startAngle = rotation;
        const endAngle = startAngle + circumference;
        const startX = Math.cos(startAngle);
        const startY = Math.sin(startAngle);
        const endX = Math.cos(endAngle);
        const endY = Math.sin(endAngle);
        const calcMax = (angle, a, b)=>(0, $breCz.o)(angle, startAngle, endAngle, true) ? 1 : Math.max(a, a * cutout, b, b * cutout);
        const calcMin = (angle, a, b)=>(0, $breCz.o)(angle, startAngle, endAngle, true) ? -1 : Math.min(a, a * cutout, b, b * cutout);
        const maxX = calcMax(0, startX, endX);
        const maxY = calcMax((0, $breCz.H), startY, endY);
        const minX = calcMin((0, $breCz.P), startX, endX);
        const minY = calcMin((0, $breCz.P) + (0, $breCz.H), startY, endY);
        ratioX = (maxX - minX) / 2;
        ratioY = (maxY - minY) / 2;
        offsetX = -(maxX + minX) / 2;
        offsetY = -(maxY + minY) / 2;
    }
    return {
        ratioX: ratioX,
        ratioY: ratioY,
        offsetX: offsetX,
        offsetY: offsetY
    };
}
class $4ffe47e38c59be9a$export$e04603e7d8b77172 extends $4ffe47e38c59be9a$export$75572ec5c55b4048 {
    constructor(chart, datasetIndex){
        super(chart, datasetIndex);
        this.enableOptionSharing = true;
        this.innerRadius = undefined;
        this.outerRadius = undefined;
        this.offsetX = undefined;
        this.offsetY = undefined;
    }
    linkScales() {}
    parse(start, count) {
        const data = this.getDataset().data;
        const meta = this._cachedMeta;
        let i, ilen;
        for(i = start, ilen = start + count; i < ilen; ++i)meta._parsed[i] = +data[i];
    }
    _getRotation() {
        return (0, $breCz.t)(this.options.rotation - 90);
    }
    _getCircumference() {
        return (0, $breCz.t)(this.options.circumference);
    }
    _getRotationExtents() {
        let min = (0, $breCz.T);
        let max = -(0, $breCz.T);
        const me = this;
        for(let i = 0; i < me.chart.data.datasets.length; ++i)if (me.chart.isDatasetVisible(i)) {
            const controller = me.chart.getDatasetMeta(i).controller;
            const rotation = controller._getRotation();
            const circumference = controller._getCircumference();
            min = Math.min(min, rotation);
            max = Math.max(max, rotation + circumference);
        }
        return {
            rotation: min,
            circumference: max - min
        };
    }
    update(mode) {
        const me = this;
        const chart = me.chart;
        const { chartArea: chartArea } = chart;
        const meta = me._cachedMeta;
        const arcs = meta.data;
        const spacing = me.getMaxBorderWidth() + me.getMaxOffset(arcs) + me.options.spacing;
        const maxSize = Math.max((Math.min(chartArea.width, chartArea.height) - spacing) / 2, 0);
        const cutout = Math.min((0, $breCz.k)(me.options.cutout, maxSize), 1);
        const chartWeight = me._getRingWeight(me.index);
        const { circumference: circumference, rotation: rotation } = me._getRotationExtents();
        const { ratioX: ratioX, ratioY: ratioY, offsetX: offsetX, offsetY: offsetY } = $4ffe47e38c59be9a$var$getRatioAndOffset(rotation, circumference, cutout);
        const maxWidth = (chartArea.width - spacing) / ratioX;
        const maxHeight = (chartArea.height - spacing) / ratioY;
        const maxRadius = Math.max(Math.min(maxWidth, maxHeight) / 2, 0);
        const outerRadius = (0, $breCz.m)(me.options.radius, maxRadius);
        const innerRadius = Math.max(outerRadius * cutout, 0);
        const radiusLength = (outerRadius - innerRadius) / me._getVisibleDatasetWeightTotal();
        me.offsetX = offsetX * outerRadius;
        me.offsetY = offsetY * outerRadius;
        meta.total = me.calculateTotal();
        me.outerRadius = outerRadius - radiusLength * me._getRingWeightOffset(me.index);
        me.innerRadius = Math.max(me.outerRadius - radiusLength * chartWeight, 0);
        me.updateElements(arcs, 0, arcs.length, mode);
    }
    _circumference(i, reset) {
        const me = this;
        const opts = me.options;
        const meta = me._cachedMeta;
        const circumference = me._getCircumference();
        if (reset && opts.animation.animateRotate || !this.chart.getDataVisibility(i) || meta._parsed[i] === null) return 0;
        return me.calculateCircumference(meta._parsed[i] * circumference / (0, $breCz.T));
    }
    updateElements(arcs, start, count, mode) {
        const me = this;
        const reset = mode === "reset";
        const chart = me.chart;
        const chartArea = chart.chartArea;
        const opts = chart.options;
        const animationOpts = opts.animation;
        const centerX = (chartArea.left + chartArea.right) / 2;
        const centerY = (chartArea.top + chartArea.bottom) / 2;
        const animateScale = reset && animationOpts.animateScale;
        const innerRadius = animateScale ? 0 : me.innerRadius;
        const outerRadius = animateScale ? 0 : me.outerRadius;
        const firstOpts = me.resolveDataElementOptions(start, mode);
        const sharedOptions = me.getSharedOptions(firstOpts);
        const includeOptions = me.includeOptions(mode, sharedOptions);
        let startAngle = me._getRotation();
        let i;
        for(i = 0; i < start; ++i)startAngle += me._circumference(i, reset);
        for(i = start; i < start + count; ++i){
            const circumference = me._circumference(i, reset);
            const arc = arcs[i];
            const properties = {
                x: centerX + me.offsetX,
                y: centerY + me.offsetY,
                startAngle: startAngle,
                endAngle: startAngle + circumference,
                circumference: circumference,
                outerRadius: outerRadius,
                innerRadius: innerRadius
            };
            if (includeOptions) properties.options = sharedOptions || me.resolveDataElementOptions(i, arc.active ? "active" : mode);
            startAngle += circumference;
            me.updateElement(arc, i, properties, mode);
        }
        me.updateSharedOptions(sharedOptions, mode, firstOpts);
    }
    calculateTotal() {
        const meta = this._cachedMeta;
        const metaData = meta.data;
        let total = 0;
        let i;
        for(i = 0; i < metaData.length; i++){
            const value = meta._parsed[i];
            if (value !== null && !isNaN(value) && this.chart.getDataVisibility(i)) total += Math.abs(value);
        }
        return total;
    }
    calculateCircumference(value) {
        const total = this._cachedMeta.total;
        if (total > 0 && !isNaN(value)) return (0, $breCz.T) * (Math.abs(value) / total);
        return 0;
    }
    getLabelAndValue(index) {
        const me = this;
        const meta = me._cachedMeta;
        const chart = me.chart;
        const labels = chart.data.labels || [];
        const value = (0, $breCz.n)(meta._parsed[index], chart.options.locale);
        return {
            label: labels[index] || "",
            value: value
        };
    }
    getMaxBorderWidth(arcs) {
        const me = this;
        let max = 0;
        const chart = me.chart;
        let i, ilen, meta, controller, options;
        if (!arcs) {
            for(i = 0, ilen = chart.data.datasets.length; i < ilen; ++i)if (chart.isDatasetVisible(i)) {
                meta = chart.getDatasetMeta(i);
                arcs = meta.data;
                controller = meta.controller;
                if (controller !== me) controller.configure();
                break;
            }
        }
        if (!arcs) return 0;
        for(i = 0, ilen = arcs.length; i < ilen; ++i){
            options = controller.resolveDataElementOptions(i);
            if (options.borderAlign !== "inner") max = Math.max(max, options.borderWidth || 0, options.hoverBorderWidth || 0);
        }
        return max;
    }
    getMaxOffset(arcs) {
        let max = 0;
        for(let i = 0, ilen = arcs.length; i < ilen; ++i){
            const options = this.resolveDataElementOptions(i);
            max = Math.max(max, options.offset || 0, options.hoverOffset || 0);
        }
        return max;
    }
    _getRingWeightOffset(datasetIndex) {
        let ringWeightOffset = 0;
        for(let i = 0; i < datasetIndex; ++i)if (this.chart.isDatasetVisible(i)) ringWeightOffset += this._getRingWeight(i);
        return ringWeightOffset;
    }
    _getRingWeight(datasetIndex) {
        return Math.max((0, $breCz.v)(this.chart.data.datasets[datasetIndex].weight, 1), 0);
    }
    _getVisibleDatasetWeightTotal() {
        return this._getRingWeightOffset(this.chart.data.datasets.length) || 1;
    }
}
$4ffe47e38c59be9a$export$e04603e7d8b77172.id = "doughnut";
$4ffe47e38c59be9a$export$e04603e7d8b77172.defaults = {
    datasetElementType: false,
    dataElementType: "arc",
    animation: {
        animateRotate: true,
        animateScale: false
    },
    animations: {
        numbers: {
            type: "number",
            properties: [
                "circumference",
                "endAngle",
                "innerRadius",
                "outerRadius",
                "startAngle",
                "x",
                "y",
                "offset",
                "borderWidth",
                "spacing"
            ]
        }
    },
    cutout: "50%",
    rotation: 0,
    circumference: 360,
    radius: "100%",
    spacing: 0,
    indexAxis: "r"
};
$4ffe47e38c59be9a$export$e04603e7d8b77172.descriptors = {
    _scriptable: (name)=>name !== "spacing",
    _indexable: (name)=>name !== "spacing"
};
$4ffe47e38c59be9a$export$e04603e7d8b77172.overrides = {
    aspectRatio: 1,
    plugins: {
        legend: {
            labels: {
                generateLabels (chart) {
                    const data = chart.data;
                    if (data.labels.length && data.datasets.length) {
                        const { labels: { pointStyle: pointStyle } } = chart.legend.options;
                        return data.labels.map((label, i)=>{
                            const meta = chart.getDatasetMeta(0);
                            const style = meta.controller.getStyle(i);
                            return {
                                text: label,
                                fillStyle: style.backgroundColor,
                                strokeStyle: style.borderColor,
                                lineWidth: style.borderWidth,
                                pointStyle: pointStyle,
                                hidden: !chart.getDataVisibility(i),
                                index: i
                            };
                        });
                    }
                    return [];
                }
            },
            onClick (e, legendItem, legend) {
                legend.chart.toggleDataVisibility(legendItem.index);
                legend.chart.update();
            }
        },
        tooltip: {
            callbacks: {
                title () {
                    return "";
                },
                label (tooltipItem) {
                    let dataLabel = tooltipItem.label;
                    const value = ": " + tooltipItem.formattedValue;
                    if ((0, $breCz.b)(dataLabel)) {
                        dataLabel = dataLabel.slice();
                        dataLabel[0] += value;
                    } else dataLabel += value;
                    return dataLabel;
                }
            }
        }
    }
};
class $4ffe47e38c59be9a$export$3c9b5d28c11cbfd0 extends $4ffe47e38c59be9a$export$75572ec5c55b4048 {
    initialize() {
        this.enableOptionSharing = true;
        super.initialize();
    }
    update(mode) {
        const me = this;
        const meta = me._cachedMeta;
        const { dataset: line, data: points = [], _dataset: _dataset } = meta;
        const animationsDisabled = me.chart._animationsDisabled;
        let { start: start, count: count } = $4ffe47e38c59be9a$var$getStartAndCountOfVisiblePoints(meta, points, animationsDisabled);
        me._drawStart = start;
        me._drawCount = count;
        if ($4ffe47e38c59be9a$var$scaleRangesChanged(meta)) {
            start = 0;
            count = points.length;
        }
        line._decimated = !!_dataset._decimated;
        line.points = points;
        const options = me.resolveDatasetElementOptions(mode);
        if (!me.options.showLine) options.borderWidth = 0;
        options.segment = me.options.segment;
        me.updateElement(line, undefined, {
            animated: !animationsDisabled,
            options: options
        }, mode);
        me.updateElements(points, start, count, mode);
    }
    updateElements(points, start, count, mode) {
        const me = this;
        const reset = mode === "reset";
        const { iScale: iScale, vScale: vScale, _stacked: _stacked } = me._cachedMeta;
        const firstOpts = me.resolveDataElementOptions(start, mode);
        const sharedOptions = me.getSharedOptions(firstOpts);
        const includeOptions = me.includeOptions(mode, sharedOptions);
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        const spanGaps = me.options.spanGaps;
        const maxGapLength = (0, $breCz.p)(spanGaps) ? spanGaps : Number.POSITIVE_INFINITY;
        const directUpdate = me.chart._animationsDisabled || reset || mode === "none";
        let prevParsed = start > 0 && me.getParsed(start - 1);
        for(let i = start; i < start + count; ++i){
            const point = points[i];
            const parsed = me.getParsed(i);
            const properties = directUpdate ? point : {};
            const nullData = (0, $breCz.j)(parsed[vAxis]);
            const iPixel = properties[iAxis] = iScale.getPixelForValue(parsed[iAxis], i);
            const vPixel = properties[vAxis] = reset || nullData ? vScale.getBasePixel() : vScale.getPixelForValue(_stacked ? me.applyStack(vScale, parsed, _stacked) : parsed[vAxis], i);
            properties.skip = isNaN(iPixel) || isNaN(vPixel) || nullData;
            properties.stop = i > 0 && parsed[iAxis] - prevParsed[iAxis] > maxGapLength;
            properties.parsed = parsed;
            if (includeOptions) properties.options = sharedOptions || me.resolveDataElementOptions(i, point.active ? "active" : mode);
            if (!directUpdate) me.updateElement(point, i, properties, mode);
            prevParsed = parsed;
        }
        me.updateSharedOptions(sharedOptions, mode, firstOpts);
    }
    getMaxOverflow() {
        const me = this;
        const meta = me._cachedMeta;
        const dataset = meta.dataset;
        const border = dataset.options && dataset.options.borderWidth || 0;
        const data = meta.data || [];
        if (!data.length) return border;
        const firstPoint = data[0].size(me.resolveDataElementOptions(0));
        const lastPoint = data[data.length - 1].size(me.resolveDataElementOptions(data.length - 1));
        return Math.max(border, firstPoint, lastPoint) / 2;
    }
    draw() {
        const meta = this._cachedMeta;
        meta.dataset.updateControlPoints(this.chart.chartArea, meta.iScale.axis);
        super.draw();
    }
}
$4ffe47e38c59be9a$export$3c9b5d28c11cbfd0.id = "line";
$4ffe47e38c59be9a$export$3c9b5d28c11cbfd0.defaults = {
    datasetElementType: "line",
    dataElementType: "point",
    showLine: true,
    spanGaps: false
};
$4ffe47e38c59be9a$export$3c9b5d28c11cbfd0.overrides = {
    scales: {
        _index_: {
            type: "category"
        },
        _value_: {
            type: "linear"
        }
    }
};
function $4ffe47e38c59be9a$var$getStartAndCountOfVisiblePoints(meta, points, animationsDisabled) {
    const pointCount = points.length;
    let start = 0;
    let count = pointCount;
    if (meta._sorted) {
        const { iScale: iScale, _parsed: _parsed } = meta;
        const axis = iScale.axis;
        const { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = iScale.getUserBounds();
        if (minDefined) start = (0, $breCz.q)(Math.min((0, $breCz.w)(_parsed, iScale.axis, min).lo, animationsDisabled ? pointCount : (0, $breCz.w)(points, axis, iScale.getPixelForValue(min)).lo), 0, pointCount - 1);
        if (maxDefined) count = (0, $breCz.q)(Math.max((0, $breCz.w)(_parsed, iScale.axis, max).hi + 1, animationsDisabled ? 0 : (0, $breCz.w)(points, axis, iScale.getPixelForValue(max)).hi + 1), start, pointCount) - start;
        else count = pointCount - start;
    }
    return {
        start: start,
        count: count
    };
}
function $4ffe47e38c59be9a$var$scaleRangesChanged(meta) {
    const { xScale: xScale, yScale: yScale, _scaleRanges: _scaleRanges } = meta;
    const newRanges = {
        xmin: xScale.min,
        xmax: xScale.max,
        ymin: yScale.min,
        ymax: yScale.max
    };
    if (!_scaleRanges) {
        meta._scaleRanges = newRanges;
        return true;
    }
    const changed = _scaleRanges.xmin !== xScale.min || _scaleRanges.xmax !== xScale.max || _scaleRanges.ymin !== yScale.min || _scaleRanges.ymax !== yScale.max;
    Object.assign(_scaleRanges, newRanges);
    return changed;
}
class $4ffe47e38c59be9a$export$2a270b3a0d973c85 extends $4ffe47e38c59be9a$export$75572ec5c55b4048 {
    constructor(chart, datasetIndex){
        super(chart, datasetIndex);
        this.innerRadius = undefined;
        this.outerRadius = undefined;
    }
    getLabelAndValue(index) {
        const me = this;
        const meta = me._cachedMeta;
        const chart = me.chart;
        const labels = chart.data.labels || [];
        const value = (0, $breCz.n)(meta._parsed[index].r, chart.options.locale);
        return {
            label: labels[index] || "",
            value: value
        };
    }
    update(mode) {
        const arcs = this._cachedMeta.data;
        this._updateRadius();
        this.updateElements(arcs, 0, arcs.length, mode);
    }
    _updateRadius() {
        const me = this;
        const chart = me.chart;
        const chartArea = chart.chartArea;
        const opts = chart.options;
        const minSize = Math.min(chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);
        const outerRadius = Math.max(minSize / 2, 0);
        const innerRadius = Math.max(opts.cutoutPercentage ? outerRadius / 100 * opts.cutoutPercentage : 1, 0);
        const radiusLength = (outerRadius - innerRadius) / chart.getVisibleDatasetCount();
        me.outerRadius = outerRadius - radiusLength * me.index;
        me.innerRadius = me.outerRadius - radiusLength;
    }
    updateElements(arcs, start, count, mode) {
        const me = this;
        const reset = mode === "reset";
        const chart = me.chart;
        const dataset = me.getDataset();
        const opts = chart.options;
        const animationOpts = opts.animation;
        const scale = me._cachedMeta.rScale;
        const centerX = scale.xCenter;
        const centerY = scale.yCenter;
        const datasetStartAngle = scale.getIndexAngle(0) - 0.5 * (0, $breCz.P);
        let angle = datasetStartAngle;
        let i;
        const defaultAngle = 360 / me.countVisibleElements();
        for(i = 0; i < start; ++i)angle += me._computeAngle(i, mode, defaultAngle);
        for(i = start; i < start + count; i++){
            const arc = arcs[i];
            let startAngle = angle;
            let endAngle = angle + me._computeAngle(i, mode, defaultAngle);
            let outerRadius = chart.getDataVisibility(i) ? scale.getDistanceFromCenterForValue(dataset.data[i]) : 0;
            angle = endAngle;
            if (reset) {
                if (animationOpts.animateScale) outerRadius = 0;
                if (animationOpts.animateRotate) startAngle = endAngle = datasetStartAngle;
            }
            const properties = {
                x: centerX,
                y: centerY,
                innerRadius: 0,
                outerRadius: outerRadius,
                startAngle: startAngle,
                endAngle: endAngle,
                options: me.resolveDataElementOptions(i, arc.active ? "active" : mode)
            };
            me.updateElement(arc, i, properties, mode);
        }
    }
    countVisibleElements() {
        const dataset = this.getDataset();
        const meta = this._cachedMeta;
        let count = 0;
        meta.data.forEach((element, index)=>{
            if (!isNaN(dataset.data[index]) && this.chart.getDataVisibility(index)) count++;
        });
        return count;
    }
    _computeAngle(index, mode, defaultAngle) {
        return this.chart.getDataVisibility(index) ? (0, $breCz.t)(this.resolveDataElementOptions(index, mode).angle || defaultAngle) : 0;
    }
}
$4ffe47e38c59be9a$export$2a270b3a0d973c85.id = "polarArea";
$4ffe47e38c59be9a$export$2a270b3a0d973c85.defaults = {
    dataElementType: "arc",
    animation: {
        animateRotate: true,
        animateScale: true
    },
    animations: {
        numbers: {
            type: "number",
            properties: [
                "x",
                "y",
                "startAngle",
                "endAngle",
                "innerRadius",
                "outerRadius"
            ]
        }
    },
    indexAxis: "r",
    startAngle: 0
};
$4ffe47e38c59be9a$export$2a270b3a0d973c85.overrides = {
    aspectRatio: 1,
    plugins: {
        legend: {
            labels: {
                generateLabels (chart) {
                    const data = chart.data;
                    if (data.labels.length && data.datasets.length) {
                        const { labels: { pointStyle: pointStyle } } = chart.legend.options;
                        return data.labels.map((label, i)=>{
                            const meta = chart.getDatasetMeta(0);
                            const style = meta.controller.getStyle(i);
                            return {
                                text: label,
                                fillStyle: style.backgroundColor,
                                strokeStyle: style.borderColor,
                                lineWidth: style.borderWidth,
                                pointStyle: pointStyle,
                                hidden: !chart.getDataVisibility(i),
                                index: i
                            };
                        });
                    }
                    return [];
                }
            },
            onClick (e, legendItem, legend) {
                legend.chart.toggleDataVisibility(legendItem.index);
                legend.chart.update();
            }
        },
        tooltip: {
            callbacks: {
                title () {
                    return "";
                },
                label (context) {
                    return context.chart.data.labels[context.dataIndex] + ": " + context.formattedValue;
                }
            }
        }
    },
    scales: {
        r: {
            type: "radialLinear",
            angleLines: {
                display: false
            },
            beginAtZero: true,
            grid: {
                circular: true
            },
            pointLabels: {
                display: false
            },
            startAngle: 0
        }
    }
};
class $4ffe47e38c59be9a$export$b21a3f1286706191 extends $4ffe47e38c59be9a$export$e04603e7d8b77172 {
}
$4ffe47e38c59be9a$export$b21a3f1286706191.id = "pie";
$4ffe47e38c59be9a$export$b21a3f1286706191.defaults = {
    cutout: 0,
    rotation: 0,
    circumference: 360,
    radius: "100%"
};
class $4ffe47e38c59be9a$export$48dbc6ac651bf8be extends $4ffe47e38c59be9a$export$75572ec5c55b4048 {
    getLabelAndValue(index) {
        const me = this;
        const vScale = me._cachedMeta.vScale;
        const parsed = me.getParsed(index);
        return {
            label: vScale.getLabels()[index],
            value: "" + vScale.getLabelForValue(parsed[vScale.axis])
        };
    }
    update(mode) {
        const me = this;
        const meta = me._cachedMeta;
        const line = meta.dataset;
        const points = meta.data || [];
        const labels = meta.iScale.getLabels();
        line.points = points;
        if (mode !== "resize") {
            const options = me.resolveDatasetElementOptions(mode);
            if (!me.options.showLine) options.borderWidth = 0;
            const properties = {
                _loop: true,
                _fullLoop: labels.length === points.length,
                options: options
            };
            me.updateElement(line, undefined, properties, mode);
        }
        me.updateElements(points, 0, points.length, mode);
    }
    updateElements(points, start, count, mode) {
        const me = this;
        const dataset = me.getDataset();
        const scale = me._cachedMeta.rScale;
        const reset = mode === "reset";
        for(let i = start; i < start + count; i++){
            const point = points[i];
            const options = me.resolveDataElementOptions(i, point.active ? "active" : mode);
            const pointPosition = scale.getPointPositionForValue(i, dataset.data[i]);
            const x = reset ? scale.xCenter : pointPosition.x;
            const y = reset ? scale.yCenter : pointPosition.y;
            const properties = {
                x: x,
                y: y,
                angle: pointPosition.angle,
                skip: isNaN(x) || isNaN(y),
                options: options
            };
            me.updateElement(point, i, properties, mode);
        }
    }
}
$4ffe47e38c59be9a$export$48dbc6ac651bf8be.id = "radar";
$4ffe47e38c59be9a$export$48dbc6ac651bf8be.defaults = {
    datasetElementType: "line",
    dataElementType: "point",
    indexAxis: "r",
    showLine: true,
    elements: {
        line: {
            fill: "start"
        }
    }
};
$4ffe47e38c59be9a$export$48dbc6ac651bf8be.overrides = {
    aspectRatio: 1,
    scales: {
        r: {
            type: "radialLinear"
        }
    }
};
class $4ffe47e38c59be9a$export$b2f2bae6713db87 extends $4ffe47e38c59be9a$export$3c9b5d28c11cbfd0 {
}
$4ffe47e38c59be9a$export$b2f2bae6713db87.id = "scatter";
$4ffe47e38c59be9a$export$b2f2bae6713db87.defaults = {
    showLine: false,
    fill: false
};
$4ffe47e38c59be9a$export$b2f2bae6713db87.overrides = {
    interaction: {
        mode: "point"
    },
    plugins: {
        tooltip: {
            callbacks: {
                title () {
                    return "";
                },
                label (item) {
                    return "(" + item.label + ", " + item.formattedValue + ")";
                }
            }
        }
    },
    scales: {
        x: {
            type: "linear"
        },
        y: {
            type: "linear"
        }
    }
};
var $4ffe47e38c59be9a$export$a6506504f799c5d5 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    BarController: $4ffe47e38c59be9a$export$e97d5dc64e999004,
    BubbleController: $4ffe47e38c59be9a$export$19b5c4773f17abe,
    DoughnutController: $4ffe47e38c59be9a$export$e04603e7d8b77172,
    LineController: $4ffe47e38c59be9a$export$3c9b5d28c11cbfd0,
    PolarAreaController: $4ffe47e38c59be9a$export$2a270b3a0d973c85,
    PieController: $4ffe47e38c59be9a$export$b21a3f1286706191,
    RadarController: $4ffe47e38c59be9a$export$48dbc6ac651bf8be,
    ScatterController: $4ffe47e38c59be9a$export$b2f2bae6713db87
});
function $4ffe47e38c59be9a$var$abstract() {
    throw new Error("This method is not implemented: Check that a complete date adapter is provided.");
}
class $4ffe47e38c59be9a$var$DateAdapter {
    constructor(options){
        this.options = options || {};
    }
    formats() {
        return $4ffe47e38c59be9a$var$abstract();
    }
    parse(value, format) {
        return $4ffe47e38c59be9a$var$abstract();
    }
    format(timestamp, format) {
        return $4ffe47e38c59be9a$var$abstract();
    }
    add(timestamp, amount, unit) {
        return $4ffe47e38c59be9a$var$abstract();
    }
    diff(a, b, unit) {
        return $4ffe47e38c59be9a$var$abstract();
    }
    startOf(timestamp, unit, weekday) {
        return $4ffe47e38c59be9a$var$abstract();
    }
    endOf(timestamp, unit) {
        return $4ffe47e38c59be9a$var$abstract();
    }
}
$4ffe47e38c59be9a$var$DateAdapter.override = function(members) {
    Object.assign($4ffe47e38c59be9a$var$DateAdapter.prototype, members);
};
var $4ffe47e38c59be9a$export$f32766ea09ec8bc4 = {
    _date: $4ffe47e38c59be9a$var$DateAdapter
};
function $4ffe47e38c59be9a$var$getRelativePosition(e, chart) {
    if ("native" in e) return {
        x: e.x,
        y: e.y
    };
    return (0, $breCz.x)(e, chart);
}
function $4ffe47e38c59be9a$var$evaluateAllVisibleItems(chart, handler) {
    const metasets = chart.getSortedVisibleDatasetMetas();
    let index, data, element;
    for(let i = 0, ilen = metasets.length; i < ilen; ++i){
        ({ index: index, data: data } = metasets[i]);
        for(let j = 0, jlen = data.length; j < jlen; ++j){
            element = data[j];
            if (!element.skip) handler(element, index, j);
        }
    }
}
function $4ffe47e38c59be9a$var$binarySearch(metaset, axis, value, intersect) {
    const { controller: controller, data: data, _sorted: _sorted } = metaset;
    const iScale = controller._cachedMeta.iScale;
    if (iScale && axis === iScale.axis && _sorted && data.length) {
        const lookupMethod = iScale._reversePixels ? (0, $breCz.z) : (0, $breCz.w);
        if (!intersect) return lookupMethod(data, axis, value);
        else if (controller._sharedOptions) {
            const el = data[0];
            const range = typeof el.getRange === "function" && el.getRange(axis);
            if (range) {
                const start = lookupMethod(data, axis, value - range);
                const end = lookupMethod(data, axis, value + range);
                return {
                    lo: start.lo,
                    hi: end.hi
                };
            }
        }
    }
    return {
        lo: 0,
        hi: data.length - 1
    };
}
function $4ffe47e38c59be9a$var$optimizedEvaluateItems(chart, axis, position, handler, intersect) {
    const metasets = chart.getSortedVisibleDatasetMetas();
    const value = position[axis];
    for(let i = 0, ilen = metasets.length; i < ilen; ++i){
        const { index: index, data: data } = metasets[i];
        const { lo: lo, hi: hi } = $4ffe47e38c59be9a$var$binarySearch(metasets[i], axis, value, intersect);
        for(let j = lo; j <= hi; ++j){
            const element = data[j];
            if (!element.skip) handler(element, index, j);
        }
    }
}
function $4ffe47e38c59be9a$var$getDistanceMetricForAxis(axis) {
    const useX = axis.indexOf("x") !== -1;
    const useY = axis.indexOf("y") !== -1;
    return function(pt1, pt2) {
        const deltaX = useX ? Math.abs(pt1.x - pt2.x) : 0;
        const deltaY = useY ? Math.abs(pt1.y - pt2.y) : 0;
        return Math.sqrt(Math.pow(deltaX, 2) + Math.pow(deltaY, 2));
    };
}
function $4ffe47e38c59be9a$var$getIntersectItems(chart, position, axis, useFinalPosition) {
    const items = [];
    if (!(0, $breCz.y)(position, chart.chartArea, chart._minPadding)) return items;
    const evaluationFunc = function(element, datasetIndex, index) {
        if (element.inRange(position.x, position.y, useFinalPosition)) items.push({
            element: element,
            datasetIndex: datasetIndex,
            index: index
        });
    };
    $4ffe47e38c59be9a$var$optimizedEvaluateItems(chart, axis, position, evaluationFunc, true);
    return items;
}
function $4ffe47e38c59be9a$var$getNearestItems(chart, position, axis, intersect, useFinalPosition) {
    const distanceMetric = $4ffe47e38c59be9a$var$getDistanceMetricForAxis(axis);
    let minDistance = Number.POSITIVE_INFINITY;
    let items = [];
    if (!(0, $breCz.y)(position, chart.chartArea, chart._minPadding)) return items;
    const evaluationFunc = function(element, datasetIndex, index) {
        if (intersect && !element.inRange(position.x, position.y, useFinalPosition)) return;
        const center = element.getCenterPoint(useFinalPosition);
        if (!(0, $breCz.y)(center, chart.chartArea, chart._minPadding)) return;
        const distance = distanceMetric(position, center);
        if (distance < minDistance) {
            items = [
                {
                    element: element,
                    datasetIndex: datasetIndex,
                    index: index
                }
            ];
            minDistance = distance;
        } else if (distance === minDistance) items.push({
            element: element,
            datasetIndex: datasetIndex,
            index: index
        });
    };
    $4ffe47e38c59be9a$var$optimizedEvaluateItems(chart, axis, position, evaluationFunc);
    return items;
}
function $4ffe47e38c59be9a$var$getAxisItems(chart, e, options, useFinalPosition) {
    const position = $4ffe47e38c59be9a$var$getRelativePosition(e, chart);
    const items = [];
    const axis = options.axis;
    const rangeMethod = axis === "x" ? "inXRange" : "inYRange";
    let intersectsItem = false;
    $4ffe47e38c59be9a$var$evaluateAllVisibleItems(chart, (element, datasetIndex, index)=>{
        if (element[rangeMethod](position[axis], useFinalPosition)) items.push({
            element: element,
            datasetIndex: datasetIndex,
            index: index
        });
        if (element.inRange(position.x, position.y, useFinalPosition)) intersectsItem = true;
    });
    if (options.intersect && !intersectsItem) return [];
    return items;
}
var $4ffe47e38c59be9a$export$a13296960cae0384 = {
    modes: {
        index (chart, e, options, useFinalPosition) {
            const position = $4ffe47e38c59be9a$var$getRelativePosition(e, chart);
            const axis = options.axis || "x";
            const items = options.intersect ? $4ffe47e38c59be9a$var$getIntersectItems(chart, position, axis, useFinalPosition) : $4ffe47e38c59be9a$var$getNearestItems(chart, position, axis, false, useFinalPosition);
            const elements = [];
            if (!items.length) return [];
            chart.getSortedVisibleDatasetMetas().forEach((meta)=>{
                const index = items[0].index;
                const element = meta.data[index];
                if (element && !element.skip) elements.push({
                    element: element,
                    datasetIndex: meta.index,
                    index: index
                });
            });
            return elements;
        },
        dataset (chart, e, options, useFinalPosition) {
            const position = $4ffe47e38c59be9a$var$getRelativePosition(e, chart);
            const axis = options.axis || "xy";
            let items = options.intersect ? $4ffe47e38c59be9a$var$getIntersectItems(chart, position, axis, useFinalPosition) : $4ffe47e38c59be9a$var$getNearestItems(chart, position, axis, false, useFinalPosition);
            if (items.length > 0) {
                const datasetIndex = items[0].datasetIndex;
                const data = chart.getDatasetMeta(datasetIndex).data;
                items = [];
                for(let i = 0; i < data.length; ++i)items.push({
                    element: data[i],
                    datasetIndex: datasetIndex,
                    index: i
                });
            }
            return items;
        },
        point (chart, e, options, useFinalPosition) {
            const position = $4ffe47e38c59be9a$var$getRelativePosition(e, chart);
            const axis = options.axis || "xy";
            return $4ffe47e38c59be9a$var$getIntersectItems(chart, position, axis, useFinalPosition);
        },
        nearest (chart, e, options, useFinalPosition) {
            const position = $4ffe47e38c59be9a$var$getRelativePosition(e, chart);
            const axis = options.axis || "xy";
            return $4ffe47e38c59be9a$var$getNearestItems(chart, position, axis, options.intersect, useFinalPosition);
        },
        x (chart, e, options, useFinalPosition) {
            options.axis = "x";
            return $4ffe47e38c59be9a$var$getAxisItems(chart, e, options, useFinalPosition);
        },
        y (chart, e, options, useFinalPosition) {
            options.axis = "y";
            return $4ffe47e38c59be9a$var$getAxisItems(chart, e, options, useFinalPosition);
        }
    }
};
const $4ffe47e38c59be9a$var$STATIC_POSITIONS = [
    "left",
    "top",
    "right",
    "bottom"
];
function $4ffe47e38c59be9a$var$filterByPosition(array, position) {
    return array.filter((v)=>v.pos === position);
}
function $4ffe47e38c59be9a$var$filterDynamicPositionByAxis(array, axis) {
    return array.filter((v)=>$4ffe47e38c59be9a$var$STATIC_POSITIONS.indexOf(v.pos) === -1 && v.box.axis === axis);
}
function $4ffe47e38c59be9a$var$sortByWeight(array, reverse) {
    return array.sort((a, b)=>{
        const v0 = reverse ? b : a;
        const v1 = reverse ? a : b;
        return v0.weight === v1.weight ? v0.index - v1.index : v0.weight - v1.weight;
    });
}
function $4ffe47e38c59be9a$var$wrapBoxes(boxes) {
    const layoutBoxes = [];
    let i, ilen, box;
    for(i = 0, ilen = (boxes || []).length; i < ilen; ++i){
        box = boxes[i];
        layoutBoxes.push({
            index: i,
            box: box,
            pos: box.position,
            horizontal: box.isHorizontal(),
            weight: box.weight
        });
    }
    return layoutBoxes;
}
function $4ffe47e38c59be9a$var$setLayoutDims(layouts, params) {
    let i, ilen, layout;
    for(i = 0, ilen = layouts.length; i < ilen; ++i){
        layout = layouts[i];
        if (layout.horizontal) {
            layout.width = layout.box.fullSize && params.availableWidth;
            layout.height = params.hBoxMaxHeight;
        } else {
            layout.width = params.vBoxMaxWidth;
            layout.height = layout.box.fullSize && params.availableHeight;
        }
    }
}
function $4ffe47e38c59be9a$var$buildLayoutBoxes(boxes) {
    const layoutBoxes = $4ffe47e38c59be9a$var$wrapBoxes(boxes);
    const fullSize = $4ffe47e38c59be9a$var$sortByWeight(layoutBoxes.filter((wrap)=>wrap.box.fullSize), true);
    const left = $4ffe47e38c59be9a$var$sortByWeight($4ffe47e38c59be9a$var$filterByPosition(layoutBoxes, "left"), true);
    const right = $4ffe47e38c59be9a$var$sortByWeight($4ffe47e38c59be9a$var$filterByPosition(layoutBoxes, "right"));
    const top = $4ffe47e38c59be9a$var$sortByWeight($4ffe47e38c59be9a$var$filterByPosition(layoutBoxes, "top"), true);
    const bottom = $4ffe47e38c59be9a$var$sortByWeight($4ffe47e38c59be9a$var$filterByPosition(layoutBoxes, "bottom"));
    const centerHorizontal = $4ffe47e38c59be9a$var$filterDynamicPositionByAxis(layoutBoxes, "x");
    const centerVertical = $4ffe47e38c59be9a$var$filterDynamicPositionByAxis(layoutBoxes, "y");
    return {
        fullSize: fullSize,
        leftAndTop: left.concat(top),
        rightAndBottom: right.concat(centerVertical).concat(bottom).concat(centerHorizontal),
        chartArea: $4ffe47e38c59be9a$var$filterByPosition(layoutBoxes, "chartArea"),
        vertical: left.concat(right).concat(centerVertical),
        horizontal: top.concat(bottom).concat(centerHorizontal)
    };
}
function $4ffe47e38c59be9a$var$getCombinedMax(maxPadding, chartArea, a, b) {
    return Math.max(maxPadding[a], chartArea[a]) + Math.max(maxPadding[b], chartArea[b]);
}
function $4ffe47e38c59be9a$var$updateMaxPadding(maxPadding, boxPadding) {
    maxPadding.top = Math.max(maxPadding.top, boxPadding.top);
    maxPadding.left = Math.max(maxPadding.left, boxPadding.left);
    maxPadding.bottom = Math.max(maxPadding.bottom, boxPadding.bottom);
    maxPadding.right = Math.max(maxPadding.right, boxPadding.right);
}
function $4ffe47e38c59be9a$var$updateDims(chartArea, params, layout) {
    const box = layout.box;
    const maxPadding = chartArea.maxPadding;
    if (!(0, $breCz.i)(layout.pos)) {
        if (layout.size) chartArea[layout.pos] -= layout.size;
        layout.size = layout.horizontal ? box.height : box.width;
        chartArea[layout.pos] += layout.size;
    }
    if (box.getPadding) $4ffe47e38c59be9a$var$updateMaxPadding(maxPadding, box.getPadding());
    const newWidth = Math.max(0, params.outerWidth - $4ffe47e38c59be9a$var$getCombinedMax(maxPadding, chartArea, "left", "right"));
    const newHeight = Math.max(0, params.outerHeight - $4ffe47e38c59be9a$var$getCombinedMax(maxPadding, chartArea, "top", "bottom"));
    const widthChanged = newWidth !== chartArea.w;
    const heightChanged = newHeight !== chartArea.h;
    chartArea.w = newWidth;
    chartArea.h = newHeight;
    return layout.horizontal ? {
        same: widthChanged,
        other: heightChanged
    } : {
        same: heightChanged,
        other: widthChanged
    };
}
function $4ffe47e38c59be9a$var$handleMaxPadding(chartArea) {
    const maxPadding = chartArea.maxPadding;
    function updatePos(pos) {
        const change = Math.max(maxPadding[pos] - chartArea[pos], 0);
        chartArea[pos] += change;
        return change;
    }
    chartArea.y += updatePos("top");
    chartArea.x += updatePos("left");
    updatePos("right");
    updatePos("bottom");
}
function $4ffe47e38c59be9a$var$getMargins(horizontal, chartArea) {
    const maxPadding = chartArea.maxPadding;
    function marginForPositions(positions) {
        const margin = {
            left: 0,
            top: 0,
            right: 0,
            bottom: 0
        };
        positions.forEach((pos)=>{
            margin[pos] = Math.max(chartArea[pos], maxPadding[pos]);
        });
        return margin;
    }
    return horizontal ? marginForPositions([
        "left",
        "right"
    ]) : marginForPositions([
        "top",
        "bottom"
    ]);
}
function $4ffe47e38c59be9a$var$fitBoxes(boxes, chartArea, params) {
    const refitBoxes = [];
    let i, ilen, layout, box, refit, changed;
    for(i = 0, ilen = boxes.length, refit = 0; i < ilen; ++i){
        layout = boxes[i];
        box = layout.box;
        box.update(layout.width || chartArea.w, layout.height || chartArea.h, $4ffe47e38c59be9a$var$getMargins(layout.horizontal, chartArea));
        const { same: same, other: other } = $4ffe47e38c59be9a$var$updateDims(chartArea, params, layout);
        refit |= same && refitBoxes.length;
        changed = changed || other;
        if (!box.fullSize) refitBoxes.push(layout);
    }
    return refit && $4ffe47e38c59be9a$var$fitBoxes(refitBoxes, chartArea, params) || changed;
}
function $4ffe47e38c59be9a$var$placeBoxes(boxes, chartArea, params) {
    const userPadding = params.padding;
    let x = chartArea.x;
    let y = chartArea.y;
    let i, ilen, layout, box;
    for(i = 0, ilen = boxes.length; i < ilen; ++i){
        layout = boxes[i];
        box = layout.box;
        if (layout.horizontal) {
            box.left = box.fullSize ? userPadding.left : chartArea.left;
            box.right = box.fullSize ? params.outerWidth - userPadding.right : chartArea.left + chartArea.w;
            box.top = y;
            box.bottom = y + box.height;
            box.width = box.right - box.left;
            y = box.bottom;
        } else {
            box.left = x;
            box.right = x + box.width;
            box.top = box.fullSize ? userPadding.top : chartArea.top;
            box.bottom = box.fullSize ? params.outerHeight - userPadding.bottom : chartArea.top + chartArea.h;
            box.height = box.bottom - box.top;
            x = box.right;
        }
    }
    chartArea.x = x;
    chartArea.y = y;
}
(0, $breCz.d).set("layout", {
    padding: {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    }
});
var $4ffe47e38c59be9a$export$1ecca0613f5e56d2 = {
    addBox (chart, item) {
        if (!chart.boxes) chart.boxes = [];
        item.fullSize = item.fullSize || false;
        item.position = item.position || "top";
        item.weight = item.weight || 0;
        item._layers = item._layers || function() {
            return [
                {
                    z: 0,
                    draw (chartArea) {
                        item.draw(chartArea);
                    }
                }
            ];
        };
        chart.boxes.push(item);
    },
    removeBox (chart, layoutItem) {
        const index = chart.boxes ? chart.boxes.indexOf(layoutItem) : -1;
        if (index !== -1) chart.boxes.splice(index, 1);
    },
    configure (chart, item, options) {
        item.fullSize = options.fullSize;
        item.position = options.position;
        item.weight = options.weight;
    },
    update (chart, width, height, minPadding) {
        if (!chart) return;
        const padding = (0, $breCz.A)(chart.options.layout.padding);
        const availableWidth = Math.max(width - padding.width, 0);
        const availableHeight = Math.max(height - padding.height, 0);
        const boxes = $4ffe47e38c59be9a$var$buildLayoutBoxes(chart.boxes);
        const verticalBoxes = boxes.vertical;
        const horizontalBoxes = boxes.horizontal;
        (0, $breCz.B)(chart.boxes, (box)=>{
            if (typeof box.beforeLayout === "function") box.beforeLayout();
        });
        const visibleVerticalBoxCount = verticalBoxes.reduce((total, wrap)=>wrap.box.options && wrap.box.options.display === false ? total : total + 1, 0) || 1;
        const params = Object.freeze({
            outerWidth: width,
            outerHeight: height,
            padding: padding,
            availableWidth: availableWidth,
            availableHeight: availableHeight,
            vBoxMaxWidth: availableWidth / 2 / visibleVerticalBoxCount,
            hBoxMaxHeight: availableHeight / 2
        });
        const maxPadding = Object.assign({}, padding);
        $4ffe47e38c59be9a$var$updateMaxPadding(maxPadding, (0, $breCz.A)(minPadding));
        const chartArea = Object.assign({
            maxPadding: maxPadding,
            w: availableWidth,
            h: availableHeight,
            x: padding.left,
            y: padding.top
        }, padding);
        $4ffe47e38c59be9a$var$setLayoutDims(verticalBoxes.concat(horizontalBoxes), params);
        $4ffe47e38c59be9a$var$fitBoxes(boxes.fullSize, chartArea, params);
        $4ffe47e38c59be9a$var$fitBoxes(verticalBoxes, chartArea, params);
        if ($4ffe47e38c59be9a$var$fitBoxes(horizontalBoxes, chartArea, params)) $4ffe47e38c59be9a$var$fitBoxes(verticalBoxes, chartArea, params);
        $4ffe47e38c59be9a$var$handleMaxPadding(chartArea);
        $4ffe47e38c59be9a$var$placeBoxes(boxes.leftAndTop, chartArea, params);
        chartArea.x += chartArea.w;
        chartArea.y += chartArea.h;
        $4ffe47e38c59be9a$var$placeBoxes(boxes.rightAndBottom, chartArea, params);
        chart.chartArea = {
            left: chartArea.left,
            top: chartArea.top,
            right: chartArea.left + chartArea.w,
            bottom: chartArea.top + chartArea.h,
            height: chartArea.h,
            width: chartArea.w
        };
        (0, $breCz.B)(boxes.chartArea, (layout)=>{
            const box = layout.box;
            Object.assign(box, chart.chartArea);
            box.update(chartArea.w, chartArea.h);
        });
    }
};
class $4ffe47e38c59be9a$export$7b1aeb87f31f7da8 {
    acquireContext(canvas, aspectRatio) {}
    releaseContext(context) {
        return false;
    }
    addEventListener(chart, type, listener) {}
    removeEventListener(chart, type, listener) {}
    getDevicePixelRatio() {
        return 1;
    }
    getMaximumSize(element, width, height, aspectRatio) {
        width = Math.max(0, width || element.width);
        height = height || element.height;
        return {
            width: width,
            height: Math.max(0, aspectRatio ? Math.floor(width / aspectRatio) : height)
        };
    }
    isAttached(canvas) {
        return true;
    }
}
class $4ffe47e38c59be9a$export$a40a96b24b46cf35 extends $4ffe47e38c59be9a$export$7b1aeb87f31f7da8 {
    acquireContext(item) {
        return item && item.getContext && item.getContext("2d") || null;
    }
}
const $4ffe47e38c59be9a$var$EXPANDO_KEY = "$chartjs";
const $4ffe47e38c59be9a$var$EVENT_TYPES = {
    touchstart: "mousedown",
    touchmove: "mousemove",
    touchend: "mouseup",
    pointerenter: "mouseenter",
    pointerdown: "mousedown",
    pointermove: "mousemove",
    pointerup: "mouseup",
    pointerleave: "mouseout",
    pointerout: "mouseout"
};
const $4ffe47e38c59be9a$var$isNullOrEmpty = (value)=>value === null || value === "";
function $4ffe47e38c59be9a$var$initCanvas(canvas, aspectRatio) {
    const style = canvas.style;
    const renderHeight = canvas.getAttribute("height");
    const renderWidth = canvas.getAttribute("width");
    canvas[$4ffe47e38c59be9a$var$EXPANDO_KEY] = {
        initial: {
            height: renderHeight,
            width: renderWidth,
            style: {
                display: style.display,
                height: style.height,
                width: style.width
            }
        }
    };
    style.display = style.display || "block";
    style.boxSizing = style.boxSizing || "border-box";
    if ($4ffe47e38c59be9a$var$isNullOrEmpty(renderWidth)) {
        const displayWidth = (0, $breCz.E)(canvas, "width");
        if (displayWidth !== undefined) canvas.width = displayWidth;
    }
    if ($4ffe47e38c59be9a$var$isNullOrEmpty(renderHeight)) {
        if (canvas.style.height === "") canvas.height = canvas.width / (aspectRatio || 2);
        else {
            const displayHeight = (0, $breCz.E)(canvas, "height");
            if (displayHeight !== undefined) canvas.height = displayHeight;
        }
    }
    return canvas;
}
const $4ffe47e38c59be9a$var$eventListenerOptions = (0, $breCz.G) ? {
    passive: true
} : false;
function $4ffe47e38c59be9a$var$addListener(node, type, listener) {
    node.addEventListener(type, listener, $4ffe47e38c59be9a$var$eventListenerOptions);
}
function $4ffe47e38c59be9a$var$removeListener(chart, type, listener) {
    chart.canvas.removeEventListener(type, listener, $4ffe47e38c59be9a$var$eventListenerOptions);
}
function $4ffe47e38c59be9a$var$fromNativeEvent(event, chart) {
    const type = $4ffe47e38c59be9a$var$EVENT_TYPES[event.type] || event.type;
    const { x: x, y: y } = (0, $breCz.x)(event, chart);
    return {
        type: type,
        chart: chart,
        native: event,
        x: x !== undefined ? x : null,
        y: y !== undefined ? y : null
    };
}
function $4ffe47e38c59be9a$var$createAttachObserver(chart, type, listener) {
    const canvas = chart.canvas;
    const container = canvas && (0, $breCz.D)(canvas);
    const element = container || canvas;
    const observer = new MutationObserver((entries)=>{
        const parent = (0, $breCz.D)(element);
        entries.forEach((entry)=>{
            for(let i = 0; i < entry.addedNodes.length; i++){
                const added = entry.addedNodes[i];
                if (added === element || added === parent) listener(entry.target);
            }
        });
    });
    observer.observe(document, {
        childList: true,
        subtree: true
    });
    return observer;
}
function $4ffe47e38c59be9a$var$createDetachObserver(chart, type, listener) {
    const canvas = chart.canvas;
    const container = canvas && (0, $breCz.D)(canvas);
    if (!container) return;
    const observer = new MutationObserver((entries)=>{
        entries.forEach((entry)=>{
            for(let i = 0; i < entry.removedNodes.length; i++)if (entry.removedNodes[i] === canvas) {
                listener();
                break;
            }
        });
    });
    observer.observe(container, {
        childList: true
    });
    return observer;
}
const $4ffe47e38c59be9a$var$drpListeningCharts = new Map();
let $4ffe47e38c59be9a$var$oldDevicePixelRatio = 0;
function $4ffe47e38c59be9a$var$onWindowResize() {
    const dpr = window.devicePixelRatio;
    if (dpr === $4ffe47e38c59be9a$var$oldDevicePixelRatio) return;
    $4ffe47e38c59be9a$var$oldDevicePixelRatio = dpr;
    $4ffe47e38c59be9a$var$drpListeningCharts.forEach((resize, chart)=>{
        if (chart.currentDevicePixelRatio !== dpr) resize();
    });
}
function $4ffe47e38c59be9a$var$listenDevicePixelRatioChanges(chart, resize) {
    if (!$4ffe47e38c59be9a$var$drpListeningCharts.size) window.addEventListener("resize", $4ffe47e38c59be9a$var$onWindowResize);
    $4ffe47e38c59be9a$var$drpListeningCharts.set(chart, resize);
}
function $4ffe47e38c59be9a$var$unlistenDevicePixelRatioChanges(chart) {
    $4ffe47e38c59be9a$var$drpListeningCharts.delete(chart);
    if (!$4ffe47e38c59be9a$var$drpListeningCharts.size) window.removeEventListener("resize", $4ffe47e38c59be9a$var$onWindowResize);
}
function $4ffe47e38c59be9a$var$createResizeObserver(chart, type, listener) {
    const canvas = chart.canvas;
    const container = canvas && (0, $breCz.D)(canvas);
    if (!container) return;
    const resize = (0, $breCz.F)((width, height)=>{
        const w = container.clientWidth;
        listener(width, height);
        if (w < container.clientWidth) listener();
    }, window);
    const observer = new ResizeObserver((entries)=>{
        const entry = entries[0];
        const width = entry.contentRect.width;
        const height = entry.contentRect.height;
        if (width === 0 && height === 0) return;
        resize(width, height);
    });
    observer.observe(container);
    $4ffe47e38c59be9a$var$listenDevicePixelRatioChanges(chart, resize);
    return observer;
}
function $4ffe47e38c59be9a$var$releaseObserver(chart, type, observer) {
    if (observer) observer.disconnect();
    if (type === "resize") $4ffe47e38c59be9a$var$unlistenDevicePixelRatioChanges(chart);
}
function $4ffe47e38c59be9a$var$createProxyAndListen(chart, type, listener) {
    const canvas = chart.canvas;
    const proxy = (0, $breCz.F)((event)=>{
        if (chart.ctx !== null) listener($4ffe47e38c59be9a$var$fromNativeEvent(event, chart));
    }, chart, (args)=>{
        const event = args[0];
        return [
            event,
            event.offsetX,
            event.offsetY
        ];
    });
    $4ffe47e38c59be9a$var$addListener(canvas, type, proxy);
    return proxy;
}
class $4ffe47e38c59be9a$export$f02da7f882cf6b2e extends $4ffe47e38c59be9a$export$7b1aeb87f31f7da8 {
    acquireContext(canvas, aspectRatio) {
        const context = canvas && canvas.getContext && canvas.getContext("2d");
        if (context && context.canvas === canvas) {
            $4ffe47e38c59be9a$var$initCanvas(canvas, aspectRatio);
            return context;
        }
        return null;
    }
    releaseContext(context) {
        const canvas = context.canvas;
        if (!canvas[$4ffe47e38c59be9a$var$EXPANDO_KEY]) return false;
        const initial = canvas[$4ffe47e38c59be9a$var$EXPANDO_KEY].initial;
        [
            "height",
            "width"
        ].forEach((prop)=>{
            const value = initial[prop];
            if ((0, $breCz.j)(value)) canvas.removeAttribute(prop);
            else canvas.setAttribute(prop, value);
        });
        const style = initial.style || {};
        Object.keys(style).forEach((key)=>{
            canvas.style[key] = style[key];
        });
        canvas.width = canvas.width;
        delete canvas[$4ffe47e38c59be9a$var$EXPANDO_KEY];
        return true;
    }
    addEventListener(chart, type, listener) {
        this.removeEventListener(chart, type);
        const proxies = chart.$proxies || (chart.$proxies = {});
        const handlers = {
            attach: $4ffe47e38c59be9a$var$createAttachObserver,
            detach: $4ffe47e38c59be9a$var$createDetachObserver,
            resize: $4ffe47e38c59be9a$var$createResizeObserver
        };
        const handler = handlers[type] || $4ffe47e38c59be9a$var$createProxyAndListen;
        proxies[type] = handler(chart, type, listener);
    }
    removeEventListener(chart, type) {
        const proxies = chart.$proxies || (chart.$proxies = {});
        const proxy = proxies[type];
        if (!proxy) return;
        const handlers = {
            attach: $4ffe47e38c59be9a$var$releaseObserver,
            detach: $4ffe47e38c59be9a$var$releaseObserver,
            resize: $4ffe47e38c59be9a$var$releaseObserver
        };
        const handler = handlers[type] || $4ffe47e38c59be9a$var$removeListener;
        handler(chart, type, proxy);
        proxies[type] = undefined;
    }
    getDevicePixelRatio() {
        return window.devicePixelRatio;
    }
    getMaximumSize(canvas, width, height, aspectRatio) {
        return (0, $breCz.C)(canvas, width, height, aspectRatio);
    }
    isAttached(canvas) {
        const container = (0, $breCz.D)(canvas);
        return !!(container && (0, $breCz.D)(container));
    }
}
class $4ffe47e38c59be9a$export$db77ccec0bb4ccac {
    constructor(){
        this.x = undefined;
        this.y = undefined;
        this.active = false;
        this.options = undefined;
        this.$animations = undefined;
    }
    tooltipPosition(useFinalPosition) {
        const { x: x, y: y } = this.getProps([
            "x",
            "y"
        ], useFinalPosition);
        return {
            x: x,
            y: y
        };
    }
    hasValue() {
        return (0, $breCz.p)(this.x) && (0, $breCz.p)(this.y);
    }
    getProps(props, final) {
        const me = this;
        const anims = this.$animations;
        if (!final || !anims) return me;
        const ret = {};
        props.forEach((prop)=>{
            ret[prop] = anims[prop] && anims[prop].active() ? anims[prop]._to : me[prop];
        });
        return ret;
    }
}
$4ffe47e38c59be9a$export$db77ccec0bb4ccac.defaults = {};
$4ffe47e38c59be9a$export$db77ccec0bb4ccac.defaultRoutes = undefined;
const $4ffe47e38c59be9a$var$formatters = {
    values (value) {
        return (0, $breCz.b)(value) ? value : "" + value;
    },
    numeric (tickValue, index, ticks) {
        if (tickValue === 0) return "0";
        const locale = this.chart.options.locale;
        let notation;
        let delta = tickValue;
        if (ticks.length > 1) {
            const maxTick = Math.max(Math.abs(ticks[0].value), Math.abs(ticks[ticks.length - 1].value));
            if (maxTick < 1e-4 || maxTick > 1e+15) notation = "scientific";
            delta = $4ffe47e38c59be9a$var$calculateDelta(tickValue, ticks);
        }
        const logDelta = (0, $breCz.I)(Math.abs(delta));
        const numDecimal = Math.max(Math.min(-1 * Math.floor(logDelta), 20), 0);
        const options = {
            notation: notation,
            minimumFractionDigits: numDecimal,
            maximumFractionDigits: numDecimal
        };
        Object.assign(options, this.options.ticks.format);
        return (0, $breCz.n)(tickValue, locale, options);
    },
    logarithmic (tickValue, index, ticks) {
        if (tickValue === 0) return "0";
        const remain = tickValue / Math.pow(10, Math.floor((0, $breCz.I)(tickValue)));
        if (remain === 1 || remain === 2 || remain === 5) return $4ffe47e38c59be9a$var$formatters.numeric.call(this, tickValue, index, ticks);
        return "";
    }
};
function $4ffe47e38c59be9a$var$calculateDelta(tickValue, ticks) {
    let delta = ticks.length > 3 ? ticks[2].value - ticks[1].value : ticks[1].value - ticks[0].value;
    if (Math.abs(delta) >= 1 && tickValue !== Math.floor(tickValue)) delta = tickValue - Math.floor(tickValue);
    return delta;
}
var $4ffe47e38c59be9a$export$27c7467594ef87bd = {
    formatters: $4ffe47e38c59be9a$var$formatters
};
(0, $breCz.d).set("scale", {
    display: true,
    offset: false,
    reverse: false,
    beginAtZero: false,
    bounds: "ticks",
    grace: 0,
    grid: {
        display: true,
        lineWidth: 1,
        drawBorder: true,
        drawOnChartArea: true,
        drawTicks: true,
        tickLength: 8,
        tickWidth: (_ctx, options)=>options.lineWidth,
        tickColor: (_ctx, options)=>options.color,
        offset: false,
        borderDash: [],
        borderDashOffset: 0.0,
        borderWidth: 1
    },
    title: {
        display: false,
        text: "",
        padding: {
            top: 4,
            bottom: 4
        }
    },
    ticks: {
        minRotation: 0,
        maxRotation: 50,
        mirror: false,
        textStrokeWidth: 0,
        textStrokeColor: "",
        padding: 3,
        display: true,
        autoSkip: true,
        autoSkipPadding: 3,
        labelOffset: 0,
        callback: $4ffe47e38c59be9a$export$27c7467594ef87bd.formatters.values,
        minor: {},
        major: {},
        align: "center",
        crossAlign: "near",
        showLabelBackdrop: false,
        backdropColor: "rgba(255, 255, 255, 0.75)",
        backdropPadding: 2
    }
});
(0, $breCz.d).route("scale.ticks", "color", "", "color");
(0, $breCz.d).route("scale.grid", "color", "", "borderColor");
(0, $breCz.d).route("scale.grid", "borderColor", "", "borderColor");
(0, $breCz.d).route("scale.title", "color", "", "color");
(0, $breCz.d).describe("scale", {
    _fallback: false,
    _scriptable: (name)=>!name.startsWith("before") && !name.startsWith("after") && name !== "callback" && name !== "parser",
    _indexable: (name)=>name !== "borderDash" && name !== "tickBorderDash"
});
(0, $breCz.d).describe("scales", {
    _fallback: "scale"
});
(0, $breCz.d).describe("scale.ticks", {
    _scriptable: (name)=>name !== "backdropPadding" && name !== "callback",
    _indexable: (name)=>name !== "backdropPadding"
});
function $4ffe47e38c59be9a$var$autoSkip(scale, ticks) {
    const tickOpts = scale.options.ticks;
    const ticksLimit = tickOpts.maxTicksLimit || $4ffe47e38c59be9a$var$determineMaxTicks(scale);
    const majorIndices = tickOpts.major.enabled ? $4ffe47e38c59be9a$var$getMajorIndices(ticks) : [];
    const numMajorIndices = majorIndices.length;
    const first = majorIndices[0];
    const last = majorIndices[numMajorIndices - 1];
    const newTicks = [];
    if (numMajorIndices > ticksLimit) {
        $4ffe47e38c59be9a$var$skipMajors(ticks, newTicks, majorIndices, numMajorIndices / ticksLimit);
        return newTicks;
    }
    const spacing = $4ffe47e38c59be9a$var$calculateSpacing(majorIndices, ticks, ticksLimit);
    if (numMajorIndices > 0) {
        let i, ilen;
        const avgMajorSpacing = numMajorIndices > 1 ? Math.round((last - first) / (numMajorIndices - 1)) : null;
        $4ffe47e38c59be9a$var$skip(ticks, newTicks, spacing, (0, $breCz.j)(avgMajorSpacing) ? 0 : first - avgMajorSpacing, first);
        for(i = 0, ilen = numMajorIndices - 1; i < ilen; i++)$4ffe47e38c59be9a$var$skip(ticks, newTicks, spacing, majorIndices[i], majorIndices[i + 1]);
        $4ffe47e38c59be9a$var$skip(ticks, newTicks, spacing, last, (0, $breCz.j)(avgMajorSpacing) ? ticks.length : last + avgMajorSpacing);
        return newTicks;
    }
    $4ffe47e38c59be9a$var$skip(ticks, newTicks, spacing);
    return newTicks;
}
function $4ffe47e38c59be9a$var$determineMaxTicks(scale) {
    const offset = scale.options.offset;
    const tickLength = scale._tickSize();
    const maxScale = scale._length / tickLength + (offset ? 0 : 1);
    const maxChart = scale._maxLength / tickLength;
    return Math.floor(Math.min(maxScale, maxChart));
}
function $4ffe47e38c59be9a$var$calculateSpacing(majorIndices, ticks, ticksLimit) {
    const evenMajorSpacing = $4ffe47e38c59be9a$var$getEvenSpacing(majorIndices);
    const spacing = ticks.length / ticksLimit;
    if (!evenMajorSpacing) return Math.max(spacing, 1);
    const factors = (0, $breCz.J)(evenMajorSpacing);
    for(let i = 0, ilen = factors.length - 1; i < ilen; i++){
        const factor = factors[i];
        if (factor > spacing) return factor;
    }
    return Math.max(spacing, 1);
}
function $4ffe47e38c59be9a$var$getMajorIndices(ticks) {
    const result = [];
    let i, ilen;
    for(i = 0, ilen = ticks.length; i < ilen; i++)if (ticks[i].major) result.push(i);
    return result;
}
function $4ffe47e38c59be9a$var$skipMajors(ticks, newTicks, majorIndices, spacing) {
    let count = 0;
    let next = majorIndices[0];
    let i;
    spacing = Math.ceil(spacing);
    for(i = 0; i < ticks.length; i++)if (i === next) {
        newTicks.push(ticks[i]);
        count++;
        next = majorIndices[count * spacing];
    }
}
function $4ffe47e38c59be9a$var$skip(ticks, newTicks, spacing, majorStart, majorEnd) {
    const start = (0, $breCz.v)(majorStart, 0);
    const end = Math.min((0, $breCz.v)(majorEnd, ticks.length), ticks.length);
    let count = 0;
    let length, i, next;
    spacing = Math.ceil(spacing);
    if (majorEnd) {
        length = majorEnd - majorStart;
        spacing = length / Math.floor(length / spacing);
    }
    next = start;
    while(next < 0){
        count++;
        next = Math.round(start + count * spacing);
    }
    for(i = Math.max(start, 0); i < end; i++)if (i === next) {
        newTicks.push(ticks[i]);
        count++;
        next = Math.round(start + count * spacing);
    }
}
function $4ffe47e38c59be9a$var$getEvenSpacing(arr) {
    const len = arr.length;
    let i, diff;
    if (len < 2) return false;
    for(diff = arr[0], i = 1; i < len; ++i){
        if (arr[i] - arr[i - 1] !== diff) return false;
    }
    return diff;
}
const $4ffe47e38c59be9a$var$reverseAlign = (align)=>align === "left" ? "right" : align === "right" ? "left" : align;
const $4ffe47e38c59be9a$var$offsetFromEdge = (scale, edge, offset)=>edge === "top" || edge === "left" ? scale[edge] + offset : scale[edge] - offset;
function $4ffe47e38c59be9a$var$sample(arr, numItems) {
    const result = [];
    const increment = arr.length / numItems;
    const len = arr.length;
    let i = 0;
    for(; i < len; i += increment)result.push(arr[Math.floor(i)]);
    return result;
}
function $4ffe47e38c59be9a$var$getPixelForGridLine(scale, index, offsetGridLines) {
    const length = scale.ticks.length;
    const validIndex = Math.min(index, length - 1);
    const start = scale._startPixel;
    const end = scale._endPixel;
    const epsilon = 1e-6;
    let lineValue = scale.getPixelForTick(validIndex);
    let offset;
    if (offsetGridLines) {
        if (length === 1) offset = Math.max(lineValue - start, end - lineValue);
        else if (index === 0) offset = (scale.getPixelForTick(1) - lineValue) / 2;
        else offset = (lineValue - scale.getPixelForTick(validIndex - 1)) / 2;
        lineValue += validIndex < index ? offset : -offset;
        if (lineValue < start - epsilon || lineValue > end + epsilon) return;
    }
    return lineValue;
}
function $4ffe47e38c59be9a$var$garbageCollect(caches, length) {
    (0, $breCz.B)(caches, (cache)=>{
        const gc = cache.gc;
        const gcLen = gc.length / 2;
        let i;
        if (gcLen > length) {
            for(i = 0; i < gcLen; ++i)delete cache.data[gc[i]];
            gc.splice(0, gcLen);
        }
    });
}
function $4ffe47e38c59be9a$var$getTickMarkLength(options) {
    return options.drawTicks ? options.tickLength : 0;
}
function $4ffe47e38c59be9a$var$getTitleHeight(options, fallback) {
    if (!options.display) return 0;
    const font = (0, $breCz.W)(options.font, fallback);
    const padding = (0, $breCz.A)(options.padding);
    const lines = (0, $breCz.b)(options.text) ? options.text.length : 1;
    return lines * font.lineHeight + padding.height;
}
function $4ffe47e38c59be9a$var$createScaleContext(parent, scale) {
    return Object.assign(Object.create(parent), {
        scale: scale,
        type: "scale"
    });
}
function $4ffe47e38c59be9a$var$createTickContext(parent, index, tick) {
    return Object.assign(Object.create(parent), {
        tick: tick,
        index: index,
        type: "tick"
    });
}
function $4ffe47e38c59be9a$var$titleAlign(align, position, reverse) {
    let ret = (0, $breCz.X)(align);
    if (reverse && position !== "right" || !reverse && position === "right") ret = $4ffe47e38c59be9a$var$reverseAlign(ret);
    return ret;
}
function $4ffe47e38c59be9a$var$titleArgs(scale, offset, position, align) {
    const { top: top, left: left, bottom: bottom, right: right } = scale;
    let rotation = 0;
    let maxWidth, titleX, titleY;
    if (scale.isHorizontal()) {
        titleX = (0, $breCz.Y)(align, left, right);
        titleY = $4ffe47e38c59be9a$var$offsetFromEdge(scale, position, offset);
        maxWidth = right - left;
    } else {
        titleX = $4ffe47e38c59be9a$var$offsetFromEdge(scale, position, offset);
        titleY = (0, $breCz.Y)(align, bottom, top);
        rotation = position === "left" ? -(0, $breCz.H) : (0, $breCz.H);
    }
    return {
        titleX: titleX,
        titleY: titleY,
        maxWidth: maxWidth,
        rotation: rotation
    };
}
class $4ffe47e38c59be9a$export$d60cfc58d3c358b6 extends $4ffe47e38c59be9a$export$db77ccec0bb4ccac {
    constructor(cfg){
        super();
        this.id = cfg.id;
        this.type = cfg.type;
        this.options = undefined;
        this.ctx = cfg.ctx;
        this.chart = cfg.chart;
        this.top = undefined;
        this.bottom = undefined;
        this.left = undefined;
        this.right = undefined;
        this.width = undefined;
        this.height = undefined;
        this._margins = {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
        };
        this.maxWidth = undefined;
        this.maxHeight = undefined;
        this.paddingTop = undefined;
        this.paddingBottom = undefined;
        this.paddingLeft = undefined;
        this.paddingRight = undefined;
        this.axis = undefined;
        this.labelRotation = undefined;
        this.min = undefined;
        this.max = undefined;
        this._range = undefined;
        this.ticks = [];
        this._gridLineItems = null;
        this._labelItems = null;
        this._labelSizes = null;
        this._length = 0;
        this._maxLength = 0;
        this._longestTextCache = {};
        this._startPixel = undefined;
        this._endPixel = undefined;
        this._reversePixels = false;
        this._userMax = undefined;
        this._userMin = undefined;
        this._suggestedMax = undefined;
        this._suggestedMin = undefined;
        this._ticksLength = 0;
        this._borderValue = 0;
        this._cache = {};
        this._dataLimitsCached = false;
        this.$context = undefined;
    }
    init(options) {
        const me = this;
        me.options = options.setContext(me.getContext());
        me.axis = options.axis;
        me._userMin = me.parse(options.min);
        me._userMax = me.parse(options.max);
        me._suggestedMin = me.parse(options.suggestedMin);
        me._suggestedMax = me.parse(options.suggestedMax);
    }
    parse(raw, index) {
        return raw;
    }
    getUserBounds() {
        let { _userMin: _userMin, _userMax: _userMax, _suggestedMin: _suggestedMin, _suggestedMax: _suggestedMax } = this;
        _userMin = (0, $breCz.K)(_userMin, Number.POSITIVE_INFINITY);
        _userMax = (0, $breCz.K)(_userMax, Number.NEGATIVE_INFINITY);
        _suggestedMin = (0, $breCz.K)(_suggestedMin, Number.POSITIVE_INFINITY);
        _suggestedMax = (0, $breCz.K)(_suggestedMax, Number.NEGATIVE_INFINITY);
        return {
            min: (0, $breCz.K)(_userMin, _suggestedMin),
            max: (0, $breCz.K)(_userMax, _suggestedMax),
            minDefined: (0, $breCz.g)(_userMin),
            maxDefined: (0, $breCz.g)(_userMax)
        };
    }
    getMinMax(canStack) {
        const me = this;
        let { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = me.getUserBounds();
        let range;
        if (minDefined && maxDefined) return {
            min: min,
            max: max
        };
        const metas = me.getMatchingVisibleMetas();
        for(let i = 0, ilen = metas.length; i < ilen; ++i){
            range = metas[i].controller.getMinMax(me, canStack);
            if (!minDefined) min = Math.min(min, range.min);
            if (!maxDefined) max = Math.max(max, range.max);
        }
        return {
            min: (0, $breCz.K)(min, (0, $breCz.K)(max, min)),
            max: (0, $breCz.K)(max, (0, $breCz.K)(min, max))
        };
    }
    getPadding() {
        const me = this;
        return {
            left: me.paddingLeft || 0,
            top: me.paddingTop || 0,
            right: me.paddingRight || 0,
            bottom: me.paddingBottom || 0
        };
    }
    getTicks() {
        return this.ticks;
    }
    getLabels() {
        const data = this.chart.data;
        return this.options.labels || (this.isHorizontal() ? data.xLabels : data.yLabels) || data.labels || [];
    }
    beforeLayout() {
        this._cache = {};
        this._dataLimitsCached = false;
    }
    beforeUpdate() {
        (0, $breCz.L)(this.options.beforeUpdate, [
            this
        ]);
    }
    update(maxWidth, maxHeight, margins) {
        const me = this;
        const tickOpts = me.options.ticks;
        const sampleSize = tickOpts.sampleSize;
        me.beforeUpdate();
        me.maxWidth = maxWidth;
        me.maxHeight = maxHeight;
        me._margins = margins = Object.assign({
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
        }, margins);
        me.ticks = null;
        me._labelSizes = null;
        me._gridLineItems = null;
        me._labelItems = null;
        me.beforeSetDimensions();
        me.setDimensions();
        me.afterSetDimensions();
        me._maxLength = me.isHorizontal() ? me.width + margins.left + margins.right : me.height + margins.top + margins.bottom;
        if (!me._dataLimitsCached) {
            me.beforeDataLimits();
            me.determineDataLimits();
            me.afterDataLimits();
            me._range = (0, $breCz.M)(me, me.options.grace);
            me._dataLimitsCached = true;
        }
        me.beforeBuildTicks();
        me.ticks = me.buildTicks() || [];
        me.afterBuildTicks();
        const samplingEnabled = sampleSize < me.ticks.length;
        me._convertTicksToLabels(samplingEnabled ? $4ffe47e38c59be9a$var$sample(me.ticks, sampleSize) : me.ticks);
        me.configure();
        me.beforeCalculateLabelRotation();
        me.calculateLabelRotation();
        me.afterCalculateLabelRotation();
        if (tickOpts.display && (tickOpts.autoSkip || tickOpts.source === "auto")) {
            me.ticks = $4ffe47e38c59be9a$var$autoSkip(me, me.ticks);
            me._labelSizes = null;
        }
        if (samplingEnabled) me._convertTicksToLabels(me.ticks);
        me.beforeFit();
        me.fit();
        me.afterFit();
        me.afterUpdate();
    }
    configure() {
        const me = this;
        let reversePixels = me.options.reverse;
        let startPixel, endPixel;
        if (me.isHorizontal()) {
            startPixel = me.left;
            endPixel = me.right;
        } else {
            startPixel = me.top;
            endPixel = me.bottom;
            reversePixels = !reversePixels;
        }
        me._startPixel = startPixel;
        me._endPixel = endPixel;
        me._reversePixels = reversePixels;
        me._length = endPixel - startPixel;
        me._alignToPixels = me.options.alignToPixels;
    }
    afterUpdate() {
        (0, $breCz.L)(this.options.afterUpdate, [
            this
        ]);
    }
    beforeSetDimensions() {
        (0, $breCz.L)(this.options.beforeSetDimensions, [
            this
        ]);
    }
    setDimensions() {
        const me = this;
        if (me.isHorizontal()) {
            me.width = me.maxWidth;
            me.left = 0;
            me.right = me.width;
        } else {
            me.height = me.maxHeight;
            me.top = 0;
            me.bottom = me.height;
        }
        me.paddingLeft = 0;
        me.paddingTop = 0;
        me.paddingRight = 0;
        me.paddingBottom = 0;
    }
    afterSetDimensions() {
        (0, $breCz.L)(this.options.afterSetDimensions, [
            this
        ]);
    }
    _callHooks(name) {
        const me = this;
        me.chart.notifyPlugins(name, me.getContext());
        (0, $breCz.L)(me.options[name], [
            me
        ]);
    }
    beforeDataLimits() {
        this._callHooks("beforeDataLimits");
    }
    determineDataLimits() {}
    afterDataLimits() {
        this._callHooks("afterDataLimits");
    }
    beforeBuildTicks() {
        this._callHooks("beforeBuildTicks");
    }
    buildTicks() {
        return [];
    }
    afterBuildTicks() {
        this._callHooks("afterBuildTicks");
    }
    beforeTickToLabelConversion() {
        (0, $breCz.L)(this.options.beforeTickToLabelConversion, [
            this
        ]);
    }
    generateTickLabels(ticks) {
        const me = this;
        const tickOpts = me.options.ticks;
        let i, ilen, tick;
        for(i = 0, ilen = ticks.length; i < ilen; i++){
            tick = ticks[i];
            tick.label = (0, $breCz.L)(tickOpts.callback, [
                tick.value,
                i,
                ticks
            ], me);
        }
    }
    afterTickToLabelConversion() {
        (0, $breCz.L)(this.options.afterTickToLabelConversion, [
            this
        ]);
    }
    beforeCalculateLabelRotation() {
        (0, $breCz.L)(this.options.beforeCalculateLabelRotation, [
            this
        ]);
    }
    calculateLabelRotation() {
        const me = this;
        const options = me.options;
        const tickOpts = options.ticks;
        const numTicks = me.ticks.length;
        const minRotation = tickOpts.minRotation || 0;
        const maxRotation = tickOpts.maxRotation;
        let labelRotation = minRotation;
        let tickWidth, maxHeight, maxLabelDiagonal;
        if (!me._isVisible() || !tickOpts.display || minRotation >= maxRotation || numTicks <= 1 || !me.isHorizontal()) {
            me.labelRotation = minRotation;
            return;
        }
        const labelSizes = me._getLabelSizes();
        const maxLabelWidth = labelSizes.widest.width;
        const maxLabelHeight = labelSizes.highest.height;
        const maxWidth = (0, $breCz.q)(me.chart.width - maxLabelWidth, 0, me.maxWidth);
        tickWidth = options.offset ? me.maxWidth / numTicks : maxWidth / (numTicks - 1);
        if (maxLabelWidth + 6 > tickWidth) {
            tickWidth = maxWidth / (numTicks - (options.offset ? 0.5 : 1));
            maxHeight = me.maxHeight - $4ffe47e38c59be9a$var$getTickMarkLength(options.grid) - tickOpts.padding - $4ffe47e38c59be9a$var$getTitleHeight(options.title, me.chart.options.font);
            maxLabelDiagonal = Math.sqrt(maxLabelWidth * maxLabelWidth + maxLabelHeight * maxLabelHeight);
            labelRotation = (0, $breCz.N)(Math.min(Math.asin(Math.min((labelSizes.highest.height + 6) / tickWidth, 1)), Math.asin(Math.min(maxHeight / maxLabelDiagonal, 1)) - Math.asin(maxLabelHeight / maxLabelDiagonal)));
            labelRotation = Math.max(minRotation, Math.min(maxRotation, labelRotation));
        }
        me.labelRotation = labelRotation;
    }
    afterCalculateLabelRotation() {
        (0, $breCz.L)(this.options.afterCalculateLabelRotation, [
            this
        ]);
    }
    beforeFit() {
        (0, $breCz.L)(this.options.beforeFit, [
            this
        ]);
    }
    fit() {
        const me = this;
        const minSize = {
            width: 0,
            height: 0
        };
        const { chart: chart, options: { ticks: tickOpts, title: titleOpts, grid: gridOpts } } = me;
        const display = me._isVisible();
        const isHorizontal = me.isHorizontal();
        if (display) {
            const titleHeight = $4ffe47e38c59be9a$var$getTitleHeight(titleOpts, chart.options.font);
            if (isHorizontal) {
                minSize.width = me.maxWidth;
                minSize.height = $4ffe47e38c59be9a$var$getTickMarkLength(gridOpts) + titleHeight;
            } else {
                minSize.height = me.maxHeight;
                minSize.width = $4ffe47e38c59be9a$var$getTickMarkLength(gridOpts) + titleHeight;
            }
            if (tickOpts.display && me.ticks.length) {
                const { first: first, last: last, widest: widest, highest: highest } = me._getLabelSizes();
                const tickPadding = tickOpts.padding * 2;
                const angleRadians = (0, $breCz.t)(me.labelRotation);
                const cos = Math.cos(angleRadians);
                const sin = Math.sin(angleRadians);
                if (isHorizontal) {
                    const labelHeight = tickOpts.mirror ? 0 : sin * widest.width + cos * highest.height;
                    minSize.height = Math.min(me.maxHeight, minSize.height + labelHeight + tickPadding);
                } else {
                    const labelWidth = tickOpts.mirror ? 0 : cos * widest.width + sin * highest.height;
                    minSize.width = Math.min(me.maxWidth, minSize.width + labelWidth + tickPadding);
                }
                me._calculatePadding(first, last, sin, cos);
            }
        }
        me._handleMargins();
        if (isHorizontal) {
            me.width = me._length = chart.width - me._margins.left - me._margins.right;
            me.height = minSize.height;
        } else {
            me.width = minSize.width;
            me.height = me._length = chart.height - me._margins.top - me._margins.bottom;
        }
    }
    _calculatePadding(first, last, sin, cos) {
        const me = this;
        const { ticks: { align: align, padding: padding }, position: position } = me.options;
        const isRotated = me.labelRotation !== 0;
        const labelsBelowTicks = position !== "top" && me.axis === "x";
        if (me.isHorizontal()) {
            const offsetLeft = me.getPixelForTick(0) - me.left;
            const offsetRight = me.right - me.getPixelForTick(me.ticks.length - 1);
            let paddingLeft = 0;
            let paddingRight = 0;
            if (isRotated) {
                if (labelsBelowTicks) {
                    paddingLeft = cos * first.width;
                    paddingRight = sin * last.height;
                } else {
                    paddingLeft = sin * first.height;
                    paddingRight = cos * last.width;
                }
            } else if (align === "start") paddingRight = last.width;
            else if (align === "end") paddingLeft = first.width;
            else {
                paddingLeft = first.width / 2;
                paddingRight = last.width / 2;
            }
            me.paddingLeft = Math.max((paddingLeft - offsetLeft + padding) * me.width / (me.width - offsetLeft), 0);
            me.paddingRight = Math.max((paddingRight - offsetRight + padding) * me.width / (me.width - offsetRight), 0);
        } else {
            let paddingTop = last.height / 2;
            let paddingBottom = first.height / 2;
            if (align === "start") {
                paddingTop = 0;
                paddingBottom = first.height;
            } else if (align === "end") {
                paddingTop = last.height;
                paddingBottom = 0;
            }
            me.paddingTop = paddingTop + padding;
            me.paddingBottom = paddingBottom + padding;
        }
    }
    _handleMargins() {
        const me = this;
        if (me._margins) {
            me._margins.left = Math.max(me.paddingLeft, me._margins.left);
            me._margins.top = Math.max(me.paddingTop, me._margins.top);
            me._margins.right = Math.max(me.paddingRight, me._margins.right);
            me._margins.bottom = Math.max(me.paddingBottom, me._margins.bottom);
        }
    }
    afterFit() {
        (0, $breCz.L)(this.options.afterFit, [
            this
        ]);
    }
    isHorizontal() {
        const { axis: axis, position: position } = this.options;
        return position === "top" || position === "bottom" || axis === "x";
    }
    isFullSize() {
        return this.options.fullSize;
    }
    _convertTicksToLabels(ticks) {
        const me = this;
        me.beforeTickToLabelConversion();
        me.generateTickLabels(ticks);
        let i, ilen;
        for(i = 0, ilen = ticks.length; i < ilen; i++)if ((0, $breCz.j)(ticks[i].label)) {
            ticks.splice(i, 1);
            ilen--;
            i--;
        }
        me.afterTickToLabelConversion();
    }
    _getLabelSizes() {
        const me = this;
        let labelSizes = me._labelSizes;
        if (!labelSizes) {
            const sampleSize = me.options.ticks.sampleSize;
            let ticks = me.ticks;
            if (sampleSize < ticks.length) ticks = $4ffe47e38c59be9a$var$sample(ticks, sampleSize);
            me._labelSizes = labelSizes = me._computeLabelSizes(ticks, ticks.length);
        }
        return labelSizes;
    }
    _computeLabelSizes(ticks, length) {
        const { ctx: ctx, _longestTextCache: caches } = this;
        const widths = [];
        const heights = [];
        let widestLabelSize = 0;
        let highestLabelSize = 0;
        let i, j, jlen, label, tickFont, fontString, cache, lineHeight, width, height, nestedLabel;
        for(i = 0; i < length; ++i){
            label = ticks[i].label;
            tickFont = this._resolveTickFontOptions(i);
            ctx.font = fontString = tickFont.string;
            cache = caches[fontString] = caches[fontString] || {
                data: {},
                gc: []
            };
            lineHeight = tickFont.lineHeight;
            width = height = 0;
            if (!(0, $breCz.j)(label) && !(0, $breCz.b)(label)) {
                width = (0, $breCz.O)(ctx, cache.data, cache.gc, width, label);
                height = lineHeight;
            } else if ((0, $breCz.b)(label)) for(j = 0, jlen = label.length; j < jlen; ++j){
                nestedLabel = label[j];
                if (!(0, $breCz.j)(nestedLabel) && !(0, $breCz.b)(nestedLabel)) {
                    width = (0, $breCz.O)(ctx, cache.data, cache.gc, width, nestedLabel);
                    height += lineHeight;
                }
            }
            widths.push(width);
            heights.push(height);
            widestLabelSize = Math.max(width, widestLabelSize);
            highestLabelSize = Math.max(height, highestLabelSize);
        }
        $4ffe47e38c59be9a$var$garbageCollect(caches, length);
        const widest = widths.indexOf(widestLabelSize);
        const highest = heights.indexOf(highestLabelSize);
        const valueAt = (idx)=>({
                width: widths[idx] || 0,
                height: heights[idx] || 0
            });
        return {
            first: valueAt(0),
            last: valueAt(length - 1),
            widest: valueAt(widest),
            highest: valueAt(highest),
            widths: widths,
            heights: heights
        };
    }
    getLabelForValue(value) {
        return value;
    }
    getPixelForValue(value, index) {
        return NaN;
    }
    getValueForPixel(pixel) {}
    getPixelForTick(index) {
        const ticks = this.ticks;
        if (index < 0 || index > ticks.length - 1) return null;
        return this.getPixelForValue(ticks[index].value);
    }
    getPixelForDecimal(decimal) {
        const me = this;
        if (me._reversePixels) decimal = 1 - decimal;
        const pixel = me._startPixel + decimal * me._length;
        return (0, $breCz.Q)(me._alignToPixels ? (0, $breCz.R)(me.chart, pixel, 0) : pixel);
    }
    getDecimalForPixel(pixel) {
        const decimal = (pixel - this._startPixel) / this._length;
        return this._reversePixels ? 1 - decimal : decimal;
    }
    getBasePixel() {
        return this.getPixelForValue(this.getBaseValue());
    }
    getBaseValue() {
        const { min: min, max: max } = this;
        return min < 0 && max < 0 ? max : min > 0 && max > 0 ? min : 0;
    }
    getContext(index) {
        const me = this;
        const ticks = me.ticks || [];
        if (index >= 0 && index < ticks.length) {
            const tick = ticks[index];
            return tick.$context || (tick.$context = $4ffe47e38c59be9a$var$createTickContext(me.getContext(), index, tick));
        }
        return me.$context || (me.$context = $4ffe47e38c59be9a$var$createScaleContext(me.chart.getContext(), me));
    }
    _tickSize() {
        const me = this;
        const optionTicks = me.options.ticks;
        const rot = (0, $breCz.t)(me.labelRotation);
        const cos = Math.abs(Math.cos(rot));
        const sin = Math.abs(Math.sin(rot));
        const labelSizes = me._getLabelSizes();
        const padding = optionTicks.autoSkipPadding || 0;
        const w = labelSizes ? labelSizes.widest.width + padding : 0;
        const h = labelSizes ? labelSizes.highest.height + padding : 0;
        return me.isHorizontal() ? h * cos > w * sin ? w / cos : h / sin : h * sin < w * cos ? h / cos : w / sin;
    }
    _isVisible() {
        const display = this.options.display;
        if (display !== "auto") return !!display;
        return this.getMatchingVisibleMetas().length > 0;
    }
    _computeGridLineItems(chartArea) {
        const me = this;
        const axis = me.axis;
        const chart = me.chart;
        const options = me.options;
        const { grid: grid, position: position } = options;
        const offset = grid.offset;
        const isHorizontal = me.isHorizontal();
        const ticks = me.ticks;
        const ticksLength = ticks.length + (offset ? 1 : 0);
        const tl = $4ffe47e38c59be9a$var$getTickMarkLength(grid);
        const items = [];
        const borderOpts = grid.setContext(me.getContext());
        const axisWidth = borderOpts.drawBorder ? borderOpts.borderWidth : 0;
        const axisHalfWidth = axisWidth / 2;
        const alignBorderValue = function(pixel) {
            return (0, $breCz.R)(chart, pixel, axisWidth);
        };
        let borderValue, i, lineValue, alignedLineValue;
        let tx1, ty1, tx2, ty2, x1, y1, x2, y2;
        if (position === "top") {
            borderValue = alignBorderValue(me.bottom);
            ty1 = me.bottom - tl;
            ty2 = borderValue - axisHalfWidth;
            y1 = alignBorderValue(chartArea.top) + axisHalfWidth;
            y2 = chartArea.bottom;
        } else if (position === "bottom") {
            borderValue = alignBorderValue(me.top);
            y1 = chartArea.top;
            y2 = alignBorderValue(chartArea.bottom) - axisHalfWidth;
            ty1 = borderValue + axisHalfWidth;
            ty2 = me.top + tl;
        } else if (position === "left") {
            borderValue = alignBorderValue(me.right);
            tx1 = me.right - tl;
            tx2 = borderValue - axisHalfWidth;
            x1 = alignBorderValue(chartArea.left) + axisHalfWidth;
            x2 = chartArea.right;
        } else if (position === "right") {
            borderValue = alignBorderValue(me.left);
            x1 = chartArea.left;
            x2 = alignBorderValue(chartArea.right) - axisHalfWidth;
            tx1 = borderValue + axisHalfWidth;
            tx2 = me.left + tl;
        } else if (axis === "x") {
            if (position === "center") borderValue = alignBorderValue((chartArea.top + chartArea.bottom) / 2 + 0.5);
            else if ((0, $breCz.i)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                borderValue = alignBorderValue(me.chart.scales[positionAxisID].getPixelForValue(value));
            }
            y1 = chartArea.top;
            y2 = chartArea.bottom;
            ty1 = borderValue + axisHalfWidth;
            ty2 = ty1 + tl;
        } else if (axis === "y") {
            if (position === "center") borderValue = alignBorderValue((chartArea.left + chartArea.right) / 2);
            else if ((0, $breCz.i)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                borderValue = alignBorderValue(me.chart.scales[positionAxisID].getPixelForValue(value));
            }
            tx1 = borderValue - axisHalfWidth;
            tx2 = tx1 - tl;
            x1 = chartArea.left;
            x2 = chartArea.right;
        }
        const limit = (0, $breCz.v)(options.ticks.maxTicksLimit, ticksLength);
        const step = Math.max(1, Math.ceil(ticksLength / limit));
        for(i = 0; i < ticksLength; i += step){
            const optsAtIndex = grid.setContext(me.getContext(i));
            const lineWidth = optsAtIndex.lineWidth;
            const lineColor = optsAtIndex.color;
            const borderDash = grid.borderDash || [];
            const borderDashOffset = optsAtIndex.borderDashOffset;
            const tickWidth = optsAtIndex.tickWidth;
            const tickColor = optsAtIndex.tickColor;
            const tickBorderDash = optsAtIndex.tickBorderDash || [];
            const tickBorderDashOffset = optsAtIndex.tickBorderDashOffset;
            lineValue = $4ffe47e38c59be9a$var$getPixelForGridLine(me, i, offset);
            if (lineValue === undefined) continue;
            alignedLineValue = (0, $breCz.R)(chart, lineValue, lineWidth);
            if (isHorizontal) tx1 = tx2 = x1 = x2 = alignedLineValue;
            else ty1 = ty2 = y1 = y2 = alignedLineValue;
            items.push({
                tx1: tx1,
                ty1: ty1,
                tx2: tx2,
                ty2: ty2,
                x1: x1,
                y1: y1,
                x2: x2,
                y2: y2,
                width: lineWidth,
                color: lineColor,
                borderDash: borderDash,
                borderDashOffset: borderDashOffset,
                tickWidth: tickWidth,
                tickColor: tickColor,
                tickBorderDash: tickBorderDash,
                tickBorderDashOffset: tickBorderDashOffset
            });
        }
        me._ticksLength = ticksLength;
        me._borderValue = borderValue;
        return items;
    }
    _computeLabelItems(chartArea) {
        const me = this;
        const axis = me.axis;
        const options = me.options;
        const { position: position, ticks: optionTicks } = options;
        const isHorizontal = me.isHorizontal();
        const ticks = me.ticks;
        const { align: align, crossAlign: crossAlign, padding: padding, mirror: mirror } = optionTicks;
        const tl = $4ffe47e38c59be9a$var$getTickMarkLength(options.grid);
        const tickAndPadding = tl + padding;
        const hTickAndPadding = mirror ? -padding : tickAndPadding;
        const rotation = -(0, $breCz.t)(me.labelRotation);
        const items = [];
        let i, ilen, tick, label, x, y, textAlign, pixel, font, lineHeight, lineCount, textOffset;
        let textBaseline = "middle";
        if (position === "top") {
            y = me.bottom - hTickAndPadding;
            textAlign = me._getXAxisLabelAlignment();
        } else if (position === "bottom") {
            y = me.top + hTickAndPadding;
            textAlign = me._getXAxisLabelAlignment();
        } else if (position === "left") {
            const ret = me._getYAxisLabelAlignment(tl);
            textAlign = ret.textAlign;
            x = ret.x;
        } else if (position === "right") {
            const ret = me._getYAxisLabelAlignment(tl);
            textAlign = ret.textAlign;
            x = ret.x;
        } else if (axis === "x") {
            if (position === "center") y = (chartArea.top + chartArea.bottom) / 2 + tickAndPadding;
            else if ((0, $breCz.i)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                y = me.chart.scales[positionAxisID].getPixelForValue(value) + tickAndPadding;
            }
            textAlign = me._getXAxisLabelAlignment();
        } else if (axis === "y") {
            if (position === "center") x = (chartArea.left + chartArea.right) / 2 - tickAndPadding;
            else if ((0, $breCz.i)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                x = me.chart.scales[positionAxisID].getPixelForValue(value);
            }
            textAlign = me._getYAxisLabelAlignment(tl).textAlign;
        }
        if (axis === "y") {
            if (align === "start") textBaseline = "top";
            else if (align === "end") textBaseline = "bottom";
        }
        const labelSizes = me._getLabelSizes();
        for(i = 0, ilen = ticks.length; i < ilen; ++i){
            tick = ticks[i];
            label = tick.label;
            const optsAtIndex = optionTicks.setContext(me.getContext(i));
            pixel = me.getPixelForTick(i) + optionTicks.labelOffset;
            font = me._resolveTickFontOptions(i);
            lineHeight = font.lineHeight;
            lineCount = (0, $breCz.b)(label) ? label.length : 1;
            const halfCount = lineCount / 2;
            const color = optsAtIndex.color;
            const strokeColor = optsAtIndex.textStrokeColor;
            const strokeWidth = optsAtIndex.textStrokeWidth;
            if (isHorizontal) {
                x = pixel;
                if (position === "top") {
                    if (crossAlign === "near" || rotation !== 0) textOffset = -lineCount * lineHeight + lineHeight / 2;
                    else if (crossAlign === "center") textOffset = -labelSizes.highest.height / 2 - halfCount * lineHeight + lineHeight;
                    else textOffset = -labelSizes.highest.height + lineHeight / 2;
                } else {
                    if (crossAlign === "near" || rotation !== 0) textOffset = lineHeight / 2;
                    else if (crossAlign === "center") textOffset = labelSizes.highest.height / 2 - halfCount * lineHeight;
                    else textOffset = labelSizes.highest.height - lineCount * lineHeight;
                }
                if (mirror) textOffset *= -1;
            } else {
                y = pixel;
                textOffset = (1 - lineCount) * lineHeight / 2;
            }
            let backdrop;
            if (optsAtIndex.showLabelBackdrop) {
                const labelPadding = (0, $breCz.A)(optsAtIndex.backdropPadding);
                const height = labelSizes.heights[i];
                const width = labelSizes.widths[i];
                let top = y + textOffset - labelPadding.top;
                let left = x - labelPadding.left;
                switch(textBaseline){
                    case "middle":
                        top -= height / 2;
                        break;
                    case "bottom":
                        top -= height;
                        break;
                }
                switch(textAlign){
                    case "center":
                        left -= width / 2;
                        break;
                    case "right":
                        left -= width;
                        break;
                }
                backdrop = {
                    left: left,
                    top: top,
                    width: width + labelPadding.width,
                    height: height + labelPadding.height,
                    color: optsAtIndex.backdropColor
                };
            }
            items.push({
                rotation: rotation,
                label: label,
                font: font,
                color: color,
                strokeColor: strokeColor,
                strokeWidth: strokeWidth,
                textOffset: textOffset,
                textAlign: textAlign,
                textBaseline: textBaseline,
                translation: [
                    x,
                    y
                ],
                backdrop: backdrop
            });
        }
        return items;
    }
    _getXAxisLabelAlignment() {
        const me = this;
        const { position: position, ticks: ticks } = me.options;
        const rotation = -(0, $breCz.t)(me.labelRotation);
        if (rotation) return position === "top" ? "left" : "right";
        let align = "center";
        if (ticks.align === "start") align = "left";
        else if (ticks.align === "end") align = "right";
        return align;
    }
    _getYAxisLabelAlignment(tl) {
        const me = this;
        const { position: position, ticks: { crossAlign: crossAlign, mirror: mirror, padding: padding } } = me.options;
        const labelSizes = me._getLabelSizes();
        const tickAndPadding = tl + padding;
        const widest = labelSizes.widest.width;
        let textAlign;
        let x;
        if (position === "left") {
            if (mirror) {
                textAlign = "left";
                x = me.right + padding;
            } else {
                x = me.right - tickAndPadding;
                if (crossAlign === "near") textAlign = "right";
                else if (crossAlign === "center") {
                    textAlign = "center";
                    x -= widest / 2;
                } else {
                    textAlign = "left";
                    x = me.left;
                }
            }
        } else if (position === "right") {
            if (mirror) {
                textAlign = "right";
                x = me.left + padding;
            } else {
                x = me.left + tickAndPadding;
                if (crossAlign === "near") textAlign = "left";
                else if (crossAlign === "center") {
                    textAlign = "center";
                    x += widest / 2;
                } else {
                    textAlign = "right";
                    x = me.right;
                }
            }
        } else textAlign = "right";
        return {
            textAlign: textAlign,
            x: x
        };
    }
    _computeLabelArea() {
        const me = this;
        if (me.options.ticks.mirror) return;
        const chart = me.chart;
        const position = me.options.position;
        if (position === "left" || position === "right") return {
            top: 0,
            left: me.left,
            bottom: chart.height,
            right: me.right
        };
        if (position === "top" || position === "bottom") return {
            top: me.top,
            left: 0,
            bottom: me.bottom,
            right: chart.width
        };
    }
    drawBackground() {
        const { ctx: ctx, options: { backgroundColor: backgroundColor }, left: left, top: top, width: width, height: height } = this;
        if (backgroundColor) {
            ctx.save();
            ctx.fillStyle = backgroundColor;
            ctx.fillRect(left, top, width, height);
            ctx.restore();
        }
    }
    getLineWidthForValue(value) {
        const me = this;
        const grid = me.options.grid;
        if (!me._isVisible() || !grid.display) return 0;
        const ticks = me.ticks;
        const index = ticks.findIndex((t)=>t.value === value);
        if (index >= 0) {
            const opts = grid.setContext(me.getContext(index));
            return opts.lineWidth;
        }
        return 0;
    }
    drawGrid(chartArea) {
        const me = this;
        const grid = me.options.grid;
        const ctx = me.ctx;
        const items = me._gridLineItems || (me._gridLineItems = me._computeGridLineItems(chartArea));
        let i, ilen;
        const drawLine = (p1, p2, style)=>{
            if (!style.width || !style.color) return;
            ctx.save();
            ctx.lineWidth = style.width;
            ctx.strokeStyle = style.color;
            ctx.setLineDash(style.borderDash || []);
            ctx.lineDashOffset = style.borderDashOffset;
            ctx.beginPath();
            ctx.moveTo(p1.x, p1.y);
            ctx.lineTo(p2.x, p2.y);
            ctx.stroke();
            ctx.restore();
        };
        if (grid.display) for(i = 0, ilen = items.length; i < ilen; ++i){
            const item = items[i];
            if (grid.drawOnChartArea) drawLine({
                x: item.x1,
                y: item.y1
            }, {
                x: item.x2,
                y: item.y2
            }, item);
            if (grid.drawTicks) drawLine({
                x: item.tx1,
                y: item.ty1
            }, {
                x: item.tx2,
                y: item.ty2
            }, {
                color: item.tickColor,
                width: item.tickWidth,
                borderDash: item.tickBorderDash,
                borderDashOffset: item.tickBorderDashOffset
            });
        }
    }
    drawBorder() {
        const me = this;
        const { chart: chart, ctx: ctx, options: { grid: grid } } = me;
        const borderOpts = grid.setContext(me.getContext());
        const axisWidth = grid.drawBorder ? borderOpts.borderWidth : 0;
        if (!axisWidth) return;
        const lastLineWidth = grid.setContext(me.getContext(0)).lineWidth;
        const borderValue = me._borderValue;
        let x1, x2, y1, y2;
        if (me.isHorizontal()) {
            x1 = (0, $breCz.R)(chart, me.left, axisWidth) - axisWidth / 2;
            x2 = (0, $breCz.R)(chart, me.right, lastLineWidth) + lastLineWidth / 2;
            y1 = y2 = borderValue;
        } else {
            y1 = (0, $breCz.R)(chart, me.top, axisWidth) - axisWidth / 2;
            y2 = (0, $breCz.R)(chart, me.bottom, lastLineWidth) + lastLineWidth / 2;
            x1 = x2 = borderValue;
        }
        ctx.save();
        ctx.lineWidth = borderOpts.borderWidth;
        ctx.strokeStyle = borderOpts.borderColor;
        ctx.beginPath();
        ctx.moveTo(x1, y1);
        ctx.lineTo(x2, y2);
        ctx.stroke();
        ctx.restore();
    }
    drawLabels(chartArea) {
        const me = this;
        const optionTicks = me.options.ticks;
        if (!optionTicks.display) return;
        const ctx = me.ctx;
        const area = me._computeLabelArea();
        if (area) (0, $breCz.S)(ctx, area);
        const items = me._labelItems || (me._labelItems = me._computeLabelItems(chartArea));
        let i, ilen;
        for(i = 0, ilen = items.length; i < ilen; ++i){
            const item = items[i];
            const tickFont = item.font;
            const label = item.label;
            if (item.backdrop) {
                ctx.fillStyle = item.backdrop.color;
                ctx.fillRect(item.backdrop.left, item.backdrop.top, item.backdrop.width, item.backdrop.height);
            }
            let y = item.textOffset;
            (0, $breCz.U)(ctx, label, 0, y, tickFont, item);
        }
        if (area) (0, $breCz.V)(ctx);
    }
    drawTitle() {
        const { ctx: ctx, options: { position: position, title: title, reverse: reverse } } = this;
        if (!title.display) return;
        const font = (0, $breCz.W)(title.font);
        const padding = (0, $breCz.A)(title.padding);
        const align = title.align;
        let offset = font.lineHeight / 2;
        if (position === "bottom") {
            offset += padding.bottom;
            if ((0, $breCz.b)(title.text)) offset += font.lineHeight * (title.text.length - 1);
        } else offset += padding.top;
        const { titleX: titleX, titleY: titleY, maxWidth: maxWidth, rotation: rotation } = $4ffe47e38c59be9a$var$titleArgs(this, offset, position, align);
        (0, $breCz.U)(ctx, title.text, 0, 0, font, {
            color: title.color,
            maxWidth: maxWidth,
            rotation: rotation,
            textAlign: $4ffe47e38c59be9a$var$titleAlign(align, position, reverse),
            textBaseline: "middle",
            translation: [
                titleX,
                titleY
            ]
        });
    }
    draw(chartArea) {
        const me = this;
        if (!me._isVisible()) return;
        me.drawBackground();
        me.drawGrid(chartArea);
        me.drawBorder();
        me.drawTitle();
        me.drawLabels(chartArea);
    }
    _layers() {
        const me = this;
        const opts = me.options;
        const tz = opts.ticks && opts.ticks.z || 0;
        const gz = opts.grid && opts.grid.z || 0;
        if (!me._isVisible() || me.draw !== $4ffe47e38c59be9a$export$d60cfc58d3c358b6.prototype.draw) return [
            {
                z: tz,
                draw (chartArea) {
                    me.draw(chartArea);
                }
            }
        ];
        return [
            {
                z: gz,
                draw (chartArea) {
                    me.drawBackground();
                    me.drawGrid(chartArea);
                    me.drawTitle();
                }
            },
            {
                z: gz + 1,
                draw () {
                    me.drawBorder();
                }
            },
            {
                z: tz,
                draw (chartArea) {
                    me.drawLabels(chartArea);
                }
            }
        ];
    }
    getMatchingVisibleMetas(type) {
        const me = this;
        const metas = me.chart.getSortedVisibleDatasetMetas();
        const axisID = me.axis + "AxisID";
        const result = [];
        let i, ilen;
        for(i = 0, ilen = metas.length; i < ilen; ++i){
            const meta = metas[i];
            if (meta[axisID] === me.id && (!type || meta.type === type)) result.push(meta);
        }
        return result;
    }
    _resolveTickFontOptions(index) {
        const opts = this.options.ticks.setContext(this.getContext(index));
        return (0, $breCz.W)(opts.font);
    }
    _maxDigits() {
        const me = this;
        const fontSize = me._resolveTickFontOptions(0).lineHeight;
        return (me.isHorizontal() ? me.width : me.height) / fontSize;
    }
}
class $4ffe47e38c59be9a$var$TypedRegistry {
    constructor(type, scope, override){
        this.type = type;
        this.scope = scope;
        this.override = override;
        this.items = Object.create(null);
    }
    isForType(type) {
        return Object.prototype.isPrototypeOf.call(this.type.prototype, type.prototype);
    }
    register(item) {
        const me = this;
        const proto = Object.getPrototypeOf(item);
        let parentScope;
        if ($4ffe47e38c59be9a$var$isIChartComponent(proto)) parentScope = me.register(proto);
        const items = me.items;
        const id = item.id;
        const scope = me.scope + "." + id;
        if (!id) throw new Error("class does not have id: " + item);
        if (id in items) return scope;
        items[id] = item;
        $4ffe47e38c59be9a$var$registerDefaults(item, scope, parentScope);
        if (me.override) (0, $breCz.d).override(item.id, item.overrides);
        return scope;
    }
    get(id) {
        return this.items[id];
    }
    unregister(item) {
        const items = this.items;
        const id = item.id;
        const scope = this.scope;
        if (id in items) delete items[id];
        if (scope && id in (0, $breCz.d)[scope]) {
            delete (0, $breCz.d)[scope][id];
            if (this.override) delete (0, $breCz.Z)[id];
        }
    }
}
function $4ffe47e38c59be9a$var$registerDefaults(item, scope, parentScope) {
    const itemDefaults = (0, $breCz.$)(Object.create(null), [
        parentScope ? (0, $breCz.d).get(parentScope) : {},
        (0, $breCz.d).get(scope),
        item.defaults
    ]);
    (0, $breCz.d).set(scope, itemDefaults);
    if (item.defaultRoutes) $4ffe47e38c59be9a$var$routeDefaults(scope, item.defaultRoutes);
    if (item.descriptors) (0, $breCz.d).describe(scope, item.descriptors);
}
function $4ffe47e38c59be9a$var$routeDefaults(scope, routes) {
    Object.keys(routes).forEach((property)=>{
        const propertyParts = property.split(".");
        const sourceName = propertyParts.pop();
        const sourceScope = [
            scope
        ].concat(propertyParts).join(".");
        const parts = routes[property].split(".");
        const targetName = parts.pop();
        const targetScope = parts.join(".");
        (0, $breCz.d).route(sourceScope, sourceName, targetScope, targetName);
    });
}
function $4ffe47e38c59be9a$var$isIChartComponent(proto) {
    return "id" in proto && "defaults" in proto;
}
class $4ffe47e38c59be9a$var$Registry {
    constructor(){
        this.controllers = new $4ffe47e38c59be9a$var$TypedRegistry($4ffe47e38c59be9a$export$75572ec5c55b4048, "datasets", true);
        this.elements = new $4ffe47e38c59be9a$var$TypedRegistry($4ffe47e38c59be9a$export$db77ccec0bb4ccac, "elements");
        this.plugins = new $4ffe47e38c59be9a$var$TypedRegistry(Object, "plugins");
        this.scales = new $4ffe47e38c59be9a$var$TypedRegistry($4ffe47e38c59be9a$export$d60cfc58d3c358b6, "scales");
        this._typedRegistries = [
            this.controllers,
            this.scales,
            this.elements
        ];
    }
    add(...args) {
        this._each("register", args);
    }
    remove(...args) {
        this._each("unregister", args);
    }
    addControllers(...args) {
        this._each("register", args, this.controllers);
    }
    addElements(...args) {
        this._each("register", args, this.elements);
    }
    addPlugins(...args) {
        this._each("register", args, this.plugins);
    }
    addScales(...args) {
        this._each("register", args, this.scales);
    }
    getController(id) {
        return this._get(id, this.controllers, "controller");
    }
    getElement(id) {
        return this._get(id, this.elements, "element");
    }
    getPlugin(id) {
        return this._get(id, this.plugins, "plugin");
    }
    getScale(id) {
        return this._get(id, this.scales, "scale");
    }
    removeControllers(...args) {
        this._each("unregister", args, this.controllers);
    }
    removeElements(...args) {
        this._each("unregister", args, this.elements);
    }
    removePlugins(...args) {
        this._each("unregister", args, this.plugins);
    }
    removeScales(...args) {
        this._each("unregister", args, this.scales);
    }
    _each(method, args, typedRegistry) {
        const me = this;
        [
            ...args
        ].forEach((arg)=>{
            const reg = typedRegistry || me._getRegistryForType(arg);
            if (typedRegistry || reg.isForType(arg) || reg === me.plugins && arg.id) me._exec(method, reg, arg);
            else (0, $breCz.B)(arg, (item)=>{
                const itemReg = typedRegistry || me._getRegistryForType(item);
                me._exec(method, itemReg, item);
            });
        });
    }
    _exec(method, registry, component) {
        const camelMethod = (0, $breCz.a0)(method);
        (0, $breCz.L)(component["before" + camelMethod], [], component);
        registry[method](component);
        (0, $breCz.L)(component["after" + camelMethod], [], component);
    }
    _getRegistryForType(type) {
        for(let i = 0; i < this._typedRegistries.length; i++){
            const reg = this._typedRegistries[i];
            if (reg.isForType(type)) return reg;
        }
        return this.plugins;
    }
    _get(id, typedRegistry, type) {
        const item = typedRegistry.get(id);
        if (item === undefined) throw new Error('"' + id + '" is not a registered ' + type + ".");
        return item;
    }
}
var $4ffe47e38c59be9a$export$4bb7493d241fd8a5 = new $4ffe47e38c59be9a$var$Registry();
class $4ffe47e38c59be9a$var$PluginService {
    constructor(){
        this._init = [];
    }
    notify(chart, hook, args, filter) {
        const me = this;
        if (hook === "beforeInit") {
            me._init = me._createDescriptors(chart, true);
            me._notify(me._init, chart, "install");
        }
        const descriptors = filter ? me._descriptors(chart).filter(filter) : me._descriptors(chart);
        const result = me._notify(descriptors, chart, hook, args);
        if (hook === "destroy") {
            me._notify(descriptors, chart, "stop");
            me._notify(me._init, chart, "uninstall");
        }
        return result;
    }
    _notify(descriptors, chart, hook, args) {
        args = args || {};
        for (const descriptor of descriptors){
            const plugin = descriptor.plugin;
            const method = plugin[hook];
            const params = [
                chart,
                args,
                descriptor.options
            ];
            if ((0, $breCz.L)(method, params, plugin) === false && args.cancelable) return false;
        }
        return true;
    }
    invalidate() {
        if (!(0, $breCz.j)(this._cache)) {
            this._oldCache = this._cache;
            this._cache = undefined;
        }
    }
    _descriptors(chart) {
        if (this._cache) return this._cache;
        const descriptors = this._cache = this._createDescriptors(chart);
        this._notifyStateChanges(chart);
        return descriptors;
    }
    _createDescriptors(chart, all) {
        const config = chart && chart.config;
        const options = (0, $breCz.v)(config.options && config.options.plugins, {});
        const plugins = $4ffe47e38c59be9a$var$allPlugins(config);
        return options === false && !all ? [] : $4ffe47e38c59be9a$var$createDescriptors(chart, plugins, options, all);
    }
    _notifyStateChanges(chart) {
        const previousDescriptors = this._oldCache || [];
        const descriptors = this._cache;
        const diff = (a, b)=>a.filter((x)=>!b.some((y)=>x.plugin.id === y.plugin.id));
        this._notify(diff(previousDescriptors, descriptors), chart, "stop");
        this._notify(diff(descriptors, previousDescriptors), chart, "start");
    }
}
function $4ffe47e38c59be9a$var$allPlugins(config) {
    const plugins = [];
    const keys = Object.keys($4ffe47e38c59be9a$export$4bb7493d241fd8a5.plugins.items);
    for(let i = 0; i < keys.length; i++)plugins.push($4ffe47e38c59be9a$export$4bb7493d241fd8a5.getPlugin(keys[i]));
    const local = config.plugins || [];
    for(let i = 0; i < local.length; i++){
        const plugin = local[i];
        if (plugins.indexOf(plugin) === -1) plugins.push(plugin);
    }
    return plugins;
}
function $4ffe47e38c59be9a$var$getOpts(options, all) {
    if (!all && options === false) return null;
    if (options === true) return {};
    return options;
}
function $4ffe47e38c59be9a$var$createDescriptors(chart, plugins, options, all) {
    const result = [];
    const context = chart.getContext();
    for(let i = 0; i < plugins.length; i++){
        const plugin = plugins[i];
        const id = plugin.id;
        const opts = $4ffe47e38c59be9a$var$getOpts(options[id], all);
        if (opts === null) continue;
        result.push({
            plugin: plugin,
            options: $4ffe47e38c59be9a$var$pluginOpts(chart.config, plugin, opts, context)
        });
    }
    return result;
}
function $4ffe47e38c59be9a$var$pluginOpts(config, plugin, opts, context) {
    const keys = config.pluginScopeKeys(plugin);
    const scopes = config.getOptionScopes(opts, keys);
    return config.createResolver(scopes, context, [
        ""
    ], {
        scriptable: false,
        indexable: false,
        allKeys: true
    });
}
function $4ffe47e38c59be9a$var$getIndexAxis(type, options) {
    const datasetDefaults = (0, $breCz.d).datasets[type] || {};
    const datasetOptions = (options.datasets || {})[type] || {};
    return datasetOptions.indexAxis || options.indexAxis || datasetDefaults.indexAxis || "x";
}
function $4ffe47e38c59be9a$var$getAxisFromDefaultScaleID(id, indexAxis) {
    let axis = id;
    if (id === "_index_") axis = indexAxis;
    else if (id === "_value_") axis = indexAxis === "x" ? "y" : "x";
    return axis;
}
function $4ffe47e38c59be9a$var$getDefaultScaleIDFromAxis(axis, indexAxis) {
    return axis === indexAxis ? "_index_" : "_value_";
}
function $4ffe47e38c59be9a$var$axisFromPosition(position) {
    if (position === "top" || position === "bottom") return "x";
    if (position === "left" || position === "right") return "y";
}
function $4ffe47e38c59be9a$var$determineAxis(id, scaleOptions) {
    if (id === "x" || id === "y") return id;
    return scaleOptions.axis || $4ffe47e38c59be9a$var$axisFromPosition(scaleOptions.position) || id.charAt(0).toLowerCase();
}
function $4ffe47e38c59be9a$var$mergeScaleConfig(config, options) {
    const chartDefaults = (0, $breCz.Z)[config.type] || {
        scales: {}
    };
    const configScales = options.scales || {};
    const chartIndexAxis = $4ffe47e38c59be9a$var$getIndexAxis(config.type, options);
    const firstIDs = Object.create(null);
    const scales = Object.create(null);
    Object.keys(configScales).forEach((id)=>{
        const scaleConf = configScales[id];
        const axis = $4ffe47e38c59be9a$var$determineAxis(id, scaleConf);
        const defaultId = $4ffe47e38c59be9a$var$getDefaultScaleIDFromAxis(axis, chartIndexAxis);
        const defaultScaleOptions = chartDefaults.scales || {};
        firstIDs[axis] = firstIDs[axis] || id;
        scales[id] = (0, $breCz.a6)(Object.create(null), [
            {
                axis: axis
            },
            scaleConf,
            defaultScaleOptions[axis],
            defaultScaleOptions[defaultId]
        ]);
    });
    config.data.datasets.forEach((dataset)=>{
        const type = dataset.type || config.type;
        const indexAxis = dataset.indexAxis || $4ffe47e38c59be9a$var$getIndexAxis(type, options);
        const datasetDefaults = (0, $breCz.Z)[type] || {};
        const defaultScaleOptions = datasetDefaults.scales || {};
        Object.keys(defaultScaleOptions).forEach((defaultID)=>{
            const axis = $4ffe47e38c59be9a$var$getAxisFromDefaultScaleID(defaultID, indexAxis);
            const id = dataset[axis + "AxisID"] || firstIDs[axis] || axis;
            scales[id] = scales[id] || Object.create(null);
            (0, $breCz.a6)(scales[id], [
                {
                    axis: axis
                },
                configScales[id],
                defaultScaleOptions[defaultID]
            ]);
        });
    });
    Object.keys(scales).forEach((key)=>{
        const scale = scales[key];
        (0, $breCz.a6)(scale, [
            (0, $breCz.d).scales[scale.type],
            (0, $breCz.d).scale
        ]);
    });
    return scales;
}
function $4ffe47e38c59be9a$var$initOptions(config) {
    const options = config.options || (config.options = {});
    options.plugins = (0, $breCz.v)(options.plugins, {});
    options.scales = $4ffe47e38c59be9a$var$mergeScaleConfig(config, options);
}
function $4ffe47e38c59be9a$var$initData(data) {
    data = data || {};
    data.datasets = data.datasets || [];
    data.labels = data.labels || [];
    return data;
}
function $4ffe47e38c59be9a$var$initConfig(config) {
    config = config || {};
    config.data = $4ffe47e38c59be9a$var$initData(config.data);
    $4ffe47e38c59be9a$var$initOptions(config);
    return config;
}
const $4ffe47e38c59be9a$var$keyCache = new Map();
const $4ffe47e38c59be9a$var$keysCached = new Set();
function $4ffe47e38c59be9a$var$cachedKeys(cacheKey, generate) {
    let keys = $4ffe47e38c59be9a$var$keyCache.get(cacheKey);
    if (!keys) {
        keys = generate();
        $4ffe47e38c59be9a$var$keyCache.set(cacheKey, keys);
        $4ffe47e38c59be9a$var$keysCached.add(keys);
    }
    return keys;
}
const $4ffe47e38c59be9a$var$addIfFound = (set, obj, key)=>{
    const opts = (0, $breCz.f)(obj, key);
    if (opts !== undefined) set.add(opts);
};
class $4ffe47e38c59be9a$var$Config {
    constructor(config){
        this._config = $4ffe47e38c59be9a$var$initConfig(config);
        this._scopeCache = new Map();
        this._resolverCache = new Map();
    }
    get type() {
        return this._config.type;
    }
    set type(type) {
        this._config.type = type;
    }
    get data() {
        return this._config.data;
    }
    set data(data) {
        this._config.data = $4ffe47e38c59be9a$var$initData(data);
    }
    get options() {
        return this._config.options;
    }
    set options(options) {
        this._config.options = options;
    }
    get plugins() {
        return this._config.plugins;
    }
    update() {
        const config = this._config;
        this.clearCache();
        $4ffe47e38c59be9a$var$initOptions(config);
    }
    clearCache() {
        this._scopeCache.clear();
        this._resolverCache.clear();
    }
    datasetScopeKeys(datasetType) {
        return $4ffe47e38c59be9a$var$cachedKeys(datasetType, ()=>[
                [
                    `datasets.${datasetType}`,
                    ""
                ]
            ]);
    }
    datasetAnimationScopeKeys(datasetType, transition) {
        return $4ffe47e38c59be9a$var$cachedKeys(`${datasetType}.transition.${transition}`, ()=>[
                [
                    `datasets.${datasetType}.transitions.${transition}`,
                    `transitions.${transition}`
                ],
                [
                    `datasets.${datasetType}`,
                    ""
                ]
            ]);
    }
    datasetElementScopeKeys(datasetType, elementType) {
        return $4ffe47e38c59be9a$var$cachedKeys(`${datasetType}-${elementType}`, ()=>[
                [
                    `datasets.${datasetType}.elements.${elementType}`,
                    `datasets.${datasetType}`,
                    `elements.${elementType}`,
                    ""
                ]
            ]);
    }
    pluginScopeKeys(plugin) {
        const id = plugin.id;
        const type = this.type;
        return $4ffe47e38c59be9a$var$cachedKeys(`${type}-plugin-${id}`, ()=>[
                [
                    `plugins.${id}`,
                    ...plugin.additionalOptionScopes || []
                ]
            ]);
    }
    _cachedScopes(mainScope, resetCache) {
        const _scopeCache = this._scopeCache;
        let cache = _scopeCache.get(mainScope);
        if (!cache || resetCache) {
            cache = new Map();
            _scopeCache.set(mainScope, cache);
        }
        return cache;
    }
    getOptionScopes(mainScope, keyLists, resetCache) {
        const { options: options, type: type } = this;
        const cache = this._cachedScopes(mainScope, resetCache);
        const cached = cache.get(keyLists);
        if (cached) return cached;
        const scopes = new Set();
        keyLists.forEach((keys)=>{
            if (mainScope) {
                scopes.add(mainScope);
                keys.forEach((key)=>$4ffe47e38c59be9a$var$addIfFound(scopes, mainScope, key));
            }
            keys.forEach((key)=>$4ffe47e38c59be9a$var$addIfFound(scopes, options, key));
            keys.forEach((key)=>$4ffe47e38c59be9a$var$addIfFound(scopes, (0, $breCz.Z)[type] || {}, key));
            keys.forEach((key)=>$4ffe47e38c59be9a$var$addIfFound(scopes, (0, $breCz.d), key));
            keys.forEach((key)=>$4ffe47e38c59be9a$var$addIfFound(scopes, (0, $breCz.a1), key));
        });
        const array = Array.from(scopes);
        if ($4ffe47e38c59be9a$var$keysCached.has(keyLists)) cache.set(keyLists, array);
        return array;
    }
    chartOptionScopes() {
        const { options: options, type: type } = this;
        return [
            options,
            (0, $breCz.Z)[type] || {},
            (0, $breCz.d).datasets[type] || {},
            {
                type: type
            },
            (0, $breCz.d),
            (0, $breCz.a1)
        ];
    }
    resolveNamedOptions(scopes, names, context, prefixes = [
        ""
    ]) {
        const result = {
            $shared: true
        };
        const { resolver: resolver, subPrefixes: subPrefixes } = $4ffe47e38c59be9a$var$getResolver(this._resolverCache, scopes, prefixes);
        let options = resolver;
        if ($4ffe47e38c59be9a$var$needContext(resolver, names)) {
            result.$shared = false;
            context = (0, $breCz.a2)(context) ? context() : context;
            const subResolver = this.createResolver(scopes, context, subPrefixes);
            options = (0, $breCz.a3)(resolver, context, subResolver);
        }
        for (const prop of names)result[prop] = options[prop];
        return result;
    }
    createResolver(scopes, context, prefixes = [
        ""
    ], descriptorDefaults) {
        const { resolver: resolver } = $4ffe47e38c59be9a$var$getResolver(this._resolverCache, scopes, prefixes);
        return (0, $breCz.i)(context) ? (0, $breCz.a3)(resolver, context, undefined, descriptorDefaults) : resolver;
    }
}
function $4ffe47e38c59be9a$var$getResolver(resolverCache, scopes, prefixes) {
    let cache = resolverCache.get(scopes);
    if (!cache) {
        cache = new Map();
        resolverCache.set(scopes, cache);
    }
    const cacheKey = prefixes.join();
    let cached = cache.get(cacheKey);
    if (!cached) {
        const resolver = (0, $breCz.a4)(scopes, prefixes);
        cached = {
            resolver: resolver,
            subPrefixes: prefixes.filter((p)=>!p.toLowerCase().includes("hover"))
        };
        cache.set(cacheKey, cached);
    }
    return cached;
}
function $4ffe47e38c59be9a$var$needContext(proxy, names) {
    const { isScriptable: isScriptable, isIndexable: isIndexable } = (0, $breCz.a5)(proxy);
    for (const prop of names){
        if (isScriptable(prop) && (0, $breCz.a2)(proxy[prop]) || isIndexable(prop) && (0, $breCz.b)(proxy[prop])) return true;
    }
    return false;
}
var $4ffe47e38c59be9a$var$version = "3.4.1";
const $4ffe47e38c59be9a$var$KNOWN_POSITIONS = [
    "top",
    "bottom",
    "left",
    "right",
    "chartArea"
];
function $4ffe47e38c59be9a$var$positionIsHorizontal(position, axis) {
    return position === "top" || position === "bottom" || $4ffe47e38c59be9a$var$KNOWN_POSITIONS.indexOf(position) === -1 && axis === "x";
}
function $4ffe47e38c59be9a$var$compare2Level(l1, l2) {
    return function(a, b) {
        return a[l1] === b[l1] ? a[l2] - b[l2] : a[l1] - b[l1];
    };
}
function $4ffe47e38c59be9a$var$onAnimationsComplete(context) {
    const chart = context.chart;
    const animationOptions = chart.options.animation;
    chart.notifyPlugins("afterRender");
    (0, $breCz.L)(animationOptions && animationOptions.onComplete, [
        context
    ], chart);
}
function $4ffe47e38c59be9a$var$onAnimationProgress(context) {
    const chart = context.chart;
    const animationOptions = chart.options.animation;
    (0, $breCz.L)(animationOptions && animationOptions.onProgress, [
        context
    ], chart);
}
function $4ffe47e38c59be9a$var$isDomSupported() {
    return typeof window !== "undefined" && typeof document !== "undefined";
}
function $4ffe47e38c59be9a$var$getCanvas(item) {
    if ($4ffe47e38c59be9a$var$isDomSupported() && typeof item === "string") item = document.getElementById(item);
    else if (item && item.length) item = item[0];
    if (item && item.canvas) item = item.canvas;
    return item;
}
const $4ffe47e38c59be9a$var$instances = {};
const $4ffe47e38c59be9a$var$getChart = (key)=>{
    const canvas = $4ffe47e38c59be9a$var$getCanvas(key);
    return Object.values($4ffe47e38c59be9a$var$instances).filter((c)=>c.canvas === canvas).pop();
};
class $4ffe47e38c59be9a$export$acaa6426d77a227e {
    constructor(item, config){
        const me = this;
        this.config = config = new $4ffe47e38c59be9a$var$Config(config);
        const initialCanvas = $4ffe47e38c59be9a$var$getCanvas(item);
        const existingChart = $4ffe47e38c59be9a$var$getChart(initialCanvas);
        if (existingChart) throw new Error("Canvas is already in use. Chart with ID '" + existingChart.id + "'" + " must be destroyed before the canvas can be reused.");
        const options = config.createResolver(config.chartOptionScopes(), me.getContext());
        this.platform = me._initializePlatform(initialCanvas, config);
        const context = me.platform.acquireContext(initialCanvas, options.aspectRatio);
        const canvas = context && context.canvas;
        const height = canvas && canvas.height;
        const width = canvas && canvas.width;
        this.id = (0, $breCz.a7)();
        this.ctx = context;
        this.canvas = canvas;
        this.width = width;
        this.height = height;
        this._options = options;
        this._aspectRatio = this.aspectRatio;
        this._layers = [];
        this._metasets = [];
        this._stacks = undefined;
        this.boxes = [];
        this.currentDevicePixelRatio = undefined;
        this.chartArea = undefined;
        this._active = [];
        this._lastEvent = undefined;
        this._listeners = {};
        this._responsiveListeners = undefined;
        this._sortedMetasets = [];
        this.scales = {};
        this.scale = undefined;
        this._plugins = new $4ffe47e38c59be9a$var$PluginService();
        this.$proxies = {};
        this._hiddenIndices = {};
        this.attached = false;
        this._animationsDisabled = undefined;
        this.$context = undefined;
        this._doResize = (0, $breCz.a8)(()=>this.update("resize"), options.resizeDelay || 0);
        $4ffe47e38c59be9a$var$instances[me.id] = me;
        if (!context || !canvas) {
            console.error("Failed to create chart: can't acquire context from the given item");
            return;
        }
        $4ffe47e38c59be9a$export$a424a0aa8f687495.listen(me, "complete", $4ffe47e38c59be9a$var$onAnimationsComplete);
        $4ffe47e38c59be9a$export$a424a0aa8f687495.listen(me, "progress", $4ffe47e38c59be9a$var$onAnimationProgress);
        me._initialize();
        if (me.attached) me.update();
    }
    get aspectRatio() {
        const { options: { aspectRatio: aspectRatio, maintainAspectRatio: maintainAspectRatio }, width: width, height: height, _aspectRatio: _aspectRatio } = this;
        if (!(0, $breCz.j)(aspectRatio)) return aspectRatio;
        if (maintainAspectRatio && _aspectRatio) return _aspectRatio;
        return height ? width / height : null;
    }
    get data() {
        return this.config.data;
    }
    set data(data) {
        this.config.data = data;
    }
    get options() {
        return this._options;
    }
    set options(options) {
        this.config.options = options;
    }
    _initialize() {
        const me = this;
        me.notifyPlugins("beforeInit");
        if (me.options.responsive) me.resize();
        else (0, $breCz.a9)(me, me.options.devicePixelRatio);
        me.bindEvents();
        me.notifyPlugins("afterInit");
        return me;
    }
    _initializePlatform(canvas, config) {
        if (config.platform) return new config.platform();
        else if (!$4ffe47e38c59be9a$var$isDomSupported() || typeof OffscreenCanvas !== "undefined" && canvas instanceof OffscreenCanvas) return new $4ffe47e38c59be9a$export$a40a96b24b46cf35();
        return new $4ffe47e38c59be9a$export$f02da7f882cf6b2e();
    }
    clear() {
        (0, $breCz.aa)(this.canvas, this.ctx);
        return this;
    }
    stop() {
        $4ffe47e38c59be9a$export$a424a0aa8f687495.stop(this);
        return this;
    }
    resize(width, height) {
        if (!$4ffe47e38c59be9a$export$a424a0aa8f687495.running(this)) this._resize(width, height);
        else this._resizeBeforeDraw = {
            width: width,
            height: height
        };
    }
    _resize(width, height) {
        const me = this;
        const options = me.options;
        const canvas = me.canvas;
        const aspectRatio = options.maintainAspectRatio && me.aspectRatio;
        const newSize = me.platform.getMaximumSize(canvas, width, height, aspectRatio);
        const newRatio = options.devicePixelRatio || me.platform.getDevicePixelRatio();
        me.width = newSize.width;
        me.height = newSize.height;
        me._aspectRatio = me.aspectRatio;
        if (!(0, $breCz.a9)(me, newRatio, true)) return;
        me.notifyPlugins("resize", {
            size: newSize
        });
        (0, $breCz.L)(options.onResize, [
            me,
            newSize
        ], me);
        if (me.attached) {
            if (me._doResize()) me.render();
        }
    }
    ensureScalesHaveIDs() {
        const options = this.options;
        const scalesOptions = options.scales || {};
        (0, $breCz.B)(scalesOptions, (axisOptions, axisID)=>{
            axisOptions.id = axisID;
        });
    }
    buildOrUpdateScales() {
        const me = this;
        const options = me.options;
        const scaleOpts = options.scales;
        const scales = me.scales;
        const updated = Object.keys(scales).reduce((obj, id)=>{
            obj[id] = false;
            return obj;
        }, {});
        let items = [];
        if (scaleOpts) items = items.concat(Object.keys(scaleOpts).map((id)=>{
            const scaleOptions = scaleOpts[id];
            const axis = $4ffe47e38c59be9a$var$determineAxis(id, scaleOptions);
            const isRadial = axis === "r";
            const isHorizontal = axis === "x";
            return {
                options: scaleOptions,
                dposition: isRadial ? "chartArea" : isHorizontal ? "bottom" : "left",
                dtype: isRadial ? "radialLinear" : isHorizontal ? "category" : "linear"
            };
        }));
        (0, $breCz.B)(items, (item)=>{
            const scaleOptions = item.options;
            const id = scaleOptions.id;
            const axis = $4ffe47e38c59be9a$var$determineAxis(id, scaleOptions);
            const scaleType = (0, $breCz.v)(scaleOptions.type, item.dtype);
            if (scaleOptions.position === undefined || $4ffe47e38c59be9a$var$positionIsHorizontal(scaleOptions.position, axis) !== $4ffe47e38c59be9a$var$positionIsHorizontal(item.dposition)) scaleOptions.position = item.dposition;
            updated[id] = true;
            let scale = null;
            if (id in scales && scales[id].type === scaleType) scale = scales[id];
            else {
                const scaleClass = $4ffe47e38c59be9a$export$4bb7493d241fd8a5.getScale(scaleType);
                scale = new scaleClass({
                    id: id,
                    type: scaleType,
                    ctx: me.ctx,
                    chart: me
                });
                scales[scale.id] = scale;
            }
            scale.init(scaleOptions, options);
        });
        (0, $breCz.B)(updated, (hasUpdated, id)=>{
            if (!hasUpdated) delete scales[id];
        });
        (0, $breCz.B)(scales, (scale)=>{
            $4ffe47e38c59be9a$export$1ecca0613f5e56d2.configure(me, scale, scale.options);
            $4ffe47e38c59be9a$export$1ecca0613f5e56d2.addBox(me, scale);
        });
    }
    _updateMetasets() {
        const me = this;
        const metasets = me._metasets;
        const numData = me.data.datasets.length;
        const numMeta = metasets.length;
        metasets.sort((a, b)=>a.index - b.index);
        if (numMeta > numData) {
            for(let i = numData; i < numMeta; ++i)me._destroyDatasetMeta(i);
            metasets.splice(numData, numMeta - numData);
        }
        me._sortedMetasets = metasets.slice(0).sort($4ffe47e38c59be9a$var$compare2Level("order", "index"));
    }
    _removeUnreferencedMetasets() {
        const me = this;
        const { _metasets: metasets, data: { datasets: datasets } } = me;
        if (metasets.length > datasets.length) delete me._stacks;
        metasets.forEach((meta, index)=>{
            if (datasets.filter((x)=>x === meta._dataset).length === 0) me._destroyDatasetMeta(index);
        });
    }
    buildOrUpdateControllers() {
        const me = this;
        const newControllers = [];
        const datasets = me.data.datasets;
        let i, ilen;
        me._removeUnreferencedMetasets();
        for(i = 0, ilen = datasets.length; i < ilen; i++){
            const dataset = datasets[i];
            let meta = me.getDatasetMeta(i);
            const type = dataset.type || me.config.type;
            if (meta.type && meta.type !== type) {
                me._destroyDatasetMeta(i);
                meta = me.getDatasetMeta(i);
            }
            meta.type = type;
            meta.indexAxis = dataset.indexAxis || $4ffe47e38c59be9a$var$getIndexAxis(type, me.options);
            meta.order = dataset.order || 0;
            meta.index = i;
            meta.label = "" + dataset.label;
            meta.visible = me.isDatasetVisible(i);
            if (meta.controller) {
                meta.controller.updateIndex(i);
                meta.controller.linkScales();
            } else {
                const ControllerClass = $4ffe47e38c59be9a$export$4bb7493d241fd8a5.getController(type);
                const { datasetElementType: datasetElementType, dataElementType: dataElementType } = (0, $breCz.d).datasets[type];
                Object.assign(ControllerClass.prototype, {
                    dataElementType: $4ffe47e38c59be9a$export$4bb7493d241fd8a5.getElement(dataElementType),
                    datasetElementType: datasetElementType && $4ffe47e38c59be9a$export$4bb7493d241fd8a5.getElement(datasetElementType)
                });
                meta.controller = new ControllerClass(me, i);
                newControllers.push(meta.controller);
            }
        }
        me._updateMetasets();
        return newControllers;
    }
    _resetElements() {
        const me = this;
        (0, $breCz.B)(me.data.datasets, (dataset, datasetIndex)=>{
            me.getDatasetMeta(datasetIndex).controller.reset();
        }, me);
    }
    reset() {
        this._resetElements();
        this.notifyPlugins("reset");
    }
    update(mode) {
        const me = this;
        const config = me.config;
        config.update();
        me._options = config.createResolver(config.chartOptionScopes(), me.getContext());
        (0, $breCz.B)(me.scales, (scale)=>{
            $4ffe47e38c59be9a$export$1ecca0613f5e56d2.removeBox(me, scale);
        });
        const animsDisabled = me._animationsDisabled = !me.options.animation;
        me.ensureScalesHaveIDs();
        me.buildOrUpdateScales();
        const existingEvents = new Set(Object.keys(me._listeners));
        const newEvents = new Set(me.options.events);
        if (!(0, $breCz.ab)(existingEvents, newEvents) || !!this._responsiveListeners !== me.options.responsive) {
            me.unbindEvents();
            me.bindEvents();
        }
        me._plugins.invalidate();
        if (me.notifyPlugins("beforeUpdate", {
            mode: mode,
            cancelable: true
        }) === false) return;
        const newControllers = me.buildOrUpdateControllers();
        me.notifyPlugins("beforeElementsUpdate");
        let minPadding = 0;
        for(let i = 0, ilen = me.data.datasets.length; i < ilen; i++){
            const { controller: controller } = me.getDatasetMeta(i);
            const reset = !animsDisabled && newControllers.indexOf(controller) === -1;
            controller.buildOrUpdateElements(reset);
            minPadding = Math.max(+controller.getMaxOverflow(), minPadding);
        }
        me._minPadding = minPadding;
        me._updateLayout(minPadding);
        if (!animsDisabled) (0, $breCz.B)(newControllers, (controller)=>{
            controller.reset();
        });
        me._updateDatasets(mode);
        me.notifyPlugins("afterUpdate", {
            mode: mode
        });
        me._layers.sort($4ffe47e38c59be9a$var$compare2Level("z", "_idx"));
        if (me._lastEvent) me._eventHandler(me._lastEvent, true);
        me.render();
    }
    _updateLayout(minPadding) {
        const me = this;
        if (me.notifyPlugins("beforeLayout", {
            cancelable: true
        }) === false) return;
        $4ffe47e38c59be9a$export$1ecca0613f5e56d2.update(me, me.width, me.height, minPadding);
        const area = me.chartArea;
        const noArea = area.width <= 0 || area.height <= 0;
        me._layers = [];
        (0, $breCz.B)(me.boxes, (box)=>{
            if (noArea && box.position === "chartArea") return;
            if (box.configure) box.configure();
            me._layers.push(...box._layers());
        }, me);
        me._layers.forEach((item, index)=>{
            item._idx = index;
        });
        me.notifyPlugins("afterLayout");
    }
    _updateDatasets(mode) {
        const me = this;
        const isFunction = typeof mode === "function";
        if (me.notifyPlugins("beforeDatasetsUpdate", {
            mode: mode,
            cancelable: true
        }) === false) return;
        for(let i = 0, ilen = me.data.datasets.length; i < ilen; ++i)me._updateDataset(i, isFunction ? mode({
            datasetIndex: i
        }) : mode);
        me.notifyPlugins("afterDatasetsUpdate", {
            mode: mode
        });
    }
    _updateDataset(index, mode) {
        const me = this;
        const meta = me.getDatasetMeta(index);
        const args = {
            meta: meta,
            index: index,
            mode: mode,
            cancelable: true
        };
        if (me.notifyPlugins("beforeDatasetUpdate", args) === false) return;
        meta.controller._update(mode);
        args.cancelable = false;
        me.notifyPlugins("afterDatasetUpdate", args);
    }
    render() {
        const me = this;
        if (me.notifyPlugins("beforeRender", {
            cancelable: true
        }) === false) return;
        if ($4ffe47e38c59be9a$export$a424a0aa8f687495.has(me)) {
            if (me.attached && !$4ffe47e38c59be9a$export$a424a0aa8f687495.running(me)) $4ffe47e38c59be9a$export$a424a0aa8f687495.start(me);
        } else {
            me.draw();
            $4ffe47e38c59be9a$var$onAnimationsComplete({
                chart: me
            });
        }
    }
    draw() {
        const me = this;
        let i;
        if (me._resizeBeforeDraw) {
            const { width: width, height: height } = me._resizeBeforeDraw;
            me._resize(width, height);
            me._resizeBeforeDraw = null;
        }
        me.clear();
        if (me.width <= 0 || me.height <= 0) return;
        if (me.notifyPlugins("beforeDraw", {
            cancelable: true
        }) === false) return;
        const layers = me._layers;
        for(i = 0; i < layers.length && layers[i].z <= 0; ++i)layers[i].draw(me.chartArea);
        me._drawDatasets();
        for(; i < layers.length; ++i)layers[i].draw(me.chartArea);
        me.notifyPlugins("afterDraw");
    }
    _getSortedDatasetMetas(filterVisible) {
        const me = this;
        const metasets = me._sortedMetasets;
        const result = [];
        let i, ilen;
        for(i = 0, ilen = metasets.length; i < ilen; ++i){
            const meta = metasets[i];
            if (!filterVisible || meta.visible) result.push(meta);
        }
        return result;
    }
    getSortedVisibleDatasetMetas() {
        return this._getSortedDatasetMetas(true);
    }
    _drawDatasets() {
        const me = this;
        if (me.notifyPlugins("beforeDatasetsDraw", {
            cancelable: true
        }) === false) return;
        const metasets = me.getSortedVisibleDatasetMetas();
        for(let i = metasets.length - 1; i >= 0; --i)me._drawDataset(metasets[i]);
        me.notifyPlugins("afterDatasetsDraw");
    }
    _drawDataset(meta) {
        const me = this;
        const ctx = me.ctx;
        const clip = meta._clip;
        const useClip = !clip.disabled;
        const area = me.chartArea;
        const args = {
            meta: meta,
            index: meta.index,
            cancelable: true
        };
        if (me.notifyPlugins("beforeDatasetDraw", args) === false) return;
        if (useClip) (0, $breCz.S)(ctx, {
            left: clip.left === false ? 0 : area.left - clip.left,
            right: clip.right === false ? me.width : area.right + clip.right,
            top: clip.top === false ? 0 : area.top - clip.top,
            bottom: clip.bottom === false ? me.height : area.bottom + clip.bottom
        });
        meta.controller.draw();
        if (useClip) (0, $breCz.V)(ctx);
        args.cancelable = false;
        me.notifyPlugins("afterDatasetDraw", args);
    }
    getElementsAtEventForMode(e, mode, options, useFinalPosition) {
        const method = $4ffe47e38c59be9a$export$a13296960cae0384.modes[mode];
        if (typeof method === "function") return method(this, e, options, useFinalPosition);
        return [];
    }
    getDatasetMeta(datasetIndex) {
        const me = this;
        const dataset = me.data.datasets[datasetIndex];
        const metasets = me._metasets;
        let meta = metasets.filter((x)=>x && x._dataset === dataset).pop();
        if (!meta) {
            meta = {
                type: null,
                data: [],
                dataset: null,
                controller: null,
                hidden: null,
                xAxisID: null,
                yAxisID: null,
                order: dataset && dataset.order || 0,
                index: datasetIndex,
                _dataset: dataset,
                _parsed: [],
                _sorted: false
            };
            metasets.push(meta);
        }
        return meta;
    }
    getContext() {
        return this.$context || (this.$context = {
            chart: this,
            type: "chart"
        });
    }
    getVisibleDatasetCount() {
        return this.getSortedVisibleDatasetMetas().length;
    }
    isDatasetVisible(datasetIndex) {
        const dataset = this.data.datasets[datasetIndex];
        if (!dataset) return false;
        const meta = this.getDatasetMeta(datasetIndex);
        return typeof meta.hidden === "boolean" ? !meta.hidden : !dataset.hidden;
    }
    setDatasetVisibility(datasetIndex, visible) {
        const meta = this.getDatasetMeta(datasetIndex);
        meta.hidden = !visible;
    }
    toggleDataVisibility(index) {
        this._hiddenIndices[index] = !this._hiddenIndices[index];
    }
    getDataVisibility(index) {
        return !this._hiddenIndices[index];
    }
    _updateDatasetVisibility(datasetIndex, visible) {
        const me = this;
        const mode = visible ? "show" : "hide";
        const meta = me.getDatasetMeta(datasetIndex);
        const anims = meta.controller._resolveAnimations(undefined, mode);
        me.setDatasetVisibility(datasetIndex, visible);
        anims.update(meta, {
            visible: visible
        });
        me.update((ctx)=>ctx.datasetIndex === datasetIndex ? mode : undefined);
    }
    hide(datasetIndex) {
        this._updateDatasetVisibility(datasetIndex, false);
    }
    show(datasetIndex) {
        this._updateDatasetVisibility(datasetIndex, true);
    }
    _destroyDatasetMeta(datasetIndex) {
        const me = this;
        const meta = me._metasets && me._metasets[datasetIndex];
        if (meta && meta.controller) {
            meta.controller._destroy();
            delete me._metasets[datasetIndex];
        }
    }
    destroy() {
        const me = this;
        const { canvas: canvas, ctx: ctx } = me;
        let i, ilen;
        me.stop();
        $4ffe47e38c59be9a$export$a424a0aa8f687495.remove(me);
        for(i = 0, ilen = me.data.datasets.length; i < ilen; ++i)me._destroyDatasetMeta(i);
        me.config.clearCache();
        if (canvas) {
            me.unbindEvents();
            (0, $breCz.aa)(canvas, ctx);
            me.platform.releaseContext(ctx);
            me.canvas = null;
            me.ctx = null;
        }
        me.notifyPlugins("destroy");
        delete $4ffe47e38c59be9a$var$instances[me.id];
    }
    toBase64Image(...args) {
        return this.canvas.toDataURL(...args);
    }
    bindEvents() {
        this.bindUserEvents();
        if (this.options.responsive) this.bindResponsiveEvents();
        else this.attached = true;
    }
    bindUserEvents() {
        const me = this;
        const listeners = me._listeners;
        const platform = me.platform;
        const _add = (type, listener)=>{
            platform.addEventListener(me, type, listener);
            listeners[type] = listener;
        };
        const listener = function(e, x, y) {
            e.offsetX = x;
            e.offsetY = y;
            me._eventHandler(e);
        };
        (0, $breCz.B)(me.options.events, (type)=>_add(type, listener));
    }
    bindResponsiveEvents() {
        const me = this;
        if (!me._responsiveListeners) me._responsiveListeners = {};
        const listeners = me._responsiveListeners;
        const platform = me.platform;
        const _add = (type, listener)=>{
            platform.addEventListener(me, type, listener);
            listeners[type] = listener;
        };
        const _remove = (type, listener)=>{
            if (listeners[type]) {
                platform.removeEventListener(me, type, listener);
                delete listeners[type];
            }
        };
        const listener = (width, height)=>{
            if (me.canvas) me.resize(width, height);
        };
        let detached;
        const attached = ()=>{
            _remove("attach", attached);
            me.attached = true;
            me.resize();
            _add("resize", listener);
            _add("detach", detached);
        };
        detached = ()=>{
            me.attached = false;
            _remove("resize", listener);
            _add("attach", attached);
        };
        if (platform.isAttached(me.canvas)) attached();
        else detached();
    }
    unbindEvents() {
        const me = this;
        (0, $breCz.B)(me._listeners, (listener, type)=>{
            me.platform.removeEventListener(me, type, listener);
        });
        me._listeners = {};
        (0, $breCz.B)(me._responsiveListeners, (listener, type)=>{
            me.platform.removeEventListener(me, type, listener);
        });
        me._responsiveListeners = undefined;
    }
    updateHoverStyle(items, mode, enabled) {
        const prefix = enabled ? "set" : "remove";
        let meta, item, i, ilen;
        if (mode === "dataset") {
            meta = this.getDatasetMeta(items[0].datasetIndex);
            meta.controller["_" + prefix + "DatasetHoverStyle"]();
        }
        for(i = 0, ilen = items.length; i < ilen; ++i){
            item = items[i];
            const controller = item && this.getDatasetMeta(item.datasetIndex).controller;
            if (controller) controller[prefix + "HoverStyle"](item.element, item.datasetIndex, item.index);
        }
    }
    getActiveElements() {
        return this._active || [];
    }
    setActiveElements(activeElements) {
        const me = this;
        const lastActive = me._active || [];
        const active = activeElements.map(({ datasetIndex: datasetIndex, index: index })=>{
            const meta = me.getDatasetMeta(datasetIndex);
            if (!meta) throw new Error("No dataset found at index " + datasetIndex);
            return {
                datasetIndex: datasetIndex,
                element: meta.data[index],
                index: index
            };
        });
        const changed = !(0, $breCz.ac)(active, lastActive);
        if (changed) {
            me._active = active;
            me._updateHoverStyles(active, lastActive);
        }
    }
    notifyPlugins(hook, args, filter) {
        return this._plugins.notify(this, hook, args, filter);
    }
    _updateHoverStyles(active, lastActive, replay) {
        const me = this;
        const hoverOptions = me.options.hover;
        const diff = (a, b)=>a.filter((x)=>!b.some((y)=>x.datasetIndex === y.datasetIndex && x.index === y.index));
        const deactivated = diff(lastActive, active);
        const activated = replay ? active : diff(active, lastActive);
        if (deactivated.length) me.updateHoverStyle(deactivated, hoverOptions.mode, false);
        if (activated.length && hoverOptions.mode) me.updateHoverStyle(activated, hoverOptions.mode, true);
    }
    _eventHandler(e, replay) {
        const me = this;
        const args = {
            event: e,
            replay: replay,
            cancelable: true
        };
        const eventFilter = (plugin)=>(plugin.options.events || this.options.events).includes(e.type);
        if (me.notifyPlugins("beforeEvent", args, eventFilter) === false) return;
        const changed = me._handleEvent(e, replay);
        args.cancelable = false;
        me.notifyPlugins("afterEvent", args, eventFilter);
        if (changed || args.changed) me.render();
        return me;
    }
    _handleEvent(e, replay) {
        const me = this;
        const { _active: lastActive = [], options: options } = me;
        const hoverOptions = options.hover;
        const useFinalPosition = replay;
        let active = [];
        let changed = false;
        let lastEvent = null;
        if (e.type !== "mouseout") {
            active = me.getElementsAtEventForMode(e, hoverOptions.mode, hoverOptions, useFinalPosition);
            lastEvent = e.type === "click" ? me._lastEvent : e;
        }
        me._lastEvent = null;
        if ((0, $breCz.y)(e, me.chartArea, me._minPadding)) {
            (0, $breCz.L)(options.onHover, [
                e,
                active,
                me
            ], me);
            if (e.type === "mouseup" || e.type === "click" || e.type === "contextmenu") (0, $breCz.L)(options.onClick, [
                e,
                active,
                me
            ], me);
        }
        changed = !(0, $breCz.ac)(active, lastActive);
        if (changed || replay) {
            me._active = active;
            me._updateHoverStyles(active, lastActive, replay);
        }
        me._lastEvent = lastEvent;
        return changed;
    }
}
const $4ffe47e38c59be9a$var$invalidatePlugins = ()=>(0, $breCz.B)($4ffe47e38c59be9a$export$acaa6426d77a227e.instances, (chart)=>chart._plugins.invalidate());
const $4ffe47e38c59be9a$var$enumerable = true;
Object.defineProperties($4ffe47e38c59be9a$export$acaa6426d77a227e, {
    defaults: {
        enumerable: $4ffe47e38c59be9a$var$enumerable,
        value: (0, $breCz.d)
    },
    instances: {
        enumerable: $4ffe47e38c59be9a$var$enumerable,
        value: $4ffe47e38c59be9a$var$instances
    },
    overrides: {
        enumerable: $4ffe47e38c59be9a$var$enumerable,
        value: (0, $breCz.Z)
    },
    registry: {
        enumerable: $4ffe47e38c59be9a$var$enumerable,
        value: $4ffe47e38c59be9a$export$4bb7493d241fd8a5
    },
    version: {
        enumerable: $4ffe47e38c59be9a$var$enumerable,
        value: $4ffe47e38c59be9a$var$version
    },
    getChart: {
        enumerable: $4ffe47e38c59be9a$var$enumerable,
        value: $4ffe47e38c59be9a$var$getChart
    },
    register: {
        enumerable: $4ffe47e38c59be9a$var$enumerable,
        value: (...items)=>{
            $4ffe47e38c59be9a$export$4bb7493d241fd8a5.add(...items);
            $4ffe47e38c59be9a$var$invalidatePlugins();
        }
    },
    unregister: {
        enumerable: $4ffe47e38c59be9a$var$enumerable,
        value: (...items)=>{
            $4ffe47e38c59be9a$export$4bb7493d241fd8a5.remove(...items);
            $4ffe47e38c59be9a$var$invalidatePlugins();
        }
    }
});
function $4ffe47e38c59be9a$var$clipArc(ctx, element, endAngle) {
    const { startAngle: startAngle, pixelMargin: pixelMargin, x: x, y: y, outerRadius: outerRadius, innerRadius: innerRadius } = element;
    let angleMargin = pixelMargin / outerRadius;
    ctx.beginPath();
    ctx.arc(x, y, outerRadius, startAngle - angleMargin, endAngle + angleMargin);
    if (innerRadius > pixelMargin) {
        angleMargin = pixelMargin / innerRadius;
        ctx.arc(x, y, innerRadius, endAngle + angleMargin, startAngle - angleMargin, true);
    } else ctx.arc(x, y, pixelMargin, endAngle + (0, $breCz.H), startAngle - (0, $breCz.H));
    ctx.closePath();
    ctx.clip();
}
function $4ffe47e38c59be9a$var$toRadiusCorners(value) {
    return (0, $breCz.ae)(value, [
        "outerStart",
        "outerEnd",
        "innerStart",
        "innerEnd"
    ]);
}
function $4ffe47e38c59be9a$var$parseBorderRadius$1(arc, innerRadius, outerRadius, angleDelta) {
    const o = $4ffe47e38c59be9a$var$toRadiusCorners(arc.options.borderRadius);
    const halfThickness = (outerRadius - innerRadius) / 2;
    const innerLimit = Math.min(halfThickness, angleDelta * innerRadius / 2);
    const computeOuterLimit = (val)=>{
        const outerArcLimit = (outerRadius - Math.min(halfThickness, val)) * angleDelta / 2;
        return (0, $breCz.q)(val, 0, Math.min(halfThickness, outerArcLimit));
    };
    return {
        outerStart: computeOuterLimit(o.outerStart),
        outerEnd: computeOuterLimit(o.outerEnd),
        innerStart: (0, $breCz.q)(o.innerStart, 0, innerLimit),
        innerEnd: (0, $breCz.q)(o.innerEnd, 0, innerLimit)
    };
}
function $4ffe47e38c59be9a$var$rThetaToXY(r, theta, x, y) {
    return {
        x: x + r * Math.cos(theta),
        y: y + r * Math.sin(theta)
    };
}
function $4ffe47e38c59be9a$var$pathArc(ctx, element, offset, spacing, end) {
    const { x: x, y: y, startAngle: start, pixelMargin: pixelMargin, innerRadius: innerR } = element;
    const outerRadius = Math.max(element.outerRadius + spacing + offset - pixelMargin, 0);
    const innerRadius = innerR > 0 ? innerR + spacing + offset + pixelMargin : 0;
    let spacingOffset = 0;
    const alpha = end - start;
    if (spacing) {
        const noSpacingInnerRadius = innerR > 0 ? innerR - spacing : 0;
        const noSpacingOuterRadius = outerRadius > 0 ? outerRadius - spacing : 0;
        const avNogSpacingRadius = (noSpacingInnerRadius + noSpacingOuterRadius) / 2;
        const adjustedAngle = avNogSpacingRadius !== 0 ? alpha * avNogSpacingRadius / (avNogSpacingRadius + spacing) : alpha;
        spacingOffset = (alpha - adjustedAngle) / 2;
    }
    const beta = Math.max(0.001, alpha * outerRadius - offset / (0, $breCz.P)) / outerRadius;
    const angleOffset = (alpha - beta) / 2;
    const startAngle = start + angleOffset + spacingOffset;
    const endAngle = end - angleOffset - spacingOffset;
    const { outerStart: outerStart, outerEnd: outerEnd, innerStart: innerStart, innerEnd: innerEnd } = $4ffe47e38c59be9a$var$parseBorderRadius$1(element, innerRadius, outerRadius, endAngle - startAngle);
    const outerStartAdjustedRadius = outerRadius - outerStart;
    const outerEndAdjustedRadius = outerRadius - outerEnd;
    const outerStartAdjustedAngle = startAngle + outerStart / outerStartAdjustedRadius;
    const outerEndAdjustedAngle = endAngle - outerEnd / outerEndAdjustedRadius;
    const innerStartAdjustedRadius = innerRadius + innerStart;
    const innerEndAdjustedRadius = innerRadius + innerEnd;
    const innerStartAdjustedAngle = startAngle + innerStart / innerStartAdjustedRadius;
    const innerEndAdjustedAngle = endAngle - innerEnd / innerEndAdjustedRadius;
    ctx.beginPath();
    ctx.arc(x, y, outerRadius, outerStartAdjustedAngle, outerEndAdjustedAngle);
    if (outerEnd > 0) {
        const pCenter = $4ffe47e38c59be9a$var$rThetaToXY(outerEndAdjustedRadius, outerEndAdjustedAngle, x, y);
        ctx.arc(pCenter.x, pCenter.y, outerEnd, outerEndAdjustedAngle, endAngle + (0, $breCz.H));
    }
    const p4 = $4ffe47e38c59be9a$var$rThetaToXY(innerEndAdjustedRadius, endAngle, x, y);
    ctx.lineTo(p4.x, p4.y);
    if (innerEnd > 0) {
        const pCenter = $4ffe47e38c59be9a$var$rThetaToXY(innerEndAdjustedRadius, innerEndAdjustedAngle, x, y);
        ctx.arc(pCenter.x, pCenter.y, innerEnd, endAngle + (0, $breCz.H), innerEndAdjustedAngle + Math.PI);
    }
    ctx.arc(x, y, innerRadius, endAngle - innerEnd / innerRadius, startAngle + innerStart / innerRadius, true);
    if (innerStart > 0) {
        const pCenter = $4ffe47e38c59be9a$var$rThetaToXY(innerStartAdjustedRadius, innerStartAdjustedAngle, x, y);
        ctx.arc(pCenter.x, pCenter.y, innerStart, innerStartAdjustedAngle + Math.PI, startAngle - (0, $breCz.H));
    }
    const p8 = $4ffe47e38c59be9a$var$rThetaToXY(outerStartAdjustedRadius, startAngle, x, y);
    ctx.lineTo(p8.x, p8.y);
    if (outerStart > 0) {
        const pCenter = $4ffe47e38c59be9a$var$rThetaToXY(outerStartAdjustedRadius, outerStartAdjustedAngle, x, y);
        ctx.arc(pCenter.x, pCenter.y, outerStart, startAngle - (0, $breCz.H), outerStartAdjustedAngle);
    }
    ctx.closePath();
}
function $4ffe47e38c59be9a$var$drawArc(ctx, element, offset, spacing) {
    const { fullCircles: fullCircles, startAngle: startAngle, circumference: circumference } = element;
    let endAngle = element.endAngle;
    if (fullCircles) {
        $4ffe47e38c59be9a$var$pathArc(ctx, element, offset, spacing, startAngle + (0, $breCz.T));
        for(let i = 0; i < fullCircles; ++i)ctx.fill();
        if (!isNaN(circumference)) {
            endAngle = startAngle + circumference % (0, $breCz.T);
            if (circumference % (0, $breCz.T) === 0) endAngle += (0, $breCz.T);
        }
    }
    $4ffe47e38c59be9a$var$pathArc(ctx, element, offset, spacing, endAngle);
    ctx.fill();
    return endAngle;
}
function $4ffe47e38c59be9a$var$drawFullCircleBorders(ctx, element, inner) {
    const { x: x, y: y, startAngle: startAngle, pixelMargin: pixelMargin, fullCircles: fullCircles } = element;
    const outerRadius = Math.max(element.outerRadius - pixelMargin, 0);
    const innerRadius = element.innerRadius + pixelMargin;
    let i;
    if (inner) $4ffe47e38c59be9a$var$clipArc(ctx, element, startAngle + (0, $breCz.T));
    ctx.beginPath();
    ctx.arc(x, y, innerRadius, startAngle + (0, $breCz.T), startAngle, true);
    for(i = 0; i < fullCircles; ++i)ctx.stroke();
    ctx.beginPath();
    ctx.arc(x, y, outerRadius, startAngle, startAngle + (0, $breCz.T));
    for(i = 0; i < fullCircles; ++i)ctx.stroke();
}
function $4ffe47e38c59be9a$var$drawBorder(ctx, element, offset, spacing, endAngle) {
    const { options: options } = element;
    const inner = options.borderAlign === "inner";
    if (!options.borderWidth) return;
    if (inner) {
        ctx.lineWidth = options.borderWidth * 2;
        ctx.lineJoin = "round";
    } else {
        ctx.lineWidth = options.borderWidth;
        ctx.lineJoin = "bevel";
    }
    if (element.fullCircles) $4ffe47e38c59be9a$var$drawFullCircleBorders(ctx, element, inner);
    if (inner) $4ffe47e38c59be9a$var$clipArc(ctx, element, endAngle);
    $4ffe47e38c59be9a$var$pathArc(ctx, element, offset, spacing, endAngle);
    ctx.stroke();
}
class $4ffe47e38c59be9a$export$d48203c759d6a1fc extends $4ffe47e38c59be9a$export$db77ccec0bb4ccac {
    constructor(cfg){
        super();
        this.options = undefined;
        this.circumference = undefined;
        this.startAngle = undefined;
        this.endAngle = undefined;
        this.innerRadius = undefined;
        this.outerRadius = undefined;
        this.pixelMargin = 0;
        this.fullCircles = 0;
        if (cfg) Object.assign(this, cfg);
    }
    inRange(chartX, chartY, useFinalPosition) {
        const point = this.getProps([
            "x",
            "y"
        ], useFinalPosition);
        const { angle: angle, distance: distance } = (0, $breCz.ad)(point, {
            x: chartX,
            y: chartY
        });
        const { startAngle: startAngle, endAngle: endAngle, innerRadius: innerRadius, outerRadius: outerRadius, circumference: circumference } = this.getProps([
            "startAngle",
            "endAngle",
            "innerRadius",
            "outerRadius",
            "circumference"
        ], useFinalPosition);
        const rAdjust = this.options.spacing / 2;
        const betweenAngles = circumference >= (0, $breCz.T) || (0, $breCz.o)(angle, startAngle, endAngle);
        const withinRadius = distance >= innerRadius + rAdjust && distance <= outerRadius + rAdjust;
        return betweenAngles && withinRadius;
    }
    getCenterPoint(useFinalPosition) {
        const { x: x, y: y, startAngle: startAngle, endAngle: endAngle, innerRadius: innerRadius, outerRadius: outerRadius } = this.getProps([
            "x",
            "y",
            "startAngle",
            "endAngle",
            "innerRadius",
            "outerRadius",
            "circumference"
        ], useFinalPosition);
        const { offset: offset, spacing: spacing } = this.options;
        const halfAngle = (startAngle + endAngle) / 2;
        const halfRadius = (innerRadius + outerRadius + spacing + offset) / 2;
        return {
            x: x + Math.cos(halfAngle) * halfRadius,
            y: y + Math.sin(halfAngle) * halfRadius
        };
    }
    tooltipPosition(useFinalPosition) {
        return this.getCenterPoint(useFinalPosition);
    }
    draw(ctx) {
        const me = this;
        const { options: options, circumference: circumference } = me;
        const offset = (options.offset || 0) / 2;
        const spacing = (options.spacing || 0) / 2;
        me.pixelMargin = options.borderAlign === "inner" ? 0.33 : 0;
        me.fullCircles = circumference > (0, $breCz.T) ? Math.floor(circumference / (0, $breCz.T)) : 0;
        if (circumference === 0 || me.innerRadius < 0 || me.outerRadius < 0) return;
        ctx.save();
        let radiusOffset = 0;
        if (offset) {
            radiusOffset = offset / 2;
            const halfAngle = (me.startAngle + me.endAngle) / 2;
            ctx.translate(Math.cos(halfAngle) * radiusOffset, Math.sin(halfAngle) * radiusOffset);
            if (me.circumference >= (0, $breCz.P)) radiusOffset = offset;
        }
        ctx.fillStyle = options.backgroundColor;
        ctx.strokeStyle = options.borderColor;
        const endAngle = $4ffe47e38c59be9a$var$drawArc(ctx, me, radiusOffset, spacing);
        $4ffe47e38c59be9a$var$drawBorder(ctx, me, radiusOffset, spacing, endAngle);
        ctx.restore();
    }
}
$4ffe47e38c59be9a$export$d48203c759d6a1fc.id = "arc";
$4ffe47e38c59be9a$export$d48203c759d6a1fc.defaults = {
    borderAlign: "center",
    borderColor: "#fff",
    borderRadius: 0,
    borderWidth: 2,
    offset: 0,
    spacing: 0,
    angle: undefined
};
$4ffe47e38c59be9a$export$d48203c759d6a1fc.defaultRoutes = {
    backgroundColor: "backgroundColor"
};
function $4ffe47e38c59be9a$var$setStyle(ctx, options, style = options) {
    ctx.lineCap = (0, $breCz.v)(style.borderCapStyle, options.borderCapStyle);
    ctx.setLineDash((0, $breCz.v)(style.borderDash, options.borderDash));
    ctx.lineDashOffset = (0, $breCz.v)(style.borderDashOffset, options.borderDashOffset);
    ctx.lineJoin = (0, $breCz.v)(style.borderJoinStyle, options.borderJoinStyle);
    ctx.lineWidth = (0, $breCz.v)(style.borderWidth, options.borderWidth);
    ctx.strokeStyle = (0, $breCz.v)(style.borderColor, options.borderColor);
}
function $4ffe47e38c59be9a$var$lineTo(ctx, previous, target) {
    ctx.lineTo(target.x, target.y);
}
function $4ffe47e38c59be9a$var$getLineMethod(options) {
    if (options.stepped) return 0, $breCz.al;
    if (options.tension || options.cubicInterpolationMode === "monotone") return 0, $breCz.am;
    return $4ffe47e38c59be9a$var$lineTo;
}
function $4ffe47e38c59be9a$var$pathVars(points, segment, params = {}) {
    const count = points.length;
    const { start: paramsStart = 0, end: paramsEnd = count - 1 } = params;
    const { start: segmentStart, end: segmentEnd } = segment;
    const start = Math.max(paramsStart, segmentStart);
    const end = Math.min(paramsEnd, segmentEnd);
    const outside = paramsStart < segmentStart && paramsEnd < segmentStart || paramsStart > segmentEnd && paramsEnd > segmentEnd;
    return {
        count: count,
        start: start,
        loop: segment.loop,
        ilen: end < start && !outside ? count + end - start : end - start
    };
}
function $4ffe47e38c59be9a$var$pathSegment(ctx, line, segment, params) {
    const { points: points, options: options } = line;
    const { count: count, start: start, loop: loop, ilen: ilen } = $4ffe47e38c59be9a$var$pathVars(points, segment, params);
    const lineMethod = $4ffe47e38c59be9a$var$getLineMethod(options);
    let { move: move = true, reverse: reverse } = params || {};
    let i, point, prev;
    for(i = 0; i <= ilen; ++i){
        point = points[(start + (reverse ? ilen - i : i)) % count];
        if (point.skip) continue;
        else if (move) {
            ctx.moveTo(point.x, point.y);
            move = false;
        } else lineMethod(ctx, prev, point, reverse, options.stepped);
        prev = point;
    }
    if (loop) {
        point = points[(start + (reverse ? ilen : 0)) % count];
        lineMethod(ctx, prev, point, reverse, options.stepped);
    }
    return !!loop;
}
function $4ffe47e38c59be9a$var$fastPathSegment(ctx, line, segment, params) {
    const points = line.points;
    const { count: count, start: start, ilen: ilen } = $4ffe47e38c59be9a$var$pathVars(points, segment, params);
    const { move: move = true, reverse: reverse } = params || {};
    let avgX = 0;
    let countX = 0;
    let i, point, prevX, minY, maxY, lastY;
    const pointIndex = (index)=>(start + (reverse ? ilen - index : index)) % count;
    const drawX = ()=>{
        if (minY !== maxY) {
            ctx.lineTo(avgX, maxY);
            ctx.lineTo(avgX, minY);
            ctx.lineTo(avgX, lastY);
        }
    };
    if (move) {
        point = points[pointIndex(0)];
        ctx.moveTo(point.x, point.y);
    }
    for(i = 0; i <= ilen; ++i){
        point = points[pointIndex(i)];
        if (point.skip) continue;
        const x = point.x;
        const y = point.y;
        const truncX = x | 0;
        if (truncX === prevX) {
            if (y < minY) minY = y;
            else if (y > maxY) maxY = y;
            avgX = (countX * avgX + x) / ++countX;
        } else {
            drawX();
            ctx.lineTo(x, y);
            prevX = truncX;
            countX = 0;
            minY = maxY = y;
        }
        lastY = y;
    }
    drawX();
}
function $4ffe47e38c59be9a$var$_getSegmentMethod(line) {
    const opts = line.options;
    const borderDash = opts.borderDash && opts.borderDash.length;
    const useFastPath = !line._decimated && !line._loop && !opts.tension && opts.cubicInterpolationMode !== "monotone" && !opts.stepped && !borderDash;
    return useFastPath ? $4ffe47e38c59be9a$var$fastPathSegment : $4ffe47e38c59be9a$var$pathSegment;
}
function $4ffe47e38c59be9a$var$_getInterpolationMethod(options) {
    if (options.stepped) return 0, $breCz.ai;
    if (options.tension || options.cubicInterpolationMode === "monotone") return 0, $breCz.aj;
    return 0, $breCz.ak;
}
function $4ffe47e38c59be9a$var$strokePathWithCache(ctx, line, start, count) {
    let path = line._path;
    if (!path) {
        path = line._path = new Path2D();
        if (line.path(path, start, count)) path.closePath();
    }
    $4ffe47e38c59be9a$var$setStyle(ctx, line.options);
    ctx.stroke(path);
}
function $4ffe47e38c59be9a$var$strokePathDirect(ctx, line, start, count) {
    const { segments: segments, options: options } = line;
    const segmentMethod = $4ffe47e38c59be9a$var$_getSegmentMethod(line);
    for (const segment of segments){
        $4ffe47e38c59be9a$var$setStyle(ctx, options, segment.style);
        ctx.beginPath();
        if (segmentMethod(ctx, line, segment, {
            start: start,
            end: start + count - 1
        })) ctx.closePath();
        ctx.stroke();
    }
}
const $4ffe47e38c59be9a$var$usePath2D = typeof Path2D === "function";
function $4ffe47e38c59be9a$var$draw(ctx, line, start, count) {
    if ($4ffe47e38c59be9a$var$usePath2D && line.segments.length === 1) $4ffe47e38c59be9a$var$strokePathWithCache(ctx, line, start, count);
    else $4ffe47e38c59be9a$var$strokePathDirect(ctx, line, start, count);
}
class $4ffe47e38c59be9a$export$55e463fa7bcd3469 extends $4ffe47e38c59be9a$export$db77ccec0bb4ccac {
    constructor(cfg){
        super();
        this.animated = true;
        this.options = undefined;
        this._loop = undefined;
        this._fullLoop = undefined;
        this._path = undefined;
        this._points = undefined;
        this._segments = undefined;
        this._decimated = false;
        this._pointsUpdated = false;
        if (cfg) Object.assign(this, cfg);
    }
    updateControlPoints(chartArea, indexAxis) {
        const me = this;
        const options = me.options;
        if ((options.tension || options.cubicInterpolationMode === "monotone") && !options.stepped && !me._pointsUpdated) {
            const loop = options.spanGaps ? me._loop : me._fullLoop;
            (0, $breCz.af)(me._points, options, chartArea, loop, indexAxis);
            me._pointsUpdated = true;
        }
    }
    set points(points) {
        const me = this;
        me._points = points;
        delete me._segments;
        delete me._path;
        me._pointsUpdated = false;
    }
    get points() {
        return this._points;
    }
    get segments() {
        return this._segments || (this._segments = (0, $breCz.ag)(this, this.options.segment));
    }
    first() {
        const segments = this.segments;
        const points = this.points;
        return segments.length && points[segments[0].start];
    }
    last() {
        const segments = this.segments;
        const points = this.points;
        const count = segments.length;
        return count && points[segments[count - 1].end];
    }
    interpolate(point, property) {
        const me = this;
        const options = me.options;
        const value = point[property];
        const points = me.points;
        const segments = (0, $breCz.ah)(me, {
            property: property,
            start: value,
            end: value
        });
        if (!segments.length) return;
        const result = [];
        const _interpolate = $4ffe47e38c59be9a$var$_getInterpolationMethod(options);
        let i, ilen;
        for(i = 0, ilen = segments.length; i < ilen; ++i){
            const { start: start, end: end } = segments[i];
            const p1 = points[start];
            const p2 = points[end];
            if (p1 === p2) {
                result.push(p1);
                continue;
            }
            const t = Math.abs((value - p1[property]) / (p2[property] - p1[property]));
            const interpolated = _interpolate(p1, p2, t, options.stepped);
            interpolated[property] = point[property];
            result.push(interpolated);
        }
        return result.length === 1 ? result[0] : result;
    }
    pathSegment(ctx, segment, params) {
        const segmentMethod = $4ffe47e38c59be9a$var$_getSegmentMethod(this);
        return segmentMethod(ctx, this, segment, params);
    }
    path(ctx, start, count) {
        const me = this;
        const segments = me.segments;
        const segmentMethod = $4ffe47e38c59be9a$var$_getSegmentMethod(me);
        let loop = me._loop;
        start = start || 0;
        count = count || me.points.length - start;
        for (const segment of segments)loop &= segmentMethod(ctx, me, segment, {
            start: start,
            end: start + count - 1
        });
        return !!loop;
    }
    draw(ctx, chartArea, start, count) {
        const me = this;
        const options = me.options || {};
        const points = me.points || [];
        if (!points.length || !options.borderWidth) return;
        ctx.save();
        $4ffe47e38c59be9a$var$draw(ctx, me, start, count);
        ctx.restore();
        if (me.animated) {
            me._pointsUpdated = false;
            me._path = undefined;
        }
    }
}
$4ffe47e38c59be9a$export$55e463fa7bcd3469.id = "line";
$4ffe47e38c59be9a$export$55e463fa7bcd3469.defaults = {
    borderCapStyle: "butt",
    borderDash: [],
    borderDashOffset: 0,
    borderJoinStyle: "miter",
    borderWidth: 3,
    capBezierPoints: true,
    cubicInterpolationMode: "default",
    fill: false,
    spanGaps: false,
    stepped: false,
    tension: 0
};
$4ffe47e38c59be9a$export$55e463fa7bcd3469.defaultRoutes = {
    backgroundColor: "backgroundColor",
    borderColor: "borderColor"
};
$4ffe47e38c59be9a$export$55e463fa7bcd3469.descriptors = {
    _scriptable: true,
    _indexable: (name)=>name !== "borderDash" && name !== "fill"
};
function $4ffe47e38c59be9a$var$inRange$1(el, pos, axis, useFinalPosition) {
    const options = el.options;
    const { [axis]: value } = el.getProps([
        axis
    ], useFinalPosition);
    return Math.abs(pos - value) < options.radius + options.hitRadius;
}
class $4ffe47e38c59be9a$export$bd159b522b230b7a extends $4ffe47e38c59be9a$export$db77ccec0bb4ccac {
    constructor(cfg){
        super();
        this.options = undefined;
        this.parsed = undefined;
        this.skip = undefined;
        this.stop = undefined;
        if (cfg) Object.assign(this, cfg);
    }
    inRange(mouseX, mouseY, useFinalPosition) {
        const options = this.options;
        const { x: x, y: y } = this.getProps([
            "x",
            "y"
        ], useFinalPosition);
        return Math.pow(mouseX - x, 2) + Math.pow(mouseY - y, 2) < Math.pow(options.hitRadius + options.radius, 2);
    }
    inXRange(mouseX, useFinalPosition) {
        return $4ffe47e38c59be9a$var$inRange$1(this, mouseX, "x", useFinalPosition);
    }
    inYRange(mouseY, useFinalPosition) {
        return $4ffe47e38c59be9a$var$inRange$1(this, mouseY, "y", useFinalPosition);
    }
    getCenterPoint(useFinalPosition) {
        const { x: x, y: y } = this.getProps([
            "x",
            "y"
        ], useFinalPosition);
        return {
            x: x,
            y: y
        };
    }
    size(options) {
        options = options || this.options || {};
        let radius = options.radius || 0;
        radius = Math.max(radius, radius && options.hoverRadius || 0);
        const borderWidth = radius && options.borderWidth || 0;
        return (radius + borderWidth) * 2;
    }
    draw(ctx) {
        const me = this;
        const options = me.options;
        if (me.skip || options.radius < 0.1) return;
        ctx.strokeStyle = options.borderColor;
        ctx.lineWidth = options.borderWidth;
        ctx.fillStyle = options.backgroundColor;
        (0, $breCz.an)(ctx, options, me.x, me.y);
    }
    getRange() {
        const options = this.options || {};
        return options.radius + options.hitRadius;
    }
}
$4ffe47e38c59be9a$export$bd159b522b230b7a.id = "point";
$4ffe47e38c59be9a$export$bd159b522b230b7a.defaults = {
    borderWidth: 1,
    hitRadius: 1,
    hoverBorderWidth: 1,
    hoverRadius: 4,
    pointStyle: "circle",
    radius: 3,
    rotation: 0
};
$4ffe47e38c59be9a$export$bd159b522b230b7a.defaultRoutes = {
    backgroundColor: "backgroundColor",
    borderColor: "borderColor"
};
function $4ffe47e38c59be9a$var$getBarBounds(bar, useFinalPosition) {
    const { x: x, y: y, base: base, width: width, height: height } = bar.getProps([
        "x",
        "y",
        "base",
        "width",
        "height"
    ], useFinalPosition);
    let left, right, top, bottom, half;
    if (bar.horizontal) {
        half = height / 2;
        left = Math.min(x, base);
        right = Math.max(x, base);
        top = y - half;
        bottom = y + half;
    } else {
        half = width / 2;
        left = x - half;
        right = x + half;
        top = Math.min(y, base);
        bottom = Math.max(y, base);
    }
    return {
        left: left,
        top: top,
        right: right,
        bottom: bottom
    };
}
function $4ffe47e38c59be9a$var$parseBorderSkipped(bar) {
    let edge = bar.options.borderSkipped;
    const res = {};
    if (!edge) return res;
    edge = bar.horizontal ? $4ffe47e38c59be9a$var$parseEdge(edge, "left", "right", bar.base > bar.x) : $4ffe47e38c59be9a$var$parseEdge(edge, "bottom", "top", bar.base < bar.y);
    res[edge] = true;
    return res;
}
function $4ffe47e38c59be9a$var$parseEdge(edge, a, b, reverse) {
    if (reverse) {
        edge = $4ffe47e38c59be9a$var$swap(edge, a, b);
        edge = $4ffe47e38c59be9a$var$startEnd(edge, b, a);
    } else edge = $4ffe47e38c59be9a$var$startEnd(edge, a, b);
    return edge;
}
function $4ffe47e38c59be9a$var$swap(orig, v1, v2) {
    return orig === v1 ? v2 : orig === v2 ? v1 : orig;
}
function $4ffe47e38c59be9a$var$startEnd(v, start, end) {
    return v === "start" ? start : v === "end" ? end : v;
}
function $4ffe47e38c59be9a$var$skipOrLimit(skip, value, min, max) {
    return skip ? 0 : Math.max(Math.min(value, max), min);
}
function $4ffe47e38c59be9a$var$parseBorderWidth(bar, maxW, maxH) {
    const value = bar.options.borderWidth;
    const skip = $4ffe47e38c59be9a$var$parseBorderSkipped(bar);
    const o = (0, $breCz.ap)(value);
    return {
        t: $4ffe47e38c59be9a$var$skipOrLimit(skip.top, o.top, 0, maxH),
        r: $4ffe47e38c59be9a$var$skipOrLimit(skip.right, o.right, 0, maxW),
        b: $4ffe47e38c59be9a$var$skipOrLimit(skip.bottom, o.bottom, 0, maxH),
        l: $4ffe47e38c59be9a$var$skipOrLimit(skip.left, o.left, 0, maxW)
    };
}
function $4ffe47e38c59be9a$var$parseBorderRadius(bar, maxW, maxH) {
    const { enableBorderRadius: enableBorderRadius } = bar.getProps([
        "enableBorderRadius"
    ]);
    const value = bar.options.borderRadius;
    const o = (0, $breCz.aq)(value);
    const maxR = Math.min(maxW, maxH);
    const skip = $4ffe47e38c59be9a$var$parseBorderSkipped(bar);
    const enableBorder = enableBorderRadius || (0, $breCz.i)(value);
    return {
        topLeft: $4ffe47e38c59be9a$var$skipOrLimit(!enableBorder || skip.top || skip.left, o.topLeft, 0, maxR),
        topRight: $4ffe47e38c59be9a$var$skipOrLimit(!enableBorder || skip.top || skip.right, o.topRight, 0, maxR),
        bottomLeft: $4ffe47e38c59be9a$var$skipOrLimit(!enableBorder || skip.bottom || skip.left, o.bottomLeft, 0, maxR),
        bottomRight: $4ffe47e38c59be9a$var$skipOrLimit(!enableBorder || skip.bottom || skip.right, o.bottomRight, 0, maxR)
    };
}
function $4ffe47e38c59be9a$var$boundingRects(bar) {
    const bounds = $4ffe47e38c59be9a$var$getBarBounds(bar);
    const width = bounds.right - bounds.left;
    const height = bounds.bottom - bounds.top;
    const border = $4ffe47e38c59be9a$var$parseBorderWidth(bar, width / 2, height / 2);
    const radius = $4ffe47e38c59be9a$var$parseBorderRadius(bar, width / 2, height / 2);
    return {
        outer: {
            x: bounds.left,
            y: bounds.top,
            w: width,
            h: height,
            radius: radius
        },
        inner: {
            x: bounds.left + border.l,
            y: bounds.top + border.t,
            w: width - border.l - border.r,
            h: height - border.t - border.b,
            radius: {
                topLeft: Math.max(0, radius.topLeft - Math.max(border.t, border.l)),
                topRight: Math.max(0, radius.topRight - Math.max(border.t, border.r)),
                bottomLeft: Math.max(0, radius.bottomLeft - Math.max(border.b, border.l)),
                bottomRight: Math.max(0, radius.bottomRight - Math.max(border.b, border.r))
            }
        }
    };
}
function $4ffe47e38c59be9a$var$inRange(bar, x, y, useFinalPosition) {
    const skipX = x === null;
    const skipY = y === null;
    const skipBoth = skipX && skipY;
    const bounds = bar && !skipBoth && $4ffe47e38c59be9a$var$getBarBounds(bar, useFinalPosition);
    return bounds && (skipX || x >= bounds.left && x <= bounds.right) && (skipY || y >= bounds.top && y <= bounds.bottom);
}
function $4ffe47e38c59be9a$var$hasRadius(radius) {
    return radius.topLeft || radius.topRight || radius.bottomLeft || radius.bottomRight;
}
function $4ffe47e38c59be9a$var$addNormalRectPath(ctx, rect) {
    ctx.rect(rect.x, rect.y, rect.w, rect.h);
}
class $4ffe47e38c59be9a$export$a16ed71bf4b07672 extends $4ffe47e38c59be9a$export$db77ccec0bb4ccac {
    constructor(cfg){
        super();
        this.options = undefined;
        this.horizontal = undefined;
        this.base = undefined;
        this.width = undefined;
        this.height = undefined;
        if (cfg) Object.assign(this, cfg);
    }
    draw(ctx) {
        const options = this.options;
        const { inner: inner, outer: outer } = $4ffe47e38c59be9a$var$boundingRects(this);
        const addRectPath = $4ffe47e38c59be9a$var$hasRadius(outer.radius) ? (0, $breCz.ao) : $4ffe47e38c59be9a$var$addNormalRectPath;
        ctx.save();
        if (outer.w !== inner.w || outer.h !== inner.h) {
            ctx.beginPath();
            addRectPath(ctx, outer);
            ctx.clip();
            addRectPath(ctx, inner);
            ctx.fillStyle = options.borderColor;
            ctx.fill("evenodd");
        }
        ctx.beginPath();
        addRectPath(ctx, inner);
        ctx.fillStyle = options.backgroundColor;
        ctx.fill();
        ctx.restore();
    }
    inRange(mouseX, mouseY, useFinalPosition) {
        return $4ffe47e38c59be9a$var$inRange(this, mouseX, mouseY, useFinalPosition);
    }
    inXRange(mouseX, useFinalPosition) {
        return $4ffe47e38c59be9a$var$inRange(this, mouseX, null, useFinalPosition);
    }
    inYRange(mouseY, useFinalPosition) {
        return $4ffe47e38c59be9a$var$inRange(this, null, mouseY, useFinalPosition);
    }
    getCenterPoint(useFinalPosition) {
        const { x: x, y: y, base: base, horizontal: horizontal } = this.getProps([
            "x",
            "y",
            "base",
            "horizontal"
        ], useFinalPosition);
        return {
            x: horizontal ? (x + base) / 2 : x,
            y: horizontal ? y : (y + base) / 2
        };
    }
    getRange(axis) {
        return axis === "x" ? this.width / 2 : this.height / 2;
    }
}
$4ffe47e38c59be9a$export$a16ed71bf4b07672.id = "bar";
$4ffe47e38c59be9a$export$a16ed71bf4b07672.defaults = {
    borderSkipped: "start",
    borderWidth: 0,
    borderRadius: 0,
    enableBorderRadius: true,
    pointStyle: undefined
};
$4ffe47e38c59be9a$export$a16ed71bf4b07672.defaultRoutes = {
    backgroundColor: "backgroundColor",
    borderColor: "borderColor"
};
var $4ffe47e38c59be9a$export$7a5d735b2ab6389d = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    ArcElement: $4ffe47e38c59be9a$export$d48203c759d6a1fc,
    LineElement: $4ffe47e38c59be9a$export$55e463fa7bcd3469,
    PointElement: $4ffe47e38c59be9a$export$bd159b522b230b7a,
    BarElement: $4ffe47e38c59be9a$export$a16ed71bf4b07672
});
function $4ffe47e38c59be9a$var$lttbDecimation(data, start, count, availableWidth, options) {
    const samples = options.samples || availableWidth;
    if (samples >= count) return data.slice(start, start + count);
    const decimated = [];
    const bucketWidth = (count - 2) / (samples - 2);
    let sampledIndex = 0;
    const endIndex = start + count - 1;
    let a = start;
    let i, maxAreaPoint, maxArea, area, nextA;
    decimated[sampledIndex++] = data[a];
    for(i = 0; i < samples - 2; i++){
        let avgX = 0;
        let avgY = 0;
        let j;
        const avgRangeStart = Math.floor((i + 1) * bucketWidth) + 1 + start;
        const avgRangeEnd = Math.min(Math.floor((i + 2) * bucketWidth) + 1, count) + start;
        const avgRangeLength = avgRangeEnd - avgRangeStart;
        for(j = avgRangeStart; j < avgRangeEnd; j++){
            avgX += data[j].x;
            avgY += data[j].y;
        }
        avgX /= avgRangeLength;
        avgY /= avgRangeLength;
        const rangeOffs = Math.floor(i * bucketWidth) + 1 + start;
        const rangeTo = Math.floor((i + 1) * bucketWidth) + 1 + start;
        const { x: pointAx, y: pointAy } = data[a];
        maxArea = area = -1;
        for(j = rangeOffs; j < rangeTo; j++){
            area = 0.5 * Math.abs((pointAx - avgX) * (data[j].y - pointAy) - (pointAx - data[j].x) * (avgY - pointAy));
            if (area > maxArea) {
                maxArea = area;
                maxAreaPoint = data[j];
                nextA = j;
            }
        }
        decimated[sampledIndex++] = maxAreaPoint;
        a = nextA;
    }
    decimated[sampledIndex++] = data[endIndex];
    return decimated;
}
function $4ffe47e38c59be9a$var$minMaxDecimation(data, start, count, availableWidth) {
    let avgX = 0;
    let countX = 0;
    let i, point, x, y, prevX, minIndex, maxIndex, startIndex, minY, maxY;
    const decimated = [];
    const endIndex = start + count - 1;
    const xMin = data[start].x;
    const xMax = data[endIndex].x;
    const dx = xMax - xMin;
    for(i = start; i < start + count; ++i){
        point = data[i];
        x = (point.x - xMin) / dx * availableWidth;
        y = point.y;
        const truncX = x | 0;
        if (truncX === prevX) {
            if (y < minY) {
                minY = y;
                minIndex = i;
            } else if (y > maxY) {
                maxY = y;
                maxIndex = i;
            }
            avgX = (countX * avgX + point.x) / ++countX;
        } else {
            const lastIndex = i - 1;
            if (!(0, $breCz.j)(minIndex) && !(0, $breCz.j)(maxIndex)) {
                const intermediateIndex1 = Math.min(minIndex, maxIndex);
                const intermediateIndex2 = Math.max(minIndex, maxIndex);
                if (intermediateIndex1 !== startIndex && intermediateIndex1 !== lastIndex) decimated.push({
                    ...data[intermediateIndex1],
                    x: avgX
                });
                if (intermediateIndex2 !== startIndex && intermediateIndex2 !== lastIndex) decimated.push({
                    ...data[intermediateIndex2],
                    x: avgX
                });
            }
            if (i > 0 && lastIndex !== startIndex) decimated.push(data[lastIndex]);
            decimated.push(point);
            prevX = truncX;
            countX = 0;
            minY = maxY = y;
            minIndex = maxIndex = startIndex = i;
        }
    }
    return decimated;
}
function $4ffe47e38c59be9a$var$cleanDecimatedDataset(dataset) {
    if (dataset._decimated) {
        const data = dataset._data;
        delete dataset._decimated;
        delete dataset._data;
        Object.defineProperty(dataset, "data", {
            value: data
        });
    }
}
function $4ffe47e38c59be9a$var$cleanDecimatedData(chart) {
    chart.data.datasets.forEach((dataset)=>{
        $4ffe47e38c59be9a$var$cleanDecimatedDataset(dataset);
    });
}
function $4ffe47e38c59be9a$var$getStartAndCountOfVisiblePointsSimplified(meta, points) {
    const pointCount = points.length;
    let start = 0;
    let count;
    const { iScale: iScale } = meta;
    const { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = iScale.getUserBounds();
    if (minDefined) start = (0, $breCz.q)((0, $breCz.w)(points, iScale.axis, min).lo, 0, pointCount - 1);
    if (maxDefined) count = (0, $breCz.q)((0, $breCz.w)(points, iScale.axis, max).hi + 1, start, pointCount) - start;
    else count = pointCount - start;
    return {
        start: start,
        count: count
    };
}
var $4ffe47e38c59be9a$export$be17f937e9aa7533 = {
    id: "decimation",
    defaults: {
        algorithm: "min-max",
        enabled: false
    },
    beforeElementsUpdate: (chart, args, options)=>{
        if (!options.enabled) {
            $4ffe47e38c59be9a$var$cleanDecimatedData(chart);
            return;
        }
        const availableWidth = chart.width;
        chart.data.datasets.forEach((dataset, datasetIndex)=>{
            const { _data: _data, indexAxis: indexAxis } = dataset;
            const meta = chart.getDatasetMeta(datasetIndex);
            const data = _data || dataset.data;
            if ((0, $breCz.a)([
                indexAxis,
                chart.options.indexAxis
            ]) === "y") return;
            if (meta.type !== "line") return;
            const xAxis = chart.scales[meta.xAxisID];
            if (xAxis.type !== "linear" && xAxis.type !== "time") return;
            if (chart.options.parsing) return;
            let { start: start, count: count } = $4ffe47e38c59be9a$var$getStartAndCountOfVisiblePointsSimplified(meta, data);
            if (count <= 4 * availableWidth) {
                $4ffe47e38c59be9a$var$cleanDecimatedDataset(dataset);
                return;
            }
            if ((0, $breCz.j)(_data)) {
                dataset._data = data;
                delete dataset.data;
                Object.defineProperty(dataset, "data", {
                    configurable: true,
                    enumerable: true,
                    get: function() {
                        return this._decimated;
                    },
                    set: function(d) {
                        this._data = d;
                    }
                });
            }
            let decimated;
            switch(options.algorithm){
                case "lttb":
                    decimated = $4ffe47e38c59be9a$var$lttbDecimation(data, start, count, availableWidth, options);
                    break;
                case "min-max":
                    decimated = $4ffe47e38c59be9a$var$minMaxDecimation(data, start, count, availableWidth);
                    break;
                default:
                    throw new Error(`Unsupported decimation algorithm '${options.algorithm}'`);
            }
            dataset._decimated = decimated;
        });
    },
    destroy (chart) {
        $4ffe47e38c59be9a$var$cleanDecimatedData(chart);
    }
};
function $4ffe47e38c59be9a$var$getLineByIndex(chart, index) {
    const meta = chart.getDatasetMeta(index);
    const visible = meta && chart.isDatasetVisible(index);
    return visible ? meta.dataset : null;
}
function $4ffe47e38c59be9a$var$parseFillOption(line) {
    const options = line.options;
    const fillOption = options.fill;
    let fill = (0, $breCz.v)(fillOption && fillOption.target, fillOption);
    if (fill === undefined) fill = !!options.backgroundColor;
    if (fill === false || fill === null) return false;
    if (fill === true) return "origin";
    return fill;
}
function $4ffe47e38c59be9a$var$decodeFill(line, index, count) {
    const fill = $4ffe47e38c59be9a$var$parseFillOption(line);
    if ((0, $breCz.i)(fill)) return isNaN(fill.value) ? false : fill;
    let target = parseFloat(fill);
    if ((0, $breCz.g)(target) && Math.floor(target) === target) {
        if (fill[0] === "-" || fill[0] === "+") target = index + target;
        if (target === index || target < 0 || target >= count) return false;
        return target;
    }
    return [
        "origin",
        "start",
        "end",
        "stack"
    ].indexOf(fill) >= 0 && fill;
}
function $4ffe47e38c59be9a$var$computeLinearBoundary(source) {
    const { scale: scale = {}, fill: fill } = source;
    let target = null;
    let horizontal;
    if (fill === "start") target = scale.bottom;
    else if (fill === "end") target = scale.top;
    else if ((0, $breCz.i)(fill)) target = scale.getPixelForValue(fill.value);
    else if (scale.getBasePixel) target = scale.getBasePixel();
    if ((0, $breCz.g)(target)) {
        horizontal = scale.isHorizontal();
        return {
            x: horizontal ? target : null,
            y: horizontal ? null : target
        };
    }
    return null;
}
class $4ffe47e38c59be9a$var$simpleArc {
    constructor(opts){
        this.x = opts.x;
        this.y = opts.y;
        this.radius = opts.radius;
    }
    pathSegment(ctx, bounds, opts) {
        const { x: x, y: y, radius: radius } = this;
        bounds = bounds || {
            start: 0,
            end: (0, $breCz.T)
        };
        ctx.arc(x, y, radius, bounds.end, bounds.start, true);
        return !opts.bounds;
    }
    interpolate(point) {
        const { x: x, y: y, radius: radius } = this;
        const angle = point.angle;
        return {
            x: x + Math.cos(angle) * radius,
            y: y + Math.sin(angle) * radius,
            angle: angle
        };
    }
}
function $4ffe47e38c59be9a$var$computeCircularBoundary(source) {
    const { scale: scale, fill: fill } = source;
    const options = scale.options;
    const length = scale.getLabels().length;
    const target = [];
    const start = options.reverse ? scale.max : scale.min;
    const end = options.reverse ? scale.min : scale.max;
    let i, center, value;
    if (fill === "start") value = start;
    else if (fill === "end") value = end;
    else if ((0, $breCz.i)(fill)) value = fill.value;
    else value = scale.getBaseValue();
    if (options.grid.circular) {
        center = scale.getPointPositionForValue(0, start);
        return new $4ffe47e38c59be9a$var$simpleArc({
            x: center.x,
            y: center.y,
            radius: scale.getDistanceFromCenterForValue(value)
        });
    }
    for(i = 0; i < length; ++i)target.push(scale.getPointPositionForValue(i, value));
    return target;
}
function $4ffe47e38c59be9a$var$computeBoundary(source) {
    const scale = source.scale || {};
    if (scale.getPointPositionForValue) return $4ffe47e38c59be9a$var$computeCircularBoundary(source);
    return $4ffe47e38c59be9a$var$computeLinearBoundary(source);
}
function $4ffe47e38c59be9a$var$findSegmentEnd(start, end, points) {
    for(; end > start; end--){
        const point = points[end];
        if (!isNaN(point.x) && !isNaN(point.y)) break;
    }
    return end;
}
function $4ffe47e38c59be9a$var$pointsFromSegments(boundary, line) {
    const { x: x = null, y: y = null } = boundary || {};
    const linePoints = line.points;
    const points = [];
    line.segments.forEach(({ start: start, end: end })=>{
        end = $4ffe47e38c59be9a$var$findSegmentEnd(start, end, linePoints);
        const first = linePoints[start];
        const last = linePoints[end];
        if (y !== null) {
            points.push({
                x: first.x,
                y: y
            });
            points.push({
                x: last.x,
                y: y
            });
        } else if (x !== null) {
            points.push({
                x: x,
                y: first.y
            });
            points.push({
                x: x,
                y: last.y
            });
        }
    });
    return points;
}
function $4ffe47e38c59be9a$var$buildStackLine(source) {
    const { chart: chart, scale: scale, index: index, line: line } = source;
    const points = [];
    const segments = line.segments;
    const sourcePoints = line.points;
    const linesBelow = $4ffe47e38c59be9a$var$getLinesBelow(chart, index);
    linesBelow.push($4ffe47e38c59be9a$var$createBoundaryLine({
        x: null,
        y: scale.bottom
    }, line));
    for(let i = 0; i < segments.length; i++){
        const segment = segments[i];
        for(let j = segment.start; j <= segment.end; j++)$4ffe47e38c59be9a$var$addPointsBelow(points, sourcePoints[j], linesBelow);
    }
    return new $4ffe47e38c59be9a$export$55e463fa7bcd3469({
        points: points,
        options: {}
    });
}
const $4ffe47e38c59be9a$var$isLineAndNotInHideAnimation = (meta)=>meta.type === "line" && !meta.hidden;
function $4ffe47e38c59be9a$var$getLinesBelow(chart, index) {
    const below = [];
    const metas = chart.getSortedVisibleDatasetMetas();
    for(let i = 0; i < metas.length; i++){
        const meta = metas[i];
        if (meta.index === index) break;
        if ($4ffe47e38c59be9a$var$isLineAndNotInHideAnimation(meta)) below.unshift(meta.dataset);
    }
    return below;
}
function $4ffe47e38c59be9a$var$addPointsBelow(points, sourcePoint, linesBelow) {
    const postponed = [];
    for(let j = 0; j < linesBelow.length; j++){
        const line = linesBelow[j];
        const { first: first, last: last, point: point } = $4ffe47e38c59be9a$var$findPoint(line, sourcePoint, "x");
        if (!point || first && last) continue;
        if (first) postponed.unshift(point);
        else {
            points.push(point);
            if (!last) break;
        }
    }
    points.push(...postponed);
}
function $4ffe47e38c59be9a$var$findPoint(line, sourcePoint, property) {
    const point = line.interpolate(sourcePoint, property);
    if (!point) return {};
    const pointValue = point[property];
    const segments = line.segments;
    const linePoints = line.points;
    let first = false;
    let last = false;
    for(let i = 0; i < segments.length; i++){
        const segment = segments[i];
        const firstValue = linePoints[segment.start][property];
        const lastValue = linePoints[segment.end][property];
        if (pointValue >= firstValue && pointValue <= lastValue) {
            first = pointValue === firstValue;
            last = pointValue === lastValue;
            break;
        }
    }
    return {
        first: first,
        last: last,
        point: point
    };
}
function $4ffe47e38c59be9a$var$getTarget(source) {
    const { chart: chart, fill: fill, line: line } = source;
    if ((0, $breCz.g)(fill)) return $4ffe47e38c59be9a$var$getLineByIndex(chart, fill);
    if (fill === "stack") return $4ffe47e38c59be9a$var$buildStackLine(source);
    const boundary = $4ffe47e38c59be9a$var$computeBoundary(source);
    if (boundary instanceof $4ffe47e38c59be9a$var$simpleArc) return boundary;
    return $4ffe47e38c59be9a$var$createBoundaryLine(boundary, line);
}
function $4ffe47e38c59be9a$var$createBoundaryLine(boundary, line) {
    let points = [];
    let _loop = false;
    if ((0, $breCz.b)(boundary)) {
        _loop = true;
        points = boundary;
    } else points = $4ffe47e38c59be9a$var$pointsFromSegments(boundary, line);
    return points.length ? new $4ffe47e38c59be9a$export$55e463fa7bcd3469({
        points: points,
        options: {
            tension: 0
        },
        _loop: _loop,
        _fullLoop: _loop
    }) : null;
}
function $4ffe47e38c59be9a$var$resolveTarget(sources, index, propagate) {
    const source = sources[index];
    let fill = source.fill;
    const visited = [
        index
    ];
    let target;
    if (!propagate) return fill;
    while(fill !== false && visited.indexOf(fill) === -1){
        if (!(0, $breCz.g)(fill)) return fill;
        target = sources[fill];
        if (!target) return false;
        if (target.visible) return fill;
        visited.push(fill);
        fill = target.fill;
    }
    return false;
}
function $4ffe47e38c59be9a$var$_clip(ctx, target, clipY) {
    ctx.beginPath();
    target.path(ctx);
    ctx.lineTo(target.last().x, clipY);
    ctx.lineTo(target.first().x, clipY);
    ctx.closePath();
    ctx.clip();
}
function $4ffe47e38c59be9a$var$getBounds(property, first, last, loop) {
    if (loop) return;
    let start = first[property];
    let end = last[property];
    if (property === "angle") {
        start = (0, $breCz.as)(start);
        end = (0, $breCz.as)(end);
    }
    return {
        property: property,
        start: start,
        end: end
    };
}
function $4ffe47e38c59be9a$var$_getEdge(a, b, prop, fn) {
    if (a && b) return fn(a[prop], b[prop]);
    return a ? a[prop] : b ? b[prop] : 0;
}
function $4ffe47e38c59be9a$var$_segments(line, target, property) {
    const segments = line.segments;
    const points = line.points;
    const tpoints = target.points;
    const parts = [];
    for (const segment of segments){
        let { start: start, end: end } = segment;
        end = $4ffe47e38c59be9a$var$findSegmentEnd(start, end, points);
        const bounds = $4ffe47e38c59be9a$var$getBounds(property, points[start], points[end], segment.loop);
        if (!target.segments) {
            parts.push({
                source: segment,
                target: bounds,
                start: points[start],
                end: points[end]
            });
            continue;
        }
        const targetSegments = (0, $breCz.ah)(target, bounds);
        for (const tgt of targetSegments){
            const subBounds = $4ffe47e38c59be9a$var$getBounds(property, tpoints[tgt.start], tpoints[tgt.end], tgt.loop);
            const fillSources = (0, $breCz.ar)(segment, points, subBounds);
            for (const fillSource of fillSources)parts.push({
                source: fillSource,
                target: tgt,
                start: {
                    [property]: $4ffe47e38c59be9a$var$_getEdge(bounds, subBounds, "start", Math.max)
                },
                end: {
                    [property]: $4ffe47e38c59be9a$var$_getEdge(bounds, subBounds, "end", Math.min)
                }
            });
        }
    }
    return parts;
}
function $4ffe47e38c59be9a$var$clipBounds(ctx, scale, bounds) {
    const { top: top, bottom: bottom } = scale.chart.chartArea;
    const { property: property, start: start, end: end } = bounds || {};
    if (property === "x") {
        ctx.beginPath();
        ctx.rect(start, top, end - start, bottom - top);
        ctx.clip();
    }
}
function $4ffe47e38c59be9a$var$interpolatedLineTo(ctx, target, point, property) {
    const interpolatedPoint = target.interpolate(point, property);
    if (interpolatedPoint) ctx.lineTo(interpolatedPoint.x, interpolatedPoint.y);
}
function $4ffe47e38c59be9a$var$_fill(ctx, cfg) {
    const { line: line, target: target, property: property, color: color, scale: scale } = cfg;
    const segments = $4ffe47e38c59be9a$var$_segments(line, target, property);
    for (const { source: src, target: tgt, start: start, end: end } of segments){
        const { style: { backgroundColor: backgroundColor = color } = {} } = src;
        ctx.save();
        ctx.fillStyle = backgroundColor;
        $4ffe47e38c59be9a$var$clipBounds(ctx, scale, $4ffe47e38c59be9a$var$getBounds(property, start, end));
        ctx.beginPath();
        const lineLoop = !!line.pathSegment(ctx, src);
        if (lineLoop) ctx.closePath();
        else $4ffe47e38c59be9a$var$interpolatedLineTo(ctx, target, end, property);
        const targetLoop = !!target.pathSegment(ctx, tgt, {
            move: lineLoop,
            reverse: true
        });
        const loop = lineLoop && targetLoop;
        if (!loop) $4ffe47e38c59be9a$var$interpolatedLineTo(ctx, target, start, property);
        ctx.closePath();
        ctx.fill(loop ? "evenodd" : "nonzero");
        ctx.restore();
    }
}
function $4ffe47e38c59be9a$var$doFill(ctx, cfg) {
    const { line: line, target: target, above: above, below: below, area: area, scale: scale } = cfg;
    const property = line._loop ? "angle" : cfg.axis;
    ctx.save();
    if (property === "x" && below !== above) {
        $4ffe47e38c59be9a$var$_clip(ctx, target, area.top);
        $4ffe47e38c59be9a$var$_fill(ctx, {
            line: line,
            target: target,
            color: above,
            scale: scale,
            property: property
        });
        ctx.restore();
        ctx.save();
        $4ffe47e38c59be9a$var$_clip(ctx, target, area.bottom);
    }
    $4ffe47e38c59be9a$var$_fill(ctx, {
        line: line,
        target: target,
        color: below,
        scale: scale,
        property: property
    });
    ctx.restore();
}
function $4ffe47e38c59be9a$var$drawfill(ctx, source, area) {
    const target = $4ffe47e38c59be9a$var$getTarget(source);
    const { line: line, scale: scale, axis: axis } = source;
    const lineOpts = line.options;
    const fillOption = lineOpts.fill;
    const color = lineOpts.backgroundColor;
    const { above: above = color, below: below = color } = fillOption || {};
    if (target && line.points.length) {
        (0, $breCz.S)(ctx, area);
        $4ffe47e38c59be9a$var$doFill(ctx, {
            line: line,
            target: target,
            above: above,
            below: below,
            area: area,
            scale: scale,
            axis: axis
        });
        (0, $breCz.V)(ctx);
    }
}
var $4ffe47e38c59be9a$export$d19ba4d812bed757 = {
    id: "filler",
    afterDatasetsUpdate (chart, _args, options) {
        const count = (chart.data.datasets || []).length;
        const sources = [];
        let meta, i, line, source;
        for(i = 0; i < count; ++i){
            meta = chart.getDatasetMeta(i);
            line = meta.dataset;
            source = null;
            if (line && line.options && line instanceof $4ffe47e38c59be9a$export$55e463fa7bcd3469) source = {
                visible: chart.isDatasetVisible(i),
                index: i,
                fill: $4ffe47e38c59be9a$var$decodeFill(line, i, count),
                chart: chart,
                axis: meta.controller.options.indexAxis,
                scale: meta.vScale,
                line: line
            };
            meta.$filler = source;
            sources.push(source);
        }
        for(i = 0; i < count; ++i){
            source = sources[i];
            if (!source || source.fill === false) continue;
            source.fill = $4ffe47e38c59be9a$var$resolveTarget(sources, i, options.propagate);
        }
    },
    beforeDraw (chart, _args, options) {
        const draw = options.drawTime === "beforeDraw";
        const metasets = chart.getSortedVisibleDatasetMetas();
        const area = chart.chartArea;
        for(let i = metasets.length - 1; i >= 0; --i){
            const source = metasets[i].$filler;
            if (!source) continue;
            source.line.updateControlPoints(area, source.axis);
            if (draw) $4ffe47e38c59be9a$var$drawfill(chart.ctx, source, area);
        }
    },
    beforeDatasetsDraw (chart, _args, options) {
        if (options.drawTime !== "beforeDatasetsDraw") return;
        const metasets = chart.getSortedVisibleDatasetMetas();
        for(let i = metasets.length - 1; i >= 0; --i){
            const source = metasets[i].$filler;
            if (source) $4ffe47e38c59be9a$var$drawfill(chart.ctx, source, chart.chartArea);
        }
    },
    beforeDatasetDraw (chart, args, options) {
        const source = args.meta.$filler;
        if (!source || source.fill === false || options.drawTime !== "beforeDatasetDraw") return;
        $4ffe47e38c59be9a$var$drawfill(chart.ctx, source, chart.chartArea);
    },
    defaults: {
        propagate: true,
        drawTime: "beforeDatasetDraw"
    }
};
const $4ffe47e38c59be9a$var$getBoxSize = (labelOpts, fontSize)=>{
    let { boxHeight: boxHeight = fontSize, boxWidth: boxWidth = fontSize } = labelOpts;
    if (labelOpts.usePointStyle) {
        boxHeight = Math.min(boxHeight, fontSize);
        boxWidth = Math.min(boxWidth, fontSize);
    }
    return {
        boxWidth: boxWidth,
        boxHeight: boxHeight,
        itemHeight: Math.max(fontSize, boxHeight)
    };
};
const $4ffe47e38c59be9a$var$itemsEqual = (a, b)=>a !== null && b !== null && a.datasetIndex === b.datasetIndex && a.index === b.index;
class $4ffe47e38c59be9a$var$Legend extends $4ffe47e38c59be9a$export$db77ccec0bb4ccac {
    constructor(config){
        super();
        this._added = false;
        this.legendHitBoxes = [];
        this._hoveredItem = null;
        this.doughnutMode = false;
        this.chart = config.chart;
        this.options = config.options;
        this.ctx = config.ctx;
        this.legendItems = undefined;
        this.columnSizes = undefined;
        this.lineWidths = undefined;
        this.maxHeight = undefined;
        this.maxWidth = undefined;
        this.top = undefined;
        this.bottom = undefined;
        this.left = undefined;
        this.right = undefined;
        this.height = undefined;
        this.width = undefined;
        this._margins = undefined;
        this.position = undefined;
        this.weight = undefined;
        this.fullSize = undefined;
    }
    update(maxWidth, maxHeight, margins) {
        const me = this;
        me.maxWidth = maxWidth;
        me.maxHeight = maxHeight;
        me._margins = margins;
        me.setDimensions();
        me.buildLabels();
        me.fit();
    }
    setDimensions() {
        const me = this;
        if (me.isHorizontal()) {
            me.width = me.maxWidth;
            me.left = me._margins.left;
            me.right = me.width;
        } else {
            me.height = me.maxHeight;
            me.top = me._margins.top;
            me.bottom = me.height;
        }
    }
    buildLabels() {
        const me = this;
        const labelOpts = me.options.labels || {};
        let legendItems = (0, $breCz.L)(labelOpts.generateLabels, [
            me.chart
        ], me) || [];
        if (labelOpts.filter) legendItems = legendItems.filter((item)=>labelOpts.filter(item, me.chart.data));
        if (labelOpts.sort) legendItems = legendItems.sort((a, b)=>labelOpts.sort(a, b, me.chart.data));
        if (me.options.reverse) legendItems.reverse();
        me.legendItems = legendItems;
    }
    fit() {
        const me = this;
        const { options: options, ctx: ctx } = me;
        if (!options.display) {
            me.width = me.height = 0;
            return;
        }
        const labelOpts = options.labels;
        const labelFont = (0, $breCz.W)(labelOpts.font);
        const fontSize = labelFont.size;
        const titleHeight = me._computeTitleHeight();
        const { boxWidth: boxWidth, itemHeight: itemHeight } = $4ffe47e38c59be9a$var$getBoxSize(labelOpts, fontSize);
        let width, height;
        ctx.font = labelFont.string;
        if (me.isHorizontal()) {
            width = me.maxWidth;
            height = me._fitRows(titleHeight, fontSize, boxWidth, itemHeight) + 10;
        } else {
            height = me.maxHeight;
            width = me._fitCols(titleHeight, fontSize, boxWidth, itemHeight) + 10;
        }
        me.width = Math.min(width, options.maxWidth || me.maxWidth);
        me.height = Math.min(height, options.maxHeight || me.maxHeight);
    }
    _fitRows(titleHeight, fontSize, boxWidth, itemHeight) {
        const me = this;
        const { ctx: ctx, maxWidth: maxWidth, options: { labels: { padding: padding } } } = me;
        const hitboxes = me.legendHitBoxes = [];
        const lineWidths = me.lineWidths = [
            0
        ];
        const lineHeight = itemHeight + padding;
        let totalHeight = titleHeight;
        ctx.textAlign = "left";
        ctx.textBaseline = "middle";
        let row = -1;
        let top = -lineHeight;
        me.legendItems.forEach((legendItem, i)=>{
            const itemWidth = boxWidth + fontSize / 2 + ctx.measureText(legendItem.text).width;
            if (i === 0 || lineWidths[lineWidths.length - 1] + itemWidth + 2 * padding > maxWidth) {
                totalHeight += lineHeight;
                lineWidths[lineWidths.length - (i > 0 ? 0 : 1)] = 0;
                top += lineHeight;
                row++;
            }
            hitboxes[i] = {
                left: 0,
                top: top,
                row: row,
                width: itemWidth,
                height: itemHeight
            };
            lineWidths[lineWidths.length - 1] += itemWidth + padding;
        });
        return totalHeight;
    }
    _fitCols(titleHeight, fontSize, boxWidth, itemHeight) {
        const me = this;
        const { ctx: ctx, maxHeight: maxHeight, options: { labels: { padding: padding } } } = me;
        const hitboxes = me.legendHitBoxes = [];
        const columnSizes = me.columnSizes = [];
        const heightLimit = maxHeight - titleHeight;
        let totalWidth = padding;
        let currentColWidth = 0;
        let currentColHeight = 0;
        let left = 0;
        let col = 0;
        me.legendItems.forEach((legendItem, i)=>{
            const itemWidth = boxWidth + fontSize / 2 + ctx.measureText(legendItem.text).width;
            if (i > 0 && currentColHeight + itemHeight + 2 * padding > heightLimit) {
                totalWidth += currentColWidth + padding;
                columnSizes.push({
                    width: currentColWidth,
                    height: currentColHeight
                });
                left += currentColWidth + padding;
                col++;
                currentColWidth = currentColHeight = 0;
            }
            hitboxes[i] = {
                left: left,
                top: currentColHeight,
                col: col,
                width: itemWidth,
                height: itemHeight
            };
            currentColWidth = Math.max(currentColWidth, itemWidth);
            currentColHeight += itemHeight + padding;
        });
        totalWidth += currentColWidth;
        columnSizes.push({
            width: currentColWidth,
            height: currentColHeight
        });
        return totalWidth;
    }
    adjustHitBoxes() {
        const me = this;
        if (!me.options.display) return;
        const titleHeight = me._computeTitleHeight();
        const { legendHitBoxes: hitboxes, options: { align: align, labels: { padding: padding }, rtl: rtl } } = me;
        if (this.isHorizontal()) {
            let row = 0;
            let left = (0, $breCz.Y)(align, me.left + padding, me.right - me.lineWidths[row]);
            for (const hitbox of hitboxes){
                if (row !== hitbox.row) {
                    row = hitbox.row;
                    left = (0, $breCz.Y)(align, me.left + padding, me.right - me.lineWidths[row]);
                }
                hitbox.top += me.top + titleHeight + padding;
                hitbox.left = left;
                left += hitbox.width + padding;
            }
            if (rtl) {
                const boxMap = hitboxes.reduce((map, box)=>{
                    map[box.row] = map[box.row] || [];
                    map[box.row].push(box);
                    return map;
                }, {});
                const newBoxes = [];
                Object.keys(boxMap).forEach((key)=>{
                    boxMap[key].reverse();
                    newBoxes.push(...boxMap[key]);
                });
                me.legendHitBoxes = newBoxes;
            }
        } else {
            let col = 0;
            let top = (0, $breCz.Y)(align, me.top + titleHeight + padding, me.bottom - me.columnSizes[col].height);
            for (const hitbox of hitboxes){
                if (hitbox.col !== col) {
                    col = hitbox.col;
                    top = (0, $breCz.Y)(align, me.top + titleHeight + padding, me.bottom - me.columnSizes[col].height);
                }
                hitbox.top = top;
                hitbox.left += me.left + padding;
                top += hitbox.height + padding;
            }
        }
    }
    isHorizontal() {
        return this.options.position === "top" || this.options.position === "bottom";
    }
    draw() {
        const me = this;
        if (me.options.display) {
            const ctx = me.ctx;
            (0, $breCz.S)(ctx, me);
            me._draw();
            (0, $breCz.V)(ctx);
        }
    }
    _draw() {
        const me = this;
        const { options: opts, columnSizes: columnSizes, lineWidths: lineWidths, ctx: ctx } = me;
        const { align: align, labels: labelOpts } = opts;
        const defaultColor = (0, $breCz.d).color;
        const rtlHelper = (0, $breCz.at)(opts.rtl, me.left, me.width);
        const labelFont = (0, $breCz.W)(labelOpts.font);
        const { color: fontColor, padding: padding } = labelOpts;
        const fontSize = labelFont.size;
        const halfFontSize = fontSize / 2;
        let cursor;
        me.drawTitle();
        ctx.textAlign = rtlHelper.textAlign("left");
        ctx.textBaseline = "middle";
        ctx.lineWidth = 0.5;
        ctx.font = labelFont.string;
        const { boxWidth: boxWidth, boxHeight: boxHeight, itemHeight: itemHeight } = $4ffe47e38c59be9a$var$getBoxSize(labelOpts, fontSize);
        const drawLegendBox = function(x, y, legendItem) {
            if (isNaN(boxWidth) || boxWidth <= 0 || isNaN(boxHeight) || boxHeight < 0) return;
            ctx.save();
            const lineWidth = (0, $breCz.v)(legendItem.lineWidth, 1);
            ctx.fillStyle = (0, $breCz.v)(legendItem.fillStyle, defaultColor);
            ctx.lineCap = (0, $breCz.v)(legendItem.lineCap, "butt");
            ctx.lineDashOffset = (0, $breCz.v)(legendItem.lineDashOffset, 0);
            ctx.lineJoin = (0, $breCz.v)(legendItem.lineJoin, "miter");
            ctx.lineWidth = lineWidth;
            ctx.strokeStyle = (0, $breCz.v)(legendItem.strokeStyle, defaultColor);
            ctx.setLineDash((0, $breCz.v)(legendItem.lineDash, []));
            if (labelOpts.usePointStyle) {
                const drawOptions = {
                    radius: boxWidth * Math.SQRT2 / 2,
                    pointStyle: legendItem.pointStyle,
                    rotation: legendItem.rotation,
                    borderWidth: lineWidth
                };
                const centerX = rtlHelper.xPlus(x, boxWidth / 2);
                const centerY = y + halfFontSize;
                (0, $breCz.an)(ctx, drawOptions, centerX, centerY);
            } else {
                const yBoxTop = y + Math.max((fontSize - boxHeight) / 2, 0);
                const xBoxLeft = rtlHelper.leftForLtr(x, boxWidth);
                const borderRadius = (0, $breCz.aq)(legendItem.borderRadius);
                ctx.beginPath();
                if (Object.values(borderRadius).some((v)=>v !== 0)) (0, $breCz.ao)(ctx, {
                    x: xBoxLeft,
                    y: yBoxTop,
                    w: boxWidth,
                    h: boxHeight,
                    radius: borderRadius
                });
                else ctx.rect(xBoxLeft, yBoxTop, boxWidth, boxHeight);
                ctx.fill();
                if (lineWidth !== 0) ctx.stroke();
            }
            ctx.restore();
        };
        const fillText = function(x, y, legendItem) {
            (0, $breCz.U)(ctx, legendItem.text, x, y + itemHeight / 2, labelFont, {
                strikethrough: legendItem.hidden,
                textAlign: rtlHelper.textAlign(legendItem.textAlign)
            });
        };
        const isHorizontal = me.isHorizontal();
        const titleHeight = this._computeTitleHeight();
        if (isHorizontal) cursor = {
            x: (0, $breCz.Y)(align, me.left + padding, me.right - lineWidths[0]),
            y: me.top + padding + titleHeight,
            line: 0
        };
        else cursor = {
            x: me.left + padding,
            y: (0, $breCz.Y)(align, me.top + titleHeight + padding, me.bottom - columnSizes[0].height),
            line: 0
        };
        (0, $breCz.au)(me.ctx, opts.textDirection);
        const lineHeight = itemHeight + padding;
        me.legendItems.forEach((legendItem, i)=>{
            ctx.strokeStyle = legendItem.fontColor || fontColor;
            ctx.fillStyle = legendItem.fontColor || fontColor;
            const textWidth = ctx.measureText(legendItem.text).width;
            const textAlign = rtlHelper.textAlign(legendItem.textAlign || (legendItem.textAlign = labelOpts.textAlign));
            const width = boxWidth + halfFontSize + textWidth;
            let x = cursor.x;
            let y = cursor.y;
            rtlHelper.setWidth(me.width);
            if (isHorizontal) {
                if (i > 0 && x + width + padding > me.right) {
                    y = cursor.y += lineHeight;
                    cursor.line++;
                    x = cursor.x = (0, $breCz.Y)(align, me.left + padding, me.right - lineWidths[cursor.line]);
                }
            } else if (i > 0 && y + lineHeight > me.bottom) {
                x = cursor.x = x + columnSizes[cursor.line].width + padding;
                cursor.line++;
                y = cursor.y = (0, $breCz.Y)(align, me.top + titleHeight + padding, me.bottom - columnSizes[cursor.line].height);
            }
            const realX = rtlHelper.x(x);
            drawLegendBox(realX, y, legendItem);
            x = (0, $breCz.av)(textAlign, x + boxWidth + halfFontSize, isHorizontal ? x + width : me.right, opts.rtl);
            fillText(rtlHelper.x(x), y, legendItem);
            if (isHorizontal) cursor.x += width + padding;
            else cursor.y += lineHeight;
        });
        (0, $breCz.aw)(me.ctx, opts.textDirection);
    }
    drawTitle() {
        const me = this;
        const opts = me.options;
        const titleOpts = opts.title;
        const titleFont = (0, $breCz.W)(titleOpts.font);
        const titlePadding = (0, $breCz.A)(titleOpts.padding);
        if (!titleOpts.display) return;
        const rtlHelper = (0, $breCz.at)(opts.rtl, me.left, me.width);
        const ctx = me.ctx;
        const position = titleOpts.position;
        const halfFontSize = titleFont.size / 2;
        const topPaddingPlusHalfFontSize = titlePadding.top + halfFontSize;
        let y;
        let left = me.left;
        let maxWidth = me.width;
        if (this.isHorizontal()) {
            maxWidth = Math.max(...me.lineWidths);
            y = me.top + topPaddingPlusHalfFontSize;
            left = (0, $breCz.Y)(opts.align, left, me.right - maxWidth);
        } else {
            const maxHeight = me.columnSizes.reduce((acc, size)=>Math.max(acc, size.height), 0);
            y = topPaddingPlusHalfFontSize + (0, $breCz.Y)(opts.align, me.top, me.bottom - maxHeight - opts.labels.padding - me._computeTitleHeight());
        }
        const x = (0, $breCz.Y)(position, left, left + maxWidth);
        ctx.textAlign = rtlHelper.textAlign((0, $breCz.X)(position));
        ctx.textBaseline = "middle";
        ctx.strokeStyle = titleOpts.color;
        ctx.fillStyle = titleOpts.color;
        ctx.font = titleFont.string;
        (0, $breCz.U)(ctx, titleOpts.text, x, y, titleFont);
    }
    _computeTitleHeight() {
        const titleOpts = this.options.title;
        const titleFont = (0, $breCz.W)(titleOpts.font);
        const titlePadding = (0, $breCz.A)(titleOpts.padding);
        return titleOpts.display ? titleFont.lineHeight + titlePadding.height : 0;
    }
    _getLegendItemAt(x, y) {
        const me = this;
        let i, hitBox, lh;
        if (x >= me.left && x <= me.right && y >= me.top && y <= me.bottom) {
            lh = me.legendHitBoxes;
            for(i = 0; i < lh.length; ++i){
                hitBox = lh[i];
                if (x >= hitBox.left && x <= hitBox.left + hitBox.width && y >= hitBox.top && y <= hitBox.top + hitBox.height) return me.legendItems[i];
            }
        }
        return null;
    }
    handleEvent(e) {
        const me = this;
        const opts = me.options;
        if (!$4ffe47e38c59be9a$var$isListened(e.type, opts)) return;
        const hoveredItem = me._getLegendItemAt(e.x, e.y);
        if (e.type === "mousemove") {
            const previous = me._hoveredItem;
            const sameItem = $4ffe47e38c59be9a$var$itemsEqual(previous, hoveredItem);
            if (previous && !sameItem) (0, $breCz.L)(opts.onLeave, [
                e,
                previous,
                me
            ], me);
            me._hoveredItem = hoveredItem;
            if (hoveredItem && !sameItem) (0, $breCz.L)(opts.onHover, [
                e,
                hoveredItem,
                me
            ], me);
        } else if (hoveredItem) (0, $breCz.L)(opts.onClick, [
            e,
            hoveredItem,
            me
        ], me);
    }
}
function $4ffe47e38c59be9a$var$isListened(type, opts) {
    if (type === "mousemove" && (opts.onHover || opts.onLeave)) return true;
    if (opts.onClick && (type === "click" || type === "mouseup")) return true;
    return false;
}
var $4ffe47e38c59be9a$export$ed247974535929c7 = {
    id: "legend",
    _element: $4ffe47e38c59be9a$var$Legend,
    start (chart, _args, options) {
        const legend = chart.legend = new $4ffe47e38c59be9a$var$Legend({
            ctx: chart.ctx,
            options: options,
            chart: chart
        });
        $4ffe47e38c59be9a$export$1ecca0613f5e56d2.configure(chart, legend, options);
        $4ffe47e38c59be9a$export$1ecca0613f5e56d2.addBox(chart, legend);
    },
    stop (chart) {
        $4ffe47e38c59be9a$export$1ecca0613f5e56d2.removeBox(chart, chart.legend);
        delete chart.legend;
    },
    beforeUpdate (chart, _args, options) {
        const legend = chart.legend;
        $4ffe47e38c59be9a$export$1ecca0613f5e56d2.configure(chart, legend, options);
        legend.options = options;
    },
    afterUpdate (chart) {
        const legend = chart.legend;
        legend.buildLabels();
        legend.adjustHitBoxes();
    },
    afterEvent (chart, args) {
        if (!args.replay) chart.legend.handleEvent(args.event);
    },
    defaults: {
        display: true,
        position: "top",
        align: "center",
        fullSize: true,
        reverse: false,
        weight: 1000,
        onClick (e, legendItem, legend) {
            const index = legendItem.datasetIndex;
            const ci = legend.chart;
            if (ci.isDatasetVisible(index)) {
                ci.hide(index);
                legendItem.hidden = true;
            } else {
                ci.show(index);
                legendItem.hidden = false;
            }
        },
        onHover: null,
        onLeave: null,
        labels: {
            color: (ctx)=>ctx.chart.options.color,
            boxWidth: 40,
            padding: 10,
            generateLabels (chart) {
                const datasets = chart.data.datasets;
                const { labels: { usePointStyle: usePointStyle, pointStyle: pointStyle, textAlign: textAlign, color: color } } = chart.legend.options;
                return chart._getSortedDatasetMetas().map((meta)=>{
                    const style = meta.controller.getStyle(usePointStyle ? 0 : undefined);
                    const borderWidth = (0, $breCz.A)(style.borderWidth);
                    return {
                        text: datasets[meta.index].label,
                        fillStyle: style.backgroundColor,
                        fontColor: color,
                        hidden: !meta.visible,
                        lineCap: style.borderCapStyle,
                        lineDash: style.borderDash,
                        lineDashOffset: style.borderDashOffset,
                        lineJoin: style.borderJoinStyle,
                        lineWidth: (borderWidth.width + borderWidth.height) / 4,
                        strokeStyle: style.borderColor,
                        pointStyle: pointStyle || style.pointStyle,
                        rotation: style.rotation,
                        textAlign: textAlign || style.textAlign,
                        borderRadius: 0,
                        datasetIndex: meta.index
                    };
                }, this);
            }
        },
        title: {
            color: (ctx)=>ctx.chart.options.color,
            display: false,
            position: "center",
            text: ""
        }
    },
    descriptors: {
        _scriptable: (name)=>!name.startsWith("on"),
        labels: {
            _scriptable: (name)=>![
                    "generateLabels",
                    "filter",
                    "sort"
                ].includes(name)
        }
    }
};
class $4ffe47e38c59be9a$var$Title extends $4ffe47e38c59be9a$export$db77ccec0bb4ccac {
    constructor(config){
        super();
        this.chart = config.chart;
        this.options = config.options;
        this.ctx = config.ctx;
        this._padding = undefined;
        this.top = undefined;
        this.bottom = undefined;
        this.left = undefined;
        this.right = undefined;
        this.width = undefined;
        this.height = undefined;
        this.position = undefined;
        this.weight = undefined;
        this.fullSize = undefined;
    }
    update(maxWidth, maxHeight) {
        const me = this;
        const opts = me.options;
        me.left = 0;
        me.top = 0;
        if (!opts.display) {
            me.width = me.height = me.right = me.bottom = 0;
            return;
        }
        me.width = me.right = maxWidth;
        me.height = me.bottom = maxHeight;
        const lineCount = (0, $breCz.b)(opts.text) ? opts.text.length : 1;
        me._padding = (0, $breCz.A)(opts.padding);
        const textSize = lineCount * (0, $breCz.W)(opts.font).lineHeight + me._padding.height;
        if (me.isHorizontal()) me.height = textSize;
        else me.width = textSize;
    }
    isHorizontal() {
        const pos = this.options.position;
        return pos === "top" || pos === "bottom";
    }
    _drawArgs(offset) {
        const { top: top, left: left, bottom: bottom, right: right, options: options } = this;
        const align = options.align;
        let rotation = 0;
        let maxWidth, titleX, titleY;
        if (this.isHorizontal()) {
            titleX = (0, $breCz.Y)(align, left, right);
            titleY = top + offset;
            maxWidth = right - left;
        } else {
            if (options.position === "left") {
                titleX = left + offset;
                titleY = (0, $breCz.Y)(align, bottom, top);
                rotation = (0, $breCz.P) * -0.5;
            } else {
                titleX = right - offset;
                titleY = (0, $breCz.Y)(align, top, bottom);
                rotation = (0, $breCz.P) * 0.5;
            }
            maxWidth = bottom - top;
        }
        return {
            titleX: titleX,
            titleY: titleY,
            maxWidth: maxWidth,
            rotation: rotation
        };
    }
    draw() {
        const me = this;
        const ctx = me.ctx;
        const opts = me.options;
        if (!opts.display) return;
        const fontOpts = (0, $breCz.W)(opts.font);
        const lineHeight = fontOpts.lineHeight;
        const offset = lineHeight / 2 + me._padding.top;
        const { titleX: titleX, titleY: titleY, maxWidth: maxWidth, rotation: rotation } = me._drawArgs(offset);
        (0, $breCz.U)(ctx, opts.text, 0, 0, fontOpts, {
            color: opts.color,
            maxWidth: maxWidth,
            rotation: rotation,
            textAlign: (0, $breCz.X)(opts.align),
            textBaseline: "middle",
            translation: [
                titleX,
                titleY
            ]
        });
    }
}
function $4ffe47e38c59be9a$var$createTitle(chart, titleOpts) {
    const title = new $4ffe47e38c59be9a$var$Title({
        ctx: chart.ctx,
        options: titleOpts,
        chart: chart
    });
    $4ffe47e38c59be9a$export$1ecca0613f5e56d2.configure(chart, title, titleOpts);
    $4ffe47e38c59be9a$export$1ecca0613f5e56d2.addBox(chart, title);
    chart.titleBlock = title;
}
var $4ffe47e38c59be9a$export$f99233281efd08a0 = {
    id: "title",
    _element: $4ffe47e38c59be9a$var$Title,
    start (chart, _args, options) {
        $4ffe47e38c59be9a$var$createTitle(chart, options);
    },
    stop (chart) {
        const titleBlock = chart.titleBlock;
        $4ffe47e38c59be9a$export$1ecca0613f5e56d2.removeBox(chart, titleBlock);
        delete chart.titleBlock;
    },
    beforeUpdate (chart, _args, options) {
        const title = chart.titleBlock;
        $4ffe47e38c59be9a$export$1ecca0613f5e56d2.configure(chart, title, options);
        title.options = options;
    },
    defaults: {
        align: "center",
        display: false,
        font: {
            weight: "bold"
        },
        fullSize: true,
        padding: 10,
        position: "top",
        text: "",
        weight: 2000
    },
    defaultRoutes: {
        color: "color"
    },
    descriptors: {
        _scriptable: true,
        _indexable: false
    }
};
const $4ffe47e38c59be9a$var$map = new WeakMap();
var $4ffe47e38c59be9a$export$d5c56664638992a4 = {
    id: "subtitle",
    start (chart, _args, options) {
        const title = new $4ffe47e38c59be9a$var$Title({
            ctx: chart.ctx,
            options: options,
            chart: chart
        });
        $4ffe47e38c59be9a$export$1ecca0613f5e56d2.configure(chart, title, options);
        $4ffe47e38c59be9a$export$1ecca0613f5e56d2.addBox(chart, title);
        $4ffe47e38c59be9a$var$map.set(chart, title);
    },
    stop (chart) {
        $4ffe47e38c59be9a$export$1ecca0613f5e56d2.removeBox(chart, $4ffe47e38c59be9a$var$map.get(chart));
        $4ffe47e38c59be9a$var$map.delete(chart);
    },
    beforeUpdate (chart, _args, options) {
        const title = $4ffe47e38c59be9a$var$map.get(chart);
        $4ffe47e38c59be9a$export$1ecca0613f5e56d2.configure(chart, title, options);
        title.options = options;
    },
    defaults: {
        align: "center",
        display: false,
        font: {
            weight: "normal"
        },
        fullSize: true,
        padding: 0,
        position: "top",
        text: "",
        weight: 1500
    },
    defaultRoutes: {
        color: "color"
    },
    descriptors: {
        _scriptable: true,
        _indexable: false
    }
};
const $4ffe47e38c59be9a$var$positioners = {
    average (items) {
        if (!items.length) return false;
        let i, len;
        let x = 0;
        let y = 0;
        let count = 0;
        for(i = 0, len = items.length; i < len; ++i){
            const el = items[i].element;
            if (el && el.hasValue()) {
                const pos = el.tooltipPosition();
                x += pos.x;
                y += pos.y;
                ++count;
            }
        }
        return {
            x: x / count,
            y: y / count
        };
    },
    nearest (items, eventPosition) {
        if (!items.length) return false;
        let x = eventPosition.x;
        let y = eventPosition.y;
        let minDistance = Number.POSITIVE_INFINITY;
        let i, len, nearestElement;
        for(i = 0, len = items.length; i < len; ++i){
            const el = items[i].element;
            if (el && el.hasValue()) {
                const center = el.getCenterPoint();
                const d = (0, $breCz.ay)(eventPosition, center);
                if (d < minDistance) {
                    minDistance = d;
                    nearestElement = el;
                }
            }
        }
        if (nearestElement) {
            const tp = nearestElement.tooltipPosition();
            x = tp.x;
            y = tp.y;
        }
        return {
            x: x,
            y: y
        };
    }
};
function $4ffe47e38c59be9a$var$pushOrConcat(base, toPush) {
    if (toPush) {
        if ((0, $breCz.b)(toPush)) Array.prototype.push.apply(base, toPush);
        else base.push(toPush);
    }
    return base;
}
function $4ffe47e38c59be9a$var$splitNewlines(str) {
    if ((typeof str === "string" || str instanceof String) && str.indexOf("\n") > -1) return str.split("\n");
    return str;
}
function $4ffe47e38c59be9a$var$createTooltipItem(chart, item) {
    const { element: element, datasetIndex: datasetIndex, index: index } = item;
    const controller = chart.getDatasetMeta(datasetIndex).controller;
    const { label: label, value: value } = controller.getLabelAndValue(index);
    return {
        chart: chart,
        label: label,
        parsed: controller.getParsed(index),
        raw: chart.data.datasets[datasetIndex].data[index],
        formattedValue: value,
        dataset: controller.getDataset(),
        dataIndex: index,
        datasetIndex: datasetIndex,
        element: element
    };
}
function $4ffe47e38c59be9a$var$getTooltipSize(tooltip, options) {
    const ctx = tooltip._chart.ctx;
    const { body: body, footer: footer, title: title } = tooltip;
    const { boxWidth: boxWidth, boxHeight: boxHeight } = options;
    const bodyFont = (0, $breCz.W)(options.bodyFont);
    const titleFont = (0, $breCz.W)(options.titleFont);
    const footerFont = (0, $breCz.W)(options.footerFont);
    const titleLineCount = title.length;
    const footerLineCount = footer.length;
    const bodyLineItemCount = body.length;
    const padding = (0, $breCz.A)(options.padding);
    let height = padding.height;
    let width = 0;
    let combinedBodyLength = body.reduce((count, bodyItem)=>count + bodyItem.before.length + bodyItem.lines.length + bodyItem.after.length, 0);
    combinedBodyLength += tooltip.beforeBody.length + tooltip.afterBody.length;
    if (titleLineCount) height += titleLineCount * titleFont.lineHeight + (titleLineCount - 1) * options.titleSpacing + options.titleMarginBottom;
    if (combinedBodyLength) {
        const bodyLineHeight = options.displayColors ? Math.max(boxHeight, bodyFont.lineHeight) : bodyFont.lineHeight;
        height += bodyLineItemCount * bodyLineHeight + (combinedBodyLength - bodyLineItemCount) * bodyFont.lineHeight + (combinedBodyLength - 1) * options.bodySpacing;
    }
    if (footerLineCount) height += options.footerMarginTop + footerLineCount * footerFont.lineHeight + (footerLineCount - 1) * options.footerSpacing;
    let widthPadding = 0;
    const maxLineWidth = function(line) {
        width = Math.max(width, ctx.measureText(line).width + widthPadding);
    };
    ctx.save();
    ctx.font = titleFont.string;
    (0, $breCz.B)(tooltip.title, maxLineWidth);
    ctx.font = bodyFont.string;
    (0, $breCz.B)(tooltip.beforeBody.concat(tooltip.afterBody), maxLineWidth);
    widthPadding = options.displayColors ? boxWidth + 2 : 0;
    (0, $breCz.B)(body, (bodyItem)=>{
        (0, $breCz.B)(bodyItem.before, maxLineWidth);
        (0, $breCz.B)(bodyItem.lines, maxLineWidth);
        (0, $breCz.B)(bodyItem.after, maxLineWidth);
    });
    widthPadding = 0;
    ctx.font = footerFont.string;
    (0, $breCz.B)(tooltip.footer, maxLineWidth);
    ctx.restore();
    width += padding.width;
    return {
        width: width,
        height: height
    };
}
function $4ffe47e38c59be9a$var$determineYAlign(chart, size) {
    const { y: y, height: height } = size;
    if (y < height / 2) return "top";
    else if (y > chart.height - height / 2) return "bottom";
    return "center";
}
function $4ffe47e38c59be9a$var$doesNotFitWithAlign(xAlign, chart, options, size) {
    const { x: x, width: width } = size;
    const caret = options.caretSize + options.caretPadding;
    if (xAlign === "left" && x + width + caret > chart.width) return true;
    if (xAlign === "right" && x - width - caret < 0) return true;
}
function $4ffe47e38c59be9a$var$determineXAlign(chart, options, size, yAlign) {
    const { x: x, width: width } = size;
    const { width: chartWidth, chartArea: { left: left, right: right } } = chart;
    let xAlign = "center";
    if (yAlign === "center") xAlign = x <= (left + right) / 2 ? "left" : "right";
    else if (x <= width / 2) xAlign = "left";
    else if (x >= chartWidth - width / 2) xAlign = "right";
    if ($4ffe47e38c59be9a$var$doesNotFitWithAlign(xAlign, chart, options, size)) xAlign = "center";
    return xAlign;
}
function $4ffe47e38c59be9a$var$determineAlignment(chart, options, size) {
    const yAlign = options.yAlign || $4ffe47e38c59be9a$var$determineYAlign(chart, size);
    return {
        xAlign: options.xAlign || $4ffe47e38c59be9a$var$determineXAlign(chart, options, size, yAlign),
        yAlign: yAlign
    };
}
function $4ffe47e38c59be9a$var$alignX(size, xAlign) {
    let { x: x, width: width } = size;
    if (xAlign === "right") x -= width;
    else if (xAlign === "center") x -= width / 2;
    return x;
}
function $4ffe47e38c59be9a$var$alignY(size, yAlign, paddingAndSize) {
    let { y: y, height: height } = size;
    if (yAlign === "top") y += paddingAndSize;
    else if (yAlign === "bottom") y -= height + paddingAndSize;
    else y -= height / 2;
    return y;
}
function $4ffe47e38c59be9a$var$getBackgroundPoint(options, size, alignment, chart) {
    const { caretSize: caretSize, caretPadding: caretPadding, cornerRadius: cornerRadius } = options;
    const { xAlign: xAlign, yAlign: yAlign } = alignment;
    const paddingAndSize = caretSize + caretPadding;
    const radiusAndPadding = cornerRadius + caretPadding;
    let x = $4ffe47e38c59be9a$var$alignX(size, xAlign);
    const y = $4ffe47e38c59be9a$var$alignY(size, yAlign, paddingAndSize);
    if (yAlign === "center") {
        if (xAlign === "left") x += paddingAndSize;
        else if (xAlign === "right") x -= paddingAndSize;
    } else if (xAlign === "left") x -= radiusAndPadding;
    else if (xAlign === "right") x += radiusAndPadding;
    return {
        x: (0, $breCz.q)(x, 0, chart.width - size.width),
        y: (0, $breCz.q)(y, 0, chart.height - size.height)
    };
}
function $4ffe47e38c59be9a$var$getAlignedX(tooltip, align, options) {
    const padding = (0, $breCz.A)(options.padding);
    return align === "center" ? tooltip.x + tooltip.width / 2 : align === "right" ? tooltip.x + tooltip.width - padding.right : tooltip.x + padding.left;
}
function $4ffe47e38c59be9a$var$getBeforeAfterBodyLines(callback) {
    return $4ffe47e38c59be9a$var$pushOrConcat([], $4ffe47e38c59be9a$var$splitNewlines(callback));
}
function $4ffe47e38c59be9a$var$createTooltipContext(parent, tooltip, tooltipItems) {
    return Object.assign(Object.create(parent), {
        tooltip: tooltip,
        tooltipItems: tooltipItems,
        type: "tooltip"
    });
}
function $4ffe47e38c59be9a$var$overrideCallbacks(callbacks, context) {
    const override = context && context.dataset && context.dataset.tooltip && context.dataset.tooltip.callbacks;
    return override ? callbacks.override(override) : callbacks;
}
class $4ffe47e38c59be9a$var$Tooltip extends $4ffe47e38c59be9a$export$db77ccec0bb4ccac {
    constructor(config){
        super();
        this.opacity = 0;
        this._active = [];
        this._chart = config._chart;
        this._eventPosition = undefined;
        this._size = undefined;
        this._cachedAnimations = undefined;
        this._tooltipItems = [];
        this.$animations = undefined;
        this.$context = undefined;
        this.options = config.options;
        this.dataPoints = undefined;
        this.title = undefined;
        this.beforeBody = undefined;
        this.body = undefined;
        this.afterBody = undefined;
        this.footer = undefined;
        this.xAlign = undefined;
        this.yAlign = undefined;
        this.x = undefined;
        this.y = undefined;
        this.height = undefined;
        this.width = undefined;
        this.caretX = undefined;
        this.caretY = undefined;
        this.labelColors = undefined;
        this.labelPointStyles = undefined;
        this.labelTextColors = undefined;
    }
    initialize(options) {
        this.options = options;
        this._cachedAnimations = undefined;
        this.$context = undefined;
    }
    _resolveAnimations() {
        const me = this;
        const cached = me._cachedAnimations;
        if (cached) return cached;
        const chart = me._chart;
        const options = me.options.setContext(me.getContext());
        const opts = options.enabled && chart.options.animation && options.animations;
        const animations = new $4ffe47e38c59be9a$export$8ab227dac26677d(me._chart, opts);
        if (opts._cacheable) me._cachedAnimations = Object.freeze(animations);
        return animations;
    }
    getContext() {
        const me = this;
        return me.$context || (me.$context = $4ffe47e38c59be9a$var$createTooltipContext(me._chart.getContext(), me, me._tooltipItems));
    }
    getTitle(context, options) {
        const me = this;
        const { callbacks: callbacks } = options;
        const beforeTitle = callbacks.beforeTitle.apply(me, [
            context
        ]);
        const title = callbacks.title.apply(me, [
            context
        ]);
        const afterTitle = callbacks.afterTitle.apply(me, [
            context
        ]);
        let lines = [];
        lines = $4ffe47e38c59be9a$var$pushOrConcat(lines, $4ffe47e38c59be9a$var$splitNewlines(beforeTitle));
        lines = $4ffe47e38c59be9a$var$pushOrConcat(lines, $4ffe47e38c59be9a$var$splitNewlines(title));
        lines = $4ffe47e38c59be9a$var$pushOrConcat(lines, $4ffe47e38c59be9a$var$splitNewlines(afterTitle));
        return lines;
    }
    getBeforeBody(tooltipItems, options) {
        return $4ffe47e38c59be9a$var$getBeforeAfterBodyLines(options.callbacks.beforeBody.apply(this, [
            tooltipItems
        ]));
    }
    getBody(tooltipItems, options) {
        const me = this;
        const { callbacks: callbacks } = options;
        const bodyItems = [];
        (0, $breCz.B)(tooltipItems, (context)=>{
            const bodyItem = {
                before: [],
                lines: [],
                after: []
            };
            const scoped = $4ffe47e38c59be9a$var$overrideCallbacks(callbacks, context);
            $4ffe47e38c59be9a$var$pushOrConcat(bodyItem.before, $4ffe47e38c59be9a$var$splitNewlines(scoped.beforeLabel.call(me, context)));
            $4ffe47e38c59be9a$var$pushOrConcat(bodyItem.lines, scoped.label.call(me, context));
            $4ffe47e38c59be9a$var$pushOrConcat(bodyItem.after, $4ffe47e38c59be9a$var$splitNewlines(scoped.afterLabel.call(me, context)));
            bodyItems.push(bodyItem);
        });
        return bodyItems;
    }
    getAfterBody(tooltipItems, options) {
        return $4ffe47e38c59be9a$var$getBeforeAfterBodyLines(options.callbacks.afterBody.apply(this, [
            tooltipItems
        ]));
    }
    getFooter(tooltipItems, options) {
        const me = this;
        const { callbacks: callbacks } = options;
        const beforeFooter = callbacks.beforeFooter.apply(me, [
            tooltipItems
        ]);
        const footer = callbacks.footer.apply(me, [
            tooltipItems
        ]);
        const afterFooter = callbacks.afterFooter.apply(me, [
            tooltipItems
        ]);
        let lines = [];
        lines = $4ffe47e38c59be9a$var$pushOrConcat(lines, $4ffe47e38c59be9a$var$splitNewlines(beforeFooter));
        lines = $4ffe47e38c59be9a$var$pushOrConcat(lines, $4ffe47e38c59be9a$var$splitNewlines(footer));
        lines = $4ffe47e38c59be9a$var$pushOrConcat(lines, $4ffe47e38c59be9a$var$splitNewlines(afterFooter));
        return lines;
    }
    _createItems(options) {
        const me = this;
        const active = me._active;
        const data = me._chart.data;
        const labelColors = [];
        const labelPointStyles = [];
        const labelTextColors = [];
        let tooltipItems = [];
        let i, len;
        for(i = 0, len = active.length; i < len; ++i)tooltipItems.push($4ffe47e38c59be9a$var$createTooltipItem(me._chart, active[i]));
        if (options.filter) tooltipItems = tooltipItems.filter((element, index, array)=>options.filter(element, index, array, data));
        if (options.itemSort) tooltipItems = tooltipItems.sort((a, b)=>options.itemSort(a, b, data));
        (0, $breCz.B)(tooltipItems, (context)=>{
            const scoped = $4ffe47e38c59be9a$var$overrideCallbacks(options.callbacks, context);
            labelColors.push(scoped.labelColor.call(me, context));
            labelPointStyles.push(scoped.labelPointStyle.call(me, context));
            labelTextColors.push(scoped.labelTextColor.call(me, context));
        });
        me.labelColors = labelColors;
        me.labelPointStyles = labelPointStyles;
        me.labelTextColors = labelTextColors;
        me.dataPoints = tooltipItems;
        return tooltipItems;
    }
    update(changed, replay) {
        const me = this;
        const options = me.options.setContext(me.getContext());
        const active = me._active;
        let properties;
        let tooltipItems = [];
        if (!active.length) {
            if (me.opacity !== 0) properties = {
                opacity: 0
            };
        } else {
            const position = $4ffe47e38c59be9a$var$positioners[options.position].call(me, active, me._eventPosition);
            tooltipItems = me._createItems(options);
            me.title = me.getTitle(tooltipItems, options);
            me.beforeBody = me.getBeforeBody(tooltipItems, options);
            me.body = me.getBody(tooltipItems, options);
            me.afterBody = me.getAfterBody(tooltipItems, options);
            me.footer = me.getFooter(tooltipItems, options);
            const size = me._size = $4ffe47e38c59be9a$var$getTooltipSize(me, options);
            const positionAndSize = Object.assign({}, position, size);
            const alignment = $4ffe47e38c59be9a$var$determineAlignment(me._chart, options, positionAndSize);
            const backgroundPoint = $4ffe47e38c59be9a$var$getBackgroundPoint(options, positionAndSize, alignment, me._chart);
            me.xAlign = alignment.xAlign;
            me.yAlign = alignment.yAlign;
            properties = {
                opacity: 1,
                x: backgroundPoint.x,
                y: backgroundPoint.y,
                width: size.width,
                height: size.height,
                caretX: position.x,
                caretY: position.y
            };
        }
        me._tooltipItems = tooltipItems;
        me.$context = undefined;
        if (properties) me._resolveAnimations().update(me, properties);
        if (changed && options.external) options.external.call(me, {
            chart: me._chart,
            tooltip: me,
            replay: replay
        });
    }
    drawCaret(tooltipPoint, ctx, size, options) {
        const caretPosition = this.getCaretPosition(tooltipPoint, size, options);
        ctx.lineTo(caretPosition.x1, caretPosition.y1);
        ctx.lineTo(caretPosition.x2, caretPosition.y2);
        ctx.lineTo(caretPosition.x3, caretPosition.y3);
    }
    getCaretPosition(tooltipPoint, size, options) {
        const { xAlign: xAlign, yAlign: yAlign } = this;
        const { cornerRadius: cornerRadius, caretSize: caretSize } = options;
        const { x: ptX, y: ptY } = tooltipPoint;
        const { width: width, height: height } = size;
        let x1, x2, x3, y1, y2, y3;
        if (yAlign === "center") {
            y2 = ptY + height / 2;
            if (xAlign === "left") {
                x1 = ptX;
                x2 = x1 - caretSize;
                y1 = y2 + caretSize;
                y3 = y2 - caretSize;
            } else {
                x1 = ptX + width;
                x2 = x1 + caretSize;
                y1 = y2 - caretSize;
                y3 = y2 + caretSize;
            }
            x3 = x1;
        } else {
            if (xAlign === "left") x2 = ptX + cornerRadius + caretSize;
            else if (xAlign === "right") x2 = ptX + width - cornerRadius - caretSize;
            else x2 = this.caretX;
            if (yAlign === "top") {
                y1 = ptY;
                y2 = y1 - caretSize;
                x1 = x2 - caretSize;
                x3 = x2 + caretSize;
            } else {
                y1 = ptY + height;
                y2 = y1 + caretSize;
                x1 = x2 + caretSize;
                x3 = x2 - caretSize;
            }
            y3 = y1;
        }
        return {
            x1: x1,
            x2: x2,
            x3: x3,
            y1: y1,
            y2: y2,
            y3: y3
        };
    }
    drawTitle(pt, ctx, options) {
        const me = this;
        const title = me.title;
        const length = title.length;
        let titleFont, titleSpacing, i;
        if (length) {
            const rtlHelper = (0, $breCz.at)(options.rtl, me.x, me.width);
            pt.x = $4ffe47e38c59be9a$var$getAlignedX(me, options.titleAlign, options);
            ctx.textAlign = rtlHelper.textAlign(options.titleAlign);
            ctx.textBaseline = "middle";
            titleFont = (0, $breCz.W)(options.titleFont);
            titleSpacing = options.titleSpacing;
            ctx.fillStyle = options.titleColor;
            ctx.font = titleFont.string;
            for(i = 0; i < length; ++i){
                ctx.fillText(title[i], rtlHelper.x(pt.x), pt.y + titleFont.lineHeight / 2);
                pt.y += titleFont.lineHeight + titleSpacing;
                if (i + 1 === length) pt.y += options.titleMarginBottom - titleSpacing;
            }
        }
    }
    _drawColorBox(ctx, pt, i, rtlHelper, options) {
        const me = this;
        const labelColors = me.labelColors[i];
        const labelPointStyle = me.labelPointStyles[i];
        const { boxHeight: boxHeight, boxWidth: boxWidth } = options;
        const bodyFont = (0, $breCz.W)(options.bodyFont);
        const colorX = $4ffe47e38c59be9a$var$getAlignedX(me, "left", options);
        const rtlColorX = rtlHelper.x(colorX);
        const yOffSet = boxHeight < bodyFont.lineHeight ? (bodyFont.lineHeight - boxHeight) / 2 : 0;
        const colorY = pt.y + yOffSet;
        if (options.usePointStyle) {
            const drawOptions = {
                radius: Math.min(boxWidth, boxHeight) / 2,
                pointStyle: labelPointStyle.pointStyle,
                rotation: labelPointStyle.rotation,
                borderWidth: 1
            };
            const centerX = rtlHelper.leftForLtr(rtlColorX, boxWidth) + boxWidth / 2;
            const centerY = colorY + boxHeight / 2;
            ctx.strokeStyle = options.multiKeyBackground;
            ctx.fillStyle = options.multiKeyBackground;
            (0, $breCz.an)(ctx, drawOptions, centerX, centerY);
            ctx.strokeStyle = labelColors.borderColor;
            ctx.fillStyle = labelColors.backgroundColor;
            (0, $breCz.an)(ctx, drawOptions, centerX, centerY);
        } else {
            ctx.lineWidth = labelColors.borderWidth || 1;
            ctx.strokeStyle = labelColors.borderColor;
            ctx.setLineDash(labelColors.borderDash || []);
            ctx.lineDashOffset = labelColors.borderDashOffset || 0;
            const outerX = rtlHelper.leftForLtr(rtlColorX, boxWidth);
            const innerX = rtlHelper.leftForLtr(rtlHelper.xPlus(rtlColorX, 1), boxWidth - 2);
            const borderRadius = (0, $breCz.aq)(labelColors.borderRadius);
            if (Object.values(borderRadius).some((v)=>v !== 0)) {
                ctx.beginPath();
                ctx.fillStyle = options.multiKeyBackground;
                (0, $breCz.ao)(ctx, {
                    x: outerX,
                    y: colorY,
                    w: boxWidth,
                    h: boxHeight,
                    radius: borderRadius
                });
                ctx.fill();
                ctx.stroke();
                ctx.fillStyle = labelColors.backgroundColor;
                ctx.beginPath();
                (0, $breCz.ao)(ctx, {
                    x: innerX,
                    y: colorY + 1,
                    w: boxWidth - 2,
                    h: boxHeight - 2,
                    radius: borderRadius
                });
                ctx.fill();
            } else {
                ctx.fillStyle = options.multiKeyBackground;
                ctx.fillRect(outerX, colorY, boxWidth, boxHeight);
                ctx.strokeRect(outerX, colorY, boxWidth, boxHeight);
                ctx.fillStyle = labelColors.backgroundColor;
                ctx.fillRect(innerX, colorY + 1, boxWidth - 2, boxHeight - 2);
            }
        }
        ctx.fillStyle = me.labelTextColors[i];
    }
    drawBody(pt, ctx, options) {
        const me = this;
        const { body: body } = me;
        const { bodySpacing: bodySpacing, bodyAlign: bodyAlign, displayColors: displayColors, boxHeight: boxHeight, boxWidth: boxWidth } = options;
        const bodyFont = (0, $breCz.W)(options.bodyFont);
        let bodyLineHeight = bodyFont.lineHeight;
        let xLinePadding = 0;
        const rtlHelper = (0, $breCz.at)(options.rtl, me.x, me.width);
        const fillLineOfText = function(line) {
            ctx.fillText(line, rtlHelper.x(pt.x + xLinePadding), pt.y + bodyLineHeight / 2);
            pt.y += bodyLineHeight + bodySpacing;
        };
        const bodyAlignForCalculation = rtlHelper.textAlign(bodyAlign);
        let bodyItem, textColor, lines, i, j, ilen, jlen;
        ctx.textAlign = bodyAlign;
        ctx.textBaseline = "middle";
        ctx.font = bodyFont.string;
        pt.x = $4ffe47e38c59be9a$var$getAlignedX(me, bodyAlignForCalculation, options);
        ctx.fillStyle = options.bodyColor;
        (0, $breCz.B)(me.beforeBody, fillLineOfText);
        xLinePadding = displayColors && bodyAlignForCalculation !== "right" ? bodyAlign === "center" ? boxWidth / 2 + 1 : boxWidth + 2 : 0;
        for(i = 0, ilen = body.length; i < ilen; ++i){
            bodyItem = body[i];
            textColor = me.labelTextColors[i];
            ctx.fillStyle = textColor;
            (0, $breCz.B)(bodyItem.before, fillLineOfText);
            lines = bodyItem.lines;
            if (displayColors && lines.length) {
                me._drawColorBox(ctx, pt, i, rtlHelper, options);
                bodyLineHeight = Math.max(bodyFont.lineHeight, boxHeight);
            }
            for(j = 0, jlen = lines.length; j < jlen; ++j){
                fillLineOfText(lines[j]);
                bodyLineHeight = bodyFont.lineHeight;
            }
            (0, $breCz.B)(bodyItem.after, fillLineOfText);
        }
        xLinePadding = 0;
        bodyLineHeight = bodyFont.lineHeight;
        (0, $breCz.B)(me.afterBody, fillLineOfText);
        pt.y -= bodySpacing;
    }
    drawFooter(pt, ctx, options) {
        const me = this;
        const footer = me.footer;
        const length = footer.length;
        let footerFont, i;
        if (length) {
            const rtlHelper = (0, $breCz.at)(options.rtl, me.x, me.width);
            pt.x = $4ffe47e38c59be9a$var$getAlignedX(me, options.footerAlign, options);
            pt.y += options.footerMarginTop;
            ctx.textAlign = rtlHelper.textAlign(options.footerAlign);
            ctx.textBaseline = "middle";
            footerFont = (0, $breCz.W)(options.footerFont);
            ctx.fillStyle = options.footerColor;
            ctx.font = footerFont.string;
            for(i = 0; i < length; ++i){
                ctx.fillText(footer[i], rtlHelper.x(pt.x), pt.y + footerFont.lineHeight / 2);
                pt.y += footerFont.lineHeight + options.footerSpacing;
            }
        }
    }
    drawBackground(pt, ctx, tooltipSize, options) {
        const { xAlign: xAlign, yAlign: yAlign } = this;
        const { x: x, y: y } = pt;
        const { width: width, height: height } = tooltipSize;
        const radius = options.cornerRadius;
        ctx.fillStyle = options.backgroundColor;
        ctx.strokeStyle = options.borderColor;
        ctx.lineWidth = options.borderWidth;
        ctx.beginPath();
        ctx.moveTo(x + radius, y);
        if (yAlign === "top") this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x + width - radius, y);
        ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
        if (yAlign === "center" && xAlign === "right") this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x + width, y + height - radius);
        ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
        if (yAlign === "bottom") this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x + radius, y + height);
        ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
        if (yAlign === "center" && xAlign === "left") this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x, y + radius);
        ctx.quadraticCurveTo(x, y, x + radius, y);
        ctx.closePath();
        ctx.fill();
        if (options.borderWidth > 0) ctx.stroke();
    }
    _updateAnimationTarget(options) {
        const me = this;
        const chart = me._chart;
        const anims = me.$animations;
        const animX = anims && anims.x;
        const animY = anims && anims.y;
        if (animX || animY) {
            const position = $4ffe47e38c59be9a$var$positioners[options.position].call(me, me._active, me._eventPosition);
            if (!position) return;
            const size = me._size = $4ffe47e38c59be9a$var$getTooltipSize(me, options);
            const positionAndSize = Object.assign({}, position, me._size);
            const alignment = $4ffe47e38c59be9a$var$determineAlignment(chart, options, positionAndSize);
            const point = $4ffe47e38c59be9a$var$getBackgroundPoint(options, positionAndSize, alignment, chart);
            if (animX._to !== point.x || animY._to !== point.y) {
                me.xAlign = alignment.xAlign;
                me.yAlign = alignment.yAlign;
                me.width = size.width;
                me.height = size.height;
                me.caretX = position.x;
                me.caretY = position.y;
                me._resolveAnimations().update(me, point);
            }
        }
    }
    draw(ctx) {
        const me = this;
        const options = me.options.setContext(me.getContext());
        let opacity = me.opacity;
        if (!opacity) return;
        me._updateAnimationTarget(options);
        const tooltipSize = {
            width: me.width,
            height: me.height
        };
        const pt = {
            x: me.x,
            y: me.y
        };
        opacity = Math.abs(opacity) < 1e-3 ? 0 : opacity;
        const padding = (0, $breCz.A)(options.padding);
        const hasTooltipContent = me.title.length || me.beforeBody.length || me.body.length || me.afterBody.length || me.footer.length;
        if (options.enabled && hasTooltipContent) {
            ctx.save();
            ctx.globalAlpha = opacity;
            me.drawBackground(pt, ctx, tooltipSize, options);
            (0, $breCz.au)(ctx, options.textDirection);
            pt.y += padding.top;
            me.drawTitle(pt, ctx, options);
            me.drawBody(pt, ctx, options);
            me.drawFooter(pt, ctx, options);
            (0, $breCz.aw)(ctx, options.textDirection);
            ctx.restore();
        }
    }
    getActiveElements() {
        return this._active || [];
    }
    setActiveElements(activeElements, eventPosition) {
        const me = this;
        const lastActive = me._active;
        const active = activeElements.map(({ datasetIndex: datasetIndex, index: index })=>{
            const meta = me._chart.getDatasetMeta(datasetIndex);
            if (!meta) throw new Error("Cannot find a dataset at index " + datasetIndex);
            return {
                datasetIndex: datasetIndex,
                element: meta.data[index],
                index: index
            };
        });
        const changed = !(0, $breCz.ac)(lastActive, active);
        const positionChanged = me._positionChanged(active, eventPosition);
        if (changed || positionChanged) {
            me._active = active;
            me._eventPosition = eventPosition;
            me.update(true);
        }
    }
    handleEvent(e, replay) {
        const me = this;
        const options = me.options;
        const lastActive = me._active || [];
        let changed = false;
        let active = [];
        if (e.type !== "mouseout") {
            active = me._chart.getElementsAtEventForMode(e, options.mode, options, replay);
            if (options.reverse) active.reverse();
        }
        const positionChanged = me._positionChanged(active, e);
        changed = replay || !(0, $breCz.ac)(active, lastActive) || positionChanged;
        if (changed) {
            me._active = active;
            if (options.enabled || options.external) {
                me._eventPosition = {
                    x: e.x,
                    y: e.y
                };
                me.update(true, replay);
            }
        }
        return changed;
    }
    _positionChanged(active, e) {
        const { caretX: caretX, caretY: caretY, options: options } = this;
        const position = $4ffe47e38c59be9a$var$positioners[options.position].call(this, active, e);
        return position !== false && (caretX !== position.x || caretY !== position.y);
    }
}
$4ffe47e38c59be9a$var$Tooltip.positioners = $4ffe47e38c59be9a$var$positioners;
var $4ffe47e38c59be9a$export$28c660c63b792dea = {
    id: "tooltip",
    _element: $4ffe47e38c59be9a$var$Tooltip,
    positioners: $4ffe47e38c59be9a$var$positioners,
    afterInit (chart, _args, options) {
        if (options) chart.tooltip = new $4ffe47e38c59be9a$var$Tooltip({
            _chart: chart,
            options: options
        });
    },
    beforeUpdate (chart, _args, options) {
        if (chart.tooltip) chart.tooltip.initialize(options);
    },
    reset (chart, _args, options) {
        if (chart.tooltip) chart.tooltip.initialize(options);
    },
    afterDraw (chart) {
        const tooltip = chart.tooltip;
        const args = {
            tooltip: tooltip
        };
        if (chart.notifyPlugins("beforeTooltipDraw", args) === false) return;
        if (tooltip) tooltip.draw(chart.ctx);
        chart.notifyPlugins("afterTooltipDraw", args);
    },
    afterEvent (chart, args) {
        if (chart.tooltip) {
            const useFinalPosition = args.replay;
            if (chart.tooltip.handleEvent(args.event, useFinalPosition)) args.changed = true;
        }
    },
    defaults: {
        enabled: true,
        external: null,
        position: "average",
        backgroundColor: "rgba(0,0,0,0.8)",
        titleColor: "#fff",
        titleFont: {
            weight: "bold"
        },
        titleSpacing: 2,
        titleMarginBottom: 6,
        titleAlign: "left",
        bodyColor: "#fff",
        bodySpacing: 2,
        bodyFont: {},
        bodyAlign: "left",
        footerColor: "#fff",
        footerSpacing: 2,
        footerMarginTop: 6,
        footerFont: {
            weight: "bold"
        },
        footerAlign: "left",
        padding: 6,
        caretPadding: 2,
        caretSize: 5,
        cornerRadius: 6,
        boxHeight: (ctx, opts)=>opts.bodyFont.size,
        boxWidth: (ctx, opts)=>opts.bodyFont.size,
        multiKeyBackground: "#fff",
        displayColors: true,
        borderColor: "rgba(0,0,0,0)",
        borderWidth: 0,
        animation: {
            duration: 400,
            easing: "easeOutQuart"
        },
        animations: {
            numbers: {
                type: "number",
                properties: [
                    "x",
                    "y",
                    "width",
                    "height",
                    "caretX",
                    "caretY"
                ]
            },
            opacity: {
                easing: "linear",
                duration: 200
            }
        },
        callbacks: {
            beforeTitle: (0, $breCz.ax),
            title (tooltipItems) {
                if (tooltipItems.length > 0) {
                    const item = tooltipItems[0];
                    const labels = item.chart.data.labels;
                    const labelCount = labels ? labels.length : 0;
                    if (this && this.options && this.options.mode === "dataset") return item.dataset.label || "";
                    else if (item.label) return item.label;
                    else if (labelCount > 0 && item.dataIndex < labelCount) return labels[item.dataIndex];
                }
                return "";
            },
            afterTitle: (0, $breCz.ax),
            beforeBody: (0, $breCz.ax),
            beforeLabel: (0, $breCz.ax),
            label (tooltipItem) {
                if (this && this.options && this.options.mode === "dataset") return tooltipItem.label + ": " + tooltipItem.formattedValue || tooltipItem.formattedValue;
                let label = tooltipItem.dataset.label || "";
                if (label) label += ": ";
                const value = tooltipItem.formattedValue;
                if (!(0, $breCz.j)(value)) label += value;
                return label;
            },
            labelColor (tooltipItem) {
                const meta = tooltipItem.chart.getDatasetMeta(tooltipItem.datasetIndex);
                const options = meta.controller.getStyle(tooltipItem.dataIndex);
                return {
                    borderColor: options.borderColor,
                    backgroundColor: options.backgroundColor,
                    borderWidth: options.borderWidth,
                    borderDash: options.borderDash,
                    borderDashOffset: options.borderDashOffset,
                    borderRadius: 0
                };
            },
            labelTextColor () {
                return this.options.bodyColor;
            },
            labelPointStyle (tooltipItem) {
                const meta = tooltipItem.chart.getDatasetMeta(tooltipItem.datasetIndex);
                const options = meta.controller.getStyle(tooltipItem.dataIndex);
                return {
                    pointStyle: options.pointStyle,
                    rotation: options.rotation
                };
            },
            afterLabel: (0, $breCz.ax),
            afterBody: (0, $breCz.ax),
            beforeFooter: (0, $breCz.ax),
            footer: (0, $breCz.ax),
            afterFooter: (0, $breCz.ax)
        }
    },
    defaultRoutes: {
        bodyFont: "font",
        footerFont: "font",
        titleFont: "font"
    },
    descriptors: {
        _scriptable: (name)=>name !== "filter" && name !== "itemSort" && name !== "external",
        _indexable: false,
        callbacks: {
            _scriptable: false,
            _indexable: false
        },
        animation: {
            _fallback: false
        },
        animations: {
            _fallback: "animation"
        }
    },
    additionalOptionScopes: [
        "interaction"
    ]
};
var $4ffe47e38c59be9a$export$8b3ca321c77fdea6 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    Decimation: $4ffe47e38c59be9a$export$be17f937e9aa7533,
    Filler: $4ffe47e38c59be9a$export$d19ba4d812bed757,
    Legend: $4ffe47e38c59be9a$export$ed247974535929c7,
    SubTitle: $4ffe47e38c59be9a$export$d5c56664638992a4,
    Title: $4ffe47e38c59be9a$export$f99233281efd08a0,
    Tooltip: $4ffe47e38c59be9a$export$28c660c63b792dea
});
const $4ffe47e38c59be9a$var$addIfString = (labels, raw, index)=>typeof raw === "string" ? labels.push(raw) - 1 : isNaN(raw) ? null : index;
function $4ffe47e38c59be9a$var$findOrAddLabel(labels, raw, index) {
    const first = labels.indexOf(raw);
    if (first === -1) return $4ffe47e38c59be9a$var$addIfString(labels, raw, index);
    const last = labels.lastIndexOf(raw);
    return first !== last ? index : first;
}
const $4ffe47e38c59be9a$var$validIndex = (index, max)=>index === null ? null : (0, $breCz.q)(Math.round(index), 0, max);
class $4ffe47e38c59be9a$export$29e663ba4d09fe7 extends $4ffe47e38c59be9a$export$d60cfc58d3c358b6 {
    constructor(cfg){
        super(cfg);
        this._startValue = undefined;
        this._valueRange = 0;
    }
    parse(raw, index) {
        if ((0, $breCz.j)(raw)) return null;
        const labels = this.getLabels();
        index = isFinite(index) && labels[index] === raw ? index : $4ffe47e38c59be9a$var$findOrAddLabel(labels, raw, (0, $breCz.v)(index, raw));
        return $4ffe47e38c59be9a$var$validIndex(index, labels.length - 1);
    }
    determineDataLimits() {
        const me = this;
        const { minDefined: minDefined, maxDefined: maxDefined } = me.getUserBounds();
        let { min: min, max: max } = me.getMinMax(true);
        if (me.options.bounds === "ticks") {
            if (!minDefined) min = 0;
            if (!maxDefined) max = me.getLabels().length - 1;
        }
        me.min = min;
        me.max = max;
    }
    buildTicks() {
        const me = this;
        const min = me.min;
        const max = me.max;
        const offset = me.options.offset;
        const ticks = [];
        let labels = me.getLabels();
        labels = min === 0 && max === labels.length - 1 ? labels : labels.slice(min, max + 1);
        me._valueRange = Math.max(labels.length - (offset ? 0 : 1), 1);
        me._startValue = me.min - (offset ? 0.5 : 0);
        for(let value = min; value <= max; value++)ticks.push({
            value: value
        });
        return ticks;
    }
    getLabelForValue(value) {
        const me = this;
        const labels = me.getLabels();
        if (value >= 0 && value < labels.length) return labels[value];
        return value;
    }
    configure() {
        const me = this;
        super.configure();
        if (!me.isHorizontal()) me._reversePixels = !me._reversePixels;
    }
    getPixelForValue(value) {
        const me = this;
        if (typeof value !== "number") value = me.parse(value);
        return value === null ? NaN : me.getPixelForDecimal((value - me._startValue) / me._valueRange);
    }
    getPixelForTick(index) {
        const me = this;
        const ticks = me.ticks;
        if (index < 0 || index > ticks.length - 1) return null;
        return me.getPixelForValue(ticks[index].value);
    }
    getValueForPixel(pixel) {
        const me = this;
        return Math.round(me._startValue + me.getDecimalForPixel(pixel) * me._valueRange);
    }
    getBasePixel() {
        return this.bottom;
    }
}
$4ffe47e38c59be9a$export$29e663ba4d09fe7.id = "category";
$4ffe47e38c59be9a$export$29e663ba4d09fe7.defaults = {
    ticks: {
        callback: $4ffe47e38c59be9a$export$29e663ba4d09fe7.prototype.getLabelForValue
    }
};
function $4ffe47e38c59be9a$var$generateTicks$1(generationOptions, dataRange) {
    const ticks = [];
    const MIN_SPACING = 1e-14;
    const { bounds: bounds, step: step, min: min, max: max, precision: precision, count: count, maxTicks: maxTicks, maxDigits: maxDigits, includeBounds: includeBounds } = generationOptions;
    const unit = step || 1;
    const maxSpaces = maxTicks - 1;
    const { min: rmin, max: rmax } = dataRange;
    const minDefined = !(0, $breCz.j)(min);
    const maxDefined = !(0, $breCz.j)(max);
    const countDefined = !(0, $breCz.j)(count);
    const minSpacing = (rmax - rmin) / (maxDigits + 1);
    let spacing = (0, $breCz.aA)((rmax - rmin) / maxSpaces / unit) * unit;
    let factor, niceMin, niceMax, numSpaces;
    if (spacing < MIN_SPACING && !minDefined && !maxDefined) return [
        {
            value: rmin
        },
        {
            value: rmax
        }
    ];
    numSpaces = Math.ceil(rmax / spacing) - Math.floor(rmin / spacing);
    if (numSpaces > maxSpaces) spacing = (0, $breCz.aA)(numSpaces * spacing / maxSpaces / unit) * unit;
    if (!(0, $breCz.j)(precision)) {
        factor = Math.pow(10, precision);
        spacing = Math.ceil(spacing * factor) / factor;
    }
    if (bounds === "ticks") {
        niceMin = Math.floor(rmin / spacing) * spacing;
        niceMax = Math.ceil(rmax / spacing) * spacing;
    } else {
        niceMin = rmin;
        niceMax = rmax;
    }
    if (minDefined && maxDefined && step && (0, $breCz.aB)((max - min) / step, spacing / 1000)) {
        numSpaces = Math.round(Math.min((max - min) / spacing, maxTicks));
        spacing = (max - min) / numSpaces;
        niceMin = min;
        niceMax = max;
    } else if (countDefined) {
        niceMin = minDefined ? min : niceMin;
        niceMax = maxDefined ? max : niceMax;
        numSpaces = count - 1;
        spacing = (niceMax - niceMin) / numSpaces;
    } else {
        numSpaces = (niceMax - niceMin) / spacing;
        if ((0, $breCz.aC)(numSpaces, Math.round(numSpaces), spacing / 1000)) numSpaces = Math.round(numSpaces);
        else numSpaces = Math.ceil(numSpaces);
    }
    const decimalPlaces = Math.max((0, $breCz.aD)(spacing), (0, $breCz.aD)(niceMin));
    factor = Math.pow(10, (0, $breCz.j)(precision) ? decimalPlaces : precision);
    niceMin = Math.round(niceMin * factor) / factor;
    niceMax = Math.round(niceMax * factor) / factor;
    let j = 0;
    if (minDefined) {
        if (includeBounds && niceMin !== min) {
            ticks.push({
                value: min
            });
            if (niceMin < min) j++;
            if ((0, $breCz.aC)(Math.round((niceMin + j * spacing) * factor) / factor, min, $4ffe47e38c59be9a$var$relativeLabelSize(min, minSpacing, generationOptions))) j++;
        } else if (niceMin < min) j++;
    }
    for(; j < numSpaces; ++j)ticks.push({
        value: Math.round((niceMin + j * spacing) * factor) / factor
    });
    if (maxDefined && includeBounds && niceMax !== max) {
        if ((0, $breCz.aC)(ticks[ticks.length - 1].value, max, $4ffe47e38c59be9a$var$relativeLabelSize(max, minSpacing, generationOptions))) ticks[ticks.length - 1].value = max;
        else ticks.push({
            value: max
        });
    } else if (!maxDefined || niceMax === max) ticks.push({
        value: niceMax
    });
    return ticks;
}
function $4ffe47e38c59be9a$var$relativeLabelSize(value, minSpacing, { horizontal: horizontal, minRotation: minRotation }) {
    const rad = (0, $breCz.t)(minRotation);
    const ratio = (horizontal ? Math.sin(rad) : Math.cos(rad)) || 0.001;
    const length = 0.75 * minSpacing * ("" + value).length;
    return Math.min(minSpacing / ratio, length);
}
class $4ffe47e38c59be9a$var$LinearScaleBase extends $4ffe47e38c59be9a$export$d60cfc58d3c358b6 {
    constructor(cfg){
        super(cfg);
        this.start = undefined;
        this.end = undefined;
        this._startValue = undefined;
        this._endValue = undefined;
        this._valueRange = 0;
    }
    parse(raw, index) {
        if ((0, $breCz.j)(raw)) return null;
        if ((typeof raw === "number" || raw instanceof Number) && !isFinite(+raw)) return null;
        return +raw;
    }
    handleTickRangeOptions() {
        const me = this;
        const { beginAtZero: beginAtZero } = me.options;
        const { minDefined: minDefined, maxDefined: maxDefined } = me.getUserBounds();
        let { min: min, max: max } = me;
        const setMin = (v)=>min = minDefined ? min : v;
        const setMax = (v)=>max = maxDefined ? max : v;
        if (beginAtZero) {
            const minSign = (0, $breCz.s)(min);
            const maxSign = (0, $breCz.s)(max);
            if (minSign < 0 && maxSign < 0) setMax(0);
            else if (minSign > 0 && maxSign > 0) setMin(0);
        }
        if (min === max) {
            setMax(max + 1);
            if (!beginAtZero) setMin(min - 1);
        }
        me.min = min;
        me.max = max;
    }
    getTickLimit() {
        const me = this;
        const tickOpts = me.options.ticks;
        let { maxTicksLimit: maxTicksLimit, stepSize: stepSize } = tickOpts;
        let maxTicks;
        if (stepSize) maxTicks = Math.ceil(me.max / stepSize) - Math.floor(me.min / stepSize) + 1;
        else {
            maxTicks = me.computeTickLimit();
            maxTicksLimit = maxTicksLimit || 11;
        }
        if (maxTicksLimit) maxTicks = Math.min(maxTicksLimit, maxTicks);
        return maxTicks;
    }
    computeTickLimit() {
        return Number.POSITIVE_INFINITY;
    }
    buildTicks() {
        const me = this;
        const opts = me.options;
        const tickOpts = opts.ticks;
        let maxTicks = me.getTickLimit();
        maxTicks = Math.max(2, maxTicks);
        const numericGeneratorOptions = {
            maxTicks: maxTicks,
            bounds: opts.bounds,
            min: opts.min,
            max: opts.max,
            precision: tickOpts.precision,
            step: tickOpts.stepSize,
            count: tickOpts.count,
            maxDigits: me._maxDigits(),
            horizontal: me.isHorizontal(),
            minRotation: tickOpts.minRotation || 0,
            includeBounds: tickOpts.includeBounds !== false
        };
        const dataRange = me._range || me;
        const ticks = $4ffe47e38c59be9a$var$generateTicks$1(numericGeneratorOptions, dataRange);
        if (opts.bounds === "ticks") (0, $breCz.az)(ticks, me, "value");
        if (opts.reverse) {
            ticks.reverse();
            me.start = me.max;
            me.end = me.min;
        } else {
            me.start = me.min;
            me.end = me.max;
        }
        return ticks;
    }
    configure() {
        const me = this;
        const ticks = me.ticks;
        let start = me.min;
        let end = me.max;
        super.configure();
        if (me.options.offset && ticks.length) {
            const offset = (end - start) / Math.max(ticks.length - 1, 1) / 2;
            start -= offset;
            end += offset;
        }
        me._startValue = start;
        me._endValue = end;
        me._valueRange = end - start;
    }
    getLabelForValue(value) {
        return (0, $breCz.n)(value, this.chart.options.locale);
    }
}
class $4ffe47e38c59be9a$export$e7f4e5e8656f0b93 extends $4ffe47e38c59be9a$var$LinearScaleBase {
    determineDataLimits() {
        const me = this;
        const { min: min, max: max } = me.getMinMax(true);
        me.min = (0, $breCz.g)(min) ? min : 0;
        me.max = (0, $breCz.g)(max) ? max : 1;
        me.handleTickRangeOptions();
    }
    computeTickLimit() {
        const me = this;
        const horizontal = me.isHorizontal();
        const length = horizontal ? me.width : me.height;
        const minRotation = (0, $breCz.t)(me.options.ticks.minRotation);
        const ratio = (horizontal ? Math.sin(minRotation) : Math.cos(minRotation)) || 0.001;
        const tickFont = me._resolveTickFontOptions(0);
        return Math.ceil(length / Math.min(40, tickFont.lineHeight / ratio));
    }
    getPixelForValue(value) {
        return value === null ? NaN : this.getPixelForDecimal((value - this._startValue) / this._valueRange);
    }
    getValueForPixel(pixel) {
        return this._startValue + this.getDecimalForPixel(pixel) * this._valueRange;
    }
}
$4ffe47e38c59be9a$export$e7f4e5e8656f0b93.id = "linear";
$4ffe47e38c59be9a$export$e7f4e5e8656f0b93.defaults = {
    ticks: {
        callback: $4ffe47e38c59be9a$export$27c7467594ef87bd.formatters.numeric
    }
};
function $4ffe47e38c59be9a$var$isMajor(tickVal) {
    const remain = tickVal / Math.pow(10, Math.floor((0, $breCz.I)(tickVal)));
    return remain === 1;
}
function $4ffe47e38c59be9a$var$generateTicks(generationOptions, dataRange) {
    const endExp = Math.floor((0, $breCz.I)(dataRange.max));
    const endSignificand = Math.ceil(dataRange.max / Math.pow(10, endExp));
    const ticks = [];
    let tickVal = (0, $breCz.K)(generationOptions.min, Math.pow(10, Math.floor((0, $breCz.I)(dataRange.min))));
    let exp = Math.floor((0, $breCz.I)(tickVal));
    let significand = Math.floor(tickVal / Math.pow(10, exp));
    let precision = exp < 0 ? Math.pow(10, Math.abs(exp)) : 1;
    do {
        ticks.push({
            value: tickVal,
            major: $4ffe47e38c59be9a$var$isMajor(tickVal)
        });
        ++significand;
        if (significand === 10) {
            significand = 1;
            ++exp;
            precision = exp >= 0 ? 1 : precision;
        }
        tickVal = Math.round(significand * Math.pow(10, exp) * precision) / precision;
    }while (exp < endExp || exp === endExp && significand < endSignificand);
    const lastTick = (0, $breCz.K)(generationOptions.max, tickVal);
    ticks.push({
        value: lastTick,
        major: $4ffe47e38c59be9a$var$isMajor(tickVal)
    });
    return ticks;
}
class $4ffe47e38c59be9a$export$85295eaf7cb3ac3e extends $4ffe47e38c59be9a$export$d60cfc58d3c358b6 {
    constructor(cfg){
        super(cfg);
        this.start = undefined;
        this.end = undefined;
        this._startValue = undefined;
        this._valueRange = 0;
    }
    parse(raw, index) {
        const value = $4ffe47e38c59be9a$var$LinearScaleBase.prototype.parse.apply(this, [
            raw,
            index
        ]);
        if (value === 0) {
            this._zero = true;
            return undefined;
        }
        return (0, $breCz.g)(value) && value > 0 ? value : null;
    }
    determineDataLimits() {
        const me = this;
        const { min: min, max: max } = me.getMinMax(true);
        me.min = (0, $breCz.g)(min) ? Math.max(0, min) : null;
        me.max = (0, $breCz.g)(max) ? Math.max(0, max) : null;
        if (me.options.beginAtZero) me._zero = true;
        me.handleTickRangeOptions();
    }
    handleTickRangeOptions() {
        const me = this;
        const { minDefined: minDefined, maxDefined: maxDefined } = me.getUserBounds();
        let min = me.min;
        let max = me.max;
        const setMin = (v)=>min = minDefined ? min : v;
        const setMax = (v)=>max = maxDefined ? max : v;
        const exp = (v, m)=>Math.pow(10, Math.floor((0, $breCz.I)(v)) + m);
        if (min === max) {
            if (min <= 0) {
                setMin(1);
                setMax(10);
            } else {
                setMin(exp(min, -1));
                setMax(exp(max, 1));
            }
        }
        if (min <= 0) setMin(exp(max, -1));
        if (max <= 0) setMax(exp(min, 1));
        if (me._zero && me.min !== me._suggestedMin && min === exp(me.min, 0)) setMin(exp(min, -1));
        me.min = min;
        me.max = max;
    }
    buildTicks() {
        const me = this;
        const opts = me.options;
        const generationOptions = {
            min: me._userMin,
            max: me._userMax
        };
        const ticks = $4ffe47e38c59be9a$var$generateTicks(generationOptions, me);
        if (opts.bounds === "ticks") (0, $breCz.az)(ticks, me, "value");
        if (opts.reverse) {
            ticks.reverse();
            me.start = me.max;
            me.end = me.min;
        } else {
            me.start = me.min;
            me.end = me.max;
        }
        return ticks;
    }
    getLabelForValue(value) {
        return value === undefined ? "0" : (0, $breCz.n)(value, this.chart.options.locale);
    }
    configure() {
        const me = this;
        const start = me.min;
        super.configure();
        me._startValue = (0, $breCz.I)(start);
        me._valueRange = (0, $breCz.I)(me.max) - (0, $breCz.I)(start);
    }
    getPixelForValue(value) {
        const me = this;
        if (value === undefined || value === 0) value = me.min;
        if (value === null || isNaN(value)) return NaN;
        return me.getPixelForDecimal(value === me.min ? 0 : ((0, $breCz.I)(value) - me._startValue) / me._valueRange);
    }
    getValueForPixel(pixel) {
        const me = this;
        const decimal = me.getDecimalForPixel(pixel);
        return Math.pow(10, me._startValue + decimal * me._valueRange);
    }
}
$4ffe47e38c59be9a$export$85295eaf7cb3ac3e.id = "logarithmic";
$4ffe47e38c59be9a$export$85295eaf7cb3ac3e.defaults = {
    ticks: {
        callback: $4ffe47e38c59be9a$export$27c7467594ef87bd.formatters.logarithmic,
        major: {
            enabled: true
        }
    }
};
function $4ffe47e38c59be9a$var$getTickBackdropHeight(opts) {
    const tickOpts = opts.ticks;
    if (tickOpts.display && opts.display) {
        const padding = (0, $breCz.A)(tickOpts.backdropPadding);
        return (0, $breCz.v)(tickOpts.font && tickOpts.font.size, (0, $breCz.d).font.size) + padding.height;
    }
    return 0;
}
function $4ffe47e38c59be9a$var$measureLabelSize(ctx, font, label) {
    label = (0, $breCz.b)(label) ? label : [
        label
    ];
    return {
        w: (0, $breCz.aE)(ctx, font.string, label),
        h: label.length * font.lineHeight
    };
}
function $4ffe47e38c59be9a$var$determineLimits(angle, pos, size, min, max) {
    if (angle === min || angle === max) return {
        start: pos - size / 2,
        end: pos + size / 2
    };
    else if (angle < min || angle > max) return {
        start: pos - size,
        end: pos
    };
    return {
        start: pos,
        end: pos + size
    };
}
function $4ffe47e38c59be9a$var$fitWithPointLabels(scale) {
    const furthestLimits = {
        l: 0,
        r: scale.width,
        t: 0,
        b: scale.height - scale.paddingTop
    };
    const furthestAngles = {};
    const labelSizes = [];
    const padding = [];
    const valueCount = scale.getLabels().length;
    for(let i = 0; i < valueCount; i++){
        const opts = scale.options.pointLabels.setContext(scale.getContext(i));
        padding[i] = opts.padding;
        const pointPosition = scale.getPointPosition(i, scale.drawingArea + padding[i]);
        const plFont = (0, $breCz.W)(opts.font);
        const textSize = $4ffe47e38c59be9a$var$measureLabelSize(scale.ctx, plFont, scale._pointLabels[i]);
        labelSizes[i] = textSize;
        const angleRadians = scale.getIndexAngle(i);
        const angle = (0, $breCz.N)(angleRadians);
        const hLimits = $4ffe47e38c59be9a$var$determineLimits(angle, pointPosition.x, textSize.w, 0, 180);
        const vLimits = $4ffe47e38c59be9a$var$determineLimits(angle, pointPosition.y, textSize.h, 90, 270);
        if (hLimits.start < furthestLimits.l) {
            furthestLimits.l = hLimits.start;
            furthestAngles.l = angleRadians;
        }
        if (hLimits.end > furthestLimits.r) {
            furthestLimits.r = hLimits.end;
            furthestAngles.r = angleRadians;
        }
        if (vLimits.start < furthestLimits.t) {
            furthestLimits.t = vLimits.start;
            furthestAngles.t = angleRadians;
        }
        if (vLimits.end > furthestLimits.b) {
            furthestLimits.b = vLimits.end;
            furthestAngles.b = angleRadians;
        }
    }
    scale._setReductions(scale.drawingArea, furthestLimits, furthestAngles);
    scale._pointLabelItems = $4ffe47e38c59be9a$var$buildPointLabelItems(scale, labelSizes, padding);
}
function $4ffe47e38c59be9a$var$buildPointLabelItems(scale, labelSizes, padding) {
    const items = [];
    const valueCount = scale.getLabels().length;
    const opts = scale.options;
    const tickBackdropHeight = $4ffe47e38c59be9a$var$getTickBackdropHeight(opts);
    const outerDistance = scale.getDistanceFromCenterForValue(opts.ticks.reverse ? scale.min : scale.max);
    for(let i = 0; i < valueCount; i++){
        const extra = i === 0 ? tickBackdropHeight / 2 : 0;
        const pointLabelPosition = scale.getPointPosition(i, outerDistance + extra + padding[i]);
        const angle = (0, $breCz.N)(scale.getIndexAngle(i));
        const size = labelSizes[i];
        const y = $4ffe47e38c59be9a$var$yForAngle(pointLabelPosition.y, size.h, angle);
        const textAlign = $4ffe47e38c59be9a$var$getTextAlignForAngle(angle);
        const left = $4ffe47e38c59be9a$var$leftForTextAlign(pointLabelPosition.x, size.w, textAlign);
        items.push({
            x: pointLabelPosition.x,
            y: y,
            textAlign: textAlign,
            left: left,
            top: y,
            right: left + size.w,
            bottom: y + size.h
        });
    }
    return items;
}
function $4ffe47e38c59be9a$var$getTextAlignForAngle(angle) {
    if (angle === 0 || angle === 180) return "center";
    else if (angle < 180) return "left";
    return "right";
}
function $4ffe47e38c59be9a$var$leftForTextAlign(x, w, align) {
    if (align === "right") x -= w;
    else if (align === "center") x -= w / 2;
    return x;
}
function $4ffe47e38c59be9a$var$yForAngle(y, h, angle) {
    if (angle === 90 || angle === 270) y -= h / 2;
    else if (angle > 270 || angle < 90) y -= h;
    return y;
}
function $4ffe47e38c59be9a$var$drawPointLabels(scale, labelCount) {
    const { ctx: ctx, options: { pointLabels: pointLabels } } = scale;
    for(let i = labelCount - 1; i >= 0; i--){
        const optsAtIndex = pointLabels.setContext(scale.getContext(i));
        const plFont = (0, $breCz.W)(optsAtIndex.font);
        const { x: x, y: y, textAlign: textAlign, left: left, top: top, right: right, bottom: bottom } = scale._pointLabelItems[i];
        const { backdropColor: backdropColor } = optsAtIndex;
        if (!(0, $breCz.j)(backdropColor)) {
            const padding = (0, $breCz.A)(optsAtIndex.backdropPadding);
            ctx.fillStyle = backdropColor;
            ctx.fillRect(left - padding.left, top - padding.top, right - left + padding.width, bottom - top + padding.height);
        }
        (0, $breCz.U)(ctx, scale._pointLabels[i], x, y + plFont.lineHeight / 2, plFont, {
            color: optsAtIndex.color,
            textAlign: textAlign,
            textBaseline: "middle"
        });
    }
}
function $4ffe47e38c59be9a$var$pathRadiusLine(scale, radius, circular, labelCount) {
    const { ctx: ctx } = scale;
    if (circular) ctx.arc(scale.xCenter, scale.yCenter, radius, 0, (0, $breCz.T));
    else {
        let pointPosition = scale.getPointPosition(0, radius);
        ctx.moveTo(pointPosition.x, pointPosition.y);
        for(let i = 1; i < labelCount; i++){
            pointPosition = scale.getPointPosition(i, radius);
            ctx.lineTo(pointPosition.x, pointPosition.y);
        }
    }
}
function $4ffe47e38c59be9a$var$drawRadiusLine(scale, gridLineOpts, radius, labelCount) {
    const ctx = scale.ctx;
    const circular = gridLineOpts.circular;
    const { color: color, lineWidth: lineWidth } = gridLineOpts;
    if (!circular && !labelCount || !color || !lineWidth || radius < 0) return;
    ctx.save();
    ctx.strokeStyle = color;
    ctx.lineWidth = lineWidth;
    ctx.setLineDash(gridLineOpts.borderDash);
    ctx.lineDashOffset = gridLineOpts.borderDashOffset;
    ctx.beginPath();
    $4ffe47e38c59be9a$var$pathRadiusLine(scale, radius, circular, labelCount);
    ctx.closePath();
    ctx.stroke();
    ctx.restore();
}
function $4ffe47e38c59be9a$var$numberOrZero(param) {
    return (0, $breCz.p)(param) ? param : 0;
}
class $4ffe47e38c59be9a$export$cfafc36d95386d38 extends $4ffe47e38c59be9a$var$LinearScaleBase {
    constructor(cfg){
        super(cfg);
        this.xCenter = undefined;
        this.yCenter = undefined;
        this.drawingArea = undefined;
        this._pointLabels = [];
        this._pointLabelItems = [];
    }
    setDimensions() {
        const me = this;
        me.width = me.maxWidth;
        me.height = me.maxHeight;
        me.paddingTop = $4ffe47e38c59be9a$var$getTickBackdropHeight(me.options) / 2;
        me.xCenter = Math.floor(me.width / 2);
        me.yCenter = Math.floor((me.height - me.paddingTop) / 2);
        me.drawingArea = Math.min(me.height - me.paddingTop, me.width) / 2;
    }
    determineDataLimits() {
        const me = this;
        const { min: min, max: max } = me.getMinMax(false);
        me.min = (0, $breCz.g)(min) && !isNaN(min) ? min : 0;
        me.max = (0, $breCz.g)(max) && !isNaN(max) ? max : 0;
        me.handleTickRangeOptions();
    }
    computeTickLimit() {
        return Math.ceil(this.drawingArea / $4ffe47e38c59be9a$var$getTickBackdropHeight(this.options));
    }
    generateTickLabels(ticks) {
        const me = this;
        $4ffe47e38c59be9a$var$LinearScaleBase.prototype.generateTickLabels.call(me, ticks);
        me._pointLabels = me.getLabels().map((value, index)=>{
            const label = (0, $breCz.L)(me.options.pointLabels.callback, [
                value,
                index
            ], me);
            return label || label === 0 ? label : "";
        });
    }
    fit() {
        const me = this;
        const opts = me.options;
        if (opts.display && opts.pointLabels.display) $4ffe47e38c59be9a$var$fitWithPointLabels(me);
        else me.setCenterPoint(0, 0, 0, 0);
    }
    _setReductions(largestPossibleRadius, furthestLimits, furthestAngles) {
        const me = this;
        let radiusReductionLeft = furthestLimits.l / Math.sin(furthestAngles.l);
        let radiusReductionRight = Math.max(furthestLimits.r - me.width, 0) / Math.sin(furthestAngles.r);
        let radiusReductionTop = -furthestLimits.t / Math.cos(furthestAngles.t);
        let radiusReductionBottom = -Math.max(furthestLimits.b - (me.height - me.paddingTop), 0) / Math.cos(furthestAngles.b);
        radiusReductionLeft = $4ffe47e38c59be9a$var$numberOrZero(radiusReductionLeft);
        radiusReductionRight = $4ffe47e38c59be9a$var$numberOrZero(radiusReductionRight);
        radiusReductionTop = $4ffe47e38c59be9a$var$numberOrZero(radiusReductionTop);
        radiusReductionBottom = $4ffe47e38c59be9a$var$numberOrZero(radiusReductionBottom);
        me.drawingArea = Math.max(largestPossibleRadius / 2, Math.min(Math.floor(largestPossibleRadius - (radiusReductionLeft + radiusReductionRight) / 2), Math.floor(largestPossibleRadius - (radiusReductionTop + radiusReductionBottom) / 2)));
        me.setCenterPoint(radiusReductionLeft, radiusReductionRight, radiusReductionTop, radiusReductionBottom);
    }
    setCenterPoint(leftMovement, rightMovement, topMovement, bottomMovement) {
        const me = this;
        const maxRight = me.width - rightMovement - me.drawingArea;
        const maxLeft = leftMovement + me.drawingArea;
        const maxTop = topMovement + me.drawingArea;
        const maxBottom = me.height - me.paddingTop - bottomMovement - me.drawingArea;
        me.xCenter = Math.floor((maxLeft + maxRight) / 2 + me.left);
        me.yCenter = Math.floor((maxTop + maxBottom) / 2 + me.top + me.paddingTop);
    }
    getIndexAngle(index) {
        const angleMultiplier = (0, $breCz.T) / this.getLabels().length;
        const startAngle = this.options.startAngle || 0;
        return (0, $breCz.as)(index * angleMultiplier + (0, $breCz.t)(startAngle));
    }
    getDistanceFromCenterForValue(value) {
        const me = this;
        if ((0, $breCz.j)(value)) return NaN;
        const scalingFactor = me.drawingArea / (me.max - me.min);
        if (me.options.reverse) return (me.max - value) * scalingFactor;
        return (value - me.min) * scalingFactor;
    }
    getValueForDistanceFromCenter(distance) {
        if ((0, $breCz.j)(distance)) return NaN;
        const me = this;
        const scaledDistance = distance / (me.drawingArea / (me.max - me.min));
        return me.options.reverse ? me.max - scaledDistance : me.min + scaledDistance;
    }
    getPointPosition(index, distanceFromCenter) {
        const me = this;
        const angle = me.getIndexAngle(index) - (0, $breCz.H);
        return {
            x: Math.cos(angle) * distanceFromCenter + me.xCenter,
            y: Math.sin(angle) * distanceFromCenter + me.yCenter,
            angle: angle
        };
    }
    getPointPositionForValue(index, value) {
        return this.getPointPosition(index, this.getDistanceFromCenterForValue(value));
    }
    getBasePosition(index) {
        return this.getPointPositionForValue(index || 0, this.getBaseValue());
    }
    getPointLabelPosition(index) {
        const { left: left, top: top, right: right, bottom: bottom } = this._pointLabelItems[index];
        return {
            left: left,
            top: top,
            right: right,
            bottom: bottom
        };
    }
    drawBackground() {
        const me = this;
        const { backgroundColor: backgroundColor, grid: { circular: circular } } = me.options;
        if (backgroundColor) {
            const ctx = me.ctx;
            ctx.save();
            ctx.beginPath();
            $4ffe47e38c59be9a$var$pathRadiusLine(me, me.getDistanceFromCenterForValue(me._endValue), circular, me.getLabels().length);
            ctx.closePath();
            ctx.fillStyle = backgroundColor;
            ctx.fill();
            ctx.restore();
        }
    }
    drawGrid() {
        const me = this;
        const ctx = me.ctx;
        const opts = me.options;
        const { angleLines: angleLines, grid: grid } = opts;
        const labelCount = me.getLabels().length;
        let i, offset, position;
        if (opts.pointLabels.display) $4ffe47e38c59be9a$var$drawPointLabels(me, labelCount);
        if (grid.display) me.ticks.forEach((tick, index)=>{
            if (index !== 0) {
                offset = me.getDistanceFromCenterForValue(tick.value);
                const optsAtIndex = grid.setContext(me.getContext(index - 1));
                $4ffe47e38c59be9a$var$drawRadiusLine(me, optsAtIndex, offset, labelCount);
            }
        });
        if (angleLines.display) {
            ctx.save();
            for(i = me.getLabels().length - 1; i >= 0; i--){
                const optsAtIndex = angleLines.setContext(me.getContext(i));
                const { color: color, lineWidth: lineWidth } = optsAtIndex;
                if (!lineWidth || !color) continue;
                ctx.lineWidth = lineWidth;
                ctx.strokeStyle = color;
                ctx.setLineDash(optsAtIndex.borderDash);
                ctx.lineDashOffset = optsAtIndex.borderDashOffset;
                offset = me.getDistanceFromCenterForValue(opts.ticks.reverse ? me.min : me.max);
                position = me.getPointPosition(i, offset);
                ctx.beginPath();
                ctx.moveTo(me.xCenter, me.yCenter);
                ctx.lineTo(position.x, position.y);
                ctx.stroke();
            }
            ctx.restore();
        }
    }
    drawBorder() {}
    drawLabels() {
        const me = this;
        const ctx = me.ctx;
        const opts = me.options;
        const tickOpts = opts.ticks;
        if (!tickOpts.display) return;
        const startAngle = me.getIndexAngle(0);
        let offset, width;
        ctx.save();
        ctx.translate(me.xCenter, me.yCenter);
        ctx.rotate(startAngle);
        ctx.textAlign = "center";
        ctx.textBaseline = "middle";
        me.ticks.forEach((tick, index)=>{
            if (index === 0 && !opts.reverse) return;
            const optsAtIndex = tickOpts.setContext(me.getContext(index));
            const tickFont = (0, $breCz.W)(optsAtIndex.font);
            offset = me.getDistanceFromCenterForValue(me.ticks[index].value);
            if (optsAtIndex.showLabelBackdrop) {
                ctx.font = tickFont.string;
                width = ctx.measureText(tick.label).width;
                ctx.fillStyle = optsAtIndex.backdropColor;
                const padding = (0, $breCz.A)(optsAtIndex.backdropPadding);
                ctx.fillRect(-width / 2 - padding.left, -offset - tickFont.size / 2 - padding.top, width + padding.width, tickFont.size + padding.height);
            }
            (0, $breCz.U)(ctx, tick.label, 0, -offset, tickFont, {
                color: optsAtIndex.color
            });
        });
        ctx.restore();
    }
    drawTitle() {}
}
$4ffe47e38c59be9a$export$cfafc36d95386d38.id = "radialLinear";
$4ffe47e38c59be9a$export$cfafc36d95386d38.defaults = {
    display: true,
    animate: true,
    position: "chartArea",
    angleLines: {
        display: true,
        lineWidth: 1,
        borderDash: [],
        borderDashOffset: 0.0
    },
    grid: {
        circular: false
    },
    startAngle: 0,
    ticks: {
        showLabelBackdrop: true,
        callback: $4ffe47e38c59be9a$export$27c7467594ef87bd.formatters.numeric
    },
    pointLabels: {
        backdropColor: undefined,
        backdropPadding: 2,
        display: true,
        font: {
            size: 10
        },
        callback (label) {
            return label;
        },
        padding: 5
    }
};
$4ffe47e38c59be9a$export$cfafc36d95386d38.defaultRoutes = {
    "angleLines.color": "borderColor",
    "pointLabels.color": "color",
    "ticks.color": "color"
};
$4ffe47e38c59be9a$export$cfafc36d95386d38.descriptors = {
    angleLines: {
        _fallback: "grid"
    }
};
const $4ffe47e38c59be9a$var$INTERVALS = {
    millisecond: {
        common: true,
        size: 1,
        steps: 1000
    },
    second: {
        common: true,
        size: 1000,
        steps: 60
    },
    minute: {
        common: true,
        size: 60000,
        steps: 60
    },
    hour: {
        common: true,
        size: 3600000,
        steps: 24
    },
    day: {
        common: true,
        size: 86400000,
        steps: 30
    },
    week: {
        common: false,
        size: 604800000,
        steps: 4
    },
    month: {
        common: true,
        size: 2.628e9,
        steps: 12
    },
    quarter: {
        common: false,
        size: 7.884e9,
        steps: 4
    },
    year: {
        common: true,
        size: 3.154e10
    }
};
const $4ffe47e38c59be9a$var$UNITS = Object.keys($4ffe47e38c59be9a$var$INTERVALS);
function $4ffe47e38c59be9a$var$sorter(a, b) {
    return a - b;
}
function $4ffe47e38c59be9a$var$parse(scale, input) {
    if ((0, $breCz.j)(input)) return null;
    const adapter = scale._adapter;
    const { parser: parser, round: round, isoWeekday: isoWeekday } = scale._parseOpts;
    let value = input;
    if (typeof parser === "function") value = parser(value);
    if (!(0, $breCz.g)(value)) value = typeof parser === "string" ? adapter.parse(value, parser) : adapter.parse(value);
    if (value === null) return null;
    if (round) value = round === "week" && ((0, $breCz.p)(isoWeekday) || isoWeekday === true) ? adapter.startOf(value, "isoWeek", isoWeekday) : adapter.startOf(value, round);
    return +value;
}
function $4ffe47e38c59be9a$var$determineUnitForAutoTicks(minUnit, min, max, capacity) {
    const ilen = $4ffe47e38c59be9a$var$UNITS.length;
    for(let i = $4ffe47e38c59be9a$var$UNITS.indexOf(minUnit); i < ilen - 1; ++i){
        const interval = $4ffe47e38c59be9a$var$INTERVALS[$4ffe47e38c59be9a$var$UNITS[i]];
        const factor = interval.steps ? interval.steps : Number.MAX_SAFE_INTEGER;
        if (interval.common && Math.ceil((max - min) / (factor * interval.size)) <= capacity) return $4ffe47e38c59be9a$var$UNITS[i];
    }
    return $4ffe47e38c59be9a$var$UNITS[ilen - 1];
}
function $4ffe47e38c59be9a$var$determineUnitForFormatting(scale, numTicks, minUnit, min, max) {
    for(let i = $4ffe47e38c59be9a$var$UNITS.length - 1; i >= $4ffe47e38c59be9a$var$UNITS.indexOf(minUnit); i--){
        const unit = $4ffe47e38c59be9a$var$UNITS[i];
        if ($4ffe47e38c59be9a$var$INTERVALS[unit].common && scale._adapter.diff(max, min, unit) >= numTicks - 1) return unit;
    }
    return $4ffe47e38c59be9a$var$UNITS[minUnit ? $4ffe47e38c59be9a$var$UNITS.indexOf(minUnit) : 0];
}
function $4ffe47e38c59be9a$var$determineMajorUnit(unit) {
    for(let i = $4ffe47e38c59be9a$var$UNITS.indexOf(unit) + 1, ilen = $4ffe47e38c59be9a$var$UNITS.length; i < ilen; ++i){
        if ($4ffe47e38c59be9a$var$INTERVALS[$4ffe47e38c59be9a$var$UNITS[i]].common) return $4ffe47e38c59be9a$var$UNITS[i];
    }
}
function $4ffe47e38c59be9a$var$addTick(ticks, time, timestamps) {
    if (!timestamps) ticks[time] = true;
    else if (timestamps.length) {
        const { lo: lo, hi: hi } = (0, $breCz.aG)(timestamps, time);
        const timestamp = timestamps[lo] >= time ? timestamps[lo] : timestamps[hi];
        ticks[timestamp] = true;
    }
}
function $4ffe47e38c59be9a$var$setMajorTicks(scale, ticks, map, majorUnit) {
    const adapter = scale._adapter;
    const first = +adapter.startOf(ticks[0].value, majorUnit);
    const last = ticks[ticks.length - 1].value;
    let major, index;
    for(major = first; major <= last; major = +adapter.add(major, 1, majorUnit)){
        index = map[major];
        if (index >= 0) ticks[index].major = true;
    }
    return ticks;
}
function $4ffe47e38c59be9a$var$ticksFromTimestamps(scale, values, majorUnit) {
    const ticks = [];
    const map = {};
    const ilen = values.length;
    let i, value;
    for(i = 0; i < ilen; ++i){
        value = values[i];
        map[value] = i;
        ticks.push({
            value: value,
            major: false
        });
    }
    return ilen === 0 || !majorUnit ? ticks : $4ffe47e38c59be9a$var$setMajorTicks(scale, ticks, map, majorUnit);
}
class $4ffe47e38c59be9a$export$a894c72689ff3ec extends $4ffe47e38c59be9a$export$d60cfc58d3c358b6 {
    constructor(props){
        super(props);
        this._cache = {
            data: [],
            labels: [],
            all: []
        };
        this._unit = "day";
        this._majorUnit = undefined;
        this._offsets = {};
        this._normalized = false;
        this._parseOpts = undefined;
    }
    init(scaleOpts, opts) {
        const time = scaleOpts.time || (scaleOpts.time = {});
        const adapter = this._adapter = new $4ffe47e38c59be9a$export$f32766ea09ec8bc4._date(scaleOpts.adapters.date);
        (0, $breCz.a6)(time.displayFormats, adapter.formats());
        this._parseOpts = {
            parser: time.parser,
            round: time.round,
            isoWeekday: time.isoWeekday
        };
        super.init(scaleOpts);
        this._normalized = opts.normalized;
    }
    parse(raw, index) {
        if (raw === undefined) return null;
        return $4ffe47e38c59be9a$var$parse(this, raw);
    }
    beforeLayout() {
        super.beforeLayout();
        this._cache = {
            data: [],
            labels: [],
            all: []
        };
    }
    determineDataLimits() {
        const me = this;
        const options = me.options;
        const adapter = me._adapter;
        const unit = options.time.unit || "day";
        let { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = me.getUserBounds();
        function _applyBounds(bounds) {
            if (!minDefined && !isNaN(bounds.min)) min = Math.min(min, bounds.min);
            if (!maxDefined && !isNaN(bounds.max)) max = Math.max(max, bounds.max);
        }
        if (!minDefined || !maxDefined) {
            _applyBounds(me._getLabelBounds());
            if (options.bounds !== "ticks" || options.ticks.source !== "labels") _applyBounds(me.getMinMax(false));
        }
        min = (0, $breCz.g)(min) && !isNaN(min) ? min : +adapter.startOf(Date.now(), unit);
        max = (0, $breCz.g)(max) && !isNaN(max) ? max : +adapter.endOf(Date.now(), unit) + 1;
        me.min = Math.min(min, max - 1);
        me.max = Math.max(min + 1, max);
    }
    _getLabelBounds() {
        const arr = this.getLabelTimestamps();
        let min = Number.POSITIVE_INFINITY;
        let max = Number.NEGATIVE_INFINITY;
        if (arr.length) {
            min = arr[0];
            max = arr[arr.length - 1];
        }
        return {
            min: min,
            max: max
        };
    }
    buildTicks() {
        const me = this;
        const options = me.options;
        const timeOpts = options.time;
        const tickOpts = options.ticks;
        const timestamps = tickOpts.source === "labels" ? me.getLabelTimestamps() : me._generate();
        if (options.bounds === "ticks" && timestamps.length) {
            me.min = me._userMin || timestamps[0];
            me.max = me._userMax || timestamps[timestamps.length - 1];
        }
        const min = me.min;
        const max = me.max;
        const ticks = (0, $breCz.aF)(timestamps, min, max);
        me._unit = timeOpts.unit || (tickOpts.autoSkip ? $4ffe47e38c59be9a$var$determineUnitForAutoTicks(timeOpts.minUnit, me.min, me.max, me._getLabelCapacity(min)) : $4ffe47e38c59be9a$var$determineUnitForFormatting(me, ticks.length, timeOpts.minUnit, me.min, me.max));
        me._majorUnit = !tickOpts.major.enabled || me._unit === "year" ? undefined : $4ffe47e38c59be9a$var$determineMajorUnit(me._unit);
        me.initOffsets(timestamps);
        if (options.reverse) ticks.reverse();
        return $4ffe47e38c59be9a$var$ticksFromTimestamps(me, ticks, me._majorUnit);
    }
    initOffsets(timestamps) {
        const me = this;
        let start = 0;
        let end = 0;
        let first, last;
        if (me.options.offset && timestamps.length) {
            first = me.getDecimalForValue(timestamps[0]);
            if (timestamps.length === 1) start = 1 - first;
            else start = (me.getDecimalForValue(timestamps[1]) - first) / 2;
            last = me.getDecimalForValue(timestamps[timestamps.length - 1]);
            if (timestamps.length === 1) end = last;
            else end = (last - me.getDecimalForValue(timestamps[timestamps.length - 2])) / 2;
        }
        const limit = timestamps.length < 3 ? 0.5 : 0.25;
        start = (0, $breCz.q)(start, 0, limit);
        end = (0, $breCz.q)(end, 0, limit);
        me._offsets = {
            start: start,
            end: end,
            factor: 1 / (start + 1 + end)
        };
    }
    _generate() {
        const me = this;
        const adapter = me._adapter;
        const min = me.min;
        const max = me.max;
        const options = me.options;
        const timeOpts = options.time;
        const minor = timeOpts.unit || $4ffe47e38c59be9a$var$determineUnitForAutoTicks(timeOpts.minUnit, min, max, me._getLabelCapacity(min));
        const stepSize = (0, $breCz.v)(timeOpts.stepSize, 1);
        const weekday = minor === "week" ? timeOpts.isoWeekday : false;
        const hasWeekday = (0, $breCz.p)(weekday) || weekday === true;
        const ticks = {};
        let first = min;
        let time, count;
        if (hasWeekday) first = +adapter.startOf(first, "isoWeek", weekday);
        first = +adapter.startOf(first, hasWeekday ? "day" : minor);
        if (adapter.diff(max, min, minor) > 100000 * stepSize) throw new Error(min + " and " + max + " are too far apart with stepSize of " + stepSize + " " + minor);
        const timestamps = options.ticks.source === "data" && me.getDataTimestamps();
        for(time = first, count = 0; time < max; time = +adapter.add(time, stepSize, minor), count++)$4ffe47e38c59be9a$var$addTick(ticks, time, timestamps);
        if (time === max || options.bounds === "ticks" || count === 1) $4ffe47e38c59be9a$var$addTick(ticks, time, timestamps);
        return Object.keys(ticks).sort((a, b)=>a - b).map((x)=>+x);
    }
    getLabelForValue(value) {
        const me = this;
        const adapter = me._adapter;
        const timeOpts = me.options.time;
        if (timeOpts.tooltipFormat) return adapter.format(value, timeOpts.tooltipFormat);
        return adapter.format(value, timeOpts.displayFormats.datetime);
    }
    _tickFormatFunction(time, index, ticks, format) {
        const me = this;
        const options = me.options;
        const formats = options.time.displayFormats;
        const unit = me._unit;
        const majorUnit = me._majorUnit;
        const minorFormat = unit && formats[unit];
        const majorFormat = majorUnit && formats[majorUnit];
        const tick = ticks[index];
        const major = majorUnit && majorFormat && tick && tick.major;
        const label = me._adapter.format(time, format || (major ? majorFormat : minorFormat));
        const formatter = options.ticks.callback;
        return formatter ? (0, $breCz.L)(formatter, [
            label,
            index,
            ticks
        ], me) : label;
    }
    generateTickLabels(ticks) {
        let i, ilen, tick;
        for(i = 0, ilen = ticks.length; i < ilen; ++i){
            tick = ticks[i];
            tick.label = this._tickFormatFunction(tick.value, i, ticks);
        }
    }
    getDecimalForValue(value) {
        const me = this;
        return value === null ? NaN : (value - me.min) / (me.max - me.min);
    }
    getPixelForValue(value) {
        const me = this;
        const offsets = me._offsets;
        const pos = me.getDecimalForValue(value);
        return me.getPixelForDecimal((offsets.start + pos) * offsets.factor);
    }
    getValueForPixel(pixel) {
        const me = this;
        const offsets = me._offsets;
        const pos = me.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
        return me.min + pos * (me.max - me.min);
    }
    _getLabelSize(label) {
        const me = this;
        const ticksOpts = me.options.ticks;
        const tickLabelWidth = me.ctx.measureText(label).width;
        const angle = (0, $breCz.t)(me.isHorizontal() ? ticksOpts.maxRotation : ticksOpts.minRotation);
        const cosRotation = Math.cos(angle);
        const sinRotation = Math.sin(angle);
        const tickFontSize = me._resolveTickFontOptions(0).size;
        return {
            w: tickLabelWidth * cosRotation + tickFontSize * sinRotation,
            h: tickLabelWidth * sinRotation + tickFontSize * cosRotation
        };
    }
    _getLabelCapacity(exampleTime) {
        const me = this;
        const timeOpts = me.options.time;
        const displayFormats = timeOpts.displayFormats;
        const format = displayFormats[timeOpts.unit] || displayFormats.millisecond;
        const exampleLabel = me._tickFormatFunction(exampleTime, 0, $4ffe47e38c59be9a$var$ticksFromTimestamps(me, [
            exampleTime
        ], me._majorUnit), format);
        const size = me._getLabelSize(exampleLabel);
        const capacity = Math.floor(me.isHorizontal() ? me.width / size.w : me.height / size.h) - 1;
        return capacity > 0 ? capacity : 1;
    }
    getDataTimestamps() {
        const me = this;
        let timestamps = me._cache.data || [];
        let i, ilen;
        if (timestamps.length) return timestamps;
        const metas = me.getMatchingVisibleMetas();
        if (me._normalized && metas.length) return me._cache.data = metas[0].controller.getAllParsedValues(me);
        for(i = 0, ilen = metas.length; i < ilen; ++i)timestamps = timestamps.concat(metas[i].controller.getAllParsedValues(me));
        return me._cache.data = me.normalize(timestamps);
    }
    getLabelTimestamps() {
        const me = this;
        const timestamps = me._cache.labels || [];
        let i, ilen;
        if (timestamps.length) return timestamps;
        const labels = me.getLabels();
        for(i = 0, ilen = labels.length; i < ilen; ++i)timestamps.push($4ffe47e38c59be9a$var$parse(me, labels[i]));
        return me._cache.labels = me._normalized ? timestamps : me.normalize(timestamps);
    }
    normalize(values) {
        return (0, $breCz._)(values.sort($4ffe47e38c59be9a$var$sorter));
    }
}
$4ffe47e38c59be9a$export$a894c72689ff3ec.id = "time";
$4ffe47e38c59be9a$export$a894c72689ff3ec.defaults = {
    bounds: "data",
    adapters: {},
    time: {
        parser: false,
        unit: false,
        round: false,
        isoWeekday: false,
        minUnit: "millisecond",
        displayFormats: {}
    },
    ticks: {
        source: "auto",
        major: {
            enabled: false
        }
    }
};
function $4ffe47e38c59be9a$var$interpolate(table, val, reverse) {
    let lo = 0;
    let hi = table.length - 1;
    let prevSource, nextSource, prevTarget, nextTarget;
    if (reverse) {
        if (val >= table[lo].pos && val <= table[hi].pos) ({ lo: lo, hi: hi } = (0, $breCz.w)(table, "pos", val));
        ({ pos: prevSource, time: prevTarget } = table[lo]);
        ({ pos: nextSource, time: nextTarget } = table[hi]);
    } else {
        if (val >= table[lo].time && val <= table[hi].time) ({ lo: lo, hi: hi } = (0, $breCz.w)(table, "time", val));
        ({ time: prevSource, pos: prevTarget } = table[lo]);
        ({ time: nextSource, pos: nextTarget } = table[hi]);
    }
    const span = nextSource - prevSource;
    return span ? prevTarget + (nextTarget - prevTarget) * (val - prevSource) / span : prevTarget;
}
class $4ffe47e38c59be9a$export$85df64a8eb6dc986 extends $4ffe47e38c59be9a$export$a894c72689ff3ec {
    constructor(props){
        super(props);
        this._table = [];
        this._minPos = undefined;
        this._tableRange = undefined;
    }
    initOffsets() {
        const me = this;
        const timestamps = me._getTimestampsForTable();
        const table = me._table = me.buildLookupTable(timestamps);
        me._minPos = $4ffe47e38c59be9a$var$interpolate(table, me.min);
        me._tableRange = $4ffe47e38c59be9a$var$interpolate(table, me.max) - me._minPos;
        super.initOffsets(timestamps);
    }
    buildLookupTable(timestamps) {
        const { min: min, max: max } = this;
        const items = [];
        const table = [];
        let i, ilen, prev, curr, next;
        for(i = 0, ilen = timestamps.length; i < ilen; ++i){
            curr = timestamps[i];
            if (curr >= min && curr <= max) items.push(curr);
        }
        if (items.length < 2) return [
            {
                time: min,
                pos: 0
            },
            {
                time: max,
                pos: 1
            }
        ];
        for(i = 0, ilen = items.length; i < ilen; ++i){
            next = items[i + 1];
            prev = items[i - 1];
            curr = items[i];
            if (Math.round((next + prev) / 2) !== curr) table.push({
                time: curr,
                pos: i / (ilen - 1)
            });
        }
        return table;
    }
    _getTimestampsForTable() {
        const me = this;
        let timestamps = me._cache.all || [];
        if (timestamps.length) return timestamps;
        const data = me.getDataTimestamps();
        const label = me.getLabelTimestamps();
        if (data.length && label.length) timestamps = me.normalize(data.concat(label));
        else timestamps = data.length ? data : label;
        timestamps = me._cache.all = timestamps;
        return timestamps;
    }
    getDecimalForValue(value) {
        return ($4ffe47e38c59be9a$var$interpolate(this._table, value) - this._minPos) / this._tableRange;
    }
    getValueForPixel(pixel) {
        const me = this;
        const offsets = me._offsets;
        const decimal = me.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
        return $4ffe47e38c59be9a$var$interpolate(me._table, decimal * me._tableRange + me._minPos, true);
    }
}
$4ffe47e38c59be9a$export$85df64a8eb6dc986.id = "timeseries";
$4ffe47e38c59be9a$export$85df64a8eb6dc986.defaults = $4ffe47e38c59be9a$export$a894c72689ff3ec.defaults;
var $4ffe47e38c59be9a$export$bcac1c16f1530ec2 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    CategoryScale: $4ffe47e38c59be9a$export$29e663ba4d09fe7,
    LinearScale: $4ffe47e38c59be9a$export$e7f4e5e8656f0b93,
    LogarithmicScale: $4ffe47e38c59be9a$export$85295eaf7cb3ac3e,
    RadialLinearScale: $4ffe47e38c59be9a$export$cfafc36d95386d38,
    TimeScale: $4ffe47e38c59be9a$export$a894c72689ff3ec,
    TimeSeriesScale: $4ffe47e38c59be9a$export$85df64a8eb6dc986
});
const $4ffe47e38c59be9a$export$e8959e79e3af550f = [
    $4ffe47e38c59be9a$export$a6506504f799c5d5,
    $4ffe47e38c59be9a$export$7a5d735b2ab6389d,
    $4ffe47e38c59be9a$export$8b3ca321c77fdea6,
    $4ffe47e38c59be9a$export$bcac1c16f1530ec2
];

});
parcelRegister("breCz", function(module, exports) {

$parcel$export(module.exports, "r", function () { return $853d8ec6f7609bd1$export$43caf9889c228507; });
$parcel$export(module.exports, "F", function () { return $853d8ec6f7609bd1$export$d66501df72047452; });
$parcel$export(module.exports, "a8", function () { return $853d8ec6f7609bd1$export$c3950d9923825c02; });
$parcel$export(module.exports, "X", function () { return $853d8ec6f7609bd1$export$78acf4525d8a74c4; });
$parcel$export(module.exports, "Y", function () { return $853d8ec6f7609bd1$export$8743009a87fcb00f; });
$parcel$export(module.exports, "av", function () { return $853d8ec6f7609bd1$export$d66dc83d8cfc8dd; });
$parcel$export(module.exports, "ax", function () { return $853d8ec6f7609bd1$export$9fa96a7d116ea3ce; });
$parcel$export(module.exports, "a7", function () { return $853d8ec6f7609bd1$export$a93c5207d687da10; });
$parcel$export(module.exports, "j", function () { return $853d8ec6f7609bd1$export$35e795649ee09318; });
$parcel$export(module.exports, "b", function () { return $853d8ec6f7609bd1$export$8b22cf2602fb60ce; });
$parcel$export(module.exports, "i", function () { return $853d8ec6f7609bd1$export$23f2a1d2818174ef; });
$parcel$export(module.exports, "g", function () { return $853d8ec6f7609bd1$export$39b482c5e57630a8; });
$parcel$export(module.exports, "K", function () { return $853d8ec6f7609bd1$export$3466f893ebf79586; });
$parcel$export(module.exports, "v", function () { return $853d8ec6f7609bd1$export$90a7f3efeed30595; });
$parcel$export(module.exports, "k", function () { return $853d8ec6f7609bd1$export$342063e11d6c3cad; });
$parcel$export(module.exports, "m", function () { return $853d8ec6f7609bd1$export$953cecd6e717a553; });
$parcel$export(module.exports, "L", function () { return $853d8ec6f7609bd1$export$61196ced6d74a310; });
$parcel$export(module.exports, "B", function () { return $853d8ec6f7609bd1$export$ef35774e6d314e91; });
$parcel$export(module.exports, "ac", function () { return $853d8ec6f7609bd1$export$2219238a014317b0; });
$parcel$export(module.exports, "$", function () { return $853d8ec6f7609bd1$export$3d8c2f653ac9d0b9; });
$parcel$export(module.exports, "a6", function () { return $853d8ec6f7609bd1$export$2e2af4578d910ddf; });
$parcel$export(module.exports, "f", function () { return $853d8ec6f7609bd1$export$2d1720544b23b823; });
$parcel$export(module.exports, "a0", function () { return $853d8ec6f7609bd1$export$34aec0b863436764; });
$parcel$export(module.exports, "h", function () { return $853d8ec6f7609bd1$export$dda1d9f60106f0e9; });
$parcel$export(module.exports, "a2", function () { return $853d8ec6f7609bd1$export$ce26c07117d59d6a; });
$parcel$export(module.exports, "ab", function () { return $853d8ec6f7609bd1$export$555508cbc6add439; });
$parcel$export(module.exports, "P", function () { return $853d8ec6f7609bd1$export$56c0d5a1e737357d; });
$parcel$export(module.exports, "T", function () { return $853d8ec6f7609bd1$export$971d5caa766a69d7; });
$parcel$export(module.exports, "H", function () { return $853d8ec6f7609bd1$export$7f8ddf7c7c20b3cd; });
$parcel$export(module.exports, "I", function () { return $853d8ec6f7609bd1$export$9bb611d729802a56; });
$parcel$export(module.exports, "s", function () { return $853d8ec6f7609bd1$export$2408f22a0fab9ae5; });
$parcel$export(module.exports, "aA", function () { return $853d8ec6f7609bd1$export$91c6e00c14e7e6fd; });
$parcel$export(module.exports, "aC", function () { return $853d8ec6f7609bd1$export$890c4ad488842ce7; });
$parcel$export(module.exports, "J", function () { return $853d8ec6f7609bd1$export$b4171a6734a65d42; });
$parcel$export(module.exports, "p", function () { return $853d8ec6f7609bd1$export$ffb5f4729a158638; });
$parcel$export(module.exports, "aB", function () { return $853d8ec6f7609bd1$export$9d398bebfec1c039; });
$parcel$export(module.exports, "az", function () { return $853d8ec6f7609bd1$export$3d12bd131bb975d1; });
$parcel$export(module.exports, "t", function () { return $853d8ec6f7609bd1$export$625550452a3fa3ec; });
$parcel$export(module.exports, "N", function () { return $853d8ec6f7609bd1$export$a07804094c3ecf2d; });
$parcel$export(module.exports, "aD", function () { return $853d8ec6f7609bd1$export$24baa2b76016ce0e; });
$parcel$export(module.exports, "ad", function () { return $853d8ec6f7609bd1$export$4c3d22f3d993c33f; });
$parcel$export(module.exports, "ay", function () { return $853d8ec6f7609bd1$export$28f7fcd39efa255; });
$parcel$export(module.exports, "as", function () { return $853d8ec6f7609bd1$export$6554612db691658e; });
$parcel$export(module.exports, "o", function () { return $853d8ec6f7609bd1$export$ae1af26003f05816; });
$parcel$export(module.exports, "q", function () { return $853d8ec6f7609bd1$export$9e5f44173e64f162; });
$parcel$export(module.exports, "Q", function () { return $853d8ec6f7609bd1$export$3722cfe417b6ed86; });
$parcel$export(module.exports, "e", function () { return $853d8ec6f7609bd1$export$f1e1789686576879; });
$parcel$export(module.exports, "c", function () { return $853d8ec6f7609bd1$export$db3b6bfb95261072; });
$parcel$export(module.exports, "Z", function () { return $853d8ec6f7609bd1$export$dc98b0b04f4c7758; });
$parcel$export(module.exports, "a1", function () { return $853d8ec6f7609bd1$export$3c2fa207a37baaea; });
$parcel$export(module.exports, "d", function () { return $853d8ec6f7609bd1$export$4368d992c4eafac0; });
$parcel$export(module.exports, "O", function () { return $853d8ec6f7609bd1$export$c4ce752e73470fba; });
$parcel$export(module.exports, "aE", function () { return $853d8ec6f7609bd1$export$158acd800e1ef08b; });
$parcel$export(module.exports, "R", function () { return $853d8ec6f7609bd1$export$db202ddc8be9136; });
$parcel$export(module.exports, "aa", function () { return $853d8ec6f7609bd1$export$7910e0436ed8d1de; });
$parcel$export(module.exports, "an", function () { return $853d8ec6f7609bd1$export$306ddfe3a8403e2; });
$parcel$export(module.exports, "y", function () { return $853d8ec6f7609bd1$export$4a5767248b18ef41; });
$parcel$export(module.exports, "S", function () { return $853d8ec6f7609bd1$export$25ce5a424b770e84; });
$parcel$export(module.exports, "V", function () { return $853d8ec6f7609bd1$export$e7c866399fa523f5; });
$parcel$export(module.exports, "al", function () { return $853d8ec6f7609bd1$export$ab83b03e4111b1d0; });
$parcel$export(module.exports, "am", function () { return $853d8ec6f7609bd1$export$1a82df3d29112e01; });
$parcel$export(module.exports, "U", function () { return $853d8ec6f7609bd1$export$3a6d5c9ae78a2c08; });
$parcel$export(module.exports, "ao", function () { return $853d8ec6f7609bd1$export$7a38258bbe170828; });
$parcel$export(module.exports, "ae", function () { return $853d8ec6f7609bd1$export$f787f51d84a910ad; });
$parcel$export(module.exports, "ap", function () { return $853d8ec6f7609bd1$export$2f6ca3d3b1f80bf5; });
$parcel$export(module.exports, "aq", function () { return $853d8ec6f7609bd1$export$8a5498727ef6be21; });
$parcel$export(module.exports, "A", function () { return $853d8ec6f7609bd1$export$ebd11618f299a286; });
$parcel$export(module.exports, "W", function () { return $853d8ec6f7609bd1$export$71cec2538cb2c617; });
$parcel$export(module.exports, "a", function () { return $853d8ec6f7609bd1$export$407448d2b89b1813; });
$parcel$export(module.exports, "M", function () { return $853d8ec6f7609bd1$export$3a1a48c8f6ef640e; });
$parcel$export(module.exports, "aG", function () { return $853d8ec6f7609bd1$export$53a70dd1ebbae346; });
$parcel$export(module.exports, "w", function () { return $853d8ec6f7609bd1$export$efccba1c4a2ef57b; });
$parcel$export(module.exports, "z", function () { return $853d8ec6f7609bd1$export$df995fae86a55f06; });
$parcel$export(module.exports, "aF", function () { return $853d8ec6f7609bd1$export$cf2f7c5792f80b46; });
$parcel$export(module.exports, "l", function () { return $853d8ec6f7609bd1$export$882b5998b3b9117c; });
$parcel$export(module.exports, "u", function () { return $853d8ec6f7609bd1$export$3b14a55fb2447963; });
$parcel$export(module.exports, "_", function () { return $853d8ec6f7609bd1$export$71511d61b312f219; });
$parcel$export(module.exports, "a4", function () { return $853d8ec6f7609bd1$export$efca4cbe5dd06740; });
$parcel$export(module.exports, "a3", function () { return $853d8ec6f7609bd1$export$6559d589eb85fbb6; });
$parcel$export(module.exports, "a5", function () { return $853d8ec6f7609bd1$export$a8550f7dbe79f93a; });
$parcel$export(module.exports, "af", function () { return $853d8ec6f7609bd1$export$c9170ad7d4cd7e57; });
$parcel$export(module.exports, "D", function () { return $853d8ec6f7609bd1$export$96f57966bedc81b4; });
$parcel$export(module.exports, "x", function () { return $853d8ec6f7609bd1$export$d141bba7fdc215a3; });
$parcel$export(module.exports, "C", function () { return $853d8ec6f7609bd1$export$e7094788287c5e9b; });
$parcel$export(module.exports, "a9", function () { return $853d8ec6f7609bd1$export$a9c996f45e5784d0; });
$parcel$export(module.exports, "G", function () { return $853d8ec6f7609bd1$export$2329c99376c9d0a4; });
$parcel$export(module.exports, "E", function () { return $853d8ec6f7609bd1$export$a9c23c6ac3fc3eca; });
$parcel$export(module.exports, "ak", function () { return $853d8ec6f7609bd1$export$21579262ef46735b; });
$parcel$export(module.exports, "ai", function () { return $853d8ec6f7609bd1$export$f38c853ae54ed474; });
$parcel$export(module.exports, "aj", function () { return $853d8ec6f7609bd1$export$3b513254972cfc9c; });
$parcel$export(module.exports, "n", function () { return $853d8ec6f7609bd1$export$7ccc53e8f1e7dfc5; });
$parcel$export(module.exports, "at", function () { return $853d8ec6f7609bd1$export$493d36ec626b6698; });
$parcel$export(module.exports, "au", function () { return $853d8ec6f7609bd1$export$1fbe638ecf81657e; });
$parcel$export(module.exports, "aw", function () { return $853d8ec6f7609bd1$export$92108d983e8ee699; });
$parcel$export(module.exports, "ar", function () { return $853d8ec6f7609bd1$export$d24c54395ce0c509; });
$parcel$export(module.exports, "ah", function () { return $853d8ec6f7609bd1$export$995eb9fca571757; });
$parcel$export(module.exports, "ag", function () { return $853d8ec6f7609bd1$export$ee7c8ad385a60b7b; });
/*!
 * Chart.js v3.4.1
 * https://www.chartjs.org
 * (c) 2021 Chart.js Contributors
 * Released under the MIT License
 */ function $853d8ec6f7609bd1$export$f96d196f7728bb5(pixelSize, fontStyle, fontFamily) {
    return fontStyle + " " + pixelSize + "px " + fontFamily;
}
const $853d8ec6f7609bd1$export$43caf9889c228507 = function() {
    if (typeof window === "undefined") return function(callback) {
        return callback();
    };
    return window.requestAnimationFrame;
}();
function $853d8ec6f7609bd1$export$d66501df72047452(fn, thisArg, updateFn) {
    const updateArgs = updateFn || ((args)=>Array.prototype.slice.call(args));
    let ticking = false;
    let args = [];
    return function(...rest) {
        args = updateArgs(rest);
        if (!ticking) {
            ticking = true;
            $853d8ec6f7609bd1$export$43caf9889c228507.call(window, ()=>{
                ticking = false;
                fn.apply(thisArg, args);
            });
        }
    };
}
function $853d8ec6f7609bd1$export$c3950d9923825c02(fn, delay) {
    let timeout;
    return function() {
        if (delay) {
            clearTimeout(timeout);
            timeout = setTimeout(fn, delay);
        } else fn();
        return delay;
    };
}
const $853d8ec6f7609bd1$export$78acf4525d8a74c4 = (align)=>align === "start" ? "left" : align === "end" ? "right" : "center";
const $853d8ec6f7609bd1$export$8743009a87fcb00f = (align, start, end)=>align === "start" ? start : align === "end" ? end : (start + end) / 2;
const $853d8ec6f7609bd1$export$d66dc83d8cfc8dd = (align, left, right, rtl)=>{
    const check = rtl ? "left" : "right";
    return align === check ? right : align === "center" ? (left + right) / 2 : left;
};
function $853d8ec6f7609bd1$export$9fa96a7d116ea3ce() {}
const $853d8ec6f7609bd1$export$a93c5207d687da10 = function() {
    let id = 0;
    return function() {
        return id++;
    };
}();
function $853d8ec6f7609bd1$export$35e795649ee09318(value) {
    return value === null || typeof value === "undefined";
}
function $853d8ec6f7609bd1$export$8b22cf2602fb60ce(value) {
    if (Array.isArray && Array.isArray(value)) return true;
    const type = Object.prototype.toString.call(value);
    if (type.substr(0, 7) === "[object" && type.substr(-6) === "Array]") return true;
    return false;
}
function $853d8ec6f7609bd1$export$23f2a1d2818174ef(value) {
    return value !== null && Object.prototype.toString.call(value) === "[object Object]";
}
const $853d8ec6f7609bd1$export$39b482c5e57630a8 = (value)=>(typeof value === "number" || value instanceof Number) && isFinite(+value);
function $853d8ec6f7609bd1$export$3466f893ebf79586(value, defaultValue) {
    return $853d8ec6f7609bd1$export$39b482c5e57630a8(value) ? value : defaultValue;
}
function $853d8ec6f7609bd1$export$90a7f3efeed30595(value, defaultValue) {
    return typeof value === "undefined" ? defaultValue : value;
}
const $853d8ec6f7609bd1$export$342063e11d6c3cad = (value, dimension)=>typeof value === "string" && value.endsWith("%") ? parseFloat(value) / 100 : value / dimension;
const $853d8ec6f7609bd1$export$953cecd6e717a553 = (value, dimension)=>typeof value === "string" && value.endsWith("%") ? parseFloat(value) / 100 * dimension : +value;
function $853d8ec6f7609bd1$export$61196ced6d74a310(fn, args, thisArg) {
    if (fn && typeof fn.call === "function") return fn.apply(thisArg, args);
}
function $853d8ec6f7609bd1$export$ef35774e6d314e91(loopable, fn, thisArg, reverse) {
    let i, len, keys;
    if ($853d8ec6f7609bd1$export$8b22cf2602fb60ce(loopable)) {
        len = loopable.length;
        if (reverse) for(i = len - 1; i >= 0; i--)fn.call(thisArg, loopable[i], i);
        else for(i = 0; i < len; i++)fn.call(thisArg, loopable[i], i);
    } else if ($853d8ec6f7609bd1$export$23f2a1d2818174ef(loopable)) {
        keys = Object.keys(loopable);
        len = keys.length;
        for(i = 0; i < len; i++)fn.call(thisArg, loopable[keys[i]], keys[i]);
    }
}
function $853d8ec6f7609bd1$export$2219238a014317b0(a0, a1) {
    let i, ilen, v0, v1;
    if (!a0 || !a1 || a0.length !== a1.length) return false;
    for(i = 0, ilen = a0.length; i < ilen; ++i){
        v0 = a0[i];
        v1 = a1[i];
        if (v0.datasetIndex !== v1.datasetIndex || v0.index !== v1.index) return false;
    }
    return true;
}
function $853d8ec6f7609bd1$export$b9a6b53f9be3734(source) {
    if ($853d8ec6f7609bd1$export$8b22cf2602fb60ce(source)) return source.map($853d8ec6f7609bd1$export$b9a6b53f9be3734);
    if ($853d8ec6f7609bd1$export$23f2a1d2818174ef(source)) {
        const target = Object.create(null);
        const keys = Object.keys(source);
        const klen = keys.length;
        let k = 0;
        for(; k < klen; ++k)target[keys[k]] = $853d8ec6f7609bd1$export$b9a6b53f9be3734(source[keys[k]]);
        return target;
    }
    return source;
}
function $853d8ec6f7609bd1$var$isValidKey(key) {
    return [
        "__proto__",
        "prototype",
        "constructor"
    ].indexOf(key) === -1;
}
function $853d8ec6f7609bd1$export$a05254e7c3aeba6e(key, target, source, options) {
    if (!$853d8ec6f7609bd1$var$isValidKey(key)) return;
    const tval = target[key];
    const sval = source[key];
    if ($853d8ec6f7609bd1$export$23f2a1d2818174ef(tval) && $853d8ec6f7609bd1$export$23f2a1d2818174ef(sval)) $853d8ec6f7609bd1$export$3d8c2f653ac9d0b9(tval, sval, options);
    else target[key] = $853d8ec6f7609bd1$export$b9a6b53f9be3734(sval);
}
function $853d8ec6f7609bd1$export$3d8c2f653ac9d0b9(target, source, options) {
    const sources = $853d8ec6f7609bd1$export$8b22cf2602fb60ce(source) ? source : [
        source
    ];
    const ilen = sources.length;
    if (!$853d8ec6f7609bd1$export$23f2a1d2818174ef(target)) return target;
    options = options || {};
    const merger = options.merger || $853d8ec6f7609bd1$export$a05254e7c3aeba6e;
    for(let i = 0; i < ilen; ++i){
        source = sources[i];
        if (!$853d8ec6f7609bd1$export$23f2a1d2818174ef(source)) continue;
        const keys = Object.keys(source);
        for(let k = 0, klen = keys.length; k < klen; ++k)merger(keys[k], target, source, options);
    }
    return target;
}
function $853d8ec6f7609bd1$export$2e2af4578d910ddf(target, source) {
    return $853d8ec6f7609bd1$export$3d8c2f653ac9d0b9(target, source, {
        merger: $853d8ec6f7609bd1$export$23ebac1979863676
    });
}
function $853d8ec6f7609bd1$export$23ebac1979863676(key, target, source) {
    if (!$853d8ec6f7609bd1$var$isValidKey(key)) return;
    const tval = target[key];
    const sval = source[key];
    if ($853d8ec6f7609bd1$export$23f2a1d2818174ef(tval) && $853d8ec6f7609bd1$export$23f2a1d2818174ef(sval)) $853d8ec6f7609bd1$export$2e2af4578d910ddf(tval, sval);
    else if (!Object.prototype.hasOwnProperty.call(target, key)) target[key] = $853d8ec6f7609bd1$export$b9a6b53f9be3734(sval);
}
function $853d8ec6f7609bd1$export$91477dc880baac21(scope, value, previous, current) {
    if (value !== undefined) console.warn(scope + ': "' + previous + '" is deprecated. Please use "' + current + '" instead');
}
const $853d8ec6f7609bd1$var$emptyString = "";
const $853d8ec6f7609bd1$var$dot = ".";
function $853d8ec6f7609bd1$var$indexOfDotOrLength(key, start) {
    const idx = key.indexOf($853d8ec6f7609bd1$var$dot, start);
    return idx === -1 ? key.length : idx;
}
function $853d8ec6f7609bd1$export$2d1720544b23b823(obj, key) {
    if (key === $853d8ec6f7609bd1$var$emptyString) return obj;
    let pos = 0;
    let idx = $853d8ec6f7609bd1$var$indexOfDotOrLength(key, pos);
    while(obj && idx > pos){
        obj = obj[key.substr(pos, idx - pos)];
        pos = idx + 1;
        idx = $853d8ec6f7609bd1$var$indexOfDotOrLength(key, pos);
    }
    return obj;
}
function $853d8ec6f7609bd1$export$34aec0b863436764(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}
const $853d8ec6f7609bd1$export$dda1d9f60106f0e9 = (value)=>typeof value !== "undefined";
const $853d8ec6f7609bd1$export$ce26c07117d59d6a = (value)=>typeof value === "function";
const $853d8ec6f7609bd1$export$555508cbc6add439 = (a, b)=>{
    if (a.size !== b.size) return false;
    for (const item of a){
        if (!b.has(item)) return false;
    }
    return true;
};
const $853d8ec6f7609bd1$export$56c0d5a1e737357d = Math.PI;
const $853d8ec6f7609bd1$export$971d5caa766a69d7 = 2 * $853d8ec6f7609bd1$export$56c0d5a1e737357d;
const $853d8ec6f7609bd1$export$d377dcb2b61d6c4e = $853d8ec6f7609bd1$export$971d5caa766a69d7 + $853d8ec6f7609bd1$export$56c0d5a1e737357d;
const $853d8ec6f7609bd1$export$667d3bf0c5f83305 = Number.POSITIVE_INFINITY;
const $853d8ec6f7609bd1$export$317a3d46287192d8 = $853d8ec6f7609bd1$export$56c0d5a1e737357d / 180;
const $853d8ec6f7609bd1$export$7f8ddf7c7c20b3cd = $853d8ec6f7609bd1$export$56c0d5a1e737357d / 2;
const $853d8ec6f7609bd1$export$1ee57be6f6687d2c = $853d8ec6f7609bd1$export$56c0d5a1e737357d / 4;
const $853d8ec6f7609bd1$export$9d0e2d13d04f7070 = $853d8ec6f7609bd1$export$56c0d5a1e737357d * 2 / 3;
const $853d8ec6f7609bd1$export$9bb611d729802a56 = Math.log10;
const $853d8ec6f7609bd1$export$2408f22a0fab9ae5 = Math.sign;
function $853d8ec6f7609bd1$export$91c6e00c14e7e6fd(range) {
    const roundedRange = Math.round(range);
    range = $853d8ec6f7609bd1$export$890c4ad488842ce7(range, roundedRange, range / 1000) ? roundedRange : range;
    const niceRange = Math.pow(10, Math.floor($853d8ec6f7609bd1$export$9bb611d729802a56(range)));
    const fraction = range / niceRange;
    const niceFraction = fraction <= 1 ? 1 : fraction <= 2 ? 2 : fraction <= 5 ? 5 : 10;
    return niceFraction * niceRange;
}
function $853d8ec6f7609bd1$export$b4171a6734a65d42(value) {
    const result = [];
    const sqrt = Math.sqrt(value);
    let i;
    for(i = 1; i < sqrt; i++)if (value % i === 0) {
        result.push(i);
        result.push(value / i);
    }
    if (sqrt === (sqrt | 0)) result.push(sqrt);
    result.sort((a, b)=>a - b).pop();
    return result;
}
function $853d8ec6f7609bd1$export$ffb5f4729a158638(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
}
function $853d8ec6f7609bd1$export$890c4ad488842ce7(x, y, epsilon) {
    return Math.abs(x - y) < epsilon;
}
function $853d8ec6f7609bd1$export$9d398bebfec1c039(x, epsilon) {
    const rounded = Math.round(x);
    return rounded - epsilon <= x && rounded + epsilon >= x;
}
function $853d8ec6f7609bd1$export$3d12bd131bb975d1(array, target, property) {
    let i, ilen, value;
    for(i = 0, ilen = array.length; i < ilen; i++){
        value = array[i][property];
        if (!isNaN(value)) {
            target.min = Math.min(target.min, value);
            target.max = Math.max(target.max, value);
        }
    }
}
function $853d8ec6f7609bd1$export$625550452a3fa3ec(degrees) {
    return degrees * ($853d8ec6f7609bd1$export$56c0d5a1e737357d / 180);
}
function $853d8ec6f7609bd1$export$a07804094c3ecf2d(radians) {
    return radians * (180 / $853d8ec6f7609bd1$export$56c0d5a1e737357d);
}
function $853d8ec6f7609bd1$export$24baa2b76016ce0e(x) {
    if (!$853d8ec6f7609bd1$export$39b482c5e57630a8(x)) return;
    let e = 1;
    let p = 0;
    while(Math.round(x * e) / e !== x){
        e *= 10;
        p++;
    }
    return p;
}
function $853d8ec6f7609bd1$export$4c3d22f3d993c33f(centrePoint, anglePoint) {
    const distanceFromXCenter = anglePoint.x - centrePoint.x;
    const distanceFromYCenter = anglePoint.y - centrePoint.y;
    const radialDistanceFromCenter = Math.sqrt(distanceFromXCenter * distanceFromXCenter + distanceFromYCenter * distanceFromYCenter);
    let angle = Math.atan2(distanceFromYCenter, distanceFromXCenter);
    if (angle < -0.5 * $853d8ec6f7609bd1$export$56c0d5a1e737357d) angle += $853d8ec6f7609bd1$export$971d5caa766a69d7;
    return {
        angle: angle,
        distance: radialDistanceFromCenter
    };
}
function $853d8ec6f7609bd1$export$28f7fcd39efa255(pt1, pt2) {
    return Math.sqrt(Math.pow(pt2.x - pt1.x, 2) + Math.pow(pt2.y - pt1.y, 2));
}
function $853d8ec6f7609bd1$export$1a8f5705751d8277(a, b) {
    return (a - b + $853d8ec6f7609bd1$export$d377dcb2b61d6c4e) % $853d8ec6f7609bd1$export$971d5caa766a69d7 - $853d8ec6f7609bd1$export$56c0d5a1e737357d;
}
function $853d8ec6f7609bd1$export$6554612db691658e(a) {
    return (a % $853d8ec6f7609bd1$export$971d5caa766a69d7 + $853d8ec6f7609bd1$export$971d5caa766a69d7) % $853d8ec6f7609bd1$export$971d5caa766a69d7;
}
function $853d8ec6f7609bd1$export$ae1af26003f05816(angle, start, end, sameAngleIsFullCircle) {
    const a = $853d8ec6f7609bd1$export$6554612db691658e(angle);
    const s = $853d8ec6f7609bd1$export$6554612db691658e(start);
    const e = $853d8ec6f7609bd1$export$6554612db691658e(end);
    const angleToStart = $853d8ec6f7609bd1$export$6554612db691658e(s - a);
    const angleToEnd = $853d8ec6f7609bd1$export$6554612db691658e(e - a);
    const startToAngle = $853d8ec6f7609bd1$export$6554612db691658e(a - s);
    const endToAngle = $853d8ec6f7609bd1$export$6554612db691658e(a - e);
    return a === s || a === e || sameAngleIsFullCircle && s === e || angleToStart > angleToEnd && startToAngle < endToAngle;
}
function $853d8ec6f7609bd1$export$9e5f44173e64f162(value, min, max) {
    return Math.max(min, Math.min(max, value));
}
function $853d8ec6f7609bd1$export$3722cfe417b6ed86(value) {
    return $853d8ec6f7609bd1$export$9e5f44173e64f162(value, -32768, 32767);
}
const $853d8ec6f7609bd1$var$atEdge = (t)=>t === 0 || t === 1;
const $853d8ec6f7609bd1$var$elasticIn = (t, s, p)=>-(Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * $853d8ec6f7609bd1$export$971d5caa766a69d7 / p));
const $853d8ec6f7609bd1$var$elasticOut = (t, s, p)=>Math.pow(2, -10 * t) * Math.sin((t - s) * $853d8ec6f7609bd1$export$971d5caa766a69d7 / p) + 1;
const $853d8ec6f7609bd1$export$f1e1789686576879 = {
    linear: (t)=>t,
    easeInQuad: (t)=>t * t,
    easeOutQuad: (t)=>-t * (t - 2),
    easeInOutQuad: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t : -0.5 * (--t * (t - 2) - 1),
    easeInCubic: (t)=>t * t * t,
    easeOutCubic: (t)=>(t -= 1) * t * t + 1,
    easeInOutCubic: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t * t : 0.5 * ((t -= 2) * t * t + 2),
    easeInQuart: (t)=>t * t * t * t,
    easeOutQuart: (t)=>-((t -= 1) * t * t * t - 1),
    easeInOutQuart: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t * t * t : -0.5 * ((t -= 2) * t * t * t - 2),
    easeInQuint: (t)=>t * t * t * t * t,
    easeOutQuint: (t)=>(t -= 1) * t * t * t * t + 1,
    easeInOutQuint: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t * t * t * t : 0.5 * ((t -= 2) * t * t * t * t + 2),
    easeInSine: (t)=>-Math.cos(t * $853d8ec6f7609bd1$export$7f8ddf7c7c20b3cd) + 1,
    easeOutSine: (t)=>Math.sin(t * $853d8ec6f7609bd1$export$7f8ddf7c7c20b3cd),
    easeInOutSine: (t)=>-0.5 * (Math.cos($853d8ec6f7609bd1$export$56c0d5a1e737357d * t) - 1),
    easeInExpo: (t)=>t === 0 ? 0 : Math.pow(2, 10 * (t - 1)),
    easeOutExpo: (t)=>t === 1 ? 1 : -Math.pow(2, -10 * t) + 1,
    easeInOutExpo: (t)=>$853d8ec6f7609bd1$var$atEdge(t) ? t : t < 0.5 ? 0.5 * Math.pow(2, 10 * (t * 2 - 1)) : 0.5 * (-Math.pow(2, -10 * (t * 2 - 1)) + 2),
    easeInCirc: (t)=>t >= 1 ? t : -(Math.sqrt(1 - t * t) - 1),
    easeOutCirc: (t)=>Math.sqrt(1 - (t -= 1) * t),
    easeInOutCirc: (t)=>(t /= 0.5) < 1 ? -0.5 * (Math.sqrt(1 - t * t) - 1) : 0.5 * (Math.sqrt(1 - (t -= 2) * t) + 1),
    easeInElastic: (t)=>$853d8ec6f7609bd1$var$atEdge(t) ? t : $853d8ec6f7609bd1$var$elasticIn(t, 0.075, 0.3),
    easeOutElastic: (t)=>$853d8ec6f7609bd1$var$atEdge(t) ? t : $853d8ec6f7609bd1$var$elasticOut(t, 0.075, 0.3),
    easeInOutElastic (t) {
        const s = 0.1125;
        const p = 0.45;
        return $853d8ec6f7609bd1$var$atEdge(t) ? t : t < 0.5 ? 0.5 * $853d8ec6f7609bd1$var$elasticIn(t * 2, s, p) : 0.5 + 0.5 * $853d8ec6f7609bd1$var$elasticOut(t * 2 - 1, s, p);
    },
    easeInBack (t) {
        const s = 1.70158;
        return t * t * ((s + 1) * t - s);
    },
    easeOutBack (t) {
        const s = 1.70158;
        return (t -= 1) * t * ((s + 1) * t + s) + 1;
    },
    easeInOutBack (t) {
        let s = 1.70158;
        if ((t /= 0.5) < 1) return 0.5 * (t * t * (((s *= 1.525) + 1) * t - s));
        return 0.5 * ((t -= 2) * t * (((s *= 1.525) + 1) * t + s) + 2);
    },
    easeInBounce: (t)=>1 - $853d8ec6f7609bd1$export$f1e1789686576879.easeOutBounce(1 - t),
    easeOutBounce (t) {
        const m = 7.5625;
        const d = 2.75;
        if (t < 1 / d) return m * t * t;
        if (t < 2 / d) return m * (t -= 1.5 / d) * t + 0.75;
        if (t < 2.5 / d) return m * (t -= 2.25 / d) * t + 0.9375;
        return m * (t -= 2.625 / d) * t + 0.984375;
    },
    easeInOutBounce: (t)=>t < 0.5 ? $853d8ec6f7609bd1$export$f1e1789686576879.easeInBounce(t * 2) * 0.5 : $853d8ec6f7609bd1$export$f1e1789686576879.easeOutBounce(t * 2 - 1) * 0.5 + 0.5
};
/*!
 * @kurkle/color v0.1.9
 * https://github.com/kurkle/color#readme
 * (c) 2020 Jukka Kurkela
 * Released under the MIT License
 */ const $853d8ec6f7609bd1$var$map = {
    0: 0,
    1: 1,
    2: 2,
    3: 3,
    4: 4,
    5: 5,
    6: 6,
    7: 7,
    8: 8,
    9: 9,
    A: 10,
    B: 11,
    C: 12,
    D: 13,
    E: 14,
    F: 15,
    a: 10,
    b: 11,
    c: 12,
    d: 13,
    e: 14,
    f: 15
};
const $853d8ec6f7609bd1$var$hex = "0123456789ABCDEF";
const $853d8ec6f7609bd1$var$h1 = (b)=>$853d8ec6f7609bd1$var$hex[b & 0xF];
const $853d8ec6f7609bd1$var$h2 = (b)=>$853d8ec6f7609bd1$var$hex[(b & 0xF0) >> 4] + $853d8ec6f7609bd1$var$hex[b & 0xF];
const $853d8ec6f7609bd1$var$eq = (b)=>(b & 0xF0) >> 4 === (b & 0xF);
function $853d8ec6f7609bd1$var$isShort(v) {
    return $853d8ec6f7609bd1$var$eq(v.r) && $853d8ec6f7609bd1$var$eq(v.g) && $853d8ec6f7609bd1$var$eq(v.b) && $853d8ec6f7609bd1$var$eq(v.a);
}
function $853d8ec6f7609bd1$var$hexParse(str) {
    var len = str.length;
    var ret;
    if (str[0] === "#") {
        if (len === 4 || len === 5) ret = {
            r: 255 & $853d8ec6f7609bd1$var$map[str[1]] * 17,
            g: 255 & $853d8ec6f7609bd1$var$map[str[2]] * 17,
            b: 255 & $853d8ec6f7609bd1$var$map[str[3]] * 17,
            a: len === 5 ? $853d8ec6f7609bd1$var$map[str[4]] * 17 : 255
        };
        else if (len === 7 || len === 9) ret = {
            r: $853d8ec6f7609bd1$var$map[str[1]] << 4 | $853d8ec6f7609bd1$var$map[str[2]],
            g: $853d8ec6f7609bd1$var$map[str[3]] << 4 | $853d8ec6f7609bd1$var$map[str[4]],
            b: $853d8ec6f7609bd1$var$map[str[5]] << 4 | $853d8ec6f7609bd1$var$map[str[6]],
            a: len === 9 ? $853d8ec6f7609bd1$var$map[str[7]] << 4 | $853d8ec6f7609bd1$var$map[str[8]] : 255
        };
    }
    return ret;
}
function $853d8ec6f7609bd1$var$hexString(v) {
    var f = $853d8ec6f7609bd1$var$isShort(v) ? $853d8ec6f7609bd1$var$h1 : $853d8ec6f7609bd1$var$h2;
    return v ? "#" + f(v.r) + f(v.g) + f(v.b) + (v.a < 255 ? f(v.a) : "") : v;
}
function $853d8ec6f7609bd1$var$round(v) {
    return v + 0.5 | 0;
}
const $853d8ec6f7609bd1$var$lim = (v, l, h)=>Math.max(Math.min(v, h), l);
function $853d8ec6f7609bd1$var$p2b(v) {
    return $853d8ec6f7609bd1$var$lim($853d8ec6f7609bd1$var$round(v * 2.55), 0, 255);
}
function $853d8ec6f7609bd1$var$n2b(v) {
    return $853d8ec6f7609bd1$var$lim($853d8ec6f7609bd1$var$round(v * 255), 0, 255);
}
function $853d8ec6f7609bd1$var$b2n(v) {
    return $853d8ec6f7609bd1$var$lim($853d8ec6f7609bd1$var$round(v / 2.55) / 100, 0, 1);
}
function $853d8ec6f7609bd1$var$n2p(v) {
    return $853d8ec6f7609bd1$var$lim($853d8ec6f7609bd1$var$round(v * 100), 0, 100);
}
const $853d8ec6f7609bd1$var$RGB_RE = /^rgba?\(\s*([-+.\d]+)(%)?[\s,]+([-+.e\d]+)(%)?[\s,]+([-+.e\d]+)(%)?(?:[\s,/]+([-+.e\d]+)(%)?)?\s*\)$/;
function $853d8ec6f7609bd1$var$rgbParse(str) {
    const m = $853d8ec6f7609bd1$var$RGB_RE.exec(str);
    let a = 255;
    let r, g, b;
    if (!m) return;
    if (m[7] !== r) {
        const v = +m[7];
        a = 255 & (m[8] ? $853d8ec6f7609bd1$var$p2b(v) : v * 255);
    }
    r = +m[1];
    g = +m[3];
    b = +m[5];
    r = 255 & (m[2] ? $853d8ec6f7609bd1$var$p2b(r) : r);
    g = 255 & (m[4] ? $853d8ec6f7609bd1$var$p2b(g) : g);
    b = 255 & (m[6] ? $853d8ec6f7609bd1$var$p2b(b) : b);
    return {
        r: r,
        g: g,
        b: b,
        a: a
    };
}
function $853d8ec6f7609bd1$var$rgbString(v) {
    return v && (v.a < 255 ? `rgba(${v.r}, ${v.g}, ${v.b}, ${$853d8ec6f7609bd1$var$b2n(v.a)})` : `rgb(${v.r}, ${v.g}, ${v.b})`);
}
const $853d8ec6f7609bd1$var$HUE_RE = /^(hsla?|hwb|hsv)\(\s*([-+.e\d]+)(?:deg)?[\s,]+([-+.e\d]+)%[\s,]+([-+.e\d]+)%(?:[\s,]+([-+.e\d]+)(%)?)?\s*\)$/;
function $853d8ec6f7609bd1$var$hsl2rgbn(h, s, l) {
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    return [
        f(0),
        f(8),
        f(4)
    ];
}
function $853d8ec6f7609bd1$var$hsv2rgbn(h, s, v) {
    const f = (n, k = (n + h / 60) % 6)=>v - v * s * Math.max(Math.min(k, 4 - k, 1), 0);
    return [
        f(5),
        f(3),
        f(1)
    ];
}
function $853d8ec6f7609bd1$var$hwb2rgbn(h, w, b) {
    const rgb = $853d8ec6f7609bd1$var$hsl2rgbn(h, 1, 0.5);
    let i;
    if (w + b > 1) {
        i = 1 / (w + b);
        w *= i;
        b *= i;
    }
    for(i = 0; i < 3; i++){
        rgb[i] *= 1 - w - b;
        rgb[i] += w;
    }
    return rgb;
}
function $853d8ec6f7609bd1$var$rgb2hsl(v) {
    const range = 255;
    const r = v.r / range;
    const g = v.g / range;
    const b = v.b / range;
    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);
    const l = (max + min) / 2;
    let h, s, d;
    if (max !== min) {
        d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        h = max === r ? (g - b) / d + (g < b ? 6 : 0) : max === g ? (b - r) / d + 2 : (r - g) / d + 4;
        h = h * 60 + 0.5;
    }
    return [
        h | 0,
        s || 0,
        l
    ];
}
function $853d8ec6f7609bd1$var$calln(f, a, b, c) {
    return (Array.isArray(a) ? f(a[0], a[1], a[2]) : f(a, b, c)).map($853d8ec6f7609bd1$var$n2b);
}
function $853d8ec6f7609bd1$var$hsl2rgb(h, s, l) {
    return $853d8ec6f7609bd1$var$calln($853d8ec6f7609bd1$var$hsl2rgbn, h, s, l);
}
function $853d8ec6f7609bd1$var$hwb2rgb(h, w, b) {
    return $853d8ec6f7609bd1$var$calln($853d8ec6f7609bd1$var$hwb2rgbn, h, w, b);
}
function $853d8ec6f7609bd1$var$hsv2rgb(h, s, v) {
    return $853d8ec6f7609bd1$var$calln($853d8ec6f7609bd1$var$hsv2rgbn, h, s, v);
}
function $853d8ec6f7609bd1$var$hue(h) {
    return (h % 360 + 360) % 360;
}
function $853d8ec6f7609bd1$var$hueParse(str) {
    const m = $853d8ec6f7609bd1$var$HUE_RE.exec(str);
    let a = 255;
    let v;
    if (!m) return;
    if (m[5] !== v) a = m[6] ? $853d8ec6f7609bd1$var$p2b(+m[5]) : $853d8ec6f7609bd1$var$n2b(+m[5]);
    const h = $853d8ec6f7609bd1$var$hue(+m[2]);
    const p1 = +m[3] / 100;
    const p2 = +m[4] / 100;
    if (m[1] === "hwb") v = $853d8ec6f7609bd1$var$hwb2rgb(h, p1, p2);
    else if (m[1] === "hsv") v = $853d8ec6f7609bd1$var$hsv2rgb(h, p1, p2);
    else v = $853d8ec6f7609bd1$var$hsl2rgb(h, p1, p2);
    return {
        r: v[0],
        g: v[1],
        b: v[2],
        a: a
    };
}
function $853d8ec6f7609bd1$var$rotate(v, deg) {
    var h = $853d8ec6f7609bd1$var$rgb2hsl(v);
    h[0] = $853d8ec6f7609bd1$var$hue(h[0] + deg);
    h = $853d8ec6f7609bd1$var$hsl2rgb(h);
    v.r = h[0];
    v.g = h[1];
    v.b = h[2];
}
function $853d8ec6f7609bd1$var$hslString(v) {
    if (!v) return;
    const a = $853d8ec6f7609bd1$var$rgb2hsl(v);
    const h = a[0];
    const s = $853d8ec6f7609bd1$var$n2p(a[1]);
    const l = $853d8ec6f7609bd1$var$n2p(a[2]);
    return v.a < 255 ? `hsla(${h}, ${s}%, ${l}%, ${$853d8ec6f7609bd1$var$b2n(v.a)})` : `hsl(${h}, ${s}%, ${l}%)`;
}
const $853d8ec6f7609bd1$var$map$1 = {
    x: "dark",
    Z: "light",
    Y: "re",
    X: "blu",
    W: "gr",
    V: "medium",
    U: "slate",
    A: "ee",
    T: "ol",
    S: "or",
    B: "ra",
    C: "lateg",
    D: "ights",
    R: "in",
    Q: "turquois",
    E: "hi",
    P: "ro",
    O: "al",
    N: "le",
    M: "de",
    L: "yello",
    F: "en",
    K: "ch",
    G: "arks",
    H: "ea",
    I: "ightg",
    J: "wh"
};
const $853d8ec6f7609bd1$var$names = {
    OiceXe: "f0f8ff",
    antiquewEte: "faebd7",
    aqua: "ffff",
    aquamarRe: "7fffd4",
    azuY: "f0ffff",
    beige: "f5f5dc",
    bisque: "ffe4c4",
    black: "0",
    blanKedOmond: "ffebcd",
    Xe: "ff",
    XeviTet: "8a2be2",
    bPwn: "a52a2a",
    burlywood: "deb887",
    caMtXe: "5f9ea0",
    KartYuse: "7fff00",
    KocTate: "d2691e",
    cSO: "ff7f50",
    cSnflowerXe: "6495ed",
    cSnsilk: "fff8dc",
    crimson: "dc143c",
    cyan: "ffff",
    xXe: "8b",
    xcyan: "8b8b",
    xgTMnPd: "b8860b",
    xWay: "a9a9a9",
    xgYF: "6400",
    xgYy: "a9a9a9",
    xkhaki: "bdb76b",
    xmagFta: "8b008b",
    xTivegYF: "556b2f",
    xSange: "ff8c00",
    xScEd: "9932cc",
    xYd: "8b0000",
    xsOmon: "e9967a",
    xsHgYF: "8fbc8f",
    xUXe: "483d8b",
    xUWay: "2f4f4f",
    xUgYy: "2f4f4f",
    xQe: "ced1",
    xviTet: "9400d3",
    dAppRk: "ff1493",
    dApskyXe: "bfff",
    dimWay: "696969",
    dimgYy: "696969",
    dodgerXe: "1e90ff",
    fiYbrick: "b22222",
    flSOwEte: "fffaf0",
    foYstWAn: "228b22",
    fuKsia: "ff00ff",
    gaRsbSo: "dcdcdc",
    ghostwEte: "f8f8ff",
    gTd: "ffd700",
    gTMnPd: "daa520",
    Way: "808080",
    gYF: "8000",
    gYFLw: "adff2f",
    gYy: "808080",
    honeyMw: "f0fff0",
    hotpRk: "ff69b4",
    RdianYd: "cd5c5c",
    Rdigo: "4b0082",
    ivSy: "fffff0",
    khaki: "f0e68c",
    lavFMr: "e6e6fa",
    lavFMrXsh: "fff0f5",
    lawngYF: "7cfc00",
    NmoncEffon: "fffacd",
    ZXe: "add8e6",
    ZcSO: "f08080",
    Zcyan: "e0ffff",
    ZgTMnPdLw: "fafad2",
    ZWay: "d3d3d3",
    ZgYF: "90ee90",
    ZgYy: "d3d3d3",
    ZpRk: "ffb6c1",
    ZsOmon: "ffa07a",
    ZsHgYF: "20b2aa",
    ZskyXe: "87cefa",
    ZUWay: "778899",
    ZUgYy: "778899",
    ZstAlXe: "b0c4de",
    ZLw: "ffffe0",
    lime: "ff00",
    limegYF: "32cd32",
    lRF: "faf0e6",
    magFta: "ff00ff",
    maPon: "800000",
    VaquamarRe: "66cdaa",
    VXe: "cd",
    VScEd: "ba55d3",
    VpurpN: "9370db",
    VsHgYF: "3cb371",
    VUXe: "7b68ee",
    VsprRggYF: "fa9a",
    VQe: "48d1cc",
    VviTetYd: "c71585",
    midnightXe: "191970",
    mRtcYam: "f5fffa",
    mistyPse: "ffe4e1",
    moccasR: "ffe4b5",
    navajowEte: "ffdead",
    navy: "80",
    Tdlace: "fdf5e6",
    Tive: "808000",
    TivedBb: "6b8e23",
    Sange: "ffa500",
    SangeYd: "ff4500",
    ScEd: "da70d6",
    pOegTMnPd: "eee8aa",
    pOegYF: "98fb98",
    pOeQe: "afeeee",
    pOeviTetYd: "db7093",
    papayawEp: "ffefd5",
    pHKpuff: "ffdab9",
    peru: "cd853f",
    pRk: "ffc0cb",
    plum: "dda0dd",
    powMrXe: "b0e0e6",
    purpN: "800080",
    YbeccapurpN: "663399",
    Yd: "ff0000",
    Psybrown: "bc8f8f",
    PyOXe: "4169e1",
    saddNbPwn: "8b4513",
    sOmon: "fa8072",
    sandybPwn: "f4a460",
    sHgYF: "2e8b57",
    sHshell: "fff5ee",
    siFna: "a0522d",
    silver: "c0c0c0",
    skyXe: "87ceeb",
    UXe: "6a5acd",
    UWay: "708090",
    UgYy: "708090",
    snow: "fffafa",
    sprRggYF: "ff7f",
    stAlXe: "4682b4",
    tan: "d2b48c",
    teO: "8080",
    tEstN: "d8bfd8",
    tomato: "ff6347",
    Qe: "40e0d0",
    viTet: "ee82ee",
    JHt: "f5deb3",
    wEte: "ffffff",
    wEtesmoke: "f5f5f5",
    Lw: "ffff00",
    LwgYF: "9acd32"
};
function $853d8ec6f7609bd1$var$unpack() {
    const unpacked = {};
    const keys = Object.keys($853d8ec6f7609bd1$var$names);
    const tkeys = Object.keys($853d8ec6f7609bd1$var$map$1);
    let i, j, k, ok, nk;
    for(i = 0; i < keys.length; i++){
        ok = nk = keys[i];
        for(j = 0; j < tkeys.length; j++){
            k = tkeys[j];
            nk = nk.replace(k, $853d8ec6f7609bd1$var$map$1[k]);
        }
        k = parseInt($853d8ec6f7609bd1$var$names[ok], 16);
        unpacked[nk] = [
            k >> 16 & 0xFF,
            k >> 8 & 0xFF,
            k & 0xFF
        ];
    }
    return unpacked;
}
let $853d8ec6f7609bd1$var$names$1;
function $853d8ec6f7609bd1$var$nameParse(str) {
    if (!$853d8ec6f7609bd1$var$names$1) {
        $853d8ec6f7609bd1$var$names$1 = $853d8ec6f7609bd1$var$unpack();
        $853d8ec6f7609bd1$var$names$1.transparent = [
            0,
            0,
            0,
            0
        ];
    }
    const a = $853d8ec6f7609bd1$var$names$1[str.toLowerCase()];
    return a && {
        r: a[0],
        g: a[1],
        b: a[2],
        a: a.length === 4 ? a[3] : 255
    };
}
function $853d8ec6f7609bd1$var$modHSL(v, i, ratio) {
    if (v) {
        let tmp = $853d8ec6f7609bd1$var$rgb2hsl(v);
        tmp[i] = Math.max(0, Math.min(tmp[i] + tmp[i] * ratio, i === 0 ? 360 : 1));
        tmp = $853d8ec6f7609bd1$var$hsl2rgb(tmp);
        v.r = tmp[0];
        v.g = tmp[1];
        v.b = tmp[2];
    }
}
function $853d8ec6f7609bd1$var$clone(v, proto) {
    return v ? Object.assign(proto || {}, v) : v;
}
function $853d8ec6f7609bd1$var$fromObject(input) {
    var v = {
        r: 0,
        g: 0,
        b: 0,
        a: 255
    };
    if (Array.isArray(input)) {
        if (input.length >= 3) {
            v = {
                r: input[0],
                g: input[1],
                b: input[2],
                a: 255
            };
            if (input.length > 3) v.a = $853d8ec6f7609bd1$var$n2b(input[3]);
        }
    } else {
        v = $853d8ec6f7609bd1$var$clone(input, {
            r: 0,
            g: 0,
            b: 0,
            a: 1
        });
        v.a = $853d8ec6f7609bd1$var$n2b(v.a);
    }
    return v;
}
function $853d8ec6f7609bd1$var$functionParse(str) {
    if (str.charAt(0) === "r") return $853d8ec6f7609bd1$var$rgbParse(str);
    return $853d8ec6f7609bd1$var$hueParse(str);
}
class $853d8ec6f7609bd1$var$Color {
    constructor(input){
        if (input instanceof $853d8ec6f7609bd1$var$Color) return input;
        const type = typeof input;
        let v;
        if (type === "object") v = $853d8ec6f7609bd1$var$fromObject(input);
        else if (type === "string") v = $853d8ec6f7609bd1$var$hexParse(input) || $853d8ec6f7609bd1$var$nameParse(input) || $853d8ec6f7609bd1$var$functionParse(input);
        this._rgb = v;
        this._valid = !!v;
    }
    get valid() {
        return this._valid;
    }
    get rgb() {
        var v = $853d8ec6f7609bd1$var$clone(this._rgb);
        if (v) v.a = $853d8ec6f7609bd1$var$b2n(v.a);
        return v;
    }
    set rgb(obj) {
        this._rgb = $853d8ec6f7609bd1$var$fromObject(obj);
    }
    rgbString() {
        return this._valid ? $853d8ec6f7609bd1$var$rgbString(this._rgb) : this._rgb;
    }
    hexString() {
        return this._valid ? $853d8ec6f7609bd1$var$hexString(this._rgb) : this._rgb;
    }
    hslString() {
        return this._valid ? $853d8ec6f7609bd1$var$hslString(this._rgb) : this._rgb;
    }
    mix(color, weight) {
        const me = this;
        if (color) {
            const c1 = me.rgb;
            const c2 = color.rgb;
            let w2;
            const p = weight === w2 ? 0.5 : weight;
            const w = 2 * p - 1;
            const a = c1.a - c2.a;
            const w1 = ((w * a === -1 ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
            w2 = 1 - w1;
            c1.r = 0xFF & w1 * c1.r + w2 * c2.r + 0.5;
            c1.g = 0xFF & w1 * c1.g + w2 * c2.g + 0.5;
            c1.b = 0xFF & w1 * c1.b + w2 * c2.b + 0.5;
            c1.a = p * c1.a + (1 - p) * c2.a;
            me.rgb = c1;
        }
        return me;
    }
    clone() {
        return new $853d8ec6f7609bd1$var$Color(this.rgb);
    }
    alpha(a) {
        this._rgb.a = $853d8ec6f7609bd1$var$n2b(a);
        return this;
    }
    clearer(ratio) {
        const rgb = this._rgb;
        rgb.a *= 1 - ratio;
        return this;
    }
    greyscale() {
        const rgb = this._rgb;
        const val = $853d8ec6f7609bd1$var$round(rgb.r * 0.3 + rgb.g * 0.59 + rgb.b * 0.11);
        rgb.r = rgb.g = rgb.b = val;
        return this;
    }
    opaquer(ratio) {
        const rgb = this._rgb;
        rgb.a *= 1 + ratio;
        return this;
    }
    negate() {
        const v = this._rgb;
        v.r = 255 - v.r;
        v.g = 255 - v.g;
        v.b = 255 - v.b;
        return this;
    }
    lighten(ratio) {
        $853d8ec6f7609bd1$var$modHSL(this._rgb, 2, ratio);
        return this;
    }
    darken(ratio) {
        $853d8ec6f7609bd1$var$modHSL(this._rgb, 2, -ratio);
        return this;
    }
    saturate(ratio) {
        $853d8ec6f7609bd1$var$modHSL(this._rgb, 1, ratio);
        return this;
    }
    desaturate(ratio) {
        $853d8ec6f7609bd1$var$modHSL(this._rgb, 1, -ratio);
        return this;
    }
    rotate(deg) {
        $853d8ec6f7609bd1$var$rotate(this._rgb, deg);
        return this;
    }
}
function $853d8ec6f7609bd1$var$index_esm(input) {
    return new $853d8ec6f7609bd1$var$Color(input);
}
const $853d8ec6f7609bd1$var$isPatternOrGradient = (value)=>value instanceof CanvasGradient || value instanceof CanvasPattern;
function $853d8ec6f7609bd1$export$db3b6bfb95261072(value) {
    return $853d8ec6f7609bd1$var$isPatternOrGradient(value) ? value : $853d8ec6f7609bd1$var$index_esm(value);
}
function $853d8ec6f7609bd1$export$a33b77bbdbb8366c(value) {
    return $853d8ec6f7609bd1$var$isPatternOrGradient(value) ? value : $853d8ec6f7609bd1$var$index_esm(value).saturate(0.5).darken(0.1).hexString();
}
const $853d8ec6f7609bd1$export$dc98b0b04f4c7758 = Object.create(null);
const $853d8ec6f7609bd1$export$3c2fa207a37baaea = Object.create(null);
function $853d8ec6f7609bd1$var$getScope$1(node, key) {
    if (!key) return node;
    const keys = key.split(".");
    for(let i = 0, n = keys.length; i < n; ++i){
        const k = keys[i];
        node = node[k] || (node[k] = Object.create(null));
    }
    return node;
}
function $853d8ec6f7609bd1$var$set(root, scope, values) {
    if (typeof scope === "string") return $853d8ec6f7609bd1$export$3d8c2f653ac9d0b9($853d8ec6f7609bd1$var$getScope$1(root, scope), values);
    return $853d8ec6f7609bd1$export$3d8c2f653ac9d0b9($853d8ec6f7609bd1$var$getScope$1(root, ""), scope);
}
class $853d8ec6f7609bd1$var$Defaults {
    constructor(_descriptors){
        this.animation = undefined;
        this.backgroundColor = "rgba(0,0,0,0.1)";
        this.borderColor = "rgba(0,0,0,0.1)";
        this.color = "#666";
        this.datasets = {};
        this.devicePixelRatio = (context)=>context.chart.platform.getDevicePixelRatio();
        this.elements = {};
        this.events = [
            "mousemove",
            "mouseout",
            "click",
            "touchstart",
            "touchmove"
        ];
        this.font = {
            family: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
            size: 12,
            style: "normal",
            lineHeight: 1.2,
            weight: null
        };
        this.hover = {};
        this.hoverBackgroundColor = (ctx, options)=>$853d8ec6f7609bd1$export$a33b77bbdbb8366c(options.backgroundColor);
        this.hoverBorderColor = (ctx, options)=>$853d8ec6f7609bd1$export$a33b77bbdbb8366c(options.borderColor);
        this.hoverColor = (ctx, options)=>$853d8ec6f7609bd1$export$a33b77bbdbb8366c(options.color);
        this.indexAxis = "x";
        this.interaction = {
            mode: "nearest",
            intersect: true
        };
        this.maintainAspectRatio = true;
        this.onHover = null;
        this.onClick = null;
        this.parsing = true;
        this.plugins = {};
        this.responsive = true;
        this.scale = undefined;
        this.scales = {};
        this.showLine = true;
        this.describe(_descriptors);
    }
    set(scope, values) {
        return $853d8ec6f7609bd1$var$set(this, scope, values);
    }
    get(scope) {
        return $853d8ec6f7609bd1$var$getScope$1(this, scope);
    }
    describe(scope, values) {
        return $853d8ec6f7609bd1$var$set($853d8ec6f7609bd1$export$3c2fa207a37baaea, scope, values);
    }
    override(scope, values) {
        return $853d8ec6f7609bd1$var$set($853d8ec6f7609bd1$export$dc98b0b04f4c7758, scope, values);
    }
    route(scope, name, targetScope, targetName) {
        const scopeObject = $853d8ec6f7609bd1$var$getScope$1(this, scope);
        const targetScopeObject = $853d8ec6f7609bd1$var$getScope$1(this, targetScope);
        const privateName = "_" + name;
        Object.defineProperties(scopeObject, {
            [privateName]: {
                value: scopeObject[name],
                writable: true
            },
            [name]: {
                enumerable: true,
                get () {
                    const local = this[privateName];
                    const target = targetScopeObject[targetName];
                    if ($853d8ec6f7609bd1$export$23f2a1d2818174ef(local)) return Object.assign({}, target, local);
                    return $853d8ec6f7609bd1$export$90a7f3efeed30595(local, target);
                },
                set (value) {
                    this[privateName] = value;
                }
            }
        });
    }
}
var $853d8ec6f7609bd1$export$4368d992c4eafac0 = new $853d8ec6f7609bd1$var$Defaults({
    _scriptable: (name)=>!name.startsWith("on"),
    _indexable: (name)=>name !== "events",
    hover: {
        _fallback: "interaction"
    },
    interaction: {
        _scriptable: false,
        _indexable: false
    }
});
function $853d8ec6f7609bd1$export$9f4f30ee63539e24(font) {
    if (!font || $853d8ec6f7609bd1$export$35e795649ee09318(font.size) || $853d8ec6f7609bd1$export$35e795649ee09318(font.family)) return null;
    return (font.style ? font.style + " " : "") + (font.weight ? font.weight + " " : "") + font.size + "px " + font.family;
}
function $853d8ec6f7609bd1$export$c4ce752e73470fba(ctx, data, gc, longest, string) {
    let textWidth = data[string];
    if (!textWidth) {
        textWidth = data[string] = ctx.measureText(string).width;
        gc.push(string);
    }
    if (textWidth > longest) longest = textWidth;
    return longest;
}
function $853d8ec6f7609bd1$export$158acd800e1ef08b(ctx, font, arrayOfThings, cache) {
    cache = cache || {};
    let data = cache.data = cache.data || {};
    let gc = cache.garbageCollect = cache.garbageCollect || [];
    if (cache.font !== font) {
        data = cache.data = {};
        gc = cache.garbageCollect = [];
        cache.font = font;
    }
    ctx.save();
    ctx.font = font;
    let longest = 0;
    const ilen = arrayOfThings.length;
    let i, j, jlen, thing, nestedThing;
    for(i = 0; i < ilen; i++){
        thing = arrayOfThings[i];
        if (thing !== undefined && thing !== null && $853d8ec6f7609bd1$export$8b22cf2602fb60ce(thing) !== true) longest = $853d8ec6f7609bd1$export$c4ce752e73470fba(ctx, data, gc, longest, thing);
        else if ($853d8ec6f7609bd1$export$8b22cf2602fb60ce(thing)) for(j = 0, jlen = thing.length; j < jlen; j++){
            nestedThing = thing[j];
            if (nestedThing !== undefined && nestedThing !== null && !$853d8ec6f7609bd1$export$8b22cf2602fb60ce(nestedThing)) longest = $853d8ec6f7609bd1$export$c4ce752e73470fba(ctx, data, gc, longest, nestedThing);
        }
    }
    ctx.restore();
    const gcLen = gc.length / 2;
    if (gcLen > arrayOfThings.length) {
        for(i = 0; i < gcLen; i++)delete data[gc[i]];
        gc.splice(0, gcLen);
    }
    return longest;
}
function $853d8ec6f7609bd1$export$db202ddc8be9136(chart, pixel, width) {
    const devicePixelRatio = chart.currentDevicePixelRatio;
    const halfWidth = width !== 0 ? Math.max(width / 2, 0.5) : 0;
    return Math.round((pixel - halfWidth) * devicePixelRatio) / devicePixelRatio + halfWidth;
}
function $853d8ec6f7609bd1$export$7910e0436ed8d1de(canvas, ctx) {
    ctx = ctx || canvas.getContext("2d");
    ctx.save();
    ctx.resetTransform();
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.restore();
}
function $853d8ec6f7609bd1$export$306ddfe3a8403e2(ctx, options, x, y) {
    let type, xOffset, yOffset, size, cornerRadius;
    const style = options.pointStyle;
    const rotation = options.rotation;
    const radius = options.radius;
    let rad = (rotation || 0) * $853d8ec6f7609bd1$export$317a3d46287192d8;
    if (style && typeof style === "object") {
        type = style.toString();
        if (type === "[object HTMLImageElement]" || type === "[object HTMLCanvasElement]") {
            ctx.save();
            ctx.translate(x, y);
            ctx.rotate(rad);
            ctx.drawImage(style, -style.width / 2, -style.height / 2, style.width, style.height);
            ctx.restore();
            return;
        }
    }
    if (isNaN(radius) || radius <= 0) return;
    ctx.beginPath();
    switch(style){
        default:
            ctx.arc(x, y, radius, 0, $853d8ec6f7609bd1$export$971d5caa766a69d7);
            ctx.closePath();
            break;
        case "triangle":
            ctx.moveTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
            rad += $853d8ec6f7609bd1$export$9d0e2d13d04f7070;
            ctx.lineTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
            rad += $853d8ec6f7609bd1$export$9d0e2d13d04f7070;
            ctx.lineTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
            ctx.closePath();
            break;
        case "rectRounded":
            cornerRadius = radius * 0.516;
            size = radius - cornerRadius;
            xOffset = Math.cos(rad + $853d8ec6f7609bd1$export$1ee57be6f6687d2c) * size;
            yOffset = Math.sin(rad + $853d8ec6f7609bd1$export$1ee57be6f6687d2c) * size;
            ctx.arc(x - xOffset, y - yOffset, cornerRadius, rad - $853d8ec6f7609bd1$export$56c0d5a1e737357d, rad - $853d8ec6f7609bd1$export$7f8ddf7c7c20b3cd);
            ctx.arc(x + yOffset, y - xOffset, cornerRadius, rad - $853d8ec6f7609bd1$export$7f8ddf7c7c20b3cd, rad);
            ctx.arc(x + xOffset, y + yOffset, cornerRadius, rad, rad + $853d8ec6f7609bd1$export$7f8ddf7c7c20b3cd);
            ctx.arc(x - yOffset, y + xOffset, cornerRadius, rad + $853d8ec6f7609bd1$export$7f8ddf7c7c20b3cd, rad + $853d8ec6f7609bd1$export$56c0d5a1e737357d);
            ctx.closePath();
            break;
        case "rect":
            if (!rotation) {
                size = Math.SQRT1_2 * radius;
                ctx.rect(x - size, y - size, 2 * size, 2 * size);
                break;
            }
            rad += $853d8ec6f7609bd1$export$1ee57be6f6687d2c;
        case "rectRot":
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            ctx.moveTo(x - xOffset, y - yOffset);
            ctx.lineTo(x + yOffset, y - xOffset);
            ctx.lineTo(x + xOffset, y + yOffset);
            ctx.lineTo(x - yOffset, y + xOffset);
            ctx.closePath();
            break;
        case "crossRot":
            rad += $853d8ec6f7609bd1$export$1ee57be6f6687d2c;
        case "cross":
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            ctx.moveTo(x - xOffset, y - yOffset);
            ctx.lineTo(x + xOffset, y + yOffset);
            ctx.moveTo(x + yOffset, y - xOffset);
            ctx.lineTo(x - yOffset, y + xOffset);
            break;
        case "star":
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            ctx.moveTo(x - xOffset, y - yOffset);
            ctx.lineTo(x + xOffset, y + yOffset);
            ctx.moveTo(x + yOffset, y - xOffset);
            ctx.lineTo(x - yOffset, y + xOffset);
            rad += $853d8ec6f7609bd1$export$1ee57be6f6687d2c;
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            ctx.moveTo(x - xOffset, y - yOffset);
            ctx.lineTo(x + xOffset, y + yOffset);
            ctx.moveTo(x + yOffset, y - xOffset);
            ctx.lineTo(x - yOffset, y + xOffset);
            break;
        case "line":
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            ctx.moveTo(x - xOffset, y - yOffset);
            ctx.lineTo(x + xOffset, y + yOffset);
            break;
        case "dash":
            ctx.moveTo(x, y);
            ctx.lineTo(x + Math.cos(rad) * radius, y + Math.sin(rad) * radius);
            break;
    }
    ctx.fill();
    if (options.borderWidth > 0) ctx.stroke();
}
function $853d8ec6f7609bd1$export$4a5767248b18ef41(point, area, margin) {
    margin = margin || 0.5;
    return point && point.x > area.left - margin && point.x < area.right + margin && point.y > area.top - margin && point.y < area.bottom + margin;
}
function $853d8ec6f7609bd1$export$25ce5a424b770e84(ctx, area) {
    ctx.save();
    ctx.beginPath();
    ctx.rect(area.left, area.top, area.right - area.left, area.bottom - area.top);
    ctx.clip();
}
function $853d8ec6f7609bd1$export$e7c866399fa523f5(ctx) {
    ctx.restore();
}
function $853d8ec6f7609bd1$export$ab83b03e4111b1d0(ctx, previous, target, flip, mode) {
    if (!previous) return ctx.lineTo(target.x, target.y);
    if (mode === "middle") {
        const midpoint = (previous.x + target.x) / 2.0;
        ctx.lineTo(midpoint, previous.y);
        ctx.lineTo(midpoint, target.y);
    } else if (mode === "after" !== !!flip) ctx.lineTo(previous.x, target.y);
    else ctx.lineTo(target.x, previous.y);
    ctx.lineTo(target.x, target.y);
}
function $853d8ec6f7609bd1$export$1a82df3d29112e01(ctx, previous, target, flip) {
    if (!previous) return ctx.lineTo(target.x, target.y);
    ctx.bezierCurveTo(flip ? previous.cp1x : previous.cp2x, flip ? previous.cp1y : previous.cp2y, flip ? target.cp2x : target.cp1x, flip ? target.cp2y : target.cp1y, target.x, target.y);
}
function $853d8ec6f7609bd1$export$3a6d5c9ae78a2c08(ctx, text, x, y, font, opts = {}) {
    const lines = $853d8ec6f7609bd1$export$8b22cf2602fb60ce(text) ? text : [
        text
    ];
    const stroke = opts.strokeWidth > 0 && opts.strokeColor !== "";
    let i, line;
    ctx.save();
    ctx.font = font.string;
    $853d8ec6f7609bd1$var$setRenderOpts(ctx, opts);
    for(i = 0; i < lines.length; ++i){
        line = lines[i];
        if (stroke) {
            if (opts.strokeColor) ctx.strokeStyle = opts.strokeColor;
            if (!$853d8ec6f7609bd1$export$35e795649ee09318(opts.strokeWidth)) ctx.lineWidth = opts.strokeWidth;
            ctx.strokeText(line, x, y, opts.maxWidth);
        }
        ctx.fillText(line, x, y, opts.maxWidth);
        $853d8ec6f7609bd1$var$decorateText(ctx, x, y, line, opts);
        y += font.lineHeight;
    }
    ctx.restore();
}
function $853d8ec6f7609bd1$var$setRenderOpts(ctx, opts) {
    if (opts.translation) ctx.translate(opts.translation[0], opts.translation[1]);
    if (!$853d8ec6f7609bd1$export$35e795649ee09318(opts.rotation)) ctx.rotate(opts.rotation);
    if (opts.color) ctx.fillStyle = opts.color;
    if (opts.textAlign) ctx.textAlign = opts.textAlign;
    if (opts.textBaseline) ctx.textBaseline = opts.textBaseline;
}
function $853d8ec6f7609bd1$var$decorateText(ctx, x, y, line, opts) {
    if (opts.strikethrough || opts.underline) {
        const metrics = ctx.measureText(line);
        const left = x - metrics.actualBoundingBoxLeft;
        const right = x + metrics.actualBoundingBoxRight;
        const top = y - metrics.actualBoundingBoxAscent;
        const bottom = y + metrics.actualBoundingBoxDescent;
        const yDecoration = opts.strikethrough ? (top + bottom) / 2 : bottom;
        ctx.strokeStyle = ctx.fillStyle;
        ctx.beginPath();
        ctx.lineWidth = opts.decorationWidth || 2;
        ctx.moveTo(left, yDecoration);
        ctx.lineTo(right, yDecoration);
        ctx.stroke();
    }
}
function $853d8ec6f7609bd1$export$7a38258bbe170828(ctx, rect) {
    const { x: x, y: y, w: w, h: h, radius: radius } = rect;
    ctx.arc(x + radius.topLeft, y + radius.topLeft, radius.topLeft, -$853d8ec6f7609bd1$export$7f8ddf7c7c20b3cd, $853d8ec6f7609bd1$export$56c0d5a1e737357d, true);
    ctx.lineTo(x, y + h - radius.bottomLeft);
    ctx.arc(x + radius.bottomLeft, y + h - radius.bottomLeft, radius.bottomLeft, $853d8ec6f7609bd1$export$56c0d5a1e737357d, $853d8ec6f7609bd1$export$7f8ddf7c7c20b3cd, true);
    ctx.lineTo(x + w - radius.bottomRight, y + h);
    ctx.arc(x + w - radius.bottomRight, y + h - radius.bottomRight, radius.bottomRight, $853d8ec6f7609bd1$export$7f8ddf7c7c20b3cd, 0, true);
    ctx.lineTo(x + w, y + radius.topRight);
    ctx.arc(x + w - radius.topRight, y + radius.topRight, radius.topRight, 0, -$853d8ec6f7609bd1$export$7f8ddf7c7c20b3cd, true);
    ctx.lineTo(x + radius.topLeft, y);
}
const $853d8ec6f7609bd1$var$LINE_HEIGHT = new RegExp(/^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/);
const $853d8ec6f7609bd1$var$FONT_STYLE = new RegExp(/^(normal|italic|initial|inherit|unset|(oblique( -?[0-9]?[0-9]deg)?))$/);
function $853d8ec6f7609bd1$export$738ab4df8bf92ae9(value, size) {
    const matches = ("" + value).match($853d8ec6f7609bd1$var$LINE_HEIGHT);
    if (!matches || matches[1] === "normal") return size * 1.2;
    value = +matches[2];
    switch(matches[3]){
        case "px":
            return value;
        case "%":
            value /= 100;
            break;
    }
    return size * value;
}
const $853d8ec6f7609bd1$var$numberOrZero = (v)=>+v || 0;
function $853d8ec6f7609bd1$export$f787f51d84a910ad(value, props) {
    const ret = {};
    const objProps = $853d8ec6f7609bd1$export$23f2a1d2818174ef(props);
    const keys = objProps ? Object.keys(props) : props;
    const read = $853d8ec6f7609bd1$export$23f2a1d2818174ef(value) ? objProps ? (prop)=>$853d8ec6f7609bd1$export$90a7f3efeed30595(value[prop], value[props[prop]]) : (prop)=>value[prop] : ()=>value;
    for (const prop of keys)ret[prop] = $853d8ec6f7609bd1$var$numberOrZero(read(prop));
    return ret;
}
function $853d8ec6f7609bd1$export$2f6ca3d3b1f80bf5(value) {
    return $853d8ec6f7609bd1$export$f787f51d84a910ad(value, {
        top: "y",
        right: "x",
        bottom: "y",
        left: "x"
    });
}
function $853d8ec6f7609bd1$export$8a5498727ef6be21(value) {
    return $853d8ec6f7609bd1$export$f787f51d84a910ad(value, [
        "topLeft",
        "topRight",
        "bottomLeft",
        "bottomRight"
    ]);
}
function $853d8ec6f7609bd1$export$ebd11618f299a286(value) {
    const obj = $853d8ec6f7609bd1$export$2f6ca3d3b1f80bf5(value);
    obj.width = obj.left + obj.right;
    obj.height = obj.top + obj.bottom;
    return obj;
}
function $853d8ec6f7609bd1$export$71cec2538cb2c617(options, fallback) {
    options = options || {};
    fallback = fallback || $853d8ec6f7609bd1$export$4368d992c4eafac0.font;
    let size = $853d8ec6f7609bd1$export$90a7f3efeed30595(options.size, fallback.size);
    if (typeof size === "string") size = parseInt(size, 10);
    let style = $853d8ec6f7609bd1$export$90a7f3efeed30595(options.style, fallback.style);
    if (style && !("" + style).match($853d8ec6f7609bd1$var$FONT_STYLE)) {
        console.warn('Invalid font style specified: "' + style + '"');
        style = "";
    }
    const font = {
        family: $853d8ec6f7609bd1$export$90a7f3efeed30595(options.family, fallback.family),
        lineHeight: $853d8ec6f7609bd1$export$738ab4df8bf92ae9($853d8ec6f7609bd1$export$90a7f3efeed30595(options.lineHeight, fallback.lineHeight), size),
        size: size,
        style: style,
        weight: $853d8ec6f7609bd1$export$90a7f3efeed30595(options.weight, fallback.weight),
        string: ""
    };
    font.string = $853d8ec6f7609bd1$export$9f4f30ee63539e24(font);
    return font;
}
function $853d8ec6f7609bd1$export$407448d2b89b1813(inputs, context, index, info) {
    let cacheable = true;
    let i, ilen, value;
    for(i = 0, ilen = inputs.length; i < ilen; ++i){
        value = inputs[i];
        if (value === undefined) continue;
        if (context !== undefined && typeof value === "function") {
            value = value(context);
            cacheable = false;
        }
        if (index !== undefined && $853d8ec6f7609bd1$export$8b22cf2602fb60ce(value)) {
            value = value[index % value.length];
            cacheable = false;
        }
        if (value !== undefined) {
            if (info && !cacheable) info.cacheable = false;
            return value;
        }
    }
}
function $853d8ec6f7609bd1$export$3a1a48c8f6ef640e(minmax, grace) {
    const { min: min, max: max } = minmax;
    return {
        min: min - Math.abs($853d8ec6f7609bd1$export$953cecd6e717a553(grace, min)),
        max: max + $853d8ec6f7609bd1$export$953cecd6e717a553(grace, max)
    };
}
function $853d8ec6f7609bd1$export$53a70dd1ebbae346(table, value, cmp) {
    cmp = cmp || ((index)=>table[index] < value);
    let hi = table.length - 1;
    let lo = 0;
    let mid;
    while(hi - lo > 1){
        mid = lo + hi >> 1;
        if (cmp(mid)) lo = mid;
        else hi = mid;
    }
    return {
        lo: lo,
        hi: hi
    };
}
const $853d8ec6f7609bd1$export$efccba1c4a2ef57b = (table, key, value)=>$853d8ec6f7609bd1$export$53a70dd1ebbae346(table, value, (index)=>table[index][key] < value);
const $853d8ec6f7609bd1$export$df995fae86a55f06 = (table, key, value)=>$853d8ec6f7609bd1$export$53a70dd1ebbae346(table, value, (index)=>table[index][key] >= value);
function $853d8ec6f7609bd1$export$cf2f7c5792f80b46(values, min, max) {
    let start = 0;
    let end = values.length;
    while(start < end && values[start] < min)start++;
    while(end > start && values[end - 1] > max)end--;
    return start > 0 || end < values.length ? values.slice(start, end) : values;
}
const $853d8ec6f7609bd1$var$arrayEvents = [
    "push",
    "pop",
    "shift",
    "splice",
    "unshift"
];
function $853d8ec6f7609bd1$export$882b5998b3b9117c(array, listener) {
    if (array._chartjs) {
        array._chartjs.listeners.push(listener);
        return;
    }
    Object.defineProperty(array, "_chartjs", {
        configurable: true,
        enumerable: false,
        value: {
            listeners: [
                listener
            ]
        }
    });
    $853d8ec6f7609bd1$var$arrayEvents.forEach((key)=>{
        const method = "_onData" + $853d8ec6f7609bd1$export$34aec0b863436764(key);
        const base = array[key];
        Object.defineProperty(array, key, {
            configurable: true,
            enumerable: false,
            value (...args) {
                const res = base.apply(this, args);
                array._chartjs.listeners.forEach((object)=>{
                    if (typeof object[method] === "function") object[method](...args);
                });
                return res;
            }
        });
    });
}
function $853d8ec6f7609bd1$export$3b14a55fb2447963(array, listener) {
    const stub = array._chartjs;
    if (!stub) return;
    const listeners = stub.listeners;
    const index = listeners.indexOf(listener);
    if (index !== -1) listeners.splice(index, 1);
    if (listeners.length > 0) return;
    $853d8ec6f7609bd1$var$arrayEvents.forEach((key)=>{
        delete array[key];
    });
    delete array._chartjs;
}
function $853d8ec6f7609bd1$export$71511d61b312f219(items) {
    const set = new Set();
    let i, ilen;
    for(i = 0, ilen = items.length; i < ilen; ++i)set.add(items[i]);
    if (set.size === ilen) return items;
    return Array.from(set);
}
function $853d8ec6f7609bd1$export$efca4cbe5dd06740(scopes, prefixes = [
    ""
], rootScopes = scopes, fallback, getTarget = ()=>scopes[0]) {
    if (!$853d8ec6f7609bd1$export$dda1d9f60106f0e9(fallback)) fallback = $853d8ec6f7609bd1$var$_resolve("_fallback", scopes);
    const cache = {
        [Symbol.toStringTag]: "Object",
        _cacheable: true,
        _scopes: scopes,
        _rootScopes: rootScopes,
        _fallback: fallback,
        _getTarget: getTarget,
        override: (scope)=>$853d8ec6f7609bd1$export$efca4cbe5dd06740([
                scope,
                ...scopes
            ], prefixes, rootScopes, fallback)
    };
    return new Proxy(cache, {
        deleteProperty (target, prop) {
            delete target[prop];
            delete target._keys;
            delete scopes[0][prop];
            return true;
        },
        get (target, prop) {
            return $853d8ec6f7609bd1$var$_cached(target, prop, ()=>$853d8ec6f7609bd1$var$_resolveWithPrefixes(prop, prefixes, scopes, target));
        },
        getOwnPropertyDescriptor (target, prop) {
            return Reflect.getOwnPropertyDescriptor(target._scopes[0], prop);
        },
        getPrototypeOf () {
            return Reflect.getPrototypeOf(scopes[0]);
        },
        has (target, prop) {
            return $853d8ec6f7609bd1$var$getKeysFromAllScopes(target).includes(prop);
        },
        ownKeys (target) {
            return $853d8ec6f7609bd1$var$getKeysFromAllScopes(target);
        },
        set (target, prop, value) {
            const storage = target._storage || (target._storage = getTarget());
            storage[prop] = value;
            delete target[prop];
            delete target._keys;
            return true;
        }
    });
}
function $853d8ec6f7609bd1$export$6559d589eb85fbb6(proxy, context, subProxy, descriptorDefaults) {
    const cache = {
        _cacheable: false,
        _proxy: proxy,
        _context: context,
        _subProxy: subProxy,
        _stack: new Set(),
        _descriptors: $853d8ec6f7609bd1$export$a8550f7dbe79f93a(proxy, descriptorDefaults),
        setContext: (ctx)=>$853d8ec6f7609bd1$export$6559d589eb85fbb6(proxy, ctx, subProxy, descriptorDefaults),
        override: (scope)=>$853d8ec6f7609bd1$export$6559d589eb85fbb6(proxy.override(scope), context, subProxy, descriptorDefaults)
    };
    return new Proxy(cache, {
        deleteProperty (target, prop) {
            delete target[prop];
            delete proxy[prop];
            return true;
        },
        get (target, prop, receiver) {
            return $853d8ec6f7609bd1$var$_cached(target, prop, ()=>$853d8ec6f7609bd1$var$_resolveWithContext(target, prop, receiver));
        },
        getOwnPropertyDescriptor (target, prop) {
            return target._descriptors.allKeys ? Reflect.has(proxy, prop) ? {
                enumerable: true,
                configurable: true
            } : undefined : Reflect.getOwnPropertyDescriptor(proxy, prop);
        },
        getPrototypeOf () {
            return Reflect.getPrototypeOf(proxy);
        },
        has (target, prop) {
            return Reflect.has(proxy, prop);
        },
        ownKeys () {
            return Reflect.ownKeys(proxy);
        },
        set (target, prop, value) {
            proxy[prop] = value;
            delete target[prop];
            return true;
        }
    });
}
function $853d8ec6f7609bd1$export$a8550f7dbe79f93a(proxy, defaults = {
    scriptable: true,
    indexable: true
}) {
    const { _scriptable: _scriptable = defaults.scriptable, _indexable: _indexable = defaults.indexable, _allKeys: _allKeys = defaults.allKeys } = proxy;
    return {
        allKeys: _allKeys,
        scriptable: _scriptable,
        indexable: _indexable,
        isScriptable: $853d8ec6f7609bd1$export$ce26c07117d59d6a(_scriptable) ? _scriptable : ()=>_scriptable,
        isIndexable: $853d8ec6f7609bd1$export$ce26c07117d59d6a(_indexable) ? _indexable : ()=>_indexable
    };
}
const $853d8ec6f7609bd1$var$readKey = (prefix, name)=>prefix ? prefix + $853d8ec6f7609bd1$export$34aec0b863436764(name) : name;
const $853d8ec6f7609bd1$var$needsSubResolver = (prop, value)=>$853d8ec6f7609bd1$export$23f2a1d2818174ef(value) && prop !== "adapters";
function $853d8ec6f7609bd1$var$_cached(target, prop, resolve) {
    let value = target[prop];
    if ($853d8ec6f7609bd1$export$dda1d9f60106f0e9(value)) return value;
    value = resolve();
    if ($853d8ec6f7609bd1$export$dda1d9f60106f0e9(value)) target[prop] = value;
    return value;
}
function $853d8ec6f7609bd1$var$_resolveWithContext(target, prop, receiver) {
    const { _proxy: _proxy, _context: _context, _subProxy: _subProxy, _descriptors: descriptors } = target;
    let value = _proxy[prop];
    if ($853d8ec6f7609bd1$export$ce26c07117d59d6a(value) && descriptors.isScriptable(prop)) value = $853d8ec6f7609bd1$var$_resolveScriptable(prop, value, target, receiver);
    if ($853d8ec6f7609bd1$export$8b22cf2602fb60ce(value) && value.length) value = $853d8ec6f7609bd1$var$_resolveArray(prop, value, target, descriptors.isIndexable);
    if ($853d8ec6f7609bd1$var$needsSubResolver(prop, value)) value = $853d8ec6f7609bd1$export$6559d589eb85fbb6(value, _context, _subProxy && _subProxy[prop], descriptors);
    return value;
}
function $853d8ec6f7609bd1$var$_resolveScriptable(prop, value, target, receiver) {
    const { _proxy: _proxy, _context: _context, _subProxy: _subProxy, _stack: _stack } = target;
    if (_stack.has(prop)) throw new Error("Recursion detected: " + Array.from(_stack).join("->") + "->" + prop);
    _stack.add(prop);
    value = value(_context, _subProxy || receiver);
    _stack.delete(prop);
    if ($853d8ec6f7609bd1$export$23f2a1d2818174ef(value)) value = $853d8ec6f7609bd1$var$createSubResolver(_proxy._scopes, _proxy, prop, value);
    return value;
}
function $853d8ec6f7609bd1$var$_resolveArray(prop, value, target, isIndexable) {
    const { _proxy: _proxy, _context: _context, _subProxy: _subProxy, _descriptors: descriptors } = target;
    if ($853d8ec6f7609bd1$export$dda1d9f60106f0e9(_context.index) && isIndexable(prop)) value = value[_context.index % value.length];
    else if ($853d8ec6f7609bd1$export$23f2a1d2818174ef(value[0])) {
        const arr = value;
        const scopes = _proxy._scopes.filter((s)=>s !== arr);
        value = [];
        for (const item of arr){
            const resolver = $853d8ec6f7609bd1$var$createSubResolver(scopes, _proxy, prop, item);
            value.push($853d8ec6f7609bd1$export$6559d589eb85fbb6(resolver, _context, _subProxy && _subProxy[prop], descriptors));
        }
    }
    return value;
}
function $853d8ec6f7609bd1$var$resolveFallback(fallback, prop, value) {
    return $853d8ec6f7609bd1$export$ce26c07117d59d6a(fallback) ? fallback(prop, value) : fallback;
}
const $853d8ec6f7609bd1$var$getScope = (key, parent)=>key === true ? parent : typeof key === "string" ? $853d8ec6f7609bd1$export$2d1720544b23b823(parent, key) : undefined;
function $853d8ec6f7609bd1$var$addScopes(set, parentScopes, key, parentFallback) {
    for (const parent of parentScopes){
        const scope = $853d8ec6f7609bd1$var$getScope(key, parent);
        if (scope) {
            set.add(scope);
            const fallback = $853d8ec6f7609bd1$var$resolveFallback(scope._fallback, key, scope);
            if ($853d8ec6f7609bd1$export$dda1d9f60106f0e9(fallback) && fallback !== key && fallback !== parentFallback) return fallback;
        } else if (scope === false && $853d8ec6f7609bd1$export$dda1d9f60106f0e9(parentFallback) && key !== parentFallback) return null;
    }
    return false;
}
function $853d8ec6f7609bd1$var$createSubResolver(parentScopes, resolver, prop, value) {
    const rootScopes = resolver._rootScopes;
    const fallback = $853d8ec6f7609bd1$var$resolveFallback(resolver._fallback, prop, value);
    const allScopes = [
        ...parentScopes,
        ...rootScopes
    ];
    const set = new Set();
    set.add(value);
    let key = $853d8ec6f7609bd1$var$addScopesFromKey(set, allScopes, prop, fallback || prop);
    if (key === null) return false;
    if ($853d8ec6f7609bd1$export$dda1d9f60106f0e9(fallback) && fallback !== prop) {
        key = $853d8ec6f7609bd1$var$addScopesFromKey(set, allScopes, fallback, key);
        if (key === null) return false;
    }
    return $853d8ec6f7609bd1$export$efca4cbe5dd06740(Array.from(set), [
        ""
    ], rootScopes, fallback, ()=>$853d8ec6f7609bd1$var$subGetTarget(resolver, prop, value));
}
function $853d8ec6f7609bd1$var$addScopesFromKey(set, allScopes, key, fallback) {
    while(key)key = $853d8ec6f7609bd1$var$addScopes(set, allScopes, key, fallback);
    return key;
}
function $853d8ec6f7609bd1$var$subGetTarget(resolver, prop, value) {
    const parent = resolver._getTarget();
    if (!(prop in parent)) parent[prop] = {};
    const target = parent[prop];
    if ($853d8ec6f7609bd1$export$8b22cf2602fb60ce(target) && $853d8ec6f7609bd1$export$23f2a1d2818174ef(value)) return value;
    return target;
}
function $853d8ec6f7609bd1$var$_resolveWithPrefixes(prop, prefixes, scopes, proxy) {
    let value;
    for (const prefix of prefixes){
        value = $853d8ec6f7609bd1$var$_resolve($853d8ec6f7609bd1$var$readKey(prefix, prop), scopes);
        if ($853d8ec6f7609bd1$export$dda1d9f60106f0e9(value)) return $853d8ec6f7609bd1$var$needsSubResolver(prop, value) ? $853d8ec6f7609bd1$var$createSubResolver(scopes, proxy, prop, value) : value;
    }
}
function $853d8ec6f7609bd1$var$_resolve(key, scopes) {
    for (const scope of scopes){
        if (!scope) continue;
        const value = scope[key];
        if ($853d8ec6f7609bd1$export$dda1d9f60106f0e9(value)) return value;
    }
}
function $853d8ec6f7609bd1$var$getKeysFromAllScopes(target) {
    let keys = target._keys;
    if (!keys) keys = target._keys = $853d8ec6f7609bd1$var$resolveKeysFromAllScopes(target._scopes);
    return keys;
}
function $853d8ec6f7609bd1$var$resolveKeysFromAllScopes(scopes) {
    const set = new Set();
    for (const scope of scopes)for (const key of Object.keys(scope).filter((k)=>!k.startsWith("_")))set.add(key);
    return Array.from(set);
}
const $853d8ec6f7609bd1$var$EPSILON = Number.EPSILON || 1e-14;
const $853d8ec6f7609bd1$var$getPoint = (points, i)=>i < points.length && !points[i].skip && points[i];
const $853d8ec6f7609bd1$var$getValueAxis = (indexAxis)=>indexAxis === "x" ? "y" : "x";
function $853d8ec6f7609bd1$export$faec65b429be379(firstPoint, middlePoint, afterPoint, t) {
    const previous = firstPoint.skip ? middlePoint : firstPoint;
    const current = middlePoint;
    const next = afterPoint.skip ? middlePoint : afterPoint;
    const d01 = $853d8ec6f7609bd1$export$28f7fcd39efa255(current, previous);
    const d12 = $853d8ec6f7609bd1$export$28f7fcd39efa255(next, current);
    let s01 = d01 / (d01 + d12);
    let s12 = d12 / (d01 + d12);
    s01 = isNaN(s01) ? 0 : s01;
    s12 = isNaN(s12) ? 0 : s12;
    const fa = t * s01;
    const fb = t * s12;
    return {
        previous: {
            x: current.x - fa * (next.x - previous.x),
            y: current.y - fa * (next.y - previous.y)
        },
        next: {
            x: current.x + fb * (next.x - previous.x),
            y: current.y + fb * (next.y - previous.y)
        }
    };
}
function $853d8ec6f7609bd1$var$monotoneAdjust(points, deltaK, mK) {
    const pointsLen = points.length;
    let alphaK, betaK, tauK, squaredMagnitude, pointCurrent;
    let pointAfter = $853d8ec6f7609bd1$var$getPoint(points, 0);
    for(let i = 0; i < pointsLen - 1; ++i){
        pointCurrent = pointAfter;
        pointAfter = $853d8ec6f7609bd1$var$getPoint(points, i + 1);
        if (!pointCurrent || !pointAfter) continue;
        if ($853d8ec6f7609bd1$export$890c4ad488842ce7(deltaK[i], 0, $853d8ec6f7609bd1$var$EPSILON)) {
            mK[i] = mK[i + 1] = 0;
            continue;
        }
        alphaK = mK[i] / deltaK[i];
        betaK = mK[i + 1] / deltaK[i];
        squaredMagnitude = Math.pow(alphaK, 2) + Math.pow(betaK, 2);
        if (squaredMagnitude <= 9) continue;
        tauK = 3 / Math.sqrt(squaredMagnitude);
        mK[i] = alphaK * tauK * deltaK[i];
        mK[i + 1] = betaK * tauK * deltaK[i];
    }
}
function $853d8ec6f7609bd1$var$monotoneCompute(points, mK, indexAxis = "x") {
    const valueAxis = $853d8ec6f7609bd1$var$getValueAxis(indexAxis);
    const pointsLen = points.length;
    let delta, pointBefore, pointCurrent;
    let pointAfter = $853d8ec6f7609bd1$var$getPoint(points, 0);
    for(let i = 0; i < pointsLen; ++i){
        pointBefore = pointCurrent;
        pointCurrent = pointAfter;
        pointAfter = $853d8ec6f7609bd1$var$getPoint(points, i + 1);
        if (!pointCurrent) continue;
        const iPixel = pointCurrent[indexAxis];
        const vPixel = pointCurrent[valueAxis];
        if (pointBefore) {
            delta = (iPixel - pointBefore[indexAxis]) / 3;
            pointCurrent[`cp1${indexAxis}`] = iPixel - delta;
            pointCurrent[`cp1${valueAxis}`] = vPixel - delta * mK[i];
        }
        if (pointAfter) {
            delta = (pointAfter[indexAxis] - iPixel) / 3;
            pointCurrent[`cp2${indexAxis}`] = iPixel + delta;
            pointCurrent[`cp2${valueAxis}`] = vPixel + delta * mK[i];
        }
    }
}
function $853d8ec6f7609bd1$export$c03999cb2f36933f(points, indexAxis = "x") {
    const valueAxis = $853d8ec6f7609bd1$var$getValueAxis(indexAxis);
    const pointsLen = points.length;
    const deltaK = Array(pointsLen).fill(0);
    const mK = Array(pointsLen);
    let i, pointBefore, pointCurrent;
    let pointAfter = $853d8ec6f7609bd1$var$getPoint(points, 0);
    for(i = 0; i < pointsLen; ++i){
        pointBefore = pointCurrent;
        pointCurrent = pointAfter;
        pointAfter = $853d8ec6f7609bd1$var$getPoint(points, i + 1);
        if (!pointCurrent) continue;
        if (pointAfter) {
            const slopeDelta = pointAfter[indexAxis] - pointCurrent[indexAxis];
            deltaK[i] = slopeDelta !== 0 ? (pointAfter[valueAxis] - pointCurrent[valueAxis]) / slopeDelta : 0;
        }
        mK[i] = !pointBefore ? deltaK[i] : !pointAfter ? deltaK[i - 1] : $853d8ec6f7609bd1$export$2408f22a0fab9ae5(deltaK[i - 1]) !== $853d8ec6f7609bd1$export$2408f22a0fab9ae5(deltaK[i]) ? 0 : (deltaK[i - 1] + deltaK[i]) / 2;
    }
    $853d8ec6f7609bd1$var$monotoneAdjust(points, deltaK, mK);
    $853d8ec6f7609bd1$var$monotoneCompute(points, mK, indexAxis);
}
function $853d8ec6f7609bd1$var$capControlPoint(pt, min, max) {
    return Math.max(Math.min(pt, max), min);
}
function $853d8ec6f7609bd1$var$capBezierPoints(points, area) {
    let i, ilen, point, inArea, inAreaPrev;
    let inAreaNext = $853d8ec6f7609bd1$export$4a5767248b18ef41(points[0], area);
    for(i = 0, ilen = points.length; i < ilen; ++i){
        inAreaPrev = inArea;
        inArea = inAreaNext;
        inAreaNext = i < ilen - 1 && $853d8ec6f7609bd1$export$4a5767248b18ef41(points[i + 1], area);
        if (!inArea) continue;
        point = points[i];
        if (inAreaPrev) {
            point.cp1x = $853d8ec6f7609bd1$var$capControlPoint(point.cp1x, area.left, area.right);
            point.cp1y = $853d8ec6f7609bd1$var$capControlPoint(point.cp1y, area.top, area.bottom);
        }
        if (inAreaNext) {
            point.cp2x = $853d8ec6f7609bd1$var$capControlPoint(point.cp2x, area.left, area.right);
            point.cp2y = $853d8ec6f7609bd1$var$capControlPoint(point.cp2y, area.top, area.bottom);
        }
    }
}
function $853d8ec6f7609bd1$export$c9170ad7d4cd7e57(points, options, area, loop, indexAxis) {
    let i, ilen, point, controlPoints;
    if (options.spanGaps) points = points.filter((pt)=>!pt.skip);
    if (options.cubicInterpolationMode === "monotone") $853d8ec6f7609bd1$export$c03999cb2f36933f(points, indexAxis);
    else {
        let prev = loop ? points[points.length - 1] : points[0];
        for(i = 0, ilen = points.length; i < ilen; ++i){
            point = points[i];
            controlPoints = $853d8ec6f7609bd1$export$faec65b429be379(prev, point, points[Math.min(i + 1, ilen - (loop ? 0 : 1)) % ilen], options.tension);
            point.cp1x = controlPoints.previous.x;
            point.cp1y = controlPoints.previous.y;
            point.cp2x = controlPoints.next.x;
            point.cp2y = controlPoints.next.y;
            prev = point;
        }
    }
    if (options.capBezierPoints) $853d8ec6f7609bd1$var$capBezierPoints(points, area);
}
function $853d8ec6f7609bd1$export$96f57966bedc81b4(domNode) {
    let parent = domNode.parentNode;
    if (parent && parent.toString() === "[object ShadowRoot]") parent = parent.host;
    return parent;
}
function $853d8ec6f7609bd1$var$parseMaxStyle(styleValue, node, parentProperty) {
    let valueInPixels;
    if (typeof styleValue === "string") {
        valueInPixels = parseInt(styleValue, 10);
        if (styleValue.indexOf("%") !== -1) valueInPixels = valueInPixels / 100 * node.parentNode[parentProperty];
    } else valueInPixels = styleValue;
    return valueInPixels;
}
const $853d8ec6f7609bd1$var$getComputedStyle = (element)=>window.getComputedStyle(element, null);
function $853d8ec6f7609bd1$export$2ed0fc6709e59212(el, property) {
    return $853d8ec6f7609bd1$var$getComputedStyle(el).getPropertyValue(property);
}
const $853d8ec6f7609bd1$var$positions = [
    "top",
    "right",
    "bottom",
    "left"
];
function $853d8ec6f7609bd1$var$getPositionedStyle(styles, style, suffix) {
    const result = {};
    suffix = suffix ? "-" + suffix : "";
    for(let i = 0; i < 4; i++){
        const pos = $853d8ec6f7609bd1$var$positions[i];
        result[pos] = parseFloat(styles[style + "-" + pos + suffix]) || 0;
    }
    result.width = result.left + result.right;
    result.height = result.top + result.bottom;
    return result;
}
const $853d8ec6f7609bd1$var$useOffsetPos = (x, y, target)=>(x > 0 || y > 0) && (!target || !target.shadowRoot);
function $853d8ec6f7609bd1$var$getCanvasPosition(evt, canvas) {
    const e = evt.native || evt;
    const touches = e.touches;
    const source = touches && touches.length ? touches[0] : e;
    const { offsetX: offsetX, offsetY: offsetY } = source;
    let box = false;
    let x, y;
    if ($853d8ec6f7609bd1$var$useOffsetPos(offsetX, offsetY, e.target)) {
        x = offsetX;
        y = offsetY;
    } else {
        const rect = canvas.getBoundingClientRect();
        x = source.clientX - rect.left;
        y = source.clientY - rect.top;
        box = true;
    }
    return {
        x: x,
        y: y,
        box: box
    };
}
function $853d8ec6f7609bd1$export$d141bba7fdc215a3(evt, chart) {
    const { canvas: canvas, currentDevicePixelRatio: currentDevicePixelRatio } = chart;
    const style = $853d8ec6f7609bd1$var$getComputedStyle(canvas);
    const borderBox = style.boxSizing === "border-box";
    const paddings = $853d8ec6f7609bd1$var$getPositionedStyle(style, "padding");
    const borders = $853d8ec6f7609bd1$var$getPositionedStyle(style, "border", "width");
    const { x: x, y: y, box: box } = $853d8ec6f7609bd1$var$getCanvasPosition(evt, canvas);
    const xOffset = paddings.left + (box && borders.left);
    const yOffset = paddings.top + (box && borders.top);
    let { width: width, height: height } = chart;
    if (borderBox) {
        width -= paddings.width + borders.width;
        height -= paddings.height + borders.height;
    }
    return {
        x: Math.round((x - xOffset) / width * canvas.width / currentDevicePixelRatio),
        y: Math.round((y - yOffset) / height * canvas.height / currentDevicePixelRatio)
    };
}
function $853d8ec6f7609bd1$var$getContainerSize(canvas, width, height) {
    let maxWidth, maxHeight;
    if (width === undefined || height === undefined) {
        const container = $853d8ec6f7609bd1$export$96f57966bedc81b4(canvas);
        if (!container) {
            width = canvas.clientWidth;
            height = canvas.clientHeight;
        } else {
            const rect = container.getBoundingClientRect();
            const containerStyle = $853d8ec6f7609bd1$var$getComputedStyle(container);
            const containerBorder = $853d8ec6f7609bd1$var$getPositionedStyle(containerStyle, "border", "width");
            const containerPadding = $853d8ec6f7609bd1$var$getPositionedStyle(containerStyle, "padding");
            width = rect.width - containerPadding.width - containerBorder.width;
            height = rect.height - containerPadding.height - containerBorder.height;
            maxWidth = $853d8ec6f7609bd1$var$parseMaxStyle(containerStyle.maxWidth, container, "clientWidth");
            maxHeight = $853d8ec6f7609bd1$var$parseMaxStyle(containerStyle.maxHeight, container, "clientHeight");
        }
    }
    return {
        width: width,
        height: height,
        maxWidth: maxWidth || $853d8ec6f7609bd1$export$667d3bf0c5f83305,
        maxHeight: maxHeight || $853d8ec6f7609bd1$export$667d3bf0c5f83305
    };
}
const $853d8ec6f7609bd1$var$round1 = (v)=>Math.round(v * 10) / 10;
function $853d8ec6f7609bd1$export$e7094788287c5e9b(canvas, bbWidth, bbHeight, aspectRatio) {
    const style = $853d8ec6f7609bd1$var$getComputedStyle(canvas);
    const margins = $853d8ec6f7609bd1$var$getPositionedStyle(style, "margin");
    const maxWidth = $853d8ec6f7609bd1$var$parseMaxStyle(style.maxWidth, canvas, "clientWidth") || $853d8ec6f7609bd1$export$667d3bf0c5f83305;
    const maxHeight = $853d8ec6f7609bd1$var$parseMaxStyle(style.maxHeight, canvas, "clientHeight") || $853d8ec6f7609bd1$export$667d3bf0c5f83305;
    const containerSize = $853d8ec6f7609bd1$var$getContainerSize(canvas, bbWidth, bbHeight);
    let { width: width, height: height } = containerSize;
    if (style.boxSizing === "content-box") {
        const borders = $853d8ec6f7609bd1$var$getPositionedStyle(style, "border", "width");
        const paddings = $853d8ec6f7609bd1$var$getPositionedStyle(style, "padding");
        width -= paddings.width + borders.width;
        height -= paddings.height + borders.height;
    }
    width = Math.max(0, width - margins.width);
    height = Math.max(0, aspectRatio ? Math.floor(width / aspectRatio) : height - margins.height);
    width = $853d8ec6f7609bd1$var$round1(Math.min(width, maxWidth, containerSize.maxWidth));
    height = $853d8ec6f7609bd1$var$round1(Math.min(height, maxHeight, containerSize.maxHeight));
    if (width && !height) height = $853d8ec6f7609bd1$var$round1(width / 2);
    return {
        width: width,
        height: height
    };
}
function $853d8ec6f7609bd1$export$a9c996f45e5784d0(chart, forceRatio, forceStyle) {
    const pixelRatio = forceRatio || 1;
    const deviceHeight = Math.floor(chart.height * pixelRatio);
    const deviceWidth = Math.floor(chart.width * pixelRatio);
    chart.height = deviceHeight / pixelRatio;
    chart.width = deviceWidth / pixelRatio;
    const canvas = chart.canvas;
    if (canvas.style && (forceStyle || !canvas.style.height && !canvas.style.width)) {
        canvas.style.height = `${chart.height}px`;
        canvas.style.width = `${chart.width}px`;
    }
    if (chart.currentDevicePixelRatio !== pixelRatio || canvas.height !== deviceHeight || canvas.width !== deviceWidth) {
        chart.currentDevicePixelRatio = pixelRatio;
        canvas.height = deviceHeight;
        canvas.width = deviceWidth;
        chart.ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
        return true;
    }
    return false;
}
const $853d8ec6f7609bd1$export$2329c99376c9d0a4 = function() {
    let passiveSupported = false;
    try {
        const options = {
            get passive () {
                passiveSupported = true;
                return false;
            }
        };
        window.addEventListener("test", null, options);
        window.removeEventListener("test", null, options);
    } catch (e) {}
    return passiveSupported;
}();
function $853d8ec6f7609bd1$export$a9c23c6ac3fc3eca(element, property) {
    const value = $853d8ec6f7609bd1$export$2ed0fc6709e59212(element, property);
    const matches = value && value.match(/^(\d+)(\.\d+)?px$/);
    return matches ? +matches[1] : undefined;
}
function $853d8ec6f7609bd1$export$21579262ef46735b(p1, p2, t, mode) {
    return {
        x: p1.x + t * (p2.x - p1.x),
        y: p1.y + t * (p2.y - p1.y)
    };
}
function $853d8ec6f7609bd1$export$f38c853ae54ed474(p1, p2, t, mode) {
    return {
        x: p1.x + t * (p2.x - p1.x),
        y: mode === "middle" ? t < 0.5 ? p1.y : p2.y : mode === "after" ? t < 1 ? p1.y : p2.y : t > 0 ? p2.y : p1.y
    };
}
function $853d8ec6f7609bd1$export$3b513254972cfc9c(p1, p2, t, mode) {
    const cp1 = {
        x: p1.cp2x,
        y: p1.cp2y
    };
    const cp2 = {
        x: p2.cp1x,
        y: p2.cp1y
    };
    const a = $853d8ec6f7609bd1$export$21579262ef46735b(p1, cp1, t);
    const b = $853d8ec6f7609bd1$export$21579262ef46735b(cp1, cp2, t);
    const c = $853d8ec6f7609bd1$export$21579262ef46735b(cp2, p2, t);
    const d = $853d8ec6f7609bd1$export$21579262ef46735b(a, b, t);
    const e = $853d8ec6f7609bd1$export$21579262ef46735b(b, c, t);
    return $853d8ec6f7609bd1$export$21579262ef46735b(d, e, t);
}
const $853d8ec6f7609bd1$var$intlCache = new Map();
function $853d8ec6f7609bd1$var$getNumberFormat(locale, options) {
    options = options || {};
    const cacheKey = locale + JSON.stringify(options);
    let formatter = $853d8ec6f7609bd1$var$intlCache.get(cacheKey);
    if (!formatter) {
        formatter = new Intl.NumberFormat(locale, options);
        $853d8ec6f7609bd1$var$intlCache.set(cacheKey, formatter);
    }
    return formatter;
}
function $853d8ec6f7609bd1$export$7ccc53e8f1e7dfc5(num, locale, options) {
    return $853d8ec6f7609bd1$var$getNumberFormat(locale, options).format(num);
}
const $853d8ec6f7609bd1$var$getRightToLeftAdapter = function(rectX, width) {
    return {
        x (x) {
            return rectX + rectX + width - x;
        },
        setWidth (w) {
            width = w;
        },
        textAlign (align) {
            if (align === "center") return align;
            return align === "right" ? "left" : "right";
        },
        xPlus (x, value) {
            return x - value;
        },
        leftForLtr (x, itemWidth) {
            return x - itemWidth;
        }
    };
};
const $853d8ec6f7609bd1$var$getLeftToRightAdapter = function() {
    return {
        x (x) {
            return x;
        },
        setWidth (w) {},
        textAlign (align) {
            return align;
        },
        xPlus (x, value) {
            return x + value;
        },
        leftForLtr (x, _itemWidth) {
            return x;
        }
    };
};
function $853d8ec6f7609bd1$export$493d36ec626b6698(rtl, rectX, width) {
    return rtl ? $853d8ec6f7609bd1$var$getRightToLeftAdapter(rectX, width) : $853d8ec6f7609bd1$var$getLeftToRightAdapter();
}
function $853d8ec6f7609bd1$export$1fbe638ecf81657e(ctx, direction) {
    let style, original;
    if (direction === "ltr" || direction === "rtl") {
        style = ctx.canvas.style;
        original = [
            style.getPropertyValue("direction"),
            style.getPropertyPriority("direction")
        ];
        style.setProperty("direction", direction, "important");
        ctx.prevTextDirection = original;
    }
}
function $853d8ec6f7609bd1$export$92108d983e8ee699(ctx, original) {
    if (original !== undefined) {
        delete ctx.prevTextDirection;
        ctx.canvas.style.setProperty("direction", original[0], original[1]);
    }
}
function $853d8ec6f7609bd1$var$propertyFn(property) {
    if (property === "angle") return {
        between: $853d8ec6f7609bd1$export$ae1af26003f05816,
        compare: $853d8ec6f7609bd1$export$1a8f5705751d8277,
        normalize: $853d8ec6f7609bd1$export$6554612db691658e
    };
    return {
        between: (n, s, e)=>n >= Math.min(s, e) && n <= Math.max(e, s),
        compare: (a, b)=>a - b,
        normalize: (x)=>x
    };
}
function $853d8ec6f7609bd1$var$normalizeSegment({ start: start, end: end, count: count, loop: loop, style: style }) {
    return {
        start: start % count,
        end: end % count,
        loop: loop && (end - start + 1) % count === 0,
        style: style
    };
}
function $853d8ec6f7609bd1$var$getSegment(segment, points, bounds) {
    const { property: property, start: startBound, end: endBound } = bounds;
    const { between: between, normalize: normalize } = $853d8ec6f7609bd1$var$propertyFn(property);
    const count = points.length;
    let { start: start, end: end, loop: loop } = segment;
    let i, ilen;
    if (loop) {
        start += count;
        end += count;
        for(i = 0, ilen = count; i < ilen; ++i){
            if (!between(normalize(points[start % count][property]), startBound, endBound)) break;
            start--;
            end--;
        }
        start %= count;
        end %= count;
    }
    if (end < start) end += count;
    return {
        start: start,
        end: end,
        loop: loop,
        style: segment.style
    };
}
function $853d8ec6f7609bd1$export$d24c54395ce0c509(segment, points, bounds) {
    if (!bounds) return [
        segment
    ];
    const { property: property, start: startBound, end: endBound } = bounds;
    const count = points.length;
    const { compare: compare, between: between, normalize: normalize } = $853d8ec6f7609bd1$var$propertyFn(property);
    const { start: start, end: end, loop: loop, style: style } = $853d8ec6f7609bd1$var$getSegment(segment, points, bounds);
    const result = [];
    let inside = false;
    let subStart = null;
    let value, point, prevValue;
    const startIsBefore = ()=>between(startBound, prevValue, value) && compare(startBound, prevValue) !== 0;
    const endIsBefore = ()=>compare(endBound, value) === 0 || between(endBound, prevValue, value);
    const shouldStart = ()=>inside || startIsBefore();
    const shouldStop = ()=>!inside || endIsBefore();
    for(let i = start, prev = start; i <= end; ++i){
        point = points[i % count];
        if (point.skip) continue;
        value = normalize(point[property]);
        if (value === prevValue) continue;
        inside = between(value, startBound, endBound);
        if (subStart === null && shouldStart()) subStart = compare(value, startBound) === 0 ? i : prev;
        if (subStart !== null && shouldStop()) {
            result.push($853d8ec6f7609bd1$var$normalizeSegment({
                start: subStart,
                end: i,
                loop: loop,
                count: count,
                style: style
            }));
            subStart = null;
        }
        prev = i;
        prevValue = value;
    }
    if (subStart !== null) result.push($853d8ec6f7609bd1$var$normalizeSegment({
        start: subStart,
        end: end,
        loop: loop,
        count: count,
        style: style
    }));
    return result;
}
function $853d8ec6f7609bd1$export$995eb9fca571757(line, bounds) {
    const result = [];
    const segments = line.segments;
    for(let i = 0; i < segments.length; i++){
        const sub = $853d8ec6f7609bd1$export$d24c54395ce0c509(segments[i], line.points, bounds);
        if (sub.length) result.push(...sub);
    }
    return result;
}
function $853d8ec6f7609bd1$var$findStartAndEnd(points, count, loop, spanGaps) {
    let start = 0;
    let end = count - 1;
    if (loop && !spanGaps) while(start < count && !points[start].skip)start++;
    while(start < count && points[start].skip)start++;
    start %= count;
    if (loop) end += start;
    while(end > start && points[end % count].skip)end--;
    end %= count;
    return {
        start: start,
        end: end
    };
}
function $853d8ec6f7609bd1$var$solidSegments(points, start, max, loop) {
    const count = points.length;
    const result = [];
    let last = start;
    let prev = points[start];
    let end;
    for(end = start + 1; end <= max; ++end){
        const cur = points[end % count];
        if (cur.skip || cur.stop) {
            if (!prev.skip) {
                loop = false;
                result.push({
                    start: start % count,
                    end: (end - 1) % count,
                    loop: loop
                });
                start = last = cur.stop ? end : null;
            }
        } else {
            last = end;
            if (prev.skip) start = end;
        }
        prev = cur;
    }
    if (last !== null) result.push({
        start: start % count,
        end: last % count,
        loop: loop
    });
    return result;
}
function $853d8ec6f7609bd1$export$ee7c8ad385a60b7b(line, segmentOptions) {
    const points = line.points;
    const spanGaps = line.options.spanGaps;
    const count = points.length;
    if (!count) return [];
    const loop = !!line._loop;
    const { start: start, end: end } = $853d8ec6f7609bd1$var$findStartAndEnd(points, count, loop, spanGaps);
    if (spanGaps === true) return $853d8ec6f7609bd1$var$splitByStyles([
        {
            start: start,
            end: end,
            loop: loop
        }
    ], points, segmentOptions);
    const max = end < start ? end + count : end;
    const completeLoop = !!line._fullLoop && start === 0 && end === count - 1;
    return $853d8ec6f7609bd1$var$splitByStyles($853d8ec6f7609bd1$var$solidSegments(points, start, max, completeLoop), points, segmentOptions);
}
function $853d8ec6f7609bd1$var$splitByStyles(segments, points, segmentOptions) {
    if (!segmentOptions || !segmentOptions.setContext || !points) return segments;
    return $853d8ec6f7609bd1$var$doSplitByStyles(segments, points, segmentOptions);
}
function $853d8ec6f7609bd1$var$doSplitByStyles(segments, points, segmentOptions) {
    const count = points.length;
    const result = [];
    let start = segments[0].start;
    let i = start;
    for (const segment of segments){
        let prevStyle, style;
        let prev = points[start % count];
        for(i = start + 1; i <= segment.end; i++){
            const pt = points[i % count];
            style = $853d8ec6f7609bd1$var$readStyle(segmentOptions.setContext({
                type: "segment",
                p0: prev,
                p1: pt
            }));
            if ($853d8ec6f7609bd1$var$styleChanged(style, prevStyle)) {
                result.push({
                    start: start,
                    end: i - 1,
                    loop: segment.loop,
                    style: prevStyle
                });
                prevStyle = style;
                start = i - 1;
            }
            prev = pt;
            prevStyle = style;
        }
        if (start < i - 1) {
            result.push({
                start: start,
                end: i - 1,
                loop: segment.loop,
                style: style
            });
            start = i - 1;
        }
    }
    return result;
}
function $853d8ec6f7609bd1$var$readStyle(options) {
    return {
        backgroundColor: options.backgroundColor,
        borderCapStyle: options.borderCapStyle,
        borderDash: options.borderDash,
        borderDashOffset: options.borderDashOffset,
        borderJoinStyle: options.borderJoinStyle,
        borderWidth: options.borderWidth,
        borderColor: options.borderColor
    };
}
function $853d8ec6f7609bd1$var$styleChanged(style, prevStyle) {
    return prevStyle && JSON.stringify(style) !== JSON.stringify(prevStyle);
}

});


parcelRegister("13Rru", function(module, exports) {
!function(t, e) {
    module.exports = e();
}(module.exports, function() {
    "use strict";
    var t = 1e3, e = 6e4, n = 36e5, r = "millisecond", i = "second", s = "minute", u = "hour", a = "day", o = "week", c = "month", f = "quarter", h = "year", d = "date", l = "Invalid Date", $ = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, y = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, M = {
        name: "en",
        weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
        ordinal: function(t) {
            var e = [
                "th",
                "st",
                "nd",
                "rd"
            ], n = t % 100;
            return "[" + t + (e[(n - 20) % 10] || e[n] || e[0]) + "]";
        }
    }, m = function(t, e, n) {
        var r = String(t);
        return !r || r.length >= e ? t : "" + Array(e + 1 - r.length).join(n) + t;
    }, v = {
        s: m,
        z: function(t) {
            var e = -t.utcOffset(), n = Math.abs(e), r = Math.floor(n / 60), i = n % 60;
            return (e <= 0 ? "+" : "-") + m(r, 2, "0") + ":" + m(i, 2, "0");
        },
        m: function t(e, n) {
            if (e.date() < n.date()) return -t(n, e);
            var r = 12 * (n.year() - e.year()) + (n.month() - e.month()), i = e.clone().add(r, c), s = n - i < 0, u = e.clone().add(r + (s ? -1 : 1), c);
            return +(-(r + (n - i) / (s ? i - u : u - i)) || 0);
        },
        a: function(t) {
            return t < 0 ? Math.ceil(t) || 0 : Math.floor(t);
        },
        p: function(t) {
            return ({
                M: c,
                y: h,
                w: o,
                d: a,
                D: d,
                h: u,
                m: s,
                s: i,
                ms: r,
                Q: f
            })[t] || String(t || "").toLowerCase().replace(/s$/, "");
        },
        u: function(t) {
            return void 0 === t;
        }
    }, g = "en", D = {};
    D[g] = M;
    var p = "$isDayjsObject", S = function(t) {
        return t instanceof _ || !(!t || !t[p]);
    }, w = function t(e, n, r) {
        var i;
        if (!e) return g;
        if ("string" == typeof e) {
            var s = e.toLowerCase();
            D[s] && (i = s), n && (D[s] = n, i = s);
            var u = e.split("-");
            if (!i && u.length > 1) return t(u[0]);
        } else {
            var a = e.name;
            D[a] = e, i = a;
        }
        return !r && i && (g = i), i || !r && g;
    }, O = function(t, e) {
        if (S(t)) return t.clone();
        var n = "object" == typeof e ? e : {};
        return n.date = t, n.args = arguments, new _(n);
    }, b = v;
    b.l = w, b.i = S, b.w = function(t, e) {
        return O(t, {
            locale: e.$L,
            utc: e.$u,
            x: e.$x,
            $offset: e.$offset
        });
    };
    var _ = function() {
        function M(t) {
            this.$L = w(t.locale, null, !0), this.parse(t), this.$x = this.$x || t.x || {}, this[p] = !0;
        }
        var m = M.prototype;
        return m.parse = function(t) {
            this.$d = function(t) {
                var e = t.date, n = t.utc;
                if (null === e) return new Date(NaN);
                if (b.u(e)) return new Date;
                if (e instanceof Date) return new Date(e);
                if ("string" == typeof e && !/Z$/i.test(e)) {
                    var r = e.match($);
                    if (r) {
                        var i = r[2] - 1 || 0, s = (r[7] || "0").substring(0, 3);
                        return n ? new Date(Date.UTC(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s)) : new Date(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s);
                    }
                }
                return new Date(e);
            }(t), this.init();
        }, m.init = function() {
            var t = this.$d;
            this.$y = t.getFullYear(), this.$M = t.getMonth(), this.$D = t.getDate(), this.$W = t.getDay(), this.$H = t.getHours(), this.$m = t.getMinutes(), this.$s = t.getSeconds(), this.$ms = t.getMilliseconds();
        }, m.$utils = function() {
            return b;
        }, m.isValid = function() {
            return !(this.$d.toString() === l);
        }, m.isSame = function(t, e) {
            var n = O(t);
            return this.startOf(e) <= n && n <= this.endOf(e);
        }, m.isAfter = function(t, e) {
            return O(t) < this.startOf(e);
        }, m.isBefore = function(t, e) {
            return this.endOf(e) < O(t);
        }, m.$g = function(t, e, n) {
            return b.u(t) ? this[e] : this.set(n, t);
        }, m.unix = function() {
            return Math.floor(this.valueOf() / 1e3);
        }, m.valueOf = function() {
            return this.$d.getTime();
        }, m.startOf = function(t, e) {
            var n = this, r = !!b.u(e) || e, f = b.p(t), l = function(t, e) {
                var i = b.w(n.$u ? Date.UTC(n.$y, e, t) : new Date(n.$y, e, t), n);
                return r ? i : i.endOf(a);
            }, $ = function(t, e) {
                return b.w(n.toDate()[t].apply(n.toDate("s"), (r ? [
                    0,
                    0,
                    0,
                    0
                ] : [
                    23,
                    59,
                    59,
                    999
                ]).slice(e)), n);
            }, y = this.$W, M = this.$M, m = this.$D, v = "set" + (this.$u ? "UTC" : "");
            switch(f){
                case h:
                    return r ? l(1, 0) : l(31, 11);
                case c:
                    return r ? l(1, M) : l(0, M + 1);
                case o:
                    var g = this.$locale().weekStart || 0, D = (y < g ? y + 7 : y) - g;
                    return l(r ? m - D : m + (6 - D), M);
                case a:
                case d:
                    return $(v + "Hours", 0);
                case u:
                    return $(v + "Minutes", 1);
                case s:
                    return $(v + "Seconds", 2);
                case i:
                    return $(v + "Milliseconds", 3);
                default:
                    return this.clone();
            }
        }, m.endOf = function(t) {
            return this.startOf(t, !1);
        }, m.$set = function(t, e) {
            var n, o = b.p(t), f = "set" + (this.$u ? "UTC" : ""), l = (n = {}, n[a] = f + "Date", n[d] = f + "Date", n[c] = f + "Month", n[h] = f + "FullYear", n[u] = f + "Hours", n[s] = f + "Minutes", n[i] = f + "Seconds", n[r] = f + "Milliseconds", n)[o], $ = o === a ? this.$D + (e - this.$W) : e;
            if (o === c || o === h) {
                var y = this.clone().set(d, 1);
                y.$d[l]($), y.init(), this.$d = y.set(d, Math.min(this.$D, y.daysInMonth())).$d;
            } else l && this.$d[l]($);
            return this.init(), this;
        }, m.set = function(t, e) {
            return this.clone().$set(t, e);
        }, m.get = function(t) {
            return this[b.p(t)]();
        }, m.add = function(r, f) {
            var d, l = this;
            r = Number(r);
            var $ = b.p(f), y = function(t) {
                var e = O(l);
                return b.w(e.date(e.date() + Math.round(t * r)), l);
            };
            if ($ === c) return this.set(c, this.$M + r);
            if ($ === h) return this.set(h, this.$y + r);
            if ($ === a) return y(1);
            if ($ === o) return y(7);
            var M = (d = {}, d[s] = e, d[u] = n, d[i] = t, d)[$] || 1, m = this.$d.getTime() + r * M;
            return b.w(m, this);
        }, m.subtract = function(t, e) {
            return this.add(-1 * t, e);
        }, m.format = function(t) {
            var e = this, n = this.$locale();
            if (!this.isValid()) return n.invalidDate || l;
            var r = t || "YYYY-MM-DDTHH:mm:ssZ", i = b.z(this), s = this.$H, u = this.$m, a = this.$M, o = n.weekdays, c = n.months, f = n.meridiem, h = function(t, n, i, s) {
                return t && (t[n] || t(e, r)) || i[n].slice(0, s);
            }, d = function(t) {
                return b.s(s % 12 || 12, t, "0");
            }, $ = f || function(t, e, n) {
                var r = t < 12 ? "AM" : "PM";
                return n ? r.toLowerCase() : r;
            };
            return r.replace(y, function(t, r) {
                return r || function(t) {
                    switch(t){
                        case "YY":
                            return String(e.$y).slice(-2);
                        case "YYYY":
                            return b.s(e.$y, 4, "0");
                        case "M":
                            return a + 1;
                        case "MM":
                            return b.s(a + 1, 2, "0");
                        case "MMM":
                            return h(n.monthsShort, a, c, 3);
                        case "MMMM":
                            return h(c, a);
                        case "D":
                            return e.$D;
                        case "DD":
                            return b.s(e.$D, 2, "0");
                        case "d":
                            return String(e.$W);
                        case "dd":
                            return h(n.weekdaysMin, e.$W, o, 2);
                        case "ddd":
                            return h(n.weekdaysShort, e.$W, o, 3);
                        case "dddd":
                            return o[e.$W];
                        case "H":
                            return String(s);
                        case "HH":
                            return b.s(s, 2, "0");
                        case "h":
                            return d(1);
                        case "hh":
                            return d(2);
                        case "a":
                            return $(s, u, !0);
                        case "A":
                            return $(s, u, !1);
                        case "m":
                            return String(u);
                        case "mm":
                            return b.s(u, 2, "0");
                        case "s":
                            return String(e.$s);
                        case "ss":
                            return b.s(e.$s, 2, "0");
                        case "SSS":
                            return b.s(e.$ms, 3, "0");
                        case "Z":
                            return i;
                    }
                    return null;
                }(t) || i.replace(":", "");
            });
        }, m.utcOffset = function() {
            return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, m.diff = function(r, d, l) {
            var $, y = this, M = b.p(d), m = O(r), v = (m.utcOffset() - this.utcOffset()) * e, g = this - m, D = function() {
                return b.m(y, m);
            };
            switch(M){
                case h:
                    $ = D() / 12;
                    break;
                case c:
                    $ = D();
                    break;
                case f:
                    $ = D() / 3;
                    break;
                case o:
                    $ = (g - v) / 6048e5;
                    break;
                case a:
                    $ = (g - v) / 864e5;
                    break;
                case u:
                    $ = g / n;
                    break;
                case s:
                    $ = g / e;
                    break;
                case i:
                    $ = g / t;
                    break;
                default:
                    $ = g;
            }
            return l ? $ : b.a($);
        }, m.daysInMonth = function() {
            return this.endOf(c).$D;
        }, m.$locale = function() {
            return D[this.$L];
        }, m.locale = function(t, e) {
            if (!t) return this.$L;
            var n = this.clone(), r = w(t, e, !0);
            return r && (n.$L = r), n;
        }, m.clone = function() {
            return b.w(this.$d, this);
        }, m.toDate = function() {
            return new Date(this.valueOf());
        }, m.toJSON = function() {
            return this.isValid() ? this.toISOString() : null;
        }, m.toISOString = function() {
            return this.$d.toISOString();
        }, m.toString = function() {
            return this.$d.toUTCString();
        }, M;
    }(), k = _.prototype;
    return O.prototype = k, [
        [
            "$ms",
            r
        ],
        [
            "$s",
            i
        ],
        [
            "$m",
            s
        ],
        [
            "$H",
            u
        ],
        [
            "$W",
            a
        ],
        [
            "$M",
            c
        ],
        [
            "$y",
            h
        ],
        [
            "$D",
            d
        ]
    ].forEach(function(t) {
        k[t[1]] = function(e) {
            return this.$g(e, t[0], t[1]);
        };
    }), O.extend = function(t, e) {
        return t.$i || (t(e, _, O), t.$i = !0), O;
    }, O.locale = w, O.isDayjs = S, O.unix = function(t) {
        return O(1e3 * t);
    }, O.en = D[g], O.Ls = D, O.p = {}, O;
});

});

parcelRegister("9vqIZ", function(module, exports) {
!function(t, i) {
    module.exports = i();
}(module.exports, function() {
    "use strict";
    var t = "minute", i = /[+-]\d\d(?::?\d\d)?/g, e = /([+-]|\d\d)/g;
    return function(s, f, n) {
        var u = f.prototype;
        n.utc = function(t) {
            var i = {
                date: t,
                utc: !0,
                args: arguments
            };
            return new f(i);
        }, u.utc = function(i) {
            var e = n(this.toDate(), {
                locale: this.$L,
                utc: !0
            });
            return i ? e.add(this.utcOffset(), t) : e;
        }, u.local = function() {
            return n(this.toDate(), {
                locale: this.$L,
                utc: !1
            });
        };
        var o = u.parse;
        u.parse = function(t) {
            t.utc && (this.$u = !0), this.$utils().u(t.$offset) || (this.$offset = t.$offset), o.call(this, t);
        };
        var r = u.init;
        u.init = function() {
            if (this.$u) {
                var t = this.$d;
                this.$y = t.getUTCFullYear(), this.$M = t.getUTCMonth(), this.$D = t.getUTCDate(), this.$W = t.getUTCDay(), this.$H = t.getUTCHours(), this.$m = t.getUTCMinutes(), this.$s = t.getUTCSeconds(), this.$ms = t.getUTCMilliseconds();
            } else r.call(this);
        };
        var a = u.utcOffset;
        u.utcOffset = function(s, f) {
            var n = this.$utils().u;
            if (n(s)) return this.$u ? 0 : n(this.$offset) ? a.call(this) : this.$offset;
            if ("string" == typeof s && (s = function(t) {
                void 0 === t && (t = "");
                var s = t.match(i);
                if (!s) return null;
                var f = ("" + s[0]).match(e) || [
                    "-",
                    0,
                    0
                ], n = f[0], u = 60 * +f[1] + +f[2];
                return 0 === u ? 0 : "+" === n ? u : -u;
            }(s), null === s)) return this;
            var u = Math.abs(s) <= 16 ? 60 * s : s, o = this;
            if (f) return o.$offset = u, o.$u = 0 === s, o;
            if (0 !== s) {
                var r = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset();
                (o = this.local().add(u + r, t)).$offset = u, o.$x.$localOffset = r;
            } else o = this.utc();
            return o;
        };
        var h = u.format;
        u.format = function(t) {
            var i = t || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
            return h.call(this, i);
        }, u.valueOf = function() {
            var t = this.$utils().u(this.$offset) ? 0 : this.$offset + (this.$x.$localOffset || this.$d.getTimezoneOffset());
            return this.$d.valueOf() - 6e4 * t;
        }, u.isUTC = function() {
            return !!this.$u;
        }, u.toISOString = function() {
            return this.toDate().toISOString();
        }, u.toString = function() {
            return this.toDate().toUTCString();
        };
        var l = u.toDate;
        u.toDate = function(t) {
            return "s" === t && this.$offset ? n(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate() : l.call(this);
        };
        var c = u.diff;
        u.diff = function(t, i, e) {
            if (t && this.$u === t.$u) return c.call(this, t, i, e);
            var s = this.local(), f = n(t).local();
            return c.call(s, f, i, e);
        };
    };
});

});

parcelRegister("jr2jp", function(module, exports) {
!function(t, e) {
    module.exports = e();
}(module.exports, function() {
    "use strict";
    var t = {
        year: 0,
        month: 1,
        day: 2,
        hour: 3,
        minute: 4,
        second: 5
    }, e = {};
    return function(n, i, o) {
        var r, a = function(t, n, i) {
            void 0 === i && (i = {});
            var o = new Date(t), r = function(t, n) {
                void 0 === n && (n = {});
                var i = n.timeZoneName || "short", o = t + "|" + i, r = e[o];
                return r || (r = new Intl.DateTimeFormat("en-US", {
                    hour12: !1,
                    timeZone: t,
                    year: "numeric",
                    month: "2-digit",
                    day: "2-digit",
                    hour: "2-digit",
                    minute: "2-digit",
                    second: "2-digit",
                    timeZoneName: i
                }), e[o] = r), r;
            }(n, i);
            return r.formatToParts(o);
        }, u = function(e, n) {
            for(var i = a(e, n), r = [], u = 0; u < i.length; u += 1){
                var f = i[u], s = f.type, m = f.value, c = t[s];
                c >= 0 && (r[c] = parseInt(m, 10));
            }
            var d = r[3], l = 24 === d ? 0 : d, h = r[0] + "-" + r[1] + "-" + r[2] + " " + l + ":" + r[4] + ":" + r[5] + ":000", v = +e;
            return (o.utc(h).valueOf() - (v -= v % 1e3)) / 6e4;
        }, f = i.prototype;
        f.tz = function(t, e) {
            void 0 === t && (t = r);
            var n = this.utcOffset(), i = this.toDate(), a = i.toLocaleString("en-US", {
                timeZone: t
            }), u = Math.round((i - new Date(a)) / 1e3 / 60), f = o(a, {
                locale: this.$L
            }).$set("millisecond", this.$ms).utcOffset(15 * -Math.round(i.getTimezoneOffset() / 15) - u, !0);
            if (e) {
                var s = f.utcOffset();
                f = f.add(n - s, "minute");
            }
            return f.$x.$timezone = t, f;
        }, f.offsetName = function(t) {
            var e = this.$x.$timezone || o.tz.guess(), n = a(this.valueOf(), e, {
                timeZoneName: t
            }).find(function(t) {
                return "timezonename" === t.type.toLowerCase();
            });
            return n && n.value;
        };
        var s = f.startOf;
        f.startOf = function(t, e) {
            if (!this.$x || !this.$x.$timezone) return s.call(this, t, e);
            var n = o(this.format("YYYY-MM-DD HH:mm:ss:SSS"), {
                locale: this.$L
            });
            return s.call(n, t, e).tz(this.$x.$timezone, !0);
        }, o.tz = function(t, e, n) {
            var i = n && e, a = n || e || r, f = u(+o(), a);
            if ("string" != typeof t) return o(t).tz(a);
            var s = function(t, e, n) {
                var i = t - 60 * e * 1e3, o = u(i, n);
                if (e === o) return [
                    i,
                    e
                ];
                var r = u(i -= 60 * (o - e) * 1e3, n);
                return o === r ? [
                    i,
                    o
                ] : [
                    t - 60 * Math.min(o, r) * 1e3,
                    Math.max(o, r)
                ];
            }(o.utc(t, i).valueOf(), f, a), m = s[0], c = s[1], d = o(m).utcOffset(c);
            return d.$x.$timezone = a, d;
        }, o.tz.guess = function() {
            return Intl.DateTimeFormat().resolvedOptions().timeZone;
        }, o.tz.setDefault = function(t) {
            r = t;
        };
    };
});

});

parcelRegister("kAJrR", function(module, exports) {
!function(e, t) {
    module.exports = t();
}(module.exports, function() {
    "use strict";
    return function(e, t) {
        t.prototype.weekday = function(e) {
            var t = this.$locale().weekStart || 0, i = this.$W, n = (i < t ? i + 7 : i) - t;
            return this.$utils().u(e) ? n : this.subtract(n, "day").add(e, "day");
        };
    };
});

});

parcelRegister("4yB7Z", function(module, exports) {
!function(e, t) {
    module.exports = t();
}(module.exports, function() {
    "use strict";
    return function(e, t) {
        var r = t.prototype, n = r.format;
        r.format = function(e) {
            var t = this, r = this.$locale();
            if (!this.isValid()) return n.bind(this)(e);
            var s = this.$utils(), a = (e || "YYYY-MM-DDTHH:mm:ssZ").replace(/\[([^\]]+)]|Q|wo|ww|w|WW|W|zzz|z|gggg|GGGG|Do|X|x|k{1,2}|S/g, function(e) {
                switch(e){
                    case "Q":
                        return Math.ceil((t.$M + 1) / 3);
                    case "Do":
                        return r.ordinal(t.$D);
                    case "gggg":
                        return t.weekYear();
                    case "GGGG":
                        return t.isoWeekYear();
                    case "wo":
                        return r.ordinal(t.week(), "W");
                    case "w":
                    case "ww":
                        return s.s(t.week(), "w" === e ? 1 : 2, "0");
                    case "W":
                    case "WW":
                        return s.s(t.isoWeek(), "W" === e ? 1 : 2, "0");
                    case "k":
                    case "kk":
                        return s.s(String(0 === t.$H ? 24 : t.$H), "k" === e ? 1 : 2, "0");
                    case "X":
                        return Math.floor(t.$d.getTime() / 1e3);
                    case "x":
                        return t.$d.getTime();
                    case "z":
                        return "[" + t.offsetName() + "]";
                    case "zzz":
                        return "[" + t.offsetName("long") + "]";
                    default:
                        return e;
                }
            });
            return n.bind(this)(a);
        };
    };
});

});

parcelRegister("deM4B", function(module, exports) {
!function(e, t) {
    module.exports = t();
}(module.exports, function() {
    "use strict";
    var e = {
        LTS: "h:mm:ss A",
        LT: "h:mm A",
        L: "MM/DD/YYYY",
        LL: "MMMM D, YYYY",
        LLL: "MMMM D, YYYY h:mm A",
        LLLL: "dddd, MMMM D, YYYY h:mm A"
    };
    return function(t, o, n) {
        var r = o.prototype, i = r.format;
        n.en.formats = e, r.format = function(t) {
            void 0 === t && (t = "YYYY-MM-DDTHH:mm:ssZ");
            var o = this.$locale().formats, n = function(t, o) {
                return t.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(t, n, r) {
                    var i = r && r.toUpperCase();
                    return n || o[r] || e[r] || o[i].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(e, t, o) {
                        return t || o.slice(1);
                    });
                });
            }(t, void 0 === o ? {} : o);
            return i.call(this, n);
        };
    };
});

});

parcelRegister("8a7Qn", function(module, exports) {
!function(e, t) {
    module.exports = t();
}(module.exports, function() {
    "use strict";
    var e = "week", t = "year";
    return function(i, n, r) {
        var f = n.prototype;
        f.week = function(i) {
            if (void 0 === i && (i = null), null !== i) return this.add(7 * (i - this.week()), "day");
            var n = this.$locale().yearStart || 1;
            if (11 === this.month() && this.date() > 25) {
                var f = r(this).startOf(t).add(1, t).date(n), s = r(this).endOf(e);
                if (f.isBefore(s)) return 1;
            }
            var a = r(this).startOf(t).date(n).startOf(e).subtract(1, "millisecond"), o = this.diff(a, e, !0);
            return o < 0 ? r(this).startOf("week").week() : Math.ceil(o);
        }, f.weeks = function(e) {
            return void 0 === e && (e = null), this.week(e);
        };
    };
});

});

parcelRegister("3vWD9", function(module, exports) {

$parcel$export(module.exports, "computePosition", function () { return $28f1bf2594995773$export$48a53dcb22e581d0; });
$parcel$export(module.exports, "detectOverflow", function () { return $28f1bf2594995773$export$37b6bde19b108ecc; });
$parcel$export(module.exports, "arrow", function () { return $28f1bf2594995773$export$f2120bbfa5450bd2; });
$parcel$export(module.exports, "autoPlacement", function () { return $28f1bf2594995773$export$91fb6ecbd551914; });
$parcel$export(module.exports, "flip", function () { return $28f1bf2594995773$export$8a83211c878a3f1f; });
$parcel$export(module.exports, "hide", function () { return $28f1bf2594995773$export$fe8985bb6374093c; });
$parcel$export(module.exports, "inline", function () { return $28f1bf2594995773$export$18c8ad048e32c7d5; });
$parcel$export(module.exports, "offset", function () { return $28f1bf2594995773$export$cc800923e997bb8; });
$parcel$export(module.exports, "shift", function () { return $28f1bf2594995773$export$fba63a578e423eb; });
$parcel$export(module.exports, "limitShift", function () { return $28f1bf2594995773$export$7bf07e38f3dc4b69; });
$parcel$export(module.exports, "size", function () { return $28f1bf2594995773$export$346677f925de839c; });
$parcel$export(module.exports, "rectToClientRect", function () { return (parcelRequire("cCxCV")).rectToClientRect; });

var $cCxCV = parcelRequire("cCxCV");
function $28f1bf2594995773$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const sideAxis = (0, $cCxCV.getSideAxis)(placement);
    const alignmentAxis = (0, $cCxCV.getAlignmentAxis)(placement);
    const alignLength = (0, $cCxCV.getAxisLength)(alignmentAxis);
    const side = (0, $cCxCV.getSide)(placement);
    const isVertical = sideAxis === "y";
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case "top":
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case "bottom":
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case "right":
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case "left":
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch((0, $cCxCV.getAlignment)(placement)){
        case "start":
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case "end":
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $28f1bf2594995773$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = "bottom", strategy: strategy = "absolute", middleware: middleware = [], platform: platform } = config;
    const validMiddleware = middleware.filter(Boolean);
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $28f1bf2594995773$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let middlewareData = {};
    let resetCount = 0;
    for(let i = 0; i < validMiddleware.length; i++){
        const { name: name, fn: fn } = validMiddleware[i];
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platform,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData = {
            ...middlewareData,
            [name]: {
                ...middlewareData[name],
                ...data
            }
        };
        if (reset && resetCount <= 50) {
            resetCount++;
            if (typeof reset === "object") {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $28f1bf2594995773$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $28f1bf2594995773$export$37b6bde19b108ecc(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
    const { boundary: boundary = "clippingAncestors", rootBoundary: rootBoundary = "viewport", elementContext: elementContext = "floating", altBoundary: altBoundary = false, padding: padding = 0 } = (0, $cCxCV.evaluate)(options, state);
    const paddingObject = (0, $cCxCV.getPaddingObject)(padding);
    const altContext = elementContext === "floating" ? "reference" : "floating";
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, $cCxCV.rectToClientRect)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === "floating" ? {
        x: x,
        y: y,
        width: rects.floating.width,
        height: rects.floating.height
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, $cCxCV.rectToClientRect)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        elements: elements,
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $28f1bf2594995773$export$f2120bbfa5450bd2 = (options)=>({
        name: "arrow",
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element: element, padding: padding = 0 } = (0, $cCxCV.evaluate)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, $cCxCV.getPaddingObject)(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = (0, $cCxCV.getAlignmentAxis)(placement);
            const length = (0, $cCxCV.getAxisLength)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === "y";
            const minProp = isYAxis ? "top" : "left";
            const maxProp = isYAxis ? "bottom" : "right";
            const clientProp = isYAxis ? "clientHeight" : "clientWidth";
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, $cCxCV.min)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, $cCxCV.min)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min$1 = minPadding;
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, $cCxCV.clamp)(min$1, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, $cCxCV.getAlignment)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset,
                    ...shouldAddOffset && {
                        alignmentOffset: alignmentOffset
                    }
                },
                reset: shouldAddOffset
            };
        }
    });
function $28f1bf2594995773$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, $cCxCV.getAlignment)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, $cCxCV.getAlignment)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, $cCxCV.getSide)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, $cCxCV.getAlignment)(placement) === alignment || (autoAlignment ? (0, $cCxCV.getOppositeAlignmentPlacement)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $28f1bf2594995773$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: "autoPlacement",
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
            const { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, $cCxCV.placements), autoAlignment: autoAlignment = true, ...detectOverflowOptions } = (0, $cCxCV.evaluate)(options, state);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, $cCxCV.placements) ? $28f1bf2594995773$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await $28f1bf2594995773$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            const alignmentSides = (0, $cCxCV.getAlignmentSides)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const currentOverflows = [
                overflow[(0, $cCxCV.getSide)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, $cCxCV.getAlignment)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, $cCxCV.getAlignment)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $28f1bf2594995773$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: "flip",
        options: options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = "bestFit", fallbackAxisSideDirection: fallbackAxisSideDirection = "none", flipAlignment: flipAlignment = true, ...detectOverflowOptions } = (0, $cCxCV.evaluate)(options, state);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, $cCxCV.getSide)(placement);
            const initialSideAxis = (0, $cCxCV.getSideAxis)(initialPlacement);
            const isBasePlacement = (0, $cCxCV.getSide)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, $cCxCV.getOppositePlacement)(initialPlacement)
            ] : (0, $cCxCV.getExpandedPlacements)(initialPlacement));
            const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== "none";
            if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) fallbackPlacements.push(...(0, $cCxCV.getOppositeAxisPlacements)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await $28f1bf2594995773$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, $cCxCV.getAlignmentSides)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) {
                    const ignoreCrossAxisOverflow = checkCrossAxis === "alignment" ? initialSideAxis !== (0, $cCxCV.getSideAxis)(nextPlacement) : false;
                    if (!ignoreCrossAxisOverflow || // We leave the current main axis only if every placement on that axis
                    // overflows the main axis.
                    overflowsData.every((d)=>(0, $cCxCV.getSideAxis)(d.placement) === initialSideAxis ? d.overflows[0] > 0 : true)) // Try next placement and re-run the lifecycle.
                    return {
                        data: {
                            index: nextIndex,
                            overflows: overflowsData
                        },
                        reset: {
                            placement: nextPlacement
                        }
                    };
                }
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case "bestFit":
                        {
                            var _overflowsData$filter2;
                            const placement = (_overflowsData$filter2 = overflowsData.filter((d)=>{
                                if (hasFallbackAxisSideDirection) {
                                    const currentSideAxis = (0, $cCxCV.getSideAxis)(d.placement);
                                    return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                                    // reading directions favoring greater width.
                                    currentSideAxis === "y";
                                }
                                return true;
                            }).map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case "initialPlacement":
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $28f1bf2594995773$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $28f1bf2594995773$var$isAnySideFullyClipped(overflow) {
    return (0, $cCxCV.sides).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $28f1bf2594995773$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: "hide",
        options: options,
        async fn (state) {
            const { rects: rects } = state;
            const { strategy: strategy = "referenceHidden", ...detectOverflowOptions } = (0, $cCxCV.evaluate)(options, state);
            switch(strategy){
                case "referenceHidden":
                    {
                        const overflow = await $28f1bf2594995773$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            elementContext: "reference"
                        });
                        const offsets = $28f1bf2594995773$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $28f1bf2594995773$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case "escaped":
                    {
                        const overflow = await $28f1bf2594995773$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = $28f1bf2594995773$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $28f1bf2594995773$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $28f1bf2594995773$var$getBoundingRect(rects) {
    const minX = (0, $cCxCV.min)(...rects.map((rect)=>rect.left));
    const minY = (0, $cCxCV.min)(...rects.map((rect)=>rect.top));
    const maxX = (0, $cCxCV.max)(...rects.map((rect)=>rect.right));
    const maxY = (0, $cCxCV.max)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $28f1bf2594995773$var$getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, $cCxCV.rectToClientRect)($28f1bf2594995773$var$getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $28f1bf2594995773$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: "inline",
        options: options,
        async fn (state) {
            const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2, x: x, y: y } = (0, $cCxCV.evaluate)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            const clientRects = $28f1bf2594995773$var$getRectsByLine(nativeClientRects);
            const fallback = (0, $cCxCV.rectToClientRect)($28f1bf2594995773$var$getBoundingRect(nativeClientRects));
            const paddingObject = (0, $cCxCV.getPaddingObject)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, $cCxCV.getSideAxis)(placement) === "y") {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, $cCxCV.getSide)(placement) === "top";
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = (0, $cCxCV.getSide)(placement) === "left";
                    const maxRight = (0, $cCxCV.max)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, $cCxCV.min)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top: top,
                        bottom: bottom,
                        left: left,
                        right: right,
                        width: width,
                        height: height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
const $28f1bf2594995773$var$originSides = /*#__PURE__*/ new Set([
    "left",
    "top"
]);
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function $28f1bf2594995773$var$convertValueToCoords(state, options) {
    const { placement: placement, platform: platform, elements: elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, $cCxCV.getSide)(placement);
    const alignment = (0, $cCxCV.getAlignment)(placement);
    const isVertical = (0, $cCxCV.getSideAxis)(placement) === "y";
    const mainAxisMulti = $28f1bf2594995773$var$originSides.has(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, $cCxCV.evaluate)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === "number" ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: rawValue.mainAxis || 0,
        crossAxis: rawValue.crossAxis || 0,
        alignmentAxis: rawValue.alignmentAxis
    };
    if (alignment && typeof alignmentAxis === "number") crossAxis = alignment === "end" ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $28f1bf2594995773$export$cc800923e997bb8 = function(options) {
    if (options === void 0) options = 0;
    return {
        name: "offset",
        options: options,
        async fn (state) {
            var _middlewareData$offse, _middlewareData$arrow;
            const { x: x, y: y, placement: placement, middlewareData: middlewareData } = state;
            const diffCoords = await $28f1bf2594995773$var$convertValueToCoords(state, options);
            // If the placement is the same and the arrow caused an alignment offset
            // then we don't need to change the positioning coordinates.
            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: {
                    ...diffCoords,
                    placement: placement
                }
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $28f1bf2594995773$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: "shift",
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x, y: y } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            }, ...detectOverflowOptions } = (0, $cCxCV.evaluate)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await $28f1bf2594995773$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const crossAxis = (0, $cCxCV.getSideAxis)((0, $cCxCV.getSide)(placement));
            const mainAxis = (0, $cCxCV.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === "y" ? "top" : "left";
                const maxSide = mainAxis === "y" ? "bottom" : "right";
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = (0, $cCxCV.clamp)(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === "y" ? "top" : "left";
                const maxSide = crossAxis === "y" ? "bottom" : "right";
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = (0, $cCxCV.clamp)(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y,
                    enabled: {
                        [mainAxis]: checkMainAxis,
                        [crossAxis]: checkCrossAxis
                    }
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $28f1bf2594995773$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
            const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, $cCxCV.evaluate)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const crossAxis = (0, $cCxCV.getSideAxis)(placement);
            const mainAxis = (0, $cCxCV.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, $cCxCV.evaluate)(offset, state);
            const computedOffset = typeof rawOffset === "number" ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...rawOffset
            };
            if (checkMainAxis) {
                const len = mainAxis === "y" ? "height" : "width";
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === "y" ? "width" : "height";
                const isOriginSide = $28f1bf2594995773$var$originSides.has((0, $cCxCV.getSide)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $28f1bf2594995773$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: "size",
        options: options,
        async fn (state) {
            var _state$middlewareData, _state$middlewareData2;
            const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
            const { apply: apply = ()=>{}, ...detectOverflowOptions } = (0, $cCxCV.evaluate)(options, state);
            const overflow = await $28f1bf2594995773$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const side = (0, $cCxCV.getSide)(placement);
            const alignment = (0, $cCxCV.getAlignment)(placement);
            const isYAxis = (0, $cCxCV.getSideAxis)(placement) === "y";
            const { width: width, height: height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === "top" || side === "bottom") {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? "start" : "end") ? "left" : "right";
            } else {
                widthSide = side;
                heightSide = alignment === "end" ? "top" : "bottom";
            }
            const maximumClippingHeight = height - overflow.top - overflow.bottom;
            const maximumClippingWidth = width - overflow.left - overflow.right;
            const overflowAvailableHeight = (0, $cCxCV.min)(height - overflow[heightSide], maximumClippingHeight);
            const overflowAvailableWidth = (0, $cCxCV.min)(width - overflow[widthSide], maximumClippingWidth);
            const noShift = !state.middlewareData.shift;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if ((_state$middlewareData = state.middlewareData.shift) != null && _state$middlewareData.enabled.x) availableWidth = maximumClippingWidth;
            if ((_state$middlewareData2 = state.middlewareData.shift) != null && _state$middlewareData2.enabled.y) availableHeight = maximumClippingHeight;
            if (noShift && !alignment) {
                const xMin = (0, $cCxCV.max)(overflow.left, 0);
                const xMax = (0, $cCxCV.max)(overflow.right, 0);
                const yMin = (0, $cCxCV.max)(overflow.top, 0);
                const yMax = (0, $cCxCV.max)(overflow.bottom, 0);
                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, $cCxCV.max)(overflow.left, overflow.right));
                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, $cCxCV.max)(overflow.top, overflow.bottom));
            }
            await apply({
                ...state,
                availableWidth: availableWidth,
                availableHeight: availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};

});
parcelRegister("cCxCV", function(module, exports) {

$parcel$export(module.exports, "sides", function () { return $93031e4206e8e991$export$832b6fa47fa053d2; });
$parcel$export(module.exports, "placements", function () { return $93031e4206e8e991$export$803cd8101b6c182b; });
$parcel$export(module.exports, "min", function () { return $93031e4206e8e991$export$96ec731ed4dcb222; });
$parcel$export(module.exports, "max", function () { return $93031e4206e8e991$export$8960430cfd85939f; });
$parcel$export(module.exports, "clamp", function () { return $93031e4206e8e991$export$7d15b64cf5a3a4c4; });
$parcel$export(module.exports, "evaluate", function () { return $93031e4206e8e991$export$fef61f332f2c0afc; });
$parcel$export(module.exports, "getSide", function () { return $93031e4206e8e991$export$3c915306cb7fc97a; });
$parcel$export(module.exports, "getAlignment", function () { return $93031e4206e8e991$export$f0989780f32bfcda; });
$parcel$export(module.exports, "getOppositeAxis", function () { return $93031e4206e8e991$export$8a000a963141ac32; });
$parcel$export(module.exports, "getAxisLength", function () { return $93031e4206e8e991$export$320bd9d53520c68a; });
$parcel$export(module.exports, "getSideAxis", function () { return $93031e4206e8e991$export$f28e8f882010718a; });
$parcel$export(module.exports, "getAlignmentAxis", function () { return $93031e4206e8e991$export$2b57e0052a6d6d4c; });
$parcel$export(module.exports, "getAlignmentSides", function () { return $93031e4206e8e991$export$be42861551f17911; });
$parcel$export(module.exports, "getOppositePlacement", function () { return $93031e4206e8e991$export$9c5e28bad23365fa; });
$parcel$export(module.exports, "getExpandedPlacements", function () { return $93031e4206e8e991$export$496432a3699e50b1; });
$parcel$export(module.exports, "getOppositeAlignmentPlacement", function () { return $93031e4206e8e991$export$2b182c584985588b; });
$parcel$export(module.exports, "getOppositeAxisPlacements", function () { return $93031e4206e8e991$export$a9b6fb18fd92c3ec; });
$parcel$export(module.exports, "getPaddingObject", function () { return $93031e4206e8e991$export$598c291c29bc2e71; });
$parcel$export(module.exports, "rectToClientRect", function () { return $93031e4206e8e991$export$ee05aea0aeecbad4; });
/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */ const $93031e4206e8e991$export$832b6fa47fa053d2 = [
    "top",
    "right",
    "bottom",
    "left"
];
const $93031e4206e8e991$export$27b07d8a310ed8b5 = [
    "start",
    "end"
];
const $93031e4206e8e991$export$803cd8101b6c182b = /*#__PURE__*/ $93031e4206e8e991$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $93031e4206e8e991$export$27b07d8a310ed8b5[0], side + "-" + $93031e4206e8e991$export$27b07d8a310ed8b5[1]), []);
const $93031e4206e8e991$export$96ec731ed4dcb222 = Math.min;
const $93031e4206e8e991$export$8960430cfd85939f = Math.max;
const $93031e4206e8e991$export$2077e0241d6afd3c = Math.round;
const $93031e4206e8e991$export$a3fe094919f356fd = Math.floor;
const $93031e4206e8e991$export$a397704b5e280835 = (v)=>({
        x: v,
        y: v
    });
const $93031e4206e8e991$var$oppositeSideMap = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
const $93031e4206e8e991$var$oppositeAlignmentMap = {
    start: "end",
    end: "start"
};
function $93031e4206e8e991$export$7d15b64cf5a3a4c4(start, value, end) {
    return $93031e4206e8e991$export$8960430cfd85939f(start, $93031e4206e8e991$export$96ec731ed4dcb222(value, end));
}
function $93031e4206e8e991$export$fef61f332f2c0afc(value, param) {
    return typeof value === "function" ? value(param) : value;
}
function $93031e4206e8e991$export$3c915306cb7fc97a(placement) {
    return placement.split("-")[0];
}
function $93031e4206e8e991$export$f0989780f32bfcda(placement) {
    return placement.split("-")[1];
}
function $93031e4206e8e991$export$8a000a963141ac32(axis) {
    return axis === "x" ? "y" : "x";
}
function $93031e4206e8e991$export$320bd9d53520c68a(axis) {
    return axis === "y" ? "height" : "width";
}
const $93031e4206e8e991$var$yAxisSides = /*#__PURE__*/ new Set([
    "top",
    "bottom"
]);
function $93031e4206e8e991$export$f28e8f882010718a(placement) {
    return $93031e4206e8e991$var$yAxisSides.has($93031e4206e8e991$export$3c915306cb7fc97a(placement)) ? "y" : "x";
}
function $93031e4206e8e991$export$2b57e0052a6d6d4c(placement) {
    return $93031e4206e8e991$export$8a000a963141ac32($93031e4206e8e991$export$f28e8f882010718a(placement));
}
function $93031e4206e8e991$export$be42861551f17911(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $93031e4206e8e991$export$f0989780f32bfcda(placement);
    const alignmentAxis = $93031e4206e8e991$export$2b57e0052a6d6d4c(placement);
    const length = $93031e4206e8e991$export$320bd9d53520c68a(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === "x" ? alignment === (rtl ? "end" : "start") ? "right" : "left" : alignment === "start" ? "bottom" : "top";
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $93031e4206e8e991$export$9c5e28bad23365fa(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $93031e4206e8e991$export$9c5e28bad23365fa(mainAlignmentSide)
    ];
}
function $93031e4206e8e991$export$496432a3699e50b1(placement) {
    const oppositePlacement = $93031e4206e8e991$export$9c5e28bad23365fa(placement);
    return [
        $93031e4206e8e991$export$2b182c584985588b(placement),
        oppositePlacement,
        $93031e4206e8e991$export$2b182c584985588b(oppositePlacement)
    ];
}
function $93031e4206e8e991$export$2b182c584985588b(placement) {
    return placement.replace(/start|end/g, (alignment)=>$93031e4206e8e991$var$oppositeAlignmentMap[alignment]);
}
const $93031e4206e8e991$var$lrPlacement = [
    "left",
    "right"
];
const $93031e4206e8e991$var$rlPlacement = [
    "right",
    "left"
];
const $93031e4206e8e991$var$tbPlacement = [
    "top",
    "bottom"
];
const $93031e4206e8e991$var$btPlacement = [
    "bottom",
    "top"
];
function $93031e4206e8e991$var$getSideList(side, isStart, rtl) {
    switch(side){
        case "top":
        case "bottom":
            if (rtl) return isStart ? $93031e4206e8e991$var$rlPlacement : $93031e4206e8e991$var$lrPlacement;
            return isStart ? $93031e4206e8e991$var$lrPlacement : $93031e4206e8e991$var$rlPlacement;
        case "left":
        case "right":
            return isStart ? $93031e4206e8e991$var$tbPlacement : $93031e4206e8e991$var$btPlacement;
        default:
            return [];
    }
}
function $93031e4206e8e991$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
    const alignment = $93031e4206e8e991$export$f0989780f32bfcda(placement);
    let list = $93031e4206e8e991$var$getSideList($93031e4206e8e991$export$3c915306cb7fc97a(placement), direction === "start", rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($93031e4206e8e991$export$2b182c584985588b));
    }
    return list;
}
function $93031e4206e8e991$export$9c5e28bad23365fa(placement) {
    return placement.replace(/left|right|bottom|top/g, (side)=>$93031e4206e8e991$var$oppositeSideMap[side]);
}
function $93031e4206e8e991$export$1c66dbf1a9e34223(padding) {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...padding
    };
}
function $93031e4206e8e991$export$598c291c29bc2e71(padding) {
    return typeof padding !== "number" ? $93031e4206e8e991$export$1c66dbf1a9e34223(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $93031e4206e8e991$export$ee05aea0aeecbad4(rect) {
    const { x: x, y: y, width: width, height: height } = rect;
    return {
        width: width,
        height: height,
        top: y,
        left: x,
        right: x + width,
        bottom: y + height,
        x: x,
        y: y
    };
}

});


parcelRegister("jTcSi", function(module, exports) {
/**
 * @license
 *
 * chroma.js - JavaScript library for color conversions
 * 
 * Copyright (c) 2011-2017, Gregor Aisch
 * All rights reserved.
 * 
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 * 
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer.
 * 
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 * 
 * 3. The name Gregor Aisch may not be used to endorse or promote products
 *    derived from this software without specific prior written permission.
 * 
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL GREGOR AISCH OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 * INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING,
 * BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
 * DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY
 * OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE,
 * EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 */ (function() {
    var Color, DEG2RAD, LAB_CONSTANTS, PI, PITHIRD, RAD2DEG, TWOPI, _average_lrgb, _guess_formats, _guess_formats_sorted, _input, _interpolators, abs, atan2, bezier, blend, blend_f, brewer, burn, chroma, clip_rgb, cmyk2rgb, colors, cos, css2rgb, darken, dodge, each, floor, hcg2rgb, hex2rgb, hsi2rgb, hsl2css, hsl2rgb, hsv2rgb, interpolate, interpolate_hsx, interpolate_lab, interpolate_lrgb, interpolate_num, interpolate_rgb, lab2lch, lab2rgb, lab_xyz, lch2lab, lch2rgb, lighten, limit, log, luminance_x, m, max, multiply, normal, num2rgb, overlay, pow, rgb2cmyk, rgb2css, rgb2hcg, rgb2hex, rgb2hsi, rgb2hsl, rgb2hsv, rgb2lab, rgb2lch, rgb2luminance, rgb2num, rgb2temperature, rgb2xyz, rgb_xyz, rnd, root, round, screen, sin, sqrt, temperature2rgb, type, unpack, w3cx11, xyz_lab, xyz_rgb, slice = [].slice;
    type = function() {
        /*
    for browser-safe type checking+
    ported from jQuery's $.type
     */ var classToType, len, name, o, ref;
        classToType = {};
        ref = "Boolean Number String Function Array Date RegExp Undefined Null".split(" ");
        for(o = 0, len = ref.length; o < len; o++){
            name = ref[o];
            classToType["[object " + name + "]"] = name.toLowerCase();
        }
        return function(obj) {
            var strType;
            strType = Object.prototype.toString.call(obj);
            return classToType[strType] || "object";
        };
    }();
    limit = function(x, min, max) {
        if (min == null) min = 0;
        if (max == null) max = 1;
        if (x < min) x = min;
        if (x > max) x = max;
        return x;
    };
    unpack = function(args) {
        if (args.length >= 3) return Array.prototype.slice.call(args);
        else return args[0];
    };
    clip_rgb = function(rgb) {
        var i, o;
        rgb._clipped = false;
        rgb._unclipped = rgb.slice(0);
        for(i = o = 0; o < 3; i = ++o){
            if (i < 3) {
                if (rgb[i] < 0 || rgb[i] > 255) rgb._clipped = true;
                if (rgb[i] < 0) rgb[i] = 0;
                if (rgb[i] > 255) rgb[i] = 255;
            } else if (i === 3) {
                if (rgb[i] < 0) rgb[i] = 0;
                if (rgb[i] > 1) rgb[i] = 1;
            }
        }
        if (!rgb._clipped) delete rgb._unclipped;
        return rgb;
    };
    PI = Math.PI, round = Math.round, cos = Math.cos, floor = Math.floor, pow = Math.pow, log = Math.log, sin = Math.sin, sqrt = Math.sqrt, atan2 = Math.atan2, max = Math.max, abs = Math.abs;
    TWOPI = PI * 2;
    PITHIRD = PI / 3;
    DEG2RAD = PI / 180;
    RAD2DEG = 180 / PI;
    chroma = function() {
        if (arguments[0] instanceof Color) return arguments[0];
        return function(func, args, ctor) {
            ctor.prototype = func.prototype;
            var child = new ctor, result = func.apply(child, args);
            return Object(result) === result ? result : child;
        }(Color, arguments, function() {});
    };
    chroma["default"] = chroma;
    _interpolators = [];
    if (module !== null && module.exports != null) module.exports = chroma;
    if (typeof define === "function" && define.amd) define([], function() {
        return chroma;
    });
    else {
        root = exports !== null ? exports : this;
        root.chroma = chroma;
    }
    chroma.version = "1.4.1";
    _input = {};
    _guess_formats = [];
    _guess_formats_sorted = false;
    Color = function() {
        function Color() {
            var arg, args, chk, len, len1, me, mode, o, w;
            me = this;
            args = [];
            for(o = 0, len = arguments.length; o < len; o++){
                arg = arguments[o];
                if (arg != null) args.push(arg);
            }
            if (args.length > 1) mode = args[args.length - 1];
            if (_input[mode] != null) me._rgb = clip_rgb(_input[mode](unpack(args.slice(0, -1))));
            else {
                if (!_guess_formats_sorted) {
                    _guess_formats = _guess_formats.sort(function(a, b) {
                        return b.p - a.p;
                    });
                    _guess_formats_sorted = true;
                }
                for(w = 0, len1 = _guess_formats.length; w < len1; w++){
                    chk = _guess_formats[w];
                    mode = chk.test.apply(chk, args);
                    if (mode) break;
                }
                if (mode) me._rgb = clip_rgb(_input[mode].apply(_input, args));
            }
            if (me._rgb == null) console.warn("unknown format: " + args);
            if (me._rgb == null) me._rgb = [
                0,
                0,
                0
            ];
            if (me._rgb.length === 3) me._rgb.push(1);
        }
        Color.prototype.toString = function() {
            return this.hex();
        };
        return Color;
    }();
    chroma._input = _input;
    /**
  	ColorBrewer colors for chroma.js
  
  	Copyright (c) 2002 Cynthia Brewer, Mark Harrower, and The 
  	Pennsylvania State University.
  
  	Licensed under the Apache License, Version 2.0 (the "License"); 
  	you may not use this file except in compliance with the License.
  	You may obtain a copy of the License at	
  	http://www.apache.org/licenses/LICENSE-2.0
  
  	Unless required by applicable law or agreed to in writing, software distributed
  	under the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
  	CONDITIONS OF ANY KIND, either express or implied. See the License for the
  	specific language governing permissions and limitations under the License.
  
      @preserve
   */ chroma.brewer = brewer = {
        OrRd: [
            "#fff7ec",
            "#fee8c8",
            "#fdd49e",
            "#fdbb84",
            "#fc8d59",
            "#ef6548",
            "#d7301f",
            "#b30000",
            "#7f0000"
        ],
        PuBu: [
            "#fff7fb",
            "#ece7f2",
            "#d0d1e6",
            "#a6bddb",
            "#74a9cf",
            "#3690c0",
            "#0570b0",
            "#045a8d",
            "#023858"
        ],
        BuPu: [
            "#f7fcfd",
            "#e0ecf4",
            "#bfd3e6",
            "#9ebcda",
            "#8c96c6",
            "#8c6bb1",
            "#88419d",
            "#810f7c",
            "#4d004b"
        ],
        Oranges: [
            "#fff5eb",
            "#fee6ce",
            "#fdd0a2",
            "#fdae6b",
            "#fd8d3c",
            "#f16913",
            "#d94801",
            "#a63603",
            "#7f2704"
        ],
        BuGn: [
            "#f7fcfd",
            "#e5f5f9",
            "#ccece6",
            "#99d8c9",
            "#66c2a4",
            "#41ae76",
            "#238b45",
            "#006d2c",
            "#00441b"
        ],
        YlOrBr: [
            "#ffffe5",
            "#fff7bc",
            "#fee391",
            "#fec44f",
            "#fe9929",
            "#ec7014",
            "#cc4c02",
            "#993404",
            "#662506"
        ],
        YlGn: [
            "#ffffe5",
            "#f7fcb9",
            "#d9f0a3",
            "#addd8e",
            "#78c679",
            "#41ab5d",
            "#238443",
            "#006837",
            "#004529"
        ],
        Reds: [
            "#fff5f0",
            "#fee0d2",
            "#fcbba1",
            "#fc9272",
            "#fb6a4a",
            "#ef3b2c",
            "#cb181d",
            "#a50f15",
            "#67000d"
        ],
        RdPu: [
            "#fff7f3",
            "#fde0dd",
            "#fcc5c0",
            "#fa9fb5",
            "#f768a1",
            "#dd3497",
            "#ae017e",
            "#7a0177",
            "#49006a"
        ],
        Greens: [
            "#f7fcf5",
            "#e5f5e0",
            "#c7e9c0",
            "#a1d99b",
            "#74c476",
            "#41ab5d",
            "#238b45",
            "#006d2c",
            "#00441b"
        ],
        YlGnBu: [
            "#ffffd9",
            "#edf8b1",
            "#c7e9b4",
            "#7fcdbb",
            "#41b6c4",
            "#1d91c0",
            "#225ea8",
            "#253494",
            "#081d58"
        ],
        Purples: [
            "#fcfbfd",
            "#efedf5",
            "#dadaeb",
            "#bcbddc",
            "#9e9ac8",
            "#807dba",
            "#6a51a3",
            "#54278f",
            "#3f007d"
        ],
        GnBu: [
            "#f7fcf0",
            "#e0f3db",
            "#ccebc5",
            "#a8ddb5",
            "#7bccc4",
            "#4eb3d3",
            "#2b8cbe",
            "#0868ac",
            "#084081"
        ],
        Greys: [
            "#ffffff",
            "#f0f0f0",
            "#d9d9d9",
            "#bdbdbd",
            "#969696",
            "#737373",
            "#525252",
            "#252525",
            "#000000"
        ],
        YlOrRd: [
            "#ffffcc",
            "#ffeda0",
            "#fed976",
            "#feb24c",
            "#fd8d3c",
            "#fc4e2a",
            "#e31a1c",
            "#bd0026",
            "#800026"
        ],
        PuRd: [
            "#f7f4f9",
            "#e7e1ef",
            "#d4b9da",
            "#c994c7",
            "#df65b0",
            "#e7298a",
            "#ce1256",
            "#980043",
            "#67001f"
        ],
        Blues: [
            "#f7fbff",
            "#deebf7",
            "#c6dbef",
            "#9ecae1",
            "#6baed6",
            "#4292c6",
            "#2171b5",
            "#08519c",
            "#08306b"
        ],
        PuBuGn: [
            "#fff7fb",
            "#ece2f0",
            "#d0d1e6",
            "#a6bddb",
            "#67a9cf",
            "#3690c0",
            "#02818a",
            "#016c59",
            "#014636"
        ],
        Viridis: [
            "#440154",
            "#482777",
            "#3f4a8a",
            "#31678e",
            "#26838f",
            "#1f9d8a",
            "#6cce5a",
            "#b6de2b",
            "#fee825"
        ],
        Spectral: [
            "#9e0142",
            "#d53e4f",
            "#f46d43",
            "#fdae61",
            "#fee08b",
            "#ffffbf",
            "#e6f598",
            "#abdda4",
            "#66c2a5",
            "#3288bd",
            "#5e4fa2"
        ],
        RdYlGn: [
            "#a50026",
            "#d73027",
            "#f46d43",
            "#fdae61",
            "#fee08b",
            "#ffffbf",
            "#d9ef8b",
            "#a6d96a",
            "#66bd63",
            "#1a9850",
            "#006837"
        ],
        RdBu: [
            "#67001f",
            "#b2182b",
            "#d6604d",
            "#f4a582",
            "#fddbc7",
            "#f7f7f7",
            "#d1e5f0",
            "#92c5de",
            "#4393c3",
            "#2166ac",
            "#053061"
        ],
        PiYG: [
            "#8e0152",
            "#c51b7d",
            "#de77ae",
            "#f1b6da",
            "#fde0ef",
            "#f7f7f7",
            "#e6f5d0",
            "#b8e186",
            "#7fbc41",
            "#4d9221",
            "#276419"
        ],
        PRGn: [
            "#40004b",
            "#762a83",
            "#9970ab",
            "#c2a5cf",
            "#e7d4e8",
            "#f7f7f7",
            "#d9f0d3",
            "#a6dba0",
            "#5aae61",
            "#1b7837",
            "#00441b"
        ],
        RdYlBu: [
            "#a50026",
            "#d73027",
            "#f46d43",
            "#fdae61",
            "#fee090",
            "#ffffbf",
            "#e0f3f8",
            "#abd9e9",
            "#74add1",
            "#4575b4",
            "#313695"
        ],
        BrBG: [
            "#543005",
            "#8c510a",
            "#bf812d",
            "#dfc27d",
            "#f6e8c3",
            "#f5f5f5",
            "#c7eae5",
            "#80cdc1",
            "#35978f",
            "#01665e",
            "#003c30"
        ],
        RdGy: [
            "#67001f",
            "#b2182b",
            "#d6604d",
            "#f4a582",
            "#fddbc7",
            "#ffffff",
            "#e0e0e0",
            "#bababa",
            "#878787",
            "#4d4d4d",
            "#1a1a1a"
        ],
        PuOr: [
            "#7f3b08",
            "#b35806",
            "#e08214",
            "#fdb863",
            "#fee0b6",
            "#f7f7f7",
            "#d8daeb",
            "#b2abd2",
            "#8073ac",
            "#542788",
            "#2d004b"
        ],
        Set2: [
            "#66c2a5",
            "#fc8d62",
            "#8da0cb",
            "#e78ac3",
            "#a6d854",
            "#ffd92f",
            "#e5c494",
            "#b3b3b3"
        ],
        Accent: [
            "#7fc97f",
            "#beaed4",
            "#fdc086",
            "#ffff99",
            "#386cb0",
            "#f0027f",
            "#bf5b17",
            "#666666"
        ],
        Set1: [
            "#e41a1c",
            "#377eb8",
            "#4daf4a",
            "#984ea3",
            "#ff7f00",
            "#ffff33",
            "#a65628",
            "#f781bf",
            "#999999"
        ],
        Set3: [
            "#8dd3c7",
            "#ffffb3",
            "#bebada",
            "#fb8072",
            "#80b1d3",
            "#fdb462",
            "#b3de69",
            "#fccde5",
            "#d9d9d9",
            "#bc80bd",
            "#ccebc5",
            "#ffed6f"
        ],
        Dark2: [
            "#1b9e77",
            "#d95f02",
            "#7570b3",
            "#e7298a",
            "#66a61e",
            "#e6ab02",
            "#a6761d",
            "#666666"
        ],
        Paired: [
            "#a6cee3",
            "#1f78b4",
            "#b2df8a",
            "#33a02c",
            "#fb9a99",
            "#e31a1c",
            "#fdbf6f",
            "#ff7f00",
            "#cab2d6",
            "#6a3d9a",
            "#ffff99",
            "#b15928"
        ],
        Pastel2: [
            "#b3e2cd",
            "#fdcdac",
            "#cbd5e8",
            "#f4cae4",
            "#e6f5c9",
            "#fff2ae",
            "#f1e2cc",
            "#cccccc"
        ],
        Pastel1: [
            "#fbb4ae",
            "#b3cde3",
            "#ccebc5",
            "#decbe4",
            "#fed9a6",
            "#ffffcc",
            "#e5d8bd",
            "#fddaec",
            "#f2f2f2"
        ]
    };
    (function() {
        var key, results;
        results = [];
        for(key in brewer)results.push(brewer[key.toLowerCase()] = brewer[key]);
        return results;
    })();
    /**
  	X11 color names
  
  	http://www.w3.org/TR/css3-color/#svg-color
   */ w3cx11 = {
        aliceblue: "#f0f8ff",
        antiquewhite: "#faebd7",
        aqua: "#00ffff",
        aquamarine: "#7fffd4",
        azure: "#f0ffff",
        beige: "#f5f5dc",
        bisque: "#ffe4c4",
        black: "#000000",
        blanchedalmond: "#ffebcd",
        blue: "#0000ff",
        blueviolet: "#8a2be2",
        brown: "#a52a2a",
        burlywood: "#deb887",
        cadetblue: "#5f9ea0",
        chartreuse: "#7fff00",
        chocolate: "#d2691e",
        coral: "#ff7f50",
        cornflower: "#6495ed",
        cornflowerblue: "#6495ed",
        cornsilk: "#fff8dc",
        crimson: "#dc143c",
        cyan: "#00ffff",
        darkblue: "#00008b",
        darkcyan: "#008b8b",
        darkgoldenrod: "#b8860b",
        darkgray: "#a9a9a9",
        darkgreen: "#006400",
        darkgrey: "#a9a9a9",
        darkkhaki: "#bdb76b",
        darkmagenta: "#8b008b",
        darkolivegreen: "#556b2f",
        darkorange: "#ff8c00",
        darkorchid: "#9932cc",
        darkred: "#8b0000",
        darksalmon: "#e9967a",
        darkseagreen: "#8fbc8f",
        darkslateblue: "#483d8b",
        darkslategray: "#2f4f4f",
        darkslategrey: "#2f4f4f",
        darkturquoise: "#00ced1",
        darkviolet: "#9400d3",
        deeppink: "#ff1493",
        deepskyblue: "#00bfff",
        dimgray: "#696969",
        dimgrey: "#696969",
        dodgerblue: "#1e90ff",
        firebrick: "#b22222",
        floralwhite: "#fffaf0",
        forestgreen: "#228b22",
        fuchsia: "#ff00ff",
        gainsboro: "#dcdcdc",
        ghostwhite: "#f8f8ff",
        gold: "#ffd700",
        goldenrod: "#daa520",
        gray: "#808080",
        green: "#008000",
        greenyellow: "#adff2f",
        grey: "#808080",
        honeydew: "#f0fff0",
        hotpink: "#ff69b4",
        indianred: "#cd5c5c",
        indigo: "#4b0082",
        ivory: "#fffff0",
        khaki: "#f0e68c",
        laserlemon: "#ffff54",
        lavender: "#e6e6fa",
        lavenderblush: "#fff0f5",
        lawngreen: "#7cfc00",
        lemonchiffon: "#fffacd",
        lightblue: "#add8e6",
        lightcoral: "#f08080",
        lightcyan: "#e0ffff",
        lightgoldenrod: "#fafad2",
        lightgoldenrodyellow: "#fafad2",
        lightgray: "#d3d3d3",
        lightgreen: "#90ee90",
        lightgrey: "#d3d3d3",
        lightpink: "#ffb6c1",
        lightsalmon: "#ffa07a",
        lightseagreen: "#20b2aa",
        lightskyblue: "#87cefa",
        lightslategray: "#778899",
        lightslategrey: "#778899",
        lightsteelblue: "#b0c4de",
        lightyellow: "#ffffe0",
        lime: "#00ff00",
        limegreen: "#32cd32",
        linen: "#faf0e6",
        magenta: "#ff00ff",
        maroon: "#800000",
        maroon2: "#7f0000",
        maroon3: "#b03060",
        mediumaquamarine: "#66cdaa",
        mediumblue: "#0000cd",
        mediumorchid: "#ba55d3",
        mediumpurple: "#9370db",
        mediumseagreen: "#3cb371",
        mediumslateblue: "#7b68ee",
        mediumspringgreen: "#00fa9a",
        mediumturquoise: "#48d1cc",
        mediumvioletred: "#c71585",
        midnightblue: "#191970",
        mintcream: "#f5fffa",
        mistyrose: "#ffe4e1",
        moccasin: "#ffe4b5",
        navajowhite: "#ffdead",
        navy: "#000080",
        oldlace: "#fdf5e6",
        olive: "#808000",
        olivedrab: "#6b8e23",
        orange: "#ffa500",
        orangered: "#ff4500",
        orchid: "#da70d6",
        palegoldenrod: "#eee8aa",
        palegreen: "#98fb98",
        paleturquoise: "#afeeee",
        palevioletred: "#db7093",
        papayawhip: "#ffefd5",
        peachpuff: "#ffdab9",
        peru: "#cd853f",
        pink: "#ffc0cb",
        plum: "#dda0dd",
        powderblue: "#b0e0e6",
        purple: "#800080",
        purple2: "#7f007f",
        purple3: "#a020f0",
        rebeccapurple: "#663399",
        red: "#ff0000",
        rosybrown: "#bc8f8f",
        royalblue: "#4169e1",
        saddlebrown: "#8b4513",
        salmon: "#fa8072",
        sandybrown: "#f4a460",
        seagreen: "#2e8b57",
        seashell: "#fff5ee",
        sienna: "#a0522d",
        silver: "#c0c0c0",
        skyblue: "#87ceeb",
        slateblue: "#6a5acd",
        slategray: "#708090",
        slategrey: "#708090",
        snow: "#fffafa",
        springgreen: "#00ff7f",
        steelblue: "#4682b4",
        tan: "#d2b48c",
        teal: "#008080",
        thistle: "#d8bfd8",
        tomato: "#ff6347",
        turquoise: "#40e0d0",
        violet: "#ee82ee",
        wheat: "#f5deb3",
        white: "#ffffff",
        whitesmoke: "#f5f5f5",
        yellow: "#ffff00",
        yellowgreen: "#9acd32"
    };
    chroma.colors = colors = w3cx11;
    lab2rgb = function() {
        var a, args, b, g, l, r, x, y, z;
        args = unpack(arguments);
        l = args[0], a = args[1], b = args[2];
        y = (l + 16) / 116;
        x = isNaN(a) ? y : y + a / 500;
        z = isNaN(b) ? y : y - b / 200;
        y = LAB_CONSTANTS.Yn * lab_xyz(y);
        x = LAB_CONSTANTS.Xn * lab_xyz(x);
        z = LAB_CONSTANTS.Zn * lab_xyz(z);
        r = xyz_rgb(3.2404542 * x - 1.5371385 * y - 0.4985314 * z);
        g = xyz_rgb(-0.969266 * x + 1.8760108 * y + 0.0415560 * z);
        b = xyz_rgb(0.0556434 * x - 0.2040259 * y + 1.0572252 * z);
        return [
            r,
            g,
            b,
            args.length > 3 ? args[3] : 1
        ];
    };
    xyz_rgb = function(r) {
        return 255 * (r <= 0.00304 ? 12.92 * r : 1.055 * pow(r, 1 / 2.4) - 0.055);
    };
    lab_xyz = function(t) {
        if (t > LAB_CONSTANTS.t1) return t * t * t;
        else return LAB_CONSTANTS.t2 * (t - LAB_CONSTANTS.t0);
    };
    LAB_CONSTANTS = {
        Kn: 18,
        Xn: 0.950470,
        Yn: 1,
        Zn: 1.088830,
        t0: 0.137931034,
        t1: 0.206896552,
        t2: 0.12841855,
        t3: 0.008856452
    };
    rgb2lab = function() {
        var b, g, r, ref, ref1, x, y, z;
        ref = unpack(arguments), r = ref[0], g = ref[1], b = ref[2];
        ref1 = rgb2xyz(r, g, b), x = ref1[0], y = ref1[1], z = ref1[2];
        return [
            116 * y - 16,
            500 * (x - y),
            200 * (y - z)
        ];
    };
    rgb_xyz = function(r) {
        if ((r /= 255) <= 0.04045) return r / 12.92;
        else return pow((r + 0.055) / 1.055, 2.4);
    };
    xyz_lab = function(t) {
        if (t > LAB_CONSTANTS.t3) return pow(t, 1 / 3);
        else return t / LAB_CONSTANTS.t2 + LAB_CONSTANTS.t0;
    };
    rgb2xyz = function() {
        var b, g, r, ref, x, y, z;
        ref = unpack(arguments), r = ref[0], g = ref[1], b = ref[2];
        r = rgb_xyz(r);
        g = rgb_xyz(g);
        b = rgb_xyz(b);
        x = xyz_lab((0.4124564 * r + 0.3575761 * g + 0.1804375 * b) / LAB_CONSTANTS.Xn);
        y = xyz_lab((0.2126729 * r + 0.7151522 * g + 0.0721750 * b) / LAB_CONSTANTS.Yn);
        z = xyz_lab((0.0193339 * r + 0.1191920 * g + 0.9503041 * b) / LAB_CONSTANTS.Zn);
        return [
            x,
            y,
            z
        ];
    };
    chroma.lab = function() {
        return function(func, args, ctor) {
            ctor.prototype = func.prototype;
            var child = new ctor, result = func.apply(child, args);
            return Object(result) === result ? result : child;
        }(Color, slice.call(arguments).concat([
            "lab"
        ]), function() {});
    };
    _input.lab = lab2rgb;
    Color.prototype.lab = function() {
        return rgb2lab(this._rgb);
    };
    bezier = function(colors) {
        var I, I0, I1, c, lab0, lab1, lab2, lab3, ref, ref1, ref2;
        colors = function() {
            var len, o, results;
            results = [];
            for(o = 0, len = colors.length; o < len; o++){
                c = colors[o];
                results.push(chroma(c));
            }
            return results;
        }();
        if (colors.length === 2) {
            ref = function() {
                var len, o, results;
                results = [];
                for(o = 0, len = colors.length; o < len; o++){
                    c = colors[o];
                    results.push(c.lab());
                }
                return results;
            }(), lab0 = ref[0], lab1 = ref[1];
            I = function(t) {
                var i, lab;
                lab = function() {
                    var o, results;
                    results = [];
                    for(i = o = 0; o <= 2; i = ++o)results.push(lab0[i] + t * (lab1[i] - lab0[i]));
                    return results;
                }();
                return chroma.lab.apply(chroma, lab);
            };
        } else if (colors.length === 3) {
            ref1 = function() {
                var len, o, results;
                results = [];
                for(o = 0, len = colors.length; o < len; o++){
                    c = colors[o];
                    results.push(c.lab());
                }
                return results;
            }(), lab0 = ref1[0], lab1 = ref1[1], lab2 = ref1[2];
            I = function(t) {
                var i, lab;
                lab = function() {
                    var o, results;
                    results = [];
                    for(i = o = 0; o <= 2; i = ++o)results.push((1 - t) * (1 - t) * lab0[i] + 2 * (1 - t) * t * lab1[i] + t * t * lab2[i]);
                    return results;
                }();
                return chroma.lab.apply(chroma, lab);
            };
        } else if (colors.length === 4) {
            ref2 = function() {
                var len, o, results;
                results = [];
                for(o = 0, len = colors.length; o < len; o++){
                    c = colors[o];
                    results.push(c.lab());
                }
                return results;
            }(), lab0 = ref2[0], lab1 = ref2[1], lab2 = ref2[2], lab3 = ref2[3];
            I = function(t) {
                var i, lab;
                lab = function() {
                    var o, results;
                    results = [];
                    for(i = o = 0; o <= 2; i = ++o)results.push((1 - t) * (1 - t) * (1 - t) * lab0[i] + 3 * (1 - t) * (1 - t) * t * lab1[i] + 3 * (1 - t) * t * t * lab2[i] + t * t * t * lab3[i]);
                    return results;
                }();
                return chroma.lab.apply(chroma, lab);
            };
        } else if (colors.length === 5) {
            I0 = bezier(colors.slice(0, 3));
            I1 = bezier(colors.slice(2, 5));
            I = function(t) {
                if (t < 0.5) return I0(t * 2);
                else return I1((t - 0.5) * 2);
            };
        }
        return I;
    };
    chroma.bezier = function(colors) {
        var f;
        f = bezier(colors);
        f.scale = function() {
            return chroma.scale(f);
        };
        return f;
    };
    chroma.cubehelix = function(start, rotations, hue, gamma, lightness) {
        var dh, dl, f;
        if (start == null) start = 300;
        if (rotations == null) rotations = -1.5;
        if (hue == null) hue = 1;
        if (gamma == null) gamma = 1;
        if (lightness == null) lightness = [
            0,
            1
        ];
        dh = 0;
        if (type(lightness) === "array") dl = lightness[1] - lightness[0];
        else {
            dl = 0;
            lightness = [
                lightness,
                lightness
            ];
        }
        f = function(fract) {
            var a, amp, b, cos_a, g, h, l, r, sin_a;
            a = TWOPI * ((start + 120) / 360 + rotations * fract);
            l = pow(lightness[0] + dl * fract, gamma);
            h = dh !== 0 ? hue[0] + fract * dh : hue;
            amp = h * l * (1 - l) / 2;
            cos_a = cos(a);
            sin_a = sin(a);
            r = l + amp * (-0.14861 * cos_a + 1.78277 * sin_a);
            g = l + amp * (-0.29227 * cos_a - 0.90649 * sin_a);
            b = l + amp * (1.97294 * cos_a);
            return chroma(clip_rgb([
                r * 255,
                g * 255,
                b * 255,
                1
            ]));
        };
        f.start = function(s) {
            if (s == null) return start;
            start = s;
            return f;
        };
        f.rotations = function(r) {
            if (r == null) return rotations;
            rotations = r;
            return f;
        };
        f.gamma = function(g) {
            if (g == null) return gamma;
            gamma = g;
            return f;
        };
        f.hue = function(h) {
            if (h == null) return hue;
            hue = h;
            if (type(hue) === "array") {
                dh = hue[1] - hue[0];
                if (dh === 0) hue = hue[1];
            } else dh = 0;
            return f;
        };
        f.lightness = function(h) {
            if (h == null) return lightness;
            if (type(h) === "array") {
                lightness = h;
                dl = h[1] - h[0];
            } else {
                lightness = [
                    h,
                    h
                ];
                dl = 0;
            }
            return f;
        };
        f.scale = function() {
            return chroma.scale(f);
        };
        f.hue(hue);
        return f;
    };
    chroma.random = function() {
        var code, digits, i, o;
        digits = "0123456789abcdef";
        code = "#";
        for(i = o = 0; o < 6; i = ++o)code += digits.charAt(floor(Math.random() * 16));
        return new Color(code);
    };
    _interpolators = [];
    interpolate = function(col1, col2, f, m) {
        var interpol, len, o, res;
        if (f == null) f = 0.5;
        if (m == null) m = "rgb";
        /*
    interpolates between colors
    f = 0 --> me
    f = 1 --> col
     */ if (type(col1) !== "object") col1 = chroma(col1);
        if (type(col2) !== "object") col2 = chroma(col2);
        for(o = 0, len = _interpolators.length; o < len; o++){
            interpol = _interpolators[o];
            if (m === interpol[0]) {
                res = interpol[1](col1, col2, f, m);
                break;
            }
        }
        if (res == null) throw "color mode " + m + " is not supported";
        return res.alpha(col1.alpha() + f * (col2.alpha() - col1.alpha()));
    };
    chroma.interpolate = interpolate;
    Color.prototype.interpolate = function(col2, f, m) {
        return interpolate(this, col2, f, m);
    };
    chroma.mix = interpolate;
    Color.prototype.mix = Color.prototype.interpolate;
    _input.rgb = function() {
        var k, ref, results, v;
        ref = unpack(arguments);
        results = [];
        for(k in ref){
            v = ref[k];
            results.push(v);
        }
        return results;
    };
    chroma.rgb = function() {
        return function(func, args, ctor) {
            ctor.prototype = func.prototype;
            var child = new ctor, result = func.apply(child, args);
            return Object(result) === result ? result : child;
        }(Color, slice.call(arguments).concat([
            "rgb"
        ]), function() {});
    };
    Color.prototype.rgb = function(round) {
        if (round == null) round = true;
        if (round) return this._rgb.map(Math.round).slice(0, 3);
        else return this._rgb.slice(0, 3);
    };
    Color.prototype.rgba = function(round) {
        if (round == null) round = true;
        if (!round) return this._rgb.slice(0);
        return [
            Math.round(this._rgb[0]),
            Math.round(this._rgb[1]),
            Math.round(this._rgb[2]),
            this._rgb[3]
        ];
    };
    _guess_formats.push({
        p: 3,
        test: function(n) {
            var a;
            a = unpack(arguments);
            if (type(a) === "array" && a.length === 3) return "rgb";
            if (a.length === 4 && type(a[3]) === "number" && a[3] >= 0 && a[3] <= 1) return "rgb";
        }
    });
    _input.lrgb = _input.rgb;
    interpolate_lrgb = function(col1, col2, f, m) {
        var xyz0, xyz1;
        xyz0 = col1._rgb;
        xyz1 = col2._rgb;
        return new Color(sqrt(pow(xyz0[0], 2) * (1 - f) + pow(xyz1[0], 2) * f), sqrt(pow(xyz0[1], 2) * (1 - f) + pow(xyz1[1], 2) * f), sqrt(pow(xyz0[2], 2) * (1 - f) + pow(xyz1[2], 2) * f), m);
    };
    _average_lrgb = function(colors) {
        var col, f, len, o, rgb, xyz;
        f = 1 / colors.length;
        xyz = [
            0,
            0,
            0,
            0
        ];
        for(o = 0, len = colors.length; o < len; o++){
            col = colors[o];
            rgb = col._rgb;
            xyz[0] += pow(rgb[0], 2) * f;
            xyz[1] += pow(rgb[1], 2) * f;
            xyz[2] += pow(rgb[2], 2) * f;
            xyz[3] += rgb[3] * f;
        }
        xyz[0] = sqrt(xyz[0]);
        xyz[1] = sqrt(xyz[1]);
        xyz[2] = sqrt(xyz[2]);
        if (xyz[3] > 1) xyz[3] = 1;
        return new Color(clip_rgb(xyz));
    };
    _interpolators.push([
        "lrgb",
        interpolate_lrgb
    ]);
    chroma.average = function(colors, mode) {
        var A, alpha, c, cnt, dx, dy, first, i, l, len, o, xyz, xyz2;
        if (mode == null) mode = "rgb";
        l = colors.length;
        colors = colors.map(function(c) {
            return chroma(c);
        });
        first = colors.splice(0, 1)[0];
        if (mode === "lrgb") return _average_lrgb(colors);
        xyz = first.get(mode);
        cnt = [];
        dx = 0;
        dy = 0;
        for(i in xyz){
            xyz[i] = xyz[i] || 0;
            cnt.push(isNaN(xyz[i]) ? 0 : 1);
            if (mode.charAt(i) === "h" && !isNaN(xyz[i])) {
                A = xyz[i] / 180 * PI;
                dx += cos(A);
                dy += sin(A);
            }
        }
        alpha = first.alpha();
        for(o = 0, len = colors.length; o < len; o++){
            c = colors[o];
            xyz2 = c.get(mode);
            alpha += c.alpha();
            for(i in xyz)if (!isNaN(xyz2[i])) {
                cnt[i] += 1;
                if (mode.charAt(i) === "h") {
                    A = xyz2[i] / 180 * PI;
                    dx += cos(A);
                    dy += sin(A);
                } else xyz[i] += xyz2[i];
            }
        }
        for(i in xyz)if (mode.charAt(i) === "h") {
            A = atan2(dy / cnt[i], dx / cnt[i]) / PI * 180;
            while(A < 0)A += 360;
            while(A >= 360)A -= 360;
            xyz[i] = A;
        } else xyz[i] = xyz[i] / cnt[i];
        return chroma(xyz, mode).alpha(alpha / l);
    };
    hex2rgb = function(hex) {
        var a, b, g, r, rgb, u;
        if (hex.match(/^#?([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/)) {
            if (hex.length === 4 || hex.length === 7) hex = hex.substr(1);
            if (hex.length === 3) {
                hex = hex.split("");
                hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
            }
            u = parseInt(hex, 16);
            r = u >> 16;
            g = u >> 8 & 0xFF;
            b = u & 0xFF;
            return [
                r,
                g,
                b,
                1
            ];
        }
        if (hex.match(/^#?([A-Fa-f0-9]{8})$/)) {
            if (hex.length === 9) hex = hex.substr(1);
            u = parseInt(hex, 16);
            r = u >> 24 & 0xFF;
            g = u >> 16 & 0xFF;
            b = u >> 8 & 0xFF;
            a = round((u & 0xFF) / 0xFF * 100) / 100;
            return [
                r,
                g,
                b,
                a
            ];
        }
        if (_input.css != null && (rgb = _input.css(hex))) return rgb;
        throw "unknown color: " + hex;
    };
    rgb2hex = function(channels, mode) {
        var a, b, g, hxa, r, str, u;
        if (mode == null) mode = "auto";
        r = channels[0], g = channels[1], b = channels[2], a = channels[3];
        if (mode === "auto") mode = a < 1 ? "rgba" : "rgb";
        r = Math.round(r);
        g = Math.round(g);
        b = Math.round(b);
        u = r << 16 | g << 8 | b;
        str = "000000" + u.toString(16);
        str = str.substr(str.length - 6);
        hxa = "0" + round(a * 255).toString(16);
        hxa = hxa.substr(hxa.length - 2);
        return "#" + function() {
            switch(mode.toLowerCase()){
                case "rgba":
                    return str + hxa;
                case "argb":
                    return hxa + str;
                default:
                    return str;
            }
        }();
    };
    _input.hex = function(h) {
        return hex2rgb(h);
    };
    chroma.hex = function() {
        return function(func, args, ctor) {
            ctor.prototype = func.prototype;
            var child = new ctor, result = func.apply(child, args);
            return Object(result) === result ? result : child;
        }(Color, slice.call(arguments).concat([
            "hex"
        ]), function() {});
    };
    Color.prototype.hex = function(mode) {
        if (mode == null) mode = "auto";
        return rgb2hex(this._rgb, mode);
    };
    _guess_formats.push({
        p: 4,
        test: function(n) {
            if (arguments.length === 1 && type(n) === "string") return "hex";
        }
    });
    hsl2rgb = function() {
        var args, b, c, g, h, i, l, o, r, ref, s, t1, t2, t3;
        args = unpack(arguments);
        h = args[0], s = args[1], l = args[2];
        if (s === 0) r = g = b = l * 255;
        else {
            t3 = [
                0,
                0,
                0
            ];
            c = [
                0,
                0,
                0
            ];
            t2 = l < 0.5 ? l * (1 + s) : l + s - l * s;
            t1 = 2 * l - t2;
            h /= 360;
            t3[0] = h + 1 / 3;
            t3[1] = h;
            t3[2] = h - 1 / 3;
            for(i = o = 0; o <= 2; i = ++o){
                if (t3[i] < 0) t3[i] += 1;
                if (t3[i] > 1) t3[i] -= 1;
                if (6 * t3[i] < 1) c[i] = t1 + (t2 - t1) * 6 * t3[i];
                else if (2 * t3[i] < 1) c[i] = t2;
                else if (3 * t3[i] < 2) c[i] = t1 + (t2 - t1) * (2 / 3 - t3[i]) * 6;
                else c[i] = t1;
            }
            ref = [
                round(c[0] * 255),
                round(c[1] * 255),
                round(c[2] * 255)
            ], r = ref[0], g = ref[1], b = ref[2];
        }
        if (args.length > 3) return [
            r,
            g,
            b,
            args[3]
        ];
        else return [
            r,
            g,
            b
        ];
    };
    rgb2hsl = function(r, g, b) {
        var h, l, min, ref, s;
        if (r !== void 0 && r.length >= 3) ref = r, r = ref[0], g = ref[1], b = ref[2];
        r /= 255;
        g /= 255;
        b /= 255;
        min = Math.min(r, g, b);
        max = Math.max(r, g, b);
        l = (max + min) / 2;
        if (max === min) {
            s = 0;
            h = Number.NaN;
        } else s = l < 0.5 ? (max - min) / (max + min) : (max - min) / (2 - max - min);
        if (r === max) h = (g - b) / (max - min);
        else if (g === max) h = 2 + (b - r) / (max - min);
        else if (b === max) h = 4 + (r - g) / (max - min);
        h *= 60;
        if (h < 0) h += 360;
        return [
            h,
            s,
            l
        ];
    };
    chroma.hsl = function() {
        return function(func, args, ctor) {
            ctor.prototype = func.prototype;
            var child = new ctor, result = func.apply(child, args);
            return Object(result) === result ? result : child;
        }(Color, slice.call(arguments).concat([
            "hsl"
        ]), function() {});
    };
    _input.hsl = hsl2rgb;
    Color.prototype.hsl = function() {
        return rgb2hsl(this._rgb);
    };
    hsv2rgb = function() {
        var args, b, f, g, h, i, p, q, r, ref, ref1, ref2, ref3, ref4, ref5, s, t, v;
        args = unpack(arguments);
        h = args[0], s = args[1], v = args[2];
        v *= 255;
        if (s === 0) r = g = b = v;
        else {
            if (h === 360) h = 0;
            if (h > 360) h -= 360;
            if (h < 0) h += 360;
            h /= 60;
            i = floor(h);
            f = h - i;
            p = v * (1 - s);
            q = v * (1 - s * f);
            t = v * (1 - s * (1 - f));
            switch(i){
                case 0:
                    ref = [
                        v,
                        t,
                        p
                    ], r = ref[0], g = ref[1], b = ref[2];
                    break;
                case 1:
                    ref1 = [
                        q,
                        v,
                        p
                    ], r = ref1[0], g = ref1[1], b = ref1[2];
                    break;
                case 2:
                    ref2 = [
                        p,
                        v,
                        t
                    ], r = ref2[0], g = ref2[1], b = ref2[2];
                    break;
                case 3:
                    ref3 = [
                        p,
                        q,
                        v
                    ], r = ref3[0], g = ref3[1], b = ref3[2];
                    break;
                case 4:
                    ref4 = [
                        t,
                        p,
                        v
                    ], r = ref4[0], g = ref4[1], b = ref4[2];
                    break;
                case 5:
                    ref5 = [
                        v,
                        p,
                        q
                    ], r = ref5[0], g = ref5[1], b = ref5[2];
            }
        }
        return [
            r,
            g,
            b,
            args.length > 3 ? args[3] : 1
        ];
    };
    rgb2hsv = function() {
        var b, delta, g, h, min, r, ref, s, v;
        ref = unpack(arguments), r = ref[0], g = ref[1], b = ref[2];
        min = Math.min(r, g, b);
        max = Math.max(r, g, b);
        delta = max - min;
        v = max / 255.0;
        if (max === 0) {
            h = Number.NaN;
            s = 0;
        } else {
            s = delta / max;
            if (r === max) h = (g - b) / delta;
            if (g === max) h = 2 + (b - r) / delta;
            if (b === max) h = 4 + (r - g) / delta;
            h *= 60;
            if (h < 0) h += 360;
        }
        return [
            h,
            s,
            v
        ];
    };
    chroma.hsv = function() {
        return function(func, args, ctor) {
            ctor.prototype = func.prototype;
            var child = new ctor, result = func.apply(child, args);
            return Object(result) === result ? result : child;
        }(Color, slice.call(arguments).concat([
            "hsv"
        ]), function() {});
    };
    _input.hsv = hsv2rgb;
    Color.prototype.hsv = function() {
        return rgb2hsv(this._rgb);
    };
    num2rgb = function(num) {
        var b, g, r;
        if (type(num) === "number" && num >= 0 && num <= 0xFFFFFF) {
            r = num >> 16;
            g = num >> 8 & 0xFF;
            b = num & 0xFF;
            return [
                r,
                g,
                b,
                1
            ];
        }
        console.warn("unknown num color: " + num);
        return [
            0,
            0,
            0,
            1
        ];
    };
    rgb2num = function() {
        var b, g, r, ref;
        ref = unpack(arguments), r = ref[0], g = ref[1], b = ref[2];
        return (r << 16) + (g << 8) + b;
    };
    chroma.num = function(num) {
        return new Color(num, "num");
    };
    Color.prototype.num = function(mode) {
        if (mode == null) mode = "rgb";
        return rgb2num(this._rgb, mode);
    };
    _input.num = num2rgb;
    _guess_formats.push({
        p: 1,
        test: function(n) {
            if (arguments.length === 1 && type(n) === "number" && n >= 0 && n <= 0xFFFFFF) return "num";
        }
    });
    hcg2rgb = function() {
        var _c, _g, args, b, c, f, g, h, i, p, q, r, ref, ref1, ref2, ref3, ref4, ref5, t, v;
        args = unpack(arguments);
        h = args[0], c = args[1], _g = args[2];
        c = c / 100;
        g = g / 100 * 255;
        _c = c * 255;
        if (c === 0) r = g = b = _g;
        else {
            if (h === 360) h = 0;
            if (h > 360) h -= 360;
            if (h < 0) h += 360;
            h /= 60;
            i = floor(h);
            f = h - i;
            p = _g * (1 - c);
            q = p + _c * (1 - f);
            t = p + _c * f;
            v = p + _c;
            switch(i){
                case 0:
                    ref = [
                        v,
                        t,
                        p
                    ], r = ref[0], g = ref[1], b = ref[2];
                    break;
                case 1:
                    ref1 = [
                        q,
                        v,
                        p
                    ], r = ref1[0], g = ref1[1], b = ref1[2];
                    break;
                case 2:
                    ref2 = [
                        p,
                        v,
                        t
                    ], r = ref2[0], g = ref2[1], b = ref2[2];
                    break;
                case 3:
                    ref3 = [
                        p,
                        q,
                        v
                    ], r = ref3[0], g = ref3[1], b = ref3[2];
                    break;
                case 4:
                    ref4 = [
                        t,
                        p,
                        v
                    ], r = ref4[0], g = ref4[1], b = ref4[2];
                    break;
                case 5:
                    ref5 = [
                        v,
                        p,
                        q
                    ], r = ref5[0], g = ref5[1], b = ref5[2];
            }
        }
        return [
            r,
            g,
            b,
            args.length > 3 ? args[3] : 1
        ];
    };
    rgb2hcg = function() {
        var _g, b, c, delta, g, h, min, r, ref;
        ref = unpack(arguments), r = ref[0], g = ref[1], b = ref[2];
        min = Math.min(r, g, b);
        max = Math.max(r, g, b);
        delta = max - min;
        c = delta * 100 / 255;
        _g = min / (255 - delta) * 100;
        if (delta === 0) h = Number.NaN;
        else {
            if (r === max) h = (g - b) / delta;
            if (g === max) h = 2 + (b - r) / delta;
            if (b === max) h = 4 + (r - g) / delta;
            h *= 60;
            if (h < 0) h += 360;
        }
        return [
            h,
            c,
            _g
        ];
    };
    chroma.hcg = function() {
        return function(func, args, ctor) {
            ctor.prototype = func.prototype;
            var child = new ctor, result = func.apply(child, args);
            return Object(result) === result ? result : child;
        }(Color, slice.call(arguments).concat([
            "hcg"
        ]), function() {});
    };
    _input.hcg = hcg2rgb;
    Color.prototype.hcg = function() {
        return rgb2hcg(this._rgb);
    };
    css2rgb = function(css) {
        var aa, ab, hsl, i, m, o, rgb, w;
        css = css.toLowerCase();
        if (chroma.colors != null && chroma.colors[css]) return hex2rgb(chroma.colors[css]);
        if (m = css.match(/rgb\(\s*(\-?\d+),\s*(\-?\d+)\s*,\s*(\-?\d+)\s*\)/)) {
            rgb = m.slice(1, 4);
            for(i = o = 0; o <= 2; i = ++o)rgb[i] = +rgb[i];
            rgb[3] = 1;
        } else if (m = css.match(/rgba\(\s*(\-?\d+),\s*(\-?\d+)\s*,\s*(\-?\d+)\s*,\s*([01]|[01]?\.\d+)\)/)) {
            rgb = m.slice(1, 5);
            for(i = w = 0; w <= 3; i = ++w)rgb[i] = +rgb[i];
        } else if (m = css.match(/rgb\(\s*(\-?\d+(?:\.\d+)?)%,\s*(\-?\d+(?:\.\d+)?)%\s*,\s*(\-?\d+(?:\.\d+)?)%\s*\)/)) {
            rgb = m.slice(1, 4);
            for(i = aa = 0; aa <= 2; i = ++aa)rgb[i] = round(rgb[i] * 2.55);
            rgb[3] = 1;
        } else if (m = css.match(/rgba\(\s*(\-?\d+(?:\.\d+)?)%,\s*(\-?\d+(?:\.\d+)?)%\s*,\s*(\-?\d+(?:\.\d+)?)%\s*,\s*([01]|[01]?\.\d+)\)/)) {
            rgb = m.slice(1, 5);
            for(i = ab = 0; ab <= 2; i = ++ab)rgb[i] = round(rgb[i] * 2.55);
            rgb[3] = +rgb[3];
        } else if (m = css.match(/hsl\(\s*(\-?\d+(?:\.\d+)?),\s*(\-?\d+(?:\.\d+)?)%\s*,\s*(\-?\d+(?:\.\d+)?)%\s*\)/)) {
            hsl = m.slice(1, 4);
            hsl[1] *= 0.01;
            hsl[2] *= 0.01;
            rgb = hsl2rgb(hsl);
            rgb[3] = 1;
        } else if (m = css.match(/hsla\(\s*(\-?\d+(?:\.\d+)?),\s*(\-?\d+(?:\.\d+)?)%\s*,\s*(\-?\d+(?:\.\d+)?)%\s*,\s*([01]|[01]?\.\d+)\)/)) {
            hsl = m.slice(1, 4);
            hsl[1] *= 0.01;
            hsl[2] *= 0.01;
            rgb = hsl2rgb(hsl);
            rgb[3] = +m[4];
        }
        return rgb;
    };
    rgb2css = function(rgba) {
        var mode;
        mode = rgba[3] < 1 ? "rgba" : "rgb";
        if (mode === "rgb") return mode + "(" + rgba.slice(0, 3).map(round).join(",") + ")";
        else if (mode === "rgba") return mode + "(" + rgba.slice(0, 3).map(round).join(",") + "," + rgba[3] + ")";
    };
    rnd = function(a) {
        return round(a * 100) / 100;
    };
    hsl2css = function(hsl, alpha) {
        var mode;
        mode = alpha < 1 ? "hsla" : "hsl";
        hsl[0] = rnd(hsl[0] || 0);
        hsl[1] = rnd(hsl[1] * 100) + "%";
        hsl[2] = rnd(hsl[2] * 100) + "%";
        if (mode === "hsla") hsl[3] = alpha;
        return mode + "(" + hsl.join(",") + ")";
    };
    _input.css = function(h) {
        return css2rgb(h);
    };
    chroma.css = function() {
        return function(func, args, ctor) {
            ctor.prototype = func.prototype;
            var child = new ctor, result = func.apply(child, args);
            return Object(result) === result ? result : child;
        }(Color, slice.call(arguments).concat([
            "css"
        ]), function() {});
    };
    Color.prototype.css = function(mode) {
        if (mode == null) mode = "rgb";
        if (mode.slice(0, 3) === "rgb") return rgb2css(this._rgb);
        else if (mode.slice(0, 3) === "hsl") return hsl2css(this.hsl(), this.alpha());
    };
    _input.named = function(name) {
        return hex2rgb(w3cx11[name]);
    };
    _guess_formats.push({
        p: 5,
        test: function(n) {
            if (arguments.length === 1 && w3cx11[n] != null) return "named";
        }
    });
    Color.prototype.name = function(n) {
        var h, k;
        if (arguments.length) {
            if (w3cx11[n]) this._rgb = hex2rgb(w3cx11[n]);
            this._rgb[3] = 1;
            this;
        }
        h = this.hex("rgb");
        for(k in w3cx11){
            if (h === w3cx11[k]) return k;
        }
        return h;
    };
    lch2lab = function() {
        /*
    Convert from a qualitative parameter h and a quantitative parameter l to a 24-bit pixel.
    These formulas were invented by David Dalrymple to obtain maximum contrast without going
    out of gamut if the parameters are in the range 0-1.
    
    A saturation multiplier was added by Gregor Aisch
     */ var c, h, l, ref;
        ref = unpack(arguments), l = ref[0], c = ref[1], h = ref[2];
        h = h * DEG2RAD;
        return [
            l,
            cos(h) * c,
            sin(h) * c
        ];
    };
    lch2rgb = function() {
        var L, a, args, b, c, g, h, l, r, ref, ref1;
        args = unpack(arguments);
        l = args[0], c = args[1], h = args[2];
        ref = lch2lab(l, c, h), L = ref[0], a = ref[1], b = ref[2];
        ref1 = lab2rgb(L, a, b), r = ref1[0], g = ref1[1], b = ref1[2];
        return [
            r,
            g,
            b,
            args.length > 3 ? args[3] : 1
        ];
    };
    lab2lch = function() {
        var a, b, c, h, l, ref;
        ref = unpack(arguments), l = ref[0], a = ref[1], b = ref[2];
        c = sqrt(a * a + b * b);
        h = (atan2(b, a) * RAD2DEG + 360) % 360;
        if (round(c * 10000) === 0) h = Number.NaN;
        return [
            l,
            c,
            h
        ];
    };
    rgb2lch = function() {
        var a, b, g, l, r, ref, ref1;
        ref = unpack(arguments), r = ref[0], g = ref[1], b = ref[2];
        ref1 = rgb2lab(r, g, b), l = ref1[0], a = ref1[1], b = ref1[2];
        return lab2lch(l, a, b);
    };
    chroma.lch = function() {
        var args;
        args = unpack(arguments);
        return new Color(args, "lch");
    };
    chroma.hcl = function() {
        var args;
        args = unpack(arguments);
        return new Color(args, "hcl");
    };
    _input.lch = lch2rgb;
    _input.hcl = function() {
        var c, h, l, ref;
        ref = unpack(arguments), h = ref[0], c = ref[1], l = ref[2];
        return lch2rgb([
            l,
            c,
            h
        ]);
    };
    Color.prototype.lch = function() {
        return rgb2lch(this._rgb);
    };
    Color.prototype.hcl = function() {
        return rgb2lch(this._rgb).reverse();
    };
    rgb2cmyk = function(mode) {
        var b, c, f, g, k, m, r, ref, y;
        if (mode == null) mode = "rgb";
        ref = unpack(arguments), r = ref[0], g = ref[1], b = ref[2];
        r = r / 255;
        g = g / 255;
        b = b / 255;
        k = 1 - Math.max(r, Math.max(g, b));
        f = k < 1 ? 1 / (1 - k) : 0;
        c = (1 - r - k) * f;
        m = (1 - g - k) * f;
        y = (1 - b - k) * f;
        return [
            c,
            m,
            y,
            k
        ];
    };
    cmyk2rgb = function() {
        var alpha, args, b, c, g, k, m, r, y;
        args = unpack(arguments);
        c = args[0], m = args[1], y = args[2], k = args[3];
        alpha = args.length > 4 ? args[4] : 1;
        if (k === 1) return [
            0,
            0,
            0,
            alpha
        ];
        r = c >= 1 ? 0 : 255 * (1 - c) * (1 - k);
        g = m >= 1 ? 0 : 255 * (1 - m) * (1 - k);
        b = y >= 1 ? 0 : 255 * (1 - y) * (1 - k);
        return [
            r,
            g,
            b,
            alpha
        ];
    };
    _input.cmyk = function() {
        return cmyk2rgb(unpack(arguments));
    };
    chroma.cmyk = function() {
        return function(func, args, ctor) {
            ctor.prototype = func.prototype;
            var child = new ctor, result = func.apply(child, args);
            return Object(result) === result ? result : child;
        }(Color, slice.call(arguments).concat([
            "cmyk"
        ]), function() {});
    };
    Color.prototype.cmyk = function() {
        return rgb2cmyk(this._rgb);
    };
    _input.gl = function() {
        var i, k, o, rgb, v;
        rgb = (function() {
            var ref, results;
            ref = unpack(arguments);
            results = [];
            for(k in ref){
                v = ref[k];
                results.push(v);
            }
            return results;
        }).apply(this, arguments);
        for(i = o = 0; o <= 2; i = ++o)rgb[i] *= 255;
        return rgb;
    };
    chroma.gl = function() {
        return function(func, args, ctor) {
            ctor.prototype = func.prototype;
            var child = new ctor, result = func.apply(child, args);
            return Object(result) === result ? result : child;
        }(Color, slice.call(arguments).concat([
            "gl"
        ]), function() {});
    };
    Color.prototype.gl = function() {
        var rgb;
        rgb = this._rgb;
        return [
            rgb[0] / 255,
            rgb[1] / 255,
            rgb[2] / 255,
            rgb[3]
        ];
    };
    rgb2luminance = function(r, g, b) {
        var ref;
        ref = unpack(arguments), r = ref[0], g = ref[1], b = ref[2];
        r = luminance_x(r);
        g = luminance_x(g);
        b = luminance_x(b);
        return 0.2126 * r + 0.7152 * g + 0.0722 * b;
    };
    luminance_x = function(x) {
        x /= 255;
        if (x <= 0.03928) return x / 12.92;
        else return pow((x + 0.055) / 1.055, 2.4);
    };
    interpolate_rgb = function(col1, col2, f, m) {
        var xyz0, xyz1;
        xyz0 = col1._rgb;
        xyz1 = col2._rgb;
        return new Color(xyz0[0] + f * (xyz1[0] - xyz0[0]), xyz0[1] + f * (xyz1[1] - xyz0[1]), xyz0[2] + f * (xyz1[2] - xyz0[2]), m);
    };
    _interpolators.push([
        "rgb",
        interpolate_rgb
    ]);
    Color.prototype.luminance = function(lum, mode) {
        var cur_lum, eps, max_iter, rgba, test;
        if (mode == null) mode = "rgb";
        if (!arguments.length) return rgb2luminance(this._rgb);
        rgba = this._rgb;
        if (lum === 0) rgba = [
            0,
            0,
            0,
            this._rgb[3]
        ];
        else if (lum === 1) rgba = [
            255,
            255,
            255,
            this[3]
        ];
        else {
            cur_lum = rgb2luminance(this._rgb);
            eps = 1e-7;
            max_iter = 20;
            test = function(l, h) {
                var lm, m;
                m = l.interpolate(h, 0.5, mode);
                lm = m.luminance();
                if (Math.abs(lum - lm) < eps || !max_iter--) return m;
                if (lm > lum) return test(l, m);
                return test(m, h);
            };
            if (cur_lum > lum) rgba = test(chroma("black"), this).rgba();
            else rgba = test(this, chroma("white")).rgba();
        }
        return chroma(rgba).alpha(this.alpha());
    };
    temperature2rgb = function(kelvin) {
        var b, g, r, temp;
        temp = kelvin / 100;
        if (temp < 66) {
            r = 255;
            g = -155.25485562709179 - 0.44596950469579133 * (g = temp - 2) + 104.49216199393888 * log(g);
            b = temp < 20 ? 0 : -254.76935184120902 + 0.8274096064007395 * (b = temp - 10) + 115.67994401066147 * log(b);
        } else {
            r = 351.97690566805693 + 0.114206453784165 * (r = temp - 55) - 40.25366309332127 * log(r);
            g = 325.4494125711974 + 0.07943456536662342 * (g = temp - 50) - 28.0852963507957 * log(g);
            b = 255;
        }
        return [
            r,
            g,
            b
        ];
    };
    rgb2temperature = function() {
        var b, eps, g, maxTemp, minTemp, r, ref, rgb, temp;
        ref = unpack(arguments), r = ref[0], g = ref[1], b = ref[2];
        minTemp = 1000;
        maxTemp = 40000;
        eps = 0.4;
        while(maxTemp - minTemp > eps){
            temp = (maxTemp + minTemp) * 0.5;
            rgb = temperature2rgb(temp);
            if (rgb[2] / rgb[0] >= b / r) maxTemp = temp;
            else minTemp = temp;
        }
        return round(temp);
    };
    chroma.temperature = chroma.kelvin = function() {
        return function(func, args, ctor) {
            ctor.prototype = func.prototype;
            var child = new ctor, result = func.apply(child, args);
            return Object(result) === result ? result : child;
        }(Color, slice.call(arguments).concat([
            "temperature"
        ]), function() {});
    };
    _input.temperature = _input.kelvin = _input.K = temperature2rgb;
    Color.prototype.temperature = function() {
        return rgb2temperature(this._rgb);
    };
    Color.prototype.kelvin = Color.prototype.temperature;
    chroma.contrast = function(a, b) {
        var l1, l2, ref, ref1;
        if ((ref = type(a)) === "string" || ref === "number") a = new Color(a);
        if ((ref1 = type(b)) === "string" || ref1 === "number") b = new Color(b);
        l1 = a.luminance();
        l2 = b.luminance();
        if (l1 > l2) return (l1 + 0.05) / (l2 + 0.05);
        else return (l2 + 0.05) / (l1 + 0.05);
    };
    chroma.distance = function(a, b, mode) {
        var d, i, l1, l2, ref, ref1, sum_sq;
        if (mode == null) mode = "lab";
        if ((ref = type(a)) === "string" || ref === "number") a = new Color(a);
        if ((ref1 = type(b)) === "string" || ref1 === "number") b = new Color(b);
        l1 = a.get(mode);
        l2 = b.get(mode);
        sum_sq = 0;
        for(i in l1){
            d = (l1[i] || 0) - (l2[i] || 0);
            sum_sq += d * d;
        }
        return Math.sqrt(sum_sq);
    };
    chroma.deltaE = function(a, b, L, C) {
        var L1, L2, a1, a2, b1, b2, c1, c2, c4, dH2, delA, delB, delC, delL, f, h1, ref, ref1, ref2, ref3, sc, sh, sl, t, v1, v2, v3;
        if (L == null) L = 1;
        if (C == null) C = 1;
        if ((ref = type(a)) === "string" || ref === "number") a = new Color(a);
        if ((ref1 = type(b)) === "string" || ref1 === "number") b = new Color(b);
        ref2 = a.lab(), L1 = ref2[0], a1 = ref2[1], b1 = ref2[2];
        ref3 = b.lab(), L2 = ref3[0], a2 = ref3[1], b2 = ref3[2];
        c1 = sqrt(a1 * a1 + b1 * b1);
        c2 = sqrt(a2 * a2 + b2 * b2);
        sl = L1 < 16.0 ? 0.511 : 0.040975 * L1 / (1.0 + 0.01765 * L1);
        sc = 0.0638 * c1 / (1.0 + 0.0131 * c1) + 0.638;
        h1 = c1 < 0.000001 ? 0.0 : atan2(b1, a1) * 180.0 / PI;
        while(h1 < 0)h1 += 360;
        while(h1 >= 360)h1 -= 360;
        t = h1 >= 164.0 && h1 <= 345.0 ? 0.56 + abs(0.2 * cos(PI * (h1 + 168.0) / 180.0)) : 0.36 + abs(0.4 * cos(PI * (h1 + 35.0) / 180.0));
        c4 = c1 * c1 * c1 * c1;
        f = sqrt(c4 / (c4 + 1900.0));
        sh = sc * (f * t + 1.0 - f);
        delL = L1 - L2;
        delC = c1 - c2;
        delA = a1 - a2;
        delB = b1 - b2;
        dH2 = delA * delA + delB * delB - delC * delC;
        v1 = delL / (L * sl);
        v2 = delC / (C * sc);
        v3 = sh;
        return sqrt(v1 * v1 + v2 * v2 + dH2 / (v3 * v3));
    };
    Color.prototype.get = function(modechan) {
        var channel, i, me, mode, ref, src;
        me = this;
        ref = modechan.split("."), mode = ref[0], channel = ref[1];
        src = me[mode]();
        if (channel) {
            i = mode.indexOf(channel);
            if (i > -1) return src[i];
            else return console.warn("unknown channel " + channel + " in mode " + mode);
        } else return src;
    };
    Color.prototype.set = function(modechan, value) {
        var channel, i, me, mode, ref, src;
        me = this;
        ref = modechan.split("."), mode = ref[0], channel = ref[1];
        if (channel) {
            src = me[mode]();
            i = mode.indexOf(channel);
            if (i > -1) {
                if (type(value) === "string") switch(value.charAt(0)){
                    case "+":
                        src[i] += +value;
                        break;
                    case "-":
                        src[i] += +value;
                        break;
                    case "*":
                        src[i] *= +value.substr(1);
                        break;
                    case "/":
                        src[i] /= +value.substr(1);
                        break;
                    default:
                        src[i] = +value;
                }
                else src[i] = value;
            } else console.warn("unknown channel " + channel + " in mode " + mode);
        } else src = value;
        return chroma(src, mode).alpha(me.alpha());
    };
    Color.prototype.clipped = function() {
        return this._rgb._clipped || false;
    };
    Color.prototype.alpha = function(a) {
        if (arguments.length) return chroma.rgb([
            this._rgb[0],
            this._rgb[1],
            this._rgb[2],
            a
        ]);
        return this._rgb[3];
    };
    Color.prototype.darken = function(amount) {
        var lab, me;
        if (amount == null) amount = 1;
        me = this;
        lab = me.lab();
        lab[0] -= LAB_CONSTANTS.Kn * amount;
        return chroma.lab(lab).alpha(me.alpha());
    };
    Color.prototype.brighten = function(amount) {
        if (amount == null) amount = 1;
        return this.darken(-amount);
    };
    Color.prototype.darker = Color.prototype.darken;
    Color.prototype.brighter = Color.prototype.brighten;
    Color.prototype.saturate = function(amount) {
        var lch, me;
        if (amount == null) amount = 1;
        me = this;
        lch = me.lch();
        lch[1] += amount * LAB_CONSTANTS.Kn;
        if (lch[1] < 0) lch[1] = 0;
        return chroma.lch(lch).alpha(me.alpha());
    };
    Color.prototype.desaturate = function(amount) {
        if (amount == null) amount = 1;
        return this.saturate(-amount);
    };
    Color.prototype.premultiply = function() {
        var a, rgb;
        rgb = this.rgb();
        a = this.alpha();
        return chroma(rgb[0] * a, rgb[1] * a, rgb[2] * a, a);
    };
    blend = function(bottom, top, mode) {
        if (!blend[mode]) throw "unknown blend mode " + mode;
        return blend[mode](bottom, top);
    };
    blend_f = function(f) {
        return function(bottom, top) {
            var c0, c1;
            c0 = chroma(top).rgb();
            c1 = chroma(bottom).rgb();
            return chroma(f(c0, c1), "rgb");
        };
    };
    each = function(f) {
        return function(c0, c1) {
            var i, o, out;
            out = [];
            for(i = o = 0; o <= 3; i = ++o)out[i] = f(c0[i], c1[i]);
            return out;
        };
    };
    normal = function(a, b) {
        return a;
    };
    multiply = function(a, b) {
        return a * b / 255;
    };
    darken = function(a, b) {
        if (a > b) return b;
        else return a;
    };
    lighten = function(a, b) {
        if (a > b) return a;
        else return b;
    };
    screen = function(a, b) {
        return 255 * (1 - (1 - a / 255) * (1 - b / 255));
    };
    overlay = function(a, b) {
        if (b < 128) return 2 * a * b / 255;
        else return 255 * (1 - 2 * (1 - a / 255) * (1 - b / 255));
    };
    burn = function(a, b) {
        return 255 * (1 - (1 - b / 255) / (a / 255));
    };
    dodge = function(a, b) {
        if (a === 255) return 255;
        a = 255 * (b / 255) / (1 - a / 255);
        if (a > 255) return 255;
        else return a;
    };
    blend.normal = blend_f(each(normal));
    blend.multiply = blend_f(each(multiply));
    blend.screen = blend_f(each(screen));
    blend.overlay = blend_f(each(overlay));
    blend.darken = blend_f(each(darken));
    blend.lighten = blend_f(each(lighten));
    blend.dodge = blend_f(each(dodge));
    blend.burn = blend_f(each(burn));
    chroma.blend = blend;
    chroma.analyze = function(data) {
        var len, o, r, val;
        r = {
            min: Number.MAX_VALUE,
            max: Number.MAX_VALUE * -1,
            sum: 0,
            values: [],
            count: 0
        };
        for(o = 0, len = data.length; o < len; o++){
            val = data[o];
            if (val != null && !isNaN(val)) {
                r.values.push(val);
                r.sum += val;
                if (val < r.min) r.min = val;
                if (val > r.max) r.max = val;
                r.count += 1;
            }
        }
        r.domain = [
            r.min,
            r.max
        ];
        r.limits = function(mode, num) {
            return chroma.limits(r, mode, num);
        };
        return r;
    };
    chroma.scale = function(colors, positions) {
        var _classes, _colorCache, _colors, _correctLightness, _domain, _fixed, _gamma, _max, _min, _mode, _nacol, _out, _padding, _pos, _spread, _useCache, classifyValue, f, getClass, getColor, resetCache, setColors, tmap;
        _mode = "rgb";
        _nacol = chroma("#ccc");
        _spread = 0;
        _fixed = false;
        _domain = [
            0,
            1
        ];
        _pos = [];
        _padding = [
            0,
            0
        ];
        _classes = false;
        _colors = [];
        _out = false;
        _min = 0;
        _max = 1;
        _correctLightness = false;
        _colorCache = {};
        _useCache = true;
        _gamma = 1;
        setColors = function(colors) {
            var c, col, o, ref, ref1, w;
            if (colors == null) colors = [
                "#fff",
                "#000"
            ];
            if (colors != null && type(colors) === "string" && chroma.brewer != null) colors = chroma.brewer[colors] || chroma.brewer[colors.toLowerCase()] || colors;
            if (type(colors) === "array") {
                if (colors.length === 1) colors = [
                    colors[0],
                    colors[0]
                ];
                colors = colors.slice(0);
                for(c = o = 0, ref = colors.length - 1; 0 <= ref ? o <= ref : o >= ref; c = 0 <= ref ? ++o : --o){
                    col = colors[c];
                    if (type(col) === "string") colors[c] = chroma(col);
                }
                _pos.length = 0;
                for(c = w = 0, ref1 = colors.length - 1; 0 <= ref1 ? w <= ref1 : w >= ref1; c = 0 <= ref1 ? ++w : --w)_pos.push(c / (colors.length - 1));
            }
            resetCache();
            return _colors = colors;
        };
        getClass = function(value) {
            var i, n;
            if (_classes != null) {
                n = _classes.length - 1;
                i = 0;
                while(i < n && value >= _classes[i])i++;
                return i - 1;
            }
            return 0;
        };
        tmap = function(t) {
            return t;
        };
        classifyValue = function(value) {
            var i, maxc, minc, n, val;
            val = value;
            if (_classes.length > 2) {
                n = _classes.length - 1;
                i = getClass(value);
                minc = _classes[0] + (_classes[1] - _classes[0]) * (0 + _spread * 0.5);
                maxc = _classes[n - 1] + (_classes[n] - _classes[n - 1]) * (1 - _spread * 0.5);
                val = _min + (_classes[i] + (_classes[i + 1] - _classes[i]) * 0.5 - minc) / (maxc - minc) * (_max - _min);
            }
            return val;
        };
        getColor = function(val, bypassMap) {
            var c, col, i, k, o, p, ref, t;
            if (bypassMap == null) bypassMap = false;
            if (isNaN(val) || val === null) return _nacol;
            if (!bypassMap) {
                if (_classes && _classes.length > 2) {
                    c = getClass(val);
                    t = c / (_classes.length - 2);
                } else if (_max !== _min) t = (val - _min) / (_max - _min);
                else t = 1;
            } else t = val;
            if (!bypassMap) t = tmap(t);
            if (_gamma !== 1) t = pow(t, _gamma);
            t = _padding[0] + t * (1 - _padding[0] - _padding[1]);
            t = Math.min(1, Math.max(0, t));
            k = Math.floor(t * 10000);
            if (_useCache && _colorCache[k]) col = _colorCache[k];
            else {
                if (type(_colors) === "array") for(i = o = 0, ref = _pos.length - 1; 0 <= ref ? o <= ref : o >= ref; i = 0 <= ref ? ++o : --o){
                    p = _pos[i];
                    if (t <= p) {
                        col = _colors[i];
                        break;
                    }
                    if (t >= p && i === _pos.length - 1) {
                        col = _colors[i];
                        break;
                    }
                    if (t > p && t < _pos[i + 1]) {
                        t = (t - p) / (_pos[i + 1] - p);
                        col = chroma.interpolate(_colors[i], _colors[i + 1], t, _mode);
                        break;
                    }
                }
                else if (type(_colors) === "function") col = _colors(t);
                if (_useCache) _colorCache[k] = col;
            }
            return col;
        };
        resetCache = function() {
            return _colorCache = {};
        };
        setColors(colors);
        f = function(v) {
            var c;
            c = chroma(getColor(v));
            if (_out && c[_out]) return c[_out]();
            else return c;
        };
        f.classes = function(classes) {
            var d;
            if (classes != null) {
                if (type(classes) === "array") {
                    _classes = classes;
                    _domain = [
                        classes[0],
                        classes[classes.length - 1]
                    ];
                } else {
                    d = chroma.analyze(_domain);
                    if (classes === 0) _classes = [
                        d.min,
                        d.max
                    ];
                    else _classes = chroma.limits(d, "e", classes);
                }
                return f;
            }
            return _classes;
        };
        f.domain = function(domain) {
            var c, d, k, len, o, ref, w;
            if (!arguments.length) return _domain;
            _min = domain[0];
            _max = domain[domain.length - 1];
            _pos = [];
            k = _colors.length;
            if (domain.length === k && _min !== _max) for(o = 0, len = domain.length; o < len; o++){
                d = domain[o];
                _pos.push((d - _min) / (_max - _min));
            }
            else for(c = w = 0, ref = k - 1; 0 <= ref ? w <= ref : w >= ref; c = 0 <= ref ? ++w : --w)_pos.push(c / (k - 1));
            _domain = [
                _min,
                _max
            ];
            return f;
        };
        f.mode = function(_m) {
            if (!arguments.length) return _mode;
            _mode = _m;
            resetCache();
            return f;
        };
        f.range = function(colors, _pos) {
            setColors(colors, _pos);
            return f;
        };
        f.out = function(_o) {
            _out = _o;
            return f;
        };
        f.spread = function(val) {
            if (!arguments.length) return _spread;
            _spread = val;
            return f;
        };
        f.correctLightness = function(v) {
            if (v == null) v = true;
            _correctLightness = v;
            resetCache();
            if (_correctLightness) tmap = function(t) {
                var L0, L1, L_actual, L_diff, L_ideal, max_iter, pol, t0, t1;
                L0 = getColor(0, true).lab()[0];
                L1 = getColor(1, true).lab()[0];
                pol = L0 > L1;
                L_actual = getColor(t, true).lab()[0];
                L_ideal = L0 + (L1 - L0) * t;
                L_diff = L_actual - L_ideal;
                t0 = 0;
                t1 = 1;
                max_iter = 20;
                while(Math.abs(L_diff) > 1e-2 && max_iter-- > 0)(function() {
                    if (pol) L_diff *= -1;
                    if (L_diff < 0) {
                        t0 = t;
                        t += (t1 - t) * 0.5;
                    } else {
                        t1 = t;
                        t += (t0 - t) * 0.5;
                    }
                    L_actual = getColor(t, true).lab()[0];
                    return L_diff = L_actual - L_ideal;
                })();
                return t;
            };
            else tmap = function(t) {
                return t;
            };
            return f;
        };
        f.padding = function(p) {
            if (p != null) {
                if (type(p) === "number") p = [
                    p,
                    p
                ];
                _padding = p;
                return f;
            } else return _padding;
        };
        f.colors = function(numColors, out) {
            var dd, dm, i, o, ref, result, results, samples, w;
            if (arguments.length < 2) out = "hex";
            result = [];
            if (arguments.length === 0) result = _colors.slice(0);
            else if (numColors === 1) result = [
                f(0.5)
            ];
            else if (numColors > 1) {
                dm = _domain[0];
                dd = _domain[1] - dm;
                result = (function() {
                    results = [];
                    for(var o = 0; 0 <= numColors ? o < numColors : o > numColors; 0 <= numColors ? o++ : o--)results.push(o);
                    return results;
                }).apply(this).map(function(i) {
                    return f(dm + i / (numColors - 1) * dd);
                });
            } else {
                colors = [];
                samples = [];
                if (_classes && _classes.length > 2) for(i = w = 1, ref = _classes.length; 1 <= ref ? w < ref : w > ref; i = 1 <= ref ? ++w : --w)samples.push((_classes[i - 1] + _classes[i]) * 0.5);
                else samples = _domain;
                result = samples.map(function(v) {
                    return f(v);
                });
            }
            if (chroma[out]) result = result.map(function(c) {
                return c[out]();
            });
            return result;
        };
        f.cache = function(c) {
            if (c != null) {
                _useCache = c;
                return f;
            } else return _useCache;
        };
        f.gamma = function(g) {
            if (g != null) {
                _gamma = g;
                return f;
            } else return _gamma;
        };
        f.nodata = function(d) {
            if (d != null) {
                _nacol = chroma(d);
                return f;
            } else return _nacol;
        };
        return f;
    };
    if (chroma.scales == null) chroma.scales = {};
    chroma.scales.cool = function() {
        return chroma.scale([
            chroma.hsl(180, 1, .9),
            chroma.hsl(250, .7, .4)
        ]);
    };
    chroma.scales.hot = function() {
        return chroma.scale([
            "#000",
            "#f00",
            "#ff0",
            "#fff"
        ], [
            0,
            .25,
            .75,
            1
        ]).mode("rgb");
    };
    chroma.analyze = function(data, key, filter) {
        var add, k, len, o, r, val, visit;
        r = {
            min: Number.MAX_VALUE,
            max: Number.MAX_VALUE * -1,
            sum: 0,
            values: [],
            count: 0
        };
        if (filter == null) filter = function() {
            return true;
        };
        add = function(val) {
            if (val != null && !isNaN(val)) {
                r.values.push(val);
                r.sum += val;
                if (val < r.min) r.min = val;
                if (val > r.max) r.max = val;
                r.count += 1;
            }
        };
        visit = function(val, k) {
            if (filter(val, k)) {
                if (key != null && type(key) === "function") return add(key(val));
                else if (key != null && type(key) === "string" || type(key) === "number") return add(val[key]);
                else return add(val);
            }
        };
        if (type(data) === "array") for(o = 0, len = data.length; o < len; o++){
            val = data[o];
            visit(val);
        }
        else for(k in data){
            val = data[k];
            visit(val, k);
        }
        r.domain = [
            r.min,
            r.max
        ];
        r.limits = function(mode, num) {
            return chroma.limits(r, mode, num);
        };
        return r;
    };
    chroma.limits = function(data, mode, num) {
        var aa, ab, ac, ad, ae, af, ag, ah, ai, aj, ak, al, am, assignments, best, centroids, cluster, clusterSizes, dist, i, j, kClusters, limits, max_log, min, min_log, mindist, n, nb_iters, newCentroids, o, p, pb, pr, ref, ref1, ref10, ref11, ref12, ref13, ref14, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, repeat, sum, tmpKMeansBreaks, v, value, values, w;
        if (mode == null) mode = "equal";
        if (num == null) num = 7;
        if (type(data) === "array") data = chroma.analyze(data);
        min = data.min;
        max = data.max;
        sum = data.sum;
        values = data.values.sort(function(a, b) {
            return a - b;
        });
        if (num === 1) return [
            min,
            max
        ];
        limits = [];
        if (mode.substr(0, 1) === "c") {
            limits.push(min);
            limits.push(max);
        }
        if (mode.substr(0, 1) === "e") {
            limits.push(min);
            for(i = o = 1, ref = num - 1; 1 <= ref ? o <= ref : o >= ref; i = 1 <= ref ? ++o : --o)limits.push(min + i / num * (max - min));
            limits.push(max);
        } else if (mode.substr(0, 1) === "l") {
            if (min <= 0) throw "Logarithmic scales are only possible for values > 0";
            min_log = Math.LOG10E * log(min);
            max_log = Math.LOG10E * log(max);
            limits.push(min);
            for(i = w = 1, ref1 = num - 1; 1 <= ref1 ? w <= ref1 : w >= ref1; i = 1 <= ref1 ? ++w : --w)limits.push(pow(10, min_log + i / num * (max_log - min_log)));
            limits.push(max);
        } else if (mode.substr(0, 1) === "q") {
            limits.push(min);
            for(i = aa = 1, ref2 = num - 1; 1 <= ref2 ? aa <= ref2 : aa >= ref2; i = 1 <= ref2 ? ++aa : --aa){
                p = (values.length - 1) * i / num;
                pb = floor(p);
                if (pb === p) limits.push(values[pb]);
                else {
                    pr = p - pb;
                    limits.push(values[pb] * (1 - pr) + values[pb + 1] * pr);
                }
            }
            limits.push(max);
        } else if (mode.substr(0, 1) === "k") {
            /*
      implementation based on
      http://code.google.com/p/figue/source/browse/trunk/figue.js#336
      simplified for 1-d input values
       */ n = values.length;
            assignments = new Array(n);
            clusterSizes = new Array(num);
            repeat = true;
            nb_iters = 0;
            centroids = null;
            centroids = [];
            centroids.push(min);
            for(i = ab = 1, ref3 = num - 1; 1 <= ref3 ? ab <= ref3 : ab >= ref3; i = 1 <= ref3 ? ++ab : --ab)centroids.push(min + i / num * (max - min));
            centroids.push(max);
            while(repeat){
                for(j = ac = 0, ref4 = num - 1; 0 <= ref4 ? ac <= ref4 : ac >= ref4; j = 0 <= ref4 ? ++ac : --ac)clusterSizes[j] = 0;
                for(i = ad = 0, ref5 = n - 1; 0 <= ref5 ? ad <= ref5 : ad >= ref5; i = 0 <= ref5 ? ++ad : --ad){
                    value = values[i];
                    mindist = Number.MAX_VALUE;
                    for(j = ae = 0, ref6 = num - 1; 0 <= ref6 ? ae <= ref6 : ae >= ref6; j = 0 <= ref6 ? ++ae : --ae){
                        dist = abs(centroids[j] - value);
                        if (dist < mindist) {
                            mindist = dist;
                            best = j;
                        }
                    }
                    clusterSizes[best]++;
                    assignments[i] = best;
                }
                newCentroids = new Array(num);
                for(j = af = 0, ref7 = num - 1; 0 <= ref7 ? af <= ref7 : af >= ref7; j = 0 <= ref7 ? ++af : --af)newCentroids[j] = null;
                for(i = ag = 0, ref8 = n - 1; 0 <= ref8 ? ag <= ref8 : ag >= ref8; i = 0 <= ref8 ? ++ag : --ag){
                    cluster = assignments[i];
                    if (newCentroids[cluster] === null) newCentroids[cluster] = values[i];
                    else newCentroids[cluster] += values[i];
                }
                for(j = ah = 0, ref9 = num - 1; 0 <= ref9 ? ah <= ref9 : ah >= ref9; j = 0 <= ref9 ? ++ah : --ah)newCentroids[j] *= 1 / clusterSizes[j];
                repeat = false;
                for(j = ai = 0, ref10 = num - 1; 0 <= ref10 ? ai <= ref10 : ai >= ref10; j = 0 <= ref10 ? ++ai : --ai)if (newCentroids[j] !== centroids[i]) {
                    repeat = true;
                    break;
                }
                centroids = newCentroids;
                nb_iters++;
                if (nb_iters > 200) repeat = false;
            }
            kClusters = {};
            for(j = aj = 0, ref11 = num - 1; 0 <= ref11 ? aj <= ref11 : aj >= ref11; j = 0 <= ref11 ? ++aj : --aj)kClusters[j] = [];
            for(i = ak = 0, ref12 = n - 1; 0 <= ref12 ? ak <= ref12 : ak >= ref12; i = 0 <= ref12 ? ++ak : --ak){
                cluster = assignments[i];
                kClusters[cluster].push(values[i]);
            }
            tmpKMeansBreaks = [];
            for(j = al = 0, ref13 = num - 1; 0 <= ref13 ? al <= ref13 : al >= ref13; j = 0 <= ref13 ? ++al : --al){
                tmpKMeansBreaks.push(kClusters[j][0]);
                tmpKMeansBreaks.push(kClusters[j][kClusters[j].length - 1]);
            }
            tmpKMeansBreaks = tmpKMeansBreaks.sort(function(a, b) {
                return a - b;
            });
            limits.push(tmpKMeansBreaks[0]);
            for(i = am = 1, ref14 = tmpKMeansBreaks.length - 1; am <= ref14; i = am += 2){
                v = tmpKMeansBreaks[i];
                if (!isNaN(v) && limits.indexOf(v) === -1) limits.push(v);
            }
        }
        return limits;
    };
    hsi2rgb = function(h, s, i) {
        /*
    borrowed from here:
    http://hummer.stanford.edu/museinfo/doc/examples/humdrum/keyscape2/hsi2rgb.cpp
     */ var args, b, g, r;
        args = unpack(arguments);
        h = args[0], s = args[1], i = args[2];
        if (isNaN(h)) h = 0;
        h /= 360;
        if (h < 1 / 3) {
            b = (1 - s) / 3;
            r = (1 + s * cos(TWOPI * h) / cos(PITHIRD - TWOPI * h)) / 3;
            g = 1 - (b + r);
        } else if (h < 2 / 3) {
            h -= 1 / 3;
            r = (1 - s) / 3;
            g = (1 + s * cos(TWOPI * h) / cos(PITHIRD - TWOPI * h)) / 3;
            b = 1 - (r + g);
        } else {
            h -= 2 / 3;
            g = (1 - s) / 3;
            b = (1 + s * cos(TWOPI * h) / cos(PITHIRD - TWOPI * h)) / 3;
            r = 1 - (g + b);
        }
        r = limit(i * r * 3);
        g = limit(i * g * 3);
        b = limit(i * b * 3);
        return [
            r * 255,
            g * 255,
            b * 255,
            args.length > 3 ? args[3] : 1
        ];
    };
    rgb2hsi = function() {
        /*
    borrowed from here:
    http://hummer.stanford.edu/museinfo/doc/examples/humdrum/keyscape2/rgb2hsi.cpp
     */ var b, g, h, i, min, r, ref, s;
        ref = unpack(arguments), r = ref[0], g = ref[1], b = ref[2];
        TWOPI = Math.PI * 2;
        r /= 255;
        g /= 255;
        b /= 255;
        min = Math.min(r, g, b);
        i = (r + g + b) / 3;
        s = 1 - min / i;
        if (s === 0) h = 0;
        else {
            h = (r - g + (r - b)) / 2;
            h /= Math.sqrt((r - g) * (r - g) + (r - b) * (g - b));
            h = Math.acos(h);
            if (b > g) h = TWOPI - h;
            h /= TWOPI;
        }
        return [
            h * 360,
            s,
            i
        ];
    };
    chroma.hsi = function() {
        return function(func, args, ctor) {
            ctor.prototype = func.prototype;
            var child = new ctor, result = func.apply(child, args);
            return Object(result) === result ? result : child;
        }(Color, slice.call(arguments).concat([
            "hsi"
        ]), function() {});
    };
    _input.hsi = hsi2rgb;
    Color.prototype.hsi = function() {
        return rgb2hsi(this._rgb);
    };
    interpolate_hsx = function(col1, col2, f, m) {
        var dh, hue, hue0, hue1, lbv, lbv0, lbv1, res, sat, sat0, sat1, xyz0, xyz1;
        if (m === "hsl") {
            xyz0 = col1.hsl();
            xyz1 = col2.hsl();
        } else if (m === "hsv") {
            xyz0 = col1.hsv();
            xyz1 = col2.hsv();
        } else if (m === "hcg") {
            xyz0 = col1.hcg();
            xyz1 = col2.hcg();
        } else if (m === "hsi") {
            xyz0 = col1.hsi();
            xyz1 = col2.hsi();
        } else if (m === "lch" || m === "hcl") {
            m = "hcl";
            xyz0 = col1.hcl();
            xyz1 = col2.hcl();
        }
        if (m.substr(0, 1) === "h") {
            hue0 = xyz0[0], sat0 = xyz0[1], lbv0 = xyz0[2];
            hue1 = xyz1[0], sat1 = xyz1[1], lbv1 = xyz1[2];
        }
        if (!isNaN(hue0) && !isNaN(hue1)) {
            if (hue1 > hue0 && hue1 - hue0 > 180) dh = hue1 - (hue0 + 360);
            else if (hue1 < hue0 && hue0 - hue1 > 180) dh = hue1 + 360 - hue0;
            else dh = hue1 - hue0;
            hue = hue0 + f * dh;
        } else if (!isNaN(hue0)) {
            hue = hue0;
            if ((lbv1 === 1 || lbv1 === 0) && m !== "hsv") sat = sat0;
        } else if (!isNaN(hue1)) {
            hue = hue1;
            if ((lbv0 === 1 || lbv0 === 0) && m !== "hsv") sat = sat1;
        } else hue = Number.NaN;
        if (sat == null) sat = sat0 + f * (sat1 - sat0);
        lbv = lbv0 + f * (lbv1 - lbv0);
        return res = chroma[m](hue, sat, lbv);
    };
    _interpolators = _interpolators.concat(function() {
        var len, o, ref, results;
        ref = [
            "hsv",
            "hsl",
            "hsi",
            "hcl",
            "lch",
            "hcg"
        ];
        results = [];
        for(o = 0, len = ref.length; o < len; o++){
            m = ref[o];
            results.push([
                m,
                interpolate_hsx
            ]);
        }
        return results;
    }());
    interpolate_num = function(col1, col2, f, m) {
        var n1, n2;
        n1 = col1.num();
        n2 = col2.num();
        return chroma.num(n1 + (n2 - n1) * f, "num");
    };
    _interpolators.push([
        "num",
        interpolate_num
    ]);
    interpolate_lab = function(col1, col2, f, m) {
        var res, xyz0, xyz1;
        xyz0 = col1.lab();
        xyz1 = col2.lab();
        return res = new Color(xyz0[0] + f * (xyz1[0] - xyz0[0]), xyz0[1] + f * (xyz1[1] - xyz0[1]), xyz0[2] + f * (xyz1[2] - xyz0[2]), m);
    };
    _interpolators.push([
        "lab",
        interpolate_lab
    ]);
}).call(this);

});

parcelRegister("5C8fj", function(module, exports) {

$parcel$export(module.exports, "init", function () { return init; });
$parcel$export(module.exports, "forward", function () { return forward; });
$parcel$export(module.exports, "inverse", function () { return inverse; });
$parcel$export(module.exports, "names", function () { return names; });
$parcel$export(module.exports, "default", function () { return $4166e5dcdbe95a4c$export$2e2bcd8739ae039; });
// Heavily based on this etmerc projection implementation
// https://github.com/mbloch/mapshaper-proj/blob/master/src/projections/etmerc.js

var $jSMMP = parcelRequire("jSMMP");

var $QiqjO = parcelRequire("QiqjO");

var $5nakf = parcelRequire("5nakf");

var $7vOwR = parcelRequire("7vOwR");

var $Etdpz = parcelRequire("Etdpz");

var $eyMvE = parcelRequire("eyMvE");

var $6pKZK = parcelRequire("6pKZK");

var $186WS = parcelRequire("186WS");
function init() {
    if (!this.approx && (isNaN(this.es) || this.es <= 0)) throw new Error('Incorrect elliptical usage. Try using the +approx option in the proj string, or PROJECTION["Fast_Transverse_Mercator"] in the WKT.');
    if (this.approx) {
        // When '+approx' is set, use tmerc instead
        (0, $jSMMP.default).init.apply(this);
        this.forward = (0, $jSMMP.default).forward;
        this.inverse = (0, $jSMMP.default).inverse;
    }
    this.x0 = this.x0 !== undefined ? this.x0 : 0;
    this.y0 = this.y0 !== undefined ? this.y0 : 0;
    this.long0 = this.long0 !== undefined ? this.long0 : 0;
    this.lat0 = this.lat0 !== undefined ? this.lat0 : 0;
    this.cgb = [];
    this.cbg = [];
    this.utg = [];
    this.gtu = [];
    var f = this.es / (1 + Math.sqrt(1 - this.es));
    var n = f / (2 - f);
    var np = n;
    this.cgb[0] = n * (2 + n * (-2 / 3 + n * (-2 + n * (116 / 45 + n * (26 / 45 + n * (-2854 / 675))))));
    this.cbg[0] = n * (-2 + n * (2 / 3 + n * (4 / 3 + n * (-82 / 45 + n * (32 / 45 + n * (4642 / 4725))))));
    np = np * n;
    this.cgb[1] = np * (7 / 3 + n * (-1.6 + n * (-227 / 45 + n * (2704 / 315 + n * (2323 / 945)))));
    this.cbg[1] = np * (5 / 3 + n * (-16 / 15 + n * (-13 / 9 + n * (904 / 315 + n * (-1522 / 945)))));
    np = np * n;
    this.cgb[2] = np * (56 / 15 + n * (-136 / 35 + n * (-1262 / 105 + n * (73814 / 2835))));
    this.cbg[2] = np * (-26 / 15 + n * (34 / 21 + n * (1.6 + n * (-12686 / 2835))));
    np = np * n;
    this.cgb[3] = np * (4279 / 630 + n * (-332 / 35 + n * (-399572 / 14175)));
    this.cbg[3] = np * (1237 / 630 + n * (-2.4 + n * (-24832 / 14175)));
    np = np * n;
    this.cgb[4] = np * (4174 / 315 + n * (-144838 / 6237));
    this.cbg[4] = np * (-734 / 315 + n * (109598 / 31185));
    np = np * n;
    this.cgb[5] = np * (601676 / 22275);
    this.cbg[5] = np * (444337 / 155925);
    np = Math.pow(n, 2);
    this.Qn = this.k0 / (1 + n) * (1 + np * (1 / 4 + np * (1 / 64 + np / 256)));
    this.utg[0] = n * (-0.5 + n * (2 / 3 + n * (-37 / 96 + n * (1 / 360 + n * (81 / 512 + n * (-96199 / 604800))))));
    this.gtu[0] = n * (0.5 + n * (-2 / 3 + n * (5 / 16 + n * (41 / 180 + n * (-127 / 288 + n * (7891 / 37800))))));
    this.utg[1] = np * (-1 / 48 + n * (-1 / 15 + n * (437 / 1440 + n * (-46 / 105 + n * (1118711 / 3870720)))));
    this.gtu[1] = np * (13 / 48 + n * (-0.6 + n * (557 / 1440 + n * (281 / 630 + n * (-1983433 / 1935360)))));
    np = np * n;
    this.utg[2] = np * (-17 / 480 + n * (37 / 840 + n * (209 / 4480 + n * (-5569 / 90720))));
    this.gtu[2] = np * (61 / 240 + n * (-103 / 140 + n * (15061 / 26880 + n * (167603 / 181440))));
    np = np * n;
    this.utg[3] = np * (-4397 / 161280 + n * (11 / 504 + n * (830251 / 7257600)));
    this.gtu[3] = np * (49561 / 161280 + n * (-179 / 168 + n * (6601661 / 7257600)));
    np = np * n;
    this.utg[4] = np * (-4583 / 161280 + n * (108847 / 3991680));
    this.gtu[4] = np * (34729 / 80640 + n * (-3418889 / 1995840));
    np = np * n;
    this.utg[5] = np * (-20648693 / 638668800);
    this.gtu[5] = np * 0.6650675310896665;
    var Z = (0, $Etdpz.default)(this.cbg, this.lat0);
    this.Zb = -this.Qn * (Z + (0, $eyMvE.default)(this.gtu, 2 * Z));
}
function forward(p) {
    var Ce = (0, $186WS.default)(p.x - this.long0);
    var Cn = p.y;
    Cn = (0, $Etdpz.default)(this.cbg, Cn);
    var sin_Cn = Math.sin(Cn);
    var cos_Cn = Math.cos(Cn);
    var sin_Ce = Math.sin(Ce);
    var cos_Ce = Math.cos(Ce);
    Cn = Math.atan2(sin_Cn, cos_Ce * cos_Cn);
    Ce = Math.atan2(sin_Ce * cos_Cn, (0, $5nakf.default)(sin_Cn, cos_Cn * cos_Ce));
    Ce = (0, $7vOwR.default)(Math.tan(Ce));
    var tmp = (0, $6pKZK.default)(this.gtu, 2 * Cn, 2 * Ce);
    Cn = Cn + tmp[0];
    Ce = Ce + tmp[1];
    var x;
    var y;
    if (Math.abs(Ce) <= 2.623395162778) {
        x = this.a * (this.Qn * Ce) + this.x0;
        y = this.a * (this.Qn * Cn + this.Zb) + this.y0;
    } else {
        x = Infinity;
        y = Infinity;
    }
    p.x = x;
    p.y = y;
    return p;
}
function inverse(p) {
    var Ce = (p.x - this.x0) * (1 / this.a);
    var Cn = (p.y - this.y0) * (1 / this.a);
    Cn = (Cn - this.Zb) / this.Qn;
    Ce = Ce / this.Qn;
    var lon;
    var lat;
    if (Math.abs(Ce) <= 2.623395162778) {
        var tmp = (0, $6pKZK.default)(this.utg, 2 * Cn, 2 * Ce);
        Cn = Cn + tmp[0];
        Ce = Ce + tmp[1];
        Ce = Math.atan((0, $QiqjO.default)(Ce));
        var sin_Cn = Math.sin(Cn);
        var cos_Cn = Math.cos(Cn);
        var sin_Ce = Math.sin(Ce);
        var cos_Ce = Math.cos(Ce);
        Cn = Math.atan2(sin_Cn * cos_Ce, (0, $5nakf.default)(sin_Ce, cos_Ce * cos_Cn));
        Ce = Math.atan2(sin_Ce, cos_Ce * cos_Cn);
        lon = (0, $186WS.default)(Ce + this.long0);
        lat = (0, $Etdpz.default)(this.cgb, Cn);
    } else {
        lon = Infinity;
        lat = Infinity;
    }
    p.x = lon;
    p.y = lat;
    return p;
}
var names = [
    "Extended_Transverse_Mercator",
    "Extended Transverse Mercator",
    "etmerc",
    "Transverse_Mercator",
    "Transverse Mercator",
    "Gauss Kruger",
    "Gauss_Kruger",
    "tmerc"
];
var $4166e5dcdbe95a4c$export$2e2bcd8739ae039 = {
    init: init,
    forward: forward,
    inverse: inverse,
    names: names
};

});
parcelRegister("jSMMP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e798e77a158c29cd$export$2e2bcd8739ae039; });
// Heavily based on this tmerc projection implementation
// https://github.com/mbloch/mapshaper-proj/blob/master/src/projections/tmerc.js

var $a2vUM = parcelRequire("a2vUM");

var $iX7sK = parcelRequire("iX7sK");

var $bL4ry = parcelRequire("bL4ry");

var $186WS = parcelRequire("186WS");

var $jVGH7 = parcelRequire("jVGH7");

var $45Ucl = parcelRequire("45Ucl");
function $e798e77a158c29cd$export$2cd8252107eb640b() {
    this.x0 = this.x0 !== undefined ? this.x0 : 0;
    this.y0 = this.y0 !== undefined ? this.y0 : 0;
    this.long0 = this.long0 !== undefined ? this.long0 : 0;
    this.lat0 = this.lat0 !== undefined ? this.lat0 : 0;
    if (this.es) {
        this.en = (0, $a2vUM.default)(this.es);
        this.ml0 = (0, $iX7sK.default)(this.lat0, Math.sin(this.lat0), Math.cos(this.lat0), this.en);
    }
}
function $e798e77a158c29cd$export$174bb771924e7eb1(p) {
    var lon = p.x;
    var lat = p.y;
    var delta_lon = (0, $186WS.default)(lon - this.long0);
    var con;
    var x, y;
    var sin_phi = Math.sin(lat);
    var cos_phi = Math.cos(lat);
    if (!this.es) {
        var b = cos_phi * Math.sin(delta_lon);
        if (Math.abs(Math.abs(b) - 1) < (0, $jVGH7.EPSLN)) return 93;
        else {
            x = 0.5 * this.a * this.k0 * Math.log((1 + b) / (1 - b)) + this.x0;
            y = cos_phi * Math.cos(delta_lon) / Math.sqrt(1 - Math.pow(b, 2));
            b = Math.abs(y);
            if (b >= 1) {
                if (b - 1 > (0, $jVGH7.EPSLN)) return 93;
                else y = 0;
            } else y = Math.acos(y);
            if (lat < 0) y = -y;
            y = this.a * this.k0 * (y - this.lat0) + this.y0;
        }
    } else {
        var al = cos_phi * delta_lon;
        var als = Math.pow(al, 2);
        var c = this.ep2 * Math.pow(cos_phi, 2);
        var cs = Math.pow(c, 2);
        var tq = Math.abs(cos_phi) > (0, $jVGH7.EPSLN) ? Math.tan(lat) : 0;
        var t = Math.pow(tq, 2);
        var ts = Math.pow(t, 2);
        con = 1 - this.es * Math.pow(sin_phi, 2);
        al = al / Math.sqrt(con);
        var ml = (0, $iX7sK.default)(lat, sin_phi, cos_phi, this.en);
        x = this.a * (this.k0 * al * (1 + als / 6 * (1 - t + c + als / 20 * (5 - 18 * t + ts + 14 * c - 58 * t * c + als / 42 * (61 + 179 * ts - ts * t - 479 * t))))) + this.x0;
        y = this.a * (this.k0 * (ml - this.ml0 + sin_phi * delta_lon * al / 2 * (1 + als / 12 * (5 - t + 9 * c + 4 * cs + als / 30 * (61 + ts - 58 * t + 270 * c - 330 * t * c + als / 56 * (1385 + 543 * ts - ts * t - 3111 * t)))))) + this.y0;
    }
    p.x = x;
    p.y = y;
    return p;
}
function $e798e77a158c29cd$export$70ae2c07e401031b(p) {
    var con, phi;
    var lat, lon;
    var x = (p.x - this.x0) * (1 / this.a);
    var y = (p.y - this.y0) * (1 / this.a);
    if (!this.es) {
        var f = Math.exp(x / this.k0);
        var g = 0.5 * (f - 1 / f);
        var temp = this.lat0 + y / this.k0;
        var h = Math.cos(temp);
        con = Math.sqrt((1 - Math.pow(h, 2)) / (1 + Math.pow(g, 2)));
        lat = Math.asin(con);
        if (y < 0) lat = -lat;
        if (g === 0 && h === 0) lon = 0;
        else lon = (0, $186WS.default)(Math.atan2(g, h) + this.long0);
    } else {
        con = this.ml0 + y / this.k0;
        phi = (0, $bL4ry.default)(con, this.es, this.en);
        if (Math.abs(phi) < (0, $jVGH7.HALF_PI)) {
            var sin_phi = Math.sin(phi);
            var cos_phi = Math.cos(phi);
            var tan_phi = Math.abs(cos_phi) > (0, $jVGH7.EPSLN) ? Math.tan(phi) : 0;
            var c = this.ep2 * Math.pow(cos_phi, 2);
            var cs = Math.pow(c, 2);
            var t = Math.pow(tan_phi, 2);
            var ts = Math.pow(t, 2);
            con = 1 - this.es * Math.pow(sin_phi, 2);
            var d = x * Math.sqrt(con) / this.k0;
            var ds = Math.pow(d, 2);
            con = con * tan_phi;
            lat = phi - con * ds / (1 - this.es) * 0.5 * (1 - ds / 12 * (5 + 3 * t - 9 * c * t + c - 4 * cs - ds / 30 * (61 + 90 * t - 252 * c * t + 45 * ts + 46 * c - ds / 56 * (1385 + 3633 * t + 4095 * ts + 1574 * ts * t))));
            lon = (0, $186WS.default)(this.long0 + d * (1 - ds / 6 * (1 + 2 * t + c - ds / 20 * (5 + 28 * t + 24 * ts + 8 * c * t + 6 * c - ds / 42 * (61 + 662 * t + 1320 * ts + 720 * ts * t)))) / cos_phi);
        } else {
            lat = (0, $jVGH7.HALF_PI) * (0, $45Ucl.default)(y);
            lon = 0;
        }
    }
    p.x = lon;
    p.y = lat;
    return p;
}
var $e798e77a158c29cd$export$e4b2ac9215619f8d = [
    "Fast_Transverse_Mercator",
    "Fast Transverse Mercator"
];
var $e798e77a158c29cd$export$2e2bcd8739ae039 = {
    init: $e798e77a158c29cd$export$2cd8252107eb640b,
    forward: $e798e77a158c29cd$export$174bb771924e7eb1,
    inverse: $e798e77a158c29cd$export$70ae2c07e401031b,
    names: $e798e77a158c29cd$export$e4b2ac9215619f8d
};

});
parcelRegister("a2vUM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $74f2d8e11b052508$export$2e2bcd8739ae039; });
var $74f2d8e11b052508$var$C00 = 1;
var $74f2d8e11b052508$var$C02 = 0.25;
var $74f2d8e11b052508$var$C04 = 0.046875;
var $74f2d8e11b052508$var$C06 = 0.01953125;
var $74f2d8e11b052508$var$C08 = 0.01068115234375;
var $74f2d8e11b052508$var$C22 = 0.75;
var $74f2d8e11b052508$var$C44 = 0.46875;
var $74f2d8e11b052508$var$C46 = 0.01302083333333333333;
var $74f2d8e11b052508$var$C48 = 0.00712076822916666666;
var $74f2d8e11b052508$var$C66 = 0.36458333333333333333;
var $74f2d8e11b052508$var$C68 = 0.00569661458333333333;
var $74f2d8e11b052508$var$C88 = 0.3076171875;
function $74f2d8e11b052508$export$2e2bcd8739ae039(es) {
    var en = [];
    en[0] = $74f2d8e11b052508$var$C00 - es * ($74f2d8e11b052508$var$C02 + es * ($74f2d8e11b052508$var$C04 + es * ($74f2d8e11b052508$var$C06 + es * $74f2d8e11b052508$var$C08)));
    en[1] = es * ($74f2d8e11b052508$var$C22 - es * ($74f2d8e11b052508$var$C04 + es * ($74f2d8e11b052508$var$C06 + es * $74f2d8e11b052508$var$C08)));
    var t = es * es;
    en[2] = t * ($74f2d8e11b052508$var$C44 - es * ($74f2d8e11b052508$var$C46 + es * $74f2d8e11b052508$var$C48));
    t *= es;
    en[3] = t * ($74f2d8e11b052508$var$C66 - es * $74f2d8e11b052508$var$C68);
    en[4] = t * es * $74f2d8e11b052508$var$C88;
    return en;
}

});

parcelRegister("iX7sK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $038f8a6dfcea9a6f$export$2e2bcd8739ae039; });
function $038f8a6dfcea9a6f$export$2e2bcd8739ae039(phi, sphi, cphi, en) {
    cphi *= sphi;
    sphi *= sphi;
    return en[0] * phi - cphi * (en[1] + sphi * (en[2] + sphi * (en[3] + sphi * en[4])));
}

});

parcelRegister("bL4ry", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $88f787ddee9d4cff$export$2e2bcd8739ae039; });

var $iX7sK = parcelRequire("iX7sK");

var $jVGH7 = parcelRequire("jVGH7");
var $88f787ddee9d4cff$var$MAX_ITER = 20;
function $88f787ddee9d4cff$export$2e2bcd8739ae039(arg, es, en) {
    var k = 1 / (1 - es);
    var phi = arg;
    for(var i = $88f787ddee9d4cff$var$MAX_ITER; i; --i){
        var s = Math.sin(phi);
        var t = 1 - es * s * s;
        // t = this.pj_mlfn(phi, s, Math.cos(phi), en) - arg;
        // phi -= t * (t * Math.sqrt(t)) * k;
        t = ((0, $iX7sK.default)(phi, s, Math.cos(phi), en) - arg) * (t * Math.sqrt(t)) * k;
        phi -= t;
        if (Math.abs(t) < (0, $jVGH7.EPSLN)) return phi;
    }
    // ..reportError("cass:pj_inv_mlfn: Convergence error");
    return phi;
}

});
parcelRegister("jVGH7", function(module, exports) {

$parcel$export(module.exports, "PJD_3PARAM", function () { return $e82475664a9bbd95$export$3a3ed3e590e8ec27; });
$parcel$export(module.exports, "PJD_7PARAM", function () { return $e82475664a9bbd95$export$8cab19b7f383a7a7; });
$parcel$export(module.exports, "PJD_GRIDSHIFT", function () { return $e82475664a9bbd95$export$83d26ae02793dd10; });
$parcel$export(module.exports, "PJD_WGS84", function () { return $e82475664a9bbd95$export$ab5bf8c731b6bbbb; });
$parcel$export(module.exports, "PJD_NODATUM", function () { return $e82475664a9bbd95$export$8df4c7729d8ed58d; });
$parcel$export(module.exports, "SRS_WGS84_SEMIMAJOR", function () { return $e82475664a9bbd95$export$d612c03b7390d945; });
$parcel$export(module.exports, "SRS_WGS84_SEMIMINOR", function () { return $e82475664a9bbd95$export$59af086d7527ec46; });
$parcel$export(module.exports, "SRS_WGS84_ESQUARED", function () { return $e82475664a9bbd95$export$9b798f9d78b99fc0; });
$parcel$export(module.exports, "SEC_TO_RAD", function () { return $e82475664a9bbd95$export$e0b9011552f3b2f7; });
$parcel$export(module.exports, "HALF_PI", function () { return $e82475664a9bbd95$export$f504979d7e0a75c7; });
$parcel$export(module.exports, "SIXTH", function () { return $e82475664a9bbd95$export$d7977f56a0faa834; });
$parcel$export(module.exports, "RA4", function () { return $e82475664a9bbd95$export$9e703428410a9c7b; });
$parcel$export(module.exports, "RA6", function () { return $e82475664a9bbd95$export$bb54dde5565ed6e3; });
$parcel$export(module.exports, "EPSLN", function () { return $e82475664a9bbd95$export$2aa89dbfb8b504bb; });
$parcel$export(module.exports, "D2R", function () { return $e82475664a9bbd95$export$ed6012a68c0f4a70; });
$parcel$export(module.exports, "R2D", function () { return $e82475664a9bbd95$export$456934b8be7498c3; });
$parcel$export(module.exports, "FORTPI", function () { return $e82475664a9bbd95$export$10cb69dd603c11b0; });
$parcel$export(module.exports, "TWO_PI", function () { return $e82475664a9bbd95$export$6eec49b1a6289c4e; });
$parcel$export(module.exports, "SPI", function () { return $e82475664a9bbd95$export$703a92fc6506ffb9; });
var $e82475664a9bbd95$export$3a3ed3e590e8ec27 = 1;
var $e82475664a9bbd95$export$8cab19b7f383a7a7 = 2;
var $e82475664a9bbd95$export$83d26ae02793dd10 = 3;
var $e82475664a9bbd95$export$ab5bf8c731b6bbbb = 4; // WGS84 or equivalent
var $e82475664a9bbd95$export$8df4c7729d8ed58d = 5; // WGS84 or equivalent
var $e82475664a9bbd95$export$d612c03b7390d945 = 6378137.0; // only used in grid shift transforms
var $e82475664a9bbd95$export$59af086d7527ec46 = 6356752.314; // only used in grid shift transforms
var $e82475664a9bbd95$export$9b798f9d78b99fc0 = 0.0066943799901413165; // only used in grid shift transforms
var $e82475664a9bbd95$export$e0b9011552f3b2f7 = 4.84813681109535993589914102357e-6;
var $e82475664a9bbd95$export$f504979d7e0a75c7 = Math.PI / 2;
var $e82475664a9bbd95$export$d7977f56a0faa834 = 0.1666666666666666667;
var $e82475664a9bbd95$export$9e703428410a9c7b = 0.04722222222222222222;
var $e82475664a9bbd95$export$bb54dde5565ed6e3 = 0.02215608465608465608;
var $e82475664a9bbd95$export$2aa89dbfb8b504bb = 1.0e-10;
var $e82475664a9bbd95$export$ed6012a68c0f4a70 = 0.01745329251994329577;
var $e82475664a9bbd95$export$456934b8be7498c3 = 57.29577951308232088;
var $e82475664a9bbd95$export$10cb69dd603c11b0 = Math.PI / 4;
var $e82475664a9bbd95$export$6eec49b1a6289c4e = Math.PI * 2;
var $e82475664a9bbd95$export$703a92fc6506ffb9 = 3.14159265359;

});


parcelRegister("186WS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0d2beda2f232ef9e$export$2e2bcd8739ae039; });

var $jVGH7 = parcelRequire("jVGH7");

var $45Ucl = parcelRequire("45Ucl");
function $0d2beda2f232ef9e$export$2e2bcd8739ae039(x) {
    return Math.abs(x) <= (0, $jVGH7.SPI) ? x : x - (0, $45Ucl.default)(x) * (0, $jVGH7.TWO_PI);
}

});
parcelRegister("45Ucl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2fb338d259244b96$export$2e2bcd8739ae039; });
function $2fb338d259244b96$export$2e2bcd8739ae039(x) {
    return x < 0 ? -1 : 1;
}

});



parcelRegister("QiqjO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $09d325f732074804$export$2e2bcd8739ae039; });
function $09d325f732074804$export$2e2bcd8739ae039(x) {
    var r = Math.exp(x);
    r = (r - 1 / r) / 2;
    return r;
}

});

parcelRegister("5nakf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3e971c29c546435c$export$2e2bcd8739ae039; });
function $3e971c29c546435c$export$2e2bcd8739ae039(x, y) {
    x = Math.abs(x);
    y = Math.abs(y);
    var a = Math.max(x, y);
    var b = Math.min(x, y) / (a ? a : 1);
    return a * Math.sqrt(1 + Math.pow(b, 2));
}

});

parcelRegister("7vOwR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $57829fad2bf32e56$export$2e2bcd8739ae039; });

var $5nakf = parcelRequire("5nakf");

var $htgWA = parcelRequire("htgWA");
function $57829fad2bf32e56$export$2e2bcd8739ae039(x) {
    var y = Math.abs(x);
    y = (0, $htgWA.default)(y * (1 + y / ((0, $5nakf.default)(1, y) + 1)));
    return x < 0 ? -y : y;
}

});
parcelRegister("htgWA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cb8249cfd1efb5c7$export$2e2bcd8739ae039; });
function $cb8249cfd1efb5c7$export$2e2bcd8739ae039(x) {
    var y = 1 + x;
    var z = y - 1;
    return z === 0 ? x : x * Math.log(y) / z;
}

});


parcelRegister("Etdpz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $079a66182a2ad21f$export$2e2bcd8739ae039; });
function $079a66182a2ad21f$export$2e2bcd8739ae039(pp, B) {
    var cos_2B = 2 * Math.cos(2 * B);
    var i = pp.length - 1;
    var h1 = pp[i];
    var h2 = 0;
    var h;
    while(--i >= 0){
        h = -h2 + cos_2B * h1 + pp[i];
        h2 = h1;
        h1 = h;
    }
    return B + h * Math.sin(2 * B);
}

});

parcelRegister("eyMvE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a999dea47ef5f41c$export$2e2bcd8739ae039; });
function $a999dea47ef5f41c$export$2e2bcd8739ae039(pp, arg_r) {
    var r = 2 * Math.cos(arg_r);
    var i = pp.length - 1;
    var hr1 = pp[i];
    var hr2 = 0;
    var hr;
    while(--i >= 0){
        hr = -hr2 + r * hr1 + pp[i];
        hr2 = hr1;
        hr1 = hr;
    }
    return Math.sin(arg_r) * hr;
}

});

parcelRegister("6pKZK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4ab98814e36c07d9$export$2e2bcd8739ae039; });

var $QiqjO = parcelRequire("QiqjO");

var $5b4OP = parcelRequire("5b4OP");
function $4ab98814e36c07d9$export$2e2bcd8739ae039(pp, arg_r, arg_i) {
    var sin_arg_r = Math.sin(arg_r);
    var cos_arg_r = Math.cos(arg_r);
    var sinh_arg_i = (0, $QiqjO.default)(arg_i);
    var cosh_arg_i = (0, $5b4OP.default)(arg_i);
    var r = 2 * cos_arg_r * cosh_arg_i;
    var i = -2 * sin_arg_r * sinh_arg_i;
    var j = pp.length - 1;
    var hr = pp[j];
    var hi1 = 0;
    var hr1 = 0;
    var hi = 0;
    var hr2;
    var hi2;
    while(--j >= 0){
        hr2 = hr1;
        hi2 = hi1;
        hr1 = hr;
        hi1 = hi;
        hr = -hr2 + r * hr1 - i * hi1 + pp[j];
        hi = -hi2 + i * hr1 + r * hi1;
    }
    r = sin_arg_r * cosh_arg_i;
    i = cos_arg_r * sinh_arg_i;
    return [
        r * hr - i * hi,
        r * hi + i * hr
    ];
}

});
parcelRegister("5b4OP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3c51b7bfcce4f0df$export$2e2bcd8739ae039; });
function $3c51b7bfcce4f0df$export$2e2bcd8739ae039(x) {
    var r = Math.exp(x);
    r = (r + 1 / r) / 2;
    return r;
}

});



parcelRegister("bLuvW", function(module, exports) {

$parcel$export(module.exports, "S_POLE", function () { return S_POLE; });
$parcel$export(module.exports, "N_POLE", function () { return N_POLE; });
$parcel$export(module.exports, "EQUIT", function () { return EQUIT; });
$parcel$export(module.exports, "OBLIQ", function () { return OBLIQ; });
$parcel$export(module.exports, "init", function () { return init; });
$parcel$export(module.exports, "forward", function () { return forward; });
$parcel$export(module.exports, "inverse", function () { return inverse; });
$parcel$export(module.exports, "names", function () { return names; });
$parcel$export(module.exports, "default", function () { return $890bc1005c1a3969$export$2e2bcd8739ae039; });

var $jVGH7 = parcelRequire("jVGH7");

var $axRvQ = parcelRequire("axRvQ");

var $186WS = parcelRequire("186WS");
var S_POLE = 1;
var N_POLE = 2;
var EQUIT = 3;
var OBLIQ = 4;
function init() {
    var t = Math.abs(this.lat0);
    if (Math.abs(t - (0, $jVGH7.HALF_PI)) < (0, $jVGH7.EPSLN)) this.mode = this.lat0 < 0 ? S_POLE : N_POLE;
    else if (Math.abs(t) < (0, $jVGH7.EPSLN)) this.mode = EQUIT;
    else this.mode = OBLIQ;
    if (this.es > 0) {
        var sinphi;
        this.qp = (0, $axRvQ.default)(this.e, 1);
        this.mmf = 0.5 / (1 - this.es);
        this.apa = authset(this.es);
        switch(this.mode){
            case N_POLE:
                this.dd = 1;
                break;
            case S_POLE:
                this.dd = 1;
                break;
            case EQUIT:
                this.rq = Math.sqrt(0.5 * this.qp);
                this.dd = 1 / this.rq;
                this.xmf = 1;
                this.ymf = 0.5 * this.qp;
                break;
            case OBLIQ:
                this.rq = Math.sqrt(0.5 * this.qp);
                sinphi = Math.sin(this.lat0);
                this.sinb1 = (0, $axRvQ.default)(this.e, sinphi) / this.qp;
                this.cosb1 = Math.sqrt(1 - this.sinb1 * this.sinb1);
                this.dd = Math.cos(this.lat0) / (Math.sqrt(1 - this.es * sinphi * sinphi) * this.rq * this.cosb1);
                this.ymf = (this.xmf = this.rq) / this.dd;
                this.xmf *= this.dd;
                break;
        }
    } else if (this.mode === OBLIQ) {
        this.sinph0 = Math.sin(this.lat0);
        this.cosph0 = Math.cos(this.lat0);
    }
}
function forward(p) {
    /* Forward equations
      ----------------- */ var x, y, coslam, sinlam, sinphi, q, sinb, cosb, b, cosphi;
    var lam = p.x;
    var phi = p.y;
    lam = (0, $186WS.default)(lam - this.long0);
    if (this.sphere) {
        sinphi = Math.sin(phi);
        cosphi = Math.cos(phi);
        coslam = Math.cos(lam);
        if (this.mode === this.OBLIQ || this.mode === this.EQUIT) {
            y = this.mode === this.EQUIT ? 1 + cosphi * coslam : 1 + this.sinph0 * sinphi + this.cosph0 * cosphi * coslam;
            if (y <= (0, $jVGH7.EPSLN)) return null;
            y = Math.sqrt(2 / y);
            x = y * cosphi * Math.sin(lam);
            y *= this.mode === this.EQUIT ? sinphi : this.cosph0 * sinphi - this.sinph0 * cosphi * coslam;
        } else if (this.mode === this.N_POLE || this.mode === this.S_POLE) {
            if (this.mode === this.N_POLE) coslam = -coslam;
            if (Math.abs(phi + this.lat0) < (0, $jVGH7.EPSLN)) return null;
            y = (0, $jVGH7.FORTPI) - phi * 0.5;
            y = 2 * (this.mode === this.S_POLE ? Math.cos(y) : Math.sin(y));
            x = y * Math.sin(lam);
            y *= coslam;
        }
    } else {
        sinb = 0;
        cosb = 0;
        b = 0;
        coslam = Math.cos(lam);
        sinlam = Math.sin(lam);
        sinphi = Math.sin(phi);
        q = (0, $axRvQ.default)(this.e, sinphi);
        if (this.mode === this.OBLIQ || this.mode === this.EQUIT) {
            sinb = q / this.qp;
            cosb = Math.sqrt(1 - sinb * sinb);
        }
        switch(this.mode){
            case this.OBLIQ:
                b = 1 + this.sinb1 * sinb + this.cosb1 * cosb * coslam;
                break;
            case this.EQUIT:
                b = 1 + cosb * coslam;
                break;
            case this.N_POLE:
                b = (0, $jVGH7.HALF_PI) + phi;
                q = this.qp - q;
                break;
            case this.S_POLE:
                b = phi - (0, $jVGH7.HALF_PI);
                q = this.qp + q;
                break;
        }
        if (Math.abs(b) < (0, $jVGH7.EPSLN)) return null;
        switch(this.mode){
            case this.OBLIQ:
            case this.EQUIT:
                b = Math.sqrt(2 / b);
                if (this.mode === this.OBLIQ) y = this.ymf * b * (this.cosb1 * sinb - this.sinb1 * cosb * coslam);
                else y = (b = Math.sqrt(2 / (1 + cosb * coslam))) * sinb * this.ymf;
                x = this.xmf * b * cosb * sinlam;
                break;
            case this.N_POLE:
            case this.S_POLE:
                if (q >= 0) {
                    x = (b = Math.sqrt(q)) * sinlam;
                    y = coslam * (this.mode === this.S_POLE ? b : -b);
                } else x = y = 0;
                break;
        }
    }
    p.x = this.a * x + this.x0;
    p.y = this.a * y + this.y0;
    return p;
}
function inverse(p) {
    p.x -= this.x0;
    p.y -= this.y0;
    var x = p.x / this.a;
    var y = p.y / this.a;
    var lam, phi, cCe, sCe, q, rho, ab;
    if (this.sphere) {
        var cosz = 0, rh, sinz = 0;
        rh = Math.sqrt(x * x + y * y);
        phi = rh * 0.5;
        if (phi > 1) return null;
        phi = 2 * Math.asin(phi);
        if (this.mode === this.OBLIQ || this.mode === this.EQUIT) {
            sinz = Math.sin(phi);
            cosz = Math.cos(phi);
        }
        switch(this.mode){
            case this.EQUIT:
                phi = Math.abs(rh) <= (0, $jVGH7.EPSLN) ? 0 : Math.asin(y * sinz / rh);
                x *= sinz;
                y = cosz * rh;
                break;
            case this.OBLIQ:
                phi = Math.abs(rh) <= (0, $jVGH7.EPSLN) ? this.lat0 : Math.asin(cosz * this.sinph0 + y * sinz * this.cosph0 / rh);
                x *= sinz * this.cosph0;
                y = (cosz - Math.sin(phi) * this.sinph0) * rh;
                break;
            case this.N_POLE:
                y = -y;
                phi = (0, $jVGH7.HALF_PI) - phi;
                break;
            case this.S_POLE:
                phi -= (0, $jVGH7.HALF_PI);
                break;
        }
        lam = y === 0 && (this.mode === this.EQUIT || this.mode === this.OBLIQ) ? 0 : Math.atan2(x, y);
    } else {
        ab = 0;
        if (this.mode === this.OBLIQ || this.mode === this.EQUIT) {
            x /= this.dd;
            y *= this.dd;
            rho = Math.sqrt(x * x + y * y);
            if (rho < (0, $jVGH7.EPSLN)) {
                p.x = this.long0;
                p.y = this.lat0;
                return p;
            }
            sCe = 2 * Math.asin(0.5 * rho / this.rq);
            cCe = Math.cos(sCe);
            x *= sCe = Math.sin(sCe);
            if (this.mode === this.OBLIQ) {
                ab = cCe * this.sinb1 + y * sCe * this.cosb1 / rho;
                q = this.qp * ab;
                y = rho * this.cosb1 * cCe - y * this.sinb1 * sCe;
            } else {
                ab = y * sCe / rho;
                q = this.qp * ab;
                y = rho * cCe;
            }
        } else if (this.mode === this.N_POLE || this.mode === this.S_POLE) {
            if (this.mode === this.N_POLE) y = -y;
            q = x * x + y * y;
            if (!q) {
                p.x = this.long0;
                p.y = this.lat0;
                return p;
            }
            ab = 1 - q / this.qp;
            if (this.mode === this.S_POLE) ab = -ab;
        }
        lam = Math.atan2(x, y);
        phi = authlat(Math.asin(ab), this.apa);
    }
    p.x = (0, $186WS.default)(this.long0 + lam);
    p.y = phi;
    return p;
}
/* determine latitude from authalic latitude */ var P00 = 0.33333333333333333333;
var P01 = 0.17222222222222222222;
var P02 = 0.10257936507936507936;
var P10 = 0.06388888888888888888;
var P11 = 0.06640211640211640211;
var P20 = 0.01641501294219154443;
function authset(es) {
    var t;
    var APA = [];
    APA[0] = es * P00;
    t = es * es;
    APA[0] += t * P01;
    APA[1] = t * P10;
    t *= es;
    APA[0] += t * P02;
    APA[1] += t * P11;
    APA[2] = t * P20;
    return APA;
}
function authlat(beta, APA) {
    var t = beta + beta;
    return beta + APA[0] * Math.sin(t) + APA[1] * Math.sin(t + t) + APA[2] * Math.sin(t + t + t);
}
var names = [
    "Lambert Azimuthal Equal Area",
    "Lambert_Azimuthal_Equal_Area",
    "laea"
];
var $890bc1005c1a3969$export$2e2bcd8739ae039 = {
    init: init,
    forward: forward,
    inverse: inverse,
    names: names,
    S_POLE: S_POLE,
    N_POLE: N_POLE,
    EQUIT: EQUIT,
    OBLIQ: OBLIQ
};

});
parcelRegister("axRvQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7ad67eed4bb6f479$export$2e2bcd8739ae039; });
function $7ad67eed4bb6f479$export$2e2bcd8739ae039(eccent, sinphi) {
    var con;
    if (eccent > 1.0e-7) {
        con = eccent * sinphi;
        return (1 - eccent * eccent) * (sinphi / (1 - con * con) - 0.5 / eccent * Math.log((1 - con) / (1 + con)));
    } else return 2 * sinphi;
}

});


parcelRegister("fNzYi", function(module, exports) {

$parcel$export(module.exports, "init", function () { return init; });
$parcel$export(module.exports, "forward", function () { return forward; });
$parcel$export(module.exports, "inverse", function () { return inverse; });
$parcel$export(module.exports, "phi1z", function () { return phi1z; });
$parcel$export(module.exports, "names", function () { return names; });
$parcel$export(module.exports, "default", function () { return $b80755cf768c8dfe$export$2e2bcd8739ae039; });

var $ao8xz = parcelRequire("ao8xz");

var $axRvQ = parcelRequire("axRvQ");

var $186WS = parcelRequire("186WS");

var $9sUpR = parcelRequire("9sUpR");

var $jVGH7 = parcelRequire("jVGH7");
function init() {
    if (Math.abs(this.lat1 + this.lat2) < (0, $jVGH7.EPSLN)) return;
    this.temp = this.b / this.a;
    this.es = 1 - Math.pow(this.temp, 2);
    this.e3 = Math.sqrt(this.es);
    this.sin_po = Math.sin(this.lat1);
    this.cos_po = Math.cos(this.lat1);
    this.t1 = this.sin_po;
    this.con = this.sin_po;
    this.ms1 = (0, $ao8xz.default)(this.e3, this.sin_po, this.cos_po);
    this.qs1 = (0, $axRvQ.default)(this.e3, this.sin_po);
    this.sin_po = Math.sin(this.lat2);
    this.cos_po = Math.cos(this.lat2);
    this.t2 = this.sin_po;
    this.ms2 = (0, $ao8xz.default)(this.e3, this.sin_po, this.cos_po);
    this.qs2 = (0, $axRvQ.default)(this.e3, this.sin_po);
    this.sin_po = Math.sin(this.lat0);
    this.cos_po = Math.cos(this.lat0);
    this.t3 = this.sin_po;
    this.qs0 = (0, $axRvQ.default)(this.e3, this.sin_po);
    if (Math.abs(this.lat1 - this.lat2) > (0, $jVGH7.EPSLN)) this.ns0 = (this.ms1 * this.ms1 - this.ms2 * this.ms2) / (this.qs2 - this.qs1);
    else this.ns0 = this.con;
    this.c = this.ms1 * this.ms1 + this.ns0 * this.qs1;
    this.rh = this.a * Math.sqrt(this.c - this.ns0 * this.qs0) / this.ns0;
}
function forward(p) {
    var lon = p.x;
    var lat = p.y;
    this.sin_phi = Math.sin(lat);
    this.cos_phi = Math.cos(lat);
    var qs = (0, $axRvQ.default)(this.e3, this.sin_phi);
    var rh1 = this.a * Math.sqrt(this.c - this.ns0 * qs) / this.ns0;
    var theta = this.ns0 * (0, $186WS.default)(lon - this.long0);
    var x = rh1 * Math.sin(theta) + this.x0;
    var y = this.rh - rh1 * Math.cos(theta) + this.y0;
    p.x = x;
    p.y = y;
    return p;
}
function inverse(p) {
    var rh1, qs, con, theta, lon, lat;
    p.x -= this.x0;
    p.y = this.rh - p.y + this.y0;
    if (this.ns0 >= 0) {
        rh1 = Math.sqrt(p.x * p.x + p.y * p.y);
        con = 1;
    } else {
        rh1 = -Math.sqrt(p.x * p.x + p.y * p.y);
        con = -1;
    }
    theta = 0;
    if (rh1 !== 0) theta = Math.atan2(con * p.x, con * p.y);
    con = rh1 * this.ns0 / this.a;
    if (this.sphere) lat = Math.asin((this.c - con * con) / (2 * this.ns0));
    else {
        qs = (this.c - con * con) / this.ns0;
        lat = this.phi1z(this.e3, qs);
    }
    lon = (0, $186WS.default)(theta / this.ns0 + this.long0);
    p.x = lon;
    p.y = lat;
    return p;
}
function phi1z(eccent, qs) {
    var sinphi, cosphi, con, com, dphi;
    var phi = (0, $9sUpR.default)(0.5 * qs);
    if (eccent < (0, $jVGH7.EPSLN)) return phi;
    var eccnts = eccent * eccent;
    for(var i = 1; i <= 25; i++){
        sinphi = Math.sin(phi);
        cosphi = Math.cos(phi);
        con = eccent * sinphi;
        com = 1 - con * con;
        dphi = 0.5 * com * com / cosphi * (qs / (1 - eccnts) - sinphi / com + 0.5 / eccent * Math.log((1 - con) / (1 + con)));
        phi = phi + dphi;
        if (Math.abs(dphi) <= 1e-7) return phi;
    }
    return null;
}
var names = [
    "Albers_Conic_Equal_Area",
    "Albers_Equal_Area",
    "Albers",
    "aea"
];
var $b80755cf768c8dfe$export$2e2bcd8739ae039 = {
    init: init,
    forward: forward,
    inverse: inverse,
    names: names,
    phi1z: phi1z
};

});
parcelRegister("ao8xz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7902c53d02c94550$export$2e2bcd8739ae039; });
function $7902c53d02c94550$export$2e2bcd8739ae039(eccent, sinphi, cosphi) {
    var con = eccent * sinphi;
    return cosphi / Math.sqrt(1 - con * con);
}

});

parcelRegister("9sUpR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6e427da94c9fbbf8$export$2e2bcd8739ae039; });
function $6e427da94c9fbbf8$export$2e2bcd8739ae039(x) {
    if (Math.abs(x) > 1) x = x > 1 ? 1 : -1;
    return Math.asin(x);
}

});


parcelRegister("f96MB", function(module, exports) {

$parcel$export(module.exports, "iterations", function () { return iterations; });
$parcel$export(module.exports, "init", function () { return init; });
$parcel$export(module.exports, "forward", function () { return forward; });
$parcel$export(module.exports, "inverse", function () { return inverse; });
$parcel$export(module.exports, "names", function () { return names; });
$parcel$export(module.exports, "default", function () { return $b06cf539f7e24d48$export$2e2bcd8739ae039; });

var $jVGH7 = parcelRequire("jVGH7");
var iterations = 1;
function init() {
    this.A = [];
    this.A[1] = 0.6399175073;
    this.A[2] = -0.1358797613;
    this.A[3] = 0.063294409;
    this.A[4] = -0.02526853;
    this.A[5] = 0.0117879;
    this.A[6] = -0.0055161;
    this.A[7] = 0.0026906;
    this.A[8] = -0.001333;
    this.A[9] = 0.00067;
    this.A[10] = -0.00034;
    this.B_re = [];
    this.B_im = [];
    this.B_re[1] = 0.7557853228;
    this.B_im[1] = 0;
    this.B_re[2] = 0.249204646;
    this.B_im[2] = 0.003371507;
    this.B_re[3] = -0.001541739;
    this.B_im[3] = 0.041058560;
    this.B_re[4] = -0.10162907;
    this.B_im[4] = 0.01727609;
    this.B_re[5] = -0.26623489;
    this.B_im[5] = -0.36249218;
    this.B_re[6] = -0.6870983;
    this.B_im[6] = -1.1651967;
    this.C_re = [];
    this.C_im = [];
    this.C_re[1] = 1.3231270439;
    this.C_im[1] = 0;
    this.C_re[2] = -0.577245789;
    this.C_im[2] = -0.007809598;
    this.C_re[3] = 0.508307513;
    this.C_im[3] = -0.112208952;
    this.C_re[4] = -0.15094762;
    this.C_im[4] = 0.18200602;
    this.C_re[5] = 1.01418179;
    this.C_im[5] = 1.64497696;
    this.C_re[6] = 1.9660549;
    this.C_im[6] = 2.5127645;
    this.D = [];
    this.D[1] = 1.5627014243;
    this.D[2] = 0.5185406398;
    this.D[3] = -0.03333098;
    this.D[4] = -0.1052906;
    this.D[5] = -0.0368594;
    this.D[6] = 0.007317;
    this.D[7] = 0.01220;
    this.D[8] = 0.00394;
    this.D[9] = -0.0013;
}
function forward(p) {
    var n;
    var lon = p.x;
    var lat = p.y;
    var delta_lat = lat - this.lat0;
    var delta_lon = lon - this.long0;
    // 1. Calculate d_phi and d_psi    ...                          // and d_lambda
    // For this algorithm, delta_latitude is in seconds of arc x 10-5, so we need to scale to those units. Longitude is radians.
    var d_phi = delta_lat / (0, $jVGH7.SEC_TO_RAD) * 1E-5;
    var d_lambda = delta_lon;
    var d_phi_n = 1; // d_phi^0
    var d_psi = 0;
    for(n = 1; n <= 10; n++){
        d_phi_n = d_phi_n * d_phi;
        d_psi = d_psi + this.A[n] * d_phi_n;
    }
    // 2. Calculate theta
    var th_re = d_psi;
    var th_im = d_lambda;
    // 3. Calculate z
    var th_n_re = 1;
    var th_n_im = 0; // theta^0
    var th_n_re1;
    var th_n_im1;
    var z_re = 0;
    var z_im = 0;
    for(n = 1; n <= 6; n++){
        th_n_re1 = th_n_re * th_re - th_n_im * th_im;
        th_n_im1 = th_n_im * th_re + th_n_re * th_im;
        th_n_re = th_n_re1;
        th_n_im = th_n_im1;
        z_re = z_re + this.B_re[n] * th_n_re - this.B_im[n] * th_n_im;
        z_im = z_im + this.B_im[n] * th_n_re + this.B_re[n] * th_n_im;
    }
    // 4. Calculate easting and northing
    p.x = z_im * this.a + this.x0;
    p.y = z_re * this.a + this.y0;
    return p;
}
function inverse(p) {
    var n;
    var x = p.x;
    var y = p.y;
    var delta_x = x - this.x0;
    var delta_y = y - this.y0;
    // 1. Calculate z
    var z_re = delta_y / this.a;
    var z_im = delta_x / this.a;
    // 2a. Calculate theta - first approximation gives km accuracy
    var z_n_re = 1;
    var z_n_im = 0; // z^0
    var z_n_re1;
    var z_n_im1;
    var th_re = 0;
    var th_im = 0;
    for(n = 1; n <= 6; n++){
        z_n_re1 = z_n_re * z_re - z_n_im * z_im;
        z_n_im1 = z_n_im * z_re + z_n_re * z_im;
        z_n_re = z_n_re1;
        z_n_im = z_n_im1;
        th_re = th_re + this.C_re[n] * z_n_re - this.C_im[n] * z_n_im;
        th_im = th_im + this.C_im[n] * z_n_re + this.C_re[n] * z_n_im;
    }
    // 2b. Iterate to refine the accuracy of the calculation
    //        0 iterations gives km accuracy
    //        1 iteration gives m accuracy -- good enough for most mapping applications
    //        2 iterations bives mm accuracy
    for(var i = 0; i < this.iterations; i++){
        var th_n_re = th_re;
        var th_n_im = th_im;
        var th_n_re1;
        var th_n_im1;
        var num_re = z_re;
        var num_im = z_im;
        for(n = 2; n <= 6; n++){
            th_n_re1 = th_n_re * th_re - th_n_im * th_im;
            th_n_im1 = th_n_im * th_re + th_n_re * th_im;
            th_n_re = th_n_re1;
            th_n_im = th_n_im1;
            num_re = num_re + (n - 1) * (this.B_re[n] * th_n_re - this.B_im[n] * th_n_im);
            num_im = num_im + (n - 1) * (this.B_im[n] * th_n_re + this.B_re[n] * th_n_im);
        }
        th_n_re = 1;
        th_n_im = 0;
        var den_re = this.B_re[1];
        var den_im = this.B_im[1];
        for(n = 2; n <= 6; n++){
            th_n_re1 = th_n_re * th_re - th_n_im * th_im;
            th_n_im1 = th_n_im * th_re + th_n_re * th_im;
            th_n_re = th_n_re1;
            th_n_im = th_n_im1;
            den_re = den_re + n * (this.B_re[n] * th_n_re - this.B_im[n] * th_n_im);
            den_im = den_im + n * (this.B_im[n] * th_n_re + this.B_re[n] * th_n_im);
        }
        // Complex division
        var den2 = den_re * den_re + den_im * den_im;
        th_re = (num_re * den_re + num_im * den_im) / den2;
        th_im = (num_im * den_re - num_re * den_im) / den2;
    }
    // 3. Calculate d_phi              ...                                    // and d_lambda
    var d_psi = th_re;
    var d_lambda = th_im;
    var d_psi_n = 1; // d_psi^0
    var d_phi = 0;
    for(n = 1; n <= 9; n++){
        d_psi_n = d_psi_n * d_psi;
        d_phi = d_phi + this.D[n] * d_psi_n;
    }
    // 4. Calculate latitude and longitude
    // d_phi is calcuated in second of arc * 10^-5, so we need to scale back to radians. d_lambda is in radians.
    var lat = this.lat0 + d_phi * (0, $jVGH7.SEC_TO_RAD) * 1E5;
    var lon = this.long0 + d_lambda;
    p.x = lon;
    p.y = lat;
    return p;
}
var names = [
    "New_Zealand_Map_Grid",
    "nzmg"
];
var $b06cf539f7e24d48$export$2e2bcd8739ae039 = {
    init: init,
    forward: forward,
    inverse: inverse,
    names: names
};

});

var $f130d2306183d8d9$export$8e3ada03ba72bedf = 60;
var $f130d2306183d8d9$export$a7c8f89377823cb8 = $f130d2306183d8d9$export$8e3ada03ba72bedf * 60;
var $f130d2306183d8d9$export$acc6f43ab2895cb5 = $f130d2306183d8d9$export$a7c8f89377823cb8 * 24;
var $f130d2306183d8d9$export$d99925edf30da4be = $f130d2306183d8d9$export$acc6f43ab2895cb5 * 7;
var $f130d2306183d8d9$export$c0ed55f5b8675ea3 = 1e3;
var $f130d2306183d8d9$export$37971e215480ff4b = $f130d2306183d8d9$export$8e3ada03ba72bedf * $f130d2306183d8d9$export$c0ed55f5b8675ea3;
var $f130d2306183d8d9$export$c42e2f66c1854fa2 = $f130d2306183d8d9$export$a7c8f89377823cb8 * $f130d2306183d8d9$export$c0ed55f5b8675ea3;
var $f130d2306183d8d9$export$a3d0b9741172e0d2 = $f130d2306183d8d9$export$acc6f43ab2895cb5 * $f130d2306183d8d9$export$c0ed55f5b8675ea3;
var $f130d2306183d8d9$export$3dc01d4e106e904c = $f130d2306183d8d9$export$d99925edf30da4be * $f130d2306183d8d9$export$c0ed55f5b8675ea3; // English locales
var $f130d2306183d8d9$export$71ad59f2e432cfe8 = "millisecond";
var $f130d2306183d8d9$export$25ce5a424b770e84 = "second";
var $f130d2306183d8d9$export$85fbf3b9d951b785 = "minute";
var $f130d2306183d8d9$export$7f8ddf7c7c20b3cd = "hour";
var $f130d2306183d8d9$export$96f57966bedc81b4 = "day";
var $f130d2306183d8d9$export$71cec2538cb2c617 = "week";
var $f130d2306183d8d9$export$3a1a48c8f6ef640e = "month";
var $f130d2306183d8d9$export$3722cfe417b6ed86 = "quarter";
var $f130d2306183d8d9$export$8743009a87fcb00f = "year";
var $f130d2306183d8d9$export$501a7fac1df67a49 = "date";
var $f130d2306183d8d9$export$43dfb2cd49ed2315 = "YYYY-MM-DDTHH:mm:ssZ";
var $f130d2306183d8d9$export$a3f90fd62b441bc0 = "Invalid Date"; // regex
var $f130d2306183d8d9$export$5017033e323668ef = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/;
var $f130d2306183d8d9$export$b72c006c7b334a95 = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g;


// English [en]
// We don't need weekdaysShort, weekdaysMin, monthsShort in en.js locale
var $5540b9cfe62f8a28$export$2e2bcd8739ae039 = {
    name: "en",
    weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
    months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
    ordinal: function ordinal(n) {
        var s = [
            "th",
            "st",
            "nd",
            "rd"
        ];
        var v = n % 100;
        return "[" + n + (s[(v - 20) % 10] || s[v] || s[0]) + "]";
    }
};



var $fca8c39a40c45d55$var$padStart = function padStart(string, length, pad) {
    var s = String(string);
    if (!s || s.length >= length) return string;
    return "" + Array(length + 1 - s.length).join(pad) + string;
};
var $fca8c39a40c45d55$var$padZoneStr = function padZoneStr(instance) {
    var negMinutes = -instance.utcOffset();
    var minutes = Math.abs(negMinutes);
    var hourOffset = Math.floor(minutes / 60);
    var minuteOffset = minutes % 60;
    return "" + (negMinutes <= 0 ? "+" : "-") + $fca8c39a40c45d55$var$padStart(hourOffset, 2, "0") + ":" + $fca8c39a40c45d55$var$padStart(minuteOffset, 2, "0");
};
var $fca8c39a40c45d55$var$monthDiff = function monthDiff(a, b) {
    // function from moment.js in order to keep the same result
    if (a.date() < b.date()) return -monthDiff(b, a);
    var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month());
    var anchor = a.clone().add(wholeMonthDiff, $f130d2306183d8d9$export$3a1a48c8f6ef640e);
    var c = b - anchor < 0;
    var anchor2 = a.clone().add(wholeMonthDiff + (c ? -1 : 1), $f130d2306183d8d9$export$3a1a48c8f6ef640e);
    return +(-(wholeMonthDiff + (b - anchor) / (c ? anchor - anchor2 : anchor2 - anchor)) || 0);
};
var $fca8c39a40c45d55$var$absFloor = function absFloor(n) {
    return n < 0 ? Math.ceil(n) || 0 : Math.floor(n);
};
var $fca8c39a40c45d55$var$prettyUnit = function prettyUnit(u) {
    var special = {
        M: $f130d2306183d8d9$export$3a1a48c8f6ef640e,
        y: $f130d2306183d8d9$export$8743009a87fcb00f,
        w: $f130d2306183d8d9$export$71cec2538cb2c617,
        d: $f130d2306183d8d9$export$96f57966bedc81b4,
        D: $f130d2306183d8d9$export$501a7fac1df67a49,
        h: $f130d2306183d8d9$export$7f8ddf7c7c20b3cd,
        m: $f130d2306183d8d9$export$85fbf3b9d951b785,
        s: $f130d2306183d8d9$export$25ce5a424b770e84,
        ms: $f130d2306183d8d9$export$71ad59f2e432cfe8,
        Q: $f130d2306183d8d9$export$3722cfe417b6ed86
    };
    return special[u] || String(u || "").toLowerCase().replace(/s$/, "");
};
var $fca8c39a40c45d55$var$isUndefined = function isUndefined(s) {
    return s === undefined;
};
var $fca8c39a40c45d55$export$2e2bcd8739ae039 = {
    s: $fca8c39a40c45d55$var$padStart,
    z: $fca8c39a40c45d55$var$padZoneStr,
    m: $fca8c39a40c45d55$var$monthDiff,
    a: $fca8c39a40c45d55$var$absFloor,
    p: $fca8c39a40c45d55$var$prettyUnit,
    u: $fca8c39a40c45d55$var$isUndefined
};


var $89c314bed017fff5$var$L = "en"; // global locale
var $89c314bed017fff5$var$Ls = {}; // global loaded locale
$89c314bed017fff5$var$Ls[$89c314bed017fff5$var$L] = (0, $5540b9cfe62f8a28$export$2e2bcd8739ae039);
var $89c314bed017fff5$var$IS_DAYJS = "$isDayjsObject"; // eslint-disable-next-line no-use-before-define
var $89c314bed017fff5$var$isDayjs = function isDayjs(d) {
    return d instanceof $89c314bed017fff5$var$Dayjs || !!(d && d[$89c314bed017fff5$var$IS_DAYJS]);
};
var $89c314bed017fff5$var$parseLocale = function parseLocale(preset, object, isLocal) {
    var l;
    if (!preset) return $89c314bed017fff5$var$L;
    if (typeof preset === "string") {
        var presetLower = preset.toLowerCase();
        if ($89c314bed017fff5$var$Ls[presetLower]) l = presetLower;
        if (object) {
            $89c314bed017fff5$var$Ls[presetLower] = object;
            l = presetLower;
        }
        var presetSplit = preset.split("-");
        if (!l && presetSplit.length > 1) return parseLocale(presetSplit[0]);
    } else {
        var name = preset.name;
        $89c314bed017fff5$var$Ls[name] = preset;
        l = name;
    }
    if (!isLocal && l) $89c314bed017fff5$var$L = l;
    return l || !isLocal && $89c314bed017fff5$var$L;
};
var $89c314bed017fff5$var$dayjs = function dayjs(date, c) {
    if ($89c314bed017fff5$var$isDayjs(date)) return date.clone();
     // eslint-disable-next-line no-nested-ternary
    var cfg = typeof c === "object" ? c : {};
    cfg.date = date;
    cfg.args = arguments; // eslint-disable-line prefer-rest-params
    return new $89c314bed017fff5$var$Dayjs(cfg); // eslint-disable-line no-use-before-define
};
var $89c314bed017fff5$var$wrapper = function wrapper(date, instance) {
    return $89c314bed017fff5$var$dayjs(date, {
        locale: instance.$L,
        utc: instance.$u,
        x: instance.$x,
        $offset: instance.$offset // todo: refactor; do not use this.$offset in you code
    });
};
var $89c314bed017fff5$var$Utils = (0, $fca8c39a40c45d55$export$2e2bcd8739ae039); // for plugin use
$89c314bed017fff5$var$Utils.l = $89c314bed017fff5$var$parseLocale;
$89c314bed017fff5$var$Utils.i = $89c314bed017fff5$var$isDayjs;
$89c314bed017fff5$var$Utils.w = $89c314bed017fff5$var$wrapper;
var $89c314bed017fff5$var$parseDate = function parseDate(cfg) {
    var date = cfg.date, utc = cfg.utc;
    if (date === null) return new Date(NaN); // null is invalid
    if ($89c314bed017fff5$var$Utils.u(date)) return new Date(); // today
    if (date instanceof Date) return new Date(date);
    if (typeof date === "string" && !/Z$/i.test(date)) {
        var d = date.match($f130d2306183d8d9$export$5017033e323668ef);
        if (d) {
            var m = d[2] - 1 || 0;
            var ms = (d[7] || "0").substring(0, 3);
            if (utc) return new Date(Date.UTC(d[1], m, d[3] || 1, d[4] || 0, d[5] || 0, d[6] || 0, ms));
            return new Date(d[1], m, d[3] || 1, d[4] || 0, d[5] || 0, d[6] || 0, ms);
        }
    }
    return new Date(date); // everything else
};
var $89c314bed017fff5$var$Dayjs = /*#__PURE__*/ function() {
    function Dayjs(cfg) {
        this.$L = $89c314bed017fff5$var$parseLocale(cfg.locale, null, true);
        this.parse(cfg); // for plugin
        this.$x = this.$x || cfg.x || {};
        this[$89c314bed017fff5$var$IS_DAYJS] = true;
    }
    var _proto = Dayjs.prototype;
    _proto.parse = function parse(cfg) {
        this.$d = $89c314bed017fff5$var$parseDate(cfg);
        this.init();
    };
    _proto.init = function init() {
        var $d = this.$d;
        this.$y = $d.getFullYear();
        this.$M = $d.getMonth();
        this.$D = $d.getDate();
        this.$W = $d.getDay();
        this.$H = $d.getHours();
        this.$m = $d.getMinutes();
        this.$s = $d.getSeconds();
        this.$ms = $d.getMilliseconds();
    } // eslint-disable-next-line class-methods-use-this
    ;
    _proto.$utils = function $utils() {
        return $89c314bed017fff5$var$Utils;
    };
    _proto.isValid = function isValid() {
        return !(this.$d.toString() === $f130d2306183d8d9$export$a3f90fd62b441bc0);
    };
    _proto.isSame = function isSame(that, units) {
        var other = $89c314bed017fff5$var$dayjs(that);
        return this.startOf(units) <= other && other <= this.endOf(units);
    };
    _proto.isAfter = function isAfter(that, units) {
        return $89c314bed017fff5$var$dayjs(that) < this.startOf(units);
    };
    _proto.isBefore = function isBefore(that, units) {
        return this.endOf(units) < $89c314bed017fff5$var$dayjs(that);
    };
    _proto.$g = function $g(input, get, set) {
        if ($89c314bed017fff5$var$Utils.u(input)) return this[get];
        return this.set(set, input);
    };
    _proto.unix = function unix() {
        return Math.floor(this.valueOf() / 1000);
    };
    _proto.valueOf = function valueOf() {
        // timezone(hour) * 60 * 60 * 1000 => ms
        return this.$d.getTime();
    };
    _proto.startOf = function startOf(units, _startOf) {
        var _this = this;
        // startOf -> endOf
        var isStartOf = !$89c314bed017fff5$var$Utils.u(_startOf) ? _startOf : true;
        var unit = $89c314bed017fff5$var$Utils.p(units);
        var instanceFactory = function instanceFactory(d, m) {
            var ins = $89c314bed017fff5$var$Utils.w(_this.$u ? Date.UTC(_this.$y, m, d) : new Date(_this.$y, m, d), _this);
            return isStartOf ? ins : ins.endOf($f130d2306183d8d9$export$96f57966bedc81b4);
        };
        var instanceFactorySet = function instanceFactorySet(method, slice) {
            var argumentStart = [
                0,
                0,
                0,
                0
            ];
            var argumentEnd = [
                23,
                59,
                59,
                999
            ];
            return $89c314bed017fff5$var$Utils.w(_this.toDate()[method].apply(_this.toDate("s"), (isStartOf ? argumentStart : argumentEnd).slice(slice)), _this);
        };
        var $W = this.$W, $M = this.$M, $D = this.$D;
        var utcPad = "set" + (this.$u ? "UTC" : "");
        switch(unit){
            case $f130d2306183d8d9$export$8743009a87fcb00f:
                return isStartOf ? instanceFactory(1, 0) : instanceFactory(31, 11);
            case $f130d2306183d8d9$export$3a1a48c8f6ef640e:
                return isStartOf ? instanceFactory(1, $M) : instanceFactory(0, $M + 1);
            case $f130d2306183d8d9$export$71cec2538cb2c617:
                var weekStart = this.$locale().weekStart || 0;
                var gap = ($W < weekStart ? $W + 7 : $W) - weekStart;
                return instanceFactory(isStartOf ? $D - gap : $D + (6 - gap), $M);
            case $f130d2306183d8d9$export$96f57966bedc81b4:
            case $f130d2306183d8d9$export$501a7fac1df67a49:
                return instanceFactorySet(utcPad + "Hours", 0);
            case $f130d2306183d8d9$export$7f8ddf7c7c20b3cd:
                return instanceFactorySet(utcPad + "Minutes", 1);
            case $f130d2306183d8d9$export$85fbf3b9d951b785:
                return instanceFactorySet(utcPad + "Seconds", 2);
            case $f130d2306183d8d9$export$25ce5a424b770e84:
                return instanceFactorySet(utcPad + "Milliseconds", 3);
            default:
                return this.clone();
        }
    };
    _proto.endOf = function endOf(arg) {
        return this.startOf(arg, false);
    };
    _proto.$set = function $set(units, _int) {
        var _C$D$C$DATE$C$M$C$Y$C;
        // private set
        var unit = $89c314bed017fff5$var$Utils.p(units);
        var utcPad = "set" + (this.$u ? "UTC" : "");
        var name = (_C$D$C$DATE$C$M$C$Y$C = {}, _C$D$C$DATE$C$M$C$Y$C[$f130d2306183d8d9$export$96f57966bedc81b4] = utcPad + "Date", _C$D$C$DATE$C$M$C$Y$C[$f130d2306183d8d9$export$501a7fac1df67a49] = utcPad + "Date", _C$D$C$DATE$C$M$C$Y$C[$f130d2306183d8d9$export$3a1a48c8f6ef640e] = utcPad + "Month", _C$D$C$DATE$C$M$C$Y$C[$f130d2306183d8d9$export$8743009a87fcb00f] = utcPad + "FullYear", _C$D$C$DATE$C$M$C$Y$C[$f130d2306183d8d9$export$7f8ddf7c7c20b3cd] = utcPad + "Hours", _C$D$C$DATE$C$M$C$Y$C[$f130d2306183d8d9$export$85fbf3b9d951b785] = utcPad + "Minutes", _C$D$C$DATE$C$M$C$Y$C[$f130d2306183d8d9$export$25ce5a424b770e84] = utcPad + "Seconds", _C$D$C$DATE$C$M$C$Y$C[$f130d2306183d8d9$export$71ad59f2e432cfe8] = utcPad + "Milliseconds", _C$D$C$DATE$C$M$C$Y$C)[unit];
        var arg = unit === $f130d2306183d8d9$export$96f57966bedc81b4 ? this.$D + (_int - this.$W) : _int;
        if (unit === $f130d2306183d8d9$export$3a1a48c8f6ef640e || unit === $f130d2306183d8d9$export$8743009a87fcb00f) {
            // clone is for badMutable plugin
            var date = this.clone().set($f130d2306183d8d9$export$501a7fac1df67a49, 1);
            date.$d[name](arg);
            date.init();
            this.$d = date.set($f130d2306183d8d9$export$501a7fac1df67a49, Math.min(this.$D, date.daysInMonth())).$d;
        } else if (name) this.$d[name](arg);
        this.init();
        return this;
    };
    _proto.set = function set(string, _int2) {
        return this.clone().$set(string, _int2);
    };
    _proto.get = function get(unit) {
        return this[$89c314bed017fff5$var$Utils.p(unit)]();
    };
    _proto.add = function add(number, units) {
        var _this2 = this, _C$MIN$C$H$C$S$unit;
        number = Number(number); // eslint-disable-line no-param-reassign
        var unit = $89c314bed017fff5$var$Utils.p(units);
        var instanceFactorySet = function instanceFactorySet(n) {
            var d = $89c314bed017fff5$var$dayjs(_this2);
            return $89c314bed017fff5$var$Utils.w(d.date(d.date() + Math.round(n * number)), _this2);
        };
        if (unit === $f130d2306183d8d9$export$3a1a48c8f6ef640e) return this.set($f130d2306183d8d9$export$3a1a48c8f6ef640e, this.$M + number);
        if (unit === $f130d2306183d8d9$export$8743009a87fcb00f) return this.set($f130d2306183d8d9$export$8743009a87fcb00f, this.$y + number);
        if (unit === $f130d2306183d8d9$export$96f57966bedc81b4) return instanceFactorySet(1);
        if (unit === $f130d2306183d8d9$export$71cec2538cb2c617) return instanceFactorySet(7);
        var step = (_C$MIN$C$H$C$S$unit = {}, _C$MIN$C$H$C$S$unit[$f130d2306183d8d9$export$85fbf3b9d951b785] = $f130d2306183d8d9$export$37971e215480ff4b, _C$MIN$C$H$C$S$unit[$f130d2306183d8d9$export$7f8ddf7c7c20b3cd] = $f130d2306183d8d9$export$c42e2f66c1854fa2, _C$MIN$C$H$C$S$unit[$f130d2306183d8d9$export$25ce5a424b770e84] = $f130d2306183d8d9$export$c0ed55f5b8675ea3, _C$MIN$C$H$C$S$unit)[unit] || 1; // ms
        var nextTimeStamp = this.$d.getTime() + number * step;
        return $89c314bed017fff5$var$Utils.w(nextTimeStamp, this);
    };
    _proto.subtract = function subtract(number, string) {
        return this.add(number * -1, string);
    };
    _proto.format = function format(formatStr) {
        var _this3 = this;
        var locale = this.$locale();
        if (!this.isValid()) return locale.invalidDate || $f130d2306183d8d9$export$a3f90fd62b441bc0;
        var str = formatStr || $f130d2306183d8d9$export$43dfb2cd49ed2315;
        var zoneStr = $89c314bed017fff5$var$Utils.z(this);
        var $H = this.$H, $m = this.$m, $M = this.$M;
        var weekdays = locale.weekdays, months = locale.months, meridiem = locale.meridiem;
        var getShort = function getShort(arr, index, full, length) {
            return arr && (arr[index] || arr(_this3, str)) || full[index].slice(0, length);
        };
        var get$H = function get$H(num) {
            return $89c314bed017fff5$var$Utils.s($H % 12 || 12, num, "0");
        };
        var meridiemFunc = meridiem || function(hour, minute, isLowercase) {
            var m = hour < 12 ? "AM" : "PM";
            return isLowercase ? m.toLowerCase() : m;
        };
        var matches = function matches(match) {
            switch(match){
                case "YY":
                    return String(_this3.$y).slice(-2);
                case "YYYY":
                    return $89c314bed017fff5$var$Utils.s(_this3.$y, 4, "0");
                case "M":
                    return $M + 1;
                case "MM":
                    return $89c314bed017fff5$var$Utils.s($M + 1, 2, "0");
                case "MMM":
                    return getShort(locale.monthsShort, $M, months, 3);
                case "MMMM":
                    return getShort(months, $M);
                case "D":
                    return _this3.$D;
                case "DD":
                    return $89c314bed017fff5$var$Utils.s(_this3.$D, 2, "0");
                case "d":
                    return String(_this3.$W);
                case "dd":
                    return getShort(locale.weekdaysMin, _this3.$W, weekdays, 2);
                case "ddd":
                    return getShort(locale.weekdaysShort, _this3.$W, weekdays, 3);
                case "dddd":
                    return weekdays[_this3.$W];
                case "H":
                    return String($H);
                case "HH":
                    return $89c314bed017fff5$var$Utils.s($H, 2, "0");
                case "h":
                    return get$H(1);
                case "hh":
                    return get$H(2);
                case "a":
                    return meridiemFunc($H, $m, true);
                case "A":
                    return meridiemFunc($H, $m, false);
                case "m":
                    return String($m);
                case "mm":
                    return $89c314bed017fff5$var$Utils.s($m, 2, "0");
                case "s":
                    return String(_this3.$s);
                case "ss":
                    return $89c314bed017fff5$var$Utils.s(_this3.$s, 2, "0");
                case "SSS":
                    return $89c314bed017fff5$var$Utils.s(_this3.$ms, 3, "0");
                case "Z":
                    return zoneStr;
                // 'ZZ' logic below
                default:
                    break;
            }
            return null;
        };
        return str.replace($f130d2306183d8d9$export$b72c006c7b334a95, function(match, $1) {
            return $1 || matches(match) || zoneStr.replace(":", "");
        }); // 'ZZ'
    };
    _proto.utcOffset = function utcOffset() {
        // Because a bug at FF24, we're rounding the timezone offset around 15 minutes
        // https://github.com/moment/moment/pull/1871
        return -Math.round(this.$d.getTimezoneOffset() / 15) * 15;
    };
    _proto.diff = function diff(input, units, _float) {
        var _this4 = this;
        var unit = $89c314bed017fff5$var$Utils.p(units);
        var that = $89c314bed017fff5$var$dayjs(input);
        var zoneDelta = (that.utcOffset() - this.utcOffset()) * $f130d2306183d8d9$export$37971e215480ff4b;
        var diff = this - that;
        var getMonth = function getMonth() {
            return $89c314bed017fff5$var$Utils.m(_this4, that);
        };
        var result;
        switch(unit){
            case $f130d2306183d8d9$export$8743009a87fcb00f:
                result = getMonth() / 12;
                break;
            case $f130d2306183d8d9$export$3a1a48c8f6ef640e:
                result = getMonth();
                break;
            case $f130d2306183d8d9$export$3722cfe417b6ed86:
                result = getMonth() / 3;
                break;
            case $f130d2306183d8d9$export$71cec2538cb2c617:
                result = (diff - zoneDelta) / $f130d2306183d8d9$export$3dc01d4e106e904c;
                break;
            case $f130d2306183d8d9$export$96f57966bedc81b4:
                result = (diff - zoneDelta) / $f130d2306183d8d9$export$a3d0b9741172e0d2;
                break;
            case $f130d2306183d8d9$export$7f8ddf7c7c20b3cd:
                result = diff / $f130d2306183d8d9$export$c42e2f66c1854fa2;
                break;
            case $f130d2306183d8d9$export$85fbf3b9d951b785:
                result = diff / $f130d2306183d8d9$export$37971e215480ff4b;
                break;
            case $f130d2306183d8d9$export$25ce5a424b770e84:
                result = diff / $f130d2306183d8d9$export$c0ed55f5b8675ea3;
                break;
            default:
                result = diff; // milliseconds
                break;
        }
        return _float ? result : $89c314bed017fff5$var$Utils.a(result);
    };
    _proto.daysInMonth = function daysInMonth() {
        return this.endOf($f130d2306183d8d9$export$3a1a48c8f6ef640e).$D;
    };
    _proto.$locale = function $locale() {
        // get locale object
        return $89c314bed017fff5$var$Ls[this.$L];
    };
    _proto.locale = function locale(preset, object) {
        if (!preset) return this.$L;
        var that = this.clone();
        var nextLocaleName = $89c314bed017fff5$var$parseLocale(preset, object, true);
        if (nextLocaleName) that.$L = nextLocaleName;
        return that;
    };
    _proto.clone = function clone() {
        return $89c314bed017fff5$var$Utils.w(this.$d, this);
    };
    _proto.toDate = function toDate() {
        return new Date(this.valueOf());
    };
    _proto.toJSON = function toJSON() {
        return this.isValid() ? this.toISOString() : null;
    };
    _proto.toISOString = function toISOString() {
        // ie 8 return
        // new Dayjs(this.valueOf() + this.$d.getTimezoneOffset() * 60000)
        // .format('YYYY-MM-DDTHH:mm:ss.SSS[Z]')
        return this.$d.toISOString();
    };
    _proto.toString = function toString() {
        return this.$d.toUTCString();
    };
    return Dayjs;
}();
var $89c314bed017fff5$var$proto = $89c314bed017fff5$var$Dayjs.prototype;
$89c314bed017fff5$var$dayjs.prototype = $89c314bed017fff5$var$proto;
[
    [
        "$ms",
        $f130d2306183d8d9$export$71ad59f2e432cfe8
    ],
    [
        "$s",
        $f130d2306183d8d9$export$25ce5a424b770e84
    ],
    [
        "$m",
        $f130d2306183d8d9$export$85fbf3b9d951b785
    ],
    [
        "$H",
        $f130d2306183d8d9$export$7f8ddf7c7c20b3cd
    ],
    [
        "$W",
        $f130d2306183d8d9$export$96f57966bedc81b4
    ],
    [
        "$M",
        $f130d2306183d8d9$export$3a1a48c8f6ef640e
    ],
    [
        "$y",
        $f130d2306183d8d9$export$8743009a87fcb00f
    ],
    [
        "$D",
        $f130d2306183d8d9$export$501a7fac1df67a49
    ]
].forEach(function(g) {
    $89c314bed017fff5$var$proto[g[1]] = function(input) {
        return this.$g(input, g[0], g[1]);
    };
});
$89c314bed017fff5$var$dayjs.extend = function(plugin, option) {
    if (!plugin.$i) {
        // install plugin only once
        plugin(option, $89c314bed017fff5$var$Dayjs, $89c314bed017fff5$var$dayjs);
        plugin.$i = true;
    }
    return $89c314bed017fff5$var$dayjs;
};
$89c314bed017fff5$var$dayjs.locale = $89c314bed017fff5$var$parseLocale;
$89c314bed017fff5$var$dayjs.isDayjs = $89c314bed017fff5$var$isDayjs;
$89c314bed017fff5$var$dayjs.unix = function(timestamp) {
    return $89c314bed017fff5$var$dayjs(timestamp * 1e3);
};
$89c314bed017fff5$var$dayjs.en = $89c314bed017fff5$var$Ls[$89c314bed017fff5$var$L];
$89c314bed017fff5$var$dayjs.Ls = $89c314bed017fff5$var$Ls;
$89c314bed017fff5$var$dayjs.p = {};
var $89c314bed017fff5$export$2e2bcd8739ae039 = $89c314bed017fff5$var$dayjs;


// French [fr]

var $33ef24c73acd9c51$var$locale = {
    name: "fr",
    weekdays: "dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi".split("_"),
    weekdaysShort: "dim._lun._mar._mer._jeu._ven._sam.".split("_"),
    weekdaysMin: "di_lu_ma_me_je_ve_sa".split("_"),
    months: "janvier_f\xe9vrier_mars_avril_mai_juin_juillet_ao\xfbt_septembre_octobre_novembre_d\xe9cembre".split("_"),
    monthsShort: "janv._f\xe9vr._mars_avr._mai_juin_juil._ao\xfbt_sept._oct._nov._d\xe9c.".split("_"),
    weekStart: 1,
    yearStart: 4,
    formats: {
        LT: "HH:mm",
        LTS: "HH:mm:ss",
        L: "DD/MM/YYYY",
        LL: "D MMMM YYYY",
        LLL: "D MMMM YYYY HH:mm",
        LLLL: "dddd D MMMM YYYY HH:mm"
    },
    relativeTime: {
        future: "dans %s",
        past: "il y a %s",
        s: "quelques secondes",
        m: "une minute",
        mm: "%d minutes",
        h: "une heure",
        hh: "%d heures",
        d: "un jour",
        dd: "%d jours",
        M: "un mois",
        MM: "%d mois",
        y: "un an",
        yy: "%d ans"
    },
    ordinal: function ordinal(n) {
        var o = n === 1 ? "er" : "";
        return "" + n + o;
    }
};
(0, $89c314bed017fff5$export$2e2bcd8739ae039).locale($33ef24c73acd9c51$var$locale, null, true);
var $33ef24c73acd9c51$export$2e2bcd8739ae039 = $33ef24c73acd9c51$var$locale;



var $5ewvA = parcelRequire("5ewvA");

var $5ewvA = parcelRequire("5ewvA");

var $gYLTL = parcelRequire("gYLTL");

function $e0cd4f805ce7da13$var$none() {}
function $e0cd4f805ce7da13$export$2e2bcd8739ae039(selector) {
    return selector == null ? $e0cd4f805ce7da13$var$none : function() {
        return this.querySelector(selector);
    };
}


function $6e65955f79079aac$export$2e2bcd8739ae039(select) {
    if (typeof select !== "function") select = (0, $e0cd4f805ce7da13$export$2e2bcd8739ae039)(select);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i)if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
            if ("__data__" in node) subnode.__data__ = node.__data__;
            subgroup[i] = subnode;
        }
    }
    return new (0, $5ee876dcfa0147c8$export$52baac22726c72bf)(subgroups, this._parents);
}



// Given something array like (or null), returns something that is strictly an
// array. This is used to ensure that array-like objects passed to d3.selectAll
// or selection.selectAll are converted into proper arrays when creating a
// selection; we don’t ever want to create a selection backed by a live
// HTMLCollection or NodeList. However, note that selection.selectAll will use a
// static NodeList as a group, since it safely derived from querySelectorAll.
function $28888b58f4a29961$export$2e2bcd8739ae039(x) {
    return x == null ? [] : Array.isArray(x) ? x : Array.from(x);
}


function $429453331e7e2a58$var$empty() {
    return [];
}
function $429453331e7e2a58$export$2e2bcd8739ae039(selector) {
    return selector == null ? $429453331e7e2a58$var$empty : function() {
        return this.querySelectorAll(selector);
    };
}


function $5b2fd909604f10f3$var$arrayAll(select) {
    return function() {
        return (0, $28888b58f4a29961$export$2e2bcd8739ae039)(select.apply(this, arguments));
    };
}
function $5b2fd909604f10f3$export$2e2bcd8739ae039(select) {
    if (typeof select === "function") select = $5b2fd909604f10f3$var$arrayAll(select);
    else select = (0, $429453331e7e2a58$export$2e2bcd8739ae039)(select);
    for(var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
            subgroups.push(select.call(node, node.__data__, i, group));
            parents.push(node);
        }
    }
    return new (0, $5ee876dcfa0147c8$export$52baac22726c72bf)(subgroups, parents);
}


function $690aac15e1c8d9ce$export$2e2bcd8739ae039(selector) {
    return function() {
        return this.matches(selector);
    };
}
function $690aac15e1c8d9ce$export$90c2759c036528(selector) {
    return function(node) {
        return node.matches(selector);
    };
}


var $8132d11a19a03025$var$find = Array.prototype.find;
function $8132d11a19a03025$var$childFind(match) {
    return function() {
        return $8132d11a19a03025$var$find.call(this.children, match);
    };
}
function $8132d11a19a03025$var$childFirst() {
    return this.firstElementChild;
}
function $8132d11a19a03025$export$2e2bcd8739ae039(match) {
    return this.select(match == null ? $8132d11a19a03025$var$childFirst : $8132d11a19a03025$var$childFind(typeof match === "function" ? match : (0, $690aac15e1c8d9ce$export$90c2759c036528)(match)));
}



var $b97bff92e99b7031$var$filter = Array.prototype.filter;
function $b97bff92e99b7031$var$children() {
    return Array.from(this.children);
}
function $b97bff92e99b7031$var$childrenFilter(match) {
    return function() {
        return $b97bff92e99b7031$var$filter.call(this.children, match);
    };
}
function $b97bff92e99b7031$export$2e2bcd8739ae039(match) {
    return this.selectAll(match == null ? $b97bff92e99b7031$var$children : $b97bff92e99b7031$var$childrenFilter(typeof match === "function" ? match : (0, $690aac15e1c8d9ce$export$90c2759c036528)(match)));
}




function $11691620a1b9b6f3$export$2e2bcd8739ae039(match) {
    if (typeof match !== "function") match = (0, $690aac15e1c8d9ce$export$2e2bcd8739ae039)(match);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i)if ((node = group[i]) && match.call(node, node.__data__, i, group)) subgroup.push(node);
    }
    return new (0, $5ee876dcfa0147c8$export$52baac22726c72bf)(subgroups, this._parents);
}



function $8b5138a21307fc18$export$2e2bcd8739ae039(update) {
    return new Array(update.length);
}



function $0a4874e9bcdc1edd$export$2e2bcd8739ae039() {
    return new (0, $5ee876dcfa0147c8$export$52baac22726c72bf)(this._enter || this._groups.map((0, $8b5138a21307fc18$export$2e2bcd8739ae039)), this._parents);
}
function $0a4874e9bcdc1edd$export$67b01759a14cf6a4(parent, datum) {
    this.ownerDocument = parent.ownerDocument;
    this.namespaceURI = parent.namespaceURI;
    this._next = null;
    this._parent = parent;
    this.__data__ = datum;
}
$0a4874e9bcdc1edd$export$67b01759a14cf6a4.prototype = {
    constructor: $0a4874e9bcdc1edd$export$67b01759a14cf6a4,
    appendChild: function(child) {
        return this._parent.insertBefore(child, this._next);
    },
    insertBefore: function(child, next) {
        return this._parent.insertBefore(child, next);
    },
    querySelector: function(selector) {
        return this._parent.querySelector(selector);
    },
    querySelectorAll: function(selector) {
        return this._parent.querySelectorAll(selector);
    }
};


function $fee89bb46913e9f2$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}


function $fa01014096277d5b$var$bindIndex(parent, group, enter, update, exit, data) {
    var i = 0, node, groupLength = group.length, dataLength = data.length;
    // Put any non-null nodes that fit into update.
    // Put any null nodes into enter.
    // Put any remaining data into enter.
    for(; i < dataLength; ++i)if (node = group[i]) {
        node.__data__ = data[i];
        update[i] = node;
    } else enter[i] = new (0, $0a4874e9bcdc1edd$export$67b01759a14cf6a4)(parent, data[i]);
    // Put any non-null nodes that don’t fit into exit.
    for(; i < groupLength; ++i)if (node = group[i]) exit[i] = node;
}
function $fa01014096277d5b$var$bindKey(parent, group, enter, update, exit, data, key) {
    var i, node, nodeByKeyValue = new Map, groupLength = group.length, dataLength = data.length, keyValues = new Array(groupLength), keyValue;
    // Compute the key for each node.
    // If multiple nodes have the same key, the duplicates are added to exit.
    for(i = 0; i < groupLength; ++i)if (node = group[i]) {
        keyValues[i] = keyValue = key.call(node, node.__data__, i, group) + "";
        if (nodeByKeyValue.has(keyValue)) exit[i] = node;
        else nodeByKeyValue.set(keyValue, node);
    }
    // Compute the key for each datum.
    // If there a node associated with this key, join and add it to update.
    // If there is not (or the key is a duplicate), add it to enter.
    for(i = 0; i < dataLength; ++i){
        keyValue = key.call(parent, data[i], i, data) + "";
        if (node = nodeByKeyValue.get(keyValue)) {
            update[i] = node;
            node.__data__ = data[i];
            nodeByKeyValue.delete(keyValue);
        } else enter[i] = new (0, $0a4874e9bcdc1edd$export$67b01759a14cf6a4)(parent, data[i]);
    }
    // Add any remaining nodes that were not bound to data to exit.
    for(i = 0; i < groupLength; ++i)if ((node = group[i]) && nodeByKeyValue.get(keyValues[i]) === node) exit[i] = node;
}
function $fa01014096277d5b$var$datum(node) {
    return node.__data__;
}
function $fa01014096277d5b$export$2e2bcd8739ae039(value, key) {
    if (!arguments.length) return Array.from(this, $fa01014096277d5b$var$datum);
    var bind = key ? $fa01014096277d5b$var$bindKey : $fa01014096277d5b$var$bindIndex, parents = this._parents, groups = this._groups;
    if (typeof value !== "function") value = (0, $fee89bb46913e9f2$export$2e2bcd8739ae039)(value);
    for(var m = groups.length, update = new Array(m), enter = new Array(m), exit = new Array(m), j = 0; j < m; ++j){
        var parent = parents[j], group = groups[j], groupLength = group.length, data = $fa01014096277d5b$var$arraylike(value.call(parent, parent && parent.__data__, j, parents)), dataLength = data.length, enterGroup = enter[j] = new Array(dataLength), updateGroup = update[j] = new Array(dataLength), exitGroup = exit[j] = new Array(groupLength);
        bind(parent, group, enterGroup, updateGroup, exitGroup, data, key);
        // Now connect the enter nodes to their following update node, such that
        // appendChild can insert the materialized enter node before this node,
        // rather than at the end of the parent node.
        for(var i0 = 0, i1 = 0, previous, next; i0 < dataLength; ++i0)if (previous = enterGroup[i0]) {
            if (i0 >= i1) i1 = i0 + 1;
            while(!(next = updateGroup[i1]) && ++i1 < dataLength);
            previous._next = next || null;
        }
    }
    update = new (0, $5ee876dcfa0147c8$export$52baac22726c72bf)(update, parents);
    update._enter = enter;
    update._exit = exit;
    return update;
}
// Given some data, this returns an array-like view of it: an object that
// exposes a length property and allows numeric indexing. Note that unlike
// selectAll, this isn’t worried about “live” collections because the resulting
// array will only be used briefly while data is being bound. (It is possible to
// cause the data to change while iterating by using a key function, but please
// don’t; we’d rather avoid a gratuitous copy.)
function $fa01014096277d5b$var$arraylike(data) {
    return typeof data === "object" && "length" in data ? data // Array, TypedArray, NodeList, array-like
     : Array.from(data); // Map, Set, iterable, string, or anything else
}





function $16be99442c0246d0$export$2e2bcd8739ae039() {
    return new (0, $5ee876dcfa0147c8$export$52baac22726c72bf)(this._exit || this._groups.map((0, $8b5138a21307fc18$export$2e2bcd8739ae039)), this._parents);
}


function $d9cc84a431584add$export$2e2bcd8739ae039(onenter, onupdate, onexit) {
    var enter = this.enter(), update = this, exit = this.exit();
    if (typeof onenter === "function") {
        enter = onenter(enter);
        if (enter) enter = enter.selection();
    } else enter = enter.append(onenter + "");
    if (onupdate != null) {
        update = onupdate(update);
        if (update) update = update.selection();
    }
    if (onexit == null) exit.remove();
    else onexit(exit);
    return enter && update ? enter.merge(update).order() : update;
}



function $f9060e557903e758$export$2e2bcd8739ae039(context) {
    var selection = context.selection ? context.selection() : context;
    for(var groups0 = this._groups, groups1 = selection._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j){
        for(var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group0[i] || group1[i]) merge[i] = node;
    }
    for(; j < m0; ++j)merges[j] = groups0[j];
    return new (0, $5ee876dcfa0147c8$export$52baac22726c72bf)(merges, this._parents);
}


function $f8823586b00e037d$export$2e2bcd8739ae039() {
    for(var groups = this._groups, j = -1, m = groups.length; ++j < m;){
        for(var group = groups[j], i = group.length - 1, next = group[i], node; --i >= 0;)if (node = group[i]) {
            if (next && node.compareDocumentPosition(next) ^ 4) next.parentNode.insertBefore(node, next);
            next = node;
        }
    }
    return this;
}



function $5e05d26d7c04223a$export$2e2bcd8739ae039(compare) {
    if (!compare) compare = $5e05d26d7c04223a$var$ascending;
    function compareNode(a, b) {
        return a && b ? compare(a.__data__, b.__data__) : !a - !b;
    }
    for(var groups = this._groups, m = groups.length, sortgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, sortgroup = sortgroups[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group[i]) sortgroup[i] = node;
        sortgroup.sort(compareNode);
    }
    return new (0, $5ee876dcfa0147c8$export$52baac22726c72bf)(sortgroups, this._parents).order();
}
function $5e05d26d7c04223a$var$ascending(a, b) {
    return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}


function $c7413215d90e2c7d$export$2e2bcd8739ae039() {
    var callback = arguments[0];
    arguments[0] = this;
    callback.apply(null, arguments);
    return this;
}


function $db72d7def4dc0333$export$2e2bcd8739ae039() {
    return Array.from(this);
}


function $8cc608ee6d80c00b$export$2e2bcd8739ae039() {
    for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j)for(var group = groups[j], i = 0, n = group.length; i < n; ++i){
        var node = group[i];
        if (node) return node;
    }
    return null;
}


function $12ca944a7a79ad63$export$2e2bcd8739ae039() {
    let size = 0;
    for (const node of this)++size; // eslint-disable-line no-unused-vars
    return size;
}


function $c44a7c34daa3e930$export$2e2bcd8739ae039() {
    return !this.node();
}


function $6d31764592e39758$export$2e2bcd8739ae039(callback) {
    for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j){
        for(var group = groups[j], i = 0, n = group.length, node; i < n; ++i)if (node = group[i]) callback.call(node, node.__data__, i, group);
    }
    return this;
}


var $95363054c30c8afd$export$201a3f7520ccc326 = "http://www.w3.org/1999/xhtml";
var $95363054c30c8afd$export$2e2bcd8739ae039 = {
    svg: "http://www.w3.org/2000/svg",
    xhtml: $95363054c30c8afd$export$201a3f7520ccc326,
    xlink: "http://www.w3.org/1999/xlink",
    xml: "http://www.w3.org/XML/1998/namespace",
    xmlns: "http://www.w3.org/2000/xmlns/"
};


function $cf3406a48b514514$export$2e2bcd8739ae039(name) {
    var prefix = name += "", i = prefix.indexOf(":");
    if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
    return (0, $95363054c30c8afd$export$2e2bcd8739ae039).hasOwnProperty(prefix) ? {
        space: (0, $95363054c30c8afd$export$2e2bcd8739ae039)[prefix],
        local: name
    } : name; // eslint-disable-line no-prototype-builtins
}


function $d10e1c52ed08c9bc$var$attrRemove(name) {
    return function() {
        this.removeAttribute(name);
    };
}
function $d10e1c52ed08c9bc$var$attrRemoveNS(fullname) {
    return function() {
        this.removeAttributeNS(fullname.space, fullname.local);
    };
}
function $d10e1c52ed08c9bc$var$attrConstant(name, value) {
    return function() {
        this.setAttribute(name, value);
    };
}
function $d10e1c52ed08c9bc$var$attrConstantNS(fullname, value) {
    return function() {
        this.setAttributeNS(fullname.space, fullname.local, value);
    };
}
function $d10e1c52ed08c9bc$var$attrFunction(name, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.removeAttribute(name);
        else this.setAttribute(name, v);
    };
}
function $d10e1c52ed08c9bc$var$attrFunctionNS(fullname, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.removeAttributeNS(fullname.space, fullname.local);
        else this.setAttributeNS(fullname.space, fullname.local, v);
    };
}
function $d10e1c52ed08c9bc$export$2e2bcd8739ae039(name, value) {
    var fullname = (0, $cf3406a48b514514$export$2e2bcd8739ae039)(name);
    if (arguments.length < 2) {
        var node = this.node();
        return fullname.local ? node.getAttributeNS(fullname.space, fullname.local) : node.getAttribute(fullname);
    }
    return this.each((value == null ? fullname.local ? $d10e1c52ed08c9bc$var$attrRemoveNS : $d10e1c52ed08c9bc$var$attrRemove : typeof value === "function" ? fullname.local ? $d10e1c52ed08c9bc$var$attrFunctionNS : $d10e1c52ed08c9bc$var$attrFunction : fullname.local ? $d10e1c52ed08c9bc$var$attrConstantNS : $d10e1c52ed08c9bc$var$attrConstant)(fullname, value));
}


function $03d0bd94a0abcfc0$export$2e2bcd8739ae039(node) {
    return node.ownerDocument && node.ownerDocument.defaultView // node is a Node
     || node.document && node // node is a Window
     || node.defaultView; // node is a Document
}


function $d73e6e38f360be26$var$styleRemove(name) {
    return function() {
        this.style.removeProperty(name);
    };
}
function $d73e6e38f360be26$var$styleConstant(name, value, priority) {
    return function() {
        this.style.setProperty(name, value, priority);
    };
}
function $d73e6e38f360be26$var$styleFunction(name, value, priority) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.style.removeProperty(name);
        else this.style.setProperty(name, v, priority);
    };
}
function $d73e6e38f360be26$export$2e2bcd8739ae039(name, value, priority) {
    return arguments.length > 1 ? this.each((value == null ? $d73e6e38f360be26$var$styleRemove : typeof value === "function" ? $d73e6e38f360be26$var$styleFunction : $d73e6e38f360be26$var$styleConstant)(name, value, priority == null ? "" : priority)) : $d73e6e38f360be26$export$5e3cec964f0b5efd(this.node(), name);
}
function $d73e6e38f360be26$export$5e3cec964f0b5efd(node, name) {
    return node.style.getPropertyValue(name) || (0, $03d0bd94a0abcfc0$export$2e2bcd8739ae039)(node).getComputedStyle(node, null).getPropertyValue(name);
}


function $d50bd1b80c636f84$var$propertyRemove(name) {
    return function() {
        delete this[name];
    };
}
function $d50bd1b80c636f84$var$propertyConstant(name, value) {
    return function() {
        this[name] = value;
    };
}
function $d50bd1b80c636f84$var$propertyFunction(name, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) delete this[name];
        else this[name] = v;
    };
}
function $d50bd1b80c636f84$export$2e2bcd8739ae039(name, value) {
    return arguments.length > 1 ? this.each((value == null ? $d50bd1b80c636f84$var$propertyRemove : typeof value === "function" ? $d50bd1b80c636f84$var$propertyFunction : $d50bd1b80c636f84$var$propertyConstant)(name, value)) : this.node()[name];
}


function $d6f575d6de457295$var$classArray(string) {
    return string.trim().split(/^|\s+/);
}
function $d6f575d6de457295$var$classList(node) {
    return node.classList || new $d6f575d6de457295$var$ClassList(node);
}
function $d6f575d6de457295$var$ClassList(node) {
    this._node = node;
    this._names = $d6f575d6de457295$var$classArray(node.getAttribute("class") || "");
}
$d6f575d6de457295$var$ClassList.prototype = {
    add: function(name) {
        var i = this._names.indexOf(name);
        if (i < 0) {
            this._names.push(name);
            this._node.setAttribute("class", this._names.join(" "));
        }
    },
    remove: function(name) {
        var i = this._names.indexOf(name);
        if (i >= 0) {
            this._names.splice(i, 1);
            this._node.setAttribute("class", this._names.join(" "));
        }
    },
    contains: function(name) {
        return this._names.indexOf(name) >= 0;
    }
};
function $d6f575d6de457295$var$classedAdd(node, names) {
    var list = $d6f575d6de457295$var$classList(node), i = -1, n = names.length;
    while(++i < n)list.add(names[i]);
}
function $d6f575d6de457295$var$classedRemove(node, names) {
    var list = $d6f575d6de457295$var$classList(node), i = -1, n = names.length;
    while(++i < n)list.remove(names[i]);
}
function $d6f575d6de457295$var$classedTrue(names) {
    return function() {
        $d6f575d6de457295$var$classedAdd(this, names);
    };
}
function $d6f575d6de457295$var$classedFalse(names) {
    return function() {
        $d6f575d6de457295$var$classedRemove(this, names);
    };
}
function $d6f575d6de457295$var$classedFunction(names, value) {
    return function() {
        (value.apply(this, arguments) ? $d6f575d6de457295$var$classedAdd : $d6f575d6de457295$var$classedRemove)(this, names);
    };
}
function $d6f575d6de457295$export$2e2bcd8739ae039(name, value) {
    var names = $d6f575d6de457295$var$classArray(name + "");
    if (arguments.length < 2) {
        var list = $d6f575d6de457295$var$classList(this.node()), i = -1, n = names.length;
        while(++i < n)if (!list.contains(names[i])) return false;
        return true;
    }
    return this.each((typeof value === "function" ? $d6f575d6de457295$var$classedFunction : value ? $d6f575d6de457295$var$classedTrue : $d6f575d6de457295$var$classedFalse)(names, value));
}


function $6c68f3a3157dd8aa$var$textRemove() {
    this.textContent = "";
}
function $6c68f3a3157dd8aa$var$textConstant(value) {
    return function() {
        this.textContent = value;
    };
}
function $6c68f3a3157dd8aa$var$textFunction(value) {
    return function() {
        var v = value.apply(this, arguments);
        this.textContent = v == null ? "" : v;
    };
}
function $6c68f3a3157dd8aa$export$2e2bcd8739ae039(value) {
    return arguments.length ? this.each(value == null ? $6c68f3a3157dd8aa$var$textRemove : (typeof value === "function" ? $6c68f3a3157dd8aa$var$textFunction : $6c68f3a3157dd8aa$var$textConstant)(value)) : this.node().textContent;
}


function $59b55b06dd39edcc$var$htmlRemove() {
    this.innerHTML = "";
}
function $59b55b06dd39edcc$var$htmlConstant(value) {
    return function() {
        this.innerHTML = value;
    };
}
function $59b55b06dd39edcc$var$htmlFunction(value) {
    return function() {
        var v = value.apply(this, arguments);
        this.innerHTML = v == null ? "" : v;
    };
}
function $59b55b06dd39edcc$export$2e2bcd8739ae039(value) {
    return arguments.length ? this.each(value == null ? $59b55b06dd39edcc$var$htmlRemove : (typeof value === "function" ? $59b55b06dd39edcc$var$htmlFunction : $59b55b06dd39edcc$var$htmlConstant)(value)) : this.node().innerHTML;
}


function $aebf51fbd3d9b4e9$var$raise() {
    if (this.nextSibling) this.parentNode.appendChild(this);
}
function $aebf51fbd3d9b4e9$export$2e2bcd8739ae039() {
    return this.each($aebf51fbd3d9b4e9$var$raise);
}


function $e6fc61098a1a916c$var$lower() {
    if (this.previousSibling) this.parentNode.insertBefore(this, this.parentNode.firstChild);
}
function $e6fc61098a1a916c$export$2e2bcd8739ae039() {
    return this.each($e6fc61098a1a916c$var$lower);
}




function $58805e6cd6dec954$var$creatorInherit(name) {
    return function() {
        var document = this.ownerDocument, uri = this.namespaceURI;
        return uri === (0, $95363054c30c8afd$export$201a3f7520ccc326) && document.documentElement.namespaceURI === (0, $95363054c30c8afd$export$201a3f7520ccc326) ? document.createElement(name) : document.createElementNS(uri, name);
    };
}
function $58805e6cd6dec954$var$creatorFixed(fullname) {
    return function() {
        return this.ownerDocument.createElementNS(fullname.space, fullname.local);
    };
}
function $58805e6cd6dec954$export$2e2bcd8739ae039(name) {
    var fullname = (0, $cf3406a48b514514$export$2e2bcd8739ae039)(name);
    return (fullname.local ? $58805e6cd6dec954$var$creatorFixed : $58805e6cd6dec954$var$creatorInherit)(fullname);
}


function $24b505892b9f1144$export$2e2bcd8739ae039(name) {
    var create = typeof name === "function" ? name : (0, $58805e6cd6dec954$export$2e2bcd8739ae039)(name);
    return this.select(function() {
        return this.appendChild(create.apply(this, arguments));
    });
}




function $5a917efbfd15f37d$var$constantNull() {
    return null;
}
function $5a917efbfd15f37d$export$2e2bcd8739ae039(name, before) {
    var create = typeof name === "function" ? name : (0, $58805e6cd6dec954$export$2e2bcd8739ae039)(name), select = before == null ? $5a917efbfd15f37d$var$constantNull : typeof before === "function" ? before : (0, $e0cd4f805ce7da13$export$2e2bcd8739ae039)(before);
    return this.select(function() {
        return this.insertBefore(create.apply(this, arguments), select.apply(this, arguments) || null);
    });
}


function $c6131c6be792e7b3$var$remove() {
    var parent = this.parentNode;
    if (parent) parent.removeChild(this);
}
function $c6131c6be792e7b3$export$2e2bcd8739ae039() {
    return this.each($c6131c6be792e7b3$var$remove);
}


function $4656ee6e509af2ff$var$selection_cloneShallow() {
    var clone = this.cloneNode(false), parent = this.parentNode;
    return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
}
function $4656ee6e509af2ff$var$selection_cloneDeep() {
    var clone = this.cloneNode(true), parent = this.parentNode;
    return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
}
function $4656ee6e509af2ff$export$2e2bcd8739ae039(deep) {
    return this.select(deep ? $4656ee6e509af2ff$var$selection_cloneDeep : $4656ee6e509af2ff$var$selection_cloneShallow);
}


function $1c4fb1c2bf63fbd9$export$2e2bcd8739ae039(value) {
    return arguments.length ? this.property("__data__", value) : this.node().__data__;
}


function $b491f8f830be3d4e$var$contextListener(listener) {
    return function(event) {
        listener.call(this, event, this.__data__);
    };
}
function $b491f8f830be3d4e$var$parseTypenames(typenames) {
    return typenames.trim().split(/^|\s+/).map(function(t) {
        var name = "", i = t.indexOf(".");
        if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
        return {
            type: t,
            name: name
        };
    });
}
function $b491f8f830be3d4e$var$onRemove(typename) {
    return function() {
        var on = this.__on;
        if (!on) return;
        for(var j = 0, i = -1, m = on.length, o; j < m; ++j)if (o = on[j], (!typename.type || o.type === typename.type) && o.name === typename.name) this.removeEventListener(o.type, o.listener, o.options);
        else on[++i] = o;
        if (++i) on.length = i;
        else delete this.__on;
    };
}
function $b491f8f830be3d4e$var$onAdd(typename, value, options) {
    return function() {
        var on = this.__on, o, listener = $b491f8f830be3d4e$var$contextListener(value);
        if (on) {
            for(var j = 0, m = on.length; j < m; ++j)if ((o = on[j]).type === typename.type && o.name === typename.name) {
                this.removeEventListener(o.type, o.listener, o.options);
                this.addEventListener(o.type, o.listener = listener, o.options = options);
                o.value = value;
                return;
            }
        }
        this.addEventListener(typename.type, listener, options);
        o = {
            type: typename.type,
            name: typename.name,
            value: value,
            listener: listener,
            options: options
        };
        if (!on) this.__on = [
            o
        ];
        else on.push(o);
    };
}
function $b491f8f830be3d4e$export$2e2bcd8739ae039(typename, value, options) {
    var typenames = $b491f8f830be3d4e$var$parseTypenames(typename + ""), i, n = typenames.length, t;
    if (arguments.length < 2) {
        var on = this.node().__on;
        if (on) for(var j = 0, m = on.length, o; j < m; ++j)for(i = 0, o = on[j]; i < n; ++i){
            if ((t = typenames[i]).type === o.type && t.name === o.name) return o.value;
        }
        return;
    }
    on = value ? $b491f8f830be3d4e$var$onAdd : $b491f8f830be3d4e$var$onRemove;
    for(i = 0; i < n; ++i)this.each(on(typenames[i], value, options));
    return this;
}



function $5f31b9c0c74e9455$var$dispatchEvent(node, type, params) {
    var window = (0, $03d0bd94a0abcfc0$export$2e2bcd8739ae039)(node), event = window.CustomEvent;
    if (typeof event === "function") event = new event(type, params);
    else {
        event = window.document.createEvent("Event");
        if (params) event.initEvent(type, params.bubbles, params.cancelable), event.detail = params.detail;
        else event.initEvent(type, false, false);
    }
    node.dispatchEvent(event);
}
function $5f31b9c0c74e9455$var$dispatchConstant(type, params) {
    return function() {
        return $5f31b9c0c74e9455$var$dispatchEvent(this, type, params);
    };
}
function $5f31b9c0c74e9455$var$dispatchFunction(type, params) {
    return function() {
        return $5f31b9c0c74e9455$var$dispatchEvent(this, type, params.apply(this, arguments));
    };
}
function $5f31b9c0c74e9455$export$2e2bcd8739ae039(type, params) {
    return this.each((typeof params === "function" ? $5f31b9c0c74e9455$var$dispatchFunction : $5f31b9c0c74e9455$var$dispatchConstant)(type, params));
}


function* $c5b388afd8498271$export$2e2bcd8739ae039() {
    for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j){
        for(var group = groups[j], i = 0, n = group.length, node; i < n; ++i)if (node = group[i]) yield node;
    }
}


var $5ee876dcfa0147c8$export$e8e78c978b129247 = [
    null
];
function $5ee876dcfa0147c8$export$52baac22726c72bf(groups, parents) {
    this._groups = groups;
    this._parents = parents;
}
function $5ee876dcfa0147c8$var$selection() {
    return new $5ee876dcfa0147c8$export$52baac22726c72bf([
        [
            document.documentElement
        ]
    ], $5ee876dcfa0147c8$export$e8e78c978b129247);
}
function $5ee876dcfa0147c8$var$selection_selection() {
    return this;
}
$5ee876dcfa0147c8$export$52baac22726c72bf.prototype = $5ee876dcfa0147c8$var$selection.prototype = {
    constructor: $5ee876dcfa0147c8$export$52baac22726c72bf,
    select: (0, $6e65955f79079aac$export$2e2bcd8739ae039),
    selectAll: (0, $5b2fd909604f10f3$export$2e2bcd8739ae039),
    selectChild: (0, $8132d11a19a03025$export$2e2bcd8739ae039),
    selectChildren: (0, $b97bff92e99b7031$export$2e2bcd8739ae039),
    filter: (0, $11691620a1b9b6f3$export$2e2bcd8739ae039),
    data: (0, $fa01014096277d5b$export$2e2bcd8739ae039),
    enter: (0, $0a4874e9bcdc1edd$export$2e2bcd8739ae039),
    exit: (0, $16be99442c0246d0$export$2e2bcd8739ae039),
    join: (0, $d9cc84a431584add$export$2e2bcd8739ae039),
    merge: (0, $f9060e557903e758$export$2e2bcd8739ae039),
    selection: $5ee876dcfa0147c8$var$selection_selection,
    order: (0, $f8823586b00e037d$export$2e2bcd8739ae039),
    sort: (0, $5e05d26d7c04223a$export$2e2bcd8739ae039),
    call: (0, $c7413215d90e2c7d$export$2e2bcd8739ae039),
    nodes: (0, $db72d7def4dc0333$export$2e2bcd8739ae039),
    node: (0, $8cc608ee6d80c00b$export$2e2bcd8739ae039),
    size: (0, $12ca944a7a79ad63$export$2e2bcd8739ae039),
    empty: (0, $c44a7c34daa3e930$export$2e2bcd8739ae039),
    each: (0, $6d31764592e39758$export$2e2bcd8739ae039),
    attr: (0, $d10e1c52ed08c9bc$export$2e2bcd8739ae039),
    style: (0, $d73e6e38f360be26$export$2e2bcd8739ae039),
    property: (0, $d50bd1b80c636f84$export$2e2bcd8739ae039),
    classed: (0, $d6f575d6de457295$export$2e2bcd8739ae039),
    text: (0, $6c68f3a3157dd8aa$export$2e2bcd8739ae039),
    html: (0, $59b55b06dd39edcc$export$2e2bcd8739ae039),
    raise: (0, $aebf51fbd3d9b4e9$export$2e2bcd8739ae039),
    lower: (0, $e6fc61098a1a916c$export$2e2bcd8739ae039),
    append: (0, $24b505892b9f1144$export$2e2bcd8739ae039),
    insert: (0, $5a917efbfd15f37d$export$2e2bcd8739ae039),
    remove: (0, $c6131c6be792e7b3$export$2e2bcd8739ae039),
    clone: (0, $4656ee6e509af2ff$export$2e2bcd8739ae039),
    datum: (0, $1c4fb1c2bf63fbd9$export$2e2bcd8739ae039),
    on: (0, $b491f8f830be3d4e$export$2e2bcd8739ae039),
    dispatch: (0, $5f31b9c0c74e9455$export$2e2bcd8739ae039),
    [Symbol.iterator]: (0, $c5b388afd8498271$export$2e2bcd8739ae039)
};
var $5ee876dcfa0147c8$export$2e2bcd8739ae039 = $5ee876dcfa0147c8$var$selection;


function $d78f01d7851d977e$export$2e2bcd8739ae039(selector) {
    return typeof selector === "string" ? new (0, $5ee876dcfa0147c8$export$52baac22726c72bf)([
        [
            document.querySelector(selector)
        ]
    ], [
        document.documentElement
    ]) : new (0, $5ee876dcfa0147c8$export$52baac22726c72bf)([
        [
            selector
        ]
    ], (0, $5ee876dcfa0147c8$export$e8e78c978b129247));
}



const $1cf039670900e257$var$getFullWidth = (elem)=>Math.max(elem.offsetWidth, elem.scrollWidth);
const $1cf039670900e257$var$getFullHeight = (elem)=>Math.max(elem.offsetHeight, elem.scrollHeight);
const $1cf039670900e257$var$textNodeFromPoint = (element, x, y)=>{
    const nodes = element.childNodes;
    const range = document.createRange();
    for(let i = 0; i < nodes.length; i++){
        const node = nodes[i];
        if (node.nodeType !== 3) continue;
        range.selectNodeContents(node);
        const rect = range.getBoundingClientRect();
        if (x >= rect.left && y >= rect.top && x <= rect.right && y <= rect.bottom) return node;
    }
    return false;
};
const $1cf039670900e257$var$clearTextSelection = ()=>{
    const selection = window.getSelection ? window.getSelection() : document.selection;
    if (!selection) return;
    if (selection.removeAllRanges) selection.removeAllRanges();
    else if (selection.empty) selection.empty();
};
const $1cf039670900e257$var$CLICK_EVENT_THRESHOLD_PX = 5;
class $1cf039670900e257$export$2e2bcd8739ae039 {
    /**
     * Create ScrollBooster instance
     * @param {Object} options - options object
     * @param {Element} options.viewport - container element
     * @param {Element} options.content - scrollable content element
     * @param {String} options.direction - scroll direction
     * @param {String} options.pointerMode - mouse or touch support
     * @param {String} options.scrollMode - predefined scrolling technique
     * @param {Boolean} options.bounce - bounce effect
     * @param {Number} options.bounceForce - bounce effect factor
     * @param {Number} options.friction - scroll friction factor
     * @param {Boolean} options.textSelection - enables text selection
     * @param {Boolean} options.inputsFocus - enables focus on input elements
     * @param {Boolean} options.emulateScroll - enables mousewheel emulation
     * @param {Function} options.onClick - click handler
     * @param {Function} options.onUpdate - state update handler
     * @param {Function} options.onWheel - wheel handler
     * @param {Function} options.shouldScroll - predicate to allow or disable scroll
     */ constructor(options = {}){
        const defaults = {
            content: options.viewport.children[0],
            direction: "all",
            pointerMode: "all",
            scrollMode: undefined,
            bounce: true,
            bounceForce: 0.1,
            friction: 0.05,
            textSelection: false,
            inputsFocus: true,
            emulateScroll: false,
            preventDefaultOnEmulateScroll: false,
            preventPointerMoveDefault: true,
            lockScrollOnDragDirection: false,
            pointerDownPreventDefault: true,
            dragDirectionTolerance: 40,
            onPointerDown () {},
            onPointerUp () {},
            onPointerMove () {},
            onClick () {},
            onUpdate () {},
            onWheel () {},
            shouldScroll () {
                return true;
            }
        };
        this.props = {
            ...defaults,
            ...options
        };
        if (!this.props.viewport || !(this.props.viewport instanceof Element)) {
            console.error(`ScrollBooster init error: "viewport" config property must be present and must be Element`);
            return;
        }
        if (!this.props.content) {
            console.error(`ScrollBooster init error: Viewport does not have any content`);
            return;
        }
        this.isDragging = false;
        this.isTargetScroll = false;
        this.isScrolling = false;
        this.isRunning = false;
        const START_COORDINATES = {
            x: 0,
            y: 0
        };
        this.position = {
            ...START_COORDINATES
        };
        this.velocity = {
            ...START_COORDINATES
        };
        this.dragStartPosition = {
            ...START_COORDINATES
        };
        this.dragOffset = {
            ...START_COORDINATES
        };
        this.clientOffset = {
            ...START_COORDINATES
        };
        this.dragPosition = {
            ...START_COORDINATES
        };
        this.targetPosition = {
            ...START_COORDINATES
        };
        this.scrollOffset = {
            ...START_COORDINATES
        };
        this.rafID = null;
        this.events = {};
        this.updateMetrics();
        this.handleEvents();
    }
    /**
     * Update options object with new given values
     */ updateOptions(options = {}) {
        this.props = {
            ...this.props,
            ...options
        };
        this.props.onUpdate(this.getState());
        this.startAnimationLoop();
    }
    /**
     * Update DOM container elements metrics (width and height)
     */ updateMetrics() {
        this.viewport = {
            width: this.props.viewport.clientWidth,
            height: this.props.viewport.clientHeight
        };
        this.content = {
            width: $1cf039670900e257$var$getFullWidth(this.props.content),
            height: $1cf039670900e257$var$getFullHeight(this.props.content)
        };
        this.edgeX = {
            from: Math.min(-this.content.width + this.viewport.width, 0),
            to: 0
        };
        this.edgeY = {
            from: Math.min(-this.content.height + this.viewport.height, 0),
            to: 0
        };
        this.props.onUpdate(this.getState());
        this.startAnimationLoop();
    }
    /**
     * Run animation loop
     */ startAnimationLoop() {
        this.isRunning = true;
        cancelAnimationFrame(this.rafID);
        this.rafID = requestAnimationFrame(()=>this.animate());
    }
    /**
     * Main animation loop
     */ animate() {
        if (!this.isRunning) return;
        this.updateScrollPosition();
        // stop animation loop if nothing moves
        if (!this.isMoving()) {
            this.isRunning = false;
            this.isTargetScroll = false;
        }
        const state = this.getState();
        this.setContentPosition(state);
        this.props.onUpdate(state);
        this.rafID = requestAnimationFrame(()=>this.animate());
    }
    /**
     * Calculate and set new scroll position
     */ updateScrollPosition() {
        this.applyEdgeForce();
        this.applyDragForce();
        this.applyScrollForce();
        this.applyTargetForce();
        const inverseFriction = 1 - this.props.friction;
        this.velocity.x *= inverseFriction;
        this.velocity.y *= inverseFriction;
        if (this.props.direction !== "vertical") this.position.x += this.velocity.x;
        if (this.props.direction !== "horizontal") this.position.y += this.velocity.y;
        // disable bounce effect
        if ((!this.props.bounce || this.isScrolling) && !this.isTargetScroll) {
            this.position.x = Math.max(Math.min(this.position.x, this.edgeX.to), this.edgeX.from);
            this.position.y = Math.max(Math.min(this.position.y, this.edgeY.to), this.edgeY.from);
        }
    }
    /**
     * Increase general scroll velocity by given force amount
     */ applyForce(force) {
        this.velocity.x += force.x;
        this.velocity.y += force.y;
    }
    /**
     * Apply force for bounce effect
     */ applyEdgeForce() {
        if (!this.props.bounce || this.isDragging) return;
        // scrolled past viewport edges
        const beyondXFrom = this.position.x < this.edgeX.from;
        const beyondXTo = this.position.x > this.edgeX.to;
        const beyondYFrom = this.position.y < this.edgeY.from;
        const beyondYTo = this.position.y > this.edgeY.to;
        const beyondX = beyondXFrom || beyondXTo;
        const beyondY = beyondYFrom || beyondYTo;
        if (!beyondX && !beyondY) return;
        const edge = {
            x: beyondXFrom ? this.edgeX.from : this.edgeX.to,
            y: beyondYFrom ? this.edgeY.from : this.edgeY.to
        };
        const distanceToEdge = {
            x: edge.x - this.position.x,
            y: edge.y - this.position.y
        };
        const force = {
            x: distanceToEdge.x * this.props.bounceForce,
            y: distanceToEdge.y * this.props.bounceForce
        };
        const restPosition = {
            x: this.position.x + (this.velocity.x + force.x) / this.props.friction,
            y: this.position.y + (this.velocity.y + force.y) / this.props.friction
        };
        if (beyondXFrom && restPosition.x >= this.edgeX.from || beyondXTo && restPosition.x <= this.edgeX.to) force.x = distanceToEdge.x * this.props.bounceForce - this.velocity.x;
        if (beyondYFrom && restPosition.y >= this.edgeY.from || beyondYTo && restPosition.y <= this.edgeY.to) force.y = distanceToEdge.y * this.props.bounceForce - this.velocity.y;
        this.applyForce({
            x: beyondX ? force.x : 0,
            y: beyondY ? force.y : 0
        });
    }
    /**
     * Apply force to move content while dragging with mouse/touch
     */ applyDragForce() {
        if (!this.isDragging) return;
        const dragVelocity = {
            x: this.dragPosition.x - this.position.x,
            y: this.dragPosition.y - this.position.y
        };
        this.applyForce({
            x: dragVelocity.x - this.velocity.x,
            y: dragVelocity.y - this.velocity.y
        });
    }
    /**
     * Apply force to emulate mouse wheel or trackpad
     */ applyScrollForce() {
        if (!this.isScrolling) return;
        this.applyForce({
            x: this.scrollOffset.x - this.velocity.x,
            y: this.scrollOffset.y - this.velocity.y
        });
        this.scrollOffset.x = 0;
        this.scrollOffset.y = 0;
    }
    /**
     * Apply force to scroll to given target coordinate
     */ applyTargetForce() {
        if (!this.isTargetScroll) return;
        this.applyForce({
            x: (this.targetPosition.x - this.position.x) * 0.08 - this.velocity.x,
            y: (this.targetPosition.y - this.position.y) * 0.08 - this.velocity.y
        });
    }
    /**
     * Check if scrolling happening
     */ isMoving() {
        return this.isDragging || this.isScrolling || Math.abs(this.velocity.x) >= 0.01 || Math.abs(this.velocity.y) >= 0.01;
    }
    /**
     * Set scroll target coordinate for smooth scroll
     */ scrollTo(position = {}) {
        this.isTargetScroll = true;
        this.targetPosition.x = -position.x || 0;
        this.targetPosition.y = -position.y || 0;
        this.startAnimationLoop();
    }
    /**
     * Manual position setting
     */ setPosition(position = {}) {
        this.velocity.x = 0;
        this.velocity.y = 0;
        this.position.x = -position.x || 0;
        this.position.y = -position.y || 0;
        this.startAnimationLoop();
    }
    /**
     * Get latest metrics and coordinates
     */ getState() {
        return {
            isMoving: this.isMoving(),
            isDragging: !!(this.dragOffset.x || this.dragOffset.y),
            position: {
                x: -this.position.x,
                y: -this.position.y
            },
            dragOffset: this.dragOffset,
            dragAngle: this.getDragAngle(this.clientOffset.x, this.clientOffset.y),
            borderCollision: {
                left: this.position.x >= this.edgeX.to,
                right: this.position.x <= this.edgeX.from,
                top: this.position.y >= this.edgeY.to,
                bottom: this.position.y <= this.edgeY.from
            }
        };
    }
    /**
     * Get drag angle (up: 180, left: -90, right: 90, down: 0)
     */ getDragAngle(x, y) {
        return Math.round(Math.atan2(x, y) * (180 / Math.PI));
    }
    /**
     * Get drag direction (horizontal or vertical)
     */ getDragDirection(angle, tolerance) {
        const absAngle = Math.abs(90 - Math.abs(angle));
        if (absAngle <= 90 - tolerance) return "horizontal";
        else return "vertical";
    }
    /**
     * Update DOM container elements metrics (width and height)
     */ setContentPosition(state) {
        if (this.props.scrollMode === "transform") this.props.content.style.transform = `translate(${-state.position.x}px, ${-state.position.y}px)`;
        if (this.props.scrollMode === "native") {
            this.props.viewport.scrollTop = state.position.y;
            this.props.viewport.scrollLeft = state.position.x;
        }
    }
    /**
     * Register all DOM events
     */ handleEvents() {
        const dragOrigin = {
            x: 0,
            y: 0
        };
        const clientOrigin = {
            x: 0,
            y: 0
        };
        let dragDirection = null;
        let wheelTimer = null;
        let isTouch = false;
        const setDragPosition = (event)=>{
            if (!this.isDragging) return;
            const eventData = isTouch ? event.touches[0] : event;
            const { pageX: pageX, pageY: pageY, clientX: clientX, clientY: clientY } = eventData;
            this.dragOffset.x = pageX - dragOrigin.x;
            this.dragOffset.y = pageY - dragOrigin.y;
            this.clientOffset.x = clientX - clientOrigin.x;
            this.clientOffset.y = clientY - clientOrigin.y;
            // get dragDirection if offset threshold is reached
            if (Math.abs(this.clientOffset.x) > 5 && !dragDirection || Math.abs(this.clientOffset.y) > 5 && !dragDirection) dragDirection = this.getDragDirection(this.getDragAngle(this.clientOffset.x, this.clientOffset.y), this.props.dragDirectionTolerance);
            // prevent scroll if not expected scroll direction
            if (this.props.lockScrollOnDragDirection && this.props.lockScrollOnDragDirection !== "all") {
                if (dragDirection === this.props.lockScrollOnDragDirection && isTouch) {
                    this.dragPosition.x = this.dragStartPosition.x + this.dragOffset.x;
                    this.dragPosition.y = this.dragStartPosition.y + this.dragOffset.y;
                } else if (!isTouch) {
                    this.dragPosition.x = this.dragStartPosition.x + this.dragOffset.x;
                    this.dragPosition.y = this.dragStartPosition.y + this.dragOffset.y;
                } else {
                    this.dragPosition.x = this.dragStartPosition.x;
                    this.dragPosition.y = this.dragStartPosition.y;
                }
            } else {
                this.dragPosition.x = this.dragStartPosition.x + this.dragOffset.x;
                this.dragPosition.y = this.dragStartPosition.y + this.dragOffset.y;
            }
        };
        this.events.pointerdown = (event)=>{
            isTouch = !!(event.touches && event.touches[0]);
            this.props.onPointerDown(this.getState(), event, isTouch);
            const eventData = isTouch ? event.touches[0] : event;
            const { pageX: pageX, pageY: pageY, clientX: clientX, clientY: clientY } = eventData;
            const { viewport: viewport } = this.props;
            const rect = viewport.getBoundingClientRect();
            // click on vertical scrollbar
            if (clientX - rect.left >= viewport.clientLeft + viewport.clientWidth) return;
            // click on horizontal scrollbar
            if (clientY - rect.top >= viewport.clientTop + viewport.clientHeight) return;
            // interaction disabled by user
            if (!this.props.shouldScroll(this.getState(), event)) return;
            // disable right mouse button scroll
            if (event.button === 2) return;
            // disable on mobile
            if (this.props.pointerMode === "mouse" && isTouch) return;
            // disable on desktop
            if (this.props.pointerMode === "touch" && !isTouch) return;
            // focus on form input elements
            const formNodes = [
                "input",
                "textarea",
                "button",
                "select",
                "label"
            ];
            if (this.props.inputsFocus && formNodes.indexOf(event.target.nodeName.toLowerCase()) > -1) return;
            // handle text selection
            if (this.props.textSelection) {
                const textNode = $1cf039670900e257$var$textNodeFromPoint(event.target, clientX, clientY);
                if (textNode) return;
                $1cf039670900e257$var$clearTextSelection();
            }
            this.isDragging = true;
            dragOrigin.x = pageX;
            dragOrigin.y = pageY;
            clientOrigin.x = clientX;
            clientOrigin.y = clientY;
            this.dragStartPosition.x = this.position.x;
            this.dragStartPosition.y = this.position.y;
            setDragPosition(event);
            this.startAnimationLoop();
            if (!isTouch && this.props.pointerDownPreventDefault) event.preventDefault();
        };
        this.events.pointermove = (event)=>{
            // prevent default scroll if scroll direction is locked
            if (event.cancelable && (this.props.lockScrollOnDragDirection === "all" || this.props.lockScrollOnDragDirection === dragDirection)) event.preventDefault();
            setDragPosition(event);
            this.props.onPointerMove(this.getState(), event, isTouch);
        };
        this.events.pointerup = (event)=>{
            this.isDragging = false;
            dragDirection = null;
            this.props.onPointerUp(this.getState(), event, isTouch);
        };
        this.events.wheel = (event)=>{
            const state = this.getState();
            if (!this.props.emulateScroll) return;
            this.velocity.x = 0;
            this.velocity.y = 0;
            this.isScrolling = true;
            this.scrollOffset.x = -event.deltaX;
            this.scrollOffset.y = -event.deltaY;
            this.props.onWheel(state, event);
            this.startAnimationLoop();
            clearTimeout(wheelTimer);
            wheelTimer = setTimeout(()=>this.isScrolling = false, 80);
            // get (trackpad) scrollDirection and prevent default events
            if (this.props.preventDefaultOnEmulateScroll && this.getDragDirection(this.getDragAngle(-event.deltaX, -event.deltaY), this.props.dragDirectionTolerance) === this.props.preventDefaultOnEmulateScroll) event.preventDefault();
        };
        this.events.scroll = ()=>{
            const { scrollLeft: scrollLeft, scrollTop: scrollTop } = this.props.viewport;
            if (Math.abs(this.position.x + scrollLeft) > 3) {
                this.position.x = -scrollLeft;
                this.velocity.x = 0;
            }
            if (Math.abs(this.position.y + scrollTop) > 3) {
                this.position.y = -scrollTop;
                this.velocity.y = 0;
            }
        };
        this.events.click = (event)=>{
            const state = this.getState();
            const dragOffsetX = this.props.direction !== "vertical" ? state.dragOffset.x : 0;
            const dragOffsetY = this.props.direction !== "horizontal" ? state.dragOffset.y : 0;
            if (Math.max(Math.abs(dragOffsetX), Math.abs(dragOffsetY)) > $1cf039670900e257$var$CLICK_EVENT_THRESHOLD_PX) {
                event.preventDefault();
                event.stopPropagation();
            }
            this.props.onClick(state, event, isTouch);
        };
        this.events.contentLoad = ()=>this.updateMetrics();
        this.events.resize = ()=>this.updateMetrics();
        this.props.viewport.addEventListener("mousedown", this.events.pointerdown);
        this.props.viewport.addEventListener("touchstart", this.events.pointerdown, {
            passive: false
        });
        this.props.viewport.addEventListener("click", this.events.click);
        this.props.viewport.addEventListener("wheel", this.events.wheel, {
            passive: false
        });
        this.props.viewport.addEventListener("scroll", this.events.scroll);
        this.props.content.addEventListener("load", this.events.contentLoad, true);
        window.addEventListener("mousemove", this.events.pointermove);
        window.addEventListener("touchmove", this.events.pointermove, {
            passive: false
        });
        window.addEventListener("mouseup", this.events.pointerup);
        window.addEventListener("touchend", this.events.pointerup);
        window.addEventListener("resize", this.events.resize);
    }
    /**
     * Unregister all DOM events
     */ destroy() {
        this.props.viewport.removeEventListener("mousedown", this.events.pointerdown);
        this.props.viewport.removeEventListener("touchstart", this.events.pointerdown);
        this.props.viewport.removeEventListener("click", this.events.click);
        this.props.viewport.removeEventListener("wheel", this.events.wheel);
        this.props.viewport.removeEventListener("scroll", this.events.scroll);
        this.props.content.removeEventListener("load", this.events.contentLoad);
        window.removeEventListener("mousemove", this.events.pointermove);
        window.removeEventListener("touchmove", this.events.pointermove);
        window.removeEventListener("mouseup", this.events.pointerup);
        window.removeEventListener("touchend", this.events.pointerup);
        window.removeEventListener("resize", this.events.resize);
    }
}




function $4eee8f3e49a380ba$export$2e2bcd8739ae039(selector) {
    return typeof selector === "string" ? new (0, $5ee876dcfa0147c8$export$52baac22726c72bf)([
        document.querySelectorAll(selector)
    ], [
        document.documentElement
    ]) : new (0, $5ee876dcfa0147c8$export$52baac22726c72bf)([
        (0, $28888b58f4a29961$export$2e2bcd8739ae039)(selector)
    ], (0, $5ee876dcfa0147c8$export$e8e78c978b129247));
}


function $68d1f4605b868e5f$var$responseJson(response) {
    if (!response.ok) throw new Error(response.status + " " + response.statusText);
    if (response.status === 204 || response.status === 205) return;
    return response.json();
}
function $68d1f4605b868e5f$export$2e2bcd8739ae039(input, init) {
    return fetch(input, init).then($68d1f4605b868e5f$var$responseJson);
}



var $161e663aadb86456$var$noop = {
    value: ()=>{}
};
function $161e663aadb86456$var$dispatch() {
    for(var i = 0, n = arguments.length, _ = {}, t; i < n; ++i){
        if (!(t = arguments[i] + "") || t in _ || /[\s.]/.test(t)) throw new Error("illegal type: " + t);
        _[t] = [];
    }
    return new $161e663aadb86456$var$Dispatch(_);
}
function $161e663aadb86456$var$Dispatch(_) {
    this._ = _;
}
function $161e663aadb86456$var$parseTypenames(typenames, types) {
    return typenames.trim().split(/^|\s+/).map(function(t) {
        var name = "", i = t.indexOf(".");
        if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
        if (t && !types.hasOwnProperty(t)) throw new Error("unknown type: " + t);
        return {
            type: t,
            name: name
        };
    });
}
$161e663aadb86456$var$Dispatch.prototype = $161e663aadb86456$var$dispatch.prototype = {
    constructor: $161e663aadb86456$var$Dispatch,
    on: function(typename, callback) {
        var _ = this._, T = $161e663aadb86456$var$parseTypenames(typename + "", _), t, i = -1, n = T.length;
        // If no callback was specified, return the callback of the given type and name.
        if (arguments.length < 2) {
            while(++i < n)if ((t = (typename = T[i]).type) && (t = $161e663aadb86456$var$get(_[t], typename.name))) return t;
            return;
        }
        // If a type was specified, set the callback for the given type and name.
        // Otherwise, if a null callback was specified, remove callbacks of the given name.
        if (callback != null && typeof callback !== "function") throw new Error("invalid callback: " + callback);
        while(++i < n){
            if (t = (typename = T[i]).type) _[t] = $161e663aadb86456$var$set(_[t], typename.name, callback);
            else if (callback == null) for(t in _)_[t] = $161e663aadb86456$var$set(_[t], typename.name, null);
        }
        return this;
    },
    copy: function() {
        var copy = {}, _ = this._;
        for(var t in _)copy[t] = _[t].slice();
        return new $161e663aadb86456$var$Dispatch(copy);
    },
    call: function(type, that) {
        if ((n = arguments.length - 2) > 0) for(var args = new Array(n), i = 0, n, t; i < n; ++i)args[i] = arguments[i + 2];
        if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
        for(t = this._[type], i = 0, n = t.length; i < n; ++i)t[i].value.apply(that, args);
    },
    apply: function(type, that, args) {
        if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
        for(var t = this._[type], i = 0, n = t.length; i < n; ++i)t[i].value.apply(that, args);
    }
};
function $161e663aadb86456$var$get(type, name) {
    for(var i = 0, n = type.length, c; i < n; ++i){
        if ((c = type[i]).name === name) return c.value;
    }
}
function $161e663aadb86456$var$set(type, name, callback) {
    for(var i = 0, n = type.length; i < n; ++i)if (type[i].name === name) {
        type[i] = $161e663aadb86456$var$noop, type = type.slice(0, i).concat(type.slice(i + 1));
        break;
    }
    if (callback != null) type.push({
        name: name,
        value: callback
    });
    return type;
}
var $161e663aadb86456$export$2e2bcd8739ae039 = $161e663aadb86456$var$dispatch;


var $b50daf6e64833af1$var$frame = 0, $b50daf6e64833af1$var$timeout = 0, $b50daf6e64833af1$var$interval = 0, $b50daf6e64833af1$var$pokeDelay = 1000, $b50daf6e64833af1$var$taskHead, $b50daf6e64833af1$var$taskTail, $b50daf6e64833af1$var$clockLast = 0, $b50daf6e64833af1$var$clockNow = 0, $b50daf6e64833af1$var$clockSkew = 0, $b50daf6e64833af1$var$clock = typeof performance === "object" && performance.now ? performance : Date, $b50daf6e64833af1$var$setFrame = typeof window === "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(f) {
    setTimeout(f, 17);
};
function $b50daf6e64833af1$export$461939dd4422153() {
    return $b50daf6e64833af1$var$clockNow || ($b50daf6e64833af1$var$setFrame($b50daf6e64833af1$var$clearNow), $b50daf6e64833af1$var$clockNow = $b50daf6e64833af1$var$clock.now() + $b50daf6e64833af1$var$clockSkew);
}
function $b50daf6e64833af1$var$clearNow() {
    $b50daf6e64833af1$var$clockNow = 0;
}
function $b50daf6e64833af1$export$c57e9b2d8b9e4de() {
    this._call = this._time = this._next = null;
}
$b50daf6e64833af1$export$c57e9b2d8b9e4de.prototype = $b50daf6e64833af1$export$9dc4ecf953986f04.prototype = {
    constructor: $b50daf6e64833af1$export$c57e9b2d8b9e4de,
    restart: function(callback, delay, time) {
        if (typeof callback !== "function") throw new TypeError("callback is not a function");
        time = (time == null ? $b50daf6e64833af1$export$461939dd4422153() : +time) + (delay == null ? 0 : +delay);
        if (!this._next && $b50daf6e64833af1$var$taskTail !== this) {
            if ($b50daf6e64833af1$var$taskTail) $b50daf6e64833af1$var$taskTail._next = this;
            else $b50daf6e64833af1$var$taskHead = this;
            $b50daf6e64833af1$var$taskTail = this;
        }
        this._call = callback;
        this._time = time;
        $b50daf6e64833af1$var$sleep();
    },
    stop: function() {
        if (this._call) {
            this._call = null;
            this._time = Infinity;
            $b50daf6e64833af1$var$sleep();
        }
    }
};
function $b50daf6e64833af1$export$9dc4ecf953986f04(callback, delay, time) {
    var t = new $b50daf6e64833af1$export$c57e9b2d8b9e4de;
    t.restart(callback, delay, time);
    return t;
}
function $b50daf6e64833af1$export$d60154c1d7f3990e() {
    $b50daf6e64833af1$export$461939dd4422153(); // Get the current time, if not already set.
    ++$b50daf6e64833af1$var$frame; // Pretend we’ve set an alarm, if we haven’t already.
    var t = $b50daf6e64833af1$var$taskHead, e;
    while(t){
        if ((e = $b50daf6e64833af1$var$clockNow - t._time) >= 0) t._call.call(undefined, e);
        t = t._next;
    }
    --$b50daf6e64833af1$var$frame;
}
function $b50daf6e64833af1$var$wake() {
    $b50daf6e64833af1$var$clockNow = ($b50daf6e64833af1$var$clockLast = $b50daf6e64833af1$var$clock.now()) + $b50daf6e64833af1$var$clockSkew;
    $b50daf6e64833af1$var$frame = $b50daf6e64833af1$var$timeout = 0;
    try {
        $b50daf6e64833af1$export$d60154c1d7f3990e();
    } finally{
        $b50daf6e64833af1$var$frame = 0;
        $b50daf6e64833af1$var$nap();
        $b50daf6e64833af1$var$clockNow = 0;
    }
}
function $b50daf6e64833af1$var$poke() {
    var now = $b50daf6e64833af1$var$clock.now(), delay = now - $b50daf6e64833af1$var$clockLast;
    if (delay > $b50daf6e64833af1$var$pokeDelay) $b50daf6e64833af1$var$clockSkew -= delay, $b50daf6e64833af1$var$clockLast = now;
}
function $b50daf6e64833af1$var$nap() {
    var t0, t1 = $b50daf6e64833af1$var$taskHead, t2, time = Infinity;
    while(t1)if (t1._call) {
        if (time > t1._time) time = t1._time;
        t0 = t1, t1 = t1._next;
    } else {
        t2 = t1._next, t1._next = null;
        t1 = t0 ? t0._next = t2 : $b50daf6e64833af1$var$taskHead = t2;
    }
    $b50daf6e64833af1$var$taskTail = t0;
    $b50daf6e64833af1$var$sleep(time);
}
function $b50daf6e64833af1$var$sleep(time) {
    if ($b50daf6e64833af1$var$frame) return; // Soonest alarm already set, or will be.
    if ($b50daf6e64833af1$var$timeout) $b50daf6e64833af1$var$timeout = clearTimeout($b50daf6e64833af1$var$timeout);
    var delay = time - $b50daf6e64833af1$var$clockNow; // Strictly less than if we recomputed clockNow.
    if (delay > 24) {
        if (time < Infinity) $b50daf6e64833af1$var$timeout = setTimeout($b50daf6e64833af1$var$wake, time - $b50daf6e64833af1$var$clock.now() - $b50daf6e64833af1$var$clockSkew);
        if ($b50daf6e64833af1$var$interval) $b50daf6e64833af1$var$interval = clearInterval($b50daf6e64833af1$var$interval);
    } else {
        if (!$b50daf6e64833af1$var$interval) $b50daf6e64833af1$var$clockLast = $b50daf6e64833af1$var$clock.now(), $b50daf6e64833af1$var$interval = setInterval($b50daf6e64833af1$var$poke, $b50daf6e64833af1$var$pokeDelay);
        $b50daf6e64833af1$var$frame = 1, $b50daf6e64833af1$var$setFrame($b50daf6e64833af1$var$wake);
    }
}


function $7c11dd1287da4df4$export$2e2bcd8739ae039(callback, delay, time) {
    var t = new (0, $b50daf6e64833af1$export$c57e9b2d8b9e4de);
    delay = delay == null ? 0 : +delay;
    t.restart((elapsed)=>{
        t.stop();
        callback(elapsed + delay);
    }, delay, time);
    return t;
}


var $3a551dcc03e81635$var$emptyOn = (0, $161e663aadb86456$export$2e2bcd8739ae039)("start", "end", "cancel", "interrupt");
var $3a551dcc03e81635$var$emptyTween = [];
var $3a551dcc03e81635$export$ff39ebd4bb12b718 = 0;
var $3a551dcc03e81635$export$584530fe98d14a84 = 1;
var $3a551dcc03e81635$export$a5d151aee16efd42 = 2;
var $3a551dcc03e81635$export$fb935ab5849a0db9 = 3;
var $3a551dcc03e81635$export$1573e22b087389af = 4;
var $3a551dcc03e81635$export$a2e792214ded83b2 = 5;
var $3a551dcc03e81635$export$9d38167254403955 = 6;
function $3a551dcc03e81635$export$2e2bcd8739ae039(node, name, id, index, group, timing) {
    var schedules = node.__transition;
    if (!schedules) node.__transition = {};
    else if (id in schedules) return;
    $3a551dcc03e81635$var$create(node, id, {
        name: name,
        index: index,
        group: group,
        on: $3a551dcc03e81635$var$emptyOn,
        tween: $3a551dcc03e81635$var$emptyTween,
        time: timing.time,
        delay: timing.delay,
        duration: timing.duration,
        ease: timing.ease,
        timer: null,
        state: $3a551dcc03e81635$export$ff39ebd4bb12b718
    });
}
function $3a551dcc03e81635$export$2cd8252107eb640b(node, id) {
    var schedule = $3a551dcc03e81635$export$3988ae62b71be9a3(node, id);
    if (schedule.state > $3a551dcc03e81635$export$ff39ebd4bb12b718) throw new Error("too late; already scheduled");
    return schedule;
}
function $3a551dcc03e81635$export$adaa4cf7ef1b65be(node, id) {
    var schedule = $3a551dcc03e81635$export$3988ae62b71be9a3(node, id);
    if (schedule.state > $3a551dcc03e81635$export$fb935ab5849a0db9) throw new Error("too late; already running");
    return schedule;
}
function $3a551dcc03e81635$export$3988ae62b71be9a3(node, id) {
    var schedule = node.__transition;
    if (!schedule || !(schedule = schedule[id])) throw new Error("transition not found");
    return schedule;
}
function $3a551dcc03e81635$var$create(node, id, self) {
    var schedules = node.__transition, tween;
    // Initialize the self timer when the transition is created.
    // Note the actual delay is not known until the first callback!
    schedules[id] = self;
    self.timer = (0, $b50daf6e64833af1$export$9dc4ecf953986f04)(schedule, 0, self.time);
    function schedule(elapsed) {
        self.state = $3a551dcc03e81635$export$584530fe98d14a84;
        self.timer.restart(start, self.delay, self.time);
        // If the elapsed delay is less than our first sleep, start immediately.
        if (self.delay <= elapsed) start(elapsed - self.delay);
    }
    function start(elapsed) {
        var i, j, n, o;
        // If the state is not SCHEDULED, then we previously errored on start.
        if (self.state !== $3a551dcc03e81635$export$584530fe98d14a84) return stop();
        for(i in schedules){
            o = schedules[i];
            if (o.name !== self.name) continue;
            // While this element already has a starting transition during this frame,
            // defer starting an interrupting transition until that transition has a
            // chance to tick (and possibly end); see d3/d3-transition#54!
            if (o.state === $3a551dcc03e81635$export$fb935ab5849a0db9) return (0, $7c11dd1287da4df4$export$2e2bcd8739ae039)(start);
            // Interrupt the active transition, if any.
            if (o.state === $3a551dcc03e81635$export$1573e22b087389af) {
                o.state = $3a551dcc03e81635$export$9d38167254403955;
                o.timer.stop();
                o.on.call("interrupt", node, node.__data__, o.index, o.group);
                delete schedules[i];
            } else if (+i < id) {
                o.state = $3a551dcc03e81635$export$9d38167254403955;
                o.timer.stop();
                o.on.call("cancel", node, node.__data__, o.index, o.group);
                delete schedules[i];
            }
        }
        // Defer the first tick to end of the current frame; see d3/d3#1576.
        // Note the transition may be canceled after start and before the first tick!
        // Note this must be scheduled before the start event; see d3/d3-transition#16!
        // Assuming this is successful, subsequent callbacks go straight to tick.
        (0, $7c11dd1287da4df4$export$2e2bcd8739ae039)(function() {
            if (self.state === $3a551dcc03e81635$export$fb935ab5849a0db9) {
                self.state = $3a551dcc03e81635$export$1573e22b087389af;
                self.timer.restart(tick, self.delay, self.time);
                tick(elapsed);
            }
        });
        // Dispatch the start event.
        // Note this must be done before the tween are initialized.
        self.state = $3a551dcc03e81635$export$a5d151aee16efd42;
        self.on.call("start", node, node.__data__, self.index, self.group);
        if (self.state !== $3a551dcc03e81635$export$a5d151aee16efd42) return; // interrupted
        self.state = $3a551dcc03e81635$export$fb935ab5849a0db9;
        // Initialize the tween, deleting null tween.
        tween = new Array(n = self.tween.length);
        for(i = 0, j = -1; i < n; ++i)if (o = self.tween[i].value.call(node, node.__data__, self.index, self.group)) tween[++j] = o;
        tween.length = j + 1;
    }
    function tick(elapsed) {
        var t = elapsed < self.duration ? self.ease.call(null, elapsed / self.duration) : (self.timer.restart(stop), self.state = $3a551dcc03e81635$export$a2e792214ded83b2, 1), i = -1, n = tween.length;
        while(++i < n)tween[i].call(node, t);
        // Dispatch the end event.
        if (self.state === $3a551dcc03e81635$export$a2e792214ded83b2) {
            self.on.call("end", node, node.__data__, self.index, self.group);
            stop();
        }
    }
    function stop() {
        self.state = $3a551dcc03e81635$export$9d38167254403955;
        self.timer.stop();
        delete schedules[id];
        for(var i in schedules)return; // eslint-disable-line no-unused-vars
        delete node.__transition;
    }
}


function $d1b38f63ac288224$export$2e2bcd8739ae039(node, name) {
    var schedules = node.__transition, schedule, active, empty = true, i;
    if (!schedules) return;
    name = name == null ? null : name + "";
    for(i in schedules){
        if ((schedule = schedules[i]).name !== name) {
            empty = false;
            continue;
        }
        active = schedule.state > (0, $3a551dcc03e81635$export$a5d151aee16efd42) && schedule.state < (0, $3a551dcc03e81635$export$a2e792214ded83b2);
        schedule.state = (0, $3a551dcc03e81635$export$9d38167254403955);
        schedule.timer.stop();
        schedule.on.call(active ? "interrupt" : "cancel", node, node.__data__, schedule.index, schedule.group);
        delete schedules[i];
    }
    if (empty) delete node.__transition;
}


function $c79b4eea03e189f3$export$2e2bcd8739ae039(name) {
    return this.each(function() {
        (0, $d1b38f63ac288224$export$2e2bcd8739ae039)(this, name);
    });
}



function $d9f27e55086f64c0$export$2e2bcd8739ae039(a, b) {
    return a = +a, b = +b, function(t) {
        return a * (1 - t) + b * t;
    };
}


var $ece57fed703a7f55$var$degrees = 180 / Math.PI;
var $ece57fed703a7f55$export$f0954fd7d5368655 = {
    translateX: 0,
    translateY: 0,
    rotate: 0,
    skewX: 0,
    scaleX: 1,
    scaleY: 1
};
function $ece57fed703a7f55$export$2e2bcd8739ae039(a, b, c, d, e, f) {
    var scaleX, scaleY, skewX;
    if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
    if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
    if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
    if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
    return {
        translateX: e,
        translateY: f,
        rotate: Math.atan2(b, a) * $ece57fed703a7f55$var$degrees,
        skewX: Math.atan(skewX) * $ece57fed703a7f55$var$degrees,
        scaleX: scaleX,
        scaleY: scaleY
    };
}


var $41d54dd0d6e5ea72$var$svgNode;
function $41d54dd0d6e5ea72$export$59ad369bf4938177(value) {
    const m = new (typeof DOMMatrix === "function" ? DOMMatrix : WebKitCSSMatrix)(value + "");
    return m.isIdentity ? (0, $ece57fed703a7f55$export$f0954fd7d5368655) : (0, $ece57fed703a7f55$export$2e2bcd8739ae039)(m.a, m.b, m.c, m.d, m.e, m.f);
}
function $41d54dd0d6e5ea72$export$f9ef43f9a1d89a18(value) {
    if (value == null) return 0, $ece57fed703a7f55$export$f0954fd7d5368655;
    if (!$41d54dd0d6e5ea72$var$svgNode) $41d54dd0d6e5ea72$var$svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
    $41d54dd0d6e5ea72$var$svgNode.setAttribute("transform", value);
    if (!(value = $41d54dd0d6e5ea72$var$svgNode.transform.baseVal.consolidate())) return 0, $ece57fed703a7f55$export$f0954fd7d5368655;
    value = value.matrix;
    return (0, $ece57fed703a7f55$export$2e2bcd8739ae039)(value.a, value.b, value.c, value.d, value.e, value.f);
}


function $4a83b814dfbd16ef$var$interpolateTransform(parse, pxComma, pxParen, degParen) {
    function pop(s) {
        return s.length ? s.pop() + " " : "";
    }
    function translate(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push("translate(", null, pxComma, null, pxParen);
            q.push({
                i: i - 4,
                x: (0, $d9f27e55086f64c0$export$2e2bcd8739ae039)(xa, xb)
            }, {
                i: i - 2,
                x: (0, $d9f27e55086f64c0$export$2e2bcd8739ae039)(ya, yb)
            });
        } else if (xb || yb) s.push("translate(" + xb + pxComma + yb + pxParen);
    }
    function rotate(a, b, s, q) {
        if (a !== b) {
            if (a - b > 180) b += 360;
            else if (b - a > 180) a += 360; // shortest path
            q.push({
                i: s.push(pop(s) + "rotate(", null, degParen) - 2,
                x: (0, $d9f27e55086f64c0$export$2e2bcd8739ae039)(a, b)
            });
        } else if (b) s.push(pop(s) + "rotate(" + b + degParen);
    }
    function skewX(a, b, s, q) {
        if (a !== b) q.push({
            i: s.push(pop(s) + "skewX(", null, degParen) - 2,
            x: (0, $d9f27e55086f64c0$export$2e2bcd8739ae039)(a, b)
        });
        else if (b) s.push(pop(s) + "skewX(" + b + degParen);
    }
    function scale(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push(pop(s) + "scale(", null, ",", null, ")");
            q.push({
                i: i - 4,
                x: (0, $d9f27e55086f64c0$export$2e2bcd8739ae039)(xa, xb)
            }, {
                i: i - 2,
                x: (0, $d9f27e55086f64c0$export$2e2bcd8739ae039)(ya, yb)
            });
        } else if (xb !== 1 || yb !== 1) s.push(pop(s) + "scale(" + xb + "," + yb + ")");
    }
    return function(a, b) {
        var s = [], q = []; // number interpolators
        a = parse(a), b = parse(b);
        translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
        rotate(a.rotate, b.rotate, s, q);
        skewX(a.skewX, b.skewX, s, q);
        scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
        a = b = null; // gc
        return function(t) {
            var i = -1, n = q.length, o;
            while(++i < n)s[(o = q[i]).i] = o.x(t);
            return s.join("");
        };
    };
}
var $4a83b814dfbd16ef$export$56bec7123bb3589a = $4a83b814dfbd16ef$var$interpolateTransform((0, $41d54dd0d6e5ea72$export$59ad369bf4938177), "px, ", "px)", "deg)");
var $4a83b814dfbd16ef$export$da8cba906d64c082 = $4a83b814dfbd16ef$var$interpolateTransform((0, $41d54dd0d6e5ea72$export$f9ef43f9a1d89a18), ", ", ")", ")");




function $69dc71fad5cf9173$var$tweenRemove(id, name) {
    var tween0, tween1;
    return function() {
        var schedule = (0, $3a551dcc03e81635$export$adaa4cf7ef1b65be)(this, id), tween = schedule.tween;
        // If this node shared tween with the previous node,
        // just assign the updated shared tween and we’re done!
        // Otherwise, copy-on-write.
        if (tween !== tween0) {
            tween1 = tween0 = tween;
            for(var i = 0, n = tween1.length; i < n; ++i)if (tween1[i].name === name) {
                tween1 = tween1.slice();
                tween1.splice(i, 1);
                break;
            }
        }
        schedule.tween = tween1;
    };
}
function $69dc71fad5cf9173$var$tweenFunction(id, name, value) {
    var tween0, tween1;
    if (typeof value !== "function") throw new Error;
    return function() {
        var schedule = (0, $3a551dcc03e81635$export$adaa4cf7ef1b65be)(this, id), tween = schedule.tween;
        // If this node shared tween with the previous node,
        // just assign the updated shared tween and we’re done!
        // Otherwise, copy-on-write.
        if (tween !== tween0) {
            tween1 = (tween0 = tween).slice();
            for(var t = {
                name: name,
                value: value
            }, i = 0, n = tween1.length; i < n; ++i)if (tween1[i].name === name) {
                tween1[i] = t;
                break;
            }
            if (i === n) tween1.push(t);
        }
        schedule.tween = tween1;
    };
}
function $69dc71fad5cf9173$export$2e2bcd8739ae039(name, value) {
    var id = this._id;
    name += "";
    if (arguments.length < 2) {
        var tween = (0, $3a551dcc03e81635$export$3988ae62b71be9a3)(this.node(), id).tween;
        for(var i = 0, n = tween.length, t; i < n; ++i){
            if ((t = tween[i]).name === name) return t.value;
        }
        return null;
    }
    return this.each((value == null ? $69dc71fad5cf9173$var$tweenRemove : $69dc71fad5cf9173$var$tweenFunction)(id, name, value));
}
function $69dc71fad5cf9173$export$f78ce6ab10405d82(transition, name, value) {
    var id = transition._id;
    transition.each(function() {
        var schedule = (0, $3a551dcc03e81635$export$adaa4cf7ef1b65be)(this, id);
        (schedule.value || (schedule.value = {}))[name] = value.apply(this, arguments);
    });
    return function(node) {
        return (0, $3a551dcc03e81635$export$3988ae62b71be9a3)(node, id).value[name];
    };
}



var $1tQWc = parcelRequire("1tQWc");

var $1tQWc = parcelRequire("1tQWc");
function $e81fa1172944234a$export$4e41033bfeec1a4c(t1, v0, v1, v2, v3) {
    var t2 = t1 * t1, t3 = t2 * t1;
    return ((1 - 3 * t1 + 3 * t2 - t3) * v0 + (4 - 6 * t2 + 3 * t3) * v1 + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2 + t3 * v3) / 6;
}
function $e81fa1172944234a$export$2e2bcd8739ae039(values) {
    var n = values.length - 1;
    return function(t) {
        var i = t <= 0 ? t = 0 : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n), v1 = values[i], v2 = values[i + 1], v0 = i > 0 ? values[i - 1] : 2 * v1 - v2, v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
        return $e81fa1172944234a$export$4e41033bfeec1a4c((t - i / n) * n, v0, v1, v2, v3);
    };
}



function $838b1762decf7fe9$export$2e2bcd8739ae039(values) {
    var n = values.length;
    return function(t) {
        var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n), v0 = values[(i + n - 1) % n], v1 = values[i % n], v2 = values[(i + 1) % n], v3 = values[(i + 2) % n];
        return (0, $e81fa1172944234a$export$4e41033bfeec1a4c)((t - i / n) * n, v0, v1, v2, v3);
    };
}


var $ea3d5457baf78b6a$export$2e2bcd8739ae039 = (x)=>()=>x;


function $60d0a75f48d588f4$var$linear(a, d) {
    return function(t) {
        return a + t * d;
    };
}
function $60d0a75f48d588f4$var$exponential(a, b, y) {
    return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
        return Math.pow(a + t * b, y);
    };
}
function $60d0a75f48d588f4$export$97d7b0c7ddb78dcf(a, b) {
    var d = b - a;
    return d ? $60d0a75f48d588f4$var$linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : (0, $ea3d5457baf78b6a$export$2e2bcd8739ae039)(isNaN(a) ? b : a);
}
function $60d0a75f48d588f4$export$a7ebe8cc6aaf8d37(y) {
    return (y = +y) === 1 ? $60d0a75f48d588f4$export$2e2bcd8739ae039 : function(a, b) {
        return b - a ? $60d0a75f48d588f4$var$exponential(a, b, y) : (0, $ea3d5457baf78b6a$export$2e2bcd8739ae039)(isNaN(a) ? b : a);
    };
}
function $60d0a75f48d588f4$export$2e2bcd8739ae039(a, b) {
    var d = b - a;
    return d ? $60d0a75f48d588f4$var$linear(a, d) : (0, $ea3d5457baf78b6a$export$2e2bcd8739ae039)(isNaN(a) ? b : a);
}


var $fa6c794a4958fdf6$export$2e2bcd8739ae039 = function rgbGamma(y) {
    var color = (0, $60d0a75f48d588f4$export$a7ebe8cc6aaf8d37)(y);
    function rgb(start, end) {
        var r = color((start = (0, $1tQWc.rgb)(start)).r, (end = (0, $1tQWc.rgb)(end)).r), g = color(start.g, end.g), b = color(start.b, end.b), opacity = (0, $60d0a75f48d588f4$export$2e2bcd8739ae039)(start.opacity, end.opacity);
        return function(t) {
            start.r = r(t);
            start.g = g(t);
            start.b = b(t);
            start.opacity = opacity(t);
            return start + "";
        };
    }
    rgb.gamma = rgbGamma;
    return rgb;
}(1);
function $fa6c794a4958fdf6$var$rgbSpline(spline) {
    return function(colors) {
        var n = colors.length, r = new Array(n), g = new Array(n), b = new Array(n), i, color;
        for(i = 0; i < n; ++i){
            color = (0, $1tQWc.rgb)(colors[i]);
            r[i] = color.r || 0;
            g[i] = color.g || 0;
            b[i] = color.b || 0;
        }
        r = spline(r);
        g = spline(g);
        b = spline(b);
        color.opacity = 1;
        return function(t) {
            color.r = r(t);
            color.g = g(t);
            color.b = b(t);
            return color + "";
        };
    };
}
var $fa6c794a4958fdf6$export$2c0e28f2e2852d3f = $fa6c794a4958fdf6$var$rgbSpline((0, $e81fa1172944234a$export$2e2bcd8739ae039));
var $fa6c794a4958fdf6$export$53d5214f625ccd4c = $fa6c794a4958fdf6$var$rgbSpline((0, $838b1762decf7fe9$export$2e2bcd8739ae039));


var $1ef9a1579573abd1$var$reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, $1ef9a1579573abd1$var$reB = new RegExp($1ef9a1579573abd1$var$reA.source, "g");
function $1ef9a1579573abd1$var$zero(b) {
    return function() {
        return b;
    };
}
function $1ef9a1579573abd1$var$one(b) {
    return function(t) {
        return b(t) + "";
    };
}
function $1ef9a1579573abd1$export$2e2bcd8739ae039(a, b) {
    var bi = $1ef9a1579573abd1$var$reA.lastIndex = $1ef9a1579573abd1$var$reB.lastIndex = 0, am, bm, bs, i = -1, s = [], q = []; // number interpolators
    // Coerce inputs to strings.
    a = a + "", b = b + "";
    // Interpolate pairs of numbers in a & b.
    while((am = $1ef9a1579573abd1$var$reA.exec(a)) && (bm = $1ef9a1579573abd1$var$reB.exec(b))){
        if ((bs = bm.index) > bi) {
            bs = b.slice(bi, bs);
            if (s[i]) s[i] += bs; // coalesce with previous string
            else s[++i] = bs;
        }
        if ((am = am[0]) === (bm = bm[0])) {
            if (s[i]) s[i] += bm; // coalesce with previous string
            else s[++i] = bm;
        } else {
            s[++i] = null;
            q.push({
                i: i,
                x: (0, $d9f27e55086f64c0$export$2e2bcd8739ae039)(am, bm)
            });
        }
        bi = $1ef9a1579573abd1$var$reB.lastIndex;
    }
    // Add remains of b.
    if (bi < b.length) {
        bs = b.slice(bi);
        if (s[i]) s[i] += bs; // coalesce with previous string
        else s[++i] = bs;
    }
    // Special optimization for only a single match.
    // Otherwise, interpolate each of the numbers and rejoin the string.
    return s.length < 2 ? q[0] ? $1ef9a1579573abd1$var$one(q[0].x) : $1ef9a1579573abd1$var$zero(b) : (b = q.length, function(t) {
        for(var i = 0, o; i < b; ++i)s[(o = q[i]).i] = o.x(t);
        return s.join("");
    });
}


function $601f2aa08822a5a5$export$2e2bcd8739ae039(a, b) {
    var c;
    return (typeof b === "number" ? (0, $d9f27e55086f64c0$export$2e2bcd8739ae039) : b instanceof (0, $1tQWc.default) ? (0, $fa6c794a4958fdf6$export$2e2bcd8739ae039) : (c = (0, $1tQWc.default)(b)) ? (b = c, $fa6c794a4958fdf6$export$2e2bcd8739ae039) : (0, $1ef9a1579573abd1$export$2e2bcd8739ae039))(a, b);
}


function $c5a6618ef8170a60$var$attrRemove(name) {
    return function() {
        this.removeAttribute(name);
    };
}
function $c5a6618ef8170a60$var$attrRemoveNS(fullname) {
    return function() {
        this.removeAttributeNS(fullname.space, fullname.local);
    };
}
function $c5a6618ef8170a60$var$attrConstant(name, interpolate, value1) {
    var string00, string1 = value1 + "", interpolate0;
    return function() {
        var string0 = this.getAttribute(name);
        return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
    };
}
function $c5a6618ef8170a60$var$attrConstantNS(fullname, interpolate, value1) {
    var string00, string1 = value1 + "", interpolate0;
    return function() {
        var string0 = this.getAttributeNS(fullname.space, fullname.local);
        return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
    };
}
function $c5a6618ef8170a60$var$attrFunction(name, interpolate, value) {
    var string00, string10, interpolate0;
    return function() {
        var string0, value1 = value(this), string1;
        if (value1 == null) return void this.removeAttribute(name);
        string0 = this.getAttribute(name);
        string1 = value1 + "";
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
    };
}
function $c5a6618ef8170a60$var$attrFunctionNS(fullname, interpolate, value) {
    var string00, string10, interpolate0;
    return function() {
        var string0, value1 = value(this), string1;
        if (value1 == null) return void this.removeAttributeNS(fullname.space, fullname.local);
        string0 = this.getAttributeNS(fullname.space, fullname.local);
        string1 = value1 + "";
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
    };
}
function $c5a6618ef8170a60$export$2e2bcd8739ae039(name, value) {
    var fullname = (0, $cf3406a48b514514$export$2e2bcd8739ae039)(name), i = fullname === "transform" ? (0, $4a83b814dfbd16ef$export$da8cba906d64c082) : (0, $601f2aa08822a5a5$export$2e2bcd8739ae039);
    return this.attrTween(name, typeof value === "function" ? (fullname.local ? $c5a6618ef8170a60$var$attrFunctionNS : $c5a6618ef8170a60$var$attrFunction)(fullname, i, (0, $69dc71fad5cf9173$export$f78ce6ab10405d82)(this, "attr." + name, value)) : value == null ? (fullname.local ? $c5a6618ef8170a60$var$attrRemoveNS : $c5a6618ef8170a60$var$attrRemove)(fullname) : (fullname.local ? $c5a6618ef8170a60$var$attrConstantNS : $c5a6618ef8170a60$var$attrConstant)(fullname, i, value));
}



function $e0fa2c829d5769ff$var$attrInterpolate(name, i) {
    return function(t) {
        this.setAttribute(name, i.call(this, t));
    };
}
function $e0fa2c829d5769ff$var$attrInterpolateNS(fullname, i) {
    return function(t) {
        this.setAttributeNS(fullname.space, fullname.local, i.call(this, t));
    };
}
function $e0fa2c829d5769ff$var$attrTweenNS(fullname, value) {
    var t0, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t0 = (i0 = i) && $e0fa2c829d5769ff$var$attrInterpolateNS(fullname, i);
        return t0;
    }
    tween._value = value;
    return tween;
}
function $e0fa2c829d5769ff$var$attrTween(name, value) {
    var t0, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t0 = (i0 = i) && $e0fa2c829d5769ff$var$attrInterpolate(name, i);
        return t0;
    }
    tween._value = value;
    return tween;
}
function $e0fa2c829d5769ff$export$2e2bcd8739ae039(name, value) {
    var key = "attr." + name;
    if (arguments.length < 2) return (key = this.tween(key)) && key._value;
    if (value == null) return this.tween(key, null);
    if (typeof value !== "function") throw new Error;
    var fullname = (0, $cf3406a48b514514$export$2e2bcd8739ae039)(name);
    return this.tween(key, (fullname.local ? $e0fa2c829d5769ff$var$attrTweenNS : $e0fa2c829d5769ff$var$attrTween)(fullname, value));
}



function $e75315ab9f71ffa1$var$delayFunction(id, value) {
    return function() {
        (0, $3a551dcc03e81635$export$2cd8252107eb640b)(this, id).delay = +value.apply(this, arguments);
    };
}
function $e75315ab9f71ffa1$var$delayConstant(id, value) {
    return value = +value, function() {
        (0, $3a551dcc03e81635$export$2cd8252107eb640b)(this, id).delay = value;
    };
}
function $e75315ab9f71ffa1$export$2e2bcd8739ae039(value) {
    var id = this._id;
    return arguments.length ? this.each((typeof value === "function" ? $e75315ab9f71ffa1$var$delayFunction : $e75315ab9f71ffa1$var$delayConstant)(id, value)) : (0, $3a551dcc03e81635$export$3988ae62b71be9a3)(this.node(), id).delay;
}



function $fd4601adec21e231$var$durationFunction(id, value) {
    return function() {
        (0, $3a551dcc03e81635$export$adaa4cf7ef1b65be)(this, id).duration = +value.apply(this, arguments);
    };
}
function $fd4601adec21e231$var$durationConstant(id, value) {
    return value = +value, function() {
        (0, $3a551dcc03e81635$export$adaa4cf7ef1b65be)(this, id).duration = value;
    };
}
function $fd4601adec21e231$export$2e2bcd8739ae039(value) {
    var id = this._id;
    return arguments.length ? this.each((typeof value === "function" ? $fd4601adec21e231$var$durationFunction : $fd4601adec21e231$var$durationConstant)(id, value)) : (0, $3a551dcc03e81635$export$3988ae62b71be9a3)(this.node(), id).duration;
}



function $0c6dd0c38f95c212$var$easeConstant(id, value) {
    if (typeof value !== "function") throw new Error;
    return function() {
        (0, $3a551dcc03e81635$export$adaa4cf7ef1b65be)(this, id).ease = value;
    };
}
function $0c6dd0c38f95c212$export$2e2bcd8739ae039(value) {
    var id = this._id;
    return arguments.length ? this.each($0c6dd0c38f95c212$var$easeConstant(id, value)) : (0, $3a551dcc03e81635$export$3988ae62b71be9a3)(this.node(), id).ease;
}



function $cda09fe7936d73f4$var$easeVarying(id, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (typeof v !== "function") throw new Error;
        (0, $3a551dcc03e81635$export$adaa4cf7ef1b65be)(this, id).ease = v;
    };
}
function $cda09fe7936d73f4$export$2e2bcd8739ae039(value) {
    if (typeof value !== "function") throw new Error;
    return this.each($cda09fe7936d73f4$var$easeVarying(this._id, value));
}




function $9ae41052279dd25b$export$2e2bcd8739ae039(match) {
    if (typeof match !== "function") match = (0, $690aac15e1c8d9ce$export$2e2bcd8739ae039)(match);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i)if ((node = group[i]) && match.call(node, node.__data__, i, group)) subgroup.push(node);
    }
    return new (0, $b9c043d1df5cab70$export$be58926105124dd4)(subgroups, this._parents, this._name, this._id);
}



function $70b093623528c735$export$2e2bcd8739ae039(transition) {
    if (transition._id !== this._id) throw new Error;
    for(var groups0 = this._groups, groups1 = transition._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j){
        for(var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group0[i] || group1[i]) merge[i] = node;
    }
    for(; j < m0; ++j)merges[j] = groups0[j];
    return new (0, $b9c043d1df5cab70$export$be58926105124dd4)(merges, this._parents, this._name, this._id);
}



function $de2c0a82b7be865f$var$start(name) {
    return (name + "").trim().split(/^|\s+/).every(function(t) {
        var i = t.indexOf(".");
        if (i >= 0) t = t.slice(0, i);
        return !t || t === "start";
    });
}
function $de2c0a82b7be865f$var$onFunction(id, name, listener) {
    var on0, on1, sit = $de2c0a82b7be865f$var$start(name) ? (0, $3a551dcc03e81635$export$2cd8252107eb640b) : (0, $3a551dcc03e81635$export$adaa4cf7ef1b65be);
    return function() {
        var schedule = sit(this, id), on = schedule.on;
        // If this node shared a dispatch with the previous node,
        // just assign the updated shared dispatch and we’re done!
        // Otherwise, copy-on-write.
        if (on !== on0) (on1 = (on0 = on).copy()).on(name, listener);
        schedule.on = on1;
    };
}
function $de2c0a82b7be865f$export$2e2bcd8739ae039(name, listener) {
    var id = this._id;
    return arguments.length < 2 ? (0, $3a551dcc03e81635$export$3988ae62b71be9a3)(this.node(), id).on.on(name) : this.each($de2c0a82b7be865f$var$onFunction(id, name, listener));
}


function $aa8db08d844ce813$var$removeFunction(id) {
    return function() {
        var parent = this.parentNode;
        for(var i in this.__transition)if (+i !== id) return;
        if (parent) parent.removeChild(this);
    };
}
function $aa8db08d844ce813$export$2e2bcd8739ae039() {
    return this.on("end.remove", $aa8db08d844ce813$var$removeFunction(this._id));
}





function $1c32ba1ba4d12b29$export$2e2bcd8739ae039(select) {
    var name = this._name, id = this._id;
    if (typeof select !== "function") select = (0, $e0cd4f805ce7da13$export$2e2bcd8739ae039)(select);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i)if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
            if ("__data__" in node) subnode.__data__ = node.__data__;
            subgroup[i] = subnode;
            (0, $3a551dcc03e81635$export$2e2bcd8739ae039)(subgroup[i], name, id, i, subgroup, (0, $3a551dcc03e81635$export$3988ae62b71be9a3)(node, id));
        }
    }
    return new (0, $b9c043d1df5cab70$export$be58926105124dd4)(subgroups, this._parents, name, id);
}





function $e25761f97d011e01$export$2e2bcd8739ae039(select) {
    var name = this._name, id = this._id;
    if (typeof select !== "function") select = (0, $429453331e7e2a58$export$2e2bcd8739ae039)(select);
    for(var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
            for(var children = select.call(node, node.__data__, i, group), child, inherit = (0, $3a551dcc03e81635$export$3988ae62b71be9a3)(node, id), k = 0, l = children.length; k < l; ++k)if (child = children[k]) (0, $3a551dcc03e81635$export$2e2bcd8739ae039)(child, name, id, k, children, inherit);
            subgroups.push(children);
            parents.push(node);
        }
    }
    return new (0, $b9c043d1df5cab70$export$be58926105124dd4)(subgroups, parents, name, id);
}



var $843ea3d2638a67c1$var$Selection = (0, $5ee876dcfa0147c8$export$2e2bcd8739ae039).prototype.constructor;
function $843ea3d2638a67c1$export$2e2bcd8739ae039() {
    return new $843ea3d2638a67c1$var$Selection(this._groups, this._parents);
}







function $cd897f4b3bc73b18$var$styleNull(name, interpolate) {
    var string00, string10, interpolate0;
    return function() {
        var string0 = (0, $d73e6e38f360be26$export$5e3cec964f0b5efd)(this, name), string1 = (this.style.removeProperty(name), (0, $d73e6e38f360be26$export$5e3cec964f0b5efd)(this, name));
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : interpolate0 = interpolate(string00 = string0, string10 = string1);
    };
}
function $cd897f4b3bc73b18$var$styleRemove(name) {
    return function() {
        this.style.removeProperty(name);
    };
}
function $cd897f4b3bc73b18$var$styleConstant(name, interpolate, value1) {
    var string00, string1 = value1 + "", interpolate0;
    return function() {
        var string0 = (0, $d73e6e38f360be26$export$5e3cec964f0b5efd)(this, name);
        return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
    };
}
function $cd897f4b3bc73b18$var$styleFunction(name, interpolate, value) {
    var string00, string10, interpolate0;
    return function() {
        var string0 = (0, $d73e6e38f360be26$export$5e3cec964f0b5efd)(this, name), value1 = value(this), string1 = value1 + "";
        if (value1 == null) string1 = value1 = (this.style.removeProperty(name), (0, $d73e6e38f360be26$export$5e3cec964f0b5efd)(this, name));
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
    };
}
function $cd897f4b3bc73b18$var$styleMaybeRemove(id, name) {
    var on0, on1, listener0, key = "style." + name, event = "end." + key, remove;
    return function() {
        var schedule = (0, $3a551dcc03e81635$export$adaa4cf7ef1b65be)(this, id), on = schedule.on, listener = schedule.value[key] == null ? remove || (remove = $cd897f4b3bc73b18$var$styleRemove(name)) : undefined;
        // If this node shared a dispatch with the previous node,
        // just assign the updated shared dispatch and we’re done!
        // Otherwise, copy-on-write.
        if (on !== on0 || listener0 !== listener) (on1 = (on0 = on).copy()).on(event, listener0 = listener);
        schedule.on = on1;
    };
}
function $cd897f4b3bc73b18$export$2e2bcd8739ae039(name, value, priority) {
    var i = (name += "") === "transform" ? (0, $4a83b814dfbd16ef$export$56bec7123bb3589a) : (0, $601f2aa08822a5a5$export$2e2bcd8739ae039);
    return value == null ? this.styleTween(name, $cd897f4b3bc73b18$var$styleNull(name, i)).on("end.style." + name, $cd897f4b3bc73b18$var$styleRemove(name)) : typeof value === "function" ? this.styleTween(name, $cd897f4b3bc73b18$var$styleFunction(name, i, (0, $69dc71fad5cf9173$export$f78ce6ab10405d82)(this, "style." + name, value))).each($cd897f4b3bc73b18$var$styleMaybeRemove(this._id, name)) : this.styleTween(name, $cd897f4b3bc73b18$var$styleConstant(name, i, value), priority).on("end.style." + name, null);
}


function $e6db1179d79e5bab$var$styleInterpolate(name, i, priority) {
    return function(t) {
        this.style.setProperty(name, i.call(this, t), priority);
    };
}
function $e6db1179d79e5bab$var$styleTween(name, value, priority) {
    var t, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t = (i0 = i) && $e6db1179d79e5bab$var$styleInterpolate(name, i, priority);
        return t;
    }
    tween._value = value;
    return tween;
}
function $e6db1179d79e5bab$export$2e2bcd8739ae039(name, value, priority) {
    var key = "style." + (name += "");
    if (arguments.length < 2) return (key = this.tween(key)) && key._value;
    if (value == null) return this.tween(key, null);
    if (typeof value !== "function") throw new Error;
    return this.tween(key, $e6db1179d79e5bab$var$styleTween(name, value, priority == null ? "" : priority));
}



function $3ae970976a4f52d3$var$textConstant(value) {
    return function() {
        this.textContent = value;
    };
}
function $3ae970976a4f52d3$var$textFunction(value) {
    return function() {
        var value1 = value(this);
        this.textContent = value1 == null ? "" : value1;
    };
}
function $3ae970976a4f52d3$export$2e2bcd8739ae039(value) {
    return this.tween("text", typeof value === "function" ? $3ae970976a4f52d3$var$textFunction((0, $69dc71fad5cf9173$export$f78ce6ab10405d82)(this, "text", value)) : $3ae970976a4f52d3$var$textConstant(value == null ? "" : value + ""));
}


function $415495db16f138ba$var$textInterpolate(i) {
    return function(t) {
        this.textContent = i.call(this, t);
    };
}
function $415495db16f138ba$var$textTween(value) {
    var t0, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t0 = (i0 = i) && $415495db16f138ba$var$textInterpolate(i);
        return t0;
    }
    tween._value = value;
    return tween;
}
function $415495db16f138ba$export$2e2bcd8739ae039(value) {
    var key = "text";
    if (arguments.length < 1) return (key = this.tween(key)) && key._value;
    if (value == null) return this.tween(key, null);
    if (typeof value !== "function") throw new Error;
    return this.tween(key, $415495db16f138ba$var$textTween(value));
}




function $1b5c73f14e1e26f2$export$2e2bcd8739ae039() {
    var name = this._name, id0 = this._id, id1 = (0, $b9c043d1df5cab70$export$9ffd10a3fbdc175b)();
    for(var groups = this._groups, m = groups.length, j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
            var inherit = (0, $3a551dcc03e81635$export$3988ae62b71be9a3)(node, id0);
            (0, $3a551dcc03e81635$export$2e2bcd8739ae039)(node, name, id1, i, group, {
                time: inherit.time + inherit.delay + inherit.duration,
                delay: 0,
                duration: inherit.duration,
                ease: inherit.ease
            });
        }
    }
    return new (0, $b9c043d1df5cab70$export$be58926105124dd4)(groups, this._parents, name, id1);
}




function $12cb42595b5abd3a$export$2e2bcd8739ae039() {
    var on0, on1, that = this, id = that._id, size = that.size();
    return new Promise(function(resolve, reject) {
        var cancel = {
            value: reject
        }, end = {
            value: function() {
                if (--size === 0) resolve();
            }
        };
        that.each(function() {
            var schedule = (0, $3a551dcc03e81635$export$adaa4cf7ef1b65be)(this, id), on = schedule.on;
            // If this node shared a dispatch with the previous node,
            // just assign the updated shared dispatch and we’re done!
            // Otherwise, copy-on-write.
            if (on !== on0) {
                on1 = (on0 = on).copy();
                on1._.cancel.push(cancel);
                on1._.interrupt.push(cancel);
                on1._.end.push(end);
            }
            schedule.on = on1;
        });
        // The selection was empty, resolve end immediately
        if (size === 0) resolve();
    });
}


var $b9c043d1df5cab70$var$id = 0;
function $b9c043d1df5cab70$export$be58926105124dd4(groups, parents, name, id) {
    this._groups = groups;
    this._parents = parents;
    this._name = name;
    this._id = id;
}
function $b9c043d1df5cab70$export$2e2bcd8739ae039(name) {
    return (0, $5ee876dcfa0147c8$export$2e2bcd8739ae039)().transition(name);
}
function $b9c043d1df5cab70$export$9ffd10a3fbdc175b() {
    return ++$b9c043d1df5cab70$var$id;
}
var $b9c043d1df5cab70$var$selection_prototype = (0, $5ee876dcfa0147c8$export$2e2bcd8739ae039).prototype;
$b9c043d1df5cab70$export$be58926105124dd4.prototype = $b9c043d1df5cab70$export$2e2bcd8739ae039.prototype = {
    constructor: $b9c043d1df5cab70$export$be58926105124dd4,
    select: (0, $1c32ba1ba4d12b29$export$2e2bcd8739ae039),
    selectAll: (0, $e25761f97d011e01$export$2e2bcd8739ae039),
    selectChild: $b9c043d1df5cab70$var$selection_prototype.selectChild,
    selectChildren: $b9c043d1df5cab70$var$selection_prototype.selectChildren,
    filter: (0, $9ae41052279dd25b$export$2e2bcd8739ae039),
    merge: (0, $70b093623528c735$export$2e2bcd8739ae039),
    selection: (0, $843ea3d2638a67c1$export$2e2bcd8739ae039),
    transition: (0, $1b5c73f14e1e26f2$export$2e2bcd8739ae039),
    call: $b9c043d1df5cab70$var$selection_prototype.call,
    nodes: $b9c043d1df5cab70$var$selection_prototype.nodes,
    node: $b9c043d1df5cab70$var$selection_prototype.node,
    size: $b9c043d1df5cab70$var$selection_prototype.size,
    empty: $b9c043d1df5cab70$var$selection_prototype.empty,
    each: $b9c043d1df5cab70$var$selection_prototype.each,
    on: (0, $de2c0a82b7be865f$export$2e2bcd8739ae039),
    attr: (0, $c5a6618ef8170a60$export$2e2bcd8739ae039),
    attrTween: (0, $e0fa2c829d5769ff$export$2e2bcd8739ae039),
    style: (0, $cd897f4b3bc73b18$export$2e2bcd8739ae039),
    styleTween: (0, $e6db1179d79e5bab$export$2e2bcd8739ae039),
    text: (0, $3ae970976a4f52d3$export$2e2bcd8739ae039),
    textTween: (0, $415495db16f138ba$export$2e2bcd8739ae039),
    remove: (0, $aa8db08d844ce813$export$2e2bcd8739ae039),
    tween: (0, $69dc71fad5cf9173$export$2e2bcd8739ae039),
    delay: (0, $e75315ab9f71ffa1$export$2e2bcd8739ae039),
    duration: (0, $fd4601adec21e231$export$2e2bcd8739ae039),
    ease: (0, $0c6dd0c38f95c212$export$2e2bcd8739ae039),
    easeVarying: (0, $cda09fe7936d73f4$export$2e2bcd8739ae039),
    end: (0, $12cb42595b5abd3a$export$2e2bcd8739ae039),
    [Symbol.iterator]: $b9c043d1df5cab70$var$selection_prototype[Symbol.iterator]
};



function $85b6f5cfc6aacf4f$export$b1a09cb1b71f86aa(t) {
    return t * t * t;
}
function $85b6f5cfc6aacf4f$export$68d528839c701b6(t) {
    return --t * t * t + 1;
}
function $85b6f5cfc6aacf4f$export$89238d3bc79d3ada(t) {
    return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
}



var $fc114e40e8ef0ae6$var$defaultTiming = {
    time: null,
    delay: 0,
    duration: 250,
    ease: (0, $85b6f5cfc6aacf4f$export$89238d3bc79d3ada)
};
function $fc114e40e8ef0ae6$var$inherit(node, id) {
    var timing;
    while(!(timing = node.__transition) || !(timing = timing[id])){
        if (!(node = node.parentNode)) throw new Error(`transition ${id} not found`);
    }
    return timing;
}
function $fc114e40e8ef0ae6$export$2e2bcd8739ae039(name) {
    var id, timing;
    if (name instanceof (0, $b9c043d1df5cab70$export$be58926105124dd4)) id = name._id, name = name._name;
    else id = (0, $b9c043d1df5cab70$export$9ffd10a3fbdc175b)(), (timing = $fc114e40e8ef0ae6$var$defaultTiming).time = (0, $b50daf6e64833af1$export$461939dd4422153)(), name = name == null ? null : name + "";
    for(var groups = this._groups, m = groups.length, j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) (0, $3a551dcc03e81635$export$2e2bcd8739ae039)(node, name, id, i, group, timing || $fc114e40e8ef0ae6$var$inherit(node, id));
    }
    return new (0, $b9c043d1df5cab70$export$be58926105124dd4)(groups, this._parents, name, id);
}


(0, $5ee876dcfa0147c8$export$2e2bcd8739ae039).prototype.interrupt = (0, $c79b4eea03e189f3$export$2e2bcd8739ae039);
(0, $5ee876dcfa0147c8$export$2e2bcd8739ae039).prototype.transition = (0, $fc114e40e8ef0ae6$export$2e2bcd8739ae039);









var $dnPBs = parcelRequire("dnPBs");

var $5ewvA = parcelRequire("5ewvA");

var $gYLTL = parcelRequire("gYLTL");

var $j5Ozl = parcelRequire("j5Ozl");
// import * as d3 from "d3";

var $838c0014826b39ce$exports = {};
$838c0014826b39ce$exports = JSON.parse('{"name":"leaflet","version":"1.9.4","homepage":"https://leafletjs.com/","description":"JavaScript library for mobile-friendly interactive maps","devDependencies":{"@mapbox/eslint-plugin-script-tags":"^1.0.0","@rollup/plugin-json":"^4.1.0","bundlemon":"^1.4.0","eslint":"^8.23.0","eslint-config-mourner":"^2.0.3","git-rev-sync":"^3.0.2","happen":"~0.3.2","husky":"^8.0.1","karma":"^6.4.0","karma-chrome-launcher":"^3.1.1","karma-edge-launcher":"^0.4.2","karma-expect":"^1.1.3","karma-firefox-launcher":"^2.1.2","karma-ie-launcher":"^1.0.0","karma-mocha":"^2.0.1","karma-rollup-preprocessor":"^7.0.8","karma-safari-launcher":"~1.0.0","karma-sinon":"^1.0.5","leafdoc":"^2.3.0","lint-staged":"^13.0.3","mocha":"^9.2.2","prosthetic-hand":"^1.4.0","rollup":"^2.78.1","rollup-plugin-git-version":"^0.3.1","sinon":"^7.5.0","ssri":"^9.0.1","uglify-js":"^3.17.0"},"main":"dist/leaflet-src.js","style":"dist/leaflet.css","files":["dist","src","!dist/leaflet.zip","!*.leafdoc","CHANGELOG.md"],"scripts":{"docs":"node ./build/docs.js && node ./build/integrity.js","test":"karma start ./spec/karma.conf.js","build":"npm run rollup && npm run uglify","lint":"eslint .","lintfix":"npm run lint -- --fix","rollup":"rollup -c build/rollup-config.js","watch":"rollup -w -c build/rollup-config.js","uglify":"uglifyjs dist/leaflet-src.js -c -m -o dist/leaflet.js --source-map filename=dist/leaflet.js.map --source-map content=dist/leaflet-src.js.map --source-map url=leaflet.js.map --comments","bundlemon":"bundlemon --subProject js --defaultCompression none && bundlemon --subProject js-gzip --defaultCompression gzip","serve":"cd docs && bundle exec jekyll serve","prepare":"husky install"},"eslintConfig":{"ignorePatterns":["dist","debug","docs/docs/highlight","docs/examples/choropleth/us-states.js","docs/examples/geojson/sample-geojson.js","docs/examples/map-panes/eu-countries.js","docs/examples/extending/extending-2-layers.md","docs/_posts/2012*","docs/_site","build/integrity.js"],"root":true,"env":{"commonjs":true,"amd":true,"node":false},"extends":"mourner","plugins":["@mapbox/eslint-plugin-script-tags"],"parserOptions":{"ecmaVersion":6,"sourceType":"module"},"rules":{"linebreak-style":[0,"unix"],"no-mixed-spaces-and-tabs":[2,"smart-tabs"],"indent":[2,"tab",{"VariableDeclarator":0,"flatTernaryExpressions":true}],"curly":2,"spaced-comment":2,"strict":0,"wrap-iife":0,"key-spacing":0,"consistent-return":0,"no-unused-expressions":["error",{"allowShortCircuit":true}]},"overrides":[{"files":["build/**/*"],"env":{"node":true},"rules":{"global-require":0}},{"files":["*.md"],"rules":{"eol-last":0,"no-unused-vars":0}}]},"repository":{"type":"git","url":"git://github.com/Leaflet/Leaflet.git"},"keywords":["gis","map"],"license":"BSD-2-Clause","lint-staged":{"*.(js|md)":"eslint --cache --fix"}}');


/*
 * @namespace Util
 *
 * Various utility functions, used by Leaflet internally.
 */ // @function extend(dest: Object, src?: Object): Object
// Merges the properties of the `src` object (or multiple objects) into `dest` object and returns the latter. Has an `L.extend` shortcut.
function $13bbd556cd7cee10$export$8b58be045bf06082(dest) {
    var i, j, len, src;
    for(j = 1, len = arguments.length; j < len; j++){
        src = arguments[j];
        for(i in src)dest[i] = src[i];
    }
    return dest;
}
var $13bbd556cd7cee10$export$185802fd694ee1f5 = Object.create || function() {
    function F() {}
    return function(proto) {
        F.prototype = proto;
        return new F();
    };
}();
function $13bbd556cd7cee10$export$2385a24977818dd0(fn, obj) {
    var slice = Array.prototype.slice;
    if (fn.bind) return fn.bind.apply(fn, slice.call(arguments, 1));
    var args = slice.call(arguments, 2);
    return function() {
        return fn.apply(obj, args.length ? args.concat(slice.call(arguments)) : arguments);
    };
}
var $13bbd556cd7cee10$export$be5d847186e3cff2 = 0;
function $13bbd556cd7cee10$export$bd3fba034e28f6b(obj) {
    if (!("_leaflet_id" in obj)) obj["_leaflet_id"] = ++$13bbd556cd7cee10$export$be5d847186e3cff2;
    return obj._leaflet_id;
}
function $13bbd556cd7cee10$export$de363e709c412c8a(fn, time, context) {
    var lock, args, wrapperFn, later;
    later = function() {
        // reset lock and call if queued
        lock = false;
        if (args) {
            wrapperFn.apply(context, args);
            args = false;
        }
    };
    wrapperFn = function() {
        if (lock) // called too soon, queue to call later
        args = arguments;
        else {
            // call and lock until later
            fn.apply(context, arguments);
            setTimeout(later, time);
            lock = true;
        }
    };
    return wrapperFn;
}
function $13bbd556cd7cee10$export$f6cd9682189b118b(x, range, includeMax) {
    var max = range[1], min = range[0], d = max - min;
    return x === max && includeMax ? x : ((x - min) % d + d) % d + min;
}
function $13bbd556cd7cee10$export$a3891e81a74c5e40() {
    return false;
}
function $13bbd556cd7cee10$export$533e61f4ff7f35ce(num, precision) {
    if (precision === false) return num;
    var pow = Math.pow(10, precision === undefined ? 6 : precision);
    return Math.round(num * pow) / pow;
}
function $13bbd556cd7cee10$export$87c2784dc9fc4ab(str) {
    return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, "");
}
function $13bbd556cd7cee10$export$3ea6d3c1e1f67aaa(str) {
    return $13bbd556cd7cee10$export$87c2784dc9fc4ab(str).split(/\s+/);
}
function $13bbd556cd7cee10$export$add91eafeaeab287(obj, options) {
    if (!Object.prototype.hasOwnProperty.call(obj, "options")) obj.options = obj.options ? $13bbd556cd7cee10$export$185802fd694ee1f5(obj.options) : {};
    for(var i in options)obj.options[i] = options[i];
    return obj.options;
}
function $13bbd556cd7cee10$export$27213b73b2075e98(obj, existingUrl, uppercase) {
    var params = [];
    for(var i in obj)params.push(encodeURIComponent(uppercase ? i.toUpperCase() : i) + "=" + encodeURIComponent(obj[i]));
    return (!existingUrl || existingUrl.indexOf("?") === -1 ? "?" : "&") + params.join("&");
}
var $13bbd556cd7cee10$var$templateRe = /\{ *([\w_ -]+) *\}/g;
function $13bbd556cd7cee10$export$ce69bd05624d0c48(str, data) {
    return str.replace($13bbd556cd7cee10$var$templateRe, function(str, key) {
        var value = data[key];
        if (value === undefined) throw new Error("No value provided for variable " + str);
        else if (typeof value === "function") value = value(data);
        return value;
    });
}
var $13bbd556cd7cee10$export$43bee75e5e14138e = Array.isArray || function(obj) {
    return Object.prototype.toString.call(obj) === "[object Array]";
};
function $13bbd556cd7cee10$export$305f7d4e9d4624f2(array, el) {
    for(var i = 0; i < array.length; i++){
        if (array[i] === el) return i;
    }
    return -1;
}
var $13bbd556cd7cee10$export$993f7e5c731d5268 = "data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=";
// inspired by https://paulirish.com/2011/requestanimationframe-for-smart-animating/
function $13bbd556cd7cee10$var$getPrefixed(name) {
    return window["webkit" + name] || window["moz" + name] || window["ms" + name];
}
var $13bbd556cd7cee10$var$lastTime = 0;
// fallback for IE 7-8
function $13bbd556cd7cee10$var$timeoutDefer(fn) {
    var time = +new Date(), timeToCall = Math.max(0, 16 - (time - $13bbd556cd7cee10$var$lastTime));
    $13bbd556cd7cee10$var$lastTime = time + timeToCall;
    return window.setTimeout(fn, timeToCall);
}
var $13bbd556cd7cee10$export$2d6f2967c7dddd06 = window.requestAnimationFrame || $13bbd556cd7cee10$var$getPrefixed("RequestAnimationFrame") || $13bbd556cd7cee10$var$timeoutDefer;
var $13bbd556cd7cee10$export$e76ec94050cfc5fa = window.cancelAnimationFrame || $13bbd556cd7cee10$var$getPrefixed("CancelAnimationFrame") || $13bbd556cd7cee10$var$getPrefixed("CancelRequestAnimationFrame") || function(id) {
    window.clearTimeout(id);
};
function $13bbd556cd7cee10$export$d371ad015c199c06(fn, context, immediate) {
    if (immediate && $13bbd556cd7cee10$export$2d6f2967c7dddd06 === $13bbd556cd7cee10$var$timeoutDefer) fn.call(context);
    else return $13bbd556cd7cee10$export$2d6f2967c7dddd06.call(window, $13bbd556cd7cee10$export$2385a24977818dd0(fn, context));
}
function $13bbd556cd7cee10$export$e1ed83507f55dc9d(id) {
    if (id) $13bbd556cd7cee10$export$e76ec94050cfc5fa.call(window, id);
}


function $f8984dbaa17424d1$export$4c85e640eb41c31b() {}
$f8984dbaa17424d1$export$4c85e640eb41c31b.extend = function(props) {
    // @function extend(props: Object): Function
    // [Extends the current class](#class-inheritance) given the properties to be included.
    // Returns a Javascript function that is a class constructor (to be called with `new`).
    var NewClass = function() {
        $13bbd556cd7cee10$export$add91eafeaeab287(this);
        // call the constructor
        if (this.initialize) this.initialize.apply(this, arguments);
        // call all constructor hooks
        this.callInitHooks();
    };
    var parentProto = NewClass.__super__ = this.prototype;
    var proto = $13bbd556cd7cee10$export$185802fd694ee1f5(parentProto);
    proto.constructor = NewClass;
    NewClass.prototype = proto;
    // inherit parent's statics
    for(var i in this)if (Object.prototype.hasOwnProperty.call(this, i) && i !== "prototype" && i !== "__super__") NewClass[i] = this[i];
    // mix static properties into the class
    if (props.statics) $13bbd556cd7cee10$export$8b58be045bf06082(NewClass, props.statics);
    // mix includes into the prototype
    if (props.includes) {
        $f8984dbaa17424d1$var$checkDeprecatedMixinEvents(props.includes);
        $13bbd556cd7cee10$export$8b58be045bf06082.apply(null, [
            proto
        ].concat(props.includes));
    }
    // mix given properties into the prototype
    $13bbd556cd7cee10$export$8b58be045bf06082(proto, props);
    delete proto.statics;
    delete proto.includes;
    // merge options
    if (proto.options) {
        proto.options = parentProto.options ? $13bbd556cd7cee10$export$185802fd694ee1f5(parentProto.options) : {};
        $13bbd556cd7cee10$export$8b58be045bf06082(proto.options, props.options);
    }
    proto._initHooks = [];
    // add method for calling all hooks
    proto.callInitHooks = function() {
        if (this._initHooksCalled) return;
        if (parentProto.callInitHooks) parentProto.callInitHooks.call(this);
        this._initHooksCalled = true;
        for(var i = 0, len = proto._initHooks.length; i < len; i++)proto._initHooks[i].call(this);
    };
    return NewClass;
};
// @function include(properties: Object): this
// [Includes a mixin](#class-includes) into the current class.
$f8984dbaa17424d1$export$4c85e640eb41c31b.include = function(props) {
    var parentOptions = this.prototype.options;
    $13bbd556cd7cee10$export$8b58be045bf06082(this.prototype, props);
    if (props.options) {
        this.prototype.options = parentOptions;
        this.mergeOptions(props.options);
    }
    return this;
};
// @function mergeOptions(options: Object): this
// [Merges `options`](#class-options) into the defaults of the class.
$f8984dbaa17424d1$export$4c85e640eb41c31b.mergeOptions = function(options) {
    $13bbd556cd7cee10$export$8b58be045bf06082(this.prototype.options, options);
    return this;
};
// @function addInitHook(fn: Function): this
// Adds a [constructor hook](#class-constructor-hooks) to the class.
$f8984dbaa17424d1$export$4c85e640eb41c31b.addInitHook = function(fn) {
    var args = Array.prototype.slice.call(arguments, 1);
    var init = typeof fn === "function" ? fn : function() {
        this[fn].apply(this, args);
    };
    this.prototype._initHooks = this.prototype._initHooks || [];
    this.prototype._initHooks.push(init);
    return this;
};
function $f8984dbaa17424d1$var$checkDeprecatedMixinEvents(includes) {
    /* global L: true */ if (typeof L === "undefined" || !L || !L.Mixin) return;
    includes = $13bbd556cd7cee10$export$43bee75e5e14138e(includes) ? includes : [
        includes
    ];
    for(var i = 0; i < includes.length; i++)if (includes[i] === L.Mixin.Events) console.warn("Deprecated include of L.Mixin.Events: this property will be removed in future releases, please inherit from L.Evented instead.", new Error().stack);
}





var $ca4bf785aeb0758d$export$ada873a34909da65 = {
    /* @method on(type: String, fn: Function, context?: Object): this
	 * Adds a listener function (`fn`) to a particular event type of the object. You can optionally specify the context of the listener (object the this keyword will point to). You can also pass several space-separated types (e.g. `'click dblclick'`).
	 *
	 * @alternative
	 * @method on(eventMap: Object): this
	 * Adds a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
	 */ on: function(types, fn, context) {
        // types can be a map of types/handlers
        if (typeof types === "object") for(var type in types)// we don't process space-separated events here for performance;
        // it's a hot path since Layer uses the on(obj) syntax
        this._on(type, types[type], fn);
        else {
            // types can be a string of space-separated words
            types = $13bbd556cd7cee10$export$3ea6d3c1e1f67aaa(types);
            for(var i = 0, len = types.length; i < len; i++)this._on(types[i], fn, context);
        }
        return this;
    },
    /* @method off(type: String, fn?: Function, context?: Object): this
	 * Removes a previously added listener function. If no function is specified, it will remove all the listeners of that particular event from the object. Note that if you passed a custom context to `on`, you must pass the same context to `off` in order to remove the listener.
	 *
	 * @alternative
	 * @method off(eventMap: Object): this
	 * Removes a set of type/listener pairs.
	 *
	 * @alternative
	 * @method off: this
	 * Removes all listeners to all events on the object. This includes implicitly attached events.
	 */ off: function(types, fn, context) {
        if (!arguments.length) // clear all listeners if called without arguments
        delete this._events;
        else if (typeof types === "object") for(var type in types)this._off(type, types[type], fn);
        else {
            types = $13bbd556cd7cee10$export$3ea6d3c1e1f67aaa(types);
            var removeAll = arguments.length === 1;
            for(var i = 0, len = types.length; i < len; i++)if (removeAll) this._off(types[i]);
            else this._off(types[i], fn, context);
        }
        return this;
    },
    // attach listener (without syntactic sugar now)
    _on: function(type, fn, context, _once) {
        if (typeof fn !== "function") {
            console.warn("wrong listener type: " + typeof fn);
            return;
        }
        // check if fn already there
        if (this._listens(type, fn, context) !== false) return;
        if (context === this) // Less memory footprint.
        context = undefined;
        var newListener = {
            fn: fn,
            ctx: context
        };
        if (_once) newListener.once = true;
        this._events = this._events || {};
        this._events[type] = this._events[type] || [];
        this._events[type].push(newListener);
    },
    _off: function(type, fn, context) {
        var listeners, i, len;
        if (!this._events) return;
        listeners = this._events[type];
        if (!listeners) return;
        if (arguments.length === 1) {
            if (this._firingCount) // Set all removed listeners to noop
            // so they are not called if remove happens in fire
            for(i = 0, len = listeners.length; i < len; i++)listeners[i].fn = $13bbd556cd7cee10$export$a3891e81a74c5e40;
            // clear all listeners for a type if function isn't specified
            delete this._events[type];
            return;
        }
        if (typeof fn !== "function") {
            console.warn("wrong listener type: " + typeof fn);
            return;
        }
        // find fn and remove it
        var index = this._listens(type, fn, context);
        if (index !== false) {
            var listener = listeners[index];
            if (this._firingCount) {
                // set the removed listener to noop so that's not called if remove happens in fire
                listener.fn = $13bbd556cd7cee10$export$a3891e81a74c5e40;
                /* copy array in case events are being fired */ this._events[type] = listeners = listeners.slice();
            }
            listeners.splice(index, 1);
        }
    },
    // @method fire(type: String, data?: Object, propagate?: Boolean): this
    // Fires an event of the specified type. You can optionally provide a data
    // object — the first argument of the listener function will contain its
    // properties. The event can optionally be propagated to event parents.
    fire: function(type, data, propagate) {
        if (!this.listens(type, propagate)) return this;
        var event = $13bbd556cd7cee10$export$8b58be045bf06082({}, data, {
            type: type,
            target: this,
            sourceTarget: data && data.sourceTarget || this
        });
        if (this._events) {
            var listeners = this._events[type];
            if (listeners) {
                this._firingCount = this._firingCount + 1 || 1;
                for(var i = 0, len = listeners.length; i < len; i++){
                    var l = listeners[i];
                    // off overwrites l.fn, so we need to copy fn to a var
                    var fn = l.fn;
                    if (l.once) this.off(type, fn, l.ctx);
                    fn.call(l.ctx || this, event);
                }
                this._firingCount--;
            }
        }
        if (propagate) // propagate the event to parents (set with addEventParent)
        this._propagateEvent(event);
        return this;
    },
    // @method listens(type: String, propagate?: Boolean): Boolean
    // @method listens(type: String, fn: Function, context?: Object, propagate?: Boolean): Boolean
    // Returns `true` if a particular event type has any listeners attached to it.
    // The verification can optionally be propagated, it will return `true` if parents have the listener attached to it.
    listens: function(type, fn, context, propagate) {
        if (typeof type !== "string") console.warn('"string" type argument expected');
        // we don't overwrite the input `fn` value, because we need to use it for propagation
        var _fn = fn;
        if (typeof fn !== "function") {
            propagate = !!fn;
            _fn = undefined;
            context = undefined;
        }
        var listeners = this._events && this._events[type];
        if (listeners && listeners.length) {
            if (this._listens(type, _fn, context) !== false) return true;
        }
        if (propagate) // also check parents for listeners if event propagates
        for(var id in this._eventParents){
            if (this._eventParents[id].listens(type, fn, context, propagate)) return true;
        }
        return false;
    },
    // returns the index (number) or false
    _listens: function(type, fn, context) {
        if (!this._events) return false;
        var listeners = this._events[type] || [];
        if (!fn) return !!listeners.length;
        if (context === this) // Less memory footprint.
        context = undefined;
        for(var i = 0, len = listeners.length; i < len; i++){
            if (listeners[i].fn === fn && listeners[i].ctx === context) return i;
        }
        return false;
    },
    // @method once(…): this
    // Behaves as [`on(…)`](#evented-on), except the listener will only get fired once and then removed.
    once: function(types, fn, context) {
        // types can be a map of types/handlers
        if (typeof types === "object") for(var type in types)// we don't process space-separated events here for performance;
        // it's a hot path since Layer uses the on(obj) syntax
        this._on(type, types[type], fn, true);
        else {
            // types can be a string of space-separated words
            types = $13bbd556cd7cee10$export$3ea6d3c1e1f67aaa(types);
            for(var i = 0, len = types.length; i < len; i++)this._on(types[i], fn, context, true);
        }
        return this;
    },
    // @method addEventParent(obj: Evented): this
    // Adds an event parent - an `Evented` that will receive propagated events
    addEventParent: function(obj) {
        this._eventParents = this._eventParents || {};
        this._eventParents[$13bbd556cd7cee10$export$bd3fba034e28f6b(obj)] = obj;
        return this;
    },
    // @method removeEventParent(obj: Evented): this
    // Removes an event parent, so it will stop receiving propagated events
    removeEventParent: function(obj) {
        if (this._eventParents) delete this._eventParents[$13bbd556cd7cee10$export$bd3fba034e28f6b(obj)];
        return this;
    },
    _propagateEvent: function(e) {
        for(var id in this._eventParents)this._eventParents[id].fire(e.type, $13bbd556cd7cee10$export$8b58be045bf06082({
            layer: e.target,
            propagatedFrom: e.target
        }, e), true);
    }
};
// aliases; we should ditch those eventually
// @method addEventListener(…): this
// Alias to [`on(…)`](#evented-on)
$ca4bf785aeb0758d$export$ada873a34909da65.addEventListener = $ca4bf785aeb0758d$export$ada873a34909da65.on;
// @method removeEventListener(…): this
// Alias to [`off(…)`](#evented-off)
// @method clearAllEventListeners(…): this
// Alias to [`off()`](#evented-off)
$ca4bf785aeb0758d$export$ada873a34909da65.removeEventListener = $ca4bf785aeb0758d$export$ada873a34909da65.clearAllEventListeners = $ca4bf785aeb0758d$export$ada873a34909da65.off;
// @method addOneTimeEventListener(…): this
// Alias to [`once(…)`](#evented-once)
$ca4bf785aeb0758d$export$ada873a34909da65.addOneTimeEventListener = $ca4bf785aeb0758d$export$ada873a34909da65.once;
// @method fireEvent(…): this
// Alias to [`fire(…)`](#evented-fire)
$ca4bf785aeb0758d$export$ada873a34909da65.fireEvent = $ca4bf785aeb0758d$export$ada873a34909da65.fire;
// @method hasEventListeners(…): Boolean
// Alias to [`listens(…)`](#evented-listens)
$ca4bf785aeb0758d$export$ada873a34909da65.hasEventListeners = $ca4bf785aeb0758d$export$ada873a34909da65.listens;
var $ca4bf785aeb0758d$export$ebcc362d8f4c4311 = (0, $f8984dbaa17424d1$export$4c85e640eb41c31b).extend($ca4bf785aeb0758d$export$ada873a34909da65);



function $b802e4aa6d666b45$export$baf26146a414f24a(x, y, round) {
    // @property x: Number; The `x` coordinate of the point
    this.x = round ? Math.round(x) : x;
    // @property y: Number; The `y` coordinate of the point
    this.y = round ? Math.round(y) : y;
}
var $b802e4aa6d666b45$var$trunc = Math.trunc || function(v) {
    return v > 0 ? Math.floor(v) : Math.ceil(v);
};
$b802e4aa6d666b45$export$baf26146a414f24a.prototype = {
    // @method clone(): Point
    // Returns a copy of the current point.
    clone: function() {
        return new $b802e4aa6d666b45$export$baf26146a414f24a(this.x, this.y);
    },
    // @method add(otherPoint: Point): Point
    // Returns the result of addition of the current and the given points.
    add: function(point) {
        // non-destructive, returns a new point
        return this.clone()._add($b802e4aa6d666b45$export$b63cca88ddc558a9(point));
    },
    _add: function(point) {
        // destructive, used directly for performance in situations where it's safe to modify existing point
        this.x += point.x;
        this.y += point.y;
        return this;
    },
    // @method subtract(otherPoint: Point): Point
    // Returns the result of subtraction of the given point from the current.
    subtract: function(point) {
        return this.clone()._subtract($b802e4aa6d666b45$export$b63cca88ddc558a9(point));
    },
    _subtract: function(point) {
        this.x -= point.x;
        this.y -= point.y;
        return this;
    },
    // @method divideBy(num: Number): Point
    // Returns the result of division of the current point by the given number.
    divideBy: function(num) {
        return this.clone()._divideBy(num);
    },
    _divideBy: function(num) {
        this.x /= num;
        this.y /= num;
        return this;
    },
    // @method multiplyBy(num: Number): Point
    // Returns the result of multiplication of the current point by the given number.
    multiplyBy: function(num) {
        return this.clone()._multiplyBy(num);
    },
    _multiplyBy: function(num) {
        this.x *= num;
        this.y *= num;
        return this;
    },
    // @method scaleBy(scale: Point): Point
    // Multiply each coordinate of the current point by each coordinate of
    // `scale`. In linear algebra terms, multiply the point by the
    // [scaling matrix](https://en.wikipedia.org/wiki/Scaling_%28geometry%29#Matrix_representation)
    // defined by `scale`.
    scaleBy: function(point) {
        return new $b802e4aa6d666b45$export$baf26146a414f24a(this.x * point.x, this.y * point.y);
    },
    // @method unscaleBy(scale: Point): Point
    // Inverse of `scaleBy`. Divide each coordinate of the current point by
    // each coordinate of `scale`.
    unscaleBy: function(point) {
        return new $b802e4aa6d666b45$export$baf26146a414f24a(this.x / point.x, this.y / point.y);
    },
    // @method round(): Point
    // Returns a copy of the current point with rounded coordinates.
    round: function() {
        return this.clone()._round();
    },
    _round: function() {
        this.x = Math.round(this.x);
        this.y = Math.round(this.y);
        return this;
    },
    // @method floor(): Point
    // Returns a copy of the current point with floored coordinates (rounded down).
    floor: function() {
        return this.clone()._floor();
    },
    _floor: function() {
        this.x = Math.floor(this.x);
        this.y = Math.floor(this.y);
        return this;
    },
    // @method ceil(): Point
    // Returns a copy of the current point with ceiled coordinates (rounded up).
    ceil: function() {
        return this.clone()._ceil();
    },
    _ceil: function() {
        this.x = Math.ceil(this.x);
        this.y = Math.ceil(this.y);
        return this;
    },
    // @method trunc(): Point
    // Returns a copy of the current point with truncated coordinates (rounded towards zero).
    trunc: function() {
        return this.clone()._trunc();
    },
    _trunc: function() {
        this.x = $b802e4aa6d666b45$var$trunc(this.x);
        this.y = $b802e4aa6d666b45$var$trunc(this.y);
        return this;
    },
    // @method distanceTo(otherPoint: Point): Number
    // Returns the cartesian distance between the current and the given points.
    distanceTo: function(point) {
        point = $b802e4aa6d666b45$export$b63cca88ddc558a9(point);
        var x = point.x - this.x, y = point.y - this.y;
        return Math.sqrt(x * x + y * y);
    },
    // @method equals(otherPoint: Point): Boolean
    // Returns `true` if the given point has the same coordinates.
    equals: function(point) {
        point = $b802e4aa6d666b45$export$b63cca88ddc558a9(point);
        return point.x === this.x && point.y === this.y;
    },
    // @method contains(otherPoint: Point): Boolean
    // Returns `true` if both coordinates of the given point are less than the corresponding current point coordinates (in absolute values).
    contains: function(point) {
        point = $b802e4aa6d666b45$export$b63cca88ddc558a9(point);
        return Math.abs(point.x) <= Math.abs(this.x) && Math.abs(point.y) <= Math.abs(this.y);
    },
    // @method toString(): String
    // Returns a string representation of the point for debugging purposes.
    toString: function() {
        return "Point(" + (0, $13bbd556cd7cee10$export$533e61f4ff7f35ce)(this.x) + ", " + (0, $13bbd556cd7cee10$export$533e61f4ff7f35ce)(this.y) + ")";
    }
};
function $b802e4aa6d666b45$export$b63cca88ddc558a9(x, y, round) {
    if (x instanceof $b802e4aa6d666b45$export$baf26146a414f24a) return x;
    if ((0, $13bbd556cd7cee10$export$43bee75e5e14138e)(x)) return new $b802e4aa6d666b45$export$baf26146a414f24a(x[0], x[1]);
    if (x === undefined || x === null) return x;
    if (typeof x === "object" && "x" in x && "y" in x) return new $b802e4aa6d666b45$export$baf26146a414f24a(x.x, x.y);
    return new $b802e4aa6d666b45$export$baf26146a414f24a(x, y, round);
}


function $2ffe56518af276c5$export$c4e9d269599ab4b4(a, b) {
    if (!a) return;
    var points = b ? [
        a,
        b
    ] : a;
    for(var i = 0, len = points.length; i < len; i++)this.extend(points[i]);
}
$2ffe56518af276c5$export$c4e9d269599ab4b4.prototype = {
    // @method extend(point: Point): this
    // Extends the bounds to contain the given point.
    // @alternative
    // @method extend(otherBounds: Bounds): this
    // Extend the bounds to contain the given bounds
    extend: function(obj) {
        var min2, max2;
        if (!obj) return this;
        if (obj instanceof (0, $b802e4aa6d666b45$export$baf26146a414f24a) || typeof obj[0] === "number" || "x" in obj) min2 = max2 = (0, $b802e4aa6d666b45$export$b63cca88ddc558a9)(obj);
        else {
            obj = $2ffe56518af276c5$export$c8e2f7c8aba65b28(obj);
            min2 = obj.min;
            max2 = obj.max;
            if (!min2 || !max2) return this;
        }
        // @property min: Point
        // The top left corner of the rectangle.
        // @property max: Point
        // The bottom right corner of the rectangle.
        if (!this.min && !this.max) {
            this.min = min2.clone();
            this.max = max2.clone();
        } else {
            this.min.x = Math.min(min2.x, this.min.x);
            this.max.x = Math.max(max2.x, this.max.x);
            this.min.y = Math.min(min2.y, this.min.y);
            this.max.y = Math.max(max2.y, this.max.y);
        }
        return this;
    },
    // @method getCenter(round?: Boolean): Point
    // Returns the center point of the bounds.
    getCenter: function(round) {
        return (0, $b802e4aa6d666b45$export$b63cca88ddc558a9)((this.min.x + this.max.x) / 2, (this.min.y + this.max.y) / 2, round);
    },
    // @method getBottomLeft(): Point
    // Returns the bottom-left point of the bounds.
    getBottomLeft: function() {
        return (0, $b802e4aa6d666b45$export$b63cca88ddc558a9)(this.min.x, this.max.y);
    },
    // @method getTopRight(): Point
    // Returns the top-right point of the bounds.
    getTopRight: function() {
        return (0, $b802e4aa6d666b45$export$b63cca88ddc558a9)(this.max.x, this.min.y);
    },
    // @method getTopLeft(): Point
    // Returns the top-left point of the bounds (i.e. [`this.min`](#bounds-min)).
    getTopLeft: function() {
        return this.min; // left, top
    },
    // @method getBottomRight(): Point
    // Returns the bottom-right point of the bounds (i.e. [`this.max`](#bounds-max)).
    getBottomRight: function() {
        return this.max; // right, bottom
    },
    // @method getSize(): Point
    // Returns the size of the given bounds
    getSize: function() {
        return this.max.subtract(this.min);
    },
    // @method contains(otherBounds: Bounds): Boolean
    // Returns `true` if the rectangle contains the given one.
    // @alternative
    // @method contains(point: Point): Boolean
    // Returns `true` if the rectangle contains the given point.
    contains: function(obj) {
        var min, max;
        if (typeof obj[0] === "number" || obj instanceof (0, $b802e4aa6d666b45$export$baf26146a414f24a)) obj = (0, $b802e4aa6d666b45$export$b63cca88ddc558a9)(obj);
        else obj = $2ffe56518af276c5$export$c8e2f7c8aba65b28(obj);
        if (obj instanceof $2ffe56518af276c5$export$c4e9d269599ab4b4) {
            min = obj.min;
            max = obj.max;
        } else min = max = obj;
        return min.x >= this.min.x && max.x <= this.max.x && min.y >= this.min.y && max.y <= this.max.y;
    },
    // @method intersects(otherBounds: Bounds): Boolean
    // Returns `true` if the rectangle intersects the given bounds. Two bounds
    // intersect if they have at least one point in common.
    intersects: function(bounds) {
        bounds = $2ffe56518af276c5$export$c8e2f7c8aba65b28(bounds);
        var min = this.min, max = this.max, min2 = bounds.min, max2 = bounds.max, xIntersects = max2.x >= min.x && min2.x <= max.x, yIntersects = max2.y >= min.y && min2.y <= max.y;
        return xIntersects && yIntersects;
    },
    // @method overlaps(otherBounds: Bounds): Boolean
    // Returns `true` if the rectangle overlaps the given bounds. Two bounds
    // overlap if their intersection is an area.
    overlaps: function(bounds) {
        bounds = $2ffe56518af276c5$export$c8e2f7c8aba65b28(bounds);
        var min = this.min, max = this.max, min2 = bounds.min, max2 = bounds.max, xOverlaps = max2.x > min.x && min2.x < max.x, yOverlaps = max2.y > min.y && min2.y < max.y;
        return xOverlaps && yOverlaps;
    },
    // @method isValid(): Boolean
    // Returns `true` if the bounds are properly initialized.
    isValid: function() {
        return !!(this.min && this.max);
    },
    // @method pad(bufferRatio: Number): Bounds
    // Returns bounds created by extending or retracting the current bounds by a given ratio in each direction.
    // For example, a ratio of 0.5 extends the bounds by 50% in each direction.
    // Negative values will retract the bounds.
    pad: function(bufferRatio) {
        var min = this.min, max = this.max, heightBuffer = Math.abs(min.x - max.x) * bufferRatio, widthBuffer = Math.abs(min.y - max.y) * bufferRatio;
        return $2ffe56518af276c5$export$c8e2f7c8aba65b28((0, $b802e4aa6d666b45$export$b63cca88ddc558a9)(min.x - heightBuffer, min.y - widthBuffer), (0, $b802e4aa6d666b45$export$b63cca88ddc558a9)(max.x + heightBuffer, max.y + widthBuffer));
    },
    // @method equals(otherBounds: Bounds): Boolean
    // Returns `true` if the rectangle is equivalent to the given bounds.
    equals: function(bounds) {
        if (!bounds) return false;
        bounds = $2ffe56518af276c5$export$c8e2f7c8aba65b28(bounds);
        return this.min.equals(bounds.getTopLeft()) && this.max.equals(bounds.getBottomRight());
    }
};
function $2ffe56518af276c5$export$c8e2f7c8aba65b28(a, b) {
    if (!a || a instanceof $2ffe56518af276c5$export$c4e9d269599ab4b4) return a;
    return new $2ffe56518af276c5$export$c4e9d269599ab4b4(a, b);
}





function $c1a09dde0ebe0161$export$fe84d4076a55a8e6(corner1, corner2) {
    if (!corner1) return;
    var latlngs = corner2 ? [
        corner1,
        corner2
    ] : corner1;
    for(var i = 0, len = latlngs.length; i < len; i++)this.extend(latlngs[i]);
}
$c1a09dde0ebe0161$export$fe84d4076a55a8e6.prototype = {
    // @method extend(latlng: LatLng): this
    // Extend the bounds to contain the given point
    // @alternative
    // @method extend(otherBounds: LatLngBounds): this
    // Extend the bounds to contain the given bounds
    extend: function(obj) {
        var sw = this._southWest, ne = this._northEast, sw2, ne2;
        if (obj instanceof (0, $df6fd3b1bc3e4292$export$5fd359ea0b43bded)) {
            sw2 = obj;
            ne2 = obj;
        } else if (obj instanceof $c1a09dde0ebe0161$export$fe84d4076a55a8e6) {
            sw2 = obj._southWest;
            ne2 = obj._northEast;
            if (!sw2 || !ne2) return this;
        } else return obj ? this.extend((0, $df6fd3b1bc3e4292$export$a192f247fc7a2057)(obj) || $c1a09dde0ebe0161$export$4904432a68b0399(obj)) : this;
        if (!sw && !ne) {
            this._southWest = new (0, $df6fd3b1bc3e4292$export$5fd359ea0b43bded)(sw2.lat, sw2.lng);
            this._northEast = new (0, $df6fd3b1bc3e4292$export$5fd359ea0b43bded)(ne2.lat, ne2.lng);
        } else {
            sw.lat = Math.min(sw2.lat, sw.lat);
            sw.lng = Math.min(sw2.lng, sw.lng);
            ne.lat = Math.max(ne2.lat, ne.lat);
            ne.lng = Math.max(ne2.lng, ne.lng);
        }
        return this;
    },
    // @method pad(bufferRatio: Number): LatLngBounds
    // Returns bounds created by extending or retracting the current bounds by a given ratio in each direction.
    // For example, a ratio of 0.5 extends the bounds by 50% in each direction.
    // Negative values will retract the bounds.
    pad: function(bufferRatio) {
        var sw = this._southWest, ne = this._northEast, heightBuffer = Math.abs(sw.lat - ne.lat) * bufferRatio, widthBuffer = Math.abs(sw.lng - ne.lng) * bufferRatio;
        return new $c1a09dde0ebe0161$export$fe84d4076a55a8e6(new (0, $df6fd3b1bc3e4292$export$5fd359ea0b43bded)(sw.lat - heightBuffer, sw.lng - widthBuffer), new (0, $df6fd3b1bc3e4292$export$5fd359ea0b43bded)(ne.lat + heightBuffer, ne.lng + widthBuffer));
    },
    // @method getCenter(): LatLng
    // Returns the center point of the bounds.
    getCenter: function() {
        return new (0, $df6fd3b1bc3e4292$export$5fd359ea0b43bded)((this._southWest.lat + this._northEast.lat) / 2, (this._southWest.lng + this._northEast.lng) / 2);
    },
    // @method getSouthWest(): LatLng
    // Returns the south-west point of the bounds.
    getSouthWest: function() {
        return this._southWest;
    },
    // @method getNorthEast(): LatLng
    // Returns the north-east point of the bounds.
    getNorthEast: function() {
        return this._northEast;
    },
    // @method getNorthWest(): LatLng
    // Returns the north-west point of the bounds.
    getNorthWest: function() {
        return new (0, $df6fd3b1bc3e4292$export$5fd359ea0b43bded)(this.getNorth(), this.getWest());
    },
    // @method getSouthEast(): LatLng
    // Returns the south-east point of the bounds.
    getSouthEast: function() {
        return new (0, $df6fd3b1bc3e4292$export$5fd359ea0b43bded)(this.getSouth(), this.getEast());
    },
    // @method getWest(): Number
    // Returns the west longitude of the bounds
    getWest: function() {
        return this._southWest.lng;
    },
    // @method getSouth(): Number
    // Returns the south latitude of the bounds
    getSouth: function() {
        return this._southWest.lat;
    },
    // @method getEast(): Number
    // Returns the east longitude of the bounds
    getEast: function() {
        return this._northEast.lng;
    },
    // @method getNorth(): Number
    // Returns the north latitude of the bounds
    getNorth: function() {
        return this._northEast.lat;
    },
    // @method contains(otherBounds: LatLngBounds): Boolean
    // Returns `true` if the rectangle contains the given one.
    // @alternative
    // @method contains (latlng: LatLng): Boolean
    // Returns `true` if the rectangle contains the given point.
    contains: function(obj) {
        if (typeof obj[0] === "number" || obj instanceof (0, $df6fd3b1bc3e4292$export$5fd359ea0b43bded) || "lat" in obj) obj = (0, $df6fd3b1bc3e4292$export$a192f247fc7a2057)(obj);
        else obj = $c1a09dde0ebe0161$export$4904432a68b0399(obj);
        var sw = this._southWest, ne = this._northEast, sw2, ne2;
        if (obj instanceof $c1a09dde0ebe0161$export$fe84d4076a55a8e6) {
            sw2 = obj.getSouthWest();
            ne2 = obj.getNorthEast();
        } else sw2 = ne2 = obj;
        return sw2.lat >= sw.lat && ne2.lat <= ne.lat && sw2.lng >= sw.lng && ne2.lng <= ne.lng;
    },
    // @method intersects(otherBounds: LatLngBounds): Boolean
    // Returns `true` if the rectangle intersects the given bounds. Two bounds intersect if they have at least one point in common.
    intersects: function(bounds) {
        bounds = $c1a09dde0ebe0161$export$4904432a68b0399(bounds);
        var sw = this._southWest, ne = this._northEast, sw2 = bounds.getSouthWest(), ne2 = bounds.getNorthEast(), latIntersects = ne2.lat >= sw.lat && sw2.lat <= ne.lat, lngIntersects = ne2.lng >= sw.lng && sw2.lng <= ne.lng;
        return latIntersects && lngIntersects;
    },
    // @method overlaps(otherBounds: LatLngBounds): Boolean
    // Returns `true` if the rectangle overlaps the given bounds. Two bounds overlap if their intersection is an area.
    overlaps: function(bounds) {
        bounds = $c1a09dde0ebe0161$export$4904432a68b0399(bounds);
        var sw = this._southWest, ne = this._northEast, sw2 = bounds.getSouthWest(), ne2 = bounds.getNorthEast(), latOverlaps = ne2.lat > sw.lat && sw2.lat < ne.lat, lngOverlaps = ne2.lng > sw.lng && sw2.lng < ne.lng;
        return latOverlaps && lngOverlaps;
    },
    // @method toBBoxString(): String
    // Returns a string with bounding box coordinates in a 'southwest_lng,southwest_lat,northeast_lng,northeast_lat' format. Useful for sending requests to web services that return geo data.
    toBBoxString: function() {
        return [
            this.getWest(),
            this.getSouth(),
            this.getEast(),
            this.getNorth()
        ].join(",");
    },
    // @method equals(otherBounds: LatLngBounds, maxMargin?: Number): Boolean
    // Returns `true` if the rectangle is equivalent (within a small margin of error) to the given bounds. The margin of error can be overridden by setting `maxMargin` to a small number.
    equals: function(bounds, maxMargin) {
        if (!bounds) return false;
        bounds = $c1a09dde0ebe0161$export$4904432a68b0399(bounds);
        return this._southWest.equals(bounds.getSouthWest(), maxMargin) && this._northEast.equals(bounds.getNorthEast(), maxMargin);
    },
    // @method isValid(): Boolean
    // Returns `true` if the bounds are properly initialized.
    isValid: function() {
        return !!(this._southWest && this._northEast);
    }
};
function $c1a09dde0ebe0161$export$4904432a68b0399(a, b) {
    if (a instanceof $c1a09dde0ebe0161$export$fe84d4076a55a8e6) return a;
    return new $c1a09dde0ebe0161$export$fe84d4076a55a8e6(a, b);
}


function $df6fd3b1bc3e4292$export$5fd359ea0b43bded(lat, lng, alt) {
    if (isNaN(lat) || isNaN(lng)) throw new Error("Invalid LatLng object: (" + lat + ", " + lng + ")");
    // @property lat: Number
    // Latitude in degrees
    this.lat = +lat;
    // @property lng: Number
    // Longitude in degrees
    this.lng = +lng;
    // @property alt: Number
    // Altitude in meters (optional)
    if (alt !== undefined) this.alt = +alt;
}
$df6fd3b1bc3e4292$export$5fd359ea0b43bded.prototype = {
    // @method equals(otherLatLng: LatLng, maxMargin?: Number): Boolean
    // Returns `true` if the given `LatLng` point is at the same position (within a small margin of error). The margin of error can be overridden by setting `maxMargin` to a small number.
    equals: function(obj, maxMargin) {
        if (!obj) return false;
        obj = $df6fd3b1bc3e4292$export$a192f247fc7a2057(obj);
        var margin = Math.max(Math.abs(this.lat - obj.lat), Math.abs(this.lng - obj.lng));
        return margin <= (maxMargin === undefined ? 1.0E-9 : maxMargin);
    },
    // @method toString(): String
    // Returns a string representation of the point (for debugging purposes).
    toString: function(precision) {
        return "LatLng(" + $13bbd556cd7cee10$export$533e61f4ff7f35ce(this.lat, precision) + ", " + $13bbd556cd7cee10$export$533e61f4ff7f35ce(this.lng, precision) + ")";
    },
    // @method distanceTo(otherLatLng: LatLng): Number
    // Returns the distance (in meters) to the given `LatLng` calculated using the [Spherical Law of Cosines](https://en.wikipedia.org/wiki/Spherical_law_of_cosines).
    distanceTo: function(other) {
        return (0, $22c0063417eeaa98$export$a8d7cb18a6ef9581).distance(this, $df6fd3b1bc3e4292$export$a192f247fc7a2057(other));
    },
    // @method wrap(): LatLng
    // Returns a new `LatLng` object with the longitude wrapped so it's always between -180 and +180 degrees.
    wrap: function() {
        return (0, $22c0063417eeaa98$export$a8d7cb18a6ef9581).wrapLatLng(this);
    },
    // @method toBounds(sizeInMeters: Number): LatLngBounds
    // Returns a new `LatLngBounds` object in which each boundary is `sizeInMeters/2` meters apart from the `LatLng`.
    toBounds: function(sizeInMeters) {
        var latAccuracy = 180 * sizeInMeters / 40075017, lngAccuracy = latAccuracy / Math.cos(Math.PI / 180 * this.lat);
        return (0, $c1a09dde0ebe0161$export$4904432a68b0399)([
            this.lat - latAccuracy,
            this.lng - lngAccuracy
        ], [
            this.lat + latAccuracy,
            this.lng + lngAccuracy
        ]);
    },
    clone: function() {
        return new $df6fd3b1bc3e4292$export$5fd359ea0b43bded(this.lat, this.lng, this.alt);
    }
};
function $df6fd3b1bc3e4292$export$a192f247fc7a2057(a, b, c) {
    if (a instanceof $df6fd3b1bc3e4292$export$5fd359ea0b43bded) return a;
    if ($13bbd556cd7cee10$export$43bee75e5e14138e(a) && typeof a[0] !== "object") {
        if (a.length === 3) return new $df6fd3b1bc3e4292$export$5fd359ea0b43bded(a[0], a[1], a[2]);
        if (a.length === 2) return new $df6fd3b1bc3e4292$export$5fd359ea0b43bded(a[0], a[1]);
        return null;
    }
    if (a === undefined || a === null) return a;
    if (typeof a === "object" && "lat" in a) return new $df6fd3b1bc3e4292$export$5fd359ea0b43bded(a.lat, "lng" in a ? a.lng : a.lon, a.alt);
    if (b === undefined) return null;
    return new $df6fd3b1bc3e4292$export$5fd359ea0b43bded(a, b, c);
}




var $9bd7d3356f07c68c$export$bdae29047cba02fc = {
    // @method latLngToPoint(latlng: LatLng, zoom: Number): Point
    // Projects geographical coordinates into pixel coordinates for a given zoom.
    latLngToPoint: function(latlng, zoom) {
        var projectedPoint = this.projection.project(latlng), scale = this.scale(zoom);
        return this.transformation._transform(projectedPoint, scale);
    },
    // @method pointToLatLng(point: Point, zoom: Number): LatLng
    // The inverse of `latLngToPoint`. Projects pixel coordinates on a given
    // zoom into geographical coordinates.
    pointToLatLng: function(point, zoom) {
        var scale = this.scale(zoom), untransformedPoint = this.transformation.untransform(point, scale);
        return this.projection.unproject(untransformedPoint);
    },
    // @method project(latlng: LatLng): Point
    // Projects geographical coordinates into coordinates in units accepted for
    // this CRS (e.g. meters for EPSG:3857, for passing it to WMS services).
    project: function(latlng) {
        return this.projection.project(latlng);
    },
    // @method unproject(point: Point): LatLng
    // Given a projected coordinate returns the corresponding LatLng.
    // The inverse of `project`.
    unproject: function(point) {
        return this.projection.unproject(point);
    },
    // @method scale(zoom: Number): Number
    // Returns the scale used when transforming projected coordinates into
    // pixel coordinates for a particular zoom. For example, it returns
    // `256 * 2^zoom` for Mercator-based CRS.
    scale: function(zoom) {
        return 256 * Math.pow(2, zoom);
    },
    // @method zoom(scale: Number): Number
    // Inverse of `scale()`, returns the zoom level corresponding to a scale
    // factor of `scale`.
    zoom: function(scale) {
        return Math.log(scale / 256) / Math.LN2;
    },
    // @method getProjectedBounds(zoom: Number): Bounds
    // Returns the projection's bounds scaled and transformed for the provided `zoom`.
    getProjectedBounds: function(zoom) {
        if (this.infinite) return null;
        var b = this.projection.bounds, s = this.scale(zoom), min = this.transformation.transform(b.min, s), max = this.transformation.transform(b.max, s);
        return new (0, $2ffe56518af276c5$export$c4e9d269599ab4b4)(min, max);
    },
    // @method distance(latlng1: LatLng, latlng2: LatLng): Number
    // Returns the distance between two geographical coordinates.
    // @property code: String
    // Standard code name of the CRS passed into WMS services (e.g. `'EPSG:3857'`)
    //
    // @property wrapLng: Number[]
    // An array of two numbers defining whether the longitude (horizontal) coordinate
    // axis wraps around a given range and how. Defaults to `[-180, 180]` in most
    // geographical CRSs. If `undefined`, the longitude axis does not wrap around.
    //
    // @property wrapLat: Number[]
    // Like `wrapLng`, but for the latitude (vertical) axis.
    // wrapLng: [min, max],
    // wrapLat: [min, max],
    // @property infinite: Boolean
    // If true, the coordinate space will be unbounded (infinite in both axes)
    infinite: false,
    // @method wrapLatLng(latlng: LatLng): LatLng
    // Returns a `LatLng` where lat and lng has been wrapped according to the
    // CRS's `wrapLat` and `wrapLng` properties, if they are outside the CRS's bounds.
    wrapLatLng: function(latlng) {
        var lng = this.wrapLng ? $13bbd556cd7cee10$export$f6cd9682189b118b(latlng.lng, this.wrapLng, true) : latlng.lng, lat = this.wrapLat ? $13bbd556cd7cee10$export$f6cd9682189b118b(latlng.lat, this.wrapLat, true) : latlng.lat, alt = latlng.alt;
        return new (0, $df6fd3b1bc3e4292$export$5fd359ea0b43bded)(lat, lng, alt);
    },
    // @method wrapLatLngBounds(bounds: LatLngBounds): LatLngBounds
    // Returns a `LatLngBounds` with the same size as the given one, ensuring
    // that its center is within the CRS's bounds.
    // Only accepts actual `L.LatLngBounds` instances, not arrays.
    wrapLatLngBounds: function(bounds) {
        var center = bounds.getCenter(), newCenter = this.wrapLatLng(center), latShift = center.lat - newCenter.lat, lngShift = center.lng - newCenter.lng;
        if (latShift === 0 && lngShift === 0) return bounds;
        var sw = bounds.getSouthWest(), ne = bounds.getNorthEast(), newSw = new (0, $df6fd3b1bc3e4292$export$5fd359ea0b43bded)(sw.lat - latShift, sw.lng - lngShift), newNe = new (0, $df6fd3b1bc3e4292$export$5fd359ea0b43bded)(ne.lat - latShift, ne.lng - lngShift);
        return new (0, $c1a09dde0ebe0161$export$fe84d4076a55a8e6)(newSw, newNe);
    }
};



var $22c0063417eeaa98$export$a8d7cb18a6ef9581 = $13bbd556cd7cee10$export$8b58be045bf06082({}, (0, $9bd7d3356f07c68c$export$bdae29047cba02fc), {
    wrapLng: [
        -180,
        180
    ],
    // Mean Earth Radius, as recommended for use by
    // the International Union of Geodesy and Geophysics,
    // see https://rosettacode.org/wiki/Haversine_formula
    R: 6371000,
    // distance between two geographical points using spherical law of cosines approximation
    distance: function(latlng1, latlng2) {
        var rad = Math.PI / 180, lat1 = latlng1.lat * rad, lat2 = latlng2.lat * rad, sinDLat = Math.sin((latlng2.lat - latlng1.lat) * rad / 2), sinDLon = Math.sin((latlng2.lng - latlng1.lng) * rad / 2), a = sinDLat * sinDLat + Math.cos(lat1) * Math.cos(lat2) * sinDLon * sinDLon, c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        return this.R * c;
    }
});





/*
 * @namespace Projection
 * @projection L.Projection.SphericalMercator
 *
 * Spherical Mercator projection — the most common projection for online maps,
 * used by almost all free and commercial tile providers. Assumes that Earth is
 * a sphere. Used by the `EPSG:3857` CRS.
 */ var $7c98cf1bb3c47dca$var$earthRadius = 6378137;
var $7c98cf1bb3c47dca$export$55a14d9a5359290c = {
    R: $7c98cf1bb3c47dca$var$earthRadius,
    MAX_LATITUDE: 85.0511287798,
    project: function(latlng) {
        var d = Math.PI / 180, max = this.MAX_LATITUDE, lat = Math.max(Math.min(max, latlng.lat), -max), sin = Math.sin(lat * d);
        return new (0, $b802e4aa6d666b45$export$baf26146a414f24a)(this.R * latlng.lng * d, this.R * Math.log((1 + sin) / (1 - sin)) / 2);
    },
    unproject: function(point) {
        var d = 180 / Math.PI;
        return new (0, $df6fd3b1bc3e4292$export$5fd359ea0b43bded)((2 * Math.atan(Math.exp(point.y / this.R)) - Math.PI / 2) * d, point.x * d / this.R);
    },
    bounds: function() {
        var d = $7c98cf1bb3c47dca$var$earthRadius * Math.PI;
        return new (0, $2ffe56518af276c5$export$c4e9d269599ab4b4)([
            -d,
            -d
        ], [
            d,
            d
        ]);
    }()
};




function $26f57cb74c82546e$export$a001ee18aa9e474(a, b, c, d) {
    if ($13bbd556cd7cee10$export$43bee75e5e14138e(a)) {
        // use array properties
        this._a = a[0];
        this._b = a[1];
        this._c = a[2];
        this._d = a[3];
        return;
    }
    this._a = a;
    this._b = b;
    this._c = c;
    this._d = d;
}
$26f57cb74c82546e$export$a001ee18aa9e474.prototype = {
    // @method transform(point: Point, scale?: Number): Point
    // Returns a transformed point, optionally multiplied by the given scale.
    // Only accepts actual `L.Point` instances, not arrays.
    transform: function(point, scale) {
        return this._transform(point.clone(), scale);
    },
    // destructive transform (faster)
    _transform: function(point, scale) {
        scale = scale || 1;
        point.x = scale * (this._a * point.x + this._b);
        point.y = scale * (this._c * point.y + this._d);
        return point;
    },
    // @method untransform(point: Point, scale?: Number): Point
    // Returns the reverse transformation of the given point, optionally divided
    // by the given scale. Only accepts actual `L.Point` instances, not arrays.
    untransform: function(point, scale) {
        scale = scale || 1;
        return new (0, $b802e4aa6d666b45$export$baf26146a414f24a)((point.x / scale - this._b) / this._a, (point.y / scale - this._d) / this._c);
    }
};
function $26f57cb74c82546e$export$9f6f7fcc395e278(a, b, c, d) {
    return new $26f57cb74c82546e$export$a001ee18aa9e474(a, b, c, d);
}



var $c02c17eb3d2fe7a7$export$fa530d80b080b222 = $13bbd556cd7cee10$export$8b58be045bf06082({}, (0, $22c0063417eeaa98$export$a8d7cb18a6ef9581), {
    code: "EPSG:3857",
    projection: (0, $7c98cf1bb3c47dca$export$55a14d9a5359290c),
    transformation: function() {
        var scale = 0.5 / (Math.PI * (0, $7c98cf1bb3c47dca$export$55a14d9a5359290c).R);
        return (0, $26f57cb74c82546e$export$9f6f7fcc395e278)(scale, 0.5, -scale, 0.5);
    }()
});
var $c02c17eb3d2fe7a7$export$ca3534a3dff3e397 = $13bbd556cd7cee10$export$8b58be045bf06082({}, $c02c17eb3d2fe7a7$export$fa530d80b080b222, {
    code: "EPSG:900913"
});








function $4a933da72d3faae5$export$9d9648f1590c5e1(name) {
    return document.createElementNS("http://www.w3.org/2000/svg", name);
}
function $4a933da72d3faae5$export$bc863495a5f10ca1(rings, closed) {
    var str = "", i, j, len, len2, points, p;
    for(i = 0, len = rings.length; i < len; i++){
        points = rings[i];
        for(j = 0, len2 = points.length; j < len2; j++){
            p = points[j];
            str += (j ? "L" : "M") + p.x + " " + p.y;
        }
        // closes the ring for polygons; "x" is VML syntax
        str += closed ? (0, $bda63d751c06734c$export$2e2bcd8739ae039).svg ? "z" : "x" : "";
    }
    // SVG complains about empty path strings
    return str || "M0 0";
}


/*
 * @namespace Browser
 * @aka L.Browser
 *
 * A namespace with static properties for browser/feature detection used by Leaflet internally.
 *
 * @example
 *
 * ```js
 * if (L.Browser.ielt9) {
 *   alert('Upgrade your browser, dude!');
 * }
 * ```
 */ var $bda63d751c06734c$var$style = document.documentElement.style;
// @property ie: Boolean; `true` for all Internet Explorer versions (not Edge).
var $bda63d751c06734c$var$ie = "ActiveXObject" in window;
// @property ielt9: Boolean; `true` for Internet Explorer versions less than 9.
var $bda63d751c06734c$var$ielt9 = $bda63d751c06734c$var$ie && !document.addEventListener;
// @property edge: Boolean; `true` for the Edge web browser.
var $bda63d751c06734c$var$edge = "msLaunchUri" in navigator && !("documentMode" in document);
// @property webkit: Boolean;
// `true` for webkit-based browsers like Chrome and Safari (including mobile versions).
var $bda63d751c06734c$var$webkit = $bda63d751c06734c$var$userAgentContains("webkit");
// @property android: Boolean
// **Deprecated.** `true` for any browser running on an Android platform.
var $bda63d751c06734c$var$android = $bda63d751c06734c$var$userAgentContains("android");
// @property android23: Boolean; **Deprecated.** `true` for browsers running on Android 2 or Android 3.
var $bda63d751c06734c$var$android23 = $bda63d751c06734c$var$userAgentContains("android 2") || $bda63d751c06734c$var$userAgentContains("android 3");
/* See https://stackoverflow.com/a/17961266 for details on detecting stock Android */ var $bda63d751c06734c$var$webkitVer = parseInt(/WebKit\/([0-9]+)|$/.exec(navigator.userAgent)[1], 10); // also matches AppleWebKit
// @property androidStock: Boolean; **Deprecated.** `true` for the Android stock browser (i.e. not Chrome)
var $bda63d751c06734c$var$androidStock = $bda63d751c06734c$var$android && $bda63d751c06734c$var$userAgentContains("Google") && $bda63d751c06734c$var$webkitVer < 537 && !("AudioNode" in window);
// @property opera: Boolean; `true` for the Opera browser
var $bda63d751c06734c$var$opera = !!window.opera;
// @property chrome: Boolean; `true` for the Chrome browser.
var $bda63d751c06734c$var$chrome = !$bda63d751c06734c$var$edge && $bda63d751c06734c$var$userAgentContains("chrome");
// @property gecko: Boolean; `true` for gecko-based browsers like Firefox.
var $bda63d751c06734c$var$gecko = $bda63d751c06734c$var$userAgentContains("gecko") && !$bda63d751c06734c$var$webkit && !$bda63d751c06734c$var$opera && !$bda63d751c06734c$var$ie;
// @property safari: Boolean; `true` for the Safari browser.
var $bda63d751c06734c$var$safari = !$bda63d751c06734c$var$chrome && $bda63d751c06734c$var$userAgentContains("safari");
var $bda63d751c06734c$var$phantom = $bda63d751c06734c$var$userAgentContains("phantom");
// @property opera12: Boolean
// `true` for the Opera browser supporting CSS transforms (version 12 or later).
var $bda63d751c06734c$var$opera12 = "OTransition" in $bda63d751c06734c$var$style;
// @property win: Boolean; `true` when the browser is running in a Windows platform
var $bda63d751c06734c$var$win = navigator.platform.indexOf("Win") === 0;
// @property ie3d: Boolean; `true` for all Internet Explorer versions supporting CSS transforms.
var $bda63d751c06734c$var$ie3d = $bda63d751c06734c$var$ie && "transition" in $bda63d751c06734c$var$style;
// @property webkit3d: Boolean; `true` for webkit-based browsers supporting CSS transforms.
var $bda63d751c06734c$var$webkit3d = "WebKitCSSMatrix" in window && "m11" in new window.WebKitCSSMatrix() && !$bda63d751c06734c$var$android23;
// @property gecko3d: Boolean; `true` for gecko-based browsers supporting CSS transforms.
var $bda63d751c06734c$var$gecko3d = "MozPerspective" in $bda63d751c06734c$var$style;
// @property any3d: Boolean
// `true` for all browsers supporting CSS transforms.
var $bda63d751c06734c$var$any3d = !window.L_DISABLE_3D && ($bda63d751c06734c$var$ie3d || $bda63d751c06734c$var$webkit3d || $bda63d751c06734c$var$gecko3d) && !$bda63d751c06734c$var$opera12 && !$bda63d751c06734c$var$phantom;
// @property mobile: Boolean; `true` for all browsers running in a mobile device.
var $bda63d751c06734c$var$mobile = typeof orientation !== "undefined" || $bda63d751c06734c$var$userAgentContains("mobile");
// @property mobileWebkit: Boolean; `true` for all webkit-based browsers in a mobile device.
var $bda63d751c06734c$var$mobileWebkit = $bda63d751c06734c$var$mobile && $bda63d751c06734c$var$webkit;
// @property mobileWebkit3d: Boolean
// `true` for all webkit-based browsers in a mobile device supporting CSS transforms.
var $bda63d751c06734c$var$mobileWebkit3d = $bda63d751c06734c$var$mobile && $bda63d751c06734c$var$webkit3d;
// @property msPointer: Boolean
// `true` for browsers implementing the Microsoft touch events model (notably IE10).
var $bda63d751c06734c$var$msPointer = !window.PointerEvent && window.MSPointerEvent;
// @property pointer: Boolean
// `true` for all browsers supporting [pointer events](https://msdn.microsoft.com/en-us/library/dn433244%28v=vs.85%29.aspx).
var $bda63d751c06734c$var$pointer = !!(window.PointerEvent || $bda63d751c06734c$var$msPointer);
// @property touchNative: Boolean
// `true` for all browsers supporting [touch events](https://developer.mozilla.org/docs/Web/API/Touch_events).
// **This does not necessarily mean** that the browser is running in a computer with
// a touchscreen, it only means that the browser is capable of understanding
// touch events.
var $bda63d751c06734c$var$touchNative = "ontouchstart" in window || !!window.TouchEvent;
// @property touch: Boolean
// `true` for all browsers supporting either [touch](#browser-touch) or [pointer](#browser-pointer) events.
// Note: pointer events will be preferred (if available), and processed for all `touch*` listeners.
var $bda63d751c06734c$var$touch = !window.L_NO_TOUCH && ($bda63d751c06734c$var$touchNative || $bda63d751c06734c$var$pointer);
// @property mobileOpera: Boolean; `true` for the Opera browser in a mobile device.
var $bda63d751c06734c$var$mobileOpera = $bda63d751c06734c$var$mobile && $bda63d751c06734c$var$opera;
// @property mobileGecko: Boolean
// `true` for gecko-based browsers running in a mobile device.
var $bda63d751c06734c$var$mobileGecko = $bda63d751c06734c$var$mobile && $bda63d751c06734c$var$gecko;
// @property retina: Boolean
// `true` for browsers on a high-resolution "retina" screen or on any screen when browser's display zoom is more than 100%.
var $bda63d751c06734c$var$retina = (window.devicePixelRatio || window.screen.deviceXDPI / window.screen.logicalXDPI) > 1;
// @property passiveEvents: Boolean
// `true` for browsers that support passive events.
var $bda63d751c06734c$var$passiveEvents = function() {
    var supportsPassiveOption = false;
    try {
        var opts = Object.defineProperty({}, "passive", {
            get: function() {
                supportsPassiveOption = true;
            }
        });
        window.addEventListener("testPassiveEventSupport", $13bbd556cd7cee10$export$a3891e81a74c5e40, opts);
        window.removeEventListener("testPassiveEventSupport", $13bbd556cd7cee10$export$a3891e81a74c5e40, opts);
    } catch (e) {
    // Errors can safely be ignored since this is only a browser support test.
    }
    return supportsPassiveOption;
}();
// @property canvas: Boolean
// `true` when the browser supports [`<canvas>`](https://developer.mozilla.org/docs/Web/API/Canvas_API).
var $bda63d751c06734c$var$canvas = function() {
    return !!document.createElement("canvas").getContext;
}();
// @property svg: Boolean
// `true` when the browser supports [SVG](https://developer.mozilla.org/docs/Web/SVG).
var $bda63d751c06734c$var$svg = !!(document.createElementNS && (0, $4a933da72d3faae5$export$9d9648f1590c5e1)("svg").createSVGRect);
var $bda63d751c06734c$var$inlineSvg = !!$bda63d751c06734c$var$svg && function() {
    var div = document.createElement("div");
    div.innerHTML = "<svg/>";
    return (div.firstChild && div.firstChild.namespaceURI) === "http://www.w3.org/2000/svg";
}();
// @property vml: Boolean
// `true` if the browser supports [VML](https://en.wikipedia.org/wiki/Vector_Markup_Language).
var $bda63d751c06734c$var$vml = !$bda63d751c06734c$var$svg && function() {
    try {
        var div = document.createElement("div");
        div.innerHTML = '<v:shape adj="1"/>';
        var shape = div.firstChild;
        shape.style.behavior = "url(#default#VML)";
        return shape && typeof shape.adj === "object";
    } catch (e) {
        return false;
    }
}();
// @property mac: Boolean; `true` when the browser is running in a Mac platform
var $bda63d751c06734c$var$mac = navigator.platform.indexOf("Mac") === 0;
// @property mac: Boolean; `true` when the browser is running in a Linux platform
var $bda63d751c06734c$var$linux = navigator.platform.indexOf("Linux") === 0;
function $bda63d751c06734c$var$userAgentContains(str) {
    return navigator.userAgent.toLowerCase().indexOf(str) >= 0;
}
var $bda63d751c06734c$export$2e2bcd8739ae039 = {
    ie: $bda63d751c06734c$var$ie,
    ielt9: $bda63d751c06734c$var$ielt9,
    edge: $bda63d751c06734c$var$edge,
    webkit: $bda63d751c06734c$var$webkit,
    android: $bda63d751c06734c$var$android,
    android23: $bda63d751c06734c$var$android23,
    androidStock: $bda63d751c06734c$var$androidStock,
    opera: $bda63d751c06734c$var$opera,
    chrome: $bda63d751c06734c$var$chrome,
    gecko: $bda63d751c06734c$var$gecko,
    safari: $bda63d751c06734c$var$safari,
    phantom: $bda63d751c06734c$var$phantom,
    opera12: $bda63d751c06734c$var$opera12,
    win: $bda63d751c06734c$var$win,
    ie3d: $bda63d751c06734c$var$ie3d,
    webkit3d: $bda63d751c06734c$var$webkit3d,
    gecko3d: $bda63d751c06734c$var$gecko3d,
    any3d: $bda63d751c06734c$var$any3d,
    mobile: $bda63d751c06734c$var$mobile,
    mobileWebkit: $bda63d751c06734c$var$mobileWebkit,
    mobileWebkit3d: $bda63d751c06734c$var$mobileWebkit3d,
    msPointer: $bda63d751c06734c$var$msPointer,
    pointer: $bda63d751c06734c$var$pointer,
    touch: $bda63d751c06734c$var$touch,
    touchNative: $bda63d751c06734c$var$touchNative,
    mobileOpera: $bda63d751c06734c$var$mobileOpera,
    mobileGecko: $bda63d751c06734c$var$mobileGecko,
    retina: $bda63d751c06734c$var$retina,
    passiveEvents: $bda63d751c06734c$var$passiveEvents,
    canvas: $bda63d751c06734c$var$canvas,
    svg: $bda63d751c06734c$var$svg,
    vml: $bda63d751c06734c$var$vml,
    inlineSvg: $bda63d751c06734c$var$inlineSvg,
    mac: $bda63d751c06734c$var$mac,
    linux: $bda63d751c06734c$var$linux
};








/*
 * Extends L.DomEvent to provide touch support for Internet Explorer and Windows-based devices.
 */ var $c416047e98ea263a$var$POINTER_DOWN = (0, $bda63d751c06734c$export$2e2bcd8739ae039).msPointer ? "MSPointerDown" : "pointerdown";
var $c416047e98ea263a$var$POINTER_MOVE = (0, $bda63d751c06734c$export$2e2bcd8739ae039).msPointer ? "MSPointerMove" : "pointermove";
var $c416047e98ea263a$var$POINTER_UP = (0, $bda63d751c06734c$export$2e2bcd8739ae039).msPointer ? "MSPointerUp" : "pointerup";
var $c416047e98ea263a$var$POINTER_CANCEL = (0, $bda63d751c06734c$export$2e2bcd8739ae039).msPointer ? "MSPointerCancel" : "pointercancel";
var $c416047e98ea263a$var$pEvent = {
    touchstart: $c416047e98ea263a$var$POINTER_DOWN,
    touchmove: $c416047e98ea263a$var$POINTER_MOVE,
    touchend: $c416047e98ea263a$var$POINTER_UP,
    touchcancel: $c416047e98ea263a$var$POINTER_CANCEL
};
var $c416047e98ea263a$var$handle = {
    touchstart: $c416047e98ea263a$var$_onPointerStart,
    touchmove: $c416047e98ea263a$var$_handlePointer,
    touchend: $c416047e98ea263a$var$_handlePointer,
    touchcancel: $c416047e98ea263a$var$_handlePointer
};
var $c416047e98ea263a$var$_pointers = {};
var $c416047e98ea263a$var$_pointerDocListener = false;
function $c416047e98ea263a$export$a6463408b660293c(obj, type, handler) {
    if (type === "touchstart") $c416047e98ea263a$var$_addPointerDocListener();
    if (!$c416047e98ea263a$var$handle[type]) {
        console.warn("wrong event specified:", type);
        return 0, $13bbd556cd7cee10$export$a3891e81a74c5e40;
    }
    handler = $c416047e98ea263a$var$handle[type].bind(this, handler);
    obj.addEventListener($c416047e98ea263a$var$pEvent[type], handler, false);
    return handler;
}
function $c416047e98ea263a$export$b9716686da018371(obj, type, handler) {
    if (!$c416047e98ea263a$var$pEvent[type]) {
        console.warn("wrong event specified:", type);
        return;
    }
    obj.removeEventListener($c416047e98ea263a$var$pEvent[type], handler, false);
}
function $c416047e98ea263a$var$_globalPointerDown(e) {
    $c416047e98ea263a$var$_pointers[e.pointerId] = e;
}
function $c416047e98ea263a$var$_globalPointerMove(e) {
    if ($c416047e98ea263a$var$_pointers[e.pointerId]) $c416047e98ea263a$var$_pointers[e.pointerId] = e;
}
function $c416047e98ea263a$var$_globalPointerUp(e) {
    delete $c416047e98ea263a$var$_pointers[e.pointerId];
}
function $c416047e98ea263a$var$_addPointerDocListener() {
    // need to keep track of what pointers and how many are active to provide e.touches emulation
    if (!$c416047e98ea263a$var$_pointerDocListener) {
        // we listen document as any drags that end by moving the touch off the screen get fired there
        document.addEventListener($c416047e98ea263a$var$POINTER_DOWN, $c416047e98ea263a$var$_globalPointerDown, true);
        document.addEventListener($c416047e98ea263a$var$POINTER_MOVE, $c416047e98ea263a$var$_globalPointerMove, true);
        document.addEventListener($c416047e98ea263a$var$POINTER_UP, $c416047e98ea263a$var$_globalPointerUp, true);
        document.addEventListener($c416047e98ea263a$var$POINTER_CANCEL, $c416047e98ea263a$var$_globalPointerUp, true);
        $c416047e98ea263a$var$_pointerDocListener = true;
    }
}
function $c416047e98ea263a$var$_handlePointer(handler, e) {
    if (e.pointerType === (e.MSPOINTER_TYPE_MOUSE || "mouse")) return;
    e.touches = [];
    for(var i in $c416047e98ea263a$var$_pointers)e.touches.push($c416047e98ea263a$var$_pointers[i]);
    e.changedTouches = [
        e
    ];
    handler(e);
}
function $c416047e98ea263a$var$_onPointerStart(handler, e) {
    // IE10 specific: MsTouch needs preventDefault. See #2000
    if (e.MSPOINTER_TYPE_TOUCH && e.pointerType === e.MSPOINTER_TYPE_TOUCH) $2148974bfeaf2ac1$export$fa3b29edae795ef4(e);
    $c416047e98ea263a$var$_handlePointer(handler, e);
}



/*
 * Extends the event handling code with double tap support for mobile browsers.
 *
 * Note: currently most browsers fire native dblclick, with only a few exceptions
 * (see https://github.com/Leaflet/Leaflet/issues/7012#issuecomment-595087386)
 */ function $3b70d535f70a1c6e$var$makeDblclick(event) {
    // in modern browsers `type` cannot be just overridden:
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Errors/Getter_only
    var newEvent = {}, prop, i;
    for(i in event){
        prop = event[i];
        newEvent[i] = prop && prop.bind ? prop.bind(event) : prop;
    }
    event = newEvent;
    newEvent.type = "dblclick";
    newEvent.detail = 2;
    newEvent.isTrusted = false;
    newEvent._simulated = true; // for debug purposes
    return newEvent;
}
var $3b70d535f70a1c6e$var$delay = 200;
function $3b70d535f70a1c6e$export$21cd263c61b25e59(obj, handler) {
    // Most browsers handle double tap natively
    obj.addEventListener("dblclick", handler);
    // On some platforms the browser doesn't fire native dblclicks for touch events.
    // It seems that in all such cases `detail` property of `click` event is always `1`.
    // So here we rely on that fact to avoid excessive 'dblclick' simulation when not needed.
    var last = 0, detail;
    function simDblclick(e) {
        if (e.detail !== 1) {
            detail = e.detail; // keep in sync to avoid false dblclick in some cases
            return;
        }
        if (e.pointerType === "mouse" || e.sourceCapabilities && !e.sourceCapabilities.firesTouchEvents) return;
        // When clicking on an <input>, the browser generates a click on its
        // <label> (and vice versa) triggering two clicks in quick succession.
        // This ignores clicks on elements which are a label with a 'for'
        // attribute (or children of such a label), but not children of
        // a <input>.
        var path = $2148974bfeaf2ac1$export$3a4b8ff8cd330ea2(e);
        if (path.some(function(el) {
            return el instanceof HTMLLabelElement && el.attributes.for;
        }) && !path.some(function(el) {
            return el instanceof HTMLInputElement || el instanceof HTMLSelectElement;
        })) return;
        var now = Date.now();
        if (now - last <= $3b70d535f70a1c6e$var$delay) {
            detail++;
            if (detail === 2) handler($3b70d535f70a1c6e$var$makeDblclick(e));
        } else detail = 1;
        last = now;
    }
    obj.addEventListener("click", simDblclick);
    return {
        dblclick: handler,
        simDblclick: simDblclick
    };
}
function $3b70d535f70a1c6e$export$59697814537dff5(obj, handlers) {
    obj.removeEventListener("dblclick", handlers.dblclick);
    obj.removeEventListener("click", handlers.simDblclick);
}






var $783b7cedd5fd919a$export$e3fc61237fe28123 = $783b7cedd5fd919a$export$5e36a9b3476148c1([
    "transform",
    "webkitTransform",
    "OTransform",
    "MozTransform",
    "msTransform"
]);
var $783b7cedd5fd919a$export$f2127cf693ff3edc = $783b7cedd5fd919a$export$5e36a9b3476148c1([
    "webkitTransition",
    "transition",
    "OTransition",
    "MozTransition",
    "msTransition"
]);
var $783b7cedd5fd919a$export$2f1790097c50b1a5 = $783b7cedd5fd919a$export$f2127cf693ff3edc === "webkitTransition" || $783b7cedd5fd919a$export$f2127cf693ff3edc === "OTransition" ? $783b7cedd5fd919a$export$f2127cf693ff3edc + "End" : "transitionend";
function $783b7cedd5fd919a$export$3988ae62b71be9a3(id) {
    return typeof id === "string" ? document.getElementById(id) : id;
}
function $783b7cedd5fd919a$export$3d2f074408bd1b82(el, style) {
    var value = el.style[style] || el.currentStyle && el.currentStyle[style];
    if ((!value || value === "auto") && document.defaultView) {
        var css = document.defaultView.getComputedStyle(el, null);
        value = css ? css[style] : null;
    }
    return value === "auto" ? null : value;
}
function $783b7cedd5fd919a$export$185802fd694ee1f5(tagName, className, container) {
    var el = document.createElement(tagName);
    el.className = className || "";
    if (container) container.appendChild(el);
    return el;
}
function $783b7cedd5fd919a$export$cd7f480d6b8286c3(el) {
    var parent = el.parentNode;
    if (parent) parent.removeChild(el);
}
function $783b7cedd5fd919a$export$6e22c362a0406a2c(el) {
    while(el.firstChild)el.removeChild(el.firstChild);
}
function $783b7cedd5fd919a$export$967ea9e64a77dad2(el) {
    var parent = el.parentNode;
    if (parent && parent.lastChild !== el) parent.appendChild(el);
}
function $783b7cedd5fd919a$export$4d34781508fd70d9(el) {
    var parent = el.parentNode;
    if (parent && parent.firstChild !== el) parent.insertBefore(el, parent.firstChild);
}
function $783b7cedd5fd919a$export$4ea3d958472af68f(el, name) {
    if (el.classList !== undefined) return el.classList.contains(name);
    var className = $783b7cedd5fd919a$export$d39d7c22acbe0a14(el);
    return className.length > 0 && new RegExp("(^|\\s)" + name + "(\\s|$)").test(className);
}
function $783b7cedd5fd919a$export$d2cf6cd1dc7067d3(el, name) {
    if (el.classList !== undefined) {
        var classes = $13bbd556cd7cee10$export$3ea6d3c1e1f67aaa(name);
        for(var i = 0, len = classes.length; i < len; i++)el.classList.add(classes[i]);
    } else if (!$783b7cedd5fd919a$export$4ea3d958472af68f(el, name)) {
        var className = $783b7cedd5fd919a$export$d39d7c22acbe0a14(el);
        $783b7cedd5fd919a$export$2796c4ce44e61efa(el, (className ? className + " " : "") + name);
    }
}
function $783b7cedd5fd919a$export$c2255604a80b4506(el, name) {
    if (el.classList !== undefined) el.classList.remove(name);
    else $783b7cedd5fd919a$export$2796c4ce44e61efa(el, $13bbd556cd7cee10$export$87c2784dc9fc4ab((" " + $783b7cedd5fd919a$export$d39d7c22acbe0a14(el) + " ").replace(" " + name + " ", " ")));
}
function $783b7cedd5fd919a$export$2796c4ce44e61efa(el, name) {
    if (el.className.baseVal === undefined) el.className = name;
    else // in case of SVG element
    el.className.baseVal = name;
}
function $783b7cedd5fd919a$export$d39d7c22acbe0a14(el) {
    // Check if the element is an SVGElementInstance and use the correspondingElement instead
    // (Required for linked SVG elements in IE11.)
    if (el.correspondingElement) el = el.correspondingElement;
    return el.className.baseVal === undefined ? el.className : el.className.baseVal;
}
function $783b7cedd5fd919a$export$2646c6b151d2e8(el, value) {
    if ("opacity" in el.style) el.style.opacity = value;
    else if ("filter" in el.style) $783b7cedd5fd919a$var$_setOpacityIE(el, value);
}
function $783b7cedd5fd919a$var$_setOpacityIE(el, value) {
    var filter = false, filterName = "DXImageTransform.Microsoft.Alpha";
    // filters collection throws an error if we try to retrieve a filter that doesn't exist
    try {
        filter = el.filters.item(filterName);
    } catch (e) {
        // don't set opacity to 1 if we haven't already set an opacity,
        // it isn't needed and breaks transparent pngs.
        if (value === 1) return;
    }
    value = Math.round(value * 100);
    if (filter) {
        filter.Enabled = value !== 100;
        filter.Opacity = value;
    } else el.style.filter += " progid:" + filterName + "(opacity=" + value + ")";
}
function $783b7cedd5fd919a$export$5e36a9b3476148c1(props) {
    var style = document.documentElement.style;
    for(var i = 0; i < props.length; i++){
        if (props[i] in style) return props[i];
    }
    return false;
}
function $783b7cedd5fd919a$export$ff09356c35bee89b(el, offset, scale) {
    var pos = offset || new (0, $b802e4aa6d666b45$export$baf26146a414f24a)(0, 0);
    el.style[$783b7cedd5fd919a$export$e3fc61237fe28123] = ((0, $bda63d751c06734c$export$2e2bcd8739ae039).ie3d ? "translate(" + pos.x + "px," + pos.y + "px)" : "translate3d(" + pos.x + "px," + pos.y + "px,0)") + (scale ? " scale(" + scale + ")" : "");
}
function $783b7cedd5fd919a$export$f9b088a47202d605(el, point) {
    /*eslint-disable */ el._leaflet_pos = point;
    /* eslint-enable */ if ((0, $bda63d751c06734c$export$2e2bcd8739ae039).any3d) $783b7cedd5fd919a$export$ff09356c35bee89b(el, point);
    else {
        el.style.left = point.x + "px";
        el.style.top = point.y + "px";
    }
}
function $783b7cedd5fd919a$export$1690e12b840569b9(el) {
    // this method is only used for elements previously positioned using setPosition,
    // so it's safe to cache the position for performance
    return el._leaflet_pos || new (0, $b802e4aa6d666b45$export$baf26146a414f24a)(0, 0);
}
var $783b7cedd5fd919a$export$16a4697467175487;
var $783b7cedd5fd919a$export$b1bf1c69425cc693;
var $783b7cedd5fd919a$var$_userSelect;
if ("onselectstart" in document) {
    $783b7cedd5fd919a$export$16a4697467175487 = function() {
        $2148974bfeaf2ac1$export$af631764ddc44097(window, "selectstart", $2148974bfeaf2ac1$export$fa3b29edae795ef4);
    };
    $783b7cedd5fd919a$export$b1bf1c69425cc693 = function() {
        $2148974bfeaf2ac1$export$8c8705df4a2dcec9(window, "selectstart", $2148974bfeaf2ac1$export$fa3b29edae795ef4);
    };
} else {
    var $783b7cedd5fd919a$var$userSelectProperty = $783b7cedd5fd919a$export$5e36a9b3476148c1([
        "userSelect",
        "WebkitUserSelect",
        "OUserSelect",
        "MozUserSelect",
        "msUserSelect"
    ]);
    $783b7cedd5fd919a$export$16a4697467175487 = function() {
        if ($783b7cedd5fd919a$var$userSelectProperty) {
            var style = document.documentElement.style;
            $783b7cedd5fd919a$var$_userSelect = style[$783b7cedd5fd919a$var$userSelectProperty];
            style[$783b7cedd5fd919a$var$userSelectProperty] = "none";
        }
    };
    $783b7cedd5fd919a$export$b1bf1c69425cc693 = function() {
        if ($783b7cedd5fd919a$var$userSelectProperty) {
            document.documentElement.style[$783b7cedd5fd919a$var$userSelectProperty] = $783b7cedd5fd919a$var$_userSelect;
            $783b7cedd5fd919a$var$_userSelect = undefined;
        }
    };
}
function $783b7cedd5fd919a$export$188eb2a17526281() {
    $2148974bfeaf2ac1$export$af631764ddc44097(window, "dragstart", $2148974bfeaf2ac1$export$fa3b29edae795ef4);
}
function $783b7cedd5fd919a$export$f5ef98e1c9198e63() {
    $2148974bfeaf2ac1$export$8c8705df4a2dcec9(window, "dragstart", $2148974bfeaf2ac1$export$fa3b29edae795ef4);
}
var $783b7cedd5fd919a$var$_outlineElement, $783b7cedd5fd919a$var$_outlineStyle;
function $783b7cedd5fd919a$export$73d26a0c96b464b6(element) {
    while(element.tabIndex === -1)element = element.parentNode;
    if (!element.style) return;
    $783b7cedd5fd919a$export$fa2411f9885e5b98();
    $783b7cedd5fd919a$var$_outlineElement = element;
    $783b7cedd5fd919a$var$_outlineStyle = element.style.outlineStyle;
    element.style.outlineStyle = "none";
    $2148974bfeaf2ac1$export$af631764ddc44097(window, "keydown", $783b7cedd5fd919a$export$fa2411f9885e5b98);
}
function $783b7cedd5fd919a$export$fa2411f9885e5b98() {
    if (!$783b7cedd5fd919a$var$_outlineElement) return;
    $783b7cedd5fd919a$var$_outlineElement.style.outlineStyle = $783b7cedd5fd919a$var$_outlineStyle;
    $783b7cedd5fd919a$var$_outlineElement = undefined;
    $783b7cedd5fd919a$var$_outlineStyle = undefined;
    $2148974bfeaf2ac1$export$8c8705df4a2dcec9(window, "keydown", $783b7cedd5fd919a$export$fa2411f9885e5b98);
}
function $783b7cedd5fd919a$export$d444b651082dbd47(element) {
    do element = element.parentNode;
    while ((!element.offsetWidth || !element.offsetHeight) && element !== document.body);
    return element;
}
function $783b7cedd5fd919a$export$5cdac61cf538712e(element) {
    var rect = element.getBoundingClientRect(); // Read-only in old browsers.
    return {
        x: rect.width / element.offsetWidth || 1,
        y: rect.height / element.offsetHeight || 1,
        boundingClientRect: rect
    };
}


function $2148974bfeaf2ac1$export$af631764ddc44097(obj, types, fn, context) {
    if (types && typeof types === "object") for(var type in types)$2148974bfeaf2ac1$var$addOne(obj, type, types[type], fn);
    else {
        types = $13bbd556cd7cee10$export$3ea6d3c1e1f67aaa(types);
        for(var i = 0, len = types.length; i < len; i++)$2148974bfeaf2ac1$var$addOne(obj, types[i], fn, context);
    }
    return this;
}
var $2148974bfeaf2ac1$var$eventsKey = "_leaflet_events";
function $2148974bfeaf2ac1$export$8c8705df4a2dcec9(obj, types, fn, context) {
    if (arguments.length === 1) {
        $2148974bfeaf2ac1$var$batchRemove(obj);
        delete obj[$2148974bfeaf2ac1$var$eventsKey];
    } else if (types && typeof types === "object") for(var type in types)$2148974bfeaf2ac1$var$removeOne(obj, type, types[type], fn);
    else {
        types = $13bbd556cd7cee10$export$3ea6d3c1e1f67aaa(types);
        if (arguments.length === 2) $2148974bfeaf2ac1$var$batchRemove(obj, function(type) {
            return $13bbd556cd7cee10$export$305f7d4e9d4624f2(types, type) !== -1;
        });
        else for(var i = 0, len = types.length; i < len; i++)$2148974bfeaf2ac1$var$removeOne(obj, types[i], fn, context);
    }
    return this;
}
function $2148974bfeaf2ac1$var$batchRemove(obj, filterFn) {
    for(var id in obj[$2148974bfeaf2ac1$var$eventsKey]){
        var type = id.split(/\d/)[0];
        if (!filterFn || filterFn(type)) $2148974bfeaf2ac1$var$removeOne(obj, type, null, null, id);
    }
}
var $2148974bfeaf2ac1$var$mouseSubst = {
    mouseenter: "mouseover",
    mouseleave: "mouseout",
    wheel: !("onwheel" in window) && "mousewheel"
};
function $2148974bfeaf2ac1$var$addOne(obj, type, fn, context) {
    var id = type + $13bbd556cd7cee10$export$bd3fba034e28f6b(fn) + (context ? "_" + $13bbd556cd7cee10$export$bd3fba034e28f6b(context) : "");
    if (obj[$2148974bfeaf2ac1$var$eventsKey] && obj[$2148974bfeaf2ac1$var$eventsKey][id]) return this;
    var handler = function(e) {
        return fn.call(context || obj, e || window.event);
    };
    var originalHandler = handler;
    if (!(0, $bda63d751c06734c$export$2e2bcd8739ae039).touchNative && (0, $bda63d751c06734c$export$2e2bcd8739ae039).pointer && type.indexOf("touch") === 0) // Needs DomEvent.Pointer.js
    handler = (0, $c416047e98ea263a$export$a6463408b660293c)(obj, type, handler);
    else if ((0, $bda63d751c06734c$export$2e2bcd8739ae039).touch && type === "dblclick") handler = (0, $3b70d535f70a1c6e$export$21cd263c61b25e59)(obj, handler);
    else if ("addEventListener" in obj) {
        if (type === "touchstart" || type === "touchmove" || type === "wheel" || type === "mousewheel") obj.addEventListener($2148974bfeaf2ac1$var$mouseSubst[type] || type, handler, (0, $bda63d751c06734c$export$2e2bcd8739ae039).passiveEvents ? {
            passive: false
        } : false);
        else if (type === "mouseenter" || type === "mouseleave") {
            handler = function(e) {
                e = e || window.event;
                if ($2148974bfeaf2ac1$export$de90706eda23efa2(obj, e)) originalHandler(e);
            };
            obj.addEventListener($2148974bfeaf2ac1$var$mouseSubst[type], handler, false);
        } else obj.addEventListener(type, originalHandler, false);
    } else obj.attachEvent("on" + type, handler);
    obj[$2148974bfeaf2ac1$var$eventsKey] = obj[$2148974bfeaf2ac1$var$eventsKey] || {};
    obj[$2148974bfeaf2ac1$var$eventsKey][id] = handler;
}
function $2148974bfeaf2ac1$var$removeOne(obj, type, fn, context, id) {
    id = id || type + $13bbd556cd7cee10$export$bd3fba034e28f6b(fn) + (context ? "_" + $13bbd556cd7cee10$export$bd3fba034e28f6b(context) : "");
    var handler = obj[$2148974bfeaf2ac1$var$eventsKey] && obj[$2148974bfeaf2ac1$var$eventsKey][id];
    if (!handler) return this;
    if (!(0, $bda63d751c06734c$export$2e2bcd8739ae039).touchNative && (0, $bda63d751c06734c$export$2e2bcd8739ae039).pointer && type.indexOf("touch") === 0) (0, $c416047e98ea263a$export$b9716686da018371)(obj, type, handler);
    else if ((0, $bda63d751c06734c$export$2e2bcd8739ae039).touch && type === "dblclick") (0, $3b70d535f70a1c6e$export$59697814537dff5)(obj, handler);
    else if ("removeEventListener" in obj) obj.removeEventListener($2148974bfeaf2ac1$var$mouseSubst[type] || type, handler, false);
    else obj.detachEvent("on" + type, handler);
    obj[$2148974bfeaf2ac1$var$eventsKey][id] = null;
}
function $2148974bfeaf2ac1$export$51134cce184326b9(e) {
    if (e.stopPropagation) e.stopPropagation();
    else if (e.originalEvent) e.originalEvent._stopped = true;
    else e.cancelBubble = true;
    return this;
}
function $2148974bfeaf2ac1$export$383a0f6cce2d3ccb(el) {
    $2148974bfeaf2ac1$var$addOne(el, "wheel", $2148974bfeaf2ac1$export$51134cce184326b9);
    return this;
}
function $2148974bfeaf2ac1$export$a640b530813b3952(el) {
    $2148974bfeaf2ac1$export$af631764ddc44097(el, "mousedown touchstart dblclick contextmenu", $2148974bfeaf2ac1$export$51134cce184326b9);
    el["_leaflet_disable_click"] = true;
    return this;
}
function $2148974bfeaf2ac1$export$fa3b29edae795ef4(e) {
    if (e.preventDefault) e.preventDefault();
    else e.returnValue = false;
    return this;
}
function $2148974bfeaf2ac1$export$fa6813432f753b0d(e) {
    $2148974bfeaf2ac1$export$fa3b29edae795ef4(e);
    $2148974bfeaf2ac1$export$51134cce184326b9(e);
    return this;
}
function $2148974bfeaf2ac1$export$3a4b8ff8cd330ea2(ev) {
    if (ev.composedPath) return ev.composedPath();
    var path = [];
    var el = ev.target;
    while(el){
        path.push(el);
        el = el.parentNode;
    }
    return path;
}
function $2148974bfeaf2ac1$export$642213d516a9b928(e, container) {
    if (!container) return new (0, $b802e4aa6d666b45$export$baf26146a414f24a)(e.clientX, e.clientY);
    var scale = (0, $783b7cedd5fd919a$export$5cdac61cf538712e)(container), offset = scale.boundingClientRect; // left and top  values are in page scale (like the event clientX/Y)
    return new (0, $b802e4aa6d666b45$export$baf26146a414f24a)(// offset.left/top values are in page scale (like clientX/Y),
    // whereas clientLeft/Top (border width) values are the original values (before CSS scale applies).
    (e.clientX - offset.left) / scale.x - container.clientLeft, (e.clientY - offset.top) / scale.y - container.clientTop);
}
//  except , Safari and
// We need double the scroll pixels (see #7403 and #4538) for all Browsers
// except OSX (Mac) -> 3x, Chrome running on Linux 1x
var $2148974bfeaf2ac1$var$wheelPxFactor = (0, $bda63d751c06734c$export$2e2bcd8739ae039).linux && (0, $bda63d751c06734c$export$2e2bcd8739ae039).chrome ? window.devicePixelRatio : (0, $bda63d751c06734c$export$2e2bcd8739ae039).mac ? window.devicePixelRatio * 3 : window.devicePixelRatio > 0 ? 2 * window.devicePixelRatio : 1;
function $2148974bfeaf2ac1$export$99de932e438a9331(e) {
    return (0, $bda63d751c06734c$export$2e2bcd8739ae039).edge ? e.wheelDeltaY / 2 : e.deltaY && e.deltaMode === 0 ? -e.deltaY / $2148974bfeaf2ac1$var$wheelPxFactor : e.deltaY && e.deltaMode === 1 ? -e.deltaY * 20 : e.deltaY && e.deltaMode === 2 ? -e.deltaY * 60 : e.deltaX || e.deltaZ ? 0 : e.wheelDelta ? (e.wheelDeltaY || e.wheelDelta) / 2 : e.detail && Math.abs(e.detail) < 32765 ? -e.detail * 20 : e.detail ? e.detail / -32765 * 60 : 0;
}
function $2148974bfeaf2ac1$export$de90706eda23efa2(el, e) {
    var related = e.relatedTarget;
    if (!related) return true;
    try {
        while(related && related !== el)related = related.parentNode;
    } catch (err) {
        return false;
    }
    return related !== el;
}






var $f8eff9302bd8deb5$export$51243ffcd383b20 = (0, $ca4bf785aeb0758d$export$ebcc362d8f4c4311).extend({
    // @method run(el: HTMLElement, newPos: Point, duration?: Number, easeLinearity?: Number)
    // Run an animation of a given element to a new position, optionally setting
    // duration in seconds (`0.25` by default) and easing linearity factor (3rd
    // argument of the [cubic bezier curve](https://cubic-bezier.com/#0,0,.5,1),
    // `0.5` by default).
    run: function(el, newPos, duration, easeLinearity) {
        this.stop();
        this._el = el;
        this._inProgress = true;
        this._duration = duration || 0.25;
        this._easeOutPower = 1 / Math.max(easeLinearity || 0.5, 0.2);
        this._startPos = $783b7cedd5fd919a$export$1690e12b840569b9(el);
        this._offset = newPos.subtract(this._startPos);
        this._startTime = +new Date();
        // @event start: Event
        // Fired when the animation starts
        this.fire("start");
        this._animate();
    },
    // @method stop()
    // Stops the animation (if currently running).
    stop: function() {
        if (!this._inProgress) return;
        this._step(true);
        this._complete();
    },
    _animate: function() {
        // animation loop
        this._animId = $13bbd556cd7cee10$export$d371ad015c199c06(this._animate, this);
        this._step();
    },
    _step: function(round) {
        var elapsed = +new Date() - this._startTime, duration = this._duration * 1000;
        if (elapsed < duration) this._runFrame(this._easeOut(elapsed / duration), round);
        else {
            this._runFrame(1);
            this._complete();
        }
    },
    _runFrame: function(progress, round) {
        var pos = this._startPos.add(this._offset.multiplyBy(progress));
        if (round) pos._round();
        $783b7cedd5fd919a$export$f9b088a47202d605(this._el, pos);
        // @event step: Event
        // Fired continuously during the animation.
        this.fire("step");
    },
    _complete: function() {
        $13bbd556cd7cee10$export$e1ed83507f55dc9d(this._animId);
        this._inProgress = false;
        // @event end: Event
        // Fired when the animation ends.
        this.fire("end");
    },
    _easeOut: function(t) {
        return 1 - Math.pow(1 - t, this._easeOutPower);
    }
});


var $7d9a54c6488daf4f$export$a5c7b93649eaf8f8 = (0, $ca4bf785aeb0758d$export$ebcc362d8f4c4311).extend({
    options: {
        // @section Map State Options
        // @option crs: CRS = L.CRS.EPSG3857
        // The [Coordinate Reference System](#crs) to use. Don't change this if you're not
        // sure what it means.
        crs: (0, $c02c17eb3d2fe7a7$export$fa530d80b080b222),
        // @option center: LatLng = undefined
        // Initial geographic center of the map
        center: undefined,
        // @option zoom: Number = undefined
        // Initial map zoom level
        zoom: undefined,
        // @option minZoom: Number = *
        // Minimum zoom level of the map.
        // If not specified and at least one `GridLayer` or `TileLayer` is in the map,
        // the lowest of their `minZoom` options will be used instead.
        minZoom: undefined,
        // @option maxZoom: Number = *
        // Maximum zoom level of the map.
        // If not specified and at least one `GridLayer` or `TileLayer` is in the map,
        // the highest of their `maxZoom` options will be used instead.
        maxZoom: undefined,
        // @option layers: Layer[] = []
        // Array of layers that will be added to the map initially
        layers: [],
        // @option maxBounds: LatLngBounds = null
        // When this option is set, the map restricts the view to the given
        // geographical bounds, bouncing the user back if the user tries to pan
        // outside the view. To set the restriction dynamically, use
        // [`setMaxBounds`](#map-setmaxbounds) method.
        maxBounds: undefined,
        // @option renderer: Renderer = *
        // The default method for drawing vector layers on the map. `L.SVG`
        // or `L.Canvas` by default depending on browser support.
        renderer: undefined,
        // @section Animation Options
        // @option zoomAnimation: Boolean = true
        // Whether the map zoom animation is enabled. By default it's enabled
        // in all browsers that support CSS3 Transitions except Android.
        zoomAnimation: true,
        // @option zoomAnimationThreshold: Number = 4
        // Won't animate zoom if the zoom difference exceeds this value.
        zoomAnimationThreshold: 4,
        // @option fadeAnimation: Boolean = true
        // Whether the tile fade animation is enabled. By default it's enabled
        // in all browsers that support CSS3 Transitions except Android.
        fadeAnimation: true,
        // @option markerZoomAnimation: Boolean = true
        // Whether markers animate their zoom with the zoom animation, if disabled
        // they will disappear for the length of the animation. By default it's
        // enabled in all browsers that support CSS3 Transitions except Android.
        markerZoomAnimation: true,
        // @option transform3DLimit: Number = 2^23
        // Defines the maximum size of a CSS translation transform. The default
        // value should not be changed unless a web browser positions layers in
        // the wrong place after doing a large `panBy`.
        transform3DLimit: 8388608,
        // @section Interaction Options
        // @option zoomSnap: Number = 1
        // Forces the map's zoom level to always be a multiple of this, particularly
        // right after a [`fitBounds()`](#map-fitbounds) or a pinch-zoom.
        // By default, the zoom level snaps to the nearest integer; lower values
        // (e.g. `0.5` or `0.1`) allow for greater granularity. A value of `0`
        // means the zoom level will not be snapped after `fitBounds` or a pinch-zoom.
        zoomSnap: 1,
        // @option zoomDelta: Number = 1
        // Controls how much the map's zoom level will change after a
        // [`zoomIn()`](#map-zoomin), [`zoomOut()`](#map-zoomout), pressing `+`
        // or `-` on the keyboard, or using the [zoom controls](#control-zoom).
        // Values smaller than `1` (e.g. `0.5`) allow for greater granularity.
        zoomDelta: 1,
        // @option trackResize: Boolean = true
        // Whether the map automatically handles browser window resize to update itself.
        trackResize: true
    },
    initialize: function(id, options) {
        options = $13bbd556cd7cee10$export$add91eafeaeab287(this, options);
        // Make sure to assign internal flags at the beginning,
        // to avoid inconsistent state in some edge cases.
        this._handlers = [];
        this._layers = {};
        this._zoomBoundLayers = {};
        this._sizeChanged = true;
        this._initContainer(id);
        this._initLayout();
        // hack for https://github.com/Leaflet/Leaflet/issues/1980
        this._onResize = $13bbd556cd7cee10$export$2385a24977818dd0(this._onResize, this);
        this._initEvents();
        if (options.maxBounds) this.setMaxBounds(options.maxBounds);
        if (options.zoom !== undefined) this._zoom = this._limitZoom(options.zoom);
        if (options.center && options.zoom !== undefined) this.setView((0, $df6fd3b1bc3e4292$export$a192f247fc7a2057)(options.center), options.zoom, {
            reset: true
        });
        this.callInitHooks();
        // don't animate on browsers without hardware-accelerated transitions or old Android/Opera
        this._zoomAnimated = $783b7cedd5fd919a$export$f2127cf693ff3edc && (0, $bda63d751c06734c$export$2e2bcd8739ae039).any3d && !(0, $bda63d751c06734c$export$2e2bcd8739ae039).mobileOpera && this.options.zoomAnimation;
        // zoom transitions run with the same duration for all layers, so if one of transitionend events
        // happens after starting zoom animation (propagating to the map pane), we know that it ended globally
        if (this._zoomAnimated) {
            this._createAnimProxy();
            $2148974bfeaf2ac1$export$af631764ddc44097(this._proxy, $783b7cedd5fd919a$export$2f1790097c50b1a5, this._catchTransitionEnd, this);
        }
        this._addLayers(this.options.layers);
    },
    // @section Methods for modifying map state
    // @method setView(center: LatLng, zoom: Number, options?: Zoom/pan options): this
    // Sets the view of the map (geographical center and zoom) with the given
    // animation options.
    setView: function(center, zoom, options) {
        zoom = zoom === undefined ? this._zoom : this._limitZoom(zoom);
        center = this._limitCenter((0, $df6fd3b1bc3e4292$export$a192f247fc7a2057)(center), zoom, this.options.maxBounds);
        options = options || {};
        this._stop();
        if (this._loaded && !options.reset && options !== true) {
            if (options.animate !== undefined) {
                options.zoom = $13bbd556cd7cee10$export$8b58be045bf06082({
                    animate: options.animate
                }, options.zoom);
                options.pan = $13bbd556cd7cee10$export$8b58be045bf06082({
                    animate: options.animate,
                    duration: options.duration
                }, options.pan);
            }
            // try animating pan or zoom
            var moved = this._zoom !== zoom ? this._tryAnimatedZoom && this._tryAnimatedZoom(center, zoom, options.zoom) : this._tryAnimatedPan(center, options.pan);
            if (moved) {
                // prevent resize handler call, the view will refresh after animation anyway
                clearTimeout(this._sizeTimer);
                return this;
            }
        }
        // animation didn't start, just reset the map view
        this._resetView(center, zoom, options.pan && options.pan.noMoveStart);
        return this;
    },
    // @method setZoom(zoom: Number, options?: Zoom/pan options): this
    // Sets the zoom of the map.
    setZoom: function(zoom, options) {
        if (!this._loaded) {
            this._zoom = zoom;
            return this;
        }
        return this.setView(this.getCenter(), zoom, {
            zoom: options
        });
    },
    // @method zoomIn(delta?: Number, options?: Zoom options): this
    // Increases the zoom of the map by `delta` ([`zoomDelta`](#map-zoomdelta) by default).
    zoomIn: function(delta, options) {
        delta = delta || ((0, $bda63d751c06734c$export$2e2bcd8739ae039).any3d ? this.options.zoomDelta : 1);
        return this.setZoom(this._zoom + delta, options);
    },
    // @method zoomOut(delta?: Number, options?: Zoom options): this
    // Decreases the zoom of the map by `delta` ([`zoomDelta`](#map-zoomdelta) by default).
    zoomOut: function(delta, options) {
        delta = delta || ((0, $bda63d751c06734c$export$2e2bcd8739ae039).any3d ? this.options.zoomDelta : 1);
        return this.setZoom(this._zoom - delta, options);
    },
    // @method setZoomAround(latlng: LatLng, zoom: Number, options: Zoom options): this
    // Zooms the map while keeping a specified geographical point on the map
    // stationary (e.g. used internally for scroll zoom and double-click zoom).
    // @alternative
    // @method setZoomAround(offset: Point, zoom: Number, options: Zoom options): this
    // Zooms the map while keeping a specified pixel on the map (relative to the top-left corner) stationary.
    setZoomAround: function(latlng, zoom, options) {
        var scale = this.getZoomScale(zoom), viewHalf = this.getSize().divideBy(2), containerPoint = latlng instanceof (0, $b802e4aa6d666b45$export$baf26146a414f24a) ? latlng : this.latLngToContainerPoint(latlng), centerOffset = containerPoint.subtract(viewHalf).multiplyBy(1 - 1 / scale), newCenter = this.containerPointToLatLng(viewHalf.add(centerOffset));
        return this.setView(newCenter, zoom, {
            zoom: options
        });
    },
    _getBoundsCenterZoom: function(bounds, options) {
        options = options || {};
        bounds = bounds.getBounds ? bounds.getBounds() : (0, $c1a09dde0ebe0161$export$4904432a68b0399)(bounds);
        var paddingTL = (0, $b802e4aa6d666b45$export$b63cca88ddc558a9)(options.paddingTopLeft || options.padding || [
            0,
            0
        ]), paddingBR = (0, $b802e4aa6d666b45$export$b63cca88ddc558a9)(options.paddingBottomRight || options.padding || [
            0,
            0
        ]), zoom = this.getBoundsZoom(bounds, false, paddingTL.add(paddingBR));
        zoom = typeof options.maxZoom === "number" ? Math.min(options.maxZoom, zoom) : zoom;
        if (zoom === Infinity) return {
            center: bounds.getCenter(),
            zoom: zoom
        };
        var paddingOffset = paddingBR.subtract(paddingTL).divideBy(2), swPoint = this.project(bounds.getSouthWest(), zoom), nePoint = this.project(bounds.getNorthEast(), zoom), center = this.unproject(swPoint.add(nePoint).divideBy(2).add(paddingOffset), zoom);
        return {
            center: center,
            zoom: zoom
        };
    },
    // @method fitBounds(bounds: LatLngBounds, options?: fitBounds options): this
    // Sets a map view that contains the given geographical bounds with the
    // maximum zoom level possible.
    fitBounds: function(bounds, options) {
        bounds = (0, $c1a09dde0ebe0161$export$4904432a68b0399)(bounds);
        if (!bounds.isValid()) throw new Error("Bounds are not valid.");
        var target = this._getBoundsCenterZoom(bounds, options);
        return this.setView(target.center, target.zoom, options);
    },
    // @method fitWorld(options?: fitBounds options): this
    // Sets a map view that mostly contains the whole world with the maximum
    // zoom level possible.
    fitWorld: function(options) {
        return this.fitBounds([
            [
                -90,
                -180
            ],
            [
                90,
                180
            ]
        ], options);
    },
    // @method panTo(latlng: LatLng, options?: Pan options): this
    // Pans the map to a given center.
    panTo: function(center, options) {
        return this.setView(center, this._zoom, {
            pan: options
        });
    },
    // @method panBy(offset: Point, options?: Pan options): this
    // Pans the map by a given number of pixels (animated).
    panBy: function(offset, options) {
        offset = (0, $b802e4aa6d666b45$export$b63cca88ddc558a9)(offset).round();
        options = options || {};
        if (!offset.x && !offset.y) return this.fire("moveend");
        // If we pan too far, Chrome gets issues with tiles
        // and makes them disappear or appear in the wrong place (slightly offset) #2602
        if (options.animate !== true && !this.getSize().contains(offset)) {
            this._resetView(this.unproject(this.project(this.getCenter()).add(offset)), this.getZoom());
            return this;
        }
        if (!this._panAnim) {
            this._panAnim = new (0, $f8eff9302bd8deb5$export$51243ffcd383b20)();
            this._panAnim.on({
                "step": this._onPanTransitionStep,
                "end": this._onPanTransitionEnd
            }, this);
        }
        // don't fire movestart if animating inertia
        if (!options.noMoveStart) this.fire("movestart");
        // animate pan unless animate: false specified
        if (options.animate !== false) {
            $783b7cedd5fd919a$export$d2cf6cd1dc7067d3(this._mapPane, "leaflet-pan-anim");
            var newPos = this._getMapPanePos().subtract(offset).round();
            this._panAnim.run(this._mapPane, newPos, options.duration || 0.25, options.easeLinearity);
        } else {
            this._rawPanBy(offset);
            this.fire("move").fire("moveend");
        }
        return this;
    },
    // @method flyTo(latlng: LatLng, zoom?: Number, options?: Zoom/pan options): this
    // Sets the view of the map (geographical center and zoom) performing a smooth
    // pan-zoom animation.
    flyTo: function(targetCenter, targetZoom, options) {
        options = options || {};
        if (options.animate === false || !(0, $bda63d751c06734c$export$2e2bcd8739ae039).any3d) return this.setView(targetCenter, targetZoom, options);
        this._stop();
        var from = this.project(this.getCenter()), to = this.project(targetCenter), size = this.getSize(), startZoom = this._zoom;
        targetCenter = (0, $df6fd3b1bc3e4292$export$a192f247fc7a2057)(targetCenter);
        targetZoom = targetZoom === undefined ? startZoom : targetZoom;
        var w0 = Math.max(size.x, size.y), w1 = w0 * this.getZoomScale(startZoom, targetZoom), u1 = to.distanceTo(from) || 1, rho = 1.42, rho2 = rho * rho;
        function r(i) {
            var s1 = i ? -1 : 1, s2 = i ? w1 : w0, t1 = w1 * w1 - w0 * w0 + s1 * rho2 * rho2 * u1 * u1, b1 = 2 * s2 * rho2 * u1, b = t1 / b1, sq = Math.sqrt(b * b + 1) - b;
            // workaround for floating point precision bug when sq = 0, log = -Infinite,
            // thus triggering an infinite loop in flyTo
            var log = sq < 0.000000001 ? -18 : Math.log(sq);
            return log;
        }
        function sinh(n) {
            return (Math.exp(n) - Math.exp(-n)) / 2;
        }
        function cosh(n) {
            return (Math.exp(n) + Math.exp(-n)) / 2;
        }
        function tanh(n) {
            return sinh(n) / cosh(n);
        }
        var r0 = r(0);
        function w(s) {
            return w0 * (cosh(r0) / cosh(r0 + rho * s));
        }
        function u(s) {
            return w0 * (cosh(r0) * tanh(r0 + rho * s) - sinh(r0)) / rho2;
        }
        function easeOut(t) {
            return 1 - Math.pow(1 - t, 1.5);
        }
        var start = Date.now(), S = (r(1) - r0) / rho, duration = options.duration ? 1000 * options.duration : 1000 * S * 0.8;
        function frame() {
            var t = (Date.now() - start) / duration, s = easeOut(t) * S;
            if (t <= 1) {
                this._flyToFrame = $13bbd556cd7cee10$export$d371ad015c199c06(frame, this);
                this._move(this.unproject(from.add(to.subtract(from).multiplyBy(u(s) / u1)), startZoom), this.getScaleZoom(w0 / w(s), startZoom), {
                    flyTo: true
                });
            } else this._move(targetCenter, targetZoom)._moveEnd(true);
        }
        this._moveStart(true, options.noMoveStart);
        frame.call(this);
        return this;
    },
    // @method flyToBounds(bounds: LatLngBounds, options?: fitBounds options): this
    // Sets the view of the map with a smooth animation like [`flyTo`](#map-flyto),
    // but takes a bounds parameter like [`fitBounds`](#map-fitbounds).
    flyToBounds: function(bounds, options) {
        var target = this._getBoundsCenterZoom(bounds, options);
        return this.flyTo(target.center, target.zoom, options);
    },
    // @method setMaxBounds(bounds: LatLngBounds): this
    // Restricts the map view to the given bounds (see the [maxBounds](#map-maxbounds) option).
    setMaxBounds: function(bounds) {
        bounds = (0, $c1a09dde0ebe0161$export$4904432a68b0399)(bounds);
        if (this.listens("moveend", this._panInsideMaxBounds)) this.off("moveend", this._panInsideMaxBounds);
        if (!bounds.isValid()) {
            this.options.maxBounds = null;
            return this;
        }
        this.options.maxBounds = bounds;
        if (this._loaded) this._panInsideMaxBounds();
        return this.on("moveend", this._panInsideMaxBounds);
    },
    // @method setMinZoom(zoom: Number): this
    // Sets the lower limit for the available zoom levels (see the [minZoom](#map-minzoom) option).
    setMinZoom: function(zoom) {
        var oldZoom = this.options.minZoom;
        this.options.minZoom = zoom;
        if (this._loaded && oldZoom !== zoom) {
            this.fire("zoomlevelschange");
            if (this.getZoom() < this.options.minZoom) return this.setZoom(zoom);
        }
        return this;
    },
    // @method setMaxZoom(zoom: Number): this
    // Sets the upper limit for the available zoom levels (see the [maxZoom](#map-maxzoom) option).
    setMaxZoom: function(zoom) {
        var oldZoom = this.options.maxZoom;
        this.options.maxZoom = zoom;
        if (this._loaded && oldZoom !== zoom) {
            this.fire("zoomlevelschange");
            if (this.getZoom() > this.options.maxZoom) return this.setZoom(zoom);
        }
        return this;
    },
    // @method panInsideBounds(bounds: LatLngBounds, options?: Pan options): this
    // Pans the map to the closest view that would lie inside the given bounds (if it's not already), controlling the animation using the options specific, if any.
    panInsideBounds: function(bounds, options) {
        this._enforcingBounds = true;
        var center = this.getCenter(), newCenter = this._limitCenter(center, this._zoom, (0, $c1a09dde0ebe0161$export$4904432a68b0399)(bounds));
        if (!center.equals(newCenter)) this.panTo(newCenter, options);
        this._enforcingBounds = false;
        return this;
    },
    // @method panInside(latlng: LatLng, options?: padding options): this
    // Pans the map the minimum amount to make the `latlng` visible. Use
    // padding options to fit the display to more restricted bounds.
    // If `latlng` is already within the (optionally padded) display bounds,
    // the map will not be panned.
    panInside: function(latlng, options) {
        options = options || {};
        var paddingTL = (0, $b802e4aa6d666b45$export$b63cca88ddc558a9)(options.paddingTopLeft || options.padding || [
            0,
            0
        ]), paddingBR = (0, $b802e4aa6d666b45$export$b63cca88ddc558a9)(options.paddingBottomRight || options.padding || [
            0,
            0
        ]), pixelCenter = this.project(this.getCenter()), pixelPoint = this.project(latlng), pixelBounds = this.getPixelBounds(), paddedBounds = (0, $2ffe56518af276c5$export$c8e2f7c8aba65b28)([
            pixelBounds.min.add(paddingTL),
            pixelBounds.max.subtract(paddingBR)
        ]), paddedSize = paddedBounds.getSize();
        if (!paddedBounds.contains(pixelPoint)) {
            this._enforcingBounds = true;
            var centerOffset = pixelPoint.subtract(paddedBounds.getCenter());
            var offset = paddedBounds.extend(pixelPoint).getSize().subtract(paddedSize);
            pixelCenter.x += centerOffset.x < 0 ? -offset.x : offset.x;
            pixelCenter.y += centerOffset.y < 0 ? -offset.y : offset.y;
            this.panTo(this.unproject(pixelCenter), options);
            this._enforcingBounds = false;
        }
        return this;
    },
    // @method invalidateSize(options: Zoom/pan options): this
    // Checks if the map container size changed and updates the map if so —
    // call it after you've changed the map size dynamically, also animating
    // pan by default. If `options.pan` is `false`, panning will not occur.
    // If `options.debounceMoveend` is `true`, it will delay `moveend` event so
    // that it doesn't happen often even if the method is called many
    // times in a row.
    // @alternative
    // @method invalidateSize(animate: Boolean): this
    // Checks if the map container size changed and updates the map if so —
    // call it after you've changed the map size dynamically, also animating
    // pan by default.
    invalidateSize: function(options) {
        if (!this._loaded) return this;
        options = $13bbd556cd7cee10$export$8b58be045bf06082({
            animate: false,
            pan: true
        }, options === true ? {
            animate: true
        } : options);
        var oldSize = this.getSize();
        this._sizeChanged = true;
        this._lastCenter = null;
        var newSize = this.getSize(), oldCenter = oldSize.divideBy(2).round(), newCenter = newSize.divideBy(2).round(), offset = oldCenter.subtract(newCenter);
        if (!offset.x && !offset.y) return this;
        if (options.animate && options.pan) this.panBy(offset);
        else {
            if (options.pan) this._rawPanBy(offset);
            this.fire("move");
            if (options.debounceMoveend) {
                clearTimeout(this._sizeTimer);
                this._sizeTimer = setTimeout($13bbd556cd7cee10$export$2385a24977818dd0(this.fire, this, "moveend"), 200);
            } else this.fire("moveend");
        }
        // @section Map state change events
        // @event resize: ResizeEvent
        // Fired when the map is resized.
        return this.fire("resize", {
            oldSize: oldSize,
            newSize: newSize
        });
    },
    // @section Methods for modifying map state
    // @method stop(): this
    // Stops the currently running `panTo` or `flyTo` animation, if any.
    stop: function() {
        this.setZoom(this._limitZoom(this._zoom));
        if (!this.options.zoomSnap) this.fire("viewreset");
        return this._stop();
    },
    // @section Geolocation methods
    // @method locate(options?: Locate options): this
    // Tries to locate the user using the Geolocation API, firing a [`locationfound`](#map-locationfound)
    // event with location data on success or a [`locationerror`](#map-locationerror) event on failure,
    // and optionally sets the map view to the user's location with respect to
    // detection accuracy (or to the world view if geolocation failed).
    // Note that, if your page doesn't use HTTPS, this method will fail in
    // modern browsers ([Chrome 50 and newer](https://sites.google.com/a/chromium.org/dev/Home/chromium-security/deprecating-powerful-features-on-insecure-origins))
    // See `Locate options` for more details.
    locate: function(options) {
        options = this._locateOptions = $13bbd556cd7cee10$export$8b58be045bf06082({
            timeout: 10000,
            watch: false
        }, options);
        if (!("geolocation" in navigator)) {
            this._handleGeolocationError({
                code: 0,
                message: "Geolocation not supported."
            });
            return this;
        }
        var onResponse = $13bbd556cd7cee10$export$2385a24977818dd0(this._handleGeolocationResponse, this), onError = $13bbd556cd7cee10$export$2385a24977818dd0(this._handleGeolocationError, this);
        if (options.watch) this._locationWatchId = navigator.geolocation.watchPosition(onResponse, onError, options);
        else navigator.geolocation.getCurrentPosition(onResponse, onError, options);
        return this;
    },
    // @method stopLocate(): this
    // Stops watching location previously initiated by `map.locate({watch: true})`
    // and aborts resetting the map view if map.locate was called with
    // `{setView: true}`.
    stopLocate: function() {
        if (navigator.geolocation && navigator.geolocation.clearWatch) navigator.geolocation.clearWatch(this._locationWatchId);
        if (this._locateOptions) this._locateOptions.setView = false;
        return this;
    },
    _handleGeolocationError: function(error) {
        if (!this._container._leaflet_id) return;
        var c = error.code, message = error.message || (c === 1 ? "permission denied" : c === 2 ? "position unavailable" : "timeout");
        if (this._locateOptions.setView && !this._loaded) this.fitWorld();
        // @section Location events
        // @event locationerror: ErrorEvent
        // Fired when geolocation (using the [`locate`](#map-locate) method) failed.
        this.fire("locationerror", {
            code: c,
            message: "Geolocation error: " + message + "."
        });
    },
    _handleGeolocationResponse: function(pos) {
        if (!this._container._leaflet_id) return;
        var lat = pos.coords.latitude, lng = pos.coords.longitude, latlng = new (0, $df6fd3b1bc3e4292$export$5fd359ea0b43bded)(lat, lng), bounds = latlng.toBounds(pos.coords.accuracy * 2), options = this._locateOptions;
        if (options.setView) {
            var zoom = this.getBoundsZoom(bounds);
            this.setView(latlng, options.maxZoom ? Math.min(zoom, options.maxZoom) : zoom);
        }
        var data = {
            latlng: latlng,
            bounds: bounds,
            timestamp: pos.timestamp
        };
        for(var i in pos.coords)if (typeof pos.coords[i] === "number") data[i] = pos.coords[i];
        // @event locationfound: LocationEvent
        // Fired when geolocation (using the [`locate`](#map-locate) method)
        // went successfully.
        this.fire("locationfound", data);
    },
    // TODO Appropriate docs section?
    // @section Other Methods
    // @method addHandler(name: String, HandlerClass: Function): this
    // Adds a new `Handler` to the map, given its name and constructor function.
    addHandler: function(name, HandlerClass) {
        if (!HandlerClass) return this;
        var handler = this[name] = new HandlerClass(this);
        this._handlers.push(handler);
        if (this.options[name]) handler.enable();
        return this;
    },
    // @method remove(): this
    // Destroys the map and clears all related event listeners.
    remove: function() {
        this._initEvents(true);
        if (this.options.maxBounds) this.off("moveend", this._panInsideMaxBounds);
        if (this._containerId !== this._container._leaflet_id) throw new Error("Map container is being reused by another instance");
        try {
            // throws error in IE6-8
            delete this._container._leaflet_id;
            delete this._containerId;
        } catch (e) {
            /*eslint-disable */ this._container._leaflet_id = undefined;
            /* eslint-enable */ this._containerId = undefined;
        }
        if (this._locationWatchId !== undefined) this.stopLocate();
        this._stop();
        $783b7cedd5fd919a$export$cd7f480d6b8286c3(this._mapPane);
        if (this._clearControlPos) this._clearControlPos();
        if (this._resizeRequest) {
            $13bbd556cd7cee10$export$e1ed83507f55dc9d(this._resizeRequest);
            this._resizeRequest = null;
        }
        this._clearHandlers();
        if (this._loaded) // @section Map state change events
        // @event unload: Event
        // Fired when the map is destroyed with [remove](#map-remove) method.
        this.fire("unload");
        var i;
        for(i in this._layers)this._layers[i].remove();
        for(i in this._panes)$783b7cedd5fd919a$export$cd7f480d6b8286c3(this._panes[i]);
        this._layers = [];
        this._panes = [];
        delete this._mapPane;
        delete this._renderer;
        return this;
    },
    // @section Other Methods
    // @method createPane(name: String, container?: HTMLElement): HTMLElement
    // Creates a new [map pane](#map-pane) with the given name if it doesn't exist already,
    // then returns it. The pane is created as a child of `container`, or
    // as a child of the main map pane if not set.
    createPane: function(name, container) {
        var className = "leaflet-pane" + (name ? " leaflet-" + name.replace("Pane", "") + "-pane" : ""), pane = $783b7cedd5fd919a$export$185802fd694ee1f5("div", className, container || this._mapPane);
        if (name) this._panes[name] = pane;
        return pane;
    },
    // @section Methods for Getting Map State
    // @method getCenter(): LatLng
    // Returns the geographical center of the map view
    getCenter: function() {
        this._checkIfLoaded();
        if (this._lastCenter && !this._moved()) return this._lastCenter.clone();
        return this.layerPointToLatLng(this._getCenterLayerPoint());
    },
    // @method getZoom(): Number
    // Returns the current zoom level of the map view
    getZoom: function() {
        return this._zoom;
    },
    // @method getBounds(): LatLngBounds
    // Returns the geographical bounds visible in the current map view
    getBounds: function() {
        var bounds = this.getPixelBounds(), sw = this.unproject(bounds.getBottomLeft()), ne = this.unproject(bounds.getTopRight());
        return new (0, $c1a09dde0ebe0161$export$fe84d4076a55a8e6)(sw, ne);
    },
    // @method getMinZoom(): Number
    // Returns the minimum zoom level of the map (if set in the `minZoom` option of the map or of any layers), or `0` by default.
    getMinZoom: function() {
        return this.options.minZoom === undefined ? this._layersMinZoom || 0 : this.options.minZoom;
    },
    // @method getMaxZoom(): Number
    // Returns the maximum zoom level of the map (if set in the `maxZoom` option of the map or of any layers).
    getMaxZoom: function() {
        return this.options.maxZoom === undefined ? this._layersMaxZoom === undefined ? Infinity : this._layersMaxZoom : this.options.maxZoom;
    },
    // @method getBoundsZoom(bounds: LatLngBounds, inside?: Boolean, padding?: Point): Number
    // Returns the maximum zoom level on which the given bounds fit to the map
    // view in its entirety. If `inside` (optional) is set to `true`, the method
    // instead returns the minimum zoom level on which the map view fits into
    // the given bounds in its entirety.
    getBoundsZoom: function(bounds, inside, padding) {
        bounds = (0, $c1a09dde0ebe0161$export$4904432a68b0399)(bounds);
        padding = (0, $b802e4aa6d666b45$export$b63cca88ddc558a9)(padding || [
            0,
            0
        ]);
        var zoom = this.getZoom() || 0, min = this.getMinZoom(), max = this.getMaxZoom(), nw = bounds.getNorthWest(), se = bounds.getSouthEast(), size = this.getSize().subtract(padding), boundsSize = (0, $2ffe56518af276c5$export$c8e2f7c8aba65b28)(this.project(se, zoom), this.project(nw, zoom)).getSize(), snap = (0, $bda63d751c06734c$export$2e2bcd8739ae039).any3d ? this.options.zoomSnap : 1, scalex = size.x / boundsSize.x, scaley = size.y / boundsSize.y, scale = inside ? Math.max(scalex, scaley) : Math.min(scalex, scaley);
        zoom = this.getScaleZoom(scale, zoom);
        if (snap) {
            zoom = Math.round(zoom / (snap / 100)) * (snap / 100); // don't jump if within 1% of a snap level
            zoom = inside ? Math.ceil(zoom / snap) * snap : Math.floor(zoom / snap) * snap;
        }
        return Math.max(min, Math.min(max, zoom));
    },
    // @method getSize(): Point
    // Returns the current size of the map container (in pixels).
    getSize: function() {
        if (!this._size || this._sizeChanged) {
            this._size = new (0, $b802e4aa6d666b45$export$baf26146a414f24a)(this._container.clientWidth || 0, this._container.clientHeight || 0);
            this._sizeChanged = false;
        }
        return this._size.clone();
    },
    // @method getPixelBounds(): Bounds
    // Returns the bounds of the current map view in projected pixel
    // coordinates (sometimes useful in layer and overlay implementations).
    getPixelBounds: function(center, zoom) {
        var topLeftPoint = this._getTopLeftPoint(center, zoom);
        return new (0, $2ffe56518af276c5$export$c4e9d269599ab4b4)(topLeftPoint, topLeftPoint.add(this.getSize()));
    },
    // TODO: Check semantics - isn't the pixel origin the 0,0 coord relative to
    // the map pane? "left point of the map layer" can be confusing, specially
    // since there can be negative offsets.
    // @method getPixelOrigin(): Point
    // Returns the projected pixel coordinates of the top left point of
    // the map layer (useful in custom layer and overlay implementations).
    getPixelOrigin: function() {
        this._checkIfLoaded();
        return this._pixelOrigin;
    },
    // @method getPixelWorldBounds(zoom?: Number): Bounds
    // Returns the world's bounds in pixel coordinates for zoom level `zoom`.
    // If `zoom` is omitted, the map's current zoom level is used.
    getPixelWorldBounds: function(zoom) {
        return this.options.crs.getProjectedBounds(zoom === undefined ? this.getZoom() : zoom);
    },
    // @section Other Methods
    // @method getPane(pane: String|HTMLElement): HTMLElement
    // Returns a [map pane](#map-pane), given its name or its HTML element (its identity).
    getPane: function(pane) {
        return typeof pane === "string" ? this._panes[pane] : pane;
    },
    // @method getPanes(): Object
    // Returns a plain object containing the names of all [panes](#map-pane) as keys and
    // the panes as values.
    getPanes: function() {
        return this._panes;
    },
    // @method getContainer: HTMLElement
    // Returns the HTML element that contains the map.
    getContainer: function() {
        return this._container;
    },
    // @section Conversion Methods
    // @method getZoomScale(toZoom: Number, fromZoom: Number): Number
    // Returns the scale factor to be applied to a map transition from zoom level
    // `fromZoom` to `toZoom`. Used internally to help with zoom animations.
    getZoomScale: function(toZoom, fromZoom) {
        // TODO replace with universal implementation after refactoring projections
        var crs = this.options.crs;
        fromZoom = fromZoom === undefined ? this._zoom : fromZoom;
        return crs.scale(toZoom) / crs.scale(fromZoom);
    },
    // @method getScaleZoom(scale: Number, fromZoom: Number): Number
    // Returns the zoom level that the map would end up at, if it is at `fromZoom`
    // level and everything is scaled by a factor of `scale`. Inverse of
    // [`getZoomScale`](#map-getZoomScale).
    getScaleZoom: function(scale, fromZoom) {
        var crs = this.options.crs;
        fromZoom = fromZoom === undefined ? this._zoom : fromZoom;
        var zoom = crs.zoom(scale * crs.scale(fromZoom));
        return isNaN(zoom) ? Infinity : zoom;
    },
    // @method project(latlng: LatLng, zoom: Number): Point
    // Projects a geographical coordinate `LatLng` according to the projection
    // of the map's CRS, then scales it according to `zoom` and the CRS's
    // `Transformation`. The result is pixel coordinate relative to
    // the CRS origin.
    project: function(latlng, zoom) {
        zoom = zoom === undefined ? this._zoom : zoom;
        return this.options.crs.latLngToPoint((0, $df6fd3b1bc3e4292$export$a192f247fc7a2057)(latlng), zoom);
    },
    // @method unproject(point: Point, zoom: Number): LatLng
    // Inverse of [`project`](#map-project).
    unproject: function(point, zoom) {
        zoom = zoom === undefined ? this._zoom : zoom;
        return this.options.crs.pointToLatLng((0, $b802e4aa6d666b45$export$b63cca88ddc558a9)(point), zoom);
    },
    // @method layerPointToLatLng(point: Point): LatLng
    // Given a pixel coordinate relative to the [origin pixel](#map-getpixelorigin),
    // returns the corresponding geographical coordinate (for the current zoom level).
    layerPointToLatLng: function(point) {
        var projectedPoint = (0, $b802e4aa6d666b45$export$b63cca88ddc558a9)(point).add(this.getPixelOrigin());
        return this.unproject(projectedPoint);
    },
    // @method latLngToLayerPoint(latlng: LatLng): Point
    // Given a geographical coordinate, returns the corresponding pixel coordinate
    // relative to the [origin pixel](#map-getpixelorigin).
    latLngToLayerPoint: function(latlng) {
        var projectedPoint = this.project((0, $df6fd3b1bc3e4292$export$a192f247fc7a2057)(latlng))._round();
        return projectedPoint._subtract(this.getPixelOrigin());
    },
    // @method wrapLatLng(latlng: LatLng): LatLng
    // Returns a `LatLng` where `lat` and `lng` has been wrapped according to the
    // map's CRS's `wrapLat` and `wrapLng` properties, if they are outside the
    // CRS's bounds.
    // By default this means longitude is wrapped around the dateline so its
    // value is between -180 and +180 degrees.
    wrapLatLng: function(latlng) {
        return this.options.crs.wrapLatLng((0, $df6fd3b1bc3e4292$export$a192f247fc7a2057)(latlng));
    },
    // @method wrapLatLngBounds(bounds: LatLngBounds): LatLngBounds
    // Returns a `LatLngBounds` with the same size as the given one, ensuring that
    // its center is within the CRS's bounds.
    // By default this means the center longitude is wrapped around the dateline so its
    // value is between -180 and +180 degrees, and the majority of the bounds
    // overlaps the CRS's bounds.
    wrapLatLngBounds: function(latlng) {
        return this.options.crs.wrapLatLngBounds((0, $c1a09dde0ebe0161$export$4904432a68b0399)(latlng));
    },
    // @method distance(latlng1: LatLng, latlng2: LatLng): Number
    // Returns the distance between two geographical coordinates according to
    // the map's CRS. By default this measures distance in meters.
    distance: function(latlng1, latlng2) {
        return this.options.crs.distance((0, $df6fd3b1bc3e4292$export$a192f247fc7a2057)(latlng1), (0, $df6fd3b1bc3e4292$export$a192f247fc7a2057)(latlng2));
    },
    // @method containerPointToLayerPoint(point: Point): Point
    // Given a pixel coordinate relative to the map container, returns the corresponding
    // pixel coordinate relative to the [origin pixel](#map-getpixelorigin).
    containerPointToLayerPoint: function(point) {
        return (0, $b802e4aa6d666b45$export$b63cca88ddc558a9)(point).subtract(this._getMapPanePos());
    },
    // @method layerPointToContainerPoint(point: Point): Point
    // Given a pixel coordinate relative to the [origin pixel](#map-getpixelorigin),
    // returns the corresponding pixel coordinate relative to the map container.
    layerPointToContainerPoint: function(point) {
        return (0, $b802e4aa6d666b45$export$b63cca88ddc558a9)(point).add(this._getMapPanePos());
    },
    // @method containerPointToLatLng(point: Point): LatLng
    // Given a pixel coordinate relative to the map container, returns
    // the corresponding geographical coordinate (for the current zoom level).
    containerPointToLatLng: function(point) {
        var layerPoint = this.containerPointToLayerPoint((0, $b802e4aa6d666b45$export$b63cca88ddc558a9)(point));
        return this.layerPointToLatLng(layerPoint);
    },
    // @method latLngToContainerPoint(latlng: LatLng): Point
    // Given a geographical coordinate, returns the corresponding pixel coordinate
    // relative to the map container.
    latLngToContainerPoint: function(latlng) {
        return this.layerPointToContainerPoint(this.latLngToLayerPoint((0, $df6fd3b1bc3e4292$export$a192f247fc7a2057)(latlng)));
    },
    // @method mouseEventToContainerPoint(ev: MouseEvent): Point
    // Given a MouseEvent object, returns the pixel coordinate relative to the
    // map container where the event took place.
    mouseEventToContainerPoint: function(e) {
        return $2148974bfeaf2ac1$export$642213d516a9b928(e, this._container);
    },
    // @method mouseEventToLayerPoint(ev: MouseEvent): Point
    // Given a MouseEvent object, returns the pixel coordinate relative to
    // the [origin pixel](#map-getpixelorigin) where the event took place.
    mouseEventToLayerPoint: function(e) {
        return this.containerPointToLayerPoint(this.mouseEventToContainerPoint(e));
    },
    // @method mouseEventToLatLng(ev: MouseEvent): LatLng
    // Given a MouseEvent object, returns geographical coordinate where the
    // event took place.
    mouseEventToLatLng: function(e) {
        return this.layerPointToLatLng(this.mouseEventToLayerPoint(e));
    },
    // map initialization methods
    _initContainer: function(id) {
        var container = this._container = $783b7cedd5fd919a$export$3988ae62b71be9a3(id);
        if (!container) throw new Error("Map container not found.");
        else if (container._leaflet_id) throw new Error("Map container is already initialized.");
        $2148974bfeaf2ac1$export$af631764ddc44097(container, "scroll", this._onScroll, this);
        this._containerId = $13bbd556cd7cee10$export$bd3fba034e28f6b(container);
    },
    _initLayout: function() {
        var container = this._container;
        this._fadeAnimated = this.options.fadeAnimation && (0, $bda63d751c06734c$export$2e2bcd8739ae039).any3d;
        $783b7cedd5fd919a$export$d2cf6cd1dc7067d3(container, "leaflet-container" + ((0, $bda63d751c06734c$export$2e2bcd8739ae039).touch ? " leaflet-touch" : "") + ((0, $bda63d751c06734c$export$2e2bcd8739ae039).retina ? " leaflet-retina" : "") + ((0, $bda63d751c06734c$export$2e2bcd8739ae039).ielt9 ? " leaflet-oldie" : "") + ((0, $bda63d751c06734c$export$2e2bcd8739ae039).safari ? " leaflet-safari" : "") + (this._fadeAnimated ? " leaflet-fade-anim" : ""));
        var position = $783b7cedd5fd919a$export$3d2f074408bd1b82(container, "position");
        if (position !== "absolute" && position !== "relative" && position !== "fixed" && position !== "sticky") container.style.position = "relative";
        this._initPanes();
        if (this._initControlPos) this._initControlPos();
    },
    _initPanes: function() {
        var panes = this._panes = {};
        this._paneRenderers = {};
        // @section
        //
        // Panes are DOM elements used to control the ordering of layers on the map. You
        // can access panes with [`map.getPane`](#map-getpane) or
        // [`map.getPanes`](#map-getpanes) methods. New panes can be created with the
        // [`map.createPane`](#map-createpane) method.
        //
        // Every map has the following default panes that differ only in zIndex.
        //
        // @pane mapPane: HTMLElement = 'auto'
        // Pane that contains all other map panes
        this._mapPane = this.createPane("mapPane", this._container);
        $783b7cedd5fd919a$export$f9b088a47202d605(this._mapPane, new (0, $b802e4aa6d666b45$export$baf26146a414f24a)(0, 0));
        // @pane tilePane: HTMLElement = 200
        // Pane for `GridLayer`s and `TileLayer`s
        this.createPane("tilePane");
        // @pane overlayPane: HTMLElement = 400
        // Pane for vectors (`Path`s, like `Polyline`s and `Polygon`s), `ImageOverlay`s and `VideoOverlay`s
        this.createPane("overlayPane");
        // @pane shadowPane: HTMLElement = 500
        // Pane for overlay shadows (e.g. `Marker` shadows)
        this.createPane("shadowPane");
        // @pane markerPane: HTMLElement = 600
        // Pane for `Icon`s of `Marker`s
        this.createPane("markerPane");
        // @pane tooltipPane: HTMLElement = 650
        // Pane for `Tooltip`s.
        this.createPane("tooltipPane");
        // @pane popupPane: HTMLElement = 700
        // Pane for `Popup`s.
        this.createPane("popupPane");
        if (!this.options.markerZoomAnimation) {
            $783b7cedd5fd919a$export$d2cf6cd1dc7067d3(panes.markerPane, "leaflet-zoom-hide");
            $783b7cedd5fd919a$export$d2cf6cd1dc7067d3(panes.shadowPane, "leaflet-zoom-hide");
        }
    },
    // private methods that modify map state
    // @section Map state change events
    _resetView: function(center, zoom, noMoveStart) {
        $783b7cedd5fd919a$export$f9b088a47202d605(this._mapPane, new (0, $b802e4aa6d666b45$export$baf26146a414f24a)(0, 0));
        var loading = !this._loaded;
        this._loaded = true;
        zoom = this._limitZoom(zoom);
        this.fire("viewprereset");
        var zoomChanged = this._zoom !== zoom;
        this._moveStart(zoomChanged, noMoveStart)._move(center, zoom)._moveEnd(zoomChanged);
        // @event viewreset: Event
        // Fired when the map needs to redraw its content (this usually happens
        // on map zoom or load). Very useful for creating custom overlays.
        this.fire("viewreset");
        // @event load: Event
        // Fired when the map is initialized (when its center and zoom are set
        // for the first time).
        if (loading) this.fire("load");
    },
    _moveStart: function(zoomChanged, noMoveStart) {
        // @event zoomstart: Event
        // Fired when the map zoom is about to change (e.g. before zoom animation).
        // @event movestart: Event
        // Fired when the view of the map starts changing (e.g. user starts dragging the map).
        if (zoomChanged) this.fire("zoomstart");
        if (!noMoveStart) this.fire("movestart");
        return this;
    },
    _move: function(center, zoom, data, supressEvent) {
        if (zoom === undefined) zoom = this._zoom;
        var zoomChanged = this._zoom !== zoom;
        this._zoom = zoom;
        this._lastCenter = center;
        this._pixelOrigin = this._getNewPixelOrigin(center);
        if (!supressEvent) {
            // @event zoom: Event
            // Fired repeatedly during any change in zoom level,
            // including zoom and fly animations.
            if (zoomChanged || data && data.pinch) this.fire("zoom", data);
            // @event move: Event
            // Fired repeatedly during any movement of the map,
            // including pan and fly animations.
            this.fire("move", data);
        } else if (data && data.pinch) this.fire("zoom", data);
        return this;
    },
    _moveEnd: function(zoomChanged) {
        // @event zoomend: Event
        // Fired when the map zoom changed, after any animations.
        if (zoomChanged) this.fire("zoomend");
        // @event moveend: Event
        // Fired when the center of the map stops changing
        // (e.g. user stopped dragging the map or after non-centered zoom).
        return this.fire("moveend");
    },
    _stop: function() {
        $13bbd556cd7cee10$export$e1ed83507f55dc9d(this._flyToFrame);
        if (this._panAnim) this._panAnim.stop();
        return this;
    },
    _rawPanBy: function(offset) {
        $783b7cedd5fd919a$export$f9b088a47202d605(this._mapPane, this._getMapPanePos().subtract(offset));
    },
    _getZoomSpan: function() {
        return this.getMaxZoom() - this.getMinZoom();
    },
    _panInsideMaxBounds: function() {
        if (!this._enforcingBounds) this.panInsideBounds(this.options.maxBounds);
    },
    _checkIfLoaded: function() {
        if (!this._loaded) throw new Error("Set map center and zoom first.");
    },
    // DOM event handling
    // @section Interaction events
    _initEvents: function(remove) {
        this._targets = {};
        this._targets[$13bbd556cd7cee10$export$bd3fba034e28f6b(this._container)] = this;
        var onOff = remove ? $2148974bfeaf2ac1$export$8c8705df4a2dcec9 : $2148974bfeaf2ac1$export$af631764ddc44097;
        // @event click: MouseEvent
        // Fired when the user clicks (or taps) the map.
        // @event dblclick: MouseEvent
        // Fired when the user double-clicks (or double-taps) the map.
        // @event mousedown: MouseEvent
        // Fired when the user pushes the mouse button on the map.
        // @event mouseup: MouseEvent
        // Fired when the user releases the mouse button on the map.
        // @event mouseover: MouseEvent
        // Fired when the mouse enters the map.
        // @event mouseout: MouseEvent
        // Fired when the mouse leaves the map.
        // @event mousemove: MouseEvent
        // Fired while the mouse moves over the map.
        // @event contextmenu: MouseEvent
        // Fired when the user pushes the right mouse button on the map, prevents
        // default browser context menu from showing if there are listeners on
        // this event. Also fired on mobile when the user holds a single touch
        // for a second (also called long press).
        // @event keypress: KeyboardEvent
        // Fired when the user presses a key from the keyboard that produces a character value while the map is focused.
        // @event keydown: KeyboardEvent
        // Fired when the user presses a key from the keyboard while the map is focused. Unlike the `keypress` event,
        // the `keydown` event is fired for keys that produce a character value and for keys
        // that do not produce a character value.
        // @event keyup: KeyboardEvent
        // Fired when the user releases a key from the keyboard while the map is focused.
        onOff(this._container, "click dblclick mousedown mouseup mouseover mouseout mousemove contextmenu keypress keydown keyup", this._handleDOMEvent, this);
        if (this.options.trackResize) onOff(window, "resize", this._onResize, this);
        if ((0, $bda63d751c06734c$export$2e2bcd8739ae039).any3d && this.options.transform3DLimit) (remove ? this.off : this.on).call(this, "moveend", this._onMoveEnd);
    },
    _onResize: function() {
        $13bbd556cd7cee10$export$e1ed83507f55dc9d(this._resizeRequest);
        this._resizeRequest = $13bbd556cd7cee10$export$d371ad015c199c06(function() {
            this.invalidateSize({
                debounceMoveend: true
            });
        }, this);
    },
    _onScroll: function() {
        this._container.scrollTop = 0;
        this._container.scrollLeft = 0;
    },
    _onMoveEnd: function() {
        var pos = this._getMapPanePos();
        if (Math.max(Math.abs(pos.x), Math.abs(pos.y)) >= this.options.transform3DLimit) // https://bugzilla.mozilla.org/show_bug.cgi?id=1203873 but Webkit also have
        // a pixel offset on very high values, see: https://jsfiddle.net/dg6r5hhb/
        this._resetView(this.getCenter(), this.getZoom());
    },
    _findEventTargets: function(e, type) {
        var targets = [], target, isHover = type === "mouseout" || type === "mouseover", src = e.target || e.srcElement, dragging = false;
        while(src){
            target = this._targets[$13bbd556cd7cee10$export$bd3fba034e28f6b(src)];
            if (target && (type === "click" || type === "preclick") && this._draggableMoved(target)) {
                // Prevent firing click after you just dragged an object.
                dragging = true;
                break;
            }
            if (target && target.listens(type, true)) {
                if (isHover && !$2148974bfeaf2ac1$export$de90706eda23efa2(src, e)) break;
                targets.push(target);
                if (isHover) break;
            }
            if (src === this._container) break;
            src = src.parentNode;
        }
        if (!targets.length && !dragging && !isHover && this.listens(type, true)) targets = [
            this
        ];
        return targets;
    },
    _isClickDisabled: function(el) {
        while(el && el !== this._container){
            if (el["_leaflet_disable_click"]) return true;
            el = el.parentNode;
        }
    },
    _handleDOMEvent: function(e) {
        var el = e.target || e.srcElement;
        if (!this._loaded || el["_leaflet_disable_events"] || e.type === "click" && this._isClickDisabled(el)) return;
        var type = e.type;
        if (type === "mousedown") // prevents outline when clicking on keyboard-focusable element
        $783b7cedd5fd919a$export$73d26a0c96b464b6(el);
        this._fireDOMEvent(e, type);
    },
    _mouseEvents: [
        "click",
        "dblclick",
        "mouseover",
        "mouseout",
        "contextmenu"
    ],
    _fireDOMEvent: function(e, type, canvasTargets) {
        if (e.type === "click") {
            // Fire a synthetic 'preclick' event which propagates up (mainly for closing popups).
            // @event preclick: MouseEvent
            // Fired before mouse click on the map (sometimes useful when you
            // want something to happen on click before any existing click
            // handlers start running).
            var synth = $13bbd556cd7cee10$export$8b58be045bf06082({}, e);
            synth.type = "preclick";
            this._fireDOMEvent(synth, synth.type, canvasTargets);
        }
        // Find the layer the event is propagating from and its parents.
        var targets = this._findEventTargets(e, type);
        if (canvasTargets) {
            var filtered = []; // pick only targets with listeners
            for(var i = 0; i < canvasTargets.length; i++)if (canvasTargets[i].listens(type, true)) filtered.push(canvasTargets[i]);
            targets = filtered.concat(targets);
        }
        if (!targets.length) return;
        if (type === "contextmenu") $2148974bfeaf2ac1$export$fa3b29edae795ef4(e);
        var target = targets[0];
        var data = {
            originalEvent: e
        };
        if (e.type !== "keypress" && e.type !== "keydown" && e.type !== "keyup") {
            var isMarker = target.getLatLng && (!target._radius || target._radius <= 10);
            data.containerPoint = isMarker ? this.latLngToContainerPoint(target.getLatLng()) : this.mouseEventToContainerPoint(e);
            data.layerPoint = this.containerPointToLayerPoint(data.containerPoint);
            data.latlng = isMarker ? target.getLatLng() : this.layerPointToLatLng(data.layerPoint);
        }
        for(i = 0; i < targets.length; i++){
            targets[i].fire(type, data, true);
            if (data.originalEvent._stopped || targets[i].options.bubblingMouseEvents === false && $13bbd556cd7cee10$export$305f7d4e9d4624f2(this._mouseEvents, type) !== -1) return;
        }
    },
    _draggableMoved: function(obj) {
        obj = obj.dragging && obj.dragging.enabled() ? obj : this;
        return obj.dragging && obj.dragging.moved() || this.boxZoom && this.boxZoom.moved();
    },
    _clearHandlers: function() {
        for(var i = 0, len = this._handlers.length; i < len; i++)this._handlers[i].disable();
    },
    // @section Other Methods
    // @method whenReady(fn: Function, context?: Object): this
    // Runs the given function `fn` when the map gets initialized with
    // a view (center and zoom) and at least one layer, or immediately
    // if it's already initialized, optionally passing a function context.
    whenReady: function(callback, context) {
        if (this._loaded) callback.call(context || this, {
            target: this
        });
        else this.on("load", callback, context);
        return this;
    },
    // private methods for getting map state
    _getMapPanePos: function() {
        return $783b7cedd5fd919a$export$1690e12b840569b9(this._mapPane) || new (0, $b802e4aa6d666b45$export$baf26146a414f24a)(0, 0);
    },
    _moved: function() {
        var pos = this._getMapPanePos();
        return pos && !pos.equals([
            0,
            0
        ]);
    },
    _getTopLeftPoint: function(center, zoom) {
        var pixelOrigin = center && zoom !== undefined ? this._getNewPixelOrigin(center, zoom) : this.getPixelOrigin();
        return pixelOrigin.subtract(this._getMapPanePos());
    },
    _getNewPixelOrigin: function(center, zoom) {
        var viewHalf = this.getSize()._divideBy(2);
        return this.project(center, zoom)._subtract(viewHalf)._add(this._getMapPanePos())._round();
    },
    _latLngToNewLayerPoint: function(latlng, zoom, center) {
        var topLeft = this._getNewPixelOrigin(center, zoom);
        return this.project(latlng, zoom)._subtract(topLeft);
    },
    _latLngBoundsToNewLayerBounds: function(latLngBounds, zoom, center) {
        var topLeft = this._getNewPixelOrigin(center, zoom);
        return (0, $2ffe56518af276c5$export$c8e2f7c8aba65b28)([
            this.project(latLngBounds.getSouthWest(), zoom)._subtract(topLeft),
            this.project(latLngBounds.getNorthWest(), zoom)._subtract(topLeft),
            this.project(latLngBounds.getSouthEast(), zoom)._subtract(topLeft),
            this.project(latLngBounds.getNorthEast(), zoom)._subtract(topLeft)
        ]);
    },
    // layer point of the current center
    _getCenterLayerPoint: function() {
        return this.containerPointToLayerPoint(this.getSize()._divideBy(2));
    },
    // offset of the specified place to the current center in pixels
    _getCenterOffset: function(latlng) {
        return this.latLngToLayerPoint(latlng).subtract(this._getCenterLayerPoint());
    },
    // adjust center for view to get inside bounds
    _limitCenter: function(center, zoom, bounds) {
        if (!bounds) return center;
        var centerPoint = this.project(center, zoom), viewHalf = this.getSize().divideBy(2), viewBounds = new (0, $2ffe56518af276c5$export$c4e9d269599ab4b4)(centerPoint.subtract(viewHalf), centerPoint.add(viewHalf)), offset = this._getBoundsOffset(viewBounds, bounds, zoom);
        // If offset is less than a pixel, ignore.
        // This prevents unstable projections from getting into
        // an infinite loop of tiny offsets.
        if (Math.abs(offset.x) <= 1 && Math.abs(offset.y) <= 1) return center;
        return this.unproject(centerPoint.add(offset), zoom);
    },
    // adjust offset for view to get inside bounds
    _limitOffset: function(offset, bounds) {
        if (!bounds) return offset;
        var viewBounds = this.getPixelBounds(), newBounds = new (0, $2ffe56518af276c5$export$c4e9d269599ab4b4)(viewBounds.min.add(offset), viewBounds.max.add(offset));
        return offset.add(this._getBoundsOffset(newBounds, bounds));
    },
    // returns offset needed for pxBounds to get inside maxBounds at a specified zoom
    _getBoundsOffset: function(pxBounds, maxBounds, zoom) {
        var projectedMaxBounds = (0, $2ffe56518af276c5$export$c8e2f7c8aba65b28)(this.project(maxBounds.getNorthEast(), zoom), this.project(maxBounds.getSouthWest(), zoom)), minOffset = projectedMaxBounds.min.subtract(pxBounds.min), maxOffset = projectedMaxBounds.max.subtract(pxBounds.max), dx = this._rebound(minOffset.x, -maxOffset.x), dy = this._rebound(minOffset.y, -maxOffset.y);
        return new (0, $b802e4aa6d666b45$export$baf26146a414f24a)(dx, dy);
    },
    _rebound: function(left, right) {
        return left + right > 0 ? Math.round(left - right) / 2 : Math.max(0, Math.ceil(left)) - Math.max(0, Math.floor(right));
    },
    _limitZoom: function(zoom) {
        var min = this.getMinZoom(), max = this.getMaxZoom(), snap = (0, $bda63d751c06734c$export$2e2bcd8739ae039).any3d ? this.options.zoomSnap : 1;
        if (snap) zoom = Math.round(zoom / snap) * snap;
        return Math.max(min, Math.min(max, zoom));
    },
    _onPanTransitionStep: function() {
        this.fire("move");
    },
    _onPanTransitionEnd: function() {
        $783b7cedd5fd919a$export$c2255604a80b4506(this._mapPane, "leaflet-pan-anim");
        this.fire("moveend");
    },
    _tryAnimatedPan: function(center, options) {
        // difference between the new and current centers in pixels
        var offset = this._getCenterOffset(center)._trunc();
        // don't animate too far unless animate: true specified in options
        if ((options && options.animate) !== true && !this.getSize().contains(offset)) return false;
        this.panBy(offset, options);
        return true;
    },
    _createAnimProxy: function() {
        var proxy = this._proxy = $783b7cedd5fd919a$export$185802fd694ee1f5("div", "leaflet-proxy leaflet-zoom-animated");
        this._panes.mapPane.appendChild(proxy);
        this.on("zoomanim", function(e) {
            var prop = $783b7cedd5fd919a$export$e3fc61237fe28123, transform = this._proxy.style[prop];
            $783b7cedd5fd919a$export$ff09356c35bee89b(this._proxy, this.project(e.center, e.zoom), this.getZoomScale(e.zoom, 1));
            // workaround for case when transform is the same and so transitionend event is not fired
            if (transform === this._proxy.style[prop] && this._animatingZoom) this._onZoomTransitionEnd();
        }, this);
        this.on("load moveend", this._animMoveEnd, this);
        this._on("unload", this._destroyAnimProxy, this);
    },
    _destroyAnimProxy: function() {
        $783b7cedd5fd919a$export$cd7f480d6b8286c3(this._proxy);
        this.off("load moveend", this._animMoveEnd, this);
        delete this._proxy;
    },
    _animMoveEnd: function() {
        var c = this.getCenter(), z = this.getZoom();
        $783b7cedd5fd919a$export$ff09356c35bee89b(this._proxy, this.project(c, z), this.getZoomScale(z, 1));
    },
    _catchTransitionEnd: function(e) {
        if (this._animatingZoom && e.propertyName.indexOf("transform") >= 0) this._onZoomTransitionEnd();
    },
    _nothingToAnimate: function() {
        return !this._container.getElementsByClassName("leaflet-zoom-animated").length;
    },
    _tryAnimatedZoom: function(center, zoom, options) {
        if (this._animatingZoom) return true;
        options = options || {};
        // don't animate if disabled, not supported or zoom difference is too large
        if (!this._zoomAnimated || options.animate === false || this._nothingToAnimate() || Math.abs(zoom - this._zoom) > this.options.zoomAnimationThreshold) return false;
        // offset is the pixel coords of the zoom origin relative to the current center
        var scale = this.getZoomScale(zoom), offset = this._getCenterOffset(center)._divideBy(1 - 1 / scale);
        // don't animate if the zoom origin isn't within one screen from the current center, unless forced
        if (options.animate !== true && !this.getSize().contains(offset)) return false;
        $13bbd556cd7cee10$export$d371ad015c199c06(function() {
            this._moveStart(true, options.noMoveStart || false)._animateZoom(center, zoom, true);
        }, this);
        return true;
    },
    _animateZoom: function(center, zoom, startAnim, noUpdate) {
        if (!this._mapPane) return;
        if (startAnim) {
            this._animatingZoom = true;
            // remember what center/zoom to set after animation
            this._animateToCenter = center;
            this._animateToZoom = zoom;
            $783b7cedd5fd919a$export$d2cf6cd1dc7067d3(this._mapPane, "leaflet-zoom-anim");
        }
        // @section Other Events
        // @event zoomanim: ZoomAnimEvent
        // Fired at least once per zoom animation. For continuous zoom, like pinch zooming, fired once per frame during zoom.
        this.fire("zoomanim", {
            center: center,
            zoom: zoom,
            noUpdate: noUpdate
        });
        if (!this._tempFireZoomEvent) this._tempFireZoomEvent = this._zoom !== this._animateToZoom;
        this._move(this._animateToCenter, this._animateToZoom, undefined, true);
        // Work around webkit not firing 'transitionend', see https://github.com/Leaflet/Leaflet/issues/3689, 2693
        setTimeout($13bbd556cd7cee10$export$2385a24977818dd0(this._onZoomTransitionEnd, this), 250);
    },
    _onZoomTransitionEnd: function() {
        if (!this._animatingZoom) return;
        if (this._mapPane) $783b7cedd5fd919a$export$c2255604a80b4506(this._mapPane, "leaflet-zoom-anim");
        this._animatingZoom = false;
        this._move(this._animateToCenter, this._animateToZoom, undefined, true);
        if (this._tempFireZoomEvent) this.fire("zoom");
        delete this._tempFireZoomEvent;
        this.fire("move");
        this._moveEnd(true);
    }
});
function $7d9a54c6488daf4f$export$d49c9aa30b771d59(id, options) {
    return new $7d9a54c6488daf4f$export$a5c7b93649eaf8f8(id, options);
}




var $257bd5e7d2d57b63$export$7a7fa4424cb20976 = (0, $f8984dbaa17424d1$export$4c85e640eb41c31b).extend({
    // @section
    // @aka Control Options
    options: {
        // @option position: String = 'topright'
        // The position of the control (one of the map corners). Possible values are `'topleft'`,
        // `'topright'`, `'bottomleft'` or `'bottomright'`
        position: "topright"
    },
    initialize: function(options) {
        $13bbd556cd7cee10$export$add91eafeaeab287(this, options);
    },
    /* @section
	 * Classes extending L.Control will inherit the following methods:
	 *
	 * @method getPosition: string
	 * Returns the position of the control.
	 */ getPosition: function() {
        return this.options.position;
    },
    // @method setPosition(position: string): this
    // Sets the position of the control.
    setPosition: function(position) {
        var map = this._map;
        if (map) map.removeControl(this);
        this.options.position = position;
        if (map) map.addControl(this);
        return this;
    },
    // @method getContainer: HTMLElement
    // Returns the HTMLElement that contains the control.
    getContainer: function() {
        return this._container;
    },
    // @method addTo(map: Map): this
    // Adds the control to the given map.
    addTo: function(map) {
        this.remove();
        this._map = map;
        var container = this._container = this.onAdd(map), pos = this.getPosition(), corner = map._controlCorners[pos];
        $783b7cedd5fd919a$export$d2cf6cd1dc7067d3(container, "leaflet-control");
        if (pos.indexOf("bottom") !== -1) corner.insertBefore(container, corner.firstChild);
        else corner.appendChild(container);
        this._map.on("unload", this.remove, this);
        return this;
    },
    // @method remove: this
    // Removes the control from the map it is currently active on.
    remove: function() {
        if (!this._map) return this;
        $783b7cedd5fd919a$export$cd7f480d6b8286c3(this._container);
        if (this.onRemove) this.onRemove(this._map);
        this._map.off("unload", this.remove, this);
        this._map = null;
        return this;
    },
    _refocusOnMap: function(e) {
        // if map exists and event is not a keyboard event
        if (this._map && e && e.screenX > 0 && e.screenY > 0) this._map.getContainer().focus();
    }
});
var $257bd5e7d2d57b63$export$b5cde1de278b4330 = function(options) {
    return new $257bd5e7d2d57b63$export$7a7fa4424cb20976(options);
};
/* @section Extension methods
 * @uninheritable
 *
 * Every control should extend from `L.Control` and (re-)implement the following methods.
 *
 * @method onAdd(map: Map): HTMLElement
 * Should return the container DOM element for the control and add listeners on relevant map events. Called on [`control.addTo(map)`](#control-addTo).
 *
 * @method onRemove(map: Map)
 * Optional method. Should contain all clean up code that removes the listeners previously added in [`onAdd`](#control-onadd). Called on [`control.remove()`](#control-remove).
 */ /* @namespace Map
 * @section Methods for Layers and Controls
 */ (0, $7d9a54c6488daf4f$export$a5c7b93649eaf8f8).include({
    // @method addControl(control: Control): this
    // Adds the given control to the map
    addControl: function(control) {
        control.addTo(this);
        return this;
    },
    // @method removeControl(control: Control): this
    // Removes the given control from the map
    removeControl: function(control) {
        control.remove();
        return this;
    },
    _initControlPos: function() {
        var corners = this._controlCorners = {}, l = "leaflet-", container = this._controlContainer = $783b7cedd5fd919a$export$185802fd694ee1f5("div", l + "control-container", this._container);
        function createCorner(vSide, hSide) {
            var className = l + vSide + " " + l + hSide;
            corners[vSide + hSide] = $783b7cedd5fd919a$export$185802fd694ee1f5("div", className, container);
        }
        createCorner("top", "left");
        createCorner("top", "right");
        createCorner("bottom", "left");
        createCorner("bottom", "right");
    },
    _clearControlPos: function() {
        for(var i in this._controlCorners)$783b7cedd5fd919a$export$cd7f480d6b8286c3(this._controlCorners[i]);
        $783b7cedd5fd919a$export$cd7f480d6b8286c3(this._controlContainer);
        delete this._controlCorners;
        delete this._controlContainer;
    }
});






var $8ade9dc0b848a78a$export$89312ce47c0ca777 = (0, $257bd5e7d2d57b63$export$7a7fa4424cb20976).extend({
    // @section
    // @aka Control.Layers options
    options: {
        // @option collapsed: Boolean = true
        // If `true`, the control will be collapsed into an icon and expanded on mouse hover, touch, or keyboard activation.
        collapsed: true,
        position: "topright",
        // @option autoZIndex: Boolean = true
        // If `true`, the control will assign zIndexes in increasing order to all of its layers so that the order is preserved when switching them on/off.
        autoZIndex: true,
        // @option hideSingleBase: Boolean = false
        // If `true`, the base layers in the control will be hidden when there is only one.
        hideSingleBase: false,
        // @option sortLayers: Boolean = false
        // Whether to sort the layers. When `false`, layers will keep the order
        // in which they were added to the control.
        sortLayers: false,
        // @option sortFunction: Function = *
        // A [compare function](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/sort)
        // that will be used for sorting the layers, when `sortLayers` is `true`.
        // The function receives both the `L.Layer` instances and their names, as in
        // `sortFunction(layerA, layerB, nameA, nameB)`.
        // By default, it sorts layers alphabetically by their name.
        sortFunction: function(layerA, layerB, nameA, nameB) {
            return nameA < nameB ? -1 : nameB < nameA ? 1 : 0;
        }
    },
    initialize: function(baseLayers, overlays, options) {
        $13bbd556cd7cee10$export$add91eafeaeab287(this, options);
        this._layerControlInputs = [];
        this._layers = [];
        this._lastZIndex = 0;
        this._handlingClick = false;
        this._preventClick = false;
        for(var i in baseLayers)this._addLayer(baseLayers[i], i);
        for(i in overlays)this._addLayer(overlays[i], i, true);
    },
    onAdd: function(map) {
        this._initLayout();
        this._update();
        this._map = map;
        map.on("zoomend", this._checkDisabledLayers, this);
        for(var i = 0; i < this._layers.length; i++)this._layers[i].layer.on("add remove", this._onLayerChange, this);
        return this._container;
    },
    addTo: function(map) {
        (0, $257bd5e7d2d57b63$export$7a7fa4424cb20976).prototype.addTo.call(this, map);
        // Trigger expand after Layers Control has been inserted into DOM so that is now has an actual height.
        return this._expandIfNotCollapsed();
    },
    onRemove: function() {
        this._map.off("zoomend", this._checkDisabledLayers, this);
        for(var i = 0; i < this._layers.length; i++)this._layers[i].layer.off("add remove", this._onLayerChange, this);
    },
    // @method addBaseLayer(layer: Layer, name: String): this
    // Adds a base layer (radio button entry) with the given name to the control.
    addBaseLayer: function(layer, name) {
        this._addLayer(layer, name);
        return this._map ? this._update() : this;
    },
    // @method addOverlay(layer: Layer, name: String): this
    // Adds an overlay (checkbox entry) with the given name to the control.
    addOverlay: function(layer, name) {
        this._addLayer(layer, name, true);
        return this._map ? this._update() : this;
    },
    // @method removeLayer(layer: Layer): this
    // Remove the given layer from the control.
    removeLayer: function(layer) {
        layer.off("add remove", this._onLayerChange, this);
        var obj = this._getLayer($13bbd556cd7cee10$export$bd3fba034e28f6b(layer));
        if (obj) this._layers.splice(this._layers.indexOf(obj), 1);
        return this._map ? this._update() : this;
    },
    // @method expand(): this
    // Expand the control container if collapsed.
    expand: function() {
        $783b7cedd5fd919a$export$d2cf6cd1dc7067d3(this._container, "leaflet-control-layers-expanded");
        this._section.style.height = null;
        var acceptableHeight = this._map.getSize().y - (this._container.offsetTop + 50);
        if (acceptableHeight < this._section.clientHeight) {
            $783b7cedd5fd919a$export$d2cf6cd1dc7067d3(this._section, "leaflet-control-layers-scrollbar");
            this._section.style.height = acceptableHeight + "px";
        } else $783b7cedd5fd919a$export$c2255604a80b4506(this._section, "leaflet-control-layers-scrollbar");
        this._checkDisabledLayers();
        return this;
    },
    // @method collapse(): this
    // Collapse the control container if expanded.
    collapse: function() {
        $783b7cedd5fd919a$export$c2255604a80b4506(this._container, "leaflet-control-layers-expanded");
        return this;
    },
    _initLayout: function() {
        var className = "leaflet-control-layers", container = this._container = $783b7cedd5fd919a$export$185802fd694ee1f5("div", className), collapsed = this.options.collapsed;
        // makes this work on IE touch devices by stopping it from firing a mouseout event when the touch is released
        container.setAttribute("aria-haspopup", true);
        $2148974bfeaf2ac1$export$a640b530813b3952(container);
        $2148974bfeaf2ac1$export$383a0f6cce2d3ccb(container);
        var section = this._section = $783b7cedd5fd919a$export$185802fd694ee1f5("section", className + "-list");
        if (collapsed) {
            this._map.on("click", this.collapse, this);
            $2148974bfeaf2ac1$export$af631764ddc44097(container, {
                mouseenter: this._expandSafely,
                mouseleave: this.collapse
            }, this);
        }
        var link = this._layersLink = $783b7cedd5fd919a$export$185802fd694ee1f5("a", className + "-toggle", container);
        link.href = "#";
        link.title = "Layers";
        link.setAttribute("role", "button");
        $2148974bfeaf2ac1$export$af631764ddc44097(link, {
            keydown: function(e) {
                if (e.keyCode === 13) this._expandSafely();
            },
            // Certain screen readers intercept the key event and instead send a click event
            click: function(e) {
                $2148974bfeaf2ac1$export$fa3b29edae795ef4(e);
                this._expandSafely();
            }
        }, this);
        if (!collapsed) this.expand();
        this._baseLayersList = $783b7cedd5fd919a$export$185802fd694ee1f5("div", className + "-base", section);
        this._separator = $783b7cedd5fd919a$export$185802fd694ee1f5("div", className + "-separator", section);
        this._overlaysList = $783b7cedd5fd919a$export$185802fd694ee1f5("div", className + "-overlays", section);
        container.appendChild(section);
    },
    _getLayer: function(id) {
        for(var i = 0; i < this._layers.length; i++){
            if (this._layers[i] && $13bbd556cd7cee10$export$bd3fba034e28f6b(this._layers[i].layer) === id) return this._layers[i];
        }
    },
    _addLayer: function(layer, name, overlay) {
        if (this._map) layer.on("add remove", this._onLayerChange, this);
        this._layers.push({
            layer: layer,
            name: name,
            overlay: overlay
        });
        if (this.options.sortLayers) this._layers.sort($13bbd556cd7cee10$export$2385a24977818dd0(function(a, b) {
            return this.options.sortFunction(a.layer, b.layer, a.name, b.name);
        }, this));
        if (this.options.autoZIndex && layer.setZIndex) {
            this._lastZIndex++;
            layer.setZIndex(this._lastZIndex);
        }
        this._expandIfNotCollapsed();
    },
    _update: function() {
        if (!this._container) return this;
        $783b7cedd5fd919a$export$6e22c362a0406a2c(this._baseLayersList);
        $783b7cedd5fd919a$export$6e22c362a0406a2c(this._overlaysList);
        this._layerControlInputs = [];
        var baseLayersPresent, overlaysPresent, i, obj, baseLayersCount = 0;
        for(i = 0; i < this._layers.length; i++){
            obj = this._layers[i];
            this._addItem(obj);
            overlaysPresent = overlaysPresent || obj.overlay;
            baseLayersPresent = baseLayersPresent || !obj.overlay;
            baseLayersCount += !obj.overlay ? 1 : 0;
        }
        // Hide base layers section if there's only one layer.
        if (this.options.hideSingleBase) {
            baseLayersPresent = baseLayersPresent && baseLayersCount > 1;
            this._baseLayersList.style.display = baseLayersPresent ? "" : "none";
        }
        this._separator.style.display = overlaysPresent && baseLayersPresent ? "" : "none";
        return this;
    },
    _onLayerChange: function(e) {
        if (!this._handlingClick) this._update();
        var obj = this._getLayer($13bbd556cd7cee10$export$bd3fba034e28f6b(e.target));
        // @namespace Map
        // @section Layer events
        // @event baselayerchange: LayersControlEvent
        // Fired when the base layer is changed through the [layers control](#control-layers).
        // @event overlayadd: LayersControlEvent
        // Fired when an overlay is selected through the [layers control](#control-layers).
        // @event overlayremove: LayersControlEvent
        // Fired when an overlay is deselected through the [layers control](#control-layers).
        // @namespace Control.Layers
        var type = obj.overlay ? e.type === "add" ? "overlayadd" : "overlayremove" : e.type === "add" ? "baselayerchange" : null;
        if (type) this._map.fire(type, obj);
    },
    // IE7 bugs out if you create a radio dynamically, so you have to do it this hacky way (see https://stackoverflow.com/a/119079)
    _createRadioElement: function(name, checked) {
        var radioHtml = '<input type="radio" class="leaflet-control-layers-selector" name="' + name + '"' + (checked ? ' checked="checked"' : "") + "/>";
        var radioFragment = document.createElement("div");
        radioFragment.innerHTML = radioHtml;
        return radioFragment.firstChild;
    },
    _addItem: function(obj) {
        var label = document.createElement("label"), checked = this._map.hasLayer(obj.layer), input;
        if (obj.overlay) {
            input = document.createElement("input");
            input.type = "checkbox";
            input.className = "leaflet-control-layers-selector";
            input.defaultChecked = checked;
        } else input = this._createRadioElement("leaflet-base-layers_" + $13bbd556cd7cee10$export$bd3fba034e28f6b(this), checked);
        this._layerControlInputs.push(input);
        input.layerId = $13bbd556cd7cee10$export$bd3fba034e28f6b(obj.layer);
        $2148974bfeaf2ac1$export$af631764ddc44097(input, "click", this._onInputClick, this);
        var name = document.createElement("span");
        name.innerHTML = " " + obj.name;
        // Helps from preventing layer control flicker when checkboxes are disabled
        // https://github.com/Leaflet/Leaflet/issues/2771
        var holder = document.createElement("span");
        label.appendChild(holder);
        holder.appendChild(input);
        holder.appendChild(name);
        var container = obj.overlay ? this._overlaysList : this._baseLayersList;
        container.appendChild(label);
        this._checkDisabledLayers();
        return label;
    },
    _onInputClick: function() {
        // expanding the control on mobile with a click can cause adding a layer - we don't want this
        if (this._preventClick) return;
        var inputs = this._layerControlInputs, input, layer;
        var addedLayers = [], removedLayers = [];
        this._handlingClick = true;
        for(var i = inputs.length - 1; i >= 0; i--){
            input = inputs[i];
            layer = this._getLayer(input.layerId).layer;
            if (input.checked) addedLayers.push(layer);
            else if (!input.checked) removedLayers.push(layer);
        }
        // Bugfix issue 2318: Should remove all old layers before readding new ones
        for(i = 0; i < removedLayers.length; i++)if (this._map.hasLayer(removedLayers[i])) this._map.removeLayer(removedLayers[i]);
        for(i = 0; i < addedLayers.length; i++)if (!this._map.hasLayer(addedLayers[i])) this._map.addLayer(addedLayers[i]);
        this._handlingClick = false;
        this._refocusOnMap();
    },
    _checkDisabledLayers: function() {
        var inputs = this._layerControlInputs, input, layer, zoom = this._map.getZoom();
        for(var i = inputs.length - 1; i >= 0; i--){
            input = inputs[i];
            layer = this._getLayer(input.layerId).layer;
            input.disabled = layer.options.minZoom !== undefined && zoom < layer.options.minZoom || layer.options.maxZoom !== undefined && zoom > layer.options.maxZoom;
        }
    },
    _expandIfNotCollapsed: function() {
        if (this._map && !this.options.collapsed) this.expand();
        return this;
    },
    _expandSafely: function() {
        var section = this._section;
        this._preventClick = true;
        $2148974bfeaf2ac1$export$af631764ddc44097(section, "click", $2148974bfeaf2ac1$export$fa3b29edae795ef4);
        this.expand();
        var that = this;
        setTimeout(function() {
            $2148974bfeaf2ac1$export$8c8705df4a2dcec9(section, "click", $2148974bfeaf2ac1$export$fa3b29edae795ef4);
            that._preventClick = false;
        });
    }
});
var $8ade9dc0b848a78a$export$7be255094ccdc533 = function(baseLayers, overlays, options) {
    return new $8ade9dc0b848a78a$export$89312ce47c0ca777(baseLayers, overlays, options);
};






var $f7f96624fc1f0b6e$export$65cfd44a2050f99 = (0, $257bd5e7d2d57b63$export$7a7fa4424cb20976).extend({
    // @section
    // @aka Control.Zoom options
    options: {
        position: "topleft",
        // @option zoomInText: String = '<span aria-hidden="true">+</span>'
        // The text set on the 'zoom in' button.
        zoomInText: '<span aria-hidden="true">+</span>',
        // @option zoomInTitle: String = 'Zoom in'
        // The title set on the 'zoom in' button.
        zoomInTitle: "Zoom in",
        // @option zoomOutText: String = '<span aria-hidden="true">&#x2212;</span>'
        // The text set on the 'zoom out' button.
        zoomOutText: '<span aria-hidden="true">&#x2212;</span>',
        // @option zoomOutTitle: String = 'Zoom out'
        // The title set on the 'zoom out' button.
        zoomOutTitle: "Zoom out"
    },
    onAdd: function(map) {
        var zoomName = "leaflet-control-zoom", container = $783b7cedd5fd919a$export$185802fd694ee1f5("div", zoomName + " leaflet-bar"), options = this.options;
        this._zoomInButton = this._createButton(options.zoomInText, options.zoomInTitle, zoomName + "-in", container, this._zoomIn);
        this._zoomOutButton = this._createButton(options.zoomOutText, options.zoomOutTitle, zoomName + "-out", container, this._zoomOut);
        this._updateDisabled();
        map.on("zoomend zoomlevelschange", this._updateDisabled, this);
        return container;
    },
    onRemove: function(map) {
        map.off("zoomend zoomlevelschange", this._updateDisabled, this);
    },
    disable: function() {
        this._disabled = true;
        this._updateDisabled();
        return this;
    },
    enable: function() {
        this._disabled = false;
        this._updateDisabled();
        return this;
    },
    _zoomIn: function(e) {
        if (!this._disabled && this._map._zoom < this._map.getMaxZoom()) this._map.zoomIn(this._map.options.zoomDelta * (e.shiftKey ? 3 : 1));
    },
    _zoomOut: function(e) {
        if (!this._disabled && this._map._zoom > this._map.getMinZoom()) this._map.zoomOut(this._map.options.zoomDelta * (e.shiftKey ? 3 : 1));
    },
    _createButton: function(html, title, className, container, fn) {
        var link = $783b7cedd5fd919a$export$185802fd694ee1f5("a", className, container);
        link.innerHTML = html;
        link.href = "#";
        link.title = title;
        /*
		 * Will force screen readers like VoiceOver to read this as "Zoom in - button"
		 */ link.setAttribute("role", "button");
        link.setAttribute("aria-label", title);
        $2148974bfeaf2ac1$export$a640b530813b3952(link);
        $2148974bfeaf2ac1$export$af631764ddc44097(link, "click", $2148974bfeaf2ac1$export$fa6813432f753b0d);
        $2148974bfeaf2ac1$export$af631764ddc44097(link, "click", fn, this);
        $2148974bfeaf2ac1$export$af631764ddc44097(link, "click", this._refocusOnMap, this);
        return link;
    },
    _updateDisabled: function() {
        var map = this._map, className = "leaflet-disabled";
        $783b7cedd5fd919a$export$c2255604a80b4506(this._zoomInButton, className);
        $783b7cedd5fd919a$export$c2255604a80b4506(this._zoomOutButton, className);
        this._zoomInButton.setAttribute("aria-disabled", "false");
        this._zoomOutButton.setAttribute("aria-disabled", "false");
        if (this._disabled || map._zoom === map.getMinZoom()) {
            $783b7cedd5fd919a$export$d2cf6cd1dc7067d3(this._zoomOutButton, className);
            this._zoomOutButton.setAttribute("aria-disabled", "true");
        }
        if (this._disabled || map._zoom === map.getMaxZoom()) {
            $783b7cedd5fd919a$export$d2cf6cd1dc7067d3(this._zoomInButton, className);
            this._zoomInButton.setAttribute("aria-disabled", "true");
        }
    }
});
// @namespace Map
// @section Control options
// @option zoomControl: Boolean = true
// Whether a [zoom control](#control-zoom) is added to the map by default.
(0, $7d9a54c6488daf4f$export$a5c7b93649eaf8f8).mergeOptions({
    zoomControl: true
});
(0, $7d9a54c6488daf4f$export$a5c7b93649eaf8f8).addInitHook(function() {
    if (this.options.zoomControl) {
        // @section Controls
        // @property zoomControl: Control.Zoom
        // The default zoom control (only available if the
        // [`zoomControl` option](#map-zoomcontrol) was `true` when creating the map).
        this.zoomControl = new $f7f96624fc1f0b6e$export$65cfd44a2050f99();
        this.addControl(this.zoomControl);
    }
});
var $f7f96624fc1f0b6e$export$e83f174dbf56adcc = function(options) {
    return new $f7f96624fc1f0b6e$export$65cfd44a2050f99(options);
};




var $b6ccfe0e289b0f35$export$d60cfc58d3c358b6 = (0, $257bd5e7d2d57b63$export$7a7fa4424cb20976).extend({
    // @section
    // @aka Control.Scale options
    options: {
        position: "bottomleft",
        // @option maxWidth: Number = 100
        // Maximum width of the control in pixels. The width is set dynamically to show round values (e.g. 100, 200, 500).
        maxWidth: 100,
        // @option metric: Boolean = True
        // Whether to show the metric scale line (m/km).
        metric: true,
        // @option imperial: Boolean = True
        // Whether to show the imperial scale line (mi/ft).
        imperial: true
    },
    onAdd: function(map) {
        var className = "leaflet-control-scale", container = $783b7cedd5fd919a$export$185802fd694ee1f5("div", className), options = this.options;
        this._addScales(options, className + "-line", container);
        map.on(options.updateWhenIdle ? "moveend" : "move", this._update, this);
        map.whenReady(this._update, this);
        return container;
    },
    onRemove: function(map) {
        map.off(this.options.updateWhenIdle ? "moveend" : "move", this._update, this);
    },
    _addScales: function(options, className, container) {
        if (options.metric) this._mScale = $783b7cedd5fd919a$export$185802fd694ee1f5("div", className, container);
        if (options.imperial) this._iScale = $783b7cedd5fd919a$export$185802fd694ee1f5("div", className, container);
    },
    _update: function() {
        var map = this._map, y = map.getSize().y / 2;
        var maxMeters = map.distance(map.containerPointToLatLng([
            0,
            y
        ]), map.containerPointToLatLng([
            this.options.maxWidth,
            y
        ]));
        this._updateScales(maxMeters);
    },
    _updateScales: function(maxMeters) {
        if (this.options.metric && maxMeters) this._updateMetric(maxMeters);
        if (this.options.imperial && maxMeters) this._updateImperial(maxMeters);
    },
    _updateMetric: function(maxMeters) {
        var meters = this._getRoundNum(maxMeters), label = meters < 1000 ? meters + " m" : meters / 1000 + " km";
        this._updateScale(this._mScale, label, meters / maxMeters);
    },
    _updateImperial: function(maxMeters) {
        var maxFeet = maxMeters * 3.2808399, maxMiles, miles, feet;
        if (maxFeet > 5280) {
            maxMiles = maxFeet / 5280;
            miles = this._getRoundNum(maxMiles);
            this._updateScale(this._iScale, miles + " mi", miles / maxMiles);
        } else {
            feet = this._getRoundNum(maxFeet);
            this._updateScale(this._iScale, feet + " ft", feet / maxFeet);
        }
    },
    _updateScale: function(scale, text, ratio) {
        scale.style.width = Math.round(this.options.maxWidth * ratio) + "px";
        scale.innerHTML = text;
    },
    _getRoundNum: function(num) {
        var pow10 = Math.pow(10, (Math.floor(num) + "").length - 1), d = num / pow10;
        d = d >= 10 ? 10 : d >= 5 ? 5 : d >= 3 ? 3 : d >= 2 ? 2 : 1;
        return pow10 * d;
    }
});
var $b6ccfe0e289b0f35$export$dcdf75081b88279d = function(options) {
    return new $b6ccfe0e289b0f35$export$d60cfc58d3c358b6(options);
};








var $574b686e85b098af$var$ukrainianFlag = '<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="12" height="8" viewBox="0 0 12 8" class="leaflet-attribution-flag"><path fill="#4C7BE1" d="M0 0h12v4H0z"/><path fill="#FFD500" d="M0 4h12v3H0z"/><path fill="#E0BC00" d="M0 7h12v1H0z"/></svg>';
var $574b686e85b098af$export$c18a293673ef2524 = (0, $257bd5e7d2d57b63$export$7a7fa4424cb20976).extend({
    // @section
    // @aka Control.Attribution options
    options: {
        position: "bottomright",
        // @option prefix: String|false = 'Leaflet'
        // The HTML text shown before the attributions. Pass `false` to disable.
        prefix: '<a href="https://leafletjs.com" title="A JavaScript library for interactive maps">' + ((0, $bda63d751c06734c$export$2e2bcd8739ae039).inlineSvg ? $574b686e85b098af$var$ukrainianFlag + " " : "") + "Leaflet</a>"
    },
    initialize: function(options) {
        $13bbd556cd7cee10$export$add91eafeaeab287(this, options);
        this._attributions = {};
    },
    onAdd: function(map) {
        map.attributionControl = this;
        this._container = $783b7cedd5fd919a$export$185802fd694ee1f5("div", "leaflet-control-attribution");
        $2148974bfeaf2ac1$export$a640b530813b3952(this._container);
        // TODO ugly, refactor
        for(var i in map._layers)if (map._layers[i].getAttribution) this.addAttribution(map._layers[i].getAttribution());
        this._update();
        map.on("layeradd", this._addAttribution, this);
        return this._container;
    },
    onRemove: function(map) {
        map.off("layeradd", this._addAttribution, this);
    },
    _addAttribution: function(ev) {
        if (ev.layer.getAttribution) {
            this.addAttribution(ev.layer.getAttribution());
            ev.layer.once("remove", function() {
                this.removeAttribution(ev.layer.getAttribution());
            }, this);
        }
    },
    // @method setPrefix(prefix: String|false): this
    // The HTML text shown before the attributions. Pass `false` to disable.
    setPrefix: function(prefix) {
        this.options.prefix = prefix;
        this._update();
        return this;
    },
    // @method addAttribution(text: String): this
    // Adds an attribution text (e.g. `'&copy; OpenStreetMap contributors'`).
    addAttribution: function(text) {
        if (!text) return this;
        if (!this._attributions[text]) this._attributions[text] = 0;
        this._attributions[text]++;
        this._update();
        return this;
    },
    // @method removeAttribution(text: String): this
    // Removes an attribution text.
    removeAttribution: function(text) {
        if (!text) return this;
        if (this._attributions[text]) {
            this._attributions[text]--;
            this._update();
        }
        return this;
    },
    _update: function() {
        if (!this._map) return;
        var attribs = [];
        for(var i in this._attributions)if (this._attributions[i]) attribs.push(i);
        var prefixAndAttribs = [];
        if (this.options.prefix) prefixAndAttribs.push(this.options.prefix);
        if (attribs.length) prefixAndAttribs.push(attribs.join(", "));
        this._container.innerHTML = prefixAndAttribs.join(' <span aria-hidden="true">|</span> ');
    }
});
// @namespace Map
// @section Control options
// @option attributionControl: Boolean = true
// Whether a [attribution control](#control-attribution) is added to the map by default.
(0, $7d9a54c6488daf4f$export$a5c7b93649eaf8f8).mergeOptions({
    attributionControl: true
});
(0, $7d9a54c6488daf4f$export$a5c7b93649eaf8f8).addInitHook(function() {
    if (this.options.attributionControl) new $574b686e85b098af$export$c18a293673ef2524().addTo(this);
});
var $574b686e85b098af$export$9a322927ac1e3d35 = function(options) {
    return new $574b686e85b098af$export$c18a293673ef2524(options);
};


(0, $257bd5e7d2d57b63$export$7a7fa4424cb20976).Layers = (0, $8ade9dc0b848a78a$export$89312ce47c0ca777);
(0, $257bd5e7d2d57b63$export$7a7fa4424cb20976).Zoom = (0, $f7f96624fc1f0b6e$export$65cfd44a2050f99);
(0, $257bd5e7d2d57b63$export$7a7fa4424cb20976).Scale = (0, $b6ccfe0e289b0f35$export$d60cfc58d3c358b6);
(0, $257bd5e7d2d57b63$export$7a7fa4424cb20976).Attribution = (0, $574b686e85b098af$export$c18a293673ef2524);
(0, $257bd5e7d2d57b63$export$b5cde1de278b4330).layers = (0, $8ade9dc0b848a78a$export$7be255094ccdc533);
(0, $257bd5e7d2d57b63$export$b5cde1de278b4330).zoom = (0, $f7f96624fc1f0b6e$export$e83f174dbf56adcc);
(0, $257bd5e7d2d57b63$export$b5cde1de278b4330).scale = (0, $b6ccfe0e289b0f35$export$dcdf75081b88279d);
(0, $257bd5e7d2d57b63$export$b5cde1de278b4330).attribution = (0, $574b686e85b098af$export$9a322927ac1e3d35);






var $2c337e89c81cccb9$export$a428cd33b25d5283 = (0, $f8984dbaa17424d1$export$4c85e640eb41c31b).extend({
    initialize: function(map) {
        this._map = map;
    },
    // @method enable(): this
    // Enables the handler
    enable: function() {
        if (this._enabled) return this;
        this._enabled = true;
        this.addHooks();
        return this;
    },
    // @method disable(): this
    // Disables the handler
    disable: function() {
        if (!this._enabled) return this;
        this._enabled = false;
        this.removeHooks();
        return this;
    },
    // @method enabled(): Boolean
    // Returns `true` if the handler is enabled
    enabled: function() {
        return !!this._enabled;
    }
});
// @section There is static function which can be called without instantiating L.Handler:
// @function addTo(map: Map, name: String): this
// Adds a new Handler to the given map with the given name.
$2c337e89c81cccb9$export$a428cd33b25d5283.addTo = function(map, name) {
    map.addHandler(name, this);
    return this;
};



var $a50f065a5e8bb421$export$c8d63b7d67105f7 = {
    Events: (0, $ca4bf785aeb0758d$export$ada873a34909da65)
};











/*
 * @class Draggable
 * @aka L.Draggable
 * @inherits Evented
 *
 * A class for making DOM elements draggable (including touch support).
 * Used internally for map and marker dragging. Only works for elements
 * that were positioned with [`L.DomUtil.setPosition`](#domutil-setposition).
 *
 * @example
 * ```js
 * var draggable = new L.Draggable(elementToDrag);
 * draggable.enable();
 * ```
 */ var $95c0b7701cd629ed$var$START = (0, $bda63d751c06734c$export$2e2bcd8739ae039).touch ? "touchstart mousedown" : "mousedown";
var $95c0b7701cd629ed$export$f2a139e5d18b9882 = (0, $ca4bf785aeb0758d$export$ebcc362d8f4c4311).extend({
    options: {
        // @section
        // @aka Draggable options
        // @option clickTolerance: Number = 3
        // The max number of pixels a user can shift the mouse pointer during a click
        // for it to be considered a valid click (as opposed to a mouse drag).
        clickTolerance: 3
    },
    // @constructor L.Draggable(el: HTMLElement, dragHandle?: HTMLElement, preventOutline?: Boolean, options?: Draggable options)
    // Creates a `Draggable` object for moving `el` when you start dragging the `dragHandle` element (equals `el` itself by default).
    initialize: function(element, dragStartTarget, preventOutline, options) {
        $13bbd556cd7cee10$export$add91eafeaeab287(this, options);
        this._element = element;
        this._dragStartTarget = dragStartTarget || element;
        this._preventOutline = preventOutline;
    },
    // @method enable()
    // Enables the dragging ability
    enable: function() {
        if (this._enabled) return;
        $2148974bfeaf2ac1$export$af631764ddc44097(this._dragStartTarget, $95c0b7701cd629ed$var$START, this._onDown, this);
        this._enabled = true;
    },
    // @method disable()
    // Disables the dragging ability
    disable: function() {
        if (!this._enabled) return;
        // If we're currently dragging this draggable,
        // disabling it counts as first ending the drag.
        if ($95c0b7701cd629ed$export$f2a139e5d18b9882._dragging === this) this.finishDrag(true);
        $2148974bfeaf2ac1$export$8c8705df4a2dcec9(this._dragStartTarget, $95c0b7701cd629ed$var$START, this._onDown, this);
        this._enabled = false;
        this._moved = false;
    },
    _onDown: function(e) {
        // Ignore the event if disabled; this happens in IE11
        // under some circumstances, see #3666.
        if (!this._enabled) return;
        this._moved = false;
        if ($783b7cedd5fd919a$export$4ea3d958472af68f(this._element, "leaflet-zoom-anim")) return;
        if (e.touches && e.touches.length !== 1) {
            // Finish dragging to avoid conflict with touchZoom
            if ($95c0b7701cd629ed$export$f2a139e5d18b9882._dragging === this) this.finishDrag();
            return;
        }
        if ($95c0b7701cd629ed$export$f2a139e5d18b9882._dragging || e.shiftKey || e.which !== 1 && e.button !== 1 && !e.touches) return;
        $95c0b7701cd629ed$export$f2a139e5d18b9882._dragging = this; // Prevent dragging multiple objects at once.
        if (this._preventOutline) $783b7cedd5fd919a$export$73d26a0c96b464b6(this._element);
        $783b7cedd5fd919a$export$188eb2a17526281();
        $783b7cedd5fd919a$export$16a4697467175487();
        if (this._moving) return;
        // @event down: Event
        // Fired when a drag is about to start.
        this.fire("down");
        var first = e.touches ? e.touches[0] : e, sizedParent = $783b7cedd5fd919a$export$d444b651082dbd47(this._element);
        this._startPoint = new (0, $b802e4aa6d666b45$export$baf26146a414f24a)(first.clientX, first.clientY);
        this._startPos = $783b7cedd5fd919a$export$1690e12b840569b9(this._element);
        // Cache the scale, so that we can continuously compensate for it during drag (_onMove).
        this._parentScale = $783b7cedd5fd919a$export$5cdac61cf538712e(sizedParent);
        var mouseevent = e.type === "mousedown";
        $2148974bfeaf2ac1$export$af631764ddc44097(document, mouseevent ? "mousemove" : "touchmove", this._onMove, this);
        $2148974bfeaf2ac1$export$af631764ddc44097(document, mouseevent ? "mouseup" : "touchend touchcancel", this._onUp, this);
    },
    _onMove: function(e) {
        // Ignore the event if disabled; this happens in IE11
        // under some circumstances, see #3666.
        if (!this._enabled) return;
        if (e.touches && e.touches.length > 1) {
            this._moved = true;
            return;
        }
        var first = e.touches && e.touches.length === 1 ? e.touches[0] : e, offset = new (0, $b802e4aa6d666b45$export$baf26146a414f24a)(first.clientX, first.clientY)._subtract(this._startPoint);
        if (!offset.x && !offset.y) return;
        if (Math.abs(offset.x) + Math.abs(offset.y) < this.options.clickTolerance) return;
        // We assume that the parent container's position, border and scale do not change for the duration of the drag.
        // Therefore there is no need to account for the position and border (they are eliminated by the subtraction)
        // and we can use the cached value for the scale.
        offset.x /= this._parentScale.x;
        offset.y /= this._parentScale.y;
        $2148974bfeaf2ac1$export$fa3b29edae795ef4(e);
        if (!this._moved) {
            // @event dragstart: Event
            // Fired when a drag starts
            this.fire("dragstart");
            this._moved = true;
            $783b7cedd5fd919a$export$d2cf6cd1dc7067d3(document.body, "leaflet-dragging");
            this._lastTarget = e.target || e.srcElement;
            // IE and Edge do not give the <use> element, so fetch it
            // if necessary
            if (window.SVGElementInstance && this._lastTarget instanceof window.SVGElementInstance) this._lastTarget = this._lastTarget.correspondingUseElement;
            $783b7cedd5fd919a$export$d2cf6cd1dc7067d3(this._lastTarget, "leaflet-drag-target");
        }
        this._newPos = this._startPos.add(offset);
        this._moving = true;
        this._lastEvent = e;
        this._updatePosition();
    },
    _updatePosition: function() {
        var e = {
            originalEvent: this._lastEvent
        };
        // @event predrag: Event
        // Fired continuously during dragging *before* each corresponding
        // update of the element's position.
        this.fire("predrag", e);
        $783b7cedd5fd919a$export$f9b088a47202d605(this._element, this._newPos);
        // @event drag: Event
        // Fired continuously during dragging.
        this.fire("drag", e);
    },
    _onUp: function() {
        // Ignore the event if disabled; this happens in IE11
        // under some circumstances, see #3666.
        if (!this._enabled) return;
        this.finishDrag();
    },
    finishDrag: function(noInertia) {
        $783b7cedd5fd919a$export$c2255604a80b4506(document.body, "leaflet-dragging");
        if (this._lastTarget) {
            $783b7cedd5fd919a$export$c2255604a80b4506(this._lastTarget, "leaflet-drag-target");
            this._lastTarget = null;
        }
        $2148974bfeaf2ac1$export$8c8705df4a2dcec9(document, "mousemove touchmove", this._onMove, this);
        $2148974bfeaf2ac1$export$8c8705df4a2dcec9(document, "mouseup touchend touchcancel", this._onUp, this);
        $783b7cedd5fd919a$export$f5ef98e1c9198e63();
        $783b7cedd5fd919a$export$b1bf1c69425cc693();
        var fireDragend = this._moved && this._moving;
        this._moving = false;
        $95c0b7701cd629ed$export$f2a139e5d18b9882._dragging = false;
        if (fireDragend) // @event dragend: DragEndEvent
        // Fired when the drag ends.
        this.fire("dragend", {
            noInertia: noInertia,
            distance: this._newPos.distanceTo(this._startPos)
        });
    }
});














function $9967a26f907fd395$export$cf9573e980d97240(points, bounds, round) {
    var clippedPoints, edges = [
        1,
        4,
        2,
        8
    ], i, j, k, a, b, len, edge, p;
    for(i = 0, len = points.length; i < len; i++)points[i]._code = $a1a431c02009e354$export$ba8a7cb9c0fb62cb(points[i], bounds);
    // for each edge (left, bottom, right, top)
    for(k = 0; k < 4; k++){
        edge = edges[k];
        clippedPoints = [];
        for(i = 0, len = points.length, j = len - 1; i < len; j = i++){
            a = points[i];
            b = points[j];
            // if a is inside the clip window
            if (!(a._code & edge)) {
                // if b is outside the clip window (a->b goes out of screen)
                if (b._code & edge) {
                    p = $a1a431c02009e354$export$fec5f43a3caeaae9(b, a, edge, bounds, round);
                    p._code = $a1a431c02009e354$export$ba8a7cb9c0fb62cb(p, bounds);
                    clippedPoints.push(p);
                }
                clippedPoints.push(a);
            // else if b is inside the clip window (a->b enters the screen)
            } else if (!(b._code & edge)) {
                p = $a1a431c02009e354$export$fec5f43a3caeaae9(b, a, edge, bounds, round);
                p._code = $a1a431c02009e354$export$ba8a7cb9c0fb62cb(p, bounds);
                clippedPoints.push(p);
            }
        }
        points = clippedPoints;
    }
    return points;
}
function $9967a26f907fd395$export$ab087439b250a32c(latlngs, crs) {
    var i, j, p1, p2, f, area, x, y, center;
    if (!latlngs || latlngs.length === 0) throw new Error("latlngs not passed");
    if (!$a1a431c02009e354$export$5a20f49a17c681a1(latlngs)) {
        console.warn("latlngs are not flat! Only the first ring will be used");
        latlngs = latlngs[0];
    }
    var centroidLatLng = (0, $df6fd3b1bc3e4292$export$a192f247fc7a2057)([
        0,
        0
    ]);
    var bounds = (0, $c1a09dde0ebe0161$export$4904432a68b0399)(latlngs);
    var areaBounds = bounds.getNorthWest().distanceTo(bounds.getSouthWest()) * bounds.getNorthEast().distanceTo(bounds.getNorthWest());
    // tests showed that below 1700 rounding errors are happening
    if (areaBounds < 1700) // getting a inexact center, to move the latlngs near to [0, 0] to prevent rounding errors
    centroidLatLng = $9967a26f907fd395$export$e2a20c553f6c85ce(latlngs);
    var len = latlngs.length;
    var points = [];
    for(i = 0; i < len; i++){
        var latlng = (0, $df6fd3b1bc3e4292$export$a192f247fc7a2057)(latlngs[i]);
        points.push(crs.project((0, $df6fd3b1bc3e4292$export$a192f247fc7a2057)([
            latlng.lat - centroidLatLng.lat,
            latlng.lng - centroidLatLng.lng
        ])));
    }
    area = x = y = 0;
    // polygon centroid algorithm;
    for(i = 0, j = len - 1; i < len; j = i++){
        p1 = points[i];
        p2 = points[j];
        f = p1.y * p2.x - p2.y * p1.x;
        x += (p1.x + p2.x) * f;
        y += (p1.y + p2.y) * f;
        area += f * 3;
    }
    if (area === 0) // Polygon is so small that all points are on same pixel.
    center = points[0];
    else center = [
        x / area,
        y / area
    ];
    var latlngCenter = crs.unproject((0, $b802e4aa6d666b45$export$b63cca88ddc558a9)(center));
    return (0, $df6fd3b1bc3e4292$export$a192f247fc7a2057)([
        latlngCenter.lat + centroidLatLng.lat,
        latlngCenter.lng + centroidLatLng.lng
    ]);
}
function $9967a26f907fd395$export$e2a20c553f6c85ce(coords) {
    var latSum = 0;
    var lngSum = 0;
    var len = 0;
    for(var i = 0; i < coords.length; i++){
        var latlng = (0, $df6fd3b1bc3e4292$export$a192f247fc7a2057)(coords[i]);
        latSum += latlng.lat;
        lngSum += latlng.lng;
        len++;
    }
    return (0, $df6fd3b1bc3e4292$export$a192f247fc7a2057)([
        latSum / len,
        lngSum / len
    ]);
}



function $a1a431c02009e354$export$798b53621063651(points, tolerance) {
    if (!tolerance || !points.length) return points.slice();
    var sqTolerance = tolerance * tolerance;
    // stage 1: vertex reduction
    points = $a1a431c02009e354$var$_reducePoints(points, sqTolerance);
    // stage 2: Douglas-Peucker simplification
    points = $a1a431c02009e354$var$_simplifyDP(points, sqTolerance);
    return points;
}
function $a1a431c02009e354$export$f96afe567099ccbe(p, p1, p2) {
    return Math.sqrt($a1a431c02009e354$export$618e0d6606476a13(p, p1, p2, true));
}
function $a1a431c02009e354$export$86054985d34bae0d(p, p1, p2) {
    return $a1a431c02009e354$export$618e0d6606476a13(p, p1, p2);
}
// Ramer-Douglas-Peucker simplification, see https://en.wikipedia.org/wiki/Ramer-Douglas-Peucker_algorithm
function $a1a431c02009e354$var$_simplifyDP(points, sqTolerance) {
    var len = points.length, ArrayConstructor = typeof Uint8Array !== "undefined" ? Uint8Array : Array, markers = new ArrayConstructor(len);
    markers[0] = markers[len - 1] = 1;
    $a1a431c02009e354$var$_simplifyDPStep(points, markers, sqTolerance, 0, len - 1);
    var i, newPoints = [];
    for(i = 0; i < len; i++)if (markers[i]) newPoints.push(points[i]);
    return newPoints;
}
function $a1a431c02009e354$var$_simplifyDPStep(points, markers, sqTolerance, first, last) {
    var maxSqDist = 0, index, i, sqDist;
    for(i = first + 1; i <= last - 1; i++){
        sqDist = $a1a431c02009e354$export$618e0d6606476a13(points[i], points[first], points[last], true);
        if (sqDist > maxSqDist) {
            index = i;
            maxSqDist = sqDist;
        }
    }
    if (maxSqDist > sqTolerance) {
        markers[index] = 1;
        $a1a431c02009e354$var$_simplifyDPStep(points, markers, sqTolerance, first, index);
        $a1a431c02009e354$var$_simplifyDPStep(points, markers, sqTolerance, index, last);
    }
}
// reduce points that are too close to each other to a single point
function $a1a431c02009e354$var$_reducePoints(points, sqTolerance) {
    var reducedPoints = [
        points[0]
    ];
    for(var i = 1, prev = 0, len = points.length; i < len; i++)if ($a1a431c02009e354$var$_sqDist(points[i], points[prev]) > sqTolerance) {
        reducedPoints.push(points[i]);
        prev = i;
    }
    if (prev < len - 1) reducedPoints.push(points[len - 1]);
    return reducedPoints;
}
var $a1a431c02009e354$var$_lastCode;
function $a1a431c02009e354$export$2ba0cd7011ee887c(a, b, bounds, useLastCode, round) {
    var codeA = useLastCode ? $a1a431c02009e354$var$_lastCode : $a1a431c02009e354$export$ba8a7cb9c0fb62cb(a, bounds), codeB = $a1a431c02009e354$export$ba8a7cb9c0fb62cb(b, bounds), codeOut, p, newCode;
    // save 2nd code to avoid calculating it on the next segment
    $a1a431c02009e354$var$_lastCode = codeB;
    while(true){
        // if a,b is inside the clip window (trivial accept)
        if (!(codeA | codeB)) return [
            a,
            b
        ];
        // if a,b is outside the clip window (trivial reject)
        if (codeA & codeB) return false;
        // other cases
        codeOut = codeA || codeB;
        p = $a1a431c02009e354$export$fec5f43a3caeaae9(a, b, codeOut, bounds, round);
        newCode = $a1a431c02009e354$export$ba8a7cb9c0fb62cb(p, bounds);
        if (codeOut === codeA) {
            a = p;
            codeA = newCode;
        } else {
            b = p;
            codeB = newCode;
        }
    }
}
function $a1a431c02009e354$export$fec5f43a3caeaae9(a, b, code, bounds, round) {
    var dx = b.x - a.x, dy = b.y - a.y, min = bounds.min, max = bounds.max, x, y;
    if (code & 8) {
        x = a.x + dx * (max.y - a.y) / dy;
        y = max.y;
    } else if (code & 4) {
        x = a.x + dx * (min.y - a.y) / dy;
        y = min.y;
    } else if (code & 2) {
        x = max.x;
        y = a.y + dy * (max.x - a.x) / dx;
    } else if (code & 1) {
        x = min.x;
        y = a.y + dy * (min.x - a.x) / dx;
    }
    return new (0, $b802e4aa6d666b45$export$baf26146a414f24a)(x, y, round);
}
function $a1a431c02009e354$export$ba8a7cb9c0fb62cb(p, bounds) {
    var code = 0;
    if (p.x < bounds.min.x) code |= 1;
    else if (p.x > bounds.max.x) code |= 2;
    if (p.y < bounds.min.y) code |= 4;
    else if (p.y > bounds.max.y) code |= 8;
    return code;
}
// square distance (to avoid unnecessary Math.sqrt calls)
function $a1a431c02009e354$var$_sqDist(p1, p2) {
    var dx = p2.x - p1.x, dy = p2.y - p1.y;
    return dx * dx + dy * dy;
}
function $a1a431c02009e354$export$618e0d6606476a13(p, p1, p2, sqDist) {
    var x = p1.x, y = p1.y, dx = p2.x - x, dy = p2.y - y, dot = dx * dx + dy * dy, t;
    if (dot > 0) {
        t = ((p.x - x) * dx + (p.y - y) * dy) / dot;
        if (t > 1) {
            x = p2.x;
            y = p2.y;
        } else if (t > 0) {
            x += dx * t;
            y += dy * t;
        }
    }
    dx = p.x - x;
    dy = p.y - y;
    return sqDist ? dx * dx + dy * dy : new (0, $b802e4aa6d666b45$export$baf26146a414f24a)(x, y);
}
function $a1a431c02009e354$export$5a20f49a17c681a1(latlngs) {
    return !$13bbd556cd7cee10$export$43bee75e5e14138e(latlngs[0]) || typeof latlngs[0][0] !== "object" && typeof latlngs[0][0] !== "undefined";
}
function $a1a431c02009e354$export$cad69f152e26932d(latlngs) {
    console.warn("Deprecated use of _flat, please use L.LineUtil.isFlat instead.");
    return $a1a431c02009e354$export$5a20f49a17c681a1(latlngs);
}
function $a1a431c02009e354$export$a2a52905e1ae659c(latlngs, crs) {
    var i, halfDist, segDist, dist, p1, p2, ratio, center;
    if (!latlngs || latlngs.length === 0) throw new Error("latlngs not passed");
    if (!$a1a431c02009e354$export$5a20f49a17c681a1(latlngs)) {
        console.warn("latlngs are not flat! Only the first ring will be used");
        latlngs = latlngs[0];
    }
    var centroidLatLng = (0, $df6fd3b1bc3e4292$export$a192f247fc7a2057)([
        0,
        0
    ]);
    var bounds = (0, $c1a09dde0ebe0161$export$4904432a68b0399)(latlngs);
    var areaBounds = bounds.getNorthWest().distanceTo(bounds.getSouthWest()) * bounds.getNorthEast().distanceTo(bounds.getNorthWest());
    // tests showed that below 1700 rounding errors are happening
    if (areaBounds < 1700) // getting a inexact center, to move the latlngs near to [0, 0] to prevent rounding errors
    centroidLatLng = (0, $9967a26f907fd395$export$e2a20c553f6c85ce)(latlngs);
    var len = latlngs.length;
    var points = [];
    for(i = 0; i < len; i++){
        var latlng = (0, $df6fd3b1bc3e4292$export$a192f247fc7a2057)(latlngs[i]);
        points.push(crs.project((0, $df6fd3b1bc3e4292$export$a192f247fc7a2057)([
            latlng.lat - centroidLatLng.lat,
            latlng.lng - centroidLatLng.lng
        ])));
    }
    for(i = 0, halfDist = 0; i < len - 1; i++)halfDist += points[i].distanceTo(points[i + 1]) / 2;
    // The line is so small in the current view that all points are on the same pixel.
    if (halfDist === 0) center = points[0];
    else for(i = 0, dist = 0; i < len - 1; i++){
        p1 = points[i];
        p2 = points[i + 1];
        segDist = p1.distanceTo(p2);
        dist += segDist;
        if (dist > halfDist) {
            ratio = (dist - halfDist) / segDist;
            center = [
                p2.x - ratio * (p2.x - p1.x),
                p2.y - ratio * (p2.y - p1.y)
            ];
            break;
        }
    }
    var latlngCenter = crs.unproject((0, $b802e4aa6d666b45$export$b63cca88ddc558a9)(center));
    return (0, $df6fd3b1bc3e4292$export$a192f247fc7a2057)([
        latlngCenter.lat + centroidLatLng.lat,
        latlngCenter.lng + centroidLatLng.lng
    ]);
}







/*
 * @class Projection

 * An object with methods for projecting geographical coordinates of the world onto
 * a flat surface (and back). See [Map projection](https://en.wikipedia.org/wiki/Map_projection).

 * @property bounds: Bounds
 * The bounds (specified in CRS units) where the projection is valid

 * @method project(latlng: LatLng): Point
 * Projects geographical coordinates into a 2D point.
 * Only accepts actual `L.LatLng` instances, not arrays.

 * @method unproject(point: Point): LatLng
 * The inverse of `project`. Projects a 2D point into a geographical location.
 * Only accepts actual `L.Point` instances, not arrays.

 * Note that the projection instances do not inherit from Leaflet's `Class` object,
 * and can't be instantiated. Also, new classes can't inherit from them,
 * and methods can't be added to them with the `include` function.

 */ 


var $bc2d1ac3a3b96e35$export$e7f0da3b842d3901 = {
    project: function(latlng) {
        return new (0, $b802e4aa6d666b45$export$baf26146a414f24a)(latlng.lng, latlng.lat);
    },
    unproject: function(point) {
        return new (0, $df6fd3b1bc3e4292$export$5fd359ea0b43bded)(point.y, point.x);
    },
    bounds: new (0, $2ffe56518af276c5$export$c4e9d269599ab4b4)([
        -180,
        -90
    ], [
        180,
        90
    ])
};





var $1f288a74ac02dd7f$export$10a6535c298114cf = {
    R: 6378137,
    R_MINOR: 6356752.314245179,
    bounds: new (0, $2ffe56518af276c5$export$c4e9d269599ab4b4)([
        -20037508.34279,
        -15496570.73972
    ], [
        20037508.34279,
        18764656.23138
    ]),
    project: function(latlng) {
        var d = Math.PI / 180, r = this.R, y = latlng.lat * d, tmp = this.R_MINOR / r, e = Math.sqrt(1 - tmp * tmp), con = e * Math.sin(y);
        var ts = Math.tan(Math.PI / 4 - y / 2) / Math.pow((1 - con) / (1 + con), e / 2);
        y = -r * Math.log(Math.max(ts, 1E-10));
        return new (0, $b802e4aa6d666b45$export$baf26146a414f24a)(latlng.lng * d * r, y);
    },
    unproject: function(point) {
        var d = 180 / Math.PI, r = this.R, tmp = this.R_MINOR / r, e = Math.sqrt(1 - tmp * tmp), ts = Math.exp(-point.y / r), phi = Math.PI / 2 - 2 * Math.atan(ts);
        for(var i = 0, dphi = 0.1, con; i < 15 && Math.abs(dphi) > 1e-7; i++){
            con = e * Math.sin(phi);
            con = Math.pow((1 - con) / (1 + con), e / 2);
            dphi = Math.PI / 2 - 2 * Math.atan(ts * con) - phi;
            phi += dphi;
        }
        return new (0, $df6fd3b1bc3e4292$export$5fd359ea0b43bded)(phi * d, point.x * d / r);
    }
};











var $429df527e42b7223$export$4ca8c84c9ce518e1 = $13bbd556cd7cee10$export$8b58be045bf06082({}, (0, $22c0063417eeaa98$export$a8d7cb18a6ef9581), {
    code: "EPSG:3395",
    projection: (0, $1f288a74ac02dd7f$export$10a6535c298114cf),
    transformation: function() {
        var scale = 0.5 / (Math.PI * (0, $1f288a74ac02dd7f$export$10a6535c298114cf).R);
        return (0, $26f57cb74c82546e$export$9f6f7fcc395e278)(scale, 0.5, -scale, 0.5);
    }()
});







var $8b371d276c86fbe0$export$6e6fafcc50e60294 = $13bbd556cd7cee10$export$8b58be045bf06082({}, (0, $22c0063417eeaa98$export$a8d7cb18a6ef9581), {
    code: "EPSG:4326",
    projection: (0, $bc2d1ac3a3b96e35$export$e7f0da3b842d3901),
    transformation: (0, $26f57cb74c82546e$export$9f6f7fcc395e278)(1 / 180, 1, -1 / 180, 0.5)
});






var $e8af51cb35bd7ae3$export$f3818faa9fce9618 = $13bbd556cd7cee10$export$8b58be045bf06082({}, (0, $9bd7d3356f07c68c$export$bdae29047cba02fc), {
    projection: (0, $bc2d1ac3a3b96e35$export$e7f0da3b842d3901),
    transformation: (0, $26f57cb74c82546e$export$9f6f7fcc395e278)(1, 0, -1, 0),
    scale: function(zoom) {
        return Math.pow(2, zoom);
    },
    zoom: function(scale) {
        return Math.log(scale) / Math.LN2;
    },
    distance: function(latlng1, latlng2) {
        var dx = latlng2.lng - latlng1.lng, dy = latlng2.lat - latlng1.lat;
        return Math.sqrt(dx * dx + dy * dy);
    },
    infinite: true
});


(0, $9bd7d3356f07c68c$export$bdae29047cba02fc).Earth = (0, $22c0063417eeaa98$export$a8d7cb18a6ef9581);
(0, $9bd7d3356f07c68c$export$bdae29047cba02fc).EPSG3395 = (0, $429df527e42b7223$export$4ca8c84c9ce518e1);
(0, $9bd7d3356f07c68c$export$bdae29047cba02fc).EPSG3857 = (0, $c02c17eb3d2fe7a7$export$fa530d80b080b222);
(0, $9bd7d3356f07c68c$export$bdae29047cba02fc).EPSG900913 = (0, $c02c17eb3d2fe7a7$export$ca3534a3dff3e397);
(0, $9bd7d3356f07c68c$export$bdae29047cba02fc).EPSG4326 = (0, $8b371d276c86fbe0$export$6e6fafcc50e60294);
(0, $9bd7d3356f07c68c$export$bdae29047cba02fc).Simple = (0, $e8af51cb35bd7ae3$export$f3818faa9fce9618);







var $3219933a0a8d4dcc$export$936d0764594b6eb3 = (0, $ca4bf785aeb0758d$export$ebcc362d8f4c4311).extend({
    // Classes extending `L.Layer` will inherit the following options:
    options: {
        // @option pane: String = 'overlayPane'
        // By default the layer will be added to the map's [overlay pane](#map-overlaypane). Overriding this option will cause the layer to be placed on another pane by default.
        pane: "overlayPane",
        // @option attribution: String = null
        // String to be shown in the attribution control, e.g. "© OpenStreetMap contributors". It describes the layer data and is often a legal obligation towards copyright holders and tile providers.
        attribution: null,
        bubblingMouseEvents: true
    },
    /* @section
	 * Classes extending `L.Layer` will inherit the following methods:
	 *
	 * @method addTo(map: Map|LayerGroup): this
	 * Adds the layer to the given map or layer group.
	 */ addTo: function(map) {
        map.addLayer(this);
        return this;
    },
    // @method remove: this
    // Removes the layer from the map it is currently active on.
    remove: function() {
        return this.removeFrom(this._map || this._mapToAdd);
    },
    // @method removeFrom(map: Map): this
    // Removes the layer from the given map
    //
    // @alternative
    // @method removeFrom(group: LayerGroup): this
    // Removes the layer from the given `LayerGroup`
    removeFrom: function(obj) {
        if (obj) obj.removeLayer(this);
        return this;
    },
    // @method getPane(name? : String): HTMLElement
    // Returns the `HTMLElement` representing the named pane on the map. If `name` is omitted, returns the pane for this layer.
    getPane: function(name) {
        return this._map.getPane(name ? this.options[name] || name : this.options.pane);
    },
    addInteractiveTarget: function(targetEl) {
        this._map._targets[$13bbd556cd7cee10$export$bd3fba034e28f6b(targetEl)] = this;
        return this;
    },
    removeInteractiveTarget: function(targetEl) {
        delete this._map._targets[$13bbd556cd7cee10$export$bd3fba034e28f6b(targetEl)];
        return this;
    },
    // @method getAttribution: String
    // Used by the `attribution control`, returns the [attribution option](#gridlayer-attribution).
    getAttribution: function() {
        return this.options.attribution;
    },
    _layerAdd: function(e) {
        var map = e.target;
        // check in case layer gets added and then removed before the map is ready
        if (!map.hasLayer(this)) return;
        this._map = map;
        this._zoomAnimated = map._zoomAnimated;
        if (this.getEvents) {
            var events = this.getEvents();
            map.on(events, this);
            this.once("remove", function() {
                map.off(events, this);
            }, this);
        }
        this.onAdd(map);
        this.fire("add");
        map.fire("layeradd", {
            layer: this
        });
    }
});
/* @section Extension methods
 * @uninheritable
 *
 * Every layer should extend from `L.Layer` and (re-)implement the following methods.
 *
 * @method onAdd(map: Map): this
 * Should contain code that creates DOM elements for the layer, adds them to `map panes` where they should belong and puts listeners on relevant map events. Called on [`map.addLayer(layer)`](#map-addlayer).
 *
 * @method onRemove(map: Map): this
 * Should contain all clean up code that removes the layer's elements from the DOM and removes listeners previously added in [`onAdd`](#layer-onadd). Called on [`map.removeLayer(layer)`](#map-removelayer).
 *
 * @method getEvents(): Object
 * This optional method should return an object like `{ viewreset: this._reset }` for [`addEventListener`](#evented-addeventlistener). The event handlers in this object will be automatically added and removed from the map with your layer.
 *
 * @method getAttribution(): String
 * This optional method should return a string containing HTML to be shown on the `Attribution control` whenever the layer is visible.
 *
 * @method beforeAdd(map: Map): this
 * Optional method. Called on [`map.addLayer(layer)`](#map-addlayer), before the layer is added to the map, before events are initialized, without waiting until the map is in a usable state. Use for early initialization only.
 */ /* @namespace Map
 * @section Layer events
 *
 * @event layeradd: LayerEvent
 * Fired when a new layer is added to the map.
 *
 * @event layerremove: LayerEvent
 * Fired when some layer is removed from the map
 *
 * @section Methods for Layers and Controls
 */ (0, $7d9a54c6488daf4f$export$a5c7b93649eaf8f8).include({
    // @method addLayer(layer: Layer): this
    // Adds the given layer to the map
    addLayer: function(layer) {
        if (!layer._layerAdd) throw new Error("The provided object is not a Layer.");
        var id = $13bbd556cd7cee10$export$bd3fba034e28f6b(layer);
        if (this._layers[id]) return this;
        this._layers[id] = layer;
        layer._mapToAdd = this;
        if (layer.beforeAdd) layer.beforeAdd(this);
        this.whenReady(layer._layerAdd, layer);
        return this;
    },
    // @method removeLayer(layer: Layer): this
    // Removes the given layer from the map.
    removeLayer: function(layer) {
        var id = $13bbd556cd7cee10$export$bd3fba034e28f6b(layer);
        if (!this._layers[id]) return this;
        if (this._loaded) layer.onRemove(this);
        delete this._layers[id];
        if (this._loaded) {
            this.fire("layerremove", {
                layer: layer
            });
            layer.fire("remove");
        }
        layer._map = layer._mapToAdd = null;
        return this;
    },
    // @method hasLayer(layer: Layer): Boolean
    // Returns `true` if the given layer is currently added to the map
    hasLayer: function(layer) {
        return $13bbd556cd7cee10$export$bd3fba034e28f6b(layer) in this._layers;
    },
    /* @method eachLayer(fn: Function, context?: Object): this
	 * Iterates over the layers of the map, optionally specifying context of the iterator function.
	 * ```
	 * map.eachLayer(function(layer){
	 *     layer.bindPopup('Hello');
	 * });
	 * ```
	 */ eachLayer: function(method, context) {
        for(var i in this._layers)method.call(context, this._layers[i]);
        return this;
    },
    _addLayers: function(layers) {
        layers = layers ? $13bbd556cd7cee10$export$43bee75e5e14138e(layers) ? layers : [
            layers
        ] : [];
        for(var i = 0, len = layers.length; i < len; i++)this.addLayer(layers[i]);
    },
    _addZoomLimit: function(layer) {
        if (!isNaN(layer.options.maxZoom) || !isNaN(layer.options.minZoom)) {
            this._zoomBoundLayers[$13bbd556cd7cee10$export$bd3fba034e28f6b(layer)] = layer;
            this._updateZoomLevels();
        }
    },
    _removeZoomLimit: function(layer) {
        var id = $13bbd556cd7cee10$export$bd3fba034e28f6b(layer);
        if (this._zoomBoundLayers[id]) {
            delete this._zoomBoundLayers[id];
            this._updateZoomLevels();
        }
    },
    _updateZoomLevels: function() {
        var minZoom = Infinity, maxZoom = -Infinity, oldZoomSpan = this._getZoomSpan();
        for(var i in this._zoomBoundLayers){
            var options = this._zoomBoundLayers[i].options;
            minZoom = options.minZoom === undefined ? minZoom : Math.min(minZoom, options.minZoom);
            maxZoom = options.maxZoom === undefined ? maxZoom : Math.max(maxZoom, options.maxZoom);
        }
        this._layersMaxZoom = maxZoom === -Infinity ? undefined : maxZoom;
        this._layersMinZoom = minZoom === Infinity ? undefined : minZoom;
        // @section Map state change events
        // @event zoomlevelschange: Event
        // Fired when the number of zoomlevels on the map is changed due
        // to adding or removing a layer.
        if (oldZoomSpan !== this._getZoomSpan()) this.fire("zoomlevelschange");
        if (this.options.maxZoom === undefined && this._layersMaxZoom && this.getZoom() > this._layersMaxZoom) this.setZoom(this._layersMaxZoom);
        if (this.options.minZoom === undefined && this._layersMinZoom && this.getZoom() < this._layersMinZoom) this.setZoom(this._layersMinZoom);
    }
});




var $3ce1fd68e2426278$export$829212b9319961ea = (0, $3219933a0a8d4dcc$export$936d0764594b6eb3).extend({
    initialize: function(layers, options) {
        $13bbd556cd7cee10$export$add91eafeaeab287(this, options);
        this._layers = {};
        var i, len;
        if (layers) for(i = 0, len = layers.length; i < len; i++)this.addLayer(layers[i]);
    },
    // @method addLayer(layer: Layer): this
    // Adds the given layer to the group.
    addLayer: function(layer) {
        var id = this.getLayerId(layer);
        this._layers[id] = layer;
        if (this._map) this._map.addLayer(layer);
        return this;
    },
    // @method removeLayer(layer: Layer): this
    // Removes the given layer from the group.
    // @alternative
    // @method removeLayer(id: Number): this
    // Removes the layer with the given internal ID from the group.
    removeLayer: function(layer) {
        var id = layer in this._layers ? layer : this.getLayerId(layer);
        if (this._map && this._layers[id]) this._map.removeLayer(this._layers[id]);
        delete this._layers[id];
        return this;
    },
    // @method hasLayer(layer: Layer): Boolean
    // Returns `true` if the given layer is currently added to the group.
    // @alternative
    // @method hasLayer(id: Number): Boolean
    // Returns `true` if the given internal ID is currently added to the group.
    hasLayer: function(layer) {
        var layerId = typeof layer === "number" ? layer : this.getLayerId(layer);
        return layerId in this._layers;
    },
    // @method clearLayers(): this
    // Removes all the layers from the group.
    clearLayers: function() {
        return this.eachLayer(this.removeLayer, this);
    },
    // @method invoke(methodName: String, …): this
    // Calls `methodName` on every layer contained in this group, passing any
    // additional parameters. Has no effect if the layers contained do not
    // implement `methodName`.
    invoke: function(methodName) {
        var args = Array.prototype.slice.call(arguments, 1), i, layer;
        for(i in this._layers){
            layer = this._layers[i];
            if (layer[methodName]) layer[methodName].apply(layer, args);
        }
        return this;
    },
    onAdd: function(map) {
        this.eachLayer(map.addLayer, map);
    },
    onRemove: function(map) {
        this.eachLayer(map.removeLayer, map);
    },
    // @method eachLayer(fn: Function, context?: Object): this
    // Iterates over the layers of the group, optionally specifying context of the iterator function.
    // ```js
    // group.eachLayer(function (layer) {
    // 	layer.bindPopup('Hello');
    // });
    // ```
    eachLayer: function(method, context) {
        for(var i in this._layers)method.call(context, this._layers[i]);
        return this;
    },
    // @method getLayer(id: Number): Layer
    // Returns the layer with the given internal ID.
    getLayer: function(id) {
        return this._layers[id];
    },
    // @method getLayers(): Layer[]
    // Returns an array of all the layers added to the group.
    getLayers: function() {
        var layers = [];
        this.eachLayer(layers.push, layers);
        return layers;
    },
    // @method setZIndex(zIndex: Number): this
    // Calls `setZIndex` on every layer contained in this group, passing the z-index.
    setZIndex: function(zIndex) {
        return this.invoke("setZIndex", zIndex);
    },
    // @method getLayerId(layer: Layer): Number
    // Returns the internal ID for a layer
    getLayerId: function(layer) {
        return $13bbd556cd7cee10$export$bd3fba034e28f6b(layer);
    }
});
var $3ce1fd68e2426278$export$ee36a4b3469360e3 = function(layers, options) {
    return new $3ce1fd68e2426278$export$829212b9319961ea(layers, options);
};




var $fe973108fad44854$export$520fbf7f9cbd232d = (0, $3ce1fd68e2426278$export$829212b9319961ea).extend({
    addLayer: function(layer) {
        if (this.hasLayer(layer)) return this;
        layer.addEventParent(this);
        (0, $3ce1fd68e2426278$export$829212b9319961ea).prototype.addLayer.call(this, layer);
        // @event layeradd: LayerEvent
        // Fired when a layer is added to this `FeatureGroup`
        return this.fire("layeradd", {
            layer: layer
        });
    },
    removeLayer: function(layer) {
        if (!this.hasLayer(layer)) return this;
        if (layer in this._layers) layer = this._layers[layer];
        layer.removeEventParent(this);
        (0, $3ce1fd68e2426278$export$829212b9319961ea).prototype.removeLayer.call(this, layer);
        // @event layerremove: LayerEvent
        // Fired when a layer is removed from this `FeatureGroup`
        return this.fire("layerremove", {
            layer: layer
        });
    },
    // @method setStyle(style: Path options): this
    // Sets the given path options to each layer of the group that has a `setStyle` method.
    setStyle: function(style) {
        return this.invoke("setStyle", style);
    },
    // @method bringToFront(): this
    // Brings the layer group to the top of all other layers
    bringToFront: function() {
        return this.invoke("bringToFront");
    },
    // @method bringToBack(): this
    // Brings the layer group to the back of all other layers
    bringToBack: function() {
        return this.invoke("bringToBack");
    },
    // @method getBounds(): LatLngBounds
    // Returns the LatLngBounds of the Feature Group (created from bounds and coordinates of its children).
    getBounds: function() {
        var bounds = new (0, $c1a09dde0ebe0161$export$fe84d4076a55a8e6)();
        for(var id in this._layers){
            var layer = this._layers[id];
            bounds.extend(layer.getBounds ? layer.getBounds() : layer.getLatLng());
        }
        return bounds;
    }
});
var $fe973108fad44854$export$5549395e12fb3797 = function(layers, options) {
    return new $fe973108fad44854$export$520fbf7f9cbd232d(layers, options);
};










var $a2a17357df3a183a$export$f04a61298a47a40f = (0, $f8984dbaa17424d1$export$4c85e640eb41c31b).extend({
    /* @section
	 * @aka Icon options
	 *
	 * @option iconUrl: String = null
	 * **(required)** The URL to the icon image (absolute or relative to your script path).
	 *
	 * @option iconRetinaUrl: String = null
	 * The URL to a retina sized version of the icon image (absolute or relative to your
	 * script path). Used for Retina screen devices.
	 *
	 * @option iconSize: Point = null
	 * Size of the icon image in pixels.
	 *
	 * @option iconAnchor: Point = null
	 * The coordinates of the "tip" of the icon (relative to its top left corner). The icon
	 * will be aligned so that this point is at the marker's geographical location. Centered
	 * by default if size is specified, also can be set in CSS with negative margins.
	 *
	 * @option popupAnchor: Point = [0, 0]
	 * The coordinates of the point from which popups will "open", relative to the icon anchor.
	 *
	 * @option tooltipAnchor: Point = [0, 0]
	 * The coordinates of the point from which tooltips will "open", relative to the icon anchor.
	 *
	 * @option shadowUrl: String = null
	 * The URL to the icon shadow image. If not specified, no shadow image will be created.
	 *
	 * @option shadowRetinaUrl: String = null
	 *
	 * @option shadowSize: Point = null
	 * Size of the shadow image in pixels.
	 *
	 * @option shadowAnchor: Point = null
	 * The coordinates of the "tip" of the shadow (relative to its top left corner) (the same
	 * as iconAnchor if not specified).
	 *
	 * @option className: String = ''
	 * A custom class name to assign to both icon and shadow images. Empty by default.
	 */ options: {
        popupAnchor: [
            0,
            0
        ],
        tooltipAnchor: [
            0,
            0
        ],
        // @option crossOrigin: Boolean|String = false
        // Whether the crossOrigin attribute will be added to the tiles.
        // If a String is provided, all tiles will have their crossOrigin attribute set to the String provided. This is needed if you want to access tile pixel data.
        // Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
        crossOrigin: false
    },
    initialize: function(options) {
        (0, $13bbd556cd7cee10$export$add91eafeaeab287)(this, options);
    },
    // @method createIcon(oldIcon?: HTMLElement): HTMLElement
    // Called internally when the icon has to be shown, returns a `<img>` HTML element
    // styled according to the options.
    createIcon: function(oldIcon) {
        return this._createIcon("icon", oldIcon);
    },
    // @method createShadow(oldIcon?: HTMLElement): HTMLElement
    // As `createIcon`, but for the shadow beneath it.
    createShadow: function(oldIcon) {
        return this._createIcon("shadow", oldIcon);
    },
    _createIcon: function(name, oldIcon) {
        var src = this._getIconUrl(name);
        if (!src) {
            if (name === "icon") throw new Error("iconUrl not set in Icon options (see the docs).");
            return null;
        }
        var img = this._createImg(src, oldIcon && oldIcon.tagName === "IMG" ? oldIcon : null);
        this._setIconStyles(img, name);
        if (this.options.crossOrigin || this.options.crossOrigin === "") img.crossOrigin = this.options.crossOrigin === true ? "" : this.options.crossOrigin;
        return img;
    },
    _setIconStyles: function(img, name) {
        var options = this.options;
        var sizeOption = options[name + "Size"];
        if (typeof sizeOption === "number") sizeOption = [
            sizeOption,
            sizeOption
        ];
        var size = (0, $b802e4aa6d666b45$export$b63cca88ddc558a9)(sizeOption), anchor = (0, $b802e4aa6d666b45$export$b63cca88ddc558a9)(name === "shadow" && options.shadowAnchor || options.iconAnchor || size && size.divideBy(2, true));
        img.className = "leaflet-marker-" + name + " " + (options.className || "");
        if (anchor) {
            img.style.marginLeft = -anchor.x + "px";
            img.style.marginTop = -anchor.y + "px";
        }
        if (size) {
            img.style.width = size.x + "px";
            img.style.height = size.y + "px";
        }
    },
    _createImg: function(src, el) {
        el = el || document.createElement("img");
        el.src = src;
        return el;
    },
    _getIconUrl: function(name) {
        return (0, $bda63d751c06734c$export$2e2bcd8739ae039).retina && this.options[name + "RetinaUrl"] || this.options[name + "Url"];
    }
});
function $a2a17357df3a183a$export$1ca1ec8b29a4ce27(options) {
    return new $a2a17357df3a183a$export$f04a61298a47a40f(options);
}



var $2782a71b73f5c155$export$cacc2a877598679f = (0, $a2a17357df3a183a$export$f04a61298a47a40f).extend({
    options: {
        iconUrl: "marker-icon.png",
        iconRetinaUrl: "marker-icon-2x.png",
        shadowUrl: "marker-shadow.png",
        iconSize: [
            25,
            41
        ],
        iconAnchor: [
            12,
            41
        ],
        popupAnchor: [
            1,
            -34
        ],
        tooltipAnchor: [
            16,
            -28
        ],
        shadowSize: [
            41,
            41
        ]
    },
    _getIconUrl: function(name) {
        if (typeof $2782a71b73f5c155$export$cacc2a877598679f.imagePath !== "string") $2782a71b73f5c155$export$cacc2a877598679f.imagePath = this._detectIconPath();
        // @option imagePath: String
        // `Icon.Default` will try to auto-detect the location of the
        // blue icon images. If you are placing these images in a non-standard
        // way, set this option to point to the right path.
        return (this.options.imagePath || $2782a71b73f5c155$export$cacc2a877598679f.imagePath) + (0, $a2a17357df3a183a$export$f04a61298a47a40f).prototype._getIconUrl.call(this, name);
    },
    _stripUrl: function(path) {
        var strip = function(str, re, idx) {
            var match = re.exec(str);
            return match && match[idx];
        };
        path = strip(path, /^url\((['"])?(.+)\1\)$/, 2);
        return path && strip(path, /^(.*)marker-icon\.png$/, 1);
    },
    _detectIconPath: function() {
        var el = $783b7cedd5fd919a$export$185802fd694ee1f5("div", "leaflet-default-icon-path", document.body);
        var path = $783b7cedd5fd919a$export$3d2f074408bd1b82(el, "background-image") || $783b7cedd5fd919a$export$3d2f074408bd1b82(el, "backgroundImage"); // IE8
        document.body.removeChild(el);
        path = this._stripUrl(path);
        if (path) return path;
        var link = document.querySelector('link[href$="leaflet.css"]');
        if (!link) return "";
        return link.href.substring(0, link.href.length - 11 - 1);
    }
});













var $cd159b2c408a71d7$export$7f44c3c808f5c9a4 = (0, $2c337e89c81cccb9$export$a428cd33b25d5283).extend({
    initialize: function(marker) {
        this._marker = marker;
    },
    addHooks: function() {
        var icon = this._marker._icon;
        if (!this._draggable) this._draggable = new (0, $95c0b7701cd629ed$export$f2a139e5d18b9882)(icon, icon, true);
        this._draggable.on({
            dragstart: this._onDragStart,
            predrag: this._onPreDrag,
            drag: this._onDrag,
            dragend: this._onDragEnd
        }, this).enable();
        $783b7cedd5fd919a$export$d2cf6cd1dc7067d3(icon, "leaflet-marker-draggable");
    },
    removeHooks: function() {
        this._draggable.off({
            dragstart: this._onDragStart,
            predrag: this._onPreDrag,
            drag: this._onDrag,
            dragend: this._onDragEnd
        }, this).disable();
        if (this._marker._icon) $783b7cedd5fd919a$export$c2255604a80b4506(this._marker._icon, "leaflet-marker-draggable");
    },
    moved: function() {
        return this._draggable && this._draggable._moved;
    },
    _adjustPan: function(e) {
        var marker = this._marker, map = marker._map, speed = this._marker.options.autoPanSpeed, padding = this._marker.options.autoPanPadding, iconPos = $783b7cedd5fd919a$export$1690e12b840569b9(marker._icon), bounds = map.getPixelBounds(), origin = map.getPixelOrigin();
        var panBounds = (0, $2ffe56518af276c5$export$c8e2f7c8aba65b28)(bounds.min._subtract(origin).add(padding), bounds.max._subtract(origin).subtract(padding));
        if (!panBounds.contains(iconPos)) {
            // Compute incremental movement
            var movement = (0, $b802e4aa6d666b45$export$b63cca88ddc558a9)((Math.max(panBounds.max.x, iconPos.x) - panBounds.max.x) / (bounds.max.x - panBounds.max.x) - (Math.min(panBounds.min.x, iconPos.x) - panBounds.min.x) / (bounds.min.x - panBounds.min.x), (Math.max(panBounds.max.y, iconPos.y) - panBounds.max.y) / (bounds.max.y - panBounds.max.y) - (Math.min(panBounds.min.y, iconPos.y) - panBounds.min.y) / (bounds.min.y - panBounds.min.y)).multiplyBy(speed);
            map.panBy(movement, {
                animate: false
            });
            this._draggable._newPos._add(movement);
            this._draggable._startPos._add(movement);
            $783b7cedd5fd919a$export$f9b088a47202d605(marker._icon, this._draggable._newPos);
            this._onDrag(e);
            this._panRequest = (0, $13bbd556cd7cee10$export$d371ad015c199c06)(this._adjustPan.bind(this, e));
        }
    },
    _onDragStart: function() {
        // @section Dragging events
        // @event dragstart: Event
        // Fired when the user starts dragging the marker.
        // @event movestart: Event
        // Fired when the marker starts moving (because of dragging).
        this._oldLatLng = this._marker.getLatLng();
        // When using ES6 imports it could not be set when `Popup` was not imported as well
        this._marker.closePopup && this._marker.closePopup();
        this._marker.fire("movestart").fire("dragstart");
    },
    _onPreDrag: function(e) {
        if (this._marker.options.autoPan) {
            (0, $13bbd556cd7cee10$export$e1ed83507f55dc9d)(this._panRequest);
            this._panRequest = (0, $13bbd556cd7cee10$export$d371ad015c199c06)(this._adjustPan.bind(this, e));
        }
    },
    _onDrag: function(e) {
        var marker = this._marker, shadow = marker._shadow, iconPos = $783b7cedd5fd919a$export$1690e12b840569b9(marker._icon), latlng = marker._map.layerPointToLatLng(iconPos);
        // update shadow position
        if (shadow) $783b7cedd5fd919a$export$f9b088a47202d605(shadow, iconPos);
        marker._latlng = latlng;
        e.latlng = latlng;
        e.oldLatLng = this._oldLatLng;
        // @event drag: Event
        // Fired repeatedly while the user drags the marker.
        marker.fire("move", e).fire("drag", e);
    },
    _onDragEnd: function(e) {
        // @event dragend: DragEndEvent
        // Fired when the user stops dragging the marker.
        (0, $13bbd556cd7cee10$export$e1ed83507f55dc9d)(this._panRequest);
        // @event moveend: Event
        // Fired when the marker stops moving (because of dragging).
        delete this._oldLatLng;
        this._marker.fire("moveend").fire("dragend", e);
    }
});


var $fda07f58f3165e6f$export$e98856a975cab58e = (0, $3219933a0a8d4dcc$export$936d0764594b6eb3).extend({
    // @section
    // @aka Marker options
    options: {
        // @option icon: Icon = *
        // Icon instance to use for rendering the marker.
        // See [Icon documentation](#L.Icon) for details on how to customize the marker icon.
        // If not specified, a common instance of `L.Icon.Default` is used.
        icon: new (0, $2782a71b73f5c155$export$cacc2a877598679f)(),
        // Option inherited from "Interactive layer" abstract class
        interactive: true,
        // @option keyboard: Boolean = true
        // Whether the marker can be tabbed to with a keyboard and clicked by pressing enter.
        keyboard: true,
        // @option title: String = ''
        // Text for the browser tooltip that appear on marker hover (no tooltip by default).
        // [Useful for accessibility](https://leafletjs.com/examples/accessibility/#markers-must-be-labelled).
        title: "",
        // @option alt: String = 'Marker'
        // Text for the `alt` attribute of the icon image.
        // [Useful for accessibility](https://leafletjs.com/examples/accessibility/#markers-must-be-labelled).
        alt: "Marker",
        // @option zIndexOffset: Number = 0
        // By default, marker images zIndex is set automatically based on its latitude. Use this option if you want to put the marker on top of all others (or below), specifying a high value like `1000` (or high negative value, respectively).
        zIndexOffset: 0,
        // @option opacity: Number = 1.0
        // The opacity of the marker.
        opacity: 1,
        // @option riseOnHover: Boolean = false
        // If `true`, the marker will get on top of others when you hover the mouse over it.
        riseOnHover: false,
        // @option riseOffset: Number = 250
        // The z-index offset used for the `riseOnHover` feature.
        riseOffset: 250,
        // @option pane: String = 'markerPane'
        // `Map pane` where the markers icon will be added.
        pane: "markerPane",
        // @option shadowPane: String = 'shadowPane'
        // `Map pane` where the markers shadow will be added.
        shadowPane: "shadowPane",
        // @option bubblingMouseEvents: Boolean = false
        // When `true`, a mouse event on this marker will trigger the same event on the map
        // (unless [`L.DomEvent.stopPropagation`](#domevent-stoppropagation) is used).
        bubblingMouseEvents: false,
        // @option autoPanOnFocus: Boolean = true
        // When `true`, the map will pan whenever the marker is focused (via
        // e.g. pressing `tab` on the keyboard) to ensure the marker is
        // visible within the map's bounds
        autoPanOnFocus: true,
        // @section Draggable marker options
        // @option draggable: Boolean = false
        // Whether the marker is draggable with mouse/touch or not.
        draggable: false,
        // @option autoPan: Boolean = false
        // Whether to pan the map when dragging this marker near its edge or not.
        autoPan: false,
        // @option autoPanPadding: Point = Point(50, 50)
        // Distance (in pixels to the left/right and to the top/bottom) of the
        // map edge to start panning the map.
        autoPanPadding: [
            50,
            50
        ],
        // @option autoPanSpeed: Number = 10
        // Number of pixels the map should pan by.
        autoPanSpeed: 10
    },
    /* @section
	 *
	 * In addition to [shared layer methods](#Layer) like `addTo()` and `remove()` and [popup methods](#Popup) like bindPopup() you can also use the following methods:
	 */ initialize: function(latlng, options) {
        $13bbd556cd7cee10$export$add91eafeaeab287(this, options);
        this._latlng = (0, $df6fd3b1bc3e4292$export$a192f247fc7a2057)(latlng);
    },
    onAdd: function(map) {
        this._zoomAnimated = this._zoomAnimated && map.options.markerZoomAnimation;
        if (this._zoomAnimated) map.on("zoomanim", this._animateZoom, this);
        this._initIcon();
        this.update();
    },
    onRemove: function(map) {
        if (this.dragging && this.dragging.enabled()) {
            this.options.draggable = true;
            this.dragging.removeHooks();
        }
        delete this.dragging;
        if (this._zoomAnimated) map.off("zoomanim", this._animateZoom, this);
        this._removeIcon();
        this._removeShadow();
    },
    getEvents: function() {
        return {
            zoom: this.update,
            viewreset: this.update
        };
    },
    // @method getLatLng: LatLng
    // Returns the current geographical position of the marker.
    getLatLng: function() {
        return this._latlng;
    },
    // @method setLatLng(latlng: LatLng): this
    // Changes the marker position to the given point.
    setLatLng: function(latlng) {
        var oldLatLng = this._latlng;
        this._latlng = (0, $df6fd3b1bc3e4292$export$a192f247fc7a2057)(latlng);
        this.update();
        // @event move: Event
        // Fired when the marker is moved via [`setLatLng`](#marker-setlatlng) or by [dragging](#marker-dragging). Old and new coordinates are included in event arguments as `oldLatLng`, `latlng`.
        return this.fire("move", {
            oldLatLng: oldLatLng,
            latlng: this._latlng
        });
    },
    // @method setZIndexOffset(offset: Number): this
    // Changes the [zIndex offset](#marker-zindexoffset) of the marker.
    setZIndexOffset: function(offset) {
        this.options.zIndexOffset = offset;
        return this.update();
    },
    // @method getIcon: Icon
    // Returns the current icon used by the marker
    getIcon: function() {
        return this.options.icon;
    },
    // @method setIcon(icon: Icon): this
    // Changes the marker icon.
    setIcon: function(icon) {
        this.options.icon = icon;
        if (this._map) {
            this._initIcon();
            this.update();
        }
        if (this._popup) this.bindPopup(this._popup, this._popup.options);
        return this;
    },
    getElement: function() {
        return this._icon;
    },
    update: function() {
        if (this._icon && this._map) {
            var pos = this._map.latLngToLayerPoint(this._latlng).round();
            this._setPos(pos);
        }
        return this;
    },
    _initIcon: function() {
        var options = this.options, classToAdd = "leaflet-zoom-" + (this._zoomAnimated ? "animated" : "hide");
        var icon = options.icon.createIcon(this._icon), addIcon = false;
        // if we're not reusing the icon, remove the old one and init new one
        if (icon !== this._icon) {
            if (this._icon) this._removeIcon();
            addIcon = true;
            if (options.title) icon.title = options.title;
            if (icon.tagName === "IMG") icon.alt = options.alt || "";
        }
        $783b7cedd5fd919a$export$d2cf6cd1dc7067d3(icon, classToAdd);
        if (options.keyboard) {
            icon.tabIndex = "0";
            icon.setAttribute("role", "button");
        }
        this._icon = icon;
        if (options.riseOnHover) this.on({
            mouseover: this._bringToFront,
            mouseout: this._resetZIndex
        });
        if (this.options.autoPanOnFocus) $2148974bfeaf2ac1$export$af631764ddc44097(icon, "focus", this._panOnFocus, this);
        var newShadow = options.icon.createShadow(this._shadow), addShadow = false;
        if (newShadow !== this._shadow) {
            this._removeShadow();
            addShadow = true;
        }
        if (newShadow) {
            $783b7cedd5fd919a$export$d2cf6cd1dc7067d3(newShadow, classToAdd);
            newShadow.alt = "";
        }
        this._shadow = newShadow;
        if (options.opacity < 1) this._updateOpacity();
        if (addIcon) this.getPane().appendChild(this._icon);
        this._initInteraction();
        if (newShadow && addShadow) this.getPane(options.shadowPane).appendChild(this._shadow);
    },
    _removeIcon: function() {
        if (this.options.riseOnHover) this.off({
            mouseover: this._bringToFront,
            mouseout: this._resetZIndex
        });
        if (this.options.autoPanOnFocus) $2148974bfeaf2ac1$export$8c8705df4a2dcec9(this._icon, "focus", this._panOnFocus, this);
        $783b7cedd5fd919a$export$cd7f480d6b8286c3(this._icon);
        this.removeInteractiveTarget(this._icon);
        this._icon = null;
    },
    _removeShadow: function() {
        if (this._shadow) $783b7cedd5fd919a$export$cd7f480d6b8286c3(this._shadow);
        this._shadow = null;
    },
    _setPos: function(pos) {
        if (this._icon) $783b7cedd5fd919a$export$f9b088a47202d605(this._icon, pos);
        if (this._shadow) $783b7cedd5fd919a$export$f9b088a47202d605(this._shadow, pos);
        this._zIndex = pos.y + this.options.zIndexOffset;
        this._resetZIndex();
    },
    _updateZIndex: function(offset) {
        if (this._icon) this._icon.style.zIndex = this._zIndex + offset;
    },
    _animateZoom: function(opt) {
        var pos = this._map._latLngToNewLayerPoint(this._latlng, opt.zoom, opt.center).round();
        this._setPos(pos);
    },
    _initInteraction: function() {
        if (!this.options.interactive) return;
        $783b7cedd5fd919a$export$d2cf6cd1dc7067d3(this._icon, "leaflet-interactive");
        this.addInteractiveTarget(this._icon);
        if (0, $cd159b2c408a71d7$export$7f44c3c808f5c9a4) {
            var draggable = this.options.draggable;
            if (this.dragging) {
                draggable = this.dragging.enabled();
                this.dragging.disable();
            }
            this.dragging = new (0, $cd159b2c408a71d7$export$7f44c3c808f5c9a4)(this);
            if (draggable) this.dragging.enable();
        }
    },
    // @method setOpacity(opacity: Number): this
    // Changes the opacity of the marker.
    setOpacity: function(opacity) {
        this.options.opacity = opacity;
        if (this._map) this._updateOpacity();
        return this;
    },
    _updateOpacity: function() {
        var opacity = this.options.opacity;
        if (this._icon) $783b7cedd5fd919a$export$2646c6b151d2e8(this._icon, opacity);
        if (this._shadow) $783b7cedd5fd919a$export$2646c6b151d2e8(this._shadow, opacity);
    },
    _bringToFront: function() {
        this._updateZIndex(this.options.riseOffset);
    },
    _resetZIndex: function() {
        this._updateZIndex(0);
    },
    _panOnFocus: function() {
        var map = this._map;
        if (!map) return;
        var iconOpts = this.options.icon.options;
        var size = iconOpts.iconSize ? (0, $b802e4aa6d666b45$export$b63cca88ddc558a9)(iconOpts.iconSize) : (0, $b802e4aa6d666b45$export$b63cca88ddc558a9)(0, 0);
        var anchor = iconOpts.iconAnchor ? (0, $b802e4aa6d666b45$export$b63cca88ddc558a9)(iconOpts.iconAnchor) : (0, $b802e4aa6d666b45$export$b63cca88ddc558a9)(0, 0);
        map.panInside(this._latlng, {
            paddingTopLeft: anchor,
            paddingBottomRight: size.subtract(anchor)
        });
    },
    _getPopupAnchor: function() {
        return this.options.icon.options.popupAnchor;
    },
    _getTooltipAnchor: function() {
        return this.options.icon.options.tooltipAnchor;
    }
});
function $fda07f58f3165e6f$export$ffc4d0086f1a4c9(latlng, options) {
    return new $fda07f58f3165e6f$export$e98856a975cab58e(latlng, options);
}




var $368acd641f573c2e$export$4b2950bdac9b6ee9 = (0, $3219933a0a8d4dcc$export$936d0764594b6eb3).extend({
    // @section
    // @aka Path options
    options: {
        // @option stroke: Boolean = true
        // Whether to draw stroke along the path. Set it to `false` to disable borders on polygons or circles.
        stroke: true,
        // @option color: String = '#3388ff'
        // Stroke color
        color: "#3388ff",
        // @option weight: Number = 3
        // Stroke width in pixels
        weight: 3,
        // @option opacity: Number = 1.0
        // Stroke opacity
        opacity: 1,
        // @option lineCap: String= 'round'
        // A string that defines [shape to be used at the end](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-linecap) of the stroke.
        lineCap: "round",
        // @option lineJoin: String = 'round'
        // A string that defines [shape to be used at the corners](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-linejoin) of the stroke.
        lineJoin: "round",
        // @option dashArray: String = null
        // A string that defines the stroke [dash pattern](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-dasharray). Doesn't work on `Canvas`-powered layers in [some old browsers](https://developer.mozilla.org/docs/Web/API/CanvasRenderingContext2D/setLineDash#Browser_compatibility).
        dashArray: null,
        // @option dashOffset: String = null
        // A string that defines the [distance into the dash pattern to start the dash](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-dashoffset). Doesn't work on `Canvas`-powered layers in [some old browsers](https://developer.mozilla.org/docs/Web/API/CanvasRenderingContext2D/setLineDash#Browser_compatibility).
        dashOffset: null,
        // @option fill: Boolean = depends
        // Whether to fill the path with color. Set it to `false` to disable filling on polygons or circles.
        fill: false,
        // @option fillColor: String = *
        // Fill color. Defaults to the value of the [`color`](#path-color) option
        fillColor: null,
        // @option fillOpacity: Number = 0.2
        // Fill opacity.
        fillOpacity: 0.2,
        // @option fillRule: String = 'evenodd'
        // A string that defines [how the inside of a shape](https://developer.mozilla.org/docs/Web/SVG/Attribute/fill-rule) is determined.
        fillRule: "evenodd",
        // className: '',
        // Option inherited from "Interactive layer" abstract class
        interactive: true,
        // @option bubblingMouseEvents: Boolean = true
        // When `true`, a mouse event on this path will trigger the same event on the map
        // (unless [`L.DomEvent.stopPropagation`](#domevent-stoppropagation) is used).
        bubblingMouseEvents: true
    },
    beforeAdd: function(map) {
        // Renderer is set here because we need to call renderer.getEvents
        // before this.getEvents.
        this._renderer = map.getRenderer(this);
    },
    onAdd: function() {
        this._renderer._initPath(this);
        this._reset();
        this._renderer._addPath(this);
    },
    onRemove: function() {
        this._renderer._removePath(this);
    },
    // @method redraw(): this
    // Redraws the layer. Sometimes useful after you changed the coordinates that the path uses.
    redraw: function() {
        if (this._map) this._renderer._updatePath(this);
        return this;
    },
    // @method setStyle(style: Path options): this
    // Changes the appearance of a Path based on the options in the `Path options` object.
    setStyle: function(style) {
        $13bbd556cd7cee10$export$add91eafeaeab287(this, style);
        if (this._renderer) {
            this._renderer._updateStyle(this);
            if (this.options.stroke && style && Object.prototype.hasOwnProperty.call(style, "weight")) this._updateBounds();
        }
        return this;
    },
    // @method bringToFront(): this
    // Brings the layer to the top of all path layers.
    bringToFront: function() {
        if (this._renderer) this._renderer._bringToFront(this);
        return this;
    },
    // @method bringToBack(): this
    // Brings the layer to the bottom of all path layers.
    bringToBack: function() {
        if (this._renderer) this._renderer._bringToBack(this);
        return this;
    },
    getElement: function() {
        return this._path;
    },
    _reset: function() {
        // defined in child classes
        this._project();
        this._update();
    },
    _clickTolerance: function() {
        // used when doing hit detection for Canvas layers
        return (this.options.stroke ? this.options.weight / 2 : 0) + (this._renderer.options.tolerance || 0);
    }
});





var $c603c3d53b9c3ea5$export$7bf46a893731b161 = (0, $368acd641f573c2e$export$4b2950bdac9b6ee9).extend({
    // @section
    // @aka CircleMarker options
    options: {
        fill: true,
        // @option radius: Number = 10
        // Radius of the circle marker, in pixels
        radius: 10
    },
    initialize: function(latlng, options) {
        $13bbd556cd7cee10$export$add91eafeaeab287(this, options);
        this._latlng = (0, $df6fd3b1bc3e4292$export$a192f247fc7a2057)(latlng);
        this._radius = this.options.radius;
    },
    // @method setLatLng(latLng: LatLng): this
    // Sets the position of a circle marker to a new location.
    setLatLng: function(latlng) {
        var oldLatLng = this._latlng;
        this._latlng = (0, $df6fd3b1bc3e4292$export$a192f247fc7a2057)(latlng);
        this.redraw();
        // @event move: Event
        // Fired when the marker is moved via [`setLatLng`](#circlemarker-setlatlng). Old and new coordinates are included in event arguments as `oldLatLng`, `latlng`.
        return this.fire("move", {
            oldLatLng: oldLatLng,
            latlng: this._latlng
        });
    },
    // @method getLatLng(): LatLng
    // Returns the current geographical position of the circle marker
    getLatLng: function() {
        return this._latlng;
    },
    // @method setRadius(radius: Number): this
    // Sets the radius of a circle marker. Units are in pixels.
    setRadius: function(radius) {
        this.options.radius = this._radius = radius;
        return this.redraw();
    },
    // @method getRadius(): Number
    // Returns the current radius of the circle
    getRadius: function() {
        return this._radius;
    },
    setStyle: function(options) {
        var radius = options && options.radius || this._radius;
        (0, $368acd641f573c2e$export$4b2950bdac9b6ee9).prototype.setStyle.call(this, options);
        this.setRadius(radius);
        return this;
    },
    _project: function() {
        this._point = this._map.latLngToLayerPoint(this._latlng);
        this._updateBounds();
    },
    _updateBounds: function() {
        var r = this._radius, r2 = this._radiusY || r, w = this._clickTolerance(), p = [
            r + w,
            r2 + w
        ];
        this._pxBounds = new (0, $2ffe56518af276c5$export$c4e9d269599ab4b4)(this._point.subtract(p), this._point.add(p));
    },
    _update: function() {
        if (this._map) this._updatePath();
    },
    _updatePath: function() {
        this._renderer._updateCircle(this);
    },
    _empty: function() {
        return this._radius && !this._renderer._bounds.intersects(this._pxBounds);
    },
    // Needed by the `Canvas` renderer for interactivity
    _containsPoint: function(p) {
        return p.distanceTo(this._point) <= this._radius + this._clickTolerance();
    }
});
function $c603c3d53b9c3ea5$export$d335a174f4e989fb(latlng, options) {
    return new $c603c3d53b9c3ea5$export$7bf46a893731b161(latlng, options);
}







var $8f0b947639211c99$export$c89a927ffc67e6fa = (0, $c603c3d53b9c3ea5$export$7bf46a893731b161).extend({
    initialize: function(latlng, options, legacyOptions) {
        if (typeof options === "number") // Backwards compatibility with 0.7.x factory (latlng, radius, options?)
        options = $13bbd556cd7cee10$export$8b58be045bf06082({}, legacyOptions, {
            radius: options
        });
        $13bbd556cd7cee10$export$add91eafeaeab287(this, options);
        this._latlng = (0, $df6fd3b1bc3e4292$export$a192f247fc7a2057)(latlng);
        if (isNaN(this.options.radius)) throw new Error("Circle radius cannot be NaN");
        // @section
        // @aka Circle options
        // @option radius: Number; Radius of the circle, in meters.
        this._mRadius = this.options.radius;
    },
    // @method setRadius(radius: Number): this
    // Sets the radius of a circle. Units are in meters.
    setRadius: function(radius) {
        this._mRadius = radius;
        return this.redraw();
    },
    // @method getRadius(): Number
    // Returns the current radius of a circle. Units are in meters.
    getRadius: function() {
        return this._mRadius;
    },
    // @method getBounds(): LatLngBounds
    // Returns the `LatLngBounds` of the path.
    getBounds: function() {
        var half = [
            this._radius,
            this._radiusY || this._radius
        ];
        return new (0, $c1a09dde0ebe0161$export$fe84d4076a55a8e6)(this._map.layerPointToLatLng(this._point.subtract(half)), this._map.layerPointToLatLng(this._point.add(half)));
    },
    setStyle: (0, $368acd641f573c2e$export$4b2950bdac9b6ee9).prototype.setStyle,
    _project: function() {
        var lng = this._latlng.lng, lat = this._latlng.lat, map = this._map, crs = map.options.crs;
        if (crs.distance === (0, $22c0063417eeaa98$export$a8d7cb18a6ef9581).distance) {
            var d = Math.PI / 180, latR = this._mRadius / (0, $22c0063417eeaa98$export$a8d7cb18a6ef9581).R / d, top = map.project([
                lat + latR,
                lng
            ]), bottom = map.project([
                lat - latR,
                lng
            ]), p = top.add(bottom).divideBy(2), lat2 = map.unproject(p).lat, lngR = Math.acos((Math.cos(latR * d) - Math.sin(lat * d) * Math.sin(lat2 * d)) / (Math.cos(lat * d) * Math.cos(lat2 * d))) / d;
            if (isNaN(lngR) || lngR === 0) lngR = latR / Math.cos(Math.PI / 180 * lat); // Fallback for edge case, #2425
            this._point = p.subtract(map.getPixelOrigin());
            this._radius = isNaN(lngR) ? 0 : p.x - map.project([
                lat2,
                lng - lngR
            ]).x;
            this._radiusY = p.y - top.y;
        } else {
            var latlng2 = crs.unproject(crs.project(this._latlng).subtract([
                this._mRadius,
                0
            ]));
            this._point = map.latLngToLayerPoint(this._latlng);
            this._radius = this._point.x - map.latLngToLayerPoint(latlng2).x;
        }
        this._updateBounds();
    }
});
function $8f0b947639211c99$export$e1d786d2f707b414(latlng, options, legacyOptions) {
    return new $8f0b947639211c99$export$c89a927ffc67e6fa(latlng, options, legacyOptions);
}










var $3ce4e1b2f80aebad$export$79f3ee03e63e7073 = (0, $368acd641f573c2e$export$4b2950bdac9b6ee9).extend({
    // @section
    // @aka Polyline options
    options: {
        // @option smoothFactor: Number = 1.0
        // How much to simplify the polyline on each zoom level. More means
        // better performance and smoother look, and less means more accurate representation.
        smoothFactor: 1.0,
        // @option noClip: Boolean = false
        // Disable polyline clipping.
        noClip: false
    },
    initialize: function(latlngs, options) {
        $13bbd556cd7cee10$export$add91eafeaeab287(this, options);
        this._setLatLngs(latlngs);
    },
    // @method getLatLngs(): LatLng[]
    // Returns an array of the points in the path, or nested arrays of points in case of multi-polyline.
    getLatLngs: function() {
        return this._latlngs;
    },
    // @method setLatLngs(latlngs: LatLng[]): this
    // Replaces all the points in the polyline with the given array of geographical points.
    setLatLngs: function(latlngs) {
        this._setLatLngs(latlngs);
        return this.redraw();
    },
    // @method isEmpty(): Boolean
    // Returns `true` if the Polyline has no LatLngs.
    isEmpty: function() {
        return !this._latlngs.length;
    },
    // @method closestLayerPoint(p: Point): Point
    // Returns the point closest to `p` on the Polyline.
    closestLayerPoint: function(p) {
        var minDistance = Infinity, minPoint = null, closest = $a1a431c02009e354$export$618e0d6606476a13, p1, p2;
        for(var j = 0, jLen = this._parts.length; j < jLen; j++){
            var points = this._parts[j];
            for(var i = 1, len = points.length; i < len; i++){
                p1 = points[i - 1];
                p2 = points[i];
                var sqDist = closest(p, p1, p2, true);
                if (sqDist < minDistance) {
                    minDistance = sqDist;
                    minPoint = closest(p, p1, p2);
                }
            }
        }
        if (minPoint) minPoint.distance = Math.sqrt(minDistance);
        return minPoint;
    },
    // @method getCenter(): LatLng
    // Returns the center ([centroid](https://en.wikipedia.org/wiki/Centroid)) of the polyline.
    getCenter: function() {
        // throws error when not yet added to map as this center calculation requires projected coordinates
        if (!this._map) throw new Error("Must add layer to map before using getCenter()");
        return $a1a431c02009e354$export$a2a52905e1ae659c(this._defaultShape(), this._map.options.crs);
    },
    // @method getBounds(): LatLngBounds
    // Returns the `LatLngBounds` of the path.
    getBounds: function() {
        return this._bounds;
    },
    // @method addLatLng(latlng: LatLng, latlngs?: LatLng[]): this
    // Adds a given point to the polyline. By default, adds to the first ring of
    // the polyline in case of a multi-polyline, but can be overridden by passing
    // a specific ring as a LatLng array (that you can earlier access with [`getLatLngs`](#polyline-getlatlngs)).
    addLatLng: function(latlng, latlngs) {
        latlngs = latlngs || this._defaultShape();
        latlng = (0, $df6fd3b1bc3e4292$export$a192f247fc7a2057)(latlng);
        latlngs.push(latlng);
        this._bounds.extend(latlng);
        return this.redraw();
    },
    _setLatLngs: function(latlngs) {
        this._bounds = new (0, $c1a09dde0ebe0161$export$fe84d4076a55a8e6)();
        this._latlngs = this._convertLatLngs(latlngs);
    },
    _defaultShape: function() {
        return $a1a431c02009e354$export$5a20f49a17c681a1(this._latlngs) ? this._latlngs : this._latlngs[0];
    },
    // recursively convert latlngs input into actual LatLng instances; calculate bounds along the way
    _convertLatLngs: function(latlngs) {
        var result = [], flat = $a1a431c02009e354$export$5a20f49a17c681a1(latlngs);
        for(var i = 0, len = latlngs.length; i < len; i++)if (flat) {
            result[i] = (0, $df6fd3b1bc3e4292$export$a192f247fc7a2057)(latlngs[i]);
            this._bounds.extend(result[i]);
        } else result[i] = this._convertLatLngs(latlngs[i]);
        return result;
    },
    _project: function() {
        var pxBounds = new (0, $2ffe56518af276c5$export$c4e9d269599ab4b4)();
        this._rings = [];
        this._projectLatlngs(this._latlngs, this._rings, pxBounds);
        if (this._bounds.isValid() && pxBounds.isValid()) {
            this._rawPxBounds = pxBounds;
            this._updateBounds();
        }
    },
    _updateBounds: function() {
        var w = this._clickTolerance(), p = new (0, $b802e4aa6d666b45$export$baf26146a414f24a)(w, w);
        if (!this._rawPxBounds) return;
        this._pxBounds = new (0, $2ffe56518af276c5$export$c4e9d269599ab4b4)([
            this._rawPxBounds.min.subtract(p),
            this._rawPxBounds.max.add(p)
        ]);
    },
    // recursively turns latlngs into a set of rings with projected coordinates
    _projectLatlngs: function(latlngs, result, projectedBounds) {
        var flat = latlngs[0] instanceof (0, $df6fd3b1bc3e4292$export$5fd359ea0b43bded), len = latlngs.length, i, ring;
        if (flat) {
            ring = [];
            for(i = 0; i < len; i++){
                ring[i] = this._map.latLngToLayerPoint(latlngs[i]);
                projectedBounds.extend(ring[i]);
            }
            result.push(ring);
        } else for(i = 0; i < len; i++)this._projectLatlngs(latlngs[i], result, projectedBounds);
    },
    // clip polyline by renderer bounds so that we have less to render for performance
    _clipPoints: function() {
        var bounds = this._renderer._bounds;
        this._parts = [];
        if (!this._pxBounds || !this._pxBounds.intersects(bounds)) return;
        if (this.options.noClip) {
            this._parts = this._rings;
            return;
        }
        var parts = this._parts, i, j, k, len, len2, segment, points;
        for(i = 0, k = 0, len = this._rings.length; i < len; i++){
            points = this._rings[i];
            for(j = 0, len2 = points.length; j < len2 - 1; j++){
                segment = $a1a431c02009e354$export$2ba0cd7011ee887c(points[j], points[j + 1], bounds, j, true);
                if (!segment) continue;
                parts[k] = parts[k] || [];
                parts[k].push(segment[0]);
                // if segment goes out of screen, or it's the last one, it's the end of the line part
                if (segment[1] !== points[j + 1] || j === len2 - 2) {
                    parts[k].push(segment[1]);
                    k++;
                }
            }
        }
    },
    // simplify each clipped part of the polyline for performance
    _simplifyPoints: function() {
        var parts = this._parts, tolerance = this.options.smoothFactor;
        for(var i = 0, len = parts.length; i < len; i++)parts[i] = $a1a431c02009e354$export$798b53621063651(parts[i], tolerance);
    },
    _update: function() {
        if (!this._map) return;
        this._clipPoints();
        this._simplifyPoints();
        this._updatePath();
    },
    _updatePath: function() {
        this._renderer._updatePoly(this);
    },
    // Needed by the `Canvas` renderer for interactivity
    _containsPoint: function(p, closed) {
        var i, j, k, len, len2, part, w = this._clickTolerance();
        if (!this._pxBounds || !this._pxBounds.contains(p)) return false;
        // hit detection for polylines
        for(i = 0, len = this._parts.length; i < len; i++){
            part = this._parts[i];
            for(j = 0, len2 = part.length, k = len2 - 1; j < len2; k = j++){
                if (!closed && j === 0) continue;
                if ($a1a431c02009e354$export$f96afe567099ccbe(p, part[k], part[j]) <= w) return true;
            }
        }
        return false;
    }
});
function $3ce4e1b2f80aebad$export$8d69707c7074d5c0(latlngs, options) {
    return new $3ce4e1b2f80aebad$export$79f3ee03e63e7073(latlngs, options);
}
// Retrocompat. Allow plugins to support Leaflet versions before and after 1.1.
$3ce4e1b2f80aebad$export$79f3ee03e63e7073._flat = $a1a431c02009e354$export$cad69f152e26932d;








var $bdff1e13283290e7$export$7d31b617c820d435 = (0, $3ce4e1b2f80aebad$export$79f3ee03e63e7073).extend({
    options: {
        fill: true
    },
    isEmpty: function() {
        return !this._latlngs.length || !this._latlngs[0].length;
    },
    // @method getCenter(): LatLng
    // Returns the center ([centroid](http://en.wikipedia.org/wiki/Centroid)) of the Polygon.
    getCenter: function() {
        // throws error when not yet added to map as this center calculation requires projected coordinates
        if (!this._map) throw new Error("Must add layer to map before using getCenter()");
        return $9967a26f907fd395$export$ab087439b250a32c(this._defaultShape(), this._map.options.crs);
    },
    _convertLatLngs: function(latlngs) {
        var result = (0, $3ce4e1b2f80aebad$export$79f3ee03e63e7073).prototype._convertLatLngs.call(this, latlngs), len = result.length;
        // remove last point if it equals first one
        if (len >= 2 && result[0] instanceof (0, $df6fd3b1bc3e4292$export$5fd359ea0b43bded) && result[0].equals(result[len - 1])) result.pop();
        return result;
    },
    _setLatLngs: function(latlngs) {
        (0, $3ce4e1b2f80aebad$export$79f3ee03e63e7073).prototype._setLatLngs.call(this, latlngs);
        if ($a1a431c02009e354$export$5a20f49a17c681a1(this._latlngs)) this._latlngs = [
            this._latlngs
        ];
    },
    _defaultShape: function() {
        return $a1a431c02009e354$export$5a20f49a17c681a1(this._latlngs[0]) ? this._latlngs[0] : this._latlngs[0][0];
    },
    _clipPoints: function() {
        // polygons need a different clipping algorithm so we redefine that
        var bounds = this._renderer._bounds, w = this.options.weight, p = new (0, $b802e4aa6d666b45$export$baf26146a414f24a)(w, w);
        // increase clip padding by stroke width to avoid stroke on clip edges
        bounds = new (0, $2ffe56518af276c5$export$c4e9d269599ab4b4)(bounds.min.subtract(p), bounds.max.add(p));
        this._parts = [];
        if (!this._pxBounds || !this._pxBounds.intersects(bounds)) return;
        if (this.options.noClip) {
            this._parts = this._rings;
            return;
        }
        for(var i = 0, len = this._rings.length, clipped; i < len; i++){
            clipped = $9967a26f907fd395$export$cf9573e980d97240(this._rings[i], bounds, true);
            if (clipped.length) this._parts.push(clipped);
        }
    },
    _updatePath: function() {
        this._renderer._updatePoly(this, true);
    },
    // Needed by the `Canvas` renderer for interactivity
    _containsPoint: function(p) {
        var inside = false, part, p1, p2, i, j, k, len, len2;
        if (!this._pxBounds || !this._pxBounds.contains(p)) return false;
        // ray casting algorithm for detecting if point is in polygon
        for(i = 0, len = this._parts.length; i < len; i++){
            part = this._parts[i];
            for(j = 0, len2 = part.length, k = len2 - 1; j < len2; k = j++){
                p1 = part[j];
                p2 = part[k];
                if (p1.y > p.y !== p2.y > p.y && p.x < (p2.x - p1.x) * (p.y - p1.y) / (p2.y - p1.y) + p1.x) inside = !inside;
            }
        }
        // also check if it's on polygon stroke
        return inside || (0, $3ce4e1b2f80aebad$export$79f3ee03e63e7073).prototype._containsPoint.call(this, p, true);
    }
});
function $bdff1e13283290e7$export$b7b19aa0ee06c73(latlngs, options) {
    return new $bdff1e13283290e7$export$7d31b617c820d435(latlngs, options);
}




var $20915971c93a96c6$export$3a16e672cb3a069e = (0, $fe973108fad44854$export$520fbf7f9cbd232d).extend({
    /* @section
	 * @aka GeoJSON options
	 *
	 * @option pointToLayer: Function = *
	 * A `Function` defining how GeoJSON points spawn Leaflet layers. It is internally
	 * called when data is added, passing the GeoJSON point feature and its `LatLng`.
	 * The default is to spawn a default `Marker`:
	 * ```js
	 * function(geoJsonPoint, latlng) {
	 * 	return L.marker(latlng);
	 * }
	 * ```
	 *
	 * @option style: Function = *
	 * A `Function` defining the `Path options` for styling GeoJSON lines and polygons,
	 * called internally when data is added.
	 * The default value is to not override any defaults:
	 * ```js
	 * function (geoJsonFeature) {
	 * 	return {}
	 * }
	 * ```
	 *
	 * @option onEachFeature: Function = *
	 * A `Function` that will be called once for each created `Feature`, after it has
	 * been created and styled. Useful for attaching events and popups to features.
	 * The default is to do nothing with the newly created layers:
	 * ```js
	 * function (feature, layer) {}
	 * ```
	 *
	 * @option filter: Function = *
	 * A `Function` that will be used to decide whether to include a feature or not.
	 * The default is to include all features:
	 * ```js
	 * function (geoJsonFeature) {
	 * 	return true;
	 * }
	 * ```
	 * Note: dynamically changing the `filter` option will have effect only on newly
	 * added data. It will _not_ re-evaluate already included features.
	 *
	 * @option coordsToLatLng: Function = *
	 * A `Function` that will be used for converting GeoJSON coordinates to `LatLng`s.
	 * The default is the `coordsToLatLng` static method.
	 *
	 * @option markersInheritOptions: Boolean = false
	 * Whether default Markers for "Point" type Features inherit from group options.
	 */ initialize: function(geojson, options) {
        $13bbd556cd7cee10$export$add91eafeaeab287(this, options);
        this._layers = {};
        if (geojson) this.addData(geojson);
    },
    // @method addData( <GeoJSON> data ): this
    // Adds a GeoJSON object to the layer.
    addData: function(geojson) {
        var features = $13bbd556cd7cee10$export$43bee75e5e14138e(geojson) ? geojson : geojson.features, i, len, feature;
        if (features) {
            for(i = 0, len = features.length; i < len; i++){
                // only add this if geometry or geometries are set and not null
                feature = features[i];
                if (feature.geometries || feature.geometry || feature.features || feature.coordinates) this.addData(feature);
            }
            return this;
        }
        var options = this.options;
        if (options.filter && !options.filter(geojson)) return this;
        var layer = $20915971c93a96c6$export$1d62dde364ca646a(geojson, options);
        if (!layer) return this;
        layer.feature = $20915971c93a96c6$export$9b5abe57af2a50eb(geojson);
        layer.defaultOptions = layer.options;
        this.resetStyle(layer);
        if (options.onEachFeature) options.onEachFeature(geojson, layer);
        return this.addLayer(layer);
    },
    // @method resetStyle( <Path> layer? ): this
    // Resets the given vector layer's style to the original GeoJSON style, useful for resetting style after hover events.
    // If `layer` is omitted, the style of all features in the current layer is reset.
    resetStyle: function(layer) {
        if (layer === undefined) return this.eachLayer(this.resetStyle, this);
        // reset any custom styles
        layer.options = $13bbd556cd7cee10$export$8b58be045bf06082({}, layer.defaultOptions);
        this._setLayerStyle(layer, this.options.style);
        return this;
    },
    // @method setStyle( <Function> style ): this
    // Changes styles of GeoJSON vector layers with the given style function.
    setStyle: function(style) {
        return this.eachLayer(function(layer) {
            this._setLayerStyle(layer, style);
        }, this);
    },
    _setLayerStyle: function(layer, style) {
        if (layer.setStyle) {
            if (typeof style === "function") style = style(layer.feature);
            layer.setStyle(style);
        }
    }
});
function $20915971c93a96c6$export$1d62dde364ca646a(geojson, options) {
    var geometry = geojson.type === "Feature" ? geojson.geometry : geojson, coords = geometry ? geometry.coordinates : null, layers = [], pointToLayer = options && options.pointToLayer, _coordsToLatLng = options && options.coordsToLatLng || $20915971c93a96c6$export$68c7da933fd21adc, latlng, latlngs, i, len;
    if (!coords && !geometry) return null;
    switch(geometry.type){
        case "Point":
            latlng = _coordsToLatLng(coords);
            return $20915971c93a96c6$var$_pointToLayer(pointToLayer, geojson, latlng, options);
        case "MultiPoint":
            for(i = 0, len = coords.length; i < len; i++){
                latlng = _coordsToLatLng(coords[i]);
                layers.push($20915971c93a96c6$var$_pointToLayer(pointToLayer, geojson, latlng, options));
            }
            return new (0, $fe973108fad44854$export$520fbf7f9cbd232d)(layers);
        case "LineString":
        case "MultiLineString":
            latlngs = $20915971c93a96c6$export$95b72bfd8b68a8bf(coords, geometry.type === "LineString" ? 0 : 1, _coordsToLatLng);
            return new (0, $3ce4e1b2f80aebad$export$79f3ee03e63e7073)(latlngs, options);
        case "Polygon":
        case "MultiPolygon":
            latlngs = $20915971c93a96c6$export$95b72bfd8b68a8bf(coords, geometry.type === "Polygon" ? 1 : 2, _coordsToLatLng);
            return new (0, $bdff1e13283290e7$export$7d31b617c820d435)(latlngs, options);
        case "GeometryCollection":
            for(i = 0, len = geometry.geometries.length; i < len; i++){
                var geoLayer = $20915971c93a96c6$export$1d62dde364ca646a({
                    geometry: geometry.geometries[i],
                    type: "Feature",
                    properties: geojson.properties
                }, options);
                if (geoLayer) layers.push(geoLayer);
            }
            return new (0, $fe973108fad44854$export$520fbf7f9cbd232d)(layers);
        case "FeatureCollection":
            for(i = 0, len = geometry.features.length; i < len; i++){
                var featureLayer = $20915971c93a96c6$export$1d62dde364ca646a(geometry.features[i], options);
                if (featureLayer) layers.push(featureLayer);
            }
            return new (0, $fe973108fad44854$export$520fbf7f9cbd232d)(layers);
        default:
            throw new Error("Invalid GeoJSON object.");
    }
}
function $20915971c93a96c6$var$_pointToLayer(pointToLayerFn, geojson, latlng, options) {
    return pointToLayerFn ? pointToLayerFn(geojson, latlng) : new (0, $fda07f58f3165e6f$export$e98856a975cab58e)(latlng, options && options.markersInheritOptions && options);
}
function $20915971c93a96c6$export$68c7da933fd21adc(coords) {
    return new (0, $df6fd3b1bc3e4292$export$5fd359ea0b43bded)(coords[1], coords[0], coords[2]);
}
function $20915971c93a96c6$export$95b72bfd8b68a8bf(coords, levelsDeep, _coordsToLatLng) {
    var latlngs = [];
    for(var i = 0, len = coords.length, latlng; i < len; i++){
        latlng = levelsDeep ? $20915971c93a96c6$export$95b72bfd8b68a8bf(coords[i], levelsDeep - 1, _coordsToLatLng) : (_coordsToLatLng || $20915971c93a96c6$export$68c7da933fd21adc)(coords[i]);
        latlngs.push(latlng);
    }
    return latlngs;
}
function $20915971c93a96c6$export$4a4f4d0b257f82d2(latlng, precision) {
    latlng = (0, $df6fd3b1bc3e4292$export$a192f247fc7a2057)(latlng);
    return latlng.alt !== undefined ? [
        $13bbd556cd7cee10$export$533e61f4ff7f35ce(latlng.lng, precision),
        $13bbd556cd7cee10$export$533e61f4ff7f35ce(latlng.lat, precision),
        $13bbd556cd7cee10$export$533e61f4ff7f35ce(latlng.alt, precision)
    ] : [
        $13bbd556cd7cee10$export$533e61f4ff7f35ce(latlng.lng, precision),
        $13bbd556cd7cee10$export$533e61f4ff7f35ce(latlng.lat, precision)
    ];
}
function $20915971c93a96c6$export$77b6e764d6612623(latlngs, levelsDeep, closed, precision) {
    var coords = [];
    for(var i = 0, len = latlngs.length; i < len; i++)// Check for flat arrays required to ensure unbalanced arrays are correctly converted in recursion
    coords.push(levelsDeep ? $20915971c93a96c6$export$77b6e764d6612623(latlngs[i], $a1a431c02009e354$export$5a20f49a17c681a1(latlngs[i]) ? 0 : levelsDeep - 1, closed, precision) : $20915971c93a96c6$export$4a4f4d0b257f82d2(latlngs[i], precision));
    if (!levelsDeep && closed && coords.length > 0) coords.push(coords[0].slice());
    return coords;
}
function $20915971c93a96c6$export$bba2e7bbd72e62e1(layer, newGeometry) {
    return layer.feature ? $13bbd556cd7cee10$export$8b58be045bf06082({}, layer.feature, {
        geometry: newGeometry
    }) : $20915971c93a96c6$export$9b5abe57af2a50eb(newGeometry);
}
function $20915971c93a96c6$export$9b5abe57af2a50eb(geojson) {
    if (geojson.type === "Feature" || geojson.type === "FeatureCollection") return geojson;
    return {
        type: "Feature",
        properties: {},
        geometry: geojson
    };
}
var $20915971c93a96c6$var$PointToGeoJSON = {
    toGeoJSON: function(precision) {
        return $20915971c93a96c6$export$bba2e7bbd72e62e1(this, {
            type: "Point",
            coordinates: $20915971c93a96c6$export$4a4f4d0b257f82d2(this.getLatLng(), precision)
        });
    }
};
// @namespace Marker
// @section Other methods
// @method toGeoJSON(precision?: Number|false): Object
// Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
// Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the marker (as a GeoJSON `Point` Feature).
(0, $fda07f58f3165e6f$export$e98856a975cab58e).include($20915971c93a96c6$var$PointToGeoJSON);
// @namespace CircleMarker
// @method toGeoJSON(precision?: Number|false): Object
// Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
// Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the circle marker (as a GeoJSON `Point` Feature).
(0, $8f0b947639211c99$export$c89a927ffc67e6fa).include($20915971c93a96c6$var$PointToGeoJSON);
(0, $c603c3d53b9c3ea5$export$7bf46a893731b161).include($20915971c93a96c6$var$PointToGeoJSON);
// @namespace Polyline
// @method toGeoJSON(precision?: Number|false): Object
// Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
// Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the polyline (as a GeoJSON `LineString` or `MultiLineString` Feature).
(0, $3ce4e1b2f80aebad$export$79f3ee03e63e7073).include({
    toGeoJSON: function(precision) {
        var multi = !$a1a431c02009e354$export$5a20f49a17c681a1(this._latlngs);
        var coords = $20915971c93a96c6$export$77b6e764d6612623(this._latlngs, multi ? 1 : 0, false, precision);
        return $20915971c93a96c6$export$bba2e7bbd72e62e1(this, {
            type: (multi ? "Multi" : "") + "LineString",
            coordinates: coords
        });
    }
});
// @namespace Polygon
// @method toGeoJSON(precision?: Number|false): Object
// Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
// Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the polygon (as a GeoJSON `Polygon` or `MultiPolygon` Feature).
(0, $bdff1e13283290e7$export$7d31b617c820d435).include({
    toGeoJSON: function(precision) {
        var holes = !$a1a431c02009e354$export$5a20f49a17c681a1(this._latlngs), multi = holes && !$a1a431c02009e354$export$5a20f49a17c681a1(this._latlngs[0]);
        var coords = $20915971c93a96c6$export$77b6e764d6612623(this._latlngs, multi ? 2 : holes ? 1 : 0, true, precision);
        if (!holes) coords = [
            coords
        ];
        return $20915971c93a96c6$export$bba2e7bbd72e62e1(this, {
            type: (multi ? "Multi" : "") + "Polygon",
            coordinates: coords
        });
    }
});
// @namespace LayerGroup
(0, $3ce1fd68e2426278$export$829212b9319961ea).include({
    toMultiPoint: function(precision) {
        var coords = [];
        this.eachLayer(function(layer) {
            coords.push(layer.toGeoJSON(precision).geometry.coordinates);
        });
        return $20915971c93a96c6$export$bba2e7bbd72e62e1(this, {
            type: "MultiPoint",
            coordinates: coords
        });
    },
    // @method toGeoJSON(precision?: Number|false): Object
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
    // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the layer group (as a GeoJSON `FeatureCollection`, `GeometryCollection`, or `MultiPoint`).
    toGeoJSON: function(precision) {
        var type = this.feature && this.feature.geometry && this.feature.geometry.type;
        if (type === "MultiPoint") return this.toMultiPoint(precision);
        var isGeometryCollection = type === "GeometryCollection", jsons = [];
        this.eachLayer(function(layer) {
            if (layer.toGeoJSON) {
                var json = layer.toGeoJSON(precision);
                if (isGeometryCollection) jsons.push(json.geometry);
                else {
                    var feature = $20915971c93a96c6$export$9b5abe57af2a50eb(json);
                    // Squash nested feature collections
                    if (feature.type === "FeatureCollection") jsons.push.apply(jsons, feature.features);
                    else jsons.push(feature);
                }
            }
        });
        if (isGeometryCollection) return $20915971c93a96c6$export$bba2e7bbd72e62e1(this, {
            geometries: jsons,
            type: "GeometryCollection"
        });
        return {
            type: "FeatureCollection",
            features: jsons
        };
    }
});
function $20915971c93a96c6$export$604402e11a6b4b56(geojson, options) {
    return new $20915971c93a96c6$export$3a16e672cb3a069e(geojson, options);
}
var $20915971c93a96c6$export$1c99306f6e0eb8a = $20915971c93a96c6$export$604402e11a6b4b56;







var $46bce056a5f1f2c2$export$4e7a29849e6c05f6 = (0, $3219933a0a8d4dcc$export$936d0764594b6eb3).extend({
    // @section
    // @aka ImageOverlay options
    options: {
        // @option opacity: Number = 1.0
        // The opacity of the image overlay.
        opacity: 1,
        // @option alt: String = ''
        // Text for the `alt` attribute of the image (useful for accessibility).
        alt: "",
        // @option interactive: Boolean = false
        // If `true`, the image overlay will emit [mouse events](#interactive-layer) when clicked or hovered.
        interactive: false,
        // @option crossOrigin: Boolean|String = false
        // Whether the crossOrigin attribute will be added to the image.
        // If a String is provided, the image will have its crossOrigin attribute set to the String provided. This is needed if you want to access image pixel data.
        // Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
        crossOrigin: false,
        // @option errorOverlayUrl: String = ''
        // URL to the overlay image to show in place of the overlay that failed to load.
        errorOverlayUrl: "",
        // @option zIndex: Number = 1
        // The explicit [zIndex](https://developer.mozilla.org/docs/Web/CSS/CSS_Positioning/Understanding_z_index) of the overlay layer.
        zIndex: 1,
        // @option className: String = ''
        // A custom class name to assign to the image. Empty by default.
        className: ""
    },
    initialize: function(url, bounds, options) {
        this._url = url;
        this._bounds = (0, $c1a09dde0ebe0161$export$4904432a68b0399)(bounds);
        $13bbd556cd7cee10$export$add91eafeaeab287(this, options);
    },
    onAdd: function() {
        if (!this._image) {
            this._initImage();
            if (this.options.opacity < 1) this._updateOpacity();
        }
        if (this.options.interactive) {
            $783b7cedd5fd919a$export$d2cf6cd1dc7067d3(this._image, "leaflet-interactive");
            this.addInteractiveTarget(this._image);
        }
        this.getPane().appendChild(this._image);
        this._reset();
    },
    onRemove: function() {
        $783b7cedd5fd919a$export$cd7f480d6b8286c3(this._image);
        if (this.options.interactive) this.removeInteractiveTarget(this._image);
    },
    // @method setOpacity(opacity: Number): this
    // Sets the opacity of the overlay.
    setOpacity: function(opacity) {
        this.options.opacity = opacity;
        if (this._image) this._updateOpacity();
        return this;
    },
    setStyle: function(styleOpts) {
        if (styleOpts.opacity) this.setOpacity(styleOpts.opacity);
        return this;
    },
    // @method bringToFront(): this
    // Brings the layer to the top of all overlays.
    bringToFront: function() {
        if (this._map) $783b7cedd5fd919a$export$967ea9e64a77dad2(this._image);
        return this;
    },
    // @method bringToBack(): this
    // Brings the layer to the bottom of all overlays.
    bringToBack: function() {
        if (this._map) $783b7cedd5fd919a$export$4d34781508fd70d9(this._image);
        return this;
    },
    // @method setUrl(url: String): this
    // Changes the URL of the image.
    setUrl: function(url) {
        this._url = url;
        if (this._image) this._image.src = url;
        return this;
    },
    // @method setBounds(bounds: LatLngBounds): this
    // Update the bounds that this ImageOverlay covers
    setBounds: function(bounds) {
        this._bounds = (0, $c1a09dde0ebe0161$export$4904432a68b0399)(bounds);
        if (this._map) this._reset();
        return this;
    },
    getEvents: function() {
        var events = {
            zoom: this._reset,
            viewreset: this._reset
        };
        if (this._zoomAnimated) events.zoomanim = this._animateZoom;
        return events;
    },
    // @method setZIndex(value: Number): this
    // Changes the [zIndex](#imageoverlay-zindex) of the image overlay.
    setZIndex: function(value) {
        this.options.zIndex = value;
        this._updateZIndex();
        return this;
    },
    // @method getBounds(): LatLngBounds
    // Get the bounds that this ImageOverlay covers
    getBounds: function() {
        return this._bounds;
    },
    // @method getElement(): HTMLElement
    // Returns the instance of [`HTMLImageElement`](https://developer.mozilla.org/docs/Web/API/HTMLImageElement)
    // used by this overlay.
    getElement: function() {
        return this._image;
    },
    _initImage: function() {
        var wasElementSupplied = this._url.tagName === "IMG";
        var img = this._image = wasElementSupplied ? this._url : $783b7cedd5fd919a$export$185802fd694ee1f5("img");
        $783b7cedd5fd919a$export$d2cf6cd1dc7067d3(img, "leaflet-image-layer");
        if (this._zoomAnimated) $783b7cedd5fd919a$export$d2cf6cd1dc7067d3(img, "leaflet-zoom-animated");
        if (this.options.className) $783b7cedd5fd919a$export$d2cf6cd1dc7067d3(img, this.options.className);
        img.onselectstart = $13bbd556cd7cee10$export$a3891e81a74c5e40;
        img.onmousemove = $13bbd556cd7cee10$export$a3891e81a74c5e40;
        // @event load: Event
        // Fired when the ImageOverlay layer has loaded its image
        img.onload = $13bbd556cd7cee10$export$2385a24977818dd0(this.fire, this, "load");
        img.onerror = $13bbd556cd7cee10$export$2385a24977818dd0(this._overlayOnError, this, "error");
        if (this.options.crossOrigin || this.options.crossOrigin === "") img.crossOrigin = this.options.crossOrigin === true ? "" : this.options.crossOrigin;
        if (this.options.zIndex) this._updateZIndex();
        if (wasElementSupplied) {
            this._url = img.src;
            return;
        }
        img.src = this._url;
        img.alt = this.options.alt;
    },
    _animateZoom: function(e) {
        var scale = this._map.getZoomScale(e.zoom), offset = this._map._latLngBoundsToNewLayerBounds(this._bounds, e.zoom, e.center).min;
        $783b7cedd5fd919a$export$ff09356c35bee89b(this._image, offset, scale);
    },
    _reset: function() {
        var image = this._image, bounds = new (0, $2ffe56518af276c5$export$c4e9d269599ab4b4)(this._map.latLngToLayerPoint(this._bounds.getNorthWest()), this._map.latLngToLayerPoint(this._bounds.getSouthEast())), size = bounds.getSize();
        $783b7cedd5fd919a$export$f9b088a47202d605(image, bounds.min);
        image.style.width = size.x + "px";
        image.style.height = size.y + "px";
    },
    _updateOpacity: function() {
        $783b7cedd5fd919a$export$2646c6b151d2e8(this._image, this.options.opacity);
    },
    _updateZIndex: function() {
        if (this._image && this.options.zIndex !== undefined && this.options.zIndex !== null) this._image.style.zIndex = this.options.zIndex;
    },
    _overlayOnError: function() {
        // @event error: Event
        // Fired when the ImageOverlay layer fails to load its image
        this.fire("error");
        var errorUrl = this.options.errorOverlayUrl;
        if (errorUrl && this._url !== errorUrl) {
            this._url = errorUrl;
            this._image.src = errorUrl;
        }
    },
    // @method getCenter(): LatLng
    // Returns the center of the ImageOverlay.
    getCenter: function() {
        return this._bounds.getCenter();
    }
});
var $46bce056a5f1f2c2$export$fc122a52569c1acc = function(url, bounds, options) {
    return new $46bce056a5f1f2c2$export$4e7a29849e6c05f6(url, bounds, options);
};





var $ae2f68e7751662e3$export$ea43284be2732fd6 = (0, $46bce056a5f1f2c2$export$4e7a29849e6c05f6).extend({
    // @section
    // @aka VideoOverlay options
    options: {
        // @option autoplay: Boolean = true
        // Whether the video starts playing automatically when loaded.
        // On some browsers autoplay will only work with `muted: true`
        autoplay: true,
        // @option loop: Boolean = true
        // Whether the video will loop back to the beginning when played.
        loop: true,
        // @option keepAspectRatio: Boolean = true
        // Whether the video will save aspect ratio after the projection.
        // Relevant for supported browsers. See [browser compatibility](https://developer.mozilla.org/en-US/docs/Web/CSS/object-fit)
        keepAspectRatio: true,
        // @option muted: Boolean = false
        // Whether the video starts on mute when loaded.
        muted: false,
        // @option playsInline: Boolean = true
        // Mobile browsers will play the video right where it is instead of open it up in fullscreen mode.
        playsInline: true
    },
    _initImage: function() {
        var wasElementSupplied = this._url.tagName === "VIDEO";
        var vid = this._image = wasElementSupplied ? this._url : $783b7cedd5fd919a$export$185802fd694ee1f5("video");
        $783b7cedd5fd919a$export$d2cf6cd1dc7067d3(vid, "leaflet-image-layer");
        if (this._zoomAnimated) $783b7cedd5fd919a$export$d2cf6cd1dc7067d3(vid, "leaflet-zoom-animated");
        if (this.options.className) $783b7cedd5fd919a$export$d2cf6cd1dc7067d3(vid, this.options.className);
        vid.onselectstart = $13bbd556cd7cee10$export$a3891e81a74c5e40;
        vid.onmousemove = $13bbd556cd7cee10$export$a3891e81a74c5e40;
        // @event load: Event
        // Fired when the video has finished loading the first frame
        vid.onloadeddata = $13bbd556cd7cee10$export$2385a24977818dd0(this.fire, this, "load");
        if (wasElementSupplied) {
            var sourceElements = vid.getElementsByTagName("source");
            var sources = [];
            for(var j = 0; j < sourceElements.length; j++)sources.push(sourceElements[j].src);
            this._url = sourceElements.length > 0 ? sources : [
                vid.src
            ];
            return;
        }
        if (!$13bbd556cd7cee10$export$43bee75e5e14138e(this._url)) this._url = [
            this._url
        ];
        if (!this.options.keepAspectRatio && Object.prototype.hasOwnProperty.call(vid.style, "objectFit")) vid.style["objectFit"] = "fill";
        vid.autoplay = !!this.options.autoplay;
        vid.loop = !!this.options.loop;
        vid.muted = !!this.options.muted;
        vid.playsInline = !!this.options.playsInline;
        for(var i = 0; i < this._url.length; i++){
            var source = $783b7cedd5fd919a$export$185802fd694ee1f5("source");
            source.src = this._url[i];
            vid.appendChild(source);
        }
    }
});
function $ae2f68e7751662e3$export$2d1a6f5a86a25927(video, bounds, options) {
    return new $ae2f68e7751662e3$export$ea43284be2732fd6(video, bounds, options);
}





var $313e6f52a6a4dfa7$export$515991047e5232e6 = (0, $46bce056a5f1f2c2$export$4e7a29849e6c05f6).extend({
    _initImage: function() {
        var el = this._image = this._url;
        $783b7cedd5fd919a$export$d2cf6cd1dc7067d3(el, "leaflet-image-layer");
        if (this._zoomAnimated) $783b7cedd5fd919a$export$d2cf6cd1dc7067d3(el, "leaflet-zoom-animated");
        if (this.options.className) $783b7cedd5fd919a$export$d2cf6cd1dc7067d3(el, this.options.className);
        el.onselectstart = $13bbd556cd7cee10$export$a3891e81a74c5e40;
        el.onmousemove = $13bbd556cd7cee10$export$a3891e81a74c5e40;
    }
});
function $313e6f52a6a4dfa7$export$90d67fcde5ffe8ca(el, bounds, options) {
    return new $313e6f52a6a4dfa7$export$515991047e5232e6(el, bounds, options);
}









var $98d1ab62737ca23d$export$16862402e2cc620a = (0, $3219933a0a8d4dcc$export$936d0764594b6eb3).extend({
    // @section
    // @aka DivOverlay options
    options: {
        // @option interactive: Boolean = false
        // If true, the popup/tooltip will listen to the mouse events.
        interactive: false,
        // @option offset: Point = Point(0, 0)
        // The offset of the overlay position.
        offset: [
            0,
            0
        ],
        // @option className: String = ''
        // A custom CSS class name to assign to the overlay.
        className: "",
        // @option pane: String = undefined
        // `Map pane` where the overlay will be added.
        pane: undefined,
        // @option content: String|HTMLElement|Function = ''
        // Sets the HTML content of the overlay while initializing. If a function is passed the source layer will be
        // passed to the function. The function should return a `String` or `HTMLElement` to be used in the overlay.
        content: ""
    },
    initialize: function(options, source) {
        if (options && (options instanceof (0, $df6fd3b1bc3e4292$export$5fd359ea0b43bded) || $13bbd556cd7cee10$export$43bee75e5e14138e(options))) {
            this._latlng = (0, $df6fd3b1bc3e4292$export$a192f247fc7a2057)(options);
            $13bbd556cd7cee10$export$add91eafeaeab287(this, source);
        } else {
            $13bbd556cd7cee10$export$add91eafeaeab287(this, options);
            this._source = source;
        }
        if (this.options.content) this._content = this.options.content;
    },
    // @method openOn(map: Map): this
    // Adds the overlay to the map.
    // Alternative to `map.openPopup(popup)`/`.openTooltip(tooltip)`.
    openOn: function(map) {
        map = arguments.length ? map : this._source._map; // experimental, not the part of public api
        if (!map.hasLayer(this)) map.addLayer(this);
        return this;
    },
    // @method close(): this
    // Closes the overlay.
    // Alternative to `map.closePopup(popup)`/`.closeTooltip(tooltip)`
    // and `layer.closePopup()`/`.closeTooltip()`.
    close: function() {
        if (this._map) this._map.removeLayer(this);
        return this;
    },
    // @method toggle(layer?: Layer): this
    // Opens or closes the overlay bound to layer depending on its current state.
    // Argument may be omitted only for overlay bound to layer.
    // Alternative to `layer.togglePopup()`/`.toggleTooltip()`.
    toggle: function(layer) {
        if (this._map) this.close();
        else {
            if (arguments.length) this._source = layer;
            else layer = this._source;
            this._prepareOpen();
            // open the overlay on the map
            this.openOn(layer._map);
        }
        return this;
    },
    onAdd: function(map) {
        this._zoomAnimated = map._zoomAnimated;
        if (!this._container) this._initLayout();
        if (map._fadeAnimated) $783b7cedd5fd919a$export$2646c6b151d2e8(this._container, 0);
        clearTimeout(this._removeTimeout);
        this.getPane().appendChild(this._container);
        this.update();
        if (map._fadeAnimated) $783b7cedd5fd919a$export$2646c6b151d2e8(this._container, 1);
        this.bringToFront();
        if (this.options.interactive) {
            $783b7cedd5fd919a$export$d2cf6cd1dc7067d3(this._container, "leaflet-interactive");
            this.addInteractiveTarget(this._container);
        }
    },
    onRemove: function(map) {
        if (map._fadeAnimated) {
            $783b7cedd5fd919a$export$2646c6b151d2e8(this._container, 0);
            this._removeTimeout = setTimeout($13bbd556cd7cee10$export$2385a24977818dd0($783b7cedd5fd919a$export$cd7f480d6b8286c3, undefined, this._container), 200);
        } else $783b7cedd5fd919a$export$cd7f480d6b8286c3(this._container);
        if (this.options.interactive) {
            $783b7cedd5fd919a$export$c2255604a80b4506(this._container, "leaflet-interactive");
            this.removeInteractiveTarget(this._container);
        }
    },
    // @namespace DivOverlay
    // @method getLatLng: LatLng
    // Returns the geographical point of the overlay.
    getLatLng: function() {
        return this._latlng;
    },
    // @method setLatLng(latlng: LatLng): this
    // Sets the geographical point where the overlay will open.
    setLatLng: function(latlng) {
        this._latlng = (0, $df6fd3b1bc3e4292$export$a192f247fc7a2057)(latlng);
        if (this._map) {
            this._updatePosition();
            this._adjustPan();
        }
        return this;
    },
    // @method getContent: String|HTMLElement
    // Returns the content of the overlay.
    getContent: function() {
        return this._content;
    },
    // @method setContent(htmlContent: String|HTMLElement|Function): this
    // Sets the HTML content of the overlay. If a function is passed the source layer will be passed to the function.
    // The function should return a `String` or `HTMLElement` to be used in the overlay.
    setContent: function(content) {
        this._content = content;
        this.update();
        return this;
    },
    // @method getElement: String|HTMLElement
    // Returns the HTML container of the overlay.
    getElement: function() {
        return this._container;
    },
    // @method update: null
    // Updates the overlay content, layout and position. Useful for updating the overlay after something inside changed, e.g. image loaded.
    update: function() {
        if (!this._map) return;
        this._container.style.visibility = "hidden";
        this._updateContent();
        this._updateLayout();
        this._updatePosition();
        this._container.style.visibility = "";
        this._adjustPan();
    },
    getEvents: function() {
        var events = {
            zoom: this._updatePosition,
            viewreset: this._updatePosition
        };
        if (this._zoomAnimated) events.zoomanim = this._animateZoom;
        return events;
    },
    // @method isOpen: Boolean
    // Returns `true` when the overlay is visible on the map.
    isOpen: function() {
        return !!this._map && this._map.hasLayer(this);
    },
    // @method bringToFront: this
    // Brings this overlay in front of other overlays (in the same map pane).
    bringToFront: function() {
        if (this._map) $783b7cedd5fd919a$export$967ea9e64a77dad2(this._container);
        return this;
    },
    // @method bringToBack: this
    // Brings this overlay to the back of other overlays (in the same map pane).
    bringToBack: function() {
        if (this._map) $783b7cedd5fd919a$export$4d34781508fd70d9(this._container);
        return this;
    },
    // prepare bound overlay to open: update latlng pos / content source (for FeatureGroup)
    _prepareOpen: function(latlng) {
        var source = this._source;
        if (!source._map) return false;
        if (source instanceof (0, $fe973108fad44854$export$520fbf7f9cbd232d)) {
            source = null;
            var layers = this._source._layers;
            for(var id in layers)if (layers[id]._map) {
                source = layers[id];
                break;
            }
            if (!source) return false;
             // Unable to get source layer.
            // set overlay source to this layer
            this._source = source;
        }
        if (!latlng) {
            if (source.getCenter) latlng = source.getCenter();
            else if (source.getLatLng) latlng = source.getLatLng();
            else if (source.getBounds) latlng = source.getBounds().getCenter();
            else throw new Error("Unable to get source layer LatLng.");
        }
        this.setLatLng(latlng);
        if (this._map) // update the overlay (content, layout, etc...)
        this.update();
        return true;
    },
    _updateContent: function() {
        if (!this._content) return;
        var node = this._contentNode;
        var content = typeof this._content === "function" ? this._content(this._source || this) : this._content;
        if (typeof content === "string") node.innerHTML = content;
        else {
            while(node.hasChildNodes())node.removeChild(node.firstChild);
            node.appendChild(content);
        }
        // @namespace DivOverlay
        // @section DivOverlay events
        // @event contentupdate: Event
        // Fired when the content of the overlay is updated
        this.fire("contentupdate");
    },
    _updatePosition: function() {
        if (!this._map) return;
        var pos = this._map.latLngToLayerPoint(this._latlng), offset = (0, $b802e4aa6d666b45$export$b63cca88ddc558a9)(this.options.offset), anchor = this._getAnchor();
        if (this._zoomAnimated) $783b7cedd5fd919a$export$f9b088a47202d605(this._container, pos.add(anchor));
        else offset = offset.add(pos).add(anchor);
        var bottom = this._containerBottom = -offset.y, left = this._containerLeft = -Math.round(this._containerWidth / 2) + offset.x;
        // bottom position the overlay in case the height of the overlay changes (images loading etc)
        this._container.style.bottom = bottom + "px";
        this._container.style.left = left + "px";
    },
    _getAnchor: function() {
        return [
            0,
            0
        ];
    }
});
(0, $7d9a54c6488daf4f$export$a5c7b93649eaf8f8).include({
    _initOverlay: function(OverlayClass, content, latlng, options) {
        var overlay = content;
        if (!(overlay instanceof OverlayClass)) overlay = new OverlayClass(options).setContent(content);
        if (latlng) overlay.setLatLng(latlng);
        return overlay;
    }
});
(0, $3219933a0a8d4dcc$export$936d0764594b6eb3).include({
    _initOverlay: function(OverlayClass, old, content, options) {
        var overlay = content;
        if (overlay instanceof OverlayClass) {
            $13bbd556cd7cee10$export$add91eafeaeab287(overlay, options);
            overlay._source = this;
        } else {
            overlay = old && !options ? old : new OverlayClass(options, this);
            overlay.setContent(content);
        }
        return overlay;
    }
});










var $c46100516ceeb540$export$129a32eedafa97c5 = (0, $98d1ab62737ca23d$export$16862402e2cc620a).extend({
    // @section
    // @aka Popup options
    options: {
        // @option pane: String = 'popupPane'
        // `Map pane` where the popup will be added.
        pane: "popupPane",
        // @option offset: Point = Point(0, 7)
        // The offset of the popup position.
        offset: [
            0,
            7
        ],
        // @option maxWidth: Number = 300
        // Max width of the popup, in pixels.
        maxWidth: 300,
        // @option minWidth: Number = 50
        // Min width of the popup, in pixels.
        minWidth: 50,
        // @option maxHeight: Number = null
        // If set, creates a scrollable container of the given height
        // inside a popup if its content exceeds it.
        // The scrollable container can be styled using the
        // `leaflet-popup-scrolled` CSS class selector.
        maxHeight: null,
        // @option autoPan: Boolean = true
        // Set it to `false` if you don't want the map to do panning animation
        // to fit the opened popup.
        autoPan: true,
        // @option autoPanPaddingTopLeft: Point = null
        // The margin between the popup and the top left corner of the map
        // view after autopanning was performed.
        autoPanPaddingTopLeft: null,
        // @option autoPanPaddingBottomRight: Point = null
        // The margin between the popup and the bottom right corner of the map
        // view after autopanning was performed.
        autoPanPaddingBottomRight: null,
        // @option autoPanPadding: Point = Point(5, 5)
        // Equivalent of setting both top left and bottom right autopan padding to the same value.
        autoPanPadding: [
            5,
            5
        ],
        // @option keepInView: Boolean = false
        // Set it to `true` if you want to prevent users from panning the popup
        // off of the screen while it is open.
        keepInView: false,
        // @option closeButton: Boolean = true
        // Controls the presence of a close button in the popup.
        closeButton: true,
        // @option autoClose: Boolean = true
        // Set it to `false` if you want to override the default behavior of
        // the popup closing when another popup is opened.
        autoClose: true,
        // @option closeOnEscapeKey: Boolean = true
        // Set it to `false` if you want to override the default behavior of
        // the ESC key for closing of the popup.
        closeOnEscapeKey: true,
        // @option closeOnClick: Boolean = *
        // Set it if you want to override the default behavior of the popup closing when user clicks
        // on the map. Defaults to the map's [`closePopupOnClick`](#map-closepopuponclick) option.
        // @option className: String = ''
        // A custom CSS class name to assign to the popup.
        className: ""
    },
    // @namespace Popup
    // @method openOn(map: Map): this
    // Alternative to `map.openPopup(popup)`.
    // Adds the popup to the map and closes the previous one.
    openOn: function(map) {
        map = arguments.length ? map : this._source._map; // experimental, not the part of public api
        if (!map.hasLayer(this) && map._popup && map._popup.options.autoClose) map.removeLayer(map._popup);
        map._popup = this;
        return (0, $98d1ab62737ca23d$export$16862402e2cc620a).prototype.openOn.call(this, map);
    },
    onAdd: function(map) {
        (0, $98d1ab62737ca23d$export$16862402e2cc620a).prototype.onAdd.call(this, map);
        // @namespace Map
        // @section Popup events
        // @event popupopen: PopupEvent
        // Fired when a popup is opened in the map
        map.fire("popupopen", {
            popup: this
        });
        if (this._source) {
            // @namespace Layer
            // @section Popup events
            // @event popupopen: PopupEvent
            // Fired when a popup bound to this layer is opened
            this._source.fire("popupopen", {
                popup: this
            }, true);
            // For non-path layers, we toggle the popup when clicking
            // again the layer, so prevent the map to reopen it.
            if (!(this._source instanceof (0, $368acd641f573c2e$export$4b2950bdac9b6ee9))) this._source.on("preclick", $2148974bfeaf2ac1$export$51134cce184326b9);
        }
    },
    onRemove: function(map) {
        (0, $98d1ab62737ca23d$export$16862402e2cc620a).prototype.onRemove.call(this, map);
        // @namespace Map
        // @section Popup events
        // @event popupclose: PopupEvent
        // Fired when a popup in the map is closed
        map.fire("popupclose", {
            popup: this
        });
        if (this._source) {
            // @namespace Layer
            // @section Popup events
            // @event popupclose: PopupEvent
            // Fired when a popup bound to this layer is closed
            this._source.fire("popupclose", {
                popup: this
            }, true);
            if (!(this._source instanceof (0, $368acd641f573c2e$export$4b2950bdac9b6ee9))) this._source.off("preclick", $2148974bfeaf2ac1$export$51134cce184326b9);
        }
    },
    getEvents: function() {
        var events = (0, $98d1ab62737ca23d$export$16862402e2cc620a).prototype.getEvents.call(this);
        if (this.options.closeOnClick !== undefined ? this.options.closeOnClick : this._map.options.closePopupOnClick) events.preclick = this.close;
        if (this.options.keepInView) events.moveend = this._adjustPan;
        return events;
    },
    _initLayout: function() {
        var prefix = "leaflet-popup", container = this._container = $783b7cedd5fd919a$export$185802fd694ee1f5("div", prefix + " " + (this.options.className || "") + " leaflet-zoom-animated");
        var wrapper = this._wrapper = $783b7cedd5fd919a$export$185802fd694ee1f5("div", prefix + "-content-wrapper", container);
        this._contentNode = $783b7cedd5fd919a$export$185802fd694ee1f5("div", prefix + "-content", wrapper);
        $2148974bfeaf2ac1$export$a640b530813b3952(container);
        $2148974bfeaf2ac1$export$383a0f6cce2d3ccb(this._contentNode);
        $2148974bfeaf2ac1$export$af631764ddc44097(container, "contextmenu", $2148974bfeaf2ac1$export$51134cce184326b9);
        this._tipContainer = $783b7cedd5fd919a$export$185802fd694ee1f5("div", prefix + "-tip-container", container);
        this._tip = $783b7cedd5fd919a$export$185802fd694ee1f5("div", prefix + "-tip", this._tipContainer);
        if (this.options.closeButton) {
            var closeButton = this._closeButton = $783b7cedd5fd919a$export$185802fd694ee1f5("a", prefix + "-close-button", container);
            closeButton.setAttribute("role", "button"); // overrides the implicit role=link of <a> elements #7399
            closeButton.setAttribute("aria-label", "Close popup");
            closeButton.href = "#close";
            closeButton.innerHTML = '<span aria-hidden="true">&#215;</span>';
            $2148974bfeaf2ac1$export$af631764ddc44097(closeButton, "click", function(ev) {
                $2148974bfeaf2ac1$export$fa3b29edae795ef4(ev);
                this.close();
            }, this);
        }
    },
    _updateLayout: function() {
        var container = this._contentNode, style = container.style;
        style.width = "";
        style.whiteSpace = "nowrap";
        var width = container.offsetWidth;
        width = Math.min(width, this.options.maxWidth);
        width = Math.max(width, this.options.minWidth);
        style.width = width + 1 + "px";
        style.whiteSpace = "";
        style.height = "";
        var height = container.offsetHeight, maxHeight = this.options.maxHeight, scrolledClass = "leaflet-popup-scrolled";
        if (maxHeight && height > maxHeight) {
            style.height = maxHeight + "px";
            $783b7cedd5fd919a$export$d2cf6cd1dc7067d3(container, scrolledClass);
        } else $783b7cedd5fd919a$export$c2255604a80b4506(container, scrolledClass);
        this._containerWidth = this._container.offsetWidth;
    },
    _animateZoom: function(e) {
        var pos = this._map._latLngToNewLayerPoint(this._latlng, e.zoom, e.center), anchor = this._getAnchor();
        $783b7cedd5fd919a$export$f9b088a47202d605(this._container, pos.add(anchor));
    },
    _adjustPan: function() {
        if (!this.options.autoPan) return;
        if (this._map._panAnim) this._map._panAnim.stop();
        // We can endlessly recurse if keepInView is set and the view resets.
        // Let's guard against that by exiting early if we're responding to our own autopan.
        if (this._autopanning) {
            this._autopanning = false;
            return;
        }
        var map = this._map, marginBottom = parseInt($783b7cedd5fd919a$export$3d2f074408bd1b82(this._container, "marginBottom"), 10) || 0, containerHeight = this._container.offsetHeight + marginBottom, containerWidth = this._containerWidth, layerPos = new (0, $b802e4aa6d666b45$export$baf26146a414f24a)(this._containerLeft, -containerHeight - this._containerBottom);
        layerPos._add($783b7cedd5fd919a$export$1690e12b840569b9(this._container));
        var containerPos = map.layerPointToContainerPoint(layerPos), padding = (0, $b802e4aa6d666b45$export$b63cca88ddc558a9)(this.options.autoPanPadding), paddingTL = (0, $b802e4aa6d666b45$export$b63cca88ddc558a9)(this.options.autoPanPaddingTopLeft || padding), paddingBR = (0, $b802e4aa6d666b45$export$b63cca88ddc558a9)(this.options.autoPanPaddingBottomRight || padding), size = map.getSize(), dx = 0, dy = 0;
        if (containerPos.x + containerWidth + paddingBR.x > size.x) dx = containerPos.x + containerWidth - size.x + paddingBR.x;
        if (containerPos.x - dx - paddingTL.x < 0) dx = containerPos.x - paddingTL.x;
        if (containerPos.y + containerHeight + paddingBR.y > size.y) dy = containerPos.y + containerHeight - size.y + paddingBR.y;
        if (containerPos.y - dy - paddingTL.y < 0) dy = containerPos.y - paddingTL.y;
        // @namespace Map
        // @section Popup events
        // @event autopanstart: Event
        // Fired when the map starts autopanning when opening a popup.
        if (dx || dy) {
            // Track that we're autopanning, as this function will be re-ran on moveend
            if (this.options.keepInView) this._autopanning = true;
            map.fire("autopanstart").panBy([
                dx,
                dy
            ]);
        }
    },
    _getAnchor: function() {
        // Where should we anchor the popup on the source layer?
        return (0, $b802e4aa6d666b45$export$b63cca88ddc558a9)(this._source && this._source._getPopupAnchor ? this._source._getPopupAnchor() : [
            0,
            0
        ]);
    }
});
var $c46100516ceeb540$export$63b4813c5280c707 = function(options, source) {
    return new $c46100516ceeb540$export$129a32eedafa97c5(options, source);
};
/* @namespace Map
 * @section Interaction Options
 * @option closePopupOnClick: Boolean = true
 * Set it to `false` if you don't want popups to close when user clicks the map.
 */ (0, $7d9a54c6488daf4f$export$a5c7b93649eaf8f8).mergeOptions({
    closePopupOnClick: true
});
// @namespace Map
// @section Methods for Layers and Controls
(0, $7d9a54c6488daf4f$export$a5c7b93649eaf8f8).include({
    // @method openPopup(popup: Popup): this
    // Opens the specified popup while closing the previously opened (to make sure only one is opened at one time for usability).
    // @alternative
    // @method openPopup(content: String|HTMLElement, latlng: LatLng, options?: Popup options): this
    // Creates a popup with the specified content and options and opens it in the given point on a map.
    openPopup: function(popup, latlng, options) {
        this._initOverlay($c46100516ceeb540$export$129a32eedafa97c5, popup, latlng, options).openOn(this);
        return this;
    },
    // @method closePopup(popup?: Popup): this
    // Closes the popup previously opened with [openPopup](#map-openpopup) (or the given one).
    closePopup: function(popup) {
        popup = arguments.length ? popup : this._popup;
        if (popup) popup.close();
        return this;
    }
});
/*
 * @namespace Layer
 * @section Popup methods example
 *
 * All layers share a set of methods convenient for binding popups to it.
 *
 * ```js
 * var layer = L.Polygon(latlngs).bindPopup('Hi There!').addTo(map);
 * layer.openPopup();
 * layer.closePopup();
 * ```
 *
 * Popups will also be automatically opened when the layer is clicked on and closed when the layer is removed from the map or another popup is opened.
 */ // @section Popup methods
(0, $3219933a0a8d4dcc$export$936d0764594b6eb3).include({
    // @method bindPopup(content: String|HTMLElement|Function|Popup, options?: Popup options): this
    // Binds a popup to the layer with the passed `content` and sets up the
    // necessary event listeners. If a `Function` is passed it will receive
    // the layer as the first argument and should return a `String` or `HTMLElement`.
    bindPopup: function(content, options) {
        this._popup = this._initOverlay($c46100516ceeb540$export$129a32eedafa97c5, this._popup, content, options);
        if (!this._popupHandlersAdded) {
            this.on({
                click: this._openPopup,
                keypress: this._onKeyPress,
                remove: this.closePopup,
                move: this._movePopup
            });
            this._popupHandlersAdded = true;
        }
        return this;
    },
    // @method unbindPopup(): this
    // Removes the popup previously bound with `bindPopup`.
    unbindPopup: function() {
        if (this._popup) {
            this.off({
                click: this._openPopup,
                keypress: this._onKeyPress,
                remove: this.closePopup,
                move: this._movePopup
            });
            this._popupHandlersAdded = false;
            this._popup = null;
        }
        return this;
    },
    // @method openPopup(latlng?: LatLng): this
    // Opens the bound popup at the specified `latlng` or at the default popup anchor if no `latlng` is passed.
    openPopup: function(latlng) {
        if (this._popup) {
            if (!(this instanceof (0, $fe973108fad44854$export$520fbf7f9cbd232d))) this._popup._source = this;
            if (this._popup._prepareOpen(latlng || this._latlng)) // open the popup on the map
            this._popup.openOn(this._map);
        }
        return this;
    },
    // @method closePopup(): this
    // Closes the popup bound to this layer if it is open.
    closePopup: function() {
        if (this._popup) this._popup.close();
        return this;
    },
    // @method togglePopup(): this
    // Opens or closes the popup bound to this layer depending on its current state.
    togglePopup: function() {
        if (this._popup) this._popup.toggle(this);
        return this;
    },
    // @method isPopupOpen(): boolean
    // Returns `true` if the popup bound to this layer is currently open.
    isPopupOpen: function() {
        return this._popup ? this._popup.isOpen() : false;
    },
    // @method setPopupContent(content: String|HTMLElement|Popup): this
    // Sets the content of the popup bound to this layer.
    setPopupContent: function(content) {
        if (this._popup) this._popup.setContent(content);
        return this;
    },
    // @method getPopup(): Popup
    // Returns the popup bound to this layer.
    getPopup: function() {
        return this._popup;
    },
    _openPopup: function(e) {
        if (!this._popup || !this._map) return;
        // prevent map click
        $2148974bfeaf2ac1$export$fa6813432f753b0d(e);
        var target = e.layer || e.target;
        if (this._popup._source === target && !(target instanceof (0, $368acd641f573c2e$export$4b2950bdac9b6ee9))) {
            // treat it like a marker and figure out
            // if we should toggle it open/closed
            if (this._map.hasLayer(this._popup)) this.closePopup();
            else this.openPopup(e.latlng);
            return;
        }
        this._popup._source = target;
        this.openPopup(e.latlng);
    },
    _movePopup: function(e) {
        this._popup.setLatLng(e.latlng);
    },
    _onKeyPress: function(e) {
        if (e.originalEvent.keyCode === 13) this._openPopup(e);
    }
});










var $40c252206f7b812a$export$28c660c63b792dea = (0, $98d1ab62737ca23d$export$16862402e2cc620a).extend({
    // @section
    // @aka Tooltip options
    options: {
        // @option pane: String = 'tooltipPane'
        // `Map pane` where the tooltip will be added.
        pane: "tooltipPane",
        // @option offset: Point = Point(0, 0)
        // Optional offset of the tooltip position.
        offset: [
            0,
            0
        ],
        // @option direction: String = 'auto'
        // Direction where to open the tooltip. Possible values are: `right`, `left`,
        // `top`, `bottom`, `center`, `auto`.
        // `auto` will dynamically switch between `right` and `left` according to the tooltip
        // position on the map.
        direction: "auto",
        // @option permanent: Boolean = false
        // Whether to open the tooltip permanently or only on mouseover.
        permanent: false,
        // @option sticky: Boolean = false
        // If true, the tooltip will follow the mouse instead of being fixed at the feature center.
        sticky: false,
        // @option opacity: Number = 0.9
        // Tooltip container opacity.
        opacity: 0.9
    },
    onAdd: function(map) {
        (0, $98d1ab62737ca23d$export$16862402e2cc620a).prototype.onAdd.call(this, map);
        this.setOpacity(this.options.opacity);
        // @namespace Map
        // @section Tooltip events
        // @event tooltipopen: TooltipEvent
        // Fired when a tooltip is opened in the map.
        map.fire("tooltipopen", {
            tooltip: this
        });
        if (this._source) {
            this.addEventParent(this._source);
            // @namespace Layer
            // @section Tooltip events
            // @event tooltipopen: TooltipEvent
            // Fired when a tooltip bound to this layer is opened.
            this._source.fire("tooltipopen", {
                tooltip: this
            }, true);
        }
    },
    onRemove: function(map) {
        (0, $98d1ab62737ca23d$export$16862402e2cc620a).prototype.onRemove.call(this, map);
        // @namespace Map
        // @section Tooltip events
        // @event tooltipclose: TooltipEvent
        // Fired when a tooltip in the map is closed.
        map.fire("tooltipclose", {
            tooltip: this
        });
        if (this._source) {
            this.removeEventParent(this._source);
            // @namespace Layer
            // @section Tooltip events
            // @event tooltipclose: TooltipEvent
            // Fired when a tooltip bound to this layer is closed.
            this._source.fire("tooltipclose", {
                tooltip: this
            }, true);
        }
    },
    getEvents: function() {
        var events = (0, $98d1ab62737ca23d$export$16862402e2cc620a).prototype.getEvents.call(this);
        if (!this.options.permanent) events.preclick = this.close;
        return events;
    },
    _initLayout: function() {
        var prefix = "leaflet-tooltip", className = prefix + " " + (this.options.className || "") + " leaflet-zoom-" + (this._zoomAnimated ? "animated" : "hide");
        this._contentNode = this._container = $783b7cedd5fd919a$export$185802fd694ee1f5("div", className);
        this._container.setAttribute("role", "tooltip");
        this._container.setAttribute("id", "leaflet-tooltip-" + $13bbd556cd7cee10$export$bd3fba034e28f6b(this));
    },
    _updateLayout: function() {},
    _adjustPan: function() {},
    _setPosition: function(pos) {
        var subX, subY, map = this._map, container = this._container, centerPoint = map.latLngToContainerPoint(map.getCenter()), tooltipPoint = map.layerPointToContainerPoint(pos), direction = this.options.direction, tooltipWidth = container.offsetWidth, tooltipHeight = container.offsetHeight, offset = (0, $b802e4aa6d666b45$export$b63cca88ddc558a9)(this.options.offset), anchor = this._getAnchor();
        if (direction === "top") {
            subX = tooltipWidth / 2;
            subY = tooltipHeight;
        } else if (direction === "bottom") {
            subX = tooltipWidth / 2;
            subY = 0;
        } else if (direction === "center") {
            subX = tooltipWidth / 2;
            subY = tooltipHeight / 2;
        } else if (direction === "right") {
            subX = 0;
            subY = tooltipHeight / 2;
        } else if (direction === "left") {
            subX = tooltipWidth;
            subY = tooltipHeight / 2;
        } else if (tooltipPoint.x < centerPoint.x) {
            direction = "right";
            subX = 0;
            subY = tooltipHeight / 2;
        } else {
            direction = "left";
            subX = tooltipWidth + (offset.x + anchor.x) * 2;
            subY = tooltipHeight / 2;
        }
        pos = pos.subtract((0, $b802e4aa6d666b45$export$b63cca88ddc558a9)(subX, subY, true)).add(offset).add(anchor);
        $783b7cedd5fd919a$export$c2255604a80b4506(container, "leaflet-tooltip-right");
        $783b7cedd5fd919a$export$c2255604a80b4506(container, "leaflet-tooltip-left");
        $783b7cedd5fd919a$export$c2255604a80b4506(container, "leaflet-tooltip-top");
        $783b7cedd5fd919a$export$c2255604a80b4506(container, "leaflet-tooltip-bottom");
        $783b7cedd5fd919a$export$d2cf6cd1dc7067d3(container, "leaflet-tooltip-" + direction);
        $783b7cedd5fd919a$export$f9b088a47202d605(container, pos);
    },
    _updatePosition: function() {
        var pos = this._map.latLngToLayerPoint(this._latlng);
        this._setPosition(pos);
    },
    setOpacity: function(opacity) {
        this.options.opacity = opacity;
        if (this._container) $783b7cedd5fd919a$export$2646c6b151d2e8(this._container, opacity);
    },
    _animateZoom: function(e) {
        var pos = this._map._latLngToNewLayerPoint(this._latlng, e.zoom, e.center);
        this._setPosition(pos);
    },
    _getAnchor: function() {
        // Where should we anchor the tooltip on the source layer?
        return (0, $b802e4aa6d666b45$export$b63cca88ddc558a9)(this._source && this._source._getTooltipAnchor && !this.options.sticky ? this._source._getTooltipAnchor() : [
            0,
            0
        ]);
    }
});
var $40c252206f7b812a$export$4e6f96734dfe12f4 = function(options, source) {
    return new $40c252206f7b812a$export$28c660c63b792dea(options, source);
};
// @namespace Map
// @section Methods for Layers and Controls
(0, $7d9a54c6488daf4f$export$a5c7b93649eaf8f8).include({
    // @method openTooltip(tooltip: Tooltip): this
    // Opens the specified tooltip.
    // @alternative
    // @method openTooltip(content: String|HTMLElement, latlng: LatLng, options?: Tooltip options): this
    // Creates a tooltip with the specified content and options and open it.
    openTooltip: function(tooltip, latlng, options) {
        this._initOverlay($40c252206f7b812a$export$28c660c63b792dea, tooltip, latlng, options).openOn(this);
        return this;
    },
    // @method closeTooltip(tooltip: Tooltip): this
    // Closes the tooltip given as parameter.
    closeTooltip: function(tooltip) {
        tooltip.close();
        return this;
    }
});
/*
 * @namespace Layer
 * @section Tooltip methods example
 *
 * All layers share a set of methods convenient for binding tooltips to it.
 *
 * ```js
 * var layer = L.Polygon(latlngs).bindTooltip('Hi There!').addTo(map);
 * layer.openTooltip();
 * layer.closeTooltip();
 * ```
 */ // @section Tooltip methods
(0, $3219933a0a8d4dcc$export$936d0764594b6eb3).include({
    // @method bindTooltip(content: String|HTMLElement|Function|Tooltip, options?: Tooltip options): this
    // Binds a tooltip to the layer with the passed `content` and sets up the
    // necessary event listeners. If a `Function` is passed it will receive
    // the layer as the first argument and should return a `String` or `HTMLElement`.
    bindTooltip: function(content, options) {
        if (this._tooltip && this.isTooltipOpen()) this.unbindTooltip();
        this._tooltip = this._initOverlay($40c252206f7b812a$export$28c660c63b792dea, this._tooltip, content, options);
        this._initTooltipInteractions();
        if (this._tooltip.options.permanent && this._map && this._map.hasLayer(this)) this.openTooltip();
        return this;
    },
    // @method unbindTooltip(): this
    // Removes the tooltip previously bound with `bindTooltip`.
    unbindTooltip: function() {
        if (this._tooltip) {
            this._initTooltipInteractions(true);
            this.closeTooltip();
            this._tooltip = null;
        }
        return this;
    },
    _initTooltipInteractions: function(remove) {
        if (!remove && this._tooltipHandlersAdded) return;
        var onOff = remove ? "off" : "on", events = {
            remove: this.closeTooltip,
            move: this._moveTooltip
        };
        if (!this._tooltip.options.permanent) {
            events.mouseover = this._openTooltip;
            events.mouseout = this.closeTooltip;
            events.click = this._openTooltip;
            if (this._map) this._addFocusListeners();
            else events.add = this._addFocusListeners;
        } else events.add = this._openTooltip;
        if (this._tooltip.options.sticky) events.mousemove = this._moveTooltip;
        this[onOff](events);
        this._tooltipHandlersAdded = !remove;
    },
    // @method openTooltip(latlng?: LatLng): this
    // Opens the bound tooltip at the specified `latlng` or at the default tooltip anchor if no `latlng` is passed.
    openTooltip: function(latlng) {
        if (this._tooltip) {
            if (!(this instanceof (0, $fe973108fad44854$export$520fbf7f9cbd232d))) this._tooltip._source = this;
            if (this._tooltip._prepareOpen(latlng)) {
                // open the tooltip on the map
                this._tooltip.openOn(this._map);
                if (this.getElement) this._setAriaDescribedByOnLayer(this);
                else if (this.eachLayer) this.eachLayer(this._setAriaDescribedByOnLayer, this);
            }
        }
        return this;
    },
    // @method closeTooltip(): this
    // Closes the tooltip bound to this layer if it is open.
    closeTooltip: function() {
        if (this._tooltip) return this._tooltip.close();
    },
    // @method toggleTooltip(): this
    // Opens or closes the tooltip bound to this layer depending on its current state.
    toggleTooltip: function() {
        if (this._tooltip) this._tooltip.toggle(this);
        return this;
    },
    // @method isTooltipOpen(): boolean
    // Returns `true` if the tooltip bound to this layer is currently open.
    isTooltipOpen: function() {
        return this._tooltip.isOpen();
    },
    // @method setTooltipContent(content: String|HTMLElement|Tooltip): this
    // Sets the content of the tooltip bound to this layer.
    setTooltipContent: function(content) {
        if (this._tooltip) this._tooltip.setContent(content);
        return this;
    },
    // @method getTooltip(): Tooltip
    // Returns the tooltip bound to this layer.
    getTooltip: function() {
        return this._tooltip;
    },
    _addFocusListeners: function() {
        if (this.getElement) this._addFocusListenersOnLayer(this);
        else if (this.eachLayer) this.eachLayer(this._addFocusListenersOnLayer, this);
    },
    _addFocusListenersOnLayer: function(layer) {
        var el = typeof layer.getElement === "function" && layer.getElement();
        if (el) {
            $2148974bfeaf2ac1$export$af631764ddc44097(el, "focus", function() {
                this._tooltip._source = layer;
                this.openTooltip();
            }, this);
            $2148974bfeaf2ac1$export$af631764ddc44097(el, "blur", this.closeTooltip, this);
        }
    },
    _setAriaDescribedByOnLayer: function(layer) {
        var el = typeof layer.getElement === "function" && layer.getElement();
        if (el) el.setAttribute("aria-describedby", this._tooltip._container.id);
    },
    _openTooltip: function(e) {
        if (!this._tooltip || !this._map) return;
        // If the map is moving, we will show the tooltip after it's done.
        if (this._map.dragging && this._map.dragging.moving() && !this._openOnceFlag) {
            this._openOnceFlag = true;
            var that = this;
            this._map.once("moveend", function() {
                that._openOnceFlag = false;
                that._openTooltip(e);
            });
            return;
        }
        this._tooltip._source = e.layer || e.target;
        this.openTooltip(this._tooltip.options.sticky ? e.latlng : undefined);
    },
    _moveTooltip: function(e) {
        var latlng = e.latlng, containerPoint, layerPoint;
        if (this._tooltip.options.sticky && e.originalEvent) {
            containerPoint = this._map.mouseEventToContainerPoint(e.originalEvent);
            layerPoint = this._map.containerPointToLayerPoint(containerPoint);
            latlng = this._map.layerPointToLatLng(layerPoint);
        }
        this._tooltip.setLatLng(latlng);
    }
});







var $ebbcedd1ba5fa6c7$export$2cb0785d16917af = (0, $a2a17357df3a183a$export$f04a61298a47a40f).extend({
    options: {
        // @section
        // @aka DivIcon options
        iconSize: [
            12,
            12
        ],
        // iconAnchor: (Point),
        // popupAnchor: (Point),
        // @option html: String|HTMLElement = ''
        // Custom HTML code to put inside the div element, empty by default. Alternatively,
        // an instance of `HTMLElement`.
        html: false,
        // @option bgPos: Point = [0, 0]
        // Optional relative position of the background, in pixels
        bgPos: null,
        className: "leaflet-div-icon"
    },
    createIcon: function(oldIcon) {
        var div = oldIcon && oldIcon.tagName === "DIV" ? oldIcon : document.createElement("div"), options = this.options;
        if (options.html instanceof Element) {
            (0, $783b7cedd5fd919a$export$6e22c362a0406a2c)(div);
            div.appendChild(options.html);
        } else div.innerHTML = options.html !== false ? options.html : "";
        if (options.bgPos) {
            var bgPos = (0, $b802e4aa6d666b45$export$b63cca88ddc558a9)(options.bgPos);
            div.style.backgroundPosition = -bgPos.x + "px " + -bgPos.y + "px";
        }
        this._setIconStyles(div, "icon");
        return div;
    },
    createShadow: function() {
        return null;
    }
});
function $ebbcedd1ba5fa6c7$export$46821b1bf0daf45b(options) {
    return new $ebbcedd1ba5fa6c7$export$2cb0785d16917af(options);
}



(0, $a2a17357df3a183a$export$f04a61298a47a40f).Default = (0, $2782a71b73f5c155$export$cacc2a877598679f);









var $04d60fd755d1bee0$export$3b2364b911db251c = (0, $3219933a0a8d4dcc$export$936d0764594b6eb3).extend({
    // @section
    // @aka GridLayer options
    options: {
        // @option tileSize: Number|Point = 256
        // Width and height of tiles in the grid. Use a number if width and height are equal, or `L.point(width, height)` otherwise.
        tileSize: 256,
        // @option opacity: Number = 1.0
        // Opacity of the tiles. Can be used in the `createTile()` function.
        opacity: 1,
        // @option updateWhenIdle: Boolean = (depends)
        // Load new tiles only when panning ends.
        // `true` by default on mobile browsers, in order to avoid too many requests and keep smooth navigation.
        // `false` otherwise in order to display new tiles _during_ panning, since it is easy to pan outside the
        // [`keepBuffer`](#gridlayer-keepbuffer) option in desktop browsers.
        updateWhenIdle: (0, $bda63d751c06734c$export$2e2bcd8739ae039).mobile,
        // @option updateWhenZooming: Boolean = true
        // By default, a smooth zoom animation (during a [touch zoom](#map-touchzoom) or a [`flyTo()`](#map-flyto)) will update grid layers every integer zoom level. Setting this option to `false` will update the grid layer only when the smooth animation ends.
        updateWhenZooming: true,
        // @option updateInterval: Number = 200
        // Tiles will not update more than once every `updateInterval` milliseconds when panning.
        updateInterval: 200,
        // @option zIndex: Number = 1
        // The explicit zIndex of the tile layer.
        zIndex: 1,
        // @option bounds: LatLngBounds = undefined
        // If set, tiles will only be loaded inside the set `LatLngBounds`.
        bounds: null,
        // @option minZoom: Number = 0
        // The minimum zoom level down to which this layer will be displayed (inclusive).
        minZoom: 0,
        // @option maxZoom: Number = undefined
        // The maximum zoom level up to which this layer will be displayed (inclusive).
        maxZoom: undefined,
        // @option maxNativeZoom: Number = undefined
        // Maximum zoom number the tile source has available. If it is specified,
        // the tiles on all zoom levels higher than `maxNativeZoom` will be loaded
        // from `maxNativeZoom` level and auto-scaled.
        maxNativeZoom: undefined,
        // @option minNativeZoom: Number = undefined
        // Minimum zoom number the tile source has available. If it is specified,
        // the tiles on all zoom levels lower than `minNativeZoom` will be loaded
        // from `minNativeZoom` level and auto-scaled.
        minNativeZoom: undefined,
        // @option noWrap: Boolean = false
        // Whether the layer is wrapped around the antimeridian. If `true`, the
        // GridLayer will only be displayed once at low zoom levels. Has no
        // effect when the [map CRS](#map-crs) doesn't wrap around. Can be used
        // in combination with [`bounds`](#gridlayer-bounds) to prevent requesting
        // tiles outside the CRS limits.
        noWrap: false,
        // @option pane: String = 'tilePane'
        // `Map pane` where the grid layer will be added.
        pane: "tilePane",
        // @option className: String = ''
        // A custom class name to assign to the tile layer. Empty by default.
        className: "",
        // @option keepBuffer: Number = 2
        // When panning the map, keep this many rows and columns of tiles before unloading them.
        keepBuffer: 2
    },
    initialize: function(options) {
        $13bbd556cd7cee10$export$add91eafeaeab287(this, options);
    },
    onAdd: function() {
        this._initContainer();
        this._levels = {};
        this._tiles = {};
        this._resetView(); // implicit _update() call
    },
    beforeAdd: function(map) {
        map._addZoomLimit(this);
    },
    onRemove: function(map) {
        this._removeAllTiles();
        $783b7cedd5fd919a$export$cd7f480d6b8286c3(this._container);
        map._removeZoomLimit(this);
        this._container = null;
        this._tileZoom = undefined;
    },
    // @method bringToFront: this
    // Brings the tile layer to the top of all tile layers.
    bringToFront: function() {
        if (this._map) {
            $783b7cedd5fd919a$export$967ea9e64a77dad2(this._container);
            this._setAutoZIndex(Math.max);
        }
        return this;
    },
    // @method bringToBack: this
    // Brings the tile layer to the bottom of all tile layers.
    bringToBack: function() {
        if (this._map) {
            $783b7cedd5fd919a$export$4d34781508fd70d9(this._container);
            this._setAutoZIndex(Math.min);
        }
        return this;
    },
    // @method getContainer: HTMLElement
    // Returns the HTML element that contains the tiles for this layer.
    getContainer: function() {
        return this._container;
    },
    // @method setOpacity(opacity: Number): this
    // Changes the [opacity](#gridlayer-opacity) of the grid layer.
    setOpacity: function(opacity) {
        this.options.opacity = opacity;
        this._updateOpacity();
        return this;
    },
    // @method setZIndex(zIndex: Number): this
    // Changes the [zIndex](#gridlayer-zindex) of the grid layer.
    setZIndex: function(zIndex) {
        this.options.zIndex = zIndex;
        this._updateZIndex();
        return this;
    },
    // @method isLoading: Boolean
    // Returns `true` if any tile in the grid layer has not finished loading.
    isLoading: function() {
        return this._loading;
    },
    // @method redraw: this
    // Causes the layer to clear all the tiles and request them again.
    redraw: function() {
        if (this._map) {
            this._removeAllTiles();
            var tileZoom = this._clampZoom(this._map.getZoom());
            if (tileZoom !== this._tileZoom) {
                this._tileZoom = tileZoom;
                this._updateLevels();
            }
            this._update();
        }
        return this;
    },
    getEvents: function() {
        var events = {
            viewprereset: this._invalidateAll,
            viewreset: this._resetView,
            zoom: this._resetView,
            moveend: this._onMoveEnd
        };
        if (!this.options.updateWhenIdle) {
            // update tiles on move, but not more often than once per given interval
            if (!this._onMove) this._onMove = $13bbd556cd7cee10$export$de363e709c412c8a(this._onMoveEnd, this.options.updateInterval, this);
            events.move = this._onMove;
        }
        if (this._zoomAnimated) events.zoomanim = this._animateZoom;
        return events;
    },
    // @section Extension methods
    // Layers extending `GridLayer` shall reimplement the following method.
    // @method createTile(coords: Object, done?: Function): HTMLElement
    // Called only internally, must be overridden by classes extending `GridLayer`.
    // Returns the `HTMLElement` corresponding to the given `coords`. If the `done` callback
    // is specified, it must be called when the tile has finished loading and drawing.
    createTile: function() {
        return document.createElement("div");
    },
    // @section
    // @method getTileSize: Point
    // Normalizes the [tileSize option](#gridlayer-tilesize) into a point. Used by the `createTile()` method.
    getTileSize: function() {
        var s = this.options.tileSize;
        return s instanceof (0, $b802e4aa6d666b45$export$baf26146a414f24a) ? s : new (0, $b802e4aa6d666b45$export$baf26146a414f24a)(s, s);
    },
    _updateZIndex: function() {
        if (this._container && this.options.zIndex !== undefined && this.options.zIndex !== null) this._container.style.zIndex = this.options.zIndex;
    },
    _setAutoZIndex: function(compare) {
        // go through all other layers of the same pane, set zIndex to max + 1 (front) or min - 1 (back)
        var layers = this.getPane().children, edgeZIndex = -compare(-Infinity, Infinity); // -Infinity for max, Infinity for min
        for(var i = 0, len = layers.length, zIndex; i < len; i++){
            zIndex = layers[i].style.zIndex;
            if (layers[i] !== this._container && zIndex) edgeZIndex = compare(edgeZIndex, +zIndex);
        }
        if (isFinite(edgeZIndex)) {
            this.options.zIndex = edgeZIndex + compare(-1, 1);
            this._updateZIndex();
        }
    },
    _updateOpacity: function() {
        if (!this._map) return;
        // IE doesn't inherit filter opacity properly, so we're forced to set it on tiles
        if ((0, $bda63d751c06734c$export$2e2bcd8739ae039).ielt9) return;
        $783b7cedd5fd919a$export$2646c6b151d2e8(this._container, this.options.opacity);
        var now = +new Date(), nextFrame = false, willPrune = false;
        for(var key in this._tiles){
            var tile = this._tiles[key];
            if (!tile.current || !tile.loaded) continue;
            var fade = Math.min(1, (now - tile.loaded) / 200);
            $783b7cedd5fd919a$export$2646c6b151d2e8(tile.el, fade);
            if (fade < 1) nextFrame = true;
            else {
                if (tile.active) willPrune = true;
                else this._onOpaqueTile(tile);
                tile.active = true;
            }
        }
        if (willPrune && !this._noPrune) this._pruneTiles();
        if (nextFrame) {
            $13bbd556cd7cee10$export$e1ed83507f55dc9d(this._fadeFrame);
            this._fadeFrame = $13bbd556cd7cee10$export$d371ad015c199c06(this._updateOpacity, this);
        }
    },
    _onOpaqueTile: $13bbd556cd7cee10$export$a3891e81a74c5e40,
    _initContainer: function() {
        if (this._container) return;
        this._container = $783b7cedd5fd919a$export$185802fd694ee1f5("div", "leaflet-layer " + (this.options.className || ""));
        this._updateZIndex();
        if (this.options.opacity < 1) this._updateOpacity();
        this.getPane().appendChild(this._container);
    },
    _updateLevels: function() {
        var zoom = this._tileZoom, maxZoom = this.options.maxZoom;
        if (zoom === undefined) return undefined;
        for(var z in this._levels){
            z = Number(z);
            if (this._levels[z].el.children.length || z === zoom) {
                this._levels[z].el.style.zIndex = maxZoom - Math.abs(zoom - z);
                this._onUpdateLevel(z);
            } else {
                $783b7cedd5fd919a$export$cd7f480d6b8286c3(this._levels[z].el);
                this._removeTilesAtZoom(z);
                this._onRemoveLevel(z);
                delete this._levels[z];
            }
        }
        var level = this._levels[zoom], map = this._map;
        if (!level) {
            level = this._levels[zoom] = {};
            level.el = $783b7cedd5fd919a$export$185802fd694ee1f5("div", "leaflet-tile-container leaflet-zoom-animated", this._container);
            level.el.style.zIndex = maxZoom;
            level.origin = map.project(map.unproject(map.getPixelOrigin()), zoom).round();
            level.zoom = zoom;
            this._setZoomTransform(level, map.getCenter(), map.getZoom());
            // force the browser to consider the newly added element for transition
            $13bbd556cd7cee10$export$a3891e81a74c5e40(level.el.offsetWidth);
            this._onCreateLevel(level);
        }
        this._level = level;
        return level;
    },
    _onUpdateLevel: $13bbd556cd7cee10$export$a3891e81a74c5e40,
    _onRemoveLevel: $13bbd556cd7cee10$export$a3891e81a74c5e40,
    _onCreateLevel: $13bbd556cd7cee10$export$a3891e81a74c5e40,
    _pruneTiles: function() {
        if (!this._map) return;
        var key, tile;
        var zoom = this._map.getZoom();
        if (zoom > this.options.maxZoom || zoom < this.options.minZoom) {
            this._removeAllTiles();
            return;
        }
        for(key in this._tiles){
            tile = this._tiles[key];
            tile.retain = tile.current;
        }
        for(key in this._tiles){
            tile = this._tiles[key];
            if (tile.current && !tile.active) {
                var coords = tile.coords;
                if (!this._retainParent(coords.x, coords.y, coords.z, coords.z - 5)) this._retainChildren(coords.x, coords.y, coords.z, coords.z + 2);
            }
        }
        for(key in this._tiles)if (!this._tiles[key].retain) this._removeTile(key);
    },
    _removeTilesAtZoom: function(zoom) {
        for(var key in this._tiles){
            if (this._tiles[key].coords.z !== zoom) continue;
            this._removeTile(key);
        }
    },
    _removeAllTiles: function() {
        for(var key in this._tiles)this._removeTile(key);
    },
    _invalidateAll: function() {
        for(var z in this._levels){
            $783b7cedd5fd919a$export$cd7f480d6b8286c3(this._levels[z].el);
            this._onRemoveLevel(Number(z));
            delete this._levels[z];
        }
        this._removeAllTiles();
        this._tileZoom = undefined;
    },
    _retainParent: function(x, y, z, minZoom) {
        var x2 = Math.floor(x / 2), y2 = Math.floor(y / 2), z2 = z - 1, coords2 = new (0, $b802e4aa6d666b45$export$baf26146a414f24a)(+x2, +y2);
        coords2.z = +z2;
        var key = this._tileCoordsToKey(coords2), tile = this._tiles[key];
        if (tile && tile.active) {
            tile.retain = true;
            return true;
        } else if (tile && tile.loaded) tile.retain = true;
        if (z2 > minZoom) return this._retainParent(x2, y2, z2, minZoom);
        return false;
    },
    _retainChildren: function(x, y, z, maxZoom) {
        for(var i = 2 * x; i < 2 * x + 2; i++)for(var j = 2 * y; j < 2 * y + 2; j++){
            var coords = new (0, $b802e4aa6d666b45$export$baf26146a414f24a)(i, j);
            coords.z = z + 1;
            var key = this._tileCoordsToKey(coords), tile = this._tiles[key];
            if (tile && tile.active) {
                tile.retain = true;
                continue;
            } else if (tile && tile.loaded) tile.retain = true;
            if (z + 1 < maxZoom) this._retainChildren(i, j, z + 1, maxZoom);
        }
    },
    _resetView: function(e) {
        var animating = e && (e.pinch || e.flyTo);
        this._setView(this._map.getCenter(), this._map.getZoom(), animating, animating);
    },
    _animateZoom: function(e) {
        this._setView(e.center, e.zoom, true, e.noUpdate);
    },
    _clampZoom: function(zoom) {
        var options = this.options;
        if (undefined !== options.minNativeZoom && zoom < options.minNativeZoom) return options.minNativeZoom;
        if (undefined !== options.maxNativeZoom && options.maxNativeZoom < zoom) return options.maxNativeZoom;
        return zoom;
    },
    _setView: function(center, zoom, noPrune, noUpdate) {
        var tileZoom = Math.round(zoom);
        if (this.options.maxZoom !== undefined && tileZoom > this.options.maxZoom || this.options.minZoom !== undefined && tileZoom < this.options.minZoom) tileZoom = undefined;
        else tileZoom = this._clampZoom(tileZoom);
        var tileZoomChanged = this.options.updateWhenZooming && tileZoom !== this._tileZoom;
        if (!noUpdate || tileZoomChanged) {
            this._tileZoom = tileZoom;
            if (this._abortLoading) this._abortLoading();
            this._updateLevels();
            this._resetGrid();
            if (tileZoom !== undefined) this._update(center);
            if (!noPrune) this._pruneTiles();
            // Flag to prevent _updateOpacity from pruning tiles during
            // a zoom anim or a pinch gesture
            this._noPrune = !!noPrune;
        }
        this._setZoomTransforms(center, zoom);
    },
    _setZoomTransforms: function(center, zoom) {
        for(var i in this._levels)this._setZoomTransform(this._levels[i], center, zoom);
    },
    _setZoomTransform: function(level, center, zoom) {
        var scale = this._map.getZoomScale(zoom, level.zoom), translate = level.origin.multiplyBy(scale).subtract(this._map._getNewPixelOrigin(center, zoom)).round();
        if ((0, $bda63d751c06734c$export$2e2bcd8739ae039).any3d) $783b7cedd5fd919a$export$ff09356c35bee89b(level.el, translate, scale);
        else $783b7cedd5fd919a$export$f9b088a47202d605(level.el, translate);
    },
    _resetGrid: function() {
        var map = this._map, crs = map.options.crs, tileSize = this._tileSize = this.getTileSize(), tileZoom = this._tileZoom;
        var bounds = this._map.getPixelWorldBounds(this._tileZoom);
        if (bounds) this._globalTileRange = this._pxBoundsToTileRange(bounds);
        this._wrapX = crs.wrapLng && !this.options.noWrap && [
            Math.floor(map.project([
                0,
                crs.wrapLng[0]
            ], tileZoom).x / tileSize.x),
            Math.ceil(map.project([
                0,
                crs.wrapLng[1]
            ], tileZoom).x / tileSize.y)
        ];
        this._wrapY = crs.wrapLat && !this.options.noWrap && [
            Math.floor(map.project([
                crs.wrapLat[0],
                0
            ], tileZoom).y / tileSize.x),
            Math.ceil(map.project([
                crs.wrapLat[1],
                0
            ], tileZoom).y / tileSize.y)
        ];
    },
    _onMoveEnd: function() {
        if (!this._map || this._map._animatingZoom) return;
        this._update();
    },
    _getTiledPixelBounds: function(center) {
        var map = this._map, mapZoom = map._animatingZoom ? Math.max(map._animateToZoom, map.getZoom()) : map.getZoom(), scale = map.getZoomScale(mapZoom, this._tileZoom), pixelCenter = map.project(center, this._tileZoom).floor(), halfSize = map.getSize().divideBy(scale * 2);
        return new (0, $2ffe56518af276c5$export$c4e9d269599ab4b4)(pixelCenter.subtract(halfSize), pixelCenter.add(halfSize));
    },
    // Private method to load tiles in the grid's active zoom level according to map bounds
    _update: function(center) {
        var map = this._map;
        if (!map) return;
        var zoom = this._clampZoom(map.getZoom());
        if (center === undefined) center = map.getCenter();
        if (this._tileZoom === undefined) return;
         // if out of minzoom/maxzoom
        var pixelBounds = this._getTiledPixelBounds(center), tileRange = this._pxBoundsToTileRange(pixelBounds), tileCenter = tileRange.getCenter(), queue = [], margin = this.options.keepBuffer, noPruneRange = new (0, $2ffe56518af276c5$export$c4e9d269599ab4b4)(tileRange.getBottomLeft().subtract([
            margin,
            -margin
        ]), tileRange.getTopRight().add([
            margin,
            -margin
        ]));
        // Sanity check: panic if the tile range contains Infinity somewhere.
        if (!(isFinite(tileRange.min.x) && isFinite(tileRange.min.y) && isFinite(tileRange.max.x) && isFinite(tileRange.max.y))) throw new Error("Attempted to load an infinite number of tiles");
        for(var key in this._tiles){
            var c = this._tiles[key].coords;
            if (c.z !== this._tileZoom || !noPruneRange.contains(new (0, $b802e4aa6d666b45$export$baf26146a414f24a)(c.x, c.y))) this._tiles[key].current = false;
        }
        // _update just loads more tiles. If the tile zoom level differs too much
        // from the map's, let _setView reset levels and prune old tiles.
        if (Math.abs(zoom - this._tileZoom) > 1) {
            this._setView(center, zoom);
            return;
        }
        // create a queue of coordinates to load tiles from
        for(var j = tileRange.min.y; j <= tileRange.max.y; j++)for(var i = tileRange.min.x; i <= tileRange.max.x; i++){
            var coords = new (0, $b802e4aa6d666b45$export$baf26146a414f24a)(i, j);
            coords.z = this._tileZoom;
            if (!this._isValidTile(coords)) continue;
            var tile = this._tiles[this._tileCoordsToKey(coords)];
            if (tile) tile.current = true;
            else queue.push(coords);
        }
        // sort tile queue to load tiles in order of their distance to center
        queue.sort(function(a, b) {
            return a.distanceTo(tileCenter) - b.distanceTo(tileCenter);
        });
        if (queue.length !== 0) {
            // if it's the first batch of tiles to load
            if (!this._loading) {
                this._loading = true;
                // @event loading: Event
                // Fired when the grid layer starts loading tiles.
                this.fire("loading");
            }
            // create DOM fragment to append tiles in one batch
            var fragment = document.createDocumentFragment();
            for(i = 0; i < queue.length; i++)this._addTile(queue[i], fragment);
            this._level.el.appendChild(fragment);
        }
    },
    _isValidTile: function(coords) {
        var crs = this._map.options.crs;
        if (!crs.infinite) {
            // don't load tile if it's out of bounds and not wrapped
            var bounds = this._globalTileRange;
            if (!crs.wrapLng && (coords.x < bounds.min.x || coords.x > bounds.max.x) || !crs.wrapLat && (coords.y < bounds.min.y || coords.y > bounds.max.y)) return false;
        }
        if (!this.options.bounds) return true;
        // don't load tile if it doesn't intersect the bounds in options
        var tileBounds = this._tileCoordsToBounds(coords);
        return (0, $c1a09dde0ebe0161$export$4904432a68b0399)(this.options.bounds).overlaps(tileBounds);
    },
    _keyToBounds: function(key) {
        return this._tileCoordsToBounds(this._keyToTileCoords(key));
    },
    _tileCoordsToNwSe: function(coords) {
        var map = this._map, tileSize = this.getTileSize(), nwPoint = coords.scaleBy(tileSize), sePoint = nwPoint.add(tileSize), nw = map.unproject(nwPoint, coords.z), se = map.unproject(sePoint, coords.z);
        return [
            nw,
            se
        ];
    },
    // converts tile coordinates to its geographical bounds
    _tileCoordsToBounds: function(coords) {
        var bp = this._tileCoordsToNwSe(coords), bounds = new (0, $c1a09dde0ebe0161$export$fe84d4076a55a8e6)(bp[0], bp[1]);
        if (!this.options.noWrap) bounds = this._map.wrapLatLngBounds(bounds);
        return bounds;
    },
    // converts tile coordinates to key for the tile cache
    _tileCoordsToKey: function(coords) {
        return coords.x + ":" + coords.y + ":" + coords.z;
    },
    // converts tile cache key to coordinates
    _keyToTileCoords: function(key) {
        var k = key.split(":"), coords = new (0, $b802e4aa6d666b45$export$baf26146a414f24a)(+k[0], +k[1]);
        coords.z = +k[2];
        return coords;
    },
    _removeTile: function(key) {
        var tile = this._tiles[key];
        if (!tile) return;
        $783b7cedd5fd919a$export$cd7f480d6b8286c3(tile.el);
        delete this._tiles[key];
        // @event tileunload: TileEvent
        // Fired when a tile is removed (e.g. when a tile goes off the screen).
        this.fire("tileunload", {
            tile: tile.el,
            coords: this._keyToTileCoords(key)
        });
    },
    _initTile: function(tile) {
        $783b7cedd5fd919a$export$d2cf6cd1dc7067d3(tile, "leaflet-tile");
        var tileSize = this.getTileSize();
        tile.style.width = tileSize.x + "px";
        tile.style.height = tileSize.y + "px";
        tile.onselectstart = $13bbd556cd7cee10$export$a3891e81a74c5e40;
        tile.onmousemove = $13bbd556cd7cee10$export$a3891e81a74c5e40;
        // update opacity on tiles in IE7-8 because of filter inheritance problems
        if ((0, $bda63d751c06734c$export$2e2bcd8739ae039).ielt9 && this.options.opacity < 1) $783b7cedd5fd919a$export$2646c6b151d2e8(tile, this.options.opacity);
    },
    _addTile: function(coords, container) {
        var tilePos = this._getTilePos(coords), key = this._tileCoordsToKey(coords);
        var tile = this.createTile(this._wrapCoords(coords), $13bbd556cd7cee10$export$2385a24977818dd0(this._tileReady, this, coords));
        this._initTile(tile);
        // if createTile is defined with a second argument ("done" callback),
        // we know that tile is async and will be ready later; otherwise
        if (this.createTile.length < 2) // mark tile as ready, but delay one frame for opacity animation to happen
        $13bbd556cd7cee10$export$d371ad015c199c06($13bbd556cd7cee10$export$2385a24977818dd0(this._tileReady, this, coords, null, tile));
        $783b7cedd5fd919a$export$f9b088a47202d605(tile, tilePos);
        // save tile in cache
        this._tiles[key] = {
            el: tile,
            coords: coords,
            current: true
        };
        container.appendChild(tile);
        // @event tileloadstart: TileEvent
        // Fired when a tile is requested and starts loading.
        this.fire("tileloadstart", {
            tile: tile,
            coords: coords
        });
    },
    _tileReady: function(coords, err, tile) {
        if (err) // @event tileerror: TileErrorEvent
        // Fired when there is an error loading a tile.
        this.fire("tileerror", {
            error: err,
            tile: tile,
            coords: coords
        });
        var key = this._tileCoordsToKey(coords);
        tile = this._tiles[key];
        if (!tile) return;
        tile.loaded = +new Date();
        if (this._map._fadeAnimated) {
            $783b7cedd5fd919a$export$2646c6b151d2e8(tile.el, 0);
            $13bbd556cd7cee10$export$e1ed83507f55dc9d(this._fadeFrame);
            this._fadeFrame = $13bbd556cd7cee10$export$d371ad015c199c06(this._updateOpacity, this);
        } else {
            tile.active = true;
            this._pruneTiles();
        }
        if (!err) {
            $783b7cedd5fd919a$export$d2cf6cd1dc7067d3(tile.el, "leaflet-tile-loaded");
            // @event tileload: TileEvent
            // Fired when a tile loads.
            this.fire("tileload", {
                tile: tile.el,
                coords: coords
            });
        }
        if (this._noTilesToLoad()) {
            this._loading = false;
            // @event load: Event
            // Fired when the grid layer loaded all visible tiles.
            this.fire("load");
            if ((0, $bda63d751c06734c$export$2e2bcd8739ae039).ielt9 || !this._map._fadeAnimated) $13bbd556cd7cee10$export$d371ad015c199c06(this._pruneTiles, this);
            else // Wait a bit more than 0.2 secs (the duration of the tile fade-in)
            // to trigger a pruning.
            setTimeout($13bbd556cd7cee10$export$2385a24977818dd0(this._pruneTiles, this), 250);
        }
    },
    _getTilePos: function(coords) {
        return coords.scaleBy(this.getTileSize()).subtract(this._level.origin);
    },
    _wrapCoords: function(coords) {
        var newCoords = new (0, $b802e4aa6d666b45$export$baf26146a414f24a)(this._wrapX ? $13bbd556cd7cee10$export$f6cd9682189b118b(coords.x, this._wrapX) : coords.x, this._wrapY ? $13bbd556cd7cee10$export$f6cd9682189b118b(coords.y, this._wrapY) : coords.y);
        newCoords.z = coords.z;
        return newCoords;
    },
    _pxBoundsToTileRange: function(bounds) {
        var tileSize = this.getTileSize();
        return new (0, $2ffe56518af276c5$export$c4e9d269599ab4b4)(bounds.min.unscaleBy(tileSize).floor(), bounds.max.unscaleBy(tileSize).ceil().subtract([
            1,
            1
        ]));
    },
    _noTilesToLoad: function() {
        for(var key in this._tiles){
            if (!this._tiles[key].loaded) return false;
        }
        return true;
    }
});
function $04d60fd755d1bee0$export$4d73234a74ff0ca3(options) {
    return new $04d60fd755d1bee0$export$3b2364b911db251c(options);
}







var $47ae5f26affe1e5e$export$f52ee31d61d0b27b = (0, $04d60fd755d1bee0$export$3b2364b911db251c).extend({
    // @section
    // @aka TileLayer options
    options: {
        // @option minZoom: Number = 0
        // The minimum zoom level down to which this layer will be displayed (inclusive).
        minZoom: 0,
        // @option maxZoom: Number = 18
        // The maximum zoom level up to which this layer will be displayed (inclusive).
        maxZoom: 18,
        // @option subdomains: String|String[] = 'abc'
        // Subdomains of the tile service. Can be passed in the form of one string (where each letter is a subdomain name) or an array of strings.
        subdomains: "abc",
        // @option errorTileUrl: String = ''
        // URL to the tile image to show in place of the tile that failed to load.
        errorTileUrl: "",
        // @option zoomOffset: Number = 0
        // The zoom number used in tile URLs will be offset with this value.
        zoomOffset: 0,
        // @option tms: Boolean = false
        // If `true`, inverses Y axis numbering for tiles (turn this on for [TMS](https://en.wikipedia.org/wiki/Tile_Map_Service) services).
        tms: false,
        // @option zoomReverse: Boolean = false
        // If set to true, the zoom number used in tile URLs will be reversed (`maxZoom - zoom` instead of `zoom`)
        zoomReverse: false,
        // @option detectRetina: Boolean = false
        // If `true` and user is on a retina display, it will request four tiles of half the specified size and a bigger zoom level in place of one to utilize the high resolution.
        detectRetina: false,
        // @option crossOrigin: Boolean|String = false
        // Whether the crossOrigin attribute will be added to the tiles.
        // If a String is provided, all tiles will have their crossOrigin attribute set to the String provided. This is needed if you want to access tile pixel data.
        // Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
        crossOrigin: false,
        // @option referrerPolicy: Boolean|String = false
        // Whether the referrerPolicy attribute will be added to the tiles.
        // If a String is provided, all tiles will have their referrerPolicy attribute set to the String provided.
        // This may be needed if your map's rendering context has a strict default but your tile provider expects a valid referrer
        // (e.g. to validate an API token).
        // Refer to [HTMLImageElement.referrerPolicy](https://developer.mozilla.org/en-US/docs/Web/API/HTMLImageElement/referrerPolicy) for valid String values.
        referrerPolicy: false
    },
    initialize: function(url, options) {
        this._url = url;
        options = $13bbd556cd7cee10$export$add91eafeaeab287(this, options);
        // detecting retina displays, adjusting tileSize and zoom levels
        if (options.detectRetina && (0, $bda63d751c06734c$export$2e2bcd8739ae039).retina && options.maxZoom > 0) {
            options.tileSize = Math.floor(options.tileSize / 2);
            if (!options.zoomReverse) {
                options.zoomOffset++;
                options.maxZoom = Math.max(options.minZoom, options.maxZoom - 1);
            } else {
                options.zoomOffset--;
                options.minZoom = Math.min(options.maxZoom, options.minZoom + 1);
            }
            options.minZoom = Math.max(0, options.minZoom);
        } else if (!options.zoomReverse) // make sure maxZoom is gte minZoom
        options.maxZoom = Math.max(options.minZoom, options.maxZoom);
        else // make sure minZoom is lte maxZoom
        options.minZoom = Math.min(options.maxZoom, options.minZoom);
        if (typeof options.subdomains === "string") options.subdomains = options.subdomains.split("");
        this.on("tileunload", this._onTileRemove);
    },
    // @method setUrl(url: String, noRedraw?: Boolean): this
    // Updates the layer's URL template and redraws it (unless `noRedraw` is set to `true`).
    // If the URL does not change, the layer will not be redrawn unless
    // the noRedraw parameter is set to false.
    setUrl: function(url, noRedraw) {
        if (this._url === url && noRedraw === undefined) noRedraw = true;
        this._url = url;
        if (!noRedraw) this.redraw();
        return this;
    },
    // @method createTile(coords: Object, done?: Function): HTMLElement
    // Called only internally, overrides GridLayer's [`createTile()`](#gridlayer-createtile)
    // to return an `<img>` HTML element with the appropriate image URL given `coords`. The `done`
    // callback is called when the tile has been loaded.
    createTile: function(coords, done) {
        var tile = document.createElement("img");
        $2148974bfeaf2ac1$export$af631764ddc44097(tile, "load", $13bbd556cd7cee10$export$2385a24977818dd0(this._tileOnLoad, this, done, tile));
        $2148974bfeaf2ac1$export$af631764ddc44097(tile, "error", $13bbd556cd7cee10$export$2385a24977818dd0(this._tileOnError, this, done, tile));
        if (this.options.crossOrigin || this.options.crossOrigin === "") tile.crossOrigin = this.options.crossOrigin === true ? "" : this.options.crossOrigin;
        // for this new option we follow the documented behavior
        // more closely by only setting the property when string
        if (typeof this.options.referrerPolicy === "string") tile.referrerPolicy = this.options.referrerPolicy;
        // The alt attribute is set to the empty string,
        // allowing screen readers to ignore the decorative image tiles.
        // https://www.w3.org/WAI/tutorials/images/decorative/
        // https://www.w3.org/TR/html-aria/#el-img-empty-alt
        tile.alt = "";
        tile.src = this.getTileUrl(coords);
        return tile;
    },
    // @section Extension methods
    // @uninheritable
    // Layers extending `TileLayer` might reimplement the following method.
    // @method getTileUrl(coords: Object): String
    // Called only internally, returns the URL for a tile given its coordinates.
    // Classes extending `TileLayer` can override this function to provide custom tile URL naming schemes.
    getTileUrl: function(coords) {
        var data = {
            r: (0, $bda63d751c06734c$export$2e2bcd8739ae039).retina ? "@2x" : "",
            s: this._getSubdomain(coords),
            x: coords.x,
            y: coords.y,
            z: this._getZoomForUrl()
        };
        if (this._map && !this._map.options.crs.infinite) {
            var invertedY = this._globalTileRange.max.y - coords.y;
            if (this.options.tms) data["y"] = invertedY;
            data["-y"] = invertedY;
        }
        return $13bbd556cd7cee10$export$ce69bd05624d0c48(this._url, $13bbd556cd7cee10$export$8b58be045bf06082(data, this.options));
    },
    _tileOnLoad: function(done, tile) {
        // For https://github.com/Leaflet/Leaflet/issues/3332
        if ((0, $bda63d751c06734c$export$2e2bcd8739ae039).ielt9) setTimeout($13bbd556cd7cee10$export$2385a24977818dd0(done, this, null, tile), 0);
        else done(null, tile);
    },
    _tileOnError: function(done, tile, e) {
        var errorUrl = this.options.errorTileUrl;
        if (errorUrl && tile.getAttribute("src") !== errorUrl) tile.src = errorUrl;
        done(e, tile);
    },
    _onTileRemove: function(e) {
        e.tile.onload = null;
    },
    _getZoomForUrl: function() {
        var zoom = this._tileZoom, maxZoom = this.options.maxZoom, zoomReverse = this.options.zoomReverse, zoomOffset = this.options.zoomOffset;
        if (zoomReverse) zoom = maxZoom - zoom;
        return zoom + zoomOffset;
    },
    _getSubdomain: function(tilePoint) {
        var index = Math.abs(tilePoint.x + tilePoint.y) % this.options.subdomains.length;
        return this.options.subdomains[index];
    },
    // stops loading all tiles in the background layer
    _abortLoading: function() {
        var i, tile;
        for(i in this._tiles)if (this._tiles[i].coords.z !== this._tileZoom) {
            tile = this._tiles[i].el;
            tile.onload = $13bbd556cd7cee10$export$a3891e81a74c5e40;
            tile.onerror = $13bbd556cd7cee10$export$a3891e81a74c5e40;
            if (!tile.complete) {
                tile.src = $13bbd556cd7cee10$export$993f7e5c731d5268;
                var coords = this._tiles[i].coords;
                $783b7cedd5fd919a$export$cd7f480d6b8286c3(tile);
                delete this._tiles[i];
                // @event tileabort: TileEvent
                // Fired when a tile was loading but is now not wanted.
                this.fire("tileabort", {
                    tile: tile,
                    coords: coords
                });
            }
        }
    },
    _removeTile: function(key) {
        var tile = this._tiles[key];
        if (!tile) return;
        // Cancels any pending http requests associated with the tile
        tile.el.setAttribute("src", $13bbd556cd7cee10$export$993f7e5c731d5268);
        return (0, $04d60fd755d1bee0$export$3b2364b911db251c).prototype._removeTile.call(this, key);
    },
    _tileReady: function(coords, err, tile) {
        if (!this._map || tile && tile.getAttribute("src") === $13bbd556cd7cee10$export$993f7e5c731d5268) return;
        return (0, $04d60fd755d1bee0$export$3b2364b911db251c).prototype._tileReady.call(this, coords, err, tile);
    }
});
function $47ae5f26affe1e5e$export$be2e48cfdc7506da(url, options) {
    return new $47ae5f26affe1e5e$export$f52ee31d61d0b27b(url, options);
}







var $23a9dae13ec139df$export$c504b28c0d56fb0a = (0, $47ae5f26affe1e5e$export$f52ee31d61d0b27b).extend({
    // @section
    // @aka TileLayer.WMS options
    // If any custom options not documented here are used, they will be sent to the
    // WMS server as extra parameters in each request URL. This can be useful for
    // [non-standard vendor WMS parameters](https://docs.geoserver.org/stable/en/user/services/wms/vendor.html).
    defaultWmsParams: {
        service: "WMS",
        request: "GetMap",
        // @option layers: String = ''
        // **(required)** Comma-separated list of WMS layers to show.
        layers: "",
        // @option styles: String = ''
        // Comma-separated list of WMS styles.
        styles: "",
        // @option format: String = 'image/jpeg'
        // WMS image format (use `'image/png'` for layers with transparency).
        format: "image/jpeg",
        // @option transparent: Boolean = false
        // If `true`, the WMS service will return images with transparency.
        transparent: false,
        // @option version: String = '1.1.1'
        // Version of the WMS service to use
        version: "1.1.1"
    },
    options: {
        // @option crs: CRS = null
        // Coordinate Reference System to use for the WMS requests, defaults to
        // map CRS. Don't change this if you're not sure what it means.
        crs: null,
        // @option uppercase: Boolean = false
        // If `true`, WMS request parameter keys will be uppercase.
        uppercase: false
    },
    initialize: function(url, options) {
        this._url = url;
        var wmsParams = (0, $13bbd556cd7cee10$export$8b58be045bf06082)({}, this.defaultWmsParams);
        // all keys that are not TileLayer options go to WMS params
        for(var i in options)if (!(i in this.options)) wmsParams[i] = options[i];
        options = (0, $13bbd556cd7cee10$export$add91eafeaeab287)(this, options);
        var realRetina = options.detectRetina && (0, $bda63d751c06734c$export$2e2bcd8739ae039).retina ? 2 : 1;
        var tileSize = this.getTileSize();
        wmsParams.width = tileSize.x * realRetina;
        wmsParams.height = tileSize.y * realRetina;
        this.wmsParams = wmsParams;
    },
    onAdd: function(map) {
        this._crs = this.options.crs || map.options.crs;
        this._wmsVersion = parseFloat(this.wmsParams.version);
        var projectionKey = this._wmsVersion >= 1.3 ? "crs" : "srs";
        this.wmsParams[projectionKey] = this._crs.code;
        (0, $47ae5f26affe1e5e$export$f52ee31d61d0b27b).prototype.onAdd.call(this, map);
    },
    getTileUrl: function(coords) {
        var tileBounds = this._tileCoordsToNwSe(coords), crs = this._crs, bounds = (0, $2ffe56518af276c5$export$c8e2f7c8aba65b28)(crs.project(tileBounds[0]), crs.project(tileBounds[1])), min = bounds.min, max = bounds.max, bbox = (this._wmsVersion >= 1.3 && this._crs === (0, $8b371d276c86fbe0$export$6e6fafcc50e60294) ? [
            min.y,
            min.x,
            max.y,
            max.x
        ] : [
            min.x,
            min.y,
            max.x,
            max.y
        ]).join(","), url = (0, $47ae5f26affe1e5e$export$f52ee31d61d0b27b).prototype.getTileUrl.call(this, coords);
        return url + (0, $13bbd556cd7cee10$export$27213b73b2075e98)(this.wmsParams, url, this.options.uppercase) + (this.options.uppercase ? "&BBOX=" : "&bbox=") + bbox;
    },
    // @method setParams(params: Object, noRedraw?: Boolean): this
    // Merges an object with the new parameters and re-requests tiles on the current screen (unless `noRedraw` was set to true).
    setParams: function(params, noRedraw) {
        (0, $13bbd556cd7cee10$export$8b58be045bf06082)(this.wmsParams, params);
        if (!noRedraw) this.redraw();
        return this;
    }
});
function $23a9dae13ec139df$export$4d01959a250b9387(url, options) {
    return new $23a9dae13ec139df$export$c504b28c0d56fb0a(url, options);
}


(0, $47ae5f26affe1e5e$export$f52ee31d61d0b27b).WMS = (0, $23a9dae13ec139df$export$c504b28c0d56fb0a);
(0, $47ae5f26affe1e5e$export$be2e48cfdc7506da).wms = (0, $23a9dae13ec139df$export$4d01959a250b9387);







var $6aa432fb4898fef4$export$88530751e3977073 = (0, $3219933a0a8d4dcc$export$936d0764594b6eb3).extend({
    // @section
    // @aka Renderer options
    options: {
        // @option padding: Number = 0.1
        // How much to extend the clip area around the map view (relative to its size)
        // e.g. 0.1 would be 10% of map view in each direction
        padding: 0.1
    },
    initialize: function(options) {
        $13bbd556cd7cee10$export$add91eafeaeab287(this, options);
        $13bbd556cd7cee10$export$bd3fba034e28f6b(this);
        this._layers = this._layers || {};
    },
    onAdd: function() {
        if (!this._container) {
            this._initContainer(); // defined by renderer implementations
            // always keep transform-origin as 0 0
            $783b7cedd5fd919a$export$d2cf6cd1dc7067d3(this._container, "leaflet-zoom-animated");
        }
        this.getPane().appendChild(this._container);
        this._update();
        this.on("update", this._updatePaths, this);
    },
    onRemove: function() {
        this.off("update", this._updatePaths, this);
        this._destroyContainer();
    },
    getEvents: function() {
        var events = {
            viewreset: this._reset,
            zoom: this._onZoom,
            moveend: this._update,
            zoomend: this._onZoomEnd
        };
        if (this._zoomAnimated) events.zoomanim = this._onAnimZoom;
        return events;
    },
    _onAnimZoom: function(ev) {
        this._updateTransform(ev.center, ev.zoom);
    },
    _onZoom: function() {
        this._updateTransform(this._map.getCenter(), this._map.getZoom());
    },
    _updateTransform: function(center, zoom) {
        var scale = this._map.getZoomScale(zoom, this._zoom), viewHalf = this._map.getSize().multiplyBy(0.5 + this.options.padding), currentCenterPoint = this._map.project(this._center, zoom), topLeftOffset = viewHalf.multiplyBy(-scale).add(currentCenterPoint).subtract(this._map._getNewPixelOrigin(center, zoom));
        if ((0, $bda63d751c06734c$export$2e2bcd8739ae039).any3d) $783b7cedd5fd919a$export$ff09356c35bee89b(this._container, topLeftOffset, scale);
        else $783b7cedd5fd919a$export$f9b088a47202d605(this._container, topLeftOffset);
    },
    _reset: function() {
        this._update();
        this._updateTransform(this._center, this._zoom);
        for(var id in this._layers)this._layers[id]._reset();
    },
    _onZoomEnd: function() {
        for(var id in this._layers)this._layers[id]._project();
    },
    _updatePaths: function() {
        for(var id in this._layers)this._layers[id]._update();
    },
    _update: function() {
        // Update pixel bounds of renderer container (for positioning/sizing/clipping later)
        // Subclasses are responsible of firing the 'update' event.
        var p = this.options.padding, size = this._map.getSize(), min = this._map.containerPointToLayerPoint(size.multiplyBy(-p)).round();
        this._bounds = new (0, $2ffe56518af276c5$export$c4e9d269599ab4b4)(min, min.add(size.multiplyBy(1 + p * 2)).round());
        this._center = this._map.getCenter();
        this._zoom = this._map.getZoom();
    }
});








var $eadac394fba7163b$export$8d01c972ee8b14a9 = (0, $6aa432fb4898fef4$export$88530751e3977073).extend({
    // @section
    // @aka Canvas options
    options: {
        // @option tolerance: Number = 0
        // How much to extend the click tolerance around a path/object on the map.
        tolerance: 0
    },
    getEvents: function() {
        var events = (0, $6aa432fb4898fef4$export$88530751e3977073).prototype.getEvents.call(this);
        events.viewprereset = this._onViewPreReset;
        return events;
    },
    _onViewPreReset: function() {
        // Set a flag so that a viewprereset+moveend+viewreset only updates&redraws once
        this._postponeUpdatePaths = true;
    },
    onAdd: function() {
        (0, $6aa432fb4898fef4$export$88530751e3977073).prototype.onAdd.call(this);
        // Redraw vectors since canvas is cleared upon removal,
        // in case of removing the renderer itself from the map.
        this._draw();
    },
    _initContainer: function() {
        var container = this._container = document.createElement("canvas");
        $2148974bfeaf2ac1$export$af631764ddc44097(container, "mousemove", this._onMouseMove, this);
        $2148974bfeaf2ac1$export$af631764ddc44097(container, "click dblclick mousedown mouseup contextmenu", this._onClick, this);
        $2148974bfeaf2ac1$export$af631764ddc44097(container, "mouseout", this._handleMouseOut, this);
        container["_leaflet_disable_events"] = true;
        this._ctx = container.getContext("2d");
    },
    _destroyContainer: function() {
        $13bbd556cd7cee10$export$e1ed83507f55dc9d(this._redrawRequest);
        delete this._ctx;
        $783b7cedd5fd919a$export$cd7f480d6b8286c3(this._container);
        $2148974bfeaf2ac1$export$8c8705df4a2dcec9(this._container);
        delete this._container;
    },
    _updatePaths: function() {
        if (this._postponeUpdatePaths) return;
        var layer;
        this._redrawBounds = null;
        for(var id in this._layers){
            layer = this._layers[id];
            layer._update();
        }
        this._redraw();
    },
    _update: function() {
        if (this._map._animatingZoom && this._bounds) return;
        (0, $6aa432fb4898fef4$export$88530751e3977073).prototype._update.call(this);
        var b = this._bounds, container = this._container, size = b.getSize(), m = (0, $bda63d751c06734c$export$2e2bcd8739ae039).retina ? 2 : 1;
        $783b7cedd5fd919a$export$f9b088a47202d605(container, b.min);
        // set canvas size (also clearing it); use double size on retina
        container.width = m * size.x;
        container.height = m * size.y;
        container.style.width = size.x + "px";
        container.style.height = size.y + "px";
        if ((0, $bda63d751c06734c$export$2e2bcd8739ae039).retina) this._ctx.scale(2, 2);
        // translate so we use the same path coordinates after canvas element moves
        this._ctx.translate(-b.min.x, -b.min.y);
        // Tell paths to redraw themselves
        this.fire("update");
    },
    _reset: function() {
        (0, $6aa432fb4898fef4$export$88530751e3977073).prototype._reset.call(this);
        if (this._postponeUpdatePaths) {
            this._postponeUpdatePaths = false;
            this._updatePaths();
        }
    },
    _initPath: function(layer) {
        this._updateDashArray(layer);
        this._layers[$13bbd556cd7cee10$export$bd3fba034e28f6b(layer)] = layer;
        var order = layer._order = {
            layer: layer,
            prev: this._drawLast,
            next: null
        };
        if (this._drawLast) this._drawLast.next = order;
        this._drawLast = order;
        this._drawFirst = this._drawFirst || this._drawLast;
    },
    _addPath: function(layer) {
        this._requestRedraw(layer);
    },
    _removePath: function(layer) {
        var order = layer._order;
        var next = order.next;
        var prev = order.prev;
        if (next) next.prev = prev;
        else this._drawLast = prev;
        if (prev) prev.next = next;
        else this._drawFirst = next;
        delete layer._order;
        delete this._layers[$13bbd556cd7cee10$export$bd3fba034e28f6b(layer)];
        this._requestRedraw(layer);
    },
    _updatePath: function(layer) {
        // Redraw the union of the layer's old pixel
        // bounds and the new pixel bounds.
        this._extendRedrawBounds(layer);
        layer._project();
        layer._update();
        // The redraw will extend the redraw bounds
        // with the new pixel bounds.
        this._requestRedraw(layer);
    },
    _updateStyle: function(layer) {
        this._updateDashArray(layer);
        this._requestRedraw(layer);
    },
    _updateDashArray: function(layer) {
        if (typeof layer.options.dashArray === "string") {
            var parts = layer.options.dashArray.split(/[, ]+/), dashArray = [], dashValue, i;
            for(i = 0; i < parts.length; i++){
                dashValue = Number(parts[i]);
                // Ignore dash array containing invalid lengths
                if (isNaN(dashValue)) return;
                dashArray.push(dashValue);
            }
            layer.options._dashArray = dashArray;
        } else layer.options._dashArray = layer.options.dashArray;
    },
    _requestRedraw: function(layer) {
        if (!this._map) return;
        this._extendRedrawBounds(layer);
        this._redrawRequest = this._redrawRequest || $13bbd556cd7cee10$export$d371ad015c199c06(this._redraw, this);
    },
    _extendRedrawBounds: function(layer) {
        if (layer._pxBounds) {
            var padding = (layer.options.weight || 0) + 1;
            this._redrawBounds = this._redrawBounds || new (0, $2ffe56518af276c5$export$c4e9d269599ab4b4)();
            this._redrawBounds.extend(layer._pxBounds.min.subtract([
                padding,
                padding
            ]));
            this._redrawBounds.extend(layer._pxBounds.max.add([
                padding,
                padding
            ]));
        }
    },
    _redraw: function() {
        this._redrawRequest = null;
        if (this._redrawBounds) {
            this._redrawBounds.min._floor();
            this._redrawBounds.max._ceil();
        }
        this._clear(); // clear layers in redraw bounds
        this._draw(); // draw layers
        this._redrawBounds = null;
    },
    _clear: function() {
        var bounds = this._redrawBounds;
        if (bounds) {
            var size = bounds.getSize();
            this._ctx.clearRect(bounds.min.x, bounds.min.y, size.x, size.y);
        } else {
            this._ctx.save();
            this._ctx.setTransform(1, 0, 0, 1, 0, 0);
            this._ctx.clearRect(0, 0, this._container.width, this._container.height);
            this._ctx.restore();
        }
    },
    _draw: function() {
        var layer, bounds = this._redrawBounds;
        this._ctx.save();
        if (bounds) {
            var size = bounds.getSize();
            this._ctx.beginPath();
            this._ctx.rect(bounds.min.x, bounds.min.y, size.x, size.y);
            this._ctx.clip();
        }
        this._drawing = true;
        for(var order = this._drawFirst; order; order = order.next){
            layer = order.layer;
            if (!bounds || layer._pxBounds && layer._pxBounds.intersects(bounds)) layer._updatePath();
        }
        this._drawing = false;
        this._ctx.restore(); // Restore state before clipping.
    },
    _updatePoly: function(layer, closed) {
        if (!this._drawing) return;
        var i, j, len2, p, parts = layer._parts, len = parts.length, ctx = this._ctx;
        if (!len) return;
        ctx.beginPath();
        for(i = 0; i < len; i++){
            for(j = 0, len2 = parts[i].length; j < len2; j++){
                p = parts[i][j];
                ctx[j ? "lineTo" : "moveTo"](p.x, p.y);
            }
            if (closed) ctx.closePath();
        }
        this._fillStroke(ctx, layer);
    // TODO optimization: 1 fill/stroke for all features with equal style instead of 1 for each feature
    },
    _updateCircle: function(layer) {
        if (!this._drawing || layer._empty()) return;
        var p = layer._point, ctx = this._ctx, r = Math.max(Math.round(layer._radius), 1), s = (Math.max(Math.round(layer._radiusY), 1) || r) / r;
        if (s !== 1) {
            ctx.save();
            ctx.scale(1, s);
        }
        ctx.beginPath();
        ctx.arc(p.x, p.y / s, r, 0, Math.PI * 2, false);
        if (s !== 1) ctx.restore();
        this._fillStroke(ctx, layer);
    },
    _fillStroke: function(ctx, layer) {
        var options = layer.options;
        if (options.fill) {
            ctx.globalAlpha = options.fillOpacity;
            ctx.fillStyle = options.fillColor || options.color;
            ctx.fill(options.fillRule || "evenodd");
        }
        if (options.stroke && options.weight !== 0) {
            if (ctx.setLineDash) ctx.setLineDash(layer.options && layer.options._dashArray || []);
            ctx.globalAlpha = options.opacity;
            ctx.lineWidth = options.weight;
            ctx.strokeStyle = options.color;
            ctx.lineCap = options.lineCap;
            ctx.lineJoin = options.lineJoin;
            ctx.stroke();
        }
    },
    // Canvas obviously doesn't have mouse events for individual drawn objects,
    // so we emulate that by calculating what's under the mouse on mousemove/click manually
    _onClick: function(e) {
        var point = this._map.mouseEventToLayerPoint(e), layer, clickedLayer;
        for(var order = this._drawFirst; order; order = order.next){
            layer = order.layer;
            if (layer.options.interactive && layer._containsPoint(point)) {
                if (!(e.type === "click" || e.type === "preclick") || !this._map._draggableMoved(layer)) clickedLayer = layer;
            }
        }
        this._fireEvent(clickedLayer ? [
            clickedLayer
        ] : false, e);
    },
    _onMouseMove: function(e) {
        if (!this._map || this._map.dragging.moving() || this._map._animatingZoom) return;
        var point = this._map.mouseEventToLayerPoint(e);
        this._handleMouseHover(e, point);
    },
    _handleMouseOut: function(e) {
        var layer = this._hoveredLayer;
        if (layer) {
            // if we're leaving the layer, fire mouseout
            $783b7cedd5fd919a$export$c2255604a80b4506(this._container, "leaflet-interactive");
            this._fireEvent([
                layer
            ], e, "mouseout");
            this._hoveredLayer = null;
            this._mouseHoverThrottled = false;
        }
    },
    _handleMouseHover: function(e, point) {
        if (this._mouseHoverThrottled) return;
        var layer, candidateHoveredLayer;
        for(var order = this._drawFirst; order; order = order.next){
            layer = order.layer;
            if (layer.options.interactive && layer._containsPoint(point)) candidateHoveredLayer = layer;
        }
        if (candidateHoveredLayer !== this._hoveredLayer) {
            this._handleMouseOut(e);
            if (candidateHoveredLayer) {
                $783b7cedd5fd919a$export$d2cf6cd1dc7067d3(this._container, "leaflet-interactive"); // change cursor
                this._fireEvent([
                    candidateHoveredLayer
                ], e, "mouseover");
                this._hoveredLayer = candidateHoveredLayer;
            }
        }
        this._fireEvent(this._hoveredLayer ? [
            this._hoveredLayer
        ] : false, e);
        this._mouseHoverThrottled = true;
        setTimeout($13bbd556cd7cee10$export$2385a24977818dd0(function() {
            this._mouseHoverThrottled = false;
        }, this), 32);
    },
    _fireEvent: function(layers, e, type) {
        this._map._fireDOMEvent(e, type || e.type, layers);
    },
    _bringToFront: function(layer) {
        var order = layer._order;
        if (!order) return;
        var next = order.next;
        var prev = order.prev;
        if (next) next.prev = prev;
        else // Already last
        return;
        if (prev) prev.next = next;
        else if (next) // Update first entry unless this is the
        // single entry
        this._drawFirst = next;
        order.prev = this._drawLast;
        this._drawLast.next = order;
        order.next = null;
        this._drawLast = order;
        this._requestRedraw(layer);
    },
    _bringToBack: function(layer) {
        var order = layer._order;
        if (!order) return;
        var next = order.next;
        var prev = order.prev;
        if (prev) prev.next = next;
        else // Already first
        return;
        if (next) next.prev = prev;
        else if (prev) // Update last entry unless this is the
        // single entry
        this._drawLast = prev;
        order.prev = null;
        order.next = this._drawFirst;
        this._drawFirst.prev = order;
        this._drawFirst = order;
        this._requestRedraw(layer);
    }
});
function $eadac394fba7163b$export$67ea982130081db(options) {
    return (0, $bda63d751c06734c$export$2e2bcd8739ae039).canvas ? new $eadac394fba7163b$export$8d01c972ee8b14a9(options) : null;
}











var $30302d4c97c7cad4$export$8077df4875198090 = function() {
    try {
        document.namespaces.add("lvml", "urn:schemas-microsoft-com:vml");
        return function(name) {
            return document.createElement("<lvml:" + name + ' class="lvml">');
        };
    } catch (e) {
    // Do not return fn from catch block so `e` can be garbage collected
    // See https://github.com/Leaflet/Leaflet/pull/7279
    }
    return function(name) {
        return document.createElement("<" + name + ' xmlns="urn:schemas-microsoft.com:vml" class="lvml">');
    };
}();
var $30302d4c97c7cad4$export$7bb6ae0c8f2e3b88 = {
    _initContainer: function() {
        this._container = $783b7cedd5fd919a$export$185802fd694ee1f5("div", "leaflet-vml-container");
    },
    _update: function() {
        if (this._map._animatingZoom) return;
        (0, $6aa432fb4898fef4$export$88530751e3977073).prototype._update.call(this);
        this.fire("update");
    },
    _initPath: function(layer) {
        var container = layer._container = $30302d4c97c7cad4$export$8077df4875198090("shape");
        $783b7cedd5fd919a$export$d2cf6cd1dc7067d3(container, "leaflet-vml-shape " + (this.options.className || ""));
        container.coordsize = "1 1";
        layer._path = $30302d4c97c7cad4$export$8077df4875198090("path");
        container.appendChild(layer._path);
        this._updateStyle(layer);
        this._layers[$13bbd556cd7cee10$export$bd3fba034e28f6b(layer)] = layer;
    },
    _addPath: function(layer) {
        var container = layer._container;
        this._container.appendChild(container);
        if (layer.options.interactive) layer.addInteractiveTarget(container);
    },
    _removePath: function(layer) {
        var container = layer._container;
        $783b7cedd5fd919a$export$cd7f480d6b8286c3(container);
        layer.removeInteractiveTarget(container);
        delete this._layers[$13bbd556cd7cee10$export$bd3fba034e28f6b(layer)];
    },
    _updateStyle: function(layer) {
        var stroke = layer._stroke, fill = layer._fill, options = layer.options, container = layer._container;
        container.stroked = !!options.stroke;
        container.filled = !!options.fill;
        if (options.stroke) {
            if (!stroke) stroke = layer._stroke = $30302d4c97c7cad4$export$8077df4875198090("stroke");
            container.appendChild(stroke);
            stroke.weight = options.weight + "px";
            stroke.color = options.color;
            stroke.opacity = options.opacity;
            if (options.dashArray) stroke.dashStyle = $13bbd556cd7cee10$export$43bee75e5e14138e(options.dashArray) ? options.dashArray.join(" ") : options.dashArray.replace(/( *, *)/g, " ");
            else stroke.dashStyle = "";
            stroke.endcap = options.lineCap.replace("butt", "flat");
            stroke.joinstyle = options.lineJoin;
        } else if (stroke) {
            container.removeChild(stroke);
            layer._stroke = null;
        }
        if (options.fill) {
            if (!fill) fill = layer._fill = $30302d4c97c7cad4$export$8077df4875198090("fill");
            container.appendChild(fill);
            fill.color = options.fillColor || options.color;
            fill.opacity = options.fillOpacity;
        } else if (fill) {
            container.removeChild(fill);
            layer._fill = null;
        }
    },
    _updateCircle: function(layer) {
        var p = layer._point.round(), r = Math.round(layer._radius), r2 = Math.round(layer._radiusY || r);
        this._setPath(layer, layer._empty() ? "M0 0" : "AL " + p.x + "," + p.y + " " + r + "," + r2 + " 0," + 23592600);
    },
    _setPath: function(layer, path) {
        layer._path.v = path;
    },
    _bringToFront: function(layer) {
        $783b7cedd5fd919a$export$967ea9e64a77dad2(layer._container);
    },
    _bringToBack: function(layer) {
        $783b7cedd5fd919a$export$4d34781508fd70d9(layer._container);
    }
};


var $bc2c95f9ce01d02f$export$185802fd694ee1f5 = (0, $bda63d751c06734c$export$2e2bcd8739ae039).vml ? (0, $30302d4c97c7cad4$export$8077df4875198090) : (0, $4a933da72d3faae5$export$9d9648f1590c5e1);
var $bc2c95f9ce01d02f$export$13f4b12aafeba5d6 = (0, $6aa432fb4898fef4$export$88530751e3977073).extend({
    _initContainer: function() {
        this._container = $bc2c95f9ce01d02f$export$185802fd694ee1f5("svg");
        // makes it possible to click through svg root; we'll reset it back in individual paths
        this._container.setAttribute("pointer-events", "none");
        this._rootGroup = $bc2c95f9ce01d02f$export$185802fd694ee1f5("g");
        this._container.appendChild(this._rootGroup);
    },
    _destroyContainer: function() {
        $783b7cedd5fd919a$export$cd7f480d6b8286c3(this._container);
        $2148974bfeaf2ac1$export$8c8705df4a2dcec9(this._container);
        delete this._container;
        delete this._rootGroup;
        delete this._svgSize;
    },
    _update: function() {
        if (this._map._animatingZoom && this._bounds) return;
        (0, $6aa432fb4898fef4$export$88530751e3977073).prototype._update.call(this);
        var b = this._bounds, size = b.getSize(), container = this._container;
        // set size of svg-container if changed
        if (!this._svgSize || !this._svgSize.equals(size)) {
            this._svgSize = size;
            container.setAttribute("width", size.x);
            container.setAttribute("height", size.y);
        }
        // movement: update container viewBox so that we don't have to change coordinates of individual layers
        $783b7cedd5fd919a$export$f9b088a47202d605(container, b.min);
        container.setAttribute("viewBox", [
            b.min.x,
            b.min.y,
            size.x,
            size.y
        ].join(" "));
        this.fire("update");
    },
    // methods below are called by vector layers implementations
    _initPath: function(layer) {
        var path = layer._path = $bc2c95f9ce01d02f$export$185802fd694ee1f5("path");
        // @namespace Path
        // @option className: String = null
        // Custom class name set on an element. Only for SVG renderer.
        if (layer.options.className) $783b7cedd5fd919a$export$d2cf6cd1dc7067d3(path, layer.options.className);
        if (layer.options.interactive) $783b7cedd5fd919a$export$d2cf6cd1dc7067d3(path, "leaflet-interactive");
        this._updateStyle(layer);
        this._layers[(0, $13bbd556cd7cee10$export$bd3fba034e28f6b)(layer)] = layer;
    },
    _addPath: function(layer) {
        if (!this._rootGroup) this._initContainer();
        this._rootGroup.appendChild(layer._path);
        layer.addInteractiveTarget(layer._path);
    },
    _removePath: function(layer) {
        $783b7cedd5fd919a$export$cd7f480d6b8286c3(layer._path);
        layer.removeInteractiveTarget(layer._path);
        delete this._layers[(0, $13bbd556cd7cee10$export$bd3fba034e28f6b)(layer)];
    },
    _updatePath: function(layer) {
        layer._project();
        layer._update();
    },
    _updateStyle: function(layer) {
        var path = layer._path, options = layer.options;
        if (!path) return;
        if (options.stroke) {
            path.setAttribute("stroke", options.color);
            path.setAttribute("stroke-opacity", options.opacity);
            path.setAttribute("stroke-width", options.weight);
            path.setAttribute("stroke-linecap", options.lineCap);
            path.setAttribute("stroke-linejoin", options.lineJoin);
            if (options.dashArray) path.setAttribute("stroke-dasharray", options.dashArray);
            else path.removeAttribute("stroke-dasharray");
            if (options.dashOffset) path.setAttribute("stroke-dashoffset", options.dashOffset);
            else path.removeAttribute("stroke-dashoffset");
        } else path.setAttribute("stroke", "none");
        if (options.fill) {
            path.setAttribute("fill", options.fillColor || options.color);
            path.setAttribute("fill-opacity", options.fillOpacity);
            path.setAttribute("fill-rule", options.fillRule || "evenodd");
        } else path.setAttribute("fill", "none");
    },
    _updatePoly: function(layer, closed) {
        this._setPath(layer, (0, $4a933da72d3faae5$export$bc863495a5f10ca1)(layer._parts, closed));
    },
    _updateCircle: function(layer) {
        var p = layer._point, r = Math.max(Math.round(layer._radius), 1), r2 = Math.max(Math.round(layer._radiusY), 1) || r, arc = "a" + r + "," + r2 + " 0 1,0 ";
        // drawing a circle with two half-arcs
        var d = layer._empty() ? "M0 0" : "M" + (p.x - r) + "," + p.y + arc + r * 2 + ",0 " + arc + -r * 2 + ",0 ";
        this._setPath(layer, d);
    },
    _setPath: function(layer, path) {
        layer._path.setAttribute("d", path);
    },
    // SVG does not have the concept of zIndex so we resort to changing the DOM order of elements
    _bringToFront: function(layer) {
        $783b7cedd5fd919a$export$967ea9e64a77dad2(layer._path);
    },
    _bringToBack: function(layer) {
        $783b7cedd5fd919a$export$4d34781508fd70d9(layer._path);
    }
});
if ((0, $bda63d751c06734c$export$2e2bcd8739ae039).vml) $bc2c95f9ce01d02f$export$13f4b12aafeba5d6.include((0, $30302d4c97c7cad4$export$7bb6ae0c8f2e3b88));
function $bc2c95f9ce01d02f$export$7ed1367e7fa1ad68(options) {
    return (0, $bda63d751c06734c$export$2e2bcd8739ae039).svg || (0, $bda63d751c06734c$export$2e2bcd8739ae039).vml ? new $bc2c95f9ce01d02f$export$13f4b12aafeba5d6(options) : null;
}





(0, $7d9a54c6488daf4f$export$a5c7b93649eaf8f8).include({
    // @namespace Map; @method getRenderer(layer: Path): Renderer
    // Returns the instance of `Renderer` that should be used to render the given
    // `Path`. It will ensure that the `renderer` options of the map and paths
    // are respected, and that the renderers do exist on the map.
    getRenderer: function(layer) {
        // @namespace Path; @option renderer: Renderer
        // Use this specific instance of `Renderer` for this path. Takes
        // precedence over the map's [default renderer](#map-renderer).
        var renderer = layer.options.renderer || this._getPaneRenderer(layer.options.pane) || this.options.renderer || this._renderer;
        if (!renderer) renderer = this._renderer = this._createRenderer();
        if (!this.hasLayer(renderer)) this.addLayer(renderer);
        return renderer;
    },
    _getPaneRenderer: function(name) {
        if (name === "overlayPane" || name === undefined) return false;
        var renderer = this._paneRenderers[name];
        if (renderer === undefined) {
            renderer = this._createRenderer({
                pane: name
            });
            this._paneRenderers[name] = renderer;
        }
        return renderer;
    },
    _createRenderer: function(options) {
        // @namespace Map; @option preferCanvas: Boolean = false
        // Whether `Path`s should be rendered on a `Canvas` renderer.
        // By default, all `Path`s are rendered in a `SVG` renderer.
        return this.options.preferCanvas && (0, $eadac394fba7163b$export$67ea982130081db)(options) || (0, $bc2c95f9ce01d02f$export$7ed1367e7fa1ad68)(options);
    }
});









var $237d539322c854c3$export$4617fb02663045ef = (0, $bdff1e13283290e7$export$7d31b617c820d435).extend({
    initialize: function(latLngBounds, options) {
        (0, $bdff1e13283290e7$export$7d31b617c820d435).prototype.initialize.call(this, this._boundsToLatLngs(latLngBounds), options);
    },
    // @method setBounds(latLngBounds: LatLngBounds): this
    // Redraws the rectangle with the passed bounds.
    setBounds: function(latLngBounds) {
        return this.setLatLngs(this._boundsToLatLngs(latLngBounds));
    },
    _boundsToLatLngs: function(latLngBounds) {
        latLngBounds = (0, $c1a09dde0ebe0161$export$4904432a68b0399)(latLngBounds);
        return [
            latLngBounds.getSouthWest(),
            latLngBounds.getNorthWest(),
            latLngBounds.getNorthEast(),
            latLngBounds.getSouthEast()
        ];
    }
});
function $237d539322c854c3$export$405b065079b7caf2(latLngBounds, options) {
    return new $237d539322c854c3$export$4617fb02663045ef(latLngBounds, options);
}


(0, $bc2c95f9ce01d02f$export$13f4b12aafeba5d6).create = (0, $bc2c95f9ce01d02f$export$185802fd694ee1f5);
(0, $bc2c95f9ce01d02f$export$13f4b12aafeba5d6).pointsToPath = (0, $4a933da72d3faae5$export$bc863495a5f10ca1);


(0, $20915971c93a96c6$export$3a16e672cb3a069e).geometryToLayer = (0, $20915971c93a96c6$export$1d62dde364ca646a);
(0, $20915971c93a96c6$export$3a16e672cb3a069e).coordsToLatLng = (0, $20915971c93a96c6$export$68c7da933fd21adc);
(0, $20915971c93a96c6$export$3a16e672cb3a069e).coordsToLatLngs = (0, $20915971c93a96c6$export$95b72bfd8b68a8bf);
(0, $20915971c93a96c6$export$3a16e672cb3a069e).latLngToCoords = (0, $20915971c93a96c6$export$4a4f4d0b257f82d2);
(0, $20915971c93a96c6$export$3a16e672cb3a069e).latLngsToCoords = (0, $20915971c93a96c6$export$77b6e764d6612623);
(0, $20915971c93a96c6$export$3a16e672cb3a069e).getFeature = (0, $20915971c93a96c6$export$bba2e7bbd72e62e1);
(0, $20915971c93a96c6$export$3a16e672cb3a069e).asFeature = (0, $20915971c93a96c6$export$9b5abe57af2a50eb);










/*
 * L.Handler.BoxZoom is used to add shift-drag zoom interaction to the map
 * (zoom to a selected bounding box), enabled by default.
 */ // @namespace Map
// @section Interaction Options
(0, $7d9a54c6488daf4f$export$a5c7b93649eaf8f8).mergeOptions({
    // @option boxZoom: Boolean = true
    // Whether the map can be zoomed to a rectangular area specified by
    // dragging the mouse while pressing the shift key.
    boxZoom: true
});
var $c24b3b8a0a000e78$export$2151b62cd620e937 = (0, $2c337e89c81cccb9$export$a428cd33b25d5283).extend({
    initialize: function(map) {
        this._map = map;
        this._container = map._container;
        this._pane = map._panes.overlayPane;
        this._resetStateTimeout = 0;
        map.on("unload", this._destroy, this);
    },
    addHooks: function() {
        $2148974bfeaf2ac1$export$af631764ddc44097(this._container, "mousedown", this._onMouseDown, this);
    },
    removeHooks: function() {
        $2148974bfeaf2ac1$export$8c8705df4a2dcec9(this._container, "mousedown", this._onMouseDown, this);
    },
    moved: function() {
        return this._moved;
    },
    _destroy: function() {
        $783b7cedd5fd919a$export$cd7f480d6b8286c3(this._pane);
        delete this._pane;
    },
    _resetState: function() {
        this._resetStateTimeout = 0;
        this._moved = false;
    },
    _clearDeferredResetState: function() {
        if (this._resetStateTimeout !== 0) {
            clearTimeout(this._resetStateTimeout);
            this._resetStateTimeout = 0;
        }
    },
    _onMouseDown: function(e) {
        if (!e.shiftKey || e.which !== 1 && e.button !== 1) return false;
        // Clear the deferred resetState if it hasn't executed yet, otherwise it
        // will interrupt the interaction and orphan a box element in the container.
        this._clearDeferredResetState();
        this._resetState();
        $783b7cedd5fd919a$export$16a4697467175487();
        $783b7cedd5fd919a$export$188eb2a17526281();
        this._startPoint = this._map.mouseEventToContainerPoint(e);
        $2148974bfeaf2ac1$export$af631764ddc44097(document, {
            contextmenu: $2148974bfeaf2ac1$export$fa6813432f753b0d,
            mousemove: this._onMouseMove,
            mouseup: this._onMouseUp,
            keydown: this._onKeyDown
        }, this);
    },
    _onMouseMove: function(e) {
        if (!this._moved) {
            this._moved = true;
            this._box = $783b7cedd5fd919a$export$185802fd694ee1f5("div", "leaflet-zoom-box", this._container);
            $783b7cedd5fd919a$export$d2cf6cd1dc7067d3(this._container, "leaflet-crosshair");
            this._map.fire("boxzoomstart");
        }
        this._point = this._map.mouseEventToContainerPoint(e);
        var bounds = new (0, $2ffe56518af276c5$export$c4e9d269599ab4b4)(this._point, this._startPoint), size = bounds.getSize();
        $783b7cedd5fd919a$export$f9b088a47202d605(this._box, bounds.min);
        this._box.style.width = size.x + "px";
        this._box.style.height = size.y + "px";
    },
    _finish: function() {
        if (this._moved) {
            $783b7cedd5fd919a$export$cd7f480d6b8286c3(this._box);
            $783b7cedd5fd919a$export$c2255604a80b4506(this._container, "leaflet-crosshair");
        }
        $783b7cedd5fd919a$export$b1bf1c69425cc693();
        $783b7cedd5fd919a$export$f5ef98e1c9198e63();
        $2148974bfeaf2ac1$export$8c8705df4a2dcec9(document, {
            contextmenu: $2148974bfeaf2ac1$export$fa6813432f753b0d,
            mousemove: this._onMouseMove,
            mouseup: this._onMouseUp,
            keydown: this._onKeyDown
        }, this);
    },
    _onMouseUp: function(e) {
        if (e.which !== 1 && e.button !== 1) return;
        this._finish();
        if (!this._moved) return;
        // Postpone to next JS tick so internal click event handling
        // still see it as "moved".
        this._clearDeferredResetState();
        this._resetStateTimeout = setTimeout($13bbd556cd7cee10$export$2385a24977818dd0(this._resetState, this), 0);
        var bounds = new (0, $c1a09dde0ebe0161$export$fe84d4076a55a8e6)(this._map.containerPointToLatLng(this._startPoint), this._map.containerPointToLatLng(this._point));
        this._map.fitBounds(bounds).fire("boxzoomend", {
            boxZoomBounds: bounds
        });
    },
    _onKeyDown: function(e) {
        if (e.keyCode === 27) {
            this._finish();
            this._clearDeferredResetState();
            this._resetState();
        }
    }
});
// @section Handlers
// @property boxZoom: Handler
// Box (shift-drag with mouse) zoom handler.
(0, $7d9a54c6488daf4f$export$a5c7b93649eaf8f8).addInitHook("addHandler", "boxZoom", $c24b3b8a0a000e78$export$2151b62cd620e937);




/*
 * L.Handler.DoubleClickZoom is used to handle double-click zoom on the map, enabled by default.
 */ // @namespace Map
// @section Interaction Options
(0, $7d9a54c6488daf4f$export$a5c7b93649eaf8f8).mergeOptions({
    // @option doubleClickZoom: Boolean|String = true
    // Whether the map can be zoomed in by double clicking on it and
    // zoomed out by double clicking while holding shift. If passed
    // `'center'`, double-click zoom will zoom to the center of the
    //  view regardless of where the mouse was.
    doubleClickZoom: true
});
var $d4ad05b8f1fea10f$export$659838eb19c9ae68 = (0, $2c337e89c81cccb9$export$a428cd33b25d5283).extend({
    addHooks: function() {
        this._map.on("dblclick", this._onDoubleClick, this);
    },
    removeHooks: function() {
        this._map.off("dblclick", this._onDoubleClick, this);
    },
    _onDoubleClick: function(e) {
        var map = this._map, oldZoom = map.getZoom(), delta = map.options.zoomDelta, zoom = e.originalEvent.shiftKey ? oldZoom - delta : oldZoom + delta;
        if (map.options.doubleClickZoom === "center") map.setZoom(zoom);
        else map.setZoomAround(e.containerPoint, zoom);
    }
});
// @section Handlers
//
// Map properties include interaction handlers that allow you to control
// interaction behavior in runtime, enabling or disabling certain features such
// as dragging or touch zoom (see `Handler` methods). For example:
//
// ```js
// map.doubleClickZoom.disable();
// ```
//
// @property doubleClickZoom: Handler
// Double click zoom handler.
(0, $7d9a54c6488daf4f$export$a5c7b93649eaf8f8).addInitHook("addHandler", "doubleClickZoom", $d4ad05b8f1fea10f$export$659838eb19c9ae68);









/*
 * L.Handler.MapDrag is used to make the map draggable (with panning inertia), enabled by default.
 */ // @namespace Map
// @section Interaction Options
(0, $7d9a54c6488daf4f$export$a5c7b93649eaf8f8).mergeOptions({
    // @option dragging: Boolean = true
    // Whether the map is draggable with mouse/touch or not.
    dragging: true,
    // @section Panning Inertia Options
    // @option inertia: Boolean = *
    // If enabled, panning of the map will have an inertia effect where
    // the map builds momentum while dragging and continues moving in
    // the same direction for some time. Feels especially nice on touch
    // devices. Enabled by default.
    inertia: true,
    // @option inertiaDeceleration: Number = 3000
    // The rate with which the inertial movement slows down, in pixels/second².
    inertiaDeceleration: 3400,
    // @option inertiaMaxSpeed: Number = Infinity
    // Max speed of the inertial movement, in pixels/second.
    inertiaMaxSpeed: Infinity,
    // @option easeLinearity: Number = 0.2
    easeLinearity: 0.2,
    // TODO refactor, move to CRS
    // @option worldCopyJump: Boolean = false
    // With this option enabled, the map tracks when you pan to another "copy"
    // of the world and seamlessly jumps to the original one so that all overlays
    // like markers and vector layers are still visible.
    worldCopyJump: false,
    // @option maxBoundsViscosity: Number = 0.0
    // If `maxBounds` is set, this option will control how solid the bounds
    // are when dragging the map around. The default value of `0.0` allows the
    // user to drag outside the bounds at normal speed, higher values will
    // slow down map dragging outside bounds, and `1.0` makes the bounds fully
    // solid, preventing the user from dragging outside the bounds.
    maxBoundsViscosity: 0.0
});
var $34b64479bfb86a24$export$b48985bba8f530f5 = (0, $2c337e89c81cccb9$export$a428cd33b25d5283).extend({
    addHooks: function() {
        if (!this._draggable) {
            var map = this._map;
            this._draggable = new (0, $95c0b7701cd629ed$export$f2a139e5d18b9882)(map._mapPane, map._container);
            this._draggable.on({
                dragstart: this._onDragStart,
                drag: this._onDrag,
                dragend: this._onDragEnd
            }, this);
            this._draggable.on("predrag", this._onPreDragLimit, this);
            if (map.options.worldCopyJump) {
                this._draggable.on("predrag", this._onPreDragWrap, this);
                map.on("zoomend", this._onZoomEnd, this);
                map.whenReady(this._onZoomEnd, this);
            }
        }
        $783b7cedd5fd919a$export$d2cf6cd1dc7067d3(this._map._container, "leaflet-grab leaflet-touch-drag");
        this._draggable.enable();
        this._positions = [];
        this._times = [];
    },
    removeHooks: function() {
        $783b7cedd5fd919a$export$c2255604a80b4506(this._map._container, "leaflet-grab");
        $783b7cedd5fd919a$export$c2255604a80b4506(this._map._container, "leaflet-touch-drag");
        this._draggable.disable();
    },
    moved: function() {
        return this._draggable && this._draggable._moved;
    },
    moving: function() {
        return this._draggable && this._draggable._moving;
    },
    _onDragStart: function() {
        var map = this._map;
        map._stop();
        if (this._map.options.maxBounds && this._map.options.maxBoundsViscosity) {
            var bounds = (0, $c1a09dde0ebe0161$export$4904432a68b0399)(this._map.options.maxBounds);
            this._offsetLimit = (0, $2ffe56518af276c5$export$c8e2f7c8aba65b28)(this._map.latLngToContainerPoint(bounds.getNorthWest()).multiplyBy(-1), this._map.latLngToContainerPoint(bounds.getSouthEast()).multiplyBy(-1).add(this._map.getSize()));
            this._viscosity = Math.min(1.0, Math.max(0.0, this._map.options.maxBoundsViscosity));
        } else this._offsetLimit = null;
        map.fire("movestart").fire("dragstart");
        if (map.options.inertia) {
            this._positions = [];
            this._times = [];
        }
    },
    _onDrag: function(e) {
        if (this._map.options.inertia) {
            var time = this._lastTime = +new Date(), pos = this._lastPos = this._draggable._absPos || this._draggable._newPos;
            this._positions.push(pos);
            this._times.push(time);
            this._prunePositions(time);
        }
        this._map.fire("move", e).fire("drag", e);
    },
    _prunePositions: function(time) {
        while(this._positions.length > 1 && time - this._times[0] > 50){
            this._positions.shift();
            this._times.shift();
        }
    },
    _onZoomEnd: function() {
        var pxCenter = this._map.getSize().divideBy(2), pxWorldCenter = this._map.latLngToLayerPoint([
            0,
            0
        ]);
        this._initialWorldOffset = pxWorldCenter.subtract(pxCenter).x;
        this._worldWidth = this._map.getPixelWorldBounds().getSize().x;
    },
    _viscousLimit: function(value, threshold) {
        return value - (value - threshold) * this._viscosity;
    },
    _onPreDragLimit: function() {
        if (!this._viscosity || !this._offsetLimit) return;
        var offset = this._draggable._newPos.subtract(this._draggable._startPos);
        var limit = this._offsetLimit;
        if (offset.x < limit.min.x) offset.x = this._viscousLimit(offset.x, limit.min.x);
        if (offset.y < limit.min.y) offset.y = this._viscousLimit(offset.y, limit.min.y);
        if (offset.x > limit.max.x) offset.x = this._viscousLimit(offset.x, limit.max.x);
        if (offset.y > limit.max.y) offset.y = this._viscousLimit(offset.y, limit.max.y);
        this._draggable._newPos = this._draggable._startPos.add(offset);
    },
    _onPreDragWrap: function() {
        // TODO refactor to be able to adjust map pane position after zoom
        var worldWidth = this._worldWidth, halfWidth = Math.round(worldWidth / 2), dx = this._initialWorldOffset, x = this._draggable._newPos.x, newX1 = (x - halfWidth + dx) % worldWidth + halfWidth - dx, newX2 = (x + halfWidth + dx) % worldWidth - halfWidth - dx, newX = Math.abs(newX1 + dx) < Math.abs(newX2 + dx) ? newX1 : newX2;
        this._draggable._absPos = this._draggable._newPos.clone();
        this._draggable._newPos.x = newX;
    },
    _onDragEnd: function(e) {
        var map = this._map, options = map.options, noInertia = !options.inertia || e.noInertia || this._times.length < 2;
        map.fire("dragend", e);
        if (noInertia) map.fire("moveend");
        else {
            this._prunePositions(+new Date());
            var direction = this._lastPos.subtract(this._positions[0]), duration = (this._lastTime - this._times[0]) / 1000, ease = options.easeLinearity, speedVector = direction.multiplyBy(ease / duration), speed = speedVector.distanceTo([
                0,
                0
            ]), limitedSpeed = Math.min(options.inertiaMaxSpeed, speed), limitedSpeedVector = speedVector.multiplyBy(limitedSpeed / speed), decelerationDuration = limitedSpeed / (options.inertiaDeceleration * ease), offset = limitedSpeedVector.multiplyBy(-decelerationDuration / 2).round();
            if (!offset.x && !offset.y) map.fire("moveend");
            else {
                offset = map._limitOffset(offset, map.options.maxBounds);
                $13bbd556cd7cee10$export$d371ad015c199c06(function() {
                    map.panBy(offset, {
                        duration: decelerationDuration,
                        easeLinearity: ease,
                        noMoveStart: true,
                        animate: true
                    });
                });
            }
        }
    }
});
// @section Handlers
// @property dragging: Handler
// Map dragging handler (by both mouse and touch).
(0, $7d9a54c6488daf4f$export$a5c7b93649eaf8f8).addInitHook("addHandler", "dragging", $34b64479bfb86a24$export$b48985bba8f530f5);






/*
 * L.Map.Keyboard is handling keyboard interaction with the map, enabled by default.
 */ // @namespace Map
// @section Keyboard Navigation Options
(0, $7d9a54c6488daf4f$export$a5c7b93649eaf8f8).mergeOptions({
    // @option keyboard: Boolean = true
    // Makes the map focusable and allows users to navigate the map with keyboard
    // arrows and `+`/`-` keys.
    keyboard: true,
    // @option keyboardPanDelta: Number = 80
    // Amount of pixels to pan when pressing an arrow key.
    keyboardPanDelta: 80
});
var $e65ddce7d4099ba8$export$16e4d70cc375e707 = (0, $2c337e89c81cccb9$export$a428cd33b25d5283).extend({
    keyCodes: {
        left: [
            37
        ],
        right: [
            39
        ],
        down: [
            40
        ],
        up: [
            38
        ],
        zoomIn: [
            187,
            107,
            61,
            171
        ],
        zoomOut: [
            189,
            109,
            54,
            173
        ]
    },
    initialize: function(map) {
        this._map = map;
        this._setPanDelta(map.options.keyboardPanDelta);
        this._setZoomDelta(map.options.zoomDelta);
    },
    addHooks: function() {
        var container = this._map._container;
        // make the container focusable by tabbing
        if (container.tabIndex <= 0) container.tabIndex = "0";
        (0, $2148974bfeaf2ac1$export$af631764ddc44097)(container, {
            focus: this._onFocus,
            blur: this._onBlur,
            mousedown: this._onMouseDown
        }, this);
        this._map.on({
            focus: this._addHooks,
            blur: this._removeHooks
        }, this);
    },
    removeHooks: function() {
        this._removeHooks();
        (0, $2148974bfeaf2ac1$export$8c8705df4a2dcec9)(this._map._container, {
            focus: this._onFocus,
            blur: this._onBlur,
            mousedown: this._onMouseDown
        }, this);
        this._map.off({
            focus: this._addHooks,
            blur: this._removeHooks
        }, this);
    },
    _onMouseDown: function() {
        if (this._focused) return;
        var body = document.body, docEl = document.documentElement, top = body.scrollTop || docEl.scrollTop, left = body.scrollLeft || docEl.scrollLeft;
        this._map._container.focus();
        window.scrollTo(left, top);
    },
    _onFocus: function() {
        this._focused = true;
        this._map.fire("focus");
    },
    _onBlur: function() {
        this._focused = false;
        this._map.fire("blur");
    },
    _setPanDelta: function(panDelta) {
        var keys = this._panKeys = {}, codes = this.keyCodes, i, len;
        for(i = 0, len = codes.left.length; i < len; i++)keys[codes.left[i]] = [
            -1 * panDelta,
            0
        ];
        for(i = 0, len = codes.right.length; i < len; i++)keys[codes.right[i]] = [
            panDelta,
            0
        ];
        for(i = 0, len = codes.down.length; i < len; i++)keys[codes.down[i]] = [
            0,
            panDelta
        ];
        for(i = 0, len = codes.up.length; i < len; i++)keys[codes.up[i]] = [
            0,
            -1 * panDelta
        ];
    },
    _setZoomDelta: function(zoomDelta) {
        var keys = this._zoomKeys = {}, codes = this.keyCodes, i, len;
        for(i = 0, len = codes.zoomIn.length; i < len; i++)keys[codes.zoomIn[i]] = zoomDelta;
        for(i = 0, len = codes.zoomOut.length; i < len; i++)keys[codes.zoomOut[i]] = -zoomDelta;
    },
    _addHooks: function() {
        (0, $2148974bfeaf2ac1$export$af631764ddc44097)(document, "keydown", this._onKeyDown, this);
    },
    _removeHooks: function() {
        (0, $2148974bfeaf2ac1$export$8c8705df4a2dcec9)(document, "keydown", this._onKeyDown, this);
    },
    _onKeyDown: function(e) {
        if (e.altKey || e.ctrlKey || e.metaKey) return;
        var key = e.keyCode, map = this._map, offset;
        if (key in this._panKeys) {
            if (!map._panAnim || !map._panAnim._inProgress) {
                offset = this._panKeys[key];
                if (e.shiftKey) offset = (0, $b802e4aa6d666b45$export$b63cca88ddc558a9)(offset).multiplyBy(3);
                if (map.options.maxBounds) offset = map._limitOffset((0, $b802e4aa6d666b45$export$b63cca88ddc558a9)(offset), map.options.maxBounds);
                if (map.options.worldCopyJump) {
                    var newLatLng = map.wrapLatLng(map.unproject(map.project(map.getCenter()).add(offset)));
                    map.panTo(newLatLng);
                } else map.panBy(offset);
            }
        } else if (key in this._zoomKeys) map.setZoom(map.getZoom() + (e.shiftKey ? 3 : 1) * this._zoomKeys[key]);
        else if (key === 27 && map._popup && map._popup.options.closeOnEscapeKey) map.closePopup();
        else return;
        (0, $2148974bfeaf2ac1$export$fa6813432f753b0d)(e);
    }
});
// @section Handlers
// @section Handlers
// @property keyboard: Handler
// Keyboard navigation handler.
(0, $7d9a54c6488daf4f$export$a5c7b93649eaf8f8).addInitHook("addHandler", "keyboard", $e65ddce7d4099ba8$export$16e4d70cc375e707);






/*
 * L.Handler.ScrollWheelZoom is used by L.Map to enable mouse scroll wheel zoom on the map.
 */ // @namespace Map
// @section Interaction Options
(0, $7d9a54c6488daf4f$export$a5c7b93649eaf8f8).mergeOptions({
    // @section Mouse wheel options
    // @option scrollWheelZoom: Boolean|String = true
    // Whether the map can be zoomed by using the mouse wheel. If passed `'center'`,
    // it will zoom to the center of the view regardless of where the mouse was.
    scrollWheelZoom: true,
    // @option wheelDebounceTime: Number = 40
    // Limits the rate at which a wheel can fire (in milliseconds). By default
    // user can't zoom via wheel more often than once per 40 ms.
    wheelDebounceTime: 40,
    // @option wheelPxPerZoomLevel: Number = 60
    // How many scroll pixels (as reported by [L.DomEvent.getWheelDelta](#domevent-getwheeldelta))
    // mean a change of one full zoom level. Smaller values will make wheel-zooming
    // faster (and vice versa).
    wheelPxPerZoomLevel: 60
});
var $831b4fc8af10554a$export$827ded792b758b05 = (0, $2c337e89c81cccb9$export$a428cd33b25d5283).extend({
    addHooks: function() {
        $2148974bfeaf2ac1$export$af631764ddc44097(this._map._container, "wheel", this._onWheelScroll, this);
        this._delta = 0;
    },
    removeHooks: function() {
        $2148974bfeaf2ac1$export$8c8705df4a2dcec9(this._map._container, "wheel", this._onWheelScroll, this);
    },
    _onWheelScroll: function(e) {
        var delta = $2148974bfeaf2ac1$export$99de932e438a9331(e);
        var debounce = this._map.options.wheelDebounceTime;
        this._delta += delta;
        this._lastMousePos = this._map.mouseEventToContainerPoint(e);
        if (!this._startTime) this._startTime = +new Date();
        var left = Math.max(debounce - (+new Date() - this._startTime), 0);
        clearTimeout(this._timer);
        this._timer = setTimeout($13bbd556cd7cee10$export$2385a24977818dd0(this._performZoom, this), left);
        $2148974bfeaf2ac1$export$fa6813432f753b0d(e);
    },
    _performZoom: function() {
        var map = this._map, zoom = map.getZoom(), snap = this._map.options.zoomSnap || 0;
        map._stop(); // stop panning and fly animations if any
        // map the delta with a sigmoid function to -4..4 range leaning on -1..1
        var d2 = this._delta / (this._map.options.wheelPxPerZoomLevel * 4), d3 = 4 * Math.log(2 / (1 + Math.exp(-Math.abs(d2)))) / Math.LN2, d4 = snap ? Math.ceil(d3 / snap) * snap : d3, delta = map._limitZoom(zoom + (this._delta > 0 ? d4 : -d4)) - zoom;
        this._delta = 0;
        this._startTime = null;
        if (!delta) return;
        if (map.options.scrollWheelZoom === "center") map.setZoom(zoom + delta);
        else map.setZoomAround(this._lastMousePos, zoom + delta);
    }
});
// @section Handlers
// @property scrollWheelZoom: Handler
// Scroll wheel zoom handler.
(0, $7d9a54c6488daf4f$export$a5c7b93649eaf8f8).addInitHook("addHandler", "scrollWheelZoom", $831b4fc8af10554a$export$827ded792b758b05);








/*
 * L.Map.TapHold is used to simulate `contextmenu` event on long hold,
 * which otherwise is not fired by mobile Safari.
 */ var $159f382c7b20d503$var$tapHoldDelay = 600;
// @namespace Map
// @section Interaction Options
(0, $7d9a54c6488daf4f$export$a5c7b93649eaf8f8).mergeOptions({
    // @section Touch interaction options
    // @option tapHold: Boolean
    // Enables simulation of `contextmenu` event, default is `true` for mobile Safari.
    tapHold: (0, $bda63d751c06734c$export$2e2bcd8739ae039).touchNative && (0, $bda63d751c06734c$export$2e2bcd8739ae039).safari && (0, $bda63d751c06734c$export$2e2bcd8739ae039).mobile,
    // @option tapTolerance: Number = 15
    // The max number of pixels a user can shift his finger during touch
    // for it to be considered a valid tap.
    tapTolerance: 15
});
var $159f382c7b20d503$export$1f41e5991b5e31c0 = (0, $2c337e89c81cccb9$export$a428cd33b25d5283).extend({
    addHooks: function() {
        $2148974bfeaf2ac1$export$af631764ddc44097(this._map._container, "touchstart", this._onDown, this);
    },
    removeHooks: function() {
        $2148974bfeaf2ac1$export$8c8705df4a2dcec9(this._map._container, "touchstart", this._onDown, this);
    },
    _onDown: function(e) {
        clearTimeout(this._holdTimeout);
        if (e.touches.length !== 1) return;
        var first = e.touches[0];
        this._startPos = this._newPos = new (0, $b802e4aa6d666b45$export$baf26146a414f24a)(first.clientX, first.clientY);
        this._holdTimeout = setTimeout($13bbd556cd7cee10$export$2385a24977818dd0(function() {
            this._cancel();
            if (!this._isTapValid()) return;
            // prevent simulated mouse events https://w3c.github.io/touch-events/#mouse-events
            $2148974bfeaf2ac1$export$af631764ddc44097(document, "touchend", $2148974bfeaf2ac1$export$fa3b29edae795ef4);
            $2148974bfeaf2ac1$export$af631764ddc44097(document, "touchend touchcancel", this._cancelClickPrevent);
            this._simulateEvent("contextmenu", first);
        }, this), $159f382c7b20d503$var$tapHoldDelay);
        $2148974bfeaf2ac1$export$af631764ddc44097(document, "touchend touchcancel contextmenu", this._cancel, this);
        $2148974bfeaf2ac1$export$af631764ddc44097(document, "touchmove", this._onMove, this);
    },
    _cancelClickPrevent: function cancelClickPrevent() {
        $2148974bfeaf2ac1$export$8c8705df4a2dcec9(document, "touchend", $2148974bfeaf2ac1$export$fa3b29edae795ef4);
        $2148974bfeaf2ac1$export$8c8705df4a2dcec9(document, "touchend touchcancel", cancelClickPrevent);
    },
    _cancel: function() {
        clearTimeout(this._holdTimeout);
        $2148974bfeaf2ac1$export$8c8705df4a2dcec9(document, "touchend touchcancel contextmenu", this._cancel, this);
        $2148974bfeaf2ac1$export$8c8705df4a2dcec9(document, "touchmove", this._onMove, this);
    },
    _onMove: function(e) {
        var first = e.touches[0];
        this._newPos = new (0, $b802e4aa6d666b45$export$baf26146a414f24a)(first.clientX, first.clientY);
    },
    _isTapValid: function() {
        return this._newPos.distanceTo(this._startPos) <= this._map.options.tapTolerance;
    },
    _simulateEvent: function(type, e) {
        var simulatedEvent = new MouseEvent(type, {
            bubbles: true,
            cancelable: true,
            view: window,
            // detail: 1,
            screenX: e.screenX,
            screenY: e.screenY,
            clientX: e.clientX,
            clientY: e.clientY
        });
        simulatedEvent._simulated = true;
        e.target.dispatchEvent(simulatedEvent);
    }
});
// @section Handlers
// @property tapHold: Handler
// Long tap handler to simulate `contextmenu` event (useful in mobile Safari).
(0, $7d9a54c6488daf4f$export$a5c7b93649eaf8f8).addInitHook("addHandler", "tapHold", $159f382c7b20d503$export$1f41e5991b5e31c0);








/*
 * L.Handler.TouchZoom is used by L.Map to add pinch zoom on supported mobile browsers.
 */ // @namespace Map
// @section Interaction Options
(0, $7d9a54c6488daf4f$export$a5c7b93649eaf8f8).mergeOptions({
    // @section Touch interaction options
    // @option touchZoom: Boolean|String = *
    // Whether the map can be zoomed by touch-dragging with two fingers. If
    // passed `'center'`, it will zoom to the center of the view regardless of
    // where the touch events (fingers) were. Enabled for touch-capable web
    // browsers.
    touchZoom: (0, $bda63d751c06734c$export$2e2bcd8739ae039).touch,
    // @option bounceAtZoomLimits: Boolean = true
    // Set it to false if you don't want the map to zoom beyond min/max zoom
    // and then bounce back when pinch-zooming.
    bounceAtZoomLimits: true
});
var $0b9591062c3b2a69$export$c2e78827ecf04883 = (0, $2c337e89c81cccb9$export$a428cd33b25d5283).extend({
    addHooks: function() {
        $783b7cedd5fd919a$export$d2cf6cd1dc7067d3(this._map._container, "leaflet-touch-zoom");
        $2148974bfeaf2ac1$export$af631764ddc44097(this._map._container, "touchstart", this._onTouchStart, this);
    },
    removeHooks: function() {
        $783b7cedd5fd919a$export$c2255604a80b4506(this._map._container, "leaflet-touch-zoom");
        $2148974bfeaf2ac1$export$8c8705df4a2dcec9(this._map._container, "touchstart", this._onTouchStart, this);
    },
    _onTouchStart: function(e) {
        var map = this._map;
        if (!e.touches || e.touches.length !== 2 || map._animatingZoom || this._zooming) return;
        var p1 = map.mouseEventToContainerPoint(e.touches[0]), p2 = map.mouseEventToContainerPoint(e.touches[1]);
        this._centerPoint = map.getSize()._divideBy(2);
        this._startLatLng = map.containerPointToLatLng(this._centerPoint);
        if (map.options.touchZoom !== "center") this._pinchStartLatLng = map.containerPointToLatLng(p1.add(p2)._divideBy(2));
        this._startDist = p1.distanceTo(p2);
        this._startZoom = map.getZoom();
        this._moved = false;
        this._zooming = true;
        map._stop();
        $2148974bfeaf2ac1$export$af631764ddc44097(document, "touchmove", this._onTouchMove, this);
        $2148974bfeaf2ac1$export$af631764ddc44097(document, "touchend touchcancel", this._onTouchEnd, this);
        $2148974bfeaf2ac1$export$fa3b29edae795ef4(e);
    },
    _onTouchMove: function(e) {
        if (!e.touches || e.touches.length !== 2 || !this._zooming) return;
        var map = this._map, p1 = map.mouseEventToContainerPoint(e.touches[0]), p2 = map.mouseEventToContainerPoint(e.touches[1]), scale = p1.distanceTo(p2) / this._startDist;
        this._zoom = map.getScaleZoom(scale, this._startZoom);
        if (!map.options.bounceAtZoomLimits && (this._zoom < map.getMinZoom() && scale < 1 || this._zoom > map.getMaxZoom() && scale > 1)) this._zoom = map._limitZoom(this._zoom);
        if (map.options.touchZoom === "center") {
            this._center = this._startLatLng;
            if (scale === 1) return;
        } else {
            // Get delta from pinch to center, so centerLatLng is delta applied to initial pinchLatLng
            var delta = p1._add(p2)._divideBy(2)._subtract(this._centerPoint);
            if (scale === 1 && delta.x === 0 && delta.y === 0) return;
            this._center = map.unproject(map.project(this._pinchStartLatLng, this._zoom).subtract(delta), this._zoom);
        }
        if (!this._moved) {
            map._moveStart(true, false);
            this._moved = true;
        }
        $13bbd556cd7cee10$export$e1ed83507f55dc9d(this._animRequest);
        var moveFn = $13bbd556cd7cee10$export$2385a24977818dd0(map._move, map, this._center, this._zoom, {
            pinch: true,
            round: false
        }, undefined);
        this._animRequest = $13bbd556cd7cee10$export$d371ad015c199c06(moveFn, this, true);
        $2148974bfeaf2ac1$export$fa3b29edae795ef4(e);
    },
    _onTouchEnd: function() {
        if (!this._moved || !this._zooming) {
            this._zooming = false;
            return;
        }
        this._zooming = false;
        $13bbd556cd7cee10$export$e1ed83507f55dc9d(this._animRequest);
        $2148974bfeaf2ac1$export$8c8705df4a2dcec9(document, "touchmove", this._onTouchMove, this);
        $2148974bfeaf2ac1$export$8c8705df4a2dcec9(document, "touchend touchcancel", this._onTouchEnd, this);
        // Pinch updates GridLayers' levels only when zoomSnap is off, so zoomSnap becomes noUpdate.
        if (this._map.options.zoomAnimation) this._map._animateZoom(this._center, this._map._limitZoom(this._zoom), true, this._map.options.zoomSnap);
        else this._map._resetView(this._center, this._map._limitZoom(this._zoom));
    }
});
// @section Handlers
// @property touchZoom: Handler
// Touch zoom handler.
(0, $7d9a54c6488daf4f$export$a5c7b93649eaf8f8).addInitHook("addHandler", "touchZoom", $0b9591062c3b2a69$export$c2e78827ecf04883);


(0, $7d9a54c6488daf4f$export$a5c7b93649eaf8f8).BoxZoom = (0, $c24b3b8a0a000e78$export$2151b62cd620e937);
(0, $7d9a54c6488daf4f$export$a5c7b93649eaf8f8).DoubleClickZoom = (0, $d4ad05b8f1fea10f$export$659838eb19c9ae68);
(0, $7d9a54c6488daf4f$export$a5c7b93649eaf8f8).Drag = (0, $34b64479bfb86a24$export$b48985bba8f530f5);
(0, $7d9a54c6488daf4f$export$a5c7b93649eaf8f8).Keyboard = (0, $e65ddce7d4099ba8$export$16e4d70cc375e707);
(0, $7d9a54c6488daf4f$export$a5c7b93649eaf8f8).ScrollWheelZoom = (0, $831b4fc8af10554a$export$827ded792b758b05);
(0, $7d9a54c6488daf4f$export$a5c7b93649eaf8f8).TapHold = (0, $159f382c7b20d503$export$1f41e5991b5e31c0);
(0, $7d9a54c6488daf4f$export$a5c7b93649eaf8f8).TouchZoom = (0, $0b9591062c3b2a69$export$c2e78827ecf04883);




var $86ef66e082b39606$exports = {};

/*!
Copyright (c) 2016 Dominik Moritz

This file is part of the leaflet locate control. It is licensed under the MIT license.
You can find the project at: https://github.com/domoritz/leaflet-locatecontrol
*/ (function(factory, window1) {
    // see https://github.com/Leaflet/Leaflet/blob/master/PLUGIN-GUIDE.md#module-loaders
    // for details on how to structure a leaflet plugin.
    // define an AMD module that relies on 'leaflet'
    if (typeof define === "function" && define.amd) define([
        "leaflet"
    ], factory);
    else if (true) {
        if (typeof window1 !== "undefined" && window1.L) $86ef66e082b39606$exports = factory(L);
        else $86ef66e082b39606$exports = factory((parcelRequire("iLKzi")));
    }
    // attach your plugin to the global 'L' variable
    if (typeof window1 !== "undefined" && window1.L) window1.L.Control.Locate = factory(L);
})(function(L1) {
    const LDomUtilApplyClassesMethod = (method, element, classNames)=>{
        classNames = classNames.split(" ");
        classNames.forEach(function(className) {
            L1.DomUtil[method].call(this, element, className);
        });
    };
    const addClasses = (el, names)=>LDomUtilApplyClassesMethod("addClass", el, names);
    const removeClasses = (el, names)=>LDomUtilApplyClassesMethod("removeClass", el, names);
    /**
   * Compatible with L.Circle but a true marker instead of a path
   */ const LocationMarker = L1.Marker.extend({
        initialize (latlng, options) {
            L1.Util.setOptions(this, options);
            this._latlng = latlng;
            this.createIcon();
        },
        /**
     * Create a styled circle location marker
     */ createIcon () {
            const opt = this.options;
            let style = "";
            if (opt.color !== undefined) style += `stroke:${opt.color};`;
            if (opt.weight !== undefined) style += `stroke-width:${opt.weight};`;
            if (opt.fillColor !== undefined) style += `fill:${opt.fillColor};`;
            if (opt.fillOpacity !== undefined) style += `fill-opacity:${opt.fillOpacity};`;
            if (opt.opacity !== undefined) style += `opacity:${opt.opacity};`;
            const icon = this._getIconSVG(opt, style);
            this._locationIcon = L1.divIcon({
                className: icon.className,
                html: icon.svg,
                iconSize: [
                    icon.w,
                    icon.h
                ]
            });
            this.setIcon(this._locationIcon);
        },
        /**
     * Return the raw svg for the shape
     *
     * Split so can be easily overridden
     */ _getIconSVG (options, style) {
            const r = options.radius;
            const w = options.weight;
            const s = r + w;
            const s2 = s * 2;
            const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="${s2}" height="${s2}" version="1.1" viewBox="-${s} -${s} ${s2} ${s2}">` + '<circle r="' + r + '" style="' + style + '" />' + "</svg>";
            return {
                className: "leaflet-control-locate-location",
                svg: svg,
                w: s2,
                h: s2
            };
        },
        setStyle (style) {
            L1.Util.setOptions(this, style);
            this.createIcon();
        }
    });
    const CompassMarker = LocationMarker.extend({
        initialize (latlng, heading, options) {
            L1.Util.setOptions(this, options);
            this._latlng = latlng;
            this._heading = heading;
            this.createIcon();
        },
        setHeading (heading) {
            this._heading = heading;
        },
        /**
     * Create a styled arrow compass marker
     */ _getIconSVG (options, style) {
            const r = options.radius;
            const w = options.width + options.weight;
            const h = (r + options.depth + options.weight) * 2;
            const path = `M0,0 l${options.width / 2},${options.depth} l-${w},0 z`;
            const svgstyle = `transform: rotate(${this._heading}deg)`;
            const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="${w}" height="${h}" version="1.1" viewBox="-${w / 2} 0 ${w} ${h}" style="${svgstyle}">` + '<path d="' + path + '" style="' + style + '" />' + "</svg>";
            return {
                className: "leaflet-control-locate-heading",
                svg: svg,
                w: w,
                h: h
            };
        }
    });
    const LocateControl = L1.Control.extend({
        options: {
            /** Position of the control */ position: "topleft",
            /** The layer that the user's location should be drawn on. By default creates a new layer. */ layer: undefined,
            /**
       * Automatically sets the map view (zoom and pan) to the user's location as it updates.
       * While the map is following the user's location, the control is in the `following` state,
       * which changes the style of the control and the circle marker.
       *
       * Possible values:
       *  - false: never updates the map view when location changes.
       *  - 'once': set the view when the location is first determined
       *  - 'always': always updates the map view when location changes.
       *              The map view follows the user's location.
       *  - 'untilPan': like 'always', except stops updating the
       *                view if the user has manually panned the map.
       *                The map view follows the user's location until she pans.
       *  - 'untilPanOrZoom': (default) like 'always', except stops updating the
       *                view if the user has manually panned the map.
       *                The map view follows the user's location until she pans.
       */ setView: "untilPanOrZoom",
            /** Keep the current map zoom level when setting the view and only pan. */ keepCurrentZoomLevel: false,
            /** After activating the plugin by clicking on the icon, zoom to the selected zoom level, even when keepCurrentZoomLevel is true. Set to 'false' to disable this feature. */ initialZoomLevel: false,
            /**
       * This callback can be used to override the viewport tracking
       * This function should return a LatLngBounds object.
       *
       * For example to extend the viewport to ensure that a particular LatLng is visible:
       *
       * getLocationBounds: function(locationEvent) {
       *    return locationEvent.bounds.extend([-33.873085, 151.219273]);
       * },
       */ getLocationBounds (locationEvent) {
                return locationEvent.bounds;
            },
            /** Smooth pan and zoom to the location of the marker. Only works in Leaflet 1.0+. */ flyTo: false,
            /**
       * The user location can be inside and outside the current view when the user clicks on the
       * control that is already active. Both cases can be configures separately.
       * Possible values are:
       *  - 'setView': zoom and pan to the current location
       *  - 'stop': stop locating and remove the location marker
       */ clickBehavior: {
                /** What should happen if the user clicks on the control while the location is within the current view. */ inView: "stop",
                /** What should happen if the user clicks on the control while the location is outside the current view. */ outOfView: "setView",
                /**
         * What should happen if the user clicks on the control while the location is within the current view
         * and we could be following but are not. Defaults to a special value which inherits from 'inView';
         */ inViewNotFollowing: "inView"
            },
            /**
       * If set, save the map bounds just before centering to the user's
       * location. When control is disabled, set the view back to the
       * bounds that were saved.
       */ returnToPrevBounds: false,
            /**
       * Keep a cache of the location after the user deactivates the control. If set to false, the user has to wait
       * until the locate API returns a new location before they see where they are again.
       */ cacheLocation: true,
            /** If set, a circle that shows the location accuracy is drawn. */ drawCircle: true,
            /** If set, the marker at the users' location is drawn. */ drawMarker: true,
            /** If set and supported then show the compass heading */ showCompass: true,
            /** The class to be used to create the marker. For example L.CircleMarker or L.Marker */ markerClass: LocationMarker,
            /** The class us be used to create the compass bearing arrow */ compassClass: CompassMarker,
            /** Accuracy circle style properties. NOTE these styles should match the css animations styles */ circleStyle: {
                className: "leaflet-control-locate-circle",
                color: "#136AEC",
                fillColor: "#136AEC",
                fillOpacity: 0.15,
                weight: 0
            },
            /** Inner marker style properties. Only works if your marker class supports `setStyle`. */ markerStyle: {
                className: "leaflet-control-locate-marker",
                color: "#fff",
                fillColor: "#2A93EE",
                fillOpacity: 1,
                weight: 3,
                opacity: 1,
                radius: 9
            },
            /** Compass */ compassStyle: {
                fillColor: "#2A93EE",
                fillOpacity: 1,
                weight: 0,
                color: "#fff",
                opacity: 1,
                radius: 9,
                width: 9,
                depth: 6 // Length of the arrow
            },
            /**
       * Changes to accuracy circle and inner marker while following.
       * It is only necessary to provide the properties that should change.
       */ followCircleStyle: {},
            followMarkerStyle: {
            },
            followCompassStyle: {},
            /** The CSS class for the icon. For example fa-location-arrow or fa-map-marker */ icon: "leaflet-control-locate-location-arrow",
            iconLoading: "leaflet-control-locate-spinner",
            /** The element to be created for icons. For example span or i */ iconElementTag: "span",
            /** The element to be created for the text. For example small or span */ textElementTag: "small",
            /** Padding around the accuracy circle. */ circlePadding: [
                0,
                0
            ],
            /** Use metric units. */ metric: true,
            /**
       * This callback can be used in case you would like to override button creation behavior.
       * This is useful for DOM manipulation frameworks such as angular etc.
       * This function should return an object with HtmlElement for the button (link property) and the icon (icon property).
       */ createButtonCallback (container, options) {
                const link = L1.DomUtil.create("a", "leaflet-bar-part leaflet-bar-part-single", container);
                link.title = options.strings.title;
                link.href = "#";
                link.setAttribute("role", "button");
                const icon = L1.DomUtil.create(options.iconElementTag, options.icon, link);
                if (options.strings.text !== undefined) {
                    const text = L1.DomUtil.create(options.textElementTag, "leaflet-locate-text", link);
                    text.textContent = options.strings.text;
                    link.classList.add("leaflet-locate-text-active");
                    link.parentNode.style.display = "flex";
                    if (options.icon.length > 0) icon.classList.add("leaflet-locate-icon");
                }
                return {
                    link: link,
                    icon: icon
                };
            },
            /** This event is called in case of any location error that is not a time out error. */ onLocationError (err, control) {
                alert(err.message);
            },
            /**
       * This event is called when the user's location is outside the bounds set on the map.
       * The event is called repeatedly when the location changes.
       */ onLocationOutsideMapBounds (control) {
                control.stop();
                alert(control.options.strings.outsideMapBoundsMsg);
            },
            /** Display a pop-up when the user click on the inner marker. */ showPopup: true,
            strings: {
                title: "Show me where I am",
                metersUnit: "meters",
                feetUnit: "feet",
                popup: "You are within {distance} {unit} from this point",
                outsideMapBoundsMsg: "You seem located outside the boundaries of the map"
            },
            /** The default options passed to leaflets locate method. */ locateOptions: {
                maxZoom: Infinity,
                watch: true,
                setView: false // have to set this to false because we have to
            }
        },
        initialize (options) {
            // set default options if nothing is set (merge one step deep)
            for(const i in options)if (typeof this.options[i] === "object") L1.extend(this.options[i], options[i]);
            else this.options[i] = options[i];
            // extend the follow marker style and circle from the normal style
            this.options.followMarkerStyle = L1.extend({}, this.options.markerStyle, this.options.followMarkerStyle);
            this.options.followCircleStyle = L1.extend({}, this.options.circleStyle, this.options.followCircleStyle);
            this.options.followCompassStyle = L1.extend({}, this.options.compassStyle, this.options.followCompassStyle);
        },
        /**
     * Add control to map. Returns the container for the control.
     */ onAdd (map) {
            const container = L1.DomUtil.create("div", "leaflet-control-locate leaflet-bar leaflet-control");
            this._container = container;
            this._map = map;
            this._layer = this.options.layer || new L1.LayerGroup();
            this._layer.addTo(map);
            this._event = undefined;
            this._compassHeading = null;
            this._prevBounds = null;
            const linkAndIcon = this.options.createButtonCallback(container, this.options);
            this._link = linkAndIcon.link;
            this._icon = linkAndIcon.icon;
            L1.DomEvent.on(this._link, "click", function(ev) {
                L1.DomEvent.stopPropagation(ev);
                L1.DomEvent.preventDefault(ev);
                this._onClick();
            }, this).on(this._link, "dblclick", L1.DomEvent.stopPropagation);
            this._resetVariables();
            this._map.on("unload", this._unload, this);
            return container;
        },
        /**
     * This method is called when the user clicks on the control.
     */ _onClick () {
            this._justClicked = true;
            const wasFollowing = this._isFollowing();
            this._userPanned = false;
            this._userZoomed = false;
            if (this._active && !this._event) // click while requesting
            this.stop();
            else if (this._active) {
                const behaviors = this.options.clickBehavior;
                let behavior = behaviors.outOfView;
                if (this._map.getBounds().contains(this._event.latlng)) behavior = wasFollowing ? behaviors.inView : behaviors.inViewNotFollowing;
                // Allow inheriting from another behavior
                if (behaviors[behavior]) behavior = behaviors[behavior];
                switch(behavior){
                    case "setView":
                        this.setView();
                        break;
                    case "stop":
                        this.stop();
                        if (this.options.returnToPrevBounds) {
                            const f = this.options.flyTo ? this._map.flyToBounds : this._map.fitBounds;
                            f.bind(this._map)(this._prevBounds);
                        }
                        break;
                }
            } else {
                if (this.options.returnToPrevBounds) this._prevBounds = this._map.getBounds();
                this.start();
            }
            this._updateContainerStyle();
        },
        /**
     * Starts the plugin:
     * - activates the engine
     * - draws the marker (if coordinates available)
     */ start () {
            this._activate();
            if (this._event) {
                this._drawMarker(this._map);
                // if we already have a location but the user clicked on the control
                if (this.options.setView) this.setView();
            }
            this._updateContainerStyle();
        },
        /**
     * Stops the plugin:
     * - deactivates the engine
     * - reinitializes the button
     * - removes the marker
     */ stop () {
            this._deactivate();
            this._cleanClasses();
            this._resetVariables();
            this._removeMarker();
        },
        /**
     * Keep the control active but stop following the location
     */ stopFollowing () {
            this._userPanned = true;
            this._updateContainerStyle();
            this._drawMarker();
        },
        /**
     * This method launches the location engine.
     * It is called before the marker is updated,
     * event if it does not mean that the event will be ready.
     *
     * Override it if you want to add more functionalities.
     * It should set the this._active to true and do nothing if
     * this._active is true.
     */ _activate () {
            if (this._active || !this._map) return;
            this._map.locate(this.options.locateOptions);
            this._map.fire("locateactivate", this);
            this._active = true;
            // bind event listeners
            this._map.on("locationfound", this._onLocationFound, this);
            this._map.on("locationerror", this._onLocationError, this);
            this._map.on("dragstart", this._onDrag, this);
            this._map.on("zoomstart", this._onZoom, this);
            this._map.on("zoomend", this._onZoomEnd, this);
            if (this.options.showCompass) {
                const oriAbs = "ondeviceorientationabsolute" in window;
                if (oriAbs || "ondeviceorientation" in window) {
                    const _this = this;
                    const deviceorientation = function() {
                        L1.DomEvent.on(window, oriAbs ? "deviceorientationabsolute" : "deviceorientation", _this._onDeviceOrientation, _this);
                    };
                    if (DeviceOrientationEvent && typeof DeviceOrientationEvent.requestPermission === "function") DeviceOrientationEvent.requestPermission().then(function(permissionState) {
                        if (permissionState === "granted") deviceorientation();
                    });
                    else deviceorientation();
                }
            }
        },
        /**
     * Called to stop the location engine.
     *
     * Override it to shutdown any functionalities you added on start.
     */ _deactivate () {
            if (!this._active || !this._map) return;
            this._map.stopLocate();
            this._map.fire("locatedeactivate", this);
            this._active = false;
            if (!this.options.cacheLocation) this._event = undefined;
            // unbind event listeners
            this._map.off("locationfound", this._onLocationFound, this);
            this._map.off("locationerror", this._onLocationError, this);
            this._map.off("dragstart", this._onDrag, this);
            this._map.off("zoomstart", this._onZoom, this);
            this._map.off("zoomend", this._onZoomEnd, this);
            if (this.options.showCompass) {
                this._compassHeading = null;
                if ("ondeviceorientationabsolute" in window) L1.DomEvent.off(window, "deviceorientationabsolute", this._onDeviceOrientation, this);
                else if ("ondeviceorientation" in window) L1.DomEvent.off(window, "deviceorientation", this._onDeviceOrientation, this);
            }
        },
        /**
     * Zoom (unless we should keep the zoom level) and an to the current view.
     */ setView () {
            this._drawMarker();
            if (this._isOutsideMapBounds()) {
                this._event = undefined; // clear the current location so we can get back into the bounds
                this.options.onLocationOutsideMapBounds(this);
            } else {
                if (this._justClicked && this.options.initialZoomLevel !== false) {
                    var f = this.options.flyTo ? this._map.flyTo : this._map.setView;
                    f.bind(this._map)([
                        this._event.latitude,
                        this._event.longitude
                    ], this.options.initialZoomLevel);
                } else if (this.options.keepCurrentZoomLevel) {
                    var f = this.options.flyTo ? this._map.flyTo : this._map.panTo;
                    f.bind(this._map)([
                        this._event.latitude,
                        this._event.longitude
                    ]);
                } else {
                    var f = this.options.flyTo ? this._map.flyToBounds : this._map.fitBounds;
                    // Ignore zoom events while setting the viewport as these would stop following
                    this._ignoreEvent = true;
                    f.bind(this._map)(this.options.getLocationBounds(this._event), {
                        padding: this.options.circlePadding,
                        maxZoom: this.options.initialZoomLevel || this.options.locateOptions.maxZoom
                    });
                    L1.Util.requestAnimFrame(function() {
                        // Wait until after the next animFrame because the flyTo can be async
                        this._ignoreEvent = false;
                    }, this);
                }
            }
        },
        /**
     *
     */ _drawCompass () {
            if (!this._event) return;
            const latlng = this._event.latlng;
            if (this.options.showCompass && latlng && this._compassHeading !== null) {
                const cStyle = this._isFollowing() ? this.options.followCompassStyle : this.options.compassStyle;
                if (!this._compass) this._compass = new this.options.compassClass(latlng, this._compassHeading, cStyle).addTo(this._layer);
                else {
                    this._compass.setLatLng(latlng);
                    this._compass.setHeading(this._compassHeading);
                    // If the compassClass can be updated with setStyle, update it.
                    if (this._compass.setStyle) this._compass.setStyle(cStyle);
                }
            //
            }
            if (this._compass && (!this.options.showCompass || this._compassHeading === null)) {
                this._compass.removeFrom(this._layer);
                this._compass = null;
            }
        },
        /**
     * Draw the marker and accuracy circle on the map.
     *
     * Uses the event retrieved from onLocationFound from the map.
     */ _drawMarker () {
            if (this._event.accuracy === undefined) this._event.accuracy = 0;
            const radius = this._event.accuracy;
            const latlng = this._event.latlng;
            // circle with the radius of the location's accuracy
            if (this.options.drawCircle) {
                const style = this._isFollowing() ? this.options.followCircleStyle : this.options.circleStyle;
                if (!this._circle) this._circle = L1.circle(latlng, radius, style).addTo(this._layer);
                else this._circle.setLatLng(latlng).setRadius(radius).setStyle(style);
            }
            let distance;
            let unit;
            if (this.options.metric) {
                distance = radius.toFixed(0);
                unit = this.options.strings.metersUnit;
            } else {
                distance = (radius * 3.2808399).toFixed(0);
                unit = this.options.strings.feetUnit;
            }
            // small inner marker
            if (this.options.drawMarker) {
                const mStyle = this._isFollowing() ? this.options.followMarkerStyle : this.options.markerStyle;
                if (!this._marker) this._marker = new this.options.markerClass(latlng, mStyle).addTo(this._layer);
                else {
                    this._marker.setLatLng(latlng);
                    // If the markerClass can be updated with setStyle, update it.
                    if (this._marker.setStyle) this._marker.setStyle(mStyle);
                }
            }
            this._drawCompass();
            const t = this.options.strings.popup;
            function getPopupText() {
                if (typeof t === "string") return L1.Util.template(t, {
                    distance: distance,
                    unit: unit
                });
                else if (typeof t === "function") return t({
                    distance: distance,
                    unit: unit
                });
                else return t;
            }
            if (this.options.showPopup && t && this._marker) this._marker.bindPopup(getPopupText())._popup.setLatLng(latlng);
            if (this.options.showPopup && t && this._compass) this._compass.bindPopup(getPopupText())._popup.setLatLng(latlng);
        },
        /**
     * Remove the marker from map.
     */ _removeMarker () {
            this._layer.clearLayers();
            this._marker = undefined;
            this._circle = undefined;
        },
        /**
     * Unload the plugin and all event listeners.
     * Kind of the opposite of onAdd.
     */ _unload () {
            this.stop();
            // May become undefined during HMR
            if (this._map) this._map.off("unload", this._unload, this);
        },
        /**
     * Sets the compass heading
     */ _setCompassHeading (angle) {
            if (!isNaN(parseFloat(angle)) && isFinite(angle)) {
                angle = Math.round(angle);
                this._compassHeading = angle;
                L1.Util.requestAnimFrame(this._drawCompass, this);
            } else this._compassHeading = null;
        },
        /**
     * If the compass fails calibration just fail safely and remove the compass
     */ _onCompassNeedsCalibration () {
            this._setCompassHeading();
        },
        /**
     * Process and normalise compass events
     */ _onDeviceOrientation (e) {
            if (!this._active) return;
            if (e.webkitCompassHeading) // iOS
            this._setCompassHeading(e.webkitCompassHeading);
            else if (e.absolute && e.alpha) // Android
            this._setCompassHeading(360 - e.alpha);
        },
        /**
     * Calls deactivate and dispatches an error.
     */ _onLocationError (err) {
            // ignore time out error if the location is watched
            if (err.code == 3 && this.options.locateOptions.watch) return;
            this.stop();
            this.options.onLocationError(err, this);
        },
        /**
     * Stores the received event and updates the marker.
     */ _onLocationFound (e) {
            // no need to do anything if the location has not changed
            if (this._event && this._event.latlng.lat === e.latlng.lat && this._event.latlng.lng === e.latlng.lng && this._event.accuracy === e.accuracy) return;
            if (!this._active) // we may have a stray event
            return;
            this._event = e;
            this._drawMarker();
            this._updateContainerStyle();
            switch(this.options.setView){
                case "once":
                    if (this._justClicked) this.setView();
                    break;
                case "untilPan":
                    if (!this._userPanned) this.setView();
                    break;
                case "untilPanOrZoom":
                    if (!this._userPanned && !this._userZoomed) this.setView();
                    break;
                case "always":
                    this.setView();
                    break;
                case false:
                    break;
            }
            this._justClicked = false;
        },
        /**
     * When the user drags. Need a separate event so we can bind and unbind event listeners.
     */ _onDrag () {
            // only react to drags once we have a location
            if (this._event && !this._ignoreEvent) {
                this._userPanned = true;
                this._updateContainerStyle();
                this._drawMarker();
            }
        },
        /**
     * When the user zooms. Need a separate event so we can bind and unbind event listeners.
     */ _onZoom () {
            // only react to drags once we have a location
            if (this._event && !this._ignoreEvent) {
                this._userZoomed = true;
                this._updateContainerStyle();
                this._drawMarker();
            }
        },
        /**
     * After a zoom ends update the compass and handle sideways zooms
     */ _onZoomEnd () {
            if (this._event) this._drawCompass();
            if (this._event && !this._ignoreEvent) // If we have zoomed in and out and ended up sideways treat it as a pan
            {
                if (this._marker && !this._map.getBounds().pad(-0.3).contains(this._marker.getLatLng())) {
                    this._userPanned = true;
                    this._updateContainerStyle();
                    this._drawMarker();
                }
            }
        },
        /**
     * Compute whether the map is following the user location with pan and zoom.
     */ _isFollowing () {
            if (!this._active) return false;
            if (this.options.setView === "always") return true;
            else if (this.options.setView === "untilPan") return !this._userPanned;
            else if (this.options.setView === "untilPanOrZoom") return !this._userPanned && !this._userZoomed;
        },
        /**
     * Check if location is in map bounds
     */ _isOutsideMapBounds () {
            if (this._event === undefined) return false;
            return this._map.options.maxBounds && !this._map.options.maxBounds.contains(this._event.latlng);
        },
        /**
     * Toggles button class between following and active.
     */ _updateContainerStyle () {
            if (!this._container) return;
            if (this._active && !this._event) // active but don't have a location yet
            this._setClasses("requesting");
            else if (this._isFollowing()) this._setClasses("following");
            else if (this._active) this._setClasses("active");
            else this._cleanClasses();
        },
        /**
     * Sets the CSS classes for the state.
     */ _setClasses (state) {
            if (state == "requesting") {
                removeClasses(this._container, "active following");
                addClasses(this._container, "requesting");
                removeClasses(this._icon, this.options.icon);
                addClasses(this._icon, this.options.iconLoading);
            } else if (state == "active") {
                removeClasses(this._container, "requesting following");
                addClasses(this._container, "active");
                removeClasses(this._icon, this.options.iconLoading);
                addClasses(this._icon, this.options.icon);
            } else if (state == "following") {
                removeClasses(this._container, "requesting");
                addClasses(this._container, "active following");
                removeClasses(this._icon, this.options.iconLoading);
                addClasses(this._icon, this.options.icon);
            }
        },
        /**
     * Removes all classes from button.
     */ _cleanClasses () {
            L1.DomUtil.removeClass(this._container, "requesting");
            L1.DomUtil.removeClass(this._container, "active");
            L1.DomUtil.removeClass(this._container, "following");
            removeClasses(this._icon, this.options.iconLoading);
            addClasses(this._icon, this.options.icon);
        },
        /**
     * Reinitializes state variables.
     */ _resetVariables () {
            // whether locate is active or not
            this._active = false;
            // true if the control was clicked for the first time
            // we need this so we can pan and zoom once we have the location
            this._justClicked = false;
            // true if the user has panned the map after clicking the control
            this._userPanned = false;
            // true if the user has zoomed the map after clicking the control
            this._userZoomed = false;
        }
    });
    L1.control.locate = (options)=>new L1.Control.Locate(options);
    return LocateControl;
}, window);



var $5ewvA = parcelRequire("5ewvA");

var $gYLTL = parcelRequire("gYLTL");


var $j5Ozl = parcelRequire("j5Ozl");
var $645b7147683636d0$exports = {};
/* @preserve
 * Leaflet 1.9.4, a JS library for interactive maps. https://leafletjs.com
 * (c) 2010-2023 Vladimir Agafonkin, (c) 2010-2011 CloudMade
 */ !function(t, e) {
    e($645b7147683636d0$exports);
}($645b7147683636d0$exports, function(t) {
    "use strict";
    function l(t) {
        for(var e, i, n = 1, o = arguments.length; n < o; n++)for(e in i = arguments[n])t[e] = i[e];
        return t;
    }
    var R = Object.create || function(t) {
        return N.prototype = t, new N;
    };
    function N() {}
    function a(t, e) {
        var i, n = Array.prototype.slice;
        return t.bind ? t.bind.apply(t, n.call(arguments, 1)) : (i = n.call(arguments, 2), function() {
            return t.apply(e, i.length ? i.concat(n.call(arguments)) : arguments);
        });
    }
    var D = 0;
    function h(t) {
        return "_leaflet_id" in t || (t._leaflet_id = ++D), t._leaflet_id;
    }
    function j(t, e, i) {
        var n, o, s = function() {
            n = !1, o && (r.apply(i, o), o = !1);
        }, r = function() {
            n ? o = arguments : (t.apply(i, arguments), setTimeout(s, e), n = !0);
        };
        return r;
    }
    function H(t, e, i) {
        var n = e[1], e = e[0], o = n - e;
        return t === n && i ? t : ((t - e) % o + o) % o + e;
    }
    function u() {
        return !1;
    }
    function i(t, e) {
        return !1 === e ? t : (e = Math.pow(10, void 0 === e ? 6 : e), Math.round(t * e) / e);
    }
    function W(t) {
        return t.trim ? t.trim() : t.replace(/^\s+|\s+$/g, "");
    }
    function F(t) {
        return W(t).split(/\s+/);
    }
    function c(t, e) {
        for(var i in Object.prototype.hasOwnProperty.call(t, "options") || (t.options = t.options ? R(t.options) : {}), e)t.options[i] = e[i];
        return t.options;
    }
    function U(t, e, i) {
        var n, o = [];
        for(n in t)o.push(encodeURIComponent(i ? n.toUpperCase() : n) + "=" + encodeURIComponent(t[n]));
        return (e && -1 !== e.indexOf("?") ? "&" : "?") + o.join("&");
    }
    var V = /\{ *([\w_ -]+) *\}/g;
    function q(t, i) {
        return t.replace(V, function(t, e) {
            e = i[e];
            if (void 0 === e) throw new Error("No value provided for variable " + t);
            return e = "function" == typeof e ? e(i) : e;
        });
    }
    var d = Array.isArray || function(t) {
        return "[object Array]" === Object.prototype.toString.call(t);
    };
    function G(t, e) {
        for(var i = 0; i < t.length; i++)if (t[i] === e) return i;
        return -1;
    }
    var K = "data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=";
    function Y(t) {
        return window["webkit" + t] || window["moz" + t] || window["ms" + t];
    }
    var X = 0;
    function J(t) {
        var e = +new Date, i = Math.max(0, 16 - (e - X));
        return X = e + i, window.setTimeout(t, i);
    }
    var $ = window.requestAnimationFrame || Y("RequestAnimationFrame") || J, Q = window.cancelAnimationFrame || Y("CancelAnimationFrame") || Y("CancelRequestAnimationFrame") || function(t) {
        window.clearTimeout(t);
    };
    function x(t, e, i) {
        if (!i || $ !== J) return $.call(window, a(t, e));
        t.call(e);
    }
    function r(t) {
        t && Q.call(window, t);
    }
    var tt = {
        __proto__: null,
        extend: l,
        create: R,
        bind: a,
        get lastId () {
            return D;
        },
        stamp: h,
        throttle: j,
        wrapNum: H,
        falseFn: u,
        formatNum: i,
        trim: W,
        splitWords: F,
        setOptions: c,
        getParamString: U,
        template: q,
        isArray: d,
        indexOf: G,
        emptyImageUrl: K,
        requestFn: $,
        cancelFn: Q,
        requestAnimFrame: x,
        cancelAnimFrame: r
    };
    function et() {}
    et.extend = function(t) {
        function e() {
            c(this), this.initialize && this.initialize.apply(this, arguments), this.callInitHooks();
        }
        var i, n = e.__super__ = this.prototype, o = R(n);
        for(i in (o.constructor = e).prototype = o, this)Object.prototype.hasOwnProperty.call(this, i) && "prototype" !== i && "__super__" !== i && (e[i] = this[i]);
        if (t.statics && l(e, t.statics), t.includes) {
            var s = t.includes;
            if ("undefined" != typeof L && L && L.Mixin) {
                s = d(s) ? s : [
                    s
                ];
                for(var r = 0; r < s.length; r++)s[r] === L.Mixin.Events && console.warn("Deprecated include of L.Mixin.Events: this property will be removed in future releases, please inherit from L.Evented instead.", (new Error).stack);
            }
            l.apply(null, [
                o
            ].concat(t.includes));
        }
        return l(o, t), delete o.statics, delete o.includes, o.options && (o.options = n.options ? R(n.options) : {}, l(o.options, t.options)), o._initHooks = [], o.callInitHooks = function() {
            if (!this._initHooksCalled) {
                n.callInitHooks && n.callInitHooks.call(this), this._initHooksCalled = !0;
                for(var t = 0, e = o._initHooks.length; t < e; t++)o._initHooks[t].call(this);
            }
        }, e;
    }, et.include = function(t) {
        var e = this.prototype.options;
        return l(this.prototype, t), t.options && (this.prototype.options = e, this.mergeOptions(t.options)), this;
    }, et.mergeOptions = function(t) {
        return l(this.prototype.options, t), this;
    }, et.addInitHook = function(t) {
        var e = Array.prototype.slice.call(arguments, 1), i = "function" == typeof t ? t : function() {
            this[t].apply(this, e);
        };
        return this.prototype._initHooks = this.prototype._initHooks || [], this.prototype._initHooks.push(i), this;
    };
    var e = {
        on: function(t, e, i) {
            if ("object" == typeof t) for(var n in t)this._on(n, t[n], e);
            else for(var o = 0, s = (t = F(t)).length; o < s; o++)this._on(t[o], e, i);
            return this;
        },
        off: function(t, e, i) {
            if (arguments.length) {
                if ("object" == typeof t) for(var n in t)this._off(n, t[n], e);
                else {
                    t = F(t);
                    for(var o = 1 === arguments.length, s = 0, r = t.length; s < r; s++)o ? this._off(t[s]) : this._off(t[s], e, i);
                }
            } else delete this._events;
            return this;
        },
        _on: function(t, e, i, n) {
            "function" != typeof e ? console.warn("wrong listener type: " + typeof e) : !1 === this._listens(t, e, i) && (e = {
                fn: e,
                ctx: i = i === this ? void 0 : i
            }, n && (e.once = !0), this._events = this._events || {}, this._events[t] = this._events[t] || [], this._events[t].push(e));
        },
        _off: function(t, e, i) {
            var n, o, s;
            if (this._events && (n = this._events[t])) {
                if (1 === arguments.length) {
                    if (this._firingCount) for(o = 0, s = n.length; o < s; o++)n[o].fn = u;
                    delete this._events[t];
                } else "function" != typeof e ? console.warn("wrong listener type: " + typeof e) : !1 !== (e = this._listens(t, e, i)) && (i = n[e], this._firingCount && (i.fn = u, this._events[t] = n = n.slice()), n.splice(e, 1));
            }
        },
        fire: function(t, e, i) {
            if (this.listens(t, i)) {
                var n = l({}, e, {
                    type: t,
                    target: this,
                    sourceTarget: e && e.sourceTarget || this
                });
                if (this._events) {
                    var o = this._events[t];
                    if (o) {
                        this._firingCount = this._firingCount + 1 || 1;
                        for(var s = 0, r = o.length; s < r; s++){
                            var a = o[s], h = a.fn;
                            a.once && this.off(t, h, a.ctx), h.call(a.ctx || this, n);
                        }
                        this._firingCount--;
                    }
                }
                i && this._propagateEvent(n);
            }
            return this;
        },
        listens: function(t, e, i, n) {
            "string" != typeof t && console.warn('"string" type argument expected');
            var o = e, s = ("function" != typeof e && (n = !!e, i = o = void 0), this._events && this._events[t]);
            if (s && s.length && !1 !== this._listens(t, o, i)) return !0;
            if (n) {
                for(var r in this._eventParents)if (this._eventParents[r].listens(t, e, i, n)) return !0;
            }
            return !1;
        },
        _listens: function(t, e, i) {
            if (this._events) {
                var n = this._events[t] || [];
                if (!e) return !!n.length;
                i === this && (i = void 0);
                for(var o = 0, s = n.length; o < s; o++)if (n[o].fn === e && n[o].ctx === i) return o;
            }
            return !1;
        },
        once: function(t, e, i) {
            if ("object" == typeof t) for(var n in t)this._on(n, t[n], e, !0);
            else for(var o = 0, s = (t = F(t)).length; o < s; o++)this._on(t[o], e, i, !0);
            return this;
        },
        addEventParent: function(t) {
            return this._eventParents = this._eventParents || {}, this._eventParents[h(t)] = t, this;
        },
        removeEventParent: function(t) {
            return this._eventParents && delete this._eventParents[h(t)], this;
        },
        _propagateEvent: function(t) {
            for(var e in this._eventParents)this._eventParents[e].fire(t.type, l({
                layer: t.target,
                propagatedFrom: t.target
            }, t), !0);
        }
    }, it = (e.addEventListener = e.on, e.removeEventListener = e.clearAllEventListeners = e.off, e.addOneTimeEventListener = e.once, e.fireEvent = e.fire, e.hasEventListeners = e.listens, et.extend(e));
    function p(t, e, i) {
        this.x = i ? Math.round(t) : t, this.y = i ? Math.round(e) : e;
    }
    var nt = Math.trunc || function(t) {
        return 0 < t ? Math.floor(t) : Math.ceil(t);
    };
    function m(t, e, i) {
        return t instanceof p ? t : d(t) ? new p(t[0], t[1]) : null == t ? t : "object" == typeof t && "x" in t && "y" in t ? new p(t.x, t.y) : new p(t, e, i);
    }
    function f(t, e) {
        if (t) for(var i = e ? [
            t,
            e
        ] : t, n = 0, o = i.length; n < o; n++)this.extend(i[n]);
    }
    function _(t, e) {
        return !t || t instanceof f ? t : new f(t, e);
    }
    function s(t, e) {
        if (t) for(var i = e ? [
            t,
            e
        ] : t, n = 0, o = i.length; n < o; n++)this.extend(i[n]);
    }
    function g(t, e) {
        return t instanceof s ? t : new s(t, e);
    }
    function v(t, e, i) {
        if (isNaN(t) || isNaN(e)) throw new Error("Invalid LatLng object: (" + t + ", " + e + ")");
        this.lat = +t, this.lng = +e, void 0 !== i && (this.alt = +i);
    }
    function w(t, e, i) {
        return t instanceof v ? t : d(t) && "object" != typeof t[0] ? 3 === t.length ? new v(t[0], t[1], t[2]) : 2 === t.length ? new v(t[0], t[1]) : null : null == t ? t : "object" == typeof t && "lat" in t ? new v(t.lat, "lng" in t ? t.lng : t.lon, t.alt) : void 0 === e ? null : new v(t, e, i);
    }
    p.prototype = {
        clone: function() {
            return new p(this.x, this.y);
        },
        add: function(t) {
            return this.clone()._add(m(t));
        },
        _add: function(t) {
            return this.x += t.x, this.y += t.y, this;
        },
        subtract: function(t) {
            return this.clone()._subtract(m(t));
        },
        _subtract: function(t) {
            return this.x -= t.x, this.y -= t.y, this;
        },
        divideBy: function(t) {
            return this.clone()._divideBy(t);
        },
        _divideBy: function(t) {
            return this.x /= t, this.y /= t, this;
        },
        multiplyBy: function(t) {
            return this.clone()._multiplyBy(t);
        },
        _multiplyBy: function(t) {
            return this.x *= t, this.y *= t, this;
        },
        scaleBy: function(t) {
            return new p(this.x * t.x, this.y * t.y);
        },
        unscaleBy: function(t) {
            return new p(this.x / t.x, this.y / t.y);
        },
        round: function() {
            return this.clone()._round();
        },
        _round: function() {
            return this.x = Math.round(this.x), this.y = Math.round(this.y), this;
        },
        floor: function() {
            return this.clone()._floor();
        },
        _floor: function() {
            return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this;
        },
        ceil: function() {
            return this.clone()._ceil();
        },
        _ceil: function() {
            return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this;
        },
        trunc: function() {
            return this.clone()._trunc();
        },
        _trunc: function() {
            return this.x = nt(this.x), this.y = nt(this.y), this;
        },
        distanceTo: function(t) {
            var e = (t = m(t)).x - this.x, t = t.y - this.y;
            return Math.sqrt(e * e + t * t);
        },
        equals: function(t) {
            return (t = m(t)).x === this.x && t.y === this.y;
        },
        contains: function(t) {
            return t = m(t), Math.abs(t.x) <= Math.abs(this.x) && Math.abs(t.y) <= Math.abs(this.y);
        },
        toString: function() {
            return "Point(" + i(this.x) + ", " + i(this.y) + ")";
        }
    }, f.prototype = {
        extend: function(t) {
            var e, i;
            if (t) {
                if (t instanceof p || "number" == typeof t[0] || "x" in t) e = i = m(t);
                else if (e = (t = _(t)).min, i = t.max, !e || !i) return this;
                this.min || this.max ? (this.min.x = Math.min(e.x, this.min.x), this.max.x = Math.max(i.x, this.max.x), this.min.y = Math.min(e.y, this.min.y), this.max.y = Math.max(i.y, this.max.y)) : (this.min = e.clone(), this.max = i.clone());
            }
            return this;
        },
        getCenter: function(t) {
            return m((this.min.x + this.max.x) / 2, (this.min.y + this.max.y) / 2, t);
        },
        getBottomLeft: function() {
            return m(this.min.x, this.max.y);
        },
        getTopRight: function() {
            return m(this.max.x, this.min.y);
        },
        getTopLeft: function() {
            return this.min;
        },
        getBottomRight: function() {
            return this.max;
        },
        getSize: function() {
            return this.max.subtract(this.min);
        },
        contains: function(t) {
            var e, i;
            return (t = ("number" == typeof t[0] || t instanceof p ? m : _)(t)) instanceof f ? (e = t.min, i = t.max) : e = i = t, e.x >= this.min.x && i.x <= this.max.x && e.y >= this.min.y && i.y <= this.max.y;
        },
        intersects: function(t) {
            t = _(t);
            var e = this.min, i = this.max, n = t.min, t = t.max, o = t.x >= e.x && n.x <= i.x, t = t.y >= e.y && n.y <= i.y;
            return o && t;
        },
        overlaps: function(t) {
            t = _(t);
            var e = this.min, i = this.max, n = t.min, t = t.max, o = t.x > e.x && n.x < i.x, t = t.y > e.y && n.y < i.y;
            return o && t;
        },
        isValid: function() {
            return !(!this.min || !this.max);
        },
        pad: function(t) {
            var e = this.min, i = this.max, n = Math.abs(e.x - i.x) * t, t = Math.abs(e.y - i.y) * t;
            return _(m(e.x - n, e.y - t), m(i.x + n, i.y + t));
        },
        equals: function(t) {
            return !!t && (t = _(t), this.min.equals(t.getTopLeft()) && this.max.equals(t.getBottomRight()));
        }
    }, s.prototype = {
        extend: function(t) {
            var e, i, n = this._southWest, o = this._northEast;
            if (t instanceof v) i = e = t;
            else {
                if (!(t instanceof s)) return t ? this.extend(w(t) || g(t)) : this;
                if (e = t._southWest, i = t._northEast, !e || !i) return this;
            }
            return n || o ? (n.lat = Math.min(e.lat, n.lat), n.lng = Math.min(e.lng, n.lng), o.lat = Math.max(i.lat, o.lat), o.lng = Math.max(i.lng, o.lng)) : (this._southWest = new v(e.lat, e.lng), this._northEast = new v(i.lat, i.lng)), this;
        },
        pad: function(t) {
            var e = this._southWest, i = this._northEast, n = Math.abs(e.lat - i.lat) * t, t = Math.abs(e.lng - i.lng) * t;
            return new s(new v(e.lat - n, e.lng - t), new v(i.lat + n, i.lng + t));
        },
        getCenter: function() {
            return new v((this._southWest.lat + this._northEast.lat) / 2, (this._southWest.lng + this._northEast.lng) / 2);
        },
        getSouthWest: function() {
            return this._southWest;
        },
        getNorthEast: function() {
            return this._northEast;
        },
        getNorthWest: function() {
            return new v(this.getNorth(), this.getWest());
        },
        getSouthEast: function() {
            return new v(this.getSouth(), this.getEast());
        },
        getWest: function() {
            return this._southWest.lng;
        },
        getSouth: function() {
            return this._southWest.lat;
        },
        getEast: function() {
            return this._northEast.lng;
        },
        getNorth: function() {
            return this._northEast.lat;
        },
        contains: function(t) {
            t = ("number" == typeof t[0] || t instanceof v || "lat" in t ? w : g)(t);
            var e, i, n = this._southWest, o = this._northEast;
            return t instanceof s ? (e = t.getSouthWest(), i = t.getNorthEast()) : e = i = t, e.lat >= n.lat && i.lat <= o.lat && e.lng >= n.lng && i.lng <= o.lng;
        },
        intersects: function(t) {
            t = g(t);
            var e = this._southWest, i = this._northEast, n = t.getSouthWest(), t = t.getNorthEast(), o = t.lat >= e.lat && n.lat <= i.lat, t = t.lng >= e.lng && n.lng <= i.lng;
            return o && t;
        },
        overlaps: function(t) {
            t = g(t);
            var e = this._southWest, i = this._northEast, n = t.getSouthWest(), t = t.getNorthEast(), o = t.lat > e.lat && n.lat < i.lat, t = t.lng > e.lng && n.lng < i.lng;
            return o && t;
        },
        toBBoxString: function() {
            return [
                this.getWest(),
                this.getSouth(),
                this.getEast(),
                this.getNorth()
            ].join(",");
        },
        equals: function(t, e) {
            return !!t && (t = g(t), this._southWest.equals(t.getSouthWest(), e) && this._northEast.equals(t.getNorthEast(), e));
        },
        isValid: function() {
            return !(!this._southWest || !this._northEast);
        }
    };
    var ot = {
        latLngToPoint: function(t, e) {
            t = this.projection.project(t), e = this.scale(e);
            return this.transformation._transform(t, e);
        },
        pointToLatLng: function(t, e) {
            e = this.scale(e), t = this.transformation.untransform(t, e);
            return this.projection.unproject(t);
        },
        project: function(t) {
            return this.projection.project(t);
        },
        unproject: function(t) {
            return this.projection.unproject(t);
        },
        scale: function(t) {
            return 256 * Math.pow(2, t);
        },
        zoom: function(t) {
            return Math.log(t / 256) / Math.LN2;
        },
        getProjectedBounds: function(t) {
            var e;
            return this.infinite ? null : (e = this.projection.bounds, t = this.scale(t), new f(this.transformation.transform(e.min, t), this.transformation.transform(e.max, t)));
        },
        infinite: (v.prototype = {
            equals: function(t, e) {
                return !!t && (t = w(t), Math.max(Math.abs(this.lat - t.lat), Math.abs(this.lng - t.lng)) <= (void 0 === e ? 1e-9 : e));
            },
            toString: function(t) {
                return "LatLng(" + i(this.lat, t) + ", " + i(this.lng, t) + ")";
            },
            distanceTo: function(t) {
                return st.distance(this, w(t));
            },
            wrap: function() {
                return st.wrapLatLng(this);
            },
            toBounds: function(t) {
                var t = 180 * t / 40075017, e = t / Math.cos(Math.PI / 180 * this.lat);
                return g([
                    this.lat - t,
                    this.lng - e
                ], [
                    this.lat + t,
                    this.lng + e
                ]);
            },
            clone: function() {
                return new v(this.lat, this.lng, this.alt);
            }
        }, false),
        wrapLatLng: function(t) {
            var e = this.wrapLng ? H(t.lng, this.wrapLng, !0) : t.lng;
            return new v(this.wrapLat ? H(t.lat, this.wrapLat, !0) : t.lat, e, t.alt);
        },
        wrapLatLngBounds: function(t) {
            var e = t.getCenter(), i = this.wrapLatLng(e), n = e.lat - i.lat, e = e.lng - i.lng;
            return 0 == n && 0 == e ? t : (i = t.getSouthWest(), t = t.getNorthEast(), new s(new v(i.lat - n, i.lng - e), new v(t.lat - n, t.lng - e)));
        }
    }, st = l({}, ot, {
        wrapLng: [
            -180,
            180
        ],
        R: 6371e3,
        distance: function(t, e) {
            var i = Math.PI / 180, n = t.lat * i, o = e.lat * i, s = Math.sin((e.lat - t.lat) * i / 2), e = Math.sin((e.lng - t.lng) * i / 2), t = s * s + Math.cos(n) * Math.cos(o) * e * e, i = 2 * Math.atan2(Math.sqrt(t), Math.sqrt(1 - t));
            return this.R * i;
        }
    }), rt = 6378137, rt = {
        R: rt,
        MAX_LATITUDE: 85.0511287798,
        project: function(t) {
            var e = Math.PI / 180, i = this.MAX_LATITUDE, i = Math.max(Math.min(i, t.lat), -i), i = Math.sin(i * e);
            return new p(this.R * t.lng * e, this.R * Math.log((1 + i) / (1 - i)) / 2);
        },
        unproject: function(t) {
            var e = 180 / Math.PI;
            return new v((2 * Math.atan(Math.exp(t.y / this.R)) - Math.PI / 2) * e, t.x * e / this.R);
        },
        bounds: new f([
            -(rt = rt * Math.PI),
            -rt
        ], [
            rt,
            rt
        ])
    };
    function at(t, e, i, n) {
        d(t) ? (this._a = t[0], this._b = t[1], this._c = t[2], this._d = t[3]) : (this._a = t, this._b = e, this._c = i, this._d = n);
    }
    function ht(t, e, i, n) {
        return new at(t, e, i, n);
    }
    at.prototype = {
        transform: function(t, e) {
            return this._transform(t.clone(), e);
        },
        _transform: function(t, e) {
            return t.x = (e = e || 1) * (this._a * t.x + this._b), t.y = e * (this._c * t.y + this._d), t;
        },
        untransform: function(t, e) {
            return new p((t.x / (e = e || 1) - this._b) / this._a, (t.y / e - this._d) / this._c);
        }
    };
    var lt = l({}, st, {
        code: "EPSG:3857",
        projection: rt,
        transformation: ht(lt = .5 / (Math.PI * rt.R), .5, -lt, .5)
    }), ut = l({}, lt, {
        code: "EPSG:900913"
    });
    function ct(t) {
        return document.createElementNS("http://www.w3.org/2000/svg", t);
    }
    function dt(t, e) {
        for(var i, n, o, s, r = "", a = 0, h = t.length; a < h; a++){
            for(i = 0, n = (o = t[a]).length; i < n; i++)r += (i ? "L" : "M") + (s = o[i]).x + " " + s.y;
            r += e ? b.svg ? "z" : "x" : "";
        }
        return r || "M0 0";
    }
    var _t = document.documentElement.style, pt = "ActiveXObject" in window, mt = pt && !document.addEventListener, n = "msLaunchUri" in navigator && !("documentMode" in document), ft = y("webkit"), gt = y("android"), vt = y("android 2") || y("android 3"), yt = parseInt(/WebKit\/([0-9]+)|$/.exec(navigator.userAgent)[1], 10), yt = gt && y("Google") && yt < 537 && !("AudioNode" in window), xt = !!window.opera, wt = !n && y("chrome"), bt = y("gecko") && !ft && !xt && !pt, Pt = !wt && y("safari"), Lt = y("phantom"), o = "OTransition" in _t, Tt = 0 === navigator.platform.indexOf("Win"), Mt = pt && "transition" in _t, zt = "WebKitCSSMatrix" in window && "m11" in new window.WebKitCSSMatrix && !vt, _t = "MozPerspective" in _t, Ct = !window.L_DISABLE_3D && (Mt || zt || _t) && !o && !Lt, Zt = "undefined" != typeof orientation || y("mobile"), St = Zt && ft, Et = Zt && zt, kt = !window.PointerEvent && window.MSPointerEvent, Ot = !(!window.PointerEvent && !kt), At = "ontouchstart" in window || !!window.TouchEvent, Bt = !window.L_NO_TOUCH && (At || Ot), It = Zt && xt, Rt = Zt && bt, Nt = 1 < (window.devicePixelRatio || window.screen.deviceXDPI / window.screen.logicalXDPI), Dt = function() {
        var t = !1;
        try {
            var e = Object.defineProperty({}, "passive", {
                get: function() {
                    t = !0;
                }
            });
            window.addEventListener("testPassiveEventSupport", u, e), window.removeEventListener("testPassiveEventSupport", u, e);
        } catch (t) {}
        return t;
    }(), jt = !!document.createElement("canvas").getContext, Ht = !(!document.createElementNS || !ct("svg").createSVGRect), Wt = !!Ht && ((Wt = document.createElement("div")).innerHTML = "<svg/>", "http://www.w3.org/2000/svg" === (Wt.firstChild && Wt.firstChild.namespaceURI));
    function y(t) {
        return 0 <= navigator.userAgent.toLowerCase().indexOf(t);
    }
    var b = {
        ie: pt,
        ielt9: mt,
        edge: n,
        webkit: ft,
        android: gt,
        android23: vt,
        androidStock: yt,
        opera: xt,
        chrome: wt,
        gecko: bt,
        safari: Pt,
        phantom: Lt,
        opera12: o,
        win: Tt,
        ie3d: Mt,
        webkit3d: zt,
        gecko3d: _t,
        any3d: Ct,
        mobile: Zt,
        mobileWebkit: St,
        mobileWebkit3d: Et,
        msPointer: kt,
        pointer: Ot,
        touch: Bt,
        touchNative: At,
        mobileOpera: It,
        mobileGecko: Rt,
        retina: Nt,
        passiveEvents: Dt,
        canvas: jt,
        svg: Ht,
        vml: !Ht && function() {
            try {
                var t = document.createElement("div"), e = (t.innerHTML = '<v:shape adj="1"/>', t.firstChild);
                return e.style.behavior = "url(#default#VML)", e && "object" == typeof e.adj;
            } catch (t) {
                return !1;
            }
        }(),
        inlineSvg: Wt,
        mac: 0 === navigator.platform.indexOf("Mac"),
        linux: 0 === navigator.platform.indexOf("Linux")
    }, Ft = b.msPointer ? "MSPointerDown" : "pointerdown", Ut = b.msPointer ? "MSPointerMove" : "pointermove", Vt = b.msPointer ? "MSPointerUp" : "pointerup", qt = b.msPointer ? "MSPointerCancel" : "pointercancel", Gt = {
        touchstart: Ft,
        touchmove: Ut,
        touchend: Vt,
        touchcancel: qt
    }, Kt = {
        touchstart: function(t, e) {
            e.MSPOINTER_TYPE_TOUCH && e.pointerType === e.MSPOINTER_TYPE_TOUCH && O(e);
            ee(t, e);
        },
        touchmove: ee,
        touchend: ee,
        touchcancel: ee
    }, Yt = {}, Xt = !1;
    function Jt(t, e, i) {
        return "touchstart" !== e || Xt || (document.addEventListener(Ft, $t, !0), document.addEventListener(Ut, Qt, !0), document.addEventListener(Vt, te, !0), document.addEventListener(qt, te, !0), Xt = !0), Kt[e] ? (i = Kt[e].bind(this, i), t.addEventListener(Gt[e], i, !1), i) : (console.warn("wrong event specified:", e), u);
    }
    function $t(t) {
        Yt[t.pointerId] = t;
    }
    function Qt(t) {
        Yt[t.pointerId] && (Yt[t.pointerId] = t);
    }
    function te(t) {
        delete Yt[t.pointerId];
    }
    function ee(t, e) {
        if (e.pointerType !== (e.MSPOINTER_TYPE_MOUSE || "mouse")) {
            for(var i in e.touches = [], Yt)e.touches.push(Yt[i]);
            e.changedTouches = [
                e
            ], t(e);
        }
    }
    var ie = 200;
    function ne(t, i) {
        t.addEventListener("dblclick", i);
        var n, o = 0;
        function e(t) {
            var e;
            1 !== t.detail ? n = t.detail : "mouse" === t.pointerType || t.sourceCapabilities && !t.sourceCapabilities.firesTouchEvents || (e = Ne(t)).some(function(t) {
                return t instanceof HTMLLabelElement && t.attributes.for;
            }) && !e.some(function(t) {
                return t instanceof HTMLInputElement || t instanceof HTMLSelectElement;
            }) || ((e = Date.now()) - o <= ie ? 2 === ++n && i(function(t) {
                var e, i, n = {};
                for(i in t)e = t[i], n[i] = e && e.bind ? e.bind(t) : e;
                return (t = n).type = "dblclick", n.detail = 2, n.isTrusted = !1, n._simulated = !0, n;
            }(t)) : n = 1, o = e);
        }
        return t.addEventListener("click", e), {
            dblclick: i,
            simDblclick: e
        };
    }
    var oe, se, re, ae, he, le, ue = we([
        "transform",
        "webkitTransform",
        "OTransform",
        "MozTransform",
        "msTransform"
    ]), ce = we([
        "webkitTransition",
        "transition",
        "OTransition",
        "MozTransition",
        "msTransition"
    ]), de = "webkitTransition" === ce || "OTransition" === ce ? ce + "End" : "transitionend";
    function _e(t) {
        return "string" == typeof t ? document.getElementById(t) : t;
    }
    function pe(t, e) {
        var i = t.style[e] || t.currentStyle && t.currentStyle[e];
        return "auto" === (i = i && "auto" !== i || !document.defaultView ? i : (t = document.defaultView.getComputedStyle(t, null)) ? t[e] : null) ? null : i;
    }
    function P(t, e, i) {
        t = document.createElement(t);
        return t.className = e || "", i && i.appendChild(t), t;
    }
    function T(t) {
        var e = t.parentNode;
        e && e.removeChild(t);
    }
    function me(t) {
        for(; t.firstChild;)t.removeChild(t.firstChild);
    }
    function fe(t) {
        var e = t.parentNode;
        e && e.lastChild !== t && e.appendChild(t);
    }
    function ge(t) {
        var e = t.parentNode;
        e && e.firstChild !== t && e.insertBefore(t, e.firstChild);
    }
    function ve(t, e) {
        return void 0 !== t.classList ? t.classList.contains(e) : 0 < (t = xe(t)).length && new RegExp("(^|\\s)" + e + "(\\s|$)").test(t);
    }
    function M(t, e) {
        var i;
        if (void 0 !== t.classList) for(var n = F(e), o = 0, s = n.length; o < s; o++)t.classList.add(n[o]);
        else ve(t, e) || ye(t, ((i = xe(t)) ? i + " " : "") + e);
    }
    function z(t, e) {
        void 0 !== t.classList ? t.classList.remove(e) : ye(t, W((" " + xe(t) + " ").replace(" " + e + " ", " ")));
    }
    function ye(t, e) {
        void 0 === t.className.baseVal ? t.className = e : t.className.baseVal = e;
    }
    function xe(t) {
        return void 0 === (t = t.correspondingElement ? t.correspondingElement : t).className.baseVal ? t.className : t.className.baseVal;
    }
    function C(t, e) {
        if ("opacity" in t.style) t.style.opacity = e;
        else if ("filter" in t.style) {
            var i = !1, n = "DXImageTransform.Microsoft.Alpha";
            try {
                i = t.filters.item(n);
            } catch (t) {
                if (1 === e) return;
            }
            e = Math.round(100 * e), i ? (i.Enabled = 100 !== e, i.Opacity = e) : t.style.filter += " progid:" + n + "(opacity=" + e + ")";
        }
    }
    function we(t) {
        for(var e = document.documentElement.style, i = 0; i < t.length; i++)if (t[i] in e) return t[i];
        return !1;
    }
    function be(t, e, i) {
        e = e || new p(0, 0);
        t.style[ue] = (b.ie3d ? "translate(" + e.x + "px," + e.y + "px)" : "translate3d(" + e.x + "px," + e.y + "px,0)") + (i ? " scale(" + i + ")" : "");
    }
    function Z(t, e) {
        t._leaflet_pos = e, b.any3d ? be(t, e) : (t.style.left = e.x + "px", t.style.top = e.y + "px");
    }
    function Pe(t) {
        return t._leaflet_pos || new p(0, 0);
    }
    function Le() {
        S(window, "dragstart", O);
    }
    function Te() {
        k(window, "dragstart", O);
    }
    function Me(t) {
        for(; -1 === t.tabIndex;)t = t.parentNode;
        t.style && (ze(), le = (he = t).style.outlineStyle, t.style.outlineStyle = "none", S(window, "keydown", ze));
    }
    function ze() {
        he && (he.style.outlineStyle = le, le = he = void 0, k(window, "keydown", ze));
    }
    function Ce(t) {
        for(; !((t = t.parentNode).offsetWidth && t.offsetHeight || t === document.body););
        return t;
    }
    function Ze(t) {
        var e = t.getBoundingClientRect();
        return {
            x: e.width / t.offsetWidth || 1,
            y: e.height / t.offsetHeight || 1,
            boundingClientRect: e
        };
    }
    ae = "onselectstart" in document ? (re = function() {
        S(window, "selectstart", O);
    }, function() {
        k(window, "selectstart", O);
    }) : (se = we([
        "userSelect",
        "WebkitUserSelect",
        "OUserSelect",
        "MozUserSelect",
        "msUserSelect"
    ]), re = function() {
        var t;
        se && (t = document.documentElement.style, oe = t[se], t[se] = "none");
    }, function() {
        se && (document.documentElement.style[se] = oe, oe = void 0);
    });
    pt = {
        __proto__: null,
        TRANSFORM: ue,
        TRANSITION: ce,
        TRANSITION_END: de,
        get: _e,
        getStyle: pe,
        create: P,
        remove: T,
        empty: me,
        toFront: fe,
        toBack: ge,
        hasClass: ve,
        addClass: M,
        removeClass: z,
        setClass: ye,
        getClass: xe,
        setOpacity: C,
        testProp: we,
        setTransform: be,
        setPosition: Z,
        getPosition: Pe,
        get disableTextSelection () {
            return re;
        },
        get enableTextSelection () {
            return ae;
        },
        disableImageDrag: Le,
        enableImageDrag: Te,
        preventOutline: Me,
        restoreOutline: ze,
        getSizedParentNode: Ce,
        getScale: Ze
    };
    function S(t, e, i, n) {
        if (e && "object" == typeof e) for(var o in e)ke(t, o, e[o], i);
        else for(var s = 0, r = (e = F(e)).length; s < r; s++)ke(t, e[s], i, n);
        return this;
    }
    var E = "_leaflet_events";
    function k(t, e, i, n) {
        if (1 === arguments.length) Se(t), delete t[E];
        else if (e && "object" == typeof e) for(var o in e)Oe(t, o, e[o], i);
        else if (e = F(e), 2 === arguments.length) Se(t, function(t) {
            return -1 !== G(e, t);
        });
        else for(var s = 0, r = e.length; s < r; s++)Oe(t, e[s], i, n);
        return this;
    }
    function Se(t, e) {
        for(var i in t[E]){
            var n = i.split(/\d/)[0];
            e && !e(n) || Oe(t, n, null, null, i);
        }
    }
    var Ee = {
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        wheel: !("onwheel" in window) && "mousewheel"
    };
    function ke(e, t, i, n) {
        var o, s, r = t + h(i) + (n ? "_" + h(n) : "");
        e[E] && e[E][r] || (s = o = function(t) {
            return i.call(n || e, t || window.event);
        }, !b.touchNative && b.pointer && 0 === t.indexOf("touch") ? o = Jt(e, t, o) : b.touch && "dblclick" === t ? o = ne(e, o) : "addEventListener" in e ? "touchstart" === t || "touchmove" === t || "wheel" === t || "mousewheel" === t ? e.addEventListener(Ee[t] || t, o, !!b.passiveEvents && {
            passive: !1
        }) : "mouseenter" === t || "mouseleave" === t ? e.addEventListener(Ee[t], o = function(t) {
            t = t || window.event, We(e, t) && s(t);
        }, !1) : e.addEventListener(t, s, !1) : e.attachEvent("on" + t, o), e[E] = e[E] || {}, e[E][r] = o);
    }
    function Oe(t, e, i, n, o) {
        o = o || e + h(i) + (n ? "_" + h(n) : "");
        var s, r, i = t[E] && t[E][o];
        i && (!b.touchNative && b.pointer && 0 === e.indexOf("touch") ? (n = t, r = i, Gt[s = e] ? n.removeEventListener(Gt[s], r, !1) : console.warn("wrong event specified:", s)) : b.touch && "dblclick" === e ? (n = i, (r = t).removeEventListener("dblclick", n.dblclick), r.removeEventListener("click", n.simDblclick)) : "removeEventListener" in t ? t.removeEventListener(Ee[e] || e, i, !1) : t.detachEvent("on" + e, i), t[E][o] = null);
    }
    function Ae(t) {
        return t.stopPropagation ? t.stopPropagation() : t.originalEvent ? t.originalEvent._stopped = !0 : t.cancelBubble = !0, this;
    }
    function Be(t) {
        return ke(t, "wheel", Ae), this;
    }
    function Ie(t) {
        return S(t, "mousedown touchstart dblclick contextmenu", Ae), t._leaflet_disable_click = !0, this;
    }
    function O(t) {
        return t.preventDefault ? t.preventDefault() : t.returnValue = !1, this;
    }
    function Re(t) {
        return O(t), Ae(t), this;
    }
    function Ne(t) {
        if (t.composedPath) return t.composedPath();
        for(var e = [], i = t.target; i;)e.push(i), i = i.parentNode;
        return e;
    }
    function De(t, e) {
        var i, n;
        return e ? (n = (i = Ze(e)).boundingClientRect, new p((t.clientX - n.left) / i.x - e.clientLeft, (t.clientY - n.top) / i.y - e.clientTop)) : new p(t.clientX, t.clientY);
    }
    var je = b.linux && b.chrome ? window.devicePixelRatio : b.mac ? 3 * window.devicePixelRatio : 0 < window.devicePixelRatio ? 2 * window.devicePixelRatio : 1;
    function He(t) {
        return b.edge ? t.wheelDeltaY / 2 : t.deltaY && 0 === t.deltaMode ? -t.deltaY / je : t.deltaY && 1 === t.deltaMode ? 20 * -t.deltaY : t.deltaY && 2 === t.deltaMode ? 60 * -t.deltaY : t.deltaX || t.deltaZ ? 0 : t.wheelDelta ? (t.wheelDeltaY || t.wheelDelta) / 2 : t.detail && Math.abs(t.detail) < 32765 ? 20 * -t.detail : t.detail ? t.detail / -32765 * 60 : 0;
    }
    function We(t, e) {
        var i = e.relatedTarget;
        if (!i) return !0;
        try {
            for(; i && i !== t;)i = i.parentNode;
        } catch (t) {
            return !1;
        }
        return i !== t;
    }
    var mt = {
        __proto__: null,
        on: S,
        off: k,
        stopPropagation: Ae,
        disableScrollPropagation: Be,
        disableClickPropagation: Ie,
        preventDefault: O,
        stop: Re,
        getPropagationPath: Ne,
        getMousePosition: De,
        getWheelDelta: He,
        isExternalTarget: We,
        addListener: S,
        removeListener: k
    }, Fe = it.extend({
        run: function(t, e, i, n) {
            this.stop(), this._el = t, this._inProgress = !0, this._duration = i || .25, this._easeOutPower = 1 / Math.max(n || .5, .2), this._startPos = Pe(t), this._offset = e.subtract(this._startPos), this._startTime = +new Date, this.fire("start"), this._animate();
        },
        stop: function() {
            this._inProgress && (this._step(!0), this._complete());
        },
        _animate: function() {
            this._animId = x(this._animate, this), this._step();
        },
        _step: function(t) {
            var e = +new Date - this._startTime, i = 1e3 * this._duration;
            e < i ? this._runFrame(this._easeOut(e / i), t) : (this._runFrame(1), this._complete());
        },
        _runFrame: function(t, e) {
            t = this._startPos.add(this._offset.multiplyBy(t));
            e && t._round(), Z(this._el, t), this.fire("step");
        },
        _complete: function() {
            r(this._animId), this._inProgress = !1, this.fire("end");
        },
        _easeOut: function(t) {
            return 1 - Math.pow(1 - t, this._easeOutPower);
        }
    }), A = it.extend({
        options: {
            crs: lt,
            center: void 0,
            zoom: void 0,
            minZoom: void 0,
            maxZoom: void 0,
            layers: [],
            maxBounds: void 0,
            renderer: void 0,
            zoomAnimation: !0,
            zoomAnimationThreshold: 4,
            fadeAnimation: !0,
            markerZoomAnimation: !0,
            transform3DLimit: 8388608,
            zoomSnap: 1,
            zoomDelta: 1,
            trackResize: !0
        },
        initialize: function(t, e) {
            e = c(this, e), this._handlers = [], this._layers = {}, this._zoomBoundLayers = {}, this._sizeChanged = !0, this._initContainer(t), this._initLayout(), this._onResize = a(this._onResize, this), this._initEvents(), e.maxBounds && this.setMaxBounds(e.maxBounds), void 0 !== e.zoom && (this._zoom = this._limitZoom(e.zoom)), e.center && void 0 !== e.zoom && this.setView(w(e.center), e.zoom, {
                reset: !0
            }), this.callInitHooks(), this._zoomAnimated = ce && b.any3d && !b.mobileOpera && this.options.zoomAnimation, this._zoomAnimated && (this._createAnimProxy(), S(this._proxy, de, this._catchTransitionEnd, this)), this._addLayers(this.options.layers);
        },
        setView: function(t, e, i) {
            if ((e = void 0 === e ? this._zoom : this._limitZoom(e), t = this._limitCenter(w(t), e, this.options.maxBounds), i = i || {}, this._stop(), this._loaded && !i.reset && !0 !== i) && (void 0 !== i.animate && (i.zoom = l({
                animate: i.animate
            }, i.zoom), i.pan = l({
                animate: i.animate,
                duration: i.duration
            }, i.pan)), this._zoom !== e ? this._tryAnimatedZoom && this._tryAnimatedZoom(t, e, i.zoom) : this._tryAnimatedPan(t, i.pan))) return clearTimeout(this._sizeTimer), this;
            return this._resetView(t, e, i.pan && i.pan.noMoveStart), this;
        },
        setZoom: function(t, e) {
            return this._loaded ? this.setView(this.getCenter(), t, {
                zoom: e
            }) : (this._zoom = t, this);
        },
        zoomIn: function(t, e) {
            return t = t || (b.any3d ? this.options.zoomDelta : 1), this.setZoom(this._zoom + t, e);
        },
        zoomOut: function(t, e) {
            return t = t || (b.any3d ? this.options.zoomDelta : 1), this.setZoom(this._zoom - t, e);
        },
        setZoomAround: function(t, e, i) {
            var n = this.getZoomScale(e), o = this.getSize().divideBy(2), t = (t instanceof p ? t : this.latLngToContainerPoint(t)).subtract(o).multiplyBy(1 - 1 / n), n = this.containerPointToLatLng(o.add(t));
            return this.setView(n, e, {
                zoom: i
            });
        },
        _getBoundsCenterZoom: function(t, e) {
            e = e || {}, t = t.getBounds ? t.getBounds() : g(t);
            var i = m(e.paddingTopLeft || e.padding || [
                0,
                0
            ]), n = m(e.paddingBottomRight || e.padding || [
                0,
                0
            ]), o = this.getBoundsZoom(t, !1, i.add(n));
            return (o = "number" == typeof e.maxZoom ? Math.min(e.maxZoom, o) : o) === 1 / 0 ? {
                center: t.getCenter(),
                zoom: o
            } : (e = n.subtract(i).divideBy(2), n = this.project(t.getSouthWest(), o), i = this.project(t.getNorthEast(), o), {
                center: this.unproject(n.add(i).divideBy(2).add(e), o),
                zoom: o
            });
        },
        fitBounds: function(t, e) {
            if ((t = g(t)).isValid()) return t = this._getBoundsCenterZoom(t, e), this.setView(t.center, t.zoom, e);
            throw new Error("Bounds are not valid.");
        },
        fitWorld: function(t) {
            return this.fitBounds([
                [
                    -90,
                    -180
                ],
                [
                    90,
                    180
                ]
            ], t);
        },
        panTo: function(t, e) {
            return this.setView(t, this._zoom, {
                pan: e
            });
        },
        panBy: function(t, e) {
            var i;
            return e = e || {}, (t = m(t).round()).x || t.y ? (!0 === e.animate || this.getSize().contains(t) ? (this._panAnim || (this._panAnim = new Fe, this._panAnim.on({
                step: this._onPanTransitionStep,
                end: this._onPanTransitionEnd
            }, this)), e.noMoveStart || this.fire("movestart"), !1 !== e.animate ? (M(this._mapPane, "leaflet-pan-anim"), i = this._getMapPanePos().subtract(t).round(), this._panAnim.run(this._mapPane, i, e.duration || .25, e.easeLinearity)) : (this._rawPanBy(t), this.fire("move").fire("moveend"))) : this._resetView(this.unproject(this.project(this.getCenter()).add(t)), this.getZoom()), this) : this.fire("moveend");
        },
        flyTo: function(n, o, t) {
            if (!1 === (t = t || {}).animate || !b.any3d) return this.setView(n, o, t);
            this._stop();
            var s = this.project(this.getCenter()), r = this.project(n), e = this.getSize(), a = this._zoom, h = (n = w(n), o = void 0 === o ? a : o, Math.max(e.x, e.y)), i = h * this.getZoomScale(a, o), l = r.distanceTo(s) || 1, u = 1.42, c = u * u;
            function d(t) {
                t = (i * i - h * h + (t ? -1 : 1) * c * c * l * l) / (2 * (t ? i : h) * c * l), t = Math.sqrt(t * t + 1) - t;
                return t < 1e-9 ? -18 : Math.log(t);
            }
            function _(t) {
                return (Math.exp(t) - Math.exp(-t)) / 2;
            }
            function p(t) {
                return (Math.exp(t) + Math.exp(-t)) / 2;
            }
            var m = d(0);
            function f(t) {
                return h * (p(m) * (_(t = m + u * t) / p(t)) - _(m)) / c;
            }
            var g = Date.now(), v = (d(1) - m) / u, y = t.duration ? 1e3 * t.duration : 1e3 * v * .8;
            return this._moveStart(!0, t.noMoveStart), (function t() {
                var e = (Date.now() - g) / y, i = (1 - Math.pow(1 - e, 1.5)) * v;
                e <= 1 ? (this._flyToFrame = x(t, this), this._move(this.unproject(s.add(r.subtract(s).multiplyBy(f(i) / l)), a), this.getScaleZoom(h / (e = i, h * (p(m) / p(m + u * e))), a), {
                    flyTo: !0
                })) : this._move(n, o)._moveEnd(!0);
            }).call(this), this;
        },
        flyToBounds: function(t, e) {
            t = this._getBoundsCenterZoom(t, e);
            return this.flyTo(t.center, t.zoom, e);
        },
        setMaxBounds: function(t) {
            return t = g(t), this.listens("moveend", this._panInsideMaxBounds) && this.off("moveend", this._panInsideMaxBounds), t.isValid() ? (this.options.maxBounds = t, this._loaded && this._panInsideMaxBounds(), this.on("moveend", this._panInsideMaxBounds)) : (this.options.maxBounds = null, this);
        },
        setMinZoom: function(t) {
            var e = this.options.minZoom;
            return this.options.minZoom = t, this._loaded && e !== t && (this.fire("zoomlevelschange"), this.getZoom() < this.options.minZoom) ? this.setZoom(t) : this;
        },
        setMaxZoom: function(t) {
            var e = this.options.maxZoom;
            return this.options.maxZoom = t, this._loaded && e !== t && (this.fire("zoomlevelschange"), this.getZoom() > this.options.maxZoom) ? this.setZoom(t) : this;
        },
        panInsideBounds: function(t, e) {
            this._enforcingBounds = !0;
            var i = this.getCenter(), t = this._limitCenter(i, this._zoom, g(t));
            return i.equals(t) || this.panTo(t, e), this._enforcingBounds = !1, this;
        },
        panInside: function(t, e) {
            var i = m((e = e || {}).paddingTopLeft || e.padding || [
                0,
                0
            ]), n = m(e.paddingBottomRight || e.padding || [
                0,
                0
            ]), o = this.project(this.getCenter()), t = this.project(t), s = this.getPixelBounds(), i = _([
                s.min.add(i),
                s.max.subtract(n)
            ]), s = i.getSize();
            return i.contains(t) || (this._enforcingBounds = !0, n = t.subtract(i.getCenter()), i = i.extend(t).getSize().subtract(s), o.x += n.x < 0 ? -i.x : i.x, o.y += n.y < 0 ? -i.y : i.y, this.panTo(this.unproject(o), e), this._enforcingBounds = !1), this;
        },
        invalidateSize: function(t) {
            if (!this._loaded) return this;
            t = l({
                animate: !1,
                pan: !0
            }, !0 === t ? {
                animate: !0
            } : t);
            var e = this.getSize(), i = (this._sizeChanged = !0, this._lastCenter = null, this.getSize()), n = e.divideBy(2).round(), o = i.divideBy(2).round(), n = n.subtract(o);
            return n.x || n.y ? (t.animate && t.pan ? this.panBy(n) : (t.pan && this._rawPanBy(n), this.fire("move"), t.debounceMoveend ? (clearTimeout(this._sizeTimer), this._sizeTimer = setTimeout(a(this.fire, this, "moveend"), 200)) : this.fire("moveend")), this.fire("resize", {
                oldSize: e,
                newSize: i
            })) : this;
        },
        stop: function() {
            return this.setZoom(this._limitZoom(this._zoom)), this.options.zoomSnap || this.fire("viewreset"), this._stop();
        },
        locate: function(t) {
            var e, i;
            return t = this._locateOptions = l({
                timeout: 1e4,
                watch: !1
            }, t), "geolocation" in navigator ? (e = a(this._handleGeolocationResponse, this), i = a(this._handleGeolocationError, this), t.watch ? this._locationWatchId = navigator.geolocation.watchPosition(e, i, t) : navigator.geolocation.getCurrentPosition(e, i, t)) : this._handleGeolocationError({
                code: 0,
                message: "Geolocation not supported."
            }), this;
        },
        stopLocate: function() {
            return navigator.geolocation && navigator.geolocation.clearWatch && navigator.geolocation.clearWatch(this._locationWatchId), this._locateOptions && (this._locateOptions.setView = !1), this;
        },
        _handleGeolocationError: function(t) {
            var e;
            this._container._leaflet_id && (e = t.code, t = t.message || (1 === e ? "permission denied" : 2 === e ? "position unavailable" : "timeout"), this._locateOptions.setView && !this._loaded && this.fitWorld(), this.fire("locationerror", {
                code: e,
                message: "Geolocation error: " + t + "."
            }));
        },
        _handleGeolocationResponse: function(t) {
            if (this._container._leaflet_id) {
                var e, i, n = new v(t.coords.latitude, t.coords.longitude), o = n.toBounds(2 * t.coords.accuracy), s = this._locateOptions, r = (s.setView && (e = this.getBoundsZoom(o), this.setView(n, s.maxZoom ? Math.min(e, s.maxZoom) : e)), {
                    latlng: n,
                    bounds: o,
                    timestamp: t.timestamp
                });
                for(i in t.coords)"number" == typeof t.coords[i] && (r[i] = t.coords[i]);
                this.fire("locationfound", r);
            }
        },
        addHandler: function(t, e) {
            return e && (e = this[t] = new e(this), this._handlers.push(e), this.options[t] && e.enable()), this;
        },
        remove: function() {
            if (this._initEvents(!0), this.options.maxBounds && this.off("moveend", this._panInsideMaxBounds), this._containerId !== this._container._leaflet_id) throw new Error("Map container is being reused by another instance");
            try {
                delete this._container._leaflet_id, delete this._containerId;
            } catch (t) {
                this._container._leaflet_id = void 0, this._containerId = void 0;
            }
            for(var t1 in void 0 !== this._locationWatchId && this.stopLocate(), this._stop(), T(this._mapPane), this._clearControlPos && this._clearControlPos(), this._resizeRequest && (r(this._resizeRequest), this._resizeRequest = null), this._clearHandlers(), this._loaded && this.fire("unload"), this._layers)this._layers[t1].remove();
            for(t in this._panes)T(this._panes[t]);
            return this._layers = [], this._panes = [], delete this._mapPane, delete this._renderer, this;
        },
        createPane: function(t, e) {
            e = P("div", "leaflet-pane" + (t ? " leaflet-" + t.replace("Pane", "") + "-pane" : ""), e || this._mapPane);
            return t && (this._panes[t] = e), e;
        },
        getCenter: function() {
            return this._checkIfLoaded(), this._lastCenter && !this._moved() ? this._lastCenter.clone() : this.layerPointToLatLng(this._getCenterLayerPoint());
        },
        getZoom: function() {
            return this._zoom;
        },
        getBounds: function() {
            var t = this.getPixelBounds();
            return new s(this.unproject(t.getBottomLeft()), this.unproject(t.getTopRight()));
        },
        getMinZoom: function() {
            return void 0 === this.options.minZoom ? this._layersMinZoom || 0 : this.options.minZoom;
        },
        getMaxZoom: function() {
            return void 0 === this.options.maxZoom ? void 0 === this._layersMaxZoom ? 1 / 0 : this._layersMaxZoom : this.options.maxZoom;
        },
        getBoundsZoom: function(t, e, i) {
            t = g(t), i = m(i || [
                0,
                0
            ]);
            var n = this.getZoom() || 0, o = this.getMinZoom(), s = this.getMaxZoom(), r = t.getNorthWest(), t = t.getSouthEast(), i = this.getSize().subtract(i), t = _(this.project(t, n), this.project(r, n)).getSize(), r = b.any3d ? this.options.zoomSnap : 1, a = i.x / t.x, i = i.y / t.y, t = e ? Math.max(a, i) : Math.min(a, i), n = this.getScaleZoom(t, n);
            return r && (n = Math.round(n / (r / 100)) * (r / 100), n = e ? Math.ceil(n / r) * r : Math.floor(n / r) * r), Math.max(o, Math.min(s, n));
        },
        getSize: function() {
            return this._size && !this._sizeChanged || (this._size = new p(this._container.clientWidth || 0, this._container.clientHeight || 0), this._sizeChanged = !1), this._size.clone();
        },
        getPixelBounds: function(t, e) {
            t = this._getTopLeftPoint(t, e);
            return new f(t, t.add(this.getSize()));
        },
        getPixelOrigin: function() {
            return this._checkIfLoaded(), this._pixelOrigin;
        },
        getPixelWorldBounds: function(t) {
            return this.options.crs.getProjectedBounds(void 0 === t ? this.getZoom() : t);
        },
        getPane: function(t) {
            return "string" == typeof t ? this._panes[t] : t;
        },
        getPanes: function() {
            return this._panes;
        },
        getContainer: function() {
            return this._container;
        },
        getZoomScale: function(t, e) {
            var i = this.options.crs;
            return e = void 0 === e ? this._zoom : e, i.scale(t) / i.scale(e);
        },
        getScaleZoom: function(t, e) {
            var i = this.options.crs, t = (e = void 0 === e ? this._zoom : e, i.zoom(t * i.scale(e)));
            return isNaN(t) ? 1 / 0 : t;
        },
        project: function(t, e) {
            return e = void 0 === e ? this._zoom : e, this.options.crs.latLngToPoint(w(t), e);
        },
        unproject: function(t, e) {
            return e = void 0 === e ? this._zoom : e, this.options.crs.pointToLatLng(m(t), e);
        },
        layerPointToLatLng: function(t) {
            t = m(t).add(this.getPixelOrigin());
            return this.unproject(t);
        },
        latLngToLayerPoint: function(t) {
            return this.project(w(t))._round()._subtract(this.getPixelOrigin());
        },
        wrapLatLng: function(t) {
            return this.options.crs.wrapLatLng(w(t));
        },
        wrapLatLngBounds: function(t) {
            return this.options.crs.wrapLatLngBounds(g(t));
        },
        distance: function(t, e) {
            return this.options.crs.distance(w(t), w(e));
        },
        containerPointToLayerPoint: function(t) {
            return m(t).subtract(this._getMapPanePos());
        },
        layerPointToContainerPoint: function(t) {
            return m(t).add(this._getMapPanePos());
        },
        containerPointToLatLng: function(t) {
            t = this.containerPointToLayerPoint(m(t));
            return this.layerPointToLatLng(t);
        },
        latLngToContainerPoint: function(t) {
            return this.layerPointToContainerPoint(this.latLngToLayerPoint(w(t)));
        },
        mouseEventToContainerPoint: function(t) {
            return De(t, this._container);
        },
        mouseEventToLayerPoint: function(t) {
            return this.containerPointToLayerPoint(this.mouseEventToContainerPoint(t));
        },
        mouseEventToLatLng: function(t) {
            return this.layerPointToLatLng(this.mouseEventToLayerPoint(t));
        },
        _initContainer: function(t) {
            t = this._container = _e(t);
            if (!t) throw new Error("Map container not found.");
            if (t._leaflet_id) throw new Error("Map container is already initialized.");
            S(t, "scroll", this._onScroll, this), this._containerId = h(t);
        },
        _initLayout: function() {
            var t = this._container, e = (this._fadeAnimated = this.options.fadeAnimation && b.any3d, M(t, "leaflet-container" + (b.touch ? " leaflet-touch" : "") + (b.retina ? " leaflet-retina" : "") + (b.ielt9 ? " leaflet-oldie" : "") + (b.safari ? " leaflet-safari" : "") + (this._fadeAnimated ? " leaflet-fade-anim" : "")), pe(t, "position"));
            "absolute" !== e && "relative" !== e && "fixed" !== e && "sticky" !== e && (t.style.position = "relative"), this._initPanes(), this._initControlPos && this._initControlPos();
        },
        _initPanes: function() {
            var t = this._panes = {};
            this._paneRenderers = {}, this._mapPane = this.createPane("mapPane", this._container), Z(this._mapPane, new p(0, 0)), this.createPane("tilePane"), this.createPane("overlayPane"), this.createPane("shadowPane"), this.createPane("markerPane"), this.createPane("tooltipPane"), this.createPane("popupPane"), this.options.markerZoomAnimation || (M(t.markerPane, "leaflet-zoom-hide"), M(t.shadowPane, "leaflet-zoom-hide"));
        },
        _resetView: function(t, e, i) {
            Z(this._mapPane, new p(0, 0));
            var n = !this._loaded, o = (this._loaded = !0, e = this._limitZoom(e), this.fire("viewprereset"), this._zoom !== e);
            this._moveStart(o, i)._move(t, e)._moveEnd(o), this.fire("viewreset"), n && this.fire("load");
        },
        _moveStart: function(t, e) {
            return t && this.fire("zoomstart"), e || this.fire("movestart"), this;
        },
        _move: function(t, e, i, n) {
            void 0 === e && (e = this._zoom);
            var o = this._zoom !== e;
            return this._zoom = e, this._lastCenter = t, this._pixelOrigin = this._getNewPixelOrigin(t), n ? i && i.pinch && this.fire("zoom", i) : ((o || i && i.pinch) && this.fire("zoom", i), this.fire("move", i)), this;
        },
        _moveEnd: function(t) {
            return t && this.fire("zoomend"), this.fire("moveend");
        },
        _stop: function() {
            return r(this._flyToFrame), this._panAnim && this._panAnim.stop(), this;
        },
        _rawPanBy: function(t) {
            Z(this._mapPane, this._getMapPanePos().subtract(t));
        },
        _getZoomSpan: function() {
            return this.getMaxZoom() - this.getMinZoom();
        },
        _panInsideMaxBounds: function() {
            this._enforcingBounds || this.panInsideBounds(this.options.maxBounds);
        },
        _checkIfLoaded: function() {
            if (!this._loaded) throw new Error("Set map center and zoom first.");
        },
        _initEvents: function(t) {
            this._targets = {};
            var e = t ? k : S;
            e((this._targets[h(this._container)] = this)._container, "click dblclick mousedown mouseup mouseover mouseout mousemove contextmenu keypress keydown keyup", this._handleDOMEvent, this), this.options.trackResize && e(window, "resize", this._onResize, this), b.any3d && this.options.transform3DLimit && (t ? this.off : this.on).call(this, "moveend", this._onMoveEnd);
        },
        _onResize: function() {
            r(this._resizeRequest), this._resizeRequest = x(function() {
                this.invalidateSize({
                    debounceMoveend: !0
                });
            }, this);
        },
        _onScroll: function() {
            this._container.scrollTop = 0, this._container.scrollLeft = 0;
        },
        _onMoveEnd: function() {
            var t = this._getMapPanePos();
            Math.max(Math.abs(t.x), Math.abs(t.y)) >= this.options.transform3DLimit && this._resetView(this.getCenter(), this.getZoom());
        },
        _findEventTargets: function(t, e) {
            for(var i, n = [], o = "mouseout" === e || "mouseover" === e, s = t.target || t.srcElement, r = !1; s;){
                if ((i = this._targets[h(s)]) && ("click" === e || "preclick" === e) && this._draggableMoved(i)) {
                    r = !0;
                    break;
                }
                if (i && i.listens(e, !0)) {
                    if (o && !We(s, t)) break;
                    if (n.push(i), o) break;
                }
                if (s === this._container) break;
                s = s.parentNode;
            }
            return n = n.length || r || o || !this.listens(e, !0) ? n : [
                this
            ];
        },
        _isClickDisabled: function(t) {
            for(; t && t !== this._container;){
                if (t._leaflet_disable_click) return !0;
                t = t.parentNode;
            }
        },
        _handleDOMEvent: function(t) {
            var e, i = t.target || t.srcElement;
            !this._loaded || i._leaflet_disable_events || "click" === t.type && this._isClickDisabled(i) || ("mousedown" === (e = t.type) && Me(i), this._fireDOMEvent(t, e));
        },
        _mouseEvents: [
            "click",
            "dblclick",
            "mouseover",
            "mouseout",
            "contextmenu"
        ],
        _fireDOMEvent: function(t, e, i) {
            "click" === t.type && ((a = l({}, t)).type = "preclick", this._fireDOMEvent(a, a.type, i));
            var n = this._findEventTargets(t, e);
            if (i) {
                for(var o = [], s = 0; s < i.length; s++)i[s].listens(e, !0) && o.push(i[s]);
                n = o.concat(n);
            }
            if (n.length) {
                "contextmenu" === e && O(t);
                var r, a = n[0], h = {
                    originalEvent: t
                };
                for("keypress" !== t.type && "keydown" !== t.type && "keyup" !== t.type && (r = a.getLatLng && (!a._radius || a._radius <= 10), h.containerPoint = r ? this.latLngToContainerPoint(a.getLatLng()) : this.mouseEventToContainerPoint(t), h.layerPoint = this.containerPointToLayerPoint(h.containerPoint), h.latlng = r ? a.getLatLng() : this.layerPointToLatLng(h.layerPoint)), s = 0; s < n.length; s++)if (n[s].fire(e, h, !0), h.originalEvent._stopped || !1 === n[s].options.bubblingMouseEvents && -1 !== G(this._mouseEvents, e)) return;
            }
        },
        _draggableMoved: function(t) {
            return (t = t.dragging && t.dragging.enabled() ? t : this).dragging && t.dragging.moved() || this.boxZoom && this.boxZoom.moved();
        },
        _clearHandlers: function() {
            for(var t = 0, e = this._handlers.length; t < e; t++)this._handlers[t].disable();
        },
        whenReady: function(t, e) {
            return this._loaded ? t.call(e || this, {
                target: this
            }) : this.on("load", t, e), this;
        },
        _getMapPanePos: function() {
            return Pe(this._mapPane) || new p(0, 0);
        },
        _moved: function() {
            var t = this._getMapPanePos();
            return t && !t.equals([
                0,
                0
            ]);
        },
        _getTopLeftPoint: function(t, e) {
            return (t && void 0 !== e ? this._getNewPixelOrigin(t, e) : this.getPixelOrigin()).subtract(this._getMapPanePos());
        },
        _getNewPixelOrigin: function(t, e) {
            var i = this.getSize()._divideBy(2);
            return this.project(t, e)._subtract(i)._add(this._getMapPanePos())._round();
        },
        _latLngToNewLayerPoint: function(t, e, i) {
            i = this._getNewPixelOrigin(i, e);
            return this.project(t, e)._subtract(i);
        },
        _latLngBoundsToNewLayerBounds: function(t, e, i) {
            i = this._getNewPixelOrigin(i, e);
            return _([
                this.project(t.getSouthWest(), e)._subtract(i),
                this.project(t.getNorthWest(), e)._subtract(i),
                this.project(t.getSouthEast(), e)._subtract(i),
                this.project(t.getNorthEast(), e)._subtract(i)
            ]);
        },
        _getCenterLayerPoint: function() {
            return this.containerPointToLayerPoint(this.getSize()._divideBy(2));
        },
        _getCenterOffset: function(t) {
            return this.latLngToLayerPoint(t).subtract(this._getCenterLayerPoint());
        },
        _limitCenter: function(t, e, i) {
            var n, o;
            return !i || (n = this.project(t, e), o = this.getSize().divideBy(2), o = new f(n.subtract(o), n.add(o)), o = this._getBoundsOffset(o, i, e), Math.abs(o.x) <= 1 && Math.abs(o.y) <= 1) ? t : this.unproject(n.add(o), e);
        },
        _limitOffset: function(t, e) {
            var i;
            return e ? (i = new f((i = this.getPixelBounds()).min.add(t), i.max.add(t)), t.add(this._getBoundsOffset(i, e))) : t;
        },
        _getBoundsOffset: function(t, e, i) {
            e = _(this.project(e.getNorthEast(), i), this.project(e.getSouthWest(), i)), i = e.min.subtract(t.min), e = e.max.subtract(t.max);
            return new p(this._rebound(i.x, -e.x), this._rebound(i.y, -e.y));
        },
        _rebound: function(t, e) {
            return 0 < t + e ? Math.round(t - e) / 2 : Math.max(0, Math.ceil(t)) - Math.max(0, Math.floor(e));
        },
        _limitZoom: function(t) {
            var e = this.getMinZoom(), i = this.getMaxZoom(), n = b.any3d ? this.options.zoomSnap : 1;
            return n && (t = Math.round(t / n) * n), Math.max(e, Math.min(i, t));
        },
        _onPanTransitionStep: function() {
            this.fire("move");
        },
        _onPanTransitionEnd: function() {
            z(this._mapPane, "leaflet-pan-anim"), this.fire("moveend");
        },
        _tryAnimatedPan: function(t, e) {
            t = this._getCenterOffset(t)._trunc();
            return !(!0 !== (e && e.animate) && !this.getSize().contains(t)) && (this.panBy(t, e), !0);
        },
        _createAnimProxy: function() {
            var t = this._proxy = P("div", "leaflet-proxy leaflet-zoom-animated");
            this._panes.mapPane.appendChild(t), this.on("zoomanim", function(t) {
                var e = ue, i = this._proxy.style[e];
                be(this._proxy, this.project(t.center, t.zoom), this.getZoomScale(t.zoom, 1)), i === this._proxy.style[e] && this._animatingZoom && this._onZoomTransitionEnd();
            }, this), this.on("load moveend", this._animMoveEnd, this), this._on("unload", this._destroyAnimProxy, this);
        },
        _destroyAnimProxy: function() {
            T(this._proxy), this.off("load moveend", this._animMoveEnd, this), delete this._proxy;
        },
        _animMoveEnd: function() {
            var t = this.getCenter(), e = this.getZoom();
            be(this._proxy, this.project(t, e), this.getZoomScale(e, 1));
        },
        _catchTransitionEnd: function(t) {
            this._animatingZoom && 0 <= t.propertyName.indexOf("transform") && this._onZoomTransitionEnd();
        },
        _nothingToAnimate: function() {
            return !this._container.getElementsByClassName("leaflet-zoom-animated").length;
        },
        _tryAnimatedZoom: function(t, e, i) {
            if (!this._animatingZoom) {
                if (i = i || {}, !this._zoomAnimated || !1 === i.animate || this._nothingToAnimate() || Math.abs(e - this._zoom) > this.options.zoomAnimationThreshold) return !1;
                var n = this.getZoomScale(e), n = this._getCenterOffset(t)._divideBy(1 - 1 / n);
                if (!0 !== i.animate && !this.getSize().contains(n)) return !1;
                x(function() {
                    this._moveStart(!0, i.noMoveStart || !1)._animateZoom(t, e, !0);
                }, this);
            }
            return !0;
        },
        _animateZoom: function(t, e, i, n) {
            this._mapPane && (i && (this._animatingZoom = !0, this._animateToCenter = t, this._animateToZoom = e, M(this._mapPane, "leaflet-zoom-anim")), this.fire("zoomanim", {
                center: t,
                zoom: e,
                noUpdate: n
            }), this._tempFireZoomEvent || (this._tempFireZoomEvent = this._zoom !== this._animateToZoom), this._move(this._animateToCenter, this._animateToZoom, void 0, !0), setTimeout(a(this._onZoomTransitionEnd, this), 250));
        },
        _onZoomTransitionEnd: function() {
            this._animatingZoom && (this._mapPane && z(this._mapPane, "leaflet-zoom-anim"), this._animatingZoom = !1, this._move(this._animateToCenter, this._animateToZoom, void 0, !0), this._tempFireZoomEvent && this.fire("zoom"), delete this._tempFireZoomEvent, this.fire("move"), this._moveEnd(!0));
        }
    });
    function Ue(t) {
        return new B(t);
    }
    var B = et.extend({
        options: {
            position: "topright"
        },
        initialize: function(t) {
            c(this, t);
        },
        getPosition: function() {
            return this.options.position;
        },
        setPosition: function(t) {
            var e = this._map;
            return e && e.removeControl(this), this.options.position = t, e && e.addControl(this), this;
        },
        getContainer: function() {
            return this._container;
        },
        addTo: function(t) {
            this.remove(), this._map = t;
            var e = this._container = this.onAdd(t), i = this.getPosition(), t = t._controlCorners[i];
            return M(e, "leaflet-control"), -1 !== i.indexOf("bottom") ? t.insertBefore(e, t.firstChild) : t.appendChild(e), this._map.on("unload", this.remove, this), this;
        },
        remove: function() {
            return this._map && (T(this._container), this.onRemove && this.onRemove(this._map), this._map.off("unload", this.remove, this), this._map = null), this;
        },
        _refocusOnMap: function(t) {
            this._map && t && 0 < t.screenX && 0 < t.screenY && this._map.getContainer().focus();
        }
    }), Ve = (A.include({
        addControl: function(t) {
            return t.addTo(this), this;
        },
        removeControl: function(t) {
            return t.remove(), this;
        },
        _initControlPos: function() {
            var i = this._controlCorners = {}, n = "leaflet-", o = this._controlContainer = P("div", n + "control-container", this._container);
            function t(t, e) {
                i[t + e] = P("div", n + t + " " + n + e, o);
            }
            t("top", "left"), t("top", "right"), t("bottom", "left"), t("bottom", "right");
        },
        _clearControlPos: function() {
            for(var t in this._controlCorners)T(this._controlCorners[t]);
            T(this._controlContainer), delete this._controlCorners, delete this._controlContainer;
        }
    }), B.extend({
        options: {
            collapsed: !0,
            position: "topright",
            autoZIndex: !0,
            hideSingleBase: !1,
            sortLayers: !1,
            sortFunction: function(t, e, i, n) {
                return i < n ? -1 : n < i ? 1 : 0;
            }
        },
        initialize: function(t, e, i) {
            for(var n in c(this, i), this._layerControlInputs = [], this._layers = [], this._lastZIndex = 0, this._handlingClick = !1, this._preventClick = !1, t)this._addLayer(t[n], n);
            for(n in e)this._addLayer(e[n], n, !0);
        },
        onAdd: function(t) {
            this._initLayout(), this._update(), (this._map = t).on("zoomend", this._checkDisabledLayers, this);
            for(var e = 0; e < this._layers.length; e++)this._layers[e].layer.on("add remove", this._onLayerChange, this);
            return this._container;
        },
        addTo: function(t) {
            return B.prototype.addTo.call(this, t), this._expandIfNotCollapsed();
        },
        onRemove: function() {
            this._map.off("zoomend", this._checkDisabledLayers, this);
            for(var t = 0; t < this._layers.length; t++)this._layers[t].layer.off("add remove", this._onLayerChange, this);
        },
        addBaseLayer: function(t, e) {
            return this._addLayer(t, e), this._map ? this._update() : this;
        },
        addOverlay: function(t, e) {
            return this._addLayer(t, e, !0), this._map ? this._update() : this;
        },
        removeLayer: function(t) {
            t.off("add remove", this._onLayerChange, this);
            t = this._getLayer(h(t));
            return t && this._layers.splice(this._layers.indexOf(t), 1), this._map ? this._update() : this;
        },
        expand: function() {
            M(this._container, "leaflet-control-layers-expanded"), this._section.style.height = null;
            var t = this._map.getSize().y - (this._container.offsetTop + 50);
            return t < this._section.clientHeight ? (M(this._section, "leaflet-control-layers-scrollbar"), this._section.style.height = t + "px") : z(this._section, "leaflet-control-layers-scrollbar"), this._checkDisabledLayers(), this;
        },
        collapse: function() {
            return z(this._container, "leaflet-control-layers-expanded"), this;
        },
        _initLayout: function() {
            var t = "leaflet-control-layers", e = this._container = P("div", t), i = this.options.collapsed, n = (e.setAttribute("aria-haspopup", !0), Ie(e), Be(e), this._section = P("section", t + "-list")), o = (i && (this._map.on("click", this.collapse, this), S(e, {
                mouseenter: this._expandSafely,
                mouseleave: this.collapse
            }, this)), this._layersLink = P("a", t + "-toggle", e));
            o.href = "#", o.title = "Layers", o.setAttribute("role", "button"), S(o, {
                keydown: function(t) {
                    13 === t.keyCode && this._expandSafely();
                },
                click: function(t) {
                    O(t), this._expandSafely();
                }
            }, this), i || this.expand(), this._baseLayersList = P("div", t + "-base", n), this._separator = P("div", t + "-separator", n), this._overlaysList = P("div", t + "-overlays", n), e.appendChild(n);
        },
        _getLayer: function(t) {
            for(var e = 0; e < this._layers.length; e++)if (this._layers[e] && h(this._layers[e].layer) === t) return this._layers[e];
        },
        _addLayer: function(t, e, i) {
            this._map && t.on("add remove", this._onLayerChange, this), this._layers.push({
                layer: t,
                name: e,
                overlay: i
            }), this.options.sortLayers && this._layers.sort(a(function(t, e) {
                return this.options.sortFunction(t.layer, e.layer, t.name, e.name);
            }, this)), this.options.autoZIndex && t.setZIndex && (this._lastZIndex++, t.setZIndex(this._lastZIndex)), this._expandIfNotCollapsed();
        },
        _update: function() {
            if (this._container) {
                me(this._baseLayersList), me(this._overlaysList), this._layerControlInputs = [];
                for(var t, e, i, n = 0, o = 0; o < this._layers.length; o++)i = this._layers[o], this._addItem(i), e = e || i.overlay, t = t || !i.overlay, n += i.overlay ? 0 : 1;
                this.options.hideSingleBase && (this._baseLayersList.style.display = (t = t && 1 < n) ? "" : "none"), this._separator.style.display = e && t ? "" : "none";
            }
            return this;
        },
        _onLayerChange: function(t) {
            this._handlingClick || this._update();
            var e = this._getLayer(h(t.target)), t = e.overlay ? "add" === t.type ? "overlayadd" : "overlayremove" : "add" === t.type ? "baselayerchange" : null;
            t && this._map.fire(t, e);
        },
        _createRadioElement: function(t, e) {
            t = '<input type="radio" class="leaflet-control-layers-selector" name="' + t + '"' + (e ? ' checked="checked"' : "") + "/>", e = document.createElement("div");
            return e.innerHTML = t, e.firstChild;
        },
        _addItem: function(t) {
            var e, i = document.createElement("label"), n = this._map.hasLayer(t.layer), n = (t.overlay ? ((e = document.createElement("input")).type = "checkbox", e.className = "leaflet-control-layers-selector", e.defaultChecked = n) : e = this._createRadioElement("leaflet-base-layers_" + h(this), n), this._layerControlInputs.push(e), e.layerId = h(t.layer), S(e, "click", this._onInputClick, this), document.createElement("span")), o = (n.innerHTML = " " + t.name, document.createElement("span"));
            return i.appendChild(o), o.appendChild(e), o.appendChild(n), (t.overlay ? this._overlaysList : this._baseLayersList).appendChild(i), this._checkDisabledLayers(), i;
        },
        _onInputClick: function() {
            if (!this._preventClick) {
                var t, e, i = this._layerControlInputs, n = [], o = [];
                this._handlingClick = !0;
                for(var s = i.length - 1; 0 <= s; s--)t = i[s], e = this._getLayer(t.layerId).layer, t.checked ? n.push(e) : t.checked || o.push(e);
                for(s = 0; s < o.length; s++)this._map.hasLayer(o[s]) && this._map.removeLayer(o[s]);
                for(s = 0; s < n.length; s++)this._map.hasLayer(n[s]) || this._map.addLayer(n[s]);
                this._handlingClick = !1, this._refocusOnMap();
            }
        },
        _checkDisabledLayers: function() {
            for(var t, e, i = this._layerControlInputs, n = this._map.getZoom(), o = i.length - 1; 0 <= o; o--)t = i[o], e = this._getLayer(t.layerId).layer, t.disabled = void 0 !== e.options.minZoom && n < e.options.minZoom || void 0 !== e.options.maxZoom && n > e.options.maxZoom;
        },
        _expandIfNotCollapsed: function() {
            return this._map && !this.options.collapsed && this.expand(), this;
        },
        _expandSafely: function() {
            var t = this._section, e = (this._preventClick = !0, S(t, "click", O), this.expand(), this);
            setTimeout(function() {
                k(t, "click", O), e._preventClick = !1;
            });
        }
    })), qe = B.extend({
        options: {
            position: "topleft",
            zoomInText: '<span aria-hidden="true">+</span>',
            zoomInTitle: "Zoom in",
            zoomOutText: '<span aria-hidden="true">&#x2212;</span>',
            zoomOutTitle: "Zoom out"
        },
        onAdd: function(t) {
            var e = "leaflet-control-zoom", i = P("div", e + " leaflet-bar"), n = this.options;
            return this._zoomInButton = this._createButton(n.zoomInText, n.zoomInTitle, e + "-in", i, this._zoomIn), this._zoomOutButton = this._createButton(n.zoomOutText, n.zoomOutTitle, e + "-out", i, this._zoomOut), this._updateDisabled(), t.on("zoomend zoomlevelschange", this._updateDisabled, this), i;
        },
        onRemove: function(t) {
            t.off("zoomend zoomlevelschange", this._updateDisabled, this);
        },
        disable: function() {
            return this._disabled = !0, this._updateDisabled(), this;
        },
        enable: function() {
            return this._disabled = !1, this._updateDisabled(), this;
        },
        _zoomIn: function(t) {
            !this._disabled && this._map._zoom < this._map.getMaxZoom() && this._map.zoomIn(this._map.options.zoomDelta * (t.shiftKey ? 3 : 1));
        },
        _zoomOut: function(t) {
            !this._disabled && this._map._zoom > this._map.getMinZoom() && this._map.zoomOut(this._map.options.zoomDelta * (t.shiftKey ? 3 : 1));
        },
        _createButton: function(t, e, i, n, o) {
            i = P("a", i, n);
            return i.innerHTML = t, i.href = "#", i.title = e, i.setAttribute("role", "button"), i.setAttribute("aria-label", e), Ie(i), S(i, "click", Re), S(i, "click", o, this), S(i, "click", this._refocusOnMap, this), i;
        },
        _updateDisabled: function() {
            var t = this._map, e = "leaflet-disabled";
            z(this._zoomInButton, e), z(this._zoomOutButton, e), this._zoomInButton.setAttribute("aria-disabled", "false"), this._zoomOutButton.setAttribute("aria-disabled", "false"), !this._disabled && t._zoom !== t.getMinZoom() || (M(this._zoomOutButton, e), this._zoomOutButton.setAttribute("aria-disabled", "true")), !this._disabled && t._zoom !== t.getMaxZoom() || (M(this._zoomInButton, e), this._zoomInButton.setAttribute("aria-disabled", "true"));
        }
    }), Ge = (A.mergeOptions({
        zoomControl: !0
    }), A.addInitHook(function() {
        this.options.zoomControl && (this.zoomControl = new qe, this.addControl(this.zoomControl));
    }), B.extend({
        options: {
            position: "bottomleft",
            maxWidth: 100,
            metric: !0,
            imperial: !0
        },
        onAdd: function(t) {
            var e = "leaflet-control-scale", i = P("div", e), n = this.options;
            return this._addScales(n, e + "-line", i), t.on(n.updateWhenIdle ? "moveend" : "move", this._update, this), t.whenReady(this._update, this), i;
        },
        onRemove: function(t) {
            t.off(this.options.updateWhenIdle ? "moveend" : "move", this._update, this);
        },
        _addScales: function(t, e, i) {
            t.metric && (this._mScale = P("div", e, i)), t.imperial && (this._iScale = P("div", e, i));
        },
        _update: function() {
            var t = this._map, e = t.getSize().y / 2, t = t.distance(t.containerPointToLatLng([
                0,
                e
            ]), t.containerPointToLatLng([
                this.options.maxWidth,
                e
            ]));
            this._updateScales(t);
        },
        _updateScales: function(t) {
            this.options.metric && t && this._updateMetric(t), this.options.imperial && t && this._updateImperial(t);
        },
        _updateMetric: function(t) {
            var e = this._getRoundNum(t);
            this._updateScale(this._mScale, e < 1e3 ? e + " m" : e / 1e3 + " km", e / t);
        },
        _updateImperial: function(t) {
            var e, i, t = 3.2808399 * t;
            5280 < t ? (i = this._getRoundNum(e = t / 5280), this._updateScale(this._iScale, i + " mi", i / e)) : (i = this._getRoundNum(t), this._updateScale(this._iScale, i + " ft", i / t));
        },
        _updateScale: function(t, e, i) {
            t.style.width = Math.round(this.options.maxWidth * i) + "px", t.innerHTML = e;
        },
        _getRoundNum: function(t) {
            var e = Math.pow(10, (Math.floor(t) + "").length - 1), t = t / e;
            return e * (t = 10 <= t ? 10 : 5 <= t ? 5 : 3 <= t ? 3 : 2 <= t ? 2 : 1);
        }
    })), Ke = B.extend({
        options: {
            position: "bottomright",
            prefix: '<a href="https://leafletjs.com" title="A JavaScript library for interactive maps">' + (b.inlineSvg ? '<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="12" height="8" viewBox="0 0 12 8" class="leaflet-attribution-flag"><path fill="#4C7BE1" d="M0 0h12v4H0z"/><path fill="#FFD500" d="M0 4h12v3H0z"/><path fill="#E0BC00" d="M0 7h12v1H0z"/></svg> ' : "") + "Leaflet</a>"
        },
        initialize: function(t) {
            c(this, t), this._attributions = {};
        },
        onAdd: function(t) {
            for(var e in (t.attributionControl = this)._container = P("div", "leaflet-control-attribution"), Ie(this._container), t._layers)t._layers[e].getAttribution && this.addAttribution(t._layers[e].getAttribution());
            return this._update(), t.on("layeradd", this._addAttribution, this), this._container;
        },
        onRemove: function(t) {
            t.off("layeradd", this._addAttribution, this);
        },
        _addAttribution: function(t) {
            t.layer.getAttribution && (this.addAttribution(t.layer.getAttribution()), t.layer.once("remove", function() {
                this.removeAttribution(t.layer.getAttribution());
            }, this));
        },
        setPrefix: function(t) {
            return this.options.prefix = t, this._update(), this;
        },
        addAttribution: function(t) {
            return t && (this._attributions[t] || (this._attributions[t] = 0), this._attributions[t]++, this._update()), this;
        },
        removeAttribution: function(t) {
            return t && this._attributions[t] && (this._attributions[t]--, this._update()), this;
        },
        _update: function() {
            if (this._map) {
                var t, e = [];
                for(t in this._attributions)this._attributions[t] && e.push(t);
                var i = [];
                this.options.prefix && i.push(this.options.prefix), e.length && i.push(e.join(", ")), this._container.innerHTML = i.join(' <span aria-hidden="true">|</span> ');
            }
        }
    }), n = (A.mergeOptions({
        attributionControl: !0
    }), A.addInitHook(function() {
        this.options.attributionControl && (new Ke).addTo(this);
    }), B.Layers = Ve, B.Zoom = qe, B.Scale = Ge, B.Attribution = Ke, Ue.layers = function(t, e, i) {
        return new Ve(t, e, i);
    }, Ue.zoom = function(t) {
        return new qe(t);
    }, Ue.scale = function(t) {
        return new Ge(t);
    }, Ue.attribution = function(t) {
        return new Ke(t);
    }, et.extend({
        initialize: function(t) {
            this._map = t;
        },
        enable: function() {
            return this._enabled || (this._enabled = !0, this.addHooks()), this;
        },
        disable: function() {
            return this._enabled && (this._enabled = !1, this.removeHooks()), this;
        },
        enabled: function() {
            return !!this._enabled;
        }
    })), ft = (n.addTo = function(t, e) {
        return t.addHandler(e, this), this;
    }, {
        Events: e
    }), Ye = b.touch ? "touchstart mousedown" : "mousedown", Xe = it.extend({
        options: {
            clickTolerance: 3
        },
        initialize: function(t, e, i, n) {
            c(this, n), this._element = t, this._dragStartTarget = e || t, this._preventOutline = i;
        },
        enable: function() {
            this._enabled || (S(this._dragStartTarget, Ye, this._onDown, this), this._enabled = !0);
        },
        disable: function() {
            this._enabled && (Xe._dragging === this && this.finishDrag(!0), k(this._dragStartTarget, Ye, this._onDown, this), this._enabled = !1, this._moved = !1);
        },
        _onDown: function(t) {
            var e, i;
            this._enabled && (this._moved = !1, ve(this._element, "leaflet-zoom-anim") || (t.touches && 1 !== t.touches.length ? Xe._dragging === this && this.finishDrag() : Xe._dragging || t.shiftKey || 1 !== t.which && 1 !== t.button && !t.touches || ((Xe._dragging = this)._preventOutline && Me(this._element), Le(), re(), this._moving || (this.fire("down"), i = t.touches ? t.touches[0] : t, e = Ce(this._element), this._startPoint = new p(i.clientX, i.clientY), this._startPos = Pe(this._element), this._parentScale = Ze(e), i = "mousedown" === t.type, S(document, i ? "mousemove" : "touchmove", this._onMove, this), S(document, i ? "mouseup" : "touchend touchcancel", this._onUp, this)))));
        },
        _onMove: function(t) {
            var e;
            this._enabled && (t.touches && 1 < t.touches.length ? this._moved = !0 : !(e = new p((e = t.touches && 1 === t.touches.length ? t.touches[0] : t).clientX, e.clientY)._subtract(this._startPoint)).x && !e.y || Math.abs(e.x) + Math.abs(e.y) < this.options.clickTolerance || (e.x /= this._parentScale.x, e.y /= this._parentScale.y, O(t), this._moved || (this.fire("dragstart"), this._moved = !0, M(document.body, "leaflet-dragging"), this._lastTarget = t.target || t.srcElement, window.SVGElementInstance && this._lastTarget instanceof window.SVGElementInstance && (this._lastTarget = this._lastTarget.correspondingUseElement), M(this._lastTarget, "leaflet-drag-target")), this._newPos = this._startPos.add(e), this._moving = !0, this._lastEvent = t, this._updatePosition()));
        },
        _updatePosition: function() {
            var t = {
                originalEvent: this._lastEvent
            };
            this.fire("predrag", t), Z(this._element, this._newPos), this.fire("drag", t);
        },
        _onUp: function() {
            this._enabled && this.finishDrag();
        },
        finishDrag: function(t) {
            z(document.body, "leaflet-dragging"), this._lastTarget && (z(this._lastTarget, "leaflet-drag-target"), this._lastTarget = null), k(document, "mousemove touchmove", this._onMove, this), k(document, "mouseup touchend touchcancel", this._onUp, this), Te(), ae();
            var e = this._moved && this._moving;
            this._moving = !1, Xe._dragging = !1, e && this.fire("dragend", {
                noInertia: t,
                distance: this._newPos.distanceTo(this._startPos)
            });
        }
    });
    function Je(t, e, i) {
        for(var n, o, s, r, a, h, l, u = [
            1,
            4,
            2,
            8
        ], c = 0, d = t.length; c < d; c++)t[c]._code = si(t[c], e);
        for(s = 0; s < 4; s++){
            for(h = u[s], n = [], c = 0, o = (d = t.length) - 1; c < d; o = c++)r = t[c], a = t[o], r._code & h ? a._code & h || ((l = oi(a, r, h, e, i))._code = si(l, e), n.push(l)) : (a._code & h && ((l = oi(a, r, h, e, i))._code = si(l, e), n.push(l)), n.push(r));
            t = n;
        }
        return t;
    }
    function $e(t, e) {
        var i, n, o, s, r, a, h;
        if (!t || 0 === t.length) throw new Error("latlngs not passed");
        I(t) || (console.warn("latlngs are not flat! Only the first ring will be used"), t = t[0]);
        for(var l = w([
            0,
            0
        ]), u = g(t), c = (u.getNorthWest().distanceTo(u.getSouthWest()) * u.getNorthEast().distanceTo(u.getNorthWest()) < 1700 && (l = Qe(t)), t.length), d = [], _ = 0; _ < c; _++){
            var p = w(t[_]);
            d.push(e.project(w([
                p.lat - l.lat,
                p.lng - l.lng
            ])));
        }
        for(_ = r = a = h = 0, i = c - 1; _ < c; i = _++)n = d[_], o = d[i], s = n.y * o.x - o.y * n.x, a += (n.x + o.x) * s, h += (n.y + o.y) * s, r += 3 * s;
        u = 0 === r ? d[0] : [
            a / r,
            h / r
        ], u = e.unproject(m(u));
        return w([
            u.lat + l.lat,
            u.lng + l.lng
        ]);
    }
    function Qe(t) {
        for(var e = 0, i = 0, n = 0, o = 0; o < t.length; o++){
            var s = w(t[o]);
            e += s.lat, i += s.lng, n++;
        }
        return w([
            e / n,
            i / n
        ]);
    }
    var ti, gt = {
        __proto__: null,
        clipPolygon: Je,
        polygonCenter: $e,
        centroid: Qe
    };
    function ei(t, e) {
        if (e && t.length) {
            var i = t = function(t, e) {
                for(var i = [
                    t[0]
                ], n = 1, o = 0, s = t.length; n < s; n++)(function(t, e) {
                    var i = e.x - t.x, e = e.y - t.y;
                    return i * i + e * e;
                })(t[n], t[o]) > e && (i.push(t[n]), o = n);
                o < s - 1 && i.push(t[s - 1]);
                return i;
            }(t, e = e * e), n = i.length, o = new (typeof Uint8Array != "undefined" ? Uint8Array : Array)(n);
            o[0] = o[n - 1] = 1, function t(e, i, n, o, s) {
                var r, a, h, l = 0;
                for(a = o + 1; a <= s - 1; a++)h = ri(e[a], e[o], e[s], !0), l < h && (r = a, l = h);
                n < l && (i[r] = 1, t(e, i, n, o, r), t(e, i, n, r, s));
            }(i, o, e, 0, n - 1);
            var s, r = [];
            for(s = 0; s < n; s++)o[s] && r.push(i[s]);
            return r;
        }
        return t.slice();
    }
    function ii(t, e, i) {
        return Math.sqrt(ri(t, e, i, !0));
    }
    function ni(t, e, i, n, o) {
        var s, r, a, h = n ? ti : si(t, i), l = si(e, i);
        for(ti = l;;){
            if (!(h | l)) return [
                t,
                e
            ];
            if (h & l) return !1;
            a = si(r = oi(t, e, s = h || l, i, o), i), s === h ? (t = r, h = a) : (e = r, l = a);
        }
    }
    function oi(t, e, i, n, o) {
        var s, r, a = e.x - t.x, e = e.y - t.y, h = n.min, n = n.max;
        return 8 & i ? (s = t.x + a * (n.y - t.y) / e, r = n.y) : 4 & i ? (s = t.x + a * (h.y - t.y) / e, r = h.y) : 2 & i ? (s = n.x, r = t.y + e * (n.x - t.x) / a) : 1 & i && (s = h.x, r = t.y + e * (h.x - t.x) / a), new p(s, r, o);
    }
    function si(t, e) {
        var i = 0;
        return t.x < e.min.x ? i |= 1 : t.x > e.max.x && (i |= 2), t.y < e.min.y ? i |= 4 : t.y > e.max.y && (i |= 8), i;
    }
    function ri(t, e, i, n) {
        var o = e.x, e = e.y, s = i.x - o, r = i.y - e, a = s * s + r * r;
        return 0 < a && (1 < (a = ((t.x - o) * s + (t.y - e) * r) / a) ? (o = i.x, e = i.y) : 0 < a && (o += s * a, e += r * a)), s = t.x - o, r = t.y - e, n ? s * s + r * r : new p(o, e);
    }
    function I(t) {
        return !d(t[0]) || "object" != typeof t[0][0] && void 0 !== t[0][0];
    }
    function ai(t) {
        return console.warn("Deprecated use of _flat, please use L.LineUtil.isFlat instead."), I(t);
    }
    function hi(t, e) {
        var i, n, o, s, r, a;
        if (!t || 0 === t.length) throw new Error("latlngs not passed");
        I(t) || (console.warn("latlngs are not flat! Only the first ring will be used"), t = t[0]);
        for(var h = w([
            0,
            0
        ]), l = g(t), u = (l.getNorthWest().distanceTo(l.getSouthWest()) * l.getNorthEast().distanceTo(l.getNorthWest()) < 1700 && (h = Qe(t)), t.length), c = [], d = 0; d < u; d++){
            var _ = w(t[d]);
            c.push(e.project(w([
                _.lat - h.lat,
                _.lng - h.lng
            ])));
        }
        for(i = d = 0; d < u - 1; d++)i += c[d].distanceTo(c[d + 1]) / 2;
        if (0 === i) a = c[0];
        else for(n = d = 0; d < u - 1; d++)if (o = c[d], s = c[d + 1], i < (n += r = o.distanceTo(s))) {
            a = [
                s.x - (r = (n - i) / r) * (s.x - o.x),
                s.y - r * (s.y - o.y)
            ];
            break;
        }
        l = e.unproject(m(a));
        return w([
            l.lat + h.lat,
            l.lng + h.lng
        ]);
    }
    var vt = {
        __proto__: null,
        simplify: ei,
        pointToSegmentDistance: ii,
        closestPointOnSegment: function(t, e, i) {
            return ri(t, e, i);
        },
        clipSegment: ni,
        _getEdgeIntersection: oi,
        _getBitCode: si,
        _sqClosestPointOnSegment: ri,
        isFlat: I,
        _flat: ai,
        polylineCenter: hi
    }, yt = {
        project: function(t) {
            return new p(t.lng, t.lat);
        },
        unproject: function(t) {
            return new v(t.y, t.x);
        },
        bounds: new f([
            -180,
            -90
        ], [
            180,
            90
        ])
    }, xt = {
        R: 6378137,
        R_MINOR: 6356752.314245179,
        bounds: new f([
            -20037508.34279,
            -15496570.73972
        ], [
            20037508.34279,
            18764656.23138
        ]),
        project: function(t) {
            var e = Math.PI / 180, i = this.R, n = t.lat * e, o = this.R_MINOR / i, o = Math.sqrt(1 - o * o), s = o * Math.sin(n), s = Math.tan(Math.PI / 4 - n / 2) / Math.pow((1 - s) / (1 + s), o / 2), n = -i * Math.log(Math.max(s, 1e-10));
            return new p(t.lng * e * i, n);
        },
        unproject: function(t) {
            for(var e, i = 180 / Math.PI, n = this.R, o = this.R_MINOR / n, s = Math.sqrt(1 - o * o), r = Math.exp(-t.y / n), a = Math.PI / 2 - 2 * Math.atan(r), h = 0, l = .1; h < 15 && 1e-7 < Math.abs(l); h++)e = s * Math.sin(a), e = Math.pow((1 - e) / (1 + e), s / 2), a += l = Math.PI / 2 - 2 * Math.atan(r * e) - a;
            return new v(a * i, t.x * i / n);
        }
    }, wt = {
        __proto__: null,
        LonLat: yt,
        Mercator: xt,
        SphericalMercator: rt
    }, Pt = l({}, st, {
        code: "EPSG:3395",
        projection: xt,
        transformation: ht(bt = .5 / (Math.PI * xt.R), .5, -bt, .5)
    }), li = l({}, st, {
        code: "EPSG:4326",
        projection: yt,
        transformation: ht(1 / 180, 1, -1 / 180, .5)
    }), Lt = l({}, ot, {
        projection: yt,
        transformation: ht(1, 0, -1, 0),
        scale: function(t) {
            return Math.pow(2, t);
        },
        zoom: function(t) {
            return Math.log(t) / Math.LN2;
        },
        distance: function(t, e) {
            var i = e.lng - t.lng, e = e.lat - t.lat;
            return Math.sqrt(i * i + e * e);
        },
        infinite: !0
    }), o = (ot.Earth = st, ot.EPSG3395 = Pt, ot.EPSG3857 = lt, ot.EPSG900913 = ut, ot.EPSG4326 = li, ot.Simple = Lt, it.extend({
        options: {
            pane: "overlayPane",
            attribution: null,
            bubblingMouseEvents: !0
        },
        addTo: function(t) {
            return t.addLayer(this), this;
        },
        remove: function() {
            return this.removeFrom(this._map || this._mapToAdd);
        },
        removeFrom: function(t) {
            return t && t.removeLayer(this), this;
        },
        getPane: function(t) {
            return this._map.getPane(t ? this.options[t] || t : this.options.pane);
        },
        addInteractiveTarget: function(t) {
            return this._map._targets[h(t)] = this;
        },
        removeInteractiveTarget: function(t) {
            return delete this._map._targets[h(t)], this;
        },
        getAttribution: function() {
            return this.options.attribution;
        },
        _layerAdd: function(t) {
            var e, i = t.target;
            i.hasLayer(this) && (this._map = i, this._zoomAnimated = i._zoomAnimated, this.getEvents && (e = this.getEvents(), i.on(e, this), this.once("remove", function() {
                i.off(e, this);
            }, this)), this.onAdd(i), this.fire("add"), i.fire("layeradd", {
                layer: this
            }));
        }
    })), ui = (A.include({
        addLayer: function(t) {
            var e;
            if (t._layerAdd) return e = h(t), this._layers[e] || ((this._layers[e] = t)._mapToAdd = this, t.beforeAdd && t.beforeAdd(this), this.whenReady(t._layerAdd, t)), this;
            throw new Error("The provided object is not a Layer.");
        },
        removeLayer: function(t) {
            var e = h(t);
            return this._layers[e] && (this._loaded && t.onRemove(this), delete this._layers[e], this._loaded && (this.fire("layerremove", {
                layer: t
            }), t.fire("remove")), t._map = t._mapToAdd = null), this;
        },
        hasLayer: function(t) {
            return h(t) in this._layers;
        },
        eachLayer: function(t, e) {
            for(var i in this._layers)t.call(e, this._layers[i]);
            return this;
        },
        _addLayers: function(t) {
            for(var e = 0, i = (t = t ? d(t) ? t : [
                t
            ] : []).length; e < i; e++)this.addLayer(t[e]);
        },
        _addZoomLimit: function(t) {
            isNaN(t.options.maxZoom) && isNaN(t.options.minZoom) || (this._zoomBoundLayers[h(t)] = t, this._updateZoomLevels());
        },
        _removeZoomLimit: function(t) {
            t = h(t);
            this._zoomBoundLayers[t] && (delete this._zoomBoundLayers[t], this._updateZoomLevels());
        },
        _updateZoomLevels: function() {
            var t, e = 1 / 0, i = -1 / 0, n = this._getZoomSpan();
            for(t in this._zoomBoundLayers)var o = this._zoomBoundLayers[t].options, e = void 0 === o.minZoom ? e : Math.min(e, o.minZoom), i = void 0 === o.maxZoom ? i : Math.max(i, o.maxZoom);
            this._layersMaxZoom = i === -1 / 0 ? void 0 : i, this._layersMinZoom = e === 1 / 0 ? void 0 : e, n !== this._getZoomSpan() && this.fire("zoomlevelschange"), void 0 === this.options.maxZoom && this._layersMaxZoom && this.getZoom() > this._layersMaxZoom && this.setZoom(this._layersMaxZoom), void 0 === this.options.minZoom && this._layersMinZoom && this.getZoom() < this._layersMinZoom && this.setZoom(this._layersMinZoom);
        }
    }), o.extend({
        initialize: function(t, e) {
            var i, n;
            if (c(this, e), this._layers = {}, t) for(i = 0, n = t.length; i < n; i++)this.addLayer(t[i]);
        },
        addLayer: function(t) {
            var e = this.getLayerId(t);
            return this._layers[e] = t, this._map && this._map.addLayer(t), this;
        },
        removeLayer: function(t) {
            t = t in this._layers ? t : this.getLayerId(t);
            return this._map && this._layers[t] && this._map.removeLayer(this._layers[t]), delete this._layers[t], this;
        },
        hasLayer: function(t) {
            return ("number" == typeof t ? t : this.getLayerId(t)) in this._layers;
        },
        clearLayers: function() {
            return this.eachLayer(this.removeLayer, this);
        },
        invoke: function(t) {
            var e, i, n = Array.prototype.slice.call(arguments, 1);
            for(e in this._layers)(i = this._layers[e])[t] && i[t].apply(i, n);
            return this;
        },
        onAdd: function(t) {
            this.eachLayer(t.addLayer, t);
        },
        onRemove: function(t) {
            this.eachLayer(t.removeLayer, t);
        },
        eachLayer: function(t, e) {
            for(var i in this._layers)t.call(e, this._layers[i]);
            return this;
        },
        getLayer: function(t) {
            return this._layers[t];
        },
        getLayers: function() {
            var t = [];
            return this.eachLayer(t.push, t), t;
        },
        setZIndex: function(t) {
            return this.invoke("setZIndex", t);
        },
        getLayerId: h
    })), ci = ui.extend({
        addLayer: function(t) {
            return this.hasLayer(t) ? this : (t.addEventParent(this), ui.prototype.addLayer.call(this, t), this.fire("layeradd", {
                layer: t
            }));
        },
        removeLayer: function(t) {
            return this.hasLayer(t) ? ((t = t in this._layers ? this._layers[t] : t).removeEventParent(this), ui.prototype.removeLayer.call(this, t), this.fire("layerremove", {
                layer: t
            })) : this;
        },
        setStyle: function(t) {
            return this.invoke("setStyle", t);
        },
        bringToFront: function() {
            return this.invoke("bringToFront");
        },
        bringToBack: function() {
            return this.invoke("bringToBack");
        },
        getBounds: function() {
            var t, e = new s;
            for(t in this._layers){
                var i = this._layers[t];
                e.extend(i.getBounds ? i.getBounds() : i.getLatLng());
            }
            return e;
        }
    }), di = et.extend({
        options: {
            popupAnchor: [
                0,
                0
            ],
            tooltipAnchor: [
                0,
                0
            ],
            crossOrigin: !1
        },
        initialize: function(t) {
            c(this, t);
        },
        createIcon: function(t) {
            return this._createIcon("icon", t);
        },
        createShadow: function(t) {
            return this._createIcon("shadow", t);
        },
        _createIcon: function(t, e) {
            var i = this._getIconUrl(t);
            if (i) return i = this._createImg(i, e && "IMG" === e.tagName ? e : null), this._setIconStyles(i, t), !this.options.crossOrigin && "" !== this.options.crossOrigin || (i.crossOrigin = !0 === this.options.crossOrigin ? "" : this.options.crossOrigin), i;
            if ("icon" === t) throw new Error("iconUrl not set in Icon options (see the docs).");
            return null;
        },
        _setIconStyles: function(t, e) {
            var i = this.options, n = i[e + "Size"], n = m(n = "number" == typeof n ? [
                n,
                n
            ] : n), o = m("shadow" === e && i.shadowAnchor || i.iconAnchor || n && n.divideBy(2, !0));
            t.className = "leaflet-marker-" + e + " " + (i.className || ""), o && (t.style.marginLeft = -o.x + "px", t.style.marginTop = -o.y + "px"), n && (t.style.width = n.x + "px", t.style.height = n.y + "px");
        },
        _createImg: function(t, e) {
            return (e = e || document.createElement("img")).src = t, e;
        },
        _getIconUrl: function(t) {
            return b.retina && this.options[t + "RetinaUrl"] || this.options[t + "Url"];
        }
    });
    var _i = di.extend({
        options: {
            iconUrl: "marker-icon.png",
            iconRetinaUrl: "marker-icon-2x.png",
            shadowUrl: "marker-shadow.png",
            iconSize: [
                25,
                41
            ],
            iconAnchor: [
                12,
                41
            ],
            popupAnchor: [
                1,
                -34
            ],
            tooltipAnchor: [
                16,
                -28
            ],
            shadowSize: [
                41,
                41
            ]
        },
        _getIconUrl: function(t) {
            return "string" != typeof _i.imagePath && (_i.imagePath = this._detectIconPath()), (this.options.imagePath || _i.imagePath) + di.prototype._getIconUrl.call(this, t);
        },
        _stripUrl: function(t) {
            function e(t, e, i) {
                return (e = e.exec(t)) && e[i];
            }
            return (t = e(t, /^url\((['"])?(.+)\1\)$/, 2)) && e(t, /^(.*)marker-icon\.png$/, 1);
        },
        _detectIconPath: function() {
            var t = P("div", "leaflet-default-icon-path", document.body), e = pe(t, "background-image") || pe(t, "backgroundImage");
            return document.body.removeChild(t), (e = this._stripUrl(e)) ? e : (t = document.querySelector('link[href$="leaflet.css"]')) ? t.href.substring(0, t.href.length - 11 - 1) : "";
        }
    }), pi = n.extend({
        initialize: function(t) {
            this._marker = t;
        },
        addHooks: function() {
            var t = this._marker._icon;
            this._draggable || (this._draggable = new Xe(t, t, !0)), this._draggable.on({
                dragstart: this._onDragStart,
                predrag: this._onPreDrag,
                drag: this._onDrag,
                dragend: this._onDragEnd
            }, this).enable(), M(t, "leaflet-marker-draggable");
        },
        removeHooks: function() {
            this._draggable.off({
                dragstart: this._onDragStart,
                predrag: this._onPreDrag,
                drag: this._onDrag,
                dragend: this._onDragEnd
            }, this).disable(), this._marker._icon && z(this._marker._icon, "leaflet-marker-draggable");
        },
        moved: function() {
            return this._draggable && this._draggable._moved;
        },
        _adjustPan: function(t) {
            var e = this._marker, i = e._map, n = this._marker.options.autoPanSpeed, o = this._marker.options.autoPanPadding, s = Pe(e._icon), r = i.getPixelBounds(), a = i.getPixelOrigin(), a = _(r.min._subtract(a).add(o), r.max._subtract(a).subtract(o));
            a.contains(s) || (o = m((Math.max(a.max.x, s.x) - a.max.x) / (r.max.x - a.max.x) - (Math.min(a.min.x, s.x) - a.min.x) / (r.min.x - a.min.x), (Math.max(a.max.y, s.y) - a.max.y) / (r.max.y - a.max.y) - (Math.min(a.min.y, s.y) - a.min.y) / (r.min.y - a.min.y)).multiplyBy(n), i.panBy(o, {
                animate: !1
            }), this._draggable._newPos._add(o), this._draggable._startPos._add(o), Z(e._icon, this._draggable._newPos), this._onDrag(t), this._panRequest = x(this._adjustPan.bind(this, t)));
        },
        _onDragStart: function() {
            this._oldLatLng = this._marker.getLatLng(), this._marker.closePopup && this._marker.closePopup(), this._marker.fire("movestart").fire("dragstart");
        },
        _onPreDrag: function(t) {
            this._marker.options.autoPan && (r(this._panRequest), this._panRequest = x(this._adjustPan.bind(this, t)));
        },
        _onDrag: function(t) {
            var e = this._marker, i = e._shadow, n = Pe(e._icon), o = e._map.layerPointToLatLng(n);
            i && Z(i, n), e._latlng = o, t.latlng = o, t.oldLatLng = this._oldLatLng, e.fire("move", t).fire("drag", t);
        },
        _onDragEnd: function(t) {
            r(this._panRequest), delete this._oldLatLng, this._marker.fire("moveend").fire("dragend", t);
        }
    }), mi = o.extend({
        options: {
            icon: new _i,
            interactive: !0,
            keyboard: !0,
            title: "",
            alt: "Marker",
            zIndexOffset: 0,
            opacity: 1,
            riseOnHover: !1,
            riseOffset: 250,
            pane: "markerPane",
            shadowPane: "shadowPane",
            bubblingMouseEvents: !1,
            autoPanOnFocus: !0,
            draggable: !1,
            autoPan: !1,
            autoPanPadding: [
                50,
                50
            ],
            autoPanSpeed: 10
        },
        initialize: function(t, e) {
            c(this, e), this._latlng = w(t);
        },
        onAdd: function(t) {
            this._zoomAnimated = this._zoomAnimated && t.options.markerZoomAnimation, this._zoomAnimated && t.on("zoomanim", this._animateZoom, this), this._initIcon(), this.update();
        },
        onRemove: function(t) {
            this.dragging && this.dragging.enabled() && (this.options.draggable = !0, this.dragging.removeHooks()), delete this.dragging, this._zoomAnimated && t.off("zoomanim", this._animateZoom, this), this._removeIcon(), this._removeShadow();
        },
        getEvents: function() {
            return {
                zoom: this.update,
                viewreset: this.update
            };
        },
        getLatLng: function() {
            return this._latlng;
        },
        setLatLng: function(t) {
            var e = this._latlng;
            return this._latlng = w(t), this.update(), this.fire("move", {
                oldLatLng: e,
                latlng: this._latlng
            });
        },
        setZIndexOffset: function(t) {
            return this.options.zIndexOffset = t, this.update();
        },
        getIcon: function() {
            return this.options.icon;
        },
        setIcon: function(t) {
            return this.options.icon = t, this._map && (this._initIcon(), this.update()), this._popup && this.bindPopup(this._popup, this._popup.options), this;
        },
        getElement: function() {
            return this._icon;
        },
        update: function() {
            var t;
            return this._icon && this._map && (t = this._map.latLngToLayerPoint(this._latlng).round(), this._setPos(t)), this;
        },
        _initIcon: function() {
            var t = this.options, e = "leaflet-zoom-" + (this._zoomAnimated ? "animated" : "hide"), i = t.icon.createIcon(this._icon), n = !1, i = (i !== this._icon && (this._icon && this._removeIcon(), n = !0, t.title && (i.title = t.title), "IMG" === i.tagName && (i.alt = t.alt || "")), M(i, e), t.keyboard && (i.tabIndex = "0", i.setAttribute("role", "button")), this._icon = i, t.riseOnHover && this.on({
                mouseover: this._bringToFront,
                mouseout: this._resetZIndex
            }), this.options.autoPanOnFocus && S(i, "focus", this._panOnFocus, this), t.icon.createShadow(this._shadow)), o = !1;
            i !== this._shadow && (this._removeShadow(), o = !0), i && (M(i, e), i.alt = ""), this._shadow = i, t.opacity < 1 && this._updateOpacity(), n && this.getPane().appendChild(this._icon), this._initInteraction(), i && o && this.getPane(t.shadowPane).appendChild(this._shadow);
        },
        _removeIcon: function() {
            this.options.riseOnHover && this.off({
                mouseover: this._bringToFront,
                mouseout: this._resetZIndex
            }), this.options.autoPanOnFocus && k(this._icon, "focus", this._panOnFocus, this), T(this._icon), this.removeInteractiveTarget(this._icon), this._icon = null;
        },
        _removeShadow: function() {
            this._shadow && T(this._shadow), this._shadow = null;
        },
        _setPos: function(t) {
            this._icon && Z(this._icon, t), this._shadow && Z(this._shadow, t), this._zIndex = t.y + this.options.zIndexOffset, this._resetZIndex();
        },
        _updateZIndex: function(t) {
            this._icon && (this._icon.style.zIndex = this._zIndex + t);
        },
        _animateZoom: function(t) {
            t = this._map._latLngToNewLayerPoint(this._latlng, t.zoom, t.center).round();
            this._setPos(t);
        },
        _initInteraction: function() {
            var t;
            this.options.interactive && (M(this._icon, "leaflet-interactive"), this.addInteractiveTarget(this._icon), pi && (t = this.options.draggable, this.dragging && (t = this.dragging.enabled(), this.dragging.disable()), this.dragging = new pi(this), t && this.dragging.enable()));
        },
        setOpacity: function(t) {
            return this.options.opacity = t, this._map && this._updateOpacity(), this;
        },
        _updateOpacity: function() {
            var t = this.options.opacity;
            this._icon && C(this._icon, t), this._shadow && C(this._shadow, t);
        },
        _bringToFront: function() {
            this._updateZIndex(this.options.riseOffset);
        },
        _resetZIndex: function() {
            this._updateZIndex(0);
        },
        _panOnFocus: function() {
            var t, e, i = this._map;
            i && (t = (e = this.options.icon.options).iconSize ? m(e.iconSize) : m(0, 0), e = e.iconAnchor ? m(e.iconAnchor) : m(0, 0), i.panInside(this._latlng, {
                paddingTopLeft: e,
                paddingBottomRight: t.subtract(e)
            }));
        },
        _getPopupAnchor: function() {
            return this.options.icon.options.popupAnchor;
        },
        _getTooltipAnchor: function() {
            return this.options.icon.options.tooltipAnchor;
        }
    });
    var fi = o.extend({
        options: {
            stroke: !0,
            color: "#3388ff",
            weight: 3,
            opacity: 1,
            lineCap: "round",
            lineJoin: "round",
            dashArray: null,
            dashOffset: null,
            fill: !1,
            fillColor: null,
            fillOpacity: .2,
            fillRule: "evenodd",
            interactive: !0,
            bubblingMouseEvents: !0
        },
        beforeAdd: function(t) {
            this._renderer = t.getRenderer(this);
        },
        onAdd: function() {
            this._renderer._initPath(this), this._reset(), this._renderer._addPath(this);
        },
        onRemove: function() {
            this._renderer._removePath(this);
        },
        redraw: function() {
            return this._map && this._renderer._updatePath(this), this;
        },
        setStyle: function(t) {
            return c(this, t), this._renderer && (this._renderer._updateStyle(this), this.options.stroke && t && Object.prototype.hasOwnProperty.call(t, "weight") && this._updateBounds()), this;
        },
        bringToFront: function() {
            return this._renderer && this._renderer._bringToFront(this), this;
        },
        bringToBack: function() {
            return this._renderer && this._renderer._bringToBack(this), this;
        },
        getElement: function() {
            return this._path;
        },
        _reset: function() {
            this._project(), this._update();
        },
        _clickTolerance: function() {
            return (this.options.stroke ? this.options.weight / 2 : 0) + (this._renderer.options.tolerance || 0);
        }
    }), gi = fi.extend({
        options: {
            fill: !0,
            radius: 10
        },
        initialize: function(t, e) {
            c(this, e), this._latlng = w(t), this._radius = this.options.radius;
        },
        setLatLng: function(t) {
            var e = this._latlng;
            return this._latlng = w(t), this.redraw(), this.fire("move", {
                oldLatLng: e,
                latlng: this._latlng
            });
        },
        getLatLng: function() {
            return this._latlng;
        },
        setRadius: function(t) {
            return this.options.radius = this._radius = t, this.redraw();
        },
        getRadius: function() {
            return this._radius;
        },
        setStyle: function(t) {
            var e = t && t.radius || this._radius;
            return fi.prototype.setStyle.call(this, t), this.setRadius(e), this;
        },
        _project: function() {
            this._point = this._map.latLngToLayerPoint(this._latlng), this._updateBounds();
        },
        _updateBounds: function() {
            var t = this._radius, e = this._radiusY || t, i = this._clickTolerance(), t = [
                t + i,
                e + i
            ];
            this._pxBounds = new f(this._point.subtract(t), this._point.add(t));
        },
        _update: function() {
            this._map && this._updatePath();
        },
        _updatePath: function() {
            this._renderer._updateCircle(this);
        },
        _empty: function() {
            return this._radius && !this._renderer._bounds.intersects(this._pxBounds);
        },
        _containsPoint: function(t) {
            return t.distanceTo(this._point) <= this._radius + this._clickTolerance();
        }
    });
    var vi = gi.extend({
        initialize: function(t, e, i) {
            if (c(this, e = "number" == typeof e ? l({}, i, {
                radius: e
            }) : e), this._latlng = w(t), isNaN(this.options.radius)) throw new Error("Circle radius cannot be NaN");
            this._mRadius = this.options.radius;
        },
        setRadius: function(t) {
            return this._mRadius = t, this.redraw();
        },
        getRadius: function() {
            return this._mRadius;
        },
        getBounds: function() {
            var t = [
                this._radius,
                this._radiusY || this._radius
            ];
            return new s(this._map.layerPointToLatLng(this._point.subtract(t)), this._map.layerPointToLatLng(this._point.add(t)));
        },
        setStyle: fi.prototype.setStyle,
        _project: function() {
            var t, e, i, n, o, s = this._latlng.lng, r = this._latlng.lat, a = this._map, h = a.options.crs;
            h.distance === st.distance ? (n = Math.PI / 180, o = this._mRadius / st.R / n, t = a.project([
                r + o,
                s
            ]), e = a.project([
                r - o,
                s
            ]), e = t.add(e).divideBy(2), i = a.unproject(e).lat, n = Math.acos((Math.cos(o * n) - Math.sin(r * n) * Math.sin(i * n)) / (Math.cos(r * n) * Math.cos(i * n))) / n, !isNaN(n) && 0 !== n || (n = o / Math.cos(Math.PI / 180 * r)), this._point = e.subtract(a.getPixelOrigin()), this._radius = isNaN(n) ? 0 : e.x - a.project([
                i,
                s - n
            ]).x, this._radiusY = e.y - t.y) : (o = h.unproject(h.project(this._latlng).subtract([
                this._mRadius,
                0
            ])), this._point = a.latLngToLayerPoint(this._latlng), this._radius = this._point.x - a.latLngToLayerPoint(o).x), this._updateBounds();
        }
    });
    var yi = fi.extend({
        options: {
            smoothFactor: 1,
            noClip: !1
        },
        initialize: function(t, e) {
            c(this, e), this._setLatLngs(t);
        },
        getLatLngs: function() {
            return this._latlngs;
        },
        setLatLngs: function(t) {
            return this._setLatLngs(t), this.redraw();
        },
        isEmpty: function() {
            return !this._latlngs.length;
        },
        closestLayerPoint: function(t) {
            for(var e = 1 / 0, i = null, n = ri, o = 0, s = this._parts.length; o < s; o++)for(var r = this._parts[o], a = 1, h = r.length; a < h; a++){
                var l, u, c = n(t, l = r[a - 1], u = r[a], !0);
                c < e && (e = c, i = n(t, l, u));
            }
            return i && (i.distance = Math.sqrt(e)), i;
        },
        getCenter: function() {
            if (this._map) return hi(this._defaultShape(), this._map.options.crs);
            throw new Error("Must add layer to map before using getCenter()");
        },
        getBounds: function() {
            return this._bounds;
        },
        addLatLng: function(t, e) {
            return e = e || this._defaultShape(), t = w(t), e.push(t), this._bounds.extend(t), this.redraw();
        },
        _setLatLngs: function(t) {
            this._bounds = new s, this._latlngs = this._convertLatLngs(t);
        },
        _defaultShape: function() {
            return I(this._latlngs) ? this._latlngs : this._latlngs[0];
        },
        _convertLatLngs: function(t) {
            for(var e = [], i = I(t), n = 0, o = t.length; n < o; n++)i ? (e[n] = w(t[n]), this._bounds.extend(e[n])) : e[n] = this._convertLatLngs(t[n]);
            return e;
        },
        _project: function() {
            var t = new f;
            this._rings = [], this._projectLatlngs(this._latlngs, this._rings, t), this._bounds.isValid() && t.isValid() && (this._rawPxBounds = t, this._updateBounds());
        },
        _updateBounds: function() {
            var t = this._clickTolerance(), t = new p(t, t);
            this._rawPxBounds && (this._pxBounds = new f([
                this._rawPxBounds.min.subtract(t),
                this._rawPxBounds.max.add(t)
            ]));
        },
        _projectLatlngs: function(t, e, i) {
            var n, o, s = t[0] instanceof v, r = t.length;
            if (s) {
                for(o = [], n = 0; n < r; n++)o[n] = this._map.latLngToLayerPoint(t[n]), i.extend(o[n]);
                e.push(o);
            } else for(n = 0; n < r; n++)this._projectLatlngs(t[n], e, i);
        },
        _clipPoints: function() {
            var t = this._renderer._bounds;
            if (this._parts = [], this._pxBounds && this._pxBounds.intersects(t)) {
                if (this.options.noClip) this._parts = this._rings;
                else for(var e, i, n, o, s = this._parts, r = 0, a = 0, h = this._rings.length; r < h; r++)for(e = 0, i = (o = this._rings[r]).length; e < i - 1; e++)(n = ni(o[e], o[e + 1], t, e, !0)) && (s[a] = s[a] || [], s[a].push(n[0]), n[1] === o[e + 1] && e !== i - 2 || (s[a].push(n[1]), a++));
            }
        },
        _simplifyPoints: function() {
            for(var t = this._parts, e = this.options.smoothFactor, i = 0, n = t.length; i < n; i++)t[i] = ei(t[i], e);
        },
        _update: function() {
            this._map && (this._clipPoints(), this._simplifyPoints(), this._updatePath());
        },
        _updatePath: function() {
            this._renderer._updatePoly(this);
        },
        _containsPoint: function(t, e) {
            var i, n, o, s, r, a, h = this._clickTolerance();
            if (this._pxBounds && this._pxBounds.contains(t)) {
                for(i = 0, s = this._parts.length; i < s; i++)for(n = 0, o = (r = (a = this._parts[i]).length) - 1; n < r; o = n++)if ((e || 0 !== n) && ii(t, a[o], a[n]) <= h) return !0;
            }
            return !1;
        }
    });
    yi._flat = ai;
    var xi = yi.extend({
        options: {
            fill: !0
        },
        isEmpty: function() {
            return !this._latlngs.length || !this._latlngs[0].length;
        },
        getCenter: function() {
            if (this._map) return $e(this._defaultShape(), this._map.options.crs);
            throw new Error("Must add layer to map before using getCenter()");
        },
        _convertLatLngs: function(t) {
            var t = yi.prototype._convertLatLngs.call(this, t), e = t.length;
            return 2 <= e && t[0] instanceof v && t[0].equals(t[e - 1]) && t.pop(), t;
        },
        _setLatLngs: function(t) {
            yi.prototype._setLatLngs.call(this, t), I(this._latlngs) && (this._latlngs = [
                this._latlngs
            ]);
        },
        _defaultShape: function() {
            return (I(this._latlngs[0]) ? this._latlngs : this._latlngs[0])[0];
        },
        _clipPoints: function() {
            var t = this._renderer._bounds, e = this.options.weight, e = new p(e, e), t = new f(t.min.subtract(e), t.max.add(e));
            if (this._parts = [], this._pxBounds && this._pxBounds.intersects(t)) {
                if (this.options.noClip) this._parts = this._rings;
                else for(var i, n = 0, o = this._rings.length; n < o; n++)(i = Je(this._rings[n], t, !0)).length && this._parts.push(i);
            }
        },
        _updatePath: function() {
            this._renderer._updatePoly(this, !0);
        },
        _containsPoint: function(t) {
            var e, i, n, o, s, r, a, h, l = !1;
            if (!this._pxBounds || !this._pxBounds.contains(t)) return !1;
            for(o = 0, a = this._parts.length; o < a; o++)for(s = 0, r = (h = (e = this._parts[o]).length) - 1; s < h; r = s++)i = e[s], n = e[r], i.y > t.y != n.y > t.y && t.x < (n.x - i.x) * (t.y - i.y) / (n.y - i.y) + i.x && (l = !l);
            return l || yi.prototype._containsPoint.call(this, t, !0);
        }
    });
    var wi = ci.extend({
        initialize: function(t, e) {
            c(this, e), this._layers = {}, t && this.addData(t);
        },
        addData: function(t) {
            var e, i, n, o = d(t) ? t : t.features;
            if (o) {
                for(e = 0, i = o.length; e < i; e++)((n = o[e]).geometries || n.geometry || n.features || n.coordinates) && this.addData(n);
                return this;
            }
            var s, r = this.options;
            return (!r.filter || r.filter(t)) && (s = bi(t, r)) ? (s.feature = Zi(t), s.defaultOptions = s.options, this.resetStyle(s), r.onEachFeature && r.onEachFeature(t, s), this.addLayer(s)) : this;
        },
        resetStyle: function(t) {
            return void 0 === t ? this.eachLayer(this.resetStyle, this) : (t.options = l({}, t.defaultOptions), this._setLayerStyle(t, this.options.style), this);
        },
        setStyle: function(e) {
            return this.eachLayer(function(t) {
                this._setLayerStyle(t, e);
            }, this);
        },
        _setLayerStyle: function(t, e) {
            t.setStyle && ("function" == typeof e && (e = e(t.feature)), t.setStyle(e));
        }
    });
    function bi(t, e) {
        var i, n, o, s, r = "Feature" === t.type ? t.geometry : t, a = r ? r.coordinates : null, h = [], l = e && e.pointToLayer, u = e && e.coordsToLatLng || Li;
        if (!a && !r) return null;
        switch(r.type){
            case "Point":
                return Pi(l, t, i = u(a), e);
            case "MultiPoint":
                for(o = 0, s = a.length; o < s; o++)i = u(a[o]), h.push(Pi(l, t, i, e));
                return new ci(h);
            case "LineString":
            case "MultiLineString":
                return n = Ti(a, "LineString" === r.type ? 0 : 1, u), new yi(n, e);
            case "Polygon":
            case "MultiPolygon":
                return n = Ti(a, "Polygon" === r.type ? 1 : 2, u), new xi(n, e);
            case "GeometryCollection":
                for(o = 0, s = r.geometries.length; o < s; o++){
                    var c = bi({
                        geometry: r.geometries[o],
                        type: "Feature",
                        properties: t.properties
                    }, e);
                    c && h.push(c);
                }
                return new ci(h);
            case "FeatureCollection":
                for(o = 0, s = r.features.length; o < s; o++){
                    var d = bi(r.features[o], e);
                    d && h.push(d);
                }
                return new ci(h);
            default:
                throw new Error("Invalid GeoJSON object.");
        }
    }
    function Pi(t, e, i, n) {
        return t ? t(e, i) : new mi(i, n && n.markersInheritOptions && n);
    }
    function Li(t) {
        return new v(t[1], t[0], t[2]);
    }
    function Ti(t, e, i) {
        for(var n, o = [], s = 0, r = t.length; s < r; s++)n = e ? Ti(t[s], e - 1, i) : (i || Li)(t[s]), o.push(n);
        return o;
    }
    function Mi(t, e) {
        return void 0 !== (t = w(t)).alt ? [
            i(t.lng, e),
            i(t.lat, e),
            i(t.alt, e)
        ] : [
            i(t.lng, e),
            i(t.lat, e)
        ];
    }
    function zi(t, e, i, n) {
        for(var o = [], s = 0, r = t.length; s < r; s++)o.push(e ? zi(t[s], I(t[s]) ? 0 : e - 1, i, n) : Mi(t[s], n));
        return !e && i && 0 < o.length && o.push(o[0].slice()), o;
    }
    function Ci(t, e) {
        return t.feature ? l({}, t.feature, {
            geometry: e
        }) : Zi(e);
    }
    function Zi(t) {
        return "Feature" === t.type || "FeatureCollection" === t.type ? t : {
            type: "Feature",
            properties: {},
            geometry: t
        };
    }
    Tt = {
        toGeoJSON: function(t) {
            return Ci(this, {
                type: "Point",
                coordinates: Mi(this.getLatLng(), t)
            });
        }
    };
    function Si(t, e) {
        return new wi(t, e);
    }
    mi.include(Tt), vi.include(Tt), gi.include(Tt), yi.include({
        toGeoJSON: function(t) {
            var e = !I(this._latlngs);
            return Ci(this, {
                type: (e ? "Multi" : "") + "LineString",
                coordinates: zi(this._latlngs, e ? 1 : 0, !1, t)
            });
        }
    }), xi.include({
        toGeoJSON: function(t) {
            var e = !I(this._latlngs), i = e && !I(this._latlngs[0]), t = zi(this._latlngs, i ? 2 : e ? 1 : 0, !0, t);
            return Ci(this, {
                type: (i ? "Multi" : "") + "Polygon",
                coordinates: t = e ? t : [
                    t
                ]
            });
        }
    }), ui.include({
        toMultiPoint: function(e) {
            var i = [];
            return this.eachLayer(function(t) {
                i.push(t.toGeoJSON(e).geometry.coordinates);
            }), Ci(this, {
                type: "MultiPoint",
                coordinates: i
            });
        },
        toGeoJSON: function(e) {
            var i, n, t = this.feature && this.feature.geometry && this.feature.geometry.type;
            return "MultiPoint" === t ? this.toMultiPoint(e) : (i = "GeometryCollection" === t, n = [], this.eachLayer(function(t) {
                t.toGeoJSON && (t = t.toGeoJSON(e), i ? n.push(t.geometry) : "FeatureCollection" === (t = Zi(t)).type ? n.push.apply(n, t.features) : n.push(t));
            }), i ? Ci(this, {
                geometries: n,
                type: "GeometryCollection"
            }) : {
                type: "FeatureCollection",
                features: n
            });
        }
    });
    var Mt = Si, Ei = o.extend({
        options: {
            opacity: 1,
            alt: "",
            interactive: !1,
            crossOrigin: !1,
            errorOverlayUrl: "",
            zIndex: 1,
            className: ""
        },
        initialize: function(t, e, i) {
            this._url = t, this._bounds = g(e), c(this, i);
        },
        onAdd: function() {
            this._image || (this._initImage(), this.options.opacity < 1 && this._updateOpacity()), this.options.interactive && (M(this._image, "leaflet-interactive"), this.addInteractiveTarget(this._image)), this.getPane().appendChild(this._image), this._reset();
        },
        onRemove: function() {
            T(this._image), this.options.interactive && this.removeInteractiveTarget(this._image);
        },
        setOpacity: function(t) {
            return this.options.opacity = t, this._image && this._updateOpacity(), this;
        },
        setStyle: function(t) {
            return t.opacity && this.setOpacity(t.opacity), this;
        },
        bringToFront: function() {
            return this._map && fe(this._image), this;
        },
        bringToBack: function() {
            return this._map && ge(this._image), this;
        },
        setUrl: function(t) {
            return this._url = t, this._image && (this._image.src = t), this;
        },
        setBounds: function(t) {
            return this._bounds = g(t), this._map && this._reset(), this;
        },
        getEvents: function() {
            var t = {
                zoom: this._reset,
                viewreset: this._reset
            };
            return this._zoomAnimated && (t.zoomanim = this._animateZoom), t;
        },
        setZIndex: function(t) {
            return this.options.zIndex = t, this._updateZIndex(), this;
        },
        getBounds: function() {
            return this._bounds;
        },
        getElement: function() {
            return this._image;
        },
        _initImage: function() {
            var t = "IMG" === this._url.tagName, e = this._image = t ? this._url : P("img");
            M(e, "leaflet-image-layer"), this._zoomAnimated && M(e, "leaflet-zoom-animated"), this.options.className && M(e, this.options.className), e.onselectstart = u, e.onmousemove = u, e.onload = a(this.fire, this, "load"), e.onerror = a(this._overlayOnError, this, "error"), !this.options.crossOrigin && "" !== this.options.crossOrigin || (e.crossOrigin = !0 === this.options.crossOrigin ? "" : this.options.crossOrigin), this.options.zIndex && this._updateZIndex(), t ? this._url = e.src : (e.src = this._url, e.alt = this.options.alt);
        },
        _animateZoom: function(t) {
            var e = this._map.getZoomScale(t.zoom), t = this._map._latLngBoundsToNewLayerBounds(this._bounds, t.zoom, t.center).min;
            be(this._image, t, e);
        },
        _reset: function() {
            var t = this._image, e = new f(this._map.latLngToLayerPoint(this._bounds.getNorthWest()), this._map.latLngToLayerPoint(this._bounds.getSouthEast())), i = e.getSize();
            Z(t, e.min), t.style.width = i.x + "px", t.style.height = i.y + "px";
        },
        _updateOpacity: function() {
            C(this._image, this.options.opacity);
        },
        _updateZIndex: function() {
            this._image && void 0 !== this.options.zIndex && null !== this.options.zIndex && (this._image.style.zIndex = this.options.zIndex);
        },
        _overlayOnError: function() {
            this.fire("error");
            var t = this.options.errorOverlayUrl;
            t && this._url !== t && (this._url = t, this._image.src = t);
        },
        getCenter: function() {
            return this._bounds.getCenter();
        }
    }), ki = Ei.extend({
        options: {
            autoplay: !0,
            loop: !0,
            keepAspectRatio: !0,
            muted: !1,
            playsInline: !0
        },
        _initImage: function() {
            var t = "VIDEO" === this._url.tagName, e = this._image = t ? this._url : P("video");
            if (M(e, "leaflet-image-layer"), this._zoomAnimated && M(e, "leaflet-zoom-animated"), this.options.className && M(e, this.options.className), e.onselectstart = u, e.onmousemove = u, e.onloadeddata = a(this.fire, this, "load"), t) {
                for(var i = e.getElementsByTagName("source"), n = [], o = 0; o < i.length; o++)n.push(i[o].src);
                this._url = 0 < i.length ? n : [
                    e.src
                ];
            } else {
                d(this._url) || (this._url = [
                    this._url
                ]), !this.options.keepAspectRatio && Object.prototype.hasOwnProperty.call(e.style, "objectFit") && (e.style.objectFit = "fill"), e.autoplay = !!this.options.autoplay, e.loop = !!this.options.loop, e.muted = !!this.options.muted, e.playsInline = !!this.options.playsInline;
                for(var s = 0; s < this._url.length; s++){
                    var r = P("source");
                    r.src = this._url[s], e.appendChild(r);
                }
            }
        }
    });
    var Oi = Ei.extend({
        _initImage: function() {
            var t = this._image = this._url;
            M(t, "leaflet-image-layer"), this._zoomAnimated && M(t, "leaflet-zoom-animated"), this.options.className && M(t, this.options.className), t.onselectstart = u, t.onmousemove = u;
        }
    });
    var Ai = o.extend({
        options: {
            interactive: !1,
            offset: [
                0,
                0
            ],
            className: "",
            pane: void 0,
            content: ""
        },
        initialize: function(t, e) {
            t && (t instanceof v || d(t)) ? (this._latlng = w(t), c(this, e)) : (c(this, t), this._source = e), this.options.content && (this._content = this.options.content);
        },
        openOn: function(t) {
            return (t = arguments.length ? t : this._source._map).hasLayer(this) || t.addLayer(this), this;
        },
        close: function() {
            return this._map && this._map.removeLayer(this), this;
        },
        toggle: function(t) {
            return this._map ? this.close() : (arguments.length ? this._source = t : t = this._source, this._prepareOpen(), this.openOn(t._map)), this;
        },
        onAdd: function(t) {
            this._zoomAnimated = t._zoomAnimated, this._container || this._initLayout(), t._fadeAnimated && C(this._container, 0), clearTimeout(this._removeTimeout), this.getPane().appendChild(this._container), this.update(), t._fadeAnimated && C(this._container, 1), this.bringToFront(), this.options.interactive && (M(this._container, "leaflet-interactive"), this.addInteractiveTarget(this._container));
        },
        onRemove: function(t) {
            t._fadeAnimated ? (C(this._container, 0), this._removeTimeout = setTimeout(a(T, void 0, this._container), 200)) : T(this._container), this.options.interactive && (z(this._container, "leaflet-interactive"), this.removeInteractiveTarget(this._container));
        },
        getLatLng: function() {
            return this._latlng;
        },
        setLatLng: function(t) {
            return this._latlng = w(t), this._map && (this._updatePosition(), this._adjustPan()), this;
        },
        getContent: function() {
            return this._content;
        },
        setContent: function(t) {
            return this._content = t, this.update(), this;
        },
        getElement: function() {
            return this._container;
        },
        update: function() {
            this._map && (this._container.style.visibility = "hidden", this._updateContent(), this._updateLayout(), this._updatePosition(), this._container.style.visibility = "", this._adjustPan());
        },
        getEvents: function() {
            var t = {
                zoom: this._updatePosition,
                viewreset: this._updatePosition
            };
            return this._zoomAnimated && (t.zoomanim = this._animateZoom), t;
        },
        isOpen: function() {
            return !!this._map && this._map.hasLayer(this);
        },
        bringToFront: function() {
            return this._map && fe(this._container), this;
        },
        bringToBack: function() {
            return this._map && ge(this._container), this;
        },
        _prepareOpen: function(t) {
            if (!(i = this._source)._map) return !1;
            if (i instanceof ci) {
                var e, i = null, n = this._source._layers;
                for(e in n)if (n[e]._map) {
                    i = n[e];
                    break;
                }
                if (!i) return !1;
                this._source = i;
            }
            if (!t) {
                if (i.getCenter) t = i.getCenter();
                else if (i.getLatLng) t = i.getLatLng();
                else {
                    if (!i.getBounds) throw new Error("Unable to get source layer LatLng.");
                    t = i.getBounds().getCenter();
                }
            }
            return this.setLatLng(t), this._map && this.update(), !0;
        },
        _updateContent: function() {
            if (this._content) {
                var t = this._contentNode, e = "function" == typeof this._content ? this._content(this._source || this) : this._content;
                if ("string" == typeof e) t.innerHTML = e;
                else {
                    for(; t.hasChildNodes();)t.removeChild(t.firstChild);
                    t.appendChild(e);
                }
                this.fire("contentupdate");
            }
        },
        _updatePosition: function() {
            var t, e, i;
            this._map && (e = this._map.latLngToLayerPoint(this._latlng), t = m(this.options.offset), i = this._getAnchor(), this._zoomAnimated ? Z(this._container, e.add(i)) : t = t.add(e).add(i), e = this._containerBottom = -t.y, i = this._containerLeft = -Math.round(this._containerWidth / 2) + t.x, this._container.style.bottom = e + "px", this._container.style.left = i + "px");
        },
        _getAnchor: function() {
            return [
                0,
                0
            ];
        }
    }), Bi = (A.include({
        _initOverlay: function(t, e, i, n) {
            var o = e;
            return o instanceof t || (o = new t(n).setContent(e)), i && o.setLatLng(i), o;
        }
    }), o.include({
        _initOverlay: function(t, e, i, n) {
            var o = i;
            return o instanceof t ? (c(o, n), o._source = this) : (o = e && !n ? e : new t(n, this)).setContent(i), o;
        }
    }), Ai.extend({
        options: {
            pane: "popupPane",
            offset: [
                0,
                7
            ],
            maxWidth: 300,
            minWidth: 50,
            maxHeight: null,
            autoPan: !0,
            autoPanPaddingTopLeft: null,
            autoPanPaddingBottomRight: null,
            autoPanPadding: [
                5,
                5
            ],
            keepInView: !1,
            closeButton: !0,
            autoClose: !0,
            closeOnEscapeKey: !0,
            className: ""
        },
        openOn: function(t) {
            return !(t = arguments.length ? t : this._source._map).hasLayer(this) && t._popup && t._popup.options.autoClose && t.removeLayer(t._popup), t._popup = this, Ai.prototype.openOn.call(this, t);
        },
        onAdd: function(t) {
            Ai.prototype.onAdd.call(this, t), t.fire("popupopen", {
                popup: this
            }), this._source && (this._source.fire("popupopen", {
                popup: this
            }, !0), this._source instanceof fi || this._source.on("preclick", Ae));
        },
        onRemove: function(t) {
            Ai.prototype.onRemove.call(this, t), t.fire("popupclose", {
                popup: this
            }), this._source && (this._source.fire("popupclose", {
                popup: this
            }, !0), this._source instanceof fi || this._source.off("preclick", Ae));
        },
        getEvents: function() {
            var t = Ai.prototype.getEvents.call(this);
            return (void 0 !== this.options.closeOnClick ? this.options.closeOnClick : this._map.options.closePopupOnClick) && (t.preclick = this.close), this.options.keepInView && (t.moveend = this._adjustPan), t;
        },
        _initLayout: function() {
            var t = "leaflet-popup", e = this._container = P("div", t + " " + (this.options.className || "") + " leaflet-zoom-animated"), i = this._wrapper = P("div", t + "-content-wrapper", e);
            this._contentNode = P("div", t + "-content", i), Ie(e), Be(this._contentNode), S(e, "contextmenu", Ae), this._tipContainer = P("div", t + "-tip-container", e), this._tip = P("div", t + "-tip", this._tipContainer), this.options.closeButton && ((i = this._closeButton = P("a", t + "-close-button", e)).setAttribute("role", "button"), i.setAttribute("aria-label", "Close popup"), i.href = "#close", i.innerHTML = '<span aria-hidden="true">&#215;</span>', S(i, "click", function(t) {
                O(t), this.close();
            }, this));
        },
        _updateLayout: function() {
            var t = this._contentNode, e = t.style, i = (e.width = "", e.whiteSpace = "nowrap", t.offsetWidth), i = Math.min(i, this.options.maxWidth), i = (i = Math.max(i, this.options.minWidth), e.width = i + 1 + "px", e.whiteSpace = "", e.height = "", t.offsetHeight), n = this.options.maxHeight, o = "leaflet-popup-scrolled";
            (n && n < i ? (e.height = n + "px", M) : z)(t, o), this._containerWidth = this._container.offsetWidth;
        },
        _animateZoom: function(t) {
            var t = this._map._latLngToNewLayerPoint(this._latlng, t.zoom, t.center), e = this._getAnchor();
            Z(this._container, t.add(e));
        },
        _adjustPan: function() {
            var t, e, i, n, o, s, r, a;
            this.options.autoPan && (this._map._panAnim && this._map._panAnim.stop(), this._autopanning ? this._autopanning = !1 : (t = this._map, e = parseInt(pe(this._container, "marginBottom"), 10) || 0, e = this._container.offsetHeight + e, a = this._containerWidth, (i = new p(this._containerLeft, -e - this._containerBottom))._add(Pe(this._container)), i = t.layerPointToContainerPoint(i), o = m(this.options.autoPanPadding), n = m(this.options.autoPanPaddingTopLeft || o), o = m(this.options.autoPanPaddingBottomRight || o), s = t.getSize(), r = 0, i.x + a + o.x > s.x && (r = i.x + a - s.x + o.x), i.x - r - n.x < (a = 0) && (r = i.x - n.x), i.y + e + o.y > s.y && (a = i.y + e - s.y + o.y), i.y - a - n.y < 0 && (a = i.y - n.y), (r || a) && (this.options.keepInView && (this._autopanning = !0), t.fire("autopanstart").panBy([
                r,
                a
            ]))));
        },
        _getAnchor: function() {
            return m(this._source && this._source._getPopupAnchor ? this._source._getPopupAnchor() : [
                0,
                0
            ]);
        }
    })), Ii = (A.mergeOptions({
        closePopupOnClick: !0
    }), A.include({
        openPopup: function(t, e, i) {
            return this._initOverlay(Bi, t, e, i).openOn(this), this;
        },
        closePopup: function(t) {
            return (t = arguments.length ? t : this._popup) && t.close(), this;
        }
    }), o.include({
        bindPopup: function(t, e) {
            return this._popup = this._initOverlay(Bi, this._popup, t, e), this._popupHandlersAdded || (this.on({
                click: this._openPopup,
                keypress: this._onKeyPress,
                remove: this.closePopup,
                move: this._movePopup
            }), this._popupHandlersAdded = !0), this;
        },
        unbindPopup: function() {
            return this._popup && (this.off({
                click: this._openPopup,
                keypress: this._onKeyPress,
                remove: this.closePopup,
                move: this._movePopup
            }), this._popupHandlersAdded = !1, this._popup = null), this;
        },
        openPopup: function(t) {
            return this._popup && (this instanceof ci || (this._popup._source = this), this._popup._prepareOpen(t || this._latlng) && this._popup.openOn(this._map)), this;
        },
        closePopup: function() {
            return this._popup && this._popup.close(), this;
        },
        togglePopup: function() {
            return this._popup && this._popup.toggle(this), this;
        },
        isPopupOpen: function() {
            return !!this._popup && this._popup.isOpen();
        },
        setPopupContent: function(t) {
            return this._popup && this._popup.setContent(t), this;
        },
        getPopup: function() {
            return this._popup;
        },
        _openPopup: function(t) {
            var e;
            this._popup && this._map && (Re(t), e = t.layer || t.target, this._popup._source !== e || e instanceof fi ? (this._popup._source = e, this.openPopup(t.latlng)) : this._map.hasLayer(this._popup) ? this.closePopup() : this.openPopup(t.latlng));
        },
        _movePopup: function(t) {
            this._popup.setLatLng(t.latlng);
        },
        _onKeyPress: function(t) {
            13 === t.originalEvent.keyCode && this._openPopup(t);
        }
    }), Ai.extend({
        options: {
            pane: "tooltipPane",
            offset: [
                0,
                0
            ],
            direction: "auto",
            permanent: !1,
            sticky: !1,
            opacity: .9
        },
        onAdd: function(t) {
            Ai.prototype.onAdd.call(this, t), this.setOpacity(this.options.opacity), t.fire("tooltipopen", {
                tooltip: this
            }), this._source && (this.addEventParent(this._source), this._source.fire("tooltipopen", {
                tooltip: this
            }, !0));
        },
        onRemove: function(t) {
            Ai.prototype.onRemove.call(this, t), t.fire("tooltipclose", {
                tooltip: this
            }), this._source && (this.removeEventParent(this._source), this._source.fire("tooltipclose", {
                tooltip: this
            }, !0));
        },
        getEvents: function() {
            var t = Ai.prototype.getEvents.call(this);
            return this.options.permanent || (t.preclick = this.close), t;
        },
        _initLayout: function() {
            var t = "leaflet-tooltip " + (this.options.className || "") + " leaflet-zoom-" + (this._zoomAnimated ? "animated" : "hide");
            this._contentNode = this._container = P("div", t), this._container.setAttribute("role", "tooltip"), this._container.setAttribute("id", "leaflet-tooltip-" + h(this));
        },
        _updateLayout: function() {},
        _adjustPan: function() {},
        _setPosition: function(t) {
            var e, i = this._map, n = this._container, o = i.latLngToContainerPoint(i.getCenter()), i = i.layerPointToContainerPoint(t), s = this.options.direction, r = n.offsetWidth, a = n.offsetHeight, h = m(this.options.offset), l = this._getAnchor(), i = "top" === s ? (e = r / 2, a) : "bottom" === s ? (e = r / 2, 0) : (e = "center" === s ? r / 2 : "right" === s ? 0 : "left" === s ? r : i.x < o.x ? (s = "right", 0) : (s = "left", r + 2 * (h.x + l.x)), a / 2);
            t = t.subtract(m(e, i, !0)).add(h).add(l), z(n, "leaflet-tooltip-right"), z(n, "leaflet-tooltip-left"), z(n, "leaflet-tooltip-top"), z(n, "leaflet-tooltip-bottom"), M(n, "leaflet-tooltip-" + s), Z(n, t);
        },
        _updatePosition: function() {
            var t = this._map.latLngToLayerPoint(this._latlng);
            this._setPosition(t);
        },
        setOpacity: function(t) {
            this.options.opacity = t, this._container && C(this._container, t);
        },
        _animateZoom: function(t) {
            t = this._map._latLngToNewLayerPoint(this._latlng, t.zoom, t.center);
            this._setPosition(t);
        },
        _getAnchor: function() {
            return m(this._source && this._source._getTooltipAnchor && !this.options.sticky ? this._source._getTooltipAnchor() : [
                0,
                0
            ]);
        }
    })), Ri = (A.include({
        openTooltip: function(t, e, i) {
            return this._initOverlay(Ii, t, e, i).openOn(this), this;
        },
        closeTooltip: function(t) {
            return t.close(), this;
        }
    }), o.include({
        bindTooltip: function(t, e) {
            return this._tooltip && this.isTooltipOpen() && this.unbindTooltip(), this._tooltip = this._initOverlay(Ii, this._tooltip, t, e), this._initTooltipInteractions(), this._tooltip.options.permanent && this._map && this._map.hasLayer(this) && this.openTooltip(), this;
        },
        unbindTooltip: function() {
            return this._tooltip && (this._initTooltipInteractions(!0), this.closeTooltip(), this._tooltip = null), this;
        },
        _initTooltipInteractions: function(t) {
            var e, i;
            !t && this._tooltipHandlersAdded || (e = t ? "off" : "on", i = {
                remove: this.closeTooltip,
                move: this._moveTooltip
            }, this._tooltip.options.permanent ? i.add = this._openTooltip : (i.mouseover = this._openTooltip, i.mouseout = this.closeTooltip, i.click = this._openTooltip, this._map ? this._addFocusListeners() : i.add = this._addFocusListeners), this._tooltip.options.sticky && (i.mousemove = this._moveTooltip), this[e](i), this._tooltipHandlersAdded = !t);
        },
        openTooltip: function(t) {
            return this._tooltip && (this instanceof ci || (this._tooltip._source = this), this._tooltip._prepareOpen(t) && (this._tooltip.openOn(this._map), this.getElement ? this._setAriaDescribedByOnLayer(this) : this.eachLayer && this.eachLayer(this._setAriaDescribedByOnLayer, this))), this;
        },
        closeTooltip: function() {
            if (this._tooltip) return this._tooltip.close();
        },
        toggleTooltip: function() {
            return this._tooltip && this._tooltip.toggle(this), this;
        },
        isTooltipOpen: function() {
            return this._tooltip.isOpen();
        },
        setTooltipContent: function(t) {
            return this._tooltip && this._tooltip.setContent(t), this;
        },
        getTooltip: function() {
            return this._tooltip;
        },
        _addFocusListeners: function() {
            this.getElement ? this._addFocusListenersOnLayer(this) : this.eachLayer && this.eachLayer(this._addFocusListenersOnLayer, this);
        },
        _addFocusListenersOnLayer: function(t) {
            var e = "function" == typeof t.getElement && t.getElement();
            e && (S(e, "focus", function() {
                this._tooltip._source = t, this.openTooltip();
            }, this), S(e, "blur", this.closeTooltip, this));
        },
        _setAriaDescribedByOnLayer: function(t) {
            t = "function" == typeof t.getElement && t.getElement();
            t && t.setAttribute("aria-describedby", this._tooltip._container.id);
        },
        _openTooltip: function(t) {
            var e;
            this._tooltip && this._map && (this._map.dragging && this._map.dragging.moving() && !this._openOnceFlag ? (this._openOnceFlag = !0, (e = this)._map.once("moveend", function() {
                e._openOnceFlag = !1, e._openTooltip(t);
            })) : (this._tooltip._source = t.layer || t.target, this.openTooltip(this._tooltip.options.sticky ? t.latlng : void 0)));
        },
        _moveTooltip: function(t) {
            var e = t.latlng;
            this._tooltip.options.sticky && t.originalEvent && (t = this._map.mouseEventToContainerPoint(t.originalEvent), t = this._map.containerPointToLayerPoint(t), e = this._map.layerPointToLatLng(t)), this._tooltip.setLatLng(e);
        }
    }), di.extend({
        options: {
            iconSize: [
                12,
                12
            ],
            html: !1,
            bgPos: null,
            className: "leaflet-div-icon"
        },
        createIcon: function(t) {
            var t = t && "DIV" === t.tagName ? t : document.createElement("div"), e = this.options;
            return e.html instanceof Element ? (me(t), t.appendChild(e.html)) : t.innerHTML = !1 !== e.html ? e.html : "", e.bgPos && (e = m(e.bgPos), t.style.backgroundPosition = -e.x + "px " + -e.y + "px"), this._setIconStyles(t, "icon"), t;
        },
        createShadow: function() {
            return null;
        }
    }));
    di.Default = _i;
    var Ni = o.extend({
        options: {
            tileSize: 256,
            opacity: 1,
            updateWhenIdle: b.mobile,
            updateWhenZooming: !0,
            updateInterval: 200,
            zIndex: 1,
            bounds: null,
            minZoom: 0,
            maxZoom: void 0,
            maxNativeZoom: void 0,
            minNativeZoom: void 0,
            noWrap: !1,
            pane: "tilePane",
            className: "",
            keepBuffer: 2
        },
        initialize: function(t) {
            c(this, t);
        },
        onAdd: function() {
            this._initContainer(), this._levels = {}, this._tiles = {}, this._resetView();
        },
        beforeAdd: function(t) {
            t._addZoomLimit(this);
        },
        onRemove: function(t) {
            this._removeAllTiles(), T(this._container), t._removeZoomLimit(this), this._container = null, this._tileZoom = void 0;
        },
        bringToFront: function() {
            return this._map && (fe(this._container), this._setAutoZIndex(Math.max)), this;
        },
        bringToBack: function() {
            return this._map && (ge(this._container), this._setAutoZIndex(Math.min)), this;
        },
        getContainer: function() {
            return this._container;
        },
        setOpacity: function(t) {
            return this.options.opacity = t, this._updateOpacity(), this;
        },
        setZIndex: function(t) {
            return this.options.zIndex = t, this._updateZIndex(), this;
        },
        isLoading: function() {
            return this._loading;
        },
        redraw: function() {
            var t;
            return this._map && (this._removeAllTiles(), (t = this._clampZoom(this._map.getZoom())) !== this._tileZoom && (this._tileZoom = t, this._updateLevels()), this._update()), this;
        },
        getEvents: function() {
            var t = {
                viewprereset: this._invalidateAll,
                viewreset: this._resetView,
                zoom: this._resetView,
                moveend: this._onMoveEnd
            };
            return this.options.updateWhenIdle || (this._onMove || (this._onMove = j(this._onMoveEnd, this.options.updateInterval, this)), t.move = this._onMove), this._zoomAnimated && (t.zoomanim = this._animateZoom), t;
        },
        createTile: function() {
            return document.createElement("div");
        },
        getTileSize: function() {
            var t = this.options.tileSize;
            return t instanceof p ? t : new p(t, t);
        },
        _updateZIndex: function() {
            this._container && void 0 !== this.options.zIndex && null !== this.options.zIndex && (this._container.style.zIndex = this.options.zIndex);
        },
        _setAutoZIndex: function(t) {
            for(var e, i = this.getPane().children, n = -t(-1 / 0, 1 / 0), o = 0, s = i.length; o < s; o++)e = i[o].style.zIndex, i[o] !== this._container && e && (n = t(n, +e));
            isFinite(n) && (this.options.zIndex = n + t(-1, 1), this._updateZIndex());
        },
        _updateOpacity: function() {
            if (this._map && !b.ielt9) {
                C(this._container, this.options.opacity);
                var t, e = +new Date, i = !1, n = !1;
                for(t in this._tiles){
                    var o, s = this._tiles[t];
                    s.current && s.loaded && (o = Math.min(1, (e - s.loaded) / 200), C(s.el, o), o < 1 ? i = !0 : (s.active ? n = !0 : this._onOpaqueTile(s), s.active = !0));
                }
                n && !this._noPrune && this._pruneTiles(), i && (r(this._fadeFrame), this._fadeFrame = x(this._updateOpacity, this));
            }
        },
        _onOpaqueTile: u,
        _initContainer: function() {
            this._container || (this._container = P("div", "leaflet-layer " + (this.options.className || "")), this._updateZIndex(), this.options.opacity < 1 && this._updateOpacity(), this.getPane().appendChild(this._container));
        },
        _updateLevels: function() {
            var t = this._tileZoom, e = this.options.maxZoom;
            if (void 0 !== t) {
                for(var i in this._levels)i = Number(i), this._levels[i].el.children.length || i === t ? (this._levels[i].el.style.zIndex = e - Math.abs(t - i), this._onUpdateLevel(i)) : (T(this._levels[i].el), this._removeTilesAtZoom(i), this._onRemoveLevel(i), delete this._levels[i]);
                var n = this._levels[t], o = this._map;
                return n || ((n = this._levels[t] = {}).el = P("div", "leaflet-tile-container leaflet-zoom-animated", this._container), n.el.style.zIndex = e, n.origin = o.project(o.unproject(o.getPixelOrigin()), t).round(), n.zoom = t, this._setZoomTransform(n, o.getCenter(), o.getZoom()), u(n.el.offsetWidth), this._onCreateLevel(n)), this._level = n;
            }
        },
        _onUpdateLevel: u,
        _onRemoveLevel: u,
        _onCreateLevel: u,
        _pruneTiles: function() {
            if (this._map) {
                var t, e, i, n = this._map.getZoom();
                if (n > this.options.maxZoom || n < this.options.minZoom) this._removeAllTiles();
                else {
                    for(t in this._tiles)(i = this._tiles[t]).retain = i.current;
                    for(t in this._tiles)(i = this._tiles[t]).current && !i.active && (e = i.coords, this._retainParent(e.x, e.y, e.z, e.z - 5) || this._retainChildren(e.x, e.y, e.z, e.z + 2));
                    for(t in this._tiles)this._tiles[t].retain || this._removeTile(t);
                }
            }
        },
        _removeTilesAtZoom: function(t) {
            for(var e in this._tiles)this._tiles[e].coords.z === t && this._removeTile(e);
        },
        _removeAllTiles: function() {
            for(var t in this._tiles)this._removeTile(t);
        },
        _invalidateAll: function() {
            for(var t in this._levels)T(this._levels[t].el), this._onRemoveLevel(Number(t)), delete this._levels[t];
            this._removeAllTiles(), this._tileZoom = void 0;
        },
        _retainParent: function(t, e, i, n) {
            var t = Math.floor(t / 2), e = Math.floor(e / 2), i = i - 1, o = new p(+t, +e), o = (o.z = i, this._tileCoordsToKey(o)), o = this._tiles[o];
            return o && o.active ? o.retain = !0 : (o && o.loaded && (o.retain = !0), n < i && this._retainParent(t, e, i, n));
        },
        _retainChildren: function(t, e, i, n) {
            for(var o = 2 * t; o < 2 * t + 2; o++)for(var s = 2 * e; s < 2 * e + 2; s++){
                var r = new p(o, s), r = (r.z = i + 1, this._tileCoordsToKey(r)), r = this._tiles[r];
                r && r.active ? r.retain = !0 : (r && r.loaded && (r.retain = !0), i + 1 < n && this._retainChildren(o, s, i + 1, n));
            }
        },
        _resetView: function(t) {
            t = t && (t.pinch || t.flyTo);
            this._setView(this._map.getCenter(), this._map.getZoom(), t, t);
        },
        _animateZoom: function(t) {
            this._setView(t.center, t.zoom, !0, t.noUpdate);
        },
        _clampZoom: function(t) {
            var e = this.options;
            return void 0 !== e.minNativeZoom && t < e.minNativeZoom ? e.minNativeZoom : void 0 !== e.maxNativeZoom && e.maxNativeZoom < t ? e.maxNativeZoom : t;
        },
        _setView: function(t, e, i, n) {
            var o = Math.round(e), o = void 0 !== this.options.maxZoom && o > this.options.maxZoom || void 0 !== this.options.minZoom && o < this.options.minZoom ? void 0 : this._clampZoom(o), s = this.options.updateWhenZooming && o !== this._tileZoom;
            n && !s || (this._tileZoom = o, this._abortLoading && this._abortLoading(), this._updateLevels(), this._resetGrid(), void 0 !== o && this._update(t), i || this._pruneTiles(), this._noPrune = !!i), this._setZoomTransforms(t, e);
        },
        _setZoomTransforms: function(t, e) {
            for(var i in this._levels)this._setZoomTransform(this._levels[i], t, e);
        },
        _setZoomTransform: function(t, e, i) {
            var n = this._map.getZoomScale(i, t.zoom), e = t.origin.multiplyBy(n).subtract(this._map._getNewPixelOrigin(e, i)).round();
            b.any3d ? be(t.el, e, n) : Z(t.el, e);
        },
        _resetGrid: function() {
            var t = this._map, e = t.options.crs, i = this._tileSize = this.getTileSize(), n = this._tileZoom, o = this._map.getPixelWorldBounds(this._tileZoom);
            o && (this._globalTileRange = this._pxBoundsToTileRange(o)), this._wrapX = e.wrapLng && !this.options.noWrap && [
                Math.floor(t.project([
                    0,
                    e.wrapLng[0]
                ], n).x / i.x),
                Math.ceil(t.project([
                    0,
                    e.wrapLng[1]
                ], n).x / i.y)
            ], this._wrapY = e.wrapLat && !this.options.noWrap && [
                Math.floor(t.project([
                    e.wrapLat[0],
                    0
                ], n).y / i.x),
                Math.ceil(t.project([
                    e.wrapLat[1],
                    0
                ], n).y / i.y)
            ];
        },
        _onMoveEnd: function() {
            this._map && !this._map._animatingZoom && this._update();
        },
        _getTiledPixelBounds: function(t) {
            var e = this._map, i = e._animatingZoom ? Math.max(e._animateToZoom, e.getZoom()) : e.getZoom(), i = e.getZoomScale(i, this._tileZoom), t = e.project(t, this._tileZoom).floor(), e = e.getSize().divideBy(2 * i);
            return new f(t.subtract(e), t.add(e));
        },
        _update: function(t) {
            var e = this._map;
            if (e) {
                var i = this._clampZoom(e.getZoom());
                if (void 0 === t && (t = e.getCenter()), void 0 !== this._tileZoom) {
                    var n, e = this._getTiledPixelBounds(t), o = this._pxBoundsToTileRange(e), s = o.getCenter(), r = [], e = this.options.keepBuffer, a = new f(o.getBottomLeft().subtract([
                        e,
                        -e
                    ]), o.getTopRight().add([
                        e,
                        -e
                    ]));
                    if (!(isFinite(o.min.x) && isFinite(o.min.y) && isFinite(o.max.x) && isFinite(o.max.y))) throw new Error("Attempted to load an infinite number of tiles");
                    for(n in this._tiles){
                        var h = this._tiles[n].coords;
                        h.z === this._tileZoom && a.contains(new p(h.x, h.y)) || (this._tiles[n].current = !1);
                    }
                    if (1 < Math.abs(i - this._tileZoom)) this._setView(t, i);
                    else {
                        for(var l = o.min.y; l <= o.max.y; l++)for(var u = o.min.x; u <= o.max.x; u++){
                            var c, d = new p(u, l);
                            d.z = this._tileZoom, this._isValidTile(d) && ((c = this._tiles[this._tileCoordsToKey(d)]) ? c.current = !0 : r.push(d));
                        }
                        if (r.sort(function(t, e) {
                            return t.distanceTo(s) - e.distanceTo(s);
                        }), 0 !== r.length) {
                            this._loading || (this._loading = !0, this.fire("loading"));
                            for(var _ = document.createDocumentFragment(), u = 0; u < r.length; u++)this._addTile(r[u], _);
                            this._level.el.appendChild(_);
                        }
                    }
                }
            }
        },
        _isValidTile: function(t) {
            var e = this._map.options.crs;
            if (!e.infinite) {
                var i = this._globalTileRange;
                if (!e.wrapLng && (t.x < i.min.x || t.x > i.max.x) || !e.wrapLat && (t.y < i.min.y || t.y > i.max.y)) return !1;
            }
            return !this.options.bounds || (e = this._tileCoordsToBounds(t), g(this.options.bounds).overlaps(e));
        },
        _keyToBounds: function(t) {
            return this._tileCoordsToBounds(this._keyToTileCoords(t));
        },
        _tileCoordsToNwSe: function(t) {
            var e = this._map, i = this.getTileSize(), n = t.scaleBy(i), i = n.add(i);
            return [
                e.unproject(n, t.z),
                e.unproject(i, t.z)
            ];
        },
        _tileCoordsToBounds: function(t) {
            t = this._tileCoordsToNwSe(t), t = new s(t[0], t[1]);
            return t = this.options.noWrap ? t : this._map.wrapLatLngBounds(t);
        },
        _tileCoordsToKey: function(t) {
            return t.x + ":" + t.y + ":" + t.z;
        },
        _keyToTileCoords: function(t) {
            var t = t.split(":"), e = new p(+t[0], +t[1]);
            return e.z = +t[2], e;
        },
        _removeTile: function(t) {
            var e = this._tiles[t];
            e && (T(e.el), delete this._tiles[t], this.fire("tileunload", {
                tile: e.el,
                coords: this._keyToTileCoords(t)
            }));
        },
        _initTile: function(t) {
            M(t, "leaflet-tile");
            var e = this.getTileSize();
            t.style.width = e.x + "px", t.style.height = e.y + "px", t.onselectstart = u, t.onmousemove = u, b.ielt9 && this.options.opacity < 1 && C(t, this.options.opacity);
        },
        _addTile: function(t, e) {
            var i = this._getTilePos(t), n = this._tileCoordsToKey(t), o = this.createTile(this._wrapCoords(t), a(this._tileReady, this, t));
            this._initTile(o), this.createTile.length < 2 && x(a(this._tileReady, this, t, null, o)), Z(o, i), this._tiles[n] = {
                el: o,
                coords: t,
                current: !0
            }, e.appendChild(o), this.fire("tileloadstart", {
                tile: o,
                coords: t
            });
        },
        _tileReady: function(t, e, i) {
            e && this.fire("tileerror", {
                error: e,
                tile: i,
                coords: t
            });
            var n = this._tileCoordsToKey(t);
            (i = this._tiles[n]) && (i.loaded = +new Date, this._map._fadeAnimated ? (C(i.el, 0), r(this._fadeFrame), this._fadeFrame = x(this._updateOpacity, this)) : (i.active = !0, this._pruneTiles()), e || (M(i.el, "leaflet-tile-loaded"), this.fire("tileload", {
                tile: i.el,
                coords: t
            })), this._noTilesToLoad() && (this._loading = !1, this.fire("load"), b.ielt9 || !this._map._fadeAnimated ? x(this._pruneTiles, this) : setTimeout(a(this._pruneTiles, this), 250)));
        },
        _getTilePos: function(t) {
            return t.scaleBy(this.getTileSize()).subtract(this._level.origin);
        },
        _wrapCoords: function(t) {
            var e = new p(this._wrapX ? H(t.x, this._wrapX) : t.x, this._wrapY ? H(t.y, this._wrapY) : t.y);
            return e.z = t.z, e;
        },
        _pxBoundsToTileRange: function(t) {
            var e = this.getTileSize();
            return new f(t.min.unscaleBy(e).floor(), t.max.unscaleBy(e).ceil().subtract([
                1,
                1
            ]));
        },
        _noTilesToLoad: function() {
            for(var t in this._tiles)if (!this._tiles[t].loaded) return !1;
            return !0;
        }
    });
    var Di = Ni.extend({
        options: {
            minZoom: 0,
            maxZoom: 18,
            subdomains: "abc",
            errorTileUrl: "",
            zoomOffset: 0,
            tms: !1,
            zoomReverse: !1,
            detectRetina: !1,
            crossOrigin: !1,
            referrerPolicy: !1
        },
        initialize: function(t, e) {
            this._url = t, (e = c(this, e)).detectRetina && b.retina && 0 < e.maxZoom ? (e.tileSize = Math.floor(e.tileSize / 2), e.zoomReverse ? (e.zoomOffset--, e.minZoom = Math.min(e.maxZoom, e.minZoom + 1)) : (e.zoomOffset++, e.maxZoom = Math.max(e.minZoom, e.maxZoom - 1)), e.minZoom = Math.max(0, e.minZoom)) : e.zoomReverse ? e.minZoom = Math.min(e.maxZoom, e.minZoom) : e.maxZoom = Math.max(e.minZoom, e.maxZoom), "string" == typeof e.subdomains && (e.subdomains = e.subdomains.split("")), this.on("tileunload", this._onTileRemove);
        },
        setUrl: function(t, e) {
            return this._url === t && void 0 === e && (e = !0), this._url = t, e || this.redraw(), this;
        },
        createTile: function(t, e) {
            var i = document.createElement("img");
            return S(i, "load", a(this._tileOnLoad, this, e, i)), S(i, "error", a(this._tileOnError, this, e, i)), !this.options.crossOrigin && "" !== this.options.crossOrigin || (i.crossOrigin = !0 === this.options.crossOrigin ? "" : this.options.crossOrigin), "string" == typeof this.options.referrerPolicy && (i.referrerPolicy = this.options.referrerPolicy), i.alt = "", i.src = this.getTileUrl(t), i;
        },
        getTileUrl: function(t) {
            var e = {
                r: b.retina ? "@2x" : "",
                s: this._getSubdomain(t),
                x: t.x,
                y: t.y,
                z: this._getZoomForUrl()
            };
            return this._map && !this._map.options.crs.infinite && (t = this._globalTileRange.max.y - t.y, this.options.tms && (e.y = t), e["-y"] = t), q(this._url, l(e, this.options));
        },
        _tileOnLoad: function(t, e) {
            b.ielt9 ? setTimeout(a(t, this, null, e), 0) : t(null, e);
        },
        _tileOnError: function(t, e, i) {
            var n = this.options.errorTileUrl;
            n && e.getAttribute("src") !== n && (e.src = n), t(i, e);
        },
        _onTileRemove: function(t) {
            t.tile.onload = null;
        },
        _getZoomForUrl: function() {
            var t = this._tileZoom, e = this.options.maxZoom;
            return (t = this.options.zoomReverse ? e - t : t) + this.options.zoomOffset;
        },
        _getSubdomain: function(t) {
            t = Math.abs(t.x + t.y) % this.options.subdomains.length;
            return this.options.subdomains[t];
        },
        _abortLoading: function() {
            var t, e, i;
            for(t in this._tiles)this._tiles[t].coords.z !== this._tileZoom && ((i = this._tiles[t].el).onload = u, i.onerror = u, i.complete || (i.src = K, e = this._tiles[t].coords, T(i), delete this._tiles[t], this.fire("tileabort", {
                tile: i,
                coords: e
            })));
        },
        _removeTile: function(t) {
            var e = this._tiles[t];
            if (e) return e.el.setAttribute("src", K), Ni.prototype._removeTile.call(this, t);
        },
        _tileReady: function(t, e, i) {
            if (this._map && (!i || i.getAttribute("src") !== K)) return Ni.prototype._tileReady.call(this, t, e, i);
        }
    });
    function ji(t, e) {
        return new Di(t, e);
    }
    var Hi = Di.extend({
        defaultWmsParams: {
            service: "WMS",
            request: "GetMap",
            layers: "",
            styles: "",
            format: "image/jpeg",
            transparent: !1,
            version: "1.1.1"
        },
        options: {
            crs: null,
            uppercase: !1
        },
        initialize: function(t, e) {
            this._url = t;
            var i, n = l({}, this.defaultWmsParams);
            for(i in e)i in this.options || (n[i] = e[i]);
            var t = (e = c(this, e)).detectRetina && b.retina ? 2 : 1, o = this.getTileSize();
            n.width = o.x * t, n.height = o.y * t, this.wmsParams = n;
        },
        onAdd: function(t) {
            this._crs = this.options.crs || t.options.crs, this._wmsVersion = parseFloat(this.wmsParams.version);
            var e = 1.3 <= this._wmsVersion ? "crs" : "srs";
            this.wmsParams[e] = this._crs.code, Di.prototype.onAdd.call(this, t);
        },
        getTileUrl: function(t) {
            var e = this._tileCoordsToNwSe(t), i = this._crs, i = _(i.project(e[0]), i.project(e[1])), e = i.min, i = i.max, e = (1.3 <= this._wmsVersion && this._crs === li ? [
                e.y,
                e.x,
                i.y,
                i.x
            ] : [
                e.x,
                e.y,
                i.x,
                i.y
            ]).join(","), i = Di.prototype.getTileUrl.call(this, t);
            return i + U(this.wmsParams, i, this.options.uppercase) + (this.options.uppercase ? "&BBOX=" : "&bbox=") + e;
        },
        setParams: function(t, e) {
            return l(this.wmsParams, t), e || this.redraw(), this;
        }
    });
    Di.WMS = Hi, ji.wms = function(t, e) {
        return new Hi(t, e);
    };
    var Wi = o.extend({
        options: {
            padding: .1
        },
        initialize: function(t) {
            c(this, t), h(this), this._layers = this._layers || {};
        },
        onAdd: function() {
            this._container || (this._initContainer(), M(this._container, "leaflet-zoom-animated")), this.getPane().appendChild(this._container), this._update(), this.on("update", this._updatePaths, this);
        },
        onRemove: function() {
            this.off("update", this._updatePaths, this), this._destroyContainer();
        },
        getEvents: function() {
            var t = {
                viewreset: this._reset,
                zoom: this._onZoom,
                moveend: this._update,
                zoomend: this._onZoomEnd
            };
            return this._zoomAnimated && (t.zoomanim = this._onAnimZoom), t;
        },
        _onAnimZoom: function(t) {
            this._updateTransform(t.center, t.zoom);
        },
        _onZoom: function() {
            this._updateTransform(this._map.getCenter(), this._map.getZoom());
        },
        _updateTransform: function(t, e) {
            var i = this._map.getZoomScale(e, this._zoom), n = this._map.getSize().multiplyBy(.5 + this.options.padding), o = this._map.project(this._center, e), n = n.multiplyBy(-i).add(o).subtract(this._map._getNewPixelOrigin(t, e));
            b.any3d ? be(this._container, n, i) : Z(this._container, n);
        },
        _reset: function() {
            for(var t in this._update(), this._updateTransform(this._center, this._zoom), this._layers)this._layers[t]._reset();
        },
        _onZoomEnd: function() {
            for(var t in this._layers)this._layers[t]._project();
        },
        _updatePaths: function() {
            for(var t in this._layers)this._layers[t]._update();
        },
        _update: function() {
            var t = this.options.padding, e = this._map.getSize(), i = this._map.containerPointToLayerPoint(e.multiplyBy(-t)).round();
            this._bounds = new f(i, i.add(e.multiplyBy(1 + 2 * t)).round()), this._center = this._map.getCenter(), this._zoom = this._map.getZoom();
        }
    }), Fi = Wi.extend({
        options: {
            tolerance: 0
        },
        getEvents: function() {
            var t = Wi.prototype.getEvents.call(this);
            return t.viewprereset = this._onViewPreReset, t;
        },
        _onViewPreReset: function() {
            this._postponeUpdatePaths = !0;
        },
        onAdd: function() {
            Wi.prototype.onAdd.call(this), this._draw();
        },
        _initContainer: function() {
            var t = this._container = document.createElement("canvas");
            S(t, "mousemove", this._onMouseMove, this), S(t, "click dblclick mousedown mouseup contextmenu", this._onClick, this), S(t, "mouseout", this._handleMouseOut, this), t._leaflet_disable_events = !0, this._ctx = t.getContext("2d");
        },
        _destroyContainer: function() {
            r(this._redrawRequest), delete this._ctx, T(this._container), k(this._container), delete this._container;
        },
        _updatePaths: function() {
            if (!this._postponeUpdatePaths) {
                for(var t in this._redrawBounds = null, this._layers)this._layers[t]._update();
                this._redraw();
            }
        },
        _update: function() {
            var t, e, i, n;
            this._map._animatingZoom && this._bounds || (Wi.prototype._update.call(this), t = this._bounds, e = this._container, i = t.getSize(), n = b.retina ? 2 : 1, Z(e, t.min), e.width = n * i.x, e.height = n * i.y, e.style.width = i.x + "px", e.style.height = i.y + "px", b.retina && this._ctx.scale(2, 2), this._ctx.translate(-t.min.x, -t.min.y), this.fire("update"));
        },
        _reset: function() {
            Wi.prototype._reset.call(this), this._postponeUpdatePaths && (this._postponeUpdatePaths = !1, this._updatePaths());
        },
        _initPath: function(t) {
            this._updateDashArray(t);
            t = (this._layers[h(t)] = t)._order = {
                layer: t,
                prev: this._drawLast,
                next: null
            };
            this._drawLast && (this._drawLast.next = t), this._drawLast = t, this._drawFirst = this._drawFirst || this._drawLast;
        },
        _addPath: function(t) {
            this._requestRedraw(t);
        },
        _removePath: function(t) {
            var e = t._order, i = e.next, e = e.prev;
            i ? i.prev = e : this._drawLast = e, e ? e.next = i : this._drawFirst = i, delete t._order, delete this._layers[h(t)], this._requestRedraw(t);
        },
        _updatePath: function(t) {
            this._extendRedrawBounds(t), t._project(), t._update(), this._requestRedraw(t);
        },
        _updateStyle: function(t) {
            this._updateDashArray(t), this._requestRedraw(t);
        },
        _updateDashArray: function(t) {
            if ("string" == typeof t.options.dashArray) {
                for(var e, i = t.options.dashArray.split(/[, ]+/), n = [], o = 0; o < i.length; o++){
                    if (e = Number(i[o]), isNaN(e)) return;
                    n.push(e);
                }
                t.options._dashArray = n;
            } else t.options._dashArray = t.options.dashArray;
        },
        _requestRedraw: function(t) {
            this._map && (this._extendRedrawBounds(t), this._redrawRequest = this._redrawRequest || x(this._redraw, this));
        },
        _extendRedrawBounds: function(t) {
            var e;
            t._pxBounds && (e = (t.options.weight || 0) + 1, this._redrawBounds = this._redrawBounds || new f, this._redrawBounds.extend(t._pxBounds.min.subtract([
                e,
                e
            ])), this._redrawBounds.extend(t._pxBounds.max.add([
                e,
                e
            ])));
        },
        _redraw: function() {
            this._redrawRequest = null, this._redrawBounds && (this._redrawBounds.min._floor(), this._redrawBounds.max._ceil()), this._clear(), this._draw(), this._redrawBounds = null;
        },
        _clear: function() {
            var t, e = this._redrawBounds;
            e ? (t = e.getSize(), this._ctx.clearRect(e.min.x, e.min.y, t.x, t.y)) : (this._ctx.save(), this._ctx.setTransform(1, 0, 0, 1, 0, 0), this._ctx.clearRect(0, 0, this._container.width, this._container.height), this._ctx.restore());
        },
        _draw: function() {
            var t, e, i = this._redrawBounds;
            this._ctx.save(), i && (e = i.getSize(), this._ctx.beginPath(), this._ctx.rect(i.min.x, i.min.y, e.x, e.y), this._ctx.clip()), this._drawing = !0;
            for(var n = this._drawFirst; n; n = n.next)t = n.layer, (!i || t._pxBounds && t._pxBounds.intersects(i)) && t._updatePath();
            this._drawing = !1, this._ctx.restore();
        },
        _updatePoly: function(t, e) {
            if (this._drawing) {
                var i, n, o, s, r = t._parts, a = r.length, h = this._ctx;
                if (a) {
                    for(h.beginPath(), i = 0; i < a; i++){
                        for(n = 0, o = r[i].length; n < o; n++)s = r[i][n], h[n ? "lineTo" : "moveTo"](s.x, s.y);
                        e && h.closePath();
                    }
                    this._fillStroke(h, t);
                }
            }
        },
        _updateCircle: function(t) {
            var e, i, n, o;
            this._drawing && !t._empty() && (e = t._point, i = this._ctx, n = Math.max(Math.round(t._radius), 1), 1 != (o = (Math.max(Math.round(t._radiusY), 1) || n) / n) && (i.save(), i.scale(1, o)), i.beginPath(), i.arc(e.x, e.y / o, n, 0, 2 * Math.PI, !1), 1 != o && i.restore(), this._fillStroke(i, t));
        },
        _fillStroke: function(t, e) {
            var i = e.options;
            i.fill && (t.globalAlpha = i.fillOpacity, t.fillStyle = i.fillColor || i.color, t.fill(i.fillRule || "evenodd")), i.stroke && 0 !== i.weight && (t.setLineDash && t.setLineDash(e.options && e.options._dashArray || []), t.globalAlpha = i.opacity, t.lineWidth = i.weight, t.strokeStyle = i.color, t.lineCap = i.lineCap, t.lineJoin = i.lineJoin, t.stroke());
        },
        _onClick: function(t) {
            for(var e, i, n = this._map.mouseEventToLayerPoint(t), o = this._drawFirst; o; o = o.next)(e = o.layer).options.interactive && e._containsPoint(n) && (("click" === t.type || "preclick" === t.type) && this._map._draggableMoved(e) || (i = e));
            this._fireEvent(!!i && [
                i
            ], t);
        },
        _onMouseMove: function(t) {
            var e;
            !this._map || this._map.dragging.moving() || this._map._animatingZoom || (e = this._map.mouseEventToLayerPoint(t), this._handleMouseHover(t, e));
        },
        _handleMouseOut: function(t) {
            var e = this._hoveredLayer;
            e && (z(this._container, "leaflet-interactive"), this._fireEvent([
                e
            ], t, "mouseout"), this._hoveredLayer = null, this._mouseHoverThrottled = !1);
        },
        _handleMouseHover: function(t, e) {
            if (!this._mouseHoverThrottled) {
                for(var i, n, o = this._drawFirst; o; o = o.next)(i = o.layer).options.interactive && i._containsPoint(e) && (n = i);
                n !== this._hoveredLayer && (this._handleMouseOut(t), n && (M(this._container, "leaflet-interactive"), this._fireEvent([
                    n
                ], t, "mouseover"), this._hoveredLayer = n)), this._fireEvent(!!this._hoveredLayer && [
                    this._hoveredLayer
                ], t), this._mouseHoverThrottled = !0, setTimeout(a(function() {
                    this._mouseHoverThrottled = !1;
                }, this), 32);
            }
        },
        _fireEvent: function(t, e, i) {
            this._map._fireDOMEvent(e, i || e.type, t);
        },
        _bringToFront: function(t) {
            var e, i, n = t._order;
            n && (e = n.next, i = n.prev, e && ((e.prev = i) ? i.next = e : e && (this._drawFirst = e), n.prev = this._drawLast, (this._drawLast.next = n).next = null, this._drawLast = n, this._requestRedraw(t)));
        },
        _bringToBack: function(t) {
            var e, i, n = t._order;
            n && (e = n.next, (i = n.prev) && ((i.next = e) ? e.prev = i : i && (this._drawLast = i), n.prev = null, n.next = this._drawFirst, this._drawFirst.prev = n, this._drawFirst = n, this._requestRedraw(t)));
        }
    });
    function Ui(t) {
        return b.canvas ? new Fi(t) : null;
    }
    var Vi = function() {
        try {
            return document.namespaces.add("lvml", "urn:schemas-microsoft-com:vml"), function(t) {
                return document.createElement("<lvml:" + t + ' class="lvml">');
            };
        } catch (t) {}
        return function(t) {
            return document.createElement("<" + t + ' xmlns="urn:schemas-microsoft.com:vml" class="lvml">');
        };
    }(), zt = {
        _initContainer: function() {
            this._container = P("div", "leaflet-vml-container");
        },
        _update: function() {
            this._map._animatingZoom || (Wi.prototype._update.call(this), this.fire("update"));
        },
        _initPath: function(t) {
            var e = t._container = Vi("shape");
            M(e, "leaflet-vml-shape " + (this.options.className || "")), e.coordsize = "1 1", t._path = Vi("path"), e.appendChild(t._path), this._updateStyle(t), this._layers[h(t)] = t;
        },
        _addPath: function(t) {
            var e = t._container;
            this._container.appendChild(e), t.options.interactive && t.addInteractiveTarget(e);
        },
        _removePath: function(t) {
            var e = t._container;
            T(e), t.removeInteractiveTarget(e), delete this._layers[h(t)];
        },
        _updateStyle: function(t) {
            var e = t._stroke, i = t._fill, n = t.options, o = t._container;
            o.stroked = !!n.stroke, o.filled = !!n.fill, n.stroke ? (e = e || (t._stroke = Vi("stroke")), o.appendChild(e), e.weight = n.weight + "px", e.color = n.color, e.opacity = n.opacity, n.dashArray ? e.dashStyle = d(n.dashArray) ? n.dashArray.join(" ") : n.dashArray.replace(/( *, *)/g, " ") : e.dashStyle = "", e.endcap = n.lineCap.replace("butt", "flat"), e.joinstyle = n.lineJoin) : e && (o.removeChild(e), t._stroke = null), n.fill ? (i = i || (t._fill = Vi("fill")), o.appendChild(i), i.color = n.fillColor || n.color, i.opacity = n.fillOpacity) : i && (o.removeChild(i), t._fill = null);
        },
        _updateCircle: function(t) {
            var e = t._point.round(), i = Math.round(t._radius), n = Math.round(t._radiusY || i);
            this._setPath(t, t._empty() ? "M0 0" : "AL " + e.x + "," + e.y + " " + i + "," + n + " 0,23592600");
        },
        _setPath: function(t, e) {
            t._path.v = e;
        },
        _bringToFront: function(t) {
            fe(t._container);
        },
        _bringToBack: function(t) {
            ge(t._container);
        }
    }, qi = b.vml ? Vi : ct, Gi = Wi.extend({
        _initContainer: function() {
            this._container = qi("svg"), this._container.setAttribute("pointer-events", "none"), this._rootGroup = qi("g"), this._container.appendChild(this._rootGroup);
        },
        _destroyContainer: function() {
            T(this._container), k(this._container), delete this._container, delete this._rootGroup, delete this._svgSize;
        },
        _update: function() {
            var t, e, i;
            this._map._animatingZoom && this._bounds || (Wi.prototype._update.call(this), e = (t = this._bounds).getSize(), i = this._container, this._svgSize && this._svgSize.equals(e) || (this._svgSize = e, i.setAttribute("width", e.x), i.setAttribute("height", e.y)), Z(i, t.min), i.setAttribute("viewBox", [
                t.min.x,
                t.min.y,
                e.x,
                e.y
            ].join(" ")), this.fire("update"));
        },
        _initPath: function(t) {
            var e = t._path = qi("path");
            t.options.className && M(e, t.options.className), t.options.interactive && M(e, "leaflet-interactive"), this._updateStyle(t), this._layers[h(t)] = t;
        },
        _addPath: function(t) {
            this._rootGroup || this._initContainer(), this._rootGroup.appendChild(t._path), t.addInteractiveTarget(t._path);
        },
        _removePath: function(t) {
            T(t._path), t.removeInteractiveTarget(t._path), delete this._layers[h(t)];
        },
        _updatePath: function(t) {
            t._project(), t._update();
        },
        _updateStyle: function(t) {
            var e = t._path, t = t.options;
            e && (t.stroke ? (e.setAttribute("stroke", t.color), e.setAttribute("stroke-opacity", t.opacity), e.setAttribute("stroke-width", t.weight), e.setAttribute("stroke-linecap", t.lineCap), e.setAttribute("stroke-linejoin", t.lineJoin), t.dashArray ? e.setAttribute("stroke-dasharray", t.dashArray) : e.removeAttribute("stroke-dasharray"), t.dashOffset ? e.setAttribute("stroke-dashoffset", t.dashOffset) : e.removeAttribute("stroke-dashoffset")) : e.setAttribute("stroke", "none"), t.fill ? (e.setAttribute("fill", t.fillColor || t.color), e.setAttribute("fill-opacity", t.fillOpacity), e.setAttribute("fill-rule", t.fillRule || "evenodd")) : e.setAttribute("fill", "none"));
        },
        _updatePoly: function(t, e) {
            this._setPath(t, dt(t._parts, e));
        },
        _updateCircle: function(t) {
            var e = t._point, i = Math.max(Math.round(t._radius), 1), n = "a" + i + "," + (Math.max(Math.round(t._radiusY), 1) || i) + " 0 1,0 ", e = t._empty() ? "M0 0" : "M" + (e.x - i) + "," + e.y + n + 2 * i + ",0 " + n + 2 * -i + ",0 ";
            this._setPath(t, e);
        },
        _setPath: function(t, e) {
            t._path.setAttribute("d", e);
        },
        _bringToFront: function(t) {
            fe(t._path);
        },
        _bringToBack: function(t) {
            ge(t._path);
        }
    });
    function Ki(t) {
        return b.svg || b.vml ? new Gi(t) : null;
    }
    b.vml && Gi.include(zt), A.include({
        getRenderer: function(t) {
            t = (t = t.options.renderer || this._getPaneRenderer(t.options.pane) || this.options.renderer || this._renderer) || (this._renderer = this._createRenderer());
            return this.hasLayer(t) || this.addLayer(t), t;
        },
        _getPaneRenderer: function(t) {
            var e;
            return "overlayPane" !== t && void 0 !== t && (void 0 === (e = this._paneRenderers[t]) && (e = this._createRenderer({
                pane: t
            }), this._paneRenderers[t] = e), e);
        },
        _createRenderer: function(t) {
            return this.options.preferCanvas && Ui(t) || Ki(t);
        }
    });
    var Yi = xi.extend({
        initialize: function(t, e) {
            xi.prototype.initialize.call(this, this._boundsToLatLngs(t), e);
        },
        setBounds: function(t) {
            return this.setLatLngs(this._boundsToLatLngs(t));
        },
        _boundsToLatLngs: function(t) {
            return [
                (t = g(t)).getSouthWest(),
                t.getNorthWest(),
                t.getNorthEast(),
                t.getSouthEast()
            ];
        }
    });
    Gi.create = qi, Gi.pointsToPath = dt, wi.geometryToLayer = bi, wi.coordsToLatLng = Li, wi.coordsToLatLngs = Ti, wi.latLngToCoords = Mi, wi.latLngsToCoords = zi, wi.getFeature = Ci, wi.asFeature = Zi, A.mergeOptions({
        boxZoom: !0
    });
    var _t = n.extend({
        initialize: function(t) {
            this._map = t, this._container = t._container, this._pane = t._panes.overlayPane, this._resetStateTimeout = 0, t.on("unload", this._destroy, this);
        },
        addHooks: function() {
            S(this._container, "mousedown", this._onMouseDown, this);
        },
        removeHooks: function() {
            k(this._container, "mousedown", this._onMouseDown, this);
        },
        moved: function() {
            return this._moved;
        },
        _destroy: function() {
            T(this._pane), delete this._pane;
        },
        _resetState: function() {
            this._resetStateTimeout = 0, this._moved = !1;
        },
        _clearDeferredResetState: function() {
            0 !== this._resetStateTimeout && (clearTimeout(this._resetStateTimeout), this._resetStateTimeout = 0);
        },
        _onMouseDown: function(t) {
            if (!t.shiftKey || 1 !== t.which && 1 !== t.button) return !1;
            this._clearDeferredResetState(), this._resetState(), re(), Le(), this._startPoint = this._map.mouseEventToContainerPoint(t), S(document, {
                contextmenu: Re,
                mousemove: this._onMouseMove,
                mouseup: this._onMouseUp,
                keydown: this._onKeyDown
            }, this);
        },
        _onMouseMove: function(t) {
            this._moved || (this._moved = !0, this._box = P("div", "leaflet-zoom-box", this._container), M(this._container, "leaflet-crosshair"), this._map.fire("boxzoomstart")), this._point = this._map.mouseEventToContainerPoint(t);
            var t = new f(this._point, this._startPoint), e = t.getSize();
            Z(this._box, t.min), this._box.style.width = e.x + "px", this._box.style.height = e.y + "px";
        },
        _finish: function() {
            this._moved && (T(this._box), z(this._container, "leaflet-crosshair")), ae(), Te(), k(document, {
                contextmenu: Re,
                mousemove: this._onMouseMove,
                mouseup: this._onMouseUp,
                keydown: this._onKeyDown
            }, this);
        },
        _onMouseUp: function(t) {
            1 !== t.which && 1 !== t.button || (this._finish(), this._moved && (this._clearDeferredResetState(), this._resetStateTimeout = setTimeout(a(this._resetState, this), 0), t = new s(this._map.containerPointToLatLng(this._startPoint), this._map.containerPointToLatLng(this._point)), this._map.fitBounds(t).fire("boxzoomend", {
                boxZoomBounds: t
            })));
        },
        _onKeyDown: function(t) {
            27 === t.keyCode && (this._finish(), this._clearDeferredResetState(), this._resetState());
        }
    }), Ct = (A.addInitHook("addHandler", "boxZoom", _t), A.mergeOptions({
        doubleClickZoom: !0
    }), n.extend({
        addHooks: function() {
            this._map.on("dblclick", this._onDoubleClick, this);
        },
        removeHooks: function() {
            this._map.off("dblclick", this._onDoubleClick, this);
        },
        _onDoubleClick: function(t) {
            var e = this._map, i = e.getZoom(), n = e.options.zoomDelta, i = t.originalEvent.shiftKey ? i - n : i + n;
            "center" === e.options.doubleClickZoom ? e.setZoom(i) : e.setZoomAround(t.containerPoint, i);
        }
    })), Zt = (A.addInitHook("addHandler", "doubleClickZoom", Ct), A.mergeOptions({
        dragging: !0,
        inertia: !0,
        inertiaDeceleration: 3400,
        inertiaMaxSpeed: 1 / 0,
        easeLinearity: .2,
        worldCopyJump: !1,
        maxBoundsViscosity: 0
    }), n.extend({
        addHooks: function() {
            var t;
            this._draggable || (t = this._map, this._draggable = new Xe(t._mapPane, t._container), this._draggable.on({
                dragstart: this._onDragStart,
                drag: this._onDrag,
                dragend: this._onDragEnd
            }, this), this._draggable.on("predrag", this._onPreDragLimit, this), t.options.worldCopyJump && (this._draggable.on("predrag", this._onPreDragWrap, this), t.on("zoomend", this._onZoomEnd, this), t.whenReady(this._onZoomEnd, this))), M(this._map._container, "leaflet-grab leaflet-touch-drag"), this._draggable.enable(), this._positions = [], this._times = [];
        },
        removeHooks: function() {
            z(this._map._container, "leaflet-grab"), z(this._map._container, "leaflet-touch-drag"), this._draggable.disable();
        },
        moved: function() {
            return this._draggable && this._draggable._moved;
        },
        moving: function() {
            return this._draggable && this._draggable._moving;
        },
        _onDragStart: function() {
            var t, e = this._map;
            e._stop(), this._map.options.maxBounds && this._map.options.maxBoundsViscosity ? (t = g(this._map.options.maxBounds), this._offsetLimit = _(this._map.latLngToContainerPoint(t.getNorthWest()).multiplyBy(-1), this._map.latLngToContainerPoint(t.getSouthEast()).multiplyBy(-1).add(this._map.getSize())), this._viscosity = Math.min(1, Math.max(0, this._map.options.maxBoundsViscosity))) : this._offsetLimit = null, e.fire("movestart").fire("dragstart"), e.options.inertia && (this._positions = [], this._times = []);
        },
        _onDrag: function(t) {
            var e, i;
            this._map.options.inertia && (e = this._lastTime = +new Date, i = this._lastPos = this._draggable._absPos || this._draggable._newPos, this._positions.push(i), this._times.push(e), this._prunePositions(e)), this._map.fire("move", t).fire("drag", t);
        },
        _prunePositions: function(t) {
            for(; 1 < this._positions.length && 50 < t - this._times[0];)this._positions.shift(), this._times.shift();
        },
        _onZoomEnd: function() {
            var t = this._map.getSize().divideBy(2), e = this._map.latLngToLayerPoint([
                0,
                0
            ]);
            this._initialWorldOffset = e.subtract(t).x, this._worldWidth = this._map.getPixelWorldBounds().getSize().x;
        },
        _viscousLimit: function(t, e) {
            return t - (t - e) * this._viscosity;
        },
        _onPreDragLimit: function() {
            var t, e;
            this._viscosity && this._offsetLimit && (t = this._draggable._newPos.subtract(this._draggable._startPos), e = this._offsetLimit, t.x < e.min.x && (t.x = this._viscousLimit(t.x, e.min.x)), t.y < e.min.y && (t.y = this._viscousLimit(t.y, e.min.y)), t.x > e.max.x && (t.x = this._viscousLimit(t.x, e.max.x)), t.y > e.max.y && (t.y = this._viscousLimit(t.y, e.max.y)), this._draggable._newPos = this._draggable._startPos.add(t));
        },
        _onPreDragWrap: function() {
            var t = this._worldWidth, e = Math.round(t / 2), i = this._initialWorldOffset, n = this._draggable._newPos.x, o = (n - e + i) % t + e - i, n = (n + e + i) % t - e - i, t = Math.abs(o + i) < Math.abs(n + i) ? o : n;
            this._draggable._absPos = this._draggable._newPos.clone(), this._draggable._newPos.x = t;
        },
        _onDragEnd: function(t) {
            var e, i, n, o, s = this._map, r = s.options, a = !r.inertia || t.noInertia || this._times.length < 2;
            s.fire("dragend", t), !a && (this._prunePositions(+new Date), t = this._lastPos.subtract(this._positions[0]), a = (this._lastTime - this._times[0]) / 1e3, e = r.easeLinearity, a = (t = t.multiplyBy(e / a)).distanceTo([
                0,
                0
            ]), i = Math.min(r.inertiaMaxSpeed, a), t = t.multiplyBy(i / a), n = i / (r.inertiaDeceleration * e), (o = t.multiplyBy(-n / 2).round()).x || o.y) ? (o = s._limitOffset(o, s.options.maxBounds), x(function() {
                s.panBy(o, {
                    duration: n,
                    easeLinearity: e,
                    noMoveStart: !0,
                    animate: !0
                });
            })) : s.fire("moveend");
        }
    })), St = (A.addInitHook("addHandler", "dragging", Zt), A.mergeOptions({
        keyboard: !0,
        keyboardPanDelta: 80
    }), n.extend({
        keyCodes: {
            left: [
                37
            ],
            right: [
                39
            ],
            down: [
                40
            ],
            up: [
                38
            ],
            zoomIn: [
                187,
                107,
                61,
                171
            ],
            zoomOut: [
                189,
                109,
                54,
                173
            ]
        },
        initialize: function(t) {
            this._map = t, this._setPanDelta(t.options.keyboardPanDelta), this._setZoomDelta(t.options.zoomDelta);
        },
        addHooks: function() {
            var t = this._map._container;
            t.tabIndex <= 0 && (t.tabIndex = "0"), S(t, {
                focus: this._onFocus,
                blur: this._onBlur,
                mousedown: this._onMouseDown
            }, this), this._map.on({
                focus: this._addHooks,
                blur: this._removeHooks
            }, this);
        },
        removeHooks: function() {
            this._removeHooks(), k(this._map._container, {
                focus: this._onFocus,
                blur: this._onBlur,
                mousedown: this._onMouseDown
            }, this), this._map.off({
                focus: this._addHooks,
                blur: this._removeHooks
            }, this);
        },
        _onMouseDown: function() {
            var t, e, i;
            this._focused || (i = document.body, t = document.documentElement, e = i.scrollTop || t.scrollTop, i = i.scrollLeft || t.scrollLeft, this._map._container.focus(), window.scrollTo(i, e));
        },
        _onFocus: function() {
            this._focused = !0, this._map.fire("focus");
        },
        _onBlur: function() {
            this._focused = !1, this._map.fire("blur");
        },
        _setPanDelta: function(t) {
            for(var e = this._panKeys = {}, i = this.keyCodes, n = 0, o = i.left.length; n < o; n++)e[i.left[n]] = [
                -1 * t,
                0
            ];
            for(n = 0, o = i.right.length; n < o; n++)e[i.right[n]] = [
                t,
                0
            ];
            for(n = 0, o = i.down.length; n < o; n++)e[i.down[n]] = [
                0,
                t
            ];
            for(n = 0, o = i.up.length; n < o; n++)e[i.up[n]] = [
                0,
                -1 * t
            ];
        },
        _setZoomDelta: function(t) {
            for(var e = this._zoomKeys = {}, i = this.keyCodes, n = 0, o = i.zoomIn.length; n < o; n++)e[i.zoomIn[n]] = t;
            for(n = 0, o = i.zoomOut.length; n < o; n++)e[i.zoomOut[n]] = -t;
        },
        _addHooks: function() {
            S(document, "keydown", this._onKeyDown, this);
        },
        _removeHooks: function() {
            k(document, "keydown", this._onKeyDown, this);
        },
        _onKeyDown: function(t) {
            if (!(t.altKey || t.ctrlKey || t.metaKey)) {
                var e, i, n = t.keyCode, o = this._map;
                if (n in this._panKeys) o._panAnim && o._panAnim._inProgress || (i = this._panKeys[n], t.shiftKey && (i = m(i).multiplyBy(3)), o.options.maxBounds && (i = o._limitOffset(m(i), o.options.maxBounds)), o.options.worldCopyJump ? (e = o.wrapLatLng(o.unproject(o.project(o.getCenter()).add(i))), o.panTo(e)) : o.panBy(i));
                else if (n in this._zoomKeys) o.setZoom(o.getZoom() + (t.shiftKey ? 3 : 1) * this._zoomKeys[n]);
                else {
                    if (27 !== n || !o._popup || !o._popup.options.closeOnEscapeKey) return;
                    o.closePopup();
                }
                Re(t);
            }
        }
    })), Et = (A.addInitHook("addHandler", "keyboard", St), A.mergeOptions({
        scrollWheelZoom: !0,
        wheelDebounceTime: 40,
        wheelPxPerZoomLevel: 60
    }), n.extend({
        addHooks: function() {
            S(this._map._container, "wheel", this._onWheelScroll, this), this._delta = 0;
        },
        removeHooks: function() {
            k(this._map._container, "wheel", this._onWheelScroll, this);
        },
        _onWheelScroll: function(t) {
            var e = He(t), i = this._map.options.wheelDebounceTime, e = (this._delta += e, this._lastMousePos = this._map.mouseEventToContainerPoint(t), this._startTime || (this._startTime = +new Date), Math.max(i - (+new Date - this._startTime), 0));
            clearTimeout(this._timer), this._timer = setTimeout(a(this._performZoom, this), e), Re(t);
        },
        _performZoom: function() {
            var t = this._map, e = t.getZoom(), i = this._map.options.zoomSnap || 0, n = (t._stop(), this._delta / (4 * this._map.options.wheelPxPerZoomLevel)), n = 4 * Math.log(2 / (1 + Math.exp(-Math.abs(n)))) / Math.LN2, i = i ? Math.ceil(n / i) * i : n, n = t._limitZoom(e + (0 < this._delta ? i : -i)) - e;
            this._delta = 0, this._startTime = null, n && ("center" === t.options.scrollWheelZoom ? t.setZoom(e + n) : t.setZoomAround(this._lastMousePos, e + n));
        }
    })), kt = (A.addInitHook("addHandler", "scrollWheelZoom", Et), A.mergeOptions({
        tapHold: b.touchNative && b.safari && b.mobile,
        tapTolerance: 15
    }), n.extend({
        addHooks: function() {
            S(this._map._container, "touchstart", this._onDown, this);
        },
        removeHooks: function() {
            k(this._map._container, "touchstart", this._onDown, this);
        },
        _onDown: function(t) {
            var e;
            clearTimeout(this._holdTimeout), 1 === t.touches.length && (e = t.touches[0], this._startPos = this._newPos = new p(e.clientX, e.clientY), this._holdTimeout = setTimeout(a(function() {
                this._cancel(), this._isTapValid() && (S(document, "touchend", O), S(document, "touchend touchcancel", this._cancelClickPrevent), this._simulateEvent("contextmenu", e));
            }, this), 600), S(document, "touchend touchcancel contextmenu", this._cancel, this), S(document, "touchmove", this._onMove, this));
        },
        _cancelClickPrevent: function t() {
            k(document, "touchend", O), k(document, "touchend touchcancel", t);
        },
        _cancel: function() {
            clearTimeout(this._holdTimeout), k(document, "touchend touchcancel contextmenu", this._cancel, this), k(document, "touchmove", this._onMove, this);
        },
        _onMove: function(t) {
            t = t.touches[0];
            this._newPos = new p(t.clientX, t.clientY);
        },
        _isTapValid: function() {
            return this._newPos.distanceTo(this._startPos) <= this._map.options.tapTolerance;
        },
        _simulateEvent: function(t, e) {
            t = new MouseEvent(t, {
                bubbles: !0,
                cancelable: !0,
                view: window,
                screenX: e.screenX,
                screenY: e.screenY,
                clientX: e.clientX,
                clientY: e.clientY
            });
            t._simulated = !0, e.target.dispatchEvent(t);
        }
    })), Ot = (A.addInitHook("addHandler", "tapHold", kt), A.mergeOptions({
        touchZoom: b.touch,
        bounceAtZoomLimits: !0
    }), n.extend({
        addHooks: function() {
            M(this._map._container, "leaflet-touch-zoom"), S(this._map._container, "touchstart", this._onTouchStart, this);
        },
        removeHooks: function() {
            z(this._map._container, "leaflet-touch-zoom"), k(this._map._container, "touchstart", this._onTouchStart, this);
        },
        _onTouchStart: function(t) {
            var e, i, n = this._map;
            !t.touches || 2 !== t.touches.length || n._animatingZoom || this._zooming || (e = n.mouseEventToContainerPoint(t.touches[0]), i = n.mouseEventToContainerPoint(t.touches[1]), this._centerPoint = n.getSize()._divideBy(2), this._startLatLng = n.containerPointToLatLng(this._centerPoint), "center" !== n.options.touchZoom && (this._pinchStartLatLng = n.containerPointToLatLng(e.add(i)._divideBy(2))), this._startDist = e.distanceTo(i), this._startZoom = n.getZoom(), this._moved = !1, this._zooming = !0, n._stop(), S(document, "touchmove", this._onTouchMove, this), S(document, "touchend touchcancel", this._onTouchEnd, this), O(t));
        },
        _onTouchMove: function(t) {
            if (t.touches && 2 === t.touches.length && this._zooming) {
                var e = this._map, i = e.mouseEventToContainerPoint(t.touches[0]), n = e.mouseEventToContainerPoint(t.touches[1]), o = i.distanceTo(n) / this._startDist;
                if (this._zoom = e.getScaleZoom(o, this._startZoom), !e.options.bounceAtZoomLimits && (this._zoom < e.getMinZoom() && o < 1 || this._zoom > e.getMaxZoom() && 1 < o) && (this._zoom = e._limitZoom(this._zoom)), "center" === e.options.touchZoom) {
                    if (this._center = this._startLatLng, 1 == o) return;
                } else {
                    i = i._add(n)._divideBy(2)._subtract(this._centerPoint);
                    if (1 == o && 0 === i.x && 0 === i.y) return;
                    this._center = e.unproject(e.project(this._pinchStartLatLng, this._zoom).subtract(i), this._zoom);
                }
                this._moved || (e._moveStart(!0, !1), this._moved = !0), r(this._animRequest);
                n = a(e._move, e, this._center, this._zoom, {
                    pinch: !0,
                    round: !1
                }, void 0);
                this._animRequest = x(n, this, !0), O(t);
            }
        },
        _onTouchEnd: function() {
            this._moved && this._zooming ? (this._zooming = !1, r(this._animRequest), k(document, "touchmove", this._onTouchMove, this), k(document, "touchend touchcancel", this._onTouchEnd, this), this._map.options.zoomAnimation ? this._map._animateZoom(this._center, this._map._limitZoom(this._zoom), !0, this._map.options.zoomSnap) : this._map._resetView(this._center, this._map._limitZoom(this._zoom))) : this._zooming = !1;
        }
    })), Xi = (A.addInitHook("addHandler", "touchZoom", Ot), A.BoxZoom = _t, A.DoubleClickZoom = Ct, A.Drag = Zt, A.Keyboard = St, A.ScrollWheelZoom = Et, A.TapHold = kt, A.TouchZoom = Ot, t.Bounds = f, t.Browser = b, t.CRS = ot, t.Canvas = Fi, t.Circle = vi, t.CircleMarker = gi, t.Class = et, t.Control = B, t.DivIcon = Ri, t.DivOverlay = Ai, t.DomEvent = mt, t.DomUtil = pt, t.Draggable = Xe, t.Evented = it, t.FeatureGroup = ci, t.GeoJSON = wi, t.GridLayer = Ni, t.Handler = n, t.Icon = di, t.ImageOverlay = Ei, t.LatLng = v, t.LatLngBounds = s, t.Layer = o, t.LayerGroup = ui, t.LineUtil = vt, t.Map = A, t.Marker = mi, t.Mixin = ft, t.Path = fi, t.Point = p, t.PolyUtil = gt, t.Polygon = xi, t.Polyline = yi, t.Popup = Bi, t.PosAnimation = Fe, t.Projection = wt, t.Rectangle = Yi, t.Renderer = Wi, t.SVG = Gi, t.SVGOverlay = Oi, t.TileLayer = Di, t.Tooltip = Ii, t.Transformation = at, t.Util = tt, t.VideoOverlay = ki, t.bind = a, t.bounds = _, t.canvas = Ui, t.circle = function(t, e, i) {
        return new vi(t, e, i);
    }, t.circleMarker = function(t, e) {
        return new gi(t, e);
    }, t.control = Ue, t.divIcon = function(t) {
        return new Ri(t);
    }, t.extend = l, t.featureGroup = function(t, e) {
        return new ci(t, e);
    }, t.geoJSON = Si, t.geoJson = Mt, t.gridLayer = function(t) {
        return new Ni(t);
    }, t.icon = function(t) {
        return new di(t);
    }, t.imageOverlay = function(t, e, i) {
        return new Ei(t, e, i);
    }, t.latLng = w, t.latLngBounds = g, t.layerGroup = function(t, e) {
        return new ui(t, e);
    }, t.map = function(t, e) {
        return new A(t, e);
    }, t.marker = function(t, e) {
        return new mi(t, e);
    }, t.point = m, t.polygon = function(t, e) {
        return new xi(t, e);
    }, t.polyline = function(t, e) {
        return new yi(t, e);
    }, t.popup = function(t, e) {
        return new Bi(t, e);
    }, t.rectangle = function(t, e) {
        return new Yi(t, e);
    }, t.setOptions = c, t.stamp = h, t.svg = Ki, t.svgOverlay = function(t, e, i) {
        return new Oi(t, e, i);
    }, t.tileLayer = ji, t.tooltip = function(t, e) {
        return new Ii(t, e);
    }, t.transformation = ht, t.version = "1.9.4", t.videoOverlay = function(t, e, i) {
        return new ki(t, e, i);
    }, window.L);
    t.noConflict = function() {
        return window.L = Xi, this;
    }, window.L = t;
});




function $d554099ec41e8cc9$export$19d26e5f9c5b1089(leafletBounds) {
    leafletBounds.prototype = {
        // @method extend(point: Point): this
        // Extends the bounds to contain the given point.
        extend: function(point) {
            point = (0, $b802e4aa6d666b45$export$b63cca88ddc558a9)(point);
            // @property min: Point
            // The top left corner of the rectangle.
            // @property max: Point
            // The bottom right corner of the rectangle.
            if (!this.min && !this.max) {
                this.min = point.clone();
                this.max = point.clone();
            } else {
                this.min.x = Math.min(point.x, this.min.x);
                this.max.x = Math.max(point.x, this.max.x);
                this.min.y = Math.min(point.y, this.min.y);
                this.max.y = Math.max(point.y, this.max.y);
            }
            return this;
        },
        // @method getCenter(round?: Boolean): Point
        // Returns the center point of the bounds.
        getCenter: function(round) {
            return new (0, $b802e4aa6d666b45$export$baf26146a414f24a)((this.min.x + this.max.x) / 2, (this.min.y + this.max.y) / 2, round);
        },
        // @method getBottomLeft(): Point
        // Returns the bottom-left point of the bounds.
        getBottomLeft: function() {
            return new (0, $b802e4aa6d666b45$export$baf26146a414f24a)(this.min.x, this.max.y);
        },
        // @method getTopRight(): Point
        // Returns the top-right point of the bounds.
        getTopRight: function() {
            return new (0, $b802e4aa6d666b45$export$baf26146a414f24a)(this.max.x, this.min.y);
        },
        // @method getTopLeft(): Point
        // Returns the top-left point of the bounds (i.e. [`this.min`](#bounds-min)).
        getTopLeft: function() {
            return this.min; // left, top
        },
        // @method getBottomRight(): Point
        // Returns the bottom-right point of the bounds (i.e. [`this.max`](#bounds-max)).
        getBottomRight: function() {
            return this.max; // right, bottom
        },
        // @method getSize(): Point
        // Returns the size of the given bounds
        getSize: function() {
            return this.max.subtract(this.min);
        },
        // @method contains(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle contains the given one.
        // @alternative
        // @method contains(point: Point): Boolean
        // Returns `true` if the rectangle contains the given point.
        contains: function(obj) {
            var min, max;
            if (typeof obj[0] === "number" || obj instanceof (0, $b802e4aa6d666b45$export$baf26146a414f24a)) obj = (0, $b802e4aa6d666b45$export$b63cca88ddc558a9)(obj);
            else obj = (0, $2ffe56518af276c5$export$c8e2f7c8aba65b28)(obj);
            if (obj instanceof (0, $2ffe56518af276c5$export$c4e9d269599ab4b4)) {
                min = obj.min;
                max = obj.max;
            } else min = max = obj;
            return min.x >= this.min.x && max.x <= this.max.x && min.y >= this.min.y && max.y <= this.max.y;
        },
        // @method intersects(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle intersects the given bounds. Two bounds
        // intersect if they have at least one point in common.
        intersects: function(bounds) {
            bounds = (0, $2ffe56518af276c5$export$c8e2f7c8aba65b28)(bounds);
            // console.log('overriddenxxxxx leaflet - this.min : ' + this.min + ' - this.max : ' + this.max +
            //   ' - bounds : ' + JSON.stringify(bounds));
            var min = this.min, max = this.max, min2 = bounds.min, max2 = bounds.max, xIntersects, yIntersects;
            if (min2 && max2) xIntersects = max2.x >= min.x && min2.x <= max.x, yIntersects = max2.y >= min.y && min2.y <= max.y;
            else xIntersects = false, yIntersects = false;
            return xIntersects && yIntersects;
        },
        // @method overlaps(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle overlaps the given bounds. Two bounds
        // overlap if their intersection is an area.
        overlaps: function(bounds) {
            bounds = (0, $2ffe56518af276c5$export$c8e2f7c8aba65b28)(bounds);
            var min = this.min, max = this.max, min2 = bounds.min, max2 = bounds.max, xOverlaps = max2.x > min.x && min2.x < max.x, yOverlaps = max2.y > min.y && min2.y < max.y;
            return xOverlaps && yOverlaps;
        },
        isValid: function() {
            return !!(this.min && this.max);
        }
    };
}



function $cb3e0081c099494f$export$b08464e47b7a3a8(customConfig = {}) {
    // console.time('initMap');
    if (!(0, $gYLTL.map).instance) {
        (0, $gYLTL.map).instance = $7d9a54c6488daf4f$export$d49c9aa30b771d59("map", {
            center: customConfig.mapCenter || (0, $j5Ozl.config).mapCenter,
            zoom: customConfig.mapZoom || (0, $j5Ozl.config).mapZoom,
            minZoom: (0, $j5Ozl.config).minZoom,
            maxBoundsViscosity: 1,
            zoomControl: false,
            zoomSnap: 0,
            zoomAnimation: false
        });
        $257bd5e7d2d57b63$export$b5cde1de278b4330.zoom({
            position: "topleft"
        }).addTo((0, $gYLTL.map).instance);
        // new Locate({
        //   position: 'bottomleft',
        //   keepCurrentZoomLevel: true,
        //   setView: false,
        //   strings: {
        //     title: "Voir ma position",
        //     metersUnit: "mètres",
        //     feetUnit: "pieds",
        //     popup: "Vous êtes situé(e) dans un périmètre de {distance} {unit} autour de ce point",
        //     outsideMapBoundsMsg: "Vous semblez être localisé(e) hors du périmètre de la carte"
        //   },
        //   locateOptions: {
        //     enableHighAccuracy: true
        //   }
        // }).addTo(map.instance);
        (0, $d554099ec41e8cc9$export$19d26e5f9c5b1089)($2ffe56518af276c5$export$c4e9d269599ab4b4);
        $bc2c95f9ce01d02f$export$7ed1367e7fa1ad68().addTo((0, $gYLTL.map).instance);
        document.querySelector("#map .leaflet-overlay-pane").insertAdjacentHTML("afterbegin", '<div id="particles_wrapper" class="leaflet-zoom-animated" style="width: ' + (0, $gYLTL.layout).width + "px; height: " + (0, $gYLTL.layout).height + 'px;"></div>');
        document.querySelector("#map .leaflet-tile-pane").insertAdjacentHTML("beforeend", '<div id="waves_wrapper" class="leaflet-zoom-animated" style="width: ' + (0, $gYLTL.layout).width + "px; height: " + (0, $gYLTL.layout).height + 'px;"></div>');
        let isSingleClick = true, updateParticles = (0, $5ewvA.debounce)((0, $b51085ee695c0fdd$export$392d57327b439f08), 500);
        (0, $gYLTL.map).instance.on("zoomstart", function() {
            $cb3e0081c099494f$var$stopParticles();
        });
        (0, $gYLTL.map).instance.on("zoomend", function(evt) {
            // console.debug('current map zoom: ' + map.instance.getZoom());
            (0, $b51085ee695c0fdd$export$68cdf4e2cb6fc30e)();
            setTimeout(function() {
                isSingleClick = true;
            }, 300);
            if ((0, $gYLTL.map).windLayer && (0, $gYLTL.layers).dataLayers.indexOf("wind_fc") !== -1 || (0, $gYLTL.map).wavesLayer && (0, $gYLTL.layers).dataLayers.indexOf("waves_fc") !== -1) updateParticles();
        });
        (0, $gYLTL.map).instance.on("movestart", function() {
            $cb3e0081c099494f$var$stopParticles();
        });
        (0, $gYLTL.map).instance.on("moveend", function(evt) {
            (0, $b51085ee695c0fdd$export$68cdf4e2cb6fc30e)();
            if ((0, $gYLTL.map).windLayer && (0, $gYLTL.layers).dataLayers.indexOf("wind_fc") !== -1 || (0, $gYLTL.map).wavesLayer && (0, $gYLTL.layers).dataLayers.indexOf("waves_fc") !== -1) updateParticles();
            $cb3e0081c099494f$var$updateParticlesPane();
        });
        (0, $gYLTL.map).instance.on("click", function(e) {
            setTimeout(function() {
                if (isSingleClick) {
                    if ((0, $gYLTL.layers).dataLayers.indexOf("wind_fc") !== -1 || (0, $gYLTL.layers).dataLayers.indexOf("waves_fc") !== -1 || (0, $gYLTL.layers).dataLayers.indexOf("rain_fc") !== -1) {
                        let popLocation = e.latlng;
                        (0, $gYLTL.map).popup = $c46100516ceeb540$export$63b4813c5280c707().setLatLng(popLocation);
                        (0, $j5Ozl.config).popup = (0, $gYLTL.map).popup;
                        $cb3e0081c099494f$export$3a23bfc5dbd63f67((0, $j5Ozl.config).popup, e);
                        (0, $gYLTL.map).instance.openPopup((0, $j5Ozl.config).popup);
                    }
                }
            }, 300);
        });
        (0, $gYLTL.map).instance.on("dblclick", function(e) {
            isSingleClick = false;
        });
        (0, $gYLTL.map).instance.on("popupclose", function(e) {
            (0, $gYLTL.map).popup = null;
        });
        (0, $gYLTL.map).instance.on("locationerror", function(e) {
            window.alert("Votre position n'a pas pu \xeatre relev\xe9e.");
        });
        (0, $gYLTL.layers).overlay = (0, $d78f01d7851d977e$export$2e2bcd8739ae039)((0, $gYLTL.map).instance.getPanes().overlayPane).select("svg").attr("id", "markers_layer").attr("pointer-events", "all");
        (0, $gYLTL.map).instance.setMaxBounds((0, $j5Ozl.config).mapBounds);
        (0, $gYLTL.map).viewBox = (0, $gYLTL.map).instance.getPixelBounds();
        (0, $gYLTL.map).refZoom = (0, $gYLTL.map).instance.getBoundsZoom((0, $j5Ozl.config).mapBounds);
        (0, $gYLTL.map).windBox = [
            (0, $gYLTL.map).instance.project((0, $j5Ozl.config).mapBounds[0], (0, $gYLTL.map).refZoom),
            (0, $gYLTL.map).instance.project((0, $j5Ozl.config).mapBounds[1], (0, $gYLTL.map).refZoom)
        ];
        (0, $gYLTL.map).windWidth = (0, $gYLTL.map).windBox[1].x - (0, $gYLTL.map).windBox[0].x;
        (0, $gYLTL.map).windHeight = (0, $gYLTL.map).windBox[1].y - (0, $gYLTL.map).windBox[0].y;
        (0, $gYLTL.map).wavesBox = [
            (0, $gYLTL.map).instance.project((0, $j5Ozl.config).mapBounds[0], (0, $gYLTL.map).refZoom),
            (0, $gYLTL.map).instance.project((0, $j5Ozl.config).mapBounds[1], (0, $gYLTL.map).refZoom)
        ];
        (0, $gYLTL.map).wavesWidth = (0, $gYLTL.map).wavesBox[1].x - (0, $gYLTL.map).wavesBox[0].x;
        (0, $gYLTL.map).wavesHeight = (0, $gYLTL.map).wavesBox[1].y - (0, $gYLTL.map).wavesBox[0].y;
    }
}
function $cb3e0081c099494f$var$updateParticlesPane() {
    let panTransform = document.querySelector("#map > .leaflet-map-pane").getAttribute("style");
    if (panTransform && panTransform.indexOf("translate3d") !== -1) {
        let [x, y, z] = panTransform.match(/-?[.\d]+px/g).map(function(v) {
            return parseInt(v.replace("px", ""));
        });
        document.querySelector("#particles_wrapper").setAttribute("style", "width: " + (0, $gYLTL.layout).width + "px; height: " + (0, $gYLTL.layout).height + "px; transform: translate3d(" + -x + "px, " + -y + "px, 0px);");
        if (document.querySelector("#waves_wrapper")) document.querySelector("#waves_wrapper").setAttribute("style", "width: " + (0, $gYLTL.layout).width + "px; height: " + (0, $gYLTL.layout).height + "px; transform: translate3d(" + -x + "px, " + -y + "px, 0px);");
    }
}
function $cb3e0081c099494f$var$stopParticles() {
    if ((0, $gYLTL.map).windLayer && (0, $gYLTL.layers).dataLayers.indexOf("wind_fc") !== -1) (0, $gYLTL.map).windLayer.stop();
    if ((0, $gYLTL.map).wavesLayer && (0, $gYLTL.layers).dataLayers.indexOf("waves_fc") !== -1) (0, $gYLTL.map).wavesLayer.stop();
}
function $cb3e0081c099494f$export$720449d359f5eb20(btn, ref) {
    if ((0, $gYLTL.map).activeMap !== ref) {
        let activeBtn = document.querySelector("#side_menu .map_layer.active");
        if (activeBtn) activeBtn.classList.remove("active");
        $cb3e0081c099494f$export$7936340adedaf8bc(ref);
        (0, $gYLTL.map).activeMap = ref;
        btn.classList.add("active");
    }
}
function $cb3e0081c099494f$export$7936340adedaf8bc(ref, skipRefresh) {
    console.debug("displayMapRef: " + ref);
    let mapContainer = document.querySelector("#map_container");
    if (ref === "wm") {
        $cb3e0081c099494f$export$382d1aca2389ca8b();
        $cb3e0081c099494f$export$f0c5438bd76c55d8(true);
    } else if (ref === "satellite") $cb3e0081c099494f$var$displayOrthoLayer();
    else if (ref === "elevation") $cb3e0081c099494f$var$displayMntLayer();
    mapContainer.classList.remove((0, $gYLTL.map).activeMap);
    mapContainer.classList.add(ref);
    if (typeof skipRefresh === "undefined" || !skipRefresh) (0, $fb487846a357c1c2$export$40548a160ab2d315)();
}
function $cb3e0081c099494f$export$f0c5438bd76c55d8(forceFill, waves = false) {
    const rasterTilesUrl = waves ? `https://api.maptiler.com/maps/dc27b623-f58d-4a84-a9eb-c8f5e970c2e7/{z}/{x}/{y}.png?key=${(0, $j5Ozl.config).mapKey}` : forceFill ? "https://tiles.windmorbihan.com/{z}/{x}/{y}.png" : `https://api.maptiler.com/maps/5ddfa15f-9859-4f36-95f7-25323cd9b3c3/{z}/{x}/{y}.png?key=${(0, $j5Ozl.config).mapKey}`;
    const mtLayer = $47ae5f26affe1e5e$export$be2e48cfdc7506da(rasterTilesUrl, {
        tileSize: 512,
        zoomOffset: -1,
        minZoom: 1,
        attribution: false,
        crossOrigin: true,
        minNativeZoom: 10
    }).addTo((0, $gYLTL.map).instance);
    (0, $gYLTL.layers).bgLayers.push(mtLayer);
    // console.timeEnd('displayCoastLine');
    return Promise.resolve(mtLayer);
}
function $cb3e0081c099494f$export$382d1aca2389ca8b() {
    for (const l of (0, $gYLTL.layers).bgLayers)(0, $gYLTL.map).instance.removeLayer(l);
    (0, $gYLTL.layers).bgLayers = [];
}
function $cb3e0081c099494f$export$c9d7b40556b56979() {
    const mapContainer = document.querySelector("#map_container");
    for (const l of (0, $gYLTL.layers).dataLayers){
        (0, $b51085ee695c0fdd$export$b9a19a7bc6beec63)(l, false);
        mapContainer.classList.remove(l);
    }
    (0, $gYLTL.layers).dataLayers = [];
}
function $cb3e0081c099494f$export$3a23bfc5dbd63f67(popup, evt) {
    console.debug("pt clicked : " + JSON.stringify(evt.latlng));
    if ((0, $gYLTL.layers).dataLayers.indexOf("wind_fc") !== -1 || (0, $gYLTL.layers).dataLayers.indexOf("waves_fc") !== -1) (0, $b51085ee695c0fdd$export$53d225340945d25c)(popup, evt.latlng.lat, evt.latlng.lng);
    else if ((0, $gYLTL.layers).dataLayers.indexOf("rain_fc") !== -1) (0, $b51085ee695c0fdd$export$e7dd361938fddba2)(popup, evt.latlng.lat, evt.latlng.lng);
    else popup.setContent(evt.latlng.lat + ", " + evt.latlng.lng);
}
function $cb3e0081c099494f$var$displayOrthoLayer() {
    let mtLayer = new $47ae5f26affe1e5e$export$be2e48cfdc7506da("https://data.geopf.fr/wmts?&REQUEST=GetTile&SERVICE=WMTS&VERSION=1.0.0&STYLE=normal&TILEMATRIXSET=PM&FORMAT=image/jpeg&LAYER=ORTHOIMAGERY.ORTHOPHOTOS&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}");
    mtLayer.addTo((0, $gYLTL.map).instance);
    (0, $gYLTL.layers).bgLayers.push(mtLayer);
}
function $cb3e0081c099494f$var$displayMntLayer() {
    let layr = new $47ae5f26affe1e5e$export$be2e48cfdc7506da.wms("https://services.data.shom.fr/INSPIRE/wms/r?", {
        layers: "MNT_COTIER_MORBIHAN_TANDEM_20m_PBMA_3857_WMSR",
        format: "image/png",
        transparent: true,
        version: "1.3.0",
        service: "WMS",
        request: "GetMap",
        uppercase: true,
        className: "mnt_layer"
    });
    layr.addTo((0, $gYLTL.map).instance);
    (0, $gYLTL.layers).bgLayers.push(layr);
}
function $cb3e0081c099494f$export$33d1addef09845d7(lng, lat) {
    let pt = (0, $gYLTL.map).instance.latLngToLayerPoint([
        lat,
        lng
    ]);
    return [
        pt.x,
        pt.y
    ];
}



var $7636ed459e8205ef$exports = {};
var $513562cc03c1a9cb$exports = {};

$513562cc03c1a9cb$exports = (parcelRequire("aNJCr")).getBundleURL("oAonY") + "active_poi_icon.80b63cb2.svg";


var $0e7636dc98061d5d$exports = {};

$0e7636dc98061d5d$exports = (parcelRequire("aNJCr")).getBundleURL("oAonY") + "lune-nuage-1-pluie-1.5f3e727c.svg";


var $d98e42784b565d63$exports = {};

$d98e42784b565d63$exports = (parcelRequire("aNJCr")).getBundleURL("oAonY") + "lune-nuage-1-pluie-2.e923860f.svg";


var $0389efc5ae994b00$exports = {};

$0389efc5ae994b00$exports = (parcelRequire("aNJCr")).getBundleURL("oAonY") + "lune-nuage-1-pluie-3.8e22855c.svg";


var $c1827c7e7c6b1d30$exports = {};

$c1827c7e7c6b1d30$exports = (parcelRequire("aNJCr")).getBundleURL("oAonY") + "lune-nuage-1.647e6658.svg";


var $fee3e2e4bb86aa26$exports = {};

$fee3e2e4bb86aa26$exports = (parcelRequire("aNJCr")).getBundleURL("oAonY") + "lune-nuage-2-pluie-1.e3f72300.svg";


var $eb9a1907862b5a2b$exports = {};

$eb9a1907862b5a2b$exports = (parcelRequire("aNJCr")).getBundleURL("oAonY") + "lune-nuage-2-pluie-2.4420f248.svg";


var $d03f0d7c38547154$exports = {};

$d03f0d7c38547154$exports = (parcelRequire("aNJCr")).getBundleURL("oAonY") + "lune-nuage-2-pluie-3.e99f3c7e.svg";


var $767ba93ceb469eac$exports = {};

$767ba93ceb469eac$exports = (parcelRequire("aNJCr")).getBundleURL("oAonY") + "lune-nuage-2.bbb32705.svg";


var $4bfe2a11fe4fcbc7$exports = {};

$4bfe2a11fe4fcbc7$exports = (parcelRequire("aNJCr")).getBundleURL("oAonY") + "lune-nuage-3-pluie-1.4753560e.svg";


var $76d136f2a5d8fec0$exports = {};

$76d136f2a5d8fec0$exports = (parcelRequire("aNJCr")).getBundleURL("oAonY") + "lune-nuage-3-pluie-2.68a72b69.svg";


var $761b6766b3219d0b$exports = {};

$761b6766b3219d0b$exports = (parcelRequire("aNJCr")).getBundleURL("oAonY") + "lune-nuage-3-pluie-3.d5c436cb.svg";


var $2d4ba1bb21833b24$exports = {};

$2d4ba1bb21833b24$exports = (parcelRequire("aNJCr")).getBundleURL("oAonY") + "lune-nuage-3.9204baa5.svg";


var $7f86531874cb74a9$exports = {};

$7f86531874cb74a9$exports = (parcelRequire("aNJCr")).getBundleURL("oAonY") + "lune-pluie-1.37e1dd31.svg";


var $65f1b01d830b794c$exports = {};

$65f1b01d830b794c$exports = (parcelRequire("aNJCr")).getBundleURL("oAonY") + "lune-pluie-2.27bccd53.svg";


var $b7d141d1aac54af8$exports = {};

$b7d141d1aac54af8$exports = (parcelRequire("aNJCr")).getBundleURL("oAonY") + "lune-pluie-3.daa267b6.svg";


var $df9585f5a7208557$exports = {};

$df9585f5a7208557$exports = (parcelRequire("aNJCr")).getBundleURL("oAonY") + "lune-voile-pluie-1.8ae6d3a4.svg";


var $4a4c2a7b5e3a7a4a$exports = {};

$4a4c2a7b5e3a7a4a$exports = (parcelRequire("aNJCr")).getBundleURL("oAonY") + "lune-voile-pluie-2.1605b873.svg";


var $eb289fa61b0d006c$exports = {};

$eb289fa61b0d006c$exports = (parcelRequire("aNJCr")).getBundleURL("oAonY") + "lune-voile-pluie-3.84a12d3f.svg";


var $8c321437805b674a$exports = {};

$8c321437805b674a$exports = (parcelRequire("aNJCr")).getBundleURL("oAonY") + "lune-voile.44a915df.svg";


var $da4970c97654c5aa$exports = {};

$da4970c97654c5aa$exports = (parcelRequire("aNJCr")).getBundleURL("oAonY") + "lune.bc430886.svg";


var $4ad614dc58295a4b$exports = {};

$4ad614dc58295a4b$exports = (parcelRequire("aNJCr")).getBundleURL("oAonY") + "nuage-3-pluie-1.4182f042.svg";


var $077c88e062151505$exports = {};

$077c88e062151505$exports = (parcelRequire("aNJCr")).getBundleURL("oAonY") + "nuage-3-pluie-2.955d450e.svg";


var $cc631efcdcdb4634$exports = {};

$cc631efcdcdb4634$exports = (parcelRequire("aNJCr")).getBundleURL("oAonY") + "nuage-3-pluie-3.3eda1ac8.svg";


var $0a9f8ed0f2c29152$exports = {};

$0a9f8ed0f2c29152$exports = (parcelRequire("aNJCr")).getBundleURL("oAonY") + "nuage-3.c44add4c.svg";


var $084b6c913afc2aff$exports = {};

$084b6c913afc2aff$exports = (parcelRequire("aNJCr")).getBundleURL("oAonY") + "nuage-pluie-1.23af1aaf.svg";


var $29d2cc1ad36c3a2d$exports = {};

$29d2cc1ad36c3a2d$exports = (parcelRequire("aNJCr")).getBundleURL("oAonY") + "nuage-pluie-2.42a4a462.svg";


var $20f2036074d9310a$exports = {};

$20f2036074d9310a$exports = (parcelRequire("aNJCr")).getBundleURL("oAonY") + "nuage-pluie-3.b4a4012a.svg";


var $44af916f684bddde$exports = {};

$44af916f684bddde$exports = (parcelRequire("aNJCr")).getBundleURL("oAonY") + "nuage.cb5005d5.svg";


var $406378a67b336754$exports = {};

$406378a67b336754$exports = (parcelRequire("aNJCr")).getBundleURL("oAonY") + "soleil-nuage-1-pluie-1.60181a3f.svg";


var $928bb11161997deb$exports = {};

$928bb11161997deb$exports = (parcelRequire("aNJCr")).getBundleURL("oAonY") + "soleil-nuage-1-pluie-2.31358178.svg";


var $db8b8deb6f80a3cf$exports = {};

$db8b8deb6f80a3cf$exports = (parcelRequire("aNJCr")).getBundleURL("oAonY") + "soleil-nuage-1-pluie-3.8ee1c01c.svg";


var $8b05dd3f9c85f8e8$exports = {};

$8b05dd3f9c85f8e8$exports = (parcelRequire("aNJCr")).getBundleURL("oAonY") + "soleil-nuage-1.555b937b.svg";


var $d5fde4a06f1a4597$exports = {};

$d5fde4a06f1a4597$exports = (parcelRequire("aNJCr")).getBundleURL("oAonY") + "soleil-nuage-2-pluie-1.9addd2ac.svg";


var $1e4475ba2349c787$exports = {};

$1e4475ba2349c787$exports = (parcelRequire("aNJCr")).getBundleURL("oAonY") + "soleil-nuage-2-pluie-2.8591b68a.svg";


var $7c5ba57faf089c82$exports = {};

$7c5ba57faf089c82$exports = (parcelRequire("aNJCr")).getBundleURL("oAonY") + "soleil-nuage-2-pluie-3.407fc3e5.svg";


var $96a6697a42a9eaa3$exports = {};

$96a6697a42a9eaa3$exports = (parcelRequire("aNJCr")).getBundleURL("oAonY") + "soleil-nuage-2.7b675de9.svg";


var $ed121c3e4af4528c$exports = {};

$ed121c3e4af4528c$exports = (parcelRequire("aNJCr")).getBundleURL("oAonY") + "soleil-pluie-1.7c82d183.svg";


var $fab12c202ced6e26$exports = {};

$fab12c202ced6e26$exports = (parcelRequire("aNJCr")).getBundleURL("oAonY") + "soleil-pluie-2.7f55c1cd.svg";


var $a13f8d84d63c21fd$exports = {};

$a13f8d84d63c21fd$exports = (parcelRequire("aNJCr")).getBundleURL("oAonY") + "soleil-pluie-3.adb896e1.svg";


var $5e824c210b87959a$exports = {};

$5e824c210b87959a$exports = (parcelRequire("aNJCr")).getBundleURL("oAonY") + "soleil-voile-pluie-1.0b00ef42.svg";


var $92629d44d88f8a40$exports = {};

$92629d44d88f8a40$exports = (parcelRequire("aNJCr")).getBundleURL("oAonY") + "soleil-voile-pluie-2.ce97767c.svg";


var $8fed96f0d746c653$exports = {};

$8fed96f0d746c653$exports = (parcelRequire("aNJCr")).getBundleURL("oAonY") + "soleil-voile-pluie-3.3a8ba4e6.svg";


var $016649635879b96f$exports = {};

$016649635879b96f$exports = (parcelRequire("aNJCr")).getBundleURL("oAonY") + "soleil-voile.1eaa033b.svg";


var $11b0d604dd0d6078$exports = {};

$11b0d604dd0d6078$exports = (parcelRequire("aNJCr")).getBundleURL("oAonY") + "soleil.ecdb683b.svg";


$7636ed459e8205ef$exports = {
    "active_poi_icon": $513562cc03c1a9cb$exports,
    "lune-nuage-1-pluie-1": $0e7636dc98061d5d$exports,
    "lune-nuage-1-pluie-2": $d98e42784b565d63$exports,
    "lune-nuage-1-pluie-3": $0389efc5ae994b00$exports,
    "lune-nuage-1": $c1827c7e7c6b1d30$exports,
    "lune-nuage-2-pluie-1": $fee3e2e4bb86aa26$exports,
    "lune-nuage-2-pluie-2": $eb9a1907862b5a2b$exports,
    "lune-nuage-2-pluie-3": $d03f0d7c38547154$exports,
    "lune-nuage-2": $767ba93ceb469eac$exports,
    "lune-nuage-3-pluie-1": $4bfe2a11fe4fcbc7$exports,
    "lune-nuage-3-pluie-2": $76d136f2a5d8fec0$exports,
    "lune-nuage-3-pluie-3": $761b6766b3219d0b$exports,
    "lune-nuage-3": $2d4ba1bb21833b24$exports,
    "lune-pluie-1": $7f86531874cb74a9$exports,
    "lune-pluie-2": $65f1b01d830b794c$exports,
    "lune-pluie-3": $b7d141d1aac54af8$exports,
    "lune-voile-pluie-1": $df9585f5a7208557$exports,
    "lune-voile-pluie-2": $4a4c2a7b5e3a7a4a$exports,
    "lune-voile-pluie-3": $eb289fa61b0d006c$exports,
    "lune-voile": $8c321437805b674a$exports,
    "lune": $da4970c97654c5aa$exports,
    "nuage-3-pluie-1": $4ad614dc58295a4b$exports,
    "nuage-3-pluie-2": $077c88e062151505$exports,
    "nuage-3-pluie-3": $cc631efcdcdb4634$exports,
    "nuage-3": $0a9f8ed0f2c29152$exports,
    "nuage-pluie-1": $084b6c913afc2aff$exports,
    "nuage-pluie-2": $29d2cc1ad36c3a2d$exports,
    "nuage-pluie-3": $20f2036074d9310a$exports,
    "nuage": $44af916f684bddde$exports,
    "soleil-nuage-1-pluie-1": $406378a67b336754$exports,
    "soleil-nuage-1-pluie-2": $928bb11161997deb$exports,
    "soleil-nuage-1-pluie-3": $db8b8deb6f80a3cf$exports,
    "soleil-nuage-1": $8b05dd3f9c85f8e8$exports,
    "soleil-nuage-2-pluie-1": $d5fde4a06f1a4597$exports,
    "soleil-nuage-2-pluie-2": $1e4475ba2349c787$exports,
    "soleil-nuage-2-pluie-3": $7c5ba57faf089c82$exports,
    "soleil-nuage-2": $96a6697a42a9eaa3$exports,
    "soleil-pluie-1": $ed121c3e4af4528c$exports,
    "soleil-pluie-2": $fab12c202ced6e26$exports,
    "soleil-pluie-3": $a13f8d84d63c21fd$exports,
    "soleil-voile-pluie-1": $5e824c210b87959a$exports,
    "soleil-voile-pluie-2": $92629d44d88f8a40$exports,
    "soleil-voile-pluie-3": $8fed96f0d746c653$exports,
    "soleil-voile": $016649635879b96f$exports,
    "soleil": $11b0d604dd0d6078$exports
};



var $j5Ozl = parcelRequire("j5Ozl");


var $5ewvA = parcelRequire("5ewvA");
var $39cbcd9072da7ec9$exports = {};
var $ca65e93337b8a866$exports = {};

$ca65e93337b8a866$exports = (parcelRequire("aNJCr")).getBundleURL("oAonY") + "amp-map.5f4d399a.svg";


var $d6cbf6bb8258ef7b$exports = {};

$d6cbf6bb8258ef7b$exports = (parcelRequire("aNJCr")).getBundleURL("oAonY") + "arrow.6dfe1608.svg";


var $762b880e5b5ed5ee$exports = {};

$762b880e5b5ed5ee$exports = (parcelRequire("aNJCr")).getBundleURL("oAonY") + "arrow_gray.b01d5c81.svg";


var $ae695f7e0b6ec43d$exports = {};

$ae695f7e0b6ec43d$exports = (parcelRequire("aNJCr")).getBundleURL("oAonY") + "favoris.4c725afc.svg";


var $56934c356b98f5d2$exports = {};

$56934c356b98f5d2$exports = (parcelRequire("aNJCr")).getBundleURL("oAonY") + "fleche-vague.44f035ea.svg";


var $5e7569e3dd8e7097$exports = {};

$5e7569e3dd8e7097$exports = (parcelRequire("aNJCr")).getBundleURL("oAonY") + "fleche-vent.119f7036.svg";


var $587ee195c611d672$exports = {};

$587ee195c611d672$exports = (parcelRequire("aNJCr")).getBundleURL("oAonY") + "info.325a1dbe.svg";


var $2b26fc7c52508a96$exports = {};

$2b26fc7c52508a96$exports = (parcelRequire("aNJCr")).getBundleURL("oAonY") + "legend.8c3b114a.svg";


var $2542dc0704a4db35$exports = {};

$2542dc0704a4db35$exports = (parcelRequire("aNJCr")).getBundleURL("oAonY") + "meteo.20ddaefd.svg";


var $c07edc443647cfd8$exports = {};

$c07edc443647cfd8$exports = (parcelRequire("aNJCr")).getBundleURL("oAonY") + "meteo_previ.3ade7218.svg";


var $49bd33dc10ae579d$exports = {};

$49bd33dc10ae579d$exports = (parcelRequire("aNJCr")).getBundleURL("oAonY") + "meteo_select.7431bb88.svg";


var $65dfec8722e4e59f$exports = {};

$65dfec8722e4e59f$exports = (parcelRequire("aNJCr")).getBundleURL("oAonY") + "meteogramme-prevision.474c8c2b.svg";


var $92d70fb58448baac$exports = {};

$92d70fb58448baac$exports = (parcelRequire("aNJCr")).getBundleURL("oAonY") + "meteogramme.d5d95ae7.svg";


var $f94f56ec67da08db$exports = {};

$f94f56ec67da08db$exports = (parcelRequire("aNJCr")).getBundleURL("oAonY") + "temp.1ca9d45d.svg";


var $c2aef7e6d4331851$exports = {};

$c2aef7e6d4331851$exports = (parcelRequire("aNJCr")).getBundleURL("oAonY") + "tide-map.d8641695.svg";


var $38639cd828baaaa8$exports = {};

$38639cd828baaaa8$exports = (parcelRequire("aNJCr")).getBundleURL("oAonY") + "tide.52e5a567.svg";


var $64cf7aefadb178fb$exports = {};

$64cf7aefadb178fb$exports = (parcelRequire("aNJCr")).getBundleURL("oAonY") + "waves-prevision.3ddf4c14.svg";


var $a8ad2440fb73db2a$exports = {};

$a8ad2440fb73db2a$exports = (parcelRequire("aNJCr")).getBundleURL("oAonY") + "waves.7798a008.svg";


var $50204fbbfc721a78$exports = {};

$50204fbbfc721a78$exports = (parcelRequire("aNJCr")).getBundleURL("oAonY") + "webcam-map.39b9a9ff.svg";


var $08ea67ed05910651$exports = {};

$08ea67ed05910651$exports = (parcelRequire("aNJCr")).getBundleURL("oAonY") + "webcam.15d4ed6b.svg";


var $9b91b5b168e18bbb$exports = {};

$9b91b5b168e18bbb$exports = (parcelRequire("aNJCr")).getBundleURL("oAonY") + "wind.06ed8561.svg";


var $7a5b07bc54a59f1b$exports = {};

$7a5b07bc54a59f1b$exports = (parcelRequire("aNJCr")).getBundleURL("oAonY") + "wind_prevision.4d15525c.svg";


$39cbcd9072da7ec9$exports = {
    "amp-map": $ca65e93337b8a866$exports,
    "arrow": $d6cbf6bb8258ef7b$exports,
    "arrow_gray": $762b880e5b5ed5ee$exports,
    "favoris": $ae695f7e0b6ec43d$exports,
    "fleche-vague": $56934c356b98f5d2$exports,
    "fleche-vent": $5e7569e3dd8e7097$exports,
    "info": $587ee195c611d672$exports,
    "legend": $2b26fc7c52508a96$exports,
    "meteo": $2542dc0704a4db35$exports,
    "meteo_previ": $c07edc443647cfd8$exports,
    "meteo_select": $49bd33dc10ae579d$exports,
    "meteogramme-prevision": $65dfec8722e4e59f$exports,
    "meteogramme": $92d70fb58448baac$exports,
    "temp": $f94f56ec67da08db$exports,
    "tide-map": $c2aef7e6d4331851$exports,
    "tide": $38639cd828baaaa8$exports,
    "waves-prevision": $64cf7aefadb178fb$exports,
    "waves": $a8ad2440fb73db2a$exports,
    "webcam-map": $50204fbbfc721a78$exports,
    "webcam": $08ea67ed05910651$exports,
    "wind": $9b91b5b168e18bbb$exports,
    "wind_prevision": $7a5b07bc54a59f1b$exports
};


var $957d647adad0df91$exports = {};
!function(t, n) {
    $957d647adad0df91$exports = n();
}("undefined" != typeof self ? self : $957d647adad0df91$exports, function() {
    return function() {
        "use strict";
        var t = {
            407: function(t, n, e) {
                e.d(n, {
                    default: function() {
                        return N;
                    }
                });
                var o = /([:*])(\w+)/g, r = /\*/g, i = /\/\?/g;
                function a(t) {
                    return void 0 === t && (t = "/"), v() ? location.pathname + location.search + location.hash : t;
                }
                function s(t) {
                    return t.replace(/\/+$/, "").replace(/^\/+/, "");
                }
                function c(t) {
                    return "string" == typeof t;
                }
                function u(t) {
                    return t && t.indexOf("#") >= 0 && t.split("#").pop() || "";
                }
                function h(t) {
                    var n = s(t).split(/\?(.*)?$/);
                    return [
                        s(n[0]),
                        n.slice(1).join("")
                    ];
                }
                function f(t) {
                    for(var n = {}, e = t.split("&"), o = 0; o < e.length; o++){
                        var r = e[o].split("=");
                        if ("" !== r[0]) {
                            var i = decodeURIComponent(r[0]);
                            n[i] ? (Array.isArray(n[i]) || (n[i] = [
                                n[i]
                            ]), n[i].push(decodeURIComponent(r[1] || ""))) : n[i] = decodeURIComponent(r[1] || "");
                        }
                    }
                    return n;
                }
                function l(t, n) {
                    var e, a = h(s(t.currentLocationPath)), l = a[0], p = a[1], d = "" === p ? null : f(p), v = [];
                    if (c(n.path)) {
                        if (e = "(?:/^|^)" + s(n.path).replace(o, function(t, n, e) {
                            return v.push(e), "([^/]+)";
                        }).replace(r, "?(?:.*)").replace(i, "/?([^/]+|)") + "$", "" === s(n.path) && "" === s(l)) return {
                            url: l,
                            queryString: p,
                            hashString: u(t.to),
                            route: n,
                            data: null,
                            params: d
                        };
                    } else e = n.path;
                    var g = new RegExp(e, ""), m = l.match(g);
                    if (m) {
                        var y = c(n.path) ? function(t, n) {
                            return 0 === n.length ? null : t ? t.slice(1, t.length).reduce(function(t, e, o) {
                                return null === t && (t = {}), t[n[o]] = decodeURIComponent(e), t;
                            }, null) : null;
                        }(m, v) : m.groups ? m.groups : m.slice(1);
                        return {
                            url: s(l.replace(new RegExp("^" + t.instance.root), "")),
                            queryString: p,
                            hashString: u(t.to),
                            route: n,
                            data: y,
                            params: d
                        };
                    }
                    return !1;
                }
                function p() {
                    return !("undefined" == typeof window || !window.history || !window.history.pushState);
                }
                function d(t, n) {
                    return void 0 === t[n] || !0 === t[n];
                }
                function v() {
                    return "undefined" != typeof window;
                }
                function g(t, n) {
                    return void 0 === t && (t = []), void 0 === n && (n = {}), t.filter(function(t) {
                        return t;
                    }).forEach(function(t) {
                        [
                            "before",
                            "after",
                            "already",
                            "leave"
                        ].forEach(function(e) {
                            t[e] && (n[e] || (n[e] = []), n[e].push(t[e]));
                        });
                    }), n;
                }
                function m(t, n, e) {
                    var o = n || {}, r = 0;
                    !function n() {
                        t[r] ? Array.isArray(t[r]) ? (t.splice.apply(t, [
                            r,
                            1
                        ].concat(t[r][0](o) ? t[r][1] : t[r][2])), n()) : t[r](o, function(t) {
                            void 0 === t || !0 === t ? (r += 1, n()) : e && e(o);
                        }) : e && e(o);
                    }();
                }
                function y(t, n) {
                    void 0 === t.currentLocationPath && (t.currentLocationPath = t.to = a(t.instance.root)), t.currentLocationPath = t.instance._checkForAHash(t.currentLocationPath), n();
                }
                function _(t, n) {
                    for(var e = 0; e < t.instance.routes.length; e++){
                        var o = l(t, t.instance.routes[e]);
                        if (o && (t.matches || (t.matches = []), t.matches.push(o), "ONE" === t.resolveOptions.strategy)) return void n();
                    }
                    n();
                }
                function k(t, n) {
                    t.navigateOptions && (void 0 !== t.navigateOptions.shouldResolve && console.warn('"shouldResolve" is deprecated. Please check the documentation.'), void 0 !== t.navigateOptions.silent && console.warn('"silent" is deprecated. Please check the documentation.')), n();
                }
                function O(t, n) {
                    !0 === t.navigateOptions.force ? (t.instance._setCurrent([
                        t.instance._pathToMatchObject(t.to)
                    ]), n(!1)) : n();
                }
                m.if = function(t, n, e) {
                    return Array.isArray(n) || (n = [
                        n
                    ]), Array.isArray(e) || (e = [
                        e
                    ]), [
                        t,
                        n,
                        e
                    ];
                };
                var w = v(), L = p();
                function b(t, n) {
                    if (d(t.navigateOptions, "updateBrowserURL")) {
                        var e = ("/" + t.to).replace(/\/\//g, "/"), o = w && t.resolveOptions && !0 === t.resolveOptions.hash;
                        L ? (history[t.navigateOptions.historyAPIMethod || "pushState"](t.navigateOptions.stateObj || {}, t.navigateOptions.title || "", o ? "#" + e : e), location && location.hash && (t.instance.__freezeListening = !0, setTimeout(function() {
                            if (!o) {
                                var n = location.hash;
                                location.hash = "", location.hash = n;
                            }
                            t.instance.__freezeListening = !1;
                        }, 1))) : w && (window.location.href = t.to);
                    }
                    n();
                }
                function A(t, n) {
                    var e = t.instance;
                    e.lastResolved() ? m(e.lastResolved().map(function(n) {
                        return function(e, o) {
                            if (n.route.hooks && n.route.hooks.leave) {
                                var r = !1, i = t.instance.matchLocation(n.route.path, t.currentLocationPath, !1);
                                r = "*" !== n.route.path ? !i : !(t.matches && t.matches.find(function(t) {
                                    return n.route.path === t.route.path;
                                })), d(t.navigateOptions, "callHooks") && r ? m(n.route.hooks.leave.map(function(n) {
                                    return function(e, o) {
                                        return n(function(n) {
                                            !1 === n ? t.instance.__markAsClean(t) : o();
                                        }, t.matches && t.matches.length > 0 ? 1 === t.matches.length ? t.matches[0] : t.matches : void 0);
                                    };
                                }).concat([
                                    function() {
                                        return o();
                                    }
                                ])) : o();
                            } else o();
                        };
                    }), {}, function() {
                        return n();
                    }) : n();
                }
                function P(t, n) {
                    d(t.navigateOptions, "updateState") && t.instance._setCurrent(t.matches), n();
                }
                var R = [
                    function(t, n) {
                        var e = t.instance.lastResolved();
                        if (e && e[0] && e[0].route === t.match.route && e[0].url === t.match.url && e[0].queryString === t.match.queryString) return e.forEach(function(n) {
                            n.route.hooks && n.route.hooks.already && d(t.navigateOptions, "callHooks") && n.route.hooks.already.forEach(function(n) {
                                return n(t.match);
                            });
                        }), void n(!1);
                        n();
                    },
                    function(t, n) {
                        t.match.route.hooks && t.match.route.hooks.before && d(t.navigateOptions, "callHooks") ? m(t.match.route.hooks.before.map(function(n) {
                            return function(e, o) {
                                return n(function(n) {
                                    !1 === n ? t.instance.__markAsClean(t) : o();
                                }, t.match);
                            };
                        }).concat([
                            function() {
                                return n();
                            }
                        ])) : n();
                    },
                    function(t, n) {
                        d(t.navigateOptions, "callHandler") && t.match.route.handler(t.match), t.instance.updatePageLinks(), n();
                    },
                    function(t, n) {
                        t.match.route.hooks && t.match.route.hooks.after && d(t.navigateOptions, "callHooks") && t.match.route.hooks.after.forEach(function(n) {
                            return n(t.match);
                        }), n();
                    }
                ], S = [
                    A,
                    function(t, n) {
                        var e = t.instance._notFoundRoute;
                        if (e) {
                            t.notFoundHandled = !0;
                            var o = h(t.currentLocationPath), r = o[0], i = o[1], a = u(t.to);
                            e.path = s(r);
                            var c = {
                                url: e.path,
                                queryString: i,
                                hashString: a,
                                data: null,
                                route: e,
                                params: "" !== i ? f(i) : null
                            };
                            t.matches = [
                                c
                            ], t.match = c;
                        }
                        n();
                    },
                    m.if(function(t) {
                        return t.notFoundHandled;
                    }, R.concat([
                        P
                    ]), [
                        function(t, n) {
                            t.resolveOptions && !1 !== t.resolveOptions.noMatchWarning && void 0 !== t.resolveOptions.noMatchWarning || console.warn('Navigo: "' + t.currentLocationPath + "\" didn't match any of the registered routes."), n();
                        },
                        function(t, n) {
                            t.instance._setCurrent(null), n();
                        }
                    ])
                ];
                function E() {
                    return (E = Object.assign || function(t) {
                        for(var n = 1; n < arguments.length; n++){
                            var e = arguments[n];
                            for(var o in e)Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
                        }
                        return t;
                    }).apply(this, arguments);
                }
                function x(t, n) {
                    var e = 0;
                    A(t, function o() {
                        e !== t.matches.length ? m(R, E({}, t, {
                            match: t.matches[e]
                        }), function() {
                            e += 1, o();
                        }) : P(t, n);
                    });
                }
                function H(t) {
                    t.instance.__markAsClean(t);
                }
                function j() {
                    return (j = Object.assign || function(t) {
                        for(var n = 1; n < arguments.length; n++){
                            var e = arguments[n];
                            for(var o in e)Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
                        }
                        return t;
                    }).apply(this, arguments);
                }
                var C = "[data-navigo]";
                function N(t, n) {
                    var e, o = n || {
                        strategy: "ONE",
                        hash: !1,
                        noMatchWarning: !1,
                        linksSelector: C
                    }, r = this, i = "/", d = null, w = [], L = !1, A = p(), P = v();
                    function R(t) {
                        return t.indexOf("#") >= 0 && (t = !0 === o.hash ? t.split("#")[1] || "/" : t.split("#")[0]), t;
                    }
                    function E(t) {
                        return s(i + "/" + s(t));
                    }
                    function N(t, n, e, o) {
                        return t = c(t) ? E(t) : t, {
                            name: o || s(String(t)),
                            path: t,
                            handler: n,
                            hooks: g(e)
                        };
                    }
                    function U(t, n) {
                        if (!r.__dirty) {
                            r.__dirty = !0, t = t ? s(i) + "/" + s(t) : void 0;
                            var e = {
                                instance: r,
                                to: t,
                                currentLocationPath: t,
                                navigateOptions: {},
                                resolveOptions: j({}, o, n)
                            };
                            return m([
                                y,
                                _,
                                m.if(function(t) {
                                    var n = t.matches;
                                    return n && n.length > 0;
                                }, x, S)
                            ], e, H), !!e.matches && e.matches;
                        }
                        r.__waiting.push(function() {
                            return r.resolve(t, n);
                        });
                    }
                    function q(t, n) {
                        if (r.__dirty) r.__waiting.push(function() {
                            return r.navigate(t, n);
                        });
                        else {
                            r.__dirty = !0, t = s(i) + "/" + s(t);
                            var e = {
                                instance: r,
                                to: t,
                                navigateOptions: n || {},
                                resolveOptions: n && n.resolveOptions ? n.resolveOptions : o,
                                currentLocationPath: R(t)
                            };
                            m([
                                k,
                                O,
                                _,
                                m.if(function(t) {
                                    var n = t.matches;
                                    return n && n.length > 0;
                                }, x, S),
                                b,
                                H
                            ], e, H);
                        }
                    }
                    function F() {
                        if (P) return (P ? [].slice.call(document.querySelectorAll(o.linksSelector || C)) : []).forEach(function(t) {
                            "false" !== t.getAttribute("data-navigo") && "_blank" !== t.getAttribute("target") ? t.hasListenerAttached || (t.hasListenerAttached = !0, t.navigoHandler = function(n) {
                                if ((n.ctrlKey || n.metaKey) && "a" === n.target.tagName.toLowerCase()) return !1;
                                var e = t.getAttribute("href");
                                if (null == e) return !1;
                                if (e.match(/^(http|https)/) && "undefined" != typeof URL) try {
                                    var o = new URL(e);
                                    e = o.pathname + o.search;
                                } catch (t) {}
                                var i = function(t) {
                                    if (!t) return {};
                                    var n, e = t.split(","), o = {};
                                    return e.forEach(function(t) {
                                        var e = t.split(":").map(function(t) {
                                            return t.replace(/(^ +| +$)/g, "");
                                        });
                                        switch(e[0]){
                                            case "historyAPIMethod":
                                                o.historyAPIMethod = e[1];
                                                break;
                                            case "resolveOptionsStrategy":
                                                n || (n = {}), n.strategy = e[1];
                                                break;
                                            case "resolveOptionsHash":
                                                n || (n = {}), n.hash = "true" === e[1];
                                                break;
                                            case "updateBrowserURL":
                                            case "callHandler":
                                            case "updateState":
                                            case "force":
                                                o[e[0]] = "true" === e[1];
                                        }
                                    }), n && (o.resolveOptions = n), o;
                                }(t.getAttribute("data-navigo-options"));
                                L || (n.preventDefault(), n.stopPropagation(), r.navigate(s(e), i));
                            }, t.addEventListener("click", t.navigoHandler)) : t.hasListenerAttached && t.removeEventListener("click", t.navigoHandler);
                        }), r;
                    }
                    function I(t, n, e) {
                        var o = w.find(function(n) {
                            return n.name === t;
                        }), r = null;
                        if (o) {
                            if (r = o.path, n) for(var a in n)r = r.replace(":" + a, n[a]);
                            r = r.match(/^\//) ? r : "/" + r;
                        }
                        return r && e && !e.includeRoot && (r = r.replace(new RegExp("^/" + i), "")), r;
                    }
                    function M(t) {
                        var n = h(s(t)), o = n[0], r = n[1], i = "" === r ? null : f(r);
                        return {
                            url: o,
                            queryString: r,
                            hashString: u(t),
                            route: N(o, function() {}, [
                                e
                            ], o),
                            data: null,
                            params: i
                        };
                    }
                    function T(t, n, e) {
                        return "string" == typeof n && (n = z(n)), n ? (n.hooks[t] || (n.hooks[t] = []), n.hooks[t].push(e), function() {
                            n.hooks[t] = n.hooks[t].filter(function(t) {
                                return t !== e;
                            });
                        }) : (console.warn("Route doesn't exists: " + n), function() {});
                    }
                    function z(t) {
                        return "string" == typeof t ? w.find(function(n) {
                            return n.name === E(t);
                        }) : w.find(function(n) {
                            return n.handler === t;
                        });
                    }
                    t ? i = s(t) : console.warn('Navigo requires a root path in its constructor. If not provided will use "/" as default.'), this.root = i, this.routes = w, this.destroyed = L, this.current = d, this.__freezeListening = !1, this.__waiting = [], this.__dirty = !1, this.__markAsClean = function(t) {
                        t.instance.__dirty = !1, t.instance.__waiting.length > 0 && t.instance.__waiting.shift()();
                    }, this.on = function(t, n, o) {
                        var r = this;
                        return "object" != typeof t || t instanceof RegExp ? ("function" == typeof t && (o = n, n = t, t = i), w.push(N(t, n, [
                            e,
                            o
                        ])), this) : (Object.keys(t).forEach(function(n) {
                            if ("function" == typeof t[n]) r.on(n, t[n]);
                            else {
                                var o = t[n], i = o.uses, a = o.as, s = o.hooks;
                                w.push(N(n, i, [
                                    e,
                                    s
                                ], a));
                            }
                        }), this);
                    }, this.off = function(t) {
                        return this.routes = w = w.filter(function(n) {
                            return c(t) ? s(n.path) !== s(t) : "function" == typeof t ? t !== n.handler : String(n.path) !== String(t);
                        }), this;
                    }, this.resolve = U, this.navigate = q, this.navigateByName = function(t, n, e) {
                        var o = I(t, n);
                        return null !== o && (q(o.replace(new RegExp("^/?" + i), ""), e), !0);
                    }, this.destroy = function() {
                        this.routes = w = [], A && window.removeEventListener("popstate", this.__popstateListener), this.destroyed = L = !0;
                    }, this.notFound = function(t, n) {
                        return r._notFoundRoute = N("*", t, [
                            e,
                            n
                        ], "__NOT_FOUND__"), this;
                    }, this.updatePageLinks = F, this.link = function(t) {
                        return "/" + i + "/" + s(t);
                    }, this.hooks = function(t) {
                        return e = t, this;
                    }, this.extractGETParameters = function(t) {
                        return h(R(t));
                    }, this.lastResolved = function() {
                        return d;
                    }, this.generate = I, this.getLinkPath = function(t) {
                        return t.getAttribute("href");
                    }, this.match = function(t) {
                        var n = {
                            instance: r,
                            currentLocationPath: t,
                            to: t,
                            navigateOptions: {},
                            resolveOptions: o
                        };
                        return _(n, function() {}), !!n.matches && n.matches;
                    }, this.matchLocation = function(t, n, e) {
                        void 0 === n || void 0 !== e && !e || (n = E(n));
                        var o = {
                            instance: r,
                            to: n,
                            currentLocationPath: n
                        };
                        return y(o, function() {}), "string" == typeof t && (t = void 0 === e || e ? E(t) : t), l(o, {
                            name: String(t),
                            path: t,
                            handler: function() {},
                            hooks: {}
                        }) || !1;
                    }, this.getCurrentLocation = function() {
                        return M(s(a(i)).replace(new RegExp("^" + i), ""));
                    }, this.addBeforeHook = T.bind(this, "before"), this.addAfterHook = T.bind(this, "after"), this.addAlreadyHook = T.bind(this, "already"), this.addLeaveHook = T.bind(this, "leave"), this.getRoute = z, this._pathToMatchObject = M, this._clean = s, this._checkForAHash = R, this._setCurrent = function(t) {
                        return d = r.current = t;
                    }, (function() {
                        A && (this.__popstateListener = function() {
                            r.__freezeListening || U();
                        }, window.addEventListener("popstate", this.__popstateListener));
                    }).call(this), F.call(this);
                }
            }
        }, n = {};
        function e(o) {
            if (n[o]) return n[o].exports;
            var r = n[o] = {
                exports: {}
            };
            return t[o](r, r.exports, e), r.exports;
        }
        return e.d = function(t, n) {
            for(var o in n)e.o(n, o) && !e.o(t, o) && Object.defineProperty(t, o, {
                enumerable: !0,
                get: n[o]
            });
        }, e.o = function(t, n) {
            return Object.prototype.hasOwnProperty.call(t, n);
        }, e(407);
    }().default;
});



var $dnPBs = parcelRequire("dnPBs");






var $fOKLR = parcelRequire("fOKLR");

var $6RNKk = parcelRequire("6RNKk");

var $j5Ozl = parcelRequire("j5Ozl");

var $5ewvA = parcelRequire("5ewvA");

function $f7ada542ab7a0204$export$2e2bcd8739ae039(values, valueof) {
    let max;
    if (valueof === undefined) {
        for (const value of values)if (value != null && (max < value || max === undefined && value >= value)) max = value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (max < value || max === undefined && value >= value)) max = value;
    }
    return max;
}


function $c332ea6a73ed323f$export$2e2bcd8739ae039(values, valueof) {
    let max;
    let maxIndex = -1;
    let index = -1;
    if (valueof === undefined) for (const value of values){
        ++index;
        if (value != null && (max < value || max === undefined && value >= value)) max = value, maxIndex = index;
    }
    else {
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (max < value || max === undefined && value >= value)) max = value, maxIndex = index;
    }
    return maxIndex;
}


function $67c9bcd37ca278f3$export$2e2bcd8739ae039(values, valueof) {
    let min;
    if (valueof === undefined) {
        for (const value of values)if (value != null && (min > value || min === undefined && value >= value)) min = value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (min > value || min === undefined && value >= value)) min = value;
    }
    return min;
}


function $6a52f134e4616f74$export$2e2bcd8739ae039(values, valueof) {
    let min;
    let minIndex = -1;
    let index = -1;
    if (valueof === undefined) for (const value of values){
        ++index;
        if (value != null && (min > value || min === undefined && value >= value)) min = value, minIndex = index;
    }
    else {
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (min > value || min === undefined && value >= value)) min = value, minIndex = index;
    }
    return minIndex;
}


function $b9a39bb6f3499963$export$2e2bcd8739ae039(a, b) {
    return a == null || b == null ? NaN : a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}


function $da1953ec28f4218a$export$2e2bcd8739ae039(source, keys) {
    return Array.from(keys, (key)=>source[key]);
}


function $524c8f0ea574b783$export$2e2bcd8739ae039(values, ...F) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    values = Array.from(values);
    let [f] = F;
    if (f && f.length !== 2 || F.length > 1) {
        const index = Uint32Array.from(values, (d, i)=>i);
        if (F.length > 1) {
            F = F.map((f)=>values.map(f));
            index.sort((i, j)=>{
                for (const f of F){
                    const c = $524c8f0ea574b783$export$686e14b8469efec4(f[i], f[j]);
                    if (c) return c;
                }
            });
        } else {
            f = values.map(f);
            index.sort((i, j)=>$524c8f0ea574b783$export$686e14b8469efec4(f[i], f[j]));
        }
        return (0, $da1953ec28f4218a$export$2e2bcd8739ae039)(values, index);
    }
    return values.sort($524c8f0ea574b783$export$5708b2c031939e56(f));
}
function $524c8f0ea574b783$export$5708b2c031939e56(compare = (0, $b9a39bb6f3499963$export$2e2bcd8739ae039)) {
    if (compare === (0, $b9a39bb6f3499963$export$2e2bcd8739ae039)) return $524c8f0ea574b783$export$686e14b8469efec4;
    if (typeof compare !== "function") throw new TypeError("compare is not a function");
    return (a, b)=>{
        const x = compare(a, b);
        if (x || x === 0) return x;
        return (compare(b, b) === 0) - (compare(a, a) === 0);
    };
}
function $524c8f0ea574b783$export$686e14b8469efec4(a, b) {
    return (a == null || !(a >= a)) - (b == null || !(b >= b)) || (a < b ? -1 : a > b ? 1 : 0);
}


function $272ff117a832b014$export$2e2bcd8739ae039(array, k, left = 0, right = Infinity, compare) {
    k = Math.floor(k);
    left = Math.floor(Math.max(0, left));
    right = Math.floor(Math.min(array.length - 1, right));
    if (!(left <= k && k <= right)) return array;
    compare = compare === undefined ? (0, $524c8f0ea574b783$export$686e14b8469efec4) : (0, $524c8f0ea574b783$export$5708b2c031939e56)(compare);
    while(right > left){
        if (right - left > 600) {
            const n = right - left + 1;
            const m = k - left + 1;
            const z = Math.log(n);
            const s = 0.5 * Math.exp(2 * z / 3);
            const sd = 0.5 * Math.sqrt(z * s * (n - s) / n) * (m - n / 2 < 0 ? -1 : 1);
            const newLeft = Math.max(left, Math.floor(k - m * s / n + sd));
            const newRight = Math.min(right, Math.floor(k + (n - m) * s / n + sd));
            $272ff117a832b014$export$2e2bcd8739ae039(array, k, newLeft, newRight, compare);
        }
        const t = array[k];
        let i = left;
        let j = right;
        $272ff117a832b014$var$swap(array, left, k);
        if (compare(array[right], t) > 0) $272ff117a832b014$var$swap(array, left, right);
        while(i < j){
            $272ff117a832b014$var$swap(array, i, j), ++i, --j;
            while(compare(array[i], t) < 0)++i;
            while(compare(array[j], t) > 0)--j;
        }
        if (compare(array[left], t) === 0) $272ff117a832b014$var$swap(array, left, j);
        else ++j, $272ff117a832b014$var$swap(array, j, right);
        if (j <= k) left = j + 1;
        if (k <= j) right = j - 1;
    }
    return array;
}
function $272ff117a832b014$var$swap(array, i, j) {
    const t = array[i];
    array[i] = array[j];
    array[j] = t;
}


function $b9db87649c27653e$export$2e2bcd8739ae039(x) {
    return x === null ? NaN : +x;
}
function* $b9db87649c27653e$export$1f6c9cc012ebacae(values, valueof) {
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) yield value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) yield value;
    }
}




function $504ed9215e520c2c$export$2e2bcd8739ae039(values, compare = (0, $b9a39bb6f3499963$export$2e2bcd8739ae039)) {
    let max;
    let defined = false;
    if (compare.length === 1) {
        let maxValue;
        for (const element of values){
            const value = compare(element);
            if (defined ? (0, $b9a39bb6f3499963$export$2e2bcd8739ae039)(value, maxValue) > 0 : (0, $b9a39bb6f3499963$export$2e2bcd8739ae039)(value, value) === 0) {
                max = element;
                maxValue = value;
                defined = true;
            }
        }
    } else {
        for (const value of values)if (defined ? compare(value, max) > 0 : compare(value, value) === 0) {
            max = value;
            defined = true;
        }
    }
    return max;
}


function $b430f7453c38083c$export$2e2bcd8739ae039(values, p, valueof) {
    values = Float64Array.from((0, $b9db87649c27653e$export$1f6c9cc012ebacae)(values, valueof));
    if (!(n = values.length) || isNaN(p = +p)) return;
    if (p <= 0 || n < 2) return (0, $67c9bcd37ca278f3$export$2e2bcd8739ae039)(values);
    if (p >= 1) return (0, $f7ada542ab7a0204$export$2e2bcd8739ae039)(values);
    var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = (0, $f7ada542ab7a0204$export$2e2bcd8739ae039)((0, $272ff117a832b014$export$2e2bcd8739ae039)(values, i0).subarray(0, i0 + 1)), value1 = (0, $67c9bcd37ca278f3$export$2e2bcd8739ae039)(values.subarray(i0 + 1));
    return value0 + (value1 - value0) * (i - i0);
}
function $b430f7453c38083c$export$f924a6cad778dddb(values, p, valueof = (0, $b9db87649c27653e$export$2e2bcd8739ae039)) {
    if (!(n = values.length) || isNaN(p = +p)) return;
    if (p <= 0 || n < 2) return +valueof(values[0], 0, values);
    if (p >= 1) return +valueof(values[n - 1], n - 1, values);
    var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = +valueof(values[i0], i0, values), value1 = +valueof(values[i0 + 1], i0 + 1, values);
    return value0 + (value1 - value0) * (i - i0);
}
function $b430f7453c38083c$export$f1fcc854ecc6ce55(values, p, valueof = (0, $b9db87649c27653e$export$2e2bcd8739ae039)) {
    if (isNaN(p = +p)) return;
    numbers = Float64Array.from(values, (_, i)=>(0, $b9db87649c27653e$export$2e2bcd8739ae039)(valueof(values[i], i, values)));
    if (p <= 0) return (0, $6a52f134e4616f74$export$2e2bcd8739ae039)(numbers);
    if (p >= 1) return (0, $c332ea6a73ed323f$export$2e2bcd8739ae039)(numbers);
    var numbers, index = Uint32Array.from(values, (_, i)=>i), j = numbers.length - 1, i = Math.floor(j * p);
    (0, $272ff117a832b014$export$2e2bcd8739ae039)(index, i, 0, j, (i, j)=>(0, $524c8f0ea574b783$export$686e14b8469efec4)(numbers[i], numbers[j]));
    i = (0, $504ed9215e520c2c$export$2e2bcd8739ae039)(index.subarray(0, i + 1), (i)=>numbers[i]);
    return i >= 0 ? i : -1;
}


function $274fc2d52d6925bb$export$2e2bcd8739ae039(values, valueof) {
    return (0, $b430f7453c38083c$export$2e2bcd8739ae039)(values, 0.5, valueof);
}
function $274fc2d52d6925bb$export$57546ab4fd3c7a5e(values, valueof) {
    return (0, $b430f7453c38083c$export$f1fcc854ecc6ce55)(values, 0.5, valueof);
}

function $49c34f71c88d6b5e$export$2e2bcd8739ae039(values, valueof) {
    let count = 0;
    let sum = 0;
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) ++count, sum += value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) ++count, sum += value;
    }
    if (count) return sum / count;
}



var $j5Ozl = parcelRequire("j5Ozl");

var $db02270dd08a7866$var$REGEX_VALID_OFFSET_FORMAT = /[+-]\d\d(?::?\d\d)?/g;
var $db02270dd08a7866$var$REGEX_OFFSET_HOURS_MINUTES_FORMAT = /([+-]|\d\d)/g;
function $db02270dd08a7866$var$offsetFromString(value) {
    if (value === void 0) value = "";
    var offset = value.match($db02270dd08a7866$var$REGEX_VALID_OFFSET_FORMAT);
    if (!offset) return null;
    var _ref = ("" + offset[0]).match($db02270dd08a7866$var$REGEX_OFFSET_HOURS_MINUTES_FORMAT) || [
        "-",
        0,
        0
    ], indicator = _ref[0], hoursOffset = _ref[1], minutesOffset = _ref[2];
    var totalOffsetInMinutes = +hoursOffset * 60 + +minutesOffset;
    if (totalOffsetInMinutes === 0) return 0;
    return indicator === "+" ? totalOffsetInMinutes : -totalOffsetInMinutes;
}
var $db02270dd08a7866$export$2e2bcd8739ae039 = function(option, Dayjs, dayjs) {
    var proto = Dayjs.prototype;
    dayjs.utc = function(date) {
        var cfg = {
            date: date,
            utc: true,
            args: arguments
        }; // eslint-disable-line prefer-rest-params
        return new Dayjs(cfg); // eslint-disable-line no-use-before-define
    };
    proto.utc = function(keepLocalTime) {
        var ins = dayjs(this.toDate(), {
            locale: this.$L,
            utc: true
        });
        if (keepLocalTime) return ins.add(this.utcOffset(), (0, $f130d2306183d8d9$export$85fbf3b9d951b785));
        return ins;
    };
    proto.local = function() {
        return dayjs(this.toDate(), {
            locale: this.$L,
            utc: false
        });
    };
    var oldParse = proto.parse;
    proto.parse = function(cfg) {
        if (cfg.utc) this.$u = true;
        if (!this.$utils().u(cfg.$offset)) this.$offset = cfg.$offset;
        oldParse.call(this, cfg);
    };
    var oldInit = proto.init;
    proto.init = function() {
        if (this.$u) {
            var $d = this.$d;
            this.$y = $d.getUTCFullYear();
            this.$M = $d.getUTCMonth();
            this.$D = $d.getUTCDate();
            this.$W = $d.getUTCDay();
            this.$H = $d.getUTCHours();
            this.$m = $d.getUTCMinutes();
            this.$s = $d.getUTCSeconds();
            this.$ms = $d.getUTCMilliseconds();
        } else oldInit.call(this);
    };
    var oldUtcOffset = proto.utcOffset;
    proto.utcOffset = function(input, keepLocalTime) {
        var _this$$utils = this.$utils(), u = _this$$utils.u;
        if (u(input)) {
            if (this.$u) return 0;
            if (!u(this.$offset)) return this.$offset;
            return oldUtcOffset.call(this);
        }
        if (typeof input === "string") {
            input = $db02270dd08a7866$var$offsetFromString(input);
            if (input === null) return this;
        }
        var offset = Math.abs(input) <= 16 ? input * 60 : input;
        var ins = this;
        if (keepLocalTime) {
            ins.$offset = offset;
            ins.$u = input === 0;
            return ins;
        }
        if (input !== 0) {
            var localTimezoneOffset = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset();
            ins = this.local().add(offset + localTimezoneOffset, (0, $f130d2306183d8d9$export$85fbf3b9d951b785));
            ins.$offset = offset;
            ins.$x.$localOffset = localTimezoneOffset;
        } else ins = this.utc();
        return ins;
    };
    var oldFormat = proto.format;
    var UTC_FORMAT_DEFAULT = "YYYY-MM-DDTHH:mm:ss[Z]";
    proto.format = function(formatStr) {
        var str = formatStr || (this.$u ? UTC_FORMAT_DEFAULT : "");
        return oldFormat.call(this, str);
    };
    proto.valueOf = function() {
        var addedOffset = !this.$utils().u(this.$offset) ? this.$offset + (this.$x.$localOffset || this.$d.getTimezoneOffset()) : 0;
        return this.$d.valueOf() - addedOffset * (0, $f130d2306183d8d9$export$37971e215480ff4b);
    };
    proto.isUTC = function() {
        return !!this.$u;
    };
    proto.toISOString = function() {
        return this.toDate().toISOString();
    };
    proto.toString = function() {
        return this.toDate().toUTCString();
    };
    var oldToDate = proto.toDate;
    proto.toDate = function(type) {
        if (type === "s" && this.$offset) return dayjs(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate();
        return oldToDate.call(this);
    };
    var oldDiff = proto.diff;
    proto.diff = function(input, units, _float) {
        if (input && this.$u === input.$u) return oldDiff.call(this, input, units, _float);
        var localThis = this.local();
        var localInput = dayjs(input).local();
        return oldDiff.call(localThis, localInput, units, _float);
    };
};



var $fe36b0ee5c104cfd$var$typeToPos = {
    year: 0,
    month: 1,
    day: 2,
    hour: 3,
    minute: 4,
    second: 5
}; // Cache time-zone lookups from Intl.DateTimeFormat,
// as it is a *very* slow method.
var $fe36b0ee5c104cfd$var$dtfCache = {};
var $fe36b0ee5c104cfd$var$getDateTimeFormat = function getDateTimeFormat(timezone, options) {
    if (options === void 0) options = {};
    var timeZoneName = options.timeZoneName || "short";
    var key = timezone + "|" + timeZoneName;
    var dtf = $fe36b0ee5c104cfd$var$dtfCache[key];
    if (!dtf) {
        dtf = new Intl.DateTimeFormat("en-US", {
            hour12: false,
            timeZone: timezone,
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            timeZoneName: timeZoneName
        });
        $fe36b0ee5c104cfd$var$dtfCache[key] = dtf;
    }
    return dtf;
};
var $fe36b0ee5c104cfd$export$2e2bcd8739ae039 = function(o, c, d) {
    var defaultTimezone;
    var makeFormatParts = function makeFormatParts(timestamp, timezone, options) {
        if (options === void 0) options = {};
        var date = new Date(timestamp);
        var dtf = $fe36b0ee5c104cfd$var$getDateTimeFormat(timezone, options);
        return dtf.formatToParts(date);
    };
    var tzOffset = function tzOffset(timestamp, timezone) {
        var formatResult = makeFormatParts(timestamp, timezone);
        var filled = [];
        for(var i = 0; i < formatResult.length; i += 1){
            var _formatResult$i = formatResult[i], type = _formatResult$i.type, value = _formatResult$i.value;
            var pos = $fe36b0ee5c104cfd$var$typeToPos[type];
            if (pos >= 0) filled[pos] = parseInt(value, 10);
        }
        var hour = filled[3]; // Workaround for the same behavior in different node version
        // https://github.com/nodejs/node/issues/33027
        /* istanbul ignore next */ var fixedHour = hour === 24 ? 0 : hour;
        var utcString = filled[0] + "-" + filled[1] + "-" + filled[2] + " " + fixedHour + ":" + filled[4] + ":" + filled[5] + ":000";
        var utcTs = d.utc(utcString).valueOf();
        var asTS = +timestamp;
        var over = asTS % 1000;
        asTS -= over;
        return (utcTs - asTS) / 60000;
    }; // find the right offset a given local time. The o input is our guess, which determines which
    // offset we'll pick in ambiguous cases (e.g. there are two 3 AMs b/c Fallback DST)
    // https://github.com/moment/luxon/blob/master/src/datetime.js#L76
    var fixOffset = function fixOffset(localTS, o0, tz) {
        // Our UTC time is just a guess because our offset is just a guess
        var utcGuess = localTS - o0 * 60000; // Test whether the zone matches the offset for this ts
        var o2 = tzOffset(utcGuess, tz); // If so, offset didn't change and we're done
        if (o0 === o2) return [
            utcGuess,
            o0
        ];
         // If not, change the ts by the difference in the offset
        utcGuess -= (o2 - o0) * 60000; // If that gives us the local time we want, we're done
        var o3 = tzOffset(utcGuess, tz);
        if (o2 === o3) return [
            utcGuess,
            o2
        ];
         // If it's different, we're in a hole time.
        // The offset has changed, but the we don't adjust the time
        return [
            localTS - Math.min(o2, o3) * 60000,
            Math.max(o2, o3)
        ];
    };
    var proto = c.prototype;
    proto.tz = function(timezone, keepLocalTime) {
        if (timezone === void 0) timezone = defaultTimezone;
        var oldOffset = this.utcOffset();
        var date = this.toDate();
        var target = date.toLocaleString("en-US", {
            timeZone: timezone
        });
        var diff = Math.round((date - new Date(target)) / 1000 / 60);
        var ins = d(target, {
            locale: this.$L
        }).$set((0, $f130d2306183d8d9$export$71ad59f2e432cfe8), this.$ms).utcOffset(-Math.round(date.getTimezoneOffset() / 15) * 15 - diff, true);
        if (keepLocalTime) {
            var newOffset = ins.utcOffset();
            ins = ins.add(oldOffset - newOffset, (0, $f130d2306183d8d9$export$85fbf3b9d951b785));
        }
        ins.$x.$timezone = timezone;
        return ins;
    };
    proto.offsetName = function(type) {
        // type: short(default) / long
        var zone = this.$x.$timezone || d.tz.guess();
        var result = makeFormatParts(this.valueOf(), zone, {
            timeZoneName: type
        }).find(function(m) {
            return m.type.toLowerCase() === "timezonename";
        });
        return result && result.value;
    };
    var oldStartOf = proto.startOf;
    proto.startOf = function(units, startOf) {
        if (!this.$x || !this.$x.$timezone) return oldStartOf.call(this, units, startOf);
        var withoutTz = d(this.format("YYYY-MM-DD HH:mm:ss:SSS"), {
            locale: this.$L
        });
        var startOfWithoutTz = oldStartOf.call(withoutTz, units, startOf);
        return startOfWithoutTz.tz(this.$x.$timezone, true);
    };
    d.tz = function(input, arg1, arg2) {
        var parseFormat = arg2 && arg1;
        var timezone = arg2 || arg1 || defaultTimezone;
        var previousOffset = tzOffset(+d(), timezone);
        if (typeof input !== "string") // timestamp number || js Date || Day.js
        return d(input).tz(timezone);
        var localTs = d.utc(input, parseFormat).valueOf();
        var _fixOffset = fixOffset(localTs, previousOffset, timezone), targetTs = _fixOffset[0], targetOffset = _fixOffset[1];
        var ins = d(targetTs).utcOffset(targetOffset);
        ins.$x.$timezone = timezone;
        return ins;
    };
    d.tz.guess = function() {
        return Intl.DateTimeFormat().resolvedOptions().timeZone;
    };
    d.tz.setDefault = function(timezone) {
        defaultTimezone = timezone;
    };
};



var $ea71216ed545832a$export$2e2bcd8739ae039 = function(o, c) {
    // locale needed later
    var proto = c.prototype;
    var oldFormat = proto.format;
    proto.format = function(formatStr) {
        var _this = this;
        var locale = this.$locale();
        if (!this.isValid()) return oldFormat.bind(this)(formatStr);
        var utils = this.$utils();
        var str = formatStr || (0, $f130d2306183d8d9$export$43dfb2cd49ed2315);
        var result = str.replace(/\[([^\]]+)]|Q|wo|ww|w|WW|W|zzz|z|gggg|GGGG|Do|X|x|k{1,2}|S/g, function(match) {
            switch(match){
                case "Q":
                    return Math.ceil((_this.$M + 1) / 3);
                case "Do":
                    return locale.ordinal(_this.$D);
                case "gggg":
                    return _this.weekYear();
                case "GGGG":
                    return _this.isoWeekYear();
                case "wo":
                    return locale.ordinal(_this.week(), "W");
                // W for week
                case "w":
                case "ww":
                    return utils.s(_this.week(), match === "w" ? 1 : 2, "0");
                case "W":
                case "WW":
                    return utils.s(_this.isoWeek(), match === "W" ? 1 : 2, "0");
                case "k":
                case "kk":
                    return utils.s(String(_this.$H === 0 ? 24 : _this.$H), match === "k" ? 1 : 2, "0");
                case "X":
                    return Math.floor(_this.$d.getTime() / 1000);
                case "x":
                    return _this.$d.getTime();
                case "z":
                    return "[" + _this.offsetName() + "]";
                case "zzz":
                    return "[" + _this.offsetName("long") + "]";
                default:
                    return match;
            }
        });
        return oldFormat.bind(this)(result);
    };
};


var $4d3e2442d19a711d$exports = {};








/*!
 * chartjs-adapter-dayjs v0.2.0
 * https://www.chartjs.org
 * (c) 2019 Chart.js Contributors
 * Released under the MIT license
 * Patched to include time zone information when formatting
 */ (function(global, factory) {
    factory((parcelRequire("6RNKk")), (parcelRequire("13Rru")), (parcelRequire("9vqIZ")), (parcelRequire("jr2jp")), (parcelRequire("kAJrR")), (parcelRequire("4yB7Z")), (parcelRequire("deM4B")), (parcelRequire("8a7Qn")));
})($4d3e2442d19a711d$exports, function(chart_js, dayjs, utc, dayjsTz, dayjsWeekday, advancedFormat, localizedFormat, weekOfYear) {
    "use strict";
    dayjs = dayjs && dayjs.hasOwnProperty("default") ? dayjs["default"] : dayjs;
    utc = utc && utc.hasOwnProperty("default") ? utc["default"] : utc;
    dayjsTz = dayjsTz && dayjsTz.hasOwnProperty("default") ? dayjsTz["default"] : dayjsTz;
    dayjsWeekday = dayjsWeekday && dayjsWeekday.hasOwnProperty("default") ? dayjsWeekday["default"] : dayjsWeekday;
    advancedFormat = advancedFormat && advancedFormat.hasOwnProperty("default") ? advancedFormat["default"] : advancedFormat;
    localizedFormat = localizedFormat && localizedFormat.hasOwnProperty("default") ? localizedFormat["default"] : localizedFormat;
    weekOfYear = weekOfYear && weekOfYear.hasOwnProperty("default") ? weekOfYear["default"] : weekOfYear;
    const FORMATS = {
        datetime: "MMM D, YYYY, h:mm:ss a",
        millisecond: "h:mm:ss.SSS a",
        second: "h:mm:ss a",
        minute: "h:mm a",
        hour: "hA",
        day: "MMM D",
        week: "ll",
        month: "MMM YYYY",
        quarter: "[Q]Q - YYYY",
        year: "YYYY"
    };
    chart_js._adapters._date.override({
        _id: "dayjs",
        /**
     * @private
     */ _create: function(time) {
            dayjs.extend(utc);
            return dayjs.utc(time);
        },
        formats: function() {
            return FORMATS;
        },
        parse: function(value, format) {
            dayjs.extend(utc);
            if (typeof value === "string" && typeof format === "string") value = dayjs.utc(value, format);
            else if (!(value instanceof dayjs)) value = dayjs.utc(value);
            return value.isValid() ? value.valueOf() : null;
        },
        format: function(time, format) {
            dayjs.extend(utc);
            dayjs.extend(dayjsTz);
            dayjs.extend(advancedFormat);
            dayjs.extend(localizedFormat);
            dayjs.extend(weekOfYear);
            return dayjs.tz ? dayjs.utc(time).tz(dayjs.tz.guess()).format(format) : dayjs.utc(time).format(format);
        },
        add: function(time, amount, unit) {
            dayjs.extend(utc);
            return dayjs.utc(time).add(amount, unit).valueOf();
        },
        diff: function(max, min, unit) {
            dayjs.extend(utc);
            return dayjs.utc(max).diff(dayjs(min), unit);
        },
        startOf: function(time, unit, weekday) {
            dayjs.extend(utc);
            dayjs.extend(dayjsWeekday);
            time = dayjs.utc(time);
            if (unit === "isoWeek") return time.weekday(weekday).valueOf();
            return time.startOf(unit).valueOf();
        },
        endOf: function(time, unit) {
            dayjs.extend(utc);
            return dayjs.utc(time).endOf(unit).valueOf();
        }
    });
});


(0, $89c314bed017fff5$export$2e2bcd8739ae039).extend((0, $db02270dd08a7866$export$2e2bcd8739ae039));
(0, $89c314bed017fff5$export$2e2bcd8739ae039).extend((0, $fe36b0ee5c104cfd$export$2e2bcd8739ae039));
(0, $89c314bed017fff5$export$2e2bcd8739ae039).extend((0, $ea71216ed545832a$export$2e2bcd8739ae039));
function $48196a6c42426844$export$a00e671a9b023575(rawData, duration, metrics, isSwell) {
    console.debug("generateChartConfig - " + JSON.stringify({
        duration: duration,
        metrics: metrics,
        isSwell: isSwell
    }));
    let m, yScales = {}, xScale = {
        display: true,
        type: "time",
        time: {
            unit: duration === 60 || duration === 36 ? "minute" : "hour",
            tooltipFormat: "DD/MM/YYYY\nHH[h]mm",
            displayFormats: {
                hour: "HH[h]mm",
                minute: "HH[h]mm",
                day: "ddd DD/MM [-] HH[h]mm"
            }
        },
        scaleLabel: {
            display: true
        },
        ticks: {
            source: "labels",
            includeBounds: false
        }
    };
    var cfg = {
        type: "line",
        data: $48196a6c42426844$var$generateChartData(rawData, metrics, isSwell, duration),
        options: {
            maintainAspectRatio: false,
            responsive: true,
            plugins: {
                tooltip: {
                    yAlign: "center",
                    caretPadding: 25,
                    callbacks: {
                        label: function(tooltipItem) {
                            if (tooltipItem.chart.canvas.id === "sensor_chart_wind") {
                                let value = parseInt(tooltipItem.formattedValue);
                                if (value < 0) value = value + 360;
                                return tooltipItem.dataset.label + " : " + (tooltipItem.dataset.label.indexOf("V") === 0 ? value.toString() + " nds" : (value % 360).toString() + "\xb0");
                            } else return tooltipItem.dataset.label + " : " + tooltipItem.formattedValue;
                        }
                    }
                }
            },
            transitions: {
                active: {
                    animation: {
                        duration: 0
                    }
                }
            },
            interaction: {
                mode: "index",
                intersect: false
            },
            radius: 0
        }
    };
    for(m = 0; m < metrics.length; m++)yScales["y" + (m === 0 ? "" : m)] = {
        type: "linear",
        display: true,
        scaleLabel: {
            display: true
        },
        ticks: {
            // major: {enabled: true},
            includeBounds: false,
            color: $48196a6c42426844$var$getMetricColor(metrics[m]),
            stepSize: $48196a6c42426844$var$getStepSizeY(metrics[m], duration),
            callback: $48196a6c42426844$var$labelWithUnit(metrics[m]),
            font: {
                size: 10
            }
        },
        position: m === 0 ? "left" : "right",
        grid: {
            display: true,
            drawBorder: true,
            drawOnChartArea: m === 0
        },
        ...$48196a6c42426844$var$scaleRange(metrics[m], duration, $48196a6c42426844$var$computeMinMax(cfg.data.datasets), isSwell)
    };
    cfg.options.scales = {
        x: xScale,
        ...yScales
    };
    return cfg;
}
function $48196a6c42426844$var$getMetricColor(metric) {
    return "#333"; //config.chartColors[metric].moy;
}
function $48196a6c42426844$var$labelWithUnit(metric) {
    return function(val) {
        let unit;
        if (metric === "ws") unit = " nds";
        else if (metric === "wd" || metric === "sd") {
            unit = "\xb0";
            val = val < 0 ? 360 + Math.round(val) : Math.round(val) % 360;
        } else if (metric === "t") {
            if (Math.abs(val) > 1 && Math.abs(val) < 10) val = val.toPrecision(2);
            else if (Math.abs(val) > 9) val = val.toPrecision(3);
            else val = val.toPrecision(2);
            val = Math.round(val);
            unit = " \xb0C";
        } else if (metric === "sh") unit = " m";
        else if (metric === "p") unit = " hPa";
        else if (metric === "wv") {
            val = val.toPrecision(1);
            unit = " m/s";
        } else if (metric === "sp") unit = " s";
        return val + unit;
    };
}
function $48196a6c42426844$var$generateChartData(rawData, fields, isSwell, duration) {
    console.debug("generateChartData");
    let graphDatasets = {}, graphTimestamps = [], d, prop, f, filledProps = [];
    const isSwellSensor = rawData[0]["sh"] && rawData[0]["sh"]["moy"];
    for (d of rawData){
        graphTimestamps.push(d.ts);
        for (f of fields){
            if (d[f]) for(prop in d[f]){
                graphDatasets[f + prop] = graphDatasets[f + prop] || {
                    label: $48196a6c42426844$var$graphDatasetLabel(f, prop, isSwell || Object.keys(d[f]).includes("sea"), isSwellSensor),
                    color: (0, $j5Ozl.config).chartColors[f][prop] || "#000000",
                    values: []
                };
                graphDatasets[f + prop].values.push({
                    x: (0, $89c314bed017fff5$export$2e2bcd8739ae039).unix(d.ts),
                    y: d[f][prop]
                });
                if (d[f][prop] && filledProps.indexOf(f + prop) === -1) filledProps.push(f + prop);
            }
        }
    }
    const emptyProps = Object.keys(graphDatasets).filter((f)=>filledProps.indexOf(f) === -1);
    for (const emptyProp of emptyProps)delete graphDatasets[emptyProp];
    let skippedTicks = isSwell ? 0 : duration === 60 ? 4 : 2;
    let hoverElt = document.createElement("IMG");
    hoverElt.src = (0, $j5Ozl.LayersIcons)["graph-cursor"];
    hoverElt.alt = "img";
    return {
        labels: graphTimestamps.map(function(ts) {
            if (isSwell) return (0, $89c314bed017fff5$export$2e2bcd8739ae039).unix(ts);
            else {
                let stepInSeconds = duration === 60 ? 600 : duration === 36 ? 1800 : 7200;
                return (0, $89c314bed017fff5$export$2e2bcd8739ae039).unix(ts - ts % stepInSeconds);
            }
        }).slice(skippedTicks),
        datasets: Object.keys(graphDatasets).map(function(ds, i) {
            return {
                ref: ds,
                label: graphDatasets[ds].label,
                data: graphDatasets[ds].values,
                borderColor: graphDatasets[ds].color,
                hidden: $48196a6c42426844$var$isLegendHidden(ds),
                fill: false,
                tension: 0.4,
                yAxisID: "y" + (fields.indexOf($48196a6c42426844$var$fieldRef(ds)) === 0 ? "" : fields.indexOf($48196a6c42426844$var$fieldRef(ds))),
                pointStyle: hoverElt,
                pointRadius: 0,
                pointHoverRadius: 2000,
                hoverBorderColor: "#333333"
            };
        })
    };
}
function $48196a6c42426844$var$isLegendHidden(type) {
    if (type === "wsmax" || type === "shmax") return false;
    return type.indexOf("moy") === -1;
}
function $48196a6c42426844$var$fieldRef(ref) {
    return ref.indexOf("w") === 0 || ref.indexOf("s") === 0 ? ref.substring(0, 2) : ref.substring(0, 1);
}
function $48196a6c42426844$var$computeMinMax(datasets) {
    let minMax = {}, dataset, datasetValues, field, min, max, med;
    for (dataset of datasets){
        field = $48196a6c42426844$var$fieldRef(dataset.ref);
        datasetValues = dataset.data.map(function(d) {
            return d.y;
        });
        min = Math.min(...datasetValues);
        max = Math.max(...datasetValues);
        if (!minMax[field]) minMax[field] = {};
        if (field === "wd") {
            med = (0, $274fc2d52d6925bb$export$2e2bcd8739ae039)(datasetValues);
            if (minMax[field]["med"]) minMax[field]["med"].push(med);
            else minMax[field]["med"] = [
                med
            ];
        }
        if (!minMax[field].min || min < minMax[field].min) minMax[field].min = min;
        if (!minMax[field].max || max > minMax[field].max) minMax[field].max = max;
    }
    return minMax;
}
function $48196a6c42426844$var$scaleRange(field, duration, minMax, isSwell) {
    let range, absMin, absMax, sMin, sMax, scaleRng = {};
    if (field === "wv") scaleRng = {
        min: -5,
        max: 5
    };
    else if (field === "sp") scaleRng = {
        min: 0,
        max: 30
    };
    else if (field === "sd") scaleRng = {
        min: 0,
        max: 360
    };
    else if (field === "sh") {
        range = 10;
        sMin = minMax[field].min;
        sMax = minMax[field].max;
        scaleRng = {
            min: Math.max(0, Math.round((sMin + sMax - range) / 2)),
            max: Math.max(10, Math.round((sMin + sMax + range) / 2))
        };
    } else if (field === "t") {
        console.debug("minMax t: " + JSON.stringify(minMax[field]));
        if (isSwell) range = 10;
        else range = 20;
        sMin = minMax[field].min;
        sMax = minMax[field].max;
        scaleRng = {
            min: Math.round((sMin + sMax - range) / 2),
            max: Math.round((sMin + sMax + range) / 2)
        };
    } else if (field === "p") {
        range = 20;
        sMin = minMax[field].min;
        sMax = minMax[field].max;
        scaleRng = {
            min: Math.round((sMin + sMax - range) / 2),
            max: Math.round((sMin + sMax + range) / 2)
        };
    } else if (field === "wd") {
        let med = (0, $49c34f71c88d6b5e$export$2e2bcd8739ae039)(minMax[field].med), amplitude = duration === 144 ? 400 : 200;
        scaleRng = {
            min: Math.round((med - amplitude / 2) / 10) * 10,
            max: med + amplitude / 2
        };
    } else if (field === "ws") {
        if (duration === 60 || duration === 36 || duration === 144) {
            range = duration === 144 ? 70 : 40;
            absMin = 0;
            absMax = 200;
            sMin = Math.max(absMin, minMax[field].min);
            sMax = Math.min(absMax, minMax[field].max);
            scaleRng = {
                min: (sMin + sMax - range) / 2 < absMin ? absMin : Math.round((sMin + sMax - range) / 2),
                max: (sMin + sMax - range) / 2 < absMin ? range : Math.round((sMin + sMax + range) / 2)
            };
        }
    }
    // console.log('computed scale range - field : ' + field + ' - duration : ' + duration + ' - minMax : ' +
    //   JSON.stringify(minMax) + ' - isSwell : ' + isSwell + ' - scale range : ' + JSON.stringify(scaleRng));
    return scaleRng;
}
function $48196a6c42426844$var$getStepSizeY(metrics, duration) {
    if (metrics === "t" || metrics === "p" || metrics === "wv") return 1;
    else if (metrics === "t") return 4;
    else if (metrics === "ws") return duration < 144 ? 2 : 4;
    else if (metrics === "sd") return 20;
    else if (metrics === "wd") {
        if (duration === 60 || duration === 36) return 10;
        else if (duration === 144) return 20;
    }
}
function $48196a6c42426844$var$positiveValue(rawData) {
    for(let d = 0; d < rawData.length; d++){
        if (rawData[d]["wd"].moy < 0) rawData[d]["wd"].moy = rawData[d]["wd"].moy + 360;
        if (rawData[d]["wd"].min < 0) rawData[d]["wd"].min = rawData[d]["wd"].min + 360;
        if (rawData[d]["wd"].max < 0) rawData[d]["wd"].max = rawData[d]["wd"].max + 360;
    }
    return rawData;
}
function $48196a6c42426844$var$graphDatasetLabel(field, prop, isSeaTemp, isSwellSensor) {
    if (field === "ws") return "V. " + prop + "";
    else if (field === "wd") return "Dir. " + prop + "";
    else if (field === "wv") return "V. vert.";
    else if (field === "t") {
        if (prop === "dew") return "Point de ros\xe9e / Dew point";
        else if (prop === "sea") return "T\xb0 mer \xe0 2m sous la surface";
        else return "T\xb0 " + (isSeaTemp ? `mer (${isSwellSensor ? "\xe0 40cm" : "\xe0 2m"} sous la surface)` : "air");
    } else if (field === "sh") return "Hauteur de la houle " + prop + "";
    else if (field === "sp") return "P\xe9riode de la houle " + prop + "";
    else if (field === "p") return "Pression atmosph\xe9rique";
    else if (field === "sd") return "Direction de la houle";
    else return prop;
}
function $48196a6c42426844$var$chartTitle(metric) {
    if (metric === "ws") return "Vitesse du vent";
    else if (metric === "wd") return "Direction du vent";
    else if (metric === "wv") return "Vitesse verticale du vent";
    else if (metric === "t") return "Temp\xe9rature de l'air";
    else if (metric === "p") return "Pression atmosph\xe9rique";
    else return metric;
}




(0, $6RNKk.Chart).register(...(0, $6RNKk.registerables));
(0, $2782a71b73f5c155$export$cacc2a877598679f).prototype.options.iconUrl = (0, $j5Ozl.LayersIcons)["marker-icon"];
(0, $2782a71b73f5c155$export$cacc2a877598679f).prototype.options.iconRetinaUrl = (0, $j5Ozl.LayersIcons)["marker-icon-2x"];
(0, $2782a71b73f5c155$export$cacc2a877598679f).prototype.options.shadowUrl = (0, $j5Ozl.LayersIcons)["marker-shadow"];
function $418aca01110c9e5e$export$aadaa5940712eda(evt, d, onClose = null) {
    if (evt) {
        evt.preventDefault();
        evt.stopPropagation();
    }
    console.debug("sensorDetails:" + d.category);
    let sensor = (0, $j5Ozl.sensorsRefs)[d.nid] || (0, $j5Ozl.waveSensorsRefs)[d.nid] || (0, $j5Ozl.tempSensorsRefs)[d.nid];
    document.querySelector("#map_modal").setAttribute("data-modal", "wind_sensor");
    document.querySelector("#map_modal_title").innerHTML = sensor.label + "<span>Observations</span>";
    document.querySelector("#map_modal #header_links").innerHTML = $418aca01110c9e5e$var$renderLinks(sensor, "header");
    document.querySelector("#map_modal_content").innerHTML = '<section><div id="charts_actions"><button type="button" onclick="wm.displaySensorCharts(this, ' + d.nid + ", '" + d.category + '\', 120, 60);" class="active">2 derni\xe8res heures</button>' + '<button type="button" onclick="wm.displaySensorCharts(this, ' + d.nid + ", '" + d.category + "', 600, 36);\">Graphique 6h</button>" + '<button type="button" onclick="wm.displaySensorCharts(this, ' + d.nid + ", '" + d.category + "', 600, 144);\">Graphique 24h</button>" + '<button type="button" onclick="wm.displaySensorCharts(this, ' + d.nid + ", '" + d.category + "', 600, 1152);\">8 derniers jours</button>" + "</div>" + '<div id="charts_wrapper"></div>' + "</section>" + "<aside>" + $418aca01110c9e5e$var$renderAside(sensor) + "</aside>";
    const opts = onClose ? {
        disableScroll: true,
        onClose: onClose
    } : {
        disableScroll: true
    };
    (0, $dnPBs.default).show("map_modal", opts);
    $418aca01110c9e5e$export$af377084b1bb65fd(null, d.nid, d.category, 120, 60);
    // initAsideMap();
    $418aca01110c9e5e$var$initAsideSlides();
}
function $418aca01110c9e5e$export$af377084b1bb65fd(btn, sensorId, sensorCategory, period, duration) {
    document.querySelector("#map_modal_content #charts_wrapper").innerHTML = '<p class="loading">Chargement des donn\xe9es en cours...</p>';
    let isSwell = (0, $j5Ozl.waveSensorsRefs)[sensorId], apiDuration;
    // if (sensorId === 7557) {
    //  apiDuration = duration === 60 ? 2 : (duration === 36 ? 3 : duration === 1152 ? 40 : 5);
    // } else {
    //   apiDuration = duration;
    // }
    if ($418aca01110c9e5e$var$isNewGeneration(sensorId, sensorCategory)) (0, $5ewvA.getAsync)(`https://backend.windmorbihan.com/observations/chart.json?sensor=${sensorId}&time_frame=${duration}`, (resp)=>$418aca01110c9e5e$var$processChartData(resp, sensorId, sensorCategory, duration, isSwell));
    else (0, $5ewvA.postAsync)("https://private1.windmorbihan.com/mesures/get_graph_sensor_data", "settings[cid]=" + sensorId + "&settings[interval]=-1&settings[type]=" + (isSwell ? 0 : period) + "&settings[limit]=" + duration, (resp)=>$418aca01110c9e5e$var$processChartData(resp, sensorId, sensorCategory, duration, isSwell));
    if (btn) {
        let activeBtn = document.querySelector("#map_modal_content #charts_actions .active");
        if (activeBtn) activeBtn.classList.remove("active");
        btn.classList.add("active");
    }
}
function $418aca01110c9e5e$var$isNewGeneration(sensorId, sensorCategory) {
    return [
        "mf",
        "nke"
    ].includes(sensorCategory) || /^\d{1,4}$/.test(sensorId);
}
function $418aca01110c9e5e$var$processChartData(resp, sensorId, sensorCategory, duration, isSwell) {
    console.debug("processChartData");
    let data = $418aca01110c9e5e$var$isNewGeneration(sensorId, sensorCategory) ? resp : JSON.parse(resp).reverse(), ctx, i, windMetrics = [
        "ws",
        "wd"
    ], otherMetrics = isSwell ? [
        "sh",
        "sp",
        "sd",
        "t"
    ] : [
        "t",
        "sh",
        "sp",
        "sd",
        "wv",
        "p"
    ];
    const windData = $418aca01110c9e5e$var$cleanUpDataset(data.filter((d)=>d?.ws?.moy), sensorId), otherData = data.filter((d)=>!d?.ws?.moy);
    let rawData = [
        ...windData,
        ...otherData
    ];
    if (rawData && rawData.length) {
        if (document.querySelector(".radio-container")) document.querySelector(".radio-container").remove();
        document.querySelector("#map_modal_content #charts_wrapper").innerHTML = "";
        if (duration === 1152) {
            let seperateData = $418aca01110c9e5e$var$generateSeperateChartData(rawData);
            let separateAvailableMetrics = $418aca01110c9e5e$var$getseparateAvailableMetrics(seperateData, windMetrics, otherMetrics);
            $418aca01110c9e5e$var$generateRadioCollection(seperateData, separateAvailableMetrics, isSwell, otherMetrics);
            let radioCollectionList = document.querySelectorAll(".radio-container_item input");
            $418aca01110c9e5e$var$initChart(radioCollectionList, seperateData, separateAvailableMetrics, isSwell, otherMetrics);
        } else {
            let availableMetrics = $418aca01110c9e5e$var$getAvailableMetric(rawData, windMetrics, otherMetrics);
            let availWindMetrics = availableMetrics[0];
            let availOtherMetrics = availableMetrics[1];
            let m = availableMetrics[2];
            if (availWindMetrics.length) {
                document.querySelector("#map_modal_content #charts_wrapper").insertAdjacentHTML("beforeend", '<div class="chart_container"><canvas id="sensor_chart_wind"></canvas></div>');
                ctx = document.getElementById("sensor_chart_wind").getContext("2d");
                new (0, $6RNKk.Chart)(ctx, (0, $48196a6c42426844$export$a00e671a9b023575)($418aca01110c9e5e$export$4e89807aca88641f(windData, 360), duration, availWindMetrics, isSwell));
            }
            if (availOtherMetrics.length) {
                let sortedOther = availOtherMetrics.sort(function(m) {
                    return otherMetrics.indexOf(m);
                });
                for (m of availOtherMetrics){
                    document.querySelector("#map_modal_content #charts_wrapper").insertAdjacentHTML("beforeend", '<div class="chart_container"><canvas id="sensor_chart_' + m + '"></canvas></div>');
                    ctx = document.getElementById("sensor_chart_" + m).getContext("2d");
                    new (0, $6RNKk.Chart)(ctx, (0, $48196a6c42426844$export$a00e671a9b023575)(otherData, duration, [
                        m
                    ], isSwell));
                }
            }
        }
    }
}
/* ------ get available metric ------*/ function $418aca01110c9e5e$var$getseparateAvailableMetrics(seperateData, windMetrics, otherMetrics) {
    let separateAvailableMetrics = {};
    for(let s in seperateData){
        if (!separateAvailableMetrics[s]) separateAvailableMetrics[s] = [];
        let availableMetrics = $418aca01110c9e5e$var$getAvailableMetric(seperateData[s], windMetrics, otherMetrics);
        separateAvailableMetrics[s].push(availableMetrics);
    }
    return separateAvailableMetrics;
}
function $418aca01110c9e5e$var$getAvailableMetric(rawData, windMetrics, otherMetrics) {
    let availableMetrics = Object.keys(rawData[0]), availWindMetrics = [], availOtherMetrics = [], m;
    for (m of availableMetrics){
        if (windMetrics.indexOf(m) !== -1 && (Object.values(rawData[0][m])[0] || Object.values(rawData[rawData.length - 1][m])[0])) availWindMetrics.push(m);
        else if (otherMetrics.indexOf(m) !== -1 && (Object.values(rawData[0][m])[0] || Object.values(rawData[rawData.length - 1][m])[0]) && $418aca01110c9e5e$var$isRealisticValue(m, Object.values(rawData[0][m])[0])) availOtherMetrics.push(m);
    }
    return [
        availWindMetrics,
        availOtherMetrics,
        m
    ];
}
function $418aca01110c9e5e$var$isRealisticValue(metric, value) {
    if (metric === "t" && parseInt(value) < -30) return false;
    return true;
}
/* ------ generate seperate dataset for 8 days view ------ */ function $418aca01110c9e5e$var$generateSeperateChartData(rawData) {
    let today = (0, $89c314bed017fff5$export$2e2bcd8739ae039)();
    let todayFormated = today.format("ddd DD/MM");
    let lastDate = today.subtract(7, "day");
    let lastDateTS = lastDate.format("x");
    let radioCollectionData = {};
    for(let i = 0; i < rawData.length; i++)if (rawData[i]["ts"] * 1000 > lastDateTS) {
        let formatedDate = (0, $89c314bed017fff5$export$2e2bcd8739ae039).unix(rawData[i]["ts"]).format("ddd DD/MM");
        if (formatedDate !== todayFormated) {
            if (!radioCollectionData[formatedDate]) radioCollectionData[formatedDate] = [];
            radioCollectionData[formatedDate].push(rawData[i]);
        }
    }
    return radioCollectionData;
}
/* ------ Generate chart  ------*/ function $418aca01110c9e5e$var$initChart(radioCollectionList, seperateData, separateAvailableMetrics, isSwell, otherMetrics) {
    console.debug("initChart");
    for(let i = 0; i < radioCollectionList.length; i++)if (radioCollectionList[i].checked) {
        let availWindMetrics = separateAvailableMetrics[radioCollectionList[i].value][0][0];
        let availOtherMetrics = separateAvailableMetrics[radioCollectionList[i].value][0][1];
        let m = separateAvailableMetrics[radioCollectionList[i].value][0][2];
        if (availWindMetrics.length) {
            document.querySelector("#map_modal_content #charts_wrapper").insertAdjacentHTML("beforeend", '<div class="chart_container"><canvas id="sensor_chart_wind"></canvas></div>');
            let ctx = document.getElementById("sensor_chart_wind").getContext("2d");
            new (0, $6RNKk.Chart)(ctx, (0, $48196a6c42426844$export$a00e671a9b023575)($418aca01110c9e5e$export$4e89807aca88641f(seperateData[radioCollectionList[i].value], 360), 144, availWindMetrics, isSwell));
        }
        if (availOtherMetrics.length) {
            let sortedOther = availOtherMetrics.sort(function(m) {
                return otherMetrics.indexOf(m);
            });
            for (m of availOtherMetrics){
                document.querySelector("#map_modal_content #charts_wrapper").insertAdjacentHTML("beforeend", '<div class="chart_container"><canvas id="sensor_chart_' + m + '"></canvas></div>');
                let ctx = document.getElementById("sensor_chart_" + m).getContext("2d");
                new (0, $6RNKk.Chart)(ctx, (0, $48196a6c42426844$export$a00e671a9b023575)(seperateData[radioCollectionList[i].value], 144, [
                    m
                ], isSwell));
            }
        }
    }
}
function $418aca01110c9e5e$var$generateSeperateChart(d, seperateData, separateAvailableMetrics, isSwell, otherMetrics) {
    let availWindMetrics = separateAvailableMetrics[0][0];
    let availOtherMetrics = separateAvailableMetrics[0][1];
    let m = separateAvailableMetrics[0][2];
    if (availWindMetrics.length) {
        document.querySelector("#map_modal_content #charts_wrapper").insertAdjacentHTML("beforeend", '<div class="chart_container"><canvas id="sensor_chart_wind"></canvas></div>');
        let ctx = document.getElementById("sensor_chart_wind").getContext("2d");
        new (0, $6RNKk.Chart)(ctx, (0, $48196a6c42426844$export$a00e671a9b023575)($418aca01110c9e5e$export$4e89807aca88641f(seperateData[d], 360), 144, availWindMetrics, isSwell));
    }
    if (availOtherMetrics.length) {
        let sortedOther = availOtherMetrics.sort(function(m) {
            return otherMetrics.indexOf(m);
        });
        for (m of availOtherMetrics){
            document.querySelector("#map_modal_content #charts_wrapper").insertAdjacentHTML("beforeend", '<div class="chart_container"><canvas id="sensor_chart_' + m + '"></canvas></div>');
            let ctx = document.getElementById("sensor_chart_" + m).getContext("2d");
            new (0, $6RNKk.Chart)(ctx, (0, $48196a6c42426844$export$a00e671a9b023575)(seperateData[d], 144, [
                m
            ], isSwell));
        }
    }
}
/* ------ Generate radio collection  ------*/ function $418aca01110c9e5e$var$generateRadioCollection(data, separateAvailableMetrics, isSwell, otherMetrics) {
    let radioListContainer = $418aca01110c9e5e$var$generateRadioCollectionContainer();
    for(let d in data){
        let radioContainer = $418aca01110c9e5e$var$generateRadioContainer(radioListContainer, d);
        $418aca01110c9e5e$var$generateRadioInput(radioContainer, d, data, separateAvailableMetrics[d], isSwell, otherMetrics);
        $418aca01110c9e5e$var$generateRadioLabel(radioContainer, d);
    }
    $418aca01110c9e5e$var$reverseChildren(radioListContainer);
    let firstRadio = radioListContainer.firstChild;
    let firstRadioInput = firstRadio.querySelector("input");
    firstRadioInput.checked = true;
}
function $418aca01110c9e5e$var$generateRadioCollectionContainer() {
    let div = document.createElement("div");
    div.classList.add("radio-container");
    let container = document.querySelector("#charts_actions");
    return container.parentNode.insertBefore(div, container.nextSibling);
}
function $418aca01110c9e5e$var$generateRadioContainer(radioListContainer, d) {
    let radioContainer = document.createElement("div");
    radioContainer.classList.add("radio-container_item");
    radioContainer.id = "container-" + d;
    radioListContainer.append(radioContainer);
    return radioContainer;
}
function $418aca01110c9e5e$var$generateRadioInput(radioContainer, d, data, separateAvailableMetrics, isSwell, otherMetrics) {
    let radioInput = document.createElement("input");
    radioInput.id = "input-" + d.replace(/\s|\.|\//g, "");
    radioInput.type = "radio";
    radioInput.name = "date";
    radioInput.value = d;
    radioInput.onclick = function(event) {
        let lastCanvasList = document.querySelectorAll(".chart_container");
        for(let i = 0; i < lastCanvasList.length; i++)lastCanvasList[i].remove();
        $418aca01110c9e5e$var$generateSeperateChart(d, data, separateAvailableMetrics, isSwell, otherMetrics);
    };
    radioContainer.append(radioInput);
}
function $418aca01110c9e5e$var$generateRadioLabel(radioContainer, d) {
    let radioLabel = document.createElement("label");
    radioLabel.id = "label-" + d.replace(/\s|\.|\//g, "");
    radioLabel.setAttribute("for", "input-" + d.replace(/\s|\.|\//g, ""));
    radioLabel.innerHTML = d;
    radioContainer.append(radioLabel);
}
function $418aca01110c9e5e$var$reverseChildren(parent) {
    for(let i = 1; i < parent.childNodes.length; i++)parent.insertBefore(parent.childNodes[i], parent.firstChild);
}
function $418aca01110c9e5e$var$cleanUpDataset(data, sensorId) {
    let dataset = $418aca01110c9e5e$var$cleanUpWindSpeedDataset(data, sensorId);
    return $418aca01110c9e5e$var$cleanUpWindDirectionDataset(dataset);
}
function $418aca01110c9e5e$var$cleanUpWindDirectionDataset(data) {
    console.debug("cleanUpWindDirectionDataset");
    let validData = [];
    for(let i = 0; i < data.length; i++)if (data[i]["wd"].min && data[i]["wd"].moy && data[i]["wd"].max || !data[i]["wd"].min && data[i]["wd"].moy && !data[i]["wd"].max) validData.push(data[i]);
    return validData;
}
function $418aca01110c9e5e$export$4e89807aca88641f(data, range) {
    let i, prevValue, valueDiff, field = "wd";
    if (data.length && data[0][field]) for(i = 0; i < data.length; i++){
        valueDiff = prevValue ? data[i][field].moy - prevValue : 0;
        if (Math.abs(valueDiff) > range / 2) {
            if (valueDiff > 0) // saut vers le haut : on decale les points suivants de "range" vers le bas (en detectant d'autres sauts s'il y en a)
            return [
                ...data.slice(0, i),
                ...$418aca01110c9e5e$export$4e89807aca88641f($418aca01110c9e5e$var$translatedValues(field, data.slice(i), -range), range)
            ];
            else // saut vers le bas : on decale les points suivants de "range" vers le haut (en detectant d'autres sauts s'il y en a)
            return [
                ...data.slice(0, i),
                ...$418aca01110c9e5e$export$4e89807aca88641f($418aca01110c9e5e$var$translatedValues(field, data.slice(i), range), range)
            ];
        }
        prevValue = data[i][field].moy;
    }
    return data;
}
function $418aca01110c9e5e$var$translatedValues(field, values, offset) {
    let i, translatedValues = [
        ...values
    ];
    for(i = 0; i < values.length; i++)translatedValues[i][field] = {
        min: Math.round(values[i][field].min + offset),
        moy: Math.round(values[i][field].moy + offset),
        max: Math.round(values[i][field].max + offset)
    };
    return translatedValues;
}
function $418aca01110c9e5e$var$cleanUpWindSpeedDataset(data, sensorId) {
    console.debug("cleanUpWindSpeedDataset");
    const validData = [], windSpeed = "ws", limitWindSpeed = 200, knotFactor = 1.94384;
    let previousWindSpeed = null;
    for(let i = 0; i < data.length; i++){
        // +(6.688687).toPrecision(2)
        if ([
            "73091306",
            "73091305"
        ].indexOf(sensorId.toString()) !== -1) {
            data[i][windSpeed].min = +(data[i][windSpeed].min * knotFactor).toFixed(1);
            data[i][windSpeed].moy = +(data[i][windSpeed].moy * knotFactor).toFixed(1);
            data[i][windSpeed].max = +(data[i][windSpeed].max * knotFactor).toFixed(1);
        }
        if (data[i][windSpeed].max.length === 0) validData.push(data[i]);
        if (previousWindSpeed == null) previousWindSpeed = data[i][windSpeed].max;
        if (data[i][windSpeed].max < 2 * previousWindSpeed && data[i][windSpeed].max < limitWindSpeed) {
            previousWindSpeed = data[i][windSpeed].max;
            validData.push(data[i]);
        } else previousWindSpeed = data[i][windSpeed].max;
    }
    return validData;
}
function $418aca01110c9e5e$var$renderLinks(sensor, section) {
    let linksMarkup = "", sectionLinks = (sensor.image_links_list || []).filter((l)=>l.section === section);
    if (sectionLinks.length) linksMarkup += $418aca01110c9e5e$var$renderSectionLinks("partners_links", sectionLinks);
    else if ((0, $j5Ozl.asides)[sensor.nid]) {
        for (let a of (0, $j5Ozl.asides)[sensor.nid])if (a.links) linksMarkup += '<div class="partners_links">' + a.links.map(function(l) {
            return '<a href="' + l.href + '" target="_blank"><img src="' + l.img + '" alt=""/></a>';
        }).join("") + "</div>";
    }
    return linksMarkup + '<button class="modal__close" aria-label="Fermer" data-micromodal-close></button>';
}
function $418aca01110c9e5e$var$renderSectionLinks(wrapperClass, sectionLinks) {
    return `<div class="${wrapperClass}">${sectionLinks.map((l)=>'<a href="' + l.link_url + '" target="_blank"><img src="' + l.image_url + '" alt=""/></a>').join("")}</div>`;
}
function $418aca01110c9e5e$var$renderAside(sensor) {
    let asideContent = "";
    if (sensor.description_content) asideContent += sensor.description_content;
    if (sensor.photos_list?.length) asideContent += `<div id="aside_slides">${sensor.photos_list.map((p)=>'<div><img src="' + p + '" alt=""/></div>').join("")}</div>`;
    const footerLinks = (sensor.image_links_list || []).filter((l)=>l.section === "footer");
    if (footerLinks.length) asideContent += $418aca01110c9e5e$var$renderSectionLinks("footer_links", footerLinks);
    if (sensor.validAngle && sensor.validAngle.filter((deg)=>deg > 0).length) {
        const [a1, a2, a3] = sensor.validAngle;
        let deventPie, pieSegments = [];
        if (a2) {
            if (a3) {
                for (const segment of [
                    [
                        a1,
                        a2,
                        "green"
                    ],
                    [
                        a2,
                        a3,
                        "orange"
                    ],
                    [
                        a3,
                        a1,
                        "red"
                    ]
                ])pieSegments.push(...$418aca01110c9e5e$var$pieSegment(segment[0], segment[1], segment[2]));
                pieSegments = pieSegments.sort((s1, s2)=>s1.from - s2.from).map((s)=>`${s.color} ${s.from}deg ${s.to}deg`).join(", ");
                deventPie = `<div class="devent_pie" style="border-radius: 100%; width: 180px; aspect-ratio: 1; background: conic-gradient(${pieSegments});"></div>`;
            } else {
                for (const segment of [
                    [
                        a1,
                        a2,
                        "green"
                    ],
                    [
                        a2,
                        a1,
                        "orange"
                    ]
                ])pieSegments.push(...$418aca01110c9e5e$var$pieSegment(segment[0], segment[1], segment[2]));
                pieSegments = pieSegments.sort((s1, s2)=>s1.from - s2.from).map((s)=>`${s.color} ${s.from}deg ${s.to}deg`).join(", ");
                deventPie = `<div class="devent_pie" style="border-radius: 100%; width: 180px; aspect-ratio: 1; background: conic-gradient(${pieSegments});"></div>`;
            }
        } else {
            for (const segment of [
                [
                    a1,
                    a3,
                    "green"
                ],
                [
                    a3,
                    a1,
                    "red"
                ]
            ])pieSegments.push(...$418aca01110c9e5e$var$pieSegment(segment[0], segment[1], segment[2]));
            pieSegments = pieSegments.sort((s1, s2)=>s1.from - s2.from).map((s)=>`${s.color} ${s.from}deg ${s.to}deg`).join(", ");
            deventPie = `<div class="devent_pie" style="border-radius: 100%; width: 180px; aspect-ratio: 1; background: conic-gradient(${pieSegments});"></div>`;
        }
        asideContent += '<section class="sensor_devent"><h2>Secteurs d\'utilisation</h2>' + deventPie + "<ul>" + "<li><strong>Vert</strong> : pas de d\xe9vent</li>" + "<li><strong>Rouge</strong> : d\xe9vent</li>" + "</ul>" + "<p>Dans le secteur rouge, le vent, perturb\xe9 par des obstacles, n\u2019est pas repr\xe9sentatif du vent sur le plan d\u2019eau. La fl\xe8che est gris\xe9e sur la carte.<br/><br/>" + "Le vent en hauteur est sup\xe9rieur au vent en surface (ce diff\xe9rentiel est d\u2019autant plus important que le vent est faible et que la masse d\u2019air est stable).</p>" + "</section>";
    }
    return asideContent;
}
function $418aca01110c9e5e$var$pieSegment(fromAngle, toAngle, color) {
    if (fromAngle <= toAngle) return [
        {
            from: fromAngle,
            to: toAngle,
            color: color
        }
    ];
    else return [
        {
            from: fromAngle,
            to: 0,
            color: color
        },
        {
            from: 0,
            to: toAngle,
            color: color
        }
    ];
}
function $418aca01110c9e5e$var$initAsideSlides() {
    var slidesElt = document.querySelector("#aside_slides");
    if (slidesElt) (0, $fOKLR.tns)({
        container: "#aside_slides",
        autoplay: true,
        controls: false,
        mode: "gallery"
    });
}



var $j5Ozl = parcelRequire("j5Ozl");

var $5ewvA = parcelRequire("5ewvA");



var $gYLTL = parcelRequire("gYLTL");



var $dnPBs = parcelRequire("dnPBs");
/*! shepherd.js 14.5.1 */ /**
 * Checks if `value` is classified as an `Element`.
 * @param value The param to check if it is an Element
 */ function $9f2dc49079b18fe5$var$isElement$1(value) {
    return value instanceof Element;
}
/**
 * Checks if `value` is classified as an `HTMLElement`.
 * @param value The param to check if it is an HTMLElement
 */ function $9f2dc49079b18fe5$var$isHTMLElement$1(value) {
    return value instanceof HTMLElement;
}
/**
 * Checks if `value` is classified as a `Function` object.
 * @param value The param to check if it is a function
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $9f2dc49079b18fe5$var$isFunction(value) {
    return typeof value === "function";
}
/**
 * Checks if `value` is classified as a `String` object.
 * @param value The param to check if it is a string
 */ function $9f2dc49079b18fe5$var$isString(value) {
    return typeof value === "string";
}
/**
 * Checks if `value` is undefined.
 * @param value The param to check if it is undefined
 */ function $9f2dc49079b18fe5$var$isUndefined(value) {
    return value === undefined;
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
class $9f2dc49079b18fe5$var$Evented {
    /**
   * Adds an event listener for the given event string.
   *
   * @param {string} event
   * @param {Function} handler
   * @param ctx
   * @param {boolean} once
   * @returns
   */ on(event, handler, ctx, once = false) {
        var _this$bindings$event;
        if ($9f2dc49079b18fe5$var$isUndefined(this.bindings)) this.bindings = {};
        if ($9f2dc49079b18fe5$var$isUndefined(this.bindings[event])) this.bindings[event] = [];
        (_this$bindings$event = this.bindings[event]) == null || _this$bindings$event.push({
            handler: handler,
            ctx: ctx,
            once: once
        });
        return this;
    }
    /**
   * Adds an event listener that only fires once for the given event string.
   *
   * @param {string} event
   * @param {Function} handler
   * @param ctx
   * @returns
   */ once(event, handler, ctx) {
        return this.on(event, handler, ctx, true);
    }
    /**
   * Removes an event listener for the given event string.
   *
   * @param {string} event
   * @param {Function} handler
   * @returns
   */ off(event, handler) {
        if ($9f2dc49079b18fe5$var$isUndefined(this.bindings) || $9f2dc49079b18fe5$var$isUndefined(this.bindings[event])) return this;
        if ($9f2dc49079b18fe5$var$isUndefined(handler)) delete this.bindings[event];
        else {
            var _this$bindings$event2;
            (_this$bindings$event2 = this.bindings[event]) == null || _this$bindings$event2.forEach((binding, index)=>{
                if (binding.handler === handler) {
                    var _this$bindings$event3;
                    (_this$bindings$event3 = this.bindings[event]) == null || _this$bindings$event3.splice(index, 1);
                }
            });
        }
        return this;
    }
    /**
   * Triggers an event listener for the given event string.
   *
   * @param {string} event
   * @returns
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    trigger(event, ...args) {
        if (!$9f2dc49079b18fe5$var$isUndefined(this.bindings) && this.bindings[event]) {
            var _this$bindings$event4;
            (_this$bindings$event4 = this.bindings[event]) == null || _this$bindings$event4.forEach((binding, index)=>{
                const { ctx: ctx, handler: handler, once: once } = binding;
                const context = ctx || this;
                handler.apply(context, args);
                if (once) {
                    var _this$bindings$event5;
                    (_this$bindings$event5 = this.bindings[event]) == null || _this$bindings$event5.splice(index, 1);
                }
            });
        }
        return this;
    }
}
function $9f2dc49079b18fe5$var$_extends() {
    return $9f2dc49079b18fe5$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $9f2dc49079b18fe5$var$_extends.apply(null, arguments);
}
function $9f2dc49079b18fe5$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}
/**
 * Special values that tell deepmerge to perform a certain action.
 */ const $9f2dc49079b18fe5$var$actions = {
    defaultMerge: Symbol("deepmerge-ts: default merge"),
    skip: Symbol("deepmerge-ts: skip")
};
$9f2dc49079b18fe5$var$actions.defaultMerge;
/**
 * The default function to update meta data.
 *
 * It doesn't update the meta data.
 */ function $9f2dc49079b18fe5$var$defaultMetaDataUpdater(previousMeta, metaMeta) {
    return metaMeta;
}
/**
 * The default function to filter values.
 *
 * It filters out undefined values.
 */ function $9f2dc49079b18fe5$var$defaultFilterValues(values, meta) {
    return values.filter((value)=>value !== undefined);
}
/**
 * The different types of objects deepmerge-ts support.
 */ var $9f2dc49079b18fe5$var$ObjectType;
(function(ObjectType) {
    ObjectType[ObjectType["NOT"] = 0] = "NOT";
    ObjectType[ObjectType["RECORD"] = 1] = "RECORD";
    ObjectType[ObjectType["ARRAY"] = 2] = "ARRAY";
    ObjectType[ObjectType["SET"] = 3] = "SET";
    ObjectType[ObjectType["MAP"] = 4] = "MAP";
    ObjectType[ObjectType["OTHER"] = 5] = "OTHER";
})($9f2dc49079b18fe5$var$ObjectType || ($9f2dc49079b18fe5$var$ObjectType = {}));
/**
 * Get the type of the given object.
 *
 * @param object - The object to get the type of.
 * @returns The type of the given object.
 */ function $9f2dc49079b18fe5$var$getObjectType(object) {
    if (typeof object !== "object" || object === null) return 0 /* ObjectType.NOT */ ;
    if (Array.isArray(object)) return 2 /* ObjectType.ARRAY */ ;
    if ($9f2dc49079b18fe5$var$isRecord(object)) return 1 /* ObjectType.RECORD */ ;
    if (object instanceof Set) return 3 /* ObjectType.SET */ ;
    if (object instanceof Map) return 4 /* ObjectType.MAP */ ;
    return 5 /* ObjectType.OTHER */ ;
}
/**
 * Get the keys of the given objects including symbol keys.
 *
 * Note: Only keys to enumerable properties are returned.
 *
 * @param objects - An array of objects to get the keys of.
 * @returns A set containing all the keys of all the given objects.
 */ function $9f2dc49079b18fe5$var$getKeys(objects) {
    const keys = new Set();
    for (const object of objects)for (const key of [
        ...Object.keys(object),
        ...Object.getOwnPropertySymbols(object)
    ])keys.add(key);
    return keys;
}
/**
 * Does the given object have the given property.
 *
 * @param object - The object to test.
 * @param property - The property to test.
 * @returns Whether the object has the property.
 */ function $9f2dc49079b18fe5$var$objectHasProperty(object, property) {
    return typeof object === "object" && Object.prototype.propertyIsEnumerable.call(object, property);
}
/**
 * Get an iterable object that iterates over the given iterables.
 */ function $9f2dc49079b18fe5$var$getIterableOfIterables(iterables) {
    return {
        *[Symbol.iterator] () {
            for (const iterable of iterables)for (const value of iterable)yield value;
        }
    };
}
const $9f2dc49079b18fe5$var$validRecordToStringValues = new Set([
    "[object Object]",
    "[object Module]"
]);
/**
 * Does the given object appear to be a record.
 */ function $9f2dc49079b18fe5$var$isRecord(value) {
    // All records are objects.
    if (!$9f2dc49079b18fe5$var$validRecordToStringValues.has(Object.prototype.toString.call(value))) return false;
    const { constructor: constructor } = value;
    // If has modified constructor.
    // eslint-disable-next-line ts/no-unnecessary-condition
    if (constructor === undefined) return true;
    const prototype = constructor.prototype;
    // If has modified prototype.
    if (prototype === null || typeof prototype !== "object" || !$9f2dc49079b18fe5$var$validRecordToStringValues.has(Object.prototype.toString.call(prototype))) return false;
    // If constructor does not have an Object-specific method.
    // eslint-disable-next-line sonar/prefer-single-boolean-return, no-prototype-builtins
    if (!prototype.hasOwnProperty("isPrototypeOf")) return false;
    // Most likely a record.
    return true;
}
/**
 * The default strategy to merge records.
 *
 * @param values - The records.
 */ function $9f2dc49079b18fe5$var$mergeRecords$1(values, utils, meta) {
    const result = {};
    for (const key of $9f2dc49079b18fe5$var$getKeys(values)){
        const propValues = [];
        for (const value of values)if ($9f2dc49079b18fe5$var$objectHasProperty(value, key)) propValues.push(value[key]);
        if (propValues.length === 0) continue;
        const updatedMeta = utils.metaDataUpdater(meta, {
            key: key,
            parents: values
        });
        const propertyResult = $9f2dc49079b18fe5$var$mergeUnknowns(propValues, utils, updatedMeta);
        if (propertyResult === $9f2dc49079b18fe5$var$actions.skip) continue;
        if (key === "__proto__") Object.defineProperty(result, key, {
            value: propertyResult,
            configurable: true,
            enumerable: true,
            writable: true
        });
        else result[key] = propertyResult;
    }
    return result;
}
/**
 * The default strategy to merge arrays.
 *
 * @param values - The arrays.
 */ function $9f2dc49079b18fe5$var$mergeArrays$1(values) {
    return values.flat();
}
/**
 * The default strategy to merge sets.
 *
 * @param values - The sets.
 */ function $9f2dc49079b18fe5$var$mergeSets$1(values) {
    return new Set($9f2dc49079b18fe5$var$getIterableOfIterables(values));
}
/**
 * The default strategy to merge maps.
 *
 * @param values - The maps.
 */ function $9f2dc49079b18fe5$var$mergeMaps$1(values) {
    return new Map($9f2dc49079b18fe5$var$getIterableOfIterables(values));
}
/**
 * Get the last non-undefined value in the given array.
 */ function $9f2dc49079b18fe5$var$mergeOthers$1(values) {
    return values.at(-1);
}
/**
 * The merge functions.
 */ const $9f2dc49079b18fe5$var$mergeFunctions = {
    mergeRecords: $9f2dc49079b18fe5$var$mergeRecords$1,
    mergeArrays: $9f2dc49079b18fe5$var$mergeArrays$1,
    mergeSets: $9f2dc49079b18fe5$var$mergeSets$1,
    mergeMaps: $9f2dc49079b18fe5$var$mergeMaps$1,
    mergeOthers: $9f2dc49079b18fe5$var$mergeOthers$1
};
/**
 * Deeply merge objects.
 *
 * @param objects - The objects to merge.
 */ function $9f2dc49079b18fe5$var$deepmerge(...objects) {
    return $9f2dc49079b18fe5$var$deepmergeCustom({})(...objects);
}
function $9f2dc49079b18fe5$var$deepmergeCustom(options, rootMetaData) {
    const utils = $9f2dc49079b18fe5$var$getUtils(options, customizedDeepmerge);
    /**
   * The customized deepmerge function.
   */ function customizedDeepmerge(...objects) {
        return $9f2dc49079b18fe5$var$mergeUnknowns(objects, utils, rootMetaData);
    }
    return customizedDeepmerge;
}
/**
 * The the utils that are available to the merge functions.
 *
 * @param options - The options the user specified
 */ function $9f2dc49079b18fe5$var$getUtils(options, customizedDeepmerge) {
    var _options$metaDataUpda, _options$enableImplic, _options$filterValues;
    return {
        defaultMergeFunctions: $9f2dc49079b18fe5$var$mergeFunctions,
        mergeFunctions: $9f2dc49079b18fe5$var$_extends({}, $9f2dc49079b18fe5$var$mergeFunctions, Object.fromEntries(Object.entries(options).filter(([key, option])=>Object.hasOwn($9f2dc49079b18fe5$var$mergeFunctions, key)).map(([key, option])=>option === false ? [
                key,
                $9f2dc49079b18fe5$var$mergeFunctions.mergeOthers
            ] : [
                key,
                option
            ]))),
        metaDataUpdater: (_options$metaDataUpda = options.metaDataUpdater) != null ? _options$metaDataUpda : $9f2dc49079b18fe5$var$defaultMetaDataUpdater,
        deepmerge: customizedDeepmerge,
        useImplicitDefaultMerging: (_options$enableImplic = options.enableImplicitDefaultMerging) != null ? _options$enableImplic : false,
        filterValues: options.filterValues === false ? undefined : (_options$filterValues = options.filterValues) != null ? _options$filterValues : $9f2dc49079b18fe5$var$defaultFilterValues,
        actions: $9f2dc49079b18fe5$var$actions
    };
}
/**
 * Merge unknown things.
 *
 * @param values - The values.
 */ function $9f2dc49079b18fe5$var$mergeUnknowns(values, utils, meta) {
    var _utils$filterValues;
    const filteredValues = (_utils$filterValues = utils.filterValues == null ? void 0 : utils.filterValues(values, meta)) != null ? _utils$filterValues : values;
    if (filteredValues.length === 0) return undefined;
    if (filteredValues.length === 1) return $9f2dc49079b18fe5$var$mergeOthers(filteredValues, utils, meta);
    const type = $9f2dc49079b18fe5$var$getObjectType(filteredValues[0]);
    if (type !== 0 /* ObjectType.NOT */  && type !== 5 /* ObjectType.OTHER */ ) for(let m_index = 1; m_index < filteredValues.length; m_index++){
        if ($9f2dc49079b18fe5$var$getObjectType(filteredValues[m_index]) === type) continue;
        return $9f2dc49079b18fe5$var$mergeOthers(filteredValues, utils, meta);
    }
    switch(type){
        case 1 /* ObjectType.RECORD */ :
            return $9f2dc49079b18fe5$var$mergeRecords(filteredValues, utils, meta);
        case 2 /* ObjectType.ARRAY */ :
            return $9f2dc49079b18fe5$var$mergeArrays(filteredValues, utils, meta);
        case 3 /* ObjectType.SET */ :
            return $9f2dc49079b18fe5$var$mergeSets(filteredValues, utils, meta);
        case 4 /* ObjectType.MAP */ :
            return $9f2dc49079b18fe5$var$mergeMaps(filteredValues, utils, meta);
        default:
            return $9f2dc49079b18fe5$var$mergeOthers(filteredValues, utils, meta);
    }
}
/**
 * Merge records.
 *
 * @param values - The records.
 */ function $9f2dc49079b18fe5$var$mergeRecords(values, utils, meta) {
    const result = utils.mergeFunctions.mergeRecords(values, utils, meta);
    if (result === $9f2dc49079b18fe5$var$actions.defaultMerge || utils.useImplicitDefaultMerging && result === undefined && utils.mergeFunctions.mergeRecords !== utils.defaultMergeFunctions.mergeRecords) return utils.defaultMergeFunctions.mergeRecords(values, utils, meta);
    return result;
}
/**
 * Merge arrays.
 *
 * @param values - The arrays.
 */ function $9f2dc49079b18fe5$var$mergeArrays(values, utils, meta) {
    const result = utils.mergeFunctions.mergeArrays(values, utils, meta);
    if (result === $9f2dc49079b18fe5$var$actions.defaultMerge || utils.useImplicitDefaultMerging && result === undefined && utils.mergeFunctions.mergeArrays !== utils.defaultMergeFunctions.mergeArrays) return utils.defaultMergeFunctions.mergeArrays(values);
    return result;
}
/**
 * Merge sets.
 *
 * @param values - The sets.
 */ function $9f2dc49079b18fe5$var$mergeSets(values, utils, meta) {
    const result = utils.mergeFunctions.mergeSets(values, utils, meta);
    if (result === $9f2dc49079b18fe5$var$actions.defaultMerge || utils.useImplicitDefaultMerging && result === undefined && utils.mergeFunctions.mergeSets !== utils.defaultMergeFunctions.mergeSets) return utils.defaultMergeFunctions.mergeSets(values);
    return result;
}
/**
 * Merge maps.
 *
 * @param values - The maps.
 */ function $9f2dc49079b18fe5$var$mergeMaps(values, utils, meta) {
    const result = utils.mergeFunctions.mergeMaps(values, utils, meta);
    if (result === $9f2dc49079b18fe5$var$actions.defaultMerge || utils.useImplicitDefaultMerging && result === undefined && utils.mergeFunctions.mergeMaps !== utils.defaultMergeFunctions.mergeMaps) return utils.defaultMergeFunctions.mergeMaps(values);
    return result;
}
/**
 * Merge other things.
 *
 * @param values - The other things.
 */ function $9f2dc49079b18fe5$var$mergeOthers(values, utils, meta) {
    const result = utils.mergeFunctions.mergeOthers(values, utils, meta);
    if (result === $9f2dc49079b18fe5$var$actions.defaultMerge || utils.useImplicitDefaultMerging && result === undefined && utils.mergeFunctions.mergeOthers !== utils.defaultMergeFunctions.mergeOthers) return utils.defaultMergeFunctions.mergeOthers(values);
    return result;
}
/**
 * Binds all the methods on a JS Class to the `this` context of the class.
 * Adapted from https://github.com/sindresorhus/auto-bind
 * @param self The `this` context of the class
 * @return The `this` context of the class
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $9f2dc49079b18fe5$var$autoBind(self) {
    const keys = Object.getOwnPropertyNames(self.constructor.prototype);
    for(let i = 0; i < keys.length; i++){
        const key = keys[i];
        const val = self[key];
        if (key !== "constructor" && typeof val === "function") self[key] = val.bind(self);
    }
    return self;
}
/**
 * Sets up the handler to determine if we should advance the tour
 * @param step The step instance
 * @param selector
 * @private
 */ function $9f2dc49079b18fe5$var$_setupAdvanceOnHandler(step, selector) {
    return (event)=>{
        if (step.isOpen()) {
            const targetIsEl = step.el && event.currentTarget === step.el;
            const targetIsSelector = !$9f2dc49079b18fe5$var$isUndefined(selector) && event.currentTarget.matches(selector);
            if (targetIsSelector || targetIsEl) step.tour.next();
        }
    };
}
/**
 * Bind the event handler for advanceOn
 * @param step The step instance
 */ function $9f2dc49079b18fe5$var$bindAdvance(step) {
    // An empty selector matches the step element
    const { event: event, selector: selector } = step.options.advanceOn || {};
    if (event) {
        const handler = $9f2dc49079b18fe5$var$_setupAdvanceOnHandler(step, selector);
        // TODO: this should also bind/unbind on show/hide
        let el = null;
        if (!$9f2dc49079b18fe5$var$isUndefined(selector)) {
            el = document.querySelector(selector);
            if (!el) return console.error(`No element was found for the selector supplied to advanceOn: ${selector}`);
        }
        if (el) {
            el.addEventListener(event, handler);
            step.on("destroy", ()=>{
                return el.removeEventListener(event, handler);
            });
        } else {
            document.body.addEventListener(event, handler, true);
            step.on("destroy", ()=>{
                return document.body.removeEventListener(event, handler, true);
            });
        }
    } else return console.error("advanceOn was defined, but no event name was passed.");
}
class $9f2dc49079b18fe5$var$StepNoOp {
    constructor(_options){}
}
class $9f2dc49079b18fe5$var$TourNoOp {
    constructor(_tour, _options){}
}
/**
 * Ensure class prefix ends in `-`
 * @param prefix - The prefix to prepend to the class names generated by nano-css
 * @return The prefix ending in `-`
 */ function $9f2dc49079b18fe5$var$normalizePrefix(prefix) {
    if (!$9f2dc49079b18fe5$var$isString(prefix) || prefix === "") return "";
    return prefix.charAt(prefix.length - 1) !== "-" ? `${prefix}-` : prefix;
}
/**
 * Resolves attachTo options, converting element option value to a qualified HTMLElement.
 * @param step - The step instance
 * @returns {{}|{element, on}}
 * `element` is a qualified HTML Element
 * `on` is a string position value
 */ function $9f2dc49079b18fe5$var$parseAttachTo(step) {
    const options = step.options.attachTo || {};
    const returnOpts = Object.assign({}, options);
    if ($9f2dc49079b18fe5$var$isFunction(returnOpts.element)) // Bind the callback to step so that it has access to the object, to enable running additional logic
    returnOpts.element = returnOpts.element.call(step);
    if ($9f2dc49079b18fe5$var$isString(returnOpts.element)) {
        // Can't override the element in user opts reference because we can't
        // guarantee that the element will exist in the future.
        try {
            returnOpts.element = document.querySelector(returnOpts.element);
        } catch (e) {
        // TODO
        }
        if (!returnOpts.element) console.error(`The element for this Shepherd step was not found ${options.element}`);
    }
    return returnOpts;
}
/*
 * Resolves the step's `extraHighlights` option, converting any locator values to HTMLElements.
 */ function $9f2dc49079b18fe5$var$parseExtraHighlights(step) {
    if (step.options.extraHighlights) return step.options.extraHighlights.flatMap((highlight)=>{
        return Array.from(document.querySelectorAll(highlight));
    });
    return [];
}
/**
 * Checks if the step should be centered or not. Does not trigger attachTo.element evaluation, making it a pure
 * alternative for the deprecated step.isCentered() method.
 */ function $9f2dc49079b18fe5$var$shouldCenterStep(resolvedAttachToOptions) {
    if (resolvedAttachToOptions === undefined || resolvedAttachToOptions === null) return true;
    return !resolvedAttachToOptions.element || !resolvedAttachToOptions.on;
}
/**
 * Create a unique id for steps, tours, modals, etc
 */ function $9f2dc49079b18fe5$var$uuid() {
    let d = Date.now();
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c)=>{
        const r = (d + Math.random() * 16) % 16 | 0;
        d = Math.floor(d / 16);
        return (c == "x" ? r : r & 0x3 | 0x8).toString(16);
    });
}
/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */ const $9f2dc49079b18fe5$var$sides = [
    "top",
    "right",
    "bottom",
    "left"
];
const $9f2dc49079b18fe5$var$alignments = [
    "start",
    "end"
];
const $9f2dc49079b18fe5$var$placements = /*#__PURE__*/ $9f2dc49079b18fe5$var$sides.reduce((acc, side)=>acc.concat(side, side + "-" + $9f2dc49079b18fe5$var$alignments[0], side + "-" + $9f2dc49079b18fe5$var$alignments[1]), []);
const $9f2dc49079b18fe5$var$min = Math.min;
const $9f2dc49079b18fe5$var$max = Math.max;
const $9f2dc49079b18fe5$var$round = Math.round;
const $9f2dc49079b18fe5$var$floor = Math.floor;
const $9f2dc49079b18fe5$var$createCoords = (v)=>({
        x: v,
        y: v
    });
const $9f2dc49079b18fe5$var$oppositeSideMap = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
const $9f2dc49079b18fe5$var$oppositeAlignmentMap = {
    start: "end",
    end: "start"
};
function $9f2dc49079b18fe5$var$clamp(start, value, end) {
    return $9f2dc49079b18fe5$var$max(start, $9f2dc49079b18fe5$var$min(value, end));
}
function $9f2dc49079b18fe5$var$evaluate(value, param) {
    return typeof value === "function" ? value(param) : value;
}
function $9f2dc49079b18fe5$var$getSide(placement) {
    return placement.split("-")[0];
}
function $9f2dc49079b18fe5$var$getAlignment(placement) {
    return placement.split("-")[1];
}
function $9f2dc49079b18fe5$var$getOppositeAxis(axis) {
    return axis === "x" ? "y" : "x";
}
function $9f2dc49079b18fe5$var$getAxisLength(axis) {
    return axis === "y" ? "height" : "width";
}
function $9f2dc49079b18fe5$var$getSideAxis(placement) {
    return [
        "top",
        "bottom"
    ].includes($9f2dc49079b18fe5$var$getSide(placement)) ? "y" : "x";
}
function $9f2dc49079b18fe5$var$getAlignmentAxis(placement) {
    return $9f2dc49079b18fe5$var$getOppositeAxis($9f2dc49079b18fe5$var$getSideAxis(placement));
}
function $9f2dc49079b18fe5$var$getAlignmentSides(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $9f2dc49079b18fe5$var$getAlignment(placement);
    const alignmentAxis = $9f2dc49079b18fe5$var$getAlignmentAxis(placement);
    const length = $9f2dc49079b18fe5$var$getAxisLength(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === "x" ? alignment === (rtl ? "end" : "start") ? "right" : "left" : alignment === "start" ? "bottom" : "top";
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $9f2dc49079b18fe5$var$getOppositePlacement(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $9f2dc49079b18fe5$var$getOppositePlacement(mainAlignmentSide)
    ];
}
function $9f2dc49079b18fe5$var$getExpandedPlacements(placement) {
    const oppositePlacement = $9f2dc49079b18fe5$var$getOppositePlacement(placement);
    return [
        $9f2dc49079b18fe5$var$getOppositeAlignmentPlacement(placement),
        oppositePlacement,
        $9f2dc49079b18fe5$var$getOppositeAlignmentPlacement(oppositePlacement)
    ];
}
function $9f2dc49079b18fe5$var$getOppositeAlignmentPlacement(placement) {
    return placement.replace(/start|end/g, (alignment)=>$9f2dc49079b18fe5$var$oppositeAlignmentMap[alignment]);
}
function $9f2dc49079b18fe5$var$getSideList(side, isStart, rtl) {
    const lr = [
        "left",
        "right"
    ];
    const rl = [
        "right",
        "left"
    ];
    const tb = [
        "top",
        "bottom"
    ];
    const bt = [
        "bottom",
        "top"
    ];
    switch(side){
        case "top":
        case "bottom":
            if (rtl) return isStart ? rl : lr;
            return isStart ? lr : rl;
        case "left":
        case "right":
            return isStart ? tb : bt;
        default:
            return [];
    }
}
function $9f2dc49079b18fe5$var$getOppositeAxisPlacements(placement, flipAlignment, direction, rtl) {
    const alignment = $9f2dc49079b18fe5$var$getAlignment(placement);
    let list = $9f2dc49079b18fe5$var$getSideList($9f2dc49079b18fe5$var$getSide(placement), direction === "start", rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($9f2dc49079b18fe5$var$getOppositeAlignmentPlacement));
    }
    return list;
}
function $9f2dc49079b18fe5$var$getOppositePlacement(placement) {
    return placement.replace(/left|right|bottom|top/g, (side)=>$9f2dc49079b18fe5$var$oppositeSideMap[side]);
}
function $9f2dc49079b18fe5$var$expandPaddingObject(padding) {
    return $9f2dc49079b18fe5$var$_extends({
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    }, padding);
}
function $9f2dc49079b18fe5$var$getPaddingObject(padding) {
    return typeof padding !== "number" ? $9f2dc49079b18fe5$var$expandPaddingObject(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $9f2dc49079b18fe5$var$rectToClientRect(rect) {
    const { x: x, y: y, width: width, height: height } = rect;
    return {
        width: width,
        height: height,
        top: y,
        left: x,
        right: x + width,
        bottom: y + height,
        x: x,
        y: y
    };
}
const $9f2dc49079b18fe5$var$_excluded = [
    "crossAxis",
    "alignment",
    "allowedPlacements",
    "autoAlignment"
], $9f2dc49079b18fe5$var$_excluded2 = [
    "mainAxis",
    "crossAxis",
    "fallbackPlacements",
    "fallbackStrategy",
    "fallbackAxisSideDirection",
    "flipAlignment"
], $9f2dc49079b18fe5$var$_excluded4 = [
    "mainAxis",
    "crossAxis",
    "limiter"
];
function $9f2dc49079b18fe5$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const sideAxis = $9f2dc49079b18fe5$var$getSideAxis(placement);
    const alignmentAxis = $9f2dc49079b18fe5$var$getAlignmentAxis(placement);
    const alignLength = $9f2dc49079b18fe5$var$getAxisLength(alignmentAxis);
    const side = $9f2dc49079b18fe5$var$getSide(placement);
    const isVertical = sideAxis === "y";
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case "top":
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case "bottom":
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case "right":
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case "left":
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch($9f2dc49079b18fe5$var$getAlignment(placement)){
        case "start":
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case "end":
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $9f2dc49079b18fe5$var$computePosition$1 = async (reference, floating, config)=>{
    const { placement: placement = "bottom", strategy: strategy = "absolute", middleware: middleware = [], platform: platform } = config;
    const validMiddleware = middleware.filter(Boolean);
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $9f2dc49079b18fe5$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let middlewareData = {};
    let resetCount = 0;
    for(let i = 0; i < validMiddleware.length; i++){
        const { name: name, fn: fn } = validMiddleware[i];
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platform,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData = $9f2dc49079b18fe5$var$_extends({}, middlewareData, {
            [name]: $9f2dc49079b18fe5$var$_extends({}, middlewareData[name], data)
        });
        if (reset && resetCount <= 50) {
            resetCount++;
            if (typeof reset === "object") {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $9f2dc49079b18fe5$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $9f2dc49079b18fe5$var$detectOverflow(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
    const { boundary: boundary = "clippingAncestors", rootBoundary: rootBoundary = "viewport", elementContext: elementContext = "floating", altBoundary: altBoundary = false, padding: padding = 0 } = $9f2dc49079b18fe5$var$evaluate(options, state);
    const paddingObject = $9f2dc49079b18fe5$var$getPaddingObject(padding);
    const altContext = elementContext === "floating" ? "reference" : "floating";
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = $9f2dc49079b18fe5$var$rectToClientRect(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === "floating" ? {
        x: x,
        y: y,
        width: rects.floating.width,
        height: rects.floating.height
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = $9f2dc49079b18fe5$var$rectToClientRect(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        elements: elements,
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $9f2dc49079b18fe5$var$arrow$1 = (options)=>({
        name: "arrow",
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element: element, padding: padding = 0 } = $9f2dc49079b18fe5$var$evaluate(options, state) || {};
            if (element == null) return {};
            const paddingObject = $9f2dc49079b18fe5$var$getPaddingObject(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = $9f2dc49079b18fe5$var$getAlignmentAxis(placement);
            const length = $9f2dc49079b18fe5$var$getAxisLength(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === "y";
            const minProp = isYAxis ? "top" : "left";
            const maxProp = isYAxis ? "bottom" : "right";
            const clientProp = isYAxis ? "clientHeight" : "clientWidth";
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = $9f2dc49079b18fe5$var$min(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = $9f2dc49079b18fe5$var$min(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min$1 = minPadding;
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = $9f2dc49079b18fe5$var$clamp(min$1, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && $9f2dc49079b18fe5$var$getAlignment(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: $9f2dc49079b18fe5$var$_extends({
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset
                }, shouldAddOffset && {
                    alignmentOffset: alignmentOffset
                }),
                reset: shouldAddOffset
            };
        }
    });
function $9f2dc49079b18fe5$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>$9f2dc49079b18fe5$var$getAlignment(placement) === alignment),
        ...allowedPlacements.filter((placement)=>$9f2dc49079b18fe5$var$getAlignment(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>$9f2dc49079b18fe5$var$getSide(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return $9f2dc49079b18fe5$var$getAlignment(placement) === alignment || (autoAlignment ? $9f2dc49079b18fe5$var$getOppositeAlignmentPlacement(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $9f2dc49079b18fe5$var$autoPlacement$1 = function autoPlacement(options) {
    if (options === void 0) options = {};
    return {
        name: "autoPlacement",
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
            const _evaluate = $9f2dc49079b18fe5$var$evaluate(options, state), { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = $9f2dc49079b18fe5$var$placements, autoAlignment: autoAlignment = true } = _evaluate, detectOverflowOptions = $9f2dc49079b18fe5$var$_objectWithoutPropertiesLoose(_evaluate, $9f2dc49079b18fe5$var$_excluded);
            const placements$1 = alignment !== undefined || allowedPlacements === $9f2dc49079b18fe5$var$placements ? $9f2dc49079b18fe5$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await $9f2dc49079b18fe5$var$detectOverflow(state, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            const alignmentSides = $9f2dc49079b18fe5$var$getAlignmentSides(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const currentOverflows = [
                overflow[$9f2dc49079b18fe5$var$getSide(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = $9f2dc49079b18fe5$var$getAlignment(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                $9f2dc49079b18fe5$var$getAlignment(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $9f2dc49079b18fe5$var$flip$1 = function flip(options) {
    if (options === void 0) options = {};
    return {
        name: "flip",
        options: options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
            const _evaluate2 = $9f2dc49079b18fe5$var$evaluate(options, state), { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = "bestFit", fallbackAxisSideDirection: fallbackAxisSideDirection = "none", flipAlignment: flipAlignment = true } = _evaluate2, detectOverflowOptions = $9f2dc49079b18fe5$var$_objectWithoutPropertiesLoose(_evaluate2, $9f2dc49079b18fe5$var$_excluded2);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = $9f2dc49079b18fe5$var$getSide(placement);
            const initialSideAxis = $9f2dc49079b18fe5$var$getSideAxis(initialPlacement);
            const isBasePlacement = $9f2dc49079b18fe5$var$getSide(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                $9f2dc49079b18fe5$var$getOppositePlacement(initialPlacement)
            ] : $9f2dc49079b18fe5$var$getExpandedPlacements(initialPlacement));
            const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== "none";
            if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) fallbackPlacements.push(...$9f2dc49079b18fe5$var$getOppositeAxisPlacements(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await $9f2dc49079b18fe5$var$detectOverflow(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = $9f2dc49079b18fe5$var$getAlignmentSides(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) {
                    var _overflowsData$;
                    const ignoreCrossAxisOverflow = checkCrossAxis === "alignment" ? initialSideAxis !== $9f2dc49079b18fe5$var$getSideAxis(nextPlacement) : false;
                    const hasInitialMainAxisOverflow = ((_overflowsData$ = overflowsData[0]) == null ? void 0 : _overflowsData$.overflows[0]) > 0;
                    if (!ignoreCrossAxisOverflow || hasInitialMainAxisOverflow) // Try next placement and re-run the lifecycle.
                    return {
                        data: {
                            index: nextIndex,
                            overflows: overflowsData
                        },
                        reset: {
                            placement: nextPlacement
                        }
                    };
                }
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case "bestFit":
                        {
                            var _overflowsData$filter2;
                            const placement = (_overflowsData$filter2 = overflowsData.filter((d)=>{
                                if (hasFallbackAxisSideDirection) {
                                    const currentSideAxis = $9f2dc49079b18fe5$var$getSideAxis(d.placement);
                                    return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                                    // reading directions favoring greater width.
                                    currentSideAxis === "y";
                                }
                                return true;
                            }).map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case "initialPlacement":
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $9f2dc49079b18fe5$var$shift$1 = function shift(options) {
    if (options === void 0) options = {};
    return {
        name: "shift",
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement } = state;
            const _evaluate4 = $9f2dc49079b18fe5$var$evaluate(options, state), { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x, y: y } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            } } = _evaluate4, detectOverflowOptions = $9f2dc49079b18fe5$var$_objectWithoutPropertiesLoose(_evaluate4, $9f2dc49079b18fe5$var$_excluded4);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await $9f2dc49079b18fe5$var$detectOverflow(state, detectOverflowOptions);
            const crossAxis = $9f2dc49079b18fe5$var$getSideAxis($9f2dc49079b18fe5$var$getSide(placement));
            const mainAxis = $9f2dc49079b18fe5$var$getOppositeAxis(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === "y" ? "top" : "left";
                const maxSide = mainAxis === "y" ? "bottom" : "right";
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = $9f2dc49079b18fe5$var$clamp(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === "y" ? "top" : "left";
                const maxSide = crossAxis === "y" ? "bottom" : "right";
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = $9f2dc49079b18fe5$var$clamp(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn($9f2dc49079b18fe5$var$_extends({}, state, {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            }));
            return $9f2dc49079b18fe5$var$_extends({}, limitedCoords, {
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y,
                    enabled: {
                        [mainAxis]: checkMainAxis,
                        [crossAxis]: checkCrossAxis
                    }
                }
            });
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $9f2dc49079b18fe5$var$limitShift$1 = function limitShift(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
            const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = $9f2dc49079b18fe5$var$evaluate(options, state);
            const coords = {
                x: x,
                y: y
            };
            const crossAxis = $9f2dc49079b18fe5$var$getSideAxis(placement);
            const mainAxis = $9f2dc49079b18fe5$var$getOppositeAxis(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = $9f2dc49079b18fe5$var$evaluate(offset, state);
            const computedOffset = typeof rawOffset === "number" ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : $9f2dc49079b18fe5$var$_extends({
                mainAxis: 0,
                crossAxis: 0
            }, rawOffset);
            if (checkMainAxis) {
                const len = mainAxis === "y" ? "height" : "width";
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === "y" ? "width" : "height";
                const isOriginSide = [
                    "top",
                    "left"
                ].includes($9f2dc49079b18fe5$var$getSide(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
function $9f2dc49079b18fe5$var$hasWindow() {
    return typeof window !== "undefined";
}
function $9f2dc49079b18fe5$var$getNodeName(node) {
    if ($9f2dc49079b18fe5$var$isNode(node)) return (node.nodeName || "").toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return "#document";
}
function $9f2dc49079b18fe5$var$getWindow(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $9f2dc49079b18fe5$var$getDocumentElement(node) {
    var _ref;
    return (_ref = ($9f2dc49079b18fe5$var$isNode(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $9f2dc49079b18fe5$var$isNode(value) {
    if (!$9f2dc49079b18fe5$var$hasWindow()) return false;
    return value instanceof Node || value instanceof $9f2dc49079b18fe5$var$getWindow(value).Node;
}
function $9f2dc49079b18fe5$var$isElement(value) {
    if (!$9f2dc49079b18fe5$var$hasWindow()) return false;
    return value instanceof Element || value instanceof $9f2dc49079b18fe5$var$getWindow(value).Element;
}
function $9f2dc49079b18fe5$var$isHTMLElement(value) {
    if (!$9f2dc49079b18fe5$var$hasWindow()) return false;
    return value instanceof HTMLElement || value instanceof $9f2dc49079b18fe5$var$getWindow(value).HTMLElement;
}
function $9f2dc49079b18fe5$var$isShadowRoot(value) {
    if (!$9f2dc49079b18fe5$var$hasWindow() || typeof ShadowRoot === "undefined") return false;
    return value instanceof ShadowRoot || value instanceof $9f2dc49079b18fe5$var$getWindow(value).ShadowRoot;
}
function $9f2dc49079b18fe5$var$isOverflowElement(element) {
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $9f2dc49079b18fe5$var$getComputedStyle(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && ![
        "inline",
        "contents"
    ].includes(display);
}
function $9f2dc49079b18fe5$var$isTableElement(element) {
    return [
        "table",
        "td",
        "th"
    ].includes($9f2dc49079b18fe5$var$getNodeName(element));
}
function $9f2dc49079b18fe5$var$isTopLayer(element) {
    return [
        ":popover-open",
        ":modal"
    ].some((selector)=>{
        try {
            return element.matches(selector);
        } catch (e) {
            return false;
        }
    });
}
function $9f2dc49079b18fe5$var$isContainingBlock(elementOrCss) {
    const webkit = $9f2dc49079b18fe5$var$isWebKit();
    const css = $9f2dc49079b18fe5$var$isElement(elementOrCss) ? $9f2dc49079b18fe5$var$getComputedStyle(elementOrCss) : elementOrCss;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    // https://drafts.csswg.org/css-transforms-2/#individual-transforms
    return [
        "transform",
        "translate",
        "scale",
        "rotate",
        "perspective"
    ].some((value)=>css[value] ? css[value] !== "none" : false) || (css.containerType ? css.containerType !== "normal" : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== "none" : false) || !webkit && (css.filter ? css.filter !== "none" : false) || [
        "transform",
        "translate",
        "scale",
        "rotate",
        "perspective",
        "filter"
    ].some((value)=>(css.willChange || "").includes(value)) || [
        "paint",
        "layout",
        "strict",
        "content"
    ].some((value)=>(css.contain || "").includes(value));
}
function $9f2dc49079b18fe5$var$getContainingBlock(element) {
    let currentNode = $9f2dc49079b18fe5$var$getParentNode(element);
    while($9f2dc49079b18fe5$var$isHTMLElement(currentNode) && !$9f2dc49079b18fe5$var$isLastTraversableNode(currentNode)){
        if ($9f2dc49079b18fe5$var$isContainingBlock(currentNode)) return currentNode;
        else if ($9f2dc49079b18fe5$var$isTopLayer(currentNode)) return null;
        currentNode = $9f2dc49079b18fe5$var$getParentNode(currentNode);
    }
    return null;
}
function $9f2dc49079b18fe5$var$isWebKit() {
    if (typeof CSS === "undefined" || !CSS.supports) return false;
    return CSS.supports("-webkit-backdrop-filter", "none");
}
function $9f2dc49079b18fe5$var$isLastTraversableNode(node) {
    return [
        "html",
        "body",
        "#document"
    ].includes($9f2dc49079b18fe5$var$getNodeName(node));
}
function $9f2dc49079b18fe5$var$getComputedStyle(element) {
    return $9f2dc49079b18fe5$var$getWindow(element).getComputedStyle(element);
}
function $9f2dc49079b18fe5$var$getNodeScroll(element) {
    if ($9f2dc49079b18fe5$var$isElement(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.scrollX,
        scrollTop: element.scrollY
    };
}
function $9f2dc49079b18fe5$var$getParentNode(node) {
    if ($9f2dc49079b18fe5$var$getNodeName(node) === "html") return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $9f2dc49079b18fe5$var$isShadowRoot(node) && node.host || // Fallback.
    $9f2dc49079b18fe5$var$getDocumentElement(node);
    return $9f2dc49079b18fe5$var$isShadowRoot(result) ? result.host : result;
}
function $9f2dc49079b18fe5$var$getNearestOverflowAncestor(node) {
    const parentNode = $9f2dc49079b18fe5$var$getParentNode(node);
    if ($9f2dc49079b18fe5$var$isLastTraversableNode(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if ($9f2dc49079b18fe5$var$isHTMLElement(parentNode) && $9f2dc49079b18fe5$var$isOverflowElement(parentNode)) return parentNode;
    return $9f2dc49079b18fe5$var$getNearestOverflowAncestor(parentNode);
}
function $9f2dc49079b18fe5$var$getOverflowAncestors(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = $9f2dc49079b18fe5$var$getNearestOverflowAncestor(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $9f2dc49079b18fe5$var$getWindow(scrollableAncestor);
    if (isBody) {
        const frameElement = $9f2dc49079b18fe5$var$getFrameElement(win);
        return list.concat(win, win.visualViewport || [], $9f2dc49079b18fe5$var$isOverflowElement(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? $9f2dc49079b18fe5$var$getOverflowAncestors(frameElement) : []);
    }
    return list.concat(scrollableAncestor, $9f2dc49079b18fe5$var$getOverflowAncestors(scrollableAncestor, [], traverseIframes));
}
function $9f2dc49079b18fe5$var$getFrameElement(win) {
    return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}
function $9f2dc49079b18fe5$var$getCssDimensions(element) {
    const css = $9f2dc49079b18fe5$var$getComputedStyle(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = $9f2dc49079b18fe5$var$isHTMLElement(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = $9f2dc49079b18fe5$var$round(width) !== offsetWidth || $9f2dc49079b18fe5$var$round(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $9f2dc49079b18fe5$var$unwrapElement(element) {
    return !$9f2dc49079b18fe5$var$isElement(element) ? element.contextElement : element;
}
function $9f2dc49079b18fe5$var$getScale(element) {
    const domElement = $9f2dc49079b18fe5$var$unwrapElement(element);
    if (!$9f2dc49079b18fe5$var$isHTMLElement(domElement)) return $9f2dc49079b18fe5$var$createCoords(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width, height: height, $: $ } = $9f2dc49079b18fe5$var$getCssDimensions(domElement);
    let x = ($ ? $9f2dc49079b18fe5$var$round(rect.width) : rect.width) / width;
    let y = ($ ? $9f2dc49079b18fe5$var$round(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $9f2dc49079b18fe5$var$noOffsets = /*#__PURE__*/ $9f2dc49079b18fe5$var$createCoords(0);
function $9f2dc49079b18fe5$var$getVisualOffsets(element) {
    const win = $9f2dc49079b18fe5$var$getWindow(element);
    if (!$9f2dc49079b18fe5$var$isWebKit() || !win.visualViewport) return $9f2dc49079b18fe5$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $9f2dc49079b18fe5$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== $9f2dc49079b18fe5$var$getWindow(element)) return false;
    return isFixed;
}
function $9f2dc49079b18fe5$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $9f2dc49079b18fe5$var$unwrapElement(element);
    let scale = $9f2dc49079b18fe5$var$createCoords(1);
    if (includeScale) {
        if (offsetParent) {
            if ($9f2dc49079b18fe5$var$isElement(offsetParent)) scale = $9f2dc49079b18fe5$var$getScale(offsetParent);
        } else scale = $9f2dc49079b18fe5$var$getScale(element);
    }
    const visualOffsets = $9f2dc49079b18fe5$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $9f2dc49079b18fe5$var$getVisualOffsets(domElement) : $9f2dc49079b18fe5$var$createCoords(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = $9f2dc49079b18fe5$var$getWindow(domElement);
        const offsetWin = offsetParent && $9f2dc49079b18fe5$var$isElement(offsetParent) ? $9f2dc49079b18fe5$var$getWindow(offsetParent) : offsetParent;
        let currentWin = win;
        let currentIFrame = $9f2dc49079b18fe5$var$getFrameElement(currentWin);
        while(currentIFrame && offsetParent && offsetWin !== currentWin){
            const iframeScale = $9f2dc49079b18fe5$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = $9f2dc49079b18fe5$var$getComputedStyle(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentWin = $9f2dc49079b18fe5$var$getWindow(currentIFrame);
            currentIFrame = $9f2dc49079b18fe5$var$getFrameElement(currentWin);
        }
    }
    return $9f2dc49079b18fe5$var$rectToClientRect({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
// If <html> has a CSS width greater than the viewport, then this will be
// incorrect for RTL.
function $9f2dc49079b18fe5$var$getWindowScrollBarX(element, rect) {
    const leftScroll = $9f2dc49079b18fe5$var$getNodeScroll(element).scrollLeft;
    if (!rect) return $9f2dc49079b18fe5$var$getBoundingClientRect($9f2dc49079b18fe5$var$getDocumentElement(element)).left + leftScroll;
    return rect.left + leftScroll;
}
function $9f2dc49079b18fe5$var$getHTMLOffset(documentElement, scroll, ignoreScrollbarX) {
    if (ignoreScrollbarX === void 0) ignoreScrollbarX = false;
    const htmlRect = documentElement.getBoundingClientRect();
    const x = htmlRect.left + scroll.scrollLeft - (ignoreScrollbarX ? 0 : // RTL <body> scrollbar.
    $9f2dc49079b18fe5$var$getWindowScrollBarX(documentElement, htmlRect));
    const y = htmlRect.top + scroll.scrollTop;
    return {
        x: x,
        y: y
    };
}
function $9f2dc49079b18fe5$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { elements: elements, rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isFixed = strategy === "fixed";
    const documentElement = $9f2dc49079b18fe5$var$getDocumentElement(offsetParent);
    const topLayer = elements ? $9f2dc49079b18fe5$var$isTopLayer(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = $9f2dc49079b18fe5$var$createCoords(1);
    const offsets = $9f2dc49079b18fe5$var$createCoords(0);
    const isOffsetParentAnElement = $9f2dc49079b18fe5$var$isHTMLElement(offsetParent);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ($9f2dc49079b18fe5$var$getNodeName(offsetParent) !== "body" || $9f2dc49079b18fe5$var$isOverflowElement(documentElement)) scroll = $9f2dc49079b18fe5$var$getNodeScroll(offsetParent);
        if ($9f2dc49079b18fe5$var$isHTMLElement(offsetParent)) {
            const offsetRect = $9f2dc49079b18fe5$var$getBoundingClientRect(offsetParent);
            scale = $9f2dc49079b18fe5$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $9f2dc49079b18fe5$var$getHTMLOffset(documentElement, scroll, true) : $9f2dc49079b18fe5$var$createCoords(0);
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
    };
}
function $9f2dc49079b18fe5$var$getClientRects(element) {
    return Array.from(element.getClientRects());
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $9f2dc49079b18fe5$var$getDocumentRect(element) {
    const html = $9f2dc49079b18fe5$var$getDocumentElement(element);
    const scroll = $9f2dc49079b18fe5$var$getNodeScroll(element);
    const body = element.ownerDocument.body;
    const width = $9f2dc49079b18fe5$var$max(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = $9f2dc49079b18fe5$var$max(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $9f2dc49079b18fe5$var$getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ($9f2dc49079b18fe5$var$getComputedStyle(body).direction === "rtl") x += $9f2dc49079b18fe5$var$max(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $9f2dc49079b18fe5$var$getViewportRect(element, strategy) {
    const win = $9f2dc49079b18fe5$var$getWindow(element);
    const html = $9f2dc49079b18fe5$var$getDocumentElement(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = $9f2dc49079b18fe5$var$isWebKit();
        if (!visualViewportBased || visualViewportBased && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function $9f2dc49079b18fe5$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $9f2dc49079b18fe5$var$getBoundingClientRect(element, true, strategy === "fixed");
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = $9f2dc49079b18fe5$var$isHTMLElement(element) ? $9f2dc49079b18fe5$var$getScale(element) : $9f2dc49079b18fe5$var$createCoords(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $9f2dc49079b18fe5$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === "viewport") rect = $9f2dc49079b18fe5$var$getViewportRect(element, strategy);
    else if (clippingAncestor === "document") rect = $9f2dc49079b18fe5$var$getDocumentRect($9f2dc49079b18fe5$var$getDocumentElement(element));
    else if ($9f2dc49079b18fe5$var$isElement(clippingAncestor)) rect = $9f2dc49079b18fe5$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $9f2dc49079b18fe5$var$getVisualOffsets(element);
        rect = {
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y,
            width: clippingAncestor.width,
            height: clippingAncestor.height
        };
    }
    return $9f2dc49079b18fe5$var$rectToClientRect(rect);
}
function $9f2dc49079b18fe5$var$hasFixedPositionAncestor(element, stopNode) {
    const parentNode = $9f2dc49079b18fe5$var$getParentNode(element);
    if (parentNode === stopNode || !$9f2dc49079b18fe5$var$isElement(parentNode) || $9f2dc49079b18fe5$var$isLastTraversableNode(parentNode)) return false;
    return $9f2dc49079b18fe5$var$getComputedStyle(parentNode).position === "fixed" || $9f2dc49079b18fe5$var$hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $9f2dc49079b18fe5$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = $9f2dc49079b18fe5$var$getOverflowAncestors(element, [], false).filter((el)=>$9f2dc49079b18fe5$var$isElement(el) && $9f2dc49079b18fe5$var$getNodeName(el) !== "body");
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = $9f2dc49079b18fe5$var$getComputedStyle(element).position === "fixed";
    let currentNode = elementIsFixed ? $9f2dc49079b18fe5$var$getParentNode(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while($9f2dc49079b18fe5$var$isElement(currentNode) && !$9f2dc49079b18fe5$var$isLastTraversableNode(currentNode)){
        const computedStyle = $9f2dc49079b18fe5$var$getComputedStyle(currentNode);
        const currentNodeIsContaining = $9f2dc49079b18fe5$var$isContainingBlock(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === "fixed") currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === "static" && !!currentContainingBlockComputedStyle && [
            "absolute",
            "fixed"
        ].includes(currentContainingBlockComputedStyle.position) || $9f2dc49079b18fe5$var$isOverflowElement(currentNode) && !currentNodeIsContaining && $9f2dc49079b18fe5$var$hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = $9f2dc49079b18fe5$var$getParentNode(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $9f2dc49079b18fe5$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const elementClippingAncestors = boundary === "clippingAncestors" ? $9f2dc49079b18fe5$var$isTopLayer(element) ? [] : $9f2dc49079b18fe5$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstClippingAncestor = clippingAncestors[0];
    const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
        const rect = $9f2dc49079b18fe5$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
        accRect.top = $9f2dc49079b18fe5$var$max(rect.top, accRect.top);
        accRect.right = $9f2dc49079b18fe5$var$min(rect.right, accRect.right);
        accRect.bottom = $9f2dc49079b18fe5$var$min(rect.bottom, accRect.bottom);
        accRect.left = $9f2dc49079b18fe5$var$max(rect.left, accRect.left);
        return accRect;
    }, $9f2dc49079b18fe5$var$getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
    return {
        width: clippingRect.right - clippingRect.left,
        height: clippingRect.bottom - clippingRect.top,
        x: clippingRect.left,
        y: clippingRect.top
    };
}
function $9f2dc49079b18fe5$var$getDimensions(element) {
    const { width: width, height: height } = $9f2dc49079b18fe5$var$getCssDimensions(element);
    return {
        width: width,
        height: height
    };
}
function $9f2dc49079b18fe5$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = $9f2dc49079b18fe5$var$isHTMLElement(offsetParent);
    const documentElement = $9f2dc49079b18fe5$var$getDocumentElement(offsetParent);
    const isFixed = strategy === "fixed";
    const rect = $9f2dc49079b18fe5$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = $9f2dc49079b18fe5$var$createCoords(0);
    // If the <body> scrollbar appears on the left (e.g. RTL systems). Use
    // Firefox with layout.scrollbar.side = 3 in about:config to test this.
    function setLeftRTLScrollbarOffset() {
        offsets.x = $9f2dc49079b18fe5$var$getWindowScrollBarX(documentElement);
    }
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ($9f2dc49079b18fe5$var$getNodeName(offsetParent) !== "body" || $9f2dc49079b18fe5$var$isOverflowElement(documentElement)) scroll = $9f2dc49079b18fe5$var$getNodeScroll(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $9f2dc49079b18fe5$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) setLeftRTLScrollbarOffset();
    }
    if (isFixed && !isOffsetParentAnElement && documentElement) setLeftRTLScrollbarOffset();
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $9f2dc49079b18fe5$var$getHTMLOffset(documentElement, scroll) : $9f2dc49079b18fe5$var$createCoords(0);
    const x = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
    const y = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
    return {
        x: x,
        y: y,
        width: rect.width,
        height: rect.height
    };
}
function $9f2dc49079b18fe5$var$isStaticPositioned(element) {
    return $9f2dc49079b18fe5$var$getComputedStyle(element).position === "static";
}
function $9f2dc49079b18fe5$var$getTrueOffsetParent(element, polyfill) {
    if (!$9f2dc49079b18fe5$var$isHTMLElement(element) || $9f2dc49079b18fe5$var$getComputedStyle(element).position === "fixed") return null;
    if (polyfill) return polyfill(element);
    let rawOffsetParent = element.offsetParent;
    // Firefox returns the <html> element as the offsetParent if it's non-static,
    // while Chrome and Safari return the <body> element. The <body> element must
    // be used to perform the correct calculations even if the <html> element is
    // non-static.
    if ($9f2dc49079b18fe5$var$getDocumentElement(element) === rawOffsetParent) rawOffsetParent = rawOffsetParent.ownerDocument.body;
    return rawOffsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $9f2dc49079b18fe5$var$getOffsetParent(element, polyfill) {
    const win = $9f2dc49079b18fe5$var$getWindow(element);
    if ($9f2dc49079b18fe5$var$isTopLayer(element)) return win;
    if (!$9f2dc49079b18fe5$var$isHTMLElement(element)) {
        let svgOffsetParent = $9f2dc49079b18fe5$var$getParentNode(element);
        while(svgOffsetParent && !$9f2dc49079b18fe5$var$isLastTraversableNode(svgOffsetParent)){
            if ($9f2dc49079b18fe5$var$isElement(svgOffsetParent) && !$9f2dc49079b18fe5$var$isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
            svgOffsetParent = $9f2dc49079b18fe5$var$getParentNode(svgOffsetParent);
        }
        return win;
    }
    let offsetParent = $9f2dc49079b18fe5$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && $9f2dc49079b18fe5$var$isTableElement(offsetParent) && $9f2dc49079b18fe5$var$isStaticPositioned(offsetParent))offsetParent = $9f2dc49079b18fe5$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && $9f2dc49079b18fe5$var$isLastTraversableNode(offsetParent) && $9f2dc49079b18fe5$var$isStaticPositioned(offsetParent) && !$9f2dc49079b18fe5$var$isContainingBlock(offsetParent)) return win;
    return offsetParent || $9f2dc49079b18fe5$var$getContainingBlock(element) || win;
}
const $9f2dc49079b18fe5$var$getElementRects = async function getElementRects(data) {
    const getOffsetParentFn = this.getOffsetParent || $9f2dc49079b18fe5$var$getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    const floatingDimensions = await getDimensionsFn(data.floating);
    return {
        reference: $9f2dc49079b18fe5$var$getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
        floating: {
            x: 0,
            y: 0,
            width: floatingDimensions.width,
            height: floatingDimensions.height
        }
    };
};
function $9f2dc49079b18fe5$var$isRTL(element) {
    return $9f2dc49079b18fe5$var$getComputedStyle(element).direction === "rtl";
}
const $9f2dc49079b18fe5$var$platform = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $9f2dc49079b18fe5$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $9f2dc49079b18fe5$var$getDocumentElement,
    getClippingRect: $9f2dc49079b18fe5$var$getClippingRect,
    getOffsetParent: $9f2dc49079b18fe5$var$getOffsetParent,
    getElementRects: $9f2dc49079b18fe5$var$getElementRects,
    getClientRects: $9f2dc49079b18fe5$var$getClientRects,
    getDimensions: $9f2dc49079b18fe5$var$getDimensions,
    getScale: $9f2dc49079b18fe5$var$getScale,
    isElement: $9f2dc49079b18fe5$var$isElement,
    isRTL: $9f2dc49079b18fe5$var$isRTL
};
function $9f2dc49079b18fe5$var$rectsAreEqual(a, b) {
    return a.x === b.x && a.y === b.y && a.width === b.width && a.height === b.height;
}
// https://samthor.au/2021/observing-dom/
function $9f2dc49079b18fe5$var$observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = $9f2dc49079b18fe5$var$getDocumentElement(element);
    function cleanup() {
        var _io;
        clearTimeout(timeoutId);
        (_io = io) == null || _io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const elementRectForRootMargin = element.getBoundingClientRect();
        const { left: left, top: top, width: width, height: height } = elementRectForRootMargin;
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = $9f2dc49079b18fe5$var$floor(top);
        const insetRight = $9f2dc49079b18fe5$var$floor(root.clientWidth - (left + width));
        const insetBottom = $9f2dc49079b18fe5$var$floor(root.clientHeight - (top + height));
        const insetLeft = $9f2dc49079b18fe5$var$floor(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: $9f2dc49079b18fe5$var$max(0, $9f2dc49079b18fe5$var$min(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) // If the reference is clipped, the ratio is 0. Throttle the refresh
                // to prevent an infinite loop of updates.
                timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 1000);
                else refresh(false, ratio);
            }
            if (ratio === 1 && !$9f2dc49079b18fe5$var$rectsAreEqual(elementRectForRootMargin, element.getBoundingClientRect())) // It's possible that even though the ratio is reported as 1, the
            // element is not actually fully within the IntersectionObserver's root
            // area anymore. This can happen under performance constraints. This may
            // be a bug in the browser's IntersectionObserver implementation. To
            // work around this, we compare the element's bounding rect now with
            // what it was at the time we created the IntersectionObserver. If they
            // are not equal then the element moved, so we refresh.
            refresh();
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, $9f2dc49079b18fe5$var$_extends({}, options, {
                // Handle <iframe>s
                root: root.ownerDocument
            }));
        } catch (_e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $9f2dc49079b18fe5$var$autoUpdate(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === "function", layoutShift: layoutShift = typeof IntersectionObserver === "function", animationFrame: animationFrame = false } = options;
    const referenceEl = $9f2dc49079b18fe5$var$unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? $9f2dc49079b18fe5$var$getOverflowAncestors(referenceEl) : [],
        ...$9f2dc49079b18fe5$var$getOverflowAncestors(floating)
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener("scroll", update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener("resize", update);
    });
    const cleanupIo = referenceEl && layoutShift ? $9f2dc49079b18fe5$var$observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $9f2dc49079b18fe5$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $9f2dc49079b18fe5$var$getBoundingClientRect(reference);
        if (prevRefRect && !$9f2dc49079b18fe5$var$rectsAreEqual(prevRefRect, nextRefRect)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _resizeObserver2;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener("scroll", update);
            ancestorResize && ancestor.removeEventListener("resize", update);
        });
        cleanupIo == null || cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $9f2dc49079b18fe5$var$autoPlacement = $9f2dc49079b18fe5$var$autoPlacement$1;
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $9f2dc49079b18fe5$var$shift = $9f2dc49079b18fe5$var$shift$1;
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $9f2dc49079b18fe5$var$flip = $9f2dc49079b18fe5$var$flip$1;
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $9f2dc49079b18fe5$var$arrow = $9f2dc49079b18fe5$var$arrow$1;
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $9f2dc49079b18fe5$var$limitShift = $9f2dc49079b18fe5$var$limitShift$1;
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */ const $9f2dc49079b18fe5$var$computePosition = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = $9f2dc49079b18fe5$var$_extends({
        platform: $9f2dc49079b18fe5$var$platform
    }, options);
    const platformWithCache = $9f2dc49079b18fe5$var$_extends({}, mergedOptions.platform, {
        _c: cache
    });
    return $9f2dc49079b18fe5$var$computePosition$1(reference, floating, $9f2dc49079b18fe5$var$_extends({}, mergedOptions, {
        platform: platformWithCache
    }));
};
/**
 * Determines options for the tooltip and initializes event listeners.
 *
 * @param step The step instance
 */ function $9f2dc49079b18fe5$var$setupTooltip(step) {
    if (step.cleanup) step.cleanup();
    const attachToOptions = step._getResolvedAttachToOptions();
    let target = attachToOptions.element;
    const floatingUIOptions = $9f2dc49079b18fe5$var$getFloatingUIOptions(attachToOptions, step);
    const shouldCenter = $9f2dc49079b18fe5$var$shouldCenterStep(attachToOptions);
    if (shouldCenter) {
        target = document.body;
        // @ts-expect-error TODO: fix this type error when we type Svelte
        const content = step.shepherdElementComponent.getElement();
        content.classList.add("shepherd-centered");
    }
    step.cleanup = $9f2dc49079b18fe5$var$autoUpdate(target, step.el, ()=>{
        // The element might have already been removed by the end of the tour.
        if (!step.el) {
            step.cleanup == null || step.cleanup();
            return;
        }
        $9f2dc49079b18fe5$var$setPosition(target, step, floatingUIOptions, shouldCenter);
    });
    step.target = attachToOptions.element;
    return floatingUIOptions;
}
/**
 * Merge tooltip options handling nested keys.
 *
 * @param tourOptions - The default tour options.
 * @param options - Step specific options.
 *
 * @return {floatingUIOptions: FloatingUIOptions}
 */ function $9f2dc49079b18fe5$var$mergeTooltipConfig(tourOptions, options) {
    return {
        floatingUIOptions: $9f2dc49079b18fe5$var$deepmerge(tourOptions.floatingUIOptions || {}, options.floatingUIOptions || {})
    };
}
/**
 * Cleanup function called when the step is closed/destroyed.
 *
 * @param step
 */ function $9f2dc49079b18fe5$var$destroyTooltip(step) {
    if (step.cleanup) step.cleanup();
    step.cleanup = null;
}
function $9f2dc49079b18fe5$var$setPosition(target, step, floatingUIOptions, shouldCenter) {
    return $9f2dc49079b18fe5$var$computePosition(target, step.el, floatingUIOptions).then($9f2dc49079b18fe5$var$floatingUIposition(step, shouldCenter))// Wait before forcing focus.
    .then((step)=>new Promise((resolve)=>{
            setTimeout(()=>resolve(step), 300);
        }))// Replaces focusAfterRender modifier.
    .then((step)=>{
        if (step != null && step.el) {
            step.el.tabIndex = 0;
            step.el.focus({
                preventScroll: true
            });
        }
    });
}
function $9f2dc49079b18fe5$var$floatingUIposition(step, shouldCenter) {
    return ({ x: x, y: y, placement: placement, middlewareData: middlewareData })=>{
        if (!step.el) return step;
        if (shouldCenter) Object.assign(step.el.style, {
            position: "fixed",
            left: "50%",
            top: "50%",
            transform: "translate(-50%, -50%)"
        });
        else Object.assign(step.el.style, {
            position: "absolute",
            left: `${x}px`,
            top: `${y}px`
        });
        step.el.dataset["popperPlacement"] = placement;
        $9f2dc49079b18fe5$var$placeArrow(step.el, middlewareData);
        return step;
    };
}
function $9f2dc49079b18fe5$var$placeArrow(el, middlewareData) {
    const arrowEl = el.querySelector(".shepherd-arrow");
    if ($9f2dc49079b18fe5$var$isHTMLElement$1(arrowEl) && middlewareData.arrow) {
        const { x: arrowX, y: arrowY } = middlewareData.arrow;
        Object.assign(arrowEl.style, {
            left: arrowX != null ? `${arrowX}px` : "",
            top: arrowY != null ? `${arrowY}px` : ""
        });
    }
}
/**
 * Gets the `Floating UI` options from a set of base `attachTo` options
 * @param attachToOptions
 * @param step The step instance
 * @private
 */ function $9f2dc49079b18fe5$var$getFloatingUIOptions(attachToOptions, step) {
    var _attachToOptions$on, _attachToOptions$on2, _attachToOptions$on3;
    const options = {
        strategy: "absolute"
    };
    options.middleware = [];
    const arrowEl = $9f2dc49079b18fe5$var$addArrow(step);
    const shouldCenter = $9f2dc49079b18fe5$var$shouldCenterStep(attachToOptions);
    const hasAutoPlacement = (_attachToOptions$on = attachToOptions.on) == null ? void 0 : _attachToOptions$on.includes("auto");
    const hasEdgeAlignment = (attachToOptions == null || (_attachToOptions$on2 = attachToOptions.on) == null ? void 0 : _attachToOptions$on2.includes("-start")) || (attachToOptions == null || (_attachToOptions$on3 = attachToOptions.on) == null ? void 0 : _attachToOptions$on3.includes("-end"));
    if (!shouldCenter) {
        if (hasAutoPlacement) {
            var _attachToOptions$on4;
            options.middleware.push($9f2dc49079b18fe5$var$autoPlacement({
                crossAxis: true,
                alignment: hasEdgeAlignment ? attachToOptions == null || (_attachToOptions$on4 = attachToOptions.on) == null ? void 0 : _attachToOptions$on4.split("-").pop() : null
            }));
        } else options.middleware.push($9f2dc49079b18fe5$var$flip());
        options.middleware.push(// Replicate PopperJS default behavior.
        $9f2dc49079b18fe5$var$shift({
            limiter: $9f2dc49079b18fe5$var$limitShift(),
            crossAxis: true
        }));
        if (arrowEl) {
            const arrowOptions = typeof step.options.arrow === "object" ? step.options.arrow : {
                padding: 4
            };
            options.middleware.push($9f2dc49079b18fe5$var$arrow({
                element: arrowEl,
                padding: hasEdgeAlignment ? arrowOptions.padding : 0
            }));
        }
        if (!hasAutoPlacement) options.placement = attachToOptions.on;
    }
    return $9f2dc49079b18fe5$var$deepmerge(options, step.options.floatingUIOptions || {});
}
function $9f2dc49079b18fe5$var$addArrow(step) {
    if (step.options.arrow && step.el) return step.el.querySelector(".shepherd-arrow");
    return false;
}
/** @returns {void} */ function $9f2dc49079b18fe5$var$noop() {}
/**
 * @template T
 * @template S
 * @param {T} tar
 * @param {S} src
 * @returns {T & S}
 */ function $9f2dc49079b18fe5$var$assign(tar, src) {
    // @ts-ignore
    for(const k in src)tar[k] = src[k];
    return /** @type {T & S} */ tar;
}
function $9f2dc49079b18fe5$var$run(fn) {
    return fn();
}
function $9f2dc49079b18fe5$var$blank_object() {
    return Object.create(null);
}
/**
 * @param {Function[]} fns
 * @returns {void}
 */ function $9f2dc49079b18fe5$var$run_all(fns) {
    fns.forEach($9f2dc49079b18fe5$var$run);
}
/**
 * @param {any} thing
 * @returns {thing is Function}
 */ function $9f2dc49079b18fe5$var$is_function(thing) {
    return typeof thing === "function";
}
/** @returns {boolean} */ function $9f2dc49079b18fe5$var$safe_not_equal(a, b) {
    return a != a ? b == b : a !== b || a && typeof a === "object" || typeof a === "function";
}
/** @returns {boolean} */ function $9f2dc49079b18fe5$var$is_empty(obj) {
    return Object.keys(obj).length === 0;
}
/**
 * @param {Node} target
 * @param {Node} node
 * @returns {void}
 */ function $9f2dc49079b18fe5$var$append(target, node) {
    target.appendChild(node);
}
/**
 * @param {Node} target
 * @param {Node} node
 * @param {Node} [anchor]
 * @returns {void}
 */ function $9f2dc49079b18fe5$var$insert(target, node, anchor) {
    target.insertBefore(node, anchor || null);
}
/**
 * @param {Node} node
 * @returns {void}
 */ function $9f2dc49079b18fe5$var$detach(node) {
    if (node.parentNode) node.parentNode.removeChild(node);
}
/**
 * @returns {void} */ function $9f2dc49079b18fe5$var$destroy_each(iterations, detaching) {
    for(let i = 0; i < iterations.length; i += 1)if (iterations[i]) iterations[i].d(detaching);
}
/**
 * @template {keyof HTMLElementTagNameMap} K
 * @param {K} name
 * @returns {HTMLElementTagNameMap[K]}
 */ function $9f2dc49079b18fe5$var$element(name) {
    return document.createElement(name);
}
/**
 * @template {keyof SVGElementTagNameMap} K
 * @param {K} name
 * @returns {SVGElement}
 */ function $9f2dc49079b18fe5$var$svg_element(name) {
    return document.createElementNS("http://www.w3.org/2000/svg", name);
}
/**
 * @param {string} data
 * @returns {Text}
 */ function $9f2dc49079b18fe5$var$text(data) {
    return document.createTextNode(data);
}
/**
 * @returns {Text} */ function $9f2dc49079b18fe5$var$space() {
    return $9f2dc49079b18fe5$var$text(" ");
}
/**
 * @returns {Text} */ function $9f2dc49079b18fe5$var$empty() {
    return $9f2dc49079b18fe5$var$text("");
}
/**
 * @param {EventTarget} node
 * @param {string} event
 * @param {EventListenerOrEventListenerObject} handler
 * @param {boolean | AddEventListenerOptions | EventListenerOptions} [options]
 * @returns {() => void}
 */ function $9f2dc49079b18fe5$var$listen(node, event, handler, options) {
    node.addEventListener(event, handler, options);
    return ()=>node.removeEventListener(event, handler, options);
}
/**
 * @param {Element} node
 * @param {string} attribute
 * @param {string} [value]
 * @returns {void}
 */ function $9f2dc49079b18fe5$var$attr(node, attribute, value) {
    if (value == null) node.removeAttribute(attribute);
    else if (node.getAttribute(attribute) !== value) node.setAttribute(attribute, value);
}
/**
 * List of attributes that should always be set through the attr method,
 * because updating them through the property setter doesn't work reliably.
 * In the example of `width`/`height`, the problem is that the setter only
 * accepts numeric values, but the attribute can also be set to a string like `50%`.
 * If this list becomes too big, rethink this approach.
 */ const $9f2dc49079b18fe5$var$always_set_through_set_attribute = [
    "width",
    "height"
];
/**
 * @param {Element & ElementCSSInlineStyle} node
 * @param {{ [x: string]: string }} attributes
 * @returns {void}
 */ function $9f2dc49079b18fe5$var$set_attributes(node, attributes) {
    // @ts-ignore
    const descriptors = Object.getOwnPropertyDescriptors(node.__proto__);
    for(const key in attributes){
        if (attributes[key] == null) node.removeAttribute(key);
        else if (key === "style") node.style.cssText = attributes[key];
        else if (key === "__value") /** @type {any} */ node.value = node[key] = attributes[key];
        else if (descriptors[key] && descriptors[key].set && $9f2dc49079b18fe5$var$always_set_through_set_attribute.indexOf(key) === -1) node[key] = attributes[key];
        else $9f2dc49079b18fe5$var$attr(node, key, attributes[key]);
    }
}
/**
 * @param {Element} element
 * @returns {ChildNode[]}
 */ function $9f2dc49079b18fe5$var$children(element) {
    return Array.from(element.childNodes);
}
/**
 * @returns {void} */ function $9f2dc49079b18fe5$var$toggle_class(element, name, toggle) {
    // The `!!` is required because an `undefined` flag means flipping the current state.
    element.classList.toggle(name, !!toggle);
}
/**
 * @typedef {Node & {
 * 	claim_order?: number;
 * 	hydrate_init?: true;
 * 	actual_end_child?: NodeEx;
 * 	childNodes: NodeListOf<NodeEx>;
 * }} NodeEx
 */ /** @typedef {ChildNode & NodeEx} ChildNodeEx */ /** @typedef {NodeEx & { claim_order: number }} NodeEx2 */ /**
 * @typedef {ChildNodeEx[] & {
 * 	claim_info?: {
 * 		last_index: number;
 * 		total_claimed: number;
 * 	};
 * }} ChildNodeArray
 */ let $9f2dc49079b18fe5$var$current_component;
/** @returns {void} */ function $9f2dc49079b18fe5$var$set_current_component(component) {
    $9f2dc49079b18fe5$var$current_component = component;
}
function $9f2dc49079b18fe5$var$get_current_component() {
    if (!$9f2dc49079b18fe5$var$current_component) throw new Error("Function called outside component initialization");
    return $9f2dc49079b18fe5$var$current_component;
}
/**
 * The `onMount` function schedules a callback to run as soon as the component has been mounted to the DOM.
 * It must be called during the component's initialisation (but doesn't need to live *inside* the component;
 * it can be called from an external module).
 *
 * If a function is returned _synchronously_ from `onMount`, it will be called when the component is unmounted.
 *
 * `onMount` does not run inside a [server-side component](https://svelte.dev/docs#run-time-server-side-component-api).
 *
 * https://svelte.dev/docs/svelte#onmount
 * @template T
 * @param {() => import('./private.js').NotFunction<T> | Promise<import('./private.js').NotFunction<T>> | (() => any)} fn
 * @returns {void}
 */ function $9f2dc49079b18fe5$var$onMount(fn) {
    $9f2dc49079b18fe5$var$get_current_component().$$.on_mount.push(fn);
}
/**
 * Schedules a callback to run immediately after the component has been updated.
 *
 * The first time the callback runs will be after the initial `onMount`
 *
 * https://svelte.dev/docs/svelte#afterupdate
 * @param {() => any} fn
 * @returns {void}
 */ function $9f2dc49079b18fe5$var$afterUpdate(fn) {
    $9f2dc49079b18fe5$var$get_current_component().$$.after_update.push(fn);
}
/**
 * Schedules a callback to run immediately before the component is unmounted.
 *
 * Out of `onMount`, `beforeUpdate`, `afterUpdate` and `onDestroy`, this is the
 * only one that runs inside a server-side component.
 *
 * https://svelte.dev/docs/svelte#ondestroy
 * @param {() => any} fn
 * @returns {void}
 */ function $9f2dc49079b18fe5$var$onDestroy(fn) {
    $9f2dc49079b18fe5$var$get_current_component().$$.on_destroy.push(fn);
}
const $9f2dc49079b18fe5$var$dirty_components = [];
const $9f2dc49079b18fe5$var$binding_callbacks = [];
let $9f2dc49079b18fe5$var$render_callbacks = [];
const $9f2dc49079b18fe5$var$flush_callbacks = [];
const $9f2dc49079b18fe5$var$resolved_promise = /* @__PURE__ */ Promise.resolve();
let $9f2dc49079b18fe5$var$update_scheduled = false;
/** @returns {void} */ function $9f2dc49079b18fe5$var$schedule_update() {
    if (!$9f2dc49079b18fe5$var$update_scheduled) {
        $9f2dc49079b18fe5$var$update_scheduled = true;
        $9f2dc49079b18fe5$var$resolved_promise.then($9f2dc49079b18fe5$var$flush);
    }
}
/** @returns {void} */ function $9f2dc49079b18fe5$var$add_render_callback(fn) {
    $9f2dc49079b18fe5$var$render_callbacks.push(fn);
}
// flush() calls callbacks in this order:
// 1. All beforeUpdate callbacks, in order: parents before children
// 2. All bind:this callbacks, in reverse order: children before parents.
// 3. All afterUpdate callbacks, in order: parents before children. EXCEPT
//    for afterUpdates called during the initial onMount, which are called in
//    reverse order: children before parents.
// Since callbacks might update component values, which could trigger another
// call to flush(), the following steps guard against this:
// 1. During beforeUpdate, any updated components will be added to the
//    dirty_components array and will cause a reentrant call to flush(). Because
//    the flush index is kept outside the function, the reentrant call will pick
//    up where the earlier call left off and go through all dirty components. The
//    current_component value is saved and restored so that the reentrant call will
//    not interfere with the "parent" flush() call.
// 2. bind:this callbacks cannot trigger new flush() calls.
// 3. During afterUpdate, any updated components will NOT have their afterUpdate
//    callback called a second time; the seen_callbacks set, outside the flush()
//    function, guarantees this behavior.
const $9f2dc49079b18fe5$var$seen_callbacks = new Set();
let $9f2dc49079b18fe5$var$flushidx = 0; // Do *not* move this inside the flush() function
/** @returns {void} */ function $9f2dc49079b18fe5$var$flush() {
    // Do not reenter flush while dirty components are updated, as this can
    // result in an infinite loop. Instead, let the inner flush handle it.
    // Reentrancy is ok afterwards for bindings etc.
    if ($9f2dc49079b18fe5$var$flushidx !== 0) return;
    const saved_component = $9f2dc49079b18fe5$var$current_component;
    do {
        // first, call beforeUpdate functions
        // and update components
        try {
            while($9f2dc49079b18fe5$var$flushidx < $9f2dc49079b18fe5$var$dirty_components.length){
                const component = $9f2dc49079b18fe5$var$dirty_components[$9f2dc49079b18fe5$var$flushidx];
                $9f2dc49079b18fe5$var$flushidx++;
                $9f2dc49079b18fe5$var$set_current_component(component);
                $9f2dc49079b18fe5$var$update(component.$$);
            }
        } catch (e) {
            // reset dirty state to not end up in a deadlocked state and then rethrow
            $9f2dc49079b18fe5$var$dirty_components.length = 0;
            $9f2dc49079b18fe5$var$flushidx = 0;
            throw e;
        }
        $9f2dc49079b18fe5$var$set_current_component(null);
        $9f2dc49079b18fe5$var$dirty_components.length = 0;
        $9f2dc49079b18fe5$var$flushidx = 0;
        while($9f2dc49079b18fe5$var$binding_callbacks.length)$9f2dc49079b18fe5$var$binding_callbacks.pop()();
        // then, once components are updated, call
        // afterUpdate functions. This may cause
        // subsequent updates...
        for(let i = 0; i < $9f2dc49079b18fe5$var$render_callbacks.length; i += 1){
            const callback = $9f2dc49079b18fe5$var$render_callbacks[i];
            if (!$9f2dc49079b18fe5$var$seen_callbacks.has(callback)) {
                // ...so guard against infinite loops
                $9f2dc49079b18fe5$var$seen_callbacks.add(callback);
                callback();
            }
        }
        $9f2dc49079b18fe5$var$render_callbacks.length = 0;
    }while ($9f2dc49079b18fe5$var$dirty_components.length);
    while($9f2dc49079b18fe5$var$flush_callbacks.length)$9f2dc49079b18fe5$var$flush_callbacks.pop()();
    $9f2dc49079b18fe5$var$update_scheduled = false;
    $9f2dc49079b18fe5$var$seen_callbacks.clear();
    $9f2dc49079b18fe5$var$set_current_component(saved_component);
}
/** @returns {void} */ function $9f2dc49079b18fe5$var$update($$) {
    if ($$.fragment !== null) {
        $$.update();
        $9f2dc49079b18fe5$var$run_all($$.before_update);
        const dirty = $$.dirty;
        $$.dirty = [
            -1
        ];
        $$.fragment && $$.fragment.p($$.ctx, dirty);
        $$.after_update.forEach($9f2dc49079b18fe5$var$add_render_callback);
    }
}
/**
 * Useful for example to execute remaining `afterUpdate` callbacks before executing `destroy`.
 * @param {Function[]} fns
 * @returns {void}
 */ function $9f2dc49079b18fe5$var$flush_render_callbacks(fns) {
    const filtered = [];
    const targets = [];
    $9f2dc49079b18fe5$var$render_callbacks.forEach((c)=>fns.indexOf(c) === -1 ? filtered.push(c) : targets.push(c));
    targets.forEach((c)=>c());
    $9f2dc49079b18fe5$var$render_callbacks = filtered;
}
const $9f2dc49079b18fe5$var$outroing = new Set();
/**
 * @type {Outro}
 */ let $9f2dc49079b18fe5$var$outros;
/**
 * @returns {void} */ function $9f2dc49079b18fe5$var$group_outros() {
    $9f2dc49079b18fe5$var$outros = {
        r: 0,
        c: [],
        p: $9f2dc49079b18fe5$var$outros // parent group
    };
}
/**
 * @returns {void} */ function $9f2dc49079b18fe5$var$check_outros() {
    if (!$9f2dc49079b18fe5$var$outros.r) $9f2dc49079b18fe5$var$run_all($9f2dc49079b18fe5$var$outros.c);
    $9f2dc49079b18fe5$var$outros = $9f2dc49079b18fe5$var$outros.p;
}
/**
 * @param {import('./private.js').Fragment} block
 * @param {0 | 1} [local]
 * @returns {void}
 */ function $9f2dc49079b18fe5$var$transition_in(block, local) {
    if (block && block.i) {
        $9f2dc49079b18fe5$var$outroing.delete(block);
        block.i(local);
    }
}
/**
 * @param {import('./private.js').Fragment} block
 * @param {0 | 1} local
 * @param {0 | 1} [detach]
 * @param {() => void} [callback]
 * @returns {void}
 */ function $9f2dc49079b18fe5$var$transition_out(block, local, detach, callback) {
    if (block && block.o) {
        if ($9f2dc49079b18fe5$var$outroing.has(block)) return;
        $9f2dc49079b18fe5$var$outroing.add(block);
        $9f2dc49079b18fe5$var$outros.c.push(()=>{
            $9f2dc49079b18fe5$var$outroing.delete(block);
            if (callback) {
                if (detach) block.d(1);
                callback();
            }
        });
        block.o(local);
    } else if (callback) callback();
}
/** @typedef {1} INTRO */ /** @typedef {0} OUTRO */ /** @typedef {{ direction: 'in' | 'out' | 'both' }} TransitionOptions */ /** @typedef {(node: Element, params: any, options: TransitionOptions) => import('../transition/public.js').TransitionConfig} TransitionFn */ /**
 * @typedef {Object} Outro
 * @property {number} r
 * @property {Function[]} c
 * @property {Object} p
 */ /**
 * @typedef {Object} PendingProgram
 * @property {number} start
 * @property {INTRO|OUTRO} b
 * @property {Outro} [group]
 */ /**
 * @typedef {Object} Program
 * @property {number} a
 * @property {INTRO|OUTRO} b
 * @property {1|-1} d
 * @property {number} duration
 * @property {number} start
 * @property {number} end
 * @property {Outro} [group]
 */ // general each functions:
function $9f2dc49079b18fe5$var$ensure_array_like(array_like_or_iterator) {
    return (array_like_or_iterator == null ? void 0 : array_like_or_iterator.length) !== undefined ? array_like_or_iterator : Array.from(array_like_or_iterator);
}
/** @returns {{}} */ function $9f2dc49079b18fe5$var$get_spread_update(levels, updates) {
    const update = {};
    const to_null_out = {};
    const accounted_for = {
        $$scope: 1
    };
    let i = levels.length;
    while(i--){
        const o = levels[i];
        const n = updates[i];
        if (n) {
            for(const key in o)if (!(key in n)) to_null_out[key] = 1;
            for(const key in n)if (!accounted_for[key]) {
                update[key] = n[key];
                accounted_for[key] = 1;
            }
            levels[i] = n;
        } else for(const key in o)accounted_for[key] = 1;
    }
    for(const key in to_null_out)if (!(key in update)) update[key] = undefined;
    return update;
}
/** @returns {void} */ function $9f2dc49079b18fe5$var$create_component(block) {
    block && block.c();
}
/** @returns {void} */ function $9f2dc49079b18fe5$var$mount_component(component, target, anchor) {
    const { fragment: fragment, after_update: after_update } = component.$$;
    fragment && fragment.m(target, anchor);
    // onMount happens before the initial afterUpdate
    $9f2dc49079b18fe5$var$add_render_callback(()=>{
        const new_on_destroy = component.$$.on_mount.map($9f2dc49079b18fe5$var$run).filter($9f2dc49079b18fe5$var$is_function);
        // if the component was destroyed immediately
        // it will update the `$$.on_destroy` reference to `null`.
        // the destructured on_destroy may still reference to the old array
        if (component.$$.on_destroy) component.$$.on_destroy.push(...new_on_destroy);
        else // Edge case - component was destroyed immediately,
        // most likely as a result of a binding initialising
        $9f2dc49079b18fe5$var$run_all(new_on_destroy);
        component.$$.on_mount = [];
    });
    after_update.forEach($9f2dc49079b18fe5$var$add_render_callback);
}
/** @returns {void} */ function $9f2dc49079b18fe5$var$destroy_component(component, detaching) {
    const $$ = component.$$;
    if ($$.fragment !== null) {
        $9f2dc49079b18fe5$var$flush_render_callbacks($$.after_update);
        $9f2dc49079b18fe5$var$run_all($$.on_destroy);
        $$.fragment && $$.fragment.d(detaching);
        // TODO null out other refs, including component.$$ (but need to
        // preserve final state?)
        $$.on_destroy = $$.fragment = null;
        $$.ctx = [];
    }
}
/** @returns {void} */ function $9f2dc49079b18fe5$var$make_dirty(component, i) {
    if (component.$$.dirty[0] === -1) {
        $9f2dc49079b18fe5$var$dirty_components.push(component);
        $9f2dc49079b18fe5$var$schedule_update();
        component.$$.dirty.fill(0);
    }
    component.$$.dirty[i / 31 | 0] |= 1 << i % 31;
}
// TODO: Document the other params
/**
 * @param {SvelteComponent} component
 * @param {import('./public.js').ComponentConstructorOptions} options
 *
 * @param {import('./utils.js')['not_equal']} not_equal Used to compare props and state values.
 * @param {(target: Element | ShadowRoot) => void} [append_styles] Function that appends styles to the DOM when the component is first initialised.
 * This will be the `add_css` function from the compiled component.
 *
 * @returns {void}
 */ function $9f2dc49079b18fe5$var$init(component, options, instance, create_fragment, not_equal, props, append_styles = null, dirty = [
    -1
]) {
    const parent_component = $9f2dc49079b18fe5$var$current_component;
    $9f2dc49079b18fe5$var$set_current_component(component);
    /** @type {import('./private.js').T$$} */ const $$ = component.$$ = {
        fragment: null,
        ctx: [],
        props: // state
        props,
        update: $9f2dc49079b18fe5$var$noop,
        not_equal: not_equal,
        bound: $9f2dc49079b18fe5$var$blank_object(),
        // lifecycle
        on_mount: [],
        on_destroy: [],
        on_disconnect: [],
        before_update: [],
        after_update: [],
        context: new Map(options.context || (parent_component ? parent_component.$$.context : [])),
        // everything else
        callbacks: $9f2dc49079b18fe5$var$blank_object(),
        dirty: dirty,
        skip_bound: false,
        root: options.target || parent_component.$$.root
    };
    append_styles && append_styles($$.root);
    let ready = false;
    $$.ctx = instance ? instance(component, options.props || {}, (i, ret, ...rest)=>{
        const value = rest.length ? rest[0] : ret;
        if ($$.ctx && not_equal($$.ctx[i], $$.ctx[i] = value)) {
            if (!$$.skip_bound && $$.bound[i]) $$.bound[i](value);
            if (ready) $9f2dc49079b18fe5$var$make_dirty(component, i);
        }
        return ret;
    }) : [];
    $$.update();
    ready = true;
    $9f2dc49079b18fe5$var$run_all($$.before_update);
    // `false` as a special case of no DOM component
    $$.fragment = create_fragment ? create_fragment($$.ctx) : false;
    if (options.target) {
        if (options.hydrate) {
            // TODO: what is the correct type here?
            // @ts-expect-error
            const nodes = $9f2dc49079b18fe5$var$children(options.target);
            $$.fragment && $$.fragment.l(nodes);
            nodes.forEach($9f2dc49079b18fe5$var$detach);
        } else // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        $$.fragment && $$.fragment.c();
        if (options.intro) $9f2dc49079b18fe5$var$transition_in(component.$$.fragment);
        $9f2dc49079b18fe5$var$mount_component(component, options.target, options.anchor);
        $9f2dc49079b18fe5$var$flush();
    }
    $9f2dc49079b18fe5$var$set_current_component(parent_component);
}
/**
 * Base class for Svelte components. Used when dev=false.
 *
 * @template {Record<string, any>} [Props=any]
 * @template {Record<string, any>} [Events=any]
 */ class $9f2dc49079b18fe5$var$SvelteComponent {
    constructor(){
        /**
     * ### PRIVATE API
     *
     * Do not use, may change at any time
     *
     * @type {any}
     */ this.$$ = undefined;
        /**
     * ### PRIVATE API
     *
     * Do not use, may change at any time
     *
     * @type {any}
     */ this.$$set = undefined;
    }
    /** @returns {void} */ $destroy() {
        $9f2dc49079b18fe5$var$destroy_component(this, 1);
        this.$destroy = $9f2dc49079b18fe5$var$noop;
    }
    /**
   * @template {Extract<keyof Events, string>} K
   * @param {K} type
   * @param {((e: Events[K]) => void) | null | undefined} callback
   * @returns {() => void}
   */ $on(type, callback) {
        if (!$9f2dc49079b18fe5$var$is_function(callback)) return $9f2dc49079b18fe5$var$noop;
        const callbacks = this.$$.callbacks[type] || (this.$$.callbacks[type] = []);
        callbacks.push(callback);
        return ()=>{
            const index = callbacks.indexOf(callback);
            if (index !== -1) callbacks.splice(index, 1);
        };
    }
    /**
   * @param {Partial<Props>} props
   * @returns {void}
   */ $set(props) {
        if (this.$$set && !$9f2dc49079b18fe5$var$is_empty(props)) {
            this.$$.skip_bound = true;
            this.$$set(props);
            this.$$.skip_bound = false;
        }
    }
}
/**
 * @typedef {Object} CustomElementPropDefinition
 * @property {string} [attribute]
 * @property {boolean} [reflect]
 * @property {'String'|'Boolean'|'Number'|'Array'|'Object'} [type]
 */ // generated during release, do not modify
const $9f2dc49079b18fe5$var$PUBLIC_VERSION = "4";
if (typeof window !== "undefined") // @ts-ignore
(window.__svelte || (window.__svelte = {
    v: new Set()
})).v.add($9f2dc49079b18fe5$var$PUBLIC_VERSION);
/* src/components/shepherd-button.svelte generated by Svelte v4.2.19 */ function $9f2dc49079b18fe5$var$create_fragment$8(ctx) {
    let button;
    let button_aria_label_value;
    let button_class_value;
    let mounted;
    let dispose;
    return {
        c () {
            button = $9f2dc49079b18fe5$var$element("button");
            $9f2dc49079b18fe5$var$attr(button, "aria-label", button_aria_label_value = /*label*/ ctx[3] ? /*label*/ ctx[3] : null);
            $9f2dc49079b18fe5$var$attr(button, "class", button_class_value = `${ctx[1] || ""} shepherd-button ${ctx[4] ? "shepherd-button-secondary" : ""}`);
            button.disabled = /*disabled*/ ctx[2];
            $9f2dc49079b18fe5$var$attr(button, "tabindex", "0");
            $9f2dc49079b18fe5$var$attr(button, "type", "button");
        },
        m (target, anchor) {
            $9f2dc49079b18fe5$var$insert(target, button, anchor);
            button.innerHTML = /*text*/ ctx[5];
            if (!mounted) {
                dispose = $9f2dc49079b18fe5$var$listen(button, "click", function() {
                    if ($9f2dc49079b18fe5$var$is_function(/*action*/ ctx[0])) /*action*/ ctx[0].apply(this, arguments);
                });
                mounted = true;
            }
        },
        p (new_ctx, [dirty]) {
            ctx = new_ctx;
            if (dirty & /*text*/ 32) button.innerHTML = /*text*/ ctx[5];
            if (dirty & /*label*/ 8 && button_aria_label_value !== (button_aria_label_value = /*label*/ ctx[3] ? /*label*/ ctx[3] : null)) $9f2dc49079b18fe5$var$attr(button, "aria-label", button_aria_label_value);
            if (dirty & /*classes, secondary*/ 18 && button_class_value !== (button_class_value = `${ctx[1] || ""} shepherd-button ${ctx[4] ? "shepherd-button-secondary" : ""}`)) $9f2dc49079b18fe5$var$attr(button, "class", button_class_value);
            if (dirty & /*disabled*/ 4) button.disabled = /*disabled*/ ctx[2];
        },
        i: $9f2dc49079b18fe5$var$noop,
        o: $9f2dc49079b18fe5$var$noop,
        d (detaching) {
            if (detaching) $9f2dc49079b18fe5$var$detach(button);
            mounted = false;
            dispose();
        }
    };
}
function $9f2dc49079b18fe5$var$instance$8($$self, $$props, $$invalidate) {
    let { config: config, step: step } = $$props;
    let action, classes, disabled, label, secondary, text;
    function getConfigOption(option) {
        if ($9f2dc49079b18fe5$var$isFunction(option)) return option = option.call(step);
        return option;
    }
    $$self.$$set = ($$props)=>{
        if ("config" in $$props) $$invalidate(6, config = $$props.config);
        if ("step" in $$props) $$invalidate(7, step = $$props.step);
    };
    $$self.$$.update = ()=>{
        if ($$self.$$.dirty & /*config, step*/ 192) {
            $$invalidate(0, action = config.action ? config.action.bind(step.tour) : null);
            $$invalidate(1, classes = config.classes);
            $$invalidate(2, disabled = config.disabled ? getConfigOption(config.disabled) : false);
            $$invalidate(3, label = config.label ? getConfigOption(config.label) : null);
            $$invalidate(4, secondary = config.secondary);
            $$invalidate(5, text = config.text ? getConfigOption(config.text) : null);
        }
    };
    return [
        action,
        classes,
        disabled,
        label,
        secondary,
        text,
        config,
        step
    ];
}
class $9f2dc49079b18fe5$var$Shepherd_button extends $9f2dc49079b18fe5$var$SvelteComponent {
    constructor(options){
        super();
        $9f2dc49079b18fe5$var$init(this, options, $9f2dc49079b18fe5$var$instance$8, $9f2dc49079b18fe5$var$create_fragment$8, $9f2dc49079b18fe5$var$safe_not_equal, {
            config: 6,
            step: 7
        });
    }
}
/* src/components/shepherd-footer.svelte generated by Svelte v4.2.19 */ function $9f2dc49079b18fe5$var$get_each_context(ctx, list, i) {
    const child_ctx = ctx.slice();
    child_ctx[2] = list[i];
    return child_ctx;
}
// (10:2) {#if buttons}
function $9f2dc49079b18fe5$var$create_if_block$3(ctx) {
    let each_1_anchor;
    let current;
    let each_value = $9f2dc49079b18fe5$var$ensure_array_like(/*buttons*/ ctx[1]);
    let each_blocks = [];
    for(let i = 0; i < each_value.length; i += 1)each_blocks[i] = $9f2dc49079b18fe5$var$create_each_block($9f2dc49079b18fe5$var$get_each_context(ctx, each_value, i));
    const out = (i)=>$9f2dc49079b18fe5$var$transition_out(each_blocks[i], 1, 1, ()=>{
            each_blocks[i] = null;
        });
    return {
        c () {
            for(let i = 0; i < each_blocks.length; i += 1)each_blocks[i].c();
            each_1_anchor = $9f2dc49079b18fe5$var$empty();
        },
        m (target, anchor) {
            for(let i = 0; i < each_blocks.length; i += 1)if (each_blocks[i]) each_blocks[i].m(target, anchor);
            $9f2dc49079b18fe5$var$insert(target, each_1_anchor, anchor);
            current = true;
        },
        p (ctx, dirty) {
            if (dirty & /*buttons, step*/ 3) {
                each_value = $9f2dc49079b18fe5$var$ensure_array_like(/*buttons*/ ctx[1]);
                let i;
                for(i = 0; i < each_value.length; i += 1){
                    const child_ctx = $9f2dc49079b18fe5$var$get_each_context(ctx, each_value, i);
                    if (each_blocks[i]) {
                        each_blocks[i].p(child_ctx, dirty);
                        $9f2dc49079b18fe5$var$transition_in(each_blocks[i], 1);
                    } else {
                        each_blocks[i] = $9f2dc49079b18fe5$var$create_each_block(child_ctx);
                        each_blocks[i].c();
                        $9f2dc49079b18fe5$var$transition_in(each_blocks[i], 1);
                        each_blocks[i].m(each_1_anchor.parentNode, each_1_anchor);
                    }
                }
                $9f2dc49079b18fe5$var$group_outros();
                for(i = each_value.length; i < each_blocks.length; i += 1)out(i);
                $9f2dc49079b18fe5$var$check_outros();
            }
        },
        i (local) {
            if (current) return;
            for(let i = 0; i < each_value.length; i += 1)$9f2dc49079b18fe5$var$transition_in(each_blocks[i]);
            current = true;
        },
        o (local) {
            each_blocks = each_blocks.filter(Boolean);
            for(let i = 0; i < each_blocks.length; i += 1)$9f2dc49079b18fe5$var$transition_out(each_blocks[i]);
            current = false;
        },
        d (detaching) {
            if (detaching) $9f2dc49079b18fe5$var$detach(each_1_anchor);
            $9f2dc49079b18fe5$var$destroy_each(each_blocks, detaching);
        }
    };
}
// (11:4) {#each buttons as config}
function $9f2dc49079b18fe5$var$create_each_block(ctx) {
    let shepherdbutton;
    let current;
    shepherdbutton = new $9f2dc49079b18fe5$var$Shepherd_button({
        props: {
            config: /*config*/ ctx[2],
            step: /*step*/ ctx[0]
        }
    });
    return {
        c () {
            $9f2dc49079b18fe5$var$create_component(shepherdbutton.$$.fragment);
        },
        m (target, anchor) {
            $9f2dc49079b18fe5$var$mount_component(shepherdbutton, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const shepherdbutton_changes = {};
            if (dirty & /*buttons*/ 2) shepherdbutton_changes.config = /*config*/ ctx[2];
            if (dirty & /*step*/ 1) shepherdbutton_changes.step = /*step*/ ctx[0];
            shepherdbutton.$set(shepherdbutton_changes);
        },
        i (local) {
            if (current) return;
            $9f2dc49079b18fe5$var$transition_in(shepherdbutton.$$.fragment, local);
            current = true;
        },
        o (local) {
            $9f2dc49079b18fe5$var$transition_out(shepherdbutton.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            $9f2dc49079b18fe5$var$destroy_component(shepherdbutton, detaching);
        }
    };
}
function $9f2dc49079b18fe5$var$create_fragment$7(ctx) {
    let footer;
    let current;
    let if_block = /*buttons*/ ctx[1] && $9f2dc49079b18fe5$var$create_if_block$3(ctx);
    return {
        c () {
            footer = $9f2dc49079b18fe5$var$element("footer");
            if (if_block) if_block.c();
            $9f2dc49079b18fe5$var$attr(footer, "class", "shepherd-footer");
        },
        m (target, anchor) {
            $9f2dc49079b18fe5$var$insert(target, footer, anchor);
            if (if_block) if_block.m(footer, null);
            current = true;
        },
        p (ctx, [dirty]) {
            if (/*buttons*/ ctx[1]) {
                if (if_block) {
                    if_block.p(ctx, dirty);
                    if (dirty & /*buttons*/ 2) $9f2dc49079b18fe5$var$transition_in(if_block, 1);
                } else {
                    if_block = $9f2dc49079b18fe5$var$create_if_block$3(ctx);
                    if_block.c();
                    $9f2dc49079b18fe5$var$transition_in(if_block, 1);
                    if_block.m(footer, null);
                }
            } else if (if_block) {
                $9f2dc49079b18fe5$var$group_outros();
                $9f2dc49079b18fe5$var$transition_out(if_block, 1, 1, ()=>{
                    if_block = null;
                });
                $9f2dc49079b18fe5$var$check_outros();
            }
        },
        i (local) {
            if (current) return;
            $9f2dc49079b18fe5$var$transition_in(if_block);
            current = true;
        },
        o (local) {
            $9f2dc49079b18fe5$var$transition_out(if_block);
            current = false;
        },
        d (detaching) {
            if (detaching) $9f2dc49079b18fe5$var$detach(footer);
            if (if_block) if_block.d();
        }
    };
}
function $9f2dc49079b18fe5$var$instance$7($$self, $$props, $$invalidate) {
    let buttons;
    let { step: step } = $$props;
    $$self.$$set = ($$props)=>{
        if ("step" in $$props) $$invalidate(0, step = $$props.step);
    };
    $$self.$$.update = ()=>{
        if ($$self.$$.dirty & /*step*/ 1) $$invalidate(1, buttons = step.options.buttons);
    };
    return [
        step,
        buttons
    ];
}
class $9f2dc49079b18fe5$var$Shepherd_footer extends $9f2dc49079b18fe5$var$SvelteComponent {
    constructor(options){
        super();
        $9f2dc49079b18fe5$var$init(this, options, $9f2dc49079b18fe5$var$instance$7, $9f2dc49079b18fe5$var$create_fragment$7, $9f2dc49079b18fe5$var$safe_not_equal, {
            step: 0
        });
    }
}
/* src/components/shepherd-cancel-icon.svelte generated by Svelte v4.2.19 */ function $9f2dc49079b18fe5$var$create_fragment$6(ctx) {
    let button;
    let span;
    let button_aria_label_value;
    let mounted;
    let dispose;
    return {
        c () {
            button = $9f2dc49079b18fe5$var$element("button");
            span = $9f2dc49079b18fe5$var$element("span");
            span.textContent = "\xd7";
            $9f2dc49079b18fe5$var$attr(span, "aria-hidden", "true");
            $9f2dc49079b18fe5$var$attr(button, "aria-label", button_aria_label_value = /*cancelIcon*/ ctx[0].label ? /*cancelIcon*/ ctx[0].label : "Close Tour");
            $9f2dc49079b18fe5$var$attr(button, "class", "shepherd-cancel-icon");
            $9f2dc49079b18fe5$var$attr(button, "type", "button");
        },
        m (target, anchor) {
            $9f2dc49079b18fe5$var$insert(target, button, anchor);
            $9f2dc49079b18fe5$var$append(button, span);
            if (!mounted) {
                dispose = $9f2dc49079b18fe5$var$listen(button, "click", /*handleCancelClick*/ ctx[1]);
                mounted = true;
            }
        },
        p (ctx, [dirty]) {
            if (dirty & /*cancelIcon*/ 1 && button_aria_label_value !== (button_aria_label_value = /*cancelIcon*/ ctx[0].label ? /*cancelIcon*/ ctx[0].label : "Close Tour")) $9f2dc49079b18fe5$var$attr(button, "aria-label", button_aria_label_value);
        },
        i: $9f2dc49079b18fe5$var$noop,
        o: $9f2dc49079b18fe5$var$noop,
        d (detaching) {
            if (detaching) $9f2dc49079b18fe5$var$detach(button);
            mounted = false;
            dispose();
        }
    };
}
function $9f2dc49079b18fe5$var$instance$6($$self, $$props, $$invalidate) {
    let { cancelIcon: cancelIcon, step: step } = $$props;
    /**
  * Add a click listener to the cancel link that cancels the tour
  */ const handleCancelClick = (e)=>{
        e.preventDefault();
        step.cancel();
    };
    $$self.$$set = ($$props)=>{
        if ("cancelIcon" in $$props) $$invalidate(0, cancelIcon = $$props.cancelIcon);
        if ("step" in $$props) $$invalidate(2, step = $$props.step);
    };
    return [
        cancelIcon,
        handleCancelClick,
        step
    ];
}
class $9f2dc49079b18fe5$var$Shepherd_cancel_icon extends $9f2dc49079b18fe5$var$SvelteComponent {
    constructor(options){
        super();
        $9f2dc49079b18fe5$var$init(this, options, $9f2dc49079b18fe5$var$instance$6, $9f2dc49079b18fe5$var$create_fragment$6, $9f2dc49079b18fe5$var$safe_not_equal, {
            cancelIcon: 0,
            step: 2
        });
    }
}
/* src/components/shepherd-title.svelte generated by Svelte v4.2.19 */ function $9f2dc49079b18fe5$var$create_fragment$5(ctx) {
    let h3;
    return {
        c () {
            h3 = $9f2dc49079b18fe5$var$element("h3");
            $9f2dc49079b18fe5$var$attr(h3, "id", /*labelId*/ ctx[1]);
            $9f2dc49079b18fe5$var$attr(h3, "class", "shepherd-title");
        },
        m (target, anchor) {
            $9f2dc49079b18fe5$var$insert(target, h3, anchor);
            /*h3_binding*/ ctx[3](h3);
        },
        p (ctx, [dirty]) {
            if (dirty & /*labelId*/ 2) $9f2dc49079b18fe5$var$attr(h3, "id", /*labelId*/ ctx[1]);
        },
        i: $9f2dc49079b18fe5$var$noop,
        o: $9f2dc49079b18fe5$var$noop,
        d (detaching) {
            if (detaching) $9f2dc49079b18fe5$var$detach(h3);
            /*h3_binding*/ ctx[3](null);
        }
    };
}
function $9f2dc49079b18fe5$var$instance$5($$self, $$props, $$invalidate) {
    let { labelId: labelId, element: element, title: title } = $$props;
    $9f2dc49079b18fe5$var$afterUpdate(()=>{
        if ($9f2dc49079b18fe5$var$isFunction(title)) $$invalidate(2, title = title());
        $$invalidate(0, element.innerHTML = title, element);
    });
    function h3_binding($$value) {
        $9f2dc49079b18fe5$var$binding_callbacks[$$value ? "unshift" : "push"](()=>{
            element = $$value;
            $$invalidate(0, element);
        });
    }
    $$self.$$set = ($$props)=>{
        if ("labelId" in $$props) $$invalidate(1, labelId = $$props.labelId);
        if ("element" in $$props) $$invalidate(0, element = $$props.element);
        if ("title" in $$props) $$invalidate(2, title = $$props.title);
    };
    return [
        element,
        labelId,
        title,
        h3_binding
    ];
}
class $9f2dc49079b18fe5$var$Shepherd_title extends $9f2dc49079b18fe5$var$SvelteComponent {
    constructor(options){
        super();
        $9f2dc49079b18fe5$var$init(this, options, $9f2dc49079b18fe5$var$instance$5, $9f2dc49079b18fe5$var$create_fragment$5, $9f2dc49079b18fe5$var$safe_not_equal, {
            labelId: 1,
            element: 0,
            title: 2
        });
    }
}
/* src/components/shepherd-header.svelte generated by Svelte v4.2.19 */ function $9f2dc49079b18fe5$var$create_if_block_1$1(ctx) {
    let shepherdtitle;
    let current;
    shepherdtitle = new $9f2dc49079b18fe5$var$Shepherd_title({
        props: {
            labelId: /*labelId*/ ctx[0],
            title: /*title*/ ctx[2]
        }
    });
    return {
        c () {
            $9f2dc49079b18fe5$var$create_component(shepherdtitle.$$.fragment);
        },
        m (target, anchor) {
            $9f2dc49079b18fe5$var$mount_component(shepherdtitle, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const shepherdtitle_changes = {};
            if (dirty & /*labelId*/ 1) shepherdtitle_changes.labelId = /*labelId*/ ctx[0];
            if (dirty & /*title*/ 4) shepherdtitle_changes.title = /*title*/ ctx[2];
            shepherdtitle.$set(shepherdtitle_changes);
        },
        i (local) {
            if (current) return;
            $9f2dc49079b18fe5$var$transition_in(shepherdtitle.$$.fragment, local);
            current = true;
        },
        o (local) {
            $9f2dc49079b18fe5$var$transition_out(shepherdtitle.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            $9f2dc49079b18fe5$var$destroy_component(shepherdtitle, detaching);
        }
    };
}
// (19:2) {#if cancelIcon && cancelIcon.enabled}
function $9f2dc49079b18fe5$var$create_if_block$2(ctx) {
    let shepherdcancelicon;
    let current;
    shepherdcancelicon = new $9f2dc49079b18fe5$var$Shepherd_cancel_icon({
        props: {
            cancelIcon: /*cancelIcon*/ ctx[3],
            step: /*step*/ ctx[1]
        }
    });
    return {
        c () {
            $9f2dc49079b18fe5$var$create_component(shepherdcancelicon.$$.fragment);
        },
        m (target, anchor) {
            $9f2dc49079b18fe5$var$mount_component(shepherdcancelicon, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const shepherdcancelicon_changes = {};
            if (dirty & /*cancelIcon*/ 8) shepherdcancelicon_changes.cancelIcon = /*cancelIcon*/ ctx[3];
            if (dirty & /*step*/ 2) shepherdcancelicon_changes.step = /*step*/ ctx[1];
            shepherdcancelicon.$set(shepherdcancelicon_changes);
        },
        i (local) {
            if (current) return;
            $9f2dc49079b18fe5$var$transition_in(shepherdcancelicon.$$.fragment, local);
            current = true;
        },
        o (local) {
            $9f2dc49079b18fe5$var$transition_out(shepherdcancelicon.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            $9f2dc49079b18fe5$var$destroy_component(shepherdcancelicon, detaching);
        }
    };
}
function $9f2dc49079b18fe5$var$create_fragment$4(ctx) {
    let header;
    let t;
    let current;
    let if_block0 = /*title*/ ctx[2] && $9f2dc49079b18fe5$var$create_if_block_1$1(ctx);
    let if_block1 = /*cancelIcon*/ ctx[3] && /*cancelIcon*/ ctx[3].enabled && $9f2dc49079b18fe5$var$create_if_block$2(ctx);
    return {
        c () {
            header = $9f2dc49079b18fe5$var$element("header");
            if (if_block0) if_block0.c();
            t = $9f2dc49079b18fe5$var$space();
            if (if_block1) if_block1.c();
            $9f2dc49079b18fe5$var$attr(header, "class", "shepherd-header");
        },
        m (target, anchor) {
            $9f2dc49079b18fe5$var$insert(target, header, anchor);
            if (if_block0) if_block0.m(header, null);
            $9f2dc49079b18fe5$var$append(header, t);
            if (if_block1) if_block1.m(header, null);
            current = true;
        },
        p (ctx, [dirty]) {
            if (/*title*/ ctx[2]) {
                if (if_block0) {
                    if_block0.p(ctx, dirty);
                    if (dirty & /*title*/ 4) $9f2dc49079b18fe5$var$transition_in(if_block0, 1);
                } else {
                    if_block0 = $9f2dc49079b18fe5$var$create_if_block_1$1(ctx);
                    if_block0.c();
                    $9f2dc49079b18fe5$var$transition_in(if_block0, 1);
                    if_block0.m(header, t);
                }
            } else if (if_block0) {
                $9f2dc49079b18fe5$var$group_outros();
                $9f2dc49079b18fe5$var$transition_out(if_block0, 1, 1, ()=>{
                    if_block0 = null;
                });
                $9f2dc49079b18fe5$var$check_outros();
            }
            if (/*cancelIcon*/ ctx[3] && /*cancelIcon*/ ctx[3].enabled) {
                if (if_block1) {
                    if_block1.p(ctx, dirty);
                    if (dirty & /*cancelIcon*/ 8) $9f2dc49079b18fe5$var$transition_in(if_block1, 1);
                } else {
                    if_block1 = $9f2dc49079b18fe5$var$create_if_block$2(ctx);
                    if_block1.c();
                    $9f2dc49079b18fe5$var$transition_in(if_block1, 1);
                    if_block1.m(header, null);
                }
            } else if (if_block1) {
                $9f2dc49079b18fe5$var$group_outros();
                $9f2dc49079b18fe5$var$transition_out(if_block1, 1, 1, ()=>{
                    if_block1 = null;
                });
                $9f2dc49079b18fe5$var$check_outros();
            }
        },
        i (local) {
            if (current) return;
            $9f2dc49079b18fe5$var$transition_in(if_block0);
            $9f2dc49079b18fe5$var$transition_in(if_block1);
            current = true;
        },
        o (local) {
            $9f2dc49079b18fe5$var$transition_out(if_block0);
            $9f2dc49079b18fe5$var$transition_out(if_block1);
            current = false;
        },
        d (detaching) {
            if (detaching) $9f2dc49079b18fe5$var$detach(header);
            if (if_block0) if_block0.d();
            if (if_block1) if_block1.d();
        }
    };
}
function $9f2dc49079b18fe5$var$instance$4($$self, $$props, $$invalidate) {
    let { labelId: labelId, step: step } = $$props;
    let title, cancelIcon;
    $$self.$$set = ($$props)=>{
        if ("labelId" in $$props) $$invalidate(0, labelId = $$props.labelId);
        if ("step" in $$props) $$invalidate(1, step = $$props.step);
    };
    $$self.$$.update = ()=>{
        if ($$self.$$.dirty & /*step*/ 2) {
            $$invalidate(2, title = step.options.title);
            $$invalidate(3, cancelIcon = step.options.cancelIcon);
        }
    };
    return [
        labelId,
        step,
        title,
        cancelIcon
    ];
}
class $9f2dc49079b18fe5$var$Shepherd_header extends $9f2dc49079b18fe5$var$SvelteComponent {
    constructor(options){
        super();
        $9f2dc49079b18fe5$var$init(this, options, $9f2dc49079b18fe5$var$instance$4, $9f2dc49079b18fe5$var$create_fragment$4, $9f2dc49079b18fe5$var$safe_not_equal, {
            labelId: 0,
            step: 1
        });
    }
}
/* src/components/shepherd-text.svelte generated by Svelte v4.2.19 */ function $9f2dc49079b18fe5$var$create_fragment$3(ctx) {
    let div;
    return {
        c () {
            div = $9f2dc49079b18fe5$var$element("div");
            $9f2dc49079b18fe5$var$attr(div, "class", "shepherd-text");
            $9f2dc49079b18fe5$var$attr(div, "id", /*descriptionId*/ ctx[1]);
        },
        m (target, anchor) {
            $9f2dc49079b18fe5$var$insert(target, div, anchor);
            /*div_binding*/ ctx[3](div);
        },
        p (ctx, [dirty]) {
            if (dirty & /*descriptionId*/ 2) $9f2dc49079b18fe5$var$attr(div, "id", /*descriptionId*/ ctx[1]);
        },
        i: $9f2dc49079b18fe5$var$noop,
        o: $9f2dc49079b18fe5$var$noop,
        d (detaching) {
            if (detaching) $9f2dc49079b18fe5$var$detach(div);
            /*div_binding*/ ctx[3](null);
        }
    };
}
function $9f2dc49079b18fe5$var$instance$3($$self, $$props, $$invalidate) {
    let { descriptionId: descriptionId, element: element, step: step } = $$props;
    $9f2dc49079b18fe5$var$afterUpdate(()=>{
        let { text: text } = step.options;
        if ($9f2dc49079b18fe5$var$isFunction(text)) text = text.call(step);
        if ($9f2dc49079b18fe5$var$isHTMLElement$1(text)) element.appendChild(text);
        else $$invalidate(0, element.innerHTML = text, element);
    });
    function div_binding($$value) {
        $9f2dc49079b18fe5$var$binding_callbacks[$$value ? "unshift" : "push"](()=>{
            element = $$value;
            $$invalidate(0, element);
        });
    }
    $$self.$$set = ($$props)=>{
        if ("descriptionId" in $$props) $$invalidate(1, descriptionId = $$props.descriptionId);
        if ("element" in $$props) $$invalidate(0, element = $$props.element);
        if ("step" in $$props) $$invalidate(2, step = $$props.step);
    };
    return [
        element,
        descriptionId,
        step,
        div_binding
    ];
}
class $9f2dc49079b18fe5$var$Shepherd_text extends $9f2dc49079b18fe5$var$SvelteComponent {
    constructor(options){
        super();
        $9f2dc49079b18fe5$var$init(this, options, $9f2dc49079b18fe5$var$instance$3, $9f2dc49079b18fe5$var$create_fragment$3, $9f2dc49079b18fe5$var$safe_not_equal, {
            descriptionId: 1,
            element: 0,
            step: 2
        });
    }
}
/* src/components/shepherd-content.svelte generated by Svelte v4.2.19 */ function $9f2dc49079b18fe5$var$create_if_block_2(ctx) {
    let shepherdheader;
    let current;
    shepherdheader = new $9f2dc49079b18fe5$var$Shepherd_header({
        props: {
            labelId: /*labelId*/ ctx[1],
            step: /*step*/ ctx[2]
        }
    });
    return {
        c () {
            $9f2dc49079b18fe5$var$create_component(shepherdheader.$$.fragment);
        },
        m (target, anchor) {
            $9f2dc49079b18fe5$var$mount_component(shepherdheader, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const shepherdheader_changes = {};
            if (dirty & /*labelId*/ 2) shepherdheader_changes.labelId = /*labelId*/ ctx[1];
            if (dirty & /*step*/ 4) shepherdheader_changes.step = /*step*/ ctx[2];
            shepherdheader.$set(shepherdheader_changes);
        },
        i (local) {
            if (current) return;
            $9f2dc49079b18fe5$var$transition_in(shepherdheader.$$.fragment, local);
            current = true;
        },
        o (local) {
            $9f2dc49079b18fe5$var$transition_out(shepherdheader.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            $9f2dc49079b18fe5$var$destroy_component(shepherdheader, detaching);
        }
    };
}
// (15:2) {#if !isUndefined(step.options.text)}
function $9f2dc49079b18fe5$var$create_if_block_1(ctx) {
    let shepherdtext;
    let current;
    shepherdtext = new $9f2dc49079b18fe5$var$Shepherd_text({
        props: {
            descriptionId: /*descriptionId*/ ctx[0],
            step: /*step*/ ctx[2]
        }
    });
    return {
        c () {
            $9f2dc49079b18fe5$var$create_component(shepherdtext.$$.fragment);
        },
        m (target, anchor) {
            $9f2dc49079b18fe5$var$mount_component(shepherdtext, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const shepherdtext_changes = {};
            if (dirty & /*descriptionId*/ 1) shepherdtext_changes.descriptionId = /*descriptionId*/ ctx[0];
            if (dirty & /*step*/ 4) shepherdtext_changes.step = /*step*/ ctx[2];
            shepherdtext.$set(shepherdtext_changes);
        },
        i (local) {
            if (current) return;
            $9f2dc49079b18fe5$var$transition_in(shepherdtext.$$.fragment, local);
            current = true;
        },
        o (local) {
            $9f2dc49079b18fe5$var$transition_out(shepherdtext.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            $9f2dc49079b18fe5$var$destroy_component(shepherdtext, detaching);
        }
    };
}
// (19:2) {#if Array.isArray(step.options.buttons) && step.options.buttons.length}
function $9f2dc49079b18fe5$var$create_if_block$1(ctx) {
    let shepherdfooter;
    let current;
    shepherdfooter = new $9f2dc49079b18fe5$var$Shepherd_footer({
        props: {
            step: /*step*/ ctx[2]
        }
    });
    return {
        c () {
            $9f2dc49079b18fe5$var$create_component(shepherdfooter.$$.fragment);
        },
        m (target, anchor) {
            $9f2dc49079b18fe5$var$mount_component(shepherdfooter, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const shepherdfooter_changes = {};
            if (dirty & /*step*/ 4) shepherdfooter_changes.step = /*step*/ ctx[2];
            shepherdfooter.$set(shepherdfooter_changes);
        },
        i (local) {
            if (current) return;
            $9f2dc49079b18fe5$var$transition_in(shepherdfooter.$$.fragment, local);
            current = true;
        },
        o (local) {
            $9f2dc49079b18fe5$var$transition_out(shepherdfooter.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            $9f2dc49079b18fe5$var$destroy_component(shepherdfooter, detaching);
        }
    };
}
function $9f2dc49079b18fe5$var$create_fragment$2(ctx) {
    let div;
    let show_if_2 = !$9f2dc49079b18fe5$var$isUndefined(/*step*/ ctx[2].options.title) || /*step*/ ctx[2].options.cancelIcon && /*step*/ ctx[2].options.cancelIcon.enabled;
    let t0;
    let show_if_1 = !$9f2dc49079b18fe5$var$isUndefined(/*step*/ ctx[2].options.text);
    let t1;
    let show_if = Array.isArray(/*step*/ ctx[2].options.buttons) && /*step*/ ctx[2].options.buttons.length;
    let current;
    let if_block0 = show_if_2 && $9f2dc49079b18fe5$var$create_if_block_2(ctx);
    let if_block1 = show_if_1 && $9f2dc49079b18fe5$var$create_if_block_1(ctx);
    let if_block2 = show_if && $9f2dc49079b18fe5$var$create_if_block$1(ctx);
    return {
        c () {
            div = $9f2dc49079b18fe5$var$element("div");
            if (if_block0) if_block0.c();
            t0 = $9f2dc49079b18fe5$var$space();
            if (if_block1) if_block1.c();
            t1 = $9f2dc49079b18fe5$var$space();
            if (if_block2) if_block2.c();
            $9f2dc49079b18fe5$var$attr(div, "class", "shepherd-content");
        },
        m (target, anchor) {
            $9f2dc49079b18fe5$var$insert(target, div, anchor);
            if (if_block0) if_block0.m(div, null);
            $9f2dc49079b18fe5$var$append(div, t0);
            if (if_block1) if_block1.m(div, null);
            $9f2dc49079b18fe5$var$append(div, t1);
            if (if_block2) if_block2.m(div, null);
            current = true;
        },
        p (ctx, [dirty]) {
            if (dirty & /*step*/ 4) show_if_2 = !$9f2dc49079b18fe5$var$isUndefined(/*step*/ ctx[2].options.title) || /*step*/ ctx[2].options.cancelIcon && /*step*/ ctx[2].options.cancelIcon.enabled;
            if (show_if_2) {
                if (if_block0) {
                    if_block0.p(ctx, dirty);
                    if (dirty & /*step*/ 4) $9f2dc49079b18fe5$var$transition_in(if_block0, 1);
                } else {
                    if_block0 = $9f2dc49079b18fe5$var$create_if_block_2(ctx);
                    if_block0.c();
                    $9f2dc49079b18fe5$var$transition_in(if_block0, 1);
                    if_block0.m(div, t0);
                }
            } else if (if_block0) {
                $9f2dc49079b18fe5$var$group_outros();
                $9f2dc49079b18fe5$var$transition_out(if_block0, 1, 1, ()=>{
                    if_block0 = null;
                });
                $9f2dc49079b18fe5$var$check_outros();
            }
            if (dirty & /*step*/ 4) show_if_1 = !$9f2dc49079b18fe5$var$isUndefined(/*step*/ ctx[2].options.text);
            if (show_if_1) {
                if (if_block1) {
                    if_block1.p(ctx, dirty);
                    if (dirty & /*step*/ 4) $9f2dc49079b18fe5$var$transition_in(if_block1, 1);
                } else {
                    if_block1 = $9f2dc49079b18fe5$var$create_if_block_1(ctx);
                    if_block1.c();
                    $9f2dc49079b18fe5$var$transition_in(if_block1, 1);
                    if_block1.m(div, t1);
                }
            } else if (if_block1) {
                $9f2dc49079b18fe5$var$group_outros();
                $9f2dc49079b18fe5$var$transition_out(if_block1, 1, 1, ()=>{
                    if_block1 = null;
                });
                $9f2dc49079b18fe5$var$check_outros();
            }
            if (dirty & /*step*/ 4) show_if = Array.isArray(/*step*/ ctx[2].options.buttons) && /*step*/ ctx[2].options.buttons.length;
            if (show_if) {
                if (if_block2) {
                    if_block2.p(ctx, dirty);
                    if (dirty & /*step*/ 4) $9f2dc49079b18fe5$var$transition_in(if_block2, 1);
                } else {
                    if_block2 = $9f2dc49079b18fe5$var$create_if_block$1(ctx);
                    if_block2.c();
                    $9f2dc49079b18fe5$var$transition_in(if_block2, 1);
                    if_block2.m(div, null);
                }
            } else if (if_block2) {
                $9f2dc49079b18fe5$var$group_outros();
                $9f2dc49079b18fe5$var$transition_out(if_block2, 1, 1, ()=>{
                    if_block2 = null;
                });
                $9f2dc49079b18fe5$var$check_outros();
            }
        },
        i (local) {
            if (current) return;
            $9f2dc49079b18fe5$var$transition_in(if_block0);
            $9f2dc49079b18fe5$var$transition_in(if_block1);
            $9f2dc49079b18fe5$var$transition_in(if_block2);
            current = true;
        },
        o (local) {
            $9f2dc49079b18fe5$var$transition_out(if_block0);
            $9f2dc49079b18fe5$var$transition_out(if_block1);
            $9f2dc49079b18fe5$var$transition_out(if_block2);
            current = false;
        },
        d (detaching) {
            if (detaching) $9f2dc49079b18fe5$var$detach(div);
            if (if_block0) if_block0.d();
            if (if_block1) if_block1.d();
            if (if_block2) if_block2.d();
        }
    };
}
function $9f2dc49079b18fe5$var$instance$2($$self, $$props, $$invalidate) {
    let { descriptionId: descriptionId, labelId: labelId, step: step } = $$props;
    $$self.$$set = ($$props)=>{
        if ("descriptionId" in $$props) $$invalidate(0, descriptionId = $$props.descriptionId);
        if ("labelId" in $$props) $$invalidate(1, labelId = $$props.labelId);
        if ("step" in $$props) $$invalidate(2, step = $$props.step);
    };
    return [
        descriptionId,
        labelId,
        step
    ];
}
class $9f2dc49079b18fe5$var$Shepherd_content extends $9f2dc49079b18fe5$var$SvelteComponent {
    constructor(options){
        super();
        $9f2dc49079b18fe5$var$init(this, options, $9f2dc49079b18fe5$var$instance$2, $9f2dc49079b18fe5$var$create_fragment$2, $9f2dc49079b18fe5$var$safe_not_equal, {
            descriptionId: 0,
            labelId: 1,
            step: 2
        });
    }
}
/* src/components/shepherd-element.svelte generated by Svelte v4.2.19 */ function $9f2dc49079b18fe5$var$create_if_block(ctx) {
    let div;
    return {
        c () {
            div = $9f2dc49079b18fe5$var$element("div");
            $9f2dc49079b18fe5$var$attr(div, "class", "shepherd-arrow");
            $9f2dc49079b18fe5$var$attr(div, "data-popper-arrow", "");
        },
        m (target, anchor) {
            $9f2dc49079b18fe5$var$insert(target, div, anchor);
        },
        d (detaching) {
            if (detaching) $9f2dc49079b18fe5$var$detach(div);
        }
    };
}
function $9f2dc49079b18fe5$var$create_fragment$1(ctx) {
    let dialog;
    let t;
    let shepherdcontent;
    let dialog_aria_describedby_value;
    let dialog_aria_labelledby_value;
    let current;
    let mounted;
    let dispose;
    let if_block = /*step*/ ctx[4].options.arrow && /*step*/ ctx[4].options.attachTo && /*step*/ ctx[4].options.attachTo.element && /*step*/ ctx[4].options.attachTo.on && $9f2dc49079b18fe5$var$create_if_block();
    shepherdcontent = new $9f2dc49079b18fe5$var$Shepherd_content({
        props: {
            descriptionId: /*descriptionId*/ ctx[2],
            labelId: /*labelId*/ ctx[3],
            step: /*step*/ ctx[4]
        }
    });
    let dialog_levels = [
        {
            "aria-describedby": dialog_aria_describedby_value = !$9f2dc49079b18fe5$var$isUndefined(/*step*/ ctx[4].options.text) ? /*descriptionId*/ ctx[2] : null
        },
        {
            "aria-labelledby": dialog_aria_labelledby_value = /*step*/ ctx[4].options.title ? /*labelId*/ ctx[3] : null
        },
        /*dataStepId*/ ctx[1],
        {
            open: "true"
        }
    ];
    let dialog_data = {};
    for(let i = 0; i < dialog_levels.length; i += 1)dialog_data = $9f2dc49079b18fe5$var$assign(dialog_data, dialog_levels[i]);
    return {
        c () {
            dialog = $9f2dc49079b18fe5$var$element("dialog");
            if (if_block) if_block.c();
            t = $9f2dc49079b18fe5$var$space();
            $9f2dc49079b18fe5$var$create_component(shepherdcontent.$$.fragment);
            $9f2dc49079b18fe5$var$set_attributes(dialog, dialog_data);
            $9f2dc49079b18fe5$var$toggle_class(dialog, "shepherd-has-cancel-icon", /*hasCancelIcon*/ ctx[5]);
            $9f2dc49079b18fe5$var$toggle_class(dialog, "shepherd-has-title", /*hasTitle*/ ctx[6]);
            $9f2dc49079b18fe5$var$toggle_class(dialog, "shepherd-element", true);
        },
        m (target, anchor) {
            $9f2dc49079b18fe5$var$insert(target, dialog, anchor);
            if (if_block) if_block.m(dialog, null);
            $9f2dc49079b18fe5$var$append(dialog, t);
            $9f2dc49079b18fe5$var$mount_component(shepherdcontent, dialog, null);
            /*dialog_binding*/ ctx[18](dialog);
            current = true;
            if (!mounted) {
                dispose = $9f2dc49079b18fe5$var$listen(dialog, "keydown", /*handleKeyDown*/ ctx[7]);
                mounted = true;
            }
        },
        p (ctx, [dirty]) {
            if (/*step*/ ctx[4].options.arrow && /*step*/ ctx[4].options.attachTo && /*step*/ ctx[4].options.attachTo.element && /*step*/ ctx[4].options.attachTo.on) {
                if (if_block) ;
                else {
                    if_block = $9f2dc49079b18fe5$var$create_if_block();
                    if_block.c();
                    if_block.m(dialog, t);
                }
            } else if (if_block) {
                if_block.d(1);
                if_block = null;
            }
            const shepherdcontent_changes = {};
            if (dirty & /*descriptionId*/ 4) shepherdcontent_changes.descriptionId = /*descriptionId*/ ctx[2];
            if (dirty & /*labelId*/ 8) shepherdcontent_changes.labelId = /*labelId*/ ctx[3];
            if (dirty & /*step*/ 16) shepherdcontent_changes.step = /*step*/ ctx[4];
            shepherdcontent.$set(shepherdcontent_changes);
            $9f2dc49079b18fe5$var$set_attributes(dialog, dialog_data = $9f2dc49079b18fe5$var$get_spread_update(dialog_levels, [
                (!current || dirty & /*step, descriptionId*/ 20 && dialog_aria_describedby_value !== (dialog_aria_describedby_value = !$9f2dc49079b18fe5$var$isUndefined(/*step*/ ctx[4].options.text) ? /*descriptionId*/ ctx[2] : null)) && {
                    "aria-describedby": dialog_aria_describedby_value
                },
                (!current || dirty & /*step, labelId*/ 24 && dialog_aria_labelledby_value !== (dialog_aria_labelledby_value = /*step*/ ctx[4].options.title ? /*labelId*/ ctx[3] : null)) && {
                    "aria-labelledby": dialog_aria_labelledby_value
                },
                dirty & /*dataStepId*/ 2 && /*dataStepId*/ ctx[1],
                {
                    open: "true"
                }
            ]));
            $9f2dc49079b18fe5$var$toggle_class(dialog, "shepherd-has-cancel-icon", /*hasCancelIcon*/ ctx[5]);
            $9f2dc49079b18fe5$var$toggle_class(dialog, "shepherd-has-title", /*hasTitle*/ ctx[6]);
            $9f2dc49079b18fe5$var$toggle_class(dialog, "shepherd-element", true);
        },
        i (local) {
            if (current) return;
            $9f2dc49079b18fe5$var$transition_in(shepherdcontent.$$.fragment, local);
            current = true;
        },
        o (local) {
            $9f2dc49079b18fe5$var$transition_out(shepherdcontent.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            if (detaching) $9f2dc49079b18fe5$var$detach(dialog);
            if (if_block) if_block.d();
            $9f2dc49079b18fe5$var$destroy_component(shepherdcontent);
            /*dialog_binding*/ ctx[18](null);
            mounted = false;
            dispose();
        }
    };
}
const $9f2dc49079b18fe5$var$KEY_TAB = 9;
const $9f2dc49079b18fe5$var$KEY_ESC = 27;
const $9f2dc49079b18fe5$var$LEFT_ARROW = 37;
const $9f2dc49079b18fe5$var$RIGHT_ARROW = 39;
function $9f2dc49079b18fe5$var$getClassesArray(classes) {
    return classes.split(" ").filter((className)=>!!className.length);
}
function $9f2dc49079b18fe5$var$instance$1($$self, $$props, $$invalidate) {
    let { attachToElement: attachToElement, attachTofocusableDialogElements: attachTofocusableDialogElements, classPrefix: classPrefix, element: element, descriptionId: descriptionId, focusableAttachToElements: focusableAttachToElements, firstFocusableAttachToElement: firstFocusableAttachToElement, lastFocusableAttachToElement: lastFocusableAttachToElement, firstFocusableDialogElement: firstFocusableDialogElement, focusableDialogElements: focusableDialogElements, lastFocusableDialogElement: lastFocusableDialogElement, labelId: labelId, step: step, dataStepId: dataStepId } = $$props;
    let hasCancelIcon, hasTitle, classes;
    const getElement = ()=>element;
    $9f2dc49079b18fe5$var$onMount(()=>{
        // Get all elements that are focusable
        $$invalidate(1, dataStepId = {
            [`data-${classPrefix}shepherd-step-id`]: step.id
        });
        $$invalidate(13, focusableDialogElements = [
            ...element.querySelectorAll('a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex="0"]')
        ]);
        $$invalidate(12, firstFocusableDialogElement = focusableDialogElements[0]);
        $$invalidate(14, lastFocusableDialogElement = focusableDialogElements[focusableDialogElements.length - 1]);
        const attachTo = step._getResolvedAttachToOptions();
        if (attachTo != null && attachTo.element) {
            $$invalidate(8, attachToElement = attachTo.element);
            $$invalidate(8, attachToElement.tabIndex = 0, attachToElement);
            $$invalidate(9, focusableAttachToElements = [
                attachToElement,
                ...attachToElement.querySelectorAll('a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex="0"]')
            ]);
            $$invalidate(10, firstFocusableAttachToElement = focusableAttachToElements[0]);
            $$invalidate(11, lastFocusableAttachToElement = focusableAttachToElements[focusableAttachToElements.length - 1]);
            // Add keydown listener to attachTo element
            attachToElement.addEventListener("keydown", handleKeyDown);
        }
    });
    $9f2dc49079b18fe5$var$onDestroy(()=>{
        var _attachToElement;
        (_attachToElement = attachToElement) == null || _attachToElement.removeEventListener("keydown", handleKeyDown);
    });
    $9f2dc49079b18fe5$var$afterUpdate(()=>{
        if (classes !== step.options.classes) updateDynamicClasses();
    });
    function updateDynamicClasses() {
        removeClasses(classes);
        classes = step.options.classes;
        addClasses(classes);
    }
    function removeClasses(classes) {
        if ($9f2dc49079b18fe5$var$isString(classes)) {
            const oldClasses = $9f2dc49079b18fe5$var$getClassesArray(classes);
            if (oldClasses.length) element.classList.remove(...oldClasses);
        }
    }
    function addClasses(classes) {
        if ($9f2dc49079b18fe5$var$isString(classes)) {
            const newClasses = $9f2dc49079b18fe5$var$getClassesArray(classes);
            if (newClasses.length) element.classList.add(...newClasses);
        }
    }
    /**
  * Setup keydown events to allow closing the modal with ESC
  *
  * Borrowed from this great post! https://bitsofco.de/accessible-modal-dialog/
  *
  * @private
  */ const handleKeyDown = (e)=>{
        const { tour: tour } = step;
        switch(e.keyCode){
            case $9f2dc49079b18fe5$var$KEY_TAB:
                if ((!focusableAttachToElements || focusableAttachToElements.length === 0) && focusableDialogElements.length === 0) {
                    e.preventDefault();
                    break;
                }
                // Backward tab
                if (e.shiftKey) {
                    // If at the beginning of elements in the dialog, go to last element in attachTo
                    // If attachToElement is undefined, circle around to the last element in the dialog.
                    if (document.activeElement === firstFocusableDialogElement || document.activeElement.classList.contains("shepherd-element")) {
                        var _lastFocusableAttachT;
                        e.preventDefault();
                        ((_lastFocusableAttachT = lastFocusableAttachToElement) != null ? _lastFocusableAttachT : lastFocusableDialogElement).focus();
                    } else // If at the beginning of elements in attachTo
                    if (document.activeElement === firstFocusableAttachToElement) {
                        e.preventDefault();
                        lastFocusableDialogElement.focus();
                    }
                } else {
                    if (document.activeElement === lastFocusableDialogElement) {
                        var _firstFocusableAttach;
                        e.preventDefault();
                        ((_firstFocusableAttach = firstFocusableAttachToElement) != null ? _firstFocusableAttach : firstFocusableDialogElement).focus();
                    } else // If at the end of elements in attachTo
                    if (document.activeElement === lastFocusableAttachToElement) {
                        e.preventDefault();
                        firstFocusableDialogElement.focus();
                    }
                }
                break;
            case $9f2dc49079b18fe5$var$KEY_ESC:
                if (tour.options.exitOnEsc) {
                    e.preventDefault();
                    e.stopPropagation();
                    step.cancel();
                }
                break;
            case $9f2dc49079b18fe5$var$LEFT_ARROW:
                if (tour.options.keyboardNavigation) {
                    e.preventDefault();
                    e.stopPropagation();
                    tour.back();
                }
                break;
            case $9f2dc49079b18fe5$var$RIGHT_ARROW:
                if (tour.options.keyboardNavigation) {
                    e.preventDefault();
                    e.stopPropagation();
                    tour.next();
                }
                break;
        }
    };
    function dialog_binding($$value) {
        $9f2dc49079b18fe5$var$binding_callbacks[$$value ? "unshift" : "push"](()=>{
            element = $$value;
            $$invalidate(0, element);
        });
    }
    $$self.$$set = ($$props)=>{
        if ("attachToElement" in $$props) $$invalidate(8, attachToElement = $$props.attachToElement);
        if ("attachTofocusableDialogElements" in $$props) $$invalidate(15, attachTofocusableDialogElements = $$props.attachTofocusableDialogElements);
        if ("classPrefix" in $$props) $$invalidate(16, classPrefix = $$props.classPrefix);
        if ("element" in $$props) $$invalidate(0, element = $$props.element);
        if ("descriptionId" in $$props) $$invalidate(2, descriptionId = $$props.descriptionId);
        if ("focusableAttachToElements" in $$props) $$invalidate(9, focusableAttachToElements = $$props.focusableAttachToElements);
        if ("firstFocusableAttachToElement" in $$props) $$invalidate(10, firstFocusableAttachToElement = $$props.firstFocusableAttachToElement);
        if ("lastFocusableAttachToElement" in $$props) $$invalidate(11, lastFocusableAttachToElement = $$props.lastFocusableAttachToElement);
        if ("firstFocusableDialogElement" in $$props) $$invalidate(12, firstFocusableDialogElement = $$props.firstFocusableDialogElement);
        if ("focusableDialogElements" in $$props) $$invalidate(13, focusableDialogElements = $$props.focusableDialogElements);
        if ("lastFocusableDialogElement" in $$props) $$invalidate(14, lastFocusableDialogElement = $$props.lastFocusableDialogElement);
        if ("labelId" in $$props) $$invalidate(3, labelId = $$props.labelId);
        if ("step" in $$props) $$invalidate(4, step = $$props.step);
        if ("dataStepId" in $$props) $$invalidate(1, dataStepId = $$props.dataStepId);
    };
    $$self.$$.update = ()=>{
        if ($$self.$$.dirty & /*step*/ 16) {
            $$invalidate(5, hasCancelIcon = step.options && step.options.cancelIcon && step.options.cancelIcon.enabled);
            $$invalidate(6, hasTitle = step.options && step.options.title);
        }
    };
    return [
        element,
        dataStepId,
        descriptionId,
        labelId,
        step,
        hasCancelIcon,
        hasTitle,
        handleKeyDown,
        attachToElement,
        focusableAttachToElements,
        firstFocusableAttachToElement,
        lastFocusableAttachToElement,
        firstFocusableDialogElement,
        focusableDialogElements,
        lastFocusableDialogElement,
        attachTofocusableDialogElements,
        classPrefix,
        getElement,
        dialog_binding
    ];
}
class $9f2dc49079b18fe5$var$Shepherd_element extends $9f2dc49079b18fe5$var$SvelteComponent {
    constructor(options){
        super();
        $9f2dc49079b18fe5$var$init(this, options, $9f2dc49079b18fe5$var$instance$1, $9f2dc49079b18fe5$var$create_fragment$1, $9f2dc49079b18fe5$var$safe_not_equal, {
            attachToElement: 8,
            attachTofocusableDialogElements: 15,
            classPrefix: 16,
            element: 0,
            descriptionId: 2,
            focusableAttachToElements: 9,
            firstFocusableAttachToElement: 10,
            lastFocusableAttachToElement: 11,
            firstFocusableDialogElement: 12,
            focusableDialogElements: 13,
            lastFocusableDialogElement: 14,
            labelId: 3,
            step: 4,
            dataStepId: 1,
            getElement: 17
        });
    }
    get getElement() {
        return this.$$.ctx[17];
    }
}
/**
 * The options for the step
 */ /**
 * A class representing steps to be added to a tour.
 * @extends {Evented}
 */ class $9f2dc49079b18fe5$var$Step extends $9f2dc49079b18fe5$var$Evented {
    constructor(tour, options = {}){
        super();
        this._resolvedAttachTo = void 0;
        this._resolvedExtraHighlightElements = void 0;
        this.classPrefix = void 0;
        this.el = void 0;
        this.target = void 0;
        this.tour = void 0;
        this.tour = tour;
        this.classPrefix = this.tour.options ? $9f2dc49079b18fe5$var$normalizePrefix(this.tour.options.classPrefix) : "";
        // @ts-expect-error TODO: investigate where styles comes from
        this.styles = tour.styles;
        /**
     * Resolved attachTo options. Due to lazy evaluation, we only resolve the options during `before-show` phase.
     * Do not use this directly, use the _getResolvedAttachToOptions method instead.
     * @type {StepOptionsAttachTo | null}
     * @private
     */ this._resolvedAttachTo = null;
        $9f2dc49079b18fe5$var$autoBind(this);
        this._setOptions(options);
        return this;
    }
    /**
   * Cancel the tour
   * Triggers the `cancel` event
   */ cancel() {
        this.tour.cancel();
        this.trigger("cancel");
    }
    /**
   * Complete the tour
   * Triggers the `complete` event
   */ complete() {
        this.tour.complete();
        this.trigger("complete");
    }
    /**
   * Remove the step, delete the step's element, and destroy the FloatingUI instance for the step.
   * Triggers `destroy` event
   */ destroy() {
        $9f2dc49079b18fe5$var$destroyTooltip(this);
        if ($9f2dc49079b18fe5$var$isHTMLElement$1(this.el)) {
            this.el.remove();
            this.el = null;
        }
        this._updateStepTargetOnHide();
        this.trigger("destroy");
    }
    /**
   * Returns the tour for the step
   * @return The tour instance
   */ getTour() {
        return this.tour;
    }
    /**
   * Hide the step
   */ hide() {
        var _this$tour$modal;
        (_this$tour$modal = this.tour.modal) == null || _this$tour$modal.hide();
        this.trigger("before-hide");
        if (this.el) this.el.hidden = true;
        this._updateStepTargetOnHide();
        this.trigger("hide");
    }
    /**
   * Resolves attachTo options.
   * @returns {{}|{element, on}}
   */ _resolveExtraHiglightElements() {
        this._resolvedExtraHighlightElements = $9f2dc49079b18fe5$var$parseExtraHighlights(this);
        return this._resolvedExtraHighlightElements;
    }
    /**
   * Resolves attachTo options.
   * @returns {{}|{element, on}}
   */ _resolveAttachToOptions() {
        this._resolvedAttachTo = $9f2dc49079b18fe5$var$parseAttachTo(this);
        return this._resolvedAttachTo;
    }
    /**
   * A selector for resolved attachTo options.
   * @returns {{}|{element, on}}
   * @private
   */ _getResolvedAttachToOptions() {
        if (this._resolvedAttachTo === null) return this._resolveAttachToOptions();
        return this._resolvedAttachTo;
    }
    /**
   * Check if the step is open and visible
   * @return True if the step is open and visible
   */ isOpen() {
        return Boolean(this.el && !this.el.hidden);
    }
    /**
   * Wraps `_show` and ensures `beforeShowPromise` resolves before calling show
   */ show() {
        if ($9f2dc49079b18fe5$var$isFunction(this.options.beforeShowPromise)) return Promise.resolve(this.options.beforeShowPromise()).then(()=>this._show());
        return Promise.resolve(this._show());
    }
    /**
   * Updates the options of the step.
   *
   * @param {StepOptions} options The options for the step
   */ updateStepOptions(options) {
        Object.assign(this.options, options);
        // @ts-expect-error TODO: get types for Svelte components
        if (this.shepherdElementComponent) // @ts-expect-error TODO: get types for Svelte components
        this.shepherdElementComponent.$set({
            step: this
        });
    }
    /**
   * Returns the element for the step
   * @return {HTMLElement|null|undefined} The element instance. undefined if it has never been shown, null if it has been destroyed
   */ getElement() {
        return this.el;
    }
    /**
   * Returns the target for the step
   * @return {HTMLElement|null|undefined} The element instance. undefined if it has never been shown, null if query string has not been found
   */ getTarget() {
        return this.target;
    }
    /**
   * Creates Shepherd element for step based on options
   *
   * @return {HTMLElement} The DOM element for the step tooltip
   * @private
   */ _createTooltipContent() {
        const descriptionId = `${this.id}-description`;
        const labelId = `${this.id}-label`;
        // @ts-expect-error TODO: get types for Svelte components
        this.shepherdElementComponent = new $9f2dc49079b18fe5$var$Shepherd_element({
            target: this.tour.options.stepsContainer || document.body,
            props: {
                classPrefix: this.classPrefix,
                descriptionId: descriptionId,
                labelId: labelId,
                step: this,
                // @ts-expect-error TODO: investigate where styles comes from
                styles: this.styles
            }
        });
        // @ts-expect-error TODO: get types for Svelte components
        return this.shepherdElementComponent.getElement();
    }
    /**
   * If a custom scrollToHandler is defined, call that, otherwise do the generic
   * scrollIntoView call.
   *
   * @param {boolean | ScrollIntoViewOptions} scrollToOptions - If true, uses the default `scrollIntoView`,
   * if an object, passes that object as the params to `scrollIntoView` i.e. `{ behavior: 'smooth', block: 'center' }`
   * @private
   */ _scrollTo(scrollToOptions) {
        const { element: element } = this._getResolvedAttachToOptions();
        if ($9f2dc49079b18fe5$var$isFunction(this.options.scrollToHandler)) this.options.scrollToHandler(element);
        else if ($9f2dc49079b18fe5$var$isElement$1(element) && typeof element.scrollIntoView === "function") element.scrollIntoView(scrollToOptions);
    }
    /**
   * _getClassOptions gets all possible classes for the step
   * @param {StepOptions} stepOptions The step specific options
   * @returns {string} unique string from array of classes
   */ _getClassOptions(stepOptions) {
        const defaultStepOptions = this.tour && this.tour.options && this.tour.options.defaultStepOptions;
        const stepClasses = stepOptions.classes ? stepOptions.classes : "";
        const defaultStepOptionsClasses = defaultStepOptions && defaultStepOptions.classes ? defaultStepOptions.classes : "";
        const allClasses = [
            ...stepClasses.split(" "),
            ...defaultStepOptionsClasses.split(" ")
        ];
        const uniqClasses = new Set(allClasses);
        return Array.from(uniqClasses).join(" ").trim();
    }
    /**
   * Sets the options for the step, maps `when` to events, sets up buttons
   * @param options - The options for the step
   */ _setOptions(options = {}) {
        let tourOptions = this.tour && this.tour.options && this.tour.options.defaultStepOptions;
        tourOptions = $9f2dc49079b18fe5$var$deepmerge({}, tourOptions || {});
        this.options = Object.assign({
            arrow: true
        }, tourOptions, options, $9f2dc49079b18fe5$var$mergeTooltipConfig(tourOptions, options));
        const { when: when } = this.options;
        this.options.classes = this._getClassOptions(options);
        this.destroy();
        this.id = this.options.id || `step-${$9f2dc49079b18fe5$var$uuid()}`;
        if (when) Object.keys(when).forEach((event)=>{
            // @ts-expect-error TODO: fix this type error
            this.on(event, when[event], this);
        });
    }
    /**
   * Create the element and set up the FloatingUI instance
   * @private
   */ _setupElements() {
        if (!$9f2dc49079b18fe5$var$isUndefined(this.el)) this.destroy();
        this.el = this._createTooltipContent();
        if (this.options.advanceOn) $9f2dc49079b18fe5$var$bindAdvance(this);
        // The tooltip implementation details are handled outside of the Step
        // object.
        $9f2dc49079b18fe5$var$setupTooltip(this);
    }
    /**
   * Triggers `before-show`, generates the tooltip DOM content,
   * sets up a FloatingUI instance for the tooltip, then triggers `show`.
   * @private
   */ _show() {
        var _this$tour$modal2;
        this.trigger("before-show");
        // Force resolve to make sure the options are updated on subsequent shows.
        this._resolveAttachToOptions();
        this._resolveExtraHiglightElements();
        this._setupElements();
        if (!this.tour.modal) this.tour.setupModal();
        (_this$tour$modal2 = this.tour.modal) == null || _this$tour$modal2.setupForStep(this);
        this._styleTargetElementForStep(this);
        if (this.el) this.el.hidden = false;
        // start scrolling to target before showing the step
        if (this.options.scrollTo) setTimeout(()=>{
            this._scrollTo(this.options.scrollTo);
        });
        if (this.el) this.el.hidden = false;
        // @ts-expect-error TODO: get types for Svelte components
        const content = this.shepherdElementComponent.getElement();
        const target = this.target || document.body;
        const extraHighlightElements = this._resolvedExtraHighlightElements;
        target.classList.add(`${this.classPrefix}shepherd-enabled`);
        target.classList.add(`${this.classPrefix}shepherd-target`);
        content.classList.add("shepherd-enabled");
        extraHighlightElements == null || extraHighlightElements.forEach((el)=>{
            el.classList.add(`${this.classPrefix}shepherd-enabled`);
            el.classList.add(`${this.classPrefix}shepherd-target`);
        });
        this.trigger("show");
    }
    /**
   * Modulates the styles of the passed step's target element, based on the step's options and
   * the tour's `modal` option, to visually emphasize the element
   *
   * @param {Step} step The step object that attaches to the element
   * @private
   */ _styleTargetElementForStep(step) {
        const targetElement = step.target;
        const extraHighlightElements = step._resolvedExtraHighlightElements;
        if (!targetElement) return;
        const highlightClass = step.options.highlightClass;
        if (highlightClass) {
            targetElement.classList.add(highlightClass);
            extraHighlightElements == null || extraHighlightElements.forEach((el)=>el.classList.add(highlightClass));
        }
        targetElement.classList.remove("shepherd-target-click-disabled");
        extraHighlightElements == null || extraHighlightElements.forEach((el)=>el.classList.remove("shepherd-target-click-disabled"));
        if (step.options.canClickTarget === false) {
            targetElement.classList.add("shepherd-target-click-disabled");
            extraHighlightElements == null || extraHighlightElements.forEach((el)=>el.classList.add("shepherd-target-click-disabled"));
        }
    }
    /**
   * When a step is hidden, remove the highlightClass and 'shepherd-enabled'
   * and 'shepherd-target' classes
   * @private
   */ _updateStepTargetOnHide() {
        const target = this.target || document.body;
        const extraHighlightElements = this._resolvedExtraHighlightElements;
        const highlightClass = this.options.highlightClass;
        if (highlightClass) {
            target.classList.remove(highlightClass);
            extraHighlightElements == null || extraHighlightElements.forEach((el)=>el.classList.remove(highlightClass));
        }
        target.classList.remove("shepherd-target-click-disabled", `${this.classPrefix}shepherd-enabled`, `${this.classPrefix}shepherd-target`);
        extraHighlightElements == null || extraHighlightElements.forEach((el)=>{
            el.classList.remove("shepherd-target-click-disabled", `${this.classPrefix}shepherd-enabled`, `${this.classPrefix}shepherd-target`);
        });
    }
}
/**
 * Cleanup the steps and set pointerEvents back to 'auto'
 * @param tour The tour object
 */ function $9f2dc49079b18fe5$var$cleanupSteps(tour) {
    if (tour) {
        const { steps: steps } = tour;
        steps.forEach((step)=>{
            if (step.options && step.options.canClickTarget === false && step.options.attachTo) {
                if ($9f2dc49079b18fe5$var$isHTMLElement$1(step.target)) step.target.classList.remove("shepherd-target-click-disabled");
                if (step._resolvedExtraHighlightElements) step._resolvedExtraHighlightElements.forEach((element)=>{
                    if ($9f2dc49079b18fe5$var$isHTMLElement$1(element)) element.classList.remove("shepherd-target-click-disabled");
                });
            }
        });
    }
}
/**
 * Generates the svg path data for a rounded rectangle overlay
 * @param dimension - Dimensions of rectangle.
 * @param dimension.width - Width.
 * @param dimension.height - Height.
 * @param dimension.x - Offset from top left corner in x axis. default 0.
 * @param dimension.y - Offset from top left corner in y axis. default 0.
 * @param dimension.r - Corner Radius. Keep this smaller than half of width or height.
 * @returns Rounded rectangle overlay path data.
 */ function $9f2dc49079b18fe5$var$makeOverlayPath(overlayPaths) {
    let openings = "";
    const { innerWidth: w, innerHeight: h } = window;
    overlayPaths.forEach((overlayPath)=>{
        const { width: width, height: height, x: x = 0, y: y = 0, r: r = 0 } = overlayPath;
        const { topLeft: topLeft = 0, topRight: topRight = 0, bottomRight: bottomRight = 0, bottomLeft: bottomLeft = 0 } = typeof r === "number" ? {
            topLeft: r,
            topRight: r,
            bottomRight: r,
            bottomLeft: r
        } : r;
        openings += `M${x + topLeft},${y}\
      a${topLeft},${topLeft},0,0,0-${topLeft},${topLeft}\
      V${height + y - bottomLeft}\
      a${bottomLeft},${bottomLeft},0,0,0,${bottomLeft},${bottomLeft}\
      H${width + x - bottomRight}\
      a${bottomRight},${bottomRight},0,0,0,${bottomRight}-${bottomRight}\
      V${y + topRight}\
      a${topRight},${topRight},0,0,0-${topRight}-${topRight}\
      Z`;
    });
    return `M${w},${h}\
          H0\
          V0\
          H${w}\
          V${h}\
          Z\
          ${openings}`.replace(/\s/g, "");
}
/* src/components/shepherd-modal.svelte generated by Svelte v4.2.19 */ function $9f2dc49079b18fe5$var$create_fragment(ctx) {
    let svg;
    let path;
    let svg_class_value;
    let mounted;
    let dispose;
    return {
        c () {
            svg = $9f2dc49079b18fe5$var$svg_element("svg");
            path = $9f2dc49079b18fe5$var$svg_element("path");
            $9f2dc49079b18fe5$var$attr(path, "d", /*pathDefinition*/ ctx[2]);
            $9f2dc49079b18fe5$var$attr(svg, "class", svg_class_value = `${ctx[1] ? "shepherd-modal-is-visible" : ""} shepherd-modal-overlay-container`);
        },
        m (target, anchor) {
            $9f2dc49079b18fe5$var$insert(target, svg, anchor);
            $9f2dc49079b18fe5$var$append(svg, path);
            /*svg_binding*/ ctx[11](svg);
            if (!mounted) {
                dispose = $9f2dc49079b18fe5$var$listen(svg, "touchmove", /*_preventModalOverlayTouch*/ ctx[3]);
                mounted = true;
            }
        },
        p (ctx, [dirty]) {
            if (dirty & /*pathDefinition*/ 4) $9f2dc49079b18fe5$var$attr(path, "d", /*pathDefinition*/ ctx[2]);
            if (dirty & /*modalIsVisible*/ 2 && svg_class_value !== (svg_class_value = `${ctx[1] ? "shepherd-modal-is-visible" : ""} shepherd-modal-overlay-container`)) $9f2dc49079b18fe5$var$attr(svg, "class", svg_class_value);
        },
        i: $9f2dc49079b18fe5$var$noop,
        o: $9f2dc49079b18fe5$var$noop,
        d (detaching) {
            if (detaching) $9f2dc49079b18fe5$var$detach(svg);
            /*svg_binding*/ ctx[11](null);
            mounted = false;
            dispose();
        }
    };
}
function $9f2dc49079b18fe5$var$_getScrollParent(element) {
    if (!element) return null;
    const isHtmlElement = element instanceof HTMLElement;
    const overflowY = isHtmlElement && window.getComputedStyle(element).overflowY;
    const isScrollable = overflowY !== "hidden" && overflowY !== "visible";
    if (isScrollable && element.scrollHeight >= element.clientHeight) return element;
    return $9f2dc49079b18fe5$var$_getScrollParent(element.parentElement);
}
/**
 * Get the top and left offset required to position the modal overlay cutout
 * when the target element is within an iframe
 * @param {HTMLElement} element The target element
 * @private
 */ function $9f2dc49079b18fe5$var$_getIframeOffset(element) {
    let offset = {
        top: 0,
        left: 0
    };
    if (!element) return offset;
    let targetWindow = element.ownerDocument.defaultView;
    while(targetWindow !== window.top){
        var _targetWindow;
        const targetIframe = (_targetWindow = targetWindow) == null ? void 0 : _targetWindow.frameElement;
        if (targetIframe) {
            var _targetIframeRect$scr, _targetIframeRect$scr2;
            const targetIframeRect = targetIframe.getBoundingClientRect();
            offset.top += targetIframeRect.top + ((_targetIframeRect$scr = targetIframeRect.scrollTop) != null ? _targetIframeRect$scr : 0);
            offset.left += targetIframeRect.left + ((_targetIframeRect$scr2 = targetIframeRect.scrollLeft) != null ? _targetIframeRect$scr2 : 0);
        }
        targetWindow = targetWindow.parent;
    }
    return offset;
}
/**
 * Get the visible height of the target element relative to its scrollParent.
 * If there is no scroll parent, the height of the element is returned.
 *
 * @param {HTMLElement} element The target element
 * @param {HTMLElement} [scrollParent] The scrollable parent element
 * @returns {{y: number, height: number}}
 * @private
 */ function $9f2dc49079b18fe5$var$_getVisibleHeight(element, scrollParent) {
    const elementRect = element.getBoundingClientRect();
    let top = elementRect.y || elementRect.top;
    let bottom = elementRect.bottom || top + elementRect.height;
    if (scrollParent) {
        const scrollRect = scrollParent.getBoundingClientRect();
        const scrollTop = scrollRect.y || scrollRect.top;
        const scrollBottom = scrollRect.bottom || scrollTop + scrollRect.height;
        top = Math.max(top, scrollTop);
        bottom = Math.min(bottom, scrollBottom);
    }
    const height = Math.max(bottom - top, 0); // Default to 0 if height is negative
    return {
        y: top,
        height: height
    };
}
function $9f2dc49079b18fe5$var$instance($$self, $$props, $$invalidate) {
    let { element: element, openingProperties: openingProperties } = $$props;
    let modalIsVisible = false;
    let rafId = undefined;
    let pathDefinition;
    closeModalOpening();
    const getElement = ()=>element;
    function closeModalOpening() {
        $$invalidate(4, openingProperties = [
            {
                width: 0,
                height: 0,
                x: 0,
                y: 0,
                r: 0
            }
        ]);
    }
    function hide() {
        $$invalidate(1, modalIsVisible = false);
        // Ensure we cleanup all event listeners when we hide the modal
        _cleanupStepEventListeners();
    }
    function positionModal(modalOverlayOpeningPadding = 0, modalOverlayOpeningRadius = 0, modalOverlayOpeningXOffset = 0, modalOverlayOpeningYOffset = 0, scrollParent, targetElement, extraHighlights) {
        if (targetElement) {
            const elementsToHighlight = [
                targetElement,
                ...extraHighlights || []
            ];
            $$invalidate(4, openingProperties = []);
            for (const element of elementsToHighlight){
                if (!element) continue;
                // Skip duplicate elements
                if (elementsToHighlight.indexOf(element) !== elementsToHighlight.lastIndexOf(element)) continue;
                const { y: y, height: height } = $9f2dc49079b18fe5$var$_getVisibleHeight(element, scrollParent);
                const { x: x, width: width, left: left } = element.getBoundingClientRect();
                // Check if the element is contained by another element
                const isContained = elementsToHighlight.some((otherElement)=>{
                    if (otherElement === element) return false;
                    const otherRect = otherElement.getBoundingClientRect();
                    return x >= otherRect.left && x + width <= otherRect.right && y >= otherRect.top && y + height <= otherRect.bottom;
                });
                if (isContained) continue;
                // getBoundingClientRect is not consistent. Some browsers use x and y, while others use left and top
                openingProperties.push({
                    width: width + modalOverlayOpeningPadding * 2,
                    height: height + modalOverlayOpeningPadding * 2,
                    x: (x || left) + modalOverlayOpeningXOffset - modalOverlayOpeningPadding,
                    y: y + modalOverlayOpeningYOffset - modalOverlayOpeningPadding,
                    r: modalOverlayOpeningRadius
                });
            }
        } else closeModalOpening();
    }
    function setupForStep(step) {
        // Ensure we move listeners from the previous step, before we setup new ones
        _cleanupStepEventListeners();
        if (step.tour.options.useModalOverlay) {
            _styleForStep(step);
            show();
        } else hide();
    }
    function show() {
        $$invalidate(1, modalIsVisible = true);
    }
    const _preventModalBodyTouch = (e)=>{
        e.preventDefault();
    };
    const _preventModalOverlayTouch = (e)=>{
        e.stopPropagation();
    };
    /**
  * Add touchmove event listener
  * @private
  */ function _addStepEventListeners() {
        // Prevents window from moving on touch.
        window.addEventListener("touchmove", _preventModalBodyTouch, {
            passive: false
        });
    }
    /**
  * Cancel the requestAnimationFrame loop and remove touchmove event listeners
  * @private
  */ function _cleanupStepEventListeners() {
        if (rafId) {
            cancelAnimationFrame(rafId);
            rafId = undefined;
        }
        window.removeEventListener("touchmove", _preventModalBodyTouch, {
            passive: false
        });
    }
    /**
  * Style the modal for the step
  * @param {Step} step The step to style the opening for
  * @private
  */ function _styleForStep(step) {
        const { modalOverlayOpeningPadding: modalOverlayOpeningPadding, modalOverlayOpeningRadius: modalOverlayOpeningRadius, modalOverlayOpeningXOffset: modalOverlayOpeningXOffset = 0, modalOverlayOpeningYOffset: modalOverlayOpeningYOffset = 0 } = step.options;
        const iframeOffset = $9f2dc49079b18fe5$var$_getIframeOffset(step.target);
        const scrollParent = $9f2dc49079b18fe5$var$_getScrollParent(step.target);
        // Setup recursive function to call requestAnimationFrame to update the modal opening position
        const rafLoop = ()=>{
            rafId = undefined;
            positionModal(modalOverlayOpeningPadding, modalOverlayOpeningRadius, modalOverlayOpeningXOffset + iframeOffset.left, modalOverlayOpeningYOffset + iframeOffset.top, scrollParent, step.target, step._resolvedExtraHighlightElements);
            rafId = requestAnimationFrame(rafLoop);
        };
        rafLoop();
        _addStepEventListeners();
    }
    function svg_binding($$value) {
        $9f2dc49079b18fe5$var$binding_callbacks[$$value ? "unshift" : "push"](()=>{
            element = $$value;
            $$invalidate(0, element);
        });
    }
    $$self.$$set = ($$props)=>{
        if ("element" in $$props) $$invalidate(0, element = $$props.element);
        if ("openingProperties" in $$props) $$invalidate(4, openingProperties = $$props.openingProperties);
    };
    $$self.$$.update = ()=>{
        if ($$self.$$.dirty & /*openingProperties*/ 16) $$invalidate(2, pathDefinition = $9f2dc49079b18fe5$var$makeOverlayPath(openingProperties));
    };
    return [
        element,
        modalIsVisible,
        pathDefinition,
        _preventModalOverlayTouch,
        openingProperties,
        getElement,
        closeModalOpening,
        hide,
        positionModal,
        setupForStep,
        show,
        svg_binding
    ];
}
class $9f2dc49079b18fe5$var$Shepherd_modal extends $9f2dc49079b18fe5$var$SvelteComponent {
    constructor(options){
        super();
        $9f2dc49079b18fe5$var$init(this, options, $9f2dc49079b18fe5$var$instance, $9f2dc49079b18fe5$var$create_fragment, $9f2dc49079b18fe5$var$safe_not_equal, {
            element: 0,
            openingProperties: 4,
            getElement: 5,
            closeModalOpening: 6,
            hide: 7,
            positionModal: 8,
            setupForStep: 9,
            show: 10
        });
    }
    get getElement() {
        return this.$$.ctx[5];
    }
    get closeModalOpening() {
        return this.$$.ctx[6];
    }
    get hide() {
        return this.$$.ctx[7];
    }
    get positionModal() {
        return this.$$.ctx[8];
    }
    get setupForStep() {
        return this.$$.ctx[9];
    }
    get show() {
        return this.$$.ctx[10];
    }
}
/**
 * The options for the tour
 */ class $9f2dc49079b18fe5$export$788b3677e442107c extends $9f2dc49079b18fe5$var$Evented {
    constructor(){
        super();
        this.activeTour = void 0;
        $9f2dc49079b18fe5$var$autoBind(this);
    }
}
/**
 * Class representing the site tour
 * @extends {Evented}
 */ class $9f2dc49079b18fe5$var$Tour extends $9f2dc49079b18fe5$var$Evented {
    constructor(options = {}){
        super();
        this.trackedEvents = [
            "active",
            "cancel",
            "complete",
            "show"
        ];
        this.classPrefix = void 0;
        this.currentStep = void 0;
        this.focusedElBeforeOpen = void 0;
        this.id = void 0;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.modal = void 0;
        this.options = void 0;
        this.steps = void 0;
        $9f2dc49079b18fe5$var$autoBind(this);
        const defaultTourOptions = {
            exitOnEsc: true,
            keyboardNavigation: true
        };
        this.options = Object.assign({}, defaultTourOptions, options);
        this.classPrefix = $9f2dc49079b18fe5$var$normalizePrefix(this.options.classPrefix);
        this.steps = [];
        this.addSteps(this.options.steps);
        // Pass these events onto the global Shepherd object
        const events = [
            "active",
            "cancel",
            "complete",
            "inactive",
            "show",
            "start"
        ];
        events.map((event)=>{
            ((e)=>{
                this.on(e, (opts)=>{
                    opts = opts || {};
                    opts["tour"] = this;
                    $9f2dc49079b18fe5$export$2e2bcd8739ae039.trigger(e, opts);
                });
            })(event);
        });
        this._setTourID(options.id);
        return this;
    }
    /**
   * Adds a new step to the tour
   * @param {StepOptions} options - An object containing step options or a Step instance
   * @param {number | undefined} index - The optional index to insert the step at. If undefined, the step
   * is added to the end of the array.
   * @return The newly added step
   */ addStep(options, index) {
        let step = options;
        if (!(step instanceof $9f2dc49079b18fe5$var$Step)) step = new $9f2dc49079b18fe5$var$Step(this, step);
        else step.tour = this;
        if (!$9f2dc49079b18fe5$var$isUndefined(index)) this.steps.splice(index, 0, step);
        else this.steps.push(step);
        return step;
    }
    /**
   * Add multiple steps to the tour
   * @param {Array<StepOptions> | Array<Step> | undefined} steps - The steps to add to the tour
   */ addSteps(steps) {
        if (Array.isArray(steps)) steps.forEach((step)=>{
            this.addStep(step);
        });
        return this;
    }
    /**
   * Go to the previous step in the tour
   */ back() {
        const index = this.steps.indexOf(this.currentStep);
        this.show(index - 1, false);
    }
    /**
   * Calls _done() triggering the 'cancel' event
   * If `confirmCancel` is true, will show a window.confirm before cancelling
   * If `confirmCancel` is a function, will call it and wait for the return value,
   * and only cancel when the value returned is true
   */ async cancel() {
        if (this.options.confirmCancel) {
            const cancelMessage = this.options.confirmCancelMessage || "Are you sure you want to stop the tour?";
            let stopTour;
            if ($9f2dc49079b18fe5$var$isFunction(this.options.confirmCancel)) stopTour = await this.options.confirmCancel();
            else stopTour = window.confirm(cancelMessage);
            if (stopTour) this._done("cancel");
        } else this._done("cancel");
    }
    /**
   * Calls _done() triggering the `complete` event
   */ complete() {
        this._done("complete");
    }
    /**
   * Gets the step from a given id
   * @param {number | string} id - The id of the step to retrieve
   * @return The step corresponding to the `id`
   */ getById(id) {
        return this.steps.find((step)=>{
            return step.id === id;
        });
    }
    /**
   * Gets the current step
   */ getCurrentStep() {
        return this.currentStep;
    }
    /**
   * Hide the current step
   */ hide() {
        const currentStep = this.getCurrentStep();
        if (currentStep) return currentStep.hide();
    }
    /**
   * Check if the tour is active
   */ isActive() {
        return $9f2dc49079b18fe5$export$2e2bcd8739ae039.activeTour === this;
    }
    /**
   * Go to the next step in the tour
   * If we are at the end, call `complete`
   */ next() {
        const index = this.steps.indexOf(this.currentStep);
        if (index === this.steps.length - 1) this.complete();
        else this.show(index + 1, true);
    }
    /**
   * Removes the step from the tour
   * @param {string} name - The id for the step to remove
   */ removeStep(name) {
        const current = this.getCurrentStep();
        // Find the step, destroy it and remove it from this.steps
        this.steps.some((step, i)=>{
            if (step.id === name) {
                if (step.isOpen()) step.hide();
                step.destroy();
                this.steps.splice(i, 1);
                return true;
            }
        });
        if (current && current.id === name) {
            this.currentStep = undefined;
            // If we have steps left, show the first one, otherwise just cancel the tour
            this.steps.length ? this.show(0) : this.cancel();
        }
    }
    /**
   * Show a specific step in the tour
   * @param {number | string} key - The key to look up the step by
   * @param {boolean} forward - True if we are going forward, false if backward
   */ show(key = 0, forward = true) {
        const step = $9f2dc49079b18fe5$var$isString(key) ? this.getById(key) : this.steps[key];
        if (step) {
            this._updateStateBeforeShow();
            const shouldSkipStep = $9f2dc49079b18fe5$var$isFunction(step.options.showOn) && !step.options.showOn();
            // If `showOn` returns false, we want to skip the step, otherwise, show the step like normal
            if (shouldSkipStep) this._skipStep(step, forward);
            else {
                this.currentStep = step;
                this.trigger("show", {
                    step: step,
                    previous: this.currentStep
                });
                step.show();
            }
        }
    }
    /**
   * Start the tour
   */ async start() {
        this.trigger("start");
        // Save the focused element before the tour opens
        this.focusedElBeforeOpen = document.activeElement;
        this.currentStep = null;
        this.setupModal();
        this._setupActiveTour();
        this.next();
    }
    /**
   * Called whenever the tour is cancelled or completed, basically anytime we exit the tour
   * @param {string} event - The event name to trigger
   * @private
   */ _done(event) {
        const index = this.steps.indexOf(this.currentStep);
        if (Array.isArray(this.steps)) this.steps.forEach((step)=>step.destroy());
        $9f2dc49079b18fe5$var$cleanupSteps(this);
        this.trigger(event, {
            index: index
        });
        $9f2dc49079b18fe5$export$2e2bcd8739ae039.activeTour = null;
        this.trigger("inactive", {
            tour: this
        });
        if (this.modal) this.modal.hide();
        if (event === "cancel" || event === "complete") {
            if (this.modal) {
                const modalContainer = document.querySelector(".shepherd-modal-overlay-container");
                if (modalContainer) {
                    modalContainer.remove();
                    this.modal = null;
                }
            }
        }
        // Focus the element that was focused before the tour started
        if ($9f2dc49079b18fe5$var$isHTMLElement$1(this.focusedElBeforeOpen)) this.focusedElBeforeOpen.focus();
    }
    /**
   * Make this tour "active"
   */ _setupActiveTour() {
        this.trigger("active", {
            tour: this
        });
        $9f2dc49079b18fe5$export$2e2bcd8739ae039.activeTour = this;
    }
    /**
   * setupModal create the modal container and instance
   */ setupModal() {
        this.modal = new $9f2dc49079b18fe5$var$Shepherd_modal({
            target: this.options.modalContainer || document.body,
            props: {
                // @ts-expect-error TODO: investigate where styles comes from
                styles: this.styles
            }
        });
    }
    /**
   * Called when `showOn` evaluates to false, to skip the step or complete the tour if it's the last step
   * @param {Step} step - The step to skip
   * @param {boolean} forward - True if we are going forward, false if backward
   * @private
   */ _skipStep(step, forward) {
        const index = this.steps.indexOf(step);
        if (index === this.steps.length - 1) this.complete();
        else {
            const nextIndex = forward ? index + 1 : index - 1;
            this.show(nextIndex, forward);
        }
    }
    /**
   * Before showing, hide the current step and if the tour is not
   * already active, call `this._setupActiveTour`.
   * @private
   */ _updateStateBeforeShow() {
        if (this.currentStep) this.currentStep.hide();
        if (!this.isActive()) this._setupActiveTour();
    }
    /**
   * Sets this.id to a provided tourName and id or `${tourName}--${uuid}`
   * @param {string} optionsId - True if we are going forward, false if backward
   * @private
   */ _setTourID(optionsId) {
        const tourName = this.options.tourName || "tour";
        const tourId = optionsId || $9f2dc49079b18fe5$var$uuid();
        this.id = `${tourName}--${tourId}`;
    }
}
/**
 * @public
 */ const $9f2dc49079b18fe5$export$2e2bcd8739ae039 = new $9f2dc49079b18fe5$export$788b3677e442107c();
const $9f2dc49079b18fe5$var$isServerSide = typeof window === "undefined";
$9f2dc49079b18fe5$export$2e2bcd8739ae039.Step = $9f2dc49079b18fe5$var$isServerSide ? $9f2dc49079b18fe5$var$StepNoOp : $9f2dc49079b18fe5$var$Step;
$9f2dc49079b18fe5$export$2e2bcd8739ae039.Tour = $9f2dc49079b18fe5$var$isServerSide ? $9f2dc49079b18fe5$var$TourNoOp : $9f2dc49079b18fe5$var$Tour;


var $af18dcae254e818d$exports = {};

(function(global, factory) {
    factory($af18dcae254e818d$exports, (parcelRequire("3vWD9")));
})($af18dcae254e818d$exports, function(exports1, core) {
    "use strict";
    /**
   * Custom positioning reference element.
   * @see https://floating-ui.com/docs/virtual-elements
   */ const min = Math.min;
    const max = Math.max;
    const round = Math.round;
    const floor = Math.floor;
    const createCoords = (v)=>({
            x: v,
            y: v
        });
    function hasWindow() {
        return typeof window !== "undefined";
    }
    function getNodeName(node) {
        if (isNode(node)) return (node.nodeName || "").toLowerCase();
        // Mocked nodes in testing environments may not be instances of Node. By
        // returning `#document` an infinite loop won't occur.
        // https://github.com/floating-ui/floating-ui/issues/2317
        return "#document";
    }
    function getWindow(node) {
        var _node$ownerDocument;
        return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
    }
    function getDocumentElement(node) {
        var _ref;
        return (_ref = (isNode(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
    }
    function isNode(value) {
        if (!hasWindow()) return false;
        return value instanceof Node || value instanceof getWindow(value).Node;
    }
    function isElement(value) {
        if (!hasWindow()) return false;
        return value instanceof Element || value instanceof getWindow(value).Element;
    }
    function isHTMLElement(value) {
        if (!hasWindow()) return false;
        return value instanceof HTMLElement || value instanceof getWindow(value).HTMLElement;
    }
    function isShadowRoot(value) {
        if (!hasWindow() || typeof ShadowRoot === "undefined") return false;
        return value instanceof ShadowRoot || value instanceof getWindow(value).ShadowRoot;
    }
    const invalidOverflowDisplayValues = /*#__PURE__*/ new Set([
        "inline",
        "contents"
    ]);
    function isOverflowElement(element) {
        const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = getComputedStyle$1(element);
        return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && !invalidOverflowDisplayValues.has(display);
    }
    const tableElements = /*#__PURE__*/ new Set([
        "table",
        "td",
        "th"
    ]);
    function isTableElement(element) {
        return tableElements.has(getNodeName(element));
    }
    const topLayerSelectors = [
        ":popover-open",
        ":modal"
    ];
    function isTopLayer(element) {
        return topLayerSelectors.some((selector)=>{
            try {
                return element.matches(selector);
            } catch (_e) {
                return false;
            }
        });
    }
    const transformProperties = [
        "transform",
        "translate",
        "scale",
        "rotate",
        "perspective"
    ];
    const willChangeValues = [
        "transform",
        "translate",
        "scale",
        "rotate",
        "perspective",
        "filter"
    ];
    const containValues = [
        "paint",
        "layout",
        "strict",
        "content"
    ];
    function isContainingBlock(elementOrCss) {
        const webkit = isWebKit();
        const css = isElement(elementOrCss) ? getComputedStyle$1(elementOrCss) : elementOrCss;
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        // https://drafts.csswg.org/css-transforms-2/#individual-transforms
        return transformProperties.some((value)=>css[value] ? css[value] !== "none" : false) || (css.containerType ? css.containerType !== "normal" : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== "none" : false) || !webkit && (css.filter ? css.filter !== "none" : false) || willChangeValues.some((value)=>(css.willChange || "").includes(value)) || containValues.some((value)=>(css.contain || "").includes(value));
    }
    function getContainingBlock(element) {
        let currentNode = getParentNode(element);
        while(isHTMLElement(currentNode) && !isLastTraversableNode(currentNode)){
            if (isContainingBlock(currentNode)) return currentNode;
            else if (isTopLayer(currentNode)) return null;
            currentNode = getParentNode(currentNode);
        }
        return null;
    }
    function isWebKit() {
        if (typeof CSS === "undefined" || !CSS.supports) return false;
        return CSS.supports("-webkit-backdrop-filter", "none");
    }
    const lastTraversableNodeNames = /*#__PURE__*/ new Set([
        "html",
        "body",
        "#document"
    ]);
    function isLastTraversableNode(node) {
        return lastTraversableNodeNames.has(getNodeName(node));
    }
    function getComputedStyle$1(element) {
        return getWindow(element).getComputedStyle(element);
    }
    function getNodeScroll(element) {
        if (isElement(element)) return {
            scrollLeft: element.scrollLeft,
            scrollTop: element.scrollTop
        };
        return {
            scrollLeft: element.scrollX,
            scrollTop: element.scrollY
        };
    }
    function getParentNode(node) {
        if (getNodeName(node) === "html") return node;
        const result = // Step into the shadow DOM of the parent of a slotted node.
        node.assignedSlot || // DOM Element detected.
        node.parentNode || // ShadowRoot detected.
        isShadowRoot(node) && node.host || // Fallback.
        getDocumentElement(node);
        return isShadowRoot(result) ? result.host : result;
    }
    function getNearestOverflowAncestor(node) {
        const parentNode = getParentNode(node);
        if (isLastTraversableNode(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
        if (isHTMLElement(parentNode) && isOverflowElement(parentNode)) return parentNode;
        return getNearestOverflowAncestor(parentNode);
    }
    function getOverflowAncestors(node, list, traverseIframes) {
        var _node$ownerDocument2;
        if (list === void 0) list = [];
        if (traverseIframes === void 0) traverseIframes = true;
        const scrollableAncestor = getNearestOverflowAncestor(node);
        const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
        const win = getWindow(scrollableAncestor);
        if (isBody) {
            const frameElement = getFrameElement(win);
            return list.concat(win, win.visualViewport || [], isOverflowElement(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? getOverflowAncestors(frameElement) : []);
        }
        return list.concat(scrollableAncestor, getOverflowAncestors(scrollableAncestor, [], traverseIframes));
    }
    function getFrameElement(win) {
        return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
    }
    function getCssDimensions(element) {
        const css = getComputedStyle$1(element);
        // In testing environments, the `width` and `height` properties are empty
        // strings for SVG elements, returning NaN. Fallback to `0` in this case.
        let width = parseFloat(css.width) || 0;
        let height = parseFloat(css.height) || 0;
        const hasOffset = isHTMLElement(element);
        const offsetWidth = hasOffset ? element.offsetWidth : width;
        const offsetHeight = hasOffset ? element.offsetHeight : height;
        const shouldFallback = round(width) !== offsetWidth || round(height) !== offsetHeight;
        if (shouldFallback) {
            width = offsetWidth;
            height = offsetHeight;
        }
        return {
            width: width,
            height: height,
            $: shouldFallback
        };
    }
    function unwrapElement(element) {
        return !isElement(element) ? element.contextElement : element;
    }
    function getScale(element) {
        const domElement = unwrapElement(element);
        if (!isHTMLElement(domElement)) return createCoords(1);
        const rect = domElement.getBoundingClientRect();
        const { width: width, height: height, $: $ } = getCssDimensions(domElement);
        let x = ($ ? round(rect.width) : rect.width) / width;
        let y = ($ ? round(rect.height) : rect.height) / height;
        // 0, NaN, or Infinity should always fallback to 1.
        if (!x || !Number.isFinite(x)) x = 1;
        if (!y || !Number.isFinite(y)) y = 1;
        return {
            x: x,
            y: y
        };
    }
    const noOffsets = /*#__PURE__*/ createCoords(0);
    function getVisualOffsets(element) {
        const win = getWindow(element);
        if (!isWebKit() || !win.visualViewport) return noOffsets;
        return {
            x: win.visualViewport.offsetLeft,
            y: win.visualViewport.offsetTop
        };
    }
    function shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
        if (isFixed === void 0) isFixed = false;
        if (!floatingOffsetParent || isFixed && floatingOffsetParent !== getWindow(element)) return false;
        return isFixed;
    }
    function getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
        if (includeScale === void 0) includeScale = false;
        if (isFixedStrategy === void 0) isFixedStrategy = false;
        const clientRect = element.getBoundingClientRect();
        const domElement = unwrapElement(element);
        let scale = createCoords(1);
        if (includeScale) {
            if (offsetParent) {
                if (isElement(offsetParent)) scale = getScale(offsetParent);
            } else scale = getScale(element);
        }
        const visualOffsets = shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? getVisualOffsets(domElement) : createCoords(0);
        let x = (clientRect.left + visualOffsets.x) / scale.x;
        let y = (clientRect.top + visualOffsets.y) / scale.y;
        let width = clientRect.width / scale.x;
        let height = clientRect.height / scale.y;
        if (domElement) {
            const win = getWindow(domElement);
            const offsetWin = offsetParent && isElement(offsetParent) ? getWindow(offsetParent) : offsetParent;
            let currentWin = win;
            let currentIFrame = getFrameElement(currentWin);
            while(currentIFrame && offsetParent && offsetWin !== currentWin){
                const iframeScale = getScale(currentIFrame);
                const iframeRect = currentIFrame.getBoundingClientRect();
                const css = getComputedStyle$1(currentIFrame);
                const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
                const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
                x *= iframeScale.x;
                y *= iframeScale.y;
                width *= iframeScale.x;
                height *= iframeScale.y;
                x += left;
                y += top;
                currentWin = getWindow(currentIFrame);
                currentIFrame = getFrameElement(currentWin);
            }
        }
        return core.rectToClientRect({
            width: width,
            height: height,
            x: x,
            y: y
        });
    }
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    function getWindowScrollBarX(element, rect) {
        const leftScroll = getNodeScroll(element).scrollLeft;
        if (!rect) return getBoundingClientRect(getDocumentElement(element)).left + leftScroll;
        return rect.left + leftScroll;
    }
    function getHTMLOffset(documentElement, scroll) {
        const htmlRect = documentElement.getBoundingClientRect();
        const x = htmlRect.left + scroll.scrollLeft - getWindowScrollBarX(documentElement, htmlRect);
        const y = htmlRect.top + scroll.scrollTop;
        return {
            x: x,
            y: y
        };
    }
    function convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
        let { elements: elements, rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
        const isFixed = strategy === "fixed";
        const documentElement = getDocumentElement(offsetParent);
        const topLayer = elements ? isTopLayer(elements.floating) : false;
        if (offsetParent === documentElement || topLayer && isFixed) return rect;
        let scroll = {
            scrollLeft: 0,
            scrollTop: 0
        };
        let scale = createCoords(1);
        const offsets = createCoords(0);
        const isOffsetParentAnElement = isHTMLElement(offsetParent);
        if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
            if (getNodeName(offsetParent) !== "body" || isOverflowElement(documentElement)) scroll = getNodeScroll(offsetParent);
            if (isHTMLElement(offsetParent)) {
                const offsetRect = getBoundingClientRect(offsetParent);
                scale = getScale(offsetParent);
                offsets.x = offsetRect.x + offsetParent.clientLeft;
                offsets.y = offsetRect.y + offsetParent.clientTop;
            }
        }
        const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? getHTMLOffset(documentElement, scroll) : createCoords(0);
        return {
            width: rect.width * scale.x,
            height: rect.height * scale.y,
            x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
            y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
        };
    }
    function getClientRects(element) {
        return Array.from(element.getClientRects());
    }
    // Gets the entire size of the scrollable document area, even extending outside
    // of the `<html>` and `<body>` rect bounds if horizontally scrollable.
    function getDocumentRect(element) {
        const html = getDocumentElement(element);
        const scroll = getNodeScroll(element);
        const body = element.ownerDocument.body;
        const width = max(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
        const height = max(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
        let x = -scroll.scrollLeft + getWindowScrollBarX(element);
        const y = -scroll.scrollTop;
        if (getComputedStyle$1(body).direction === "rtl") x += max(html.clientWidth, body.clientWidth) - width;
        return {
            width: width,
            height: height,
            x: x,
            y: y
        };
    }
    // Safety check: ensure the scrollbar space is reasonable in case this
    // calculation is affected by unusual styles.
    // Most scrollbars leave 15-18px of space.
    const SCROLLBAR_MAX = 25;
    function getViewportRect(element, strategy) {
        const win = getWindow(element);
        const html = getDocumentElement(element);
        const visualViewport = win.visualViewport;
        let width = html.clientWidth;
        let height = html.clientHeight;
        let x = 0;
        let y = 0;
        if (visualViewport) {
            width = visualViewport.width;
            height = visualViewport.height;
            const visualViewportBased = isWebKit();
            if (!visualViewportBased || visualViewportBased && strategy === "fixed") {
                x = visualViewport.offsetLeft;
                y = visualViewport.offsetTop;
            }
        }
        const windowScrollbarX = getWindowScrollBarX(html);
        // <html> `overflow: hidden` + `scrollbar-gutter: stable` reduces the
        // visual width of the <html> but this is not considered in the size
        // of `html.clientWidth`.
        if (windowScrollbarX <= 0) {
            const doc = html.ownerDocument;
            const body = doc.body;
            const bodyStyles = getComputedStyle(body);
            const bodyMarginInline = doc.compatMode === "CSS1Compat" ? parseFloat(bodyStyles.marginLeft) + parseFloat(bodyStyles.marginRight) || 0 : 0;
            const clippingStableScrollbarWidth = Math.abs(html.clientWidth - body.clientWidth - bodyMarginInline);
            if (clippingStableScrollbarWidth <= SCROLLBAR_MAX) width -= clippingStableScrollbarWidth;
        } else if (windowScrollbarX <= SCROLLBAR_MAX) // If the <body> scrollbar is on the left, the width needs to be extended
        // by the scrollbar amount so there isn't extra space on the right.
        width += windowScrollbarX;
        return {
            width: width,
            height: height,
            x: x,
            y: y
        };
    }
    const absoluteOrFixed = /*#__PURE__*/ new Set([
        "absolute",
        "fixed"
    ]);
    // Returns the inner client rect, subtracting scrollbars if present.
    function getInnerBoundingClientRect(element, strategy) {
        const clientRect = getBoundingClientRect(element, true, strategy === "fixed");
        const top = clientRect.top + element.clientTop;
        const left = clientRect.left + element.clientLeft;
        const scale = isHTMLElement(element) ? getScale(element) : createCoords(1);
        const width = element.clientWidth * scale.x;
        const height = element.clientHeight * scale.y;
        const x = left * scale.x;
        const y = top * scale.y;
        return {
            width: width,
            height: height,
            x: x,
            y: y
        };
    }
    function getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
        let rect;
        if (clippingAncestor === "viewport") rect = getViewportRect(element, strategy);
        else if (clippingAncestor === "document") rect = getDocumentRect(getDocumentElement(element));
        else if (isElement(clippingAncestor)) rect = getInnerBoundingClientRect(clippingAncestor, strategy);
        else {
            const visualOffsets = getVisualOffsets(element);
            rect = {
                x: clippingAncestor.x - visualOffsets.x,
                y: clippingAncestor.y - visualOffsets.y,
                width: clippingAncestor.width,
                height: clippingAncestor.height
            };
        }
        return core.rectToClientRect(rect);
    }
    function hasFixedPositionAncestor(element, stopNode) {
        const parentNode = getParentNode(element);
        if (parentNode === stopNode || !isElement(parentNode) || isLastTraversableNode(parentNode)) return false;
        return getComputedStyle$1(parentNode).position === "fixed" || hasFixedPositionAncestor(parentNode, stopNode);
    }
    // A "clipping ancestor" is an `overflow` element with the characteristic of
    // clipping (or hiding) child elements. This returns all clipping ancestors
    // of the given element up the tree.
    function getClippingElementAncestors(element, cache) {
        const cachedResult = cache.get(element);
        if (cachedResult) return cachedResult;
        let result = getOverflowAncestors(element, [], false).filter((el)=>isElement(el) && getNodeName(el) !== "body");
        let currentContainingBlockComputedStyle = null;
        const elementIsFixed = getComputedStyle$1(element).position === "fixed";
        let currentNode = elementIsFixed ? getParentNode(element) : element;
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        while(isElement(currentNode) && !isLastTraversableNode(currentNode)){
            const computedStyle = getComputedStyle$1(currentNode);
            const currentNodeIsContaining = isContainingBlock(currentNode);
            if (!currentNodeIsContaining && computedStyle.position === "fixed") currentContainingBlockComputedStyle = null;
            const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === "static" && !!currentContainingBlockComputedStyle && absoluteOrFixed.has(currentContainingBlockComputedStyle.position) || isOverflowElement(currentNode) && !currentNodeIsContaining && hasFixedPositionAncestor(element, currentNode);
            if (shouldDropCurrentNode) // Drop non-containing blocks.
            result = result.filter((ancestor)=>ancestor !== currentNode);
            else // Record last containing block for next iteration.
            currentContainingBlockComputedStyle = computedStyle;
            currentNode = getParentNode(currentNode);
        }
        cache.set(element, result);
        return result;
    }
    // Gets the maximum area that the element is visible in due to any number of
    // clipping ancestors.
    function getClippingRect(_ref) {
        let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
        const elementClippingAncestors = boundary === "clippingAncestors" ? isTopLayer(element) ? [] : getClippingElementAncestors(element, this._c) : [].concat(boundary);
        const clippingAncestors = [
            ...elementClippingAncestors,
            rootBoundary
        ];
        const firstClippingAncestor = clippingAncestors[0];
        const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
            const rect = getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
            accRect.top = max(rect.top, accRect.top);
            accRect.right = min(rect.right, accRect.right);
            accRect.bottom = min(rect.bottom, accRect.bottom);
            accRect.left = max(rect.left, accRect.left);
            return accRect;
        }, getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
        return {
            width: clippingRect.right - clippingRect.left,
            height: clippingRect.bottom - clippingRect.top,
            x: clippingRect.left,
            y: clippingRect.top
        };
    }
    function getDimensions(element) {
        const { width: width, height: height } = getCssDimensions(element);
        return {
            width: width,
            height: height
        };
    }
    function getRectRelativeToOffsetParent(element, offsetParent, strategy) {
        const isOffsetParentAnElement = isHTMLElement(offsetParent);
        const documentElement = getDocumentElement(offsetParent);
        const isFixed = strategy === "fixed";
        const rect = getBoundingClientRect(element, true, isFixed, offsetParent);
        let scroll = {
            scrollLeft: 0,
            scrollTop: 0
        };
        const offsets = createCoords(0);
        // If the <body> scrollbar appears on the left (e.g. RTL systems). Use
        // Firefox with layout.scrollbar.side = 3 in about:config to test this.
        function setLeftRTLScrollbarOffset() {
            offsets.x = getWindowScrollBarX(documentElement);
        }
        if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
            if (getNodeName(offsetParent) !== "body" || isOverflowElement(documentElement)) scroll = getNodeScroll(offsetParent);
            if (isOffsetParentAnElement) {
                const offsetRect = getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
                offsets.x = offsetRect.x + offsetParent.clientLeft;
                offsets.y = offsetRect.y + offsetParent.clientTop;
            } else if (documentElement) setLeftRTLScrollbarOffset();
        }
        if (isFixed && !isOffsetParentAnElement && documentElement) setLeftRTLScrollbarOffset();
        const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? getHTMLOffset(documentElement, scroll) : createCoords(0);
        const x = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
        const y = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
        return {
            x: x,
            y: y,
            width: rect.width,
            height: rect.height
        };
    }
    function isStaticPositioned(element) {
        return getComputedStyle$1(element).position === "static";
    }
    function getTrueOffsetParent(element, polyfill) {
        if (!isHTMLElement(element) || getComputedStyle$1(element).position === "fixed") return null;
        if (polyfill) return polyfill(element);
        let rawOffsetParent = element.offsetParent;
        // Firefox returns the <html> element as the offsetParent if it's non-static,
        // while Chrome and Safari return the <body> element. The <body> element must
        // be used to perform the correct calculations even if the <html> element is
        // non-static.
        if (getDocumentElement(element) === rawOffsetParent) rawOffsetParent = rawOffsetParent.ownerDocument.body;
        return rawOffsetParent;
    }
    // Gets the closest ancestor positioned element. Handles some edge cases,
    // such as table ancestors and cross browser bugs.
    function getOffsetParent(element, polyfill) {
        const win = getWindow(element);
        if (isTopLayer(element)) return win;
        if (!isHTMLElement(element)) {
            let svgOffsetParent = getParentNode(element);
            while(svgOffsetParent && !isLastTraversableNode(svgOffsetParent)){
                if (isElement(svgOffsetParent) && !isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
                svgOffsetParent = getParentNode(svgOffsetParent);
            }
            return win;
        }
        let offsetParent = getTrueOffsetParent(element, polyfill);
        while(offsetParent && isTableElement(offsetParent) && isStaticPositioned(offsetParent))offsetParent = getTrueOffsetParent(offsetParent, polyfill);
        if (offsetParent && isLastTraversableNode(offsetParent) && isStaticPositioned(offsetParent) && !isContainingBlock(offsetParent)) return win;
        return offsetParent || getContainingBlock(element) || win;
    }
    const getElementRects = async function(data) {
        const getOffsetParentFn = this.getOffsetParent || getOffsetParent;
        const getDimensionsFn = this.getDimensions;
        const floatingDimensions = await getDimensionsFn(data.floating);
        return {
            reference: getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
            floating: {
                x: 0,
                y: 0,
                width: floatingDimensions.width,
                height: floatingDimensions.height
            }
        };
    };
    function isRTL(element) {
        return getComputedStyle$1(element).direction === "rtl";
    }
    const platform = {
        convertOffsetParentRelativeRectToViewportRelativeRect: convertOffsetParentRelativeRectToViewportRelativeRect,
        getDocumentElement: getDocumentElement,
        getClippingRect: getClippingRect,
        getOffsetParent: getOffsetParent,
        getElementRects: getElementRects,
        getClientRects: getClientRects,
        getDimensions: getDimensions,
        getScale: getScale,
        isElement: isElement,
        isRTL: isRTL
    };
    function rectsAreEqual(a, b) {
        return a.x === b.x && a.y === b.y && a.width === b.width && a.height === b.height;
    }
    // https://samthor.au/2021/observing-dom/
    function observeMove(element, onMove) {
        let io = null;
        let timeoutId;
        const root = getDocumentElement(element);
        function cleanup() {
            var _io;
            clearTimeout(timeoutId);
            (_io = io) == null || _io.disconnect();
            io = null;
        }
        function refresh(skip, threshold) {
            if (skip === void 0) skip = false;
            if (threshold === void 0) threshold = 1;
            cleanup();
            const elementRectForRootMargin = element.getBoundingClientRect();
            const { left: left, top: top, width: width, height: height } = elementRectForRootMargin;
            if (!skip) onMove();
            if (!width || !height) return;
            const insetTop = floor(top);
            const insetRight = floor(root.clientWidth - (left + width));
            const insetBottom = floor(root.clientHeight - (top + height));
            const insetLeft = floor(left);
            const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
            const options = {
                rootMargin: rootMargin,
                threshold: max(0, min(1, threshold)) || 1
            };
            let isFirstUpdate = true;
            function handleObserve(entries) {
                const ratio = entries[0].intersectionRatio;
                if (ratio !== threshold) {
                    if (!isFirstUpdate) return refresh();
                    if (!ratio) // If the reference is clipped, the ratio is 0. Throttle the refresh
                    // to prevent an infinite loop of updates.
                    timeoutId = setTimeout(()=>{
                        refresh(false, 1e-7);
                    }, 1000);
                    else refresh(false, ratio);
                }
                if (ratio === 1 && !rectsAreEqual(elementRectForRootMargin, element.getBoundingClientRect())) // It's possible that even though the ratio is reported as 1, the
                // element is not actually fully within the IntersectionObserver's root
                // area anymore. This can happen under performance constraints. This may
                // be a bug in the browser's IntersectionObserver implementation. To
                // work around this, we compare the element's bounding rect now with
                // what it was at the time we created the IntersectionObserver. If they
                // are not equal then the element moved, so we refresh.
                refresh();
                isFirstUpdate = false;
            }
            // Older browsers don't support a `document` as the root and will throw an
            // error.
            try {
                io = new IntersectionObserver(handleObserve, {
                    ...options,
                    // Handle <iframe>s
                    root: root.ownerDocument
                });
            } catch (_e) {
                io = new IntersectionObserver(handleObserve, options);
            }
            io.observe(element);
        }
        refresh(true);
        return cleanup;
    }
    /**
   * Automatically updates the position of the floating element when necessary.
   * Should only be called when the floating element is mounted on the DOM or
   * visible on the screen.
   * @returns cleanup function that should be invoked when the floating element is
   * removed from the DOM or hidden from the screen.
   * @see https://floating-ui.com/docs/autoUpdate
   */ function autoUpdate(reference, floating, update, options) {
        if (options === void 0) options = {};
        const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === "function", layoutShift: layoutShift = typeof IntersectionObserver === "function", animationFrame: animationFrame = false } = options;
        const referenceEl = unwrapElement(reference);
        const ancestors = ancestorScroll || ancestorResize ? [
            ...referenceEl ? getOverflowAncestors(referenceEl) : [],
            ...getOverflowAncestors(floating)
        ] : [];
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.addEventListener("scroll", update, {
                passive: true
            });
            ancestorResize && ancestor.addEventListener("resize", update);
        });
        const cleanupIo = referenceEl && layoutShift ? observeMove(referenceEl, update) : null;
        let reobserveFrame = -1;
        let resizeObserver = null;
        if (elementResize) {
            resizeObserver = new ResizeObserver((_ref)=>{
                let [firstEntry] = _ref;
                if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                    // Prevent update loops when using the `size` middleware.
                    // https://github.com/floating-ui/floating-ui/issues/1740
                    resizeObserver.unobserve(floating);
                    cancelAnimationFrame(reobserveFrame);
                    reobserveFrame = requestAnimationFrame(()=>{
                        var _resizeObserver;
                        (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                    });
                }
                update();
            });
            if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
            resizeObserver.observe(floating);
        }
        let frameId;
        let prevRefRect = animationFrame ? getBoundingClientRect(reference) : null;
        if (animationFrame) frameLoop();
        function frameLoop() {
            const nextRefRect = getBoundingClientRect(reference);
            if (prevRefRect && !rectsAreEqual(prevRefRect, nextRefRect)) update();
            prevRefRect = nextRefRect;
            frameId = requestAnimationFrame(frameLoop);
        }
        update();
        return ()=>{
            var _resizeObserver2;
            ancestors.forEach((ancestor)=>{
                ancestorScroll && ancestor.removeEventListener("scroll", update);
                ancestorResize && ancestor.removeEventListener("resize", update);
            });
            cleanupIo == null || cleanupIo();
            (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
            resizeObserver = null;
            if (animationFrame) cancelAnimationFrame(frameId);
        };
    }
    /**
   * Resolves with an object of overflow side offsets that determine how much the
   * element is overflowing a given clipping boundary on each side.
   * - positive = overflowing the boundary by that number of pixels
   * - negative = how many pixels left before it will overflow
   * - 0 = lies flush with the boundary
   * @see https://floating-ui.com/docs/detectOverflow
   */ const detectOverflow = core.detectOverflow;
    /**
   * Modifies the placement by translating the floating element along the
   * specified axes.
   * A number (shorthand for `mainAxis` or distance), or an axes configuration
   * object may be passed.
   * @see https://floating-ui.com/docs/offset
   */ const offset = core.offset;
    /**
   * Optimizes the visibility of the floating element by choosing the placement
   * that has the most space available automatically, without needing to specify a
   * preferred placement. Alternative to `flip`.
   * @see https://floating-ui.com/docs/autoPlacement
   */ const autoPlacement = core.autoPlacement;
    /**
   * Optimizes the visibility of the floating element by shifting it in order to
   * keep it in view when it will overflow the clipping boundary.
   * @see https://floating-ui.com/docs/shift
   */ const shift = core.shift;
    /**
   * Optimizes the visibility of the floating element by flipping the `placement`
   * in order to keep it in view when the preferred placement(s) will overflow the
   * clipping boundary. Alternative to `autoPlacement`.
   * @see https://floating-ui.com/docs/flip
   */ const flip = core.flip;
    /**
   * Provides data that allows you to change the size of the floating element —
   * for instance, prevent it from overflowing the clipping boundary or match the
   * width of the reference element.
   * @see https://floating-ui.com/docs/size
   */ const size = core.size;
    /**
   * Provides data to hide the floating element in applicable situations, such as
   * when it is not in the same clipping context as the reference element.
   * @see https://floating-ui.com/docs/hide
   */ const hide = core.hide;
    /**
   * Provides data to position an inner element of the floating element so that it
   * appears centered to the reference element.
   * @see https://floating-ui.com/docs/arrow
   */ const arrow = core.arrow;
    /**
   * Provides improved positioning for inline reference elements that can span
   * over multiple lines, such as hyperlinks or range selections.
   * @see https://floating-ui.com/docs/inline
   */ const inline = core.inline;
    /**
   * Built-in `limiter` that will stop `shift()` at a certain point.
   */ const limitShift = core.limitShift;
    /**
   * Computes the `x` and `y` coordinates that will place the floating element
   * next to a given reference element.
   */ const computePosition = (reference, floating, options)=>{
        // This caches the expensive `getClippingElementAncestors` function so that
        // multiple lifecycle resets re-use the same result. It only lives for a
        // single call. If other functions become expensive, we can add them as well.
        const cache = new Map();
        const mergedOptions = {
            platform: platform,
            ...options
        };
        const platformWithCache = {
            ...mergedOptions.platform,
            _c: cache
        };
        return core.computePosition(reference, floating, {
            ...mergedOptions,
            platform: platformWithCache
        });
    };
    exports1.arrow = arrow;
    exports1.autoPlacement = autoPlacement;
    exports1.autoUpdate = autoUpdate;
    exports1.computePosition = computePosition;
    exports1.detectOverflow = detectOverflow;
    exports1.flip = flip;
    exports1.getOverflowAncestors = getOverflowAncestors;
    exports1.hide = hide;
    exports1.inline = inline;
    exports1.limitShift = limitShift;
    exports1.offset = offset;
    exports1.platform = platform;
    exports1.shift = shift;
    exports1.size = size;
});




var $j5Ozl = parcelRequire("j5Ozl");

var $gYLTL = parcelRequire("gYLTL");


var $5ewvA = parcelRequire("5ewvA");
const $904ba957439cb654$var$DEMO_SPOT = "DEMO";
const $904ba957439cb654$var$DEMO_PROFILE = "test-wind";
const $904ba957439cb654$var$SPOTS_TEMPLATES = [
    {
        "img": "la-torche-surf.jpg",
        "label": "La Torche - Surf",
        "ref": "TS",
        "mapCenter": [
            47.81100172556795,
            -3.5006999361894358
        ],
        "mapZoom": 8.89958997647146,
        "dataLayers": [
            "wind",
            "waves",
            "tide_fc",
            "waves_fc",
            "weather_fc"
        ],
        "bgLayers": [
            "wm"
        ],
        "point": [
            48.3006,
            -4.9823
        ],
        "pois": [
            "LaTorche"
        ],
        "webcams": [],
        "tideGauges": [
            "/port/Saint-Guenole"
        ],
        "windSensors": [
            "29158001",
            "29214001",
            "29168001"
        ],
        "wavesSensors": [],
        "tempSensors": [
            "29158001",
            "29214001",
            "29168001"
        ],
        "edit": false
    },
    {
        "img": "cap-coz-kite.jpg",
        "label": "Cap Coz - Kite",
        "ref": "CK",
        "mapCenter": [
            47.81330734584138,
            -3.972513257537114
        ],
        "mapZoom": 11.163284457697534,
        "dataLayers": [
            "wind",
            "waves",
            "wind_fc",
            "tide_fc",
            "webcam",
            "weather_fc"
        ],
        "bgLayers": [
            "wm"
        ],
        "point": [
            47.81,
            -4
        ],
        "pois": [
            "CapCoz"
        ],
        "webcams": [
            "/webcam/capcoz",
            "/webcam/begmeil",
            "/webcam/concarneau"
        ],
        "tideGauges": [
            "/port/Port-la-Foret"
        ],
        "windSensors": [],
        "wavesSensors": [],
        "tempSensors": [],
        "edit": false
    },
    {
        "img": "benodet-plaisance.jpg",
        "label": "B\xe9nodet - Plaisance",
        "ref": "BP",
        "mapCenter": [
            47.77170546467042,
            -3.8829836074927075
        ],
        "mapZoom": 9.764252745635858,
        "dataLayers": [
            "wind",
            "waves",
            "wind_fc",
            "tide_fc",
            "webcam",
            "weather_fc"
        ],
        "bgLayers": [
            "wm"
        ],
        "point": [
            47.78,
            -4.06
        ],
        "pois": [
            "Benodet"
        ],
        "webcams": [
            "/webcam/SainteMarine",
            "/webcam/penmarch"
        ],
        "tideGauges": [
            "/port/Benodet"
        ],
        "windSensors": [],
        "wavesSensors": [],
        "tempSensors": [],
        "edit": false
    },
    {
        "img": "kergelen-voile-legere.jpg",
        "label": "Kergelen - Voile l\xe9g\xe8re",
        "ref": "KVL",
        "mapCenter": [
            47.65435797658462,
            -3.564770566510287
        ],
        "mapZoom": 10.129325538328795,
        "dataLayers": [
            "wind",
            "waves",
            "weather_fc",
            "wind_fc",
            "tide_fc"
        ],
        "bgLayers": [
            "wm"
        ],
        "point": [
            47.7,
            -3.4
        ],
        "pois": [
            "kerguelen"
        ],
        "webcams": [],
        "tideGauges": [
            "/port/port-louis-locmalo"
        ],
        "windSensors": [],
        "wavesSensors": [],
        "tempSensors": [],
        "edit": false
    },
    {
        "img": "sainte-barbe-surf.jpg",
        "label": "Sainte-Barbe - Surf",
        "ref": "SBS",
        "mapCenter": [
            47.35411123065658,
            -3.0836277749981797
        ],
        "mapZoom": 9.46302267505024,
        "dataLayers": [
            "wind",
            "waves",
            "weather_fc",
            "waves_fc",
            "webcam",
            "tide_fc"
        ],
        "bgLayers": [
            "wm"
        ],
        "point": [
            47.3322,
            -3.2873
        ],
        "pois": [
            "sainte-barbe"
        ],
        "webcams": [
            "/webcam/semaphore-d-etel-plouhinec"
        ],
        "tideGauges": [
            "/port/portivy"
        ],
        "windSensors": [
            "56069001",
            "56009001",
            "5",
            "6",
            "1",
            "10438252",
            "73091265",
            "73091277",
            "73091286"
        ],
        "wavesSensors": [],
        "tempSensors": [
            "56069001",
            "56009001"
        ],
        "edit": false
    },
    {
        "img": "baie-de-quiberon-voile.jpg",
        "label": "Baie de Quiberon - Voile",
        "ref": "BQV",
        "mapCenter": [
            47.369813133091384,
            -2.7993731353657574
        ],
        "mapZoom": 9.928505491271716,
        "dataLayers": [
            "wind",
            "waves",
            "webcam",
            "tide_fc",
            "wind_fc",
            "weather_fc"
        ],
        "bgLayers": [
            "wm"
        ],
        "point": [
            47.51,
            -3
        ],
        "pois": [
            "baie-de-quiberon"
        ],
        "webcams": [
            "/webcam/saint-philibert",
            "/webcam/quiberon",
            "/webcam/houat"
        ],
        "tideGauges": [
            "/port/la-trinite-sur-mer"
        ],
        "windSensors": [],
        "wavesSensors": [],
        "tempSensors": [],
        "edit": false
    },
    {
        "img": "piriac-voile.jpg",
        "label": "Piriac - Voile",
        "ref": "PV",
        "mapCenter": [
            47.31318444465053,
            -2.6113630173287565
        ],
        "mapZoom": 9.978710503035986,
        "dataLayers": [
            "wind",
            "wind_fc",
            "webcam",
            "weather_fc"
        ],
        "bgLayers": [
            "wm"
        ],
        "point": [
            47.41,
            -2.61
        ],
        "pois": [
            "piriac"
        ],
        "webcams": [
            "/webcam/mesquer-lanseria",
            "/webcam/port-de-penerf"
        ],
        "tideGauges": [],
        "windSensors": [],
        "wavesSensors": [],
        "tempSensors": [],
        "edit": false
    },
    {
        "img": "la-baule-voile.jpg",
        "label": "La Baule - Voile",
        "ref": "BV",
        "mapCenter": [
            47.21620157676546,
            -2.294812196937526
        ],
        "mapZoom": 11.27802911640019,
        "dataLayers": [
            "wind",
            "wind_fc",
            "waves",
            "tide_fc",
            "weather_fc"
        ],
        "bgLayers": [
            "wm"
        ],
        "point": [
            47.26,
            -2.4
        ],
        "pois": [
            "LaBaule"
        ],
        "webcams": [],
        "tideGauges": [
            "/port/LePouliguen"
        ],
        "windSensors": [],
        "wavesSensors": [],
        "tempSensors": [],
        "edit": false
    },
    {
        "img": "saint-gildas-voile.jpg",
        "label": "Saint-Gildas - Voile",
        "ref": "SGV",
        "mapCenter": [
            47.07583366066162,
            -2.570473728358112
        ],
        "mapZoom": 9.680760620678683,
        "dataLayers": [
            "wind_fc",
            "waves",
            "tide_fc",
            "weather_fc",
            "wind"
        ],
        "bgLayers": [
            "wm"
        ],
        "point": [
            47.15,
            -2.25
        ],
        "pois": [
            "saintgildas"
        ],
        "webcams": [],
        "tideGauges": [
            "/port/pointedesaintgildas"
        ],
        "windSensors": [],
        "wavesSensors": [],
        "tempSensors": [],
        "edit": false
    },
    {
        "img": "la-govelle-surf.jpg",
        "label": "La Govelle - Surf",
        "ref": "GS",
        "mapCenter": [
            47.24096426887133,
            -2.5605645497447176
        ],
        "mapZoom": 10.762341288414444,
        "dataLayers": [
            "wind",
            "weather_fc",
            "waves_fc",
            "tide_fc",
            "waves"
        ],
        "bgLayers": [
            "wm"
        ],
        "point": [
            47.2615,
            -2.4595
        ],
        "pois": [
            "lagovelle"
        ],
        "webcams": [],
        "tideGauges": [
            "/port/le-croisic"
        ],
        "windSensors": [],
        "wavesSensors": [],
        "tempSensors": [],
        "edit": false
    }
];
function $904ba957439cb654$export$88a0cf2a781036f4(btn) {
    if (btn.classList.contains("expanded")) {
        btn.nextElementSibling.classList.add("hidden");
        btn.classList.remove("expanded");
    } else {
        btn.nextElementSibling.classList.remove("hidden");
        btn.classList.add("expanded");
    }
}
function $904ba957439cb654$export$28a81b7dca2195d2(btn, spotIndex) {
    $904ba957439cb654$export$88a0cf2a781036f4(document.querySelector("#account_spots > button:first-child"));
    $904ba957439cb654$var$loadUserSpot(spotIndex, false);
}
function $904ba957439cb654$export$214a8c2dc2483e31() {
    $904ba957439cb654$export$88a0cf2a781036f4(document.querySelector("#account_spots > button:first-child"));
    (0, $dnPBs.default).show("spots_modal", {
        disableScroll: true
    });
}
function $904ba957439cb654$export$fe0f878e056a2558(spotIndex) {
    (0, $dnPBs.default).close("spots_modal");
    $904ba957439cb654$var$loadUserSpot(spotIndex, true);
}
function $904ba957439cb654$export$8d0ede5d4e5abc56() {
    (0, $dnPBs.default).close("spots_modal");
    $904ba957439cb654$var$loadDemoSpot();
    const activeTour = document.querySelector("dialog.shepherd-element.shepherd-enabled");
    if (!activeTour) $904ba957439cb654$export$f2461f6207ae9479("zoom-step");
}
function $904ba957439cb654$export$8a2289091bacd0a2() {
    (0, $dnPBs.default).close("spots_modal");
    (0, $dnPBs.default).show("spots_templates_modal", {
        disableScroll: true
    });
}
function $904ba957439cb654$export$a2aa5000ac9238e0(btnElt) {
    const prev = document.querySelector("#spots_templates_list .selected"), userSpots = $904ba957439cb654$var$getUserProfile().spots.map((s)=>s.ref);
    if (prev) {
        prev.classList.remove("selected");
        if (prev.nextElementSibling.querySelector("p")) prev.nextElementSibling.querySelector("p").remove();
        if (prev.nextElementSibling.querySelector("select")) prev.nextElementSibling.querySelector("select").remove();
        if (prev.nextElementSibling.querySelector("button")) prev.nextElementSibling.querySelector("button").remove();
    }
    btnElt.classList.add("selected");
    if (btnElt.classList.contains("selected")) btnElt.nextElementSibling.insertAdjacentHTML("beforeend", `<p>Utiliser ce mod\xe8le pour le spot :</p><select name="spot_template_target" id="spot_template_target">${userSpots.map((s)=>`<option value="${s}">${s}</option>`)}</select><button type="button" onclick="wm.applySpotTemplate()">Valider</button>`);
}
function $904ba957439cb654$export$43e0afad5800723b() {
    const userProfile1 = $904ba957439cb654$var$getUserProfile(), targetSpotRef = document.querySelector("#spot_template_target").value, selectedTemplate = document.querySelector("#spots_templates_list .selected").getAttribute("data-template");
    const templateData = {
        ...$904ba957439cb654$var$SPOTS_TEMPLATES[$904ba957439cb654$var$SPOTS_TEMPLATES.findIndex((st)=>st.ref === selectedTemplate)]
    };
    delete templateData.img;
    delete templateData.label;
    userProfile1.spots[userProfile1.spots.findIndex((s)=>s.ref === targetSpotRef)] = templateData;
    $904ba957439cb654$var$saveUserProfile(userProfile1);
    (0, $dnPBs.default).close("spots_templates_modal");
    (0, $a512f8659cf98537$export$2e2bcd8739ae039).navigate(`/profil/${userProfile1.id}/spots/${selectedTemplate}`);
}
function $904ba957439cb654$export$14a75613620cf6da(spotRef) {
    const userProfile1 = $904ba957439cb654$var$getUserProfile();
    return spotRef === $904ba957439cb654$var$DEMO_SPOT ? userProfile1.demoSpot : userProfile1.spots.find((s)=>s.ref === spotRef);
}
function $904ba957439cb654$export$b76628102be99548(spotRef) {
    const editControls = document.querySelector("#edit_spot_controls");
    editControls.classList.remove("hidden");
    editControls.querySelector("#edit_spot_ref").value = spotRef;
    editControls.setAttribute("data-spot", spotRef);
}
function $904ba957439cb654$export$b20553db877206de(userSpot) {
    console.debug("selectPinnedElements: " + JSON.stringify(userSpot));
    if (userSpot.pois.length) for (const poi of document.querySelectorAll(`${userSpot.pois.map((p)=>"#poi_" + p + ".weather_poi").join(",")}`))poi.classList.add("edit_pinned");
    if (userSpot.webcams.length) for (const poi of document.querySelectorAll(`${userSpot.webcams.map((w)=>".webcam_spot a[data-href='" + w + "']").join(",")}`))poi.closest("g[data-edit]").classList.add("edit_pinned");
    if (userSpot.tideGauges.length) for (const poi of document.querySelectorAll(`${userSpot.tideGauges.map((t)=>".tide_spot a[data-href='" + t + "']").join(",")}`))poi.closest("g[data-edit]").classList.add("edit_pinned");
    if (userSpot.windSensors.length) for (const poi of document.querySelectorAll(`${userSpot.windSensors.map((s)=>"#sensor_" + s + ".wind_sensor").join(",")}`))poi.classList.add("edit_pinned");
    if (userSpot.wavesSensors.length) for (const poi of document.querySelectorAll(`${userSpot.wavesSensors.map((s)=>"#sensor_" + s + ".wave_sensor").join(",")}`))poi.classList.add("edit_pinned");
    if (userSpot.tempSensors.length) for (const poi of document.querySelectorAll(`${userSpot.tempSensors.map((s)=>"#sensor_" + s + ".temp_sensor").join(",")}`))poi.classList.add("edit_pinned");
}
function $904ba957439cb654$export$9da0aee0111de573() {
    const userProfile1 = $904ba957439cb654$var$getUserProfile(), prevSpotRef = document.querySelector("#edit_spot_controls").getAttribute("data-spot"), isDemo = prevSpotRef === $904ba957439cb654$var$DEMO_SPOT, newSpotRef = isDemo ? $904ba957439cb654$var$DEMO_SPOT : document.querySelector("#edit_spot_ref").value;
    if (!newSpotRef || newSpotRef !== prevSpotRef && userProfile1.spots.find((s)=>s.ref === newSpotRef)) {
        document.querySelector("#info_spot_modal_title").innerHTML = `Spot ${newSpotRef} - Enregistrement impossible`;
        document.querySelector("#info_spot_modal_content").innerHTML = `L'enregistrement du spot ${newSpotRef} n'a pas pu aboutir. Veuillez v\xe9rifier que vous avez bien choisi un nom unique pour votre spot (3 caract\xe8res max.).`;
    } else {
        const mainPoi = document.querySelector(".weather_poi[data-main-poi='true']"), pinnedPois = $904ba957439cb654$var$pinnedElements(".weather_poi");
        const newSpotData = {
            ref: newSpotRef,
            mapCenter: [
                (0, $gYLTL.map).instance.getCenter().lat,
                (0, $gYLTL.map).instance.getCenter().lng
            ],
            mapZoom: (0, $gYLTL.map).instance.getZoom(),
            dataLayers: [
                ...(0, $gYLTL.layers).dataLayers
            ],
            bgLayers: Array.from(document.querySelectorAll(".map_layer.active")).map((l)=>l.getAttribute("data-bg")),
            point: (0, $gYLTL.map).currentFocus ? [
                (0, $gYLTL.map).currentFocus.lat,
                (0, $gYLTL.map).currentFocus.lng
            ] : null,
            pois: mainPoi ? [
                mainPoi.id.split("_")[1],
                ...pinnedPois.filter((p)=>p !== mainPoi.id.split("_")[1])
            ] : pinnedPois,
            webcams: $904ba957439cb654$var$pinnedElements(".webcam_spot"),
            tideGauges: $904ba957439cb654$var$pinnedElements(".tide_spot"),
            windSensors: $904ba957439cb654$var$pinnedElements(".wind_sensor"),
            wavesSensors: $904ba957439cb654$var$pinnedElements(".wave_sensor"),
            tempSensors: $904ba957439cb654$var$pinnedElements(".temp_sensor")
        };
        if (isDemo) {
            (0, $a512f8659cf98537$export$2e2bcd8739ae039).navigate("/");
            document.querySelector("#edit_spot_controls").classList.add("hidden");
            document.querySelector("#info_spot_modal_title").innerHTML = `Spot de d\xe9mo - Configuration termin\xe9e`;
            document.querySelector("#info_spot_modal_content").innerHTML = `Configurez vos 3 spots de la m\xeame mani\xe8re, via le menu "mes spots" en ent\xeate du site. Rejouez la d\xe9mo \xe0 partir de l'entr\xe9e <strong>config</strong> du menu, en cliquant \xe0 nouveau sur <strong>Configurer le spot de d\xe9mo</strong>.`;
        } else {
            userProfile1.spots[userProfile1.spots.findIndex((s)=>s.ref === prevSpotRef)] = newSpotData;
            $904ba957439cb654$var$saveUserProfile(userProfile1);
            (0, $a512f8659cf98537$export$2e2bcd8739ae039).navigate(`/profil/${userProfile1.id}/spots/${newSpotRef}`);
            $904ba957439cb654$var$updateSpotsMenu(userProfile1.spots);
            document.querySelector("#info_spot_modal_title").innerHTML = `Spot ${newSpotRef} - Enregistrement r\xe9ussi`;
            document.querySelector("#info_spot_modal_content").innerHTML = `Vous pouvez acc\xe9der \xe0 ce spot :<br/>- via le menu "mes spots" en ent\xeate du site<br/>` + `- directement via l'adresse <a href="${window.location.protocol}//${window.location.host}/profil/${userProfile1.id}/spots/${newSpotRef}">${window.location.host}/profil/${userProfile1.id}/spots/${newSpotRef}</a>`;
        }
    }
    (0, $dnPBs.default).show("info_spot_modal", {
        disableScroll: true
    });
}
function $904ba957439cb654$export$9a2e0453dc446366() {
    if (window.confirm("Annuler la configuration du spot en cours ?")) {
        const spotRef = document.querySelector("#edit_spot_controls").getAttribute("data-spot");
        (0, $a512f8659cf98537$export$2e2bcd8739ae039).navigate(`/profil/${userProfile.id}/spots/${spotRef}`);
    }
}
function $904ba957439cb654$export$6f5378aa3397b877() {
    const signUpForm = document.querySelector("#wm_sign_up_form");
    if (signUpForm.reportValidity()) {
        const formData = new FormData(signUpForm);
        (0, $5ewvA.postFetch)(`${(0, $j5Ozl.config).backEndUrl}/wind_users.json`, formData).then((resp)=>{
            console.debug("resp: " + JSON.stringify(resp));
            if (resp.success) {
                document.querySelector("#info_spot_modal_title").innerHTML = `Compte en attente de validation`;
                document.querySelector("#info_spot_modal_content").innerHTML = `<p>Veuillez consulter votre bo\xeete de r\xe9ception pour finaliser la cr\xe9ation de votre compte.<br/>` + `Une fois votre compte valid\xe9, vous pourrez <button type="button" onclick="wm.dismissAccountCreation()"><strong>vous connecter</strong></button> \xe0 l'aide vos identifiants.</p>`;
            } else {
                document.querySelector("#info_spot_modal_title").innerHTML = `Erreur lors de la cr\xe9ation de compte`;
                document.querySelector("#info_spot_modal_content").innerHTML = `<p>${resp.msg}</p>`;
            }
            (0, $dnPBs.default).close("form_modal");
            (0, $dnPBs.default).show("info_spot_modal", {
                disableScroll: true
            });
        }).catch((error)=>{
            console.error("error: " + JSON.stringify(error));
        });
    }
}
function $904ba957439cb654$export$8449a7e210b4502a() {
    const signUpForm = document.querySelector("#wm_sign_up_form");
    if (signUpForm.reportValidity()) {
        (0, $dnPBs.default).close("form_modal");
        document.querySelector("#info_spot_modal_title").innerHTML = `Cr\xe9ation de compte r\xe9ussie`;
        document.querySelector("#info_spot_modal_content").innerHTML = `<p>Merci pour votre saisie, votre compte windfrance a bien \xe9t\xe9 cr\xe9\xe9.<br/>` + `<strong>MODE TEST<br/>Pour vous connecter au compte windfrance de test, utilisez les identifiants suivants :<br/>` + `E-mail : test@windmorbihan.com - Mot de passe : TestWindFrance25</strong></p>` + `<button type="button" class="configure_spot" onclick="wm.dismissAccountCreation()">Je me connecte</button>`;
        (0, $dnPBs.default).show("info_spot_modal", {
            disableScroll: true
        });
    }
}
function $904ba957439cb654$export$dc726c8e334dd814() {
    document.querySelector("#info_spot_modal_title").innerHTML = `R\xe9initialiser votre mot de passe`;
    document.querySelector("#info_spot_modal_content").innerHTML = `<form id="wm_reset_pwd_form" action="" method="post" class="modal_form grid-2">` + `<div class="form_field"><label for="account_email">Adresse email</label><input type="email" placeholder="Email" id="account_email" data-form-type="username" name="user[email]" required/></div>` + `<div><button class="reset_pwd_button" type="button" value="Connexion" onclick="wm.submitPasswordReset()">R\xe9initialiser</button></div>` + `</form>`;
    (0, $dnPBs.default).close("form_modal");
    (0, $dnPBs.default).show("info_spot_modal", {
        disableScroll: true
    });
}
function $904ba957439cb654$export$4166b4b285bc9ec4() {
    const resetForm = document.querySelector("#wm_reset_pwd_form");
    if (resetForm.reportValidity()) {
        const formData = new FormData(resetForm);
        (0, $5ewvA.postFetch)(`${(0, $j5Ozl.config).backEndUrl}/wind_users/reset_password.json`, formData).then((resp)=>{
            document.querySelector("#info_spot_modal_title").innerHTML = `Demande de r\xe9initialisation transmise`;
            document.querySelector("#info_spot_modal_content").innerHTML = `<p>${resp.msg}</p>`;
        }).catch((error)=>{
            console.error("error: " + JSON.stringify(error));
        });
    }
}
function $904ba957439cb654$export$dd347fd6d8a2a2d8() {
    const usrProfile = document.querySelector("#user_profile"), choices = usrProfile.querySelectorAll(".choice_field");
    let totalAnswers = 0;
    for (const choice of choices){
        const maxAnswers = parseInt(choice.getAttribute("data-max")), selectedAnswers = choice.querySelectorAll("input[type='checkbox']:checked");
        totalAnswers += selectedAnswers.length;
        if (maxAnswers < selectedAnswers.length) selectedAnswers[selectedAnswers.length - 1].setCustomValidity(`Veuillez s\xe9lectionner au maximum ${maxAnswers} choix`);
        else for (const a of choice.querySelectorAll("input[type='checkbox']"))a.setCustomValidity("");
    }
    console.debug("totalAnswers: " + totalAnswers.toString());
    if (totalAnswers === 0) choices[0].querySelector("input[type='checkbox']").setCustomValidity("Veuillez s\xe9lectionner au moins une pratique (loisir ou professionnelle)");
    else choices[0].querySelector("input[type='checkbox']").setCustomValidity("");
}
function $904ba957439cb654$export$4db896465f11c081() {
    (0, $dnPBs.default).close("info_spot_modal");
    (0, $dnPBs.default).show("form_modal", {
        disableScroll: true
    });
    document.querySelector("#form_modal #form_cta > button:first-child").click();
}
function $904ba957439cb654$export$e2d809643f42c341() {
    if (document.querySelector("#wm_sign_in_form input[type='email']").value === "test@windmorbihan.com" && document.querySelector("#wm_sign_in_form input[type='password']").value === "TestWindFrance25") {
        if (!localStorage.getItem("windUser")) $904ba957439cb654$var$saveUserProfile($904ba957439cb654$var$defaultUserProfile());
        $904ba957439cb654$export$745b26d8c003724a();
        (0, $dnPBs.default).close("form_modal");
        document.querySelector("#info_spot_modal_title").innerHTML = `Connexion r\xe9ussie`;
        document.querySelector("#info_spot_modal_content").innerHTML = `<p>Bienvenue sur votre compte windfrance.</p>` + `<div class="guided_tour"><button type="button" onclick="wm.startSpotsTour()">D\xe9marrer la visite guid\xe9e</button></div>`;
        (0, $dnPBs.default).show("info_spot_modal", {
            disableScroll: true
        });
    } else console.error("login attempt failed");
}
function $904ba957439cb654$export$9615a332827b5ee() {
    const signInForm = document.querySelector("#wm_sign_in_form");
    if (signInForm.reportValidity()) {
        const formData = new FormData(signInForm);
        (0, $5ewvA.postFetch)(`${(0, $j5Ozl.config).backEndUrl}/wind_users/login.json`, formData).then((resp)=>{
            console.debug("resp: " + JSON.stringify(resp));
            if (resp.success) {
                $904ba957439cb654$var$saveUserProfile(resp.user, false);
                $904ba957439cb654$export$745b26d8c003724a();
                document.querySelector("#info_spot_modal_title").innerHTML = `Connexion r\xe9ussie`;
                document.querySelector("#info_spot_modal_content").innerHTML = `<p>Bienvenue sur votre compte windfrance.</p>` + `<div class="guided_tour"><button type="button" onclick="wm.startSpotsTour()">D\xe9marrer la visite guid\xe9e</button></div>`;
            } else {
                document.querySelector("#info_spot_modal_title").innerHTML = `Erreur lors de la connexion`;
                document.querySelector("#info_spot_modal_content").innerHTML = `<p>${resp.msg}</p>`;
            }
            (0, $dnPBs.default).close("form_modal");
            (0, $dnPBs.default).show("info_spot_modal", {
                disableScroll: true
            });
        }).catch((error)=>{
            console.error("error: " + JSON.stringify(error));
        });
    }
}
function $904ba957439cb654$export$745b26d8c003724a() {
    const userProfile1 = $904ba957439cb654$var$getUserProfile();
    $904ba957439cb654$var$updateSpotsMenu(userProfile1.spots);
    (0, $gYLTL.profile).id = userProfile1.id;
    if (typeof window._paq !== "undefined") {
        console.debug("setUserId: " + (0, $gYLTL.profile).id.toString());
        window._paq.push([
            "setUserId",
            (0, $gYLTL.profile).id
        ]);
    }
    document.querySelector("#account_spots").classList.remove("hidden");
    document.querySelector("#wind_france_top").classList.add("hidden");
    document.querySelector("#map_layers #rain_fc").classList.remove("disabled");
    document.querySelector("#map_layers #rain_fc").setAttribute("onclick", "wm.toggleLayer(this, 'rain_fc')");
    document.querySelector("#map_layers #rain_fc").setAttribute("title", "Radar pluie");
}
function $904ba957439cb654$var$updateSpotsMenu(userSpots) {
    document.querySelector("#account_spots button[data-spot-index='1'] strong").innerHTML = userSpots[0].ref;
    document.querySelector("#account_spots button[data-spot-index='2'] strong").innerHTML = userSpots[1].ref;
    document.querySelector("#account_spots button[data-spot-index='3'] strong").innerHTML = userSpots[2].ref;
}
function $904ba957439cb654$export$f2461f6207ae9479(step = null) {
    (0, $dnPBs.default).close("info_spot_modal");
    const tour = new (0, $9f2dc49079b18fe5$export$2e2bcd8739ae039).Tour({
        useModalOverlay: true,
        confirmCancel: true,
        confirmCancelMessage: "Quitter la d\xe9mo ?",
        keyboardNavigation: false,
        defaultStepOptions: {
            scrollTo: false,
            cancelIcon: {
                enabled: true
            },
            floatingUIOptions: {
                middleware: [
                    (0, $af18dcae254e818d$exports.offset)(10)
                ]
            }
        }
    });
    tour.addStep({
        id: "menu-spots-step",
        text: "Cliquez sur le menu <strong>mes spots</strong><br/>afin de les configurer.",
        attachTo: {
            element: "#account_spots > button:first-child",
            on: "bottom"
        },
        advanceOn: {
            selector: "#account_spots",
            event: "click"
        }
    });
    tour.addStep({
        id: "edit-spots-step",
        text: "Cliquez sur <strong><i class='fa-solid fa-cog'></i>&nbsp;config</strong>.",
        attachTo: {
            element: "#account_spots > div > button:last-child",
            on: "bottom"
        },
        advanceOn: {
            selector: "#account_spots > div > button:last-child",
            event: "click"
        }
    });
    tour.addStep({
        id: "select-edit-spot",
        text: "Dans la fen\xeatre qui s'ouvre, s\xe9lectionnez le spot que vous souhaitez personnaliser : nous allons ici <strong>configurer le spot de d\xe9mo</strong>.",
        attachTo: {
            element: "#spots_modal_content .guided_tour > button",
            on: "top"
        },
        advanceOn: {
            selector: "#spots_modal_content .guided_tour > button",
            event: "click"
        }
    });
    tour.addStep({
        id: "zoom-step",
        text: "S\xe9lectionnez le <strong>niveau de zoom</strong> que vous souhaitez. Par exemple, nous allons nous positionner autour de Belle \xcele.",
        buttons: [
            {
                text: "Suiv. >",
                classes: "tour_next_btn",
                action: function() {
                    (0, $gYLTL.map).instance.setView(new $645b7147683636d0$exports.LatLng(47.2695, -3.184), 10.8);
                    tour.next();
                }
            }
        ]
    });
    tour.addStep({
        id: "sensor-step",
        text: "Vous pouvez s\xe9lectionner <strong>un ou plusieurs capteurs</strong>. Dans notre exemple, <strong>cliquez sur le capteur Belle \xcele</strong>.",
        attachTo: {
            element: "#sensor_56009001",
            on: "bottom"
        },
        advanceOn: {
            selector: "#sensor_56009001",
            event: "click"
        }
    });
    tour.addStep({
        id: "layer-step",
        text: "Vous pouvez <strong>activer diff\xe9rents calques</strong>. Dans notre exemple, <strong>cliquez sur le calque des mar\xe9graphes en surbrillance</strong>.",
        attachTo: {
            element: "#map_layers #tide",
            on: "top"
        },
        advanceOn: {
            selector: "#map_layers #tide",
            event: "click"
        }
    });
    tour.addStep({
        id: "tide-step",
        text: "<strong>Choisissez un mar\xe9graphe</strong>. Dans notre exemple, <strong>cliquez sur celui du Palais</strong>.",
        beforeShowPromise: function() {
            return new Promise((resolve, reject)=>{
                setTimeout(resolve, 800, "one");
            });
        },
        attachTo: {
            element: ".tide_spot a[title='Le Palais']",
            on: "bottom"
        },
        advanceOn: {
            selector: ".tide_spot a[title='Le Palais']",
            event: "click"
        }
    });
    tour.addStep({
        id: "fc-step",
        text: "Vous pouvez <strong>s\xe9lectionner d'autres calques</strong>. Dans notre exemple, <strong>activez le calque de pr\xe9visions du vent</strong> en surbrillance.",
        attachTo: {
            element: "#map_layers #wind_fc",
            on: "top"
        },
        advanceOn: {
            selector: "#map_layers #wind_fc",
            event: "click"
        }
    });
    tour.addStep({
        id: "fc-point-step",
        text: "Cliquez sur un point de votre choix dans la zone en surbrillance afin d'afficher la valeur pr\xe9vue en ce point.",
        beforeShowPromise: function() {
            return new Promise((resolve, reject)=>{
                document.querySelector("#particles_wrapper").insertAdjacentHTML("beforeend", '<div id="fc-point-step-overlay"></div>');
                resolve();
            });
        },
        attachTo: {
            element: "#fc-point-step-overlay",
            on: "top"
        },
        advanceOn: {
            selector: "#markers_layer",
            event: "click"
        }
    });
    tour.addStep({
        id: "weather-step",
        text: "Vous pouvez <strong>ajouter plusieurs m\xe9t\xe9ogrammes</strong>. Pour cela, <strong>activez le calque m\xe9t\xe9o</strong> en surbrillance.",
        beforeShowPromise: function() {
            return new Promise((resolve, reject)=>{
                setTimeout(resolve, 800, "one");
            });
        },
        attachTo: {
            element: "#map_layers #weather_fc",
            on: "top"
        },
        advanceOn: {
            selector: "#map_layers #weather_fc",
            event: "click"
        }
    });
    tour.addStep({
        id: "poi-step-1",
        text: "S\xe9lectionnez un m\xe9t\xe9ogramme - dans cet exemple <strong>Donnant</strong>. Le 1er m\xe9t\xe9ogramme s\xe9lectionn\xe9 sera activ\xe9 automatiquement.",
        beforeShowPromise: function() {
            return new Promise((resolve, reject)=>{
                setTimeout(resolve, 800, "one");
            });
        },
        attachTo: {
            element: "#poi_donnant",
            on: "top"
        },
        advanceOn: {
            selector: "#poi_donnant",
            event: "click"
        }
    });
    tour.addStep({
        id: "poi-step-2",
        text: "Vous pouvez s\xe9lectionner un 2\xe8me m\xe9t\xe9ogramme - dans cet exemple <strong>Le Palais</strong>. Son ic\xf4ne sera affich\xe9e sur votre spot.",
        attachTo: {
            element: "#poi_le-palais",
            on: "top"
        },
        advanceOn: {
            selector: "#poi_le-palais",
            event: "click"
        }
    });
    tour.addStep({
        id: "rename-step",
        text: "Enfin, <strong>donnez un nom</strong> \xe0 votre spot (3 caract\xe8res maximum) puis cliquez sur <strong>Enregistrer</strong> dans l'encart \xe0 gauche.",
        scrollTo: false,
        attachTo: {
            element: "#edit_spot_controls",
            on: "bottom"
        },
        advanceOn: {
            selector: "#save_current_spot",
            event: "click"
        }
    });
    tour.addStep({
        id: "other-data-step",
        text: "Toutes les donn\xe9es pr\xe9sentes sur le site peuvent \xeatre int\xe9gr\xe9es de la m\xeame fa\xe7on :<br/>- observations vent, houle, temp\xe9rature<br/>- pr\xe9visions vent, vagues<br/>- pr\xe9visions pluie via carte radar<br/>- m\xe9t\xe9ogrammes, webcams, mar\xe9graphes",
        buttons: [
            {
                text: "Terminer la visite",
                action: tour.complete
            }
        ]
    });
    if (step) tour.show(step);
    else tour.start();
}
function $904ba957439cb654$var$pinnedElements(selector) {
    const pinnedElts = document.querySelectorAll(`g.zoom_wrapper ${selector}.edit_pinned`), refs = [];
    for (const el of pinnedElts)if (el.id) refs.push(el.id.split("_")[1]);
    else refs.push(el.querySelector("a").getAttribute("data-href"));
    return refs;
}
function $904ba957439cb654$var$loadUserSpot(spotIndex, editMode) {
    const userProfile1 = $904ba957439cb654$var$getUserProfile(), userSpot = userProfile1.spots[spotIndex - 1], spotRef = userSpot?.ref;
    (0, $a512f8659cf98537$export$2e2bcd8739ae039).navigate(`/profil/${userProfile1.id}/spots/${spotRef}${editMode ? "?edit=true" : ""}`);
}
function $904ba957439cb654$var$loadDemoSpot() {
    (0, $a512f8659cf98537$export$2e2bcd8739ae039).navigate(`/profil/${$904ba957439cb654$var$DEMO_PROFILE}/spots/DEMO?edit=true`);
}
function $904ba957439cb654$var$defaultUserSpot(ref) {
    return {
        ref: ref,
        mapCenter: [
            ...(0, $j5Ozl.config).mapCenter
        ],
        mapZoom: (0, $j5Ozl.config).mapZoom,
        bgLayers: [
            "wm"
        ],
        dataLayers: [
            "wind",
            "waves"
        ],
        point: null,
        pois: [],
        webcams: [],
        tideGauges: [],
        windSensors: [],
        wavesSensors: [],
        tempSensors: []
    };
}
function $904ba957439cb654$var$getUserProfile() {
    const storedProfile = localStorage.getItem("windUser");
    return storedProfile ? JSON.parse(localStorage.getItem("windUser")) : $904ba957439cb654$var$defaultUserProfile();
}
function $904ba957439cb654$var$saveUserProfile(profileData, remote = true) {
    console.debug("saving user profile: " + JSON.stringify(profileData));
    localStorage.setItem("windUser", $904ba957439cb654$var$stringifySafe(profileData));
    if (remote) (0, $5ewvA.postFetch)(`${(0, $j5Ozl.config).backEndUrl}/wind_users/${profileData.id}.json`, $904ba957439cb654$var$stringifySafe(profileData), {
        "Accept": "application/json",
        "Content-Type": "application/json"
    }).then((resp)=>{
        console.debug("resp: " + JSON.stringify(resp));
    });
}
function $904ba957439cb654$var$defaultUserProfile() {
    return {
        email: "test@windmorbihan.com",
        spots: [
            $904ba957439cb654$var$defaultUserSpot("1"),
            $904ba957439cb654$var$defaultUserSpot("2"),
            $904ba957439cb654$var$defaultUserSpot("3")
        ],
        demoSpot: $904ba957439cb654$var$defaultUserSpot("DEMO")
    };
}
function $904ba957439cb654$var$stringifySafe(obj) {
    const seen = new WeakSet();
    return JSON.stringify(obj, (key, value)=>{
        if (typeof value === "object" && value !== null) {
            if (seen.has(value)) return;
            seen.add(value);
        }
        return value;
    });
}



const $a512f8659cf98537$var$router = new (0, (/*@__PURE__*/$parcel$interopDefault($957d647adad0df91$exports)))("/");
let $a512f8659cf98537$var$autoRefresh;
// console.time('routerConfig');
$a512f8659cf98537$var$router.on("/", function(match) {
    // console.timeEnd('partialInit');
    (0, $gYLTL.layers).activeSpot = null;
    $a512f8659cf98537$var$displayDefaultData(null);
    (0, $gYLTL.logPageView)($a512f8659cf98537$var$router.lastResolved(), "/", "Accueil");
    $a512f8659cf98537$var$setAutoRefresh();
});
$a512f8659cf98537$var$router.on("/webcam/:name", function(match) {
    (0, $gYLTL.layers).activeSpot = null;
    $a512f8659cf98537$var$displayDefaultData(function() {
        (0, $5ewvA.getAsync)((0, $j5Ozl.config).backEndUrl + "/webcams/list.json", function(data) {
            const webcam = data.webcams.find((element)=>element.slug === match.data.name);
            if (webcam) {
                (0, $b51085ee695c0fdd$export$3d0a3aba327d4829)(null, webcam, ()=>{
                    $a512f8659cf98537$var$router.navigate("/");
                });
                (0, $gYLTL.logPageView)($a512f8659cf98537$var$router.lastResolved(), "/webcam/" + webcam.slug, webcam.label);
            }
        });
    });
});
$a512f8659cf98537$var$router.on("/port/:name", function(match) {
    (0, $gYLTL.layers).activeSpot = null;
    $a512f8659cf98537$var$displayDefaultData(function() {
        (0, $5ewvA.getAsync)((0, $j5Ozl.config).backEndUrl + "/harbors/list.json", function(data) {
            const harbor = data.harbors.find((element)=>element.slug === match.data.name);
            if (harbor) {
                (0, $b51085ee695c0fdd$export$a56d4708c86e0d68)(null, harbor, ()=>{
                    $a512f8659cf98537$var$router.navigate("/");
                });
                (0, $gYLTL.logPageView)($a512f8659cf98537$var$router.lastResolved(), "/port/" + harbor.slug, harbor.label);
            }
        });
    });
});
$a512f8659cf98537$var$router.on("/previsions/:name", function(match) {
    (0, $gYLTL.layers).activeSpot = null;
    $a512f8659cf98537$var$displayDefaultData(function() {
        (0, $5ewvA.getAsync)((0, $j5Ozl.config).backEndUrl + "/live_forecasts/weather.json", function(poisData) {
            const poi = poisData["pois"].find((element)=>element.slug === match.data.name);
            if (poi) {
                (0, $145480a03a16151b$export$564dd0f7905e57b7)(null, poi);
                const menuBtn = document.querySelector("#weather_fc");
                if (menuBtn.classList.contains("active") && (0, $gYLTL.layers).dataLayers.indexOf("weather_fc") !== -1) (0, $145480a03a16151b$export$c5f0806055af3943)(poi.slug);
                (0, $gYLTL.map).instance.setView(new $645b7147683636d0$exports.LatLng(parseFloat(poi.lat) - 0.1, parseFloat(poi.lng)), 9.5);
                (0, $gYLTL.logPageView)($a512f8659cf98537$var$router.lastResolved(), "/previsions/" + poi.slug, poi.label);
                $a512f8659cf98537$var$setAutoRefresh();
            }
        });
    });
});
$a512f8659cf98537$var$router.on("/profil/:account/spots/:spot", function(match) {
    const spotRef = match.data.spot, editMode = match.params?.edit;
    const userSpot = (0, $904ba957439cb654$export$14a75613620cf6da)(spotRef), isEdit = editMode === "true";
    userSpot.edit = isEdit;
    (0, $gYLTL.layout).edit = isEdit;
    if (!isEdit) (0, $gYLTL.layers).activeSpot = userSpot;
    else (0, $gYLTL.layers).activeSpot = null;
    console.debug("userSpot: " + JSON.stringify(userSpot));
    $a512f8659cf98537$var$displayDefaultData(function() {
        console.debug(`setView : ${userSpot.mapCenter[0]}, ${userSpot.mapCenter[1]}`);
        (0, $gYLTL.map).instance.setView(new $645b7147683636d0$exports.LatLng(userSpot.mapCenter[0], userSpot.mapCenter[1]), userSpot.mapZoom);
        if (userSpot.pois.length) (0, $5ewvA.getAsync)((0, $j5Ozl.config).backEndUrl + "/live_forecasts/weather.json", function(poisData) {
            const poi = poisData["pois"].find((element)=>element.slug === userSpot.pois[0]);
            if (poi) (0, $145480a03a16151b$export$564dd0f7905e57b7)(null, poi);
        });
        if (userSpot.point) setTimeout(function() {
            const coords = $645b7147683636d0$exports.latLng(userSpot.point[0], userSpot.point[1]);
            (0, $gYLTL.map).popup = $645b7147683636d0$exports.popup().setLatLng(coords);
            (0, $j5Ozl.config).popup = (0, $gYLTL.map).popup;
            (0, $cb3e0081c099494f$export$3a23bfc5dbd63f67)((0, $j5Ozl.config).popup, {
                latlng: coords
            });
            (0, $j5Ozl.config).popup.openOn((0, $gYLTL.map).instance);
        }, 1000);
        else if ((0, $gYLTL.map).popup) {
            (0, $gYLTL.map).popup.remove();
            (0, $gYLTL.map).popup = null;
        }
        if (userSpot.edit) {
            (0, $904ba957439cb654$export$b76628102be99548)(spotRef);
            setTimeout(function() {
                (0, $904ba957439cb654$export$b20553db877206de)(userSpot);
            }, 1500);
        } else document.querySelector("#edit_spot_controls").classList.add("hidden");
        (0, $gYLTL.logPageView)($a512f8659cf98537$var$router.lastResolved(), `/spots/${spotRef}`, `Spot ${spotRef}`);
        $a512f8659cf98537$var$setAutoRefresh();
    }, userSpot);
});
$a512f8659cf98537$var$router.on("/:name", function(match) {
    (0, $gYLTL.layers).activeSpot = null;
    $a512f8659cf98537$var$displayDefaultData(function() {
        (0, $j5Ozl.loadSensors)(function(data) {
            let sensors = Object.values(data.sensors["WindSensor"] || {}).concat(Object.values(data.sensors["WaveSensor"] || {})).concat(Object.values(data.sensors["TempSensor"] || {}));
            let sensor = sensors.find((s)=>s.slug === match.data.name);
            if (sensor) {
                (0, $418aca01110c9e5e$export$aadaa5940712eda)(null, sensor, ()=>{
                    $a512f8659cf98537$var$router.navigate("/");
                });
                (0, $gYLTL.logPageView)($a512f8659cf98537$var$router.lastResolved(), "/" + sensor.slug, sensor.label);
                $a512f8659cf98537$var$setAutoRefresh();
            }
        });
    });
});
if (localStorage.getItem("windUser")) {
    (0, $904ba957439cb654$export$745b26d8c003724a)();
    $a512f8659cf98537$var$router.resolve();
} else {
    // if (config.favoritePath && window.location.pathname === '/') {
    //   if(document.querySelector("#map_favorite button").classList.contains("no-favorite")){
    //     document.querySelector("#map_favorite button").classList.remove("no-favorite")
    //   }
    //   router.navigate(config.favoritePath);
    // } else {
    //   if(!document.querySelector("#map_favorite button").classList.contains("no-favorite")){
    //     document.querySelector("#map_favorite button").classList.add("no-favorite")
    //   }
    //   router.resolve();
    // }
    $a512f8659cf98537$var$router.resolve();
    if (window.location.search.indexOf("nosplash") === -1) (0, $gYLTL.displayWindFranceForm)(1000);
}
function $a512f8659cf98537$var$displayDefaultData(callback, customConfig = {}) {
    let isHome = $a512f8659cf98537$var$router.lastResolved() === null || $a512f8659cf98537$var$router.lastResolved().path === "";
    console.debug("displayDefaultData - customConfig " + JSON.stringify(customConfig));
    if (isHome || customConfig && JSON.stringify(customConfig) !== "{}") {
        (0, $gYLTL.updateLayout)();
        const referenceDate = new Date(new Date().toDateString()).getTime() / 1000;
        (0, $cb3e0081c099494f$export$b08464e47b7a3a8)(customConfig);
        try {
            (0, $j5Ozl.loadSensors)(function() {
                (0, $b51085ee695c0fdd$export$c3627125dd65970c)();
                const mapContainer = document.querySelector("#map_container"), sideLayers = document.querySelectorAll("#layers_tab button"), mapLayers = document.querySelectorAll("#map_layers button");
                (0, $cb3e0081c099494f$export$382d1aca2389ca8b)();
                (0, $cb3e0081c099494f$export$c9d7b40556b56979)();
                if ((0, $gYLTL.map).popup) {
                    (0, $gYLTL.map).popup.close();
                    (0, $gYLTL.map).popup = null;
                }
                (0, $gYLTL.map).activeMap = null;
                for (const btn of sideLayers)btn.classList.remove("active");
                for (const btn of mapLayers)btn.classList.remove("active");
                if (document.body.classList.contains("active_poi")) (0, $145480a03a16151b$export$b678dbcde018e0b2)();
                const bgLayers = customConfig.bgLayers || [
                    "wm"
                ];
                const dataLayers = customConfig.dataLayers || [
                    "wind",
                    "waves"
                ];
                for (const l of bgLayers)(0, $cb3e0081c099494f$export$720449d359f5eb20)(document.querySelector(`.map_layer[onclick*='${l}']`), l);
                for (const l of dataLayers){
                    (0, $b51085ee695c0fdd$export$2f794522d80bee9d)(l);
                    (0, $gYLTL.layers).dataLayers.push(l);
                    mapContainer.classList.add(l);
                    document.querySelector(`#layers_tab #${l}_side`)?.classList?.add("active");
                    document.querySelector(`#map_layers #${l}`)?.classList?.add("active");
                }
                if (callback) callback();
            });
        } catch (e) {
            console.error("default init error: " + e);
        }
        (0, $fb487846a357c1c2$export$59153413680588f8)(referenceDate);
        (0, $b51085ee695c0fdd$export$f45e13584efe3e9)();
    } else try {
        (0, $b51085ee695c0fdd$export$2eeb97286c6ecc12)();
        (0, $b51085ee695c0fdd$export$73503ae067c61ef7)();
        // displayWaterTemp();
        if (callback) callback();
    } catch (e) {
        console.error("default init error: " + e);
    }
}
function $a512f8659cf98537$var$setAutoRefresh() {
// if (autoRefresh) {
//   clearTimeout(autoRefresh);
// }
// autoRefresh = setTimeout(function() {
//   window.location.reload();
// }, 900000);
}
var // console.timeEnd('routerConfig');
$a512f8659cf98537$export$2e2bcd8739ae039 = $a512f8659cf98537$var$router;




var $gYLTL = parcelRequire("gYLTL");
const $145480a03a16151b$export$77b77ede33ca4f0d = '  <div class="heading_table">      <div class="table_header_1 details_btn"><span class="short_label">N\xe9b.</span><span>N\xe9bulosit\xe9</span><span><button onclick="wm.toggleLines(this, \'neb_haute\', \'neb_moyenne\', \'neb_basse\');" class="button"></button></span></div>      <div class="neb_haute table_header_1" style="display:none;"><span class="short_label">Haute</span><span>N\xe9bulosit\xe9 haute</span> <span>%</span></div>      <div class="table_header_1 neb_moyenne" style="display:none;"><span class="short_label">Moy.</span><span>N\xe9bulosit\xe9 moyenne</span> <span>%</span></div>      <div class="table_header_1 neb_basse" style="display:none;"><span class="short_label">Basse</span><span>N\xe9bulosit\xe9 basse</span> <span>%</span></div>      <div class="table_header_1"><span class="short_label">Temp.</span><span>Temp\xe9rature</span> <span>\xb0C</span></div>      <div class="table_header_1 details_btn"><span class="short_label">Pr\xe9c.</span><span>Pr\xe9cipitation</span> <span>mm/h</span> <span><button onclick="wm.toggleLines(this, \'humidity_values\', \'pression_values\');" class="button"></button></span></div>      <div class="table_header_1 pression_values " style="display:none;"><span class="short_label">P</span><span>Pression</span> <span>(hPa)</span></div>      <div class="table_header_1 humidity_values" style="display:none;"><span class="short_label">Hum.</span><span>Humidit\xe9</span></div>      <div class="table_header_1 th-border-top"><span class="short_label">Vit.</span><span>Vitesse</span> <span>nds</span></div>      <div class="table_header_1"><span class="short_label">Raf.</span><span>Rafales</span> <span>nds</span></div>      <div class="table_header_1 zindex_high details_btn"><span class="short_label">Dir.</span><span>Direction</span><span><button onclick="wm.toggleLines(this, \'wind_direction_values\');" class="button"></button></span></div>      <div class="table_header_1 wind_direction_values" style="display:none;"><span class="short_label">Dir.</span><span>Direction</span> <span>\xb0</span></div>      <div class="table_header_1 th-border-top" ><span class="short_label">Mer tot.</span><span>Mer totale - hauteur</span> <span>m</span></div>      <div class="table_header_1 zindex_high" ><span class="short_label">Dir.</span><span>Direction</span></div>      <div class="table_header_1 details_btn" ><span class="short_label">P\xe9riode</span><span>P\xe9riode (s)</span>  <span><button onclick="wm.toggleLines(this, \'primary_swell_direction\',\'primary_swell_height\',\'primary_swell_period\', \'secondary_swell_values\', \'secondary_swell_height\',\'secondary_swell_period\');" class="button"></button></span></div>      <div class="table_header_1 zindex_high primary_swell_direction" style="display:none;"><span class="short_label">HP dir.</span><span>Houle primaire - direction</span></div>      <div class="table_header_1 primary_swell_height" style="display:none;"><span class="short_label">H (m)</span><span>Hauteur (m)</span></div>      <div class="table_header_1 primary_swell_period" style="display:none;"><span class="short_label">P (s)</span><span>P\xe9riode (s)</span></div>      <div class="table_header_1 zindex_high secondary_swell_values" style="display:none;"><span class="short_label">HS dir.</span><span>Houle secondaire - direction</span></div>      <div class="table_header_1 secondary_swell_height" style="display:none;"><span class="short_label">H (m)</span><span>Hauteur (m)</span></div>      <div class="table_header_1 secondary_swell_period" style="display:none;"><span class="short_label"> P (s)</span><span>P\xe9riode (s)</span></div>  </div>';
const $145480a03a16151b$export$cf29ab69f4b683c7 = '    <div class="content_table">      <div class="details_source"></div>      <div class="details_hours"></div>      <div class="details_neb"></div>      <div class="neb_haute details_nebh" style="display:none;"></div>      <div class="neb_moyenne details_nebm" style="display:none;"></div>      <div class="neb_basse details_nebl" style="display:none;"></div>      <div class="details_temp"></div>      <div class="details_rain"></div>      <div style="display:none;" class="pression_values details_pres"></div>      <div style="display:none;" class="humidity_values details_rh"></div>      <div class="details_ws"></div>      <div class="details_wg"></div>      <div class="details_wd"></div>      <div style="display:none;" class="wind_direction_values details_wd_deg"></div>      <div class="details_hs"></div>      <div class="details_ds"></div>      <div class="details_ps"></div>      <div class="details_dsp primary_swell_direction" style="display:none;"></div>      <div style="display:none;" class="primary_swell_height details_hsp"></div>      <div style="display:none;" class="primary_swell_period details_psp"></div>      <div style="display:none;" class="secondary_swell_values details_dss"></div>      <div style="display:none;" class="secondary_swell_height details_hss"></div>      <div style="display:none;" class="secondary_swell_period details_pss"></div>    </div>';
function $145480a03a16151b$export$564dd0f7905e57b7(evt, dt) {
    if (evt) {
        evt.preventDefault();
        evt.stopPropagation();
    }
    const now = new Date().getTime() / 1000, prevHour = now - now % 3600;
    (0, $5ewvA.getAsync)(`${(0, $j5Ozl.config).backEndUrl}/live_forecasts/details.json?poi=${dt.id}&timestamp=${prevHour - 86400}`, function(details) {
        document.querySelector("#timeline").classList.add("weather_details");
        document.querySelector("#weather_details_header").innerHTML = $145480a03a16151b$export$77b77ede33ca4f0d;
        document.querySelector("#weather_title").innerHTML = "<h2>" + dt.name + "</h2>";
        document.querySelector("#weather_details").innerHTML = $145480a03a16151b$export$cf29ab69f4b683c7;
        document.querySelector("#weather_buttons").innerHTML = '<button aria-label="Fermer" onclick="wm.closePoi()"><i class="fas fa-times"></i></button>';
        document.body.classList.add("active_poi");
        document.querySelector(".weather_poi.poi-active")?.classList?.remove("poi-active");
        document.querySelector(`#poi_${dt.slug}.weather_poi`)?.classList?.add("poi-active");
        (0, $gYLTL.layers).activePoi = dt;
        let allHours = details.timestamps.reduce(function(currentHours, newHours) {
            return currentHours.concat(newHours[1]);
        }, []);
        // d3.select("#weather_details .details_header").selectAll(".table_day").data(details.timestamps).join("div")
        //   .attr("class", "table_day").attr("data-number", function(d) { return  d[1].length }).attr("style", function(d) { return "width: " + (d[1].length * 30) + "px;"; }).text(function(d) { return d[0]; });
        $d78f01d7851d977e$export$2e2bcd8739ae039("#weather_details .details_hours").selectAll(".table_hour").data(allHours).join("div").attr("class", "table_hour").attr("data-hour", function(d) {
            return d;
        }).text(function(d) {
            return d;
        }).attr("data-source", function(d) {
            return d.source ? d.source.substring(0, 3).toLowerCase() : "";
        }).text(function(d) {
            return d.source ? d.source.substring(0, 3).toUpperCase() : "";
        });
        $d78f01d7851d977e$export$2e2bcd8739ae039("#weather_details .details_neb").selectAll(".table_neb_icon").data(details.data.tcc).join("div").attr("class", "table_neb_icon").text(function(d) {
            return d;
        });
        $d78f01d7851d977e$export$2e2bcd8739ae039("#weather_details .details_neb").selectAll(".table_neb_icon").data(allHours).join("div").attr("data-hour", function(d) {
            return d;
        });
        $d78f01d7851d977e$export$2e2bcd8739ae039("#weather_details .details_nebh").selectAll(".table_neb_color").data(details.data.hcc).join("div").attr("class", "table_neb_color").text(function(d) {
            return d;
        });
        $d78f01d7851d977e$export$2e2bcd8739ae039("#weather_details .details_nebh").selectAll(".table_neb_color").data(allHours).join("div").attr("data-hour", function(d) {
            return d;
        });
        $d78f01d7851d977e$export$2e2bcd8739ae039("#weather_details .details_nebm").selectAll(".table_neb_color").data(details.data.mcc).join("div").attr("class", "table_neb_color").text(function(d) {
            return d;
        });
        $d78f01d7851d977e$export$2e2bcd8739ae039("#weather_details .details_nebm").selectAll(".table_neb_color").data(allHours).join("div").attr("data-hour", function(d) {
            return d;
        });
        $d78f01d7851d977e$export$2e2bcd8739ae039("#weather_details .details_nebl").selectAll(".table_neb_color").data(details.data.lcc).join("div").attr("class", "table_neb_color").text(function(d) {
            return d;
        });
        $d78f01d7851d977e$export$2e2bcd8739ae039("#weather_details .details_nebl").selectAll(".table_neb_color").data(allHours).join("div").attr("data-hour", function(d) {
            return d;
        });
        $d78f01d7851d977e$export$2e2bcd8739ae039("#weather_details .details_temp").selectAll(".table_temp").data(details.data.temp).join("div").attr("class", "table_temp").text(function(d) {
            return d;
        });
        $d78f01d7851d977e$export$2e2bcd8739ae039("#weather_details .details_temp").selectAll(".table_temp").data(allHours).join("div").attr("data-hour", function(d) {
            return d;
        });
        $d78f01d7851d977e$export$2e2bcd8739ae039("#weather_details .details_rain").selectAll(".table_rain_color").data(details.data.rain).join("div").attr("class", "table_rain_color").text(function(d, i) {
            return i === 0 || details.data.rain[i - 1] === d || d === 0 ? "" : details.data.rain[i - 1] >= d ? d : Math.round(d * 10 - details.data.rain[i - 1] * 10) / 10;
        });
        $d78f01d7851d977e$export$2e2bcd8739ae039("#weather_details .details_rain").selectAll(".table_rain_color").data(allHours).join("div").attr("data-hour", function(d) {
            return d;
        });
        $d78f01d7851d977e$export$2e2bcd8739ae039("#weather_details .details_ws").selectAll(".table_wind").data(details.data.wind_s).join("div").attr("class", "table_wind").text(function(d) {
            return d;
        });
        $d78f01d7851d977e$export$2e2bcd8739ae039("#weather_details .details_ws").selectAll(".table_wind").data(allHours).join("div").attr("data-hour", function(d) {
            return d;
        });
        $d78f01d7851d977e$export$2e2bcd8739ae039("#weather_details .details_wg").selectAll(".table_wind").data(details.data.gust_s).join("div").attr("class", "table_wind").text(function(d) {
            return d;
        });
        $d78f01d7851d977e$export$2e2bcd8739ae039("#weather_details .details_wg").selectAll(".table_wind").data(allHours).join("div").attr("data-hour", function(d) {
            return d;
        });
        $d78f01d7851d977e$export$2e2bcd8739ae039("#weather_details .details_wd").selectAll(".table_wind_icon").data(details.data.wind_d).join("div").attr("class", "table_wind_icon").append("img").attr("class", "wind_dir_arrow img-small").attr("src", (0, (/*@__PURE__*/$parcel$interopDefault($39cbcd9072da7ec9$exports)))["fleche-vent"]).attr("style", function(d) {
            return "transform: rotate(" + (90 - d) + "deg); transform-origin: 50% 50% 0px; display: inline;";
        });
        $d78f01d7851d977e$export$2e2bcd8739ae039("#weather_details .details_wd").selectAll(".table_wind_icon").data(allHours).join("div").attr("data-hour", function(d) {
            return d;
        });
        $d78f01d7851d977e$export$2e2bcd8739ae039("#weather_details .details_wd_deg").selectAll(".table_wind_deg").data(details.data.wind_d).join("div").attr("class", "table_wind_deg").text(function(d) {
            return (270 - d) % 360;
        });
        $d78f01d7851d977e$export$2e2bcd8739ae039("#weather_details .details_wd_deg").selectAll(".table_wind_deg").data(allHours).join("div").attr("data-hour", function(d) {
            return d;
        });
        $d78f01d7851d977e$export$2e2bcd8739ae039("#weather_details .details_hs").selectAll(".table_wave_height").data(details.data.wave_h).join("div").attr("class", "table_wave_height").text(function(d) {
            return d;
        });
        $d78f01d7851d977e$export$2e2bcd8739ae039("#weather_details .details_hs").selectAll(".table_wave_height").data(allHours).join("div").attr("data-hour", function(d) {
            return d;
        });
        $d78f01d7851d977e$export$2e2bcd8739ae039("#weather_details .details_ds").selectAll(".table_wind_icon").data(details.data.wave_d).join("div").attr("class", "table_wind_icon").append("img").attr("class", function(d) {
            return d ? "img-small" : "hidden";
        }).attr("src", (0, (/*@__PURE__*/$parcel$interopDefault($39cbcd9072da7ec9$exports)))["fleche-vague"]).attr("style", function(d) {
            return "transform: rotate(" + (d - 180) + "deg); transform-origin: 50% 50% 0px; display: inline;";
        });
        $d78f01d7851d977e$export$2e2bcd8739ae039("#weather_details .details_ds").selectAll(".table_wind_icon").data(allHours).join("div").attr("data-hour", function(d) {
            return d;
        });
        $d78f01d7851d977e$export$2e2bcd8739ae039("#weather_details .details_ps").selectAll(".table_wind_period").data(details.data.ptp).join("div").attr("class", "table_wind_period").text(function(d) {
            return d;
        });
        $d78f01d7851d977e$export$2e2bcd8739ae039("#weather_details .details_ps").selectAll(".table_wind_period").data(allHours).join("div").attr("data-hour", function(d) {
            return d;
        });
        $d78f01d7851d977e$export$2e2bcd8739ae039("#weather_details .details_dsp").selectAll(".table_wind_icon").data(details.data.pdir1).join("div").attr("class", "table_wind_icon").append("img").attr("class", function(d) {
            return d ? "img-small" : "hidden";
        }).attr("src", (0, (/*@__PURE__*/$parcel$interopDefault($39cbcd9072da7ec9$exports)))["fleche-vague"]).attr("style", function(d) {
            return "transform: rotate(" + (d - 180) + "deg); transform-origin: 50% 50% 0px; display: inline;";
        });
        $d78f01d7851d977e$export$2e2bcd8739ae039("#weather_details .details_dsp").selectAll(".table_wind_icon").data(allHours).join("div").attr("data-hour", function(d) {
            return d;
        });
        $d78f01d7851d977e$export$2e2bcd8739ae039("#weather_details .details_hsp").selectAll(".table_wind_period").data(details.data.phs1).join("div").attr("class", "table_wind_period txt_smaller").html(function(d) {
            return d;
        });
        $d78f01d7851d977e$export$2e2bcd8739ae039("#weather_details .details_hsp").selectAll(".table_wind_period").data(allHours).join("div").attr("data-hour", function(d) {
            return d;
        });
        $d78f01d7851d977e$export$2e2bcd8739ae039("#weather_details .details_psp").selectAll(".table_wind_period").data(details.data.ptp1).join("div").attr("class", "table_wind_period").text(function(d) {
            return d;
        });
        $d78f01d7851d977e$export$2e2bcd8739ae039("#weather_details .details_psp").selectAll(".table_wind_period").data(allHours).join("div").attr("data-hour", function(d) {
            return d;
        });
        $d78f01d7851d977e$export$2e2bcd8739ae039("#weather_details .details_dss").selectAll(".table_wind_icon").data(details.data.pdir0).join("div").attr("class", "table_wind_icon").append("img").attr("class", function(d) {
            return d ? "img-small" : "hidden";
        }).attr("src", (0, (/*@__PURE__*/$parcel$interopDefault($39cbcd9072da7ec9$exports)))["fleche-vague"]).attr("style", function(d) {
            return "transform: rotate(" + (d - 180) + "deg); transform-origin: 50% 50% 0px; display: inline;";
        });
        $d78f01d7851d977e$export$2e2bcd8739ae039("#weather_details .details_dss").selectAll(".table_wind_icon").data(allHours).join("div").attr("data-hour", function(d) {
            return d;
        });
        $d78f01d7851d977e$export$2e2bcd8739ae039("#weather_details .details_hss").selectAll(".table_wind_period").data(details.data.phs0).join("div").attr("class", "table_wind_period txt_smaller").html(function(d) {
            return d;
        });
        $d78f01d7851d977e$export$2e2bcd8739ae039("#weather_details .details_hss").selectAll(".table_wind_period").data(allHours).join("div").attr("data-hour", function(d) {
            return d;
        });
        $d78f01d7851d977e$export$2e2bcd8739ae039("#weather_details .details_pss").selectAll(".table_wind_period").data(details.data.ptp0).join("div").attr("class", "table_wind_period").text(function(d) {
            return d;
        });
        $d78f01d7851d977e$export$2e2bcd8739ae039("#weather_details .details_pss").selectAll(".table_wind_period").data(allHours).join("div").attr("data-hour", function(d) {
            return d;
        });
        $d78f01d7851d977e$export$2e2bcd8739ae039("#weather_details .details_pres").selectAll(".table_wind_pression").data(details.data.pr).join("div").attr("class", "table_wind_pression").text(function(d) {
            return d ? d / 100.0 : "";
        });
        $d78f01d7851d977e$export$2e2bcd8739ae039("#weather_details .details_pres").selectAll(".table_wind_pression").data(allHours).join("div").attr("data-hour", function(d) {
            return d;
        });
        $d78f01d7851d977e$export$2e2bcd8739ae039("#weather_details .details_rh").selectAll(".table_rh").data(details.data.rh).join("div").attr("class", "table_rh txt_smaller").text(function(d) {
            return d;
        });
        $d78f01d7851d977e$export$2e2bcd8739ae039("#weather_details .details_rh").selectAll(".table_rh").data(allHours).join("div").attr("data-hour", function(d) {
            return d;
        });
        $d78f01d7851d977e$export$2e2bcd8739ae039("#weather_details .details_source").selectAll(".table_source").data(details.source).join("div").attr("class", "table_source").attr("data-source", function(d) {
            return d.source ? d.source.substring(0, 3).toLowerCase() : "";
        });
        // d3.select("#weather_details .details_source").selectAll(".table_source").data(allHours)
        //   .join("div").attr("data-hour", function(d) { return d; });
        $145480a03a16151b$var$setWindColor();
        $145480a03a16151b$var$setTempColor();
        $145480a03a16151b$var$setNebColor();
        $145480a03a16151b$var$setNebIcon();
        $145480a03a16151b$var$setRainIcon();
        $145480a03a16151b$var$setWaveColor();
        $145480a03a16151b$var$setWavePeriodColor();
        $145480a03a16151b$var$setRainColor();
        $145480a03a16151b$var$setPressionColor();
        $145480a03a16151b$var$setNightColor();
        // initFavorite(dt.slug);
        (0, $fb487846a357c1c2$export$9cc3739d965cbe89)(true, true);
    });
}
function $145480a03a16151b$var$setWindColor() {
    var i, windSpeed, color, windCells = document.getElementsByClassName("table_wind");
    for(i = 0; i < windCells.length; i++){
        windSpeed = parseFloat(windCells[i].innerText || windCells[i].textContent);
        color = (0, $j5Ozl.windColor)(windSpeed);
        windCells[i].style.color = color.text;
        windCells[i].style.backgroundColor = color.bg;
    }
}
function $145480a03a16151b$var$setTempColor() {
    var i, temp, tempCells = document.getElementsByClassName("table_temp");
    for(i = 0; i < tempCells.length; i++){
        temp = parseFloat(tempCells[i].innerText || tempCells[i].textContent);
        tempCells[i].style.color = (0, $j5Ozl.tempColor)(temp);
    }
}
function $145480a03a16151b$var$setWaveColor() {
    var i, waveHeight, waveCells = document.getElementsByClassName("table_wave_height");
    for(i = 0; i < waveCells.length; i++){
        waveHeight = parseFloat(waveCells[i].innerText || waveCells[i].textContent);
        waveCells[i].style.backgroundColor = (0, $j5Ozl.waveColor)(waveHeight);
    }
}
function $145480a03a16151b$var$setNebColor() {
    var i, neb, nebCells = document.getElementsByClassName("table_neb_color");
    for(i = 0; i < nebCells.length; i++){
        neb = parseFloat(nebCells[i].innerText || nebCells[i].textContent);
        if (neb < 13) nebCells[i].style.backgroundColor = "#ffffff";
        else if (neb > 14 && neb < 38) nebCells[i].style.backgroundColor = "#D9D9D9";
        else if (neb > 37 && neb < 63) {
            nebCells[i].style.backgroundColor = "#BEBEBE";
            nebCells[i].style.color = "#FFFFFF";
        } else if (neb > 62 && neb < 88) {
            nebCells[i].style.backgroundColor = "#A6A5A6";
            nebCells[i].style.color = "#FFFFFF";
        } else if (neb > 87 && neb < 101) {
            nebCells[i].style.backgroundColor = "#808181";
            nebCells[i].style.color = "#FFFFFF";
        } else nebCells[i].style.backgroundColor = "#FFFFFF";
    }
}
function $145480a03a16151b$var$setRainColor() {
    var i, rainHeight, rainCells = document.getElementsByClassName("table_rain_color");
    for(i = 0; i < rainCells.length; i++){
        rainHeight = parseFloat(rainCells[i].innerText || rainCells[i].textContent);
        rainCells[i].style.backgroundColor = (0, $j5Ozl.rainColor)(rainHeight);
    }
}
function $145480a03a16151b$var$setWavePeriodColor() {
    var i, period, periodCells = document.querySelectorAll(".details_ps .table_wind_period");
    for(i = 0; i < periodCells.length; i++){
        period = parseFloat(periodCells[i].innerText || periodCells[i].textContent);
        periodCells[i].style.backgroundColor = (0, $j5Ozl.periodColor)(period);
    }
}
function $145480a03a16151b$var$setNebIcon() {
    let i, nebH, nebM, nebL, rain, hour, icon;
    let nebCells = document.querySelectorAll("#weather_details .table_neb_icon"), nebHCells = document.querySelectorAll("#weather_details .details_nebh .table_neb_color"), nebMCells = document.querySelectorAll("#weather_details .details_nebm .table_neb_color"), nebLCells = document.querySelectorAll("#weather_details .details_nebl .table_neb_color"), rainCells = document.querySelectorAll("#weather_details .table_rain_color"), hourCells = document.querySelectorAll("#weather_details .table_hour");
    for(i = 0; i < nebCells.length; i++){
        nebH = nebHCells[i] ? parseFloat(nebHCells[i].innerText || nebHCells[i].textContent) : 0;
        nebM = nebMCells[i] ? parseFloat(nebMCells[i].innerText || nebMCells[i].textContent) : 0;
        nebL = nebLCells[i] ? parseFloat(nebLCells[i].innerText || nebLCells[i].textContent) : 0;
        rain = rainCells[i] ? parseFloat(rainCells[i].innerText || rainCells[i].textContent) : 0;
        hour = hourCells[i] ? parseFloat(hourCells[i].getAttribute("data-hour").replace("h", "")) : 0;
        icon = $145480a03a16151b$export$a815945e7f6f673b(nebH, nebM, nebL, hour, rain);
        // console.log('computeNebIcon - neb : ' +  nebH+ ' - hour : ' + hour + ' - rain : ' + rain + ' -> icon : ' + icon);
        nebCells[i].innerHTML = icon ? '<img class="img-icon" src="' + (0, (/*@__PURE__*/$parcel$interopDefault($7636ed459e8205ef$exports)))[icon] + '" alt="' + icon + '">' : "";
    }
}
function $145480a03a16151b$export$a815945e7f6f673b(nebH, nebM, nebL, hour, rain) {
    // console.log('computeNebIcon: ' + JSON.stringify({nebH, nebM, nebL, hour, rain}));
    let icon = "", sunOrMoon = hour < 21 && hour > 6 ? "soleil" : "lune";
    /* nebM et nebL ce qui prévaut c'est le plus couvert*/ if (nebM <= nebL) {
        /* Ciel dégagé ou voilé */ if (nebM <= 19 && nebL <= 19) {
            if (nebH <= 80) /* ciel clair */ icon = $145480a03a16151b$var$applyRain(sunOrMoon, rain);
            else /* ciel voilé */ icon = $145480a03a16151b$var$applyRain(sunOrMoon + "-voile", rain);
        } else if (nebL >= 20 && nebL <= 49) icon = $145480a03a16151b$var$applyRain(sunOrMoon + "-nuage-1", rain);
        else if (nebL >= 50 && nebL <= 79) icon = $145480a03a16151b$var$applyRain(sunOrMoon + "-nuage-2", rain);
        else if (nebL >= 80) icon = $145480a03a16151b$var$applyRain("nuage-3", rain);
    } else if (nebM > nebL) {
        /* Ciel dégagé ou voilé */ if (nebM <= 19 && nebL <= 19) {
            if (nebH <= 80) /* ciel clair */ icon = $145480a03a16151b$var$applyRain(sunOrMoon, rain);
            else /* ciel voilé */ icon = $145480a03a16151b$var$applyRain(sunOrMoon + "-voile", rain);
        } else if (nebM >= 20 && nebM <= 49) icon = $145480a03a16151b$var$applyRain(sunOrMoon + "-nuage-1", rain);
        else if (nebM >= 50 && nebM <= 79) icon = $145480a03a16151b$var$applyRain(sunOrMoon + "-nuage-2", rain);
        else if (nebM >= 80) icon = $145480a03a16151b$var$applyRain("nuage-3", rain);
    }
    return icon;
}
function $145480a03a16151b$var$applyRain(prefix, rain) {
    let icon;
    if (rain === 0) icon = prefix;
    else if (rain <= 2.5) icon = prefix + "-pluie-1";
    else if (rain > 2.5 && rain <= 7.6) icon = prefix + "-pluie-2";
    else if (rain > 7.6) icon = prefix + "-pluie-3";
    else icon = prefix;
    return icon;
}
function $145480a03a16151b$var$setRainIcon() {
    var i, x, icon, y = document.getElementsByClassName("table_rain_icon");
    for(i = 0; i < y.length; i++){
        x = parseFloat(y[i].innerText || y[i].textContent);
        if (x <= 2.5) icon = "nuage-pluie-1";
        else if (x > 2.5 && x < 7.7) icon = "nuage-pluie-2";
        else if (x >= 7.7) icon = "nuage-pluie-3";
        else icon = "";
        y[i].innerHTML = icon ? '<img class="img-icon" src="img/weather/' + icon + '.svg" alt="' + icon + '">' : "";
    }
}
function $145480a03a16151b$var$setPressionColor() {
    var i, txt, x, y = document.getElementsByClassName("table_wind_pression");
    for(i = 0; i < y.length; i++){
        txt = y[i].innerText || y[i].textContent;
        if (txt) {
            x = parseFloat(y[i].innerText || y[i].textContent);
            if (x < 1000) {
                y[i].style.fontWeight = "900";
                y[i].innerHTML = Math.trunc(x);
            } else if (x >= 1000 && x < 1020) {
                y[i].style.fontWeight = "500";
                y[i].innerHTML = Math.trunc(x);
            } else if (x >= 1020) {
                y[i].style.fontWeight = "900";
                y[i].innerHTML = Math.trunc(x);
            } else {
                y[i].style.fontWeight = "500";
                y[i].innerHTML = Math.trunc(x);
            }
        }
    }
}
function $145480a03a16151b$var$setNightColor() {
    var i, x, y = document.getElementsByClassName("table_hours");
    for(i = 0; i < y.length; i++){
        x = parseFloat(y[i].innerText || y[i].textContent);
        if (x > 6 && x < 21) y[i].style.backgroundColor = "rgb(255,255,255)";
        else y[i].style.backgroundColor = "rgb(229,229,229)";
    }
}
function $145480a03a16151b$var$initFavorite(slug) {
    let button = document.querySelector("#modal_favorite");
    let text = button.querySelector("span");
    let navBtn = document.querySelector("#map_favorite button");
    if ((0, $j5Ozl.config).favoritePath === "/previsions/" + slug) {
        button.classList.add("is_favorite");
        text.innerHTML = "Supprimer le favori";
        if (navBtn.classList.contains("no-favorite")) navBtn.classList.remove("no-favorite");
    } else {
        button.classList.remove("is_favorite");
        text.innerHTML = "D\xe9finir comme favori";
    }
}
function $145480a03a16151b$export$1ed640048cefe91a(element) {
    var slug = element.getAttribute("data-slug");
    var button = document.querySelector("#modal_favorite");
    var navBtn = document.querySelector("#map_favorite button");
    var text = button.querySelector("span");
    if ((0, $j5Ozl.config).favoritePath === "/previsions/" + slug) {
        localStorage.removeItem("path");
        (0, $j5Ozl.config).favoritePath = "";
        button.classList.remove("is_favorite");
        if (!navBtn.classList.contains("no-favorite")) navBtn.classList.add("no-favorite");
        text.innerHTML = "D\xe9finir comme favori";
    } else {
        button.classList.add("is_favorite");
        text.innerHTML = "Supprimer le favori";
        if (navBtn.classList.contains("no-favorite")) navBtn.classList.remove("no-favorite");
        localStorage.setItem("path", "/previsions/" + slug);
        (0, $j5Ozl.config).favoritePath = "/previsions/" + slug;
    }
}
function $145480a03a16151b$export$b678dbcde018e0b2() {
    if (!(0, $gYLTL.isSpotContext)()) (0, $a512f8659cf98537$export$2e2bcd8739ae039).navigate("/");
    document.querySelector("#timeline").classList.remove("weather_details");
    document.querySelector("#weather_title").innerHTML = "";
    document.body.classList.remove("active_poi");
    (0, $gYLTL.layers).activePoi = null;
    (0, $fb487846a357c1c2$export$9cc3739d965cbe89)(true, false);
    $145480a03a16151b$export$535890a1dbf69608();
}
function $145480a03a16151b$export$c5f0806055af3943(slug) {
    $145480a03a16151b$export$535890a1dbf69608();
    let poi = document.querySelector("#poi_" + slug);
    if (poi) poi.classList.add("poi-active");
}
function $145480a03a16151b$export$535890a1dbf69608() {
    let poiActive = document.querySelector(".poi-active");
    if (poiActive) poiActive.classList.remove("poi-active");
}







/* global proj4 */ 
var $iLKzi = parcelRequire("iLKzi");

var $jTcSi = parcelRequire("jTcSi");
var $e6ff6cf3f009bcd5$exports = {};
var $53ec58915c85ab08$exports = {};
var $821004e6d224a19e$exports = {};
var $56439f984776a4a1$exports = {};
var $816fb6790923d569$exports = {};
$816fb6790923d569$exports = function categorizeIntersection(segments) {
    try {
        let through, xmin, xmax;
        const n = segments.length;
        const first = segments[0];
        if (n === 1) {
            through = true;
            xmin = first.xmin;
            xmax = first.xmax;
        } else {
            const last = segments[n - 1];
            through = first.direction === last.direction;
            xmin = Math.min(first.xmin, last.xmin);
            xmax = Math.max(first.xmax, last.xmax);
        }
        if (xmin === undefined || xmax === undefined || through === undefined || isNaN(xmin) || isNaN(xmax)) throw Error("categorizeIntersection failed with xmin", xmin, "and xmax", xmax);
        return {
            xmin: xmin,
            xmax: xmax,
            through: through
        };
    } catch (error) {
        console.error("[categorizeIntersection] segments:", segments);
        console.error("[categorizeIntersection]", error);
        throw error;
    }
};


var $7509e3f10aa8a3d6$exports = {};
$7509e3f10aa8a3d6$exports = function clamp(n, min, max) {
    if (n < min) return min;
    else if (n > max) return max;
    return n;
};


var $92a7e1323f066261$exports = {};
$92a7e1323f066261$exports = function cluster(items, newClusterTest) {
    try {
        const numberOfItems = items.length;
        const clusters = [];
        let cluster = [];
        for(let i = 0; i < numberOfItems; i++){
            const item = items[i];
            cluster.push(item);
            if (newClusterTest(item)) {
                clusters.push(cluster);
                cluster = [];
            }
        }
        if (cluster.length > 0) clusters.push(cluster);
        return clusters;
    } catch (error) {
        console.error("[cluster]:", error);
    }
};


var $53575899829bd2cd$exports = {};

$53575899829bd2cd$exports = function clusterLineSegments(lineSegments, numberOfEdges, debug = false) {
    try {
        const clusters = $92a7e1323f066261$exports(lineSegments, (s)=>s.endsOffLine);
        const numberOfClusters = clusters.length;
        if (numberOfClusters >= 2) {
            const firstCluster = clusters[0];
            const firstSegment = firstCluster[0];
            const lastCluster = clusters[clusters.length - 1];
            const lastSegment = lastCluster[lastCluster.length - 1];
            if (lastSegment.index === numberOfEdges - 1 && firstSegment.index === 0 && lastSegment.endsOnLine) clusters[0] = clusters.pop().concat(firstCluster);
        }
        return clusters;
    } catch (error) {
        console.error("[clusterLineSegments]", error);
    }
};


var $32c3a9fd9de4c5bd$exports = {};
var $ffd9bc8c5a4f659b$exports = {};
var $6d8cd8d0b5026707$exports = {};
// function to convert two points into a
// representation of a line
$6d8cd8d0b5026707$exports = function getLineFromPoints(startPoint, endPoint) {
    // get a, b, and c from line equation ax + by = c
    const [x1, y1] = startPoint;
    const [x2, y2] = endPoint;
    const a = y2 - y1;
    const b = x1 - x2;
    const c = a * x1 + b * y1;
    // return just a b and c since that is all we need
    // to compute the intersection
    return {
        a: a,
        b: b,
        c: c
    };
};




var $b173830a5f81c459$exports = {};
// This function takes in an array with an even number of elements and
// returns an array that couples every two consecutive elements;
$b173830a5f81c459$exports = function couple(array) {
    const couples = [];
    const lengthOfArray = array.length;
    for(let i = 0; i < lengthOfArray; i += 2)couples.push([
        array[i],
        array[i + 1]
    ]);
    return couples;
};



var $98c8c498fc16fa4f$exports = {};
var $f2b46d82e720eb96$exports = {};
$f2b46d82e720eb96$exports = function eachEdge(polygon, callback) {
    polygon.forEach((ring)=>{
        for(let i = 1; i < ring.length; i++){
            // should reuse previous endPoint as startPoint to save memory
            const startPoint = ring[i - 1];
            const endPoint = ring[i];
            const edgeIndex = i - 1;
            callback([
                startPoint,
                endPoint
            ], edgeIndex);
        }
    });
};


$98c8c498fc16fa4f$exports = function getEdges(polygon) {
    const edges = [];
    $f2b46d82e720eb96$exports(polygon, (edge)=>edges.push(edge));
    return edges;
};


var $4ba49f7db7778a3c$exports = {};
// function to get the point at which two lines intersect
// the input uses the line representations from the
// getLineFromPoints function
$4ba49f7db7778a3c$exports = function getIntersectionOfTwoLines(line1, line2) {
    // calculate the determinant, ad - cb in a square matrix |a b|
    const det = line1.a * line2.b - line2.a * line1.b; /*  |c d| */ 
    if (det) {
        // this makes sure the lines aren't parallel, if they are, det will equal 0
        const x = (line2.b * line1.c - line1.b * line2.c) / det;
        const y = (line1.a * line2.c - line2.a * line1.c) / det;
        return {
            x: x,
            y: y
        };
    }
};


var $5e52bca43aecc70f$exports = {};
var $90c16f9bdd20ab4d$exports = {};
var $3ef794cf89b4cf7e$exports = {};
$3ef794cf89b4cf7e$exports = function getDepth(arr) {
    const isArray = (arr)=>Array.isArray(arr) || arr instanceof Int8Array || arr instanceof Uint8Array || arr instanceof Uint8ClampedArray || arr instanceof Int16Array || arr instanceof Uint16Array || arr instanceof Int32Array || arr instanceof Uint32Array || arr instanceof Float32Array || arr instanceof Float64Array || arr instanceof BigInt64Array || arr instanceof BigUint64Array;
    let depth = 0;
    let part = arr;
    while(isArray(part)){
        depth++;
        part = part[0];
    }
    return depth;
};


// call callback function for each polygon in geojson
$90c16f9bdd20ab4d$exports = function eachPolygon(geojson, callback) {
    if (geojson.type === "FeatureCollection") geojson.features.forEach((feature)=>eachPolygon(feature, callback));
    else if (geojson.type === "Feature") eachPolygon(geojson.geometry, callback);
    else if (geojson.type === "Polygon") eachPolygon(geojson.coordinates, callback);
    else if (geojson.type === "MultiPolygon") geojson.coordinates.forEach((polygon)=>{
        callback(polygon);
    });
    else if (Array.isArray(geojson)) {
        const depth = $3ef794cf89b4cf7e$exports(geojson);
        if (depth === 4) geojson.forEach((polygon)=>{
            callback(polygon);
        });
        else if (depth === 3) callback(geojson);
    }
};


$5e52bca43aecc70f$exports = function getPolygons(geojson) {
    const polygons = [];
    $90c16f9bdd20ab4d$exports(geojson, (polygon)=>polygons.push(polygon));
    return polygons;
};


var $780fd026c6616908$exports = {};
// This function takes in an array of number pairs and combines where there's overlap
$780fd026c6616908$exports = function mergeRanges(ranges) {
    const numberOfRanges = ranges.length;
    if (numberOfRanges > 0) {
        const firstRange = ranges[0];
        let previousEnd = firstRange[1];
        const result = [
            firstRange
        ];
        for(let i = 1; i < numberOfRanges; i++){
            const tempRange = ranges[i];
            const [start, end] = tempRange;
            if (start <= previousEnd) result[result.length - 1][1] = end;
            else result.push(tempRange);
            previousEnd = end;
        }
        return result;
    }
};


var $a35f30dbd8784172$exports = {};
$a35f30dbd8784172$exports = function partition(array, filter) {
    const passed = [];
    const unpassed = [];
    const len = array.length;
    for(let i = 0; i < len; i++){
        const item = array[i];
        if (filter(item)) passed.push(item);
        else unpassed.push(item);
    }
    return [
        passed,
        unpassed
    ];
};


var $2a533358c791f5e8$exports = {};
var $d3e21fc96c65d0fc$exports = {};
/**
 * @name roundDown
 * @description like Math.round, but numbers in the middle are rounded down not up
 * @param {Number} n
 * @returns {Number} rounded number
 */ $d3e21fc96c65d0fc$exports = function roundDown(n) {
    return -1 * Math.round(-1 * n);
};


/**
 * @name prepareSnap
 * @description snap horizontal range in crs to model space
 * @private
 * @param {Number} raster_xmin
 * @param {Number} pixel_width
 * @return {([Number, Number]) => [Number, Number]}
 */ $2a533358c791f5e8$exports = function prepareSnap(raster_xmin, pixel_width) {
    return ([xmin, xmax])=>{
        // use roundDown so 1.5 is rounded to 1 not 2
        xmin = $d3e21fc96c65d0fc$exports((xmin - raster_xmin) / pixel_width);
        if (xmin === -0) xmin = 0;
        xmax = Math.round((xmax - raster_xmin) / pixel_width);
        if (xmax === -0) xmax = 0;
        return [
            xmin,
            xmax
        ];
    };
};


var $c438c954a1277608$exports = {};
$c438c954a1277608$exports = function range(count) {
    const result = new Array(count);
    for(let i = 0; i < count; i++)result[i] = i;
    return result;
};


$ffd9bc8c5a4f659b$exports = function calculateCore({ debug_level: debug_level = 0, raster_bbox: raster_bbox, raster_height: raster_height, raster_width: raster_width, pixel_height: pixel_height, pixel_width: pixel_width, geometry: geometry, per_pixel: per_pixel, per_row_segment: per_row_segment }) {
    const [raster_xmin, raster_ymin, raster_xmax, raster_ymax] = raster_bbox;
    // iterate through image rows and convert each one to a line
    // running through the middle of the row
    const imageLines = [];
    if (raster_height === 0) return;
    for(let y = 0; y < raster_height; y++){
        const lat = raster_ymax - pixel_height * y - pixel_height / 2;
        // use that point, plus another point along the same latitude to
        // create a line
        const point0 = [
            raster_xmin,
            lat
        ];
        const point1 = [
            raster_xmin + 1,
            lat
        ];
        const line = $6d8cd8d0b5026707$exports(point0, point1);
        imageLines.push(line);
    }
    if (debug_level >= 2) console.log("[dufour-peyton-intersection] imageLines:", imageLines);
    // collapse geometry down to a list of edges
    // necessary for multi-part geometries
    const polygons = $5e52bca43aecc70f$exports(geometry);
    const polygonEdges = polygons.map($98c8c498fc16fa4f$exports);
    polygonEdges.forEach((edges)=>{
        // iterate through the list of polygon vertices, convert them to
        // lines, and compute the intersections with each image row
        const intersectionsByRow = $c438c954a1277608$exports(raster_height).map(()=>[]);
        const numberOfEdges = edges.length;
        for(let i = 0; i < numberOfEdges; i++){
            // get vertices that make up an edge and convert that to a line
            const edge = edges[i];
            const [startPoint, endPoint] = edge;
            const [x1, y1] = startPoint;
            const [x2, y2] = endPoint;
            const direction = Math.sign(y2 - y1);
            const horizontal = y1 === y2;
            const vertical = x1 === x2;
            const edgeY = y1;
            const edgeLine = $6d8cd8d0b5026707$exports(startPoint, endPoint);
            const edgeYMin = Math.min(y1, y2);
            const edgeYMax = Math.max(y1, y2);
            let startLng, startLat, endLat, endLng;
            if (x1 < x2) {
                [startLng, startLat] = startPoint;
                [endLng, endLat] = endPoint;
            } else {
                [startLng, startLat] = endPoint;
                [endLng, endLat] = startPoint;
            }
            if (startLng === undefined) throw Error("startLng is " + startLng);
            // find the y values in the image coordinate space
            const imageY1 = Math.round((raster_bbox[3] - 0.5 * pixel_height - startLat) / pixel_height);
            const imageY2 = Math.round((raster_bbox[3] - 0.5 * pixel_height - endLat) / pixel_height);
            // make sure to set the start and end points so that we are
            // incrementing upwards through rows
            let rowStart, rowEnd;
            if (imageY1 < imageY2) {
                rowStart = imageY1;
                rowEnd = imageY2;
            } else {
                rowStart = imageY2;
                rowEnd = imageY1;
            }
            rowStart = $7509e3f10aa8a3d6$exports(rowStart, 0, raster_height - 1);
            rowEnd = $7509e3f10aa8a3d6$exports(rowEnd, 0, raster_height - 1);
            // iterate through image lines within the change in y of
            // the edge line and find all intersections
            for(let j = rowStart; j < rowEnd + 1; j++){
                const imageLine = imageLines[j];
                if (imageLine === undefined) {
                    console.error("j:", j);
                    console.error("imageLines:", imageLines);
                    throw Error("imageLines");
                }
                // because you know x is zero in ax + by = c, so by = c and b = -1, so -1 * y = c or y = -1 * c
                const imageLineY = -1 * imageLine.c;
                const startsOnLine = y1 === imageLineY;
                const endsOnLine = y2 === imageLineY;
                const endsOffLine = !endsOnLine;
                let xminOnLine, xmaxOnLine;
                if (horizontal) {
                    if (edgeY === imageLineY) {
                        xminOnLine = startLng;
                        xmaxOnLine = endLng;
                    } else continue; // stop running calculations for this horizontal line because it doesn't intersect at all
                } else if (vertical) /* we have to have a seprate section for vertical because of floating point arithmetic probs with get_inter..." */ {
                    if (imageLineY >= edgeYMin && imageLineY <= edgeYMax) {
                        xminOnLine = startLng;
                        xmaxOnLine = endLng;
                    }
                } else if (startsOnLine) // we know that the other end is not on the line because then it would be horizontal
                xminOnLine = xmaxOnLine = x1;
                else if (endsOnLine) // we know that the other end is not on the line because then it would be horizontal
                xminOnLine = xmaxOnLine = x2;
                else try {
                    xminOnLine = xmaxOnLine = $4ba49f7db7778a3c$exports(edgeLine, imageLine).x;
                } catch (error) {
                    throw error;
                }
                // check to see if the intersection point is within the range of
                // the edge line segment. If it is, add the intersection to the
                // list of intersections at the corresponding index for that row
                // in intersectionsByRow
                if (xminOnLine !== undefined && xmaxOnLine !== undefined && (horizontal || xminOnLine >= startLng && xmaxOnLine <= endLng && imageLineY <= edgeYMax && imageLineY >= edgeYMin)) intersectionsByRow[j].push({
                    direction: direction,
                    index: i,
                    edge: edge,
                    endsOnLine: endsOnLine,
                    endsOffLine: endsOffLine,
                    horizontal: horizontal,
                    startsOnLine: startsOnLine,
                    vertical: vertical,
                    xmin: xminOnLine,
                    xmax: xmaxOnLine,
                    imageLineY: imageLineY
                });
            }
        }
        const half_pixel_width = pixel_width / 2;
        const snap = $2a533358c791f5e8$exports(raster_xmin, pixel_width);
        intersectionsByRow.forEach((segmentsInRow, row_index)=>{
            if (segmentsInRow.length > 0) {
                const clusters = $53575899829bd2cd$exports(segmentsInRow, numberOfEdges);
                const categorized = clusters.map($816fb6790923d569$exports);
                const [throughs, nonthroughs] = $a35f30dbd8784172$exports(categorized, (item)=>item.through);
                if (throughs.length % 2 === 1) {
                    if (debug_level >= 1) console.error("throughs:", JSON.stringify(throughs));
                    throw Error("throughs.length for " + row_index + " is odd with " + throughs.length);
                }
                let insides = nonthroughs.map((intersection)=>[
                        intersection.xmin,
                        intersection.xmax
                    ]);
                // sorts throughs from left to right in-place
                throughs.sort((a, b)=>a.xmin - b.xmin);
                const couples = $b173830a5f81c459$exports(throughs).map((couple)=>{
                    const [left, right] = couple;
                    return [
                        left.xmin,
                        right.xmax
                    ];
                });
                insides = insides.concat(couples);
                /*
          This makes sure we don't double count pixels.
          For example, converts `[[0,10],[10,10]]` to `[[0,10]]`
        */ insides = $780fd026c6616908$exports(insides);
                insides.forEach((pair)=>{
                    const [xmin, xmax] = pair;
                    if (xmax - xmin < half_pixel_width) return;
                    // snap [xmin, xmax] in srs to raster coordinates
                    const [left, right] = snap(pair);
                    // intersection doesn't take up more than half of a pixel
                    if (left === right) return;
                    // skip because segment is beyond the right edge of the raster
                    if (left > raster_width) return;
                    // skip because segment is beyond the left edge of the raster
                    if (right <= 0) return;
                    const start_column_index = Math.max(left, 0);
                    const end_column_index = Math.min(right - 1, raster_width - 1);
                    if (per_row_segment) per_row_segment({
                        row: row_index,
                        columns: [
                            start_column_index,
                            end_column_index
                        ]
                    });
                    if (per_pixel) for(let column_index = start_column_index; column_index <= end_column_index; column_index++)per_pixel({
                        row: row_index,
                        column: column_index
                    });
                });
            }
        });
    });
};


var $b5623d071bf607e3$exports = {};
$b5623d071bf607e3$exports = function checkRanges(rows) {
    rows.forEach((ranges, irow)=>{
        for(let irange = 0; irange < ranges.length; irange++){
            const range = ranges[irange];
            const [start, end] = range;
            if (start > end) console.warn("[dufour-peyton-intersection] uh oh, encountered invalid range", range, "at row index", irow, "with ranges", ranges);
            for(let iother = irange + 1; iother < ranges.length; iother++)if (iother[0] <= end) console.warn("[dufour-peyton-intersection] encountered range problem on row index", irow, ":", ranges);
        }
    });
};


var $c401bcbf25109d77$exports = {};
$c401bcbf25109d77$exports = function mergeConsecutiveRanges(ranges) {
    const numberOfRanges = ranges.length;
    if (numberOfRanges > 0) {
        const firstRange = ranges[0];
        let previousEnd = firstRange[1];
        const result = [
            firstRange
        ];
        for(let i = 1; i < numberOfRanges; i++){
            const tempRange = ranges[i];
            const [start, end] = tempRange;
            if (start <= previousEnd + 1) result[result.length - 1][1] = end;
            else result.push(tempRange);
            previousEnd = end;
        }
        return result;
    }
};


$32c3a9fd9de4c5bd$exports = function calculate({ debug: debug = false, raster_bbox: raster_bbox, raster_height: raster_height, raster_width: raster_width, pixel_height: pixel_height, pixel_width: pixel_width, geometry: geometry, per_pixel: per_pixel, per_row_segment: per_row_segment }) {
    const [xmin, ymin, xmax, ymax] = raster_bbox;
    if (pixel_height === undefined || pixel_height === null) pixel_height = (ymax - ymin) / raster_height;
    if (pixel_width === undefined || pixel_width === null) pixel_width = (xmax - xmin) / raster_width;
    const rows = new Array(raster_height);
    $ffd9bc8c5a4f659b$exports({
        raster_bbox: raster_bbox,
        raster_height: raster_height,
        raster_width: raster_width,
        pixel_height: pixel_height,
        pixel_width: pixel_width,
        geometry: geometry,
        per_pixel: per_pixel,
        per_row_segment: ({ row: row, columns: columns })=>{
            if (!rows[row]) rows[row] = [];
            rows[row].push(columns);
            if (per_row_segment) per_row_segment({
                row: row,
                columns: columns
            });
        }
    });
    for(let irow = 0; irow < rows.length; irow++){
        const ranges = rows[irow];
        if (ranges) {
            // sort from left to right
            ranges.sort((a, b)=>a === b ? a[1] - b[1] : a[0] - b[0]);
            // replace existing row with sorted and merged one
            rows[irow] = $c401bcbf25109d77$exports(ranges);
        }
    }
    if (debug) $b5623d071bf607e3$exports(insides);
    return {
        rows: rows
    };
};




var $d7ba91e889fb220b$exports = {};

$d7ba91e889fb220b$exports = function getBoundingBox(geometry) {
    let xmin, ymin, xmax, ymax;
    $90c16f9bdd20ab4d$exports(geometry, (polygon)=>{
        const ring = polygon[0]; // only want the exterior ring
        const imax = ring.length - 1;
        let i;
        if (xmin === undefined) {
            xmin = xmax = ring[0][0];
            ymin = ymax = ring[0][1];
            i = 1;
        } else i = 0;
        for(; i <= imax; i++){
            const [x, y] = ring[i];
            if (x < xmin) xmin = x;
            else if (x > xmax) xmax = x;
            if (y < ymin) ymin = y;
            else if (y > ymax) ymax = y;
        }
    });
    return [
        xmin,
        ymin,
        xmax,
        ymax
    ];
};











const $56439f984776a4a1$var$dufour_peyton_intersection = {
    calculate: $32c3a9fd9de4c5bd$exports,
    calculateCore: $ffd9bc8c5a4f659b$exports,
    categorizeIntersection: $816fb6790923d569$exports,
    clamp: $7509e3f10aa8a3d6$exports,
    cluster: $92a7e1323f066261$exports,
    clusterLineSegments: $53575899829bd2cd$exports,
    couple: $b173830a5f81c459$exports,
    eachEdge: $f2b46d82e720eb96$exports,
    getBoundingBox: $d7ba91e889fb220b$exports,
    getIntersectionOfTwoLines: $4ba49f7db7778a3c$exports,
    getLineFromPoints: $6d8cd8d0b5026707$exports,
    getPolygons: $5e52bca43aecc70f$exports,
    mergeRanges: $780fd026c6616908$exports,
    partition: $a35f30dbd8784172$exports,
    prepareSnap: $2a533358c791f5e8$exports,
    range: $c438c954a1277608$exports,
    roundDown: $d3e21fc96c65d0fc$exports
};
if (typeof define === "function" && define.amd) define(()=>$56439f984776a4a1$var$dufour_peyton_intersection);
$56439f984776a4a1$exports = $56439f984776a4a1$var$dufour_peyton_intersection;
if (typeof self == "object") self.dufour_peyton_intersection = $56439f984776a4a1$var$dufour_peyton_intersection;
if (typeof window == "object") window.dufour_peyton_intersection = $56439f984776a4a1$var$dufour_peyton_intersection;


var $3dc398bcd9931447$exports = {};
var $b6a7b313734f0dbf$exports = {};
var $a3030e81a67a6421$exports = {};
// convert exponential notation to normal string
// not optimized yet and no support for big numbers
$a3030e81a67a6421$exports = function expand(n) {
    // remove + from beginning
    if (n[0] === "+") n = n.substring(1);
    const sign = n[0] === "-" ? "-" : "";
    if (sign === "-") n = n.substring(1);
    const index_of_e = n.indexOf("e");
    // number not in exponential notation
    if (index_of_e === -1) return sign + n;
    let index_of_dot = n.indexOf(".");
    // if number doesn't include a period dot
    // then just assume it at the end
    // such that 3e4 has index of dot at 1
    if (index_of_dot === -1) index_of_dot = index_of_e;
    const shift = Number(n.substring(index_of_e + 1));
    // remove old decimal place
    const base = n.substring(0, index_of_e).replace(".", "");
    // normalize shift to start of the string at index zero
    const normshift = index_of_dot + shift;
    const baselen = base.length;
    if (normshift >= baselen) {
        const zct = normshift - baselen;
        let result1 = base;
        for(let i = 0; i < zct; i++)result1 += "0";
        return sign + result1;
    } else if (normshift < 0) {
        // need to add zeros in decimal places
        result = "0.";
        for(let i = 0; i > normshift; i--)result += "0";
        result += base;
        return sign + result;
    } else // shifting within the base
    return sign + base.substring(0, normshift) + "." + base.substring(normshift);
};


$b6a7b313734f0dbf$exports = function clean(n) {
    // remove + from beginning
    if (n[0] === "+") n = n.substring(1);
    n = $a3030e81a67a6421$exports(n);
    // remove extra zero in front
    // 03938.123 => 3938.123
    n = n.replace(/^0+(?=\d)/, "");
    // remove extra zero at end
    return n;
};


var $e6efb4235acdd452$exports = {};

// given:
//  - a and b are positive numbers
//  - a and b have been cleaned (i.e. no + or leading zeros)
$e6efb4235acdd452$exports = function compare_positive(a, b) {
    const alen = a.length;
    const blen = b.length;
    const aidx = a.indexOf(".");
    const bidx = b.indexOf(".");
    // basically where would the dot be
    // if we add a dot at the end of integers
    // like 123.
    const a_adjusted_dot_index = aidx === -1 ? alen : aidx;
    const b_adjusted_dot_index = bidx === -1 ? blen : bidx;
    // how much you need to shift the second number
    // to line up the decimal with the first
    //        0.12345
    //    12345.0
    const offset = a_adjusted_dot_index - b_adjusted_dot_index;
    let left = Math.max(a_adjusted_dot_index, b_adjusted_dot_index);
    let right = Math.max(alen - a_adjusted_dot_index, blen - b_adjusted_dot_index);
    let aoffset = offset < 0 ? -1 * offset : 0;
    let boffset = offset <= 0 ? 0 : offset;
    let imax = left + 1 + right - 1; // -1 for zero-index
    let i = 0;
    while(i < imax){
        const achar = a[i - aoffset] || "0";
        const bchar = b[i - boffset] || "0";
        if (achar !== bchar) {
            if (achar > bchar) return ">";
            else if (achar < bchar) return "<";
        }
        i++;
    }
    return "=";
};


var $021c5914313b59dd$exports = {};
// assumes both numbers are positive integers
$021c5914313b59dd$exports = function long_addition(a, b) {
    // assuming both positive for now
    const alen = a.length;
    const blen = b.length;
    const aidx = a.indexOf(".");
    const bidx = b.indexOf(".");
    // basically where would the dot be
    // if we add a dot at the end of integers
    // like 123.
    const a_adjusted_dot_index = aidx === -1 ? alen : aidx;
    const b_adjusted_dot_index = bidx === -1 ? blen : bidx;
    // how much you need to shift the second number
    // to line up the decimal with the first
    //        0.12345
    //    12345.0
    const offset = a_adjusted_dot_index - b_adjusted_dot_index;
    let left = Math.max(a_adjusted_dot_index, b_adjusted_dot_index);
    let right = Math.max(alen - a_adjusted_dot_index - 1, blen - b_adjusted_dot_index - 1);
    let aoffset = offset < 0 ? -1 * offset : 0;
    let boffset = offset <= 0 ? 0 : offset;
    let imax = left + 1 + right - 1; // -1 for zero-index
    let result = "";
    let carried = 0;
    // to the right of the period
    //        0.12345
    //    12345.0
    let i = imax;
    if (right > 0) {
        while(i > imax - right){
            const achar = a[i - aoffset] || "0";
            const bchar = b[i - boffset] || "0";
            let n = Number(achar) + Number(bchar) + carried;
            if (n >= 10) {
                n -= 10;
                carried = 1;
            } else carried = 0;
            if (result !== "" || n !== 0) result = n + result;
            i--;
        }
        if (result) result = "." + result;
        i--; // substract 1 for dot
    }
    if (left > 0) while(i >= 0){
        const achar = a[i - aoffset] || "0";
        const bchar = b[i - boffset] || "0";
        let n = Number(achar) + Number(bchar) + carried;
        if (n >= 10) {
            n -= 10;
            carried = 1;
        } else carried = 0;
        result = n + result;
        i--;
    }
    if (carried === 1) result = carried + result;
    return result;
};


var $23e71c951699382b$exports = {};
// const lookup = {};
// const vals = [undefined, 0, 1, 2, 3, 4, 5, 6, 8, 9];
// vals.forEach(top => {
//   lookup[top] = {};
//   vals.forEach(bottom => {
//     lookup[top][bottom] = (top || 0) - (bottom || 0);
//   })
// });
// assumes (1) both a and b are positive numbers
// and (2) a is larger than b
$23e71c951699382b$exports = function long_subtraction(a, b) {
    const alen = a.length;
    const blen = b.length;
    const aidx = a.indexOf(".");
    const bidx = b.indexOf(".");
    // basically where would the dot be
    // if we add a dot at the end of integers
    // like 123.
    const a_adjusted_dot_index = aidx === -1 ? alen : aidx;
    const b_adjusted_dot_index = bidx === -1 ? blen : bidx;
    // console.log({a_adjusted_dot_index, b_adjusted_dot_index});
    // how much you need to shift the second number
    // to line up the decimal with the first
    //        0.12345
    //    12345.0
    const offset = a_adjusted_dot_index - b_adjusted_dot_index;
    // console.log("offset:", offset);
    let left = Math.max(a_adjusted_dot_index, b_adjusted_dot_index);
    // console.log("left:", left);
    let right = Math.max(alen - a_adjusted_dot_index - 1, blen - b_adjusted_dot_index - 1);
    // console.log("right:", right);
    let aoffset = offset < 0 ? -1 * offset : 0;
    let boffset = offset <= 0 ? 0 : offset;
    // console.log({aoffset, boffset});
    let imax = left + 1 + right - 1; // -1 for zero-index
    // console.log({imax});
    let result = "";
    // number of borrowings
    let borrowed = 0;
    // to the right of the period
    //  100.5  6  7
    //    2.2  9  3
    //        (-3 + 10)  4
    let i = imax;
    if (right > 0) {
        while(i > imax - right){
            // console.log("\n\n", {i});
            let top = a[i - aoffset] || "0";
            let bottom = b[i - boffset] || "0";
            // console.log("pre borrowing", {top, bottom});
            top -= borrowed;
            borrowed = 0;
            // console.log("after borrowing", {top, bottom});
            let n = top - bottom;
            // console.log({n});
            if (n < 0) while(n < 0){
                borrowed++;
                n += 10;
            }
            else if (borrowed) borrowed--;
            // console.log({n});
            if (result !== "" || n !== 0) result = n + result;
            i--;
        }
        if (result !== "") result = "." + result;
        i--; // substract 1 for dot
    }
    // console.log({result});
    if (left > 0) {
        while(i > 0){
            // console.log("\n\n", {i});
            let top = a[i - aoffset] || "0";
            let bottom = b[i - boffset] || "0";
            // console.log("pre borrowing", {top, bottom});
            top -= borrowed;
            borrowed = 0;
            // console.log("after borrowing", {top, bottom});
            let n = top - bottom;
            // console.log({n});
            if (n < 0) while(n < 0){
                borrowed++;
                n += 10;
            }
            else if (borrowed) borrowed--;
            // console.log({n});
            result = n + result;
            i--;
        }
        // console.log({borrowed});
        // special rule for last one
        const achar = a[0 - aoffset] || "0";
        const bchar = b[0 - boffset] || "0";
        let n = Number(achar) - (borrowed > 0 ? 1 : 0) - Number(bchar);
        if (n !== 0) result = n + result;
        // remove any zeros in front like in 0123
        result = result.replace(/^0+/, "");
    }
    // if decimal number add zero
    if (result[0] === ".") result = "0" + result;
    return result;
};


$3dc398bcd9931447$exports = function subtract(a, b) {
    a = $b6a7b313734f0dbf$exports(a);
    b = $b6a7b313734f0dbf$exports(b);
    const a_is_positive = a[0] !== "-";
    const b_is_positive = b[0] !== "-";
    if (a_is_positive) {
        if (b_is_positive) {
            const comparison = $e6efb4235acdd452$exports(a, b);
            if (comparison === ">") return $23e71c951699382b$exports(a, b);
            else if (comparison === "<") return "-" + $23e71c951699382b$exports(b, a);
            else return "0";
        } else return $021c5914313b59dd$exports(a, b.substring(1));
    } else if (b_is_positive) return "-" + $021c5914313b59dd$exports(a.substring(1), b);
    else {
        a = a.substring(1);
        b = b.substring(1);
        const comparison = $e6efb4235acdd452$exports(a, b);
        if (comparison === ">") return "-" + $23e71c951699382b$exports(a, b);
        else if (comparison === "<") return $23e71c951699382b$exports(b, a);
        else return "0";
    }
};


var $96b5ba017ae46854$exports = {};
var $b63829404a114eb7$exports = {};

$b63829404a114eb7$exports = function absolute(n) {
    n = $b6a7b313734f0dbf$exports(n);
    if (n[0] === "-") return n.substring(1);
    else return n;
};



var $90fc83b0bfda74e8$exports = {};

var $15486944f4322e7e$exports = {};




$15486944f4322e7e$exports = function add(a, b) {
    a = $b6a7b313734f0dbf$exports(a);
    b = $b6a7b313734f0dbf$exports(b);
    const apos = a[0] !== "-";
    const bpos = b[0] !== "-";
    if (apos && bpos) return $021c5914313b59dd$exports(a, b);
    else if (!apos && !bpos) return "-" + $021c5914313b59dd$exports(a.substring(1), b.substring(1));
    else if (!apos && bpos) {
        a = a.substring(1);
        switch($e6efb4235acdd452$exports(a, b)){
            case "=":
                return "0";
            case "<":
                return $23e71c951699382b$exports(b, a);
            case ">":
                return "-" + $23e71c951699382b$exports(a, b);
        }
    } else if (apos && !bpos) {
        b = b.substring(1);
        switch($e6efb4235acdd452$exports(a, b)){
            case "=":
                return "0";
            case "<":
                return "-" + $23e71c951699382b$exports(b, a);
            case ">":
                return $23e71c951699382b$exports(a, b);
        }
    }
};


var $caa4ac1c160ff6e3$exports = {};



var $a2900f76ef7fd9eb$exports = {};
const $a2900f76ef7fd9eb$var$CHUNK_SIZE = 15;
/**
 *
 * @param {String} a - numerical string larger or equal to b
 * @param {String} b - numerical string smaller or equal to a
 * @returns {String} product - result of multiplying a with b
 */ $a2900f76ef7fd9eb$exports = function long_multiplication(a, b) {
    if (a === "0" || b === "0") return "0";
    const top_index_of_dot = a.indexOf(".");
    const bottom_index_of_dot = b.indexOf(".");
    const a_num_decimal_places = top_index_of_dot === -1 ? 0 : a.length - 1 - top_index_of_dot;
    const b_num_decimal_places = bottom_index_of_dot === -1 ? 0 : b.length - 1 - bottom_index_of_dot;
    const out_num_decimal_places = a_num_decimal_places + b_num_decimal_places;
    // remove decimals
    a = a.replace(".", "");
    b = b.replace(".", "");
    const alen = a.length;
    const blen = b.length;
    const chunks = [];
    let i = alen;
    while(i >= 0){
        const end = i;
        const start = i -= $a2900f76ef7fd9eb$var$CHUNK_SIZE;
        const str = a.substring(start, end);
        chunks.push([
            Number(str),
            str.length
        ]);
    }
    const partial_products = [];
    const partials = [];
    // for each number in multiplier
    for(let i = 0, ireverse = blen - 1; ireverse >= 0; ireverse--, i++){
        const bstr = b[ireverse];
        const bnum = Number(bstr);
        let carried = 0;
        let partial = "";
        const ichunklast = chunks.length - 1;
        chunks.forEach(([chunk, chunklen], c)=>{
            const subpartial = carried + bnum * chunk;
            let subpartstr = subpartial.toString();
            const subpartcharlen = subpartstr.length;
            if (subpartcharlen > chunklen && c !== ichunklast) {
                const islice = -1 * chunklen;
                partial = subpartstr.slice(islice) + partial;
                carried = Number(subpartstr.slice(0, islice));
            } else {
                const imax = chunklen - subpartcharlen;
                for(let i = 0; i < imax; i++)subpartstr = "0" + subpartstr;
                carried = 0;
                partial = subpartstr + partial;
            }
        });
        // add number of zeros at end
        partial += "0".repeat(i);
        partial_products.push(partial);
        partials.push([
            Array.from(partial).map((char)=>Number(char)),
            partial.length
        ]);
    }
    // back to front, iterate through columns
    // and add partial products together
    const num_partials = partial_products.length;
    const number_of_columns = partials[partials.length - 1][1] + num_partials;
    let result = "";
    let carried = 0;
    for(let icol = 0; icol < number_of_columns; icol++){
        let sum = carried;
        const pmax = Math.min(icol, num_partials - 1);
        for(let p = 0; p <= pmax; p++){
            const [pnums, plen] = partials[p];
            const i = plen - 1 - icol;
            if (i >= 0) sum += pnums[i];
        }
        if (sum >= 10) {
            sum = sum.toString();
            result = sum[sum.length - 1] + result;
            carried = Number(sum.slice(0, -1));
        } else {
            result = sum + result;
            carried = 0;
        }
    }
    // add decimal back in
    if (out_num_decimal_places === 0) // integer
    // remove extra zeros
    result = result.replace(/^0+/, "");
    else {
        // decimal number
        const idot = result.length - out_num_decimal_places;
        result = result.substring(0, idot) + "." + result.substring(idot);
        // remove zeros from front
        result = result.replace(/^0+/, "");
        // remove extra zeros from the end
        result = result.replace(/\.?0+$/, "");
        if (result[0] === ".") result = "0" + result;
    }
    return result;
};


$caa4ac1c160ff6e3$exports = function multiply(a, b) {
    a = $b6a7b313734f0dbf$exports(a);
    b = $b6a7b313734f0dbf$exports(b);
    const apos = a[0] !== "-";
    const bpos = b[0] !== "-";
    const out_sign = apos !== bpos ? "-" : "";
    a = $b63829404a114eb7$exports(a);
    b = $b63829404a114eb7$exports(b);
    const comparison = $e6efb4235acdd452$exports(a, b);
    if (comparison === "<") {
        const aold = a;
        const bold = b;
        a = bold;
        b = aold;
    }
    return out_sign + $a2900f76ef7fd9eb$exports(a, b);
};



var $8be75dfdd4e79a23$exports = {};
// given n is a decimal number
const $8be75dfdd4e79a23$var$up = [
    "5",
    "6",
    "7",
    "8",
    "9"
];
$8be75dfdd4e79a23$exports = function round_last_decimal(n) {
    // remove + from beginning
    if (n[0] === "+") n = n.substring(1);
    //console.log("rounding:", {n});
    const len = n.length;
    //console.log({len});
    let result = "";
    const last_char = n[n.length - 1];
    //console.log({last_char});
    if ($8be75dfdd4e79a23$var$up.includes(last_char)) {
        let i;
        for(i = len - 2; i >= 0; i--){
            const char = n[i];
            //console.log({char});
            // skip over . or -
            if (char === "." || char === "-") continue;
            const nchar = Number(char) + 1;
            //console.log({nchar});
            if (nchar === 10) result = "0" + result;
            else {
                result = nchar + result;
                break;
            }
        }
        //console.log({i});
        if (i > 0) result = n.substring(0, i) + result;
    } else result = n.substring(0, len - 1);
    if (result[result.length - 1] === ".") result = result.substring(0, result.length - 1);
    // remove trailing zeros in decimal number
    // 0.50 => 0.5
    if (result.indexOf(".") > -1) result = result.replace(/0+$/, "");
    return result;
};


// given dividend and divisor are positive numberical strings
$90fc83b0bfda74e8$exports = function long_division(dividend, divisor, { max_decimal_digits: max_decimal_digits = 100, ellipsis: ellipsis = false } = {}) {
    // remove unnecessary starting zeros
    // ex: 0.5 => .5
    if (dividend[0] === "0") dividend = dividend.substring(1);
    if (divisor[0] === "0") divisor = divisor.substring(1);
    const dividend_index_of_dot = dividend.indexOf(".");
    const divisor_index_of_dot = divisor.indexOf(".");
    const adjusted_dividend_index_of_dot = dividend_index_of_dot === -1 ? dividend.length : dividend_index_of_dot;
    const divisor_num_decimal_places = divisor_index_of_dot === -1 ? 0 : divisor.length - 1 - divisor_index_of_dot;
    // whether the result has a repeating decimal
    // e.g. 1/3 is repeating as in "0.333..."
    let repeating = false;
    // remove decimals
    dividend = dividend.replace(/\./, "");
    divisor = divisor.replace(/\./, "");
    const dividend_length = dividend.length;
    let current = "";
    let quotient = "";
    let comparison;
    let offset = -1 * divisor_num_decimal_places;
    let skip = 0;
    for(let i = 0; i < dividend_length; i++){
        const char = dividend[i];
        current += char;
        comparison = $e6efb4235acdd452$exports(current, divisor);
        if (comparison === ">") {
            // same as const times = Math.floor(current / divisor);
            // but without floating point problems
            let times = 1;
            let product = $15486944f4322e7e$exports(divisor, divisor);
            let passed_product = divisor;
            while($e6efb4235acdd452$exports(product, current) !== ">"){
                times++;
                passed_product = product;
                product = $15486944f4322e7e$exports(product, divisor);
            }
            times = times.toString();
            if (quotient !== "") for(let i = times.length; i <= skip; i++)quotient += "0";
            quotient += times; // string concatentation
            current = $3dc398bcd9931447$exports(current, passed_product);
            skip = 0;
        } else if (comparison === "<") {
            if (quotient === "") offset++;
            skip++;
            continue;
        } else if (comparison === "=") {
            if (quotient !== "") for(let i = 0; i < skip; i++)quotient += "0";
            quotient += "1";
            current = "0";
            skip = 0;
        }
    }
    if (current.match(/^0+$/g)) {
        if (comparison === "<") quotient += current.substring(0, current.length - 1);
    } else {
        const previous = {};
        // keep dividing until we have an answer
        // figure out current place of decimal number
        const idot = adjusted_dividend_index_of_dot - offset;
        const qlen = quotient.length;
        // add 1 extra for rounding purposes
        const imax = idot - qlen + max_decimal_digits + 1;
        // reset skip if just "" so far because don't want to count 0 in 0.
        if (quotient === "") skip = 0;
        for(let i = 0; i < imax; i++){
            current += "0";
            if (ellipsis) {
                if (current in previous) {
                    previous[current]++;
                    if (previous[current] > 3) {
                        quotient += "...";
                        repeating = true;
                        break;
                    }
                } else previous[current] = 1;
            }
            const comparison = $e6efb4235acdd452$exports(current, divisor);
            if (comparison === ">") {
                // inside greater than outside
                // how many times the divisor goes into the current
                let times = 1;
                let product = $15486944f4322e7e$exports(divisor, divisor);
                let passed_product = divisor;
                while($e6efb4235acdd452$exports(product, current) !== ">"){
                    times++;
                    passed_product = product;
                    product = $15486944f4322e7e$exports(product, divisor);
                }
                times = times.toString();
                // pad left zeros
                for(let i = times.length; i <= skip; i++)quotient += "0";
                quotient += times; // string concatentation
                current = $3dc398bcd9931447$exports(current, passed_product);
                if (current === "0") break;
                skip = 0;
            } else if (comparison === "<") {
                // outside greater than inside
                skip++;
                continue;
            } else if (comparison === "=") {
                // fill in previous with zeros
                for(let i = 0; i < skip; i++)quotient += "0";
                quotient += "1";
                skip = 0;
                break;
            }
        }
    }
    // reinsert decimal place
    const idot = adjusted_dividend_index_of_dot - offset;
    const qlen = quotient.length;
    let num_decimals;
    if (idot === qlen) // integer number so don't do anything
    num_decimals = 0;
    else if (idot < 0) {
        quotient = "0." + "0".repeat(Math.abs(idot)) + quotient;
        num_decimals = qlen - idot; // idot is negative, so adding
    } else if (idot > qlen) {
        // add more zeros to integer
        for(let i = qlen; i < idot; i++)quotient += "0";
        num_decimals = 0;
    } else if (idot < qlen) {
        quotient = quotient.substring(0, idot) + "." + quotient.substring(idot);
        num_decimals = qlen - idot;
    } else if (idot === 0) {
        quotient = "0." + quotient;
        num_decimals = qlen;
    }
    // remove zeros from front
    // 03938.123 => 3938.123
    quotient = quotient.replace(/^0+/, "");
    // remove extra zeros from the end
    quotient = quotient.replace(/\.\d+0+$/, "");
    // round if necessary
    if (!repeating) {
        const extra_decimals = num_decimals - max_decimal_digits;
        if (extra_decimals > 0) quotient = $8be75dfdd4e79a23$exports(quotient.substring(0, quotient.length - extra_decimals + 1));
    }
    if (quotient[0] === ".") quotient = "0" + quotient;
    return quotient;
};


$96b5ba017ae46854$exports = function(dividend, divisor, options) {
    dividend = $b6a7b313734f0dbf$exports(dividend);
    divisor = $b6a7b313734f0dbf$exports(divisor);
    const dividend_is_positive = dividend[0] !== "-";
    const divisor_is_positive = divisor[0] !== "-";
    const out_sign = dividend_is_positive !== divisor_is_positive ? "-" : "";
    if (!dividend_is_positive) dividend = $b63829404a114eb7$exports(dividend);
    if (!divisor_is_positive) divisor = $b63829404a114eb7$exports(divisor);
    return out_sign + $90fc83b0bfda74e8$exports(dividend, divisor, options);
};


var $08c71cdfa72ababb$exports = {};
const $08c71cdfa72ababb$var$clone = (data)=>JSON.parse(JSON.stringify(data));
function $08c71cdfa72ababb$var$reprojectGeoJSONPluggable(data, { in_place: in_place = false, reproject: reproject }) {
    if (typeof reproject !== "function") throw new Error(`[reproject-geojson] you must specify a reproject function`);
    if (in_place !== true) data = $08c71cdfa72ababb$var$clone(data);
    if (data.type === "FeatureCollection") data.features = data.features.map((feature)=>$08c71cdfa72ababb$var$reprojectGeoJSONPluggable(feature, {
            in_place: in_place,
            reproject: reproject
        }));
    else if (data.type === "Feature") data.geometry = $08c71cdfa72ababb$var$reprojectGeoJSONPluggable(data.geometry, {
        in_place: in_place,
        reproject: reproject
    });
    else if (data.type === "LineString") data.coordinates = data.coordinates.map((coord)=>reproject(coord));
    else if (data.type === "MultiLineString") data.coordinates = data.coordinates.map((line)=>line.map((coord)=>reproject(coord)));
    else if (data.type === "MultiPoint") data.coordinates = data.coordinates.map((point)=>reproject(point));
    else if (data.type === "MultiPolygon") data.coordinates = data.coordinates.map((polygon)=>{
        return polygon.map((ring)=>ring.map((coord)=>reproject(coord)));
    });
    else if (data.type === "Point") data.coordinates = reproject(data.coordinates);
    else if (data.type === "Polygon") data.coordinates = data.coordinates.map((ring)=>ring.map((coord)=>reproject(coord)));
    return data;
}
if (typeof define === "function" && define.amd) define(function() {
    return $08c71cdfa72ababb$var$reprojectGeoJSONPluggable;
});
$08c71cdfa72ababb$exports = $08c71cdfa72ababb$var$reprojectGeoJSONPluggable;
if (typeof window === "object") window.reprojectGeoJSONPluggable = $08c71cdfa72ababb$var$reprojectGeoJSONPluggable;
if (typeof self === "object") self.reprojectGeoJSONPluggable = $08c71cdfa72ababb$var$reprojectGeoJSONPluggable;


var $eb12fc4e796bef00$exports = {};
// [ [0, 11], [58, 59] ],
// [ [-1, 12], [57, 60] ] // subtract one from start and add one to end
// [ 0, -1, 12, 57, 60, 255 ] // flatten
// [ [0, -1], [12, 57], [60, 255] ] // pair
// [ [12, 57], [60, 255] ] // discard bad like [0, -1]
function $eb12fc4e796bef00$var$segflip({ segments: segs, min: min = -Infinity, max: max = Infinity, debug: debug = false }) {
    if (debug) console.log("[segflip] segs:", segs);
    if (segs === undefined || segs === null || Array.isArray(segs) && segs.length === 0) {
        if (debug) console.log("[segflip] segments are empty so return the whole row flipped");
        return [
            [
                min,
                max
            ]
        ];
    }
    const nums = segs.map(([start, end])=>[
            start - 1,
            end + 1
        ]).flat();
    nums.unshift(min);
    nums.push(max);
    if (debug) console.log("flattened nums:", nums);
    const results = [];
    for(let i = 1; i < nums.length; i += 2){
        const start = nums[i - 1];
        const end = nums[i];
        if (start > end) continue; // e.g. [0, -1]
        results.push([
            start,
            end
        ]);
    }
    return results;
}
if (typeof define === "function" && define.amd) define(function() {
    return $eb12fc4e796bef00$var$segflip;
});
$eb12fc4e796bef00$exports = $eb12fc4e796bef00$var$segflip;
if (typeof window === "object") window.segflip = $eb12fc4e796bef00$var$segflip;
if (typeof self === "object") self.segflip = $eb12fc4e796bef00$var$segflip;


function $821004e6d224a19e$var$checkRows({ rows: rows }) {
    rows.forEach((segs, irow)=>{
        if (segs) segs.forEach(([start, end], iseg)=>{
            if (start > end) throw Error(`uh oh: invalid segment at row ${irow}, segment ${iseg}`);
        });
    });
}
function $821004e6d224a19e$var$inside({ debug: debug = false, raster_bbox: raster_bbox, raster_height: raster_height, raster_width: raster_width, pixel_height: pixel_height, pixel_width: pixel_width, mask: mask, reproject: reproject }) {
    if (typeof reproject === "function") // reproject geometry to the srs of the raster
    mask = $08c71cdfa72ababb$exports(mask, {
        in_place: false,
        reproject: reproject
    });
    if (pixel_height === undefined) pixel_height = Number($96b5ba017ae46854$exports($3dc398bcd9931447$exports(raster_bbox[3].toString(), raster_bbox[1].toString()), raster_height.toString()));
    if (pixel_width === undefined) pixel_width = Number($96b5ba017ae46854$exports($3dc398bcd9931447$exports(raster_bbox[2].toString(), raster_bbox[0].toString()), raster_width.toString()));
    const { rows: rows } = $56439f984776a4a1$exports.calculate({
        raster_bbox: raster_bbox,
        raster_height: raster_height,
        raster_width: raster_width,
        pixel_height: pixel_height,
        pixel_width: pixel_width,
        geometry: mask
    });
    if (debug) $821004e6d224a19e$var$checkRows({
        rows: rows
    });
    return {
        rows: rows
    };
}
function $821004e6d224a19e$var$outside({ debug: debug = false, raster_bbox: raster_bbox, raster_height: raster_height, raster_width: raster_width, pixel_height: pixel_height, pixel_width: pixel_width, mask: mask, reproject: reproject }) {
    if (typeof reproject === "function") // reproject geometry to the srs of the raster
    mask = $08c71cdfa72ababb$exports(mask, {
        in_place: false,
        reproject: reproject
    });
    if (pixel_height === undefined) pixel_height = Number($96b5ba017ae46854$exports($3dc398bcd9931447$exports(raster_bbox[3].toString(), raster_bbox[1].toString()), raster_height.toString()));
    if (pixel_width === undefined) pixel_width = Number($96b5ba017ae46854$exports($3dc398bcd9931447$exports(raster_bbox[2].toString(), raster_bbox[0].toString()), raster_width.toString()));
    // calculate inside segments
    const { rows: insides } = $821004e6d224a19e$var$inside({
        debug: debug,
        raster_bbox: raster_bbox,
        raster_height: raster_height,
        raster_width: raster_width,
        pixel_height: pixel_height,
        pixel_width: pixel_width,
        mask: mask
    });
    if (debug) $821004e6d224a19e$var$checkRows({
        rows: insides
    });
    const last_column_index = raster_width - 1;
    // consider optimizing memory and speed
    // by just returning a reference to a whole row
    // instead of generating a new array every time
    // const whole_row = [0, last_column_index];
    const outsides = [];
    // using for loop instead of map because
    // map skips empty insides/rows
    for(let i = 0; i < insides.length; i++){
        const segs = insides[i];
        if (!Array.isArray(segs) || segs.length === 0) outsides.push([
            [
                0,
                last_column_index
            ]
        ]);
        else outsides.push($eb12fc4e796bef00$exports({
            segments: segs,
            min: 0,
            max: last_column_index,
            debug: false
        }));
    }
    if (debug) $821004e6d224a19e$var$checkRows({
        rows: outsides
    });
    return {
        rows: outsides
    };
}
const $821004e6d224a19e$var$geomask = {
    inside: $821004e6d224a19e$var$inside,
    outside: $821004e6d224a19e$var$outside
};
$821004e6d224a19e$exports = $821004e6d224a19e$var$geomask;


var $6b3689d852234853$exports = {};
var $7e38a554ccd68dd6$exports = {};
var $37e7d27a698002f1$exports = {};

$parcel$defineInteropFlag($37e7d27a698002f1$exports);

$parcel$export($37e7d27a698002f1$exports, "default", function () { return $37e7d27a698002f1$export$2e2bcd8739ae039; });
function $54518b00b2a9ea1f$export$2e2bcd8739ae039(defs) {
    defs("EPSG:4326", "+title=WGS 84 (long/lat) +proj=longlat +ellps=WGS84 +datum=WGS84 +units=degrees");
    defs("EPSG:4269", "+title=NAD83 (long/lat) +proj=longlat +a=6378137.0 +b=6356752.31414036 +ellps=GRS80 +datum=NAD83 +units=degrees");
    defs("EPSG:3857", "+title=WGS 84 / Pseudo-Mercator +proj=merc +a=6378137 +b=6378137 +lat_ts=0.0 +lon_0=0.0 +x_0=0.0 +y_0=0 +k=1.0 +units=m +nadgrids=@null +no_defs");
    // UTM WGS84
    for(var i = 1; i <= 60; ++i){
        defs("EPSG:" + (32600 + i), "+proj=utm +zone=" + i + " +datum=WGS84 +units=m");
        defs("EPSG:" + (32700 + i), "+proj=utm +zone=" + i + " +south +datum=WGS84 +units=m");
    }
    defs.WGS84 = defs["EPSG:4326"];
    defs["EPSG:3785"] = defs["EPSG:3857"]; // maintain backward compat, official code is 3857
    defs.GOOGLE = defs["EPSG:3857"];
    defs["EPSG:900913"] = defs["EPSG:3857"];
    defs["EPSG:102113"] = defs["EPSG:3857"];
}



var $jVGH7 = parcelRequire("jVGH7");
var $df88b5834907a45d$var$primeMeridian = {};
$df88b5834907a45d$var$primeMeridian.greenwich = 0.0; // "0dE",
$df88b5834907a45d$var$primeMeridian.lisbon = -9.131906111111; // "9d07'54.862\"W",
$df88b5834907a45d$var$primeMeridian.paris = 2.337229166667; // "2d20'14.025\"E",
$df88b5834907a45d$var$primeMeridian.bogota = -74.080916666667; // "74d04'51.3\"W",
$df88b5834907a45d$var$primeMeridian.madrid = -3.687938888889; // "3d41'16.58\"W",
$df88b5834907a45d$var$primeMeridian.rome = 12.452333333333; // "12d27'8.4\"E",
$df88b5834907a45d$var$primeMeridian.bern = 7.439583333333; // "7d26'22.5\"E",
$df88b5834907a45d$var$primeMeridian.jakarta = 106.807719444444; // "106d48'27.79\"E",
$df88b5834907a45d$var$primeMeridian.ferro = -17.666666666667; // "17d40'W",
$df88b5834907a45d$var$primeMeridian.brussels = 4.367975; // "4d22'4.71\"E",
$df88b5834907a45d$var$primeMeridian.stockholm = 18.058277777778; // "18d3'29.8\"E",
$df88b5834907a45d$var$primeMeridian.athens = 23.7163375; // "23d42'58.815\"E",
$df88b5834907a45d$var$primeMeridian.oslo = 10.722916666667; // "10d43'22.5\"E"
var $df88b5834907a45d$export$2e2bcd8739ae039 = $df88b5834907a45d$var$primeMeridian;


var $975c2956f79a842a$export$2e2bcd8739ae039 = {
    mm: {
        to_meter: 0.001
    },
    cm: {
        to_meter: 0.01
    },
    ft: {
        to_meter: 0.3048
    },
    "us-ft": {
        to_meter: 1200 / 3937
    },
    fath: {
        to_meter: 1.8288
    },
    kmi: {
        to_meter: 1852
    },
    "us-ch": {
        to_meter: 20.1168402336805
    },
    "us-mi": {
        to_meter: 1609.34721869444
    },
    km: {
        to_meter: 1000
    },
    "ind-ft": {
        to_meter: 0.30479841
    },
    "ind-yd": {
        to_meter: 0.91439523
    },
    mi: {
        to_meter: 1609.344
    },
    yd: {
        to_meter: 0.9144
    },
    ch: {
        to_meter: 20.1168
    },
    link: {
        to_meter: 0.201168
    },
    dm: {
        to_meter: 0.1
    },
    in: {
        to_meter: 0.0254
    },
    "ind-ch": {
        to_meter: 20.11669506
    },
    "us-in": {
        to_meter: 0.025400050800101
    },
    "us-yd": {
        to_meter: 0.914401828803658
    }
};


var $aca64ceea23ffc2c$var$ignoredChar = /[\s_\-\/\(\)]/g;
function $aca64ceea23ffc2c$export$2e2bcd8739ae039(obj, key) {
    if (obj[key]) return obj[key];
    var keys = Object.keys(obj);
    var lkey = key.toLowerCase().replace($aca64ceea23ffc2c$var$ignoredChar, "");
    var i = -1;
    var testkey, processedKey;
    while(++i < keys.length){
        testkey = keys[i];
        processedKey = testkey.toLowerCase().replace($aca64ceea23ffc2c$var$ignoredChar, "");
        if (processedKey === lkey) return obj[testkey];
    }
}


function $b7395216027058e0$export$2e2bcd8739ae039(defData) {
    /** @type {import('./defs').ProjectionDefinition} */ var self = {};
    var paramObj = defData.split("+").map(function(v) {
        return v.trim();
    }).filter(function(a) {
        return a;
    }).reduce(function(p, a) {
        /** @type {Array<?>} */ var split = a.split("=");
        split.push(true);
        p[split[0].toLowerCase()] = split[1];
        return p;
    }, {});
    var paramName, paramVal, paramOutname;
    var params = {
        proj: "projName",
        datum: "datumCode",
        rf: function(v) {
            self.rf = parseFloat(v);
        },
        lat_0: function(v) {
            self.lat0 = v * (0, $jVGH7.D2R);
        },
        lat_1: function(v) {
            self.lat1 = v * (0, $jVGH7.D2R);
        },
        lat_2: function(v) {
            self.lat2 = v * (0, $jVGH7.D2R);
        },
        lat_ts: function(v) {
            self.lat_ts = v * (0, $jVGH7.D2R);
        },
        lon_0: function(v) {
            self.long0 = v * (0, $jVGH7.D2R);
        },
        lon_1: function(v) {
            self.long1 = v * (0, $jVGH7.D2R);
        },
        lon_2: function(v) {
            self.long2 = v * (0, $jVGH7.D2R);
        },
        alpha: function(v) {
            self.alpha = parseFloat(v) * (0, $jVGH7.D2R);
        },
        gamma: function(v) {
            self.rectified_grid_angle = parseFloat(v) * (0, $jVGH7.D2R);
        },
        lonc: function(v) {
            self.longc = v * (0, $jVGH7.D2R);
        },
        x_0: function(v) {
            self.x0 = parseFloat(v);
        },
        y_0: function(v) {
            self.y0 = parseFloat(v);
        },
        k_0: function(v) {
            self.k0 = parseFloat(v);
        },
        k: function(v) {
            self.k0 = parseFloat(v);
        },
        a: function(v) {
            self.a = parseFloat(v);
        },
        b: function(v) {
            self.b = parseFloat(v);
        },
        r: function(v) {
            self.a = self.b = parseFloat(v);
        },
        r_a: function() {
            self.R_A = true;
        },
        zone: function(v) {
            self.zone = parseInt(v, 10);
        },
        south: function() {
            self.utmSouth = true;
        },
        towgs84: function(v) {
            self.datum_params = v.split(",").map(function(a) {
                return parseFloat(a);
            });
        },
        to_meter: function(v) {
            self.to_meter = parseFloat(v);
        },
        units: function(v) {
            self.units = v;
            var unit = (0, $aca64ceea23ffc2c$export$2e2bcd8739ae039)((0, $975c2956f79a842a$export$2e2bcd8739ae039), v);
            if (unit) self.to_meter = unit.to_meter;
        },
        from_greenwich: function(v) {
            self.from_greenwich = v * (0, $jVGH7.D2R);
        },
        pm: function(v) {
            var pm = (0, $aca64ceea23ffc2c$export$2e2bcd8739ae039)((0, $df88b5834907a45d$export$2e2bcd8739ae039), v);
            self.from_greenwich = (pm ? pm : parseFloat(v)) * (0, $jVGH7.D2R);
        },
        nadgrids: function(v) {
            if (v === "@null") self.datumCode = "none";
            else self.nadgrids = v;
        },
        axis: function(v) {
            var legalAxis = "ewnsud";
            if (v.length === 3 && legalAxis.indexOf(v.substr(0, 1)) !== -1 && legalAxis.indexOf(v.substr(1, 1)) !== -1 && legalAxis.indexOf(v.substr(2, 1)) !== -1) self.axis = v;
        },
        approx: function() {
            self.approx = true;
        }
    };
    for(paramName in paramObj){
        paramVal = paramObj[paramName];
        if (paramName in params) {
            paramOutname = params[paramName];
            if (typeof paramOutname === "function") paramOutname(paramVal);
            else self[paramOutname] = paramVal;
        } else self[paramName] = paramVal;
    }
    if (typeof self.datumCode === "string" && self.datumCode !== "WGS84") self.datumCode = self.datumCode.toLowerCase();
    return self;
}


class $05c453a3bc66d65b$var$PROJJSONBuilderBase {
    static getId(node) {
        const idNode = node.find((child)=>Array.isArray(child) && child[0] === "ID");
        if (idNode && idNode.length >= 3) return {
            authority: idNode[1],
            code: parseInt(idNode[2], 10)
        };
        return null;
    }
    static convertUnit(node, type = "unit") {
        if (!node || node.length < 3) return {
            type: type,
            name: "unknown",
            conversion_factor: null
        };
        const name = node[1];
        const conversionFactor = parseFloat(node[2]) || null;
        const idNode = node.find((child)=>Array.isArray(child) && child[0] === "ID");
        const id = idNode ? {
            authority: idNode[1],
            code: parseInt(idNode[2], 10)
        } : null;
        return {
            type: type,
            name: name,
            conversion_factor: conversionFactor,
            id: id
        };
    }
    static convertAxis(node) {
        const name = node[1] || "Unknown";
        // Determine the direction
        let direction;
        const abbreviationMatch = name.match(/^\((.)\)$/); // Match abbreviations like "(E)" or "(N)"
        if (abbreviationMatch) {
            // Use the abbreviation to determine the direction
            const abbreviation = abbreviationMatch[1].toUpperCase();
            if (abbreviation === "E") direction = "east";
            else if (abbreviation === "N") direction = "north";
            else if (abbreviation === "U") direction = "up";
            else throw new Error(`Unknown axis abbreviation: ${abbreviation}`);
        } else // Use the explicit direction provided in the AXIS node
        direction = node[2] ? node[2].toLowerCase() : "unknown";
        const orderNode = node.find((child)=>Array.isArray(child) && child[0] === "ORDER");
        const order = orderNode ? parseInt(orderNode[1], 10) : null;
        const unitNode = node.find((child)=>Array.isArray(child) && (child[0] === "LENGTHUNIT" || child[0] === "ANGLEUNIT" || child[0] === "SCALEUNIT"));
        const unit = this.convertUnit(unitNode);
        return {
            name: name,
            direction: direction,
            unit: unit,
            order: order
        };
    }
    static extractAxes(node) {
        return node.filter((child)=>Array.isArray(child) && child[0] === "AXIS").map((axis)=>this.convertAxis(axis)).sort((a, b)=>(a.order || 0) - (b.order || 0)); // Sort by the "order" property
    }
    static convert(node, result = {}) {
        switch(node[0]){
            case "PROJCRS":
                result.type = "ProjectedCRS";
                result.name = node[1];
                result.base_crs = node.find((child)=>Array.isArray(child) && child[0] === "BASEGEOGCRS") ? this.convert(node.find((child)=>Array.isArray(child) && child[0] === "BASEGEOGCRS")) : null;
                result.conversion = node.find((child)=>Array.isArray(child) && child[0] === "CONVERSION") ? this.convert(node.find((child)=>Array.isArray(child) && child[0] === "CONVERSION")) : null;
                const csNode = node.find((child)=>Array.isArray(child) && child[0] === "CS");
                if (csNode) result.coordinate_system = {
                    type: csNode[1],
                    axis: this.extractAxes(node)
                };
                const lengthUnitNode = node.find((child)=>Array.isArray(child) && child[0] === "LENGTHUNIT");
                if (lengthUnitNode) {
                    const unit = this.convertUnit(lengthUnitNode);
                    result.coordinate_system.unit = unit; // Add unit to coordinate_system
                }
                result.id = this.getId(node);
                break;
            case "BASEGEOGCRS":
            case "GEOGCRS":
                result.type = "GeographicCRS";
                result.name = node[1];
                // Handle DATUM or ENSEMBLE
                const datumOrEnsembleNode = node.find((child)=>Array.isArray(child) && (child[0] === "DATUM" || child[0] === "ENSEMBLE"));
                if (datumOrEnsembleNode) {
                    const datumOrEnsemble = this.convert(datumOrEnsembleNode);
                    if (datumOrEnsembleNode[0] === "ENSEMBLE") result.datum_ensemble = datumOrEnsemble;
                    else result.datum = datumOrEnsemble;
                    const primem = node.find((child)=>Array.isArray(child) && child[0] === "PRIMEM");
                    if (primem && primem[1] !== "Greenwich") datumOrEnsemble.prime_meridian = {
                        name: primem[1],
                        longitude: parseFloat(primem[2])
                    };
                }
                result.coordinate_system = {
                    type: "ellipsoidal",
                    axis: this.extractAxes(node)
                };
                result.id = this.getId(node);
                break;
            case "DATUM":
                result.type = "GeodeticReferenceFrame";
                result.name = node[1];
                result.ellipsoid = node.find((child)=>Array.isArray(child) && child[0] === "ELLIPSOID") ? this.convert(node.find((child)=>Array.isArray(child) && child[0] === "ELLIPSOID")) : null;
                break;
            case "ENSEMBLE":
                result.type = "DatumEnsemble";
                result.name = node[1];
                // Extract ensemble members
                result.members = node.filter((child)=>Array.isArray(child) && child[0] === "MEMBER").map((member)=>({
                        type: "DatumEnsembleMember",
                        name: member[1],
                        id: this.getId(member)
                    }));
                // Extract accuracy
                const accuracyNode = node.find((child)=>Array.isArray(child) && child[0] === "ENSEMBLEACCURACY");
                if (accuracyNode) result.accuracy = parseFloat(accuracyNode[1]);
                // Extract ellipsoid
                const ellipsoidNode = node.find((child)=>Array.isArray(child) && child[0] === "ELLIPSOID");
                if (ellipsoidNode) result.ellipsoid = this.convert(ellipsoidNode); // Convert the ellipsoid node
                // Extract identifier for the ensemble
                result.id = this.getId(node);
                break;
            case "ELLIPSOID":
                result.type = "Ellipsoid";
                result.name = node[1];
                result.semi_major_axis = parseFloat(node[2]);
                result.inverse_flattening = parseFloat(node[3]);
                const units = node.find((child)=>Array.isArray(child) && child[0] === "LENGTHUNIT") ? this.convert(node.find((child)=>Array.isArray(child) && child[0] === "LENGTHUNIT"), result) : null;
                break;
            case "CONVERSION":
                result.type = "Conversion";
                result.name = node[1];
                result.method = node.find((child)=>Array.isArray(child) && child[0] === "METHOD") ? this.convert(node.find((child)=>Array.isArray(child) && child[0] === "METHOD")) : null;
                result.parameters = node.filter((child)=>Array.isArray(child) && child[0] === "PARAMETER").map((param)=>this.convert(param));
                break;
            case "METHOD":
                result.type = "Method";
                result.name = node[1];
                result.id = this.getId(node);
                break;
            case "PARAMETER":
                result.type = "Parameter";
                result.name = node[1];
                result.value = parseFloat(node[2]);
                result.unit = this.convertUnit(node.find((child)=>Array.isArray(child) && (child[0] === "LENGTHUNIT" || child[0] === "ANGLEUNIT" || child[0] === "SCALEUNIT")));
                result.id = this.getId(node);
                break;
            case "BOUNDCRS":
                result.type = "BoundCRS";
                // Process SOURCECRS
                const sourceCrsNode = node.find((child)=>Array.isArray(child) && child[0] === "SOURCECRS");
                if (sourceCrsNode) {
                    const sourceCrsContent = sourceCrsNode.find((child)=>Array.isArray(child));
                    result.source_crs = sourceCrsContent ? this.convert(sourceCrsContent) : null;
                }
                // Process TARGETCRS
                const targetCrsNode = node.find((child)=>Array.isArray(child) && child[0] === "TARGETCRS");
                if (targetCrsNode) {
                    const targetCrsContent = targetCrsNode.find((child)=>Array.isArray(child));
                    result.target_crs = targetCrsContent ? this.convert(targetCrsContent) : null;
                }
                // Process ABRIDGEDTRANSFORMATION
                const transformationNode = node.find((child)=>Array.isArray(child) && child[0] === "ABRIDGEDTRANSFORMATION");
                if (transformationNode) result.transformation = this.convert(transformationNode);
                else result.transformation = null;
                break;
            case "ABRIDGEDTRANSFORMATION":
                result.type = "Transformation";
                result.name = node[1];
                result.method = node.find((child)=>Array.isArray(child) && child[0] === "METHOD") ? this.convert(node.find((child)=>Array.isArray(child) && child[0] === "METHOD")) : null;
                result.parameters = node.filter((child)=>Array.isArray(child) && (child[0] === "PARAMETER" || child[0] === "PARAMETERFILE")).map((param)=>{
                    if (param[0] === "PARAMETER") return this.convert(param);
                    else if (param[0] === "PARAMETERFILE") return {
                        name: param[1],
                        value: param[2],
                        id: {
                            "authority": "EPSG",
                            "code": 8656
                        }
                    };
                });
                // Adjust the Scale difference parameter if present
                if (result.parameters.length === 7) {
                    const scaleDifference = result.parameters[6];
                    if (scaleDifference.name === "Scale difference") scaleDifference.value = Math.round((scaleDifference.value - 1) * 1e12) / 1e6;
                }
                result.id = this.getId(node);
                break;
            case "AXIS":
                if (!result.coordinate_system) result.coordinate_system = {
                    type: "unspecified",
                    axis: []
                };
                result.coordinate_system.axis.push(this.convertAxis(node));
                break;
            case "LENGTHUNIT":
                const unit = this.convertUnit(node, "LinearUnit");
                if (result.coordinate_system && result.coordinate_system.axis) result.coordinate_system.axis.forEach((axis)=>{
                    if (!axis.unit) axis.unit = unit;
                });
                if (unit.conversion_factor && unit.conversion_factor !== 1) {
                    if (result.semi_major_axis) result.semi_major_axis = {
                        value: result.semi_major_axis,
                        unit: unit
                    };
                }
                break;
            default:
                result.keyword = node[0];
                break;
        }
        return result;
    }
}
var $05c453a3bc66d65b$export$2e2bcd8739ae039 = $05c453a3bc66d65b$var$PROJJSONBuilderBase;


class $d3fce1d0c14ee1c8$var$PROJJSONBuilder2015 extends (0, $05c453a3bc66d65b$export$2e2bcd8739ae039) {
    static convert(node, result = {}) {
        super.convert(node, result);
        // Skip `CS` and `USAGE` nodes for WKT2-2015
        if (result.coordinate_system && result.coordinate_system.subtype === "Cartesian") delete result.coordinate_system;
        if (result.usage) delete result.usage;
        return result;
    }
}
var $d3fce1d0c14ee1c8$export$2e2bcd8739ae039 = $d3fce1d0c14ee1c8$var$PROJJSONBuilder2015;



class $8835e155f9e2bc26$var$PROJJSONBuilder2019 extends (0, $05c453a3bc66d65b$export$2e2bcd8739ae039) {
    static convert(node, result = {}) {
        super.convert(node, result);
        // Handle `CS` node for WKT2-2019
        const csNode = node.find((child)=>Array.isArray(child) && child[0] === "CS");
        if (csNode) result.coordinate_system = {
            subtype: csNode[1],
            axis: this.extractAxes(node)
        };
        // Handle `USAGE` node for WKT2-2019
        const usageNode = node.find((child)=>Array.isArray(child) && child[0] === "USAGE");
        if (usageNode) {
            const scope = usageNode.find((child)=>Array.isArray(child) && child[0] === "SCOPE");
            const area = usageNode.find((child)=>Array.isArray(child) && child[0] === "AREA");
            const bbox = usageNode.find((child)=>Array.isArray(child) && child[0] === "BBOX");
            result.usage = {};
            if (scope) result.usage.scope = scope[1];
            if (area) result.usage.area = area[1];
            if (bbox) result.usage.bbox = bbox.slice(1);
        }
        return result;
    }
}
var $8835e155f9e2bc26$export$2e2bcd8739ae039 = $8835e155f9e2bc26$var$PROJJSONBuilder2019;


/**
 * Detects the WKT2 version based on the structure of the WKT.
 * @param {Array} root The root WKT array node.
 * @returns {string} The detected version ("2015" or "2019").
 */ function $2a8b41914fd2c2c0$var$detectWKT2Version(root) {
    // Check for WKT2-2019-specific nodes
    if (root.find((child)=>Array.isArray(child) && child[0] === "USAGE")) return "2019"; // `USAGE` is specific to WKT2-2019
    // Check for WKT2-2015-specific nodes
    if (root.find((child)=>Array.isArray(child) && child[0] === "CS")) return "2015"; // `CS` is valid in both, but default to 2015 unless `USAGE` is present
    if (root[0] === "BOUNDCRS" || root[0] === "PROJCRS" || root[0] === "GEOGCRS") return "2015"; // These are valid in both, but default to 2015
    // Default to WKT2-2015 if no specific indicators are found
    return "2015";
}
function $2a8b41914fd2c2c0$export$48d0005f67ba915(root) {
    const version = $2a8b41914fd2c2c0$var$detectWKT2Version(root);
    const builder = version === "2019" ? (0, $8835e155f9e2bc26$export$2e2bcd8739ae039) : (0, $d3fce1d0c14ee1c8$export$2e2bcd8739ae039);
    return builder.convert(root);
}


/**
 * Detects whether the WKT string is WKT1 or WKT2.
 * @param {string} wkt The WKT string.
 * @returns {string} The detected version ("WKT1" or "WKT2").
 */ function $65a5e945f2b13908$export$9362d65e4771b5d5(wkt) {
    // Normalize the WKT string for easier keyword matching
    const normalizedWKT = wkt.toUpperCase();
    // Check for WKT2-specific keywords
    if (normalizedWKT.includes("PROJCRS") || normalizedWKT.includes("GEOGCRS") || normalizedWKT.includes("BOUNDCRS") || normalizedWKT.includes("VERTCRS") || normalizedWKT.includes("LENGTHUNIT") || normalizedWKT.includes("ANGLEUNIT") || normalizedWKT.includes("SCALEUNIT")) return "WKT2";
    // Check for WKT1-specific keywords
    if (normalizedWKT.includes("PROJCS") || normalizedWKT.includes("GEOGCS") || normalizedWKT.includes("LOCAL_CS") || normalizedWKT.includes("VERT_CS") || normalizedWKT.includes("UNIT")) return "WKT1";
    // Default to WKT1 if no specific indicators are found
    return "WKT1";
}


var $1cac0ee42dae5591$export$2e2bcd8739ae039 = $1cac0ee42dae5591$var$parseString;
var $1cac0ee42dae5591$var$NEUTRAL = 1;
var $1cac0ee42dae5591$var$KEYWORD = 2;
var $1cac0ee42dae5591$var$NUMBER = 3;
var $1cac0ee42dae5591$var$QUOTED = 4;
var $1cac0ee42dae5591$var$AFTERQUOTE = 5;
var $1cac0ee42dae5591$var$ENDED = -1;
var $1cac0ee42dae5591$var$whitespace = /\s/;
var $1cac0ee42dae5591$var$latin = /[A-Za-z]/;
var $1cac0ee42dae5591$var$keyword = /[A-Za-z84_]/;
var $1cac0ee42dae5591$var$endThings = /[,\]]/;
var $1cac0ee42dae5591$var$digets = /[\d\.E\-\+]/;
// const ignoredChar = /[\s_\-\/\(\)]/g;
function $1cac0ee42dae5591$var$Parser(text) {
    if (typeof text !== "string") throw new Error("not a string");
    this.text = text.trim();
    this.level = 0;
    this.place = 0;
    this.root = null;
    this.stack = [];
    this.currentObject = null;
    this.state = $1cac0ee42dae5591$var$NEUTRAL;
}
$1cac0ee42dae5591$var$Parser.prototype.readCharicter = function() {
    var char = this.text[this.place++];
    if (this.state !== $1cac0ee42dae5591$var$QUOTED) while($1cac0ee42dae5591$var$whitespace.test(char)){
        if (this.place >= this.text.length) return;
        char = this.text[this.place++];
    }
    switch(this.state){
        case $1cac0ee42dae5591$var$NEUTRAL:
            return this.neutral(char);
        case $1cac0ee42dae5591$var$KEYWORD:
            return this.keyword(char);
        case $1cac0ee42dae5591$var$QUOTED:
            return this.quoted(char);
        case $1cac0ee42dae5591$var$AFTERQUOTE:
            return this.afterquote(char);
        case $1cac0ee42dae5591$var$NUMBER:
            return this.number(char);
        case $1cac0ee42dae5591$var$ENDED:
            return;
    }
};
$1cac0ee42dae5591$var$Parser.prototype.afterquote = function(char) {
    if (char === '"') {
        this.word += '"';
        this.state = $1cac0ee42dae5591$var$QUOTED;
        return;
    }
    if ($1cac0ee42dae5591$var$endThings.test(char)) {
        this.word = this.word.trim();
        this.afterItem(char);
        return;
    }
    throw new Error("havn't handled \"" + char + '" in afterquote yet, index ' + this.place);
};
$1cac0ee42dae5591$var$Parser.prototype.afterItem = function(char) {
    if (char === ",") {
        if (this.word !== null) this.currentObject.push(this.word);
        this.word = null;
        this.state = $1cac0ee42dae5591$var$NEUTRAL;
        return;
    }
    if (char === "]") {
        this.level--;
        if (this.word !== null) {
            this.currentObject.push(this.word);
            this.word = null;
        }
        this.state = $1cac0ee42dae5591$var$NEUTRAL;
        this.currentObject = this.stack.pop();
        if (!this.currentObject) this.state = $1cac0ee42dae5591$var$ENDED;
        return;
    }
};
$1cac0ee42dae5591$var$Parser.prototype.number = function(char) {
    if ($1cac0ee42dae5591$var$digets.test(char)) {
        this.word += char;
        return;
    }
    if ($1cac0ee42dae5591$var$endThings.test(char)) {
        this.word = parseFloat(this.word);
        this.afterItem(char);
        return;
    }
    throw new Error("havn't handled \"" + char + '" in number yet, index ' + this.place);
};
$1cac0ee42dae5591$var$Parser.prototype.quoted = function(char) {
    if (char === '"') {
        this.state = $1cac0ee42dae5591$var$AFTERQUOTE;
        return;
    }
    this.word += char;
    return;
};
$1cac0ee42dae5591$var$Parser.prototype.keyword = function(char) {
    if ($1cac0ee42dae5591$var$keyword.test(char)) {
        this.word += char;
        return;
    }
    if (char === "[") {
        var newObjects = [];
        newObjects.push(this.word);
        this.level++;
        if (this.root === null) this.root = newObjects;
        else this.currentObject.push(newObjects);
        this.stack.push(this.currentObject);
        this.currentObject = newObjects;
        this.state = $1cac0ee42dae5591$var$NEUTRAL;
        return;
    }
    if ($1cac0ee42dae5591$var$endThings.test(char)) {
        this.afterItem(char);
        return;
    }
    throw new Error("havn't handled \"" + char + '" in keyword yet, index ' + this.place);
};
$1cac0ee42dae5591$var$Parser.prototype.neutral = function(char) {
    if ($1cac0ee42dae5591$var$latin.test(char)) {
        this.word = char;
        this.state = $1cac0ee42dae5591$var$KEYWORD;
        return;
    }
    if (char === '"') {
        this.word = "";
        this.state = $1cac0ee42dae5591$var$QUOTED;
        return;
    }
    if ($1cac0ee42dae5591$var$digets.test(char)) {
        this.word = char;
        this.state = $1cac0ee42dae5591$var$NUMBER;
        return;
    }
    if ($1cac0ee42dae5591$var$endThings.test(char)) {
        this.afterItem(char);
        return;
    }
    throw new Error("havn't handled \"" + char + '" in neutral yet, index ' + this.place);
};
$1cac0ee42dae5591$var$Parser.prototype.output = function() {
    while(this.place < this.text.length)this.readCharicter();
    if (this.state === $1cac0ee42dae5591$var$ENDED) return this.root;
    throw new Error('unable to parse string "' + this.text + '". State is ' + this.state);
};
function $1cac0ee42dae5591$var$parseString(txt) {
    var parser = new $1cac0ee42dae5591$var$Parser(txt);
    return parser.output();
}


function $c0fbfe8b16e62850$var$mapit(obj, key, value) {
    if (Array.isArray(key)) {
        value.unshift(key);
        key = null;
    }
    var thing = key ? {} : obj;
    var out = value.reduce(function(newObj, item) {
        $c0fbfe8b16e62850$export$337bc7a3aef1f775(item, newObj);
        return newObj;
    }, thing);
    if (key) obj[key] = out;
}
function $c0fbfe8b16e62850$export$337bc7a3aef1f775(v, obj) {
    if (!Array.isArray(v)) {
        obj[v] = true;
        return;
    }
    var key = v.shift();
    if (key === "PARAMETER") key = v.shift();
    if (v.length === 1) {
        if (Array.isArray(v[0])) {
            obj[key] = {};
            $c0fbfe8b16e62850$export$337bc7a3aef1f775(v[0], obj[key]);
            return;
        }
        obj[key] = v[0];
        return;
    }
    if (!v.length) {
        obj[key] = true;
        return;
    }
    if (key === "TOWGS84") {
        obj[key] = v;
        return;
    }
    if (key === "AXIS") {
        if (!(key in obj)) obj[key] = [];
        obj[key].push(v);
        return;
    }
    if (!Array.isArray(key)) obj[key] = {};
    var i;
    switch(key){
        case "UNIT":
        case "PRIMEM":
        case "VERT_DATUM":
            obj[key] = {
                name: v[0].toLowerCase(),
                convert: v[1]
            };
            if (v.length === 3) $c0fbfe8b16e62850$export$337bc7a3aef1f775(v[2], obj[key]);
            return;
        case "SPHEROID":
        case "ELLIPSOID":
            obj[key] = {
                name: v[0],
                a: v[1],
                rf: v[2]
            };
            if (v.length === 4) $c0fbfe8b16e62850$export$337bc7a3aef1f775(v[3], obj[key]);
            return;
        case "EDATUM":
        case "ENGINEERINGDATUM":
        case "LOCAL_DATUM":
        case "DATUM":
        case "VERT_CS":
        case "VERTCRS":
        case "VERTICALCRS":
            v[0] = [
                "name",
                v[0]
            ];
            $c0fbfe8b16e62850$var$mapit(obj, key, v);
            return;
        case "COMPD_CS":
        case "COMPOUNDCRS":
        case "FITTED_CS":
        // the followings are the crs defined in
        // https://github.com/proj4js/proj4js/blob/1da4ed0b865d0fcb51c136090569210cdcc9019e/lib/parseCode.js#L11
        case "PROJECTEDCRS":
        case "PROJCRS":
        case "GEOGCS":
        case "GEOCCS":
        case "PROJCS":
        case "LOCAL_CS":
        case "GEODCRS":
        case "GEODETICCRS":
        case "GEODETICDATUM":
        case "ENGCRS":
        case "ENGINEERINGCRS":
            v[0] = [
                "name",
                v[0]
            ];
            $c0fbfe8b16e62850$var$mapit(obj, key, v);
            obj[key].type = key;
            return;
        default:
            i = -1;
            while(++i < v.length){
                if (!Array.isArray(v[i])) return $c0fbfe8b16e62850$export$337bc7a3aef1f775(v, obj[key]);
            }
            return $c0fbfe8b16e62850$var$mapit(obj, key, v);
    }
}


var $f1bd4f262dc935a3$var$D2R = 0.01745329251994329577;
function $f1bd4f262dc935a3$export$e726aea149b4fd71(input) {
    return input * $f1bd4f262dc935a3$var$D2R;
}
function $f1bd4f262dc935a3$export$d6def86a6ec68808(wkt) {
    // Normalize projName for WKT2 compatibility
    const normalizedProjName = (wkt.projName || "").toLowerCase().replace(/_/g, " ");
    if (!wkt.long0 && wkt.longc && (normalizedProjName === "albers conic equal area" || normalizedProjName === "lambert azimuthal equal area")) wkt.long0 = wkt.longc;
    if (!wkt.lat_ts && wkt.lat1 && (normalizedProjName === "stereographic south pole" || normalizedProjName === "polar stereographic (variant b)")) {
        wkt.lat0 = $f1bd4f262dc935a3$export$e726aea149b4fd71(wkt.lat1 > 0 ? 90 : -90);
        wkt.lat_ts = wkt.lat1;
        delete wkt.lat1;
    } else if (!wkt.lat_ts && wkt.lat0 && (normalizedProjName === "polar stereographic" || normalizedProjName === "polar stereographic (variant a)")) {
        wkt.lat_ts = wkt.lat0;
        wkt.lat0 = $f1bd4f262dc935a3$export$e726aea149b4fd71(wkt.lat0 > 0 ? 90 : -90);
        delete wkt.lat1;
    }
}


// Helper function to process units and to_meter
function $6053abe52113fcc2$var$processUnit(unit) {
    let result = {
        units: null,
        to_meter: undefined
    };
    if (typeof unit === "string") {
        result.units = unit.toLowerCase();
        if (result.units === "metre") result.units = "meter"; // Normalize 'metre' to 'meter'
        if (result.units === "meter") result.to_meter = 1; // Only set to_meter if units are 'meter'
    } else if (unit && unit.name) {
        result.units = unit.name.toLowerCase();
        if (result.units === "metre") result.units = "meter"; // Normalize 'metre' to 'meter'
        result.to_meter = unit.conversion_factor;
    }
    return result;
}
function $6053abe52113fcc2$var$toValue(valueOrObject) {
    if (typeof valueOrObject === "object") return valueOrObject.value * valueOrObject.unit.conversion_factor;
    return valueOrObject;
}
function $6053abe52113fcc2$var$calculateEllipsoid(value, result) {
    if (value.ellipsoid.radius) {
        result.a = value.ellipsoid.radius;
        result.rf = 0;
    } else {
        result.a = $6053abe52113fcc2$var$toValue(value.ellipsoid.semi_major_axis);
        if (value.ellipsoid.inverse_flattening !== undefined) result.rf = value.ellipsoid.inverse_flattening;
        else if (value.ellipsoid.semi_major_axis !== undefined && value.ellipsoid.semi_minor_axis !== undefined) result.rf = result.a / (result.a - $6053abe52113fcc2$var$toValue(value.ellipsoid.semi_minor_axis));
    }
}
function $6053abe52113fcc2$export$b04e619e90585ec3(projjson, result = {}) {
    if (!projjson || typeof projjson !== "object") return projjson; // Return primitive values as-is
    if (projjson.type === "BoundCRS") {
        $6053abe52113fcc2$export$b04e619e90585ec3(projjson.source_crs, result);
        if (projjson.transformation) {
            if (projjson.transformation.method && projjson.transformation.method.name === "NTv2") // Set nadgrids to the filename from the parameterfile
            result.nadgrids = projjson.transformation.parameters[0].value;
            else // Populate datum_params if no parameterfile is found
            result.datum_params = projjson.transformation.parameters.map((param)=>param.value);
        }
        return result; // Return early for BoundCRS
    }
    // Handle specific keys in PROJJSON
    Object.keys(projjson).forEach((key)=>{
        const value = projjson[key];
        if (value === null) return;
        switch(key){
            case "name":
                if (result.srsCode) break;
                result.name = value;
                result.srsCode = value; // Map `name` to `srsCode`
                break;
            case "type":
                if (value === "GeographicCRS") result.projName = "longlat";
                else if (value === "ProjectedCRS" && projjson.conversion && projjson.conversion.method) result.projName = projjson.conversion.method.name; // Retain original capitalization
                break;
            case "datum":
            case "datum_ensemble":
                if (value.ellipsoid) {
                    // Extract ellipsoid properties
                    result.ellps = value.ellipsoid.name;
                    $6053abe52113fcc2$var$calculateEllipsoid(value, result);
                }
                if (value.prime_meridian) result.from_greenwich = value.prime_meridian.longitude * Math.PI / 180; // Convert to radians
                break;
            case "ellipsoid":
                result.ellps = value.name;
                $6053abe52113fcc2$var$calculateEllipsoid(value, result);
                break;
            case "prime_meridian":
                result.long0 = (value.longitude || 0) * Math.PI / 180; // Convert to radians
                break;
            case "coordinate_system":
                if (value.axis) {
                    result.axis = value.axis.map((axis)=>{
                        const direction = axis.direction;
                        if (direction === "east") return "e";
                        if (direction === "north") return "n";
                        if (direction === "west") return "w";
                        if (direction === "south") return "s";
                        throw new Error(`Unknown axis direction: ${direction}`);
                    }).join("") + "u"; // Combine into a single string (e.g., "enu")
                    if (value.unit) {
                        const { units: units, to_meter: to_meter } = $6053abe52113fcc2$var$processUnit(value.unit);
                        result.units = units;
                        result.to_meter = to_meter;
                    } else if (value.axis[0] && value.axis[0].unit) {
                        const { units: units, to_meter: to_meter } = $6053abe52113fcc2$var$processUnit(value.axis[0].unit);
                        result.units = units;
                        result.to_meter = to_meter;
                    }
                }
                break;
            case "id":
                if (value.authority && value.code) result.title = value.authority + ":" + value.code;
                break;
            case "conversion":
                if (value.method && value.method.name) result.projName = value.method.name; // Retain original capitalization
                if (value.parameters) value.parameters.forEach((param)=>{
                    const paramName = param.name.toLowerCase().replace(/\s+/g, "_");
                    const paramValue = param.value;
                    if (param.unit && param.unit.conversion_factor) result[paramName] = paramValue * param.unit.conversion_factor; // Convert to radians or meters
                    else if (param.unit === "degree") result[paramName] = paramValue * Math.PI / 180; // Convert to radians
                    else result[paramName] = paramValue;
                });
                break;
            case "unit":
                if (value.name) {
                    result.units = value.name.toLowerCase();
                    if (result.units === "metre") result.units = "meter";
                }
                if (value.conversion_factor) result.to_meter = value.conversion_factor;
                break;
            case "base_crs":
                $6053abe52113fcc2$export$b04e619e90585ec3(value, result); // Pass `result` directly
                result.datumCode = value.id ? value.id.authority + "_" + value.id.code : value.name; // Set datumCode
                break;
            default:
                break;
        }
    });
    // Additional calculated properties
    if (result.latitude_of_false_origin !== undefined) result.lat0 = result.latitude_of_false_origin; // Already in radians
    if (result.longitude_of_false_origin !== undefined) result.long0 = result.longitude_of_false_origin;
    if (result.latitude_of_standard_parallel !== undefined) {
        result.lat0 = result.latitude_of_standard_parallel;
        result.lat1 = result.latitude_of_standard_parallel;
    }
    if (result.latitude_of_1st_standard_parallel !== undefined) result.lat1 = result.latitude_of_1st_standard_parallel;
    if (result.latitude_of_2nd_standard_parallel !== undefined) result.lat2 = result.latitude_of_2nd_standard_parallel;
    if (result.latitude_of_projection_centre !== undefined) result.lat0 = result.latitude_of_projection_centre;
    if (result.longitude_of_projection_centre !== undefined) result.longc = result.longitude_of_projection_centre;
    if (result.easting_at_false_origin !== undefined) result.x0 = result.easting_at_false_origin;
    if (result.northing_at_false_origin !== undefined) result.y0 = result.northing_at_false_origin;
    if (result.latitude_of_natural_origin !== undefined) result.lat0 = result.latitude_of_natural_origin;
    if (result.longitude_of_natural_origin !== undefined) result.long0 = result.longitude_of_natural_origin;
    if (result.longitude_of_origin !== undefined) result.long0 = result.longitude_of_origin;
    if (result.false_easting !== undefined) result.x0 = result.false_easting;
    if (result.easting_at_projection_centre) result.x0 = result.easting_at_projection_centre;
    if (result.false_northing !== undefined) result.y0 = result.false_northing;
    if (result.northing_at_projection_centre) result.y0 = result.northing_at_projection_centre;
    if (result.standard_parallel_1 !== undefined) result.lat1 = result.standard_parallel_1;
    if (result.standard_parallel_2 !== undefined) result.lat2 = result.standard_parallel_2;
    if (result.scale_factor_at_natural_origin !== undefined) result.k0 = result.scale_factor_at_natural_origin;
    if (result.scale_factor_at_projection_centre !== undefined) result.k0 = result.scale_factor_at_projection_centre;
    if (result.scale_factor_on_pseudo_standard_parallel !== undefined) result.k0 = result.scale_factor_on_pseudo_standard_parallel;
    if (result.azimuth !== undefined) result.alpha = result.azimuth;
    if (result.azimuth_at_projection_centre !== undefined) result.alpha = result.azimuth_at_projection_centre;
    if (result.angle_from_rectified_to_skew_grid) result.rectified_grid_angle = result.angle_from_rectified_to_skew_grid;
    // Apply projection defaults
    (0, $f1bd4f262dc935a3$export$d6def86a6ec68808)(result);
    return result;
}



var $35a9e46deb415c52$var$knownTypes = [
    "PROJECTEDCRS",
    "PROJCRS",
    "GEOGCS",
    "GEOCCS",
    "PROJCS",
    "LOCAL_CS",
    "GEODCRS",
    "GEODETICCRS",
    "GEODETICDATUM",
    "ENGCRS",
    "ENGINEERINGCRS"
];
function $35a9e46deb415c52$var$rename(obj, params) {
    var outName = params[0];
    var inName = params[1];
    if (!(outName in obj) && inName in obj) {
        obj[outName] = obj[inName];
        if (params.length === 3) obj[outName] = params[2](obj[outName]);
    }
}
function $35a9e46deb415c52$var$cleanWKT(wkt) {
    var keys = Object.keys(wkt);
    for(var i = 0, ii = keys.length; i < ii; ++i){
        var key = keys[i];
        // the followings are the crs defined in
        // https://github.com/proj4js/proj4js/blob/1da4ed0b865d0fcb51c136090569210cdcc9019e/lib/parseCode.js#L11
        if ($35a9e46deb415c52$var$knownTypes.indexOf(key) !== -1) $35a9e46deb415c52$var$setPropertiesFromWkt(wkt[key]);
        if (typeof wkt[key] === "object") $35a9e46deb415c52$var$cleanWKT(wkt[key]);
    }
}
function $35a9e46deb415c52$var$setPropertiesFromWkt(wkt) {
    if (wkt.AUTHORITY) {
        var authority = Object.keys(wkt.AUTHORITY)[0];
        if (authority && authority in wkt.AUTHORITY) wkt.title = authority + ":" + wkt.AUTHORITY[authority];
    }
    if (wkt.type === "GEOGCS") wkt.projName = "longlat";
    else if (wkt.type === "LOCAL_CS") {
        wkt.projName = "identity";
        wkt.local = true;
    } else if (typeof wkt.PROJECTION === "object") wkt.projName = Object.keys(wkt.PROJECTION)[0];
    else wkt.projName = wkt.PROJECTION;
    if (wkt.AXIS) {
        var axisOrder = "";
        for(var i = 0, ii = wkt.AXIS.length; i < ii; ++i){
            var axis = [
                wkt.AXIS[i][0].toLowerCase(),
                wkt.AXIS[i][1].toLowerCase()
            ];
            if (axis[0].indexOf("north") !== -1 || (axis[0] === "y" || axis[0] === "lat") && axis[1] === "north") axisOrder += "n";
            else if (axis[0].indexOf("south") !== -1 || (axis[0] === "y" || axis[0] === "lat") && axis[1] === "south") axisOrder += "s";
            else if (axis[0].indexOf("east") !== -1 || (axis[0] === "x" || axis[0] === "lon") && axis[1] === "east") axisOrder += "e";
            else if (axis[0].indexOf("west") !== -1 || (axis[0] === "x" || axis[0] === "lon") && axis[1] === "west") axisOrder += "w";
        }
        if (axisOrder.length === 2) axisOrder += "u";
        if (axisOrder.length === 3) wkt.axis = axisOrder;
    }
    if (wkt.UNIT) {
        wkt.units = wkt.UNIT.name.toLowerCase();
        if (wkt.units === "metre") wkt.units = "meter";
        if (wkt.UNIT.convert) {
            if (wkt.type === "GEOGCS") {
                if (wkt.DATUM && wkt.DATUM.SPHEROID) wkt.to_meter = wkt.UNIT.convert * wkt.DATUM.SPHEROID.a;
            } else wkt.to_meter = wkt.UNIT.convert;
        }
    }
    var geogcs = wkt.GEOGCS;
    if (wkt.type === "GEOGCS") geogcs = wkt;
    if (geogcs) {
        //if(wkt.GEOGCS.PRIMEM&&wkt.GEOGCS.PRIMEM.convert){
        //  wkt.from_greenwich=wkt.GEOGCS.PRIMEM.convert*D2R;
        //}
        if (geogcs.DATUM) wkt.datumCode = geogcs.DATUM.name.toLowerCase();
        else wkt.datumCode = geogcs.name.toLowerCase();
        if (wkt.datumCode.slice(0, 2) === "d_") wkt.datumCode = wkt.datumCode.slice(2);
        if (wkt.datumCode === "new_zealand_1949") wkt.datumCode = "nzgd49";
        if (wkt.datumCode === "wgs_1984" || wkt.datumCode === "world_geodetic_system_1984") {
            if (wkt.PROJECTION === "Mercator_Auxiliary_Sphere") wkt.sphere = true;
            wkt.datumCode = "wgs84";
        }
        if (wkt.datumCode === "belge_1972") wkt.datumCode = "rnb72";
        if (geogcs.DATUM && geogcs.DATUM.SPHEROID) {
            wkt.ellps = geogcs.DATUM.SPHEROID.name.replace("_19", "").replace(/[Cc]larke\_18/, "clrk");
            if (wkt.ellps.toLowerCase().slice(0, 13) === "international") wkt.ellps = "intl";
            wkt.a = geogcs.DATUM.SPHEROID.a;
            wkt.rf = parseFloat(geogcs.DATUM.SPHEROID.rf, 10);
        }
        if (geogcs.DATUM && geogcs.DATUM.TOWGS84) wkt.datum_params = geogcs.DATUM.TOWGS84;
        if (~wkt.datumCode.indexOf("osgb_1936")) wkt.datumCode = "osgb36";
        if (~wkt.datumCode.indexOf("osni_1952")) wkt.datumCode = "osni52";
        if (~wkt.datumCode.indexOf("tm65") || ~wkt.datumCode.indexOf("geodetic_datum_of_1965")) wkt.datumCode = "ire65";
        if (wkt.datumCode === "ch1903+") wkt.datumCode = "ch1903";
        if (~wkt.datumCode.indexOf("israel")) wkt.datumCode = "isr93";
    }
    if (wkt.b && !isFinite(wkt.b)) wkt.b = wkt.a;
    if (wkt.rectified_grid_angle) wkt.rectified_grid_angle = (0, $f1bd4f262dc935a3$export$e726aea149b4fd71)(wkt.rectified_grid_angle);
    function toMeter(input) {
        var ratio = wkt.to_meter || 1;
        return input * ratio;
    }
    var renamer = function(a) {
        return $35a9e46deb415c52$var$rename(wkt, a);
    };
    var list = [
        [
            "standard_parallel_1",
            "Standard_Parallel_1"
        ],
        [
            "standard_parallel_1",
            "Latitude of 1st standard parallel"
        ],
        [
            "standard_parallel_2",
            "Standard_Parallel_2"
        ],
        [
            "standard_parallel_2",
            "Latitude of 2nd standard parallel"
        ],
        [
            "false_easting",
            "False_Easting"
        ],
        [
            "false_easting",
            "False easting"
        ],
        [
            "false-easting",
            "Easting at false origin"
        ],
        [
            "false_northing",
            "False_Northing"
        ],
        [
            "false_northing",
            "False northing"
        ],
        [
            "false_northing",
            "Northing at false origin"
        ],
        [
            "central_meridian",
            "Central_Meridian"
        ],
        [
            "central_meridian",
            "Longitude of natural origin"
        ],
        [
            "central_meridian",
            "Longitude of false origin"
        ],
        [
            "latitude_of_origin",
            "Latitude_Of_Origin"
        ],
        [
            "latitude_of_origin",
            "Central_Parallel"
        ],
        [
            "latitude_of_origin",
            "Latitude of natural origin"
        ],
        [
            "latitude_of_origin",
            "Latitude of false origin"
        ],
        [
            "scale_factor",
            "Scale_Factor"
        ],
        [
            "k0",
            "scale_factor"
        ],
        [
            "latitude_of_center",
            "Latitude_Of_Center"
        ],
        [
            "latitude_of_center",
            "Latitude_of_center"
        ],
        [
            "lat0",
            "latitude_of_center",
            (0, $f1bd4f262dc935a3$export$e726aea149b4fd71)
        ],
        [
            "longitude_of_center",
            "Longitude_Of_Center"
        ],
        [
            "longitude_of_center",
            "Longitude_of_center"
        ],
        [
            "longc",
            "longitude_of_center",
            (0, $f1bd4f262dc935a3$export$e726aea149b4fd71)
        ],
        [
            "x0",
            "false_easting",
            toMeter
        ],
        [
            "y0",
            "false_northing",
            toMeter
        ],
        [
            "long0",
            "central_meridian",
            (0, $f1bd4f262dc935a3$export$e726aea149b4fd71)
        ],
        [
            "lat0",
            "latitude_of_origin",
            (0, $f1bd4f262dc935a3$export$e726aea149b4fd71)
        ],
        [
            "lat0",
            "standard_parallel_1",
            (0, $f1bd4f262dc935a3$export$e726aea149b4fd71)
        ],
        [
            "lat1",
            "standard_parallel_1",
            (0, $f1bd4f262dc935a3$export$e726aea149b4fd71)
        ],
        [
            "lat2",
            "standard_parallel_2",
            (0, $f1bd4f262dc935a3$export$e726aea149b4fd71)
        ],
        [
            "azimuth",
            "Azimuth"
        ],
        [
            "alpha",
            "azimuth",
            (0, $f1bd4f262dc935a3$export$e726aea149b4fd71)
        ],
        [
            "srsCode",
            "name"
        ]
    ];
    list.forEach(renamer);
    (0, $f1bd4f262dc935a3$export$d6def86a6ec68808)(wkt);
}
function $35a9e46deb415c52$export$2e2bcd8739ae039(wkt) {
    if (typeof wkt === "object") return (0, $6053abe52113fcc2$export$b04e619e90585ec3)(wkt);
    const version = (0, $65a5e945f2b13908$export$9362d65e4771b5d5)(wkt);
    var lisp = (0, $1cac0ee42dae5591$export$2e2bcd8739ae039)(wkt);
    if (version === "WKT2") {
        const projjson = (0, $2a8b41914fd2c2c0$export$48d0005f67ba915)(lisp);
        return (0, $6053abe52113fcc2$export$b04e619e90585ec3)(projjson);
    }
    var type = lisp[0];
    var obj = {};
    (0, $c0fbfe8b16e62850$export$337bc7a3aef1f775)(lisp, obj);
    $35a9e46deb415c52$var$cleanWKT(obj);
    return obj[type];
}


/**
 * @typedef {Object} ProjectionDefinition
 * @property {string} title
 * @property {string} [projName]
 * @property {string} [ellps]
 * @property {import('./Proj.js').DatumDefinition} [datum]
 * @property {string} [datumName]
 * @property {number} [rf]
 * @property {number} [lat0]
 * @property {number} [lat1]
 * @property {number} [lat2]
 * @property {number} [lat_ts]
 * @property {number} [long0]
 * @property {number} [long1]
 * @property {number} [long2]
 * @property {number} [alpha]
 * @property {number} [longc]
 * @property {number} [x0]
 * @property {number} [y0]
 * @property {number} [k0]
 * @property {number} [a]
 * @property {number} [b]
 * @property {true} [R_A]
 * @property {number} [zone]
 * @property {true} [utmSouth]
 * @property {string|Array<number>} [datum_params]
 * @property {number} [to_meter]
 * @property {string} [units]
 * @property {number} [from_greenwich]
 * @property {string} [datumCode]
 * @property {string} [nadgrids]
 * @property {string} [axis]
 * @property {boolean} [sphere]
 * @property {number} [rectified_grid_angle]
 * @property {boolean} [approx]
 * @property {<T extends import('./core').TemplateCoordinates>(coordinates: T, enforceAxis?: boolean) => T} inverse
 * @property {<T extends import('./core').TemplateCoordinates>(coordinates: T, enforceAxis?: boolean) => T} forward
 */ /**
 * @overload
 * @param {string} name
 * @param {string|ProjectionDefinition|import('./core.js').PROJJSONDefinition} projection
 * @returns {void}
 */ /**
 * @overload
 * @param {Array<[string, string]>} name
 * @returns {Array<ProjectionDefinition|undefined>}
 */ /**
 * @overload
 * @param {string} name
 * @returns {ProjectionDefinition}
 */ /**
 * @param {string | Array<Array<string>> | Partial<Record<'EPSG'|'ESRI'|'IAU2000', ProjectionDefinition>>} name
 * @returns {ProjectionDefinition | Array<ProjectionDefinition|undefined> | void}
 */ function $03d76949ae40b981$var$defs(name) {
    /* global console */ var that = this;
    if (arguments.length === 2) {
        var def = arguments[1];
        if (typeof def === "string") {
            if (def.charAt(0) === "+") $03d76949ae40b981$var$defs[/** @type {string} */ name] = (0, $b7395216027058e0$export$2e2bcd8739ae039)(arguments[1]);
            else $03d76949ae40b981$var$defs[/** @type {string} */ name] = (0, $35a9e46deb415c52$export$2e2bcd8739ae039)(arguments[1]);
        } else $03d76949ae40b981$var$defs[/** @type {string} */ name] = def;
    } else if (arguments.length === 1) {
        if (Array.isArray(name)) return name.map(function(v) {
            if (Array.isArray(v)) return $03d76949ae40b981$var$defs.apply(that, v);
            else return $03d76949ae40b981$var$defs(v);
        });
        else if (typeof name === "string") {
            if (name in $03d76949ae40b981$var$defs) return $03d76949ae40b981$var$defs[name];
        } else if ("EPSG" in name) $03d76949ae40b981$var$defs["EPSG:" + name.EPSG] = name;
        else if ("ESRI" in name) $03d76949ae40b981$var$defs["ESRI:" + name.ESRI] = name;
        else if ("IAU2000" in name) $03d76949ae40b981$var$defs["IAU2000:" + name.IAU2000] = name;
        else console.log(name);
        return;
    }
}
(0, $54518b00b2a9ea1f$export$2e2bcd8739ae039)($03d76949ae40b981$var$defs);
var $03d76949ae40b981$export$2e2bcd8739ae039 = $03d76949ae40b981$var$defs;





function $29542401062aff13$var$testObj(code) {
    return typeof code === "string";
}
function $29542401062aff13$var$testDef(code) {
    return code in (0, $03d76949ae40b981$export$2e2bcd8739ae039);
}
function $29542401062aff13$var$testWKT(code) {
    return code.indexOf("+") !== 0 && code.indexOf("[") !== -1 || typeof code === "object" && !("srsCode" in code);
}
var $29542401062aff13$var$codes = [
    "3857",
    "900913",
    "3785",
    "102113"
];
function $29542401062aff13$var$checkMercator(item) {
    var auth = (0, $aca64ceea23ffc2c$export$2e2bcd8739ae039)(item, "authority");
    if (!auth) return;
    var code = (0, $aca64ceea23ffc2c$export$2e2bcd8739ae039)(auth, "epsg");
    return code && $29542401062aff13$var$codes.indexOf(code) > -1;
}
function $29542401062aff13$var$checkProjStr(item) {
    var ext = (0, $aca64ceea23ffc2c$export$2e2bcd8739ae039)(item, "extension");
    if (!ext) return;
    return (0, $aca64ceea23ffc2c$export$2e2bcd8739ae039)(ext, "proj4");
}
function $29542401062aff13$var$testProj(code) {
    return code[0] === "+";
}
/**
 * @param {string | import('./core').PROJJSONDefinition | import('./defs').ProjectionDefinition} code
 * @returns {import('./defs').ProjectionDefinition}
 */ function $29542401062aff13$var$parse(code) {
    if ($29542401062aff13$var$testObj(code)) {
        // check to see if this is a WKT string
        if ($29542401062aff13$var$testDef(code)) return (0, $03d76949ae40b981$export$2e2bcd8739ae039)[code];
        if ($29542401062aff13$var$testWKT(code)) {
            var out = (0, $35a9e46deb415c52$export$2e2bcd8739ae039)(code);
            // test of spetial case, due to this being a very common and often malformed
            if ($29542401062aff13$var$checkMercator(out)) return (0, $03d76949ae40b981$export$2e2bcd8739ae039)["EPSG:3857"];
            var maybeProjStr = $29542401062aff13$var$checkProjStr(out);
            if (maybeProjStr) return (0, $b7395216027058e0$export$2e2bcd8739ae039)(maybeProjStr);
            return out;
        }
        if ($29542401062aff13$var$testProj(code)) return (0, $b7395216027058e0$export$2e2bcd8739ae039)(code);
    } else if (!("projName" in code)) return (0, $35a9e46deb415c52$export$2e2bcd8739ae039)(code);
    else return code;
}
var $29542401062aff13$export$2e2bcd8739ae039 = $29542401062aff13$var$parse;


function $fcc7caaddb728552$export$2e2bcd8739ae039(destination, source) {
    destination = destination || {};
    var value, property;
    if (!source) return destination;
    for(property in source){
        value = source[property];
        if (value !== undefined) destination[property] = value;
    }
    return destination;
}



var $ao8xz = parcelRequire("ao8xz");

var $186WS = parcelRequire("186WS");

var $jVGH7 = parcelRequire("jVGH7");
function $1fd05693455a46f8$export$2e2bcd8739ae039(eccent, phi, sinphi) {
    var con = eccent * sinphi;
    var com = 0.5 * eccent;
    con = Math.pow((1 - con) / (1 + con), com);
    return Math.tan(0.5 * ((0, $jVGH7.HALF_PI) - phi)) / con;
}



var $jVGH7 = parcelRequire("jVGH7");
function $d9cf96cf291e0f24$export$2e2bcd8739ae039(eccent, ts) {
    var eccnth = 0.5 * eccent;
    var con, dphi;
    var phi = (0, $jVGH7.HALF_PI) - 2 * Math.atan(ts);
    for(var i = 0; i <= 15; i++){
        con = eccent * Math.sin(phi);
        dphi = (0, $jVGH7.HALF_PI) - 2 * Math.atan(ts * Math.pow((1 - con) / (1 + con), eccnth)) - phi;
        phi += dphi;
        if (Math.abs(dphi) <= 0.0000000001) return phi;
    }
    // console.log("phi2z has NoConvergence");
    return -9999;
}



var $jVGH7 = parcelRequire("jVGH7");
function $2c0195b2811c158e$export$2cd8252107eb640b() {
    var con = this.b / this.a;
    this.es = 1 - con * con;
    if (!("x0" in this)) this.x0 = 0;
    if (!("y0" in this)) this.y0 = 0;
    this.e = Math.sqrt(this.es);
    if (this.lat_ts) {
        if (this.sphere) this.k0 = Math.cos(this.lat_ts);
        else this.k0 = (0, $ao8xz.default)(this.e, Math.sin(this.lat_ts), Math.cos(this.lat_ts));
    } else if (!this.k0) {
        if (this.k) this.k0 = this.k;
        else this.k0 = 1;
    }
}
function $2c0195b2811c158e$export$174bb771924e7eb1(p) {
    var lon = p.x;
    var lat = p.y;
    // convert to radians
    if (lat * (0, $jVGH7.R2D) > 90 && lat * (0, $jVGH7.R2D) < -90 && lon * (0, $jVGH7.R2D) > 180 && lon * (0, $jVGH7.R2D) < -180) return null;
    var x, y;
    if (Math.abs(Math.abs(lat) - (0, $jVGH7.HALF_PI)) <= (0, $jVGH7.EPSLN)) return null;
    else {
        if (this.sphere) {
            x = this.x0 + this.a * this.k0 * (0, $186WS.default)(lon - this.long0);
            y = this.y0 + this.a * this.k0 * Math.log(Math.tan((0, $jVGH7.FORTPI) + 0.5 * lat));
        } else {
            var sinphi = Math.sin(lat);
            var ts = (0, $1fd05693455a46f8$export$2e2bcd8739ae039)(this.e, lat, sinphi);
            x = this.x0 + this.a * this.k0 * (0, $186WS.default)(lon - this.long0);
            y = this.y0 - this.a * this.k0 * Math.log(ts);
        }
        p.x = x;
        p.y = y;
        return p;
    }
}
function $2c0195b2811c158e$export$70ae2c07e401031b(p) {
    var x = p.x - this.x0;
    var y = p.y - this.y0;
    var lon, lat;
    if (this.sphere) lat = (0, $jVGH7.HALF_PI) - 2 * Math.atan(Math.exp(-y / (this.a * this.k0)));
    else {
        var ts = Math.exp(-y / (this.a * this.k0));
        lat = (0, $d9cf96cf291e0f24$export$2e2bcd8739ae039)(this.e, ts);
        if (lat === -9999) return null;
    }
    lon = (0, $186WS.default)(this.long0 + x / (this.a * this.k0));
    p.x = lon;
    p.y = lat;
    return p;
}
var $2c0195b2811c158e$export$e4b2ac9215619f8d = [
    "Mercator",
    "Popular Visualisation Pseudo Mercator",
    "Mercator_1SP",
    "Mercator_Auxiliary_Sphere",
    "Mercator_Variant_A",
    "merc"
];
var $2c0195b2811c158e$export$2e2bcd8739ae039 = {
    init: $2c0195b2811c158e$export$2cd8252107eb640b,
    forward: $2c0195b2811c158e$export$174bb771924e7eb1,
    inverse: $2c0195b2811c158e$export$70ae2c07e401031b,
    names: $2c0195b2811c158e$export$e4b2ac9215619f8d
};


function $caf0db2d6026aec4$export$2cd8252107eb640b() {
// no-op for longlat
}
function $caf0db2d6026aec4$export$174bb771924e7eb1(pt) {
    return pt;
}
var $caf0db2d6026aec4$export$e4b2ac9215619f8d = [
    "longlat",
    "identity"
];
var $caf0db2d6026aec4$export$2e2bcd8739ae039 = {
    init: $caf0db2d6026aec4$export$2cd8252107eb640b,
    forward: $caf0db2d6026aec4$export$174bb771924e7eb1,
    inverse: $caf0db2d6026aec4$export$174bb771924e7eb1,
    names: $caf0db2d6026aec4$export$e4b2ac9215619f8d
};


var $0e1d3f1fd830d3be$var$projs = [
    (0, $2c0195b2811c158e$export$2e2bcd8739ae039),
    (0, $caf0db2d6026aec4$export$2e2bcd8739ae039)
];
var $0e1d3f1fd830d3be$var$names = {};
var $0e1d3f1fd830d3be$var$projStore = [];
function $0e1d3f1fd830d3be$export$e16d8520af44a096(proj, i) {
    var len = $0e1d3f1fd830d3be$var$projStore.length;
    if (!proj.names) {
        console.log(i);
        return true;
    }
    $0e1d3f1fd830d3be$var$projStore[len] = proj;
    proj.names.forEach(function(n) {
        $0e1d3f1fd830d3be$var$names[n.toLowerCase()] = len;
    });
    return this;
}
function $0e1d3f1fd830d3be$export$9ee0bb5510679155(n) {
    return n.replace(/[-\(\)\s]+/g, " ").trim().replace(/ /g, "_");
}
function $0e1d3f1fd830d3be$export$3988ae62b71be9a3(name) {
    if (!name) return false;
    var n = name.toLowerCase();
    if (typeof $0e1d3f1fd830d3be$var$names[n] !== "undefined" && $0e1d3f1fd830d3be$var$projStore[$0e1d3f1fd830d3be$var$names[n]]) return $0e1d3f1fd830d3be$var$projStore[$0e1d3f1fd830d3be$var$names[n]];
    n = $0e1d3f1fd830d3be$export$9ee0bb5510679155(n);
    if (n in $0e1d3f1fd830d3be$var$names && $0e1d3f1fd830d3be$var$projStore[$0e1d3f1fd830d3be$var$names[n]]) return $0e1d3f1fd830d3be$var$projStore[$0e1d3f1fd830d3be$var$names[n]];
}
function $0e1d3f1fd830d3be$export$b3571188c770cc5a() {
    $0e1d3f1fd830d3be$var$projs.forEach($0e1d3f1fd830d3be$export$e16d8520af44a096);
}
var $0e1d3f1fd830d3be$export$2e2bcd8739ae039 = {
    start: $0e1d3f1fd830d3be$export$b3571188c770cc5a,
    add: $0e1d3f1fd830d3be$export$e16d8520af44a096,
    get: $0e1d3f1fd830d3be$export$3988ae62b71be9a3
};



var $jVGH7 = parcelRequire("jVGH7");
var $c31fdc10ca2d6757$var$ellipsoids = {
    MERIT: {
        a: 6378137,
        rf: 298.257,
        ellipseName: "MERIT 1983"
    },
    SGS85: {
        a: 6378136,
        rf: 298.257,
        ellipseName: "Soviet Geodetic System 85"
    },
    GRS80: {
        a: 6378137,
        rf: 298.257222101,
        ellipseName: "GRS 1980(IUGG, 1980)"
    },
    IAU76: {
        a: 6378140,
        rf: 298.257,
        ellipseName: "IAU 1976"
    },
    airy: {
        a: 6377563.396,
        b: 6356256.91,
        ellipseName: "Airy 1830"
    },
    APL4: {
        a: 6378137,
        rf: 298.25,
        ellipseName: "Appl. Physics. 1965"
    },
    NWL9D: {
        a: 6378145,
        rf: 298.25,
        ellipseName: "Naval Weapons Lab., 1965"
    },
    mod_airy: {
        a: 6377340.189,
        b: 6356034.446,
        ellipseName: "Modified Airy"
    },
    andrae: {
        a: 6377104.43,
        rf: 300,
        ellipseName: "Andrae 1876 (Den., Iclnd.)"
    },
    aust_SA: {
        a: 6378160,
        rf: 298.25,
        ellipseName: "Australian Natl & S. Amer. 1969"
    },
    GRS67: {
        a: 6378160,
        rf: 298.247167427,
        ellipseName: "GRS 67(IUGG 1967)"
    },
    bessel: {
        a: 6377397.155,
        rf: 299.1528128,
        ellipseName: "Bessel 1841"
    },
    bess_nam: {
        a: 6377483.865,
        rf: 299.1528128,
        ellipseName: "Bessel 1841 (Namibia)"
    },
    clrk66: {
        a: 6378206.4,
        b: 6356583.8,
        ellipseName: "Clarke 1866"
    },
    clrk80: {
        a: 6378249.145,
        rf: 293.4663,
        ellipseName: "Clarke 1880 mod."
    },
    clrk80ign: {
        a: 6378249.2,
        b: 6356515,
        rf: 293.4660213,
        ellipseName: "Clarke 1880 (IGN)"
    },
    clrk58: {
        a: 6378293.645208759,
        rf: 294.2606763692654,
        ellipseName: "Clarke 1858"
    },
    CPM: {
        a: 6375738.7,
        rf: 334.29,
        ellipseName: "Comm. des Poids et Mesures 1799"
    },
    delmbr: {
        a: 6376428,
        rf: 311.5,
        ellipseName: "Delambre 1810 (Belgium)"
    },
    engelis: {
        a: 6378136.05,
        rf: 298.2566,
        ellipseName: "Engelis 1985"
    },
    evrst30: {
        a: 6377276.345,
        rf: 300.8017,
        ellipseName: "Everest 1830"
    },
    evrst48: {
        a: 6377304.063,
        rf: 300.8017,
        ellipseName: "Everest 1948"
    },
    evrst56: {
        a: 6377301.243,
        rf: 300.8017,
        ellipseName: "Everest 1956"
    },
    evrst69: {
        a: 6377295.664,
        rf: 300.8017,
        ellipseName: "Everest 1969"
    },
    evrstSS: {
        a: 6377298.556,
        rf: 300.8017,
        ellipseName: "Everest (Sabah & Sarawak)"
    },
    fschr60: {
        a: 6378166,
        rf: 298.3,
        ellipseName: "Fischer (Mercury Datum) 1960"
    },
    fschr60m: {
        a: 6378155,
        rf: 298.3,
        ellipseName: "Fischer 1960"
    },
    fschr68: {
        a: 6378150,
        rf: 298.3,
        ellipseName: "Fischer 1968"
    },
    helmert: {
        a: 6378200,
        rf: 298.3,
        ellipseName: "Helmert 1906"
    },
    hough: {
        a: 6378270,
        rf: 297,
        ellipseName: "Hough"
    },
    intl: {
        a: 6378388,
        rf: 297,
        ellipseName: "International 1909 (Hayford)"
    },
    kaula: {
        a: 6378163,
        rf: 298.24,
        ellipseName: "Kaula 1961"
    },
    lerch: {
        a: 6378139,
        rf: 298.257,
        ellipseName: "Lerch 1979"
    },
    mprts: {
        a: 6397300,
        rf: 191,
        ellipseName: "Maupertius 1738"
    },
    new_intl: {
        a: 6378157.5,
        b: 6356772.2,
        ellipseName: "New International 1967"
    },
    plessis: {
        a: 6376523,
        rf: 6355863,
        ellipseName: "Plessis 1817 (France)"
    },
    krass: {
        a: 6378245,
        rf: 298.3,
        ellipseName: "Krassovsky, 1942"
    },
    SEasia: {
        a: 6378155,
        b: 6356773.3205,
        ellipseName: "Southeast Asia"
    },
    walbeck: {
        a: 6376896,
        b: 6355834.8467,
        ellipseName: "Walbeck"
    },
    WGS60: {
        a: 6378165,
        rf: 298.3,
        ellipseName: "WGS 60"
    },
    WGS66: {
        a: 6378145,
        rf: 298.25,
        ellipseName: "WGS 66"
    },
    WGS7: {
        a: 6378135,
        rf: 298.26,
        ellipseName: "WGS 72"
    },
    WGS84: {
        a: 6378137,
        rf: 298.257223563,
        ellipseName: "WGS 84"
    },
    sphere: {
        a: 6370997,
        b: 6370997,
        ellipseName: "Normal Sphere (r=6370997)"
    }
};
var $c31fdc10ca2d6757$export$2e2bcd8739ae039 = $c31fdc10ca2d6757$var$ellipsoids;



const $be456f43e089118b$var$WGS84 = (0, $c31fdc10ca2d6757$export$2e2bcd8739ae039).WGS84; // default ellipsoid
function $be456f43e089118b$export$e3d7bf2ed2a7479f(a, b, rf, R_A) {
    var a2 = a * a; // used in geocentric
    var b2 = b * b; // used in geocentric
    var es = (a2 - b2) / a2; // e ^ 2
    var e = 0;
    if (R_A) {
        a *= 1 - es * ((0, $jVGH7.SIXTH) + es * ((0, $jVGH7.RA4) + es * (0, $jVGH7.RA6)));
        a2 = a * a;
        es = 0;
    } else e = Math.sqrt(es); // eccentricity
    var ep2 = (a2 - b2) / b2; // used in geocentric
    return {
        es: es,
        e: e,
        ep2: ep2
    };
}
function $be456f43e089118b$export$b2690196de52b050(a, b, rf, ellps, sphere) {
    if (!a) {
        var ellipse = (0, $aca64ceea23ffc2c$export$2e2bcd8739ae039)((0, $c31fdc10ca2d6757$export$2e2bcd8739ae039), ellps);
        if (!ellipse) ellipse = $be456f43e089118b$var$WGS84;
        a = ellipse.a;
        b = ellipse.b;
        rf = ellipse.rf;
    }
    if (rf && !b) b = (1.0 - 1.0 / rf) * a;
    if (rf === 0 || Math.abs(a - b) < (0, $jVGH7.EPSLN)) {
        sphere = true;
        b = a;
    }
    return {
        a: a,
        b: b,
        rf: rf,
        sphere: sphere
    };
}


var $4b9c37234a8f7847$var$datums = {
    wgs84: {
        towgs84: "0,0,0",
        ellipse: "WGS84",
        datumName: "WGS84"
    },
    ch1903: {
        towgs84: "674.374,15.056,405.346",
        ellipse: "bessel",
        datumName: "swiss"
    },
    ggrs87: {
        towgs84: "-199.87,74.79,246.62",
        ellipse: "GRS80",
        datumName: "Greek_Geodetic_Reference_System_1987"
    },
    nad83: {
        towgs84: "0,0,0",
        ellipse: "GRS80",
        datumName: "North_American_Datum_1983"
    },
    nad27: {
        nadgrids: "@conus,@alaska,@ntv2_0.gsb,@ntv1_can.dat",
        ellipse: "clrk66",
        datumName: "North_American_Datum_1927"
    },
    potsdam: {
        towgs84: "598.1,73.7,418.2,0.202,0.045,-2.455,6.7",
        ellipse: "bessel",
        datumName: "Potsdam Rauenberg 1950 DHDN"
    },
    carthage: {
        towgs84: "-263.0,6.0,431.0",
        ellipse: "clark80",
        datumName: "Carthage 1934 Tunisia"
    },
    hermannskogel: {
        towgs84: "577.326,90.129,463.919,5.137,1.474,5.297,2.4232",
        ellipse: "bessel",
        datumName: "Hermannskogel"
    },
    mgi: {
        towgs84: "577.326,90.129,463.919,5.137,1.474,5.297,2.4232",
        ellipse: "bessel",
        datumName: "Militar-Geographische Institut"
    },
    osni52: {
        towgs84: "482.530,-130.596,564.557,-1.042,-0.214,-0.631,8.15",
        ellipse: "airy",
        datumName: "Irish National"
    },
    ire65: {
        towgs84: "482.530,-130.596,564.557,-1.042,-0.214,-0.631,8.15",
        ellipse: "mod_airy",
        datumName: "Ireland 1965"
    },
    rassadiran: {
        towgs84: "-133.63,-157.5,-158.62",
        ellipse: "intl",
        datumName: "Rassadiran"
    },
    nzgd49: {
        towgs84: "59.47,-5.04,187.44,0.47,-0.1,1.024,-4.5993",
        ellipse: "intl",
        datumName: "New Zealand Geodetic Datum 1949"
    },
    osgb36: {
        towgs84: "446.448,-125.157,542.060,0.1502,0.2470,0.8421,-20.4894",
        ellipse: "airy",
        datumName: "Ordnance Survey of Great Britain 1936"
    },
    s_jtsk: {
        towgs84: "589,76,480",
        ellipse: "bessel",
        datumName: "S-JTSK (Ferro)"
    },
    beduaram: {
        towgs84: "-106,-87,188",
        ellipse: "clrk80",
        datumName: "Beduaram"
    },
    gunung_segara: {
        towgs84: "-403,684,41",
        ellipse: "bessel",
        datumName: "Gunung Segara Jakarta"
    },
    rnb72: {
        towgs84: "106.869,-52.2978,103.724,-0.33657,0.456955,-1.84218,1",
        ellipse: "intl",
        datumName: "Reseau National Belge 1972"
    },
    EPSG_5451: {
        towgs84: "6.41,-49.05,-11.28,1.5657,0.5242,6.9718,-5.7649"
    },
    IGNF_LURESG: {
        towgs84: "-192.986,13.673,-39.309,-0.4099,-2.9332,2.6881,0.43"
    },
    EPSG_4614: {
        towgs84: "-119.4248,-303.65872,-11.00061,1.164298,0.174458,1.096259,3.657065"
    },
    EPSG_4615: {
        towgs84: "-494.088,-312.129,279.877,-1.423,-1.013,1.59,-0.748"
    },
    ESRI_37241: {
        towgs84: "-76.822,257.457,-12.817,2.136,-0.033,-2.392,-0.031"
    },
    ESRI_37249: {
        towgs84: "-440.296,58.548,296.265,1.128,10.202,4.559,-0.438"
    },
    ESRI_37245: {
        towgs84: "-511.151,-181.269,139.609,1.05,2.703,1.798,3.071"
    },
    EPSG_4178: {
        towgs84: "24.9,-126.4,-93.2,-0.063,-0.247,-0.041,1.01"
    },
    EPSG_4622: {
        towgs84: "-472.29,-5.63,-304.12,0.4362,-0.8374,0.2563,1.8984"
    },
    EPSG_4625: {
        towgs84: "126.93,547.94,130.41,-2.7867,5.1612,-0.8584,13.8227"
    },
    EPSG_5252: {
        towgs84: "0.023,0.036,-0.068,0.00176,0.00912,-0.01136,0.00439"
    },
    EPSG_4314: {
        towgs84: "597.1,71.4,412.1,0.894,0.068,-1.563,7.58"
    },
    EPSG_4282: {
        towgs84: "-178.3,-316.7,-131.5,5.278,6.077,10.979,19.166"
    },
    EPSG_4231: {
        towgs84: "-83.11,-97.38,-117.22,0.0276,-0.2167,0.2147,0.1218"
    },
    EPSG_4274: {
        towgs84: "-230.994,102.591,25.199,0.633,-0.239,0.9,1.95"
    },
    EPSG_4134: {
        towgs84: "-180.624,-225.516,173.919,-0.81,-1.898,8.336,16.71006"
    },
    EPSG_4254: {
        towgs84: "18.38,192.45,96.82,0.056,-0.142,-0.2,-0.0013"
    },
    EPSG_4159: {
        towgs84: "-194.513,-63.978,-25.759,-3.4027,3.756,-3.352,-0.9175"
    },
    EPSG_4687: {
        towgs84: "0.072,-0.507,-0.245,0.0183,-0.0003,0.007,-0.0093"
    },
    EPSG_4227: {
        towgs84: "-83.58,-397.54,458.78,-17.595,-2.847,4.256,3.225"
    },
    EPSG_4746: {
        towgs84: "599.4,72.4,419.2,-0.062,-0.022,-2.723,6.46"
    },
    EPSG_4745: {
        towgs84: "612.4,77,440.2,-0.054,0.057,-2.797,2.55"
    },
    EPSG_6311: {
        towgs84: "8.846,-4.394,-1.122,-0.00237,-0.146528,0.130428,0.783926"
    },
    EPSG_4289: {
        towgs84: "565.7381,50.4018,465.2904,-1.91514,1.60363,-9.09546,4.07244"
    },
    EPSG_4230: {
        towgs84: "-68.863,-134.888,-111.49,-0.53,-0.14,0.57,-3.4"
    },
    EPSG_4154: {
        towgs84: "-123.02,-158.95,-168.47"
    },
    EPSG_4156: {
        towgs84: "570.8,85.7,462.8,4.998,1.587,5.261,3.56"
    },
    EPSG_4299: {
        towgs84: "482.5,-130.6,564.6,-1.042,-0.214,-0.631,8.15"
    },
    EPSG_4179: {
        towgs84: "33.4,-146.6,-76.3,-0.359,-0.053,0.844,-0.84"
    },
    EPSG_4313: {
        towgs84: "-106.8686,52.2978,-103.7239,0.3366,-0.457,1.8422,-1.2747"
    },
    EPSG_4194: {
        towgs84: "163.511,127.533,-159.789"
    },
    EPSG_4195: {
        towgs84: "105,326,-102.5"
    },
    EPSG_4196: {
        towgs84: "-45,417,-3.5"
    },
    EPSG_4611: {
        towgs84: "-162.619,-276.959,-161.764,0.067753,-2.243649,-1.158827,-1.094246"
    },
    EPSG_4633: {
        towgs84: "137.092,131.66,91.475,-1.9436,-11.5993,-4.3321,-7.4824"
    },
    EPSG_4641: {
        towgs84: "-408.809,366.856,-412.987,1.8842,-0.5308,2.1655,-121.0993"
    },
    EPSG_4643: {
        towgs84: "-480.26,-438.32,-643.429,16.3119,20.1721,-4.0349,-111.7002"
    },
    EPSG_4300: {
        towgs84: "482.5,-130.6,564.6,-1.042,-0.214,-0.631,8.15"
    },
    EPSG_4188: {
        towgs84: "482.5,-130.6,564.6,-1.042,-0.214,-0.631,8.15"
    },
    EPSG_4660: {
        towgs84: "982.6087,552.753,-540.873,32.39344,-153.25684,-96.2266,16.805"
    },
    EPSG_4662: {
        towgs84: "97.295,-263.247,310.882,-1.5999,0.8386,3.1409,13.3259"
    },
    EPSG_3906: {
        towgs84: "577.88891,165.22205,391.18289,4.9145,-0.94729,-13.05098,7.78664"
    },
    EPSG_4307: {
        towgs84: "-209.3622,-87.8162,404.6198,0.0046,3.4784,0.5805,-1.4547"
    },
    EPSG_6892: {
        towgs84: "-76.269,-16.683,68.562,-6.275,10.536,-4.286,-13.686"
    },
    EPSG_4690: {
        towgs84: "221.597,152.441,176.523,2.403,1.3893,0.884,11.4648"
    },
    EPSG_4691: {
        towgs84: "218.769,150.75,176.75,3.5231,2.0037,1.288,10.9817"
    },
    EPSG_4629: {
        towgs84: "72.51,345.411,79.241,-1.5862,-0.8826,-0.5495,1.3653"
    },
    EPSG_4630: {
        towgs84: "165.804,216.213,180.26,-0.6251,-0.4515,-0.0721,7.4111"
    },
    EPSG_4692: {
        towgs84: "217.109,86.452,23.711,0.0183,-0.0003,0.007,-0.0093"
    },
    EPSG_9333: {
        towgs84: "0,0,0,-8.393,0.749,-10.276,0"
    },
    EPSG_9059: {
        towgs84: "0,0,0"
    },
    EPSG_4312: {
        towgs84: "601.705,84.263,485.227,4.7354,1.3145,5.393,-2.3887"
    },
    EPSG_4123: {
        towgs84: "-96.062,-82.428,-121.753,4.801,0.345,-1.376,1.496"
    },
    EPSG_4309: {
        towgs84: "-124.45,183.74,44.64,-0.4384,0.5446,-0.9706,-2.1365"
    },
    ESRI_104106: {
        towgs84: "-283.088,-70.693,117.445,-1.157,0.059,-0.652,-4.058"
    },
    EPSG_4281: {
        towgs84: "-219.247,-73.802,269.529"
    },
    EPSG_4322: {
        towgs84: "0,0,4.5"
    },
    EPSG_4324: {
        towgs84: "0,0,1.9"
    },
    EPSG_4284: {
        towgs84: "43.822,-108.842,-119.585,1.455,-0.761,0.737,0.549"
    },
    EPSG_4277: {
        towgs84: "446.448,-125.157,542.06,0.15,0.247,0.842,-20.489"
    },
    EPSG_4207: {
        towgs84: "-282.1,-72.2,120,-1.529,0.145,-0.89,-4.46"
    },
    EPSG_4688: {
        towgs84: "347.175,1077.618,2623.677,33.9058,-70.6776,9.4013,186.0647"
    },
    EPSG_4689: {
        towgs84: "410.793,54.542,80.501,-2.5596,-2.3517,-0.6594,17.3218"
    },
    EPSG_4720: {
        towgs84: "0,0,4.5"
    },
    EPSG_4273: {
        towgs84: "278.3,93,474.5,7.889,0.05,-6.61,6.21"
    },
    EPSG_4240: {
        towgs84: "204.64,834.74,293.8"
    },
    EPSG_4817: {
        towgs84: "278.3,93,474.5,7.889,0.05,-6.61,6.21"
    },
    ESRI_104131: {
        towgs84: "426.62,142.62,460.09,4.98,4.49,-12.42,-17.1"
    },
    EPSG_4265: {
        towgs84: "-104.1,-49.1,-9.9,0.971,-2.917,0.714,-11.68"
    },
    EPSG_4263: {
        towgs84: "-111.92,-87.85,114.5,1.875,0.202,0.219,0.032"
    },
    EPSG_4298: {
        towgs84: "-689.5937,623.84046,-65.93566,-0.02331,1.17094,-0.80054,5.88536"
    },
    EPSG_4270: {
        towgs84: "-253.4392,-148.452,386.5267,0.15605,0.43,-0.1013,-0.0424"
    },
    EPSG_4229: {
        towgs84: "-121.8,98.1,-10.7"
    },
    EPSG_4220: {
        towgs84: "-55.5,-348,-229.2"
    },
    EPSG_4214: {
        towgs84: "12.646,-155.176,-80.863"
    },
    EPSG_4232: {
        towgs84: "-345,3,223"
    },
    EPSG_4238: {
        towgs84: "-1.977,-13.06,-9.993,0.364,0.254,0.689,-1.037"
    },
    EPSG_4168: {
        towgs84: "-170,33,326"
    },
    EPSG_4131: {
        towgs84: "199,931,318.9"
    },
    EPSG_4152: {
        towgs84: "-0.9102,2.0141,0.5602,0.029039,0.010065,0.010101,0"
    },
    EPSG_5228: {
        towgs84: "572.213,85.334,461.94,4.9732,1.529,5.2484,3.5378"
    },
    EPSG_8351: {
        towgs84: "485.021,169.465,483.839,7.786342,4.397554,4.102655,0"
    },
    EPSG_4683: {
        towgs84: "-127.62,-67.24,-47.04,-3.068,4.903,1.578,-1.06"
    },
    EPSG_4133: {
        towgs84: "0,0,0"
    },
    EPSG_7373: {
        towgs84: "0.819,-0.5762,-1.6446,-0.00378,-0.03317,0.00318,0.0693"
    },
    EPSG_9075: {
        towgs84: "-0.9102,2.0141,0.5602,0.029039,0.010065,0.010101,0"
    },
    EPSG_9072: {
        towgs84: "-0.9102,2.0141,0.5602,0.029039,0.010065,0.010101,0"
    },
    EPSG_9294: {
        towgs84: "1.16835,-1.42001,-2.24431,-0.00822,-0.05508,0.01818,0.23388"
    },
    EPSG_4212: {
        towgs84: "-267.434,173.496,181.814,-13.4704,8.7154,7.3926,14.7492"
    },
    EPSG_4191: {
        towgs84: "-44.183,-0.58,-38.489,2.3867,2.7072,-3.5196,-8.2703"
    },
    EPSG_4237: {
        towgs84: "52.684,-71.194,-13.975,-0.312,-0.1063,-0.3729,1.0191"
    },
    EPSG_4740: {
        towgs84: "-1.08,-0.27,-0.9"
    },
    EPSG_4124: {
        towgs84: "419.3836,99.3335,591.3451,0.850389,1.817277,-7.862238,-0.99496"
    },
    EPSG_5681: {
        towgs84: "584.9636,107.7175,413.8067,1.1155,0.2824,-3.1384,7.9922"
    },
    EPSG_4141: {
        towgs84: "23.772,17.49,17.859,-0.3132,-1.85274,1.67299,-5.4262"
    },
    EPSG_4204: {
        towgs84: "-85.645,-273.077,-79.708,2.289,-1.421,2.532,3.194"
    },
    EPSG_4319: {
        towgs84: "226.702,-193.337,-35.371,-2.229,-4.391,9.238,0.9798"
    },
    EPSG_4200: {
        towgs84: "24.82,-131.21,-82.66"
    },
    EPSG_4130: {
        towgs84: "0,0,0"
    },
    EPSG_4127: {
        towgs84: "-82.875,-57.097,-156.768,-2.158,1.524,-0.982,-0.359"
    },
    EPSG_4149: {
        towgs84: "674.374,15.056,405.346"
    },
    EPSG_4617: {
        towgs84: "-0.991,1.9072,0.5129,1.25033e-7,4.6785e-8,5.6529e-8,0"
    },
    EPSG_4663: {
        towgs84: "-210.502,-66.902,-48.476,2.094,-15.067,-5.817,0.485"
    },
    EPSG_4664: {
        towgs84: "-211.939,137.626,58.3,-0.089,0.251,0.079,0.384"
    },
    EPSG_4665: {
        towgs84: "-105.854,165.589,-38.312,-0.003,-0.026,0.024,-0.048"
    },
    EPSG_4666: {
        towgs84: "631.392,-66.551,481.442,1.09,-4.445,-4.487,-4.43"
    },
    EPSG_4756: {
        towgs84: "-192.873,-39.382,-111.202,-0.00205,-0.0005,0.00335,0.0188"
    },
    EPSG_4723: {
        towgs84: "-179.483,-69.379,-27.584,-7.862,8.163,6.042,-13.925"
    },
    EPSG_4726: {
        towgs84: "8.853,-52.644,180.304,-0.393,-2.323,2.96,-24.081"
    },
    EPSG_4267: {
        towgs84: "-8.0,160.0,176.0"
    },
    EPSG_5365: {
        towgs84: "-0.16959,0.35312,0.51846,0.03385,-0.16325,0.03446,0.03693"
    },
    EPSG_4218: {
        towgs84: "304.5,306.5,-318.1"
    },
    EPSG_4242: {
        towgs84: "-33.722,153.789,94.959,-8.581,-4.478,4.54,8.95"
    },
    EPSG_4216: {
        towgs84: "-292.295,248.758,429.447,4.9971,2.99,6.6906,1.0289"
    },
    ESRI_104105: {
        towgs84: "631.392,-66.551,481.442,1.09,-4.445,-4.487,-4.43"
    },
    ESRI_104129: {
        towgs84: "0,0,0"
    },
    EPSG_4673: {
        towgs84: "174.05,-25.49,112.57"
    },
    EPSG_4202: {
        towgs84: "-124,-60,154"
    },
    EPSG_4203: {
        towgs84: "-117.763,-51.51,139.061,0.292,0.443,0.277,-0.191"
    },
    EPSG_3819: {
        towgs84: "595.48,121.69,515.35,4.115,-2.9383,0.853,-3.408"
    },
    EPSG_8694: {
        towgs84: "-93.799,-132.737,-219.073,-1.844,0.648,-6.37,-0.169"
    },
    EPSG_4145: {
        towgs84: "275.57,676.78,229.6"
    },
    EPSG_4283: {
        towgs84: "61.55,-10.87,-40.19,39.4924,32.7221,32.8979,-9.994"
    },
    EPSG_4317: {
        towgs84: "2.3287,-147.0425,-92.0802,-0.3092483,0.32482185,0.49729934,5.68906266"
    },
    EPSG_4272: {
        towgs84: "59.47,-5.04,187.44,0.47,-0.1,1.024,-4.5993"
    },
    EPSG_4248: {
        towgs84: "-307.7,265.3,-363.5"
    },
    EPSG_5561: {
        towgs84: "24,-121,-76"
    },
    EPSG_5233: {
        towgs84: "-0.293,766.95,87.713,0.195704,1.695068,3.473016,-0.039338"
    },
    ESRI_104130: {
        towgs84: "-86,-98,-119"
    },
    ESRI_104102: {
        towgs84: "682,-203,480"
    },
    ESRI_37207: {
        towgs84: "7,-10,-26"
    },
    EPSG_4675: {
        towgs84: "59.935,118.4,-10.871"
    },
    ESRI_104109: {
        towgs84: "-89.121,-348.182,260.871"
    },
    ESRI_104112: {
        towgs84: "-185.583,-230.096,281.361"
    },
    ESRI_104113: {
        towgs84: "25.1,-275.6,222.6"
    },
    IGNF_WGS72G: {
        towgs84: "0,12,6"
    },
    IGNF_NTFG: {
        towgs84: "-168,-60,320"
    },
    IGNF_EFATE57G: {
        towgs84: "-127,-769,472"
    },
    IGNF_PGP50G: {
        towgs84: "324.8,153.6,172.1"
    },
    IGNF_REUN47G: {
        towgs84: "94,-948,-1262"
    },
    IGNF_CSG67G: {
        towgs84: "-186,230,110"
    },
    IGNF_GUAD48G: {
        towgs84: "-467,-16,-300"
    },
    IGNF_TAHI51G: {
        towgs84: "162,117,154"
    },
    IGNF_TAHAAG: {
        towgs84: "65,342,77"
    },
    IGNF_NUKU72G: {
        towgs84: "84,274,65"
    },
    IGNF_PETRELS72G: {
        towgs84: "365,194,166"
    },
    IGNF_WALL78G: {
        towgs84: "253,-133,-127"
    },
    IGNF_MAYO50G: {
        towgs84: "-382,-59,-262"
    },
    IGNF_TANNAG: {
        towgs84: "-139,-967,436"
    },
    IGNF_IGN72G: {
        towgs84: "-13,-348,292"
    },
    IGNF_ATIGG: {
        towgs84: "1118,23,66"
    },
    IGNF_FANGA84G: {
        towgs84: "150.57,158.33,118.32"
    },
    IGNF_RUSAT84G: {
        towgs84: "202.13,174.6,-15.74"
    },
    IGNF_KAUE70G: {
        towgs84: "126.74,300.1,-75.49"
    },
    IGNF_MOP90G: {
        towgs84: "-10.8,-1.8,12.77"
    },
    IGNF_MHPF67G: {
        towgs84: "338.08,212.58,-296.17"
    },
    IGNF_TAHI79G: {
        towgs84: "160.61,116.05,153.69"
    },
    IGNF_ANAA92G: {
        towgs84: "1.5,3.84,4.81"
    },
    IGNF_MARQUI72G: {
        towgs84: "330.91,-13.92,58.56"
    },
    IGNF_APAT86G: {
        towgs84: "143.6,197.82,74.05"
    },
    IGNF_TUBU69G: {
        towgs84: "237.17,171.61,-77.84"
    },
    IGNF_STPM50G: {
        towgs84: "11.363,424.148,373.13"
    },
    EPSG_4150: {
        towgs84: "674.374,15.056,405.346"
    },
    EPSG_4754: {
        towgs84: "-208.4058,-109.8777,-2.5764"
    },
    ESRI_104101: {
        towgs84: "374,150,588"
    },
    EPSG_4693: {
        towgs84: "0,-0.15,0.68"
    },
    EPSG_6207: {
        towgs84: "293.17,726.18,245.36"
    },
    EPSG_4153: {
        towgs84: "-133.63,-157.5,-158.62"
    },
    EPSG_4132: {
        towgs84: "-241.54,-163.64,396.06"
    },
    EPSG_4221: {
        towgs84: "-154.5,150.7,100.4"
    },
    EPSG_4266: {
        towgs84: "-80.7,-132.5,41.1"
    },
    EPSG_4193: {
        towgs84: "-70.9,-151.8,-41.4"
    },
    EPSG_5340: {
        towgs84: "-0.41,0.46,-0.35"
    },
    EPSG_4246: {
        towgs84: "-294.7,-200.1,525.5"
    },
    EPSG_4318: {
        towgs84: "-3.2,-5.7,2.8"
    },
    EPSG_4121: {
        towgs84: "-199.87,74.79,246.62"
    },
    EPSG_4223: {
        towgs84: "-260.1,5.5,432.2"
    },
    EPSG_4158: {
        towgs84: "-0.465,372.095,171.736"
    },
    EPSG_4285: {
        towgs84: "-128.16,-282.42,21.93"
    },
    EPSG_4613: {
        towgs84: "-404.78,685.68,45.47"
    },
    EPSG_4607: {
        towgs84: "195.671,332.517,274.607"
    },
    EPSG_4475: {
        towgs84: "-381.788,-57.501,-256.673"
    },
    EPSG_4208: {
        towgs84: "-157.84,308.54,-146.6"
    },
    EPSG_4743: {
        towgs84: "70.995,-335.916,262.898"
    },
    EPSG_4710: {
        towgs84: "-323.65,551.39,-491.22"
    },
    EPSG_7881: {
        towgs84: "-0.077,0.079,0.086"
    },
    EPSG_4682: {
        towgs84: "283.729,735.942,261.143"
    },
    EPSG_4739: {
        towgs84: "-156,-271,-189"
    },
    EPSG_4679: {
        towgs84: "-80.01,253.26,291.19"
    },
    EPSG_4750: {
        towgs84: "-56.263,16.136,-22.856"
    },
    EPSG_4644: {
        towgs84: "-10.18,-350.43,291.37"
    },
    EPSG_4695: {
        towgs84: "-103.746,-9.614,-255.95"
    },
    EPSG_4292: {
        towgs84: "-355,21,72"
    },
    EPSG_4302: {
        towgs84: "-61.702,284.488,472.052"
    },
    EPSG_4143: {
        towgs84: "-124.76,53,466.79"
    },
    EPSG_4606: {
        towgs84: "-153,153,307"
    },
    EPSG_4699: {
        towgs84: "-770.1,158.4,-498.2"
    },
    EPSG_4247: {
        towgs84: "-273.5,110.6,-357.9"
    },
    EPSG_4160: {
        towgs84: "8.88,184.86,106.69"
    },
    EPSG_4161: {
        towgs84: "-233.43,6.65,173.64"
    },
    EPSG_9251: {
        towgs84: "-9.5,122.9,138.2"
    },
    EPSG_9253: {
        towgs84: "-78.1,101.6,133.3"
    },
    EPSG_4297: {
        towgs84: "-198.383,-240.517,-107.909"
    },
    EPSG_4269: {
        towgs84: "0,0,0"
    },
    EPSG_4301: {
        towgs84: "-147,506,687"
    },
    EPSG_4618: {
        towgs84: "-59,-11,-52"
    },
    EPSG_4612: {
        towgs84: "0,0,0"
    },
    EPSG_4678: {
        towgs84: "44.585,-131.212,-39.544"
    },
    EPSG_4250: {
        towgs84: "-130,29,364"
    },
    EPSG_4144: {
        towgs84: "214,804,268"
    },
    EPSG_4147: {
        towgs84: "-17.51,-108.32,-62.39"
    },
    EPSG_4259: {
        towgs84: "-254.1,-5.36,-100.29"
    },
    EPSG_4164: {
        towgs84: "-76,-138,67"
    },
    EPSG_4211: {
        towgs84: "-378.873,676.002,-46.255"
    },
    EPSG_4182: {
        towgs84: "-422.651,-172.995,84.02"
    },
    EPSG_4224: {
        towgs84: "-143.87,243.37,-33.52"
    },
    EPSG_4225: {
        towgs84: "-205.57,168.77,-4.12"
    },
    EPSG_5527: {
        towgs84: "-67.35,3.88,-38.22"
    },
    EPSG_4752: {
        towgs84: "98,390,-22"
    },
    EPSG_4310: {
        towgs84: "-30,190,89"
    },
    EPSG_9248: {
        towgs84: "-192.26,65.72,132.08"
    },
    EPSG_4680: {
        towgs84: "124.5,-63.5,-281"
    },
    EPSG_4701: {
        towgs84: "-79.9,-158,-168.9"
    },
    EPSG_4706: {
        towgs84: "-146.21,112.63,4.05"
    },
    EPSG_4805: {
        towgs84: "682,-203,480"
    },
    EPSG_4201: {
        towgs84: "-165,-11,206"
    },
    EPSG_4210: {
        towgs84: "-157,-2,-299"
    },
    EPSG_4183: {
        towgs84: "-104,167,-38"
    },
    EPSG_4139: {
        towgs84: "11,72,-101"
    },
    EPSG_4668: {
        towgs84: "-86,-98,-119"
    },
    EPSG_4717: {
        towgs84: "-2,151,181"
    },
    EPSG_4732: {
        towgs84: "102,52,-38"
    },
    EPSG_4280: {
        towgs84: "-377,681,-50"
    },
    EPSG_4209: {
        towgs84: "-138,-105,-289"
    },
    EPSG_4261: {
        towgs84: "31,146,47"
    },
    EPSG_4658: {
        towgs84: "-73,46,-86"
    },
    EPSG_4721: {
        towgs84: "265.025,384.929,-194.046"
    },
    EPSG_4222: {
        towgs84: "-136,-108,-292"
    },
    EPSG_4601: {
        towgs84: "-255,-15,71"
    },
    EPSG_4602: {
        towgs84: "725,685,536"
    },
    EPSG_4603: {
        towgs84: "72,213.7,93"
    },
    EPSG_4605: {
        towgs84: "9,183,236"
    },
    EPSG_4621: {
        towgs84: "137,248,-430"
    },
    EPSG_4657: {
        towgs84: "-28,199,5"
    },
    EPSG_4316: {
        towgs84: "103.25,-100.4,-307.19"
    },
    EPSG_4642: {
        towgs84: "-13,-348,292"
    },
    EPSG_4698: {
        towgs84: "145,-187,103"
    },
    EPSG_4192: {
        towgs84: "-206.1,-174.7,-87.7"
    },
    EPSG_4311: {
        towgs84: "-265,120,-358"
    },
    EPSG_4135: {
        towgs84: "58,-283,-182"
    },
    ESRI_104138: {
        towgs84: "198,-226,-347"
    },
    EPSG_4245: {
        towgs84: "-11,851,5"
    },
    EPSG_4142: {
        towgs84: "-125,53,467"
    },
    EPSG_4213: {
        towgs84: "-106,-87,188"
    },
    EPSG_4253: {
        towgs84: "-133,-77,-51"
    },
    EPSG_4129: {
        towgs84: "-132,-110,-335"
    },
    EPSG_4713: {
        towgs84: "-77,-128,142"
    },
    EPSG_4239: {
        towgs84: "217,823,299"
    },
    EPSG_4146: {
        towgs84: "295,736,257"
    },
    EPSG_4155: {
        towgs84: "-83,37,124"
    },
    EPSG_4165: {
        towgs84: "-173,253,27"
    },
    EPSG_4672: {
        towgs84: "175,-38,113"
    },
    EPSG_4236: {
        towgs84: "-637,-549,-203"
    },
    EPSG_4251: {
        towgs84: "-90,40,88"
    },
    EPSG_4271: {
        towgs84: "-2,374,172"
    },
    EPSG_4175: {
        towgs84: "-88,4,101"
    },
    EPSG_4716: {
        towgs84: "298,-304,-375"
    },
    EPSG_4315: {
        towgs84: "-23,259,-9"
    },
    EPSG_4744: {
        towgs84: "-242.2,-144.9,370.3"
    },
    EPSG_4244: {
        towgs84: "-97,787,86"
    },
    EPSG_4293: {
        towgs84: "616,97,-251"
    },
    EPSG_4714: {
        towgs84: "-127,-769,472"
    },
    EPSG_4736: {
        towgs84: "260,12,-147"
    },
    EPSG_6883: {
        towgs84: "-235,-110,393"
    },
    EPSG_6894: {
        towgs84: "-63,176,185"
    },
    EPSG_4205: {
        towgs84: "-43,-163,45"
    },
    EPSG_4256: {
        towgs84: "41,-220,-134"
    },
    EPSG_4262: {
        towgs84: "639,405,60"
    },
    EPSG_4604: {
        towgs84: "174,359,365"
    },
    EPSG_4169: {
        towgs84: "-115,118,426"
    },
    EPSG_4620: {
        towgs84: "-106,-129,165"
    },
    EPSG_4184: {
        towgs84: "-203,141,53"
    },
    EPSG_4616: {
        towgs84: "-289,-124,60"
    },
    EPSG_9403: {
        towgs84: "-307,-92,127"
    },
    EPSG_4684: {
        towgs84: "-133,-321,50"
    },
    EPSG_4708: {
        towgs84: "-491,-22,435"
    },
    EPSG_4707: {
        towgs84: "114,-116,-333"
    },
    EPSG_4709: {
        towgs84: "145,75,-272"
    },
    EPSG_4712: {
        towgs84: "-205,107,53"
    },
    EPSG_4711: {
        towgs84: "124,-234,-25"
    },
    EPSG_4718: {
        towgs84: "230,-199,-752"
    },
    EPSG_4719: {
        towgs84: "211,147,111"
    },
    EPSG_4724: {
        towgs84: "208,-435,-229"
    },
    EPSG_4725: {
        towgs84: "189,-79,-202"
    },
    EPSG_4735: {
        towgs84: "647,1777,-1124"
    },
    EPSG_4722: {
        towgs84: "-794,119,-298"
    },
    EPSG_4728: {
        towgs84: "-307,-92,127"
    },
    EPSG_4734: {
        towgs84: "-632,438,-609"
    },
    EPSG_4727: {
        towgs84: "912,-58,1227"
    },
    EPSG_4729: {
        towgs84: "185,165,42"
    },
    EPSG_4730: {
        towgs84: "170,42,84"
    },
    EPSG_4733: {
        towgs84: "276,-57,149"
    },
    ESRI_37218: {
        towgs84: "230,-199,-752"
    },
    ESRI_37240: {
        towgs84: "-7,215,225"
    },
    ESRI_37221: {
        towgs84: "252,-209,-751"
    },
    ESRI_4305: {
        towgs84: "-123,-206,219"
    },
    ESRI_104139: {
        towgs84: "-73,-247,227"
    },
    EPSG_4748: {
        towgs84: "51,391,-36"
    },
    EPSG_4219: {
        towgs84: "-384,664,-48"
    },
    EPSG_4255: {
        towgs84: "-333,-222,114"
    },
    EPSG_4257: {
        towgs84: "-587.8,519.75,145.76"
    },
    EPSG_4646: {
        towgs84: "-963,510,-359"
    },
    EPSG_6881: {
        towgs84: "-24,-203,268"
    },
    EPSG_6882: {
        towgs84: "-183,-15,273"
    },
    EPSG_4715: {
        towgs84: "-104,-129,239"
    },
    IGNF_RGF93GDD: {
        towgs84: "0,0,0"
    },
    IGNF_RGM04GDD: {
        towgs84: "0,0,0"
    },
    IGNF_RGSPM06GDD: {
        towgs84: "0,0,0"
    },
    IGNF_RGTAAF07GDD: {
        towgs84: "0,0,0"
    },
    IGNF_RGFG95GDD: {
        towgs84: "0,0,0"
    },
    IGNF_RGNCG: {
        towgs84: "0,0,0"
    },
    IGNF_RGPFGDD: {
        towgs84: "0,0,0"
    },
    IGNF_ETRS89G: {
        towgs84: "0,0,0"
    },
    IGNF_RGR92GDD: {
        towgs84: "0,0,0"
    },
    EPSG_4173: {
        towgs84: "0,0,0"
    },
    EPSG_4180: {
        towgs84: "0,0,0"
    },
    EPSG_4619: {
        towgs84: "0,0,0"
    },
    EPSG_4667: {
        towgs84: "0,0,0"
    },
    EPSG_4075: {
        towgs84: "0,0,0"
    },
    EPSG_6706: {
        towgs84: "0,0,0"
    },
    EPSG_7798: {
        towgs84: "0,0,0"
    },
    EPSG_4661: {
        towgs84: "0,0,0"
    },
    EPSG_4669: {
        towgs84: "0,0,0"
    },
    EPSG_8685: {
        towgs84: "0,0,0"
    },
    EPSG_4151: {
        towgs84: "0,0,0"
    },
    EPSG_9702: {
        towgs84: "0,0,0"
    },
    EPSG_4758: {
        towgs84: "0,0,0"
    },
    EPSG_4761: {
        towgs84: "0,0,0"
    },
    EPSG_4765: {
        towgs84: "0,0,0"
    },
    EPSG_8997: {
        towgs84: "0,0,0"
    },
    EPSG_4023: {
        towgs84: "0,0,0"
    },
    EPSG_4670: {
        towgs84: "0,0,0"
    },
    EPSG_4694: {
        towgs84: "0,0,0"
    },
    EPSG_4148: {
        towgs84: "0,0,0"
    },
    EPSG_4163: {
        towgs84: "0,0,0"
    },
    EPSG_4167: {
        towgs84: "0,0,0"
    },
    EPSG_4189: {
        towgs84: "0,0,0"
    },
    EPSG_4190: {
        towgs84: "0,0,0"
    },
    EPSG_4176: {
        towgs84: "0,0,0"
    },
    EPSG_4659: {
        towgs84: "0,0,0"
    },
    EPSG_3824: {
        towgs84: "0,0,0"
    },
    EPSG_3889: {
        towgs84: "0,0,0"
    },
    EPSG_4046: {
        towgs84: "0,0,0"
    },
    EPSG_4081: {
        towgs84: "0,0,0"
    },
    EPSG_4558: {
        towgs84: "0,0,0"
    },
    EPSG_4483: {
        towgs84: "0,0,0"
    },
    EPSG_5013: {
        towgs84: "0,0,0"
    },
    EPSG_5264: {
        towgs84: "0,0,0"
    },
    EPSG_5324: {
        towgs84: "0,0,0"
    },
    EPSG_5354: {
        towgs84: "0,0,0"
    },
    EPSG_5371: {
        towgs84: "0,0,0"
    },
    EPSG_5373: {
        towgs84: "0,0,0"
    },
    EPSG_5381: {
        towgs84: "0,0,0"
    },
    EPSG_5393: {
        towgs84: "0,0,0"
    },
    EPSG_5489: {
        towgs84: "0,0,0"
    },
    EPSG_5593: {
        towgs84: "0,0,0"
    },
    EPSG_6135: {
        towgs84: "0,0,0"
    },
    EPSG_6365: {
        towgs84: "0,0,0"
    },
    EPSG_5246: {
        towgs84: "0,0,0"
    },
    EPSG_7886: {
        towgs84: "0,0,0"
    },
    EPSG_8431: {
        towgs84: "0,0,0"
    },
    EPSG_8427: {
        towgs84: "0,0,0"
    },
    EPSG_8699: {
        towgs84: "0,0,0"
    },
    EPSG_8818: {
        towgs84: "0,0,0"
    },
    EPSG_4757: {
        towgs84: "0,0,0"
    },
    EPSG_9140: {
        towgs84: "0,0,0"
    },
    EPSG_8086: {
        towgs84: "0,0,0"
    },
    EPSG_4686: {
        towgs84: "0,0,0"
    },
    EPSG_4737: {
        towgs84: "0,0,0"
    },
    EPSG_4702: {
        towgs84: "0,0,0"
    },
    EPSG_4747: {
        towgs84: "0,0,0"
    },
    EPSG_4749: {
        towgs84: "0,0,0"
    },
    EPSG_4674: {
        towgs84: "0,0,0"
    },
    EPSG_4755: {
        towgs84: "0,0,0"
    },
    EPSG_4759: {
        towgs84: "0,0,0"
    },
    EPSG_4762: {
        towgs84: "0,0,0"
    },
    EPSG_4763: {
        towgs84: "0,0,0"
    },
    EPSG_4764: {
        towgs84: "0,0,0"
    },
    EPSG_4166: {
        towgs84: "0,0,0"
    },
    EPSG_4170: {
        towgs84: "0,0,0"
    },
    EPSG_5546: {
        towgs84: "0,0,0"
    },
    EPSG_7844: {
        towgs84: "0,0,0"
    },
    EPSG_4818: {
        towgs84: "589,76,480"
    }
};
for(var $4b9c37234a8f7847$var$key in $4b9c37234a8f7847$var$datums){
    var $4b9c37234a8f7847$var$datum = $4b9c37234a8f7847$var$datums[$4b9c37234a8f7847$var$key];
    if (!$4b9c37234a8f7847$var$datum.datumName) continue;
    $4b9c37234a8f7847$var$datums[$4b9c37234a8f7847$var$datum.datumName] = $4b9c37234a8f7847$var$datum;
}
var $4b9c37234a8f7847$export$2e2bcd8739ae039 = $4b9c37234a8f7847$var$datums;



var $jVGH7 = parcelRequire("jVGH7");
function $595047770f54700b$var$datum(datumCode, datum_params, a, b, es, ep2, nadgrids) {
    var out = {};
    if (datumCode === undefined || datumCode === "none") out.datum_type = (0, $jVGH7.PJD_NODATUM);
    else out.datum_type = (0, $jVGH7.PJD_WGS84);
    if (datum_params) {
        out.datum_params = datum_params.map(parseFloat);
        if (out.datum_params[0] !== 0 || out.datum_params[1] !== 0 || out.datum_params[2] !== 0) out.datum_type = (0, $jVGH7.PJD_3PARAM);
        if (out.datum_params.length > 3) {
            if (out.datum_params[3] !== 0 || out.datum_params[4] !== 0 || out.datum_params[5] !== 0 || out.datum_params[6] !== 0) {
                out.datum_type = (0, $jVGH7.PJD_7PARAM);
                out.datum_params[3] *= (0, $jVGH7.SEC_TO_RAD);
                out.datum_params[4] *= (0, $jVGH7.SEC_TO_RAD);
                out.datum_params[5] *= (0, $jVGH7.SEC_TO_RAD);
                out.datum_params[6] = out.datum_params[6] / 1000000.0 + 1.0;
            }
        }
    }
    if (nadgrids) {
        out.datum_type = (0, $jVGH7.PJD_GRIDSHIFT);
        out.grids = nadgrids;
    }
    out.a = a; // datum object also uses these values
    out.b = b;
    out.es = es;
    out.ep2 = ep2;
    return out;
}
var $595047770f54700b$export$2e2bcd8739ae039 = $595047770f54700b$var$datum;



/**
 * Resources for details of NTv2 file formats:
 * - https://web.archive.org/web/20140127204822if_/http://www.mgs.gov.on.ca:80/stdprodconsume/groups/content/@mgs/@iandit/documents/resourcelist/stel02_047447.pdf
 * - http://mimaka.com/help/gs/html/004_NTV2%20Data%20Format.htm
 */ /**
 * @typedef {Object} NadgridInfo
 * @property {string} name The name of the NAD grid or 'null' if not specified.
 * @property {boolean} mandatory Indicates if the grid is mandatory (true) or optional (false).
 * @property {*} grid The loaded NAD grid object, or null if not loaded or not applicable.
 * @property {boolean} isNull True if the grid is explicitly 'null', otherwise false.
 */ /**
 * @typedef {Object} NTV2GridOptions
 * @property {boolean} [includeErrorFields=true] Whether to include error fields in the subgrids.
 */ /**
 * @typedef {Object} NadgridHeader
 * @property {number} [nFields] Number of fields in the header.
 * @property {number} [nSubgridFields] Number of fields in each subgrid header.
 * @property {number} nSubgrids Number of subgrids in the file.
 * @property {string} [shiftType] Type of shift (e.g., "SECONDS").
 * @property {number} [fromSemiMajorAxis] Source ellipsoid semi-major axis.
 * @property {number} [fromSemiMinorAxis] Source ellipsoid semi-minor axis.
 * @property {number} [toSemiMajorAxis] Target ellipsoid semi-major axis.
 * @property {number} [toSemiMinorAxis] Target ellipsoid semi-minor axis.
 */ /**
 * @typedef {Object} Subgrid
 * @property {Array<number>} ll Lower left corner of the grid in radians [longitude, latitude].
 * @property {Array<number>} del Grid spacing in radians [longitude interval, latitude interval].
 * @property {Array<number>} lim Number of columns in the grid [longitude columns, latitude columns].
 * @property {number} [count] Total number of grid nodes.
 * @property {Array} cvs Mapped node values for the grid.
 */ /** @typedef {{header: NadgridHeader, subgrids: Array<Subgrid>}} NADGrid */ var $80595ee12d2371a9$var$loadedNadgrids = {};
function $80595ee12d2371a9$export$2e2bcd8739ae039(key, data, options) {
    if (data instanceof ArrayBuffer) return $80595ee12d2371a9$var$readNTV2Grid(key, data, options);
    return {
        ready: $80595ee12d2371a9$var$readGeotiffGrid(key, data)
    };
}
/**
 * @param {string} key The key to associate with the loaded grid.
 * @param {ArrayBuffer} data The NTv2 grid data as an ArrayBuffer.
 * @param {NTV2GridOptions} [options] Optional parameters for loading the grid.
 * @returns {NADGrid} The loaded NAD grid information.
 */ function $80595ee12d2371a9$var$readNTV2Grid(key, data, options) {
    var includeErrorFields = true;
    if (options !== undefined && options.includeErrorFields === false) includeErrorFields = false;
    var view = new DataView(data);
    var isLittleEndian = $80595ee12d2371a9$var$detectLittleEndian(view);
    var header = $80595ee12d2371a9$var$readHeader(view, isLittleEndian);
    var subgrids = $80595ee12d2371a9$var$readSubgrids(view, header, isLittleEndian, includeErrorFields);
    var nadgrid = {
        header: header,
        subgrids: subgrids
    };
    $80595ee12d2371a9$var$loadedNadgrids[key] = nadgrid;
    return nadgrid;
}
/**
 * @param {string} key The key to associate with the loaded grid.
 * @param {import('geotiff').GeoTIFF} tiff The GeoTIFF instance to read the grid from.
 * @returns {Promise<NADGrid>} A promise that resolves to the loaded NAD grid information.
 */ async function $80595ee12d2371a9$var$readGeotiffGrid(key, tiff) {
    var subgrids = [];
    var subGridCount = await tiff.getImageCount();
    // proj produced tiff grid shift files appear to organize lower res subgrids first, higher res/ child subgrids last.
    for(var subgridIndex = subGridCount - 1; subgridIndex >= 0; subgridIndex--){
        var image = await tiff.getImage(subgridIndex);
        var rasters = await image.readRasters();
        var data = rasters;
        var lim = [
            image.getWidth(),
            image.getHeight()
        ];
        var imageBBoxRadians = image.getBoundingBox().map($80595ee12d2371a9$var$degreesToRadians);
        var del = [
            image.fileDirectory.ModelPixelScale[0],
            image.fileDirectory.ModelPixelScale[1]
        ].map($80595ee12d2371a9$var$degreesToRadians);
        var maxX = imageBBoxRadians[0] + (lim[0] - 1) * del[0];
        var minY = imageBBoxRadians[3] - (lim[1] - 1) * del[1];
        var latitudeOffsetBand = data[0];
        var longitudeOffsetBand = data[1];
        var nodes = [];
        for(let i = lim[1] - 1; i >= 0; i--)for(let j = lim[0] - 1; j >= 0; j--){
            var index = i * lim[0] + j;
            nodes.push([
                -$80595ee12d2371a9$var$secondsToRadians(longitudeOffsetBand[index]),
                $80595ee12d2371a9$var$secondsToRadians(latitudeOffsetBand[index])
            ]);
        }
        subgrids.push({
            del: del,
            lim: lim,
            ll: [
                -maxX,
                minY
            ],
            cvs: nodes
        });
    }
    var tifGrid = {
        header: {
            nSubgrids: subGridCount
        },
        subgrids: subgrids
    };
    $80595ee12d2371a9$var$loadedNadgrids[key] = tifGrid;
    return tifGrid;
}
function $80595ee12d2371a9$export$31c4d9288d81329a(nadgrids) {
    // Format details: http://proj.maptools.org/gen_parms.html
    if (nadgrids === undefined) return null;
    var grids = nadgrids.split(",");
    return grids.map($80595ee12d2371a9$var$parseNadgridString);
}
/**
 * @param {string} value The nadgrid string to get information for.
 * @returns {NadgridInfo|null} An object with grid information, or null if the input is empty.
 */ function $80595ee12d2371a9$var$parseNadgridString(value) {
    if (value.length === 0) return null;
    var optional = value[0] === "@";
    if (optional) value = value.slice(1);
    if (value === "null") return {
        name: "null",
        mandatory: !optional,
        grid: null,
        isNull: true
    };
    return {
        name: value,
        mandatory: !optional,
        grid: $80595ee12d2371a9$var$loadedNadgrids[value] || null,
        isNull: false
    };
}
function $80595ee12d2371a9$var$degreesToRadians(degrees) {
    return degrees * Math.PI / 180;
}
function $80595ee12d2371a9$var$secondsToRadians(seconds) {
    return seconds / 3600 * Math.PI / 180;
}
function $80595ee12d2371a9$var$detectLittleEndian(view) {
    var nFields = view.getInt32(8, false);
    if (nFields === 11) return false;
    nFields = view.getInt32(8, true);
    if (nFields !== 11) console.warn("Failed to detect nadgrid endian-ness, defaulting to little-endian");
    return true;
}
function $80595ee12d2371a9$var$readHeader(view, isLittleEndian) {
    return {
        nFields: view.getInt32(8, isLittleEndian),
        nSubgridFields: view.getInt32(24, isLittleEndian),
        nSubgrids: view.getInt32(40, isLittleEndian),
        shiftType: $80595ee12d2371a9$var$decodeString(view, 56, 64).trim(),
        fromSemiMajorAxis: view.getFloat64(120, isLittleEndian),
        fromSemiMinorAxis: view.getFloat64(136, isLittleEndian),
        toSemiMajorAxis: view.getFloat64(152, isLittleEndian),
        toSemiMinorAxis: view.getFloat64(168, isLittleEndian)
    };
}
function $80595ee12d2371a9$var$decodeString(view, start, end) {
    return String.fromCharCode.apply(null, new Uint8Array(view.buffer.slice(start, end)));
}
function $80595ee12d2371a9$var$readSubgrids(view, header, isLittleEndian, includeErrorFields) {
    var gridOffset = 176;
    var grids = [];
    for(var i = 0; i < header.nSubgrids; i++){
        var subHeader = $80595ee12d2371a9$var$readGridHeader(view, gridOffset, isLittleEndian);
        var nodes = $80595ee12d2371a9$var$readGridNodes(view, gridOffset, subHeader, isLittleEndian, includeErrorFields);
        var lngColumnCount = Math.round(1 + (subHeader.upperLongitude - subHeader.lowerLongitude) / subHeader.longitudeInterval);
        var latColumnCount = Math.round(1 + (subHeader.upperLatitude - subHeader.lowerLatitude) / subHeader.latitudeInterval);
        // Proj4 operates on radians whereas the coordinates are in seconds in the grid
        grids.push({
            ll: [
                $80595ee12d2371a9$var$secondsToRadians(subHeader.lowerLongitude),
                $80595ee12d2371a9$var$secondsToRadians(subHeader.lowerLatitude)
            ],
            del: [
                $80595ee12d2371a9$var$secondsToRadians(subHeader.longitudeInterval),
                $80595ee12d2371a9$var$secondsToRadians(subHeader.latitudeInterval)
            ],
            lim: [
                lngColumnCount,
                latColumnCount
            ],
            count: subHeader.gridNodeCount,
            cvs: $80595ee12d2371a9$var$mapNodes(nodes)
        });
        var rowSize = 16;
        if (includeErrorFields === false) rowSize = 8;
        gridOffset += 176 + subHeader.gridNodeCount * rowSize;
    }
    return grids;
}
/**
 * @param {*} nodes
 * @returns Array<Array<number>>
 */ function $80595ee12d2371a9$var$mapNodes(nodes) {
    return nodes.map(function(r) {
        return [
            $80595ee12d2371a9$var$secondsToRadians(r.longitudeShift),
            $80595ee12d2371a9$var$secondsToRadians(r.latitudeShift)
        ];
    });
}
function $80595ee12d2371a9$var$readGridHeader(view, offset, isLittleEndian) {
    return {
        name: $80595ee12d2371a9$var$decodeString(view, offset + 8, offset + 16).trim(),
        parent: $80595ee12d2371a9$var$decodeString(view, offset + 24, offset + 24 + 8).trim(),
        lowerLatitude: view.getFloat64(offset + 72, isLittleEndian),
        upperLatitude: view.getFloat64(offset + 88, isLittleEndian),
        lowerLongitude: view.getFloat64(offset + 104, isLittleEndian),
        upperLongitude: view.getFloat64(offset + 120, isLittleEndian),
        latitudeInterval: view.getFloat64(offset + 136, isLittleEndian),
        longitudeInterval: view.getFloat64(offset + 152, isLittleEndian),
        gridNodeCount: view.getInt32(offset + 168, isLittleEndian)
    };
}
function $80595ee12d2371a9$var$readGridNodes(view, offset, gridHeader, isLittleEndian, includeErrorFields) {
    var nodesOffset = offset + 176;
    var gridRecordLength = 16;
    if (includeErrorFields === false) gridRecordLength = 8;
    var gridShiftRecords = [];
    for(var i = 0; i < gridHeader.gridNodeCount; i++){
        var record = {
            latitudeShift: view.getFloat32(nodesOffset + i * gridRecordLength, isLittleEndian),
            longitudeShift: view.getFloat32(nodesOffset + i * gridRecordLength + 4, isLittleEndian)
        };
        if (includeErrorFields !== false) {
            record.latitudeAccuracy = view.getFloat32(nodesOffset + i * gridRecordLength + 8, isLittleEndian);
            record.longitudeAccuracy = view.getFloat32(nodesOffset + i * gridRecordLength + 12, isLittleEndian);
        }
        gridShiftRecords.push(record);
    }
    return gridShiftRecords;
}


/**
 * @typedef {Object} DatumDefinition
 * @property {number} datum_type - The type of datum.
 * @property {number} a - Semi-major axis of the ellipsoid.
 * @property {number} b - Semi-minor axis of the ellipsoid.
 * @property {number} es - Eccentricity squared of the ellipsoid.
 * @property {number} ep2 - Second eccentricity squared of the ellipsoid.
 */ /**
 * @param {string | import('./core').PROJJSONDefinition | import('./defs').ProjectionDefinition} srsCode
 * @param {(errorMessage?: string, instance?: Projection) => void} [callback]
 */ function $52991e6d5af7834c$var$Projection(srsCode, callback) {
    if (!(this instanceof $52991e6d5af7834c$var$Projection)) return new $52991e6d5af7834c$var$Projection(srsCode);
    /** @type {<T extends import('./core').TemplateCoordinates>(coordinates: T, enforceAxis?: boolean) => T} */ this.forward = null;
    /** @type {<T extends import('./core').TemplateCoordinates>(coordinates: T, enforceAxis?: boolean) => T} */ this.inverse = null;
    /** @type {string} */ this.name;
    /** @type {string} */ this.title;
    callback = callback || function(error) {
        if (error) throw error;
    };
    var json = (0, $29542401062aff13$export$2e2bcd8739ae039)(srsCode);
    if (typeof json !== "object") {
        callback("Could not parse to valid json: " + srsCode);
        return;
    }
    var ourProj = $52991e6d5af7834c$var$Projection.projections.get(json.projName);
    if (!ourProj) {
        callback("Could not get projection name from: " + srsCode);
        return;
    }
    if (json.datumCode && json.datumCode !== "none") {
        var datumDef = (0, $aca64ceea23ffc2c$export$2e2bcd8739ae039)((0, $4b9c37234a8f7847$export$2e2bcd8739ae039), json.datumCode);
        if (datumDef) {
            json.datum_params = json.datum_params || (datumDef.towgs84 ? datumDef.towgs84.split(",") : null);
            json.ellps = datumDef.ellipse;
            json.datumName = datumDef.datumName ? datumDef.datumName : json.datumCode;
        }
    }
    json.k0 = json.k0 || 1.0;
    json.axis = json.axis || "enu";
    json.ellps = json.ellps || "wgs84";
    json.lat1 = json.lat1 || json.lat0; // Lambert_Conformal_Conic_1SP, for example, needs this
    var sphere_ = (0, $be456f43e089118b$export$b2690196de52b050)(json.a, json.b, json.rf, json.ellps, json.sphere);
    var ecc = (0, $be456f43e089118b$export$e3d7bf2ed2a7479f)(sphere_.a, sphere_.b, sphere_.rf, json.R_A);
    var nadgrids = (0, $80595ee12d2371a9$export$31c4d9288d81329a)(json.nadgrids);
    /** @type {DatumDefinition} */ var datumObj = json.datum || (0, $595047770f54700b$export$2e2bcd8739ae039)(json.datumCode, json.datum_params, sphere_.a, sphere_.b, ecc.es, ecc.ep2, nadgrids);
    (0, $fcc7caaddb728552$export$2e2bcd8739ae039)(this, json); // transfer everything over from the projection because we don't know what we'll need
    (0, $fcc7caaddb728552$export$2e2bcd8739ae039)(this, ourProj); // transfer all the methods from the projection
    // copy the 4 things over we calculated in deriveConstants.sphere
    this.a = sphere_.a;
    this.b = sphere_.b;
    this.rf = sphere_.rf;
    this.sphere = sphere_.sphere;
    // copy the 3 things we calculated in deriveConstants.eccentricity
    this.es = ecc.es;
    this.e = ecc.e;
    this.ep2 = ecc.ep2;
    // add in the datum object
    this.datum = datumObj;
    // init the projection
    if ("init" in this && typeof this.init === "function") this.init();
    // legecy callback from back in the day when it went to spatialreference.org
    callback(null, this);
}
$52991e6d5af7834c$var$Projection.projections = (0, $0e1d3f1fd830d3be$export$2e2bcd8739ae039);
$52991e6d5af7834c$var$Projection.projections.start();
var $52991e6d5af7834c$export$2e2bcd8739ae039 = $52991e6d5af7834c$var$Projection;



var $jVGH7 = parcelRequire("jVGH7");

var $jVGH7 = parcelRequire("jVGH7");

var $jVGH7 = parcelRequire("jVGH7");
"use strict";
function $28350e6d07d8320b$export$68c8d8590fbb24e4(source, dest) {
    if (source.datum_type !== dest.datum_type) return false; // false, datums are not equal
    else if (source.a !== dest.a || Math.abs(source.es - dest.es) > 0.000000000050) // the tolerance for es is to ensure that GRS80 and WGS84
    // are considered identical
    return false;
    else if (source.datum_type === (0, $jVGH7.PJD_3PARAM)) return source.datum_params[0] === dest.datum_params[0] && source.datum_params[1] === dest.datum_params[1] && source.datum_params[2] === dest.datum_params[2];
    else if (source.datum_type === (0, $jVGH7.PJD_7PARAM)) return source.datum_params[0] === dest.datum_params[0] && source.datum_params[1] === dest.datum_params[1] && source.datum_params[2] === dest.datum_params[2] && source.datum_params[3] === dest.datum_params[3] && source.datum_params[4] === dest.datum_params[4] && source.datum_params[5] === dest.datum_params[5] && source.datum_params[6] === dest.datum_params[6];
    else return true; // datums are equal
} // cs_compare_datums()
function $28350e6d07d8320b$export$4a4ae2976f9a808a(p, es, a) {
    var Longitude = p.x;
    var Latitude = p.y;
    var Height = p.z ? p.z : 0; // Z value not always supplied
    var Rn; /*  Earth radius at location  */ 
    var Sin_Lat; /*  Math.sin(Latitude)  */ 
    var Sin2_Lat; /*  Square of Math.sin(Latitude)  */ 
    var Cos_Lat; /*  Math.cos(Latitude)  */ 
    /*
   ** Don't blow up if Latitude is just a little out of the value
   ** range as it may just be a rounding issue.  Also removed longitude
   ** test, it should be wrapped by Math.cos() and Math.sin().  NFW for PROJ.4, Sep/2001.
   */ if (Latitude < -(0, $jVGH7.HALF_PI) && Latitude > -1.001 * (0, $jVGH7.HALF_PI)) Latitude = -(0, $jVGH7.HALF_PI);
    else if (Latitude > (0, $jVGH7.HALF_PI) && Latitude < 1.001 * (0, $jVGH7.HALF_PI)) Latitude = (0, $jVGH7.HALF_PI);
    else if (Latitude < -(0, $jVGH7.HALF_PI)) /* Latitude out of range */ // ..reportError('geocent:lat out of range:' + Latitude);
    return {
        x: -Infinity,
        y: -Infinity,
        z: p.z
    };
    else if (Latitude > (0, $jVGH7.HALF_PI)) /* Latitude out of range */ return {
        x: Infinity,
        y: Infinity,
        z: p.z
    };
    if (Longitude > Math.PI) Longitude -= 2 * Math.PI;
    Sin_Lat = Math.sin(Latitude);
    Cos_Lat = Math.cos(Latitude);
    Sin2_Lat = Sin_Lat * Sin_Lat;
    Rn = a / Math.sqrt(1.0e0 - es * Sin2_Lat);
    return {
        x: (Rn + Height) * Cos_Lat * Math.cos(Longitude),
        y: (Rn + Height) * Cos_Lat * Math.sin(Longitude),
        z: (Rn * (1 - es) + Height) * Sin_Lat
    };
} // cs_geodetic_to_geocentric()
function $28350e6d07d8320b$export$26210192c8922750(p, es, a, b) {
    /* local defintions and variables */ /* end-criterium of loop, accuracy of sin(Latitude) */ var genau = 1e-12;
    var genau2 = genau * genau;
    var maxiter = 30;
    var P; /* distance between semi-minor axis and location */ 
    var RR; /* distance between center and location */ 
    var CT; /* sin of geocentric latitude */ 
    var ST; /* cos of geocentric latitude */ 
    var RX;
    var RK;
    var RN; /* Earth radius at location */ 
    var CPHI0; /* cos of start or old geodetic latitude in iterations */ 
    var SPHI0; /* sin of start or old geodetic latitude in iterations */ 
    var CPHI; /* cos of searched geodetic latitude */ 
    var SPHI; /* sin of searched geodetic latitude */ 
    var SDPHI; /* end-criterium: addition-theorem of sin(Latitude(iter)-Latitude(iter-1)) */ 
    var iter; /* # of continous iteration, max. 30 is always enough (s.a.) */ 
    var X = p.x;
    var Y = p.y;
    var Z = p.z ? p.z : 0.0; // Z value not always supplied
    var Longitude;
    var Latitude;
    var Height;
    P = Math.sqrt(X * X + Y * Y);
    RR = Math.sqrt(X * X + Y * Y + Z * Z);
    /*      special cases for latitude and longitude */ if (P / a < genau) {
        /*  special case, if P=0. (X=0., Y=0.) */ Longitude = 0.0;
        /*  if (X,Y,Z)=(0.,0.,0.) then Height becomes semi-minor axis
     *  of ellipsoid (=center of mass), Latitude becomes PI/2 */ if (RR / a < genau) {
            Latitude = (0, $jVGH7.HALF_PI);
            Height = -b;
            return {
                x: p.x,
                y: p.y,
                z: p.z
            };
        }
    } else /*  ellipsoidal (geodetic) longitude
     *  interval: -PI < Longitude <= +PI */ Longitude = Math.atan2(Y, X);
    /* --------------------------------------------------------------
   * Following iterative algorithm was developped by
   * "Institut for Erdmessung", University of Hannover, July 1988.
   * Internet: www.ife.uni-hannover.de
   * Iterative computation of CPHI,SPHI and Height.
   * Iteration of CPHI and SPHI to 10**-12 radian resp.
   * 2*10**-7 arcsec.
   * --------------------------------------------------------------
   */ CT = Z / RR;
    ST = P / RR;
    RX = 1.0 / Math.sqrt(1.0 - es * (2.0 - es) * ST * ST);
    CPHI0 = ST * (1.0 - es) * RX;
    SPHI0 = CT * RX;
    iter = 0;
    /* loop to find sin(Latitude) resp. Latitude
   * until |sin(Latitude(iter)-Latitude(iter-1))| < genau */ do {
        iter++;
        RN = a / Math.sqrt(1.0 - es * SPHI0 * SPHI0);
        /*  ellipsoidal (geodetic) height */ Height = P * CPHI0 + Z * SPHI0 - RN * (1.0 - es * SPHI0 * SPHI0);
        RK = es * RN / (RN + Height);
        RX = 1.0 / Math.sqrt(1.0 - RK * (2.0 - RK) * ST * ST);
        CPHI = ST * (1.0 - RK) * RX;
        SPHI = CT * RX;
        SDPHI = SPHI * CPHI0 - CPHI * SPHI0;
        CPHI0 = CPHI;
        SPHI0 = SPHI;
    }while (SDPHI * SDPHI > genau2 && iter < maxiter);
    /*      ellipsoidal (geodetic) latitude */ Latitude = Math.atan(SPHI / Math.abs(CPHI));
    return {
        x: Longitude,
        y: Latitude,
        z: Height
    };
} // cs_geocentric_to_geodetic()
function $28350e6d07d8320b$export$d18952b9ecb47c8f(p, datum_type, datum_params) {
    if (datum_type === (0, $jVGH7.PJD_3PARAM)) // if( x[io] === HUGE_VAL )
    //    continue;
    return {
        x: p.x + datum_params[0],
        y: p.y + datum_params[1],
        z: p.z + datum_params[2]
    };
    else if (datum_type === (0, $jVGH7.PJD_7PARAM)) {
        var Dx_BF = datum_params[0];
        var Dy_BF = datum_params[1];
        var Dz_BF = datum_params[2];
        var Rx_BF = datum_params[3];
        var Ry_BF = datum_params[4];
        var Rz_BF = datum_params[5];
        var M_BF = datum_params[6];
        // if( x[io] === HUGE_VAL )
        //    continue;
        return {
            x: M_BF * (p.x - Rz_BF * p.y + Ry_BF * p.z) + Dx_BF,
            y: M_BF * (Rz_BF * p.x + p.y - Rx_BF * p.z) + Dy_BF,
            z: M_BF * (-Ry_BF * p.x + Rx_BF * p.y + p.z) + Dz_BF
        };
    }
} // cs_geocentric_to_wgs84
function $28350e6d07d8320b$export$2b744ad521e7ac0b(p, datum_type, datum_params) {
    if (datum_type === (0, $jVGH7.PJD_3PARAM)) // if( x[io] === HUGE_VAL )
    //    continue;
    return {
        x: p.x - datum_params[0],
        y: p.y - datum_params[1],
        z: p.z - datum_params[2]
    };
    else if (datum_type === (0, $jVGH7.PJD_7PARAM)) {
        var Dx_BF = datum_params[0];
        var Dy_BF = datum_params[1];
        var Dz_BF = datum_params[2];
        var Rx_BF = datum_params[3];
        var Ry_BF = datum_params[4];
        var Rz_BF = datum_params[5];
        var M_BF = datum_params[6];
        var x_tmp = (p.x - Dx_BF) / M_BF;
        var y_tmp = (p.y - Dy_BF) / M_BF;
        var z_tmp = (p.z - Dz_BF) / M_BF;
        // if( x[io] === HUGE_VAL )
        //    continue;
        return {
            x: x_tmp + Rz_BF * y_tmp - Ry_BF * z_tmp,
            y: -Rz_BF * x_tmp + y_tmp + Rx_BF * z_tmp,
            z: Ry_BF * x_tmp - Rx_BF * y_tmp + z_tmp
        };
    } // cs_geocentric_from_wgs84()
}



var $186WS = parcelRequire("186WS");
function $11d283fe633f71f8$var$checkParams(type) {
    return type === (0, $jVGH7.PJD_3PARAM) || type === (0, $jVGH7.PJD_7PARAM);
}
function $11d283fe633f71f8$export$2e2bcd8739ae039(source, dest, point) {
    // Short cut if the datums are identical.
    if ((0, $28350e6d07d8320b$export$68c8d8590fbb24e4)(source, dest)) return point; // in this case, zero is sucess,
    // Explicitly skip datum transform by setting 'datum=none' as parameter for either source or dest
    if (source.datum_type === (0, $jVGH7.PJD_NODATUM) || dest.datum_type === (0, $jVGH7.PJD_NODATUM)) return point;
    // If this datum requires grid shifts, then apply it to geodetic coordinates.
    var source_a = source.a;
    var source_es = source.es;
    if (source.datum_type === (0, $jVGH7.PJD_GRIDSHIFT)) {
        var gridShiftCode = $11d283fe633f71f8$export$cfa06df23524576a(source, false, point);
        if (gridShiftCode !== 0) return undefined;
        source_a = (0, $jVGH7.SRS_WGS84_SEMIMAJOR);
        source_es = (0, $jVGH7.SRS_WGS84_ESQUARED);
    }
    var dest_a = dest.a;
    var dest_b = dest.b;
    var dest_es = dest.es;
    if (dest.datum_type === (0, $jVGH7.PJD_GRIDSHIFT)) {
        dest_a = (0, $jVGH7.SRS_WGS84_SEMIMAJOR);
        dest_b = (0, $jVGH7.SRS_WGS84_SEMIMINOR);
        dest_es = (0, $jVGH7.SRS_WGS84_ESQUARED);
    }
    // Do we need to go through geocentric coordinates?
    if (source_es === dest_es && source_a === dest_a && !$11d283fe633f71f8$var$checkParams(source.datum_type) && !$11d283fe633f71f8$var$checkParams(dest.datum_type)) return point;
    // Convert to geocentric coordinates.
    point = (0, $28350e6d07d8320b$export$4a4ae2976f9a808a)(point, source_es, source_a);
    // Convert between datums
    if ($11d283fe633f71f8$var$checkParams(source.datum_type)) point = (0, $28350e6d07d8320b$export$d18952b9ecb47c8f)(point, source.datum_type, source.datum_params);
    if ($11d283fe633f71f8$var$checkParams(dest.datum_type)) point = (0, $28350e6d07d8320b$export$2b744ad521e7ac0b)(point, dest.datum_type, dest.datum_params);
    point = (0, $28350e6d07d8320b$export$26210192c8922750)(point, dest_es, dest_a, dest_b);
    if (dest.datum_type === (0, $jVGH7.PJD_GRIDSHIFT)) {
        var destGridShiftResult = $11d283fe633f71f8$export$cfa06df23524576a(dest, true, point);
        if (destGridShiftResult !== 0) return undefined;
    }
    return point;
}
function $11d283fe633f71f8$export$cfa06df23524576a(source, inverse, point) {
    if (source.grids === null || source.grids.length === 0) {
        console.log("Grid shift grids not found");
        return -1;
    }
    var input = {
        x: -point.x,
        y: point.y
    };
    var output = {
        x: Number.NaN,
        y: Number.NaN
    };
    var attemptedGrids = [];
    outer: for(var i = 0; i < source.grids.length; i++){
        var grid = source.grids[i];
        attemptedGrids.push(grid.name);
        if (grid.isNull) {
            output = input;
            break;
        }
        if (grid.grid === null) {
            if (grid.mandatory) {
                console.log("Unable to find mandatory grid '" + grid.name + "'");
                return -1;
            }
            continue;
        }
        var subgrids = grid.grid.subgrids;
        for(var j = 0, jj = subgrids.length; j < jj; j++){
            var subgrid = subgrids[j];
            // skip tables that don't match our point at all
            var epsilon = (Math.abs(subgrid.del[1]) + Math.abs(subgrid.del[0])) / 10000.0;
            var minX = subgrid.ll[0] - epsilon;
            var minY = subgrid.ll[1] - epsilon;
            var maxX = subgrid.ll[0] + (subgrid.lim[0] - 1) * subgrid.del[0] + epsilon;
            var maxY = subgrid.ll[1] + (subgrid.lim[1] - 1) * subgrid.del[1] + epsilon;
            if (minY > input.y || minX > input.x || maxY < input.y || maxX < input.x) continue;
            output = $11d283fe633f71f8$var$applySubgridShift(input, inverse, subgrid);
            if (!isNaN(output.x)) break outer;
        }
    }
    if (isNaN(output.x)) {
        console.log("Failed to find a grid shift table for location '" + -input.x * (0, $jVGH7.R2D) + " " + input.y * (0, $jVGH7.R2D) + " tried: '" + attemptedGrids + "'");
        return -1;
    }
    point.x = -output.x;
    point.y = output.y;
    return 0;
}
function $11d283fe633f71f8$var$applySubgridShift(pin, inverse, ct) {
    var val = {
        x: Number.NaN,
        y: Number.NaN
    };
    if (isNaN(pin.x)) return val;
    var tb = {
        x: pin.x,
        y: pin.y
    };
    tb.x -= ct.ll[0];
    tb.y -= ct.ll[1];
    tb.x = (0, $186WS.default)(tb.x - Math.PI) + Math.PI;
    var t = $11d283fe633f71f8$var$nadInterpolate(tb, ct);
    if (inverse) {
        if (isNaN(t.x)) return val;
        t.x = tb.x - t.x;
        t.y = tb.y - t.y;
        var i = 9, tol = 1e-12;
        var dif, del;
        do {
            del = $11d283fe633f71f8$var$nadInterpolate(t, ct);
            if (isNaN(del.x)) {
                console.log("Inverse grid shift iteration failed, presumably at grid edge.  Using first approximation.");
                break;
            }
            dif = {
                x: tb.x - (del.x + t.x),
                y: tb.y - (del.y + t.y)
            };
            t.x += dif.x;
            t.y += dif.y;
        }while (i-- && Math.abs(dif.x) > tol && Math.abs(dif.y) > tol);
        if (i < 0) {
            console.log("Inverse grid shift iterator failed to converge.");
            return val;
        }
        val.x = (0, $186WS.default)(t.x + ct.ll[0]);
        val.y = t.y + ct.ll[1];
    } else if (!isNaN(t.x)) {
        val.x = pin.x + t.x;
        val.y = pin.y + t.y;
    }
    return val;
}
function $11d283fe633f71f8$var$nadInterpolate(pin, ct) {
    var t = {
        x: pin.x / ct.del[0],
        y: pin.y / ct.del[1]
    };
    var indx = {
        x: Math.floor(t.x),
        y: Math.floor(t.y)
    };
    var frct = {
        x: t.x - 1.0 * indx.x,
        y: t.y - 1.0 * indx.y
    };
    var val = {
        x: Number.NaN,
        y: Number.NaN
    };
    var inx;
    if (indx.x < 0 || indx.x >= ct.lim[0]) return val;
    if (indx.y < 0 || indx.y >= ct.lim[1]) return val;
    inx = indx.y * ct.lim[0] + indx.x;
    var f00 = {
        x: ct.cvs[inx][0],
        y: ct.cvs[inx][1]
    };
    inx++;
    var f10 = {
        x: ct.cvs[inx][0],
        y: ct.cvs[inx][1]
    };
    inx += ct.lim[0];
    var f11 = {
        x: ct.cvs[inx][0],
        y: ct.cvs[inx][1]
    };
    inx--;
    var f01 = {
        x: ct.cvs[inx][0],
        y: ct.cvs[inx][1]
    };
    var m11 = frct.x * frct.y, m10 = frct.x * (1.0 - frct.y), m00 = (1.0 - frct.x) * (1.0 - frct.y), m01 = (1.0 - frct.x) * frct.y;
    val.x = m00 * f00.x + m10 * f10.x + m01 * f01.x + m11 * f11.x;
    val.y = m00 * f00.y + m10 * f10.y + m01 * f01.y + m11 * f11.y;
    return val;
}


function $33930746129bc9d8$export$2e2bcd8739ae039(crs, denorm, point) {
    var xin = point.x, yin = point.y, zin = point.z || 0.0;
    var v, t, i;
    /** @type {import("./core").InterfaceCoordinates} */ var out = {};
    for(i = 0; i < 3; i++){
        if (denorm && i === 2 && point.z === undefined) continue;
        if (i === 0) {
            v = xin;
            if ("ew".indexOf(crs.axis[i]) !== -1) t = "x";
            else t = "y";
        } else if (i === 1) {
            v = yin;
            if ("ns".indexOf(crs.axis[i]) !== -1) t = "y";
            else t = "x";
        } else {
            v = zin;
            t = "z";
        }
        switch(crs.axis[i]){
            case "e":
                out[t] = v;
                break;
            case "w":
                out[t] = -v;
                break;
            case "n":
                out[t] = v;
                break;
            case "s":
                out[t] = -v;
                break;
            case "u":
                if (point[t] !== undefined) out.z = v;
                break;
            case "d":
                if (point[t] !== undefined) out.z = -v;
                break;
            default:
                // console.log("ERROR: unknow axis ("+crs.axis[i]+") - check definition of "+crs.projName);
                return null;
        }
    }
    return out;
}



/**
 * @param {Array<number>} array
 * @returns {import("../core").InterfaceCoordinates}
 */ function $f096975591849c79$export$2e2bcd8739ae039(array) {
    var out = {
        x: array[0],
        y: array[1]
    };
    if (array.length > 2) out.z = array[2];
    if (array.length > 3) out.m = array[3];
    return out;
}


function $e79af69ac85143a0$export$2e2bcd8739ae039(point) {
    $e79af69ac85143a0$var$checkCoord(point.x);
    $e79af69ac85143a0$var$checkCoord(point.y);
}
function $e79af69ac85143a0$var$checkCoord(num) {
    if (typeof Number.isFinite === "function") {
        if (Number.isFinite(num)) return;
        throw new TypeError("coordinates must be finite numbers");
    }
    if (typeof num !== "number" || num !== num || !isFinite(num)) throw new TypeError("coordinates must be finite numbers");
}


function $a485f78aa3c84bef$var$checkNotWGS(source, dest) {
    return (source.datum.datum_type === (0, $jVGH7.PJD_3PARAM) || source.datum.datum_type === (0, $jVGH7.PJD_7PARAM) || source.datum.datum_type === (0, $jVGH7.PJD_GRIDSHIFT)) && dest.datumCode !== "WGS84" || (dest.datum.datum_type === (0, $jVGH7.PJD_3PARAM) || dest.datum.datum_type === (0, $jVGH7.PJD_7PARAM) || dest.datum.datum_type === (0, $jVGH7.PJD_GRIDSHIFT)) && source.datumCode !== "WGS84";
}
function $a485f78aa3c84bef$export$2e2bcd8739ae039(source, dest, point, enforceAxis) {
    var wgs84;
    if (Array.isArray(point)) point = (0, $f096975591849c79$export$2e2bcd8739ae039)(point);
    else // Clone the point object so inputs don't get modified
    point = {
        x: point.x,
        y: point.y,
        z: point.z,
        m: point.m
    };
    var hasZ = point.z !== undefined;
    (0, $e79af69ac85143a0$export$2e2bcd8739ae039)(point);
    // Workaround for datum shifts towgs84, if either source or destination projection is not wgs84
    if (source.datum && dest.datum && $a485f78aa3c84bef$var$checkNotWGS(source, dest)) {
        wgs84 = new (0, $52991e6d5af7834c$export$2e2bcd8739ae039)("WGS84");
        point = $a485f78aa3c84bef$export$2e2bcd8739ae039(source, wgs84, point, enforceAxis);
        source = wgs84;
    }
    // DGR, 2010/11/12
    if (enforceAxis && source.axis !== "enu") point = (0, $33930746129bc9d8$export$2e2bcd8739ae039)(source, false, point);
    // Transform source points to long/lat, if they aren't already.
    if (source.projName === "longlat") point = {
        x: point.x * (0, $jVGH7.D2R),
        y: point.y * (0, $jVGH7.D2R),
        z: point.z || 0
    };
    else {
        if (source.to_meter) point = {
            x: point.x * source.to_meter,
            y: point.y * source.to_meter,
            z: point.z || 0
        };
        point = source.inverse(point); // Convert Cartesian to longlat
        if (!point) return;
    }
    // Adjust for the prime meridian if necessary
    if (source.from_greenwich) point.x += source.from_greenwich;
    // Convert datums if needed, and if possible.
    point = (0, $11d283fe633f71f8$export$2e2bcd8739ae039)(source.datum, dest.datum, point);
    if (!point) return;
    /** @type {import('./core').InterfaceCoordinates} */ point;
    // Adjust for the prime meridian if necessary
    if (dest.from_greenwich) point = {
        x: point.x - dest.from_greenwich,
        y: point.y,
        z: point.z || 0
    };
    if (dest.projName === "longlat") // convert radians to decimal degrees
    point = {
        x: point.x * (0, $jVGH7.R2D),
        y: point.y * (0, $jVGH7.R2D),
        z: point.z || 0
    };
    else {
        point = dest.forward(point);
        if (dest.to_meter) point = {
            x: point.x / dest.to_meter,
            y: point.y / dest.to_meter,
            z: point.z || 0
        };
    }
    // DGR, 2010/11/12
    if (enforceAxis && dest.axis !== "enu") return (0, $33930746129bc9d8$export$2e2bcd8739ae039)(dest, true, point);
    if (point && !hasZ) delete point.z;
    return point;
}


var $99c84e6d92fa15df$var$wgs84 = (0, $52991e6d5af7834c$export$2e2bcd8739ae039)("WGS84");
/**
 * @typedef {{x: number, y: number, z?: number, m?: number}} InterfaceCoordinates
 */ /**
 * @typedef {Array<number> | InterfaceCoordinates} TemplateCoordinates
 */ /**
 * @typedef {Object} Converter
 * @property {<T extends TemplateCoordinates>(coordinates: T, enforceAxis?: boolean) => T} forward
 * @property {<T extends TemplateCoordinates>(coordinates: T, enforceAxis?: boolean) => T} inverse
 * @property {proj} [oProj]
 */ /**
 * @typedef {Object} PROJJSONDefinition
 * @property {string} [$schema]
 * @property {string} type
 * @property {string} [name]
 * @property {{authority: string, code: number}} [id]
 * @property {string} [scope]
 * @property {string} [area]
 * @property {{south_latitude: number, west_longitude: number, north_latitude: number, east_longitude: number}} [bbox]
 * @property {PROJJSONDefinition[]} [components]
 * @property {{type: string, name: string}} [datum]
 * @property {{
 *   name: string,
 *   members: Array<{
 *     name: string,
 *     id?: {authority: string, code: number}
 *   }>,
 *   ellipsoid?: {
 *     name: string,
 *     semi_major_axis: number,
 *     inverse_flattening?: number
 *   },
 *   accuracy?: string,
 *   id?: {authority: string, code: number}
 * }} [datum_ensemble]
 * @property {{
 *   subtype: string,
 *   axis: Array<{
 *     name: string,
 *     abbreviation?: string,
 *     direction: string,
 *     unit: string
 *   }>
 * }} [coordinate_system]
 * @property {{
 *   name: string,
 *   method: {name: string},
 *   parameters: Array<{
 *     name: string,
 *     value: number,
 *     unit?: string
 *   }>
 * }} [conversion]
 * @property {{
 *   name: string,
 *   method: {name: string},
 *   parameters: Array<{
 *     name: string,
 *     value: number,
 *     unit?: string,
 *     type?: string,
 *     file_name?: string
 *   }>
 * }} [transformation]
 */ /**
 * @template {TemplateCoordinates} T
 * @param {proj} from
 * @param {proj} to
 * @param {T} coords
 * @param {boolean} [enforceAxis]
 * @returns {T}
 */ function $99c84e6d92fa15df$var$transformer(from, to, coords, enforceAxis) {
    var transformedArray, out, keys;
    if (Array.isArray(coords)) {
        transformedArray = (0, $a485f78aa3c84bef$export$2e2bcd8739ae039)(from, to, coords, enforceAxis) || {
            x: NaN,
            y: NaN
        };
        if (coords.length > 2) {
            if (typeof from.name !== "undefined" && from.name === "geocent" || typeof to.name !== "undefined" && to.name === "geocent") {
                if (typeof transformedArray.z === "number") return /** @type {T} */ [
                    transformedArray.x,
                    transformedArray.y,
                    transformedArray.z
                ].concat(coords.slice(3));
                else return /** @type {T} */ [
                    transformedArray.x,
                    transformedArray.y,
                    coords[2]
                ].concat(coords.slice(3));
            } else return /** @type {T} */ [
                transformedArray.x,
                transformedArray.y
            ].concat(coords.slice(2));
        } else return /** @type {T} */ [
            transformedArray.x,
            transformedArray.y
        ];
    } else {
        out = (0, $a485f78aa3c84bef$export$2e2bcd8739ae039)(from, to, coords, enforceAxis);
        keys = Object.keys(coords);
        if (keys.length === 2) return /** @type {T} */ out;
        keys.forEach(function(key) {
            if (typeof from.name !== "undefined" && from.name === "geocent" || typeof to.name !== "undefined" && to.name === "geocent") {
                if (key === "x" || key === "y" || key === "z") return;
            } else {
                if (key === "x" || key === "y") return;
            }
            out[key] = coords[key];
        });
        return /** @type {T} */ out;
    }
}
/**
 * @param {proj | string | PROJJSONDefinition | Converter} item
 * @returns {import('./Proj').default}
 */ function $99c84e6d92fa15df$var$checkProj(item) {
    if (item instanceof (0, $52991e6d5af7834c$export$2e2bcd8739ae039)) return item;
    if (typeof item === "object" && "oProj" in item) return item.oProj;
    return (0, $52991e6d5af7834c$export$2e2bcd8739ae039)(/** @type {string | PROJJSONDefinition} */ item);
}
/**
 * @overload
 * @param {string | PROJJSONDefinition | proj} toProj
 * @returns {Converter}
 */ /**
 * @overload
 * @param {string | PROJJSONDefinition | proj} fromProj
 * @param {string | PROJJSONDefinition | proj} toProj
 * @returns {Converter}
 */ /**
 * @template {TemplateCoordinates} T
 * @overload
 * @param {string | PROJJSONDefinition | proj} toProj
 * @param {T} coord
 * @returns {T}
 */ /**
 * @template {TemplateCoordinates} T
 * @overload
 * @param {string | PROJJSONDefinition | proj} fromProj
 * @param {string | PROJJSONDefinition | proj} toProj
 * @param {T} coord
 * @returns {T}
 */ /**
 * @template {TemplateCoordinates} T
 * @param {string | PROJJSONDefinition | proj} fromProjOrToProj
 * @param {string | PROJJSONDefinition | proj | TemplateCoordinates} [toProjOrCoord]
 * @param {T} [coord]
 * @returns {T|Converter}
 */ function $99c84e6d92fa15df$var$proj4(fromProjOrToProj, toProjOrCoord, coord) {
    /** @type {proj} */ var fromProj;
    /** @type {proj} */ var toProj;
    var single = false;
    /** @type {Converter} */ var obj;
    if (typeof toProjOrCoord === "undefined") {
        toProj = $99c84e6d92fa15df$var$checkProj(fromProjOrToProj);
        fromProj = $99c84e6d92fa15df$var$wgs84;
        single = true;
    } else if (typeof /** @type {?} */ toProjOrCoord.x !== "undefined" || Array.isArray(toProjOrCoord)) {
        coord = /** @type {?} */ toProjOrCoord;
        toProj = $99c84e6d92fa15df$var$checkProj(fromProjOrToProj);
        fromProj = $99c84e6d92fa15df$var$wgs84;
        single = true;
    }
    if (!fromProj) fromProj = $99c84e6d92fa15df$var$checkProj(fromProjOrToProj);
    if (!toProj) toProj = $99c84e6d92fa15df$var$checkProj(/** @type {string | PROJJSONDefinition | proj } */ toProjOrCoord);
    if (coord) return $99c84e6d92fa15df$var$transformer(fromProj, toProj, coord);
    else {
        obj = {
            /**
       * @template {TemplateCoordinates} T
       * @param {T} coords
       * @param {boolean=} enforceAxis
       * @returns {T}
       */ forward: function(coords, enforceAxis) {
                return $99c84e6d92fa15df$var$transformer(fromProj, toProj, coords, enforceAxis);
            },
            /**
       * @template {TemplateCoordinates} T
       * @param {T} coords
       * @param {boolean=} enforceAxis
       * @returns {T}
       */ inverse: function(coords, enforceAxis) {
                return $99c84e6d92fa15df$var$transformer(toProj, fromProj, coords, enforceAxis);
            }
        };
        if (single) obj.oProj = toProj;
        return obj;
    }
}
var $99c84e6d92fa15df$export$2e2bcd8739ae039 = $99c84e6d92fa15df$var$proj4;



/**
 * UTM zones are grouped, and assigned to one of a group of 6
 * sets.
 *
 * {int} @private
 */ var $a69d50808ceeca96$var$NUM_100K_SETS = 6;
/**
 * The column letters (for easting) of the lower left value, per
 * set.
 *
 * {string} @private
 */ var $a69d50808ceeca96$var$SET_ORIGIN_COLUMN_LETTERS = "AJSAJS";
/**
 * The row letters (for northing) of the lower left value, per
 * set.
 *
 * {string} @private
 */ var $a69d50808ceeca96$var$SET_ORIGIN_ROW_LETTERS = "AFAFAF";
var $a69d50808ceeca96$var$A = 65; // A
var $a69d50808ceeca96$var$I = 73; // I
var $a69d50808ceeca96$var$O = 79; // O
var $a69d50808ceeca96$var$V = 86; // V
var $a69d50808ceeca96$var$Z = 90; // Z
var $a69d50808ceeca96$export$2e2bcd8739ae039 = {
    forward: $a69d50808ceeca96$export$174bb771924e7eb1,
    inverse: $a69d50808ceeca96$export$70ae2c07e401031b,
    toPoint: $a69d50808ceeca96$export$b63cca88ddc558a9
};
function $a69d50808ceeca96$export$174bb771924e7eb1(ll, accuracy) {
    accuracy = accuracy || 5; // default accuracy 1m
    return $a69d50808ceeca96$var$encode($a69d50808ceeca96$var$LLtoUTM({
        lat: ll[1],
        lon: ll[0]
    }), accuracy);
}
function $a69d50808ceeca96$export$70ae2c07e401031b(mgrs) {
    var bbox = $a69d50808ceeca96$var$UTMtoLL($a69d50808ceeca96$var$decode(mgrs.toUpperCase()));
    if (bbox.lat && bbox.lon) return [
        bbox.lon,
        bbox.lat,
        bbox.lon,
        bbox.lat
    ];
    return [
        bbox.left,
        bbox.bottom,
        bbox.right,
        bbox.top
    ];
}
function $a69d50808ceeca96$export$b63cca88ddc558a9(mgrs) {
    var bbox = $a69d50808ceeca96$var$UTMtoLL($a69d50808ceeca96$var$decode(mgrs.toUpperCase()));
    if (bbox.lat && bbox.lon) return [
        bbox.lon,
        bbox.lat
    ];
    return [
        (bbox.left + bbox.right) / 2,
        (bbox.top + bbox.bottom) / 2
    ];
}
/**
 * Conversion from degrees to radians.
 *
 * @private
 * @param {number} deg the angle in degrees.
 * @return {number} the angle in radians.
 */ function $a69d50808ceeca96$var$degToRad(deg) {
    return deg * (Math.PI / 180.0);
}
/**
 * Conversion from radians to degrees.
 *
 * @private
 * @param {number} rad the angle in radians.
 * @return {number} the angle in degrees.
 */ function $a69d50808ceeca96$var$radToDeg(rad) {
    return 180.0 * (rad / Math.PI);
}
/**
 * Converts a set of Longitude and Latitude co-ordinates to UTM
 * using the WGS84 ellipsoid.
 *
 * @private
 * @param {object} ll Object literal with lat and lon properties
 *     representing the WGS84 coordinate to be converted.
 * @return {object} Object literal containing the UTM value with easting,
 *     northing, zoneNumber and zoneLetter properties, and an optional
 *     accuracy property in digits. Returns null if the conversion failed.
 */ function $a69d50808ceeca96$var$LLtoUTM(ll) {
    var Lat = ll.lat;
    var Long = ll.lon;
    var a = 6378137.0; //ellip.radius;
    var eccSquared = 0.00669438; //ellip.eccsq;
    var k0 = 0.9996;
    var LongOrigin;
    var eccPrimeSquared;
    var N, T, C, A, M;
    var LatRad = $a69d50808ceeca96$var$degToRad(Lat);
    var LongRad = $a69d50808ceeca96$var$degToRad(Long);
    var LongOriginRad;
    var ZoneNumber;
    // (int)
    ZoneNumber = Math.floor((Long + 180) / 6) + 1;
    //Make sure the longitude 180.00 is in Zone 60
    if (Long === 180) ZoneNumber = 60;
    // Special zone for Norway
    if (Lat >= 56.0 && Lat < 64.0 && Long >= 3.0 && Long < 12.0) ZoneNumber = 32;
    // Special zones for Svalbard
    if (Lat >= 72.0 && Lat < 84.0) {
        if (Long >= 0.0 && Long < 9.0) ZoneNumber = 31;
        else if (Long >= 9.0 && Long < 21.0) ZoneNumber = 33;
        else if (Long >= 21.0 && Long < 33.0) ZoneNumber = 35;
        else if (Long >= 33.0 && Long < 42.0) ZoneNumber = 37;
    }
    LongOrigin = (ZoneNumber - 1) * 6 - 180 + 3; //+3 puts origin
    // in middle of
    // zone
    LongOriginRad = $a69d50808ceeca96$var$degToRad(LongOrigin);
    eccPrimeSquared = eccSquared / (1 - eccSquared);
    N = a / Math.sqrt(1 - eccSquared * Math.sin(LatRad) * Math.sin(LatRad));
    T = Math.tan(LatRad) * Math.tan(LatRad);
    C = eccPrimeSquared * Math.cos(LatRad) * Math.cos(LatRad);
    A = Math.cos(LatRad) * (LongRad - LongOriginRad);
    M = a * ((1 - eccSquared / 4 - 3 * eccSquared * eccSquared / 64 - 5 * eccSquared * eccSquared * eccSquared / 256) * LatRad - (3 * eccSquared / 8 + 3 * eccSquared * eccSquared / 32 + 45 * eccSquared * eccSquared * eccSquared / 1024) * Math.sin(2 * LatRad) + (15 * eccSquared * eccSquared / 256 + 45 * eccSquared * eccSquared * eccSquared / 1024) * Math.sin(4 * LatRad) - 35 * eccSquared * eccSquared * eccSquared / 3072 * Math.sin(6 * LatRad));
    var UTMEasting = k0 * N * (A + (1 - T + C) * A * A * A / 6.0 + (5 - 18 * T + T * T + 72 * C - 58 * eccPrimeSquared) * A * A * A * A * A / 120.0) + 500000.0;
    var UTMNorthing = k0 * (M + N * Math.tan(LatRad) * (A * A / 2 + (5 - T + 9 * C + 4 * C * C) * A * A * A * A / 24.0 + (61 - 58 * T + T * T + 600 * C - 330 * eccPrimeSquared) * A * A * A * A * A * A / 720.0));
    if (Lat < 0.0) UTMNorthing += 10000000.0; //10000000 meter offset for
    return {
        northing: Math.round(UTMNorthing),
        easting: Math.round(UTMEasting),
        zoneNumber: ZoneNumber,
        zoneLetter: $a69d50808ceeca96$var$getLetterDesignator(Lat)
    };
}
/**
 * Converts UTM coords to lat/long, using the WGS84 ellipsoid. This is a convenience
 * class where the Zone can be specified as a single string eg."60N" which
 * is then broken down into the ZoneNumber and ZoneLetter.
 *
 * @private
 * @param {object} utm An object literal with northing, easting, zoneNumber
 *     and zoneLetter properties. If an optional accuracy property is
 *     provided (in meters), a bounding box will be returned instead of
 *     latitude and longitude.
 * @return {object} An object literal containing either lat and lon values
 *     (if no accuracy was provided), or top, right, bottom and left values
 *     for the bounding box calculated according to the provided accuracy.
 *     Returns null if the conversion failed.
 */ function $a69d50808ceeca96$var$UTMtoLL(utm) {
    var UTMNorthing = utm.northing;
    var UTMEasting = utm.easting;
    var zoneLetter = utm.zoneLetter;
    var zoneNumber = utm.zoneNumber;
    // check the ZoneNummber is valid
    if (zoneNumber < 0 || zoneNumber > 60) return null;
    var k0 = 0.9996;
    var a = 6378137.0; //ellip.radius;
    var eccSquared = 0.00669438; //ellip.eccsq;
    var eccPrimeSquared;
    var e1 = (1 - Math.sqrt(1 - eccSquared)) / (1 + Math.sqrt(1 - eccSquared));
    var N1, T1, C1, R1, D, M;
    var LongOrigin;
    var mu, phi1Rad;
    // remove 500,000 meter offset for longitude
    var x = UTMEasting - 500000.0;
    var y = UTMNorthing;
    // We must know somehow if we are in the Northern or Southern
    // hemisphere, this is the only time we use the letter So even
    // if the Zone letter isn't exactly correct it should indicate
    // the hemisphere correctly
    if (zoneLetter < "N") y -= 10000000.0; // remove 10,000,000 meter offset used
    // There are 60 zones with zone 1 being at West -180 to -174
    LongOrigin = (zoneNumber - 1) * 6 - 180 + 3; // +3 puts origin
    // in middle of
    // zone
    eccPrimeSquared = eccSquared / (1 - eccSquared);
    M = y / k0;
    mu = M / (a * (1 - eccSquared / 4 - 3 * eccSquared * eccSquared / 64 - 5 * eccSquared * eccSquared * eccSquared / 256));
    phi1Rad = mu + (3 * e1 / 2 - 27 * e1 * e1 * e1 / 32) * Math.sin(2 * mu) + (21 * e1 * e1 / 16 - 55 * e1 * e1 * e1 * e1 / 32) * Math.sin(4 * mu) + 151 * e1 * e1 * e1 / 96 * Math.sin(6 * mu);
    // double phi1 = ProjMath.radToDeg(phi1Rad);
    N1 = a / Math.sqrt(1 - eccSquared * Math.sin(phi1Rad) * Math.sin(phi1Rad));
    T1 = Math.tan(phi1Rad) * Math.tan(phi1Rad);
    C1 = eccPrimeSquared * Math.cos(phi1Rad) * Math.cos(phi1Rad);
    R1 = a * (1 - eccSquared) / Math.pow(1 - eccSquared * Math.sin(phi1Rad) * Math.sin(phi1Rad), 1.5);
    D = x / (N1 * k0);
    var lat = phi1Rad - N1 * Math.tan(phi1Rad) / R1 * (D * D / 2 - (5 + 3 * T1 + 10 * C1 - 4 * C1 * C1 - 9 * eccPrimeSquared) * D * D * D * D / 24 + (61 + 90 * T1 + 298 * C1 + 45 * T1 * T1 - 252 * eccPrimeSquared - 3 * C1 * C1) * D * D * D * D * D * D / 720);
    lat = $a69d50808ceeca96$var$radToDeg(lat);
    var lon = (D - (1 + 2 * T1 + C1) * D * D * D / 6 + (5 - 2 * C1 + 28 * T1 - 3 * C1 * C1 + 8 * eccPrimeSquared + 24 * T1 * T1) * D * D * D * D * D / 120) / Math.cos(phi1Rad);
    lon = LongOrigin + $a69d50808ceeca96$var$radToDeg(lon);
    var result;
    if (utm.accuracy) {
        var topRight = $a69d50808ceeca96$var$UTMtoLL({
            northing: utm.northing + utm.accuracy,
            easting: utm.easting + utm.accuracy,
            zoneLetter: utm.zoneLetter,
            zoneNumber: utm.zoneNumber
        });
        result = {
            top: topRight.lat,
            right: topRight.lon,
            bottom: lat,
            left: lon
        };
    } else result = {
        lat: lat,
        lon: lon
    };
    return result;
}
/**
 * Calculates the MGRS letter designator for the given latitude.
 *
 * @private
 * @param {number} lat The latitude in WGS84 to get the letter designator
 *     for.
 * @return {char} The letter designator.
 */ function $a69d50808ceeca96$var$getLetterDesignator(lat) {
    //This is here as an error flag to show that the Latitude is
    //outside MGRS limits
    var LetterDesignator = "Z";
    if (84 >= lat && lat >= 72) LetterDesignator = "X";
    else if (72 > lat && lat >= 64) LetterDesignator = "W";
    else if (64 > lat && lat >= 56) LetterDesignator = "V";
    else if (56 > lat && lat >= 48) LetterDesignator = "U";
    else if (48 > lat && lat >= 40) LetterDesignator = "T";
    else if (40 > lat && lat >= 32) LetterDesignator = "S";
    else if (32 > lat && lat >= 24) LetterDesignator = "R";
    else if (24 > lat && lat >= 16) LetterDesignator = "Q";
    else if (16 > lat && lat >= 8) LetterDesignator = "P";
    else if (8 > lat && lat >= 0) LetterDesignator = "N";
    else if (0 > lat && lat >= -8) LetterDesignator = "M";
    else if (-8 > lat && lat >= -16) LetterDesignator = "L";
    else if (-16 > lat && lat >= -24) LetterDesignator = "K";
    else if (-24 > lat && lat >= -32) LetterDesignator = "J";
    else if (-32 > lat && lat >= -40) LetterDesignator = "H";
    else if (-40 > lat && lat >= -48) LetterDesignator = "G";
    else if (-48 > lat && lat >= -56) LetterDesignator = "F";
    else if (-56 > lat && lat >= -64) LetterDesignator = "E";
    else if (-64 > lat && lat >= -72) LetterDesignator = "D";
    else if (-72 > lat && lat >= -80) LetterDesignator = "C";
    return LetterDesignator;
}
/**
 * Encodes a UTM location as MGRS string.
 *
 * @private
 * @param {object} utm An object literal with easting, northing,
 *     zoneLetter, zoneNumber
 * @param {number} accuracy Accuracy in digits (1-5).
 * @return {string} MGRS string for the given UTM location.
 */ function $a69d50808ceeca96$var$encode(utm, accuracy) {
    // prepend with leading zeroes
    var seasting = "00000" + utm.easting, snorthing = "00000" + utm.northing;
    return utm.zoneNumber + utm.zoneLetter + $a69d50808ceeca96$var$get100kID(utm.easting, utm.northing, utm.zoneNumber) + seasting.substr(seasting.length - 5, accuracy) + snorthing.substr(snorthing.length - 5, accuracy);
}
/**
 * Get the two letter 100k designator for a given UTM easting,
 * northing and zone number value.
 *
 * @private
 * @param {number} easting
 * @param {number} northing
 * @param {number} zoneNumber
 * @return the two letter 100k designator for the given UTM location.
 */ function $a69d50808ceeca96$var$get100kID(easting, northing, zoneNumber) {
    var setParm = $a69d50808ceeca96$var$get100kSetForZone(zoneNumber);
    var setColumn = Math.floor(easting / 100000);
    var setRow = Math.floor(northing / 100000) % 20;
    return $a69d50808ceeca96$var$getLetter100kID(setColumn, setRow, setParm);
}
/**
 * Given a UTM zone number, figure out the MGRS 100K set it is in.
 *
 * @private
 * @param {number} i An UTM zone number.
 * @return {number} the 100k set the UTM zone is in.
 */ function $a69d50808ceeca96$var$get100kSetForZone(i) {
    var setParm = i % $a69d50808ceeca96$var$NUM_100K_SETS;
    if (setParm === 0) setParm = $a69d50808ceeca96$var$NUM_100K_SETS;
    return setParm;
}
/**
 * Get the two-letter MGRS 100k designator given information
 * translated from the UTM northing, easting and zone number.
 *
 * @private
 * @param {number} column the column index as it relates to the MGRS
 *        100k set spreadsheet, created from the UTM easting.
 *        Values are 1-8.
 * @param {number} row the row index as it relates to the MGRS 100k set
 *        spreadsheet, created from the UTM northing value. Values
 *        are from 0-19.
 * @param {number} parm the set block, as it relates to the MGRS 100k set
 *        spreadsheet, created from the UTM zone. Values are from
 *        1-60.
 * @return two letter MGRS 100k code.
 */ function $a69d50808ceeca96$var$getLetter100kID(column, row, parm) {
    // colOrigin and rowOrigin are the letters at the origin of the set
    var index = parm - 1;
    var colOrigin = $a69d50808ceeca96$var$SET_ORIGIN_COLUMN_LETTERS.charCodeAt(index);
    var rowOrigin = $a69d50808ceeca96$var$SET_ORIGIN_ROW_LETTERS.charCodeAt(index);
    // colInt and rowInt are the letters to build to return
    var colInt = colOrigin + column - 1;
    var rowInt = rowOrigin + row;
    var rollover = false;
    if (colInt > $a69d50808ceeca96$var$Z) {
        colInt = colInt - $a69d50808ceeca96$var$Z + $a69d50808ceeca96$var$A - 1;
        rollover = true;
    }
    if (colInt === $a69d50808ceeca96$var$I || colOrigin < $a69d50808ceeca96$var$I && colInt > $a69d50808ceeca96$var$I || (colInt > $a69d50808ceeca96$var$I || colOrigin < $a69d50808ceeca96$var$I) && rollover) colInt++;
    if (colInt === $a69d50808ceeca96$var$O || colOrigin < $a69d50808ceeca96$var$O && colInt > $a69d50808ceeca96$var$O || (colInt > $a69d50808ceeca96$var$O || colOrigin < $a69d50808ceeca96$var$O) && rollover) {
        colInt++;
        if (colInt === $a69d50808ceeca96$var$I) colInt++;
    }
    if (colInt > $a69d50808ceeca96$var$Z) colInt = colInt - $a69d50808ceeca96$var$Z + $a69d50808ceeca96$var$A - 1;
    if (rowInt > $a69d50808ceeca96$var$V) {
        rowInt = rowInt - $a69d50808ceeca96$var$V + $a69d50808ceeca96$var$A - 1;
        rollover = true;
    } else rollover = false;
    if (rowInt === $a69d50808ceeca96$var$I || rowOrigin < $a69d50808ceeca96$var$I && rowInt > $a69d50808ceeca96$var$I || (rowInt > $a69d50808ceeca96$var$I || rowOrigin < $a69d50808ceeca96$var$I) && rollover) rowInt++;
    if (rowInt === $a69d50808ceeca96$var$O || rowOrigin < $a69d50808ceeca96$var$O && rowInt > $a69d50808ceeca96$var$O || (rowInt > $a69d50808ceeca96$var$O || rowOrigin < $a69d50808ceeca96$var$O) && rollover) {
        rowInt++;
        if (rowInt === $a69d50808ceeca96$var$I) rowInt++;
    }
    if (rowInt > $a69d50808ceeca96$var$V) rowInt = rowInt - $a69d50808ceeca96$var$V + $a69d50808ceeca96$var$A - 1;
    var twoLetter = String.fromCharCode(colInt) + String.fromCharCode(rowInt);
    return twoLetter;
}
/**
 * Decode the UTM parameters from a MGRS string.
 *
 * @private
 * @param {string} mgrsString an UPPERCASE coordinate string is expected.
 * @return {object} An object literal with easting, northing, zoneLetter,
 *     zoneNumber and accuracy (in meters) properties.
 */ function $a69d50808ceeca96$var$decode(mgrsString) {
    if (mgrsString && mgrsString.length === 0) throw "MGRSPoint coverting from nothing";
    var length = mgrsString.length;
    var hunK = null;
    var sb = "";
    var testChar;
    var i = 0;
    // get Zone number
    while(!/[A-Z]/.test(testChar = mgrsString.charAt(i))){
        if (i >= 2) throw "MGRSPoint bad conversion from: " + mgrsString;
        sb += testChar;
        i++;
    }
    var zoneNumber = parseInt(sb, 10);
    if (i === 0 || i + 3 > length) // A good MGRS string has to be 4-5 digits long,
    // ##AAA/#AAA at least.
    throw "MGRSPoint bad conversion from: " + mgrsString;
    var zoneLetter = mgrsString.charAt(i++);
    // Should we check the zone letter here? Why not.
    if (zoneLetter <= "A" || zoneLetter === "B" || zoneLetter === "Y" || zoneLetter >= "Z" || zoneLetter === "I" || zoneLetter === "O") throw "MGRSPoint zone letter " + zoneLetter + " not handled: " + mgrsString;
    hunK = mgrsString.substring(i, i += 2);
    var set = $a69d50808ceeca96$var$get100kSetForZone(zoneNumber);
    var east100k = $a69d50808ceeca96$var$getEastingFromChar(hunK.charAt(0), set);
    var north100k = $a69d50808ceeca96$var$getNorthingFromChar(hunK.charAt(1), set);
    // We have a bug where the northing may be 2000000 too low.
    // How
    // do we know when to roll over?
    while(north100k < $a69d50808ceeca96$var$getMinNorthing(zoneLetter))north100k += 2000000;
    // calculate the char index for easting/northing separator
    var remainder = length - i;
    if (remainder % 2 !== 0) throw "MGRSPoint has to have an even number \nof digits after the zone letter and two 100km letters - front \nhalf for easting meters, second half for \nnorthing meters" + mgrsString;
    var sep = remainder / 2;
    var sepEasting = 0.0;
    var sepNorthing = 0.0;
    var accuracyBonus, sepEastingString, sepNorthingString, easting, northing;
    if (sep > 0) {
        accuracyBonus = 100000.0 / Math.pow(10, sep);
        sepEastingString = mgrsString.substring(i, i + sep);
        sepEasting = parseFloat(sepEastingString) * accuracyBonus;
        sepNorthingString = mgrsString.substring(i + sep);
        sepNorthing = parseFloat(sepNorthingString) * accuracyBonus;
    }
    easting = sepEasting + east100k;
    northing = sepNorthing + north100k;
    return {
        easting: easting,
        northing: northing,
        zoneLetter: zoneLetter,
        zoneNumber: zoneNumber,
        accuracy: accuracyBonus
    };
}
/**
 * Given the first letter from a two-letter MGRS 100k zone, and given the
 * MGRS table set for the zone number, figure out the easting value that
 * should be added to the other, secondary easting value.
 *
 * @private
 * @param {char} e The first letter from a two-letter MGRS 100´k zone.
 * @param {number} set The MGRS table set for the zone number.
 * @return {number} The easting value for the given letter and set.
 */ function $a69d50808ceeca96$var$getEastingFromChar(e, set) {
    // colOrigin is the letter at the origin of the set for the
    // column
    var curCol = $a69d50808ceeca96$var$SET_ORIGIN_COLUMN_LETTERS.charCodeAt(set - 1);
    var eastingValue = 100000.0;
    var rewindMarker = false;
    while(curCol !== e.charCodeAt(0)){
        curCol++;
        if (curCol === $a69d50808ceeca96$var$I) curCol++;
        if (curCol === $a69d50808ceeca96$var$O) curCol++;
        if (curCol > $a69d50808ceeca96$var$Z) {
            if (rewindMarker) throw "Bad character: " + e;
            curCol = $a69d50808ceeca96$var$A;
            rewindMarker = true;
        }
        eastingValue += 100000.0;
    }
    return eastingValue;
}
/**
 * Given the second letter from a two-letter MGRS 100k zone, and given the
 * MGRS table set for the zone number, figure out the northing value that
 * should be added to the other, secondary northing value. You have to
 * remember that Northings are determined from the equator, and the vertical
 * cycle of letters mean a 2000000 additional northing meters. This happens
 * approx. every 18 degrees of latitude. This method does *NOT* count any
 * additional northings. You have to figure out how many 2000000 meters need
 * to be added for the zone letter of the MGRS coordinate.
 *
 * @private
 * @param {char} n Second letter of the MGRS 100k zone
 * @param {number} set The MGRS table set number, which is dependent on the
 *     UTM zone number.
 * @return {number} The northing value for the given letter and set.
 */ function $a69d50808ceeca96$var$getNorthingFromChar(n, set) {
    if (n > "V") throw "MGRSPoint given invalid Northing " + n;
    // rowOrigin is the letter at the origin of the set for the
    // column
    var curRow = $a69d50808ceeca96$var$SET_ORIGIN_ROW_LETTERS.charCodeAt(set - 1);
    var northingValue = 0.0;
    var rewindMarker = false;
    while(curRow !== n.charCodeAt(0)){
        curRow++;
        if (curRow === $a69d50808ceeca96$var$I) curRow++;
        if (curRow === $a69d50808ceeca96$var$O) curRow++;
        // fixing a bug making whole application hang in this loop
        // when 'n' is a wrong character
        if (curRow > $a69d50808ceeca96$var$V) {
            if (rewindMarker) throw "Bad character: " + n;
            curRow = $a69d50808ceeca96$var$A;
            rewindMarker = true;
        }
        northingValue += 100000.0;
    }
    return northingValue;
}
/**
 * The function getMinNorthing returns the minimum northing value of a MGRS
 * zone.
 *
 * Ported from Geotrans' c Lattitude_Band_Value structure table.
 *
 * @private
 * @param {char} zoneLetter The MGRS zone to get the min northing for.
 * @return {number}
 */ function $a69d50808ceeca96$var$getMinNorthing(zoneLetter) {
    var northing;
    switch(zoneLetter){
        case "C":
            northing = 1100000.0;
            break;
        case "D":
            northing = 2000000.0;
            break;
        case "E":
            northing = 2800000.0;
            break;
        case "F":
            northing = 3700000.0;
            break;
        case "G":
            northing = 4600000.0;
            break;
        case "H":
            northing = 5500000.0;
            break;
        case "J":
            northing = 6400000.0;
            break;
        case "K":
            northing = 7300000.0;
            break;
        case "L":
            northing = 8200000.0;
            break;
        case "M":
            northing = 9100000.0;
            break;
        case "N":
            northing = 0.0;
            break;
        case "P":
            northing = 800000.0;
            break;
        case "Q":
            northing = 1700000.0;
            break;
        case "R":
            northing = 2600000.0;
            break;
        case "S":
            northing = 3500000.0;
            break;
        case "T":
            northing = 4400000.0;
            break;
        case "U":
            northing = 5300000.0;
            break;
        case "V":
            northing = 6200000.0;
            break;
        case "W":
            northing = 7000000.0;
            break;
        case "X":
            northing = 7900000.0;
            break;
        default:
            northing = -1;
    }
    if (northing >= 0.0) return northing;
    else throw "Invalid zone letter: " + zoneLetter;
}


/**
 * @deprecated v3.0.0 - use proj4.toPoint instead
 * @param {number | import('./core').TemplateCoordinates | string} x
 * @param {number} [y]
 * @param {number} [z]
 */ function $707fd9647656ee51$var$Point(x, y, z) {
    if (!(this instanceof $707fd9647656ee51$var$Point)) return new $707fd9647656ee51$var$Point(x, y, z);
    if (Array.isArray(x)) {
        this.x = x[0];
        this.y = x[1];
        this.z = x[2] || 0.0;
    } else if (typeof x === "object") {
        this.x = x.x;
        this.y = x.y;
        this.z = x.z || 0.0;
    } else if (typeof x === "string" && typeof y === "undefined") {
        var coords = x.split(",");
        this.x = parseFloat(coords[0]);
        this.y = parseFloat(coords[1]);
        this.z = parseFloat(coords[2]) || 0.0;
    } else {
        this.x = x;
        this.y = y;
        this.z = z || 0.0;
    }
    console.warn("proj4.Point will be removed in version 3, use proj4.toPoint");
}
$707fd9647656ee51$var$Point.fromMGRS = function(mgrsStr) {
    return new $707fd9647656ee51$var$Point((0, $a69d50808ceeca96$export$b63cca88ddc558a9)(mgrsStr));
};
$707fd9647656ee51$var$Point.prototype.toMGRS = function(accuracy) {
    return (0, $a69d50808ceeca96$export$174bb771924e7eb1)([
        this.x,
        this.y
    ], accuracy);
};
var $707fd9647656ee51$export$2e2bcd8739ae039 = $707fd9647656ee51$var$Point;








var $jSMMP = parcelRequire("jSMMP");

var $5C8fj = parcelRequire("5C8fj");

var $186WS = parcelRequire("186WS");
function $bcaacc2f948ec019$export$2e2bcd8739ae039(zone, lon) {
    if (zone === undefined) {
        zone = Math.floor(((0, $186WS.default)(lon) + Math.PI) * 30 / Math.PI) + 1;
        if (zone < 0) return 0;
        else if (zone > 60) return 60;
    }
    return zone;
}



var $5C8fj = parcelRequire("5C8fj");

var $jVGH7 = parcelRequire("jVGH7");
var $1317aa6303863d5e$export$3f91ef0e0d0d8bf8 = "etmerc";
function $1317aa6303863d5e$export$2cd8252107eb640b() {
    var zone = (0, $bcaacc2f948ec019$export$2e2bcd8739ae039)(this.zone, this.long0);
    if (zone === undefined) throw new Error("unknown utm zone");
    this.lat0 = 0;
    this.long0 = (6 * Math.abs(zone) - 183) * (0, $jVGH7.D2R);
    this.x0 = 500000;
    this.y0 = this.utmSouth ? 10000000 : 0;
    this.k0 = 0.9996;
    (0, $5C8fj.default).init.apply(this);
    this.forward = (0, $5C8fj.default).forward;
    this.inverse = (0, $5C8fj.default).inverse;
}
var $1317aa6303863d5e$export$e4b2ac9215619f8d = [
    "Universal Transverse Mercator System",
    "utm"
];
var $1317aa6303863d5e$export$2e2bcd8739ae039 = {
    init: $1317aa6303863d5e$export$2cd8252107eb640b,
    names: $1317aa6303863d5e$export$e4b2ac9215619f8d,
    dependsOn: $1317aa6303863d5e$export$3f91ef0e0d0d8bf8
};


function $0ef74e9419caed60$export$2e2bcd8739ae039(esinp, exp) {
    return Math.pow((1 - esinp) / (1 + esinp), exp);
}



var $jVGH7 = parcelRequire("jVGH7");
var $2925f8f75093da8b$var$MAX_ITER = 20;
function $2925f8f75093da8b$export$2cd8252107eb640b() {
    var sphi = Math.sin(this.lat0);
    var cphi = Math.cos(this.lat0);
    cphi *= cphi;
    this.rc = Math.sqrt(1 - this.es) / (1 - this.es * sphi * sphi);
    this.C = Math.sqrt(1 + this.es * cphi * cphi / (1 - this.es));
    this.phic0 = Math.asin(sphi / this.C);
    this.ratexp = 0.5 * this.C * this.e;
    this.K = Math.tan(0.5 * this.phic0 + (0, $jVGH7.FORTPI)) / (Math.pow(Math.tan(0.5 * this.lat0 + (0, $jVGH7.FORTPI)), this.C) * (0, $0ef74e9419caed60$export$2e2bcd8739ae039)(this.e * sphi, this.ratexp));
}
function $2925f8f75093da8b$export$174bb771924e7eb1(p) {
    var lon = p.x;
    var lat = p.y;
    p.y = 2 * Math.atan(this.K * Math.pow(Math.tan(0.5 * lat + (0, $jVGH7.FORTPI)), this.C) * (0, $0ef74e9419caed60$export$2e2bcd8739ae039)(this.e * Math.sin(lat), this.ratexp)) - (0, $jVGH7.HALF_PI);
    p.x = this.C * lon;
    return p;
}
function $2925f8f75093da8b$export$70ae2c07e401031b(p) {
    var DEL_TOL = 1e-14;
    var lon = p.x / this.C;
    var lat = p.y;
    var num = Math.pow(Math.tan(0.5 * lat + (0, $jVGH7.FORTPI)) / this.K, 1 / this.C);
    for(var i = $2925f8f75093da8b$var$MAX_ITER; i > 0; --i){
        lat = 2 * Math.atan(num * (0, $0ef74e9419caed60$export$2e2bcd8739ae039)(this.e * Math.sin(p.y), -0.5 * this.e)) - (0, $jVGH7.HALF_PI);
        if (Math.abs(lat - p.y) < DEL_TOL) break;
        p.y = lat;
    }
    /* convergence failed */ if (!i) return null;
    p.x = lon;
    p.y = lat;
    return p;
}
var $2925f8f75093da8b$export$e4b2ac9215619f8d = [
    "gauss"
];
var $2925f8f75093da8b$export$2e2bcd8739ae039 = {
    init: $2925f8f75093da8b$export$2cd8252107eb640b,
    forward: $2925f8f75093da8b$export$174bb771924e7eb1,
    inverse: $2925f8f75093da8b$export$70ae2c07e401031b,
    names: $2925f8f75093da8b$export$e4b2ac9215619f8d
};



var $186WS = parcelRequire("186WS");

var $5nakf = parcelRequire("5nakf");
function $9f9db2d24b8edc66$export$2cd8252107eb640b() {
    (0, $2925f8f75093da8b$export$2e2bcd8739ae039).init.apply(this);
    if (!this.rc) return;
    this.sinc0 = Math.sin(this.phic0);
    this.cosc0 = Math.cos(this.phic0);
    this.R2 = 2 * this.rc;
    if (!this.title) this.title = "Oblique Stereographic Alternative";
}
function $9f9db2d24b8edc66$export$174bb771924e7eb1(p) {
    var sinc, cosc, cosl, k;
    p.x = (0, $186WS.default)(p.x - this.long0);
    (0, $2925f8f75093da8b$export$2e2bcd8739ae039).forward.apply(this, [
        p
    ]);
    sinc = Math.sin(p.y);
    cosc = Math.cos(p.y);
    cosl = Math.cos(p.x);
    k = this.k0 * this.R2 / (1 + this.sinc0 * sinc + this.cosc0 * cosc * cosl);
    p.x = k * cosc * Math.sin(p.x);
    p.y = k * (this.cosc0 * sinc - this.sinc0 * cosc * cosl);
    p.x = this.a * p.x + this.x0;
    p.y = this.a * p.y + this.y0;
    return p;
}
function $9f9db2d24b8edc66$export$70ae2c07e401031b(p) {
    var sinc, cosc, lon, lat, rho;
    p.x = (p.x - this.x0) / this.a;
    p.y = (p.y - this.y0) / this.a;
    p.x /= this.k0;
    p.y /= this.k0;
    if (rho = (0, $5nakf.default)(p.x, p.y)) {
        var c = 2 * Math.atan2(rho, this.R2);
        sinc = Math.sin(c);
        cosc = Math.cos(c);
        lat = Math.asin(cosc * this.sinc0 + p.y * sinc * this.cosc0 / rho);
        lon = Math.atan2(p.x * sinc, rho * this.cosc0 * cosc - p.y * this.sinc0 * sinc);
    } else {
        lat = this.phic0;
        lon = 0;
    }
    p.x = lon;
    p.y = lat;
    (0, $2925f8f75093da8b$export$2e2bcd8739ae039).inverse.apply(this, [
        p
    ]);
    p.x = (0, $186WS.default)(p.x + this.long0);
    return p;
}
var $9f9db2d24b8edc66$export$e4b2ac9215619f8d = [
    "Stereographic_North_Pole",
    "Oblique_Stereographic",
    "sterea",
    "Oblique Stereographic Alternative",
    "Double_Stereographic"
];
var $9f9db2d24b8edc66$export$2e2bcd8739ae039 = {
    init: $9f9db2d24b8edc66$export$2cd8252107eb640b,
    forward: $9f9db2d24b8edc66$export$174bb771924e7eb1,
    inverse: $9f9db2d24b8edc66$export$70ae2c07e401031b,
    names: $9f9db2d24b8edc66$export$e4b2ac9215619f8d
};



var $jVGH7 = parcelRequire("jVGH7");

var $45Ucl = parcelRequire("45Ucl");

var $ao8xz = parcelRequire("ao8xz");



var $186WS = parcelRequire("186WS");
function $292ab23fdb0d0b5e$export$8adc077b4b982c95(phit, sinphi, eccen) {
    sinphi *= eccen;
    return Math.tan(0.5 * ((0, $jVGH7.HALF_PI) + phit)) * Math.pow((1 - sinphi) / (1 + sinphi), 0.5 * eccen);
}
function $292ab23fdb0d0b5e$export$2cd8252107eb640b() {
    // setting default parameters
    this.x0 = this.x0 || 0;
    this.y0 = this.y0 || 0;
    this.lat0 = this.lat0 || 0;
    this.long0 = this.long0 || 0;
    this.coslat0 = Math.cos(this.lat0);
    this.sinlat0 = Math.sin(this.lat0);
    if (this.sphere) {
        if (this.k0 === 1 && !isNaN(this.lat_ts) && Math.abs(this.coslat0) <= (0, $jVGH7.EPSLN)) this.k0 = 0.5 * (1 + (0, $45Ucl.default)(this.lat0) * Math.sin(this.lat_ts));
    } else {
        if (Math.abs(this.coslat0) <= (0, $jVGH7.EPSLN)) {
            if (this.lat0 > 0) // North pole
            // trace('stere:north pole');
            this.con = 1;
            else // South pole
            // trace('stere:south pole');
            this.con = -1;
        }
        this.cons = Math.sqrt(Math.pow(1 + this.e, 1 + this.e) * Math.pow(1 - this.e, 1 - this.e));
        if (this.k0 === 1 && !isNaN(this.lat_ts) && Math.abs(this.coslat0) <= (0, $jVGH7.EPSLN) && Math.abs(Math.cos(this.lat_ts)) > (0, $jVGH7.EPSLN)) // When k0 is 1 (default value) and lat_ts is a vaild number and lat0 is at a pole and lat_ts is not at a pole
        // Recalculate k0 using formula 21-35 from p161 of Snyder, 1987
        this.k0 = 0.5 * this.cons * (0, $ao8xz.default)(this.e, Math.sin(this.lat_ts), Math.cos(this.lat_ts)) / (0, $1fd05693455a46f8$export$2e2bcd8739ae039)(this.e, this.con * this.lat_ts, this.con * Math.sin(this.lat_ts));
        this.ms1 = (0, $ao8xz.default)(this.e, this.sinlat0, this.coslat0);
        this.X0 = 2 * Math.atan($292ab23fdb0d0b5e$export$8adc077b4b982c95(this.lat0, this.sinlat0, this.e)) - (0, $jVGH7.HALF_PI);
        this.cosX0 = Math.cos(this.X0);
        this.sinX0 = Math.sin(this.X0);
    }
}
function $292ab23fdb0d0b5e$export$174bb771924e7eb1(p) {
    var lon = p.x;
    var lat = p.y;
    var sinlat = Math.sin(lat);
    var coslat = Math.cos(lat);
    var A, X, sinX, cosX, ts, rh;
    var dlon = (0, $186WS.default)(lon - this.long0);
    if (Math.abs(Math.abs(lon - this.long0) - Math.PI) <= (0, $jVGH7.EPSLN) && Math.abs(lat + this.lat0) <= (0, $jVGH7.EPSLN)) {
        // case of the origine point
        // trace('stere:this is the origin point');
        p.x = NaN;
        p.y = NaN;
        return p;
    }
    if (this.sphere) {
        // trace('stere:sphere case');
        A = 2 * this.k0 / (1 + this.sinlat0 * sinlat + this.coslat0 * coslat * Math.cos(dlon));
        p.x = this.a * A * coslat * Math.sin(dlon) + this.x0;
        p.y = this.a * A * (this.coslat0 * sinlat - this.sinlat0 * coslat * Math.cos(dlon)) + this.y0;
        return p;
    } else {
        X = 2 * Math.atan($292ab23fdb0d0b5e$export$8adc077b4b982c95(lat, sinlat, this.e)) - (0, $jVGH7.HALF_PI);
        cosX = Math.cos(X);
        sinX = Math.sin(X);
        if (Math.abs(this.coslat0) <= (0, $jVGH7.EPSLN)) {
            ts = (0, $1fd05693455a46f8$export$2e2bcd8739ae039)(this.e, lat * this.con, this.con * sinlat);
            rh = 2 * this.a * this.k0 * ts / this.cons;
            p.x = this.x0 + rh * Math.sin(lon - this.long0);
            p.y = this.y0 - this.con * rh * Math.cos(lon - this.long0);
            // trace(p.toString());
            return p;
        } else if (Math.abs(this.sinlat0) < (0, $jVGH7.EPSLN)) {
            // Eq
            // trace('stere:equateur');
            A = 2 * this.a * this.k0 / (1 + cosX * Math.cos(dlon));
            p.y = A * sinX;
        } else {
            // other case
            // trace('stere:normal case');
            A = 2 * this.a * this.k0 * this.ms1 / (this.cosX0 * (1 + this.sinX0 * sinX + this.cosX0 * cosX * Math.cos(dlon)));
            p.y = A * (this.cosX0 * sinX - this.sinX0 * cosX * Math.cos(dlon)) + this.y0;
        }
        p.x = A * cosX * Math.sin(dlon) + this.x0;
    }
    // trace(p.toString());
    return p;
}
function $292ab23fdb0d0b5e$export$70ae2c07e401031b(p) {
    p.x -= this.x0;
    p.y -= this.y0;
    var lon, lat, ts, ce, Chi;
    var rh = Math.sqrt(p.x * p.x + p.y * p.y);
    if (this.sphere) {
        var c = 2 * Math.atan(rh / (2 * this.a * this.k0));
        lon = this.long0;
        lat = this.lat0;
        if (rh <= (0, $jVGH7.EPSLN)) {
            p.x = lon;
            p.y = lat;
            return p;
        }
        lat = Math.asin(Math.cos(c) * this.sinlat0 + p.y * Math.sin(c) * this.coslat0 / rh);
        if (Math.abs(this.coslat0) < (0, $jVGH7.EPSLN)) {
            if (this.lat0 > 0) lon = (0, $186WS.default)(this.long0 + Math.atan2(p.x, -1 * p.y));
            else lon = (0, $186WS.default)(this.long0 + Math.atan2(p.x, p.y));
        } else lon = (0, $186WS.default)(this.long0 + Math.atan2(p.x * Math.sin(c), rh * this.coslat0 * Math.cos(c) - p.y * this.sinlat0 * Math.sin(c)));
        p.x = lon;
        p.y = lat;
        return p;
    } else if (Math.abs(this.coslat0) <= (0, $jVGH7.EPSLN)) {
        if (rh <= (0, $jVGH7.EPSLN)) {
            lat = this.lat0;
            lon = this.long0;
            p.x = lon;
            p.y = lat;
            // trace(p.toString());
            return p;
        }
        p.x *= this.con;
        p.y *= this.con;
        ts = rh * this.cons / (2 * this.a * this.k0);
        lat = this.con * (0, $d9cf96cf291e0f24$export$2e2bcd8739ae039)(this.e, ts);
        lon = this.con * (0, $186WS.default)(this.con * this.long0 + Math.atan2(p.x, -1 * p.y));
    } else {
        ce = 2 * Math.atan(rh * this.cosX0 / (2 * this.a * this.k0 * this.ms1));
        lon = this.long0;
        if (rh <= (0, $jVGH7.EPSLN)) Chi = this.X0;
        else {
            Chi = Math.asin(Math.cos(ce) * this.sinX0 + p.y * Math.sin(ce) * this.cosX0 / rh);
            lon = (0, $186WS.default)(this.long0 + Math.atan2(p.x * Math.sin(ce), rh * this.cosX0 * Math.cos(ce) - p.y * this.sinX0 * Math.sin(ce)));
        }
        lat = -1 * (0, $d9cf96cf291e0f24$export$2e2bcd8739ae039)(this.e, Math.tan(0.5 * ((0, $jVGH7.HALF_PI) + Chi)));
    }
    p.x = lon;
    p.y = lat;
    // trace(p.toString());
    return p;
}
var $292ab23fdb0d0b5e$export$e4b2ac9215619f8d = [
    "stere",
    "Stereographic_South_Pole",
    "Polar_Stereographic_variant_A",
    "Polar_Stereographic_variant_B",
    "Polar_Stereographic"
];
var $292ab23fdb0d0b5e$export$2e2bcd8739ae039 = {
    init: $292ab23fdb0d0b5e$export$2cd8252107eb640b,
    forward: $292ab23fdb0d0b5e$export$174bb771924e7eb1,
    inverse: $292ab23fdb0d0b5e$export$70ae2c07e401031b,
    names: $292ab23fdb0d0b5e$export$e4b2ac9215619f8d,
    ssfn_: $292ab23fdb0d0b5e$export$8adc077b4b982c95
};


/*
  references:
    Formules et constantes pour le Calcul pour la
    projection cylindrique conforme à axe oblique et pour la transformation entre
    des systèmes de référence.
    http://www.swisstopo.admin.ch/internet/swisstopo/fr/home/topics/survey/sys/refsys/switzerland.parsysrelated1.31216.downloadList.77004.DownloadFile.tmp/swissprojectionfr.pdf
  */ /**
 * @typedef {Object} LocalThis
 * @property {number} lambda0
 * @property {number} e
 * @property {number} R
 * @property {number} b0
 * @property {number} K
 */ /** @this {import('../defs.js').ProjectionDefinition & LocalThis} */ function $2e022212320a1a67$export$2cd8252107eb640b() {
    var phy0 = this.lat0;
    this.lambda0 = this.long0;
    var sinPhy0 = Math.sin(phy0);
    var semiMajorAxis = this.a;
    var invF = this.rf;
    var flattening = 1 / invF;
    var e2 = 2 * flattening - Math.pow(flattening, 2);
    var e = this.e = Math.sqrt(e2);
    this.R = this.k0 * semiMajorAxis * Math.sqrt(1 - e2) / (1 - e2 * Math.pow(sinPhy0, 2));
    this.alpha = Math.sqrt(1 + e2 / (1 - e2) * Math.pow(Math.cos(phy0), 4));
    this.b0 = Math.asin(sinPhy0 / this.alpha);
    var k1 = Math.log(Math.tan(Math.PI / 4 + this.b0 / 2));
    var k2 = Math.log(Math.tan(Math.PI / 4 + phy0 / 2));
    var k3 = Math.log((1 + e * sinPhy0) / (1 - e * sinPhy0));
    this.K = k1 - this.alpha * k2 + this.alpha * e / 2 * k3;
}
function $2e022212320a1a67$export$174bb771924e7eb1(p) {
    var Sa1 = Math.log(Math.tan(Math.PI / 4 - p.y / 2));
    var Sa2 = this.e / 2 * Math.log((1 + this.e * Math.sin(p.y)) / (1 - this.e * Math.sin(p.y)));
    var S = -this.alpha * (Sa1 + Sa2) + this.K;
    // spheric latitude
    var b = 2 * (Math.atan(Math.exp(S)) - Math.PI / 4);
    // spheric longitude
    var I = this.alpha * (p.x - this.lambda0);
    // psoeudo equatorial rotation
    var rotI = Math.atan(Math.sin(I) / (Math.sin(this.b0) * Math.tan(b) + Math.cos(this.b0) * Math.cos(I)));
    var rotB = Math.asin(Math.cos(this.b0) * Math.sin(b) - Math.sin(this.b0) * Math.cos(b) * Math.cos(I));
    p.y = this.R / 2 * Math.log((1 + Math.sin(rotB)) / (1 - Math.sin(rotB))) + this.y0;
    p.x = this.R * rotI + this.x0;
    return p;
}
function $2e022212320a1a67$export$70ae2c07e401031b(p) {
    var Y = p.x - this.x0;
    var X = p.y - this.y0;
    var rotI = Y / this.R;
    var rotB = 2 * (Math.atan(Math.exp(X / this.R)) - Math.PI / 4);
    var b = Math.asin(Math.cos(this.b0) * Math.sin(rotB) + Math.sin(this.b0) * Math.cos(rotB) * Math.cos(rotI));
    var I = Math.atan(Math.sin(rotI) / (Math.cos(this.b0) * Math.cos(rotI) - Math.sin(this.b0) * Math.tan(rotB)));
    var lambda = this.lambda0 + I / this.alpha;
    var S = 0;
    var phy = b;
    var prevPhy = -1000;
    var iteration = 0;
    while(Math.abs(phy - prevPhy) > 0.0000001){
        if (++iteration > 20) // ...reportError("omercFwdInfinity");
        return;
        // S = Math.log(Math.tan(Math.PI / 4 + phy / 2));
        S = 1 / this.alpha * (Math.log(Math.tan(Math.PI / 4 + b / 2)) - this.K) + this.e * Math.log(Math.tan(Math.PI / 4 + Math.asin(this.e * Math.sin(phy)) / 2));
        prevPhy = phy;
        phy = 2 * Math.atan(Math.exp(S)) - Math.PI / 2;
    }
    p.x = lambda;
    p.y = phy;
    return p;
}
var $2e022212320a1a67$export$e4b2ac9215619f8d = [
    "somerc"
];
var $2e022212320a1a67$export$2e2bcd8739ae039 = {
    init: $2e022212320a1a67$export$2cd8252107eb640b,
    forward: $2e022212320a1a67$export$174bb771924e7eb1,
    inverse: $2e022212320a1a67$export$70ae2c07e401031b,
    names: $2e022212320a1a67$export$e4b2ac9215619f8d
};




var $186WS = parcelRequire("186WS");


var $jVGH7 = parcelRequire("jVGH7");

/**
 * @typedef {Object} LocalThis
 * @property {boolean} no_off
 * @property {boolean} no_rot
 * @property {number} rectified_grid_angle
 * @property {number} es
 * @property {number} A
 * @property {number} B
 * @property {number} E
 * @property {number} e
 * @property {number} lam0
 * @property {number} singam
 * @property {number} cosgam
 * @property {number} sinrot
 * @property {number} cosrot
 * @property {number} rB
 * @property {number} ArB
 * @property {number} BrA
 * @property {number} u_0
 * @property {number} v_pole_n
 * @property {number} v_pole_s
 */ var $3566c122b734ed10$var$TOL = 1e-7;
function $3566c122b734ed10$var$isTypeA(P) {
    var typeAProjections = [
        "Hotine_Oblique_Mercator",
        "Hotine_Oblique_Mercator_variant_A",
        "Hotine_Oblique_Mercator_Azimuth_Natural_Origin"
    ];
    var projectionName = typeof P.projName === "object" ? Object.keys(P.projName)[0] : P.projName;
    return "no_uoff" in P || "no_off" in P || typeAProjections.indexOf(projectionName) !== -1 || typeAProjections.indexOf((0, $0e1d3f1fd830d3be$export$9ee0bb5510679155)(projectionName)) !== -1;
}
function $3566c122b734ed10$export$2cd8252107eb640b() {
    var con, com, cosph0, D, F, H, L, sinph0, p, J, gamma = 0, gamma0, lamc = 0, lam1 = 0, lam2 = 0, phi1 = 0, phi2 = 0, alpha_c = 0;
    // only Type A uses the no_off or no_uoff property
    // https://github.com/OSGeo/proj.4/issues/104
    this.no_off = $3566c122b734ed10$var$isTypeA(this);
    this.no_rot = "no_rot" in this;
    var alp = false;
    if ("alpha" in this) alp = true;
    var gam = false;
    if ("rectified_grid_angle" in this) gam = true;
    if (alp) alpha_c = this.alpha;
    if (gam) gamma = this.rectified_grid_angle;
    if (alp || gam) lamc = this.longc;
    else {
        lam1 = this.long1;
        phi1 = this.lat1;
        lam2 = this.long2;
        phi2 = this.lat2;
        if (Math.abs(phi1 - phi2) <= $3566c122b734ed10$var$TOL || (con = Math.abs(phi1)) <= $3566c122b734ed10$var$TOL || Math.abs(con - (0, $jVGH7.HALF_PI)) <= $3566c122b734ed10$var$TOL || Math.abs(Math.abs(this.lat0) - (0, $jVGH7.HALF_PI)) <= $3566c122b734ed10$var$TOL || Math.abs(Math.abs(phi2) - (0, $jVGH7.HALF_PI)) <= $3566c122b734ed10$var$TOL) throw new Error();
    }
    var one_es = 1.0 - this.es;
    com = Math.sqrt(one_es);
    if (Math.abs(this.lat0) > (0, $jVGH7.EPSLN)) {
        sinph0 = Math.sin(this.lat0);
        cosph0 = Math.cos(this.lat0);
        con = 1 - this.es * sinph0 * sinph0;
        this.B = cosph0 * cosph0;
        this.B = Math.sqrt(1 + this.es * this.B * this.B / one_es);
        this.A = this.B * this.k0 * com / con;
        D = this.B * com / (cosph0 * Math.sqrt(con));
        F = D * D - 1;
        if (F <= 0) F = 0;
        else {
            F = Math.sqrt(F);
            if (this.lat0 < 0) F = -F;
        }
        this.E = F += D;
        this.E *= Math.pow((0, $1fd05693455a46f8$export$2e2bcd8739ae039)(this.e, this.lat0, sinph0), this.B);
    } else {
        this.B = 1 / com;
        this.A = this.k0;
        this.E = D = F = 1;
    }
    if (alp || gam) {
        if (alp) {
            gamma0 = Math.asin(Math.sin(alpha_c) / D);
            if (!gam) gamma = alpha_c;
        } else {
            gamma0 = gamma;
            alpha_c = Math.asin(D * Math.sin(gamma0));
        }
        this.lam0 = lamc - Math.asin(0.5 * (F - 1 / F) * Math.tan(gamma0)) / this.B;
    } else {
        H = Math.pow((0, $1fd05693455a46f8$export$2e2bcd8739ae039)(this.e, phi1, Math.sin(phi1)), this.B);
        L = Math.pow((0, $1fd05693455a46f8$export$2e2bcd8739ae039)(this.e, phi2, Math.sin(phi2)), this.B);
        F = this.E / H;
        p = (L - H) / (L + H);
        J = this.E * this.E;
        J = (J - L * H) / (J + L * H);
        con = lam1 - lam2;
        if (con < -Math.PI) lam2 -= (0, $jVGH7.TWO_PI);
        else if (con > Math.PI) lam2 += (0, $jVGH7.TWO_PI);
        this.lam0 = (0, $186WS.default)(0.5 * (lam1 + lam2) - Math.atan(J * Math.tan(0.5 * this.B * (lam1 - lam2)) / p) / this.B);
        gamma0 = Math.atan(2 * Math.sin(this.B * (0, $186WS.default)(lam1 - this.lam0)) / (F - 1 / F));
        gamma = alpha_c = Math.asin(D * Math.sin(gamma0));
    }
    this.singam = Math.sin(gamma0);
    this.cosgam = Math.cos(gamma0);
    this.sinrot = Math.sin(gamma);
    this.cosrot = Math.cos(gamma);
    this.rB = 1 / this.B;
    this.ArB = this.A * this.rB;
    this.BrA = 1 / this.ArB;
    if (this.no_off) this.u_0 = 0;
    else {
        this.u_0 = Math.abs(this.ArB * Math.atan(Math.sqrt(D * D - 1) / Math.cos(alpha_c)));
        if (this.lat0 < 0) this.u_0 = -this.u_0;
    }
    F = 0.5 * gamma0;
    this.v_pole_n = this.ArB * Math.log(Math.tan((0, $jVGH7.FORTPI) - F));
    this.v_pole_s = this.ArB * Math.log(Math.tan((0, $jVGH7.FORTPI) + F));
}
function $3566c122b734ed10$export$174bb771924e7eb1(p) {
    var coords = {};
    var S, T, U, V, W, temp, u, v;
    p.x = p.x - this.lam0;
    if (Math.abs(Math.abs(p.y) - (0, $jVGH7.HALF_PI)) > (0, $jVGH7.EPSLN)) {
        W = this.E / Math.pow((0, $1fd05693455a46f8$export$2e2bcd8739ae039)(this.e, p.y, Math.sin(p.y)), this.B);
        temp = 1 / W;
        S = 0.5 * (W - temp);
        T = 0.5 * (W + temp);
        V = Math.sin(this.B * p.x);
        U = (S * this.singam - V * this.cosgam) / T;
        if (Math.abs(Math.abs(U) - 1.0) < (0, $jVGH7.EPSLN)) throw new Error();
        v = 0.5 * this.ArB * Math.log((1 - U) / (1 + U));
        temp = Math.cos(this.B * p.x);
        if (Math.abs(temp) < $3566c122b734ed10$var$TOL) u = this.A * p.x;
        else u = this.ArB * Math.atan2(S * this.cosgam + V * this.singam, temp);
    } else {
        v = p.y > 0 ? this.v_pole_n : this.v_pole_s;
        u = this.ArB * p.y;
    }
    if (this.no_rot) {
        coords.x = u;
        coords.y = v;
    } else {
        u -= this.u_0;
        coords.x = v * this.cosrot + u * this.sinrot;
        coords.y = u * this.cosrot - v * this.sinrot;
    }
    coords.x = this.a * coords.x + this.x0;
    coords.y = this.a * coords.y + this.y0;
    return coords;
}
function $3566c122b734ed10$export$70ae2c07e401031b(p) {
    var u, v, Qp, Sp, Tp, Vp, Up;
    var coords = {};
    p.x = (p.x - this.x0) * (1.0 / this.a);
    p.y = (p.y - this.y0) * (1.0 / this.a);
    if (this.no_rot) {
        v = p.y;
        u = p.x;
    } else {
        v = p.x * this.cosrot - p.y * this.sinrot;
        u = p.y * this.cosrot + p.x * this.sinrot + this.u_0;
    }
    Qp = Math.exp(-this.BrA * v);
    Sp = 0.5 * (Qp - 1 / Qp);
    Tp = 0.5 * (Qp + 1 / Qp);
    Vp = Math.sin(this.BrA * u);
    Up = (Vp * this.cosgam + Sp * this.singam) / Tp;
    if (Math.abs(Math.abs(Up) - 1) < (0, $jVGH7.EPSLN)) {
        coords.x = 0;
        coords.y = Up < 0 ? -(0, $jVGH7.HALF_PI) : (0, $jVGH7.HALF_PI);
    } else {
        coords.y = this.E / Math.sqrt((1 + Up) / (1 - Up));
        coords.y = (0, $d9cf96cf291e0f24$export$2e2bcd8739ae039)(this.e, Math.pow(coords.y, 1 / this.B));
        if (coords.y === Infinity) throw new Error();
        coords.x = -this.rB * Math.atan2(Sp * this.cosgam - Vp * this.singam, Math.cos(this.BrA * u));
    }
    coords.x += this.lam0;
    return coords;
}
var $3566c122b734ed10$export$e4b2ac9215619f8d = [
    "Hotine_Oblique_Mercator",
    "Hotine Oblique Mercator",
    "Hotine_Oblique_Mercator_variant_A",
    "Hotine_Oblique_Mercator_Variant_B",
    "Hotine_Oblique_Mercator_Azimuth_Natural_Origin",
    "Hotine_Oblique_Mercator_Two_Point_Natural_Origin",
    "Hotine_Oblique_Mercator_Azimuth_Center",
    "Oblique_Mercator",
    "omerc"
];
var $3566c122b734ed10$export$2e2bcd8739ae039 = {
    init: $3566c122b734ed10$export$2cd8252107eb640b,
    forward: $3566c122b734ed10$export$174bb771924e7eb1,
    inverse: $3566c122b734ed10$export$70ae2c07e401031b,
    names: $3566c122b734ed10$export$e4b2ac9215619f8d
};



var $ao8xz = parcelRequire("ao8xz");


var $45Ucl = parcelRequire("45Ucl");

var $186WS = parcelRequire("186WS");


var $jVGH7 = parcelRequire("jVGH7");
function $9b86752aaa99cc3b$export$2cd8252107eb640b() {
    // double lat0;                    /* the reference latitude               */
    // double long0;                   /* the reference longitude              */
    // double lat1;                    /* first standard parallel              */
    // double lat2;                    /* second standard parallel             */
    // double r_maj;                   /* major axis                           */
    // double r_min;                   /* minor axis                           */
    // double false_east;              /* x offset in meters                   */
    // double false_north;             /* y offset in meters                   */
    // the above value can be set with proj4.defs
    // example: proj4.defs("EPSG:2154","+proj=lcc +lat_1=49 +lat_2=44 +lat_0=46.5 +lon_0=3 +x_0=700000 +y_0=6600000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs");
    if (!this.lat2) this.lat2 = this.lat1;
     // if lat2 is not defined
    if (!this.k0) this.k0 = 1;
    this.x0 = this.x0 || 0;
    this.y0 = this.y0 || 0;
    // Standard Parallels cannot be equal and on opposite sides of the equator
    if (Math.abs(this.lat1 + this.lat2) < (0, $jVGH7.EPSLN)) return;
    var temp = this.b / this.a;
    this.e = Math.sqrt(1 - temp * temp);
    var sin1 = Math.sin(this.lat1);
    var cos1 = Math.cos(this.lat1);
    var ms1 = (0, $ao8xz.default)(this.e, sin1, cos1);
    var ts1 = (0, $1fd05693455a46f8$export$2e2bcd8739ae039)(this.e, this.lat1, sin1);
    var sin2 = Math.sin(this.lat2);
    var cos2 = Math.cos(this.lat2);
    var ms2 = (0, $ao8xz.default)(this.e, sin2, cos2);
    var ts2 = (0, $1fd05693455a46f8$export$2e2bcd8739ae039)(this.e, this.lat2, sin2);
    var ts0 = Math.abs(Math.abs(this.lat0) - (0, $jVGH7.HALF_PI)) < (0, $jVGH7.EPSLN) ? 0 // Handle poles by setting ts0 to 0
     : (0, $1fd05693455a46f8$export$2e2bcd8739ae039)(this.e, this.lat0, Math.sin(this.lat0));
    if (Math.abs(this.lat1 - this.lat2) > (0, $jVGH7.EPSLN)) this.ns = Math.log(ms1 / ms2) / Math.log(ts1 / ts2);
    else this.ns = sin1;
    if (isNaN(this.ns)) this.ns = sin1;
    this.f0 = ms1 / (this.ns * Math.pow(ts1, this.ns));
    this.rh = this.a * this.f0 * Math.pow(ts0, this.ns);
    if (!this.title) this.title = "Lambert Conformal Conic";
}
function $9b86752aaa99cc3b$export$174bb771924e7eb1(p) {
    var lon = p.x;
    var lat = p.y;
    // singular cases :
    if (Math.abs(2 * Math.abs(lat) - Math.PI) <= (0, $jVGH7.EPSLN)) lat = (0, $45Ucl.default)(lat) * ((0, $jVGH7.HALF_PI) - 2 * (0, $jVGH7.EPSLN));
    var con = Math.abs(Math.abs(lat) - (0, $jVGH7.HALF_PI));
    var ts, rh1;
    if (con > (0, $jVGH7.EPSLN)) {
        ts = (0, $1fd05693455a46f8$export$2e2bcd8739ae039)(this.e, lat, Math.sin(lat));
        rh1 = this.a * this.f0 * Math.pow(ts, this.ns);
    } else {
        con = lat * this.ns;
        if (con <= 0) return null;
        rh1 = 0;
    }
    var theta = this.ns * (0, $186WS.default)(lon - this.long0);
    p.x = this.k0 * (rh1 * Math.sin(theta)) + this.x0;
    p.y = this.k0 * (this.rh - rh1 * Math.cos(theta)) + this.y0;
    return p;
}
function $9b86752aaa99cc3b$export$70ae2c07e401031b(p) {
    var rh1, con, ts;
    var lat, lon;
    var x = (p.x - this.x0) / this.k0;
    var y = this.rh - (p.y - this.y0) / this.k0;
    if (this.ns > 0) {
        rh1 = Math.sqrt(x * x + y * y);
        con = 1;
    } else {
        rh1 = -Math.sqrt(x * x + y * y);
        con = -1;
    }
    var theta = 0;
    if (rh1 !== 0) theta = Math.atan2(con * x, con * y);
    if (rh1 !== 0 || this.ns > 0) {
        con = 1 / this.ns;
        ts = Math.pow(rh1 / (this.a * this.f0), con);
        lat = (0, $d9cf96cf291e0f24$export$2e2bcd8739ae039)(this.e, ts);
        if (lat === -9999) return null;
    } else lat = -(0, $jVGH7.HALF_PI);
    lon = (0, $186WS.default)(theta / this.ns + this.long0);
    p.x = lon;
    p.y = lat;
    return p;
}
var $9b86752aaa99cc3b$export$e4b2ac9215619f8d = [
    "Lambert Tangential Conformal Conic Projection",
    "Lambert_Conformal_Conic",
    "Lambert_Conformal_Conic_1SP",
    "Lambert_Conformal_Conic_2SP",
    "lcc",
    "Lambert Conic Conformal (1SP)",
    "Lambert Conic Conformal (2SP)"
];
var $9b86752aaa99cc3b$export$2e2bcd8739ae039 = {
    init: $9b86752aaa99cc3b$export$2cd8252107eb640b,
    forward: $9b86752aaa99cc3b$export$174bb771924e7eb1,
    inverse: $9b86752aaa99cc3b$export$70ae2c07e401031b,
    names: $9b86752aaa99cc3b$export$e4b2ac9215619f8d
};



var $186WS = parcelRequire("186WS");
function $eac2b833dce4b7da$export$2cd8252107eb640b() {
    this.a = 6377397.155;
    this.es = 0.006674372230614;
    this.e = Math.sqrt(this.es);
    if (!this.lat0) this.lat0 = 0.863937979737193;
    if (!this.long0) this.long0 = 0.4334234309119251;
    /* if scale not set default to 0.9999 */ if (!this.k0) this.k0 = 0.9999;
    this.s45 = 0.785398163397448; /* 45 */ 
    this.s90 = 2 * this.s45;
    this.fi0 = this.lat0;
    this.e2 = this.es;
    this.e = Math.sqrt(this.e2);
    this.alfa = Math.sqrt(1 + this.e2 * Math.pow(Math.cos(this.fi0), 4) / (1 - this.e2));
    this.uq = 1.04216856380474;
    this.u0 = Math.asin(Math.sin(this.fi0) / this.alfa);
    this.g = Math.pow((1 + this.e * Math.sin(this.fi0)) / (1 - this.e * Math.sin(this.fi0)), this.alfa * this.e / 2);
    this.k = Math.tan(this.u0 / 2 + this.s45) / Math.pow(Math.tan(this.fi0 / 2 + this.s45), this.alfa) * this.g;
    this.k1 = this.k0;
    this.n0 = this.a * Math.sqrt(1 - this.e2) / (1 - this.e2 * Math.pow(Math.sin(this.fi0), 2));
    this.s0 = 1.37008346281555;
    this.n = Math.sin(this.s0);
    this.ro0 = this.k1 * this.n0 / Math.tan(this.s0);
    this.ad = this.s90 - this.uq;
}
function $eac2b833dce4b7da$export$174bb771924e7eb1(p) {
    var gfi, u, deltav, s, d, eps, ro;
    var lon = p.x;
    var lat = p.y;
    var delta_lon = (0, $186WS.default)(lon - this.long0);
    /* Transformation */ gfi = Math.pow((1 + this.e * Math.sin(lat)) / (1 - this.e * Math.sin(lat)), this.alfa * this.e / 2);
    u = 2 * (Math.atan(this.k * Math.pow(Math.tan(lat / 2 + this.s45), this.alfa) / gfi) - this.s45);
    deltav = -delta_lon * this.alfa;
    s = Math.asin(Math.cos(this.ad) * Math.sin(u) + Math.sin(this.ad) * Math.cos(u) * Math.cos(deltav));
    d = Math.asin(Math.cos(u) * Math.sin(deltav) / Math.cos(s));
    eps = this.n * d;
    ro = this.ro0 * Math.pow(Math.tan(this.s0 / 2 + this.s45), this.n) / Math.pow(Math.tan(s / 2 + this.s45), this.n);
    p.y = ro * Math.cos(eps) / 1;
    p.x = ro * Math.sin(eps) / 1;
    if (!this.czech) {
        p.y *= -1;
        p.x *= -1;
    }
    return p;
}
function $eac2b833dce4b7da$export$70ae2c07e401031b(p) {
    var u, deltav, s, d, eps, ro, fi1;
    var ok;
    /* Transformation */ /* revert y, x */ var tmp = p.x;
    p.x = p.y;
    p.y = tmp;
    if (!this.czech) {
        p.y *= -1;
        p.x *= -1;
    }
    ro = Math.sqrt(p.x * p.x + p.y * p.y);
    eps = Math.atan2(p.y, p.x);
    d = eps / Math.sin(this.s0);
    s = 2 * (Math.atan(Math.pow(this.ro0 / ro, 1 / this.n) * Math.tan(this.s0 / 2 + this.s45)) - this.s45);
    u = Math.asin(Math.cos(this.ad) * Math.sin(s) - Math.sin(this.ad) * Math.cos(s) * Math.cos(d));
    deltav = Math.asin(Math.cos(s) * Math.sin(d) / Math.cos(u));
    p.x = this.long0 - deltav / this.alfa;
    fi1 = u;
    ok = 0;
    var iter = 0;
    do {
        p.y = 2 * (Math.atan(Math.pow(this.k, -1 / this.alfa) * Math.pow(Math.tan(u / 2 + this.s45), 1 / this.alfa) * Math.pow((1 + this.e * Math.sin(fi1)) / (1 - this.e * Math.sin(fi1)), this.e / 2)) - this.s45);
        if (Math.abs(fi1 - p.y) < 0.0000000001) ok = 1;
        fi1 = p.y;
        iter += 1;
    }while (ok === 0 && iter < 15);
    if (iter >= 15) return null;
    return p;
}
var $eac2b833dce4b7da$export$e4b2ac9215619f8d = [
    "Krovak",
    "krovak"
];
var $eac2b833dce4b7da$export$2e2bcd8739ae039 = {
    init: $eac2b833dce4b7da$export$2cd8252107eb640b,
    forward: $eac2b833dce4b7da$export$174bb771924e7eb1,
    inverse: $eac2b833dce4b7da$export$70ae2c07e401031b,
    names: $eac2b833dce4b7da$export$e4b2ac9215619f8d
};


function $3dc6096878ca0e32$export$2e2bcd8739ae039(e0, e1, e2, e3, phi) {
    return e0 * phi - e1 * Math.sin(2 * phi) + e2 * Math.sin(4 * phi) - e3 * Math.sin(6 * phi);
}


function $9d4fc5743e2bea0f$export$2e2bcd8739ae039(x) {
    return 1 - 0.25 * x * (1 + x / 16 * (3 + 1.25 * x));
}


function $c5c37487e2f50fb0$export$2e2bcd8739ae039(x) {
    return 0.375 * x * (1 + 0.25 * x * (1 + 0.46875 * x));
}


function $8eab0ca873cfb51b$export$2e2bcd8739ae039(x) {
    return 0.05859375 * x * x * (1 + 0.75 * x);
}


function $2d1d8edef9796095$export$2e2bcd8739ae039(x) {
    return x * x * x * (35 / 3072);
}


function $b26d524e29989c20$export$2e2bcd8739ae039(a, e, sinphi) {
    var temp = e * sinphi;
    return a / Math.sqrt(1 - temp * temp);
}



var $186WS = parcelRequire("186WS");

var $jVGH7 = parcelRequire("jVGH7");

var $45Ucl = parcelRequire("45Ucl");
function $5e9ef618071d6e3b$export$2e2bcd8739ae039(x) {
    return Math.abs(x) < (0, $jVGH7.HALF_PI) ? x : x - (0, $45Ucl.default)(x) * Math.PI;
}


function $2811fe0fe86055bd$export$2e2bcd8739ae039(ml, e0, e1, e2, e3) {
    var phi;
    var dphi;
    phi = ml / e0;
    for(var i = 0; i < 15; i++){
        dphi = (ml - (e0 * phi - e1 * Math.sin(2 * phi) + e2 * Math.sin(4 * phi) - e3 * Math.sin(6 * phi))) / (e0 - 2 * e1 * Math.cos(2 * phi) + 4 * e2 * Math.cos(4 * phi) - 6 * e3 * Math.cos(6 * phi));
        phi += dphi;
        if (Math.abs(dphi) <= 0.0000000001) return phi;
    }
    // ..reportError("IMLFN-CONV:Latitude failed to converge after 15 iterations");
    return NaN;
}



var $jVGH7 = parcelRequire("jVGH7");
function $b68c64924618a152$export$2cd8252107eb640b() {
    if (!this.sphere) {
        this.e0 = (0, $9d4fc5743e2bea0f$export$2e2bcd8739ae039)(this.es);
        this.e1 = (0, $c5c37487e2f50fb0$export$2e2bcd8739ae039)(this.es);
        this.e2 = (0, $8eab0ca873cfb51b$export$2e2bcd8739ae039)(this.es);
        this.e3 = (0, $2d1d8edef9796095$export$2e2bcd8739ae039)(this.es);
        this.ml0 = this.a * (0, $3dc6096878ca0e32$export$2e2bcd8739ae039)(this.e0, this.e1, this.e2, this.e3, this.lat0);
    }
}
function $b68c64924618a152$export$174bb771924e7eb1(p) {
    /* Forward equations
      ----------------- */ var x, y;
    var lam = p.x;
    var phi = p.y;
    lam = (0, $186WS.default)(lam - this.long0);
    if (this.sphere) {
        x = this.a * Math.asin(Math.cos(phi) * Math.sin(lam));
        y = this.a * (Math.atan2(Math.tan(phi), Math.cos(lam)) - this.lat0);
    } else {
        // ellipsoid
        var sinphi = Math.sin(phi);
        var cosphi = Math.cos(phi);
        var nl = (0, $b26d524e29989c20$export$2e2bcd8739ae039)(this.a, this.e, sinphi);
        var tl = Math.tan(phi) * Math.tan(phi);
        var al = lam * Math.cos(phi);
        var asq = al * al;
        var cl = this.es * cosphi * cosphi / (1 - this.es);
        var ml = this.a * (0, $3dc6096878ca0e32$export$2e2bcd8739ae039)(this.e0, this.e1, this.e2, this.e3, phi);
        x = nl * al * (1 - asq * tl * (1 / 6 - (8 - tl + 8 * cl) * asq / 120));
        y = ml - this.ml0 + nl * sinphi / cosphi * asq * (0.5 + (5 - tl + 6 * cl) * asq / 24);
    }
    p.x = x + this.x0;
    p.y = y + this.y0;
    return p;
}
function $b68c64924618a152$export$70ae2c07e401031b(p) {
    p.x -= this.x0;
    p.y -= this.y0;
    var x = p.x / this.a;
    var y = p.y / this.a;
    var phi, lam;
    if (this.sphere) {
        var dd = y + this.lat0;
        phi = Math.asin(Math.sin(dd) * Math.cos(x));
        lam = Math.atan2(Math.tan(x), Math.cos(dd));
    } else {
        /* ellipsoid */ var ml1 = this.ml0 / this.a + y;
        var phi1 = (0, $2811fe0fe86055bd$export$2e2bcd8739ae039)(ml1, this.e0, this.e1, this.e2, this.e3);
        if (Math.abs(Math.abs(phi1) - (0, $jVGH7.HALF_PI)) <= (0, $jVGH7.EPSLN)) {
            p.x = this.long0;
            p.y = (0, $jVGH7.HALF_PI);
            if (y < 0) p.y *= -1;
            return p;
        }
        var nl1 = (0, $b26d524e29989c20$export$2e2bcd8739ae039)(this.a, this.e, Math.sin(phi1));
        var rl1 = nl1 * nl1 * nl1 / this.a / this.a * (1 - this.es);
        var tl1 = Math.pow(Math.tan(phi1), 2);
        var dl = x * this.a / nl1;
        var dsq = dl * dl;
        phi = phi1 - nl1 * Math.tan(phi1) / rl1 * dl * dl * (0.5 - (1 + 3 * tl1) * dl * dl / 24);
        lam = dl * (1 - dsq * (tl1 / 3 + (1 + 3 * tl1) * tl1 * dsq / 15)) / Math.cos(phi1);
    }
    p.x = (0, $186WS.default)(lam + this.long0);
    p.y = (0, $5e9ef618071d6e3b$export$2e2bcd8739ae039)(phi);
    return p;
}
var $b68c64924618a152$export$e4b2ac9215619f8d = [
    "Cassini",
    "Cassini_Soldner",
    "cass"
];
var $b68c64924618a152$export$2e2bcd8739ae039 = {
    init: $b68c64924618a152$export$2cd8252107eb640b,
    forward: $b68c64924618a152$export$174bb771924e7eb1,
    inverse: $b68c64924618a152$export$70ae2c07e401031b,
    names: $b68c64924618a152$export$e4b2ac9215619f8d
};



var $bLuvW = parcelRequire("bLuvW");

var $fNzYi = parcelRequire("fNzYi");

var $186WS = parcelRequire("186WS");

var $9sUpR = parcelRequire("9sUpR");

var $jVGH7 = parcelRequire("jVGH7");
function $25cea8f4ad97de74$export$2cd8252107eb640b() {
    /* Place parameters in static storage for common use
      ------------------------------------------------- */ this.sin_p14 = Math.sin(this.lat0);
    this.cos_p14 = Math.cos(this.lat0);
    // Approximation for projecting points to the horizon (infinity)
    this.infinity_dist = 1000 * this.a;
    this.rc = 1;
}
function $25cea8f4ad97de74$export$174bb771924e7eb1(p) {
    var sinphi, cosphi; /* sin and cos value        */ 
    var dlon; /* delta longitude value      */ 
    var coslon; /* cos of longitude        */ 
    var ksp; /* scale factor          */ 
    var g;
    var x, y;
    var lon = p.x;
    var lat = p.y;
    /* Forward equations
      ----------------- */ dlon = (0, $186WS.default)(lon - this.long0);
    sinphi = Math.sin(lat);
    cosphi = Math.cos(lat);
    coslon = Math.cos(dlon);
    g = this.sin_p14 * sinphi + this.cos_p14 * cosphi * coslon;
    ksp = 1;
    if (g > 0 || Math.abs(g) <= (0, $jVGH7.EPSLN)) {
        x = this.x0 + this.a * ksp * cosphi * Math.sin(dlon) / g;
        y = this.y0 + this.a * ksp * (this.cos_p14 * sinphi - this.sin_p14 * cosphi * coslon) / g;
    } else {
        // Point is in the opposing hemisphere and is unprojectable
        // We still need to return a reasonable point, so we project
        // to infinity, on a bearing
        // equivalent to the northern hemisphere equivalent
        // This is a reasonable approximation for short shapes and lines that
        // straddle the horizon.
        x = this.x0 + this.infinity_dist * cosphi * Math.sin(dlon);
        y = this.y0 + this.infinity_dist * (this.cos_p14 * sinphi - this.sin_p14 * cosphi * coslon);
    }
    p.x = x;
    p.y = y;
    return p;
}
function $25cea8f4ad97de74$export$70ae2c07e401031b(p) {
    var rh; /* Rho */ 
    var sinc, cosc;
    var c;
    var lon, lat;
    /* Inverse equations
      ----------------- */ p.x = (p.x - this.x0) / this.a;
    p.y = (p.y - this.y0) / this.a;
    p.x /= this.k0;
    p.y /= this.k0;
    if (rh = Math.sqrt(p.x * p.x + p.y * p.y)) {
        c = Math.atan2(rh, this.rc);
        sinc = Math.sin(c);
        cosc = Math.cos(c);
        lat = (0, $9sUpR.default)(cosc * this.sin_p14 + p.y * sinc * this.cos_p14 / rh);
        lon = Math.atan2(p.x * sinc, rh * this.cos_p14 * cosc - p.y * this.sin_p14 * sinc);
        lon = (0, $186WS.default)(this.long0 + lon);
    } else {
        lat = this.phic0;
        lon = 0;
    }
    p.x = lon;
    p.y = lat;
    return p;
}
var $25cea8f4ad97de74$export$e4b2ac9215619f8d = [
    "gnom"
];
var $25cea8f4ad97de74$export$2e2bcd8739ae039 = {
    init: $25cea8f4ad97de74$export$2cd8252107eb640b,
    forward: $25cea8f4ad97de74$export$174bb771924e7eb1,
    inverse: $25cea8f4ad97de74$export$70ae2c07e401031b,
    names: $25cea8f4ad97de74$export$e4b2ac9215619f8d
};



var $186WS = parcelRequire("186WS");

var $axRvQ = parcelRequire("axRvQ");

var $ao8xz = parcelRequire("ao8xz");

var $jVGH7 = parcelRequire("jVGH7");
function $0b8c78ef0ccb9e57$export$2e2bcd8739ae039(eccent, q) {
    var temp = 1 - (1 - eccent * eccent) / (2 * eccent) * Math.log((1 - eccent) / (1 + eccent));
    if (Math.abs(Math.abs(q) - temp) < 1.0E-6) {
        if (q < 0) return -1 * (0, $jVGH7.HALF_PI);
        else return 0, $jVGH7.HALF_PI;
    }
    // var phi = 0.5* q/(1-eccent*eccent);
    var phi = Math.asin(0.5 * q);
    var dphi;
    var sin_phi;
    var cos_phi;
    var con;
    for(var i = 0; i < 30; i++){
        sin_phi = Math.sin(phi);
        cos_phi = Math.cos(phi);
        con = eccent * sin_phi;
        dphi = Math.pow(1 - con * con, 2) / (2 * cos_phi) * (q / (1 - eccent * eccent) - sin_phi / (1 - con * con) + 0.5 / eccent * Math.log((1 - con) / (1 + con)));
        phi += dphi;
        if (Math.abs(dphi) <= 0.0000000001) return phi;
    }
    // console.log("IQSFN-CONV:Latitude failed to converge after 30 iterations");
    return NaN;
}


function $1cbf69e6a792f5dc$export$2cd8252107eb640b() {
    // no-op
    if (!this.sphere) this.k0 = (0, $ao8xz.default)(this.e, Math.sin(this.lat_ts), Math.cos(this.lat_ts));
}
function $1cbf69e6a792f5dc$export$174bb771924e7eb1(p) {
    var lon = p.x;
    var lat = p.y;
    var x, y;
    /* Forward equations
      ----------------- */ var dlon = (0, $186WS.default)(lon - this.long0);
    if (this.sphere) {
        x = this.x0 + this.a * dlon * Math.cos(this.lat_ts);
        y = this.y0 + this.a * Math.sin(lat) / Math.cos(this.lat_ts);
    } else {
        var qs = (0, $axRvQ.default)(this.e, Math.sin(lat));
        x = this.x0 + this.a * this.k0 * dlon;
        y = this.y0 + this.a * qs * 0.5 / this.k0;
    }
    p.x = x;
    p.y = y;
    return p;
}
function $1cbf69e6a792f5dc$export$70ae2c07e401031b(p) {
    p.x -= this.x0;
    p.y -= this.y0;
    var lon, lat;
    if (this.sphere) {
        lon = (0, $186WS.default)(this.long0 + p.x / this.a / Math.cos(this.lat_ts));
        lat = Math.asin(p.y / this.a * Math.cos(this.lat_ts));
    } else {
        lat = (0, $0b8c78ef0ccb9e57$export$2e2bcd8739ae039)(this.e, 2 * p.y * this.k0 / this.a);
        lon = (0, $186WS.default)(this.long0 + p.x / (this.a * this.k0));
    }
    p.x = lon;
    p.y = lat;
    return p;
}
var $1cbf69e6a792f5dc$export$e4b2ac9215619f8d = [
    "cea"
];
var $1cbf69e6a792f5dc$export$2e2bcd8739ae039 = {
    init: $1cbf69e6a792f5dc$export$2cd8252107eb640b,
    forward: $1cbf69e6a792f5dc$export$174bb771924e7eb1,
    inverse: $1cbf69e6a792f5dc$export$70ae2c07e401031b,
    names: $1cbf69e6a792f5dc$export$e4b2ac9215619f8d
};



var $186WS = parcelRequire("186WS");

function $4ae3f27f6655e1e5$export$2cd8252107eb640b() {
    this.x0 = this.x0 || 0;
    this.y0 = this.y0 || 0;
    this.lat0 = this.lat0 || 0;
    this.long0 = this.long0 || 0;
    this.lat_ts = this.lat_ts || 0;
    this.title = this.title || "Equidistant Cylindrical (Plate Carre)";
    this.rc = Math.cos(this.lat_ts);
}
function $4ae3f27f6655e1e5$export$174bb771924e7eb1(p) {
    var lon = p.x;
    var lat = p.y;
    var dlon = (0, $186WS.default)(lon - this.long0);
    var dlat = (0, $5e9ef618071d6e3b$export$2e2bcd8739ae039)(lat - this.lat0);
    p.x = this.x0 + this.a * dlon * this.rc;
    p.y = this.y0 + this.a * dlat;
    return p;
}
function $4ae3f27f6655e1e5$export$70ae2c07e401031b(p) {
    var x = p.x;
    var y = p.y;
    p.x = (0, $186WS.default)(this.long0 + (x - this.x0) / (this.a * this.rc));
    p.y = (0, $5e9ef618071d6e3b$export$2e2bcd8739ae039)(this.lat0 + (y - this.y0) / this.a);
    return p;
}
var $4ae3f27f6655e1e5$export$e4b2ac9215619f8d = [
    "Equirectangular",
    "Equidistant_Cylindrical",
    "Equidistant_Cylindrical_Spherical",
    "eqc"
];
var $4ae3f27f6655e1e5$export$2e2bcd8739ae039 = {
    init: $4ae3f27f6655e1e5$export$2cd8252107eb640b,
    forward: $4ae3f27f6655e1e5$export$174bb771924e7eb1,
    inverse: $4ae3f27f6655e1e5$export$70ae2c07e401031b,
    names: $4ae3f27f6655e1e5$export$e4b2ac9215619f8d
};







var $186WS = parcelRequire("186WS");



var $jVGH7 = parcelRequire("jVGH7");

/**
 * @typedef {Object} LocalThis
 * @property {number} temp
 * @property {number} es
 * @property {number} e
 * @property {number} e0
 * @property {number} e1
 * @property {number} e2
 * @property {number} e3
 * @property {number} ml0
 */ var $a1ba7e59704eb1bc$var$MAX_ITER = 20;
function $a1ba7e59704eb1bc$export$2cd8252107eb640b() {
    /* Place parameters in static storage for common use
      ------------------------------------------------- */ this.temp = this.b / this.a;
    this.es = 1 - Math.pow(this.temp, 2); // devait etre dans tmerc.js mais n y est pas donc je commente sinon retour de valeurs nulles
    this.e = Math.sqrt(this.es);
    this.e0 = (0, $9d4fc5743e2bea0f$export$2e2bcd8739ae039)(this.es);
    this.e1 = (0, $c5c37487e2f50fb0$export$2e2bcd8739ae039)(this.es);
    this.e2 = (0, $8eab0ca873cfb51b$export$2e2bcd8739ae039)(this.es);
    this.e3 = (0, $2d1d8edef9796095$export$2e2bcd8739ae039)(this.es);
    this.ml0 = this.a * (0, $3dc6096878ca0e32$export$2e2bcd8739ae039)(this.e0, this.e1, this.e2, this.e3, this.lat0); // si que des zeros le calcul ne se fait pas
}
function $a1ba7e59704eb1bc$export$174bb771924e7eb1(p) {
    var lon = p.x;
    var lat = p.y;
    var x, y, el;
    var dlon = (0, $186WS.default)(lon - this.long0);
    el = dlon * Math.sin(lat);
    if (this.sphere) {
        if (Math.abs(lat) <= (0, $jVGH7.EPSLN)) {
            x = this.a * dlon;
            y = -1 * this.a * this.lat0;
        } else {
            x = this.a * Math.sin(el) / Math.tan(lat);
            y = this.a * ((0, $5e9ef618071d6e3b$export$2e2bcd8739ae039)(lat - this.lat0) + (1 - Math.cos(el)) / Math.tan(lat));
        }
    } else if (Math.abs(lat) <= (0, $jVGH7.EPSLN)) {
        x = this.a * dlon;
        y = -1 * this.ml0;
    } else {
        var nl = (0, $b26d524e29989c20$export$2e2bcd8739ae039)(this.a, this.e, Math.sin(lat)) / Math.tan(lat);
        x = nl * Math.sin(el);
        y = this.a * (0, $3dc6096878ca0e32$export$2e2bcd8739ae039)(this.e0, this.e1, this.e2, this.e3, lat) - this.ml0 + nl * (1 - Math.cos(el));
    }
    p.x = x + this.x0;
    p.y = y + this.y0;
    return p;
}
function $a1ba7e59704eb1bc$export$70ae2c07e401031b(p) {
    var lon, lat, x, y, i;
    var al, bl;
    var phi, dphi;
    x = p.x - this.x0;
    y = p.y - this.y0;
    if (this.sphere) {
        if (Math.abs(y + this.a * this.lat0) <= (0, $jVGH7.EPSLN)) {
            lon = (0, $186WS.default)(x / this.a + this.long0);
            lat = 0;
        } else {
            al = this.lat0 + y / this.a;
            bl = x * x / this.a / this.a + al * al;
            phi = al;
            var tanphi;
            for(i = $a1ba7e59704eb1bc$var$MAX_ITER; i; --i){
                tanphi = Math.tan(phi);
                dphi = -1 * (al * (phi * tanphi + 1) - phi - 0.5 * (phi * phi + bl) * tanphi) / ((phi - al) / tanphi - 1);
                phi += dphi;
                if (Math.abs(dphi) <= (0, $jVGH7.EPSLN)) {
                    lat = phi;
                    break;
                }
            }
            lon = (0, $186WS.default)(this.long0 + Math.asin(x * Math.tan(phi) / this.a) / Math.sin(lat));
        }
    } else if (Math.abs(y + this.ml0) <= (0, $jVGH7.EPSLN)) {
        lat = 0;
        lon = (0, $186WS.default)(this.long0 + x / this.a);
    } else {
        al = (this.ml0 + y) / this.a;
        bl = x * x / this.a / this.a + al * al;
        phi = al;
        var cl, mln, mlnp, ma;
        var con;
        for(i = $a1ba7e59704eb1bc$var$MAX_ITER; i; --i){
            con = this.e * Math.sin(phi);
            cl = Math.sqrt(1 - con * con) * Math.tan(phi);
            mln = this.a * (0, $3dc6096878ca0e32$export$2e2bcd8739ae039)(this.e0, this.e1, this.e2, this.e3, phi);
            mlnp = this.e0 - 2 * this.e1 * Math.cos(2 * phi) + 4 * this.e2 * Math.cos(4 * phi) - 6 * this.e3 * Math.cos(6 * phi);
            ma = mln / this.a;
            dphi = (al * (cl * ma + 1) - ma - 0.5 * cl * (ma * ma + bl)) / (this.es * Math.sin(2 * phi) * (ma * ma + bl - 2 * al * ma) / (4 * cl) + (al - ma) * (cl * mlnp - 2 / Math.sin(2 * phi)) - mlnp);
            phi -= dphi;
            if (Math.abs(dphi) <= (0, $jVGH7.EPSLN)) {
                lat = phi;
                break;
            }
        }
        // lat=phi4z(this.e,this.e0,this.e1,this.e2,this.e3,al,bl,0,0);
        cl = Math.sqrt(1 - this.es * Math.pow(Math.sin(lat), 2)) * Math.tan(lat);
        lon = (0, $186WS.default)(this.long0 + Math.asin(x * cl / this.a) / Math.sin(lat));
    }
    p.x = lon;
    p.y = lat;
    return p;
}
var $a1ba7e59704eb1bc$export$e4b2ac9215619f8d = [
    "Polyconic",
    "American_Polyconic",
    "poly"
];
var $a1ba7e59704eb1bc$export$2e2bcd8739ae039 = {
    init: $a1ba7e59704eb1bc$export$2cd8252107eb640b,
    forward: $a1ba7e59704eb1bc$export$174bb771924e7eb1,
    inverse: $a1ba7e59704eb1bc$export$70ae2c07e401031b,
    names: $a1ba7e59704eb1bc$export$e4b2ac9215619f8d
};



var $f96MB = parcelRequire("f96MB");

var $186WS = parcelRequire("186WS");
function $a5ace360409b4efe$export$2cd8252107eb640b() {
// no-op
}
function $a5ace360409b4efe$export$174bb771924e7eb1(p) {
    var lon = p.x;
    var lat = p.y;
    /* Forward equations
      ----------------- */ var dlon = (0, $186WS.default)(lon - this.long0);
    var x = this.x0 + this.a * dlon;
    var y = this.y0 + this.a * Math.log(Math.tan(Math.PI / 4 + lat / 2.5)) * 1.25;
    p.x = x;
    p.y = y;
    return p;
}
function $a5ace360409b4efe$export$70ae2c07e401031b(p) {
    p.x -= this.x0;
    p.y -= this.y0;
    var lon = (0, $186WS.default)(this.long0 + p.x / this.a);
    var lat = 2.5 * (Math.atan(Math.exp(0.8 * p.y / this.a)) - Math.PI / 4);
    p.x = lon;
    p.y = lat;
    return p;
}
var $a5ace360409b4efe$export$e4b2ac9215619f8d = [
    "Miller_Cylindrical",
    "mill"
];
var $a5ace360409b4efe$export$2e2bcd8739ae039 = {
    init: $a5ace360409b4efe$export$2cd8252107eb640b,
    forward: $a5ace360409b4efe$export$174bb771924e7eb1,
    inverse: $a5ace360409b4efe$export$70ae2c07e401031b,
    names: $a5ace360409b4efe$export$e4b2ac9215619f8d
};



var $186WS = parcelRequire("186WS");


var $a2vUM = parcelRequire("a2vUM");

var $iX7sK = parcelRequire("iX7sK");

var $bL4ry = parcelRequire("bL4ry");

var $jVGH7 = parcelRequire("jVGH7");

var $9sUpR = parcelRequire("9sUpR");
var $ced6a1dae75e9d8e$var$MAX_ITER = 20;
function $ced6a1dae75e9d8e$export$2cd8252107eb640b() {
    /* Place parameters in static storage for common use
    ------------------------------------------------- */ if (!this.sphere) this.en = (0, $a2vUM.default)(this.es);
    else {
        this.n = 1;
        this.m = 0;
        this.es = 0;
        this.C_y = Math.sqrt((this.m + 1) / this.n);
        this.C_x = this.C_y / (this.m + 1);
    }
}
function $ced6a1dae75e9d8e$export$174bb771924e7eb1(p) {
    var x, y;
    var lon = p.x;
    var lat = p.y;
    /* Forward equations
    ----------------- */ lon = (0, $186WS.default)(lon - this.long0);
    if (this.sphere) {
        if (!this.m) lat = this.n !== 1 ? Math.asin(this.n * Math.sin(lat)) : lat;
        else {
            var k = this.n * Math.sin(lat);
            for(var i = $ced6a1dae75e9d8e$var$MAX_ITER; i; --i){
                var V = (this.m * lat + Math.sin(lat) - k) / (this.m + Math.cos(lat));
                lat -= V;
                if (Math.abs(V) < (0, $jVGH7.EPSLN)) break;
            }
        }
        x = this.a * this.C_x * lon * (this.m + Math.cos(lat));
        y = this.a * this.C_y * lat;
    } else {
        var s = Math.sin(lat);
        var c = Math.cos(lat);
        y = this.a * (0, $iX7sK.default)(lat, s, c, this.en);
        x = this.a * lon * c / Math.sqrt(1 - this.es * s * s);
    }
    p.x = x;
    p.y = y;
    return p;
}
function $ced6a1dae75e9d8e$export$70ae2c07e401031b(p) {
    var lat, temp, lon, s;
    p.x -= this.x0;
    lon = p.x / this.a;
    p.y -= this.y0;
    lat = p.y / this.a;
    if (this.sphere) {
        lat /= this.C_y;
        lon = lon / (this.C_x * (this.m + Math.cos(lat)));
        if (this.m) lat = (0, $9sUpR.default)((this.m * lat + Math.sin(lat)) / this.n);
        else if (this.n !== 1) lat = (0, $9sUpR.default)(Math.sin(lat) / this.n);
        lon = (0, $186WS.default)(lon + this.long0);
        lat = (0, $5e9ef618071d6e3b$export$2e2bcd8739ae039)(lat);
    } else {
        lat = (0, $bL4ry.default)(p.y / this.a, this.es, this.en);
        s = Math.abs(lat);
        if (s < (0, $jVGH7.HALF_PI)) {
            s = Math.sin(lat);
            temp = this.long0 + p.x * Math.sqrt(1 - this.es * s * s) / (this.a * Math.cos(lat));
            // temp = this.long0 + p.x / (this.a * Math.cos(lat));
            lon = (0, $186WS.default)(temp);
        } else if (s - (0, $jVGH7.EPSLN) < (0, $jVGH7.HALF_PI)) lon = this.long0;
    }
    p.x = lon;
    p.y = lat;
    return p;
}
var $ced6a1dae75e9d8e$export$e4b2ac9215619f8d = [
    "Sinusoidal",
    "sinu"
];
var $ced6a1dae75e9d8e$export$2e2bcd8739ae039 = {
    init: $ced6a1dae75e9d8e$export$2cd8252107eb640b,
    forward: $ced6a1dae75e9d8e$export$174bb771924e7eb1,
    inverse: $ced6a1dae75e9d8e$export$70ae2c07e401031b,
    names: $ced6a1dae75e9d8e$export$e4b2ac9215619f8d
};



var $186WS = parcelRequire("186WS");

var $jVGH7 = parcelRequire("jVGH7");
function $ffe241c139dc27b2$export$2cd8252107eb640b() {}
function $ffe241c139dc27b2$export$174bb771924e7eb1(p) {
    /* Forward equations
      ----------------- */ var lon = p.x;
    var lat = p.y;
    var delta_lon = (0, $186WS.default)(lon - this.long0);
    var theta = lat;
    var con = Math.PI * Math.sin(lat);
    /* Iterate using the Newton-Raphson method to find theta
      ----------------------------------------------------- */ while(true){
        var delta_theta = -(theta + Math.sin(theta) - con) / (1 + Math.cos(theta));
        theta += delta_theta;
        if (Math.abs(delta_theta) < (0, $jVGH7.EPSLN)) break;
    }
    theta /= 2;
    /* If the latitude is 90 deg, force the x coordinate to be "0 + false easting"
       this is done here because of precision problems with "cos(theta)"
       -------------------------------------------------------------------------- */ if (Math.PI / 2 - Math.abs(lat) < (0, $jVGH7.EPSLN)) delta_lon = 0;
    var x = 0.900316316158 * this.a * delta_lon * Math.cos(theta) + this.x0;
    var y = 1.4142135623731 * this.a * Math.sin(theta) + this.y0;
    p.x = x;
    p.y = y;
    return p;
}
function $ffe241c139dc27b2$export$70ae2c07e401031b(p) {
    var theta;
    var arg;
    /* Inverse equations
      ----------------- */ p.x -= this.x0;
    p.y -= this.y0;
    arg = p.y / (1.4142135623731 * this.a);
    /* Because of division by zero problems, 'arg' can not be 1.  Therefore
       a number very close to one is used instead.
       ------------------------------------------------------------------- */ if (Math.abs(arg) > 0.999999999999) arg = 0.999999999999;
    theta = Math.asin(arg);
    var lon = (0, $186WS.default)(this.long0 + p.x / (0.900316316158 * this.a * Math.cos(theta)));
    if (lon < -Math.PI) lon = -Math.PI;
    if (lon > Math.PI) lon = Math.PI;
    arg = (2 * theta + Math.sin(2 * theta)) / Math.PI;
    if (Math.abs(arg) > 1) arg = 1;
    var lat = Math.asin(arg);
    p.x = lon;
    p.y = lat;
    return p;
}
var $ffe241c139dc27b2$export$e4b2ac9215619f8d = [
    "Mollweide",
    "moll"
];
var $ffe241c139dc27b2$export$2e2bcd8739ae039 = {
    init: $ffe241c139dc27b2$export$2cd8252107eb640b,
    forward: $ffe241c139dc27b2$export$174bb771924e7eb1,
    inverse: $ffe241c139dc27b2$export$70ae2c07e401031b,
    names: $ffe241c139dc27b2$export$e4b2ac9215619f8d
};







var $ao8xz = parcelRequire("ao8xz");


var $186WS = parcelRequire("186WS");



var $jVGH7 = parcelRequire("jVGH7");
function $3b0a2156b617102a$export$2cd8252107eb640b() {
    /* Place parameters in static storage for common use
      ------------------------------------------------- */ // Standard Parallels cannot be equal and on opposite sides of the equator
    if (Math.abs(this.lat1 + this.lat2) < (0, $jVGH7.EPSLN)) return;
    this.lat2 = this.lat2 || this.lat1;
    this.temp = this.b / this.a;
    this.es = 1 - Math.pow(this.temp, 2);
    this.e = Math.sqrt(this.es);
    this.e0 = (0, $9d4fc5743e2bea0f$export$2e2bcd8739ae039)(this.es);
    this.e1 = (0, $c5c37487e2f50fb0$export$2e2bcd8739ae039)(this.es);
    this.e2 = (0, $8eab0ca873cfb51b$export$2e2bcd8739ae039)(this.es);
    this.e3 = (0, $2d1d8edef9796095$export$2e2bcd8739ae039)(this.es);
    this.sin_phi = Math.sin(this.lat1);
    this.cos_phi = Math.cos(this.lat1);
    this.ms1 = (0, $ao8xz.default)(this.e, this.sin_phi, this.cos_phi);
    this.ml1 = (0, $3dc6096878ca0e32$export$2e2bcd8739ae039)(this.e0, this.e1, this.e2, this.e3, this.lat1);
    if (Math.abs(this.lat1 - this.lat2) < (0, $jVGH7.EPSLN)) this.ns = this.sin_phi;
    else {
        this.sin_phi = Math.sin(this.lat2);
        this.cos_phi = Math.cos(this.lat2);
        this.ms2 = (0, $ao8xz.default)(this.e, this.sin_phi, this.cos_phi);
        this.ml2 = (0, $3dc6096878ca0e32$export$2e2bcd8739ae039)(this.e0, this.e1, this.e2, this.e3, this.lat2);
        this.ns = (this.ms1 - this.ms2) / (this.ml2 - this.ml1);
    }
    this.g = this.ml1 + this.ms1 / this.ns;
    this.ml0 = (0, $3dc6096878ca0e32$export$2e2bcd8739ae039)(this.e0, this.e1, this.e2, this.e3, this.lat0);
    this.rh = this.a * (this.g - this.ml0);
}
function $3b0a2156b617102a$export$174bb771924e7eb1(p) {
    var lon = p.x;
    var lat = p.y;
    var rh1;
    /* Forward equations
      ----------------- */ if (this.sphere) rh1 = this.a * (this.g - lat);
    else {
        var ml = (0, $3dc6096878ca0e32$export$2e2bcd8739ae039)(this.e0, this.e1, this.e2, this.e3, lat);
        rh1 = this.a * (this.g - ml);
    }
    var theta = this.ns * (0, $186WS.default)(lon - this.long0);
    var x = this.x0 + rh1 * Math.sin(theta);
    var y = this.y0 + this.rh - rh1 * Math.cos(theta);
    p.x = x;
    p.y = y;
    return p;
}
function $3b0a2156b617102a$export$70ae2c07e401031b(p) {
    p.x -= this.x0;
    p.y = this.rh - p.y + this.y0;
    var con, rh1, lat, lon;
    if (this.ns >= 0) {
        rh1 = Math.sqrt(p.x * p.x + p.y * p.y);
        con = 1;
    } else {
        rh1 = -Math.sqrt(p.x * p.x + p.y * p.y);
        con = -1;
    }
    var theta = 0;
    if (rh1 !== 0) theta = Math.atan2(con * p.x, con * p.y);
    if (this.sphere) {
        lon = (0, $186WS.default)(this.long0 + theta / this.ns);
        lat = (0, $5e9ef618071d6e3b$export$2e2bcd8739ae039)(this.g - rh1 / this.a);
        p.x = lon;
        p.y = lat;
        return p;
    } else {
        var ml = this.g - rh1 / this.a;
        lat = (0, $2811fe0fe86055bd$export$2e2bcd8739ae039)(ml, this.e0, this.e1, this.e2, this.e3);
        lon = (0, $186WS.default)(this.long0 + theta / this.ns);
        p.x = lon;
        p.y = lat;
        return p;
    }
}
var $3b0a2156b617102a$export$e4b2ac9215619f8d = [
    "Equidistant_Conic",
    "eqdc"
];
var $3b0a2156b617102a$export$2e2bcd8739ae039 = {
    init: $3b0a2156b617102a$export$2cd8252107eb640b,
    forward: $3b0a2156b617102a$export$174bb771924e7eb1,
    inverse: $3b0a2156b617102a$export$70ae2c07e401031b,
    names: $3b0a2156b617102a$export$e4b2ac9215619f8d
};



var $186WS = parcelRequire("186WS");

var $jVGH7 = parcelRequire("jVGH7");

var $9sUpR = parcelRequire("9sUpR");
function $aa03d8084d376ef4$export$2cd8252107eb640b() {
    // this.R = 6370997; //Radius of earth
    this.R = this.a;
}
function $aa03d8084d376ef4$export$174bb771924e7eb1(p) {
    var lon = p.x;
    var lat = p.y;
    /* Forward equations
    ----------------- */ var dlon = (0, $186WS.default)(lon - this.long0);
    var x, y;
    if (Math.abs(lat) <= (0, $jVGH7.EPSLN)) {
        x = this.x0 + this.R * dlon;
        y = this.y0;
    }
    var theta = (0, $9sUpR.default)(2 * Math.abs(lat / Math.PI));
    if (Math.abs(dlon) <= (0, $jVGH7.EPSLN) || Math.abs(Math.abs(lat) - (0, $jVGH7.HALF_PI)) <= (0, $jVGH7.EPSLN)) {
        x = this.x0;
        if (lat >= 0) y = this.y0 + Math.PI * this.R * Math.tan(0.5 * theta);
        else y = this.y0 + Math.PI * this.R * -Math.tan(0.5 * theta);
    //  return(OK);
    }
    var al = 0.5 * Math.abs(Math.PI / dlon - dlon / Math.PI);
    var asq = al * al;
    var sinth = Math.sin(theta);
    var costh = Math.cos(theta);
    var g = costh / (sinth + costh - 1);
    var gsq = g * g;
    var m = g * (2 / sinth - 1);
    var msq = m * m;
    var con = Math.PI * this.R * (al * (g - msq) + Math.sqrt(asq * (g - msq) * (g - msq) - (msq + asq) * (gsq - msq))) / (msq + asq);
    if (dlon < 0) con = -con;
    x = this.x0 + con;
    // con = Math.abs(con / (Math.PI * this.R));
    var q = asq + g;
    con = Math.PI * this.R * (m * q - al * Math.sqrt((msq + asq) * (asq + 1) - q * q)) / (msq + asq);
    if (lat >= 0) // y = this.y0 + Math.PI * this.R * Math.sqrt(1 - con * con - 2 * al * con);
    y = this.y0 + con;
    else // y = this.y0 - Math.PI * this.R * Math.sqrt(1 - con * con - 2 * al * con);
    y = this.y0 - con;
    p.x = x;
    p.y = y;
    return p;
}
function $aa03d8084d376ef4$export$70ae2c07e401031b(p) {
    var lon, lat;
    var xx, yy, xys, c1, c2, c3;
    var a1;
    var m1;
    var con;
    var th1;
    var d;
    /* inverse equations
    ----------------- */ p.x -= this.x0;
    p.y -= this.y0;
    con = Math.PI * this.R;
    xx = p.x / con;
    yy = p.y / con;
    xys = xx * xx + yy * yy;
    c1 = -Math.abs(yy) * (1 + xys);
    c2 = c1 - 2 * yy * yy + xx * xx;
    c3 = -2 * c1 + 1 + 2 * yy * yy + xys * xys;
    d = yy * yy / c3 + (2 * c2 * c2 * c2 / c3 / c3 / c3 - 9 * c1 * c2 / c3 / c3) / 27;
    a1 = (c1 - c2 * c2 / 3 / c3) / c3;
    m1 = 2 * Math.sqrt(-a1 / 3);
    con = 3 * d / a1 / m1;
    if (Math.abs(con) > 1) {
        if (con >= 0) con = 1;
        else con = -1;
    }
    th1 = Math.acos(con) / 3;
    if (p.y >= 0) lat = (-m1 * Math.cos(th1 + Math.PI / 3) - c2 / 3 / c3) * Math.PI;
    else lat = -(-m1 * Math.cos(th1 + Math.PI / 3) - c2 / 3 / c3) * Math.PI;
    if (Math.abs(xx) < (0, $jVGH7.EPSLN)) lon = this.long0;
    else lon = (0, $186WS.default)(this.long0 + Math.PI * (xys - 1 + Math.sqrt(1 + 2 * (xx * xx - yy * yy) + xys * xys)) / 2 / xx);
    p.x = lon;
    p.y = lat;
    return p;
}
var $aa03d8084d376ef4$export$e4b2ac9215619f8d = [
    "Van_der_Grinten_I",
    "VanDerGrinten",
    "Van_der_Grinten",
    "vandg"
];
var $aa03d8084d376ef4$export$2e2bcd8739ae039 = {
    init: $aa03d8084d376ef4$export$2cd8252107eb640b,
    forward: $aa03d8084d376ef4$export$174bb771924e7eb1,
    inverse: $aa03d8084d376ef4$export$70ae2c07e401031b,
    names: $aa03d8084d376ef4$export$e4b2ac9215619f8d
};



var $186WS = parcelRequire("186WS");

var $jVGH7 = parcelRequire("jVGH7");






var $9sUpR = parcelRequire("9sUpR");

/**
 * Calculates the inverse geodesic problem using Vincenty's formulae.
 * Computes the forward azimuth and ellipsoidal distance between two points
 * specified by latitude and longitude on the surface of an ellipsoid.
 *
 * @param {number} lat1 Latitude of the first point in radians.
 * @param {number} lon1 Longitude of the first point in radians.
 * @param {number} lat2 Latitude of the second point in radians.
 * @param {number} lon2 Longitude of the second point in radians.
 * @param {number} a Semi-major axis of the ellipsoid (meters).
 * @param {number} f Flattening of the ellipsoid.
 * @returns {{ azi1: number, s12: number }} An object containing:
 *   - azi1: Forward azimuth from the first point to the second point (radians).
 *   - s12: Ellipsoidal distance between the two points (meters).
 */ function $39562ee98a5f3344$export$56278523bd130841(lat1, lon1, lat2, lon2, a, f) {
    const L = lon2 - lon1;
    const U1 = Math.atan((1 - f) * Math.tan(lat1));
    const U2 = Math.atan((1 - f) * Math.tan(lat2));
    const sinU1 = Math.sin(U1), cosU1 = Math.cos(U1);
    const sinU2 = Math.sin(U2), cosU2 = Math.cos(U2);
    let lambda = L, lambdaP, iterLimit = 100;
    let sinLambda, cosLambda, sinSigma, cosSigma, sigma, sinAlpha, cos2Alpha, cos2SigmaM, C;
    let uSq, A, B, deltaSigma, s;
    do {
        sinLambda = Math.sin(lambda);
        cosLambda = Math.cos(lambda);
        sinSigma = Math.sqrt(cosU2 * sinLambda * (cosU2 * sinLambda) + (cosU1 * sinU2 - sinU1 * cosU2 * cosLambda) * (cosU1 * sinU2 - sinU1 * cosU2 * cosLambda));
        if (sinSigma === 0) return {
            azi1: 0,
            s12: 0
        }; // coincident points
        cosSigma = sinU1 * sinU2 + cosU1 * cosU2 * cosLambda;
        sigma = Math.atan2(sinSigma, cosSigma);
        sinAlpha = cosU1 * cosU2 * sinLambda / sinSigma;
        cos2Alpha = 1 - sinAlpha * sinAlpha;
        cos2SigmaM = cos2Alpha !== 0 ? cosSigma - 2 * sinU1 * sinU2 / cos2Alpha : 0;
        C = f / 16 * cos2Alpha * (4 + f * (4 - 3 * cos2Alpha));
        lambdaP = lambda;
        lambda = L + (1 - C) * f * sinAlpha * (sigma + C * sinSigma * (cos2SigmaM + C * cosSigma * (-1 + 2 * cos2SigmaM * cos2SigmaM)));
    }while (Math.abs(lambda - lambdaP) > 1e-12 && --iterLimit > 0);
    if (iterLimit === 0) return {
        azi1: NaN,
        s12: NaN
    }; // formula failed to converge
    uSq = cos2Alpha * (a * a - a * (1 - f) * (a * (1 - f))) / (a * (1 - f) * (a * (1 - f)));
    A = 1 + uSq / 16384 * (4096 + uSq * (-768 + uSq * (320 - 175 * uSq)));
    B = uSq / 1024 * (256 + uSq * (-128 + uSq * (74 - 47 * uSq)));
    deltaSigma = B * sinSigma * (cos2SigmaM + B / 4 * (cosSigma * (-1 + 2 * cos2SigmaM * cos2SigmaM) - B / 6 * cos2SigmaM * (-3 + 4 * sinSigma * sinSigma) * (-3 + 4 * cos2SigmaM * cos2SigmaM)));
    s = a * (1 - f) * A * (sigma - deltaSigma);
    // Forward azimuth
    const azi1 = Math.atan2(cosU2 * sinLambda, cosU1 * sinU2 - sinU1 * cosU2 * cosLambda);
    return {
        azi1: azi1,
        s12: s
    };
}
function $39562ee98a5f3344$export$b5a922c94102a306(lat1, lon1, azi1, s12, a, f) {
    const U1 = Math.atan((1 - f) * Math.tan(lat1));
    const sinU1 = Math.sin(U1), cosU1 = Math.cos(U1);
    const sinAlpha1 = Math.sin(azi1), cosAlpha1 = Math.cos(azi1);
    const sigma1 = Math.atan2(sinU1, cosU1 * cosAlpha1);
    const sinAlpha = cosU1 * sinAlpha1;
    const cos2Alpha = 1 - sinAlpha * sinAlpha;
    const uSq = cos2Alpha * (a * a - a * (1 - f) * (a * (1 - f))) / (a * (1 - f) * (a * (1 - f)));
    const A = 1 + uSq / 16384 * (4096 + uSq * (-768 + uSq * (320 - 175 * uSq)));
    const B = uSq / 1024 * (256 + uSq * (-128 + uSq * (74 - 47 * uSq)));
    let sigma = s12 / (a * (1 - f) * A), sigmaP, iterLimit = 100;
    let cos2SigmaM, sinSigma, cosSigma, deltaSigma;
    do {
        cos2SigmaM = Math.cos(2 * sigma1 + sigma);
        sinSigma = Math.sin(sigma);
        cosSigma = Math.cos(sigma);
        deltaSigma = B * sinSigma * (cos2SigmaM + B / 4 * (cosSigma * (-1 + 2 * cos2SigmaM * cos2SigmaM) - B / 6 * cos2SigmaM * (-3 + 4 * sinSigma * sinSigma) * (-3 + 4 * cos2SigmaM * cos2SigmaM)));
        sigmaP = sigma;
        sigma = s12 / (a * (1 - f) * A) + deltaSigma;
    }while (Math.abs(sigma - sigmaP) > 1e-12 && --iterLimit > 0);
    if (iterLimit === 0) return {
        lat2: NaN,
        lon2: NaN
    };
    const tmp = sinU1 * sinSigma - cosU1 * cosSigma * cosAlpha1;
    const lat2 = Math.atan2(sinU1 * cosSigma + cosU1 * sinSigma * cosAlpha1, (1 - f) * Math.sqrt(sinAlpha * sinAlpha + tmp * tmp));
    const lambda = Math.atan2(sinSigma * sinAlpha1, cosU1 * cosSigma - sinU1 * sinSigma * cosAlpha1);
    const C = f / 16 * cos2Alpha * (4 + f * (4 - 3 * cos2Alpha));
    const L = lambda - (1 - C) * f * sinAlpha * (sigma + C * sinSigma * (cos2SigmaM + C * cosSigma * (-1 + 2 * cos2SigmaM * cos2SigmaM)));
    const lon2 = lon1 + L;
    return {
        lat2: lat2,
        lon2: lon2
    };
}


function $8fe311c4825ed36a$export$2cd8252107eb640b() {
    this.sin_p12 = Math.sin(this.lat0);
    this.cos_p12 = Math.cos(this.lat0);
    // flattening for ellipsoid
    this.f = this.es / (1 + Math.sqrt(1 - this.es));
}
function $8fe311c4825ed36a$export$174bb771924e7eb1(p) {
    var lon = p.x;
    var lat = p.y;
    var sinphi = Math.sin(p.y);
    var cosphi = Math.cos(p.y);
    var dlon = (0, $186WS.default)(lon - this.long0);
    var e0, e1, e2, e3, Mlp, Ml, c, kp, cos_c, vars, azi1;
    if (this.sphere) {
        if (Math.abs(this.sin_p12 - 1) <= (0, $jVGH7.EPSLN)) {
            // North Pole case
            p.x = this.x0 + this.a * ((0, $jVGH7.HALF_PI) - lat) * Math.sin(dlon);
            p.y = this.y0 - this.a * ((0, $jVGH7.HALF_PI) - lat) * Math.cos(dlon);
            return p;
        } else if (Math.abs(this.sin_p12 + 1) <= (0, $jVGH7.EPSLN)) {
            // South Pole case
            p.x = this.x0 + this.a * ((0, $jVGH7.HALF_PI) + lat) * Math.sin(dlon);
            p.y = this.y0 + this.a * ((0, $jVGH7.HALF_PI) + lat) * Math.cos(dlon);
            return p;
        } else {
            // default case
            cos_c = this.sin_p12 * sinphi + this.cos_p12 * cosphi * Math.cos(dlon);
            c = Math.acos(cos_c);
            kp = c ? c / Math.sin(c) : 1;
            p.x = this.x0 + this.a * kp * cosphi * Math.sin(dlon);
            p.y = this.y0 + this.a * kp * (this.cos_p12 * sinphi - this.sin_p12 * cosphi * Math.cos(dlon));
            return p;
        }
    } else {
        e0 = (0, $9d4fc5743e2bea0f$export$2e2bcd8739ae039)(this.es);
        e1 = (0, $c5c37487e2f50fb0$export$2e2bcd8739ae039)(this.es);
        e2 = (0, $8eab0ca873cfb51b$export$2e2bcd8739ae039)(this.es);
        e3 = (0, $2d1d8edef9796095$export$2e2bcd8739ae039)(this.es);
        if (Math.abs(this.sin_p12 - 1) <= (0, $jVGH7.EPSLN)) {
            // North Pole case
            Mlp = this.a * (0, $3dc6096878ca0e32$export$2e2bcd8739ae039)(e0, e1, e2, e3, (0, $jVGH7.HALF_PI));
            Ml = this.a * (0, $3dc6096878ca0e32$export$2e2bcd8739ae039)(e0, e1, e2, e3, lat);
            p.x = this.x0 + (Mlp - Ml) * Math.sin(dlon);
            p.y = this.y0 - (Mlp - Ml) * Math.cos(dlon);
            return p;
        } else if (Math.abs(this.sin_p12 + 1) <= (0, $jVGH7.EPSLN)) {
            // South Pole case
            Mlp = this.a * (0, $3dc6096878ca0e32$export$2e2bcd8739ae039)(e0, e1, e2, e3, (0, $jVGH7.HALF_PI));
            Ml = this.a * (0, $3dc6096878ca0e32$export$2e2bcd8739ae039)(e0, e1, e2, e3, lat);
            p.x = this.x0 + (Mlp + Ml) * Math.sin(dlon);
            p.y = this.y0 + (Mlp + Ml) * Math.cos(dlon);
            return p;
        } else {
            // Default case
            if (Math.abs(lon) < (0, $jVGH7.EPSLN) && Math.abs(lat - this.lat0) < (0, $jVGH7.EPSLN)) {
                p.x = p.y = 0;
                return p;
            }
            vars = (0, $39562ee98a5f3344$export$56278523bd130841)(this.lat0, this.long0, lat, lon, this.a, this.f);
            azi1 = vars.azi1;
            p.x = vars.s12 * Math.sin(azi1);
            p.y = vars.s12 * Math.cos(azi1);
            return p;
        }
    }
}
function $8fe311c4825ed36a$export$70ae2c07e401031b(p) {
    p.x -= this.x0;
    p.y -= this.y0;
    var rh, z, sinz, cosz, lon, lat, con, e0, e1, e2, e3, Mlp, M, azi1, s12, vars;
    if (this.sphere) {
        rh = Math.sqrt(p.x * p.x + p.y * p.y);
        if (rh > 2 * (0, $jVGH7.HALF_PI) * this.a) return;
        z = rh / this.a;
        sinz = Math.sin(z);
        cosz = Math.cos(z);
        lon = this.long0;
        if (Math.abs(rh) <= (0, $jVGH7.EPSLN)) lat = this.lat0;
        else {
            lat = (0, $9sUpR.default)(cosz * this.sin_p12 + p.y * sinz * this.cos_p12 / rh);
            con = Math.abs(this.lat0) - (0, $jVGH7.HALF_PI);
            if (Math.abs(con) <= (0, $jVGH7.EPSLN)) {
                if (this.lat0 >= 0) lon = (0, $186WS.default)(this.long0 + Math.atan2(p.x, -p.y));
                else lon = (0, $186WS.default)(this.long0 - Math.atan2(-p.x, p.y));
            } else lon = (0, $186WS.default)(this.long0 + Math.atan2(p.x * sinz, rh * this.cos_p12 * cosz - p.y * this.sin_p12 * sinz));
        }
        p.x = lon;
        p.y = lat;
        return p;
    } else {
        e0 = (0, $9d4fc5743e2bea0f$export$2e2bcd8739ae039)(this.es);
        e1 = (0, $c5c37487e2f50fb0$export$2e2bcd8739ae039)(this.es);
        e2 = (0, $8eab0ca873cfb51b$export$2e2bcd8739ae039)(this.es);
        e3 = (0, $2d1d8edef9796095$export$2e2bcd8739ae039)(this.es);
        if (Math.abs(this.sin_p12 - 1) <= (0, $jVGH7.EPSLN)) {
            // North pole case
            Mlp = this.a * (0, $3dc6096878ca0e32$export$2e2bcd8739ae039)(e0, e1, e2, e3, (0, $jVGH7.HALF_PI));
            rh = Math.sqrt(p.x * p.x + p.y * p.y);
            M = Mlp - rh;
            lat = (0, $2811fe0fe86055bd$export$2e2bcd8739ae039)(M / this.a, e0, e1, e2, e3);
            lon = (0, $186WS.default)(this.long0 + Math.atan2(p.x, -1 * p.y));
            p.x = lon;
            p.y = lat;
            return p;
        } else if (Math.abs(this.sin_p12 + 1) <= (0, $jVGH7.EPSLN)) {
            // South pole case
            Mlp = this.a * (0, $3dc6096878ca0e32$export$2e2bcd8739ae039)(e0, e1, e2, e3, (0, $jVGH7.HALF_PI));
            rh = Math.sqrt(p.x * p.x + p.y * p.y);
            M = rh - Mlp;
            lat = (0, $2811fe0fe86055bd$export$2e2bcd8739ae039)(M / this.a, e0, e1, e2, e3);
            lon = (0, $186WS.default)(this.long0 + Math.atan2(p.x, p.y));
            p.x = lon;
            p.y = lat;
            return p;
        } else {
            // default case
            azi1 = Math.atan2(p.x, p.y);
            s12 = Math.sqrt(p.x * p.x + p.y * p.y);
            vars = (0, $39562ee98a5f3344$export$b5a922c94102a306)(this.lat0, this.long0, azi1, s12, this.a, this.f);
            p.x = vars.lon2;
            p.y = vars.lat2;
            return p;
        }
    }
}
var $8fe311c4825ed36a$export$e4b2ac9215619f8d = [
    "Azimuthal_Equidistant",
    "aeqd"
];
var $8fe311c4825ed36a$export$2e2bcd8739ae039 = {
    init: $8fe311c4825ed36a$export$2cd8252107eb640b,
    forward: $8fe311c4825ed36a$export$174bb771924e7eb1,
    inverse: $8fe311c4825ed36a$export$70ae2c07e401031b,
    names: $8fe311c4825ed36a$export$e4b2ac9215619f8d
};



var $186WS = parcelRequire("186WS");

var $9sUpR = parcelRequire("9sUpR");

var $jVGH7 = parcelRequire("jVGH7");
function $dce4c808e0fe5749$export$2cd8252107eb640b() {
    // double temp;      /* temporary variable    */
    /* Place parameters in static storage for common use
      ------------------------------------------------- */ this.sin_p14 = Math.sin(this.lat0);
    this.cos_p14 = Math.cos(this.lat0);
}
function $dce4c808e0fe5749$export$174bb771924e7eb1(p) {
    var sinphi, cosphi; /* sin and cos value        */ 
    var dlon; /* delta longitude value      */ 
    var coslon; /* cos of longitude        */ 
    var ksp; /* scale factor          */ 
    var g, x, y;
    var lon = p.x;
    var lat = p.y;
    /* Forward equations
      ----------------- */ dlon = (0, $186WS.default)(lon - this.long0);
    sinphi = Math.sin(lat);
    cosphi = Math.cos(lat);
    coslon = Math.cos(dlon);
    g = this.sin_p14 * sinphi + this.cos_p14 * cosphi * coslon;
    ksp = 1;
    if (g > 0 || Math.abs(g) <= (0, $jVGH7.EPSLN)) {
        x = this.a * ksp * cosphi * Math.sin(dlon);
        y = this.y0 + this.a * ksp * (this.cos_p14 * sinphi - this.sin_p14 * cosphi * coslon);
    }
    p.x = x;
    p.y = y;
    return p;
}
function $dce4c808e0fe5749$export$70ae2c07e401031b(p) {
    var rh; /* height above ellipsoid      */ 
    var z; /* angle          */ 
    var sinz, cosz; /* sin of z and cos of z      */ 
    var con;
    var lon, lat;
    /* Inverse equations
      ----------------- */ p.x -= this.x0;
    p.y -= this.y0;
    rh = Math.sqrt(p.x * p.x + p.y * p.y);
    z = (0, $9sUpR.default)(rh / this.a);
    sinz = Math.sin(z);
    cosz = Math.cos(z);
    lon = this.long0;
    if (Math.abs(rh) <= (0, $jVGH7.EPSLN)) {
        lat = this.lat0;
        p.x = lon;
        p.y = lat;
        return p;
    }
    lat = (0, $9sUpR.default)(cosz * this.sin_p14 + p.y * sinz * this.cos_p14 / rh);
    con = Math.abs(this.lat0) - (0, $jVGH7.HALF_PI);
    if (Math.abs(con) <= (0, $jVGH7.EPSLN)) {
        if (this.lat0 >= 0) lon = (0, $186WS.default)(this.long0 + Math.atan2(p.x, -p.y));
        else lon = (0, $186WS.default)(this.long0 - Math.atan2(-p.x, p.y));
        p.x = lon;
        p.y = lat;
        return p;
    }
    lon = (0, $186WS.default)(this.long0 + Math.atan2(p.x * sinz, rh * this.cos_p14 * cosz - p.y * this.sin_p14 * sinz));
    p.x = lon;
    p.y = lat;
    return p;
}
var $dce4c808e0fe5749$export$e4b2ac9215619f8d = [
    "ortho"
];
var $dce4c808e0fe5749$export$2e2bcd8739ae039 = {
    init: $dce4c808e0fe5749$export$2cd8252107eb640b,
    forward: $dce4c808e0fe5749$export$174bb771924e7eb1,
    inverse: $dce4c808e0fe5749$export$70ae2c07e401031b,
    names: $dce4c808e0fe5749$export$e4b2ac9215619f8d
};


// QSC projection rewritten from the original PROJ4
// https://github.com/OSGeo/proj.4/blob/master/src/PJ_qsc.c

var $jVGH7 = parcelRequire("jVGH7");
/**
 * @typedef {Object} LocalThis
 * @property {number} face
 * @property {number} x0
 * @property {number} y0
 * @property {number} es
 * @property {number} one_minus_f
 * @property {number} one_minus_f_squared
 */ /* constants */ var $b2bb233327c3895a$var$FACE_ENUM = {
    FRONT: 1,
    RIGHT: 2,
    BACK: 3,
    LEFT: 4,
    TOP: 5,
    BOTTOM: 6
};
var $b2bb233327c3895a$var$AREA_ENUM = {
    AREA_0: 1,
    AREA_1: 2,
    AREA_2: 3,
    AREA_3: 4
};
function $b2bb233327c3895a$export$2cd8252107eb640b() {
    this.x0 = this.x0 || 0;
    this.y0 = this.y0 || 0;
    this.lat0 = this.lat0 || 0;
    this.long0 = this.long0 || 0;
    this.lat_ts = this.lat_ts || 0;
    this.title = this.title || "Quadrilateralized Spherical Cube";
    /* Determine the cube face from the center of projection. */ if (this.lat0 >= (0, $jVGH7.HALF_PI) - (0, $jVGH7.FORTPI) / 2.0) this.face = $b2bb233327c3895a$var$FACE_ENUM.TOP;
    else if (this.lat0 <= -((0, $jVGH7.HALF_PI) - (0, $jVGH7.FORTPI) / 2.0)) this.face = $b2bb233327c3895a$var$FACE_ENUM.BOTTOM;
    else if (Math.abs(this.long0) <= (0, $jVGH7.FORTPI)) this.face = $b2bb233327c3895a$var$FACE_ENUM.FRONT;
    else if (Math.abs(this.long0) <= (0, $jVGH7.HALF_PI) + (0, $jVGH7.FORTPI)) this.face = this.long0 > 0.0 ? $b2bb233327c3895a$var$FACE_ENUM.RIGHT : $b2bb233327c3895a$var$FACE_ENUM.LEFT;
    else this.face = $b2bb233327c3895a$var$FACE_ENUM.BACK;
    /* Fill in useful values for the ellipsoid <-> sphere shift
   * described in [LK12]. */ if (this.es !== 0) {
        this.one_minus_f = 1 - (this.a - this.b) / this.a;
        this.one_minus_f_squared = this.one_minus_f * this.one_minus_f;
    }
}
function $b2bb233327c3895a$export$174bb771924e7eb1(p) {
    var xy = {
        x: 0,
        y: 0
    };
    var lat, lon;
    var theta, phi;
    var t, mu;
    /* nu; */ var area = {
        value: 0
    };
    // move lon according to projection's lon
    p.x -= this.long0;
    /* Convert the geodetic latitude to a geocentric latitude.
   * This corresponds to the shift from the ellipsoid to the sphere
   * described in [LK12]. */ if (this.es !== 0) lat = Math.atan(this.one_minus_f_squared * Math.tan(p.y));
    else lat = p.y;
    /* Convert the input lat, lon into theta, phi as used by QSC.
   * This depends on the cube face and the area on it.
   * For the top and bottom face, we can compute theta and phi
   * directly from phi, lam. For the other faces, we must use
   * unit sphere cartesian coordinates as an intermediate step. */ lon = p.x; // lon = lp.lam;
    if (this.face === $b2bb233327c3895a$var$FACE_ENUM.TOP) {
        phi = (0, $jVGH7.HALF_PI) - lat;
        if (lon >= (0, $jVGH7.FORTPI) && lon <= (0, $jVGH7.HALF_PI) + (0, $jVGH7.FORTPI)) {
            area.value = $b2bb233327c3895a$var$AREA_ENUM.AREA_0;
            theta = lon - (0, $jVGH7.HALF_PI);
        } else if (lon > (0, $jVGH7.HALF_PI) + (0, $jVGH7.FORTPI) || lon <= -((0, $jVGH7.HALF_PI) + (0, $jVGH7.FORTPI))) {
            area.value = $b2bb233327c3895a$var$AREA_ENUM.AREA_1;
            theta = lon > 0.0 ? lon - (0, $jVGH7.SPI) : lon + (0, $jVGH7.SPI);
        } else if (lon > -((0, $jVGH7.HALF_PI) + (0, $jVGH7.FORTPI)) && lon <= -(0, $jVGH7.FORTPI)) {
            area.value = $b2bb233327c3895a$var$AREA_ENUM.AREA_2;
            theta = lon + (0, $jVGH7.HALF_PI);
        } else {
            area.value = $b2bb233327c3895a$var$AREA_ENUM.AREA_3;
            theta = lon;
        }
    } else if (this.face === $b2bb233327c3895a$var$FACE_ENUM.BOTTOM) {
        phi = (0, $jVGH7.HALF_PI) + lat;
        if (lon >= (0, $jVGH7.FORTPI) && lon <= (0, $jVGH7.HALF_PI) + (0, $jVGH7.FORTPI)) {
            area.value = $b2bb233327c3895a$var$AREA_ENUM.AREA_0;
            theta = -lon + (0, $jVGH7.HALF_PI);
        } else if (lon < (0, $jVGH7.FORTPI) && lon >= -(0, $jVGH7.FORTPI)) {
            area.value = $b2bb233327c3895a$var$AREA_ENUM.AREA_1;
            theta = -lon;
        } else if (lon < -(0, $jVGH7.FORTPI) && lon >= -((0, $jVGH7.HALF_PI) + (0, $jVGH7.FORTPI))) {
            area.value = $b2bb233327c3895a$var$AREA_ENUM.AREA_2;
            theta = -lon - (0, $jVGH7.HALF_PI);
        } else {
            area.value = $b2bb233327c3895a$var$AREA_ENUM.AREA_3;
            theta = lon > 0.0 ? -lon + (0, $jVGH7.SPI) : -lon - (0, $jVGH7.SPI);
        }
    } else {
        var q, r, s;
        var sinlat, coslat;
        var sinlon, coslon;
        if (this.face === $b2bb233327c3895a$var$FACE_ENUM.RIGHT) lon = $b2bb233327c3895a$var$qsc_shift_lon_origin(lon, +(0, $jVGH7.HALF_PI));
        else if (this.face === $b2bb233327c3895a$var$FACE_ENUM.BACK) lon = $b2bb233327c3895a$var$qsc_shift_lon_origin(lon, +(0, $jVGH7.SPI));
        else if (this.face === $b2bb233327c3895a$var$FACE_ENUM.LEFT) lon = $b2bb233327c3895a$var$qsc_shift_lon_origin(lon, -(0, $jVGH7.HALF_PI));
        sinlat = Math.sin(lat);
        coslat = Math.cos(lat);
        sinlon = Math.sin(lon);
        coslon = Math.cos(lon);
        q = coslat * coslon;
        r = coslat * sinlon;
        s = sinlat;
        if (this.face === $b2bb233327c3895a$var$FACE_ENUM.FRONT) {
            phi = Math.acos(q);
            theta = $b2bb233327c3895a$var$qsc_fwd_equat_face_theta(phi, s, r, area);
        } else if (this.face === $b2bb233327c3895a$var$FACE_ENUM.RIGHT) {
            phi = Math.acos(r);
            theta = $b2bb233327c3895a$var$qsc_fwd_equat_face_theta(phi, s, -q, area);
        } else if (this.face === $b2bb233327c3895a$var$FACE_ENUM.BACK) {
            phi = Math.acos(-q);
            theta = $b2bb233327c3895a$var$qsc_fwd_equat_face_theta(phi, s, -r, area);
        } else if (this.face === $b2bb233327c3895a$var$FACE_ENUM.LEFT) {
            phi = Math.acos(-r);
            theta = $b2bb233327c3895a$var$qsc_fwd_equat_face_theta(phi, s, q, area);
        } else {
            /* Impossible */ phi = theta = 0;
            area.value = $b2bb233327c3895a$var$AREA_ENUM.AREA_0;
        }
    }
    /* Compute mu and nu for the area of definition.
   * For mu, see Eq. (3-21) in [OL76], but note the typos:
   * compare with Eq. (3-14). For nu, see Eq. (3-38). */ mu = Math.atan(12 / (0, $jVGH7.SPI) * (theta + Math.acos(Math.sin(theta) * Math.cos((0, $jVGH7.FORTPI))) - (0, $jVGH7.HALF_PI)));
    t = Math.sqrt((1 - Math.cos(phi)) / (Math.cos(mu) * Math.cos(mu)) / (1 - Math.cos(Math.atan(1 / Math.cos(theta)))));
    /* Apply the result to the real area. */ if (area.value === $b2bb233327c3895a$var$AREA_ENUM.AREA_1) mu += (0, $jVGH7.HALF_PI);
    else if (area.value === $b2bb233327c3895a$var$AREA_ENUM.AREA_2) mu += (0, $jVGH7.SPI);
    else if (area.value === $b2bb233327c3895a$var$AREA_ENUM.AREA_3) mu += 1.5 * (0, $jVGH7.SPI);
    /* Now compute x, y from mu and nu */ xy.x = t * Math.cos(mu);
    xy.y = t * Math.sin(mu);
    xy.x = xy.x * this.a + this.x0;
    xy.y = xy.y * this.a + this.y0;
    p.x = xy.x;
    p.y = xy.y;
    return p;
}
function $b2bb233327c3895a$export$70ae2c07e401031b(p) {
    var lp = {
        lam: 0,
        phi: 0
    };
    var mu, nu, cosmu, tannu;
    var tantheta, theta, cosphi, phi;
    var t;
    var area = {
        value: 0
    };
    /* de-offset */ p.x = (p.x - this.x0) / this.a;
    p.y = (p.y - this.y0) / this.a;
    /* Convert the input x, y to the mu and nu angles as used by QSC.
   * This depends on the area of the cube face. */ nu = Math.atan(Math.sqrt(p.x * p.x + p.y * p.y));
    mu = Math.atan2(p.y, p.x);
    if (p.x >= 0.0 && p.x >= Math.abs(p.y)) area.value = $b2bb233327c3895a$var$AREA_ENUM.AREA_0;
    else if (p.y >= 0.0 && p.y >= Math.abs(p.x)) {
        area.value = $b2bb233327c3895a$var$AREA_ENUM.AREA_1;
        mu -= (0, $jVGH7.HALF_PI);
    } else if (p.x < 0.0 && -p.x >= Math.abs(p.y)) {
        area.value = $b2bb233327c3895a$var$AREA_ENUM.AREA_2;
        mu = mu < 0.0 ? mu + (0, $jVGH7.SPI) : mu - (0, $jVGH7.SPI);
    } else {
        area.value = $b2bb233327c3895a$var$AREA_ENUM.AREA_3;
        mu += (0, $jVGH7.HALF_PI);
    }
    /* Compute phi and theta for the area of definition.
   * The inverse projection is not described in the original paper, but some
   * good hints can be found here (as of 2011-12-14):
   * http://fits.gsfc.nasa.gov/fitsbits/saf.93/saf.9302
   * (search for "Message-Id: <9302181759.AA25477 at fits.cv.nrao.edu>") */ t = (0, $jVGH7.SPI) / 12 * Math.tan(mu);
    tantheta = Math.sin(t) / (Math.cos(t) - 1 / Math.sqrt(2));
    theta = Math.atan(tantheta);
    cosmu = Math.cos(mu);
    tannu = Math.tan(nu);
    cosphi = 1 - cosmu * cosmu * tannu * tannu * (1 - Math.cos(Math.atan(1 / Math.cos(theta))));
    if (cosphi < -1) cosphi = -1;
    else if (cosphi > 1) cosphi = 1;
    /* Apply the result to the real area on the cube face.
   * For the top and bottom face, we can compute phi and lam directly.
   * For the other faces, we must use unit sphere cartesian coordinates
   * as an intermediate step. */ if (this.face === $b2bb233327c3895a$var$FACE_ENUM.TOP) {
        phi = Math.acos(cosphi);
        lp.phi = (0, $jVGH7.HALF_PI) - phi;
        if (area.value === $b2bb233327c3895a$var$AREA_ENUM.AREA_0) lp.lam = theta + (0, $jVGH7.HALF_PI);
        else if (area.value === $b2bb233327c3895a$var$AREA_ENUM.AREA_1) lp.lam = theta < 0.0 ? theta + (0, $jVGH7.SPI) : theta - (0, $jVGH7.SPI);
        else if (area.value === $b2bb233327c3895a$var$AREA_ENUM.AREA_2) lp.lam = theta - (0, $jVGH7.HALF_PI);
        else lp.lam = theta;
    } else if (this.face === $b2bb233327c3895a$var$FACE_ENUM.BOTTOM) {
        phi = Math.acos(cosphi);
        lp.phi = phi - (0, $jVGH7.HALF_PI);
        if (area.value === $b2bb233327c3895a$var$AREA_ENUM.AREA_0) lp.lam = -theta + (0, $jVGH7.HALF_PI);
        else if (area.value === $b2bb233327c3895a$var$AREA_ENUM.AREA_1) lp.lam = -theta;
        else if (area.value === $b2bb233327c3895a$var$AREA_ENUM.AREA_2) lp.lam = -theta - (0, $jVGH7.HALF_PI);
        else lp.lam = theta < 0.0 ? -theta - (0, $jVGH7.SPI) : -theta + (0, $jVGH7.SPI);
    } else {
        /* Compute phi and lam via cartesian unit sphere coordinates. */ var q, r, s;
        q = cosphi;
        t = q * q;
        if (t >= 1) s = 0;
        else s = Math.sqrt(1 - t) * Math.sin(theta);
        t += s * s;
        if (t >= 1) r = 0;
        else r = Math.sqrt(1 - t);
        /* Rotate q,r,s into the correct area. */ if (area.value === $b2bb233327c3895a$var$AREA_ENUM.AREA_1) {
            t = r;
            r = -s;
            s = t;
        } else if (area.value === $b2bb233327c3895a$var$AREA_ENUM.AREA_2) {
            r = -r;
            s = -s;
        } else if (area.value === $b2bb233327c3895a$var$AREA_ENUM.AREA_3) {
            t = r;
            r = s;
            s = -t;
        }
        /* Rotate q,r,s into the correct cube face. */ if (this.face === $b2bb233327c3895a$var$FACE_ENUM.RIGHT) {
            t = q;
            q = -r;
            r = t;
        } else if (this.face === $b2bb233327c3895a$var$FACE_ENUM.BACK) {
            q = -q;
            r = -r;
        } else if (this.face === $b2bb233327c3895a$var$FACE_ENUM.LEFT) {
            t = q;
            q = r;
            r = -t;
        }
        /* Now compute phi and lam from the unit sphere coordinates. */ lp.phi = Math.acos(-s) - (0, $jVGH7.HALF_PI);
        lp.lam = Math.atan2(r, q);
        if (this.face === $b2bb233327c3895a$var$FACE_ENUM.RIGHT) lp.lam = $b2bb233327c3895a$var$qsc_shift_lon_origin(lp.lam, -(0, $jVGH7.HALF_PI));
        else if (this.face === $b2bb233327c3895a$var$FACE_ENUM.BACK) lp.lam = $b2bb233327c3895a$var$qsc_shift_lon_origin(lp.lam, -(0, $jVGH7.SPI));
        else if (this.face === $b2bb233327c3895a$var$FACE_ENUM.LEFT) lp.lam = $b2bb233327c3895a$var$qsc_shift_lon_origin(lp.lam, +(0, $jVGH7.HALF_PI));
    }
    /* Apply the shift from the sphere to the ellipsoid as described
   * in [LK12]. */ if (this.es !== 0) {
        var invert_sign;
        var tanphi, xa;
        invert_sign = lp.phi < 0 ? 1 : 0;
        tanphi = Math.tan(lp.phi);
        xa = this.b / Math.sqrt(tanphi * tanphi + this.one_minus_f_squared);
        lp.phi = Math.atan(Math.sqrt(this.a * this.a - xa * xa) / (this.one_minus_f * xa));
        if (invert_sign) lp.phi = -lp.phi;
    }
    lp.lam += this.long0;
    p.x = lp.lam;
    p.y = lp.phi;
    return p;
}
/* Helper function for forward projection: compute the theta angle
 * and determine the area number. */ function $b2bb233327c3895a$var$qsc_fwd_equat_face_theta(phi, y, x, area) {
    var theta;
    if (phi < (0, $jVGH7.EPSLN)) {
        area.value = $b2bb233327c3895a$var$AREA_ENUM.AREA_0;
        theta = 0.0;
    } else {
        theta = Math.atan2(y, x);
        if (Math.abs(theta) <= (0, $jVGH7.FORTPI)) area.value = $b2bb233327c3895a$var$AREA_ENUM.AREA_0;
        else if (theta > (0, $jVGH7.FORTPI) && theta <= (0, $jVGH7.HALF_PI) + (0, $jVGH7.FORTPI)) {
            area.value = $b2bb233327c3895a$var$AREA_ENUM.AREA_1;
            theta -= (0, $jVGH7.HALF_PI);
        } else if (theta > (0, $jVGH7.HALF_PI) + (0, $jVGH7.FORTPI) || theta <= -((0, $jVGH7.HALF_PI) + (0, $jVGH7.FORTPI))) {
            area.value = $b2bb233327c3895a$var$AREA_ENUM.AREA_2;
            theta = theta >= 0.0 ? theta - (0, $jVGH7.SPI) : theta + (0, $jVGH7.SPI);
        } else {
            area.value = $b2bb233327c3895a$var$AREA_ENUM.AREA_3;
            theta += (0, $jVGH7.HALF_PI);
        }
    }
    return theta;
}
/* Helper function: shift the longitude. */ function $b2bb233327c3895a$var$qsc_shift_lon_origin(lon, offset) {
    var slon = lon + offset;
    if (slon < -(0, $jVGH7.SPI)) slon += (0, $jVGH7.TWO_PI);
    else if (slon > +(0, $jVGH7.SPI)) slon -= (0, $jVGH7.TWO_PI);
    return slon;
}
var $b2bb233327c3895a$export$e4b2ac9215619f8d = [
    "Quadrilateralized Spherical Cube",
    "Quadrilateralized_Spherical_Cube",
    "qsc"
];
var $b2bb233327c3895a$export$2e2bcd8739ae039 = {
    init: $b2bb233327c3895a$export$2cd8252107eb640b,
    forward: $b2bb233327c3895a$export$174bb771924e7eb1,
    inverse: $b2bb233327c3895a$export$70ae2c07e401031b,
    names: $b2bb233327c3895a$export$e4b2ac9215619f8d
};


// Robinson projection
// Based on https://github.com/OSGeo/proj.4/blob/master/src/PJ_robin.c
// Polynomial coeficients from http://article.gmane.org/gmane.comp.gis.proj-4.devel/6039

var $jVGH7 = parcelRequire("jVGH7");

var $186WS = parcelRequire("186WS");
var $4311944230ad93f2$var$COEFS_X = [
    [
        1.0000,
        2.2199e-17,
        -0.0000715515,
        3.1103e-06
    ],
    [
        0.9986,
        -0.000482243,
        -0.000024897,
        -0.0000013309
    ],
    [
        0.9954,
        -0.00083103,
        -0.0000448605,
        -0.000000986701
    ],
    [
        0.9900,
        -0.00135364,
        -0.000059661,
        3.6777e-06
    ],
    [
        0.9822,
        -0.00167442,
        -0.00000449547,
        -0.00000572411
    ],
    [
        0.9730,
        -0.00214868,
        -0.0000903571,
        1.8736e-08
    ],
    [
        0.9600,
        -0.00305085,
        -0.0000900761,
        1.64917e-06
    ],
    [
        0.9427,
        -0.00382792,
        -0.0000653386,
        -0.0000026154
    ],
    [
        0.9216,
        -0.00467746,
        -0.00010457,
        4.81243e-06
    ],
    [
        0.8962,
        -0.00536223,
        -0.0000323831,
        -0.00000543432
    ],
    [
        0.8679,
        -0.00609363,
        -0.000113898,
        3.32484e-06
    ],
    [
        0.8350,
        -0.00698325,
        -0.0000640253,
        9.34959e-07
    ],
    [
        0.7986,
        -0.00755338,
        -0.0000500009,
        9.35324e-07
    ],
    [
        0.7597,
        -0.00798324,
        -0.000035971,
        -0.00000227626
    ],
    [
        0.7186,
        -0.00851367,
        -0.0000701149,
        -0.0000086303
    ],
    [
        0.6732,
        -0.00986209,
        -0.000199569,
        1.91974e-05
    ],
    [
        0.6213,
        -0.010418,
        8.83923e-05,
        6.24051e-06
    ],
    [
        0.5722,
        -0.00906601,
        0.000182,
        6.24051e-06
    ],
    [
        0.5322,
        -0.00677797,
        0.000275608,
        6.24051e-06
    ]
];
var $4311944230ad93f2$var$COEFS_Y = [
    [
        -0.00000000000000000520417,
        0.0124,
        1.21431e-18,
        -0.0000000000845284
    ],
    [
        0.0620,
        0.0124,
        -0.00000000126793,
        4.22642e-10
    ],
    [
        0.1240,
        0.0124,
        5.07171e-09,
        -0.00000000160604
    ],
    [
        0.1860,
        0.0123999,
        -0.0000000190189,
        6.00152e-09
    ],
    [
        0.2480,
        0.0124002,
        7.10039e-08,
        -0.0000000224
    ],
    [
        0.3100,
        0.0123992,
        -0.000000264997,
        8.35986e-08
    ],
    [
        0.3720,
        0.0124029,
        9.88983e-07,
        -0.000000311994
    ],
    [
        0.4340,
        0.0123893,
        -0.00000369093,
        -0.000000435621
    ],
    [
        0.4958,
        0.0123198,
        -0.0000102252,
        -0.000000345523
    ],
    [
        0.5571,
        0.0121916,
        -0.0000154081,
        -0.000000582288
    ],
    [
        0.6176,
        0.0119938,
        -0.0000241424,
        -0.000000525327
    ],
    [
        0.6769,
        0.011713,
        -0.0000320223,
        -0.000000516405
    ],
    [
        0.7346,
        0.0113541,
        -0.0000397684,
        -0.000000609052
    ],
    [
        0.7903,
        0.0109107,
        -0.0000489042,
        -0.00000104739
    ],
    [
        0.8435,
        0.0103431,
        -0.000064615,
        -0.00000000140374
    ],
    [
        0.8936,
        0.00969686,
        -0.000064636,
        -0.000008547
    ],
    [
        0.9394,
        0.00840947,
        -0.000192841,
        -0.0000042106
    ],
    [
        0.9761,
        0.00616527,
        -0.000256,
        -0.0000042106
    ],
    [
        1.0000,
        0.00328947,
        -0.000319159,
        -0.0000042106
    ]
];
var $4311944230ad93f2$var$FXC = 0.8487;
var $4311944230ad93f2$var$FYC = 1.3523;
var $4311944230ad93f2$var$C1 = (0, $jVGH7.R2D) / 5; // rad to 5-degree interval
var $4311944230ad93f2$var$RC1 = 1 / $4311944230ad93f2$var$C1;
var $4311944230ad93f2$var$NODES = 18;
var $4311944230ad93f2$var$poly3_val = function(coefs, x) {
    return coefs[0] + x * (coefs[1] + x * (coefs[2] + x * coefs[3]));
};
var $4311944230ad93f2$var$poly3_der = function(coefs, x) {
    return coefs[1] + x * (2 * coefs[2] + x * 3 * coefs[3]);
};
function $4311944230ad93f2$var$newton_rapshon(f_df, start, max_err, iters) {
    var x = start;
    for(; iters; --iters){
        var upd = f_df(x);
        x -= upd;
        if (Math.abs(upd) < max_err) break;
    }
    return x;
}
function $4311944230ad93f2$export$2cd8252107eb640b() {
    this.x0 = this.x0 || 0;
    this.y0 = this.y0 || 0;
    this.long0 = this.long0 || 0;
    this.es = 0;
    this.title = this.title || "Robinson";
}
function $4311944230ad93f2$export$174bb771924e7eb1(ll) {
    var lon = (0, $186WS.default)(ll.x - this.long0);
    var dphi = Math.abs(ll.y);
    var i = Math.floor(dphi * $4311944230ad93f2$var$C1);
    if (i < 0) i = 0;
    else if (i >= $4311944230ad93f2$var$NODES) i = $4311944230ad93f2$var$NODES - 1;
    dphi = (0, $jVGH7.R2D) * (dphi - $4311944230ad93f2$var$RC1 * i);
    var xy = {
        x: $4311944230ad93f2$var$poly3_val($4311944230ad93f2$var$COEFS_X[i], dphi) * lon,
        y: $4311944230ad93f2$var$poly3_val($4311944230ad93f2$var$COEFS_Y[i], dphi)
    };
    if (ll.y < 0) xy.y = -xy.y;
    xy.x = xy.x * this.a * $4311944230ad93f2$var$FXC + this.x0;
    xy.y = xy.y * this.a * $4311944230ad93f2$var$FYC + this.y0;
    return xy;
}
function $4311944230ad93f2$export$70ae2c07e401031b(xy) {
    var ll = {
        x: (xy.x - this.x0) / (this.a * $4311944230ad93f2$var$FXC),
        y: Math.abs(xy.y - this.y0) / (this.a * $4311944230ad93f2$var$FYC)
    };
    if (ll.y >= 1) {
        ll.x /= $4311944230ad93f2$var$COEFS_X[$4311944230ad93f2$var$NODES][0];
        ll.y = xy.y < 0 ? -(0, $jVGH7.HALF_PI) : (0, $jVGH7.HALF_PI);
    } else {
        // find table interval
        var i = Math.floor(ll.y * $4311944230ad93f2$var$NODES);
        if (i < 0) i = 0;
        else if (i >= $4311944230ad93f2$var$NODES) i = $4311944230ad93f2$var$NODES - 1;
        for(;;){
            if ($4311944230ad93f2$var$COEFS_Y[i][0] > ll.y) --i;
            else if ($4311944230ad93f2$var$COEFS_Y[i + 1][0] <= ll.y) ++i;
            else break;
        }
        // linear interpolation in 5 degree interval
        var coefs = $4311944230ad93f2$var$COEFS_Y[i];
        var t = 5 * (ll.y - coefs[0]) / ($4311944230ad93f2$var$COEFS_Y[i + 1][0] - coefs[0]);
        // find t so that poly3_val(coefs, t) = ll.y
        t = $4311944230ad93f2$var$newton_rapshon(function(x) {
            return ($4311944230ad93f2$var$poly3_val(coefs, x) - ll.y) / $4311944230ad93f2$var$poly3_der(coefs, x);
        }, t, (0, $jVGH7.EPSLN), 100);
        ll.x /= $4311944230ad93f2$var$poly3_val($4311944230ad93f2$var$COEFS_X[i], t);
        ll.y = (5 * i + t) * (0, $jVGH7.D2R);
        if (xy.y < 0) ll.y = -ll.y;
    }
    ll.x = (0, $186WS.default)(ll.x + this.long0);
    return ll;
}
var $4311944230ad93f2$export$e4b2ac9215619f8d = [
    "Robinson",
    "robin"
];
var $4311944230ad93f2$export$2e2bcd8739ae039 = {
    init: $4311944230ad93f2$export$2cd8252107eb640b,
    forward: $4311944230ad93f2$export$174bb771924e7eb1,
    inverse: $4311944230ad93f2$export$70ae2c07e401031b,
    names: $4311944230ad93f2$export$e4b2ac9215619f8d
};



function $c06a388fbde39dac$export$2cd8252107eb640b() {
    this.name = "geocent";
}
function $c06a388fbde39dac$export$174bb771924e7eb1(p) {
    var point = (0, $28350e6d07d8320b$export$4a4ae2976f9a808a)(p, this.es, this.a);
    return point;
}
function $c06a388fbde39dac$export$70ae2c07e401031b(p) {
    var point = (0, $28350e6d07d8320b$export$26210192c8922750)(p, this.es, this.a, this.b);
    return point;
}
var $c06a388fbde39dac$export$e4b2ac9215619f8d = [
    "Geocentric",
    "geocentric",
    "geocent",
    "Geocent"
];
var $c06a388fbde39dac$export$2e2bcd8739ae039 = {
    init: $c06a388fbde39dac$export$2cd8252107eb640b,
    forward: $c06a388fbde39dac$export$174bb771924e7eb1,
    inverse: $c06a388fbde39dac$export$70ae2c07e401031b,
    names: $c06a388fbde39dac$export$e4b2ac9215619f8d
};



var $jVGH7 = parcelRequire("jVGH7");

var $5nakf = parcelRequire("5nakf");
/**
 * @typedef {Object} LocalThis
 * @property {number} mode
 * @property {number} sinph0
 * @property {number} cosph0
 * @property {number} pn1
 * @property {number} h
 * @property {number} rp
 * @property {number} p
 * @property {number} h1
 * @property {number} pfact
 * @property {number} es
 * @property {number} tilt
 * @property {number} azi
 * @property {number} cg
 * @property {number} sg
 * @property {number} cw
 * @property {number} sw
 */ var $aa8d8df9577aac33$var$mode = {
    N_POLE: 0,
    S_POLE: 1,
    EQUIT: 2,
    OBLIQ: 3
};
var $aa8d8df9577aac33$var$params = {
    h: {
        def: 100000,
        num: true
    },
    azi: {
        def: 0,
        num: true,
        degrees: true
    },
    tilt: {
        def: 0,
        num: true,
        degrees: true
    },
    long0: {
        def: 0,
        num: true
    },
    lat0: {
        def: 0,
        num: true
    } // default is Equator, conversion to rad is automatic
};
function $aa8d8df9577aac33$export$2cd8252107eb640b() {
    Object.keys($aa8d8df9577aac33$var$params).forEach((function(p) {
        if (typeof this[p] === "undefined") this[p] = $aa8d8df9577aac33$var$params[p].def;
        else if ($aa8d8df9577aac33$var$params[p].num && isNaN(this[p])) throw new Error("Invalid parameter value, must be numeric " + p + " = " + this[p]);
        else if ($aa8d8df9577aac33$var$params[p].num) this[p] = parseFloat(this[p]);
        if ($aa8d8df9577aac33$var$params[p].degrees) this[p] = this[p] * (0, $jVGH7.D2R);
    }).bind(this));
    if (Math.abs(Math.abs(this.lat0) - (0, $jVGH7.HALF_PI)) < (0, $jVGH7.EPSLN)) this.mode = this.lat0 < 0 ? $aa8d8df9577aac33$var$mode.S_POLE : $aa8d8df9577aac33$var$mode.N_POLE;
    else if (Math.abs(this.lat0) < (0, $jVGH7.EPSLN)) this.mode = $aa8d8df9577aac33$var$mode.EQUIT;
    else {
        this.mode = $aa8d8df9577aac33$var$mode.OBLIQ;
        this.sinph0 = Math.sin(this.lat0);
        this.cosph0 = Math.cos(this.lat0);
    }
    this.pn1 = this.h / this.a; // Normalize relative to the Earth's radius
    if (this.pn1 <= 0 || this.pn1 > 1e10) throw new Error("Invalid height");
    this.p = 1 + this.pn1;
    this.rp = 1 / this.p;
    this.h1 = 1 / this.pn1;
    this.pfact = (this.p + 1) * this.h1;
    this.es = 0;
    var omega = this.tilt;
    var gamma = this.azi;
    this.cg = Math.cos(gamma);
    this.sg = Math.sin(gamma);
    this.cw = Math.cos(omega);
    this.sw = Math.sin(omega);
}
function $aa8d8df9577aac33$export$174bb771924e7eb1(p) {
    p.x -= this.long0;
    var sinphi = Math.sin(p.y);
    var cosphi = Math.cos(p.y);
    var coslam = Math.cos(p.x);
    var x, y;
    switch(this.mode){
        case $aa8d8df9577aac33$var$mode.OBLIQ:
            y = this.sinph0 * sinphi + this.cosph0 * cosphi * coslam;
            break;
        case $aa8d8df9577aac33$var$mode.EQUIT:
            y = cosphi * coslam;
            break;
        case $aa8d8df9577aac33$var$mode.S_POLE:
            y = -sinphi;
            break;
        case $aa8d8df9577aac33$var$mode.N_POLE:
            y = sinphi;
            break;
    }
    y = this.pn1 / (this.p - y);
    x = y * cosphi * Math.sin(p.x);
    switch(this.mode){
        case $aa8d8df9577aac33$var$mode.OBLIQ:
            y *= this.cosph0 * sinphi - this.sinph0 * cosphi * coslam;
            break;
        case $aa8d8df9577aac33$var$mode.EQUIT:
            y *= sinphi;
            break;
        case $aa8d8df9577aac33$var$mode.N_POLE:
            y *= -(cosphi * coslam);
            break;
        case $aa8d8df9577aac33$var$mode.S_POLE:
            y *= cosphi * coslam;
            break;
    }
    // Tilt
    var yt, ba;
    yt = y * this.cg + x * this.sg;
    ba = 1 / (yt * this.sw * this.h1 + this.cw);
    x = (x * this.cg - y * this.sg) * this.cw * ba;
    y = yt * ba;
    p.x = x * this.a;
    p.y = y * this.a;
    return p;
}
function $aa8d8df9577aac33$export$70ae2c07e401031b(p) {
    p.x /= this.a;
    p.y /= this.a;
    var r = {
        x: p.x,
        y: p.y
    };
    // Un-Tilt
    var bm, bq, yt;
    yt = 1 / (this.pn1 - p.y * this.sw);
    bm = this.pn1 * p.x * yt;
    bq = this.pn1 * p.y * this.cw * yt;
    p.x = bm * this.cg + bq * this.sg;
    p.y = bq * this.cg - bm * this.sg;
    var rh = (0, $5nakf.default)(p.x, p.y);
    if (Math.abs(rh) < (0, $jVGH7.EPSLN)) {
        r.x = 0;
        r.y = p.y;
    } else {
        var cosz, sinz;
        sinz = 1 - rh * rh * this.pfact;
        sinz = (this.p - Math.sqrt(sinz)) / (this.pn1 / rh + rh / this.pn1);
        cosz = Math.sqrt(1 - sinz * sinz);
        switch(this.mode){
            case $aa8d8df9577aac33$var$mode.OBLIQ:
                r.y = Math.asin(cosz * this.sinph0 + p.y * sinz * this.cosph0 / rh);
                p.y = (cosz - this.sinph0 * Math.sin(r.y)) * rh;
                p.x *= sinz * this.cosph0;
                break;
            case $aa8d8df9577aac33$var$mode.EQUIT:
                r.y = Math.asin(p.y * sinz / rh);
                p.y = cosz * rh;
                p.x *= sinz;
                break;
            case $aa8d8df9577aac33$var$mode.N_POLE:
                r.y = Math.asin(cosz);
                p.y = -p.y;
                break;
            case $aa8d8df9577aac33$var$mode.S_POLE:
                r.y = -Math.asin(cosz);
                break;
        }
        r.x = Math.atan2(p.x, p.y);
    }
    p.x = r.x + this.long0;
    p.y = r.y;
    return p;
}
var $aa8d8df9577aac33$export$e4b2ac9215619f8d = [
    "Tilted_Perspective",
    "tpers"
];
var $aa8d8df9577aac33$export$2e2bcd8739ae039 = {
    init: $aa8d8df9577aac33$export$2cd8252107eb640b,
    forward: $aa8d8df9577aac33$export$174bb771924e7eb1,
    inverse: $aa8d8df9577aac33$export$70ae2c07e401031b,
    names: $aa8d8df9577aac33$export$e4b2ac9215619f8d
};



var $5nakf = parcelRequire("5nakf");
function $00b6e40a25759b03$export$2cd8252107eb640b() {
    this.flip_axis = this.sweep === "x" ? 1 : 0;
    this.h = Number(this.h);
    this.radius_g_1 = this.h / this.a;
    if (this.radius_g_1 <= 0 || this.radius_g_1 > 1e10) throw new Error();
    this.radius_g = 1.0 + this.radius_g_1;
    this.C = this.radius_g * this.radius_g - 1.0;
    if (this.es !== 0.0) {
        var one_es = 1.0 - this.es;
        var rone_es = 1 / one_es;
        this.radius_p = Math.sqrt(one_es);
        this.radius_p2 = one_es;
        this.radius_p_inv2 = rone_es;
        this.shape = "ellipse"; // Use as a condition in the forward and inverse functions.
    } else {
        this.radius_p = 1.0;
        this.radius_p2 = 1.0;
        this.radius_p_inv2 = 1.0;
        this.shape = "sphere"; // Use as a condition in the forward and inverse functions.
    }
    if (!this.title) this.title = "Geostationary Satellite View";
}
function $00b6e40a25759b03$var$forward(p) {
    var lon = p.x;
    var lat = p.y;
    var tmp, v_x, v_y, v_z;
    lon = lon - this.long0;
    if (this.shape === "ellipse") {
        lat = Math.atan(this.radius_p2 * Math.tan(lat));
        var r = this.radius_p / (0, $5nakf.default)(this.radius_p * Math.cos(lat), Math.sin(lat));
        v_x = r * Math.cos(lon) * Math.cos(lat);
        v_y = r * Math.sin(lon) * Math.cos(lat);
        v_z = r * Math.sin(lat);
        if ((this.radius_g - v_x) * v_x - v_y * v_y - v_z * v_z * this.radius_p_inv2 < 0.0) {
            p.x = Number.NaN;
            p.y = Number.NaN;
            return p;
        }
        tmp = this.radius_g - v_x;
        if (this.flip_axis) {
            p.x = this.radius_g_1 * Math.atan(v_y / (0, $5nakf.default)(v_z, tmp));
            p.y = this.radius_g_1 * Math.atan(v_z / tmp);
        } else {
            p.x = this.radius_g_1 * Math.atan(v_y / tmp);
            p.y = this.radius_g_1 * Math.atan(v_z / (0, $5nakf.default)(v_y, tmp));
        }
    } else if (this.shape === "sphere") {
        tmp = Math.cos(lat);
        v_x = Math.cos(lon) * tmp;
        v_y = Math.sin(lon) * tmp;
        v_z = Math.sin(lat);
        tmp = this.radius_g - v_x;
        if (this.flip_axis) {
            p.x = this.radius_g_1 * Math.atan(v_y / (0, $5nakf.default)(v_z, tmp));
            p.y = this.radius_g_1 * Math.atan(v_z / tmp);
        } else {
            p.x = this.radius_g_1 * Math.atan(v_y / tmp);
            p.y = this.radius_g_1 * Math.atan(v_z / (0, $5nakf.default)(v_y, tmp));
        }
    }
    p.x = p.x * this.a;
    p.y = p.y * this.a;
    return p;
}
function $00b6e40a25759b03$var$inverse(p) {
    var v_x = -1;
    var v_y = 0.0;
    var v_z = 0.0;
    var a, b, det, k;
    p.x = p.x / this.a;
    p.y = p.y / this.a;
    if (this.shape === "ellipse") {
        if (this.flip_axis) {
            v_z = Math.tan(p.y / this.radius_g_1);
            v_y = Math.tan(p.x / this.radius_g_1) * (0, $5nakf.default)(1.0, v_z);
        } else {
            v_y = Math.tan(p.x / this.radius_g_1);
            v_z = Math.tan(p.y / this.radius_g_1) * (0, $5nakf.default)(1.0, v_y);
        }
        var v_zp = v_z / this.radius_p;
        a = v_y * v_y + v_zp * v_zp + v_x * v_x;
        b = 2 * this.radius_g * v_x;
        det = b * b - 4 * a * this.C;
        if (det < 0.0) {
            p.x = Number.NaN;
            p.y = Number.NaN;
            return p;
        }
        k = (-b - Math.sqrt(det)) / (2.0 * a);
        v_x = this.radius_g + k * v_x;
        v_y *= k;
        v_z *= k;
        p.x = Math.atan2(v_y, v_x);
        p.y = Math.atan(v_z * Math.cos(p.x) / v_x);
        p.y = Math.atan(this.radius_p_inv2 * Math.tan(p.y));
    } else if (this.shape === "sphere") {
        if (this.flip_axis) {
            v_z = Math.tan(p.y / this.radius_g_1);
            v_y = Math.tan(p.x / this.radius_g_1) * Math.sqrt(1.0 + v_z * v_z);
        } else {
            v_y = Math.tan(p.x / this.radius_g_1);
            v_z = Math.tan(p.y / this.radius_g_1) * Math.sqrt(1.0 + v_y * v_y);
        }
        a = v_y * v_y + v_z * v_z + v_x * v_x;
        b = 2 * this.radius_g * v_x;
        det = b * b - 4 * a * this.C;
        if (det < 0.0) {
            p.x = Number.NaN;
            p.y = Number.NaN;
            return p;
        }
        k = (-b - Math.sqrt(det)) / (2.0 * a);
        v_x = this.radius_g + k * v_x;
        v_y *= k;
        v_z *= k;
        p.x = Math.atan2(v_y, v_x);
        p.y = Math.atan(v_z * Math.cos(p.x) / v_x);
    }
    p.x = p.x + this.long0;
    return p;
}
var $00b6e40a25759b03$export$e4b2ac9215619f8d = [
    "Geostationary Satellite View",
    "Geostationary_Satellite",
    "geos"
];
var $00b6e40a25759b03$export$2e2bcd8739ae039 = {
    init: $00b6e40a25759b03$export$2cd8252107eb640b,
    forward: $00b6e40a25759b03$var$forward,
    inverse: $00b6e40a25759b03$var$inverse,
    names: $00b6e40a25759b03$export$e4b2ac9215619f8d
};


/**
 * Copyright 2018 Bernie Jenny, Monash University, Melbourne, Australia.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Equal Earth is a projection inspired by the Robinson projection, but unlike
 * the Robinson projection retains the relative size of areas. The projection
 * was designed in 2018 by Bojan Savric, Tom Patterson and Bernhard Jenny.
 *
 * Publication:
 * Bojan Savric, Tom Patterson & Bernhard Jenny (2018). The Equal Earth map
 * projection, International Journal of Geographical Information Science,
 * DOI: 10.1080/13658816.2018.1504949
 *
 * Code released August 2018
 * Ported to JavaScript and adapted for mapshaper-proj by Matthew Bloch August 2018
 * Modified for proj4js by Andreas Hocevar by Andreas Hocevar March 2024
 */ 
var $186WS = parcelRequire("186WS");
var $c63433ff1d05c447$var$A1 = 1.340264, $c63433ff1d05c447$var$A2 = -0.081106, $c63433ff1d05c447$var$A3 = 0.000893, $c63433ff1d05c447$var$A4 = 0.003796, $c63433ff1d05c447$var$M = Math.sqrt(3) / 2.0;
function $c63433ff1d05c447$export$2cd8252107eb640b() {
    this.es = 0;
    this.long0 = this.long0 !== undefined ? this.long0 : 0;
}
function $c63433ff1d05c447$export$174bb771924e7eb1(p) {
    var lam = (0, $186WS.default)(p.x - this.long0);
    var phi = p.y;
    var paramLat = Math.asin($c63433ff1d05c447$var$M * Math.sin(phi)), paramLatSq = paramLat * paramLat, paramLatPow6 = paramLatSq * paramLatSq * paramLatSq;
    p.x = lam * Math.cos(paramLat) / ($c63433ff1d05c447$var$M * ($c63433ff1d05c447$var$A1 + 3 * $c63433ff1d05c447$var$A2 * paramLatSq + paramLatPow6 * (7 * $c63433ff1d05c447$var$A3 + 9 * $c63433ff1d05c447$var$A4 * paramLatSq)));
    p.y = paramLat * ($c63433ff1d05c447$var$A1 + $c63433ff1d05c447$var$A2 * paramLatSq + paramLatPow6 * ($c63433ff1d05c447$var$A3 + $c63433ff1d05c447$var$A4 * paramLatSq));
    p.x = this.a * p.x + this.x0;
    p.y = this.a * p.y + this.y0;
    return p;
}
function $c63433ff1d05c447$export$70ae2c07e401031b(p) {
    p.x = (p.x - this.x0) / this.a;
    p.y = (p.y - this.y0) / this.a;
    var EPS = 1e-9, NITER = 12, paramLat = p.y, paramLatSq, paramLatPow6, fy, fpy, dlat, i;
    for(i = 0; i < NITER; ++i){
        paramLatSq = paramLat * paramLat;
        paramLatPow6 = paramLatSq * paramLatSq * paramLatSq;
        fy = paramLat * ($c63433ff1d05c447$var$A1 + $c63433ff1d05c447$var$A2 * paramLatSq + paramLatPow6 * ($c63433ff1d05c447$var$A3 + $c63433ff1d05c447$var$A4 * paramLatSq)) - p.y;
        fpy = $c63433ff1d05c447$var$A1 + 3 * $c63433ff1d05c447$var$A2 * paramLatSq + paramLatPow6 * (7 * $c63433ff1d05c447$var$A3 + 9 * $c63433ff1d05c447$var$A4 * paramLatSq);
        paramLat -= dlat = fy / fpy;
        if (Math.abs(dlat) < EPS) break;
    }
    paramLatSq = paramLat * paramLat;
    paramLatPow6 = paramLatSq * paramLatSq * paramLatSq;
    p.x = $c63433ff1d05c447$var$M * p.x * ($c63433ff1d05c447$var$A1 + 3 * $c63433ff1d05c447$var$A2 * paramLatSq + paramLatPow6 * (7 * $c63433ff1d05c447$var$A3 + 9 * $c63433ff1d05c447$var$A4 * paramLatSq)) / Math.cos(paramLat);
    p.y = Math.asin(Math.sin(paramLat) / $c63433ff1d05c447$var$M);
    p.x = (0, $186WS.default)(p.x + this.long0);
    return p;
}
var $c63433ff1d05c447$export$e4b2ac9215619f8d = [
    "eqearth",
    "Equal Earth",
    "Equal_Earth"
];
var $c63433ff1d05c447$export$2e2bcd8739ae039 = {
    init: $c63433ff1d05c447$export$2cd8252107eb640b,
    forward: $c63433ff1d05c447$export$174bb771924e7eb1,
    inverse: $c63433ff1d05c447$export$70ae2c07e401031b,
    names: $c63433ff1d05c447$export$e4b2ac9215619f8d
};




var $186WS = parcelRequire("186WS");

var $5nakf = parcelRequire("5nakf");

var $a2vUM = parcelRequire("a2vUM");

var $bL4ry = parcelRequire("bL4ry");

var $iX7sK = parcelRequire("iX7sK");

var $jVGH7 = parcelRequire("jVGH7");
/**
 * @typedef {Object} LocalThis
 * @property {number} phi1
 * @property {number} cphi1
 * @property {number} es
 * @property {Array<number>} en
 * @property {number} m1
 * @property {number} am1
 */ var $7f76a52d4e2ae2ea$var$EPS10 = 1e-10;
function $7f76a52d4e2ae2ea$export$2cd8252107eb640b() {
    var c;
    this.phi1 = this.lat1;
    if (Math.abs(this.phi1) < $7f76a52d4e2ae2ea$var$EPS10) throw new Error();
    if (this.es) {
        this.en = (0, $a2vUM.default)(this.es);
        this.m1 = (0, $iX7sK.default)(this.phi1, this.am1 = Math.sin(this.phi1), c = Math.cos(this.phi1), this.en);
        this.am1 = c / (Math.sqrt(1 - this.es * this.am1 * this.am1) * this.am1);
        this.inverse = $7f76a52d4e2ae2ea$var$e_inv;
        this.forward = $7f76a52d4e2ae2ea$var$e_fwd;
    } else {
        if (Math.abs(this.phi1) + $7f76a52d4e2ae2ea$var$EPS10 >= (0, $jVGH7.HALF_PI)) this.cphi1 = 0;
        else this.cphi1 = 1 / Math.tan(this.phi1);
        this.inverse = $7f76a52d4e2ae2ea$var$s_inv;
        this.forward = $7f76a52d4e2ae2ea$var$s_fwd;
    }
}
function $7f76a52d4e2ae2ea$var$e_fwd(p) {
    var lam = (0, $186WS.default)(p.x - (this.long0 || 0));
    var phi = p.y;
    var rh, E, c;
    rh = this.am1 + this.m1 - (0, $iX7sK.default)(phi, E = Math.sin(phi), c = Math.cos(phi), this.en);
    E = c * lam / (rh * Math.sqrt(1 - this.es * E * E));
    p.x = rh * Math.sin(E);
    p.y = this.am1 - rh * Math.cos(E);
    p.x = this.a * p.x + (this.x0 || 0);
    p.y = this.a * p.y + (this.y0 || 0);
    return p;
}
function $7f76a52d4e2ae2ea$var$e_inv(p) {
    p.x = (p.x - (this.x0 || 0)) / this.a;
    p.y = (p.y - (this.y0 || 0)) / this.a;
    var s, rh, lam, phi;
    rh = (0, $5nakf.default)(p.x, p.y = this.am1 - p.y);
    phi = (0, $bL4ry.default)(this.am1 + this.m1 - rh, this.es, this.en);
    if ((s = Math.abs(phi)) < (0, $jVGH7.HALF_PI)) {
        s = Math.sin(phi);
        lam = rh * Math.atan2(p.x, p.y) * Math.sqrt(1 - this.es * s * s) / Math.cos(phi);
    } else if (Math.abs(s - (0, $jVGH7.HALF_PI)) <= $7f76a52d4e2ae2ea$var$EPS10) lam = 0;
    else throw new Error();
    p.x = (0, $186WS.default)(lam + (this.long0 || 0));
    p.y = (0, $5e9ef618071d6e3b$export$2e2bcd8739ae039)(phi);
    return p;
}
function $7f76a52d4e2ae2ea$var$s_fwd(p) {
    var lam = (0, $186WS.default)(p.x - (this.long0 || 0));
    var phi = p.y;
    var E, rh;
    rh = this.cphi1 + this.phi1 - phi;
    if (Math.abs(rh) > $7f76a52d4e2ae2ea$var$EPS10) {
        p.x = rh * Math.sin(E = lam * Math.cos(phi) / rh);
        p.y = this.cphi1 - rh * Math.cos(E);
    } else p.x = p.y = 0;
    p.x = this.a * p.x + (this.x0 || 0);
    p.y = this.a * p.y + (this.y0 || 0);
    return p;
}
function $7f76a52d4e2ae2ea$var$s_inv(p) {
    p.x = (p.x - (this.x0 || 0)) / this.a;
    p.y = (p.y - (this.y0 || 0)) / this.a;
    var lam, phi;
    var rh = (0, $5nakf.default)(p.x, p.y = this.cphi1 - p.y);
    phi = this.cphi1 + this.phi1 - rh;
    if (Math.abs(phi) > (0, $jVGH7.HALF_PI)) throw new Error();
    if (Math.abs(Math.abs(phi) - (0, $jVGH7.HALF_PI)) <= $7f76a52d4e2ae2ea$var$EPS10) lam = 0;
    else lam = rh * Math.atan2(p.x, p.y) / Math.cos(phi);
    p.x = (0, $186WS.default)(lam + (this.long0 || 0));
    p.y = (0, $5e9ef618071d6e3b$export$2e2bcd8739ae039)(phi);
    return p;
}
var $7f76a52d4e2ae2ea$export$e4b2ac9215619f8d = [
    "bonne",
    "Bonne (Werner lat_1=90)"
];
var $7f76a52d4e2ae2ea$export$2e2bcd8739ae039 = {
    init: $7f76a52d4e2ae2ea$export$2cd8252107eb640b,
    names: $7f76a52d4e2ae2ea$export$e4b2ac9215619f8d
};


function $fb4c9c7de390eda5$export$2e2bcd8739ae039(proj4) {
    proj4.Proj.projections.add((0, $jSMMP.default));
    proj4.Proj.projections.add((0, $5C8fj.default));
    proj4.Proj.projections.add((0, $1317aa6303863d5e$export$2e2bcd8739ae039));
    proj4.Proj.projections.add((0, $9f9db2d24b8edc66$export$2e2bcd8739ae039));
    proj4.Proj.projections.add((0, $292ab23fdb0d0b5e$export$2e2bcd8739ae039));
    proj4.Proj.projections.add((0, $2e022212320a1a67$export$2e2bcd8739ae039));
    proj4.Proj.projections.add((0, $3566c122b734ed10$export$2e2bcd8739ae039));
    proj4.Proj.projections.add((0, $9b86752aaa99cc3b$export$2e2bcd8739ae039));
    proj4.Proj.projections.add((0, $eac2b833dce4b7da$export$2e2bcd8739ae039));
    proj4.Proj.projections.add((0, $b68c64924618a152$export$2e2bcd8739ae039));
    proj4.Proj.projections.add((0, $bLuvW.default));
    proj4.Proj.projections.add((0, $fNzYi.default));
    proj4.Proj.projections.add((0, $25cea8f4ad97de74$export$2e2bcd8739ae039));
    proj4.Proj.projections.add((0, $1cbf69e6a792f5dc$export$2e2bcd8739ae039));
    proj4.Proj.projections.add((0, $4ae3f27f6655e1e5$export$2e2bcd8739ae039));
    proj4.Proj.projections.add((0, $a1ba7e59704eb1bc$export$2e2bcd8739ae039));
    proj4.Proj.projections.add((0, $f96MB.default));
    proj4.Proj.projections.add((0, $a5ace360409b4efe$export$2e2bcd8739ae039));
    proj4.Proj.projections.add((0, $ced6a1dae75e9d8e$export$2e2bcd8739ae039));
    proj4.Proj.projections.add((0, $ffe241c139dc27b2$export$2e2bcd8739ae039));
    proj4.Proj.projections.add((0, $3b0a2156b617102a$export$2e2bcd8739ae039));
    proj4.Proj.projections.add((0, $aa03d8084d376ef4$export$2e2bcd8739ae039));
    proj4.Proj.projections.add((0, $8fe311c4825ed36a$export$2e2bcd8739ae039));
    proj4.Proj.projections.add((0, $dce4c808e0fe5749$export$2e2bcd8739ae039));
    proj4.Proj.projections.add((0, $b2bb233327c3895a$export$2e2bcd8739ae039));
    proj4.Proj.projections.add((0, $4311944230ad93f2$export$2e2bcd8739ae039));
    proj4.Proj.projections.add((0, $c06a388fbde39dac$export$2e2bcd8739ae039));
    proj4.Proj.projections.add((0, $aa8d8df9577aac33$export$2e2bcd8739ae039));
    proj4.Proj.projections.add((0, $00b6e40a25759b03$export$2e2bcd8739ae039));
    proj4.Proj.projections.add((0, $c63433ff1d05c447$export$2e2bcd8739ae039));
    proj4.Proj.projections.add((0, $7f76a52d4e2ae2ea$export$2e2bcd8739ae039));
}


/**
 * @typedef {Object} Mgrs
 * @property {(lonlat: [number, number]) => string} forward
 * @property {(mgrsString: string) => [number, number, number, number]} inverse
 * @property {(mgrsString: string) => [number, number]} toPoint
 */ /**
 * @template {import('./core').TemplateCoordinates} T
 * @type {core<T> & {defaultDatum: string, Proj: typeof Proj, WGS84: Proj, Point: typeof Point, toPoint: typeof common, defs: typeof defs, nadgrid: typeof nadgrid, transform: typeof transform, mgrs: Mgrs, version: string}}
 */ const $37e7d27a698002f1$var$proj4 = Object.assign((0, $99c84e6d92fa15df$export$2e2bcd8739ae039), {
    defaultDatum: "WGS84",
    Proj: $52991e6d5af7834c$export$2e2bcd8739ae039,
    WGS84: new (0, $52991e6d5af7834c$export$2e2bcd8739ae039)("WGS84"),
    Point: $707fd9647656ee51$export$2e2bcd8739ae039,
    toPoint: (0, $f096975591849c79$export$2e2bcd8739ae039),
    defs: $03d76949ae40b981$export$2e2bcd8739ae039,
    nadgrid: $80595ee12d2371a9$export$2e2bcd8739ae039,
    transform: $a485f78aa3c84bef$export$2e2bcd8739ae039,
    mgrs: $a69d50808ceeca96$export$2e2bcd8739ae039,
    version: "__VERSION__"
});
(0, $fb4c9c7de390eda5$export$2e2bcd8739ae039)($37e7d27a698002f1$var$proj4);
var $37e7d27a698002f1$export$2e2bcd8739ae039 = $37e7d27a698002f1$var$proj4;


var $7e38a554ccd68dd6$require$proj4 = $37e7d27a698002f1$exports;
var $f68f332138d52ff8$exports = {};
/* pass 1 */ const $f68f332138d52ff8$var$A = " +no_defs", $f68f332138d52ff8$var$B = " +towgs84=0,0,0,0,0,0,0", $f68f332138d52ff8$var$C = " +ellps=GRS80", $f68f332138d52ff8$var$D = "+proj=tmerc", $f68f332138d52ff8$var$E = " +units=m", $f68f332138d52ff8$var$F = " +towgs84=23.92,-141.27,-80.9,-0,0.35,0.82,-0.12", $f68f332138d52ff8$var$G = " +towgs84=24.47,-130.89,-81.56,-0,-0,0.13,-0.22", $f68f332138d52ff8$var$H = "+proj=lcc", $f68f332138d52ff8$var$I = "+proj=utm", $f68f332138d52ff8$var$J = " +units=us-ft", $f68f332138d52ff8$var$K = "+proj=longlat", $f68f332138d52ff8$var$L = " +lat_0=0", $f68f332138d52ff8$var$M = " +ellps=krass", $f68f332138d52ff8$var$N = " +y_0=0", $f68f332138d52ff8$var$O = " +x_0=500000", $f68f332138d52ff8$var$P = " +towgs84=0,0,4.5,0,0,0.554,0.2263", $f68f332138d52ff8$var$Q = " +towgs84=0,0,1.9,0,0,0.814,-0.38", $f68f332138d52ff8$var$R = " +ellps=intl", $f68f332138d52ff8$var$S = " +datum=WGS84", $f68f332138d52ff8$var$T = " +ellps=WGS72", $f68f332138d52ff8$var$U = " +towgs84=15.8,-154.4,-82.3,0,0,0,0", $f68f332138d52ff8$var$V = " +k=0.9999", $f68f332138d52ff8$var$W = " +towgs84=59.47,-5.04,187.44,0.47,-0.1,1.024,-4.5993", $f68f332138d52ff8$var$X = " +datum=NAD27", $f68f332138d52ff8$var$Y = " +ellps=bessel", $f68f332138d52ff8$var$Z = " +x_0=609601.2192024384", $f68f332138d52ff8$var$a = " +x_0=600000", $f68f332138d52ff8$var$b = " +towgs84=33.4,-146.6,-76.3,-0.359,-0.053,0.844,-0.84", $f68f332138d52ff8$var$c = " +ellps=clrk80", $f68f332138d52ff8$var$d = " +b=6356755.288157528", $f68f332138d52ff8$var$e = " +x_0=152400.3048006096", $f68f332138d52ff8$var$f = " +lat_0=36.66666666666666", $f68f332138d52ff8$var$g = " +towgs84=-146.414,507.337,680.507,0,0,0,0", $f68f332138d52ff8$var$h = " +x_0=200000", $f68f332138d52ff8$var$i = " +ellps=clrk66", $f68f332138d52ff8$var$j = " +ellps=WGS84", $f68f332138d52ff8$var$k = " +x_0=500000.001016002", $f68f332138d52ff8$var$l = " +x_0=240000", $f68f332138d52ff8$var$m = " +lat_0=-90", $f68f332138d52ff8$var$n = " +towgs84=-87,-98,-121,0,0,0,0", $f68f332138d52ff8$var$o = " +south", $f68f332138d52ff8$var$p = " +lat_0=41.66666666666666", $f68f332138d52ff8$var$q = " +y_0=36000", $f68f332138d52ff8$var$r = " +towgs84=-117.808,-51.536,137.784,0.303,0.446,0.234,-0.29", $f68f332138d52ff8$var$s = " +x_0=0", $f68f332138d52ff8$var$t = " +units=ft", $f68f332138d52ff8$var$u = " +x_0=400000", $f68f332138d52ff8$var$v = " +towgs84=-115.854,-99.0583,-152.462,0,0,0,0", $f68f332138d52ff8$var$w = " +towgs84=-208.406,-109.878,-2.5764,0,0,0,0", $f68f332138d52ff8$var$x = " +ellps=aust_SA", $f68f332138d52ff8$var$y = " +lat_0=39.33333333333334", $f68f332138d52ff8$var$z = " +towgs84=577.326,90.129,463.919,5.137,1.474,5.297,2.4232", $f68f332138d52ff8$var$AA = " +lat_0=37.66666666666666", $f68f332138d52ff8$var$AB = " +lat_0=36.33333333333334", $f68f332138d52ff8$var$AC = " +towgs84=598.1,73.7,418.2,0.202,0.045,-2.455,6.7", $f68f332138d52ff8$var$AD = " +y_0=500000.0001016001", $f68f332138d52ff8$var$AE = " +x_0=200000.0001016002", $f68f332138d52ff8$var$AF = " +x_0=500000.0001016001", $f68f332138d52ff8$var$AG = " +x_0=500000.00001016", $f68f332138d52ff8$var$AH = " +y_0=1000000", $f68f332138d52ff8$var$AI = " +x_0=300000", $f68f332138d52ff8$var$AJ = " +lon_0=-120.5", $f68f332138d52ff8$var$AK = " +lat_0=43.66666666666666", $f68f332138d52ff8$var$AL = " +lat_0=43.83333333333334", $f68f332138d52ff8$var$AM = " +lat_1=-68.66666666666667", $f68f332138d52ff8$var$AN = " +lat_2=-71.33333333333333", $f68f332138d52ff8$var$AO = " +k=0.999966667", $f68f332138d52ff8$var$AP = " +k=0.9996", $f68f332138d52ff8$var$AQ = " +lat_0=38.33333333333334", $f68f332138d52ff8$var$AR = " +lat_1=73.66666666666667", $f68f332138d52ff8$var$AS = " +lat_2=70.33333333333333", $f68f332138d52ff8$var$AT = " +lat_0=72.02500919444445", $f68f332138d52ff8$var$AU = " +a=6378249.2", $f68f332138d52ff8$var$AV = " +x_0=1500000", $f68f332138d52ff8$var$AW = " +lat_ts=-80.23861111111111", $f68f332138d52ff8$var$AX = " +towgs84=-288,175,-376,0,0,0,0", $f68f332138d52ff8$var$AY = " +lat_1=41.78333333333333", $f68f332138d52ff8$var$AZ = " +lat_2=-75.33333333333333", $f68f332138d52ff8$var$Aa = " +towgs84=278.3,93,474.5,7.889,0.05,-6.61,6.21", $f68f332138d52ff8$var$Ab = " +x_0=304800", $f68f332138d52ff8$var$Ac = " +x_0=2000000.0001016", $f68f332138d52ff8$var$Ad = " +k=0.9999375", $f68f332138d52ff8$var$Ae = " +y_0=500000", $f68f332138d52ff8$var$Af = " +towgs84=-209.362,-87.8162,404.62,0.0046,3.4784,0.5805,-1.4547", $f68f332138d52ff8$var$Ag = " +lon_0=-100.3333333333333", $f68f332138d52ff8$var$Ah = " +lat_1=-72.66666666666667", $f68f332138d52ff8$var$Ai = " +lat_1=-76.66666666666667", $f68f332138d52ff8$var$Aj = " +lat_2=-79.33333333333333", $f68f332138d52ff8$var$Ak = " +y_0=10000000", $f68f332138d52ff8$var$Al = " +towgs84=-57,1,-41,0,0,0,0", $f68f332138d52ff8$var$Am = " +k=0.999941177", $f68f332138d52ff8$var$An = " +x_0=800000.0000101599", $f68f332138d52ff8$var$Ao = " +y_0=99999.99998983997", $f68f332138d52ff8$var$Ap = " +lat_1=38.43333333333333", $f68f332138d52ff8$var$Aq = " +lat_0=24.33333333333333", $f68f332138d52ff8$var$Ar = " +towgs84=26,-121,-78,0,0,0,0", $f68f332138d52ff8$var$As = " +a=6378140", $f68f332138d52ff8$var$At = " +towgs84=-96.062,-82.428,-121.753,4.801,0.345,-1.376,1.496", $f68f332138d52ff8$var$Au = " +x_0=399999.99998984", $f68f332138d52ff8$var$Av = " +towgs84=-24,-15,5,0,0,0,0", $f68f332138d52ff8$var$Aw = " +towgs84=682,-203,480,0,0,0,0", $f68f332138d52ff8$var$Ax = " +towgs84=-136,-108,-292,0,0,0,0", $f68f332138d52ff8$var$Ay = " +b=6356075.41314024", $f68f332138d52ff8$var$Az = " +lat_1=37.96666666666667", $f68f332138d52ff8$var$BA = " +lat_0=38.83333333333334", $f68f332138d52ff8$var$BB = " +lat_0=40.16666666666666", $f68f332138d52ff8$var$BC = " +lat_0=34.33333333333334", $f68f332138d52ff8$var$BD = " +lat_0=42.83333333333334", $f68f332138d52ff8$var$BE = " +lon_0=-84.36666666666666", $f68f332138d52ff8$var$BF = " +x_0=300000.0000000001", $f68f332138d52ff8$var$BG = " +k=0.999933333", $f68f332138d52ff8$var$BH = " +lat_1=48.73333333333333", $f68f332138d52ff8$var$BI = " +lon_0=-111.5", $f68f332138d52ff8$var$BJ = " +k=0.9999473679999999", $f68f332138d52ff8$var$BK = " +towgs84=-67.35,3.88,-38.22,0,0,0,0", $f68f332138d52ff8$var$BL = " +lat_2=73.66666666666667", $f68f332138d52ff8$var$BM = " +lat_0=75.36440330555556", $f68f332138d52ff8$var$BN = " +b=6356515", $f68f332138d52ff8$var$BO = " +towgs84=25,-141,-78.5,-0,0.35,0.736,0", $f68f332138d52ff8$var$BP = "+proj=stere", $f68f332138d52ff8$var$BQ = " +lat_1=-64.66666666666667", $f68f332138d52ff8$var$BR = " +lat_2=-67.33333333333333", $f68f332138d52ff8$var$BS = " +b=6356514.966398753", $f68f332138d52ff8$var$BT = " +towgs84=295,736,257,0,0,0,0", $f68f332138d52ff8$var$BU = " +x_0=100000", $f68f332138d52ff8$var$BV = " +towgs84=-11,851,5,0,0,0,0", $f68f332138d52ff8$var$BW = " +towgs84=414.1,41.3,603.1,-0.855,2.141,-7.023,0", $f68f332138d52ff8$var$BX = " +towgs84=-127.62,-67.24,-47.04,-3.068,4.903,1.578,-1.06", $f68f332138d52ff8$var$BY = " +lat_0=39.66666666666666", $f68f332138d52ff8$var$BZ = " +x_0=1000000", $f68f332138d52ff8$var$Ba = " +lon_0=-105.5", $f68f332138d52ff8$var$Bb = " +towgs84=482.5,-130.6,564.6,-1.042,-0.214,-0.631,8.15", $f68f332138d52ff8$var$Bc = " +a=6378249.145", $f68f332138d52ff8$var$Bd = " +x_0=2000000", $f68f332138d52ff8$var$Be = " +lat_0=45.66666666666666", $f68f332138d52ff8$var$Bf = " +lat_1=80.33333333333333", $f68f332138d52ff8$var$Bg = " +lat_0=78.70733752777778", $f68f332138d52ff8$var$Bh = " +b=6356774.50408554", $f68f332138d52ff8$var$Bi = " +lon_0=-91.33333333333333", $f68f332138d52ff8$var$Bj = " +lon_0=-123.3333333333333", $f68f332138d52ff8$var$Bk = " +towgs84=-168,-60,320,0,0,0,0", $f68f332138d52ff8$var$Bl = " +lat_0=31", $f68f332138d52ff8$var$Bm = " +towgs84=0.072,-0.507,-0.245,-0.0183,0.0003,-0.007,-0.0093", $f68f332138d52ff8$var$Bn = " +x_0=150000", $f68f332138d52ff8$var$Bo = " +x_0=3500000", $f68f332138d52ff8$var$Bp = " +towgs84=213.11,9.37,-74.95,0,0,0,0", $f68f332138d52ff8$var$Bq = " +lat_1=43.66666666666666", $f68f332138d52ff8$var$Br = " +lat_0=40.33333333333334", $f68f332138d52ff8$var$Bs = " +towgs84=-148,136,90,0,0,0,0", $f68f332138d52ff8$var$Bt = " +towgs84=616,97,-251,0,0,0,0", $f68f332138d52ff8$var$Bu = " +lon_0=-90", $f68f332138d52ff8$var$Bv = " +x_0=250000", $f68f332138d52ff8$var$Bw = " +x_0=914401.8288036576", $f68f332138d52ff8$var$Bx = " +lon_0=-90.33333333333333", $f68f332138d52ff8$var$By = " +a=6377276.345", $f68f332138d52ff8$var$Bz = " +b=6356103.038993155", $f68f332138d52ff8$var$CA = " +lat_0=40.5", $f68f332138d52ff8$var$CB = " +towgs84=-134,-48,149,0,0,0,0", $f68f332138d52ff8$var$CC = " +towgs84=25,-141,-78.5,0,0.35,0.736,0", $f68f332138d52ff8$var$CD = " +lat_1=27.83333333333333", $f68f332138d52ff8$var$CE = " +lat_2=26.16666666666667", $f68f332138d52ff8$var$CF = " +lat_2=40.71666666666667", $f68f332138d52ff8$var$CG = " +lat_2=39.01666666666667", $f68f332138d52ff8$var$CH = " +lat_2=37.21666666666667", $f68f332138d52ff8$var$CI = " +lat_1=70.33333333333333", $f68f332138d52ff8$var$CJ = " +lat_0=68.68747555555557", $f68f332138d52ff8$var$CK = " +towgs84=-104.1,-49.1,-9.9,0.971,-2.917,0.714,-11.68", $f68f332138d52ff8$var$CL = " +y_0=304800.6096012192", $f68f332138d52ff8$var$CM = " +x_0=699999.9998983998", $f68f332138d52ff8$var$CN = " +y_0=999999.9998983998", $f68f332138d52ff8$var$CO = " +y_0=800000", $f68f332138d52ff8$var$CP = " +k=0.99995", $f68f332138d52ff8$var$CQ = " +lat_0=34.75", $f68f332138d52ff8$var$CR = " +lon_0=-81", $f68f332138d52ff8$var$CS = " +lon_0=-100", $f68f332138d52ff8$var$CT = " +b=6356098.145120132", $f68f332138d52ff8$var$CU = "+proj=omerc", $f68f332138d52ff8$var$CV = " +lon_0=-98.5", $f68f332138d52ff8$var$CW = " +towgs84=-103.746,-9.614,-255.95,0,0,0,0", $f68f332138d52ff8$var$CX = " +x_0=800000", $f68f332138d52ff8$var$CY = " +lat_0=37.83333333333334", $f68f332138d52ff8$var$CZ = " +lat_2=44.33333333333334", $f68f332138d52ff8$var$Ca = " +lat_2=42.33333333333334", $f68f332138d52ff8$var$Cb = " +lat_0=29.66666666666667", $f68f332138d52ff8$var$Cc = " +lat_0=25.66666666666667", $f68f332138d52ff8$var$Cd = " +lat_0=35.83333333333334", $f68f332138d52ff8$var$Ce = " +lat_1=83.66666666666667", $f68f332138d52ff8$var$Cf = " +lat_2=80.33333333333333", $f68f332138d52ff8$var$Cg = " +lat_0=82.05842488888888", $f68f332138d52ff8$var$Ch = " +lat_0=38", $f68f332138d52ff8$var$Ci = " +x_0=2500000", $f68f332138d52ff8$var$Cj = " +towgs84=-377,681,-50,0,0,0,0", $f68f332138d52ff8$var$Ck = "+proj=cass", $f68f332138d52ff8$var$Cl = " +y_0=2000000", $f68f332138d52ff8$var$Cm = " +towgs84=-143,-236,7,0,0,0,0", $f68f332138d52ff8$var$Cn = " +lon_0=-110.1666666666667", $f68f332138d52ff8$var$Co = " +lon_0=-111.9166666666667", $f68f332138d52ff8$var$Cp = " +lon_0=-75.41666666666667", $f68f332138d52ff8$var$Cq = " +lon_0=-82.16666666666667", $f68f332138d52ff8$var$Cr = " +lon_0=-84.16666666666667", $f68f332138d52ff8$var$Cs = " +lon_0=-112.1666666666667", $f68f332138d52ff8$var$Ct = " +lon_0=-88.83333333333333", $f68f332138d52ff8$var$Cu = " +lon_0=-104.3333333333333", $f68f332138d52ff8$var$Cv = " +lon_0=-107.8333333333333", $f68f332138d52ff8$var$Cw = " +lon_0=-76.58333333333333", $f68f332138d52ff8$var$Cx = " +lon_0=-78.58333333333333", $f68f332138d52ff8$var$Cy = " +lon_0=-120.8333333333333", $f68f332138d52ff8$var$Cz = " +lon_0=-88.33333333333333", $f68f332138d52ff8$var$DA = " +lon_0=-90.16666666666667", $f68f332138d52ff8$var$DB = " +lon_0=-85.66666666666667", $f68f332138d52ff8$var$DC = " +lon_0=-87.08333333333333", $f68f332138d52ff8$var$DD = " +lon_0=-70.16666666666667", $f68f332138d52ff8$var$DE = " +lon_0=-93.09999999999999", $f68f332138d52ff8$var$DF = " +lon_0=-115.5833333333333", $f68f332138d52ff8$var$DG = " +lon_0=-116.6666666666667", $f68f332138d52ff8$var$DH = " +lon_0=-118.5833333333333", $f68f332138d52ff8$var$DI = " +lon_0=-71.66666666666667", $f68f332138d52ff8$var$DJ = " +lon_0=-105.1666666666667", $f68f332138d52ff8$var$DK = " +lon_0=-107.3333333333333", $f68f332138d52ff8$var$DL = " +lon_0=-110.0833333333333", $f68f332138d52ff8$var$DM = " +lat_0=37.5", $f68f332138d52ff8$var$DN = " +y_0=700000", $f68f332138d52ff8$var$DO = " +towgs84=-242.2,-144.9,370.3,0,0,0,0", $f68f332138d52ff8$var$DP = " +x_0=4500000", $f68f332138d52ff8$var$DQ = " +y_0=1500000", $f68f332138d52ff8$var$DR = " +x_0=599999.9999976", $f68f332138d52ff8$var$DS = " +towgs84=-275.722,94.7824,340.894,-8.001,-4.42,-11.821,1", $f68f332138d52ff8$var$DT = "+proj=aea", $f68f332138d52ff8$var$DU = " +y_0=-2500000", $f68f332138d52ff8$var$DV = " +lat_2=38.96666666666667", $f68f332138d52ff8$var$DW = " +lat_1=41.66666666666666", $f68f332138d52ff8$var$DX = " +lat_1=39.83333333333334", $f68f332138d52ff8$var$DY = " +lat_2=38.33333333333334", $f68f332138d52ff8$var$DZ = " +lat_2=37.06666666666667", $f68f332138d52ff8$var$Da = " +lat_0=35.33333333333334", $f68f332138d52ff8$var$Db = " +lat_1=35.46666666666667", $f68f332138d52ff8$var$Dc = " +lat_2=34.03333333333333", $f68f332138d52ff8$var$Dd = " +lat_1=33.88333333333333", $f68f332138d52ff8$var$De = " +lat_2=32.78333333333333", $f68f332138d52ff8$var$Df = " +lat_0=32.16666666666666", $f68f332138d52ff8$var$Dg = " +lat_2=37.23333333333333", $f68f332138d52ff8$var$Dh = " +lat_1=41.86666666666667", $f68f332138d52ff8$var$Di = " +lat_0=40.83333333333334", $f68f332138d52ff8$var$Dj = " +lat_2=29.58333333333333", $f68f332138d52ff8$var$Dk = " +lat_2=41.71666666666667", $f68f332138d52ff8$var$Dl = " +lat_1=41.03333333333333", $f68f332138d52ff8$var$Dm = " +lat_2=40.66666666666666", $f68f332138d52ff8$var$Dn = " +lat_1=36.76666666666667", $f68f332138d52ff8$var$Do = " +lat_0=33.33333333333334", $f68f332138d52ff8$var$Dp = " +lat_1=40.96666666666667", $f68f332138d52ff8$var$Dq = " +lat_2=39.93333333333333", $f68f332138d52ff8$var$Dr = " +lat_0=31.83333333333333", $f68f332138d52ff8$var$Ds = " +lat_0=31.66666666666667", $f68f332138d52ff8$var$Dt = " +lat_0=27.83333333333333", $f68f332138d52ff8$var$Du = " +lat_2=36.76666666666667", $f68f332138d52ff8$var$Dv = " +lat_0=45.33333333333334", $f68f332138d52ff8$var$Dw = " +lat_0=45.16666666666666", $f68f332138d52ff8$var$Dx = " +lat_1=36.23333333333333", $f68f332138d52ff8$var$Dy = " +lat_2=34.93333333333333", $f68f332138d52ff8$var$Dz = " +lat_1=34.76666666666667", $f68f332138d52ff8$var$EA = " +lat_0=32.66666666666666", $f68f332138d52ff8$var$EB = " +lat_1=43.26666666666667", $f68f332138d52ff8$var$EC = " +lat_2=42.06666666666667", $f68f332138d52ff8$var$ED = " +lat_2=40.61666666666667", $f68f332138d52ff8$var$EE = " +lat_1=39.78333333333333", $f68f332138d52ff8$var$EF = " +lat_2=38.71666666666667", $f68f332138d52ff8$var$EG = " +lat_1=38.56666666666667", $f68f332138d52ff8$var$EH = " +lat_2=37.26666666666667", $f68f332138d52ff8$var$EI = " +lat_0=41.08333333333334", $f68f332138d52ff8$var$EJ = " +lat_0=42.33333333333334", $f68f332138d52ff8$var$EK = " +y_0=100000", $f68f332138d52ff8$var$EL = " +b=6356173.508712696", $f68f332138d52ff8$var$EM = " +y_0=5500000", $f68f332138d52ff8$var$EN = " +lon_0=105", $f68f332138d52ff8$var$EO = " +y_0=-5000000", $f68f332138d52ff8$var$EP = " +k=0.9995000000000001", $f68f332138d52ff8$var$EQ = " +k=0.9999749999999999", $f68f332138d52ff8$var$ER = " +towgs84=-160,-6,-302,0,0,0,0", $f68f332138d52ff8$var$ES = " +towgs84=307,304,-318,0,0,0,0", $f68f332138d52ff8$var$ET = " +lon_0=-82.5", $f68f332138d52ff8$var$EU = " +towgs84=70.995,-335.916,262.898,0,0,0,0", $f68f332138d52ff8$var$EV = " +towgs84=-304.046,-60.576,103.64,0,0,0,0", $f68f332138d52ff8$var$EW = " +x_0=700000", $f68f332138d52ff8$var$EX = " +x_0=213360", $f68f332138d52ff8$var$EY = " +lon_0=-85.75", $f68f332138d52ff8$var$EZ = " +lon_0=-100.5", $f68f332138d52ff8$var$Ea = " +lon_0=-77.75", $f68f332138d52ff8$var$Eb = " +x_0=999999.9999898402", $f68f332138d52ff8$var$Ec = " +towgs84=-151.99,287.04,-147.45,0,0,0,0", $f68f332138d52ff8$var$Ed = " +lon_0=129", $f68f332138d52ff8$var$Ee = " +a=6378293.645208759", $f68f332138d52ff8$var$Ef = " +b=6356617.987679838", $f68f332138d52ff8$var$Eg = " +x_0=5500000", $f68f332138d52ff8$var$Eh = " +lat_1=40.78333333333333", $f68f332138d52ff8$var$Ei = " +lat_2=39.71666666666667", $f68f332138d52ff8$var$Ej = " +lat_1=37.93333333333333", $f68f332138d52ff8$var$Ek = " +lat_2=36.73333333333333", $f68f332138d52ff8$var$El = " +lat_1=42.68333333333333", $f68f332138d52ff8$var$Em = " +lat_1=41.48333333333333", $f68f332138d52ff8$var$En = " +lat_2=41.28333333333333", $f68f332138d52ff8$var$Eo = " +lat_1=47.08333333333334", $f68f332138d52ff8$var$Ep = " +lat_2=45.48333333333333", $f68f332138d52ff8$var$Eq = " +lat_0=44.78333333333333", $f68f332138d52ff8$var$Er = " +lat_2=44.18333333333333", $f68f332138d52ff8$var$Es = " +lat_0=43.31666666666667", $f68f332138d52ff8$var$Et = " +lat_1=36.16666666666666", $f68f332138d52ff8$var$Eu = " +lat_2=34.33333333333334", $f68f332138d52ff8$var$Ev = " +lat_2=47.43333333333333", $f68f332138d52ff8$var$Ew = " +lat_1=47.48333333333333", $f68f332138d52ff8$var$Ex = " +lat_2=46.18333333333333", $f68f332138d52ff8$var$Ey = " +lat_2=35.56666666666667", $f68f332138d52ff8$var$Ez = " +lat_1=35.23333333333333", $f68f332138d52ff8$var$FA = " +lat_2=33.93333333333333", $f68f332138d52ff8$var$FB = " +lat_2=40.88333333333333", $f68f332138d52ff8$var$FC = " +lat_1=34.83333333333334", $f68f332138d52ff8$var$FD = " +lat_1=36.41666666666666", $f68f332138d52ff8$var$FE = " +lat_1=36.18333333333333", $f68f332138d52ff8$var$FF = " +lat_1=33.96666666666667", $f68f332138d52ff8$var$FG = " +lat_2=32.13333333333333", $f68f332138d52ff8$var$FH = " +lat_1=31.88333333333333", $f68f332138d52ff8$var$FI = " +lat_2=30.11666666666667", $f68f332138d52ff8$var$FJ = " +lat_1=30.28333333333333", $f68f332138d52ff8$var$FK = " +lat_2=28.38333333333333", $f68f332138d52ff8$var$FL = " +lat_2=38.03333333333333", $f68f332138d52ff8$var$FM = " +lat_1=47.33333333333334", $f68f332138d52ff8$var$FN = " +lat_2=45.83333333333334", $f68f332138d52ff8$var$FO = " +lat_1=46.76666666666667", $f68f332138d52ff8$var$FP = " +lat_2=45.56666666666667", $f68f332138d52ff8$var$FQ = " +lat_1=44.06666666666667", $f68f332138d52ff8$var$FR = " +lat_2=42.73333333333333", $f68f332138d52ff8$var$FS = " +lat_1=32.66666666666666", $f68f332138d52ff8$var$FT = " +lat_2=31.16666666666667", $f68f332138d52ff8$var$FU = " +lat_1=48.63333333333333", $f68f332138d52ff8$var$FV = " +lat_2=47.03333333333333", $f68f332138d52ff8$var$FW = " +lat_2=45.61666666666667", $f68f332138d52ff8$var$FX = " +lat_1=45.21666666666667", $f68f332138d52ff8$var$FY = " +lat_2=43.78333333333333", $f68f332138d52ff8$var$FZ = " +lat_0=39.83333333333334", $f68f332138d52ff8$var$Fa = " +lat_2=40.43333333333333", $f68f332138d52ff8$var$Fb = " +lat_1=40.03333333333333", $f68f332138d52ff8$var$Fc = " +lat_2=38.73333333333333", $f68f332138d52ff8$var$Fd = " +lat_1=45.68333333333333", $f68f332138d52ff8$var$Fe = " +lat_2=44.41666666666666", $f68f332138d52ff8$var$Ff = " +lat_2=42.83333333333334", $f68f332138d52ff8$var$Fg = " +lat_1=38.88333333333333", $f68f332138d52ff8$var$Fh = " +lat_2=37.48333333333333", $f68f332138d52ff8$var$Fi = " +lat_1=37.08333333333334", $f68f332138d52ff8$var$Fj = " +lat_2=38.66666666666666", $f68f332138d52ff8$var$Fk = " +lat_0=58", $f68f332138d52ff8$var$Fl = " +lon_0=-98", $f68f332138d52ff8$var$Fm = " +lon_0=117", $f68f332138d52ff8$var$Fn = " +lon_0=135", $f68f332138d52ff8$var$Fo = " +lat_0=41.5", $f68f332138d52ff8$var$Fp = " +lat_0=42.5", $f68f332138d52ff8$var$Fq = " +y_0=3000000", $f68f332138d52ff8$var$Fr = " +lon_0=123", $f68f332138d52ff8$var$Fs = " +lat_0=40", $f68f332138d52ff8$var$Ft = " +lat_0=54", $f68f332138d52ff8$var$Fu = " +towgs84=-192.873,-39.382,-111.202,-0.00205,-0.0005,0.00335,0.0188", $f68f332138d52ff8$var$Fv = " +towgs84=565.417,50.3319,465.552,-0.398957,0.343988,-1.8774,4.0725", $f68f332138d52ff8$var$Fw = " +x_0=914401.8289", $f68f332138d52ff8$var$Fx = " +y_0=304800.6096", $f68f332138d52ff8$var$Fy = " +lon_0=111", $f68f332138d52ff8$var$Fz = " +k_0=0.99878641", $f68f332138d52ff8$var$GA = " +lon_0=-66.43333333333334", $f68f332138d52ff8$var$GB = " +towgs84=61,-285,-181,0,0,0,0", $f68f332138d52ff8$var$GC = " +towgs84=-133,-77,-51,0,0,0,0", $f68f332138d52ff8$var$GD = " +towgs84=-679,669,-48,0,0,0,0", $f68f332138d52ff8$var$GE = " +lon_0=-71.5", $f68f332138d52ff8$var$GF = " +lon_0=-78.5", $f68f332138d52ff8$var$GG = " +lon_0=-93.5", $f68f332138d52ff8$var$GH = " +lat_0=41.75", $f68f332138d52ff8$var$GI = " +y_0=249999.9998983998", $f68f332138d52ff8$var$GJ = " +y_0=999999.9999898402", $f68f332138d52ff8$var$GK = " +to_meter=1.0000135965", $f68f332138d52ff8$var$GL = " +a=6377304.063", $f68f332138d52ff8$var$GM = " +lat_0=36", $f68f332138d52ff8$var$GN = " +towgs84=-79.9,-158,-168.9,0,0,0,0", $f68f332138d52ff8$var$GO = " +towgs84=-50.9,-347.6,-231,0,0,0,0", $f68f332138d52ff8$var$GP = " +towgs84=-106.869,52.2978,-103.724,0.3366,-0.457,1.8422,-1.2747", $f68f332138d52ff8$var$GQ = " +towgs84=283,682,231,0,0,0,0", $f68f332138d52ff8$var$GR = " +towgs84=-206,172,-6,0,0,0,0", $f68f332138d52ff8$var$GS = " +towgs84=-92,-93,122,0,0,0,0", $f68f332138d52ff8$var$GT = " +to_meter=0.9143985307444408", $f68f332138d52ff8$var$GU = "+proj=sterea", $f68f332138d52ff8$var$GV = " +lat_0=21.16666666666667", $f68f332138d52ff8$var$GW = " +lat_1=18.43333333333333", $f68f332138d52ff8$var$GX = " +lat_2=18.03333333333333", $f68f332138d52ff8$var$GY = " +lat_0=17.83333333333333", $f68f332138d52ff8$var$GZ = " +gamma=323.1301023611111", $f68f332138d52ff8$var$Ga = " +lon_0=-79.5", $f68f332138d52ff8$var$Gb = " +y_0=4500000", $f68f332138d52ff8$var$Gc = " +x_0=31500000", $f68f332138d52ff8$var$Gd = " +x_0=500000.0001504", $f68f332138d52ff8$var$Ge = " +b=6356514.96582849", $f68f332138d52ff8$var$Gf = " +towgs84=674.4,15.1,405.3,0,0,0,0", $f68f332138d52ff8$var$Gg = " +towgs84=-180.624,-225.516,173.919,-0.81,-1.898,8.336,16.7101", $f68f332138d52ff8$var$Gh = " +towgs84=589,76,480,0,0,0,0", $f68f332138d52ff8$var$Gi = " +towgs84=-263,6,431,0,0,0,0", $f68f332138d52ff8$var$Gj = " +lon_0=15", $f68f332138d52ff8$var$Gk = " +axis=wsu", $f68f332138d52ff8$var$Gl = " +lon_0=21", $f68f332138d52ff8$var$Gm = " +lat_0=30", $f68f332138d52ff8$var$Gn = " +ellps=helmert", $f68f332138d52ff8$var$Go = " +a=6377299.151", $f68f332138d52ff8$var$Gp = " +lon_0=-74.5", $f68f332138d52ff8$var$Gq = " +b=6356750.304921594", $f68f332138d52ff8$var$Gr = " +y_0=2000000.0001016", $f68f332138d52ff8$var$Gs = " +x_0=3500000.0001016", $f68f332138d52ff8$var$Gt = " +y_0=399999.99998984", $f68f332138d52ff8$var$Gu = " +x_0=200000.00001016", $f68f332138d52ff8$var$Gv = " +b=6356098.359005156", $f68f332138d52ff8$var$Gw = " +x_0=14500000", $f68f332138d52ff8$var$Gx = " +x_0=29500000", $f68f332138d52ff8$var$Gy = " +towgs84=-117,-132,-164,0,0,0,0", $f68f332138d52ff8$var$Gz = " +zone=20", $f68f332138d52ff8$var$HA = " +lon_0=-122", $f68f332138d52ff8$var$HB = " +ellps=bess_nam", $f68f332138d52ff8$var$HC = " +lon_0=-86.15000000000001", $f68f332138d52ff8$var$HD = " +towgs84=-189,-242,-91,0,0,0,0", $f68f332138d52ff8$var$HE = " +towgs84=-265,120,-358,0,0,0,0", $f68f332138d52ff8$var$HF = " +towgs84=-73.472,-51.66,-112.482,0.953,4.6,-2.368,0.586", $f68f332138d52ff8$var$HG = " +towgs84=-17.51,-108.32,-62.39,0,0,0,0", $f68f332138d52ff8$var$HH = " +towgs84=-10.18,-350.43,291.37,0,0,0,0", $f68f332138d52ff8$var$HI = " +towgs84=-190.421,8.532,238.69,0,0,0,0", $f68f332138d52ff8$var$HJ = " +lon_0=-68.5", $f68f332138d52ff8$var$HK = " +a=6377299.36559538", $f68f332138d52ff8$var$HL = " +x_0=79999.99999968", $f68f332138d52ff8$var$HM = " +x_0=50000.00001504", $f68f332138d52ff8$var$HN = " +lon_0=0", $f68f332138d52ff8$var$HO = " +lon_0=27", $f68f332138d52ff8$var$HP = " +lon_0=75", $f68f332138d52ff8$var$HQ = " +lon_0=81", $f68f332138d52ff8$var$HR = " +lon_0=93", $f68f332138d52ff8$var$HS = " +lon_0=99", $f68f332138d52ff8$var$HT = " +x_0=900000", $f68f332138d52ff8$var$HU = " +x_0=13500000", $f68f332138d52ff8$var$HV = " +x_0=20500000", $f68f332138d52ff8$var$HW = " +x_0=22500000", $f68f332138d52ff8$var$HX = " +towgs84=-166,-15,204,0,0,0,0", $f68f332138d52ff8$var$HY = " +towgs84=-130,110,-13,0,0,0,0", $f68f332138d52ff8$var$HZ = " +towgs84=-587.8,519.75,145.76,0,0,0,0", $f68f332138d52ff8$var$Ha = " +lat_2=83.66666666666667", $f68f332138d52ff8$var$Hb = " +lat_0=85.43711833333333", $f68f332138d52ff8$var$Hc = " +towgs84=-273.5,110.6,-357.9,0,0,0,0", $f68f332138d52ff8$var$Hd = " +lon_0=87", $f68f332138d52ff8$var$He = "+proj=laea", $f68f332138d52ff8$var$Hf = " +towgs84=-403,684,41,0,0,0,0", $f68f332138d52ff8$var$Hg = " +lon_0=-92.5", $f68f332138d52ff8$var$Hh = " +y_0=6000000", $f68f332138d52ff8$var$Hi = " +zone=19", $f68f332138d52ff8$var$Hj = " +lat_0=29.5", $f68f332138d52ff8$var$Hk = " +y_0=300000", $f68f332138d52ff8$var$Hl = " +lat_2=45.5", $f68f332138d52ff8$var$Hm = " +k=0.999909091", $f68f332138d52ff8$var$Hn = " +a=6377492.018", $f68f332138d52ff8$var$Ho = " +b=6356751.689189189", $f68f332138d52ff8$var$Hp = " +b=6356100.230165384", $f68f332138d52ff8$var$Hq = " +lon_0=90", $f68f332138d52ff8$var$Hr = " +lat_0=90", $f68f332138d52ff8$var$Hs = " +x_0=18500000", $f68f332138d52ff8$var$Ht = " +x_0=19500000", $f68f332138d52ff8$var$Hu = " +x_0=15500000", $f68f332138d52ff8$var$Hv = " +x_0=16500000", $f68f332138d52ff8$var$Hw = " +x_0=21500000", $f68f332138d52ff8$var$Hx = " +x_0=23500000", $f68f332138d52ff8$var$Hy = " +x_0=25500000", $f68f332138d52ff8$var$Hz = " +x_0=26500000", $f68f332138d52ff8$var$IA = " +x_0=27500000", $f68f332138d52ff8$var$IB = " +x_0=28500000", $f68f332138d52ff8$var$IC = " +zone=18", $f68f332138d52ff8$var$ID = " +zone=21", $f68f332138d52ff8$var$IE = " +towgs84=-124.76,53,466.79,0,0,0,0", $f68f332138d52ff8$var$IF = " +lon_0=-92", $f68f332138d52ff8$var$IG = " +lon_0=33", $f68f332138d52ff8$var$IH = " +lon_0=12", $f68f332138d52ff8$var$II = " +lon_0=24", $f68f332138d52ff8$var$IJ = " +lat_2=77", $f68f332138d52ff8$var$IK = " +y_0=200000", $f68f332138d52ff8$var$IL = " +lon_0=-70.5", $f68f332138d52ff8$var$IM = " +x_0=7500000", $f68f332138d52ff8$var$IN = " +y_0=3500000", $f68f332138d52ff8$var$IO = " +towgs84=31,146,47,0,0,0,0", $f68f332138d52ff8$var$IP = " +lat_0=45", $f68f332138d52ff8$var$IQ = " +lat_0=26", $f68f332138d52ff8$var$IR = " +a=6378160", $f68f332138d52ff8$var$IS = " +lon_0=-109.5", $f68f332138d52ff8$var$IT = " +x_0=30500000", $f68f332138d52ff8$var$IU = " +x_0=32500000", $f68f332138d52ff8$var$IV = " +lon_0=-85.83333333333333", $f68f332138d52ff8$var$IW = " +lon_0=-118.3333333333333", $f68f332138d52ff8$var$IX = " +y_0=0.003048006096012192", $f68f332138d52ff8$var$IY = " +lat_0=30.5", $f68f332138d52ff8$var$IZ = " +lat_0=44", $f68f332138d52ff8$var$Ia = " +lon_0=30", $f68f332138d52ff8$var$Ib = " +lat_0=47", $f68f332138d52ff8$var$Ic = " +lat_1=77", $f68f332138d52ff8$var$Id = " +lat_0=36.16666666666666", $f68f332138d52ff8$var$Ie = " +lat_0=4.596200416666666", $f68f332138d52ff8$var$If = " +gamma=53.13010236111111", $f68f332138d52ff8$var$Ig = " +lon_0=13.33333333333333", $f68f332138d52ff8$var$Ih = " +lat_0=81.31722600000001", $f68f332138d52ff8$var$Ii = " +lat_0=73.15574086111111", $f68f332138d52ff8$var$Ij = " +lat_0=65.10127088888888", $f68f332138d52ff8$var$Ik = " +zone=17", $f68f332138d52ff8$var$Il = " +lon_0=132", $f68f332138d52ff8$var$Im = " +lon_0=114", $f68f332138d52ff8$var$In = " +towgs84=-143,-90,-294,0,0,0,0", $f68f332138d52ff8$var$Io = " +zone=22", $f68f332138d52ff8$var$Ip = " +lat_0=41", $f68f332138d52ff8$var$Iq = " +lat_0=46.5", $f68f332138d52ff8$var$Ir = " +lon_0=-118", $f68f332138d52ff8$var$Is = " +y_0=400000", $f68f332138d52ff8$var$It = " +x_0=17500000", $f68f332138d52ff8$var$Iu = " +x_0=33500000", $f68f332138d52ff8$var$Iv = " +lon_0=-113.75", $f68f332138d52ff8$var$Iw = " +lon_0=-116.25", $f68f332138d52ff8$var$Ix = " +lon_0=-115.75", $f68f332138d52ff8$var$Iy = " +lon_0=-106.25", $f68f332138d52ff8$var$Iz = " +k=0.999916667", $f68f332138d52ff8$var$JA = " +k=0.999964286", $f68f332138d52ff8$var$JB = " +lon_0=-108.75", $f68f332138d52ff8$var$JC = " +towgs84=-73,-247,227,0,0,0,0", $f68f332138d52ff8$var$JD = " +towgs84=265.025,384.929,-194.046,0,0,0,0", $f68f332138d52ff8$var$JE = " +k=0.99998", $f68f332138d52ff8$var$JF = " +lat_1=40.65", $f68f332138d52ff8$var$JG = " +lat_1=38.35", $f68f332138d52ff8$var$JH = " +y_0=2500000", $f68f332138d52ff8$var$JI = " +y_0=6500000", $f68f332138d52ff8$var$JJ = " +x_0=39999.99999984", $f68f332138d52ff8$var$JK = " +towgs84=-61.702,284.488,472.052,0,0,0,0", $f68f332138d52ff8$var$JL = " +towgs84=-223.237,110.193,36.649,0,0,0,0", $f68f332138d52ff8$var$JM = " +zone=39", $f68f332138d52ff8$var$JN = " +zone=32", $f68f332138d52ff8$var$JO = " +towgs84=-125,53,467,0,0,0,0", $f68f332138d52ff8$var$JP = " +towgs84=198,881,317,0,0,0,0", $f68f332138d52ff8$var$JQ = " +towgs84=214,804,268,0,0,0,0", $f68f332138d52ff8$var$JR = " +towgs84=217,823,299,0,0,0,0", $f68f332138d52ff8$var$JS = " +lon_0=45", $f68f332138d52ff8$var$JT = " +lat_1=43", $f68f332138d52ff8$var$JU = "+proj=merc", $f68f332138d52ff8$var$JV = " +x_0=99999.99998983997", $f68f332138d52ff8$var$JW = " +x_0=99999.99999960001", $f68f332138d52ff8$var$JX = " +x_0=2743195.592233322", $f68f332138d52ff8$var$JY = " +y_0=914398.5307444407", $f68f332138d52ff8$var$JZ = " +zone=38", $f68f332138d52ff8$var$Ja = " +zone=28", $f68f332138d52ff8$var$Jb = " +lon_0=-114", $f68f332138d52ff8$var$Jc = " +lat_1=45.5", $f68f332138d52ff8$var$Jd = " +towgs84=-73,46,-86,0,0,0,0", $f68f332138d52ff8$var$Je = " +towgs84=11,72,-101,0,0,0,0", $f68f332138d52ff8$var$Jf = " +towgs84=287.58,177.78,-135.41,0,0,0,0", $f68f332138d52ff8$var$Jg = " +towgs84=-162.619,-276.959,-161.764,0.067753,-2.24365,-1.15883,-1.09425", $f68f332138d52ff8$var$Jh = " +lon_0=-87", $f68f332138d52ff8$var$Ji = " +lon_0=-99", $f68f332138d52ff8$var$Jj = " +lon_0=102", $f68f332138d52ff8$var$Jk = " +lon_0=126", $f68f332138d52ff8$var$Jl = " +k=0.99999", $f68f332138d52ff8$var$Jm = " +x_0=50000", $f68f332138d52ff8$var$Jn = " +lat_2=40", $f68f332138d52ff8$var$Jo = " +lon_0=-84.25", $f68f332138d52ff8$var$Jp = " +x_0=11500000", $f68f332138d52ff8$var$Jq = " +lon_0=-72.75", $f68f332138d52ff8$var$Jr = " +lon_0=-101.5", $f68f332138d52ff8$var$Js = " +lon_0=-94.25", $f68f332138d52ff8$var$Jt = " +x_0=6500000", $f68f332138d52ff8$var$Ju = " +y_0=5000000", $f68f332138d52ff8$var$Jv = " +x_0=1700000", $f68f332138d52ff8$var$Jw = " +towgs84=31.95,300.99,419.19,0,0,0,0", $f68f332138d52ff8$var$Jx = " +towgs84=-189.681,18.3463,-42.7695,-0.33746,-3.09264,2.53861,0.4598", $f68f332138d52ff8$var$Jy = " +towgs84=-119.425,-303.659,-11.0006,1.1643,0.174458,1.09626,3.65706", $f68f332138d52ff8$var$Jz = " +towgs84=982.609,552.753,-540.873,6.68163,-31.6115,-19.8482,16.805", $f68f332138d52ff8$var$KA = " +zone=29", $f68f332138d52ff8$var$KB = " +lon_0=9", $f68f332138d52ff8$var$KC = " +zone=33", $f68f332138d52ff8$var$KD = " +zone=37", $f68f332138d52ff8$var$KE = " +no_uoff", $f68f332138d52ff8$var$KF = " +lon_0=120", $f68f332138d52ff8$var$KG = " +lon_0=177", $f68f332138d52ff8$var$KH = " +lon_0=-177", $f68f332138d52ff8$var$KI = " +lon_0=-158", $f68f332138d52ff8$var$KJ = " +y_0=250000", $f68f332138d52ff8$var$KK = " +lon_0=-111", $f68f332138d52ff8$var$KL = " +x_0=2500000.0001424", $f68f332138d52ff8$var$KM = " +x_0=1500000.0001464", $f68f332138d52ff8$var$KN = " +lon_0=-71.60561777777777", $f68f332138d52ff8$var$KO = " +lon_0=-156.6666666666667", $f68f332138d52ff8$var$KP = " +lon_0=-160.1666666666667", $f68f332138d52ff8$var$KQ = " +lat_0=0.1166666666666667", $f68f332138d52ff8$var$KR = " +towgs84=0,0,0,-0,-0,-0,0", $f68f332138d52ff8$var$KS = " +lon_0=-117.8333333333333", $f68f332138d52ff8$var$KT = " +lon_0=-123.1666666666667", $f68f332138d52ff8$var$KU = " +lon_0=-122.3333333333333", $f68f332138d52ff8$var$KV = " +lon_0=-119.1666666666667", $f68f332138d52ff8$var$KW = " +lon_0=-123.0833333333333", $f68f332138d52ff8$var$KX = " +lon_0=-85.84999999999999", $f68f332138d52ff8$var$KY = " +lon_0=-87.09999999999999", $f68f332138d52ff8$var$KZ = " +lon_0=-86.90000000000001", $f68f332138d52ff8$var$Ka = " +lon_0=-89.24166666666667", $f68f332138d52ff8$var$Kb = " +lon_0=-92.63333333333334", $f68f332138d52ff8$var$Kc = " +towgs84=347.103,1078.12,2623.92,-33.8875,70.6773,-9.3943,186.074", $f68f332138d52ff8$var$Kd = " +towgs84=8.846,-4.394,-1.122,-0.00237,-0.146528,0.130428,0.783926", $f68f332138d52ff8$var$Ke = " +towgs84=-480.26,-438.32,-643.429,16.3119,20.1721,-4.0349,-111.7", $f68f332138d52ff8$var$Kf = " +towgs84=-0.293,766.95,87.713,0.195704,1.69507,3.47302,-0.039338", $f68f332138d52ff8$var$Kg = " +towgs84=221.525,152.948,176.768,-2.3847,-1.3896,-0.877,11.4741", $f68f332138d52ff8$var$Kh = " +towgs84=215.525,149.593,176.229,-3.2624,-1.692,-1.1571,10.4773", $f68f332138d52ff8$var$Ki = " +zone=35", $f68f332138d52ff8$var$Kj = " +lat_0=46.95240555555556", $f68f332138d52ff8$var$Kk = " +alpha=30.28813972222222", $f68f332138d52ff8$var$Kl = " +lat_1=10.16666666666667", $f68f332138d52ff8$var$Km = " +lat_0=10.16666666666667", $f68f332138d52ff8$var$Kn = " +lat_0=18.83333333333333", $f68f332138d52ff8$var$Ko = " +lat_0=20.33333333333333", $f68f332138d52ff8$var$Kp = " +lat_0=21.83333333333333", $f68f332138d52ff8$var$Kq = " +lat_0=21.66666666666667", $f68f332138d52ff8$var$Kr = " +lat_0=45.30916666666666", $f68f332138d52ff8$var$Ks = " +lat_1=49.83333333333334", $f68f332138d52ff8$var$Kt = " +lat_2=51.16666666666666", $f68f332138d52ff8$var$Ku = " +lonc=-133.6666666666667", $f68f332138d52ff8$var$Kv = " +alpha=323.1301023611111", $f68f332138d52ff8$var$Kw = " +lat_1=53.83333333333334", $f68f332138d52ff8$var$Kx = " +lat_2=51.83333333333334", $f68f332138d52ff8$var$Ky = " +lat_1=44.66666666666666", $f68f332138d52ff8$var$Kz = " +lat_0=44.66666666666666", $f68f332138d52ff8$var$LA = " +lat_1=45.66666666666666", $f68f332138d52ff8$var$LB = " +lat_0=45.91666666666666", $f68f332138d52ff8$var$LC = " +lat_0=45.08333333333334", $f68f332138d52ff8$var$LD = " +lat_0=44.33333333333334", $f68f332138d52ff8$var$LE = " +lat_0=44.08333333333334", $f68f332138d52ff8$var$LF = " +lat_1=48.33333333333334", $f68f332138d52ff8$var$LG = " +lat_0=48.33333333333334", $f68f332138d52ff8$var$LH = " +lat_0=31.73409694444445", $f68f332138d52ff8$var$LI = " +lon_0=35.21208055555556", $f68f332138d52ff8$var$LJ = " +lat_0=44.03611111111111", $f68f332138d52ff8$var$LK = " +lat_0=4.599047222222222", $f68f332138d52ff8$var$LL = " +lat_0=40.66666666666666", $f68f332138d52ff8$var$LM = " +lat_1=49", $f68f332138d52ff8$var$LN = " +lon_0=39", $f68f332138d52ff8$var$LO = " +lat_1=37.25", $f68f332138d52ff8$var$LP = " +lat_1=39.75", $f68f332138d52ff8$var$LQ = " +lat_2=38.45", $f68f332138d52ff8$var$LR = " +lat_1=30.75", $f68f332138d52ff8$var$LS = " +lon_0=-84.5", $f68f332138d52ff8$var$LT = " +lat_0=33.75", $f68f332138d52ff8$var$LU = " +x_0=4000000", $f68f332138d52ff8$var$LV = " +y_0=4000000", $f68f332138d52ff8$var$LW = " +lon_0=-72.5", $f68f332138d52ff8$var$LX = " +x_0=5000000", $f68f332138d52ff8$var$LY = " +x_0=10500000", $f68f332138d52ff8$var$LZ = " +x_0=12500000", $f68f332138d52ff8$var$La = " +x_0=24500000", $f68f332138d52ff8$var$Lb = " +k=0.99999375", $f68f332138d52ff8$var$Lc = " +x_0=399999.9999984", $f68f332138d52ff8$var$Ld = " +lon_0=-77", $f68f332138d52ff8$var$Le = " +lon_0=108", $f68f332138d52ff8$var$Lf = " +lon_0=171", $f68f332138d52ff8$var$Lg = " +towgs84=-179.483,-69.379,-27.584,-7.862,8.163,6.042,-13.925", $f68f332138d52ff8$var$Lh = " +lon_0=-171", $f68f332138d52ff8$var$Li = " +lat_0=32.5", $f68f332138d52ff8$var$Lj = " +lon_0=-117", $f68f332138d52ff8$var$Lk = " +k=1.000015", $f68f332138d52ff8$var$Ll = " +k=1.000034", $f68f332138d52ff8$var$Lm = " +k=1.000031", $f68f332138d52ff8$var$Ln = " +k=1.000026", $f68f332138d52ff8$var$Lo = " +ellps=evrstSS", $f68f332138d52ff8$var$Lp = " +a=6377301.243", $f68f332138d52ff8$var$Lq = " +towgs84=410.721,55.049,80.746,2.5779,2.3514,0.6664,17.3311", $f68f332138d52ff8$var$Lr = " +towgs84=72.438,345.918,79.486,1.6045,0.8823,0.5565,1.3746", $f68f332138d52ff8$var$Ls = " +pm=ferro", $f68f332138d52ff8$var$Lt = " +lon_0=78", $f68f332138d52ff8$var$Lu = " +lon_0=10", $f68f332138d52ff8$var$Lv = " +pm=paris", $f68f332138d52ff8$var$Lw = " +towgs84=0.055,-0.541,-0.185,0.0183,-0.0003,-0.007,-0.014", $f68f332138d52ff8$var$Lx = " +towgs84=446.448,-125.157,542.06,0.15,0.247,0.842,-20.489", $f68f332138d52ff8$var$Ly = " +towgs84=8.853,-52.644,180.304,-0.393,-2.323,2.96,-24.081", $f68f332138d52ff8$var$Lz = " +towgs84=572.213,85.334,461.94,4.9732,1.529,5.2484,3.5378", $f68f332138d52ff8$var$MA = " +zone=58", $f68f332138d52ff8$var$MB = " +zone=23", $f68f332138d52ff8$var$MC = " +x_0=304800.6096012192", $f68f332138d52ff8$var$MD = " +y_0=152400.3048006096", $f68f332138d52ff8$var$ME = " +x_0=800000.0001016001", $f68f332138d52ff8$var$MF = " +x_0=399999.9998983998", $f68f332138d52ff8$var$MG = " +x_0=7999999.999968001", $f68f332138d52ff8$var$MH = " +x_0=5999999.999976001", $f68f332138d52ff8$var$MI = " +x_0=830000.0001016001", $f68f332138d52ff8$var$MJ = " +x_0=249999.9998983998", $f68f332138d52ff8$var$MK = " +x_0=350000.0001016001", $f68f332138d52ff8$var$ML = " +to_meter=0.3047972654", $f68f332138d52ff8$var$MM = " +x_0=99999.99989839978", $f68f332138d52ff8$var$MN = " +y_0=8000000.000010163", $f68f332138d52ff8$var$MO = " +x_0=699999.9999898402", $f68f332138d52ff8$var$MP = " +lon_0=-69", $f68f332138d52ff8$var$MQ = " +lon_0=-86", $f68f332138d52ff8$var$MR = " +towgs84=-3.2,-5.7,2.8,0,0,0,0", $f68f332138d52ff8$var$MS = " +x_0=8500000", $f68f332138d52ff8$var$MT = " +x_0=9500000", $f68f332138d52ff8$var$MU = " +lat_1=39.45", $f68f332138d52ff8$var$MV = " +lat_0=44.25", $f68f332138d52ff8$var$MW = " +lat_1=41.95", $f68f332138d52ff8$var$MX = " +lat_2=35.25", $f68f332138d52ff8$var$MY = " +lat_2=34.65", $f68f332138d52ff8$var$MZ = " +lat_2=44.25", $f68f332138d52ff8$var$Ma = " +lat_1=47.05", $f68f332138d52ff8$var$Mb = " +lat_1=40.25", $f68f332138d52ff8$var$Mc = " +k_0=1.00012", $f68f332138d52ff8$var$Md = " +lat_0=40.25", $f68f332138d52ff8$var$Me = " +zone=40", $f68f332138d52ff8$var$Mf = " +zone=36", $f68f332138d52ff8$var$Mg = " +zone=51", $f68f332138d52ff8$var$Mh = " +zone=48", $f68f332138d52ff8$var$Mi = " +zone=49", $f68f332138d52ff8$var$Mj = " +lon_0=96", $f68f332138d52ff8$var$Mk = " +y_0=750000", $f68f332138d52ff8$var$Ml = " +lat_0=36.5", $f68f332138d52ff8$var$Mm = " +lon_0=-119", $f68f332138d52ff8$var$Mn = " +lat_0=33.5", $f68f332138d52ff8$var$Mo = " +lat_2=41.2", $f68f332138d52ff8$var$Mp = " +k=0.999995", $f68f332138d52ff8$var$Mq = " +lat_2=33.3", $f68f332138d52ff8$var$Mr = " +lat_0=38.5", $f68f332138d52ff8$var$Ms = " +lon_0=-154", $f68f332138d52ff8$var$Mt = " +lon_0=-120", $f68f332138d52ff8$var$Mu = " +x_0=34500000", $f68f332138d52ff8$var$Mv = " +x_0=35500000", $f68f332138d52ff8$var$Mw = " +x_0=36500000", $f68f332138d52ff8$var$Mx = " +x_0=37500000", $f68f332138d52ff8$var$My = " +x_0=38500000", $f68f332138d52ff8$var$Mz = " +x_0=39500000", $f68f332138d52ff8$var$NA = " +x_0=40500000", $f68f332138d52ff8$var$NB = " +x_0=41500000", $f68f332138d52ff8$var$NC = " +x_0=43500000", $f68f332138d52ff8$var$ND = " +x_0=45500000", $f68f332138d52ff8$var$NE = " +y_0=3999999.99998984", $f68f332138d52ff8$var$NF = " +y_0=2000000.00001016", $f68f332138d52ff8$var$NG = " +towgs84=164,138,-189,0,0,0,0", $f68f332138d52ff8$var$NH = " +towgs84=-186,230,110,0,0,0,0", $f68f332138d52ff8$var$NI = " +towgs84=-199,32,322,0,0,0,0", $f68f332138d52ff8$var$NJ = " +to_meter=0.3047997101815088", $f68f332138d52ff8$var$NK = " +towgs84=-76,-138,67,0,0,0,0", $f68f332138d52ff8$var$NL = " +towgs84=-43,-163,45,0,0,0,0", $f68f332138d52ff8$var$NM = " +towgs84=-346,-1,224,0,0,0,0", $f68f332138d52ff8$var$NN = " +towgs84=210,814,289,0,0,0,0", $f68f332138d52ff8$var$NO = " +towgs84=-74,-130,42,0,0,0,0", $f68f332138d52ff8$var$NP = " +zone=15", $f68f332138d52ff8$var$NQ = " +zone=16", $f68f332138d52ff8$var$NR = " +zone=34", $f68f332138d52ff8$var$NS = " +zone=50", $f68f332138d52ff8$var$NT = " +zone=52", $f68f332138d52ff8$var$NU = " +lon_0=-62", $f68f332138d52ff8$var$NV = " +lon_0=-84", $f68f332138d52ff8$var$NW = " +lon_0=-79", $f68f332138d52ff8$var$NX = " +lon_0=131", $f68f332138d52ff8$var$NY = " +lon_0=153", $f68f332138d52ff8$var$NZ = " +lon_0=165", $f68f332138d52ff8$var$Na = " +lon_0=-94", $f68f332138d52ff8$var$Nb = " +lon_0=-54", $f68f332138d52ff8$var$Nc = " +a=6378300.789", $f68f332138d52ff8$var$Nd = " +b=6356566.435", $f68f332138d52ff8$var$Ne = " +y_0=3999999.9998984", $f68f332138d52ff8$var$Nf = " +y_0=5000000.0001016", $f68f332138d52ff8$var$Ng = " +x_0=150000.00001464", $f68f332138d52ff8$var$Nh = " +lat_2=46", $f68f332138d52ff8$var$Ni = " +lon_0=84", $f68f332138d52ff8$var$Nj = " +lat_0=43", $f68f332138d52ff8$var$Nk = " +k_0=0.999625769", $f68f332138d52ff8$var$Nl = " +towgs84=51,391,-36,0,0,0,0", $f68f332138d52ff8$var$Nm = " +towgs84=-83,37,124,0,0,0,0", $f68f332138d52ff8$var$Nn = " +towgs84=-355,21,72,0,0,0,0", $f68f332138d52ff8$var$No = " +towgs84=-23,259,-9,0,0,0,0", $f68f332138d52ff8$var$Np = " +towgs84=174.05,-25.49,112.57,-0,-0,0.554,0.2263", $f68f332138d52ff8$var$Nq = " +zone=59", $f68f332138d52ff8$var$Nr = " +zone=25", $f68f332138d52ff8$var$Ns = " +zone=11", $f68f332138d52ff8$var$Nt = " +zone=12", $f68f332138d52ff8$var$Nu = " +zone=13", $f68f332138d52ff8$var$Nv = " +zone=54", $f68f332138d52ff8$var$Nw = " +zone=14", $f68f332138d52ff8$var$Nx = " +zone=24", $f68f332138d52ff8$var$Ny = " +zone=47", $f68f332138d52ff8$var$Nz = " +lat_2=38.3", $f68f332138d52ff8$var$OA = " +lat_1=45.7", $f68f332138d52ff8$var$OB = " +lat_2=42.1", $f68f332138d52ff8$var$OC = " +x_0=165000", $f68f332138d52ff8$var$OD = " +lat_2=32.5", $f68f332138d52ff8$var$OE = " +x_0=609600", $f68f332138d52ff8$var$OF = " +lat_1=39.2", $f68f332138d52ff8$var$OG = " +lat_2=47.5", $f68f332138d52ff8$var$OH = " +lat_1=30.7", $f68f332138d52ff8$var$OI = " +lat_2=29.3", $f68f332138d52ff8$var$OJ = " +lat_0=28.5", $f68f332138d52ff8$var$OK = " +lat_1=41.7", $f68f332138d52ff8$var$OL = " +lat_1=44.4", $f68f332138d52ff8$var$OM = " +lat_1=27.5", $f68f332138d52ff8$var$ON = " +lon_0=-150", $f68f332138d52ff8$var$OO = " +lat_0=44.5", $f68f332138d52ff8$var$OP = " +k=1.000027", $f68f332138d52ff8$var$OQ = " +k=1.000038", $f68f332138d52ff8$var$OR = " +k=1.000036", $f68f332138d52ff8$var$OS = " +lon_0=-87.5", $f68f332138d52ff8$var$OT = " +x_0=3999999.999984", $f68f332138d52ff8$var$OU = " +x_0=199999.9999992", $f68f332138d52ff8$var$OV = " +towgs84=16,196,93,0,0,0,0", $f68f332138d52ff8$var$OW = " +towgs84=-88,4,101,0,0,0,0", $f68f332138d52ff8$var$OX = " +lat_0=18", $f68f332138d52ff8$var$OY = " +lat_2=67", $f68f332138d52ff8$var$OZ = " +lon_0=-96", $f68f332138d52ff8$var$Oa = " +x_0=80000", $f68f332138d52ff8$var$Ob = " +lon_0=-82", $f68f332138d52ff8$var$Oc = " +lon_0=-74", $f68f332138d52ff8$var$Od = " +lon_0=147", $f68f332138d52ff8$var$Oe = " +lon_0=150", $f68f332138d52ff8$var$Of = " +x_0=40000", $f68f332138d52ff8$var$Og = " +k=1.00002", $f68f332138d52ff8$var$Oh = " +x_0=42500000", $f68f332138d52ff8$var$Oi = " +x_0=44500000", $f68f332138d52ff8$var$Oj = " +lon_0=-85.05", $f68f332138d52ff8$var$Ok = " +ellps=mod_airy", $f68f332138d52ff8$var$Ol = " +lat_0=0.1333333333333333", $f68f332138d52ff8$var$Om = " +lat_1=-60.66666666666666", $f68f332138d52ff8$var$On = " +lat_2=-63.33333333333334", $f68f332138d52ff8$var$Oo = " +lon_0=-91.91666666666667", $f68f332138d52ff8$var$Op = " +y_0=0.003352806705613411", $f68f332138d52ff8$var$Oq = " +zone=30", $f68f332138d52ff8$var$Or = " +lon_0=3", $f68f332138d52ff8$var$Os = " +zone=26", $f68f332138d52ff8$var$Ot = " +zone=53", $f68f332138d52ff8$var$Ou = " +lat_0=31.73439361111111", $f68f332138d52ff8$var$Ov = " +lon_0=35.20451694444445", $f68f332138d52ff8$var$Ow = " +lon_0=7.439583333333333", $f68f332138d52ff8$var$Ox = " +lon_0=132.1666666666667", $f68f332138d52ff8$var$Oy = " +lon_0=134.3333333333333", $f68f332138d52ff8$var$Oz = " +lon_0=137.1666666666667", $f68f332138d52ff8$var$PA = " +lon_0=139.8333333333333", $f68f332138d52ff8$var$PB = " +lon_0=140.8333333333333", $f68f332138d52ff8$var$PC = " +lon_0=3.192280555555556", $f68f332138d52ff8$var$PD = " +lat_1=49.50000000000001", $f68f332138d52ff8$var$PE = " +lat_0=49.50000000000001", $f68f332138d52ff8$var$PF = " +alpha=53.31582047222222", $f68f332138d52ff8$var$PG = " +lon_0=10.33333333333333", $f68f332138d52ff8$var$PH = " +lon_0=16.33333333333333", $f68f332138d52ff8$var$PI = " +towgs84=-502.862,-247.438,312.724,0,0,0,0", $f68f332138d52ff8$var$PJ = " +towgs84=-381.788,-57.501,-256.673,0,0,0,0", $f68f332138d52ff8$var$PK = " +towgs84=-43.685,-179.785,-267.721,0,0,0,0", $f68f332138d52ff8$var$PL = " +zone=60", $f68f332138d52ff8$var$PM = " +zone=55", $f68f332138d52ff8$var$PN = " +lon_0=36", $f68f332138d52ff8$var$PO = " +lon_0=42", $f68f332138d52ff8$var$PP = " +lat_1=46", $f68f332138d52ff8$var$PQ = " +lat_1=44", $f68f332138d52ff8$var$PR = " +lat_0=42", $f68f332138d52ff8$var$PS = " +lon_0=51", $f68f332138d52ff8$var$PT = " +lat_0=33", $f68f332138d52ff8$var$PU = " +lat_0=52", $f68f332138d52ff8$var$PV = " +ellps=airy", $f68f332138d52ff8$var$PW = " +pm=jakarta", $f68f332138d52ff8$var$PX = " +x_0=2743195.5", $f68f332138d52ff8$var$PY = " +y_0=-4354009.816", $f68f332138d52ff8$var$PZ = " +k_0=0.9987864078000001", $f68f332138d52ff8$var$Pa = " +towgs84=-106.226,166.366,-37.893,0,0,0,0", $f68f332138d52ff8$var$Pb = " +towgs84=508.088,-191.042,565.223,0,0,0,0", $f68f332138d52ff8$var$Pc = " +k=0.99996", $f68f332138d52ff8$var$Pd = " +a=6378135", $f68f332138d52ff8$var$Pe = " +lon_0=-66", $f68f332138d52ff8$var$Pf = " +lon_0=141", $f68f332138d52ff8$var$Pg = " +lon_0=159", $f68f332138d52ff8$var$Ph = " +k=0.99984", $f68f332138d52ff8$var$Pi = " +lat_0=-22", $f68f332138d52ff8$var$Pj = " +lon_0=127.5", $f68f332138d52ff8$var$Pk = " +x_0=6000000", $f68f332138d52ff8$var$Pl = " +x_0=3900000", $f68f332138d52ff8$var$Pm = " +y_0=1300000", $f68f332138d52ff8$var$Pn = " +lat_0=44.75", $f68f332138d52ff8$var$Po = " +lat_0=37.75", $f68f332138d52ff8$var$Pp = " +lat_0=40.55", $f68f332138d52ff8$var$Pq = " +lon_0=-87.3", $f68f332138d52ff8$var$Pr = " +lon_0=-86.5", $f68f332138d52ff8$var$Ps = " +towgs84=195.671,332.517,274.607,0,0,0,0", $f68f332138d52ff8$var$Pt = " +towgs84=-204.619,140.176,55.226,0,0,0,0", $f68f332138d52ff8$var$Pu = "+proj=somerc", $f68f332138d52ff8$var$Pv = " +y_0=30480.06096012192", $f68f332138d52ff8$var$Pw = " +y_0=999999.9999960001", $f68f332138d52ff8$var$Px = " +x_0=182880.3657607315", $f68f332138d52ff8$var$Py = " +towgs84=674.374,15.056,405.346,0,0,0,0", $f68f332138d52ff8$var$Pz = " +towgs84=-133.63,-157.5,-158.62,0,0,0,0", $f68f332138d52ff8$var$QA = " +towgs84=-0.465,372.095,171.736,0,0,0,0", $f68f332138d52ff8$var$QB = " +towgs84=-56.263,16.136,-22.856,0,0,0,0", $f68f332138d52ff8$var$QC = " +towgs84=-241.54,-163.64,396.06,0,0,0,0", $f68f332138d52ff8$var$QD = " +zone=31", $f68f332138d52ff8$var$QE = " +zone=10", $f68f332138d52ff8$var$QF = " +zone=46", $f68f332138d52ff8$var$QG = " +x_0=304800.6096", $f68f332138d52ff8$var$QH = " +y_0=152400.3048", $f68f332138d52ff8$var$QI = " +alpha=337.25556", $f68f332138d52ff8$var$QJ = " +x_0=2546731.496", $f68f332138d52ff8$var$QK = " +gamma=337.25556", $f68f332138d52ff8$var$QL = " +k_0=0.999625544", $f68f332138d52ff8$var$QM = " +towgs84=335.47,222.58,-230.94,0,0,0,0", $f68f332138d52ff8$var$QN = " +towgs84=217.037,86.959,23.956,0,0,0,0", $f68f332138d52ff8$var$QO = " +towgs84=-128.16,-282.42,21.93,0,0,0,0", $f68f332138d52ff8$var$QP = " +towgs84=103.25,-100.4,-307.19,0,0,0,0", $f68f332138d52ff8$var$QQ = " +lon_0=31", $f68f332138d52ff8$var$QR = " +lon_0=18", $f68f332138d52ff8$var$QS = " +lat_2=36", $f68f332138d52ff8$var$QT = " +lat_0=29", $f68f332138d52ff8$var$QU = " +lat_0=35", $f68f332138d52ff8$var$QV = " +lat_0=34", $f68f332138d52ff8$var$QW = " +lon_0=63", $f68f332138d52ff8$var$QX = " +lat_0=37", $f68f332138d52ff8$var$QY = " +lat_2=65", $f68f332138d52ff8$var$QZ = " +y_0=-4000000", $f68f332138d52ff8$var$Qa = " +y_0=914398.5", $f68f332138d52ff8$var$Qb = " +towgs84=-199.87,74.79,246.62,0,0,0,0", $f68f332138d52ff8$var$Qc = " +towgs84=-11.64,-348.6,291.98,0,0,0,0", $f68f332138d52ff8$var$Qd = " +towgs84=-254.1,-5.36,-100.29,0,0,0,0", $f68f332138d52ff8$var$Qe = " +towgs84=-206.1,-174.7,-87.7,0,0,0,0", $f68f332138d52ff8$var$Qf = " +towgs84=-770.1,158.4,-498.2,0,0,0,0", $f68f332138d52ff8$var$Qg = " +towgs84=-146.21,112.63,4.05,0,0,0,0", $f68f332138d52ff8$var$Qh = " +towgs84=-294.7,-200.1,525.5,0,0,0,0", $f68f332138d52ff8$var$Qi = " +lat_0=4", $f68f332138d52ff8$var$Qj = " +a=6378300", $f68f332138d52ff8$var$Qk = " +lon_0=-63", $f68f332138d52ff8$var$Ql = " +lon_0=162", $f68f332138d52ff8$var$Qm = " +lat_ts=90", $f68f332138d52ff8$var$Qn = " +y_0=600000", $f68f332138d52ff8$var$Qo = " +x_0=350000", $f68f332138d52ff8$var$Qp = " +y_0=900000", $f68f332138d52ff8$var$Qq = " +lat_1=32.5", $f68f332138d52ff8$var$Qr = " +lon_0=-147", $f68f332138d52ff8$var$Qs = " +k=1.000043", $f68f332138d52ff8$var$Qt = " +lat_0=48.5", $f68f332138d52ff8$var$Qu = " +lat_0=40.9", $f68f332138d52ff8$var$Qv = " +k=1.000028", $f68f332138d52ff8$var$Qw = " +k=1.000025", $f68f332138d52ff8$var$Qx = " +x_0=170251.555", $f68f332138d52ff8$var$Qy = " +b=6356657.142669561", $f68f332138d52ff8$var$Qz = " +b=6356094.667915204", $f68f332138d52ff8$var$RA = " +b=6355862.933255573", $f68f332138d52ff8$var$RB = " +a=6378249.144808011", $f68f332138d52ff8$var$RC = " +b=6356514.966204134", $f68f332138d52ff8$var$RD = " +towgs84=-70.9,-151.8,-41.4,0,0,0,0", $f68f332138d52ff8$var$RE = " +towgs84=52.17,-71.82,-14.9,0,0,0,0", $f68f332138d52ff8$var$RF = " +towgs84=283.7,735.9,261.1,0,0,0,0", $f68f332138d52ff8$var$RG = " +zone=5", $f68f332138d52ff8$var$RH = " +zone=7", $f68f332138d52ff8$var$RI = " +lon_0=19", $f68f332138d52ff8$var$RJ = " +lon_0=25", $f68f332138d52ff8$var$RK = " +lat_2=45", $f68f332138d52ff8$var$RL = " +lon_0=57", $f68f332138d52ff8$var$RM = " +lon_0=69", $f68f332138d52ff8$var$RN = " +lat_2=39", $f68f332138d52ff8$var$RO = " +lat_2=35", $f68f332138d52ff8$var$RP = " +lon_0=28", $f68f332138d52ff8$var$RQ = " +lon_0=-61.5", $f68f332138d52ff8$var$RR = " +lon_0=-64.5", $f68f332138d52ff8$var$RS = " +lon_0=-90.5", $f68f332138d52ff8$var$RT = " +lon_0=-94.5", $f68f332138d52ff8$var$RU = " +y_0=2800000", $f68f332138d52ff8$var$RV = " +x_0=4321000", $f68f332138d52ff8$var$RW = " +y_0=3210000", $f68f332138d52ff8$var$RX = " +y_0=14743.5", $f68f332138d52ff8$var$RY = " +y_0=1999999.999992", $f68f332138d52ff8$var$RZ = " +y_0=2999999.999988", $f68f332138d52ff8$var$Ra = " +y_0=50000.00001504", $f68f332138d52ff8$var$Rb = " +zone=41", $f68f332138d52ff8$var$Rc = " +zone=42", $f68f332138d52ff8$var$Rd = " +k=0.994", $f68f332138d52ff8$var$Re = " +zone=56", $f68f332138d52ff8$var$Rf = " +lon_0=-67.875", $f68f332138d52ff8$var$Rg = " +lon_0=-70.375", $f68f332138d52ff8$var$Rh = " +x_0=609601.22", $f68f332138d52ff8$var$Ri = " +b=6356889.449", $f68f332138d52ff8$var$Rj = " +lon_0=-69.125", $f68f332138d52ff8$var$Rk = " +lon_0=-121.75", $f68f332138d52ff8$var$Rl = " +lon_0=-121.25", $f68f332138d52ff8$var$Rm = " +lon_0=-119.75", $f68f332138d52ff8$var$Rn = " +lon_0=-122.75", $f68f332138d52ff8$var$Ro = " +zone=6", $f68f332138d52ff8$var$Rp = "+proj=krovak", $f68f332138d52ff8$var$Rq = " +towgs84=-637,-549,-203,0,0,0,0", $f68f332138d52ff8$var$Rr = " +towgs84=-20.8,11.3,2.4,0,0,0,0", $f68f332138d52ff8$var$Rs = " +lon_0=-93", $f68f332138d52ff8$var$Rt = " +lon_0=127", $f68f332138d52ff8$var$Ru = " +lon_0=125", $f68f332138d52ff8$var$Rv = " +k=0.99975", $f68f332138d52ff8$var$Rw = " +lon_0=136", $f68f332138d52ff8$var$Rx = " +lon_0=138", $f68f332138d52ff8$var$Ry = " +lon_0=180", $f68f332138d52ff8$var$Rz = " +y_0=50000", $f68f332138d52ff8$var$SA = " +lon_0=-85", $f68f332138d52ff8$var$SB = " +k=1.00016", $f68f332138d52ff8$var$SC = " +lon_0=2.7", $f68f332138d52ff8$var$SD = " +towgs84=27.5,14,186.4,0,0,0,0", $f68f332138d52ff8$var$SE = " +towgs84=-499,-249,314,0,0,0,0", $f68f332138d52ff8$var$SF = " +towgs84=-467,-16,-300,0,0,0,0", $f68f332138d52ff8$var$SG = " +towgs84=-382,-59,-262,0,0,0,0", $f68f332138d52ff8$var$SH = " +towgs84=253,-132,-127,0,0,0,0", $f68f332138d52ff8$var$SI = " +towgs84=-963,510,-359,0,0,0,0", $f68f332138d52ff8$var$SJ = " +towgs84=94,-948,-1262,0,0,0,0", $f68f332138d52ff8$var$SK = " +zone=1", $f68f332138d52ff8$var$SL = " +zone=27", $f68f332138d52ff8$var$SM = " +zone=57", $f68f332138d52ff8$var$SN = " +pm=oslo", $f68f332138d52ff8$var$SO = " +zone=43", $f68f332138d52ff8$var$SP = " +lon_0=23", $f68f332138d52ff8$var$SQ = " +lon_0=48", $f68f332138d52ff8$var$SR = " +lon_0=54", $f68f332138d52ff8$var$SS = " +lat_0=49.5", $f68f332138d52ff8$var$ST = " +k=0.999912", $f68f332138d52ff8$var$SU = " +lon_0=-174", $f68f332138d52ff8$var$SV = " +lon_0=-168", $f68f332138d52ff8$var$SW = " +lon_0=-170", $f68f332138d52ff8$var$SX = " +lon_0=-165", $f68f332138d52ff8$var$SY = " +lat_2=40.5", $f68f332138d52ff8$var$SZ = " +lon_0=-115", $f68f332138d52ff8$var$Sa = " +lat_1=29.5", $f68f332138d52ff8$var$Sb = " +k=1.000045", $f68f332138d52ff8$var$Sc = " +lat_1=39.5", $f68f332138d52ff8$var$Sd = " +lat_1=33.3", $f68f332138d52ff8$var$Se = " +lat_0=33.3", $f68f332138d52ff8$var$Sf = " +lon_0=-155.5", $f68f332138d52ff8$var$Sg = " +lon_0=-159.5", $f68f332138d52ff8$var$Sh = " +y_0=-4480000", $f68f332138d52ff8$var$Si = " +lon_0=-176.5", $f68f332138d52ff8$var$Sj = " +lon_0=-89.75", $f68f332138d52ff8$var$Sk = " +k_0=1.000008", $f68f332138d52ff8$var$Sl = " +lonc=-124.05", $f68f332138d52ff8$var$Sm = " +k_0=1.000002", $f68f332138d52ff8$var$Sn = " +lon_0=-122.5", $f68f332138d52ff8$var$So = " +lon_0=-98.25", $f68f332138d52ff8$var$Sp = " +lon_0=-112.5", $f68f332138d52ff8$var$Sq = " +lon_0=-84.95", $f68f332138d52ff8$var$Sr = " +lon_0=-86.95", $f68f332138d52ff8$var$Ss = " +lon_0=-85.45", $f68f332138d52ff8$var$St = " +lon_0=-87.45", $f68f332138d52ff8$var$Su = " +lon_0=-87.55", $f68f332138d52ff8$var$Sv = " +towgs84=-149,128,296,0,0,0,0", $f68f332138d52ff8$var$Sw = " +towgs84=-425,-169,81,0,0,0,0", $f68f332138d52ff8$var$Sx = " +towgs84=-104,167,-38,0,0,0,0", $f68f332138d52ff8$var$Sy = " +towgs84=-106,-87,188,0,0,0,0", $f68f332138d52ff8$var$Sz = " +towgs84=-289,-124,60,0,0,0,0", $f68f332138d52ff8$var$TA = " +towgs84=137,248,-430,0,0,0,0", $f68f332138d52ff8$var$TB = " +towgs84=-13,-348,292,0,0,0,0", $f68f332138d52ff8$var$TC = " +towgs84=-115,118,426,0,0,0,0", $f68f332138d52ff8$var$TD = " +towgs84=0,-0.15,0.68,0,0,0,0", $f68f332138d52ff8$var$TE = " +towgs84=145,-187,103,0,0,0,0", $f68f332138d52ff8$var$TF = " +towgs84=-134,229,-29,0,0,0,0", $f68f332138d52ff8$var$TG = " +towgs84=70,207,389.5,0,0,0,0", $f68f332138d52ff8$var$TH = " +towgs84=-148,51,-291,0,0,0,0", $f68f332138d52ff8$var$TI = " +towgs84=-255,-15,71,0,0,0,0", $f68f332138d52ff8$var$TJ = " +towgs84=725,685,536,0,0,0,0", $f68f332138d52ff8$var$TK = " +towgs84=72,213.7,93,0,0,0,0", $f68f332138d52ff8$var$TL = " +towgs84=174,359,365,0,0,0,0", $f68f332138d52ff8$var$TM = " +towgs84=-173,253,27,0,0,0,0", $f68f332138d52ff8$var$TN = " +towgs84=-203,141,53,0,0,0,0", $f68f332138d52ff8$var$TO = " +towgs84=186,482,151,0,0,0,0", $f68f332138d52ff8$var$TP = " +towgs84=162,117,154,0,0,0,0", $f68f332138d52ff8$var$TQ = " +towgs84=-73,213,296,0,0,0,0", $f68f332138d52ff8$var$TR = " +towgs84=-130,29,364,0,0,0,0", $f68f332138d52ff8$var$TS = " +towgs84=-10,375,165,0,0,0,0", $f68f332138d52ff8$var$TT = " +towgs84=175,-38,113,0,0,0,0", $f68f332138d52ff8$var$TU = " +to_meter=0.9143984146160287", $f68f332138d52ff8$var$TV = " +zone=2", $f68f332138d52ff8$var$TW = " +zone=8", $f68f332138d52ff8$var$TX = " +zone=9", $f68f332138d52ff8$var$TY = " +zone=4", $f68f332138d52ff8$var$TZ = " +towgs84=30,430,368,0,0,0,0", $f68f332138d52ff8$var$Ta = " +towgs84=185,165,42,0,0,0,0", $f68f332138d52ff8$var$Tb = " +towgs84=-97,787,86,0,0,0,0", $f68f332138d52ff8$var$Tc = " +towgs84=639,405,60,0,0,0,0", $f68f332138d52ff8$var$Td = " +zone=44", $f68f332138d52ff8$var$Te = " +zone=45", $f68f332138d52ff8$var$Tf = " +lon_0=-58.5", $f68f332138d52ff8$var$Tg = " +lon_0=-67.5", $f68f332138d52ff8$var$Th = " +lon_0=-73.5", $f68f332138d52ff8$var$Ti = " +lon_0=-76.5", $f68f332138d52ff8$var$Tj = " +y_0=1200000", $f68f332138d52ff8$var$Tk = " +lon_0=133.5", $f68f332138d52ff8$var$Tl = " +x_0=8000000", $f68f332138d52ff8$var$Tm = " +y_0=8000000", $f68f332138d52ff8$var$Tn = " +k=0.9998335", $f68f332138d52ff8$var$To = " +lon_0=-85.5", $f68f332138d52ff8$var$Tp = " +x_0=7000000", $f68f332138d52ff8$var$Tq = " +lat_0=43.75", $f68f332138d52ff8$var$Tr = " +lat_0=43.25", $f68f332138d52ff8$var$Ts = " +lat_0=45.25", $f68f332138d52ff8$var$Tt = " +lon_0=-86.3", $f68f332138d52ff8$var$Tu = " +lat_0=38.15", $f68f332138d52ff8$var$Tv = " +lat_0=39.15", $f68f332138d52ff8$var$Tw = " +lat_0=41.25", $f68f332138d52ff8$var$Tx = " +lat_0=40.65", $f68f332138d52ff8$var$Ty = " +lat_0=39.25", $f68f332138d52ff8$var$Tz = " +lat_0=40.35", $f68f332138d52ff8$var$UA = " +lon_0=-85.8", $f68f332138d52ff8$var$UB = " +towgs84=9,183,236,0,0,0,0", $f68f332138d52ff8$var$UC = " +towgs84=-48,55,52,0,0,0,0", $f68f332138d52ff8$var$UD = " +towgs84=84,274,65,0,0,0,0", $f68f332138d52ff8$var$UE = " +lon_0=17", $f68f332138d52ff8$var$UF = " +lat_1=60", $f68f332138d52ff8$var$UG = " +k=0.9998", $f68f332138d52ff8$var$UH = " +lon_0=66", $f68f332138d52ff8$var$UI = " +lon_0=20", $f68f332138d52ff8$var$UJ = " +lon_0=26", $f68f332138d52ff8$var$UK = " +lat_0=51", $f68f332138d52ff8$var$UL = " +lat_1=87", $f68f332138d52ff8$var$UM = " +lat_1=26", $f68f332138d52ff8$var$UN = " +lon_0=144", $f68f332138d52ff8$var$UO = " +lon_0=168", $f68f332138d52ff8$var$UP = " +lon_0=174", $f68f332138d52ff8$var$UQ = " +lon_0=-72", $f68f332138d52ff8$var$UR = " +lon_0=-75", $f68f332138d52ff8$var$US = " +lon_0=-60", $f68f332138d52ff8$var$UT = " +lon_0=-39", $f68f332138d52ff8$var$UU = "+proj=poly", $f68f332138d52ff8$var$UV = " +x_0=219529.584", $f68f332138d52ff8$var$UW = " +a=6378306.3696", $f68f332138d52ff8$var$UX = " +lon_0=-61.33333333333334", $f68f332138d52ff8$var$UY = " +lon_0=-91.86666666666666", $f68f332138d52ff8$var$UZ = " +lon_0=-8.131906111111112", $f68f332138d52ff8$var$Ua = " +lon_0=-83.66666666666667", $f68f332138d52ff8$var$Ub = " +lon_0=-108.4166666666667", $f68f332138d52ff8$var$Uc = " +lon_0=-108.3333333333333", $f68f332138d52ff8$var$Ud = " +lon_0=-85.40000000000001", $f68f332138d52ff8$var$Ue = " +lon_0=-86.65000000000001", $f68f332138d52ff8$var$Uf = " +lon_0=-86.40000000000001", $f68f332138d52ff8$var$Ug = " +lon_0=-85.59999999999999", $f68f332138d52ff8$var$Uh = " +lon_0=-87.15000000000001", $f68f332138d52ff8$var$Ui = " +lon_0=-86.59999999999999", $f68f332138d52ff8$var$Uj = " +lon_0=-84.90000000000001", $f68f332138d52ff8$var$Uk = " +lon_0=-85.65000000000001", $f68f332138d52ff8$var$Ul = " +lon_0=-87.65000000000001", $f68f332138d52ff8$var$Um = " +lon_0=-85.34999999999999", $f68f332138d52ff8$var$Un = " +lon_0=-87.40000000000001", $f68f332138d52ff8$var$Uo = " +lon_0=-87.34999999999999", $f68f332138d52ff8$var$Up = " +lon_0=-85.90000000000001", $f68f332138d52ff8$var$Uq = " +lon_0=-90.62222222222222", $f68f332138d52ff8$var$Ur = " +lon_0=-91.84999999999999", $f68f332138d52ff8$var$Us = " +lon_0=-91.15277777777779", $f68f332138d52ff8$var$Ut = " +lon_0=-91.79722222222222", $f68f332138d52ff8$var$Uu = " +lon_0=-92.45777777777778", $f68f332138d52ff8$var$Uv = " +lon_0=-91.29444444444444", $f68f332138d52ff8$var$Uw = " +lon_0=-90.70833333333334", $f68f332138d52ff8$var$Ux = " +lon_0=-89.39444444444445", $f68f332138d52ff8$var$Uy = " +lon_0=-89.42222222222223", $f68f332138d52ff8$var$Uz = " +lon_0=-88.77500000000001", $f68f332138d52ff8$var$VA = " +lon_0=-87.27222222222223", $f68f332138d52ff8$var$VB = " +lon_0=-91.89444444444445", $f68f332138d52ff8$var$VC = " +lon_0=-91.28888888888889", $f68f332138d52ff8$var$VD = " +lon_0=-88.14166666666668", $f68f332138d52ff8$var$VE = " +lon_0=-88.63333333333334", $f68f332138d52ff8$var$VF = " +lon_0=-89.83888888888889", $f68f332138d52ff8$var$VG = " +lon_0=-90.16111111111111", $f68f332138d52ff8$var$VH = " +lon_0=-90.25555555555556", $f68f332138d52ff8$var$VI = " +lon_0=-90.84429651944444", $f68f332138d52ff8$var$VJ = " +lon_0=-87.89444444444445", $f68f332138d52ff8$var$VK = " +lon_0=-91.31666666666666", $f68f332138d52ff8$var$VL = " +lon_0=-89.03333333333333", $f68f332138d52ff8$var$VM = " +lon_0=-89.73333333333333", $f68f332138d52ff8$var$VN = " +lon_0=-87.71111111111111", $f68f332138d52ff8$var$VO = " +lon_0=-88.41666666666667", $f68f332138d52ff8$var$VP = " +lon_0=-90.64166666666668", $f68f332138d52ff8$var$VQ = " +lon_0=-87.90833333333335", $f68f332138d52ff8$var$VR = " +lon_0=-89.54444444444444", $f68f332138d52ff8$var$VS = " +lon_0=-92.22777777777777", $f68f332138d52ff8$var$VT = " +lon_0=-90.48888888888889", $f68f332138d52ff8$var$VU = " +lon_0=-90.43055555555556", $f68f332138d52ff8$var$VV = " +lon_0=-89.07222222222222", $f68f332138d52ff8$var$VW = " +lon_0=-91.06666666666666", $f68f332138d52ff8$var$VX = " +lon_0=-89.90000000000001", $f68f332138d52ff8$var$VY = " +lon_0=-91.11666666666666", $f68f332138d52ff8$var$VZ = " +lon_0=-88.60555555555555", $f68f332138d52ff8$var$Va = " +lon_0=-90.48333333333333", $f68f332138d52ff8$var$Vb = " +lon_0=-91.36666666666666", $f68f332138d52ff8$var$Vc = " +lon_0=-90.78333333333333", $f68f332138d52ff8$var$Vd = " +lon_0=-89.48888888888889", $f68f332138d52ff8$var$Ve = " +lon_0=-88.54166666666667", $f68f332138d52ff8$var$Vf = " +lon_0=-91.78333333333333", $f68f332138d52ff8$var$Vg = " +lon_0=-88.06388888888888", $f68f332138d52ff8$var$Vh = " +lon_0=-88.22499999999999", $f68f332138d52ff8$var$Vi = " +lon_0=-88.81666666666666", $f68f332138d52ff8$var$Vj = " +y_0=0.004876809753619507", $f68f332138d52ff8$var$Vk = " +y_0=0.008534417068834137", $f68f332138d52ff8$var$Vl = " +y_0=0.003962407924815849", $f68f332138d52ff8$var$Vm = " +y_0=0.005791211582423164", $f68f332138d52ff8$var$Vn = " +lon_0=-55.68333333333333", $f68f332138d52ff8$var$Vo = " +to_meter=0.201166195164", $f68f332138d52ff8$var$Vp = " +lat_0=4.666666666666667", $f68f332138d52ff8$var$Vq = " +lat_0=6.666666666666667", $f68f332138d52ff8$var$Vr = " +lon_0=6.166666666666667", $f68f332138d52ff8$var$Vs = " +lat_0=10.44166666666667", $f68f332138d52ff8$var$Vt = " +lat_0=22.31213333333334", $f68f332138d52ff8$var$Vu = " +lon_0=114.1785555555556", $f68f332138d52ff8$var$Vv = " +lon_0=51.21666666666667", $f68f332138d52ff8$var$Vw = " +lon_0=11.30827777777778", $f68f332138d52ff8$var$Vx = " +lon_0=13.55827777777778", $f68f332138d52ff8$var$Vy = " +lon_0=15.80827777777778", $f68f332138d52ff8$var$Vz = " +lon_0=18.05827777777778", $f68f332138d52ff8$var$WA = " +lon_0=20.30827777777778", $f68f332138d52ff8$var$WB = " +lon_0=22.55827777777778", $f68f332138d52ff8$var$WC = " +lat_1=27.41666666666667", $f68f332138d52ff8$var$WD = " +lat_2=34.91666666666666", $f68f332138d52ff8$var$WE = " +lat_0=31.16666666666667", $f68f332138d52ff8$var$WF = " +lat_1=59.33333333333334", $f68f332138d52ff8$var$WG = " +lat_0=57.51755393055556", $f68f332138d52ff8$var$WH = " +lon_0=4.359215833333333", $f68f332138d52ff8$var$WI = " +lat_1=61.66666666666666", $f68f332138d52ff8$var$WJ = " +lat_0=29.02626833333333", $f68f332138d52ff8$var$WK = " +lat_1=48.66666666666666", $f68f332138d52ff8$var$WL = " +lat_2=53.66666666666666", $f68f332138d52ff8$var$WM = " +lon_0=127.0028902777778", $f68f332138d52ff8$var$WN = " +lon_0=89.84999999999999", $f68f332138d52ff8$var$WO = " +lon_0=91.56666666666666", $f68f332138d52ff8$var$WP = " +lon_0=24.83333333333333", $f68f332138d52ff8$var$WQ = " +lat_2=63.66666666666666", $f68f332138d52ff8$var$WR = " +lat_0=65.35103930555555", $f68f332138d52ff8$var$WS = " +lat_1=63.66666666666666", $f68f332138d52ff8$var$WT = " +lat_2=60.33333333333334", $f68f332138d52ff8$var$WU = " +lat_0=62.01530688888889", $f68f332138d52ff8$var$WV = " +lat_1=45.78333333333333", $f68f332138d52ff8$var$WW = " +lat_0=45.78333333333333", $f68f332138d52ff8$var$WX = " +lat_0=42.66666666666666", $f68f332138d52ff8$var$WY = " +lat_0=43.36666666666667", $f68f332138d52ff8$var$WZ = " +lat_0=45.70611111111111", $f68f332138d52ff8$var$Wa = " +lat_0=45.13333333333333", $f68f332138d52ff8$var$Wb = " +lat_1=46.66964837722222", $f68f332138d52ff8$var$Wc = " +lat_0=46.66964837722222", $f68f332138d52ff8$var$Wd = " +lat_0=43.48138888888889", $f68f332138d52ff8$var$We = " +lat_1=45.89871486583333", $f68f332138d52ff8$var$Wf = " +lat_0=45.89871486583333", $f68f332138d52ff8$var$Wg = " +lat_0=42.71944444444445", $f68f332138d52ff8$var$Wh = " +lat_1=44.97785689861112", $f68f332138d52ff8$var$Wi = " +lat_0=44.97785689861112", $f68f332138d52ff8$var$Wj = " +lat_1=43.46254664583333", $f68f332138d52ff8$var$Wk = " +lat_0=43.46254664583333", $f68f332138d52ff8$var$Wl = " +lon_0=-90.9388888888889", $f68f332138d52ff8$var$Wm = " +lat_0=41.47222222222222", $f68f332138d52ff8$var$Wn = " +lat_0=45.88333333333333", $f68f332138d52ff8$var$Wo = " +lat_0=44.40833333333333", $f68f332138d52ff8$var$Wp = " +lat_1=44.87228112638889", $f68f332138d52ff8$var$Wq = " +lat_0=44.87228112638889", $f68f332138d52ff8$var$Wr = " +lat_0=45.43888888888888", $f68f332138d52ff8$var$Ws = " +lat_0=44.00555555555555", $f68f332138d52ff8$var$Wt = " +lat_0=41.41111111111111", $f68f332138d52ff8$var$Wu = " +lat_1=42.63756227694444", $f68f332138d52ff8$var$Wv = " +lat_0=42.63756227694444", $f68f332138d52ff8$var$Ww = " +lat_1=43.80700011777778", $f68f332138d52ff8$var$Wx = " +lat_0=43.80700011777778", $f68f332138d52ff8$var$Wy = " +lat_0=42.53888888888888", $f68f332138d52ff8$var$Wz = " +lat_0=45.43333333333333", $f68f332138d52ff8$var$XA = " +lat_0=44.25333512777778", $f68f332138d52ff8$var$XB = " +lat_0=42.21666666666667", $f68f332138d52ff8$var$XC = " +lat_0=43.26666666666667", $f68f332138d52ff8$var$XD = " +lat_0=43.45111111111111", $f68f332138d52ff8$var$XE = " +lat_1=45.15423710527778", $f68f332138d52ff8$var$XF = " +lat_0=45.15423710527778", $f68f332138d52ff8$var$XG = " +lat_0=44.84444444444445", $f68f332138d52ff8$var$XH = " +lat_1=44.90090442361111", $f68f332138d52ff8$var$XI = " +lat_0=44.90090442361111", $f68f332138d52ff8$var$XJ = " +lat_0=44.69166666666666", $f68f332138d52ff8$var$XK = " +lat_0=44.71666666666667", $f68f332138d52ff8$var$XL = " +lat_1=44.00007392861111", $f68f332138d52ff8$var$XM = " +lat_0=44.00007392861111", $f68f332138d52ff8$var$XN = " +lat_0=44.39722222222222", $f68f332138d52ff8$var$XO = " +lat_1=45.70422377027778", $f68f332138d52ff8$var$XP = " +lat_0=45.70422377027778", $f68f332138d52ff8$var$XQ = " +lat_1=44.63614887194444", $f68f332138d52ff8$var$XR = " +lat_0=44.63614887194444", $f68f332138d52ff8$var$XS = " +lat_0=44.66111111111111", $f68f332138d52ff8$var$XT = " +lat_1=44.41682397527777", $f68f332138d52ff8$var$XU = " +lat_0=44.41682397527777", $f68f332138d52ff8$var$XV = " +lat_0=44.55555555555555", $f68f332138d52ff8$var$XW = " +lat_0=41.94444444444444", $f68f332138d52ff8$var$XX = " +lat_0=43.91944444444444", $f68f332138d52ff8$var$XY = " +lat_0=42.81944444444445", $f68f332138d52ff8$var$XZ = " +lat_1=45.90009913138888", $f68f332138d52ff8$var$Xa = " +lat_0=45.90009913138888", $f68f332138d52ff8$var$Xb = " +lat_1=45.17782208583333", $f68f332138d52ff8$var$Xc = " +lat_0=45.17782208583333", $f68f332138d52ff8$var$Xd = " +lat_0=43.16111111111111", $f68f332138d52ff8$var$Xe = " +lat_1=43.57503293972223", $f68f332138d52ff8$var$Xf = " +lat_0=43.57503293972223", $f68f332138d52ff8$var$Xg = " +lat_1=46.07784409055556", $f68f332138d52ff8$var$Xh = " +lat_0=46.07784409055556", $f68f332138d52ff8$var$Xi = " +lat_1=42.66946209694444", $f68f332138d52ff8$var$Xj = " +lat_0=42.66946209694444", $f68f332138d52ff8$var$Xk = " +lat_1=45.96121983333334", $f68f332138d52ff8$var$Xl = " +lat_0=45.96121983333334", $f68f332138d52ff8$var$Xm = " +lat_0=42.91805555555555", $f68f332138d52ff8$var$Xn = " +lat_0=42.56944444444445", $f68f332138d52ff8$var$Xo = " +lat_0=43.42027777777778", $f68f332138d52ff8$var$Xp = " +lat_1=44.11394404583334", $f68f332138d52ff8$var$Xq = " +lat_0=44.11394404583334", $f68f332138d52ff8$var$Xr = " +lat_1=44.36259546944444", $f68f332138d52ff8$var$Xs = " +lat_0=44.36259546944444", $f68f332138d52ff8$var$Xt = " +lat_1=44.10000000000001", $f68f332138d52ff8$var$Xu = " +lat_0=44.10000000000001", $f68f332138d52ff8$var$Xv = " +lat_1=42.16500000000001", $f68f332138d52ff8$var$Xw = " +lat_0=42.16500000000001", $f68f332138d52ff8$var$Xx = " +lat_0=52.15616055555555", $f68f332138d52ff8$var$Xy = " +lat_2=48.73333333333333", $f68f332138d52ff8$var$Xz = " +zone=3", $f68f332138d52ff8$var$YA = " +lat_0=53.5", $f68f332138d52ff8$var$YB = " +k=0.999923", $f68f332138d52ff8$var$YC = " +x_0=850000", $f68f332138d52ff8$var$YD = " +x_0=830000", $f68f332138d52ff8$var$YE = " +lon_0=16.5", $f68f332138d52ff8$var$YF = " +x_0=520000", $f68f332138d52ff8$var$YG = " +lat_2=31.5", $f68f332138d52ff8$var$YH = " +lon_0=10.5", $f68f332138d52ff8$var$YI = " +lat_1=44.5", $f68f332138d52ff8$var$YJ = " +lon_0=-153", $f68f332138d52ff8$var$YK = " +lon_0=-135", $f68f332138d52ff8$var$YL = " +x_0=750000", $f68f332138d52ff8$var$YM = " +lat_0=43.5", $f68f332138d52ff8$var$YN = " +lon_0=-142", $f68f332138d52ff8$var$YO = " +lon_0=-146", $f68f332138d52ff8$var$YP = " +lon_0=-162", $f68f332138d52ff8$var$YQ = " +lon_0=-166", $f68f332138d52ff8$var$YR = " +lon_0=-176", $f68f332138d52ff8$var$YS = " +lat_2=39.5", $f68f332138d52ff8$var$YT = " +lon_0=-129", $f68f332138d52ff8$var$YU = " +k_0=1.0002", $f68f332138d52ff8$var$YV = " +k=1.000023", $f68f332138d52ff8$var$YW = " +lon_0=-121", $f68f332138d52ff8$var$YX = " +k=1.000175", $f68f332138d52ff8$var$YY = " +lat_0=45.5", $f68f332138d52ff8$var$YZ = " +k=1.000155", $f68f332138d52ff8$var$Ya = " +lat_2=37.5", $f68f332138d52ff8$var$Yb = " +lat_1=48.5", $f68f332138d52ff8$var$Yc = " +k=1.000029", $f68f332138d52ff8$var$Yd = " +lat_0=39.6", $f68f332138d52ff8$var$Ye = " +k=1.000013", $f68f332138d52ff8$var$Yf = " +k=1.000022", $f68f332138d52ff8$var$Yg = " +lat_0=40.7", $f68f332138d52ff8$var$Yh = " +lat_0=39.3", $f68f332138d52ff8$var$Yi = " +lat_0=37.8", $f68f332138d52ff8$var$Yj = " +lat_0=38.9", $f68f332138d52ff8$var$Yk = " +lon_0=-5.4", $f68f332138d52ff8$var$Yl = " +y_0=626907.39", $f68f332138d52ff8$var$Ym = " +b=6356571.996", $f68f332138d52ff8$var$Yn = " +a=6377295.664", $f68f332138d52ff8$var$Yo = " +lon_0=5.38763888888889", $f68f332138d52ff8$var$Yp = " +y_0=-4600000.00001208", $f68f332138d52ff8$var$Yq = " +y_0=1889763.779527559", $f68f332138d52ff8$var$Yr = " +y_0=99999.99999960001", $f68f332138d52ff8$var$Ys = " +x_0=120091.4401828804", $f68f332138d52ff8$var$Yt = " +lon_0=72", $f68f332138d52ff8$var$Yu = " +lat_0=50", $f68f332138d52ff8$var$Yv = " +lat_1=50", $f68f332138d52ff8$var$Yw = " +lat_1=35", $f68f332138d52ff8$var$Yx = " +lon_0=22", $f68f332138d52ff8$var$Yy = " +lat_1=34", $f68f332138d52ff8$var$Yz = " +lonc=115", $f68f332138d52ff8$var$ZA = " +lat_0=-9", $f68f332138d52ff8$var$ZB = " +lat_0=23", $f68f332138d52ff8$var$ZC = " +lat_1=85", $f68f332138d52ff8$var$ZD = " +lat_2=69", $f68f332138d52ff8$var$ZE = " +lat_1=69", $f68f332138d52ff8$var$ZF = " +lat_2=61", $f68f332138d52ff8$var$ZG = " +lon_0=34", $f68f332138d52ff8$var$ZH = " +lon_0=140.25", $f68f332138d52ff8$var$ZI = " +lon_0=142.25", $f68f332138d52ff8$var$ZJ = " +lon_0=144.25", $f68f332138d52ff8$var$ZK = " +x_0=47500000", $f68f332138d52ff8$var$ZL = " +y_0=-3000000", $f68f332138d52ff8$var$ZM = " +pm=2.337208333333333", $f68f332138d52ff8$var$ZN = " +x_0=7000000.00000248", $f68f332138d52ff8$var$ZO = " +lon_0=6", $f68f332138d52ff8$var$ZP = " +k=0.997", $f68f332138d52ff8$var$ZQ = " +lon_0=106", $f68f332138d52ff8$var$ZR = " +lon_0=154", $f68f332138d52ff8$var$ZS = " +lon_0=156", $f68f332138d52ff8$var$ZT = " +lat_2=-36", $f68f332138d52ff8$var$ZU = " +lon_0=119", $f68f332138d52ff8$var$ZV = " +lon_0=121", $f68f332138d52ff8$var$ZW = " +lon_0=166", $f68f332138d52ff8$var$ZX = " +a=6371228", $f68f332138d52ff8$var$ZY = " +b=6371228", $f68f332138d52ff8$var$ZZ = " +a=6378273", $f68f332138d52ff8$var$Za = " +lat_0=-44", $f68f332138d52ff8$var$Zb = " +pm=lisbon", $f68f332138d52ff8$var$Zc = " +lon_0=-57", $f68f332138d52ff8$var$Zd = " +lon_0=-56", $f68f332138d52ff8$var$Ze = " +k=1.00007", $f68f332138d52ff8$var$Zf = " +lonc=-123", $f68f332138d52ff8$var$Zg = " +alpha=295", $f68f332138d52ff8$var$Zh = " +gamma=295", $f68f332138d52ff8$var$Zi = " +k=1.00011", $f68f332138d52ff8$var$Zj = " +k=1.00005", $f68f332138d52ff8$var$Zk = " +k=1.00013", $f68f332138d52ff8$var$Zl = " +x_0=30000", $f68f332138d52ff8$var$Zm = " +k=1.00001", $f68f332138d52ff8$var$Zn = " +k=1.00003", $f68f332138d52ff8$var$Zo = " +y_0=130000.00001472", $f68f332138d52ff8$var$Zp = " +x_0=119999.99999952", $f68f332138d52ff8$var$Zq = " +y_0=-2999999.999988", $f68f332138d52ff8$var$Zr = " +x_0=-299999.9999988", $f68f332138d52ff8$var$Zs = " +lat_1=43.0695160375", $f68f332138d52ff8$var$Zt = " +lat_0=43.0695160375", $f68f332138d52ff8$var$Zu = " +lat_1=43.3223129275", $f68f332138d52ff8$var$Zv = " +lat_0=43.3223129275", $f68f332138d52ff8$var$Zw = " +k=1.0000067", $f68f332138d52ff8$var$Zx = " +a=6378298.3", $f68f332138d52ff8$var$Zy = " +lon_0=-66.5", $f68f332138d52ff8$var$Zz = " +lon_0=129.5", $f68f332138d52ff8$var$aA = " +lon_0=138.5", $f68f332138d52ff8$var$aB = " +x_0=2300000", $f68f332138d52ff8$var$aC = " +x_0=3300000", $f68f332138d52ff8$var$aD = " +x_0=4300000", $f68f332138d52ff8$var$aE = " +y_0=7500000", $f68f332138d52ff8$var$aF = " +lonc=102.25", $f68f332138d52ff8$var$aG = " +y_0=1166200", $f68f332138d52ff8$var$aH = " +x_0=3000000", $f68f332138d52ff8$var$aI = " +lat_1=46.25", $f68f332138d52ff8$var$aJ = " +ellps=WGS66", $f68f332138d52ff8$var$aK = " +ellps=GRS67", $f68f332138d52ff8$var$aL = " +lat_1=34.65", $f68f332138d52ff8$var$aM = " +y_0=59999.99999976", $f68f332138d52ff8$var$aN = " +y_0=30000.00001512", $f68f332138d52ff8$var$aO = " +x_0=59999.99999976", $f68f332138d52ff8$var$aP = " +x_0=30000.00001512", $f68f332138d52ff8$var$aQ = " +lat_1=43.200055605", $f68f332138d52ff8$var$aR = " +lat_0=43.200055605", $f68f332138d52ff8$var$aS = " +y_0=65379.0134283", $f68f332138d52ff8$var$aT = " +alpha=323.0257905", $f68f332138d52ff8$var$aU = " +alpha=53.31580995", $f68f332138d52ff8$var$aV = " +x_0=10000.0000152";
$f68f332138d52ff8$exports = [
    2000,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$NU + $f68f332138d52ff8$var$EP + $f68f332138d52ff8$var$u + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$c + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$NU + $f68f332138d52ff8$var$EP + $f68f332138d52ff8$var$u + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$c + $f68f332138d52ff8$var$TI + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$NU + $f68f332138d52ff8$var$EP + $f68f332138d52ff8$var$u + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$c + $f68f332138d52ff8$var$TJ + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$NU + $f68f332138d52ff8$var$EP + $f68f332138d52ff8$var$u + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$c + $f68f332138d52ff8$var$TK + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$NU + $f68f332138d52ff8$var$EP + $f68f332138d52ff8$var$u + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$c + $f68f332138d52ff8$var$TL + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$NU + $f68f332138d52ff8$var$EP + $f68f332138d52ff8$var$u + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$c + $f68f332138d52ff8$var$UB + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$NU + $f68f332138d52ff8$var$EP + $f68f332138d52ff8$var$u + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$c + $f68f332138d52ff8$var$Sv + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$NU + $f68f332138d52ff8$var$EP + $f68f332138d52ff8$var$u + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$c + $f68f332138d52ff8$var$Ps + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    2,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Tf + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$Ab + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$i + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$RQ + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$Ab + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$i + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$RR + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$Ab + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$i + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Tg + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$Ab + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$i + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$IL + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$Ab + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$i + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Th + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$Ab + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$i + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Ti + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$Ab + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$i + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Ga + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$Ab + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$i + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Th + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$Ab + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$i + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Ti + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$Ab + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$i + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Ga + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$Ab + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$i + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$ET + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$Ab + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$i + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$CR + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$Ab + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$i + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$NV + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$Ab + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$i + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Jh + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$Ab + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$i + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Bu + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$Ab + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$i + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Rs + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$Ab + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$i + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$OZ + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$Ab + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$i + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$NP + $f68f332138d52ff8$var$i + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$NQ + $f68f332138d52ff8$var$i + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ik + $f68f332138d52ff8$var$i + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$IC + $f68f332138d52ff8$var$i + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ik + $f68f332138d52ff8$var$i + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$IC + $f68f332138d52ff8$var$i + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Hi + $f68f332138d52ff8$var$i + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Gz + $f68f332138d52ff8$var$i + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$ID + $f68f332138d52ff8$var$i + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    4,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Ou + $f68f332138d52ff8$var$Ov + $f68f332138d52ff8$var$Zw + $f68f332138d52ff8$var$UV + $f68f332138d52ff8$var$Yl + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$UC + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Oq + $f68f332138d52ff8$var$c + $f68f332138d52ff8$var$JO + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Oq + $f68f332138d52ff8$var$c + $f68f332138d52ff8$var$IE + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$KA + $f68f332138d52ff8$var$c + $f68f332138d52ff8$var$JO + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$KA + $f68f332138d52ff8$var$c + $f68f332138d52ff8$var$IE + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$EN + " +k=1" + $f68f332138d52ff8$var$Hs + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$HG + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Fy + " +k=1" + $f68f332138d52ff8$var$Ht + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$HG + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Gj + " +k=1" + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$Gk + $f68f332138d52ff8$var$j + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$UE + " +k=1" + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$Gk + $f68f332138d52ff8$var$j + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$RI + " +k=1" + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$Gk + $f68f332138d52ff8$var$j + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Gl + " +k=1" + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$Gk + $f68f332138d52ff8$var$j + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$SP + " +k=1" + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$Gk + $f68f332138d52ff8$var$j + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$RJ + " +k=1" + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$Gk + $f68f332138d52ff8$var$j + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$HO + " +k=1" + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$Gk + $f68f332138d52ff8$var$j + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + " +lon_0=29 +k=1" + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$Gk + $f68f332138d52ff8$var$j + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$QQ + " +k=1" + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$Gk + $f68f332138d52ff8$var$j + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$IG + " +k=1" + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$Gk + $f68f332138d52ff8$var$j + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$Pu + $f68f332138d52ff8$var$Kj + $f68f332138d52ff8$var$Ow + " +k_0=1 +x_0=2600000" + $f68f332138d52ff8$var$Tj + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$Py + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$CU + " +lat_0=27.51882880555555 +lonc=52.60353916666667 +alpha=0.5716611944444444 +k=0.999895934 +x_0=658377.437 +y_0=3044969.194 +gamma=0.5716611944444444" + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$Pz + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$JZ + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$Gy + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$JM + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$Gy + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Me + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$Gy + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Rb + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$Gy + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + " +lat_1=40" + $f68f332138d52ff8$var$Fs + $f68f332138d52ff8$var$HN + " +k_0=0.9988085293" + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$Qn + $f68f332138d52ff8$var$Zx + $f68f332138d52ff8$var$Qy + " +pm=madrid" + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    3,
    $f68f332138d52ff8$var$Rp + $f68f332138d52ff8$var$SS + " +lon_0=42.5" + $f68f332138d52ff8$var$Kk + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$Gh + $f68f332138d52ff8$var$Ls + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$Ck + " +lat_0=11.25217861111111 +lon_0=-60.68600888888889 +x_0=37718.66159325 +y_0=36209.91512952" + $f68f332138d52ff8$var$Ee + $f68f332138d52ff8$var$Ef + $f68f332138d52ff8$var$Vo + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Gz + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$QA + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$KB + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$h + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$v + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + " +lon_0=11" + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$h + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$v + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + " +lon_0=13" + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$h + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$v + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Gj + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$h + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$v + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$UE + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$h + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$v + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$RI + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$h + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$v + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Gl + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$h + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$v + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$SP + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$h + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$v + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$RJ + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$h + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$v + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$JN + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$v + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$KC + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$v + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$NR + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$v + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ki + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$v + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$m + $f68f332138d52ff8$var$MP + " +k=1" + $f68f332138d52ff8$var$Ci + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$m + $f68f332138d52ff8$var$MP + " +k=1" + $f68f332138d52ff8$var$Ci + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$SD + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$m + $f68f332138d52ff8$var$MP + " +k=1" + $f68f332138d52ff8$var$Ci + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$OV + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Hi + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$OV + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    3,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$IH + $f68f332138d52ff8$var$AP + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$v + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + " +lon_0=11" + $f68f332138d52ff8$var$AP + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$AU + $f68f332138d52ff8$var$BN + $f68f332138d52ff8$var$Gi + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$JZ + $f68f332138d52ff8$var$j + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$JM + $f68f332138d52ff8$var$j + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    3,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$ZQ + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$HG + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$ZQ + $f68f332138d52ff8$var$AP + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$Q + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ja + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$TM + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Ch + $f68f332138d52ff8$var$Ed + " +k=1" + $f68f332138d52ff8$var$h + $f68f332138d52ff8$var$Ae + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Ch + $f68f332138d52ff8$var$Rt + " +k=1" + $f68f332138d52ff8$var$h + $f68f332138d52ff8$var$Ae + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Ch + $f68f332138d52ff8$var$Ru + " +k=1" + $f68f332138d52ff8$var$h + $f68f332138d52ff8$var$Ae + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$Ck + " +lat_0=25.38236111111111 +lon_0=50.76138888888889" + $f68f332138d52ff8$var$BU + $f68f332138d52ff8$var$EK + $f68f332138d52ff8$var$Gn + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$II + $f68f332138d52ff8$var$AP + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$Qb + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Kl + $f68f332138d52ff8$var$Km + $f68f332138d52ff8$var$KN + " +k_0=1" + $f68f332138d52ff8$var$s + " +y_0=-52684.972" + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Kl + $f68f332138d52ff8$var$Km + $f68f332138d52ff8$var$KN + " +k_0=1" + $f68f332138d52ff8$var$h + " +y_0=147315.028" + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Kl + $f68f332138d52ff8$var$Km + $f68f332138d52ff8$var$KN + " +k_0=1" + $f68f332138d52ff8$var$O + " +y_0=447315.028" + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Kl + $f68f332138d52ff8$var$Km + $f68f332138d52ff8$var$KN + " +k_0=1 +x_0=-17044 +y_0=-23139.97" + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=-36.87972222222222 +lon_0=174.7641666666667" + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$u + $f68f332138d52ff8$var$CO + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=-37.76111111111111 +lon_0=176.4661111111111 +k=1" + $f68f332138d52ff8$var$u + $f68f332138d52ff8$var$CO + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=-38.62444444444444 +lon_0=177.8855555555556 +k=1" + $f68f332138d52ff8$var$u + $f68f332138d52ff8$var$CO + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=-39.65083333333333 +lon_0=176.6736111111111 +k=1" + $f68f332138d52ff8$var$u + $f68f332138d52ff8$var$CO + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=-39.13555555555556 +lon_0=174.2277777777778 +k=1" + $f68f332138d52ff8$var$u + $f68f332138d52ff8$var$CO + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=-39.51222222222222 +lon_0=175.64 +k=1" + $f68f332138d52ff8$var$u + $f68f332138d52ff8$var$CO + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=-40.24194444444444 +lon_0=175.4880555555555 +k=1" + $f68f332138d52ff8$var$u + $f68f332138d52ff8$var$CO + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=-40.92527777777777 +lon_0=175.6472222222222 +k=1" + $f68f332138d52ff8$var$u + $f68f332138d52ff8$var$CO + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=-41.3011111111111 +lon_0=174.7763888888889 +k=1" + $f68f332138d52ff8$var$u + $f68f332138d52ff8$var$CO + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=-40.71472222222223 +lon_0=172.6719444444444 +k=1" + $f68f332138d52ff8$var$u + $f68f332138d52ff8$var$CO + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=-41.27444444444444 +lon_0=173.2991666666667 +k=1" + $f68f332138d52ff8$var$u + $f68f332138d52ff8$var$CO + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=-41.28972222222222 +lon_0=172.1088888888889 +k=1" + $f68f332138d52ff8$var$u + $f68f332138d52ff8$var$CO + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=-41.81055555555555 +lon_0=171.5811111111111 +k=1" + $f68f332138d52ff8$var$u + $f68f332138d52ff8$var$CO + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=-42.33361111111111 +lon_0=171.5497222222222 +k=1" + $f68f332138d52ff8$var$u + $f68f332138d52ff8$var$CO + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=-42.68888888888888 +lon_0=173.01 +k=1" + $f68f332138d52ff8$var$u + $f68f332138d52ff8$var$CO + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=-41.54444444444444 +lon_0=173.8019444444444 +k=1" + $f68f332138d52ff8$var$u + $f68f332138d52ff8$var$CO + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=-42.88611111111111 +lon_0=170.9797222222222 +k=1" + $f68f332138d52ff8$var$u + $f68f332138d52ff8$var$CO + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=-43.11 +lon_0=170.2608333333333 +k=1" + $f68f332138d52ff8$var$u + $f68f332138d52ff8$var$CO + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=-43.97777777777778 +lon_0=168.6061111111111 +k=1" + $f68f332138d52ff8$var$u + $f68f332138d52ff8$var$CO + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=-43.59055555555556 +lon_0=172.7269444444445 +k=1" + $f68f332138d52ff8$var$u + $f68f332138d52ff8$var$CO + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=-43.74861111111111 +lon_0=171.3605555555555 +k=1" + $f68f332138d52ff8$var$u + $f68f332138d52ff8$var$CO + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=-44.40194444444445 +lon_0=171.0572222222222 +k=1" + $f68f332138d52ff8$var$u + $f68f332138d52ff8$var$CO + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=-44.735 +lon_0=169.4675 +k=1" + $f68f332138d52ff8$var$u + $f68f332138d52ff8$var$CO + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=-45.13277777777778 +lon_0=168.3986111111111 +k=1" + $f68f332138d52ff8$var$u + $f68f332138d52ff8$var$CO + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=-45.56361111111111 +lon_0=167.7386111111111 +k=1" + $f68f332138d52ff8$var$u + $f68f332138d52ff8$var$CO + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=-45.81611111111111 +lon_0=170.6283333333333 +k=1" + $f68f332138d52ff8$var$u + $f68f332138d52ff8$var$CO + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=-45.86138888888889 +lon_0=170.2825" + $f68f332138d52ff8$var$Pc + $f68f332138d52ff8$var$u + $f68f332138d52ff8$var$CO + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=-46.6 +lon_0=168.3427777777778 +k=1" + $f68f332138d52ff8$var$u + $f68f332138d52ff8$var$CO + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$MA + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Nq + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$PL + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Vp + " +lon_0=-1" + $f68f332138d52ff8$var$Rv + " +x_0=274319.7391633579" + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$Qj + $f68f332138d52ff8$var$Ho + $f68f332138d52ff8$var$NI + $f68f332138d52ff8$var$NJ + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + " +lon_0=-1" + $f68f332138d52ff8$var$AP + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$Qj + $f68f332138d52ff8$var$Ho + $f68f332138d52ff8$var$NI + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$UF + $f68f332138d52ff8$var$Nh + $f68f332138d52ff8$var$IZ + $f68f332138d52ff8$var$HJ + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$i + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    16,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$LM + " +lat_2=44" + $f68f332138d52ff8$var$Iq + $f68f332138d52ff8$var$Or + $f68f332138d52ff8$var$EW + " +y_0=6600000" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    3,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$YA + " +lon_0=-8 +k=0.99982" + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$Mk + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$KA + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Vq + " +lon_0=-12 +k=1 +x_0=152399.8550907544" + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$Qj + $f68f332138d52ff8$var$Ho + $f68f332138d52ff8$var$NJ + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Vq + " +lon_0=-12 +k=1 +x_0=243839.7681452071 +y_0=182879.8261089053" + $f68f332138d52ff8$var$Qj + $f68f332138d52ff8$var$Ho + $f68f332138d52ff8$var$NJ + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ja + $f68f332138d52ff8$var$c + $f68f332138d52ff8$var$OW + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$KA + $f68f332138d52ff8$var$c + $f68f332138d52ff8$var$OW + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$He + $f68f332138d52ff8$var$IP + $f68f332138d52ff8$var$CS + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + " +a=6370997 +b=6370997" + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + " +lon_0=-5" + $f68f332138d52ff8$var$AP + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$c + $f68f332138d52ff8$var$JO + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + " +lon_0=-5" + $f68f332138d52ff8$var$AP + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$c + $f68f332138d52ff8$var$IE + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    4,
    $f68f332138d52ff8$var$D + " +lat_0=49.83333333333334" + $f68f332138d52ff8$var$Vr + " +k=1" + $f68f332138d52ff8$var$Oa + $f68f332138d52ff8$var$EK + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$Jx + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    3,
    $f68f332138d52ff8$var$GU + " +lat_0=53.00194444444445 +lon_0=21.50277777777778" + $f68f332138d52ff8$var$UG + " +x_0=4603000 +y_0=5806000" + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$b + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$GU + " +lat_0=53.58333333333334 +lon_0=17.00833333333333" + $f68f332138d52ff8$var$UG + " +x_0=3501000 +y_0=5999000" + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$b + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$GU + " +lat_0=51.67083333333333 +lon_0=16.67222222222222" + $f68f332138d52ff8$var$UG + " +x_0=3703000 +y_0=5627000" + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$b + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + " +lon_0=18.95833333333333 +k=0.999983 +x_0=237000 +y_0=-4700000" + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$b + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Gj + $f68f332138d52ff8$var$YB + $f68f332138d52ff8$var$Eg + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$QR + $f68f332138d52ff8$var$YB + $f68f332138d52ff8$var$Jt + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Gl + $f68f332138d52ff8$var$YB + $f68f332138d52ff8$var$IM + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$II + $f68f332138d52ff8$var$YB + $f68f332138d52ff8$var$MS + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$RI + " +k=0.9993" + $f68f332138d52ff8$var$O + " +y_0=-5300000" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    8,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Nr + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$Sw + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Os + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$Sx + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Os + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$TN + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    3,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + " +lon_0=173" + $f68f332138d52ff8$var$AP + " +x_0=1600000" + $f68f332138d52ff8$var$Ak + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    2,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$TV + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + " +lon_0=9.5" + $f68f332138d52ff8$var$CP + $f68f332138d52ff8$var$h + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$IH + $f68f332138d52ff8$var$CP + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Gj + " +k=1" + $f68f332138d52ff8$var$HT + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    2,
    $f68f332138d52ff8$var$GU + $f68f332138d52ff8$var$Iq + $f68f332138d52ff8$var$Zy + $f68f332138d52ff8$var$ST + $f68f332138d52ff8$var$AI + $f68f332138d52ff8$var$CO + $f68f332138d52ff8$var$Pd + $f68f332138d52ff8$var$Gq + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$IC + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Hi + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Gz + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + " +lat_1=35.25 +lat_2=36.41666666666666 +lat_0=34.66666666666666" + $f68f332138d52ff8$var$MQ + $f68f332138d52ff8$var$Z + $f68f332138d52ff8$var$Pv + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Az + $f68f332138d52ff8$var$DV + $f68f332138d52ff8$var$DM + $f68f332138d52ff8$var$Jo + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$HO + " +k=1" + $f68f332138d52ff8$var$MT + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$n + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Ia + " +k=1" + $f68f332138d52ff8$var$LY + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$n + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$IG + " +k=1" + $f68f332138d52ff8$var$Jp + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$n + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$PN + " +k=1" + $f68f332138d52ff8$var$LZ + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$n + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$LN + " +k=1" + $f68f332138d52ff8$var$HU + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$n + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$PO + " +k=1" + $f68f332138d52ff8$var$Gw + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$n + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$JS + " +k=1" + $f68f332138d52ff8$var$Hu + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$n + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Ia + $f68f332138d52ff8$var$AP + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    2,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$JN + $f68f332138d52ff8$var$AU + $f68f332138d52ff8$var$BN + $f68f332138d52ff8$var$RD + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Io + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$NG + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$MB + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$NG + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    2,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Hi + $f68f332138d52ff8$var$Pd + $f68f332138d52ff8$var$Gq + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Gz + $f68f332138d52ff8$var$Pd + $f68f332138d52ff8$var$Gq + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    2,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Bl + $f68f332138d52ff8$var$Cn + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$EX + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$t + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Bl + $f68f332138d52ff8$var$Co + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$EX + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$t + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Bl + $f68f332138d52ff8$var$Iv + $f68f332138d52ff8$var$BG + $f68f332138d52ff8$var$EX + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$t + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$DW + $f68f332138d52ff8$var$Jn + $f68f332138d52ff8$var$y + $f68f332138d52ff8$var$HA + $f68f332138d52ff8$var$Ac + $f68f332138d52ff8$var$AD + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$DX + $f68f332138d52ff8$var$DY + $f68f332138d52ff8$var$AA + $f68f332138d52ff8$var$HA + $f68f332138d52ff8$var$Ac + $f68f332138d52ff8$var$AD + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Ap + $f68f332138d52ff8$var$DZ + $f68f332138d52ff8$var$Ml + $f68f332138d52ff8$var$AJ + $f68f332138d52ff8$var$Ac + $f68f332138d52ff8$var$AD + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$LO + $f68f332138d52ff8$var$QS + $f68f332138d52ff8$var$Da + $f68f332138d52ff8$var$Mm + $f68f332138d52ff8$var$Ac + $f68f332138d52ff8$var$AD + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Db + $f68f332138d52ff8$var$Dc + $f68f332138d52ff8$var$Mn + $f68f332138d52ff8$var$Ir + $f68f332138d52ff8$var$Ac + $f68f332138d52ff8$var$AD + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Dd + $f68f332138d52ff8$var$De + $f68f332138d52ff8$var$Df + $f68f332138d52ff8$var$Iw + $f68f332138d52ff8$var$Ac + $f68f332138d52ff8$var$AD + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Eh + $f68f332138d52ff8$var$Ei + $f68f332138d52ff8$var$y + $f68f332138d52ff8$var$Ba + $f68f332138d52ff8$var$Bw + $f68f332138d52ff8$var$CL + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$LP + $f68f332138d52ff8$var$LQ + $f68f332138d52ff8$var$CY + $f68f332138d52ff8$var$Ba + $f68f332138d52ff8$var$Bw + $f68f332138d52ff8$var$CL + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Ap + $f68f332138d52ff8$var$Dg + $f68f332138d52ff8$var$f + $f68f332138d52ff8$var$Ba + $f68f332138d52ff8$var$Bw + $f68f332138d52ff8$var$CL + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Dh + $f68f332138d52ff8$var$Mo + $f68f332138d52ff8$var$Di + $f68f332138d52ff8$var$Jq + $f68f332138d52ff8$var$MC + $f68f332138d52ff8$var$MD + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Ch + $f68f332138d52ff8$var$Cp + $f68f332138d52ff8$var$Mp + $f68f332138d52ff8$var$AE + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Aq + $f68f332138d52ff8$var$CR + $f68f332138d52ff8$var$Am + $f68f332138d52ff8$var$AE + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Aq + $f68f332138d52ff8$var$Ob + $f68f332138d52ff8$var$Am + $f68f332138d52ff8$var$AE + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$LR + $f68f332138d52ff8$var$Dj + $f68f332138d52ff8$var$QT + $f68f332138d52ff8$var$LS + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Gm + $f68f332138d52ff8$var$Cq + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$AE + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Gm + $f68f332138d52ff8$var$Cr + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$CM + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$p + $f68f332138d52ff8$var$Cs + $f68f332138d52ff8$var$BJ + $f68f332138d52ff8$var$AE + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$p + $f68f332138d52ff8$var$Jb + $f68f332138d52ff8$var$BJ + $f68f332138d52ff8$var$AF + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$p + $f68f332138d52ff8$var$Ix + $f68f332138d52ff8$var$BG + $f68f332138d52ff8$var$ME + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    3,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Az + $f68f332138d52ff8$var$DV + $f68f332138d52ff8$var$DM + $f68f332138d52ff8$var$Jo + $f68f332138d52ff8$var$AF + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Ej + $f68f332138d52ff8$var$Ek + $f68f332138d52ff8$var$AB + $f68f332138d52ff8$var$EY + $f68f332138d52ff8$var$AF + $f68f332138d52ff8$var$AD + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$MU + $f68f332138d52ff8$var$Nz + $f68f332138d52ff8$var$AA + $f68f332138d52ff8$var$Ld + $f68f332138d52ff8$var$MF + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$El + $f68f332138d52ff8$var$Dk + $f68f332138d52ff8$var$Ip + $f68f332138d52ff8$var$GE + $f68f332138d52ff8$var$AE + $f68f332138d52ff8$var$Mk + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Em + $f68f332138d52ff8$var$En + $f68f332138d52ff8$var$Ip + $f68f332138d52ff8$var$IL + $f68f332138d52ff8$var$AF + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Eo + $f68f332138d52ff8$var$Ep + $f68f332138d52ff8$var$Eq + $f68f332138d52ff8$var$Jh + $f68f332138d52ff8$var$MG + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$t + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$OA + $f68f332138d52ff8$var$Er + $f68f332138d52ff8$var$Es + $f68f332138d52ff8$var$BE + $f68f332138d52ff8$var$MH + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$t + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Bq + $f68f332138d52ff8$var$OB + $f68f332138d52ff8$var$Fo + $f68f332138d52ff8$var$BE + $f68f332138d52ff8$var$OT + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$t + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Hj + $f68f332138d52ff8$var$Ct + $f68f332138d52ff8$var$CP + $f68f332138d52ff8$var$BF + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Hj + $f68f332138d52ff8$var$Bx + $f68f332138d52ff8$var$CP + $f68f332138d52ff8$var$CM + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$LM + $f68f332138d52ff8$var$RK + $f68f332138d52ff8$var$MV + $f68f332138d52ff8$var$IS + $f68f332138d52ff8$var$DR + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$t + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Bl + $f68f332138d52ff8$var$Cu + $f68f332138d52ff8$var$Hm + $f68f332138d52ff8$var$OC + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Bl + $f68f332138d52ff8$var$Iy + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$AF + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Bl + $f68f332138d52ff8$var$Cv + $f68f332138d52ff8$var$Iz + $f68f332138d52ff8$var$MI + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$BA + $f68f332138d52ff8$var$Gp + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$Bn + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Fs + $f68f332138d52ff8$var$Cw + $f68f332138d52ff8$var$Ad + $f68f332138d52ff8$var$MJ + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Fs + $f68f332138d52ff8$var$Cx + $f68f332138d52ff8$var$Ad + $f68f332138d52ff8$var$MK + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Dl + $f68f332138d52ff8$var$Dm + $f68f332138d52ff8$var$BB + $f68f332138d52ff8$var$Oc + $f68f332138d52ff8$var$BF + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Et + $f68f332138d52ff8$var$Eu + $f68f332138d52ff8$var$LT + $f68f332138d52ff8$var$NW + $f68f332138d52ff8$var$Z + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$BH + $f68f332138d52ff8$var$Ev + $f68f332138d52ff8$var$Ib + $f68f332138d52ff8$var$EZ + $f68f332138d52ff8$var$DR + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$t + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Ew + $f68f332138d52ff8$var$Ex + $f68f332138d52ff8$var$Be + $f68f332138d52ff8$var$EZ + $f68f332138d52ff8$var$DR + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$t + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Dn + $f68f332138d52ff8$var$Ey + $f68f332138d52ff8$var$QU + $f68f332138d52ff8$var$Fl + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Ez + $f68f332138d52ff8$var$FA + $f68f332138d52ff8$var$Do + $f68f332138d52ff8$var$Fl + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$PP + $f68f332138d52ff8$var$CZ + $f68f332138d52ff8$var$AK + $f68f332138d52ff8$var$AJ + $f68f332138d52ff8$var$KL + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$t + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$PQ + $f68f332138d52ff8$var$Ca + $f68f332138d52ff8$var$p + $f68f332138d52ff8$var$AJ + $f68f332138d52ff8$var$KM + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$t + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$MW + $f68f332138d52ff8$var$FB + $f68f332138d52ff8$var$BB + $f68f332138d52ff8$var$Ea + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Dp + $f68f332138d52ff8$var$Dq + $f68f332138d52ff8$var$y + $f68f332138d52ff8$var$Ea + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$FC + $f68f332138d52ff8$var$OD + $f68f332138d52ff8$var$Dr + $f68f332138d52ff8$var$CR + $f68f332138d52ff8$var$OE + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$t + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$FD + $f68f332138d52ff8$var$MX + $f68f332138d52ff8$var$BC + $f68f332138d52ff8$var$MQ + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$FE + $f68f332138d52ff8$var$MY + $f68f332138d52ff8$var$QV + $f68f332138d52ff8$var$Jr + $f68f332138d52ff8$var$AE + $f68f332138d52ff8$var$CN + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$FF + $f68f332138d52ff8$var$FG + $f68f332138d52ff8$var$Ds + $f68f332138d52ff8$var$CV + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$Gr + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$FH + $f68f332138d52ff8$var$FI + $f68f332138d52ff8$var$Cb + $f68f332138d52ff8$var$Ag + $f68f332138d52ff8$var$CM + $f68f332138d52ff8$var$Fq + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$FJ + $f68f332138d52ff8$var$FK + $f68f332138d52ff8$var$Dt + $f68f332138d52ff8$var$Ji + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$Ne + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$CD + $f68f332138d52ff8$var$CE + $f68f332138d52ff8$var$Cc + $f68f332138d52ff8$var$CV + $f68f332138d52ff8$var$BF + $f68f332138d52ff8$var$Nf + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$AY + $f68f332138d52ff8$var$CF + $f68f332138d52ff8$var$Br + $f68f332138d52ff8$var$BI + $f68f332138d52ff8$var$Gd + $f68f332138d52ff8$var$Pw + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$t + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$JF + $f68f332138d52ff8$var$CG + $f68f332138d52ff8$var$AQ + $f68f332138d52ff8$var$BI + $f68f332138d52ff8$var$Gd + $f68f332138d52ff8$var$RY + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$t + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$JG + $f68f332138d52ff8$var$CH + $f68f332138d52ff8$var$f + $f68f332138d52ff8$var$BI + $f68f332138d52ff8$var$Gd + $f68f332138d52ff8$var$RZ + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$t + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$OF + $f68f332138d52ff8$var$FL + $f68f332138d52ff8$var$AA + $f68f332138d52ff8$var$GF + $f68f332138d52ff8$var$Gs + $f68f332138d52ff8$var$Gr + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Az + $f68f332138d52ff8$var$Du + $f68f332138d52ff8$var$AB + $f68f332138d52ff8$var$GF + $f68f332138d52ff8$var$Gs + $f68f332138d52ff8$var$CN + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$BH + $f68f332138d52ff8$var$OG + $f68f332138d52ff8$var$Ib + $f68f332138d52ff8$var$Cy + $f68f332138d52ff8$var$AF + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$FM + $f68f332138d52ff8$var$FN + $f68f332138d52ff8$var$Dv + $f68f332138d52ff8$var$AJ + $f68f332138d52ff8$var$AF + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$FO + $f68f332138d52ff8$var$FP + $f68f332138d52ff8$var$Dw + $f68f332138d52ff8$var$Bu + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Jc + $f68f332138d52ff8$var$MZ + $f68f332138d52ff8$var$AL + $f68f332138d52ff8$var$Bu + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$FQ + $f68f332138d52ff8$var$FR + $f68f332138d52ff8$var$PR + $f68f332138d52ff8$var$Bu + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$GU + " +lat_0=47.25" + $f68f332138d52ff8$var$Qk + $f68f332138d52ff8$var$ST + $f68f332138d52ff8$var$EW + $f68f332138d52ff8$var$Is + $f68f332138d52ff8$var$Pd + $f68f332138d52ff8$var$Gq + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    4,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$RQ + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$DP + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$Pd + $f68f332138d52ff8$var$Gq + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$RR + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$Eg + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$Pd + $f68f332138d52ff8$var$Gq + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    13,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + " +lon_0=109" + $f68f332138d52ff8$var$AP + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$Ak + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$Cj + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + " +lon_0=116" + $f68f332138d52ff8$var$AP + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$Ak + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Il + $f68f332138d52ff8$var$AP + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$Ak + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$ZO + $f68f332138d52ff8$var$AP + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$KC + $f68f332138d52ff8$var$c + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$KC + $f68f332138d52ff8$var$c + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$Ck + $f68f332138d52ff8$var$Vs + $f68f332138d52ff8$var$UX + " +x_0=86501.46392052001" + $f68f332138d52ff8$var$aS + $f68f332138d52ff8$var$Ee + $f68f332138d52ff8$var$Ef + $f68f332138d52ff8$var$JK + $f68f332138d52ff8$var$ML + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Hi + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$Bs + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Gz + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$Bs + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + " +lat_1=9 +lat_2=3 +lat_0=6" + $f68f332138d52ff8$var$Pe + $f68f332138d52ff8$var$BZ + $f68f332138d52ff8$var$AH + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$AX + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + " +lat_1=17 +lat_2=33 +lat_0=25.08951" + $f68f332138d52ff8$var$SQ + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$Cm + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$HO + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$n + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Ia + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$n + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$IG + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$n + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$PN + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$n + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$LN + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$n + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$PO + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$n + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$JS + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$n + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Vt + $f68f332138d52ff8$var$Vu + " +k=1 +x_0=836694.05 +y_0=819069.8" + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$Jg + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$HP + " +k=1" + $f68f332138d52ff8$var$HU + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$As + $f68f332138d52ff8$var$d + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$HQ + " +k=1" + $f68f332138d52ff8$var$Gw + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$As + $f68f332138d52ff8$var$d + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Hd + " +k=1" + $f68f332138d52ff8$var$Hu + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$As + $f68f332138d52ff8$var$d + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$HR + " +k=1" + $f68f332138d52ff8$var$Hv + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$As + $f68f332138d52ff8$var$d + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$HS + " +k=1" + $f68f332138d52ff8$var$It + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$As + $f68f332138d52ff8$var$d + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$EN + " +k=1" + $f68f332138d52ff8$var$Hs + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$As + $f68f332138d52ff8$var$d + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Fy + " +k=1" + $f68f332138d52ff8$var$Ht + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$As + $f68f332138d52ff8$var$d + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Fm + " +k=1" + $f68f332138d52ff8$var$HV + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$As + $f68f332138d52ff8$var$d + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Fr + " +k=1" + $f68f332138d52ff8$var$Hw + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$As + $f68f332138d52ff8$var$d + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Ed + " +k=1" + $f68f332138d52ff8$var$HW + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$As + $f68f332138d52ff8$var$d + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Fn + " +k=1" + $f68f332138d52ff8$var$Hx + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$As + $f68f332138d52ff8$var$d + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$HP + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$As + $f68f332138d52ff8$var$d + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$HQ + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$As + $f68f332138d52ff8$var$d + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Hd + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$As + $f68f332138d52ff8$var$d + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$HR + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$As + $f68f332138d52ff8$var$d + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$HS + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$As + $f68f332138d52ff8$var$d + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$EN + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$As + $f68f332138d52ff8$var$d + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Fy + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$As + $f68f332138d52ff8$var$d + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Fm + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$As + $f68f332138d52ff8$var$d + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Fr + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$As + $f68f332138d52ff8$var$d + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Ed + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$As + $f68f332138d52ff8$var$d + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Fn + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$As + $f68f332138d52ff8$var$d + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$HP + " +k=1" + $f68f332138d52ff8$var$Hy + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$As + $f68f332138d52ff8$var$d + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Lt + " +k=1" + $f68f332138d52ff8$var$Hz + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$As + $f68f332138d52ff8$var$d + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$HQ + " +k=1" + $f68f332138d52ff8$var$IA + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$As + $f68f332138d52ff8$var$d + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Ni + " +k=1" + $f68f332138d52ff8$var$IB + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$As + $f68f332138d52ff8$var$d + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Hd + " +k=1" + $f68f332138d52ff8$var$Gx + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$As + $f68f332138d52ff8$var$d + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Hq + " +k=1" + $f68f332138d52ff8$var$IT + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$As + $f68f332138d52ff8$var$d + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$HR + " +k=1" + $f68f332138d52ff8$var$Gc + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$As + $f68f332138d52ff8$var$d + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Mj + " +k=1" + $f68f332138d52ff8$var$IU + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$As + $f68f332138d52ff8$var$d + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$HS + " +k=1" + $f68f332138d52ff8$var$Iu + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$As + $f68f332138d52ff8$var$d + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Jj + " +k=1" + $f68f332138d52ff8$var$Mu + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$As + $f68f332138d52ff8$var$d + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$EN + " +k=1" + $f68f332138d52ff8$var$Mv + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$As + $f68f332138d52ff8$var$d + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Le + " +k=1" + $f68f332138d52ff8$var$Mw + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$As + $f68f332138d52ff8$var$d + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Fy + " +k=1" + $f68f332138d52ff8$var$Mx + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$As + $f68f332138d52ff8$var$d + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Im + " +k=1" + $f68f332138d52ff8$var$My + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$As + $f68f332138d52ff8$var$d + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Fm + " +k=1" + $f68f332138d52ff8$var$Mz + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$As + $f68f332138d52ff8$var$d + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$KF + " +k=1" + $f68f332138d52ff8$var$NA + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$As + $f68f332138d52ff8$var$d + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Fr + " +k=1" + $f68f332138d52ff8$var$NB + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$As + $f68f332138d52ff8$var$d + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Jk + " +k=1" + $f68f332138d52ff8$var$Oh + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$As + $f68f332138d52ff8$var$d + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Ed + " +k=1" + $f68f332138d52ff8$var$NC + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$As + $f68f332138d52ff8$var$d + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Il + " +k=1" + $f68f332138d52ff8$var$Oi + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$As + $f68f332138d52ff8$var$d + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Fn + " +k=1" + $f68f332138d52ff8$var$ND + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$As + $f68f332138d52ff8$var$d + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$HP + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$As + $f68f332138d52ff8$var$d + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Lt + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$As + $f68f332138d52ff8$var$d + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$HQ + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$As + $f68f332138d52ff8$var$d + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Ni + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$As + $f68f332138d52ff8$var$d + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Hd + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$As + $f68f332138d52ff8$var$d + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Hq + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$As + $f68f332138d52ff8$var$d + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$HR + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$As + $f68f332138d52ff8$var$d + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Mj + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$As + $f68f332138d52ff8$var$d + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$HS + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$As + $f68f332138d52ff8$var$d + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Jj + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$As + $f68f332138d52ff8$var$d + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$EN + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$As + $f68f332138d52ff8$var$d + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Le + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$As + $f68f332138d52ff8$var$d + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Fy + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$As + $f68f332138d52ff8$var$d + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Im + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$As + $f68f332138d52ff8$var$d + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Fm + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$As + $f68f332138d52ff8$var$d + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$KF + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$As + $f68f332138d52ff8$var$d + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Fr + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$As + $f68f332138d52ff8$var$d + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Jk + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$As + $f68f332138d52ff8$var$d + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Ed + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$As + $f68f332138d52ff8$var$d + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Il + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$As + $f68f332138d52ff8$var$d + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Fn + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$As + $f68f332138d52ff8$var$d + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Gl + " +k=1" + $f68f332138d52ff8$var$AV + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$At + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$II + " +k=1" + $f68f332138d52ff8$var$Ci + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$At + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$HO + " +k=1" + $f68f332138d52ff8$var$Bo + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$At + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Ia + " +k=1" + $f68f332138d52ff8$var$DP + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$At + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$JS + " +k=1" + $f68f332138d52ff8$var$MS + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$NK + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$PS + " +k=1" + $f68f332138d52ff8$var$MT + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$NK + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$KB + " +k=1" + $f68f332138d52ff8$var$Bo + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$Ar + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$IH + " +k=1" + $f68f332138d52ff8$var$DP + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$Ar + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Gj + " +k=1" + $f68f332138d52ff8$var$Eg + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$Ar + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    2,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$HP + " +k=1" + $f68f332138d52ff8$var$Hy + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$U + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Lt + " +k=1" + $f68f332138d52ff8$var$Hz + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$U + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$HQ + " +k=1" + $f68f332138d52ff8$var$IA + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$U + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Ni + " +k=1" + $f68f332138d52ff8$var$IB + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$U + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Hd + " +k=1" + $f68f332138d52ff8$var$Gx + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$U + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Hq + " +k=1" + $f68f332138d52ff8$var$IT + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$U + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$HR + " +k=1" + $f68f332138d52ff8$var$Gc + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$U + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Mj + " +k=1" + $f68f332138d52ff8$var$IU + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$U + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$HS + " +k=1" + $f68f332138d52ff8$var$Iu + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$U + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Jj + " +k=1" + $f68f332138d52ff8$var$Mu + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$U + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$EN + " +k=1" + $f68f332138d52ff8$var$Mv + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$U + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Le + " +k=1" + $f68f332138d52ff8$var$Mw + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$U + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Fy + " +k=1" + $f68f332138d52ff8$var$Mx + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$U + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Im + " +k=1" + $f68f332138d52ff8$var$My + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$U + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Fm + " +k=1" + $f68f332138d52ff8$var$Mz + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$U + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$KF + " +k=1" + $f68f332138d52ff8$var$NA + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$U + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Fr + " +k=1" + $f68f332138d52ff8$var$NB + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$U + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Jk + " +k=1" + $f68f332138d52ff8$var$Oh + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$U + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Ed + " +k=1" + $f68f332138d52ff8$var$NC + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$U + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Il + " +k=1" + $f68f332138d52ff8$var$Oi + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$U + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Fn + " +k=1" + $f68f332138d52ff8$var$ND + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$U + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$HP + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$U + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Lt + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$U + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$HQ + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$U + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Ni + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$U + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Hd + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$U + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Hq + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$U + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$HR + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$U + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Mj + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$U + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$HS + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$U + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Jj + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$U + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$EN + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$U + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Le + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$U + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Fy + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$U + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Im + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$U + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Fm + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$U + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$KF + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$U + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Fr + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$U + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Jk + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$U + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Ed + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$U + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Il + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$U + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Fn + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$U + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$PT + $f68f332138d52ff8$var$Zz + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$PT + $f68f332138d52ff8$var$NX + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$GM + $f68f332138d52ff8$var$Ox + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$PT + $f68f332138d52ff8$var$Tk + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$GM + $f68f332138d52ff8$var$Oy + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$GM + $f68f332138d52ff8$var$Rw + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$GM + $f68f332138d52ff8$var$Oz + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$GM + $f68f332138d52ff8$var$aA + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$GM + $f68f332138d52ff8$var$PA + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Fs + $f68f332138d52ff8$var$PB + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$IZ + $f68f332138d52ff8$var$ZH + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$IZ + $f68f332138d52ff8$var$ZI + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$IZ + $f68f332138d52ff8$var$ZJ + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$IQ + " +lon_0=142" + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$IQ + $f68f332138d52ff8$var$Pj + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$IQ + " +lon_0=124" + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$IQ + $f68f332138d52ff8$var$NX + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=20" + $f68f332138d52ff8$var$Rw + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$IQ + $f68f332138d52ff8$var$ZR + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Gl + " +k=1" + $f68f332138d52ff8$var$DP + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Gl + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$HO + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$IG + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$LN + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$JS + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$PS + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$RL + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$QW + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$RM + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$HP + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$HQ + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Hd + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$HR + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$HS + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$EN + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Fy + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Fm + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Fr + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Ed + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Fn + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Pf + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Od + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$NY + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Pg + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$NZ + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Lf + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$KG + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$KH + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Lh + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    3,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Gl + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$HO + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$IG + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$LN + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$JS + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$PS + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$RL + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$QW + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$RM + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$HP + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$HQ + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Hd + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$HR + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$HS + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$EN + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Fy + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Fm + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Fr + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Ed + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Fn + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Pf + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Od + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$NY + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Pg + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$NZ + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Lf + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$KG + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$KH + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Lh + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Gl + " +k=1" + $f68f332138d52ff8$var$IM + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$II + " +k=1" + $f68f332138d52ff8$var$MS + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$HO + " +k=1" + $f68f332138d52ff8$var$MT + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Ia + " +k=1" + $f68f332138d52ff8$var$LY + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$IG + " +k=1" + $f68f332138d52ff8$var$Jp + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$PN + " +k=1" + $f68f332138d52ff8$var$LZ + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$LN + " +k=1" + $f68f332138d52ff8$var$HU + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$PO + " +k=1" + $f68f332138d52ff8$var$Gw + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$JS + " +k=1" + $f68f332138d52ff8$var$Hu + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$SQ + " +k=1" + $f68f332138d52ff8$var$Hv + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$PS + " +k=1" + $f68f332138d52ff8$var$It + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$SR + " +k=1" + $f68f332138d52ff8$var$Hs + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$RL + " +k=1" + $f68f332138d52ff8$var$Ht + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + " +lon_0=60 +k=1" + $f68f332138d52ff8$var$HV + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$QW + " +k=1" + $f68f332138d52ff8$var$Hw + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$UH + " +k=1" + $f68f332138d52ff8$var$HW + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$RM + " +k=1" + $f68f332138d52ff8$var$Hx + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Yt + " +k=1" + $f68f332138d52ff8$var$La + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$HP + " +k=1" + $f68f332138d52ff8$var$Hy + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Lt + " +k=1" + $f68f332138d52ff8$var$Hz + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$HQ + " +k=1" + $f68f332138d52ff8$var$IA + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Ni + " +k=1" + $f68f332138d52ff8$var$IB + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Hd + " +k=1" + $f68f332138d52ff8$var$Gx + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Hq + " +k=1" + $f68f332138d52ff8$var$IT + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$HR + " +k=1" + $f68f332138d52ff8$var$Gc + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Mj + " +k=1" + $f68f332138d52ff8$var$IU + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$HS + " +k=1" + $f68f332138d52ff8$var$Iu + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    2,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Jj + " +k=1" + $f68f332138d52ff8$var$Mu + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$EN + " +k=1" + $f68f332138d52ff8$var$Mv + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Le + " +k=1" + $f68f332138d52ff8$var$Mw + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Fy + " +k=1" + $f68f332138d52ff8$var$Mx + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Im + " +k=1" + $f68f332138d52ff8$var$My + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Fm + " +k=1" + $f68f332138d52ff8$var$Mz + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$KF + " +k=1" + $f68f332138d52ff8$var$NA + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Fr + " +k=1" + $f68f332138d52ff8$var$NB + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Jk + " +k=1" + $f68f332138d52ff8$var$Oh + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Ed + " +k=1" + $f68f332138d52ff8$var$NC + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Il + " +k=1" + $f68f332138d52ff8$var$Oi + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Fn + " +k=1" + $f68f332138d52ff8$var$ND + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Rx + " +k=1 +x_0=46500000" + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Pf + " +k=1" + $f68f332138d52ff8$var$ZK + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$UN + " +k=1 +x_0=48500000" + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Od + " +k=1 +x_0=49500000" + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Oe + " +k=1 +x_0=50500000" + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$NY + " +k=1 +x_0=51500000" + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$ZS + " +k=1 +x_0=52500000" + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Pg + " +k=1 +x_0=53500000" + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Ql + " +k=1 +x_0=54500000" + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$NZ + " +k=1 +x_0=55500000" + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$UO + " +k=1 +x_0=56500000" + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Lf + " +k=1 +x_0=57500000" + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$UP + " +k=1 +x_0=58500000" + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$KG + " +k=1 +x_0=59500000" + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    2,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$KH + " +k=1 +x_0=61500000" + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$SU + " +k=1 +x_0=62500000" + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Lh + " +k=1 +x_0=63500000" + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$SV + " +k=1 +x_0=64500000" + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Gl + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$II + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$HO + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Ia + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$IG + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$PN + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$LN + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$PO + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$JS + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$SQ + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$PS + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$SR + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$RL + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + " +lon_0=60 +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$QW + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$UH + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$RM + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Yt + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    2,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$HP + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Lt + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$HQ + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Ni + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Hd + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Hq + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$HR + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Mj + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$HS + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Jj + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$EN + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Le + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Fy + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Im + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Fm + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$KF + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Fr + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Jk + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Ed + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Il + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Fn + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Rx + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Pf + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$UN + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Od + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Oe + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$NY + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$ZS + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Pg + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Ql + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$NZ + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$UO + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Lf + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$UP + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$KG + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Ry + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$KH + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$SU + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Lh + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$SV + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Gl + " +k=1" + $f68f332138d52ff8$var$IM + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$II + " +k=1" + $f68f332138d52ff8$var$MS + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$HO + " +k=1" + $f68f332138d52ff8$var$MT + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Ia + " +k=1" + $f68f332138d52ff8$var$LY + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$IG + " +k=1" + $f68f332138d52ff8$var$Jp + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$PN + " +k=1" + $f68f332138d52ff8$var$LZ + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$LN + " +k=1" + $f68f332138d52ff8$var$HU + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$PO + " +k=1" + $f68f332138d52ff8$var$Gw + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$JS + " +k=1" + $f68f332138d52ff8$var$Hu + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$SQ + " +k=1" + $f68f332138d52ff8$var$Hv + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$PS + " +k=1" + $f68f332138d52ff8$var$It + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$SR + " +k=1" + $f68f332138d52ff8$var$Hs + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$RL + " +k=1" + $f68f332138d52ff8$var$Ht + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + " +lon_0=60 +k=1" + $f68f332138d52ff8$var$HV + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$QW + " +k=1" + $f68f332138d52ff8$var$Hw + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$UH + " +k=1" + $f68f332138d52ff8$var$HW + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$RM + " +k=1" + $f68f332138d52ff8$var$Hx + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Yt + " +k=1" + $f68f332138d52ff8$var$La + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$HP + " +k=1" + $f68f332138d52ff8$var$Hy + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Lt + " +k=1" + $f68f332138d52ff8$var$Hz + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$HQ + " +k=1" + $f68f332138d52ff8$var$IA + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Ni + " +k=1" + $f68f332138d52ff8$var$IB + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Hd + " +k=1" + $f68f332138d52ff8$var$Gx + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Hq + " +k=1" + $f68f332138d52ff8$var$IT + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$HR + " +k=1" + $f68f332138d52ff8$var$Gc + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Mj + " +k=1" + $f68f332138d52ff8$var$IU + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$HS + " +k=1" + $f68f332138d52ff8$var$Iu + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Jj + " +k=1" + $f68f332138d52ff8$var$Mu + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$EN + " +k=1" + $f68f332138d52ff8$var$Mv + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Le + " +k=1" + $f68f332138d52ff8$var$Mw + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Fy + " +k=1" + $f68f332138d52ff8$var$Mx + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Im + " +k=1" + $f68f332138d52ff8$var$My + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Fm + " +k=1" + $f68f332138d52ff8$var$Mz + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$KF + " +k=1" + $f68f332138d52ff8$var$NA + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Fr + " +k=1" + $f68f332138d52ff8$var$NB + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Jk + " +k=1" + $f68f332138d52ff8$var$Oh + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Ed + " +k=1" + $f68f332138d52ff8$var$NC + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Il + " +k=1" + $f68f332138d52ff8$var$Oi + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Fn + " +k=1" + $f68f332138d52ff8$var$ND + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Rx + " +k=1 +x_0=46500000" + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Pf + " +k=1" + $f68f332138d52ff8$var$ZK + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$UN + " +k=1 +x_0=48500000" + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Od + " +k=1 +x_0=49500000" + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Oe + " +k=1 +x_0=50500000" + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$NY + " +k=1 +x_0=51500000" + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$ZS + " +k=1 +x_0=52500000" + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Pg + " +k=1 +x_0=53500000" + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Ql + " +k=1 +x_0=54500000" + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$NZ + " +k=1 +x_0=55500000" + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$UO + " +k=1 +x_0=56500000" + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Lf + " +k=1 +x_0=57500000" + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$UP + " +k=1 +x_0=58500000" + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$KG + " +k=1 +x_0=59500000" + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    2,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$KH + " +k=1 +x_0=61500000" + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$SU + " +k=1 +x_0=62500000" + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Lh + " +k=1 +x_0=63500000" + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$SV + " +k=1 +x_0=64500000" + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Gl + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$II + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$HO + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Ia + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$IG + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$PN + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$LN + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$PO + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$JS + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$SQ + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$PS + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$SR + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$RL + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + " +lon_0=60 +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$QW + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$UH + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$RM + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Yt + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$HP + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Lt + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$HQ + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Ni + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Hd + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Hq + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$HR + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Mj + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$HS + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Jj + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$EN + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Le + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Fy + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Im + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Fm + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$KF + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Fr + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Jk + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Ed + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Mf + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$i + $f68f332138d52ff8$var$HF + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$KD + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$i + $f68f332138d52ff8$var$HF + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Il + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Fn + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Rx + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Pf + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$UN + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Od + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Oe + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$NY + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$ZS + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Pg + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Ql + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$NZ + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$UO + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Lf + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$UP + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$KG + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Ry + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$KH + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$SU + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Lh + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$SV + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$IY + $f68f332138d52ff8$var$IV + $f68f332138d52ff8$var$Pc + $f68f332138d52ff8$var$h + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Gm + $f68f332138d52ff8$var$OS + $f68f332138d52ff8$var$BG + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Bl + $f68f332138d52ff8$var$Cn + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$EX + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Bl + $f68f332138d52ff8$var$Co + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$EX + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Bl + $f68f332138d52ff8$var$Iv + $f68f332138d52ff8$var$BG + $f68f332138d52ff8$var$EX + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Dx + $f68f332138d52ff8$var$Dy + $f68f332138d52ff8$var$BC + $f68f332138d52ff8$var$IF + $f68f332138d52ff8$var$u + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Dz + $f68f332138d52ff8$var$Mq + $f68f332138d52ff8$var$EA + $f68f332138d52ff8$var$IF + $f68f332138d52ff8$var$u + $f68f332138d52ff8$var$Is + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$DW + $f68f332138d52ff8$var$Jn + $f68f332138d52ff8$var$y + $f68f332138d52ff8$var$HA + $f68f332138d52ff8$var$Bd + $f68f332138d52ff8$var$Ae + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$DX + $f68f332138d52ff8$var$DY + $f68f332138d52ff8$var$AA + $f68f332138d52ff8$var$HA + $f68f332138d52ff8$var$Bd + $f68f332138d52ff8$var$Ae + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Ap + $f68f332138d52ff8$var$DZ + $f68f332138d52ff8$var$Ml + $f68f332138d52ff8$var$AJ + $f68f332138d52ff8$var$Bd + $f68f332138d52ff8$var$Ae + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$LO + $f68f332138d52ff8$var$QS + $f68f332138d52ff8$var$Da + $f68f332138d52ff8$var$Mm + $f68f332138d52ff8$var$Bd + $f68f332138d52ff8$var$Ae + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Db + $f68f332138d52ff8$var$Dc + $f68f332138d52ff8$var$Mn + $f68f332138d52ff8$var$Ir + $f68f332138d52ff8$var$Bd + $f68f332138d52ff8$var$Ae + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Dd + $f68f332138d52ff8$var$De + $f68f332138d52ff8$var$Df + $f68f332138d52ff8$var$Iw + $f68f332138d52ff8$var$Bd + $f68f332138d52ff8$var$Ae + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Eh + $f68f332138d52ff8$var$Ei + $f68f332138d52ff8$var$y + $f68f332138d52ff8$var$Ba + $f68f332138d52ff8$var$Fw + $f68f332138d52ff8$var$Fx + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$LP + $f68f332138d52ff8$var$LQ + $f68f332138d52ff8$var$CY + $f68f332138d52ff8$var$Ba + $f68f332138d52ff8$var$Fw + $f68f332138d52ff8$var$Fx + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Ap + $f68f332138d52ff8$var$Dg + $f68f332138d52ff8$var$f + $f68f332138d52ff8$var$Ba + $f68f332138d52ff8$var$Fw + $f68f332138d52ff8$var$Fx + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Dh + $f68f332138d52ff8$var$Mo + $f68f332138d52ff8$var$Di + $f68f332138d52ff8$var$Jq + $f68f332138d52ff8$var$QG + $f68f332138d52ff8$var$QH + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Ch + $f68f332138d52ff8$var$Cp + $f68f332138d52ff8$var$Mp + $f68f332138d52ff8$var$h + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Aq + $f68f332138d52ff8$var$CR + $f68f332138d52ff8$var$Am + $f68f332138d52ff8$var$h + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Aq + $f68f332138d52ff8$var$Ob + $f68f332138d52ff8$var$Am + $f68f332138d52ff8$var$h + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$LR + $f68f332138d52ff8$var$Dj + $f68f332138d52ff8$var$QT + $f68f332138d52ff8$var$LS + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Gm + $f68f332138d52ff8$var$Cq + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$h + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Gm + $f68f332138d52ff8$var$Cr + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$EW + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Kn + $f68f332138d52ff8$var$Sf + $f68f332138d52ff8$var$AO + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Ko + $f68f332138d52ff8$var$KO + $f68f332138d52ff8$var$AO + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$GV + $f68f332138d52ff8$var$KI + $f68f332138d52ff8$var$Jl + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Kp + $f68f332138d52ff8$var$Sg + $f68f332138d52ff8$var$Jl + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Kq + $f68f332138d52ff8$var$KP + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$p + $f68f332138d52ff8$var$Cs + $f68f332138d52ff8$var$BJ + $f68f332138d52ff8$var$h + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$p + $f68f332138d52ff8$var$Jb + $f68f332138d52ff8$var$BJ + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$p + $f68f332138d52ff8$var$Ix + $f68f332138d52ff8$var$BG + $f68f332138d52ff8$var$CX + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$f + $f68f332138d52ff8$var$Cz + $f68f332138d52ff8$var$EQ + $f68f332138d52ff8$var$AI + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$f + $f68f332138d52ff8$var$DA + $f68f332138d52ff8$var$Am + $f68f332138d52ff8$var$EW + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$DM + $f68f332138d52ff8$var$DB + $f68f332138d52ff8$var$AO + $f68f332138d52ff8$var$BU + $f68f332138d52ff8$var$KJ + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$DM + $f68f332138d52ff8$var$DC + $f68f332138d52ff8$var$AO + $f68f332138d52ff8$var$HT + $f68f332138d52ff8$var$KJ + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$EB + $f68f332138d52ff8$var$EC + $f68f332138d52ff8$var$Fo + $f68f332138d52ff8$var$GG + $f68f332138d52ff8$var$AV + $f68f332138d52ff8$var$AH + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$AY + $f68f332138d52ff8$var$ED + $f68f332138d52ff8$var$Fs + $f68f332138d52ff8$var$GG + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$EE + $f68f332138d52ff8$var$EF + $f68f332138d52ff8$var$AQ + $f68f332138d52ff8$var$Fl + $f68f332138d52ff8$var$u + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$EG + $f68f332138d52ff8$var$EH + $f68f332138d52ff8$var$f + $f68f332138d52ff8$var$CV + $f68f332138d52ff8$var$u + $f68f332138d52ff8$var$Is + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Az + $f68f332138d52ff8$var$DV + $f68f332138d52ff8$var$DM + $f68f332138d52ff8$var$Jo + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Ej + $f68f332138d52ff8$var$Ek + $f68f332138d52ff8$var$AB + $f68f332138d52ff8$var$EY + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$Ae + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$FS + $f68f332138d52ff8$var$FT + $f68f332138d52ff8$var$IY + $f68f332138d52ff8$var$Hg + $f68f332138d52ff8$var$BZ + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$OH + $f68f332138d52ff8$var$OI + $f68f332138d52ff8$var$OJ + $f68f332138d52ff8$var$Bi + $f68f332138d52ff8$var$BZ + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$AK + $f68f332138d52ff8$var$HJ + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$AI + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$BD + $f68f332138d52ff8$var$DD + $f68f332138d52ff8$var$AO + $f68f332138d52ff8$var$HT + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$MU + $f68f332138d52ff8$var$Nz + $f68f332138d52ff8$var$AA + $f68f332138d52ff8$var$Ld + $f68f332138d52ff8$var$u + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$El + $f68f332138d52ff8$var$Dk + $f68f332138d52ff8$var$Ip + $f68f332138d52ff8$var$GE + $f68f332138d52ff8$var$h + $f68f332138d52ff8$var$Mk + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Em + $f68f332138d52ff8$var$En + $f68f332138d52ff8$var$Ip + $f68f332138d52ff8$var$IL + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Eo + $f68f332138d52ff8$var$Ep + $f68f332138d52ff8$var$Eq + $f68f332138d52ff8$var$Jh + $f68f332138d52ff8$var$Tl + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$OA + $f68f332138d52ff8$var$Er + $f68f332138d52ff8$var$Es + $f68f332138d52ff8$var$BE + $f68f332138d52ff8$var$Pk + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Bq + $f68f332138d52ff8$var$OB + $f68f332138d52ff8$var$Fo + $f68f332138d52ff8$var$BE + $f68f332138d52ff8$var$LU + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$FU + $f68f332138d52ff8$var$FV + $f68f332138d52ff8$var$Iq + $f68f332138d52ff8$var$DE + $f68f332138d52ff8$var$CX + $f68f332138d52ff8$var$EK + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Ma + $f68f332138d52ff8$var$FW + $f68f332138d52ff8$var$IP + $f68f332138d52ff8$var$Js + $f68f332138d52ff8$var$CX + $f68f332138d52ff8$var$EK + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$FX + $f68f332138d52ff8$var$FY + $f68f332138d52ff8$var$Nj + $f68f332138d52ff8$var$Na + $f68f332138d52ff8$var$CX + $f68f332138d52ff8$var$EK + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Hj + $f68f332138d52ff8$var$Ct + $f68f332138d52ff8$var$CP + $f68f332138d52ff8$var$AI + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Hj + $f68f332138d52ff8$var$Bx + $f68f332138d52ff8$var$CP + $f68f332138d52ff8$var$EW + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Cd + $f68f332138d52ff8$var$RS + $f68f332138d52ff8$var$BG + $f68f332138d52ff8$var$Bv + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Cd + $f68f332138d52ff8$var$Hg + $f68f332138d52ff8$var$BG + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Id + $f68f332138d52ff8$var$RT + $f68f332138d52ff8$var$Am + $f68f332138d52ff8$var$YC + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$LM + $f68f332138d52ff8$var$RK + $f68f332138d52ff8$var$MV + $f68f332138d52ff8$var$IS + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$JT + $f68f332138d52ff8$var$Jn + $f68f332138d52ff8$var$FZ + $f68f332138d52ff8$var$CS + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$CQ + $f68f332138d52ff8$var$DF + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$h + $f68f332138d52ff8$var$Tm + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$CQ + $f68f332138d52ff8$var$DG + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$Hh + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$CQ + $f68f332138d52ff8$var$DH + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$CX + $f68f332138d52ff8$var$LV + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Fp + $f68f332138d52ff8$var$DI + $f68f332138d52ff8$var$AO + $f68f332138d52ff8$var$AI + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$BA + $f68f332138d52ff8$var$Gp + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$Bn + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Bl + $f68f332138d52ff8$var$Cu + $f68f332138d52ff8$var$Hm + $f68f332138d52ff8$var$OC + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Bl + $f68f332138d52ff8$var$Iy + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Bl + $f68f332138d52ff8$var$Cv + $f68f332138d52ff8$var$Iz + $f68f332138d52ff8$var$YD + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$BA + $f68f332138d52ff8$var$Gp + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$Bn + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Fs + $f68f332138d52ff8$var$Cw + $f68f332138d52ff8$var$Ad + $f68f332138d52ff8$var$Bv + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Fs + $f68f332138d52ff8$var$Cx + $f68f332138d52ff8$var$Ad + $f68f332138d52ff8$var$Qo + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Dl + $f68f332138d52ff8$var$Dm + $f68f332138d52ff8$var$BB + $f68f332138d52ff8$var$Oc + $f68f332138d52ff8$var$AI + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$BH + $f68f332138d52ff8$var$Ev + $f68f332138d52ff8$var$Ib + $f68f332138d52ff8$var$EZ + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Ew + $f68f332138d52ff8$var$Ex + $f68f332138d52ff8$var$Be + $f68f332138d52ff8$var$EZ + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$OK + $f68f332138d52ff8$var$Fa + $f68f332138d52ff8$var$BY + $f68f332138d52ff8$var$ET + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Fb + $f68f332138d52ff8$var$Fc + $f68f332138d52ff8$var$Ch + $f68f332138d52ff8$var$ET + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Dn + $f68f332138d52ff8$var$Ey + $f68f332138d52ff8$var$QU + $f68f332138d52ff8$var$Fl + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Ez + $f68f332138d52ff8$var$FA + $f68f332138d52ff8$var$Do + $f68f332138d52ff8$var$Fl + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$PP + $f68f332138d52ff8$var$CZ + $f68f332138d52ff8$var$AK + $f68f332138d52ff8$var$AJ + $f68f332138d52ff8$var$Ci + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$PQ + $f68f332138d52ff8$var$Ca + $f68f332138d52ff8$var$p + $f68f332138d52ff8$var$AJ + $f68f332138d52ff8$var$AV + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$EI + $f68f332138d52ff8$var$GE + $f68f332138d52ff8$var$Lb + $f68f332138d52ff8$var$BU + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Fd + $f68f332138d52ff8$var$Fe + $f68f332138d52ff8$var$AL + $f68f332138d52ff8$var$CS + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$OL + $f68f332138d52ff8$var$Ff + $f68f332138d52ff8$var$EJ + $f68f332138d52ff8$var$Ag + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$FD + $f68f332138d52ff8$var$MX + $f68f332138d52ff8$var$BC + $f68f332138d52ff8$var$MQ + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$FE + $f68f332138d52ff8$var$MY + $f68f332138d52ff8$var$QV + $f68f332138d52ff8$var$Jr + $f68f332138d52ff8$var$h + $f68f332138d52ff8$var$AH + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$FF + $f68f332138d52ff8$var$FG + $f68f332138d52ff8$var$Ds + $f68f332138d52ff8$var$CV + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$Cl + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$FH + $f68f332138d52ff8$var$FI + $f68f332138d52ff8$var$Cb + $f68f332138d52ff8$var$Ag + $f68f332138d52ff8$var$EW + $f68f332138d52ff8$var$Fq + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$FJ + $f68f332138d52ff8$var$FK + $f68f332138d52ff8$var$Dt + $f68f332138d52ff8$var$Ji + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$LV + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$CD + $f68f332138d52ff8$var$CE + $f68f332138d52ff8$var$Cc + $f68f332138d52ff8$var$CV + $f68f332138d52ff8$var$AI + $f68f332138d52ff8$var$Ju + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$AY + $f68f332138d52ff8$var$CF + $f68f332138d52ff8$var$Br + $f68f332138d52ff8$var$BI + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$AH + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$JF + $f68f332138d52ff8$var$CG + $f68f332138d52ff8$var$AQ + $f68f332138d52ff8$var$BI + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$Cl + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$JG + $f68f332138d52ff8$var$CH + $f68f332138d52ff8$var$f + $f68f332138d52ff8$var$BI + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$Fq + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Fp + $f68f332138d52ff8$var$LW + $f68f332138d52ff8$var$JA + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$OF + $f68f332138d52ff8$var$FL + $f68f332138d52ff8$var$AA + $f68f332138d52ff8$var$GF + $f68f332138d52ff8$var$Bo + $f68f332138d52ff8$var$Cl + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Az + $f68f332138d52ff8$var$Du + $f68f332138d52ff8$var$AB + $f68f332138d52ff8$var$GF + $f68f332138d52ff8$var$Bo + $f68f332138d52ff8$var$AH + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$BH + $f68f332138d52ff8$var$OG + $f68f332138d52ff8$var$Ib + $f68f332138d52ff8$var$Cy + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$FM + $f68f332138d52ff8$var$FN + $f68f332138d52ff8$var$Dv + $f68f332138d52ff8$var$AJ + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Mb + $f68f332138d52ff8$var$RN + $f68f332138d52ff8$var$Mr + $f68f332138d52ff8$var$Ga + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Fg + $f68f332138d52ff8$var$Fh + $f68f332138d52ff8$var$QX + $f68f332138d52ff8$var$CR + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$FO + $f68f332138d52ff8$var$FP + $f68f332138d52ff8$var$Dw + $f68f332138d52ff8$var$Bu + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Jc + $f68f332138d52ff8$var$MZ + $f68f332138d52ff8$var$AL + $f68f332138d52ff8$var$Bu + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$FQ + $f68f332138d52ff8$var$FR + $f68f332138d52ff8$var$PR + $f68f332138d52ff8$var$Bu + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$CA + $f68f332138d52ff8$var$DJ + $f68f332138d52ff8$var$Ad + $f68f332138d52ff8$var$h + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$CA + $f68f332138d52ff8$var$DK + $f68f332138d52ff8$var$Ad + $f68f332138d52ff8$var$u + $f68f332138d52ff8$var$EK + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$CA + $f68f332138d52ff8$var$JB + $f68f332138d52ff8$var$Ad + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$CA + $f68f332138d52ff8$var$DL + $f68f332138d52ff8$var$Ad + $f68f332138d52ff8$var$CX + $f68f332138d52ff8$var$EK + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$GW + $f68f332138d52ff8$var$GX + $f68f332138d52ff8$var$GY + $f68f332138d52ff8$var$GA + $f68f332138d52ff8$var$h + $f68f332138d52ff8$var$IK + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Bl + $f68f332138d52ff8$var$Cn + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$EX + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$t + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Bl + $f68f332138d52ff8$var$Co + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$EX + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$t + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Bl + $f68f332138d52ff8$var$Iv + $f68f332138d52ff8$var$BG + $f68f332138d52ff8$var$EX + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$t + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$DW + $f68f332138d52ff8$var$Jn + $f68f332138d52ff8$var$y + $f68f332138d52ff8$var$HA + $f68f332138d52ff8$var$Ac + $f68f332138d52ff8$var$AD + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$DX + $f68f332138d52ff8$var$DY + $f68f332138d52ff8$var$AA + $f68f332138d52ff8$var$HA + $f68f332138d52ff8$var$Ac + $f68f332138d52ff8$var$AD + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Ap + $f68f332138d52ff8$var$DZ + $f68f332138d52ff8$var$Ml + $f68f332138d52ff8$var$AJ + $f68f332138d52ff8$var$Ac + $f68f332138d52ff8$var$AD + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$LO + $f68f332138d52ff8$var$QS + $f68f332138d52ff8$var$Da + $f68f332138d52ff8$var$Mm + $f68f332138d52ff8$var$Ac + $f68f332138d52ff8$var$AD + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Db + $f68f332138d52ff8$var$Dc + $f68f332138d52ff8$var$Mn + $f68f332138d52ff8$var$Ir + $f68f332138d52ff8$var$Ac + $f68f332138d52ff8$var$AD + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Dd + $f68f332138d52ff8$var$De + $f68f332138d52ff8$var$Df + $f68f332138d52ff8$var$Iw + $f68f332138d52ff8$var$Ac + $f68f332138d52ff8$var$AD + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Eh + $f68f332138d52ff8$var$Ei + $f68f332138d52ff8$var$y + $f68f332138d52ff8$var$Ba + $f68f332138d52ff8$var$Bw + $f68f332138d52ff8$var$CL + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$LP + $f68f332138d52ff8$var$LQ + $f68f332138d52ff8$var$CY + $f68f332138d52ff8$var$Ba + $f68f332138d52ff8$var$Bw + $f68f332138d52ff8$var$CL + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Ap + $f68f332138d52ff8$var$Dg + $f68f332138d52ff8$var$f + $f68f332138d52ff8$var$Ba + $f68f332138d52ff8$var$Bw + $f68f332138d52ff8$var$CL + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Dh + $f68f332138d52ff8$var$Mo + $f68f332138d52ff8$var$Di + $f68f332138d52ff8$var$Jq + $f68f332138d52ff8$var$MC + $f68f332138d52ff8$var$MD + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Ch + $f68f332138d52ff8$var$Cp + $f68f332138d52ff8$var$Mp + $f68f332138d52ff8$var$AE + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Aq + $f68f332138d52ff8$var$CR + $f68f332138d52ff8$var$Am + $f68f332138d52ff8$var$AE + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Aq + $f68f332138d52ff8$var$Ob + $f68f332138d52ff8$var$Am + $f68f332138d52ff8$var$AE + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$LR + $f68f332138d52ff8$var$Dj + $f68f332138d52ff8$var$QT + $f68f332138d52ff8$var$LS + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Gm + $f68f332138d52ff8$var$Cq + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$AE + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Gm + $f68f332138d52ff8$var$Cr + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$CM + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$p + $f68f332138d52ff8$var$Cs + $f68f332138d52ff8$var$BJ + $f68f332138d52ff8$var$AE + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$p + $f68f332138d52ff8$var$Jb + $f68f332138d52ff8$var$BJ + $f68f332138d52ff8$var$AF + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$p + $f68f332138d52ff8$var$Ix + $f68f332138d52ff8$var$BG + $f68f332138d52ff8$var$ME + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    3,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Az + $f68f332138d52ff8$var$DV + $f68f332138d52ff8$var$DM + $f68f332138d52ff8$var$Jo + $f68f332138d52ff8$var$AF + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Ej + $f68f332138d52ff8$var$Ek + $f68f332138d52ff8$var$AB + $f68f332138d52ff8$var$EY + $f68f332138d52ff8$var$AF + $f68f332138d52ff8$var$AD + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$MU + $f68f332138d52ff8$var$Nz + $f68f332138d52ff8$var$AA + $f68f332138d52ff8$var$Ld + $f68f332138d52ff8$var$MF + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$El + $f68f332138d52ff8$var$Dk + $f68f332138d52ff8$var$Ip + $f68f332138d52ff8$var$GE + $f68f332138d52ff8$var$AE + $f68f332138d52ff8$var$Mk + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Em + $f68f332138d52ff8$var$En + $f68f332138d52ff8$var$Ip + $f68f332138d52ff8$var$IL + $f68f332138d52ff8$var$AF + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Eo + $f68f332138d52ff8$var$Ep + $f68f332138d52ff8$var$Eq + $f68f332138d52ff8$var$Jh + $f68f332138d52ff8$var$MG + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$t + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$OA + $f68f332138d52ff8$var$Er + $f68f332138d52ff8$var$Es + $f68f332138d52ff8$var$BE + $f68f332138d52ff8$var$MH + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$t + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Bq + $f68f332138d52ff8$var$OB + $f68f332138d52ff8$var$Fo + $f68f332138d52ff8$var$BE + $f68f332138d52ff8$var$OT + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$t + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Hj + $f68f332138d52ff8$var$Ct + $f68f332138d52ff8$var$CP + $f68f332138d52ff8$var$BF + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Hj + $f68f332138d52ff8$var$Bx + $f68f332138d52ff8$var$CP + $f68f332138d52ff8$var$CM + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$LM + $f68f332138d52ff8$var$RK + $f68f332138d52ff8$var$MV + $f68f332138d52ff8$var$IS + $f68f332138d52ff8$var$DR + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$t + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Bl + $f68f332138d52ff8$var$Cu + $f68f332138d52ff8$var$Hm + $f68f332138d52ff8$var$OC + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Bl + $f68f332138d52ff8$var$Iy + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$AF + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Bl + $f68f332138d52ff8$var$Cv + $f68f332138d52ff8$var$Iz + $f68f332138d52ff8$var$MI + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$BA + $f68f332138d52ff8$var$Gp + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$Bn + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Fs + $f68f332138d52ff8$var$Cw + $f68f332138d52ff8$var$Ad + $f68f332138d52ff8$var$MJ + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Fs + $f68f332138d52ff8$var$Cx + $f68f332138d52ff8$var$Ad + $f68f332138d52ff8$var$MK + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Dl + $f68f332138d52ff8$var$Dm + $f68f332138d52ff8$var$BB + $f68f332138d52ff8$var$Oc + $f68f332138d52ff8$var$BF + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$BH + $f68f332138d52ff8$var$Ev + $f68f332138d52ff8$var$Ib + $f68f332138d52ff8$var$EZ + $f68f332138d52ff8$var$DR + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$t + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Ew + $f68f332138d52ff8$var$Ex + $f68f332138d52ff8$var$Be + $f68f332138d52ff8$var$EZ + $f68f332138d52ff8$var$DR + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$t + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Dn + $f68f332138d52ff8$var$Ey + $f68f332138d52ff8$var$QU + $f68f332138d52ff8$var$Fl + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Ez + $f68f332138d52ff8$var$FA + $f68f332138d52ff8$var$Do + $f68f332138d52ff8$var$Fl + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$PP + $f68f332138d52ff8$var$CZ + $f68f332138d52ff8$var$AK + $f68f332138d52ff8$var$AJ + $f68f332138d52ff8$var$KL + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$t + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$PQ + $f68f332138d52ff8$var$Ca + $f68f332138d52ff8$var$p + $f68f332138d52ff8$var$AJ + $f68f332138d52ff8$var$KM + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$t + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$FD + $f68f332138d52ff8$var$MX + $f68f332138d52ff8$var$BC + $f68f332138d52ff8$var$MQ + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$FE + $f68f332138d52ff8$var$MY + $f68f332138d52ff8$var$QV + $f68f332138d52ff8$var$Jr + $f68f332138d52ff8$var$AE + $f68f332138d52ff8$var$CN + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$FF + $f68f332138d52ff8$var$FG + $f68f332138d52ff8$var$Ds + $f68f332138d52ff8$var$CV + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$Gr + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$FH + $f68f332138d52ff8$var$FI + $f68f332138d52ff8$var$Cb + $f68f332138d52ff8$var$Ag + $f68f332138d52ff8$var$CM + $f68f332138d52ff8$var$Fq + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$FJ + $f68f332138d52ff8$var$FK + $f68f332138d52ff8$var$Dt + $f68f332138d52ff8$var$Ji + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$Ne + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$CD + $f68f332138d52ff8$var$CE + $f68f332138d52ff8$var$Cc + $f68f332138d52ff8$var$CV + $f68f332138d52ff8$var$BF + $f68f332138d52ff8$var$Nf + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$AY + $f68f332138d52ff8$var$CF + $f68f332138d52ff8$var$Br + $f68f332138d52ff8$var$BI + $f68f332138d52ff8$var$Gd + $f68f332138d52ff8$var$Pw + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$t + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$JF + $f68f332138d52ff8$var$CG + $f68f332138d52ff8$var$AQ + $f68f332138d52ff8$var$BI + $f68f332138d52ff8$var$Gd + $f68f332138d52ff8$var$RY + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$t + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$JG + $f68f332138d52ff8$var$CH + $f68f332138d52ff8$var$f + $f68f332138d52ff8$var$BI + $f68f332138d52ff8$var$Gd + $f68f332138d52ff8$var$RZ + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$t + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$OF + $f68f332138d52ff8$var$FL + $f68f332138d52ff8$var$AA + $f68f332138d52ff8$var$GF + $f68f332138d52ff8$var$Gs + $f68f332138d52ff8$var$Gr + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Az + $f68f332138d52ff8$var$Du + $f68f332138d52ff8$var$AB + $f68f332138d52ff8$var$GF + $f68f332138d52ff8$var$Gs + $f68f332138d52ff8$var$CN + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$BH + $f68f332138d52ff8$var$OG + $f68f332138d52ff8$var$Ib + $f68f332138d52ff8$var$Cy + $f68f332138d52ff8$var$AF + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$FM + $f68f332138d52ff8$var$FN + $f68f332138d52ff8$var$Dv + $f68f332138d52ff8$var$AJ + $f68f332138d52ff8$var$AF + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$FO + $f68f332138d52ff8$var$FP + $f68f332138d52ff8$var$Dw + $f68f332138d52ff8$var$Bu + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Jc + $f68f332138d52ff8$var$MZ + $f68f332138d52ff8$var$AL + $f68f332138d52ff8$var$Bu + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$FQ + $f68f332138d52ff8$var$FR + $f68f332138d52ff8$var$PR + $f68f332138d52ff8$var$Bu + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + " +lon_0=13" + $f68f332138d52ff8$var$AP + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$AU + $f68f332138d52ff8$var$BN + $f68f332138d52ff8$var$Sy + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=24.45" + $f68f332138d52ff8$var$Vv + $f68f332138d52ff8$var$Jl + $f68f332138d52ff8$var$h + $f68f332138d52ff8$var$Hk + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$Jy + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$NS + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$Hf + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    2,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$KQ + " +lon_0=41.53333333333333 +k=1 +x_0=1300000" + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$KQ + " +lon_0=44.53333333333333 +k=1" + $f68f332138d52ff8$var$aB + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$KQ + " +lon_0=47.53333333333333 +k=1" + $f68f332138d52ff8$var$aC + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$KQ + " +lon_0=50.53333333333333 +k=1" + $f68f332138d52ff8$var$aD + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Ol + " +lon_0=50.76666666666667 +k=1" + $f68f332138d52ff8$var$aB + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Ol + " +lon_0=53.76666666666667 +k=1" + $f68f332138d52ff8$var$aC + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Ol + " +lon_0=56.76666666666667 +k=1" + $f68f332138d52ff8$var$aD + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ja + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$SE + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ja + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$Sz + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    2,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Tf + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$Ab + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$RQ + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$Ab + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$RR + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$Ab + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Tg + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$Ab + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$IL + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$Ab + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Th + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$Ab + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Ti + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$Ab + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Ga + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$Ab + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$GU + $f68f332138d52ff8$var$Iq + $f68f332138d52ff8$var$Zy + $f68f332138d52ff8$var$ST + $f68f332138d52ff8$var$Ci + $f68f332138d52ff8$var$aE + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$GU + " +lat_0=47.25" + $f68f332138d52ff8$var$Qk + $f68f332138d52ff8$var$ST + $f68f332138d52ff8$var$u + $f68f332138d52ff8$var$CO + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ns + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Nt + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Nu + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ik + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$IC + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Hi + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Gz + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$ID + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    2,
    $f68f332138d52ff8$var$DT + " +lat_1=55" + $f68f332138d52ff8$var$QY + $f68f332138d52ff8$var$Yu + $f68f332138d52ff8$var$Ms + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$DM + $f68f332138d52ff8$var$DB + $f68f332138d52ff8$var$AO + $f68f332138d52ff8$var$MM + $f68f332138d52ff8$var$GI + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$DM + $f68f332138d52ff8$var$DC + $f68f332138d52ff8$var$AO + $f68f332138d52ff8$var$HT + $f68f332138d52ff8$var$GI + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$DM + $f68f332138d52ff8$var$DB + $f68f332138d52ff8$var$AO + $f68f332138d52ff8$var$MM + $f68f332138d52ff8$var$GI + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$DM + $f68f332138d52ff8$var$DC + $f68f332138d52ff8$var$AO + $f68f332138d52ff8$var$HT + $f68f332138d52ff8$var$GI + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Gz + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$TA + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Gz + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$SF + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Io + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$NH + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Io + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Gz + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$TO + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    2,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Me + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ro + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$TP + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$RG + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$Lr + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$RH + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$UD + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    2,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$JZ + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$SG + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$MA + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$QM + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    6,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$ID + $f68f332138d52ff8$var$i + $f68f332138d52ff8$var$TZ + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$SK + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$SH + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    3,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$JT + $f68f332138d52ff8$var$Hl + $f68f332138d52ff8$var$GH + $f68f332138d52ff8$var$AJ + $f68f332138d52ff8$var$u + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$JT + $f68f332138d52ff8$var$Hl + $f68f332138d52ff8$var$GH + $f68f332138d52ff8$var$AJ + $f68f332138d52ff8$var$Lc + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$t + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$JT + $f68f332138d52ff8$var$Hl + $f68f332138d52ff8$var$GH + $f68f332138d52ff8$var$AJ + $f68f332138d52ff8$var$u + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$JT + $f68f332138d52ff8$var$Hl + $f68f332138d52ff8$var$GH + $f68f332138d52ff8$var$AJ + $f68f332138d52ff8$var$Lc + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$t + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$MA + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$Jf + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$MA + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$TB + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$MA + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$Ke + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$MA + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$HH + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$JZ + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$SI + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$JU + " +lon_0=110" + $f68f332138d52ff8$var$ZP + $f68f332138d52ff8$var$Pl + $f68f332138d52ff8$var$Qp + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$Hf + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$JU + " +lon_0=110" + $f68f332138d52ff8$var$ZP + $f68f332138d52ff8$var$Pl + $f68f332138d52ff8$var$Qp + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$Cj + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$JU + " +lon_0=110" + $f68f332138d52ff8$var$ZP + $f68f332138d52ff8$var$Pl + $f68f332138d52ff8$var$Qp + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$HZ + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$KB + $f68f332138d52ff8$var$AP + $f68f332138d52ff8$var$AV + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$CK + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Gj + $f68f332138d52ff8$var$AP + " +x_0=2520000" + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$CK + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$DT + $f68f332138d52ff8$var$Yv + " +lat_2=58.5" + $f68f332138d52ff8$var$IP + " +lon_0=-126" + $f68f332138d52ff8$var$BZ + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$KC + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$IH + " +k=1" + $f68f332138d52ff8$var$Bn + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + " +lon_0=13.5 +k=1" + $f68f332138d52ff8$var$Bn + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Gj + " +k=1" + $f68f332138d52ff8$var$Bn + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$YE + " +k=1" + $f68f332138d52ff8$var$Bn + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$QR + " +k=1" + $f68f332138d52ff8$var$Bn + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + " +lon_0=14.25 +k=1" + $f68f332138d52ff8$var$Bn + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + " +lon_0=15.75 +k=1" + $f68f332138d52ff8$var$Bn + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + " +lon_0=17.25 +k=1" + $f68f332138d52ff8$var$Bn + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + " +lon_0=18.75 +k=1" + $f68f332138d52ff8$var$Bn + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + " +lon_0=20.25 +k=1" + $f68f332138d52ff8$var$Bn + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + " +lon_0=21.75 +k=1" + $f68f332138d52ff8$var$Bn + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + " +lon_0=23.25 +k=1" + $f68f332138d52ff8$var$Bn + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Vw + " +k=1" + $f68f332138d52ff8$var$AV + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$BW + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Vx + " +k=1" + $f68f332138d52ff8$var$AV + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$BW + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Vy + " +k=1" + $f68f332138d52ff8$var$AV + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$BW + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Vz + " +k=1" + $f68f332138d52ff8$var$AV + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$BW + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$WA + " +k=1" + $f68f332138d52ff8$var$AV + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$BW + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$WB + " +k=1" + $f68f332138d52ff8$var$AV + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$BW + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Vw + " +k=1" + $f68f332138d52ff8$var$AV + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Vx + " +k=1" + $f68f332138d52ff8$var$AV + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Vy + " +k=1" + $f68f332138d52ff8$var$AV + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Vz + " +k=1" + $f68f332138d52ff8$var$AV + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$WA + " +k=1" + $f68f332138d52ff8$var$AV + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$WB + " +k=1" + $f68f332138d52ff8$var$AV + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$BP + $f68f332138d52ff8$var$m + " +lat_ts=-71" + $f68f332138d52ff8$var$HN + " +k=1" + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$BP + $f68f332138d52ff8$var$m + " +lat_ts=-71 +lon_0=70 +k=1" + $f68f332138d52ff8$var$Pk + $f68f332138d52ff8$var$Hh + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + " +lat_1=-68.5 +lat_2=-74.5 +lat_0=-50 +lon_0=70" + $f68f332138d52ff8$var$Pk + $f68f332138d52ff8$var$Hh + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Yw + $f68f332138d52ff8$var$QY + $f68f332138d52ff8$var$PU + $f68f332138d52ff8$var$Lu + $f68f332138d52ff8$var$LU + $f68f332138d52ff8$var$RU + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$He + $f68f332138d52ff8$var$PU + $f68f332138d52ff8$var$Lu + $f68f332138d52ff8$var$RV + $f68f332138d52ff8$var$RW + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Mf + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$j + $f68f332138d52ff8$var$KR + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$KD + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$j + $f68f332138d52ff8$var$KR + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    3,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ja + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$KA + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Oq + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$QD + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$JN + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$KC + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$NR + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ki + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Mf + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$KD + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    5,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Os + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$Jd + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$SL + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$Jd + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ja + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$Jd + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + " +lat_1=64.25 +lat_2=65.75 +lat_0=65 +lon_0=-19" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$Ae + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + " +lon_0=-8.5 +k=1" + $f68f332138d52ff8$var$Jm + " +y_0=-7800000" + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$Jz + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$II + $f68f332138d52ff8$var$AP + $f68f332138d52ff8$var$O + " +y_0=-6000000" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$MA + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$Qc + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ja + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$PI + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Os + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$Pt + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Os + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$Pa + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$JN + $f68f332138d52ff8$var$j + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$KC + $f68f332138d52ff8$var$j + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + " +lon_0=37" + $f68f332138d52ff8$var$UG + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$ZL + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$n + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ki + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$Ck + " +lat_0=52.41864827777778 +lon_0=13.62720366666667" + $f68f332138d52ff8$var$Of + " +y_0=10000" + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$AC + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Bu + $f68f332138d52ff8$var$AP + $f68f332138d52ff8$var$O + " +y_0=-4500000" + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Bu + $f68f332138d52ff8$var$AP + $f68f332138d52ff8$var$YF + $f68f332138d52ff8$var$Sh + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Bu + $f68f332138d52ff8$var$AP + $f68f332138d52ff8$var$YF + $f68f332138d52ff8$var$Sh + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$AL + $f68f332138d52ff8$var$Rf + $f68f332138d52ff8$var$JE + $f68f332138d52ff8$var$EW + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    2,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$BD + $f68f332138d52ff8$var$Rg + $f68f332138d52ff8$var$JE + $f68f332138d52ff8$var$AI + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$AL + $f68f332138d52ff8$var$Rf + $f68f332138d52ff8$var$JE + $f68f332138d52ff8$var$EW + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    2,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$BD + $f68f332138d52ff8$var$Rg + $f68f332138d52ff8$var$JE + $f68f332138d52ff8$var$AI + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$CU + $f68f332138d52ff8$var$Kr + " +lonc=-86" + $f68f332138d52ff8$var$QI + $f68f332138d52ff8$var$AP + $f68f332138d52ff8$var$QJ + $f68f332138d52ff8$var$PY + $f68f332138d52ff8$var$KE + $f68f332138d52ff8$var$QK + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$CU + $f68f332138d52ff8$var$Kr + " +lonc=-86" + $f68f332138d52ff8$var$QI + $f68f332138d52ff8$var$AP + $f68f332138d52ff8$var$QJ + $f68f332138d52ff8$var$PY + $f68f332138d52ff8$var$KE + $f68f332138d52ff8$var$QK + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$WC + $f68f332138d52ff8$var$WD + $f68f332138d52ff8$var$WE + $f68f332138d52ff8$var$CS + " +x_0=914400 +y_0=914400" + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$t + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$WC + $f68f332138d52ff8$var$WD + $f68f332138d52ff8$var$WE + $f68f332138d52ff8$var$CS + $f68f332138d52ff8$var$BZ + $f68f332138d52ff8$var$AH + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$OM + $f68f332138d52ff8$var$RO + $f68f332138d52ff8$var$OX + $f68f332138d52ff8$var$CS + $f68f332138d52ff8$var$AV + $f68f332138d52ff8$var$Ju + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$DT + $f68f332138d52ff8$var$OM + $f68f332138d52ff8$var$RO + $f68f332138d52ff8$var$OX + $f68f332138d52ff8$var$CS + $f68f332138d52ff8$var$AV + $f68f332138d52ff8$var$Hh + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$OM + $f68f332138d52ff8$var$RO + $f68f332138d52ff8$var$OX + $f68f332138d52ff8$var$CS + $f68f332138d52ff8$var$AV + $f68f332138d52ff8$var$Ju + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$DT + $f68f332138d52ff8$var$OM + $f68f332138d52ff8$var$RO + $f68f332138d52ff8$var$OX + $f68f332138d52ff8$var$CS + $f68f332138d52ff8$var$AV + $f68f332138d52ff8$var$Hh + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$DT + " +lat_1=24" + $f68f332138d52ff8$var$YG + " +lat_0=24" + $f68f332138d52ff8$var$NV + $f68f332138d52ff8$var$u + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$DT + " +lat_1=24" + $f68f332138d52ff8$var$YG + " +lat_0=24" + $f68f332138d52ff8$var$NV + $f68f332138d52ff8$var$u + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Fi + $f68f332138d52ff8$var$Fj + $f68f332138d52ff8$var$AB + $f68f332138d52ff8$var$EY + $f68f332138d52ff8$var$AV + $f68f332138d52ff8$var$AH + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Fi + $f68f332138d52ff8$var$Fj + $f68f332138d52ff8$var$AB + $f68f332138d52ff8$var$EY + $f68f332138d52ff8$var$AV + $f68f332138d52ff8$var$CN + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Fi + $f68f332138d52ff8$var$Fj + $f68f332138d52ff8$var$AB + $f68f332138d52ff8$var$EY + $f68f332138d52ff8$var$AV + $f68f332138d52ff8$var$AH + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Fi + $f68f332138d52ff8$var$Fj + $f68f332138d52ff8$var$AB + $f68f332138d52ff8$var$EY + $f68f332138d52ff8$var$AV + $f68f332138d52ff8$var$CN + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Mg + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$g + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$NT + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$g + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ot + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$g + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Nv + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$g + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$PM + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$g + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Mg + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$NT + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ot + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Nv + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$PM + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + " +lat_1=-14.26666666666667 +lat_0=-14.26666666666667" + $f68f332138d52ff8$var$SW + " +k_0=1" + $f68f332138d52ff8$var$e + " +y_0=95169.31165862332" + $f68f332138d52ff8$var$i + $f68f332138d52ff8$var$TC + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    4,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Hq + $f68f332138d52ff8$var$AP + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$By + $f68f332138d52ff8$var$Ay + $f68f332138d52ff8$var$RF + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + " +lat_1=-28" + $f68f332138d52ff8$var$ZT + " +lat_0=-32" + $f68f332138d52ff8$var$Fn + $f68f332138d52ff8$var$BZ + $f68f332138d52ff8$var$Cl + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$SS + " +lon_0=-2.416666666666667 +k=0.999997 +x_0=47000" + $f68f332138d52ff8$var$Rz + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=49.225 +lon_0=-2.135 +k=0.9999999000000001" + $f68f332138d52ff8$var$Of + " +y_0=70000" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + " +lat_1=-36 +lat_2=-38 +lat_0=-37 +lon_0=145" + $f68f332138d52ff8$var$Ci + $f68f332138d52ff8$var$Gb + $f68f332138d52ff8$var$x + $f68f332138d52ff8$var$r + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + " +lat_1=-36 +lat_2=-38 +lat_0=-37 +lon_0=145" + $f68f332138d52ff8$var$Ci + $f68f332138d52ff8$var$JH + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + " +lat_1=-18" + $f68f332138d52ff8$var$ZT + $f68f332138d52ff8$var$L + " +lon_0=134" + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=-28" + $f68f332138d52ff8$var$NY + $f68f332138d52ff8$var$Jl + $f68f332138d52ff8$var$Jm + $f68f332138d52ff8$var$EK + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Ie + " +lon_0=-80.07750791666666 +k=1" + $f68f332138d52ff8$var$BZ + $f68f332138d52ff8$var$AH + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Ie + " +lon_0=-77.07750791666666 +k=1" + $f68f332138d52ff8$var$BZ + $f68f332138d52ff8$var$AH + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Ie + " +lon_0=-74.07750791666666 +k=1" + $f68f332138d52ff8$var$BZ + $f68f332138d52ff8$var$AH + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Ie + " +lon_0=-71.07750791666666 +k=1" + $f68f332138d52ff8$var$BZ + $f68f332138d52ff8$var$AH + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Ie + " +lon_0=-68.07750791666666 +k=1" + $f68f332138d52ff8$var$BZ + $f68f332138d52ff8$var$AH + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$YH + " +k=0.999" + $f68f332138d52ff8$var$BZ + $f68f332138d52ff8$var$AH + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$Qe + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$GU + " +lat_0=50.625 +lon_0=21.08333333333333" + $f68f332138d52ff8$var$UG + " +x_0=4637000 +y_0=5467000" + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$b + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Fm + $f68f332138d52ff8$var$CP + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$i + $f68f332138d52ff8$var$BX + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$ZU + $f68f332138d52ff8$var$CP + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$i + $f68f332138d52ff8$var$BX + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$ZV + $f68f332138d52ff8$var$CP + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$i + $f68f332138d52ff8$var$BX + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Fr + $f68f332138d52ff8$var$CP + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$i + $f68f332138d52ff8$var$BX + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Ru + $f68f332138d52ff8$var$CP + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$i + $f68f332138d52ff8$var$BX + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$RI + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$UI + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Gl + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Yx + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$SP + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$II + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$RJ + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$UJ + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$HO + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$RP + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + " +lon_0=29 +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Ia + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$QQ + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    2,
    $f68f332138d52ff8$var$Ck + " +lat_0=-18 +lon_0=178 +x_0=109435.392 +y_0=141622.272" + $f68f332138d52ff8$var$UW + $f68f332138d52ff8$var$Ym + $f68f332138d52ff8$var$Nl + " +to_meter=0.201168" + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$PL + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$JD + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$SK + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$JD + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    6,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Mh + $f68f332138d52ff8$var$By + $f68f332138d52ff8$var$Ay + $f68f332138d52ff8$var$JP + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Mi + $f68f332138d52ff8$var$By + $f68f332138d52ff8$var$Ay + $f68f332138d52ff8$var$JP + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    3,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + " +lon_0=18.05779 +k=0.99999425 +x_0=100178.1808 +y_0=-6500614.7836" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$DT + $f68f332138d52ff8$var$Yv + " +lat_2=58.5" + $f68f332138d52ff8$var$IP + " +lon_0=-126" + $f68f332138d52ff8$var$BZ + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$RH + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$TW + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$TX + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$QE + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Nw + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$NP + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$NQ + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$YI + " +lat_2=53.5" + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$SA + " +x_0=930000 +y_0=6430000" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$YI + " +lat_2=53.5" + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$SA + " +x_0=930000 +y_0=6430000" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + " +lat_1=-20.66666666666667 +lat_2=-22.33333333333333 +lat_0=-21.5" + $f68f332138d52ff8$var$ZW + $f68f332138d52ff8$var$u + $f68f332138d52ff8$var$Hk + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$MA + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$j + $f68f332138d52ff8$var$QB + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + " +lat_1=-22.24469175 +lat_2=-22.29469175 +lat_0=-22.26969175 +lon_0=166.44242575 +x_0=0.66 +y_0=1.02" + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$HH + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + " +lat_1=-22.24472222222222 +lat_2=-22.29472222222222 +lat_0=-22.26972222222222 +lon_0=166.4425 +x_0=8.313000000000001 +y_0=-2.354" + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$HH + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$CU + $f68f332138d52ff8$var$Qi + $f68f332138d52ff8$var$aF + $f68f332138d52ff8$var$aT + $f68f332138d52ff8$var$Ph + $f68f332138d52ff8$var$Of + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$KE + $f68f332138d52ff8$var$GZ + $f68f332138d52ff8$var$Yn + $f68f332138d52ff8$var$Qz + " +to_meter=20.116756" + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$CU + $f68f332138d52ff8$var$Qi + $f68f332138d52ff8$var$aF + $f68f332138d52ff8$var$aT + $f68f332138d52ff8$var$Ph + " +x_0=804670.24" + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$KE + $f68f332138d52ff8$var$GZ + $f68f332138d52ff8$var$Yn + $f68f332138d52ff8$var$Qz + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$SM + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$MA + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Nq + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Nq + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$Jf + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    2,
    $f68f332138d52ff8$var$DT + " +lat_1=42.122774 +lat_2=49.01518 +lat_0=45.568977 +lon_0=-84.455955" + $f68f332138d52ff8$var$BZ + $f68f332138d52ff8$var$AH + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$DT + " +lat_1=42.122774 +lat_2=49.01518 +lat_0=45.568977 +lon_0=-83.248627" + $f68f332138d52ff8$var$BZ + $f68f332138d52ff8$var$AH + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$ZQ + $f68f332138d52ff8$var$AP + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$By + $f68f332138d52ff8$var$Ay + $f68f332138d52ff8$var$JP + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$UE + " +k=0.9965000000000001" + $f68f332138d52ff8$var$BZ + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$w + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$IC + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Hi + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Gz + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$ID + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Io + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$MB + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Nx + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Nr + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Os + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$SL + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ja + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$KA + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$KB + $f68f332138d52ff8$var$CP + $f68f332138d52ff8$var$h + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$w + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + " +lon_0=11" + $f68f332138d52ff8$var$CP + $f68f332138d52ff8$var$h + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$w + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + " +lon_0=13" + $f68f332138d52ff8$var$CP + $f68f332138d52ff8$var$h + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$w + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Gj + $f68f332138d52ff8$var$CP + $f68f332138d52ff8$var$h + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$w + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$UE + $f68f332138d52ff8$var$CP + $f68f332138d52ff8$var$h + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$w + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$RI + $f68f332138d52ff8$var$CP + $f68f332138d52ff8$var$h + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$w + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Gl + $f68f332138d52ff8$var$CP + $f68f332138d52ff8$var$h + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$w + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$SP + $f68f332138d52ff8$var$CP + $f68f332138d52ff8$var$h + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$w + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$RJ + $f68f332138d52ff8$var$CP + $f68f332138d52ff8$var$h + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$w + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$JN + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$w + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Qq + $f68f332138d52ff8$var$Li + $f68f332138d52ff8$var$JS + $f68f332138d52ff8$var$PZ + $f68f332138d52ff8$var$AV + $f68f332138d52ff8$var$aG + $f68f332138d52ff8$var$c + $f68f332138d52ff8$var$QC + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$KC + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$w + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$NR + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$w + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ki + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$w + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Om + $f68f332138d52ff8$var$On + $f68f332138d52ff8$var$m + $f68f332138d52ff8$var$Pe + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Om + $f68f332138d52ff8$var$On + $f68f332138d52ff8$var$m + $f68f332138d52ff8$var$Nb + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Om + $f68f332138d52ff8$var$On + $f68f332138d52ff8$var$m + " +lon_0=-42" + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$BQ + $f68f332138d52ff8$var$BR + $f68f332138d52ff8$var$m + $f68f332138d52ff8$var$SU + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$BQ + $f68f332138d52ff8$var$BR + $f68f332138d52ff8$var$m + $f68f332138d52ff8$var$Pe + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$BQ + $f68f332138d52ff8$var$BR + $f68f332138d52ff8$var$m + $f68f332138d52ff8$var$Nb + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$BQ + $f68f332138d52ff8$var$BR + $f68f332138d52ff8$var$m + $f68f332138d52ff8$var$PO + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$BQ + $f68f332138d52ff8$var$BR + $f68f332138d52ff8$var$m + $f68f332138d52ff8$var$SR + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$BQ + $f68f332138d52ff8$var$BR + $f68f332138d52ff8$var$m + $f68f332138d52ff8$var$UH + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$BQ + $f68f332138d52ff8$var$BR + $f68f332138d52ff8$var$m + $f68f332138d52ff8$var$Lt + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$BQ + $f68f332138d52ff8$var$BR + $f68f332138d52ff8$var$m + $f68f332138d52ff8$var$Hq + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$BQ + $f68f332138d52ff8$var$BR + $f68f332138d52ff8$var$m + $f68f332138d52ff8$var$Jj + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$BQ + $f68f332138d52ff8$var$BR + $f68f332138d52ff8$var$m + $f68f332138d52ff8$var$Im + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$BQ + $f68f332138d52ff8$var$BR + $f68f332138d52ff8$var$m + $f68f332138d52ff8$var$Jk + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$BQ + $f68f332138d52ff8$var$BR + $f68f332138d52ff8$var$m + $f68f332138d52ff8$var$Rx + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$BQ + $f68f332138d52ff8$var$BR + $f68f332138d52ff8$var$m + $f68f332138d52ff8$var$Oe + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$BQ + $f68f332138d52ff8$var$BR + $f68f332138d52ff8$var$m + $f68f332138d52ff8$var$Ql + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$AM + $f68f332138d52ff8$var$AN + $f68f332138d52ff8$var$m + " +lon_0=-102" + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$AM + $f68f332138d52ff8$var$AN + $f68f332138d52ff8$var$m + $f68f332138d52ff8$var$Bu + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$AM + $f68f332138d52ff8$var$AN + $f68f332138d52ff8$var$m + " +lon_0=-78" + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$AM + $f68f332138d52ff8$var$AN + $f68f332138d52ff8$var$m + $f68f332138d52ff8$var$Pe + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$AM + $f68f332138d52ff8$var$AN + $f68f332138d52ff8$var$m + " +lon_0=-18" + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$AM + $f68f332138d52ff8$var$AN + $f68f332138d52ff8$var$m + " +lon_0=-6" + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$AM + $f68f332138d52ff8$var$AN + $f68f332138d52ff8$var$m + $f68f332138d52ff8$var$ZO + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$AM + $f68f332138d52ff8$var$AN + $f68f332138d52ff8$var$m + $f68f332138d52ff8$var$QR + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$AM + $f68f332138d52ff8$var$AN + $f68f332138d52ff8$var$m + $f68f332138d52ff8$var$Ia + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$AM + $f68f332138d52ff8$var$AN + $f68f332138d52ff8$var$m + $f68f332138d52ff8$var$PO + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$AM + $f68f332138d52ff8$var$AN + $f68f332138d52ff8$var$m + $f68f332138d52ff8$var$SR + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$AM + $f68f332138d52ff8$var$AN + $f68f332138d52ff8$var$m + $f68f332138d52ff8$var$UH + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$AM + $f68f332138d52ff8$var$AN + $f68f332138d52ff8$var$m + $f68f332138d52ff8$var$Lt + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$AM + $f68f332138d52ff8$var$AN + $f68f332138d52ff8$var$m + $f68f332138d52ff8$var$Hq + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$AM + $f68f332138d52ff8$var$AN + $f68f332138d52ff8$var$m + $f68f332138d52ff8$var$Jj + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$AM + $f68f332138d52ff8$var$AN + $f68f332138d52ff8$var$m + $f68f332138d52ff8$var$Im + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$AM + $f68f332138d52ff8$var$AN + $f68f332138d52ff8$var$m + $f68f332138d52ff8$var$Jk + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$AM + $f68f332138d52ff8$var$AN + $f68f332138d52ff8$var$m + $f68f332138d52ff8$var$Rx + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$AM + $f68f332138d52ff8$var$AN + $f68f332138d52ff8$var$m + $f68f332138d52ff8$var$Oe + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$AM + $f68f332138d52ff8$var$AN + $f68f332138d52ff8$var$m + $f68f332138d52ff8$var$Ql + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$AM + $f68f332138d52ff8$var$AN + $f68f332138d52ff8$var$m + $f68f332138d52ff8$var$UP + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Ah + $f68f332138d52ff8$var$AZ + $f68f332138d52ff8$var$m + $f68f332138d52ff8$var$YJ + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Ah + $f68f332138d52ff8$var$AZ + $f68f332138d52ff8$var$m + $f68f332138d52ff8$var$YK + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Ah + $f68f332138d52ff8$var$AZ + $f68f332138d52ff8$var$m + $f68f332138d52ff8$var$Lj + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Ah + $f68f332138d52ff8$var$AZ + $f68f332138d52ff8$var$m + $f68f332138d52ff8$var$Ji + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Ah + $f68f332138d52ff8$var$AZ + $f68f332138d52ff8$var$m + $f68f332138d52ff8$var$CR + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Ah + $f68f332138d52ff8$var$AZ + $f68f332138d52ff8$var$m + $f68f332138d52ff8$var$Qk + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Ah + $f68f332138d52ff8$var$AZ + $f68f332138d52ff8$var$m + " +lon_0=-27" + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Ah + $f68f332138d52ff8$var$AZ + $f68f332138d52ff8$var$m + " +lon_0=-9" + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Ah + $f68f332138d52ff8$var$AZ + $f68f332138d52ff8$var$m + $f68f332138d52ff8$var$KB + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Ah + $f68f332138d52ff8$var$AZ + $f68f332138d52ff8$var$m + $f68f332138d52ff8$var$HO + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Ah + $f68f332138d52ff8$var$AZ + $f68f332138d52ff8$var$m + $f68f332138d52ff8$var$JS + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Ah + $f68f332138d52ff8$var$AZ + $f68f332138d52ff8$var$m + $f68f332138d52ff8$var$QW + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Ah + $f68f332138d52ff8$var$AZ + $f68f332138d52ff8$var$m + $f68f332138d52ff8$var$HQ + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Ah + $f68f332138d52ff8$var$AZ + $f68f332138d52ff8$var$m + $f68f332138d52ff8$var$HS + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Ah + $f68f332138d52ff8$var$AZ + $f68f332138d52ff8$var$m + $f68f332138d52ff8$var$Fm + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Ah + $f68f332138d52ff8$var$AZ + $f68f332138d52ff8$var$m + $f68f332138d52ff8$var$Fn + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Ah + $f68f332138d52ff8$var$AZ + $f68f332138d52ff8$var$m + $f68f332138d52ff8$var$NY + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Ah + $f68f332138d52ff8$var$AZ + $f68f332138d52ff8$var$m + $f68f332138d52ff8$var$Lf + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Ai + $f68f332138d52ff8$var$Aj + $f68f332138d52ff8$var$m + $f68f332138d52ff8$var$SV + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Ai + $f68f332138d52ff8$var$Aj + $f68f332138d52ff8$var$m + " +lon_0=-144" + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Ai + $f68f332138d52ff8$var$Aj + $f68f332138d52ff8$var$m + $f68f332138d52ff8$var$Mt + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Ai + $f68f332138d52ff8$var$Aj + $f68f332138d52ff8$var$m + $f68f332138d52ff8$var$OZ + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Ai + $f68f332138d52ff8$var$Aj + $f68f332138d52ff8$var$m + $f68f332138d52ff8$var$UQ + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Ai + $f68f332138d52ff8$var$Aj + $f68f332138d52ff8$var$m + " +lon_0=-48" + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Ai + $f68f332138d52ff8$var$Aj + $f68f332138d52ff8$var$m + " +lon_0=-24" + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Ai + $f68f332138d52ff8$var$Aj + $f68f332138d52ff8$var$m + $f68f332138d52ff8$var$HN + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Ai + $f68f332138d52ff8$var$Aj + $f68f332138d52ff8$var$m + $f68f332138d52ff8$var$II + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Ai + $f68f332138d52ff8$var$Aj + $f68f332138d52ff8$var$m + $f68f332138d52ff8$var$SQ + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Ai + $f68f332138d52ff8$var$Aj + $f68f332138d52ff8$var$m + $f68f332138d52ff8$var$Yt + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Ai + $f68f332138d52ff8$var$Aj + $f68f332138d52ff8$var$m + $f68f332138d52ff8$var$Mj + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Ai + $f68f332138d52ff8$var$Aj + $f68f332138d52ff8$var$m + $f68f332138d52ff8$var$KF + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Ai + $f68f332138d52ff8$var$Aj + $f68f332138d52ff8$var$m + $f68f332138d52ff8$var$UN + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Ai + $f68f332138d52ff8$var$Aj + $f68f332138d52ff8$var$m + $f68f332138d52ff8$var$UO + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$BP + $f68f332138d52ff8$var$m + $f68f332138d52ff8$var$AW + $f68f332138d52ff8$var$SX + " +k=1" + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$BP + $f68f332138d52ff8$var$m + $f68f332138d52ff8$var$AW + $f68f332138d52ff8$var$YK + " +k=1" + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$BP + $f68f332138d52ff8$var$m + $f68f332138d52ff8$var$AW + " +lon_0=-105 +k=1" + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$BP + $f68f332138d52ff8$var$m + $f68f332138d52ff8$var$AW + $f68f332138d52ff8$var$UR + " +k=1" + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$BP + $f68f332138d52ff8$var$m + $f68f332138d52ff8$var$AW + " +lon_0=-45 +k=1" + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$BP + $f68f332138d52ff8$var$m + $f68f332138d52ff8$var$AW + " +lon_0=-15 +k=1" + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$BP + $f68f332138d52ff8$var$m + $f68f332138d52ff8$var$AW + $f68f332138d52ff8$var$Gj + " +k=1" + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$BP + $f68f332138d52ff8$var$m + $f68f332138d52ff8$var$AW + $f68f332138d52ff8$var$JS + " +k=1" + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$BP + $f68f332138d52ff8$var$m + $f68f332138d52ff8$var$AW + $f68f332138d52ff8$var$HP + " +k=1" + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$BP + $f68f332138d52ff8$var$m + $f68f332138d52ff8$var$AW + $f68f332138d52ff8$var$EN + " +k=1" + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$BP + $f68f332138d52ff8$var$m + $f68f332138d52ff8$var$AW + $f68f332138d52ff8$var$Fn + " +k=1" + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$BP + $f68f332138d52ff8$var$m + $f68f332138d52ff8$var$AW + $f68f332138d52ff8$var$NZ + " +k=1" + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$BP + $f68f332138d52ff8$var$m + $f68f332138d52ff8$var$AW + $f68f332138d52ff8$var$ON + " +k=1" + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$BP + $f68f332138d52ff8$var$m + $f68f332138d52ff8$var$AW + $f68f332138d52ff8$var$Bu + " +k=1" + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$BP + $f68f332138d52ff8$var$m + $f68f332138d52ff8$var$AW + " +lon_0=-30 +k=1" + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$BP + $f68f332138d52ff8$var$m + $f68f332138d52ff8$var$AW + $f68f332138d52ff8$var$Ia + " +k=1" + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$BP + $f68f332138d52ff8$var$m + $f68f332138d52ff8$var$AW + $f68f332138d52ff8$var$Hq + " +k=1" + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$BP + $f68f332138d52ff8$var$m + $f68f332138d52ff8$var$AW + $f68f332138d52ff8$var$Oe + " +k=1" + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$BP + $f68f332138d52ff8$var$m + $f68f332138d52ff8$var$AW + $f68f332138d52ff8$var$HN + " +k=1" + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Ai + $f68f332138d52ff8$var$Aj + " +lat_0=-78" + $f68f332138d52ff8$var$Ql + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    2,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$RG + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$Bm + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ro + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$Bm + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$RH + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$Bm + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$TW + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$Bm + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$WF + " +lat_2=58" + $f68f332138d52ff8$var$WG + $f68f332138d52ff8$var$II + $f68f332138d52ff8$var$O + " +y_0=6375000" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$Lw + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$WF + " +lat_2=58" + $f68f332138d52ff8$var$WG + $f68f332138d52ff8$var$II + $f68f332138d52ff8$var$O + " +y_0=6375000" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$RH + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$Lq + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$RH + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$Kc + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ro + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$Kg + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ro + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$Kh + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$RG + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$QN + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$JM + $f68f332138d52ff8$var$j + $f68f332138d52ff8$var$TD + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + " +lat_1=-30.75 +lat_2=-35.75 +lat_0=-33.25" + $f68f332138d52ff8$var$Od + " +x_0=9300000" + $f68f332138d52ff8$var$Gb + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$DT + $f68f332138d52ff8$var$Yy + $f68f332138d52ff8$var$SY + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Mt + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$QZ + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$DT + $f68f332138d52ff8$var$Yy + $f68f332138d52ff8$var$SY + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Mt + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$QZ + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$DT + $f68f332138d52ff8$var$Yy + $f68f332138d52ff8$var$SY + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Mt + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$QZ + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$ID + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$NH + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$ID + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    3,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Yx + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$Ak + $f68f332138d52ff8$var$c + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$II + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$Ak + $f68f332138d52ff8$var$c + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$IH + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$Ak + $f68f332138d52ff8$var$c + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + " +lon_0=14" + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$Ak + $f68f332138d52ff8$var$c + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + " +lon_0=16" + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$Ak + $f68f332138d52ff8$var$c + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$QR + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$Ak + $f68f332138d52ff8$var$c + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$UI + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$Ak + $f68f332138d52ff8$var$c + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Yx + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$Ak + $f68f332138d52ff8$var$c + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$II + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$Ak + $f68f332138d52ff8$var$c + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$UJ + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$Ak + $f68f332138d52ff8$var$c + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$RP + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$Ak + $f68f332138d52ff8$var$c + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Ia + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$Ak + $f68f332138d52ff8$var$c + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$GU + " +lat_0=52.16666666666666 +lon_0=19.16666666666667 +k=0.999714" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$Ae + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$b + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Gj + " +k=1" + $f68f332138d52ff8$var$Eg + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$b + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$QR + " +k=1" + $f68f332138d52ff8$var$Jt + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$b + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Gl + " +k=1" + $f68f332138d52ff8$var$IM + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$b + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$II + " +k=1" + $f68f332138d52ff8$var$MS + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$b + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Gj + " +k=1" + $f68f332138d52ff8$var$Bo + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$b + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Gl + " +k=1" + $f68f332138d52ff8$var$DP + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$b + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$HO + " +k=1" + $f68f332138d52ff8$var$Eg + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$b + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Rc + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$TE + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + " +lat_1=-20.19506944444445 +lat_0=-20.19506944444445 +lon_0=57.52182777777778 +k_0=1" + $f68f332138d52ff8$var$BZ + $f68f332138d52ff8$var$AH + $f68f332138d52ff8$var$c + $f68f332138d52ff8$var$Qf + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$DT + " +lat_1=55" + $f68f332138d52ff8$var$QY + $f68f332138d52ff8$var$Yu + $f68f332138d52ff8$var$Ms + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$IH + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$Ak + $f68f332138d52ff8$var$c + $f68f332138d52ff8$var$GN + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + " +lon_0=14" + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$Ak + $f68f332138d52ff8$var$c + $f68f332138d52ff8$var$GN + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + " +lon_0=16" + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$Ak + $f68f332138d52ff8$var$c + $f68f332138d52ff8$var$GN + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$KC + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$c + $f68f332138d52ff8$var$GN + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ja + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$KA + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Oq + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$II + $f68f332138d52ff8$var$UG + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$LM + $f68f332138d52ff8$var$IJ + " +lat_0=63.390675" + $f68f332138d52ff8$var$UY + " +x_0=6200000" + $f68f332138d52ff8$var$Fq + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$LM + $f68f332138d52ff8$var$IJ + " +lat_0=63.390675" + $f68f332138d52ff8$var$UY + " +x_0=6200000" + $f68f332138d52ff8$var$Fq + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    2,
    $f68f332138d52ff8$var$D + " +lat_0=0.1 +lon_0=21.95 +k=1" + $f68f332138d52ff8$var$Bv + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=0.1 +lon_0=24.95 +k=1 +x_0=1250000" + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=0.1 +lon_0=27.95 +k=1 +x_0=2250000" + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$JN + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$JN + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Gm + $f68f332138d52ff8$var$QQ + " +k=1 +x_0=615000 +y_0=810000" + $f68f332138d52ff8$var$Gn + $f68f332138d52ff8$var$Qg + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    3,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Et + $f68f332138d52ff8$var$Eu + $f68f332138d52ff8$var$LT + $f68f332138d52ff8$var$NW + $f68f332138d52ff8$var$Rh + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    2,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$FC + $f68f332138d52ff8$var$OD + $f68f332138d52ff8$var$Dr + $f68f332138d52ff8$var$CR + $f68f332138d52ff8$var$OE + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$FC + $f68f332138d52ff8$var$OD + $f68f332138d52ff8$var$Dr + $f68f332138d52ff8$var$CR + $f68f332138d52ff8$var$OE + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$t + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$MW + $f68f332138d52ff8$var$FB + $f68f332138d52ff8$var$BB + $f68f332138d52ff8$var$Ea + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$MW + $f68f332138d52ff8$var$FB + $f68f332138d52ff8$var$BB + $f68f332138d52ff8$var$Ea + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Dp + $f68f332138d52ff8$var$Dq + $f68f332138d52ff8$var$y + $f68f332138d52ff8$var$Ea + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Dp + $f68f332138d52ff8$var$Dq + $f68f332138d52ff8$var$y + $f68f332138d52ff8$var$Ea + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    2,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ja + $f68f332138d52ff8$var$c + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$KA + $f68f332138d52ff8$var$c + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Oq + $f68f332138d52ff8$var$c + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Nq + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$PL + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Nq + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$PL + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$KA + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$CU + $f68f332138d52ff8$var$Qi + $f68f332138d52ff8$var$aF + " +alpha=323.0257964666666" + $f68f332138d52ff8$var$Ph + " +x_0=804671" + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$KE + $f68f332138d52ff8$var$GZ + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$CU + $f68f332138d52ff8$var$Qi + $f68f332138d52ff8$var$Yz + $f68f332138d52ff8$var$aU + $f68f332138d52ff8$var$Ph + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$KE + $f68f332138d52ff8$var$If + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$Ck + " +lat_0=2.121679744444445 +lon_0=103.4279362361111 +x_0=-14810.562 +y_0=8758.32" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$Ck + " +lat_0=2.682347636111111 +lon_0=101.9749050416667 +x_0=3673.785 +y_0=-4240.573" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$Ck + " +lat_0=3.769388088888889 +lon_0=102.3682989833333 +x_0=-7368.228 +y_0=6485.858" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$Ck + " +lat_0=3.68464905 +lon_0=101.3891079138889 +x_0=-34836.161 +y_0=56464.049" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$Ck + " +lat_0=4.9762852 +lon_0=103.070275625 +x_0=19594.245 +y_0=3371.895" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$Ck + " +lat_0=5.421517541666667 +lon_0=100.3443769638889 +x_0=-23.414 +y_0=62.283" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$Ck + " +lat_0=5.964672713888889 +lon_0=100.6363711111111" + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$Ck + " +lat_0=4.859063022222222 +lon_0=100.8154105861111 +x_0=-1.769 +y_0=133454.779" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$Ck + " +lat_0=5.972543658333334 +lon_0=102.2952416694444 +x_0=13227.851 +y_0=8739.894" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$QR + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$At + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$IG + " +k=1" + $f68f332138d52ff8$var$Eg + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$At + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$JU + $f68f332138d52ff8$var$PS + " +lat_ts=42" + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Ry + " +k=1 +x_0=60500000" + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Ry + " +k=1 +x_0=60500000" + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$KD + $f68f332138d52ff8$var$c + $f68f332138d52ff8$var$EU + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$JZ + $f68f332138d52ff8$var$c + $f68f332138d52ff8$var$EU + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$JM + $f68f332138d52ff8$var$c + $f68f332138d52ff8$var$EU + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Qq + $f68f332138d52ff8$var$Li + $f68f332138d52ff8$var$JS + $f68f332138d52ff8$var$PZ + $f68f332138d52ff8$var$AV + $f68f332138d52ff8$var$aG + $f68f332138d52ff8$var$c + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$JU + $f68f332138d52ff8$var$HN + " +k=1" + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$KB + " +k=1" + $f68f332138d52ff8$var$Bo + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$IH + " +k=1" + $f68f332138d52ff8$var$DP + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$IH + " +k=1" + $f68f332138d52ff8$var$DP + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Gj + " +k=1" + $f68f332138d52ff8$var$Eg + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$SZ + " +k=0.9992" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$SZ + " +k=0.9992" + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$SZ + " +k=0.9992" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$SZ + " +k=0.9992" + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Et + $f68f332138d52ff8$var$Eu + $f68f332138d52ff8$var$LT + $f68f332138d52ff8$var$NW + $f68f332138d52ff8$var$Z + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Mh + $f68f332138d52ff8$var$j + $f68f332138d52ff8$var$Fu + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Mi + $f68f332138d52ff8$var$j + $f68f332138d52ff8$var$Fu + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$Ck + $f68f332138d52ff8$var$Vt + $f68f332138d52ff8$var$Vu + " +x_0=40243.57775604237 +y_0=19069.93351512578" + $f68f332138d52ff8$var$Ee + $f68f332138d52ff8$var$Ef + $f68f332138d52ff8$var$ML + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$He + $f68f332138d52ff8$var$Hr + $f68f332138d52ff8$var$HN + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$ZX + $f68f332138d52ff8$var$ZY + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$He + $f68f332138d52ff8$var$m + $f68f332138d52ff8$var$HN + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$ZX + $f68f332138d52ff8$var$ZY + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    "+proj=cea" + $f68f332138d52ff8$var$HN + " +lat_ts=30" + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$ZX + $f68f332138d52ff8$var$ZY + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$BP + $f68f332138d52ff8$var$Hr + " +lat_ts=70 +lon_0=-45 +k=1" + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$ZZ + $f68f332138d52ff8$var$Ri + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$BP + $f68f332138d52ff8$var$m + " +lat_ts=-70" + $f68f332138d52ff8$var$HN + " +k=1" + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$ZZ + $f68f332138d52ff8$var$Ri + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$BP + $f68f332138d52ff8$var$Hr + " +lat_ts=70 +lon_0=-45 +k=1" + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=1.366666666666667 +lon_0=103.8333333333333 +k=1 +x_0=28001.642 +y_0=38744.572" + $f68f332138d52ff8$var$j + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + " +lat_1=18 +lat_2=24 +lat_0=21" + $f68f332138d52ff8$var$Im + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$Ae + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$Q + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$LM + $f68f332138d52ff8$var$Nh + " +lat_0=47.5" + $f68f332138d52ff8$var$Ig + $f68f332138d52ff8$var$u + $f68f332138d52ff8$var$Is + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$EB + $f68f332138d52ff8$var$EC + $f68f332138d52ff8$var$Fo + $f68f332138d52ff8$var$GG + $f68f332138d52ff8$var$AV + $f68f332138d52ff8$var$GJ + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$AY + $f68f332138d52ff8$var$ED + $f68f332138d52ff8$var$Fs + $f68f332138d52ff8$var$GG + $f68f332138d52ff8$var$AG + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$EE + $f68f332138d52ff8$var$EF + $f68f332138d52ff8$var$AQ + $f68f332138d52ff8$var$Fl + $f68f332138d52ff8$var$Au + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$EG + $f68f332138d52ff8$var$EH + $f68f332138d52ff8$var$f + $f68f332138d52ff8$var$CV + $f68f332138d52ff8$var$Au + $f68f332138d52ff8$var$Gt + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$CQ + $f68f332138d52ff8$var$DF + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$Gu + $f68f332138d52ff8$var$MN + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$CQ + $f68f332138d52ff8$var$DG + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$AG + $f68f332138d52ff8$var$Hh + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$CQ + $f68f332138d52ff8$var$DH + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$An + $f68f332138d52ff8$var$NE + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$BA + $f68f332138d52ff8$var$Gp + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$Bn + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$EB + $f68f332138d52ff8$var$EC + $f68f332138d52ff8$var$Fo + $f68f332138d52ff8$var$GG + $f68f332138d52ff8$var$AV + $f68f332138d52ff8$var$GJ + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$AY + $f68f332138d52ff8$var$ED + $f68f332138d52ff8$var$Fs + $f68f332138d52ff8$var$GG + $f68f332138d52ff8$var$AG + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$EE + $f68f332138d52ff8$var$EF + $f68f332138d52ff8$var$AQ + $f68f332138d52ff8$var$Fl + $f68f332138d52ff8$var$Au + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$EG + $f68f332138d52ff8$var$EH + $f68f332138d52ff8$var$f + $f68f332138d52ff8$var$CV + $f68f332138d52ff8$var$Au + $f68f332138d52ff8$var$Gt + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$CQ + $f68f332138d52ff8$var$DF + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$Gu + $f68f332138d52ff8$var$MN + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$CQ + $f68f332138d52ff8$var$DG + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$AG + $f68f332138d52ff8$var$Hh + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$CQ + $f68f332138d52ff8$var$DH + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$An + $f68f332138d52ff8$var$NE + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$BA + $f68f332138d52ff8$var$Gp + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$Bn + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Dx + $f68f332138d52ff8$var$Dy + $f68f332138d52ff8$var$BC + $f68f332138d52ff8$var$IF + $f68f332138d52ff8$var$Au + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Dz + $f68f332138d52ff8$var$Mq + $f68f332138d52ff8$var$EA + $f68f332138d52ff8$var$IF + $f68f332138d52ff8$var$Au + $f68f332138d52ff8$var$Gt + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$f + $f68f332138d52ff8$var$Cz + $f68f332138d52ff8$var$EQ + $f68f332138d52ff8$var$BF + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$f + $f68f332138d52ff8$var$DA + $f68f332138d52ff8$var$Am + $f68f332138d52ff8$var$MO + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Fp + $f68f332138d52ff8$var$DI + $f68f332138d52ff8$var$AO + $f68f332138d52ff8$var$BF + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$EI + $f68f332138d52ff8$var$GE + $f68f332138d52ff8$var$Lb + $f68f332138d52ff8$var$JV + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$JM + $f68f332138d52ff8$var$c + $f68f332138d52ff8$var$Gg + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Me + $f68f332138d52ff8$var$c + $f68f332138d52ff8$var$Gg + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Dx + $f68f332138d52ff8$var$Dy + $f68f332138d52ff8$var$BC + $f68f332138d52ff8$var$IF + $f68f332138d52ff8$var$Au + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Dz + $f68f332138d52ff8$var$Mq + $f68f332138d52ff8$var$EA + $f68f332138d52ff8$var$IF + $f68f332138d52ff8$var$Au + $f68f332138d52ff8$var$Gt + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$f + $f68f332138d52ff8$var$Cz + $f68f332138d52ff8$var$EQ + $f68f332138d52ff8$var$BF + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$f + $f68f332138d52ff8$var$DA + $f68f332138d52ff8$var$Am + $f68f332138d52ff8$var$MO + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Fp + $f68f332138d52ff8$var$DI + $f68f332138d52ff8$var$AO + $f68f332138d52ff8$var$BF + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$EI + $f68f332138d52ff8$var$GE + $f68f332138d52ff8$var$Lb + $f68f332138d52ff8$var$JV + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Ks + $f68f332138d52ff8$var$Kt + " +lat_0=50.797815" + $f68f332138d52ff8$var$WH + " +x_0=150328 +y_0=166262" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + " +lat_1=18" + $f68f332138d52ff8$var$OX + $f68f332138d52ff8$var$Ld + " +k_0=1" + $f68f332138d52ff8$var$YL + " +y_0=650000" + $f68f332138d52ff8$var$j + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ik + $f68f332138d52ff8$var$j + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$IC + $f68f332138d52ff8$var$j + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$FS + $f68f332138d52ff8$var$FT + $f68f332138d52ff8$var$IY + $f68f332138d52ff8$var$Hg + $f68f332138d52ff8$var$Eb + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$OH + $f68f332138d52ff8$var$OI + $f68f332138d52ff8$var$OJ + $f68f332138d52ff8$var$Bi + $f68f332138d52ff8$var$Eb + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$CD + $f68f332138d52ff8$var$CE + " +lat_0=25.5" + $f68f332138d52ff8$var$Bi + $f68f332138d52ff8$var$Eb + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    2,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$OL + $f68f332138d52ff8$var$Ff + $f68f332138d52ff8$var$EJ + $f68f332138d52ff8$var$Ag + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$FS + $f68f332138d52ff8$var$FT + $f68f332138d52ff8$var$IY + $f68f332138d52ff8$var$Hg + $f68f332138d52ff8$var$Eb + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$OH + $f68f332138d52ff8$var$OI + $f68f332138d52ff8$var$OJ + $f68f332138d52ff8$var$Bi + $f68f332138d52ff8$var$Eb + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Fd + $f68f332138d52ff8$var$Fe + $f68f332138d52ff8$var$AL + $f68f332138d52ff8$var$CS + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$OL + $f68f332138d52ff8$var$Ff + $f68f332138d52ff8$var$EJ + $f68f332138d52ff8$var$Ag + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=-17 +lon_0=178.75 +k=0.99985" + $f68f332138d52ff8$var$Bd + $f68f332138d52ff8$var$LV + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$P + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ja + $f68f332138d52ff8$var$AU + $f68f332138d52ff8$var$BN + $f68f332138d52ff8$var$Nm + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$KA + $f68f332138d52ff8$var$AU + $f68f332138d52ff8$var$BN + $f68f332138d52ff8$var$Nm + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$YM + $f68f332138d52ff8$var$Rj + $f68f332138d52ff8$var$JE + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$YM + $f68f332138d52ff8$var$Rj + $f68f332138d52ff8$var$JE + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$IY + $f68f332138d52ff8$var$IV + $f68f332138d52ff8$var$Pc + $f68f332138d52ff8$var$h + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Gm + $f68f332138d52ff8$var$OS + $f68f332138d52ff8$var$BG + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$DT + " +lat_1=55" + $f68f332138d52ff8$var$QY + $f68f332138d52ff8$var$Yu + $f68f332138d52ff8$var$Ms + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$CU + " +lat_0=57" + $f68f332138d52ff8$var$Ku + $f68f332138d52ff8$var$Kv + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$LX + $f68f332138d52ff8$var$EO + $f68f332138d52ff8$var$KE + $f68f332138d52ff8$var$GZ + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Ft + $f68f332138d52ff8$var$YN + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Ft + $f68f332138d52ff8$var$YO + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Ft + $f68f332138d52ff8$var$ON + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Ft + $f68f332138d52ff8$var$Ms + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Ft + $f68f332138d52ff8$var$KI + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Ft + $f68f332138d52ff8$var$YP + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Ft + $f68f332138d52ff8$var$YQ + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Ft + $f68f332138d52ff8$var$SW + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Kw + $f68f332138d52ff8$var$Kx + $f68f332138d52ff8$var$UK + $f68f332138d52ff8$var$YR + $f68f332138d52ff8$var$BZ + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Bl + $f68f332138d52ff8$var$Co + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$EX + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Bl + $f68f332138d52ff8$var$Co + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$EX + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$t + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Bl + $f68f332138d52ff8$var$Cn + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$EX + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Bl + $f68f332138d52ff8$var$Cn + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$EX + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$t + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Bl + $f68f332138d52ff8$var$Iv + $f68f332138d52ff8$var$BG + $f68f332138d52ff8$var$EX + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Bl + $f68f332138d52ff8$var$Iv + $f68f332138d52ff8$var$BG + $f68f332138d52ff8$var$EX + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$t + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Dx + $f68f332138d52ff8$var$Dy + $f68f332138d52ff8$var$BC + $f68f332138d52ff8$var$IF + $f68f332138d52ff8$var$u + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Dx + $f68f332138d52ff8$var$Dy + $f68f332138d52ff8$var$BC + $f68f332138d52ff8$var$IF + $f68f332138d52ff8$var$Au + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Dz + $f68f332138d52ff8$var$Mq + $f68f332138d52ff8$var$EA + $f68f332138d52ff8$var$IF + $f68f332138d52ff8$var$u + $f68f332138d52ff8$var$Is + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Dz + $f68f332138d52ff8$var$Mq + $f68f332138d52ff8$var$EA + $f68f332138d52ff8$var$IF + $f68f332138d52ff8$var$Au + $f68f332138d52ff8$var$Gt + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$DT + $f68f332138d52ff8$var$Yy + $f68f332138d52ff8$var$SY + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Mt + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$QZ + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$DW + $f68f332138d52ff8$var$Jn + $f68f332138d52ff8$var$y + $f68f332138d52ff8$var$HA + $f68f332138d52ff8$var$Bd + $f68f332138d52ff8$var$Ae + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$DW + $f68f332138d52ff8$var$Jn + $f68f332138d52ff8$var$y + $f68f332138d52ff8$var$HA + $f68f332138d52ff8$var$Ac + $f68f332138d52ff8$var$AD + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$DX + $f68f332138d52ff8$var$DY + $f68f332138d52ff8$var$AA + $f68f332138d52ff8$var$HA + $f68f332138d52ff8$var$Bd + $f68f332138d52ff8$var$Ae + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$DX + $f68f332138d52ff8$var$DY + $f68f332138d52ff8$var$AA + $f68f332138d52ff8$var$HA + $f68f332138d52ff8$var$Ac + $f68f332138d52ff8$var$AD + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Ap + $f68f332138d52ff8$var$DZ + $f68f332138d52ff8$var$Ml + $f68f332138d52ff8$var$AJ + $f68f332138d52ff8$var$Bd + $f68f332138d52ff8$var$Ae + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Ap + $f68f332138d52ff8$var$DZ + $f68f332138d52ff8$var$Ml + $f68f332138d52ff8$var$AJ + $f68f332138d52ff8$var$Ac + $f68f332138d52ff8$var$AD + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$LO + $f68f332138d52ff8$var$QS + $f68f332138d52ff8$var$Da + $f68f332138d52ff8$var$Mm + $f68f332138d52ff8$var$Bd + $f68f332138d52ff8$var$Ae + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$LO + $f68f332138d52ff8$var$QS + $f68f332138d52ff8$var$Da + $f68f332138d52ff8$var$Mm + $f68f332138d52ff8$var$Ac + $f68f332138d52ff8$var$AD + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Db + $f68f332138d52ff8$var$Dc + $f68f332138d52ff8$var$Mn + $f68f332138d52ff8$var$Ir + $f68f332138d52ff8$var$Bd + $f68f332138d52ff8$var$Ae + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Db + $f68f332138d52ff8$var$Dc + $f68f332138d52ff8$var$Mn + $f68f332138d52ff8$var$Ir + $f68f332138d52ff8$var$Ac + $f68f332138d52ff8$var$AD + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Dd + $f68f332138d52ff8$var$De + $f68f332138d52ff8$var$Df + $f68f332138d52ff8$var$Iw + $f68f332138d52ff8$var$Bd + $f68f332138d52ff8$var$Ae + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Dd + $f68f332138d52ff8$var$De + $f68f332138d52ff8$var$Df + $f68f332138d52ff8$var$Iw + $f68f332138d52ff8$var$Ac + $f68f332138d52ff8$var$AD + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$LP + $f68f332138d52ff8$var$LQ + $f68f332138d52ff8$var$CY + $f68f332138d52ff8$var$Ba + $f68f332138d52ff8$var$Fw + $f68f332138d52ff8$var$Fx + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$LP + $f68f332138d52ff8$var$LQ + $f68f332138d52ff8$var$CY + $f68f332138d52ff8$var$Ba + $f68f332138d52ff8$var$Bw + $f68f332138d52ff8$var$CL + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Eh + $f68f332138d52ff8$var$Ei + $f68f332138d52ff8$var$y + $f68f332138d52ff8$var$Ba + $f68f332138d52ff8$var$Fw + $f68f332138d52ff8$var$Fx + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Eh + $f68f332138d52ff8$var$Ei + $f68f332138d52ff8$var$y + $f68f332138d52ff8$var$Ba + $f68f332138d52ff8$var$Bw + $f68f332138d52ff8$var$CL + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Ap + $f68f332138d52ff8$var$Dg + $f68f332138d52ff8$var$f + $f68f332138d52ff8$var$Ba + $f68f332138d52ff8$var$Fw + $f68f332138d52ff8$var$Fx + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Ap + $f68f332138d52ff8$var$Dg + $f68f332138d52ff8$var$f + $f68f332138d52ff8$var$Ba + $f68f332138d52ff8$var$Bw + $f68f332138d52ff8$var$CL + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Dh + $f68f332138d52ff8$var$Mo + $f68f332138d52ff8$var$Di + $f68f332138d52ff8$var$Jq + $f68f332138d52ff8$var$QG + $f68f332138d52ff8$var$QH + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Dh + $f68f332138d52ff8$var$Mo + $f68f332138d52ff8$var$Di + $f68f332138d52ff8$var$Jq + $f68f332138d52ff8$var$MC + $f68f332138d52ff8$var$MD + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Ch + $f68f332138d52ff8$var$Cp + $f68f332138d52ff8$var$Mp + $f68f332138d52ff8$var$h + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Ch + $f68f332138d52ff8$var$Cp + $f68f332138d52ff8$var$Mp + $f68f332138d52ff8$var$AE + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Aq + $f68f332138d52ff8$var$CR + $f68f332138d52ff8$var$Am + $f68f332138d52ff8$var$h + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Aq + $f68f332138d52ff8$var$CR + $f68f332138d52ff8$var$Am + $f68f332138d52ff8$var$AE + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$DT + " +lat_1=24" + $f68f332138d52ff8$var$YG + " +lat_0=24" + $f68f332138d52ff8$var$NV + $f68f332138d52ff8$var$u + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$LR + $f68f332138d52ff8$var$Dj + $f68f332138d52ff8$var$QT + $f68f332138d52ff8$var$LS + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$LR + $f68f332138d52ff8$var$Dj + $f68f332138d52ff8$var$QT + $f68f332138d52ff8$var$LS + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Aq + $f68f332138d52ff8$var$Ob + $f68f332138d52ff8$var$Am + $f68f332138d52ff8$var$h + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Aq + $f68f332138d52ff8$var$Ob + $f68f332138d52ff8$var$Am + $f68f332138d52ff8$var$AE + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Gm + $f68f332138d52ff8$var$Cq + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$h + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Gm + $f68f332138d52ff8$var$Cq + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$AE + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Gm + $f68f332138d52ff8$var$Cr + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$EW + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Gm + $f68f332138d52ff8$var$Cr + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$CM + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$p + $f68f332138d52ff8$var$Jb + $f68f332138d52ff8$var$BJ + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$p + $f68f332138d52ff8$var$Jb + $f68f332138d52ff8$var$BJ + $f68f332138d52ff8$var$AF + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$p + $f68f332138d52ff8$var$Cs + $f68f332138d52ff8$var$BJ + $f68f332138d52ff8$var$h + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$p + $f68f332138d52ff8$var$Cs + $f68f332138d52ff8$var$BJ + $f68f332138d52ff8$var$AE + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$p + $f68f332138d52ff8$var$Ix + $f68f332138d52ff8$var$BG + $f68f332138d52ff8$var$CX + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$p + $f68f332138d52ff8$var$Ix + $f68f332138d52ff8$var$BG + $f68f332138d52ff8$var$ME + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$f + $f68f332138d52ff8$var$Cz + $f68f332138d52ff8$var$EQ + $f68f332138d52ff8$var$AI + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$f + $f68f332138d52ff8$var$Cz + $f68f332138d52ff8$var$EQ + $f68f332138d52ff8$var$BF + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$f + $f68f332138d52ff8$var$DA + $f68f332138d52ff8$var$Am + $f68f332138d52ff8$var$EW + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$f + $f68f332138d52ff8$var$DA + $f68f332138d52ff8$var$Am + $f68f332138d52ff8$var$MO + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$DM + $f68f332138d52ff8$var$DB + $f68f332138d52ff8$var$AO + $f68f332138d52ff8$var$BU + $f68f332138d52ff8$var$KJ + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$DM + $f68f332138d52ff8$var$DB + $f68f332138d52ff8$var$AO + $f68f332138d52ff8$var$MM + $f68f332138d52ff8$var$GI + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$DM + $f68f332138d52ff8$var$DC + $f68f332138d52ff8$var$AO + $f68f332138d52ff8$var$HT + $f68f332138d52ff8$var$KJ + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$DM + $f68f332138d52ff8$var$DC + $f68f332138d52ff8$var$AO + $f68f332138d52ff8$var$HT + $f68f332138d52ff8$var$GI + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$EB + $f68f332138d52ff8$var$EC + $f68f332138d52ff8$var$Fo + $f68f332138d52ff8$var$GG + $f68f332138d52ff8$var$AV + $f68f332138d52ff8$var$AH + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$EB + $f68f332138d52ff8$var$EC + $f68f332138d52ff8$var$Fo + $f68f332138d52ff8$var$GG + $f68f332138d52ff8$var$AV + $f68f332138d52ff8$var$GJ + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$AY + $f68f332138d52ff8$var$ED + $f68f332138d52ff8$var$Fs + $f68f332138d52ff8$var$GG + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$AY + $f68f332138d52ff8$var$ED + $f68f332138d52ff8$var$Fs + $f68f332138d52ff8$var$GG + $f68f332138d52ff8$var$AG + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$EE + $f68f332138d52ff8$var$EF + $f68f332138d52ff8$var$AQ + $f68f332138d52ff8$var$Fl + $f68f332138d52ff8$var$u + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$EE + $f68f332138d52ff8$var$EF + $f68f332138d52ff8$var$AQ + $f68f332138d52ff8$var$Fl + $f68f332138d52ff8$var$Au + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$EG + $f68f332138d52ff8$var$EH + $f68f332138d52ff8$var$f + $f68f332138d52ff8$var$CV + $f68f332138d52ff8$var$u + $f68f332138d52ff8$var$Is + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$EG + $f68f332138d52ff8$var$EH + $f68f332138d52ff8$var$f + $f68f332138d52ff8$var$CV + $f68f332138d52ff8$var$Au + $f68f332138d52ff8$var$Gt + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Az + $f68f332138d52ff8$var$DV + $f68f332138d52ff8$var$DM + $f68f332138d52ff8$var$Jo + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Az + $f68f332138d52ff8$var$DV + $f68f332138d52ff8$var$DM + $f68f332138d52ff8$var$Jo + $f68f332138d52ff8$var$AF + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Fi + $f68f332138d52ff8$var$Fj + $f68f332138d52ff8$var$AB + $f68f332138d52ff8$var$EY + $f68f332138d52ff8$var$AV + $f68f332138d52ff8$var$AH + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Fi + $f68f332138d52ff8$var$Fj + $f68f332138d52ff8$var$AB + $f68f332138d52ff8$var$EY + $f68f332138d52ff8$var$AV + $f68f332138d52ff8$var$CN + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Ej + $f68f332138d52ff8$var$Ek + $f68f332138d52ff8$var$AB + $f68f332138d52ff8$var$EY + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$Ae + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Ej + $f68f332138d52ff8$var$Ek + $f68f332138d52ff8$var$AB + $f68f332138d52ff8$var$EY + $f68f332138d52ff8$var$AF + $f68f332138d52ff8$var$AD + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$FS + $f68f332138d52ff8$var$FT + $f68f332138d52ff8$var$IY + $f68f332138d52ff8$var$Hg + $f68f332138d52ff8$var$BZ + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$FS + $f68f332138d52ff8$var$FT + $f68f332138d52ff8$var$IY + $f68f332138d52ff8$var$Hg + $f68f332138d52ff8$var$Eb + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$OH + $f68f332138d52ff8$var$OI + $f68f332138d52ff8$var$OJ + $f68f332138d52ff8$var$Bi + $f68f332138d52ff8$var$BZ + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$OH + $f68f332138d52ff8$var$OI + $f68f332138d52ff8$var$OJ + $f68f332138d52ff8$var$Bi + $f68f332138d52ff8$var$Eb + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$YM + $f68f332138d52ff8$var$Rj + $f68f332138d52ff8$var$JE + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$AL + $f68f332138d52ff8$var$Rf + $f68f332138d52ff8$var$JE + $f68f332138d52ff8$var$EW + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$BD + $f68f332138d52ff8$var$Rg + $f68f332138d52ff8$var$JE + $f68f332138d52ff8$var$AI + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$AK + $f68f332138d52ff8$var$HJ + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$AI + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$BD + $f68f332138d52ff8$var$DD + $f68f332138d52ff8$var$AO + $f68f332138d52ff8$var$HT + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$MU + $f68f332138d52ff8$var$Nz + $f68f332138d52ff8$var$AA + $f68f332138d52ff8$var$Ld + $f68f332138d52ff8$var$u + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$AY + $f68f332138d52ff8$var$CF + $f68f332138d52ff8$var$Br + $f68f332138d52ff8$var$BI + $f68f332138d52ff8$var$AG + $f68f332138d52ff8$var$GJ + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Kn + $f68f332138d52ff8$var$Sf + $f68f332138d52ff8$var$AO + $f68f332138d52ff8$var$e + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$i + $f68f332138d52ff8$var$GB + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Ko + $f68f332138d52ff8$var$KO + $f68f332138d52ff8$var$AO + $f68f332138d52ff8$var$e + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$i + $f68f332138d52ff8$var$GB + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$GV + $f68f332138d52ff8$var$KI + $f68f332138d52ff8$var$Jl + $f68f332138d52ff8$var$e + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$i + $f68f332138d52ff8$var$GB + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Kp + $f68f332138d52ff8$var$Sg + $f68f332138d52ff8$var$Jl + $f68f332138d52ff8$var$e + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$i + $f68f332138d52ff8$var$GB + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Kq + $f68f332138d52ff8$var$KP + " +k=1" + $f68f332138d52ff8$var$e + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$i + $f68f332138d52ff8$var$GB + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$JF + $f68f332138d52ff8$var$CG + $f68f332138d52ff8$var$AQ + $f68f332138d52ff8$var$BI + $f68f332138d52ff8$var$AG + $f68f332138d52ff8$var$NF + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$JG + $f68f332138d52ff8$var$CH + $f68f332138d52ff8$var$f + $f68f332138d52ff8$var$BI + $f68f332138d52ff8$var$AG + $f68f332138d52ff8$var$Fq + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$AY + $f68f332138d52ff8$var$CF + $f68f332138d52ff8$var$Br + $f68f332138d52ff8$var$BI + $f68f332138d52ff8$var$AG + $f68f332138d52ff8$var$GJ + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$JF + $f68f332138d52ff8$var$CG + $f68f332138d52ff8$var$AQ + $f68f332138d52ff8$var$BI + $f68f332138d52ff8$var$AG + $f68f332138d52ff8$var$NF + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$JG + $f68f332138d52ff8$var$CH + $f68f332138d52ff8$var$f + $f68f332138d52ff8$var$BI + $f68f332138d52ff8$var$AG + $f68f332138d52ff8$var$Fq + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$He + $f68f332138d52ff8$var$Hr + $f68f332138d52ff8$var$Ry + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$He + $f68f332138d52ff8$var$Hr + $f68f332138d52ff8$var$ON + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$He + $f68f332138d52ff8$var$Hr + $f68f332138d52ff8$var$CS + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$He + $f68f332138d52ff8$var$Hr + " +lon_0=-40" + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$He + $f68f332138d52ff8$var$Hr + $f68f332138d52ff8$var$Lu + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$He + $f68f332138d52ff8$var$Hr + $f68f332138d52ff8$var$Hq + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$DT + " +lat_1=-18" + $f68f332138d52ff8$var$ZT + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Il + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$DT + $f68f332138d52ff8$var$WI + " +lat_2=68 +lat_0=59 +lon_0=-132.5" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$Ae + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$DT + $f68f332138d52ff8$var$WI + " +lat_2=68 +lat_0=59 +lon_0=-132.5" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$Ae + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + " +lat_1=62 +lat_2=70" + $f68f332138d52ff8$var$L + " +lon_0=-112" + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + " +lat_1=62 +lat_2=70" + $f68f332138d52ff8$var$L + " +lon_0=-112" + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$MU + $f68f332138d52ff8$var$Nz + $f68f332138d52ff8$var$AA + $f68f332138d52ff8$var$Ld + $f68f332138d52ff8$var$MF + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Em + $f68f332138d52ff8$var$En + $f68f332138d52ff8$var$Ip + $f68f332138d52ff8$var$IL + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Em + $f68f332138d52ff8$var$En + $f68f332138d52ff8$var$Ip + $f68f332138d52ff8$var$IL + $f68f332138d52ff8$var$AF + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$El + $f68f332138d52ff8$var$Dk + $f68f332138d52ff8$var$Ip + $f68f332138d52ff8$var$GE + $f68f332138d52ff8$var$h + $f68f332138d52ff8$var$Mk + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$El + $f68f332138d52ff8$var$Dk + $f68f332138d52ff8$var$Ip + $f68f332138d52ff8$var$GE + $f68f332138d52ff8$var$AE + $f68f332138d52ff8$var$Mk + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$OA + $f68f332138d52ff8$var$Er + $f68f332138d52ff8$var$Es + $f68f332138d52ff8$var$BE + $f68f332138d52ff8$var$Pk + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$OA + $f68f332138d52ff8$var$Er + $f68f332138d52ff8$var$Es + $f68f332138d52ff8$var$BE + $f68f332138d52ff8$var$MH + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$t + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Eo + $f68f332138d52ff8$var$Ep + $f68f332138d52ff8$var$Eq + $f68f332138d52ff8$var$Jh + $f68f332138d52ff8$var$Tl + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Eo + $f68f332138d52ff8$var$Ep + $f68f332138d52ff8$var$Eq + $f68f332138d52ff8$var$Jh + $f68f332138d52ff8$var$MG + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$t + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$CU + $f68f332138d52ff8$var$Kr + " +lonc=-86" + $f68f332138d52ff8$var$QI + $f68f332138d52ff8$var$AP + $f68f332138d52ff8$var$QJ + $f68f332138d52ff8$var$PY + $f68f332138d52ff8$var$KE + $f68f332138d52ff8$var$QK + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Bq + $f68f332138d52ff8$var$OB + $f68f332138d52ff8$var$Fo + $f68f332138d52ff8$var$BE + $f68f332138d52ff8$var$LU + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Bq + $f68f332138d52ff8$var$OB + $f68f332138d52ff8$var$Fo + $f68f332138d52ff8$var$BE + $f68f332138d52ff8$var$OT + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$t + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Ma + $f68f332138d52ff8$var$FW + $f68f332138d52ff8$var$IP + $f68f332138d52ff8$var$Js + $f68f332138d52ff8$var$CX + $f68f332138d52ff8$var$EK + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$FU + $f68f332138d52ff8$var$FV + $f68f332138d52ff8$var$Iq + $f68f332138d52ff8$var$DE + $f68f332138d52ff8$var$CX + $f68f332138d52ff8$var$EK + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$FX + $f68f332138d52ff8$var$FY + $f68f332138d52ff8$var$Nj + $f68f332138d52ff8$var$Na + $f68f332138d52ff8$var$CX + $f68f332138d52ff8$var$EK + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Hj + $f68f332138d52ff8$var$Ct + $f68f332138d52ff8$var$CP + $f68f332138d52ff8$var$AI + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Hj + $f68f332138d52ff8$var$Ct + $f68f332138d52ff8$var$CP + $f68f332138d52ff8$var$BF + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Hj + $f68f332138d52ff8$var$Bx + $f68f332138d52ff8$var$CP + $f68f332138d52ff8$var$EW + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Hj + $f68f332138d52ff8$var$Bx + $f68f332138d52ff8$var$CP + $f68f332138d52ff8$var$CM + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Cd + $f68f332138d52ff8$var$Hg + $f68f332138d52ff8$var$BG + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Cd + $f68f332138d52ff8$var$RS + $f68f332138d52ff8$var$BG + $f68f332138d52ff8$var$Bv + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Id + $f68f332138d52ff8$var$RT + $f68f332138d52ff8$var$Am + $f68f332138d52ff8$var$YC + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$LM + $f68f332138d52ff8$var$RK + $f68f332138d52ff8$var$MV + $f68f332138d52ff8$var$IS + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$LM + $f68f332138d52ff8$var$RK + $f68f332138d52ff8$var$MV + $f68f332138d52ff8$var$IS + $f68f332138d52ff8$var$DR + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$t + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$JT + $f68f332138d52ff8$var$Jn + $f68f332138d52ff8$var$FZ + $f68f332138d52ff8$var$CS + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$CQ + $f68f332138d52ff8$var$DG + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$Hh + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$CQ + $f68f332138d52ff8$var$DG + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$AG + $f68f332138d52ff8$var$Hh + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$CQ + $f68f332138d52ff8$var$DF + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$h + $f68f332138d52ff8$var$Tm + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$CQ + $f68f332138d52ff8$var$DF + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$Gu + $f68f332138d52ff8$var$MN + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$CQ + $f68f332138d52ff8$var$DH + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$CX + $f68f332138d52ff8$var$LV + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$CQ + $f68f332138d52ff8$var$DH + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$An + $f68f332138d52ff8$var$NE + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Fp + $f68f332138d52ff8$var$DI + $f68f332138d52ff8$var$AO + $f68f332138d52ff8$var$AI + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Fp + $f68f332138d52ff8$var$DI + $f68f332138d52ff8$var$AO + $f68f332138d52ff8$var$BF + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$BA + $f68f332138d52ff8$var$Gp + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$Bn + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$BA + $f68f332138d52ff8$var$Gp + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$Bn + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Bl + $f68f332138d52ff8$var$Iy + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Bl + $f68f332138d52ff8$var$Iy + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$AF + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Bl + $f68f332138d52ff8$var$Cu + $f68f332138d52ff8$var$Hm + $f68f332138d52ff8$var$OC + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Bl + $f68f332138d52ff8$var$Cu + $f68f332138d52ff8$var$Hm + $f68f332138d52ff8$var$OC + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Bl + $f68f332138d52ff8$var$Cv + $f68f332138d52ff8$var$Iz + $f68f332138d52ff8$var$YD + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Bl + $f68f332138d52ff8$var$Cv + $f68f332138d52ff8$var$Iz + $f68f332138d52ff8$var$MI + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Fs + $f68f332138d52ff8$var$Cw + $f68f332138d52ff8$var$Ad + $f68f332138d52ff8$var$Bv + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Fs + $f68f332138d52ff8$var$Cw + $f68f332138d52ff8$var$Ad + $f68f332138d52ff8$var$MJ + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$BA + $f68f332138d52ff8$var$Gp + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$Bn + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$BA + $f68f332138d52ff8$var$Gp + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$Bn + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Dl + $f68f332138d52ff8$var$Dm + $f68f332138d52ff8$var$BB + $f68f332138d52ff8$var$Oc + $f68f332138d52ff8$var$AI + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Dl + $f68f332138d52ff8$var$Dm + $f68f332138d52ff8$var$BB + $f68f332138d52ff8$var$Oc + $f68f332138d52ff8$var$BF + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Fs + $f68f332138d52ff8$var$Cx + $f68f332138d52ff8$var$Ad + $f68f332138d52ff8$var$Qo + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Fs + $f68f332138d52ff8$var$Cx + $f68f332138d52ff8$var$Ad + $f68f332138d52ff8$var$MK + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Et + $f68f332138d52ff8$var$Eu + $f68f332138d52ff8$var$LT + $f68f332138d52ff8$var$NW + $f68f332138d52ff8$var$Rh + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Et + $f68f332138d52ff8$var$Eu + $f68f332138d52ff8$var$LT + $f68f332138d52ff8$var$NW + $f68f332138d52ff8$var$Z + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$BH + $f68f332138d52ff8$var$Ev + $f68f332138d52ff8$var$Ib + $f68f332138d52ff8$var$EZ + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$BH + $f68f332138d52ff8$var$Ev + $f68f332138d52ff8$var$Ib + $f68f332138d52ff8$var$EZ + $f68f332138d52ff8$var$DR + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$t + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Ew + $f68f332138d52ff8$var$Ex + $f68f332138d52ff8$var$Be + $f68f332138d52ff8$var$EZ + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Ew + $f68f332138d52ff8$var$Ex + $f68f332138d52ff8$var$Be + $f68f332138d52ff8$var$EZ + $f68f332138d52ff8$var$DR + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$t + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$OK + $f68f332138d52ff8$var$Fa + $f68f332138d52ff8$var$BY + $f68f332138d52ff8$var$ET + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Fb + $f68f332138d52ff8$var$Fc + $f68f332138d52ff8$var$Ch + $f68f332138d52ff8$var$ET + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Dn + $f68f332138d52ff8$var$Ey + $f68f332138d52ff8$var$QU + $f68f332138d52ff8$var$Fl + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Dn + $f68f332138d52ff8$var$Ey + $f68f332138d52ff8$var$QU + $f68f332138d52ff8$var$Fl + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Ez + $f68f332138d52ff8$var$FA + $f68f332138d52ff8$var$Do + $f68f332138d52ff8$var$Fl + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Ez + $f68f332138d52ff8$var$FA + $f68f332138d52ff8$var$Do + $f68f332138d52ff8$var$Fl + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$JT + $f68f332138d52ff8$var$Hl + $f68f332138d52ff8$var$GH + $f68f332138d52ff8$var$AJ + $f68f332138d52ff8$var$u + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$JT + $f68f332138d52ff8$var$Hl + $f68f332138d52ff8$var$GH + $f68f332138d52ff8$var$AJ + $f68f332138d52ff8$var$Lc + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$t + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$PP + $f68f332138d52ff8$var$CZ + $f68f332138d52ff8$var$AK + $f68f332138d52ff8$var$AJ + $f68f332138d52ff8$var$Ci + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$PP + $f68f332138d52ff8$var$CZ + $f68f332138d52ff8$var$AK + $f68f332138d52ff8$var$AJ + $f68f332138d52ff8$var$KL + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$t + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$PQ + $f68f332138d52ff8$var$Ca + $f68f332138d52ff8$var$p + $f68f332138d52ff8$var$AJ + $f68f332138d52ff8$var$AV + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$PQ + $f68f332138d52ff8$var$Ca + $f68f332138d52ff8$var$p + $f68f332138d52ff8$var$AJ + $f68f332138d52ff8$var$KM + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$t + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$MW + $f68f332138d52ff8$var$FB + $f68f332138d52ff8$var$BB + $f68f332138d52ff8$var$Ea + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$MW + $f68f332138d52ff8$var$FB + $f68f332138d52ff8$var$BB + $f68f332138d52ff8$var$Ea + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Dp + $f68f332138d52ff8$var$Dq + $f68f332138d52ff8$var$y + $f68f332138d52ff8$var$Ea + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Dp + $f68f332138d52ff8$var$Dq + $f68f332138d52ff8$var$y + $f68f332138d52ff8$var$Ea + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$EI + $f68f332138d52ff8$var$GE + $f68f332138d52ff8$var$Lb + $f68f332138d52ff8$var$BU + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$EI + $f68f332138d52ff8$var$GE + $f68f332138d52ff8$var$Lb + $f68f332138d52ff8$var$JV + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$FC + $f68f332138d52ff8$var$OD + $f68f332138d52ff8$var$Dr + $f68f332138d52ff8$var$CR + $f68f332138d52ff8$var$OE + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$FC + $f68f332138d52ff8$var$OD + $f68f332138d52ff8$var$Dr + $f68f332138d52ff8$var$CR + $f68f332138d52ff8$var$OE + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$t + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Fd + $f68f332138d52ff8$var$Fe + $f68f332138d52ff8$var$AL + $f68f332138d52ff8$var$CS + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Fd + $f68f332138d52ff8$var$Fe + $f68f332138d52ff8$var$AL + $f68f332138d52ff8$var$CS + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$OL + $f68f332138d52ff8$var$Ff + $f68f332138d52ff8$var$EJ + $f68f332138d52ff8$var$Ag + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$OL + $f68f332138d52ff8$var$Ff + $f68f332138d52ff8$var$EJ + $f68f332138d52ff8$var$Ag + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$FD + $f68f332138d52ff8$var$MX + $f68f332138d52ff8$var$BC + $f68f332138d52ff8$var$MQ + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$FD + $f68f332138d52ff8$var$MX + $f68f332138d52ff8$var$BC + $f68f332138d52ff8$var$MQ + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$FH + $f68f332138d52ff8$var$FI + $f68f332138d52ff8$var$Cb + $f68f332138d52ff8$var$Ag + $f68f332138d52ff8$var$EW + $f68f332138d52ff8$var$Fq + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$FH + $f68f332138d52ff8$var$FI + $f68f332138d52ff8$var$Cb + $f68f332138d52ff8$var$Ag + $f68f332138d52ff8$var$CM + $f68f332138d52ff8$var$Fq + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$DT + $f68f332138d52ff8$var$OM + $f68f332138d52ff8$var$RO + $f68f332138d52ff8$var$OX + $f68f332138d52ff8$var$CS + $f68f332138d52ff8$var$AV + $f68f332138d52ff8$var$Hh + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$OM + $f68f332138d52ff8$var$RO + $f68f332138d52ff8$var$OX + $f68f332138d52ff8$var$CS + $f68f332138d52ff8$var$AV + $f68f332138d52ff8$var$Ju + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$FE + $f68f332138d52ff8$var$MY + $f68f332138d52ff8$var$QV + $f68f332138d52ff8$var$Jr + $f68f332138d52ff8$var$h + $f68f332138d52ff8$var$AH + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$FE + $f68f332138d52ff8$var$MY + $f68f332138d52ff8$var$QV + $f68f332138d52ff8$var$Jr + $f68f332138d52ff8$var$AE + $f68f332138d52ff8$var$CN + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$FF + $f68f332138d52ff8$var$FG + $f68f332138d52ff8$var$Ds + $f68f332138d52ff8$var$CV + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$Cl + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$FF + $f68f332138d52ff8$var$FG + $f68f332138d52ff8$var$Ds + $f68f332138d52ff8$var$CV + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$Gr + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$CD + $f68f332138d52ff8$var$CE + $f68f332138d52ff8$var$Cc + $f68f332138d52ff8$var$CV + $f68f332138d52ff8$var$AI + $f68f332138d52ff8$var$Ju + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$CD + $f68f332138d52ff8$var$CE + $f68f332138d52ff8$var$Cc + $f68f332138d52ff8$var$CV + $f68f332138d52ff8$var$BF + $f68f332138d52ff8$var$Nf + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$FJ + $f68f332138d52ff8$var$FK + $f68f332138d52ff8$var$Dt + $f68f332138d52ff8$var$Ji + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$LV + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$FJ + $f68f332138d52ff8$var$FK + $f68f332138d52ff8$var$Dt + $f68f332138d52ff8$var$Ji + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$Ne + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$JF + $f68f332138d52ff8$var$CG + $f68f332138d52ff8$var$AQ + $f68f332138d52ff8$var$BI + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$Cl + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$JF + $f68f332138d52ff8$var$CG + $f68f332138d52ff8$var$AQ + $f68f332138d52ff8$var$BI + $f68f332138d52ff8$var$Gd + $f68f332138d52ff8$var$RY + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$t + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$JF + $f68f332138d52ff8$var$CG + $f68f332138d52ff8$var$AQ + $f68f332138d52ff8$var$BI + $f68f332138d52ff8$var$AG + $f68f332138d52ff8$var$NF + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$AY + $f68f332138d52ff8$var$CF + $f68f332138d52ff8$var$Br + $f68f332138d52ff8$var$BI + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$AH + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$AY + $f68f332138d52ff8$var$CF + $f68f332138d52ff8$var$Br + $f68f332138d52ff8$var$BI + $f68f332138d52ff8$var$Gd + $f68f332138d52ff8$var$Pw + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$t + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$AY + $f68f332138d52ff8$var$CF + $f68f332138d52ff8$var$Br + $f68f332138d52ff8$var$BI + $f68f332138d52ff8$var$AG + $f68f332138d52ff8$var$GJ + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$JG + $f68f332138d52ff8$var$CH + $f68f332138d52ff8$var$f + $f68f332138d52ff8$var$BI + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$Fq + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$JG + $f68f332138d52ff8$var$CH + $f68f332138d52ff8$var$f + $f68f332138d52ff8$var$BI + $f68f332138d52ff8$var$Gd + $f68f332138d52ff8$var$RZ + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$t + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$JG + $f68f332138d52ff8$var$CH + $f68f332138d52ff8$var$f + $f68f332138d52ff8$var$BI + $f68f332138d52ff8$var$AG + $f68f332138d52ff8$var$Fq + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Fp + $f68f332138d52ff8$var$LW + $f68f332138d52ff8$var$JA + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$OF + $f68f332138d52ff8$var$FL + $f68f332138d52ff8$var$AA + $f68f332138d52ff8$var$GF + $f68f332138d52ff8$var$Bo + $f68f332138d52ff8$var$Cl + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$OF + $f68f332138d52ff8$var$FL + $f68f332138d52ff8$var$AA + $f68f332138d52ff8$var$GF + $f68f332138d52ff8$var$Gs + $f68f332138d52ff8$var$Gr + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Az + $f68f332138d52ff8$var$Du + $f68f332138d52ff8$var$AB + $f68f332138d52ff8$var$GF + $f68f332138d52ff8$var$Bo + $f68f332138d52ff8$var$AH + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Az + $f68f332138d52ff8$var$Du + $f68f332138d52ff8$var$AB + $f68f332138d52ff8$var$GF + $f68f332138d52ff8$var$Gs + $f68f332138d52ff8$var$CN + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$BH + $f68f332138d52ff8$var$OG + $f68f332138d52ff8$var$Ib + $f68f332138d52ff8$var$Cy + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$BH + $f68f332138d52ff8$var$OG + $f68f332138d52ff8$var$Ib + $f68f332138d52ff8$var$Cy + $f68f332138d52ff8$var$AF + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$FM + $f68f332138d52ff8$var$FN + $f68f332138d52ff8$var$Dv + $f68f332138d52ff8$var$AJ + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$FM + $f68f332138d52ff8$var$FN + $f68f332138d52ff8$var$Dv + $f68f332138d52ff8$var$AJ + $f68f332138d52ff8$var$AF + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Mb + $f68f332138d52ff8$var$RN + $f68f332138d52ff8$var$Mr + $f68f332138d52ff8$var$Ga + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Fg + $f68f332138d52ff8$var$Fh + $f68f332138d52ff8$var$QX + $f68f332138d52ff8$var$CR + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Jc + $f68f332138d52ff8$var$MZ + $f68f332138d52ff8$var$AL + $f68f332138d52ff8$var$Bu + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Jc + $f68f332138d52ff8$var$MZ + $f68f332138d52ff8$var$AL + $f68f332138d52ff8$var$Bu + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$FO + $f68f332138d52ff8$var$FP + $f68f332138d52ff8$var$Dw + $f68f332138d52ff8$var$Bu + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$FO + $f68f332138d52ff8$var$FP + $f68f332138d52ff8$var$Dw + $f68f332138d52ff8$var$Bu + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$FQ + $f68f332138d52ff8$var$FR + $f68f332138d52ff8$var$PR + $f68f332138d52ff8$var$Bu + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$FQ + $f68f332138d52ff8$var$FR + $f68f332138d52ff8$var$PR + $f68f332138d52ff8$var$Bu + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Bu + $f68f332138d52ff8$var$AP + $f68f332138d52ff8$var$YF + $f68f332138d52ff8$var$Sh + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$CA + $f68f332138d52ff8$var$DJ + $f68f332138d52ff8$var$Ad + $f68f332138d52ff8$var$h + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$CA + $f68f332138d52ff8$var$DK + $f68f332138d52ff8$var$Ad + $f68f332138d52ff8$var$u + $f68f332138d52ff8$var$EK + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$CA + $f68f332138d52ff8$var$JB + $f68f332138d52ff8$var$Ad + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$CA + $f68f332138d52ff8$var$DL + $f68f332138d52ff8$var$Ad + $f68f332138d52ff8$var$CX + $f68f332138d52ff8$var$EK + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Nq + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$PL + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$SK + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$TV + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Xz + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$TY + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$RG + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ro + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$RH + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$TW + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$TX + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$QE + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ns + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Nt + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Nu + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Nw + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$NP + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$NQ + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ik + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$IC + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Hi + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=-21.11666666666667 +lon_0=55.53333333333333 +k=1 +x_0=160000" + $f68f332138d52ff8$var$Rz + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$SJ + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$OK + $f68f332138d52ff8$var$Fa + $f68f332138d52ff8$var$BY + $f68f332138d52ff8$var$ET + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Fb + $f68f332138d52ff8$var$Fc + $f68f332138d52ff8$var$Ch + $f68f332138d52ff8$var$ET + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$CA + $f68f332138d52ff8$var$DJ + $f68f332138d52ff8$var$Ad + $f68f332138d52ff8$var$Gu + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$CA + $f68f332138d52ff8$var$DK + $f68f332138d52ff8$var$Ad + $f68f332138d52ff8$var$Au + $f68f332138d52ff8$var$Ao + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$CA + $f68f332138d52ff8$var$JB + $f68f332138d52ff8$var$Ad + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$CA + $f68f332138d52ff8$var$DL + $f68f332138d52ff8$var$Ad + $f68f332138d52ff8$var$An + $f68f332138d52ff8$var$Ao + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$OK + $f68f332138d52ff8$var$Fa + $f68f332138d52ff8$var$BY + $f68f332138d52ff8$var$ET + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Fb + $f68f332138d52ff8$var$Fc + $f68f332138d52ff8$var$Ch + $f68f332138d52ff8$var$ET + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$CA + $f68f332138d52ff8$var$DJ + $f68f332138d52ff8$var$Ad + $f68f332138d52ff8$var$Gu + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$CA + $f68f332138d52ff8$var$DK + $f68f332138d52ff8$var$Ad + $f68f332138d52ff8$var$Au + $f68f332138d52ff8$var$Ao + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$CA + $f68f332138d52ff8$var$JB + $f68f332138d52ff8$var$Ad + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$CA + $f68f332138d52ff8$var$DL + $f68f332138d52ff8$var$Ad + $f68f332138d52ff8$var$An + $f68f332138d52ff8$var$Ao + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$QE + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ns + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Nt + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Nu + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Nw + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$NP + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$NQ + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ik + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$IC + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Hi + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$TY + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$RG + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    2,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$OK + $f68f332138d52ff8$var$Fa + $f68f332138d52ff8$var$BY + $f68f332138d52ff8$var$ET + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Fb + $f68f332138d52ff8$var$Fc + $f68f332138d52ff8$var$Ch + $f68f332138d52ff8$var$ET + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$CA + $f68f332138d52ff8$var$DJ + $f68f332138d52ff8$var$Ad + $f68f332138d52ff8$var$Gu + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$CA + $f68f332138d52ff8$var$DK + $f68f332138d52ff8$var$Ad + $f68f332138d52ff8$var$Au + $f68f332138d52ff8$var$Ao + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$CA + $f68f332138d52ff8$var$JB + $f68f332138d52ff8$var$Ad + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$CA + $f68f332138d52ff8$var$DL + $f68f332138d52ff8$var$Ad + $f68f332138d52ff8$var$An + $f68f332138d52ff8$var$Ao + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$GV + $f68f332138d52ff8$var$KI + $f68f332138d52ff8$var$Jl + $f68f332138d52ff8$var$AG + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$GV + $f68f332138d52ff8$var$KI + $f68f332138d52ff8$var$Jl + $f68f332138d52ff8$var$AG + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Io + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + " +lat_1=-54 +lat_2=-54.75 +lat_0=-55 +lon_0=-37" + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=39.66825833333333 +lon_0=-8.133108333333334 +k=1" + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Za + $f68f332138d52ff8$var$Si + " +k=1" + $f68f332138d52ff8$var$u + $f68f332138d52ff8$var$CO + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$YE + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + " +lat_1=45.91666666666666 +lat_2=43.08333333333334" + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$YE + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$KC + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$NR + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Gz + $f68f332138d52ff8$var$i + $f68f332138d52ff8$var$TQ + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=32 +lon_0=-64.75 +k=1 +x_0=550000" + $f68f332138d52ff8$var$EK + $f68f332138d52ff8$var$j + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$KK + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Jb + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Lj + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    2,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$KK + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Jb + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Lj + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    2,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$KK + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Jb + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Lj + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    2,
    $f68f332138d52ff8$var$D + " +lat_0=-25.06855261111111 +lon_0=-130.1129671111111 +k=1 +x_0=14200 +y_0=15500" + $f68f332138d52ff8$var$j + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$TX + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$Ta + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    4,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$ZW + " +k=1" + $f68f332138d52ff8$var$Bo + $f68f332138d52ff8$var$Ak + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + " +lon_0=169 +k=1" + $f68f332138d52ff8$var$Bo + $f68f332138d52ff8$var$Ak + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + " +lon_0=179 +k=1" + $f68f332138d52ff8$var$Bo + $f68f332138d52ff8$var$Ak + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + " +lon_0=-178 +k=1" + $f68f332138d52ff8$var$Bo + $f68f332138d52ff8$var$Ak + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    2,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Si + " +k=1" + $f68f332138d52ff8$var$Bo + $f68f332138d52ff8$var$Ak + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Gj + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$EO + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + " +lat_1=23 +lat_2=21.7 +lat_0=22.35" + $f68f332138d52ff8$var$CR + $f68f332138d52ff8$var$O + " +y_0=280296.016" + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + " +lat_1=21.3 +lat_2=20.13333333333333 +lat_0=20.71666666666667 +lon_0=-76.83333333333333" + $f68f332138d52ff8$var$O + " +y_0=229126.939" + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Yv + $f68f332138d52ff8$var$Nh + $f68f332138d52ff8$var$IZ + " +lon_0=-70" + $f68f332138d52ff8$var$CX + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Yv + $f68f332138d52ff8$var$Nh + $f68f332138d52ff8$var$IZ + " +lon_0=-70" + $f68f332138d52ff8$var$CX + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Yv + $f68f332138d52ff8$var$Nh + $f68f332138d52ff8$var$IZ + " +lon_0=-70" + $f68f332138d52ff8$var$CX + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Mt + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Mt + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Mt + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    10,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Ks + $f68f332138d52ff8$var$Kt + " +lat_0=50.797815" + $f68f332138d52ff8$var$WH + " +x_0=649328 +y_0=665262" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    2,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Li + $f68f332138d52ff8$var$Sj + $f68f332138d52ff8$var$Tn + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$Pm + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Li + $f68f332138d52ff8$var$Sj + $f68f332138d52ff8$var$Tn + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$Pm + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Li + $f68f332138d52ff8$var$Sj + $f68f332138d52ff8$var$Tn + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$Pm + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    3,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$Y + " +towgs84=595.48,121.69,515.35,4.115,-2.9383,0.853,-3.408" + $f68f332138d52ff8$var$A,
    2,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$x + $f68f332138d52ff8$var$A,
    3,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$ZU + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$Bv + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$ZV + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$Bv + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$ZU + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$Bv + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$x + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$ZV + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$Bv + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$x + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Mg + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$Rq + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    3,
    $f68f332138d52ff8$var$JU + $f68f332138d52ff8$var$Oe + " +k=1" + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$KB + " +k=1" + $f68f332138d52ff8$var$Ci + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$b + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$KB + " +k=1" + $f68f332138d52ff8$var$Ci + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$Ar + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Gj + " +k=1" + $f68f332138d52ff8$var$Bo + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$Ar + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Gl + " +k=1" + $f68f332138d52ff8$var$DP + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$Ar + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$KB + " +k=1" + $f68f332138d52ff8$var$Bo + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$b + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$IH + " +k=1" + $f68f332138d52ff8$var$DP + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$b + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$HO + " +k=1" + $f68f332138d52ff8$var$MT + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$b + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Ia + " +k=1" + $f68f332138d52ff8$var$LY + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$b + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$QR + " +k=1" + $f68f332138d52ff8$var$Jt + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$Ar + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    3,
    $f68f332138d52ff8$var$GU + " +lat_0=46" + $f68f332138d52ff8$var$RJ + $f68f332138d52ff8$var$Rv + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$Ae + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$b + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + " +lon_0=11.30625 +k=1.000006 +x_0=1500025.141 +y_0=-667.282" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + " +lon_0=13.55626666666667 +k=1.0000058 +x_0=1500044.695 +y_0=-667.13" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + " +lon_0=15.80628452944445 +k=1.00000561024 +x_0=1500064.274 +y_0=-667.711" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + " +lon_0=18.0563 +k=1.0000054 +x_0=1500083.521 +y_0=-668.8440000000001" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + " +lon_0=20.30631666666667 +k=1.0000052 +x_0=1500102.765 +y_0=-670.706" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + " +lon_0=22.55633333333333 +k=1.0000049 +x_0=1500121.846 +y_0=-672.557" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + " +lat_1=-37.5 +lat_2=-44.5 +lat_0=-41 +lon_0=173" + $f68f332138d52ff8$var$aH + " +y_0=7000000" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Ai + $f68f332138d52ff8$var$Aj + $f68f332138d52ff8$var$m + " +lon_0=157" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    2,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + " +lon_0=18.05787 +k=0.99999506 +x_0=100182.7406 +y_0=-6500620.1207" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    3,
    $f68f332138d52ff8$var$JU + " +a=6378137 +b=6378137 +lat_ts=0.0 +lon_0=0.0 +x_0=0.0" + $f68f332138d52ff8$var$N + " +k=1.0" + $f68f332138d52ff8$var$E + " +nadgrids=@null +wktext " + $f68f332138d52ff8$var$A,
    16,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$RI + " +k=1" + $f68f332138d52ff8$var$Ht + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$UI + " +k=1" + $f68f332138d52ff8$var$HV + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Gl + " +k=1" + $f68f332138d52ff8$var$Hw + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Yx + " +k=1" + $f68f332138d52ff8$var$HW + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$SP + " +k=1" + $f68f332138d52ff8$var$Hx + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$II + " +k=1" + $f68f332138d52ff8$var$La + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$RJ + " +k=1" + $f68f332138d52ff8$var$Hy + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$UJ + " +k=1" + $f68f332138d52ff8$var$Hz + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$HO + " +k=1" + $f68f332138d52ff8$var$IA + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$RP + " +k=1" + $f68f332138d52ff8$var$IB + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + " +lon_0=29 +k=1" + $f68f332138d52ff8$var$Gx + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Ia + " +k=1" + $f68f332138d52ff8$var$IT + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$QQ + " +k=1" + $f68f332138d52ff8$var$Gc + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    4,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$KD + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$JZ + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$JM + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$WJ + " +lon_0=46.5 +k=0.9994" + $f68f332138d52ff8$var$CX + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$n + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    13,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$Aw + $f68f332138d52ff8$var$A,
    6,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Gj + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$EO + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$Aw + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    8,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Gz + $f68f332138d52ff8$var$i + $f68f332138d52ff8$var$Je + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    22,
    $f68f332138d52ff8$var$H + " +lat_1=41.25 +lat_2=42.75" + $f68f332138d52ff8$var$PR + $f68f332138d52ff8$var$Or + $f68f332138d52ff8$var$Jv + $f68f332138d52ff8$var$Tj + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + " +lat_1=42.25 +lat_2=43.75" + $f68f332138d52ff8$var$Nj + $f68f332138d52ff8$var$Or + $f68f332138d52ff8$var$Jv + " +y_0=2200000" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + " +lat_1=43.25 +lat_2=44.75" + $f68f332138d52ff8$var$IZ + $f68f332138d52ff8$var$Or + $f68f332138d52ff8$var$Jv + " +y_0=3200000" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + " +lat_1=44.25 +lat_2=45.75" + $f68f332138d52ff8$var$IP + $f68f332138d52ff8$var$Or + $f68f332138d52ff8$var$Jv + " +y_0=4200000" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + " +lat_1=45.25 +lat_2=46.75 +lat_0=46" + $f68f332138d52ff8$var$Or + $f68f332138d52ff8$var$Jv + " +y_0=5200000" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$aI + " +lat_2=47.75" + $f68f332138d52ff8$var$Ib + $f68f332138d52ff8$var$Or + $f68f332138d52ff8$var$Jv + " +y_0=6200000" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + " +lat_1=47.25 +lat_2=48.75 +lat_0=48" + $f68f332138d52ff8$var$Or + $f68f332138d52ff8$var$Jv + " +y_0=7200000" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + " +lat_1=48.25 +lat_2=49.75 +lat_0=49" + $f68f332138d52ff8$var$Or + $f68f332138d52ff8$var$Jv + " +y_0=8200000" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + " +lat_1=49.25 +lat_2=50.75" + $f68f332138d52ff8$var$Yu + $f68f332138d52ff8$var$Or + $f68f332138d52ff8$var$Jv + " +y_0=9200000" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    18,
    $f68f332138d52ff8$var$H + " +lat_1=37" + $f68f332138d52ff8$var$YS + $f68f332138d52ff8$var$GM + $f68f332138d52ff8$var$Ga + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + " +lat_1=37" + $f68f332138d52ff8$var$YS + $f68f332138d52ff8$var$GM + $f68f332138d52ff8$var$Ga + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + " +lat_1=37" + $f68f332138d52ff8$var$YS + $f68f332138d52ff8$var$GM + $f68f332138d52ff8$var$Ga + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    6,
    $f68f332138d52ff8$var$BP + $f68f332138d52ff8$var$m + " +lat_ts=-70" + $f68f332138d52ff8$var$HN + " +k=1" + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    2,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$LM + $f68f332138d52ff8$var$IJ + " +lat_0=49 +lon_0=-95" + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$LM + $f68f332138d52ff8$var$IJ + " +lat_0=49 +lon_0=-95" + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    7,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$ZA + $f68f332138d52ff8$var$Ia + " +k=1" + $f68f332138d52ff8$var$h + $f68f332138d52ff8$var$Ae + $f68f332138d52ff8$var$i + $f68f332138d52ff8$var$CW + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$ZA + $f68f332138d52ff8$var$RP + " +k=1" + $f68f332138d52ff8$var$h + $f68f332138d52ff8$var$Ae + $f68f332138d52ff8$var$i + $f68f332138d52ff8$var$CW + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$ZA + $f68f332138d52ff8$var$UJ + " +k=1" + $f68f332138d52ff8$var$h + $f68f332138d52ff8$var$Ae + $f68f332138d52ff8$var$i + $f68f332138d52ff8$var$CW + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$ZA + $f68f332138d52ff8$var$II + " +k=1" + $f68f332138d52ff8$var$h + $f68f332138d52ff8$var$Ae + $f68f332138d52ff8$var$i + $f68f332138d52ff8$var$CW + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    2,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$GW + $f68f332138d52ff8$var$GX + $f68f332138d52ff8$var$GY + $f68f332138d52ff8$var$GA + $f68f332138d52ff8$var$e + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$i + $f68f332138d52ff8$var$Je + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$GW + $f68f332138d52ff8$var$GX + $f68f332138d52ff8$var$GY + $f68f332138d52ff8$var$GA + $f68f332138d52ff8$var$e + $f68f332138d52ff8$var$Pv + $f68f332138d52ff8$var$i + $f68f332138d52ff8$var$Je + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    2,
    $f68f332138d52ff8$var$JU + " +lon_0=100 +lat_ts=-41" + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$BP + $f68f332138d52ff8$var$Hr + " +lat_ts=71" + $f68f332138d52ff8$var$HN + " +k=1" + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$BP + $f68f332138d52ff8$var$Hr + " +lat_ts=75" + $f68f332138d52ff8$var$HN + " +k=1" + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + " +lon_0=55.33333333333334 +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    4,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$PV + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$Ok + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$x + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$Hn + $f68f332138d52ff8$var$EL + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$HB + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$Ee + $f68f332138d52ff8$var$Ef + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$i + $f68f332138d52ff8$var$A,
    2,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$Nc + $f68f332138d52ff8$var$Nd + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$AU + $f68f332138d52ff8$var$BN + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$c + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$Bc + $f68f332138d52ff8$var$BS + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$AU + " +b=6356514.996941779" + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$By + $f68f332138d52ff8$var$Ay + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$Lo + $f68f332138d52ff8$var$A,
    2,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$GL + $f68f332138d52ff8$var$Bz + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$Gn + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$IR + $f68f332138d52ff8$var$Bh + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$A,
    0,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$aJ + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + " +lon_0=28.4 +k=0.9999400000000001" + $f68f332138d52ff8$var$h + $f68f332138d52ff8$var$EO + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + " +a=6376523" + $f68f332138d52ff8$var$RA + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$Zx + $f68f332138d52ff8$var$Qy + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$Qj + $f68f332138d52ff8$var$Ho + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$j + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$j + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + " +a=6378136.2 +b=6356751.516927429" + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + " +a=6378136.3 +b=6356751.616592146" + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$RB + $f68f332138d52ff8$var$RC + $f68f332138d52ff8$var$A,
    2,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$aK + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ki + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Mf + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    3,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$Pd + $f68f332138d52ff8$var$Gq + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$HK + $f68f332138d52ff8$var$Gv + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$Lp + $f68f332138d52ff8$var$Hp + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$Go + $f68f332138d52ff8$var$CT + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + " +a=6371007 +b=6371007" + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$IH + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$Ak + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + " +lon_0=14" + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$Ak + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + " +lon_0=16" + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$Ak + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$QR + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$Ak + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + " +a=6370997 +b=6370997" + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$ZX + $f68f332138d52ff8$var$ZY + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$ZZ + $f68f332138d52ff8$var$Ri + $f68f332138d52ff8$var$A,
    2,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$UI + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$Ak + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Yx + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$Ak + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$II + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$Ak + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$UJ + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$Ak + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$RP + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$Ak + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$KC + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$NR + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ki + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    8,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$MB + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$TF + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    4,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$A,
    6,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$SL + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ja + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    4,
    "+proj=eqc +lat_ts=0" + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$HN + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    "+proj=eqc +lat_ts=0" + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$HN + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + " +a=6371007 +b=6371007" + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    5,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$KB + $f68f332138d52ff8$var$JE + $f68f332138d52ff8$var$h + $f68f332138d52ff8$var$EO + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Lu + $f68f332138d52ff8$var$JE + $f68f332138d52ff8$var$u + $f68f332138d52ff8$var$EO + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + " +lon_0=11.75" + $f68f332138d52ff8$var$JE + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$EO + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Gj + " +k=1" + $f68f332138d52ff8$var$CX + $f68f332138d52ff8$var$EO + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    24,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$Qb + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$Pd + $f68f332138d52ff8$var$Gq + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$At + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$BW + $f68f332138d52ff8$var$A,
    3,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$i + $f68f332138d52ff8$var$HF + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$i + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$i + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$j + $f68f332138d52ff8$var$KR + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$By + $f68f332138d52ff8$var$Ay + $f68f332138d52ff8$var$JP + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$c + $f68f332138d52ff8$var$QC + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$Lw + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$c + $f68f332138d52ff8$var$Gg + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$i + $f68f332138d52ff8$var$GB + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$i + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$i + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$i + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$i + $f68f332138d52ff8$var$Je + $f68f332138d52ff8$var$A,
    2,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$UC + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$c + $f68f332138d52ff8$var$JO + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$c + $f68f332138d52ff8$var$IE + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$By + $f68f332138d52ff8$var$Ay + $f68f332138d52ff8$var$JQ + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$Lp + $f68f332138d52ff8$var$Hp + $f68f332138d52ff8$var$GQ + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$Go + $f68f332138d52ff8$var$CT + $f68f332138d52ff8$var$BT + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$HG + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$j + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$Gf + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$Py + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$Pz + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$Gy + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$AU + $f68f332138d52ff8$var$BN + $f68f332138d52ff8$var$Nm + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$Gh + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$Ee + $f68f332138d52ff8$var$Ef + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$QA + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$v + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$SD + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$j + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$NK + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$TM + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$j + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$Qj + $f68f332138d52ff8$var$Ho + $f68f332138d52ff8$var$NI + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$i + $f68f332138d52ff8$var$TC + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$A,
    2,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$Qj + $f68f332138d52ff8$var$Ho + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$c + $f68f332138d52ff8$var$OW + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$A,
    2,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$Ar + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$b + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$Jx + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$Sw + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$Sx + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$TN + $f68f332138d52ff8$var$A,
    4,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$PV + $f68f332138d52ff8$var$Bb + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$Qe + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$AU + $f68f332138d52ff8$var$BN + $f68f332138d52ff8$var$RD + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$NG + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$R + " +towgs84=105,326,-102.5,0,0,0.814,-0.6" + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$R + " +towgs84=-45,417,-3.5,0,0,0.814,-0.6" + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$c + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$c + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$c + $f68f332138d52ff8$var$HX + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$x + $f68f332138d52ff8$var$r + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$x + $f68f332138d52ff8$var$CB + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$Cm + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$NL + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$AU + $f68f332138d52ff8$var$BN + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$EV + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$Ec + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$Bc + $f68f332138d52ff8$var$BS + $f68f332138d52ff8$var$In + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$c + $f68f332138d52ff8$var$ER + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$Cj + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$c + $f68f332138d52ff8$var$Jw + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$AU + $f68f332138d52ff8$var$BN + $f68f332138d52ff8$var$Sy + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$U + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$i + $f68f332138d52ff8$var$TQ + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Lf + $f68f332138d52ff8$var$AP + $f68f332138d52ff8$var$k + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    0,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Lf + $f68f332138d52ff8$var$AP + $f68f332138d52ff8$var$k + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$ES + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$Y + " +towgs84=-384,664,-48,0,0,0,0" + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$c + $f68f332138d52ff8$var$GO + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$Bs + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$Bc + $f68f332138d52ff8$var$BS + $f68f332138d52ff8$var$Ax + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$AU + $f68f332138d52ff8$var$BN + $f68f332138d52ff8$var$Gi + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$TF + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$GR + $f68f332138d52ff8$var$A,
    2,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$AU + $f68f332138d52ff8$var$BN + $f68f332138d52ff8$var$HI + $f68f332138d52ff8$var$A,
    2,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$Gn + $f68f332138d52ff8$var$HY + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$n + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$R + " +towgs84=-83.11,-97.38,-117.22,0.00569291,-0.0446976,0.0442851,0.1218" + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$c + $f68f332138d52ff8$var$NM + $f68f332138d52ff8$var$A,
    4,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$Rq + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$aK + $f68f332138d52ff8$var$RE + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$IR + $f68f332138d52ff8$var$Bh + $f68f332138d52ff8$var$Av + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$By + $f68f332138d52ff8$var$Ay + $f68f332138d52ff8$var$JR + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$By + $f68f332138d52ff8$var$Ay + $f68f332138d52ff8$var$NN + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$RB + $f68f332138d52ff8$var$RC + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$i + $f68f332138d52ff8$var$TG + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$HK + $f68f332138d52ff8$var$Gv + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$By + $f68f332138d52ff8$var$Ay + $f68f332138d52ff8$var$Tb + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$GL + $f68f332138d52ff8$var$Bz + $f68f332138d52ff8$var$BV + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$c + $f68f332138d52ff8$var$Qh + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$Hc + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$AX + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$c + $f68f332138d52ff8$var$TR + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$c + " +towgs84=-90,40,88,0,0,0,0" + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$AU + $f68f332138d52ff8$var$BN + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$i + $f68f332138d52ff8$var$GC + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$OV + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$R + " +towgs84=-333,-222,114,0,0,0,0" + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$c + " +towgs84=41,-220,-134,0,0,0,0" + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$HZ + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$Qd + $f68f332138d52ff8$var$A,
    2,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$AU + $f68f332138d52ff8$var$BN + $f68f332138d52ff8$var$IO + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$Tc + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$c + $f68f332138d52ff8$var$GS + $f68f332138d52ff8$var$A,
    2,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$CK + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$AU + $f68f332138d52ff8$var$BN + $f68f332138d52ff8$var$NO + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$A,
    2,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$c + $f68f332138d52ff8$var$DO + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$TS + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$W + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$Hn + $f68f332138d52ff8$var$EL + $f68f332138d52ff8$var$Aa + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$JL + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$AU + $f68f332138d52ff8$var$BN + $f68f332138d52ff8$var$Bk + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$aJ + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$PV + $f68f332138d52ff8$var$Lx + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$PV + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$PV + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$Nc + $f68f332138d52ff8$var$Nd + $f68f332138d52ff8$var$DS + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$AU + $f68f332138d52ff8$var$BN + $f68f332138d52ff8$var$TH + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$QO + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$Gn + $f68f332138d52ff8$var$A,
    2,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$Fv + $f68f332138d52ff8$var$A,
    3,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$Nn + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$HB + $f68f332138d52ff8$var$Bt + $f68f332138d52ff8$var$A,
    2,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$A,
    2,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$HD + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$Lo + $f68f332138d52ff8$var$GD + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$Ok + $f68f332138d52ff8$var$Bb + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$Ok + $f68f332138d52ff8$var$Bb + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$g + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$Ee + $f68f332138d52ff8$var$Ef + $f68f332138d52ff8$var$JK + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$Gn + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$AU + $f68f332138d52ff8$var$BN + $f68f332138d52ff8$var$JC + $f68f332138d52ff8$var$A,
    2,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$c + $f68f332138d52ff8$var$Af + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$R + " +towgs84=-155,171,37,0,0,0,0" + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$AU + $f68f332138d52ff8$var$BN + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$HE + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$z + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$GP + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$AC + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$AU + $f68f332138d52ff8$var$BN + $f68f332138d52ff8$var$No + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$QP + $f68f332138d52ff8$var$A,
    2,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$j + $f68f332138d52ff8$var$MR + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$Rr + $f68f332138d52ff8$var$A,
    3,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$P + $f68f332138d52ff8$var$A,
    2,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$Q + $f68f332138d52ff8$var$A,
    2,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$A,
    64,
    $f68f332138d52ff8$var$Ck + " +lat_0=2.042583333333333 +lon_0=103.5627583333333" + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$GL + $f68f332138d52ff8$var$Bz + $f68f332138d52ff8$var$BV + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$Ck + " +lat_0=2.712283333333334 +lon_0=101.9411666666667 +x_0=-242.005 +y_0=-948.547" + $f68f332138d52ff8$var$GL + $f68f332138d52ff8$var$Bz + $f68f332138d52ff8$var$BV + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$Ck + " +lat_0=3.710972222222222 +lon_0=102.4361777777778" + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$GL + $f68f332138d52ff8$var$Bz + $f68f332138d52ff8$var$BV + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$Ck + " +lat_0=3.680344444444444 +lon_0=101.5082444444444 +x_0=-21759.438 +y_0=55960.906" + $f68f332138d52ff8$var$GL + $f68f332138d52ff8$var$Bz + $f68f332138d52ff8$var$BV + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$Ck + " +lat_0=4.946141666666667 +lon_0=102.8952083333333" + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$GL + $f68f332138d52ff8$var$Bz + $f68f332138d52ff8$var$BV + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$Ck + " +lat_0=5.421325 +lon_0=100.3458694444444" + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$GL + $f68f332138d52ff8$var$Bz + $f68f332138d52ff8$var$BV + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$Ck + " +lat_0=5.965147222222223 +lon_0=100.6375944444444" + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$GL + $f68f332138d52ff8$var$Bz + $f68f332138d52ff8$var$BV + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$Ck + " +lat_0=4.859380555555555 +lon_0=100.8167666666667" + $f68f332138d52ff8$var$s + " +y_0=133453.669" + $f68f332138d52ff8$var$GL + $f68f332138d52ff8$var$Bz + $f68f332138d52ff8$var$BV + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$Ck + " +lat_0=5.893922222222222 +lon_0=102.1772916666667" + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$GL + $f68f332138d52ff8$var$Bz + $f68f332138d52ff8$var$BV + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Lf + $f68f332138d52ff8$var$AP + $f68f332138d52ff8$var$k + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$KG + $f68f332138d52ff8$var$AP + $f68f332138d52ff8$var$k + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$KH + $f68f332138d52ff8$var$AP + $f68f332138d52ff8$var$k + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Lh + $f68f332138d52ff8$var$AP + $f68f332138d52ff8$var$k + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$SX + $f68f332138d52ff8$var$AP + $f68f332138d52ff8$var$k + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + " +lon_0=-159" + $f68f332138d52ff8$var$AP + $f68f332138d52ff8$var$k + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    0,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + " +lon_0=-159" + $f68f332138d52ff8$var$AP + $f68f332138d52ff8$var$k + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$YJ + $f68f332138d52ff8$var$AP + $f68f332138d52ff8$var$k + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Qr + $f68f332138d52ff8$var$AP + $f68f332138d52ff8$var$k + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + " +lon_0=-141" + $f68f332138d52ff8$var$AP + $f68f332138d52ff8$var$k + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$YK + $f68f332138d52ff8$var$AP + $f68f332138d52ff8$var$k + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$YT + $f68f332138d52ff8$var$AP + $f68f332138d52ff8$var$k + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + " +lon_0=-123" + $f68f332138d52ff8$var$AP + $f68f332138d52ff8$var$k + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Lj + $f68f332138d52ff8$var$AP + $f68f332138d52ff8$var$k + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$KK + $f68f332138d52ff8$var$AP + $f68f332138d52ff8$var$k + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + " +lon_0=-105" + $f68f332138d52ff8$var$AP + $f68f332138d52ff8$var$k + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=13.5 +lon_0=144.75 +k=1" + $f68f332138d52ff8$var$BU + $f68f332138d52ff8$var$IK + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + " +lat_1=-6.5 +lat_2=-11.5" + $f68f332138d52ff8$var$ZA + $f68f332138d52ff8$var$UJ + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$Ae + $f68f332138d52ff8$var$i + $f68f332138d52ff8$var$CW + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    2,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Gl + " +k=1" + $f68f332138d52ff8$var$IM + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$Ar + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$UR + $f68f332138d52ff8$var$AP + $f68f332138d52ff8$var$k + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$MP + $f68f332138d52ff8$var$AP + $f68f332138d52ff8$var$k + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$KG + $f68f332138d52ff8$var$AP + $f68f332138d52ff8$var$k + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$KH + $f68f332138d52ff8$var$AP + $f68f332138d52ff8$var$k + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Lh + $f68f332138d52ff8$var$AP + $f68f332138d52ff8$var$k + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$SX + $f68f332138d52ff8$var$AP + $f68f332138d52ff8$var$k + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + " +lon_0=-159" + $f68f332138d52ff8$var$AP + $f68f332138d52ff8$var$k + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$YJ + $f68f332138d52ff8$var$AP + $f68f332138d52ff8$var$k + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Qr + $f68f332138d52ff8$var$AP + $f68f332138d52ff8$var$k + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + " +lon_0=-141" + $f68f332138d52ff8$var$AP + $f68f332138d52ff8$var$k + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$YK + $f68f332138d52ff8$var$AP + $f68f332138d52ff8$var$k + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$YT + $f68f332138d52ff8$var$AP + $f68f332138d52ff8$var$k + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + " +lon_0=-123" + $f68f332138d52ff8$var$AP + $f68f332138d52ff8$var$k + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Lj + $f68f332138d52ff8$var$AP + $f68f332138d52ff8$var$k + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$KK + $f68f332138d52ff8$var$AP + $f68f332138d52ff8$var$k + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + " +lon_0=-105" + $f68f332138d52ff8$var$AP + $f68f332138d52ff8$var$k + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$II + " +k=1" + $f68f332138d52ff8$var$MS + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$Ar + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    3,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$GW + $f68f332138d52ff8$var$GX + $f68f332138d52ff8$var$GY + $f68f332138d52ff8$var$GA + $f68f332138d52ff8$var$h + $f68f332138d52ff8$var$IK + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$UR + $f68f332138d52ff8$var$AP + $f68f332138d52ff8$var$k + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$MP + $f68f332138d52ff8$var$AP + $f68f332138d52ff8$var$k + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    16,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Dp + $f68f332138d52ff8$var$Dq + $f68f332138d52ff8$var$y + $f68f332138d52ff8$var$Ea + $f68f332138d52ff8$var$Z + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Dl + $f68f332138d52ff8$var$Dm + $f68f332138d52ff8$var$CA + $f68f332138d52ff8$var$Oc + $f68f332138d52ff8$var$Z + $f68f332138d52ff8$var$Pv + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Fd + $f68f332138d52ff8$var$Fe + $f68f332138d52ff8$var$AL + $f68f332138d52ff8$var$CS + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    5,
    $f68f332138d52ff8$var$H + " +lat_1=-18" + $f68f332138d52ff8$var$ZT + " +lat_0=-27" + $f68f332138d52ff8$var$Il + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$A,
    4,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$ID + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    3,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$JZ + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    4,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$PJ + $f68f332138d52ff8$var$A,
    8,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ns + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Nt + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Nu + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Nw + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$NP + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$NQ + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$HP + " +k=1" + $f68f332138d52ff8$var$HU + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$HQ + " +k=1" + $f68f332138d52ff8$var$Gw + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Hd + " +k=1" + $f68f332138d52ff8$var$Hu + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$HR + " +k=1" + $f68f332138d52ff8$var$Hv + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$HS + " +k=1" + $f68f332138d52ff8$var$It + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$EN + " +k=1" + $f68f332138d52ff8$var$Hs + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Fy + " +k=1" + $f68f332138d52ff8$var$Ht + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Fm + " +k=1" + $f68f332138d52ff8$var$HV + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Fr + " +k=1" + $f68f332138d52ff8$var$Hw + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Ed + " +k=1" + $f68f332138d52ff8$var$HW + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Fn + " +k=1" + $f68f332138d52ff8$var$Hx + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$HP + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$HQ + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Hd + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$HR + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$HS + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$EN + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Fy + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Fm + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Fr + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Ed + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Fn + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$HP + " +k=1" + $f68f332138d52ff8$var$Hy + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Lt + " +k=1" + $f68f332138d52ff8$var$Hz + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$HQ + " +k=1" + $f68f332138d52ff8$var$IA + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Ni + " +k=1" + $f68f332138d52ff8$var$IB + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Hd + " +k=1" + $f68f332138d52ff8$var$Gx + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Hq + " +k=1" + $f68f332138d52ff8$var$IT + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$HR + " +k=1" + $f68f332138d52ff8$var$Gc + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Mj + " +k=1" + $f68f332138d52ff8$var$IU + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$HS + " +k=1" + $f68f332138d52ff8$var$Iu + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Jj + " +k=1" + $f68f332138d52ff8$var$Mu + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$EN + " +k=1" + $f68f332138d52ff8$var$Mv + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Le + " +k=1" + $f68f332138d52ff8$var$Mw + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Fy + " +k=1" + $f68f332138d52ff8$var$Mx + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Im + " +k=1" + $f68f332138d52ff8$var$My + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Fm + " +k=1" + $f68f332138d52ff8$var$Mz + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$KF + " +k=1" + $f68f332138d52ff8$var$NA + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Fr + " +k=1" + $f68f332138d52ff8$var$NB + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Jk + " +k=1" + $f68f332138d52ff8$var$Oh + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Ed + " +k=1" + $f68f332138d52ff8$var$NC + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Il + " +k=1" + $f68f332138d52ff8$var$Oi + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Fn + " +k=1" + $f68f332138d52ff8$var$ND + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$HP + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Lt + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$HQ + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Ni + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Hd + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Hq + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$HR + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Mj + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$HS + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Jj + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$EN + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Le + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Fy + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Im + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Fm + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$KF + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Fr + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Jk + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Ed + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Il + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Fn + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$A,
    3,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Gz + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    9,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$HP + " +k=1" + $f68f332138d52ff8$var$HU + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$HQ + " +k=1" + $f68f332138d52ff8$var$Gw + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Hd + " +k=1" + $f68f332138d52ff8$var$Hu + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$HR + " +k=1" + $f68f332138d52ff8$var$Hv + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$HS + " +k=1" + $f68f332138d52ff8$var$It + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$EN + " +k=1" + $f68f332138d52ff8$var$Hs + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Fy + " +k=1" + $f68f332138d52ff8$var$Ht + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Fm + " +k=1" + $f68f332138d52ff8$var$HV + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Fr + " +k=1" + $f68f332138d52ff8$var$Hw + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Ed + " +k=1" + $f68f332138d52ff8$var$HW + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Fn + " +k=1" + $f68f332138d52ff8$var$Hx + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$HP + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$HQ + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Hd + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$HR + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$HS + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$EN + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Fy + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Fm + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Fr + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Ed + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Fn + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    11,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$c + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$c + $f68f332138d52ff8$var$TI + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$c + $f68f332138d52ff8$var$TJ + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$c + $f68f332138d52ff8$var$TK + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$c + $f68f332138d52ff8$var$TL + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$c + $f68f332138d52ff8$var$UB + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$c + $f68f332138d52ff8$var$Sv + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$c + $f68f332138d52ff8$var$Ps + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$i + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$i + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$As + $f68f332138d52ff8$var$d + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$Jg + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$Hf + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$Jy + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$SE + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$Sz + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$x + $f68f332138d52ff8$var$Al + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$c + " +towgs84=-106,-129,165,0,0,0,0" + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$TA + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$SF + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$NH + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$TO + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$SJ + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$TP + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$Lr + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$UD + $f68f332138d52ff8$var$A,
    2,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$SG + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$QM + $f68f332138d52ff8$var$A,
    3,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$R + " +towgs84=365,194,166,0,0,0,0" + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$R + " +towgs84=325,154,172,0,0,0,0" + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$i + $f68f332138d52ff8$var$TZ + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$SH + $f68f332138d52ff8$var$A,
    2,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$Jf + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$TB + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$Ke + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$HH + $f68f332138d52ff8$var$A,
    2,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$SI + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$KB + $f68f332138d52ff8$var$AP + $f68f332138d52ff8$var$IU + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    5,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$HP + " +k=1" + $f68f332138d52ff8$var$Hy + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Lt + " +k=1" + $f68f332138d52ff8$var$Hz + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$HQ + " +k=1" + $f68f332138d52ff8$var$IA + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Ni + " +k=1" + $f68f332138d52ff8$var$IB + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Hd + " +k=1" + $f68f332138d52ff8$var$Gx + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + " +a=6377019.27 +b=6355762.5391 +towgs84=-28,199,5,0,0,0,0" + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$Jd + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$Jz + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$Qc + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$PI + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$Pt + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$Pa + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$Pb + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$j + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$R + " +towgs84=-86,-98,-119,0,0,0,0" + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$j + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$AU + $f68f332138d52ff8$var$BN + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$TT + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$Np + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$i + " +towgs84=-100,-248,259,0,0,0,0" + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$M + " +towgs84=44.585,-131.212,-39.544,0,0,0,0" + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$c + " +towgs84=-80.01,253.26,291.19,0,0,0,0" + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$c + " +towgs84=124.5,-63.5,-281,0,0,0,0" + $f68f332138d52ff8$var$A,
    2,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$By + $f68f332138d52ff8$var$Ay + $f68f332138d52ff8$var$RF + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$i + $f68f332138d52ff8$var$BX + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$R + " +towgs84=-133,-321,50,0,0,0,0" + $f68f332138d52ff8$var$A,
    2,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$Bm + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$Kc + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$Lq + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$Kg + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$Kh + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$QN + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$j + $f68f332138d52ff8$var$TD + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$j + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$i + $f68f332138d52ff8$var$CW + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$c + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$c + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$TE + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$c + $f68f332138d52ff8$var$Qf + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$c + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$c + $f68f332138d52ff8$var$GN + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$c + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$Gn + $f68f332138d52ff8$var$Qg + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$R + " +towgs84=114,-116,-333,0,0,0,0" + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$x + " +towgs84=-491,-22,435,0,0,0,0" + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$R + " +towgs84=145,75,-272,0,0,0,0" + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$R + " +towgs84=-320,550,-494,0,0,0,0" + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$R + " +towgs84=124,-234,-25,0,0,0,0" + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$R + " +towgs84=-205,107,53,0,0,0,0" + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$c + " +towgs84=-79,-129,145,0,0,0,0" + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$R + " +towgs84=-127,-769,472,0,0,0,0" + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$R + " +towgs84=-104,-129,239,0,0,0,0" + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$R + " +towgs84=298,-304,-375,0,0,0,0" + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$i + " +towgs84=-2,151,181,0,0,0,0" + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$R + " +towgs84=230,-199,-752,0,0,0,0" + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$R + " +towgs84=211,147,111,0,0,0,0" + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$P + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$JD + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$R + " +towgs84=-794,119,-298,0,0,0,0" + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$i + $f68f332138d52ff8$var$Lg + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$R + " +towgs84=208,-435,-229,0,0,0,0" + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$R + " +towgs84=189,-79,-202,0,0,0,0" + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$i + $f68f332138d52ff8$var$Ly + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$R + " +towgs84=403,-81,277,0,0,0,0" + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$R + " +towgs84=-307,-92,127,0,0,0,0" + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$Ta + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$R + " +towgs84=170,42,84,0,0,0,0" + $f68f332138d52ff8$var$A,
    2,
    $f68f332138d52ff8$var$K + " +a=6378270 +b=6356794.343434343 +towgs84=102,52,-38,0,0,0,0" + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$R + " +towgs84=276,-57,149,0,0,0,0" + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$R + " +towgs84=-632,438,-609,0,0,0,0" + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$R + " +towgs84=647,1777,-1124,0,0,0,0" + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$c + " +towgs84=260,12,-147,0,0,0,0" + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$Ee + $f68f332138d52ff8$var$Ef + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$R + " +towgs84=-156,-271,-189,0,0,0,0" + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + " +a=6378136 +b=6356751.361745712 +towgs84=0,0,1.5,-0,-0,0.076,0" + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$c + $f68f332138d52ff8$var$EU + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$c + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$UW + $f68f332138d52ff8$var$Ym + $f68f332138d52ff8$var$Nl + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$j + $f68f332138d52ff8$var$QB + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$Yn + $f68f332138d52ff8$var$Qz + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$UW + $f68f332138d52ff8$var$Ym + $f68f332138d52ff8$var$Nl + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$w + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$j + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$j + $f68f332138d52ff8$var$Fu + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$j + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$j + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$aJ + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$j + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$j + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Hq + " +k=1" + $f68f332138d52ff8$var$IT + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$HR + " +k=1" + $f68f332138d52ff8$var$Gc + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Mj + " +k=1" + $f68f332138d52ff8$var$IU + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$HS + " +k=1" + $f68f332138d52ff8$var$Iu + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Jj + " +k=1" + $f68f332138d52ff8$var$Mu + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$EN + " +k=1" + $f68f332138d52ff8$var$Mv + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Le + " +k=1" + $f68f332138d52ff8$var$Mw + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Fy + " +k=1" + $f68f332138d52ff8$var$Mx + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Im + " +k=1" + $f68f332138d52ff8$var$My + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Fm + " +k=1" + $f68f332138d52ff8$var$Mz + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$KF + " +k=1" + $f68f332138d52ff8$var$NA + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Fr + " +k=1" + $f68f332138d52ff8$var$NB + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Jk + " +k=1" + $f68f332138d52ff8$var$Oh + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Ed + " +k=1" + $f68f332138d52ff8$var$NC + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Il + " +k=1" + $f68f332138d52ff8$var$Oi + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Fn + " +k=1" + $f68f332138d52ff8$var$ND + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$HP + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Lt + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$HQ + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Ni + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Hd + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Hq + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$HR + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Mj + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$HS + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Jj + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$EN + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Le + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Fy + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Im + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Fm + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$KF + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Fr + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Jk + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Ed + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$Gf + " +pm=bern" + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$ES + " +pm=bogota" + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$EV + $f68f332138d52ff8$var$Zb + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$HZ + $f68f332138d52ff8$var$PW + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$Aw + $f68f332138d52ff8$var$Ls + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$CK + " +pm=rome" + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$AU + $f68f332138d52ff8$var$BN + $f68f332138d52ff8$var$Bk + $f68f332138d52ff8$var$Lv + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$PW + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$R + " +pm=brussels" + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$HD + $f68f332138d52ff8$var$Lv + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$AU + $f68f332138d52ff8$var$BN + $f68f332138d52ff8$var$JC + $f68f332138d52ff8$var$Lv + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Il + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    0,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Il + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$Cj + $f68f332138d52ff8$var$PW + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$Y + " +pm=stockholm" + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$Y + " +pm=athens" + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$AU + $f68f332138d52ff8$var$BN + $f68f332138d52ff8$var$Gi + $f68f332138d52ff8$var$Lv + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$Hn + $f68f332138d52ff8$var$EL + $f68f332138d52ff8$var$Aa + $f68f332138d52ff8$var$SN + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$Gh + $f68f332138d52ff8$var$Ls + $f68f332138d52ff8$var$A,
    2,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$Hf + $f68f332138d52ff8$var$PW + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$AU + $f68f332138d52ff8$var$BN + $f68f332138d52ff8$var$Lv + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Fn + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$A,
    2,
    $f68f332138d52ff8$var$H + " +lat_1=15 +lat_2=16.66666666666667 +lat_0=15.83333333333333 +lon_0=-24 +x_0=161587.83 +y_0=128511.202" + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    13,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$WK + $f68f332138d52ff8$var$WL + $f68f332138d52ff8$var$UK + $f68f332138d52ff8$var$YH + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    62,
    $f68f332138d52ff8$var$K + " +a=6376523" + $f68f332138d52ff8$var$RA + $f68f332138d52ff8$var$ZM + $f68f332138d52ff8$var$A,
    2,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$Zx + $f68f332138d52ff8$var$Qy + " +pm=madrid" + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$Pb + $f68f332138d52ff8$var$Zb + $f68f332138d52ff8$var$A,
    109,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Nr + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Os + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ja + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    2,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$BY + $f68f332138d52ff8$var$UZ + " +k=1" + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$EV + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    23,
    $f68f332138d52ff8$var$BP + $f68f332138d52ff8$var$Hr + $f68f332138d52ff8$var$Qm + $f68f332138d52ff8$var$HN + $f68f332138d52ff8$var$Rd + $f68f332138d52ff8$var$Bd + $f68f332138d52ff8$var$Cl + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$BP + $f68f332138d52ff8$var$m + " +lat_ts=-90" + $f68f332138d52ff8$var$HN + $f68f332138d52ff8$var$Rd + $f68f332138d52ff8$var$Bd + $f68f332138d52ff8$var$Cl + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    6,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ki + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    21,
    $f68f332138d52ff8$var$DT + $f68f332138d52ff8$var$Sa + $f68f332138d52ff8$var$Hl + $f68f332138d52ff8$var$ZB + $f68f332138d52ff8$var$OZ + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$DT + $f68f332138d52ff8$var$Sa + $f68f332138d52ff8$var$Hl + $f68f332138d52ff8$var$ZB + $f68f332138d52ff8$var$OZ + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$DT + $f68f332138d52ff8$var$Sa + $f68f332138d52ff8$var$Hl + $f68f332138d52ff8$var$ZB + $f68f332138d52ff8$var$OZ + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$DT + $f68f332138d52ff8$var$Sa + $f68f332138d52ff8$var$Hl + $f68f332138d52ff8$var$ZB + $f68f332138d52ff8$var$OZ + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    33,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Fk + " +lon_0=5.5 +k=1" + $f68f332138d52ff8$var$BU + $f68f332138d52ff8$var$AH + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Fk + " +lon_0=6.5 +k=1" + $f68f332138d52ff8$var$BU + $f68f332138d52ff8$var$AH + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Fk + " +lon_0=7.5 +k=1" + $f68f332138d52ff8$var$BU + $f68f332138d52ff8$var$AH + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Fk + " +lon_0=8.5 +k=1" + $f68f332138d52ff8$var$BU + $f68f332138d52ff8$var$AH + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Fk + " +lon_0=9.5 +k=1" + $f68f332138d52ff8$var$BU + $f68f332138d52ff8$var$AH + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Fk + $f68f332138d52ff8$var$YH + " +k=1" + $f68f332138d52ff8$var$BU + $f68f332138d52ff8$var$AH + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Fk + " +lon_0=11.5 +k=1" + $f68f332138d52ff8$var$BU + $f68f332138d52ff8$var$AH + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Fk + " +lon_0=12.5 +k=1" + $f68f332138d52ff8$var$BU + $f68f332138d52ff8$var$AH + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Fk + " +lon_0=13.5 +k=1" + $f68f332138d52ff8$var$BU + $f68f332138d52ff8$var$AH + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Fk + " +lon_0=14.5 +k=1" + $f68f332138d52ff8$var$BU + $f68f332138d52ff8$var$AH + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Fk + " +lon_0=15.5 +k=1" + $f68f332138d52ff8$var$BU + $f68f332138d52ff8$var$AH + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Fk + $f68f332138d52ff8$var$YE + " +k=1" + $f68f332138d52ff8$var$BU + $f68f332138d52ff8$var$AH + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Fk + " +lon_0=17.5 +k=1" + $f68f332138d52ff8$var$BU + $f68f332138d52ff8$var$AH + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Fk + " +lon_0=18.5 +k=1" + $f68f332138d52ff8$var$BU + $f68f332138d52ff8$var$AH + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Fk + " +lon_0=19.5 +k=1" + $f68f332138d52ff8$var$BU + $f68f332138d52ff8$var$AH + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Fk + " +lon_0=20.5 +k=1" + $f68f332138d52ff8$var$BU + $f68f332138d52ff8$var$AH + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Fk + " +lon_0=21.5 +k=1" + $f68f332138d52ff8$var$BU + $f68f332138d52ff8$var$AH + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Fk + " +lon_0=22.5 +k=1" + $f68f332138d52ff8$var$BU + $f68f332138d52ff8$var$AH + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Fk + " +lon_0=23.5 +k=1" + $f68f332138d52ff8$var$BU + $f68f332138d52ff8$var$AH + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Fk + " +lon_0=24.5 +k=1" + $f68f332138d52ff8$var$BU + $f68f332138d52ff8$var$AH + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Fk + " +lon_0=25.5 +k=1" + $f68f332138d52ff8$var$BU + $f68f332138d52ff8$var$AH + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Fk + " +lon_0=26.5 +k=1" + $f68f332138d52ff8$var$BU + $f68f332138d52ff8$var$AH + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Fk + " +lon_0=27.5 +k=1" + $f68f332138d52ff8$var$BU + $f68f332138d52ff8$var$AH + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Fk + " +lon_0=28.5 +k=1" + $f68f332138d52ff8$var$BU + $f68f332138d52ff8$var$AH + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Fk + " +lon_0=29.5 +k=1" + $f68f332138d52ff8$var$BU + $f68f332138d52ff8$var$AH + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Fk + " +lon_0=30.5 +k=1" + $f68f332138d52ff8$var$BU + $f68f332138d52ff8$var$AH + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    2,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$A,
    35,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Ch + $f68f332138d52ff8$var$NX + " +k=1" + $f68f332138d52ff8$var$h + $f68f332138d52ff8$var$Ae + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Ch + $f68f332138d52ff8$var$Rt + " +k=1" + $f68f332138d52ff8$var$h + " +y_0=550000" + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Ch + $f68f332138d52ff8$var$Ru + " +k=1" + $f68f332138d52ff8$var$h + $f68f332138d52ff8$var$Ae + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Ch + $f68f332138d52ff8$var$Rt + " +k=1" + $f68f332138d52ff8$var$h + $f68f332138d52ff8$var$Ae + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Ch + $f68f332138d52ff8$var$Ed + " +k=1" + $f68f332138d52ff8$var$h + $f68f332138d52ff8$var$Ae + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Ch + $f68f332138d52ff8$var$NX + " +k=1" + $f68f332138d52ff8$var$h + $f68f332138d52ff8$var$Ae + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Ch + " +lon_0=125.0028902777778 +k=1" + $f68f332138d52ff8$var$h + $f68f332138d52ff8$var$Ae + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Ch + $f68f332138d52ff8$var$WM + " +k=1" + $f68f332138d52ff8$var$h + $f68f332138d52ff8$var$Ae + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Ch + $f68f332138d52ff8$var$WM + " +k=1" + $f68f332138d52ff8$var$h + " +y_0=550000" + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Ch + " +lon_0=129.0028902777778 +k=1" + $f68f332138d52ff8$var$h + $f68f332138d52ff8$var$Ae + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Ch + " +lon_0=131.0028902777778 +k=1" + $f68f332138d52ff8$var$h + $f68f332138d52ff8$var$Ae + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Ch + $f68f332138d52ff8$var$Pj + $f68f332138d52ff8$var$AP + $f68f332138d52ff8$var$BZ + $f68f332138d52ff8$var$Cl + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Ch + $f68f332138d52ff8$var$Pj + $f68f332138d52ff8$var$AP + $f68f332138d52ff8$var$BZ + $f68f332138d52ff8$var$Cl + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Ch + $f68f332138d52ff8$var$Ru + " +k=1" + $f68f332138d52ff8$var$h + $f68f332138d52ff8$var$Ae + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Ch + $f68f332138d52ff8$var$Rt + " +k=1" + $f68f332138d52ff8$var$h + $f68f332138d52ff8$var$Ae + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Ch + $f68f332138d52ff8$var$Rt + " +k=1" + $f68f332138d52ff8$var$h + " +y_0=550000" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Ch + $f68f332138d52ff8$var$Ed + " +k=1" + $f68f332138d52ff8$var$h + $f68f332138d52ff8$var$Ae + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Ch + $f68f332138d52ff8$var$NX + " +k=1" + $f68f332138d52ff8$var$h + $f68f332138d52ff8$var$Ae + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Ch + $f68f332138d52ff8$var$Ru + " +k=1" + $f68f332138d52ff8$var$h + $f68f332138d52ff8$var$Qn + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Ch + $f68f332138d52ff8$var$Rt + " +k=1" + $f68f332138d52ff8$var$h + $f68f332138d52ff8$var$Qn + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Ch + $f68f332138d52ff8$var$Ed + " +k=1" + $f68f332138d52ff8$var$h + $f68f332138d52ff8$var$Qn + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Ch + $f68f332138d52ff8$var$NX + " +k=1" + $f68f332138d52ff8$var$h + $f68f332138d52ff8$var$Qn + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    33,
    $f68f332138d52ff8$var$Rp + $f68f332138d52ff8$var$SS + " +lon_0=42.5" + $f68f332138d52ff8$var$Kk + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$Gh + $f68f332138d52ff8$var$Ls + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    2,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$IH + $f68f332138d52ff8$var$AP + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$Ae + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    5,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$Lz + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$Lz + $f68f332138d52ff8$var$Ls + $f68f332138d52ff8$var$A,
    4,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$By + $f68f332138d52ff8$var$Ay + $f68f332138d52ff8$var$Kf + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=7.000480277777778 +lon_0=80.77171111111112 +k=0.9999238418" + $f68f332138d52ff8$var$h + $f68f332138d52ff8$var$IK + $f68f332138d52ff8$var$By + $f68f332138d52ff8$var$Ay + $f68f332138d52ff8$var$Tb + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=7.000471527777778 +lon_0=80.77171308333334 +k=0.9999238418" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$Ae + $f68f332138d52ff8$var$By + $f68f332138d52ff8$var$Ay + $f68f332138d52ff8$var$Kf + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    8,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$WK + $f68f332138d52ff8$var$WL + $f68f332138d52ff8$var$UK + $f68f332138d52ff8$var$YH + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    3,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$CU + $f68f332138d52ff8$var$Qi + $f68f332138d52ff8$var$Yz + $f68f332138d52ff8$var$aU + $f68f332138d52ff8$var$Ph + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$KE + $f68f332138d52ff8$var$If + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    5,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$HO + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Ia + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$IG + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$PN + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$LN + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$PO + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$JS + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    5,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$A,
    2,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Hq + " +k=1" + $f68f332138d52ff8$var$Bv + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    3,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$HO + " +k=1" + $f68f332138d52ff8$var$MT + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Ia + " +k=1" + $f68f332138d52ff8$var$LY + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$IG + " +k=1" + $f68f332138d52ff8$var$Jp + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$PN + " +k=1" + $f68f332138d52ff8$var$LZ + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$LN + " +k=1" + $f68f332138d52ff8$var$HU + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$PO + " +k=1" + $f68f332138d52ff8$var$Gw + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$JS + " +k=1" + $f68f332138d52ff8$var$Hu + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    17,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + " +lon_0=90.73333333333333 +k=1" + $f68f332138d52ff8$var$Bv + $f68f332138d52ff8$var$DU + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + " +lon_0=89.55 +k=1" + $f68f332138d52ff8$var$Bv + $f68f332138d52ff8$var$DU + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$WN + " +k=1" + $f68f332138d52ff8$var$Bv + $f68f332138d52ff8$var$DU + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + " +lon_0=90.03333333333333 +k=1" + $f68f332138d52ff8$var$Bv + $f68f332138d52ff8$var$DU + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + " +lon_0=90.15000000000001 +k=1" + $f68f332138d52ff8$var$Bv + $f68f332138d52ff8$var$DU + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + " +lon_0=91.13333333333334 +k=1" + $f68f332138d52ff8$var$Bv + $f68f332138d52ff8$var$DU + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + " +lon_0=91.23333333333333 +k=1" + $f68f332138d52ff8$var$Bv + $f68f332138d52ff8$var$DU + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + " +lon_0=89.34999999999999 +k=1" + $f68f332138d52ff8$var$Bv + $f68f332138d52ff8$var$DU + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + " +lon_0=91.34999999999999 +k=1" + $f68f332138d52ff8$var$Bv + $f68f332138d52ff8$var$DU + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$WN + " +k=1" + $f68f332138d52ff8$var$Bv + $f68f332138d52ff8$var$DU + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$WO + " +k=1" + $f68f332138d52ff8$var$Bv + $f68f332138d52ff8$var$DU + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + " +lon_0=89.06666666666666 +k=1" + $f68f332138d52ff8$var$Bv + $f68f332138d52ff8$var$DU + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + " +lon_0=90.26666666666667 +k=1" + $f68f332138d52ff8$var$Bv + $f68f332138d52ff8$var$DU + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + " +lon_0=89.55 +k=1" + $f68f332138d52ff8$var$Bv + $f68f332138d52ff8$var$DU + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + " +lon_0=91.75 +k=1" + $f68f332138d52ff8$var$Bv + $f68f332138d52ff8$var$DU + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + " +lon_0=90.5 +k=1" + $f68f332138d52ff8$var$Bv + $f68f332138d52ff8$var$DU + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + " +lon_0=90.16666666666667 +k=1" + $f68f332138d52ff8$var$Bv + $f68f332138d52ff8$var$DU + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + " +lon_0=90.11666666666666 +k=1" + $f68f332138d52ff8$var$Bv + $f68f332138d52ff8$var$DU + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$WO + " +k=1" + $f68f332138d52ff8$var$Bv + $f68f332138d52ff8$var$DU + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + " +lon_0=90.86666666666666 +k=1" + $f68f332138d52ff8$var$Bv + $f68f332138d52ff8$var$DU + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    5,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + " +lon_0=-7 +k=0.999997" + $f68f332138d52ff8$var$h + " +y_0=-6000000" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    4,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$YI + " +lat_2=54.5" + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$NV + $f68f332138d52ff8$var$BZ + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$YI + " +lat_2=54.5" + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$NV + $f68f332138d52ff8$var$BZ + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    3,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + " +lat_1=64.25 +lat_2=65.75 +lat_0=65 +lon_0=-19" + $f68f332138d52ff8$var$Jv + $f68f332138d52ff8$var$Hk + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    4,
    $f68f332138d52ff8$var$JU + $f68f332138d52ff8$var$PC + $f68f332138d52ff8$var$ZP + $f68f332138d52ff8$var$Pl + $f68f332138d52ff8$var$Qp + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$Hf + $f68f332138d52ff8$var$PW + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$JU + $f68f332138d52ff8$var$PC + $f68f332138d52ff8$var$ZP + $f68f332138d52ff8$var$Pl + $f68f332138d52ff8$var$Qp + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$Cj + $f68f332138d52ff8$var$PW + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$JU + $f68f332138d52ff8$var$PC + $f68f332138d52ff8$var$ZP + $f68f332138d52ff8$var$Pl + $f68f332138d52ff8$var$Qp + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$HZ + $f68f332138d52ff8$var$PW + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    6,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Nr + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$Ec + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    3,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$A,
    3,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$m + $f68f332138d52ff8$var$UQ + " +k=1" + $f68f332138d52ff8$var$AV + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$m + $f68f332138d52ff8$var$MP + " +k=1" + $f68f332138d52ff8$var$Ci + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$m + $f68f332138d52ff8$var$Pe + " +k=1" + $f68f332138d52ff8$var$Bo + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$m + $f68f332138d52ff8$var$Qk + " +k=1" + $f68f332138d52ff8$var$DP + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$m + $f68f332138d52ff8$var$US + " +k=1" + $f68f332138d52ff8$var$Eg + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$m + $f68f332138d52ff8$var$Zc + " +k=1" + $f68f332138d52ff8$var$Jt + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$m + $f68f332138d52ff8$var$Nb + " +k=1" + $f68f332138d52ff8$var$IM + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    5,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Gz + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Hi + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$ID + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    3,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Hi + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$IC + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    3,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$j + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$A,
    2,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$NV + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$j + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    4,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$A,
    2,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$A,
    8,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$j + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$ID + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$j + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Io + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$j + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    4,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$IC + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    2,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Hi + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    4,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$A,
    3,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Os + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    55,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$i + $f68f332138d52ff8$var$Bp + $f68f332138d52ff8$var$A,
    5,
    $f68f332138d52ff8$var$H + " +lat_1=10.46666666666667 +lat_0=10.46666666666667 +lon_0=-84.33333333333333 +k_0=0.99995696" + $f68f332138d52ff8$var$O + " +y_0=271820.522" + $f68f332138d52ff8$var$i + $f68f332138d52ff8$var$Bp + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + " +lat_1=9 +lat_0=9" + $f68f332138d52ff8$var$Ua + " +k_0=0.99995696" + $f68f332138d52ff8$var$O + " +y_0=327987.436" + $f68f332138d52ff8$var$i + $f68f332138d52ff8$var$Bp + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    2,
    $f68f332138d52ff8$var$H + " +lat_1=14.9 +lat_0=14.9" + $f68f332138d52ff8$var$Bx + " +k_0=0.99989906" + $f68f332138d52ff8$var$O + " +y_0=325992.681" + $f68f332138d52ff8$var$i + $f68f332138d52ff8$var$Bp + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + " +lat_1=13.78333333333333 +lat_0=13.78333333333333 +lon_0=-89 +k_0=0.99996704" + $f68f332138d52ff8$var$O + " +y_0=295809.184" + $f68f332138d52ff8$var$i + $f68f332138d52ff8$var$Bp + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + " +lat_1=13.86666666666667 +lat_0=13.86666666666667" + $f68f332138d52ff8$var$To + " +k_0=0.99990314" + $f68f332138d52ff8$var$O + " +y_0=359891.816" + $f68f332138d52ff8$var$i + $f68f332138d52ff8$var$Bp + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + " +lat_1=11.73333333333333 +lat_0=11.73333333333333" + $f68f332138d52ff8$var$To + " +k_0=0.9999222800000001" + $f68f332138d52ff8$var$O + " +y_0=288876.327" + $f68f332138d52ff8$var$i + $f68f332138d52ff8$var$Bp + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ik + $f68f332138d52ff8$var$x + $f68f332138d52ff8$var$Al + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$Ee + $f68f332138d52ff8$var$Ef + $f68f332138d52ff8$var$A,
    3,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$i + $f68f332138d52ff8$var$A,
    2,
    $f68f332138d52ff8$var$H + " +lat_1=8.416666666666666 +lat_0=8.416666666666666 +lon_0=-80 +k_0=0.99989909" + $f68f332138d52ff8$var$O + " +y_0=294865.303" + $f68f332138d52ff8$var$i + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    3,
    $f68f332138d52ff8$var$UU + " +lat_0=8.25" + $f68f332138d52ff8$var$CR + " +x_0=914391.7962 +y_0=999404.7217154861" + $f68f332138d52ff8$var$i + " +to_meter=0.9143917962" + $f68f332138d52ff8$var$A,
    7,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Ai + $f68f332138d52ff8$var$Aj + " +lat_0=-78 +lon_0=163" + $f68f332138d52ff8$var$Tp + $f68f332138d52ff8$var$Ju + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + " +lat_1=-73.66666666666667" + $f68f332138d52ff8$var$AZ + " +lat_0=-74.5" + $f68f332138d52ff8$var$NZ + $f68f332138d52ff8$var$LX + $f68f332138d52ff8$var$Fq + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + " +lat_1=-70.66666666666667 +lat_2=-72.33333333333333 +lat_0=-71.5" + $f68f332138d52ff8$var$ZW + $f68f332138d52ff8$var$aH + $f68f332138d52ff8$var$AH + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$BP + $f68f332138d52ff8$var$m + " +lat_ts=-90" + $f68f332138d52ff8$var$Ry + $f68f332138d52ff8$var$Rd + $f68f332138d52ff8$var$LX + $f68f332138d52ff8$var$AH + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    7,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Gz + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    23,
    $f68f332138d52ff8$var$Rp + $f68f332138d52ff8$var$SS + $f68f332138d52ff8$var$WP + $f68f332138d52ff8$var$Kk + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$Gh + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$Rp + $f68f332138d52ff8$var$SS + $f68f332138d52ff8$var$WP + $f68f332138d52ff8$var$Kk + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$Gh + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    4,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Za + $f68f332138d52ff8$var$Si + " +k=1" + $f68f332138d52ff8$var$Qo + " +y_0=650000" + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$TT + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Za + $f68f332138d52ff8$var$Si + " +k=1" + $f68f332138d52ff8$var$Qo + " +y_0=650000" + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$Np + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Or + " +k=1" + $f68f332138d52ff8$var$AV + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$AC + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    3,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + " +lon_0=11.5" + $f68f332138d52ff8$var$AP + $f68f332138d52ff8$var$AV + $f68f332138d52ff8$var$EM + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$A,
    3,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$x + $f68f332138d52ff8$var$BK + $f68f332138d52ff8$var$A,
    3,
    $f68f332138d52ff8$var$UU + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Nb + $f68f332138d52ff8$var$LX + $f68f332138d52ff8$var$Ak + $f68f332138d52ff8$var$x + $f68f332138d52ff8$var$BK + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$ID + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$x + $f68f332138d52ff8$var$BK + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    2,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$MB + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$x + $f68f332138d52ff8$var$BK + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Nx + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$x + $f68f332138d52ff8$var$BK + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Nr + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$x + $f68f332138d52ff8$var$BK + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$ID + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Io + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$MB + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Nx + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    7,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$A,
    4,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Nv + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$PM + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Re + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    7,
    $f68f332138d52ff8$var$H + " +lat_1=16.81666666666667 +lat_0=16.81666666666667" + $f68f332138d52ff8$var$Bx + " +k_0=0.99992226" + $f68f332138d52ff8$var$O + " +y_0=292209.579" + $f68f332138d52ff8$var$i + $f68f332138d52ff8$var$Bp + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    2,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$BO + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Gl + " +k=1" + $f68f332138d52ff8$var$DP + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$BO + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$HO + " +k=1" + $f68f332138d52ff8$var$Eg + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$BO + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$IG + " +k=1" + $f68f332138d52ff8$var$Jt + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$BO + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$LN + " +k=1" + $f68f332138d52ff8$var$IM + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$BO + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Gl + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$BO + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$HO + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$BO + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$IG + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$BO + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$LN + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$BO + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    19,
    $f68f332138d52ff8$var$GU + $f68f332138d52ff8$var$Iq + $f68f332138d52ff8$var$Zy + $f68f332138d52ff8$var$ST + $f68f332138d52ff8$var$Ab + " +y_0=304800" + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$t + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=17.06124194444444 +lon_0=-88.6318575 +k=1 +x_0=66220.02833082761 +y_0=135779.5099885299" + $f68f332138d52ff8$var$Ee + $f68f332138d52ff8$var$Ef + $f68f332138d52ff8$var$ML + $f68f332138d52ff8$var$A,
    4,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$A,
    3,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + " +lon_0=11.33333333333333 +k=1" + $f68f332138d52ff8$var$BZ + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    27,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Fo + $f68f332138d52ff8$var$Ua + " +k=0.999942857" + $f68f332138d52ff8$var$e + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Fo + $f68f332138d52ff8$var$EY + $f68f332138d52ff8$var$Hm + $f68f332138d52ff8$var$e + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Fo + " +lon_0=-88.75" + $f68f332138d52ff8$var$Hm + $f68f332138d52ff8$var$e + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    2,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$ZO + $f68f332138d52ff8$var$AP + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$n + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    2,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$JZ + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$j + $f68f332138d52ff8$var$KR + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    2,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$KB + " +k=1" + $f68f332138d52ff8$var$Ci + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$b + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Yw + $f68f332138d52ff8$var$QY + $f68f332138d52ff8$var$PU + $f68f332138d52ff8$var$Lu + $f68f332138d52ff8$var$LU + $f68f332138d52ff8$var$RU + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$He + $f68f332138d52ff8$var$PU + $f68f332138d52ff8$var$Lu + $f68f332138d52ff8$var$RV + $f68f332138d52ff8$var$RW + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Yw + $f68f332138d52ff8$var$QY + $f68f332138d52ff8$var$PU + $f68f332138d52ff8$var$Lu + $f68f332138d52ff8$var$LU + $f68f332138d52ff8$var$RU + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$He + $f68f332138d52ff8$var$PU + $f68f332138d52ff8$var$Lu + $f68f332138d52ff8$var$RV + $f68f332138d52ff8$var$RW + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$He + $f68f332138d52ff8$var$PU + $f68f332138d52ff8$var$Lu + $f68f332138d52ff8$var$RV + $f68f332138d52ff8$var$RW + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Yw + $f68f332138d52ff8$var$QY + $f68f332138d52ff8$var$PU + $f68f332138d52ff8$var$Lu + $f68f332138d52ff8$var$LU + $f68f332138d52ff8$var$RU + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$He + $f68f332138d52ff8$var$PU + $f68f332138d52ff8$var$Lu + $f68f332138d52ff8$var$RV + $f68f332138d52ff8$var$RW + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Yw + $f68f332138d52ff8$var$QY + $f68f332138d52ff8$var$PU + $f68f332138d52ff8$var$Lu + $f68f332138d52ff8$var$LU + $f68f332138d52ff8$var$RU + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    2,
    $f68f332138d52ff8$var$JU + " +lon_0=-43 +lat_ts=-2" + $f68f332138d52ff8$var$LX + $f68f332138d52ff8$var$Ak + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    2,
    $f68f332138d52ff8$var$H + " +lat_1=52.66666666666666 +lat_2=54.33333333333334 +lat_0=48" + $f68f332138d52ff8$var$Lu + " +x_0=815000" + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$n + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$JM + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    2,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Fp + $f68f332138d52ff8$var$LW + $f68f332138d52ff8$var$JA + $f68f332138d52ff8$var$AG + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    3,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Or + $f68f332138d52ff8$var$AP + $f68f332138d52ff8$var$Gc + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Gj + $f68f332138d52ff8$var$AP + $f68f332138d52ff8$var$Iu + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Or + $f68f332138d52ff8$var$AP + $f68f332138d52ff8$var$Gc + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$KB + $f68f332138d52ff8$var$AP + $f68f332138d52ff8$var$IU + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Gj + $f68f332138d52ff8$var$AP + $f68f332138d52ff8$var$Iu + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Fp + $f68f332138d52ff8$var$LW + $f68f332138d52ff8$var$JA + $f68f332138d52ff8$var$AG + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Fp + $f68f332138d52ff8$var$LW + $f68f332138d52ff8$var$JA + $f68f332138d52ff8$var$AG + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    4,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$KB + $f68f332138d52ff8$var$AP + " +x_0=500053 +y_0=-3999820" + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$CK + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    4,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Gj + " +k=1" + $f68f332138d52ff8$var$Bo + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$b + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$KB + " +k=1" + $f68f332138d52ff8$var$Ci + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$Ar + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Gj + " +k=1" + $f68f332138d52ff8$var$Bo + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$Ar + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$KB + " +k=1" + $f68f332138d52ff8$var$Bo + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$IH + " +k=1" + $f68f332138d52ff8$var$DP + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$IH + " +k=1" + $f68f332138d52ff8$var$DP + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Gj + " +k=1" + $f68f332138d52ff8$var$Eg + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$KB + " +k=1" + $f68f332138d52ff8$var$Bo + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$b + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$IH + " +k=1" + $f68f332138d52ff8$var$DP + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$b + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Gj + " +k=1" + $f68f332138d52ff8$var$Eg + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$b + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$KB + " +k=1" + $f68f332138d52ff8$var$Bo + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$Ar + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$IH + " +k=1" + $f68f332138d52ff8$var$DP + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$Ar + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Gj + " +k=1" + $f68f332138d52ff8$var$Eg + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$Ar + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$ZO + " +k=1" + $f68f332138d52ff8$var$Ci + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$AC + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$KB + " +k=1" + $f68f332138d52ff8$var$Bo + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$AC + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$IH + " +k=1" + $f68f332138d52ff8$var$DP + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$AC + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Gj + " +k=1" + $f68f332138d52ff8$var$Eg + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$AC + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Or + " +k=1" + $f68f332138d52ff8$var$AV + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$AC + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$ZO + " +k=1" + $f68f332138d52ff8$var$Ci + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$KB + " +k=1" + $f68f332138d52ff8$var$Bo + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$IH + " +k=1" + $f68f332138d52ff8$var$DP + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Gj + " +k=1" + $f68f332138d52ff8$var$Eg + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    15,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$SK + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    125,
    $f68f332138d52ff8$var$D + " +lat_0=-35.31773627777778 +lon_0=149.0092948305555 +k=1.000086" + $f68f332138d52ff8$var$h + $f68f332138d52ff8$var$Qn + $f68f332138d52ff8$var$x + $f68f332138d52ff8$var$r + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    11,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$KD + $f68f332138d52ff8$var$j + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Me + $f68f332138d52ff8$var$j + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    2,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ik + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    3,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$IH + $f68f332138d52ff8$var$AP + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$Ak + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    2,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Ia + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$Ak + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    14,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Io + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$x + $f68f332138d52ff8$var$BK + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    17,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$IC + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$x + $f68f332138d52ff8$var$BK + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Hi + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$x + $f68f332138d52ff8$var$BK + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Gz + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$x + $f68f332138d52ff8$var$BK + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    2,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$JZ + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$PJ + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$UU + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Nb + $f68f332138d52ff8$var$LX + $f68f332138d52ff8$var$Ak + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    6,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$KH + $f68f332138d52ff8$var$AP + $f68f332138d52ff8$var$AV + $f68f332138d52ff8$var$Ju + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    3,
    $f68f332138d52ff8$var$BP + $f68f332138d52ff8$var$Hr + " +lat_ts=70" + $f68f332138d52ff8$var$Hq + " +k=1" + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$ZZ + $f68f332138d52ff8$var$Ri + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    31,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$ZC + $f68f332138d52ff8$var$IJ + $f68f332138d52ff8$var$Ih + $f68f332138d52ff8$var$KK + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$ZC + $f68f332138d52ff8$var$IJ + $f68f332138d52ff8$var$Ih + $f68f332138d52ff8$var$UT + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$ZC + $f68f332138d52ff8$var$IJ + $f68f332138d52ff8$var$Ih + $f68f332138d52ff8$var$IG + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$ZC + $f68f332138d52ff8$var$IJ + $f68f332138d52ff8$var$Ih + $f68f332138d52ff8$var$EN + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$ZC + $f68f332138d52ff8$var$IJ + $f68f332138d52ff8$var$Ih + $f68f332138d52ff8$var$KG + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Ic + $f68f332138d52ff8$var$ZD + $f68f332138d52ff8$var$Ii + $f68f332138d52ff8$var$KK + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Ic + $f68f332138d52ff8$var$ZD + $f68f332138d52ff8$var$Ii + $f68f332138d52ff8$var$UT + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Ic + $f68f332138d52ff8$var$ZD + $f68f332138d52ff8$var$Ii + $f68f332138d52ff8$var$IG + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Ic + $f68f332138d52ff8$var$ZD + $f68f332138d52ff8$var$Ii + $f68f332138d52ff8$var$EN + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Ic + $f68f332138d52ff8$var$ZD + $f68f332138d52ff8$var$Ii + $f68f332138d52ff8$var$KG + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$ZE + $f68f332138d52ff8$var$ZF + $f68f332138d52ff8$var$Ij + $f68f332138d52ff8$var$KK + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$ZE + $f68f332138d52ff8$var$ZF + $f68f332138d52ff8$var$Ij + $f68f332138d52ff8$var$UT + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$ZE + $f68f332138d52ff8$var$ZF + $f68f332138d52ff8$var$Ij + $f68f332138d52ff8$var$IG + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$ZE + $f68f332138d52ff8$var$ZF + $f68f332138d52ff8$var$Ij + $f68f332138d52ff8$var$EN + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$ZE + $f68f332138d52ff8$var$ZF + $f68f332138d52ff8$var$Ij + $f68f332138d52ff8$var$KG + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$BP + $f68f332138d52ff8$var$Hr + $f68f332138d52ff8$var$Qm + $f68f332138d52ff8$var$ON + $f68f332138d52ff8$var$Rd + $f68f332138d52ff8$var$Bd + $f68f332138d52ff8$var$Cl + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$BP + $f68f332138d52ff8$var$Hr + $f68f332138d52ff8$var$Qm + $f68f332138d52ff8$var$CS + $f68f332138d52ff8$var$Rd + $f68f332138d52ff8$var$Bd + $f68f332138d52ff8$var$Cl + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$BP + $f68f332138d52ff8$var$Hr + $f68f332138d52ff8$var$Qm + " +lon_0=-33" + $f68f332138d52ff8$var$Rd + $f68f332138d52ff8$var$Bd + $f68f332138d52ff8$var$Cl + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$BP + $f68f332138d52ff8$var$Hr + $f68f332138d52ff8$var$Qm + $f68f332138d52ff8$var$QR + $f68f332138d52ff8$var$Rd + $f68f332138d52ff8$var$Bd + $f68f332138d52ff8$var$Cl + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$BP + $f68f332138d52ff8$var$Hr + $f68f332138d52ff8$var$Qm + $f68f332138d52ff8$var$EN + $f68f332138d52ff8$var$Rd + $f68f332138d52ff8$var$Bd + $f68f332138d52ff8$var$Cl + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    110,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$UL + $f68f332138d52ff8$var$Ha + $f68f332138d52ff8$var$Hb + " +lon_0=-30" + $f68f332138d52ff8$var$Hy + $f68f332138d52ff8$var$DQ + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Ce + $f68f332138d52ff8$var$Cf + $f68f332138d52ff8$var$Cg + " +lon_0=-52" + $f68f332138d52ff8$var$Hs + $f68f332138d52ff8$var$JH + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Ce + $f68f332138d52ff8$var$Cf + $f68f332138d52ff8$var$Cg + " +lon_0=-12" + $f68f332138d52ff8$var$HV + $f68f332138d52ff8$var$JH + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Bf + $f68f332138d52ff8$var$IJ + $f68f332138d52ff8$var$Bg + $f68f332138d52ff8$var$MP + $f68f332138d52ff8$var$Gx + $f68f332138d52ff8$var$IN + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Bf + $f68f332138d52ff8$var$IJ + $f68f332138d52ff8$var$Bg + $f68f332138d52ff8$var$UT + $f68f332138d52ff8$var$Gc + $f68f332138d52ff8$var$IN + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Bf + $f68f332138d52ff8$var$IJ + $f68f332138d52ff8$var$Bg + " +lon_0=-10" + $f68f332138d52ff8$var$Iu + $f68f332138d52ff8$var$IN + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Ic + $f68f332138d52ff8$var$BL + $f68f332138d52ff8$var$BM + " +lon_0=-64" + $f68f332138d52ff8$var$HV + $f68f332138d52ff8$var$Gb + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Ic + $f68f332138d52ff8$var$BL + $f68f332138d52ff8$var$BM + $f68f332138d52ff8$var$UT + $f68f332138d52ff8$var$HW + $f68f332138d52ff8$var$Gb + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Ic + $f68f332138d52ff8$var$BL + $f68f332138d52ff8$var$BM + " +lon_0=-14" + $f68f332138d52ff8$var$La + $f68f332138d52ff8$var$Gb + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$AR + $f68f332138d52ff8$var$AS + $f68f332138d52ff8$var$AT + $f68f332138d52ff8$var$NU + $f68f332138d52ff8$var$NB + $f68f332138d52ff8$var$EM + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$AR + $f68f332138d52ff8$var$AS + $f68f332138d52ff8$var$AT + " +lon_0=-42" + $f68f332138d52ff8$var$NC + $f68f332138d52ff8$var$EM + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$AR + $f68f332138d52ff8$var$AS + $f68f332138d52ff8$var$AT + " +lon_0=-22" + $f68f332138d52ff8$var$ND + $f68f332138d52ff8$var$EM + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$CI + $f68f332138d52ff8$var$OY + $f68f332138d52ff8$var$CJ + $f68f332138d52ff8$var$Zd + $f68f332138d52ff8$var$Hz + $f68f332138d52ff8$var$JI + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$CI + $f68f332138d52ff8$var$OY + $f68f332138d52ff8$var$CJ + " +lon_0=-38" + $f68f332138d52ff8$var$IB + $f68f332138d52ff8$var$JI + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$CI + $f68f332138d52ff8$var$OY + $f68f332138d52ff8$var$CJ + " +lon_0=-20" + $f68f332138d52ff8$var$IT + $f68f332138d52ff8$var$JI + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + " +lat_1=67" + $f68f332138d52ff8$var$WQ + $f68f332138d52ff8$var$WR + " +lon_0=-51" + $f68f332138d52ff8$var$Jp + $f68f332138d52ff8$var$aE + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + " +lat_1=67" + $f68f332138d52ff8$var$WQ + $f68f332138d52ff8$var$WR + " +lon_0=-34" + $f68f332138d52ff8$var$HU + $f68f332138d52ff8$var$aE + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$WS + $f68f332138d52ff8$var$WT + $f68f332138d52ff8$var$WU + " +lon_0=-52" + $f68f332138d52ff8$var$HV + " +y_0=8500000" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$WS + $f68f332138d52ff8$var$WT + $f68f332138d52ff8$var$WU + " +lon_0=-37" + $f68f332138d52ff8$var$HW + " +y_0=8500000" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Ce + $f68f332138d52ff8$var$Cf + $f68f332138d52ff8$var$Cg + " +lon_0=16" + $f68f332138d52ff8$var$HW + $f68f332138d52ff8$var$JH + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Bf + $f68f332138d52ff8$var$IJ + $f68f332138d52ff8$var$Bg + $f68f332138d52ff8$var$Gl + $f68f332138d52ff8$var$Jp + $f68f332138d52ff8$var$IN + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Ic + $f68f332138d52ff8$var$BL + $f68f332138d52ff8$var$BM + $f68f332138d52ff8$var$Lu + $f68f332138d52ff8$var$Hz + $f68f332138d52ff8$var$Gb + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Ic + $f68f332138d52ff8$var$BL + $f68f332138d52ff8$var$BM + $f68f332138d52ff8$var$ZG + $f68f332138d52ff8$var$IB + $f68f332138d52ff8$var$Gb + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$AR + $f68f332138d52ff8$var$AS + $f68f332138d52ff8$var$AT + " +lon_0=14" + $f68f332138d52ff8$var$Jp + $f68f332138d52ff8$var$EM + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$AR + $f68f332138d52ff8$var$AS + $f68f332138d52ff8$var$AT + $f68f332138d52ff8$var$ZG + $f68f332138d52ff8$var$HU + $f68f332138d52ff8$var$EM + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Ce + $f68f332138d52ff8$var$Cf + $f68f332138d52ff8$var$Cg + " +lon_0=53" + $f68f332138d52ff8$var$La + $f68f332138d52ff8$var$JH + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Ce + $f68f332138d52ff8$var$Cf + $f68f332138d52ff8$var$Cg + $f68f332138d52ff8$var$HR + $f68f332138d52ff8$var$Hz + $f68f332138d52ff8$var$JH + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Bf + $f68f332138d52ff8$var$IJ + $f68f332138d52ff8$var$Bg + " +lon_0=52" + $f68f332138d52ff8$var$HU + $f68f332138d52ff8$var$IN + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Bf + $f68f332138d52ff8$var$IJ + $f68f332138d52ff8$var$Bg + " +lon_0=83" + $f68f332138d52ff8$var$Hu + $f68f332138d52ff8$var$IN + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Bf + $f68f332138d52ff8$var$IJ + $f68f332138d52ff8$var$Bg + $f68f332138d52ff8$var$Im + $f68f332138d52ff8$var$It + $f68f332138d52ff8$var$IN + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Bf + $f68f332138d52ff8$var$IJ + $f68f332138d52ff8$var$Bg + " +lon_0=145" + $f68f332138d52ff8$var$Ht + $f68f332138d52ff8$var$IN + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Ic + $f68f332138d52ff8$var$BL + $f68f332138d52ff8$var$BM + " +lon_0=58" + $f68f332138d52ff8$var$IT + $f68f332138d52ff8$var$Gb + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Ic + $f68f332138d52ff8$var$BL + $f68f332138d52ff8$var$BM + " +lon_0=82" + $f68f332138d52ff8$var$IU + $f68f332138d52ff8$var$Gb + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Ic + $f68f332138d52ff8$var$BL + $f68f332138d52ff8$var$BM + $f68f332138d52ff8$var$ZQ + $f68f332138d52ff8$var$Mu + $f68f332138d52ff8$var$Gb + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Ic + $f68f332138d52ff8$var$BL + $f68f332138d52ff8$var$BM + " +lon_0=130" + $f68f332138d52ff8$var$Mw + $f68f332138d52ff8$var$Gb + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Ic + $f68f332138d52ff8$var$BL + $f68f332138d52ff8$var$BM + $f68f332138d52ff8$var$ZR + $f68f332138d52ff8$var$My + $f68f332138d52ff8$var$Gb + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Ic + $f68f332138d52ff8$var$BL + $f68f332138d52ff8$var$BM + " +lon_0=179" + $f68f332138d52ff8$var$NA + $f68f332138d52ff8$var$Gb + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$AR + $f68f332138d52ff8$var$AS + $f68f332138d52ff8$var$AT + $f68f332138d52ff8$var$SR + $f68f332138d52ff8$var$Hu + $f68f332138d52ff8$var$EM + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$AR + $f68f332138d52ff8$var$AS + $f68f332138d52ff8$var$AT + " +lon_0=74" + $f68f332138d52ff8$var$It + $f68f332138d52ff8$var$EM + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$AR + $f68f332138d52ff8$var$AS + $f68f332138d52ff8$var$AT + " +lon_0=95" + $f68f332138d52ff8$var$Ht + $f68f332138d52ff8$var$EM + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$AR + $f68f332138d52ff8$var$AS + $f68f332138d52ff8$var$AT + " +lon_0=116" + $f68f332138d52ff8$var$Hw + $f68f332138d52ff8$var$EM + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$AR + $f68f332138d52ff8$var$AS + $f68f332138d52ff8$var$AT + " +lon_0=137" + $f68f332138d52ff8$var$Hx + $f68f332138d52ff8$var$EM + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$AR + $f68f332138d52ff8$var$AS + $f68f332138d52ff8$var$AT + " +lon_0=158" + $f68f332138d52ff8$var$Hy + $f68f332138d52ff8$var$EM + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$AR + $f68f332138d52ff8$var$AS + $f68f332138d52ff8$var$AT + " +lon_0=179" + $f68f332138d52ff8$var$IA + $f68f332138d52ff8$var$EM + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$AR + $f68f332138d52ff8$var$AS + $f68f332138d52ff8$var$AT + " +lon_0=-163" + $f68f332138d52ff8$var$Gx + $f68f332138d52ff8$var$EM + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$AR + $f68f332138d52ff8$var$AS + $f68f332138d52ff8$var$AT + $f68f332138d52ff8$var$Qr + $f68f332138d52ff8$var$Gc + $f68f332138d52ff8$var$EM + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$CI + $f68f332138d52ff8$var$OY + $f68f332138d52ff8$var$CJ + $f68f332138d52ff8$var$SX + $f68f332138d52ff8$var$Gw + $f68f332138d52ff8$var$JI + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$CI + $f68f332138d52ff8$var$OY + $f68f332138d52ff8$var$CJ + $f68f332138d52ff8$var$Qr + $f68f332138d52ff8$var$Hv + $f68f332138d52ff8$var$JI + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$UL + $f68f332138d52ff8$var$Ha + $f68f332138d52ff8$var$Hb + $f68f332138d52ff8$var$Bu + $f68f332138d52ff8$var$Hx + $f68f332138d52ff8$var$DQ + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Ce + $f68f332138d52ff8$var$Cf + $f68f332138d52ff8$var$Cg + $f68f332138d52ff8$var$SZ + $f68f332138d52ff8$var$Gw + $f68f332138d52ff8$var$JH + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Ce + $f68f332138d52ff8$var$Cf + $f68f332138d52ff8$var$Cg + $f68f332138d52ff8$var$UR + $f68f332138d52ff8$var$Hv + $f68f332138d52ff8$var$JH + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Bf + $f68f332138d52ff8$var$IJ + $f68f332138d52ff8$var$Bg + $f68f332138d52ff8$var$YT + $f68f332138d52ff8$var$Hy + $f68f332138d52ff8$var$IN + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Bf + $f68f332138d52ff8$var$IJ + $f68f332138d52ff8$var$Bg + $f68f332138d52ff8$var$Ji + $f68f332138d52ff8$var$IA + $f68f332138d52ff8$var$IN + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Bf + $f68f332138d52ff8$var$IJ + $f68f332138d52ff8$var$Bg + $f68f332138d52ff8$var$MP + $f68f332138d52ff8$var$Gx + $f68f332138d52ff8$var$IN + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Ic + $f68f332138d52ff8$var$BL + $f68f332138d52ff8$var$BM + $f68f332138d52ff8$var$YT + $f68f332138d52ff8$var$Gw + $f68f332138d52ff8$var$Gb + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Ic + $f68f332138d52ff8$var$BL + $f68f332138d52ff8$var$BM + " +lon_0=-104" + $f68f332138d52ff8$var$Hv + $f68f332138d52ff8$var$Gb + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Ic + $f68f332138d52ff8$var$BL + $f68f332138d52ff8$var$BM + $f68f332138d52ff8$var$NW + $f68f332138d52ff8$var$Hs + $f68f332138d52ff8$var$Gb + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$AR + $f68f332138d52ff8$var$AS + $f68f332138d52ff8$var$AT + " +lon_0=-131" + $f68f332138d52ff8$var$Iu + $f68f332138d52ff8$var$EM + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$AR + $f68f332138d52ff8$var$AS + $f68f332138d52ff8$var$AT + $f68f332138d52ff8$var$KK + $f68f332138d52ff8$var$Mv + $f68f332138d52ff8$var$EM + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$AR + $f68f332138d52ff8$var$AS + $f68f332138d52ff8$var$AT + " +lon_0=-91" + $f68f332138d52ff8$var$Mx + $f68f332138d52ff8$var$EM + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$AR + $f68f332138d52ff8$var$AS + $f68f332138d52ff8$var$AT + " +lon_0=-71" + $f68f332138d52ff8$var$Mz + $f68f332138d52ff8$var$EM + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$CI + $f68f332138d52ff8$var$OY + $f68f332138d52ff8$var$CJ + " +lon_0=-132" + $f68f332138d52ff8$var$Hs + $f68f332138d52ff8$var$JI + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$CI + $f68f332138d52ff8$var$OY + $f68f332138d52ff8$var$CJ + " +lon_0=-113" + $f68f332138d52ff8$var$HV + $f68f332138d52ff8$var$JI + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$CI + $f68f332138d52ff8$var$OY + $f68f332138d52ff8$var$CJ + $f68f332138d52ff8$var$Na + $f68f332138d52ff8$var$HW + $f68f332138d52ff8$var$JI + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$CI + $f68f332138d52ff8$var$OY + $f68f332138d52ff8$var$CJ + $f68f332138d52ff8$var$UR + $f68f332138d52ff8$var$La + $f68f332138d52ff8$var$JI + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$UL + $f68f332138d52ff8$var$Ha + $f68f332138d52ff8$var$Hb + $f68f332138d52ff8$var$Ia + $f68f332138d52ff8$var$IA + $f68f332138d52ff8$var$DQ + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$UL + $f68f332138d52ff8$var$Ha + $f68f332138d52ff8$var$Hb + $f68f332138d52ff8$var$Hq + $f68f332138d52ff8$var$Gx + $f68f332138d52ff8$var$DQ + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$UL + $f68f332138d52ff8$var$Ha + $f68f332138d52ff8$var$Hb + $f68f332138d52ff8$var$Oe + $f68f332138d52ff8$var$Gc + $f68f332138d52ff8$var$DQ + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$UL + $f68f332138d52ff8$var$Ha + $f68f332138d52ff8$var$Hb + $f68f332138d52ff8$var$ON + $f68f332138d52ff8$var$Hw + $f68f332138d52ff8$var$DQ + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Ce + $f68f332138d52ff8$var$Cf + $f68f332138d52ff8$var$Cg + " +lon_0=133" + $f68f332138d52ff8$var$IB + $f68f332138d52ff8$var$JH + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Ce + $f68f332138d52ff8$var$Cf + $f68f332138d52ff8$var$Cg + $f68f332138d52ff8$var$ZW + $f68f332138d52ff8$var$LY + $f68f332138d52ff8$var$JH + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Ce + $f68f332138d52ff8$var$Cf + $f68f332138d52ff8$var$Cg + $f68f332138d52ff8$var$Ms + $f68f332138d52ff8$var$LZ + $f68f332138d52ff8$var$JH + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Bf + $f68f332138d52ff8$var$IJ + $f68f332138d52ff8$var$Bg + " +lon_0=176" + $f68f332138d52ff8$var$Hw + $f68f332138d52ff8$var$IN + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Bf + $f68f332138d52ff8$var$IJ + $f68f332138d52ff8$var$Bg + $f68f332138d52ff8$var$YJ + $f68f332138d52ff8$var$Hx + $f68f332138d52ff8$var$IN + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Ic + $f68f332138d52ff8$var$BL + $f68f332138d52ff8$var$BM + " +lon_0=-155" + $f68f332138d52ff8$var$LZ + $f68f332138d52ff8$var$Gb + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$AR + $f68f332138d52ff8$var$AS + $f68f332138d52ff8$var$AT + " +lon_0=-5" + $f68f332138d52ff8$var$ZK + $f68f332138d52ff8$var$EM + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    3,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ik + $f68f332138d52ff8$var$i + $f68f332138d52ff8$var$Lg + $f68f332138d52ff8$var$t + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ik + $f68f332138d52ff8$var$i + $f68f332138d52ff8$var$Ly + $f68f332138d52ff8$var$t + $f68f332138d52ff8$var$A,
    6,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$A,
    69,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Gl + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$Aw + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    3,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$By + $f68f332138d52ff8$var$Ay + " +towgs84=293.17,726.18,245.36,0,0,0,0" + $f68f332138d52ff8$var$A,
    3,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$MB + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Nx + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    96,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$GW + $f68f332138d52ff8$var$GX + $f68f332138d52ff8$var$GY + $f68f332138d52ff8$var$GA + $f68f332138d52ff8$var$h + $f68f332138d52ff8$var$IK + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    4,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$j + $f68f332138d52ff8$var$Kd + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$IG + $f68f332138d52ff8$var$CP + $f68f332138d52ff8$var$h + " +y_0=-3500000" + $f68f332138d52ff8$var$j + $f68f332138d52ff8$var$Kd + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    4,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Gl + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$IM + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$Aw + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    2,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$A,
    4,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$A,
    3,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$A,
    3,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Nq + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$PL + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$SK + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$TV + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Xz + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$TY + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$RG + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ro + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$RH + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$TW + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$TX + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$QE + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ns + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Nt + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Nu + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Nw + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$NP + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$NQ + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ik + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$IC + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Hi + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    2,
    $f68f332138d52ff8$var$DT + $f68f332138d52ff8$var$Sa + $f68f332138d52ff8$var$Hl + $f68f332138d52ff8$var$ZB + $f68f332138d52ff8$var$OZ + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$AR + $f68f332138d52ff8$var$AS + $f68f332138d52ff8$var$AT + " +lon_0=-163" + $f68f332138d52ff8$var$Gx + $f68f332138d52ff8$var$EM + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$AR + $f68f332138d52ff8$var$AS + $f68f332138d52ff8$var$AT + $f68f332138d52ff8$var$Qr + $f68f332138d52ff8$var$Gc + $f68f332138d52ff8$var$EM + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$CI + $f68f332138d52ff8$var$OY + $f68f332138d52ff8$var$CJ + $f68f332138d52ff8$var$SX + $f68f332138d52ff8$var$Gw + $f68f332138d52ff8$var$JI + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$CI + $f68f332138d52ff8$var$OY + $f68f332138d52ff8$var$CJ + $f68f332138d52ff8$var$Qr + $f68f332138d52ff8$var$Hv + $f68f332138d52ff8$var$JI + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$IY + $f68f332138d52ff8$var$IV + $f68f332138d52ff8$var$Pc + $f68f332138d52ff8$var$h + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Gm + $f68f332138d52ff8$var$OS + $f68f332138d52ff8$var$BG + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    6,
    $f68f332138d52ff8$var$H + " +lat_1=17.5 +lat_2=29.5 +lat_0=12 +lon_0=-102" + $f68f332138d52ff8$var$Ci + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    3,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ns + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Nt + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Nu + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Nw + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$NP + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$NQ + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + " +lat_1=17.5 +lat_2=29.5 +lat_0=12 +lon_0=-102" + $f68f332138d52ff8$var$Ci + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    9,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Gl + " +k=1" + $f68f332138d52ff8$var$AI + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$CC + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$II + " +k=1" + $f68f332138d52ff8$var$AI + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$CC + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$HO + " +k=1" + $f68f332138d52ff8$var$AI + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$CC + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Ia + " +k=1" + $f68f332138d52ff8$var$AI + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$CC + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$IG + " +k=1" + $f68f332138d52ff8$var$AI + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$CC + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$PN + " +k=1" + $f68f332138d52ff8$var$AI + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$CC + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$LN + " +k=1" + $f68f332138d52ff8$var$AI + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$CC + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    4,
    $f68f332138d52ff8$var$H + " +lat_1=19.33333333333333 +lat_2=19.7 +lat_0=19.33333333333333 +lon_0=-80.56666666666666 +x_0=899160 +y_0=579120" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$t + $f68f332138d52ff8$var$A,
    2,
    $f68f332138d52ff8$var$DT + " +lat_1=55" + $f68f332138d52ff8$var$QY + $f68f332138d52ff8$var$Yu + $f68f332138d52ff8$var$Ms + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$CU + " +lat_0=57" + $f68f332138d52ff8$var$Ku + $f68f332138d52ff8$var$Kv + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$LX + $f68f332138d52ff8$var$EO + $f68f332138d52ff8$var$KE + $f68f332138d52ff8$var$GZ + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Ft + $f68f332138d52ff8$var$YN + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Ft + $f68f332138d52ff8$var$YO + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Ft + $f68f332138d52ff8$var$ON + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Ft + $f68f332138d52ff8$var$Ms + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Ft + $f68f332138d52ff8$var$KI + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Ft + $f68f332138d52ff8$var$YP + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Ft + $f68f332138d52ff8$var$YQ + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Ft + $f68f332138d52ff8$var$SW + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Kw + $f68f332138d52ff8$var$Kx + $f68f332138d52ff8$var$UK + $f68f332138d52ff8$var$YR + $f68f332138d52ff8$var$BZ + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Bl + $f68f332138d52ff8$var$Co + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$EX + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Bl + $f68f332138d52ff8$var$Co + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$EX + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$t + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Bl + $f68f332138d52ff8$var$Cn + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$EX + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Bl + $f68f332138d52ff8$var$Cn + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$EX + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$t + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Bl + $f68f332138d52ff8$var$Iv + $f68f332138d52ff8$var$BG + $f68f332138d52ff8$var$EX + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Bl + $f68f332138d52ff8$var$Iv + $f68f332138d52ff8$var$BG + $f68f332138d52ff8$var$EX + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$t + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Dx + $f68f332138d52ff8$var$Dy + $f68f332138d52ff8$var$BC + $f68f332138d52ff8$var$IF + $f68f332138d52ff8$var$u + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Dx + $f68f332138d52ff8$var$Dy + $f68f332138d52ff8$var$BC + $f68f332138d52ff8$var$IF + $f68f332138d52ff8$var$Au + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Dz + $f68f332138d52ff8$var$Mq + $f68f332138d52ff8$var$EA + $f68f332138d52ff8$var$IF + $f68f332138d52ff8$var$u + $f68f332138d52ff8$var$Is + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Dz + $f68f332138d52ff8$var$Mq + $f68f332138d52ff8$var$EA + $f68f332138d52ff8$var$IF + $f68f332138d52ff8$var$Au + $f68f332138d52ff8$var$Gt + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$DT + $f68f332138d52ff8$var$Yy + $f68f332138d52ff8$var$SY + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Mt + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$QZ + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$DW + $f68f332138d52ff8$var$Jn + $f68f332138d52ff8$var$y + $f68f332138d52ff8$var$HA + $f68f332138d52ff8$var$Bd + $f68f332138d52ff8$var$Ae + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$DW + $f68f332138d52ff8$var$Jn + $f68f332138d52ff8$var$y + $f68f332138d52ff8$var$HA + $f68f332138d52ff8$var$Ac + $f68f332138d52ff8$var$AD + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$DX + $f68f332138d52ff8$var$DY + $f68f332138d52ff8$var$AA + $f68f332138d52ff8$var$HA + $f68f332138d52ff8$var$Bd + $f68f332138d52ff8$var$Ae + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$DX + $f68f332138d52ff8$var$DY + $f68f332138d52ff8$var$AA + $f68f332138d52ff8$var$HA + $f68f332138d52ff8$var$Ac + $f68f332138d52ff8$var$AD + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Ap + $f68f332138d52ff8$var$DZ + $f68f332138d52ff8$var$Ml + $f68f332138d52ff8$var$AJ + $f68f332138d52ff8$var$Bd + $f68f332138d52ff8$var$Ae + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Ap + $f68f332138d52ff8$var$DZ + $f68f332138d52ff8$var$Ml + $f68f332138d52ff8$var$AJ + $f68f332138d52ff8$var$Ac + $f68f332138d52ff8$var$AD + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$LO + $f68f332138d52ff8$var$QS + $f68f332138d52ff8$var$Da + $f68f332138d52ff8$var$Mm + $f68f332138d52ff8$var$Bd + $f68f332138d52ff8$var$Ae + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$LO + $f68f332138d52ff8$var$QS + $f68f332138d52ff8$var$Da + $f68f332138d52ff8$var$Mm + $f68f332138d52ff8$var$Ac + $f68f332138d52ff8$var$AD + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Db + $f68f332138d52ff8$var$Dc + $f68f332138d52ff8$var$Mn + $f68f332138d52ff8$var$Ir + $f68f332138d52ff8$var$Bd + $f68f332138d52ff8$var$Ae + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Db + $f68f332138d52ff8$var$Dc + $f68f332138d52ff8$var$Mn + $f68f332138d52ff8$var$Ir + $f68f332138d52ff8$var$Ac + $f68f332138d52ff8$var$AD + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Dd + $f68f332138d52ff8$var$De + $f68f332138d52ff8$var$Df + $f68f332138d52ff8$var$Iw + $f68f332138d52ff8$var$Bd + $f68f332138d52ff8$var$Ae + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Dd + $f68f332138d52ff8$var$De + $f68f332138d52ff8$var$Df + $f68f332138d52ff8$var$Iw + $f68f332138d52ff8$var$Ac + $f68f332138d52ff8$var$AD + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$LP + $f68f332138d52ff8$var$LQ + $f68f332138d52ff8$var$CY + $f68f332138d52ff8$var$Ba + $f68f332138d52ff8$var$Fw + $f68f332138d52ff8$var$Fx + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$LP + $f68f332138d52ff8$var$LQ + $f68f332138d52ff8$var$CY + $f68f332138d52ff8$var$Ba + $f68f332138d52ff8$var$Bw + $f68f332138d52ff8$var$CL + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Eh + $f68f332138d52ff8$var$Ei + $f68f332138d52ff8$var$y + $f68f332138d52ff8$var$Ba + $f68f332138d52ff8$var$Fw + $f68f332138d52ff8$var$Fx + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Eh + $f68f332138d52ff8$var$Ei + $f68f332138d52ff8$var$y + $f68f332138d52ff8$var$Ba + $f68f332138d52ff8$var$Bw + $f68f332138d52ff8$var$CL + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Ap + $f68f332138d52ff8$var$Dg + $f68f332138d52ff8$var$f + $f68f332138d52ff8$var$Ba + $f68f332138d52ff8$var$Fw + $f68f332138d52ff8$var$Fx + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Ap + $f68f332138d52ff8$var$Dg + $f68f332138d52ff8$var$f + $f68f332138d52ff8$var$Ba + $f68f332138d52ff8$var$Bw + $f68f332138d52ff8$var$CL + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Dh + $f68f332138d52ff8$var$Mo + $f68f332138d52ff8$var$Di + $f68f332138d52ff8$var$Jq + $f68f332138d52ff8$var$QG + $f68f332138d52ff8$var$QH + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Dh + $f68f332138d52ff8$var$Mo + $f68f332138d52ff8$var$Di + $f68f332138d52ff8$var$Jq + $f68f332138d52ff8$var$MC + $f68f332138d52ff8$var$MD + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Ch + $f68f332138d52ff8$var$Cp + $f68f332138d52ff8$var$Mp + $f68f332138d52ff8$var$h + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Ch + $f68f332138d52ff8$var$Cp + $f68f332138d52ff8$var$Mp + $f68f332138d52ff8$var$AE + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Aq + $f68f332138d52ff8$var$CR + $f68f332138d52ff8$var$Am + $f68f332138d52ff8$var$h + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Aq + $f68f332138d52ff8$var$CR + $f68f332138d52ff8$var$Am + $f68f332138d52ff8$var$AE + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$DT + " +lat_1=24" + $f68f332138d52ff8$var$YG + " +lat_0=24" + $f68f332138d52ff8$var$NV + $f68f332138d52ff8$var$u + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$LR + $f68f332138d52ff8$var$Dj + $f68f332138d52ff8$var$QT + $f68f332138d52ff8$var$LS + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$LR + $f68f332138d52ff8$var$Dj + $f68f332138d52ff8$var$QT + $f68f332138d52ff8$var$LS + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Aq + $f68f332138d52ff8$var$Ob + $f68f332138d52ff8$var$Am + $f68f332138d52ff8$var$h + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Aq + $f68f332138d52ff8$var$Ob + $f68f332138d52ff8$var$Am + $f68f332138d52ff8$var$AE + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Gm + $f68f332138d52ff8$var$Cq + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$h + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Gm + $f68f332138d52ff8$var$Cq + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$AE + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Gm + $f68f332138d52ff8$var$Cr + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$EW + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Gm + $f68f332138d52ff8$var$Cr + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$CM + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$p + $f68f332138d52ff8$var$Jb + $f68f332138d52ff8$var$BJ + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$p + $f68f332138d52ff8$var$Jb + $f68f332138d52ff8$var$BJ + $f68f332138d52ff8$var$AF + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$p + $f68f332138d52ff8$var$Cs + $f68f332138d52ff8$var$BJ + $f68f332138d52ff8$var$h + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$p + $f68f332138d52ff8$var$Cs + $f68f332138d52ff8$var$BJ + $f68f332138d52ff8$var$AE + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$p + $f68f332138d52ff8$var$Ix + $f68f332138d52ff8$var$BG + $f68f332138d52ff8$var$CX + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$p + $f68f332138d52ff8$var$Ix + $f68f332138d52ff8$var$BG + $f68f332138d52ff8$var$ME + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$f + $f68f332138d52ff8$var$Cz + $f68f332138d52ff8$var$EQ + $f68f332138d52ff8$var$AI + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$f + $f68f332138d52ff8$var$Cz + $f68f332138d52ff8$var$EQ + $f68f332138d52ff8$var$AI + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$f + $f68f332138d52ff8$var$DA + $f68f332138d52ff8$var$Am + $f68f332138d52ff8$var$EW + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$f + $f68f332138d52ff8$var$DA + $f68f332138d52ff8$var$Am + $f68f332138d52ff8$var$MO + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$DM + $f68f332138d52ff8$var$DB + $f68f332138d52ff8$var$AO + $f68f332138d52ff8$var$BU + $f68f332138d52ff8$var$KJ + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$DM + $f68f332138d52ff8$var$DB + $f68f332138d52ff8$var$AO + $f68f332138d52ff8$var$MM + $f68f332138d52ff8$var$GI + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$DM + $f68f332138d52ff8$var$DC + $f68f332138d52ff8$var$AO + $f68f332138d52ff8$var$HT + $f68f332138d52ff8$var$KJ + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$DM + $f68f332138d52ff8$var$DC + $f68f332138d52ff8$var$AO + $f68f332138d52ff8$var$HT + $f68f332138d52ff8$var$GI + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$EB + $f68f332138d52ff8$var$EC + $f68f332138d52ff8$var$Fo + $f68f332138d52ff8$var$GG + $f68f332138d52ff8$var$AV + $f68f332138d52ff8$var$AH + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$EB + $f68f332138d52ff8$var$EC + $f68f332138d52ff8$var$Fo + $f68f332138d52ff8$var$GG + $f68f332138d52ff8$var$AV + $f68f332138d52ff8$var$GJ + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$AY + $f68f332138d52ff8$var$ED + $f68f332138d52ff8$var$Fs + $f68f332138d52ff8$var$GG + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$AY + $f68f332138d52ff8$var$ED + $f68f332138d52ff8$var$Fs + $f68f332138d52ff8$var$GG + $f68f332138d52ff8$var$AG + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$EE + $f68f332138d52ff8$var$EF + $f68f332138d52ff8$var$AQ + $f68f332138d52ff8$var$Fl + $f68f332138d52ff8$var$u + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$EE + $f68f332138d52ff8$var$EF + $f68f332138d52ff8$var$AQ + $f68f332138d52ff8$var$Fl + $f68f332138d52ff8$var$Au + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$EG + $f68f332138d52ff8$var$EH + $f68f332138d52ff8$var$f + $f68f332138d52ff8$var$CV + $f68f332138d52ff8$var$u + $f68f332138d52ff8$var$Is + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$EG + $f68f332138d52ff8$var$EH + $f68f332138d52ff8$var$f + $f68f332138d52ff8$var$CV + $f68f332138d52ff8$var$Au + $f68f332138d52ff8$var$Gt + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Az + $f68f332138d52ff8$var$DV + $f68f332138d52ff8$var$DM + $f68f332138d52ff8$var$Jo + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Az + $f68f332138d52ff8$var$DV + $f68f332138d52ff8$var$DM + $f68f332138d52ff8$var$Jo + $f68f332138d52ff8$var$AF + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Fi + $f68f332138d52ff8$var$Fj + $f68f332138d52ff8$var$AB + $f68f332138d52ff8$var$EY + $f68f332138d52ff8$var$AV + $f68f332138d52ff8$var$AH + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Fi + $f68f332138d52ff8$var$Fj + $f68f332138d52ff8$var$AB + $f68f332138d52ff8$var$EY + $f68f332138d52ff8$var$AV + $f68f332138d52ff8$var$CN + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Ej + $f68f332138d52ff8$var$Ek + $f68f332138d52ff8$var$AB + $f68f332138d52ff8$var$EY + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$Ae + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Ej + $f68f332138d52ff8$var$Ek + $f68f332138d52ff8$var$AB + $f68f332138d52ff8$var$EY + $f68f332138d52ff8$var$AF + $f68f332138d52ff8$var$AD + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$FS + $f68f332138d52ff8$var$FT + $f68f332138d52ff8$var$IY + $f68f332138d52ff8$var$Hg + $f68f332138d52ff8$var$BZ + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$FS + $f68f332138d52ff8$var$FT + $f68f332138d52ff8$var$IY + $f68f332138d52ff8$var$Hg + $f68f332138d52ff8$var$Eb + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$OH + $f68f332138d52ff8$var$OI + $f68f332138d52ff8$var$OJ + $f68f332138d52ff8$var$Bi + $f68f332138d52ff8$var$BZ + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$OH + $f68f332138d52ff8$var$OI + $f68f332138d52ff8$var$OJ + $f68f332138d52ff8$var$Bi + $f68f332138d52ff8$var$Eb + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$YM + $f68f332138d52ff8$var$Rj + $f68f332138d52ff8$var$JE + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$AL + $f68f332138d52ff8$var$Rf + $f68f332138d52ff8$var$JE + $f68f332138d52ff8$var$EW + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$BD + $f68f332138d52ff8$var$Rg + $f68f332138d52ff8$var$JE + $f68f332138d52ff8$var$AI + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$AK + $f68f332138d52ff8$var$HJ + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$AI + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$AK + $f68f332138d52ff8$var$HJ + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$AI + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$BD + $f68f332138d52ff8$var$DD + $f68f332138d52ff8$var$AO + $f68f332138d52ff8$var$HT + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$BD + $f68f332138d52ff8$var$DD + $f68f332138d52ff8$var$AO + $f68f332138d52ff8$var$HT + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$MU + $f68f332138d52ff8$var$Nz + $f68f332138d52ff8$var$AA + $f68f332138d52ff8$var$Ld + $f68f332138d52ff8$var$u + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$MU + $f68f332138d52ff8$var$Nz + $f68f332138d52ff8$var$AA + $f68f332138d52ff8$var$Ld + $f68f332138d52ff8$var$MF + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Em + $f68f332138d52ff8$var$En + $f68f332138d52ff8$var$Ip + $f68f332138d52ff8$var$IL + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Em + $f68f332138d52ff8$var$En + $f68f332138d52ff8$var$Ip + $f68f332138d52ff8$var$IL + $f68f332138d52ff8$var$AF + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$El + $f68f332138d52ff8$var$Dk + $f68f332138d52ff8$var$Ip + $f68f332138d52ff8$var$GE + $f68f332138d52ff8$var$h + $f68f332138d52ff8$var$Mk + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$El + $f68f332138d52ff8$var$Dk + $f68f332138d52ff8$var$Ip + $f68f332138d52ff8$var$GE + $f68f332138d52ff8$var$AE + $f68f332138d52ff8$var$Mk + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$OA + $f68f332138d52ff8$var$Er + $f68f332138d52ff8$var$Es + $f68f332138d52ff8$var$BE + $f68f332138d52ff8$var$Pk + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$OA + $f68f332138d52ff8$var$Er + $f68f332138d52ff8$var$Es + $f68f332138d52ff8$var$BE + $f68f332138d52ff8$var$MH + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$t + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Eo + $f68f332138d52ff8$var$Ep + $f68f332138d52ff8$var$Eq + $f68f332138d52ff8$var$Jh + $f68f332138d52ff8$var$Tl + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Eo + $f68f332138d52ff8$var$Ep + $f68f332138d52ff8$var$Eq + $f68f332138d52ff8$var$Jh + $f68f332138d52ff8$var$MG + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$t + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$CU + $f68f332138d52ff8$var$Kr + " +lonc=-86" + $f68f332138d52ff8$var$QI + $f68f332138d52ff8$var$AP + $f68f332138d52ff8$var$QJ + $f68f332138d52ff8$var$PY + $f68f332138d52ff8$var$KE + $f68f332138d52ff8$var$QK + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Bq + $f68f332138d52ff8$var$OB + $f68f332138d52ff8$var$Fo + $f68f332138d52ff8$var$BE + $f68f332138d52ff8$var$LU + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Bq + $f68f332138d52ff8$var$OB + $f68f332138d52ff8$var$Fo + $f68f332138d52ff8$var$BE + $f68f332138d52ff8$var$OT + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$t + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Ma + $f68f332138d52ff8$var$FW + $f68f332138d52ff8$var$IP + $f68f332138d52ff8$var$Js + $f68f332138d52ff8$var$CX + $f68f332138d52ff8$var$EK + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Ma + $f68f332138d52ff8$var$FW + $f68f332138d52ff8$var$IP + $f68f332138d52ff8$var$Js + $f68f332138d52ff8$var$An + $f68f332138d52ff8$var$Ao + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$FU + $f68f332138d52ff8$var$FV + $f68f332138d52ff8$var$Iq + $f68f332138d52ff8$var$DE + $f68f332138d52ff8$var$CX + $f68f332138d52ff8$var$EK + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$FU + $f68f332138d52ff8$var$FV + $f68f332138d52ff8$var$Iq + $f68f332138d52ff8$var$DE + $f68f332138d52ff8$var$An + $f68f332138d52ff8$var$Ao + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$FX + $f68f332138d52ff8$var$FY + $f68f332138d52ff8$var$Nj + $f68f332138d52ff8$var$Na + $f68f332138d52ff8$var$CX + $f68f332138d52ff8$var$EK + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$FX + $f68f332138d52ff8$var$FY + $f68f332138d52ff8$var$Nj + $f68f332138d52ff8$var$Na + $f68f332138d52ff8$var$An + $f68f332138d52ff8$var$Ao + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Hj + $f68f332138d52ff8$var$Ct + $f68f332138d52ff8$var$CP + $f68f332138d52ff8$var$AI + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Hj + $f68f332138d52ff8$var$Ct + $f68f332138d52ff8$var$CP + $f68f332138d52ff8$var$AI + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Li + $f68f332138d52ff8$var$Sj + $f68f332138d52ff8$var$Tn + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$Pm + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Hj + $f68f332138d52ff8$var$Bx + $f68f332138d52ff8$var$CP + $f68f332138d52ff8$var$EW + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Hj + $f68f332138d52ff8$var$Bx + $f68f332138d52ff8$var$CP + $f68f332138d52ff8$var$CM + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Cd + $f68f332138d52ff8$var$Hg + $f68f332138d52ff8$var$BG + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Cd + $f68f332138d52ff8$var$RS + $f68f332138d52ff8$var$BG + $f68f332138d52ff8$var$Bv + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Id + $f68f332138d52ff8$var$RT + $f68f332138d52ff8$var$Am + $f68f332138d52ff8$var$YC + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$LM + $f68f332138d52ff8$var$RK + $f68f332138d52ff8$var$MV + $f68f332138d52ff8$var$IS + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$LM + $f68f332138d52ff8$var$RK + $f68f332138d52ff8$var$MV + $f68f332138d52ff8$var$IS + $f68f332138d52ff8$var$DR + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$t + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$JT + $f68f332138d52ff8$var$Jn + $f68f332138d52ff8$var$FZ + $f68f332138d52ff8$var$CS + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    2,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$CQ + $f68f332138d52ff8$var$DG + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$Hh + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$CQ + $f68f332138d52ff8$var$DG + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$AG + $f68f332138d52ff8$var$Hh + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$CQ + $f68f332138d52ff8$var$DF + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$h + $f68f332138d52ff8$var$Tm + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$CQ + $f68f332138d52ff8$var$DF + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$Gu + $f68f332138d52ff8$var$MN + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$CQ + $f68f332138d52ff8$var$DH + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$CX + $f68f332138d52ff8$var$LV + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$CQ + $f68f332138d52ff8$var$DH + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$An + $f68f332138d52ff8$var$NE + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Fp + $f68f332138d52ff8$var$DI + $f68f332138d52ff8$var$AO + $f68f332138d52ff8$var$AI + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Fp + $f68f332138d52ff8$var$DI + $f68f332138d52ff8$var$AO + $f68f332138d52ff8$var$AI + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$BA + $f68f332138d52ff8$var$Gp + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$Bn + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$BA + $f68f332138d52ff8$var$Gp + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$Bn + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Bl + $f68f332138d52ff8$var$Iy + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Bl + $f68f332138d52ff8$var$Iy + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$AF + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Bl + $f68f332138d52ff8$var$Cu + $f68f332138d52ff8$var$Hm + $f68f332138d52ff8$var$OC + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Bl + $f68f332138d52ff8$var$Cu + $f68f332138d52ff8$var$Hm + $f68f332138d52ff8$var$OC + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Bl + $f68f332138d52ff8$var$Cv + $f68f332138d52ff8$var$Iz + $f68f332138d52ff8$var$YD + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Bl + $f68f332138d52ff8$var$Cv + $f68f332138d52ff8$var$Iz + $f68f332138d52ff8$var$MI + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Fs + $f68f332138d52ff8$var$Cw + $f68f332138d52ff8$var$Ad + $f68f332138d52ff8$var$Bv + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Fs + $f68f332138d52ff8$var$Cw + $f68f332138d52ff8$var$Ad + $f68f332138d52ff8$var$MJ + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$BA + $f68f332138d52ff8$var$Gp + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$Bn + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$BA + $f68f332138d52ff8$var$Gp + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$Bn + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Dl + $f68f332138d52ff8$var$Dm + $f68f332138d52ff8$var$BB + $f68f332138d52ff8$var$Oc + $f68f332138d52ff8$var$AI + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Dl + $f68f332138d52ff8$var$Dm + $f68f332138d52ff8$var$BB + $f68f332138d52ff8$var$Oc + $f68f332138d52ff8$var$AI + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Fs + $f68f332138d52ff8$var$Cx + $f68f332138d52ff8$var$Ad + $f68f332138d52ff8$var$Qo + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Fs + $f68f332138d52ff8$var$Cx + $f68f332138d52ff8$var$Ad + $f68f332138d52ff8$var$MK + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Et + $f68f332138d52ff8$var$Eu + $f68f332138d52ff8$var$LT + $f68f332138d52ff8$var$NW + $f68f332138d52ff8$var$Rh + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Et + $f68f332138d52ff8$var$Eu + $f68f332138d52ff8$var$LT + $f68f332138d52ff8$var$NW + $f68f332138d52ff8$var$Z + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$BH + $f68f332138d52ff8$var$Ev + $f68f332138d52ff8$var$Ib + $f68f332138d52ff8$var$EZ + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$BH + $f68f332138d52ff8$var$Ev + $f68f332138d52ff8$var$Ib + $f68f332138d52ff8$var$EZ + $f68f332138d52ff8$var$DR + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$t + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Ew + $f68f332138d52ff8$var$Ex + $f68f332138d52ff8$var$Be + $f68f332138d52ff8$var$EZ + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Ew + $f68f332138d52ff8$var$Ex + $f68f332138d52ff8$var$Be + $f68f332138d52ff8$var$EZ + $f68f332138d52ff8$var$DR + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$t + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$OK + $f68f332138d52ff8$var$Fa + $f68f332138d52ff8$var$BY + $f68f332138d52ff8$var$ET + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$OK + $f68f332138d52ff8$var$Fa + $f68f332138d52ff8$var$BY + $f68f332138d52ff8$var$ET + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Fb + $f68f332138d52ff8$var$Fc + $f68f332138d52ff8$var$Ch + $f68f332138d52ff8$var$ET + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Fb + $f68f332138d52ff8$var$Fc + $f68f332138d52ff8$var$Ch + $f68f332138d52ff8$var$ET + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Dn + $f68f332138d52ff8$var$Ey + $f68f332138d52ff8$var$QU + $f68f332138d52ff8$var$Fl + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Dn + $f68f332138d52ff8$var$Ey + $f68f332138d52ff8$var$QU + $f68f332138d52ff8$var$Fl + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Ez + $f68f332138d52ff8$var$FA + $f68f332138d52ff8$var$Do + $f68f332138d52ff8$var$Fl + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Ez + $f68f332138d52ff8$var$FA + $f68f332138d52ff8$var$Do + $f68f332138d52ff8$var$Fl + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$JT + $f68f332138d52ff8$var$Hl + $f68f332138d52ff8$var$GH + $f68f332138d52ff8$var$AJ + $f68f332138d52ff8$var$u + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$JT + $f68f332138d52ff8$var$Hl + $f68f332138d52ff8$var$GH + $f68f332138d52ff8$var$AJ + $f68f332138d52ff8$var$Lc + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$t + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$PP + $f68f332138d52ff8$var$CZ + $f68f332138d52ff8$var$AK + $f68f332138d52ff8$var$AJ + $f68f332138d52ff8$var$Ci + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$PP + $f68f332138d52ff8$var$CZ + $f68f332138d52ff8$var$AK + $f68f332138d52ff8$var$AJ + $f68f332138d52ff8$var$KL + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$t + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$PQ + $f68f332138d52ff8$var$Ca + $f68f332138d52ff8$var$p + $f68f332138d52ff8$var$AJ + $f68f332138d52ff8$var$AV + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$PQ + $f68f332138d52ff8$var$Ca + $f68f332138d52ff8$var$p + $f68f332138d52ff8$var$AJ + $f68f332138d52ff8$var$KM + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$t + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$MW + $f68f332138d52ff8$var$FB + $f68f332138d52ff8$var$BB + $f68f332138d52ff8$var$Ea + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$MW + $f68f332138d52ff8$var$FB + $f68f332138d52ff8$var$BB + $f68f332138d52ff8$var$Ea + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Dp + $f68f332138d52ff8$var$Dq + $f68f332138d52ff8$var$y + $f68f332138d52ff8$var$Ea + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Dp + $f68f332138d52ff8$var$Dq + $f68f332138d52ff8$var$y + $f68f332138d52ff8$var$Ea + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$GW + $f68f332138d52ff8$var$GX + $f68f332138d52ff8$var$GY + $f68f332138d52ff8$var$GA + $f68f332138d52ff8$var$h + $f68f332138d52ff8$var$IK + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$EI + $f68f332138d52ff8$var$GE + $f68f332138d52ff8$var$Lb + $f68f332138d52ff8$var$BU + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$EI + $f68f332138d52ff8$var$GE + $f68f332138d52ff8$var$Lb + $f68f332138d52ff8$var$JV + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$FC + $f68f332138d52ff8$var$OD + $f68f332138d52ff8$var$Dr + $f68f332138d52ff8$var$CR + $f68f332138d52ff8$var$OE + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$FC + $f68f332138d52ff8$var$OD + $f68f332138d52ff8$var$Dr + $f68f332138d52ff8$var$CR + $f68f332138d52ff8$var$OE + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$t + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Fd + $f68f332138d52ff8$var$Fe + $f68f332138d52ff8$var$AL + $f68f332138d52ff8$var$CS + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Fd + $f68f332138d52ff8$var$Fe + $f68f332138d52ff8$var$AL + $f68f332138d52ff8$var$CS + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$OL + $f68f332138d52ff8$var$Ff + $f68f332138d52ff8$var$EJ + $f68f332138d52ff8$var$Ag + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$OL + $f68f332138d52ff8$var$Ff + $f68f332138d52ff8$var$EJ + $f68f332138d52ff8$var$Ag + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$FD + $f68f332138d52ff8$var$MX + $f68f332138d52ff8$var$BC + $f68f332138d52ff8$var$MQ + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$FD + $f68f332138d52ff8$var$MX + $f68f332138d52ff8$var$BC + $f68f332138d52ff8$var$MQ + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$FH + $f68f332138d52ff8$var$FI + $f68f332138d52ff8$var$Cb + $f68f332138d52ff8$var$Ag + $f68f332138d52ff8$var$EW + $f68f332138d52ff8$var$Fq + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$FH + $f68f332138d52ff8$var$FI + $f68f332138d52ff8$var$Cb + $f68f332138d52ff8$var$Ag + $f68f332138d52ff8$var$CM + $f68f332138d52ff8$var$Fq + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$DT + $f68f332138d52ff8$var$OM + $f68f332138d52ff8$var$RO + $f68f332138d52ff8$var$OX + $f68f332138d52ff8$var$CS + $f68f332138d52ff8$var$AV + $f68f332138d52ff8$var$Hh + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$OM + $f68f332138d52ff8$var$RO + $f68f332138d52ff8$var$OX + $f68f332138d52ff8$var$CS + $f68f332138d52ff8$var$AV + $f68f332138d52ff8$var$Ju + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$FE + $f68f332138d52ff8$var$MY + $f68f332138d52ff8$var$QV + $f68f332138d52ff8$var$Jr + $f68f332138d52ff8$var$h + $f68f332138d52ff8$var$AH + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$FE + $f68f332138d52ff8$var$MY + $f68f332138d52ff8$var$QV + $f68f332138d52ff8$var$Jr + $f68f332138d52ff8$var$AE + $f68f332138d52ff8$var$CN + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$FF + $f68f332138d52ff8$var$FG + $f68f332138d52ff8$var$Ds + $f68f332138d52ff8$var$CV + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$Cl + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$FF + $f68f332138d52ff8$var$FG + $f68f332138d52ff8$var$Ds + $f68f332138d52ff8$var$CV + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$Gr + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$CD + $f68f332138d52ff8$var$CE + $f68f332138d52ff8$var$Cc + $f68f332138d52ff8$var$CV + $f68f332138d52ff8$var$AI + $f68f332138d52ff8$var$Ju + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$CD + $f68f332138d52ff8$var$CE + $f68f332138d52ff8$var$Cc + $f68f332138d52ff8$var$CV + $f68f332138d52ff8$var$AI + $f68f332138d52ff8$var$Nf + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$FJ + $f68f332138d52ff8$var$FK + $f68f332138d52ff8$var$Dt + $f68f332138d52ff8$var$Ji + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$LV + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$FJ + $f68f332138d52ff8$var$FK + $f68f332138d52ff8$var$Dt + $f68f332138d52ff8$var$Ji + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$Ne + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Fp + $f68f332138d52ff8$var$LW + $f68f332138d52ff8$var$JA + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Fp + $f68f332138d52ff8$var$LW + $f68f332138d52ff8$var$JA + $f68f332138d52ff8$var$AG + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + " +lat_1=37" + $f68f332138d52ff8$var$YS + $f68f332138d52ff8$var$GM + $f68f332138d52ff8$var$Ga + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$OF + $f68f332138d52ff8$var$FL + $f68f332138d52ff8$var$AA + $f68f332138d52ff8$var$GF + $f68f332138d52ff8$var$Bo + $f68f332138d52ff8$var$Cl + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$OF + $f68f332138d52ff8$var$FL + $f68f332138d52ff8$var$AA + $f68f332138d52ff8$var$GF + $f68f332138d52ff8$var$Gs + $f68f332138d52ff8$var$Gr + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Az + $f68f332138d52ff8$var$Du + $f68f332138d52ff8$var$AB + $f68f332138d52ff8$var$GF + $f68f332138d52ff8$var$Bo + $f68f332138d52ff8$var$AH + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Az + $f68f332138d52ff8$var$Du + $f68f332138d52ff8$var$AB + $f68f332138d52ff8$var$GF + $f68f332138d52ff8$var$Gs + $f68f332138d52ff8$var$CN + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$BH + $f68f332138d52ff8$var$OG + $f68f332138d52ff8$var$Ib + $f68f332138d52ff8$var$Cy + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$BH + $f68f332138d52ff8$var$OG + $f68f332138d52ff8$var$Ib + $f68f332138d52ff8$var$Cy + $f68f332138d52ff8$var$AF + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$FM + $f68f332138d52ff8$var$FN + $f68f332138d52ff8$var$Dv + $f68f332138d52ff8$var$AJ + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$FM + $f68f332138d52ff8$var$FN + $f68f332138d52ff8$var$Dv + $f68f332138d52ff8$var$AJ + $f68f332138d52ff8$var$AF + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Mb + $f68f332138d52ff8$var$RN + $f68f332138d52ff8$var$Mr + $f68f332138d52ff8$var$Ga + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Mb + $f68f332138d52ff8$var$RN + $f68f332138d52ff8$var$Mr + $f68f332138d52ff8$var$Ga + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Fg + $f68f332138d52ff8$var$Fh + $f68f332138d52ff8$var$QX + $f68f332138d52ff8$var$CR + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Fg + $f68f332138d52ff8$var$Fh + $f68f332138d52ff8$var$QX + $f68f332138d52ff8$var$CR + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    2,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Jc + $f68f332138d52ff8$var$MZ + $f68f332138d52ff8$var$AL + $f68f332138d52ff8$var$Bu + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$FO + $f68f332138d52ff8$var$FP + $f68f332138d52ff8$var$Dw + $f68f332138d52ff8$var$Bu + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$FO + $f68f332138d52ff8$var$FP + $f68f332138d52ff8$var$Dw + $f68f332138d52ff8$var$Bu + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$FQ + $f68f332138d52ff8$var$FR + $f68f332138d52ff8$var$PR + $f68f332138d52ff8$var$Bu + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$FQ + $f68f332138d52ff8$var$FR + $f68f332138d52ff8$var$PR + $f68f332138d52ff8$var$Bu + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Bu + $f68f332138d52ff8$var$AP + $f68f332138d52ff8$var$YF + $f68f332138d52ff8$var$Sh + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$CA + $f68f332138d52ff8$var$DJ + $f68f332138d52ff8$var$Ad + $f68f332138d52ff8$var$h + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$CA + $f68f332138d52ff8$var$DJ + $f68f332138d52ff8$var$Ad + $f68f332138d52ff8$var$Gu + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$CA + $f68f332138d52ff8$var$DK + $f68f332138d52ff8$var$Ad + $f68f332138d52ff8$var$u + $f68f332138d52ff8$var$EK + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$CA + $f68f332138d52ff8$var$DK + $f68f332138d52ff8$var$Ad + $f68f332138d52ff8$var$Au + $f68f332138d52ff8$var$Ao + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$CA + $f68f332138d52ff8$var$DL + $f68f332138d52ff8$var$Ad + $f68f332138d52ff8$var$CX + $f68f332138d52ff8$var$EK + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$CA + $f68f332138d52ff8$var$DL + $f68f332138d52ff8$var$Ad + $f68f332138d52ff8$var$An + $f68f332138d52ff8$var$Ao + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$CA + $f68f332138d52ff8$var$JB + $f68f332138d52ff8$var$Ad + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$CA + $f68f332138d52ff8$var$JB + $f68f332138d52ff8$var$Ad + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$JF + $f68f332138d52ff8$var$CG + $f68f332138d52ff8$var$AQ + $f68f332138d52ff8$var$BI + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$Cl + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$AY + $f68f332138d52ff8$var$CF + $f68f332138d52ff8$var$Br + $f68f332138d52ff8$var$BI + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$AH + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$JG + $f68f332138d52ff8$var$CH + $f68f332138d52ff8$var$f + $f68f332138d52ff8$var$BI + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$Fq + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$UF + $f68f332138d52ff8$var$Nh + $f68f332138d52ff8$var$IZ + $f68f332138d52ff8$var$HJ + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$DT + $f68f332138d52ff8$var$UF + $f68f332138d52ff8$var$Nh + $f68f332138d52ff8$var$IZ + $f68f332138d52ff8$var$HJ + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$DT + $f68f332138d52ff8$var$UF + $f68f332138d52ff8$var$Nh + $f68f332138d52ff8$var$IZ + $f68f332138d52ff8$var$HJ + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$JF + $f68f332138d52ff8$var$CG + $f68f332138d52ff8$var$AQ + $f68f332138d52ff8$var$BI + $f68f332138d52ff8$var$AG + $f68f332138d52ff8$var$NF + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$AY + $f68f332138d52ff8$var$CF + $f68f332138d52ff8$var$Br + $f68f332138d52ff8$var$BI + $f68f332138d52ff8$var$AG + $f68f332138d52ff8$var$GJ + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$JG + $f68f332138d52ff8$var$CH + $f68f332138d52ff8$var$f + $f68f332138d52ff8$var$BI + $f68f332138d52ff8$var$AG + $f68f332138d52ff8$var$Fq + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Kn + $f68f332138d52ff8$var$Sf + $f68f332138d52ff8$var$AO + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Ko + $f68f332138d52ff8$var$KO + $f68f332138d52ff8$var$AO + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$GV + $f68f332138d52ff8$var$KI + $f68f332138d52ff8$var$Jl + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Kp + $f68f332138d52ff8$var$Sg + $f68f332138d52ff8$var$Jl + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Kq + $f68f332138d52ff8$var$KP + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$GV + $f68f332138d52ff8$var$KI + $f68f332138d52ff8$var$Jl + $f68f332138d52ff8$var$AG + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$TY + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$RG + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$TV + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=13.5 +lon_0=144.75 +k=1" + $f68f332138d52ff8$var$BU + $f68f332138d52ff8$var$IK + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    9,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$WJ + " +lon_0=46.5 +k=0.9994" + $f68f332138d52ff8$var$CX + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$Bc + $f68f332138d52ff8$var$Ge + $f68f332138d52ff8$var$EU + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    22,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$PT + $f68f332138d52ff8$var$Zz + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$PT + $f68f332138d52ff8$var$NX + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$GM + $f68f332138d52ff8$var$Ox + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$PT + $f68f332138d52ff8$var$Tk + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$GM + $f68f332138d52ff8$var$Oy + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$GM + $f68f332138d52ff8$var$Rw + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$GM + $f68f332138d52ff8$var$Oz + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$GM + $f68f332138d52ff8$var$aA + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$GM + $f68f332138d52ff8$var$PA + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Fs + $f68f332138d52ff8$var$PB + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$IZ + $f68f332138d52ff8$var$ZH + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$IZ + $f68f332138d52ff8$var$ZI + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$IZ + $f68f332138d52ff8$var$ZJ + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$IQ + " +lon_0=142" + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$IQ + $f68f332138d52ff8$var$Pj + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$IQ + " +lon_0=124" + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$IQ + $f68f332138d52ff8$var$NX + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=20" + $f68f332138d52ff8$var$Rw + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$IQ + $f68f332138d52ff8$var$ZR + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Mg + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$NT + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ot + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Nv + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$PM + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    11,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$US + $f68f332138d52ff8$var$AP + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$Ak + $f68f332138d52ff8$var$j + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    3,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$JN + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$KC + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$NR + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    11,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + " +lon_0=105.625 +k=1.000024" + $f68f332138d52ff8$var$Jm + $f68f332138d52ff8$var$Pm + $f68f332138d52ff8$var$j + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + " +lon_0=105.625 +k=1.00002514" + $f68f332138d52ff8$var$Jm + $f68f332138d52ff8$var$Pm + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + " +lon_0=96.875 +k=1" + $f68f332138d52ff8$var$Jm + " +y_0=1400000" + $f68f332138d52ff8$var$j + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + " +lon_0=96.875 +k=0.99999387" + $f68f332138d52ff8$var$Jm + $f68f332138d52ff8$var$DQ + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    13,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$QF + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ny + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Nq + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    45,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$OO + $f68f332138d52ff8$var$KS + $f68f332138d52ff8$var$SB + $f68f332138d52ff8$var$Of + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$OO + $f68f332138d52ff8$var$KS + $f68f332138d52ff8$var$SB + $f68f332138d52ff8$var$JJ + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$t + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$OO + $f68f332138d52ff8$var$KS + $f68f332138d52ff8$var$SB + $f68f332138d52ff8$var$Of + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$OO + $f68f332138d52ff8$var$KS + $f68f332138d52ff8$var$SB + $f68f332138d52ff8$var$JJ + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$t + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$GH + $f68f332138d52ff8$var$Rk + " +k=1.0002" + $f68f332138d52ff8$var$Oa + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$GH + $f68f332138d52ff8$var$Rk + " +k=1.0002" + $f68f332138d52ff8$var$HL + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$t + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$GH + $f68f332138d52ff8$var$Rk + " +k=1.0002" + $f68f332138d52ff8$var$Oa + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$GH + $f68f332138d52ff8$var$Rk + " +k=1.0002" + $f68f332138d52ff8$var$HL + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$t + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Ky + $f68f332138d52ff8$var$Kz + $f68f332138d52ff8$var$Rl + $f68f332138d52ff8$var$Mc + $f68f332138d52ff8$var$Oa + " +y_0=130000" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Ky + $f68f332138d52ff8$var$Kz + $f68f332138d52ff8$var$Rl + $f68f332138d52ff8$var$Mc + $f68f332138d52ff8$var$HL + $f68f332138d52ff8$var$Zo + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$t + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Ky + $f68f332138d52ff8$var$Kz + $f68f332138d52ff8$var$Rl + $f68f332138d52ff8$var$Mc + $f68f332138d52ff8$var$Oa + " +y_0=130000" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Ky + $f68f332138d52ff8$var$Kz + $f68f332138d52ff8$var$Rl + $f68f332138d52ff8$var$Mc + $f68f332138d52ff8$var$HL + $f68f332138d52ff8$var$Zo + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$t + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Bq + $f68f332138d52ff8$var$AK + $f68f332138d52ff8$var$Rm + $f68f332138d52ff8$var$YU + " +x_0=120000 +y_0=60000" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Bq + $f68f332138d52ff8$var$AK + $f68f332138d52ff8$var$Rm + $f68f332138d52ff8$var$YU + $f68f332138d52ff8$var$Zp + $f68f332138d52ff8$var$aM + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$t + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Bq + $f68f332138d52ff8$var$AK + $f68f332138d52ff8$var$Rm + $f68f332138d52ff8$var$YU + " +x_0=120000 +y_0=60000" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Bq + $f68f332138d52ff8$var$AK + $f68f332138d52ff8$var$Rm + $f68f332138d52ff8$var$YU + $f68f332138d52ff8$var$Zp + $f68f332138d52ff8$var$aM + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$t + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Fp + $f68f332138d52ff8$var$Bj + $f68f332138d52ff8$var$Ze + $f68f332138d52ff8$var$Of + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Fp + $f68f332138d52ff8$var$Bj + $f68f332138d52ff8$var$Ze + $f68f332138d52ff8$var$JJ + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$t + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Fp + $f68f332138d52ff8$var$Bj + $f68f332138d52ff8$var$Ze + $f68f332138d52ff8$var$Of + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Fp + $f68f332138d52ff8$var$Bj + $f68f332138d52ff8$var$Ze + $f68f332138d52ff8$var$JJ + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$t + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$LA + $f68f332138d52ff8$var$Be + $f68f332138d52ff8$var$AJ + $f68f332138d52ff8$var$Sk + $f68f332138d52ff8$var$Bn + " +y_0=30000" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$LA + $f68f332138d52ff8$var$Be + $f68f332138d52ff8$var$AJ + $f68f332138d52ff8$var$Sk + $f68f332138d52ff8$var$Ng + $f68f332138d52ff8$var$aN + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$t + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$LA + $f68f332138d52ff8$var$Be + $f68f332138d52ff8$var$AJ + $f68f332138d52ff8$var$Sk + $f68f332138d52ff8$var$Bn + " +y_0=30000" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$LA + $f68f332138d52ff8$var$Be + $f68f332138d52ff8$var$AJ + $f68f332138d52ff8$var$Sk + $f68f332138d52ff8$var$Ng + $f68f332138d52ff8$var$aN + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$t + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$CU + $f68f332138d52ff8$var$LB + $f68f332138d52ff8$var$Zf + $f68f332138d52ff8$var$Zg + " +k=1" + $f68f332138d52ff8$var$Tp + $f68f332138d52ff8$var$ZL + $f68f332138d52ff8$var$KE + $f68f332138d52ff8$var$Zh + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$CU + $f68f332138d52ff8$var$LB + $f68f332138d52ff8$var$Zf + $f68f332138d52ff8$var$Zg + " +k=1" + $f68f332138d52ff8$var$ZN + $f68f332138d52ff8$var$Zq + $f68f332138d52ff8$var$KE + $f68f332138d52ff8$var$Zh + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$t + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$CU + $f68f332138d52ff8$var$LB + $f68f332138d52ff8$var$Zf + $f68f332138d52ff8$var$Zg + " +k=1" + $f68f332138d52ff8$var$Tp + $f68f332138d52ff8$var$ZL + $f68f332138d52ff8$var$KE + $f68f332138d52ff8$var$Zh + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$CU + $f68f332138d52ff8$var$LB + $f68f332138d52ff8$var$Zf + $f68f332138d52ff8$var$Zg + " +k=1" + $f68f332138d52ff8$var$ZN + $f68f332138d52ff8$var$Zq + $f68f332138d52ff8$var$KE + $f68f332138d52ff8$var$Zh + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$t + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$BD + $f68f332138d52ff8$var$Bj + $f68f332138d52ff8$var$YV + $f68f332138d52ff8$var$Jm + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$BD + $f68f332138d52ff8$var$Bj + $f68f332138d52ff8$var$YV + $f68f332138d52ff8$var$HM + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$t + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$BD + $f68f332138d52ff8$var$Bj + $f68f332138d52ff8$var$YV + $f68f332138d52ff8$var$Jm + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$BD + $f68f332138d52ff8$var$Bj + $f68f332138d52ff8$var$YV + $f68f332138d52ff8$var$HM + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$t + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$OO + $f68f332138d52ff8$var$YW + $f68f332138d52ff8$var$Zi + $f68f332138d52ff8$var$Oa + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$OO + $f68f332138d52ff8$var$YW + $f68f332138d52ff8$var$Zi + $f68f332138d52ff8$var$HL + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$t + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$OO + $f68f332138d52ff8$var$YW + $f68f332138d52ff8$var$Zi + $f68f332138d52ff8$var$Oa + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$OO + $f68f332138d52ff8$var$YW + $f68f332138d52ff8$var$Zi + $f68f332138d52ff8$var$HL + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$t + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Tq + $f68f332138d52ff8$var$KT + $f68f332138d52ff8$var$Lk + $f68f332138d52ff8$var$Jm + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Tq + $f68f332138d52ff8$var$KT + $f68f332138d52ff8$var$Lk + $f68f332138d52ff8$var$HM + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$t + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Tq + $f68f332138d52ff8$var$KT + $f68f332138d52ff8$var$Lk + $f68f332138d52ff8$var$Jm + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Tq + $f68f332138d52ff8$var$KT + $f68f332138d52ff8$var$Lk + $f68f332138d52ff8$var$HM + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$t + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$GH + $f68f332138d52ff8$var$Bj + $f68f332138d52ff8$var$Qs + $f68f332138d52ff8$var$Jm + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$GH + $f68f332138d52ff8$var$Bj + $f68f332138d52ff8$var$Qs + $f68f332138d52ff8$var$HM + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$t + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$GH + $f68f332138d52ff8$var$Bj + $f68f332138d52ff8$var$Qs + $f68f332138d52ff8$var$Jm + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$GH + $f68f332138d52ff8$var$Bj + $f68f332138d52ff8$var$Qs + $f68f332138d52ff8$var$HM + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$t + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$IP + $f68f332138d52ff8$var$KU + $f68f332138d52ff8$var$Zj + " +x_0=10000" + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$IP + $f68f332138d52ff8$var$KU + $f68f332138d52ff8$var$Zj + $f68f332138d52ff8$var$aV + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$t + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$IP + $f68f332138d52ff8$var$KU + $f68f332138d52ff8$var$Zj + " +x_0=10000" + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$IP + $f68f332138d52ff8$var$KU + $f68f332138d52ff8$var$Zj + $f68f332138d52ff8$var$aV + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$t + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$IP + $f68f332138d52ff8$var$Ir + $f68f332138d52ff8$var$Zk + $f68f332138d52ff8$var$Of + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$IP + $f68f332138d52ff8$var$Ir + $f68f332138d52ff8$var$Zk + $f68f332138d52ff8$var$JJ + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$t + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$IP + $f68f332138d52ff8$var$Ir + $f68f332138d52ff8$var$Zk + $f68f332138d52ff8$var$Of + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$IP + $f68f332138d52ff8$var$Ir + $f68f332138d52ff8$var$Zk + $f68f332138d52ff8$var$JJ + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$t + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Tr + $f68f332138d52ff8$var$Lj + " +k=1.0001" + $f68f332138d52ff8$var$Oa + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Tr + $f68f332138d52ff8$var$Lj + " +k=1.0001" + $f68f332138d52ff8$var$HL + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$t + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Tr + $f68f332138d52ff8$var$Lj + " +k=1.0001" + $f68f332138d52ff8$var$Oa + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Tr + $f68f332138d52ff8$var$Lj + " +k=1.0001" + $f68f332138d52ff8$var$HL + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$t + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$CU + $f68f332138d52ff8$var$Pn + $f68f332138d52ff8$var$Sl + " +alpha=5 +k=1 +x_0=-300000 +y_0=-4600000" + $f68f332138d52ff8$var$KE + " +gamma=5" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$CU + $f68f332138d52ff8$var$Pn + $f68f332138d52ff8$var$Sl + " +alpha=5 +k=1" + $f68f332138d52ff8$var$Zr + $f68f332138d52ff8$var$Yp + $f68f332138d52ff8$var$KE + " +gamma=5" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$t + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$CU + $f68f332138d52ff8$var$Pn + $f68f332138d52ff8$var$Sl + " +alpha=5 +k=1 +x_0=-300000 +y_0=-4600000" + $f68f332138d52ff8$var$KE + " +gamma=5" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$CU + $f68f332138d52ff8$var$Pn + $f68f332138d52ff8$var$Sl + " +alpha=5 +k=1" + $f68f332138d52ff8$var$Zr + $f68f332138d52ff8$var$Yp + $f68f332138d52ff8$var$KE + " +gamma=5" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$t + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Ts + $f68f332138d52ff8$var$KV + $f68f332138d52ff8$var$Sb + " +x_0=60000" + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Ts + $f68f332138d52ff8$var$KV + $f68f332138d52ff8$var$Sb + $f68f332138d52ff8$var$aO + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$t + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Ts + $f68f332138d52ff8$var$KV + $f68f332138d52ff8$var$Sb + " +x_0=60000" + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Ts + $f68f332138d52ff8$var$KV + $f68f332138d52ff8$var$Sb + $f68f332138d52ff8$var$aO + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$t + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$LC + $f68f332138d52ff8$var$IW + $f68f332138d52ff8$var$YX + $f68f332138d52ff8$var$Zl + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$LC + $f68f332138d52ff8$var$IW + $f68f332138d52ff8$var$YX + $f68f332138d52ff8$var$aP + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$t + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$LC + $f68f332138d52ff8$var$IW + $f68f332138d52ff8$var$YX + $f68f332138d52ff8$var$Zl + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$LC + $f68f332138d52ff8$var$IW + $f68f332138d52ff8$var$YX + $f68f332138d52ff8$var$aP + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$t + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Jc + $f68f332138d52ff8$var$YY + $f68f332138d52ff8$var$Rn + $f68f332138d52ff8$var$Sm + $f68f332138d52ff8$var$BU + $f68f332138d52ff8$var$Rz + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Jc + $f68f332138d52ff8$var$YY + $f68f332138d52ff8$var$Rn + $f68f332138d52ff8$var$Sm + $f68f332138d52ff8$var$JW + $f68f332138d52ff8$var$Ra + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$t + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Jc + $f68f332138d52ff8$var$YY + $f68f332138d52ff8$var$Rn + $f68f332138d52ff8$var$Sm + $f68f332138d52ff8$var$BU + $f68f332138d52ff8$var$Rz + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Jc + $f68f332138d52ff8$var$YY + $f68f332138d52ff8$var$Rn + $f68f332138d52ff8$var$Sm + $f68f332138d52ff8$var$JW + $f68f332138d52ff8$var$Ra + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$t + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$LD + $f68f332138d52ff8$var$KW + $f68f332138d52ff8$var$Zm + $f68f332138d52ff8$var$Jm + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$LD + $f68f332138d52ff8$var$KW + $f68f332138d52ff8$var$Zm + $f68f332138d52ff8$var$HM + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$t + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$LD + $f68f332138d52ff8$var$KW + $f68f332138d52ff8$var$Zm + $f68f332138d52ff8$var$Jm + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$LD + $f68f332138d52ff8$var$KW + $f68f332138d52ff8$var$Zm + $f68f332138d52ff8$var$HM + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$t + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$LE + $f68f332138d52ff8$var$Sn + $f68f332138d52ff8$var$YZ + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$LE + $f68f332138d52ff8$var$Sn + $f68f332138d52ff8$var$YZ + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$t + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$LE + $f68f332138d52ff8$var$Sn + $f68f332138d52ff8$var$YZ + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$LE + $f68f332138d52ff8$var$Sn + $f68f332138d52ff8$var$YZ + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$t + $f68f332138d52ff8$var$A,
    4,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$JT + $f68f332138d52ff8$var$Hl + $f68f332138d52ff8$var$GH + $f68f332138d52ff8$var$AJ + $f68f332138d52ff8$var$u + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$JT + $f68f332138d52ff8$var$Hl + $f68f332138d52ff8$var$GH + $f68f332138d52ff8$var$AJ + $f68f332138d52ff8$var$Lc + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$t + $f68f332138d52ff8$var$A,
    2,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$UI + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    5,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$IH + " +k=0.9985000000000001" + $f68f332138d52ff8$var$Tp + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$IH + " +k=1" + $f68f332138d52ff8$var$aH + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    3,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Jc + $f68f332138d52ff8$var$MZ + $f68f332138d52ff8$var$AL + $f68f332138d52ff8$var$Bu + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$JT + $f68f332138d52ff8$var$Jn + $f68f332138d52ff8$var$FZ + $f68f332138d52ff8$var$CS + $f68f332138d52ff8$var$AG + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$Bc + $f68f332138d52ff8$var$Ge + " +towgs84=-24,-203,268,0,0,0,0" + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$Bc + $f68f332138d52ff8$var$Ge + " +towgs84=-183,-15,273,0,0,0,0" + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$R + " +towgs84=-235,-110,393,0,0,0,0" + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$PP + $f68f332138d52ff8$var$CZ + $f68f332138d52ff8$var$AK + $f68f332138d52ff8$var$AJ + $f68f332138d52ff8$var$Ci + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$PP + $f68f332138d52ff8$var$CZ + $f68f332138d52ff8$var$AK + $f68f332138d52ff8$var$AJ + $f68f332138d52ff8$var$KL + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$t + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$PQ + $f68f332138d52ff8$var$Ca + $f68f332138d52ff8$var$p + $f68f332138d52ff8$var$AJ + $f68f332138d52ff8$var$AV + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$PQ + $f68f332138d52ff8$var$Ca + $f68f332138d52ff8$var$p + $f68f332138d52ff8$var$AJ + $f68f332138d52ff8$var$KM + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$t + $f68f332138d52ff8$var$A,
    5,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$Bc + $f68f332138d52ff8$var$Ge + $f68f332138d52ff8$var$PK + $f68f332138d52ff8$var$A,
    2,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$Bc + $f68f332138d52ff8$var$Ge + " +towgs84=-63,176,185,0,0,0,0" + $f68f332138d52ff8$var$A,
    21,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Me + $f68f332138d52ff8$var$Bc + $f68f332138d52ff8$var$Ge + $f68f332138d52ff8$var$PK + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    7,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Sc + $f68f332138d52ff8$var$Ya + $f68f332138d52ff8$var$GM + $f68f332138d52ff8$var$So + $f68f332138d52ff8$var$u + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Sc + $f68f332138d52ff8$var$Ya + $f68f332138d52ff8$var$GM + $f68f332138d52ff8$var$So + $f68f332138d52ff8$var$Au + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Sc + $f68f332138d52ff8$var$Ya + $f68f332138d52ff8$var$GM + $f68f332138d52ff8$var$So + $f68f332138d52ff8$var$u + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Sc + $f68f332138d52ff8$var$Ya + $f68f332138d52ff8$var$GM + $f68f332138d52ff8$var$So + $f68f332138d52ff8$var$Au + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    6,
    $f68f332138d52ff8$var$He + $f68f332138d52ff8$var$Hr + $f68f332138d52ff8$var$HN + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$j + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$He + $f68f332138d52ff8$var$m + $f68f332138d52ff8$var$HN + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$j + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    "+proj=cea" + $f68f332138d52ff8$var$HN + " +lat_ts=30" + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$j + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    29,
    $f68f332138d52ff8$var$H + " +lat_1=39 +lat_2=43" + $f68f332138d52ff8$var$Ip + $f68f332138d52ff8$var$UI + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    21,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Ou + $f68f332138d52ff8$var$Ov + $f68f332138d52ff8$var$Zw + $f68f332138d52ff8$var$UV + $f68f332138d52ff8$var$Yl + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    6,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Ou + $f68f332138d52ff8$var$Ov + $f68f332138d52ff8$var$Zw + $f68f332138d52ff8$var$UV + $f68f332138d52ff8$var$Yl + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    14,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$KD + $f68f332138d52ff8$var$Bc + $f68f332138d52ff8$var$Ge + $f68f332138d52ff8$var$DO + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$JZ + $f68f332138d52ff8$var$Bc + $f68f332138d52ff8$var$Ge + $f68f332138d52ff8$var$DO + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$JM + $f68f332138d52ff8$var$Bc + $f68f332138d52ff8$var$Ge + $f68f332138d52ff8$var$DO + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    28,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$A,
    2,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$A,
    2,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$A,
    2,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$A,
    16,
    $f68f332138d52ff8$var$H + " +lat_1=43.2 +lat_0=43.2 +lon_0=-95.25 +k_0=1.000052 +x_0=3505207.010414021 +y_0=2926085.852171705" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + " +lat_1=43.16666666666666 +lat_0=43.16666666666666 +lon_0=-92.75 +k_0=1.000043 +x_0=3810007.62001524 +y_0=2987045.974091948" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Md + " +lon_0=-91.2 +k=1.000035 +x_0=4114808.229616459 +y_0=2529845.05969012" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + " +lat_1=42.53333333333333 +lat_0=42.53333333333333 +lon_0=-94.83333333333333 +k_0=1.000045 +x_0=4419608.839217679 +y_0=2621285.242570485" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + " +lat_1=42.65 +lat_0=42.65 +lon_0=-92.25 +k_0=1.000032 +x_0=4724409.448818898 +y_0=2712725.425450851" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Md + " +lon_0=-95.73333333333333 +k=1.000039 +x_0=5029210.058420117 +y_0=2011684.023368047" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Md + " +lon_0=-94.63333333333334" + $f68f332138d52ff8$var$Sb + " +x_0=5334010.668021336 +y_0=2072644.145288291" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Md + " +lon_0=-93.71666666666667 +k=1.000033 +x_0=5638811.277622555 +y_0=2133604.267208535" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Md + " +lon_0=-92.81666666666666" + $f68f332138d52ff8$var$OP + " +x_0=5943611.887223775 +y_0=2194564.389128779" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + " +lat_1=41.83333333333334 +lat_0=41.83333333333334 +lon_0=-91.66666666666667 +k_0=1.00002 +x_0=6248412.496824994 +y_0=2438404.876809754" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Md + " +lon_0=-90.53333333333333" + $f68f332138d52ff8$var$OP + " +x_0=6553213.106426213 +y_0=2316484.632969266" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + " +lat_1=40.91666666666666 +lat_0=40.91666666666666 +lon_0=-93.75 +k_0=1.000037 +x_0=6858013.716027432" + $f68f332138d52ff8$var$Yq + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Md + $f68f332138d52ff8$var$Oo + $f68f332138d52ff8$var$Og + " +x_0=7162814.325628651 +y_0=1950723.901447803" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Md + " +lon_0=-91.25 +k=1.000018 +x_0=7467614.93522987" + $f68f332138d52ff8$var$Yq + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    3,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$KD + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$JZ + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$JM + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Me + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Rb + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Rc + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$SO + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Td + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    3,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$A,
    2,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$A,
    23,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Qt + $f68f332138d52ff8$var$Sp + $f68f332138d52ff8$var$SB + $f68f332138d52ff8$var$Bn + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=48" + $f68f332138d52ff8$var$Sp + " +k=1.00019" + $f68f332138d52ff8$var$BU + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Yb + $f68f332138d52ff8$var$Qt + $f68f332138d52ff8$var$KK + " +k_0=1.000145" + $f68f332138d52ff8$var$Bn + $f68f332138d52ff8$var$IK + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Yb + $f68f332138d52ff8$var$Qt + " +lon_0=-108.5" + $f68f332138d52ff8$var$Mc + $f68f332138d52ff8$var$h + " +y_0=150000" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$LF + $f68f332138d52ff8$var$LG + $f68f332138d52ff8$var$Ba + $f68f332138d52ff8$var$Mc + $f68f332138d52ff8$var$h + $f68f332138d52ff8$var$EK + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$LF + $f68f332138d52ff8$var$LG + $f68f332138d52ff8$var$Ba + " +k_0=1.00009" + $f68f332138d52ff8$var$BU + $f68f332138d52ff8$var$Rz + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Pn + " +lon_0=-107.75 +k=1.000148" + $f68f332138d52ff8$var$h + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$aI + " +lat_0=46.25 +lon_0=-111.25 +k_0=1.000185" + $f68f332138d52ff8$var$BU + $f68f332138d52ff8$var$EK + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$WV + $f68f332138d52ff8$var$WW + $f68f332138d52ff8$var$Ub + " +k_0=1.0001515" + $f68f332138d52ff8$var$h + $f68f332138d52ff8$var$Rz + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$WX + $f68f332138d52ff8$var$Uc + " +k=1.00024" + $f68f332138d52ff8$var$BU + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Qt + $f68f332138d52ff8$var$Sp + $f68f332138d52ff8$var$SB + $f68f332138d52ff8$var$Ng + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$t + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=48" + $f68f332138d52ff8$var$Sp + " +k=1.00019" + $f68f332138d52ff8$var$JW + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$t + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Yb + $f68f332138d52ff8$var$Qt + $f68f332138d52ff8$var$KK + " +k_0=1.000145" + $f68f332138d52ff8$var$Ng + " +y_0=199999.9999992" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$t + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Yb + $f68f332138d52ff8$var$Qt + " +lon_0=-108.5" + $f68f332138d52ff8$var$Mc + $f68f332138d52ff8$var$OU + " +y_0=150000.00001464" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$t + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$LF + $f68f332138d52ff8$var$LG + $f68f332138d52ff8$var$Ba + $f68f332138d52ff8$var$Mc + $f68f332138d52ff8$var$OU + $f68f332138d52ff8$var$Yr + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$t + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$LF + $f68f332138d52ff8$var$LG + $f68f332138d52ff8$var$Ba + " +k_0=1.00009" + $f68f332138d52ff8$var$JW + " +y_0=49999.99971024" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$t + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Pn + " +lon_0=-107.75 +k=1.000148" + $f68f332138d52ff8$var$OU + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$t + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$aI + " +lat_0=46.25 +lon_0=-111.25 +k_0=1.000185" + $f68f332138d52ff8$var$JW + $f68f332138d52ff8$var$Yr + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$t + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$WV + $f68f332138d52ff8$var$WW + $f68f332138d52ff8$var$Ub + " +k_0=1.0001515" + $f68f332138d52ff8$var$OU + $f68f332138d52ff8$var$Ra + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$t + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$WX + $f68f332138d52ff8$var$Uc + " +k=1.00024" + $f68f332138d52ff8$var$JV + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    3,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Po + " +lon_0=-122.45 +k=1.000007 +x_0=48000 +y_0=24000" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Po + " +lon_0=-122.45 +k=1.000007 +x_0=48000 +y_0=24000" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$A,
    3,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$j + $f68f332138d52ff8$var$A,
    3,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$j + $f68f332138d52ff8$var$A,
    3,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$LH + $f68f332138d52ff8$var$LI + " +k=1" + $f68f332138d52ff8$var$Qx + " +y_0=126867.909" + $f68f332138d52ff8$var$Nc + $f68f332138d52ff8$var$Nd + " +towgs84=-275.7224,94.7824,340.8944,-8.001,-4.42,-11.821,1" + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    115,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Pp + $f68f332138d52ff8$var$Sq + $f68f332138d52ff8$var$Ll + $f68f332138d52ff8$var$l + $f68f332138d52ff8$var$q + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Pp + $f68f332138d52ff8$var$Sq + $f68f332138d52ff8$var$Ll + $f68f332138d52ff8$var$l + $f68f332138d52ff8$var$q + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Qu + $f68f332138d52ff8$var$Oj + $f68f332138d52ff8$var$Lm + $f68f332138d52ff8$var$l + $f68f332138d52ff8$var$q + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Qu + $f68f332138d52ff8$var$Oj + $f68f332138d52ff8$var$Lm + $f68f332138d52ff8$var$l + $f68f332138d52ff8$var$q + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=39" + $f68f332138d52ff8$var$KX + $f68f332138d52ff8$var$Ln + $f68f332138d52ff8$var$l + $f68f332138d52ff8$var$q + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=39" + $f68f332138d52ff8$var$KX + $f68f332138d52ff8$var$Ln + $f68f332138d52ff8$var$l + $f68f332138d52ff8$var$q + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=40.45" + $f68f332138d52ff8$var$Pq + $f68f332138d52ff8$var$Yc + $f68f332138d52ff8$var$l + $f68f332138d52ff8$var$q + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=40.45" + $f68f332138d52ff8$var$Pq + $f68f332138d52ff8$var$Yc + $f68f332138d52ff8$var$l + $f68f332138d52ff8$var$q + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=40.05" + $f68f332138d52ff8$var$Ud + $f68f332138d52ff8$var$OQ + $f68f332138d52ff8$var$l + $f68f332138d52ff8$var$q + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=40.05" + $f68f332138d52ff8$var$Ud + $f68f332138d52ff8$var$OQ + $f68f332138d52ff8$var$l + $f68f332138d52ff8$var$q + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Yd + $f68f332138d52ff8$var$Pr + $f68f332138d52ff8$var$OR + $f68f332138d52ff8$var$l + $f68f332138d52ff8$var$q + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Yd + $f68f332138d52ff8$var$Pr + $f68f332138d52ff8$var$OR + $f68f332138d52ff8$var$l + $f68f332138d52ff8$var$q + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=39" + $f68f332138d52ff8$var$Tt + $f68f332138d52ff8$var$Zn + $f68f332138d52ff8$var$l + $f68f332138d52ff8$var$q + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=39" + $f68f332138d52ff8$var$Tt + $f68f332138d52ff8$var$Zn + $f68f332138d52ff8$var$l + $f68f332138d52ff8$var$q + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=40.4" + $f68f332138d52ff8$var$Ue + $f68f332138d52ff8$var$Ln + $f68f332138d52ff8$var$l + $f68f332138d52ff8$var$q + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=40.4" + $f68f332138d52ff8$var$Ue + $f68f332138d52ff8$var$Ln + $f68f332138d52ff8$var$l + $f68f332138d52ff8$var$q + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Pp + $f68f332138d52ff8$var$Uf + $f68f332138d52ff8$var$Qv + $f68f332138d52ff8$var$l + $f68f332138d52ff8$var$q + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Pp + $f68f332138d52ff8$var$Uf + $f68f332138d52ff8$var$Qv + $f68f332138d52ff8$var$l + $f68f332138d52ff8$var$q + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Tu + $f68f332138d52ff8$var$Ug + " +k=1.000021" + $f68f332138d52ff8$var$l + $f68f332138d52ff8$var$q + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Tu + $f68f332138d52ff8$var$Ug + " +k=1.000021" + $f68f332138d52ff8$var$l + $f68f332138d52ff8$var$q + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Tv + $f68f332138d52ff8$var$Uh + " +k=1.000024" + $f68f332138d52ff8$var$l + $f68f332138d52ff8$var$q + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Tv + $f68f332138d52ff8$var$Uh + " +k=1.000024" + $f68f332138d52ff8$var$l + $f68f332138d52ff8$var$q + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=40.15" + $f68f332138d52ff8$var$Ui + " +k=1.000032" + $f68f332138d52ff8$var$l + $f68f332138d52ff8$var$q + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=40.15" + $f68f332138d52ff8$var$Ui + " +k=1.000032" + $f68f332138d52ff8$var$l + $f68f332138d52ff8$var$q + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=38.1" + $f68f332138d52ff8$var$Pr + $f68f332138d52ff8$var$Qw + $f68f332138d52ff8$var$l + $f68f332138d52ff8$var$q + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=38.1" + $f68f332138d52ff8$var$Pr + $f68f332138d52ff8$var$Qw + $f68f332138d52ff8$var$l + $f68f332138d52ff8$var$q + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=38.45" + $f68f332138d52ff8$var$KY + " +k=1.000018" + $f68f332138d52ff8$var$l + $f68f332138d52ff8$var$q + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=38.45" + $f68f332138d52ff8$var$KY + " +k=1.000018" + $f68f332138d52ff8$var$l + $f68f332138d52ff8$var$q + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=38.65" + $f68f332138d52ff8$var$Uj + $f68f332138d52ff8$var$Yc + $f68f332138d52ff8$var$l + $f68f332138d52ff8$var$q + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=38.65" + $f68f332138d52ff8$var$Uj + $f68f332138d52ff8$var$Yc + $f68f332138d52ff8$var$l + $f68f332138d52ff8$var$q + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=39.1" + $f68f332138d52ff8$var$Uk + $f68f332138d52ff8$var$OR + $f68f332138d52ff8$var$l + $f68f332138d52ff8$var$q + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=39.1" + $f68f332138d52ff8$var$Uk + $f68f332138d52ff8$var$OR + $f68f332138d52ff8$var$l + $f68f332138d52ff8$var$q + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Tw + $f68f332138d52ff8$var$Sq + $f68f332138d52ff8$var$OR + $f68f332138d52ff8$var$l + $f68f332138d52ff8$var$q + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Tw + $f68f332138d52ff8$var$Sq + $f68f332138d52ff8$var$OR + $f68f332138d52ff8$var$l + $f68f332138d52ff8$var$q + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=38.2" + $f68f332138d52ff8$var$Sr + $f68f332138d52ff8$var$Og + $f68f332138d52ff8$var$l + $f68f332138d52ff8$var$q + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=38.2" + $f68f332138d52ff8$var$Sr + $f68f332138d52ff8$var$Og + $f68f332138d52ff8$var$l + $f68f332138d52ff8$var$q + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Tx + $f68f332138d52ff8$var$KX + " +k=1.000033" + $f68f332138d52ff8$var$l + $f68f332138d52ff8$var$q + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Tx + $f68f332138d52ff8$var$KX + " +k=1.000033" + $f68f332138d52ff8$var$l + $f68f332138d52ff8$var$q + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Ty + $f68f332138d52ff8$var$Oj + $f68f332138d52ff8$var$OQ + $f68f332138d52ff8$var$l + $f68f332138d52ff8$var$q + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Ty + $f68f332138d52ff8$var$Oj + $f68f332138d52ff8$var$OQ + $f68f332138d52ff8$var$l + $f68f332138d52ff8$var$q + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=39.95" + $f68f332138d52ff8$var$Pq + $f68f332138d52ff8$var$Qw + $f68f332138d52ff8$var$l + $f68f332138d52ff8$var$q + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=39.95" + $f68f332138d52ff8$var$Pq + $f68f332138d52ff8$var$Qw + $f68f332138d52ff8$var$l + $f68f332138d52ff8$var$q + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Qu + $f68f332138d52ff8$var$Tt + $f68f332138d52ff8$var$Lm + $f68f332138d52ff8$var$l + $f68f332138d52ff8$var$q + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Qu + $f68f332138d52ff8$var$Tt + $f68f332138d52ff8$var$Lm + $f68f332138d52ff8$var$l + $f68f332138d52ff8$var$q + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Tu + $f68f332138d52ff8$var$Ul + $f68f332138d52ff8$var$Ye + $f68f332138d52ff8$var$l + $f68f332138d52ff8$var$q + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Tu + $f68f332138d52ff8$var$Ul + $f68f332138d52ff8$var$Ye + $f68f332138d52ff8$var$l + $f68f332138d52ff8$var$q + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Tz + " +lon_0=-85.7" + $f68f332138d52ff8$var$Ll + $f68f332138d52ff8$var$l + $f68f332138d52ff8$var$q + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Tz + " +lon_0=-85.7" + $f68f332138d52ff8$var$Ll + $f68f332138d52ff8$var$l + $f68f332138d52ff8$var$q + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=39.9" + $f68f332138d52ff8$var$MQ + $f68f332138d52ff8$var$Ll + $f68f332138d52ff8$var$l + $f68f332138d52ff8$var$q + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=39.9" + $f68f332138d52ff8$var$MQ + $f68f332138d52ff8$var$Ll + $f68f332138d52ff8$var$l + $f68f332138d52ff8$var$q + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=39.65" + $f68f332138d52ff8$var$UA + $f68f332138d52ff8$var$OR + $f68f332138d52ff8$var$l + $f68f332138d52ff8$var$q + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=39.65" + $f68f332138d52ff8$var$UA + $f68f332138d52ff8$var$OR + $f68f332138d52ff8$var$l + $f68f332138d52ff8$var$q + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=37.95" + $f68f332138d52ff8$var$HC + $f68f332138d52ff8$var$OP + $f68f332138d52ff8$var$l + $f68f332138d52ff8$var$q + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=37.95" + $f68f332138d52ff8$var$HC + $f68f332138d52ff8$var$OP + $f68f332138d52ff8$var$l + $f68f332138d52ff8$var$q + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=39.75" + $f68f332138d52ff8$var$Ss + $f68f332138d52ff8$var$Qs + $f68f332138d52ff8$var$l + $f68f332138d52ff8$var$q + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=39.75" + $f68f332138d52ff8$var$Ss + $f68f332138d52ff8$var$Qs + $f68f332138d52ff8$var$l + $f68f332138d52ff8$var$q + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Tz + $f68f332138d52ff8$var$HC + $f68f332138d52ff8$var$Lm + $f68f332138d52ff8$var$l + $f68f332138d52ff8$var$q + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Tz + $f68f332138d52ff8$var$HC + $f68f332138d52ff8$var$Lm + $f68f332138d52ff8$var$l + $f68f332138d52ff8$var$q + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Tx + $f68f332138d52ff8$var$To + $f68f332138d52ff8$var$Ll + $f68f332138d52ff8$var$l + $f68f332138d52ff8$var$q + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Tx + $f68f332138d52ff8$var$To + $f68f332138d52ff8$var$Ll + $f68f332138d52ff8$var$l + $f68f332138d52ff8$var$q + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=38.7 +lon_0=-85.95" + $f68f332138d52ff8$var$Yf + $f68f332138d52ff8$var$l + $f68f332138d52ff8$var$q + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=38.7 +lon_0=-85.95" + $f68f332138d52ff8$var$Yf + $f68f332138d52ff8$var$l + $f68f332138d52ff8$var$q + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Yg + $f68f332138d52ff8$var$KY + $f68f332138d52ff8$var$OP + $f68f332138d52ff8$var$l + $f68f332138d52ff8$var$q + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Yg + $f68f332138d52ff8$var$KY + $f68f332138d52ff8$var$OP + $f68f332138d52ff8$var$l + $f68f332138d52ff8$var$q + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=40.3" + $f68f332138d52ff8$var$SA + $f68f332138d52ff8$var$OQ + $f68f332138d52ff8$var$l + $f68f332138d52ff8$var$q + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=40.3" + $f68f332138d52ff8$var$SA + $f68f332138d52ff8$var$OQ + $f68f332138d52ff8$var$l + $f68f332138d52ff8$var$q + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=38.55" + $f68f332138d52ff8$var$Um + $f68f332138d52ff8$var$Qv + $f68f332138d52ff8$var$l + $f68f332138d52ff8$var$q + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=38.55" + $f68f332138d52ff8$var$Um + $f68f332138d52ff8$var$Qv + $f68f332138d52ff8$var$l + $f68f332138d52ff8$var$q + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=38.8" + $f68f332138d52ff8$var$UA + $f68f332138d52ff8$var$Qw + $f68f332138d52ff8$var$l + $f68f332138d52ff8$var$q + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=38.8" + $f68f332138d52ff8$var$UA + $f68f332138d52ff8$var$Qw + $f68f332138d52ff8$var$l + $f68f332138d52ff8$var$q + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Yh + $f68f332138d52ff8$var$HC + $f68f332138d52ff8$var$Lm + $f68f332138d52ff8$var$l + $f68f332138d52ff8$var$q + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Yh + $f68f332138d52ff8$var$HC + $f68f332138d52ff8$var$Lm + $f68f332138d52ff8$var$l + $f68f332138d52ff8$var$q + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=38.4" + $f68f332138d52ff8$var$St + $f68f332138d52ff8$var$Lk + $f68f332138d52ff8$var$l + $f68f332138d52ff8$var$q + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=38.4" + $f68f332138d52ff8$var$St + $f68f332138d52ff8$var$Lk + $f68f332138d52ff8$var$l + $f68f332138d52ff8$var$q + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Tw + $f68f332138d52ff8$var$Ss + " +k=1.000037" + $f68f332138d52ff8$var$l + $f68f332138d52ff8$var$q + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Tw + $f68f332138d52ff8$var$Ss + " +k=1.000037" + $f68f332138d52ff8$var$l + $f68f332138d52ff8$var$q + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Yg + $f68f332138d52ff8$var$Un + $f68f332138d52ff8$var$Ln + $f68f332138d52ff8$var$l + $f68f332138d52ff8$var$q + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Yg + $f68f332138d52ff8$var$Un + $f68f332138d52ff8$var$Ln + $f68f332138d52ff8$var$l + $f68f332138d52ff8$var$q + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Qu + " +lon_0=-86.75" + $f68f332138d52ff8$var$OP + $f68f332138d52ff8$var$l + $f68f332138d52ff8$var$q + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Qu + " +lon_0=-86.75" + $f68f332138d52ff8$var$OP + $f68f332138d52ff8$var$l + $f68f332138d52ff8$var$q + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=38.95" + $f68f332138d52ff8$var$Pr + $f68f332138d52ff8$var$Qv + $f68f332138d52ff8$var$l + $f68f332138d52ff8$var$q + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=38.95" + $f68f332138d52ff8$var$Pr + $f68f332138d52ff8$var$Qv + $f68f332138d52ff8$var$l + $f68f332138d52ff8$var$q + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=39.45" + $f68f332138d52ff8$var$Sr + $f68f332138d52ff8$var$Lm + $f68f332138d52ff8$var$l + $f68f332138d52ff8$var$q + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=39.45" + $f68f332138d52ff8$var$Sr + $f68f332138d52ff8$var$Lm + $f68f332138d52ff8$var$l + $f68f332138d52ff8$var$q + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Tv + $f68f332138d52ff8$var$KZ + $f68f332138d52ff8$var$Ln + $f68f332138d52ff8$var$l + $f68f332138d52ff8$var$q + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Tv + $f68f332138d52ff8$var$KZ + $f68f332138d52ff8$var$Ln + $f68f332138d52ff8$var$l + $f68f332138d52ff8$var$q + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Yd + $f68f332138d52ff8$var$Uo + $f68f332138d52ff8$var$Yf + $f68f332138d52ff8$var$l + $f68f332138d52ff8$var$q + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Yd + $f68f332138d52ff8$var$Uo + $f68f332138d52ff8$var$Yf + $f68f332138d52ff8$var$l + $f68f332138d52ff8$var$q + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Yi + " +lon_0=-86.7" + $f68f332138d52ff8$var$Og + $f68f332138d52ff8$var$l + $f68f332138d52ff8$var$q + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Yi + " +lon_0=-86.7" + $f68f332138d52ff8$var$Og + $f68f332138d52ff8$var$l + $f68f332138d52ff8$var$q + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=37.85" + $f68f332138d52ff8$var$Pq + $f68f332138d52ff8$var$Lk + $f68f332138d52ff8$var$l + $f68f332138d52ff8$var$q + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=37.85" + $f68f332138d52ff8$var$Pq + $f68f332138d52ff8$var$Lk + $f68f332138d52ff8$var$l + $f68f332138d52ff8$var$q + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Po + " +lon_0=-87.95" + $f68f332138d52ff8$var$Ye + $f68f332138d52ff8$var$l + $f68f332138d52ff8$var$q + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Po + " +lon_0=-87.95" + $f68f332138d52ff8$var$Ye + $f68f332138d52ff8$var$l + $f68f332138d52ff8$var$q + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=39.7" + $f68f332138d52ff8$var$Oj + " +k=1.000044" + $f68f332138d52ff8$var$l + $f68f332138d52ff8$var$q + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=39.7" + $f68f332138d52ff8$var$Oj + " +k=1.000044" + $f68f332138d52ff8$var$l + $f68f332138d52ff8$var$q + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Yj + " +lon_0=-85.3" + $f68f332138d52ff8$var$OQ + $f68f332138d52ff8$var$l + $f68f332138d52ff8$var$q + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Yj + " +lon_0=-85.3" + $f68f332138d52ff8$var$OQ + $f68f332138d52ff8$var$l + $f68f332138d52ff8$var$q + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Yh + $f68f332138d52ff8$var$Up + $f68f332138d52ff8$var$Zn + $f68f332138d52ff8$var$l + $f68f332138d52ff8$var$q + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Yh + $f68f332138d52ff8$var$Up + $f68f332138d52ff8$var$Zn + $f68f332138d52ff8$var$l + $f68f332138d52ff8$var$q + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Po + " +lon_0=-87.05 +k=1.000014" + $f68f332138d52ff8$var$l + $f68f332138d52ff8$var$q + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Po + " +lon_0=-87.05 +k=1.000014" + $f68f332138d52ff8$var$l + $f68f332138d52ff8$var$q + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Fo + $f68f332138d52ff8$var$SA + " +k=1.000041" + $f68f332138d52ff8$var$l + $f68f332138d52ff8$var$q + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Fo + $f68f332138d52ff8$var$SA + " +k=1.000041" + $f68f332138d52ff8$var$l + $f68f332138d52ff8$var$q + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Yj + $f68f332138d52ff8$var$OS + " +k=1.000017" + $f68f332138d52ff8$var$l + $f68f332138d52ff8$var$q + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Yj + $f68f332138d52ff8$var$OS + " +k=1.000017" + $f68f332138d52ff8$var$l + $f68f332138d52ff8$var$q + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=40.2" + $f68f332138d52ff8$var$KZ + $f68f332138d52ff8$var$Ln + $f68f332138d52ff8$var$l + $f68f332138d52ff8$var$q + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=40.2" + $f68f332138d52ff8$var$KZ + $f68f332138d52ff8$var$Ln + $f68f332138d52ff8$var$l + $f68f332138d52ff8$var$q + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Yi + $f68f332138d52ff8$var$Su + $f68f332138d52ff8$var$Lk + $f68f332138d52ff8$var$l + $f68f332138d52ff8$var$q + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Yi + $f68f332138d52ff8$var$Su + $f68f332138d52ff8$var$Lk + $f68f332138d52ff8$var$l + $f68f332138d52ff8$var$q + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Ty + $f68f332138d52ff8$var$St + $f68f332138d52ff8$var$Og + $f68f332138d52ff8$var$l + $f68f332138d52ff8$var$q + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Ty + $f68f332138d52ff8$var$St + $f68f332138d52ff8$var$Og + $f68f332138d52ff8$var$l + $f68f332138d52ff8$var$q + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Pp + " +lon_0=-85.25" + $f68f332138d52ff8$var$Ll + $f68f332138d52ff8$var$l + $f68f332138d52ff8$var$q + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Pp + " +lon_0=-85.25" + $f68f332138d52ff8$var$Ll + $f68f332138d52ff8$var$l + $f68f332138d52ff8$var$q + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    3,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$JM + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Me + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Rb + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    152,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$WY + $f68f332138d52ff8$var$Bu + " +k=1.0000365285 +x_0=147218.6942 +y_0=0.0037" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$WZ + $f68f332138d52ff8$var$Uq + " +k=1.0000495683 +x_0=172821.9461 +y_0=0.0017" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Wa + $f68f332138d52ff8$var$Ur + " +k=1.0000486665 +x_0=93150 +y_0=0.0029" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Wb + $f68f332138d52ff8$var$Wc + $f68f332138d52ff8$var$Us + " +k_0=1.0000331195 +x_0=228600.4575 +y_0=148551.4837" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Nj + " +lon_0=-88" + $f68f332138d52ff8$var$Og + " +x_0=31600 +y_0=4600" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Wd + $f68f332138d52ff8$var$Ut + " +k=1.0000382778 +x_0=175260.3502 +y_0=0.0048" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$We + $f68f332138d52ff8$var$Wf + $f68f332138d52ff8$var$Uu + " +k_0=1.0000383841 +x_0=64008.1276 +y_0=59445.9043" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Wg + " +lon_0=-88.5 +k=1.0000286569 +x_0=244754.8893 +y_0=0.0049" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Wh + $f68f332138d52ff8$var$Wi + $f68f332138d52ff8$var$Uv + " +k_0=1.0000391127 +x_0=60045.72 +y_0=44091.4346" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=43.6" + $f68f332138d52ff8$var$Uw + " +k=1.0000463003 +x_0=199949.1989 +y_0=0.0086" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Wj + $f68f332138d52ff8$var$Wk + $f68f332138d52ff8$var$Ux + " +k_0=1.00003498 +x_0=169164.3381 +y_0=111569.6134" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$aQ + $f68f332138d52ff8$var$aR + $f68f332138d52ff8$var$Wl + " +k_0=1.0000349151 +x_0=113690.6274 +y_0=53703.1201" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Zs + $f68f332138d52ff8$var$Zt + $f68f332138d52ff8$var$Uy + " +k_0=1.0000384786 +x_0=247193.2944 +y_0=146591.9896" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Wm + $f68f332138d52ff8$var$Uz + " +k=1.0000346418 +x_0=263347.7263 +y_0=0.0076" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=44.4" + $f68f332138d52ff8$var$VA + " +k=1.0000187521 +x_0=158801.1176 +y_0=0.0023" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Wn + $f68f332138d52ff8$var$Oo + " +k=1.0000385418 +x_0=59131.3183 +y_0=0.0041" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Wo + $f68f332138d52ff8$var$VB + " +k=1.0000410324 +x_0=51816.104 +y_0=0.003" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Wp + $f68f332138d52ff8$var$Wq + $f68f332138d52ff8$var$VC + " +k_0=1.000035079 +x_0=120091.4402 +y_0=91687.92389999999" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Wr + $f68f332138d52ff8$var$VD + " +k=1.0000552095 +x_0=133502.6683 +y_0=0.0063" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Ws + $f68f332138d52ff8$var$VE + " +k=1.0000673004 +x_0=275844.5533 +y_0=0.0157" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Wt + " +lon_0=-90.8 +k=1.0000349452 +x_0=242316.4841 +y_0=0.01" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Wu + $f68f332138d52ff8$var$Wv + $f68f332138d52ff8$var$VF + " +k_0=1.0000390487 +x_0=170078.7403 +y_0=45830.2947" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Ww + $f68f332138d52ff8$var$Wx + $f68f332138d52ff8$var$Ka + " +k_0=1.0000344057 +x_0=150876.3018 +y_0=79170.7795" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Wy + $f68f332138d52ff8$var$VG + " +k=1.0000394961 +x_0=113081.0261 +y_0=0.0045" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Wz + $f68f332138d52ff8$var$VH + " +k=1.0000677153 +x_0=220980.4419 +y_0=0.008500000000000001" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$XA + $f68f332138d52ff8$var$VI + " +k=1.0000353 +x_0=27000 +y_0=25000" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$XB + $f68f332138d52ff8$var$VJ + " +k=1.0000260649 +x_0=185928.3728 +y_0=0.0009" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$XC + $f68f332138d52ff8$var$Su + " +k=1.0000233704 +x_0=79857.7614 +y_0=0.0012" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$XD + $f68f332138d52ff8$var$VK + " +k=1.0000319985 +x_0=130454.6598 +y_0=0.0033" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$XE + $f68f332138d52ff8$var$XF + $f68f332138d52ff8$var$VL + " +k_0=1.0000627024 +x_0=198425.197 +y_0=105279.7829" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$XG + $f68f332138d52ff8$var$VM + " +k=1.0000599003 +x_0=116129.0323 +y_0=0.0058" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$XH + $f68f332138d52ff8$var$XI + " +lon_0=-89.77 +k_0=1.000053289 +x_0=74676.1493 +y_0=55049.2669" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$XJ + $f68f332138d52ff8$var$VN + " +k=1.0000234982 +x_0=238658.8794 +y_0=0.0032" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$XK + $f68f332138d52ff8$var$VO + " +k=1.0000362499 +x_0=105461.0121 +y_0=0.0029" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$XL + $f68f332138d52ff8$var$XM + $f68f332138d52ff8$var$VP + " +k_0=1.0000434122 +x_0=204521.209 +y_0=121923.9861" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$XN + $f68f332138d52ff8$var$VQ + " +k=1.0000236869 +x_0=182880.3676 +y_0=0.0033" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$XO + $f68f332138d52ff8$var$XP + $f68f332138d52ff8$var$VR + " +k_0=1.0000686968 +x_0=70104.1401 +y_0=57588.0346" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$XQ + $f68f332138d52ff8$var$XR + $f68f332138d52ff8$var$VS + " +k_0=1.0000362977 +x_0=167640.3354 +y_0=86033.0876" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$XS + $f68f332138d52ff8$var$Kb + " +k=1.0000433849 +x_0=141732.2823 +y_0=0.0059" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$XT + $f68f332138d52ff8$var$XU + " +lon_0=-89.5 +k_0=1.000039936 +x_0=56388.1128 +y_0=50022.1874" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$XV + $f68f332138d52ff8$var$VT + " +k=1.0000649554 +x_0=227990.8546 +y_0=0.0109" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Zu + $f68f332138d52ff8$var$Zv + $f68f332138d52ff8$var$VU + " +k_0=1.0000375653 +x_0=202387.6048 +y_0=134255.4253" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$XW + $f68f332138d52ff8$var$VV + " +k=1.0000337311 +x_0=146304.2926 +y_0=0.0068" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$XX + $f68f332138d52ff8$var$VW + " +k=1.0000495976 +x_0=250546.1013 +y_0=0.0234" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$XY + $f68f332138d52ff8$var$VX + " +k=1.0000373868 +x_0=185623.5716 +y_0=0.0051" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$XZ + $f68f332138d52ff8$var$Xa + $f68f332138d52ff8$var$VY + " +k_0=1.0000573461 +x_0=216713.2336 +y_0=120734.1631" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$LJ + $f68f332138d52ff8$var$VZ + " +k=1.000032144 +x_0=262433.3253 +y_0=0.009599999999999999" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$LJ + $f68f332138d52ff8$var$Kb + " +k=1.0000381803 +x_0=165506.7302 +y_0=0.0103" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Xb + $f68f332138d52ff8$var$Xc + $f68f332138d52ff8$var$Va + " +k_0=1.0000597566 +x_0=187147.5744 +y_0=107746.7522" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Xd + $f68f332138d52ff8$var$Vb + " +k=1.0000361538 +x_0=256946.9138 +y_0=0.0041" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Xe + $f68f332138d52ff8$var$Xf + $f68f332138d52ff8$var$Vc + " +k_0=1.0000408158 +x_0=222504.4451 +y_0=47532.0602" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Xg + $f68f332138d52ff8$var$Xh + $f68f332138d52ff8$var$Vd + " +k_0=1.0000730142 +x_0=134417.0689 +y_0=50337.1092" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Xi + $f68f332138d52ff8$var$Xj + $f68f332138d52ff8$var$Ve + " +k_0=1.0000367192 +x_0=232562.8651 +y_0=111088.2224" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Xk + $f68f332138d52ff8$var$Xl + $f68f332138d52ff8$var$Vf + " +k_0=1.0000475376 +x_0=234086.8682 +y_0=188358.6058" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Xm + $f68f332138d52ff8$var$Vg + " +k=1.00003738 +x_0=120091.4415 +y_0=0.003" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Xn + $f68f332138d52ff8$var$Vh + " +k=1.0000346179 +x_0=208788.418 +y_0=0.0034" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Xo + $f68f332138d52ff8$var$Vi + " +k=1.0000333645 +x_0=185013.9709 +y_0=0.007" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Xp + $f68f332138d52ff8$var$Xq + $f68f332138d52ff8$var$Ka + " +k_0=1.0000392096 +x_0=120091.4402 +y_0=45069.7587" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Xr + $f68f332138d52ff8$var$Xs + $f68f332138d52ff8$var$Bu + " +k_0=1.0000421209 +x_0=208483.6173 +y_0=134589.754" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$WY + $f68f332138d52ff8$var$Bu + " +k=1.0000365285 +x_0=147218.6941325883 +y_0=0.00365760731521463" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$WZ + $f68f332138d52ff8$var$Uq + " +k=1.0000495683 +x_0=172821.945948692 +y_0=0.001828803657607315" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Wa + $f68f332138d52ff8$var$Ur + " +k=1.0000486665 +x_0=93150" + $f68f332138d52ff8$var$IX + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Wb + $f68f332138d52ff8$var$Wc + $f68f332138d52ff8$var$Us + " +k_0=1.0000331195 +x_0=228600.4575057151 +y_0=148551.4835661671" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Nj + " +lon_0=-88" + $f68f332138d52ff8$var$Og + " +x_0=31599.99989839979 +y_0=4599.999898399797" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Wd + $f68f332138d52ff8$var$Ut + " +k=1.0000382778 +x_0=175260.3502159004" + $f68f332138d52ff8$var$Vj + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$We + $f68f332138d52ff8$var$Wf + $f68f332138d52ff8$var$Uu + " +k_0=1.0000383841 +x_0=64008.12771145543 +y_0=59445.90419100838" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Wg + " +lon_0=-88.5 +k=1.0000286569 +x_0=244754.8892049784" + $f68f332138d52ff8$var$Vj + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Wh + $f68f332138d52ff8$var$Wi + $f68f332138d52ff8$var$Uv + " +k_0=1.0000391127 +x_0=60045.72009144018 +y_0=44091.43449326898" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=43.6" + $f68f332138d52ff8$var$Uw + " +k=1.0000463003 +x_0=199949.198983998" + $f68f332138d52ff8$var$Vk + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Wj + $f68f332138d52ff8$var$Wk + $f68f332138d52ff8$var$Ux + " +k_0=1.00003498 +x_0=169164.338023876 +y_0=111569.613512827" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$aQ + $f68f332138d52ff8$var$aR + $f68f332138d52ff8$var$Wl + " +k_0=1.0000349151 +x_0=113690.6273812548 +y_0=53703.12024384048" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Zs + $f68f332138d52ff8$var$Zt + $f68f332138d52ff8$var$Uy + " +k_0=1.0000384786 +x_0=247193.2943865888 +y_0=146591.9896367793" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Wm + $f68f332138d52ff8$var$Uz + " +k=1.0000346418 +x_0=263347.7263906528 +y_0=0.00762001524003048" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=44.4" + $f68f332138d52ff8$var$VA + " +k=1.0000187521 +x_0=158801.1176022352 +y_0=0.002438404876809754" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Wn + $f68f332138d52ff8$var$Oo + " +k=1.0000385418 +x_0=59131.31826263652" + $f68f332138d52ff8$var$Vl + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Wo + $f68f332138d52ff8$var$VB + " +k=1.0000410324 +x_0=51816.10393700787" + $f68f332138d52ff8$var$IX + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Wp + $f68f332138d52ff8$var$Wq + $f68f332138d52ff8$var$VC + " +k_0=1.000035079" + $f68f332138d52ff8$var$Ys + " +y_0=91687.92390144781" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Wr + $f68f332138d52ff8$var$VD + " +k=1.0000552095 +x_0=133502.6682245364 +y_0=0.006400812801625603" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Ws + $f68f332138d52ff8$var$VE + " +k=1.0000673004 +x_0=275844.5532131065 +y_0=0.0158496316992634" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Wt + " +lon_0=-90.8 +k=1.0000349452 +x_0=242316.484023368 +y_0=0.01005842011684023" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Wu + $f68f332138d52ff8$var$Wv + $f68f332138d52ff8$var$VF + " +k_0=1.0000390487 +x_0=170078.7401574803 +y_0=45830.29484378968" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Ww + $f68f332138d52ff8$var$Wx + $f68f332138d52ff8$var$Ka + " +k_0=1.0000344057 +x_0=150876.3017526035 +y_0=79170.77937515875" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Wy + $f68f332138d52ff8$var$VG + " +k=1.0000394961 +x_0=113081.0261620523 +y_0=0.004572009144018288" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Wz + $f68f332138d52ff8$var$VH + " +k=1.0000677153 +x_0=220980.4419608839" + $f68f332138d52ff8$var$Vk + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$XA + $f68f332138d52ff8$var$VI + " +k=1.0000353 +x_0=27000 +y_0=24999.99989839979" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$XB + $f68f332138d52ff8$var$VJ + " +k=1.0000260649 +x_0=185928.3727711455 +y_0=0.0009144018288036576" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$XC + $f68f332138d52ff8$var$Su + " +k=1.0000233704 +x_0=79857.76154432308 +y_0=0.001219202438404877" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$XD + $f68f332138d52ff8$var$VK + " +k=1.0000319985 +x_0=130454.6596901194" + $f68f332138d52ff8$var$Op + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$XE + $f68f332138d52ff8$var$XF + $f68f332138d52ff8$var$VL + " +k_0=1.0000627024 +x_0=198425.1968503937 +y_0=105279.7828803657" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$XG + $f68f332138d52ff8$var$VM + " +k=1.0000599003 +x_0=116129.0322580645" + $f68f332138d52ff8$var$Vm + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$XH + $f68f332138d52ff8$var$XI + " +lon_0=-89.77 +k_0=1.000053289 +x_0=74676.1493522987 +y_0=55049.26695453391" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$XJ + $f68f332138d52ff8$var$VN + " +k=1.0000234982 +x_0=238658.8794513589" + $f68f332138d52ff8$var$IX + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$XK + $f68f332138d52ff8$var$VO + " +k=1.0000362499 +x_0=105461.0121412243" + $f68f332138d52ff8$var$IX + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$XL + $f68f332138d52ff8$var$XM + $f68f332138d52ff8$var$VP + " +k_0=1.0000434122 +x_0=204521.2090424181 +y_0=121923.9861823724" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$XN + $f68f332138d52ff8$var$VQ + " +k=1.0000236869 +x_0=182880.3675895352" + $f68f332138d52ff8$var$Op + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$XO + $f68f332138d52ff8$var$XP + $f68f332138d52ff8$var$VR + " +k_0=1.0000686968 +x_0=70104.14020828041 +y_0=57588.03474726949" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$XQ + $f68f332138d52ff8$var$XR + $f68f332138d52ff8$var$VS + " +k_0=1.0000362977 +x_0=167640.3352806706 +y_0=86033.08773177546" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$XS + $f68f332138d52ff8$var$Kb + " +k=1.0000433849 +x_0=141732.2822453645" + $f68f332138d52ff8$var$Vm + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$XT + $f68f332138d52ff8$var$XU + " +lon_0=-89.5 +k_0=1.000039936 +x_0=56388.11277622555 +y_0=50022.1874523749" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$XV + $f68f332138d52ff8$var$VT + " +k=1.0000649554 +x_0=227990.8544577089 +y_0=0.01097282194564389" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Zu + $f68f332138d52ff8$var$Zv + $f68f332138d52ff8$var$VU + " +k_0=1.0000375653 +x_0=202387.6047752095 +y_0=134255.4254508509" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$XW + $f68f332138d52ff8$var$VV + " +k=1.0000337311 +x_0=146304.2926085852 +y_0=0.006705613411226822" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$XX + $f68f332138d52ff8$var$VW + " +k=1.0000495976 +x_0=250546.1013970028 +y_0=0.02346964693929388" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$XY + $f68f332138d52ff8$var$VX + " +k=1.0000373868 +x_0=185623.5715519431 +y_0=0.005181610363220727" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$XZ + $f68f332138d52ff8$var$Xa + $f68f332138d52ff8$var$VY + " +k_0=1.0000573461 +x_0=216713.2337312675 +y_0=120734.1631699263" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$LJ + $f68f332138d52ff8$var$VZ + " +k=1.000032144 +x_0=262433.3251714504 +y_0=0.009448818897637795" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$LJ + $f68f332138d52ff8$var$Kb + " +k=1.0000381803 +x_0=165506.7300990602 +y_0=0.01036322072644145" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Xb + $f68f332138d52ff8$var$Xc + $f68f332138d52ff8$var$Va + " +k_0=1.0000597566 +x_0=187147.5742951486 +y_0=107746.7521463043" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Xd + $f68f332138d52ff8$var$Vb + " +k=1.0000361538 +x_0=256946.9138938278" + $f68f332138d52ff8$var$Vl + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Xe + $f68f332138d52ff8$var$Xf + $f68f332138d52ff8$var$Vc + " +k_0=1.0000408158 +x_0=222504.44500889 +y_0=47532.0603505207" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Xg + $f68f332138d52ff8$var$Xh + $f68f332138d52ff8$var$Vd + " +k_0=1.0000730142 +x_0=134417.0688341377 +y_0=50337.10927101854" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Xi + $f68f332138d52ff8$var$Xj + $f68f332138d52ff8$var$Ve + " +k_0=1.0000367192 +x_0=232562.8651257302 +y_0=111088.2224028448" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Xk + $f68f332138d52ff8$var$Xl + $f68f332138d52ff8$var$Vf + " +k_0=1.0000475376 +x_0=234086.8681737363 +y_0=188358.6059436119" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Xm + $f68f332138d52ff8$var$Vg + " +k=1.00003738 +x_0=120091.4414020828" + $f68f332138d52ff8$var$IX + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Xn + $f68f332138d52ff8$var$Vh + " +k=1.0000346179 +x_0=208788.4178816358" + $f68f332138d52ff8$var$Op + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Xo + $f68f332138d52ff8$var$Vi + " +k=1.0000333645 +x_0=185013.9709423419 +y_0=0.007010414020828041" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Xp + $f68f332138d52ff8$var$Xq + $f68f332138d52ff8$var$Ka + " +k_0=1.0000392096" + $f68f332138d52ff8$var$Ys + " +y_0=45069.7588011176" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Xr + $f68f332138d52ff8$var$Xs + $f68f332138d52ff8$var$Bu + " +k_0=1.0000421209 +x_0=208483.6172720346 +y_0=134589.7539243078" + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    41,
    $f68f332138d52ff8$var$K + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$A,
    6,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + " +lon_0=68.51666666666667 +k=1 +x_0=1300000" + $f68f332138d52ff8$var$RX + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + " +lon_0=71.51666666666667 +k=1" + $f68f332138d52ff8$var$aB + $f68f332138d52ff8$var$RX + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + " +lon_0=74.51666666666667 +k=1" + $f68f332138d52ff8$var$aC + $f68f332138d52ff8$var$RX + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + " +lon_0=77.51666666666667 +k=1" + $f68f332138d52ff8$var$aD + $f68f332138d52ff8$var$RX + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + " +lon_0=80.51666666666667 +k=1 +x_0=5300000" + $f68f332138d52ff8$var$RX + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    12308,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Gl + " +k=1" + $f68f332138d52ff8$var$DP + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$HO + " +k=1" + $f68f332138d52ff8$var$Eg + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$IG + " +k=1" + $f68f332138d52ff8$var$Jt + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$LN + " +k=1" + $f68f332138d52ff8$var$IM + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$JS + " +k=1" + $f68f332138d52ff8$var$MS + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$PS + " +k=1" + $f68f332138d52ff8$var$MT + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$RL + " +k=1" + $f68f332138d52ff8$var$LY + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$QW + " +k=1" + $f68f332138d52ff8$var$Jp + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$RM + " +k=1" + $f68f332138d52ff8$var$LZ + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$HP + " +k=1" + $f68f332138d52ff8$var$HU + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$HQ + " +k=1" + $f68f332138d52ff8$var$Gw + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Hd + " +k=1" + $f68f332138d52ff8$var$Hu + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$HR + " +k=1" + $f68f332138d52ff8$var$Hv + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$HS + " +k=1" + $f68f332138d52ff8$var$It + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$EN + " +k=1" + $f68f332138d52ff8$var$Hs + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Fy + " +k=1" + $f68f332138d52ff8$var$Ht + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Fm + " +k=1" + $f68f332138d52ff8$var$HV + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Fr + " +k=1" + $f68f332138d52ff8$var$Hw + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Ed + " +k=1" + $f68f332138d52ff8$var$HW + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Fn + " +k=1" + $f68f332138d52ff8$var$Hx + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Pf + " +k=1" + $f68f332138d52ff8$var$La + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Od + " +k=1" + $f68f332138d52ff8$var$Hy + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$NY + " +k=1" + $f68f332138d52ff8$var$Hz + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Pg + " +k=1" + $f68f332138d52ff8$var$IA + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$NZ + " +k=1" + $f68f332138d52ff8$var$IB + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Lf + " +k=1" + $f68f332138d52ff8$var$Gx + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$KG + " +k=1" + $f68f332138d52ff8$var$IT + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$KH + " +k=1" + $f68f332138d52ff8$var$Gc + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Lh + " +k=1" + $f68f332138d52ff8$var$IU + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$G + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    103,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ki + $f68f332138d52ff8$var$c + $f68f332138d52ff8$var$HX + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Mf + $f68f332138d52ff8$var$c + $f68f332138d52ff8$var$HX + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$KD + $f68f332138d52ff8$var$c + $f68f332138d52ff8$var$HX + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$JZ + $f68f332138d52ff8$var$c + $f68f332138d52ff8$var$HX + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    111,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Mi + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$x + $f68f332138d52ff8$var$r + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$NS + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$x + $f68f332138d52ff8$var$r + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Mg + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$x + $f68f332138d52ff8$var$r + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$NT + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$x + $f68f332138d52ff8$var$r + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ot + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$x + $f68f332138d52ff8$var$r + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Nv + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$x + $f68f332138d52ff8$var$r + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$PM + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$x + $f68f332138d52ff8$var$r + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Re + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$x + $f68f332138d52ff8$var$r + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$SM + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$x + $f68f332138d52ff8$var$r + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$MA + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$x + $f68f332138d52ff8$var$r + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    91,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Mi + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$x + $f68f332138d52ff8$var$CB + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$NS + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$x + $f68f332138d52ff8$var$CB + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Mg + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$x + $f68f332138d52ff8$var$CB + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$NT + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$x + $f68f332138d52ff8$var$CB + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ot + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$x + $f68f332138d52ff8$var$CB + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Nv + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$x + $f68f332138d52ff8$var$CB + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$PM + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$x + $f68f332138d52ff8$var$CB + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Re + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$x + $f68f332138d52ff8$var$CB + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    80,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Mf + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$Cm + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$KD + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$Cm + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$JZ + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$Cm + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$JM + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$Cm + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Me + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$Cm + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    59,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$JM + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$Cm + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    39,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$JZ + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$NL + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$JM + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$NL + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    251,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$BY + " +lon_0=1 +k=1" + $f68f332138d52ff8$var$h + $f68f332138d52ff8$var$Hk + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$EV + $f68f332138d52ff8$var$Zb + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$BY + " +lon_0=1 +k=1" + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$EV + $f68f332138d52ff8$var$Zb + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    31,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Io + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$Ec + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$MB + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$Ec + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Nx + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$Ec + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    110,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$NR + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$Bc + $f68f332138d52ff8$var$BS + $f68f332138d52ff8$var$In + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ki + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$Bc + $f68f332138d52ff8$var$BS + $f68f332138d52ff8$var$In + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Mf + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$Bc + $f68f332138d52ff8$var$BS + $f68f332138d52ff8$var$In + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    99,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ki + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$c + $f68f332138d52ff8$var$ER + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Mf + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$c + $f68f332138d52ff8$var$ER + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$KD + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$c + $f68f332138d52ff8$var$ER + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    58,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ki + $f68f332138d52ff8$var$c + $f68f332138d52ff8$var$ER + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Mf + $f68f332138d52ff8$var$c + $f68f332138d52ff8$var$ER + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$KD + $f68f332138d52ff8$var$c + $f68f332138d52ff8$var$ER + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    51,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Mh + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$Cj + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Mi + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$Cj + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$NS + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$Cj + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    141,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$NU + $f68f332138d52ff8$var$EP + $f68f332138d52ff8$var$u + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$c + $f68f332138d52ff8$var$Jw + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=13.17638888888889 +lon_0=-59.55972222222222 +k=0.9999986" + $f68f332138d52ff8$var$Zl + " +y_0=75000" + $f68f332138d52ff8$var$c + $f68f332138d52ff8$var$Jw + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    121,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$HP + " +k=1" + $f68f332138d52ff8$var$HU + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$U + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$HQ + " +k=1" + $f68f332138d52ff8$var$Gw + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$U + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Hd + " +k=1" + $f68f332138d52ff8$var$Hu + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$U + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$HR + " +k=1" + $f68f332138d52ff8$var$Hv + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$U + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$HS + " +k=1" + $f68f332138d52ff8$var$It + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$U + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$EN + " +k=1" + $f68f332138d52ff8$var$Hs + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$U + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Fy + " +k=1" + $f68f332138d52ff8$var$Ht + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$U + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Fm + " +k=1" + $f68f332138d52ff8$var$HV + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$U + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Fr + " +k=1" + $f68f332138d52ff8$var$Hw + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$U + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Ed + " +k=1" + $f68f332138d52ff8$var$HW + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$U + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Fn + " +k=1" + $f68f332138d52ff8$var$Hx + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$U + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    30,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$HP + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$U + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$HQ + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$U + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Hd + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$U + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$HR + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$U + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$HS + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$U + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$EN + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$U + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Fy + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$U + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Fm + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$U + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Fr + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$U + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Ed + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$U + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Fn + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$U + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    37,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Ks + $f68f332138d52ff8$var$Kt + $f68f332138d52ff8$var$Hr + $f68f332138d52ff8$var$HN + $f68f332138d52ff8$var$Bn + " +y_0=5400000" + $f68f332138d52ff8$var$R + " +pm=brussels" + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    280,
    $f68f332138d52ff8$var$Pu + $f68f332138d52ff8$var$Kj + $f68f332138d52ff8$var$HN + " +k_0=1" + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$Gf + " +pm=bern" + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$Pu + $f68f332138d52ff8$var$Kj + $f68f332138d52ff8$var$Ow + " +k_0=1" + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$IK + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$Gf + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$Pu + $f68f332138d52ff8$var$Kj + $f68f332138d52ff8$var$Ow + " +k_0=1" + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$Gf + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    36,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$IC + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$ES + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    78,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$LK + " +lon_0=-77.08091666666667 +k=1" + $f68f332138d52ff8$var$BZ + $f68f332138d52ff8$var$AH + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$ES + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$LK + " +lon_0=-74.08091666666667 +k=1" + $f68f332138d52ff8$var$BZ + $f68f332138d52ff8$var$AH + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$ES + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$LK + " +lon_0=-71.08091666666667 +k=1" + $f68f332138d52ff8$var$BZ + $f68f332138d52ff8$var$AH + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$ES + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$LK + " +lon_0=-68.08091666666667 +k=1" + $f68f332138d52ff8$var$BZ + $f68f332138d52ff8$var$AH + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$ES + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    133,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$JN + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$c + $f68f332138d52ff8$var$GO + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$KC + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$c + $f68f332138d52ff8$var$GO + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    58,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + " +lon_0=11.5" + $f68f332138d52ff8$var$AP + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$Ak + $f68f332138d52ff8$var$c + $f68f332138d52ff8$var$GO + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$IH + $f68f332138d52ff8$var$AP + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$Ak + $f68f332138d52ff8$var$c + $f68f332138d52ff8$var$GO + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    79,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$m + $f68f332138d52ff8$var$UQ + " +k=1" + $f68f332138d52ff8$var$AV + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$m + $f68f332138d52ff8$var$MP + " +k=1" + $f68f332138d52ff8$var$Ci + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$m + $f68f332138d52ff8$var$Pe + " +k=1" + $f68f332138d52ff8$var$Bo + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$m + $f68f332138d52ff8$var$Qk + " +k=1" + $f68f332138d52ff8$var$DP + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$m + $f68f332138d52ff8$var$US + " +k=1" + $f68f332138d52ff8$var$Eg + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$m + $f68f332138d52ff8$var$Zc + " +k=1" + $f68f332138d52ff8$var$Jt + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$m + $f68f332138d52ff8$var$Nb + " +k=1" + $f68f332138d52ff8$var$IM + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    4,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$m + $f68f332138d52ff8$var$UQ + " +k=1" + $f68f332138d52ff8$var$AV + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$j + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$m + $f68f332138d52ff8$var$MP + " +k=1" + $f68f332138d52ff8$var$Ci + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$j + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$m + $f68f332138d52ff8$var$Pe + " +k=1" + $f68f332138d52ff8$var$Bo + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$j + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$m + $f68f332138d52ff8$var$Qk + " +k=1" + $f68f332138d52ff8$var$DP + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$j + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$m + $f68f332138d52ff8$var$US + " +k=1" + $f68f332138d52ff8$var$Eg + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$j + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$m + $f68f332138d52ff8$var$Zc + " +k=1" + $f68f332138d52ff8$var$Jt + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$j + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$m + $f68f332138d52ff8$var$Nb + " +k=1" + $f68f332138d52ff8$var$IM + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$j + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    4,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$m + $f68f332138d52ff8$var$UQ + " +k=1" + $f68f332138d52ff8$var$AV + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$Bs + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$m + $f68f332138d52ff8$var$MP + " +k=1" + $f68f332138d52ff8$var$Ci + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$Bs + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$m + $f68f332138d52ff8$var$Pe + " +k=1" + $f68f332138d52ff8$var$Bo + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$Bs + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$m + $f68f332138d52ff8$var$Qk + " +k=1" + $f68f332138d52ff8$var$DP + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$Bs + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$m + $f68f332138d52ff8$var$US + " +k=1" + $f68f332138d52ff8$var$Eg + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$Bs + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$m + $f68f332138d52ff8$var$Zc + " +k=1" + $f68f332138d52ff8$var$Jt + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$Bs + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$m + $f68f332138d52ff8$var$Nb + " +k=1" + $f68f332138d52ff8$var$IM + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$Bs + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    37,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$NR + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$Bc + $f68f332138d52ff8$var$BS + $f68f332138d52ff8$var$Ax + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ki + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$Bc + $f68f332138d52ff8$var$BS + $f68f332138d52ff8$var$Ax + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    40,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Gj + " +k=1" + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$Gk + $f68f332138d52ff8$var$Bc + $f68f332138d52ff8$var$BS + $f68f332138d52ff8$var$Ax + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    2,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$UE + " +k=1" + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$Gk + $f68f332138d52ff8$var$Bc + $f68f332138d52ff8$var$BS + $f68f332138d52ff8$var$Ax + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    2,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$RI + " +k=1" + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$Gk + $f68f332138d52ff8$var$Bc + $f68f332138d52ff8$var$BS + $f68f332138d52ff8$var$Ax + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    2,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Gl + " +k=1" + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$Gk + $f68f332138d52ff8$var$Bc + $f68f332138d52ff8$var$BS + $f68f332138d52ff8$var$Ax + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    2,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$SP + " +k=1" + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$Gk + $f68f332138d52ff8$var$Bc + $f68f332138d52ff8$var$BS + $f68f332138d52ff8$var$Ax + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    2,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$RJ + " +k=1" + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$Gk + $f68f332138d52ff8$var$Bc + $f68f332138d52ff8$var$BS + $f68f332138d52ff8$var$Ax + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    2,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$HO + " +k=1" + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$Gk + $f68f332138d52ff8$var$Bc + $f68f332138d52ff8$var$BS + $f68f332138d52ff8$var$Ax + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    2,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + " +lon_0=29 +k=1" + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$Gk + $f68f332138d52ff8$var$Bc + $f68f332138d52ff8$var$BS + $f68f332138d52ff8$var$Ax + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    2,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$QQ + " +k=1" + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$Gk + $f68f332138d52ff8$var$Bc + $f68f332138d52ff8$var$BS + $f68f332138d52ff8$var$Ax + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    2,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$IG + " +k=1" + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$Gk + $f68f332138d52ff8$var$Bc + $f68f332138d52ff8$var$BS + $f68f332138d52ff8$var$Ax + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    39,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$JN + $f68f332138d52ff8$var$AU + $f68f332138d52ff8$var$BN + $f68f332138d52ff8$var$Gi + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    59,
    $f68f332138d52ff8$var$H + " +lat_1=36" + $f68f332138d52ff8$var$GM + " +lon_0=9.9" + $f68f332138d52ff8$var$QL + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$Hk + $f68f332138d52ff8$var$AU + $f68f332138d52ff8$var$BN + $f68f332138d52ff8$var$Gi + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Sd + $f68f332138d52ff8$var$Se + " +lon_0=9.9" + $f68f332138d52ff8$var$Nk + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$Hk + $f68f332138d52ff8$var$AU + $f68f332138d52ff8$var$BN + $f68f332138d52ff8$var$Gi + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    129,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$ID + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$GR + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Io + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$GR + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$MB + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$GR + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Nx + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$GR + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Nr + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$GR + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    175,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$aL + " +lat_0=34.65 +lon_0=37.35 +k_0=0.9996256" + $f68f332138d52ff8$var$AI + $f68f332138d52ff8$var$Hk + $f68f332138d52ff8$var$AU + $f68f332138d52ff8$var$BN + $f68f332138d52ff8$var$HI + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    70,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$aL + " +lat_0=34.65 +lon_0=37.35 +k_0=0.9996256" + $f68f332138d52ff8$var$AI + $f68f332138d52ff8$var$Hk + $f68f332138d52ff8$var$AU + $f68f332138d52ff8$var$BN + $f68f332138d52ff8$var$HI + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    10,
    $f68f332138d52ff8$var$GU + " +lat_0=34.2 +lon_0=39.15 +k=0.9995341" + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$AU + $f68f332138d52ff8$var$BN + $f68f332138d52ff8$var$HI + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    211,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Gm + " +lon_0=35 +k=1" + $f68f332138d52ff8$var$AI + " +y_0=1100000" + $f68f332138d52ff8$var$Gn + $f68f332138d52ff8$var$HY + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Gm + $f68f332138d52ff8$var$QQ + " +k=1 +x_0=615000 +y_0=810000" + $f68f332138d52ff8$var$Gn + $f68f332138d52ff8$var$HY + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Gm + $f68f332138d52ff8$var$HO + " +k=1" + $f68f332138d52ff8$var$EW + $f68f332138d52ff8$var$IK + $f68f332138d52ff8$var$Gn + $f68f332138d52ff8$var$HY + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Gm + $f68f332138d52ff8$var$HO + " +k=1" + $f68f332138d52ff8$var$EW + $f68f332138d52ff8$var$Tj + $f68f332138d52ff8$var$Gn + $f68f332138d52ff8$var$HY + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    34,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ja + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$n + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$KA + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$n + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Oq + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$n + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$QD + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$n + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$JN + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$n + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$KC + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$n + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$NR + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$n + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ki + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$n + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Mf + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$n + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$KD + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$n + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$JZ + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$n + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    52,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$HN + $f68f332138d52ff8$var$AP + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$n + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    5,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + " +lon_0=5" + $f68f332138d52ff8$var$AP + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$n + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    144,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$JM + $f68f332138d52ff8$var$c + $f68f332138d52ff8$var$NM + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Me + $f68f332138d52ff8$var$c + $f68f332138d52ff8$var$NM + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    460,
    $f68f332138d52ff8$var$Pu + " +lat_0=47.14439372222222 +lon_0=19.04857177777778 +k_0=0.99993 +x_0=650000" + $f68f332138d52ff8$var$IK + $f68f332138d52ff8$var$aK + $f68f332138d52ff8$var$RE + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    130,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + " +lon_0=94.5" + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$h + $f68f332138d52ff8$var$DQ + $f68f332138d52ff8$var$j + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + " +lon_0=97.5" + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$h + $f68f332138d52ff8$var$DQ + $f68f332138d52ff8$var$j + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + " +lon_0=100.5" + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$h + $f68f332138d52ff8$var$DQ + $f68f332138d52ff8$var$j + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + " +lon_0=103.5" + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$h + $f68f332138d52ff8$var$DQ + $f68f332138d52ff8$var$j + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + " +lon_0=106.5" + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$h + $f68f332138d52ff8$var$DQ + $f68f332138d52ff8$var$j + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + " +lon_0=109.5" + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$h + $f68f332138d52ff8$var$DQ + $f68f332138d52ff8$var$j + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + " +lon_0=112.5" + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$h + $f68f332138d52ff8$var$DQ + $f68f332138d52ff8$var$j + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + " +lon_0=115.5" + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$h + $f68f332138d52ff8$var$DQ + $f68f332138d52ff8$var$j + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + " +lon_0=118.5" + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$h + $f68f332138d52ff8$var$DQ + $f68f332138d52ff8$var$j + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + " +lon_0=121.5" + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$h + $f68f332138d52ff8$var$DQ + $f68f332138d52ff8$var$j + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + " +lon_0=124.5" + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$h + $f68f332138d52ff8$var$DQ + $f68f332138d52ff8$var$j + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Pj + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$h + $f68f332138d52ff8$var$DQ + $f68f332138d52ff8$var$j + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + " +lon_0=130.5" + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$h + $f68f332138d52ff8$var$DQ + $f68f332138d52ff8$var$j + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Tk + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$h + $f68f332138d52ff8$var$DQ + $f68f332138d52ff8$var$j + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + " +lon_0=136.5" + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$h + $f68f332138d52ff8$var$DQ + $f68f332138d52ff8$var$j + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + " +lon_0=139.5" + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$h + $f68f332138d52ff8$var$DQ + $f68f332138d52ff8$var$j + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$QF + $f68f332138d52ff8$var$IR + $f68f332138d52ff8$var$Bh + $f68f332138d52ff8$var$Av + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ny + $f68f332138d52ff8$var$IR + $f68f332138d52ff8$var$Bh + $f68f332138d52ff8$var$Av + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Mh + $f68f332138d52ff8$var$IR + $f68f332138d52ff8$var$Bh + $f68f332138d52ff8$var$Av + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Mi + $f68f332138d52ff8$var$IR + $f68f332138d52ff8$var$Bh + $f68f332138d52ff8$var$Av + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$NS + $f68f332138d52ff8$var$IR + $f68f332138d52ff8$var$Bh + $f68f332138d52ff8$var$Av + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Mg + $f68f332138d52ff8$var$IR + $f68f332138d52ff8$var$Bh + $f68f332138d52ff8$var$Av + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$NT + $f68f332138d52ff8$var$IR + $f68f332138d52ff8$var$Bh + $f68f332138d52ff8$var$Av + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    14,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$QF + $f68f332138d52ff8$var$j + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ny + $f68f332138d52ff8$var$j + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Mh + $f68f332138d52ff8$var$j + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Mi + $f68f332138d52ff8$var$j + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$NS + $f68f332138d52ff8$var$j + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Mg + $f68f332138d52ff8$var$j + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$NT + $f68f332138d52ff8$var$j + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    5,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ny + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$j + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Mh + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$j + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Mi + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$j + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$NS + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$j + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Mg + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$j + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$NT + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$j + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ot + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$j + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Nv + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$j + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    3,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ny + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$IR + $f68f332138d52ff8$var$Bh + $f68f332138d52ff8$var$Av + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Mh + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$IR + $f68f332138d52ff8$var$Bh + $f68f332138d52ff8$var$Av + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Mi + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$IR + $f68f332138d52ff8$var$Bh + $f68f332138d52ff8$var$Av + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$NS + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$IR + $f68f332138d52ff8$var$Bh + $f68f332138d52ff8$var$Av + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Mg + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$IR + $f68f332138d52ff8$var$Bh + $f68f332138d52ff8$var$Av + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$NT + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$IR + $f68f332138d52ff8$var$Bh + $f68f332138d52ff8$var$Av + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ot + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$IR + $f68f332138d52ff8$var$Bh + $f68f332138d52ff8$var$Av + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Nv + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$IR + $f68f332138d52ff8$var$Bh + $f68f332138d52ff8$var$Av + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    52,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$QF + $f68f332138d52ff8$var$By + $f68f332138d52ff8$var$Ay + $f68f332138d52ff8$var$JR + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ny + $f68f332138d52ff8$var$By + $f68f332138d52ff8$var$Ay + $f68f332138d52ff8$var$JR + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Mh + $f68f332138d52ff8$var$By + $f68f332138d52ff8$var$Ay + $f68f332138d52ff8$var$JR + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    99,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ny + $f68f332138d52ff8$var$By + $f68f332138d52ff8$var$Ay + $f68f332138d52ff8$var$NN + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Mh + $f68f332138d52ff8$var$By + $f68f332138d52ff8$var$Ay + $f68f332138d52ff8$var$NN + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    52,
    $f68f332138d52ff8$var$H + " +lat_1=18" + $f68f332138d52ff8$var$OX + $f68f332138d52ff8$var$Ld + " +k_0=1 +x_0=167638.49597 +y_0=121918.90616" + $f68f332138d52ff8$var$RB + $f68f332138d52ff8$var$RC + $f68f332138d52ff8$var$ML + $f68f332138d52ff8$var$A,
    100,
    $f68f332138d52ff8$var$H + " +lat_1=18" + $f68f332138d52ff8$var$OX + $f68f332138d52ff8$var$Ld + " +k_0=1" + $f68f332138d52ff8$var$Bv + " +y_0=150000" + $f68f332138d52ff8$var$i + $f68f332138d52ff8$var$TG + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    105,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Te + $f68f332138d52ff8$var$By + $f68f332138d52ff8$var$Ay + $f68f332138d52ff8$var$JQ + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$QF + $f68f332138d52ff8$var$By + $f68f332138d52ff8$var$Ay + $f68f332138d52ff8$var$JQ + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    5,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Rb + $f68f332138d52ff8$var$Lp + $f68f332138d52ff8$var$Hp + $f68f332138d52ff8$var$GQ + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Rc + $f68f332138d52ff8$var$Lp + $f68f332138d52ff8$var$Hp + $f68f332138d52ff8$var$GQ + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$SO + $f68f332138d52ff8$var$Lp + $f68f332138d52ff8$var$Hp + $f68f332138d52ff8$var$GQ + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    29,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Rc + $f68f332138d52ff8$var$Go + $f68f332138d52ff8$var$CT + $f68f332138d52ff8$var$BT + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$SO + $f68f332138d52ff8$var$Go + $f68f332138d52ff8$var$CT + $f68f332138d52ff8$var$BT + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Td + $f68f332138d52ff8$var$Go + $f68f332138d52ff8$var$CT + $f68f332138d52ff8$var$BT + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Te + $f68f332138d52ff8$var$Go + $f68f332138d52ff8$var$CT + $f68f332138d52ff8$var$BT + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$QF + $f68f332138d52ff8$var$Go + $f68f332138d52ff8$var$CT + $f68f332138d52ff8$var$BT + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ny + $f68f332138d52ff8$var$Go + $f68f332138d52ff8$var$CT + $f68f332138d52ff8$var$BT + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    23,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Sc + " +lat_0=39.5 +lon_0=68 +k_0=0.99846154 +x_0=2153865.73916853 +y_0=2368292.194628102" + $f68f332138d52ff8$var$HK + $f68f332138d52ff8$var$Gv + $f68f332138d52ff8$var$GT + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Qq + $f68f332138d52ff8$var$Li + " +lon_0=68" + $f68f332138d52ff8$var$Fz + $f68f332138d52ff8$var$JX + $f68f332138d52ff8$var$JY + $f68f332138d52ff8$var$HK + $f68f332138d52ff8$var$Gv + $f68f332138d52ff8$var$GT + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$UM + $f68f332138d52ff8$var$IQ + " +lon_0=74" + $f68f332138d52ff8$var$Fz + $f68f332138d52ff8$var$JX + $f68f332138d52ff8$var$JY + $f68f332138d52ff8$var$HK + $f68f332138d52ff8$var$Gv + $f68f332138d52ff8$var$GT + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + " +lat_1=19 +lat_0=19 +lon_0=80" + $f68f332138d52ff8$var$Fz + $f68f332138d52ff8$var$JX + $f68f332138d52ff8$var$JY + $f68f332138d52ff8$var$HK + $f68f332138d52ff8$var$Gv + $f68f332138d52ff8$var$GT + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + " +lat_1=12 +lat_0=12 +lon_0=80" + $f68f332138d52ff8$var$Fz + $f68f332138d52ff8$var$JX + $f68f332138d52ff8$var$JY + $f68f332138d52ff8$var$HK + $f68f332138d52ff8$var$Gv + $f68f332138d52ff8$var$GT + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$UM + $f68f332138d52ff8$var$IQ + $f68f332138d52ff8$var$Hq + $f68f332138d52ff8$var$Fz + " +x_0=2743185.69 +y_0=914395.23" + $f68f332138d52ff8$var$By + $f68f332138d52ff8$var$Ay + $f68f332138d52ff8$var$JQ + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Qq + $f68f332138d52ff8$var$Li + " +lon_0=68" + $f68f332138d52ff8$var$Fz + " +x_0=2743196.4 +y_0=914398.8" + $f68f332138d52ff8$var$Lp + $f68f332138d52ff8$var$Hp + $f68f332138d52ff8$var$GQ + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$UM + $f68f332138d52ff8$var$IQ + " +lon_0=74" + $f68f332138d52ff8$var$Fz + " +x_0=2743196.4 +y_0=914398.8" + $f68f332138d52ff8$var$Lp + $f68f332138d52ff8$var$Hp + $f68f332138d52ff8$var$GQ + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Qq + $f68f332138d52ff8$var$Li + " +lon_0=68" + $f68f332138d52ff8$var$Fz + $f68f332138d52ff8$var$PX + $f68f332138d52ff8$var$Qa + $f68f332138d52ff8$var$Go + $f68f332138d52ff8$var$CT + $f68f332138d52ff8$var$BT + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$UM + $f68f332138d52ff8$var$IQ + " +lon_0=74" + $f68f332138d52ff8$var$Fz + $f68f332138d52ff8$var$PX + $f68f332138d52ff8$var$Qa + $f68f332138d52ff8$var$Go + $f68f332138d52ff8$var$CT + $f68f332138d52ff8$var$BT + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$UM + $f68f332138d52ff8$var$IQ + $f68f332138d52ff8$var$Hq + $f68f332138d52ff8$var$Fz + $f68f332138d52ff8$var$PX + $f68f332138d52ff8$var$Qa + $f68f332138d52ff8$var$Go + $f68f332138d52ff8$var$CT + $f68f332138d52ff8$var$BT + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + " +lat_1=19 +lat_0=19 +lon_0=80" + $f68f332138d52ff8$var$Fz + $f68f332138d52ff8$var$PX + $f68f332138d52ff8$var$Qa + $f68f332138d52ff8$var$Go + $f68f332138d52ff8$var$CT + $f68f332138d52ff8$var$BT + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$UM + $f68f332138d52ff8$var$IQ + $f68f332138d52ff8$var$Hq + $f68f332138d52ff8$var$Fz + $f68f332138d52ff8$var$JX + $f68f332138d52ff8$var$JY + $f68f332138d52ff8$var$HK + $f68f332138d52ff8$var$Gv + $f68f332138d52ff8$var$GT + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + " +lat_1=12 +lat_0=12 +lon_0=80" + $f68f332138d52ff8$var$Fz + $f68f332138d52ff8$var$PX + $f68f332138d52ff8$var$Qa + $f68f332138d52ff8$var$Go + $f68f332138d52ff8$var$CT + $f68f332138d52ff8$var$BT + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    117,
    $f68f332138d52ff8$var$Ck + " +lat_0=1.287646666666667 +lon_0=103.8530022222222" + $f68f332138d52ff8$var$Zl + " +y_0=30000" + $f68f332138d52ff8$var$GL + $f68f332138d52ff8$var$Bz + $f68f332138d52ff8$var$BV + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    47,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ny + $f68f332138d52ff8$var$GL + $f68f332138d52ff8$var$Bz + $f68f332138d52ff8$var$BV + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Mh + $f68f332138d52ff8$var$GL + $f68f332138d52ff8$var$Bz + $f68f332138d52ff8$var$BV + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    52,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Qq + $f68f332138d52ff8$var$Li + $f68f332138d52ff8$var$JS + $f68f332138d52ff8$var$PZ + $f68f332138d52ff8$var$AV + $f68f332138d52ff8$var$aG + $f68f332138d52ff8$var$c + $f68f332138d52ff8$var$Qh + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    118,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$IC + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$Hc + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Hi + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$Hc + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Gz + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$Hc + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    97,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ik + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$AX + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$IC + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$AX + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Hi + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$AX + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Gz + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$AX + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$ID + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$AX + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    56,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ik + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$AX + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$IC + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$AX + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Hi + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$AX + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Gz + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$AX + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$ID + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$AX + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Io + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$AX + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    9,
    $f68f332138d52ff8$var$D + " +lat_0=-6 +lon_0=-80.5 +k=0.99983008 +x_0=222000 +y_0=1426834.743" + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$AX + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=-9.5 +lon_0=-76 +k=0.99932994 +x_0=720000 +y_0=1039979.159" + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$AX + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=-9.5" + $f68f332138d52ff8$var$IL + " +k=0.99952992 +x_0=1324000 +y_0=1040084.558" + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$AX + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    107,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Vp + " +lon_0=-1" + $f68f332138d52ff8$var$Rv + " +x_0=274319.51" + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$c + $f68f332138d52ff8$var$TR + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    231,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$QD + $f68f332138d52ff8$var$AU + $f68f332138d52ff8$var$BN + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    160,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Fm + $f68f332138d52ff8$var$CP + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$i + $f68f332138d52ff8$var$GC + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$ZU + $f68f332138d52ff8$var$CP + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$i + $f68f332138d52ff8$var$GC + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$ZV + $f68f332138d52ff8$var$CP + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$i + $f68f332138d52ff8$var$GC + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Fr + $f68f332138d52ff8$var$CP + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$i + $f68f332138d52ff8$var$GC + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Ru + $f68f332138d52ff8$var$CP + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$i + $f68f332138d52ff8$var$GC + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    433,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ja + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$KA + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Oq + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$QD + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$JN + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$KC + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$NR + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ki + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Mf + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$KD + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    47,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$II + $f68f332138d52ff8$var$AP + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    48,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$JN + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$Qd + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    259,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Sd + $f68f332138d52ff8$var$Se + $f68f332138d52ff8$var$Yk + $f68f332138d52ff8$var$Nk + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$Hk + $f68f332138d52ff8$var$AU + $f68f332138d52ff8$var$BN + $f68f332138d52ff8$var$IO + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + " +lat_1=29.7 +lat_0=29.7" + $f68f332138d52ff8$var$Yk + " +k_0=0.9996155960000001" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$Hk + $f68f332138d52ff8$var$AU + $f68f332138d52ff8$var$BN + $f68f332138d52ff8$var$IO + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    2,
    $f68f332138d52ff8$var$H + " +lat_1=26.1 +lat_0=26.1" + $f68f332138d52ff8$var$Yk + " +k_0=0.999616304 +x_0=1200000" + $f68f332138d52ff8$var$Is + $f68f332138d52ff8$var$AU + $f68f332138d52ff8$var$BN + $f68f332138d52ff8$var$IO + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + " +lat_1=22.5 +lat_0=22.5" + $f68f332138d52ff8$var$Yk + " +k_0=0.999616437" + $f68f332138d52ff8$var$AV + $f68f332138d52ff8$var$Is + $f68f332138d52ff8$var$AU + $f68f332138d52ff8$var$BN + $f68f332138d52ff8$var$IO + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    42,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$KD + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$Tc + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    94,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$QD + $f68f332138d52ff8$var$c + $f68f332138d52ff8$var$GS + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$JN + $f68f332138d52ff8$var$c + $f68f332138d52ff8$var$GS + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    59,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Qi + " +lon_0=4.5" + $f68f332138d52ff8$var$Rv + " +x_0=230738.26" + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$c + $f68f332138d52ff8$var$GS + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Qi + " +lon_0=8.5" + $f68f332138d52ff8$var$Rv + " +x_0=670553.98" + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$c + $f68f332138d52ff8$var$GS + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Qi + " +lon_0=12.5" + $f68f332138d52ff8$var$Rv + " +x_0=1110369.7" + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$c + $f68f332138d52ff8$var$GS + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    239,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$JN + $f68f332138d52ff8$var$AU + $f68f332138d52ff8$var$BN + $f68f332138d52ff8$var$NO + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    60,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$JN + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$AU + $f68f332138d52ff8$var$BN + $f68f332138d52ff8$var$NO + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    9,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$SK + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$TV + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Xz + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$TY + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$RG + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ro + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$RH + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$TW + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$TX + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$QE + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ns + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Nt + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Nu + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Nw + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$NP + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$NQ + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ik + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$IC + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Hi + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Gz + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$ID + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Io + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    7,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$IY + $f68f332138d52ff8$var$IV + $f68f332138d52ff8$var$Pc + $f68f332138d52ff8$var$e + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Gm + $f68f332138d52ff8$var$OS + $f68f332138d52ff8$var$BG + $f68f332138d52ff8$var$e + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$CU + " +lat_0=57" + $f68f332138d52ff8$var$Ku + $f68f332138d52ff8$var$Kv + $f68f332138d52ff8$var$V + " +x_0=5000000.001016002 +y_0=-5000000.001016002" + $f68f332138d52ff8$var$KE + $f68f332138d52ff8$var$GZ + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Ft + $f68f332138d52ff8$var$YN + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$e + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Ft + $f68f332138d52ff8$var$YO + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$e + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Ft + $f68f332138d52ff8$var$ON + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$e + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Ft + $f68f332138d52ff8$var$Ms + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$e + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Ft + $f68f332138d52ff8$var$KI + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$e + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Ft + $f68f332138d52ff8$var$YP + $f68f332138d52ff8$var$V + " +x_0=213360.4267208534" + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Ft + $f68f332138d52ff8$var$YQ + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$e + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Ft + $f68f332138d52ff8$var$SW + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$Px + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Kw + $f68f332138d52ff8$var$Kx + $f68f332138d52ff8$var$UK + $f68f332138d52ff8$var$YR + $f68f332138d52ff8$var$Bw + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$DW + $f68f332138d52ff8$var$Jn + $f68f332138d52ff8$var$y + $f68f332138d52ff8$var$HA + $f68f332138d52ff8$var$Z + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$DX + $f68f332138d52ff8$var$DY + $f68f332138d52ff8$var$AA + $f68f332138d52ff8$var$HA + $f68f332138d52ff8$var$Z + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Ap + $f68f332138d52ff8$var$DZ + $f68f332138d52ff8$var$Ml + $f68f332138d52ff8$var$AJ + $f68f332138d52ff8$var$Z + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$LO + $f68f332138d52ff8$var$QS + $f68f332138d52ff8$var$Da + $f68f332138d52ff8$var$Mm + $f68f332138d52ff8$var$Z + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Db + $f68f332138d52ff8$var$Dc + $f68f332138d52ff8$var$Mn + $f68f332138d52ff8$var$Ir + $f68f332138d52ff8$var$Z + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Dd + $f68f332138d52ff8$var$De + $f68f332138d52ff8$var$Df + $f68f332138d52ff8$var$Iw + $f68f332138d52ff8$var$Z + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    2,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Bl + $f68f332138d52ff8$var$Cn + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$e + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Bl + $f68f332138d52ff8$var$Co + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$e + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Bl + $f68f332138d52ff8$var$Iv + $f68f332138d52ff8$var$BG + $f68f332138d52ff8$var$e + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Dx + $f68f332138d52ff8$var$Dy + $f68f332138d52ff8$var$BC + $f68f332138d52ff8$var$IF + $f68f332138d52ff8$var$Z + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Dz + $f68f332138d52ff8$var$Mq + $f68f332138d52ff8$var$EA + $f68f332138d52ff8$var$IF + $f68f332138d52ff8$var$Z + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + " +lat_1=39.71666666666667 +lat_2=40.78333333333333" + $f68f332138d52ff8$var$y + $f68f332138d52ff8$var$Ba + $f68f332138d52ff8$var$Z + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$LP + $f68f332138d52ff8$var$LQ + $f68f332138d52ff8$var$CY + $f68f332138d52ff8$var$Ba + $f68f332138d52ff8$var$Z + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Ap + $f68f332138d52ff8$var$Dg + $f68f332138d52ff8$var$f + $f68f332138d52ff8$var$Ba + $f68f332138d52ff8$var$Z + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Dh + $f68f332138d52ff8$var$Mo + $f68f332138d52ff8$var$Di + $f68f332138d52ff8$var$Jq + $f68f332138d52ff8$var$Px + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Ch + $f68f332138d52ff8$var$Cp + $f68f332138d52ff8$var$Mp + $f68f332138d52ff8$var$e + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Aq + $f68f332138d52ff8$var$CR + $f68f332138d52ff8$var$Am + $f68f332138d52ff8$var$e + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Aq + $f68f332138d52ff8$var$Ob + $f68f332138d52ff8$var$Am + $f68f332138d52ff8$var$e + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$LR + $f68f332138d52ff8$var$Dj + $f68f332138d52ff8$var$QT + $f68f332138d52ff8$var$LS + $f68f332138d52ff8$var$Z + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    6,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Gm + $f68f332138d52ff8$var$Cq + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$e + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Gm + $f68f332138d52ff8$var$Cr + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$e + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$p + $f68f332138d52ff8$var$Cs + $f68f332138d52ff8$var$BJ + $f68f332138d52ff8$var$e + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$p + $f68f332138d52ff8$var$Jb + $f68f332138d52ff8$var$BJ + $f68f332138d52ff8$var$e + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$p + $f68f332138d52ff8$var$Ix + $f68f332138d52ff8$var$BG + $f68f332138d52ff8$var$e + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$f + $f68f332138d52ff8$var$Cz + $f68f332138d52ff8$var$EQ + $f68f332138d52ff8$var$e + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$f + $f68f332138d52ff8$var$DA + $f68f332138d52ff8$var$Am + $f68f332138d52ff8$var$e + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$DM + $f68f332138d52ff8$var$DB + $f68f332138d52ff8$var$AO + $f68f332138d52ff8$var$e + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$DM + $f68f332138d52ff8$var$DC + $f68f332138d52ff8$var$AO + $f68f332138d52ff8$var$e + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$EB + $f68f332138d52ff8$var$EC + $f68f332138d52ff8$var$Fo + $f68f332138d52ff8$var$GG + $f68f332138d52ff8$var$Z + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$AY + $f68f332138d52ff8$var$ED + $f68f332138d52ff8$var$Fs + $f68f332138d52ff8$var$GG + $f68f332138d52ff8$var$Z + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$EE + $f68f332138d52ff8$var$EF + $f68f332138d52ff8$var$AQ + $f68f332138d52ff8$var$Fl + $f68f332138d52ff8$var$Z + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$EG + $f68f332138d52ff8$var$EH + $f68f332138d52ff8$var$f + $f68f332138d52ff8$var$CV + $f68f332138d52ff8$var$Z + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Az + $f68f332138d52ff8$var$DV + $f68f332138d52ff8$var$DM + $f68f332138d52ff8$var$Jo + $f68f332138d52ff8$var$Z + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + " +lat_1=36.73333333333333 +lat_2=37.93333333333333" + $f68f332138d52ff8$var$AB + $f68f332138d52ff8$var$EY + $f68f332138d52ff8$var$Z + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + " +lat_1=31.16666666666667 +lat_2=32.66666666666666 +lat_0=30.66666666666667" + $f68f332138d52ff8$var$Hg + $f68f332138d52ff8$var$Z + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + " +lat_1=29.3 +lat_2=30.7 +lat_0=28.66666666666667" + $f68f332138d52ff8$var$Bi + $f68f332138d52ff8$var$Z + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$AL + $f68f332138d52ff8$var$HJ + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$e + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$BD + $f68f332138d52ff8$var$DD + $f68f332138d52ff8$var$AO + $f68f332138d52ff8$var$e + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + " +lat_1=38.3 +lat_2=39.45" + $f68f332138d52ff8$var$CY + $f68f332138d52ff8$var$Ld + " +x_0=243840.4876809754" + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + " +lat_1=41.71666666666667 +lat_2=42.68333333333333" + $f68f332138d52ff8$var$Ip + $f68f332138d52ff8$var$GE + $f68f332138d52ff8$var$Px + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + " +lat_1=41.28333333333333 +lat_2=41.48333333333333" + $f68f332138d52ff8$var$Ip + $f68f332138d52ff8$var$IL + " +x_0=60960.12192024384" + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    4,
    $f68f332138d52ff8$var$H + " +lat_1=47.03333333333333 +lat_2=48.63333333333333" + $f68f332138d52ff8$var$Iq + $f68f332138d52ff8$var$DE + $f68f332138d52ff8$var$Z + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + " +lat_1=45.61666666666667 +lat_2=47.05" + $f68f332138d52ff8$var$IP + $f68f332138d52ff8$var$Js + $f68f332138d52ff8$var$Z + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + " +lat_1=43.78333333333333 +lat_2=45.21666666666667" + $f68f332138d52ff8$var$Nj + $f68f332138d52ff8$var$Na + $f68f332138d52ff8$var$Z + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Cb + $f68f332138d52ff8$var$Ct + $f68f332138d52ff8$var$Pc + $f68f332138d52ff8$var$e + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$IY + $f68f332138d52ff8$var$Bx + $f68f332138d52ff8$var$Am + $f68f332138d52ff8$var$e + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Cd + $f68f332138d52ff8$var$RS + $f68f332138d52ff8$var$BG + $f68f332138d52ff8$var$e + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Cd + $f68f332138d52ff8$var$Hg + $f68f332138d52ff8$var$BG + $f68f332138d52ff8$var$e + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Id + $f68f332138d52ff8$var$RT + $f68f332138d52ff8$var$Am + $f68f332138d52ff8$var$e + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + " +lat_1=34.41666666666666 +lat_2=33.86666666666667 +lat_0=34.13333333333333" + $f68f332138d52ff8$var$IW + " +x_0=1276106.450596901 +y_0=1268253.006858014" + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    48,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$AK + $f68f332138d52ff8$var$HJ + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$BF + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$BD + $f68f332138d52ff8$var$DD + $f68f332138d52ff8$var$AO + $f68f332138d52ff8$var$HT + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$FU + $f68f332138d52ff8$var$FV + $f68f332138d52ff8$var$Iq + $f68f332138d52ff8$var$DE + $f68f332138d52ff8$var$An + $f68f332138d52ff8$var$Ao + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Ma + $f68f332138d52ff8$var$FW + $f68f332138d52ff8$var$IP + $f68f332138d52ff8$var$Js + $f68f332138d52ff8$var$An + $f68f332138d52ff8$var$Ao + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$FX + $f68f332138d52ff8$var$FY + $f68f332138d52ff8$var$Nj + $f68f332138d52ff8$var$Na + $f68f332138d52ff8$var$An + $f68f332138d52ff8$var$Ao + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$JT + $f68f332138d52ff8$var$Jn + $f68f332138d52ff8$var$FZ + $f68f332138d52ff8$var$CS + $f68f332138d52ff8$var$AG + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Mb + $f68f332138d52ff8$var$RN + $f68f332138d52ff8$var$Mr + $f68f332138d52ff8$var$Ga + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Fg + $f68f332138d52ff8$var$Fh + $f68f332138d52ff8$var$QX + $f68f332138d52ff8$var$CR + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$AK + $f68f332138d52ff8$var$HJ + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$BF + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$BD + $f68f332138d52ff8$var$DD + $f68f332138d52ff8$var$AO + $f68f332138d52ff8$var$HT + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$FU + $f68f332138d52ff8$var$FV + $f68f332138d52ff8$var$Iq + $f68f332138d52ff8$var$DE + $f68f332138d52ff8$var$An + $f68f332138d52ff8$var$Ao + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Ma + $f68f332138d52ff8$var$FW + $f68f332138d52ff8$var$IP + $f68f332138d52ff8$var$Js + $f68f332138d52ff8$var$An + $f68f332138d52ff8$var$Ao + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$FX + $f68f332138d52ff8$var$FY + $f68f332138d52ff8$var$Nj + $f68f332138d52ff8$var$Na + $f68f332138d52ff8$var$An + $f68f332138d52ff8$var$Ao + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$JT + $f68f332138d52ff8$var$Jn + $f68f332138d52ff8$var$FZ + $f68f332138d52ff8$var$CS + $f68f332138d52ff8$var$AG + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Mb + $f68f332138d52ff8$var$RN + $f68f332138d52ff8$var$Mr + $f68f332138d52ff8$var$Ga + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Fg + $f68f332138d52ff8$var$Fh + $f68f332138d52ff8$var$QX + $f68f332138d52ff8$var$CR + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$AK + $f68f332138d52ff8$var$HJ + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$BF + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$BD + $f68f332138d52ff8$var$DD + $f68f332138d52ff8$var$AO + $f68f332138d52ff8$var$HT + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$FU + $f68f332138d52ff8$var$FV + $f68f332138d52ff8$var$Iq + $f68f332138d52ff8$var$DE + $f68f332138d52ff8$var$An + $f68f332138d52ff8$var$Ao + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Ma + $f68f332138d52ff8$var$FW + $f68f332138d52ff8$var$IP + $f68f332138d52ff8$var$Js + $f68f332138d52ff8$var$An + $f68f332138d52ff8$var$Ao + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$FX + $f68f332138d52ff8$var$FY + $f68f332138d52ff8$var$Nj + $f68f332138d52ff8$var$Na + $f68f332138d52ff8$var$An + $f68f332138d52ff8$var$Ao + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$JT + $f68f332138d52ff8$var$Jn + $f68f332138d52ff8$var$FZ + $f68f332138d52ff8$var$CS + $f68f332138d52ff8$var$AG + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Mb + $f68f332138d52ff8$var$RN + $f68f332138d52ff8$var$Mr + $f68f332138d52ff8$var$Ga + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Fg + $f68f332138d52ff8$var$Fh + $f68f332138d52ff8$var$QX + $f68f332138d52ff8$var$CR + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    21,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$ET + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$Ab + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$CR + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$Ab + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$NV + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$Ab + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Jh + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$Ab + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Bu + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$Ab + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Rs + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$Ab + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$OZ + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$Ab + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + " +lon_0=-53" + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$Ab + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Zd + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$Ab + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    2,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$SK + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$TV + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Xz + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$TY + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$RG + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ro + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$RH + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$TW + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$TX + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$QE + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ns + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Nt + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Nu + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Nw + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$NP + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$NQ + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ik + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$IC + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Hi + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Gz + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$ID + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Io + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$MB + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    6,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$IY + $f68f332138d52ff8$var$IV + $f68f332138d52ff8$var$Pc + $f68f332138d52ff8$var$h + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Gm + $f68f332138d52ff8$var$OS + $f68f332138d52ff8$var$BG + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$CU + " +lat_0=57" + $f68f332138d52ff8$var$Ku + $f68f332138d52ff8$var$Kv + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$LX + $f68f332138d52ff8$var$EO + $f68f332138d52ff8$var$KE + $f68f332138d52ff8$var$GZ + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Ft + $f68f332138d52ff8$var$YN + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Ft + $f68f332138d52ff8$var$YO + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Ft + $f68f332138d52ff8$var$ON + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Ft + $f68f332138d52ff8$var$Ms + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Ft + $f68f332138d52ff8$var$KI + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Ft + $f68f332138d52ff8$var$YP + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Ft + $f68f332138d52ff8$var$YQ + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Ft + $f68f332138d52ff8$var$SW + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Kw + $f68f332138d52ff8$var$Kx + $f68f332138d52ff8$var$UK + $f68f332138d52ff8$var$YR + $f68f332138d52ff8$var$BZ + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$DW + $f68f332138d52ff8$var$Jn + $f68f332138d52ff8$var$y + $f68f332138d52ff8$var$HA + $f68f332138d52ff8$var$Bd + $f68f332138d52ff8$var$Ae + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$DX + $f68f332138d52ff8$var$DY + $f68f332138d52ff8$var$AA + $f68f332138d52ff8$var$HA + $f68f332138d52ff8$var$Bd + $f68f332138d52ff8$var$Ae + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Ap + $f68f332138d52ff8$var$DZ + $f68f332138d52ff8$var$Ml + $f68f332138d52ff8$var$AJ + $f68f332138d52ff8$var$Bd + $f68f332138d52ff8$var$Ae + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$LO + $f68f332138d52ff8$var$QS + $f68f332138d52ff8$var$Da + $f68f332138d52ff8$var$Mm + $f68f332138d52ff8$var$Bd + $f68f332138d52ff8$var$Ae + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Db + $f68f332138d52ff8$var$Dc + $f68f332138d52ff8$var$Mn + $f68f332138d52ff8$var$Ir + $f68f332138d52ff8$var$Bd + $f68f332138d52ff8$var$Ae + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Dd + $f68f332138d52ff8$var$De + $f68f332138d52ff8$var$Df + $f68f332138d52ff8$var$Iw + $f68f332138d52ff8$var$Bd + $f68f332138d52ff8$var$Ae + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    2,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Bl + $f68f332138d52ff8$var$Cn + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$EX + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Bl + $f68f332138d52ff8$var$Co + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$EX + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Bl + $f68f332138d52ff8$var$Iv + $f68f332138d52ff8$var$BG + $f68f332138d52ff8$var$EX + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Dx + $f68f332138d52ff8$var$Dy + $f68f332138d52ff8$var$BC + $f68f332138d52ff8$var$IF + $f68f332138d52ff8$var$u + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Dz + $f68f332138d52ff8$var$Mq + $f68f332138d52ff8$var$EA + $f68f332138d52ff8$var$IF + $f68f332138d52ff8$var$u + $f68f332138d52ff8$var$Is + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Eh + $f68f332138d52ff8$var$Ei + $f68f332138d52ff8$var$y + $f68f332138d52ff8$var$Ba + $f68f332138d52ff8$var$Fw + $f68f332138d52ff8$var$Fx + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$LP + $f68f332138d52ff8$var$LQ + $f68f332138d52ff8$var$CY + $f68f332138d52ff8$var$Ba + $f68f332138d52ff8$var$Fw + $f68f332138d52ff8$var$Fx + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Ap + $f68f332138d52ff8$var$Dg + $f68f332138d52ff8$var$f + $f68f332138d52ff8$var$Ba + $f68f332138d52ff8$var$Fw + $f68f332138d52ff8$var$Fx + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Dh + $f68f332138d52ff8$var$Mo + $f68f332138d52ff8$var$Di + $f68f332138d52ff8$var$Jq + $f68f332138d52ff8$var$QG + $f68f332138d52ff8$var$QH + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Ch + $f68f332138d52ff8$var$Cp + $f68f332138d52ff8$var$Mp + $f68f332138d52ff8$var$h + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Aq + $f68f332138d52ff8$var$CR + $f68f332138d52ff8$var$Am + $f68f332138d52ff8$var$h + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Aq + $f68f332138d52ff8$var$Ob + $f68f332138d52ff8$var$Am + $f68f332138d52ff8$var$h + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$LR + $f68f332138d52ff8$var$Dj + $f68f332138d52ff8$var$QT + $f68f332138d52ff8$var$LS + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Kn + $f68f332138d52ff8$var$Sf + $f68f332138d52ff8$var$AO + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Ko + $f68f332138d52ff8$var$KO + $f68f332138d52ff8$var$AO + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$GV + $f68f332138d52ff8$var$KI + $f68f332138d52ff8$var$Jl + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Kp + $f68f332138d52ff8$var$Sg + $f68f332138d52ff8$var$Jl + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Kq + $f68f332138d52ff8$var$KP + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Gm + $f68f332138d52ff8$var$Cq + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$h + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Gm + $f68f332138d52ff8$var$Cr + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$EW + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$p + $f68f332138d52ff8$var$Cs + $f68f332138d52ff8$var$BJ + $f68f332138d52ff8$var$h + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$p + $f68f332138d52ff8$var$Jb + $f68f332138d52ff8$var$BJ + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$p + $f68f332138d52ff8$var$Ix + $f68f332138d52ff8$var$BG + $f68f332138d52ff8$var$CX + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$f + $f68f332138d52ff8$var$Cz + $f68f332138d52ff8$var$EQ + $f68f332138d52ff8$var$AI + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$f + $f68f332138d52ff8$var$DA + $f68f332138d52ff8$var$Am + $f68f332138d52ff8$var$EW + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$DM + $f68f332138d52ff8$var$DB + $f68f332138d52ff8$var$AO + $f68f332138d52ff8$var$BU + $f68f332138d52ff8$var$KJ + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$DM + $f68f332138d52ff8$var$DC + $f68f332138d52ff8$var$AO + $f68f332138d52ff8$var$HT + $f68f332138d52ff8$var$KJ + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$EB + $f68f332138d52ff8$var$EC + $f68f332138d52ff8$var$Fo + $f68f332138d52ff8$var$GG + $f68f332138d52ff8$var$AV + $f68f332138d52ff8$var$AH + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$AY + $f68f332138d52ff8$var$ED + $f68f332138d52ff8$var$Fs + $f68f332138d52ff8$var$GG + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$EE + $f68f332138d52ff8$var$EF + $f68f332138d52ff8$var$AQ + $f68f332138d52ff8$var$Fl + $f68f332138d52ff8$var$u + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$EG + $f68f332138d52ff8$var$EH + $f68f332138d52ff8$var$f + $f68f332138d52ff8$var$CV + $f68f332138d52ff8$var$u + $f68f332138d52ff8$var$Is + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    2,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Ej + $f68f332138d52ff8$var$Ek + $f68f332138d52ff8$var$AB + $f68f332138d52ff8$var$EY + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$Ae + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$FS + $f68f332138d52ff8$var$FT + $f68f332138d52ff8$var$IY + $f68f332138d52ff8$var$Hg + $f68f332138d52ff8$var$BZ + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$OH + $f68f332138d52ff8$var$OI + $f68f332138d52ff8$var$OJ + $f68f332138d52ff8$var$Bi + $f68f332138d52ff8$var$BZ + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$AK + $f68f332138d52ff8$var$HJ + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$AI + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$BD + $f68f332138d52ff8$var$DD + $f68f332138d52ff8$var$AO + $f68f332138d52ff8$var$HT + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$MU + $f68f332138d52ff8$var$Nz + $f68f332138d52ff8$var$AA + $f68f332138d52ff8$var$Ld + $f68f332138d52ff8$var$u + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$El + $f68f332138d52ff8$var$Dk + $f68f332138d52ff8$var$Ip + $f68f332138d52ff8$var$GE + $f68f332138d52ff8$var$h + $f68f332138d52ff8$var$Mk + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Em + $f68f332138d52ff8$var$En + $f68f332138d52ff8$var$Ip + $f68f332138d52ff8$var$IL + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Eo + $f68f332138d52ff8$var$Ep + $f68f332138d52ff8$var$Eq + $f68f332138d52ff8$var$Jh + $f68f332138d52ff8$var$Tl + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$OA + $f68f332138d52ff8$var$Er + $f68f332138d52ff8$var$Es + $f68f332138d52ff8$var$BE + $f68f332138d52ff8$var$Pk + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Bq + $f68f332138d52ff8$var$OB + $f68f332138d52ff8$var$Fo + $f68f332138d52ff8$var$BE + $f68f332138d52ff8$var$LU + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$FU + $f68f332138d52ff8$var$FV + $f68f332138d52ff8$var$Iq + $f68f332138d52ff8$var$DE + $f68f332138d52ff8$var$CX + $f68f332138d52ff8$var$EK + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Ma + $f68f332138d52ff8$var$FW + $f68f332138d52ff8$var$IP + $f68f332138d52ff8$var$Js + $f68f332138d52ff8$var$CX + $f68f332138d52ff8$var$EK + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$FX + $f68f332138d52ff8$var$FY + $f68f332138d52ff8$var$Nj + $f68f332138d52ff8$var$Na + $f68f332138d52ff8$var$CX + $f68f332138d52ff8$var$EK + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Hj + $f68f332138d52ff8$var$Ct + $f68f332138d52ff8$var$CP + $f68f332138d52ff8$var$AI + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Hj + $f68f332138d52ff8$var$Bx + $f68f332138d52ff8$var$CP + $f68f332138d52ff8$var$EW + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Cd + $f68f332138d52ff8$var$RS + $f68f332138d52ff8$var$BG + $f68f332138d52ff8$var$Bv + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Cd + $f68f332138d52ff8$var$Hg + $f68f332138d52ff8$var$BG + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Id + $f68f332138d52ff8$var$RT + $f68f332138d52ff8$var$Am + $f68f332138d52ff8$var$YC + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    41,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$JM + $f68f332138d52ff8$var$c + $f68f332138d52ff8$var$DO + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Me + $f68f332138d52ff8$var$c + $f68f332138d52ff8$var$DO + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    80,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Gz + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$TS + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    80,
    "+proj=nzmg +lat_0=-41 +lon_0=173 +x_0=2510000 +y_0=6023150" + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$W + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    5,
    $f68f332138d52ff8$var$D + " +lat_0=-36.87986527777778 +lon_0=174.7643393611111" + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$AI + $f68f332138d52ff8$var$DN + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$W + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=-37.76124980555556 +lon_0=176.46619725 +k=1" + $f68f332138d52ff8$var$AI + $f68f332138d52ff8$var$DN + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$W + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=-38.62470277777778 +lon_0=177.8856362777778 +k=1" + $f68f332138d52ff8$var$AI + $f68f332138d52ff8$var$DN + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$W + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=-39.65092930555556 +lon_0=176.6736805277778 +k=1" + $f68f332138d52ff8$var$AI + $f68f332138d52ff8$var$DN + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$W + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=-39.13575830555556 +lon_0=174.22801175 +k=1" + $f68f332138d52ff8$var$AI + $f68f332138d52ff8$var$DN + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$W + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=-39.51247038888889 +lon_0=175.6400368055556 +k=1" + $f68f332138d52ff8$var$AI + $f68f332138d52ff8$var$DN + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$W + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=-40.24194713888889 +lon_0=175.4880996111111 +k=1" + $f68f332138d52ff8$var$AI + $f68f332138d52ff8$var$DN + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$W + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=-40.92553263888889 +lon_0=175.6473496666667 +k=1" + $f68f332138d52ff8$var$AI + $f68f332138d52ff8$var$DN + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$W + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=-41.30131963888888 +lon_0=174.7766231111111 +k=1" + $f68f332138d52ff8$var$AI + $f68f332138d52ff8$var$DN + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$W + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=-40.71475905555556 +lon_0=172.6720465 +k=1" + $f68f332138d52ff8$var$AI + $f68f332138d52ff8$var$DN + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$W + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=-41.27454472222222 +lon_0=173.2993168055555 +k=1" + $f68f332138d52ff8$var$AI + $f68f332138d52ff8$var$DN + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$W + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=-41.28991152777778 +lon_0=172.1090281944444 +k=1" + $f68f332138d52ff8$var$AI + $f68f332138d52ff8$var$DN + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$W + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=-41.81080286111111 +lon_0=171.5812600555556 +k=1" + $f68f332138d52ff8$var$AI + $f68f332138d52ff8$var$DN + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$W + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=-42.33369427777778 +lon_0=171.5497713055556 +k=1" + $f68f332138d52ff8$var$AI + $f68f332138d52ff8$var$DN + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$W + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=-42.68911658333333 +lon_0=173.0101333888889 +k=1" + $f68f332138d52ff8$var$AI + $f68f332138d52ff8$var$DN + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$W + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=-41.54448666666666 +lon_0=173.8020741111111 +k=1" + $f68f332138d52ff8$var$AI + $f68f332138d52ff8$var$DN + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$W + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=-42.88632236111111 +lon_0=170.9799935 +k=1" + $f68f332138d52ff8$var$AI + $f68f332138d52ff8$var$DN + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$W + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=-43.11012813888889 +lon_0=170.2609258333333 +k=1" + $f68f332138d52ff8$var$AI + $f68f332138d52ff8$var$DN + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$W + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=-43.97780288888889 +lon_0=168.606267 +k=1" + $f68f332138d52ff8$var$AI + $f68f332138d52ff8$var$DN + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$W + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=-43.59063758333333 +lon_0=172.7271935833333 +k=1" + $f68f332138d52ff8$var$AI + $f68f332138d52ff8$var$DN + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$W + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=-43.74871155555556 +lon_0=171.3607484722222 +k=1" + $f68f332138d52ff8$var$AI + $f68f332138d52ff8$var$DN + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$W + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=-44.40222036111111 +lon_0=171.0572508333333 +k=1" + $f68f332138d52ff8$var$AI + $f68f332138d52ff8$var$DN + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$W + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=-44.73526797222222 +lon_0=169.4677550833333 +k=1" + $f68f332138d52ff8$var$AI + $f68f332138d52ff8$var$DN + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$W + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=-45.13290258333333 +lon_0=168.3986411944444 +k=1" + $f68f332138d52ff8$var$AI + $f68f332138d52ff8$var$DN + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$W + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=-45.56372616666666 +lon_0=167.7388617777778 +k=1" + $f68f332138d52ff8$var$AI + $f68f332138d52ff8$var$DN + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$W + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=-45.81619661111111 +lon_0=170.6285951666667 +k=1" + $f68f332138d52ff8$var$AI + $f68f332138d52ff8$var$DN + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$W + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=-45.86151336111111 +lon_0=170.2825891111111" + $f68f332138d52ff8$var$Pc + $f68f332138d52ff8$var$AI + $f68f332138d52ff8$var$DN + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$W + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=-46.60000961111111 +lon_0=168.342872 +k=1 +x_0=300002.66 +y_0=699999.58" + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$W + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    26,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$MA + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$W + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Nq + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$W + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$PL + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$W + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    31,
    $f68f332138d52ff8$var$D + " +lat_0=-39 +lon_0=175.5 +k=1 +x_0=274319.5243848086 +y_0=365759.3658464114" + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$W + $f68f332138d52ff8$var$TU + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Za + " +lon_0=171.5 +k=1 +x_0=457199.2073080143 +y_0=457199.2073080143" + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$W + $f68f332138d52ff8$var$TU + $f68f332138d52ff8$var$A,
    99,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Fk + " +lon_0=-4.666666666666667 +k=1" + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$Hn + $f68f332138d52ff8$var$EL + $f68f332138d52ff8$var$Aa + $f68f332138d52ff8$var$SN + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Fk + " +lon_0=-2.333333333333333 +k=1" + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$Hn + $f68f332138d52ff8$var$EL + $f68f332138d52ff8$var$Aa + $f68f332138d52ff8$var$SN + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Fk + $f68f332138d52ff8$var$HN + " +k=1" + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$Hn + $f68f332138d52ff8$var$EL + $f68f332138d52ff8$var$Aa + $f68f332138d52ff8$var$SN + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Fk + " +lon_0=2.5 +k=1" + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$Hn + $f68f332138d52ff8$var$EL + $f68f332138d52ff8$var$Aa + $f68f332138d52ff8$var$SN + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Fk + $f68f332138d52ff8$var$Vr + " +k=1" + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$Hn + $f68f332138d52ff8$var$EL + $f68f332138d52ff8$var$Aa + $f68f332138d52ff8$var$SN + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Fk + " +lon_0=10.16666666666667 +k=1" + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$Hn + $f68f332138d52ff8$var$EL + $f68f332138d52ff8$var$Aa + $f68f332138d52ff8$var$SN + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Fk + " +lon_0=14.16666666666667 +k=1" + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$Hn + $f68f332138d52ff8$var$EL + $f68f332138d52ff8$var$Aa + $f68f332138d52ff8$var$SN + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Fk + " +lon_0=18.33333333333333 +k=1" + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$Hn + $f68f332138d52ff8$var$EL + $f68f332138d52ff8$var$Aa + $f68f332138d52ff8$var$SN + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    31,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$KA + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$JL + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    64,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$BY + $f68f332138d52ff8$var$UZ + " +k=1 +x_0=180.598 +y_0=-86.98999999999999" + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$JL + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    7,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$PD + $f68f332138d52ff8$var$PE + " +lon_0=5.399999999999999 +k_0=0.99950908" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$Hk + " +a=6376523" + $f68f332138d52ff8$var$RA + $f68f332138d52ff8$var$ZM + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    61,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$PD + $f68f332138d52ff8$var$PE + $f68f332138d52ff8$var$HN + " +k_0=0.999877341" + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$IK + $f68f332138d52ff8$var$AU + $f68f332138d52ff8$var$BN + $f68f332138d52ff8$var$Bk + $f68f332138d52ff8$var$Lv + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + " +lat_1=46.8 +lat_0=46.8" + $f68f332138d52ff8$var$HN + " +k_0=0.99987742" + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$IK + $f68f332138d52ff8$var$AU + $f68f332138d52ff8$var$BN + $f68f332138d52ff8$var$Bk + $f68f332138d52ff8$var$Lv + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Xt + $f68f332138d52ff8$var$Xu + $f68f332138d52ff8$var$HN + " +k_0=0.999877499" + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$IK + $f68f332138d52ff8$var$AU + $f68f332138d52ff8$var$BN + $f68f332138d52ff8$var$Bk + $f68f332138d52ff8$var$Lv + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Xv + $f68f332138d52ff8$var$Xw + $f68f332138d52ff8$var$HN + " +k_0=0.99994471 +x_0=234.358 +y_0=185861.369" + $f68f332138d52ff8$var$AU + $f68f332138d52ff8$var$BN + $f68f332138d52ff8$var$Bk + $f68f332138d52ff8$var$Lv + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    7,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$PD + $f68f332138d52ff8$var$PE + $f68f332138d52ff8$var$HN + " +k_0=0.999877341" + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$Tj + $f68f332138d52ff8$var$AU + $f68f332138d52ff8$var$BN + $f68f332138d52ff8$var$Bk + $f68f332138d52ff8$var$Lv + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + " +lat_1=46.8 +lat_0=46.8" + $f68f332138d52ff8$var$HN + " +k_0=0.99987742" + $f68f332138d52ff8$var$a + " +y_0=2200000" + $f68f332138d52ff8$var$AU + $f68f332138d52ff8$var$BN + $f68f332138d52ff8$var$Bk + $f68f332138d52ff8$var$Lv + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Xt + $f68f332138d52ff8$var$Xu + $f68f332138d52ff8$var$HN + " +k_0=0.999877499" + $f68f332138d52ff8$var$a + " +y_0=3200000" + $f68f332138d52ff8$var$AU + $f68f332138d52ff8$var$BN + $f68f332138d52ff8$var$Bk + $f68f332138d52ff8$var$Lv + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Xv + $f68f332138d52ff8$var$Xw + $f68f332138d52ff8$var$HN + " +k_0=0.99994471 +x_0=234.358 +y_0=4185861.369" + $f68f332138d52ff8$var$AU + $f68f332138d52ff8$var$BN + $f68f332138d52ff8$var$Bk + $f68f332138d52ff8$var$Lv + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    126,
    $f68f332138d52ff8$var$D + " +lat_0=49 +lon_0=-2 +k=0.9996012717" + $f68f332138d52ff8$var$u + " +y_0=-100000" + $f68f332138d52ff8$var$PV + $f68f332138d52ff8$var$Lx + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    491,
    $f68f332138d52ff8$var$Ck + $f68f332138d52ff8$var$LH + $f68f332138d52ff8$var$LI + $f68f332138d52ff8$var$Qx + " +y_0=126867.909" + $f68f332138d52ff8$var$Nc + $f68f332138d52ff8$var$Nd + $f68f332138d52ff8$var$DS + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$LH + $f68f332138d52ff8$var$LI + " +k=1" + $f68f332138d52ff8$var$Qx + " +y_0=1126867.909" + $f68f332138d52ff8$var$Nc + $f68f332138d52ff8$var$Nd + $f68f332138d52ff8$var$DS + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$Ck + $f68f332138d52ff8$var$LH + $f68f332138d52ff8$var$LI + $f68f332138d52ff8$var$Qx + " +y_0=1126867.909" + $f68f332138d52ff8$var$Nc + $f68f332138d52ff8$var$Nd + $f68f332138d52ff8$var$DS + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    39,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$JN + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$AU + $f68f332138d52ff8$var$BN + $f68f332138d52ff8$var$TH + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    116,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Mh + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Mi + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$NS + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Mg + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$NT + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ot + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Nv + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$PM + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Re + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$SM + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$MA + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    46,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Gl + " +k=1" + $f68f332138d52ff8$var$DP + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$HO + " +k=1" + $f68f332138d52ff8$var$Eg + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$IG + " +k=1" + $f68f332138d52ff8$var$Jt + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$LN + " +k=1" + $f68f332138d52ff8$var$IM + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$JS + " +k=1" + $f68f332138d52ff8$var$MS + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$PS + " +k=1" + $f68f332138d52ff8$var$MT + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$RL + " +k=1" + $f68f332138d52ff8$var$LY + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$QW + " +k=1" + $f68f332138d52ff8$var$Jp + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$RM + " +k=1" + $f68f332138d52ff8$var$LZ + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$HP + " +k=1" + $f68f332138d52ff8$var$HU + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$HQ + " +k=1" + $f68f332138d52ff8$var$Gw + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Hd + " +k=1" + $f68f332138d52ff8$var$Hu + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$HR + " +k=1" + $f68f332138d52ff8$var$Hv + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$HS + " +k=1" + $f68f332138d52ff8$var$It + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$EN + " +k=1" + $f68f332138d52ff8$var$Hs + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Fy + " +k=1" + $f68f332138d52ff8$var$Ht + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Fm + " +k=1" + $f68f332138d52ff8$var$HV + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Fr + " +k=1" + $f68f332138d52ff8$var$Hw + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Ed + " +k=1" + $f68f332138d52ff8$var$HW + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Fn + " +k=1" + $f68f332138d52ff8$var$Hx + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Pf + " +k=1" + $f68f332138d52ff8$var$La + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Od + " +k=1" + $f68f332138d52ff8$var$Hy + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$NY + " +k=1" + $f68f332138d52ff8$var$Hz + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Pg + " +k=1" + $f68f332138d52ff8$var$IA + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$NZ + " +k=1" + $f68f332138d52ff8$var$IB + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Lf + " +k=1" + $f68f332138d52ff8$var$Gx + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$KG + " +k=1" + $f68f332138d52ff8$var$IT + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$KH + " +k=1" + $f68f332138d52ff8$var$Gc + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Lh + " +k=1" + $f68f332138d52ff8$var$IU + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$M + $f68f332138d52ff8$var$F + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    168,
    $f68f332138d52ff8$var$D + " +lat_0=24.45" + $f68f332138d52ff8$var$Vv + $f68f332138d52ff8$var$Jl + $f68f332138d52ff8$var$h + $f68f332138d52ff8$var$Hk + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$QO + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    391,
    $f68f332138d52ff8$var$GU + $f68f332138d52ff8$var$Xx + $f68f332138d52ff8$var$Yo + " +k=0.9999079" + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$Fv + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$GU + $f68f332138d52ff8$var$Xx + $f68f332138d52ff8$var$Yo + " +k=0.9999079 +x_0=155000 +y_0=463000" + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$Fv + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    109,
    $f68f332138d52ff8$var$UU + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Nb + $f68f332138d52ff8$var$LX + $f68f332138d52ff8$var$Ak + $f68f332138d52ff8$var$x + $f68f332138d52ff8$var$Al + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    67,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$IC + $f68f332138d52ff8$var$x + $f68f332138d52ff8$var$Al + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Hi + $f68f332138d52ff8$var$x + $f68f332138d52ff8$var$Al + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Gz + $f68f332138d52ff8$var$x + $f68f332138d52ff8$var$Al + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$ID + $f68f332138d52ff8$var$x + $f68f332138d52ff8$var$Al + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Io + $f68f332138d52ff8$var$x + $f68f332138d52ff8$var$Al + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    15,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ik + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$x + $f68f332138d52ff8$var$Al + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$IC + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$x + $f68f332138d52ff8$var$Al + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Hi + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$x + $f68f332138d52ff8$var$Al + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Gz + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$x + $f68f332138d52ff8$var$Al + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$ID + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$x + $f68f332138d52ff8$var$Al + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Io + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$x + $f68f332138d52ff8$var$Al + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$MB + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$x + $f68f332138d52ff8$var$Al + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Nx + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$x + $f68f332138d52ff8$var$Al + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Nr + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$x + $f68f332138d52ff8$var$Al + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    25,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Gz + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$Nn + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$ID + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$Nn + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    112,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$KC + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$HB + $f68f332138d52ff8$var$Bt + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    38,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Pi + " +lon_0=11 +k=1" + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$Gk + $f68f332138d52ff8$var$HB + $f68f332138d52ff8$var$Bt + $f68f332138d52ff8$var$GK + $f68f332138d52ff8$var$A,
    2,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Pi + " +lon_0=13 +k=1" + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$Gk + $f68f332138d52ff8$var$HB + $f68f332138d52ff8$var$Bt + $f68f332138d52ff8$var$GK + $f68f332138d52ff8$var$A,
    2,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Pi + $f68f332138d52ff8$var$Gj + " +k=1" + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$Gk + $f68f332138d52ff8$var$HB + $f68f332138d52ff8$var$Bt + $f68f332138d52ff8$var$GK + $f68f332138d52ff8$var$A,
    2,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Pi + $f68f332138d52ff8$var$UE + " +k=1" + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$Gk + $f68f332138d52ff8$var$HB + $f68f332138d52ff8$var$Bt + $f68f332138d52ff8$var$GK + $f68f332138d52ff8$var$A,
    2,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Pi + $f68f332138d52ff8$var$RI + " +k=1" + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$Gk + $f68f332138d52ff8$var$HB + $f68f332138d52ff8$var$Bt + $f68f332138d52ff8$var$GK + $f68f332138d52ff8$var$A,
    2,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Pi + $f68f332138d52ff8$var$Gl + " +k=1" + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$Gk + $f68f332138d52ff8$var$HB + $f68f332138d52ff8$var$Bt + $f68f332138d52ff8$var$GK + $f68f332138d52ff8$var$A,
    2,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Pi + $f68f332138d52ff8$var$SP + " +k=1" + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$Gk + $f68f332138d52ff8$var$HB + $f68f332138d52ff8$var$Bt + $f68f332138d52ff8$var$GK + $f68f332138d52ff8$var$A,
    2,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Pi + $f68f332138d52ff8$var$RJ + " +k=1" + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$Gk + $f68f332138d52ff8$var$HB + $f68f332138d52ff8$var$Bt + $f68f332138d52ff8$var$GK + $f68f332138d52ff8$var$A,
    317,
    $f68f332138d52ff8$var$CU + " +lat_0=-18.9 +lonc=44.10000000000001 +alpha=18.9" + $f68f332138d52ff8$var$EP + $f68f332138d52ff8$var$u + $f68f332138d52ff8$var$CO + " +gamma=18.9" + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$HD + $f68f332138d52ff8$var$Lv + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    36,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$JZ + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$HD + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$JM + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$HD + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    110,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Mi + $f68f332138d52ff8$var$Lo + $f68f332138d52ff8$var$GD + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$NS + $f68f332138d52ff8$var$Lo + $f68f332138d52ff8$var$GD + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    21,
    $f68f332138d52ff8$var$CU + $f68f332138d52ff8$var$Qi + $f68f332138d52ff8$var$Yz + $f68f332138d52ff8$var$PF + $f68f332138d52ff8$var$Ph + " +x_0=590476.8714630401 +y_0=442857.653094361" + $f68f332138d52ff8$var$If + $f68f332138d52ff8$var$Lo + $f68f332138d52ff8$var$GD + " +to_meter=20.11676512155263" + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$CU + $f68f332138d52ff8$var$Qi + $f68f332138d52ff8$var$Yz + $f68f332138d52ff8$var$PF + $f68f332138d52ff8$var$Ph + " +x_0=590476.8727431979 +y_0=442857.6545573985" + $f68f332138d52ff8$var$If + $f68f332138d52ff8$var$Lo + $f68f332138d52ff8$var$GD + " +to_meter=0.3047994715386762" + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$CU + $f68f332138d52ff8$var$Qi + $f68f332138d52ff8$var$Yz + $f68f332138d52ff8$var$PF + $f68f332138d52ff8$var$Ph + " +x_0=590476.87 +y_0=442857.65" + $f68f332138d52ff8$var$If + $f68f332138d52ff8$var$Lo + $f68f332138d52ff8$var$GD + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    28,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$YA + " +lon_0=-8 +k=1" + $f68f332138d52ff8$var$h + $f68f332138d52ff8$var$KJ + $f68f332138d52ff8$var$PV + $f68f332138d52ff8$var$Bb + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$YA + " +lon_0=-8 +k=1.000035" + $f68f332138d52ff8$var$h + $f68f332138d52ff8$var$KJ + $f68f332138d52ff8$var$Ok + $f68f332138d52ff8$var$Bb + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$YA + " +lon_0=-8 +k=1.000035" + $f68f332138d52ff8$var$h + $f68f332138d52ff8$var$KJ + $f68f332138d52ff8$var$Ok + $f68f332138d52ff8$var$Bb + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    258,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$PT + $f68f332138d52ff8$var$Zz + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$g + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$PT + $f68f332138d52ff8$var$NX + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$g + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$GM + $f68f332138d52ff8$var$Ox + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$g + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$PT + $f68f332138d52ff8$var$Tk + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$g + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$GM + $f68f332138d52ff8$var$Oy + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$g + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$GM + $f68f332138d52ff8$var$Rw + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$g + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$GM + $f68f332138d52ff8$var$Oz + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$g + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$GM + $f68f332138d52ff8$var$aA + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$g + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$GM + $f68f332138d52ff8$var$PA + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$g + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Fs + $f68f332138d52ff8$var$PB + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$g + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$IZ + $f68f332138d52ff8$var$ZH + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$g + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$IZ + $f68f332138d52ff8$var$ZI + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$g + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$IZ + $f68f332138d52ff8$var$ZJ + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$g + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$IQ + " +lon_0=142" + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$g + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$IQ + $f68f332138d52ff8$var$Pj + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$g + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$IQ + " +lon_0=124" + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$g + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$IQ + $f68f332138d52ff8$var$NX + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$g + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + " +lat_0=20" + $f68f332138d52ff8$var$Rw + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$g + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$IQ + $f68f332138d52ff8$var$ZR + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$g + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    21,
    $f68f332138d52ff8$var$Ck + $f68f332138d52ff8$var$Vs + $f68f332138d52ff8$var$UX + " +x_0=86501.46392051999" + $f68f332138d52ff8$var$aS + $f68f332138d52ff8$var$Ee + $f68f332138d52ff8$var$Ef + $f68f332138d52ff8$var$JK + $f68f332138d52ff8$var$Vo + $f68f332138d52ff8$var$A,
    139,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$JM + $f68f332138d52ff8$var$Gn + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Me + $f68f332138d52ff8$var$Gn + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    151,
    $f68f332138d52ff8$var$H + " +lat_1=36" + $f68f332138d52ff8$var$GM + $f68f332138d52ff8$var$SC + $f68f332138d52ff8$var$QL + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$Hk + $f68f332138d52ff8$var$AU + $f68f332138d52ff8$var$BN + $f68f332138d52ff8$var$JC + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Sd + $f68f332138d52ff8$var$Se + $f68f332138d52ff8$var$SC + $f68f332138d52ff8$var$Nk + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$Hk + $f68f332138d52ff8$var$AU + $f68f332138d52ff8$var$BN + $f68f332138d52ff8$var$JC + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + " +lat_1=36" + $f68f332138d52ff8$var$GM + $f68f332138d52ff8$var$SC + $f68f332138d52ff8$var$QL + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$Hk + $f68f332138d52ff8$var$AU + $f68f332138d52ff8$var$BN + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Sd + $f68f332138d52ff8$var$Se + $f68f332138d52ff8$var$SC + $f68f332138d52ff8$var$Nk + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$Hk + $f68f332138d52ff8$var$AU + $f68f332138d52ff8$var$BN + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    235,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$KA + $f68f332138d52ff8$var$c + $f68f332138d52ff8$var$Af + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Oq + $f68f332138d52ff8$var$c + $f68f332138d52ff8$var$Af + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$QD + $f68f332138d52ff8$var$c + $f68f332138d52ff8$var$Af + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$JN + $f68f332138d52ff8$var$c + $f68f332138d52ff8$var$Af + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    59,
    $f68f332138d52ff8$var$H + " +lat_1=36" + $f68f332138d52ff8$var$GM + $f68f332138d52ff8$var$SC + $f68f332138d52ff8$var$QL + " +x_0=500135 +y_0=300090" + $f68f332138d52ff8$var$c + $f68f332138d52ff8$var$Af + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Sd + $f68f332138d52ff8$var$Se + $f68f332138d52ff8$var$SC + $f68f332138d52ff8$var$Nk + " +x_0=500135 +y_0=300090" + $f68f332138d52ff8$var$c + $f68f332138d52ff8$var$Af + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    236,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ja + $f68f332138d52ff8$var$AU + $f68f332138d52ff8$var$BN + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    93,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$ID + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$HE + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    33,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Nb + $f68f332138d52ff8$var$AP + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$HE + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    16,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Vn + $f68f332138d52ff8$var$AP + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$HE + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Vn + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$HE + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    80,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$RP + " +k=1" + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$EO + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$Aw + $f68f332138d52ff8$var$Ls + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$QQ + " +k=1" + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$EO + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$Aw + $f68f332138d52ff8$var$Ls + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$ZG + " +k=1" + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$EO + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$Aw + $f68f332138d52ff8$var$Ls + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$PG + " +k=1" + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$EO + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$z + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Ig + " +k=1" + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$EO + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$z + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$PH + " +k=1" + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$EO + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$z + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$PG + " +k=1" + $f68f332138d52ff8$var$Bn + $f68f332138d52ff8$var$EO + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$z + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Ig + " +k=1 +x_0=450000" + $f68f332138d52ff8$var$EO + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$z + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$PH + " +k=1" + $f68f332138d52ff8$var$YL + $f68f332138d52ff8$var$EO + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$z + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    22,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$RP + " +k=1" + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$Aw + $f68f332138d52ff8$var$Ls + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$QQ + " +k=1" + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$Aw + $f68f332138d52ff8$var$Ls + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$ZG + " +k=1" + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$Aw + $f68f332138d52ff8$var$Ls + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$PG + " +k=1" + $f68f332138d52ff8$var$Bn + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$z + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Ig + " +k=1 +x_0=450000" + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$z + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$PH + " +k=1" + $f68f332138d52ff8$var$YL + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$z + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$LM + $f68f332138d52ff8$var$Nh + " +lat_0=47.5" + $f68f332138d52ff8$var$Ig + $f68f332138d52ff8$var$u + $f68f332138d52ff8$var$Is + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$z + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$RP + " +k=1" + $f68f332138d52ff8$var$Bn + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$Aw + $f68f332138d52ff8$var$Ls + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$QQ + " +k=1 +x_0=450000" + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$Aw + $f68f332138d52ff8$var$Ls + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$ZG + " +k=1" + $f68f332138d52ff8$var$YL + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$Aw + $f68f332138d52ff8$var$Ls + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    10,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Ks + $f68f332138d52ff8$var$Kt + $f68f332138d52ff8$var$Hr + " +lon_0=4.356939722222222 +x_0=150000.01256 +y_0=5400088.4378" + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$GP + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    70,
    $f68f332138d52ff8$var$H + " +lat_1=51.16666723333333 +lat_2=49.8333339" + $f68f332138d52ff8$var$Hr + " +lon_0=4.367486666666666 +x_0=150000.013 +y_0=5400088.438" + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$GP + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    96,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$ZO + " +k=1" + $f68f332138d52ff8$var$Ci + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$AC + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$KB + " +k=1" + $f68f332138d52ff8$var$Bo + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$AC + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$IH + " +k=1" + $f68f332138d52ff8$var$DP + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$AC + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Gj + " +k=1" + $f68f332138d52ff8$var$Eg + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$Y + $f68f332138d52ff8$var$AC + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    59,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ja + $f68f332138d52ff8$var$AU + $f68f332138d52ff8$var$BN + $f68f332138d52ff8$var$No + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$KA + $f68f332138d52ff8$var$AU + $f68f332138d52ff8$var$BN + $f68f332138d52ff8$var$No + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    71,
    $f68f332138d52ff8$var$GU + " +lat_0=45.9 +lon_0=25.39246588888889 +k=0.9996667" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$Ae + $f68f332138d52ff8$var$R + $f68f332138d52ff8$var$QP + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    238,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$JZ + $f68f332138d52ff8$var$j + $f68f332138d52ff8$var$MR + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$JM + $f68f332138d52ff8$var$j + $f68f332138d52ff8$var$MR + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    62,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$SQ + " +k=1" + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$Rr + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    64,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ns + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Nt + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Nu + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Nw + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$NP + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$NQ + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ik + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$IC + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Hi + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Gz + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$ID + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Io + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ik + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$IC + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Hi + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Gz + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$ID + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Io + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$MB + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Nx + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Nr + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ik + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$IC + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Hi + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Gz + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$ID + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Io + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ik + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$IC + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Hi + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Gz + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$ID + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Io + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$MB + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Nx + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Nr + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + " +lat_1=48.71666666666667 +lat_2=47.85" + $f68f332138d52ff8$var$Ib + $f68f332138d52ff8$var$IS + $f68f332138d52ff8$var$Z + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + " +lat_1=47.88333333333333 +lat_2=46.45 +lat_0=45.83333333333334" + $f68f332138d52ff8$var$IS + $f68f332138d52ff8$var$Z + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + " +lat_1=46.4 +lat_2=44.86666666666667" + $f68f332138d52ff8$var$IZ + $f68f332138d52ff8$var$IS + $f68f332138d52ff8$var$Z + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    2,
    $f68f332138d52ff8$var$H + " +lat_1=41.85 +lat_2=42.81666666666667 +lat_0=41.33333333333334" + $f68f332138d52ff8$var$CS + $f68f332138d52ff8$var$Z + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + " +lat_1=40.28333333333333" + $f68f332138d52ff8$var$Dk + $f68f332138d52ff8$var$BY + " +lon_0=-99.5" + $f68f332138d52ff8$var$Z + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$CQ + $f68f332138d52ff8$var$DF + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$e + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$CQ + $f68f332138d52ff8$var$DG + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$e + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$CQ + $f68f332138d52ff8$var$DH + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$e + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Fp + $f68f332138d52ff8$var$DI + $f68f332138d52ff8$var$AO + $f68f332138d52ff8$var$e + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$BA + " +lon_0=-74.66666666666667" + $f68f332138d52ff8$var$EQ + $f68f332138d52ff8$var$Z + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Bl + $f68f332138d52ff8$var$Cu + $f68f332138d52ff8$var$Hm + $f68f332138d52ff8$var$e + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Bl + $f68f332138d52ff8$var$Iy + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$e + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Bl + $f68f332138d52ff8$var$Cv + $f68f332138d52ff8$var$Iz + $f68f332138d52ff8$var$e + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Fs + " +lon_0=-74.33333333333333" + $f68f332138d52ff8$var$AO + $f68f332138d52ff8$var$e + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Fs + $f68f332138d52ff8$var$Cw + $f68f332138d52ff8$var$Ad + $f68f332138d52ff8$var$e + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Fs + $f68f332138d52ff8$var$Cx + $f68f332138d52ff8$var$Ad + $f68f332138d52ff8$var$e + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    2,
    $f68f332138d52ff8$var$H + " +lat_1=34.33333333333334 +lat_2=36.16666666666666" + $f68f332138d52ff8$var$LT + $f68f332138d52ff8$var$NW + $f68f332138d52ff8$var$Z + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + " +lat_1=47.43333333333333" + $f68f332138d52ff8$var$Xy + $f68f332138d52ff8$var$Ib + $f68f332138d52ff8$var$EZ + $f68f332138d52ff8$var$Z + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + " +lat_1=46.18333333333333 +lat_2=47.48333333333333" + $f68f332138d52ff8$var$Be + $f68f332138d52ff8$var$EZ + $f68f332138d52ff8$var$Z + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + " +lat_1=40.43333333333333 +lat_2=41.7" + $f68f332138d52ff8$var$BY + $f68f332138d52ff8$var$ET + $f68f332138d52ff8$var$Z + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + " +lat_1=38.73333333333333 +lat_2=40.03333333333333" + $f68f332138d52ff8$var$Ch + $f68f332138d52ff8$var$ET + $f68f332138d52ff8$var$Z + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + " +lat_1=35.56666666666667" + $f68f332138d52ff8$var$Du + $f68f332138d52ff8$var$QU + $f68f332138d52ff8$var$Fl + $f68f332138d52ff8$var$Z + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + " +lat_1=33.93333333333333 +lat_2=35.23333333333333" + $f68f332138d52ff8$var$Do + $f68f332138d52ff8$var$Fl + $f68f332138d52ff8$var$Z + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + " +lat_1=44.33333333333334" + $f68f332138d52ff8$var$Nh + $f68f332138d52ff8$var$AK + $f68f332138d52ff8$var$AJ + $f68f332138d52ff8$var$Z + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + " +lat_1=42.33333333333334 +lat_2=44" + $f68f332138d52ff8$var$p + $f68f332138d52ff8$var$AJ + $f68f332138d52ff8$var$Z + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + " +lat_1=40.88333333333333 +lat_2=41.95" + $f68f332138d52ff8$var$BB + $f68f332138d52ff8$var$Ea + $f68f332138d52ff8$var$Z + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    2,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$EI + $f68f332138d52ff8$var$GE + " +k=0.9999938" + $f68f332138d52ff8$var$e + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + " +lat_1=33.76666666666667 +lat_2=34.96666666666667" + $f68f332138d52ff8$var$PT + $f68f332138d52ff8$var$CR + $f68f332138d52ff8$var$Z + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    2,
    $f68f332138d52ff8$var$H + " +lat_1=32.33333333333334 +lat_2=33.66666666666666" + $f68f332138d52ff8$var$Dr + $f68f332138d52ff8$var$CR + $f68f332138d52ff8$var$Z + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + " +lat_1=44.41666666666666 +lat_2=45.68333333333333" + $f68f332138d52ff8$var$AL + $f68f332138d52ff8$var$CS + $f68f332138d52ff8$var$Z + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + " +lat_1=42.83333333333334 +lat_2=44.4" + $f68f332138d52ff8$var$EJ + $f68f332138d52ff8$var$Ag + $f68f332138d52ff8$var$Z + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    2,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$aL + " +lat_2=36.18333333333333" + $f68f332138d52ff8$var$QV + $f68f332138d52ff8$var$Jr + $f68f332138d52ff8$var$Z + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + " +lat_1=32.13333333333333 +lat_2=33.96666666666667" + $f68f332138d52ff8$var$Ds + " +lon_0=-97.5" + $f68f332138d52ff8$var$Z + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + " +lat_1=30.11666666666667 +lat_2=31.88333333333333" + $f68f332138d52ff8$var$Cb + $f68f332138d52ff8$var$Ag + $f68f332138d52ff8$var$Z + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + " +lat_1=28.38333333333333 +lat_2=30.28333333333333" + $f68f332138d52ff8$var$Dt + $f68f332138d52ff8$var$Ji + $f68f332138d52ff8$var$Z + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + " +lat_1=26.16666666666667 +lat_2=27.83333333333333" + $f68f332138d52ff8$var$Cc + $f68f332138d52ff8$var$CV + $f68f332138d52ff8$var$Z + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + " +lat_1=40.71666666666667 +lat_2=41.78333333333333" + $f68f332138d52ff8$var$Br + $f68f332138d52ff8$var$BI + $f68f332138d52ff8$var$Z + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + " +lat_1=39.01666666666667 +lat_2=40.65" + $f68f332138d52ff8$var$AQ + $f68f332138d52ff8$var$BI + $f68f332138d52ff8$var$Z + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + " +lat_1=37.21666666666667 +lat_2=38.35" + $f68f332138d52ff8$var$f + $f68f332138d52ff8$var$BI + $f68f332138d52ff8$var$Z + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Fp + $f68f332138d52ff8$var$LW + $f68f332138d52ff8$var$JA + $f68f332138d52ff8$var$e + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + " +lat_1=38.03333333333333 +lat_2=39.2" + $f68f332138d52ff8$var$AA + $f68f332138d52ff8$var$GF + $f68f332138d52ff8$var$Z + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Dn + " +lat_2=37.96666666666667" + $f68f332138d52ff8$var$AB + $f68f332138d52ff8$var$GF + $f68f332138d52ff8$var$Z + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + " +lat_1=47.5" + $f68f332138d52ff8$var$Xy + $f68f332138d52ff8$var$Ib + $f68f332138d52ff8$var$Cy + $f68f332138d52ff8$var$Z + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + " +lat_1=45.83333333333334 +lat_2=47.33333333333334" + $f68f332138d52ff8$var$Dv + $f68f332138d52ff8$var$AJ + $f68f332138d52ff8$var$Z + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + " +lat_1=39 +lat_2=40.25" + $f68f332138d52ff8$var$Mr + $f68f332138d52ff8$var$Ga + $f68f332138d52ff8$var$Z + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + " +lat_1=37.48333333333333 +lat_2=38.88333333333333" + $f68f332138d52ff8$var$QX + $f68f332138d52ff8$var$CR + $f68f332138d52ff8$var$Z + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + " +lat_1=45.56666666666667 +lat_2=46.76666666666667" + $f68f332138d52ff8$var$Dw + $f68f332138d52ff8$var$Bu + $f68f332138d52ff8$var$Z + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + " +lat_1=44.25" + $f68f332138d52ff8$var$Hl + $f68f332138d52ff8$var$AL + $f68f332138d52ff8$var$Bu + $f68f332138d52ff8$var$Z + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + " +lat_1=42.73333333333333 +lat_2=44.06666666666667" + $f68f332138d52ff8$var$PR + $f68f332138d52ff8$var$Bu + $f68f332138d52ff8$var$Z + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$LL + $f68f332138d52ff8$var$DJ + $f68f332138d52ff8$var$Am + $f68f332138d52ff8$var$e + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$LL + $f68f332138d52ff8$var$DK + $f68f332138d52ff8$var$Am + $f68f332138d52ff8$var$e + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$LL + $f68f332138d52ff8$var$JB + $f68f332138d52ff8$var$Am + $f68f332138d52ff8$var$e + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$LL + $f68f332138d52ff8$var$DL + $f68f332138d52ff8$var$Am + $f68f332138d52ff8$var$e + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    6,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Ji + $f68f332138d52ff8$var$AP + $f68f332138d52ff8$var$k + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Rs + $f68f332138d52ff8$var$AP + $f68f332138d52ff8$var$k + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Jh + $f68f332138d52ff8$var$AP + $f68f332138d52ff8$var$k + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$CR + $f68f332138d52ff8$var$AP + $f68f332138d52ff8$var$k + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    14,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + " +lon_0=-53" + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$Ab + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Zd + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$Ab + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Tf + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$Ab + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$RQ + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$Ab + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$RR + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$Ab + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Tg + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$Ab + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    12,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$UF + $f68f332138d52ff8$var$Nh + $f68f332138d52ff8$var$IZ + $f68f332138d52ff8$var$HJ + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$CD + $f68f332138d52ff8$var$CE + $f68f332138d52ff8$var$Cc + $f68f332138d52ff8$var$Bi + $f68f332138d52ff8$var$Z + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$X + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$LM + $f68f332138d52ff8$var$RK + $f68f332138d52ff8$var$MV + $f68f332138d52ff8$var$IS + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    4,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$JT + $f68f332138d52ff8$var$Jn + $f68f332138d52ff8$var$FZ + $f68f332138d52ff8$var$CS + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    3,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$CQ + $f68f332138d52ff8$var$DF + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$h + $f68f332138d52ff8$var$Tm + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$CQ + $f68f332138d52ff8$var$DG + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$Hh + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$CQ + $f68f332138d52ff8$var$DH + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$CX + $f68f332138d52ff8$var$LV + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Fp + $f68f332138d52ff8$var$DI + $f68f332138d52ff8$var$AO + $f68f332138d52ff8$var$AI + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$BA + $f68f332138d52ff8$var$Gp + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$Bn + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Bl + $f68f332138d52ff8$var$Cu + $f68f332138d52ff8$var$Hm + $f68f332138d52ff8$var$OC + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Bl + $f68f332138d52ff8$var$Iy + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Bl + $f68f332138d52ff8$var$Cv + $f68f332138d52ff8$var$Iz + $f68f332138d52ff8$var$YD + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$BA + $f68f332138d52ff8$var$Gp + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$Bn + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Fs + $f68f332138d52ff8$var$Cw + $f68f332138d52ff8$var$Ad + $f68f332138d52ff8$var$Bv + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Fs + $f68f332138d52ff8$var$Cx + $f68f332138d52ff8$var$Ad + $f68f332138d52ff8$var$Qo + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Dl + $f68f332138d52ff8$var$Dm + $f68f332138d52ff8$var$BB + $f68f332138d52ff8$var$Oc + $f68f332138d52ff8$var$AI + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Et + $f68f332138d52ff8$var$Eu + $f68f332138d52ff8$var$LT + $f68f332138d52ff8$var$NW + $f68f332138d52ff8$var$Rh + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$BH + $f68f332138d52ff8$var$Ev + $f68f332138d52ff8$var$Ib + $f68f332138d52ff8$var$EZ + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Ew + $f68f332138d52ff8$var$Ex + $f68f332138d52ff8$var$Be + $f68f332138d52ff8$var$EZ + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$OK + $f68f332138d52ff8$var$Fa + $f68f332138d52ff8$var$BY + $f68f332138d52ff8$var$ET + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Fb + $f68f332138d52ff8$var$Fc + $f68f332138d52ff8$var$Ch + $f68f332138d52ff8$var$ET + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Dn + $f68f332138d52ff8$var$Ey + $f68f332138d52ff8$var$QU + $f68f332138d52ff8$var$Fl + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Ez + $f68f332138d52ff8$var$FA + $f68f332138d52ff8$var$Do + $f68f332138d52ff8$var$Fl + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$PP + $f68f332138d52ff8$var$CZ + $f68f332138d52ff8$var$AK + $f68f332138d52ff8$var$AJ + $f68f332138d52ff8$var$Ci + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$PQ + $f68f332138d52ff8$var$Ca + $f68f332138d52ff8$var$p + $f68f332138d52ff8$var$AJ + $f68f332138d52ff8$var$AV + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$MW + $f68f332138d52ff8$var$FB + $f68f332138d52ff8$var$BB + $f68f332138d52ff8$var$Ea + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Dp + $f68f332138d52ff8$var$Dq + $f68f332138d52ff8$var$y + $f68f332138d52ff8$var$Ea + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$EI + $f68f332138d52ff8$var$GE + $f68f332138d52ff8$var$Lb + $f68f332138d52ff8$var$BU + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    3,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$FC + $f68f332138d52ff8$var$OD + $f68f332138d52ff8$var$Dr + $f68f332138d52ff8$var$CR + $f68f332138d52ff8$var$OE + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Fd + $f68f332138d52ff8$var$Fe + $f68f332138d52ff8$var$AL + $f68f332138d52ff8$var$CS + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$OL + $f68f332138d52ff8$var$Ff + $f68f332138d52ff8$var$EJ + $f68f332138d52ff8$var$Ag + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$FD + $f68f332138d52ff8$var$MX + $f68f332138d52ff8$var$BC + $f68f332138d52ff8$var$MQ + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$FE + $f68f332138d52ff8$var$MY + $f68f332138d52ff8$var$QV + $f68f332138d52ff8$var$Jr + $f68f332138d52ff8$var$h + $f68f332138d52ff8$var$AH + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$FF + $f68f332138d52ff8$var$FG + $f68f332138d52ff8$var$Ds + $f68f332138d52ff8$var$CV + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$Cl + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$FH + $f68f332138d52ff8$var$FI + $f68f332138d52ff8$var$Cb + $f68f332138d52ff8$var$Ag + $f68f332138d52ff8$var$EW + $f68f332138d52ff8$var$Fq + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$FJ + $f68f332138d52ff8$var$FK + $f68f332138d52ff8$var$Dt + $f68f332138d52ff8$var$Ji + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$LV + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$CD + $f68f332138d52ff8$var$CE + $f68f332138d52ff8$var$Cc + $f68f332138d52ff8$var$CV + $f68f332138d52ff8$var$AI + $f68f332138d52ff8$var$Ju + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$AY + $f68f332138d52ff8$var$CF + $f68f332138d52ff8$var$Br + $f68f332138d52ff8$var$BI + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$AH + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$JF + $f68f332138d52ff8$var$CG + $f68f332138d52ff8$var$AQ + $f68f332138d52ff8$var$BI + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$Cl + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$JG + $f68f332138d52ff8$var$CH + $f68f332138d52ff8$var$f + $f68f332138d52ff8$var$BI + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$Fq + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$Fp + $f68f332138d52ff8$var$LW + $f68f332138d52ff8$var$JA + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$OF + $f68f332138d52ff8$var$FL + $f68f332138d52ff8$var$AA + $f68f332138d52ff8$var$GF + $f68f332138d52ff8$var$Bo + $f68f332138d52ff8$var$Cl + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Az + $f68f332138d52ff8$var$Du + $f68f332138d52ff8$var$AB + $f68f332138d52ff8$var$GF + $f68f332138d52ff8$var$Bo + $f68f332138d52ff8$var$AH + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$BH + $f68f332138d52ff8$var$OG + $f68f332138d52ff8$var$Ib + $f68f332138d52ff8$var$Cy + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$FM + $f68f332138d52ff8$var$FN + $f68f332138d52ff8$var$Dv + $f68f332138d52ff8$var$AJ + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Mb + $f68f332138d52ff8$var$RN + $f68f332138d52ff8$var$Mr + $f68f332138d52ff8$var$Ga + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Fg + $f68f332138d52ff8$var$Fh + $f68f332138d52ff8$var$QX + $f68f332138d52ff8$var$CR + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$FO + $f68f332138d52ff8$var$FP + $f68f332138d52ff8$var$Dw + $f68f332138d52ff8$var$Bu + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$Jc + $f68f332138d52ff8$var$MZ + $f68f332138d52ff8$var$AL + $f68f332138d52ff8$var$Bu + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$FQ + $f68f332138d52ff8$var$FR + $f68f332138d52ff8$var$PR + $f68f332138d52ff8$var$Bu + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$CA + $f68f332138d52ff8$var$DJ + $f68f332138d52ff8$var$Ad + $f68f332138d52ff8$var$h + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$CA + $f68f332138d52ff8$var$DK + $f68f332138d52ff8$var$Ad + $f68f332138d52ff8$var$u + $f68f332138d52ff8$var$EK + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$CA + $f68f332138d52ff8$var$JB + $f68f332138d52ff8$var$Ad + $f68f332138d52ff8$var$a + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$CA + $f68f332138d52ff8$var$DL + $f68f332138d52ff8$var$Ad + $f68f332138d52ff8$var$CX + $f68f332138d52ff8$var$EK + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    3,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$GW + $f68f332138d52ff8$var$GX + $f68f332138d52ff8$var$GY + $f68f332138d52ff8$var$GA + $f68f332138d52ff8$var$h + $f68f332138d52ff8$var$IK + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    3,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Ji + $f68f332138d52ff8$var$AP + $f68f332138d52ff8$var$k + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Rs + $f68f332138d52ff8$var$AP + $f68f332138d52ff8$var$k + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Jh + $f68f332138d52ff8$var$AP + $f68f332138d52ff8$var$k + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$CR + $f68f332138d52ff8$var$AP + $f68f332138d52ff8$var$k + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    14,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + " +lon_0=-53" + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$Ab + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Zd + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$Ab + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Tf + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$Ab + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$RQ + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$Ab + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$RR + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$Ab + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Tg + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$Ab + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$IL + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$Ab + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Th + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$Ab + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Ti + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$Ab + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Ga + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$Ab + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$ET + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$Ab + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$CR + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$Ab + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$NV + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$Ab + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Jh + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$Ab + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Bu + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$Ab + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Rs + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$Ab + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$OZ + $f68f332138d52ff8$var$V + $f68f332138d52ff8$var$Ab + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$UF + $f68f332138d52ff8$var$Nh + $f68f332138d52ff8$var$IZ + $f68f332138d52ff8$var$HJ + $f68f332138d52ff8$var$s + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$H + $f68f332138d52ff8$var$CD + $f68f332138d52ff8$var$CE + " +lat_0=25.5" + $f68f332138d52ff8$var$Bi + $f68f332138d52ff8$var$BZ + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$C + $f68f332138d52ff8$var$B + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    2,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$SK + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$P + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$TV + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$P + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Xz + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$P + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$TY + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$P + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$RG + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$P + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ro + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$P + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$RH + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$P + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$TW + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$P + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$TX + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$P + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$QE + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$P + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ns + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$P + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Nt + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$P + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Nu + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$P + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Nw + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$P + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$NP + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$P + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$NQ + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$P + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ik + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$P + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$IC + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$P + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Hi + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$P + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Gz + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$P + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$ID + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$P + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Io + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$P + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$MB + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$P + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Nx + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$P + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Nr + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$P + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Os + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$P + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$SL + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$P + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ja + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$P + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$KA + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$P + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Oq + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$P + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$QD + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$P + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$JN + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$P + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$KC + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$P + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$NR + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$P + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ki + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$P + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Mf + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$P + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$KD + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$P + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$JZ + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$P + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$JM + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$P + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Me + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$P + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Rb + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$P + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Rc + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$P + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$SO + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$P + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Td + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$P + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Te + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$P + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$QF + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$P + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ny + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$P + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Mh + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$P + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Mi + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$P + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$NS + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$P + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Mg + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$P + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$NT + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$P + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ot + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$P + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Nv + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$P + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$PM + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$P + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Re + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$P + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$SM + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$P + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$MA + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$P + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Nq + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$P + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$PL + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$P + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    41,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$SK + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$P + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$TV + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$P + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Xz + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$P + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$TY + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$P + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$RG + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$P + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ro + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$P + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$RH + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$P + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$TW + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$P + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$TX + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$P + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$QE + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$P + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ns + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$P + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Nt + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$P + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Nu + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$P + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Nw + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$P + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$NP + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$P + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$NQ + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$P + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ik + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$P + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$IC + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$P + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Hi + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$P + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Gz + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$P + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$ID + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$P + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Io + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$P + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$MB + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$P + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Nx + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$P + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Nr + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$P + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Os + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$P + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$SL + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$P + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ja + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$P + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$KA + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$P + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Oq + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$P + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$QD + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$P + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$JN + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$P + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$KC + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$P + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$NR + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$P + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ki + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$P + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Mf + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$P + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$KD + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$P + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$JZ + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$P + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$JM + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$P + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Me + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$P + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Rb + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$P + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Rc + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$P + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$SO + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$P + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Td + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$P + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Te + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$P + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$QF + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$P + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ny + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$P + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Mh + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$P + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Mi + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$P + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$NS + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$P + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Mg + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$P + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$NT + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$P + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ot + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$P + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Nv + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$P + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$PM + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$P + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Re + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$P + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$SM + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$P + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$MA + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$P + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Nq + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$P + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$PL + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$P + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    41,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$SK + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$Q + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$TV + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$Q + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Xz + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$Q + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$TY + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$Q + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$RG + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$Q + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ro + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$Q + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$RH + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$Q + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$TW + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$Q + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$TX + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$Q + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$QE + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$Q + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ns + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$Q + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Nt + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$Q + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Nu + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$Q + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Nw + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$Q + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$NP + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$Q + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$NQ + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$Q + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ik + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$Q + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$IC + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$Q + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Hi + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$Q + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Gz + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$Q + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$ID + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$Q + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Io + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$Q + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$MB + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$Q + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Nx + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$Q + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Nr + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$Q + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Os + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$Q + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$SL + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$Q + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ja + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$Q + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$KA + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$Q + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Oq + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$Q + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$QD + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$Q + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$JN + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$Q + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$KC + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$Q + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$NR + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$Q + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ki + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$Q + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Mf + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$Q + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$KD + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$Q + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$JZ + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$Q + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$JM + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$Q + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Me + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$Q + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Rb + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$Q + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Rc + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$Q + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$SO + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$Q + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Td + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$Q + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Te + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$Q + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$QF + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$Q + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ny + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$Q + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Mh + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$Q + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Mi + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$Q + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$NS + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$Q + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Mg + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$Q + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$NT + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$Q + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ot + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$Q + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Nv + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$Q + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$PM + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$Q + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Re + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$Q + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$SM + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$Q + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$MA + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$Q + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Nq + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$Q + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$PL + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$Q + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    41,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$SK + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$Q + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$TV + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$Q + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Xz + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$Q + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$TY + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$Q + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$RG + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$Q + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ro + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$Q + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$RH + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$Q + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$TW + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$Q + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$TX + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$Q + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$QE + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$Q + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ns + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$Q + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Nt + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$Q + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Nu + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$Q + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Nw + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$Q + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$NP + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$Q + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$NQ + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$Q + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ik + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$Q + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$IC + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$Q + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Hi + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$Q + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Gz + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$Q + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$ID + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$Q + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Io + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$Q + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$MB + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$Q + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Nx + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$Q + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Nr + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$Q + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Os + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$Q + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$SL + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$Q + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ja + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$Q + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$KA + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$Q + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Oq + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$Q + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$QD + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$Q + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$JN + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$Q + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$KC + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$Q + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$NR + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$Q + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ki + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$Q + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Mf + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$Q + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$KD + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$Q + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$JZ + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$Q + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$JM + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$Q + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Me + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$Q + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Rb + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$Q + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Rc + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$Q + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$SO + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$Q + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Td + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$Q + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Te + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$Q + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$QF + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$Q + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ny + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$Q + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Mh + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$Q + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Mi + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$Q + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$NS + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$Q + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Mg + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$Q + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$NT + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$Q + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ot + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$Q + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Nv + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$Q + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$PM + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$Q + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Re + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$Q + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$SM + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$Q + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$MA + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$Q + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Nq + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$Q + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$PL + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$T + $f68f332138d52ff8$var$Q + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    41,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$SK + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$TV + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Xz + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$TY + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$RG + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ro + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$RH + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$TW + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$TX + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$QE + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ns + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Nt + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Nu + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Nw + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$NP + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$NQ + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ik + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$IC + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Hi + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Gz + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$ID + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Io + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$MB + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Nx + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Nr + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Os + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$SL + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ja + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$KA + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Oq + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$QD + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$JN + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$KC + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$NR + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ki + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Mf + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$KD + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$JZ + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$JM + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Me + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Rb + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Rc + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$SO + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Td + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Te + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$QF + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ny + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Mh + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Mi + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$NS + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Mg + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$NT + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ot + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Nv + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$PM + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Re + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$SM + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$MA + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Nq + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$PL + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$BP + $f68f332138d52ff8$var$Hr + $f68f332138d52ff8$var$Qm + $f68f332138d52ff8$var$HN + $f68f332138d52ff8$var$Rd + $f68f332138d52ff8$var$Bd + $f68f332138d52ff8$var$Cl + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    3,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Ji + $f68f332138d52ff8$var$AP + $f68f332138d52ff8$var$k + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Rs + $f68f332138d52ff8$var$AP + $f68f332138d52ff8$var$k + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$Jh + $f68f332138d52ff8$var$AP + $f68f332138d52ff8$var$k + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$CR + $f68f332138d52ff8$var$AP + $f68f332138d52ff8$var$k + $f68f332138d52ff8$var$N + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$J + $f68f332138d52ff8$var$A,
    34,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$SK + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$TV + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Xz + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$TY + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$RG + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ro + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$RH + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$TW + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$TX + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$QE + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ns + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Nt + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Nu + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Nw + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$NP + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$NQ + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ik + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$IC + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Hi + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Gz + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$ID + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Io + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$MB + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Nx + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Nr + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Os + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$SL + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ja + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$KA + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Oq + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$QD + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$JN + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$KC + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$NR + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ki + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Mf + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$KD + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$JZ + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$JM + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Me + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Rb + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Rc + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$SO + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Td + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Te + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$QF + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ny + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Mh + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Mi + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$NS + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Mg + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$NT + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Ot + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Nv + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$PM + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Re + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$SM + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$MA + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$Nq + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$I + $f68f332138d52ff8$var$PL + $f68f332138d52ff8$var$o + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    1,
    $f68f332138d52ff8$var$BP + $f68f332138d52ff8$var$m + " +lat_ts=-90" + $f68f332138d52ff8$var$HN + $f68f332138d52ff8$var$Rd + $f68f332138d52ff8$var$Bd + $f68f332138d52ff8$var$Cl + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A,
    5,
    $f68f332138d52ff8$var$D + $f68f332138d52ff8$var$L + $f68f332138d52ff8$var$PN + $f68f332138d52ff8$var$AP + $f68f332138d52ff8$var$O + $f68f332138d52ff8$var$Ak + $f68f332138d52ff8$var$S + $f68f332138d52ff8$var$E + $f68f332138d52ff8$var$A
].reduce((acc, it, i)=>{
    if (i % 2 === 0) {
        // v is the addition in EPSG code
        const cur = acc.prev + it;
        const code = "EPSG:" + cur;
        acc.defs.push([
            code
        ]);
        acc.prev = cur;
    } else // v is the proj4 text
    acc.defs[acc.defs.length - 1].push(it);
    return acc;
}, {
    defs: [],
    prev: 0
}).defs;


if (typeof $7e38a554ccd68dd6$require$proj4 === "object" && typeof $7e38a554ccd68dd6$require$proj4.defs !== "function" && typeof $7e38a554ccd68dd6$require$proj4.default === "function") // probably inside an Angular project
$7e38a554ccd68dd6$require$proj4 = $7e38a554ccd68dd6$require$proj4.default;
$7e38a554ccd68dd6$require$proj4.defs($f68f332138d52ff8$exports);
$7e38a554ccd68dd6$exports = $7e38a554ccd68dd6$require$proj4;



function $6b3689d852234853$var$reprojectGeoJSON(data, { from: _from = "EPSG:4326", in_place: in_place = false, to: _to = "EPSG:4326" }) {
    if (typeof _from === "number" || _from.match(/^\d+$/)) _from = "EPSG:" + _from;
    if (typeof _to === "number" || _to.match(/^\d+$/)) _to = "EPSG:" + _to;
    return $08c71cdfa72ababb$exports(data, {
        in_place: in_place,
        reproject: $7e38a554ccd68dd6$exports(_from, _to).forward
    });
}
if (typeof define === "function" && define.amd) define(function() {
    return $6b3689d852234853$var$reprojectGeoJSON;
});
$6b3689d852234853$exports = $6b3689d852234853$var$reprojectGeoJSON;
if (typeof window === "object") window.reprojectGeoJSON = $6b3689d852234853$var$reprojectGeoJSON;
if (typeof self === "object") self.reprojectGeoJSON = $6b3689d852234853$var$reprojectGeoJSON;


function $53ec58915c85ab08$var$calcMask({ debug: debug = false, fname: fname, raster_bbox: raster_bbox, raster_srs: raster_srs, raster_height: raster_height, raster_width: raster_width, pixel_height: pixel_height, pixel_width: pixel_width, mask: mask, mask_srs: mask_srs }) {
    if (raster_srs !== mask_srs) mask = $6b3689d852234853$exports(mask, {
        from: mask_srs,
        to: raster_srs
    });
    return $821004e6d224a19e$exports[fname]({
        debug: debug,
        raster_bbox: raster_bbox,
        raster_height: raster_height,
        raster_width: raster_width,
        pixel_height: pixel_height,
        pixel_width: pixel_width,
        mask: mask
    });
}
function $53ec58915c85ab08$var$inside(options) {
    return $53ec58915c85ab08$var$calcMask({
        ...options,
        fname: "inside"
    });
}
function $53ec58915c85ab08$var$outside(options) {
    return $53ec58915c85ab08$var$calcMask({
        ...options,
        fname: "outside"
    });
}
const $53ec58915c85ab08$var$geomask = {
    inside: $53ec58915c85ab08$var$inside,
    outside: $53ec58915c85ab08$var$outside
};
$53ec58915c85ab08$exports = $53ec58915c85ab08$var$geomask;


var $e244bb5dcfd12c3c$exports = {};
// takes in image data array and sets alpha value to 0 for parts outside the mask geometry
function $e244bb5dcfd12c3c$var$maskImageData({ data: data, data_bbox: data_bbox, data_height: data_height, data_width: data_width, data_srs: data_srs, debug: debug = false, geomask: geomask, mask: mask, mask_srs: mask_srs, reproject: reproject, strategy: strategy = "outside", edition: edition }) {
    if (![
        "inside",
        "outside"
    ].includes(strategy)) throw new Error(`[geocanvas] strategy can be either "inside" or "outside". you provided "${strategy}"`);
    const { rows: rows } = geomask[strategy]({
        raster_bbox: data_bbox,
        raster_height: data_height,
        raster_width: data_width,
        raster_srs: data_srs,
        mask: mask,
        mask_srs: mask_srs,
        reproject: reproject
    });
    rows.forEach((ranges, r)=>{
        if (ranges) {
            const row_offset = r * 4 * data_width;
            ranges.forEach(([start, end])=>{
                for(let c = start; c <= end; c++)data[row_offset + c * 4 + 3] = 0; // set alpha to zero
            });
        }
    });
}
function $e244bb5dcfd12c3c$var$maskCanvas({ canvas: canvas, canvas_bbox: canvas_bbox, canvas_srs: canvas_srs, geomask: geomask, mask: mask, mask_srs: mask_srs, reproject: reproject, strategy: strategy = "outside", edition: edition, debug: debug = false }) {
    if (debug) console.log("[geocanvas] starting to mask canvas");
    if (![
        "inside",
        "outside"
    ].includes(strategy)) throw new Error(`[geocanvas] strategy can be either "inside" or "outside". you provided "${strategy}"`);
    const context = canvas.getContext("2d");
    const { height: height, width: width } = canvas;
    if (debug) console.log(`[geocanvas] canvas height is ${height} pixels`);
    if (debug) console.log(`[geocanvas] canvas width is ${width} pixels`);
    const imageData = context.getImageData(0, 0, width, height);
    $e244bb5dcfd12c3c$var$maskImageData({
        data: imageData.data,
        data_bbox: canvas_bbox,
        data_height: height,
        data_srs: canvas_srs,
        data_width: width,
        debug: debug,
        geomask: geomask,
        mask: mask,
        mask_srs: mask_srs,
        reproject: reproject,
        strategy: strategy
    });
    if (debug) console.log("[geocanvas] image data after masking:", imageData);
    context.putImageData(imageData, 0, 0);
    if (debug) console.log("[geocanvas] put image data back");
    return canvas;
}
$e244bb5dcfd12c3c$exports = {
    maskImageData: $e244bb5dcfd12c3c$var$maskImageData,
    maskCanvas: $e244bb5dcfd12c3c$var$maskCanvas
};


function $e6ff6cf3f009bcd5$var$maskImageData(options) {
    return $e244bb5dcfd12c3c$exports.maskImageData({
        ...options,
        edition: "full",
        geomask: $53ec58915c85ab08$exports
    });
}
function $e6ff6cf3f009bcd5$var$maskCanvas(options) {
    return $e244bb5dcfd12c3c$exports.maskCanvas({
        ...options,
        edition: "full",
        geomask: $53ec58915c85ab08$exports
    });
}
const $e6ff6cf3f009bcd5$var$geocanvas = {
    maskImageData: $e6ff6cf3f009bcd5$var$maskImageData,
    maskCanvas: $e6ff6cf3f009bcd5$var$maskCanvas
};
if (typeof define === "function" && define.amd) define(function() {
    return $e6ff6cf3f009bcd5$var$geocanvas;
});
$e6ff6cf3f009bcd5$exports = $e6ff6cf3f009bcd5$var$geocanvas;
if (typeof self === "object") self.geocanvas = $e6ff6cf3f009bcd5$var$geocanvas;
if (typeof window === "object") window.geocanvas = $e6ff6cf3f009bcd5$var$geocanvas;


/**
 * @description adds an alpha channel to an RGB Pixel, creating a new RGBA pixel
 * @param rgb - a 3-number RGB pixel
 * @returns rgba - a 4-number array representing an RGBA pixel
 */ function $544ad420fbe8433b$export$2e2bcd8739ae039(rgb) {
    return [
        ...rgb,
        255
    ];
}


var $0696259da4f0e285$exports = {};
const $0696259da4f0e285$var$layoutCache = {};
var $f86ea23d1526e88a$exports = {};
function $f86ea23d1526e88a$var$addSymbolIterator(obj) {
    try {
        obj[Symbol.iterator] = function() {
            return this;
        };
    } catch (error) {
    // pass
    }
}
function $f86ea23d1526e88a$var$addSymbolIteratorFallback(obj) {
    obj["@@iterator"] = function() {
        return this;
    };
}
function $f86ea23d1526e88a$var$wrapNextFunction(next) {
    const iter = {
        next: next
    };
    $f86ea23d1526e88a$var$addSymbolIterator(iter);
    $f86ea23d1526e88a$var$addSymbolIteratorFallback(iter);
    return iter;
}
function $f86ea23d1526e88a$var$isArray(data) {
    try {
        return data.constructor.name.endsWith("Array");
    } catch  {
        return false;
    }
}
function $f86ea23d1526e88a$var$hasNext(data) {
    try {
        return typeof data.next === "function";
    } catch  {
        return false;
    }
}
function $f86ea23d1526e88a$var$hasIterator(data) {
    try {
        return "@@iterator" in data;
    } catch  {
        return false;
    }
}
function $f86ea23d1526e88a$var$hasSymbolIterator(data) {
    try {
        return Symbol.iterator in data.constructor.prototype;
    } catch  {
        return false;
    }
}
function $f86ea23d1526e88a$var$isIterator(data) {
    try {
        return Symbol.iterator in data && typeof data.next === "function" && data.propertyIsEnumerable("next") === false;
    } catch  {
        return false;
    }
}
function $f86ea23d1526e88a$var$getIterator(data) {
    const iter = data["@@iterator"];
    if ($f86ea23d1526e88a$var$hasNext(iter)) return iter;
    else if (typeof iter === "function") return iter();
}
function $f86ea23d1526e88a$var$createIterator(data) {
    let i = 0;
    let len = data.length;
    const next = ()=>i++ < len ? {
            value: data[i],
            done: false
        } : {
            done: true
        };
    return $f86ea23d1526e88a$var$wrapNextFunction(next);
}
function $f86ea23d1526e88a$var$getOrCreateIterator(data) {
    if ($f86ea23d1526e88a$var$isIterator(data)) return data;
    else if ($f86ea23d1526e88a$var$hasSymbolIterator(data)) return data[Symbol.iterator]();
    else if ($f86ea23d1526e88a$var$hasNext(data)) return $f86ea23d1526e88a$var$wrapNextFunction(data.next);
    else if ($f86ea23d1526e88a$var$hasIterator(data)) return $f86ea23d1526e88a$var$getIterator(data);
    else if (typeof data === "string" || $f86ea23d1526e88a$var$isArray(data)) return $f86ea23d1526e88a$var$createIterator(data);
    else throw "[iter-fun] unable to determine iterator";
}
function $f86ea23d1526e88a$var$zip(iters) {
    // convert input to iters just in case
    iters = iters.map($f86ea23d1526e88a$var$getOrCreateIterator);
    return $f86ea23d1526e88a$var$wrapNextFunction(function next() {
        const values = iters.map((iter)=>iter.next());
        // if they are all done, stop
        if (values.every(({ done: done })=>done)) return {
            done: true
        };
        else return {
            done: false,
            value: values.map(({ value: value })=>value)
        };
    });
}
$f86ea23d1526e88a$exports = {
    addSymbolIterator: $f86ea23d1526e88a$var$addSymbolIterator,
    addSymbolIteratorFallback: $f86ea23d1526e88a$var$addSymbolIteratorFallback,
    isIterator: $f86ea23d1526e88a$var$isIterator,
    isArray: $f86ea23d1526e88a$var$isArray,
    hasNext: $f86ea23d1526e88a$var$hasNext,
    hasSymbolIterator: $f86ea23d1526e88a$var$hasSymbolIterator,
    hasIterator: $f86ea23d1526e88a$var$hasIterator,
    getIterator: $f86ea23d1526e88a$var$getIterator,
    createIterator: $f86ea23d1526e88a$var$createIterator,
    getOrCreateIterator: $f86ea23d1526e88a$var$getOrCreateIterator,
    wrapNextFunction: $f86ea23d1526e88a$var$wrapNextFunction,
    zip: $f86ea23d1526e88a$var$zip
};


var $0696259da4f0e285$require$wrapNextFunction = $f86ea23d1526e88a$exports.wrapNextFunction;
var $e9967fa81119b145$exports = {};
$e9967fa81119b145$exports = {
    "1": function({ point: point }) {
        const parent = this.data;
        const index = point[this.d0v0];
        return {
            parent: parent,
            index: index,
            value: parent[index]
        };
    },
    "2": function({ point: point }) {
        const parent = this.data;
        const index = this.m0v0 * point[this.d0v0] + this.m0v1 * point[this.d0v1];
        return {
            parent: parent,
            index: index,
            value: parent[index]
        };
    },
    "3": function({ point: point }) {
        const parent = this.data;
        const index = this.m0v0 * point[this.d0v0] + this.m0v1 * point[this.d0v1] + this.m0v2 * point[this.d0v2];
        return {
            parent: parent,
            index: index,
            value: parent[index]
        };
    },
    "4": function({ point: point }) {
        const parent = this.data;
        const index = this.m0v0 * point[this.d0v0] + this.m0v1 * point[this.d0v1] + this.m0v2 * point[this.d0v2] + this.m0v3 * point[this.d0v3];
        return {
            parent: parent,
            index: index,
            value: parent[index]
        };
    },
    "5": function({ point: point }) {
        const parent = this.data;
        const index = this.m0v0 * point[this.d0v0] + this.m0v1 * point[this.d0v1] + this.m0v2 * point[this.d0v2] + this.m0v3 * point[this.d0v3] + this.m0v4 * point[this.d0v4];
        return {
            parent: parent,
            index: index,
            value: parent[index]
        };
    },
    "1,1": function({ point: point }) {
        const parent = this.data[point[this.d0v0]];
        const index = point[this.d1v0];
        return {
            parent: parent,
            index: index,
            value: parent[index]
        };
    },
    "1,2": function({ point: point }) {
        const parent = this.data[point[this.d0v0]];
        const index = this.m1v0 * point[this.d1v0] + this.m1v1 * point[this.d1v1];
        return {
            parent: parent,
            index: index,
            value: parent[index]
        };
    },
    "1,3": function({ point: point }) {
        const parent = this.data[point[this.d0v0]];
        const index = this.m1v0 * point[this.d1v0] + this.m1v1 * point[this.d1v1] + this.m1v2 * point[this.d1v2];
        return {
            parent: parent,
            index: index,
            value: parent[index]
        };
    },
    "1,4": function({ point: point }) {
        const parent = this.data[point[this.d0v0]];
        const index = this.m1v0 * point[this.d1v0] + this.m1v1 * point[this.d1v1] + this.m1v2 * point[this.d1v2] + this.m1v3 * point[this.d1v3];
        return {
            parent: parent,
            index: index,
            value: parent[index]
        };
    },
    "1,5": function({ point: point }) {
        const parent = this.data[point[this.d0v0]];
        const index = this.m1v0 * point[this.d1v0] + this.m1v1 * point[this.d1v1] + this.m1v2 * point[this.d1v2] + this.m1v3 * point[this.d1v3] + this.m1v4 * point[this.d1v4];
        return {
            parent: parent,
            index: index,
            value: parent[index]
        };
    },
    "1,1,1": function({ point: point }) {
        const parent = this.data[point[this.d0v0]][point[this.d1v0]];
        const index = point[this.d2v0];
        return {
            parent: parent,
            index: index,
            value: parent[index]
        };
    },
    "1,1,2": function({ point: point }) {
        const parent = this.data[point[this.d0v0]][point[this.d1v0]];
        const index = this.m2v0 * point[this.d2v0] + this.m2v1 * point[this.d2v1];
        return {
            parent: parent,
            index: index,
            value: parent[index]
        };
    },
    "1,1,3": function({ point: point }) {
        const parent = this.data[point[this.d0v0]][point[this.d1v0]];
        const index = this.m2v0 * point[this.d2v0] + this.m2v1 * point[this.d2v1] + this.m2v2 * point[this.d2v2];
        return {
            parent: parent,
            index: index,
            value: parent[index]
        };
    },
    "1,1,4": function({ point: point }) {
        const parent = this.data[point[this.d0v0]][point[this.d1v0]];
        const index = this.m2v0 * point[this.d2v0] + this.m2v1 * point[this.d2v1] + this.m2v2 * point[this.d2v2] + this.m2v3 * point[this.d2v3];
        return {
            parent: parent,
            index: index,
            value: parent[index]
        };
    },
    "1,1,5": function({ point: point }) {
        const parent = this.data[point[this.d0v0]][point[this.d1v0]];
        const index = this.m2v0 * point[this.d2v0] + this.m2v1 * point[this.d2v1] + this.m2v2 * point[this.d2v2] + this.m2v3 * point[this.d2v3] + this.m2v4 * point[this.d2v4];
        return {
            parent: parent,
            index: index,
            value: parent[index]
        };
    },
    "1,1,1,1": function({ point: point }) {
        const parent = this.data[point[this.d0v0]][point[this.d1v0]][point[this.d2v0]];
        const index = point[this.d3v0];
        return {
            parent: parent,
            index: index,
            value: parent[index]
        };
    },
    "1,1,1,2": function({ point: point }) {
        const parent = this.data[point[this.d0v0]][point[this.d1v0]][point[this.d2v0]];
        const index = this.m3v0 * point[this.d3v0] + this.m3v1 * point[this.d3v1];
        return {
            parent: parent,
            index: index,
            value: parent[index]
        };
    },
    "1,1,1,3": function({ point: point }) {
        const parent = this.data[point[this.d0v0]][point[this.d1v0]][point[this.d2v0]];
        const index = this.m3v0 * point[this.d3v0] + this.m3v1 * point[this.d3v1] + this.m3v2 * point[this.d3v2];
        return {
            parent: parent,
            index: index,
            value: parent[index]
        };
    },
    "1,1,1,4": function({ point: point }) {
        const parent = this.data[point[this.d0v0]][point[this.d1v0]][point[this.d2v0]];
        const index = this.m3v0 * point[this.d3v0] + this.m3v1 * point[this.d3v1] + this.m3v2 * point[this.d3v2] + this.m3v3 * point[this.d3v3];
        return {
            parent: parent,
            index: index,
            value: parent[index]
        };
    },
    "1,1,1,5": function({ point: point }) {
        const parent = this.data[point[this.d0v0]][point[this.d1v0]][point[this.d2v0]];
        const index = this.m3v0 * point[this.d3v0] + this.m3v1 * point[this.d3v1] + this.m3v2 * point[this.d3v2] + this.m3v3 * point[this.d3v3] + this.m3v4 * point[this.d3v4];
        return {
            parent: parent,
            index: index,
            value: parent[index]
        };
    },
    "1,1,1,1,1": function({ point: point }) {
        const parent = this.data[point[this.d0v0]][point[this.d1v0]][point[this.d2v0]][point[this.d3v0]];
        const index = point[this.d4v0];
        return {
            parent: parent,
            index: index,
            value: parent[index]
        };
    },
    "1,1,1,1,2": function({ point: point }) {
        const parent = this.data[point[this.d0v0]][point[this.d1v0]][point[this.d2v0]][point[this.d3v0]];
        const index = this.m4v0 * point[this.d4v0] + this.m4v1 * point[this.d4v1];
        return {
            parent: parent,
            index: index,
            value: parent[index]
        };
    },
    "1,1,1,1,3": function({ point: point }) {
        const parent = this.data[point[this.d0v0]][point[this.d1v0]][point[this.d2v0]][point[this.d3v0]];
        const index = this.m4v0 * point[this.d4v0] + this.m4v1 * point[this.d4v1] + this.m4v2 * point[this.d4v2];
        return {
            parent: parent,
            index: index,
            value: parent[index]
        };
    },
    "1,1,1,1,4": function({ point: point }) {
        const parent = this.data[point[this.d0v0]][point[this.d1v0]][point[this.d2v0]][point[this.d3v0]];
        const index = this.m4v0 * point[this.d4v0] + this.m4v1 * point[this.d4v1] + this.m4v2 * point[this.d4v2] + this.m4v3 * point[this.d4v3];
        return {
            parent: parent,
            index: index,
            value: parent[index]
        };
    },
    "1,1,1,1,5": function({ point: point }) {
        const parent = this.data[point[this.d0v0]][point[this.d1v0]][point[this.d2v0]][point[this.d3v0]];
        const index = this.m4v0 * point[this.d4v0] + this.m4v1 * point[this.d4v1] + this.m4v2 * point[this.d4v2] + this.m4v3 * point[this.d4v3] + this.m4v4 * point[this.d4v4];
        return {
            parent: parent,
            index: index,
            value: parent[index]
        };
    }
};


var $8b9ef2bb0a97b90d$exports = {};
$8b9ef2bb0a97b90d$exports = {
    "1": function({ point: point, value: value }) {
        this.data[point[this.d0v0]] = value;
    },
    "2": function({ point: point, value: value }) {
        this.data[this.m0v0 * point[this.d0v0] + this.m0v1 * point[this.d0v1]] = value;
    },
    "3": function({ point: point, value: value }) {
        this.data[this.m0v0 * point[this.d0v0] + this.m0v1 * point[this.d0v1] + this.m0v2 * point[this.d0v2]] = value;
    },
    "4": function({ point: point, value: value }) {
        this.data[this.m0v0 * point[this.d0v0] + this.m0v1 * point[this.d0v1] + this.m0v2 * point[this.d0v2] + this.m0v3 * point[this.d0v3]] = value;
    },
    "5": function({ point: point, value: value }) {
        this.data[this.m0v0 * point[this.d0v0] + this.m0v1 * point[this.d0v1] + this.m0v2 * point[this.d0v2] + this.m0v3 * point[this.d0v3] + this.m0v4 * point[this.d0v4]] = value;
    },
    "1,1": function({ point: point, value: value }) {
        this.data[point[this.d0v0]][point[this.d1v0]] = value;
    },
    "1,2": function({ point: point, value: value }) {
        this.data[point[this.d0v0]][this.m1v0 * point[this.d1v0] + this.m1v1 * point[this.d1v1]] = value;
    },
    "1,3": function({ point: point, value: value }) {
        this.data[point[this.d0v0]][this.m1v0 * point[this.d1v0] + this.m1v1 * point[this.d1v1] + this.m1v2 * point[this.d1v2]] = value;
    },
    "1,4": function({ point: point, value: value }) {
        this.data[point[this.d0v0]][this.m1v0 * point[this.d1v0] + this.m1v1 * point[this.d1v1] + this.m1v2 * point[this.d1v2] + this.m1v3 * point[this.d1v3]] = value;
    },
    "1,5": function({ point: point, value: value }) {
        this.data[point[this.d0v0]][this.m1v0 * point[this.d1v0] + this.m1v1 * point[this.d1v1] + this.m1v2 * point[this.d1v2] + this.m1v3 * point[this.d1v3] + this.m1v4 * point[this.d1v4]] = value;
    },
    "1,1,1": function({ point: point, value: value }) {
        this.data[point[this.d0v0]][point[this.d1v0]][point[this.d2v0]] = value;
    },
    "1,1,2": function({ point: point, value: value }) {
        this.data[point[this.d0v0]][point[this.d1v0]][this.m2v0 * point[this.d2v0] + this.m2v1 * point[this.d2v1]] = value;
    },
    "1,1,3": function({ point: point, value: value }) {
        this.data[point[this.d0v0]][point[this.d1v0]][this.m2v0 * point[this.d2v0] + this.m2v1 * point[this.d2v1] + this.m2v2 * point[this.d2v2]] = value;
    },
    "1,1,4": function({ point: point, value: value }) {
        this.data[point[this.d0v0]][point[this.d1v0]][this.m2v0 * point[this.d2v0] + this.m2v1 * point[this.d2v1] + this.m2v2 * point[this.d2v2] + this.m2v3 * point[this.d2v3]] = value;
    },
    "1,1,5": function({ point: point, value: value }) {
        this.data[point[this.d0v0]][point[this.d1v0]][this.m2v0 * point[this.d2v0] + this.m2v1 * point[this.d2v1] + this.m2v2 * point[this.d2v2] + this.m2v3 * point[this.d2v3] + this.m2v4 * point[this.d2v4]] = value;
    },
    "1,1,1,1": function({ point: point, value: value }) {
        this.data[point[this.d0v0]][point[this.d1v0]][point[this.d2v0]][point[this.d3v0]] = value;
    },
    "1,1,1,2": function({ point: point, value: value }) {
        this.data[point[this.d0v0]][point[this.d1v0]][point[this.d2v0]][this.m3v0 * point[this.d3v0] + this.m3v1 * point[this.d3v1]] = value;
    },
    "1,1,1,3": function({ point: point, value: value }) {
        this.data[point[this.d0v0]][point[this.d1v0]][point[this.d2v0]][this.m3v0 * point[this.d3v0] + this.m3v1 * point[this.d3v1] + this.m3v2 * point[this.d3v2]] = value;
    },
    "1,1,1,4": function({ point: point, value: value }) {
        this.data[point[this.d0v0]][point[this.d1v0]][point[this.d2v0]][this.m3v0 * point[this.d3v0] + this.m3v1 * point[this.d3v1] + this.m3v2 * point[this.d3v2] + this.m3v3 * point[this.d3v3]] = value;
    },
    "1,1,1,5": function({ point: point, value: value }) {
        this.data[point[this.d0v0]][point[this.d1v0]][point[this.d2v0]][this.m3v0 * point[this.d3v0] + this.m3v1 * point[this.d3v1] + this.m3v2 * point[this.d3v2] + this.m3v3 * point[this.d3v3] + this.m3v4 * point[this.d3v4]] = value;
    },
    "1,1,1,1,1": function({ point: point, value: value }) {
        this.data[point[this.d0v0]][point[this.d1v0]][point[this.d2v0]][point[this.d3v0]][point[this.d4v0]] = value;
    },
    "1,1,1,1,2": function({ point: point, value: value }) {
        this.data[point[this.d0v0]][point[this.d1v0]][point[this.d2v0]][point[this.d3v0]][this.m4v0 * point[this.d4v0] + this.m4v1 * point[this.d4v1]] = value;
    },
    "1,1,1,1,3": function({ point: point, value: value }) {
        this.data[point[this.d0v0]][point[this.d1v0]][point[this.d2v0]][point[this.d3v0]][this.m4v0 * point[this.d4v0] + this.m4v1 * point[this.d4v1] + this.m4v2 * point[this.d4v2]] = value;
    },
    "1,1,1,1,4": function({ point: point, value: value }) {
        this.data[point[this.d0v0]][point[this.d1v0]][point[this.d2v0]][point[this.d3v0]][this.m4v0 * point[this.d4v0] + this.m4v1 * point[this.d4v1] + this.m4v2 * point[this.d4v2] + this.m4v3 * point[this.d4v3]] = value;
    },
    "1,1,1,1,5": function({ point: point, value: value }) {
        this.data[point[this.d0v0]][point[this.d1v0]][point[this.d2v0]][point[this.d3v0]][this.m4v0 * point[this.d4v0] + this.m4v1 * point[this.d4v1] + this.m4v2 * point[this.d4v2] + this.m4v3 * point[this.d4v3] + this.m4v4 * point[this.d4v4]] = value;
    }
};


const $0696259da4f0e285$var$ARRAY_TYPES = {
    Array: Array,
    Int8Array: Int8Array,
    Uint8Array: Uint8Array,
    Uint8ClampedArray: Uint8ClampedArray,
    Int16Array: Int16Array,
    Uint16Array: Uint16Array,
    Float32Array: Float32Array,
    Float64Array: Float64Array
};
try {
    $0696259da4f0e285$var$ARRAY_TYPES.BigInt64Array = BigInt64Array;
    $0696259da4f0e285$var$ARRAY_TYPES.BigUint64Array = BigUint64Array;
} catch (error) {
// pass
}
function $0696259da4f0e285$var$parseDimensions(str) {
    const dims = {};
    const re = /[A-Za-z]+/g;
    let arr;
    while((arr = re.exec(str)) !== null){
        const [match] = arr;
        dims[match] = {
            name: match
        };
    }
    return dims;
}
function $0696259da4f0e285$var$normalizeLayoutString(str) {
    const alphabet = "abcdefghijklmnopqrstuvwxyz";
    let i = 0;
    return str.replace(/[A-Za-z]+/g, ()=>alphabet[i++]);
}
const $0696259da4f0e285$var$parseVectors = (str)=>str.match(/\[[^\]]+\]/g);
// "[row]" to "row"
const $0696259da4f0e285$var$removeBraces = (str)=>str.startsWith("[") && str.endsWith("]") ? str.substring(1, str.length - 1) : str;
// "(row)" to "row"
const $0696259da4f0e285$var$removeParentheses = (str)=>str.startsWith("(") && str.endsWith(")") ? str.substring(1, str.length - 1) : str;
// sort of like parsing a CSV except instead of " for quotes use (
const $0696259da4f0e285$var$matchSequences = (str)=>str.match(/(\(.*?\)|[^\(,\s]+)(?=\s*,|\s*$)/g);
const $0696259da4f0e285$var$parseSequences = (str)=>{
    // unwrap [...]
    str = $0696259da4f0e285$var$removeBraces(str);
    // unwrap (...)
    str = $0696259da4f0e285$var$removeParentheses(str);
    const seqs = $0696259da4f0e285$var$matchSequences(str);
    if (seqs.length === 1) return {
        type: "Vector",
        dim: seqs[0]
    };
    else return {
        type: "Matrix",
        parts: seqs.map($0696259da4f0e285$var$parseSequences)
    };
};
function $0696259da4f0e285$var$checkValidity(str) {
    const invalid = str.match(/[^ A-Za-z,\[\]]/g);
    if (invalid) throw new Error("The following invalid characters were used: " + invalid.map((c)=>`"${c}"`).join(", "));
    else return true;
}
function $0696259da4f0e285$var$parse(str, { useLayoutCache: useLayoutCache = true } = {
    useLayoutCache: true
}) {
    if (useLayoutCache && str in $0696259da4f0e285$var$layoutCache) return $0696259da4f0e285$var$layoutCache[str];
    $0696259da4f0e285$var$checkValidity(str);
    const vectors = $0696259da4f0e285$var$parseVectors(str);
    const dims = vectors.map($0696259da4f0e285$var$parseSequences);
    const result = {
        type: "Layout",
        summary: dims.map((it)=>it.type === "Matrix" ? it.parts.length : 1),
        dims: dims
    };
    if (useLayoutCache) $0696259da4f0e285$var$layoutCache[str] = result;
    return result;
}
function $0696259da4f0e285$var$update({ useLayoutCache: useLayoutCache = true, data: data, layout: layout, point: point1, sizes: sizes = {}, value: value }) {
    if (typeof layout === "string") layout = $0696259da4f0e285$var$parse(layout, {
        useLayoutCache: useLayoutCache
    });
    const { dims: dims } = layout;
    for(let idim = 0; idim < dims.length; idim++){
        const last = idim === dims.length - 1;
        const arr = dims[idim];
        let offset;
        if (arr.type === "Vector") offset = point1[arr.dim];
        else {
            // arr.type assumed to be "Matrix"
            const { parts: parts } = arr;
            offset = 0;
            let multiplier = 1;
            for(let i = parts.length - 1; i >= 0; i--){
                const part = parts[i];
                const { dim: dim } = part;
                offset += multiplier * point1[dim];
                if (i > 0) {
                    if (!(dim in sizes)) throw new Error(`you cannot calculate the location without knowing the size of the "${dim}" dimension.`);
                    multiplier *= sizes[dim];
                }
            }
        }
        if (last) data[offset] = value;
        else data = data[offset];
    }
}
function $0696259da4f0e285$var$prepareUpdate({ useLayoutCache: useLayoutCache = true, data: data, layout: layout, sizes: sizes = {} }) {
    if (typeof layout === "string") layout = $0696259da4f0e285$var$parse(layout, {
        useLayoutCache: useLayoutCache
    });
    const { dims: dims } = layout;
    const numDims = dims.length;
    const multipliers = $0696259da4f0e285$var$getMultipliers({
        useLayoutCache: useLayoutCache,
        layout: layout,
        sizes: sizes
    });
    const end = numDims - 1;
    const key = layout.summary.toString();
    if (key in $8b9ef2bb0a97b90d$exports) {
        const _this = {
            data: data
        };
        layout.dims.map((it, depth)=>{
            if (it.type === "Vector") _this[`d${depth}v0`] = it.dim;
            else if (it.type === "Matrix") it.parts.forEach((part, ipart)=>{
                _this[`d${depth}v${ipart}`] = part.dim;
                _this[`m${depth}v${ipart}`] = multipliers[part.dim];
            });
        });
        return $8b9ef2bb0a97b90d$exports[key].bind(_this);
    }
    return ({ point: point1, value: value })=>{
        let currentData = data;
        for(let idim = 0; idim < numDims; idim++){
            const last = idim === end;
            const arr = dims[idim];
            let offset;
            if (arr.type === "Vector") offset = point1[arr.dim];
            else // arr.type assumed to be "Matrix"
            offset = arr.parts.reduce((acc, { dim: dim })=>acc + multipliers[dim] * point1[dim], 0);
            if (last) currentData[offset] = value;
            else currentData = currentData[offset];
        }
    };
}
function $0696259da4f0e285$var$iterClip({ data: data, layout: layout, order: order, rect: rect = {}, sizes: sizes = {}, useLayoutCache: useLayoutCache = true }) {
    if (!data) throw new Error("[xdim] must specify data");
    if (!layout) throw new Error("[xdim] must specify layout");
    const points = $0696259da4f0e285$var$iterPoints({
        order: order,
        sizes: sizes,
        rect: rect
    });
    return $0696259da4f0e285$require$wrapNextFunction(function next() {
        const { value: point1, done: done } = points.next();
        if (done) return {
            done: true
        };
        else {
            const { value: value } = $0696259da4f0e285$var$select({
                data: data,
                layout: layout,
                point: point1,
                sizes: sizes,
                useLayoutCache: useLayoutCache
            });
            return {
                done: false,
                value: value
            };
        }
    });
}
function $0696259da4f0e285$var$validateRect({ rect: rect = {} }) {
    if (rect) for(let key in rect){
        const value = rect[key];
        if (value.length !== 2) throw new Error(`[xdim] uh oh. invalid hyper-rectangle`);
        const [start, end] = value;
        if (start > end) throw new Error(`[xdim] uh oh. invalid range for "${key}".  Start of ${start} can't be greater than end of ${end}.`);
        if (start < 0) throw new Error(`[xdim] uh oh. invalid hyper-rectangle with start ${start}`);
    }
}
function $0696259da4f0e285$var$clip({ useLayoutCache: useLayoutCache = true, data: data, layout: layout, rect: rect, sizes: sizes = {}, flat: flat = false, validate: validate = true }) {
    if (validate) $0696259da4f0e285$var$validateRect({
        rect: rect
    });
    if (typeof layout === "string") layout = $0696259da4f0e285$var$parse(layout, {
        useLayoutCache: useLayoutCache
    });
    let datas = [
        data
    ];
    layout.dims.forEach((arr)=>{
        let new_datas = [];
        datas.forEach((data)=>{
            if (arr.type === "Vector") {
                const [start, end] = rect[arr.dim];
                new_datas = new_datas.concat(data.slice(start, end + 1));
            } else {
                // only 2 types so must be arr.type === "Matrix"
                const { parts: parts } = arr;
                let offsets = [
                    0
                ];
                let multiplier = 1;
                for(let i = parts.length - 1; i >= 0; i--){
                    const part = parts[i];
                    // assume part.type === "Vector"
                    const { dim: dim } = part;
                    const [start, end] = rect[dim];
                    const new_offsets = [];
                    for(let n = start; n <= end; n++)offsets.forEach((offset)=>{
                        new_offsets.push(offset + multiplier * n);
                    });
                    offsets = new_offsets;
                    multiplier *= sizes[dim];
                }
                offsets.forEach((offset)=>{
                    new_datas.push(data[offset]);
                });
            }
        });
        datas = new_datas;
    });
    if (flat) return {
        data: datas
    };
    // prepareResult
    const out_sizes = Object.fromEntries(Object.entries(rect).map(([dim, [start, end]])=>[
            dim,
            end - start + 1
        ]));
    const { data: out_data } = $0696259da4f0e285$var$prepareData({
        layout: layout,
        sizes: out_sizes
    });
    const max_depth = layout.dims.length;
    const step = (arr, depth)=>{
        if (depth === max_depth) for(let i = 0; i < arr.length; i++)arr[i] = datas.shift();
        else arr.forEach((sub)=>step(sub, depth + 1));
    };
    step(out_data, 1);
    return {
        data: out_data
    };
}
function $0696259da4f0e285$var$getMultipliers({ useLayoutCache: useLayoutCache = true, layout: layout, sizes: sizes }) {
    if (typeof layout === "string") layout = $0696259da4f0e285$var$parse(layout, {
        useLayoutCache: useLayoutCache
    });
    const { dims: dims } = layout;
    const numDims = dims.length;
    let multipliers = {};
    for(let idim = 0; idim < numDims; idim++){
        const arr = dims[idim];
        if (arr.type === "Vector") multipliers[arr.dim] = 1;
        else {
            // arr.type assumed to be "Matrix"
            const { parts: parts } = arr;
            let multiplier = 1;
            for(let i = parts.length - 1; i >= 0; i--){
                const { dim: dim } = parts[i];
                multipliers[dim] = multiplier;
                multiplier *= sizes[parts[i].dim];
            }
        }
    }
    return multipliers;
}
function $0696259da4f0e285$var$prepareSelect({ useLayoutCache: useLayoutCache = true, data: data, layout: layout, sizes: sizes = {} }) {
    if (typeof layout === "string") layout = $0696259da4f0e285$var$parse(layout, {
        useLayoutCache: useLayoutCache
    });
    const { dims: dims } = layout;
    const numDims = dims.length;
    const multipliers = $0696259da4f0e285$var$getMultipliers({
        useLayoutCache: useLayoutCache,
        layout: layout,
        sizes: sizes
    });
    const end = numDims - 1;
    const key = layout.summary.toString();
    if (key in $e9967fa81119b145$exports) {
        const _this = {
            data: data
        };
        layout.dims.map((it, depth)=>{
            if (it.type === "Vector") _this[`d${depth}v0`] = it.dim;
            else if (it.type === "Matrix") it.parts.forEach((part, ipart)=>{
                _this[`d${depth}v${ipart}`] = part.dim;
                _this[`m${depth}v${ipart}`] = multipliers[part.dim];
            });
        });
        return $e9967fa81119b145$exports[key].bind(_this);
    }
    return ({ point: point1 })=>{
        let currentData = data;
        for(let idim = 0; idim < numDims; idim++){
            const last = idim === end;
            const arr = dims[idim];
            let offset;
            if (arr.type === "Vector") offset = point1[arr.dim];
            else // arr.type assumed to be "Matrix"
            offset = arr.parts.reduce((acc, { dim: dim })=>acc + multipliers[dim] * point1[dim], 0);
            if (last) return {
                index: offset,
                parent: currentData,
                value: currentData[offset]
            };
            else currentData = currentData[offset];
        }
    };
}
function $0696259da4f0e285$var$select({ useLayoutCache: useLayoutCache = true, data: data, layout: layout, point: point1, sizes: sizes = {} }) {
    // converts layout expression to a layout object
    if (typeof layout === "string") layout = $0696259da4f0e285$var$parse(layout, {
        useLayoutCache: useLayoutCache
    });
    let parent;
    let index;
    let value = data;
    // dims are arrays
    const { dims: dims } = layout;
    const len = dims.length;
    for(let idim = 0; idim < len; idim++){
        const arr = dims[idim];
        if (arr.type === "Vector") {
            const i = point1[arr.dim];
            parent = value;
            index = i;
            value = value[i];
        } else {
            // only 2 types so must be a Matrix
            const { parts: parts } = arr;
            let offset = 0;
            let multiplier = 1;
            for(let i = parts.length - 1; i >= 0; i--){
                const part = parts[i];
                if (part.type === "Vector") {
                    const { dim: dim } = part;
                    offset += multiplier * point1[dim];
                    if (i > 0) {
                        if (!(dim in sizes)) throw new Error(`you cannot calculate the location without knowing the size of the "${dim}" dimension.`);
                        multiplier *= sizes[dim];
                    }
                }
            }
            parent = value;
            index = offset;
            value = value[offset];
        }
    }
    return {
        index: index,
        value: value,
        parent: parent
    };
}
// add dimensions to an array until the limit reaches zero
function $0696259da4f0e285$var$addDims({ arr: arr, fill: fill, lens: lens, arrayTypes: arrayTypes }) {
    // no new dimensions to add
    if (lens.length === 0) return arr;
    const len = lens[0];
    if (lens.length === 1) {
        const lastArrayType = arrayTypes ? arrayTypes[arrayTypes.length - 1] : "Array";
        for(let i = 0; i < arr.length; i++)arr[i] = new $0696259da4f0e285$var$ARRAY_TYPES[lastArrayType](len).fill(fill);
    } else for(let i = 0; i < arr.length; i++){
        const sub = new Array(len).fill(fill);
        arr[i] = sub;
        $0696259da4f0e285$var$addDims({
            arr: sub,
            fill: fill,
            lens: lens.slice(1),
            arrayTypes: arrayTypes
        });
    }
    return arr;
}
// to-do: maybe only call fill if not undefined or default typed array value?
function $0696259da4f0e285$var$createMatrix({ fill: fill, shape: shape, arrayTypes: arrayTypes }) {
    const len = shape[0];
    if (shape.length === 1) {
        if (Array.isArray(arrayTypes) && arrayTypes.length !== 1) throw new Error("[xdim] shape and arrayTypes have different lengths");
        const arrayType = Array.isArray(arrayTypes) ? arrayTypes[0] : "Array";
        return new $0696259da4f0e285$var$ARRAY_TYPES[arrayType](len).fill(fill);
    }
    const arr = new Array(len).fill(fill);
    return $0696259da4f0e285$var$addDims({
        arr: arr,
        fill: fill,
        lens: shape.slice(1),
        arrayTypes: arrayTypes
    });
}
// generates an in-memory data structure to hold the data
function $0696259da4f0e285$var$prepareData({ fill: fill, layout: layout, useLayoutCache: useLayoutCache = true, sizes: sizes, arrayTypes: arrayTypes }) {
    if (typeof layout === "string") layout = $0696259da4f0e285$var$parse(layout, {
        useLayoutCache: useLayoutCache
    });
    // console.log("layout:", layout);
    const shape = layout.dims.map((it)=>{
        if (it.type === "Vector") return sizes[it.dim];
        else if (it.type === "Matrix") return it.parts.reduce((total, part)=>{
            if (!(part.dim in sizes)) throw new Error(`[xdim] could not find "${part.dim}" in sizes: { ${Object.keys(sizes).join(", ")} }`);
            return total * sizes[part.dim];
        }, 1);
    });
    const data = $0696259da4f0e285$var$createMatrix({
        fill: fill,
        shape: shape,
        arrayTypes: arrayTypes
    });
    return {
        data: data,
        shape: shape,
        arrayTypes: arrayTypes
    };
}
// assume positive step
function $0696259da4f0e285$var$iterRange({ start: start = 0, end: end = 100 }) {
    let i = start - 1;
    end = end + 1;
    return $0696259da4f0e285$require$wrapNextFunction(function next() {
        i++;
        if (i === end) return {
            done: true
        };
        else return {
            done: false,
            value: i
        };
    });
}
// iterate over all the points, saving memory vs array
function $0696259da4f0e285$var$iterPoints({ order: order, sizes: sizes, rect: rect = {} }) {
    // names sorted by shortest dimension to longest dimension
    const names = Array.isArray(order) ? order : Object.keys(sizes).sort((a, b)=>sizes[a] - sizes[b]);
    const iters = new Array(names.length);
    const current = {};
    for(let i = 0; i < names.length - 1; i++){
        const name = names[i];
        const [start, end] = rect[name] || [
            0,
            sizes[name] - 1
        ];
        iters[i] = $0696259da4f0e285$var$iterRange({
            start: start + 1,
            end: end
        });
        current[name] = start;
    }
    const lastName = names[names.length - 1];
    const [start, end] = rect[lastName] || [
        0,
        sizes[lastName] - 1
    ];
    iters[iters.length - 1] = $0696259da4f0e285$var$iterRange({
        start: start,
        end: end
    });
    current[lastName] = start - 1;
    // permutate
    return $0696259da4f0e285$require$wrapNextFunction(function next() {
        for(let i = iters.length - 1; i >= 0; i--){
            const { value: value, done: done } = iters[i].next();
            if (done) {
                if (i === 0) // we have exhausted all of the permutations
                return {
                    done: true
                };
            } else {
                // add iters for the remaining dims
                for(let ii = i + 1; ii < iters.length; ii++){
                    const nameii = names[ii];
                    const [start, end] = rect[nameii] || [
                        0,
                        sizes[nameii] - 1
                    ];
                    iters[ii] = $0696259da4f0e285$var$iterRange({
                        start: start + 1,
                        end: end
                    });
                    current[nameii] = start;
                }
                current[names[i]] = value;
                return {
                    value: current,
                    done: false
                };
            }
        }
    });
}
function $0696259da4f0e285$var$transform({ data: data, fill: fill, from: from, to: to, sizes: sizes, useLayoutCache: useLayoutCache = true }) {
    if (typeof from === "string") from = $0696259da4f0e285$var$parse(from, {
        useLayoutCache: useLayoutCache
    });
    if (typeof to === "string") to = $0696259da4f0e285$var$parse(to, {
        useLayoutCache: useLayoutCache
    });
    const { data: out_data } = $0696259da4f0e285$var$prepareData({
        fill: fill,
        layout: to,
        sizes: sizes
    });
    const update = $0696259da4f0e285$var$prepareUpdate({
        useLayoutCache: useLayoutCache,
        data: out_data,
        layout: to,
        sizes: sizes
    });
    const points = $0696259da4f0e285$var$iterPoints({
        sizes: sizes
    });
    for (point of points){
        const { value: value } = $0696259da4f0e285$var$select({
            data: data,
            layout: from,
            point: point,
            sizes: sizes
        });
        // insert into new frame
        update({
            point: point,
            value: value
        });
    }
    return {
        data: out_data
    };
}
$0696259da4f0e285$exports = {
    addDims: $0696259da4f0e285$var$addDims,
    checkValidity: $0696259da4f0e285$var$checkValidity,
    createMatrix: $0696259da4f0e285$var$createMatrix,
    iterClip: $0696259da4f0e285$var$iterClip,
    iterRange: $0696259da4f0e285$var$iterRange,
    iterPoints: $0696259da4f0e285$var$iterPoints,
    matchSequences: $0696259da4f0e285$var$matchSequences,
    parse: $0696259da4f0e285$var$parse,
    parseDimensions: $0696259da4f0e285$var$parseDimensions,
    parseSequences: $0696259da4f0e285$var$parseSequences,
    parseVectors: $0696259da4f0e285$var$parseVectors,
    prepareData: $0696259da4f0e285$var$prepareData,
    prepareSelect: $0696259da4f0e285$var$prepareSelect,
    prepareUpdate: $0696259da4f0e285$var$prepareUpdate,
    removeBraces: $0696259da4f0e285$var$removeBraces,
    removeParentheses: $0696259da4f0e285$var$removeParentheses,
    select: $0696259da4f0e285$var$select,
    transform: $0696259da4f0e285$var$transform,
    update: $0696259da4f0e285$var$update,
    clip: $0696259da4f0e285$var$clip,
    validateRect: $0696259da4f0e285$var$validateRect
};


var $c9ebbebcf6d622b0$exports = {};
// to-do: provide offsets, so evenly distributed when rounding
function $c9ebbebcf6d622b0$var$_identity(n) {
    return n;
}
function $c9ebbebcf6d622b0$var$_scale_number(old_min, old_range, new_min, new_range, n) {
    return new_min + new_range * (n - old_min) / old_range;
}
function $c9ebbebcf6d622b0$var$_scale_and_flip_number(old_min, old_range, new_max, new_range, n) {
    return new_max - new_range * (n - old_min) / old_range;
}
function $c9ebbebcf6d622b0$var$_scale_and_round_number(old_min, old_range, new_min, new_range, n) {
    return Math.round(new_min + new_range * (n - old_min) / old_range);
}
function $c9ebbebcf6d622b0$var$_scale_and_flip_and_round_number(old_min, old_range, new_max, new_range, n) {
    return Math.round(new_max - new_range * (n - old_min) / old_range);
}
// assuming not no data
function $c9ebbebcf6d622b0$var$createScaleFunction([old_min, old_max], [new_min, new_max], { flip: flip, no_range_value: no_range_value, no_range_value_strategy: no_range_value_strategy = "highest", round: round = false } = {}) {
    const old_range = old_max - old_min;
    const new_range = new_max - new_min;
    if (old_range === 0) {
        if (typeof no_range_value === "number") return $c9ebbebcf6d622b0$var$_identity.bind(null, no_range_value);
        else if (no_range_value_strategy === "highest") return $c9ebbebcf6d622b0$var$_identity.bind(null, new_max);
        else if (no_range_value_strategy === "lowest") return $c9ebbebcf6d622b0$var$_identity.bind(null, new_min);
        else if (no_range_value_strategy === "middle") {
            let n = (new_max - new_min) / 2;
            if (round) n = Math.round(n);
            return $c9ebbebcf6d622b0$var$_identity.bind(null, n);
        }
    }
    if (flip) {
        if (round) return $c9ebbebcf6d622b0$var$_scale_and_flip_and_round_number.bind(null, old_min, old_range, new_max, new_range);
        else return $c9ebbebcf6d622b0$var$_scale_and_flip_number.bind(null, old_min, old_range, new_max, new_range);
    } else {
        if (round) return $c9ebbebcf6d622b0$var$_scale_and_round_number.bind(null, old_min, old_range, new_min, new_range);
        else return $c9ebbebcf6d622b0$var$_scale_number.bind(null, old_min, old_range, new_min, new_range);
    }
}
function $c9ebbebcf6d622b0$var$_scale(pixel, ...rest) {
    return create(rest)(pixel);
}
const $c9ebbebcf6d622b0$var$quickScale = {
    _identity: $c9ebbebcf6d622b0$var$_identity,
    _scale: $c9ebbebcf6d622b0$var$_scale,
    _scale_number: $c9ebbebcf6d622b0$var$_scale_number,
    _scale_and_flip_number: $c9ebbebcf6d622b0$var$_scale_and_flip_number,
    _scale_and_round_number: $c9ebbebcf6d622b0$var$_scale_and_round_number,
    _scale_and_flip_and_round_number: $c9ebbebcf6d622b0$var$_scale_and_flip_and_round_number,
    createScaleFunction: $c9ebbebcf6d622b0$var$createScaleFunction
};
if (typeof define === "object") define(function() {
    return $c9ebbebcf6d622b0$var$quickScale;
});
$c9ebbebcf6d622b0$exports = $c9ebbebcf6d622b0$var$quickScale;
if (typeof window === "object") window.quickScale = $c9ebbebcf6d622b0$var$quickScale;
if (typeof self === "object") self.quickScale = $c9ebbebcf6d622b0$var$quickScale;


function $921c61681728eab7$export$2e2bcd8739ae039(noDataValue) {
    // typescript not smart enough to realize all values in the array will be the same
    // @ts-ignore
    return [
        noDataValue,
        noDataValue,
        noDataValue,
        0
    ];
}


function $548baa44ba805e87$export$2e2bcd8739ae039(old_no_data_value, noDataPixel, scalefn, pixel) {
    const n = pixel[0];
    if (n === old_no_data_value) return noDataPixel;
    const scaled = scalefn(n);
    return [
        scaled,
        scaled,
        scaled,
        255
    ];
}


function $754f63295cff9e2b$export$2e2bcd8739ae039(old_no_data_value, new_no_data_value, scalefn1, scalefn2, pixel) {
    const [r, g] = pixel; // @ts-ignore
    return [
        r === old_no_data_value ? new_no_data_value : scalefn1(r),
        g === old_no_data_value ? new_no_data_value : scalefn2(g),
        0,
        r === old_no_data_value || g === old_no_data_value ? 0 : 255
    ];
}


// convert a 2-band pixel
// if any no data is found, set all RGB to no data
function $2c400753d49d6e94$export$2e2bcd8739ae039(old_no_data_value, noDataPixel, scalefn1, scalefn2, pixel) {
    if (pixel.includes(old_no_data_value)) return noDataPixel;
    return [
        scalefn1(pixel[0]),
        scalefn2(pixel[1]),
        0,
        255
    ];
}


function $e537b18a0796860e$export$2e2bcd8739ae039(old_no_data_value, new_no_data_value, scalefn1, scalefn2, scalefn3, pixel) {
    const [r, g, b] = pixel;
    return [
        r === old_no_data_value ? new_no_data_value : scalefn1(r),
        g === old_no_data_value ? new_no_data_value : scalefn2(g),
        b === old_no_data_value ? new_no_data_value : scalefn3(b),
        r === old_no_data_value || g === old_no_data_value || b === old_no_data_value ? 0 : 255
    ];
}


function $c1442064f74d2e23$export$2e2bcd8739ae039(old_no_data_value, noDataPixel, scalefn1, scalefn2, scalefn3, pixel) {
    if (pixel.includes(old_no_data_value)) return noDataPixel;
    return [
        scalefn1(pixel[0]),
        scalefn2(pixel[1]),
        scalefn3(pixel[2]),
        255
    ];
}


function $324e19b7a1eaabd8$export$2e2bcd8739ae039({ debug_level: debug_level = 0, ranges: ranges, flip: flip = false, new_no_data_value: new_no_data_value, no_data_strategy: no_data_strategy, no_range_value: no_range_value, no_range_value_strategy: no_range_value_strategy, old_no_data_value: old_no_data_value }) {
    if (debug_level >= 1) console.log("[pixel-utils/raw-to-rgba] ranges:", ranges);
    const nbands = ranges.length;
    const new_range = [
        0 === new_no_data_value ? 1 : 0,
        255 === new_no_data_value ? 254 : 255
    ];
    if (debug_level >= 1) console.log("[pixel-utils/raw-to-rgba] new_range:", new_range);
    const options = {
        no_data_value: new_no_data_value,
        flip: flip,
        no_range_value: no_range_value,
        no_range_value_strategy: no_range_value_strategy,
        round: true
    };
    if (debug_level >= 1) console.log("[pixel-utils/raw-to-rgba] options:", options);
    const scalefns = ranges.slice(0, 3).map((rng)=>(0, $c9ebbebcf6d622b0$exports.createScaleFunction)(rng, new_range, options));
    if (nbands === 1) // @ts-ignore
    return (0, $548baa44ba805e87$export$2e2bcd8739ae039).bind(null, old_no_data_value, (0, $921c61681728eab7$export$2e2bcd8739ae039)(new_no_data_value), scalefns[0]);
    else if (nbands === 2) {
        if (no_data_strategy === "all") // @ts-ignore
        return (0, $2c400753d49d6e94$export$2e2bcd8739ae039).bind(null, old_no_data_value, (0, $921c61681728eab7$export$2e2bcd8739ae039)(new_no_data_value), ...scalefns);
        else // @ts-ignore
        return (0, $754f63295cff9e2b$export$2e2bcd8739ae039).bind(null, old_no_data_value, new_no_data_value, ...scalefns);
    } else if (nbands >= 3) {
        if (no_data_strategy === "all") // @ts-ignore
        return (0, $c1442064f74d2e23$export$2e2bcd8739ae039).bind(null, old_no_data_value, (0, $921c61681728eab7$export$2e2bcd8739ae039)(new_no_data_value), ...scalefns);
        else // @ts-ignore
        return (0, $e537b18a0796860e$export$2e2bcd8739ae039).bind(null, old_no_data_value, new_no_data_value, ...scalefns);
    }
    throw Error("uh oh");
}


let $236cfa17d17b85b5$export$c84671f46d6a1ca;
(function(Layout) {
    Layout["[band][row][column]"] = "[band][row][column]";
    Layout["[band][row,column]"] = "[band][row,column]";
    Layout["[band,row,column]"] = "[band,row,column]";
    Layout["[row,column,band]"] = "[row,column,band]";
    Layout["[row,column][band]"] = "[row,column][band]";
    Layout["[row][column][band]"] = "[row][column][band]";
    Layout["[row][column,band]"] = "[row][column,band]";
})($236cfa17d17b85b5$export$c84671f46d6a1ca || ($236cfa17d17b85b5$export$c84671f46d6a1ca = {}));


function $e50a1cb2855be370$export$2e2bcd8739ae039(data, depth, height, width, r, c) {
    const pixel = [];
    const size = height * width;
    const i = r * width + c;
    for(let b = 0; b < depth; b++)pixel.push(data[b * size + i]);
    return pixel;
}


function $d5f13341bd1514de$export$2e2bcd8739ae039(data, depth, r, c) {
    const pixel = [];
    for(let b = 0; b < depth; b++)pixel.push(data[b][r][c]);
    return pixel;
}


function $098f4a0633e2e6a5$export$2e2bcd8739ae039(data, depth, width, r, c) {
    const pixel = [];
    const i = r * width + c;
    for(let b = 0; b < depth; b++)pixel.push(data[b][i]);
    return pixel;
}


// like ImageData.data
function $196443f724ec8e46$export$2e2bcd8739ae039(data, depth, width, r, c) {
    const pixel = [];
    let i = (r * width + c) * depth;
    const imax = i + depth;
    for(; i < imax; i++)pixel.push(data[i]);
    return pixel;
}


function $2a460c61c73dd60b$export$2e2bcd8739ae039(data, width, r, c) {
    return data[r * width + c];
}


function $5eead41bf99e5e9d$export$2e2bcd8739ae039(data, r, c) {
    return data[r][c];
}


// each row is its own array
function $1b1f681b9d7d0255$export$2e2bcd8739ae039(data, depth, r, c) {
    const pixel = [];
    const row = data[r];
    let i = c * depth;
    const imax = i + depth;
    for(; i < imax; i++)pixel.push(row[i]);
    return pixel;
}


function $77fcc744eba1adca$export$2e2bcd8739ae039(data, { depth: depth, height: height, layout: layout, width: width }) {
    // console.log("layout:", {layout, data, depth, width});
    switch(layout){
        case (0, $236cfa17d17b85b5$export$c84671f46d6a1ca)["[band][row][column]"]:
            // @ts-ignore
            return (0, $d5f13341bd1514de$export$2e2bcd8739ae039).bind(null, data, depth);
        case (0, $236cfa17d17b85b5$export$c84671f46d6a1ca)["[band][row,column]"]:
            // @ts-ignore
            return (0, $098f4a0633e2e6a5$export$2e2bcd8739ae039).bind(null, data, depth, width);
        case (0, $236cfa17d17b85b5$export$c84671f46d6a1ca)["[band,row,column]"]:
            // @ts-ignore
            return (0, $e50a1cb2855be370$export$2e2bcd8739ae039).bind(null, data, depth, height, width);
        case (0, $236cfa17d17b85b5$export$c84671f46d6a1ca)["[row,column][band]"]:
            // @ts-ignore
            return (0, $2a460c61c73dd60b$export$2e2bcd8739ae039).bind(null, data, width);
        case (0, $236cfa17d17b85b5$export$c84671f46d6a1ca)["[row][column][band]"]:
            // @ts-ignore
            return (0, $5eead41bf99e5e9d$export$2e2bcd8739ae039).bind(null, data);
        case (0, $236cfa17d17b85b5$export$c84671f46d6a1ca)["[row][column,band]"]:
            // @ts-ignore
            return (0, $1b1f681b9d7d0255$export$2e2bcd8739ae039).bind(null, data, depth);
        case (0, $236cfa17d17b85b5$export$c84671f46d6a1ca)["[row,column,band]"]:
            // @ts-ignore
            return (0, $196443f724ec8e46$export$2e2bcd8739ae039).bind(null, data, depth, width);
        default:
            throw new Error("[pixel-utils] unknown layout " + layout);
    }
}


function $fd70e0d8585418af$export$2e2bcd8739ae039({ data: data, debug_level: debug_level = 0, depth: depth, flip: flip = false, old_no_data_value: old_no_data_value, old_layout: old_layout, no_data_strategy: no_data_strategy = "partial", no_range_value: // png strategy
no_range_value, no_range_value_strategy: no_range_value_strategy = "top", new_layout: new_layout, new_no_data_value: new_no_data_value, height: height, ranges: ranges, width: width }) {
    if (!ranges) throw new Error("[expand] can't expand without ranges");
    if (debug_level >= 1) console.log("[stretch] starting fit");
    if (typeof height !== "number") throw new Error("[fit] height must be a number");
    if (typeof width !== "number") throw new Error("[fit] height must be a number");
    if (typeof old_layout !== "string") throw new Error("[fit] old_layout must be a string");
    if (new_layout === undefined) new_layout;
    if (typeof new_layout !== "string") throw new Error("[fit] new_layout must be a string");
    const select = (0, $77fcc744eba1adca$export$2e2bcd8739ae039)(data, {
        depth: depth,
        height: height,
        layout: old_layout,
        width: width
    });
    const out_sizes = {
        band: 4,
        row: height,
        column: width
    };
    const { data: out_data } = (0, $0696259da4f0e285$exports.prepareData)({
        fill: new_no_data_value,
        layout: new_layout,
        sizes: out_sizes
    });
    const convert = (0, $324e19b7a1eaabd8$export$2e2bcd8739ae039)({
        debug_level: debug_level - 1,
        flip: flip,
        ranges: ranges,
        new_no_data_value: new_no_data_value,
        no_data_strategy: no_data_strategy,
        no_range_value: no_range_value,
        no_range_value_strategy: no_range_value_strategy,
        old_no_data_value: old_no_data_value
    });
    const update = (0, $0696259da4f0e285$exports.prepareUpdate)({
        data: out_data,
        layout: new_layout,
        sizes: out_sizes
    });
    for(let row = 0; row < height; row++)for(let column = 0; column < width; column++){
        const [r, g, b, a] = convert(select(row, column));
        update({
            point: {
                band: 0,
                row: row,
                column: column
            },
            value: r
        });
        update({
            point: {
                band: 1,
                row: row,
                column: column
            },
            value: g
        });
        update({
            point: {
                band: 2,
                row: row,
                column: column
            },
            value: b
        });
        update({
            point: {
                band: 3,
                row: row,
                column: column
            },
            value: a
        });
    }
    if (debug_level >= 1) console.log("[pixel-utils/fit] out_data:", out_data);
    return {
        // @ts-ignore
        data: out_data,
        layout: new_layout
    };
}


function $b4e1b29b602caf4f$export$2e2bcd8739ae039(noDataValue, pixel) {
    return pixel.includes(noDataValue);
}


/**
 * @name hide_rgba
 * @description make a given (scaled) rgba value transparent/invisble
 * @param {RGBA} rgba pixel
 * @returns a new rgba pixel with the same Red, Green and Blue values and a 0 alpha value
 */ function $3d0f2796ead8ef77$export$2e2bcd8739ae039([r, g, b]) {
    return [
        r,
        g,
        b,
        0
    ];
}


/**
 * @description check if an RGBA pixel is hidden
 * @param {number[]} pixel - an array of 4 numbers representing [R, G, B, A]
 * @returns {boolean} whether the pixel is hidden
 */ function $b42175fcd714ec1c$export$2e2bcd8739ae039(pixel) {
    return pixel[3] === 0;
}


/**
 * @description check if an RGB pixel is a no data pixel
 * @param {number} no_data_value
 * @param {number[]} pixel - an array of 4 numbers representing [R, G, B, A]
 * @returns {boolean} whether the pixel is a no data pixel
 */ function $f74e07d665ad61b1$export$2e2bcd8739ae039(no_data_value, pixel) {
    return pixel[0] === no_data_value;
}


function $6e1019e747e53f97$export$2e2bcd8739ae039(noDataValue) {
    // typescript not smart enough to realize all values in the array will be the same
    // @ts-ignore
    return [
        noDataValue,
        noDataValue,
        noDataValue
    ];
}



/**
 *
 * @param {Pixel} pixel - an RGBA Pixel, an Array of 4 Numbers [Red, Green, Blue, Alpha]
 * @returns {RGBA} an RGB Pixel, an Array of 3 Numbers [Red, Green, Blue]
 */ function $3155db1e7ada0889$export$2e2bcd8739ae039(pixel) {
    pixel.pop(); // @ts-ignore
    return pixel;
}


function $fa68e43b78dfbdb5$export$2e2bcd8739ae039(ct) {
    return new Array(ct).fill(0).map((_, i)=>i);
}




function $fa29f9b1b947aa3b$export$2e2bcd8739ae039(noDataValue, noDataPixel, scale, pixel) {
    if (pixel.includes(noDataValue)) return noDataPixel;
    const scaled = scale(pixel[0]);
    return [
        scaled,
        scaled,
        scaled
    ];
}


function $604bdf3d9b7579b9$export$2e2bcd8739ae039(noDataValue, noDataPixel, scale, pixel) {
    if (pixel.includes(noDataValue)) return noDataPixel;
    const scaled = scale(pixel[0]);
    return "rgb(" + scaled + ", " + scaled + ", " + scaled + ")";
}


function $ebac0aa10bfa5df1$export$2e2bcd8739ae039(noDataValue, noDataPixel, scaleFunction1, scaleFunction2, pixel) {
    if (pixel.includes(noDataValue)) return noDataPixel;
    return [
        scaleFunction1(pixel[0]),
        scaleFunction2(pixel[1]),
        0
    ];
}


function $89330269ca7332a2$export$2e2bcd8739ae039(noDataValue, noDataPixel, scaleFunction1, scaleFunction2, pixel) {
    if (pixel.includes(noDataValue)) return noDataPixel;
    return "rgb(" + scaleFunction1(pixel[0]) + ", " + scaleFunction2(pixel[1]) + ", 0)";
}


function $9fecfc289dad0f0e$export$2e2bcd8739ae039(noDataValue, noDataPixel, scaleFunction1, scaleFunction2, scaleFunction3, pixel) {
    if (pixel.includes(noDataValue)) return noDataPixel;
    return [
        scaleFunction1(pixel[0]),
        scaleFunction2(pixel[1]),
        scaleFunction3(pixel[2])
    ];
}


function $3d64552d87c32b05$export$2e2bcd8739ae039(noDataValue, noDataPixel, scaleFunction1, scaleFunction2, scaleFunction3, pixel) {
    if (pixel.includes(noDataValue)) return noDataPixel;
    return "rgb(" + scaleFunction1(pixel[0]) + ", " + scaleFunction2(pixel[1]) + ", " + scaleFunction3(pixel[2]) + ")";
}


function $e034ddccbdf1a689$export$2e2bcd8739ae039(noDataValue, noDataPixel, scaleFunction1, scaleFunction2, scaleFunction3, pixel) {
    pixel = pixel.slice(0, 3);
    if (pixel.includes(noDataValue)) return noDataPixel;
    return [
        scaleFunction1(pixel[0]),
        scaleFunction2(pixel[1]),
        scaleFunction3(pixel[2])
    ];
}


function $58e04ce3a42a93e2$export$2e2bcd8739ae039(noDataValue, noDataPixel, scaleFunction1, scaleFunction2, scaleFunction3, pixel) {
    pixel = pixel.slice(0, 3);
    if (pixel.includes(noDataValue)) return noDataPixel;
    return "rgb(" + scaleFunction1(pixel[0]) + ", " + scaleFunction2(pixel[1]) + ", " + scaleFunction3(pixel[2]) + ")";
}


// prettier-ignore
function $e6f858ae671c7b06$export$2e2bcd8739ae039([r, g, b]) {
    return "rgb(" + r + ", " + g + ", " + b + ")";
}


function $772952f2056f565b$export$2e2bcd8739ae039({ format: format = "array", ranges: ranges, flip: flip, new_no_data_pixel: new_no_data_pixel, new_no_data_value: new_no_data_value, no_range_value: no_range_value, no_range_value_strategy: no_range_value_strategy, old_no_data_value: old_no_data_value, round: round = true }) {
    const nbands = ranges.length;
    if (new_no_data_pixel && new_no_data_value) throw new Error("[pixel-utils/raw-to-rgb] can't specify both new_no_data_pixel and new_no_data_value");
    if (new_no_data_pixel === undefined || new_no_data_pixel === null) {
        if (new_no_data_value === undefined || new_no_data_value === null) new_no_data_pixel = (0, $6e1019e747e53f97$export$2e2bcd8739ae039)(null);
        else new_no_data_pixel = (0, $6e1019e747e53f97$export$2e2bcd8739ae039)(new_no_data_value);
    }
    if (new_no_data_pixel === undefined) throw new Error("[raw-to-rgb] undefined new_no_data_pixel");
    const new_range = [
        0 === new_no_data_value ? 1 : 0,
        255 === new_no_data_value ? 254 : 255
    ];
    const options = {
        flip: flip,
        no_range_value: no_range_value,
        no_range_value_strategy: no_range_value_strategy,
        round: round
    };
    const scalefns = ranges.slice(0, 3).map((rng)=>(0, $c9ebbebcf6d622b0$exports.createScaleFunction)(rng, new_range, options));
    if (nbands === 1) {
        if (format === "string") // @ts-ignore
        return (0, $604bdf3d9b7579b9$export$2e2bcd8739ae039).bind(null, old_no_data_value, (0, $e6f858ae671c7b06$export$2e2bcd8739ae039)(new_no_data_pixel), ...scalefns);
        else // @ts-ignore
        return (0, $fa29f9b1b947aa3b$export$2e2bcd8739ae039).bind(null, old_no_data_value, new_no_data_pixel, ...scalefns);
    } else if (nbands === 2) {
        if (format === "string") // @ts-ignore
        return (0, $89330269ca7332a2$export$2e2bcd8739ae039).bind(null, old_no_data_value, (0, $e6f858ae671c7b06$export$2e2bcd8739ae039)(new_no_data_pixel), ...scalefns);
        else // @ts-ignore
        return (0, $ebac0aa10bfa5df1$export$2e2bcd8739ae039).bind(null, old_no_data_value, new_no_data_pixel, ...scalefns);
    } else if (nbands === 3) {
        if (format === "string") // @ts-ignore
        return (0, $3d64552d87c32b05$export$2e2bcd8739ae039).bind(null, old_no_data_value, (0, $e6f858ae671c7b06$export$2e2bcd8739ae039)(new_no_data_pixel), ...scalefns);
        else // @ts-ignore
        return (0, $9fecfc289dad0f0e$export$2e2bcd8739ae039).bind(null, old_no_data_value, new_no_data_pixel, ...scalefns);
    } else if (nbands >= 4) {
        if (format === "string") // @ts-ignore
        return (0, $58e04ce3a42a93e2$export$2e2bcd8739ae039).bind(null, old_no_data_value, (0, $e6f858ae671c7b06$export$2e2bcd8739ae039)(new_no_data_pixel), ...scalefns);
        else // @ts-ignore
        return (0, $e034ddccbdf1a689$export$2e2bcd8739ae039).bind(null, old_no_data_value, new_no_data_pixel, ...scalefns);
    } else throw new Error("[pixel-utils/raw-to-rgb] invalid number of bands: " + nbands);
}




/**
 * @description converts an RGB to an RGBA by pushing an alpha value at the end of the RGB array
 * @param rgb - a 3-number RGB pixel
 * @returns rgba - a 4-number array representing an RGBA pixel
 */ function $923c14e178b526b6$export$2e2bcd8739ae039(pixel) {
    // @ts-ignore
    pixel.push(255); // @ts-ignore
    return pixel;
}






function $c6967137c2eb4bba$export$2e2bcd8739ae039(old_no_data_value, new_no_data_value, pixel) {
    return (0, $f74e07d665ad61b1$export$2e2bcd8739ae039)(old_no_data_value, pixel) ? (0, $921c61681728eab7$export$2e2bcd8739ae039)(new_no_data_value) : (0, $544ad420fbe8433b$export$2e2bcd8739ae039)(pixel);
}




function $bca166ccf439955b$export$2e2bcd8739ae039(old_no_data_value, new_no_data_pixel, px) {
    return (0, $f74e07d665ad61b1$export$2e2bcd8739ae039)(old_no_data_value, px) ? new_no_data_pixel : (0, $923c14e178b526b6$export$2e2bcd8739ae039)(px);
}


function $95f4ccafac75e4ca$export$2e2bcd8739ae039({ old_no_data_value: old_no_data_value, new_no_data_value: new_no_data_value = null, safe: safe = true } = {}) {
    if (typeof old_no_data_value === "number") {
        if (safe) // @ts-ignore
        return (0, $c6967137c2eb4bba$export$2e2bcd8739ae039).bind(null, old_no_data_value, new_no_data_value);
        else {
            const new_no_data_pixel = (0, $921c61681728eab7$export$2e2bcd8739ae039)(new_no_data_value); // we will reuse this no data pixel
            // @ts-ignore
            return (0, $bca166ccf439955b$export$2e2bcd8739ae039).bind(null, old_no_data_value, new_no_data_pixel);
        }
    } else {
        if (safe) return 0, $544ad420fbe8433b$export$2e2bcd8739ae039;
        else return 0, $923c14e178b526b6$export$2e2bcd8739ae039;
    }
}





/**
 * @name sliceAlpha
 * @description slices off the alpha value of a 4-number RGBA pixel array,
 * leaving a new 3-Number RGB pixel array
 * @param {RGBA} pixel - an RGBA
 * @returns {RGBA} an RGBA pixel as an array of 4 numbers
 */ function $bea5179235e5dba5$export$2e2bcd8739ae039(pixel) {
    // @ts-ignore
    return pixel.slice(0, 3);
}





function $378db9cd923a91e2$export$2e2bcd8739ae039(noDataValue, pixel) {
    return (0, $b42175fcd714ec1c$export$2e2bcd8739ae039)(pixel) ? (0, $6e1019e747e53f97$export$2e2bcd8739ae039)(noDataValue) : (0, $bea5179235e5dba5$export$2e2bcd8739ae039)(pixel);
}




function $bbf8c69afa4811dc$export$2e2bcd8739ae039(noDataPixel, pixel) {
    return (0, $b42175fcd714ec1c$export$2e2bcd8739ae039)(pixel) ? noDataPixel : (0, $3155db1e7ada0889$export$2e2bcd8739ae039)(pixel);
}


function $b7debe9086a09f68$export$2e2bcd8739ae039({ new_no_data_value: new_no_data_value, safe: safe = true } = {}) {
    if (safe) {
        if (typeof new_no_data_value === "number") // @ts-ignore
        return (0, $378db9cd923a91e2$export$2e2bcd8739ae039).bind(null, new_no_data_value);
        else return 0, $bea5179235e5dba5$export$2e2bcd8739ae039;
    } else {
        if (typeof new_no_data_value === "number") // @ts-ignore
        return (0, $bbf8c69afa4811dc$export$2e2bcd8739ae039).bind(null, (0, $6e1019e747e53f97$export$2e2bcd8739ae039)(new_no_data_value));
        else return 0, $3155db1e7ada0889$export$2e2bcd8739ae039;
    }
}


// make a given rgba value transparent
function $5bcf39be8cb230f7$export$2e2bcd8739ae039(pixel) {
    // @ts-ignore
    pixel[3] = 0; // @ts-ignore
    return pixel;
}


// make a given rgba value visible
function $4bf01af20d63afdb$export$2e2bcd8739ae039(pixel) {
    // @ts-ignore
    pixel[3] = 255; // @ts-ignore
    return pixel;
}


/**
 * @name show_rgba
 * @description // make a given (scaled) rgba value visible
 * @param {RGBA} rgba pixel
 * @returns a new rgba pixel with the same Red, Green and Blue values and a 255 alpha value
 */ function $b6e5cbe650fb902b$export$2e2bcd8739ae039([r, g, b]) {
    return [
        r,
        g,
        b,
        255
    ];
}





var $da647afaa7b4daaa$exports = {};
$da647afaa7b4daaa$exports = function isUTM(projection) {
    const projstr = projection.toString();
    return projstr.startsWith("326") || projstr.startsWith("327");
};


var $53b6c494a80f9dfd$exports = {};
var $fff526728eeaab09$exports = {};
$fff526728eeaab09$exports = function getZone(projection) {
    return Number.parseInt(projection.toString().substring(3));
};


var $1c1f5a61f2f16aa2$exports = {};
$1c1f5a61f2f16aa2$exports = function getHemisphere(projection) {
    const projstr = projection.toString();
    if (projstr.startsWith("326")) return "N";
    else if (projstr.startsWith("327")) return "S";
};


$53b6c494a80f9dfd$exports = function getProjString(projection) {
    const zone = $fff526728eeaab09$exports(projection);
    const hemisphere = $1c1f5a61f2f16aa2$exports(projection);
    return `+proj=utm +zone=${zone}${hemisphere === "S" ? " +south " : " "}+ellps=WGS84 +datum=WGS84 +units=m +no_defs`;
};


var $3faba67f5f823edd$exports = {};

var $3faba67f5f823edd$require$proj4 = $37e7d27a698002f1$exports;

if (typeof $3faba67f5f823edd$require$proj4 === "object" && typeof $3faba67f5f823edd$require$proj4.defs !== "function" && typeof $3faba67f5f823edd$require$proj4.default === "function") // probably inside an Angular project
$3faba67f5f823edd$require$proj4 = $3faba67f5f823edd$require$proj4.default;
$3faba67f5f823edd$require$proj4.defs($f68f332138d52ff8$exports);
if (typeof define === "function" && define.amd) define(function() {
    return $3faba67f5f823edd$require$proj4;
});
$3faba67f5f823edd$exports = $3faba67f5f823edd$require$proj4;
$3faba67f5f823edd$exports.default = $3faba67f5f823edd$require$proj4;


var $f8a5576c27bdd239$exports = {};
"use strict";
var $5192f89b16a7cf75$exports = {};
"use strict";
// given:
//  - a and b are positive numbers
//  - a and b have been cleaned (i.e. no + or leading zeros)
function $5192f89b16a7cf75$var$compare_positive(a, b) {
    const alen = a.length;
    const blen = b.length;
    const aidx = a.indexOf(".");
    const bidx = b.indexOf(".");
    // basically where would the dot be
    // if we add a dot at the end of integers
    // like 123.
    const a_adjusted_dot_index = aidx === -1 ? alen : aidx;
    const b_adjusted_dot_index = bidx === -1 ? blen : bidx;
    // how much you need to shift the second number
    // to line up the decimal with the first
    //        0.12345
    //    12345.0
    const offset = a_adjusted_dot_index - b_adjusted_dot_index;
    let left = Math.max(a_adjusted_dot_index, b_adjusted_dot_index);
    let right = Math.max(alen - a_adjusted_dot_index, blen - b_adjusted_dot_index);
    let aoffset = offset < 0 ? -1 * offset : 0;
    let boffset = offset <= 0 ? 0 : offset;
    let imax = left + 1 + right - 1; // -1 for zero-index
    let i = 0;
    while(i < imax){
        const ai = i - aoffset;
        const achar = ai === a_adjusted_dot_index ? "." : a[ai] || "0";
        const bi = i - boffset;
        const bchar = bi === b_adjusted_dot_index ? "." : b[bi] || "0";
        if (achar !== bchar) {
            if (achar > bchar) return ">";
            else if (achar < bchar) return "<";
        }
        i++;
    }
    return "=";
}
$5192f89b16a7cf75$exports = $5192f89b16a7cf75$var$compare_positive;
$5192f89b16a7cf75$exports.default = $5192f89b16a7cf75$var$compare_positive;


var $f6234cb65e75e7df$exports = {};
"use strict";
var $befb7dc4374f4474$exports = {};
"use strict";
// convert exponential notation to normal string
// not optimized yet and no support for big numbers
function $befb7dc4374f4474$var$expand(n) {
    // remove + from beginning
    if (n[0] === "+") n = n.substring(1);
    const sign = n[0] === "-" ? "-" : "";
    if (sign === "-") n = n.substring(1);
    const index_of_e = n.indexOf("e");
    // number not in exponential notation
    if (index_of_e === -1) return sign + n;
    let index_of_dot = n.indexOf(".");
    // if number doesn't include a period dot
    // then just assume it at the end
    // such that 3e4 has index of dot at 1
    if (index_of_dot === -1) index_of_dot = index_of_e;
    const shift = Number(n.substring(index_of_e + 1));
    // remove old decimal place
    const base = n.substring(0, index_of_e).replace(".", "");
    // normalize shift to start of the string at index zero
    const normshift = index_of_dot + shift;
    const baselen = base.length;
    if (normshift >= baselen) {
        const zct = normshift - baselen;
        let result = base;
        for(let i = 0; i < zct; i++)result += "0";
        return sign + result;
    } else if (normshift < 0) {
        // need to add zeros in decimal places
        let result = "0.";
        for(let i = 0; i > normshift; i--)result += "0";
        result += base;
        return sign + result;
    } else // shifting within the base
    return sign + base.substring(0, normshift) + "." + base.substring(normshift);
}
$befb7dc4374f4474$exports = $befb7dc4374f4474$var$expand;
$befb7dc4374f4474$exports.default = $befb7dc4374f4474$var$expand;


$f6234cb65e75e7df$exports = function clean(n) {
    // remove + from beginning
    if (n[0] === "+") n = n.substring(1);
    n = $befb7dc4374f4474$exports(n);
    // remove extra zero in front
    // 03938.123 => 3938.123
    n = n.replace(/^0+(?=\d)/, "");
    // remove extra zero at end
    if (n.includes(".")) n = n.replace(/\.?0+$/, "");
    // should improve this, so it identifies zero earlier
    if (n === "") n = "0";
    if (n === "-0") n = "0";
    return n;
};


var $b74223d0182048b8$exports = {};
"use strict";
var $31d6263ad5b58057$exports = {};
"use strict";
// Internet Explorer doesn't support Number.MAX_SAFE_INTEGER
// so we just define the constant ourselves
const $31d6263ad5b58057$var$MAX_SAFE_INTEGER = 9007199254740991;
// the greatest number of digits an integer can have
// and be guaranteed to be stored safely as a floating point.
// subtract 1 because MAX_SAFE_INTEGER isn't all 9's
const $31d6263ad5b58057$var$MAX_SAFE_INTEGER_LENGTH = $31d6263ad5b58057$var$MAX_SAFE_INTEGER.toString().length - 1;
$31d6263ad5b58057$exports = {
    MAX_SAFE_INTEGER: $31d6263ad5b58057$var$MAX_SAFE_INTEGER,
    MAX_SAFE_INTEGER_LENGTH: $31d6263ad5b58057$var$MAX_SAFE_INTEGER_LENGTH
};


var $b74223d0182048b8$require$MAX_SAFE_INTEGER_LENGTH = $31d6263ad5b58057$exports.MAX_SAFE_INTEGER_LENGTH;
// assumes both numbers are positive numbers
function $b74223d0182048b8$var$long_addition(a, b) {
    const alen = a.length;
    const blen = b.length;
    const aidx = a.indexOf(".");
    const bidx = b.indexOf(".");
    // basically where would the dot be
    // if we add a dot at the end of integers
    // like 123.
    const a_adjusted_dot_index = aidx === -1 ? alen : aidx;
    const b_adjusted_dot_index = bidx === -1 ? blen : bidx;
    // just use floating point arithmetic for small integers
    if (aidx === -1 && bidx === -1 && alen < $b74223d0182048b8$require$MAX_SAFE_INTEGER_LENGTH && blen < $b74223d0182048b8$require$MAX_SAFE_INTEGER_LENGTH) return (Number(a) + Number(b)).toFixed();
    // how much you need to shift the second number
    // to line up the decimal with the first
    //        0.12345
    //    12345.0
    const offset = a_adjusted_dot_index - b_adjusted_dot_index;
    let left = Math.max(a_adjusted_dot_index, b_adjusted_dot_index);
    let right = Math.max(alen - a_adjusted_dot_index - 1, blen - b_adjusted_dot_index - 1);
    let aoffset = offset < 0 ? -1 * offset : 0;
    let boffset = offset <= 0 ? 0 : offset;
    let imax = left + 1 + right - 1; // -1 for zero-index
    let result = "";
    let carried = 0;
    // to the right of the period
    //        0.12345
    //    12345.0
    let i = imax;
    if (right > 0) {
        while(i > imax - right){
            const achar = a[i - aoffset] || "0";
            const bchar = b[i - boffset] || "0";
            let n = Number(achar) + Number(bchar) + carried;
            if (n >= 10) {
                n -= 10;
                carried = 1;
            } else carried = 0;
            if (result !== "" || n !== 0) result = n + result;
            i--;
        }
        if (result) result = "." + result;
        i--; // substract 1 for dot
    }
    if (left > 0) while(i >= 0){
        const achar = a[i - aoffset] || "0";
        const bchar = b[i - boffset] || "0";
        let n = Number(achar) + Number(bchar) + carried;
        if (n >= 10) {
            n -= 10;
            carried = 1;
        } else carried = 0;
        result = n + result;
        i--;
    }
    if (carried === 1) result = carried + result;
    if (result[0] === ".") result = "0" + result;
    return result;
}
$b74223d0182048b8$exports = $b74223d0182048b8$var$long_addition;
$b74223d0182048b8$exports.default = $b74223d0182048b8$var$long_addition;


var $dd8977ef38db6c34$exports = {};
"use strict";

var $dd8977ef38db6c34$require$MAX_SAFE_INTEGER_LENGTH = $31d6263ad5b58057$exports.MAX_SAFE_INTEGER_LENGTH;
// assumes (1) both a and b are positive numbers
// and (2) a is larger than b
function $dd8977ef38db6c34$var$long_subtraction(a, b) {
    const alen = a.length;
    const blen = b.length;
    const aidx = a.indexOf(".");
    const bidx = b.indexOf(".");
    // basically where would the dot be
    // if we add a dot at the end of integers
    // like 123.
    const a_adjusted_dot_index = aidx === -1 ? alen : aidx;
    const b_adjusted_dot_index = bidx === -1 ? blen : bidx;
    // console.log({a_adjusted_dot_index, b_adjusted_dot_index});
    // how much you need to shift the second number
    // to line up the decimal with the first
    //        0.12345
    //    12345.0
    // just use floating point arithmetic for small integers
    if (aidx === -1 && bidx === -1 && alen < $dd8977ef38db6c34$require$MAX_SAFE_INTEGER_LENGTH && blen < $dd8977ef38db6c34$require$MAX_SAFE_INTEGER_LENGTH) return (Number(a) - Number(b)).toFixed();
    const offset = a_adjusted_dot_index - b_adjusted_dot_index;
    // console.log("offset:", offset);
    let left = Math.max(a_adjusted_dot_index, b_adjusted_dot_index);
    // console.log("left:", left);
    let right = Math.max(alen - a_adjusted_dot_index - 1, blen - b_adjusted_dot_index - 1);
    // console.log("right:", right);
    let aoffset = offset < 0 ? -1 * offset : 0;
    let boffset = offset <= 0 ? 0 : offset;
    // console.log({aoffset, boffset});
    let imax = left + 1 + right - 1; // -1 for zero-index
    // console.log({imax});
    let result = "";
    // number of borrowings
    let borrowed = 0;
    // to the right of the period
    //  100.5  6  7
    //    2.2  9  3
    //        (-3 + 10)  4
    let i = imax;
    if (right > 0) {
        while(i > imax - right){
            // console.log("\n\n", {i});
            let top = a[i - aoffset] || "0";
            let bottom = b[i - boffset] || "0";
            // console.log("pre borrowing", {top, bottom});
            top -= borrowed;
            borrowed = 0;
            // console.log("after borrowing", {top, bottom});
            let n = top - bottom;
            // console.log({n});
            if (n < 0) while(n < 0){
                borrowed++;
                n += 10;
            }
            else if (borrowed) borrowed--;
            // console.log({n});
            if (result !== "" || n !== 0) result = n + result;
            i--;
        }
        if (result !== "") result = "." + result;
        i--; // substract 1 for dot
    }
    // console.log({result});
    if (left > 0) {
        while(i > 0){
            // console.log("\n\n", {i});
            let top = a[i - aoffset] || "0";
            let bottom = b[i - boffset] || "0";
            // console.log("pre borrowing", {top, bottom});
            top -= borrowed;
            borrowed = 0;
            // console.log("after borrowing", {top, bottom});
            let n = top - bottom;
            // console.log({n});
            if (n < 0) while(n < 0){
                borrowed++;
                n += 10;
            }
            else if (borrowed) borrowed--;
            // console.log({n});
            result = n + result;
            i--;
        }
        // console.log({borrowed});
        // special rule for last one
        const achar = a[0 - aoffset] || "0";
        const bchar = b[0 - boffset] || "0";
        let n = Number(achar) - (borrowed > 0 ? 1 : 0) - Number(bchar);
        if (n !== 0) result = n + result;
        // remove any zeros in front like in 0123
        result = result.replace(/^0+/, "");
    }
    // if decimal number add zero
    if (result[0] === ".") result = "0" + result;
    return result;
}
$dd8977ef38db6c34$exports = $dd8977ef38db6c34$var$long_subtraction;
$dd8977ef38db6c34$exports.default = $dd8977ef38db6c34$var$long_subtraction;


function $f8a5576c27bdd239$var$add(a, b) {
    a = $f6234cb65e75e7df$exports(a);
    b = $f6234cb65e75e7df$exports(b);
    const apos = a[0] !== "-";
    const bpos = b[0] !== "-";
    if (apos && bpos) return $b74223d0182048b8$exports(a, b);
    else if (!apos && !bpos) return "-" + $b74223d0182048b8$exports(a.substring(1), b.substring(1));
    else if (!apos && bpos) {
        a = a.substring(1);
        switch($5192f89b16a7cf75$exports(a, b)){
            case "=":
                return "0";
            case "<":
                return $dd8977ef38db6c34$exports(b, a);
            case ">":
                return "-" + $dd8977ef38db6c34$exports(a, b);
        }
    } else if (apos && !bpos) {
        b = b.substring(1);
        switch($5192f89b16a7cf75$exports(a, b)){
            case "=":
                return "0";
            case "<":
                return "-" + $dd8977ef38db6c34$exports(b, a);
            case ">":
                return $dd8977ef38db6c34$exports(a, b);
        }
    }
}
$f8a5576c27bdd239$exports = $f8a5576c27bdd239$var$add;
$f8a5576c27bdd239$exports.default = $f8a5576c27bdd239$var$add;


var $c140608fa6ffaa42$exports = {};
"use strict";
var $b6ab9eb1aa61d8fa$exports = {};
"use strict";

function $b6ab9eb1aa61d8fa$var$absolute(n) {
    n = $f6234cb65e75e7df$exports(n);
    if (n[0] === "-") return n.substring(1);
    else return n;
}
$b6ab9eb1aa61d8fa$exports = $b6ab9eb1aa61d8fa$var$absolute;
$b6ab9eb1aa61d8fa$exports.default = $b6ab9eb1aa61d8fa$var$absolute;



var $d979634a8655aea7$exports = {};
"use strict";


var $bc5586d89a48b2ea$exports = {};
"use strict";




function $bc5586d89a48b2ea$var$subtract(a, b) {
    a = $f6234cb65e75e7df$exports(a);
    b = $f6234cb65e75e7df$exports(b);
    const a_is_positive = a[0] !== "-";
    const b_is_positive = b[0] !== "-";
    if (a_is_positive) {
        if (b_is_positive) {
            const comparison = $5192f89b16a7cf75$exports(a, b);
            if (comparison === ">") return $dd8977ef38db6c34$exports(a, b);
            else if (comparison === "<") return "-" + $dd8977ef38db6c34$exports(b, a);
            else return "0";
        } else return $b74223d0182048b8$exports(a, b.substring(1));
    } else if (b_is_positive) return "-" + $b74223d0182048b8$exports(a.substring(1), b);
    else {
        a = a.substring(1);
        b = b.substring(1);
        const comparison = $5192f89b16a7cf75$exports(a, b);
        if (comparison === ">") return "-" + $dd8977ef38db6c34$exports(a, b);
        else if (comparison === "<") return $dd8977ef38db6c34$exports(b, a);
        else return "0";
    }
}
$bc5586d89a48b2ea$exports = $bc5586d89a48b2ea$var$subtract;
$bc5586d89a48b2ea$exports.default = $bc5586d89a48b2ea$var$subtract;


var $616dc53ddd218fb5$exports = {};
"use strict";

var $7f946b854d7262aa$exports = {};
"use strict";
// given n is a decimal number
function $7f946b854d7262aa$var$truncate_decimal(n) {
    return n.substring(0, n.indexOf("."));
}
$7f946b854d7262aa$exports = $7f946b854d7262aa$var$truncate_decimal;
$7f946b854d7262aa$exports.default = $7f946b854d7262aa$var$truncate_decimal;


// given n is a positive decimal number
const $616dc53ddd218fb5$var$up = [
    "5",
    "6",
    "7",
    "8",
    "9"
];
function $616dc53ddd218fb5$var$round_last_decimal(n) {
    // will round up to an integer
    if (n.match(/\.9+$/)) return $f8a5576c27bdd239$exports($7f946b854d7262aa$exports(n), "1");
    // remove + from beginning
    if (n[0] === "+") n = n.substring(1);
    //console.log("rounding:", {n});
    const len = n.length;
    //console.log({len});
    let result = "";
    const last_char = n[n.length - 1];
    //console.log({last_char});
    if ($616dc53ddd218fb5$var$up.includes(last_char)) {
        let i;
        for(i = len - 2; i >= 0; i--){
            const char = n[i];
            //console.log({char});
            // skip over . or -
            if (char === "." || char === "-") continue;
            const nchar = Number(char) + 1;
            //console.log({nchar});
            if (nchar === 10) result = "0" + result;
            else {
                result = nchar + result;
                break;
            }
        }
        //console.log({i});
        if (i > 0) result = n.substring(0, i) + result;
    } else result = n.substring(0, len - 1);
    if (result[result.length - 1] === ".") result = result.substring(0, result.length - 1);
    // remove trailing zeros in decimal number
    // 0.50 => 0.5
    if (result.indexOf(".") > -1) result = result.replace(/0+$/, "");
    return result;
}
$616dc53ddd218fb5$exports = $616dc53ddd218fb5$var$round_last_decimal;
$616dc53ddd218fb5$exports.default = $616dc53ddd218fb5$var$round_last_decimal;


// given dividend and divisor are positive numberical strings
function $d979634a8655aea7$var$long_division(dividend, divisor, { max_decimal_digits: max_decimal_digits = 100, ellipsis: ellipsis = false } = {}) {
    // remove unnecessary starting zeros
    // ex: 0.5 => .5
    if (dividend[0] === "0") dividend = dividend.substring(1);
    if (divisor[0] === "0") divisor = divisor.substring(1);
    const dividend_index_of_dot = dividend.indexOf(".");
    const divisor_index_of_dot = divisor.indexOf(".");
    const adjusted_dividend_index_of_dot = dividend_index_of_dot === -1 ? dividend.length : dividend_index_of_dot;
    const divisor_num_decimal_places = divisor_index_of_dot === -1 ? 0 : divisor.length - 1 - divisor_index_of_dot;
    // whether the result has a repeating decimal
    // e.g. 1/3 is repeating as in "0.333..."
    let repeating = false;
    // remove decimals
    dividend = dividend.replace(/\./, "");
    divisor = divisor.replace(/\./, "");
    const dividend_length = dividend.length;
    let current = "";
    let quotient = "";
    let comparison;
    let offset = -1 * divisor_num_decimal_places;
    let skip = 0;
    for(let i = 0; i < dividend_length; i++){
        const char = dividend[i];
        current += char;
        comparison = $5192f89b16a7cf75$exports(current, divisor);
        if (comparison === ">") {
            // same as const times = Math.floor(current / divisor);
            // but without floating point problems
            let times = 1;
            let product = $f8a5576c27bdd239$exports(divisor, divisor);
            let passed_product = divisor;
            while($5192f89b16a7cf75$exports(product, current) !== ">"){
                times++;
                passed_product = product;
                product = $f8a5576c27bdd239$exports(product, divisor);
            }
            times = times.toString();
            if (quotient !== "") for(let i = times.length; i <= skip; i++)quotient += "0";
            quotient += times; // string concatentation
            current = $bc5586d89a48b2ea$exports(current, passed_product);
            skip = 0;
        } else if (comparison === "<") {
            if (quotient === "") offset++;
            skip++;
            continue;
        } else if (comparison === "=") {
            if (quotient !== "") for(let i = 0; i < skip; i++)quotient += "0";
            quotient += "1";
            current = "0";
            skip = 0;
        }
    }
    if (current.match(/^0+$/g)) {
        if (comparison === "<") quotient += current.substring(0, current.length - 1);
    } else {
        const previous = {};
        // keep dividing until we have an answer
        // figure out current place of decimal number
        const idot = adjusted_dividend_index_of_dot - offset;
        const qlen = quotient.length;
        // add 1 extra for rounding purposes
        const imax = idot - qlen + max_decimal_digits + 1;
        // reset skip if just "" so far because don't want to count 0 in 0.
        if (quotient === "") skip = 0;
        for(let i = 0; i < imax; i++){
            current += "0";
            if (ellipsis) {
                if (current in previous) {
                    previous[current]++;
                    if (previous[current] > 3) {
                        quotient += "...";
                        repeating = true;
                        break;
                    }
                } else previous[current] = 1;
            }
            const comparison = $5192f89b16a7cf75$exports(current, divisor);
            if (comparison === ">") {
                // inside greater than outside
                // how many times the divisor goes into the current
                let times = 1;
                let product = $f8a5576c27bdd239$exports(divisor, divisor);
                let passed_product = divisor;
                while($5192f89b16a7cf75$exports(product, current) !== ">"){
                    times++;
                    passed_product = product;
                    product = $f8a5576c27bdd239$exports(product, divisor);
                }
                times = times.toString();
                // pad left zeros
                for(let i = times.length; i <= skip; i++)quotient += "0";
                quotient += times; // string concatentation
                current = $bc5586d89a48b2ea$exports(current, passed_product);
                if (current === "0") break;
                skip = 0;
            } else if (comparison === "<") {
                // outside greater than inside
                skip++;
                continue;
            } else if (comparison === "=") {
                // fill in previous with zeros
                for(let i = 0; i < skip; i++)quotient += "0";
                quotient += "1";
                skip = 0;
                break;
            }
        }
    }
    // reinsert decimal place
    const idot = adjusted_dividend_index_of_dot - offset;
    const qlen = quotient.length;
    let num_decimals;
    if (idot === qlen) // integer number so don't do anything
    num_decimals = 0;
    else if (idot < 0) {
        quotient = "0." + "0".repeat(Math.abs(idot)) + quotient;
        num_decimals = qlen - idot; // idot is negative, so adding
    } else if (idot > qlen) {
        // add more zeros to integer
        for(let i = qlen; i < idot; i++)quotient += "0";
        num_decimals = 0;
    } else if (idot < qlen) {
        quotient = quotient.substring(0, idot) + "." + quotient.substring(idot);
        num_decimals = qlen - idot;
    } else if (idot === 0) {
        quotient = "0." + quotient;
        num_decimals = qlen;
    }
    // remove zeros from front
    // 03938.123 => 3938.123
    quotient = quotient.replace(/^0+/, "");
    // remove extra zeros from the end
    quotient = quotient.replace(/\.\d+0+$/, "");
    // round if necessary
    if (!repeating) {
        const extra_decimals = num_decimals - max_decimal_digits;
        if (extra_decimals > 0) quotient = $616dc53ddd218fb5$exports(quotient.substring(0, quotient.length - extra_decimals + 1));
    }
    if (quotient[0] === ".") quotient = "0" + quotient;
    return quotient;
}
$d979634a8655aea7$exports = $d979634a8655aea7$var$long_division;
$d979634a8655aea7$exports.default = $d979634a8655aea7$var$long_division;


function $c140608fa6ffaa42$var$divide(dividend, divisor, options) {
    dividend = $f6234cb65e75e7df$exports(dividend);
    divisor = $f6234cb65e75e7df$exports(divisor);
    if (divisor === "0") throw new Error("[preciso] division by zero");
    // sometimes dividend can be cleaned to ""
    if (dividend === "" || dividend === "0") return "0";
    const dividend_is_positive = dividend[0] !== "-";
    const divisor_is_positive = divisor[0] !== "-";
    const out_sign = dividend_is_positive !== divisor_is_positive ? "-" : "";
    if (!dividend_is_positive) dividend = $b6ab9eb1aa61d8fa$exports(dividend);
    if (!divisor_is_positive) divisor = $b6ab9eb1aa61d8fa$exports(divisor);
    return out_sign + $d979634a8655aea7$exports(dividend, divisor, options);
}
$c140608fa6ffaa42$exports = $c140608fa6ffaa42$var$divide;
$c140608fa6ffaa42$exports.default = $c140608fa6ffaa42$var$divide;


var $492646347db2c919$exports = {};
"use strict";



var $68da51f2ec86ff92$exports = {};
"use strict";

var $68da51f2ec86ff92$require$MAX_SAFE_INTEGER_LENGTH = $31d6263ad5b58057$exports.MAX_SAFE_INTEGER_LENGTH;
const $68da51f2ec86ff92$var$CHUNK_SIZE = 15;
/**
 *
 * @param {String} a - numerical string larger or equal to b
 * @param {String} b - numerical string smaller or equal to a
 * @returns {String} product - result of multiplying a with b
 */ function $68da51f2ec86ff92$var$long_multiplication(a, b) {
    if (a === "0" || b === "0") return "0";
    const top_index_of_dot = a.indexOf(".");
    const bottom_index_of_dot = b.indexOf(".");
    const a_num_integer_places = top_index_of_dot === -1 ? a.length : top_index_of_dot;
    const b_num_integer_places = bottom_index_of_dot === -1 ? b.length : bottom_index_of_dot;
    const max_total_num_integer_places = a_num_integer_places + b_num_integer_places;
    const a_num_decimal_places = top_index_of_dot === -1 ? 0 : a.length - 1 - top_index_of_dot;
    const b_num_decimal_places = bottom_index_of_dot === -1 ? 0 : b.length - 1 - bottom_index_of_dot;
    const out_num_decimal_places = a_num_decimal_places + b_num_decimal_places;
    if (out_num_decimal_places === 0 && max_total_num_integer_places < $68da51f2ec86ff92$require$MAX_SAFE_INTEGER_LENGTH) return (Number(a) * Number(b)).toFixed(0);
    // remove decimals
    const aint = a.replace(".", "");
    const bint = b.replace(".", "");
    const alen = aint.length;
    const blen = bint.length;
    const chunks = [];
    let i = alen;
    while(i >= 0){
        const end = i;
        const start = i -= $68da51f2ec86ff92$var$CHUNK_SIZE;
        const str = aint.substring(start, end);
        chunks.push([
            Number(str),
            str.length
        ]);
    }
    const partial_products = [];
    const partials = [];
    // for each number in multiplier
    for(let i = 0, ireverse = blen - 1; ireverse >= 0; ireverse--, i++){
        const bstr = bint[ireverse];
        const bnum = Number(bstr);
        let carried = 0;
        let partial = "";
        const ichunklast = chunks.length - 1;
        chunks.forEach(([chunk, chunklen], c)=>{
            const subpartial = carried + bnum * chunk;
            let subpartstr = subpartial.toString();
            const subpartcharlen = subpartstr.length;
            if (subpartcharlen > chunklen && c !== ichunklast) {
                const islice = -1 * chunklen;
                partial = subpartstr.slice(islice) + partial;
                carried = Number(subpartstr.slice(0, islice));
            } else {
                const imax = chunklen - subpartcharlen;
                for(let i = 0; i < imax; i++)subpartstr = "0" + subpartstr;
                carried = 0;
                partial = subpartstr + partial;
            }
        });
        // add number of zeros at end
        partial += "0".repeat(i);
        partial_products.push(partial);
        partials.push([
            Array.from(partial).map((char)=>Number(char)),
            partial.length
        ]);
    }
    // back to front, iterate through columns
    // and add partial products together
    const num_partials = partial_products.length;
    const number_of_columns = partials[partials.length - 1][1] + num_partials;
    let result = "";
    let carried = 0;
    for(let icol = 0; icol < number_of_columns; icol++){
        let sum = carried;
        const pmax = Math.min(icol, num_partials - 1);
        for(let p = 0; p <= pmax; p++){
            const [pnums, plen] = partials[p];
            const i = plen - 1 - icol;
            if (i >= 0) sum += pnums[i];
        }
        if (sum >= 10) {
            sum = sum.toString();
            result = sum[sum.length - 1] + result;
            carried = Number(sum.slice(0, -1));
        } else {
            result = sum + result;
            carried = 0;
        }
    }
    // add decimal back in
    if (out_num_decimal_places === 0) // integer
    // remove extra zeros
    result = result.replace(/^0+/, "");
    else {
        // decimal number
        const idot = result.length - out_num_decimal_places;
        result = result.substring(0, idot) + "." + result.substring(idot);
        // remove zeros from front
        result = result.replace(/^0+/, "");
        // remove extra zeros from the end
        result = result.replace(/\.?0+$/, "");
        if (result[0] === ".") result = "0" + result;
    }
    return result;
}
$68da51f2ec86ff92$exports = $68da51f2ec86ff92$var$long_multiplication;
$68da51f2ec86ff92$exports.default = $68da51f2ec86ff92$var$long_multiplication;


function $492646347db2c919$var$multiply(a, b) {
    a = $f6234cb65e75e7df$exports(a);
    b = $f6234cb65e75e7df$exports(b);
    const apos = a[0] !== "-";
    const bpos = b[0] !== "-";
    const out_sign = apos !== bpos ? "-" : "";
    a = $b6ab9eb1aa61d8fa$exports(a);
    b = $b6ab9eb1aa61d8fa$exports(b);
    const comparison = $5192f89b16a7cf75$exports(a, b);
    if (comparison === "<") {
        const aold = a;
        const bold = b;
        a = bold;
        b = aold;
    }
    return out_sign + $68da51f2ec86ff92$exports(a, b);
}
$492646347db2c919$exports = $492646347db2c919$var$multiply;
$492646347db2c919$exports.default = $492646347db2c919$var$multiply;



var $2717c6280c0c11e4$exports = {};
var $4acf49f6c3e67aec$exports = {};
// shim for using process in browser
var $4acf49f6c3e67aec$var$process = $4acf49f6c3e67aec$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $4acf49f6c3e67aec$var$cachedSetTimeout;
var $4acf49f6c3e67aec$var$cachedClearTimeout;
function $4acf49f6c3e67aec$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $4acf49f6c3e67aec$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $4acf49f6c3e67aec$var$cachedSetTimeout = setTimeout;
        else $4acf49f6c3e67aec$var$cachedSetTimeout = $4acf49f6c3e67aec$var$defaultSetTimout;
    } catch (e) {
        $4acf49f6c3e67aec$var$cachedSetTimeout = $4acf49f6c3e67aec$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $4acf49f6c3e67aec$var$cachedClearTimeout = clearTimeout;
        else $4acf49f6c3e67aec$var$cachedClearTimeout = $4acf49f6c3e67aec$var$defaultClearTimeout;
    } catch (e) {
        $4acf49f6c3e67aec$var$cachedClearTimeout = $4acf49f6c3e67aec$var$defaultClearTimeout;
    }
})();
function $4acf49f6c3e67aec$var$runTimeout(fun) {
    if ($4acf49f6c3e67aec$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($4acf49f6c3e67aec$var$cachedSetTimeout === $4acf49f6c3e67aec$var$defaultSetTimout || !$4acf49f6c3e67aec$var$cachedSetTimeout) && setTimeout) {
        $4acf49f6c3e67aec$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $4acf49f6c3e67aec$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $4acf49f6c3e67aec$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $4acf49f6c3e67aec$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $4acf49f6c3e67aec$var$runClearTimeout(marker) {
    if ($4acf49f6c3e67aec$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($4acf49f6c3e67aec$var$cachedClearTimeout === $4acf49f6c3e67aec$var$defaultClearTimeout || !$4acf49f6c3e67aec$var$cachedClearTimeout) && clearTimeout) {
        $4acf49f6c3e67aec$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $4acf49f6c3e67aec$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $4acf49f6c3e67aec$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $4acf49f6c3e67aec$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $4acf49f6c3e67aec$var$queue = [];
var $4acf49f6c3e67aec$var$draining = false;
var $4acf49f6c3e67aec$var$currentQueue;
var $4acf49f6c3e67aec$var$queueIndex = -1;
function $4acf49f6c3e67aec$var$cleanUpNextTick() {
    if (!$4acf49f6c3e67aec$var$draining || !$4acf49f6c3e67aec$var$currentQueue) return;
    $4acf49f6c3e67aec$var$draining = false;
    if ($4acf49f6c3e67aec$var$currentQueue.length) $4acf49f6c3e67aec$var$queue = $4acf49f6c3e67aec$var$currentQueue.concat($4acf49f6c3e67aec$var$queue);
    else $4acf49f6c3e67aec$var$queueIndex = -1;
    if ($4acf49f6c3e67aec$var$queue.length) $4acf49f6c3e67aec$var$drainQueue();
}
function $4acf49f6c3e67aec$var$drainQueue() {
    if ($4acf49f6c3e67aec$var$draining) return;
    var timeout = $4acf49f6c3e67aec$var$runTimeout($4acf49f6c3e67aec$var$cleanUpNextTick);
    $4acf49f6c3e67aec$var$draining = true;
    var len = $4acf49f6c3e67aec$var$queue.length;
    while(len){
        $4acf49f6c3e67aec$var$currentQueue = $4acf49f6c3e67aec$var$queue;
        $4acf49f6c3e67aec$var$queue = [];
        while(++$4acf49f6c3e67aec$var$queueIndex < len)if ($4acf49f6c3e67aec$var$currentQueue) $4acf49f6c3e67aec$var$currentQueue[$4acf49f6c3e67aec$var$queueIndex].run();
        $4acf49f6c3e67aec$var$queueIndex = -1;
        len = $4acf49f6c3e67aec$var$queue.length;
    }
    $4acf49f6c3e67aec$var$currentQueue = null;
    $4acf49f6c3e67aec$var$draining = false;
    $4acf49f6c3e67aec$var$runClearTimeout(timeout);
}
$4acf49f6c3e67aec$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $4acf49f6c3e67aec$var$queue.push(new $4acf49f6c3e67aec$var$Item(fun, args));
    if ($4acf49f6c3e67aec$var$queue.length === 1 && !$4acf49f6c3e67aec$var$draining) $4acf49f6c3e67aec$var$runTimeout($4acf49f6c3e67aec$var$drainQueue);
};
// v8 likes predictible objects
function $4acf49f6c3e67aec$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$4acf49f6c3e67aec$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$4acf49f6c3e67aec$var$process.title = "browser";
$4acf49f6c3e67aec$var$process.browser = true;
$4acf49f6c3e67aec$var$process.env = {};
$4acf49f6c3e67aec$var$process.argv = [];
$4acf49f6c3e67aec$var$process.version = ""; // empty string to avoid regexp issues
$4acf49f6c3e67aec$var$process.versions = {};
function $4acf49f6c3e67aec$var$noop() {}
$4acf49f6c3e67aec$var$process.on = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.addListener = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.once = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.off = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.removeListener = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.removeAllListeners = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.emit = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.prependListener = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.prependOnceListener = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.listeners = function(name) {
    return [];
};
$4acf49f6c3e67aec$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$4acf49f6c3e67aec$var$process.cwd = function() {
    return "/";
};
$4acf49f6c3e67aec$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$4acf49f6c3e67aec$var$process.umask = function() {
    return 0;
};


/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $24f87a6f86a8996f$export$a143d493d941bafc;
var $24f87a6f86a8996f$export$e4cf37d7f6fb9e0a;
var $24f87a6f86a8996f$export$f99ded8fe4b79145;
var $24f87a6f86a8996f$export$599f31c3813fae4d;
"use strict";
var $3caef5c332c7293f$export$a48f0734ac7c2329;
var $3caef5c332c7293f$export$d622b2ad8d90c771;
var $3caef5c332c7293f$export$6100ba28696e12de;
"use strict";
$3caef5c332c7293f$export$a48f0734ac7c2329 = $3caef5c332c7293f$var$byteLength;
$3caef5c332c7293f$export$d622b2ad8d90c771 = $3caef5c332c7293f$var$toByteArray;
$3caef5c332c7293f$export$6100ba28696e12de = $3caef5c332c7293f$var$fromByteArray;
var $3caef5c332c7293f$var$lookup = [];
var $3caef5c332c7293f$var$revLookup = [];
var $3caef5c332c7293f$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $3caef5c332c7293f$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $3caef5c332c7293f$var$i = 0, $3caef5c332c7293f$var$len = $3caef5c332c7293f$var$code.length; $3caef5c332c7293f$var$i < $3caef5c332c7293f$var$len; ++$3caef5c332c7293f$var$i){
    $3caef5c332c7293f$var$lookup[$3caef5c332c7293f$var$i] = $3caef5c332c7293f$var$code[$3caef5c332c7293f$var$i];
    $3caef5c332c7293f$var$revLookup[$3caef5c332c7293f$var$code.charCodeAt($3caef5c332c7293f$var$i)] = $3caef5c332c7293f$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$3caef5c332c7293f$var$revLookup["-".charCodeAt(0)] = 62;
$3caef5c332c7293f$var$revLookup["_".charCodeAt(0)] = 63;
function $3caef5c332c7293f$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $3caef5c332c7293f$var$byteLength(b64) {
    var lens = $3caef5c332c7293f$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $3caef5c332c7293f$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $3caef5c332c7293f$var$toByteArray(b64) {
    var tmp;
    var lens = $3caef5c332c7293f$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $3caef5c332c7293f$var$Arr($3caef5c332c7293f$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i)] << 18 | $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i)] << 2 | $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i)] << 10 | $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $3caef5c332c7293f$var$tripletToBase64(num) {
    return $3caef5c332c7293f$var$lookup[num >> 18 & 0x3F] + $3caef5c332c7293f$var$lookup[num >> 12 & 0x3F] + $3caef5c332c7293f$var$lookup[num >> 6 & 0x3F] + $3caef5c332c7293f$var$lookup[num & 0x3F];
}
function $3caef5c332c7293f$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($3caef5c332c7293f$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $3caef5c332c7293f$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($3caef5c332c7293f$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($3caef5c332c7293f$var$lookup[tmp >> 2] + $3caef5c332c7293f$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($3caef5c332c7293f$var$lookup[tmp >> 10] + $3caef5c332c7293f$var$lookup[tmp >> 4 & 0x3F] + $3caef5c332c7293f$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $56a54f6ebabce67d$export$aafa59e2e03f2942;
var $56a54f6ebabce67d$export$68d8715fc104d294;
$56a54f6ebabce67d$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$56a54f6ebabce67d$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


const $24f87a6f86a8996f$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$24f87a6f86a8996f$export$a143d493d941bafc = $24f87a6f86a8996f$var$Buffer;
$24f87a6f86a8996f$export$e4cf37d7f6fb9e0a = $24f87a6f86a8996f$var$SlowBuffer;
$24f87a6f86a8996f$export$f99ded8fe4b79145 = 50;
const $24f87a6f86a8996f$var$K_MAX_LENGTH = 0x7fffffff;
$24f87a6f86a8996f$export$599f31c3813fae4d = $24f87a6f86a8996f$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $24f87a6f86a8996f$var$Buffer.TYPED_ARRAY_SUPPORT = $24f87a6f86a8996f$var$typedArraySupport();
if (!$24f87a6f86a8996f$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $24f87a6f86a8996f$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($24f87a6f86a8996f$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$24f87a6f86a8996f$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($24f87a6f86a8996f$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$24f87a6f86a8996f$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $24f87a6f86a8996f$var$createBuffer(length) {
    if (length > $24f87a6f86a8996f$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $24f87a6f86a8996f$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $24f87a6f86a8996f$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $24f87a6f86a8996f$var$allocUnsafe(arg);
    }
    return $24f87a6f86a8996f$var$from(arg, encodingOrOffset, length);
}
$24f87a6f86a8996f$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $24f87a6f86a8996f$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $24f87a6f86a8996f$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $24f87a6f86a8996f$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($24f87a6f86a8996f$var$isInstance(value, ArrayBuffer) || value && $24f87a6f86a8996f$var$isInstance(value.buffer, ArrayBuffer)) return $24f87a6f86a8996f$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($24f87a6f86a8996f$var$isInstance(value, SharedArrayBuffer) || value && $24f87a6f86a8996f$var$isInstance(value.buffer, SharedArrayBuffer))) return $24f87a6f86a8996f$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $24f87a6f86a8996f$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $24f87a6f86a8996f$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $24f87a6f86a8996f$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $24f87a6f86a8996f$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $24f87a6f86a8996f$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($24f87a6f86a8996f$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($24f87a6f86a8996f$var$Buffer, Uint8Array);
function $24f87a6f86a8996f$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $24f87a6f86a8996f$var$alloc(size, fill, encoding) {
    $24f87a6f86a8996f$var$assertSize(size);
    if (size <= 0) return $24f87a6f86a8996f$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $24f87a6f86a8996f$var$createBuffer(size).fill(fill, encoding) : $24f87a6f86a8996f$var$createBuffer(size).fill(fill);
    return $24f87a6f86a8996f$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $24f87a6f86a8996f$var$Buffer.alloc = function(size, fill, encoding) {
    return $24f87a6f86a8996f$var$alloc(size, fill, encoding);
};
function $24f87a6f86a8996f$var$allocUnsafe(size) {
    $24f87a6f86a8996f$var$assertSize(size);
    return $24f87a6f86a8996f$var$createBuffer(size < 0 ? 0 : $24f87a6f86a8996f$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $24f87a6f86a8996f$var$Buffer.allocUnsafe = function(size) {
    return $24f87a6f86a8996f$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $24f87a6f86a8996f$var$Buffer.allocUnsafeSlow = function(size) {
    return $24f87a6f86a8996f$var$allocUnsafe(size);
};
function $24f87a6f86a8996f$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$24f87a6f86a8996f$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $24f87a6f86a8996f$var$byteLength(string, encoding) | 0;
    let buf = $24f87a6f86a8996f$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $24f87a6f86a8996f$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $24f87a6f86a8996f$var$checked(array.length) | 0;
    const buf = $24f87a6f86a8996f$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $24f87a6f86a8996f$var$fromArrayView(arrayView) {
    if ($24f87a6f86a8996f$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $24f87a6f86a8996f$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $24f87a6f86a8996f$var$fromArrayLike(arrayView);
}
function $24f87a6f86a8996f$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $24f87a6f86a8996f$var$Buffer.prototype);
    return buf;
}
function $24f87a6f86a8996f$var$fromObject(obj) {
    if ($24f87a6f86a8996f$var$Buffer.isBuffer(obj)) {
        const len = $24f87a6f86a8996f$var$checked(obj.length) | 0;
        const buf = $24f87a6f86a8996f$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $24f87a6f86a8996f$var$numberIsNaN(obj.length)) return $24f87a6f86a8996f$var$createBuffer(0);
        return $24f87a6f86a8996f$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $24f87a6f86a8996f$var$fromArrayLike(obj.data);
}
function $24f87a6f86a8996f$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $24f87a6f86a8996f$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $24f87a6f86a8996f$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $24f87a6f86a8996f$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $24f87a6f86a8996f$var$Buffer.alloc(+length);
}
$24f87a6f86a8996f$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $24f87a6f86a8996f$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$24f87a6f86a8996f$var$Buffer.compare = function compare(a, b) {
    if ($24f87a6f86a8996f$var$isInstance(a, Uint8Array)) a = $24f87a6f86a8996f$var$Buffer.from(a, a.offset, a.byteLength);
    if ($24f87a6f86a8996f$var$isInstance(b, Uint8Array)) b = $24f87a6f86a8996f$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$24f87a6f86a8996f$var$Buffer.isBuffer(a) || !$24f87a6f86a8996f$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$24f87a6f86a8996f$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$24f87a6f86a8996f$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $24f87a6f86a8996f$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $24f87a6f86a8996f$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($24f87a6f86a8996f$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$24f87a6f86a8996f$var$Buffer.isBuffer(buf)) buf = $24f87a6f86a8996f$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$24f87a6f86a8996f$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $24f87a6f86a8996f$var$byteLength(string, encoding) {
    if ($24f87a6f86a8996f$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $24f87a6f86a8996f$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $24f87a6f86a8996f$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $24f87a6f86a8996f$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $24f87a6f86a8996f$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$24f87a6f86a8996f$var$Buffer.byteLength = $24f87a6f86a8996f$var$byteLength;
function $24f87a6f86a8996f$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $24f87a6f86a8996f$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $24f87a6f86a8996f$var$utf8Slice(this, start, end);
        case "ascii":
            return $24f87a6f86a8996f$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $24f87a6f86a8996f$var$latin1Slice(this, start, end);
        case "base64":
            return $24f87a6f86a8996f$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $24f87a6f86a8996f$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$24f87a6f86a8996f$var$Buffer.prototype._isBuffer = true;
function $24f87a6f86a8996f$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$24f87a6f86a8996f$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$24f87a6f86a8996f$var$swap(this, i, i + 1);
    return this;
};
$24f87a6f86a8996f$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $24f87a6f86a8996f$var$swap(this, i, i + 3);
        $24f87a6f86a8996f$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$24f87a6f86a8996f$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $24f87a6f86a8996f$var$swap(this, i, i + 7);
        $24f87a6f86a8996f$var$swap(this, i + 1, i + 6);
        $24f87a6f86a8996f$var$swap(this, i + 2, i + 5);
        $24f87a6f86a8996f$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$24f87a6f86a8996f$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $24f87a6f86a8996f$var$utf8Slice(this, 0, length);
    return $24f87a6f86a8996f$var$slowToString.apply(this, arguments);
};
$24f87a6f86a8996f$var$Buffer.prototype.toLocaleString = $24f87a6f86a8996f$var$Buffer.prototype.toString;
$24f87a6f86a8996f$var$Buffer.prototype.equals = function equals(b) {
    if (!$24f87a6f86a8996f$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $24f87a6f86a8996f$var$Buffer.compare(this, b) === 0;
};
$24f87a6f86a8996f$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $24f87a6f86a8996f$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($24f87a6f86a8996f$var$customInspectSymbol) $24f87a6f86a8996f$var$Buffer.prototype[$24f87a6f86a8996f$var$customInspectSymbol] = $24f87a6f86a8996f$var$Buffer.prototype.inspect;
$24f87a6f86a8996f$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($24f87a6f86a8996f$var$isInstance(target, Uint8Array)) target = $24f87a6f86a8996f$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$24f87a6f86a8996f$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $24f87a6f86a8996f$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($24f87a6f86a8996f$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $24f87a6f86a8996f$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($24f87a6f86a8996f$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $24f87a6f86a8996f$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $24f87a6f86a8996f$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $24f87a6f86a8996f$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$24f87a6f86a8996f$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$24f87a6f86a8996f$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $24f87a6f86a8996f$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$24f87a6f86a8996f$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $24f87a6f86a8996f$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $24f87a6f86a8996f$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($24f87a6f86a8996f$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $24f87a6f86a8996f$var$utf8Write(buf, string, offset, length) {
    return $24f87a6f86a8996f$var$blitBuffer($24f87a6f86a8996f$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $24f87a6f86a8996f$var$asciiWrite(buf, string, offset, length) {
    return $24f87a6f86a8996f$var$blitBuffer($24f87a6f86a8996f$var$asciiToBytes(string), buf, offset, length);
}
function $24f87a6f86a8996f$var$base64Write(buf, string, offset, length) {
    return $24f87a6f86a8996f$var$blitBuffer($24f87a6f86a8996f$var$base64ToBytes(string), buf, offset, length);
}
function $24f87a6f86a8996f$var$ucs2Write(buf, string, offset, length) {
    return $24f87a6f86a8996f$var$blitBuffer($24f87a6f86a8996f$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$24f87a6f86a8996f$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $24f87a6f86a8996f$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $24f87a6f86a8996f$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $24f87a6f86a8996f$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $24f87a6f86a8996f$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $24f87a6f86a8996f$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$24f87a6f86a8996f$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $24f87a6f86a8996f$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $3caef5c332c7293f$export$6100ba28696e12de(buf);
    else return $3caef5c332c7293f$export$6100ba28696e12de(buf.slice(start, end));
}
function $24f87a6f86a8996f$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $24f87a6f86a8996f$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $24f87a6f86a8996f$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $24f87a6f86a8996f$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $24f87a6f86a8996f$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $24f87a6f86a8996f$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $24f87a6f86a8996f$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $24f87a6f86a8996f$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $24f87a6f86a8996f$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $24f87a6f86a8996f$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $24f87a6f86a8996f$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$24f87a6f86a8996f$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $24f87a6f86a8996f$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $24f87a6f86a8996f$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$24f87a6f86a8996f$var$Buffer.prototype.readUintLE = $24f87a6f86a8996f$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$24f87a6f86a8996f$var$Buffer.prototype.readUintBE = $24f87a6f86a8996f$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$24f87a6f86a8996f$var$Buffer.prototype.readUint8 = $24f87a6f86a8996f$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$24f87a6f86a8996f$var$Buffer.prototype.readUint16LE = $24f87a6f86a8996f$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$24f87a6f86a8996f$var$Buffer.prototype.readUint16BE = $24f87a6f86a8996f$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$24f87a6f86a8996f$var$Buffer.prototype.readUint32LE = $24f87a6f86a8996f$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$24f87a6f86a8996f$var$Buffer.prototype.readUint32BE = $24f87a6f86a8996f$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$24f87a6f86a8996f$var$Buffer.prototype.readBigUInt64LE = $24f87a6f86a8996f$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $24f87a6f86a8996f$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $24f87a6f86a8996f$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$24f87a6f86a8996f$var$Buffer.prototype.readBigUInt64BE = $24f87a6f86a8996f$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $24f87a6f86a8996f$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $24f87a6f86a8996f$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$24f87a6f86a8996f$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$24f87a6f86a8996f$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$24f87a6f86a8996f$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$24f87a6f86a8996f$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$24f87a6f86a8996f$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$24f87a6f86a8996f$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$24f87a6f86a8996f$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$24f87a6f86a8996f$var$Buffer.prototype.readBigInt64LE = $24f87a6f86a8996f$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $24f87a6f86a8996f$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $24f87a6f86a8996f$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$24f87a6f86a8996f$var$Buffer.prototype.readBigInt64BE = $24f87a6f86a8996f$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $24f87a6f86a8996f$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $24f87a6f86a8996f$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$24f87a6f86a8996f$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 4, this.length);
    return $56a54f6ebabce67d$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$24f87a6f86a8996f$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 4, this.length);
    return $56a54f6ebabce67d$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$24f87a6f86a8996f$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 8, this.length);
    return $56a54f6ebabce67d$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$24f87a6f86a8996f$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 8, this.length);
    return $56a54f6ebabce67d$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $24f87a6f86a8996f$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$24f87a6f86a8996f$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$24f87a6f86a8996f$var$Buffer.prototype.writeUintLE = $24f87a6f86a8996f$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $24f87a6f86a8996f$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeUintBE = $24f87a6f86a8996f$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $24f87a6f86a8996f$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeUint8 = $24f87a6f86a8996f$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeUint16LE = $24f87a6f86a8996f$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeUint16BE = $24f87a6f86a8996f$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeUint32LE = $24f87a6f86a8996f$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeUint32BE = $24f87a6f86a8996f$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $24f87a6f86a8996f$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $24f87a6f86a8996f$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $24f87a6f86a8996f$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $24f87a6f86a8996f$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$24f87a6f86a8996f$var$Buffer.prototype.writeBigUInt64LE = $24f87a6f86a8996f$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $24f87a6f86a8996f$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$24f87a6f86a8996f$var$Buffer.prototype.writeBigUInt64BE = $24f87a6f86a8996f$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $24f87a6f86a8996f$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$24f87a6f86a8996f$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $24f87a6f86a8996f$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $24f87a6f86a8996f$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeBigInt64LE = $24f87a6f86a8996f$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $24f87a6f86a8996f$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$24f87a6f86a8996f$var$Buffer.prototype.writeBigInt64BE = $24f87a6f86a8996f$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $24f87a6f86a8996f$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $24f87a6f86a8996f$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $24f87a6f86a8996f$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $56a54f6ebabce67d$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$24f87a6f86a8996f$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $24f87a6f86a8996f$var$writeFloat(this, value, offset, true, noAssert);
};
$24f87a6f86a8996f$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $24f87a6f86a8996f$var$writeFloat(this, value, offset, false, noAssert);
};
function $24f87a6f86a8996f$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $56a54f6ebabce67d$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$24f87a6f86a8996f$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $24f87a6f86a8996f$var$writeDouble(this, value, offset, true, noAssert);
};
$24f87a6f86a8996f$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $24f87a6f86a8996f$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$24f87a6f86a8996f$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$24f87a6f86a8996f$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$24f87a6f86a8996f$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$24f87a6f86a8996f$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $24f87a6f86a8996f$var$Buffer.isBuffer(val) ? val : $24f87a6f86a8996f$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $24f87a6f86a8996f$var$errors = {};
function $24f87a6f86a8996f$var$E(sym, getMessage, Base) {
    $24f87a6f86a8996f$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$24f87a6f86a8996f$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$24f87a6f86a8996f$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$24f87a6f86a8996f$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $24f87a6f86a8996f$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $24f87a6f86a8996f$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $24f87a6f86a8996f$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $24f87a6f86a8996f$var$checkBounds(buf, offset, byteLength) {
    $24f87a6f86a8996f$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $24f87a6f86a8996f$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $24f87a6f86a8996f$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $24f87a6f86a8996f$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $24f87a6f86a8996f$var$checkBounds(buf, offset, byteLength);
}
function $24f87a6f86a8996f$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $24f87a6f86a8996f$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $24f87a6f86a8996f$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $24f87a6f86a8996f$var$validateNumber(value, type);
        throw new $24f87a6f86a8996f$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $24f87a6f86a8996f$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $24f87a6f86a8996f$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $24f87a6f86a8996f$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $24f87a6f86a8996f$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($24f87a6f86a8996f$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $24f87a6f86a8996f$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $24f87a6f86a8996f$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $24f87a6f86a8996f$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $24f87a6f86a8996f$var$base64ToBytes(str) {
    return $3caef5c332c7293f$export$d622b2ad8d90c771($24f87a6f86a8996f$var$base64clean(str));
}
function $24f87a6f86a8996f$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $24f87a6f86a8996f$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $24f87a6f86a8996f$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $24f87a6f86a8996f$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $24f87a6f86a8996f$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $24f87a6f86a8996f$var$BufferBigIntNotDefined : fn;
}
function $24f87a6f86a8996f$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}


var $2717c6280c0c11e4$require$Buffer = $24f87a6f86a8996f$export$a143d493d941bafc;
!function(t, e) {
    $2717c6280c0c11e4$exports = e();
}("undefined" != typeof self ? self : $2717c6280c0c11e4$exports, function() {
    return function(t) {
        var e = {};
        function o(r) {
            if (e[r]) return e[r].exports;
            var n = e[r] = {
                i: r,
                l: !1,
                exports: {}
            };
            return t[r].call(n.exports, n, n.exports, o), n.l = !0, n.exports;
        }
        return o.m = t, o.c = e, o.d = function(t, e, r) {
            o.o(t, e) || Object.defineProperty(t, e, {
                enumerable: !0,
                get: r
            });
        }, o.r = function(t) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(t, "__esModule", {
                value: !0
            });
        }, o.t = function(t, e) {
            if (1 & e && (t = o(t)), 8 & e) return t;
            if (4 & e && "object" == typeof t && t && t.__esModule) return t;
            var r = Object.create(null);
            if (o.r(r), Object.defineProperty(r, "default", {
                enumerable: !0,
                value: t
            }), 2 & e && "string" != typeof t) for(var n in t)o.d(r, n, (function(e) {
                return t[e];
            }).bind(null, n));
            return r;
        }, o.n = function(t) {
            var e = t && t.__esModule ? function() {
                return t.default;
            } : function() {
                return t;
            };
            return o.d(e, "a", e), e;
        }, o.o = function(t, e) {
            return Object.prototype.hasOwnProperty.call(t, e);
        }, o.p = "", o(o.s = 1);
    }([
        function(t, e, o) {
            const r = o(5);
            t.exports = function(t, e, o) {
                const n = o && o.debug || !1, a = o && o.startIndex || 0;
                n && console.log("starting findTag with", e, " and ", o);
                const i = r(t, `<${e}[ >]`, a);
                if (n && console.log("start:", i), -1 === i) return;
                const s = i + e.length + r(t.slice(i + e.length), "[ /]" + e + ">", 0) + 1 + e.length + 1;
                if (n && console.log("end:", s), -1 === s) return;
                const C = t.slice(i, s);
                return {
                    inner: C.slice(C.indexOf(">") + 1, C.lastIndexOf("<")),
                    outer: C,
                    start: i,
                    end: s
                };
            };
        },
        function(t, e, o) {
            var r = o(2), n = o(0), a = o(6), i = o(12).default, s = o(7), C = o(8), E = (C.ARRAY_TYPE, C.EXCLUDED_FORMATS), d = C.BYTES_PER_VALUE, f = C.DATA_VIEW_READER_NAME, D = C.FORMATS, c = C.HASHED_FIELDS, g = C.NUM_FIELDS, l = (C.NUM_HASHED_FIELDS, C.UNSUPPORTED_MSG), p = D.ESRI_WKT, A = D.GEOSERVER, u = D.MAPFILE, Q = D.MAPNIK, h = D.OGC_GML, R = D.OGC_XML, G = D.OGC_WKT, I = D.POSTGIS, x = D.PROJ_4, w = D.PROJ_4_JS, M = o(9), m = new DataView(M), B = o(11).hash, F = [
                "PROJECTEDCRS",
                "PROJCRS",
                "GEOGCS",
                "GEOCCS",
                "PROJCS",
                "LOCAL_CS",
                "GEODCRS",
                "GEODETICCRS",
                "GEODETICDATUM",
                "ENGCRS",
                "ENGINEERINGCRS"
            ];
            function O(t) {
                return function(t) {
                    return !(!(t = t.trim()).startsWith("PROJCS[") && !t.startsWith("GEOGCS[")) && F.some(function(e) {
                        return t.includes(e);
                    });
                }(t) ? t.includes("AUTHORITY") ? G : p : t.includes("gml:ProjectedCRS") || t.includes("gml:GeodeticCRS") || t.includes("gml:GeographicCRS") ? t.includes("gml:srsID") ? R : h : t.startsWith("+proj=") ? x : t.startsWith('proj4.defs("EPSG:') ? w : /^\d{1,6}\=(PROJCS|GEOGCS)/.test(t) ? A : t.startsWith("PROJECTION") && t.endsWith("END") ? u : t.endsWith("</Map>") ? Q : t.startsWith("INSERT") ? I : "SOMETHING ELSE";
            }
            function k(t, e, o) {
                o && console.log("looking up " + e);
                var r = B(t);
                o && console.log("hashed:", r);
                var n = c.indexOf(e) + 1;
                o && console.log("offset:", n);
                for(var a = n * d; a < M.byteLength; a += g * d){
                    if (r === m[f](a, !0)) return m[f](a - n * d, !0);
                }
            }
            function T(t, e) {
                var o = !(!e || !e.debug) && e.debug, C = O(t);
                if (o && console.log("dataType:", C), o && console.log("EXCLUDED_FORMATS:", E), E.includes(C.toLowerCase())) throw new Error(l.replace("{}", C));
                if (C === G) {
                    var d = i(t);
                    if (o && console.log("parsed:", d), d.AUTHORITY) {
                        var f = d.AUTHORITY;
                        return Number(f.epsg || f.EPSG);
                    }
                } else {
                    if (C == p) {
                        var D = i(t);
                        if (o && console.log("parsed:", D), D.name.match(/^WGS_1984_UTM_Zone_\d{1,2}(N|S)$/)) {
                            var c = D.name.split("_").pop(), g = c.substring(0, c.length - 1), M = "N" == c.substr(-1) ? 6 : 7;
                            return Number.parseInt("32" + M + g);
                        }
                        return k(t = s(t), p, !1);
                    }
                    if (C === h) {
                        var m = n(t, "gml:identifier", {
                            debug: o
                        }).inner;
                        return Number(m.replace("urn:ogc:def:crs:EPSG::", ""));
                    }
                    if (C === R) return Number(r(t, [
                        "gml:srsID",
                        "gml:name"
                    ], {
                        debug: o
                    }).inner);
                    if (C === x) {
                        if (t.startsWith("+proj=utm")) {
                            var B = t.split(" ").find(function(t) {
                                return t.startsWith("+zone=");
                            }).split("=")[1], F = t.includes("+south") ? "7" : "6";
                            return Number.parseInt("32" + F + B);
                        }
                        return k(t, x);
                    }
                    if (C === w) return Number(t.substring(17, t.indexOf('"', 17)));
                    if (C === A) return Number(t.match(/^\d{1,6}/)[0]);
                    if (C === u) {
                        if (t.includes("init=epsg:")) return Number.parseInt(/("init\=epsg:)(\d{1,10})(")/.exec(t)[2]);
                        if (t.includes('"proj=utm"')) {
                            var Z = /("zone\=)(\d{1,2})(")/.exec(t)[2], H = t.includes('"south"') ? "7" : "6";
                            return Number.parseInt("32" + H + Z);
                        }
                        return k(t, u);
                    }
                    if (C === Q) {
                        var U = n(t, "Map");
                        return T(a(U.outer, "srs"));
                    }
                    if (C === I) return Number(t.substring(t.indexOf("values (") + 8, t.indexOf("EPSG") - 3).trim());
                }
            }
            void 0 !== t.exports && (t.exports = T), "undefined" != typeof window ? window.getEPSGCode = T : "undefined" != typeof self && (self.getEPSGCode = T);
        },
        function(t, e, o) {
            const r = o(3);
            t.exports = function(t, e, o) {
                const n = o && o.debug || !1, a = r(t, e, {
                    debug: n,
                    returnOnFirst: !0
                });
                return Array.isArray(a) && 1 === a.length ? a[0] : void 0;
            };
        },
        function(t, e, o) {
            const r = o(4);
            t.exports = function(t, e, o) {
                const n = o && o.debug || !1, a = o && o.returnOnFirst || !1;
                let i = r(t, e.shift(), {
                    debug: n
                });
                n && console.log("first tags are:", i);
                for(let t = 0; t < e.length; t++){
                    const o = e[t];
                    let s = [];
                    for(let C = 0; C < i.length; C++){
                        const E = i[C], d = r(E.outer, o, {
                            debug: n,
                            startIndex: 1
                        });
                        if (d.length > 0) {
                            if (d.forEach((t)=>{
                                t.start += E.start, t.end += E.start;
                            }), a && t === e.length - 1) return [
                                d[0]
                            ];
                            s = s.concat(d);
                        }
                    }
                    i = s;
                }
                return i;
            };
        },
        function(t, e, o) {
            const r = o(0);
            t.exports = function(t, e, o) {
                const n = [], a = o && o.debug || !1;
                let i, s = o && o.startIndex || 0;
                for(; i = r(t, e, {
                    debug: a,
                    startIndex: s
                });)s = i.end, n.push(i);
                return n;
            };
        },
        function(t, e) {
            t.exports = function(t, e, o) {
                const r = new RegExp(e).exec(t.slice(o));
                return r ? o + r.index : -1;
            };
        },
        function(t, e) {
            t.exports = function(t, e, o) {
                const r = o && o.debug || !1;
                r && console.log("getting " + e + " in " + t);
                const n = "object" == typeof t ? t.outer : t, a = `${e}\\="(.*)"`;
                r && console.log("pattern:", a);
                const i = new RegExp(a).exec(n);
                if (i) return i[1];
            };
        },
        function(t, e) {
            t.exports = function(t) {
                return t = (t = t.replace('DATUM["D_', 'DATUM["')).replace(/\.\d{16,}/g, function(t) {
                    return t.substr(0, 16);
                });
            };
        },
        function(t, e) {
            var o = [
                "esriwkt",
                "mapfile",
                "proj4"
            ], r = o;
            "undefined" != typeof $4acf49f6c3e67aec$exports && $4acf49f6c3e67aec$exports.env;
            var n = [];
            "undefined" != typeof $4acf49f6c3e67aec$exports && $4acf49f6c3e67aec$exports.env, r.includes("esriwkt") || n.push("esriwkt"), r.includes("mapfile") || n.push("mapfile"), r.includes("proj4") || (n.push("mapnik"), n.push("proj4")), n.sort();
            var a = r.length, i = a + 1, s = Int16Array;
            t.exports = {
                ARRAY_TYPE: s,
                DATA_VIEW_READER_NAME: "getInt16",
                BYTES_PER_VALUE: 2,
                DEFAULT_HASHED_FIELDS: o,
                EXCLUDED_FORMATS: n,
                FORMATS: {
                    ESRI_WKT: "esriwkt",
                    GEOSERVER: "geoserver",
                    MAPFILE: "mapfile",
                    MAPNIK: "mapnik",
                    OGC_GML: "gml",
                    OGC_XML: "xml",
                    OGC_WKT: "wkt",
                    POSTGIS: "postgis",
                    PROJ_4: "proj4",
                    PROJ_4_JS: "js"
                },
                HASHED_FIELDS: r,
                NUM_HASHED_FIELDS: a,
                NUM_FIELDS: i,
                UNSUPPORTED_MSG: "[get-epsg-code] {} format not supported"
            };
        },
        function(t, e, o) {
            t.exports = o(10)("5hB9Zw2Ck9AKEi6BFEeSwwYeyJESZ7FwzRzIkWu2inbjG60iVH8SIOAbrSJUfxIg3RvIkRJnsXCuG8iREmexcKwbyJESZ7FwoRvIkRJnsXCBG8iREmexcH8byJESZ7FwfRvIkRJnsXB7G8iREmexcE4byJESZ7FwRxvIkRJnsXDuGhgkWOXZa+waGCTajDtB4xoT3SpAjzjiGhgkTzSewOEaGCRKZmPhfxrIkRJnsXAyGsiRa7aKdgwayJESZ7Fw3RjIkWu2ina1GMiREmexcLIYyJESZ7FwrhjIkRJnsXCnGK0iQLawDT8Ya/fk9/2N9xcXomu2inb+FpLFEmexcDEWuWge+74p2RUVM2u2ina5FcYFB8BIgKoVmWdrtop2lxWj8UbkR8KUFUaxigOljXEVV9hrtop2WxX02UBqIKdYFdLpPqP+wEsVrTwODRGfERXDIWu2inYFFZQfkMavqf0U7Y5rtop2+xRMa2u2inb1FONNkMavqfAUvptrtop26hRVTWu2inbcFO9ja7aKdswU00hrtop2kBSoGGu2inaEFCu4a7aKdn4UGWQSZ7FwcRQya5ObVFJtFLcnYajK4mwUlu9SZ2EkDBS1tB77vimVEwa8a7aKdigTayQLvV6RJxN9Uj0EwEwlEx330FJlo9gSMlWKA6WN1xIE1IoDpY3VEoghMMtAsdQSdfkPY6DQ0hIp/UdOCRPREkI2JY6LiNASYfb64PQnzxJXjwZwY+vOEvylv2jc6M0Suac0DHoVyxI5Ho8027TKEqQT5icELckS5uXkp0DSyBIrA5aP58DHEsGCQhi1L8YSH+pL+UnDxRLz7DEerN3EEsvYqOW9eMMSMZtExBvewhLVJyPbuzfBEmkIeqosYp0SOk5rtop2nBJ6Wmu2inabEg73kMavqZoSvUWQxq+pmRLCiGu2inaYEhEuhJfb3pcSGaJrtop2lhK51JDGr6mVEiPbVH8SIJQStW+YVUS+kxJY5JDGr6mSEteMjjzMC5ESAJmKA6WNkBJgPl6YXQiPEh1jGh+mGY4S5oIo8vskjRKjfGu2inaMEv9mXphdCIsSYTtrtop2ihKDFh77vimJEnaEHvu+KYgSUGtpDzAXhxILJyr5S62GEk55EmexcIUSSlGKA6WNhBK4tyvv7MmDEgAFVZo7WoISDYI+o/7AgRK76Wu2inaAEtfRk3XyR38SUVZjMwRmfhIFWqZBYdh9Ek6qqelfP3wSklsBtXHRehJ2pHS58Yd5EvpRq2JpingS1IcvsssbdxJfx5jSLQl2EgfydjMnkXUSwD8nNs0bdBK4uTAYImBzEsBhqWVaZXISGbKzfru2cRJ6PUEbVjVwEuDvo6I9Ym8SqCycMYD2bhKr2o2s82htEhEtzlztd2wStYGgmDjraxIpPnajK+pqEsnHY4WALmkSUiLBxfB1aBJDT8V2iGtnEipSOPqWOWYSLKF9uYW4ZRKIQp7qT65kElepmlidZmMSXNK3Pf+kYhIV/rysy3xhEgzDigOljWASo/2KA6WNXxIa3WkPMBdeEmoXa7aKdl0SGihQK7PbXBLqGGkPMBdbEo2ICZhVuVoS5E2gSCDZWRJQg2kPMBdYEiYXaQ8wF1cSgWLkTKYsVhJrwZDGr6lVEgvoMrgMP1QSO8DyHQefUxJPBASdstxSEkpQyzU86lESFUI5VfTUUBKtnoePvHpPEgJHiDoJBU4Sh5Nrtop2TBIvKyueY+NLEkslNk0gAEoS9PstKLQxSBIaqzj11LdHEsQzyGKhX0YSkDXrYR8+RRKDADTK569EEm8QNMrnr0MSaVok05fBQhLXpWu2inZBEv8PINMp0kAS4mBBDm06PxLJXdZoD9c+EnrUkMavqT0S6khrtop2PBIYbco8cb47Er8fkMavqToSlnFIN1/tORI0sFTEXNM4EgWdLFwoTTcSaOvK+mbDNhI3jQyy0l81Ejh4a7aKdjQSZbEdQNG8MxL3b2u2inYyEohzGLyyODESDVFrG03gJhLoHFPGJOgkEvwwq06OHSMSPrdWUzpvIhK5qg3fm6IhEp/6yjqM1B8SVlXnfrGeHhJWxTDwKDkdEspN+eA4dRwSuH0S5+DHGRJbL4N6uF0YEgGK0+DjiBYSMF1CIHWrFRJRdB4m0bEUEktHKgzoyxMSO/Nrtop2EhL+y/h8ru8RElKWG2b9UhASjEBrtop2DxIhrljCA/cOElujL4kLrQ0SSeIDk/D6DBIRb9TpaaYLEt0Ma7aKdgkS7xZrtop2CBLi/KT881wHElGoYIbiAQYSAXT0X/sKBRI6r68TV1EEEt3Ya7aKdgMS3q76LyebAhI7JK1OuIMBElOjQGogpwASofZAaiCn/xEGrxtSYG7+EaIrQqRPcP0Rag7JV9zY/BG8fEMFFRj7EZvxcVKZafoRLhlXR5iD+REl4sN0WUv4EWXbaQ8wF84RYc1rtop2yxF4OjTK56+KEZBGEmexcIMRZttrtop2exF7EosUfqF2ETLka7aKdm8RL+Jrtop25BCoPUMZTHLiEFado6I9Yt8QBx71lKwA3hAOWcTDytncEDgKyVIwB9sQjKlZzqSr2hDAxs/Pk/7ZEMWkZR7dxdgQ8r40Xk8V1xB5r8+CRWDWEJdc1mgP19UQ1v00OHoU1BAZUx77vinTENDodrrkJdIQqVge+74p0BDpkE0PHsnPEP9zYtQQkM4Q47mwNV5PzRBxmTYomJHMEHEcDmLfIMsQYnQOYt8gyhDJnH7+kfDJEMOg7stLmccQxrke+74pxRA2tA9z8zfEEN+QzU6AIcEQAsBsFWSDwBCHb4oDpY2+ED7kYtQQkL0QKhZxFA/BvBDcKL6O11K7EBufa7aKdroQKtsrnBBOuRA0unhTII24ECGZHvu+KbcQGE+jUQYxthCT1KNRBjG1EHRuKzFhnrQQ3zKEl9vesxCi9iLPg+SyEOtoluEjzrEQxKDT6rp5sBBNPxrv2qqvEAEuwKS6IK4QW/Kn+y4erRAkOGu2inarEHDyeOzMNKoQf+zqJdafqRBHFSwzfcWnEHXiNm+4iaYQKSvYdMmdpRADKNC3K4SjEFCkMv5d2qIQJc1rtop2oRBM9dpVYumgEPGX3PsXrZ8Qg40jpXbKnhCG5X3wzGKdEJSAe1kahpwQBHPWaA/XmxB8JGvlYtuaEF8ud4WhhJkQc3mKA6WNmBBbMB1vC1+XEJxxwOBCm5YQ+g3V6H+1lRA1oh1QCh6UEH/iaZD0PJMQRNKbtVPAkhAzSfuVTyOREEpsbK9HY5AQvex2XtzYjxCwTJKoI3eOEEOcn3Qa6I0QusRbolpCjBArjZfryMSIEEEsGiDNTIcQQFKakSh7hhAVB0Ba3qCFEKR0zb0Bt4MQT8dg+XrTgRAh/9bpxj6AEOo5dMqBXX8Q9PUMmFUsfhCMESBybS59EAgRiM8ZNnwQ9QYUWqj2exDX/1VK1Ht6EE3mUF0ZiHgQaLKliMZUdxBc6ooDpY12EHKrIirJenUQ/940QT/ydBD/Vpkx3mRzEHUzfez98XIQ/Wf6eb9jcRBMQ2gY1+NwECXOkPloNG8QbYDiHH8CbhANvNZoD9dtENGUd6t2fWwQlu+V6rnGaxCT77mOYiZqEFbzQfSVJWkQNUq3u3tLaBDVCec42XVnEAXXigOljWYQnmVpDzAXZRDyImkPMBdkEJXsrkik4mMQnL6c++4vYhCAWRN2zddhEJGIrBYw5WAQHCljzDnqXxDapzTK569eEIYZa7aKdl0QhKJrtop2XBDROEKGAjFYEGivvmaoMVcQwYPoK2DaVhDqm3BFRJhVEMqSUCX9plQQp3lrtop2UxBLbnhFoM5SELFJs/ow+1AQAvhrtop2TxBilLazs71OEBhDIEt3iU0Q+jtrtop2SxDW5Gu2inZKEDxDa7aKdkkQr19vdNSTSBAL9IIcfORHENhoa7aKdkYQvP6Qxq+pRRCSfFixephEEDuiliDa/kMQKwOQxq+pQhCbsB77vilBEGYdd9ANq0AQPIiKA6WNPxA1BHMiSJU+EBh/Goy82T0QB7o+o/7APBDDDrb9cdo7EK6C+WzYHToQwo5mvJkJORCjm21nk3I4EMfpa7aKdjcQlnBrtop2NhA0gZHbOJg1EILWMU+TbzQQ3ZCQxq+pMxC9nyB0FIwyEBheEac0FzEQBryLcYo5MBBw9UXNKTYvEC1P13lBBi4QmKmZgIMELRBjF2kqH2wrEGDAW2J1YyoQAWpAaiCnKRBrsUBqIKcoEICFQGogpycQaEbC+8kCJhBoBm7SoJslEGQPJvdSkyQQhvWqgS75IxBIkSF8/fMiEE/yfbnr3iEQV9lAaiCnIBBcykBqIKcfEKhRvvzmNRwQT0uZ/i/IGxB6MyYk7+UaEO1xWJAxahkQ2fenOOoXGBCLAh77vinxD1vfa7aKdusPBqZrtop21g+1appwusPVD+shbQrw3dQPZArynqnvzw8q3mtacgLOD1nYa7aKds0P6my+aPsUzA9p3uCMtu/LDyzPbhmaosoPjWObtVPAyQ/Su1iQMWrED3pEkxLq9MIPpZBsr0djwQ88ynM7f47ADxJWD3oZYr8P6hlUfxIgvg/Zx1R/EiC9D9XhIEt3ibwPRBc5tOCYuw8dPnY06cW5DyxAhJfb3rgPmA40yuevtw/0lmu2ina2D5ZWigOljbUPZN2sOcd2tA+Ls2LUEJCzD0f+EmexcLIPOGiPx+kwsA/Ppnt3cbOvDzlBjJMMXq4PgQCJqtu6rQ/Lo3u9Y+KsD2TQaQ8wF6sPv5TWaA/Xqg9OYhq6JPeoDxlFQGogp6cPxVU+o/7Apg9xMD4yslylD0ravqPqRqQP/YIe+74pow+Vwn4x8tSiD/9wDK+yx6EP6FWjUQYxQg+HVpmDCvUxD+ura7aKdvAOivtrtop27Q6mfX4x8tTrDrLH2erVJLcP9JZrtop2EQ+g/5IO6dM0bBvGmpzT2WoIqcp4Vu3/ihXf+K9RKqsVVcDNqcVcbUBqVJ8wk1hZinqzO94rJ8lAcYXgXRHMBPsLFrQiAKNNznRInfU1GeEICGhTMVzXMvhZ22SRwvsAkQg8gQdI/IMQHs2JRqBSTA8eX8tPW6iwDh5q8BtkGSINHnUV52yKkwweB1fwJ9/33R0AQe3gskTcHX5gcuN+kNsdPwp4ynkA2h2NalPGz/XZHc3777S+btgdnYNrD1b01x0CaPnAnzfWHf8r0roXC9UdZoxraBI21B1a7mRjkU7THWvVxx6C+tId0L5kACxC0R0LJNz7KaXQHWc3E7i6tc8dL8HwaHmZzh3p/cAaPmTNHRtHQuA10cwdCsWFJL14yx14L0yaWTrKHZDS10FArskdHRahZoutyB3jpQlId7DHHTxpLiV3WcYdsJugY7C6xR0By/MpKlXEHb4msHLbR8MdVRWkoAPIwh1Ey/ftHdDBHWkC70KAvMAd1nXZnQA0vx0qeV2TgJu+HV6GToPOnL0dVMPSIjJXvB3qrscsywe7HT7nv4WEJ7od7veLl0u4uR1GGwVyYvi4HV24LpyK2LcdnFyA440hth06dRTr8h61HZQQ0kJyqbQdcHzc07rcsx0ngt5IRXGyHWmf4/ts77EdKBYT9XVjsB04dkSnpE+vHYpbzp20Pa4dvoQDKAH/rR1svxFSkL6sHUxGNF53TasdM9YqZxgFqh3Bl6ia/P+pHQB3IDkPF6gdRm0000Napx1BoXdipemmHYpj6G7EMKUdfeWn0O2epB3Y8OeNPuGjHQDTt/+CE6IdTKg4nVpgoR0ZtIZqE1CgHSiL7yMBz58dFK0y8jB9nh2JHyiHCCGdHXk45550H5wdV/We1DOAmx2YJ87l8oeaHVHCdUJhDZkdMVhm/qitmB0M5roP+eOXHZ/ixTZ0iZYdkaNxpqjClR2tinxR9YGUHQxbZLQh4JMdXT4PB2m1kh3iSh4A7HuRHal6JPOvopAdHmvBR6Uejx2YpfVoSQuOHQYcfpZ/o40diyWVFJ7EjB1kySM5J6iLHegX5IWTqood+rYrAtlliR2sTRZh5DCIHYF26WtSLIcdCEeECWfJhh06VeILdSWFHbhJkqn/nIQdqJJeZJ7Mgx0cX4CjREmCHSmqH2bBf4EdQLx5oAu4gB29BaGICBF/HSMZyoGIdX4dNVXar0IzfR1MEbUgGJF8HWxoWloSRnsdi+Ob3bUAeh1mB16jwhB5HVBcbYkRtHgdtNnhwO4Hdx2eVlVMT4x2HTruXcfjc3UdqZAs/T+qdB0m6pE+g61zHSW0vHEX+3IdOaAkAyiucR2BQS1PPStwHfDNUt6Pym8dZZjiMyIXbh3C1uF6TQFtHZ8jv0C6XWwdQxObb4Z5ax1boIWvjz1qHaxr1VD1C2kdUqIZZYUvaB2Wa9ayxcvQHAkou3+Iqc8c2yZN4zOAzhy4R9lx9PLKHD9AcBCvmMkc8NcADq0xyBwguWnkIAXHHLjMfKCmqsYcDewp8gB9xRz6Y5qilfTEHNxiZA53GsMcs+RSci/fwhxkrFansBXBHFTSBcuneMAcGL/QOXnFvxw+mE3Wnhm+HH/aY2atD70cAO9aFZcFvBwUEigx9eG7HJsItFaCdrocBoqL9P7duRxVR/uuQQq4HD1SuQog47cc/4XAdny9thweXDh9l5O1HKNnyVMgXLQcFUO6BLQ4sxxixyfKfZ+yHIbLDLRx+7EcR6ID/XdMsBx+lTriMGSvHEdzr46Z1q4cXf5dsu/nrRzaVaNkTHCsHD6pRl+VV6scnUyEte7WqhwACVSrmJapHJ2cPCPXaqgcBvQ30iqjpxzU6zh6htymHBv1AOOw5qUcWOu16Hg0pBynZWZn3mCjHCmuvmBxoqIcmXTw0IuJoRySJNjQvn2gHCMuXr4VXp8cIA1uC5O1nhyvuusZtM2dHEipcWri+Zwc5/CeZvxTmxx7wo+VKECaHBNMu8kMj5kciMIbA8ApmBx6cB604viXHDGRCq3mipYcBthUMsbblRyNoZntyUCUHEz63JUWWZMcQC8UtB9AkhzNwvCETQqRHHYM42e1wZAcv0EcfwGqjxxjWm0P22+OHByYEVF2xo0c1Rwiq8+KjByDkXeKaaSLHIo8vMVnwYocvXzJDZcXiRwHmuPhTeOIHMagXN6o94ccX/ltGjZWhhy8UpcoS6qFHCC4dw86y4QcZ+mVxI9xgxwZQ31mNQyCHNBkqTyy04EcThGc9iTQgBy73t0ZOZJ/HA4vuasc4n4c3lkfsUXKfRwY7Jeo48N8HJ7jCoepHXscrxRurVO1ehydHfITLMF5HB1V9VBiTngc1es50I90dxx3I5Hb8d92HC76gCAtunUcmCKwmSW9dBwYjaz8eX9zHHZnwQ+HVnIcuwf+UkLzcRzJRv0ASEZwHHfMTOqxiG8c3s134HFEbhw9hUeTlRFtHJQZbPaGgGwcZU6lx7GXaxx5Hn/7jL9qHMg7FxQzmmkcc8xpplv3aBypOy6KU+dnHCuAzmF4NGYcDkZ/YW03ZRwGeDpTHEhkHEyLpfWZt2McIjm3D0X1YhwxFPiEqXZhHCIvfekfu2AcKHXAPof+XxxrgHV3u3deHHDK1fGnmF0cCI2kQzWgXBxOit9Bb5pbHEmYI5LgZVocbEV8qUkOWRzKIPCmzj/mG59nT0/aCdwbDJbYj46U2xt+67Gvq9zYGzW9I2Ue6tcbzE/K68zK1htg+ZQkyp7VG6SSFzx9edQb3pBPGk9B0xtYCUN4OfzSG4zi3gio4dEbjUV6X7tC0BtfGYUg2gXPGyK4SUJSQc4bC50dvv8KzRu1skPhgjzMG6yIlt7Sp8sbHTMC0FJDyhso7pTPAFrJG28fqJ8Axsgb8kCxoQhkxxvWx2kr8ajGGz2NtslvHMUbBUXQKC5EqRtWHdfz4B6oG5Ox/sXfVacb0EUmmN6Mphtt9U1q3cOlG6qJdTzc+qQbc0XXS8a0oxuw2f8dxeuiG+1tJvDEIp4bkYDY4JfEnRvmE6WxRjScGy0lJZVHpZsbRBqnwnOTmhs282xZYdqZG2RQLpBGV5gbX555d/pylxt3d4B4BzaWG2ilnDmlPZUb07jeZnFKlBsxeC51Zi2TG1c2PWxZWJIb/P7iu7T6kRt0L6z8XTJfGxps1/snHl4bNeVqjvxXXRtQXv0g0pFPG6JpLHCGfEgbomkscIZ8MhtKkze7WbkVG/Dg16/IgxQbETHCtT/lExv0Ly7rFQ0NGyindMb9+wwbcu2BVLWaCxvQhn8SaZgKGwyN2g9QkQMb88gLXbeI5xq+AFQNmv7mGoiUwNfZZOUa6i23UfGe5BpMYhXNcofgGo1NT6lU1t8a8LwMGAto3BoznZQOhVHbGtWAOxdYC9Ya9YBxwsob1BrLVWLTboLTGpj+ww5MJM8a7ROL70olzhpirNIDK+3NGu0Ti+9KJcwaYqzSAyvtyxpj8NpNc7jKGui1rhhOv8kaY/DaTXO4yBrota4YTr/HGuQ80KpakcYa9uIwVn0XxRrkPNCqWpHEGvbiMFZ9F8MaiYjC+tQfwhonWguCLs/BGomIwvrUH8AaJ1oLgi7PvxpDI3Nh7bi+GnjhLVhq4r0aQyNzYe24vBp44S1YauK7Gi3yO7BM3Loa0vq/IluZuRot8juwTNy4GtL6vyJbmbcaOfT5knZethoXQbloAo21Gjn0+ZJ2XrQaF0G5aAKNsxrh/D/XuiuyGs5/rTWp0bEa4fw/17orsBrOf601qdGvGpxBbTvMgq4aaCKb96ZLrRqcQW07zIKsGmgim/emS6sazustaW7ZqhrlPO0MNPypGs7rLWlu2aga5TztDDT8pxpTlBVY1wemGrHwJ9+cp6UaU5QVWNcHpBqx8CffnKejGhs6CRF/UqIajrUbUoZ2oRobOgkRf1KgGo61G1KGdp8aerSvCR5EnhrcKJE/j1CdGnq0rwkeRJwa3CiRP49Qmxpn1le/aziaGqQHnOTiY5kaZ9ZXv2s4mBqkB5zk4mOXGsmgQ3wDw5YaoBlduT4tlRrJoEN8A8OUGqAZXbk+LZMaq0JErhpnkhpx2f891LuRGqtCRK4aZ5Aacdn/PdS7jxq/oePbKmmOGrUy80LFI40av6Hj2yppjBq1MvNCxSOLGvXE5v4NJYoa+PQuM8AxiRr1xOb+DSWIGvj0LjPAMYcal797QcWRhhpaTfnFCa6FGpe/e0HFkYQaWk35xQmugxoW8q3HfDiCGuoHdhOiT4EaFvKtx3w4gBrqB3YTok9SGttHeJ5iYFEa3ynag1ZEUBp82QuDF7BDGie0FLygg0IakZBpcDLrQRqQvNUThCBAGnynrQyB1DUacqG0Y04kNBpDoEbH+vozGhPy2Cqm0S8a71RC+ZkjJBpivx4+PEojGqDs3FgLwiIaDmqbc9s5IRp751mOq7EgGrkUGKl7KR8af6HZCoO+HhoB0EfCP08dGq8Y04C4bxwaWneGu8dNGxoO0Okp5AAaGqP1UGKClhka0+a1J7HMGBqAb4ajRasXGi74WB/ZiRYa15BpAYSTFRrh7g98YsQUGk43toho1xMaY4gTXShpEhrG+5bSNhIRGsBXzbvbmRAaSAk+X9JCDxqucW80x0wOGqZHdh7ieA0adYI7U6p/9hm/I5puN4ftGcCy7fWqr+wZZo6wwy5b6xkgiofQXfzqGUeVRestdOkZPhG8Prbu6BlUWaSiy4vnGXlWiO+2TeYZPb/LvnLO5RneTkQemQLkGXoWAAUxuOMZ9aYRXNXS4hktJy1WYA3hGTlpkm2x1eAZnQ2FCnKa3xlXOYUKcpreGbN+30PeX90ZXo8HFkGN3BnmtWheT87bGec++HoImdoZC9d9TmnE2RkdBTsYOMDYGePWnyztvtcZtq917VNz1hlLX3hfU/bVGXm5Q7Y7DdQZp4P5DxuG0xkDUsdBN/HSGeY9C7KBAtEZlQg2oIvu0BkJYuOxerHPGT6M+COk184Zz6slh5UUzRnte6j00DjLGWrqZa8EzMoZAj8u7yViyRm60H3YtB/IGQ2dkmLANMcZJTduUgg4xhkzP2EqX97FGSLdT3K3xMQZdtihH0zowxllzdlkT1/CGVby+Kjxe8EZ7zhmJQ4nwBm+GNpnjFu/Gd3EjJxxbb4ZkjIXShABvRkVw27ZFQO8GX/Blh44OLsZEdr6CPi7uhkZSaJlZ3y5GVo3FZbbE7gZye79iIf1txmwC1bI66C2Gajz88BTM7UZ9nLnV9FYtBljsztIcAKzGSO7t2ZhkrIZOiT13hxgsRmxYkMs1++wGZbwB4GZbq8ZFOwvhd8qrhmhunLDOfatGcYKYNKmM6wZ+QIMLsHMqxlnHSx1yhiqGUR6dTOIoKkZnzLJHj1UqBl1oQLJ4gOnGW2udgcauKYZynTcwjbXpRmUgZdIYlakGXHqWpNX8aMZfLm3H4BUohm2+0B5kuyhGb4AVA2a/qAZiJTA19lknxnqLbdR8Z6eGUxiFc1yh50Zy1Vi026CnBmY/sMOTCSbGbBQAqQBnZoZ3AJhe3AKmRn01aRQxkqYGVewFi4FRJcZ/IsHQZMilhlwSItHSMiVGX6U9Yh2NJQZ9QHco7YXkxkQkQ3/4SiSGa0Zq9fWA5EZYW+3dFTMkBntXEEbXk+PGYf0Z/qCo44Z4+Y1AmxajRmsPvSrqMaMGXVxNS8UD4sZs32FVzknihlVKP6eQxeJGV5olvAGd4gZnirOhRrDhxl2HiL+nV6GGcK3nkjWPYUZH34KxrUshBlPgs1w57+DGYWpYjOU6oIZJiMs6jLzgRkTnhpMtCyAGfy6p0veOX8ZXmiW8AZ3fhmeKs6FGsN9GdA6yr7FP3wZZwQ+YVdUexmwhBf8CMZ6GcSNy0qhQXkZ35M4OAQaeBkS1QY+hXt3GUdWlsCZAXYZnOIzz/g+dBmNhH7lbcZzGQ4wTqTzZ3IZjAPkEAnDcRktVMpoT7dwGQs49OBMeW8Zl/d5u6eAbhkm5QXdO5FtGUuPv9QJN2wZKrkLQZUoaxlQeZuTZ19qGX9F648xG2kZX5tewKRbaBnNIV4/xThnGbmspIRkgWYZUeZsyN6XZRlEcMxZQU1kGQy0dv6fM2MZLk5YpEQBYhmpDXkx9RNhGa8RwLVZ7GAZNDxBujeBXxkOYNKggpdeGUb1r554o10Z4rRb1TdaXBnezOtob2FbGdMxP0/h/1oZCAtmdfBaWRmoE21ugbRYGeBriZin/1cZEmJyU37RVhlQL/ngQ/1VGcQXVdV6BVQZtkpVh2XkUxkSoCkD1XNSGR8KSX6cylEZnylDkuVYUBnd6gQTZpBPGRX/Mvm+6k4Zm8cyVi3zTRmzYRtoZ51MGYm2tpI2CEsZMxpx7IYDShkeiRbXHv5JGeH2xq5TvkgZup738wXoRxn7nQhrPYVGGebGgDSx3kUZXH/wC8t7RBlS3nEaYodDGc+++r5/LUIZslZKe0rnQRnBbQJk8a9AGeiZoHNnET8Zk5Y0AszfPhnOxwRw4x49GdbMFZ4YvzwZW1mdN0MwOxlKLIGAbio6GX8XzWtSTTkZMkCvPOlCOBk+CJpgBvY3GSdTrejM7zYZrN9tvlMwNRkGB+qtWNU0Gafy30SzwzMZQtAhU7D2Mhmw7QXwGyMxGdEdc6wPmzAZutzMaqsxLxnYlLZGmScuGQvRuPizoC0ZwVNgYkB0LBn8bn1x500rGQtgyzinoCoZSjuEywOzKRk6MOkHNCIoGbxBjmA1IycZUkfRS7LRJhlU05xxLsAlGb6sCCTUSCQZooc1o13EIxlQi5XRWaoiGYR6rl7zTiEZg/JEC21cIBlG84iNLLQfGVRBK3jOiR4ZoBGZzDzCHRlpNeeWgTYcGaICd11fVhsZ8+SlOctJGhnEnmBU76IZGV9w9YN3IhgZJsI/CyUUFxkE+XK+8dkWGQWvZrBqJxUZNGcYN9hAFBmSPSxVd7ETGYTbTn+DbxIZVWtxvat3ERlVd2jP/GYQGRiy6V8kNQ8ZuSAu1nhDDhm0NwsHDfINGWzXBALZGgwZijn1dgXhCxlhPqtoo0IKGULMhAmOKwkZNXRRnRo7CBnxouDXhIIHGaWGv74lyAYZK2n9+YVVBRlHjAu+iPoEGZ4ygyscNgMZuhifvY2WAhmSEAUZxHkBGWiI5KdHRAAZELDfQ3Fa/xjmJ77S9CT+GI5PuW4eO/0YNXezCkdR/BgM75KZyxv7GLMWjTX0MfoYy8nawcVg+RiyioDkonH3GPn8dQP3Q/MY5+rvA6lT8hgwfoTpaeTxGHkRGM8odfAYwqSttOgF7xgLP1Ph44vuGFTS6MaiHO0YnWV9rGGt5BiVcYY7MXzjGIb27LmKdOIYn1x+HTZL4RjnEhCB4iHgGEu+ouSN+N8YQ3k0SDnP3hhrhMar5aXaGJVxhjsxfNQYuKBFpYWQ0xjD9FO8F2jSGM/hS67xodEY3N4E5HcF0BgM4fzBurzPGB4G3WRrdM4Ya+ORtiNjzBgNdHLHnnPLGCXaMOJt68oYPkDv/D1jyRiG9q0XDdvIGJ9cbDLdUscY5xIrTazKxhhLvulnfELFGEN5qIJMusQYa4RmnRwywxhjPyW466nCGA9OjWUeHcEYBwlLgO6UwBgAxAqbvgy/GCfPyLWNhL4YIIqH0F38vRhHlUXrLXS8GEBQBAb967sYOAvDIMxjuhhgFoE7nNu5GJkXw4YiH7gY2xkj0/1qrBhXLjgrJU+oGEd0bjXF6qMYynTcwjbXQxgvAGJyGCNCGEhm9NXE+TwYR7ln25u48RdDdXaS19zwF1XCouunie0XuXCLWXOL7BeupG+ludLrF33yQC/kJeoXrsYtaNjc6RcpbRl//XfoF5FxUTcecOcXw3S7jSN25hc8cGcQvOjlF1JHqD50j+QX5CujFId+4xeQG8zhWtPiF+RDkOX7G+EXqzDgZWAH4BeegxgKdfzfFzPbxGyVvN4XQPzrj7CX3RebpPUuxrHcFxiUSFAjhdsXqt1S7zmf2hf2nDiszFzZF1J3ivPqUNgX4uc4LHdU1xfCZhwLxQ/WF9oYs2JX0dUX0oH8Ps361BcnoYSS6XTTF+Uhb2CRltIXB0na1Etp0RcSsOXsphjQF5mWek5Z1c8X9UIsjvspzhfUYKqUB17NF9YnjfqWoswXKDH+e8P+yxd6Om7971rKF8xD334bt8kXaxLKulyAyBe8DDs8idzHFzbNHdhrScYXjDrDeYbPxReymHszcl7EFyadmGV9iMMXHGBybJ5Twhd5sryb/MTBF5hElaIekMAXWD76V5eovxcklrylv/6+F30/fMLTGr0XcmY/EPxwvBdsw0lFZDS7F5qFz3k/lboXJsQsQtpEuRfVZAP/AcG4F6ZiPcD8DLcXJFErAl3OthdsfCvRSO61F+Uh28P9j7QX8912ZzzJsxd58dxs2vmyF7TuUP3o+LEXVfcrQOqGsBcBxf9EA7evF/egqwPkc64Xwm9BZZcwrRdSBLen4UqsF6z2wUb3ZKsXBunL5Qx/qhfRthpTWFCpF8bwyIvlU6gXOGy7Sf8rpxexHZMdJrumF1BwKdF4eaUXPxkcC8UPpBc+XMuk9pCjF21PS5e/zqIXwFWdU0axNBdYQzoEZ8czFxcF2D+LXzIXPtF7hegfMRee3GwXU/MwF9D3Cq95AS8XqWy04SR/LhdedhRf3tUtF6cedNoojCwXvVNoNwA1KxfgFpTRxxYqFwV42H1mRCkXuoE4+yCbKBeSUK6lx5onFxhfjNNC+iYXAnfzucj5JRckfhEYQTYkF7BlcZX6jCMXsdJVYO8NIhe8/sRtHewhF9So0WZBQwIX1jlFhBwp/xZbaJMKo/j4FqWJtc2qdvcW5ZLvnIpc9Rbys7MF+Sz0Fo0DYxg6G/MWp7U8GWsa4hYgawAEli7UFoiMUlHlNtIW68B38VrDzxaeZdY4p2nNFmMCI2RZkMwWVuTTuXGwwRbxNu3MqvxEFk2Nbzru0TUWtB2hUtzLNBbciuGmnWszFs/cXUqnQTIWx3acnmnhMBadZL0UchgvFnIfIux0by4WI5YR0q2GLRbOJ99IAOosFjVGzi45ASsWaKTf8FgNKhbQwkD9BCIpFhPc2/j2mSgWElp2CF7iJxZ5eMCpvVkmFiGocb4YpyUWhAihUtzLJBZ4eOGmnWsjFhjV4aadayIWmiZdSqdBIRbX7M8edtggFm4f0w+Ffx8W5oCEof9TGxYesdUIu6EXFo2IksyS8xYW64eSzJLzFRZxmjhrcHwUFrQRyJ2BoRMWnCQe4UxjEhY+lThrcHwRFprJHuFMYw4W1qCSzJLzDBYOgHVsQ3kLFvOCmaKVhgkW+bbmmwaJBxYqpjeiGJoGFlrZ5q4bDQUWKD43ohiaBBZzGOauGw0DFtKp5q4bDQIW1AI3ohiaARaDOeauGw0AFtkBN6IYmv8VTYf4Cujf/RUWB7q+aJ37FcwSFUCg0fkVyLnH3zGV+BUokaXUM733FXBUOWFZ4twVvkAduo161RV5CVno34PUFa9Er53R5MEV1jECOB52wBXXygvSeIS/FV97MwcQRb4VYRQ8oWpTvRUOlNqnUni8FYOpNDBI7bsV+ZdWgZn3uhVurbAJj2y3FTewHl4a37AV2usMnKejrxX7Mj6baA+uFXyVb5oqe6MVfILGBBD3ohWvxTvBvpWhFeMIsH1rNKAVtTAlOhjTnxU0cHQBATGeFe0GTQIzMJ0VBrknA2QvmxXYAdoExy2aFdQx5LyTV5MVrfimLj19kBVka70UchiPFTNJvEHkGI4Vc/9dw70EiRVHp69RKqtyFSYQqgDHfWoVY/KUWjPzaRWKx73LoH9oFb/FBaA3YGcV9LEZ4SBqYBXhQEPcq7ZdFQXKNTNC7VcV+l1lMrAPVhUQ1Dcj1GdVFeFNOCysOFQV9nmKH1vGUxW3vv7AKUlRFYVTes4ImlAVs87qDlLPFBW10whR+MgNFfFdczokkgsVx+GkOeb9BxXqs6TOJIgGFQlx1s3m8/cUp2Ma+UP88hRUkKQ55v3xFNS3czokku0UnbAATcDj7BRPbnM6JJLrFAV2MUyCT+UUpqO6M4qL5BQtMm3o9ojjFLTnZiJau+IUO3YZ18a44RTCBMyLMrbgFEqTfkCes98U0Eh4egLm2RQyjTRtEwnTFCNZ48avd9IUklQcxDYG0RRmG32CPpvNFLuw/xKoFMkUG/ZVHASbyBTzIlUcBJvEFJgsgm1Iar8Uu/9r0VLdvhRgr5VVL9q9FPgrY1JOIrwUYpBR1dxLuxQp/KdX3xq6FAmU0J3i2LkUP+V6CyEMuBRHY2gelmq3FCa3FVWIQLYULVeVVS/atRQvYvU+I2i0FMoDj2SEzrMUSZmC0YDOshSgecJZS2ixFIdeMhQyj7AUvZubE10ErxQi/iRoy9GuFCCf9T4jaK0UuoJ6CyEMrBQUPcVn4qibFNbzduRc1JoUke1UE4KWmRReLqYetO6YFBkohE3asJcU1SFifABzlhSQG0CrJjWVFOgGIjcbfZIUz9HTbxutixT/1dLjfvuKFKNLRI4D5okUxvjV4S46iBRrbkeMsySHFA/kujY4D4YUtFks4b75hRTWBrw06U1/FNeEtoXXEXsUfEBk01Z+cxQSPH+PuJByFHp0ETY6/2cUw2JbvEh4ZRTgY8rN7clEFPvHIT7ui0MUidbtL/wTQhQjLyGp/YNBFH8GVCL/80AUVqgVd+qFPxR12eFo+A0+FOEFim2G0T0UR70V4vl9PBS8LEhb++07FBlgfMbu7zoUwfKprD3xORQ5WYs8K1M4FPG/JpoWYzcU7dLF7y9BNhQVOc/O6N41FE0peQO6WjQUnJyajkVUMxT6Mu3pqQIyFNwNm9ss2jEU8GJKza+xMBTerZH8czwvFJmGmo5FVAoUHH//Ulj+CRTVhKfrvH4IFACoOn41EAcULMvNEK6hBhRX7mGjJzMFFIIR9DWgxAQUrjSHyBlWAxTZVxpbkucCFAR7ru0LeQEUMJ5BgIQKABRbwdQS/Jv/ExTHfKthHP4TQOoPPtqt/RNrDaLQUz/8E5YwNmPM0PsTwlPJ9UVi+hPtdlyIvvP5Exia8Bo3hfgTRL2Dra8W9xNv4BZAKKj2E5oDqdKhOfUTi8SC+CAK9BMcuRWLmZvzE62tqB0SLfITPqI7sIu+8RPOls9CBFDQE1Z1ZamGrM8TZ21lqYaszhOh/GWphqzNE2/nFZzfKLgTItIiAKNNshO5B4eB7+uxEyyhqQ0YbJoT1zhpK3n0mBN7bhrkaciXE1DgPqvBdZYTInHQDmxM5xKMhGTTVn7aEjxRMBJQNtYSGOXOqy65zBIVdapWi7XAEgL1jK1zmL8SAIVpWNCUvhL+FEUDLpG9EvukIa6LjbwS6CQEBXNwuxLmtOCv0Gy6EuREvFotabkS0cSfsRVMuBLOVHtccki3EszkVwfPRLYShCvYoh2+tRIECbVNerq0EoXmkfjXtrMSBcRtozSzshIJsFD6HJaxEoqNLKV5krASCmsIUNaOrxIOV+umvnGuEo80x1Ebbq0Sa/R/TtjyrBKfjocmcLGrEuVvRsGV4KoSGQpPmS2fqRJNpFdxxV2oEoE+X0ldHKcS2/CrVFKcphIPi7Qs6lqlEkMlvASCGaQSiQZ7n6dIoxK9oIN3PweiEvE6jE/XxaESrb+OgtuHoBLVepdac0afEvw1nzILBZ4SI/GnCqPDMBJgePMVmEMvEogz/O0wAi4Sr+4ExsjALRLo8MNg7e8sEg+szDiFricSsrbInYGh7RGLPM6rLrnsEXZMjK1zmOsRcWxFAy6R6hFcfAQFc3DpEVecvFotaegRQqx7XHJI5xEfvtiiHb7mESB5kfjXtuURpEJQ+hyW5BGl/QhQ1o7jESrHx1EbbuIRy2U5E6dK4RGmLO0SBdPgEW+s60/W6t8RSXOgTzNz3hElxCv91NvdEQCL3/wyZNwR4rnXlG9/2xGeWtXRQJfaEWxCidGeH9kRKOOHDm432BH2yjwOzL/PEU5bqgDHfcoRzJpcUjyTyRGLhzj9mY/IEYTtGlSBcscRRNr3/t5uxhEDx9OpO2vFEcKzr1SYZ8QRuxmSq4BKwxF6Bm5W3kbCETnzSgE7Q8ERMlktWCMmwBHxRQkDgCK/EbAy5a3dHr4RmD5mSSuYvRFZJ0P0iJS8ERkQH5/lkLsR2vj7SUKNuhHePt6gKnC5EZ8nukuHbLgRXxCW9uRotxFkVnlNzEu2ESQ/VfgpSLURiJIN9eXMtBGMQBXNfYuzEaE11GeiurIRpePdPzp5sRGokeUX0jewEaw/7e9q9q8R2aU5+2B2rhHdU0LT9zStEeABSquP86wR9fYJRrUiqxH5pBEeTOGqEf1SGvbkn6kRB38cKelhqBFvriUBgSCnEdbdLdkZ36YRPg01sbGdpREGkoG8ph2kEW7BipQ+3KMR1vCSbNaaohFPZ1EH+8mhEbeWWt+TiKARt89cUjyTnxFvIhpUgXKeEe3706k7a50RpU6Sq4BKnBEkKEoBO0ObEdx6CQOAIpoRma9mSSuYmREagR+f5ZCYEd+v3qAqcJcRYIGW9uRolhElsFX4KUiVEV1Sx7m1JJQRBy17uROtkxGgwHn248SSEUqbLvZBTZER+p+5o+K1kBGkem2jQD6PETmhZTt9WY4RNbZjeE5xjRFDEhd4rPmMEUAnFbV8EYsRToPKtNqZiREvoey5inSIEayIfh02S4cRWMAQgeIhhhEpaqLkjfiFEULQNEg5z4QRiobGq+WldxFg/qdrBeVzEWE4GJ0bp24RXo/q5/ZGaRHy2ldMOCVoEb3iC1ElOGcRC2H7fB5JVxGPOjMNQZZWEfLzkiM+mFURSMJy09aJUhGUUdsVkYVREZAmy0ZnVFARigEqXWRWTxFDlT8pgAFOET5wnT99A00RyaWyC5iuTBHEgBAilbBLEb9bbziSskoRd++EBK5dSRFyyuIaq19IESpe9+bHCkcRJTlW/cQMRhEgFLQTwQ5FEdinyd/duUQRyM0VJM8IQxHTs+VP2npCEYK69zg57kERWTo9IjyaPxH1y3sc/Yc+EbG9BRiBoD0R8f7MLiJBPBEdNt0XgLQ7EQYmxBKV6joRMl3V+/RdORHTo732CZQ4Ef/azt9nBzcRKxLfyMZ6NhEUAsbD27A1ET8516w5JDQRKSm/p05aMxFUYNCQrc0yEYCX4XkLQTERaYfIdCB3MBHDMUR2z1gvEWH1XXu6Ii4RxDrSaaHPLRHpCtsQgr4sEVUh1HzYWSsRqaOh6uJlKhEE3xpGemUpEdpaL8724CgRF+6LNmAhJxF00pEsj6AmES66v/wsgnkQ4OwAWLRdABCZaVji/db/D+8Z6X9DU/4PeM3AnVwC/Q/fNrPJoa74D7SsYOWtRfcPgEe3sNG/8w+d/xrkacjyD2NhrEcVn+cPOLPv4PzV3w/OGDtpSSjeD7gVbWgLlN0PQveeZ83/3A/m70OGE2nbD8G1TAW+3NoPnXtWhGlQ2Q95QWADE8TYD1QHaoK+N9MPsmpbt+xp0g+OMGU2l93RD2r2b7VCUdAPRbx5NO3Exg8W9bz5GyHFD6d/exTqmLoPzcF5irznnQ93OnR282ucD3GO0MoYqpsPLm8srgmSmg8MOcV0KtqYD1BjE5LZS5cP3xb34N/ylQ9VMim6xoCUD+/h8j+TB5MPiZG7xWCOkg/08EbIlJyLD3UGTaEIYIoPwoBNoQhgiA+5hP3cCs+CD9b+6Y+0+YEPIIPpj7T5gA8V/OmPtPluD+AwdmacuG0PKmpTvZDubA8OVeXarUJrD/I/d/jKlmoP1ioJFufqaQ+6FZozAz9oD54ALFEgk2cPguu+bj3nZg9m1lCMWjtQD87/vYja7EgPl7NcdJnaNQ82+mOkIYM0D3/z2XH08jMP52Zr1aDJMg9O2v04S6AtD8GpR5uwlCwP6Ko+O8kXKw8zxIH66FsqD1nFeJoB3ykPgMZwOhliKA+mx2faMuUnD8zIX3pLaCYP88lWGmPrJQ8Zy026fG4kDz/MRVqV8SMPZs08+q10Ig+MzjSaxvchD9fndlnlOw4PRLN7zUA6DA9hhHM3BIALD3RTiJedwwoPXsHYxjawCQ9/dbPlWJsID9vIvaq4nAcPOQYqwXDTBg+pgixd0qsFD2Q9rbFyAQQPP+/TjTZpAQ8e/H3krfgAD2ohMoHNUf8Ot2v3MflO/g6P0MCpvVn9DqlWcb4Yp/wORXMlZ+lK+w7mCs8edtj6DlCz0w+Ff/kOBGb4Cujf+A4Cer2TXk71DnKxbvYeyfQOzpv3gd6/8w79KBmR+d3yDuUIDZrDWvEOpvPZi9Hi6A5l1s69793nDv8Wzr3v3eYOpI/Ove/d5A7CejRz1AvaDgurrRgWm9kO4j2tGBab2A4/JEo1/B/XDkQE5w0TS9YOc/vnDRNL1Q5W6Vgf5tPUDq4wtH6Xb9MOvUtSupMx0g4UX2arv2rRDlwU8fPdYs8Oh987iKG3zg5Xvv9qO93NDtHw1CrgeswONcGO4ksvyA59Ee1b11rHDil7GK97NMUORTk9bEDvxA4MK7AWxtnDDtMcIsFLxMEOS2I9bEDvwA7YZrAWxtm/DmVrIsFLxL0OFQEsjOQCvA6wXAg3Qf+7Dku45eGe+7oOYCMVIFEmuQ7bBqo2dwG4DpNatGNOJLcOZFlGx/r6tg5m/sXu9qe1DgtmeHGRzLQOx+D3oBZGsw7t9AsNvi2yDiQiFtF5wLEOEMyGOW/QsA5I0RsVM1uvDrTlGxUzW64OfU7ZDmZqrQ753fcZmrGsDqa3gr3QhKsOO7+ZhdF+qg6BnEytxSipDunHDpHIIKcORk5LfFJVpg6I+t3f/SulDgnbNo+H8KQOdcrI8jPHow7huVpW352iDn357LmKdKEO6eh+HTZLoA6EKBCB4iGfDm79ouSN+J4OgVk0SDnPnQ7DBcar5aWcDtZhWA+QfJsOda7ZDmZqmg5FCPcZmrGZDimOgr3QhJgOFgCZhdF+lw7C1kytxSiWDkzADpHIIJUOfdfZDmZqlA4pNfcZmrGTDgo4gr3QhJIOkNKZhdF+kQ4fHUytxSiQDlAhDpHIII8O2hQVUGXqjg7V4DaPh/CNDuPpyPIzx4wO8vJaVt+diw4xTOy5inSKDkBVfh02S4kOfq4QgeIhiA5XUaLkjfiHDh3INEg5z4YOE4/Gq+WlhQ7ZBVgPkHyEDotVA+6j+oMOUsyVUU/Rgg4YQye1+qeBDg4KuRimfoAO1YBLfFJVfw7KR93f/St+DpG+cEOpAn0OWDUCp1XZfA5N/JQKALB7DgKU8MWggnoOapd9VGH1eQ4u4PwQ3W14Ds7Yr9RH3XcOJPDcTrZNdg6COZvU1hB1DoieanOZ1XQOoXKnQfB+cw5SZPK8eNFyDt8dmlcWOHEOTTlOKFPscA6qsFkuarlvDlmNTxRR824OxgtX+jPnbQ7EzBqesKlsDiUpP+m8eGsOKxVVM4CVag6vgr302cVpDj9TB/+392gOg1tBjgr+Zw6HwjJLq+BmDkuoPA/WXmUO+wH/1x0KZA4j9sPpGddjDp4GXuj+jmIODHnWP5a7YQ5Yaq1WIhpgDkGxtAaAD18OLBQDDNM6Xg7kQfRqhJldDsgZY0OY0FwOqKmtCCpIWw44yJr5DaNaDn4Ld1XdbFkOE/AhLmpNWA7o551Vu+JXDuxmWhbqvlYOYc8bjj5DVQ64nbNh1sBUDrREsAQVIFMOofcKO9FsUg4YfnBKIZtRDmO/HYWJdFAOSHc3UqFETw7/rSxk6BRODqeBkxqeb00Oom+0y0MCTA6IH/OJ+kNLDp5pPEUQgEoOEvtXTDglSQ7ZYm6jgWBIDi83RKUveEcO45lLfb+MRg4GO2WtJrlFDtvIWEZPI0QOOe864agbQw52Dwib0F5CDoYSg05FrUEOi2B/W+gHQA4Cf3FUirs/DsCdKLKmWz4OE7iblrGaPQ6EnPp30Kc8DpkFXUpf2zsO5Og3BUCmOg4sJ9rLmNM5DgrdP/8KNTgO06NI4LjCNw57HbQ2NW02DiG9+i42XjUOgT71FULwNA5ETLUTdREzDgyIqEYiJDIOPhQko0F3MQ4sx1LqClowDjNecmL3Oy8OHEA5jB8/Lg4GqJl5HE8tDr5uRwXoVywOjR4eMh4YKw4DIf6EpcUqDhfAjfKYuSkOC0fSMzxJKA6iHMMEH8MnDrB3frlq6yYOer0HPytCJQ5Aa7qcXGwkDtHNqwOXaiMO7wub5DX/Ig5f1ymN9rkhDpKp34IWrCAOaDKN8pi5Hw4A4NIzPEkeDsmGDU7MGx0OIc/O7oXMHA6gDvmflLcbDpdZBLTiKxoOLh7hvP2DGQ6HEJiCO+8YDnZQJrZbzBcO8kZsZfzjFg7wT4sLzbwVDtJaHdvIgRQOw4Yq2r9/Ew6h4gSEGlUSDoAyEwn8jBEOWIe/s6iZEA5EXRF+XigPDsNCxBj0MQ4OEA5Yf5MPDQ7YbENMNRIMDmo22XjZcQsOZRTTE7kRCg6WOcx9Ws4JDiBCc78llQgOqqbnRmhwBw5SH4sMRGIGDhy+98hf9QUOE68ERtHkBA5pZ2K9Kb0CDj3jBniDlgEObYaF7puqAA4UZizCve7/DeOtbffvBf4Nlob9AQll/Q1gARlNJb/8DSVmGU0lv/sNILPwTJfo+g3E/vBMl+j5DYWgMQj0F/gNUTCg4uwo9w2Rh61AGn32DXzKUkKsJvUNV2zVFycT9A06gA39il7zDXQqiWG/4/INPk1e6P6O8Q3zdWNDmNDwDdx6tAaAD+8Npqde6P6O7g0nE2NDmNDtDeAp0/07SewN0nAqZkW76w2u2GafpnPqDYNqUJfD1OkNUqBLX7V16A0nMbQGgA/nDQFhxt+5MOYN+6rMyB0S5Q0rsGwEpW3kDaLCZ/s8yOMN+uES6adA4g1KmbKfKdDhDbrC7FosouANBfepIT2S3w3oUEJEz+DeDbMq+dHWxN0NyZ4r3LJB3A1hXfXefYHbDYorKqnYT9oNxgjSe5N32Q03GD/ydjrYDcbDglXindcNRyn21sTA1g2BqV8cp+7VDTTiiG30idQNeRCkyKGN0w2imPes6M7SDSUoMw7C0NENcFoOn3Dr0A3IB3Z905LPDcyUriPevc4NG/cBVG+vzQ3nJ/XyZlDMDceli/JH+ssN3Rz3CZLMyg1RKM3XP2TJDcM2Eal9PMgNtvHr9Gawxw1BqTWDCn7GDW7NtBdOacUNdYSpDegQxA0D3OTfHDPDDfKhwiYjkcIN3qmH0G/fwQ3e2QYUjZ7ADRLMzUGg0L8NOqMdh9bVvg0ycSjGZEi9DVNUQVPlI7wNmGPjSHsuuw31O6uReea6DVog9da7MrkNzQXY7VqhuA2xB5I5ffq3DeXUsYNzRbYNrtEZtI3KtQ1lFFDlYoG0DRgVsDAYR7MN0ArzyrgXsg3OwUfpOrqxDby2uyyXQrANrMD+8wiNrw1b93Zy1eSuDZm7kXHHZa0Ni2xG2V04rA3uaKtr4wCrDadpxHmsoqoNMqkAYQfRqQ0nRFf24ROoDcnGa83ajKcNeU5n7Ccnpg3xr8h9MkqlDbhc93k0saQNwvRtJdWxow2mpHPjZ3eiDUZY9EktvKENu/dPyuE0oA0NhZ9Y3MCfDaF2pDVpo54NspkcbFcxnQ0t8Pg/4KucDUhW777cZpsNJVM36vZmmg2lTZ3ixd6ZDddCa/1ey5gNZADRNel+lw2VoMRXSQWWDTiHFqTIgJUNDWRTGv8ClA0htoZA9QWTDWkwhasF/pINgVrrnQfekQ3J1OsIF9aQDeH+UfsZto8N+ii37RyWjg1Bo7ZYLI6NDVrNHEsubowNuQ/t8LvZiw0agLfk3WSKDQxy3i/NB4kNBV7lMaaTiA1Ja7KfKdCHDaUBsp8p0IYNHyYuLVc2hQ0kC4znK1OEDZ8CrKjvW4MNf7fzifpDgg0Qf1dMOCWBDZIl7FosooANjp9CRM/gfw3DNPOJ+kN9Dayg/kaSnnwND6bsWiyiew3/4UJEz+B6DQTinnNY13kNtCQw1wSueA14UkTraxt3DXcf0hiB0nYNIR1lrSa5dQ0CDA1OzBt0DXWG9wmSzHMNbQ0RqX08cg2fdKQ1aaNxDVEJ+D/gq3ANK31KxK0Lbw34A//Ro5VuDTuFZa0muW0NSKENTswbbA0FW/cJksxrDbpWEal9PGoNQxKkNWmjaQ3eX/g/4KtoDSIYjfKYuWcNsxr5n5S3Zg3hRCa2W8xlDSy24bz9g2QNkJz21sTAYw3pxIht9IliDdm+96zozmENbIoOn3DrYA2/I43ymLlfDYbq+Z+Ut14N17UmtlvMXQ3wvuG8/YNcDa2i9tbEwFsNMxiIbfSJWg3o0fes6M5ZDaszDp9w61gN0gKeOeqWVw0MIOlsHKFWDYEd8+HF71UNL8H+tFhrVA1iEltmXS5TDQL4y9W1ZlINuxcwzD+CUQ2Y2Qbjr+dQDV9DVrDVW08NnCR5muHOTg2X0QFVEMJNDZwr9UZWo0wNzApyYvc7Sw16L3b2tEdKDRchK7v9JEkNzNd29rRHSA2nBiu7/SRHDTNMoVLcy0YN8ozhpp1rRQ15puGmnWtEDYRbXUqnQUMNI6zH37IVQg2FnrRTpC1BDRNMkzoy5UANXpgMzMHKPw2q5IVdULA+DdkKyqODXz0NsdtqTXXaPA1DBSYYx+k7DWERCguKTToNxLFVebGJOQ3Di64PghM4DUFjXyOx2jcNMI6D2ZRlNg2xWlCYm0A1DT4HKRxYBjQNtzXF20OTMw1IaPJYtikyDa2mD7QMSTENxDJxxDRiMA30PraF1xEvDRK/qHLali4NpC5jp7wLLQ0LOfDFoIIsDTLcfVRh9SsN7LxHbN3kKg0oa6i4uDApDYwXEi8o9CgNnyTBbp4jJw06pNWrxqUlDWLJOuGoGyQNwUoIm9BeIw0z0oNORa0iDTPHf1voByENyvxEpS94IA1sLUt9v4weDTZxOYwfPxsNyLj4gv08Gg1CqoirbP0ZDTq9iKts/RgNt0NQYBJaFw2cj/dB0SQWDYIfFk4U8xQNKEt6segGEw1b9nqx6AYSDZniqveWSxENmjP88f1+EA1pJYiAvvEPDUOWGuRpyA4N2YkqnsNvDQ3O0kMRAPQMDVGk5N0xoQsN1XWFqmJOCg3/k7fk3WQJDSSyUvdnjAgNNIGACXvABw1tWBNkPDIGDQ0XIFoq6AUNrq6Eof9TBA17VEHTWMYDDUA9i3S4PQINBf8sZ/5qAQ3K53YIXuIADfcgz1FBq/8MviRbYSBO/gzmRt4fzJ/9DN9Jm5QpvfwM10xYCYba+wzQTxZ+4vf6DMhS0/I/FfkM8HRWsetm+AzpdxQmSIT3DOF60ZqlofYM2X2PDwK/9Qw09FgJhtr0DL1XFn7i9/EMM2cYnRun8AxA03PNRHPvDDJ1n1jcwO4MDhqfWNzA7QxJKJDsyLfsDB9M2SHruOsMcCBcHn656gxC57+c9n3pDLpl/oGHYegM85GrL2Pk5wzOU4EQsxLmDOZvUf4CE+UMgWzGXavV5Aw7i+FqJwbjDEK648ThWuIMtndqEbKT4QzKGfBdgszgDD7Xd6pTBd4M5h2N7knc3QzNTUBHxEjcDAryZ/9WBNsMwVxjaaoP2gxXY3rBlvzZDGdrQzm6c9gMMZYs4c6G1wwM4bOApHHWDKbU3/7mg9UMH8DqKlz61AyEqfVW03DTDLuU5pSwBdIM/ZfxwCd80QxRm/3snfLQDIg4xWTAabsMHFI16mVjugyLwaQ2YOu5DNBPEoNbczB/emSTwCTnuAz15oDPVfsvfyWG+EC5tC5/BJ9x0m4yLX/it+pjI7AsfyHsY/XZLSt//wTcho6rKn8+OVUYQykpfxxSzqn5pih/+mpGO64kJ385n7/MY6Imfxe4OF4ZILcMXQE6nW88JX/D2Z3ere0kf6HyFnBiayN/MHaPARjpIn8HDAiTzWYhf32GgSSC5CB/VBz6tTdiH3/KlnJH7d8ef0AR69iiXR1/F6dkalfbHH+NId37DVm2DGBOTzU5+xt/RqZCfKEmGn+9ILsNVqQZfzObNJ8MIhh/CjGtMMGfF3+AqybCdh0Wf1ZBnlMsmxV/zbsX5eEYFH/295B2lpYTf18+CQhLFBJ/YKeCmQGStQxHjr2BNIMRf1Bg5xmVXxB/AF1gq0rdD3/X4Nk8AFsOf01JUc612A1/JM3KX2pWDH+aNUPxINQLf3C5vILVUQp/Rz01FIrPCX+9pa6lQE0If5QpJzf1yrQMqpMszi4LB392f4y3iZgGf00DBUk/FgV/JId92vSTBH+a7/ZrqREDf3Fzb/1ejwJ/59vojhQNAX8MD2EgyYoAf33B2rF+CP9+jlhTQzSG/n4AC8zU6QOzDJLTmhopk/1+boBjckgi/H7fMtwD/Z/7flHlVZWzHfp+YnzOJmib+X7TLke4HRn4fuTFwEnTlvd+VXg524gU9n7HKrJsPZL1ftfBK/7yD7IMyyjatsrTsQyOXE2qtrqwDC+AgZWlia8M1Rak/K95zH56ZsVPtIyuDOM+NrC18ct+jkWoKUDeyn5LZKcQgJDJfgiDpffBQsh+llGk3gH1x35TcKPFQqfGfuE+oayCWcV+nl2gk8MLxH5bfJ96A77DfuhKnmFEcMJ+pWmcSIQirQyqeCEY6zLBfrlIfyIQdMB+dmd+CVEmv36T5X3wkdi+flpXe9fSir1+Txl6vhI9vH4Vi3mlU++7fgpNd4yTobp+AA92c9RTuX7GgHVaFAa4frtCc0FVuKwM64xvsVfUt36mKFYb4Qm2fpzqVQIhvLV+kaxU6WJutH5XHlLQoiCzfkzgUbfj0rJ+E1JQniOFsX4IFE6FZDewfkShTWyk6a9+d71MU+Wbrn4EmEo6JU6rDG6oAWVcTK1++QYtFLGfrH5ILiz78lGrfrA1K+IyBKp+SI0pyXO2qX6wlCiws2iofkfsJ5f0Gqd+sPMmfjTNpn4Y+yRldX+lfq9SI0y1MaR+F1oiM/bjqgykbJIYYcSjfjXCBQ2BNaJ+nckD9MLnoX4F0QLbA5qgfp0oAcJDTJ9+BTD/qIT+nn6ch/6PxLCdftlo/XYFY5x+bqz7XUUVm34zQPpEhseafsmD+SvGeakMvHgVgav3mX7rF6XUxq2YfoFbpLsGYJd+Fp+jokcSln7bMqGJh8SVfnB2oHDIdpR+NQqfVwkpk37LTZ0+SduSfmCRnCWKjZF+JSWbDMo/qAzJZ+t3QQ+nDKp1wm7YJqYMcHbyGaAHpQxShMgQNx9oflzQgzmJLaQME5ueB842Z36BVq/FgxJmfsK5VGN3S2V+Ax35AGuEZH6km56eX71jfuX+QzxT9mJ+h33o2UgvYX7I4Ix3PGhgfglEMRUwoV9+qsLWsiTaXn7rJXtQGBOjDCCKdf5kTl1+EKyn3BL4XH5RD0x6BjFbfvdH8Rf6aVp+G32Wte6iWX7fljtT4ttYfgPM4PDXFFd+x+WFjstNVn6L/yosv4ZVfq80z8mzv1R+c05zZ6f4ogypCEVtlbpTftWDn/Oh3VJ+mZ1EkZUWUX5ct+kuiU9QfoDsjsx9iE9+RAYzanHBTn5oO9gHZvpNfixVfaVaM0x+y/kiQ05sS37B8sfgQqVKfqgebH423qEMMdV1GF2bSX5CiJgKMMNIfpR9Pagk/Ed+zUviRRg1Rn6m/objDG5Fft/MK4EAp0R+uH/QHvXfQ37xTXW86RhCfiscGlrdUUF+A8+/99GKQH49nWSVxcOgDNSuTA/0sj9+mVeQIb+oPn7SJTW/s+E9fgz02lynGjx+5KZ/+ptTO34edSSYkIw6fvcnyTWExTl+50Zt03j+OH5K+xJxbDc3fkyUtw5gcDZ+r0hcrFSpnwzRyiIGi8o1fgBRssHcVjR+YwVXX9CPM37Gufz8xMgyfslSoZq4ATF+LAdFOKw6MH4uoOrVoHMvfpFUj3OUrC5+9Ag0EYjlLX73odmufB6eDJcn+Pwh4p0MOgHP87j5nAzCzf+egNqbDDrt91hO4QR+fCGGkOg5mgwT5xrZqZEDfsxJA/PSGQJ+3eva66OvAX7ujbHkc0UAftDfiN1E2/994YFf1hRx/n3D0zbP5Qb9fdR1Dsi1nPx95RflwIYy+33Haby5Vsj6fdgLk7InXpkMHUo3I4E1+X0oNA8VET74fTnW5w3h0/d9lLO+BrJp9n0TGZX/gv/1fcDObPhTlfR9PzRD8SMr833t6Rrq9MDyfZqf8eLEVvF9GQXI25Xs8H3Gup/UZYKYDPtghJP1De99i5IcN09i7n04SPMvIPjtfeb9yijwjex9ZGOhIcEj630SGXkakbnqfZF+UBNiT+l9PjQnDDLl6H0aaP4EA3vnfYX31f3TEOZ9Y5Os9qSmlwxfwq2cXvblfTH0KVmOhuR9b2sAUl4c430r9tdKL7LifRfRrkP/R+F901uFPNDd4H2/Nlw1oHPffXvBMy5xCd59OEwKJ0Gf3X0jJ+IfEjXcfeCxuRjiypYMtE998ZYV2305YzV7zKraffbtDHSdQNl9snjjbG3W2H2dU7tlPmzXfVrekl4OAtZ9RblpV9+X1X2JU0BQry3UfVF+F0mAw9N9R/nuQVBZ0n0PJMU6Ie+VDAkGQQGEU9F9ufqwpxY70H2AJYeg5tDPfUdQXpm3Zs59Pss1kof8zX0F9gyLWJLMffxw44MoKMt9w5u7fPm9yn2KxpJ1yVPJfYFBaW6Z6ZQMpYo+lvgvx30tgcKPzczGfT/V30PeX8V9P48qfIumxH3oPPexjc7DfZDqxOeP9sJ9aOgplp42wX0QlvbLoF7AfblDwwGihr992NiuAofwvn1Qv/etaWmTDIeYFI2PR719Taxgo4WYvH2okcmYoce7fQR3Mo699rp9fV17OZ9vuX3ZQuQuu564fTUoTSTXzbd9rQ6Wz7lGtn1sEIzW2sa1fRW+WQzc7pIMTZlEOFcokQwvpxov7j+nfVWt8Dk7mqZ9dh8FBldFpX3Z2GMcVEekffpKeOhv8qF9IqRy09aJkAzwvfElhVeefXcF/BDdbZ19E1mv1EfdnH0k0txOtk2bfVa8m9TWEJp9imXyvHjRmX2FKU8UUfOYfYaWTihT7Jd9HtFX+jPnln31JxqesKmPDP2sxxwbb5V9brBVM4CVlH21gwf/t/eTfQFlMkur4JJ94g3/1x0KkX1FzcPpGdeQfY+QrVYiGo9904Ca+Q2jjn27zPRqhJmNfd3ZWhbqvox90h0hLmpNjgx/4C8sehaLfd3NLGToFIp9V/WzYdbAiX01TAo70WyIfUqftMtDAod9GYM8RRCAhn3vI26jgWCFfbhgS32/jIJ9GeVYRk8jjQwGrV/XQveBfXJUCJvQXoB95sZ/W+gHf320Ryiyplt+fWLN+nfQp319FQw//wo1fH1ByLQ2NW17feVw+i42Xnp9a5b1FULweX0kOqhGIiR4fT08UuoKWowMqoY2ztkOd30q3zmMHz92fbBD/oSlxXV94/xHBehXdH2O+H65autzfTPd0jM8SXJ9yz+6nFxscX2BzN+CFqxwfY08m+Q1/299kPXSMzxJbn1CUM7uhcyLDKeiDMVwJm19q1EEtOIrbH2d82xl/ONrfUEEmII772h9W26LC828ZH2mnSrav3+KDG3/4rsGPmN928ZoF137Yn1LW/TiKjeJDMD6rKhDRlZ9YJ+jEhPGVX1CN8h4ZOtUfSXP7t62EFN9I2gdEEE7Un27dngvXlJRffhndOT9IogM2IPWsawuhwzUmdUv7vJDfTHBCCKXYUJ9noDvHKyXQX1NhwAGCwtAfblG6AAgQYYMKUeY4mcIOn190zB7vV85fY8a8naEUDh9acRAhmlON33zCII8HS02fdFMHpMMRTV9Fxhm0gM6NH3CbQQK33MzfYNOzF0PiDJ9DtyGNdwOhQxhx8Lr0PAxfb2MTJSyQDB9B4m+1SIHL33w3adCWg4ufUWsTmyXES19oAgFAiTeLH27MFqwlVYrfR2QFyEBVip9IZLWEdkUKX0QOqWaRV4ofd32iZ7//YQMelDs9DnZJ30vOC25xLgmffW72SV0OyV9MuTi8Lw9I32VxdVl+poifViXgHHfYyF9wlXZu1STH30GCTJ3pRAefUvp0L5r6IMMWbX0bXYvHH0y46iiz5YbfSBu+zHHCBp9qQ2/3KGIGX1MFdeDKOwYfWANUBEqBRd9dNw+H/IJFn0wrLglH7UVfTg0jevypBR9VRVQpjKUggxPLm3/BRUTfamzAaAwAxF92fxSzHBOEH3zTIIu8K4PfWSLT7Z15A59ufJKIcp6DX15DL3XslMMfcS/JDFGjAt9inDySvDoCn30WsCcl6yBDHX35pCU+gl9ugiNIg9YCH15ay4MNmcHfUWUDGI8sAZ9UQjW0T8sBX0Lgnqp8FUDfcB54Is3ygJ91W5JsPXkAX1pyIpFjFkAfZnYOlC6NIAMdGn5A/GI/3ys2GtPe6D+fB/0nU49DP18kg/OTf93/HykDwBNwOP7fBcrMUyCT/p8aIhzOiSS+Xzbo6Q55v34fE6/1jinafd8odaGOW/Q9nypexidG6d/DJOgXyIj4PV8g9CqAMd99HxZ4DaPh/DzfDI1yPIzx/J8C4paVt+d8XxvxTpQujTwfMiba097oO98go2dTj0M7nw8f85N/3ftfJVVAE3A4+x8TkcxTIJPfgw/TSgJgajrfLQOczokkup8bgCkOeb96Xwo8tY4p2nofDVNhjlv0Od88qUYnRun5nx/rqoAx33lfNIvNo+H8OR8YDjI8jPH43ztQFpW353ifKqZ7LmKdH0MXvHK1bJV4Xw4on4dNkvgfPX6EIHiId98EYSi5I343nwt6zRIOc/dfHeixqvlpXwMfJVrouMCewxR76xTl0p6DF0mTiDI93kMe8rv7PmkeAyabpC5KlJ3DLgSMoZb/518dw5CTTdydgzVpPAdMA51DNl/iIC+8XQMRG4a5GnIcwyMEqxHFZ9yDAQHPqvBdXEMTKvQDmxMcAzDn2JyGCNffGf/MsigwV58Ad8bhhDObwwLRPTVxPluDFPohjlv0G0MytwYnRunbAwSgaoAx31rDGxkNo+H8GoMtAjI8jPHaQzJgTluMJtoDNBsqZpwg2cMWKA5JHjZZgzctUBjmWhkDBc/rw7mQGMM/rZ4nmJgYgwvTamdJMxhDF/j25zlN2AMWJR9d4niXwzkk0FW66leDAA2gWaG8F0MLEKk6zF7XAyxefFYavpbDNwk0nbqb1oMqNneA6LAWQxiFt4DosBwe7xSJaQzLFgMZCTsuYp0VwylqH4dNktWDBR9EIHiIVUMGrZYD5B8VAzhlQPuo/pTDKf3lVFP0VIMblkntfqnUQwm0UP8iiIpe67ULJL2vyh7bcCKTMrcUAyMyAPfshJNDKZgvIVQGUwMDdSNvtRx7Xps7CLsdG/semfkEdKthut625nfSADq6nqfgs4uOQFGDJ1RR9qQZ0UMkhDAsk+DRAxTLf3Z1PlCDARlW6jnAEEM2q4s4b75QAwzBxvDOlw/DAhR7PsSVT4M3pq8NOlNPQyz5I1twEY8DIkuXqaXPzsMXngv3244RHpjHXe2e246DDTC/xdFMTp6V2zKF76TOQwKDNBQHCo5ep+Ja+PT3Dh6JJgosOE7N3q3UoZg7MA2epxE+m6b3DV6w4eZoETYNHpWuDfS7dMzeiY3CKIUjDJ6KaOdh6GOMXpti0O0A6M4DN9VoYnzIjcMtZ9xwsobNgwO+GGkR34bejpK3gkeWhp6o0RmU50RGXoMR+6cHMkYeh8/ggIp5Rd6U+oM1eAVFno+sZanl0YVerIjuDOO8RR6D3BoFWCVE3o7Pusi6rM1DCpPkTZqUzQMTQngtdafMwxxwy81Q+wyDEszO20hWzEMbu2K7I6nMAy1eCUSa/YvDM/qutsQ9C4MnCk7vOK2w3mNW2WI4trCeVa/1zJ2OS0M1hS4rvEPLAw22QjNExuyeQrLwa93risM+xNX6zUmKgzSUNTdRH8pDIRGtKRKLJF59iYqfDczKAzEQANsgjInDE8CaTv2HyYMu4jSRFybJQyW3MuRyjMkDOUc87WW3CMMV1t65c4QIgysspSNk000eeNkfbaMIx4M6QHokrFJHQy5S8XiD1AcDCdlV0a7JhsMxs7pqWf9GgxkOHsNEtQZDNNRDXG+qhgMeQNtWR7NFwzbPRL3cJkWDGzIt5TCZRUM/lJcMhMyFAxgjQDQZf4TDEmpKqnYTxIMHfTSe5N3EQyGZCqp2E8QDDqk0nuTdw8MjNrY7VqhDgwxF9jtWqENDKIOHYWJdAwMBKlwSiGbCwzCtB2FiXQKDBYncEohmwkMrtqkC8FiCAzmOcwsZYpIeKPIh5Zj6Ed46hvQYkDIBwxRbYsMRGIGDOvBiwxEYgUMFZ5n+zzIAwz8tRLpp0ACDFcGZ/s8yAx4oSnA9yEPC3gz4LQWny4KeDZ+qDUdTgl4/yyb3vYCAAzBgRLpp0D/C1mhanOZ1f4LuNZqc5nV/QtQ7Go+llb8C48tFxaivPoLE3QEPNAv+Qvl8xtIHwv4C6RQravL4fcLGf1SgrZU9gtD9K4KtkL1C1JCTQ9HbfQL9uzxhtI/8wvRa7b+xbzyCwJQod5t2vELc+SB5YuE8At2QnAe6YjvC8IcJpwzeO4LPkfbGX5nHncO8DyVkbodd7jXITYubRx3bxS+adFoG3cWYpLUo9npC4CT/ThLoOgLq3CPnPd25wsEniIAo03mCy97tGNOJOULiKhGx/r65AsJutgqptHjC3ryao5RqOILsW788f1+4QtFGIiAvvHgC55HGuRpyN0LjIHH4KhP3AtjF9MC6QHbC2up5q4bDYR2GtpRAtNL2gvG+TeiGJqDdqT6gbgZC9kLwL4vUeQV2AuB3ZziO9nXC5JSJuQO1dYLA3ZFBKYD1QtJGwqn1ZLUC+2B+KGiI9MLUdRb5HrL0gshTAt2QbDRC+hP0BhwP9ALvyKq6U91zwtAIx9GMTfOC0aNAva+SM0LchyvSff9+HX5RQfyXErMCwg5jXr2wMsLJwAB19iCygtvDfCHHynjdYJPm6NxZuJ1FgSk4+qv4XWXQMIUKZngdVmOPRbLPN91mBYB7r+23nUXZaM3cHDddciT7Xyg2dx1RrXWX+RI23UTCb9CJ7jadZu9qtaYn8kLaGx9b30h2XVI3PCTmHHYdfJCyCuii9d1adZ4Rg951nW9OtGKtAHVdXFQS4S05dR1kHQaLkWk03VGrG4bsvfSdWtIFU6gptF1+xct3CvyyAso1858Cp3HCy+6bhbbwMYL8CS/I2g8xQvog0wLxjTEC6nunRhUsMMLbFzLhAYbwgtnFdIiPMnBC+2oPS+LBcALM0Us+dAnvwtu9a/ZEfC+C0tERsf6+r0LjmxD/IoivAv/L8jRQjO7C6gaejIP6LoLA/JPR5fcuQuiNA3yx0+4C493j+k0tLcLxPA096/otgu+AOH3pt21C90jKr+7N7QL96U42M8KswvkM4gPF0CyC4KdXUpf27ELnbk3BUCmsAvAOV1KX9uvCxzfNwVAps90cvr1NRnhzXTdCWzjX3OsCyGcAYQSibF0bJzeMKO4sHTRty+v4cyvdLMwCw+gjqsLWkG5hVITmnS10ErVKIaZdO45i8PSqaULHmYOWSp0pAtouWt4LGKiCy1jmaQ3iaELUY2bTn3foAuo4b5r9XCfC2NeNH6hNit0OXBYXHXjKnR6olkUJPKdC9WR2c+ddJwLx6OGOW/Qmwt8P+Tnui0GdOaOkHiEiQV0dnq/owAAmgshqscTSYqZCwFRQqmtCpgLSc2uI969lwvhYPXyZlCWC7KariPevZUL4rD18mZQlAv2isDjI6CSC4CgGJ0bp5ELwCSqAMd9kAt0RzaPh/CPC7TLyPIzx44L9U9aVt+djQuZQKLkjfiMC1+iNEg5z4sLVFTGq+WligvKT+O4w5OJC+T7FUyDZIgLDET3rWlphwvCsGCjhZiGC+7CyZihx4ULGdUyjr32hAth6Hs5n2+DC4365C67noILuAxNJNfNgQsAIJbPuUZ/C4YGerzTY34LUaouiWWifQvnHFVCU558CwiX/BxYmnsLKhGj912WyXKLD7JRtyvHcvnCjXRhq8VyZ3ZolwsregsXyCyrMTfDctoFPSgxZ8FySLkYS9vmv3K2bPNthWa9ciQgzpAv5rtyktOps9lleQso0sPkCV94C0lMar8OW3cLa8YRmhNXlXIH5Dxze0h1C6XLAr85U3QLka3FRas9cwsvNLF6E3lyC43lp0HwfnELeIlZLmq5cAtZYppXFjhvCz8oP+m8eG4LDpS99NnFbQsxwkGOCv5sCwqjPA/WXmsLwzTWP5a7JXKbmX6TXMEkcrgPBbMsV2oLCz2tCCpIaQvu0AMM0zpoC2jLnVW74gtyDXzajEVwCnJT4F7l19MJcvlf4j1pNwhyn99mlvuaB3LlQ+rujf4GcovDbkcfYmcL8Fp3Vd1sBXJDvcriq/AEcuk8Tjs9VANykLzSk8+3ZgumQzdSoUT0cYQs3uGj//NxUpttxy1F8nHwufyst4plC87SG44+Q/FxvCBHZ5uE8HFbP9ZMJspkC+8QsAQVIGML4vqTGp5vYgut5XFUirthC+r2m5axmmAL3fTay5jTXws8BkjguMKtcdStTuV7614LBni1E3URXQuzyySjQXdcC7GRHjIeGFsL04WZeRxPWgtw2MMEH8NZC4xqjfKYuVgLnscHPytCVwuTgimN9rlWC5I9qwOXalULlLUd28iBVAvx1xF+Xig/ccjCGVpiW1MLdGVYf5MPUguAJHO/JZVRC4ReYr0pvVALViH3yF/1TwswEyzCve5OC/E0BniDlk0Lw0P9AQllTAuaPyvcskFLCzWWP/J2OkgLFBc1gwp+RwtLs8ImI5FGC3haqQ3oEEUL+L0GFI2eRAubXR2H1tVDC/Duq5F55kILV9pBU+UjQQu+YZI5ffpAC+2rGbSNyj8LO+OwMBhHPguw3UfpOro9C8IdkXHHZTwLh7D+8wiNOwsDfqtr4wA6C+3JAGEH0TkL25drzdqMOAs7Rch9Mko3C/OybSXVsTYLmhf0SS28NQuX3Tfq9mY0C9zkxFdJBTMLKuhr/V7LMgvcknLT1okxC+eK/BDdbTAL0iOv1EfdLwube9xOtk0uC49em9TWEC0LHX7yvHjRuG96AfACCTgsCxgJTxRR8ysLWCZOKFPsKgsEV1f6M+cpC98PGp6wqSgL5YtVM4CVJwurIAf/t/cmC8bCMkur4CULNOz/1x0KJAuYncPpGdcjC8o+rVYiGiILBmGa+Q2jIQu0z/RqhJkgC81QWhbqvh8LJBUhLmpNHgvo8Cxk6BQdCw1Ms2HWwBwLfr8KO9FsEG9yWrfldlwPb080LKJXBw5vTOarowIpGwu/eLTLQwINbwtDuS+82wxv5FsaI5lrC2+9dHoWdfsKb4VGos8+hQlvXl8CwxoVCG8mMSp84p4Hb/9Jim+/LgZv2GLrYpy+BW+gNBIcZEgEb3lNcw9B2BoLWYY8RRCAA284qoGb+ooCbxHD4o7XGgFvTp0hE832AG+nH0jMloD/bhLpqb9yEP5ua2vQeDqa/W7VNDFsFyr8bkD+kV/0uftumIC4GLxD+m4DShkMmdMZC9VnbqOBYPlu/8orsB2s+G5WBO7wJGf3bq09sDEqIvZuA54mw1En9W5a1+gDWOL0brE3XpV+5xgLLlRYRk8jFwsdpSiyplsWC74t+nfQpxULCrc//wo1FAtP1bQ2NW3GbmhOqZ0kzMVuJC3bnOU3xG5AJwycp6PDbvwFPptoD8JuGABvmip7wW7U3qGZ7ObAbpC90pitUr9urLcEmG++vm5oljWXMCoTC+l2+i42Xr1uG7l3hdNsvG5NEaiElNgSC0Iw9RVC8BELmY2oRiIkEAsUqVLqCloPCwAb/oSlxQ4LSGZHBehXDQuQcn65ausMC5s20jM8SQsLxEC6nFxsCgv6s9+CFqwJCwPam+Q1/wgLrw7SMzxJSG58jff2D+QHCyfRzu6FzAYL8iAEtOIrBQukD2xl/OMEC52JmII77yFuhJJg95GGIG6v6dxgQaYfbhUepjnPSAMLwBSLC828AguaRSrav38BCx+BBIQaVQALOGO/s6iZ/wrT4xMJ/Iz+ChNAxBj0Mf0KE3VDTDUS/Apemtl42XH7CjGYzH1azvoK8U3TE7kR+Qpj++dGaHD4CpCs5hIbAPcKXvAERtHk9grCjm337wX1Cs1Fhe6bqvQK85nG37kw8wqUs8zIHRLyCpxGbASlbfEKdWipIT2S8AqwQvnR1sTvCoAJ9d59ge4K7/6CVeKd7QqCol8cp+7sCuOFpMihjesKc6kzDsLQ6gr6S3Z905LpCgPXAVRvr+gKcACL8kf65woJZc3XP2TmCm3x6/RmsOUKYYG0F05p5Aq5z4fQb9/jCn4D5N8cM+IK7Z7hdWDX4QqLFsrZtIPgChWCvSBwJd8KZcSHw+q03gq1CF5kywfdCvEZzUGg0NwKdBkoxmRI2wrC6fXWuzLaCgJN40h7LtkK3raxg3NF2ApBYlDlYoHXCgif88q4F9YKkmq7LJdC1QpWvEbZXTjUCqLvdnLV5NMKZj/Eeayi0gpwzVf24RPRCpk1Z+wnJ9AKbE73eTSxzwp633PjZ3fOCtedT8rhNM0K/XQcbFcxzApbdO++3GbLCt0/neLF3soKZl8WpMiAyQpGz9E16X7ICgXF3i/NB8cKSmTlMaaTxgr8xns4aGe2a0nsVjRLZrVrGP3w4dcItGsP+84HATeza2TmeXJMaMUK+a3qfQO5rGt4xKvLxx+ra4VO47/JWKprFkrESJF6qWtFBg+aKHPECtiKmEY2g8MKuGdGD2lNwgrWUMJ+NQTBCnf3UzmbssAKTCylcGjovwogYfenNB5sayZKJT9bOL4KwgeJYprMZWtrBsXa/ou9CpY825lmArwKanEt0TM4uwoMGL6Lmea6CuBMEMNlHLkKtIFi+jJSuAqItrQx/4e3CipdRexkNiVrvlcmG8adtgr+kZcjMWy1CtPG6lr+obQKdG17FWNQBmuaB3KzW6wFa6RZxcczSQRrPTeWb+AgA2vt8Zpr/fwCa1IXeYh+wAFrjYclqittAGuiDgRhDRv/anKjULPmJrMKSaLNTDCGsgod1x+E/buxCq0p68GNVrAKFXAD8wx2rwq/fbA+YmquCpOyAnYvoK0KZ+dUrfzVrAo7HKbkyAurCt3COJ8uuqoKsfeK1vvvnGoJGCwZ5Fybau23hgIOKqkKhSzcDcclqAon023ILdSnCvsHv//6CXxqZuw+1OMRpgrPPBE3xj97aiHgloYwQ3pqResPgz8LpQqIzr+8z0+kCqz7EvSchWBqP4uUXkWzX2rDI8f2wTteao/3GaE8VKMK0ShkK2m7XWpSkjrn6chcaq6EQE8GP1tqaWhKrB0OWmpvhNh5iyhZatFoRL5Ga1hqPzR4XJrZV2ptaeN5Vf9Waonl8aDhY1VqkMvna+neVGqKmSHuriCiCvVVtmI18VNq+q6Fe26IUmrBpML7LDFRagJMcCWC2FBqJlwa/9XtT2r6dy8AT9tOaot8VlwEbU1q9cT2uTFfTGqXz+2YImlLalSRZ3DSPEpqCPvDPPEOoQoYv0cdm59Jak/aQtCB5Ehqb8M526FZR2o4mgQpf+ZGalpK/5VAiUVqdco7ovd7oAo87JlUaNWfCmAZ64s0C54Kg4J8Rpq5nQqor859Z++cCszcILUzJZsK70Wyb5nTmgoTcwSnZgmZCjegVt4yP/Bpbh4EdPadmApczagV/3SXCn42OdBlI5YKo2OLBzFZlQrHkN0+/o6UCur5bvlkPZMKDifBMDBzkgoyVBNo/aiRClW9pCJjV6Bp732FFuBCkAp66vZZL42faQlg4LGYX48KnhdIkfzCjgrCRJrIyfiNCuWtK4Mup4wKCdt9uvvcdmmkIQSEGlV1aakXv7OomXRpvg8TCfyMc2keacQY9DFyae4zQ0w1EnFpex7ZeNlxcGkxC8x9Ws5vaZGG0xO5EW5pmUvnRmhwiwouCNDxyBJtaVbx5hIbAGxpzyAERtHka2lBwW337wVqaXMMhe6bqmlpPPfG37kwaGlwEszIHRJnaWuZbASlbWZpfLapIT2SZWlH/vnR1sRkaS9d9d59gYoKKaU/002+Yml5618cp+5haddBpMihjWBpsoQzDsLQX2nXLXZ905JeaVDWAVRvr11pynCL8kf6XGmWC83XP2RbaS/Q6/RmsFppOUy0F05piQqJHXQ43hNZaYMuh9Bv31hpxCzk3xwzV2nxnc1BoNBWaay6KMZkSFVpuwjhdWDXVGnMvcrZtINTaWa4vSBwJVJp4MOHw+q0UWkM815kywdQaYdP9da7MogK+9z1TE4fT2k8quNIey5OaZt3sYNzRU1prExQ5WKBTGl7W/PKuBdLaRoWuyyXQkppmIdG2V04SWnLxnZy1eRIaRH7HGxXMUdpNc7vvtxmRmkeLJ3ixd6HCmycdmG+KkVpxtwWpMiARGlPp9E16X5CaefQxHmsokFp0EFX9uETQGnTdWfsJyc/aam993k0sT5pg7xz42d3PWkzZE/K4TQ8aZZNUxr/AjtpireGQPUFOmkC8IWrBf45aUrY650H3jhpwhDrCBfWN2kK+VH7GbY2aVPht+0cljVpyxm2WCyONGkTAhxLLm4zaeK07fC72TJpXGHeL80HhQoUybp6fB0xaYuD5TGmkytpq3z01cT5Kmlx3oY5b9ApaWaQGJ0bpyhpLPKqAMd9hApHtePlvhMnaV0eNo+H8CZpJIDI8jPHJWnq4VpW350kad+T7LmKdCNppfV+HTZLImmbpxCB4iEhaQg6ouSN+CBp/240SDnPH2kl9Mar5aUeaRwpWA+QfIMKeqEMUQEKHWkIAwPuo/ocaf83lVFP0Rtp9mwntfqnGmkc8rkYpn4ZaRInS3xSVRhpOKzd3/0rF2kv4XBDqQIWaSUWAqdV2RVpS5uUCgCwggq/1IJrI7YTaYerjNbaxhJpAjFZDNzuEWmMOSp8i6YQaQe/97GNzg9pgkTE54/2DmksGimWnjYNaaef9sugXgxpIiXDAaKGC2nEMK4Ch/CBCvHAq9ZlrIAKJK3UQaii9mjr0mpJfnF/CmngSVzKTvVobghrXBHN9GiWQTpibIPzaB34c3H42PJo51UmWaEn8WgLJGRIy7/waM+ScQOSfO9o23Xhenv37mg43mpJfnHtaOGua1wRzexokhA6YmyDfgqczHLHDUXraDKrc3H42OpocNkmWaEn6WjTz2RIy7/oaHPMcQOSfOdoUUnhenv35mg9tGpJfnHlaH70a1wRzeRoekM6YmyD42inzHNx+NjiaCsEJlmhJ30KzricMk874Whn42RIy7/gaIRDcQOSfN9oq0nhenv3fAoBpcWdkjF7Cj1jtXSK73oKcE/e383leQqjOwdLD9x4CudufWUxiK9oK7qM5vdlrmgP2j8G4rOtaJUB0EoB7qxof8C22Qmfq2iqR64vWbOqaN//OF7WialoAHs4zJmOqGiK5t3ni12naAZI65UuNXcKGlum0HR+o2joJK4jr8eiaFd3wjNXwqFovzGTFElcoGjJ6GeUU8afaDxZUaGcHp5o2l8+GNQDnWhBLcaNMw+caM2K/8gZz3YKTUfPO7Z0m2j4iyhB/O2aaEnhaEflzplohFSvzDxTmGgAGEKZZZeXaLqBYxqQbZZoP9CWplk2lWgnS2zrGIOUaDjyzNox9JNoDwNhj4TnkmgI46yyNcp1CpF6RFbZIJFobdoVOA3CkGjaKW1kjmqPaEInEf5zdI5ocxetcx7oiGjefWJkRWx0CsRmbcEbF4doAzQYSoUUhmgkaeiCDDSFaK9NgbQ7OIRoxmXQlVcRg2gyFa+g6GmCaE2TKGLlKYFoQENuGgXkgGh6wn0UvbR/aFL038vwrX5oIA7MDv6scwr3UpYsXg19aF9/fclt23xoyAwaPEe5emhoxtO/iH95aO8aToAGU3hoIRXdt5NTd2jjouUHMiJ2aOQic1vQzHVo3m6QXJbudGjcpIYY9pByCio/v5egA3NoVMaCmjigcmiRe42c2sZxaGdDFP4p4HBoWXYkmDlKb2iaOXYB3UFuaNz8yWqAOW1oYzQN/T3FbGik92Bm4LxraBRiDjwkF2pomeJJjR+qcQpm/bBumcFpaMH5X0e3w2JoUs4ZK9/9YWhTr9dFr3VgaCZAlmB+7XAKmenZ2du3X2hsd/asWTleaD8ItccpsV1oEplz4vgoXGgUejL9yKBbaOYK8BeYGFpo6OuvMmiQWWj4MW5NNwhYaHUZLGgHgFdoIVHrgtf3VmieOKmdp29vCsvVAkUerlVoywsRS9niVGhI89BlqVpTaMTajoB50lJocRJNm0hKUWju+Qu2GMJQaJoxytDoOU9oFxmI67ixTmiUAEcGhylNaEA4BiFXoW4KEAl3X0BaRGghJmKDYjxtCkP1oMqCUGwKduHKNcVGawpvv4jIfHlqCjRcsTO/b2kK+PjangJmaAq8lQMKRFwIaOa5zTv9CmcKdID04DwaZgo4HR1MfxBlCvy5RrfCBmQK0p270eSyYwqWOuQ8JqliClrXDqhpn2EKMLuDwotLYAr0V6wtzUFfCrj01ZgQOF4KfJH+A1IuXQo1fO/aS+xcCvkYGEaN4lsKvbVBsdDYWgqTmbbL8oRZClc23zY1e1gKG9MIondxVwrwtn68mR1WCrVTpyfcE1UKefDQkh4KVAo9jfn9YQBTCjZ5LwWA4FIKsQP3dyNlUQosjr7qxulQCqBq2k4rzxlnO1b8lRg7GGcv4Bk8vCwXZxChA+3DI08KnVFIt96wTgp8LlYEFS1NClwLZFFLqUwKcKB40QDMSwoRRwppTepKCuZ7/BsWbtxmmVBYfnxr22ZUW6pKPtdJCrqw7s7g8UgKXFeAZi0QRwowjHIZ9pNGCgTBZMzAF0UKpmf2Yww2RAp6nOgW1rlDCk7R2smgPUIKIgbMfGnBQQrErF4Utt9ACpjhUMd/Y31m1Xf94EuxPwptFkJ6Sec+Cg691BGWBT0K4vHGxF+JPAq3Jrh3KQ1TZtQOAKbun1JmR2kgML01UGYRIP+/b5FPZjVQ5ZXFmDsKWM1KD3UrOgotAjzCP685CgE3LnUJMzgK1WsgKNK2Nwp3ErK/H9U2CktHpHLoWDUKH3yWJbLcNArBIii9//ozCpVXGnDIfjIKaYwMI5ICMQo2qCRTqvMwClrVFgZzdy8KfgIJuT37LgqjL/trBn8tCsaYjANTnSwK6sV/th0hKwoO83Fp5qQqCjFcAgEzwykKVYn0s/xGJwp6tudmxsomCpwfeP4T6SUKwUxqsdxsJArleV1kpvAjCgmnTxdvdCIKLBDgrrySTGXgV6CQ440hClA902GGFiAKdWrFFE+aHwqY01asnLgeCrwASF9lPB0K4C07Ei/AHGVuPFRrtBYcCgOXzKl83hsKJ8S+XEViGgpM8bEPD+YZCnAeo8LYaRgKk4c0WiWI7WQam/04S6DsZBm3j5z3dutkRyMiAKNN6mRGP7RjTiTpZHSrRsf6+uhkpKvYKqbR52QTxWqOUajmZBou/PH9fhcKt7QnDe8L5WTwPYiAvvHkZCFzGuRpyBYK2+EZwLiPFQpp76UM21QUCshnDk5isRMKOievyf0TEgqr5lBFmHYQCu2ZhVSJ2w8KIIaATpetDgpTcnpIpn8NCpelrnzJVwwKypGpdtcpCwr9faRw5vsKCkGx16QJ1AkKdJ3SnhemCAqnic2YJXgHCtp1yJI0SgYKFjTjmUhLBQpJIN2TVx0ECnwM2I1l7wMKwD8MwojHAgrzKwe8lpkBCiYYAbalawAKaks16shD/wmdNzDk1hX+CdAjK97k5/0JAxAm2PO5/Ak+zkDfB7v7CXG6O9kWjfoJpKY20yRf+Qnp2WoHRzf4CRvGZQFVCfcJTrJf+2Tb9QkTY3HAoP/0Cdf/bLqv0fMJnJxntL2j8glgOWKuzHXxCRgkfbXgdvAJ3MB3r+5I7wmgXXKp/RruCXZBpt0g8+0JOt6h1y7F7An+epvRPZczYxDWhSKFkDJjLcpsBi7FMWOSplTq1/kwYzehPKdyVy9jYnokixuM6wnUXs8FX2/qCZj7yv9uQekJXJjF+XwT6AkgNb/zi+XnCdgf2vqf5uYJnbzV9K245QlhWdDuvIrkCTY9BCPfYuMJ+9n/HO004gm/dvkW/AbhCZRaLUsf3+AJWfcoRS2x3wkdlCM/O4PeCeEwHTlKVd0JQdWwGAV53Am8X9L+w4iPYtmRldOvodsJNur05ICY2gkdC0i33rDZCdzEZFFLqdgJ/QoKaU3q1wmldO7O4PHWCRtQchn2k9UJkSv2Yww21Ak6ldrJoD3TCa9wXhS239IJWNpCeknn0QnOtcbEX4nQCUSRSg91K88J7PoudQkzzgli1rK/H9XNCQtAliWy3MwJgRsacMh+ywnoTiRTqvPKCTGpCbk9+8kJeD+MA1OdyAnBmXFp5qTHCQgw9LP8RsYJT8Z4/hPpxQmYIF1kpvCoYVYtY0KBbMQJ37bgrrySwwknEcUUT5rCCW6nSF9lPMEJtT3MqXzewAn+l7EPD+a/CUUuNFoliL4JjogZwLiPuwn3xOp9A7m6Cbd+Rg9pTT1hSNevKqPXPGGo3OzBF6A7YUcbmfiop7kJDFNTOZuyMmHEvxPyXqgxYY2lFKoMtzBhtqYUYrvFuAm0vPenNB4vYavBIjK5CC5h1MIj6mcXLWH9wySiFSa3CSqY25lmArYJoHO+i5nmtQlJ3WL6MlK0Cb+4RexkNrMJZyLqWv6h9WDMM+jhbET0YM9VOa4usLIJ3f3NTDCG82A2B0I90PLyYDgplAmSXvFgO0vl1VPKsQlT2bA+YmqwCfxCVK381a8JcR44ny66rgkaiNwNxyWtCZBjv//6CawJwRW/vM9PqwkJcGQrabuqCVAGRx2bn6kJmWDrizQLkGDkR1zsB2KoCeD2zn1n749gWx/voZTwjmCkcXXBJlSnCSeNsm+Z06YJcOdW3jI/pQm3fTnQZSOkCQDY3T7+jqMJR27BMDBzogmOBKQiY1ehCdZeSJH8wqAJHvUrgy6nnwlmT9DxyBKeCXWreOnwL50JNnUl4roSGGCdBoY38tecCV1AoVmAFZsJC9IjT1lBmgmEAfaF4HiZCRfBs2j4RpgJ8TUMNXUmlwmCf1zE3rTkX+7Tqu9PzuNfurTzv52flgldukYSfFeVCdJpL2AZ+pQJN3kEy4xfkwljXm0kuJe0X4YhnXAMOZIJEbb0Nc47kQls5EeY4OGQCfO+G0FQK48J5fHJm4o8jglmbcmA+9uNCWxzC1KHZYwJxIJ48LFfiwn94Ap7IvCKCcV2bnMGIYkJmav9sYfOiAk7UnOmijqHCQ+HAuUK6D9f2H5plNHZPl8fJirlWC09X5NSF15WtTxfmNHsr4i3hgnju5Aji5U7Xw1pputFHjpfcExN5D2BOV9Sk+4yJZk4X8+VlSsc/Ddfxw9k6HNUNl+FR2Y22ZU1X+jEwSIBmDRf7JiHan/TM186lH9rKjcyXygVFE+k84UJuPAfYgtDhAlZl5VWDq+DCS7MJJWPXBtfRF2/Z0l1Gl954gVJSS0ZX9y3SypK5RhfED2RC0udF19zEtbsS1UWX9fnHM5MDYIJAgGz0w8KgQmjpynIEnaACXjctwaTI/leNMy+RM8G+F6XoQQm0L73XssmSgfQdn8JTBFGRRPR8l5OPnsedrrxXnXmS1f6En4JwlSmBmQdfQnmgTVF5Mp8CQqvxINkeHsJL9xSwuUleglSRci26JF5CXZyV/VoP3gJmp/mM+nsdwm9CFwo7Fh2CeE16mZsBnUJEgK9NmAHiF5AlASCzGN0CUXuUuRqeHMJiiHoamYScgm9DX0YcYNxCe/5E8Z79HAJIuaoc4ZlbwlepHqsispuCZGQEFqVO20JxHylB5+sbAkIsDuOm0ZrCTuc0DumtyRekxQX3gq8agluiGXpsChpCYB6Oao9xWgJRBfPV0c2ZwkItGQFUqdmCcxQ+bJcGGUJhDvM62F98F0nMVfJLhHvXUzeJwKyaWQJSNhhmWvuYwkNdfZGdl9iCeJYjM1y+WEJpvUhe3xqXwnj5N/wWA1eCajNQP0EIl0JNuvb+PaZXAnZOrF27FJbCfmuWy554IxdUj33ZjRFi10178ifuJ2KXcalmdg89loJWL6Q0q7dWQk4E1sOmjZYCUjx4NW+xlcJQJ5lneFWVgmJMyoc81VWXd5C60nFd1Vd4eDg8MYvVF3lftWXx+dTXUk4yT7Hn1JdTda+5chXVQkHCuqs6LpRXS9pxj7WJ1BdMwe65dbfT11PIK+M15dMXWPlRRtPi0tdh/B3GhH3Sl2s+6gZ0mJJXTIi2hiUzkhdVi0LGFY6VAnyveUylOJHXREhTAb4fEZdNix+BbroRV1ILa8Ee1RAXTujUI445D9dMRzi8eO6Pl1W5XRVj5FTCXCUpMOKRz1dYGkB5FAEPF2FMpNH+9o7XeoaJaunsTpdaXm3DlOIUgntamRUf6wsXamMxxR8zytdBTqgFa7OKl2QN3oW381RCWtBI+V1ESldUjwpKSC8KF3dOQMqUrsnXRkl3CqDuiZdD562K7W5JV3Y9ElAyHMkXQj8ktNVdiNd/WfbZuF4Il0tbyT6bXshXW6KbZTQjyBdnpG3J1ySUAlW9R5rITkfXZP9ALvplB5dELRJVUupHV0FIJLo2KscXXl923tkrhtdupgkFsbCGl3qn22pU8UZXd8LtzzfxxhdDxMA0GvKF13WGp06LQgWXTos5826Ck8J08vd+xaeTglRop2MDANNCTxWmBK3KkwJuixXo62PSwk3Axc0ovRKCY6y0fhEtUkJ4sORiTkaSAk11VAaL39HCYjmD6sk5EYJIHELMdALRQl0gsrBxnBECceTiVK71UMJXx6F2Gf9lFzDXwED0XFCCbIvRGldYkEJyFufBdsmQAl6zvFcDqY/CT6InUlRFD4J8PrvoIWTPQmibUH4uBI8CVTgk0/skTsJgC3kpTqiOgkyoDb9bSE5CeQSiFShoDgJqMw0QeQONwlaP4aYF442CQyy2O9LDTUJJl9taCitNAnNMb+/WywzCXQEERePqzIJG9djbsIqMQlXY7TEEDswCf41BhxEui8JpghYc3c5LgleIgRguqctCQb1VrfuJiwJ6sIqHPNVKwlTTeUylOIqCU76ZFR/rCkJt4QeayE5KAmyMZ2MDAMnCRu8V6OtjyYJ1jbR+ES1JQl8WVAaL38kCWj1CzHQCyMJDhiJUrvVIgn6s0RpXWIhCWLdZzuajiAJu3yOhnH6HwkC1Vo8OXceCVp0gYcR4x0JCWDzpuQBHAli/xryu20bCQtyKsktCxoJRyr2fvWHGQmUKR3KzfMYCdDh6n+VcBcJHuERy2zcFgkE4KPFD8kVCQcN35/22chak+tjMAlAFAlgC6kjMbLHWk9HbL+rghMJJf71QQd0Egl+/L/FQUwRCdb6iEl8JBAJL/lSzbf8Dwn065/rjb4OCQfiQOL8FQ0JA9qS6JEuDAlaV/c4otILCaRPuDUB8AoJolXlfS5bCQkRotd3r20ICS4O13evbQcJ7Ytt8xeeBgmVwtTkIIw3WiRgCV+vmTJadqDM+fuBBQkxFEM5NRsECZYDHhSt5P5ZSso3Yb1f/VnXrsZGR6X8WTVDVSzS6vtZwSfkEVww+lkfvHP35nX5WaygAt1xu/dZTQYgqIVG9llvjK+NEIz1WWv0+kf0hfRZbR+JLX7L0lnvk3AqnYvRWTzZUy4bY9BZr32r3HU2z1kl/JmRTGj3CDGebv6WkfYI+iQrnsIc8ggaud2yHhHxCK4wp0HwfvAI47lZLmq57wh1MJpXFjjuCCsRP+m8eO0I8HC99NnF7Aj2J0GOCv7rCLo0PA/WXuoICxzWP5a76Qjuza0IKkjoCGjwAwzTOucIvgydVbvi/FjIy9wqIjfmCPOkd1XdbPJYAQgdgOsF5QiLrDdSoUTkCCeMG44+Q+MIzsSwBBUg4ggerpManm/hCDOlRKUveOAIrOE64agb3wgpaYNORa2sWNY1HYDrBd4ISR9xVIq73QgC7JuWsZrcCGFF2suY09sI8chI4LjC2ghssrUTdRHZCGt7JKNBd9gI/3JyYvc71wiy8x4yHhjWCBaGmXkcT9UIzhLDBB/D1AgrV43ymLnTCJ1EBz8rQtII7/Ypjfa50QjNpqsDl2rQCFklHdvIgc8IiDkRfl4ozgjzrFh/kw/NCIz1c78llf1XI/js7BDb/FcChDu+T//7V0EriY+NI/pXgNLYYMxH+VdfXiYyCmzMCB+mYr0pvcsIr2r3yF/1yghJoCzCve7JCLm6BniDlsgIwdb9AQllxwgtyyvcskHGCFMPP/J2OsMIxL41gwp+wgjmBcImI5HBCHcoqQ3oEMAI6icGFI2eeFeO/UZAMjh3V5MG675rFb8IXugdh9bVvgg4kKuReea9CPCzQVPlI7wIPjeSOX36uwjI7Rm0jcq6CH2OsDAYRzxXz/StsTM0uQhW00fpOrq4CAbokXHHZbcIVoz+8wiNHFd0Nr+jAAC2CHGQq2vjABVXsfCJWuZBE1dHPhrFulW1CE7sAGEH0RFXibqajr25D1cfCCv5kM0NV7VVvGNk4QtXTKNMzjj1CVfi8N04DAm0CP2Na83ajAdXJG1eAg5tBVe6uu5s4oADV1AIf9e2lLMIoZbIfTJKsgh59W0l1bGxCEYa9EktvLAIlaA36vZm21b8Wv2qPZraVqazFtx9yq8IYBjEV0kFrgiQwmv9XsusCIhxW50rbrVWOUNU+V1ItFZT7jATFqmzVmvAiJI0ILJWhGtjrO6AsVaeFj/Gp+GwVrfBGuBhQq9W0JNyX3+5qwj/sQXBNqCrVqMqkLSvm6pW9gtCaRyZqVZKFDyjf8uoVp7171fryKdW8dahDFjGplZFuFTBxMOlVpnATvsn9qFWoA+6M4qLoFbz8G3o9oifVkf5ZiJau55Wm9oZ18a4nVbuu8yLMracVkKdfkCes5tWlqV4egLmqQgvO/u8T5moCL1DiqLZ3qcIDmlac+2FpQhwnyKHo66kCL2IwWs4TqMIrOZzOjLoogitizoPGHFMVlwrAHmta0tWe3Y7qHjtoQid6ezdEQugCI1HnqwLpZ8IfKVQewU/ngiATpHtBnydCP2DglXinZwIpph5JU6tEVblRFvZTvwQVsCta6GgyJsIEc6qAMd9mggvNjaPh/CZCJc9yPIzx5gIkTmAj8DolggUdGlCqdCVCG4QRiKg8ZQIEzRKp3x+kwjgkD47LGaOCO/qVDGW/ItV8/f273+UilUUQqW8hZiJVThbO5YFWYhVs/HRb4YZjQibXBU751uMCPNUrBnZeDpVIPIstl+2hAiu1FpXnFKDCIsvo0F7yhZVBL7DmSp1FFVB1KLtiLuCCDRH4FF44oEIT4EzaGDpgAj4mHF4XQF/CDsaF4RiCn4I1YJqMkhFfQgAYDLr9X98CD1YK9F+mnkI/BbJPBvBdQgvAVUUkT10CD+Fqq2y7nMIQXaebhl5cgi0o0ZoeDBxCItWO6F0KnAIKmLpESv6bwgtDI0PHqRuCJ26iIC+8W0IcUIvA4Jk/FPEADdofuzXU+UfbnMGIdZTW/tzpoo61VMEZZAji5XUU3pAlVYOr9NTIqqz0w8K0lOYhbcGkyPRU18vpgZkHdBTqInEg2R4z1PvH8i26JHOUzh65jPp7M1TfxDqZmwGr1NMjC0lhoquUyalnoGAc61T7XYPBYkzrFPGj4BhghyrU4XsLpeUp6pTXwWf842QqVMndk+KGHyoU4D4vw0gPKdT68ExaholplNERKLtIuWlU64NE0oczloIW/kbsH2lWQghImkH/yNYCKGZ9ezflVcIq8E3sMAdVggHy3ieYmBVCG1uqZ0kzFQIGi1kTtTVUwjD7+FdCp5SCOkclV/0XyxTWVurl+JOK1NN/V05A7hRCII85nuKllAISk+A6UijTwjcQL4auOxOCKFYcqJ6X00I5s6om5mdTAgPjz+ptSBLCEpAymyMtEoIv8cAwockSQhSbxy0scVICHa3b3Xhr0cI72aBJHcBRgjmQvbDeJ1FCO8Hi8G0SkQIfFpU1ME+nlI4QPPKSZFDCCn/63RbTJ1SinGi/ACunFJ8f7ZEIHVCCPQWpEwGCEEIoOQtZ2ZMQAiqiHoys9I/CKqMCDAZ1D4IWcW73i2IaVLrcggljSZoUlur8eL9MmdS+zPZoG4/PQi5OGdG3f88CCMSuM1nVTsI4v4ykkp8Ogh3GrDPA/05CPHTGJOgUjgIttjypasgLVIHRDdqoQwsUjRUSrLB0ytSAUle+uGaNwipxCYq+uY2CIKERnYXWDUI3NrNrPM7NAjP7C5ZjwMzCE9d1JxLODIIQWtKza+xMQj4RpvbLNowCGaS7empAi8ILCsIhZAVLgg1xeFdZCbIUTzOrtqfDsdRwzszmvMoxlGsxLhZSEMtCKh08AQhkioIFAGv8hkDKQi18kFWxdkoCLKlDC+wVicI90KC0zSoJAiY8Mt5kFkjCI5S3h6yKVhR0QeJhxLwV1HRnd6hEddWUdEzMrwPviII7BDiAbCxIQjMhv4Bqo4gCGVFfkCptjdRsOw/7QtnNlFzu2tNh+IfCNfmI977gh4IedjIe01PHQhNTm0ZnxscCFDZZVCeSxsI6t8HHc/4GgiE5qjpAKYZCEw96Zq07RgIqDSLZ+WaFwhBOyw0FkgWCNtBzQBH9RUIdUhvzXiiFAg1Qi1lTbETCGUCNRl/ahIIR8seDIn8EQg6PcrN7ckOCPgSHumjpw0I1RfF/VIkDAjITa67wjALCIorsA1tQgoIfmGZy95OCQjgn8BKD64HCO9YLTkfpAYIFSUdMiAUO1BM+o/BGZ06UEG8Hqej4gUIztDu4C+cBAj1nN/ZMAwDCBtpz9IxfAIIQTXAyzPsE1C8k5CwDLIBCGgBscQ0XAAIIa2Bc0Lk/wdHeXJsRFT+B21FYmVFxP0HqdrVp4rb2E/YNJbLXzb8B03cxRQ4i9dPiTOQsAyy1k8qJYTpCKzVT8sWeCIEptRPPbhsWwGg+wf1FvHndI76Bw7rOF72yPkH0ateMuj/+AfqfzDPVIb3B97HZBZDE4RPLWVD9f3tg09p+aKv0gqCTwepAWqmJ4FPQz1gJHpEgE+A0b7eT2F/Tx2BHZkjfn5PWhV8U/ea8weybqSpmzd9TyTRoFc2FfIHRR+45sO58QcUEWcmOenwB6fBemNha+8HOnKOoInt7gfe3XpjYWvtB/E5jqCJ7ewHM+ah3bJv6wdGQrUa2vHqB8Ug8msSvyJPI056efeZIU9f4tG9PHsgT/2RKAKCXB9POSZ/Rsg9Hk/X1dWKDh8dTxRqLM9TABxPUP6DE5nhG0/urdpX38IaTypCMZwlpOkHmTl3VlcCGU/0/ad7JADoB25S/UCcRecHcbsnlcFf5gdF1K1/BqPlBxrtMmpL5uQHTfxPcVsX4wcPMu9lQj7iB0Ozg8Qfw+EH6ecXI/xH4AfFJe9lQj7fB3Lyg8Qfw94HoWIXI/xHqk5DY8EHFN+pTuAeqsWF66hOToqSg/X3p07qRXtBZgTdB8/Sq4HZzNwHG0RLdsHz2wdJtN/UnnjaB3gkczN7/dkHw5UTKGIk1weOC9/jCQLWB7bLBHxNx9UHJqPjvMxj1Ad7sUR/E41ATmkHtKi1Yz9OReHhEbx5Pk6/Z9SuylnTB2DpAIG7ST1OfsTMgUxXPE5X3ZZH1/g7TjD2Xw1imjpO+MfcIw6GOU7R4KbpmSc4TpmyIwBFEzdOcsvsxdC0Nk5L5LWLW1Y1ThO2MqIHQjRO7M78Z5Lj0geB8V/xkpwzTqsr9DoU4TJOhES9AJ+CMU4pV9A+wKowToLZTVVsli9O7KIWG/c3Lk5FJZMxoiMtTq/uXfcuxSxOGrgmvblmK05zOqPTZVIqTt0DbJnw89EHhZM3v/AcKU4038C/qvIoTosYGMqZlSdO4lFx1Ik4Jk44siv69kAlTo/rhATl4yRO5Us9KlLs0Af8z0l4VZsDDlzt5hIbAMwSFXWqVou1NBEpKb+nTlp5EODsAFi0XQ==");
        },
        function(t, e, o) {
            "use strict";
            t.exports = function(t) {
                for(var e = "undefined" != typeof window && "function" == typeof window.atob ? window.atob(t) : $2717c6280c0c11e4$require$Buffer.from(t, "base64").toString("binary"), o = new Uint8Array(e.length), r = 0; r < e.length; ++r)o[r] = e.charCodeAt(r);
                return o.buffer;
            };
        },
        function(t, e) {
            t.exports = {
                hash: function(t) {
                    var e, o = 0;
                    if (0 === (t = (t = t.trim()).replace(/  /g, " ")).length) return o;
                    for(t.length, e = 0; e < t.length; e++)o = (o << 5) - o + t.charCodeAt(e), o |= 0;
                    return o = Math.round(o / Math.pow(2, 16));
                }
            };
        },
        function(t, e, o) {
            "use strict";
            o.r(e);
            var r = function(t) {
                return new E(t).output();
            }, n = /\s/, a = /[A-Za-z]/, i = /[A-Za-z84]/, s = /[,\]]/, C = /[\d\.E\-\+]/;
            function E(t) {
                if ("string" != typeof t) throw new Error("not a string");
                this.text = t.trim(), this.level = 0, this.place = 0, this.root = null, this.stack = [], this.currentObject = null, this.state = 1;
            }
            function d(t, e, o) {
                Array.isArray(e) && (o.unshift(e), e = null);
                var r = e ? {} : t, n = o.reduce(function(t, e) {
                    return f(e, t), t;
                }, r);
                e && (t[e] = n);
            }
            function f(t, e) {
                if (Array.isArray(t)) {
                    var o, r = t.shift();
                    if ("PARAMETER" === r && (r = t.shift()), 1 === t.length) return Array.isArray(t[0]) ? (e[r] = {}, void f(t[0], e[r])) : void (e[r] = t[0]);
                    if (t.length) {
                        if ("TOWGS84" !== r) switch(Array.isArray(r) || (e[r] = {}), r){
                            case "UNIT":
                            case "PRIMEM":
                            case "VERT_DATUM":
                                return e[r] = {
                                    name: t[0].toLowerCase(),
                                    convert: t[1]
                                }, void (3 === t.length && f(t[2], e[r]));
                            case "SPHEROID":
                            case "ELLIPSOID":
                                return e[r] = {
                                    name: t[0],
                                    a: t[1],
                                    rf: t[2]
                                }, void (4 === t.length && f(t[3], e[r]));
                            case "PROJECTEDCRS":
                            case "PROJCRS":
                            case "GEOGCS":
                            case "GEOCCS":
                            case "PROJCS":
                            case "LOCAL_CS":
                            case "GEODCRS":
                            case "GEODETICCRS":
                            case "GEODETICDATUM":
                            case "EDATUM":
                            case "ENGINEERINGDATUM":
                            case "VERT_CS":
                            case "VERTCRS":
                            case "VERTICALCRS":
                            case "COMPD_CS":
                            case "COMPOUNDCRS":
                            case "ENGINEERINGCRS":
                            case "ENGCRS":
                            case "FITTED_CS":
                            case "LOCAL_DATUM":
                            case "DATUM":
                                return t[0] = [
                                    "name",
                                    t[0]
                                ], void d(e, r, t);
                            default:
                                for(o = -1; ++o < t.length;)if (!Array.isArray(t[o])) return f(t, e[r]);
                                return d(e, r, t);
                        }
                        else e[r] = t;
                    } else e[r] = !0;
                } else e[t] = !0;
            }
            E.prototype.readCharicter = function() {
                var t = this.text[this.place++];
                if (4 !== this.state) for(; n.test(t);){
                    if (this.place >= this.text.length) return;
                    t = this.text[this.place++];
                }
                switch(this.state){
                    case 1:
                        return this.neutral(t);
                    case 2:
                        return this.keyword(t);
                    case 4:
                        return this.quoted(t);
                    case 5:
                        return this.afterquote(t);
                    case 3:
                        return this.number(t);
                    case -1:
                        return;
                }
            }, E.prototype.afterquote = function(t) {
                if ('"' === t) return this.word += '"', void (this.state = 4);
                if (s.test(t)) return this.word = this.word.trim(), void this.afterItem(t);
                throw new Error("havn't handled \"" + t + '" in afterquote yet, index ' + this.place);
            }, E.prototype.afterItem = function(t) {
                return "," === t ? (null !== this.word && this.currentObject.push(this.word), this.word = null, void (this.state = 1)) : "]" === t ? (this.level--, null !== this.word && (this.currentObject.push(this.word), this.word = null), this.state = 1, this.currentObject = this.stack.pop(), void (this.currentObject || (this.state = -1))) : void 0;
            }, E.prototype.number = function(t) {
                if (!C.test(t)) {
                    if (s.test(t)) return this.word = parseFloat(this.word), void this.afterItem(t);
                    throw new Error("havn't handled \"" + t + '" in number yet, index ' + this.place);
                }
                this.word += t;
            }, E.prototype.quoted = function(t) {
                '"' !== t ? this.word += t : this.state = 5;
            }, E.prototype.keyword = function(t) {
                if (i.test(t)) this.word += t;
                else {
                    if ("[" === t) {
                        var e = [];
                        return e.push(this.word), this.level++, null === this.root ? this.root = e : this.currentObject.push(e), this.stack.push(this.currentObject), this.currentObject = e, void (this.state = 1);
                    }
                    if (!s.test(t)) throw new Error("havn't handled \"" + t + '" in keyword yet, index ' + this.place);
                    this.afterItem(t);
                }
            }, E.prototype.neutral = function(t) {
                if (a.test(t)) return this.word = t, void (this.state = 2);
                if ('"' === t) return this.word = "", void (this.state = 4);
                if (C.test(t)) return this.word = t, void (this.state = 3);
                if (!s.test(t)) throw new Error("havn't handled \"" + t + '" in neutral yet, index ' + this.place);
                this.afterItem(t);
            }, E.prototype.output = function() {
                for(; this.place < this.text.length;)this.readCharicter();
                if (-1 === this.state) return this.root;
                throw new Error('unable to parse string "' + this.text + '". State is ' + this.state);
            };
            function D(t) {
                return .017453292519943295 * t;
            }
            e.default = function(t) {
                var e = r(t), o = e.shift(), n = e.shift();
                e.unshift([
                    "name",
                    n
                ]), e.unshift([
                    "type",
                    o
                ]);
                var a = {};
                return f(e, a), function(t) {
                    "GEOGCS" === t.type ? t.projName = "longlat" : "LOCAL_CS" === t.type ? (t.projName = "identity", t.local = !0) : "object" == typeof t.PROJECTION ? t.projName = Object.keys(t.PROJECTION)[0] : t.projName = t.PROJECTION, t.UNIT && (t.units = t.UNIT.name.toLowerCase(), "metre" === t.units && (t.units = "meter"), t.UNIT.convert && ("GEOGCS" === t.type ? t.DATUM && t.DATUM.SPHEROID && (t.to_meter = t.UNIT.convert * t.DATUM.SPHEROID.a) : t.to_meter = t.UNIT.convert));
                    var e = t.GEOGCS;
                    function o(e) {
                        return e * (t.to_meter || 1);
                    }
                    "GEOGCS" === t.type && (e = t), e && (e.DATUM ? t.datumCode = e.DATUM.name.toLowerCase() : t.datumCode = e.name.toLowerCase(), "d_" === t.datumCode.slice(0, 2) && (t.datumCode = t.datumCode.slice(2)), "new_zealand_geodetic_datum_1949" !== t.datumCode && "new_zealand_1949" !== t.datumCode || (t.datumCode = "nzgd49"), "wgs_1984" === t.datumCode && ("Mercator_Auxiliary_Sphere" === t.PROJECTION && (t.sphere = !0), t.datumCode = "wgs84"), "_ferro" === t.datumCode.slice(-6) && (t.datumCode = t.datumCode.slice(0, -6)), "_jakarta" === t.datumCode.slice(-8) && (t.datumCode = t.datumCode.slice(0, -8)), ~t.datumCode.indexOf("belge") && (t.datumCode = "rnb72"), e.DATUM && e.DATUM.SPHEROID && (t.ellps = e.DATUM.SPHEROID.name.replace("_19", "").replace(/[Cc]larke\_18/, "clrk"), "international" === t.ellps.toLowerCase().slice(0, 13) && (t.ellps = "intl"), t.a = e.DATUM.SPHEROID.a, t.rf = parseFloat(e.DATUM.SPHEROID.rf, 10)), e.DATUM && e.DATUM.TOWGS84 && (t.datum_params = e.DATUM.TOWGS84), ~t.datumCode.indexOf("osgb_1936") && (t.datumCode = "osgb36"), ~t.datumCode.indexOf("osni_1952") && (t.datumCode = "osni52"), (~t.datumCode.indexOf("tm65") || ~t.datumCode.indexOf("geodetic_datum_of_1965")) && (t.datumCode = "ire65"), "ch1903+" === t.datumCode && (t.datumCode = "ch1903"), ~t.datumCode.indexOf("israel") && (t.datumCode = "isr93")), t.b && !isFinite(t.b) && (t.b = t.a), [
                        [
                            "standard_parallel_1",
                            "Standard_Parallel_1"
                        ],
                        [
                            "standard_parallel_2",
                            "Standard_Parallel_2"
                        ],
                        [
                            "false_easting",
                            "False_Easting"
                        ],
                        [
                            "false_northing",
                            "False_Northing"
                        ],
                        [
                            "central_meridian",
                            "Central_Meridian"
                        ],
                        [
                            "latitude_of_origin",
                            "Latitude_Of_Origin"
                        ],
                        [
                            "latitude_of_origin",
                            "Central_Parallel"
                        ],
                        [
                            "scale_factor",
                            "Scale_Factor"
                        ],
                        [
                            "k0",
                            "scale_factor"
                        ],
                        [
                            "latitude_of_center",
                            "Latitude_Of_Center"
                        ],
                        [
                            "latitude_of_center",
                            "Latitude_of_center"
                        ],
                        [
                            "lat0",
                            "latitude_of_center",
                            D
                        ],
                        [
                            "longitude_of_center",
                            "Longitude_Of_Center"
                        ],
                        [
                            "longitude_of_center",
                            "Longitude_of_center"
                        ],
                        [
                            "longc",
                            "longitude_of_center",
                            D
                        ],
                        [
                            "x0",
                            "false_easting",
                            o
                        ],
                        [
                            "y0",
                            "false_northing",
                            o
                        ],
                        [
                            "long0",
                            "central_meridian",
                            D
                        ],
                        [
                            "lat0",
                            "latitude_of_origin",
                            D
                        ],
                        [
                            "lat0",
                            "standard_parallel_1",
                            D
                        ],
                        [
                            "lat1",
                            "standard_parallel_1",
                            D
                        ],
                        [
                            "lat2",
                            "standard_parallel_2",
                            D
                        ],
                        [
                            "azimuth",
                            "Azimuth"
                        ],
                        [
                            "alpha",
                            "azimuth",
                            D
                        ],
                        [
                            "srsCode",
                            "name"
                        ]
                    ].forEach(function(e) {
                        var o, r, n, a;
                        return o = t, n = (r = e)[0], a = r[1], void (!(n in o) && a in o && (o[n] = o[a], 3 === r.length && (o[n] = r[2](o[n]))));
                    }), t.long0 || !t.longc || "Albers_Conic_Equal_Area" !== t.projName && "Lambert_Azimuthal_Equal_Area" !== t.projName || (t.long0 = t.longc), t.lat_ts || !t.lat1 || "Stereographic_South_Pole" !== t.projName && "Polar Stereographic (variant B)" !== t.projName || (t.lat0 = D(t.lat1 > 0 ? 90 : -90), t.lat_ts = t.lat1);
                }(a), a;
            };
        }
    ]);
});


var $3854fc9213889200$exports = {};
var $999003ffb5a01b82$exports = {};
function $999003ffb5a01b82$var$merge() {
    const instances = [];
    const isEmpty = (it)=>typeof it === "object" && Object.keys(it).length === 0 && JSON.stringify(it) === "{}";
    const add = (it)=>{
        if (!it) return;
        if (Array.isArray(it)) return it.forEach(add);
        if (it.default) it = it.default;
        if (isEmpty(it)) return;
        instances.push(it);
    };
    Array.from(arguments).forEach(add);
    if (instances.length === 0) throw Error("[proj4-merge] merge called with zero instances of proj4");
    const [first, ...rest] = instances;
    rest.forEach((instance)=>{
        first.defs(Object.entries(instance.defs));
    });
    return first;
}
if (typeof define === "function" && define.amd) define(function() {
    return $999003ffb5a01b82$var$merge;
});
$999003ffb5a01b82$exports = $999003ffb5a01b82$var$merge;
$999003ffb5a01b82$exports.default = $999003ffb5a01b82$var$merge;



var $9dec53e38f1c1ae1$exports = {};
function $9dec53e38f1c1ae1$var$reprojectBoundingBoxPluggable({ bbox: bbox, reproject: reproject }) {
    const [xmin, ymin, xmax, ymax] = bbox;
    const topleft = reproject([
        xmin,
        ymax
    ]);
    const topright = reproject([
        xmax,
        ymax
    ]);
    const bottomleft = reproject([
        xmin,
        ymin
    ]);
    const bottomright = reproject([
        xmax,
        ymin
    ]);
    const corners = [
        topleft,
        topright,
        bottomleft,
        bottomright
    ];
    const xs = corners.map((corner)=>corner[0]);
    const ys = corners.map((corner)=>corner[1]);
    return [
        Math.min(...xs),
        Math.min(...ys),
        Math.max(...xs),
        Math.max(...ys)
    ];
}
if (typeof define === "function" && define.amd) define(function() {
    return $9dec53e38f1c1ae1$var$reprojectBoundingBoxPluggable;
});
$9dec53e38f1c1ae1$exports = $9dec53e38f1c1ae1$var$reprojectBoundingBoxPluggable;
$9dec53e38f1c1ae1$exports.default = $9dec53e38f1c1ae1$var$reprojectBoundingBoxPluggable;
if (typeof window === "object") window.reprojectBoundingBoxPluggable = $9dec53e38f1c1ae1$var$reprojectBoundingBoxPluggable;
if (typeof self === "object") self.reprojectBoundingBoxPluggable = $9dec53e38f1c1ae1$var$reprojectBoundingBoxPluggable;


if (typeof $999003ffb5a01b82$exports !== "function") console.warn("[reproject-bbox] failed to import proj4-merge");
function $3854fc9213889200$var$reprojectBoundingBox({ bbox: bbox, from: from, proj4: _proj4, to: to }) {
    if (typeof from === "number") from = "EPSG:" + from;
    if (typeof to === "number") to = "EPSG:" + to;
    const instances = [
        _proj4,
        $3faba67f5f823edd$exports
    ];
    if (typeof window === "object" && window.proj4) instances.push(window.proj4);
    if (typeof self === "object" && self.proj4) instances.push(self.proj4);
    const proj = $999003ffb5a01b82$exports(instances);
    const fwd = proj(from, to).forward;
    return $9dec53e38f1c1ae1$exports({
        bbox: bbox,
        reproject: fwd
    });
}
if (typeof define === "function" && define.amd) define(function() {
    return $3854fc9213889200$var$reprojectBoundingBox;
});
$3854fc9213889200$exports = $3854fc9213889200$var$reprojectBoundingBox;
$3854fc9213889200$exports.default = $3854fc9213889200$var$reprojectBoundingBox;
if (typeof window === "object") window.reprojectBoundingBox = $3854fc9213889200$var$reprojectBoundingBox;
if (typeof self === "object") self.reprojectBoundingBox = $3854fc9213889200$var$reprojectBoundingBox;


"use strict";
const $53ee8012aead888f$var$avg = (a, b)=>(0, (/*@__PURE__*/$parcel$interopDefault($c140608fa6ffaa42$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($f8a5576c27bdd239$exports)))(a.toString(), b.toString()), "2");
const $53ee8012aead888f$var$isAry = (o)=>Array.isArray(o);
const $53ee8012aead888f$var$isDef = (o)=>o !== undefined && o !== null && o !== "";
const $53ee8012aead888f$var$isFunc = (o)=>typeof o === "function";
// identifying GeoJSON currently unused
// shouldn't rely on type being provided
// because sometimes the rest could be valid but no type is provided
// const isFeatureCollection = it => isObj(it) && it.type === "FeatureCollection" && hasKey(it, "features");
// const isFeature = it => isObj(it) && it.type === "Feature" && hasKey(it, "geometry");
// const isGeometryCollection = it => isObj(it) && it.type === "GeometryCollection" && hasKey("geometries");
// const isMultiPolygon = it => isObj(it) && it.type === "MultiPolygon" && hasKey(it, "coordinates");
// const isPolygon = it => isObj(it) && it.type === "Polygon" && hasKey(it, "coordinates");
// const isPoint = it => isObj(it) && it.type === "Point" && hasKey(it, "coordinates");
// const isMultiPoint = it => isObj(it) && isObj.type === "MultiPoint" && hasKey(it, "coordinates");
const $53ee8012aead888f$var$isObj = (o)=>typeof o === "object";
const $53ee8012aead888f$var$isStr = (o)=>typeof o === "string";
const $53ee8012aead888f$var$isNum = (o)=>typeof o === "number";
const $53ee8012aead888f$var$isBoxStr = (o)=>$53ee8012aead888f$var$isStr(o) && !!o.match(/^[-|+]?[\d\.]+(, ?[-|+]?[\d\.]+){3}$/);
const $53ee8012aead888f$var$isLeafletLatLngBounds = (o)=>$53ee8012aead888f$var$isObj(o) && $53ee8012aead888f$var$hasFuncs(o, [
        "getEast",
        "getNorth",
        "getSouth",
        "getWest"
    ]);
const $53ee8012aead888f$var$hasFunc = (o, f)=>$53ee8012aead888f$var$isObj(o) && $53ee8012aead888f$var$isFunc(o[f]);
const $53ee8012aead888f$var$hasObj = (o, k)=>$53ee8012aead888f$var$isObj(o) && $53ee8012aead888f$var$isObj(o[k]);
const $53ee8012aead888f$var$hasFuncs = (o, fs)=>fs.every((f)=>$53ee8012aead888f$var$hasFunc(o, f));
const $53ee8012aead888f$var$hasObjs = (o, ks)=>ks.every((k)=>$53ee8012aead888f$var$hasObj(o, k));
const $53ee8012aead888f$var$hasKey = (o, k)=>$53ee8012aead888f$var$isObj(o) && o[k] !== undefined && o[k] !== null;
const $53ee8012aead888f$var$hasKeys = (o, ks)=>ks.every((k)=>$53ee8012aead888f$var$hasKey(o, k));
const $53ee8012aead888f$var$allNums = (ary)=>$53ee8012aead888f$var$isAry(ary) && ary.every($53ee8012aead888f$var$isNum);
const $53ee8012aead888f$var$allStrs = (ary)=>$53ee8012aead888f$var$isAry(ary) && ary.every($53ee8012aead888f$var$isStr);
const $53ee8012aead888f$var$getConstructor = (o)=>typeof obj === "object" && typeof obj.constructor === "function" || undefined;
const $53ee8012aead888f$var$normalize = (srs)=>{
    if (!srs) return srs;
    if ($53ee8012aead888f$var$isStr(srs) && srs.startsWith("EPSG:")) return srs;
    if ($53ee8012aead888f$var$isStr(srs) && srs.match(/^\d+$/)) return "EPSG:" + srs;
    else if ($53ee8012aead888f$var$isNum(srs)) return "EPSG:" + srs;
    const code = (0, (/*@__PURE__*/$parcel$interopDefault($2717c6280c0c11e4$exports)))(srs);
    if ($53ee8012aead888f$var$isNum(code)) return "EPSG:" + code;
    return srs;
};
class $53ee8012aead888f$export$46bf242104d56a04 {
    constructor(o, { srs: srs } = {}){
        this.srs = $53ee8012aead888f$var$normalize(srs);
        let xmin, xmax, ymin, ymax;
        let xmin_str, xmax_str, ymin_str, ymax_str;
        if ($53ee8012aead888f$var$getConstructor(o) === this.constructor) {
            ({ xmin: xmin, xmax: xmax, ymin: ymin, ymax: ymax } = o);
            if ($53ee8012aead888f$var$isDef(o.srs)) this.srs = $53ee8012aead888f$var$normalize(o.srs);
        }
        if ($53ee8012aead888f$var$isBoxStr(o)) o = o.split(/, ?/);
        if ($53ee8012aead888f$var$isAry(o) && o.length === 4 && $53ee8012aead888f$var$allNums(o)) [xmin, ymin, xmax, ymax] = o;
        else if ($53ee8012aead888f$var$isAry(o) && o.length === 4 && $53ee8012aead888f$var$allStrs(o)) {
            [xmin_str, ymin_str, xmax_str, ymax_str] = o;
            [xmin, ymin, xmax, ymax] = o.map((str)=>Number(str));
        } else if ($53ee8012aead888f$var$isAry(o) && o.length === 2 && o.every($53ee8012aead888f$var$isAry) && o.every((o)=>o.length === 2 && $53ee8012aead888f$var$allNums(o))) [[ymin, xmin], [ymax, xmax]] = o;
        else if ($53ee8012aead888f$var$isLeafletLatLngBounds(o)) {
            xmin = o.getWest(), xmax = o.getEast(), ymin = o.getSouth(), ymax = o.getNorth();
            if (!$53ee8012aead888f$var$isDef(this.srs)) this.srs = "EPSG:4326";
        } else if ($53ee8012aead888f$var$isAry(o) && o.length === 2 && o.every((it)=>$53ee8012aead888f$var$hasKeys(it, [
                "x",
                "y"
            ]))) [{ x: xmin, y: ymin }, { x: xmax, y: ymax }] = o;
        else if ($53ee8012aead888f$var$isObj(o) && $53ee8012aead888f$var$hasKeys(o, [
            "x",
            "y"
        ]) && $53ee8012aead888f$var$isNum(o.x) && $53ee8012aead888f$var$isNum(o.y)) {
            // receive a point like { x: 147, y: -18 } because isn't a point
            // really just an extent with zero height and width?
            xmin = xmax = o.x;
            ymin = ymax = o.y;
            if ($53ee8012aead888f$var$hasKey(o, "spatialReference") && $53ee8012aead888f$var$hasKey(o.spatialReference, "wkid")) {
                if (!$53ee8012aead888f$var$isDef(this.srs)) this.srs = $53ee8012aead888f$var$normalize(o.spatialReference.wkid);
            }
        } else if ($53ee8012aead888f$var$isObj(o) && $53ee8012aead888f$var$hasKeys(o, [
            "xmin",
            "xmax",
            "ymin",
            "ymax"
        ])) {
            ({ xmin: xmin, xmax: xmax, ymin: ymin, ymax: ymax } = o);
            const keys = [
                "srs",
                "crs",
                "proj",
                "projection"
            ];
            for(let i = 0; i < keys.length; i++){
                const k = keys[i];
                const v = o[k];
                const normalized = $53ee8012aead888f$var$normalize(v);
                if (normalized) {
                    this.srs = normalized;
                    break;
                }
            }
            if (!this.srs && $53ee8012aead888f$var$isDef(o.srs)) this.srs = o.srs;
        } else if ($53ee8012aead888f$var$isAry(o) && o.length === 2 && $53ee8012aead888f$var$allNums(o)) {
            // assume [ x , y ]
            xmin = xmax = o[0];
            ymin = ymax = o[1];
        } else if ($53ee8012aead888f$var$isObj(o) && $53ee8012aead888f$var$hasFuncs(o, [
            "getCoordinates"
        ])) {
            const xy = o.getCoordinates();
            xmin = xmax = xy[0];
            ymin = ymax = xy[1];
        } else if ($53ee8012aead888f$var$isObj(o) && $53ee8012aead888f$var$hasKey(o, "bbox") && o.bbox.length === 4 && $53ee8012aead888f$var$allNums(o)) // like GeoJSON with bbox property set
        // { type: "Feature", "bbox": [-37, 7, 12, 67 ], "geometry": { "type": "Polygon", "coordinates": [...] } }
        [xmin, ymin, xmax, ymax] = o.bbox;
        else if ($53ee8012aead888f$var$hasObj(o, "_bounds") && $53ee8012aead888f$var$isLeafletLatLngBounds(o._bounds)) {
            const { _bounds: _bounds } = o;
            xmin = _bounds.getWest(), xmax = _bounds.getEast(), ymin = _bounds.getSouth(), ymax = _bounds.getNorth();
            if (!this.srs) this.srs = "EPSG:4326";
        } else if ($53ee8012aead888f$var$isObj(o) && $53ee8012aead888f$var$isObj(o._bounds) && $53ee8012aead888f$var$hasObjs(o._bounds, [
            "_southWest",
            "_northEast"
        ])) {
            ({ lat: ymin, lng: xmin } = o._bounds._southWest);
            ({ lat: ymax, lng: xmax } = o._bounds._northEast);
            if (!$53ee8012aead888f$var$isDef(this.srs)) this.srs = "EPSG:4326";
        } else throw new Error("[geo-extent] unknown format");
        this.xmin = xmin;
        this.xmin_str = xmin_str || xmin.toString();
        this.ymin = ymin;
        this.ymin_str = ymin_str || ymin.toString();
        this.xmax = xmax;
        this.xmax_str = xmax_str || xmax.toString();
        this.ymax = ymax;
        this.ymax_str = ymax_str || ymax.toString();
        this.width_str = (0, (/*@__PURE__*/$parcel$interopDefault($bc5586d89a48b2ea$exports)))(this.xmax_str, this.xmin_str);
        this.width = Number(this.width_str);
        this.height_str = (0, (/*@__PURE__*/$parcel$interopDefault($bc5586d89a48b2ea$exports)))(this.ymax_str, this.ymin_str);
        this.height = Number(this.height_str);
        // corners
        this.bottomLeft = {
            x: xmin,
            y: ymin
        };
        this.bottomRight = {
            x: xmax,
            y: ymin
        };
        this.topLeft = {
            x: xmin,
            y: ymax
        };
        this.topRight = {
            x: xmax,
            y: ymax
        };
        this.leafletBounds = [
            [
                this.ymin,
                this.xmin
            ],
            [
                this.ymax,
                this.xmax
            ]
        ];
        this.area_str = (0, (/*@__PURE__*/$parcel$interopDefault($492646347db2c919$exports)))(this.width_str, this.height_str);
        this.area = Number(this.area_str);
        this.perimeter_str = (0, (/*@__PURE__*/$parcel$interopDefault($f8a5576c27bdd239$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($492646347db2c919$exports)))(this.width_str, "2"), (0, (/*@__PURE__*/$parcel$interopDefault($492646347db2c919$exports)))(this.height_str, "2"));
        this.perimeter = Number(this.perimeter_str);
        this.bbox = [
            xmin,
            ymin,
            xmax,
            ymax
        ];
        this.bbox_str = [
            this.xmin_str,
            this.ymin_str,
            this.xmax_str,
            this.ymax_str
        ];
        this.center_str = {
            x: $53ee8012aead888f$var$avg(xmin_str || xmin, xmax_str || xmax),
            y: $53ee8012aead888f$var$avg(ymin_str || ymin, ymax_str || ymax)
        };
        this.center = {
            x: Number(this.center_str.x),
            y: Number(this.center_str.y)
        };
        this.str = this.bbox_str.join(",");
    }
    _pre(_this, _other) {
        // convert other to an extent instance (if not already)
        _other = new this.constructor(_other);
        if (!$53ee8012aead888f$var$isDef(_this.srs) && !$53ee8012aead888f$var$isDef(_other.srs)) ;
        else if ($53ee8012aead888f$var$isDef(_this.srs) && !$53ee8012aead888f$var$isDef(_other.srs)) // assume other is the same srs as this
        _other = new _this.constructor({
            ..._other,
            srs: _this.srs
        });
        else if (!$53ee8012aead888f$var$isDef(_this.srs) && $53ee8012aead888f$var$isDef(_other.srs)) // assume this' srs is the same as other
        _this = new _this.constructor({
            ..._this,
            srs: _other.srs
        });
        else if ($53ee8012aead888f$var$isDef(_this.srs) && $53ee8012aead888f$var$isDef(_other.srs) && _this.srs !== _other.srs) _other = _other.reproj(_this.srs);
        else if ($53ee8012aead888f$var$isDef(_this.srs) && $53ee8012aead888f$var$isDef(_other.srs) && _this.srs === _other.srs) ;
        else throw "UH OH";
        return [
            _this,
            _other
        ];
    }
    clone() {
        return new this.constructor(this);
    }
    contains(other) {
        const [_this, _other] = this._pre(this, other);
        const xContains = _other.xmin >= _this.xmin && _other.xmax <= _this.xmax;
        const yContains = _other.ymin >= _this.ymin && _other.ymax <= _this.ymax;
        return xContains && yContains;
    }
    // should return null if no overlap
    crop(other) {
        other = new this.constructor(other);
        // if really no overlap then return null
        if (this.overlaps(other, {
            quiet: true
        }) === false && other.overlaps(this, {
            quiet: true
        }) === false) return null;
        // first check if other fully contains this extent
        // in which case, we don't really need to crop
        // and can just return the extent of this
        if (other.contains(this)) return this.clone();
        // check if special case where other crosses 180th meridian
        if (other.srs === "EPSG:4326" && (other.xmin < -180 || other.xmax > 180)) {
            const parts = other.unwrap();
            let cropped = parts.map((it)=>this.crop(it));
            // filter out any parts that are null (didn't overlap)
            cropped = cropped.filter(Boolean);
            // no overlap
            if (cropped.length === 0) return null;
            let combo = cropped[0];
            for(let i = 1; i < cropped.length; i++)combo = combo.combine(cropped[i]);
            return combo;
        }
        // if both this and other have srs defined reproject
        // otherwise, assume they are the same projection
        let another = $53ee8012aead888f$var$isDef(this.srs) && $53ee8012aead888f$var$isDef(other.srs) ? other.reproj(this.srs, {
            quiet: true
        }) : other.clone();
        if (another) {
            if (!this.overlaps(another)) return null;
            const xmin = Math.max(this.xmin, another.xmin);
            const ymin = Math.max(this.ymin, another.ymin);
            const xmax = Math.min(this.xmax, another.xmax);
            const ymax = Math.min(this.ymax, another.ymax);
            return new this.constructor([
                xmin,
                ymin,
                xmax,
                ymax
            ], {
                srs: this.srs
            });
        }
        // fall back to converting everything to 4326 and cropping there
        const this4326 = $53ee8012aead888f$var$isDef(this.srs) ? this.reproj(4326) : this;
        const other4326 = $53ee8012aead888f$var$isDef(other.srs) ? other.reproj(4326) : other;
        const [aMinLon, aMinLat, aMaxLon, aMaxLat] = this4326.bbox;
        const [bMinLon, bMinLat, bMaxLon, bMaxLat] = other4326.bbox;
        if (!this4326.overlaps(other4326)) return null;
        const minLon = Math.max(aMinLon, bMinLon);
        const minLat = Math.max(aMinLat, bMinLat);
        const maxLon = Math.min(aMaxLon, bMaxLon);
        const maxLat = Math.min(aMaxLat, bMaxLat);
        return new this.constructor([
            minLon,
            minLat,
            maxLon,
            maxLat
        ], {
            srs: 4326
        }).reproj(this.srs);
    }
    // add two extents together
    // result is a new extent in the projection of this
    combine(other) {
        if ($53ee8012aead888f$var$isDef(this.srs) && $53ee8012aead888f$var$isDef(other.srs)) other = other.reproj(this.srs);
        const xmin = Math.min(this.xmin, other.xmin);
        const xmax = Math.max(this.xmax, other.xmax);
        const ymin = Math.min(this.ymin, other.ymin);
        const ymax = Math.max(this.ymax, other.ymax);
        return new this.constructor({
            xmin: xmin,
            xmax: xmax,
            ymin: ymin,
            ymax: ymax,
            srs: this.srs
        });
    }
    equals(other, { digits: digits = 13, strict: strict = true } = {
        digits: 13,
        strict: true
    }) {
        // convert other to GeoExtent if necessary
        other = new this.constructor(other);
        if ($53ee8012aead888f$var$isDef(this.srs) && $53ee8012aead888f$var$isDef(other.srs)) other = other.reproj(this.srs);
        else if (strict && $53ee8012aead888f$var$isDef(this.srs) !== !$53ee8012aead888f$var$isDef(this.srs)) return false;
        const str1 = this.bbox.map((n)=>n.toFixed(digits)).join(",");
        const str2 = other.bbox.map((n)=>n.toFixed(digits)).join(",");
        return str1 === str2;
    }
    /*
    shouldn't accept GeoJSON as input because the extent created from a GeoJSON
    might overlap, but the actual polygon wouldn't.
    Or at least make the user have to be explicit about the functionality via
    a flag like overlaps(geojson, { strict: false })
  */ overlaps(other, { quiet: quiet = false } = {
        quite: false
    }) {
        try {
            const [_this, _other] = this._pre(this, other);
            const yOverlaps = _other.ymin <= _this.ymax && _other.ymax >= _this.ymin;
            const xOverlaps = _other.xmin <= _this.xmax && _other.xmax >= _this.xmin;
            return xOverlaps && yOverlaps;
        } catch (error) {
            if (quiet) return;
            else throw error;
        }
    }
    reproj(to, { quiet: quiet = false } = {
        quiet: false
    }) {
        to = $53ee8012aead888f$var$normalize(to); // normalize srs
        // don't need to reproject, so just return a clone
        if ($53ee8012aead888f$var$isDef(this.srs) && this.srs === $53ee8012aead888f$var$normalize(to)) return this.clone();
        if (!$53ee8012aead888f$var$isDef(this.srs)) {
            if (quiet) return;
            throw new Error(`[geo-extent] cannot reproject ${this.bbox} without a projection set`);
        }
        // unwrap, reproject pieces, and combine
        if (this.srs === "EPSG:4326" && (this.xmin < -180 || this.xmax > 180)) try {
            const parts = this.unwrap().map((ext)=>ext.reproj(to));
            let combo = parts[0];
            for(let i = 1; i < parts.length; i++)combo = combo.combine(parts[i]);
            return combo;
        } catch (error) {
            if (quiet) return;
            throw error;
        }
        const reprojected = (0, (/*@__PURE__*/$parcel$interopDefault($3854fc9213889200$exports)))({
            bbox: this.bbox,
            from: this.srs,
            to: to
        });
        if (reprojected.some(isNaN)) {
            if (quiet) return;
            throw new Error(`[geo-extent] failed to reproject ${this.bbox} from ${this.srs} to ${to}`);
        }
        return new $53ee8012aead888f$export$46bf242104d56a04(reprojected, {
            srs: to
        });
    }
    unwrap() {
        const { xmin: xmin, ymin: ymin, xmax: xmax, ymax: ymax, srs: srs } = this;
        // not in 4326, so just return a clone
        if (srs !== "EPSG:4326") return [
            this.clone()
        ];
        // extent is within the normal extent of the earth, so return clone
        if (xmin > -180 && xmax < 180) return [
            this.clone()
        ];
        // handle special case where extent overflows xmin and then overlaps itself
        if (xmin < -180 && xmax >= xmin + 360) return [
            new this.constructor([
                -180,
                ymin,
                180,
                ymax
            ], {
                srs: 4326
            })
        ];
        if (xmax > 180 && xmin <= xmax - 360) return [
            new this.constructor([
                -180,
                ymin,
                180,
                ymax
            ], {
                srs: 4326
            })
        ];
        let extents = [];
        // extent overflows left edge of the world
        if (xmin < -180) extents.push(new this.constructor([
            xmin + 360,
            ymin,
            180,
            ymax
        ], {
            srs: srs
        }));
        // add extent for part between -180 to 180 longitude
        extents.push(new this.constructor([
            xmin < -180 ? -180 : xmin,
            ymin,
            xmax > 180 ? 180 : xmax,
            ymax
        ], {
            srs: srs
        }));
        // extent overflows right edge of the world
        if (this.xmax > 180) extents.push(new this.constructor([
            -180,
            ymin,
            xmax - 360,
            ymax
        ], {
            srs: srs
        }));
        return extents;
    }
    asEsriJSON() {
        return {
            xmin: this.xmin,
            ymin: this.ymin,
            xmax: this.xmax,
            ymax: this.ymax,
            spatialReference: {
                wkid: this.srs
            }
        };
    }
    asGeoJSON() {
        const { xmin: xmin, ymin: ymin, xmax: xmax, ymax: ymax } = this.srs === "EPSG:4326" ? this : this.reproj(4326);
        return {
            type: "Feature",
            geometry: {
                type: "Polygon",
                coordinates: [
                    [
                        [
                            xmin,
                            ymax
                        ],
                        [
                            xmax,
                            ymax
                        ],
                        [
                            xmax,
                            ymin
                        ],
                        [
                            xmin,
                            ymin
                        ],
                        [
                            xmin,
                            ymax
                        ]
                    ]
                ]
            }
        };
    }
    asObj() {
        const res = {};
        for(let k in this){
            const v = this[k];
            if (!$53ee8012aead888f$var$isFunc(v)) res[k] = v;
        }
        return res;
    }
}
if (typeof define === "function" && define.amd) define(function() {
    return $53ee8012aead888f$export$46bf242104d56a04;
});
if (typeof self === "object") self.GeoExtent = $53ee8012aead888f$export$46bf242104d56a04;
if (typeof window === "object") window.GeoExtent = $53ee8012aead888f$export$46bf242104d56a04;


var $9b650cea4a5970ae$exports = {};
$9b650cea4a5970ae$exports = ({ bbox: bbox, container: container, debug: debug, origin: origin, padding: padding, scale: scale })=>{
    if (debug) console.log("[snap-bbox] starting");
    if (debug) console.log("[snap-bbox] bbox:", bbox);
    if (debug) console.log("[snap-bbox] debug:", debug);
    if (debug) console.log("[snap-bbox] origin:", origin);
    if (debug) console.log("[snap-bbox] padding:", padding);
    if (debug) console.log("[snap-bbox] scale:", scale);
    const [originX, originY] = origin;
    if (debug) console.log("[snap-bbox] originX:", originX);
    if (debug) console.log("[snap-bbox] originY:", originY);
    const [padX, padY] = padding || [
        0,
        0
    ];
    if (debug) console.log("[snap-bbox] padX:", padX);
    if (debug) console.log("[snap-bbox] padY:", padY);
    const [scale_x, scale_y] = scale;
    if (debug) console.log("[snap-bbox] scale_x:", scale_x);
    if (debug) console.log("[snap-bbox] scale_y:", scale_y);
    // if sign is -1 then x/y value decreases
    // as grid cell number increases
    const sign_scale_x = Math.sign(scale_x);
    const sign_scale_y = Math.sign(scale_y);
    if (debug) console.log("[snap-bbox] sign_scale_x:", sign_scale_x);
    if (debug) console.log("[snap-bbox] sign_scale_y:", sign_scale_y);
    const [xmin, ymin, xmax, ymax] = bbox;
    if (debug) console.log("[snap-bbox] xmin:", xmin);
    if (debug) console.log("[snap-bbox] ymin:", ymin);
    if (debug) console.log("[snap-bbox] xmax:", xmax);
    if (debug) console.log("[snap-bbox] ymax:", ymax);
    const left = (xmin - originX) / scale_x;
    const right = (xmax - originX) / scale_x;
    const top = (ymax - originY) / scale_y;
    const bottom = (ymin - originY) / scale_y;
    if (debug) console.log("[snap-bbox] left:", left);
    if (debug) console.log("[snap-bbox] right:", right);
    if (debug) console.log("[snap-bbox] top:", top);
    if (debug) console.log("[snap-bbox] bottom:", bottom);
    // we're rounding here, so we don't ask for half a pixel
    let left_int = Math.floor(left) - padX;
    let right_int = Math.ceil(right) + padX;
    // top_int is the number of pixels from the top edge of the grid
    // so we want to subtract the padding
    let top_int = Math.floor(top) - padY;
    // bottom_int is the number of pixels from the top edge of the edge
    // so we want to increase the padding
    let bottom_int = Math.ceil(bottom) + padY;
    if (debug) console.log("[snap-bbox] left_int:", left_int);
    if (debug) console.log("[snap-bbox] right_int:", right_int);
    if (debug) console.log("[snap-bbox] top_int:", top_int);
    if (debug) console.log("[snap-bbox] bottom_int:", bottom_int);
    if (container) {
        if (debug) console.log("[snap-bbox] container:", container);
        const min_left = (container[0] - originX) / scale_x;
        const max_right = (container[2] - originX) / scale_x;
        const min_top = (container[3] - originY) / scale_y;
        const max_bottom = (container[1] - originY) / scale_y;
        if (debug) console.log("[snap-bbox] min_left:", min_left);
        if (debug) console.log("[snap-bbox] max_right:", max_right);
        if (debug) console.log("[snap-bbox] min_top:", min_top);
        if (debug) console.log("[snap-bbox] max_bottom:", max_bottom);
        const min_left_int = Math.ceil(min_left);
        const max_right_int = Math.floor(max_right);
        const min_top_int = Math.ceil(min_top);
        const max_bottom_int = Math.floor(max_bottom);
        if (debug) console.log("[snap-bbox] min_left_int:", min_left_int);
        if (debug) console.log("[snap-bbox] max_right_int:", max_right_int);
        if (debug) console.log("[snap-bbox] min_top_int:", min_top_int);
        if (debug) console.log("[snap-bbox] max_bottom_int:", max_bottom_int);
        left_int = Math.max(left_int, min_left_int);
        right_int = Math.min(right_int, max_right_int);
        top_int = Math.max(top_int, min_top_int);
        bottom_int = Math.min(bottom_int, max_bottom_int);
        if (debug) console.log("[snap-bbox] after containment, left_int:", left_int);
        if (debug) console.log("[snap-bbox] after containment, right_int:", right_int);
        if (debug) console.log("[snap-bbox] after containment, top_int:", top_int);
        if (debug) console.log("[snap-bbox] after containment, bottom_int:", bottom_int);
    }
    // need ternary expresssions below because
    // top_int is sometimes -0, which fails
    // some NodeJS strict equality tests with 0
    // however, 0 === -0 evaluates to true in NodeJS
    const bbox_in_grid_cells = [
        left_int === 0 ? 0 : left_int,
        bottom_int === 0 ? 0 : bottom_int,
        right_int === 0 ? 0 : right_int,
        top_int === 0 ? 0 : top_int
    ];
    if (debug) console.log("[snap-bbox] bbox_in_grid_cells:", bbox_in_grid_cells);
    const bbox_in_coordinate_system = [
        originX + left_int * scale_x,
        originY + bottom_int * scale_y,
        originX + right_int * scale_x,
        originY + top_int * scale_y // ymax
    ];
    return {
        bbox_in_coordinate_system: bbox_in_coordinate_system,
        bbox_in_grid_cells: bbox_in_grid_cells
    };
};


const $4243bf518a93e3b4$var$EPSG4326 = 4326;
const $4243bf518a93e3b4$var$PROJ4_SUPPORTED_PROJECTIONS = new Set([
    3785,
    3857,
    4269,
    4326,
    900913,
    102113
]);
const $4243bf518a93e3b4$var$MAX_NORTHING = 1000;
const $4243bf518a93e3b4$var$MAX_EASTING = 1000;
const $4243bf518a93e3b4$var$ORIGIN = [
    0,
    0
];
const $4243bf518a93e3b4$var$log = (obj)=>console.log("[georaster-layer-for-leaflet] ", obj); // figure out if simple CRS
// even if not created with same instance of LeafletJS
const $4243bf518a93e3b4$var$isSimpleCRS = (crs)=>{
    var _crs$transformation, _crs$transformation2, _crs$transformation3, _crs$transformation4;
    return crs === $iLKzi.CRS.Simple || !crs.code && crs.infinite && (crs === null || crs === void 0 ? void 0 : (_crs$transformation = crs.transformation) === null || _crs$transformation === void 0 ? void 0 : _crs$transformation._a) === 1 && (crs === null || crs === void 0 ? void 0 : (_crs$transformation2 = crs.transformation) === null || _crs$transformation2 === void 0 ? void 0 : _crs$transformation2._b) === 0 && (crs === null || crs === void 0 ? void 0 : (_crs$transformation3 = crs.transformation) === null || _crs$transformation3 === void 0 ? void 0 : _crs$transformation3._c) === -1 && (crs === null || crs === void 0 ? void 0 : (_crs$transformation4 = crs.transformation) === null || _crs$transformation4 === void 0 ? void 0 : _crs$transformation4._d) === 0;
};
if (!$iLKzi) console.warn("[georaster-layer-for-leaflet] can't find Leaflet.  If you are loading via <script>, please add the GeoRasterLayer script after the LeafletJS script.");
const $4243bf518a93e3b4$var$zip = (a, b)=>a.map((it, i)=>[
            it,
            b[i]
        ]);
const $4243bf518a93e3b4$var$GeoRasterLayer = $iLKzi.GridLayer.extend({
    options: {
        updateWhenIdle: true,
        updateWhenZooming: false,
        keepBuffer: 25,
        resolution: 32,
        debugLevel: 0
    },
    initialize: function(options) {
        try {
            if (options.georasters) this.georasters = options.georasters;
            else if (options.georaster) this.georasters = [
                options.georaster
            ];
            else throw new Error("You initialized a GeoRasterLayer without a georaster or georasters value.");
            if (this.sourceType === "url") {
                options.updateWhenIdle = false;
                options.updateWhenZooming = true;
                options.keepBuffer = 16;
            }
            if (options.resampleMethod) this.resampleMethod = options.resampleMethod;
            /*
          Unpacking values for use later.
          We do this in order to increase speed.
      */ const keys = [
                "height",
                "width",
                "noDataValue",
                "palette",
                "pixelHeight",
                "pixelWidth",
                "projection",
                "sourceType",
                "xmin",
                "xmax",
                "ymin",
                "ymax"
            ];
            if (this.georasters.length > 1) keys.forEach((key)=>{
                if (this.same(this.georasters, key)) this[key] = this.georasters[0][key];
                else throw new Error("all GeoRasters must have the same " + key);
            });
            else if (this.georasters.length === 1) keys.forEach((key)=>{
                this[key] = this.georasters[0][key];
            });
            this._cache = {
                innerTile: {},
                tile: {}
            };
            this.extent = new (0, $53ee8012aead888f$export$46bf242104d56a04)([
                this.xmin,
                this.ymin,
                this.xmax,
                this.ymax
            ], {
                srs: this.projection
            }); // used later if simple projection
            this.ratio = this.height / this.width;
            this.debugLevel = options.debugLevel;
            if (this.debugLevel >= 1) $4243bf518a93e3b4$var$log({
                options: options
            });
            if (this.georasters.every((georaster)=>typeof georaster.values === "object")) {
                this.rasters = this.georasters.reduce((result, georaster)=>{
                    // added double-check of values to make typescript linter and compiler happy
                    if (georaster.values) {
                        result = result.concat(georaster.values);
                        return result;
                    }
                }, []);
                if (this.debugLevel > 1) console.log("this.rasters:", this.rasters);
            }
            if (options.mask) {
                if (typeof options.mask === "string") this.mask = fetch(options.mask).then((r)=>r.json());
                else if (typeof options.mask === "object") this.mask = Promise.resolve(options.mask);
                 // default mask srs is the EPSG:4326 projection used by GeoJSON
                this.mask_srs = options.mask_srs || "EPSG:4326";
            }
            this.mask_strategy = options.mask_strategy || "outside";
            this.chroma = (0, (/*@__PURE__*/$parcel$interopDefault($jTcSi)));
            this.scale = (0, (/*@__PURE__*/$parcel$interopDefault($jTcSi))).scale(); // could probably replace some day with a simple
            // (for let k in options) { this.options[k] = options[k]; }
            // but need to find a way around TypeScript any issues
            $iLKzi.Util.setOptions(this, options);
            /*
          Caching the constant tile size, so we don't recalculate everytime we
          create a new tile
      */ const tileSize = this.getTileSize();
            this.tileHeight = tileSize.y;
            this.tileWidth = tileSize.x;
            if (this.georasters.length >= 4 && !options.pixelValuesToColorFn) throw "you must pass in a pixelValuesToColorFn if you are combining rasters";
             // total number of bands across all georasters
            this.numBands = this.georasters.reduce((total, g)=>total + g.numberOfRasters, 0);
            if (this.debugLevel > 1) console.log("this.numBands:", this.numBands); // in-case we want to track dynamic/running stats of all pixels fetched
            this.currentStats = {
                mins: new Array(this.numBands),
                maxs: new Array(this.numBands),
                ranges: new Array(this.numBands)
            }; // using single-band raster as grayscale
            // or mapping 2 or 3 rasters to rgb bands
            if ([
                1,
                2,
                3
            ].includes(this.georasters.length) && this.georasters.every((g)=>g.sourceType === "url") && this.georasters.every((g)=>g.numberOfRasters === 1) && !options.pixelValuesToColorFn) try {
                this.calcStats = true;
                this._dynamic = true;
                this.options.pixelValuesToColorFn = (values)=>{
                    const haveDataForAllBands = values.every((value)=>value !== undefined && value !== this.noDataValue);
                    if (haveDataForAllBands) return this.rawToRgb(values);
                };
            } catch (error) {
                console.error("[georaster-layer-for-leaflet]", error);
            }
             // if you haven't specified a pixelValuesToColorFn
            // and the image is YCbCr, add a function to convert YCbCr
            this.checkIfYCbCr = new Promise(async (resolve)=>{
                if (this.options.pixelValuesToColorFn) return resolve(true);
                if (this.georasters.length === 1 && this.georasters[0].numberOfRasters === 3) {
                    var _this$georasters$0$_g, _image$fileDirectory;
                    const image = await ((_this$georasters$0$_g = this.georasters[0]._geotiff) === null || _this$georasters$0$_g === void 0 ? void 0 : _this$georasters$0$_g.getImage());
                    if ((image === null || image === void 0 ? void 0 : (_image$fileDirectory = image.fileDirectory) === null || _image$fileDirectory === void 0 ? void 0 : _image$fileDirectory.PhotometricInterpretation) === 6) this.options.pixelValuesToColorFn = (values)=>{
                        const r = Math.round(values[0] + 1.402 * (values[2] - 0x80));
                        const g = Math.round(values[0] - 0.34414 * (values[1] - 0x80) - 0.71414 * (values[2] - 0x80));
                        const b = Math.round(values[0] + 1.772 * (values[1] - 0x80));
                        return `rgb(${r},${g},${b})`;
                    };
                }
                return resolve(true);
            });
        } catch (error) {
            console.error("ERROR initializing GeoTIFFLayer", error);
        }
    },
    getRasters: function(options) {
        const { innerTileTopLeftPoint: innerTileTopLeftPoint, heightOfSampleInScreenPixels: heightOfSampleInScreenPixels, widthOfSampleInScreenPixels: widthOfSampleInScreenPixels, zoom: zoom, numberOfSamplesAcross: numberOfSamplesAcross, numberOfSamplesDown: numberOfSamplesDown, ymax: ymax, xmin: xmin } = options;
        if (this.debugLevel >= 1) console.log("starting getRasters with options:", options); // called if georaster was constructed from URL and we need to get
        // data separately for each tile
        // aka 'COG mode'
        /*
      This function takes in coordinates in the rendered image inner tile and
      returns the y and x values in the original raster
    */ const rasterCoordsForTileCoords = (h, w)=>{
            const xInMapPixels = innerTileTopLeftPoint.x + w * widthOfSampleInScreenPixels;
            const yInMapPixels = innerTileTopLeftPoint.y + h * heightOfSampleInScreenPixels;
            const mapPoint = $iLKzi.point(xInMapPixels, yInMapPixels);
            if (this.debugLevel >= 1) $4243bf518a93e3b4$var$log({
                mapPoint: mapPoint
            });
            const { lat: lat, lng: lng } = this.getMap().unproject(mapPoint, zoom);
            if (this.projection === $4243bf518a93e3b4$var$EPSG4326) return {
                y: Math.round((ymax - lat) / this.pixelHeight),
                x: Math.round((lng - xmin) / this.pixelWidth)
            };
            else if (this.getProjector()) {
                /* source raster doesn't use latitude and longitude,
           so need to reproject point from lat/long to projection of raster
        */ const [x, y] = this.getProjector().inverse([
                    lng,
                    lat
                ]);
                if (x === Infinity || y === Infinity) {
                    if (this.debugLevel >= 1) console.error("projector converted", [
                        lng,
                        lat
                    ], "to", [
                        x,
                        y
                    ]);
                }
                return {
                    y: Math.round((ymax - y) / this.pixelHeight),
                    x: Math.round((x - xmin) / this.pixelWidth)
                };
            } else return null;
        }; // careful not to flip min_y/max_y here
        const topLeft = rasterCoordsForTileCoords(0, 0);
        const bottomRight = rasterCoordsForTileCoords(numberOfSamplesDown, numberOfSamplesAcross);
        const getValuesOptions = {
            bottom: bottomRight === null || bottomRight === void 0 ? void 0 : bottomRight.y,
            height: numberOfSamplesDown,
            left: topLeft === null || topLeft === void 0 ? void 0 : topLeft.x,
            right: bottomRight === null || bottomRight === void 0 ? void 0 : bottomRight.x,
            top: topLeft === null || topLeft === void 0 ? void 0 : topLeft.y,
            width: numberOfSamplesAcross
        };
        if (!Object.values(getValuesOptions).every((it)=>it !== undefined && isFinite(it))) console.error("getRasters failed because not all values are finite:", getValuesOptions);
        else // !note: The types need confirmation - SFR 2021-01-20
        return Promise.all(this.georasters.map((georaster)=>georaster.getValues({
                ...getValuesOptions,
                resampleMethod: this.resampleMethod || "nearest"
            }))).then((valuesByGeoRaster)=>valuesByGeoRaster.reduce((result, values)=>{
                result = result.concat(values);
                return result;
            }, []));
    },
    createTile: function(coords, done) {
        /* This tile is the square piece of the Leaflet map that we draw on */ const tile = $iLKzi.DomUtil.create("canvas", "leaflet-tile"); // we do this because sometimes css normalizers will set * to box-sizing: border-box
        tile.style.boxSizing = "content-box"; // start tile hidden
        tile.style.visibility = "hidden";
        const context = tile.getContext("2d"); // note that we aren't setting the tile height or width here
        // drawTile dynamically sets the width and padding based on
        // how much the georaster takes up the tile area
        this.drawTile({
            tile: tile,
            coords: coords,
            context: context,
            done: done
        });
        return tile;
    },
    drawTile: function({ tile: tile, coords: coords, context: context, done: done }) {
        try {
            const { debugLevel: debugLevel = 0 } = this;
            if (debugLevel >= 2) console.log("starting drawTile with", {
                tile: tile,
                coords: coords,
                context: context,
                done: done
            });
            let error;
            const { z: zoom } = coords; // stringified hash of tile coordinates for caching purposes
            const cacheKey = [
                coords.x,
                coords.y,
                coords.z
            ].join(",");
            if (debugLevel >= 2) $4243bf518a93e3b4$var$log({
                cacheKey: cacheKey
            });
            const mapCRS = this.getMapCRS();
            if (debugLevel >= 2) $4243bf518a93e3b4$var$log({
                mapCRS: mapCRS
            });
            const inSimpleCRS = $4243bf518a93e3b4$var$isSimpleCRS(mapCRS);
            if (debugLevel >= 2) $4243bf518a93e3b4$var$log({
                inSimpleCRS: inSimpleCRS
            }); // Unpacking values for increased speed
            const { rasters: rasters, xmin: xmin, xmax: xmax, ymin: ymin, ymax: ymax } = this;
            const rasterHeight = this.height;
            const rasterWidth = this.width;
            const extentOfLayer = new (0, $53ee8012aead888f$export$46bf242104d56a04)(this.getBounds(), {
                srs: inSimpleCRS ? "simple" : 4326
            });
            if (debugLevel >= 2) $4243bf518a93e3b4$var$log({
                extentOfLayer: extentOfLayer
            });
            const pixelHeight = inSimpleCRS ? extentOfLayer.height / rasterHeight : this.pixelHeight;
            const pixelWidth = inSimpleCRS ? extentOfLayer.width / rasterWidth : this.pixelWidth;
            if (debugLevel >= 2) $4243bf518a93e3b4$var$log({
                pixelHeight: pixelHeight,
                pixelWidth: pixelWidth
            }); // these values are used, so we don't try to sample outside of the raster
            const { xMinOfLayer: xMinOfLayer, xMaxOfLayer: xMaxOfLayer, yMinOfLayer: yMinOfLayer, yMaxOfLayer: yMaxOfLayer } = this;
            const boundsOfTile = this._tileCoordsToBounds(coords);
            if (debugLevel >= 2) $4243bf518a93e3b4$var$log({
                boundsOfTile: boundsOfTile
            });
            const { code: code } = mapCRS;
            if (debugLevel >= 2) $4243bf518a93e3b4$var$log({
                code: code
            });
            const extentOfTile = new (0, $53ee8012aead888f$export$46bf242104d56a04)(boundsOfTile, {
                srs: inSimpleCRS ? "simple" : 4326
            });
            if (debugLevel >= 2) $4243bf518a93e3b4$var$log({
                extentOfTile: extentOfTile
            }); // create blue outline around tiles
            if (debugLevel >= 4) {
                if (!this._cache.tile[cacheKey]) this._cache.tile[cacheKey] = $iLKzi.rectangle(extentOfTile.leafletBounds, {
                    fillOpacity: 0
                }).addTo(this.getMap()).bindTooltip(cacheKey, {
                    direction: "center",
                    permanent: true
                });
            }
            const extentOfTileInMapCRS = inSimpleCRS ? extentOfTile : extentOfTile.reproj(code);
            if (debugLevel >= 2) $4243bf518a93e3b4$var$log({
                extentOfTileInMapCRS: extentOfTileInMapCRS
            });
            let extentOfInnerTileInMapCRS = extentOfTileInMapCRS.crop(inSimpleCRS ? extentOfLayer : this.extent);
            if (debugLevel >= 2) console.log("[georaster-layer-for-leaflet] extentOfInnerTileInMapCRS", extentOfInnerTileInMapCRS.reproj(inSimpleCRS ? "simple" : 4326));
            if (debugLevel >= 2) $4243bf518a93e3b4$var$log({
                coords: coords,
                extentOfInnerTileInMapCRS: extentOfInnerTileInMapCRS,
                extent: this.extent
            }); // create blue outline around tiles
            if (debugLevel >= 4) {
                if (!this._cache.innerTile[cacheKey]) {
                    const ext = inSimpleCRS ? extentOfInnerTileInMapCRS : extentOfInnerTileInMapCRS.reproj(4326);
                    this._cache.innerTile[cacheKey] = $iLKzi.rectangle(ext.leafletBounds, {
                        color: "#F00",
                        dashArray: "5, 10",
                        fillOpacity: 0
                    }).addTo(this.getMap());
                }
            }
            const widthOfScreenPixelInMapCRS = extentOfTileInMapCRS.width / this.tileWidth;
            const heightOfScreenPixelInMapCRS = extentOfTileInMapCRS.height / this.tileHeight;
            if (debugLevel >= 3) $4243bf518a93e3b4$var$log({
                heightOfScreenPixelInMapCRS: heightOfScreenPixelInMapCRS,
                widthOfScreenPixelInMapCRS: widthOfScreenPixelInMapCRS
            }); // expand tile sampling area to align with raster pixels
            const oldExtentOfInnerTileInRasterCRS = inSimpleCRS ? extentOfInnerTileInMapCRS : extentOfInnerTileInMapCRS.reproj(this.projection);
            const snapped = (0, (/*@__PURE__*/$parcel$interopDefault($9b650cea4a5970ae$exports)))({
                bbox: oldExtentOfInnerTileInRasterCRS.bbox,
                // pad xmax and ymin of container to tolerate ceil() and floor() in snap()
                container: inSimpleCRS ? [
                    extentOfLayer.xmin,
                    extentOfLayer.ymin - 0.25 * pixelHeight,
                    extentOfLayer.xmax + 0.25 * pixelWidth,
                    extentOfLayer.ymax
                ] : [
                    xmin,
                    ymin - 0.25 * pixelHeight,
                    xmax + 0.25 * pixelWidth,
                    ymax
                ],
                debug: debugLevel >= 2,
                origin: inSimpleCRS ? [
                    extentOfLayer.xmin,
                    extentOfLayer.ymax
                ] : [
                    xmin,
                    ymax
                ],
                scale: [
                    pixelWidth,
                    -pixelHeight
                ] // negative because origin is at ymax
            });
            const extentOfInnerTileInRasterCRS = new (0, $53ee8012aead888f$export$46bf242104d56a04)(snapped.bbox_in_coordinate_system, {
                srs: inSimpleCRS ? "simple" : this.projection
            });
            const gridbox = snapped.bbox_in_grid_cells;
            const snappedSamplesAcross = Math.abs(gridbox[2] - gridbox[0]);
            const snappedSamplesDown = Math.abs(gridbox[3] - gridbox[1]);
            const rasterPixelsAcross = Math.ceil(oldExtentOfInnerTileInRasterCRS.width / pixelWidth);
            const rasterPixelsDown = Math.ceil(oldExtentOfInnerTileInRasterCRS.height / pixelHeight);
            const { resolution: resolution } = this.options;
            const layerCropExtent = inSimpleCRS ? extentOfLayer : this.extent;
            const recropTileOrig = oldExtentOfInnerTileInRasterCRS.crop(layerCropExtent); // may be null
            let maxSamplesAcross = 1;
            let maxSamplesDown = 1;
            if (recropTileOrig !== null) {
                const recropTileProj = inSimpleCRS ? recropTileOrig : recropTileOrig.reproj(code);
                const recropTile = recropTileProj.crop(extentOfTileInMapCRS);
                if (recropTile !== null) {
                    maxSamplesAcross = Math.ceil(resolution * (recropTile.width / extentOfTileInMapCRS.width));
                    maxSamplesDown = Math.ceil(resolution * (recropTile.height / extentOfTileInMapCRS.height));
                }
            }
            const overdrawTileAcross = rasterPixelsAcross < maxSamplesAcross;
            const overdrawTileDown = rasterPixelsDown < maxSamplesDown;
            const numberOfSamplesAcross = overdrawTileAcross ? snappedSamplesAcross : maxSamplesAcross;
            const numberOfSamplesDown = overdrawTileDown ? snappedSamplesDown : maxSamplesDown;
            if (debugLevel >= 3) console.log("[georaster-layer-for-leaflet] extent of inner tile before snapping " + extentOfInnerTileInMapCRS.reproj(inSimpleCRS ? "simple" : 4326).bbox.toString()); // Reprojecting the bounding box back to the map CRS would expand it
            // (unless the projection is purely scaling and translation),
            // so instead just extend the old map bounding box proportionately.
            {
                const oldrb = new (0, $53ee8012aead888f$export$46bf242104d56a04)(oldExtentOfInnerTileInRasterCRS.bbox);
                const newrb = new (0, $53ee8012aead888f$export$46bf242104d56a04)(extentOfInnerTileInRasterCRS.bbox);
                const oldmb = new (0, $53ee8012aead888f$export$46bf242104d56a04)(extentOfInnerTileInMapCRS.bbox);
                if (oldrb.width !== 0 && oldrb.height !== 0) {
                    let n0 = (newrb.xmin - oldrb.xmin) / oldrb.width * oldmb.width;
                    let n1 = (newrb.ymin - oldrb.ymin) / oldrb.height * oldmb.height;
                    let n2 = (newrb.xmax - oldrb.xmax) / oldrb.width * oldmb.width;
                    let n3 = (newrb.ymax - oldrb.ymax) / oldrb.height * oldmb.height;
                    if (!overdrawTileAcross) {
                        n0 = Math.max(n0, 0);
                        n2 = Math.min(n2, 0);
                    }
                    if (!overdrawTileDown) {
                        n1 = Math.max(n1, 0);
                        n3 = Math.min(n3, 0);
                    }
                    const newbox = [
                        oldmb.xmin + n0,
                        oldmb.ymin + n1,
                        oldmb.xmax + n2,
                        oldmb.ymax + n3
                    ];
                    extentOfInnerTileInMapCRS = new (0, $53ee8012aead888f$export$46bf242104d56a04)(newbox, {
                        srs: extentOfInnerTileInMapCRS.srs
                    });
                }
            }
            if (debugLevel >= 4) {
                if (!this._cache.innerTile[cacheKey]) {
                    const ext = inSimpleCRS ? extentOfInnerTileInMapCRS : extentOfInnerTileInMapCRS.reproj(4326);
                    this._cache.innerTile[cacheKey] = $iLKzi.rectangle(ext.leafletBounds, {
                        color: "#F00",
                        dashArray: "5, 10",
                        fillOpacity: 0
                    }).addTo(this.getMap());
                }
            }
            if (debugLevel >= 3) console.log("[georaster-layer-for-leaflet] extent of inner tile after snapping " + extentOfInnerTileInMapCRS.reproj(inSimpleCRS ? "simple" : 4326).bbox.toString()); // Note that the snapped "inner" tile may extend beyond the original tile,
            // in which case the padding values will be negative.
            // we round here because sometimes there will be slight floating arithmetic issues
            // where the padding is like 0.00000000000001
            const padding = {
                left: Math.round((extentOfInnerTileInMapCRS.xmin - extentOfTileInMapCRS.xmin) / widthOfScreenPixelInMapCRS),
                right: Math.round((extentOfTileInMapCRS.xmax - extentOfInnerTileInMapCRS.xmax) / widthOfScreenPixelInMapCRS),
                top: Math.round((extentOfTileInMapCRS.ymax - extentOfInnerTileInMapCRS.ymax) / heightOfScreenPixelInMapCRS),
                bottom: Math.round((extentOfInnerTileInMapCRS.ymin - extentOfTileInMapCRS.ymin) / heightOfScreenPixelInMapCRS)
            };
            if (debugLevel >= 3) $4243bf518a93e3b4$var$log({
                padding: padding
            });
            const innerTileHeight = this.tileHeight - padding.top - padding.bottom;
            const innerTileWidth = this.tileWidth - padding.left - padding.right;
            if (debugLevel >= 3) $4243bf518a93e3b4$var$log({
                innerTileHeight: innerTileHeight,
                innerTileWidth: innerTileWidth
            });
            if (debugLevel >= 4) {
                const xMinOfInnerTileInMapCRS = extentOfTileInMapCRS.xmin + padding.left * widthOfScreenPixelInMapCRS;
                const yMinOfInnerTileInMapCRS = extentOfTileInMapCRS.ymin + padding.bottom * heightOfScreenPixelInMapCRS;
                const xMaxOfInnerTileInMapCRS = extentOfTileInMapCRS.xmax - padding.right * widthOfScreenPixelInMapCRS;
                const yMaxOfInnerTileInMapCRS = extentOfTileInMapCRS.ymax - padding.top * heightOfScreenPixelInMapCRS;
                $4243bf518a93e3b4$var$log({
                    xMinOfInnerTileInMapCRS: xMinOfInnerTileInMapCRS,
                    yMinOfInnerTileInMapCRS: yMinOfInnerTileInMapCRS,
                    xMaxOfInnerTileInMapCRS: xMaxOfInnerTileInMapCRS,
                    yMaxOfInnerTileInMapCRS: yMaxOfInnerTileInMapCRS
                });
            }
            const canvasPadding = {
                left: Math.max(padding.left, 0),
                right: Math.max(padding.right, 0),
                top: Math.max(padding.top, 0),
                bottom: Math.max(padding.bottom, 0)
            };
            const canvasHeight = this.tileHeight - canvasPadding.top - canvasPadding.bottom;
            const canvasWidth = this.tileWidth - canvasPadding.left - canvasPadding.right; // set padding and size of canvas tile
            tile.style.paddingTop = canvasPadding.top + "px";
            tile.style.paddingRight = canvasPadding.right + "px";
            tile.style.paddingBottom = canvasPadding.bottom + "px";
            tile.style.paddingLeft = canvasPadding.left + "px";
            tile.height = canvasHeight;
            tile.style.height = canvasHeight + "px";
            tile.width = canvasWidth;
            tile.style.width = canvasWidth + "px";
            if (debugLevel >= 3) console.log("setting tile height to " + canvasHeight + "px");
            if (debugLevel >= 3) console.log("setting tile width to " + canvasWidth + "px"); // set how large to display each sample in screen pixels
            const heightOfSampleInScreenPixels = innerTileHeight / numberOfSamplesDown;
            const heightOfSampleInScreenPixelsInt = Math.ceil(heightOfSampleInScreenPixels);
            const widthOfSampleInScreenPixels = innerTileWidth / numberOfSamplesAcross;
            const widthOfSampleInScreenPixelsInt = Math.ceil(widthOfSampleInScreenPixels);
            const map = this.getMap();
            const tileSize = this.getTileSize(); // this converts tile coordinates (how many tiles down and right)
            // to pixels from left and top of tile pane
            const tileNwPoint = coords.scaleBy(tileSize);
            if (debugLevel >= 4) $4243bf518a93e3b4$var$log({
                tileNwPoint: tileNwPoint
            });
            const xLeftOfInnerTile = tileNwPoint.x + padding.left;
            const yTopOfInnerTile = tileNwPoint.y + padding.top;
            const innerTileTopLeftPoint = {
                x: xLeftOfInnerTile,
                y: yTopOfInnerTile
            };
            if (debugLevel >= 4) $4243bf518a93e3b4$var$log({
                innerTileTopLeftPoint: innerTileTopLeftPoint
            }); // render asynchronously so tiles show up as they finish instead of all at once (which blocks the UI)
            setTimeout(async ()=>{
                try {
                    let tileRasters = null;
                    if (!rasters) {
                        tileRasters = await this.getRasters({
                            innerTileTopLeftPoint: innerTileTopLeftPoint,
                            heightOfSampleInScreenPixels: heightOfSampleInScreenPixels,
                            widthOfSampleInScreenPixels: widthOfSampleInScreenPixels,
                            zoom: zoom,
                            pixelHeight: pixelHeight,
                            pixelWidth: pixelWidth,
                            numberOfSamplesAcross: numberOfSamplesAcross,
                            numberOfSamplesDown: numberOfSamplesDown,
                            ymax: ymax,
                            xmin: xmin
                        });
                        if (tileRasters && this.calcStats) {
                            const { noDataValue: noDataValue } = this;
                            for(let bandIndex = 0; bandIndex < tileRasters.length; bandIndex++){
                                let min = this.currentStats.mins[bandIndex];
                                let max = this.currentStats.maxs[bandIndex];
                                const band = tileRasters[bandIndex];
                                for(let rowIndex = 0; rowIndex < band.length; rowIndex++){
                                    const row = band[rowIndex];
                                    for(let columnIndex = 0; columnIndex < row.length; columnIndex++){
                                        const value = row[columnIndex];
                                        if (value !== noDataValue) {
                                            if (min === undefined || value < min) min = value;
                                            if (max === undefined || value > max) max = value;
                                        }
                                    }
                                }
                                this.currentStats.mins[bandIndex] = min;
                                this.currentStats.maxs[bandIndex] = max;
                                this.currentStats.ranges[bandIndex] = max - min;
                            }
                            if (this._dynamic) try {
                                const rawToRgbFn = (0, $772952f2056f565b$export$2e2bcd8739ae039).default || (0, $772952f2056f565b$export$2e2bcd8739ae039);
                                this.rawToRgb = rawToRgbFn({
                                    format: "string",
                                    flip: this.currentStats.mins.length === 1 ? true : false,
                                    ranges: $4243bf518a93e3b4$var$zip(this.currentStats.mins, this.currentStats.maxs),
                                    round: true
                                });
                            } catch (error) {
                                console.error(error);
                            }
                        }
                    }
                    await this.checkIfYCbCr;
                    for(let h = 0; h < numberOfSamplesDown; h++){
                        const yCenterInMapPixels = yTopOfInnerTile + (h + 0.5) * heightOfSampleInScreenPixels;
                        const latWestPoint = $iLKzi.point(xLeftOfInnerTile, yCenterInMapPixels);
                        const { lat: lat } = map.unproject(latWestPoint, zoom);
                        if (lat > yMinOfLayer && lat < yMaxOfLayer) {
                            const yInTilePixels = Math.round(h * heightOfSampleInScreenPixels) + Math.min(padding.top, 0);
                            let yInRasterPixels = 0;
                            if (inSimpleCRS || this.projection === $4243bf518a93e3b4$var$EPSG4326) yInRasterPixels = Math.floor((yMaxOfLayer - lat) / pixelHeight);
                            for(let w = 0; w < numberOfSamplesAcross; w++){
                                const latLngPoint = $iLKzi.point(xLeftOfInnerTile + (w + 0.5) * widthOfSampleInScreenPixels, yCenterInMapPixels);
                                const { lng: xOfLayer } = map.unproject(latLngPoint, zoom);
                                if (xOfLayer > xMinOfLayer && xOfLayer < xMaxOfLayer) {
                                    let xInRasterPixels = 0;
                                    if (inSimpleCRS || this.projection === $4243bf518a93e3b4$var$EPSG4326) xInRasterPixels = Math.floor((xOfLayer - xMinOfLayer) / pixelWidth);
                                    else if (this.getProjector()) {
                                        const inverted = this.getProjector().inverse({
                                            x: xOfLayer,
                                            y: lat
                                        });
                                        const yInSrc = inverted.y;
                                        yInRasterPixels = Math.floor((ymax - yInSrc) / pixelHeight);
                                        if (yInRasterPixels < 0 || yInRasterPixels >= rasterHeight) continue;
                                        const xInSrc = inverted.x;
                                        xInRasterPixels = Math.floor((xInSrc - xmin) / pixelWidth);
                                        if (xInRasterPixels < 0 || xInRasterPixels >= rasterWidth) continue;
                                    }
                                    let values = null;
                                    if (tileRasters) // get value from array specific to this tile
                                    values = tileRasters.map((band)=>band[h][w]);
                                    else if (rasters) // get value from array with data for entire raster
                                    values = rasters.map((band)=>{
                                        return band[yInRasterPixels][xInRasterPixels];
                                    });
                                    else {
                                        done && done(Error("no rasters are available for, so skipping value generation"));
                                        return;
                                    } // x-axis coordinate of the starting point of the rectangle representing the raster pixel
                                    const x = Math.round(w * widthOfSampleInScreenPixels) + Math.min(padding.left, 0); // y-axis coordinate of the starting point of the rectangle representing the raster pixel
                                    const y = yInTilePixels; // how many real screen pixels does a pixel of the sampled raster take up
                                    const width = widthOfSampleInScreenPixelsInt;
                                    const height = heightOfSampleInScreenPixelsInt;
                                    if (this.options.customDrawFunction) this.options.customDrawFunction({
                                        values: values,
                                        context: context,
                                        x: x,
                                        y: y,
                                        width: width,
                                        height: height,
                                        rasterX: xInRasterPixels,
                                        rasterY: yInRasterPixels,
                                        sampleX: w,
                                        sampleY: h,
                                        sampledRaster: tileRasters
                                    });
                                    else {
                                        const color = this.getColor(values);
                                        if (color && context) {
                                            context.fillStyle = color;
                                            context.fillRect(x, y, width, height);
                                        }
                                    }
                                }
                            }
                        }
                    }
                    if (this.mask) {
                        if (inSimpleCRS) console.warn("[georaster-layer-for-leaflet] mask is not supported when using simple projection");
                        else this.mask.then((mask)=>{
                            (0, (/*@__PURE__*/$parcel$interopDefault($e6ff6cf3f009bcd5$exports))).maskCanvas({
                                canvas: tile,
                                // eslint-disable-next-line camelcase
                                canvas_bbox: extentOfInnerTileInMapCRS.bbox,
                                // need to support simple projection too
                                // eslint-disable-next-line camelcase
                                canvas_srs: 3857,
                                mask: // default map crs, need to support simple
                                mask,
                                // eslint-disable-next-line camelcase
                                mask_srs: this.mask_srs,
                                strategy: this.mask_strategy // hide everything inside or outside the mask
                            });
                        });
                    }
                    tile.style.visibility = "visible"; // set to default
                } catch (e) {
                    console.error(e);
                    error = e;
                }
                done && done(error, tile);
            }, 0); // return the tile so it can be rendered on screen
            return tile;
        } catch (error) {
            console.error(error);
            done && done(error, tile);
        }
    },
    // copied from Leaflet with slight modifications,
    // including removing the lines that set the tile size
    _initTile: function(tile) {
        $iLKzi.DomUtil.addClass(tile, "leaflet-tile");
        tile.onselectstart = $iLKzi.Util.falseFn;
        tile.onmousemove = $iLKzi.Util.falseFn; // update opacity on tiles in IE7-8 because of filter inheritance problems
        if ($iLKzi.Browser.ielt9 && this.options.opacity < 1) $iLKzi.DomUtil.setOpacity(tile, this.options.opacity);
         // without this hack, tiles disappear after zoom on Chrome for Android
        // https://github.com/Leaflet/Leaflet/issues/2078
        if ($iLKzi.Browser.android && !$iLKzi.Browser.android23) tile.style.WebkitBackfaceVisibility = "hidden";
    },
    // method from https://github.com/Leaflet/Leaflet/blob/bb1d94ac7f2716852213dd11563d89855f8d6bb1/src/layer/ImageOverlay.js
    getBounds: function() {
        this.initBounds();
        return this._bounds;
    },
    getMap: function() {
        return this._map || this._mapToAdd;
    },
    getMapCRS: function() {
        var _this$getMap;
        return ((_this$getMap = this.getMap()) === null || _this$getMap === void 0 ? void 0 : _this$getMap.options.crs) || $iLKzi.CRS.EPSG3857;
    },
    // add in to ensure backwards compatability with Leaflet 1.0.3
    _tileCoordsToNwSe: function(coords) {
        const map = this.getMap();
        const tileSize = this.getTileSize();
        const nwPoint = coords.scaleBy(tileSize);
        const sePoint = nwPoint.add(tileSize);
        const nw = map.unproject(nwPoint, coords.z);
        const se = map.unproject(sePoint, coords.z);
        return [
            nw,
            se
        ];
    },
    _tileCoordsToBounds: function(coords) {
        const [nw, se] = this._tileCoordsToNwSe(coords);
        let bounds = new $iLKzi.LatLngBounds(nw, se);
        if (!this.options.noWrap) {
            const { crs: crs } = this.getMap().options;
            bounds = crs.wrapLatLngBounds(bounds);
        }
        return bounds;
    },
    _isValidTile: function(coords) {
        const crs = this.getMapCRS();
        if (!crs.infinite) {
            // don't load tile if it's out of bounds and not wrapped
            const globalBounds = this._globalTileRange;
            if (!crs.wrapLng && (coords.x < globalBounds.min.x || coords.x > globalBounds.max.x) || !crs.wrapLat && (coords.y < globalBounds.min.y || coords.y > globalBounds.max.y)) return false;
        }
        const bounds = this.getBounds();
        if (!bounds) return true;
        const { x: x, y: y, z: z } = coords; // not sure what srs should be here when simple crs
        const layerExtent = new (0, $53ee8012aead888f$export$46bf242104d56a04)(bounds, {
            srs: 4326
        });
        const boundsOfTile = this._tileCoordsToBounds(coords); // check given tile coordinates
        if (layerExtent.overlaps(boundsOfTile)) return true; // if not within the original confines of the earth return false
        // we don't want wrapping if using Simple CRS
        if ($4243bf518a93e3b4$var$isSimpleCRS(crs)) return false; // width of the globe in tiles at the given zoom level
        const width = Math.pow(2, z); // check one world to the left
        const leftCoords = $iLKzi.point(x - width, y);
        leftCoords.z = z;
        const leftBounds = this._tileCoordsToBounds(leftCoords);
        if (layerExtent.overlaps(leftBounds)) return true; // check one world to the right
        const rightCoords = $iLKzi.point(x + width, y);
        rightCoords.z = z;
        const rightBounds = this._tileCoordsToBounds(rightCoords);
        if (layerExtent.overlaps(rightBounds)) return true;
        return false;
    },
    getColor: function(values) {
        if (this.options.pixelValuesToColorFn) return this.options.pixelValuesToColorFn(values);
        else {
            const numberOfValues = values.length;
            const haveDataForAllBands = values.every((value)=>value !== undefined && value !== this.noDataValue);
            if (haveDataForAllBands) {
                if (numberOfValues == 1) {
                    const value = values[0];
                    if (this.palette) {
                        const [r, g, b, a] = this.palette[value];
                        return `rgba(${r},${g},${b},${a / 255})`;
                    } else if (this.georasters[0].mins) {
                        const { mins: mins, ranges: ranges } = this.georasters[0];
                        return this.scale((values[0] - mins[0]) / ranges[0]).hex();
                    } else if (this.currentStats.mins) {
                        const min = this.currentStats.mins[0];
                        const range = this.currentStats.ranges[0];
                        return this.scale((values[0] - min) / range).hex();
                    }
                } else if (numberOfValues === 2) return `rgb(${values[0]},${values[1]},0)`;
                else if (numberOfValues === 3) return `rgb(${values[0]},${values[1]},${values[2]})`;
                else if (numberOfValues === 4) return `rgba(${values[0]},${values[1]},${values[2]},${values[3] / 255})`;
            }
        }
    },
    /**
   * Redraws the active map tiles updating the pixel values using the supplie callback
   */ updateColors (pixelValuesToColorFn, { debugLevel: debugLevel = -1 } = {
        debugLevel: -1
    }) {
        if (!pixelValuesToColorFn) throw new Error("Missing pixelValuesToColorFn function");
         // if debugLevel is -1, set it to the default for the class
        if (debugLevel === -1) debugLevel = this.debugLevel;
        if (debugLevel >= 1) console.log("Start updating active tile pixel values"); // update option to ensure correct colours at other zoom levels.
        this.options.pixelValuesToColorFn = pixelValuesToColorFn;
        const tiles = this.getActiveTiles();
        if (!tiles) {
            console.error("No active tiles available");
            return this;
        }
        if (debugLevel >= 1) console.log("Active tiles fetched", tiles);
        tiles.forEach((tile)=>{
            const { coords: coords, el: el } = tile;
            this.drawTile({
                tile: el,
                coords: coords,
                context: el.getContext("2d")
            });
        });
        if (debugLevel >= 1) console.log("Finished updating active tile colours");
        return this;
    },
    getTiles () {
        // transform _tiles object collection into an array
        return Object.values(this._tiles);
    },
    getActiveTiles () {
        const tiles = this.getTiles(); // only return valid tiles
        return tiles.filter((tile)=>this._isValidTile(tile.coords));
    },
    isSupportedProjection: function() {
        if (this._isSupportedProjection === undefined) {
            const projection = this.projection;
            if ((0, (/*@__PURE__*/$parcel$interopDefault($da647afaa7b4daaa$exports)))(projection)) this._isSupportedProjection = true;
            else if ($4243bf518a93e3b4$var$PROJ4_SUPPORTED_PROJECTIONS.has(projection)) this._isSupportedProjection = true;
            else if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($3faba67f5f823edd$exports))) === "function" && `EPSG:${projection}` in (0, (/*@__PURE__*/$parcel$interopDefault($3faba67f5f823edd$exports))).defs) this._isSupportedProjection = true;
            else if (typeof proj4 === "function" && typeof proj4.defs !== "undefined" && `EPSG:${projection}` in proj4.defs) this._isSupportedProjection = true;
            else this._isSupportedProjection = false;
        }
        return this._isSupportedProjection;
    },
    getProjectionString: function(projection) {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($da647afaa7b4daaa$exports)))(projection)) return (0, (/*@__PURE__*/$parcel$interopDefault($53b6c494a80f9dfd$exports)))(projection);
        return `EPSG:${projection}`;
    },
    initBounds: function(options) {
        if (!options) options = this.options;
        if (!this._bounds) {
            const { debugLevel: debugLevel, height: height, width: width, projection: projection, xmin: xmin, xmax: xmax, ymin: ymin, ymax: ymax } = this; // check if map using Simple CRS
            if ($4243bf518a93e3b4$var$isSimpleCRS(this.getMapCRS())) {
                if (height === width) this._bounds = $iLKzi.latLngBounds([
                    $4243bf518a93e3b4$var$ORIGIN,
                    [
                        $4243bf518a93e3b4$var$MAX_NORTHING,
                        $4243bf518a93e3b4$var$MAX_EASTING
                    ]
                ]);
                else if (height > width) this._bounds = $iLKzi.latLngBounds([
                    $4243bf518a93e3b4$var$ORIGIN,
                    [
                        $4243bf518a93e3b4$var$MAX_NORTHING,
                        $4243bf518a93e3b4$var$MAX_EASTING / this.ratio
                    ]
                ]);
                else if (width > height) this._bounds = $iLKzi.latLngBounds([
                    $4243bf518a93e3b4$var$ORIGIN,
                    [
                        $4243bf518a93e3b4$var$MAX_NORTHING * this.ratio,
                        $4243bf518a93e3b4$var$MAX_EASTING
                    ]
                ]);
            } else if (projection === $4243bf518a93e3b4$var$EPSG4326) {
                if (debugLevel >= 1) console.log(`georaster projection is in ${$4243bf518a93e3b4$var$EPSG4326}`);
                const minLatWest = $iLKzi.latLng(ymin, xmin);
                const maxLatEast = $iLKzi.latLng(ymax, xmax);
                this._bounds = $iLKzi.latLngBounds(minLatWest, maxLatEast);
            } else if (this.getProjector()) {
                if (debugLevel >= 1) console.log("projection is UTM or supported by proj4");
                const bottomLeft = this.getProjector().forward({
                    x: xmin,
                    y: ymin
                });
                const minLatWest = $iLKzi.latLng(bottomLeft.y, bottomLeft.x);
                const topRight = this.getProjector().forward({
                    x: xmax,
                    y: ymax
                });
                const maxLatEast = $iLKzi.latLng(topRight.y, topRight.x);
                this._bounds = $iLKzi.latLngBounds(minLatWest, maxLatEast);
            } else {
                if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($3faba67f5f823edd$exports))) !== "function") throw `You are using the lite version of georaster-layer-for-leaflet, which does not support rasters with the projection ${projection}.  Please try using the default build or add the projection definition to your global proj4.`;
                else throw `GeoRasterLayer does not provide built-in support for rasters with the projection ${projection}.  Add the projection definition to your global proj4.`;
            } // these values are used so we don't try to sample outside of the raster
            this.xMinOfLayer = this._bounds.getWest();
            this.xMaxOfLayer = this._bounds.getEast();
            this.yMaxOfLayer = this._bounds.getNorth();
            this.yMinOfLayer = this._bounds.getSouth();
            options.bounds = this._bounds;
        }
    },
    getProjector: function() {
        if (this.isSupportedProjection()) {
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($3faba67f5f823edd$exports))) && !proj4) throw "proj4 must be found in the global scope in order to load a raster that uses this projection";
            if (!this._projector) {
                const projString = this.getProjectionString(this.projection);
                if (this.debugLevel >= 1) $4243bf518a93e3b4$var$log({
                    projString: projString
                });
                let proj4Lib;
                if (projString.startsWith("EPSG")) {
                    if (typeof proj4 === "function" && typeof proj4.defs === "function" && projString in proj4.defs) proj4Lib = proj4;
                    else if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($3faba67f5f823edd$exports))) === "function" && typeof (0, (/*@__PURE__*/$parcel$interopDefault($3faba67f5f823edd$exports))).defs === "function" && projString in (0, (/*@__PURE__*/$parcel$interopDefault($3faba67f5f823edd$exports))).defs) proj4Lib = (0, (/*@__PURE__*/$parcel$interopDefault($3faba67f5f823edd$exports)));
                    else throw "[georaster-layer-for-leaflet] projection not found in proj4 instance";
                } else {
                    if (typeof proj4 === "function") proj4Lib = proj4;
                    else if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($3faba67f5f823edd$exports))) === "function") proj4Lib = (0, (/*@__PURE__*/$parcel$interopDefault($3faba67f5f823edd$exports)));
                    else throw "[georaster-layer-for-leaflet] projection not found in proj4 instance";
                }
                this._projector = proj4Lib(projString, `EPSG:${$4243bf518a93e3b4$var$EPSG4326}`);
                if (this.debugLevel >= 1) console.log("projector set");
            }
            return this._projector;
        }
    },
    same (array, key) {
        return new Set(array.map((item)=>item[key])).size === 1;
    }
});
/* eslint-disable @typescript-eslint/no-explicit-any */ if (typeof window === "object") window["GeoRasterLayer"] = $4243bf518a93e3b4$var$GeoRasterLayer;
if (typeof self !== "undefined") self["GeoRasterLayer"] = $4243bf518a93e3b4$var$GeoRasterLayer;
var /* eslint-enable @typescript-eslint/no-explicit-any */ $4243bf518a93e3b4$export$2e2bcd8739ae039 // Explicitly exports public types
 = $4243bf518a93e3b4$var$GeoRasterLayer;


var $fff057aebec3dd6f$exports = {};
!function(t, e) {
    $fff057aebec3dd6f$exports = e();
}("undefined" != typeof window ? window : "undefined" != typeof self ? self : "undefined" != typeof $parcel$global ? $parcel$global : void 0 !== $fff057aebec3dd6f$exports ? $fff057aebec3dd6f$exports : void 0, function() {
    return function(t) {
        var e = {};
        function r(n) {
            if (e[n]) return e[n].exports;
            var i = e[n] = {
                i: n,
                l: !1,
                exports: {}
            };
            return t[n].call(i.exports, i, i.exports, r), i.l = !0, i.exports;
        }
        return r.m = t, r.c = e, r.d = function(t, e, n) {
            r.o(t, e) || Object.defineProperty(t, e, {
                enumerable: !0,
                get: n
            });
        }, r.r = function(t) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(t, "__esModule", {
                value: !0
            });
        }, r.t = function(t, e) {
            if (1 & e && (t = r(t)), 8 & e) return t;
            if (4 & e && "object" == typeof t && t && t.__esModule) return t;
            var n = Object.create(null);
            if (r.r(n), Object.defineProperty(n, "default", {
                enumerable: !0,
                value: t
            }), 2 & e && "string" != typeof t) for(var i in t)r.d(n, i, (function(e) {
                return t[e];
            }).bind(null, i));
            return n;
        }, r.n = function(t) {
            var e = t && t.__esModule ? function() {
                return t.default;
            } : function() {
                return t;
            };
            return r.d(e, "a", e), e;
        }, r.o = function(t, e) {
            return Object.prototype.hasOwnProperty.call(t, e);
        }, r.p = "", r(r.s = 177);
    }([
        function(t, e, r) {
            "use strict";
            (function(t) {
                r.d(e, "e", function() {
                    return n;
                }), r.d(e, "p", function() {
                    return i;
                }), r.d(e, "a", function() {
                    return o;
                }), r.d(e, "c", function() {
                    return a;
                }), r.d(e, "d", function() {
                    return s;
                }), r.d(e, "o", function() {
                    return u;
                }), r.d(e, "q", function() {
                    return l;
                }), r.d(e, "t", function() {
                    return c;
                }), r.d(e, "i", function() {
                    return f;
                }), r.d(e, "r", function() {
                    return h;
                }), r.d(e, "s", function() {
                    return p;
                }), r.d(e, "k", function() {
                    return d;
                }), r.d(e, "m", function() {
                    return m;
                }), r.d(e, "j", function() {
                    return y;
                }), r.d(e, "l", function() {
                    return g;
                }), r.d(e, "g", function() {
                    return v;
                }), r.d(e, "f", function() {
                    return b;
                }), r.d(e, "h", function() {
                    return x;
                }), r.d(e, "n", function() {
                    return w;
                }), r.d(e, "b", function() {
                    return _;
                });
                var n = "1.13.6", i = "object" == typeof self && self.self === self && self || "object" == typeof t && t.global === t && t || Function("return this")() || {}, o = Array.prototype, a = Object.prototype, s = "undefined" != typeof Symbol ? Symbol.prototype : null, u = o.push, l = o.slice, c = a.toString, f = a.hasOwnProperty, h = "undefined" != typeof ArrayBuffer, p = "undefined" != typeof DataView, d = Array.isArray, m = Object.keys, y = Object.create, g = h && ArrayBuffer.isView, v = isNaN, b = isFinite, x = !({
                    toString: null
                }).propertyIsEnumerable("toString"), w = [
                    "valueOf",
                    "isPrototypeOf",
                    "toString",
                    "propertyIsEnumerable",
                    "hasOwnProperty",
                    "toLocaleString"
                ], _ = Math.pow(2, 53) - 1;
            }).call(this, r(46));
        },
        ,
        function(t, e, r) {
            var n = r(212);
            t.exports = function(t, e, r) {
                return (e = n(e)) in t ? Object.defineProperty(t, e, {
                    value: r,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }) : t[e] = r, t;
            }, t.exports.__esModule = !0, t.exports.default = t.exports;
        },
        function(t, e, r) {
            "use strict";
            const n = r(130);
            t.exports = function(t) {
                return "+" === t[0] && (t = t.substring(1)), (t = (t = n(t)).replace(/^0+(?=\d)/, "")).includes(".") && (t = t.replace(/\.?0+$/, "")), "" === t && (t = "0"), "-0" === t && (t = "0"), t;
            };
        },
        function(t, e) {
            function r() {
                return t.exports = r = Object.assign ? Object.assign.bind() : function(t) {
                    for(var e = 1; e < arguments.length; e++){
                        var r = arguments[e];
                        for(var n in r)({}).hasOwnProperty.call(r, n) && (t[n] = r[n]);
                    }
                    return t;
                }, t.exports.__esModule = !0, t.exports.default = t.exports, r.apply(null, arguments);
            }
            t.exports = r, t.exports.__esModule = !0, t.exports.default = t.exports;
        },
        function(t, e, r) {
            var n = r(184)();
            t.exports = n;
            try {
                regeneratorRuntime = n;
            } catch (t) {
                "object" == typeof globalThis ? globalThis.regeneratorRuntime = n : Function("r", "regeneratorRuntime = r")(n);
            }
        },
        function(t, e, r) {
            "use strict";
            r.d(e, "a", function() {
                return n;
            }), r.d(e, "e", function() {
                return i;
            }), r.d(e, "d", function() {
                return o;
            }), r.d(e, "b", function() {
                return a;
            }), r.d(e, "c", function() {
                return s;
            });
            function n(t, e, r) {
                void 0 === r && (r = {});
                var n = {
                    type: "Feature"
                };
                return (0 === r.id || r.id) && (n.id = r.id), r.bbox && (n.bbox = r.bbox), n.properties = e || {}, n.geometry = t, n;
            }
            function i(t, e, r) {
                if (void 0 === r && (r = {}), !t) throw new Error("coordinates is required");
                if (!Array.isArray(t)) throw new Error("coordinates must be an Array");
                if (t.length < 2) throw new Error("coordinates must be at least 2 numbers long");
                if (!a(t[0]) || !a(t[1])) throw new Error("coordinates must contain numbers");
                return n({
                    type: "Point",
                    coordinates: t
                }, e, r);
            }
            function o(t, e, r) {
                if (void 0 === r && (r = {}), t.length < 2) throw new Error("coordinates must be an array of two or more positions");
                return n({
                    type: "LineString",
                    coordinates: t
                }, e, r);
            }
            function a(t) {
                return !isNaN(t) && null !== t && !Array.isArray(t);
            }
            function s(t) {
                return !!t && t.constructor === Object;
            }
        },
        function(t, e) {
            function r(e) {
                return t.exports = r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                    return typeof t;
                } : function(t) {
                    return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                }, t.exports.__esModule = !0, t.exports.default = t.exports, r(e);
            }
            t.exports = r, t.exports.__esModule = !0, t.exports.default = t.exports;
        },
        function(t, e, r) {
            var n = r(185), i = r(186), o = r(110), a = r(187);
            t.exports = function(t, e) {
                return n(t) || i(t, e) || o(t, e) || a();
            }, t.exports.__esModule = !0, t.exports.default = t.exports;
        },
        function(t, e, r) {
            "use strict";
            r.d(e, "a", function() {
                return _;
            });
            var n = r(22), i = r.n(n), o = r(8), a = r.n(o), s = r(7), u = r.n(s), l = r(66), c = r.n(l), f = r(54), h = r.n(f), p = r(103), d = r.n(p), m = r(165), y = r.n(m), g = r(44), v = r.n(g);
            function b(t) {
                return c()(t).then(function(t) {
                    return t.json();
                });
            }
            function x(t) {
                return -1 * Math.round(-1 * t);
            }
            var w = {
                convertToGeojsonIfNecessary: function(t) {
                    var e = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                    return this.isEsriJson(t, e) ? this.toGeoJSON(t, e) : t;
                },
                convertCrsBboxToImageBbox: function(t, e) {
                    var r, n, i, o;
                    return void 0 !== e.xmin ? (r = e.xmin, n = e.ymin, i = e.xmax, o = e.ymax) : Array.isArray(e) && 4 === e.length && (r = e[0], n = e[1], i = e[2], o = e[3]), {
                        xmin: x((r - t.xmin) / t.pixelWidth),
                        ymin: x((t.ymax - o) / t.pixelHeight),
                        xmax: Math.round((i - t.xmin) / t.pixelWidth),
                        ymax: Math.round((t.ymax - n) / t.pixelHeight)
                    };
                },
                isBbox: function(t) {
                    var e = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                    if ("string" == typeof t && (t = JSON.parse(t)), null == t) return e && console.log("[geoblaze/src/utils/isBbox] geom is undefined or null"), !1;
                    if (void 0 !== t.xmin && void 0 !== t.xmax && void 0 !== t.ymax && void 0 !== t.ymin) return e && console.log("[geoblaze/src/utils/isBbox] geom is bbox object"), !0;
                    if (Array.isArray(t) && v()(t)) return e && console.log("[geoblaze/src/utils/isBbox] geom is valid bbox"), !0;
                    var r = h.a.get(t);
                    return !!y()(r);
                },
                isEsriJson: function(t) {
                    var e = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                    if (e && console.log("starting isEsriJson with", t), void 0 === t) return !1;
                    var r = "string" == typeof t ? JSON.parse(t) : "object" === u()(t) ? t : null, n = r.geometry ? r.geometry : r;
                    if (!n) return !1;
                    if (!(n.rings || n.x && n.y)) return !1;
                    try {
                        return !!d.a.parse(r);
                    } catch (t) {
                        return console.error(t), !1;
                    }
                },
                isGeoJSON: function(t) {
                    return void 0 !== t && null !== t && !w.isEsriJson(t) && [
                        "FeatureCollection",
                        "Feature",
                        "Polygon",
                        "MultiPolygon"
                    ].includes(t.type);
                },
                toGeoJSON: function(t) {
                    var e = d.a.toGeoJSON(t);
                    return Array.isArray(e) ? e[0] : e;
                },
                isBboxObj: function(t) {
                    return "object" === u()(t) && !1 === Array.isArray(t) && "number" == typeof t.xmin && "number" == typeof t.xmax && "number" == typeof t.ymin && "number" == typeof t.ymax;
                },
                isPolygonal: function(t) {
                    var e = h.a.get(t);
                    if (0 === e.length) return !1;
                    for(var r = 0; r < e.length; r++)for(var n = e[r], i = 0; i < n.length; i++){
                        var o = n[i], s = a()(o[0], 2), u = s[0], l = s[1], c = a()(o[o.length - 1], 2), f = c[0], p = c[1];
                        if (u !== f || l !== p) return !1;
                    }
                    return !0;
                },
                fetchJson: b,
                fetchJsons: function(t) {
                    try {
                        return Promise.all(t.map(b));
                    } catch (t) {
                        throw console.log("[geoblaze] fetchJsons failed because of the following error:", t), t;
                    }
                },
                getConstructorName: function(t) {
                    try {
                        if ("object" === u()(t) && "function" == typeof t.constructor && "string" == typeof t.constructor.name) return t.constructor.name;
                    } catch (t) {
                        return;
                    }
                },
                sum: function(t) {
                    return t.reduce(function(t, e) {
                        return t + e;
                    });
                },
                isPromise: function(t) {
                    return "object" === u()(t) && "function" == typeof t.then;
                },
                isSync: function(t) {
                    return !this.isPromise(t);
                },
                listVariables: function(t) {
                    return i()(Array(t)).map(function(t, e) {
                        return String.fromCharCode(e + 65).toLowerCase();
                    });
                },
                round: function(t) {
                    return Number(t.toFixed(2));
                },
                callAfterResolveArgs: function(t) {
                    for(var e = arguments.length, r = new Array(e > 1 ? e - 1 : 0), n = 1; n < e; n++)r[n - 1] = arguments[n];
                    return r.some(this.isPromise) ? Promise.all(r).then(function(e) {
                        return t.apply(void 0, i()(e));
                    }) : t.apply(void 0, r);
                },
                range: function(t, e) {
                    for(var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1, n = [], i = t; r < 0 ? i > e : i < e; i += r)n.push(i);
                    return n;
                },
                roundDown: x
            }, _ = w;
        },
        function(t, e, r) {
            var n;
            /**
 * @license Complex.js v2.1.1 12/05/2020
 *
 * Copyright (c) 2020, Robert Eisele (robert@xarg.org)
 * Dual licensed under the MIT or GPL Version 2 licenses.
 **/ !function(r) {
                "use strict";
                var i = Math.cosh || function(t) {
                    return Math.abs(t) < 1e-9 ? 1 - t : .5 * (Math.exp(t) + Math.exp(-t));
                }, o = Math.sinh || function(t) {
                    return Math.abs(t) < 1e-9 ? t : .5 * (Math.exp(t) - Math.exp(-t));
                }, a = function() {
                    throw SyntaxError("Invalid Param");
                };
                function s(t, e) {
                    var r = Math.abs(t), n = Math.abs(e);
                    return 0 === t ? Math.log(n) : 0 === e ? Math.log(r) : r < 3e3 && n < 3e3 ? .5 * Math.log(t * t + e * e) : (t /= 2, e /= 2, .5 * Math.log(t * t + e * e) + Math.LN2);
                }
                function u(t, e) {
                    if (!(this instanceof u)) return new u(t, e);
                    var r = function(t, e) {
                        var r = {
                            re: 0,
                            im: 0
                        };
                        if (null == t) r.re = r.im = 0;
                        else if (void 0 !== e) r.re = t, r.im = e;
                        else switch(typeof t){
                            case "object":
                                if ("im" in t && "re" in t) r.re = t.re, r.im = t.im;
                                else if ("abs" in t && "arg" in t) {
                                    if (!Number.isFinite(t.abs) && Number.isFinite(t.arg)) return u.INFINITY;
                                    r.re = t.abs * Math.cos(t.arg), r.im = t.abs * Math.sin(t.arg);
                                } else if ("r" in t && "phi" in t) {
                                    if (!Number.isFinite(t.r) && Number.isFinite(t.phi)) return u.INFINITY;
                                    r.re = t.r * Math.cos(t.phi), r.im = t.r * Math.sin(t.phi);
                                } else 2 === t.length ? (r.re = t[0], r.im = t[1]) : a();
                                break;
                            case "string":
                                r.im = r.re = 0;
                                var n = t.match(/\d+\.?\d*e[+-]?\d+|\d+\.?\d*|\.\d+|./g), i = 1, o = 0;
                                null === n && a();
                                for(var s = 0; s < n.length; s++){
                                    var l = n[s];
                                    " " === l || "	" === l || "\n" === l || ("+" === l ? i++ : "-" === l ? o++ : "i" === l || "I" === l ? (i + o === 0 && a(), " " === n[s + 1] || isNaN(n[s + 1]) ? r.im += parseFloat((o % 2 ? "-" : "") + "1") : (r.im += parseFloat((o % 2 ? "-" : "") + n[s + 1]), s++), i = o = 0) : ((i + o === 0 || isNaN(l)) && a(), "i" === n[s + 1] || "I" === n[s + 1] ? (r.im += parseFloat((o % 2 ? "-" : "") + l), s++) : r.re += parseFloat((o % 2 ? "-" : "") + l), i = o = 0));
                                }
                                i + o > 0 && a();
                                break;
                            case "number":
                                r.im = 0, r.re = t;
                                break;
                            default:
                                a();
                        }
                        return isNaN(r.re) || isNaN(r.im), r;
                    }(t, e);
                    this.re = r.re, this.im = r.im;
                }
                u.prototype = {
                    re: 0,
                    im: 0,
                    sign: function() {
                        var t = this.abs();
                        return new u(this.re / t, this.im / t);
                    },
                    add: function(t, e) {
                        var r = new u(t, e);
                        return this.isInfinite() && r.isInfinite() ? u.NAN : this.isInfinite() || r.isInfinite() ? u.INFINITY : new u(this.re + r.re, this.im + r.im);
                    },
                    sub: function(t, e) {
                        var r = new u(t, e);
                        return this.isInfinite() && r.isInfinite() ? u.NAN : this.isInfinite() || r.isInfinite() ? u.INFINITY : new u(this.re - r.re, this.im - r.im);
                    },
                    mul: function(t, e) {
                        var r = new u(t, e);
                        return this.isInfinite() && r.isZero() || this.isZero() && r.isInfinite() ? u.NAN : this.isInfinite() || r.isInfinite() ? u.INFINITY : 0 === r.im && 0 === this.im ? new u(this.re * r.re, 0) : new u(this.re * r.re - this.im * r.im, this.re * r.im + this.im * r.re);
                    },
                    div: function(t, e) {
                        var r = new u(t, e);
                        if (this.isZero() && r.isZero() || this.isInfinite() && r.isInfinite()) return u.NAN;
                        if (this.isInfinite() || r.isZero()) return u.INFINITY;
                        if (this.isZero() || r.isInfinite()) return u.ZERO;
                        t = this.re, e = this.im;
                        var n, i, o = r.re, a = r.im;
                        return 0 === a ? new u(t / o, e / o) : Math.abs(o) < Math.abs(a) ? new u((t * (i = o / a) + e) / (n = o * i + a), (e * i - t) / n) : new u((t + e * (i = a / o)) / (n = a * i + o), (e - t * i) / n);
                    },
                    pow: function(t, e) {
                        var r = new u(t, e);
                        if (t = this.re, e = this.im, r.isZero()) return u.ONE;
                        if (0 === r.im) {
                            if (0 === e && t > 0) return new u(Math.pow(t, r.re), 0);
                            if (0 === t) switch((r.re % 4 + 4) % 4){
                                case 0:
                                    return new u(Math.pow(e, r.re), 0);
                                case 1:
                                    return new u(0, Math.pow(e, r.re));
                                case 2:
                                    return new u(-Math.pow(e, r.re), 0);
                                case 3:
                                    return new u(0, -Math.pow(e, r.re));
                            }
                        }
                        if (0 === t && 0 === e && r.re > 0 && r.im >= 0) return u.ZERO;
                        var n = Math.atan2(e, t), i = s(t, e);
                        return t = Math.exp(r.re * i - r.im * n), e = r.im * i + r.re * n, new u(t * Math.cos(e), t * Math.sin(e));
                    },
                    sqrt: function() {
                        var t, e, r = this.re, n = this.im, i = this.abs();
                        if (r >= 0) {
                            if (0 === n) return new u(Math.sqrt(r), 0);
                            t = .5 * Math.sqrt(2 * (i + r));
                        } else t = Math.abs(n) / Math.sqrt(2 * (i - r));
                        return e = r <= 0 ? .5 * Math.sqrt(2 * (i - r)) : Math.abs(n) / Math.sqrt(2 * (i + r)), new u(t, n < 0 ? -e : e);
                    },
                    exp: function() {
                        var t = Math.exp(this.re);
                        return this.im, new u(t * Math.cos(this.im), t * Math.sin(this.im));
                    },
                    expm1: function() {
                        var t = this.re, e = this.im;
                        return new u(Math.expm1(t) * Math.cos(e) + function(t) {
                            var e = Math.PI / 4;
                            if (-e > t || t > e) return Math.cos(t) - 1;
                            var r = t * t;
                            return r * (r * (r * (r * (r * (r * (r * (r / 20922789888e3 - 1 / 87178291200) + 1 / 479001600) - 1 / 3628800) + 1 / 40320) - 1 / 720) + 1 / 24) - .5);
                        }(e), Math.exp(t) * Math.sin(e));
                    },
                    log: function() {
                        var t = this.re, e = this.im;
                        return new u(s(t, e), Math.atan2(e, t));
                    },
                    abs: function() {
                        var t, e, r, n;
                        return t = this.re, e = this.im, r = Math.abs(t), n = Math.abs(e), r < 3e3 && n < 3e3 ? Math.sqrt(r * r + n * n) : (r < n ? (r = n, n = t / e) : n = e / t, r * Math.sqrt(1 + n * n));
                    },
                    arg: function() {
                        return Math.atan2(this.im, this.re);
                    },
                    sin: function() {
                        var t = this.re, e = this.im;
                        return new u(Math.sin(t) * i(e), Math.cos(t) * o(e));
                    },
                    cos: function() {
                        var t = this.re, e = this.im;
                        return new u(Math.cos(t) * i(e), -Math.sin(t) * o(e));
                    },
                    tan: function() {
                        var t = 2 * this.re, e = 2 * this.im, r = Math.cos(t) + i(e);
                        return new u(Math.sin(t) / r, o(e) / r);
                    },
                    cot: function() {
                        var t = 2 * this.re, e = 2 * this.im, r = Math.cos(t) - i(e);
                        return new u(-Math.sin(t) / r, o(e) / r);
                    },
                    sec: function() {
                        var t = this.re, e = this.im, r = .5 * i(2 * e) + .5 * Math.cos(2 * t);
                        return new u(Math.cos(t) * i(e) / r, Math.sin(t) * o(e) / r);
                    },
                    csc: function() {
                        var t = this.re, e = this.im, r = .5 * i(2 * e) - .5 * Math.cos(2 * t);
                        return new u(Math.sin(t) * i(e) / r, -Math.cos(t) * o(e) / r);
                    },
                    asin: function() {
                        var t = this.re, e = this.im, r = new u(e * e - t * t + 1, -2 * t * e).sqrt(), n = new u(r.re - e, r.im + t).log();
                        return new u(n.im, -n.re);
                    },
                    acos: function() {
                        var t = this.re, e = this.im, r = new u(e * e - t * t + 1, -2 * t * e).sqrt(), n = new u(r.re - e, r.im + t).log();
                        return new u(Math.PI / 2 - n.im, n.re);
                    },
                    atan: function() {
                        var t = this.re, e = this.im;
                        if (0 === t) {
                            if (1 === e) return new u(0, 1 / 0);
                            if (-1 === e) return new u(0, -1 / 0);
                        }
                        var r = t * t + (1 - e) * (1 - e), n = new u((1 - e * e - t * t) / r, -2 * t / r).log();
                        return new u(-0.5 * n.im, .5 * n.re);
                    },
                    acot: function() {
                        var t = this.re, e = this.im;
                        if (0 === e) return new u(Math.atan2(1, t), 0);
                        var r = t * t + e * e;
                        return 0 !== r ? new u(t / r, -e / r).atan() : new u(0 !== t ? t / 0 : 0, 0 !== e ? -e / 0 : 0).atan();
                    },
                    asec: function() {
                        var t = this.re, e = this.im;
                        if (0 === t && 0 === e) return new u(0, 1 / 0);
                        var r = t * t + e * e;
                        return 0 !== r ? new u(t / r, -e / r).acos() : new u(0 !== t ? t / 0 : 0, 0 !== e ? -e / 0 : 0).acos();
                    },
                    acsc: function() {
                        var t = this.re, e = this.im;
                        if (0 === t && 0 === e) return new u(Math.PI / 2, 1 / 0);
                        var r = t * t + e * e;
                        return 0 !== r ? new u(t / r, -e / r).asin() : new u(0 !== t ? t / 0 : 0, 0 !== e ? -e / 0 : 0).asin();
                    },
                    sinh: function() {
                        var t = this.re, e = this.im;
                        return new u(o(t) * Math.cos(e), i(t) * Math.sin(e));
                    },
                    cosh: function() {
                        var t = this.re, e = this.im;
                        return new u(i(t) * Math.cos(e), o(t) * Math.sin(e));
                    },
                    tanh: function() {
                        var t = 2 * this.re, e = 2 * this.im, r = i(t) + Math.cos(e);
                        return new u(o(t) / r, Math.sin(e) / r);
                    },
                    coth: function() {
                        var t = 2 * this.re, e = 2 * this.im, r = i(t) - Math.cos(e);
                        return new u(o(t) / r, -Math.sin(e) / r);
                    },
                    csch: function() {
                        var t = this.re, e = this.im, r = Math.cos(2 * e) - i(2 * t);
                        return new u(-2 * o(t) * Math.cos(e) / r, 2 * i(t) * Math.sin(e) / r);
                    },
                    sech: function() {
                        var t = this.re, e = this.im, r = Math.cos(2 * e) + i(2 * t);
                        return new u(2 * i(t) * Math.cos(e) / r, -2 * o(t) * Math.sin(e) / r);
                    },
                    asinh: function() {
                        var t = this.im;
                        this.im = -this.re, this.re = t;
                        var e = this.asin();
                        return this.re = -this.im, this.im = t, t = e.re, e.re = -e.im, e.im = t, e;
                    },
                    acosh: function() {
                        var t = this.acos();
                        if (t.im <= 0) {
                            var e = t.re;
                            t.re = -t.im, t.im = e;
                        } else {
                            e = t.im;
                            t.im = -t.re, t.re = e;
                        }
                        return t;
                    },
                    atanh: function() {
                        var t = this.re, e = this.im, r = t > 1 && 0 === e, n = 1 - t, i = 1 + t, o = n * n + e * e, a = 0 !== o ? new u((i * n - e * e) / o, (e * n + i * e) / o) : new u(-1 !== t ? t / 0 : 0, 0 !== e ? e / 0 : 0), l = a.re;
                        return a.re = s(a.re, a.im) / 2, a.im = Math.atan2(a.im, l) / 2, r && (a.im = -a.im), a;
                    },
                    acoth: function() {
                        var t = this.re, e = this.im;
                        if (0 === t && 0 === e) return new u(0, Math.PI / 2);
                        var r = t * t + e * e;
                        return 0 !== r ? new u(t / r, -e / r).atanh() : new u(0 !== t ? t / 0 : 0, 0 !== e ? -e / 0 : 0).atanh();
                    },
                    acsch: function() {
                        var t = this.re, e = this.im;
                        if (0 === e) return new u(0 !== t ? Math.log(t + Math.sqrt(t * t + 1)) : 1 / 0, 0);
                        var r = t * t + e * e;
                        return 0 !== r ? new u(t / r, -e / r).asinh() : new u(0 !== t ? t / 0 : 0, 0 !== e ? -e / 0 : 0).asinh();
                    },
                    asech: function() {
                        var t = this.re, e = this.im;
                        if (this.isZero()) return u.INFINITY;
                        var r = t * t + e * e;
                        return 0 !== r ? new u(t / r, -e / r).acosh() : new u(0 !== t ? t / 0 : 0, 0 !== e ? -e / 0 : 0).acosh();
                    },
                    inverse: function() {
                        if (this.isZero()) return u.INFINITY;
                        if (this.isInfinite()) return u.ZERO;
                        var t = this.re, e = this.im, r = t * t + e * e;
                        return new u(t / r, -e / r);
                    },
                    conjugate: function() {
                        return new u(this.re, -this.im);
                    },
                    neg: function() {
                        return new u(-this.re, -this.im);
                    },
                    ceil: function(t) {
                        return t = Math.pow(10, t || 0), new u(Math.ceil(this.re * t) / t, Math.ceil(this.im * t) / t);
                    },
                    floor: function(t) {
                        return t = Math.pow(10, t || 0), new u(Math.floor(this.re * t) / t, Math.floor(this.im * t) / t);
                    },
                    round: function(t) {
                        return t = Math.pow(10, t || 0), new u(Math.round(this.re * t) / t, Math.round(this.im * t) / t);
                    },
                    equals: function(t, e) {
                        var r = new u(t, e);
                        return Math.abs(r.re - this.re) <= u.EPSILON && Math.abs(r.im - this.im) <= u.EPSILON;
                    },
                    clone: function() {
                        return new u(this.re, this.im);
                    },
                    toString: function() {
                        var t = this.re, e = this.im, r = "";
                        return this.isNaN() ? "NaN" : this.isInfinite() ? "Infinity" : (Math.abs(t) < u.EPSILON && (t = 0), Math.abs(e) < u.EPSILON && (e = 0), 0 === e ? r + t : (0 !== t ? (r += t, r += " ", e < 0 ? (e = -e, r += "-") : r += "+", r += " ") : e < 0 && (e = -e, r += "-"), 1 !== e && (r += e), r + "i"));
                    },
                    toVector: function() {
                        return [
                            this.re,
                            this.im
                        ];
                    },
                    valueOf: function() {
                        return 0 === this.im ? this.re : null;
                    },
                    isNaN: function() {
                        return isNaN(this.re) || isNaN(this.im);
                    },
                    isZero: function() {
                        return 0 === this.im && 0 === this.re;
                    },
                    isFinite: function() {
                        return isFinite(this.re) && isFinite(this.im);
                    },
                    isInfinite: function() {
                        return !(this.isNaN() || this.isFinite());
                    }
                }, u.ZERO = new u(0, 0), u.ONE = new u(1, 0), u.I = new u(0, 1), u.PI = new u(Math.PI, 0), u.E = new u(Math.E, 0), u.INFINITY = new u(1 / 0, 1 / 0), u.NAN = new u(NaN, NaN), u.EPSILON = 1e-15, void 0 === (n = (function() {
                    return u;
                }).apply(e, [])) || (t.exports = n);
            }();
        },
        function(t, e, r) {
            "use strict";
            r.d(e, "a", function() {
                return a;
            });
            var n = r(14), i = r.n(n), o = r(51);
            function a(t, e, r, n, a) {
                return i.a.resolve(Object(o.a)(t, e, {
                    stats: [
                        r
                    ]
                }, n, a)).then(function(t) {
                    return t.map(function(t) {
                        return t[r];
                    });
                });
            }
        },
        function(t, e, r) {
            "use strict";
            const n = r(21), i = r(3), o = r(38), a = r(58);
            function s(t, e, r) {
                t = i(t), e = i(e);
                const s = "-" !== t[0], u = "-" !== e[0], l = o(t), c = o(e);
                if (l || c) return s == u ? "Infinity" : "-Infinity";
                if ("0" === e) throw new Error("[preciso] division by zero");
                if ("" === t || "0" === t) return "0";
                const f = s !== u ? "-" : "";
                return s || (t = n(t)), u || (e = n(e)), f + a(t, e, r);
            }
            t.exports = s, t.exports.default = s;
        },
        function(t, e, r) {
            "use strict";
            r.d(e, "a", function() {
                return i;
            });
            var n = r(52);
            function i(t) {
                return function(e) {
                    for(var r = arguments.length, i = new Array(r > 1 ? r - 1 : 0), o = 1; o < r; o++)i[o - 1] = arguments[o];
                    return "string" == typeof e ? Object(n.a)(e).then(function(e) {
                        return t.apply(void 0, [
                            e
                        ].concat(i));
                    }) : t.apply(void 0, [
                        e
                    ].concat(i));
                };
            }
        },
        function(t, e, r) {
            var n;
            class i {
                static isPromise(t) {
                    return "object" == typeof t && "function" == typeof t.then;
                }
                static all(t) {
                    return t.some(i.isPromise) ? Promise.all(t) : {
                        then: (e)=>e(t)
                    };
                }
                static resolve(t) {
                    return "object" == typeof t && "function" == typeof t.then ? t : {
                        then: (e)=>e(t)
                    };
                }
            }
            void 0 === (n = (function() {
                return i;
            }).call(e, r, e, t)) || (t.exports = n), t.exports = i, t.exports.default = i, "object" == typeof self && (self.QuickPromise = i), "object" == typeof window && (window.QuickPromise = i);
        },
        function(t, e, r) {
            "use strict";
            const n = r(246);
            t.exports = function(t) {
                return "+" === t[0] && (t = t.substring(1)), (t = (t = n(t)).replace(/^0+(?=\d)/, "")).includes(".") && (t = t.replace(/\.?0+$/, "")), "" === t && (t = "0"), "-0" === t && (t = "0"), t;
            };
        },
        function(t, e, r) {
            "use strict";
            r.d(e, "a", function() {
                return a;
            });
            var n = r(9), i = r(24), o = r(13), a = Object(o.a)(function(t, e, r) {
                if (!t) throw new Error("[georaster] can't get values without a georaster!");
                var o, a, s, u;
                if (null == e) try {
                    if (!r) return t.values || t.getValues({
                        height: t.height,
                        left: 0,
                        right: t.width,
                        bottom: t.height,
                        top: 0,
                        width: t.width
                    });
                    u = t.height, a = 0, s = t.width, o = 0;
                } catch (t) {
                    throw console.error(t), t;
                }
                else if (n.a.isBbox(e)) try {
                    var l = Object(i.a)(e), c = n.a.convertCrsBboxToImageBbox(t, l);
                    o = Math.max(c.ymin, 0), a = Math.max(c.xmin, 0), s = Math.min(c.xmax, t.width), u = Math.min(c.ymax, t.height);
                } catch (t) {
                    throw console.error(t), t;
                }
                else {
                    if (![
                        "bottom",
                        "left",
                        "right",
                        "top"
                    ].every(function(t) {
                        return t in e;
                    })) throw console.error(e), "Geometry is not a bounding box - please make sure to send a bounding box when using geoblaze.get";
                    u = e.bottom, a = e.left, s = e.right, o = e.top;
                }
                try {
                    return r ? t.values ? t.values.map(function(t) {
                        for(var e = [], r = o; r < u; r++)e = e.concat(Array.prototype.slice.call(t[r].slice(a, s)));
                        return e;
                    }) : t.getValues({
                        height: u - o,
                        width: s - a,
                        left: a,
                        top: o,
                        right: s,
                        bottom: u
                    }).then(function(t) {
                        return t.map(function(t) {
                            return t.reduce(function(t, e) {
                                return t.concat(Array.from(e));
                            }, []);
                        });
                    }) : t.values ? t.values.map(function(t) {
                        for(var e = [], r = o; r < u; r++)e.push(t[r].slice(a, s));
                        return e;
                    }) : t.getValues({
                        height: u - o,
                        width: s - a,
                        left: a,
                        top: o,
                        right: s,
                        bottom: u
                    });
                } catch (t) {
                    throw console.error("[geoblaze] error in get.module.js"), t;
                }
            });
        },
        function(t, e) {
            function r(t, e, r, n, i, o, a) {
                try {
                    var s = t[o](a), u = s.value;
                } catch (t) {
                    return void r(t);
                }
                s.done ? e(u) : Promise.resolve(u).then(n, i);
            }
            t.exports = function(t) {
                return function() {
                    var e = this, n = arguments;
                    return new Promise(function(i, o) {
                        var a = t.apply(e, n);
                        function s(t) {
                            r(a, i, o, s, u, "next", t);
                        }
                        function u(t) {
                            r(a, i, o, s, u, "throw", t);
                        }
                        s(void 0);
                    });
                };
            }, t.exports.__esModule = !0, t.exports.default = t.exports;
        },
        function(t, e) {
            t.exports = function() {
                throw new Error("define cannot be used indirect");
            };
        },
        function(t, e, r) {
            "use strict";
            const n = r(20), i = r(3), o = r(26), a = r(57), s = r(38);
            function u(t, e, { infinity_minus_infinity: r = "NaN" } = {}) {
                t = i(t), e = i(e);
                const u = "-" !== t[0], l = "-" !== e[0], c = !u, f = !l, h = s(t), p = s(e);
                if (h && p) return u && l ? "Infinity" : c & f ? "-Infinity" : r;
                if (h) return u ? "Infinity" : "-Infinity";
                if (p) return l ? "Infinity" : "-Infinity";
                if (u && l) return o(t, e);
                if (c && f) return "-" + o(t.substring(1), e.substring(1));
                if (c && l) switch(t = t.substring(1), n(t, e)){
                    case "=":
                        return "0";
                    case "<":
                        return a(e, t);
                    case ">":
                        return "-" + a(t, e);
                }
                else if (u && !l) switch(e = e.substring(1), n(t, e)){
                    case "=":
                        return "0";
                    case "<":
                        return "-" + a(e, t);
                    case ">":
                        return a(t, e);
                }
            }
            t.exports = u, t.exports.default = u;
        },
        function(t, e, r) {
            "use strict";
            function n(t, e) {
                const r = t.length, n = e.length, i = t.indexOf("."), o = e.indexOf("."), a = -1 === i ? r : i, s = -1 === o ? n : o, u = a - s;
                let l = u < 0 ? -1 * u : 0, c = u <= 0 ? 0 : u, f = Math.max(a, s) + 1 + Math.max(r - a, n - s) - 1, h = 0;
                for(; h < f;){
                    const r = h - l, n = r === a ? "." : t[r] || "0", i = h - c, o = i === s ? "." : e[i] || "0";
                    if (n !== o) {
                        if (n > o) return ">";
                        if (n < o) return "<";
                    }
                    h++;
                }
                return "=";
            }
            t.exports = n, t.exports.default = n;
        },
        function(t, e, r) {
            "use strict";
            const n = r(3);
            function i(t) {
                return "-" === (t = n(t))[0] ? t.substring(1) : t;
            }
            t.exports = i, t.exports.default = i;
        },
        function(t, e, r) {
            var n = r(181), i = r(182), o = r(110), a = r(183);
            t.exports = function(t) {
                return n(t) || i(t) || o(t) || a();
            }, t.exports.__esModule = !0, t.exports.default = t.exports;
        },
        function(t, e, r) {
            "use strict";
            var n = {};
            e.a = n;
        },
        function(t, e, r) {
            "use strict";
            r.d(e, "a", function() {
                return m;
            }), r.d(e, "b", function() {
                return y;
            }), r.d(e, "c", function() {
                return d;
            });
            var n = r(8), i = r.n(n), o = r(7), a = r.n(o), s = r(166), u = r.n(s), l = r(54), c = r.n(l), f = r(44), h = r.n(f), p = r(9);
            function d(t) {
                var e;
                if ("string" == typeof t && (t = JSON.parse(t)), Array.isArray(t) && 2 === t.length && "number" == typeof t[0] && "number" == typeof t[1] ? e = t : "object" === a()(t) && /Point/i.test(t.type) && (e = t.coordinates), !e) throw "Invalid point object was used. Please use either a [lng, lat] array or GeoJSON point.";
                return e;
            }
            function m(t) {
                var e;
                if ("string" == typeof t && (t = JSON.parse(t)), p.a.isBbox(t)) {
                    if (void 0 !== t.xmin && void 0 !== t.ymax) e = t;
                    else if (h()(t)) {
                        var r = t, n = i()(r, 4);
                        e = {
                            xmin: n[0],
                            ymin: n[1],
                            xmax: n[2],
                            ymax: n[3]
                        };
                    } else if ("object" === a()(t)) {
                        var o = u()(t), s = i()(o, 4);
                        e = {
                            xmin: s[0],
                            ymin: s[1],
                            xmax: s[2],
                            ymax: s[3]
                        };
                    }
                }
                if (!e) throw "Invalid bounding box object was used. Please use either a [xmin, ymin, xmax, ymax] array or GeoJSON polygon.";
                return e;
            }
            function y(t) {
                var e = c.a.get(t);
                if (0 === e.length) throw new Error("Invalild polygonal object was used.  Please use a GeoJSON polygon.");
                return e;
            }
        },
        function(t, e, r) {
            /**
 * @license Fraction.js v4.3.0 20/08/2023
 * https://www.xarg.org/2014/03/rational-numbers-in-javascript/
 *
 * Copyright (c) 2023, Robert Eisele (robert@raw.org)
 * Dual licensed under the MIT or GPL Version 2 licenses.
 **/ !function(e) {
                "use strict";
                var r = {
                    s: 1,
                    n: 0,
                    d: 1
                };
                function n(t, e) {
                    if (isNaN(t = parseInt(t, 10))) throw c();
                    return t * e;
                }
                function i(t, e) {
                    if (0 === e) throw l();
                    var r = Object.create(u.prototype);
                    r.s = t < 0 ? -1 : 1;
                    var n = s(t = t < 0 ? -t : t, e);
                    return r.n = t / n, r.d = e / n, r;
                }
                function o(t) {
                    for(var e = {}, r = t, n = 2, i = 4; i <= r;){
                        for(; r % n == 0;)r /= n, e[n] = (e[n] || 0) + 1;
                        i += 1 + 2 * n++;
                    }
                    return r !== t ? r > 1 && (e[r] = (e[r] || 0) + 1) : e[t] = (e[t] || 0) + 1, e;
                }
                var a = function(t, e) {
                    var i, o = 0, a = 1, s = 1, u = 0, h = 0, p = 0, d = 1, m = 1, y = 0, g = 1, v = 1, b = 1, x = 1e7;
                    if (null == t) ;
                    else if (void 0 !== e) {
                        if (s = (o = t) * (a = e), o % 1 != 0 || a % 1 != 0) throw f();
                    } else switch(typeof t){
                        case "object":
                            if ("d" in t && "n" in t) o = t.n, a = t.d, "s" in t && (o *= t.s);
                            else {
                                if (!(0 in t)) throw c();
                                o = t[0], 1 in t && (a = t[1]);
                            }
                            s = o * a;
                            break;
                        case "number":
                            if (t < 0 && (s = t, t = -t), t % 1 == 0) o = t;
                            else if (t > 0) {
                                for(t >= 1 && (t /= m = Math.pow(10, Math.floor(1 + Math.log(t) / Math.LN10))); g <= x && b <= x;){
                                    if (t === (i = (y + v) / (g + b))) {
                                        g + b <= x ? (o = y + v, a = g + b) : b > g ? (o = v, a = b) : (o = y, a = g);
                                        break;
                                    }
                                    t > i ? (y += v, g += b) : (v += y, b += g), g > x ? (o = v, a = b) : (o = y, a = g);
                                }
                                o *= m;
                            } else (isNaN(t) || isNaN(e)) && (a = o = NaN);
                            break;
                        case "string":
                            if (null === (g = t.match(/\d+|./g))) throw c();
                            if ("-" === g[y] ? (s = -1, y++) : "+" === g[y] && y++, g.length === y + 1 ? h = n(g[y++], s) : "." === g[y + 1] || "." === g[y] ? ("." !== g[y] && (u = n(g[y++], s)), (++y + 1 === g.length || "(" === g[y + 1] && ")" === g[y + 3] || "'" === g[y + 1] && "'" === g[y + 3]) && (h = n(g[y], s), d = Math.pow(10, g[y].length), y++), ("(" === g[y] && ")" === g[y + 2] || "'" === g[y] && "'" === g[y + 2]) && (p = n(g[y + 1], s), m = Math.pow(10, g[y + 1].length) - 1, y += 3)) : "/" === g[y + 1] || ":" === g[y + 1] ? (h = n(g[y], s), d = n(g[y + 2], 1), y += 3) : "/" === g[y + 3] && " " === g[y + 1] && (u = n(g[y], s), h = n(g[y + 2], s), d = n(g[y + 4], 1), y += 5), g.length <= y) {
                                s = o = p + (a = d * m) * u + m * h;
                                break;
                            }
                        default:
                            throw c();
                    }
                    if (0 === a) throw l();
                    r.s = s < 0 ? -1 : 1, r.n = Math.abs(o), r.d = Math.abs(a);
                };
                function s(t, e) {
                    if (!t) return e;
                    if (!e) return t;
                    for(;;){
                        if (!(t %= e)) return e;
                        if (!(e %= t)) return t;
                    }
                }
                function u(t, e) {
                    if (a(t, e), !(this instanceof u)) return i(r.s * r.n, r.d);
                    t = s(r.d, r.n), this.s = r.s, this.n = r.n / t, this.d = r.d / t;
                }
                var l = function() {
                    return new Error("Division by Zero");
                }, c = function() {
                    return new Error("Invalid argument");
                }, f = function() {
                    return new Error("Parameters must be integer");
                };
                u.prototype = {
                    s: 1,
                    n: 0,
                    d: 1,
                    abs: function() {
                        return i(this.n, this.d);
                    },
                    neg: function() {
                        return i(-this.s * this.n, this.d);
                    },
                    add: function(t, e) {
                        return a(t, e), i(this.s * this.n * r.d + r.s * this.d * r.n, this.d * r.d);
                    },
                    sub: function(t, e) {
                        return a(t, e), i(this.s * this.n * r.d - r.s * this.d * r.n, this.d * r.d);
                    },
                    mul: function(t, e) {
                        return a(t, e), i(this.s * r.s * this.n * r.n, this.d * r.d);
                    },
                    div: function(t, e) {
                        return a(t, e), i(this.s * r.s * this.n * r.d, this.d * r.n);
                    },
                    clone: function() {
                        return i(this.s * this.n, this.d);
                    },
                    mod: function(t, e) {
                        if (isNaN(this.n) || isNaN(this.d)) return new u(NaN);
                        if (void 0 === t) return i(this.s * this.n % this.d, 1);
                        if (a(t, e), 0 === r.n && 0 === this.d) throw l();
                        return i(this.s * (r.d * this.n) % (r.n * this.d), r.d * this.d);
                    },
                    gcd: function(t, e) {
                        return a(t, e), i(s(r.n, this.n) * s(r.d, this.d), r.d * this.d);
                    },
                    lcm: function(t, e) {
                        return a(t, e), 0 === r.n && 0 === this.n ? i(0, 1) : i(r.n * this.n, s(r.n, this.n) * s(r.d, this.d));
                    },
                    ceil: function(t) {
                        return t = Math.pow(10, t || 0), isNaN(this.n) || isNaN(this.d) ? new u(NaN) : i(Math.ceil(t * this.s * this.n / this.d), t);
                    },
                    floor: function(t) {
                        return t = Math.pow(10, t || 0), isNaN(this.n) || isNaN(this.d) ? new u(NaN) : i(Math.floor(t * this.s * this.n / this.d), t);
                    },
                    round: function(t) {
                        return t = Math.pow(10, t || 0), isNaN(this.n) || isNaN(this.d) ? new u(NaN) : i(Math.round(t * this.s * this.n / this.d), t);
                    },
                    inverse: function() {
                        return i(this.s * this.d, this.n);
                    },
                    pow: function(t, e) {
                        if (a(t, e), 1 === r.d) return r.s < 0 ? i(Math.pow(this.s * this.d, r.n), Math.pow(this.n, r.n)) : i(Math.pow(this.s * this.n, r.n), Math.pow(this.d, r.n));
                        if (this.s < 0) return null;
                        var n = o(this.n), s = o(this.d), u = 1, l = 1;
                        for(var c in n)if ("1" !== c) {
                            if ("0" === c) {
                                u = 0;
                                break;
                            }
                            if (n[c] *= r.n, n[c] % r.d != 0) return null;
                            n[c] /= r.d, u *= Math.pow(c, n[c]);
                        }
                        for(var c in s)if ("1" !== c) {
                            if (s[c] *= r.n, s[c] % r.d != 0) return null;
                            s[c] /= r.d, l *= Math.pow(c, s[c]);
                        }
                        return r.s < 0 ? i(l, u) : i(u, l);
                    },
                    equals: function(t, e) {
                        return a(t, e), this.s * this.n * r.d == r.s * r.n * this.d;
                    },
                    compare: function(t, e) {
                        a(t, e);
                        var n = this.s * this.n * r.d - r.s * r.n * this.d;
                        return (0 < n) - (n < 0);
                    },
                    simplify: function(t) {
                        if (isNaN(this.n) || isNaN(this.d)) return this;
                        t = t || .001;
                        for(var e = this.abs(), r = e.toContinued(), n = 1; n < r.length; n++){
                            for(var o = i(r[n - 1], 1), a = n - 2; a >= 0; a--)o = o.inverse().add(r[a]);
                            if (Math.abs(o.sub(e).valueOf()) < t) return o.mul(this.s);
                        }
                        return this;
                    },
                    divisible: function(t, e) {
                        return a(t, e), !(!(r.n * this.d) || this.n * r.d % (r.n * this.d));
                    },
                    valueOf: function() {
                        return this.s * this.n / this.d;
                    },
                    toFraction: function(t) {
                        var e, r = "", n = this.n, i = this.d;
                        return this.s < 0 && (r += "-"), 1 === i ? r += n : (t && (e = Math.floor(n / i)) > 0 && (r += e, r += " ", n %= i), r += n, r += "/", r += i), r;
                    },
                    toLatex: function(t) {
                        var e, r = "", n = this.n, i = this.d;
                        return this.s < 0 && (r += "-"), 1 === i ? r += n : (t && (e = Math.floor(n / i)) > 0 && (r += e, n %= i), r += "\\frac{", r += n, r += "}{", r += i, r += "}"), r;
                    },
                    toContinued: function() {
                        var t, e = this.n, r = this.d, n = [];
                        if (isNaN(e) || isNaN(r)) return n;
                        do n.push(Math.floor(e / r)), t = e % r, e = r, r = t;
                        while (1 !== e);
                        return n;
                    },
                    toString: function(t) {
                        var e = this.n, r = this.d;
                        if (isNaN(e) || isNaN(r)) return "NaN";
                        t = t || 15;
                        var n = function(t, e) {
                            for(; e % 2 == 0; e /= 2);
                            for(; e % 5 == 0; e /= 5);
                            if (1 === e) return 0;
                            for(var r = 10 % e, n = 1; 1 !== r; n++)if (r = 10 * r % e, n > 2e3) return 0;
                            return n;
                        }(0, r), i = function(t, e, r) {
                            for(var n = 1, i = function(t, e, r) {
                                for(var n = 1; e > 0; t = t * t % r, e >>= 1)1 & e && (n = n * t % r);
                                return n;
                            }(10, r, e), o = 0; o < 300; o++){
                                if (n === i) return o;
                                n = 10 * n % e, i = 10 * i % e;
                            }
                            return 0;
                        }(0, r, n), o = this.s < 0 ? "-" : "";
                        if (o += e / r | 0, e %= r, (e *= 10) && (o += "."), n) {
                            for(var a = i; a--;)o += e / r | 0, e %= r, e *= 10;
                            o += "(";
                            for(a = n; a--;)o += e / r | 0, e %= r, e *= 10;
                            o += ")";
                        } else for(a = t; e && a--;)o += e / r | 0, e %= r, e *= 10;
                        return o;
                    }
                }, Object.defineProperty(u, "__esModule", {
                    value: !0
                }), u.default = u, u.Fraction = u, t.exports = u;
            }();
        },
        function(t, e, r) {
            "use strict";
            const { MAX_SAFE_INTEGER_LENGTH: n } = r(56);
            function i(t, e) {
                const r = t.length, i = e.length, o = t.indexOf("."), a = e.indexOf("."), s = -1 === o ? r : o, u = -1 === a ? i : a;
                if (-1 === o && -1 === a && r < n && i < n) return (Number(t) + Number(e)).toFixed();
                const l = s - u;
                let c = Math.max(s, u), f = Math.max(r - s - 1, i - u - 1), h = l < 0 ? -1 * l : 0, p = l <= 0 ? 0 : l, d = c + 1 + f - 1, m = "", y = 0, g = d;
                if (f > 0) {
                    for(; g > d - f;){
                        const r = t[g - h] || "0", n = e[g - p] || "0";
                        let i = Number(r) + Number(n) + y;
                        i >= 10 ? (i -= 10, y = 1) : y = 0, "" === m && 0 === i || (m = i + m), g--;
                    }
                    m && (m = "." + m), g--;
                }
                if (c > 0) for(; g >= 0;){
                    const r = t[g - h] || "0", n = e[g - p] || "0";
                    let i = Number(r) + Number(n) + y;
                    i >= 10 ? (i -= 10, y = 1) : y = 0, m = i + m, g--;
                }
                return 1 === y && (m = y + m), "." === m[0] && (m = "0" + m), m;
            }
            t.exports = i, t.exports.default = i;
        },
        function(t, e, r) {
            "use strict";
            r.d(e, "a", function() {
                return wr;
            });
            var n = {};
            r.r(n), r.d(n, "VERSION", function() {
                return i.e;
            }), r.d(n, "restArguments", function() {
                return o;
            }), r.d(n, "isObject", function() {
                return a;
            }), r.d(n, "isNull", function() {
                return s;
            }), r.d(n, "isUndefined", function() {
                return u;
            }), r.d(n, "isBoolean", function() {
                return l;
            }), r.d(n, "isElement", function() {
                return c;
            }), r.d(n, "isString", function() {
                return h;
            }), r.d(n, "isNumber", function() {
                return p;
            }), r.d(n, "isDate", function() {
                return d;
            }), r.d(n, "isRegExp", function() {
                return m;
            }), r.d(n, "isError", function() {
                return y;
            }), r.d(n, "isSymbol", function() {
                return g;
            }), r.d(n, "isArrayBuffer", function() {
                return v;
            }), r.d(n, "isDataView", function() {
                return M;
            }), r.d(n, "isArray", function() {
                return k;
            }), r.d(n, "isFunction", function() {
                return w;
            }), r.d(n, "isArguments", function() {
                return D;
            }), r.d(n, "isFinite", function() {
                return O;
            }), r.d(n, "isNaN", function() {
                return T;
            }), r.d(n, "isTypedArray", function() {
                return L;
            }), r.d(n, "isEmpty", function() {
                return G;
            }), r.d(n, "isMatch", function() {
                return H;
            }), r.d(n, "isEqual", function() {
                return Z;
            }), r.d(n, "isMap", function() {
                return nt;
            }), r.d(n, "isWeakMap", function() {
                return it;
            }), r.d(n, "isSet", function() {
                return ot;
            }), r.d(n, "isWeakSet", function() {
                return at;
            }), r.d(n, "keys", function() {
                return z;
            }), r.d(n, "allKeys", function() {
                return Y;
            }), r.d(n, "values", function() {
                return st;
            }), r.d(n, "pairs", function() {
                return ut;
            }), r.d(n, "invert", function() {
                return lt;
            }), r.d(n, "functions", function() {
                return ct;
            }), r.d(n, "methods", function() {
                return ct;
            }), r.d(n, "extend", function() {
                return ht;
            }), r.d(n, "extendOwn", function() {
                return pt;
            }), r.d(n, "assign", function() {
                return pt;
            }), r.d(n, "defaults", function() {
                return dt;
            }), r.d(n, "create", function() {
                return yt;
            }), r.d(n, "clone", function() {
                return gt;
            }), r.d(n, "tap", function() {
                return vt;
            }), r.d(n, "get", function() {
                return _t;
            }), r.d(n, "has", function() {
                return At;
            }), r.d(n, "mapObject", function() {
                return Ot;
            }), r.d(n, "identity", function() {
                return Et;
            }), r.d(n, "constant", function() {
                return F;
            }), r.d(n, "noop", function() {
                return Tt;
            }), r.d(n, "toPath", function() {
                return bt;
            }), r.d(n, "property", function() {
                return Mt;
            }), r.d(n, "propertyOf", function() {
                return Ft;
            }), r.d(n, "matcher", function() {
                return St;
            }), r.d(n, "matches", function() {
                return St;
            }), r.d(n, "times", function() {
                return Pt;
            }), r.d(n, "random", function() {
                return It;
            }), r.d(n, "now", function() {
                return Bt;
            }), r.d(n, "escape", function() {
                return Lt;
            }), r.d(n, "unescape", function() {
                return qt;
            }), r.d(n, "templateSettings", function() {
                return Ut;
            }), r.d(n, "template", function() {
                return Vt;
            }), r.d(n, "result", function() {
                return Zt;
            }), r.d(n, "uniqueId", function() {
                return Kt;
            }), r.d(n, "chain", function() {
                return Xt;
            }), r.d(n, "iteratee", function() {
                return Ct;
            }), r.d(n, "partial", function() {
                return te;
            }), r.d(n, "bind", function() {
                return ee;
            }), r.d(n, "bindAll", function() {
                return ie;
            }), r.d(n, "memoize", function() {
                return oe;
            }), r.d(n, "delay", function() {
                return ae;
            }), r.d(n, "defer", function() {
                return se;
            }), r.d(n, "throttle", function() {
                return ue;
            }), r.d(n, "debounce", function() {
                return le;
            }), r.d(n, "wrap", function() {
                return ce;
            }), r.d(n, "negate", function() {
                return fe;
            }), r.d(n, "compose", function() {
                return he;
            }), r.d(n, "after", function() {
                return pe;
            }), r.d(n, "before", function() {
                return de;
            }), r.d(n, "once", function() {
                return me;
            }), r.d(n, "findKey", function() {
                return ye;
            }), r.d(n, "findIndex", function() {
                return ve;
            }), r.d(n, "findLastIndex", function() {
                return be;
            }), r.d(n, "sortedIndex", function() {
                return xe;
            }), r.d(n, "indexOf", function() {
                return _e;
            }), r.d(n, "lastIndexOf", function() {
                return Ae;
            }), r.d(n, "find", function() {
                return Ee;
            }), r.d(n, "detect", function() {
                return Ee;
            }), r.d(n, "findWhere", function() {
                return Se;
            }), r.d(n, "each", function() {
                return Me;
            }), r.d(n, "forEach", function() {
                return Me;
            }), r.d(n, "map", function() {
                return ke;
            }), r.d(n, "collect", function() {
                return ke;
            }), r.d(n, "reduce", function() {
                return Ce;
            }), r.d(n, "foldl", function() {
                return Ce;
            }), r.d(n, "inject", function() {
                return Ce;
            }), r.d(n, "reduceRight", function() {
                return De;
            }), r.d(n, "foldr", function() {
                return De;
            }), r.d(n, "filter", function() {
                return Oe;
            }), r.d(n, "select", function() {
                return Oe;
            }), r.d(n, "reject", function() {
                return Te;
            }), r.d(n, "every", function() {
                return Fe;
            }), r.d(n, "all", function() {
                return Fe;
            }), r.d(n, "some", function() {
                return Pe;
            }), r.d(n, "any", function() {
                return Pe;
            }), r.d(n, "contains", function() {
                return Ie;
            }), r.d(n, "includes", function() {
                return Ie;
            }), r.d(n, "include", function() {
                return Ie;
            }), r.d(n, "invoke", function() {
                return Be;
            }), r.d(n, "pluck", function() {
                return je;
            }), r.d(n, "where", function() {
                return Re;
            }), r.d(n, "max", function() {
                return Le;
            }), r.d(n, "min", function() {
                return qe;
            }), r.d(n, "shuffle", function() {
                return He;
            }), r.d(n, "sample", function() {
                return Ge;
            }), r.d(n, "sortBy", function() {
                return We;
            }), r.d(n, "groupBy", function() {
                return Ve;
            }), r.d(n, "indexBy", function() {
                return Ze;
            }), r.d(n, "countBy", function() {
                return Ye;
            }), r.d(n, "partition", function() {
                return Ke;
            }), r.d(n, "toArray", function() {
                return ze;
            }), r.d(n, "size", function() {
                return Xe;
            }), r.d(n, "pick", function() {
                return Qe;
            }), r.d(n, "omit", function() {
                return tr;
            }), r.d(n, "first", function() {
                return rr;
            }), r.d(n, "head", function() {
                return rr;
            }), r.d(n, "take", function() {
                return rr;
            }), r.d(n, "initial", function() {
                return er;
            }), r.d(n, "last", function() {
                return ir;
            }), r.d(n, "rest", function() {
                return nr;
            }), r.d(n, "tail", function() {
                return nr;
            }), r.d(n, "drop", function() {
                return nr;
            }), r.d(n, "compact", function() {
                return or;
            }), r.d(n, "flatten", function() {
                return ar;
            }), r.d(n, "without", function() {
                return ur;
            }), r.d(n, "uniq", function() {
                return lr;
            }), r.d(n, "unique", function() {
                return lr;
            }), r.d(n, "union", function() {
                return cr;
            }), r.d(n, "intersection", function() {
                return fr;
            }), r.d(n, "difference", function() {
                return sr;
            }), r.d(n, "unzip", function() {
                return hr;
            }), r.d(n, "transpose", function() {
                return hr;
            }), r.d(n, "zip", function() {
                return pr;
            }), r.d(n, "object", function() {
                return dr;
            }), r.d(n, "range", function() {
                return mr;
            }), r.d(n, "chunk", function() {
                return yr;
            }), r.d(n, "mixin", function() {
                return vr;
            }), r.d(n, "default", function() {
                return br;
            });
            var i = r(0);
            function o(t, e) {
                return e = null == e ? t.length - 1 : +e, function() {
                    for(var r = Math.max(arguments.length - e, 0), n = Array(r), i = 0; i < r; i++)n[i] = arguments[i + e];
                    switch(e){
                        case 0:
                            return t.call(this, n);
                        case 1:
                            return t.call(this, arguments[0], n);
                        case 2:
                            return t.call(this, arguments[0], arguments[1], n);
                    }
                    var o = Array(e + 1);
                    for(i = 0; i < e; i++)o[i] = arguments[i];
                    return o[e] = n, t.apply(this, o);
                };
            }
            function a(t) {
                var e = typeof t;
                return "function" === e || "object" === e && !!t;
            }
            function s(t) {
                return null === t;
            }
            function u(t) {
                return void 0 === t;
            }
            function l(t) {
                return !0 === t || !1 === t || "[object Boolean]" === i.t.call(t);
            }
            function c(t) {
                return !(!t || 1 !== t.nodeType);
            }
            function f(t) {
                var e = "[object " + t + "]";
                return function(t) {
                    return i.t.call(t) === e;
                };
            }
            var h = f("String"), p = f("Number"), d = f("Date"), m = f("RegExp"), y = f("Error"), g = f("Symbol"), v = f("ArrayBuffer"), b = f("Function"), x = i.p.document && i.p.document.childNodes;
            "object" != typeof Int8Array && "function" != typeof x && (b = function(t) {
                return "function" == typeof t || !1;
            });
            var w = b, _ = f("Object"), A = i.s && _(new DataView(new ArrayBuffer(8))), E = "undefined" != typeof Map && _(new Map), S = f("DataView");
            var M = A ? function(t) {
                return null != t && w(t.getInt8) && v(t.buffer);
            } : S, k = i.k || f("Array");
            function N(t, e) {
                return null != t && i.i.call(t, e);
            }
            var C = f("Arguments");
            !function() {
                C(arguments) || (C = function(t) {
                    return N(t, "callee");
                });
            }();
            var D = C;
            function O(t) {
                return !g(t) && Object(i.f)(t) && !isNaN(parseFloat(t));
            }
            function T(t) {
                return p(t) && Object(i.g)(t);
            }
            function F(t) {
                return function() {
                    return t;
                };
            }
            function P(t) {
                return function(e) {
                    var r = t(e);
                    return "number" == typeof r && r >= 0 && r <= i.b;
                };
            }
            function I(t) {
                return function(e) {
                    return null == e ? void 0 : e[t];
                };
            }
            var B = I("byteLength"), j = P(B), R = /\[object ((I|Ui)nt(8|16|32)|Float(32|64)|Uint8Clamped|Big(I|Ui)nt64)Array\]/;
            var L = i.r ? function(t) {
                return i.l ? Object(i.l)(t) && !M(t) : j(t) && R.test(i.t.call(t));
            } : F(!1), q = I("length");
            function U(t, e) {
                e = function(t) {
                    for(var e = {}, r = t.length, n = 0; n < r; ++n)e[t[n]] = !0;
                    return {
                        contains: function(t) {
                            return !0 === e[t];
                        },
                        push: function(r) {
                            return e[r] = !0, t.push(r);
                        }
                    };
                }(e);
                var r = i.n.length, n = t.constructor, o = w(n) && n.prototype || i.c, a = "constructor";
                for(N(t, a) && !e.contains(a) && e.push(a); r--;)(a = i.n[r]) in t && t[a] !== o[a] && !e.contains(a) && e.push(a);
            }
            function z(t) {
                if (!a(t)) return [];
                if (i.m) return Object(i.m)(t);
                var e = [];
                for(var r in t)N(t, r) && e.push(r);
                return i.h && U(t, e), e;
            }
            function G(t) {
                if (null == t) return !0;
                var e = q(t);
                return "number" == typeof e && (k(t) || h(t) || D(t)) ? 0 === e : 0 === q(z(t));
            }
            function H(t, e) {
                var r = z(e), n = r.length;
                if (null == t) return !n;
                for(var i = Object(t), o = 0; o < n; o++){
                    var a = r[o];
                    if (e[a] !== i[a] || !(a in i)) return !1;
                }
                return !0;
            }
            function W(t) {
                return t instanceof W ? t : this instanceof W ? void (this._wrapped = t) : new W(t);
            }
            function $(t) {
                return new Uint8Array(t.buffer || t, t.byteOffset || 0, B(t));
            }
            W.VERSION = i.e, W.prototype.value = function() {
                return this._wrapped;
            }, W.prototype.valueOf = W.prototype.toJSON = W.prototype.value, W.prototype.toString = function() {
                return String(this._wrapped);
            };
            function V(t, e, r, n) {
                if (t === e) return 0 !== t || 1 / t == 1 / e;
                if (null == t || null == e) return !1;
                if (t != t) return e != e;
                var o = typeof t;
                return ("function" === o || "object" === o || "object" == typeof e) && function t(e, r, n, o) {
                    e instanceof W && (e = e._wrapped);
                    r instanceof W && (r = r._wrapped);
                    var a = i.t.call(e);
                    if (a !== i.t.call(r)) return !1;
                    if (A && "[object Object]" == a && M(e)) {
                        if (!M(r)) return !1;
                        a = "[object DataView]";
                    }
                    switch(a){
                        case "[object RegExp]":
                        case "[object String]":
                            return "" + e == "" + r;
                        case "[object Number]":
                            return +e != +e ? +r != +r : 0 == +e ? 1 / +e == 1 / r : +e == +r;
                        case "[object Date]":
                        case "[object Boolean]":
                            return +e == +r;
                        case "[object Symbol]":
                            return i.d.valueOf.call(e) === i.d.valueOf.call(r);
                        case "[object ArrayBuffer]":
                        case "[object DataView]":
                            return t($(e), $(r), n, o);
                    }
                    var s = "[object Array]" === a;
                    if (!s && L(e)) {
                        if (B(e) !== B(r)) return !1;
                        if (e.buffer === r.buffer && e.byteOffset === r.byteOffset) return !0;
                        s = !0;
                    }
                    if (!s) {
                        if ("object" != typeof e || "object" != typeof r) return !1;
                        var u = e.constructor, l = r.constructor;
                        if (u !== l && !(w(u) && u instanceof u && w(l) && l instanceof l) && "constructor" in e && "constructor" in r) return !1;
                    }
                    o = o || [];
                    var c = (n = n || []).length;
                    for(; c--;)if (n[c] === e) return o[c] === r;
                    if (n.push(e), o.push(r), s) {
                        if ((c = e.length) !== r.length) return !1;
                        for(; c--;)if (!V(e[c], r[c], n, o)) return !1;
                    } else {
                        var f, h = z(e);
                        if (c = h.length, z(r).length !== c) return !1;
                        for(; c--;)if (f = h[c], !N(r, f) || !V(e[f], r[f], n, o)) return !1;
                    }
                    return n.pop(), o.pop(), !0;
                }(t, e, r, n);
            }
            function Z(t, e) {
                return V(t, e);
            }
            function Y(t) {
                if (!a(t)) return [];
                var e = [];
                for(var r in t)e.push(r);
                return i.h && U(t, e), e;
            }
            function K(t) {
                var e = q(t);
                return function(r) {
                    if (null == r) return !1;
                    var n = Y(r);
                    if (q(n)) return !1;
                    for(var i = 0; i < e; i++)if (!w(r[t[i]])) return !1;
                    return t !== et || !w(r[X]);
                };
            }
            var X = "forEach", J = [
                "clear",
                "delete"
            ], Q = [
                "get",
                "has",
                "set"
            ], tt = J.concat(X, Q), et = J.concat(Q), rt = [
                "add"
            ].concat(J, X, "has"), nt = E ? K(tt) : f("Map"), it = E ? K(et) : f("WeakMap"), ot = E ? K(rt) : f("Set"), at = f("WeakSet");
            function st(t) {
                for(var e = z(t), r = e.length, n = Array(r), i = 0; i < r; i++)n[i] = t[e[i]];
                return n;
            }
            function ut(t) {
                for(var e = z(t), r = e.length, n = Array(r), i = 0; i < r; i++)n[i] = [
                    e[i],
                    t[e[i]]
                ];
                return n;
            }
            function lt(t) {
                for(var e = {}, r = z(t), n = 0, i = r.length; n < i; n++)e[t[r[n]]] = r[n];
                return e;
            }
            function ct(t) {
                var e = [];
                for(var r in t)w(t[r]) && e.push(r);
                return e.sort();
            }
            function ft(t, e) {
                return function(r) {
                    var n = arguments.length;
                    if (e && (r = Object(r)), n < 2 || null == r) return r;
                    for(var i = 1; i < n; i++)for(var o = arguments[i], a = t(o), s = a.length, u = 0; u < s; u++){
                        var l = a[u];
                        e && void 0 !== r[l] || (r[l] = o[l]);
                    }
                    return r;
                };
            }
            var ht = ft(Y), pt = ft(z), dt = ft(Y, !0);
            function mt(t) {
                if (!a(t)) return {};
                if (i.j) return Object(i.j)(t);
                var e = function() {};
                e.prototype = t;
                var r = new e;
                return e.prototype = null, r;
            }
            function yt(t, e) {
                var r = mt(t);
                return e && pt(r, e), r;
            }
            function gt(t) {
                return a(t) ? k(t) ? t.slice() : ht({}, t) : t;
            }
            function vt(t, e) {
                return e(t), t;
            }
            function bt(t) {
                return k(t) ? t : [
                    t
                ];
            }
            function xt(t) {
                return W.toPath(t);
            }
            function wt(t, e) {
                for(var r = e.length, n = 0; n < r; n++){
                    if (null == t) return;
                    t = t[e[n]];
                }
                return r ? t : void 0;
            }
            function _t(t, e, r) {
                var n = wt(t, xt(e));
                return u(n) ? r : n;
            }
            function At(t, e) {
                for(var r = (e = xt(e)).length, n = 0; n < r; n++){
                    var i = e[n];
                    if (!N(t, i)) return !1;
                    t = t[i];
                }
                return !!r;
            }
            function Et(t) {
                return t;
            }
            function St(t) {
                return t = pt({}, t), function(e) {
                    return H(e, t);
                };
            }
            function Mt(t) {
                return t = xt(t), function(e) {
                    return wt(e, t);
                };
            }
            function kt(t, e, r) {
                if (void 0 === e) return t;
                switch(null == r ? 3 : r){
                    case 1:
                        return function(r) {
                            return t.call(e, r);
                        };
                    case 3:
                        return function(r, n, i) {
                            return t.call(e, r, n, i);
                        };
                    case 4:
                        return function(r, n, i, o) {
                            return t.call(e, r, n, i, o);
                        };
                }
                return function() {
                    return t.apply(e, arguments);
                };
            }
            function Nt(t, e, r) {
                return null == t ? Et : w(t) ? kt(t, e, r) : a(t) && !k(t) ? St(t) : Mt(t);
            }
            function Ct(t, e) {
                return Nt(t, e, 1 / 0);
            }
            function Dt(t, e, r) {
                return W.iteratee !== Ct ? W.iteratee(t, e) : Nt(t, e, r);
            }
            function Ot(t, e, r) {
                e = Dt(e, r);
                for(var n = z(t), i = n.length, o = {}, a = 0; a < i; a++){
                    var s = n[a];
                    o[s] = e(t[s], s, t);
                }
                return o;
            }
            function Tt() {}
            function Ft(t) {
                return null == t ? Tt : function(e) {
                    return _t(t, e);
                };
            }
            function Pt(t, e, r) {
                var n = Array(Math.max(0, t));
                e = kt(e, r, 1);
                for(var i = 0; i < t; i++)n[i] = e(i);
                return n;
            }
            function It(t, e) {
                return null == e && (e = t, t = 0), t + Math.floor(Math.random() * (e - t + 1));
            }
            W.toPath = bt, W.iteratee = Ct;
            var Bt = Date.now || function() {
                return (new Date).getTime();
            };
            function jt(t) {
                var e = function(e) {
                    return t[e];
                }, r = "(?:" + z(t).join("|") + ")", n = RegExp(r), i = RegExp(r, "g");
                return function(t) {
                    return t = null == t ? "" : "" + t, n.test(t) ? t.replace(i, e) : t;
                };
            }
            var Rt = {
                "&": "&amp;",
                "<": "&lt;",
                ">": "&gt;",
                '"': "&quot;",
                "'": "&#x27;",
                "`": "&#x60;"
            }, Lt = jt(Rt), qt = jt(lt(Rt)), Ut = W.templateSettings = {
                evaluate: /<%([\s\S]+?)%>/g,
                interpolate: /<%=([\s\S]+?)%>/g,
                escape: /<%-([\s\S]+?)%>/g
            }, zt = /(.)^/, Gt = {
                "'": "'",
                "\\": "\\",
                "\r": "r",
                "\n": "n",
                "\u2028": "u2028",
                "\u2029": "u2029"
            }, Ht = /\\|'|\r|\n|\u2028|\u2029/g;
            function Wt(t) {
                return "\\" + Gt[t];
            }
            var $t = /^\s*(\w|\$)+\s*$/;
            function Vt(t, e, r) {
                !e && r && (e = r), e = dt({}, e, W.templateSettings);
                var n = RegExp([
                    (e.escape || zt).source,
                    (e.interpolate || zt).source,
                    (e.evaluate || zt).source
                ].join("|") + "|$", "g"), i = 0, o = "__p+='";
                t.replace(n, function(e, r, n, a, s) {
                    return o += t.slice(i, s).replace(Ht, Wt), i = s + e.length, r ? o += "'+\n((__t=(" + r + "))==null?'':_.escape(__t))+\n'" : n ? o += "'+\n((__t=(" + n + "))==null?'':__t)+\n'" : a && (o += "';\n" + a + "\n__p+='"), e;
                }), o += "';\n";
                var a, s = e.variable;
                if (s) {
                    if (!$t.test(s)) throw new Error("variable is not a bare identifier: " + s);
                } else o = "with(obj||{}){\n" + o + "}\n", s = "obj";
                o = "var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};\n" + o + "return __p;\n";
                try {
                    a = new Function(s, "_", o);
                } catch (t) {
                    throw t.source = o, t;
                }
                var u = function(t) {
                    return a.call(this, t, W);
                };
                return u.source = "function(" + s + "){\n" + o + "}", u;
            }
            function Zt(t, e, r) {
                var n = (e = xt(e)).length;
                if (!n) return w(r) ? r.call(t) : r;
                for(var i = 0; i < n; i++){
                    var o = null == t ? void 0 : t[e[i]];
                    void 0 === o && (o = r, i = n), t = w(o) ? o.call(t) : o;
                }
                return t;
            }
            var Yt = 0;
            function Kt(t) {
                var e = ++Yt + "";
                return t ? t + e : e;
            }
            function Xt(t) {
                var e = W(t);
                return e._chain = !0, e;
            }
            function Jt(t, e, r, n, i) {
                if (!(n instanceof e)) return t.apply(r, i);
                var o = mt(t.prototype), s = t.apply(o, i);
                return a(s) ? s : o;
            }
            var Qt = o(function(t, e) {
                var r = Qt.placeholder, n = function() {
                    for(var i = 0, o = e.length, a = Array(o), s = 0; s < o; s++)a[s] = e[s] === r ? arguments[i++] : e[s];
                    for(; i < arguments.length;)a.push(arguments[i++]);
                    return Jt(t, n, this, this, a);
                };
                return n;
            });
            Qt.placeholder = W;
            var te = Qt, ee = o(function(t, e, r) {
                if (!w(t)) throw new TypeError("Bind must be called on a function");
                var n = o(function(i) {
                    return Jt(t, n, e, this, r.concat(i));
                });
                return n;
            }), re = P(q);
            function ne(t, e, r, n) {
                if (n = n || [], e || 0 === e) {
                    if (e <= 0) return n.concat(t);
                } else e = 1 / 0;
                for(var i = n.length, o = 0, a = q(t); o < a; o++){
                    var s = t[o];
                    if (re(s) && (k(s) || D(s))) {
                        if (e > 1) ne(s, e - 1, r, n), i = n.length;
                        else for(var u = 0, l = s.length; u < l;)n[i++] = s[u++];
                    } else r || (n[i++] = s);
                }
                return n;
            }
            var ie = o(function(t, e) {
                var r = (e = ne(e, !1, !1)).length;
                if (r < 1) throw new Error("bindAll must be passed function names");
                for(; r--;){
                    var n = e[r];
                    t[n] = ee(t[n], t);
                }
                return t;
            });
            function oe(t, e) {
                var r = function(n) {
                    var i = r.cache, o = "" + (e ? e.apply(this, arguments) : n);
                    return N(i, o) || (i[o] = t.apply(this, arguments)), i[o];
                };
                return r.cache = {}, r;
            }
            var ae = o(function(t, e, r) {
                return setTimeout(function() {
                    return t.apply(null, r);
                }, e);
            }), se = te(ae, W, 1);
            function ue(t, e, r) {
                var n, i, o, a, s = 0;
                r || (r = {});
                var u = function() {
                    s = !1 === r.leading ? 0 : Bt(), n = null, a = t.apply(i, o), n || (i = o = null);
                }, l = function() {
                    var l = Bt();
                    s || !1 !== r.leading || (s = l);
                    var c = e - (l - s);
                    return i = this, o = arguments, c <= 0 || c > e ? (n && (clearTimeout(n), n = null), s = l, a = t.apply(i, o), n || (i = o = null)) : n || !1 === r.trailing || (n = setTimeout(u, c)), a;
                };
                return l.cancel = function() {
                    clearTimeout(n), s = 0, n = i = o = null;
                }, l;
            }
            function le(t, e, r) {
                var n, i, a, s, u, l = function() {
                    var o = Bt() - i;
                    e > o ? n = setTimeout(l, e - o) : (n = null, r || (s = t.apply(u, a)), n || (a = u = null));
                }, c = o(function(o) {
                    return u = this, a = o, i = Bt(), n || (n = setTimeout(l, e), r && (s = t.apply(u, a))), s;
                });
                return c.cancel = function() {
                    clearTimeout(n), n = a = u = null;
                }, c;
            }
            function ce(t, e) {
                return te(e, t);
            }
            function fe(t) {
                return function() {
                    return !t.apply(this, arguments);
                };
            }
            function he() {
                var t = arguments, e = t.length - 1;
                return function() {
                    for(var r = e, n = t[e].apply(this, arguments); r--;)n = t[r].call(this, n);
                    return n;
                };
            }
            function pe(t, e) {
                return function() {
                    if (--t < 1) return e.apply(this, arguments);
                };
            }
            function de(t, e) {
                var r;
                return function() {
                    return --t > 0 && (r = e.apply(this, arguments)), t <= 1 && (e = null), r;
                };
            }
            var me = te(de, 2);
            function ye(t, e, r) {
                e = Dt(e, r);
                for(var n, i = z(t), o = 0, a = i.length; o < a; o++)if (e(t[n = i[o]], n, t)) return n;
            }
            function ge(t) {
                return function(e, r, n) {
                    r = Dt(r, n);
                    for(var i = q(e), o = t > 0 ? 0 : i - 1; o >= 0 && o < i; o += t)if (r(e[o], o, e)) return o;
                    return -1;
                };
            }
            var ve = ge(1), be = ge(-1);
            function xe(t, e, r, n) {
                for(var i = (r = Dt(r, n, 1))(e), o = 0, a = q(t); o < a;){
                    var s = Math.floor((o + a) / 2);
                    r(t[s]) < i ? o = s + 1 : a = s;
                }
                return o;
            }
            function we(t, e, r) {
                return function(n, o, a) {
                    var s = 0, u = q(n);
                    if ("number" == typeof a) t > 0 ? s = a >= 0 ? a : Math.max(a + u, s) : u = a >= 0 ? Math.min(a + 1, u) : a + u + 1;
                    else if (r && a && u) return n[a = r(n, o)] === o ? a : -1;
                    if (o != o) return (a = e(i.q.call(n, s, u), T)) >= 0 ? a + s : -1;
                    for(a = t > 0 ? s : u - 1; a >= 0 && a < u; a += t)if (n[a] === o) return a;
                    return -1;
                };
            }
            var _e = we(1, ve, xe), Ae = we(-1, be);
            function Ee(t, e, r) {
                var n = (re(t) ? ve : ye)(t, e, r);
                if (void 0 !== n && -1 !== n) return t[n];
            }
            function Se(t, e) {
                return Ee(t, St(e));
            }
            function Me(t, e, r) {
                var n, i;
                if (e = kt(e, r), re(t)) for(n = 0, i = t.length; n < i; n++)e(t[n], n, t);
                else {
                    var o = z(t);
                    for(n = 0, i = o.length; n < i; n++)e(t[o[n]], o[n], t);
                }
                return t;
            }
            function ke(t, e, r) {
                e = Dt(e, r);
                for(var n = !re(t) && z(t), i = (n || t).length, o = Array(i), a = 0; a < i; a++){
                    var s = n ? n[a] : a;
                    o[a] = e(t[s], s, t);
                }
                return o;
            }
            function Ne(t) {
                var e = function(e, r, n, i) {
                    var o = !re(e) && z(e), a = (o || e).length, s = t > 0 ? 0 : a - 1;
                    for(i || (n = e[o ? o[s] : s], s += t); s >= 0 && s < a; s += t){
                        var u = o ? o[s] : s;
                        n = r(n, e[u], u, e);
                    }
                    return n;
                };
                return function(t, r, n, i) {
                    var o = arguments.length >= 3;
                    return e(t, kt(r, i, 4), n, o);
                };
            }
            var Ce = Ne(1), De = Ne(-1);
            function Oe(t, e, r) {
                var n = [];
                return e = Dt(e, r), Me(t, function(t, r, i) {
                    e(t, r, i) && n.push(t);
                }), n;
            }
            function Te(t, e, r) {
                return Oe(t, fe(Dt(e)), r);
            }
            function Fe(t, e, r) {
                e = Dt(e, r);
                for(var n = !re(t) && z(t), i = (n || t).length, o = 0; o < i; o++){
                    var a = n ? n[o] : o;
                    if (!e(t[a], a, t)) return !1;
                }
                return !0;
            }
            function Pe(t, e, r) {
                e = Dt(e, r);
                for(var n = !re(t) && z(t), i = (n || t).length, o = 0; o < i; o++){
                    var a = n ? n[o] : o;
                    if (e(t[a], a, t)) return !0;
                }
                return !1;
            }
            function Ie(t, e, r, n) {
                return re(t) || (t = st(t)), ("number" != typeof r || n) && (r = 0), _e(t, e, r) >= 0;
            }
            var Be = o(function(t, e, r) {
                var n, i;
                return w(e) ? i = e : (e = xt(e), n = e.slice(0, -1), e = e[e.length - 1]), ke(t, function(t) {
                    var o = i;
                    if (!o) {
                        if (n && n.length && (t = wt(t, n)), null == t) return;
                        o = t[e];
                    }
                    return null == o ? o : o.apply(t, r);
                });
            });
            function je(t, e) {
                return ke(t, Mt(e));
            }
            function Re(t, e) {
                return Oe(t, St(e));
            }
            function Le(t, e, r) {
                var n, i, o = -1 / 0, a = -1 / 0;
                if (null == e || "number" == typeof e && "object" != typeof t[0] && null != t) for(var s = 0, u = (t = re(t) ? t : st(t)).length; s < u; s++)null != (n = t[s]) && n > o && (o = n);
                else e = Dt(e, r), Me(t, function(t, r, n) {
                    ((i = e(t, r, n)) > a || i === -1 / 0 && o === -1 / 0) && (o = t, a = i);
                });
                return o;
            }
            function qe(t, e, r) {
                var n, i, o = 1 / 0, a = 1 / 0;
                if (null == e || "number" == typeof e && "object" != typeof t[0] && null != t) for(var s = 0, u = (t = re(t) ? t : st(t)).length; s < u; s++)null != (n = t[s]) && n < o && (o = n);
                else e = Dt(e, r), Me(t, function(t, r, n) {
                    ((i = e(t, r, n)) < a || i === 1 / 0 && o === 1 / 0) && (o = t, a = i);
                });
                return o;
            }
            var Ue = /[^\ud800-\udfff]|[\ud800-\udbff][\udc00-\udfff]|[\ud800-\udfff]/g;
            function ze(t) {
                return t ? k(t) ? i.q.call(t) : h(t) ? t.match(Ue) : re(t) ? ke(t, Et) : st(t) : [];
            }
            function Ge(t, e, r) {
                if (null == e || r) return re(t) || (t = st(t)), t[It(t.length - 1)];
                var n = ze(t), i = q(n);
                e = Math.max(Math.min(e, i), 0);
                for(var o = i - 1, a = 0; a < e; a++){
                    var s = It(a, o), u = n[a];
                    n[a] = n[s], n[s] = u;
                }
                return n.slice(0, e);
            }
            function He(t) {
                return Ge(t, 1 / 0);
            }
            function We(t, e, r) {
                var n = 0;
                return e = Dt(e, r), je(ke(t, function(t, r, i) {
                    return {
                        value: t,
                        index: n++,
                        criteria: e(t, r, i)
                    };
                }).sort(function(t, e) {
                    var r = t.criteria, n = e.criteria;
                    if (r !== n) {
                        if (r > n || void 0 === r) return 1;
                        if (r < n || void 0 === n) return -1;
                    }
                    return t.index - e.index;
                }), "value");
            }
            function $e(t, e) {
                return function(r, n, i) {
                    var o = e ? [
                        [],
                        []
                    ] : {};
                    return n = Dt(n, i), Me(r, function(e, i) {
                        var a = n(e, i, r);
                        t(o, e, a);
                    }), o;
                };
            }
            var Ve = $e(function(t, e, r) {
                N(t, r) ? t[r].push(e) : t[r] = [
                    e
                ];
            }), Ze = $e(function(t, e, r) {
                t[r] = e;
            }), Ye = $e(function(t, e, r) {
                N(t, r) ? t[r]++ : t[r] = 1;
            }), Ke = $e(function(t, e, r) {
                t[r ? 0 : 1].push(e);
            }, !0);
            function Xe(t) {
                return null == t ? 0 : re(t) ? t.length : z(t).length;
            }
            function Je(t, e, r) {
                return e in r;
            }
            var Qe = o(function(t, e) {
                var r = {}, n = e[0];
                if (null == t) return r;
                w(n) ? (e.length > 1 && (n = kt(n, e[1])), e = Y(t)) : (n = Je, e = ne(e, !1, !1), t = Object(t));
                for(var i = 0, o = e.length; i < o; i++){
                    var a = e[i], s = t[a];
                    n(s, a, t) && (r[a] = s);
                }
                return r;
            }), tr = o(function(t, e) {
                var r, n = e[0];
                return w(n) ? (n = fe(n), e.length > 1 && (r = e[1])) : (e = ke(ne(e, !1, !1), String), n = function(t, r) {
                    return !Ie(e, r);
                }), Qe(t, n, r);
            });
            function er(t, e, r) {
                return i.q.call(t, 0, Math.max(0, t.length - (null == e || r ? 1 : e)));
            }
            function rr(t, e, r) {
                return null == t || t.length < 1 ? null == e || r ? void 0 : [] : null == e || r ? t[0] : er(t, t.length - e);
            }
            function nr(t, e, r) {
                return i.q.call(t, null == e || r ? 1 : e);
            }
            function ir(t, e, r) {
                return null == t || t.length < 1 ? null == e || r ? void 0 : [] : null == e || r ? t[t.length - 1] : nr(t, Math.max(0, t.length - e));
            }
            function or(t) {
                return Oe(t, Boolean);
            }
            function ar(t, e) {
                return ne(t, e, !1);
            }
            var sr = o(function(t, e) {
                return e = ne(e, !0, !0), Oe(t, function(t) {
                    return !Ie(e, t);
                });
            }), ur = o(function(t, e) {
                return sr(t, e);
            });
            function lr(t, e, r, n) {
                l(e) || (n = r, r = e, e = !1), null != r && (r = Dt(r, n));
                for(var i = [], o = [], a = 0, s = q(t); a < s; a++){
                    var u = t[a], c = r ? r(u, a, t) : u;
                    e && !r ? (a && o === c || i.push(u), o = c) : r ? Ie(o, c) || (o.push(c), i.push(u)) : Ie(i, u) || i.push(u);
                }
                return i;
            }
            var cr = o(function(t) {
                return lr(ne(t, !0, !0));
            });
            function fr(t) {
                for(var e = [], r = arguments.length, n = 0, i = q(t); n < i; n++){
                    var o = t[n];
                    if (!Ie(e, o)) {
                        var a;
                        for(a = 1; a < r && Ie(arguments[a], o); a++);
                        a === r && e.push(o);
                    }
                }
                return e;
            }
            function hr(t) {
                for(var e = t && Le(t, q).length || 0, r = Array(e), n = 0; n < e; n++)r[n] = je(t, n);
                return r;
            }
            var pr = o(hr);
            function dr(t, e) {
                for(var r = {}, n = 0, i = q(t); n < i; n++)e ? r[t[n]] = e[n] : r[t[n][0]] = t[n][1];
                return r;
            }
            function mr(t, e, r) {
                null == e && (e = t || 0, t = 0), r || (r = e < t ? -1 : 1);
                for(var n = Math.max(Math.ceil((e - t) / r), 0), i = Array(n), o = 0; o < n; o++, t += r)i[o] = t;
                return i;
            }
            function yr(t, e) {
                if (null == e || e < 1) return [];
                for(var r = [], n = 0, o = t.length; n < o;)r.push(i.q.call(t, n, n += e));
                return r;
            }
            function gr(t, e) {
                return t._chain ? W(e).chain() : e;
            }
            function vr(t) {
                return Me(ct(t), function(e) {
                    var r = W[e] = t[e];
                    W.prototype[e] = function() {
                        var t = [
                            this._wrapped
                        ];
                        return i.o.apply(t, arguments), gr(this, r.apply(W, t));
                    };
                }), W;
            }
            Me([
                "pop",
                "push",
                "reverse",
                "shift",
                "sort",
                "splice",
                "unshift"
            ], function(t) {
                var e = i.a[t];
                W.prototype[t] = function() {
                    var r = this._wrapped;
                    return null != r && (e.apply(r, arguments), "shift" !== t && "splice" !== t || 0 !== r.length || delete r[0]), gr(this, r);
                };
            }), Me([
                "concat",
                "join",
                "slice"
            ], function(t) {
                var e = i.a[t];
                W.prototype[t] = function() {
                    var t = this._wrapped;
                    return null != t && (t = e.apply(t, arguments)), gr(this, t);
                };
            });
            var br = W, xr = vr(n);
            xr._ = xr;
            var wr = xr;
        },
        function(t, e, r) {
            "use strict";
            function n(t) {
                return /^[-+]?0(\.0+)?(e[\.\d]+)?$/.test(t);
            }
            t.exports = n, t.exports.default = n;
        },
        function(t, e, r) {
            "undefined" != typeof self && self, t.exports = function(t) {
                var e = {};
                function r(n) {
                    if (e[n]) return e[n].exports;
                    var i = e[n] = {
                        i: n,
                        l: !1,
                        exports: {}
                    };
                    return t[n].call(i.exports, i, i.exports, r), i.l = !0, i.exports;
                }
                return r.m = t, r.c = e, r.d = function(t, e, n) {
                    r.o(t, e) || Object.defineProperty(t, e, {
                        enumerable: !0,
                        get: n
                    });
                }, r.r = function(t) {
                    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
                        value: "Module"
                    }), Object.defineProperty(t, "__esModule", {
                        value: !0
                    });
                }, r.t = function(t, e) {
                    if (1 & e && (t = r(t)), 8 & e) return t;
                    if (4 & e && "object" == typeof t && t && t.__esModule) return t;
                    var n = Object.create(null);
                    if (r.r(n), Object.defineProperty(n, "default", {
                        enumerable: !0,
                        value: t
                    }), 2 & e && "string" != typeof t) for(var i in t)r.d(n, i, (function(e) {
                        return t[e];
                    }).bind(null, i));
                    return n;
                }, r.n = function(t) {
                    var e = t && t.__esModule ? function() {
                        return t.default;
                    } : function() {
                        return t;
                    };
                    return r.d(e, "a", e), e;
                }, r.o = function(t, e) {
                    return Object.prototype.hasOwnProperty.call(t, e);
                }, r.p = "", r(r.s = 107);
            }([
                function(t, e, r) {
                    "use strict";
                    const n = r(73);
                    t.exports = function(t) {
                        return "+" === t[0] && (t = t.substring(1)), (t = (t = n(t)).replace(/^0+(?=\d)/, "")).includes(".") && (t = t.replace(/\.?0+$/, "")), "" === t && (t = "0"), "-0" === t && (t = "0"), t;
                    };
                },
                function(t, e, r) {
                    "use strict";
                    const n = r(4), i = r(0), o = r(15), a = r(32);
                    function s(t, e, r) {
                        t = i(t), e = i(e);
                        const s = "-" !== t[0], u = "-" !== e[0], l = o(t), c = o(e);
                        if (l || c) return s == u ? "Infinity" : "-Infinity";
                        if ("0" === e) throw new Error("[preciso] division by zero");
                        if ("" === t || "0" === t) return "0";
                        const f = s !== u ? "-" : "";
                        return s || (t = n(t)), u || (e = n(e)), f + a(t, e, r);
                    }
                    t.exports = s, t.exports.default = s;
                },
                function(t, e, r) {
                    "use strict";
                    r.d(e, "a", function() {
                        return n;
                    }), r.d(e, "b", function() {
                        return i;
                    }), r.d(e, "c", function() {
                        return o;
                    }), r.d(e, "d", function() {
                        return a;
                    }), r.d(e, "e", function() {
                        return s;
                    });
                    const n = Symbol("thread.errors"), i = Symbol("thread.events"), o = Symbol("thread.terminate"), a = Symbol("thread.transferable"), s = Symbol("thread.worker");
                },
                function(t, e) {
                    var r;
                    r = function() {
                        return this;
                    }();
                    try {
                        r = r || new Function("return this")();
                    } catch (t) {
                        "object" == typeof window && (r = window);
                    }
                    t.exports = r;
                },
                function(t, e, r) {
                    "use strict";
                    const n = r(0);
                    function i(t) {
                        return "-" === (t = n(t))[0] ? t.substring(1) : t;
                    }
                    t.exports = i, t.exports.default = i;
                },
                function(t, e, r) {
                    "use strict";
                    function n(t, e) {
                        const r = t.length, n = e.length, i = t.indexOf("."), o = e.indexOf("."), a = -1 === i ? r : i, s = -1 === o ? n : o, u = a - s;
                        let l = u < 0 ? -1 * u : 0, c = u <= 0 ? 0 : u, f = Math.max(a, s) + 1 + Math.max(r - a, n - s) - 1, h = 0;
                        for(; h < f;){
                            const r = h - l, n = r === a ? "." : t[r] || "0", i = h - c, o = i === s ? "." : e[i] || "0";
                            if (n !== o) {
                                if (n > o) return ">";
                                if (n < o) return "<";
                            }
                            h++;
                        }
                        return "=";
                    }
                    t.exports = n, t.exports.default = n;
                },
                function(t, e, r) {
                    "use strict";
                    const n = r(5), i = r(0), o = r(9), a = r(31), s = r(15);
                    function u(t, e, { infinity_minus_infinity: r = "NaN" } = {}) {
                        t = i(t), e = i(e);
                        const u = "-" !== t[0], l = "-" !== e[0], c = !u, f = !l, h = s(t), p = s(e);
                        if (h && p) return u && l ? "Infinity" : c & f ? "-Infinity" : r;
                        if (h) return u ? "Infinity" : "-Infinity";
                        if (p) return l ? "Infinity" : "-Infinity";
                        if (u && l) return o(t, e);
                        if (c && f) return "-" + o(t.substring(1), e.substring(1));
                        if (c && l) switch(t = t.substring(1), n(t, e)){
                            case "=":
                                return "0";
                            case "<":
                                return a(e, t);
                            case ">":
                                return "-" + a(t, e);
                        }
                        else if (u && !l) switch(e = e.substring(1), n(t, e)){
                            case "=":
                                return "0";
                            case "<":
                                return "-" + a(e, t);
                            case ">":
                                return a(t, e);
                        }
                    }
                    t.exports = u, t.exports.default = u;
                },
                function(t, e, r) {
                    "use strict";
                    (function(t) {
                        /*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <http://feross.org>
 * @license  MIT
 */ var n = r(108), i = r(109), o = r(60);
                        function a() {
                            return u.TYPED_ARRAY_SUPPORT ? 2147483647 : 1073741823;
                        }
                        function s(t, e) {
                            if (a() < e) throw new RangeError("Invalid typed array length");
                            return u.TYPED_ARRAY_SUPPORT ? (t = new Uint8Array(e)).__proto__ = u.prototype : (null === t && (t = new u(e)), t.length = e), t;
                        }
                        function u(t, e, r) {
                            if (!(u.TYPED_ARRAY_SUPPORT || this instanceof u)) return new u(t, e, r);
                            if ("number" == typeof t) {
                                if ("string" == typeof e) throw new Error("If encoding is specified then the first argument must be a string");
                                return f(this, t);
                            }
                            return l(this, t, e, r);
                        }
                        function l(t, e, r, n) {
                            if ("number" == typeof e) throw new TypeError('"value" argument must not be a number');
                            return "undefined" != typeof ArrayBuffer && e instanceof ArrayBuffer ? function(t, e, r, n) {
                                if (e.byteLength, r < 0 || e.byteLength < r) throw new RangeError("'offset' is out of bounds");
                                if (e.byteLength < r + (n || 0)) throw new RangeError("'length' is out of bounds");
                                return e = void 0 === r && void 0 === n ? new Uint8Array(e) : void 0 === n ? new Uint8Array(e, r) : new Uint8Array(e, r, n), u.TYPED_ARRAY_SUPPORT ? (t = e).__proto__ = u.prototype : t = h(t, e), t;
                            }(t, e, r, n) : "string" == typeof e ? function(t, e, r) {
                                if ("string" == typeof r && "" !== r || (r = "utf8"), !u.isEncoding(r)) throw new TypeError('"encoding" must be a valid string encoding');
                                var n = 0 | d(e, r), i = (t = s(t, n)).write(e, r);
                                return i !== n && (t = t.slice(0, i)), t;
                            }(t, e, r) : function(t, e) {
                                if (u.isBuffer(e)) {
                                    var r = 0 | p(e.length);
                                    return 0 === (t = s(t, r)).length || e.copy(t, 0, 0, r), t;
                                }
                                if (e) {
                                    if ("undefined" != typeof ArrayBuffer && e.buffer instanceof ArrayBuffer || "length" in e) return "number" != typeof e.length || (n = e.length) != n ? s(t, 0) : h(t, e);
                                    if ("Buffer" === e.type && o(e.data)) return h(t, e.data);
                                }
                                var n;
                                throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.");
                            }(t, e);
                        }
                        function c(t) {
                            if ("number" != typeof t) throw new TypeError('"size" argument must be a number');
                            if (t < 0) throw new RangeError('"size" argument must not be negative');
                        }
                        function f(t, e) {
                            if (c(e), t = s(t, e < 0 ? 0 : 0 | p(e)), !u.TYPED_ARRAY_SUPPORT) for(var r = 0; r < e; ++r)t[r] = 0;
                            return t;
                        }
                        function h(t, e) {
                            var r = e.length < 0 ? 0 : 0 | p(e.length);
                            t = s(t, r);
                            for(var n = 0; n < r; n += 1)t[n] = 255 & e[n];
                            return t;
                        }
                        function p(t) {
                            if (t >= a()) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + a().toString(16) + " bytes");
                            return 0 | t;
                        }
                        function d(t, e) {
                            if (u.isBuffer(t)) return t.length;
                            if ("undefined" != typeof ArrayBuffer && "function" == typeof ArrayBuffer.isView && (ArrayBuffer.isView(t) || t instanceof ArrayBuffer)) return t.byteLength;
                            "string" != typeof t && (t = "" + t);
                            var r = t.length;
                            if (0 === r) return 0;
                            for(var n = !1;;)switch(e){
                                case "ascii":
                                case "latin1":
                                case "binary":
                                    return r;
                                case "utf8":
                                case "utf-8":
                                case void 0:
                                    return q(t).length;
                                case "ucs2":
                                case "ucs-2":
                                case "utf16le":
                                case "utf-16le":
                                    return 2 * r;
                                case "hex":
                                    return r >>> 1;
                                case "base64":
                                    return U(t).length;
                                default:
                                    if (n) return q(t).length;
                                    e = ("" + e).toLowerCase(), n = !0;
                            }
                        }
                        function m(t, e, r) {
                            var n = !1;
                            if ((void 0 === e || e < 0) && (e = 0), e > this.length) return "";
                            if ((void 0 === r || r > this.length) && (r = this.length), r <= 0) return "";
                            if ((r >>>= 0) <= (e >>>= 0)) return "";
                            for(t || (t = "utf8");;)switch(t){
                                case "hex":
                                    return C(this, e, r);
                                case "utf8":
                                case "utf-8":
                                    return M(this, e, r);
                                case "ascii":
                                    return k(this, e, r);
                                case "latin1":
                                case "binary":
                                    return N(this, e, r);
                                case "base64":
                                    return S(this, e, r);
                                case "ucs2":
                                case "ucs-2":
                                case "utf16le":
                                case "utf-16le":
                                    return D(this, e, r);
                                default:
                                    if (n) throw new TypeError("Unknown encoding: " + t);
                                    t = (t + "").toLowerCase(), n = !0;
                            }
                        }
                        function y(t, e, r) {
                            var n = t[e];
                            t[e] = t[r], t[r] = n;
                        }
                        function g(t, e, r, n, i) {
                            if (0 === t.length) return -1;
                            if ("string" == typeof r ? (n = r, r = 0) : r > 2147483647 ? r = 2147483647 : r < -2147483648 && (r = -2147483648), r = +r, isNaN(r) && (r = i ? 0 : t.length - 1), r < 0 && (r = t.length + r), r >= t.length) {
                                if (i) return -1;
                                r = t.length - 1;
                            } else if (r < 0) {
                                if (!i) return -1;
                                r = 0;
                            }
                            if ("string" == typeof e && (e = u.from(e, n)), u.isBuffer(e)) return 0 === e.length ? -1 : v(t, e, r, n, i);
                            if ("number" == typeof e) return e &= 255, u.TYPED_ARRAY_SUPPORT && "function" == typeof Uint8Array.prototype.indexOf ? i ? Uint8Array.prototype.indexOf.call(t, e, r) : Uint8Array.prototype.lastIndexOf.call(t, e, r) : v(t, [
                                e
                            ], r, n, i);
                            throw new TypeError("val must be string, number or Buffer");
                        }
                        function v(t, e, r, n, i) {
                            var o, a = 1, s = t.length, u = e.length;
                            if (void 0 !== n && ("ucs2" === (n = String(n).toLowerCase()) || "ucs-2" === n || "utf16le" === n || "utf-16le" === n)) {
                                if (t.length < 2 || e.length < 2) return -1;
                                a = 2, s /= 2, u /= 2, r /= 2;
                            }
                            function l(t, e) {
                                return 1 === a ? t[e] : t.readUInt16BE(e * a);
                            }
                            if (i) {
                                var c = -1;
                                for(o = r; o < s; o++)if (l(t, o) === l(e, -1 === c ? 0 : o - c)) {
                                    if (-1 === c && (c = o), o - c + 1 === u) return c * a;
                                } else -1 !== c && (o -= o - c), c = -1;
                            } else for(r + u > s && (r = s - u), o = r; o >= 0; o--){
                                for(var f = !0, h = 0; h < u; h++)if (l(t, o + h) !== l(e, h)) {
                                    f = !1;
                                    break;
                                }
                                if (f) return o;
                            }
                            return -1;
                        }
                        function b(t, e, r, n) {
                            r = Number(r) || 0;
                            var i = t.length - r;
                            n ? (n = Number(n)) > i && (n = i) : n = i;
                            var o = e.length;
                            if (o % 2 != 0) throw new TypeError("Invalid hex string");
                            n > o / 2 && (n = o / 2);
                            for(var a = 0; a < n; ++a){
                                var s = parseInt(e.substr(2 * a, 2), 16);
                                if (isNaN(s)) return a;
                                t[r + a] = s;
                            }
                            return a;
                        }
                        function x(t, e, r, n) {
                            return z(q(e, t.length - r), t, r, n);
                        }
                        function w(t, e, r, n) {
                            return z(function(t) {
                                for(var e = [], r = 0; r < t.length; ++r)e.push(255 & t.charCodeAt(r));
                                return e;
                            }(e), t, r, n);
                        }
                        function _(t, e, r, n) {
                            return w(t, e, r, n);
                        }
                        function A(t, e, r, n) {
                            return z(U(e), t, r, n);
                        }
                        function E(t, e, r, n) {
                            return z(function(t, e) {
                                for(var r, n, i, o = [], a = 0; a < t.length && !((e -= 2) < 0); ++a)n = (r = t.charCodeAt(a)) >> 8, i = r % 256, o.push(i), o.push(n);
                                return o;
                            }(e, t.length - r), t, r, n);
                        }
                        function S(t, e, r) {
                            return 0 === e && r === t.length ? n.fromByteArray(t) : n.fromByteArray(t.slice(e, r));
                        }
                        function M(t, e, r) {
                            r = Math.min(t.length, r);
                            for(var n = [], i = e; i < r;){
                                var o, a, s, u, l = t[i], c = null, f = l > 239 ? 4 : l > 223 ? 3 : l > 191 ? 2 : 1;
                                if (i + f <= r) switch(f){
                                    case 1:
                                        l < 128 && (c = l);
                                        break;
                                    case 2:
                                        128 == (192 & (o = t[i + 1])) && (u = (31 & l) << 6 | 63 & o) > 127 && (c = u);
                                        break;
                                    case 3:
                                        o = t[i + 1], a = t[i + 2], 128 == (192 & o) && 128 == (192 & a) && (u = (15 & l) << 12 | (63 & o) << 6 | 63 & a) > 2047 && (u < 55296 || u > 57343) && (c = u);
                                        break;
                                    case 4:
                                        o = t[i + 1], a = t[i + 2], s = t[i + 3], 128 == (192 & o) && 128 == (192 & a) && 128 == (192 & s) && (u = (15 & l) << 18 | (63 & o) << 12 | (63 & a) << 6 | 63 & s) > 65535 && u < 1114112 && (c = u);
                                }
                                null === c ? (c = 65533, f = 1) : c > 65535 && (c -= 65536, n.push(c >>> 10 & 1023 | 55296), c = 56320 | 1023 & c), n.push(c), i += f;
                            }
                            return function(t) {
                                var e = t.length;
                                if (e <= 4096) return String.fromCharCode.apply(String, t);
                                for(var r = "", n = 0; n < e;)r += String.fromCharCode.apply(String, t.slice(n, n += 4096));
                                return r;
                            }(n);
                        }
                        function k(t, e, r) {
                            var n = "";
                            r = Math.min(t.length, r);
                            for(var i = e; i < r; ++i)n += String.fromCharCode(127 & t[i]);
                            return n;
                        }
                        function N(t, e, r) {
                            var n = "";
                            r = Math.min(t.length, r);
                            for(var i = e; i < r; ++i)n += String.fromCharCode(t[i]);
                            return n;
                        }
                        function C(t, e, r) {
                            var n = t.length;
                            (!e || e < 0) && (e = 0), (!r || r < 0 || r > n) && (r = n);
                            for(var i = "", o = e; o < r; ++o)i += L(t[o]);
                            return i;
                        }
                        function D(t, e, r) {
                            for(var n = t.slice(e, r), i = "", o = 0; o < n.length; o += 2)i += String.fromCharCode(n[o] + 256 * n[o + 1]);
                            return i;
                        }
                        function O(t, e, r) {
                            if (t % 1 != 0 || t < 0) throw new RangeError("offset is not uint");
                            if (t + e > r) throw new RangeError("Trying to access beyond buffer length");
                        }
                        function T(t, e, r, n, i, o) {
                            if (!u.isBuffer(t)) throw new TypeError('"buffer" argument must be a Buffer instance');
                            if (e > i || e < o) throw new RangeError('"value" argument is out of bounds');
                            if (r + n > t.length) throw new RangeError("Index out of range");
                        }
                        function F(t, e, r, n) {
                            e < 0 && (e = 65535 + e + 1);
                            for(var i = 0, o = Math.min(t.length - r, 2); i < o; ++i)t[r + i] = (e & 255 << 8 * (n ? i : 1 - i)) >>> 8 * (n ? i : 1 - i);
                        }
                        function P(t, e, r, n) {
                            e < 0 && (e = 4294967295 + e + 1);
                            for(var i = 0, o = Math.min(t.length - r, 4); i < o; ++i)t[r + i] = e >>> 8 * (n ? i : 3 - i) & 255;
                        }
                        function I(t, e, r, n, i, o) {
                            if (r + n > t.length) throw new RangeError("Index out of range");
                            if (r < 0) throw new RangeError("Index out of range");
                        }
                        function B(t, e, r, n, o) {
                            return o || I(t, 0, r, 4), i.write(t, e, r, n, 23, 4), r + 4;
                        }
                        function j(t, e, r, n, o) {
                            return o || I(t, 0, r, 8), i.write(t, e, r, n, 52, 8), r + 8;
                        }
                        e.Buffer = u, e.SlowBuffer = function(t) {
                            return +t != t && (t = 0), u.alloc(+t);
                        }, e.INSPECT_MAX_BYTES = 50, u.TYPED_ARRAY_SUPPORT = void 0 !== t.TYPED_ARRAY_SUPPORT ? t.TYPED_ARRAY_SUPPORT : function() {
                            try {
                                var t = new Uint8Array(1);
                                return t.__proto__ = {
                                    __proto__: Uint8Array.prototype,
                                    foo: function() {
                                        return 42;
                                    }
                                }, 42 === t.foo() && "function" == typeof t.subarray && 0 === t.subarray(1, 1).byteLength;
                            } catch (t) {
                                return !1;
                            }
                        }(), e.kMaxLength = a(), u.poolSize = 8192, u._augment = function(t) {
                            return t.__proto__ = u.prototype, t;
                        }, u.from = function(t, e, r) {
                            return l(null, t, e, r);
                        }, u.TYPED_ARRAY_SUPPORT && (u.prototype.__proto__ = Uint8Array.prototype, u.__proto__ = Uint8Array, "undefined" != typeof Symbol && Symbol.species && u[Symbol.species] === u && Object.defineProperty(u, Symbol.species, {
                            value: null,
                            configurable: !0
                        })), u.alloc = function(t, e, r) {
                            return function(t, e, r, n) {
                                return c(e), e <= 0 ? s(t, e) : void 0 !== r ? "string" == typeof n ? s(t, e).fill(r, n) : s(t, e).fill(r) : s(t, e);
                            }(null, t, e, r);
                        }, u.allocUnsafe = function(t) {
                            return f(null, t);
                        }, u.allocUnsafeSlow = function(t) {
                            return f(null, t);
                        }, u.isBuffer = function(t) {
                            return !(null == t || !t._isBuffer);
                        }, u.compare = function(t, e) {
                            if (!u.isBuffer(t) || !u.isBuffer(e)) throw new TypeError("Arguments must be Buffers");
                            if (t === e) return 0;
                            for(var r = t.length, n = e.length, i = 0, o = Math.min(r, n); i < o; ++i)if (t[i] !== e[i]) {
                                r = t[i], n = e[i];
                                break;
                            }
                            return r < n ? -1 : n < r ? 1 : 0;
                        }, u.isEncoding = function(t) {
                            switch(String(t).toLowerCase()){
                                case "hex":
                                case "utf8":
                                case "utf-8":
                                case "ascii":
                                case "latin1":
                                case "binary":
                                case "base64":
                                case "ucs2":
                                case "ucs-2":
                                case "utf16le":
                                case "utf-16le":
                                    return !0;
                                default:
                                    return !1;
                            }
                        }, u.concat = function(t, e) {
                            if (!o(t)) throw new TypeError('"list" argument must be an Array of Buffers');
                            if (0 === t.length) return u.alloc(0);
                            var r;
                            if (void 0 === e) for(e = 0, r = 0; r < t.length; ++r)e += t[r].length;
                            var n = u.allocUnsafe(e), i = 0;
                            for(r = 0; r < t.length; ++r){
                                var a = t[r];
                                if (!u.isBuffer(a)) throw new TypeError('"list" argument must be an Array of Buffers');
                                a.copy(n, i), i += a.length;
                            }
                            return n;
                        }, u.byteLength = d, u.prototype._isBuffer = !0, u.prototype.swap16 = function() {
                            var t = this.length;
                            if (t % 2 != 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
                            for(var e = 0; e < t; e += 2)y(this, e, e + 1);
                            return this;
                        }, u.prototype.swap32 = function() {
                            var t = this.length;
                            if (t % 4 != 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
                            for(var e = 0; e < t; e += 4)y(this, e, e + 3), y(this, e + 1, e + 2);
                            return this;
                        }, u.prototype.swap64 = function() {
                            var t = this.length;
                            if (t % 8 != 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
                            for(var e = 0; e < t; e += 8)y(this, e, e + 7), y(this, e + 1, e + 6), y(this, e + 2, e + 5), y(this, e + 3, e + 4);
                            return this;
                        }, u.prototype.toString = function() {
                            var t = 0 | this.length;
                            return 0 === t ? "" : 0 === arguments.length ? M(this, 0, t) : m.apply(this, arguments);
                        }, u.prototype.equals = function(t) {
                            if (!u.isBuffer(t)) throw new TypeError("Argument must be a Buffer");
                            return this === t || 0 === u.compare(this, t);
                        }, u.prototype.inspect = function() {
                            var t = "", r = e.INSPECT_MAX_BYTES;
                            return this.length > 0 && (t = this.toString("hex", 0, r).match(/.{2}/g).join(" "), this.length > r && (t += " ... ")), "<Buffer " + t + ">";
                        }, u.prototype.compare = function(t, e, r, n, i) {
                            if (!u.isBuffer(t)) throw new TypeError("Argument must be a Buffer");
                            if (void 0 === e && (e = 0), void 0 === r && (r = t ? t.length : 0), void 0 === n && (n = 0), void 0 === i && (i = this.length), e < 0 || r > t.length || n < 0 || i > this.length) throw new RangeError("out of range index");
                            if (n >= i && e >= r) return 0;
                            if (n >= i) return -1;
                            if (e >= r) return 1;
                            if (this === t) return 0;
                            for(var o = (i >>>= 0) - (n >>>= 0), a = (r >>>= 0) - (e >>>= 0), s = Math.min(o, a), l = this.slice(n, i), c = t.slice(e, r), f = 0; f < s; ++f)if (l[f] !== c[f]) {
                                o = l[f], a = c[f];
                                break;
                            }
                            return o < a ? -1 : a < o ? 1 : 0;
                        }, u.prototype.includes = function(t, e, r) {
                            return -1 !== this.indexOf(t, e, r);
                        }, u.prototype.indexOf = function(t, e, r) {
                            return g(this, t, e, r, !0);
                        }, u.prototype.lastIndexOf = function(t, e, r) {
                            return g(this, t, e, r, !1);
                        }, u.prototype.write = function(t, e, r, n) {
                            if (void 0 === e) n = "utf8", r = this.length, e = 0;
                            else if (void 0 === r && "string" == typeof e) n = e, r = this.length, e = 0;
                            else {
                                if (!isFinite(e)) throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
                                e |= 0, isFinite(r) ? (r |= 0, void 0 === n && (n = "utf8")) : (n = r, r = void 0);
                            }
                            var i = this.length - e;
                            if ((void 0 === r || r > i) && (r = i), t.length > 0 && (r < 0 || e < 0) || e > this.length) throw new RangeError("Attempt to write outside buffer bounds");
                            n || (n = "utf8");
                            for(var o = !1;;)switch(n){
                                case "hex":
                                    return b(this, t, e, r);
                                case "utf8":
                                case "utf-8":
                                    return x(this, t, e, r);
                                case "ascii":
                                    return w(this, t, e, r);
                                case "latin1":
                                case "binary":
                                    return _(this, t, e, r);
                                case "base64":
                                    return A(this, t, e, r);
                                case "ucs2":
                                case "ucs-2":
                                case "utf16le":
                                case "utf-16le":
                                    return E(this, t, e, r);
                                default:
                                    if (o) throw new TypeError("Unknown encoding: " + n);
                                    n = ("" + n).toLowerCase(), o = !0;
                            }
                        }, u.prototype.toJSON = function() {
                            return {
                                type: "Buffer",
                                data: Array.prototype.slice.call(this._arr || this, 0)
                            };
                        }, u.prototype.slice = function(t, e) {
                            var r, n = this.length;
                            if ((t = ~~t) < 0 ? (t += n) < 0 && (t = 0) : t > n && (t = n), (e = void 0 === e ? n : ~~e) < 0 ? (e += n) < 0 && (e = 0) : e > n && (e = n), e < t && (e = t), u.TYPED_ARRAY_SUPPORT) (r = this.subarray(t, e)).__proto__ = u.prototype;
                            else {
                                var i = e - t;
                                r = new u(i, void 0);
                                for(var o = 0; o < i; ++o)r[o] = this[o + t];
                            }
                            return r;
                        }, u.prototype.readUIntLE = function(t, e, r) {
                            t |= 0, e |= 0, r || O(t, e, this.length);
                            for(var n = this[t], i = 1, o = 0; ++o < e && (i *= 256);)n += this[t + o] * i;
                            return n;
                        }, u.prototype.readUIntBE = function(t, e, r) {
                            t |= 0, e |= 0, r || O(t, e, this.length);
                            for(var n = this[t + --e], i = 1; e > 0 && (i *= 256);)n += this[t + --e] * i;
                            return n;
                        }, u.prototype.readUInt8 = function(t, e) {
                            return e || O(t, 1, this.length), this[t];
                        }, u.prototype.readUInt16LE = function(t, e) {
                            return e || O(t, 2, this.length), this[t] | this[t + 1] << 8;
                        }, u.prototype.readUInt16BE = function(t, e) {
                            return e || O(t, 2, this.length), this[t] << 8 | this[t + 1];
                        }, u.prototype.readUInt32LE = function(t, e) {
                            return e || O(t, 4, this.length), (this[t] | this[t + 1] << 8 | this[t + 2] << 16) + 16777216 * this[t + 3];
                        }, u.prototype.readUInt32BE = function(t, e) {
                            return e || O(t, 4, this.length), 16777216 * this[t] + (this[t + 1] << 16 | this[t + 2] << 8 | this[t + 3]);
                        }, u.prototype.readIntLE = function(t, e, r) {
                            t |= 0, e |= 0, r || O(t, e, this.length);
                            for(var n = this[t], i = 1, o = 0; ++o < e && (i *= 256);)n += this[t + o] * i;
                            return n >= (i *= 128) && (n -= Math.pow(2, 8 * e)), n;
                        }, u.prototype.readIntBE = function(t, e, r) {
                            t |= 0, e |= 0, r || O(t, e, this.length);
                            for(var n = e, i = 1, o = this[t + --n]; n > 0 && (i *= 256);)o += this[t + --n] * i;
                            return o >= (i *= 128) && (o -= Math.pow(2, 8 * e)), o;
                        }, u.prototype.readInt8 = function(t, e) {
                            return e || O(t, 1, this.length), 128 & this[t] ? -1 * (255 - this[t] + 1) : this[t];
                        }, u.prototype.readInt16LE = function(t, e) {
                            e || O(t, 2, this.length);
                            var r = this[t] | this[t + 1] << 8;
                            return 32768 & r ? 4294901760 | r : r;
                        }, u.prototype.readInt16BE = function(t, e) {
                            e || O(t, 2, this.length);
                            var r = this[t + 1] | this[t] << 8;
                            return 32768 & r ? 4294901760 | r : r;
                        }, u.prototype.readInt32LE = function(t, e) {
                            return e || O(t, 4, this.length), this[t] | this[t + 1] << 8 | this[t + 2] << 16 | this[t + 3] << 24;
                        }, u.prototype.readInt32BE = function(t, e) {
                            return e || O(t, 4, this.length), this[t] << 24 | this[t + 1] << 16 | this[t + 2] << 8 | this[t + 3];
                        }, u.prototype.readFloatLE = function(t, e) {
                            return e || O(t, 4, this.length), i.read(this, t, !0, 23, 4);
                        }, u.prototype.readFloatBE = function(t, e) {
                            return e || O(t, 4, this.length), i.read(this, t, !1, 23, 4);
                        }, u.prototype.readDoubleLE = function(t, e) {
                            return e || O(t, 8, this.length), i.read(this, t, !0, 52, 8);
                        }, u.prototype.readDoubleBE = function(t, e) {
                            return e || O(t, 8, this.length), i.read(this, t, !1, 52, 8);
                        }, u.prototype.writeUIntLE = function(t, e, r, n) {
                            t = +t, e |= 0, r |= 0, n || T(this, t, e, r, Math.pow(2, 8 * r) - 1, 0);
                            var i = 1, o = 0;
                            for(this[e] = 255 & t; ++o < r && (i *= 256);)this[e + o] = t / i & 255;
                            return e + r;
                        }, u.prototype.writeUIntBE = function(t, e, r, n) {
                            t = +t, e |= 0, r |= 0, n || T(this, t, e, r, Math.pow(2, 8 * r) - 1, 0);
                            var i = r - 1, o = 1;
                            for(this[e + i] = 255 & t; --i >= 0 && (o *= 256);)this[e + i] = t / o & 255;
                            return e + r;
                        }, u.prototype.writeUInt8 = function(t, e, r) {
                            return t = +t, e |= 0, r || T(this, t, e, 1, 255, 0), u.TYPED_ARRAY_SUPPORT || (t = Math.floor(t)), this[e] = 255 & t, e + 1;
                        }, u.prototype.writeUInt16LE = function(t, e, r) {
                            return t = +t, e |= 0, r || T(this, t, e, 2, 65535, 0), u.TYPED_ARRAY_SUPPORT ? (this[e] = 255 & t, this[e + 1] = t >>> 8) : F(this, t, e, !0), e + 2;
                        }, u.prototype.writeUInt16BE = function(t, e, r) {
                            return t = +t, e |= 0, r || T(this, t, e, 2, 65535, 0), u.TYPED_ARRAY_SUPPORT ? (this[e] = t >>> 8, this[e + 1] = 255 & t) : F(this, t, e, !1), e + 2;
                        }, u.prototype.writeUInt32LE = function(t, e, r) {
                            return t = +t, e |= 0, r || T(this, t, e, 4, 4294967295, 0), u.TYPED_ARRAY_SUPPORT ? (this[e + 3] = t >>> 24, this[e + 2] = t >>> 16, this[e + 1] = t >>> 8, this[e] = 255 & t) : P(this, t, e, !0), e + 4;
                        }, u.prototype.writeUInt32BE = function(t, e, r) {
                            return t = +t, e |= 0, r || T(this, t, e, 4, 4294967295, 0), u.TYPED_ARRAY_SUPPORT ? (this[e] = t >>> 24, this[e + 1] = t >>> 16, this[e + 2] = t >>> 8, this[e + 3] = 255 & t) : P(this, t, e, !1), e + 4;
                        }, u.prototype.writeIntLE = function(t, e, r, n) {
                            if (t = +t, e |= 0, !n) {
                                var i = Math.pow(2, 8 * r - 1);
                                T(this, t, e, r, i - 1, -i);
                            }
                            var o = 0, a = 1, s = 0;
                            for(this[e] = 255 & t; ++o < r && (a *= 256);)t < 0 && 0 === s && 0 !== this[e + o - 1] && (s = 1), this[e + o] = (t / a >> 0) - s & 255;
                            return e + r;
                        }, u.prototype.writeIntBE = function(t, e, r, n) {
                            if (t = +t, e |= 0, !n) {
                                var i = Math.pow(2, 8 * r - 1);
                                T(this, t, e, r, i - 1, -i);
                            }
                            var o = r - 1, a = 1, s = 0;
                            for(this[e + o] = 255 & t; --o >= 0 && (a *= 256);)t < 0 && 0 === s && 0 !== this[e + o + 1] && (s = 1), this[e + o] = (t / a >> 0) - s & 255;
                            return e + r;
                        }, u.prototype.writeInt8 = function(t, e, r) {
                            return t = +t, e |= 0, r || T(this, t, e, 1, 127, -128), u.TYPED_ARRAY_SUPPORT || (t = Math.floor(t)), t < 0 && (t = 255 + t + 1), this[e] = 255 & t, e + 1;
                        }, u.prototype.writeInt16LE = function(t, e, r) {
                            return t = +t, e |= 0, r || T(this, t, e, 2, 32767, -32768), u.TYPED_ARRAY_SUPPORT ? (this[e] = 255 & t, this[e + 1] = t >>> 8) : F(this, t, e, !0), e + 2;
                        }, u.prototype.writeInt16BE = function(t, e, r) {
                            return t = +t, e |= 0, r || T(this, t, e, 2, 32767, -32768), u.TYPED_ARRAY_SUPPORT ? (this[e] = t >>> 8, this[e + 1] = 255 & t) : F(this, t, e, !1), e + 2;
                        }, u.prototype.writeInt32LE = function(t, e, r) {
                            return t = +t, e |= 0, r || T(this, t, e, 4, 2147483647, -2147483648), u.TYPED_ARRAY_SUPPORT ? (this[e] = 255 & t, this[e + 1] = t >>> 8, this[e + 2] = t >>> 16, this[e + 3] = t >>> 24) : P(this, t, e, !0), e + 4;
                        }, u.prototype.writeInt32BE = function(t, e, r) {
                            return t = +t, e |= 0, r || T(this, t, e, 4, 2147483647, -2147483648), t < 0 && (t = 4294967295 + t + 1), u.TYPED_ARRAY_SUPPORT ? (this[e] = t >>> 24, this[e + 1] = t >>> 16, this[e + 2] = t >>> 8, this[e + 3] = 255 & t) : P(this, t, e, !1), e + 4;
                        }, u.prototype.writeFloatLE = function(t, e, r) {
                            return B(this, t, e, !0, r);
                        }, u.prototype.writeFloatBE = function(t, e, r) {
                            return B(this, t, e, !1, r);
                        }, u.prototype.writeDoubleLE = function(t, e, r) {
                            return j(this, t, e, !0, r);
                        }, u.prototype.writeDoubleBE = function(t, e, r) {
                            return j(this, t, e, !1, r);
                        }, u.prototype.copy = function(t, e, r, n) {
                            if (r || (r = 0), n || 0 === n || (n = this.length), e >= t.length && (e = t.length), e || (e = 0), n > 0 && n < r && (n = r), n === r) return 0;
                            if (0 === t.length || 0 === this.length) return 0;
                            if (e < 0) throw new RangeError("targetStart out of bounds");
                            if (r < 0 || r >= this.length) throw new RangeError("sourceStart out of bounds");
                            if (n < 0) throw new RangeError("sourceEnd out of bounds");
                            n > this.length && (n = this.length), t.length - e < n - r && (n = t.length - e + r);
                            var i, o = n - r;
                            if (this === t && r < e && e < n) for(i = o - 1; i >= 0; --i)t[i + e] = this[i + r];
                            else if (o < 1e3 || !u.TYPED_ARRAY_SUPPORT) for(i = 0; i < o; ++i)t[i + e] = this[i + r];
                            else Uint8Array.prototype.set.call(t, this.subarray(r, r + o), e);
                            return o;
                        }, u.prototype.fill = function(t, e, r, n) {
                            if ("string" == typeof t) {
                                if ("string" == typeof e ? (n = e, e = 0, r = this.length) : "string" == typeof r && (n = r, r = this.length), 1 === t.length) {
                                    var i = t.charCodeAt(0);
                                    i < 256 && (t = i);
                                }
                                if (void 0 !== n && "string" != typeof n) throw new TypeError("encoding must be a string");
                                if ("string" == typeof n && !u.isEncoding(n)) throw new TypeError("Unknown encoding: " + n);
                            } else "number" == typeof t && (t &= 255);
                            if (e < 0 || this.length < e || this.length < r) throw new RangeError("Out of range index");
                            if (r <= e) return this;
                            var o;
                            if (e >>>= 0, r = void 0 === r ? this.length : r >>> 0, t || (t = 0), "number" == typeof t) for(o = e; o < r; ++o)this[o] = t;
                            else {
                                var a = u.isBuffer(t) ? t : q(new u(t, n).toString()), s = a.length;
                                for(o = 0; o < r - e; ++o)this[o + e] = a[o % s];
                            }
                            return this;
                        };
                        var R = /[^+\/0-9A-Za-z-_]/g;
                        function L(t) {
                            return t < 16 ? "0" + t.toString(16) : t.toString(16);
                        }
                        function q(t, e) {
                            var r;
                            e = e || 1 / 0;
                            for(var n = t.length, i = null, o = [], a = 0; a < n; ++a){
                                if ((r = t.charCodeAt(a)) > 55295 && r < 57344) {
                                    if (!i) {
                                        if (r > 56319) {
                                            (e -= 3) > -1 && o.push(239, 191, 189);
                                            continue;
                                        }
                                        if (a + 1 === n) {
                                            (e -= 3) > -1 && o.push(239, 191, 189);
                                            continue;
                                        }
                                        i = r;
                                        continue;
                                    }
                                    if (r < 56320) {
                                        (e -= 3) > -1 && o.push(239, 191, 189), i = r;
                                        continue;
                                    }
                                    r = 65536 + (i - 55296 << 10 | r - 56320);
                                } else i && (e -= 3) > -1 && o.push(239, 191, 189);
                                if (i = null, r < 128) {
                                    if ((e -= 1) < 0) break;
                                    o.push(r);
                                } else if (r < 2048) {
                                    if ((e -= 2) < 0) break;
                                    o.push(r >> 6 | 192, 63 & r | 128);
                                } else if (r < 65536) {
                                    if ((e -= 3) < 0) break;
                                    o.push(r >> 12 | 224, r >> 6 & 63 | 128, 63 & r | 128);
                                } else {
                                    if (!(r < 1114112)) throw new Error("Invalid code point");
                                    if ((e -= 4) < 0) break;
                                    o.push(r >> 18 | 240, r >> 12 & 63 | 128, r >> 6 & 63 | 128, 63 & r | 128);
                                }
                            }
                            return o;
                        }
                        function U(t) {
                            return n.toByteArray(function(t) {
                                if ((t = (function(t) {
                                    return t.trim ? t.trim() : t.replace(/^\s+|\s+$/g, "");
                                })(t).replace(R, "")).length < 2) return "";
                                for(; t.length % 4 != 0;)t += "=";
                                return t;
                            }(t));
                        }
                        function z(t, e, r, n) {
                            for(var i = 0; i < n && !(i + r >= e.length || i >= t.length); ++i)e[i + r] = t[i];
                            return i;
                        }
                    }).call(this, r(3));
                },
                function(t, e) {
                    var r, n, i = t.exports = {};
                    function o() {
                        throw new Error("setTimeout has not been defined");
                    }
                    function a() {
                        throw new Error("clearTimeout has not been defined");
                    }
                    function s(t) {
                        if (r === setTimeout) return setTimeout(t, 0);
                        if ((r === o || !r) && setTimeout) return r = setTimeout, setTimeout(t, 0);
                        try {
                            return r(t, 0);
                        } catch (e) {
                            try {
                                return r.call(null, t, 0);
                            } catch (e) {
                                return r.call(this, t, 0);
                            }
                        }
                    }
                    !function() {
                        try {
                            r = "function" == typeof setTimeout ? setTimeout : o;
                        } catch (t) {
                            r = o;
                        }
                        try {
                            n = "function" == typeof clearTimeout ? clearTimeout : a;
                        } catch (t) {
                            n = a;
                        }
                    }();
                    var u, l = [], c = !1, f = -1;
                    function h() {
                        c && u && (c = !1, u.length ? l = u.concat(l) : f = -1, l.length && p());
                    }
                    function p() {
                        if (!c) {
                            var t = s(h);
                            c = !0;
                            for(var e = l.length; e;){
                                for(u = l, l = []; ++f < e;)u && u[f].run();
                                f = -1, e = l.length;
                            }
                            u = null, c = !1, function(t) {
                                if (n === clearTimeout) return clearTimeout(t);
                                if ((n === a || !n) && clearTimeout) return n = clearTimeout, clearTimeout(t);
                                try {
                                    n(t);
                                } catch (e) {
                                    try {
                                        return n.call(null, t);
                                    } catch (e) {
                                        return n.call(this, t);
                                    }
                                }
                            }(t);
                        }
                    }
                    function d(t, e) {
                        this.fun = t, this.array = e;
                    }
                    function m() {}
                    i.nextTick = function(t) {
                        var e = new Array(arguments.length - 1);
                        if (arguments.length > 1) for(var r = 1; r < arguments.length; r++)e[r - 1] = arguments[r];
                        l.push(new d(t, e)), 1 !== l.length || c || s(p);
                    }, d.prototype.run = function() {
                        this.fun.apply(null, this.array);
                    }, i.title = "browser", i.browser = !0, i.env = {}, i.argv = [], i.version = "", i.versions = {}, i.on = m, i.addListener = m, i.once = m, i.off = m, i.removeListener = m, i.removeAllListeners = m, i.emit = m, i.prependListener = m, i.prependOnceListener = m, i.listeners = function(t) {
                        return [];
                    }, i.binding = function(t) {
                        throw new Error("process.binding is not supported");
                    }, i.cwd = function() {
                        return "/";
                    }, i.chdir = function(t) {
                        throw new Error("process.chdir is not supported");
                    }, i.umask = function() {
                        return 0;
                    };
                },
                function(t, e, r) {
                    "use strict";
                    const { MAX_SAFE_INTEGER_LENGTH: n } = r(30);
                    function i(t, e) {
                        const r = t.length, i = e.length, o = t.indexOf("."), a = e.indexOf("."), s = -1 === o ? r : o, u = -1 === a ? i : a;
                        if (-1 === o && -1 === a && r < n && i < n) return (Number(t) + Number(e)).toFixed();
                        const l = s - u;
                        let c = Math.max(s, u), f = Math.max(r - s - 1, i - u - 1), h = l < 0 ? -1 * l : 0, p = l <= 0 ? 0 : l, d = c + 1 + f - 1, m = "", y = 0, g = d;
                        if (f > 0) {
                            for(; g > d - f;){
                                const r = t[g - h] || "0", n = e[g - p] || "0";
                                let i = Number(r) + Number(n) + y;
                                i >= 10 ? (i -= 10, y = 1) : y = 0, "" === m && 0 === i || (m = i + m), g--;
                            }
                            m && (m = "." + m), g--;
                        }
                        if (c > 0) for(; g >= 0;){
                            const r = t[g - h] || "0", n = e[g - p] || "0";
                            let i = Number(r) + Number(n) + y;
                            i >= 10 ? (i -= 10, y = 1) : y = 0, m = i + m, g--;
                        }
                        return 1 === y && (m = y + m), "." === m[0] && (m = "0" + m), m;
                    }
                    t.exports = i, t.exports.default = i;
                },
                function(t, e) {
                    "function" == typeof Object.create ? t.exports = function(t, e) {
                        e && (t.super_ = e, t.prototype = Object.create(e.prototype, {
                            constructor: {
                                value: t,
                                enumerable: !1,
                                writable: !0,
                                configurable: !0
                            }
                        }));
                    } : t.exports = function(t, e) {
                        if (e) {
                            t.super_ = e;
                            var r = function() {};
                            r.prototype = e.prototype, t.prototype = new r, t.prototype.constructor = t;
                        }
                    };
                },
                function(t, e, r) {
                    "use strict";
                    function n(t) {
                        return /^[-+]?0(\.0+)?(e[\.\d]+)?$/.test(t);
                    }
                    t.exports = n, t.exports.default = n;
                },
                function(t, e, r) {
                    (function(n) {
                        e.formatArgs = function(e) {
                            if (e[0] = (this.useColors ? "%c" : "") + this.namespace + (this.useColors ? " %c" : " ") + e[0] + (this.useColors ? "%c " : " ") + "+" + t.exports.humanize(this.diff), !this.useColors) return;
                            const r = "color: " + this.color;
                            e.splice(1, 0, r, "color: inherit");
                            let n = 0, i = 0;
                            e[0].replace(/%[a-zA-Z%]/g, (t)=>{
                                "%%" !== t && (n++, "%c" === t && (i = n));
                            }), e.splice(i, 0, r);
                        }, e.save = function(t) {
                            try {
                                t ? e.storage.setItem("debug", t) : e.storage.removeItem("debug");
                            } catch (t) {}
                        }, e.load = function() {
                            let t;
                            try {
                                t = e.storage.getItem("debug");
                            } catch (t) {}
                            return !t && void 0 !== n && "env" in n && (t = n.env.DEBUG), t;
                        }, e.useColors = function() {
                            return !("undefined" == typeof window || !window.process || "renderer" !== window.process.type && !window.process.__nwjs) || ("undefined" == typeof navigator || !navigator.userAgent || !navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) && ("undefined" != typeof document && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || "undefined" != typeof window && window.console && (window.console.firebug || window.console.exception && window.console.table) || "undefined" != typeof navigator && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 || "undefined" != typeof navigator && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
                        }, e.storage = function() {
                            try {
                                return localStorage;
                            } catch (t) {}
                        }(), e.destroy = (()=>{
                            let t = !1;
                            return ()=>{
                                t || (t = !0, console.warn("Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`."));
                            };
                        })(), e.colors = [
                            "#0000CC",
                            "#0000FF",
                            "#0033CC",
                            "#0033FF",
                            "#0066CC",
                            "#0066FF",
                            "#0099CC",
                            "#0099FF",
                            "#00CC00",
                            "#00CC33",
                            "#00CC66",
                            "#00CC99",
                            "#00CCCC",
                            "#00CCFF",
                            "#3300CC",
                            "#3300FF",
                            "#3333CC",
                            "#3333FF",
                            "#3366CC",
                            "#3366FF",
                            "#3399CC",
                            "#3399FF",
                            "#33CC00",
                            "#33CC33",
                            "#33CC66",
                            "#33CC99",
                            "#33CCCC",
                            "#33CCFF",
                            "#6600CC",
                            "#6600FF",
                            "#6633CC",
                            "#6633FF",
                            "#66CC00",
                            "#66CC33",
                            "#9900CC",
                            "#9900FF",
                            "#9933CC",
                            "#9933FF",
                            "#99CC00",
                            "#99CC33",
                            "#CC0000",
                            "#CC0033",
                            "#CC0066",
                            "#CC0099",
                            "#CC00CC",
                            "#CC00FF",
                            "#CC3300",
                            "#CC3333",
                            "#CC3366",
                            "#CC3399",
                            "#CC33CC",
                            "#CC33FF",
                            "#CC6600",
                            "#CC6633",
                            "#CC9900",
                            "#CC9933",
                            "#CCCC00",
                            "#CCCC33",
                            "#FF0000",
                            "#FF0033",
                            "#FF0066",
                            "#FF0099",
                            "#FF00CC",
                            "#FF00FF",
                            "#FF3300",
                            "#FF3333",
                            "#FF3366",
                            "#FF3399",
                            "#FF33CC",
                            "#FF33FF",
                            "#FF6600",
                            "#FF6633",
                            "#FF9900",
                            "#FF9933",
                            "#FFCC00",
                            "#FFCC33"
                        ], e.log = console.debug || console.log || (()=>{}), t.exports = r(134)(e);
                        const { formatters: i } = t.exports;
                        i.j = function(t) {
                            try {
                                return JSON.stringify(t);
                            } catch (t) {
                                return "[UnexpectedJSONParseError]: " + t.message;
                            }
                        };
                    }).call(this, r(8));
                },
                function(t, e, r) {
                    "use strict";
                    r.d(e, "a", function() {
                        return a;
                    }), r.d(e, "b", function() {
                        return s;
                    });
                    const n = (t)=>Object.assign(Error(t.message), {
                            name: t.name,
                            stack: t.stack
                        }), i = (t)=>({
                            __error_marker: "$$error",
                            message: t.message,
                            name: t.name,
                            stack: t.stack
                        });
                    let o = {
                        deserialize (t) {
                            var e;
                            return (e = t) && "object" == typeof e && "__error_marker" in e && "$$error" === e.__error_marker ? n(t) : t;
                        },
                        serialize: (t)=>t instanceof Error ? i(t) : t
                    };
                    function a(t) {
                        return o.deserialize(t);
                    }
                    function s(t) {
                        return o.serialize(t);
                    }
                },
                function(t, e, r) {
                    "use strict";
                    var n = r(28), i = Object.keys || function(t) {
                        var e = [];
                        for(var r in t)e.push(r);
                        return e;
                    };
                    t.exports = f;
                    var o = Object.create(r(21));
                    o.inherits = r(10);
                    var a = r(61), s = r(65);
                    o.inherits(f, a);
                    for(var u = i(s.prototype), l = 0; l < u.length; l++){
                        var c = u[l];
                        f.prototype[c] || (f.prototype[c] = s.prototype[c]);
                    }
                    function f(t) {
                        if (!(this instanceof f)) return new f(t);
                        a.call(this, t), s.call(this, t), t && !1 === t.readable && (this.readable = !1), t && !1 === t.writable && (this.writable = !1), this.allowHalfOpen = !0, t && !1 === t.allowHalfOpen && (this.allowHalfOpen = !1), this.once("end", h);
                    }
                    function h() {
                        this.allowHalfOpen || this._writableState.ended || n.nextTick(p, this);
                    }
                    function p(t) {
                        t.end();
                    }
                    Object.defineProperty(f.prototype, "writableHighWaterMark", {
                        enumerable: !1,
                        get: function() {
                            return this._writableState.highWaterMark;
                        }
                    }), Object.defineProperty(f.prototype, "destroyed", {
                        get: function() {
                            return void 0 !== this._readableState && void 0 !== this._writableState && this._readableState.destroyed && this._writableState.destroyed;
                        },
                        set: function(t) {
                            void 0 !== this._readableState && void 0 !== this._writableState && (this._readableState.destroyed = t, this._writableState.destroyed = t);
                        }
                    }), f.prototype._destroy = function(t, e) {
                        this.push(null), this.end(), n.nextTick(e, t);
                    };
                },
                function(t, e, r) {
                    "use strict";
                    function n(t) {
                        return !!t.match(/^(|-|\+)inf(inity)?$/i);
                    }
                    t.exports = n, t.exports.default = n;
                },
                function(t, e, r) {
                    "use strict";
                    const n = r(0), i = r(15);
                    function o(t) {
                        return !i(t) && !(t = n(t)).includes(".") && !t.includes("/");
                    }
                    t.exports = o, t.exports.default = o;
                },
                function(t, e, r) {
                    "use strict";
                    const n = r(4), i = r(0), o = r(5), a = r(48), s = r(36);
                    function u(t, { max_decimal_digits: e } = {}) {
                        let r = i(t[0]), u = n(r), l = "-" === r[0] ? "-" : "";
                        const c = t.length;
                        for(let e = 1; e < c; e++){
                            const s = i(t[e]), c = "-" === s[0] ? "-" : "", f = n(s);
                            l = l !== c ? "-" : "", u = "<" === o(u, f) ? a(f, u) : a(u, f), r = l + u;
                        }
                        return "number" == typeof e && (r = s(r, {
                            digits: e
                        })), r;
                    }
                    t.exports = u, t.exports.default = u;
                },
                function(t, e, r) {
                    const n = r(184);
                    t.exports = function(t) {
                        return "+" === t[0] && (t = t.substring(1)), (t = (t = n(t)).replace(/^0+(?=\d)/, "")).includes(".") && (t = t.replace(/\.?0+$/, "")), "" === t && (t = "0"), t;
                    };
                },
                function(t, e, r) {
                    "use strict";
                    let n;
                    function i() {
                        return n || (n = function() {
                            try {
                                throw new Error;
                            } catch (t) {
                                const e = ("" + t.stack).match(/(https?|file|ftp|chrome-extension|moz-extension):\/\/[^)\n]+/g);
                                if (e) return ("" + e[0]).replace(/^((?:https?|file|ftp|chrome-extension|moz-extension):\/\/.+)?\/[^/]+(?:\?.*)?$/, "$1") + "/";
                            }
                            return "/";
                        }()), n;
                    }
                    r.d(e, "a", function() {
                        return o;
                    }), r.d(e, "b", function() {
                        return l;
                    });
                    const o = "undefined" != typeof navigator && navigator.hardwareConcurrency ? navigator.hardwareConcurrency : 4, a = (t)=>/^[a-zA-Z][a-zA-Z\d+\-.]*:/.test(t);
                    function s(t) {
                        const e = new Blob([
                            t
                        ], {
                            type: "application/javascript"
                        });
                        return URL.createObjectURL(e);
                    }
                    let u;
                    function l() {
                        return u || (u = function() {
                            if ("undefined" == typeof Worker) return class {
                                constructor(){
                                    throw Error("No web worker implementation available. You might have tried to spawn a worker within a worker in a browser that doesn't support workers in workers.");
                                }
                            };
                            class t extends Worker {
                                constructor(t, e){
                                    var r, n;
                                    "string" == typeof t && e && e._baseURL ? t = new URL(t, e._baseURL) : "string" == typeof t && !a(t) && i().match(/^file:\/\//i) && (t = new URL(t, i().replace(/\/[^\/]+$/, "/")), (null === (r = null == e ? void 0 : e.CORSWorkaround) || void 0 === r || r) && (t = s(`importScripts(${JSON.stringify(t)});`))), "string" == typeof t && a(t) && (null === (n = null == e ? void 0 : e.CORSWorkaround) || void 0 === n || n) && (t = s(`importScripts(${JSON.stringify(t)});`)), super(t, e);
                                }
                            }
                            class e extends t {
                                constructor(t, e){
                                    super(window.URL.createObjectURL(t), e);
                                }
                                static fromText(t, r) {
                                    const n = new window.Blob([
                                        t
                                    ], {
                                        type: "text/javascript"
                                    });
                                    return new e(n, r);
                                }
                            }
                            return {
                                blob: e,
                                default: t
                            };
                        }()), u;
                    }
                },
                function(t, e, r) {
                    "use strict";
                    var n, i;
                    r.d(e, "a", function() {
                        return n;
                    }), r.d(e, "b", function() {
                        return i;
                    }), function(t) {
                        t.cancel = "cancel", t.run = "run";
                    }(n || (n = {})), function(t) {
                        t.error = "error", t.init = "init", t.result = "result", t.running = "running", t.uncaughtError = "uncaughtError";
                    }(i || (i = {}));
                },
                function(t, e, r) {
                    function n(t) {
                        return Object.prototype.toString.call(t);
                    }
                    e.isArray = function(t) {
                        return Array.isArray ? Array.isArray(t) : "[object Array]" === n(t);
                    }, e.isBoolean = function(t) {
                        return "boolean" == typeof t;
                    }, e.isNull = function(t) {
                        return null === t;
                    }, e.isNullOrUndefined = function(t) {
                        return null == t;
                    }, e.isNumber = function(t) {
                        return "number" == typeof t;
                    }, e.isString = function(t) {
                        return "string" == typeof t;
                    }, e.isSymbol = function(t) {
                        return "symbol" == typeof t;
                    }, e.isUndefined = function(t) {
                        return void 0 === t;
                    }, e.isRegExp = function(t) {
                        return "[object RegExp]" === n(t);
                    }, e.isObject = function(t) {
                        return "object" == typeof t && null !== t;
                    }, e.isDate = function(t) {
                        return "[object Date]" === n(t);
                    }, e.isError = function(t) {
                        return "[object Error]" === n(t) || t instanceof Error;
                    }, e.isFunction = function(t) {
                        return "function" == typeof t;
                    }, e.isPrimitive = function(t) {
                        return null === t || "boolean" == typeof t || "number" == typeof t || "string" == typeof t || "symbol" == typeof t || void 0 === t;
                    }, e.isBuffer = r(7).Buffer.isBuffer;
                },
                function(t, e, r) {
                    "use strict";
                    const n = r(11), i = r(50);
                    function o(t) {
                        return n(t) ? "" : i(t);
                    }
                    t.exports = o, t.exports.default = o;
                },
                function(t, e, r) {
                    "use strict";
                    const n = r(35);
                    function i(t, e) {
                        return n(t, "2", e);
                    }
                    t.exports = i, t.exports.default = i;
                },
                function(t, e, r) {
                    "use strict";
                    r.d(e, "a", function() {
                        return o;
                    });
                    var n = r(2);
                    function i(t) {
                        throw Error(t);
                    }
                    const o = {
                        errors: (t)=>t[n.a] || i("Error observable not found. Make sure to pass a thread instance as returned by the spawn() promise."),
                        events: (t)=>t[n.b] || i("Events observable not found. Make sure to pass a thread instance as returned by the spawn() promise."),
                        terminate: (t)=>t[n.c]()
                    };
                },
                function(t, e) {},
                function(t, e, r) {
                    "use strict";
                    const n = ()=>"function" == typeof Symbol, i = (t)=>n() && Boolean(Symbol[t]), o = (t)=>i(t) ? Symbol[t] : "@@" + t;
                    i("asyncIterator") || (Symbol.asyncIterator = Symbol.asyncIterator || Symbol.for("Symbol.asyncIterator"));
                    const a = o("iterator"), s = o("observable"), u = o("species");
                    function l(t, e) {
                        const r = t[e];
                        if (null != r) {
                            if ("function" != typeof r) throw new TypeError(r + " is not a function");
                            return r;
                        }
                    }
                    function c(t) {
                        let e = t.constructor;
                        return void 0 !== e && (e = e[u], null === e && (e = void 0)), void 0 !== e ? e : b;
                    }
                    function f(t) {
                        f.log ? f.log(t) : setTimeout(()=>{
                            throw t;
                        }, 0);
                    }
                    function h(t) {
                        Promise.resolve().then(()=>{
                            try {
                                t();
                            } catch (t) {
                                f(t);
                            }
                        });
                    }
                    function p(t) {
                        const e = t._cleanup;
                        if (void 0 !== e && (t._cleanup = void 0, e)) try {
                            if ("function" == typeof e) e();
                            else {
                                const t = l(e, "unsubscribe");
                                t && t.call(e);
                            }
                        } catch (t) {
                            f(t);
                        }
                    }
                    function d(t) {
                        t._observer = void 0, t._queue = void 0, t._state = "closed";
                    }
                    function m(t, e, r) {
                        t._state = "running";
                        const n = t._observer;
                        try {
                            const i = n ? l(n, e) : void 0;
                            switch(e){
                                case "next":
                                    i && i.call(n, r);
                                    break;
                                case "error":
                                    if (d(t), !i) throw r;
                                    i.call(n, r);
                                    break;
                                case "complete":
                                    d(t), i && i.call(n);
                            }
                        } catch (t) {
                            f(t);
                        }
                        "closed" === t._state ? p(t) : "running" === t._state && (t._state = "ready");
                    }
                    function y(t, e, r) {
                        if ("closed" !== t._state) return "buffering" === t._state ? (t._queue = t._queue || [], void t._queue.push({
                            type: e,
                            value: r
                        })) : "ready" !== t._state ? (t._state = "buffering", t._queue = [
                            {
                                type: e,
                                value: r
                            }
                        ], void h(()=>(function(t) {
                                const e = t._queue;
                                if (e) {
                                    t._queue = void 0, t._state = "ready";
                                    for (const r of e)if (m(t, r.type, r.value), "closed" === t._state) break;
                                }
                            })(t))) : void m(t, e, r);
                    }
                    class g {
                        constructor(t, e){
                            this._cleanup = void 0, this._observer = t, this._queue = void 0, this._state = "initializing";
                            const r = new v(this);
                            try {
                                this._cleanup = e.call(void 0, r);
                            } catch (t) {
                                r.error(t);
                            }
                            "initializing" === this._state && (this._state = "ready");
                        }
                        get closed() {
                            return "closed" === this._state;
                        }
                        unsubscribe() {
                            "closed" !== this._state && (d(this), p(this));
                        }
                    }
                    class v {
                        constructor(t){
                            this._subscription = t;
                        }
                        get closed() {
                            return "closed" === this._subscription._state;
                        }
                        next(t) {
                            y(this._subscription, "next", t);
                        }
                        error(t) {
                            y(this._subscription, "error", t);
                        }
                        complete() {
                            y(this._subscription, "complete");
                        }
                    }
                    class b {
                        constructor(t){
                            if (!(this instanceof b)) throw new TypeError("Observable cannot be called as a function");
                            if ("function" != typeof t) throw new TypeError("Observable initializer must be a function");
                            this._subscriber = t;
                        }
                        subscribe(t, e, r) {
                            return "object" == typeof t && null !== t || (t = {
                                next: t,
                                error: e,
                                complete: r
                            }), new g(t, this._subscriber);
                        }
                        pipe(t, ...e) {
                            let r = this;
                            for (const n of [
                                t,
                                ...e
                            ])r = n(r);
                            return r;
                        }
                        tap(t, e, r) {
                            const n = "object" != typeof t || null === t ? {
                                next: t,
                                error: e,
                                complete: r
                            } : t;
                            return new b((t)=>this.subscribe({
                                    next (e) {
                                        n.next && n.next(e), t.next(e);
                                    },
                                    error (e) {
                                        n.error && n.error(e), t.error(e);
                                    },
                                    complete () {
                                        n.complete && n.complete(), t.complete();
                                    },
                                    start (t) {
                                        n.start && n.start(t);
                                    }
                                }));
                        }
                        forEach(t) {
                            return new Promise((e, r)=>{
                                if ("function" != typeof t) return void r(new TypeError(t + " is not a function"));
                                function n() {
                                    i.unsubscribe(), e(void 0);
                                }
                                const i = this.subscribe({
                                    next (e) {
                                        try {
                                            t(e, n);
                                        } catch (t) {
                                            r(t), i.unsubscribe();
                                        }
                                    },
                                    error (t) {
                                        r(t);
                                    },
                                    complete () {
                                        e(void 0);
                                    }
                                });
                            });
                        }
                        map(t) {
                            if ("function" != typeof t) throw new TypeError(t + " is not a function");
                            return new (c(this))((e)=>this.subscribe({
                                    next (r) {
                                        let n = r;
                                        try {
                                            n = t(r);
                                        } catch (t) {
                                            return e.error(t);
                                        }
                                        e.next(n);
                                    },
                                    error (t) {
                                        e.error(t);
                                    },
                                    complete () {
                                        e.complete();
                                    }
                                }));
                        }
                        filter(t) {
                            if ("function" != typeof t) throw new TypeError(t + " is not a function");
                            return new (c(this))((e)=>this.subscribe({
                                    next (r) {
                                        try {
                                            if (!t(r)) return;
                                        } catch (t) {
                                            return e.error(t);
                                        }
                                        e.next(r);
                                    },
                                    error (t) {
                                        e.error(t);
                                    },
                                    complete () {
                                        e.complete();
                                    }
                                }));
                        }
                        reduce(t, e) {
                            if ("function" != typeof t) throw new TypeError(t + " is not a function");
                            const r = c(this), n = arguments.length > 1;
                            let i = !1, o = e;
                            return new r((e)=>this.subscribe({
                                    next (r) {
                                        const a = !i;
                                        if (i = !0, !a || n) try {
                                            o = t(o, r);
                                        } catch (t) {
                                            return e.error(t);
                                        }
                                        else o = r;
                                    },
                                    error (t) {
                                        e.error(t);
                                    },
                                    complete () {
                                        if (!i && !n) return e.error(new TypeError("Cannot reduce an empty sequence"));
                                        e.next(o), e.complete();
                                    }
                                }));
                        }
                        concat(...t) {
                            const e = c(this);
                            return new e((r)=>{
                                let n, i = 0;
                                return function o(a) {
                                    n = a.subscribe({
                                        next (t) {
                                            r.next(t);
                                        },
                                        error (t) {
                                            r.error(t);
                                        },
                                        complete () {
                                            i === t.length ? (n = void 0, r.complete()) : o(e.from(t[i++]));
                                        }
                                    });
                                }(this), ()=>{
                                    n && (n.unsubscribe(), n = void 0);
                                };
                            });
                        }
                        flatMap(t) {
                            if ("function" != typeof t) throw new TypeError(t + " is not a function");
                            const e = c(this);
                            return new e((r)=>{
                                const n = [], i = this.subscribe({
                                    next (i) {
                                        let a;
                                        if (t) try {
                                            a = t(i);
                                        } catch (t) {
                                            return r.error(t);
                                        }
                                        else a = i;
                                        const s = e.from(a).subscribe({
                                            next (t) {
                                                r.next(t);
                                            },
                                            error (t) {
                                                r.error(t);
                                            },
                                            complete () {
                                                const t = n.indexOf(s);
                                                t >= 0 && n.splice(t, 1), o();
                                            }
                                        });
                                        n.push(s);
                                    },
                                    error (t) {
                                        r.error(t);
                                    },
                                    complete () {
                                        o();
                                    }
                                });
                                function o() {
                                    i.closed && 0 === n.length && r.complete();
                                }
                                return ()=>{
                                    n.forEach((t)=>t.unsubscribe()), i.unsubscribe();
                                };
                            });
                        }
                        [(Symbol.observable, s)]() {
                            return this;
                        }
                        static from(t) {
                            const e = "function" == typeof this ? this : b;
                            if (null == t) throw new TypeError(t + " is not an object");
                            const r = l(t, s);
                            if (r) {
                                const n = r.call(t);
                                if (Object(n) !== n) throw new TypeError(n + " is not an object");
                                return function(t) {
                                    return t instanceof b;
                                }(n) && n.constructor === e ? n : new e((t)=>n.subscribe(t));
                            }
                            if (i("iterator")) {
                                const r = l(t, a);
                                if (r) return new e((e)=>{
                                    h(()=>{
                                        if (!e.closed) {
                                            for (const n of r.call(t))if (e.next(n), e.closed) return;
                                            e.complete();
                                        }
                                    });
                                });
                            }
                            if (Array.isArray(t)) return new e((e)=>{
                                h(()=>{
                                    if (!e.closed) {
                                        for (const r of t)if (e.next(r), e.closed) return;
                                        e.complete();
                                    }
                                });
                            });
                            throw new TypeError(t + " is not observable");
                        }
                        static of(...t) {
                            return new ("function" == typeof this ? this : b)((e)=>{
                                h(()=>{
                                    if (!e.closed) {
                                        for (const r of t)if (e.next(r), e.closed) return;
                                        e.complete();
                                    }
                                });
                            });
                        }
                        static get [u]() {
                            return this;
                        }
                    }
                    n() && Object.defineProperty(b, Symbol("extensions"), {
                        value: {
                            symbol: s,
                            hostReportError: f
                        },
                        configurable: !0
                    }), e.a = b;
                },
                function(t, e, r) {
                    "use strict";
                    var n;
                    r.d(e, "a", function() {
                        return n;
                    }), function(t) {
                        t.internalError = "internalError", t.message = "message", t.termination = "termination";
                    }(n || (n = {}));
                },
                function(t, e, r) {
                    "use strict";
                    (function(e) {
                        void 0 === e || !e.version || 0 === e.version.indexOf("v0.") || 0 === e.version.indexOf("v1.") && 0 !== e.version.indexOf("v1.8.") ? t.exports = {
                            nextTick: function(t, r, n, i) {
                                if ("function" != typeof t) throw new TypeError('"callback" argument must be a function');
                                var o, a, s = arguments.length;
                                switch(s){
                                    case 0:
                                    case 1:
                                        return e.nextTick(t);
                                    case 2:
                                        return e.nextTick(function() {
                                            t.call(null, r);
                                        });
                                    case 3:
                                        return e.nextTick(function() {
                                            t.call(null, r, n);
                                        });
                                    case 4:
                                        return e.nextTick(function() {
                                            t.call(null, r, n, i);
                                        });
                                    default:
                                        for(o = new Array(s - 1), a = 0; a < o.length;)o[a++] = arguments[a];
                                        return e.nextTick(function() {
                                            t.apply(null, o);
                                        });
                                }
                            }
                        } : t.exports = e;
                    }).call(this, r(8));
                },
                function(t, e, r) {
                    "use strict";
                    var n = "undefined" != typeof Uint8Array && "undefined" != typeof Uint16Array && "undefined" != typeof Int32Array;
                    function i(t, e) {
                        return Object.prototype.hasOwnProperty.call(t, e);
                    }
                    e.assign = function(t) {
                        for(var e = Array.prototype.slice.call(arguments, 1); e.length;){
                            var r = e.shift();
                            if (r) {
                                if ("object" != typeof r) throw new TypeError(r + "must be non-object");
                                for(var n in r)i(r, n) && (t[n] = r[n]);
                            }
                        }
                        return t;
                    }, e.shrinkBuf = function(t, e) {
                        return t.length === e ? t : t.subarray ? t.subarray(0, e) : (t.length = e, t);
                    };
                    var o = {
                        arraySet: function(t, e, r, n, i) {
                            if (e.subarray && t.subarray) t.set(e.subarray(r, r + n), i);
                            else for(var o = 0; o < n; o++)t[i + o] = e[r + o];
                        },
                        flattenChunks: function(t) {
                            var e, r, n, i, o, a;
                            for(n = 0, e = 0, r = t.length; e < r; e++)n += t[e].length;
                            for(a = new Uint8Array(n), i = 0, e = 0, r = t.length; e < r; e++)o = t[e], a.set(o, i), i += o.length;
                            return a;
                        }
                    }, a = {
                        arraySet: function(t, e, r, n, i) {
                            for(var o = 0; o < n; o++)t[i + o] = e[r + o];
                        },
                        flattenChunks: function(t) {
                            return [].concat.apply([], t);
                        }
                    };
                    e.setTyped = function(t) {
                        t ? (e.Buf8 = Uint8Array, e.Buf16 = Uint16Array, e.Buf32 = Int32Array, e.assign(e, o)) : (e.Buf8 = Array, e.Buf16 = Array, e.Buf32 = Array, e.assign(e, a));
                    }, e.setTyped(n);
                },
                function(t, e, r) {
                    "use strict";
                    const { MAX_SAFE_INTEGER: n } = r(74), i = n.toString().length - 1;
                    t.exports = {
                        MAX_SAFE_INTEGER_LENGTH: i
                    };
                },
                function(t, e, r) {
                    "use strict";
                    const { MAX_SAFE_INTEGER_LENGTH: n } = r(30);
                    function i(t, e) {
                        const r = t.length, i = e.length, o = t.indexOf("."), a = e.indexOf("."), s = -1 === o ? r : o, u = -1 === a ? i : a;
                        if (-1 === o && -1 === a && r < n && i < n) return (Number(t) - Number(e)).toFixed();
                        const l = s - u;
                        let c = Math.max(s, u), f = Math.max(r - s - 1, i - u - 1), h = l < 0 ? -1 * l : 0, p = l <= 0 ? 0 : l, d = c + 1 + f - 1, m = "", y = 0, g = d;
                        if (f > 0) {
                            for(; g > d - f;){
                                let r = t[g - h] || "0", n = e[g - p] || "0";
                                r -= y, y = 0;
                                let i = r - n;
                                if (i < 0) for(; i < 0;)y++, i += 10;
                                else y && y--;
                                "" === m && 0 === i || (m = i + m), g--;
                            }
                            "" !== m && (m = "." + m), g--;
                        }
                        if (c > 0) {
                            for(; g > 0;){
                                let r = t[g - h] || "0", n = e[g - p] || "0";
                                r -= y, y = 0;
                                let i = r - n;
                                if (i < 0) for(; i < 0;)y++, i += 10;
                                else y && y--;
                                m = i + m, g--;
                            }
                            const r = t[0 - h] || "0", n = e[0 - p] || "0";
                            let i = Number(r) - (y > 0 ? 1 : 0) - Number(n);
                            0 !== i && (m = i + m), m = m.replace(/^0+/, "");
                        }
                        return "." === m[0] && (m = "0" + m), m;
                    }
                    t.exports = i, t.exports.default = i;
                },
                function(t, e, r) {
                    "use strict";
                    const n = r(5), i = r(6), o = r(33), a = r(49);
                    function s(t, e, { format: r = "string", max_decimal_digits: s = 100, ellipsis: u = !1 } = {}) {
                        "0" === t[0] && (t = t.substring(1)), "0" === e[0] && (e = e.substring(1));
                        const l = t.indexOf("."), c = e.indexOf("."), f = -1 === l ? t.length : l, h = -1 === c ? 0 : e.length - 1 - c;
                        let p = !1;
                        t = t.replace(/\./, ""), e = e.replace(/\./, "");
                        const d = t.length;
                        let m, y = "", g = "", v = -1 * h, b = 0;
                        for(let r = 0; r < d; r++)if (y += t[r], m = n(y, e), ">" === m) {
                            let t = 1, r = i(e, e), a = e;
                            for(; ">" !== n(r, y);)t++, a = r, r = i(r, e);
                            if (t = t.toString(), "" !== g) for(let e = t.length; e <= b; e++)g += "0";
                            g += t, y = o(y, a), b = 0;
                        } else {
                            if ("<" === m) {
                                "" === g && v++, b++;
                                continue;
                            }
                            if ("=" === m) {
                                if ("" !== g) for(let t = 0; t < b; t++)g += "0";
                                g += "1", y = "0", b = 0;
                            }
                        }
                        if (y.match(/^0+$/g)) "<" === m && (g += y.substring(0, y.length - 1));
                        else {
                            const t = {}, r = f - v - g.length + s + 1;
                            "" === g && (b = 0);
                            for(let a = 0; a < r; a++){
                                if (y += "0", u) {
                                    if (y in t) {
                                        if (t[y]++, t[y] > 3) {
                                            g += "...", p = !0;
                                            break;
                                        }
                                    } else t[y] = 1;
                                }
                                const r = n(y, e);
                                if (">" === r) {
                                    let t = 1, r = i(e, e), a = e;
                                    for(; ">" !== n(r, y);)t++, a = r, r = i(r, e);
                                    t = t.toString();
                                    for(let e = t.length; e <= b; e++)g += "0";
                                    if (g += t, y = o(y, a), "0" === y) break;
                                    b = 0;
                                } else {
                                    if ("<" === r) {
                                        b++;
                                        continue;
                                    }
                                    if ("=" === r) {
                                        for(let t = 0; t < b; t++)g += "0";
                                        g += "1", b = 0;
                                        break;
                                    }
                                }
                            }
                        }
                        const x = f - v, w = g.length;
                        let _;
                        if (x === w) _ = 0;
                        else if (x < 0) g = "0." + "0".repeat(Math.abs(x)) + g, _ = w - x;
                        else if (x > w) {
                            for(let t = w; t < x; t++)g += "0";
                            _ = 0;
                        } else x < w ? (g = g.substring(0, x) + "." + g.substring(x), _ = w - x) : 0 === x && (g = "0." + g, _ = w);
                        g = g.replace(/^0+/, ""), g = g.replace(/\.\d+0+$/, "");
                        const A = _ - s;
                        return p || A > 0 && (g = a(g.substring(0, g.length - A + 1))), "." === g[0] && (g = "0" + g), "object" === r ? {
                            quotient: g,
                            extra_decimals: A
                        } : g;
                    }
                    t.exports = s, t.exports.default = s;
                },
                function(t, e, r) {
                    "use strict";
                    const n = r(0), i = r(5), o = r(15), a = r(9), s = r(31);
                    function u(t, e, { infinity_minus_infinity: r = "NaN" } = {}) {
                        t = n(t), e = n(e);
                        const u = !("-" === t[0]), l = !("-" === e[0]), c = o(t), f = o(e);
                        if (c && f) {
                            if (u === l) return r;
                            if (u) return "Infinity";
                            if (l) return "-Infinity";
                        } else {
                            if (c) return t;
                            if (f) return l ? "-Infinity" : "Infinity";
                        }
                        if (u) {
                            if (l) {
                                const r = i(t, e);
                                return ">" === r ? s(t, e) : "<" === r ? "-" + s(e, t) : "0";
                            }
                            return a(t, e.substring(1));
                        }
                        if (l) return "-" + a(t.substring(1), e);
                        {
                            t = t.substring(1), e = e.substring(1);
                            const r = i(t, e);
                            return ">" === r ? "-" + s(t, e) : "<" === r ? s(e, t) : "0";
                        }
                    }
                    t.exports = u, t.exports.default = u;
                },
                function(t, e, r) {
                    "use strict";
                    const n = r(0), i = r(5);
                    function o(t, e) {
                        t = n(t), e = n(e);
                        const r = "-" !== t[0], o = "-" !== e[0];
                        return r ? o ? i(t, e) : ">" : o ? "<" : i(e.substring(1), t.substring(1));
                    }
                    t.exports = o, t.exports.default = o;
                },
                function(t, e, r) {
                    "use strict";
                    const n = r(4), i = r(0), o = r(1), a = r(77), s = r(16), u = r(52), l = r(78), c = r(11), f = r(53), h = r(54), p = r(81), d = r(37), m = r(36), y = r(22), g = r(85);
                    function v(t, e, { zero_to_the_power_of_zero: r = "1", ellipsis: v = !1, imaginary: b = !0, max_decimal_digits: x = 100, fraction: w = !1 } = {}) {
                        t = i(t), e = i(e);
                        const _ = b && u(t);
                        _ && (t = t.replace(/i$/, ""));
                        const A = c(t), E = c(e);
                        if (A && E) return r;
                        if (E) return "1";
                        const S = y(e);
                        if (A) {
                            if ("+" === S) return "0";
                            if ("-" === S) return "Infinity";
                        }
                        const M = s(e);
                        if ("+" === S && M) {
                            let r = h(t, e);
                            return "number" == typeof x && (r = m(r, {
                                digits: x
                            })), _ && l(e) && (r += "i"), r;
                        }
                        if ("-" === S && M) {
                            const r = "1", i = h(t, n(e));
                            return o(r, i, {
                                ellipsis: v,
                                max_decimal_digits: x
                            });
                        }
                        if (!M) {
                            e = n(e);
                            let [r, i] = e.includes("/") ? e.split("/") : a(e);
                            [r, i] = g(r, i);
                            let o = d(t, i, {
                                imaginary: b
                            }), s = f(r, o);
                            return "number" == typeof x && (s = m(s, {
                                digits: x
                            })), "-" === S && (s = p(s, {
                                fraction: w,
                                max_decimal_digits: x
                            })), s;
                        }
                    }
                    t.exports = v, t.exports.default = v;
                },
                function(t, e, r) {
                    "use strict";
                    const n = r(52), i = r(164);
                    function o(t, { digits: e = 0 } = {}) {
                        return n(t) ? i(t.substring(0, t.length - 1), {
                            digits: e
                        }) + "i" : i(t, {
                            digits: e
                        });
                    }
                    t.exports = o, t.exports.default = o;
                },
                function(t, e, r) {
                    "use strict";
                    const n = r(4), i = r(0), o = r(5), a = r(82), s = r(16), u = r(80), l = r(54), c = r(83);
                    function f(t, e, { imaginary: r = !0, max_decimal_digits: f = 100 } = {}) {
                        if (t = i(t), "1" === (e = i(e))) return t;
                        if ("1" === t) return "1";
                        if (!s(e)) throw new Error("[preciso] can't find fractional roots");
                        if (u(e)) throw new Error("[preciso] can't find root of negative indexes");
                        const h = n(t), p = u(t), d = a(e), m = p && d;
                        if (m && !r) throw new Error("[preciso] root has an imaginary number");
                        const y = p && !d ? "-" : "", g = c(h, e), v = [
                            "9",
                            "8",
                            "7",
                            "6",
                            "5",
                            "4",
                            "3",
                            "2",
                            "1",
                            "0"
                        ];
                        let b = "";
                        for(let t = 0; t < g; t++)for(let r = 0; r < v.length; r++){
                            const n = b + v[r];
                            let i = n + "0".repeat(g - t - 1);
                            const a = l(i, e), s = o(a, h);
                            if ("=" === s) return m && (i += "i"), y + i;
                            if ("<" === s) {
                                b = n;
                                break;
                            }
                        }
                        let x = b + ".";
                        for(let t = 0; t < f; t++){
                            let t = !1;
                            for(let r = 0; r < v.length; r++){
                                let n = x + v[r];
                                const i = l(n, e), a = o(i, h);
                                if ("=" === a) return m && (n += "i"), y + n;
                                if ("<" === a) {
                                    x = n, t = !0;
                                    break;
                                }
                            }
                            if (!t) break;
                        }
                        return m && (x += "i"), y + x;
                    }
                    t.exports = f, t.exports.default = f;
                },
                function(t, e, r) {
                    function n(t, e) {
                        const r = t.length, n = e.length, i = t.indexOf("."), o = e.indexOf("."), a = -1 === i ? r : i, s = -1 === o ? n : o, u = a - s;
                        let l = u < 0 ? -1 * u : 0, c = u <= 0 ? 0 : u, f = Math.max(a, s) + 1 + Math.max(r - a, n - s) - 1, h = 0;
                        for(; h < f;){
                            const r = h - l, n = r === a ? "." : t[r] || "0", i = h - c, o = i === s ? "." : e[i] || "0";
                            if (n !== o) {
                                if (n > o) return ">";
                                if (n < o) return "<";
                            }
                            h++;
                        }
                        return "=";
                    }
                    r(18), t.exports = n, t.exports.default = n;
                },
                function(t, e, r) {
                    "use strict";
                    var n = r(140);
                    function i() {
                        this.protocol = null, this.slashes = null, this.auth = null, this.host = null, this.port = null, this.hostname = null, this.hash = null, this.search = null, this.query = null, this.pathname = null, this.path = null, this.href = null;
                    }
                    var o = /^([a-z0-9.+-]+:)/i, a = /:[0-9]*$/, s = /^(\/\/?(?!\/)[^?\s]*)(\?[^\s]*)?$/, u = [
                        "{",
                        "}",
                        "|",
                        "\\",
                        "^",
                        "`"
                    ].concat([
                        "<",
                        ">",
                        '"',
                        "`",
                        " ",
                        "\r",
                        "\n",
                        "	"
                    ]), l = [
                        "'"
                    ].concat(u), c = [
                        "%",
                        "/",
                        "?",
                        ";",
                        "#"
                    ].concat(l), f = [
                        "/",
                        "?",
                        "#"
                    ], h = /^[+a-z0-9A-Z_-]{0,63}$/, p = /^([+a-z0-9A-Z_-]{0,63})(.*)$/, d = {
                        javascript: !0,
                        "javascript:": !0
                    }, m = {
                        javascript: !0,
                        "javascript:": !0
                    }, y = {
                        http: !0,
                        https: !0,
                        ftp: !0,
                        gopher: !0,
                        file: !0,
                        "http:": !0,
                        "https:": !0,
                        "ftp:": !0,
                        "gopher:": !0,
                        "file:": !0
                    }, g = r(142);
                    function v(t, e, r) {
                        if (t && "object" == typeof t && t instanceof i) return t;
                        var n = new i;
                        return n.parse(t, e, r), n;
                    }
                    i.prototype.parse = function(t, e, r) {
                        if ("string" != typeof t) throw new TypeError("Parameter 'url' must be a string, not " + typeof t);
                        var i = t.indexOf("?"), a = -1 !== i && i < t.indexOf("#") ? "?" : "#", u = t.split(a);
                        u[0] = u[0].replace(/\\/g, "/");
                        var v = t = u.join(a);
                        if (v = v.trim(), !r && 1 === t.split("#").length) {
                            var b = s.exec(v);
                            if (b) return this.path = v, this.href = v, this.pathname = b[1], b[2] ? (this.search = b[2], this.query = e ? g.parse(this.search.substr(1)) : this.search.substr(1)) : e && (this.search = "", this.query = {}), this;
                        }
                        var x = o.exec(v);
                        if (x) {
                            var w = (x = x[0]).toLowerCase();
                            this.protocol = w, v = v.substr(x.length);
                        }
                        if (r || x || v.match(/^\/\/[^@/]+@[^@/]+/)) {
                            var _ = "//" === v.substr(0, 2);
                            !_ || x && m[x] || (v = v.substr(2), this.slashes = !0);
                        }
                        if (!m[x] && (_ || x && !y[x])) {
                            for(var A, E, S = -1, M = 0; M < f.length; M++)-1 !== (k = v.indexOf(f[M])) && (-1 === S || k < S) && (S = k);
                            for(-1 !== (E = -1 === S ? v.lastIndexOf("@") : v.lastIndexOf("@", S)) && (A = v.slice(0, E), v = v.slice(E + 1), this.auth = decodeURIComponent(A)), S = -1, M = 0; M < c.length; M++){
                                var k;
                                -1 !== (k = v.indexOf(c[M])) && (-1 === S || k < S) && (S = k);
                            }
                            -1 === S && (S = v.length), this.host = v.slice(0, S), v = v.slice(S), this.parseHost(), this.hostname = this.hostname || "";
                            var N = "[" === this.hostname[0] && "]" === this.hostname[this.hostname.length - 1];
                            if (!N) for(var C = this.hostname.split(/\./), D = (M = 0, C.length); M < D; M++){
                                var O = C[M];
                                if (O && !O.match(h)) {
                                    for(var T = "", F = 0, P = O.length; F < P; F++)O.charCodeAt(F) > 127 ? T += "x" : T += O[F];
                                    if (!T.match(h)) {
                                        var I = C.slice(0, M), B = C.slice(M + 1), j = O.match(p);
                                        j && (I.push(j[1]), B.unshift(j[2])), B.length && (v = "/" + B.join(".") + v), this.hostname = I.join(".");
                                        break;
                                    }
                                }
                            }
                            this.hostname.length > 255 ? this.hostname = "" : this.hostname = this.hostname.toLowerCase(), N || (this.hostname = n.toASCII(this.hostname));
                            var R = this.port ? ":" + this.port : "", L = this.hostname || "";
                            this.host = L + R, this.href += this.host, N && (this.hostname = this.hostname.substr(1, this.hostname.length - 2), "/" !== v[0] && (v = "/" + v));
                        }
                        if (!d[w]) for(M = 0, D = l.length; M < D; M++){
                            var q = l[M];
                            if (-1 !== v.indexOf(q)) {
                                var U = encodeURIComponent(q);
                                U === q && (U = escape(q)), v = v.split(q).join(U);
                            }
                        }
                        var z = v.indexOf("#");
                        -1 !== z && (this.hash = v.substr(z), v = v.slice(0, z));
                        var G = v.indexOf("?");
                        if (-1 !== G ? (this.search = v.substr(G), this.query = v.substr(G + 1), e && (this.query = g.parse(this.query)), v = v.slice(0, G)) : e && (this.search = "", this.query = {}), v && (this.pathname = v), y[w] && this.hostname && !this.pathname && (this.pathname = "/"), this.pathname || this.search) {
                            R = this.pathname || "";
                            var H = this.search || "";
                            this.path = R + H;
                        }
                        return this.href = this.format(), this;
                    }, i.prototype.format = function() {
                        var t = this.auth || "";
                        t && (t = (t = encodeURIComponent(t)).replace(/%3A/i, ":"), t += "@");
                        var e = this.protocol || "", r = this.pathname || "", n = this.hash || "", i = !1, o = "";
                        this.host ? i = t + this.host : this.hostname && (i = t + (-1 === this.hostname.indexOf(":") ? this.hostname : "[" + this.hostname + "]"), this.port && (i += ":" + this.port)), this.query && "object" == typeof this.query && Object.keys(this.query).length && (o = g.stringify(this.query));
                        var a = this.search || o && "?" + o || "";
                        return e && ":" !== e.substr(-1) && (e += ":"), this.slashes || (!e || y[e]) && !1 !== i ? (i = "//" + (i || ""), r && "/" !== r.charAt(0) && (r = "/" + r)) : i || (i = ""), n && "#" !== n.charAt(0) && (n = "#" + n), a && "?" !== a.charAt(0) && (a = "?" + a), e + i + (r = r.replace(/[?#]/g, function(t) {
                            return encodeURIComponent(t);
                        })) + (a = a.replace("#", "%23")) + n;
                    }, i.prototype.resolve = function(t) {
                        return this.resolveObject(v(t, !1, !0)).format();
                    }, i.prototype.resolveObject = function(t) {
                        if ("string" == typeof t) {
                            var e = new i;
                            e.parse(t, !1, !0), t = e;
                        }
                        for(var r = new i, n = Object.keys(this), o = 0; o < n.length; o++){
                            var a = n[o];
                            r[a] = this[a];
                        }
                        if (r.hash = t.hash, "" === t.href) return r.href = r.format(), r;
                        if (t.slashes && !t.protocol) {
                            for(var s = Object.keys(t), u = 0; u < s.length; u++){
                                var l = s[u];
                                "protocol" !== l && (r[l] = t[l]);
                            }
                            return y[r.protocol] && r.hostname && !r.pathname && (r.pathname = "/", r.path = r.pathname), r.href = r.format(), r;
                        }
                        if (t.protocol && t.protocol !== r.protocol) {
                            if (!y[t.protocol]) {
                                for(var c = Object.keys(t), f = 0; f < c.length; f++){
                                    var h = c[f];
                                    r[h] = t[h];
                                }
                                return r.href = r.format(), r;
                            }
                            if (r.protocol = t.protocol, t.host || m[t.protocol]) r.pathname = t.pathname;
                            else {
                                for(var p = (t.pathname || "").split("/"); p.length && !(t.host = p.shift()););
                                t.host || (t.host = ""), t.hostname || (t.hostname = ""), "" !== p[0] && p.unshift(""), p.length < 2 && p.unshift(""), r.pathname = p.join("/");
                            }
                            if (r.search = t.search, r.query = t.query, r.host = t.host || "", r.auth = t.auth, r.hostname = t.hostname || t.host, r.port = t.port, r.pathname || r.search) {
                                var d = r.pathname || "", g = r.search || "";
                                r.path = d + g;
                            }
                            return r.slashes = r.slashes || t.slashes, r.href = r.format(), r;
                        }
                        var v = r.pathname && "/" === r.pathname.charAt(0), b = t.host || t.pathname && "/" === t.pathname.charAt(0), x = b || v || r.host && t.pathname, w = x, _ = r.pathname && r.pathname.split("/") || [], A = (p = t.pathname && t.pathname.split("/") || [], r.protocol && !y[r.protocol]);
                        if (A && (r.hostname = "", r.port = null, r.host && ("" === _[0] ? _[0] = r.host : _.unshift(r.host)), r.host = "", t.protocol && (t.hostname = null, t.port = null, t.host && ("" === p[0] ? p[0] = t.host : p.unshift(t.host)), t.host = null), x = x && ("" === p[0] || "" === _[0])), b) r.host = t.host || "" === t.host ? t.host : r.host, r.hostname = t.hostname || "" === t.hostname ? t.hostname : r.hostname, r.search = t.search, r.query = t.query, _ = p;
                        else if (p.length) _ || (_ = []), _.pop(), _ = _.concat(p), r.search = t.search, r.query = t.query;
                        else if (null != t.search) return A && (r.host = _.shift(), r.hostname = r.host, (N = !!(r.host && r.host.indexOf("@") > 0) && r.host.split("@")) && (r.auth = N.shift(), r.hostname = N.shift(), r.host = r.hostname)), r.search = t.search, r.query = t.query, null === r.pathname && null === r.search || (r.path = (r.pathname ? r.pathname : "") + (r.search ? r.search : "")), r.href = r.format(), r;
                        if (!_.length) return r.pathname = null, r.search ? r.path = "/" + r.search : r.path = null, r.href = r.format(), r;
                        for(var E = _.slice(-1)[0], S = (r.host || t.host || _.length > 1) && ("." === E || ".." === E) || "" === E, M = 0, k = _.length; k >= 0; k--)"." === (E = _[k]) ? _.splice(k, 1) : ".." === E ? (_.splice(k, 1), M++) : M && (_.splice(k, 1), M--);
                        if (!x && !w) for(; M--; M)_.unshift("..");
                        !x || "" === _[0] || _[0] && "/" === _[0].charAt(0) || _.unshift(""), S && "/" !== _.join("/").substr(-1) && _.push("");
                        var N, C = "" === _[0] || _[0] && "/" === _[0].charAt(0);
                        return A && (r.hostname = C ? "" : _.length ? _.shift() : "", r.host = r.hostname, (N = !!(r.host && r.host.indexOf("@") > 0) && r.host.split("@")) && (r.auth = N.shift(), r.hostname = N.shift(), r.host = r.hostname)), (x = x || r.host && _.length) && !C && _.unshift(""), _.length > 0 ? r.pathname = _.join("/") : (r.pathname = null, r.path = null), null === r.pathname && null === r.search || (r.path = (r.pathname ? r.pathname : "") + (r.search ? r.search : "")), r.auth = t.auth || r.auth, r.slashes = r.slashes || t.slashes, r.href = r.format(), r;
                    }, i.prototype.parseHost = function() {
                        var t = this.host, e = a.exec(t);
                        e && (":" !== (e = e[0]) && (this.port = e.substr(1)), t = t.substr(0, t.length - e.length)), t && (this.hostname = t);
                    }, e.parse = v, e.resolve = function(t, e) {
                        return v(t, !1, !0).resolve(e);
                    }, e.resolveObject = function(t, e) {
                        return t ? v(t, !1, !0).resolveObject(e) : e;
                    }, e.format = function(t) {
                        return "string" == typeof t && (t = v(t)), t instanceof i ? t.format() : i.prototype.format.call(t);
                    }, e.Url = i;
                },
                function(t, e, r) {
                    (function(t) {
                        var n = r(136), i = r(70), o = r(138), a = r(139), s = r(39), u = e;
                        u.request = function(e, r) {
                            e = "string" == typeof e ? s.parse(e) : o(e);
                            var i = -1 === t.location.protocol.search(/^https?:$/) ? "http:" : "", a = e.protocol || i, u = e.hostname || e.host, l = e.port, c = e.path || "/";
                            u && -1 !== u.indexOf(":") && (u = "[" + u + "]"), e.url = (u ? a + "//" + u : "") + (l ? ":" + l : "") + c, e.method = (e.method || "GET").toUpperCase(), e.headers = e.headers || {};
                            var f = new n(e);
                            return r && f.on("response", r), f;
                        }, u.get = function(t, e) {
                            var r = u.request(t, e);
                            return r.end(), r;
                        }, u.ClientRequest = n, u.IncomingMessage = i.IncomingMessage, u.Agent = function() {}, u.Agent.defaultMaxSockets = 4, u.globalAgent = new u.Agent, u.STATUS_CODES = a, u.METHODS = [
                            "CHECKOUT",
                            "CONNECT",
                            "COPY",
                            "DELETE",
                            "GET",
                            "HEAD",
                            "LOCK",
                            "M-SEARCH",
                            "MERGE",
                            "MKACTIVITY",
                            "MKCOL",
                            "MOVE",
                            "NOTIFY",
                            "OPTIONS",
                            "PATCH",
                            "POST",
                            "PROPFIND",
                            "PROPPATCH",
                            "PURGE",
                            "PUT",
                            "REPORT",
                            "SEARCH",
                            "SUBSCRIBE",
                            "TRACE",
                            "UNLOCK",
                            "UNSUBSCRIBE"
                        ];
                    }).call(this, r(3));
                },
                ,
                function(t, e, r) {
                    (e = t.exports = r(61)).Stream = e, e.Readable = e, e.Writable = r(65), e.Duplex = r(14), e.Transform = r(67), e.PassThrough = r(122);
                },
                function(t, e, r) {
                    var n = r(7), i = n.Buffer;
                    function o(t, e) {
                        for(var r in t)e[r] = t[r];
                    }
                    function a(t, e, r) {
                        return i(t, e, r);
                    }
                    i.from && i.alloc && i.allocUnsafe && i.allocUnsafeSlow ? t.exports = n : (o(n, e), e.Buffer = a), o(i, a), a.from = function(t, e, r) {
                        if ("number" == typeof t) throw new TypeError("Argument must not be a number");
                        return i(t, e, r);
                    }, a.alloc = function(t, e, r) {
                        if ("number" != typeof t) throw new TypeError("Argument must be a number");
                        var n = i(t);
                        return void 0 !== e ? "string" == typeof r ? n.fill(e, r) : n.fill(e) : n.fill(0), n;
                    }, a.allocUnsafe = function(t) {
                        if ("number" != typeof t) throw new TypeError("Argument must be a number");
                        return i(t);
                    }, a.allocUnsafeSlow = function(t) {
                        if ("number" != typeof t) throw new TypeError("Argument must be a number");
                        return n.SlowBuffer(t);
                    };
                },
                function(t, e, r) {
                    "use strict";
                    var n = SyntaxError, i = Function, o = TypeError, a = function(t) {
                        try {
                            return i('"use strict"; return (' + t + ").constructor;")();
                        } catch (t) {}
                    }, s = Object.getOwnPropertyDescriptor;
                    if (s) try {
                        s({}, "");
                    } catch (t) {
                        s = null;
                    }
                    var u = function() {
                        throw new o;
                    }, l = s ? function() {
                        try {
                            return u;
                        } catch (t) {
                            try {
                                return s(arguments, "callee").get;
                            } catch (t) {
                                return u;
                            }
                        }
                    }() : u, c = r(145)(), f = r(147)(), h = Object.getPrototypeOf || (f ? function(t) {
                        return t.__proto__;
                    } : null), p = {}, d = "undefined" != typeof Uint8Array && h ? h(Uint8Array) : void 0, m = {
                        "%AggregateError%": "undefined" == typeof AggregateError ? void 0 : AggregateError,
                        "%Array%": Array,
                        "%ArrayBuffer%": "undefined" == typeof ArrayBuffer ? void 0 : ArrayBuffer,
                        "%ArrayIteratorPrototype%": c && h ? h([][Symbol.iterator]()) : void 0,
                        "%AsyncFromSyncIteratorPrototype%": void 0,
                        "%AsyncFunction%": p,
                        "%AsyncGenerator%": p,
                        "%AsyncGeneratorFunction%": p,
                        "%AsyncIteratorPrototype%": p,
                        "%Atomics%": "undefined" == typeof Atomics ? void 0 : Atomics,
                        "%BigInt%": "undefined" == typeof BigInt ? void 0 : BigInt,
                        "%BigInt64Array%": "undefined" == typeof BigInt64Array ? void 0 : BigInt64Array,
                        "%BigUint64Array%": "undefined" == typeof BigUint64Array ? void 0 : BigUint64Array,
                        "%Boolean%": Boolean,
                        "%DataView%": "undefined" == typeof DataView ? void 0 : DataView,
                        "%Date%": Date,
                        "%decodeURI%": decodeURI,
                        "%decodeURIComponent%": decodeURIComponent,
                        "%encodeURI%": encodeURI,
                        "%encodeURIComponent%": encodeURIComponent,
                        "%Error%": Error,
                        "%eval%": eval,
                        "%EvalError%": EvalError,
                        "%Float32Array%": "undefined" == typeof Float32Array ? void 0 : Float32Array,
                        "%Float64Array%": "undefined" == typeof Float64Array ? void 0 : Float64Array,
                        "%FinalizationRegistry%": "undefined" == typeof FinalizationRegistry ? void 0 : FinalizationRegistry,
                        "%Function%": i,
                        "%GeneratorFunction%": p,
                        "%Int8Array%": "undefined" == typeof Int8Array ? void 0 : Int8Array,
                        "%Int16Array%": "undefined" == typeof Int16Array ? void 0 : Int16Array,
                        "%Int32Array%": "undefined" == typeof Int32Array ? void 0 : Int32Array,
                        "%isFinite%": isFinite,
                        "%isNaN%": isNaN,
                        "%IteratorPrototype%": c && h ? h(h([][Symbol.iterator]())) : void 0,
                        "%JSON%": "object" == typeof JSON ? JSON : void 0,
                        "%Map%": "undefined" == typeof Map ? void 0 : Map,
                        "%MapIteratorPrototype%": "undefined" != typeof Map && c && h ? h((new Map)[Symbol.iterator]()) : void 0,
                        "%Math%": Math,
                        "%Number%": Number,
                        "%Object%": Object,
                        "%parseFloat%": parseFloat,
                        "%parseInt%": parseInt,
                        "%Promise%": "undefined" == typeof Promise ? void 0 : Promise,
                        "%Proxy%": "undefined" == typeof Proxy ? void 0 : Proxy,
                        "%RangeError%": RangeError,
                        "%ReferenceError%": ReferenceError,
                        "%Reflect%": "undefined" == typeof Reflect ? void 0 : Reflect,
                        "%RegExp%": RegExp,
                        "%Set%": "undefined" == typeof Set ? void 0 : Set,
                        "%SetIteratorPrototype%": "undefined" != typeof Set && c && h ? h((new Set)[Symbol.iterator]()) : void 0,
                        "%SharedArrayBuffer%": "undefined" == typeof SharedArrayBuffer ? void 0 : SharedArrayBuffer,
                        "%String%": String,
                        "%StringIteratorPrototype%": c && h ? h(""[Symbol.iterator]()) : void 0,
                        "%Symbol%": c ? Symbol : void 0,
                        "%SyntaxError%": n,
                        "%ThrowTypeError%": l,
                        "%TypedArray%": d,
                        "%TypeError%": o,
                        "%Uint8Array%": "undefined" == typeof Uint8Array ? void 0 : Uint8Array,
                        "%Uint8ClampedArray%": "undefined" == typeof Uint8ClampedArray ? void 0 : Uint8ClampedArray,
                        "%Uint16Array%": "undefined" == typeof Uint16Array ? void 0 : Uint16Array,
                        "%Uint32Array%": "undefined" == typeof Uint32Array ? void 0 : Uint32Array,
                        "%URIError%": URIError,
                        "%WeakMap%": "undefined" == typeof WeakMap ? void 0 : WeakMap,
                        "%WeakRef%": "undefined" == typeof WeakRef ? void 0 : WeakRef,
                        "%WeakSet%": "undefined" == typeof WeakSet ? void 0 : WeakSet
                    };
                    if (h) try {
                        null.error;
                    } catch (t) {
                        var y = h(h(t));
                        m["%Error.prototype%"] = y;
                    }
                    var g = {
                        "%ArrayBufferPrototype%": [
                            "ArrayBuffer",
                            "prototype"
                        ],
                        "%ArrayPrototype%": [
                            "Array",
                            "prototype"
                        ],
                        "%ArrayProto_entries%": [
                            "Array",
                            "prototype",
                            "entries"
                        ],
                        "%ArrayProto_forEach%": [
                            "Array",
                            "prototype",
                            "forEach"
                        ],
                        "%ArrayProto_keys%": [
                            "Array",
                            "prototype",
                            "keys"
                        ],
                        "%ArrayProto_values%": [
                            "Array",
                            "prototype",
                            "values"
                        ],
                        "%AsyncFunctionPrototype%": [
                            "AsyncFunction",
                            "prototype"
                        ],
                        "%AsyncGenerator%": [
                            "AsyncGeneratorFunction",
                            "prototype"
                        ],
                        "%AsyncGeneratorPrototype%": [
                            "AsyncGeneratorFunction",
                            "prototype",
                            "prototype"
                        ],
                        "%BooleanPrototype%": [
                            "Boolean",
                            "prototype"
                        ],
                        "%DataViewPrototype%": [
                            "DataView",
                            "prototype"
                        ],
                        "%DatePrototype%": [
                            "Date",
                            "prototype"
                        ],
                        "%ErrorPrototype%": [
                            "Error",
                            "prototype"
                        ],
                        "%EvalErrorPrototype%": [
                            "EvalError",
                            "prototype"
                        ],
                        "%Float32ArrayPrototype%": [
                            "Float32Array",
                            "prototype"
                        ],
                        "%Float64ArrayPrototype%": [
                            "Float64Array",
                            "prototype"
                        ],
                        "%FunctionPrototype%": [
                            "Function",
                            "prototype"
                        ],
                        "%Generator%": [
                            "GeneratorFunction",
                            "prototype"
                        ],
                        "%GeneratorPrototype%": [
                            "GeneratorFunction",
                            "prototype",
                            "prototype"
                        ],
                        "%Int8ArrayPrototype%": [
                            "Int8Array",
                            "prototype"
                        ],
                        "%Int16ArrayPrototype%": [
                            "Int16Array",
                            "prototype"
                        ],
                        "%Int32ArrayPrototype%": [
                            "Int32Array",
                            "prototype"
                        ],
                        "%JSONParse%": [
                            "JSON",
                            "parse"
                        ],
                        "%JSONStringify%": [
                            "JSON",
                            "stringify"
                        ],
                        "%MapPrototype%": [
                            "Map",
                            "prototype"
                        ],
                        "%NumberPrototype%": [
                            "Number",
                            "prototype"
                        ],
                        "%ObjectPrototype%": [
                            "Object",
                            "prototype"
                        ],
                        "%ObjProto_toString%": [
                            "Object",
                            "prototype",
                            "toString"
                        ],
                        "%ObjProto_valueOf%": [
                            "Object",
                            "prototype",
                            "valueOf"
                        ],
                        "%PromisePrototype%": [
                            "Promise",
                            "prototype"
                        ],
                        "%PromiseProto_then%": [
                            "Promise",
                            "prototype",
                            "then"
                        ],
                        "%Promise_all%": [
                            "Promise",
                            "all"
                        ],
                        "%Promise_reject%": [
                            "Promise",
                            "reject"
                        ],
                        "%Promise_resolve%": [
                            "Promise",
                            "resolve"
                        ],
                        "%RangeErrorPrototype%": [
                            "RangeError",
                            "prototype"
                        ],
                        "%ReferenceErrorPrototype%": [
                            "ReferenceError",
                            "prototype"
                        ],
                        "%RegExpPrototype%": [
                            "RegExp",
                            "prototype"
                        ],
                        "%SetPrototype%": [
                            "Set",
                            "prototype"
                        ],
                        "%SharedArrayBufferPrototype%": [
                            "SharedArrayBuffer",
                            "prototype"
                        ],
                        "%StringPrototype%": [
                            "String",
                            "prototype"
                        ],
                        "%SymbolPrototype%": [
                            "Symbol",
                            "prototype"
                        ],
                        "%SyntaxErrorPrototype%": [
                            "SyntaxError",
                            "prototype"
                        ],
                        "%TypedArrayPrototype%": [
                            "TypedArray",
                            "prototype"
                        ],
                        "%TypeErrorPrototype%": [
                            "TypeError",
                            "prototype"
                        ],
                        "%Uint8ArrayPrototype%": [
                            "Uint8Array",
                            "prototype"
                        ],
                        "%Uint8ClampedArrayPrototype%": [
                            "Uint8ClampedArray",
                            "prototype"
                        ],
                        "%Uint16ArrayPrototype%": [
                            "Uint16Array",
                            "prototype"
                        ],
                        "%Uint32ArrayPrototype%": [
                            "Uint32Array",
                            "prototype"
                        ],
                        "%URIErrorPrototype%": [
                            "URIError",
                            "prototype"
                        ],
                        "%WeakMapPrototype%": [
                            "WeakMap",
                            "prototype"
                        ],
                        "%WeakSetPrototype%": [
                            "WeakSet",
                            "prototype"
                        ]
                    }, v = r(45), b = r(149), x = v.call(Function.call, Array.prototype.concat), w = v.call(Function.apply, Array.prototype.splice), _ = v.call(Function.call, String.prototype.replace), A = v.call(Function.call, String.prototype.slice), E = v.call(Function.call, RegExp.prototype.exec), S = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g, M = /\\(\\)?/g, k = function(t) {
                        var e = A(t, 0, 1), r = A(t, -1);
                        if ("%" === e && "%" !== r) throw new n("invalid intrinsic syntax, expected closing `%`");
                        if ("%" === r && "%" !== e) throw new n("invalid intrinsic syntax, expected opening `%`");
                        var i = [];
                        return _(t, S, function(t, e, r, n) {
                            i[i.length] = r ? _(n, M, "$1") : e || t;
                        }), i;
                    }, N = function(t, e) {
                        var r, i = t;
                        if (b(g, i) && (i = "%" + (r = g[i])[0] + "%"), b(m, i)) {
                            var s = m[i];
                            if (s === p && (s = function t(e) {
                                var r;
                                if ("%AsyncFunction%" === e) r = a("async function () {}");
                                else if ("%GeneratorFunction%" === e) r = a("function* () {}");
                                else if ("%AsyncGeneratorFunction%" === e) r = a("async function* () {}");
                                else if ("%AsyncGenerator%" === e) {
                                    var n = t("%AsyncGeneratorFunction%");
                                    n && (r = n.prototype);
                                } else if ("%AsyncIteratorPrototype%" === e) {
                                    var i = t("%AsyncGenerator%");
                                    i && h && (r = h(i.prototype));
                                }
                                return m[e] = r, r;
                            }(i)), void 0 === s && !e) throw new o("intrinsic " + t + " exists, but is not available. Please file an issue!");
                            return {
                                alias: r,
                                name: i,
                                value: s
                            };
                        }
                        throw new n("intrinsic " + t + " does not exist!");
                    };
                    t.exports = function(t, e) {
                        if ("string" != typeof t || 0 === t.length) throw new o("intrinsic name must be a non-empty string");
                        if (arguments.length > 1 && "boolean" != typeof e) throw new o('"allowMissing" argument must be a boolean');
                        if (null === E(/^%?[^%]*%?$/, t)) throw new n("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
                        var r = k(t), i = r.length > 0 ? r[0] : "", a = N("%" + i + "%", e), u = a.name, l = a.value, c = !1, f = a.alias;
                        f && (i = f[0], w(r, x([
                            0,
                            1
                        ], f)));
                        for(var h = 1, p = !0; h < r.length; h += 1){
                            var d = r[h], y = A(d, 0, 1), g = A(d, -1);
                            if (('"' === y || "'" === y || "`" === y || '"' === g || "'" === g || "`" === g) && y !== g) throw new n("property names with quotes must have matching quotes");
                            if ("constructor" !== d && p || (c = !0), b(m, u = "%" + (i += "." + d) + "%")) l = m[u];
                            else if (null != l) {
                                if (!(d in l)) {
                                    if (!e) throw new o("base intrinsic for " + t + " exists, but the property is not available.");
                                    return;
                                }
                                if (s && h + 1 >= r.length) {
                                    var v = s(l, d);
                                    l = (p = !!v) && "get" in v && !("originalValue" in v.get) ? v.get : l[d];
                                } else p = b(l, d), l = l[d];
                                p && !c && (m[u] = l);
                            }
                        }
                        return l;
                    };
                },
                function(t, e, r) {
                    "use strict";
                    var n = r(148);
                    t.exports = Function.prototype.bind || n;
                },
                function(t, e, r) {
                    "use strict";
                    var n = String.prototype.replace, i = /%20/g, o = "RFC3986";
                    t.exports = {
                        default: o,
                        formatters: {
                            RFC1738: function(t) {
                                return n.call(t, i, "+");
                            },
                            RFC3986: function(t) {
                                return String(t);
                            }
                        },
                        RFC1738: "RFC1738",
                        RFC3986: o
                    };
                },
                function(t, e, r) {
                    "use strict";
                    const n = r(5), i = r(11), o = r(48), a = r(9);
                    function s(t, e, r = "1") {
                        if (i(t)) return "0";
                        let s = t, u = t;
                        for(; "<" === n(u, e);)u = a(u, r), s = o(s, u);
                        return s;
                    }
                    t.exports = s, t.exports.default = s;
                },
                function(t, e, r) {
                    "use strict";
                    const { MAX_SAFE_INTEGER_LENGTH: n } = r(30);
                    function i(t, e) {
                        if ("0" === t || "0" === e) return "0";
                        const r = t.indexOf("."), i = e.indexOf("."), o = (-1 === r ? t.length : r) + (-1 === i ? e.length : i), a = (-1 === r ? 0 : t.length - 1 - r) + (-1 === i ? 0 : e.length - 1 - i);
                        if (0 === a && o < n) return (Number(t) * Number(e)).toFixed(0);
                        const s = t.replace(".", ""), u = e.replace(".", ""), l = s.length, c = u.length, f = [];
                        let h = l;
                        for(; h >= 0;){
                            const t = h, e = h -= 15, r = s.substring(e, t);
                            f.push([
                                Number(r),
                                r.length
                            ]);
                        }
                        const p = [], d = [];
                        for(let t = 0, e = c - 1; e >= 0; e--, t++){
                            const r = u[e], n = Number(r);
                            let i = 0, o = "";
                            const a = f.length - 1;
                            f.forEach(([t, e], r)=>{
                                let s = (i + n * t).toString();
                                const u = s.length;
                                if (u > e && r !== a) {
                                    const t = -1 * e;
                                    o = s.slice(t) + o, i = Number(s.slice(0, t));
                                } else {
                                    const t = e - u;
                                    for(let e = 0; e < t; e++)s = "0" + s;
                                    i = 0, o = s + o;
                                }
                            }), o += "0".repeat(t), p.push(o), d.push([
                                Array.from(o).map((t)=>Number(t)),
                                o.length
                            ]);
                        }
                        const m = p.length, y = d[d.length - 1][1] + m;
                        let g = "", v = 0;
                        for(let t = 0; t < y; t++){
                            let e = v;
                            const r = Math.min(t, m - 1);
                            for(let n = 0; n <= r; n++){
                                const [r, i] = d[n], o = i - 1 - t;
                                o >= 0 && (e += r[o]);
                            }
                            e >= 10 ? (e = e.toString(), g = e[e.length - 1] + g, v = Number(e.slice(0, -1))) : (g = e + g, v = 0);
                        }
                        if (0 === a) g = g.replace(/^0+/, "");
                        else {
                            const t = g.length - a;
                            g = g.substring(0, t) + "." + g.substring(t), g = g.replace(/^0+/, ""), g = g.replace(/\.?0+$/, ""), "." === g[0] && (g = "0" + g);
                        }
                        return g;
                    }
                    t.exports = i, t.exports.default = i;
                },
                function(t, e, r) {
                    "use strict";
                    const n = r(6), i = r(160), o = [
                        "5",
                        "6",
                        "7",
                        "8",
                        "9"
                    ];
                    function a(t) {
                        if (t.match(/\.9+$/)) return n(i(t), "1");
                        "+" === t[0] && (t = t.substring(1));
                        const e = t.length;
                        let r = "";
                        const a = t[t.length - 1];
                        if (o.includes(a)) {
                            let n;
                            for(n = e - 2; n >= 0; n--){
                                const e = t[n];
                                if ("." === e || "-" === e) continue;
                                const i = Number(e) + 1;
                                if (10 !== i) {
                                    r = i + r;
                                    break;
                                }
                                r = "0" + r;
                            }
                            n > 0 && (r = t.substring(0, n) + r);
                        } else r = t.substring(0, e - 1);
                        return "." === r[r.length - 1] && (r = r.substring(0, r.length - 1)), r.indexOf(".") > -1 && (r = r.replace(/0+$/, "")), r;
                    }
                    t.exports = a, t.exports.default = a;
                },
                function(t, e, r) {
                    "use strict";
                    function n(t) {
                        return "-" === t[0] ? "-" : "+";
                    }
                    t.exports = n, t.exports.default = n;
                },
                function(t, e, r) {
                    "use strict";
                    const n = r(0);
                    function i(t) {
                        const e = (t = n(t)).indexOf(".");
                        return -1 === e ? "0" : (t.length - e - 1).toString();
                    }
                    t.exports = i, t.exports.default = i;
                },
                function(t, e, r) {
                    "use strict";
                    function n(t) {
                        return t.includes("i");
                    }
                    t.exports = n, t.exports.default = n;
                },
                function(t, e, r) {
                    "use strict";
                    const n = r(79);
                    function i() {
                        const t = Array.from(arguments), e = "object" == typeof t[t.length - 1] ? t[t.length - 1] : void 0, r = Array.isArray(t[0]) ? t[0] : e ? t.slice(0, t.length - 1) : t;
                        return n(r, e);
                    }
                    t.exports = i, t.exports.default = i;
                },
                function(t, e, r) {
                    "use strict";
                    const n = r(17);
                    function i(t, e) {
                        const r = Number(e);
                        let i = t;
                        for(let e = 1; e < r; e++)i = n([
                            i,
                            t
                        ]);
                        return i;
                    }
                    t.exports = i, t.exports.default = i;
                },
                function(t, e, r) {
                    "use strict";
                    const n = r(6);
                    function i(t) {
                        let e = "0";
                        for (let r of t)e = n(e, r);
                        return e;
                    }
                    t.exports = i, t.exports.default = i;
                },
                function(t, e) {
                    const r = 9007199254740991..toString().length - 1;
                    t.exports = {
                        MAX_SAFE_INTEGER: 9007199254740991,
                        MAX_SAFE_INTEGER_LENGTH: r
                    };
                },
                function(t, e, r) {
                    "use strict";
                    (function(t) {
                        r.d(e, "a", function() {
                            return g;
                        });
                        var n = r(12), i = r.n(n), o = r(26), a = r(13), s = r(104), u = r(2), l = r(27), c = r(59), f = function(t, e, r, n) {
                            return new (r || (r = Promise))(function(i, o) {
                                function a(t) {
                                    try {
                                        u(n.next(t));
                                    } catch (t) {
                                        o(t);
                                    }
                                }
                                function s(t) {
                                    try {
                                        u(n.throw(t));
                                    } catch (t) {
                                        o(t);
                                    }
                                }
                                function u(t) {
                                    var e;
                                    t.done ? i(t.value) : (e = t.value, e instanceof r ? e : new r(function(t) {
                                        t(e);
                                    })).then(a, s);
                                }
                                u((n = n.apply(t, e || [])).next());
                            });
                        };
                        const h = i()("threads:master:messages"), p = i()("threads:master:spawn"), d = i()("threads:master:thread-utils"), m = void 0 !== t && t.env.THREADS_WORKER_INIT_TIMEOUT ? Number.parseInt(t.env.THREADS_WORKER_INIT_TIMEOUT, 10) : 1e4;
                        function y(t, e, r, n) {
                            const i = r.filter((t)=>t.type === l.a.internalError).map((t)=>t.error);
                            return Object.assign(t, {
                                [u.a]: i,
                                [u.b]: r,
                                [u.c]: n,
                                [u.e]: e
                            });
                        }
                        function g(t, e) {
                            return f(this, void 0, void 0, function*() {
                                p("Initializing new thread");
                                const r = e && e.timeout ? e.timeout : m, n = (yield function(t, e, r) {
                                    return f(this, void 0, void 0, function*() {
                                        let n;
                                        const i = new Promise((t, i)=>{
                                            n = setTimeout(()=>i(Error(r)), e);
                                        }), o = yield Promise.race([
                                            t,
                                            i
                                        ]);
                                        return clearTimeout(n), o;
                                    });
                                }(function(t) {
                                    return new Promise((e, r)=>{
                                        const n = (i)=>{
                                            var o;
                                            h("Message from worker before finishing initialization:", i.data), (o = i.data) && "init" === o.type ? (t.removeEventListener("message", n), e(i.data)) : ((t)=>t && "uncaughtError" === t.type)(i.data) && (t.removeEventListener("message", n), r(Object(a.a)(i.data.error)));
                                        };
                                        t.addEventListener("message", n);
                                    });
                                }(t), r, `Timeout: Did not receive an init message from worker after ${r}ms. Make sure the worker calls expose().`)).exposed, { termination: i, terminate: u } = function(t) {
                                    const [e, r] = Object(s.a)();
                                    return {
                                        terminate: ()=>f(this, void 0, void 0, function*() {
                                                d("Terminating worker"), yield t.terminate(), r();
                                            }),
                                        termination: e
                                    };
                                }(t), g = function(t, e) {
                                    return new o.a((r)=>{
                                        const n = (t)=>{
                                            const e = {
                                                type: l.a.message,
                                                data: t.data
                                            };
                                            r.next(e);
                                        }, i = (t)=>{
                                            d("Unhandled promise rejection event in thread:", t);
                                            const e = {
                                                type: l.a.internalError,
                                                error: Error(t.reason)
                                            };
                                            r.next(e);
                                        };
                                        t.addEventListener("message", n), t.addEventListener("unhandledrejection", i), e.then(()=>{
                                            const e = {
                                                type: l.a.termination
                                            };
                                            t.removeEventListener("message", n), t.removeEventListener("unhandledrejection", i), r.next(e), r.complete();
                                        });
                                    });
                                }(t, i);
                                if ("function" === n.type) return y(Object(c.a)(t), t, g, u);
                                if ("module" === n.type) return y(Object(c.b)(t, n.methods), t, g, u);
                                {
                                    const t = n.type;
                                    throw Error("Worker init message states unexpected type of expose(): " + t);
                                }
                            });
                        }
                    }).call(this, r(8));
                },
                function(t, e, r) {
                    "use strict";
                    r.d(e, "a", function() {
                        return y;
                    });
                    var n = r(12), i = r.n(n), o = r(103), a = r(201), s = r(26);
                    function u(t) {
                        return Promise.all(t.map((t)=>{
                            const e = (t)=>({
                                    status: "fulfilled",
                                    value: t
                                }), r = (t)=>({
                                    status: "rejected",
                                    reason: t
                                }), n = Promise.resolve(t);
                            try {
                                return n.then(e, r);
                            } catch (t) {
                                return Promise.reject(t);
                            }
                        }));
                    }
                    var l, c = r(19);
                    !function(t) {
                        t.initialized = "initialized", t.taskCanceled = "taskCanceled", t.taskCompleted = "taskCompleted", t.taskFailed = "taskFailed", t.taskQueued = "taskQueued", t.taskQueueDrained = "taskQueueDrained", t.taskStart = "taskStart", t.terminated = "terminated";
                    }(l || (l = {}));
                    var f = r(24), h = function(t, e, r, n) {
                        return new (r || (r = Promise))(function(i, o) {
                            function a(t) {
                                try {
                                    u(n.next(t));
                                } catch (t) {
                                    o(t);
                                }
                            }
                            function s(t) {
                                try {
                                    u(n.throw(t));
                                } catch (t) {
                                    o(t);
                                }
                            }
                            function u(t) {
                                var e;
                                t.done ? i(t.value) : (e = t.value, e instanceof r ? e : new r(function(t) {
                                    t(e);
                                })).then(a, s);
                            }
                            u((n = n.apply(t, e || [])).next());
                        });
                    };
                    let p = 1;
                    class d {
                        constructor(t, e){
                            this.eventSubject = new o.a, this.initErrors = [], this.isClosing = !1, this.nextTaskID = 1, this.taskQueue = [];
                            const r = "number" == typeof e ? {
                                size: e
                            } : e || {}, { size: n = c.a } = r;
                            this.debug = i()("threads:pool:" + (r.name || String(p++)).replace(/\W/g, " ").trim().replace(/\s+/g, "-")), this.options = r, this.workers = function(t, e) {
                                return (function(t) {
                                    const e = [];
                                    for(let r = 0; r < t; r++)e.push(r);
                                    return e;
                                })(e).map(()=>({
                                        init: t(),
                                        runningTasks: []
                                    }));
                            }(t, n), this.eventObservable = Object(a.a)(s.a.from(this.eventSubject)), Promise.all(this.workers.map((t)=>t.init)).then(()=>this.eventSubject.next({
                                    type: l.initialized,
                                    size: this.workers.length
                                }), (t)=>{
                                this.debug("Error while initializing pool worker:", t), this.eventSubject.error(t), this.initErrors.push(t);
                            });
                        }
                        findIdlingWorker() {
                            const { concurrency: t = 1 } = this.options;
                            return this.workers.find((e)=>e.runningTasks.length < t);
                        }
                        runPoolTask(t, e) {
                            return h(this, void 0, void 0, function*() {
                                const r = this.workers.indexOf(t) + 1;
                                this.debug(`Running task #${e.id} on worker #${r}...`), this.eventSubject.next({
                                    type: l.taskStart,
                                    taskID: e.id,
                                    workerID: r
                                });
                                try {
                                    const n = yield e.run((yield t.init));
                                    this.debug(`Task #${e.id} completed successfully`), this.eventSubject.next({
                                        type: l.taskCompleted,
                                        returnValue: n,
                                        taskID: e.id,
                                        workerID: r
                                    });
                                } catch (t) {
                                    this.debug(`Task #${e.id} failed`), this.eventSubject.next({
                                        type: l.taskFailed,
                                        taskID: e.id,
                                        error: t,
                                        workerID: r
                                    });
                                }
                            });
                        }
                        run(t, e) {
                            return h(this, void 0, void 0, function*() {
                                const r = (()=>h(this, void 0, void 0, function*() {
                                        yield new Promise((t)=>setTimeout(t, 0));
                                        try {
                                            yield this.runPoolTask(t, e);
                                        } finally{
                                            t.runningTasks = t.runningTasks.filter((t)=>t !== r), this.isClosing || this.scheduleWork();
                                        }
                                    }))();
                                t.runningTasks.push(r);
                            });
                        }
                        scheduleWork() {
                            this.debug("Attempt de-queueing a task in order to run it...");
                            const t = this.findIdlingWorker();
                            if (!t) return;
                            const e = this.taskQueue.shift();
                            if (!e) return this.debug("Task queue is empty"), void this.eventSubject.next({
                                type: l.taskQueueDrained
                            });
                            this.run(t, e);
                        }
                        taskCompletion(t) {
                            return new Promise((e, r)=>{
                                const n = this.events().subscribe((i)=>{
                                    i.type === l.taskCompleted && i.taskID === t ? (n.unsubscribe(), e(i.returnValue)) : i.type === l.taskFailed && i.taskID === t ? (n.unsubscribe(), r(i.error)) : i.type === l.terminated && (n.unsubscribe(), r(Error("Pool has been terminated before task was run.")));
                                });
                            });
                        }
                        settled(t = !1) {
                            return h(this, void 0, void 0, function*() {
                                const e = ()=>{
                                    var t, e;
                                    return t = this.workers, e = (t)=>t.runningTasks, t.reduce((t, r)=>[
                                            ...t,
                                            ...e(r)
                                        ], []);
                                }, r = [], n = this.eventObservable.subscribe((t)=>{
                                    t.type === l.taskFailed && r.push(t.error);
                                });
                                return this.initErrors.length > 0 ? Promise.reject(this.initErrors[0]) : t && 0 === this.taskQueue.length ? (yield u(e()), r) : (yield new Promise((t, e)=>{
                                    const r = this.eventObservable.subscribe({
                                        next (e) {
                                            e.type === l.taskQueueDrained && (r.unsubscribe(), t(void 0));
                                        },
                                        error: e
                                    });
                                }), yield u(e()), n.unsubscribe(), r);
                            });
                        }
                        completed(t = !1) {
                            return h(this, void 0, void 0, function*() {
                                const e = this.settled(t), r = new Promise((t, r)=>{
                                    const n = this.eventObservable.subscribe({
                                        next (i) {
                                            i.type === l.taskQueueDrained ? (n.unsubscribe(), t(e)) : i.type === l.taskFailed && (n.unsubscribe(), r(i.error));
                                        },
                                        error: r
                                    });
                                }), n = yield Promise.race([
                                    e,
                                    r
                                ]);
                                if (n.length > 0) throw n[0];
                            });
                        }
                        events() {
                            return this.eventObservable;
                        }
                        queue(t) {
                            const { maxQueuedJobs: e = 1 / 0 } = this.options;
                            if (this.isClosing) throw Error("Cannot schedule pool tasks after terminate() has been called.");
                            if (this.initErrors.length > 0) throw this.initErrors[0];
                            const r = this.nextTaskID++, n = this.taskCompletion(r);
                            n.catch((t)=>{
                                this.debug(`Task #${r} errored:`, t);
                            });
                            const i = {
                                id: r,
                                run: t,
                                cancel: ()=>{
                                    -1 !== this.taskQueue.indexOf(i) && (this.taskQueue = this.taskQueue.filter((t)=>t !== i), this.eventSubject.next({
                                        type: l.taskCanceled,
                                        taskID: i.id
                                    }));
                                },
                                then: n.then.bind(n)
                            };
                            if (this.taskQueue.length >= e) throw Error("Maximum number of pool tasks queued. Refusing to queue another one.\nThis usually happens for one of two reasons: We are either at peak workload right now or some tasks just won't finish, thus blocking the pool.");
                            return this.debug(`Queueing task #${i.id}...`), this.taskQueue.push(i), this.eventSubject.next({
                                type: l.taskQueued,
                                taskID: i.id
                            }), this.scheduleWork(), i;
                        }
                        terminate(t) {
                            return h(this, void 0, void 0, function*() {
                                this.isClosing = !0, t || (yield this.completed(!0)), this.eventSubject.next({
                                    type: l.terminated,
                                    remainingQueue: [
                                        ...this.taskQueue
                                    ]
                                }), this.eventSubject.complete(), yield Promise.all(this.workers.map((t)=>h(this, void 0, void 0, function*() {
                                        return f.a.terminate((yield t.init));
                                    })));
                            });
                        }
                    }
                    function m(t, e) {
                        return new d(t, e);
                    }
                    d.EventType = l, m.EventType = l;
                    const y = m;
                },
                function(t, e, r) {
                    "use strict";
                    r.d(e, "a", function() {
                        return v;
                    }), r.d(e, "b", function() {
                        return b;
                    });
                    var n = r(12), i = r.n(n), o = r(26), a = r(201), s = r(13);
                    const u = ()=>{}, l = (t)=>t, c = (t)=>Promise.resolve().then(t);
                    function f(t) {
                        throw t;
                    }
                    class h extends o.a {
                        constructor(t){
                            super((e)=>{
                                const r = this, n = Object.assign(Object.assign({}, e), {
                                    complete () {
                                        e.complete(), r.onCompletion();
                                    },
                                    error (t) {
                                        e.error(t), r.onError(t);
                                    },
                                    next (t) {
                                        e.next(t), r.onNext(t);
                                    }
                                });
                                try {
                                    return this.initHasRun = !0, t(n);
                                } catch (t) {
                                    n.error(t);
                                }
                            }), this.initHasRun = !1, this.fulfillmentCallbacks = [], this.rejectionCallbacks = [], this.firstValueSet = !1, this.state = "pending";
                        }
                        onNext(t) {
                            this.firstValueSet || (this.firstValue = t, this.firstValueSet = !0);
                        }
                        onError(t) {
                            this.state = "rejected", this.rejection = t;
                            for (const e of this.rejectionCallbacks)c(()=>e(t));
                        }
                        onCompletion() {
                            this.state = "fulfilled";
                            for (const t of this.fulfillmentCallbacks)c(()=>t(this.firstValue));
                        }
                        then(t, e) {
                            const r = t || l, n = e || f;
                            let i = !1;
                            return new Promise((t, e)=>{
                                const o = (r)=>{
                                    if (!i) {
                                        i = !0;
                                        try {
                                            t(n(r));
                                        } catch (t) {
                                            e(t);
                                        }
                                    }
                                };
                                return this.initHasRun || this.subscribe({
                                    error: o
                                }), "fulfilled" === this.state ? t(r(this.firstValue)) : "rejected" === this.state ? (i = !0, t(n(this.rejection))) : (this.fulfillmentCallbacks.push((e)=>{
                                    try {
                                        t(r(e));
                                    } catch (t) {
                                        o(t);
                                    }
                                }), void this.rejectionCallbacks.push(o));
                            });
                        }
                        catch(t) {
                            return this.then(void 0, t);
                        }
                        finally(t) {
                            const e = t || u;
                            return this.then((t)=>(e(), t), ()=>e());
                        }
                        static from(t) {
                            return function(t) {
                                return t && "function" == typeof t.then;
                            }(t) ? new h((e)=>{
                                t.then((t)=>{
                                    e.next(t), e.complete();
                                }, (t)=>{
                                    e.error(t);
                                });
                            }) : super.from(t);
                        }
                    }
                    var p = r(105), d = r(20);
                    const m = i()("threads:master:messages");
                    let y = 1;
                    function g(t, e) {
                        return new o.a((r)=>{
                            let n;
                            const i = (o)=>{
                                var a;
                                if (m("Message from worker:", o.data), o.data && o.data.uid === e) {
                                    if ((a = o.data) && a.type === d.b.running) n = o.data.resultType;
                                    else if (((t)=>t && t.type === d.b.result)(o.data)) "promise" === n ? (void 0 !== o.data.payload && r.next(Object(s.a)(o.data.payload)), r.complete(), t.removeEventListener("message", i)) : (o.data.payload && r.next(Object(s.a)(o.data.payload)), o.data.complete && (r.complete(), t.removeEventListener("message", i)));
                                    else if (((t)=>t && t.type === d.b.error)(o.data)) {
                                        const e = Object(s.a)(o.data.error);
                                        r.error(e), t.removeEventListener("message", i);
                                    }
                                }
                            };
                            return t.addEventListener("message", i), ()=>{
                                if ("observable" === n || !n) {
                                    const r = {
                                        type: d.a.cancel,
                                        uid: e
                                    };
                                    t.postMessage(r);
                                }
                                t.removeEventListener("message", i);
                            };
                        });
                    }
                    function v(t, e) {
                        return (...r)=>{
                            const n = y++, { args: i, transferables: o } = function(t) {
                                if (0 === t.length) return {
                                    args: [],
                                    transferables: []
                                };
                                const e = [], r = [];
                                for (const n of t)Object(p.a)(n) ? (e.push(Object(s.b)(n.send)), r.push(...n.transferables)) : e.push(Object(s.b)(n));
                                var n;
                                return {
                                    args: e,
                                    transferables: 0 === r.length ? r : (n = r, Array.from(new Set(n)))
                                };
                            }(r), u = {
                                type: d.a.run,
                                uid: n,
                                method: e,
                                args: i
                            };
                            m("Sending command to run function to worker:", u);
                            try {
                                t.postMessage(u, o);
                            } catch (t) {
                                return h.from(Promise.reject(t));
                            }
                            return h.from(Object(a.a)(g(t, n)));
                        };
                    }
                    function b(t, e) {
                        const r = {};
                        for (const n of e)r[n] = v(t, n);
                        return r;
                    }
                },
                function(t, e) {
                    var r = {}.toString;
                    t.exports = Array.isArray || function(t) {
                        return "[object Array]" == r.call(t);
                    };
                },
                function(t, e, r) {
                    "use strict";
                    (function(e, n) {
                        var i = r(28);
                        t.exports = b;
                        var o, a = r(60);
                        b.ReadableState = v, r(62).EventEmitter;
                        var s = function(t, e) {
                            return t.listeners(e).length;
                        }, u = r(63), l = r(43).Buffer, c = (void 0 !== e ? e : "undefined" != typeof window ? window : "undefined" != typeof self ? self : {}).Uint8Array || function() {}, f = Object.create(r(21));
                        f.inherits = r(10);
                        var h = r(115), p = void 0;
                        p = h && h.debuglog ? h.debuglog("stream") : function() {};
                        var d, m = r(116), y = r(64);
                        f.inherits(b, u);
                        var g = [
                            "error",
                            "close",
                            "destroy",
                            "pause",
                            "resume"
                        ];
                        function v(t, e) {
                            t = t || {};
                            var n = e instanceof (o = o || r(14));
                            this.objectMode = !!t.objectMode, n && (this.objectMode = this.objectMode || !!t.readableObjectMode);
                            var i = t.highWaterMark, a = t.readableHighWaterMark, s = this.objectMode ? 16 : 16384;
                            this.highWaterMark = i || 0 === i ? i : n && (a || 0 === a) ? a : s, this.highWaterMark = Math.floor(this.highWaterMark), this.buffer = new m, this.length = 0, this.pipes = null, this.pipesCount = 0, this.flowing = null, this.ended = !1, this.endEmitted = !1, this.reading = !1, this.sync = !0, this.needReadable = !1, this.emittedReadable = !1, this.readableListening = !1, this.resumeScheduled = !1, this.destroyed = !1, this.defaultEncoding = t.defaultEncoding || "utf8", this.awaitDrain = 0, this.readingMore = !1, this.decoder = null, this.encoding = null, t.encoding && (d || (d = r(66).StringDecoder), this.decoder = new d(t.encoding), this.encoding = t.encoding);
                        }
                        function b(t) {
                            if (o = o || r(14), !(this instanceof b)) return new b(t);
                            this._readableState = new v(t, this), this.readable = !0, t && ("function" == typeof t.read && (this._read = t.read), "function" == typeof t.destroy && (this._destroy = t.destroy)), u.call(this);
                        }
                        function x(t, e, r, n, i) {
                            var o, a = t._readableState;
                            return null === e ? (a.reading = !1, function(t, e) {
                                if (!e.ended) {
                                    if (e.decoder) {
                                        var r = e.decoder.end();
                                        r && r.length && (e.buffer.push(r), e.length += e.objectMode ? 1 : r.length);
                                    }
                                    e.ended = !0, A(t);
                                }
                            }(t, a)) : (i || (o = function(t, e) {
                                var r, n;
                                return n = e, l.isBuffer(n) || n instanceof c || "string" == typeof e || void 0 === e || t.objectMode || (r = new TypeError("Invalid non-string/buffer chunk")), r;
                            }(a, e)), o ? t.emit("error", o) : a.objectMode || e && e.length > 0 ? ("string" == typeof e || a.objectMode || Object.getPrototypeOf(e) === l.prototype || (e = function(t) {
                                return l.from(t);
                            }(e)), n ? a.endEmitted ? t.emit("error", new Error("stream.unshift() after end event")) : w(t, a, e, !0) : a.ended ? t.emit("error", new Error("stream.push() after EOF")) : (a.reading = !1, a.decoder && !r ? (e = a.decoder.write(e), a.objectMode || 0 !== e.length ? w(t, a, e, !1) : S(t, a)) : w(t, a, e, !1))) : n || (a.reading = !1)), function(t) {
                                return !t.ended && (t.needReadable || t.length < t.highWaterMark || 0 === t.length);
                            }(a);
                        }
                        function w(t, e, r, n) {
                            e.flowing && 0 === e.length && !e.sync ? (t.emit("data", r), t.read(0)) : (e.length += e.objectMode ? 1 : r.length, n ? e.buffer.unshift(r) : e.buffer.push(r), e.needReadable && A(t)), S(t, e);
                        }
                        function _(t, e) {
                            return t <= 0 || 0 === e.length && e.ended ? 0 : e.objectMode ? 1 : t != t ? e.flowing && e.length ? e.buffer.head.data.length : e.length : (t > e.highWaterMark && (e.highWaterMark = function(t) {
                                return t >= 8388608 ? t = 8388608 : (t--, t |= t >>> 1, t |= t >>> 2, t |= t >>> 4, t |= t >>> 8, t |= t >>> 16, t++), t;
                            }(t)), t <= e.length ? t : e.ended ? e.length : (e.needReadable = !0, 0));
                        }
                        function A(t) {
                            var e = t._readableState;
                            e.needReadable = !1, e.emittedReadable || (p("emitReadable", e.flowing), e.emittedReadable = !0, e.sync ? i.nextTick(E, t) : E(t));
                        }
                        function E(t) {
                            p("emit readable"), t.emit("readable"), C(t);
                        }
                        function S(t, e) {
                            e.readingMore || (e.readingMore = !0, i.nextTick(M, t, e));
                        }
                        function M(t, e) {
                            for(var r = e.length; !e.reading && !e.flowing && !e.ended && e.length < e.highWaterMark && (p("maybeReadMore read 0"), t.read(0), r !== e.length);)r = e.length;
                            e.readingMore = !1;
                        }
                        function k(t) {
                            p("readable nexttick read 0"), t.read(0);
                        }
                        function N(t, e) {
                            e.reading || (p("resume read 0"), t.read(0)), e.resumeScheduled = !1, e.awaitDrain = 0, t.emit("resume"), C(t), e.flowing && !e.reading && t.read(0);
                        }
                        function C(t) {
                            var e = t._readableState;
                            for(p("flow", e.flowing); e.flowing && null !== t.read(););
                        }
                        function D(t, e) {
                            var r;
                            return 0 === e.length ? null : (e.objectMode ? r = e.buffer.shift() : !t || t >= e.length ? (r = e.decoder ? e.buffer.join("") : 1 === e.buffer.length ? e.buffer.head.data : e.buffer.concat(e.length), e.buffer.clear()) : r = function(t, e, r) {
                                var n;
                                return t < e.head.data.length ? (n = e.head.data.slice(0, t), e.head.data = e.head.data.slice(t)) : n = t === e.head.data.length ? e.shift() : r ? function(t, e) {
                                    var r = e.head, n = 1, i = r.data;
                                    for(t -= i.length; r = r.next;){
                                        var o = r.data, a = t > o.length ? o.length : t;
                                        if (a === o.length ? i += o : i += o.slice(0, t), 0 == (t -= a)) {
                                            a === o.length ? (++n, r.next ? e.head = r.next : e.head = e.tail = null) : (e.head = r, r.data = o.slice(a));
                                            break;
                                        }
                                        ++n;
                                    }
                                    return e.length -= n, i;
                                }(t, e) : function(t, e) {
                                    var r = l.allocUnsafe(t), n = e.head, i = 1;
                                    for(n.data.copy(r), t -= n.data.length; n = n.next;){
                                        var o = n.data, a = t > o.length ? o.length : t;
                                        if (o.copy(r, r.length - t, 0, a), 0 == (t -= a)) {
                                            a === o.length ? (++i, n.next ? e.head = n.next : e.head = e.tail = null) : (e.head = n, n.data = o.slice(a));
                                            break;
                                        }
                                        ++i;
                                    }
                                    return e.length -= i, r;
                                }(t, e), n;
                            }(t, e.buffer, e.decoder), r);
                        }
                        function O(t) {
                            var e = t._readableState;
                            if (e.length > 0) throw new Error('"endReadable()" called on non-empty stream');
                            e.endEmitted || (e.ended = !0, i.nextTick(T, e, t));
                        }
                        function T(t, e) {
                            t.endEmitted || 0 !== t.length || (t.endEmitted = !0, e.readable = !1, e.emit("end"));
                        }
                        function F(t, e) {
                            for(var r = 0, n = t.length; r < n; r++)if (t[r] === e) return r;
                            return -1;
                        }
                        Object.defineProperty(b.prototype, "destroyed", {
                            get: function() {
                                return void 0 !== this._readableState && this._readableState.destroyed;
                            },
                            set: function(t) {
                                this._readableState && (this._readableState.destroyed = t);
                            }
                        }), b.prototype.destroy = y.destroy, b.prototype._undestroy = y.undestroy, b.prototype._destroy = function(t, e) {
                            this.push(null), e(t);
                        }, b.prototype.push = function(t, e) {
                            var r, n = this._readableState;
                            return n.objectMode ? r = !0 : "string" == typeof t && ((e = e || n.defaultEncoding) !== n.encoding && (t = l.from(t, e), e = ""), r = !0), x(this, t, e, !1, r);
                        }, b.prototype.unshift = function(t) {
                            return x(this, t, null, !0, !1);
                        }, b.prototype.isPaused = function() {
                            return !1 === this._readableState.flowing;
                        }, b.prototype.setEncoding = function(t) {
                            return d || (d = r(66).StringDecoder), this._readableState.decoder = new d(t), this._readableState.encoding = t, this;
                        }, b.prototype.read = function(t) {
                            p("read", t), t = parseInt(t, 10);
                            var e = this._readableState, r = t;
                            if (0 !== t && (e.emittedReadable = !1), 0 === t && e.needReadable && (e.length >= e.highWaterMark || e.ended)) return p("read: emitReadable", e.length, e.ended), 0 === e.length && e.ended ? O(this) : A(this), null;
                            if (0 === (t = _(t, e)) && e.ended) return 0 === e.length && O(this), null;
                            var n, i = e.needReadable;
                            return p("need readable", i), (0 === e.length || e.length - t < e.highWaterMark) && p("length less than watermark", i = !0), e.ended || e.reading ? p("reading or ended", i = !1) : i && (p("do read"), e.reading = !0, e.sync = !0, 0 === e.length && (e.needReadable = !0), this._read(e.highWaterMark), e.sync = !1, e.reading || (t = _(r, e))), null === (n = t > 0 ? D(t, e) : null) ? (e.needReadable = !0, t = 0) : e.length -= t, 0 === e.length && (e.ended || (e.needReadable = !0), r !== t && e.ended && O(this)), null !== n && this.emit("data", n), n;
                        }, b.prototype._read = function(t) {
                            this.emit("error", new Error("_read() is not implemented"));
                        }, b.prototype.pipe = function(t, e) {
                            var r = this, o = this._readableState;
                            switch(o.pipesCount){
                                case 0:
                                    o.pipes = t;
                                    break;
                                case 1:
                                    o.pipes = [
                                        o.pipes,
                                        t
                                    ];
                                    break;
                                default:
                                    o.pipes.push(t);
                            }
                            o.pipesCount += 1, p("pipe count=%d opts=%j", o.pipesCount, e);
                            var u = e && !1 === e.end || t === n.stdout || t === n.stderr ? v : l;
                            function l() {
                                p("onend"), t.end();
                            }
                            o.endEmitted ? i.nextTick(u) : r.once("end", u), t.on("unpipe", function e(n, i) {
                                p("onunpipe"), n === r && i && !1 === i.hasUnpiped && (i.hasUnpiped = !0, p("cleanup"), t.removeListener("close", y), t.removeListener("finish", g), t.removeListener("drain", c), t.removeListener("error", m), t.removeListener("unpipe", e), r.removeListener("end", l), r.removeListener("end", v), r.removeListener("data", d), f = !0, !o.awaitDrain || t._writableState && !t._writableState.needDrain || c());
                            });
                            var c = function(t) {
                                return function() {
                                    var e = t._readableState;
                                    p("pipeOnDrain", e.awaitDrain), e.awaitDrain && e.awaitDrain--, 0 === e.awaitDrain && s(t, "data") && (e.flowing = !0, C(t));
                                };
                            }(r);
                            t.on("drain", c);
                            var f = !1, h = !1;
                            function d(e) {
                                p("ondata"), h = !1, !1 !== t.write(e) || h || ((1 === o.pipesCount && o.pipes === t || o.pipesCount > 1 && -1 !== F(o.pipes, t)) && !f && (p("false write response, pause", o.awaitDrain), o.awaitDrain++, h = !0), r.pause());
                            }
                            function m(e) {
                                p("onerror", e), v(), t.removeListener("error", m), 0 === s(t, "error") && t.emit("error", e);
                            }
                            function y() {
                                t.removeListener("finish", g), v();
                            }
                            function g() {
                                p("onfinish"), t.removeListener("close", y), v();
                            }
                            function v() {
                                p("unpipe"), r.unpipe(t);
                            }
                            return r.on("data", d), function(t, e, r) {
                                if ("function" == typeof t.prependListener) return t.prependListener(e, r);
                                t._events && t._events[e] ? a(t._events[e]) ? t._events[e].unshift(r) : t._events[e] = [
                                    r,
                                    t._events[e]
                                ] : t.on(e, r);
                            }(t, "error", m), t.once("close", y), t.once("finish", g), t.emit("pipe", r), o.flowing || (p("pipe resume"), r.resume()), t;
                        }, b.prototype.unpipe = function(t) {
                            var e = this._readableState, r = {
                                hasUnpiped: !1
                            };
                            if (0 === e.pipesCount) return this;
                            if (1 === e.pipesCount) return t && t !== e.pipes || (t || (t = e.pipes), e.pipes = null, e.pipesCount = 0, e.flowing = !1, t && t.emit("unpipe", this, r)), this;
                            if (!t) {
                                var n = e.pipes, i = e.pipesCount;
                                e.pipes = null, e.pipesCount = 0, e.flowing = !1;
                                for(var o = 0; o < i; o++)n[o].emit("unpipe", this, {
                                    hasUnpiped: !1
                                });
                                return this;
                            }
                            var a = F(e.pipes, t);
                            return -1 === a || (e.pipes.splice(a, 1), e.pipesCount -= 1, 1 === e.pipesCount && (e.pipes = e.pipes[0]), t.emit("unpipe", this, r)), this;
                        }, b.prototype.on = function(t, e) {
                            var r = u.prototype.on.call(this, t, e);
                            if ("data" === t) !1 !== this._readableState.flowing && this.resume();
                            else if ("readable" === t) {
                                var n = this._readableState;
                                n.endEmitted || n.readableListening || (n.readableListening = n.needReadable = !0, n.emittedReadable = !1, n.reading ? n.length && A(this) : i.nextTick(k, this));
                            }
                            return r;
                        }, b.prototype.addListener = b.prototype.on, b.prototype.resume = function() {
                            var t = this._readableState;
                            return t.flowing || (p("resume"), t.flowing = !0, function(t, e) {
                                e.resumeScheduled || (e.resumeScheduled = !0, i.nextTick(N, t, e));
                            }(this, t)), this;
                        }, b.prototype.pause = function() {
                            return p("call pause flowing=%j", this._readableState.flowing), !1 !== this._readableState.flowing && (p("pause"), this._readableState.flowing = !1, this.emit("pause")), this;
                        }, b.prototype.wrap = function(t) {
                            var e = this, r = this._readableState, n = !1;
                            for(var i in t.on("end", function() {
                                if (p("wrapped end"), r.decoder && !r.ended) {
                                    var t = r.decoder.end();
                                    t && t.length && e.push(t);
                                }
                                e.push(null);
                            }), t.on("data", function(i) {
                                p("wrapped data"), r.decoder && (i = r.decoder.write(i)), r.objectMode && null == i || (r.objectMode || i && i.length) && (e.push(i) || (n = !0, t.pause()));
                            }), t)void 0 === this[i] && "function" == typeof t[i] && (this[i] = function(e) {
                                return function() {
                                    return t[e].apply(t, arguments);
                                };
                            }(i));
                            for(var o = 0; o < g.length; o++)t.on(g[o], this.emit.bind(this, g[o]));
                            return this._read = function(e) {
                                p("wrapped _read", e), n && (n = !1, t.resume());
                            }, this;
                        }, Object.defineProperty(b.prototype, "readableHighWaterMark", {
                            enumerable: !1,
                            get: function() {
                                return this._readableState.highWaterMark;
                            }
                        }), b._fromList = D;
                    }).call(this, r(3), r(8));
                },
                function(t, e, r) {
                    "use strict";
                    var n, i = "object" == typeof Reflect ? Reflect : null, o = i && "function" == typeof i.apply ? i.apply : function(t, e, r) {
                        return Function.prototype.apply.call(t, e, r);
                    };
                    n = i && "function" == typeof i.ownKeys ? i.ownKeys : Object.getOwnPropertySymbols ? function(t) {
                        return Object.getOwnPropertyNames(t).concat(Object.getOwnPropertySymbols(t));
                    } : function(t) {
                        return Object.getOwnPropertyNames(t);
                    };
                    var a = Number.isNaN || function(t) {
                        return t != t;
                    };
                    function s() {
                        s.init.call(this);
                    }
                    t.exports = s, t.exports.once = function(t, e) {
                        return new Promise(function(r, n) {
                            function i(r) {
                                t.removeListener(e, o), n(r);
                            }
                            function o() {
                                "function" == typeof t.removeListener && t.removeListener("error", i), r([].slice.call(arguments));
                            }
                            g(t, e, o, {
                                once: !0
                            }), "error" !== e && function(t, e, r) {
                                "function" == typeof t.on && g(t, "error", e, {
                                    once: !0
                                });
                            }(t, i);
                        });
                    }, s.EventEmitter = s, s.prototype._events = void 0, s.prototype._eventsCount = 0, s.prototype._maxListeners = void 0;
                    var u = 10;
                    function l(t) {
                        if ("function" != typeof t) throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof t);
                    }
                    function c(t) {
                        return void 0 === t._maxListeners ? s.defaultMaxListeners : t._maxListeners;
                    }
                    function f(t, e, r, n) {
                        var i, o, a, s;
                        if (l(r), void 0 === (o = t._events) ? (o = t._events = Object.create(null), t._eventsCount = 0) : (void 0 !== o.newListener && (t.emit("newListener", e, r.listener ? r.listener : r), o = t._events), a = o[e]), void 0 === a) a = o[e] = r, ++t._eventsCount;
                        else if ("function" == typeof a ? a = o[e] = n ? [
                            r,
                            a
                        ] : [
                            a,
                            r
                        ] : n ? a.unshift(r) : a.push(r), (i = c(t)) > 0 && a.length > i && !a.warned) {
                            a.warned = !0;
                            var u = new Error("Possible EventEmitter memory leak detected. " + a.length + " " + String(e) + " listeners added. Use emitter.setMaxListeners() to increase limit");
                            u.name = "MaxListenersExceededWarning", u.emitter = t, u.type = e, u.count = a.length, s = u, console && console.warn && console.warn(s);
                        }
                        return t;
                    }
                    function h() {
                        if (!this.fired) return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, 0 === arguments.length ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
                    }
                    function p(t, e, r) {
                        var n = {
                            fired: !1,
                            wrapFn: void 0,
                            target: t,
                            type: e,
                            listener: r
                        }, i = h.bind(n);
                        return i.listener = r, n.wrapFn = i, i;
                    }
                    function d(t, e, r) {
                        var n = t._events;
                        if (void 0 === n) return [];
                        var i = n[e];
                        return void 0 === i ? [] : "function" == typeof i ? r ? [
                            i.listener || i
                        ] : [
                            i
                        ] : r ? function(t) {
                            for(var e = new Array(t.length), r = 0; r < e.length; ++r)e[r] = t[r].listener || t[r];
                            return e;
                        }(i) : y(i, i.length);
                    }
                    function m(t) {
                        var e = this._events;
                        if (void 0 !== e) {
                            var r = e[t];
                            if ("function" == typeof r) return 1;
                            if (void 0 !== r) return r.length;
                        }
                        return 0;
                    }
                    function y(t, e) {
                        for(var r = new Array(e), n = 0; n < e; ++n)r[n] = t[n];
                        return r;
                    }
                    function g(t, e, r, n) {
                        if ("function" == typeof t.on) n.once ? t.once(e, r) : t.on(e, r);
                        else {
                            if ("function" != typeof t.addEventListener) throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof t);
                            t.addEventListener(e, function i(o) {
                                n.once && t.removeEventListener(e, i), r(o);
                            });
                        }
                    }
                    Object.defineProperty(s, "defaultMaxListeners", {
                        enumerable: !0,
                        get: function() {
                            return u;
                        },
                        set: function(t) {
                            if ("number" != typeof t || t < 0 || a(t)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + t + ".");
                            u = t;
                        }
                    }), s.init = function() {
                        void 0 !== this._events && this._events !== Object.getPrototypeOf(this)._events || (this._events = Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
                    }, s.prototype.setMaxListeners = function(t) {
                        if ("number" != typeof t || t < 0 || a(t)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + t + ".");
                        return this._maxListeners = t, this;
                    }, s.prototype.getMaxListeners = function() {
                        return c(this);
                    }, s.prototype.emit = function(t) {
                        for(var e = [], r = 1; r < arguments.length; r++)e.push(arguments[r]);
                        var n = "error" === t, i = this._events;
                        if (void 0 !== i) n = n && void 0 === i.error;
                        else if (!n) return !1;
                        if (n) {
                            var a;
                            if (e.length > 0 && (a = e[0]), a instanceof Error) throw a;
                            var s = new Error("Unhandled error." + (a ? " (" + a.message + ")" : ""));
                            throw s.context = a, s;
                        }
                        var u = i[t];
                        if (void 0 === u) return !1;
                        if ("function" == typeof u) o(u, this, e);
                        else {
                            var l = u.length, c = y(u, l);
                            for(r = 0; r < l; ++r)o(c[r], this, e);
                        }
                        return !0;
                    }, s.prototype.addListener = function(t, e) {
                        return f(this, t, e, !1);
                    }, s.prototype.on = s.prototype.addListener, s.prototype.prependListener = function(t, e) {
                        return f(this, t, e, !0);
                    }, s.prototype.once = function(t, e) {
                        return l(e), this.on(t, p(this, t, e)), this;
                    }, s.prototype.prependOnceListener = function(t, e) {
                        return l(e), this.prependListener(t, p(this, t, e)), this;
                    }, s.prototype.removeListener = function(t, e) {
                        var r, n, i, o, a;
                        if (l(e), void 0 === (n = this._events)) return this;
                        if (void 0 === (r = n[t])) return this;
                        if (r === e || r.listener === e) 0 == --this._eventsCount ? this._events = Object.create(null) : (delete n[t], n.removeListener && this.emit("removeListener", t, r.listener || e));
                        else if ("function" != typeof r) {
                            for(i = -1, o = r.length - 1; o >= 0; o--)if (r[o] === e || r[o].listener === e) {
                                a = r[o].listener, i = o;
                                break;
                            }
                            if (i < 0) return this;
                            0 === i ? r.shift() : function(t, e) {
                                for(; e + 1 < t.length; e++)t[e] = t[e + 1];
                                t.pop();
                            }(r, i), 1 === r.length && (n[t] = r[0]), void 0 !== n.removeListener && this.emit("removeListener", t, a || e);
                        }
                        return this;
                    }, s.prototype.off = s.prototype.removeListener, s.prototype.removeAllListeners = function(t) {
                        var e, r, n;
                        if (void 0 === (r = this._events)) return this;
                        if (void 0 === r.removeListener) return 0 === arguments.length ? (this._events = Object.create(null), this._eventsCount = 0) : void 0 !== r[t] && (0 == --this._eventsCount ? this._events = Object.create(null) : delete r[t]), this;
                        if (0 === arguments.length) {
                            var i, o = Object.keys(r);
                            for(n = 0; n < o.length; ++n)"removeListener" !== (i = o[n]) && this.removeAllListeners(i);
                            return this.removeAllListeners("removeListener"), this._events = Object.create(null), this._eventsCount = 0, this;
                        }
                        if ("function" == typeof (e = r[t])) this.removeListener(t, e);
                        else if (void 0 !== e) for(n = e.length - 1; n >= 0; n--)this.removeListener(t, e[n]);
                        return this;
                    }, s.prototype.listeners = function(t) {
                        return d(this, t, !0);
                    }, s.prototype.rawListeners = function(t) {
                        return d(this, t, !1);
                    }, s.listenerCount = function(t, e) {
                        return "function" == typeof t.listenerCount ? t.listenerCount(e) : m.call(t, e);
                    }, s.prototype.listenerCount = m, s.prototype.eventNames = function() {
                        return this._eventsCount > 0 ? n(this._events) : [];
                    };
                },
                function(t, e, r) {
                    t.exports = r(62).EventEmitter;
                },
                function(t, e, r) {
                    "use strict";
                    var n = r(28);
                    function i(t, e) {
                        t.emit("error", e);
                    }
                    t.exports = {
                        destroy: function(t, e) {
                            var r = this, o = this._readableState && this._readableState.destroyed, a = this._writableState && this._writableState.destroyed;
                            return o || a ? (e ? e(t) : t && (this._writableState ? this._writableState.errorEmitted || (this._writableState.errorEmitted = !0, n.nextTick(i, this, t)) : n.nextTick(i, this, t)), this) : (this._readableState && (this._readableState.destroyed = !0), this._writableState && (this._writableState.destroyed = !0), this._destroy(t || null, function(t) {
                                !e && t ? r._writableState ? r._writableState.errorEmitted || (r._writableState.errorEmitted = !0, n.nextTick(i, r, t)) : n.nextTick(i, r, t) : e && e(t);
                            }), this);
                        },
                        undestroy: function() {
                            this._readableState && (this._readableState.destroyed = !1, this._readableState.reading = !1, this._readableState.ended = !1, this._readableState.endEmitted = !1), this._writableState && (this._writableState.destroyed = !1, this._writableState.ended = !1, this._writableState.ending = !1, this._writableState.finalCalled = !1, this._writableState.prefinished = !1, this._writableState.finished = !1, this._writableState.errorEmitted = !1);
                        }
                    };
                },
                function(t, e, r) {
                    "use strict";
                    (function(e, n, i) {
                        var o = r(28);
                        function a(t) {
                            var e = this;
                            this.next = null, this.entry = null, this.finish = function() {
                                !function(t, e, r) {
                                    var n = t.entry;
                                    for(t.entry = null; n;){
                                        var i = n.callback;
                                        e.pendingcb--, i(void 0), n = n.next;
                                    }
                                    e.corkedRequestsFree.next = t;
                                }(e, t);
                            };
                        }
                        t.exports = v;
                        var s, u = !e.browser && [
                            "v0.10",
                            "v0.9."
                        ].indexOf(e.version.slice(0, 5)) > -1 ? n : o.nextTick;
                        v.WritableState = g;
                        var l = Object.create(r(21));
                        l.inherits = r(10);
                        var c, f = {
                            deprecate: r(120)
                        }, h = r(63), p = r(43).Buffer, d = (void 0 !== i ? i : "undefined" != typeof window ? window : "undefined" != typeof self ? self : {}).Uint8Array || function() {}, m = r(64);
                        function y() {}
                        function g(t, e) {
                            s = s || r(14), t = t || {};
                            var n = e instanceof s;
                            this.objectMode = !!t.objectMode, n && (this.objectMode = this.objectMode || !!t.writableObjectMode);
                            var i = t.highWaterMark, l = t.writableHighWaterMark, c = this.objectMode ? 16 : 16384;
                            this.highWaterMark = i || 0 === i ? i : n && (l || 0 === l) ? l : c, this.highWaterMark = Math.floor(this.highWaterMark), this.finalCalled = !1, this.needDrain = !1, this.ending = !1, this.ended = !1, this.finished = !1, this.destroyed = !1;
                            var f = !1 === t.decodeStrings;
                            this.decodeStrings = !f, this.defaultEncoding = t.defaultEncoding || "utf8", this.length = 0, this.writing = !1, this.corked = 0, this.sync = !0, this.bufferProcessing = !1, this.onwrite = function(t) {
                                !function(t, e) {
                                    var r = t._writableState, n = r.sync, i = r.writecb;
                                    if (function(t) {
                                        t.writing = !1, t.writecb = null, t.length -= t.writelen, t.writelen = 0;
                                    }(r), e) !function(t, e, r, n, i) {
                                        --e.pendingcb, r ? (o.nextTick(i, n), o.nextTick(E, t, e), t._writableState.errorEmitted = !0, t.emit("error", n)) : (i(n), t._writableState.errorEmitted = !0, t.emit("error", n), E(t, e));
                                    }(t, r, n, e, i);
                                    else {
                                        var a = _(r);
                                        a || r.corked || r.bufferProcessing || !r.bufferedRequest || w(t, r), n ? u(x, t, r, a, i) : x(t, r, a, i);
                                    }
                                }(e, t);
                            }, this.writecb = null, this.writelen = 0, this.bufferedRequest = null, this.lastBufferedRequest = null, this.pendingcb = 0, this.prefinished = !1, this.errorEmitted = !1, this.bufferedRequestCount = 0, this.corkedRequestsFree = new a(this);
                        }
                        function v(t) {
                            if (s = s || r(14), !(c.call(v, this) || this instanceof s)) return new v(t);
                            this._writableState = new g(t, this), this.writable = !0, t && ("function" == typeof t.write && (this._write = t.write), "function" == typeof t.writev && (this._writev = t.writev), "function" == typeof t.destroy && (this._destroy = t.destroy), "function" == typeof t.final && (this._final = t.final)), h.call(this);
                        }
                        function b(t, e, r, n, i, o, a) {
                            e.writelen = n, e.writecb = a, e.writing = !0, e.sync = !0, r ? t._writev(i, e.onwrite) : t._write(i, o, e.onwrite), e.sync = !1;
                        }
                        function x(t, e, r, n) {
                            r || function(t, e) {
                                0 === e.length && e.needDrain && (e.needDrain = !1, t.emit("drain"));
                            }(t, e), e.pendingcb--, n(), E(t, e);
                        }
                        function w(t, e) {
                            e.bufferProcessing = !0;
                            var r = e.bufferedRequest;
                            if (t._writev && r && r.next) {
                                var n = e.bufferedRequestCount, i = new Array(n), o = e.corkedRequestsFree;
                                o.entry = r;
                                for(var s = 0, u = !0; r;)i[s] = r, r.isBuf || (u = !1), r = r.next, s += 1;
                                i.allBuffers = u, b(t, e, !0, e.length, i, "", o.finish), e.pendingcb++, e.lastBufferedRequest = null, o.next ? (e.corkedRequestsFree = o.next, o.next = null) : e.corkedRequestsFree = new a(e), e.bufferedRequestCount = 0;
                            } else {
                                for(; r;){
                                    var l = r.chunk, c = r.encoding, f = r.callback;
                                    if (b(t, e, !1, e.objectMode ? 1 : l.length, l, c, f), r = r.next, e.bufferedRequestCount--, e.writing) break;
                                }
                                null === r && (e.lastBufferedRequest = null);
                            }
                            e.bufferedRequest = r, e.bufferProcessing = !1;
                        }
                        function _(t) {
                            return t.ending && 0 === t.length && null === t.bufferedRequest && !t.finished && !t.writing;
                        }
                        function A(t, e) {
                            t._final(function(r) {
                                e.pendingcb--, r && t.emit("error", r), e.prefinished = !0, t.emit("prefinish"), E(t, e);
                            });
                        }
                        function E(t, e) {
                            var r = _(e);
                            return r && (function(t, e) {
                                e.prefinished || e.finalCalled || ("function" == typeof t._final ? (e.pendingcb++, e.finalCalled = !0, o.nextTick(A, t, e)) : (e.prefinished = !0, t.emit("prefinish")));
                            }(t, e), 0 === e.pendingcb && (e.finished = !0, t.emit("finish"))), r;
                        }
                        l.inherits(v, h), g.prototype.getBuffer = function() {
                            for(var t = this.bufferedRequest, e = []; t;)e.push(t), t = t.next;
                            return e;
                        }, function() {
                            try {
                                Object.defineProperty(g.prototype, "buffer", {
                                    get: f.deprecate(function() {
                                        return this.getBuffer();
                                    }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
                                });
                            } catch (t) {}
                        }(), "function" == typeof Symbol && Symbol.hasInstance && "function" == typeof Function.prototype[Symbol.hasInstance] ? (c = Function.prototype[Symbol.hasInstance], Object.defineProperty(v, Symbol.hasInstance, {
                            value: function(t) {
                                return !!c.call(this, t) || this === v && t && t._writableState instanceof g;
                            }
                        })) : c = function(t) {
                            return t instanceof this;
                        }, v.prototype.pipe = function() {
                            this.emit("error", new Error("Cannot pipe, not readable"));
                        }, v.prototype.write = function(t, e, r) {
                            var n, i = this._writableState, a = !1, s = !i.objectMode && (n = t, p.isBuffer(n) || n instanceof d);
                            return s && !p.isBuffer(t) && (t = function(t) {
                                return p.from(t);
                            }(t)), "function" == typeof e && (r = e, e = null), s ? e = "buffer" : e || (e = i.defaultEncoding), "function" != typeof r && (r = y), i.ended ? function(t, e) {
                                var r = new Error("write after end");
                                t.emit("error", r), o.nextTick(e, r);
                            }(this, r) : (s || function(t, e, r, n) {
                                var i = !0, a = !1;
                                return null === r ? a = new TypeError("May not write null values to stream") : "string" == typeof r || void 0 === r || e.objectMode || (a = new TypeError("Invalid non-string/buffer chunk")), a && (t.emit("error", a), o.nextTick(n, a), i = !1), i;
                            }(this, i, t, r)) && (i.pendingcb++, a = function(t, e, r, n, i, o) {
                                if (!r) {
                                    var a = function(t, e, r) {
                                        return t.objectMode || !1 === t.decodeStrings || "string" != typeof e || (e = p.from(e, r)), e;
                                    }(e, n, i);
                                    n !== a && (r = !0, i = "buffer", n = a);
                                }
                                var s = e.objectMode ? 1 : n.length;
                                e.length += s;
                                var u = e.length < e.highWaterMark;
                                if (u || (e.needDrain = !0), e.writing || e.corked) {
                                    var l = e.lastBufferedRequest;
                                    e.lastBufferedRequest = {
                                        chunk: n,
                                        encoding: i,
                                        isBuf: r,
                                        callback: o,
                                        next: null
                                    }, l ? l.next = e.lastBufferedRequest : e.bufferedRequest = e.lastBufferedRequest, e.bufferedRequestCount += 1;
                                } else b(t, e, !1, s, n, i, o);
                                return u;
                            }(this, i, s, t, e, r)), a;
                        }, v.prototype.cork = function() {
                            this._writableState.corked++;
                        }, v.prototype.uncork = function() {
                            var t = this._writableState;
                            t.corked && (t.corked--, t.writing || t.corked || t.bufferProcessing || !t.bufferedRequest || w(this, t));
                        }, v.prototype.setDefaultEncoding = function(t) {
                            if ("string" == typeof t && (t = t.toLowerCase()), !([
                                "hex",
                                "utf8",
                                "utf-8",
                                "ascii",
                                "binary",
                                "base64",
                                "ucs2",
                                "ucs-2",
                                "utf16le",
                                "utf-16le",
                                "raw"
                            ].indexOf((t + "").toLowerCase()) > -1)) throw new TypeError("Unknown encoding: " + t);
                            return this._writableState.defaultEncoding = t, this;
                        }, Object.defineProperty(v.prototype, "writableHighWaterMark", {
                            enumerable: !1,
                            get: function() {
                                return this._writableState.highWaterMark;
                            }
                        }), v.prototype._write = function(t, e, r) {
                            r(new Error("_write() is not implemented"));
                        }, v.prototype._writev = null, v.prototype.end = function(t, e, r) {
                            var n = this._writableState;
                            "function" == typeof t ? (r = t, t = null, e = null) : "function" == typeof e && (r = e, e = null), null != t && this.write(t, e), n.corked && (n.corked = 1, this.uncork()), n.ending || function(t, e, r) {
                                e.ending = !0, E(t, e), r && (e.finished ? o.nextTick(r) : t.once("finish", r)), e.ended = !0, t.writable = !1;
                            }(this, n, r);
                        }, Object.defineProperty(v.prototype, "destroyed", {
                            get: function() {
                                return void 0 !== this._writableState && this._writableState.destroyed;
                            },
                            set: function(t) {
                                this._writableState && (this._writableState.destroyed = t);
                            }
                        }), v.prototype.destroy = m.destroy, v.prototype._undestroy = m.undestroy, v.prototype._destroy = function(t, e) {
                            this.end(), e(t);
                        };
                    }).call(this, r(8), r(118).setImmediate, r(3));
                },
                function(t, e, r) {
                    "use strict";
                    var n = r(121).Buffer, i = n.isEncoding || function(t) {
                        switch((t = "" + t) && t.toLowerCase()){
                            case "hex":
                            case "utf8":
                            case "utf-8":
                            case "ascii":
                            case "binary":
                            case "base64":
                            case "ucs2":
                            case "ucs-2":
                            case "utf16le":
                            case "utf-16le":
                            case "raw":
                                return !0;
                            default:
                                return !1;
                        }
                    };
                    function o(t) {
                        var e;
                        switch(this.encoding = function(t) {
                            var e = function(t) {
                                if (!t) return "utf8";
                                for(var e;;)switch(t){
                                    case "utf8":
                                    case "utf-8":
                                        return "utf8";
                                    case "ucs2":
                                    case "ucs-2":
                                    case "utf16le":
                                    case "utf-16le":
                                        return "utf16le";
                                    case "latin1":
                                    case "binary":
                                        return "latin1";
                                    case "base64":
                                    case "ascii":
                                    case "hex":
                                        return t;
                                    default:
                                        if (e) return;
                                        t = ("" + t).toLowerCase(), e = !0;
                                }
                            }(t);
                            if ("string" != typeof e && (n.isEncoding === i || !i(t))) throw new Error("Unknown encoding: " + t);
                            return e || t;
                        }(t), this.encoding){
                            case "utf16le":
                                this.text = u, this.end = l, e = 4;
                                break;
                            case "utf8":
                                this.fillLast = s, e = 4;
                                break;
                            case "base64":
                                this.text = c, this.end = f, e = 3;
                                break;
                            default:
                                return this.write = h, void (this.end = p);
                        }
                        this.lastNeed = 0, this.lastTotal = 0, this.lastChar = n.allocUnsafe(e);
                    }
                    function a(t) {
                        return t <= 127 ? 0 : t >> 5 == 6 ? 2 : t >> 4 == 14 ? 3 : t >> 3 == 30 ? 4 : -1;
                    }
                    function s(t) {
                        var e = this.lastTotal - this.lastNeed, r = function(t, e, r) {
                            if (128 != (192 & e[0])) return t.lastNeed = 0, "\uFFFD".repeat(r);
                            if (t.lastNeed > 1 && e.length > 1) {
                                if (128 != (192 & e[1])) return t.lastNeed = 1, "\uFFFD".repeat(r + 1);
                                if (t.lastNeed > 2 && e.length > 2 && 128 != (192 & e[2])) return t.lastNeed = 2, "\uFFFD".repeat(r + 2);
                            }
                        }(this, t, e);
                        return void 0 !== r ? r : this.lastNeed <= t.length ? (t.copy(this.lastChar, e, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal)) : (t.copy(this.lastChar, e, 0, t.length), void (this.lastNeed -= t.length));
                    }
                    function u(t, e) {
                        if ((t.length - e) % 2 == 0) {
                            var r = t.toString("utf16le", e);
                            if (r) {
                                var n = r.charCodeAt(r.length - 1);
                                if (n >= 55296 && n <= 56319) return this.lastNeed = 2, this.lastTotal = 4, this.lastChar[0] = t[t.length - 2], this.lastChar[1] = t[t.length - 1], r.slice(0, -1);
                            }
                            return r;
                        }
                        return this.lastNeed = 1, this.lastTotal = 2, this.lastChar[0] = t[t.length - 1], t.toString("utf16le", e, t.length - 1);
                    }
                    function l(t) {
                        var e = t && t.length ? this.write(t) : "";
                        if (this.lastNeed) {
                            var r = this.lastTotal - this.lastNeed;
                            return e + this.lastChar.toString("utf16le", 0, r);
                        }
                        return e;
                    }
                    function c(t, e) {
                        var r = (t.length - e) % 3;
                        return 0 === r ? t.toString("base64", e) : (this.lastNeed = 3 - r, this.lastTotal = 3, 1 === r ? this.lastChar[0] = t[t.length - 1] : (this.lastChar[0] = t[t.length - 2], this.lastChar[1] = t[t.length - 1]), t.toString("base64", e, t.length - r));
                    }
                    function f(t) {
                        var e = t && t.length ? this.write(t) : "";
                        return this.lastNeed ? e + this.lastChar.toString("base64", 0, 3 - this.lastNeed) : e;
                    }
                    function h(t) {
                        return t.toString(this.encoding);
                    }
                    function p(t) {
                        return t && t.length ? this.write(t) : "";
                    }
                    e.StringDecoder = o, o.prototype.write = function(t) {
                        if (0 === t.length) return "";
                        var e, r;
                        if (this.lastNeed) {
                            if (void 0 === (e = this.fillLast(t))) return "";
                            r = this.lastNeed, this.lastNeed = 0;
                        } else r = 0;
                        return r < t.length ? e ? e + this.text(t, r) : this.text(t, r) : e || "";
                    }, o.prototype.end = function(t) {
                        var e = t && t.length ? this.write(t) : "";
                        return this.lastNeed ? e + "\uFFFD".repeat(this.lastTotal - this.lastNeed) : e;
                    }, o.prototype.text = function(t, e) {
                        var r = function(t, e, r) {
                            var n = e.length - 1;
                            if (n < r) return 0;
                            var i = a(e[n]);
                            return i >= 0 ? (i > 0 && (t.lastNeed = i - 1), i) : --n < r ? 0 : (i = a(e[n])) >= 0 ? (i > 0 && (t.lastNeed = i - 2), i) : --n < r ? 0 : (i = a(e[n])) >= 0 ? (i > 0 && (2 === i ? i = 0 : t.lastNeed = i - 3), i) : 0;
                        }(this, t, e);
                        if (!this.lastNeed) return t.toString("utf8", e);
                        this.lastTotal = r;
                        var n = t.length - (r - this.lastNeed);
                        return t.copy(this.lastChar, 0, n), t.toString("utf8", e, n);
                    }, o.prototype.fillLast = function(t) {
                        if (this.lastNeed <= t.length) return t.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
                        t.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, t.length), this.lastNeed -= t.length;
                    };
                },
                function(t, e, r) {
                    "use strict";
                    t.exports = a;
                    var n = r(14), i = Object.create(r(21));
                    function o(t, e) {
                        var r = this._transformState;
                        r.transforming = !1;
                        var n = r.writecb;
                        if (!n) return this.emit("error", new Error("write callback called multiple times"));
                        r.writechunk = null, r.writecb = null, null != e && this.push(e), n(t);
                        var i = this._readableState;
                        i.reading = !1, (i.needReadable || i.length < i.highWaterMark) && this._read(i.highWaterMark);
                    }
                    function a(t) {
                        if (!(this instanceof a)) return new a(t);
                        n.call(this, t), this._transformState = {
                            afterTransform: o.bind(this),
                            needTransform: !1,
                            transforming: !1,
                            writecb: null,
                            writechunk: null,
                            writeencoding: null
                        }, this._readableState.needReadable = !0, this._readableState.sync = !1, t && ("function" == typeof t.transform && (this._transform = t.transform), "function" == typeof t.flush && (this._flush = t.flush)), this.on("prefinish", s);
                    }
                    function s() {
                        var t = this;
                        "function" == typeof this._flush ? this._flush(function(e, r) {
                            u(t, e, r);
                        }) : u(this, null, null);
                    }
                    function u(t, e, r) {
                        if (e) return t.emit("error", e);
                        if (null != r && t.push(r), t._writableState.length) throw new Error("Calling transform done when ws.length != 0");
                        if (t._transformState.transforming) throw new Error("Calling transform done when still transforming");
                        return t.push(null);
                    }
                    i.inherits = r(10), i.inherits(a, n), a.prototype.push = function(t, e) {
                        return this._transformState.needTransform = !1, n.prototype.push.call(this, t, e);
                    }, a.prototype._transform = function(t, e, r) {
                        throw new Error("_transform() is not implemented");
                    }, a.prototype._write = function(t, e, r) {
                        var n = this._transformState;
                        if (n.writecb = r, n.writechunk = t, n.writeencoding = e, !n.transforming) {
                            var i = this._readableState;
                            (n.needTransform || i.needReadable || i.length < i.highWaterMark) && this._read(i.highWaterMark);
                        }
                    }, a.prototype._read = function(t) {
                        var e = this._transformState;
                        null !== e.writechunk && e.writecb && !e.transforming ? (e.transforming = !0, this._transform(e.writechunk, e.writeencoding, e.afterTransform)) : e.needTransform = !0;
                    }, a.prototype._destroy = function(t, e) {
                        var r = this;
                        n.prototype._destroy.call(this, t, function(t) {
                            e(t), r.emit("close");
                        });
                    };
                },
                function(t, e, r) {
                    "use strict";
                    (function(t) {
                        var n = r(198), i = r(58), o = r(57);
                        const a = "undefined" != typeof navigator ? navigator.hardwareConcurrency : null;
                        e.a = class {
                            constructor(e = a){
                                const r = new n.a(t);
                                this.pool = Object(i.a)(()=>Object(o.a)(r), e);
                            }
                            async decode(t, e) {
                                return new Promise((r, n)=>{
                                    this.pool.queue(async (i)=>{
                                        try {
                                            const n = await i(t, e);
                                            r(n);
                                        } catch (t) {
                                            n(t);
                                        }
                                    });
                                });
                            }
                            destroy() {
                                this.pool.terminate(!0);
                            }
                        };
                    }).call(this, r(133));
                },
                function(t, e, r) {
                    (function(t) {
                        e.fetch = s(t.fetch) && s(t.ReadableStream), e.writableStream = s(t.WritableStream), e.abortController = s(t.AbortController), e.blobConstructor = !1;
                        try {
                            new Blob([
                                new ArrayBuffer(1)
                            ]), e.blobConstructor = !0;
                        } catch (t) {}
                        var r;
                        function n() {
                            if (void 0 !== r) return r;
                            if (t.XMLHttpRequest) {
                                r = new t.XMLHttpRequest;
                                try {
                                    r.open("GET", t.XDomainRequest ? "/" : "https://example.com");
                                } catch (t) {
                                    r = null;
                                }
                            } else r = null;
                            return r;
                        }
                        function i(t) {
                            var e = n();
                            if (!e) return !1;
                            try {
                                return e.responseType = t, e.responseType === t;
                            } catch (t) {}
                            return !1;
                        }
                        var o = void 0 !== t.ArrayBuffer, a = o && s(t.ArrayBuffer.prototype.slice);
                        function s(t) {
                            return "function" == typeof t;
                        }
                        e.arraybuffer = e.fetch || o && i("arraybuffer"), e.msstream = !e.fetch && a && i("ms-stream"), e.mozchunkedarraybuffer = !e.fetch && o && i("moz-chunked-arraybuffer"), e.overrideMimeType = e.fetch || !!n() && s(n().overrideMimeType), e.vbArray = s(t.VBArray), r = null;
                    }).call(this, r(3));
                },
                function(t, e, r) {
                    (function(t, n, i) {
                        var o = r(69), a = r(10), s = r(42), u = e.readyStates = {
                            UNSENT: 0,
                            OPENED: 1,
                            HEADERS_RECEIVED: 2,
                            LOADING: 3,
                            DONE: 4
                        }, l = e.IncomingMessage = function(e, r, a, u) {
                            var l = this;
                            if (s.Readable.call(l), l._mode = a, l.headers = {}, l.rawHeaders = [], l.trailers = {}, l.rawTrailers = [], l.on("end", function() {
                                t.nextTick(function() {
                                    l.emit("close");
                                });
                            }), "fetch" === a) {
                                if (l._fetchResponse = r, l.url = r.url, l.statusCode = r.status, l.statusMessage = r.statusText, r.headers.forEach(function(t, e) {
                                    l.headers[e.toLowerCase()] = t, l.rawHeaders.push(e, t);
                                }), o.writableStream) {
                                    var c = new WritableStream({
                                        write: function(t) {
                                            return new Promise(function(e, r) {
                                                l._destroyed ? r() : l.push(new n(t)) ? e() : l._resumeFetch = e;
                                            });
                                        },
                                        close: function() {
                                            i.clearTimeout(u), l._destroyed || l.push(null);
                                        },
                                        abort: function(t) {
                                            l._destroyed || l.emit("error", t);
                                        }
                                    });
                                    try {
                                        return void r.body.pipeTo(c).catch(function(t) {
                                            i.clearTimeout(u), l._destroyed || l.emit("error", t);
                                        });
                                    } catch (t) {}
                                }
                                var f = r.body.getReader();
                                !function t() {
                                    f.read().then(function(e) {
                                        if (!l._destroyed) {
                                            if (e.done) return i.clearTimeout(u), void l.push(null);
                                            l.push(new n(e.value)), t();
                                        }
                                    }).catch(function(t) {
                                        i.clearTimeout(u), l._destroyed || l.emit("error", t);
                                    });
                                }();
                            } else if (l._xhr = e, l._pos = 0, l.url = e.responseURL, l.statusCode = e.status, l.statusMessage = e.statusText, e.getAllResponseHeaders().split(/\r?\n/).forEach(function(t) {
                                var e = t.match(/^([^:]+):\s*(.*)/);
                                if (e) {
                                    var r = e[1].toLowerCase();
                                    "set-cookie" === r ? (void 0 === l.headers[r] && (l.headers[r] = []), l.headers[r].push(e[2])) : void 0 !== l.headers[r] ? l.headers[r] += ", " + e[2] : l.headers[r] = e[2], l.rawHeaders.push(e[1], e[2]);
                                }
                            }), l._charset = "x-user-defined", !o.overrideMimeType) {
                                var h = l.rawHeaders["mime-type"];
                                if (h) {
                                    var p = h.match(/;\s*charset=([^;])(;|$)/);
                                    p && (l._charset = p[1].toLowerCase());
                                }
                                l._charset || (l._charset = "utf-8");
                            }
                        };
                        a(l, s.Readable), l.prototype._read = function() {
                            var t = this._resumeFetch;
                            t && (this._resumeFetch = null, t());
                        }, l.prototype._onXHRProgress = function() {
                            var t = this, e = t._xhr, r = null;
                            switch(t._mode){
                                case "text:vbarray":
                                    if (e.readyState !== u.DONE) break;
                                    try {
                                        r = new i.VBArray(e.responseBody).toArray();
                                    } catch (t) {}
                                    if (null !== r) {
                                        t.push(new n(r));
                                        break;
                                    }
                                case "text":
                                    try {
                                        r = e.responseText;
                                    } catch (e) {
                                        t._mode = "text:vbarray";
                                        break;
                                    }
                                    if (r.length > t._pos) {
                                        var o = r.substr(t._pos);
                                        if ("x-user-defined" === t._charset) {
                                            for(var a = new n(o.length), s = 0; s < o.length; s++)a[s] = 255 & o.charCodeAt(s);
                                            t.push(a);
                                        } else t.push(o, t._charset);
                                        t._pos = r.length;
                                    }
                                    break;
                                case "arraybuffer":
                                    if (e.readyState !== u.DONE || !e.response) break;
                                    r = e.response, t.push(new n(new Uint8Array(r)));
                                    break;
                                case "moz-chunked-arraybuffer":
                                    if (r = e.response, e.readyState !== u.LOADING || !r) break;
                                    t.push(new n(new Uint8Array(r)));
                                    break;
                                case "ms-stream":
                                    if (r = e.response, e.readyState !== u.LOADING) break;
                                    var l = new i.MSStreamReader;
                                    l.onprogress = function() {
                                        l.result.byteLength > t._pos && (t.push(new n(new Uint8Array(l.result.slice(t._pos)))), t._pos = l.result.byteLength);
                                    }, l.onload = function() {
                                        t.push(null);
                                    }, l.readAsArrayBuffer(r);
                            }
                            t._xhr.readyState === u.DONE && "ms-stream" !== t._mode && t.push(null);
                        };
                    }).call(this, r(8), r(7).Buffer, r(3));
                },
                function(t, e, r) {
                    "use strict";
                    var n = r(46), i = Object.prototype.hasOwnProperty, o = Array.isArray, a = function() {
                        for(var t = [], e = 0; e < 256; ++e)t.push("%" + ((e < 16 ? "0" : "") + e.toString(16)).toUpperCase());
                        return t;
                    }(), s = function(t, e) {
                        for(var r = e && e.plainObjects ? Object.create(null) : {}, n = 0; n < t.length; ++n)void 0 !== t[n] && (r[n] = t[n]);
                        return r;
                    };
                    t.exports = {
                        arrayToObject: s,
                        assign: function(t, e) {
                            return Object.keys(e).reduce(function(t, r) {
                                return t[r] = e[r], t;
                            }, t);
                        },
                        combine: function(t, e) {
                            return [].concat(t, e);
                        },
                        compact: function(t) {
                            for(var e = [
                                {
                                    obj: {
                                        o: t
                                    },
                                    prop: "o"
                                }
                            ], r = [], n = 0; n < e.length; ++n)for(var i = e[n], a = i.obj[i.prop], s = Object.keys(a), u = 0; u < s.length; ++u){
                                var l = s[u], c = a[l];
                                "object" == typeof c && null !== c && -1 === r.indexOf(c) && (e.push({
                                    obj: a,
                                    prop: l
                                }), r.push(c));
                            }
                            return function(t) {
                                for(; t.length > 1;){
                                    var e = t.pop(), r = e.obj[e.prop];
                                    if (o(r)) {
                                        for(var n = [], i = 0; i < r.length; ++i)void 0 !== r[i] && n.push(r[i]);
                                        e.obj[e.prop] = n;
                                    }
                                }
                            }(e), t;
                        },
                        decode: function(t, e, r) {
                            var n = t.replace(/\+/g, " ");
                            if ("iso-8859-1" === r) return n.replace(/%[0-9a-f]{2}/gi, unescape);
                            try {
                                return decodeURIComponent(n);
                            } catch (t) {
                                return n;
                            }
                        },
                        encode: function(t, e, r, i, o) {
                            if (0 === t.length) return t;
                            var s = t;
                            if ("symbol" == typeof t ? s = Symbol.prototype.toString.call(t) : "string" != typeof t && (s = String(t)), "iso-8859-1" === r) return escape(s).replace(/%u[0-9a-f]{4}/gi, function(t) {
                                return "%26%23" + parseInt(t.slice(2), 16) + "%3B";
                            });
                            for(var u = "", l = 0; l < s.length; ++l){
                                var c = s.charCodeAt(l);
                                45 === c || 46 === c || 95 === c || 126 === c || c >= 48 && c <= 57 || c >= 65 && c <= 90 || c >= 97 && c <= 122 || o === n.RFC1738 && (40 === c || 41 === c) ? u += s.charAt(l) : c < 128 ? u += a[c] : c < 2048 ? u += a[192 | c >> 6] + a[128 | 63 & c] : c < 55296 || c >= 57344 ? u += a[224 | c >> 12] + a[128 | c >> 6 & 63] + a[128 | 63 & c] : (l += 1, c = 65536 + ((1023 & c) << 10 | 1023 & s.charCodeAt(l)), u += a[240 | c >> 18] + a[128 | c >> 12 & 63] + a[128 | c >> 6 & 63] + a[128 | 63 & c]);
                            }
                            return u;
                        },
                        isBuffer: function(t) {
                            return !(!t || "object" != typeof t || !(t.constructor && t.constructor.isBuffer && t.constructor.isBuffer(t)));
                        },
                        isRegExp: function(t) {
                            return "[object RegExp]" === Object.prototype.toString.call(t);
                        },
                        maybeMap: function(t, e) {
                            if (o(t)) {
                                for(var r = [], n = 0; n < t.length; n += 1)r.push(e(t[n]));
                                return r;
                            }
                            return e(t);
                        },
                        merge: function t(e, r, n) {
                            if (!r) return e;
                            if ("object" != typeof r) {
                                if (o(e)) e.push(r);
                                else {
                                    if (!e || "object" != typeof e) return [
                                        e,
                                        r
                                    ];
                                    (n && (n.plainObjects || n.allowPrototypes) || !i.call(Object.prototype, r)) && (e[r] = !0);
                                }
                                return e;
                            }
                            if (!e || "object" != typeof e) return [
                                e
                            ].concat(r);
                            var a = e;
                            return o(e) && !o(r) && (a = s(e, n)), o(e) && o(r) ? (r.forEach(function(r, o) {
                                if (i.call(e, o)) {
                                    var a = e[o];
                                    a && "object" == typeof a && r && "object" == typeof r ? e[o] = t(a, r, n) : e.push(r);
                                } else e[o] = r;
                            }), e) : Object.keys(r).reduce(function(e, o) {
                                var a = r[o];
                                return i.call(e, o) ? e[o] = t(e[o], a, n) : e[o] = a, e;
                            }, a);
                        }
                    };
                },
                function(t, e, r) {
                    function n(t) {
                        try {
                            t[Symbol.iterator] = function() {
                                return this;
                            };
                        } catch (t) {}
                    }
                    function i(t) {
                        t["@@iterator"] = function() {
                            return this;
                        };
                    }
                    function o(t) {
                        const e = {
                            next: t
                        };
                        return n(e), i(e), e;
                    }
                    function a(t) {
                        try {
                            return t.constructor.name.endsWith("Array");
                        } catch  {
                            return !1;
                        }
                    }
                    function s(t) {
                        try {
                            return "function" == typeof t.next;
                        } catch  {
                            return !1;
                        }
                    }
                    function u(t) {
                        try {
                            return "@@iterator" in t;
                        } catch  {
                            return !1;
                        }
                    }
                    function l(t) {
                        try {
                            return Symbol.iterator in t.constructor.prototype;
                        } catch  {
                            return !1;
                        }
                    }
                    function c(t) {
                        try {
                            return Symbol.iterator in t && "function" == typeof t.next && !1 === t.propertyIsEnumerable("next");
                        } catch  {
                            return !1;
                        }
                    }
                    function f(t) {
                        const e = t["@@iterator"];
                        return s(e) ? e : "function" == typeof e ? e() : void 0;
                    }
                    function h(t) {
                        let e = 0, r = t.length;
                        return o(()=>e++ < r ? {
                                value: t[e],
                                done: !1
                            } : {
                                done: !0
                            });
                    }
                    function p(t) {
                        if (c(t)) return t;
                        if (l(t)) return t[Symbol.iterator]();
                        if (s(t)) return o(t.next);
                        if (u(t)) return f(t);
                        if ("string" == typeof t || a(t)) return h(t);
                        throw "[iter-fun] unable to determine iterator";
                    }
                    t.exports = {
                        addSymbolIterator: n,
                        addSymbolIteratorFallback: i,
                        isIterator: c,
                        isArray: a,
                        hasNext: s,
                        hasSymbolIterator: l,
                        hasIterator: u,
                        getIterator: f,
                        createIterator: h,
                        getOrCreateIterator: p,
                        wrapNextFunction: o,
                        zip: function(t) {
                            return t = t.map(p), o(function() {
                                const e = t.map((t)=>t.next());
                                return e.every(({ done: t })=>t) ? {
                                    done: !0
                                } : {
                                    done: !1,
                                    value: e.map(({ value: t })=>t)
                                };
                            });
                        }
                    };
                },
                function(t, e, r) {
                    "use strict";
                    function n(t) {
                        "+" === t[0] && (t = t.substring(1));
                        const e = "-" === t[0] ? "-" : "";
                        "-" === e && (t = t.substring(1));
                        const r = t.indexOf("e");
                        if (-1 === r) return e + t;
                        let n = t.indexOf(".");
                        -1 === n && (n = r);
                        const i = Number(t.substring(r + 1)), o = t.substring(0, r).replace(".", ""), a = n + i, s = o.length;
                        if (a >= s) {
                            const t = a - s;
                            let r = o;
                            for(let e = 0; e < t; e++)r += "0";
                            return e + r;
                        }
                        if (a < 0) {
                            let t = "0.";
                            for(let e = 0; e > a; e--)t += "0";
                            return t += o, e + t;
                        }
                        return e + o.substring(0, a) + "." + o.substring(a);
                    }
                    t.exports = n, t.exports.default = n;
                },
                function(t, e, r) {
                    "use strict";
                    t.exports = {
                        MAX_SAFE_INTEGER: 9007199254740991
                    };
                },
                function(t, e, r) {
                    "use strict";
                    const n = r(47);
                    function i(t) {
                        return "0" === t ? "1" : n("1", t);
                    }
                    t.exports = i, t.exports.default = i;
                },
                function(t, e, r) {
                    "use strict";
                    const n = r(4), i = r(0), o = r(9), a = r(22);
                    function s(t) {
                        if (-1 === (t = i(t)).indexOf(".")) return t;
                        const e = a(t);
                        return t = n(t).split(".")[0], "+" === e ? o(t, "1") : "-" === e ? "0" === t || "" === t ? "0" : "-" + t : void 0;
                    }
                    t.exports = s, t.exports.default = s;
                },
                function(t, e, r) {
                    "use strict";
                    const n = r(51);
                    function i(t) {
                        const e = n(t);
                        return [
                            t.replace(/\./g, "").replace(/^0/, ""),
                            1 + "0".repeat(e)
                        ];
                    }
                    t.exports = i, t.exports.default = i;
                },
                function(t, e, r) {
                    const n = r(0), i = r(16);
                    function o(t) {
                        if (t = n(t), !i(t)) throw new Error("can't call is_odd on decimal");
                        return [
                            "1",
                            "3",
                            "5",
                            "7",
                            "9"
                        ].includes(t.charAt(t.length - 1));
                    }
                    t.exports = o, t.exports.default = o;
                },
                function(t, e, r) {
                    "use strict";
                    const n = r(52), i = r(15), o = r(78), a = r(11), s = r(17), u = r(50);
                    function l(t, { max_decimal_digits: e, infinity_times_zero: r = "NaN" } = {}) {
                        const l = t.some((t)=>i(t)), c = t.some((t)=>a(t));
                        if (l && c) return r;
                        if (l) return t.filter((t)=>"-" === u(t)).length % 2 == 0 ? "Infinity" : "-Infinity";
                        if (c) return "0";
                        const f = o(t.filter((t)=>n(t)).length.toString());
                        let h = s(t.map((t)=>t.replace(/i$/, "")), {
                            max_decimal_digits: e
                        });
                        return f && (h += "i"), h;
                    }
                    t.exports = l, t.exports.default = l;
                },
                function(t, e, r) {
                    "use strict";
                    const n = r(0);
                    function i(t) {
                        return "-" === (t = n(t))[0];
                    }
                    t.exports = i, t.exports.default = i;
                },
                function(t, e, r) {
                    "use strict";
                    const n = r(1), i = r(165), o = r(166);
                    function a(t, { max_decimal_digits: e = 100, fraction: r = !1 } = {}) {
                        if (i(t)) {
                            const [i, a] = o(t);
                            return r ? a + "/" + i : n(a, i, {
                                max_decimal_digits: e
                            });
                        }
                        return r ? "1/" + t : n("1", t, {
                            max_decimal_digits: e
                        });
                    }
                    t.exports = a, t.exports.default = a;
                },
                function(t, e, r) {
                    "use strict";
                    const n = r(0), i = r(16);
                    function o(t) {
                        if (t = n(t), !i(t)) throw new Error("can't call is_even on decimal");
                        return [
                            "0",
                            "2",
                            "4",
                            "6",
                            "8"
                        ].includes(t.charAt(t.length - 1));
                    }
                    t.exports = o, t.exports.default = o;
                },
                function(t, e, r) {
                    "use strict";
                    const n = r(76), i = r(84), o = r(1);
                    function a(t, e) {
                        const r = i(t);
                        return "0" === r ? "0" : n(o(r, e, {
                            max_decimal_digits: 1
                        }));
                    }
                    t.exports = a, t.exports.default = a;
                },
                function(t, e, r) {
                    "use strict";
                    const n = r(4), i = r(0);
                    function o(t) {
                        const e = (t = n(i(t))).indexOf(".");
                        return (-1 === e ? t.length : e).toString();
                    }
                    t.exports = o, t.exports.default = o;
                },
                function(t, e, r) {
                    "use strict";
                    const n = r(1), i = r(82), o = r(86), a = r(87);
                    function s(t, e) {
                        const r = a("2", o([
                            "1000",
                            e,
                            e
                        ]));
                        for(; t.endsWith("0") && e.endsWith("0");)t = t.substring(0, t.length - 1), e = e.substring(0, e.length - 1);
                        for(; i(t) && i(e);)t = n(t, "2"), e = n(e, "2");
                        let s = !0;
                        for(; s;){
                            s = !1;
                            for(let i = 0; i < r.length; i++){
                                const o = r[i], a = o.length + 1, u = n(t, o, {
                                    ellipsis: !0,
                                    max_decimal_digits: a
                                });
                                if (-1 === u.indexOf(".")) {
                                    const r = n(e, o, {
                                        ellipsis: !0,
                                        max_decimal_digits: a
                                    });
                                    if (-1 === r.indexOf(".")) {
                                        t = u, e = r, s = !0;
                                        break;
                                    }
                                }
                            }
                        }
                        return [
                            t,
                            e
                        ];
                    }
                    t.exports = s, t.exports.default = s;
                },
                function(t, e, r) {
                    "use strict";
                    const n = r(0), i = r(34);
                    function o(t) {
                        "string" == typeof t && (t = Array.prototype.slice.call(arguments));
                        let e = n(t[0]);
                        const r = t.length;
                        for(let n = 1; n < r; n++){
                            const r = t[n];
                            "<" === i(r, e) && (e = r);
                        }
                        return e;
                    }
                    t.exports = o, t.exports.default = o;
                },
                function(t, e, r) {
                    "use strict";
                    const n = r(5), i = r(1), o = r(16), a = r(9);
                    function s(t = "0", e = "100") {
                        const r = [
                            "2",
                            "3",
                            "5",
                            "7",
                            "11"
                        ].filter((r)=>"<" !== n(r, t) && ">" !== n(r, e));
                        let s = "13";
                        for(; ">" !== n(s, e);)/^\d+5/.test(s) || /^(\d)\1+/.test(s) || [
                            "9",
                            "7",
                            "3"
                        ].every((t)=>!o(i(s, t))) && r.push(s), s = a(s, "2");
                        return r;
                    }
                    t.exports = s, t.exports.default = s;
                },
                function(t, e, r) {
                    "use strict";
                    const n = r(6), i = r(1);
                    function o({ max_decimal_digits: t = 100, steps: e = 100 } = {}) {
                        let r = "1", o = "1";
                        for(let a = 1; a < e; a++)o = i(o, a.toString(), {
                            max_decimal_digits: t
                        }), r = n(r, o);
                        return r;
                    }
                    t.exports = o, t.exports.default = o;
                },
                function(t, e, r) {
                    "use strict";
                    const n = r(0), i = r(90), o = r(91), a = r(11), s = r(88), u = r(35);
                    function l(t, { max_decimal_digits: e = 100 } = {}) {
                        const r = s({
                            max_decimal_digits: 2 * e
                        });
                        return i(t) ? "0" : o(t) ? "Infinity" : a(t) ? "1" : (t = n(t), u(r, t, {
                            max_decimal_digits: e
                        }));
                    }
                    t.exports = l, t.exports.default = l;
                },
                function(t, e, r) {
                    "use strict";
                    function n(t) {
                        return !!t.match(/^-inf(inity)?$/i);
                    }
                    t.exports = n, t.exports.default = n;
                },
                function(t, e, r) {
                    "use strict";
                    function n(t) {
                        return !!t.match(/^\+?inf(inity)?$/i);
                    }
                    t.exports = n, t.exports.default = n;
                },
                function(t, e, r) {
                    "use strict";
                    const n = r(37);
                    function i(t, e) {
                        return n(t, "2", e);
                    }
                    t.exports = i, t.exports.default = i;
                },
                function(t, e, r) {
                    "use strict";
                    function n(t) {
                        const e = t.indexOf(".");
                        return -1 === e ? t : t.substring(0, e);
                    }
                    t.exports = n, t.exports.default = n;
                },
                function(t, e, r) {
                    const n = r(95), i = r(185);
                    function o(t, e, { precise: r = !1 } = {
                        precise: !1
                    }) {
                        return r ? i(n(t.toString(), e.toString()), "2") : (t + e) / 2;
                    }
                    t.exports = o, t.exports.default = o;
                },
                function(t, e, r) {
                    const n = r(38), i = r(18), o = r(96), a = r(97);
                    function s(t, e) {
                        t = i(t), e = i(e);
                        const r = "-" !== t[0], s = "-" !== e[0];
                        if (r && s) return o(t, e);
                        if (!r && !s) return "-" + o(t.substring(1), e.substring(1));
                        if (!r && s) switch(t = t.substring(1), n(t, e)){
                            case "=":
                                return "0";
                            case "<":
                                return a(e, t);
                            case ">":
                                return "-" + a(t, e);
                        }
                        else if (r && !s) switch(e = e.substring(1), n(t, e)){
                            case "=":
                                return "0";
                            case "<":
                                return "-" + a(e, t);
                            case ">":
                                return a(t, e);
                        }
                    }
                    t.exports = s, t.exports.default = s;
                },
                function(t, e, r) {
                    const { MAX_SAFE_INTEGER_LENGTH: n } = r(56);
                    t.exports = function(t, e) {
                        const r = t.length, i = e.length, o = t.indexOf("."), a = e.indexOf("."), s = -1 === o ? r : o, u = -1 === a ? i : a;
                        if (-1 === o && -1 === a && r < n && i < n) return (Number(t) + Number(e)).toFixed();
                        const l = s - u;
                        let c = Math.max(s, u), f = Math.max(r - s - 1, i - u - 1), h = l < 0 ? -1 * l : 0, p = l <= 0 ? 0 : l, d = c + 1 + f - 1, m = "", y = 0, g = d;
                        if (f > 0) {
                            for(; g > d - f;){
                                const r = t[g - h] || "0", n = e[g - p] || "0";
                                let i = Number(r) + Number(n) + y;
                                i >= 10 ? (i -= 10, y = 1) : y = 0, "" === m && 0 === i || (m = i + m), g--;
                            }
                            m && (m = "." + m), g--;
                        }
                        if (c > 0) for(; g >= 0;){
                            const r = t[g - h] || "0", n = e[g - p] || "0";
                            let i = Number(r) + Number(n) + y;
                            i >= 10 ? (i -= 10, y = 1) : y = 0, m = i + m, g--;
                        }
                        return 1 === y && (m = y + m), "." === m[0] && (m = "0" + m), m;
                    };
                },
                function(t, e, r) {
                    const { MAX_SAFE_INTEGER_LENGTH: n } = r(56);
                    t.exports = function(t, e) {
                        const r = t.length, i = e.length, o = t.indexOf("."), a = e.indexOf("."), s = -1 === o ? r : o, u = -1 === a ? i : a;
                        if (-1 === o && -1 === a && r < n && i < n) return (Number(t) - Number(e)).toFixed();
                        const l = s - u;
                        let c = Math.max(s, u), f = Math.max(r - s - 1, i - u - 1), h = l < 0 ? -1 * l : 0, p = l <= 0 ? 0 : l, d = c + 1 + f - 1, m = "", y = 0, g = d;
                        if (f > 0) {
                            for(; g > d - f;){
                                let r = t[g - h] || "0", n = e[g - p] || "0";
                                r -= y, y = 0;
                                let i = r - n;
                                if (i < 0) for(; i < 0;)y++, i += 10;
                                else y && y--;
                                "" === m && 0 === i || (m = i + m), g--;
                            }
                            "" !== m && (m = "." + m), g--;
                        }
                        if (c > 0) {
                            for(; g > 0;){
                                let r = t[g - h] || "0", n = e[g - p] || "0";
                                r -= y, y = 0;
                                let i = r - n;
                                if (i < 0) for(; i < 0;)y++, i += 10;
                                else y && y--;
                                m = i + m, g--;
                            }
                            const r = t[0 - h] || "0", n = e[0 - p] || "0";
                            let i = Number(r) - (y > 0 ? 1 : 0) - Number(n);
                            0 !== i && (m = i + m), m = m.replace(/^0+/, "");
                        }
                        return "." === m[0] && (m = "0" + m), m;
                    };
                },
                function(t, e, r) {
                    const n = r(18);
                    function i(t) {
                        return "-" === (t = n(t))[0] ? t.substring(1) : t;
                    }
                    t.exports = i, t.exports.default = i;
                },
                function(t, e, r) {
                    "use strict";
                    t.exports = {
                        countIn1D: function(t) {
                            return t.reduce(function(t, e) {
                                return void 0 === t[e] ? t[e] = 1 : t[e]++, t;
                            }, {});
                        },
                        countIn2D: function(t) {
                            return t.reduce(function(t, e) {
                                return e.forEach(function(e) {
                                    void 0 === t[e] ? t[e] = 1 : t[e]++;
                                }), t;
                            }, {});
                        },
                        unflatten: function(t, e) {
                            for(var r = e.height, n = e.width, i = [], o = 0; o < r; o++){
                                var a = o * n, s = a + n;
                                i.push(t.subarray(a, s));
                            }
                            return i;
                        }
                    };
                },
                function(t, e, r) {
                    "use strict";
                    r.r(e), r.d(e, "globals", function() {
                        return n;
                    }), r.d(e, "rgb", function() {
                        return i;
                    }), r.d(e, "getDecoder", function() {
                        return R;
                    }), r.d(e, "setLogger", function() {
                        return yt;
                    }), r.d(e, "GeoTIFF", function() {
                        return _t;
                    }), r.d(e, "MultiGeoTIFF", function() {
                        return At;
                    }), r.d(e, "fromUrl", function() {
                        return Et;
                    }), r.d(e, "fromArrayBuffer", function() {
                        return St;
                    }), r.d(e, "fromFile", function() {
                        return Mt;
                    }), r.d(e, "fromBlob", function() {
                        return kt;
                    }), r.d(e, "fromUrls", function() {
                        return Nt;
                    }), r.d(e, "writeArrayBuffer", function() {
                        return Ct;
                    }), r.d(e, "Pool", function() {
                        return $.a;
                    });
                    var n = {};
                    r.r(n), r.d(n, "fieldTagNames", function() {
                        return s;
                    }), r.d(n, "fieldTags", function() {
                        return u;
                    }), r.d(n, "fieldTagTypes", function() {
                        return l;
                    }), r.d(n, "arrayFields", function() {
                        return c;
                    }), r.d(n, "fieldTypeNames", function() {
                        return f;
                    }), r.d(n, "fieldTypes", function() {
                        return h;
                    }), r.d(n, "photometricInterpretations", function() {
                        return p;
                    }), r.d(n, "ExtraSamplesValues", function() {
                        return d;
                    }), r.d(n, "geoKeyNames", function() {
                        return m;
                    }), r.d(n, "geoKeys", function() {
                        return y;
                    });
                    var i = {};
                    r.r(i), r.d(i, "fromWhiteIsZero", function() {
                        return g;
                    }), r.d(i, "fromBlackIsZero", function() {
                        return v;
                    }), r.d(i, "fromPalette", function() {
                        return b;
                    }), r.d(i, "fromCMYK", function() {
                        return x;
                    }), r.d(i, "fromYCbCr", function() {
                        return w;
                    }), r.d(i, "fromCIELab", function() {
                        return _;
                    });
                    var o = r(101), a = r.n(o);
                    const s = {
                        315: "Artist",
                        258: "BitsPerSample",
                        265: "CellLength",
                        264: "CellWidth",
                        320: "ColorMap",
                        259: "Compression",
                        33432: "Copyright",
                        306: "DateTime",
                        338: "ExtraSamples",
                        266: "FillOrder",
                        289: "FreeByteCounts",
                        288: "FreeOffsets",
                        291: "GrayResponseCurve",
                        290: "GrayResponseUnit",
                        316: "HostComputer",
                        270: "ImageDescription",
                        257: "ImageLength",
                        256: "ImageWidth",
                        271: "Make",
                        281: "MaxSampleValue",
                        280: "MinSampleValue",
                        272: "Model",
                        254: "NewSubfileType",
                        274: "Orientation",
                        262: "PhotometricInterpretation",
                        284: "PlanarConfiguration",
                        296: "ResolutionUnit",
                        278: "RowsPerStrip",
                        277: "SamplesPerPixel",
                        305: "Software",
                        279: "StripByteCounts",
                        273: "StripOffsets",
                        255: "SubfileType",
                        263: "Threshholding",
                        282: "XResolution",
                        283: "YResolution",
                        326: "BadFaxLines",
                        327: "CleanFaxData",
                        343: "ClipPath",
                        328: "ConsecutiveBadFaxLines",
                        433: "Decode",
                        434: "DefaultImageColor",
                        269: "DocumentName",
                        336: "DotRange",
                        321: "HalftoneHints",
                        346: "Indexed",
                        347: "JPEGTables",
                        285: "PageName",
                        297: "PageNumber",
                        317: "Predictor",
                        319: "PrimaryChromaticities",
                        532: "ReferenceBlackWhite",
                        339: "SampleFormat",
                        340: "SMinSampleValue",
                        341: "SMaxSampleValue",
                        559: "StripRowCounts",
                        330: "SubIFDs",
                        292: "T4Options",
                        293: "T6Options",
                        325: "TileByteCounts",
                        323: "TileLength",
                        324: "TileOffsets",
                        322: "TileWidth",
                        301: "TransferFunction",
                        318: "WhitePoint",
                        344: "XClipPathUnits",
                        286: "XPosition",
                        529: "YCbCrCoefficients",
                        531: "YCbCrPositioning",
                        530: "YCbCrSubSampling",
                        345: "YClipPathUnits",
                        287: "YPosition",
                        37378: "ApertureValue",
                        40961: "ColorSpace",
                        36868: "DateTimeDigitized",
                        36867: "DateTimeOriginal",
                        34665: "Exif IFD",
                        36864: "ExifVersion",
                        33434: "ExposureTime",
                        41728: "FileSource",
                        37385: "Flash",
                        40960: "FlashpixVersion",
                        33437: "FNumber",
                        42016: "ImageUniqueID",
                        37384: "LightSource",
                        37500: "MakerNote",
                        37377: "ShutterSpeedValue",
                        37510: "UserComment",
                        33723: "IPTC",
                        34675: "ICC Profile",
                        700: "XMP",
                        42112: "GDAL_METADATA",
                        42113: "GDAL_NODATA",
                        34377: "Photoshop",
                        33550: "ModelPixelScale",
                        33922: "ModelTiepoint",
                        34264: "ModelTransformation",
                        34735: "GeoKeyDirectory",
                        34736: "GeoDoubleParams",
                        34737: "GeoAsciiParams"
                    }, u = {};
                    for(const t in s)s.hasOwnProperty(t) && (u[s[t]] = parseInt(t, 10));
                    const l = {
                        256: "SHORT",
                        257: "SHORT",
                        258: "SHORT",
                        259: "SHORT",
                        262: "SHORT",
                        273: "LONG",
                        274: "SHORT",
                        277: "SHORT",
                        278: "LONG",
                        279: "LONG",
                        282: "RATIONAL",
                        283: "RATIONAL",
                        284: "SHORT",
                        286: "SHORT",
                        287: "RATIONAL",
                        296: "SHORT",
                        305: "ASCII",
                        306: "ASCII",
                        338: "SHORT",
                        339: "SHORT",
                        513: "LONG",
                        514: "LONG",
                        1024: "SHORT",
                        1025: "SHORT",
                        2048: "SHORT",
                        2049: "ASCII",
                        33550: "DOUBLE",
                        33922: "DOUBLE",
                        34665: "LONG",
                        34735: "SHORT",
                        34737: "ASCII",
                        42113: "ASCII"
                    }, c = [
                        u.BitsPerSample,
                        u.ExtraSamples,
                        u.SampleFormat,
                        u.StripByteCounts,
                        u.StripOffsets,
                        u.StripRowCounts,
                        u.TileByteCounts,
                        u.TileOffsets
                    ], f = {
                        1: "BYTE",
                        2: "ASCII",
                        3: "SHORT",
                        4: "LONG",
                        5: "RATIONAL",
                        6: "SBYTE",
                        7: "UNDEFINED",
                        8: "SSHORT",
                        9: "SLONG",
                        10: "SRATIONAL",
                        11: "FLOAT",
                        12: "DOUBLE",
                        13: "IFD",
                        16: "LONG8",
                        17: "SLONG8",
                        18: "IFD8"
                    }, h = {};
                    for(const t in f)f.hasOwnProperty(t) && (h[f[t]] = parseInt(t, 10));
                    const p = {
                        WhiteIsZero: 0,
                        BlackIsZero: 1,
                        RGB: 2,
                        Palette: 3,
                        TransparencyMask: 4,
                        CMYK: 5,
                        YCbCr: 6,
                        CIELab: 8,
                        ICCLab: 9
                    }, d = {
                        Unspecified: 0,
                        Assocalpha: 1,
                        Unassalpha: 2
                    }, m = {
                        1024: "GTModelTypeGeoKey",
                        1025: "GTRasterTypeGeoKey",
                        1026: "GTCitationGeoKey",
                        2048: "GeographicTypeGeoKey",
                        2049: "GeogCitationGeoKey",
                        2050: "GeogGeodeticDatumGeoKey",
                        2051: "GeogPrimeMeridianGeoKey",
                        2052: "GeogLinearUnitsGeoKey",
                        2053: "GeogLinearUnitSizeGeoKey",
                        2054: "GeogAngularUnitsGeoKey",
                        2055: "GeogAngularUnitSizeGeoKey",
                        2056: "GeogEllipsoidGeoKey",
                        2057: "GeogSemiMajorAxisGeoKey",
                        2058: "GeogSemiMinorAxisGeoKey",
                        2059: "GeogInvFlatteningGeoKey",
                        2060: "GeogAzimuthUnitsGeoKey",
                        2061: "GeogPrimeMeridianLongGeoKey",
                        2062: "GeogTOWGS84GeoKey",
                        3072: "ProjectedCSTypeGeoKey",
                        3073: "PCSCitationGeoKey",
                        3074: "ProjectionGeoKey",
                        3075: "ProjCoordTransGeoKey",
                        3076: "ProjLinearUnitsGeoKey",
                        3077: "ProjLinearUnitSizeGeoKey",
                        3078: "ProjStdParallel1GeoKey",
                        3079: "ProjStdParallel2GeoKey",
                        3080: "ProjNatOriginLongGeoKey",
                        3081: "ProjNatOriginLatGeoKey",
                        3082: "ProjFalseEastingGeoKey",
                        3083: "ProjFalseNorthingGeoKey",
                        3084: "ProjFalseOriginLongGeoKey",
                        3085: "ProjFalseOriginLatGeoKey",
                        3086: "ProjFalseOriginEastingGeoKey",
                        3087: "ProjFalseOriginNorthingGeoKey",
                        3088: "ProjCenterLongGeoKey",
                        3089: "ProjCenterLatGeoKey",
                        3090: "ProjCenterEastingGeoKey",
                        3091: "ProjCenterNorthingGeoKey",
                        3092: "ProjScaleAtNatOriginGeoKey",
                        3093: "ProjScaleAtCenterGeoKey",
                        3094: "ProjAzimuthAngleGeoKey",
                        3095: "ProjStraightVertPoleLongGeoKey",
                        3096: "ProjRectifiedGridAngleGeoKey",
                        4096: "VerticalCSTypeGeoKey",
                        4097: "VerticalCitationGeoKey",
                        4098: "VerticalDatumGeoKey",
                        4099: "VerticalUnitsGeoKey"
                    }, y = {};
                    for(const t in m)m.hasOwnProperty(t) && (y[m[t]] = parseInt(t, 10));
                    function g(t, e) {
                        const { width: r, height: n } = t, i = new Uint8Array(r * n * 3);
                        let o;
                        for(let r = 0, n = 0; r < t.length; ++r, n += 3)o = 256 - t[r] / e * 256, i[n] = o, i[n + 1] = o, i[n + 2] = o;
                        return i;
                    }
                    function v(t, e) {
                        const { width: r, height: n } = t, i = new Uint8Array(r * n * 3);
                        let o;
                        for(let r = 0, n = 0; r < t.length; ++r, n += 3)o = t[r] / e * 256, i[n] = o, i[n + 1] = o, i[n + 2] = o;
                        return i;
                    }
                    function b(t, e) {
                        const { width: r, height: n } = t, i = new Uint8Array(r * n * 3), o = e.length / 3, a = e.length / 3 * 2;
                        for(let r = 0, n = 0; r < t.length; ++r, n += 3){
                            const s = t[r];
                            i[n] = e[s] / 65536 * 256, i[n + 1] = e[s + o] / 65536 * 256, i[n + 2] = e[s + a] / 65536 * 256;
                        }
                        return i;
                    }
                    function x(t) {
                        const { width: e, height: r } = t, n = new Uint8Array(e * r * 3);
                        for(let e = 0, r = 0; e < t.length; e += 4, r += 3){
                            const i = t[e], o = t[e + 1], a = t[e + 2], s = t[e + 3];
                            n[r] = (255 - i) / 256 * 255 * ((255 - s) / 256), n[r + 1] = (255 - o) / 256 * 255 * ((255 - s) / 256), n[r + 2] = (255 - a) / 256 * 255 * ((255 - s) / 256);
                        }
                        return n;
                    }
                    function w(t) {
                        const { width: e, height: r } = t, n = new Uint8ClampedArray(e * r * 3);
                        for(let e = 0, r = 0; e < t.length; e += 3, r += 3){
                            const i = t[e], o = t[e + 1], a = t[e + 2];
                            n[r] = i + 1.402 * (a - 128), n[r + 1] = i - .34414 * (o - 128) - .71414 * (a - 128), n[r + 2] = i + 1.772 * (o - 128);
                        }
                        return n;
                    }
                    function _(t) {
                        const { width: e, height: r } = t, n = new Uint8Array(e * r * 3);
                        for(let e = 0, r = 0; e < t.length; e += 3, r += 3){
                            let i, o, a, s = (t[e + 0] + 16) / 116, u = (t[e + 1] << 24 >> 24) / 500 + s, l = s - (t[e + 2] << 24 >> 24) / 200;
                            u = .95047 * (u * u * u > .008856 ? u * u * u : (u - 16 / 116) / 7.787), s = 1 * (s * s * s > .008856 ? s * s * s : (s - 16 / 116) / 7.787), l = 1.08883 * (l * l * l > .008856 ? l * l * l : (l - 16 / 116) / 7.787), i = 3.2406 * u + -1.5372 * s + -0.4986 * l, o = -0.9689 * u + 1.8758 * s + .0415 * l, a = .0557 * u + -0.204 * s + 1.057 * l, i = i > .0031308 ? 1.055 * i ** (1 / 2.4) - .055 : 12.92 * i, o = o > .0031308 ? 1.055 * o ** (1 / 2.4) - .055 : 12.92 * o, a = a > .0031308 ? 1.055 * a ** (1 / 2.4) - .055 : 12.92 * a, n[r] = 255 * Math.max(0, Math.min(1, i)), n[r + 1] = 255 * Math.max(0, Math.min(1, o)), n[r + 2] = 255 * Math.max(0, Math.min(1, a));
                        }
                        return n;
                    }
                    function A(t, e) {
                        let r = t.length - e, n = 0;
                        do {
                            for(let r = e; r > 0; r--)t[n + e] += t[n], n++;
                            r -= e;
                        }while (r > 0);
                    }
                    function E(t, e, r) {
                        let n = 0, i = t.length;
                        const o = i / r;
                        for(; i > e;){
                            for(let r = e; r > 0; --r)t[n + e] += t[n], ++n;
                            i -= e;
                        }
                        const a = t.slice();
                        for(let e = 0; e < o; ++e)for(let n = 0; n < r; ++n)t[r * e + n] = a[(r - n - 1) * o + e];
                    }
                    class S {
                        decode(t, e) {
                            const r = this.decodeBlock(e), n = t.Predictor || 1;
                            if (1 !== n) {
                                const e = !t.StripOffsets;
                                return function(t, e, r, n, i, o) {
                                    if (!e || 1 === e) return t;
                                    for(let t = 0; t < i.length; ++t){
                                        if (i[t] % 8 != 0) throw new Error("When decoding with predictor, only multiple of 8 bits are supported.");
                                        if (i[t] !== i[0]) throw new Error("When decoding with predictor, all samples must have the same size.");
                                    }
                                    const a = i[0] / 8, s = 2 === o ? 1 : i.length;
                                    for(let o = 0; o < n && !(o * s * r * a >= t.byteLength); ++o){
                                        let n;
                                        if (2 === e) {
                                            switch(i[0]){
                                                case 8:
                                                    n = new Uint8Array(t, o * s * r * a, s * r * a);
                                                    break;
                                                case 16:
                                                    n = new Uint16Array(t, o * s * r * a, s * r * a / 2);
                                                    break;
                                                case 32:
                                                    n = new Uint32Array(t, o * s * r * a, s * r * a / 4);
                                                    break;
                                                default:
                                                    throw new Error(`Predictor 2 not allowed with ${i[0]} bits per sample.`);
                                            }
                                            A(n, s);
                                        } else 3 === e && (n = new Uint8Array(t, o * s * r * a, s * r * a), E(n, s, a));
                                    }
                                    return t;
                                }(r, n, e ? t.TileWidth : t.ImageWidth, e ? t.TileLength : t.RowsPerStrip || t.ImageLength, t.BitsPerSample, t.PlanarConfiguration);
                            }
                            return r;
                        }
                    }
                    class M extends S {
                        decodeBlock(t) {
                            return t;
                        }
                    }
                    function k(t, e) {
                        for(let r = e.length - 1; r >= 0; r--)t.push(e[r]);
                        return t;
                    }
                    class N extends S {
                        decodeBlock(t) {
                            return function(t) {
                                const e = new Uint16Array(4093), r = new Uint8Array(4093);
                                for(let t = 0; t <= 257; t++)e[t] = 4096, r[t] = t;
                                let n = 258, i = 9, o = 0;
                                function a() {
                                    n = 258, i = 9;
                                }
                                function s(t) {
                                    const e = function(t, e, r) {
                                        const n = e % 8, i = Math.floor(e / 8), o = 8 - n, a = e + r - 8 * (i + 1);
                                        let s = 8 * (i + 2) - (e + r);
                                        const u = 8 * (i + 2) - e;
                                        if (s = Math.max(0, s), i >= t.length) return console.warn("ran off the end of the buffer before finding EOI_CODE (end on input code)"), 257;
                                        let l = t[i] & 2 ** (8 - n) - 1;
                                        l <<= r - o;
                                        let c = l;
                                        if (i + 1 < t.length) {
                                            let e = t[i + 1] >>> s;
                                            e <<= Math.max(0, r - u), c += e;
                                        }
                                        if (a > 8 && i + 2 < t.length) {
                                            const n = 8 * (i + 3) - (e + r);
                                            c += t[i + 2] >>> n;
                                        }
                                        return c;
                                    }(t, o, i);
                                    return o += i, e;
                                }
                                function u(t, i) {
                                    return r[n] = i, e[n] = t, n++, n - 1;
                                }
                                function l(t) {
                                    const n = [];
                                    for(let i = t; 4096 !== i; i = e[i])n.push(r[i]);
                                    return n;
                                }
                                const c = [];
                                a();
                                const f = new Uint8Array(t);
                                let h, p = s(f);
                                for(; 257 !== p;){
                                    if (256 === p) {
                                        for(a(), p = s(f); 256 === p;)p = s(f);
                                        if (257 === p) break;
                                        if (p > 256) throw new Error("corrupted code at scanline " + p);
                                        k(c, l(p)), h = p;
                                    } else if (p < n) {
                                        const t = l(p);
                                        k(c, t), u(h, t[t.length - 1]), h = p;
                                    } else {
                                        const t = l(h);
                                        if (!t) throw new Error(`Bogus entry. Not in dictionary, ${h} / ${n}, position: ${o}`);
                                        k(c, t), c.push(t[t.length - 1]), u(h, t[t.length - 1]), h = p;
                                    }
                                    n + 1 >= 2 ** i && (12 === i ? h = void 0 : i++), p = s(f);
                                }
                                return new Uint8Array(c);
                            }(t).buffer;
                        }
                    }
                    const C = new Int32Array([
                        0,
                        1,
                        8,
                        16,
                        9,
                        2,
                        3,
                        10,
                        17,
                        24,
                        32,
                        25,
                        18,
                        11,
                        4,
                        5,
                        12,
                        19,
                        26,
                        33,
                        40,
                        48,
                        41,
                        34,
                        27,
                        20,
                        13,
                        6,
                        7,
                        14,
                        21,
                        28,
                        35,
                        42,
                        49,
                        56,
                        57,
                        50,
                        43,
                        36,
                        29,
                        22,
                        15,
                        23,
                        30,
                        37,
                        44,
                        51,
                        58,
                        59,
                        52,
                        45,
                        38,
                        31,
                        39,
                        46,
                        53,
                        60,
                        61,
                        54,
                        47,
                        55,
                        62,
                        63
                    ]);
                    function D(t, e) {
                        let r = 0;
                        const n = [];
                        let i = 16;
                        for(; i > 0 && !t[i - 1];)--i;
                        n.push({
                            children: [],
                            index: 0
                        });
                        let o, a = n[0];
                        for(let s = 0; s < i; s++){
                            for(let i = 0; i < t[s]; i++){
                                for(a = n.pop(), a.children[a.index] = e[r]; a.index > 0;)a = n.pop();
                                for(a.index++, n.push(a); n.length <= s;)n.push(o = {
                                    children: [],
                                    index: 0
                                }), a.children[a.index] = o.children, a = o;
                                r++;
                            }
                            s + 1 < i && (n.push(o = {
                                children: [],
                                index: 0
                            }), a.children[a.index] = o.children, a = o);
                        }
                        return n[0].children;
                    }
                    function O(t, e, r, n, i, o, a, s, u) {
                        const { mcusPerLine: l, progressive: c } = r, f = e;
                        let h = e, p = 0, d = 0;
                        function m() {
                            if (d > 0) return d--, p >> d & 1;
                            if (p = t[h++], 255 === p) {
                                const e = t[h++];
                                if (e) throw new Error("unexpected marker: " + (p << 8 | e).toString(16));
                            }
                            return d = 7, p >>> 7;
                        }
                        function y(t) {
                            let e, r = t;
                            for(; null !== (e = m());){
                                if (r = r[e], "number" == typeof r) return r;
                                if ("object" != typeof r) throw new Error("invalid huffman sequence");
                            }
                            return null;
                        }
                        function g(t) {
                            let e = t, r = 0;
                            for(; e > 0;){
                                const t = m();
                                if (null === t) return;
                                r = r << 1 | t, --e;
                            }
                            return r;
                        }
                        function v(t) {
                            const e = g(t);
                            return e >= 1 << t - 1 ? e : e + (-1 << t) + 1;
                        }
                        let b, x = 0, w = 0;
                        function _(t, e, r, n, i) {
                            const o = r % l, a = (r / l | 0) * t.v + n, s = o * t.h + i;
                            e(t, t.blocks[a][s]);
                        }
                        function A(t, e, r) {
                            const n = r / t.blocksPerLine | 0, i = r % t.blocksPerLine;
                            e(t, t.blocks[n][i]);
                        }
                        const E = n.length;
                        let S, M, k, N, D, O;
                        O = c ? 0 === o ? 0 === s ? function(t, e) {
                            const r = y(t.huffmanTableDC), n = 0 === r ? 0 : v(r) << u;
                            t.pred += n, e[0] = t.pred;
                        } : function(t, e) {
                            e[0] |= m() << u;
                        } : 0 === s ? function(t, e) {
                            if (x > 0) return void x--;
                            let r = o;
                            const n = a;
                            for(; r <= n;){
                                const n = y(t.huffmanTableAC), i = 15 & n, o = n >> 4;
                                if (0 === i) {
                                    if (o < 15) {
                                        x = g(o) + (1 << o) - 1;
                                        break;
                                    }
                                    r += 16;
                                } else r += o, e[C[r]] = v(i) * (1 << u), r++;
                            }
                        } : function(t, e) {
                            let r = o;
                            const n = a;
                            let i = 0;
                            for(; r <= n;){
                                const n = C[r], o = e[n] < 0 ? -1 : 1;
                                switch(w){
                                    case 0:
                                        {
                                            const e = y(t.huffmanTableAC), r = 15 & e;
                                            if (i = e >> 4, 0 === r) i < 15 ? (x = g(i) + (1 << i), w = 4) : (i = 16, w = 1);
                                            else {
                                                if (1 !== r) throw new Error("invalid ACn encoding");
                                                b = v(r), w = i ? 2 : 3;
                                            }
                                            continue;
                                        }
                                    case 1:
                                    case 2:
                                        e[n] ? e[n] += (m() << u) * o : (i--, 0 === i && (w = 2 === w ? 3 : 0));
                                        break;
                                    case 3:
                                        e[n] ? e[n] += (m() << u) * o : (e[n] = b << u, w = 0);
                                        break;
                                    case 4:
                                        e[n] && (e[n] += (m() << u) * o);
                                }
                                r++;
                            }
                            4 === w && (x--, 0 === x && (w = 0));
                        } : function(t, e) {
                            const r = y(t.huffmanTableDC), n = 0 === r ? 0 : v(r);
                            t.pred += n, e[0] = t.pred;
                            let i = 1;
                            for(; i < 64;){
                                const r = y(t.huffmanTableAC), n = 15 & r, o = r >> 4;
                                if (0 === n) {
                                    if (o < 15) break;
                                    i += 16;
                                } else i += o, e[C[i]] = v(n), i++;
                            }
                        };
                        let T, F, P = 0;
                        F = 1 === E ? n[0].blocksPerLine * n[0].blocksPerColumn : l * r.mcusPerColumn;
                        const I = i || F;
                        for(; P < F;){
                            for(M = 0; M < E; M++)n[M].pred = 0;
                            if (x = 0, 1 === E) for(S = n[0], D = 0; D < I; D++)A(S, O, P), P++;
                            else for(D = 0; D < I; D++){
                                for(M = 0; M < E; M++){
                                    S = n[M];
                                    const { h: t, v: e } = S;
                                    for(k = 0; k < e; k++)for(N = 0; N < t; N++)_(S, O, P, k, N);
                                }
                                if (P++, P === F) break;
                            }
                            if (d = 0, T = t[h] << 8 | t[h + 1], T < 65280) throw new Error("marker was not found");
                            if (!(T >= 65488 && T <= 65495)) break;
                            h += 2;
                        }
                        return h - f;
                    }
                    function T(t, e) {
                        const r = [], { blocksPerLine: n, blocksPerColumn: i } = e, o = n << 3, a = new Int32Array(64), s = new Uint8Array(64);
                        function u(t, r, n) {
                            const i = e.quantizationTable;
                            let o, a, s, u, l, c, f, h, p;
                            const d = n;
                            let m;
                            for(m = 0; m < 64; m++)d[m] = t[m] * i[m];
                            for(m = 0; m < 8; ++m){
                                const t = 8 * m;
                                0 !== d[1 + t] || 0 !== d[2 + t] || 0 !== d[3 + t] || 0 !== d[4 + t] || 0 !== d[5 + t] || 0 !== d[6 + t] || 0 !== d[7 + t] ? (o = 5793 * d[0 + t] + 128 >> 8, a = 5793 * d[4 + t] + 128 >> 8, s = d[2 + t], u = d[6 + t], l = 2896 * (d[1 + t] - d[7 + t]) + 128 >> 8, h = 2896 * (d[1 + t] + d[7 + t]) + 128 >> 8, c = d[3 + t] << 4, f = d[5 + t] << 4, p = o - a + 1 >> 1, o = o + a + 1 >> 1, a = p, p = 3784 * s + 1567 * u + 128 >> 8, s = 1567 * s - 3784 * u + 128 >> 8, u = p, p = l - f + 1 >> 1, l = l + f + 1 >> 1, f = p, p = h + c + 1 >> 1, c = h - c + 1 >> 1, h = p, p = o - u + 1 >> 1, o = o + u + 1 >> 1, u = p, p = a - s + 1 >> 1, a = a + s + 1 >> 1, s = p, p = 2276 * l + 3406 * h + 2048 >> 12, l = 3406 * l - 2276 * h + 2048 >> 12, h = p, p = 799 * c + 4017 * f + 2048 >> 12, c = 4017 * c - 799 * f + 2048 >> 12, f = p, d[0 + t] = o + h, d[7 + t] = o - h, d[1 + t] = a + f, d[6 + t] = a - f, d[2 + t] = s + c, d[5 + t] = s - c, d[3 + t] = u + l, d[4 + t] = u - l) : (p = 5793 * d[0 + t] + 512 >> 10, d[0 + t] = p, d[1 + t] = p, d[2 + t] = p, d[3 + t] = p, d[4 + t] = p, d[5 + t] = p, d[6 + t] = p, d[7 + t] = p);
                            }
                            for(m = 0; m < 8; ++m){
                                const t = m;
                                0 !== d[8 + t] || 0 !== d[16 + t] || 0 !== d[24 + t] || 0 !== d[32 + t] || 0 !== d[40 + t] || 0 !== d[48 + t] || 0 !== d[56 + t] ? (o = 5793 * d[0 + t] + 2048 >> 12, a = 5793 * d[32 + t] + 2048 >> 12, s = d[16 + t], u = d[48 + t], l = 2896 * (d[8 + t] - d[56 + t]) + 2048 >> 12, h = 2896 * (d[8 + t] + d[56 + t]) + 2048 >> 12, c = d[24 + t], f = d[40 + t], p = o - a + 1 >> 1, o = o + a + 1 >> 1, a = p, p = 3784 * s + 1567 * u + 2048 >> 12, s = 1567 * s - 3784 * u + 2048 >> 12, u = p, p = l - f + 1 >> 1, l = l + f + 1 >> 1, f = p, p = h + c + 1 >> 1, c = h - c + 1 >> 1, h = p, p = o - u + 1 >> 1, o = o + u + 1 >> 1, u = p, p = a - s + 1 >> 1, a = a + s + 1 >> 1, s = p, p = 2276 * l + 3406 * h + 2048 >> 12, l = 3406 * l - 2276 * h + 2048 >> 12, h = p, p = 799 * c + 4017 * f + 2048 >> 12, c = 4017 * c - 799 * f + 2048 >> 12, f = p, d[0 + t] = o + h, d[56 + t] = o - h, d[8 + t] = a + f, d[48 + t] = a - f, d[16 + t] = s + c, d[40 + t] = s - c, d[24 + t] = u + l, d[32 + t] = u - l) : (p = 5793 * n[m + 0] + 8192 >> 14, d[0 + t] = p, d[8 + t] = p, d[16 + t] = p, d[24 + t] = p, d[32 + t] = p, d[40 + t] = p, d[48 + t] = p, d[56 + t] = p);
                            }
                            for(m = 0; m < 64; ++m){
                                const t = 128 + (d[m] + 8 >> 4);
                                r[m] = t < 0 ? 0 : t > 255 ? 255 : t;
                            }
                        }
                        for(let t = 0; t < i; t++){
                            const i = t << 3;
                            for(let t = 0; t < 8; t++)r.push(new Uint8Array(o));
                            for(let o = 0; o < n; o++){
                                u(e.blocks[t][o], s, a);
                                let n = 0;
                                const l = o << 3;
                                for(let t = 0; t < 8; t++){
                                    const e = r[i + t];
                                    for(let t = 0; t < 8; t++)e[l + t] = s[n++];
                                }
                            }
                        }
                        return r;
                    }
                    class F {
                        constructor(){
                            this.jfif = null, this.adobe = null, this.quantizationTables = [], this.huffmanTablesAC = [], this.huffmanTablesDC = [], this.resetFrames();
                        }
                        resetFrames() {
                            this.frames = [];
                        }
                        parse(t) {
                            let e = 0;
                            function r() {
                                const r = t[e] << 8 | t[e + 1];
                                return e += 2, r;
                            }
                            function n() {
                                const n = r(), i = t.subarray(e, e + n - 2);
                                return e += i.length, i;
                            }
                            function i(t) {
                                let e, r, n = 0, i = 0;
                                for(r in t.components)t.components.hasOwnProperty(r) && (e = t.components[r], n < e.h && (n = e.h), i < e.v && (i = e.v));
                                const o = Math.ceil(t.samplesPerLine / 8 / n), a = Math.ceil(t.scanLines / 8 / i);
                                for(r in t.components)if (t.components.hasOwnProperty(r)) {
                                    e = t.components[r];
                                    const s = Math.ceil(Math.ceil(t.samplesPerLine / 8) * e.h / n), u = Math.ceil(Math.ceil(t.scanLines / 8) * e.v / i), l = o * e.h, c = a * e.v, f = [];
                                    for(let t = 0; t < c; t++){
                                        const t = [];
                                        for(let e = 0; e < l; e++)t.push(new Int32Array(64));
                                        f.push(t);
                                    }
                                    e.blocksPerLine = s, e.blocksPerColumn = u, e.blocks = f;
                                }
                                t.maxH = n, t.maxV = i, t.mcusPerLine = o, t.mcusPerColumn = a;
                            }
                            let o = r();
                            if (65496 !== o) throw new Error("SOI not found");
                            for(o = r(); 65497 !== o;){
                                switch(o){
                                    case 65280:
                                        break;
                                    case 65504:
                                    case 65505:
                                    case 65506:
                                    case 65507:
                                    case 65508:
                                    case 65509:
                                    case 65510:
                                    case 65511:
                                    case 65512:
                                    case 65513:
                                    case 65514:
                                    case 65515:
                                    case 65516:
                                    case 65517:
                                    case 65518:
                                    case 65519:
                                    case 65534:
                                        {
                                            const t = n();
                                            65504 === o && 74 === t[0] && 70 === t[1] && 73 === t[2] && 70 === t[3] && 0 === t[4] && (this.jfif = {
                                                version: {
                                                    major: t[5],
                                                    minor: t[6]
                                                },
                                                densityUnits: t[7],
                                                xDensity: t[8] << 8 | t[9],
                                                yDensity: t[10] << 8 | t[11],
                                                thumbWidth: t[12],
                                                thumbHeight: t[13],
                                                thumbData: t.subarray(14, 14 + 3 * t[12] * t[13])
                                            }), 65518 === o && 65 === t[0] && 100 === t[1] && 111 === t[2] && 98 === t[3] && 101 === t[4] && 0 === t[5] && (this.adobe = {
                                                version: t[6],
                                                flags0: t[7] << 8 | t[8],
                                                flags1: t[9] << 8 | t[10],
                                                transformCode: t[11]
                                            });
                                            break;
                                        }
                                    case 65499:
                                        {
                                            const n = r() + e - 2;
                                            for(; e < n;){
                                                const n = t[e++], i = new Int32Array(64);
                                                if (n >> 4 == 0) for(let r = 0; r < 64; r++)i[C[r]] = t[e++];
                                                else {
                                                    if (n >> 4 != 1) throw new Error("DQT: invalid table spec");
                                                    for(let t = 0; t < 64; t++)i[C[t]] = r();
                                                }
                                                this.quantizationTables[15 & n] = i;
                                            }
                                            break;
                                        }
                                    case 65472:
                                    case 65473:
                                    case 65474:
                                        {
                                            r();
                                            const n = {
                                                extended: 65473 === o,
                                                progressive: 65474 === o,
                                                precision: t[e++],
                                                scanLines: r(),
                                                samplesPerLine: r(),
                                                components: {},
                                                componentsOrder: []
                                            }, a = t[e++];
                                            let s;
                                            for(let r = 0; r < a; r++){
                                                s = t[e];
                                                const r = t[e + 1] >> 4, i = 15 & t[e + 1], o = t[e + 2];
                                                n.componentsOrder.push(s), n.components[s] = {
                                                    h: r,
                                                    v: i,
                                                    quantizationIdx: o
                                                }, e += 3;
                                            }
                                            i(n), this.frames.push(n);
                                            break;
                                        }
                                    case 65476:
                                        {
                                            const n = r();
                                            for(let r = 2; r < n;){
                                                const n = t[e++], i = new Uint8Array(16);
                                                let o = 0;
                                                for(let r = 0; r < 16; r++, e++)i[r] = t[e], o += i[r];
                                                const a = new Uint8Array(o);
                                                for(let r = 0; r < o; r++, e++)a[r] = t[e];
                                                r += 17 + o, n >> 4 == 0 ? this.huffmanTablesDC[15 & n] = D(i, a) : this.huffmanTablesAC[15 & n] = D(i, a);
                                            }
                                            break;
                                        }
                                    case 65501:
                                        r(), this.resetInterval = r();
                                        break;
                                    case 65498:
                                        {
                                            r();
                                            const n = t[e++], i = [], o = this.frames[0];
                                            for(let r = 0; r < n; r++){
                                                const r = o.components[t[e++]], n = t[e++];
                                                r.huffmanTableDC = this.huffmanTablesDC[n >> 4], r.huffmanTableAC = this.huffmanTablesAC[15 & n], i.push(r);
                                            }
                                            const a = t[e++], s = t[e++], u = t[e++], l = O(t, e, o, i, this.resetInterval, a, s, u >> 4, 15 & u);
                                            e += l;
                                            break;
                                        }
                                    case 65535:
                                        255 !== t[e] && e--;
                                        break;
                                    default:
                                        if (255 === t[e - 3] && t[e - 2] >= 192 && t[e - 2] <= 254) {
                                            e -= 3;
                                            break;
                                        }
                                        throw new Error("unknown JPEG marker " + o.toString(16));
                                }
                                o = r();
                            }
                        }
                        getResult() {
                            const { frames: t } = this;
                            if (0 === this.frames.length) throw new Error("no frames were decoded");
                            this.frames.length > 1 && console.warn("more than one frame is not supported");
                            for(let t = 0; t < this.frames.length; t++){
                                const e = this.frames[t].components;
                                for (const t of Object.keys(e))e[t].quantizationTable = this.quantizationTables[e[t].quantizationIdx], delete e[t].quantizationIdx;
                            }
                            const e = t[0], { components: r, componentsOrder: n } = e, i = [], o = e.samplesPerLine, a = e.scanLines;
                            for(let t = 0; t < n.length; t++){
                                const o = r[n[t]];
                                i.push({
                                    lines: T(0, o),
                                    scaleX: o.h / e.maxH,
                                    scaleY: o.v / e.maxV
                                });
                            }
                            const s = new Uint8Array(o * a * i.length);
                            let u = 0;
                            for(let t = 0; t < a; ++t)for(let e = 0; e < o; ++e)for(let r = 0; r < i.length; ++r){
                                const n = i[r];
                                s[u] = n.lines[0 | t * n.scaleY][0 | e * n.scaleX], ++u;
                            }
                            return s;
                        }
                    }
                    class P extends S {
                        constructor(t){
                            super(), this.reader = new F, t.JPEGTables && this.reader.parse(t.JPEGTables);
                        }
                        decodeBlock(t) {
                            return this.reader.resetFrames(), this.reader.parse(new Uint8Array(t)), this.reader.getResult().buffer;
                        }
                    }
                    var I = r(102);
                    class B extends S {
                        decodeBlock(t) {
                            return Object(I.inflate)(new Uint8Array(t)).buffer;
                        }
                    }
                    class j extends S {
                        decodeBlock(t) {
                            const e = new DataView(t), r = [];
                            for(let n = 0; n < t.byteLength; ++n){
                                let t = e.getInt8(n);
                                if (t < 0) {
                                    const i = e.getUint8(n + 1);
                                    t = -t;
                                    for(let e = 0; e <= t; ++e)r.push(i);
                                    n += 1;
                                } else {
                                    for(let i = 0; i <= t; ++i)r.push(e.getUint8(n + i + 1));
                                    n += t + 1;
                                }
                            }
                            return new Uint8Array(r).buffer;
                        }
                    }
                    function R(t) {
                        switch(t.Compression){
                            case void 0:
                            case 1:
                                return new M;
                            case 5:
                                return new N;
                            case 6:
                                throw new Error("old style JPEG compression is not supported.");
                            case 7:
                                return new P(t);
                            case 8:
                            case 32946:
                                return new B;
                            case 32773:
                                return new j;
                            default:
                                throw new Error("Unknown compression method identifier: " + t.Compression);
                        }
                    }
                    function L(t, e, r, n = 1) {
                        return new (Object.getPrototypeOf(t)).constructor(e * r * n);
                    }
                    function q(t, e, r) {
                        return (1 - r) * t + r * e;
                    }
                    function U(t, e, r) {
                        let n = 0;
                        for(let i = e; i < r; ++i)n += t[i];
                        return n;
                    }
                    function z(t, e, r) {
                        switch(t){
                            case 1:
                                switch(e){
                                    case 8:
                                        return new Uint8Array(r);
                                    case 16:
                                        return new Uint16Array(r);
                                    case 32:
                                        return new Uint32Array(r);
                                }
                                break;
                            case 2:
                                switch(e){
                                    case 8:
                                        return new Int8Array(r);
                                    case 16:
                                        return new Int16Array(r);
                                    case 32:
                                        return new Int32Array(r);
                                }
                                break;
                            case 3:
                                switch(e){
                                    case 32:
                                        return new Float32Array(r);
                                    case 64:
                                        return new Float64Array(r);
                                }
                        }
                        throw Error("Unsupported data format/bitsPerSample");
                    }
                    var G = class {
                        constructor(t, e, r, n, i, o){
                            this.fileDirectory = t, this.geoKeys = e, this.dataView = r, this.littleEndian = n, this.tiles = i ? {} : null, this.isTiled = !t.StripOffsets;
                            const a = t.PlanarConfiguration;
                            if (this.planarConfiguration = void 0 === a ? 1 : a, 1 !== this.planarConfiguration && 2 !== this.planarConfiguration) throw new Error("Invalid planar configuration.");
                            this.source = o;
                        }
                        getFileDirectory() {
                            return this.fileDirectory;
                        }
                        getGeoKeys() {
                            return this.geoKeys;
                        }
                        getWidth() {
                            return this.fileDirectory.ImageWidth;
                        }
                        getHeight() {
                            return this.fileDirectory.ImageLength;
                        }
                        getSamplesPerPixel() {
                            return this.fileDirectory.SamplesPerPixel;
                        }
                        getTileWidth() {
                            return this.isTiled ? this.fileDirectory.TileWidth : this.getWidth();
                        }
                        getTileHeight() {
                            return this.isTiled ? this.fileDirectory.TileLength : void 0 !== this.fileDirectory.RowsPerStrip ? Math.min(this.fileDirectory.RowsPerStrip, this.getHeight()) : this.getHeight();
                        }
                        getBytesPerPixel() {
                            let t = 0;
                            for(let e = 0; e < this.fileDirectory.BitsPerSample.length; ++e){
                                const r = this.fileDirectory.BitsPerSample[e];
                                if (r % 8 != 0) throw new Error(`Sample bit-width of ${r} is not supported.`);
                                if (r !== this.fileDirectory.BitsPerSample[0]) throw new Error("Differing size of samples in a pixel are not supported.");
                                t += r;
                            }
                            return t / 8;
                        }
                        getSampleByteSize(t) {
                            if (t >= this.fileDirectory.BitsPerSample.length) throw new RangeError(`Sample index ${t} is out of range.`);
                            const e = this.fileDirectory.BitsPerSample[t];
                            if (e % 8 != 0) throw new Error(`Sample bit-width of ${e} is not supported.`);
                            return e / 8;
                        }
                        getReaderForSample(t) {
                            const e = this.fileDirectory.SampleFormat ? this.fileDirectory.SampleFormat[t] : 1, r = this.fileDirectory.BitsPerSample[t];
                            switch(e){
                                case 1:
                                    switch(r){
                                        case 8:
                                            return DataView.prototype.getUint8;
                                        case 16:
                                            return DataView.prototype.getUint16;
                                        case 32:
                                            return DataView.prototype.getUint32;
                                    }
                                    break;
                                case 2:
                                    switch(r){
                                        case 8:
                                            return DataView.prototype.getInt8;
                                        case 16:
                                            return DataView.prototype.getInt16;
                                        case 32:
                                            return DataView.prototype.getInt32;
                                    }
                                    break;
                                case 3:
                                    switch(r){
                                        case 32:
                                            return DataView.prototype.getFloat32;
                                        case 64:
                                            return DataView.prototype.getFloat64;
                                    }
                            }
                            throw Error("Unsupported data format/bitsPerSample");
                        }
                        getArrayForSample(t, e) {
                            return z(this.fileDirectory.SampleFormat ? this.fileDirectory.SampleFormat[t] : 1, this.fileDirectory.BitsPerSample[t], e);
                        }
                        async getTileOrStrip(t, e, r, n) {
                            const i = Math.ceil(this.getWidth() / this.getTileWidth()), o = Math.ceil(this.getHeight() / this.getTileHeight());
                            let a;
                            const { tiles: s } = this;
                            let u, l;
                            1 === this.planarConfiguration ? a = e * i + t : 2 === this.planarConfiguration && (a = r * i * o + e * i + t), this.isTiled ? (u = this.fileDirectory.TileOffsets[a], l = this.fileDirectory.TileByteCounts[a]) : (u = this.fileDirectory.StripOffsets[a], l = this.fileDirectory.StripByteCounts[a]);
                            const c = await this.source.fetch(u, l);
                            let f;
                            return null === s ? f = n.decode(this.fileDirectory, c) : s[a] || (f = n.decode(this.fileDirectory, c), s[a] = f), {
                                x: t,
                                y: e,
                                sample: r,
                                data: await f
                            };
                        }
                        async _readRaster(t, e, r, n, i, o, a, s) {
                            const u = this.getTileWidth(), l = this.getTileHeight(), c = Math.max(Math.floor(t[0] / u), 0), f = Math.min(Math.ceil(t[2] / u), Math.ceil(this.getWidth() / this.getTileWidth())), h = Math.max(Math.floor(t[1] / l), 0), p = Math.min(Math.ceil(t[3] / l), Math.ceil(this.getHeight() / this.getTileHeight())), d = t[2] - t[0];
                            let m = this.getBytesPerPixel();
                            const y = [], g = [];
                            for(let t = 0; t < e.length; ++t)1 === this.planarConfiguration ? y.push(U(this.fileDirectory.BitsPerSample, 0, e[t]) / 8) : y.push(0), g.push(this.getReaderForSample(e[t]));
                            const v = [], { littleEndian: b } = this;
                            for(let o = h; o < p; ++o)for(let a = c; a < f; ++a)for(let s = 0; s < e.length; ++s){
                                const c = s, f = e[s];
                                2 === this.planarConfiguration && (m = this.getSampleByteSize(f));
                                const h = this.getTileOrStrip(a, o, f, i);
                                v.push(h), h.then((i)=>{
                                    const o = i.data, a = new DataView(o), s = i.y * l, f = i.x * u, h = (i.y + 1) * l, p = (i.x + 1) * u, v = g[c], x = Math.min(l, l - (h - t[3])), w = Math.min(u, u - (p - t[2]));
                                    for(let i = Math.max(0, t[1] - s); i < x; ++i)for(let o = Math.max(0, t[0] - f); o < w; ++o){
                                        const l = (i * u + o) * m, h = v.call(a, l + y[c], b);
                                        let p;
                                        n ? (p = (i + s - t[1]) * d * e.length + (o + f - t[0]) * e.length + c, r[p] = h) : (p = (i + s - t[1]) * d + o + f - t[0], r[c][p] = h);
                                    }
                                });
                            }
                            if (await Promise.all(v), o && t[2] - t[0] !== o || a && t[3] - t[1] !== a) {
                                let i;
                                return i = n ? function(t, e, r, n, i, o, a = "nearest") {
                                    switch(a.toLowerCase()){
                                        case "nearest":
                                            return function(t, e, r, n, i, o) {
                                                const a = e / n, s = r / i, u = L(t, n, i, o);
                                                for(let l = 0; l < i; ++l){
                                                    const i = Math.min(Math.round(s * l), r - 1);
                                                    for(let r = 0; r < n; ++r){
                                                        const s = Math.min(Math.round(a * r), e - 1);
                                                        for(let a = 0; a < o; ++a){
                                                            const c = t[i * e * o + s * o + a];
                                                            u[l * n * o + r * o + a] = c;
                                                        }
                                                    }
                                                }
                                                return u;
                                            }(t, e, r, n, i, o);
                                        case "bilinear":
                                        case "linear":
                                            return function(t, e, r, n, i, o) {
                                                const a = e / n, s = r / i, u = L(t, n, i, o);
                                                for(let l = 0; l < i; ++l){
                                                    const i = s * l, c = Math.floor(i), f = Math.min(Math.ceil(i), r - 1);
                                                    for(let r = 0; r < n; ++r){
                                                        const s = a * r, h = s % 1, p = Math.floor(s), d = Math.min(Math.ceil(s), e - 1);
                                                        for(let a = 0; a < o; ++a){
                                                            const s = t[c * e * o + p * o + a], m = t[c * e * o + d * o + a], y = t[f * e * o + p * o + a], g = t[f * e * o + d * o + a], v = q(q(s, m, h), q(y, g, h), i % 1);
                                                            u[l * n * o + r * o + a] = v;
                                                        }
                                                    }
                                                }
                                                return u;
                                            }(t, e, r, n, i, o);
                                        default:
                                            throw new Error(`Unsupported resampling method: '${a}'`);
                                    }
                                }(r, t[2] - t[0], t[3] - t[1], o, a, e.length, s) : function(t, e, r, n, i, o = "nearest") {
                                    switch(o.toLowerCase()){
                                        case "nearest":
                                            return function(t, e, r, n, i) {
                                                const o = e / n, a = r / i;
                                                return t.map((t)=>{
                                                    const s = L(t, n, i);
                                                    for(let u = 0; u < i; ++u){
                                                        const i = Math.min(Math.round(a * u), r - 1);
                                                        for(let r = 0; r < n; ++r){
                                                            const a = Math.min(Math.round(o * r), e - 1), l = t[i * e + a];
                                                            s[u * n + r] = l;
                                                        }
                                                    }
                                                    return s;
                                                });
                                            }(t, e, r, n, i);
                                        case "bilinear":
                                        case "linear":
                                            return function(t, e, r, n, i) {
                                                const o = e / n, a = r / i;
                                                return t.map((t)=>{
                                                    const s = L(t, n, i);
                                                    for(let u = 0; u < i; ++u){
                                                        const i = a * u, l = Math.floor(i), c = Math.min(Math.ceil(i), r - 1);
                                                        for(let r = 0; r < n; ++r){
                                                            const a = o * r, f = a % 1, h = Math.floor(a), p = Math.min(Math.ceil(a), e - 1), d = t[l * e + h], m = t[l * e + p], y = t[c * e + h], g = t[c * e + p], v = q(q(d, m, f), q(y, g, f), i % 1);
                                                            s[u * n + r] = v;
                                                        }
                                                    }
                                                    return s;
                                                });
                                            }(t, e, r, n, i);
                                        default:
                                            throw new Error(`Unsupported resampling method: '${o}'`);
                                    }
                                }(r, t[2] - t[0], t[3] - t[1], o, a, s), i.width = o, i.height = a, i;
                            }
                            return r.width = o || t[2] - t[0], r.height = a || t[3] - t[1], r;
                        }
                        async readRasters({ window: t, samples: e = [], interleave: r, pool: n = null, width: i, height: o, resampleMethod: a, fillValue: s } = {}) {
                            const u = t || [
                                0,
                                0,
                                this.getWidth(),
                                this.getHeight()
                            ];
                            if (u[0] > u[2] || u[1] > u[3]) throw new Error("Invalid subsets");
                            const l = (u[2] - u[0]) * (u[3] - u[1]);
                            if (e && e.length) {
                                for(let t = 0; t < e.length; ++t)if (e[t] >= this.fileDirectory.SamplesPerPixel) return Promise.reject(new RangeError(`Invalid sample index '${e[t]}'.`));
                            } else for(let t = 0; t < this.fileDirectory.SamplesPerPixel; ++t)e.push(t);
                            let c;
                            if (r) c = z(this.fileDirectory.SampleFormat ? Math.max.apply(null, this.fileDirectory.SampleFormat) : 1, Math.max.apply(null, this.fileDirectory.BitsPerSample), l * e.length), s && c.fill(s);
                            else {
                                c = [];
                                for(let t = 0; t < e.length; ++t){
                                    const r = this.getArrayForSample(e[t], l);
                                    Array.isArray(s) && t < s.length ? r.fill(s[t]) : s && !Array.isArray(s) && r.fill(s), c.push(r);
                                }
                            }
                            const f = n || R(this.fileDirectory);
                            return await this._readRaster(u, e, c, r, f, i, o, a);
                        }
                        async readRGB({ window: t, pool: e = null, width: r, height: n, resampleMethod: i, enableAlpha: o = !1 } = {}) {
                            const a = t || [
                                0,
                                0,
                                this.getWidth(),
                                this.getHeight()
                            ];
                            if (a[0] > a[2] || a[1] > a[3]) throw new Error("Invalid subsets");
                            const s = this.fileDirectory.PhotometricInterpretation;
                            if (s === p.RGB) {
                                let i = [
                                    0,
                                    1,
                                    2
                                ];
                                if (this.fileDirectory.ExtraSamples !== d.Unspecified && o) {
                                    i = [];
                                    for(let t = 0; t < this.fileDirectory.BitsPerSample.length; t += 1)i.push(t);
                                }
                                return this.readRasters({
                                    window: t,
                                    interleave: !0,
                                    samples: i,
                                    pool: e,
                                    width: r,
                                    height: n
                                });
                            }
                            let u;
                            switch(s){
                                case p.WhiteIsZero:
                                case p.BlackIsZero:
                                case p.Palette:
                                    u = [
                                        0
                                    ];
                                    break;
                                case p.CMYK:
                                    u = [
                                        0,
                                        1,
                                        2,
                                        3
                                    ];
                                    break;
                                case p.YCbCr:
                                case p.CIELab:
                                    u = [
                                        0,
                                        1,
                                        2
                                    ];
                                    break;
                                default:
                                    throw new Error("Invalid or unsupported photometric interpretation.");
                            }
                            const l = {
                                window: a,
                                interleave: !0,
                                samples: u,
                                pool: e,
                                width: r,
                                height: n,
                                resampleMethod: i
                            }, { fileDirectory: c } = this, f = await this.readRasters(l), h = 2 ** this.fileDirectory.BitsPerSample[0];
                            let m;
                            switch(s){
                                case p.WhiteIsZero:
                                    m = g(f, h);
                                    break;
                                case p.BlackIsZero:
                                    m = v(f, h);
                                    break;
                                case p.Palette:
                                    m = b(f, c.ColorMap);
                                    break;
                                case p.CMYK:
                                    m = x(f);
                                    break;
                                case p.YCbCr:
                                    m = w(f);
                                    break;
                                case p.CIELab:
                                    m = _(f);
                                    break;
                                default:
                                    throw new Error("Unsupported photometric interpretation.");
                            }
                            return m.width = f.width, m.height = f.height, m;
                        }
                        getTiePoints() {
                            if (!this.fileDirectory.ModelTiepoint) return [];
                            const t = [];
                            for(let e = 0; e < this.fileDirectory.ModelTiepoint.length; e += 6)t.push({
                                i: this.fileDirectory.ModelTiepoint[e],
                                j: this.fileDirectory.ModelTiepoint[e + 1],
                                k: this.fileDirectory.ModelTiepoint[e + 2],
                                x: this.fileDirectory.ModelTiepoint[e + 3],
                                y: this.fileDirectory.ModelTiepoint[e + 4],
                                z: this.fileDirectory.ModelTiepoint[e + 5]
                            });
                            return t;
                        }
                        getGDALMetadata(t = null) {
                            const e = {};
                            if (!this.fileDirectory.GDAL_METADATA) return null;
                            const r = this.fileDirectory.GDAL_METADATA, n = a()(r.substring(0, r.length - 1));
                            if (!n[0].tagName) throw new Error("Failed to parse GDAL metadata XML.");
                            const i = n[0];
                            if ("GDALMetadata" !== i.tagName) throw new Error("Unexpected GDAL metadata XML tag.");
                            let o = i.children.filter((t)=>"Item" === t.tagName);
                            t && (o = o.filter((e)=>Number(e.attributes.sample) === t));
                            for(let t = 0; t < o.length; ++t){
                                const r = o[t];
                                e[r.attributes.name] = r.children[0];
                            }
                            return e;
                        }
                        getGDALNoData() {
                            if (!this.fileDirectory.GDAL_NODATA) return null;
                            const t = this.fileDirectory.GDAL_NODATA;
                            return Number(t.substring(0, t.length - 1));
                        }
                        getOrigin() {
                            const t = this.fileDirectory.ModelTiepoint, e = this.fileDirectory.ModelTransformation;
                            if (t && 6 === t.length) return [
                                t[3],
                                t[4],
                                t[5]
                            ];
                            if (e) return [
                                e[3],
                                e[7],
                                e[11]
                            ];
                            throw new Error("The image does not have an affine transformation.");
                        }
                        getResolution(t = null) {
                            const e = this.fileDirectory.ModelPixelScale, r = this.fileDirectory.ModelTransformation;
                            if (e) return [
                                e[0],
                                -e[1],
                                e[2]
                            ];
                            if (r) return [
                                r[0],
                                r[5],
                                r[10]
                            ];
                            if (t) {
                                const [e, r, n] = t.getResolution();
                                return [
                                    e * t.getWidth() / this.getWidth(),
                                    r * t.getHeight() / this.getHeight(),
                                    n * t.getWidth() / this.getWidth()
                                ];
                            }
                            throw new Error("The image does not have an affine transformation.");
                        }
                        pixelIsArea() {
                            return 1 === this.geoKeys.GTRasterTypeGeoKey;
                        }
                        getBoundingBox() {
                            const t = this.getOrigin(), e = this.getResolution(), r = t[0], n = t[1], i = r + e[0] * this.getWidth(), o = n + e[1] * this.getHeight();
                            return [
                                Math.min(r, i),
                                Math.min(n, o),
                                Math.max(r, i),
                                Math.max(n, o)
                            ];
                        }
                    };
                    class H {
                        constructor(t){
                            this._dataView = new DataView(t);
                        }
                        get buffer() {
                            return this._dataView.buffer;
                        }
                        getUint64(t, e) {
                            const r = this.getUint32(t, e), n = this.getUint32(t + 4, e);
                            let i;
                            if (e) {
                                if (i = r + 2 ** 32 * n, !Number.isSafeInteger(i)) throw new Error(i + " exceeds MAX_SAFE_INTEGER. Precision may be lost. Please report if you get this message to https://github.com/geotiffjs/geotiff.js/issues");
                                return i;
                            }
                            if (i = 2 ** 32 * r + n, !Number.isSafeInteger(i)) throw new Error(i + " exceeds MAX_SAFE_INTEGER. Precision may be lost. Please report if you get this message to https://github.com/geotiffjs/geotiff.js/issues");
                            return i;
                        }
                        getInt64(t, e) {
                            let r = 0;
                            const n = (128 & this._dataView.getUint8(t + (e ? 7 : 0))) > 0;
                            let i = !0;
                            for(let o = 0; o < 8; o++){
                                let a = this._dataView.getUint8(t + (e ? o : 7 - o));
                                n && (i ? 0 !== a && (a = 255 & ~(a - 1), i = !1) : a = 255 & ~a), r += a * 256 ** o;
                            }
                            return n && (r = -r), r;
                        }
                        getUint8(t, e) {
                            return this._dataView.getUint8(t, e);
                        }
                        getInt8(t, e) {
                            return this._dataView.getInt8(t, e);
                        }
                        getUint16(t, e) {
                            return this._dataView.getUint16(t, e);
                        }
                        getInt16(t, e) {
                            return this._dataView.getInt16(t, e);
                        }
                        getUint32(t, e) {
                            return this._dataView.getUint32(t, e);
                        }
                        getInt32(t, e) {
                            return this._dataView.getInt32(t, e);
                        }
                        getFloat32(t, e) {
                            return this._dataView.getFloat32(t, e);
                        }
                        getFloat64(t, e) {
                            return this._dataView.getFloat64(t, e);
                        }
                    }
                    class W {
                        constructor(t, e, r, n){
                            this._dataView = new DataView(t), this._sliceOffset = e, this._littleEndian = r, this._bigTiff = n;
                        }
                        get sliceOffset() {
                            return this._sliceOffset;
                        }
                        get sliceTop() {
                            return this._sliceOffset + this.buffer.byteLength;
                        }
                        get littleEndian() {
                            return this._littleEndian;
                        }
                        get bigTiff() {
                            return this._bigTiff;
                        }
                        get buffer() {
                            return this._dataView.buffer;
                        }
                        covers(t, e) {
                            return this.sliceOffset <= t && this.sliceTop >= t + e;
                        }
                        readUint8(t) {
                            return this._dataView.getUint8(t - this._sliceOffset, this._littleEndian);
                        }
                        readInt8(t) {
                            return this._dataView.getInt8(t - this._sliceOffset, this._littleEndian);
                        }
                        readUint16(t) {
                            return this._dataView.getUint16(t - this._sliceOffset, this._littleEndian);
                        }
                        readInt16(t) {
                            return this._dataView.getInt16(t - this._sliceOffset, this._littleEndian);
                        }
                        readUint32(t) {
                            return this._dataView.getUint32(t - this._sliceOffset, this._littleEndian);
                        }
                        readInt32(t) {
                            return this._dataView.getInt32(t - this._sliceOffset, this._littleEndian);
                        }
                        readFloat32(t) {
                            return this._dataView.getFloat32(t - this._sliceOffset, this._littleEndian);
                        }
                        readFloat64(t) {
                            return this._dataView.getFloat64(t - this._sliceOffset, this._littleEndian);
                        }
                        readUint64(t) {
                            const e = this.readUint32(t), r = this.readUint32(t + 4);
                            let n;
                            if (this._littleEndian) {
                                if (n = e + 2 ** 32 * r, !Number.isSafeInteger(n)) throw new Error(n + " exceeds MAX_SAFE_INTEGER. Precision may be lost. Please report if you get this message to https://github.com/geotiffjs/geotiff.js/issues");
                                return n;
                            }
                            if (n = 2 ** 32 * e + r, !Number.isSafeInteger(n)) throw new Error(n + " exceeds MAX_SAFE_INTEGER. Precision may be lost. Please report if you get this message to https://github.com/geotiffjs/geotiff.js/issues");
                            return n;
                        }
                        readInt64(t) {
                            let e = 0;
                            const r = (128 & this._dataView.getUint8(t + (this._littleEndian ? 7 : 0))) > 0;
                            let n = !0;
                            for(let i = 0; i < 8; i++){
                                let o = this._dataView.getUint8(t + (this._littleEndian ? i : 7 - i));
                                r && (n ? 0 !== o && (o = 255 & ~(o - 1), n = !1) : o = 255 & ~o), e += o * 256 ** i;
                            }
                            return r && (e = -e), e;
                        }
                        readOffset(t) {
                            return this._bigTiff ? this.readUint64(t) : this.readUint32(t);
                        }
                    }
                    var $ = r(68), V = r(7), Z = r(25), Y = r(40), K = r.n(Y), X = r(106), J = r.n(X), Q = r(39), tt = r.n(Q);
                    class et {
                        constructor(t, { blockSize: e = 65536 } = {}){
                            this.retrievalFunction = t, this.blockSize = e, this.blockRequests = new Map, this.blocks = new Map, this.blockIdsAwaitingRequest = null;
                        }
                        async fetch(t, e, r = !1) {
                            const n = t + e, i = [], o = [], a = [];
                            for(let e = Math.floor(t / this.blockSize) * this.blockSize; e < n; e += this.blockSize){
                                const t = Math.floor(e / this.blockSize);
                                this.blocks.has(t) || this.blockRequests.has(t) || o.push(t), this.blockRequests.has(t) && a.push(this.blockRequests.get(t)), i.push(t);
                            }
                            if (this.blockIdsAwaitingRequest) for(let t = 0; t < o.length; ++t){
                                const e = o[t];
                                this.blockIdsAwaitingRequest.add(e);
                            }
                            else this.blockIdsAwaitingRequest = new Set(o);
                            if (r || await async function(t) {
                                return new Promise((t)=>setTimeout(t, void 0));
                            }(), this.blockIdsAwaitingRequest) {
                                const t = function(t) {
                                    if (0 === t.length) return [];
                                    const e = [];
                                    let r = [];
                                    e.push(r);
                                    for(let n = 0; n < t.length; ++n)0 === n || t[n] === t[n - 1] + 1 ? r.push(t[n]) : (r = [
                                        t[n]
                                    ], e.push(r));
                                    return e;
                                }(Array.from(this.blockIdsAwaitingRequest).sort());
                                for (const e of t){
                                    const t = this.requestData(e[0] * this.blockSize, e.length * this.blockSize);
                                    for(let r = 0; r < e.length; ++r){
                                        const n = e[r];
                                        this.blockRequests.set(n, (async ()=>{
                                            const e = await t, i = r * this.blockSize, o = Math.min(i + this.blockSize, e.data.byteLength), a = e.data.slice(i, o);
                                            this.blockRequests.delete(n), this.blocks.set(n, {
                                                data: a,
                                                offset: e.offset + i,
                                                length: a.byteLength,
                                                top: e.offset + o
                                            });
                                        })());
                                    }
                                }
                                this.blockIdsAwaitingRequest = null;
                            }
                            const s = [];
                            for (const t of o)this.blockRequests.has(t) && s.push(this.blockRequests.get(t));
                            return await Promise.all(s), await Promise.all(a), function(t, e, r) {
                                const n = e + r, i = new ArrayBuffer(r), o = new Uint8Array(i);
                                for (const r of t){
                                    const t = r.offset - e, i = r.top - n;
                                    let a, s = 0, u = 0;
                                    t < 0 ? s = -t : t > 0 && (u = t), a = i < 0 ? r.length - s : n - r.offset - s;
                                    const l = new Uint8Array(r.data, s, a);
                                    o.set(l, u);
                                }
                                return i;
                            }(i.map((t)=>this.blocks.get(t)), t, e);
                        }
                        async requestData(t, e) {
                            const r = await this.retrievalFunction(t, e);
                            return r.length ? r.length !== r.data.byteLength && (r.data = r.data.slice(0, r.length)) : r.length = r.data.byteLength, r.top = r.offset + r.length, r;
                        }
                    }
                    function rt(t, e) {
                        const { forceXHR: r } = e;
                        if ("function" == typeof fetch && !r) return function(t, { headers: e = {}, blockSize: r } = {}) {
                            return new et(async (r, n)=>{
                                const i = await fetch(t, {
                                    headers: {
                                        ...e,
                                        Range: `bytes=${r}-${r + n - 1}`
                                    }
                                });
                                if (i.ok) {
                                    if (206 === i.status) return {
                                        data: i.arrayBuffer ? await i.arrayBuffer() : (await i.buffer()).buffer,
                                        offset: r,
                                        length: n
                                    };
                                    {
                                        const t = i.arrayBuffer ? await i.arrayBuffer() : (await i.buffer()).buffer;
                                        return {
                                            data: t,
                                            offset: 0,
                                            length: t.byteLength
                                        };
                                    }
                                }
                                throw new Error("Error fetching data.");
                            }, {
                                blockSize: r
                            });
                        }(t, e);
                        if ("undefined" != typeof XMLHttpRequest) return function(t, { headers: e = {}, blockSize: r } = {}) {
                            return new et(async (r, n)=>new Promise((i, o)=>{
                                    const a = new XMLHttpRequest;
                                    a.open("GET", t), a.responseType = "arraybuffer";
                                    const s = {
                                        ...e,
                                        Range: `bytes=${r}-${r + n - 1}`
                                    };
                                    for (const [t, e] of Object.entries(s))a.setRequestHeader(t, e);
                                    a.onload = ()=>{
                                        const t = a.response;
                                        206 === a.status ? i({
                                            data: t,
                                            offset: r,
                                            length: n
                                        }) : i({
                                            data: t,
                                            offset: 0,
                                            length: t.byteLength
                                        });
                                    }, a.onerror = o, a.send();
                                }), {
                                blockSize: r
                            });
                        }(t, e);
                        if (K.a.get) return function(t, { headers: e = {}, blockSize: r } = {}) {
                            return new et(async (r, n)=>new Promise((i, o)=>{
                                    const a = tt.a.parse(t);
                                    ("http:" === a.protocol ? K.a : J.a).get({
                                        ...a,
                                        headers: {
                                            ...e,
                                            Range: `bytes=${r}-${r + n - 1}`
                                        }
                                    }, (t)=>{
                                        const e = [];
                                        t.on("data", (t)=>{
                                            e.push(t);
                                        }), t.on("end", ()=>{
                                            const t = V.Buffer.concat(e).buffer;
                                            i({
                                                data: t,
                                                offset: r,
                                                length: t.byteLength
                                            });
                                        });
                                    }).on("error", o);
                                }), {
                                blockSize: r
                            });
                        }(t, e);
                        throw new Error("No remote source available");
                    }
                    function nt(t, e) {
                        for(const r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
                    }
                    function it(t, e) {
                        return !(t.length < e.length) && t.substr(t.length - e.length) === e;
                    }
                    function ot(t) {
                        const e = {};
                        for(const r in t)t.hasOwnProperty(r) && (e[t[r]] = r);
                        return e;
                    }
                    function at(t, e) {
                        const r = [];
                        for(let n = 0; n < t; n++)r.push(e(n));
                        return r;
                    }
                    const st = ot(s), ut = ot(m), lt = {};
                    nt(lt, st), nt(lt, ut);
                    const ct = ot(f), ft = {
                        nextZero: (t, e)=>{
                            let r = e;
                            for(; 0 !== t[r];)r++;
                            return r;
                        },
                        readUshort: (t, e)=>t[e] << 8 | t[e + 1],
                        readShort: (t, e)=>{
                            const r = ft.ui8;
                            return r[0] = t[e + 1], r[1] = t[e + 0], ft.i16[0];
                        },
                        readInt: (t, e)=>{
                            const r = ft.ui8;
                            return r[0] = t[e + 3], r[1] = t[e + 2], r[2] = t[e + 1], r[3] = t[e + 0], ft.i32[0];
                        },
                        readUint: (t, e)=>{
                            const r = ft.ui8;
                            return r[0] = t[e + 3], r[1] = t[e + 2], r[2] = t[e + 1], r[3] = t[e + 0], ft.ui32[0];
                        },
                        readASCII: (t, e, r)=>r.map((r)=>String.fromCharCode(t[e + r])).join(""),
                        readFloat: (t, e)=>{
                            const r = ft.ui8;
                            return at(4, (n)=>{
                                r[n] = t[e + 3 - n];
                            }), ft.fl32[0];
                        },
                        readDouble: (t, e)=>{
                            const r = ft.ui8;
                            return at(8, (n)=>{
                                r[n] = t[e + 7 - n];
                            }), ft.fl64[0];
                        },
                        writeUshort: (t, e, r)=>{
                            t[e] = r >> 8 & 255, t[e + 1] = 255 & r;
                        },
                        writeUint: (t, e, r)=>{
                            t[e] = r >> 24 & 255, t[e + 1] = r >> 16 & 255, t[e + 2] = r >> 8 & 255, t[e + 3] = r >> 0 & 255;
                        },
                        writeASCII: (t, e, r)=>{
                            at(r.length, (n)=>{
                                t[e + n] = r.charCodeAt(n);
                            });
                        },
                        ui8: new Uint8Array(8)
                    };
                    ft.fl64 = new Float64Array(ft.ui8.buffer), ft.writeDouble = (t, e, r)=>{
                        ft.fl64[0] = r, at(8, (r)=>{
                            t[e + r] = ft.ui8[7 - r];
                        });
                    };
                    const ht = [
                        [
                            "Compression",
                            1
                        ],
                        [
                            "PlanarConfiguration",
                            1
                        ],
                        [
                            "XPosition",
                            0
                        ],
                        [
                            "YPosition",
                            0
                        ],
                        [
                            "ResolutionUnit",
                            1
                        ],
                        [
                            "ExtraSamples",
                            0
                        ],
                        [
                            "GeoAsciiParams",
                            "WGS 84\0"
                        ],
                        [
                            "ModelTiepoint",
                            [
                                0,
                                0,
                                0,
                                -180,
                                90,
                                0
                            ]
                        ],
                        [
                            "GTModelTypeGeoKey",
                            2
                        ],
                        [
                            "GTRasterTypeGeoKey",
                            1
                        ],
                        [
                            "GeographicTypeGeoKey",
                            4326
                        ],
                        [
                            "GeogCitationGeoKey",
                            "WGS 84"
                        ]
                    ];
                    function pt(t, e) {
                        let r, n, i, o;
                        "number" == typeof t[0] ? (r = e.height || e.ImageLength, i = e.width || e.ImageWidth, n = t.length / (r * i), o = t) : (n = t.length, r = t[0].length, i = t[0][0].length, o = [], at(r, (e)=>{
                            at(i, (r)=>{
                                at(n, (n)=>{
                                    o.push(t[n][e][r]);
                                });
                            });
                        })), e.ImageLength = r, delete e.height, e.ImageWidth = i, delete e.width, e.BitsPerSample || (e.BitsPerSample = at(n, ()=>8)), ht.forEach((t)=>{
                            const r = t[0];
                            if (!e[r]) {
                                const n = t[1];
                                e[r] = n;
                            }
                        }), e.PhotometricInterpretation || (e.PhotometricInterpretation = 3 === e.BitsPerSample.length ? 2 : 1), e.SamplesPerPixel || (e.SamplesPerPixel = [
                            n
                        ]), e.StripByteCounts || (e.StripByteCounts = [
                            n * r * i
                        ]), e.ModelPixelScale || (e.ModelPixelScale = [
                            360 / i,
                            180 / r,
                            0
                        ]), e.SampleFormat || (e.SampleFormat = at(n, ()=>1));
                        const a = Object.keys(e).filter((t)=>it(t, "GeoKey")).sort((t, e)=>lt[t] - lt[e]);
                        if (!e.GeoKeyDirectory) {
                            const t = [
                                1,
                                1,
                                0,
                                a.length
                            ];
                            a.forEach((r)=>{
                                const n = Number(lt[r]);
                                let i, o, a;
                                t.push(n), "SHORT" === l[n] ? (i = 1, o = 0, a = e[r]) : "GeogCitationGeoKey" === r ? (i = e.GeoAsciiParams.length, o = Number(lt.GeoAsciiParams), a = 0) : console.log("[geotiff.js] couldn't get TIFFTagLocation for " + r), t.push(o), t.push(i), t.push(a);
                            }), e.GeoKeyDirectory = t;
                        }
                        for(const t in a)a.hasOwnProperty(t) && delete e[t];
                        [
                            "Compression",
                            "ExtraSamples",
                            "GeographicTypeGeoKey",
                            "GTModelTypeGeoKey",
                            "GTRasterTypeGeoKey",
                            "ImageLength",
                            "ImageWidth",
                            "PhotometricInterpretation",
                            "PlanarConfiguration",
                            "ResolutionUnit",
                            "SamplesPerPixel",
                            "XPosition",
                            "YPosition"
                        ].forEach((t)=>{
                            var r;
                            e[t] && (e[t] = (r = e[t], Array.isArray(r) ? r : [
                                r
                            ]));
                        });
                        const s = ((t)=>{
                            const e = {};
                            for(const r in t)"StripOffsets" !== r && (lt[r] || console.error(r, "not in name2code:", Object.keys(lt)), e[lt[r]] = t[r]);
                            return e;
                        })(e);
                        return ((t, e, r, n)=>{
                            if (null == r) throw new Error("you passed into encodeImage a width of type " + r);
                            if (null == e) throw new Error("you passed into encodeImage a width of type " + e);
                            const i = {
                                256: [
                                    e
                                ],
                                257: [
                                    r
                                ],
                                273: [
                                    1e3
                                ],
                                278: [
                                    r
                                ],
                                305: "geotiff.js"
                            };
                            if (n) for(const t in n)n.hasOwnProperty(t) && (i[t] = n[t]);
                            const o = new Uint8Array(((t)=>{
                                const e = new Uint8Array(1e3);
                                let r = 4;
                                const n = ft;
                                e[0] = 77, e[1] = 77, e[3] = 42;
                                let i = 8;
                                if (n.writeUint(e, r, i), r += 4, t.forEach((r, o)=>{
                                    const a = ((t, e, r, n)=>{
                                        let i = r;
                                        const o = Object.keys(n).filter((t)=>null != t && "undefined" !== t);
                                        t.writeUshort(e, i, o.length), i += 2;
                                        let a = i + 12 * o.length + 4;
                                        for (const r of o){
                                            let o = null;
                                            "number" == typeof r ? o = r : "string" == typeof r && (o = parseInt(r, 10));
                                            const s = l[o], u = ct[s];
                                            if (null == s || void 0 === s || void 0 === s) throw new Error("unknown type of tag: " + o);
                                            let c = n[r];
                                            if (void 0 === c) throw new Error("failed to get value for key " + r);
                                            "ASCII" === s && "string" == typeof c && !1 === it(c, "\0") && (c += "\0");
                                            const f = c.length;
                                            t.writeUshort(e, i, o), i += 2, t.writeUshort(e, i, u), i += 2, t.writeUint(e, i, f), i += 4;
                                            let h = [
                                                -1,
                                                1,
                                                1,
                                                2,
                                                4,
                                                8,
                                                0,
                                                0,
                                                0,
                                                0,
                                                0,
                                                0,
                                                8
                                            ][u] * f, p = i;
                                            h > 4 && (t.writeUint(e, i, a), p = a), "ASCII" === s ? t.writeASCII(e, p, c) : "SHORT" === s ? at(f, (r)=>{
                                                t.writeUshort(e, p + 2 * r, c[r]);
                                            }) : "LONG" === s ? at(f, (r)=>{
                                                t.writeUint(e, p + 4 * r, c[r]);
                                            }) : "RATIONAL" === s ? at(f, (r)=>{
                                                t.writeUint(e, p + 8 * r, Math.round(1e4 * c[r])), t.writeUint(e, p + 8 * r + 4, 1e4);
                                            }) : "DOUBLE" === s && at(f, (r)=>{
                                                t.writeDouble(e, p + 8 * r, c[r]);
                                            }), h > 4 && (h += 1 & h, a += h), i += 4;
                                        }
                                        return [
                                            i,
                                            a
                                        ];
                                    })(n, e, i, r);
                                    i = a[1], o < t.length - 1 && n.writeUint(e, a[0], i);
                                }), e.slice) return e.slice(0, i).buffer;
                                const o = new Uint8Array(i);
                                for(let t = 0; t < i; t++)o[t] = e[t];
                                return o.buffer;
                            })([
                                i
                            ])), a = new Uint8Array(t), s = i[277], u = new Uint8Array(1e3 + e * r * s);
                            return at(o.length, (t)=>{
                                u[t] = o[t];
                            }), function(t, e) {
                                const { length: r } = t;
                                for(let n = 0; n < r; n++)e(t[n], n);
                            }(a, (t, e)=>{
                                u[1e3 + e] = t;
                            }), u.buffer;
                        })(o, i, r, s);
                    }
                    class dt {
                        log() {}
                        info() {}
                        warn() {}
                        error() {}
                        time() {}
                        timeEnd() {}
                    }
                    let mt = new dt;
                    function yt(t = new dt) {
                        mt = t;
                    }
                    function gt(t) {
                        switch(t){
                            case h.BYTE:
                            case h.ASCII:
                            case h.SBYTE:
                            case h.UNDEFINED:
                                return 1;
                            case h.SHORT:
                            case h.SSHORT:
                                return 2;
                            case h.LONG:
                            case h.SLONG:
                            case h.FLOAT:
                            case h.IFD:
                                return 4;
                            case h.RATIONAL:
                            case h.SRATIONAL:
                            case h.DOUBLE:
                            case h.LONG8:
                            case h.SLONG8:
                            case h.IFD8:
                                return 8;
                            default:
                                throw new RangeError("Invalid field type: " + t);
                        }
                    }
                    function vt(t, e, r, n) {
                        let i = null, o = null;
                        const a = gt(e);
                        switch(e){
                            case h.BYTE:
                            case h.ASCII:
                            case h.UNDEFINED:
                                i = new Uint8Array(r), o = t.readUint8;
                                break;
                            case h.SBYTE:
                                i = new Int8Array(r), o = t.readInt8;
                                break;
                            case h.SHORT:
                                i = new Uint16Array(r), o = t.readUint16;
                                break;
                            case h.SSHORT:
                                i = new Int16Array(r), o = t.readInt16;
                                break;
                            case h.LONG:
                            case h.IFD:
                                i = new Uint32Array(r), o = t.readUint32;
                                break;
                            case h.SLONG:
                                i = new Int32Array(r), o = t.readInt32;
                                break;
                            case h.LONG8:
                            case h.IFD8:
                                i = new Array(r), o = t.readUint64;
                                break;
                            case h.SLONG8:
                                i = new Array(r), o = t.readInt64;
                                break;
                            case h.RATIONAL:
                                i = new Uint32Array(2 * r), o = t.readUint32;
                                break;
                            case h.SRATIONAL:
                                i = new Int32Array(2 * r), o = t.readInt32;
                                break;
                            case h.FLOAT:
                                i = new Float32Array(r), o = t.readFloat32;
                                break;
                            case h.DOUBLE:
                                i = new Float64Array(r), o = t.readFloat64;
                                break;
                            default:
                                throw new RangeError("Invalid field type: " + e);
                        }
                        if (e !== h.RATIONAL && e !== h.SRATIONAL) for(let e = 0; e < r; ++e)i[e] = o.call(t, n + e * a);
                        else for(let e = 0; e < r; e += 2)i[e] = o.call(t, n + e * a), i[e + 1] = o.call(t, n + (e * a + 4));
                        return e === h.ASCII ? String.fromCharCode.apply(null, i) : i;
                    }
                    class bt {
                        constructor(t, e, r){
                            this.fileDirectory = t, this.geoKeyDirectory = e, this.nextIFDByteOffset = r;
                        }
                    }
                    class xt extends Error {
                        constructor(t){
                            super("No image at index " + t), this.index = t;
                        }
                    }
                    class wt {
                        async readRasters(t = {}) {
                            const { window: e, width: r, height: n } = t;
                            let { resX: i, resY: o, bbox: a } = t;
                            const s = await this.getImage();
                            let u = s;
                            const l = await this.getImageCount(), c = s.getBoundingBox();
                            if (e && a) throw new Error('Both "bbox" and "window" passed.');
                            if (r || n) {
                                if (e) {
                                    const [t, r] = s.getOrigin(), [n, i] = s.getResolution();
                                    a = [
                                        t + e[0] * n,
                                        r + e[1] * i,
                                        t + e[2] * n,
                                        r + e[3] * i
                                    ];
                                }
                                const t = a || c;
                                if (r) {
                                    if (i) throw new Error("Both width and resX passed");
                                    i = (t[2] - t[0]) / r;
                                }
                                if (n) {
                                    if (o) throw new Error("Both width and resY passed");
                                    o = (t[3] - t[1]) / n;
                                }
                            }
                            if (i || o) {
                                const t = [];
                                for(let e = 0; e < l; ++e){
                                    const r = await this.getImage(e), { SubfileType: n, NewSubfileType: i } = r.fileDirectory;
                                    (0 === e || 2 === n || 1 & i) && t.push(r);
                                }
                                t.sort((t, e)=>t.getWidth() - e.getWidth());
                                for(let e = 0; e < t.length; ++e){
                                    const r = t[e], n = (c[2] - c[0]) / r.getWidth(), a = (c[3] - c[1]) / r.getHeight();
                                    if (u = r, i && i > n || o && o > a) break;
                                }
                            }
                            let f = e;
                            if (a) {
                                const [t, e] = s.getOrigin(), [r, n] = u.getResolution(s);
                                f = [
                                    Math.round((a[0] - t) / r),
                                    Math.round((a[1] - e) / n),
                                    Math.round((a[2] - t) / r),
                                    Math.round((a[3] - e) / n)
                                ], f = [
                                    Math.min(f[0], f[2]),
                                    Math.min(f[1], f[3]),
                                    Math.max(f[0], f[2]),
                                    Math.max(f[1], f[3])
                                ];
                            }
                            return u.readRasters({
                                ...t,
                                window: f
                            });
                        }
                    }
                    class _t extends wt {
                        constructor(t, e, r, n, i = {}){
                            super(), this.source = t, this.littleEndian = e, this.bigTiff = r, this.firstIFDOffset = n, this.cache = i.cache || !1, this.ifdRequests = [], this.ghostValues = null;
                        }
                        async getSlice(t, e) {
                            const r = this.bigTiff ? 4048 : 1024;
                            return new W(await this.source.fetch(t, void 0 !== e ? e : r), t, this.littleEndian, this.bigTiff);
                        }
                        async parseFileDirectoryAt(t) {
                            const e = this.bigTiff ? 20 : 12, r = this.bigTiff ? 8 : 2;
                            let n = await this.getSlice(t);
                            const i = this.bigTiff ? n.readUint64(t) : n.readUint16(t), o = i * e + (this.bigTiff ? 16 : 6);
                            n.covers(t, o) || (n = await this.getSlice(t, o));
                            const a = {};
                            let u = t + (this.bigTiff ? 8 : 2);
                            for(let t = 0; t < i; u += e, ++t){
                                const t = n.readUint16(u), e = n.readUint16(u + 2), r = this.bigTiff ? n.readUint64(u + 4) : n.readUint32(u + 4);
                                let i, o;
                                const l = gt(e), f = u + (this.bigTiff ? 12 : 8);
                                if (l * r <= (this.bigTiff ? 8 : 4)) i = vt(n, e, r, f);
                                else {
                                    const t = n.readOffset(f), o = gt(e) * r;
                                    i = n.covers(t, o) ? vt(n, e, r, t) : vt(await this.getSlice(t, o), e, r, t);
                                }
                                o = 1 === r && -1 === c.indexOf(t) && e !== h.RATIONAL && e !== h.SRATIONAL ? i[0] : i, a[s[t]] = o;
                            }
                            const l = function(t) {
                                const e = t.GeoKeyDirectory;
                                if (!e) return null;
                                const r = {};
                                for(let n = 4; n <= 4 * e[3]; n += 4){
                                    const i = m[e[n]], o = e[n + 1] ? s[e[n + 1]] : null, a = e[n + 2], u = e[n + 3];
                                    let l = null;
                                    if (o) {
                                        if (l = t[o], null == l) throw new Error(`Could not get value of geoKey '${i}'.`);
                                        "string" == typeof l ? l = l.substring(u, u + a - 1) : l.subarray && (l = l.subarray(u, u + a), 1 === a && (l = l[0]));
                                    } else l = u;
                                    r[i] = l;
                                }
                                return r;
                            }(a), f = n.readOffset(t + r + e * i);
                            return new bt(a, l, f);
                        }
                        async requestIFD(t) {
                            if (this.ifdRequests[t]) return this.ifdRequests[t];
                            if (0 === t) return this.ifdRequests[t] = this.parseFileDirectoryAt(this.firstIFDOffset), this.ifdRequests[t];
                            if (!this.ifdRequests[t - 1]) try {
                                this.ifdRequests[t - 1] = this.requestIFD(t - 1);
                            } catch (e) {
                                if (e instanceof xt) throw new xt(t);
                                throw e;
                            }
                            return this.ifdRequests[t] = (async ()=>{
                                const e = await this.ifdRequests[t - 1];
                                if (0 === e.nextIFDByteOffset) throw new xt(t);
                                return this.parseFileDirectoryAt(e.nextIFDByteOffset);
                            })(), this.ifdRequests[t];
                        }
                        async getImage(t = 0) {
                            const e = await this.requestIFD(t);
                            return new G(e.fileDirectory, e.geoKeyDirectory, this.dataView, this.littleEndian, this.cache, this.source);
                        }
                        async getImageCount() {
                            let t = 0, e = !0;
                            for(; e;)try {
                                await this.requestIFD(t), ++t;
                            } catch (t) {
                                if (!(t instanceof xt)) throw t;
                                e = !1;
                            }
                            return t;
                        }
                        async getGhostValues() {
                            const t = this.bigTiff ? 16 : 8;
                            if (this.ghostValues) return this.ghostValues;
                            const e = "GDAL_STRUCTURAL_METADATA_SIZE=", r = e.length + 100;
                            let n = await this.getSlice(t, r);
                            if (e === vt(n, h.ASCII, e.length, t)) {
                                const e = vt(n, h.ASCII, r, t).split("\n")[0], i = Number(e.split("=")[1].split(" ")[0]) + e.length;
                                i > r && (n = await this.getSlice(t, i));
                                const o = vt(n, h.ASCII, i, t);
                                this.ghostValues = {}, o.split("\n").filter((t)=>t.length > 0).map((t)=>t.split("=")).forEach(([t, e])=>{
                                    this.ghostValues[t] = e;
                                });
                            }
                            return this.ghostValues;
                        }
                        static async fromSource(t, e) {
                            const r = await t.fetch(0, 1024), n = new H(r), i = n.getUint16(0, 0);
                            let o;
                            if (18761 === i) o = !0;
                            else {
                                if (19789 !== i) throw new TypeError("Invalid byte order value.");
                                o = !1;
                            }
                            const a = n.getUint16(2, o);
                            let s;
                            if (42 === a) s = !1;
                            else {
                                if (43 !== a) throw new TypeError("Invalid magic number.");
                                if (s = !0, 8 !== n.getUint16(4, o)) throw new Error("Unsupported offset byte-size.");
                            }
                            const u = s ? n.getUint64(8, o) : n.getUint32(4, o);
                            return new _t(t, o, s, u, e);
                        }
                        close() {
                            return "function" == typeof this.source.close && this.source.close();
                        }
                    }
                    e.default = _t;
                    class At extends wt {
                        constructor(t, e){
                            super(), this.mainFile = t, this.overviewFiles = e, this.imageFiles = [
                                t
                            ].concat(e), this.fileDirectoriesPerFile = null, this.fileDirectoriesPerFileParsing = null, this.imageCount = null;
                        }
                        async parseFileDirectoriesPerFile() {
                            const t = [
                                this.mainFile.parseFileDirectoryAt(this.mainFile.firstIFDOffset)
                            ].concat(this.overviewFiles.map((t)=>t.parseFileDirectoryAt(t.firstIFDOffset)));
                            return this.fileDirectoriesPerFile = await Promise.all(t), this.fileDirectoriesPerFile;
                        }
                        async getImage(t = 0) {
                            await this.getImageCount(), await this.parseFileDirectoriesPerFile();
                            let e = 0, r = 0;
                            for(let n = 0; n < this.imageFiles.length; n++){
                                const i = this.imageFiles[n];
                                for(let o = 0; o < this.imageCounts[n]; o++){
                                    if (t === e) {
                                        const t = await i.requestIFD(r);
                                        return new G(t.fileDirectory, i.geoKeyDirectory, i.dataView, i.littleEndian, i.cache, i.source);
                                    }
                                    e++, r++;
                                }
                                r = 0;
                            }
                            throw new RangeError("Invalid image index");
                        }
                        async getImageCount() {
                            if (null !== this.imageCount) return this.imageCount;
                            const t = [
                                this.mainFile.getImageCount()
                            ].concat(this.overviewFiles.map((t)=>t.getImageCount()));
                            return this.imageCounts = await Promise.all(t), this.imageCount = this.imageCounts.reduce((t, e)=>t + e, 0), this.imageCount;
                        }
                    }
                    async function Et(t, e = {}) {
                        return _t.fromSource(rt(t, e));
                    }
                    async function St(t) {
                        return _t.fromSource(function(t) {
                            return {
                                fetch: async (e, r)=>t.slice(e, e + r)
                            };
                        }(t));
                    }
                    async function Mt(t) {
                        return _t.fromSource(function(t) {
                            const e = function(t, e, r) {
                                return new Promise((e, r)=>{
                                    Object(Z.open)(t, "r", void 0, (t, n)=>{
                                        t ? r(t) : e(n);
                                    });
                                });
                            }(t);
                            return {
                                async fetch (t, r) {
                                    const n = await e, { buffer: i } = await function(...t) {
                                        return new Promise((e, r)=>{
                                            Object(Z.read)(...t, (t, n, i)=>{
                                                t ? r(t) : e({
                                                    bytesRead: n,
                                                    buffer: i
                                                });
                                            });
                                        });
                                    }(n, V.Buffer.alloc(r), 0, r, t);
                                    return i.buffer;
                                },
                                async close () {
                                    const t = await e;
                                    return await function(t) {
                                        return new Promise((e, r)=>{
                                            Object(Z.close)(t, (t)=>{
                                                t ? r(t) : e();
                                            });
                                        });
                                    }(t);
                                }
                            };
                        }(t));
                    }
                    async function kt(t) {
                        var e;
                        return _t.fromSource((e = t, {
                            fetch: async (t, r)=>new Promise((n, i)=>{
                                    const o = e.slice(t, t + r), a = new FileReader;
                                    a.onload = (t)=>n(t.target.result), a.onerror = i, a.readAsArrayBuffer(o);
                                })
                        }));
                    }
                    async function Nt(t, e = [], r = {}) {
                        const n = await _t.fromSource(rt(t, r)), i = await Promise.all(e.map((t)=>_t.fromSource(rt(t, r))));
                        return new At(n, i);
                    }
                    async function Ct(t, e) {
                        return pt(t, e);
                    }
                },
                function(t, e, r) {
                    function n(t, e) {
                        "use strict";
                        var r = (e = e || {}).pos || 0, i = "<".charCodeAt(0), o = ">".charCodeAt(0), a = "-".charCodeAt(0), s = "/".charCodeAt(0), u = "!".charCodeAt(0), l = "'".charCodeAt(0), c = '"'.charCodeAt(0);
                        function f() {
                            for(var e = []; t[r];)if (t.charCodeAt(r) == i) {
                                if (t.charCodeAt(r + 1) === s) return (r = t.indexOf(">", r)) + 1 && (r += 1), e;
                                if (t.charCodeAt(r + 1) === u) {
                                    if (t.charCodeAt(r + 2) == a) {
                                        for(; -1 !== r && (t.charCodeAt(r) !== o || t.charCodeAt(r - 1) != a || t.charCodeAt(r - 2) != a || -1 == r);)r = t.indexOf(">", r + 1);
                                        -1 === r && (r = t.length);
                                    } else for(r += 2; t.charCodeAt(r) !== o && t[r];)r++;
                                    r++;
                                    continue;
                                }
                                var n = m();
                                e.push(n);
                            } else {
                                var l = h();
                                l.trim().length > 0 && e.push(l), r++;
                            }
                            return e;
                        }
                        function h() {
                            var e = r;
                            return -2 == (r = t.indexOf("<", r) - 1) && (r = t.length), t.slice(e, r + 1);
                        }
                        function p() {
                            for(var e = r; -1 === "\n	>/= ".indexOf(t[r]) && t[r];)r++;
                            return t.slice(e, r);
                        }
                        var d = e.noChildNodes || [
                            "img",
                            "br",
                            "input",
                            "meta",
                            "link"
                        ];
                        function m() {
                            r++;
                            const e = p(), n = {};
                            let i = [];
                            for(; t.charCodeAt(r) !== o && t[r];){
                                var a = t.charCodeAt(r);
                                if (a > 64 && a < 91 || a > 96 && a < 123) {
                                    for(var u = p(), h = t.charCodeAt(r); h && h !== l && h !== c && !(h > 64 && h < 91 || h > 96 && h < 123) && h !== o;)r++, h = t.charCodeAt(r);
                                    if (h === l || h === c) {
                                        var m = y();
                                        if (-1 === r) return {
                                            tagName: e,
                                            attributes: n,
                                            children: i
                                        };
                                    } else m = null, r--;
                                    n[u] = m;
                                }
                                r++;
                            }
                            if (t.charCodeAt(r - 1) !== s) {
                                if ("script" == e) {
                                    var g = r + 1;
                                    r = t.indexOf("</script>", r), i = [
                                        t.slice(g, r - 1)
                                    ], r += 9;
                                } else "style" == e ? (g = r + 1, r = t.indexOf("</style>", r), i = [
                                    t.slice(g, r - 1)
                                ], r += 8) : -1 == d.indexOf(e) && (r++, i = f());
                            } else r++;
                            return {
                                tagName: e,
                                attributes: n,
                                children: i
                            };
                        }
                        function y() {
                            var e = t[r], n = ++r;
                            return r = t.indexOf(e, n), t.slice(n, r);
                        }
                        var g, v = null;
                        if (void 0 !== e.attrValue) for(e.attrName = e.attrName || "id", v = []; -1 !== (g = new RegExp("\\s" + e.attrName + "\\s*=['\"]" + e.attrValue + "['\"]").exec(t), r = g ? g.index : -1);)-1 !== (r = t.lastIndexOf("<", r)) && v.push(m()), t = t.substr(r), r = 0;
                        else v = e.parseNode ? m() : f();
                        return e.filter && (v = n.filter(v, e.filter)), e.setPos && (v.pos = r), v;
                    }
                    n.simplify = function(t) {
                        var e = {};
                        if (!t.length) return "";
                        if (1 === t.length && "string" == typeof t[0]) return t[0];
                        for(var r in t.forEach(function(t) {
                            if ("object" == typeof t) {
                                e[t.tagName] || (e[t.tagName] = []);
                                var r = n.simplify(t.children || []);
                                e[t.tagName].push(r), t.attributes && (r._attributes = t.attributes);
                            }
                        }), e)1 == e[r].length && (e[r] = e[r][0]);
                        return e;
                    }, n.filter = function(t, e) {
                        var r = [];
                        return t.forEach(function(t) {
                            if ("object" == typeof t && e(t) && r.push(t), t.children) {
                                var i = n.filter(t.children, e);
                                r = r.concat(i);
                            }
                        }), r;
                    }, n.stringify = function(t) {
                        var e = "";
                        function r(t) {
                            if (t) for(var r = 0; r < t.length; r++)"string" == typeof t[r] ? e += t[r].trim() : n(t[r]);
                        }
                        function n(t) {
                            for(var n in e += "<" + t.tagName, t.attributes)null === t.attributes[n] ? e += " " + n : -1 === t.attributes[n].indexOf('"') ? e += " " + n + '="' + t.attributes[n].trim() + '"' : e += " " + n + "='" + t.attributes[n].trim() + "'";
                            e += ">", r(t.children), e += "</" + t.tagName + ">";
                        }
                        return r(t), e;
                    }, n.toContentString = function(t) {
                        if (Array.isArray(t)) {
                            var e = "";
                            return t.forEach(function(t) {
                                e = (e += " " + n.toContentString(t)).trim();
                            }), e;
                        }
                        return "object" == typeof t ? n.toContentString(t.children) : " " + t;
                    }, n.getElementById = function(t, e, r) {
                        var i = n(t, {
                            attrValue: e
                        });
                        return r ? n.simplify(i) : i[0];
                    }, n.getElementsByClassName = function(t, e, r) {
                        const i = n(t, {
                            attrName: "class",
                            attrValue: "[a-zA-Z0-9-s ]*" + e + "[a-zA-Z0-9-s ]*"
                        });
                        return r ? n.simplify(i) : i;
                    }, n.parseStream = function(t, e) {
                        if ("string" == typeof e && (e = e.length + 2), "string" == typeof t) {
                            var i = r(25);
                            t = i.createReadStream(t, {
                                start: e
                            }), e = 0;
                        }
                        var o = e, a = "";
                        return t.on("data", function(e) {
                            a += e;
                            for(var r = 0;;){
                                if (!(o = a.indexOf("<", o) + 1)) return void (o = r);
                                if ("/" !== a[o + 1]) {
                                    var i = n(a, {
                                        pos: o - 1,
                                        parseNode: !0,
                                        setPos: !0
                                    });
                                    if ((o = i.pos) > a.length - 1 || o < r) return a = a.slice(r), o = 0, void (r = 0);
                                    t.emit("xml", i), r = o;
                                } else o += 1, r = pos;
                            }
                        }), t.on("end", function() {
                            console.log("end");
                        }), t;
                    }, n.transformStream = function(t) {
                        const e = r(114);
                        "string" == typeof t && (t = t.length + 2);
                        var i = t || 0, o = "";
                        return e({
                            readableObjectMode: !0
                        }, function(t, e, r) {
                            o += t;
                            for(var a = 0;;){
                                if (!(i = o.indexOf("<", i) + 1)) return i = a, r();
                                if ("/" !== o[i + 1]) {
                                    var s = n(o, {
                                        pos: i - 1,
                                        parseNode: !0,
                                        setPos: !0
                                    });
                                    if ((i = s.pos) > o.length - 1 || i < a) return o = o.slice(a), i = 0, a = 0, r();
                                    this.push(s), a = i;
                                } else i += 1, a = pos;
                            }
                            r();
                        });
                    }, t.exports = n, n.xml = n;
                },
                function(t, e, r) {
                    "use strict";
                    var n = r(123), i = r(29), o = r(128), a = r(129), s = r(130), u = r(131), l = r(132), c = Object.prototype.toString;
                    function f(t) {
                        if (!(this instanceof f)) return new f(t);
                        this.options = i.assign({
                            chunkSize: 16384,
                            windowBits: 0,
                            to: ""
                        }, t || {});
                        var e = this.options;
                        e.raw && e.windowBits >= 0 && e.windowBits < 16 && (e.windowBits = -e.windowBits, 0 === e.windowBits && (e.windowBits = -15)), !(e.windowBits >= 0 && e.windowBits < 16) || t && t.windowBits || (e.windowBits += 32), e.windowBits > 15 && e.windowBits < 48 && 0 == (15 & e.windowBits) && (e.windowBits |= 15), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new u, this.strm.avail_out = 0;
                        var r = n.inflateInit2(this.strm, e.windowBits);
                        if (r !== a.Z_OK) throw new Error(s[r]);
                        if (this.header = new l, n.inflateGetHeader(this.strm, this.header), e.dictionary && ("string" == typeof e.dictionary ? e.dictionary = o.string2buf(e.dictionary) : "[object ArrayBuffer]" === c.call(e.dictionary) && (e.dictionary = new Uint8Array(e.dictionary)), e.raw && (r = n.inflateSetDictionary(this.strm, e.dictionary)) !== a.Z_OK)) throw new Error(s[r]);
                    }
                    function h(t, e) {
                        var r = new f(e);
                        if (r.push(t, !0), r.err) throw r.msg || s[r.err];
                        return r.result;
                    }
                    f.prototype.push = function(t, e) {
                        var r, s, u, l, f, h = this.strm, p = this.options.chunkSize, d = this.options.dictionary, m = !1;
                        if (this.ended) return !1;
                        s = e === ~~e ? e : !0 === e ? a.Z_FINISH : a.Z_NO_FLUSH, "string" == typeof t ? h.input = o.binstring2buf(t) : "[object ArrayBuffer]" === c.call(t) ? h.input = new Uint8Array(t) : h.input = t, h.next_in = 0, h.avail_in = h.input.length;
                        do {
                            if (0 === h.avail_out && (h.output = new i.Buf8(p), h.next_out = 0, h.avail_out = p), (r = n.inflate(h, a.Z_NO_FLUSH)) === a.Z_NEED_DICT && d && (r = n.inflateSetDictionary(this.strm, d)), r === a.Z_BUF_ERROR && !0 === m && (r = a.Z_OK, m = !1), r !== a.Z_STREAM_END && r !== a.Z_OK) return this.onEnd(r), this.ended = !0, !1;
                            h.next_out && (0 !== h.avail_out && r !== a.Z_STREAM_END && (0 !== h.avail_in || s !== a.Z_FINISH && s !== a.Z_SYNC_FLUSH) || ("string" === this.options.to ? (u = o.utf8border(h.output, h.next_out), l = h.next_out - u, f = o.buf2string(h.output, u), h.next_out = l, h.avail_out = p - l, l && i.arraySet(h.output, h.output, u, l, 0), this.onData(f)) : this.onData(i.shrinkBuf(h.output, h.next_out)))), 0 === h.avail_in && 0 === h.avail_out && (m = !0);
                        }while ((h.avail_in > 0 || 0 === h.avail_out) && r !== a.Z_STREAM_END);
                        return r === a.Z_STREAM_END && (s = a.Z_FINISH), s === a.Z_FINISH ? (r = n.inflateEnd(this.strm), this.onEnd(r), this.ended = !0, r === a.Z_OK) : s !== a.Z_SYNC_FLUSH || (this.onEnd(a.Z_OK), h.avail_out = 0, !0);
                    }, f.prototype.onData = function(t) {
                        this.chunks.push(t);
                    }, f.prototype.onEnd = function(t) {
                        t === a.Z_OK && ("string" === this.options.to ? this.result = this.chunks.join("") : this.result = i.flattenChunks(this.chunks)), this.chunks = [], this.err = t, this.msg = this.strm.msg;
                    }, e.Inflate = f, e.inflate = h, e.inflateRaw = function(t, e) {
                        return (e = e || {}).raw = !0, h(t, e);
                    }, e.ungzip = h;
                },
                function(t, e, r) {
                    "use strict";
                    var n = r(26);
                    class i extends n.a {
                        constructor(){
                            super((t)=>(this._observers.add(t), ()=>this._observers.delete(t))), this._observers = new Set;
                        }
                        next(t) {
                            for (const e of this._observers)e.next(t);
                        }
                        error(t) {
                            for (const e of this._observers)e.error(t);
                        }
                        complete() {
                            for (const t of this._observers)t.complete();
                        }
                    }
                    e.a = i;
                },
                function(t, e, r) {
                    "use strict";
                    r.d(e, "a", function() {
                        return i;
                    });
                    const n = ()=>{};
                    function i() {
                        let t, e = !1, r = n;
                        return [
                            new Promise((n)=>{
                                e ? n(t) : r = n;
                            }),
                            (n)=>{
                                e = !0, t = n, r(t);
                            }
                        ];
                    }
                },
                function(t, e, r) {
                    "use strict";
                    r.d(e, "a", function() {
                        return i;
                    });
                    var n = r(2);
                    function i(t) {
                        return t && "object" == typeof t && t[n.d];
                    }
                },
                function(t, e, r) {
                    var n = r(40), i = r(39), o = t.exports;
                    for(var a in n)n.hasOwnProperty(a) && (o[a] = n[a]);
                    function s(t) {
                        if ("string" == typeof t && (t = i.parse(t)), t.protocol || (t.protocol = "https:"), "https:" !== t.protocol) throw new Error('Protocol "' + t.protocol + '" not supported. Expected "https:"');
                        return t;
                    }
                    o.request = function(t, e) {
                        return t = s(t), n.request.call(this, t, e);
                    }, o.get = function(t, e) {
                        return t = s(t), n.get.call(this, t, e);
                    };
                },
                function(t, e, r) {
                    "use strict";
                    (function(e) {
                        var n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                            return typeof t;
                        } : function(t) {
                            return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                        }, i = function() {
                            function t(t, e) {
                                for(var r = 0; r < e.length; r++){
                                    var n = e[r];
                                    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
                                }
                            }
                            return function(e, r, n) {
                                return r && t(e.prototype, r), n && t(e, n), e;
                            };
                        }(), o = f(r(110)), a = f(r(111)), s = f(r(113)), u = r(99), l = r(100), c = f(r(197));
                        function f(t) {
                            return t && t.__esModule ? t : {
                                default: t
                            };
                        }
                        function h(t, e) {
                            var r = e.left, n = e.top, i = e.right, o = e.bottom, a = e.width, s = e.height, l = e.resampleMethod;
                            return t.readRasters({
                                window: [
                                    r,
                                    n,
                                    i,
                                    o
                                ],
                                width: a,
                                height: s,
                                resampleMethod: l || "bilinear"
                            }).then(function(t) {
                                return t.map(function(t) {
                                    return (0, u.unflatten)(t, {
                                        height: s,
                                        width: a
                                    });
                                });
                            });
                        }
                        var p = function() {
                            function t(r, i, o) {
                                !function(t, e) {
                                    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                                }(this, t), o && console.log("starting GeoRaster.constructor with", r, i), this._web_worker_is_available = "undefined" != typeof window && void 0 !== window.Worker, this._blob_is_available = "undefined" != typeof Blob, this._url_is_available = "undefined" != typeof URL, "object" === (void 0 === r ? "undefined" : n(r)) && r.constructor && "Buffer" === r.constructor.name && !1 === e.isBuffer(r) && (r = new e(r)), "string" == typeof r ? (o && console.log("data is a url"), this._data = r, this._url = r, this.rasterType = "geotiff", this.sourceType = "url") : "undefined" != typeof Blob && r instanceof Blob ? (this._data = r, this.rasterType = "geotiff", this.sourceType = "Blob") : void 0 !== e && e.isBuffer(r) ? (o && console.log("data is a buffer"), this._data = r.buffer.slice(r.byteOffset, r.byteOffset + r.byteLength), this.rasterType = "geotiff", this.sourceType = "Buffer") : r instanceof ArrayBuffer ? (this._data = r, this.rasterType = "geotiff", this.sourceType = "ArrayBuffer", this._metadata = i) : Array.isArray(r) && i && (this._data = r, this.rasterType = "object", this._metadata = i), o && console.log("this after construction:", this);
                            }
                            return i(t, [
                                {
                                    key: "preinitialize",
                                    value: function(t) {
                                        var e = this;
                                        if (t && console.log("starting preinitialize"), this._url) {
                                            var r = this._url + ".ovr";
                                            return (function(t) {
                                                try {
                                                    return (0, o.default)(t, {
                                                        method: "HEAD"
                                                    }).then(function(t) {
                                                        return 200 === t.status;
                                                    }).catch(function(t) {
                                                        return !1;
                                                    });
                                                } catch (t) {
                                                    return Promise.resolve(!1);
                                                }
                                            })(r).then(function(n) {
                                                return t && console.log("overview exists:", n), n ? (0, l.fromUrls)(e._url, [
                                                    r
                                                ], {
                                                    cache: !0,
                                                    forceXHR: !1
                                                }) : (0, l.fromUrl)(e._url, {
                                                    cache: !0,
                                                    forceXHR: !1
                                                });
                                            });
                                        }
                                        return Promise.resolve();
                                    }
                                },
                                {
                                    key: "initialize",
                                    value: function(t) {
                                        var e = this;
                                        return this.preinitialize(t).then(function(r) {
                                            return new Promise(function(n, i) {
                                                if (t && console.log("starting GeoRaster.initialize"), t && console.log("this", e), "object" === e.rasterType || "geotiff" === e.rasterType || "tiff" === e.rasterType) {
                                                    if (e._web_worker_is_available) {
                                                        var o = new a.default;
                                                        o.onmessage = function(i) {
                                                            t && console.log("main thread received message:", i);
                                                            var o = i.data;
                                                            for(var a in o)e[a] = o[a];
                                                            e._url && (e._geotiff = r, e.getValues = function(t) {
                                                                return h(this._geotiff, t);
                                                            }), e.toCanvas = function(t) {
                                                                return (0, c.default)(this, t);
                                                            }, n(e);
                                                        }, t && console.log("about to postMessage"), e._data instanceof ArrayBuffer ? o.postMessage({
                                                            data: e._data,
                                                            rasterType: e.rasterType,
                                                            sourceType: e.sourceType,
                                                            metadata: e._metadata
                                                        }, [
                                                            e._data
                                                        ]) : o.postMessage({
                                                            data: e._data,
                                                            rasterType: e.rasterType,
                                                            sourceType: e.sourceType,
                                                            metadata: e._metadata
                                                        });
                                                    } else t && console.log("web worker is not available"), (0, s.default)({
                                                        data: e._data,
                                                        rasterType: e.rasterType,
                                                        sourceType: e.sourceType,
                                                        metadata: e._metadata
                                                    }, t).then(function(i) {
                                                        t && console.log("result:", i), e._url && (i._geotiff = r, i.getValues = function(t) {
                                                            return h(this._geotiff, t);
                                                        }), i.toCanvas = function(t) {
                                                            return (0, c.default)(this, t);
                                                        }, n(i);
                                                    }).catch(i);
                                                } else i("couldn't find a way to parse");
                                            });
                                        });
                                    }
                                }
                            ]), t;
                        }(), d = function(t, e, r) {
                            if (r && console.log("starting parseGeoraster with ", t, e), void 0 === t) throw Error("[Georaster.parseGeoraster] Error. You passed in undefined to parseGeoraster. We can't make a raster out of nothing!");
                            return new p(t, e, r).initialize(r);
                        };
                        void 0 !== t.exports && (t.exports = d), "undefined" != typeof window ? window.parseGeoraster = d : "undefined" != typeof self && (self.parseGeoraster = d);
                    }).call(this, r(7).Buffer);
                },
                function(t, e, r) {
                    "use strict";
                    e.byteLength = function(t) {
                        var e = l(t), r = e[0], n = e[1];
                        return 3 * (r + n) / 4 - n;
                    }, e.toByteArray = function(t) {
                        var e, r, n = l(t), a = n[0], s = n[1], u = new o(function(t, e, r) {
                            return 3 * (e + r) / 4 - r;
                        }(0, a, s)), c = 0, f = s > 0 ? a - 4 : a;
                        for(r = 0; r < f; r += 4)e = i[t.charCodeAt(r)] << 18 | i[t.charCodeAt(r + 1)] << 12 | i[t.charCodeAt(r + 2)] << 6 | i[t.charCodeAt(r + 3)], u[c++] = e >> 16 & 255, u[c++] = e >> 8 & 255, u[c++] = 255 & e;
                        return 2 === s && (e = i[t.charCodeAt(r)] << 2 | i[t.charCodeAt(r + 1)] >> 4, u[c++] = 255 & e), 1 === s && (e = i[t.charCodeAt(r)] << 10 | i[t.charCodeAt(r + 1)] << 4 | i[t.charCodeAt(r + 2)] >> 2, u[c++] = e >> 8 & 255, u[c++] = 255 & e), u;
                    }, e.fromByteArray = function(t) {
                        for(var e, r = t.length, i = r % 3, o = [], a = 0, s = r - i; a < s; a += 16383)o.push(c(t, a, a + 16383 > s ? s : a + 16383));
                        return 1 === i ? (e = t[r - 1], o.push(n[e >> 2] + n[e << 4 & 63] + "==")) : 2 === i && (e = (t[r - 2] << 8) + t[r - 1], o.push(n[e >> 10] + n[e >> 4 & 63] + n[e << 2 & 63] + "=")), o.join("");
                    };
                    for(var n = [], i = [], o = "undefined" != typeof Uint8Array ? Uint8Array : Array, a = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", s = 0, u = a.length; s < u; ++s)n[s] = a[s], i[a.charCodeAt(s)] = s;
                    function l(t) {
                        var e = t.length;
                        if (e % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
                        var r = t.indexOf("=");
                        return -1 === r && (r = e), [
                            r,
                            r === e ? 0 : 4 - r % 4
                        ];
                    }
                    function c(t, e, r) {
                        for(var i, o, a = [], s = e; s < r; s += 3)i = (t[s] << 16 & 16711680) + (t[s + 1] << 8 & 65280) + (255 & t[s + 2]), a.push(n[(o = i) >> 18 & 63] + n[o >> 12 & 63] + n[o >> 6 & 63] + n[63 & o]);
                        return a.join("");
                    }
                    i["-".charCodeAt(0)] = 62, i["_".charCodeAt(0)] = 63;
                },
                function(t, e) {
                    /*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ e.read = function(t, e, r, n, i) {
                        var o, a, s = 8 * i - n - 1, u = (1 << s) - 1, l = u >> 1, c = -7, f = r ? i - 1 : 0, h = r ? -1 : 1, p = t[e + f];
                        for(f += h, o = p & (1 << -c) - 1, p >>= -c, c += s; c > 0; o = 256 * o + t[e + f], f += h, c -= 8);
                        for(a = o & (1 << -c) - 1, o >>= -c, c += n; c > 0; a = 256 * a + t[e + f], f += h, c -= 8);
                        if (0 === o) o = 1 - l;
                        else {
                            if (o === u) return a ? NaN : 1 / 0 * (p ? -1 : 1);
                            a += Math.pow(2, n), o -= l;
                        }
                        return (p ? -1 : 1) * a * Math.pow(2, o - n);
                    }, e.write = function(t, e, r, n, i, o) {
                        var a, s, u, l = 8 * o - i - 1, c = (1 << l) - 1, f = c >> 1, h = 23 === i ? Math.pow(2, -24) - Math.pow(2, -77) : 0, p = n ? 0 : o - 1, d = n ? 1 : -1, m = e < 0 || 0 === e && 1 / e < 0 ? 1 : 0;
                        for(e = Math.abs(e), isNaN(e) || e === 1 / 0 ? (s = isNaN(e) ? 1 : 0, a = c) : (a = Math.floor(Math.log(e) / Math.LN2), e * (u = Math.pow(2, -a)) < 1 && (a--, u *= 2), (e += a + f >= 1 ? h / u : h * Math.pow(2, 1 - f)) * u >= 2 && (a++, u /= 2), a + f >= c ? (s = 0, a = c) : a + f >= 1 ? (s = (e * u - 1) * Math.pow(2, i), a += f) : (s = e * Math.pow(2, f - 1) * Math.pow(2, i), a = 0)); i >= 8; t[r + p] = 255 & s, p += d, s /= 256, i -= 8);
                        for(a = a << i | s, l += i; l > 0; t[r + p] = 255 & a, p += d, a /= 256, l -= 8);
                        t[r + p - d] |= 128 * m;
                    };
                },
                function(t, e) {
                    var r = "undefined" != typeof self ? self : this, n = function() {
                        function t() {
                            this.fetch = !1, this.DOMException = r.DOMException;
                        }
                        return t.prototype = r, new t;
                    }();
                    !function(t) {
                        !function(e) {
                            var r = "URLSearchParams" in t, n = "Symbol" in t && "iterator" in Symbol, i = "FileReader" in t && "Blob" in t && function() {
                                try {
                                    return new Blob, !0;
                                } catch (t) {
                                    return !1;
                                }
                            }(), o = "FormData" in t, a = "ArrayBuffer" in t;
                            if (a) var s = [
                                "[object Int8Array]",
                                "[object Uint8Array]",
                                "[object Uint8ClampedArray]",
                                "[object Int16Array]",
                                "[object Uint16Array]",
                                "[object Int32Array]",
                                "[object Uint32Array]",
                                "[object Float32Array]",
                                "[object Float64Array]"
                            ], u = ArrayBuffer.isView || function(t) {
                                return t && s.indexOf(Object.prototype.toString.call(t)) > -1;
                            };
                            function l(t) {
                                if ("string" != typeof t && (t = String(t)), /[^a-z0-9\-#$%&'*+.^_`|~]/i.test(t)) throw new TypeError("Invalid character in header field name");
                                return t.toLowerCase();
                            }
                            function c(t) {
                                return "string" != typeof t && (t = String(t)), t;
                            }
                            function f(t) {
                                var e = {
                                    next: function() {
                                        var e = t.shift();
                                        return {
                                            done: void 0 === e,
                                            value: e
                                        };
                                    }
                                };
                                return n && (e[Symbol.iterator] = function() {
                                    return e;
                                }), e;
                            }
                            function h(t) {
                                this.map = {}, t instanceof h ? t.forEach(function(t, e) {
                                    this.append(e, t);
                                }, this) : Array.isArray(t) ? t.forEach(function(t) {
                                    this.append(t[0], t[1]);
                                }, this) : t && Object.getOwnPropertyNames(t).forEach(function(e) {
                                    this.append(e, t[e]);
                                }, this);
                            }
                            function p(t) {
                                if (t.bodyUsed) return Promise.reject(new TypeError("Already read"));
                                t.bodyUsed = !0;
                            }
                            function d(t) {
                                return new Promise(function(e, r) {
                                    t.onload = function() {
                                        e(t.result);
                                    }, t.onerror = function() {
                                        r(t.error);
                                    };
                                });
                            }
                            function m(t) {
                                var e = new FileReader, r = d(e);
                                return e.readAsArrayBuffer(t), r;
                            }
                            function y(t) {
                                if (t.slice) return t.slice(0);
                                var e = new Uint8Array(t.byteLength);
                                return e.set(new Uint8Array(t)), e.buffer;
                            }
                            function g() {
                                return this.bodyUsed = !1, this._initBody = function(t) {
                                    var e;
                                    this._bodyInit = t, t ? "string" == typeof t ? this._bodyText = t : i && Blob.prototype.isPrototypeOf(t) ? this._bodyBlob = t : o && FormData.prototype.isPrototypeOf(t) ? this._bodyFormData = t : r && URLSearchParams.prototype.isPrototypeOf(t) ? this._bodyText = t.toString() : a && i && (e = t) && DataView.prototype.isPrototypeOf(e) ? (this._bodyArrayBuffer = y(t.buffer), this._bodyInit = new Blob([
                                        this._bodyArrayBuffer
                                    ])) : a && (ArrayBuffer.prototype.isPrototypeOf(t) || u(t)) ? this._bodyArrayBuffer = y(t) : this._bodyText = t = Object.prototype.toString.call(t) : this._bodyText = "", this.headers.get("content-type") || ("string" == typeof t ? this.headers.set("content-type", "text/plain;charset=UTF-8") : this._bodyBlob && this._bodyBlob.type ? this.headers.set("content-type", this._bodyBlob.type) : r && URLSearchParams.prototype.isPrototypeOf(t) && this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8"));
                                }, i && (this.blob = function() {
                                    var t = p(this);
                                    if (t) return t;
                                    if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
                                    if (this._bodyArrayBuffer) return Promise.resolve(new Blob([
                                        this._bodyArrayBuffer
                                    ]));
                                    if (this._bodyFormData) throw new Error("could not read FormData body as blob");
                                    return Promise.resolve(new Blob([
                                        this._bodyText
                                    ]));
                                }, this.arrayBuffer = function() {
                                    return this._bodyArrayBuffer ? p(this) || Promise.resolve(this._bodyArrayBuffer) : this.blob().then(m);
                                }), this.text = function() {
                                    var t, e, r, n = p(this);
                                    if (n) return n;
                                    if (this._bodyBlob) return t = this._bodyBlob, r = d(e = new FileReader), e.readAsText(t), r;
                                    if (this._bodyArrayBuffer) return Promise.resolve(function(t) {
                                        for(var e = new Uint8Array(t), r = new Array(e.length), n = 0; n < e.length; n++)r[n] = String.fromCharCode(e[n]);
                                        return r.join("");
                                    }(this._bodyArrayBuffer));
                                    if (this._bodyFormData) throw new Error("could not read FormData body as text");
                                    return Promise.resolve(this._bodyText);
                                }, o && (this.formData = function() {
                                    return this.text().then(x);
                                }), this.json = function() {
                                    return this.text().then(JSON.parse);
                                }, this;
                            }
                            h.prototype.append = function(t, e) {
                                t = l(t), e = c(e);
                                var r = this.map[t];
                                this.map[t] = r ? r + ", " + e : e;
                            }, h.prototype.delete = function(t) {
                                delete this.map[l(t)];
                            }, h.prototype.get = function(t) {
                                return t = l(t), this.has(t) ? this.map[t] : null;
                            }, h.prototype.has = function(t) {
                                return this.map.hasOwnProperty(l(t));
                            }, h.prototype.set = function(t, e) {
                                this.map[l(t)] = c(e);
                            }, h.prototype.forEach = function(t, e) {
                                for(var r in this.map)this.map.hasOwnProperty(r) && t.call(e, this.map[r], r, this);
                            }, h.prototype.keys = function() {
                                var t = [];
                                return this.forEach(function(e, r) {
                                    t.push(r);
                                }), f(t);
                            }, h.prototype.values = function() {
                                var t = [];
                                return this.forEach(function(e) {
                                    t.push(e);
                                }), f(t);
                            }, h.prototype.entries = function() {
                                var t = [];
                                return this.forEach(function(e, r) {
                                    t.push([
                                        r,
                                        e
                                    ]);
                                }), f(t);
                            }, n && (h.prototype[Symbol.iterator] = h.prototype.entries);
                            var v = [
                                "DELETE",
                                "GET",
                                "HEAD",
                                "OPTIONS",
                                "POST",
                                "PUT"
                            ];
                            function b(t, e) {
                                var r, n, i = (e = e || {}).body;
                                if (t instanceof b) {
                                    if (t.bodyUsed) throw new TypeError("Already read");
                                    this.url = t.url, this.credentials = t.credentials, e.headers || (this.headers = new h(t.headers)), this.method = t.method, this.mode = t.mode, this.signal = t.signal, i || null == t._bodyInit || (i = t._bodyInit, t.bodyUsed = !0);
                                } else this.url = String(t);
                                if (this.credentials = e.credentials || this.credentials || "same-origin", !e.headers && this.headers || (this.headers = new h(e.headers)), this.method = (n = (r = e.method || this.method || "GET").toUpperCase(), v.indexOf(n) > -1 ? n : r), this.mode = e.mode || this.mode || null, this.signal = e.signal || this.signal, this.referrer = null, ("GET" === this.method || "HEAD" === this.method) && i) throw new TypeError("Body not allowed for GET or HEAD requests");
                                this._initBody(i);
                            }
                            function x(t) {
                                var e = new FormData;
                                return t.trim().split("&").forEach(function(t) {
                                    if (t) {
                                        var r = t.split("="), n = r.shift().replace(/\+/g, " "), i = r.join("=").replace(/\+/g, " ");
                                        e.append(decodeURIComponent(n), decodeURIComponent(i));
                                    }
                                }), e;
                            }
                            function w(t, e) {
                                e || (e = {}), this.type = "default", this.status = void 0 === e.status ? 200 : e.status, this.ok = this.status >= 200 && this.status < 300, this.statusText = "statusText" in e ? e.statusText : "OK", this.headers = new h(e.headers), this.url = e.url || "", this._initBody(t);
                            }
                            b.prototype.clone = function() {
                                return new b(this, {
                                    body: this._bodyInit
                                });
                            }, g.call(b.prototype), g.call(w.prototype), w.prototype.clone = function() {
                                return new w(this._bodyInit, {
                                    status: this.status,
                                    statusText: this.statusText,
                                    headers: new h(this.headers),
                                    url: this.url
                                });
                            }, w.error = function() {
                                var t = new w(null, {
                                    status: 0,
                                    statusText: ""
                                });
                                return t.type = "error", t;
                            };
                            var _ = [
                                301,
                                302,
                                303,
                                307,
                                308
                            ];
                            w.redirect = function(t, e) {
                                if (-1 === _.indexOf(e)) throw new RangeError("Invalid status code");
                                return new w(null, {
                                    status: e,
                                    headers: {
                                        location: t
                                    }
                                });
                            }, e.DOMException = t.DOMException;
                            try {
                                new e.DOMException;
                            } catch (t) {
                                e.DOMException = function(t, e) {
                                    this.message = t, this.name = e;
                                    var r = Error(t);
                                    this.stack = r.stack;
                                }, e.DOMException.prototype = Object.create(Error.prototype), e.DOMException.prototype.constructor = e.DOMException;
                            }
                            function A(t, r) {
                                return new Promise(function(n, o) {
                                    var a = new b(t, r);
                                    if (a.signal && a.signal.aborted) return o(new e.DOMException("Aborted", "AbortError"));
                                    var s = new XMLHttpRequest;
                                    function u() {
                                        s.abort();
                                    }
                                    s.onload = function() {
                                        var t, e, r = {
                                            status: s.status,
                                            statusText: s.statusText,
                                            headers: (t = s.getAllResponseHeaders() || "", e = new h, t.replace(/\r?\n[\t ]+/g, " ").split(/\r?\n/).forEach(function(t) {
                                                var r = t.split(":"), n = r.shift().trim();
                                                if (n) {
                                                    var i = r.join(":").trim();
                                                    e.append(n, i);
                                                }
                                            }), e)
                                        };
                                        r.url = "responseURL" in s ? s.responseURL : r.headers.get("X-Request-URL");
                                        var i = "response" in s ? s.response : s.responseText;
                                        n(new w(i, r));
                                    }, s.onerror = function() {
                                        o(new TypeError("Network request failed"));
                                    }, s.ontimeout = function() {
                                        o(new TypeError("Network request failed"));
                                    }, s.onabort = function() {
                                        o(new e.DOMException("Aborted", "AbortError"));
                                    }, s.open(a.method, a.url, !0), "include" === a.credentials ? s.withCredentials = !0 : "omit" === a.credentials && (s.withCredentials = !1), "responseType" in s && i && (s.responseType = "blob"), a.headers.forEach(function(t, e) {
                                        s.setRequestHeader(e, t);
                                    }), a.signal && (a.signal.addEventListener("abort", u), s.onreadystatechange = function() {
                                        4 === s.readyState && a.signal.removeEventListener("abort", u);
                                    }), s.send(void 0 === a._bodyInit ? null : a._bodyInit);
                                });
                            }
                            A.polyfill = !0, t.fetch || (t.fetch = A, t.Headers = h, t.Request = b, t.Response = w), e.Headers = h, e.Request = b, e.Response = w, e.fetch = A, Object.defineProperty(e, "__esModule", {
                                value: !0
                            });
                        }({});
                    }(n), n.fetch.ponyfill = !0, delete n.fetch.polyfill;
                    var i = n;
                    (e = i.fetch).default = i.fetch, e.fetch = i.fetch, e.Headers = i.Headers, e.Request = i.Request, e.Response = i.Response, t.exports = e;
                },
                function(t, e, r) {
                    "use strict";
                    t.exports = function() {
                        return r(112)('!function(t){var e={};function r(n){if(e[n])return e[n].exports;var i=e[n]={i:n,l:!1,exports:{}};return t[n].call(i.exports,i,i.exports,r),i.l=!0,i.exports}r.m=t,r.c=e,r.d=function(t,e,n){r.o(t,e)||Object.defineProperty(t,e,{enumerable:!0,get:n})},r.r=function(t){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})},r.t=function(t,e){if(1&e&&(t=r(t)),8&e)return t;if(4&e&&"object"==typeof t&&t&&t.__esModule)return t;var n=Object.create(null);if(r.r(n),Object.defineProperty(n,"default",{enumerable:!0,value:t}),2&e&&"string"!=typeof t)for(var i in t)r.d(n,i,function(e){return t[e]}.bind(null,i));return n},r.n=function(t){var e=t&&t.__esModule?function(){return t.default}:function(){return t};return r.d(e,"a",e),e},r.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},r.p="",r(r.s=106)}([function(t,e,r){"use strict";const n=r(73);t.exports=function(t){return"+"===t[0]&&(t=t.substring(1)),(t=(t=n(t)).replace(/^0+(?=\\d)/,"")).includes(".")&&(t=t.replace(/\\.?0+$/,"")),""===t&&(t="0"),"-0"===t&&(t="0"),t}},function(t,e,r){"use strict";const n=r(4),i=r(0),o=r(15),s=r(32);function a(t,e,r){t=i(t),e=i(e);const a="-"!==t[0],u="-"!==e[0],c=o(t),l=o(e);if(c||l)return a==u?"Infinity":"-Infinity";if("0"===e)throw new Error("[preciso] division by zero");if(""===t||"0"===t)return"0";const f=a!==u?"-":"";return a||(t=n(t)),u||(e=n(e)),f+s(t,e,r)}t.exports=a,t.exports.default=a},function(t,e,r){"use strict";r.d(e,"a",(function(){return n})),r.d(e,"b",(function(){return i})),r.d(e,"c",(function(){return o})),r.d(e,"d",(function(){return s})),r.d(e,"e",(function(){return a}));const n=Symbol("thread.errors"),i=Symbol("thread.events"),o=Symbol("thread.terminate"),s=Symbol("thread.transferable"),a=Symbol("thread.worker")},function(t,e){var r;r=function(){return this}();try{r=r||new Function("return this")()}catch(t){"object"==typeof window&&(r=window)}t.exports=r},function(t,e,r){"use strict";const n=r(0);function i(t){return"-"===(t=n(t))[0]?t.substring(1):t}t.exports=i,t.exports.default=i},function(t,e,r){"use strict";function n(t,e){const r=t.length,n=e.length,i=t.indexOf("."),o=e.indexOf("."),s=-1===i?r:i,a=-1===o?n:o,u=s-a;let c=u<0?-1*u:0,l=u<=0?0:u,f=Math.max(s,a)+1+Math.max(r-s,n-a)-1,h=0;for(;h<f;){const r=h-c,n=r===s?".":t[r]||"0",i=h-l,o=i===a?".":e[i]||"0";if(n!==o){if(n>o)return">";if(n<o)return"<"}h++}return"="}t.exports=n,t.exports.default=n},function(t,e,r){"use strict";const n=r(5),i=r(0),o=r(8),s=r(31),a=r(15);function u(t,e,{infinity_minus_infinity:r="NaN"}={}){t=i(t),e=i(e);const u="-"!==t[0],c="-"!==e[0],l=!u,f=!c,h=a(t),d=a(e);if(h&&d)return u&&c?"Infinity":l&f?"-Infinity":r;if(h)return u?"Infinity":"-Infinity";if(d)return c?"Infinity":"-Infinity";if(u&&c)return o(t,e);if(l&&f)return"-"+o(t.substring(1),e.substring(1));if(l&&c)switch(t=t.substring(1),n(t,e)){case"=":return"0";case"<":return s(e,t);case">":return"-"+s(t,e)}else if(u&&!c)switch(e=e.substring(1),n(t,e)){case"=":return"0";case"<":return"-"+s(e,t);case">":return s(t,e)}}t.exports=u,t.exports.default=u},function(t,e){var r,n,i=t.exports={};function o(){throw new Error("setTimeout has not been defined")}function s(){throw new Error("clearTimeout has not been defined")}function a(t){if(r===setTimeout)return setTimeout(t,0);if((r===o||!r)&&setTimeout)return r=setTimeout,setTimeout(t,0);try{return r(t,0)}catch(e){try{return r.call(null,t,0)}catch(e){return r.call(this,t,0)}}}!function(){try{r="function"==typeof setTimeout?setTimeout:o}catch(t){r=o}try{n="function"==typeof clearTimeout?clearTimeout:s}catch(t){n=s}}();var u,c=[],l=!1,f=-1;function h(){l&&u&&(l=!1,u.length?c=u.concat(c):f=-1,c.length&&d())}function d(){if(!l){var t=a(h);l=!0;for(var e=c.length;e;){for(u=c,c=[];++f<e;)u&&u[f].run();f=-1,e=c.length}u=null,l=!1,function(t){if(n===clearTimeout)return clearTimeout(t);if((n===s||!n)&&clearTimeout)return n=clearTimeout,clearTimeout(t);try{n(t)}catch(e){try{return n.call(null,t)}catch(e){return n.call(this,t)}}}(t)}}function p(t,e){this.fun=t,this.array=e}function y(){}i.nextTick=function(t){var e=new Array(arguments.length-1);if(arguments.length>1)for(var r=1;r<arguments.length;r++)e[r-1]=arguments[r];c.push(new p(t,e)),1!==c.length||l||a(d)},p.prototype.run=function(){this.fun.apply(null,this.array)},i.title="browser",i.browser=!0,i.env={},i.argv=[],i.version="",i.versions={},i.on=y,i.addListener=y,i.once=y,i.off=y,i.removeListener=y,i.removeAllListeners=y,i.emit=y,i.prependListener=y,i.prependOnceListener=y,i.listeners=function(t){return[]},i.binding=function(t){throw new Error("process.binding is not supported")},i.cwd=function(){return"/"},i.chdir=function(t){throw new Error("process.chdir is not supported")},i.umask=function(){return 0}},function(t,e,r){"use strict";const{MAX_SAFE_INTEGER_LENGTH:n}=r(30);function i(t,e){const r=t.length,i=e.length,o=t.indexOf("."),s=e.indexOf("."),a=-1===o?r:o,u=-1===s?i:s;if(-1===o&&-1===s&&r<n&&i<n)return(Number(t)+Number(e)).toFixed();const c=a-u;let l=Math.max(a,u),f=Math.max(r-a-1,i-u-1),h=c<0?-1*c:0,d=c<=0?0:c,p=l+1+f-1,y="",g=0,m=p;if(f>0){for(;m>p-f;){const r=t[m-h]||"0",n=e[m-d]||"0";let i=Number(r)+Number(n)+g;i>=10?(i-=10,g=1):g=0,""===y&&0===i||(y=i+y),m--}y&&(y="."+y),m--}if(l>0)for(;m>=0;){const r=t[m-h]||"0",n=e[m-d]||"0";let i=Number(r)+Number(n)+g;i>=10?(i-=10,g=1):g=0,y=i+y,m--}return 1===g&&(y=g+y),"."===y[0]&&(y="0"+y),y}t.exports=i,t.exports.default=i},function(t,e,r){"use strict";(function(t){\n/*!\n * The buffer module from node.js, for the browser.\n *\n * @author   Feross Aboukhadijeh <http://feross.org>\n * @license  MIT\n */\nvar n=r(108),i=r(109),o=r(61);function s(){return u.TYPED_ARRAY_SUPPORT?2147483647:1073741823}function a(t,e){if(s()<e)throw new RangeError("Invalid typed array length");return u.TYPED_ARRAY_SUPPORT?(t=new Uint8Array(e)).__proto__=u.prototype:(null===t&&(t=new u(e)),t.length=e),t}function u(t,e,r){if(!(u.TYPED_ARRAY_SUPPORT||this instanceof u))return new u(t,e,r);if("number"==typeof t){if("string"==typeof e)throw new Error("If encoding is specified then the first argument must be a string");return f(this,t)}return c(this,t,e,r)}function c(t,e,r,n){if("number"==typeof e)throw new TypeError(\'"value" argument must not be a number\');return"undefined"!=typeof ArrayBuffer&&e instanceof ArrayBuffer?function(t,e,r,n){if(e.byteLength,r<0||e.byteLength<r)throw new RangeError("\'offset\' is out of bounds");if(e.byteLength<r+(n||0))throw new RangeError("\'length\' is out of bounds");e=void 0===r&&void 0===n?new Uint8Array(e):void 0===n?new Uint8Array(e,r):new Uint8Array(e,r,n);u.TYPED_ARRAY_SUPPORT?(t=e).__proto__=u.prototype:t=h(t,e);return t}(t,e,r,n):"string"==typeof e?function(t,e,r){"string"==typeof r&&""!==r||(r="utf8");if(!u.isEncoding(r))throw new TypeError(\'"encoding" must be a valid string encoding\');var n=0|p(e,r),i=(t=a(t,n)).write(e,r);i!==n&&(t=t.slice(0,i));return t}(t,e,r):function(t,e){if(u.isBuffer(e)){var r=0|d(e.length);return 0===(t=a(t,r)).length||e.copy(t,0,0,r),t}if(e){if("undefined"!=typeof ArrayBuffer&&e.buffer instanceof ArrayBuffer||"length"in e)return"number"!=typeof e.length||(n=e.length)!=n?a(t,0):h(t,e);if("Buffer"===e.type&&o(e.data))return h(t,e.data)}var n;throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.")}(t,e)}function l(t){if("number"!=typeof t)throw new TypeError(\'"size" argument must be a number\');if(t<0)throw new RangeError(\'"size" argument must not be negative\')}function f(t,e){if(l(e),t=a(t,e<0?0:0|d(e)),!u.TYPED_ARRAY_SUPPORT)for(var r=0;r<e;++r)t[r]=0;return t}function h(t,e){var r=e.length<0?0:0|d(e.length);t=a(t,r);for(var n=0;n<r;n+=1)t[n]=255&e[n];return t}function d(t){if(t>=s())throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x"+s().toString(16)+" bytes");return 0|t}function p(t,e){if(u.isBuffer(t))return t.length;if("undefined"!=typeof ArrayBuffer&&"function"==typeof ArrayBuffer.isView&&(ArrayBuffer.isView(t)||t instanceof ArrayBuffer))return t.byteLength;"string"!=typeof t&&(t=""+t);var r=t.length;if(0===r)return 0;for(var n=!1;;)switch(e){case"ascii":case"latin1":case"binary":return r;case"utf8":case"utf-8":case void 0:return B(t).length;case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return 2*r;case"hex":return r>>>1;case"base64":return G(t).length;default:if(n)return B(t).length;e=(""+e).toLowerCase(),n=!0}}function y(t,e,r){var n=!1;if((void 0===e||e<0)&&(e=0),e>this.length)return"";if((void 0===r||r>this.length)&&(r=this.length),r<=0)return"";if((r>>>=0)<=(e>>>=0))return"";for(t||(t="utf8");;)switch(t){case"hex":return O(this,e,r);case"utf8":case"utf-8":return k(this,e,r);case"ascii":return T(this,e,r);case"latin1":case"binary":return C(this,e,r);case"base64":return E(this,e,r);case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return I(this,e,r);default:if(n)throw new TypeError("Unknown encoding: "+t);t=(t+"").toLowerCase(),n=!0}}function g(t,e,r){var n=t[e];t[e]=t[r],t[r]=n}function m(t,e,r,n,i){if(0===t.length)return-1;if("string"==typeof r?(n=r,r=0):r>2147483647?r=2147483647:r<-2147483648&&(r=-2147483648),r=+r,isNaN(r)&&(r=i?0:t.length-1),r<0&&(r=t.length+r),r>=t.length){if(i)return-1;r=t.length-1}else if(r<0){if(!i)return-1;r=0}if("string"==typeof e&&(e=u.from(e,n)),u.isBuffer(e))return 0===e.length?-1:b(t,e,r,n,i);if("number"==typeof e)return e&=255,u.TYPED_ARRAY_SUPPORT&&"function"==typeof Uint8Array.prototype.indexOf?i?Uint8Array.prototype.indexOf.call(t,e,r):Uint8Array.prototype.lastIndexOf.call(t,e,r):b(t,[e],r,n,i);throw new TypeError("val must be string, number or Buffer")}function b(t,e,r,n,i){var o,s=1,a=t.length,u=e.length;if(void 0!==n&&("ucs2"===(n=String(n).toLowerCase())||"ucs-2"===n||"utf16le"===n||"utf-16le"===n)){if(t.length<2||e.length<2)return-1;s=2,a/=2,u/=2,r/=2}function c(t,e){return 1===s?t[e]:t.readUInt16BE(e*s)}if(i){var l=-1;for(o=r;o<a;o++)if(c(t,o)===c(e,-1===l?0:o-l)){if(-1===l&&(l=o),o-l+1===u)return l*s}else-1!==l&&(o-=o-l),l=-1}else for(r+u>a&&(r=a-u),o=r;o>=0;o--){for(var f=!0,h=0;h<u;h++)if(c(t,o+h)!==c(e,h)){f=!1;break}if(f)return o}return-1}function v(t,e,r,n){r=Number(r)||0;var i=t.length-r;n?(n=Number(n))>i&&(n=i):n=i;var o=e.length;if(o%2!=0)throw new TypeError("Invalid hex string");n>o/2&&(n=o/2);for(var s=0;s<n;++s){var a=parseInt(e.substr(2*s,2),16);if(isNaN(a))return s;t[r+s]=a}return s}function w(t,e,r,n){return q(B(e,t.length-r),t,r,n)}function x(t,e,r,n){return q(function(t){for(var e=[],r=0;r<t.length;++r)e.push(255&t.charCodeAt(r));return e}(e),t,r,n)}function _(t,e,r,n){return x(t,e,r,n)}function S(t,e,r,n){return q(G(e),t,r,n)}function A(t,e,r,n){return q(function(t,e){for(var r,n,i,o=[],s=0;s<t.length&&!((e-=2)<0);++s)r=t.charCodeAt(s),n=r>>8,i=r%256,o.push(i),o.push(n);return o}(e,t.length-r),t,r,n)}function E(t,e,r){return 0===e&&r===t.length?n.fromByteArray(t):n.fromByteArray(t.slice(e,r))}function k(t,e,r){r=Math.min(t.length,r);for(var n=[],i=e;i<r;){var o,s,a,u,c=t[i],l=null,f=c>239?4:c>223?3:c>191?2:1;if(i+f<=r)switch(f){case 1:c<128&&(l=c);break;case 2:128==(192&(o=t[i+1]))&&(u=(31&c)<<6|63&o)>127&&(l=u);break;case 3:o=t[i+1],s=t[i+2],128==(192&o)&&128==(192&s)&&(u=(15&c)<<12|(63&o)<<6|63&s)>2047&&(u<55296||u>57343)&&(l=u);break;case 4:o=t[i+1],s=t[i+2],a=t[i+3],128==(192&o)&&128==(192&s)&&128==(192&a)&&(u=(15&c)<<18|(63&o)<<12|(63&s)<<6|63&a)>65535&&u<1114112&&(l=u)}null===l?(l=65533,f=1):l>65535&&(l-=65536,n.push(l>>>10&1023|55296),l=56320|1023&l),n.push(l),i+=f}return function(t){var e=t.length;if(e<=4096)return String.fromCharCode.apply(String,t);var r="",n=0;for(;n<e;)r+=String.fromCharCode.apply(String,t.slice(n,n+=4096));return r}(n)}e.Buffer=u,e.SlowBuffer=function(t){+t!=t&&(t=0);return u.alloc(+t)},e.INSPECT_MAX_BYTES=50,u.TYPED_ARRAY_SUPPORT=void 0!==t.TYPED_ARRAY_SUPPORT?t.TYPED_ARRAY_SUPPORT:function(){try{var t=new Uint8Array(1);return t.__proto__={__proto__:Uint8Array.prototype,foo:function(){return 42}},42===t.foo()&&"function"==typeof t.subarray&&0===t.subarray(1,1).byteLength}catch(t){return!1}}(),e.kMaxLength=s(),u.poolSize=8192,u._augment=function(t){return t.__proto__=u.prototype,t},u.from=function(t,e,r){return c(null,t,e,r)},u.TYPED_ARRAY_SUPPORT&&(u.prototype.__proto__=Uint8Array.prototype,u.__proto__=Uint8Array,"undefined"!=typeof Symbol&&Symbol.species&&u[Symbol.species]===u&&Object.defineProperty(u,Symbol.species,{value:null,configurable:!0})),u.alloc=function(t,e,r){return function(t,e,r,n){return l(e),e<=0?a(t,e):void 0!==r?"string"==typeof n?a(t,e).fill(r,n):a(t,e).fill(r):a(t,e)}(null,t,e,r)},u.allocUnsafe=function(t){return f(null,t)},u.allocUnsafeSlow=function(t){return f(null,t)},u.isBuffer=function(t){return!(null==t||!t._isBuffer)},u.compare=function(t,e){if(!u.isBuffer(t)||!u.isBuffer(e))throw new TypeError("Arguments must be Buffers");if(t===e)return 0;for(var r=t.length,n=e.length,i=0,o=Math.min(r,n);i<o;++i)if(t[i]!==e[i]){r=t[i],n=e[i];break}return r<n?-1:n<r?1:0},u.isEncoding=function(t){switch(String(t).toLowerCase()){case"hex":case"utf8":case"utf-8":case"ascii":case"latin1":case"binary":case"base64":case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return!0;default:return!1}},u.concat=function(t,e){if(!o(t))throw new TypeError(\'"list" argument must be an Array of Buffers\');if(0===t.length)return u.alloc(0);var r;if(void 0===e)for(e=0,r=0;r<t.length;++r)e+=t[r].length;var n=u.allocUnsafe(e),i=0;for(r=0;r<t.length;++r){var s=t[r];if(!u.isBuffer(s))throw new TypeError(\'"list" argument must be an Array of Buffers\');s.copy(n,i),i+=s.length}return n},u.byteLength=p,u.prototype._isBuffer=!0,u.prototype.swap16=function(){var t=this.length;if(t%2!=0)throw new RangeError("Buffer size must be a multiple of 16-bits");for(var e=0;e<t;e+=2)g(this,e,e+1);return this},u.prototype.swap32=function(){var t=this.length;if(t%4!=0)throw new RangeError("Buffer size must be a multiple of 32-bits");for(var e=0;e<t;e+=4)g(this,e,e+3),g(this,e+1,e+2);return this},u.prototype.swap64=function(){var t=this.length;if(t%8!=0)throw new RangeError("Buffer size must be a multiple of 64-bits");for(var e=0;e<t;e+=8)g(this,e,e+7),g(this,e+1,e+6),g(this,e+2,e+5),g(this,e+3,e+4);return this},u.prototype.toString=function(){var t=0|this.length;return 0===t?"":0===arguments.length?k(this,0,t):y.apply(this,arguments)},u.prototype.equals=function(t){if(!u.isBuffer(t))throw new TypeError("Argument must be a Buffer");return this===t||0===u.compare(this,t)},u.prototype.inspect=function(){var t="",r=e.INSPECT_MAX_BYTES;return this.length>0&&(t=this.toString("hex",0,r).match(/.{2}/g).join(" "),this.length>r&&(t+=" ... ")),"<Buffer "+t+">"},u.prototype.compare=function(t,e,r,n,i){if(!u.isBuffer(t))throw new TypeError("Argument must be a Buffer");if(void 0===e&&(e=0),void 0===r&&(r=t?t.length:0),void 0===n&&(n=0),void 0===i&&(i=this.length),e<0||r>t.length||n<0||i>this.length)throw new RangeError("out of range index");if(n>=i&&e>=r)return 0;if(n>=i)return-1;if(e>=r)return 1;if(this===t)return 0;for(var o=(i>>>=0)-(n>>>=0),s=(r>>>=0)-(e>>>=0),a=Math.min(o,s),c=this.slice(n,i),l=t.slice(e,r),f=0;f<a;++f)if(c[f]!==l[f]){o=c[f],s=l[f];break}return o<s?-1:s<o?1:0},u.prototype.includes=function(t,e,r){return-1!==this.indexOf(t,e,r)},u.prototype.indexOf=function(t,e,r){return m(this,t,e,r,!0)},u.prototype.lastIndexOf=function(t,e,r){return m(this,t,e,r,!1)},u.prototype.write=function(t,e,r,n){if(void 0===e)n="utf8",r=this.length,e=0;else if(void 0===r&&"string"==typeof e)n=e,r=this.length,e=0;else{if(!isFinite(e))throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");e|=0,isFinite(r)?(r|=0,void 0===n&&(n="utf8")):(n=r,r=void 0)}var i=this.length-e;if((void 0===r||r>i)&&(r=i),t.length>0&&(r<0||e<0)||e>this.length)throw new RangeError("Attempt to write outside buffer bounds");n||(n="utf8");for(var o=!1;;)switch(n){case"hex":return v(this,t,e,r);case"utf8":case"utf-8":return w(this,t,e,r);case"ascii":return x(this,t,e,r);case"latin1":case"binary":return _(this,t,e,r);case"base64":return S(this,t,e,r);case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return A(this,t,e,r);default:if(o)throw new TypeError("Unknown encoding: "+n);n=(""+n).toLowerCase(),o=!0}},u.prototype.toJSON=function(){return{type:"Buffer",data:Array.prototype.slice.call(this._arr||this,0)}};function T(t,e,r){var n="";r=Math.min(t.length,r);for(var i=e;i<r;++i)n+=String.fromCharCode(127&t[i]);return n}function C(t,e,r){var n="";r=Math.min(t.length,r);for(var i=e;i<r;++i)n+=String.fromCharCode(t[i]);return n}function O(t,e,r){var n=t.length;(!e||e<0)&&(e=0),(!r||r<0||r>n)&&(r=n);for(var i="",o=e;o<r;++o)i+=U(t[o]);return i}function I(t,e,r){for(var n=t.slice(e,r),i="",o=0;o<n.length;o+=2)i+=String.fromCharCode(n[o]+256*n[o+1]);return i}function P(t,e,r){if(t%1!=0||t<0)throw new RangeError("offset is not uint");if(t+e>r)throw new RangeError("Trying to access beyond buffer length")}function R(t,e,r,n,i,o){if(!u.isBuffer(t))throw new TypeError(\'"buffer" argument must be a Buffer instance\');if(e>i||e<o)throw new RangeError(\'"value" argument is out of bounds\');if(r+n>t.length)throw new RangeError("Index out of range")}function j(t,e,r,n){e<0&&(e=65535+e+1);for(var i=0,o=Math.min(t.length-r,2);i<o;++i)t[r+i]=(e&255<<8*(n?i:1-i))>>>8*(n?i:1-i)}function M(t,e,r,n){e<0&&(e=4294967295+e+1);for(var i=0,o=Math.min(t.length-r,4);i<o;++i)t[r+i]=e>>>8*(n?i:3-i)&255}function L(t,e,r,n,i,o){if(r+n>t.length)throw new RangeError("Index out of range");if(r<0)throw new RangeError("Index out of range")}function F(t,e,r,n,o){return o||L(t,0,r,4),i.write(t,e,r,n,23,4),r+4}function N(t,e,r,n,o){return o||L(t,0,r,8),i.write(t,e,r,n,52,8),r+8}u.prototype.slice=function(t,e){var r,n=this.length;if((t=~~t)<0?(t+=n)<0&&(t=0):t>n&&(t=n),(e=void 0===e?n:~~e)<0?(e+=n)<0&&(e=0):e>n&&(e=n),e<t&&(e=t),u.TYPED_ARRAY_SUPPORT)(r=this.subarray(t,e)).__proto__=u.prototype;else{var i=e-t;r=new u(i,void 0);for(var o=0;o<i;++o)r[o]=this[o+t]}return r},u.prototype.readUIntLE=function(t,e,r){t|=0,e|=0,r||P(t,e,this.length);for(var n=this[t],i=1,o=0;++o<e&&(i*=256);)n+=this[t+o]*i;return n},u.prototype.readUIntBE=function(t,e,r){t|=0,e|=0,r||P(t,e,this.length);for(var n=this[t+--e],i=1;e>0&&(i*=256);)n+=this[t+--e]*i;return n},u.prototype.readUInt8=function(t,e){return e||P(t,1,this.length),this[t]},u.prototype.readUInt16LE=function(t,e){return e||P(t,2,this.length),this[t]|this[t+1]<<8},u.prototype.readUInt16BE=function(t,e){return e||P(t,2,this.length),this[t]<<8|this[t+1]},u.prototype.readUInt32LE=function(t,e){return e||P(t,4,this.length),(this[t]|this[t+1]<<8|this[t+2]<<16)+16777216*this[t+3]},u.prototype.readUInt32BE=function(t,e){return e||P(t,4,this.length),16777216*this[t]+(this[t+1]<<16|this[t+2]<<8|this[t+3])},u.prototype.readIntLE=function(t,e,r){t|=0,e|=0,r||P(t,e,this.length);for(var n=this[t],i=1,o=0;++o<e&&(i*=256);)n+=this[t+o]*i;return n>=(i*=128)&&(n-=Math.pow(2,8*e)),n},u.prototype.readIntBE=function(t,e,r){t|=0,e|=0,r||P(t,e,this.length);for(var n=e,i=1,o=this[t+--n];n>0&&(i*=256);)o+=this[t+--n]*i;return o>=(i*=128)&&(o-=Math.pow(2,8*e)),o},u.prototype.readInt8=function(t,e){return e||P(t,1,this.length),128&this[t]?-1*(255-this[t]+1):this[t]},u.prototype.readInt16LE=function(t,e){e||P(t,2,this.length);var r=this[t]|this[t+1]<<8;return 32768&r?4294901760|r:r},u.prototype.readInt16BE=function(t,e){e||P(t,2,this.length);var r=this[t+1]|this[t]<<8;return 32768&r?4294901760|r:r},u.prototype.readInt32LE=function(t,e){return e||P(t,4,this.length),this[t]|this[t+1]<<8|this[t+2]<<16|this[t+3]<<24},u.prototype.readInt32BE=function(t,e){return e||P(t,4,this.length),this[t]<<24|this[t+1]<<16|this[t+2]<<8|this[t+3]},u.prototype.readFloatLE=function(t,e){return e||P(t,4,this.length),i.read(this,t,!0,23,4)},u.prototype.readFloatBE=function(t,e){return e||P(t,4,this.length),i.read(this,t,!1,23,4)},u.prototype.readDoubleLE=function(t,e){return e||P(t,8,this.length),i.read(this,t,!0,52,8)},u.prototype.readDoubleBE=function(t,e){return e||P(t,8,this.length),i.read(this,t,!1,52,8)},u.prototype.writeUIntLE=function(t,e,r,n){(t=+t,e|=0,r|=0,n)||R(this,t,e,r,Math.pow(2,8*r)-1,0);var i=1,o=0;for(this[e]=255&t;++o<r&&(i*=256);)this[e+o]=t/i&255;return e+r},u.prototype.writeUIntBE=function(t,e,r,n){(t=+t,e|=0,r|=0,n)||R(this,t,e,r,Math.pow(2,8*r)-1,0);var i=r-1,o=1;for(this[e+i]=255&t;--i>=0&&(o*=256);)this[e+i]=t/o&255;return e+r},u.prototype.writeUInt8=function(t,e,r){return t=+t,e|=0,r||R(this,t,e,1,255,0),u.TYPED_ARRAY_SUPPORT||(t=Math.floor(t)),this[e]=255&t,e+1},u.prototype.writeUInt16LE=function(t,e,r){return t=+t,e|=0,r||R(this,t,e,2,65535,0),u.TYPED_ARRAY_SUPPORT?(this[e]=255&t,this[e+1]=t>>>8):j(this,t,e,!0),e+2},u.prototype.writeUInt16BE=function(t,e,r){return t=+t,e|=0,r||R(this,t,e,2,65535,0),u.TYPED_ARRAY_SUPPORT?(this[e]=t>>>8,this[e+1]=255&t):j(this,t,e,!1),e+2},u.prototype.writeUInt32LE=function(t,e,r){return t=+t,e|=0,r||R(this,t,e,4,4294967295,0),u.TYPED_ARRAY_SUPPORT?(this[e+3]=t>>>24,this[e+2]=t>>>16,this[e+1]=t>>>8,this[e]=255&t):M(this,t,e,!0),e+4},u.prototype.writeUInt32BE=function(t,e,r){return t=+t,e|=0,r||R(this,t,e,4,4294967295,0),u.TYPED_ARRAY_SUPPORT?(this[e]=t>>>24,this[e+1]=t>>>16,this[e+2]=t>>>8,this[e+3]=255&t):M(this,t,e,!1),e+4},u.prototype.writeIntLE=function(t,e,r,n){if(t=+t,e|=0,!n){var i=Math.pow(2,8*r-1);R(this,t,e,r,i-1,-i)}var o=0,s=1,a=0;for(this[e]=255&t;++o<r&&(s*=256);)t<0&&0===a&&0!==this[e+o-1]&&(a=1),this[e+o]=(t/s>>0)-a&255;return e+r},u.prototype.writeIntBE=function(t,e,r,n){if(t=+t,e|=0,!n){var i=Math.pow(2,8*r-1);R(this,t,e,r,i-1,-i)}var o=r-1,s=1,a=0;for(this[e+o]=255&t;--o>=0&&(s*=256);)t<0&&0===a&&0!==this[e+o+1]&&(a=1),this[e+o]=(t/s>>0)-a&255;return e+r},u.prototype.writeInt8=function(t,e,r){return t=+t,e|=0,r||R(this,t,e,1,127,-128),u.TYPED_ARRAY_SUPPORT||(t=Math.floor(t)),t<0&&(t=255+t+1),this[e]=255&t,e+1},u.prototype.writeInt16LE=function(t,e,r){return t=+t,e|=0,r||R(this,t,e,2,32767,-32768),u.TYPED_ARRAY_SUPPORT?(this[e]=255&t,this[e+1]=t>>>8):j(this,t,e,!0),e+2},u.prototype.writeInt16BE=function(t,e,r){return t=+t,e|=0,r||R(this,t,e,2,32767,-32768),u.TYPED_ARRAY_SUPPORT?(this[e]=t>>>8,this[e+1]=255&t):j(this,t,e,!1),e+2},u.prototype.writeInt32LE=function(t,e,r){return t=+t,e|=0,r||R(this,t,e,4,2147483647,-2147483648),u.TYPED_ARRAY_SUPPORT?(this[e]=255&t,this[e+1]=t>>>8,this[e+2]=t>>>16,this[e+3]=t>>>24):M(this,t,e,!0),e+4},u.prototype.writeInt32BE=function(t,e,r){return t=+t,e|=0,r||R(this,t,e,4,2147483647,-2147483648),t<0&&(t=4294967295+t+1),u.TYPED_ARRAY_SUPPORT?(this[e]=t>>>24,this[e+1]=t>>>16,this[e+2]=t>>>8,this[e+3]=255&t):M(this,t,e,!1),e+4},u.prototype.writeFloatLE=function(t,e,r){return F(this,t,e,!0,r)},u.prototype.writeFloatBE=function(t,e,r){return F(this,t,e,!1,r)},u.prototype.writeDoubleLE=function(t,e,r){return N(this,t,e,!0,r)},u.prototype.writeDoubleBE=function(t,e,r){return N(this,t,e,!1,r)},u.prototype.copy=function(t,e,r,n){if(r||(r=0),n||0===n||(n=this.length),e>=t.length&&(e=t.length),e||(e=0),n>0&&n<r&&(n=r),n===r)return 0;if(0===t.length||0===this.length)return 0;if(e<0)throw new RangeError("targetStart out of bounds");if(r<0||r>=this.length)throw new RangeError("sourceStart out of bounds");if(n<0)throw new RangeError("sourceEnd out of bounds");n>this.length&&(n=this.length),t.length-e<n-r&&(n=t.length-e+r);var i,o=n-r;if(this===t&&r<e&&e<n)for(i=o-1;i>=0;--i)t[i+e]=this[i+r];else if(o<1e3||!u.TYPED_ARRAY_SUPPORT)for(i=0;i<o;++i)t[i+e]=this[i+r];else Uint8Array.prototype.set.call(t,this.subarray(r,r+o),e);return o},u.prototype.fill=function(t,e,r,n){if("string"==typeof t){if("string"==typeof e?(n=e,e=0,r=this.length):"string"==typeof r&&(n=r,r=this.length),1===t.length){var i=t.charCodeAt(0);i<256&&(t=i)}if(void 0!==n&&"string"!=typeof n)throw new TypeError("encoding must be a string");if("string"==typeof n&&!u.isEncoding(n))throw new TypeError("Unknown encoding: "+n)}else"number"==typeof t&&(t&=255);if(e<0||this.length<e||this.length<r)throw new RangeError("Out of range index");if(r<=e)return this;var o;if(e>>>=0,r=void 0===r?this.length:r>>>0,t||(t=0),"number"==typeof t)for(o=e;o<r;++o)this[o]=t;else{var s=u.isBuffer(t)?t:B(new u(t,n).toString()),a=s.length;for(o=0;o<r-e;++o)this[o+e]=s[o%a]}return this};var D=/[^+\\/0-9A-Za-z-_]/g;function U(t){return t<16?"0"+t.toString(16):t.toString(16)}function B(t,e){var r;e=e||1/0;for(var n=t.length,i=null,o=[],s=0;s<n;++s){if((r=t.charCodeAt(s))>55295&&r<57344){if(!i){if(r>56319){(e-=3)>-1&&o.push(239,191,189);continue}if(s+1===n){(e-=3)>-1&&o.push(239,191,189);continue}i=r;continue}if(r<56320){(e-=3)>-1&&o.push(239,191,189),i=r;continue}r=65536+(i-55296<<10|r-56320)}else i&&(e-=3)>-1&&o.push(239,191,189);if(i=null,r<128){if((e-=1)<0)break;o.push(r)}else if(r<2048){if((e-=2)<0)break;o.push(r>>6|192,63&r|128)}else if(r<65536){if((e-=3)<0)break;o.push(r>>12|224,r>>6&63|128,63&r|128)}else{if(!(r<1114112))throw new Error("Invalid code point");if((e-=4)<0)break;o.push(r>>18|240,r>>12&63|128,r>>6&63|128,63&r|128)}}return o}function G(t){return n.toByteArray(function(t){if((t=function(t){return t.trim?t.trim():t.replace(/^\\s+|\\s+$/g,"")}(t).replace(D,"")).length<2)return"";for(;t.length%4!=0;)t+="=";return t}(t))}function q(t,e,r,n){for(var i=0;i<n&&!(i+r>=e.length||i>=t.length);++i)e[i+r]=t[i];return i}}).call(this,r(3))},function(t,e){"function"==typeof Object.create?t.exports=function(t,e){e&&(t.super_=e,t.prototype=Object.create(e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}))}:t.exports=function(t,e){if(e){t.super_=e;var r=function(){};r.prototype=e.prototype,t.prototype=new r,t.prototype.constructor=t}}},function(t,e,r){"use strict";function n(t){return/^[-+]?0(\\.0+)?(e[\\.\\d]+)?$/.test(t)}t.exports=n,t.exports.default=n},function(t,e,r){(function(n){e.formatArgs=function(e){if(e[0]=(this.useColors?"%c":"")+this.namespace+(this.useColors?" %c":" ")+e[0]+(this.useColors?"%c ":" ")+"+"+t.exports.humanize(this.diff),!this.useColors)return;const r="color: "+this.color;e.splice(1,0,r,"color: inherit");let n=0,i=0;e[0].replace(/%[a-zA-Z%]/g,t=>{"%%"!==t&&(n++,"%c"===t&&(i=n))}),e.splice(i,0,r)},e.save=function(t){try{t?e.storage.setItem("debug",t):e.storage.removeItem("debug")}catch(t){}},e.load=function(){let t;try{t=e.storage.getItem("debug")}catch(t){}!t&&void 0!==n&&"env"in n&&(t=n.env.DEBUG);return t},e.useColors=function(){if("undefined"!=typeof window&&window.process&&("renderer"===window.process.type||window.process.__nwjs))return!0;if("undefined"!=typeof navigator&&navigator.userAgent&&navigator.userAgent.toLowerCase().match(/(edge|trident)\\/(\\d+)/))return!1;return"undefined"!=typeof document&&document.documentElement&&document.documentElement.style&&document.documentElement.style.WebkitAppearance||"undefined"!=typeof window&&window.console&&(window.console.firebug||window.console.exception&&window.console.table)||"undefined"!=typeof navigator&&navigator.userAgent&&navigator.userAgent.toLowerCase().match(/firefox\\/(\\d+)/)&&parseInt(RegExp.$1,10)>=31||"undefined"!=typeof navigator&&navigator.userAgent&&navigator.userAgent.toLowerCase().match(/applewebkit\\/(\\d+)/)},e.storage=function(){try{return localStorage}catch(t){}}(),e.destroy=(()=>{let t=!1;return()=>{t||(t=!0,console.warn("Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`."))}})(),e.colors=["#0000CC","#0000FF","#0033CC","#0033FF","#0066CC","#0066FF","#0099CC","#0099FF","#00CC00","#00CC33","#00CC66","#00CC99","#00CCCC","#00CCFF","#3300CC","#3300FF","#3333CC","#3333FF","#3366CC","#3366FF","#3399CC","#3399FF","#33CC00","#33CC33","#33CC66","#33CC99","#33CCCC","#33CCFF","#6600CC","#6600FF","#6633CC","#6633FF","#66CC00","#66CC33","#9900CC","#9900FF","#9933CC","#9933FF","#99CC00","#99CC33","#CC0000","#CC0033","#CC0066","#CC0099","#CC00CC","#CC00FF","#CC3300","#CC3333","#CC3366","#CC3399","#CC33CC","#CC33FF","#CC6600","#CC6633","#CC9900","#CC9933","#CCCC00","#CCCC33","#FF0000","#FF0033","#FF0066","#FF0099","#FF00CC","#FF00FF","#FF3300","#FF3333","#FF3366","#FF3399","#FF33CC","#FF33FF","#FF6600","#FF6633","#FF9900","#FF9933","#FFCC00","#FFCC33"],e.log=console.debug||console.log||(()=>{}),t.exports=r(129)(e);const{formatters:i}=t.exports;i.j=function(t){try{return JSON.stringify(t)}catch(t){return"[UnexpectedJSONParseError]: "+t.message}}}).call(this,r(7))},function(t,e,r){"use strict";r.d(e,"a",(function(){return o})),r.d(e,"b",(function(){return s}));const n={deserialize:t=>Object.assign(Error(t.message),{name:t.name,stack:t.stack}),serialize:t=>({__error_marker:"$$error",message:t.message,name:t.name,stack:t.stack})};let i={deserialize(t){return(e=t)&&"object"==typeof e&&"__error_marker"in e&&"$$error"===e.__error_marker?n.deserialize(t):t;var e},serialize:t=>t instanceof Error?n.serialize(t):t};function o(t){return i.deserialize(t)}function s(t){return i.serialize(t)}},function(t,e,r){"use strict";var n=r(28),i=Object.keys||function(t){var e=[];for(var r in t)e.push(r);return e};t.exports=f;var o=Object.create(r(21));o.inherits=r(10);var s=r(60),a=r(65);o.inherits(f,s);for(var u=i(a.prototype),c=0;c<u.length;c++){var l=u[c];f.prototype[l]||(f.prototype[l]=a.prototype[l])}function f(t){if(!(this instanceof f))return new f(t);s.call(this,t),a.call(this,t),t&&!1===t.readable&&(this.readable=!1),t&&!1===t.writable&&(this.writable=!1),this.allowHalfOpen=!0,t&&!1===t.allowHalfOpen&&(this.allowHalfOpen=!1),this.once("end",h)}function h(){this.allowHalfOpen||this._writableState.ended||n.nextTick(d,this)}function d(t){t.end()}Object.defineProperty(f.prototype,"writableHighWaterMark",{enumerable:!1,get:function(){return this._writableState.highWaterMark}}),Object.defineProperty(f.prototype,"destroyed",{get:function(){return void 0!==this._readableState&&void 0!==this._writableState&&(this._readableState.destroyed&&this._writableState.destroyed)},set:function(t){void 0!==this._readableState&&void 0!==this._writableState&&(this._readableState.destroyed=t,this._writableState.destroyed=t)}}),f.prototype._destroy=function(t,e){this.push(null),this.end(),n.nextTick(e,t)}},function(t,e,r){"use strict";function n(t){return!!t.match(/^(|-|\\+)inf(inity)?$/i)}t.exports=n,t.exports.default=n},function(t,e,r){"use strict";const n=r(0),i=r(15);function o(t){return!i(t)&&(!(t=n(t)).includes(".")&&!t.includes("/"))}t.exports=o,t.exports.default=o},function(t,e,r){"use strict";const n=r(4),i=r(0),o=r(5),s=r(48),a=r(36);function u(t,{max_decimal_digits:e}={}){let r=i(t[0]),u=n(r),c="-"===r[0]?"-":"";const l=t.length;for(let e=1;e<l;e++){const a=i(t[e]),l="-"===a[0]?"-":"",f=n(a);c=c!==l?"-":"";u="<"===o(u,f)?s(f,u):s(u,f),r=c+u}return"number"==typeof e&&(r=a(r,{digits:e})),r}t.exports=u,t.exports.default=u},function(t,e,r){const n=r(179);t.exports=function(t){return"+"===t[0]&&(t=t.substring(1)),(t=(t=n(t)).replace(/^0+(?=\\d)/,"")).includes(".")&&(t=t.replace(/\\.?0+$/,"")),""===t&&(t="0"),t}},function(t,e,r){"use strict";let n;function i(){return n||(n=function(){try{throw new Error}catch(t){const e=(""+t.stack).match(/(https?|file|ftp|chrome-extension|moz-extension):\\/\\/[^)\\n]+/g);if(e)return(""+e[0]).replace(/^((?:https?|file|ftp|chrome-extension|moz-extension):\\/\\/.+)?\\/[^/]+(?:\\?.*)?$/,"$1")+"/"}return"/"}()),n}r.d(e,"a",(function(){return o})),r.d(e,"b",(function(){return c}));const o="undefined"!=typeof navigator&&navigator.hardwareConcurrency?navigator.hardwareConcurrency:4,s=t=>/^[a-zA-Z][a-zA-Z\\d+\\-.]*:/.test(t);function a(t){const e=new Blob([t],{type:"application/javascript"});return URL.createObjectURL(e)}let u;function c(){return u||(u=function(){if("undefined"==typeof Worker)return class{constructor(){throw Error("No web worker implementation available. You might have tried to spawn a worker within a worker in a browser that doesn\'t support workers in workers.")}};class t extends Worker{constructor(t,e){var r,n;"string"==typeof t&&e&&e._baseURL?t=new URL(t,e._baseURL):"string"==typeof t&&!s(t)&&i().match(/^file:\\/\\//i)&&(t=new URL(t,i().replace(/\\/[^\\/]+$/,"/")),(null===(r=null==e?void 0:e.CORSWorkaround)||void 0===r||r)&&(t=a(`importScripts(${JSON.stringify(t)});`))),"string"==typeof t&&s(t)&&(null===(n=null==e?void 0:e.CORSWorkaround)||void 0===n||n)&&(t=a(`importScripts(${JSON.stringify(t)});`)),super(t,e)}}class e extends t{constructor(t,e){super(window.URL.createObjectURL(t),e)}static fromText(t,r){const n=new window.Blob([t],{type:"text/javascript"});return new e(n,r)}}return{blob:e,default:t}}()),u}},function(t,e,r){"use strict";var n,i;r.d(e,"a",(function(){return n})),r.d(e,"b",(function(){return i})),function(t){t.cancel="cancel",t.run="run"}(n||(n={})),function(t){t.error="error",t.init="init",t.result="result",t.running="running",t.uncaughtError="uncaughtError"}(i||(i={}))},function(t,e,r){function n(t){return Object.prototype.toString.call(t)}e.isArray=function(t){return Array.isArray?Array.isArray(t):"[object Array]"===n(t)},e.isBoolean=function(t){return"boolean"==typeof t},e.isNull=function(t){return null===t},e.isNullOrUndefined=function(t){return null==t},e.isNumber=function(t){return"number"==typeof t},e.isString=function(t){return"string"==typeof t},e.isSymbol=function(t){return"symbol"==typeof t},e.isUndefined=function(t){return void 0===t},e.isRegExp=function(t){return"[object RegExp]"===n(t)},e.isObject=function(t){return"object"==typeof t&&null!==t},e.isDate=function(t){return"[object Date]"===n(t)},e.isError=function(t){return"[object Error]"===n(t)||t instanceof Error},e.isFunction=function(t){return"function"==typeof t},e.isPrimitive=function(t){return null===t||"boolean"==typeof t||"number"==typeof t||"string"==typeof t||"symbol"==typeof t||void 0===t},e.isBuffer=r(9).Buffer.isBuffer},function(t,e,r){"use strict";const n=r(11),i=r(50);function o(t){return n(t)?"":i(t)}t.exports=o,t.exports.default=o},function(t,e,r){"use strict";const n=r(35);function i(t,e){return n(t,"2",e)}t.exports=i,t.exports.default=i},function(t,e,r){"use strict";r.d(e,"a",(function(){return o}));var n=r(2);function i(t){throw Error(t)}const o={errors:t=>t[n.a]||i("Error observable not found. Make sure to pass a thread instance as returned by the spawn() promise."),events:t=>t[n.b]||i("Events observable not found. Make sure to pass a thread instance as returned by the spawn() promise."),terminate:t=>t[n.c]()}},function(t,e){},function(t,e,r){"use strict";const n=()=>"function"==typeof Symbol,i=t=>n()&&Boolean(Symbol[t]),o=t=>i(t)?Symbol[t]:"@@"+t;i("asyncIterator")||(Symbol.asyncIterator=Symbol.asyncIterator||Symbol.for("Symbol.asyncIterator"));const s=o("iterator"),a=o("observable"),u=o("species");function c(t,e){const r=t[e];if(null!=r){if("function"!=typeof r)throw new TypeError(r+" is not a function");return r}}function l(t){let e=t.constructor;return void 0!==e&&(e=e[u],null===e&&(e=void 0)),void 0!==e?e:v}function f(t){f.log?f.log(t):setTimeout(()=>{throw t},0)}function h(t){Promise.resolve().then(()=>{try{t()}catch(t){f(t)}})}function d(t){const e=t._cleanup;if(void 0!==e&&(t._cleanup=void 0,e))try{if("function"==typeof e)e();else{const t=c(e,"unsubscribe");t&&t.call(e)}}catch(t){f(t)}}function p(t){t._observer=void 0,t._queue=void 0,t._state="closed"}function y(t,e,r){t._state="running";const n=t._observer;try{const i=n?c(n,e):void 0;switch(e){case"next":i&&i.call(n,r);break;case"error":if(p(t),!i)throw r;i.call(n,r);break;case"complete":p(t),i&&i.call(n)}}catch(t){f(t)}"closed"===t._state?d(t):"running"===t._state&&(t._state="ready")}function g(t,e,r){if("closed"!==t._state)return"buffering"===t._state?(t._queue=t._queue||[],void t._queue.push({type:e,value:r})):"ready"!==t._state?(t._state="buffering",t._queue=[{type:e,value:r}],void h(()=>function(t){const e=t._queue;if(e){t._queue=void 0,t._state="ready";for(const r of e)if(y(t,r.type,r.value),"closed"===t._state)break}}(t))):void y(t,e,r)}class m{constructor(t,e){this._cleanup=void 0,this._observer=t,this._queue=void 0,this._state="initializing";const r=new b(this);try{this._cleanup=e.call(void 0,r)}catch(t){r.error(t)}"initializing"===this._state&&(this._state="ready")}get closed(){return"closed"===this._state}unsubscribe(){"closed"!==this._state&&(p(this),d(this))}}class b{constructor(t){this._subscription=t}get closed(){return"closed"===this._subscription._state}next(t){g(this._subscription,"next",t)}error(t){g(this._subscription,"error",t)}complete(){g(this._subscription,"complete")}}class v{constructor(t){if(!(this instanceof v))throw new TypeError("Observable cannot be called as a function");if("function"!=typeof t)throw new TypeError("Observable initializer must be a function");this._subscriber=t}subscribe(t,e,r){return"object"==typeof t&&null!==t||(t={next:t,error:e,complete:r}),new m(t,this._subscriber)}pipe(t,...e){let r=this;for(const n of[t,...e])r=n(r);return r}tap(t,e,r){const n="object"!=typeof t||null===t?{next:t,error:e,complete:r}:t;return new v(t=>this.subscribe({next(e){n.next&&n.next(e),t.next(e)},error(e){n.error&&n.error(e),t.error(e)},complete(){n.complete&&n.complete(),t.complete()},start(t){n.start&&n.start(t)}}))}forEach(t){return new Promise((e,r)=>{if("function"!=typeof t)return void r(new TypeError(t+" is not a function"));function n(){i.unsubscribe(),e(void 0)}const i=this.subscribe({next(e){try{t(e,n)}catch(t){r(t),i.unsubscribe()}},error(t){r(t)},complete(){e(void 0)}})})}map(t){if("function"!=typeof t)throw new TypeError(t+" is not a function");return new(l(this))(e=>this.subscribe({next(r){let n=r;try{n=t(r)}catch(t){return e.error(t)}e.next(n)},error(t){e.error(t)},complete(){e.complete()}}))}filter(t){if("function"!=typeof t)throw new TypeError(t+" is not a function");return new(l(this))(e=>this.subscribe({next(r){try{if(!t(r))return}catch(t){return e.error(t)}e.next(r)},error(t){e.error(t)},complete(){e.complete()}}))}reduce(t,e){if("function"!=typeof t)throw new TypeError(t+" is not a function");const r=l(this),n=arguments.length>1;let i=!1,o=e;return new r(e=>this.subscribe({next(r){const s=!i;if(i=!0,!s||n)try{o=t(o,r)}catch(t){return e.error(t)}else o=r},error(t){e.error(t)},complete(){if(!i&&!n)return e.error(new TypeError("Cannot reduce an empty sequence"));e.next(o),e.complete()}}))}concat(...t){const e=l(this);return new e(r=>{let n,i=0;return function o(s){n=s.subscribe({next(t){r.next(t)},error(t){r.error(t)},complete(){i===t.length?(n=void 0,r.complete()):o(e.from(t[i++]))}})}(this),()=>{n&&(n.unsubscribe(),n=void 0)}})}flatMap(t){if("function"!=typeof t)throw new TypeError(t+" is not a function");const e=l(this);return new e(r=>{const n=[],i=this.subscribe({next(i){let s;if(t)try{s=t(i)}catch(t){return r.error(t)}else s=i;const a=e.from(s).subscribe({next(t){r.next(t)},error(t){r.error(t)},complete(){const t=n.indexOf(a);t>=0&&n.splice(t,1),o()}});n.push(a)},error(t){r.error(t)},complete(){o()}});function o(){i.closed&&0===n.length&&r.complete()}return()=>{n.forEach(t=>t.unsubscribe()),i.unsubscribe()}})}[(Symbol.observable,a)](){return this}static from(t){const e="function"==typeof this?this:v;if(null==t)throw new TypeError(t+" is not an object");const r=c(t,a);if(r){const n=r.call(t);if(Object(n)!==n)throw new TypeError(n+" is not an object");return function(t){return t instanceof v}(n)&&n.constructor===e?n:new e(t=>n.subscribe(t))}if(i("iterator")){const r=c(t,s);if(r)return new e(e=>{h(()=>{if(!e.closed){for(const n of r.call(t))if(e.next(n),e.closed)return;e.complete()}})})}if(Array.isArray(t))return new e(e=>{h(()=>{if(!e.closed){for(const r of t)if(e.next(r),e.closed)return;e.complete()}})});throw new TypeError(t+" is not observable")}static of(...t){return new("function"==typeof this?this:v)(e=>{h(()=>{if(!e.closed){for(const r of t)if(e.next(r),e.closed)return;e.complete()}})})}static get[u](){return this}}n()&&Object.defineProperty(v,Symbol("extensions"),{value:{symbol:a,hostReportError:f},configurable:!0});e.a=v},function(t,e,r){"use strict";var n;r.d(e,"a",(function(){return n})),function(t){t.internalError="internalError",t.message="message",t.termination="termination"}(n||(n={}))},function(t,e,r){"use strict";(function(e){void 0===e||!e.version||0===e.version.indexOf("v0.")||0===e.version.indexOf("v1.")&&0!==e.version.indexOf("v1.8.")?t.exports={nextTick:function(t,r,n,i){if("function"!=typeof t)throw new TypeError(\'"callback" argument must be a function\');var o,s,a=arguments.length;switch(a){case 0:case 1:return e.nextTick(t);case 2:return e.nextTick((function(){t.call(null,r)}));case 3:return e.nextTick((function(){t.call(null,r,n)}));case 4:return e.nextTick((function(){t.call(null,r,n,i)}));default:for(o=new Array(a-1),s=0;s<o.length;)o[s++]=arguments[s];return e.nextTick((function(){t.apply(null,o)}))}}}:t.exports=e}).call(this,r(7))},function(t,e,r){"use strict";var n="undefined"!=typeof Uint8Array&&"undefined"!=typeof Uint16Array&&"undefined"!=typeof Int32Array;function i(t,e){return Object.prototype.hasOwnProperty.call(t,e)}e.assign=function(t){for(var e=Array.prototype.slice.call(arguments,1);e.length;){var r=e.shift();if(r){if("object"!=typeof r)throw new TypeError(r+"must be non-object");for(var n in r)i(r,n)&&(t[n]=r[n])}}return t},e.shrinkBuf=function(t,e){return t.length===e?t:t.subarray?t.subarray(0,e):(t.length=e,t)};var o={arraySet:function(t,e,r,n,i){if(e.subarray&&t.subarray)t.set(e.subarray(r,r+n),i);else for(var o=0;o<n;o++)t[i+o]=e[r+o]},flattenChunks:function(t){var e,r,n,i,o,s;for(n=0,e=0,r=t.length;e<r;e++)n+=t[e].length;for(s=new Uint8Array(n),i=0,e=0,r=t.length;e<r;e++)o=t[e],s.set(o,i),i+=o.length;return s}},s={arraySet:function(t,e,r,n,i){for(var o=0;o<n;o++)t[i+o]=e[r+o]},flattenChunks:function(t){return[].concat.apply([],t)}};e.setTyped=function(t){t?(e.Buf8=Uint8Array,e.Buf16=Uint16Array,e.Buf32=Int32Array,e.assign(e,o)):(e.Buf8=Array,e.Buf16=Array,e.Buf32=Array,e.assign(e,s))},e.setTyped(n)},function(t,e,r){"use strict";const{MAX_SAFE_INTEGER:n}=r(74),i=n.toString().length-1;t.exports={MAX_SAFE_INTEGER_LENGTH:i}},function(t,e,r){"use strict";const{MAX_SAFE_INTEGER_LENGTH:n}=r(30);function i(t,e){const r=t.length,i=e.length,o=t.indexOf("."),s=e.indexOf("."),a=-1===o?r:o,u=-1===s?i:s;if(-1===o&&-1===s&&r<n&&i<n)return(Number(t)-Number(e)).toFixed();const c=a-u;let l=Math.max(a,u),f=Math.max(r-a-1,i-u-1),h=c<0?-1*c:0,d=c<=0?0:c,p=l+1+f-1,y="",g=0,m=p;if(f>0){for(;m>p-f;){let r=t[m-h]||"0",n=e[m-d]||"0";r-=g,g=0;let i=r-n;if(i<0)for(;i<0;)g++,i+=10;else g&&g--;""===y&&0===i||(y=i+y),m--}""!==y&&(y="."+y),m--}if(l>0){for(;m>0;){let r=t[m-h]||"0",n=e[m-d]||"0";r-=g,g=0;let i=r-n;if(i<0)for(;i<0;)g++,i+=10;else g&&g--;y=i+y,m--}const r=t[0-h]||"0",n=e[0-d]||"0";let i=Number(r)-(g>0?1:0)-Number(n);0!==i&&(y=i+y),y=y.replace(/^0+/,"")}return"."===y[0]&&(y="0"+y),y}t.exports=i,t.exports.default=i},function(t,e,r){"use strict";const n=r(5),i=r(6),o=r(33),s=r(49);function a(t,e,{format:r="string",max_decimal_digits:a=100,ellipsis:u=!1}={}){"0"===t[0]&&(t=t.substring(1)),"0"===e[0]&&(e=e.substring(1));const c=t.indexOf("."),l=e.indexOf("."),f=-1===c?t.length:c,h=-1===l?0:e.length-1-l;let d=!1;t=t.replace(/\\./,""),e=e.replace(/\\./,"");const p=t.length;let y,g="",m="",b=-1*h,v=0;for(let r=0;r<p;r++){if(g+=t[r],y=n(g,e),">"===y){let t=1,r=i(e,e),s=e;for(;">"!==n(r,g);)t++,s=r,r=i(r,e);if(t=t.toString(),""!==m)for(let e=t.length;e<=v;e++)m+="0";m+=t,g=o(g,s),v=0}else{if("<"===y){""===m&&b++,v++;continue}if("="===y){if(""!==m)for(let t=0;t<v;t++)m+="0";m+="1",g="0",v=0}}}if(g.match(/^0+$/g))"<"===y&&(m+=g.substring(0,g.length-1));else{const t={},r=f-b-m.length+a+1;""===m&&(v=0);for(let s=0;s<r;s++){if(g+="0",u)if(g in t){if(t[g]++,t[g]>3){m+="...",d=!0;break}}else t[g]=1;const r=n(g,e);if(">"===r){let t=1,r=i(e,e),s=e;for(;">"!==n(r,g);)t++,s=r,r=i(r,e);t=t.toString();for(let e=t.length;e<=v;e++)m+="0";if(m+=t,g=o(g,s),"0"===g)break;v=0}else{if("<"===r){v++;continue}if("="===r){for(let t=0;t<v;t++)m+="0";m+="1",v=0;break}}}}const w=f-b,x=m.length;let _;if(w===x)_=0;else if(w<0)m="0."+"0".repeat(Math.abs(w))+m,_=x-w;else if(w>x){for(let t=x;t<w;t++)m+="0";_=0}else w<x?(m=m.substring(0,w)+"."+m.substring(w),_=x-w):0===w&&(m="0."+m,_=x);m=m.replace(/^0+/,""),m=m.replace(/\\.\\d+0+$/,"");const S=_-a;return d||S>0&&(m=s(m.substring(0,m.length-S+1))),"."===m[0]&&(m="0"+m),"object"===r?{quotient:m,extra_decimals:S}:m}t.exports=a,t.exports.default=a},function(t,e,r){"use strict";const n=r(0),i=r(5),o=r(15),s=r(8),a=r(31);function u(t,e,{infinity_minus_infinity:r="NaN"}={}){t=n(t),e=n(e);const u=!("-"===t[0]),c=!("-"===e[0]),l=o(t),f=o(e);if(l&&f){if(u===c)return r;if(u)return"Infinity";if(c)return"-Infinity"}else{if(l)return t;if(f)return c?"-Infinity":"Infinity"}if(u){if(c){const r=i(t,e);return">"===r?a(t,e):"<"===r?"-"+a(e,t):"0"}return s(t,e.substring(1))}if(c)return"-"+s(t.substring(1),e);{t=t.substring(1),e=e.substring(1);const r=i(t,e);return">"===r?"-"+a(t,e):"<"===r?a(e,t):"0"}}t.exports=u,t.exports.default=u},function(t,e,r){"use strict";const n=r(0),i=r(5);function o(t,e){t=n(t),e=n(e);const r="-"!==t[0],o="-"!==e[0];return r?o?i(t,e):">":o?"<":i(e.substring(1),t.substring(1))}t.exports=o,t.exports.default=o},function(t,e,r){"use strict";const n=r(4),i=r(0),o=r(1),s=r(77),a=r(16),u=r(52),c=r(78),l=r(11),f=r(53),h=r(54),d=r(81),p=r(37),y=r(36),g=r(22),m=r(85);function b(t,e,{zero_to_the_power_of_zero:r="1",ellipsis:b=!1,imaginary:v=!0,max_decimal_digits:w=100,fraction:x=!1}={}){t=i(t),e=i(e);const _=v&&u(t);_&&(t=t.replace(/i$/,""));const S=l(t),A=l(e);if(S&&A)return r;if(A)return"1";const E=g(e);if(S){if("+"===E)return"0";if("-"===E)return"Infinity"}const k=a(e);if("+"===E&&k){let r=h(t,e);return"number"==typeof w&&(r=y(r,{digits:w})),_&&c(e)&&(r+="i"),r}if("-"===E&&k){const r="1",i=h(t,n(e));return o(r,i,{ellipsis:b,max_decimal_digits:w})}if(!k){e=n(e);let[r,i]=e.includes("/")?e.split("/"):s(e);[r,i]=m(r,i);let o=p(t,i,{imaginary:v}),a=f(r,o);return"number"==typeof w&&(a=y(a,{digits:w})),"-"===E&&(a=d(a,{fraction:x,max_decimal_digits:w})),a}}t.exports=b,t.exports.default=b},function(t,e,r){"use strict";const n=r(52),i=r(159);function o(t,{digits:e=0}={}){return n(t)?i(t.substring(0,t.length-1),{digits:e})+"i":i(t,{digits:e})}t.exports=o,t.exports.default=o},function(t,e,r){"use strict";const n=r(4),i=r(0),o=r(5),s=r(82),a=r(16),u=r(80),c=r(54),l=r(83);function f(t,e,{imaginary:r=!0,max_decimal_digits:f=100}={}){if(t=i(t),"1"===(e=i(e)))return t;if("1"===t)return"1";if(!a(e))throw new Error("[preciso] can\'t find fractional roots");if(u(e))throw new Error("[preciso] can\'t find root of negative indexes");const h=n(t),d=u(t),p=s(e),y=d&&p;if(y&&!r)throw new Error("[preciso] root has an imaginary number");const g=d&&!p?"-":"",m=l(h,e),b=["9","8","7","6","5","4","3","2","1","0"];let v="";for(let t=0;t<m;t++)for(let r=0;r<b.length;r++){const n=v+b[r];let i=n+"0".repeat(m-t-1);const s=c(i,e),a=o(s,h);if("="===a)return y&&(i+="i"),g+i;if("<"===a){v=n;break}}let w=v+".";for(let t=0;t<f;t++){let t=!1;for(let r=0;r<b.length;r++){let n=w+b[r];const i=c(n,e),s=o(i,h);if("="===s)return y&&(n+="i"),g+n;if("<"===s){w=n,t=!0;break}}if(!t)break}return y&&(w+="i"),g+w}t.exports=f,t.exports.default=f},function(t,e,r){r(18);function n(t,e){const r=t.length,n=e.length,i=t.indexOf("."),o=e.indexOf("."),s=-1===i?r:i,a=-1===o?n:o,u=s-a;let c=u<0?-1*u:0,l=u<=0?0:u,f=Math.max(s,a)+1+Math.max(r-s,n-a)-1,h=0;for(;h<f;){const r=h-c,n=r===s?".":t[r]||"0",i=h-l,o=i===a?".":e[i]||"0";if(n!==o){if(n>o)return">";if(n<o)return"<"}h++}return"="}t.exports=n,t.exports.default=n},function(t,e,r){"use strict";var n=r(135);function i(){this.protocol=null,this.slashes=null,this.auth=null,this.host=null,this.port=null,this.hostname=null,this.hash=null,this.search=null,this.query=null,this.pathname=null,this.path=null,this.href=null}var o=/^([a-z0-9.+-]+:)/i,s=/:[0-9]*$/,a=/^(\\/\\/?(?!\\/)[^?\\s]*)(\\?[^\\s]*)?$/,u=["{","}","|","\\\\","^","`"].concat(["<",">",\'"\',"`"," ","\\r","\\n","\\t"]),c=["\'"].concat(u),l=["%","/","?",";","#"].concat(c),f=["/","?","#"],h=/^[+a-z0-9A-Z_-]{0,63}$/,d=/^([+a-z0-9A-Z_-]{0,63})(.*)$/,p={javascript:!0,"javascript:":!0},y={javascript:!0,"javascript:":!0},g={http:!0,https:!0,ftp:!0,gopher:!0,file:!0,"http:":!0,"https:":!0,"ftp:":!0,"gopher:":!0,"file:":!0},m=r(137);function b(t,e,r){if(t&&"object"==typeof t&&t instanceof i)return t;var n=new i;return n.parse(t,e,r),n}i.prototype.parse=function(t,e,r){if("string"!=typeof t)throw new TypeError("Parameter \'url\' must be a string, not "+typeof t);var i=t.indexOf("?"),s=-1!==i&&i<t.indexOf("#")?"?":"#",u=t.split(s);u[0]=u[0].replace(/\\\\/g,"/");var b=t=u.join(s);if(b=b.trim(),!r&&1===t.split("#").length){var v=a.exec(b);if(v)return this.path=b,this.href=b,this.pathname=v[1],v[2]?(this.search=v[2],this.query=e?m.parse(this.search.substr(1)):this.search.substr(1)):e&&(this.search="",this.query={}),this}var w=o.exec(b);if(w){var x=(w=w[0]).toLowerCase();this.protocol=x,b=b.substr(w.length)}if(r||w||b.match(/^\\/\\/[^@/]+@[^@/]+/)){var _="//"===b.substr(0,2);!_||w&&y[w]||(b=b.substr(2),this.slashes=!0)}if(!y[w]&&(_||w&&!g[w])){for(var S,A,E=-1,k=0;k<f.length;k++){-1!==(T=b.indexOf(f[k]))&&(-1===E||T<E)&&(E=T)}-1!==(A=-1===E?b.lastIndexOf("@"):b.lastIndexOf("@",E))&&(S=b.slice(0,A),b=b.slice(A+1),this.auth=decodeURIComponent(S)),E=-1;for(k=0;k<l.length;k++){var T;-1!==(T=b.indexOf(l[k]))&&(-1===E||T<E)&&(E=T)}-1===E&&(E=b.length),this.host=b.slice(0,E),b=b.slice(E),this.parseHost(),this.hostname=this.hostname||"";var C="["===this.hostname[0]&&"]"===this.hostname[this.hostname.length-1];if(!C)for(var O=this.hostname.split(/\\./),I=(k=0,O.length);k<I;k++){var P=O[k];if(P&&!P.match(h)){for(var R="",j=0,M=P.length;j<M;j++)P.charCodeAt(j)>127?R+="x":R+=P[j];if(!R.match(h)){var L=O.slice(0,k),F=O.slice(k+1),N=P.match(d);N&&(L.push(N[1]),F.unshift(N[2])),F.length&&(b="/"+F.join(".")+b),this.hostname=L.join(".");break}}}this.hostname.length>255?this.hostname="":this.hostname=this.hostname.toLowerCase(),C||(this.hostname=n.toASCII(this.hostname));var D=this.port?":"+this.port:"",U=this.hostname||"";this.host=U+D,this.href+=this.host,C&&(this.hostname=this.hostname.substr(1,this.hostname.length-2),"/"!==b[0]&&(b="/"+b))}if(!p[x])for(k=0,I=c.length;k<I;k++){var B=c[k];if(-1!==b.indexOf(B)){var G=encodeURIComponent(B);G===B&&(G=escape(B)),b=b.split(B).join(G)}}var q=b.indexOf("#");-1!==q&&(this.hash=b.substr(q),b=b.slice(0,q));var z=b.indexOf("?");if(-1!==z?(this.search=b.substr(z),this.query=b.substr(z+1),e&&(this.query=m.parse(this.query)),b=b.slice(0,z)):e&&(this.search="",this.query={}),b&&(this.pathname=b),g[x]&&this.hostname&&!this.pathname&&(this.pathname="/"),this.pathname||this.search){D=this.pathname||"";var H=this.search||"";this.path=D+H}return this.href=this.format(),this},i.prototype.format=function(){var t=this.auth||"";t&&(t=(t=encodeURIComponent(t)).replace(/%3A/i,":"),t+="@");var e=this.protocol||"",r=this.pathname||"",n=this.hash||"",i=!1,o="";this.host?i=t+this.host:this.hostname&&(i=t+(-1===this.hostname.indexOf(":")?this.hostname:"["+this.hostname+"]"),this.port&&(i+=":"+this.port)),this.query&&"object"==typeof this.query&&Object.keys(this.query).length&&(o=m.stringify(this.query));var s=this.search||o&&"?"+o||"";return e&&":"!==e.substr(-1)&&(e+=":"),this.slashes||(!e||g[e])&&!1!==i?(i="//"+(i||""),r&&"/"!==r.charAt(0)&&(r="/"+r)):i||(i=""),n&&"#"!==n.charAt(0)&&(n="#"+n),s&&"?"!==s.charAt(0)&&(s="?"+s),e+i+(r=r.replace(/[?#]/g,(function(t){return encodeURIComponent(t)})))+(s=s.replace("#","%23"))+n},i.prototype.resolve=function(t){return this.resolveObject(b(t,!1,!0)).format()},i.prototype.resolveObject=function(t){if("string"==typeof t){var e=new i;e.parse(t,!1,!0),t=e}for(var r=new i,n=Object.keys(this),o=0;o<n.length;o++){var s=n[o];r[s]=this[s]}if(r.hash=t.hash,""===t.href)return r.href=r.format(),r;if(t.slashes&&!t.protocol){for(var a=Object.keys(t),u=0;u<a.length;u++){var c=a[u];"protocol"!==c&&(r[c]=t[c])}return g[r.protocol]&&r.hostname&&!r.pathname&&(r.pathname="/",r.path=r.pathname),r.href=r.format(),r}if(t.protocol&&t.protocol!==r.protocol){if(!g[t.protocol]){for(var l=Object.keys(t),f=0;f<l.length;f++){var h=l[f];r[h]=t[h]}return r.href=r.format(),r}if(r.protocol=t.protocol,t.host||y[t.protocol])r.pathname=t.pathname;else{for(var d=(t.pathname||"").split("/");d.length&&!(t.host=d.shift()););t.host||(t.host=""),t.hostname||(t.hostname=""),""!==d[0]&&d.unshift(""),d.length<2&&d.unshift(""),r.pathname=d.join("/")}if(r.search=t.search,r.query=t.query,r.host=t.host||"",r.auth=t.auth,r.hostname=t.hostname||t.host,r.port=t.port,r.pathname||r.search){var p=r.pathname||"",m=r.search||"";r.path=p+m}return r.slashes=r.slashes||t.slashes,r.href=r.format(),r}var b=r.pathname&&"/"===r.pathname.charAt(0),v=t.host||t.pathname&&"/"===t.pathname.charAt(0),w=v||b||r.host&&t.pathname,x=w,_=r.pathname&&r.pathname.split("/")||[],S=(d=t.pathname&&t.pathname.split("/")||[],r.protocol&&!g[r.protocol]);if(S&&(r.hostname="",r.port=null,r.host&&(""===_[0]?_[0]=r.host:_.unshift(r.host)),r.host="",t.protocol&&(t.hostname=null,t.port=null,t.host&&(""===d[0]?d[0]=t.host:d.unshift(t.host)),t.host=null),w=w&&(""===d[0]||""===_[0])),v)r.host=t.host||""===t.host?t.host:r.host,r.hostname=t.hostname||""===t.hostname?t.hostname:r.hostname,r.search=t.search,r.query=t.query,_=d;else if(d.length)_||(_=[]),_.pop(),_=_.concat(d),r.search=t.search,r.query=t.query;else if(null!=t.search){if(S)r.host=_.shift(),r.hostname=r.host,(C=!!(r.host&&r.host.indexOf("@")>0)&&r.host.split("@"))&&(r.auth=C.shift(),r.hostname=C.shift(),r.host=r.hostname);return r.search=t.search,r.query=t.query,null===r.pathname&&null===r.search||(r.path=(r.pathname?r.pathname:"")+(r.search?r.search:"")),r.href=r.format(),r}if(!_.length)return r.pathname=null,r.search?r.path="/"+r.search:r.path=null,r.href=r.format(),r;for(var A=_.slice(-1)[0],E=(r.host||t.host||_.length>1)&&("."===A||".."===A)||""===A,k=0,T=_.length;T>=0;T--)"."===(A=_[T])?_.splice(T,1):".."===A?(_.splice(T,1),k++):k&&(_.splice(T,1),k--);if(!w&&!x)for(;k--;k)_.unshift("..");!w||""===_[0]||_[0]&&"/"===_[0].charAt(0)||_.unshift(""),E&&"/"!==_.join("/").substr(-1)&&_.push("");var C,O=""===_[0]||_[0]&&"/"===_[0].charAt(0);S&&(r.hostname=O?"":_.length?_.shift():"",r.host=r.hostname,(C=!!(r.host&&r.host.indexOf("@")>0)&&r.host.split("@"))&&(r.auth=C.shift(),r.hostname=C.shift(),r.host=r.hostname));return(w=w||r.host&&_.length)&&!O&&_.unshift(""),_.length>0?r.pathname=_.join("/"):(r.pathname=null,r.path=null),null===r.pathname&&null===r.search||(r.path=(r.pathname?r.pathname:"")+(r.search?r.search:"")),r.auth=t.auth||r.auth,r.slashes=r.slashes||t.slashes,r.href=r.format(),r},i.prototype.parseHost=function(){var t=this.host,e=s.exec(t);e&&(":"!==(e=e[0])&&(this.port=e.substr(1)),t=t.substr(0,t.length-e.length)),t&&(this.hostname=t)},e.parse=b,e.resolve=function(t,e){return b(t,!1,!0).resolve(e)},e.resolveObject=function(t,e){return t?b(t,!1,!0).resolveObject(e):e},e.format=function(t){return"string"==typeof t&&(t=b(t)),t instanceof i?t.format():i.prototype.format.call(t)},e.Url=i},function(t,e,r){(function(t){var n=r(131),i=r(70),o=r(133),s=r(134),a=r(39),u=e;u.request=function(e,r){e="string"==typeof e?a.parse(e):o(e);var i=-1===t.location.protocol.search(/^https?:$/)?"http:":"",s=e.protocol||i,u=e.hostname||e.host,c=e.port,l=e.path||"/";u&&-1!==u.indexOf(":")&&(u="["+u+"]"),e.url=(u?s+"//"+u:"")+(c?":"+c:"")+l,e.method=(e.method||"GET").toUpperCase(),e.headers=e.headers||{};var f=new n(e);return r&&f.on("response",r),f},u.get=function(t,e){var r=u.request(t,e);return r.end(),r},u.ClientRequest=n,u.IncomingMessage=i.IncomingMessage,u.Agent=function(){},u.Agent.defaultMaxSockets=4,u.globalAgent=new u.Agent,u.STATUS_CODES=s,u.METHODS=["CHECKOUT","CONNECT","COPY","DELETE","GET","HEAD","LOCK","M-SEARCH","MERGE","MKACTIVITY","MKCOL","MOVE","NOTIFY","OPTIONS","PATCH","POST","PROPFIND","PROPPATCH","PURGE","PUT","REPORT","SEARCH","SUBSCRIBE","TRACE","UNLOCK","UNSUBSCRIBE"]}).call(this,r(3))},,function(t,e,r){(e=t.exports=r(60)).Stream=e,e.Readable=e,e.Writable=r(65),e.Duplex=r(14),e.Transform=r(67),e.PassThrough=r(117)},function(t,e,r){var n=r(9),i=n.Buffer;function o(t,e){for(var r in t)e[r]=t[r]}function s(t,e,r){return i(t,e,r)}i.from&&i.alloc&&i.allocUnsafe&&i.allocUnsafeSlow?t.exports=n:(o(n,e),e.Buffer=s),o(i,s),s.from=function(t,e,r){if("number"==typeof t)throw new TypeError("Argument must not be a number");return i(t,e,r)},s.alloc=function(t,e,r){if("number"!=typeof t)throw new TypeError("Argument must be a number");var n=i(t);return void 0!==e?"string"==typeof r?n.fill(e,r):n.fill(e):n.fill(0),n},s.allocUnsafe=function(t){if("number"!=typeof t)throw new TypeError("Argument must be a number");return i(t)},s.allocUnsafeSlow=function(t){if("number"!=typeof t)throw new TypeError("Argument must be a number");return n.SlowBuffer(t)}},function(t,e,r){"use strict";var n=SyntaxError,i=Function,o=TypeError,s=function(t){try{return i(\'"use strict"; return (\'+t+").constructor;")()}catch(t){}},a=Object.getOwnPropertyDescriptor;if(a)try{a({},"")}catch(t){a=null}var u=function(){throw new o},c=a?function(){try{return u}catch(t){try{return a(arguments,"callee").get}catch(t){return u}}}():u,l=r(140)(),f=r(142)(),h=Object.getPrototypeOf||(f?function(t){return t.__proto__}:null),d={},p="undefined"!=typeof Uint8Array&&h?h(Uint8Array):void 0,y={"%AggregateError%":"undefined"==typeof AggregateError?void 0:AggregateError,"%Array%":Array,"%ArrayBuffer%":"undefined"==typeof ArrayBuffer?void 0:ArrayBuffer,"%ArrayIteratorPrototype%":l&&h?h([][Symbol.iterator]()):void 0,"%AsyncFromSyncIteratorPrototype%":void 0,"%AsyncFunction%":d,"%AsyncGenerator%":d,"%AsyncGeneratorFunction%":d,"%AsyncIteratorPrototype%":d,"%Atomics%":"undefined"==typeof Atomics?void 0:Atomics,"%BigInt%":"undefined"==typeof BigInt?void 0:BigInt,"%BigInt64Array%":"undefined"==typeof BigInt64Array?void 0:BigInt64Array,"%BigUint64Array%":"undefined"==typeof BigUint64Array?void 0:BigUint64Array,"%Boolean%":Boolean,"%DataView%":"undefined"==typeof DataView?void 0:DataView,"%Date%":Date,"%decodeURI%":decodeURI,"%decodeURIComponent%":decodeURIComponent,"%encodeURI%":encodeURI,"%encodeURIComponent%":encodeURIComponent,"%Error%":Error,"%eval%":eval,"%EvalError%":EvalError,"%Float32Array%":"undefined"==typeof Float32Array?void 0:Float32Array,"%Float64Array%":"undefined"==typeof Float64Array?void 0:Float64Array,"%FinalizationRegistry%":"undefined"==typeof FinalizationRegistry?void 0:FinalizationRegistry,"%Function%":i,"%GeneratorFunction%":d,"%Int8Array%":"undefined"==typeof Int8Array?void 0:Int8Array,"%Int16Array%":"undefined"==typeof Int16Array?void 0:Int16Array,"%Int32Array%":"undefined"==typeof Int32Array?void 0:Int32Array,"%isFinite%":isFinite,"%isNaN%":isNaN,"%IteratorPrototype%":l&&h?h(h([][Symbol.iterator]())):void 0,"%JSON%":"object"==typeof JSON?JSON:void 0,"%Map%":"undefined"==typeof Map?void 0:Map,"%MapIteratorPrototype%":"undefined"!=typeof Map&&l&&h?h((new Map)[Symbol.iterator]()):void 0,"%Math%":Math,"%Number%":Number,"%Object%":Object,"%parseFloat%":parseFloat,"%parseInt%":parseInt,"%Promise%":"undefined"==typeof Promise?void 0:Promise,"%Proxy%":"undefined"==typeof Proxy?void 0:Proxy,"%RangeError%":RangeError,"%ReferenceError%":ReferenceError,"%Reflect%":"undefined"==typeof Reflect?void 0:Reflect,"%RegExp%":RegExp,"%Set%":"undefined"==typeof Set?void 0:Set,"%SetIteratorPrototype%":"undefined"!=typeof Set&&l&&h?h((new Set)[Symbol.iterator]()):void 0,"%SharedArrayBuffer%":"undefined"==typeof SharedArrayBuffer?void 0:SharedArrayBuffer,"%String%":String,"%StringIteratorPrototype%":l&&h?h(""[Symbol.iterator]()):void 0,"%Symbol%":l?Symbol:void 0,"%SyntaxError%":n,"%ThrowTypeError%":c,"%TypedArray%":p,"%TypeError%":o,"%Uint8Array%":"undefined"==typeof Uint8Array?void 0:Uint8Array,"%Uint8ClampedArray%":"undefined"==typeof Uint8ClampedArray?void 0:Uint8ClampedArray,"%Uint16Array%":"undefined"==typeof Uint16Array?void 0:Uint16Array,"%Uint32Array%":"undefined"==typeof Uint32Array?void 0:Uint32Array,"%URIError%":URIError,"%WeakMap%":"undefined"==typeof WeakMap?void 0:WeakMap,"%WeakRef%":"undefined"==typeof WeakRef?void 0:WeakRef,"%WeakSet%":"undefined"==typeof WeakSet?void 0:WeakSet};if(h)try{null.error}catch(t){var g=h(h(t));y["%Error.prototype%"]=g}var m={"%ArrayBufferPrototype%":["ArrayBuffer","prototype"],"%ArrayPrototype%":["Array","prototype"],"%ArrayProto_entries%":["Array","prototype","entries"],"%ArrayProto_forEach%":["Array","prototype","forEach"],"%ArrayProto_keys%":["Array","prototype","keys"],"%ArrayProto_values%":["Array","prototype","values"],"%AsyncFunctionPrototype%":["AsyncFunction","prototype"],"%AsyncGenerator%":["AsyncGeneratorFunction","prototype"],"%AsyncGeneratorPrototype%":["AsyncGeneratorFunction","prototype","prototype"],"%BooleanPrototype%":["Boolean","prototype"],"%DataViewPrototype%":["DataView","prototype"],"%DatePrototype%":["Date","prototype"],"%ErrorPrototype%":["Error","prototype"],"%EvalErrorPrototype%":["EvalError","prototype"],"%Float32ArrayPrototype%":["Float32Array","prototype"],"%Float64ArrayPrototype%":["Float64Array","prototype"],"%FunctionPrototype%":["Function","prototype"],"%Generator%":["GeneratorFunction","prototype"],"%GeneratorPrototype%":["GeneratorFunction","prototype","prototype"],"%Int8ArrayPrototype%":["Int8Array","prototype"],"%Int16ArrayPrototype%":["Int16Array","prototype"],"%Int32ArrayPrototype%":["Int32Array","prototype"],"%JSONParse%":["JSON","parse"],"%JSONStringify%":["JSON","stringify"],"%MapPrototype%":["Map","prototype"],"%NumberPrototype%":["Number","prototype"],"%ObjectPrototype%":["Object","prototype"],"%ObjProto_toString%":["Object","prototype","toString"],"%ObjProto_valueOf%":["Object","prototype","valueOf"],"%PromisePrototype%":["Promise","prototype"],"%PromiseProto_then%":["Promise","prototype","then"],"%Promise_all%":["Promise","all"],"%Promise_reject%":["Promise","reject"],"%Promise_resolve%":["Promise","resolve"],"%RangeErrorPrototype%":["RangeError","prototype"],"%ReferenceErrorPrototype%":["ReferenceError","prototype"],"%RegExpPrototype%":["RegExp","prototype"],"%SetPrototype%":["Set","prototype"],"%SharedArrayBufferPrototype%":["SharedArrayBuffer","prototype"],"%StringPrototype%":["String","prototype"],"%SymbolPrototype%":["Symbol","prototype"],"%SyntaxErrorPrototype%":["SyntaxError","prototype"],"%TypedArrayPrototype%":["TypedArray","prototype"],"%TypeErrorPrototype%":["TypeError","prototype"],"%Uint8ArrayPrototype%":["Uint8Array","prototype"],"%Uint8ClampedArrayPrototype%":["Uint8ClampedArray","prototype"],"%Uint16ArrayPrototype%":["Uint16Array","prototype"],"%Uint32ArrayPrototype%":["Uint32Array","prototype"],"%URIErrorPrototype%":["URIError","prototype"],"%WeakMapPrototype%":["WeakMap","prototype"],"%WeakSetPrototype%":["WeakSet","prototype"]},b=r(45),v=r(144),w=b.call(Function.call,Array.prototype.concat),x=b.call(Function.apply,Array.prototype.splice),_=b.call(Function.call,String.prototype.replace),S=b.call(Function.call,String.prototype.slice),A=b.call(Function.call,RegExp.prototype.exec),E=/[^%.[\\]]+|\\[(?:(-?\\d+(?:\\.\\d+)?)|(["\'])((?:(?!\\2)[^\\\\]|\\\\.)*?)\\2)\\]|(?=(?:\\.|\\[\\])(?:\\.|\\[\\]|%$))/g,k=/\\\\(\\\\)?/g,T=function(t){var e=S(t,0,1),r=S(t,-1);if("%"===e&&"%"!==r)throw new n("invalid intrinsic syntax, expected closing `%`");if("%"===r&&"%"!==e)throw new n("invalid intrinsic syntax, expected opening `%`");var i=[];return _(t,E,(function(t,e,r,n){i[i.length]=r?_(n,k,"$1"):e||t})),i},C=function(t,e){var r,i=t;if(v(m,i)&&(i="%"+(r=m[i])[0]+"%"),v(y,i)){var a=y[i];if(a===d&&(a=function t(e){var r;if("%AsyncFunction%"===e)r=s("async function () {}");else if("%GeneratorFunction%"===e)r=s("function* () {}");else if("%AsyncGeneratorFunction%"===e)r=s("async function* () {}");else if("%AsyncGenerator%"===e){var n=t("%AsyncGeneratorFunction%");n&&(r=n.prototype)}else if("%AsyncIteratorPrototype%"===e){var i=t("%AsyncGenerator%");i&&h&&(r=h(i.prototype))}return y[e]=r,r}(i)),void 0===a&&!e)throw new o("intrinsic "+t+" exists, but is not available. Please file an issue!");return{alias:r,name:i,value:a}}throw new n("intrinsic "+t+" does not exist!")};t.exports=function(t,e){if("string"!=typeof t||0===t.length)throw new o("intrinsic name must be a non-empty string");if(arguments.length>1&&"boolean"!=typeof e)throw new o(\'"allowMissing" argument must be a boolean\');if(null===A(/^%?[^%]*%?$/,t))throw new n("`%` may not be present anywhere but at the beginning and end of the intrinsic name");var r=T(t),i=r.length>0?r[0]:"",s=C("%"+i+"%",e),u=s.name,c=s.value,l=!1,f=s.alias;f&&(i=f[0],x(r,w([0,1],f)));for(var h=1,d=!0;h<r.length;h+=1){var p=r[h],g=S(p,0,1),m=S(p,-1);if((\'"\'===g||"\'"===g||"`"===g||\'"\'===m||"\'"===m||"`"===m)&&g!==m)throw new n("property names with quotes must have matching quotes");if("constructor"!==p&&d||(l=!0),v(y,u="%"+(i+="."+p)+"%"))c=y[u];else if(null!=c){if(!(p in c)){if(!e)throw new o("base intrinsic for "+t+" exists, but the property is not available.");return}if(a&&h+1>=r.length){var b=a(c,p);c=(d=!!b)&&"get"in b&&!("originalValue"in b.get)?b.get:c[p]}else d=v(c,p),c=c[p];d&&!l&&(y[u]=c)}}return c}},function(t,e,r){"use strict";var n=r(143);t.exports=Function.prototype.bind||n},function(t,e,r){"use strict";var n=String.prototype.replace,i=/%20/g,o="RFC1738",s="RFC3986";t.exports={default:s,formatters:{RFC1738:function(t){return n.call(t,i,"+")},RFC3986:function(t){return String(t)}},RFC1738:o,RFC3986:s}},function(t,e,r){"use strict";const n=r(5),i=r(11),o=r(48),s=r(8);function a(t,e,r="1"){if(i(t))return"0";let a=t,u=t;for(;"<"===n(u,e);)u=s(u,r),a=o(a,u);return a}t.exports=a,t.exports.default=a},function(t,e,r){"use strict";const{MAX_SAFE_INTEGER_LENGTH:n}=r(30);function i(t,e){if("0"===t||"0"===e)return"0";const r=t.indexOf("."),i=e.indexOf("."),o=(-1===r?t.length:r)+(-1===i?e.length:i),s=(-1===r?0:t.length-1-r)+(-1===i?0:e.length-1-i);if(0===s&&o<n)return(Number(t)*Number(e)).toFixed(0);const a=t.replace(".",""),u=e.replace(".",""),c=a.length,l=u.length,f=[];let h=c;for(;h>=0;){const t=h,e=h-=15,r=a.substring(e,t);f.push([Number(r),r.length])}const d=[],p=[];for(let t=0,e=l-1;e>=0;e--,t++){const r=u[e],n=Number(r);let i=0,o="";const s=f.length-1;f.forEach(([t,e],r)=>{let a=(i+n*t).toString();const u=a.length;if(u>e&&r!==s){const t=-1*e;o=a.slice(t)+o,i=Number(a.slice(0,t))}else{const t=e-u;for(let e=0;e<t;e++)a="0"+a;i=0,o=a+o}}),o+="0".repeat(t),d.push(o),p.push([Array.from(o).map(t=>Number(t)),o.length])}const y=d.length,g=p[p.length-1][1]+y;let m="",b=0;for(let t=0;t<g;t++){let e=b;const r=Math.min(t,y-1);for(let n=0;n<=r;n++){const[r,i]=p[n],o=i-1-t;o>=0&&(e+=r[o])}e>=10?(e=e.toString(),m=e[e.length-1]+m,b=Number(e.slice(0,-1))):(m=e+m,b=0)}if(0===s)m=m.replace(/^0+/,"");else{const t=m.length-s;m=m.substring(0,t)+"."+m.substring(t),m=m.replace(/^0+/,""),m=m.replace(/\\.?0+$/,""),"."===m[0]&&(m="0"+m)}return m}t.exports=i,t.exports.default=i},function(t,e,r){"use strict";const n=r(6),i=r(155),o=["5","6","7","8","9"];function s(t){if(t.match(/\\.9+$/))return n(i(t),"1");"+"===t[0]&&(t=t.substring(1));const e=t.length;let r="";const s=t[t.length-1];if(o.includes(s)){let n;for(n=e-2;n>=0;n--){const e=t[n];if("."===e||"-"===e)continue;const i=Number(e)+1;if(10!==i){r=i+r;break}r="0"+r}n>0&&(r=t.substring(0,n)+r)}else r=t.substring(0,e-1);return"."===r[r.length-1]&&(r=r.substring(0,r.length-1)),r.indexOf(".")>-1&&(r=r.replace(/0+$/,"")),r}t.exports=s,t.exports.default=s},function(t,e,r){"use strict";function n(t){return"-"===t[0]?"-":"+"}t.exports=n,t.exports.default=n},function(t,e,r){"use strict";const n=r(0);function i(t){const e=(t=n(t)).indexOf(".");return-1===e?"0":(t.length-e-1).toString()}t.exports=i,t.exports.default=i},function(t,e,r){"use strict";function n(t){return t.includes("i")}t.exports=n,t.exports.default=n},function(t,e,r){"use strict";const n=r(79);function i(){const t=Array.from(arguments),e="object"==typeof t[t.length-1]?t[t.length-1]:void 0,r=Array.isArray(t[0])?t[0]:e?t.slice(0,t.length-1):t;return n(r,e)}t.exports=i,t.exports.default=i},function(t,e,r){"use strict";const n=r(17);function i(t,e){const r=Number(e);let i=t;for(let e=1;e<r;e++)i=n([i,t]);return i}t.exports=i,t.exports.default=i},function(t,e,r){"use strict";const n=r(6);function i(t){let e="0";for(let r of t)e=n(e,r);return e}t.exports=i,t.exports.default=i},function(t,e){const r=9007199254740991..toString().length-1;t.exports={MAX_SAFE_INTEGER:9007199254740991,MAX_SAFE_INTEGER_LENGTH:r}},function(t,e,r){"use strict";(function(t){r.d(e,"a",(function(){return m}));var n=r(12),i=r.n(n),o=r(26),s=r(13),a=r(103),u=r(2),c=r(27),l=r(59),f=function(t,e,r,n){return new(r||(r=Promise))((function(i,o){function s(t){try{u(n.next(t))}catch(t){o(t)}}function a(t){try{u(n.throw(t))}catch(t){o(t)}}function u(t){var e;t.done?i(t.value):(e=t.value,e instanceof r?e:new r((function(t){t(e)}))).then(s,a)}u((n=n.apply(t,e||[])).next())}))};const h=i()("threads:master:messages"),d=i()("threads:master:spawn"),p=i()("threads:master:thread-utils"),y=void 0!==t&&t.env.THREADS_WORKER_INIT_TIMEOUT?Number.parseInt(t.env.THREADS_WORKER_INIT_TIMEOUT,10):1e4;function g(t,e,r,n){const i=r.filter(t=>t.type===c.a.internalError).map(t=>t.error);return Object.assign(t,{[u.a]:i,[u.b]:r,[u.c]:n,[u.e]:e})}function m(t,e){return f(this,void 0,void 0,(function*(){d("Initializing new thread");const r=e&&e.timeout?e.timeout:y,n=(yield function(t,e,r){return f(this,void 0,void 0,(function*(){let n;const i=new Promise((t,i)=>{n=setTimeout(()=>i(Error(r)),e)}),o=yield Promise.race([t,i]);return clearTimeout(n),o}))}(function(t){return new Promise((e,r)=>{const n=i=>{var o;h("Message from worker before finishing initialization:",i.data),(o=i.data)&&"init"===o.type?(t.removeEventListener("message",n),e(i.data)):(t=>t&&"uncaughtError"===t.type)(i.data)&&(t.removeEventListener("message",n),r(Object(s.a)(i.data.error)))};t.addEventListener("message",n)})}(t),r,`Timeout: Did not receive an init message from worker after ${r}ms. Make sure the worker calls expose().`)).exposed,{termination:i,terminate:u}=function(t){const[e,r]=Object(a.a)();return{terminate:()=>f(this,void 0,void 0,(function*(){p("Terminating worker"),yield t.terminate(),r()})),termination:e}}(t),m=function(t,e){return new o.a(r=>{const n=t=>{const e={type:c.a.message,data:t.data};r.next(e)},i=t=>{p("Unhandled promise rejection event in thread:",t);const e={type:c.a.internalError,error:Error(t.reason)};r.next(e)};t.addEventListener("message",n),t.addEventListener("unhandledrejection",i),e.then(()=>{const e={type:c.a.termination};t.removeEventListener("message",n),t.removeEventListener("unhandledrejection",i),r.next(e),r.complete()})})}(t,i);if("function"===n.type){return g(Object(l.a)(t),t,m,u)}if("module"===n.type){return g(Object(l.b)(t,n.methods),t,m,u)}{const t=n.type;throw Error("Worker init message states unexpected type of expose(): "+t)}}))}}).call(this,r(7))},function(t,e,r){"use strict";r.d(e,"a",(function(){return g}));var n=r(12),i=r.n(n),o=r(102),s=r(197),a=r(26);function u(t){return Promise.all(t.map(t=>{const e=t=>({status:"fulfilled",value:t}),r=t=>({status:"rejected",reason:t}),n=Promise.resolve(t);try{return n.then(e,r)}catch(t){return Promise.reject(t)}}))}var c,l=r(19);!function(t){t.initialized="initialized",t.taskCanceled="taskCanceled",t.taskCompleted="taskCompleted",t.taskFailed="taskFailed",t.taskQueued="taskQueued",t.taskQueueDrained="taskQueueDrained",t.taskStart="taskStart",t.terminated="terminated"}(c||(c={}));var f=r(24),h=function(t,e,r,n){return new(r||(r=Promise))((function(i,o){function s(t){try{u(n.next(t))}catch(t){o(t)}}function a(t){try{u(n.throw(t))}catch(t){o(t)}}function u(t){var e;t.done?i(t.value):(e=t.value,e instanceof r?e:new r((function(t){t(e)}))).then(s,a)}u((n=n.apply(t,e||[])).next())}))};let d=1;class p{constructor(t,e){this.eventSubject=new o.a,this.initErrors=[],this.isClosing=!1,this.nextTaskID=1,this.taskQueue=[];const r="number"==typeof e?{size:e}:e||{},{size:n=l.a}=r;this.debug=i()("threads:pool:"+(r.name||String(d++)).replace(/\\W/g," ").trim().replace(/\\s+/g,"-")),this.options=r,this.workers=function(t,e){return function(t){const e=[];for(let r=0;r<t;r++)e.push(r);return e}(e).map(()=>({init:t(),runningTasks:[]}))}(t,n),this.eventObservable=Object(s.a)(a.a.from(this.eventSubject)),Promise.all(this.workers.map(t=>t.init)).then(()=>this.eventSubject.next({type:c.initialized,size:this.workers.length}),t=>{this.debug("Error while initializing pool worker:",t),this.eventSubject.error(t),this.initErrors.push(t)})}findIdlingWorker(){const{concurrency:t=1}=this.options;return this.workers.find(e=>e.runningTasks.length<t)}runPoolTask(t,e){return h(this,void 0,void 0,(function*(){const r=this.workers.indexOf(t)+1;this.debug(`Running task #${e.id} on worker #${r}...`),this.eventSubject.next({type:c.taskStart,taskID:e.id,workerID:r});try{const n=yield e.run(yield t.init);this.debug(`Task #${e.id} completed successfully`),this.eventSubject.next({type:c.taskCompleted,returnValue:n,taskID:e.id,workerID:r})}catch(t){this.debug(`Task #${e.id} failed`),this.eventSubject.next({type:c.taskFailed,taskID:e.id,error:t,workerID:r})}}))}run(t,e){return h(this,void 0,void 0,(function*(){const r=(()=>h(this,void 0,void 0,(function*(){var n;yield(n=0,new Promise(t=>setTimeout(t,n)));try{yield this.runPoolTask(t,e)}finally{t.runningTasks=t.runningTasks.filter(t=>t!==r),this.isClosing||this.scheduleWork()}})))();t.runningTasks.push(r)}))}scheduleWork(){this.debug("Attempt de-queueing a task in order to run it...");const t=this.findIdlingWorker();if(!t)return;const e=this.taskQueue.shift();if(!e)return this.debug("Task queue is empty"),void this.eventSubject.next({type:c.taskQueueDrained});this.run(t,e)}taskCompletion(t){return new Promise((e,r)=>{const n=this.events().subscribe(i=>{i.type===c.taskCompleted&&i.taskID===t?(n.unsubscribe(),e(i.returnValue)):i.type===c.taskFailed&&i.taskID===t?(n.unsubscribe(),r(i.error)):i.type===c.terminated&&(n.unsubscribe(),r(Error("Pool has been terminated before task was run.")))})})}settled(t=!1){return h(this,void 0,void 0,(function*(){const e=()=>{return t=this.workers,e=t=>t.runningTasks,t.reduce((t,r)=>[...t,...e(r)],[]);var t,e},r=[],n=this.eventObservable.subscribe(t=>{t.type===c.taskFailed&&r.push(t.error)});return this.initErrors.length>0?Promise.reject(this.initErrors[0]):t&&0===this.taskQueue.length?(yield u(e()),r):(yield new Promise((t,e)=>{const r=this.eventObservable.subscribe({next(e){e.type===c.taskQueueDrained&&(r.unsubscribe(),t(void 0))},error:e})}),yield u(e()),n.unsubscribe(),r)}))}completed(t=!1){return h(this,void 0,void 0,(function*(){const e=this.settled(t),r=new Promise((t,r)=>{const n=this.eventObservable.subscribe({next(i){i.type===c.taskQueueDrained?(n.unsubscribe(),t(e)):i.type===c.taskFailed&&(n.unsubscribe(),r(i.error))},error:r})}),n=yield Promise.race([e,r]);if(n.length>0)throw n[0]}))}events(){return this.eventObservable}queue(t){const{maxQueuedJobs:e=1/0}=this.options;if(this.isClosing)throw Error("Cannot schedule pool tasks after terminate() has been called.");if(this.initErrors.length>0)throw this.initErrors[0];const r=this.nextTaskID++,n=this.taskCompletion(r);n.catch(t=>{this.debug(`Task #${r} errored:`,t)});const i={id:r,run:t,cancel:()=>{-1!==this.taskQueue.indexOf(i)&&(this.taskQueue=this.taskQueue.filter(t=>t!==i),this.eventSubject.next({type:c.taskCanceled,taskID:i.id}))},then:n.then.bind(n)};if(this.taskQueue.length>=e)throw Error("Maximum number of pool tasks queued. Refusing to queue another one.\\nThis usually happens for one of two reasons: We are either at peak workload right now or some tasks just won\'t finish, thus blocking the pool.");return this.debug(`Queueing task #${i.id}...`),this.taskQueue.push(i),this.eventSubject.next({type:c.taskQueued,taskID:i.id}),this.scheduleWork(),i}terminate(t){return h(this,void 0,void 0,(function*(){this.isClosing=!0,t||(yield this.completed(!0)),this.eventSubject.next({type:c.terminated,remainingQueue:[...this.taskQueue]}),this.eventSubject.complete(),yield Promise.all(this.workers.map(t=>h(this,void 0,void 0,(function*(){return f.a.terminate(yield t.init)}))))}))}}function y(t,e){return new p(t,e)}p.EventType=c,y.EventType=c;const g=y},function(t,e,r){"use strict";r.d(e,"a",(function(){return b})),r.d(e,"b",(function(){return v}));var n=r(12),i=r.n(n),o=r(26),s=r(197),a=r(13);const u=()=>{},c=t=>t,l=t=>Promise.resolve().then(t);function f(t){throw t}class h extends o.a{constructor(t){super(e=>{const r=this,n=Object.assign(Object.assign({},e),{complete(){e.complete(),r.onCompletion()},error(t){e.error(t),r.onError(t)},next(t){e.next(t),r.onNext(t)}});try{return this.initHasRun=!0,t(n)}catch(t){n.error(t)}}),this.initHasRun=!1,this.fulfillmentCallbacks=[],this.rejectionCallbacks=[],this.firstValueSet=!1,this.state="pending"}onNext(t){this.firstValueSet||(this.firstValue=t,this.firstValueSet=!0)}onError(t){this.state="rejected",this.rejection=t;for(const e of this.rejectionCallbacks)l(()=>e(t))}onCompletion(){this.state="fulfilled";for(const t of this.fulfillmentCallbacks)l(()=>t(this.firstValue))}then(t,e){const r=t||c,n=e||f;let i=!1;return new Promise((t,e)=>{const o=r=>{if(!i){i=!0;try{t(n(r))}catch(t){e(t)}}};return this.initHasRun||this.subscribe({error:o}),"fulfilled"===this.state?t(r(this.firstValue)):"rejected"===this.state?(i=!0,t(n(this.rejection))):(this.fulfillmentCallbacks.push(e=>{try{t(r(e))}catch(t){o(t)}}),void this.rejectionCallbacks.push(o))})}catch(t){return this.then(void 0,t)}finally(t){const e=t||u;return this.then(t=>(e(),t),()=>e())}static from(t){return function(t){return t&&"function"==typeof t.then}(t)?new h(e=>{t.then(t=>{e.next(t),e.complete()},t=>{e.error(t)})}):super.from(t)}}var d=r(104),p=r(20);const y=i()("threads:master:messages");let g=1;function m(t,e){return new o.a(r=>{let n;const i=o=>{var s;if(y("Message from worker:",o.data),o.data&&o.data.uid===e)if((s=o.data)&&s.type===p.b.running)n=o.data.resultType;else if((t=>t&&t.type===p.b.result)(o.data))"promise"===n?(void 0!==o.data.payload&&r.next(Object(a.a)(o.data.payload)),r.complete(),t.removeEventListener("message",i)):(o.data.payload&&r.next(Object(a.a)(o.data.payload)),o.data.complete&&(r.complete(),t.removeEventListener("message",i)));else if((t=>t&&t.type===p.b.error)(o.data)){const e=Object(a.a)(o.data.error);r.error(e),t.removeEventListener("message",i)}};return t.addEventListener("message",i),()=>{if("observable"===n||!n){const r={type:p.a.cancel,uid:e};t.postMessage(r)}t.removeEventListener("message",i)}})}function b(t,e){return(...r)=>{const n=g++,{args:i,transferables:o}=function(t){if(0===t.length)return{args:[],transferables:[]};const e=[],r=[];for(const n of t)Object(d.a)(n)?(e.push(Object(a.b)(n.send)),r.push(...n.transferables)):e.push(Object(a.b)(n));return{args:e,transferables:0===r.length?r:(n=r,Array.from(new Set(n)))};var n}(r),u={type:p.a.run,uid:n,method:e,args:i};y("Sending command to run function to worker:",u);try{t.postMessage(u,o)}catch(t){return h.from(Promise.reject(t))}return h.from(Object(s.a)(m(t,n)))}}function v(t,e){const r={};for(const n of e)r[n]=b(t,n);return r}},function(t,e,r){"use strict";(function(e,n){var i=r(28);t.exports=v;var o,s=r(61);v.ReadableState=b;r(62).EventEmitter;var a=function(t,e){return t.listeners(e).length},u=r(63),c=r(43).Buffer,l=(void 0!==e?e:"undefined"!=typeof window?window:"undefined"!=typeof self?self:{}).Uint8Array||function(){};var f=Object.create(r(21));f.inherits=r(10);var h=r(110),d=void 0;d=h&&h.debuglog?h.debuglog("stream"):function(){};var p,y=r(111),g=r(64);f.inherits(v,u);var m=["error","close","destroy","pause","resume"];function b(t,e){t=t||{};var n=e instanceof(o=o||r(14));this.objectMode=!!t.objectMode,n&&(this.objectMode=this.objectMode||!!t.readableObjectMode);var i=t.highWaterMark,s=t.readableHighWaterMark,a=this.objectMode?16:16384;this.highWaterMark=i||0===i?i:n&&(s||0===s)?s:a,this.highWaterMark=Math.floor(this.highWaterMark),this.buffer=new y,this.length=0,this.pipes=null,this.pipesCount=0,this.flowing=null,this.ended=!1,this.endEmitted=!1,this.reading=!1,this.sync=!0,this.needReadable=!1,this.emittedReadable=!1,this.readableListening=!1,this.resumeScheduled=!1,this.destroyed=!1,this.defaultEncoding=t.defaultEncoding||"utf8",this.awaitDrain=0,this.readingMore=!1,this.decoder=null,this.encoding=null,t.encoding&&(p||(p=r(66).StringDecoder),this.decoder=new p(t.encoding),this.encoding=t.encoding)}function v(t){if(o=o||r(14),!(this instanceof v))return new v(t);this._readableState=new b(t,this),this.readable=!0,t&&("function"==typeof t.read&&(this._read=t.read),"function"==typeof t.destroy&&(this._destroy=t.destroy)),u.call(this)}function w(t,e,r,n,i){var o,s=t._readableState;null===e?(s.reading=!1,function(t,e){if(e.ended)return;if(e.decoder){var r=e.decoder.end();r&&r.length&&(e.buffer.push(r),e.length+=e.objectMode?1:r.length)}e.ended=!0,S(t)}(t,s)):(i||(o=function(t,e){var r;n=e,c.isBuffer(n)||n instanceof l||"string"==typeof e||void 0===e||t.objectMode||(r=new TypeError("Invalid non-string/buffer chunk"));var n;return r}(s,e)),o?t.emit("error",o):s.objectMode||e&&e.length>0?("string"==typeof e||s.objectMode||Object.getPrototypeOf(e)===c.prototype||(e=function(t){return c.from(t)}(e)),n?s.endEmitted?t.emit("error",new Error("stream.unshift() after end event")):x(t,s,e,!0):s.ended?t.emit("error",new Error("stream.push() after EOF")):(s.reading=!1,s.decoder&&!r?(e=s.decoder.write(e),s.objectMode||0!==e.length?x(t,s,e,!1):E(t,s)):x(t,s,e,!1))):n||(s.reading=!1));return function(t){return!t.ended&&(t.needReadable||t.length<t.highWaterMark||0===t.length)}(s)}function x(t,e,r,n){e.flowing&&0===e.length&&!e.sync?(t.emit("data",r),t.read(0)):(e.length+=e.objectMode?1:r.length,n?e.buffer.unshift(r):e.buffer.push(r),e.needReadable&&S(t)),E(t,e)}Object.defineProperty(v.prototype,"destroyed",{get:function(){return void 0!==this._readableState&&this._readableState.destroyed},set:function(t){this._readableState&&(this._readableState.destroyed=t)}}),v.prototype.destroy=g.destroy,v.prototype._undestroy=g.undestroy,v.prototype._destroy=function(t,e){this.push(null),e(t)},v.prototype.push=function(t,e){var r,n=this._readableState;return n.objectMode?r=!0:"string"==typeof t&&((e=e||n.defaultEncoding)!==n.encoding&&(t=c.from(t,e),e=""),r=!0),w(this,t,e,!1,r)},v.prototype.unshift=function(t){return w(this,t,null,!0,!1)},v.prototype.isPaused=function(){return!1===this._readableState.flowing},v.prototype.setEncoding=function(t){return p||(p=r(66).StringDecoder),this._readableState.decoder=new p(t),this._readableState.encoding=t,this};function _(t,e){return t<=0||0===e.length&&e.ended?0:e.objectMode?1:t!=t?e.flowing&&e.length?e.buffer.head.data.length:e.length:(t>e.highWaterMark&&(e.highWaterMark=function(t){return t>=8388608?t=8388608:(t--,t|=t>>>1,t|=t>>>2,t|=t>>>4,t|=t>>>8,t|=t>>>16,t++),t}(t)),t<=e.length?t:e.ended?e.length:(e.needReadable=!0,0))}function S(t){var e=t._readableState;e.needReadable=!1,e.emittedReadable||(d("emitReadable",e.flowing),e.emittedReadable=!0,e.sync?i.nextTick(A,t):A(t))}function A(t){d("emit readable"),t.emit("readable"),O(t)}function E(t,e){e.readingMore||(e.readingMore=!0,i.nextTick(k,t,e))}function k(t,e){for(var r=e.length;!e.reading&&!e.flowing&&!e.ended&&e.length<e.highWaterMark&&(d("maybeReadMore read 0"),t.read(0),r!==e.length);)r=e.length;e.readingMore=!1}function T(t){d("readable nexttick read 0"),t.read(0)}function C(t,e){e.reading||(d("resume read 0"),t.read(0)),e.resumeScheduled=!1,e.awaitDrain=0,t.emit("resume"),O(t),e.flowing&&!e.reading&&t.read(0)}function O(t){var e=t._readableState;for(d("flow",e.flowing);e.flowing&&null!==t.read(););}function I(t,e){return 0===e.length?null:(e.objectMode?r=e.buffer.shift():!t||t>=e.length?(r=e.decoder?e.buffer.join(""):1===e.buffer.length?e.buffer.head.data:e.buffer.concat(e.length),e.buffer.clear()):r=function(t,e,r){var n;t<e.head.data.length?(n=e.head.data.slice(0,t),e.head.data=e.head.data.slice(t)):n=t===e.head.data.length?e.shift():r?function(t,e){var r=e.head,n=1,i=r.data;t-=i.length;for(;r=r.next;){var o=r.data,s=t>o.length?o.length:t;if(s===o.length?i+=o:i+=o.slice(0,t),0===(t-=s)){s===o.length?(++n,r.next?e.head=r.next:e.head=e.tail=null):(e.head=r,r.data=o.slice(s));break}++n}return e.length-=n,i}(t,e):function(t,e){var r=c.allocUnsafe(t),n=e.head,i=1;n.data.copy(r),t-=n.data.length;for(;n=n.next;){var o=n.data,s=t>o.length?o.length:t;if(o.copy(r,r.length-t,0,s),0===(t-=s)){s===o.length?(++i,n.next?e.head=n.next:e.head=e.tail=null):(e.head=n,n.data=o.slice(s));break}++i}return e.length-=i,r}(t,e);return n}(t,e.buffer,e.decoder),r);var r}function P(t){var e=t._readableState;if(e.length>0)throw new Error(\'"endReadable()" called on non-empty stream\');e.endEmitted||(e.ended=!0,i.nextTick(R,e,t))}function R(t,e){t.endEmitted||0!==t.length||(t.endEmitted=!0,e.readable=!1,e.emit("end"))}function j(t,e){for(var r=0,n=t.length;r<n;r++)if(t[r]===e)return r;return-1}v.prototype.read=function(t){d("read",t),t=parseInt(t,10);var e=this._readableState,r=t;if(0!==t&&(e.emittedReadable=!1),0===t&&e.needReadable&&(e.length>=e.highWaterMark||e.ended))return d("read: emitReadable",e.length,e.ended),0===e.length&&e.ended?P(this):S(this),null;if(0===(t=_(t,e))&&e.ended)return 0===e.length&&P(this),null;var n,i=e.needReadable;return d("need readable",i),(0===e.length||e.length-t<e.highWaterMark)&&d("length less than watermark",i=!0),e.ended||e.reading?d("reading or ended",i=!1):i&&(d("do read"),e.reading=!0,e.sync=!0,0===e.length&&(e.needReadable=!0),this._read(e.highWaterMark),e.sync=!1,e.reading||(t=_(r,e))),null===(n=t>0?I(t,e):null)?(e.needReadable=!0,t=0):e.length-=t,0===e.length&&(e.ended||(e.needReadable=!0),r!==t&&e.ended&&P(this)),null!==n&&this.emit("data",n),n},v.prototype._read=function(t){this.emit("error",new Error("_read() is not implemented"))},v.prototype.pipe=function(t,e){var r=this,o=this._readableState;switch(o.pipesCount){case 0:o.pipes=t;break;case 1:o.pipes=[o.pipes,t];break;default:o.pipes.push(t)}o.pipesCount+=1,d("pipe count=%d opts=%j",o.pipesCount,e);var u=(!e||!1!==e.end)&&t!==n.stdout&&t!==n.stderr?l:v;function c(e,n){d("onunpipe"),e===r&&n&&!1===n.hasUnpiped&&(n.hasUnpiped=!0,d("cleanup"),t.removeListener("close",m),t.removeListener("finish",b),t.removeListener("drain",f),t.removeListener("error",g),t.removeListener("unpipe",c),r.removeListener("end",l),r.removeListener("end",v),r.removeListener("data",y),h=!0,!o.awaitDrain||t._writableState&&!t._writableState.needDrain||f())}function l(){d("onend"),t.end()}o.endEmitted?i.nextTick(u):r.once("end",u),t.on("unpipe",c);var f=function(t){return function(){var e=t._readableState;d("pipeOnDrain",e.awaitDrain),e.awaitDrain&&e.awaitDrain--,0===e.awaitDrain&&a(t,"data")&&(e.flowing=!0,O(t))}}(r);t.on("drain",f);var h=!1;var p=!1;function y(e){d("ondata"),p=!1,!1!==t.write(e)||p||((1===o.pipesCount&&o.pipes===t||o.pipesCount>1&&-1!==j(o.pipes,t))&&!h&&(d("false write response, pause",o.awaitDrain),o.awaitDrain++,p=!0),r.pause())}function g(e){d("onerror",e),v(),t.removeListener("error",g),0===a(t,"error")&&t.emit("error",e)}function m(){t.removeListener("finish",b),v()}function b(){d("onfinish"),t.removeListener("close",m),v()}function v(){d("unpipe"),r.unpipe(t)}return r.on("data",y),function(t,e,r){if("function"==typeof t.prependListener)return t.prependListener(e,r);t._events&&t._events[e]?s(t._events[e])?t._events[e].unshift(r):t._events[e]=[r,t._events[e]]:t.on(e,r)}(t,"error",g),t.once("close",m),t.once("finish",b),t.emit("pipe",r),o.flowing||(d("pipe resume"),r.resume()),t},v.prototype.unpipe=function(t){var e=this._readableState,r={hasUnpiped:!1};if(0===e.pipesCount)return this;if(1===e.pipesCount)return t&&t!==e.pipes||(t||(t=e.pipes),e.pipes=null,e.pipesCount=0,e.flowing=!1,t&&t.emit("unpipe",this,r)),this;if(!t){var n=e.pipes,i=e.pipesCount;e.pipes=null,e.pipesCount=0,e.flowing=!1;for(var o=0;o<i;o++)n[o].emit("unpipe",this,{hasUnpiped:!1});return this}var s=j(e.pipes,t);return-1===s||(e.pipes.splice(s,1),e.pipesCount-=1,1===e.pipesCount&&(e.pipes=e.pipes[0]),t.emit("unpipe",this,r)),this},v.prototype.on=function(t,e){var r=u.prototype.on.call(this,t,e);if("data"===t)!1!==this._readableState.flowing&&this.resume();else if("readable"===t){var n=this._readableState;n.endEmitted||n.readableListening||(n.readableListening=n.needReadable=!0,n.emittedReadable=!1,n.reading?n.length&&S(this):i.nextTick(T,this))}return r},v.prototype.addListener=v.prototype.on,v.prototype.resume=function(){var t=this._readableState;return t.flowing||(d("resume"),t.flowing=!0,function(t,e){e.resumeScheduled||(e.resumeScheduled=!0,i.nextTick(C,t,e))}(this,t)),this},v.prototype.pause=function(){return d("call pause flowing=%j",this._readableState.flowing),!1!==this._readableState.flowing&&(d("pause"),this._readableState.flowing=!1,this.emit("pause")),this},v.prototype.wrap=function(t){var e=this,r=this._readableState,n=!1;for(var i in t.on("end",(function(){if(d("wrapped end"),r.decoder&&!r.ended){var t=r.decoder.end();t&&t.length&&e.push(t)}e.push(null)})),t.on("data",(function(i){(d("wrapped data"),r.decoder&&(i=r.decoder.write(i)),r.objectMode&&null==i)||(r.objectMode||i&&i.length)&&(e.push(i)||(n=!0,t.pause()))})),t)void 0===this[i]&&"function"==typeof t[i]&&(this[i]=function(e){return function(){return t[e].apply(t,arguments)}}(i));for(var o=0;o<m.length;o++)t.on(m[o],this.emit.bind(this,m[o]));return this._read=function(e){d("wrapped _read",e),n&&(n=!1,t.resume())},this},Object.defineProperty(v.prototype,"readableHighWaterMark",{enumerable:!1,get:function(){return this._readableState.highWaterMark}}),v._fromList=I}).call(this,r(3),r(7))},function(t,e){var r={}.toString;t.exports=Array.isArray||function(t){return"[object Array]"==r.call(t)}},function(t,e,r){"use strict";var n,i="object"==typeof Reflect?Reflect:null,o=i&&"function"==typeof i.apply?i.apply:function(t,e,r){return Function.prototype.apply.call(t,e,r)};n=i&&"function"==typeof i.ownKeys?i.ownKeys:Object.getOwnPropertySymbols?function(t){return Object.getOwnPropertyNames(t).concat(Object.getOwnPropertySymbols(t))}:function(t){return Object.getOwnPropertyNames(t)};var s=Number.isNaN||function(t){return t!=t};function a(){a.init.call(this)}t.exports=a,t.exports.once=function(t,e){return new Promise((function(r,n){function i(r){t.removeListener(e,o),n(r)}function o(){"function"==typeof t.removeListener&&t.removeListener("error",i),r([].slice.call(arguments))}m(t,e,o,{once:!0}),"error"!==e&&function(t,e,r){"function"==typeof t.on&&m(t,"error",e,r)}(t,i,{once:!0})}))},a.EventEmitter=a,a.prototype._events=void 0,a.prototype._eventsCount=0,a.prototype._maxListeners=void 0;var u=10;function c(t){if("function"!=typeof t)throw new TypeError(\'The "listener" argument must be of type Function. Received type \'+typeof t)}function l(t){return void 0===t._maxListeners?a.defaultMaxListeners:t._maxListeners}function f(t,e,r,n){var i,o,s,a;if(c(r),void 0===(o=t._events)?(o=t._events=Object.create(null),t._eventsCount=0):(void 0!==o.newListener&&(t.emit("newListener",e,r.listener?r.listener:r),o=t._events),s=o[e]),void 0===s)s=o[e]=r,++t._eventsCount;else if("function"==typeof s?s=o[e]=n?[r,s]:[s,r]:n?s.unshift(r):s.push(r),(i=l(t))>0&&s.length>i&&!s.warned){s.warned=!0;var u=new Error("Possible EventEmitter memory leak detected. "+s.length+" "+String(e)+" listeners added. Use emitter.setMaxListeners() to increase limit");u.name="MaxListenersExceededWarning",u.emitter=t,u.type=e,u.count=s.length,a=u,console&&console.warn&&console.warn(a)}return t}function h(){if(!this.fired)return this.target.removeListener(this.type,this.wrapFn),this.fired=!0,0===arguments.length?this.listener.call(this.target):this.listener.apply(this.target,arguments)}function d(t,e,r){var n={fired:!1,wrapFn:void 0,target:t,type:e,listener:r},i=h.bind(n);return i.listener=r,n.wrapFn=i,i}function p(t,e,r){var n=t._events;if(void 0===n)return[];var i=n[e];return void 0===i?[]:"function"==typeof i?r?[i.listener||i]:[i]:r?function(t){for(var e=new Array(t.length),r=0;r<e.length;++r)e[r]=t[r].listener||t[r];return e}(i):g(i,i.length)}function y(t){var e=this._events;if(void 0!==e){var r=e[t];if("function"==typeof r)return 1;if(void 0!==r)return r.length}return 0}function g(t,e){for(var r=new Array(e),n=0;n<e;++n)r[n]=t[n];return r}function m(t,e,r,n){if("function"==typeof t.on)n.once?t.once(e,r):t.on(e,r);else{if("function"!=typeof t.addEventListener)throw new TypeError(\'The "emitter" argument must be of type EventEmitter. Received type \'+typeof t);t.addEventListener(e,(function i(o){n.once&&t.removeEventListener(e,i),r(o)}))}}Object.defineProperty(a,"defaultMaxListeners",{enumerable:!0,get:function(){return u},set:function(t){if("number"!=typeof t||t<0||s(t))throw new RangeError(\'The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received \'+t+".");u=t}}),a.init=function(){void 0!==this._events&&this._events!==Object.getPrototypeOf(this)._events||(this._events=Object.create(null),this._eventsCount=0),this._maxListeners=this._maxListeners||void 0},a.prototype.setMaxListeners=function(t){if("number"!=typeof t||t<0||s(t))throw new RangeError(\'The value of "n" is out of range. It must be a non-negative number. Received \'+t+".");return this._maxListeners=t,this},a.prototype.getMaxListeners=function(){return l(this)},a.prototype.emit=function(t){for(var e=[],r=1;r<arguments.length;r++)e.push(arguments[r]);var n="error"===t,i=this._events;if(void 0!==i)n=n&&void 0===i.error;else if(!n)return!1;if(n){var s;if(e.length>0&&(s=e[0]),s instanceof Error)throw s;var a=new Error("Unhandled error."+(s?" ("+s.message+")":""));throw a.context=s,a}var u=i[t];if(void 0===u)return!1;if("function"==typeof u)o(u,this,e);else{var c=u.length,l=g(u,c);for(r=0;r<c;++r)o(l[r],this,e)}return!0},a.prototype.addListener=function(t,e){return f(this,t,e,!1)},a.prototype.on=a.prototype.addListener,a.prototype.prependListener=function(t,e){return f(this,t,e,!0)},a.prototype.once=function(t,e){return c(e),this.on(t,d(this,t,e)),this},a.prototype.prependOnceListener=function(t,e){return c(e),this.prependListener(t,d(this,t,e)),this},a.prototype.removeListener=function(t,e){var r,n,i,o,s;if(c(e),void 0===(n=this._events))return this;if(void 0===(r=n[t]))return this;if(r===e||r.listener===e)0==--this._eventsCount?this._events=Object.create(null):(delete n[t],n.removeListener&&this.emit("removeListener",t,r.listener||e));else if("function"!=typeof r){for(i=-1,o=r.length-1;o>=0;o--)if(r[o]===e||r[o].listener===e){s=r[o].listener,i=o;break}if(i<0)return this;0===i?r.shift():function(t,e){for(;e+1<t.length;e++)t[e]=t[e+1];t.pop()}(r,i),1===r.length&&(n[t]=r[0]),void 0!==n.removeListener&&this.emit("removeListener",t,s||e)}return this},a.prototype.off=a.prototype.removeListener,a.prototype.removeAllListeners=function(t){var e,r,n;if(void 0===(r=this._events))return this;if(void 0===r.removeListener)return 0===arguments.length?(this._events=Object.create(null),this._eventsCount=0):void 0!==r[t]&&(0==--this._eventsCount?this._events=Object.create(null):delete r[t]),this;if(0===arguments.length){var i,o=Object.keys(r);for(n=0;n<o.length;++n)"removeListener"!==(i=o[n])&&this.removeAllListeners(i);return this.removeAllListeners("removeListener"),this._events=Object.create(null),this._eventsCount=0,this}if("function"==typeof(e=r[t]))this.removeListener(t,e);else if(void 0!==e)for(n=e.length-1;n>=0;n--)this.removeListener(t,e[n]);return this},a.prototype.listeners=function(t){return p(this,t,!0)},a.prototype.rawListeners=function(t){return p(this,t,!1)},a.listenerCount=function(t,e){return"function"==typeof t.listenerCount?t.listenerCount(e):y.call(t,e)},a.prototype.listenerCount=y,a.prototype.eventNames=function(){return this._eventsCount>0?n(this._events):[]}},function(t,e,r){t.exports=r(62).EventEmitter},function(t,e,r){"use strict";var n=r(28);function i(t,e){t.emit("error",e)}t.exports={destroy:function(t,e){var r=this,o=this._readableState&&this._readableState.destroyed,s=this._writableState&&this._writableState.destroyed;return o||s?(e?e(t):t&&(this._writableState?this._writableState.errorEmitted||(this._writableState.errorEmitted=!0,n.nextTick(i,this,t)):n.nextTick(i,this,t)),this):(this._readableState&&(this._readableState.destroyed=!0),this._writableState&&(this._writableState.destroyed=!0),this._destroy(t||null,(function(t){!e&&t?r._writableState?r._writableState.errorEmitted||(r._writableState.errorEmitted=!0,n.nextTick(i,r,t)):n.nextTick(i,r,t):e&&e(t)})),this)},undestroy:function(){this._readableState&&(this._readableState.destroyed=!1,this._readableState.reading=!1,this._readableState.ended=!1,this._readableState.endEmitted=!1),this._writableState&&(this._writableState.destroyed=!1,this._writableState.ended=!1,this._writableState.ending=!1,this._writableState.finalCalled=!1,this._writableState.prefinished=!1,this._writableState.finished=!1,this._writableState.errorEmitted=!1)}}},function(t,e,r){"use strict";(function(e,n,i){var o=r(28);function s(t){var e=this;this.next=null,this.entry=null,this.finish=function(){!function(t,e,r){var n=t.entry;t.entry=null;for(;n;){var i=n.callback;e.pendingcb--,i(r),n=n.next}e.corkedRequestsFree.next=t}(e,t)}}t.exports=b;var a,u=!e.browser&&["v0.10","v0.9."].indexOf(e.version.slice(0,5))>-1?n:o.nextTick;b.WritableState=m;var c=Object.create(r(21));c.inherits=r(10);var l={deprecate:r(115)},f=r(63),h=r(43).Buffer,d=(void 0!==i?i:"undefined"!=typeof window?window:"undefined"!=typeof self?self:{}).Uint8Array||function(){};var p,y=r(64);function g(){}function m(t,e){a=a||r(14),t=t||{};var n=e instanceof a;this.objectMode=!!t.objectMode,n&&(this.objectMode=this.objectMode||!!t.writableObjectMode);var i=t.highWaterMark,c=t.writableHighWaterMark,l=this.objectMode?16:16384;this.highWaterMark=i||0===i?i:n&&(c||0===c)?c:l,this.highWaterMark=Math.floor(this.highWaterMark),this.finalCalled=!1,this.needDrain=!1,this.ending=!1,this.ended=!1,this.finished=!1,this.destroyed=!1;var f=!1===t.decodeStrings;this.decodeStrings=!f,this.defaultEncoding=t.defaultEncoding||"utf8",this.length=0,this.writing=!1,this.corked=0,this.sync=!0,this.bufferProcessing=!1,this.onwrite=function(t){!function(t,e){var r=t._writableState,n=r.sync,i=r.writecb;if(function(t){t.writing=!1,t.writecb=null,t.length-=t.writelen,t.writelen=0}(r),e)!function(t,e,r,n,i){--e.pendingcb,r?(o.nextTick(i,n),o.nextTick(A,t,e),t._writableState.errorEmitted=!0,t.emit("error",n)):(i(n),t._writableState.errorEmitted=!0,t.emit("error",n),A(t,e))}(t,r,n,e,i);else{var s=_(r);s||r.corked||r.bufferProcessing||!r.bufferedRequest||x(t,r),n?u(w,t,r,s,i):w(t,r,s,i)}}(e,t)},this.writecb=null,this.writelen=0,this.bufferedRequest=null,this.lastBufferedRequest=null,this.pendingcb=0,this.prefinished=!1,this.errorEmitted=!1,this.bufferedRequestCount=0,this.corkedRequestsFree=new s(this)}function b(t){if(a=a||r(14),!(p.call(b,this)||this instanceof a))return new b(t);this._writableState=new m(t,this),this.writable=!0,t&&("function"==typeof t.write&&(this._write=t.write),"function"==typeof t.writev&&(this._writev=t.writev),"function"==typeof t.destroy&&(this._destroy=t.destroy),"function"==typeof t.final&&(this._final=t.final)),f.call(this)}function v(t,e,r,n,i,o,s){e.writelen=n,e.writecb=s,e.writing=!0,e.sync=!0,r?t._writev(i,e.onwrite):t._write(i,o,e.onwrite),e.sync=!1}function w(t,e,r,n){r||function(t,e){0===e.length&&e.needDrain&&(e.needDrain=!1,t.emit("drain"))}(t,e),e.pendingcb--,n(),A(t,e)}function x(t,e){e.bufferProcessing=!0;var r=e.bufferedRequest;if(t._writev&&r&&r.next){var n=e.bufferedRequestCount,i=new Array(n),o=e.corkedRequestsFree;o.entry=r;for(var a=0,u=!0;r;)i[a]=r,r.isBuf||(u=!1),r=r.next,a+=1;i.allBuffers=u,v(t,e,!0,e.length,i,"",o.finish),e.pendingcb++,e.lastBufferedRequest=null,o.next?(e.corkedRequestsFree=o.next,o.next=null):e.corkedRequestsFree=new s(e),e.bufferedRequestCount=0}else{for(;r;){var c=r.chunk,l=r.encoding,f=r.callback;if(v(t,e,!1,e.objectMode?1:c.length,c,l,f),r=r.next,e.bufferedRequestCount--,e.writing)break}null===r&&(e.lastBufferedRequest=null)}e.bufferedRequest=r,e.bufferProcessing=!1}function _(t){return t.ending&&0===t.length&&null===t.bufferedRequest&&!t.finished&&!t.writing}function S(t,e){t._final((function(r){e.pendingcb--,r&&t.emit("error",r),e.prefinished=!0,t.emit("prefinish"),A(t,e)}))}function A(t,e){var r=_(e);return r&&(!function(t,e){e.prefinished||e.finalCalled||("function"==typeof t._final?(e.pendingcb++,e.finalCalled=!0,o.nextTick(S,t,e)):(e.prefinished=!0,t.emit("prefinish")))}(t,e),0===e.pendingcb&&(e.finished=!0,t.emit("finish"))),r}c.inherits(b,f),m.prototype.getBuffer=function(){for(var t=this.bufferedRequest,e=[];t;)e.push(t),t=t.next;return e},function(){try{Object.defineProperty(m.prototype,"buffer",{get:l.deprecate((function(){return this.getBuffer()}),"_writableState.buffer is deprecated. Use _writableState.getBuffer instead.","DEP0003")})}catch(t){}}(),"function"==typeof Symbol&&Symbol.hasInstance&&"function"==typeof Function.prototype[Symbol.hasInstance]?(p=Function.prototype[Symbol.hasInstance],Object.defineProperty(b,Symbol.hasInstance,{value:function(t){return!!p.call(this,t)||this===b&&(t&&t._writableState instanceof m)}})):p=function(t){return t instanceof this},b.prototype.pipe=function(){this.emit("error",new Error("Cannot pipe, not readable"))},b.prototype.write=function(t,e,r){var n,i=this._writableState,s=!1,a=!i.objectMode&&(n=t,h.isBuffer(n)||n instanceof d);return a&&!h.isBuffer(t)&&(t=function(t){return h.from(t)}(t)),"function"==typeof e&&(r=e,e=null),a?e="buffer":e||(e=i.defaultEncoding),"function"!=typeof r&&(r=g),i.ended?function(t,e){var r=new Error("write after end");t.emit("error",r),o.nextTick(e,r)}(this,r):(a||function(t,e,r,n){var i=!0,s=!1;return null===r?s=new TypeError("May not write null values to stream"):"string"==typeof r||void 0===r||e.objectMode||(s=new TypeError("Invalid non-string/buffer chunk")),s&&(t.emit("error",s),o.nextTick(n,s),i=!1),i}(this,i,t,r))&&(i.pendingcb++,s=function(t,e,r,n,i,o){if(!r){var s=function(t,e,r){t.objectMode||!1===t.decodeStrings||"string"!=typeof e||(e=h.from(e,r));return e}(e,n,i);n!==s&&(r=!0,i="buffer",n=s)}var a=e.objectMode?1:n.length;e.length+=a;var u=e.length<e.highWaterMark;u||(e.needDrain=!0);if(e.writing||e.corked){var c=e.lastBufferedRequest;e.lastBufferedRequest={chunk:n,encoding:i,isBuf:r,callback:o,next:null},c?c.next=e.lastBufferedRequest:e.bufferedRequest=e.lastBufferedRequest,e.bufferedRequestCount+=1}else v(t,e,!1,a,n,i,o);return u}(this,i,a,t,e,r)),s},b.prototype.cork=function(){this._writableState.corked++},b.prototype.uncork=function(){var t=this._writableState;t.corked&&(t.corked--,t.writing||t.corked||t.bufferProcessing||!t.bufferedRequest||x(this,t))},b.prototype.setDefaultEncoding=function(t){if("string"==typeof t&&(t=t.toLowerCase()),!(["hex","utf8","utf-8","ascii","binary","base64","ucs2","ucs-2","utf16le","utf-16le","raw"].indexOf((t+"").toLowerCase())>-1))throw new TypeError("Unknown encoding: "+t);return this._writableState.defaultEncoding=t,this},Object.defineProperty(b.prototype,"writableHighWaterMark",{enumerable:!1,get:function(){return this._writableState.highWaterMark}}),b.prototype._write=function(t,e,r){r(new Error("_write() is not implemented"))},b.prototype._writev=null,b.prototype.end=function(t,e,r){var n=this._writableState;"function"==typeof t?(r=t,t=null,e=null):"function"==typeof e&&(r=e,e=null),null!=t&&this.write(t,e),n.corked&&(n.corked=1,this.uncork()),n.ending||function(t,e,r){e.ending=!0,A(t,e),r&&(e.finished?o.nextTick(r):t.once("finish",r));e.ended=!0,t.writable=!1}(this,n,r)},Object.defineProperty(b.prototype,"destroyed",{get:function(){return void 0!==this._writableState&&this._writableState.destroyed},set:function(t){this._writableState&&(this._writableState.destroyed=t)}}),b.prototype.destroy=y.destroy,b.prototype._undestroy=y.undestroy,b.prototype._destroy=function(t,e){this.end(),e(t)}}).call(this,r(7),r(113).setImmediate,r(3))},function(t,e,r){"use strict";var n=r(116).Buffer,i=n.isEncoding||function(t){switch((t=""+t)&&t.toLowerCase()){case"hex":case"utf8":case"utf-8":case"ascii":case"binary":case"base64":case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":case"raw":return!0;default:return!1}};function o(t){var e;switch(this.encoding=function(t){var e=function(t){if(!t)return"utf8";for(var e;;)switch(t){case"utf8":case"utf-8":return"utf8";case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return"utf16le";case"latin1":case"binary":return"latin1";case"base64":case"ascii":case"hex":return t;default:if(e)return;t=(""+t).toLowerCase(),e=!0}}(t);if("string"!=typeof e&&(n.isEncoding===i||!i(t)))throw new Error("Unknown encoding: "+t);return e||t}(t),this.encoding){case"utf16le":this.text=u,this.end=c,e=4;break;case"utf8":this.fillLast=a,e=4;break;case"base64":this.text=l,this.end=f,e=3;break;default:return this.write=h,void(this.end=d)}this.lastNeed=0,this.lastTotal=0,this.lastChar=n.allocUnsafe(e)}function s(t){return t<=127?0:t>>5==6?2:t>>4==14?3:t>>3==30?4:-1}function a(t){var e=this.lastTotal-this.lastNeed,r=function(t,e,r){if(128!=(192&e[0]))return t.lastNeed=0,"\uFFFD".repeat(r);if(t.lastNeed>1&&e.length>1){if(128!=(192&e[1]))return t.lastNeed=1,"\uFFFD".repeat(r+1);if(t.lastNeed>2&&e.length>2&&128!=(192&e[2]))return t.lastNeed=2,"\uFFFD".repeat(r+2)}}(this,t,e);return void 0!==r?r:this.lastNeed<=t.length?(t.copy(this.lastChar,e,0,this.lastNeed),this.lastChar.toString(this.encoding,0,this.lastTotal)):(t.copy(this.lastChar,e,0,t.length),void(this.lastNeed-=t.length))}function u(t,e){if((t.length-e)%2==0){var r=t.toString("utf16le",e);if(r){var n=r.charCodeAt(r.length-1);if(n>=55296&&n<=56319)return this.lastNeed=2,this.lastTotal=4,this.lastChar[0]=t[t.length-2],this.lastChar[1]=t[t.length-1],r.slice(0,-1)}return r}return this.lastNeed=1,this.lastTotal=2,this.lastChar[0]=t[t.length-1],t.toString("utf16le",e,t.length-1)}function c(t){var e=t&&t.length?this.write(t):"";if(this.lastNeed){var r=this.lastTotal-this.lastNeed;return e+this.lastChar.toString("utf16le",0,r)}return e}function l(t,e){var r=(t.length-e)%3;return 0===r?t.toString("base64",e):(this.lastNeed=3-r,this.lastTotal=3,1===r?this.lastChar[0]=t[t.length-1]:(this.lastChar[0]=t[t.length-2],this.lastChar[1]=t[t.length-1]),t.toString("base64",e,t.length-r))}function f(t){var e=t&&t.length?this.write(t):"";return this.lastNeed?e+this.lastChar.toString("base64",0,3-this.lastNeed):e}function h(t){return t.toString(this.encoding)}function d(t){return t&&t.length?this.write(t):""}e.StringDecoder=o,o.prototype.write=function(t){if(0===t.length)return"";var e,r;if(this.lastNeed){if(void 0===(e=this.fillLast(t)))return"";r=this.lastNeed,this.lastNeed=0}else r=0;return r<t.length?e?e+this.text(t,r):this.text(t,r):e||""},o.prototype.end=function(t){var e=t&&t.length?this.write(t):"";return this.lastNeed?e+"\uFFFD".repeat(this.lastTotal-this.lastNeed):e},o.prototype.text=function(t,e){var r=function(t,e,r){var n=e.length-1;if(n<r)return 0;var i=s(e[n]);if(i>=0)return i>0&&(t.lastNeed=i-1),i;if(--n<r)return 0;if((i=s(e[n]))>=0)return i>0&&(t.lastNeed=i-2),i;if(--n<r)return 0;if((i=s(e[n]))>=0)return i>0&&(2===i?i=0:t.lastNeed=i-3),i;return 0}(this,t,e);if(!this.lastNeed)return t.toString("utf8",e);this.lastTotal=r;var n=t.length-(r-this.lastNeed);return t.copy(this.lastChar,0,n),t.toString("utf8",e,n)},o.prototype.fillLast=function(t){if(this.lastNeed<=t.length)return t.copy(this.lastChar,this.lastTotal-this.lastNeed,0,this.lastNeed),this.lastChar.toString(this.encoding,0,this.lastTotal);t.copy(this.lastChar,this.lastTotal-this.lastNeed,0,t.length),this.lastNeed-=t.length}},function(t,e,r){"use strict";t.exports=s;var n=r(14),i=Object.create(r(21));function o(t,e){var r=this._transformState;r.transforming=!1;var n=r.writecb;if(!n)return this.emit("error",new Error("write callback called multiple times"));r.writechunk=null,r.writecb=null,null!=e&&this.push(e),n(t);var i=this._readableState;i.reading=!1,(i.needReadable||i.length<i.highWaterMark)&&this._read(i.highWaterMark)}function s(t){if(!(this instanceof s))return new s(t);n.call(this,t),this._transformState={afterTransform:o.bind(this),needTransform:!1,transforming:!1,writecb:null,writechunk:null,writeencoding:null},this._readableState.needReadable=!0,this._readableState.sync=!1,t&&("function"==typeof t.transform&&(this._transform=t.transform),"function"==typeof t.flush&&(this._flush=t.flush)),this.on("prefinish",a)}function a(){var t=this;"function"==typeof this._flush?this._flush((function(e,r){u(t,e,r)})):u(this,null,null)}function u(t,e,r){if(e)return t.emit("error",e);if(null!=r&&t.push(r),t._writableState.length)throw new Error("Calling transform done when ws.length != 0");if(t._transformState.transforming)throw new Error("Calling transform done when still transforming");return t.push(null)}i.inherits=r(10),i.inherits(s,n),s.prototype.push=function(t,e){return this._transformState.needTransform=!1,n.prototype.push.call(this,t,e)},s.prototype._transform=function(t,e,r){throw new Error("_transform() is not implemented")},s.prototype._write=function(t,e,r){var n=this._transformState;if(n.writecb=r,n.writechunk=t,n.writeencoding=e,!n.transforming){var i=this._readableState;(n.needTransform||i.needReadable||i.length<i.highWaterMark)&&this._read(i.highWaterMark)}},s.prototype._read=function(t){var e=this._transformState;null!==e.writechunk&&e.writecb&&!e.transforming?(e.transforming=!0,this._transform(e.writechunk,e.writeencoding,e.afterTransform)):e.needTransform=!0},s.prototype._destroy=function(t,e){var r=this;n.prototype._destroy.call(this,t,(function(t){e(t),r.emit("close")}))}},function(t,e,r){"use strict";(function(t){var n=r(194),i=r(58),o=r(57);const s="undefined"!=typeof navigator?navigator.hardwareConcurrency:null;e.a=class{constructor(e=s){const r=new n.a(t);this.pool=Object(i.a)(()=>Object(o.a)(r),e)}async decode(t,e){return new Promise((r,n)=>{this.pool.queue(async i=>{try{const n=await i(t,e);r(n)}catch(t){n(t)}})})}destroy(){this.pool.terminate(!0)}}}).call(this,r(128))},function(t,e,r){(function(t){e.fetch=a(t.fetch)&&a(t.ReadableStream),e.writableStream=a(t.WritableStream),e.abortController=a(t.AbortController),e.blobConstructor=!1;try{new Blob([new ArrayBuffer(1)]),e.blobConstructor=!0}catch(t){}var r;function n(){if(void 0!==r)return r;if(t.XMLHttpRequest){r=new t.XMLHttpRequest;try{r.open("GET",t.XDomainRequest?"/":"https://example.com")}catch(t){r=null}}else r=null;return r}function i(t){var e=n();if(!e)return!1;try{return e.responseType=t,e.responseType===t}catch(t){}return!1}var o=void 0!==t.ArrayBuffer,s=o&&a(t.ArrayBuffer.prototype.slice);function a(t){return"function"==typeof t}e.arraybuffer=e.fetch||o&&i("arraybuffer"),e.msstream=!e.fetch&&s&&i("ms-stream"),e.mozchunkedarraybuffer=!e.fetch&&o&&i("moz-chunked-arraybuffer"),e.overrideMimeType=e.fetch||!!n()&&a(n().overrideMimeType),e.vbArray=a(t.VBArray),r=null}).call(this,r(3))},function(t,e,r){(function(t,n,i){var o=r(69),s=r(10),a=r(42),u=e.readyStates={UNSENT:0,OPENED:1,HEADERS_RECEIVED:2,LOADING:3,DONE:4},c=e.IncomingMessage=function(e,r,s,u){var c=this;if(a.Readable.call(c),c._mode=s,c.headers={},c.rawHeaders=[],c.trailers={},c.rawTrailers=[],c.on("end",(function(){t.nextTick((function(){c.emit("close")}))})),"fetch"===s){if(c._fetchResponse=r,c.url=r.url,c.statusCode=r.status,c.statusMessage=r.statusText,r.headers.forEach((function(t,e){c.headers[e.toLowerCase()]=t,c.rawHeaders.push(e,t)})),o.writableStream){var l=new WritableStream({write:function(t){return new Promise((function(e,r){c._destroyed?r():c.push(new n(t))?e():c._resumeFetch=e}))},close:function(){i.clearTimeout(u),c._destroyed||c.push(null)},abort:function(t){c._destroyed||c.emit("error",t)}});try{return void r.body.pipeTo(l).catch((function(t){i.clearTimeout(u),c._destroyed||c.emit("error",t)}))}catch(t){}}var f=r.body.getReader();!function t(){f.read().then((function(e){if(!c._destroyed){if(e.done)return i.clearTimeout(u),void c.push(null);c.push(new n(e.value)),t()}})).catch((function(t){i.clearTimeout(u),c._destroyed||c.emit("error",t)}))}()}else{if(c._xhr=e,c._pos=0,c.url=e.responseURL,c.statusCode=e.status,c.statusMessage=e.statusText,e.getAllResponseHeaders().split(/\\r?\\n/).forEach((function(t){var e=t.match(/^([^:]+):\\s*(.*)/);if(e){var r=e[1].toLowerCase();"set-cookie"===r?(void 0===c.headers[r]&&(c.headers[r]=[]),c.headers[r].push(e[2])):void 0!==c.headers[r]?c.headers[r]+=", "+e[2]:c.headers[r]=e[2],c.rawHeaders.push(e[1],e[2])}})),c._charset="x-user-defined",!o.overrideMimeType){var h=c.rawHeaders["mime-type"];if(h){var d=h.match(/;\\s*charset=([^;])(;|$)/);d&&(c._charset=d[1].toLowerCase())}c._charset||(c._charset="utf-8")}}};s(c,a.Readable),c.prototype._read=function(){var t=this._resumeFetch;t&&(this._resumeFetch=null,t())},c.prototype._onXHRProgress=function(){var t=this,e=t._xhr,r=null;switch(t._mode){case"text:vbarray":if(e.readyState!==u.DONE)break;try{r=new i.VBArray(e.responseBody).toArray()}catch(t){}if(null!==r){t.push(new n(r));break}case"text":try{r=e.responseText}catch(e){t._mode="text:vbarray";break}if(r.length>t._pos){var o=r.substr(t._pos);if("x-user-defined"===t._charset){for(var s=new n(o.length),a=0;a<o.length;a++)s[a]=255&o.charCodeAt(a);t.push(s)}else t.push(o,t._charset);t._pos=r.length}break;case"arraybuffer":if(e.readyState!==u.DONE||!e.response)break;r=e.response,t.push(new n(new Uint8Array(r)));break;case"moz-chunked-arraybuffer":if(r=e.response,e.readyState!==u.LOADING||!r)break;t.push(new n(new Uint8Array(r)));break;case"ms-stream":if(r=e.response,e.readyState!==u.LOADING)break;var c=new i.MSStreamReader;c.onprogress=function(){c.result.byteLength>t._pos&&(t.push(new n(new Uint8Array(c.result.slice(t._pos)))),t._pos=c.result.byteLength)},c.onload=function(){t.push(null)},c.readAsArrayBuffer(r)}t._xhr.readyState===u.DONE&&"ms-stream"!==t._mode&&t.push(null)}}).call(this,r(7),r(9).Buffer,r(3))},function(t,e,r){"use strict";var n=r(46),i=Object.prototype.hasOwnProperty,o=Array.isArray,s=function(){for(var t=[],e=0;e<256;++e)t.push("%"+((e<16?"0":"")+e.toString(16)).toUpperCase());return t}(),a=function(t,e){for(var r=e&&e.plainObjects?Object.create(null):{},n=0;n<t.length;++n)void 0!==t[n]&&(r[n]=t[n]);return r};t.exports={arrayToObject:a,assign:function(t,e){return Object.keys(e).reduce((function(t,r){return t[r]=e[r],t}),t)},combine:function(t,e){return[].concat(t,e)},compact:function(t){for(var e=[{obj:{o:t},prop:"o"}],r=[],n=0;n<e.length;++n)for(var i=e[n],s=i.obj[i.prop],a=Object.keys(s),u=0;u<a.length;++u){var c=a[u],l=s[c];"object"==typeof l&&null!==l&&-1===r.indexOf(l)&&(e.push({obj:s,prop:c}),r.push(l))}return function(t){for(;t.length>1;){var e=t.pop(),r=e.obj[e.prop];if(o(r)){for(var n=[],i=0;i<r.length;++i)void 0!==r[i]&&n.push(r[i]);e.obj[e.prop]=n}}}(e),t},decode:function(t,e,r){var n=t.replace(/\\+/g," ");if("iso-8859-1"===r)return n.replace(/%[0-9a-f]{2}/gi,unescape);try{return decodeURIComponent(n)}catch(t){return n}},encode:function(t,e,r,i,o){if(0===t.length)return t;var a=t;if("symbol"==typeof t?a=Symbol.prototype.toString.call(t):"string"!=typeof t&&(a=String(t)),"iso-8859-1"===r)return escape(a).replace(/%u[0-9a-f]{4}/gi,(function(t){return"%26%23"+parseInt(t.slice(2),16)+"%3B"}));for(var u="",c=0;c<a.length;++c){var l=a.charCodeAt(c);45===l||46===l||95===l||126===l||l>=48&&l<=57||l>=65&&l<=90||l>=97&&l<=122||o===n.RFC1738&&(40===l||41===l)?u+=a.charAt(c):l<128?u+=s[l]:l<2048?u+=s[192|l>>6]+s[128|63&l]:l<55296||l>=57344?u+=s[224|l>>12]+s[128|l>>6&63]+s[128|63&l]:(c+=1,l=65536+((1023&l)<<10|1023&a.charCodeAt(c)),u+=s[240|l>>18]+s[128|l>>12&63]+s[128|l>>6&63]+s[128|63&l])}return u},isBuffer:function(t){return!(!t||"object"!=typeof t)&&!!(t.constructor&&t.constructor.isBuffer&&t.constructor.isBuffer(t))},isRegExp:function(t){return"[object RegExp]"===Object.prototype.toString.call(t)},maybeMap:function(t,e){if(o(t)){for(var r=[],n=0;n<t.length;n+=1)r.push(e(t[n]));return r}return e(t)},merge:function t(e,r,n){if(!r)return e;if("object"!=typeof r){if(o(e))e.push(r);else{if(!e||"object"!=typeof e)return[e,r];(n&&(n.plainObjects||n.allowPrototypes)||!i.call(Object.prototype,r))&&(e[r]=!0)}return e}if(!e||"object"!=typeof e)return[e].concat(r);var s=e;return o(e)&&!o(r)&&(s=a(e,n)),o(e)&&o(r)?(r.forEach((function(r,o){if(i.call(e,o)){var s=e[o];s&&"object"==typeof s&&r&&"object"==typeof r?e[o]=t(s,r,n):e.push(r)}else e[o]=r})),e):Object.keys(r).reduce((function(e,o){var s=r[o];return i.call(e,o)?e[o]=t(e[o],s,n):e[o]=s,e}),s)}}},function(t,e,r){function n(t){try{t[Symbol.iterator]=function(){return this}}catch(t){}}function i(t){t["@@iterator"]=function(){return this}}function o(t){const e={next:t};return n(e),i(e),e}function s(t){try{return t.constructor.name.endsWith("Array")}catch{return!1}}function a(t){try{return"function"==typeof t.next}catch{return!1}}function u(t){try{return"@@iterator"in t}catch{return!1}}function c(t){try{return Symbol.iterator in t.constructor.prototype}catch{return!1}}function l(t){try{return Symbol.iterator in t&&"function"==typeof t.next&&!1===t.propertyIsEnumerable("next")}catch{return!1}}function f(t){const e=t["@@iterator"];return a(e)?e:"function"==typeof e?e():void 0}function h(t){let e=0,r=t.length;return o(()=>e++<r?{value:t[e],done:!1}:{done:!0})}function d(t){if(l(t))return t;if(c(t))return t[Symbol.iterator]();if(a(t))return o(t.next);if(u(t))return f(t);if("string"==typeof t||s(t))return h(t);throw"[iter-fun] unable to determine iterator"}t.exports={addSymbolIterator:n,addSymbolIteratorFallback:i,isIterator:l,isArray:s,hasNext:a,hasSymbolIterator:c,hasIterator:u,getIterator:f,createIterator:h,getOrCreateIterator:d,wrapNextFunction:o,zip:function(t){return t=t.map(d),o((function(){const e=t.map(t=>t.next());return e.every(({done:t})=>t)?{done:!0}:{done:!1,value:e.map(({value:t})=>t)}}))}}},function(t,e,r){"use strict";function n(t){"+"===t[0]&&(t=t.substring(1));const e="-"===t[0]?"-":"";"-"===e&&(t=t.substring(1));const r=t.indexOf("e");if(-1===r)return e+t;let n=t.indexOf(".");-1===n&&(n=r);const i=Number(t.substring(r+1)),o=t.substring(0,r).replace(".",""),s=n+i,a=o.length;if(s>=a){const t=s-a;let r=o;for(let e=0;e<t;e++)r+="0";return e+r}if(s<0){let t="0.";for(let e=0;e>s;e--)t+="0";return t+=o,e+t}return e+o.substring(0,s)+"."+o.substring(s)}t.exports=n,t.exports.default=n},function(t,e,r){"use strict";t.exports={MAX_SAFE_INTEGER:9007199254740991}},function(t,e,r){"use strict";const n=r(47);function i(t){return"0"===t?"1":n("1",t)}t.exports=i,t.exports.default=i},function(t,e,r){"use strict";const n=r(4),i=r(0),o=r(8),s=r(22);function a(t){if(-1===(t=i(t)).indexOf("."))return t;const e=s(t);return t=n(t).split(".")[0],"+"===e?o(t,"1"):"-"===e?"0"===t||""===t?"0":"-"+t:void 0}t.exports=a,t.exports.default=a},function(t,e,r){"use strict";const n=r(51);function i(t){const e=n(t);return[t.replace(/\\./g,"").replace(/^0/,""),1+"0".repeat(e)]}t.exports=i,t.exports.default=i},function(t,e,r){const n=r(0),i=r(16);function o(t){if(t=n(t),!i(t))throw new Error("can\'t call is_odd on decimal");return["1","3","5","7","9"].includes(t.charAt(t.length-1))}t.exports=o,t.exports.default=o},function(t,e,r){"use strict";const n=r(52),i=r(15),o=r(78),s=r(11),a=r(17),u=r(50);function c(t,{max_decimal_digits:e,infinity_times_zero:r="NaN"}={}){const c=t.some(t=>i(t)),l=t.some(t=>s(t));if(c&&l)return r;if(c){return t.filter(t=>"-"===u(t)).length%2==0?"Infinity":"-Infinity"}if(l)return"0";const f=o(t.filter(t=>n(t)).length.toString());let h=a(t.map(t=>t.replace(/i$/,"")),{max_decimal_digits:e});return f&&(h+="i"),h}t.exports=c,t.exports.default=c},function(t,e,r){"use strict";const n=r(0);function i(t){return"-"===(t=n(t))[0]}t.exports=i,t.exports.default=i},function(t,e,r){"use strict";const n=r(1),i=r(160),o=r(161);function s(t,{max_decimal_digits:e=100,fraction:r=!1}={}){if(i(t)){const[i,s]=o(t);return r?s+"/"+i:n(s,i,{max_decimal_digits:e})}return r?"1/"+t:n("1",t,{max_decimal_digits:e})}t.exports=s,t.exports.default=s},function(t,e,r){"use strict";const n=r(0),i=r(16);function o(t){if(t=n(t),!i(t))throw new Error("can\'t call is_even on decimal");return["0","2","4","6","8"].includes(t.charAt(t.length-1))}t.exports=o,t.exports.default=o},function(t,e,r){"use strict";const n=r(76),i=r(84),o=r(1);function s(t,e){const r=i(t);return"0"===r?"0":n(o(r,e,{max_decimal_digits:1}))}t.exports=s,t.exports.default=s},function(t,e,r){"use strict";const n=r(4),i=r(0);function o(t){const e=(t=n(i(t))).indexOf(".");return(-1===e?t.length:e).toString()}t.exports=o,t.exports.default=o},function(t,e,r){"use strict";const n=r(1),i=r(82),o=r(86),s=r(87);function a(t,e){const r=s("2",o(["1000",e,e]));for(;t.endsWith("0")&&e.endsWith("0");)t=t.substring(0,t.length-1),e=e.substring(0,e.length-1);for(;i(t)&&i(e);)t=n(t,"2"),e=n(e,"2");let a=!0;for(;a;){a=!1;for(let i=0;i<r.length;i++){const o=r[i],s=o.length+1,u=n(t,o,{ellipsis:!0,max_decimal_digits:s});if(-1===u.indexOf(".")){const r=n(e,o,{ellipsis:!0,max_decimal_digits:s});if(-1===r.indexOf(".")){t=u,e=r,a=!0;break}}}}return[t,e]}t.exports=a,t.exports.default=a},function(t,e,r){"use strict";const n=r(0),i=r(34);function o(t){"string"==typeof t&&(t=Array.prototype.slice.call(arguments));let e=n(t[0]);const r=t.length;for(let n=1;n<r;n++){const r=t[n];"<"===i(r,e)&&(e=r)}return e}t.exports=o,t.exports.default=o},function(t,e,r){"use strict";const n=r(5),i=r(1),o=r(16),s=r(8);function a(t="0",e="100"){const r=["2","3","5","7","11"].filter(r=>"<"!==n(r,t)&&">"!==n(r,e));let a="13";for(;">"!==n(a,e);)/^\\d+5/.test(a)||/^(\\d)\\1+/.test(a)||["9","7","3"].every(t=>!o(i(a,t)))&&r.push(a),a=s(a,"2");return r}t.exports=a,t.exports.default=a},function(t,e,r){"use strict";const n=r(6),i=r(1);function o({max_decimal_digits:t=100,steps:e=100}={}){let r="1",o="1";for(let s=1;s<e;s++)o=i(o,s.toString(),{max_decimal_digits:t}),r=n(r,o);return r}t.exports=o,t.exports.default=o},function(t,e,r){"use strict";const n=r(0),i=r(90),o=r(91),s=r(11),a=r(88),u=r(35);function c(t,{max_decimal_digits:e=100}={}){const r=a({max_decimal_digits:2*e});return i(t)?"0":o(t)?"Infinity":s(t)?"1":(t=n(t),u(r,t,{max_decimal_digits:e}))}t.exports=c,t.exports.default=c},function(t,e,r){"use strict";function n(t){return!!t.match(/^-inf(inity)?$/i)}t.exports=n,t.exports.default=n},function(t,e,r){"use strict";function n(t){return!!t.match(/^\\+?inf(inity)?$/i)}t.exports=n,t.exports.default=n},function(t,e,r){"use strict";const n=r(37);function i(t,e){return n(t,"2",e)}t.exports=i,t.exports.default=i},function(t,e,r){"use strict";function n(t){const e=t.indexOf(".");return-1===e?t:t.substring(0,e)}t.exports=n,t.exports.default=n},function(t,e,r){const n=r(95),i=r(180);function o(t,e,{precise:r=!1}={precise:!1}){return r?i(n(t.toString(),e.toString()),"2"):(t+e)/2}t.exports=o,t.exports.default=o},function(t,e,r){const n=r(38),i=r(18),o=r(96),s=r(97);function a(t,e){t=i(t),e=i(e);const r="-"!==t[0],a="-"!==e[0];if(r&&a)return o(t,e);if(!r&&!a)return"-"+o(t.substring(1),e.substring(1));if(!r&&a)switch(t=t.substring(1),n(t,e)){case"=":return"0";case"<":return s(e,t);case">":return"-"+s(t,e)}else if(r&&!a)switch(e=e.substring(1),n(t,e)){case"=":return"0";case"<":return"-"+s(e,t);case">":return s(t,e)}}t.exports=a,t.exports.default=a},function(t,e,r){const{MAX_SAFE_INTEGER_LENGTH:n}=r(56);t.exports=function(t,e){const r=t.length,i=e.length,o=t.indexOf("."),s=e.indexOf("."),a=-1===o?r:o,u=-1===s?i:s;if(-1===o&&-1===s&&r<n&&i<n)return(Number(t)+Number(e)).toFixed();const c=a-u;let l=Math.max(a,u),f=Math.max(r-a-1,i-u-1),h=c<0?-1*c:0,d=c<=0?0:c,p=l+1+f-1,y="",g=0,m=p;if(f>0){for(;m>p-f;){const r=t[m-h]||"0",n=e[m-d]||"0";let i=Number(r)+Number(n)+g;i>=10?(i-=10,g=1):g=0,""===y&&0===i||(y=i+y),m--}y&&(y="."+y),m--}if(l>0)for(;m>=0;){const r=t[m-h]||"0",n=e[m-d]||"0";let i=Number(r)+Number(n)+g;i>=10?(i-=10,g=1):g=0,y=i+y,m--}return 1===g&&(y=g+y),"."===y[0]&&(y="0"+y),y}},function(t,e,r){const{MAX_SAFE_INTEGER_LENGTH:n}=r(56);t.exports=function(t,e){const r=t.length,i=e.length,o=t.indexOf("."),s=e.indexOf("."),a=-1===o?r:o,u=-1===s?i:s;if(-1===o&&-1===s&&r<n&&i<n)return(Number(t)-Number(e)).toFixed();const c=a-u;let l=Math.max(a,u),f=Math.max(r-a-1,i-u-1),h=c<0?-1*c:0,d=c<=0?0:c,p=l+1+f-1,y="",g=0,m=p;if(f>0){for(;m>p-f;){let r=t[m-h]||"0",n=e[m-d]||"0";r-=g,g=0;let i=r-n;if(i<0)for(;i<0;)g++,i+=10;else g&&g--;""===y&&0===i||(y=i+y),m--}""!==y&&(y="."+y),m--}if(l>0){for(;m>0;){let r=t[m-h]||"0",n=e[m-d]||"0";r-=g,g=0;let i=r-n;if(i<0)for(;i<0;)g++,i+=10;else g&&g--;y=i+y,m--}const r=t[0-h]||"0",n=e[0-d]||"0";let i=Number(r)-(g>0?1:0)-Number(n);0!==i&&(y=i+y),y=y.replace(/^0+/,"")}return"."===y[0]&&(y="0"+y),y}},function(t,e,r){const n=r(18);function i(t){return"-"===(t=n(t))[0]?t.substring(1):t}t.exports=i,t.exports.default=i},function(t,e,r){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var n=function(t,e){if(Array.isArray(t))return t;if(Symbol.iterator in Object(t))return function(t,e){var r=[],n=!0,i=!1,o=void 0;try{for(var s,a=t[Symbol.iterator]();!(n=(s=a.next()).done)&&(r.push(s.value),!e||r.length!==e);n=!0);}catch(t){i=!0,o=t}finally{try{!n&&a.return&&a.return()}finally{if(i)throw o}}return r}(t,e);throw new TypeError("Invalid attempt to destructure non-iterable instance")},i="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t};e.default=function(t,e){return new Promise((function(r,o){try{e&&console.log("starting parseData with",t),e&&console.log("\\tGeoTIFF:","undefined"==typeof GeoTIFF?"undefined":i(GeoTIFF));var u={},c=void 0,h=void 0;if("object"===t.rasterType)u.values=t.data,u.height=c=t.metadata.height||u.values[0].length,u.width=h=t.metadata.width||u.values[0][0].length,u.pixelHeight=t.metadata.pixelHeight,u.pixelWidth=t.metadata.pixelWidth,u.projection=t.metadata.projection,u.xmin=t.metadata.xmin,u.ymax=t.metadata.ymax,u.noDataValue=t.metadata.noDataValue,u.numberOfRasters=u.values.length,u.xmax=u.xmin+u.width*u.pixelWidth,u.ymin=u.ymax-u.height*u.pixelHeight,u._data=null,r(f(u));else if("geotiff"===t.rasterType){u._data=t.data;var d=s.fromArrayBuffer;"url"===t.sourceType?d=s.fromUrl:"Blob"===t.sourceType&&(d=s.fromBlob),e&&console.log("data.rasterType is geotiff"),r(d(t.data).then((function(r){return e&&console.log("geotiff:",r),r.getImage().then((function(r){try{e&&console.log("image:",r);var i=r.fileDirectory,s=r.getGeoKeys()||{},d=s.GeographicTypeGeoKey,p=s.ProjectedCSTypeGeoKey;u.projection=p||d||t.metadata.projection,e&&console.log("projection:",u.projection),u.height=c=r.getHeight(),e&&console.log("result.height:",u.height),u.width=h=r.getWidth(),e&&console.log("result.width:",u.width);var y=r.getResolution(),g=n(y,2),m=g[0],b=g[1];u.pixelHeight=Math.abs(b),u.pixelWidth=Math.abs(m);var v=r.getOrigin(),w=n(v,2),x=w[0],_=w[1];return u.xmin=x,u.xmax=u.xmin+h*u.pixelWidth,u.ymax=_,u.ymin=u.ymax-c*u.pixelHeight,u.noDataValue=i.GDAL_NODATA?parseFloat(i.GDAL_NODATA):null,u.numberOfRasters=i.SamplesPerPixel,i.ColorMap&&(u.palette=(0,a.getPalette)(r)),"url"!==t.sourceType?r.readRasters().then((function(t){return u.values=t.map((function(t){return(0,l.unflatten)(t,{height:c,width:h})})),f(u)})):u}catch(t){o(t),console.error("[georaster] error parsing georaster:",t)}}))})))}}catch(t){o(t),console.error("[georaster] error parsing georaster:",t)}}))};var o,s=r(193),a=r(150),u=r(151),c=(o=u)&&o.__esModule?o:{default:o},l=r(192);function f(t){var e=(0,c.default)(t.values,{height:t.height,layout:"[band][row][column]",noData:t.noDataValue,precise:!1,stats:["max","min","range"],width:t.width});return t.maxs=e.bands.map((function(t){return t.max})),t.mins=e.bands.map((function(t){return t.min})),t.ranges=e.bands.map((function(t){return t.range})),t}},function(t,e,r){function n(t,e){"use strict";var r=(e=e||{}).pos||0,i="<".charCodeAt(0),o=">".charCodeAt(0),s="-".charCodeAt(0),a="/".charCodeAt(0),u="!".charCodeAt(0),c="\'".charCodeAt(0),l=\'"\'.charCodeAt(0);function f(){for(var e=[];t[r];)if(t.charCodeAt(r)==i){if(t.charCodeAt(r+1)===a)return(r=t.indexOf(">",r))+1&&(r+=1),e;if(t.charCodeAt(r+1)===u){if(t.charCodeAt(r+2)==s){for(;-1!==r&&(t.charCodeAt(r)!==o||t.charCodeAt(r-1)!=s||t.charCodeAt(r-2)!=s||-1==r);)r=t.indexOf(">",r+1);-1===r&&(r=t.length)}else for(r+=2;t.charCodeAt(r)!==o&&t[r];)r++;r++;continue}var n=y();e.push(n)}else{var c=h();c.trim().length>0&&e.push(c),r++}return e}function h(){var e=r;return-2===(r=t.indexOf("<",r)-1)&&(r=t.length),t.slice(e,r+1)}function d(){for(var e=r;-1==="\\n\\t>/= ".indexOf(t[r])&&t[r];)r++;return t.slice(e,r)}var p=e.noChildNodes||["img","br","input","meta","link"];function y(){r++;const e=d(),n={};let i=[];for(;t.charCodeAt(r)!==o&&t[r];){var s=t.charCodeAt(r);if(s>64&&s<91||s>96&&s<123){for(var u=d(),h=t.charCodeAt(r);h&&h!==c&&h!==l&&!(h>64&&h<91||h>96&&h<123)&&h!==o;)r++,h=t.charCodeAt(r);if(h===c||h===l){var y=g();if(-1===r)return{tagName:e,attributes:n,children:i}}else y=null,r--;n[u]=y}r++}if(t.charCodeAt(r-1)!==a)if("script"==e){var m=r+1;r=t.indexOf("<\\/script>",r),i=[t.slice(m,r-1)],r+=9}else if("style"==e){m=r+1;r=t.indexOf("</style>",r),i=[t.slice(m,r-1)],r+=8}else-1==p.indexOf(e)&&(r++,i=f());else r++;return{tagName:e,attributes:n,children:i}}function g(){var e=t[r],n=++r;return r=t.indexOf(e,n),t.slice(n,r)}var m,b=null;if(void 0!==e.attrValue){e.attrName=e.attrName||"id";for(b=[];-1!==(m=void 0,m=new RegExp("\\\\s"+e.attrName+"\\\\s*=[\'\\"]"+e.attrValue+"[\'\\"]").exec(t),r=m?m.index:-1);)-1!==(r=t.lastIndexOf("<",r))&&b.push(y()),t=t.substr(r),r=0}else b=e.parseNode?y():f();return e.filter&&(b=n.filter(b,e.filter)),e.setPos&&(b.pos=r),b}n.simplify=function(t){var e={};if(!t.length)return"";if(1===t.length&&"string"==typeof t[0])return t[0];for(var r in t.forEach((function(t){if("object"==typeof t){e[t.tagName]||(e[t.tagName]=[]);var r=n.simplify(t.children||[]);e[t.tagName].push(r),t.attributes&&(r._attributes=t.attributes)}})),e)1==e[r].length&&(e[r]=e[r][0]);return e},n.filter=function(t,e){var r=[];return t.forEach((function(t){if("object"==typeof t&&e(t)&&r.push(t),t.children){var i=n.filter(t.children,e);r=r.concat(i)}})),r},n.stringify=function(t){var e="";function r(t){if(t)for(var r=0;r<t.length;r++)"string"==typeof t[r]?e+=t[r].trim():n(t[r])}function n(t){for(var n in e+="<"+t.tagName,t.attributes)null===t.attributes[n]?e+=" "+n:-1===t.attributes[n].indexOf(\'"\')?e+=" "+n+\'="\'+t.attributes[n].trim()+\'"\':e+=" "+n+"=\'"+t.attributes[n].trim()+"\'";e+=">",r(t.children),e+="</"+t.tagName+">"}return r(t),e},n.toContentString=function(t){if(Array.isArray(t)){var e="";return t.forEach((function(t){e=(e+=" "+n.toContentString(t)).trim()})),e}return"object"==typeof t?n.toContentString(t.children):" "+t},n.getElementById=function(t,e,r){var i=n(t,{attrValue:e});return r?n.simplify(i):i[0]},n.getElementsByClassName=function(t,e,r){const i=n(t,{attrName:"class",attrValue:"[a-zA-Z0-9-s ]*"+e+"[a-zA-Z0-9-s ]*"});return r?n.simplify(i):i},n.parseStream=function(t,e){if("string"==typeof e&&(e=e.length+2),"string"==typeof t){var i=r(25);t=i.createReadStream(t,{start:e}),e=0}var o=e,s="";return t.on("data",(function(e){s+=e;for(var r=0;;){if(!(o=s.indexOf("<",o)+1))return void(o=r);if("/"!==s[o+1]){var i=n(s,{pos:o-1,parseNode:!0,setPos:!0});if((o=i.pos)>s.length-1||o<r)return s=s.slice(r),o=0,void(r=0);t.emit("xml",i),r=o}else o+=1,r=pos}})),t.on("end",(function(){console.log("end")})),t},n.transformStream=function(t){const e=r(107);"string"==typeof t&&(t=t.length+2);var i=t||0,o="";return e({readableObjectMode:!0},(function(t,e,r){o+=t;for(var s=0;;){if(!(i=o.indexOf("<",i)+1))return i=s,r();if("/"!==o[i+1]){var a=n(o,{pos:i-1,parseNode:!0,setPos:!0});if((i=a.pos)>o.length-1||i<s)return o=o.slice(s),i=0,s=0,r();this.push(a),s=i}else i+=1,s=pos}r()}))},t.exports=n,n.xml=n},function(t,e,r){"use strict";var n=r(118),i=r(29),o=r(123),s=r(124),a=r(125),u=r(126),c=r(127),l=Object.prototype.toString;function f(t){if(!(this instanceof f))return new f(t);this.options=i.assign({chunkSize:16384,windowBits:0,to:""},t||{});var e=this.options;e.raw&&e.windowBits>=0&&e.windowBits<16&&(e.windowBits=-e.windowBits,0===e.windowBits&&(e.windowBits=-15)),!(e.windowBits>=0&&e.windowBits<16)||t&&t.windowBits||(e.windowBits+=32),e.windowBits>15&&e.windowBits<48&&0==(15&e.windowBits)&&(e.windowBits|=15),this.err=0,this.msg="",this.ended=!1,this.chunks=[],this.strm=new u,this.strm.avail_out=0;var r=n.inflateInit2(this.strm,e.windowBits);if(r!==s.Z_OK)throw new Error(a[r]);if(this.header=new c,n.inflateGetHeader(this.strm,this.header),e.dictionary&&("string"==typeof e.dictionary?e.dictionary=o.string2buf(e.dictionary):"[object ArrayBuffer]"===l.call(e.dictionary)&&(e.dictionary=new Uint8Array(e.dictionary)),e.raw&&(r=n.inflateSetDictionary(this.strm,e.dictionary))!==s.Z_OK))throw new Error(a[r])}function h(t,e){var r=new f(e);if(r.push(t,!0),r.err)throw r.msg||a[r.err];return r.result}f.prototype.push=function(t,e){var r,a,u,c,f,h=this.strm,d=this.options.chunkSize,p=this.options.dictionary,y=!1;if(this.ended)return!1;a=e===~~e?e:!0===e?s.Z_FINISH:s.Z_NO_FLUSH,"string"==typeof t?h.input=o.binstring2buf(t):"[object ArrayBuffer]"===l.call(t)?h.input=new Uint8Array(t):h.input=t,h.next_in=0,h.avail_in=h.input.length;do{if(0===h.avail_out&&(h.output=new i.Buf8(d),h.next_out=0,h.avail_out=d),(r=n.inflate(h,s.Z_NO_FLUSH))===s.Z_NEED_DICT&&p&&(r=n.inflateSetDictionary(this.strm,p)),r===s.Z_BUF_ERROR&&!0===y&&(r=s.Z_OK,y=!1),r!==s.Z_STREAM_END&&r!==s.Z_OK)return this.onEnd(r),this.ended=!0,!1;h.next_out&&(0!==h.avail_out&&r!==s.Z_STREAM_END&&(0!==h.avail_in||a!==s.Z_FINISH&&a!==s.Z_SYNC_FLUSH)||("string"===this.options.to?(u=o.utf8border(h.output,h.next_out),c=h.next_out-u,f=o.buf2string(h.output,u),h.next_out=c,h.avail_out=d-c,c&&i.arraySet(h.output,h.output,u,c,0),this.onData(f)):this.onData(i.shrinkBuf(h.output,h.next_out)))),0===h.avail_in&&0===h.avail_out&&(y=!0)}while((h.avail_in>0||0===h.avail_out)&&r!==s.Z_STREAM_END);return r===s.Z_STREAM_END&&(a=s.Z_FINISH),a===s.Z_FINISH?(r=n.inflateEnd(this.strm),this.onEnd(r),this.ended=!0,r===s.Z_OK):a!==s.Z_SYNC_FLUSH||(this.onEnd(s.Z_OK),h.avail_out=0,!0)},f.prototype.onData=function(t){this.chunks.push(t)},f.prototype.onEnd=function(t){t===s.Z_OK&&("string"===this.options.to?this.result=this.chunks.join(""):this.result=i.flattenChunks(this.chunks)),this.chunks=[],this.err=t,this.msg=this.strm.msg},e.Inflate=f,e.inflate=h,e.inflateRaw=function(t,e){return(e=e||{}).raw=!0,h(t,e)},e.ungzip=h},function(t,e,r){"use strict";var n=r(26);class i extends n.a{constructor(){super(t=>(this._observers.add(t),()=>this._observers.delete(t))),this._observers=new Set}next(t){for(const e of this._observers)e.next(t)}error(t){for(const e of this._observers)e.error(t)}complete(){for(const t of this._observers)t.complete()}}e.a=i},function(t,e,r){"use strict";r.d(e,"a",(function(){return i}));const n=()=>{};function i(){let t,e=!1,r=n;return[new Promise(n=>{e?n(t):r=n}),n=>{e=!0,t=n,r(t)}]}},function(t,e,r){"use strict";r.d(e,"a",(function(){return i}));var n=r(2);function i(t){return t&&"object"==typeof t&&t[n.d]}},function(t,e,r){var n=r(40),i=r(39),o=t.exports;for(var s in n)n.hasOwnProperty(s)&&(o[s]=n[s]);function a(t){if("string"==typeof t&&(t=i.parse(t)),t.protocol||(t.protocol="https:"),"https:"!==t.protocol)throw new Error(\'Protocol "\'+t.protocol+\'" not supported. Expected "https:"\');return t}o.request=function(t,e){return t=a(t),n.request.call(this,t,e)},o.get=function(t,e){return t=a(t),n.get.call(this,t,e)}},function(t,e,r){"use strict";r.r(e);var n=r(99),i=r.n(n);self;onmessage=t=>{const e=t.data;i()(e).then(t=>{const e=[];if(t.values){let r;t.values.forEach(t=>t.forEach(({buffer:t})=>{t instanceof ArrayBuffer&&t!==r&&(e.push(t),r=t)}))}t._data instanceof ArrayBuffer&&e.push(t._data),postMessage(t,e),close()})}},function(t,e,r){(function(e){var n=r(42).Transform,i=r(10);function o(t){n.call(this,t),this._destroyed=!1}function s(t,e,r){r(null,t)}function a(t){return function(e,r,n){return"function"==typeof e&&(n=r,r=e,e={}),"function"!=typeof r&&(r=s),"function"!=typeof n&&(n=null),t(e,r,n)}}i(o,n),o.prototype.destroy=function(t){if(!this._destroyed){this._destroyed=!0;var r=this;e.nextTick((function(){t&&r.emit("error",t),r.emit("close")}))}},t.exports=a((function(t,e,r){var n=new o(t);return n._transform=e,r&&(n._flush=r),n})),t.exports.ctor=a((function(t,e,r){function n(e){if(!(this instanceof n))return new n(e);this.options=Object.assign({},t,e),o.call(this,this.options)}return i(n,o),n.prototype._transform=e,r&&(n.prototype._flush=r),n})),t.exports.obj=a((function(t,e,r){var n=new o(Object.assign({objectMode:!0,highWaterMark:16},t));return n._transform=e,r&&(n._flush=r),n}))}).call(this,r(7))},function(t,e,r){"use strict";e.byteLength=function(t){var e=c(t),r=e[0],n=e[1];return 3*(r+n)/4-n},e.toByteArray=function(t){var e,r,n=c(t),s=n[0],a=n[1],u=new o(function(t,e,r){return 3*(e+r)/4-r}(0,s,a)),l=0,f=a>0?s-4:s;for(r=0;r<f;r+=4)e=i[t.charCodeAt(r)]<<18|i[t.charCodeAt(r+1)]<<12|i[t.charCodeAt(r+2)]<<6|i[t.charCodeAt(r+3)],u[l++]=e>>16&255,u[l++]=e>>8&255,u[l++]=255&e;2===a&&(e=i[t.charCodeAt(r)]<<2|i[t.charCodeAt(r+1)]>>4,u[l++]=255&e);1===a&&(e=i[t.charCodeAt(r)]<<10|i[t.charCodeAt(r+1)]<<4|i[t.charCodeAt(r+2)]>>2,u[l++]=e>>8&255,u[l++]=255&e);return u},e.fromByteArray=function(t){for(var e,r=t.length,i=r%3,o=[],s=0,a=r-i;s<a;s+=16383)o.push(l(t,s,s+16383>a?a:s+16383));1===i?(e=t[r-1],o.push(n[e>>2]+n[e<<4&63]+"==")):2===i&&(e=(t[r-2]<<8)+t[r-1],o.push(n[e>>10]+n[e>>4&63]+n[e<<2&63]+"="));return o.join("")};for(var n=[],i=[],o="undefined"!=typeof Uint8Array?Uint8Array:Array,s="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",a=0,u=s.length;a<u;++a)n[a]=s[a],i[s.charCodeAt(a)]=a;function c(t){var e=t.length;if(e%4>0)throw new Error("Invalid string. Length must be a multiple of 4");var r=t.indexOf("=");return-1===r&&(r=e),[r,r===e?0:4-r%4]}function l(t,e,r){for(var i,o,s=[],a=e;a<r;a+=3)i=(t[a]<<16&16711680)+(t[a+1]<<8&65280)+(255&t[a+2]),s.push(n[(o=i)>>18&63]+n[o>>12&63]+n[o>>6&63]+n[63&o]);return s.join("")}i["-".charCodeAt(0)]=62,i["_".charCodeAt(0)]=63},function(t,e){\n/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */\ne.read=function(t,e,r,n,i){var o,s,a=8*i-n-1,u=(1<<a)-1,c=u>>1,l=-7,f=r?i-1:0,h=r?-1:1,d=t[e+f];for(f+=h,o=d&(1<<-l)-1,d>>=-l,l+=a;l>0;o=256*o+t[e+f],f+=h,l-=8);for(s=o&(1<<-l)-1,o>>=-l,l+=n;l>0;s=256*s+t[e+f],f+=h,l-=8);if(0===o)o=1-c;else{if(o===u)return s?NaN:1/0*(d?-1:1);s+=Math.pow(2,n),o-=c}return(d?-1:1)*s*Math.pow(2,o-n)},e.write=function(t,e,r,n,i,o){var s,a,u,c=8*o-i-1,l=(1<<c)-1,f=l>>1,h=23===i?Math.pow(2,-24)-Math.pow(2,-77):0,d=n?0:o-1,p=n?1:-1,y=e<0||0===e&&1/e<0?1:0;for(e=Math.abs(e),isNaN(e)||e===1/0?(a=isNaN(e)?1:0,s=l):(s=Math.floor(Math.log(e)/Math.LN2),e*(u=Math.pow(2,-s))<1&&(s--,u*=2),(e+=s+f>=1?h/u:h*Math.pow(2,1-f))*u>=2&&(s++,u/=2),s+f>=l?(a=0,s=l):s+f>=1?(a=(e*u-1)*Math.pow(2,i),s+=f):(a=e*Math.pow(2,f-1)*Math.pow(2,i),s=0));i>=8;t[r+d]=255&a,d+=p,a/=256,i-=8);for(s=s<<i|a,c+=i;c>0;t[r+d]=255&s,d+=p,s/=256,c-=8);t[r+d-p]|=128*y}},function(t,e){},function(t,e,r){"use strict";var n=r(43).Buffer,i=r(112);t.exports=function(){function t(){!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t),this.head=null,this.tail=null,this.length=0}return t.prototype.push=function(t){var e={data:t,next:null};this.length>0?this.tail.next=e:this.head=e,this.tail=e,++this.length},t.prototype.unshift=function(t){var e={data:t,next:this.head};0===this.length&&(this.tail=e),this.head=e,++this.length},t.prototype.shift=function(){if(0!==this.length){var t=this.head.data;return 1===this.length?this.head=this.tail=null:this.head=this.head.next,--this.length,t}},t.prototype.clear=function(){this.head=this.tail=null,this.length=0},t.prototype.join=function(t){if(0===this.length)return"";for(var e=this.head,r=""+e.data;e=e.next;)r+=t+e.data;return r},t.prototype.concat=function(t){if(0===this.length)return n.alloc(0);for(var e,r,i,o=n.allocUnsafe(t>>>0),s=this.head,a=0;s;)e=s.data,r=o,i=a,e.copy(r,i),a+=s.data.length,s=s.next;return o},t}(),i&&i.inspect&&i.inspect.custom&&(t.exports.prototype[i.inspect.custom]=function(){var t=i.inspect({length:this.length});return this.constructor.name+" "+t})},function(t,e){},function(t,e,r){(function(t){var n=void 0!==t&&t||"undefined"!=typeof self&&self||window,i=Function.prototype.apply;function o(t,e){this._id=t,this._clearFn=e}e.setTimeout=function(){return new o(i.call(setTimeout,n,arguments),clearTimeout)},e.setInterval=function(){return new o(i.call(setInterval,n,arguments),clearInterval)},e.clearTimeout=e.clearInterval=function(t){t&&t.close()},o.prototype.unref=o.prototype.ref=function(){},o.prototype.close=function(){this._clearFn.call(n,this._id)},e.enroll=function(t,e){clearTimeout(t._idleTimeoutId),t._idleTimeout=e},e.unenroll=function(t){clearTimeout(t._idleTimeoutId),t._idleTimeout=-1},e._unrefActive=e.active=function(t){clearTimeout(t._idleTimeoutId);var e=t._idleTimeout;e>=0&&(t._idleTimeoutId=setTimeout((function(){t._onTimeout&&t._onTimeout()}),e))},r(114),e.setImmediate="undefined"!=typeof self&&self.setImmediate||void 0!==t&&t.setImmediate||this&&this.setImmediate,e.clearImmediate="undefined"!=typeof self&&self.clearImmediate||void 0!==t&&t.clearImmediate||this&&this.clearImmediate}).call(this,r(3))},function(t,e,r){(function(t,e){!function(t,r){"use strict";if(!t.setImmediate){var n,i,o,s,a,u=1,c={},l=!1,f=t.document,h=Object.getPrototypeOf&&Object.getPrototypeOf(t);h=h&&h.setTimeout?h:t,"[object process]"==={}.toString.call(t.process)?n=function(t){e.nextTick((function(){p(t)}))}:!function(){if(t.postMessage&&!t.importScripts){var e=!0,r=t.onmessage;return t.onmessage=function(){e=!1},t.postMessage("","*"),t.onmessage=r,e}}()?t.MessageChannel?((o=new MessageChannel).port1.onmessage=function(t){p(t.data)},n=function(t){o.port2.postMessage(t)}):f&&"onreadystatechange"in f.createElement("script")?(i=f.documentElement,n=function(t){var e=f.createElement("script");e.onreadystatechange=function(){p(t),e.onreadystatechange=null,i.removeChild(e),e=null},i.appendChild(e)}):n=function(t){setTimeout(p,0,t)}:(s="setImmediate$"+Math.random()+"$",a=function(e){e.source===t&&"string"==typeof e.data&&0===e.data.indexOf(s)&&p(+e.data.slice(s.length))},t.addEventListener?t.addEventListener("message",a,!1):t.attachEvent("onmessage",a),n=function(e){t.postMessage(s+e,"*")}),h.setImmediate=function(t){"function"!=typeof t&&(t=new Function(""+t));for(var e=new Array(arguments.length-1),r=0;r<e.length;r++)e[r]=arguments[r+1];var i={callback:t,args:e};return c[u]=i,n(u),u++},h.clearImmediate=d}function d(t){delete c[t]}function p(t){if(l)setTimeout(p,0,t);else{var e=c[t];if(e){l=!0;try{!function(t){var e=t.callback,r=t.args;switch(r.length){case 0:e();break;case 1:e(r[0]);break;case 2:e(r[0],r[1]);break;case 3:e(r[0],r[1],r[2]);break;default:e.apply(void 0,r)}}(e)}finally{d(t),l=!1}}}}}("undefined"==typeof self?void 0===t?this:t:self)}).call(this,r(3),r(7))},function(t,e,r){(function(e){function r(t){try{if(!e.localStorage)return!1}catch(t){return!1}var r=e.localStorage[t];return null!=r&&"true"===String(r).toLowerCase()}t.exports=function(t,e){if(r("noDeprecation"))return t;var n=!1;return function(){if(!n){if(r("throwDeprecation"))throw new Error(e);r("traceDeprecation")?console.trace(e):console.warn(e),n=!0}return t.apply(this,arguments)}}}).call(this,r(3))},function(t,e,r){var n=r(9),i=n.Buffer;function o(t,e){for(var r in t)e[r]=t[r]}function s(t,e,r){return i(t,e,r)}i.from&&i.alloc&&i.allocUnsafe&&i.allocUnsafeSlow?t.exports=n:(o(n,e),e.Buffer=s),o(i,s),s.from=function(t,e,r){if("number"==typeof t)throw new TypeError("Argument must not be a number");return i(t,e,r)},s.alloc=function(t,e,r){if("number"!=typeof t)throw new TypeError("Argument must be a number");var n=i(t);return void 0!==e?"string"==typeof r?n.fill(e,r):n.fill(e):n.fill(0),n},s.allocUnsafe=function(t){if("number"!=typeof t)throw new TypeError("Argument must be a number");return i(t)},s.allocUnsafeSlow=function(t){if("number"!=typeof t)throw new TypeError("Argument must be a number");return n.SlowBuffer(t)}},function(t,e,r){"use strict";t.exports=o;var n=r(67),i=Object.create(r(21));function o(t){if(!(this instanceof o))return new o(t);n.call(this,t)}i.inherits=r(10),i.inherits(o,n),o.prototype._transform=function(t,e,r){r(null,t)}},function(t,e,r){"use strict";var n=r(29),i=r(119),o=r(120),s=r(121),a=r(122);function u(t){return(t>>>24&255)+(t>>>8&65280)+((65280&t)<<8)+((255&t)<<24)}function c(){this.mode=0,this.last=!1,this.wrap=0,this.havedict=!1,this.flags=0,this.dmax=0,this.check=0,this.total=0,this.head=null,this.wbits=0,this.wsize=0,this.whave=0,this.wnext=0,this.window=null,this.hold=0,this.bits=0,this.length=0,this.offset=0,this.extra=0,this.lencode=null,this.distcode=null,this.lenbits=0,this.distbits=0,this.ncode=0,this.nlen=0,this.ndist=0,this.have=0,this.next=null,this.lens=new n.Buf16(320),this.work=new n.Buf16(288),this.lendyn=null,this.distdyn=null,this.sane=0,this.back=0,this.was=0}function l(t){var e;return t&&t.state?(e=t.state,t.total_in=t.total_out=e.total=0,t.msg="",e.wrap&&(t.adler=1&e.wrap),e.mode=1,e.last=0,e.havedict=0,e.dmax=32768,e.head=null,e.hold=0,e.bits=0,e.lencode=e.lendyn=new n.Buf32(852),e.distcode=e.distdyn=new n.Buf32(592),e.sane=1,e.back=-1,0):-2}function f(t){var e;return t&&t.state?((e=t.state).wsize=0,e.whave=0,e.wnext=0,l(t)):-2}function h(t,e){var r,n;return t&&t.state?(n=t.state,e<0?(r=0,e=-e):(r=1+(e>>4),e<48&&(e&=15)),e&&(e<8||e>15)?-2:(null!==n.window&&n.wbits!==e&&(n.window=null),n.wrap=r,n.wbits=e,f(t))):-2}function d(t,e){var r,n;return t?(n=new c,t.state=n,n.window=null,0!==(r=h(t,e))&&(t.state=null),r):-2}var p,y,g=!0;function m(t){if(g){var e;for(p=new n.Buf32(512),y=new n.Buf32(32),e=0;e<144;)t.lens[e++]=8;for(;e<256;)t.lens[e++]=9;for(;e<280;)t.lens[e++]=7;for(;e<288;)t.lens[e++]=8;for(a(1,t.lens,0,288,p,0,t.work,{bits:9}),e=0;e<32;)t.lens[e++]=5;a(2,t.lens,0,32,y,0,t.work,{bits:5}),g=!1}t.lencode=p,t.lenbits=9,t.distcode=y,t.distbits=5}function b(t,e,r,i){var o,s=t.state;return null===s.window&&(s.wsize=1<<s.wbits,s.wnext=0,s.whave=0,s.window=new n.Buf8(s.wsize)),i>=s.wsize?(n.arraySet(s.window,e,r-s.wsize,s.wsize,0),s.wnext=0,s.whave=s.wsize):((o=s.wsize-s.wnext)>i&&(o=i),n.arraySet(s.window,e,r-i,o,s.wnext),(i-=o)?(n.arraySet(s.window,e,r-i,i,0),s.wnext=i,s.whave=s.wsize):(s.wnext+=o,s.wnext===s.wsize&&(s.wnext=0),s.whave<s.wsize&&(s.whave+=o))),0}e.inflateReset=f,e.inflateReset2=h,e.inflateResetKeep=l,e.inflateInit=function(t){return d(t,15)},e.inflateInit2=d,e.inflate=function(t,e){var r,c,l,f,h,d,p,y,g,v,w,x,_,S,A,E,k,T,C,O,I,P,R,j,M=0,L=new n.Buf8(4),F=[16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15];if(!t||!t.state||!t.output||!t.input&&0!==t.avail_in)return-2;12===(r=t.state).mode&&(r.mode=13),h=t.next_out,l=t.output,p=t.avail_out,f=t.next_in,c=t.input,d=t.avail_in,y=r.hold,g=r.bits,v=d,w=p,P=0;t:for(;;)switch(r.mode){case 1:if(0===r.wrap){r.mode=13;break}for(;g<16;){if(0===d)break t;d--,y+=c[f++]<<g,g+=8}if(2&r.wrap&&35615===y){r.check=0,L[0]=255&y,L[1]=y>>>8&255,r.check=o(r.check,L,2,0),y=0,g=0,r.mode=2;break}if(r.flags=0,r.head&&(r.head.done=!1),!(1&r.wrap)||(((255&y)<<8)+(y>>8))%31){t.msg="incorrect header check",r.mode=30;break}if(8!=(15&y)){t.msg="unknown compression method",r.mode=30;break}if(g-=4,I=8+(15&(y>>>=4)),0===r.wbits)r.wbits=I;else if(I>r.wbits){t.msg="invalid window size",r.mode=30;break}r.dmax=1<<I,t.adler=r.check=1,r.mode=512&y?10:12,y=0,g=0;break;case 2:for(;g<16;){if(0===d)break t;d--,y+=c[f++]<<g,g+=8}if(r.flags=y,8!=(255&r.flags)){t.msg="unknown compression method",r.mode=30;break}if(57344&r.flags){t.msg="unknown header flags set",r.mode=30;break}r.head&&(r.head.text=y>>8&1),512&r.flags&&(L[0]=255&y,L[1]=y>>>8&255,r.check=o(r.check,L,2,0)),y=0,g=0,r.mode=3;case 3:for(;g<32;){if(0===d)break t;d--,y+=c[f++]<<g,g+=8}r.head&&(r.head.time=y),512&r.flags&&(L[0]=255&y,L[1]=y>>>8&255,L[2]=y>>>16&255,L[3]=y>>>24&255,r.check=o(r.check,L,4,0)),y=0,g=0,r.mode=4;case 4:for(;g<16;){if(0===d)break t;d--,y+=c[f++]<<g,g+=8}r.head&&(r.head.xflags=255&y,r.head.os=y>>8),512&r.flags&&(L[0]=255&y,L[1]=y>>>8&255,r.check=o(r.check,L,2,0)),y=0,g=0,r.mode=5;case 5:if(1024&r.flags){for(;g<16;){if(0===d)break t;d--,y+=c[f++]<<g,g+=8}r.length=y,r.head&&(r.head.extra_len=y),512&r.flags&&(L[0]=255&y,L[1]=y>>>8&255,r.check=o(r.check,L,2,0)),y=0,g=0}else r.head&&(r.head.extra=null);r.mode=6;case 6:if(1024&r.flags&&((x=r.length)>d&&(x=d),x&&(r.head&&(I=r.head.extra_len-r.length,r.head.extra||(r.head.extra=new Array(r.head.extra_len)),n.arraySet(r.head.extra,c,f,x,I)),512&r.flags&&(r.check=o(r.check,c,x,f)),d-=x,f+=x,r.length-=x),r.length))break t;r.length=0,r.mode=7;case 7:if(2048&r.flags){if(0===d)break t;x=0;do{I=c[f+x++],r.head&&I&&r.length<65536&&(r.head.name+=String.fromCharCode(I))}while(I&&x<d);if(512&r.flags&&(r.check=o(r.check,c,x,f)),d-=x,f+=x,I)break t}else r.head&&(r.head.name=null);r.length=0,r.mode=8;case 8:if(4096&r.flags){if(0===d)break t;x=0;do{I=c[f+x++],r.head&&I&&r.length<65536&&(r.head.comment+=String.fromCharCode(I))}while(I&&x<d);if(512&r.flags&&(r.check=o(r.check,c,x,f)),d-=x,f+=x,I)break t}else r.head&&(r.head.comment=null);r.mode=9;case 9:if(512&r.flags){for(;g<16;){if(0===d)break t;d--,y+=c[f++]<<g,g+=8}if(y!==(65535&r.check)){t.msg="header crc mismatch",r.mode=30;break}y=0,g=0}r.head&&(r.head.hcrc=r.flags>>9&1,r.head.done=!0),t.adler=r.check=0,r.mode=12;break;case 10:for(;g<32;){if(0===d)break t;d--,y+=c[f++]<<g,g+=8}t.adler=r.check=u(y),y=0,g=0,r.mode=11;case 11:if(0===r.havedict)return t.next_out=h,t.avail_out=p,t.next_in=f,t.avail_in=d,r.hold=y,r.bits=g,2;t.adler=r.check=1,r.mode=12;case 12:if(5===e||6===e)break t;case 13:if(r.last){y>>>=7&g,g-=7&g,r.mode=27;break}for(;g<3;){if(0===d)break t;d--,y+=c[f++]<<g,g+=8}switch(r.last=1&y,g-=1,3&(y>>>=1)){case 0:r.mode=14;break;case 1:if(m(r),r.mode=20,6===e){y>>>=2,g-=2;break t}break;case 2:r.mode=17;break;case 3:t.msg="invalid block type",r.mode=30}y>>>=2,g-=2;break;case 14:for(y>>>=7&g,g-=7&g;g<32;){if(0===d)break t;d--,y+=c[f++]<<g,g+=8}if((65535&y)!=(y>>>16^65535)){t.msg="invalid stored block lengths",r.mode=30;break}if(r.length=65535&y,y=0,g=0,r.mode=15,6===e)break t;case 15:r.mode=16;case 16:if(x=r.length){if(x>d&&(x=d),x>p&&(x=p),0===x)break t;n.arraySet(l,c,f,x,h),d-=x,f+=x,p-=x,h+=x,r.length-=x;break}r.mode=12;break;case 17:for(;g<14;){if(0===d)break t;d--,y+=c[f++]<<g,g+=8}if(r.nlen=257+(31&y),y>>>=5,g-=5,r.ndist=1+(31&y),y>>>=5,g-=5,r.ncode=4+(15&y),y>>>=4,g-=4,r.nlen>286||r.ndist>30){t.msg="too many length or distance symbols",r.mode=30;break}r.have=0,r.mode=18;case 18:for(;r.have<r.ncode;){for(;g<3;){if(0===d)break t;d--,y+=c[f++]<<g,g+=8}r.lens[F[r.have++]]=7&y,y>>>=3,g-=3}for(;r.have<19;)r.lens[F[r.have++]]=0;if(r.lencode=r.lendyn,r.lenbits=7,R={bits:r.lenbits},P=a(0,r.lens,0,19,r.lencode,0,r.work,R),r.lenbits=R.bits,P){t.msg="invalid code lengths set",r.mode=30;break}r.have=0,r.mode=19;case 19:for(;r.have<r.nlen+r.ndist;){for(;E=(M=r.lencode[y&(1<<r.lenbits)-1])>>>16&255,k=65535&M,!((A=M>>>24)<=g);){if(0===d)break t;d--,y+=c[f++]<<g,g+=8}if(k<16)y>>>=A,g-=A,r.lens[r.have++]=k;else{if(16===k){for(j=A+2;g<j;){if(0===d)break t;d--,y+=c[f++]<<g,g+=8}if(y>>>=A,g-=A,0===r.have){t.msg="invalid bit length repeat",r.mode=30;break}I=r.lens[r.have-1],x=3+(3&y),y>>>=2,g-=2}else if(17===k){for(j=A+3;g<j;){if(0===d)break t;d--,y+=c[f++]<<g,g+=8}g-=A,I=0,x=3+(7&(y>>>=A)),y>>>=3,g-=3}else{for(j=A+7;g<j;){if(0===d)break t;d--,y+=c[f++]<<g,g+=8}g-=A,I=0,x=11+(127&(y>>>=A)),y>>>=7,g-=7}if(r.have+x>r.nlen+r.ndist){t.msg="invalid bit length repeat",r.mode=30;break}for(;x--;)r.lens[r.have++]=I}}if(30===r.mode)break;if(0===r.lens[256]){t.msg="invalid code -- missing end-of-block",r.mode=30;break}if(r.lenbits=9,R={bits:r.lenbits},P=a(1,r.lens,0,r.nlen,r.lencode,0,r.work,R),r.lenbits=R.bits,P){t.msg="invalid literal/lengths set",r.mode=30;break}if(r.distbits=6,r.distcode=r.distdyn,R={bits:r.distbits},P=a(2,r.lens,r.nlen,r.ndist,r.distcode,0,r.work,R),r.distbits=R.bits,P){t.msg="invalid distances set",r.mode=30;break}if(r.mode=20,6===e)break t;case 20:r.mode=21;case 21:if(d>=6&&p>=258){t.next_out=h,t.avail_out=p,t.next_in=f,t.avail_in=d,r.hold=y,r.bits=g,s(t,w),h=t.next_out,l=t.output,p=t.avail_out,f=t.next_in,c=t.input,d=t.avail_in,y=r.hold,g=r.bits,12===r.mode&&(r.back=-1);break}for(r.back=0;E=(M=r.lencode[y&(1<<r.lenbits)-1])>>>16&255,k=65535&M,!((A=M>>>24)<=g);){if(0===d)break t;d--,y+=c[f++]<<g,g+=8}if(E&&0==(240&E)){for(T=A,C=E,O=k;E=(M=r.lencode[O+((y&(1<<T+C)-1)>>T)])>>>16&255,k=65535&M,!(T+(A=M>>>24)<=g);){if(0===d)break t;d--,y+=c[f++]<<g,g+=8}y>>>=T,g-=T,r.back+=T}if(y>>>=A,g-=A,r.back+=A,r.length=k,0===E){r.mode=26;break}if(32&E){r.back=-1,r.mode=12;break}if(64&E){t.msg="invalid literal/length code",r.mode=30;break}r.extra=15&E,r.mode=22;case 22:if(r.extra){for(j=r.extra;g<j;){if(0===d)break t;d--,y+=c[f++]<<g,g+=8}r.length+=y&(1<<r.extra)-1,y>>>=r.extra,g-=r.extra,r.back+=r.extra}r.was=r.length,r.mode=23;case 23:for(;E=(M=r.distcode[y&(1<<r.distbits)-1])>>>16&255,k=65535&M,!((A=M>>>24)<=g);){if(0===d)break t;d--,y+=c[f++]<<g,g+=8}if(0==(240&E)){for(T=A,C=E,O=k;E=(M=r.distcode[O+((y&(1<<T+C)-1)>>T)])>>>16&255,k=65535&M,!(T+(A=M>>>24)<=g);){if(0===d)break t;d--,y+=c[f++]<<g,g+=8}y>>>=T,g-=T,r.back+=T}if(y>>>=A,g-=A,r.back+=A,64&E){t.msg="invalid distance code",r.mode=30;break}r.offset=k,r.extra=15&E,r.mode=24;case 24:if(r.extra){for(j=r.extra;g<j;){if(0===d)break t;d--,y+=c[f++]<<g,g+=8}r.offset+=y&(1<<r.extra)-1,y>>>=r.extra,g-=r.extra,r.back+=r.extra}if(r.offset>r.dmax){t.msg="invalid distance too far back",r.mode=30;break}r.mode=25;case 25:if(0===p)break t;if(x=w-p,r.offset>x){if((x=r.offset-x)>r.whave&&r.sane){t.msg="invalid distance too far back",r.mode=30;break}x>r.wnext?(x-=r.wnext,_=r.wsize-x):_=r.wnext-x,x>r.length&&(x=r.length),S=r.window}else S=l,_=h-r.offset,x=r.length;x>p&&(x=p),p-=x,r.length-=x;do{l[h++]=S[_++]}while(--x);0===r.length&&(r.mode=21);break;case 26:if(0===p)break t;l[h++]=r.length,p--,r.mode=21;break;case 27:if(r.wrap){for(;g<32;){if(0===d)break t;d--,y|=c[f++]<<g,g+=8}if(w-=p,t.total_out+=w,r.total+=w,w&&(t.adler=r.check=r.flags?o(r.check,l,w,h-w):i(r.check,l,w,h-w)),w=p,(r.flags?y:u(y))!==r.check){t.msg="incorrect data check",r.mode=30;break}y=0,g=0}r.mode=28;case 28:if(r.wrap&&r.flags){for(;g<32;){if(0===d)break t;d--,y+=c[f++]<<g,g+=8}if(y!==(4294967295&r.total)){t.msg="incorrect length check",r.mode=30;break}y=0,g=0}r.mode=29;case 29:P=1;break t;case 30:P=-3;break t;case 31:return-4;case 32:default:return-2}return t.next_out=h,t.avail_out=p,t.next_in=f,t.avail_in=d,r.hold=y,r.bits=g,(r.wsize||w!==t.avail_out&&r.mode<30&&(r.mode<27||4!==e))&&b(t,t.output,t.next_out,w-t.avail_out)?(r.mode=31,-4):(v-=t.avail_in,w-=t.avail_out,t.total_in+=v,t.total_out+=w,r.total+=w,r.wrap&&w&&(t.adler=r.check=r.flags?o(r.check,l,w,t.next_out-w):i(r.check,l,w,t.next_out-w)),t.data_type=r.bits+(r.last?64:0)+(12===r.mode?128:0)+(20===r.mode||15===r.mode?256:0),(0===v&&0===w||4===e)&&0===P&&(P=-5),P)},e.inflateEnd=function(t){if(!t||!t.state)return-2;var e=t.state;return e.window&&(e.window=null),t.state=null,0},e.inflateGetHeader=function(t,e){var r;return t&&t.state?0==(2&(r=t.state).wrap)?-2:(r.head=e,e.done=!1,0):-2},e.inflateSetDictionary=function(t,e){var r,n=e.length;return t&&t.state?0!==(r=t.state).wrap&&11!==r.mode?-2:11===r.mode&&i(1,e,n,0)!==r.check?-3:b(t,e,n,n)?(r.mode=31,-4):(r.havedict=1,0):-2},e.inflateInfo="pako inflate (from Nodeca project)"},function(t,e,r){"use strict";t.exports=function(t,e,r,n){for(var i=65535&t|0,o=t>>>16&65535|0,s=0;0!==r;){r-=s=r>2e3?2e3:r;do{o=o+(i=i+e[n++]|0)|0}while(--s);i%=65521,o%=65521}return i|o<<16|0}},function(t,e,r){"use strict";var n=function(){for(var t,e=[],r=0;r<256;r++){t=r;for(var n=0;n<8;n++)t=1&t?3988292384^t>>>1:t>>>1;e[r]=t}return e}();t.exports=function(t,e,r,i){var o=n,s=i+r;t^=-1;for(var a=i;a<s;a++)t=t>>>8^o[255&(t^e[a])];return-1^t}},function(t,e,r){"use strict";t.exports=function(t,e){var r,n,i,o,s,a,u,c,l,f,h,d,p,y,g,m,b,v,w,x,_,S,A,E,k;r=t.state,n=t.next_in,E=t.input,i=n+(t.avail_in-5),o=t.next_out,k=t.output,s=o-(e-t.avail_out),a=o+(t.avail_out-257),u=r.dmax,c=r.wsize,l=r.whave,f=r.wnext,h=r.window,d=r.hold,p=r.bits,y=r.lencode,g=r.distcode,m=(1<<r.lenbits)-1,b=(1<<r.distbits)-1;t:do{p<15&&(d+=E[n++]<<p,p+=8,d+=E[n++]<<p,p+=8),v=y[d&m];e:for(;;){if(d>>>=w=v>>>24,p-=w,0===(w=v>>>16&255))k[o++]=65535&v;else{if(!(16&w)){if(0==(64&w)){v=y[(65535&v)+(d&(1<<w)-1)];continue e}if(32&w){r.mode=12;break t}t.msg="invalid literal/length code",r.mode=30;break t}x=65535&v,(w&=15)&&(p<w&&(d+=E[n++]<<p,p+=8),x+=d&(1<<w)-1,d>>>=w,p-=w),p<15&&(d+=E[n++]<<p,p+=8,d+=E[n++]<<p,p+=8),v=g[d&b];r:for(;;){if(d>>>=w=v>>>24,p-=w,!(16&(w=v>>>16&255))){if(0==(64&w)){v=g[(65535&v)+(d&(1<<w)-1)];continue r}t.msg="invalid distance code",r.mode=30;break t}if(_=65535&v,p<(w&=15)&&(d+=E[n++]<<p,(p+=8)<w&&(d+=E[n++]<<p,p+=8)),(_+=d&(1<<w)-1)>u){t.msg="invalid distance too far back",r.mode=30;break t}if(d>>>=w,p-=w,_>(w=o-s)){if((w=_-w)>l&&r.sane){t.msg="invalid distance too far back",r.mode=30;break t}if(S=0,A=h,0===f){if(S+=c-w,w<x){x-=w;do{k[o++]=h[S++]}while(--w);S=o-_,A=k}}else if(f<w){if(S+=c+f-w,(w-=f)<x){x-=w;do{k[o++]=h[S++]}while(--w);if(S=0,f<x){x-=w=f;do{k[o++]=h[S++]}while(--w);S=o-_,A=k}}}else if(S+=f-w,w<x){x-=w;do{k[o++]=h[S++]}while(--w);S=o-_,A=k}for(;x>2;)k[o++]=A[S++],k[o++]=A[S++],k[o++]=A[S++],x-=3;x&&(k[o++]=A[S++],x>1&&(k[o++]=A[S++]))}else{S=o-_;do{k[o++]=k[S++],k[o++]=k[S++],k[o++]=k[S++],x-=3}while(x>2);x&&(k[o++]=k[S++],x>1&&(k[o++]=k[S++]))}break}}break}}while(n<i&&o<a);n-=x=p>>3,d&=(1<<(p-=x<<3))-1,t.next_in=n,t.next_out=o,t.avail_in=n<i?i-n+5:5-(n-i),t.avail_out=o<a?a-o+257:257-(o-a),r.hold=d,r.bits=p}},function(t,e,r){"use strict";var n=r(29),i=[3,4,5,6,7,8,9,10,11,13,15,17,19,23,27,31,35,43,51,59,67,83,99,115,131,163,195,227,258,0,0],o=[16,16,16,16,16,16,16,16,17,17,17,17,18,18,18,18,19,19,19,19,20,20,20,20,21,21,21,21,16,72,78],s=[1,2,3,4,5,7,9,13,17,25,33,49,65,97,129,193,257,385,513,769,1025,1537,2049,3073,4097,6145,8193,12289,16385,24577,0,0],a=[16,16,16,16,17,17,18,18,19,19,20,20,21,21,22,22,23,23,24,24,25,25,26,26,27,27,28,28,29,29,64,64];t.exports=function(t,e,r,u,c,l,f,h){var d,p,y,g,m,b,v,w,x,_=h.bits,S=0,A=0,E=0,k=0,T=0,C=0,O=0,I=0,P=0,R=0,j=null,M=0,L=new n.Buf16(16),F=new n.Buf16(16),N=null,D=0;for(S=0;S<=15;S++)L[S]=0;for(A=0;A<u;A++)L[e[r+A]]++;for(T=_,k=15;k>=1&&0===L[k];k--);if(T>k&&(T=k),0===k)return c[l++]=20971520,c[l++]=20971520,h.bits=1,0;for(E=1;E<k&&0===L[E];E++);for(T<E&&(T=E),I=1,S=1;S<=15;S++)if(I<<=1,(I-=L[S])<0)return-1;if(I>0&&(0===t||1!==k))return-1;for(F[1]=0,S=1;S<15;S++)F[S+1]=F[S]+L[S];for(A=0;A<u;A++)0!==e[r+A]&&(f[F[e[r+A]]++]=A);if(0===t?(j=N=f,b=19):1===t?(j=i,M-=257,N=o,D-=257,b=256):(j=s,N=a,b=-1),R=0,A=0,S=E,m=l,C=T,O=0,y=-1,g=(P=1<<T)-1,1===t&&P>852||2===t&&P>592)return 1;for(;;){v=S-O,f[A]<b?(w=0,x=f[A]):f[A]>b?(w=N[D+f[A]],x=j[M+f[A]]):(w=96,x=0),d=1<<S-O,E=p=1<<C;do{c[m+(R>>O)+(p-=d)]=v<<24|w<<16|x|0}while(0!==p);for(d=1<<S-1;R&d;)d>>=1;if(0!==d?(R&=d-1,R+=d):R=0,A++,0==--L[S]){if(S===k)break;S=e[r+f[A]]}if(S>T&&(R&g)!==y){for(0===O&&(O=T),m+=E,I=1<<(C=S-O);C+O<k&&!((I-=L[C+O])<=0);)C++,I<<=1;if(P+=1<<C,1===t&&P>852||2===t&&P>592)return 1;c[y=R&g]=T<<24|C<<16|m-l|0}}return 0!==R&&(c[m+R]=S-O<<24|64<<16|0),h.bits=T,0}},function(t,e,r){"use strict";var n=r(29),i=!0,o=!0;try{String.fromCharCode.apply(null,[0])}catch(t){i=!1}try{String.fromCharCode.apply(null,new Uint8Array(1))}catch(t){o=!1}for(var s=new n.Buf8(256),a=0;a<256;a++)s[a]=a>=252?6:a>=248?5:a>=240?4:a>=224?3:a>=192?2:1;function u(t,e){if(e<65534&&(t.subarray&&o||!t.subarray&&i))return String.fromCharCode.apply(null,n.shrinkBuf(t,e));for(var r="",s=0;s<e;s++)r+=String.fromCharCode(t[s]);return r}s[254]=s[254]=1,e.string2buf=function(t){var e,r,i,o,s,a=t.length,u=0;for(o=0;o<a;o++)55296==(64512&(r=t.charCodeAt(o)))&&o+1<a&&56320==(64512&(i=t.charCodeAt(o+1)))&&(r=65536+(r-55296<<10)+(i-56320),o++),u+=r<128?1:r<2048?2:r<65536?3:4;for(e=new n.Buf8(u),s=0,o=0;s<u;o++)55296==(64512&(r=t.charCodeAt(o)))&&o+1<a&&56320==(64512&(i=t.charCodeAt(o+1)))&&(r=65536+(r-55296<<10)+(i-56320),o++),r<128?e[s++]=r:r<2048?(e[s++]=192|r>>>6,e[s++]=128|63&r):r<65536?(e[s++]=224|r>>>12,e[s++]=128|r>>>6&63,e[s++]=128|63&r):(e[s++]=240|r>>>18,e[s++]=128|r>>>12&63,e[s++]=128|r>>>6&63,e[s++]=128|63&r);return e},e.buf2binstring=function(t){return u(t,t.length)},e.binstring2buf=function(t){for(var e=new n.Buf8(t.length),r=0,i=e.length;r<i;r++)e[r]=t.charCodeAt(r);return e},e.buf2string=function(t,e){var r,n,i,o,a=e||t.length,c=new Array(2*a);for(n=0,r=0;r<a;)if((i=t[r++])<128)c[n++]=i;else if((o=s[i])>4)c[n++]=65533,r+=o-1;else{for(i&=2===o?31:3===o?15:7;o>1&&r<a;)i=i<<6|63&t[r++],o--;o>1?c[n++]=65533:i<65536?c[n++]=i:(i-=65536,c[n++]=55296|i>>10&1023,c[n++]=56320|1023&i)}return u(c,n)},e.utf8border=function(t,e){var r;for((e=e||t.length)>t.length&&(e=t.length),r=e-1;r>=0&&128==(192&t[r]);)r--;return r<0||0===r?e:r+s[t[r]]>e?r:e}},function(t,e,r){"use strict";t.exports={Z_NO_FLUSH:0,Z_PARTIAL_FLUSH:1,Z_SYNC_FLUSH:2,Z_FULL_FLUSH:3,Z_FINISH:4,Z_BLOCK:5,Z_TREES:6,Z_OK:0,Z_STREAM_END:1,Z_NEED_DICT:2,Z_ERRNO:-1,Z_STREAM_ERROR:-2,Z_DATA_ERROR:-3,Z_BUF_ERROR:-5,Z_NO_COMPRESSION:0,Z_BEST_SPEED:1,Z_BEST_COMPRESSION:9,Z_DEFAULT_COMPRESSION:-1,Z_FILTERED:1,Z_HUFFMAN_ONLY:2,Z_RLE:3,Z_FIXED:4,Z_DEFAULT_STRATEGY:0,Z_BINARY:0,Z_TEXT:1,Z_UNKNOWN:2,Z_DEFLATED:8}},function(t,e,r){"use strict";t.exports={2:"need dictionary",1:"stream end",0:"","-1":"file error","-2":"stream error","-3":"data error","-4":"insufficient memory","-5":"buffer error","-6":"incompatible version"}},function(t,e,r){"use strict";t.exports=function(){this.input=null,this.next_in=0,this.avail_in=0,this.total_in=0,this.output=null,this.next_out=0,this.avail_out=0,this.total_out=0,this.msg="",this.state=null,this.data_type=2,this.adler=0}},function(t,e,r){"use strict";t.exports=function(){this.text=0,this.time=0,this.xflags=0,this.os=0,this.extra=null,this.extra_len=0,this.name="",this.comment="",this.hcrc=0,this.done=!1}},function(t,e,r){t.exports=r.p+"0.bce5ef15ddaa1e171e9d.worker.worker.js"},function(t,e,r){t.exports=function(t){function e(t){let r,i,o,s=null;function a(...t){if(!a.enabled)return;const n=a,i=Number(new Date),o=i-(r||i);n.diff=o,n.prev=r,n.curr=i,r=i,t[0]=e.coerce(t[0]),"string"!=typeof t[0]&&t.unshift("%O");let s=0;t[0]=t[0].replace(/%([a-zA-Z%])/g,(r,i)=>{if("%%"===r)return"%";s++;const o=e.formatters[i];if("function"==typeof o){const e=t[s];r=o.call(n,e),t.splice(s,1),s--}return r}),e.formatArgs.call(n,t);(n.log||e.log).apply(n,t)}return a.namespace=t,a.useColors=e.useColors(),a.color=e.selectColor(t),a.extend=n,a.destroy=e.destroy,Object.defineProperty(a,"enabled",{enumerable:!0,configurable:!1,get:()=>null!==s?s:(i!==e.namespaces&&(i=e.namespaces,o=e.enabled(t)),o),set:t=>{s=t}}),"function"==typeof e.init&&e.init(a),a}function n(t,r){const n=e(this.namespace+(void 0===r?":":r)+t);return n.log=this.log,n}function i(t){return t.toString().substring(2,t.toString().length-2).replace(/\\.\\*\\?$/,"*")}return e.debug=e,e.default=e,e.coerce=function(t){if(t instanceof Error)return t.stack||t.message;return t},e.disable=function(){const t=[...e.names.map(i),...e.skips.map(i).map(t=>"-"+t)].join(",");return e.enable(""),t},e.enable=function(t){let r;e.save(t),e.namespaces=t,e.names=[],e.skips=[];const n=("string"==typeof t?t:"").split(/[\\s,]+/),i=n.length;for(r=0;r<i;r++)n[r]&&("-"===(t=n[r].replace(/\\*/g,".*?"))[0]?e.skips.push(new RegExp("^"+t.slice(1)+"$")):e.names.push(new RegExp("^"+t+"$")))},e.enabled=function(t){if("*"===t[t.length-1])return!0;let r,n;for(r=0,n=e.skips.length;r<n;r++)if(e.skips[r].test(t))return!1;for(r=0,n=e.names.length;r<n;r++)if(e.names[r].test(t))return!0;return!1},e.humanize=r(130),e.destroy=function(){console.warn("Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.")},Object.keys(t).forEach(r=>{e[r]=t[r]}),e.names=[],e.skips=[],e.formatters={},e.selectColor=function(t){let r=0;for(let e=0;e<t.length;e++)r=(r<<5)-r+t.charCodeAt(e),r|=0;return e.colors[Math.abs(r)%e.colors.length]},e.enable(e.load()),e}},function(t,e){var r=1e3,n=6e4,i=60*n,o=24*i;function s(t,e,r,n){var i=e>=1.5*r;return Math.round(t/r)+" "+n+(i?"s":"")}t.exports=function(t,e){e=e||{};var a=typeof t;if("string"===a&&t.length>0)return function(t){if((t=String(t)).length>100)return;var e=/^(-?(?:\\d+)?\\.?\\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(t);if(!e)return;var s=parseFloat(e[1]);switch((e[2]||"ms").toLowerCase()){case"years":case"year":case"yrs":case"yr":case"y":return 315576e5*s;case"weeks":case"week":case"w":return 6048e5*s;case"days":case"day":case"d":return s*o;case"hours":case"hour":case"hrs":case"hr":case"h":return s*i;case"minutes":case"minute":case"mins":case"min":case"m":return s*n;case"seconds":case"second":case"secs":case"sec":case"s":return s*r;case"milliseconds":case"millisecond":case"msecs":case"msec":case"ms":return s;default:return}}(t);if("number"===a&&isFinite(t))return e.long?function(t){var e=Math.abs(t);if(e>=o)return s(t,e,o,"day");if(e>=i)return s(t,e,i,"hour");if(e>=n)return s(t,e,n,"minute");if(e>=r)return s(t,e,r,"second");return t+" ms"}(t):function(t){var e=Math.abs(t);if(e>=o)return Math.round(t/o)+"d";if(e>=i)return Math.round(t/i)+"h";if(e>=n)return Math.round(t/n)+"m";if(e>=r)return Math.round(t/r)+"s";return t+"ms"}(t);throw new Error("val is not a non-empty string or a valid number. val="+JSON.stringify(t))}},function(t,e,r){(function(e,n,i){var o=r(69),s=r(10),a=r(70),u=r(42),c=r(132),l=a.IncomingMessage,f=a.readyStates;var h=t.exports=function(t){var r,n=this;u.Writable.call(n),n._opts=t,n._body=[],n._headers={},t.auth&&n.setHeader("Authorization","Basic "+new e(t.auth).toString("base64")),Object.keys(t.headers).forEach((function(e){n.setHeader(e,t.headers[e])}));var i=!0;if("disable-fetch"===t.mode||"requestTimeout"in t&&!o.abortController)i=!1,r=!0;else if("prefer-streaming"===t.mode)r=!1;else if("allow-wrong-content-type"===t.mode)r=!o.overrideMimeType;else{if(t.mode&&"default"!==t.mode&&"prefer-fast"!==t.mode)throw new Error("Invalid value for opts.mode");r=!0}n._mode=function(t,e){return o.fetch&&e?"fetch":o.mozchunkedarraybuffer?"moz-chunked-arraybuffer":o.msstream?"ms-stream":o.arraybuffer&&t?"arraybuffer":o.vbArray&&t?"text:vbarray":"text"}(r,i),n._fetchTimer=null,n.on("finish",(function(){n._onFinish()}))};s(h,u.Writable),h.prototype.setHeader=function(t,e){var r=t.toLowerCase();-1===d.indexOf(r)&&(this._headers[r]={name:t,value:e})},h.prototype.getHeader=function(t){var e=this._headers[t.toLowerCase()];return e?e.value:null},h.prototype.removeHeader=function(t){delete this._headers[t.toLowerCase()]},h.prototype._onFinish=function(){var t=this;if(!t._destroyed){var r=t._opts,s=t._headers,a=null;"GET"!==r.method&&"HEAD"!==r.method&&(a=o.arraybuffer?c(e.concat(t._body)):o.blobConstructor?new n.Blob(t._body.map((function(t){return c(t)})),{type:(s["content-type"]||{}).value||""}):e.concat(t._body).toString());var u=[];if(Object.keys(s).forEach((function(t){var e=s[t].name,r=s[t].value;Array.isArray(r)?r.forEach((function(t){u.push([e,t])})):u.push([e,r])})),"fetch"===t._mode){var l=null;if(o.abortController){var h=new AbortController;l=h.signal,t._fetchAbortController=h,"requestTimeout"in r&&0!==r.requestTimeout&&(t._fetchTimer=n.setTimeout((function(){t.emit("requestTimeout"),t._fetchAbortController&&t._fetchAbortController.abort()}),r.requestTimeout))}n.fetch(t._opts.url,{method:t._opts.method,headers:u,body:a||void 0,mode:"cors",credentials:r.withCredentials?"include":"same-origin",signal:l}).then((function(e){t._fetchResponse=e,t._connect()}),(function(e){n.clearTimeout(t._fetchTimer),t._destroyed||t.emit("error",e)}))}else{var d=t._xhr=new n.XMLHttpRequest;try{d.open(t._opts.method,t._opts.url,!0)}catch(e){return void i.nextTick((function(){t.emit("error",e)}))}"responseType"in d&&(d.responseType=t._mode.split(":")[0]),"withCredentials"in d&&(d.withCredentials=!!r.withCredentials),"text"===t._mode&&"overrideMimeType"in d&&d.overrideMimeType("text/plain; charset=x-user-defined"),"requestTimeout"in r&&(d.timeout=r.requestTimeout,d.ontimeout=function(){t.emit("requestTimeout")}),u.forEach((function(t){d.setRequestHeader(t[0],t[1])})),t._response=null,d.onreadystatechange=function(){switch(d.readyState){case f.LOADING:case f.DONE:t._onXHRProgress()}},"moz-chunked-arraybuffer"===t._mode&&(d.onprogress=function(){t._onXHRProgress()}),d.onerror=function(){t._destroyed||t.emit("error",new Error("XHR error"))};try{d.send(a)}catch(e){return void i.nextTick((function(){t.emit("error",e)}))}}}},h.prototype._onXHRProgress=function(){(function(t){try{var e=t.status;return null!==e&&0!==e}catch(t){return!1}})(this._xhr)&&!this._destroyed&&(this._response||this._connect(),this._response._onXHRProgress())},h.prototype._connect=function(){var t=this;t._destroyed||(t._response=new l(t._xhr,t._fetchResponse,t._mode,t._fetchTimer),t._response.on("error",(function(e){t.emit("error",e)})),t.emit("response",t._response))},h.prototype._write=function(t,e,r){this._body.push(t),r()},h.prototype.abort=h.prototype.destroy=function(){this._destroyed=!0,n.clearTimeout(this._fetchTimer),this._response&&(this._response._destroyed=!0),this._xhr?this._xhr.abort():this._fetchAbortController&&this._fetchAbortController.abort()},h.prototype.end=function(t,e,r){"function"==typeof t&&(r=t,t=void 0),u.Writable.prototype.end.call(this,t,e,r)},h.prototype.flushHeaders=function(){},h.prototype.setTimeout=function(){},h.prototype.setNoDelay=function(){},h.prototype.setSocketKeepAlive=function(){};var d=["accept-charset","accept-encoding","access-control-request-headers","access-control-request-method","connection","content-length","cookie","cookie2","date","dnt","expect","host","keep-alive","origin","referer","te","trailer","transfer-encoding","upgrade","via"]}).call(this,r(9).Buffer,r(3),r(7))},function(t,e,r){var n=r(9).Buffer;t.exports=function(t){if(t instanceof Uint8Array){if(0===t.byteOffset&&t.byteLength===t.buffer.byteLength)return t.buffer;if("function"==typeof t.buffer.slice)return t.buffer.slice(t.byteOffset,t.byteOffset+t.byteLength)}if(n.isBuffer(t)){for(var e=new Uint8Array(t.length),r=t.length,i=0;i<r;i++)e[i]=t[i];return e.buffer}throw new Error("Argument must be a Buffer")}},function(t,e){t.exports=function(){for(var t={},e=0;e<arguments.length;e++){var n=arguments[e];for(var i in n)r.call(n,i)&&(t[i]=n[i])}return t};var r=Object.prototype.hasOwnProperty},function(t,e){t.exports={100:"Continue",101:"Switching Protocols",102:"Processing",200:"OK",201:"Created",202:"Accepted",203:"Non-Authoritative Information",204:"No Content",205:"Reset Content",206:"Partial Content",207:"Multi-Status",208:"Already Reported",226:"IM Used",300:"Multiple Choices",301:"Moved Permanently",302:"Found",303:"See Other",304:"Not Modified",305:"Use Proxy",307:"Temporary Redirect",308:"Permanent Redirect",400:"Bad Request",401:"Unauthorized",402:"Payment Required",403:"Forbidden",404:"Not Found",405:"Method Not Allowed",406:"Not Acceptable",407:"Proxy Authentication Required",408:"Request Timeout",409:"Conflict",410:"Gone",411:"Length Required",412:"Precondition Failed",413:"Payload Too Large",414:"URI Too Long",415:"Unsupported Media Type",416:"Range Not Satisfiable",417:"Expectation Failed",418:"I\'m a teapot",421:"Misdirected Request",422:"Unprocessable Entity",423:"Locked",424:"Failed Dependency",425:"Unordered Collection",426:"Upgrade Required",428:"Precondition Required",429:"Too Many Requests",431:"Request Header Fields Too Large",451:"Unavailable For Legal Reasons",500:"Internal Server Error",501:"Not Implemented",502:"Bad Gateway",503:"Service Unavailable",504:"Gateway Timeout",505:"HTTP Version Not Supported",506:"Variant Also Negotiates",507:"Insufficient Storage",508:"Loop Detected",509:"Bandwidth Limit Exceeded",510:"Not Extended",511:"Network Authentication Required"}},function(t,e,r){(function(t,n){var i;/*! https://mths.be/punycode v1.4.1 by @mathias */!function(o){e&&e.nodeType,t&&t.nodeType;var s="object"==typeof n&&n;s.global!==s&&s.window!==s&&s.self;var a,u=2147483647,c=/^xn--/,l=/[^\\x20-\\x7E]/,f=/[\\x2E\\u3002\\uFF0E\\uFF61]/g,h={overflow:"Overflow: input needs wider integers to process","not-basic":"Illegal input >= 0x80 (not a basic code point)","invalid-input":"Invalid input"},d=Math.floor,p=String.fromCharCode;function y(t){throw new RangeError(h[t])}function g(t,e){for(var r=t.length,n=[];r--;)n[r]=e(t[r]);return n}function m(t,e){var r=t.split("@"),n="";return r.length>1&&(n=r[0]+"@",t=r[1]),n+g((t=t.replace(f,".")).split("."),e).join(".")}function b(t){for(var e,r,n=[],i=0,o=t.length;i<o;)(e=t.charCodeAt(i++))>=55296&&e<=56319&&i<o?56320==(64512&(r=t.charCodeAt(i++)))?n.push(((1023&e)<<10)+(1023&r)+65536):(n.push(e),i--):n.push(e);return n}function v(t){return g(t,(function(t){var e="";return t>65535&&(e+=p((t-=65536)>>>10&1023|55296),t=56320|1023&t),e+=p(t)})).join("")}function w(t,e){return t+22+75*(t<26)-((0!=e)<<5)}function x(t,e,r){var n=0;for(t=r?d(t/700):t>>1,t+=d(t/e);t>455;n+=36)t=d(t/35);return d(n+36*t/(t+38))}function _(t){var e,r,n,i,o,s,a,c,l,f,h,p=[],g=t.length,m=0,b=128,w=72;for((r=t.lastIndexOf("-"))<0&&(r=0),n=0;n<r;++n)t.charCodeAt(n)>=128&&y("not-basic"),p.push(t.charCodeAt(n));for(i=r>0?r+1:0;i<g;){for(o=m,s=1,a=36;i>=g&&y("invalid-input"),((c=(h=t.charCodeAt(i++))-48<10?h-22:h-65<26?h-65:h-97<26?h-97:36)>=36||c>d((u-m)/s))&&y("overflow"),m+=c*s,!(c<(l=a<=w?1:a>=w+26?26:a-w));a+=36)s>d(u/(f=36-l))&&y("overflow"),s*=f;w=x(m-o,e=p.length+1,0==o),d(m/e)>u-b&&y("overflow"),b+=d(m/e),m%=e,p.splice(m++,0,b)}return v(p)}function S(t){var e,r,n,i,o,s,a,c,l,f,h,g,m,v,_,S=[];for(g=(t=b(t)).length,e=128,r=0,o=72,s=0;s<g;++s)(h=t[s])<128&&S.push(p(h));for(n=i=S.length,i&&S.push("-");n<g;){for(a=u,s=0;s<g;++s)(h=t[s])>=e&&h<a&&(a=h);for(a-e>d((u-r)/(m=n+1))&&y("overflow"),r+=(a-e)*m,e=a,s=0;s<g;++s)if((h=t[s])<e&&++r>u&&y("overflow"),h==e){for(c=r,l=36;!(c<(f=l<=o?1:l>=o+26?26:l-o));l+=36)_=c-f,v=36-f,S.push(p(w(f+_%v,0))),c=d(_/v);S.push(p(w(c,0))),o=x(r,m,n==i),r=0,++n}++r,++e}return S.join("")}a={version:"1.4.1",ucs2:{decode:b,encode:v},decode:_,encode:S,toASCII:function(t){return m(t,(function(t){return l.test(t)?"xn--"+S(t):t}))},toUnicode:function(t){return m(t,(function(t){return c.test(t)?_(t.slice(4).toLowerCase()):t}))}},void 0===(i=function(){return a}.call(e,r,e,t))||(t.exports=i)}()}).call(this,r(136)(t),r(3))},function(t,e){t.exports=function(t){return t.webpackPolyfill||(t.deprecate=function(){},t.paths=[],t.children||(t.children=[]),Object.defineProperty(t,"loaded",{enumerable:!0,get:function(){return t.l}}),Object.defineProperty(t,"id",{enumerable:!0,get:function(){return t.i}}),t.webpackPolyfill=1),t}},function(t,e,r){"use strict";var n=r(138),i=r(149),o=r(46);t.exports={formats:o,parse:i,stringify:n}},function(t,e,r){"use strict";var n=r(139),i=r(71),o=r(46),s=Object.prototype.hasOwnProperty,a={brackets:function(t){return t+"[]"},comma:"comma",indices:function(t,e){return t+"["+e+"]"},repeat:function(t){return t}},u=Array.isArray,c=Array.prototype.push,l=function(t,e){c.apply(t,u(e)?e:[e])},f=Date.prototype.toISOString,h=o.default,d={addQueryPrefix:!1,allowDots:!1,charset:"utf-8",charsetSentinel:!1,delimiter:"&",encode:!0,encoder:i.encode,encodeValuesOnly:!1,format:h,formatter:o.formatters[h],indices:!1,serializeDate:function(t){return f.call(t)},skipNulls:!1,strictNullHandling:!1},p={},y=function t(e,r,o,s,a,c,f,h,y,g,m,b,v,w,x,_){for(var S,A=e,E=_,k=0,T=!1;void 0!==(E=E.get(p))&&!T;){var C=E.get(e);if(k+=1,void 0!==C){if(C===k)throw new RangeError("Cyclic object value");T=!0}void 0===E.get(p)&&(k=0)}if("function"==typeof h?A=h(r,A):A instanceof Date?A=m(A):"comma"===o&&u(A)&&(A=i.maybeMap(A,(function(t){return t instanceof Date?m(t):t}))),null===A){if(a)return f&&!w?f(r,d.encoder,x,"key",b):r;A=""}if("string"==typeof(S=A)||"number"==typeof S||"boolean"==typeof S||"symbol"==typeof S||"bigint"==typeof S||i.isBuffer(A))return f?[v(w?r:f(r,d.encoder,x,"key",b))+"="+v(f(A,d.encoder,x,"value",b))]:[v(r)+"="+v(String(A))];var O,I=[];if(void 0===A)return I;if("comma"===o&&u(A))w&&f&&(A=i.maybeMap(A,f)),O=[{value:A.length>0?A.join(",")||null:void 0}];else if(u(h))O=h;else{var P=Object.keys(A);O=y?P.sort(y):P}for(var R=s&&u(A)&&1===A.length?r+"[]":r,j=0;j<O.length;++j){var M=O[j],L="object"==typeof M&&void 0!==M.value?M.value:A[M];if(!c||null!==L){var F=u(A)?"function"==typeof o?o(R,M):R:R+(g?"."+M:"["+M+"]");_.set(e,k);var N=n();N.set(p,_),l(I,t(L,F,o,s,a,c,"comma"===o&&w&&u(A)?null:f,h,y,g,m,b,v,w,x,N))}}return I};t.exports=function(t,e){var r,i=t,c=function(t){if(!t)return d;if(null!==t.encoder&&void 0!==t.encoder&&"function"!=typeof t.encoder)throw new TypeError("Encoder has to be a function.");var e=t.charset||d.charset;if(void 0!==t.charset&&"utf-8"!==t.charset&&"iso-8859-1"!==t.charset)throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");var r=o.default;if(void 0!==t.format){if(!s.call(o.formatters,t.format))throw new TypeError("Unknown format option provided.");r=t.format}var n=o.formatters[r],i=d.filter;return("function"==typeof t.filter||u(t.filter))&&(i=t.filter),{addQueryPrefix:"boolean"==typeof t.addQueryPrefix?t.addQueryPrefix:d.addQueryPrefix,allowDots:void 0===t.allowDots?d.allowDots:!!t.allowDots,charset:e,charsetSentinel:"boolean"==typeof t.charsetSentinel?t.charsetSentinel:d.charsetSentinel,delimiter:void 0===t.delimiter?d.delimiter:t.delimiter,encode:"boolean"==typeof t.encode?t.encode:d.encode,encoder:"function"==typeof t.encoder?t.encoder:d.encoder,encodeValuesOnly:"boolean"==typeof t.encodeValuesOnly?t.encodeValuesOnly:d.encodeValuesOnly,filter:i,format:r,formatter:n,serializeDate:"function"==typeof t.serializeDate?t.serializeDate:d.serializeDate,skipNulls:"boolean"==typeof t.skipNulls?t.skipNulls:d.skipNulls,sort:"function"==typeof t.sort?t.sort:null,strictNullHandling:"boolean"==typeof t.strictNullHandling?t.strictNullHandling:d.strictNullHandling}}(e);"function"==typeof c.filter?i=(0,c.filter)("",i):u(c.filter)&&(r=c.filter);var f,h=[];if("object"!=typeof i||null===i)return"";f=e&&e.arrayFormat in a?e.arrayFormat:e&&"indices"in e?e.indices?"indices":"repeat":"indices";var p=a[f];if(e&&"commaRoundTrip"in e&&"boolean"!=typeof e.commaRoundTrip)throw new TypeError("`commaRoundTrip` must be a boolean, or absent");var g="comma"===p&&e&&e.commaRoundTrip;r||(r=Object.keys(i)),c.sort&&r.sort(c.sort);for(var m=n(),b=0;b<r.length;++b){var v=r[b];c.skipNulls&&null===i[v]||l(h,y(i[v],v,p,g,c.strictNullHandling,c.skipNulls,c.encode?c.encoder:null,c.filter,c.sort,c.allowDots,c.serializeDate,c.format,c.formatter,c.encodeValuesOnly,c.charset,m))}var w=h.join(c.delimiter),x=!0===c.addQueryPrefix?"?":"";return c.charsetSentinel&&("iso-8859-1"===c.charset?x+="utf8=%26%2310003%3B&":x+="utf8=%E2%9C%93&"),w.length>0?x+w:""}},function(t,e,r){"use strict";var n=r(44),i=r(145),o=r(147),s=n("%TypeError%"),a=n("%WeakMap%",!0),u=n("%Map%",!0),c=i("WeakMap.prototype.get",!0),l=i("WeakMap.prototype.set",!0),f=i("WeakMap.prototype.has",!0),h=i("Map.prototype.get",!0),d=i("Map.prototype.set",!0),p=i("Map.prototype.has",!0),y=function(t,e){for(var r,n=t;null!==(r=n.next);n=r)if(r.key===e)return n.next=r.next,r.next=t.next,t.next=r,r};t.exports=function(){var t,e,r,n={assert:function(t){if(!n.has(t))throw new s("Side channel does not contain "+o(t))},get:function(n){if(a&&n&&("object"==typeof n||"function"==typeof n)){if(t)return c(t,n)}else if(u){if(e)return h(e,n)}else if(r)return function(t,e){var r=y(t,e);return r&&r.value}(r,n)},has:function(n){if(a&&n&&("object"==typeof n||"function"==typeof n)){if(t)return f(t,n)}else if(u){if(e)return p(e,n)}else if(r)return function(t,e){return!!y(t,e)}(r,n);return!1},set:function(n,i){a&&n&&("object"==typeof n||"function"==typeof n)?(t||(t=new a),l(t,n,i)):u?(e||(e=new u),d(e,n,i)):(r||(r={key:{},next:null}),function(t,e,r){var n=y(t,e);n?n.value=r:t.next={key:e,next:t.next,value:r}}(r,n,i))}};return n}},function(t,e,r){"use strict";var n="undefined"!=typeof Symbol&&Symbol,i=r(141);t.exports=function(){return"function"==typeof n&&("function"==typeof Symbol&&("symbol"==typeof n("foo")&&("symbol"==typeof Symbol("bar")&&i())))}},function(t,e,r){"use strict";t.exports=function(){if("function"!=typeof Symbol||"function"!=typeof Object.getOwnPropertySymbols)return!1;if("symbol"==typeof Symbol.iterator)return!0;var t={},e=Symbol("test"),r=Object(e);if("string"==typeof e)return!1;if("[object Symbol]"!==Object.prototype.toString.call(e))return!1;if("[object Symbol]"!==Object.prototype.toString.call(r))return!1;for(e in t[e]=42,t)return!1;if("function"==typeof Object.keys&&0!==Object.keys(t).length)return!1;if("function"==typeof Object.getOwnPropertyNames&&0!==Object.getOwnPropertyNames(t).length)return!1;var n=Object.getOwnPropertySymbols(t);if(1!==n.length||n[0]!==e)return!1;if(!Object.prototype.propertyIsEnumerable.call(t,e))return!1;if("function"==typeof Object.getOwnPropertyDescriptor){var i=Object.getOwnPropertyDescriptor(t,e);if(42!==i.value||!0!==i.enumerable)return!1}return!0}},function(t,e,r){"use strict";var n={foo:{}},i=Object;t.exports=function(){return{__proto__:n}.foo===n.foo&&!({__proto__:null}instanceof i)}},function(t,e,r){"use strict";var n="Function.prototype.bind called on incompatible ",i=Array.prototype.slice,o=Object.prototype.toString;t.exports=function(t){var e=this;if("function"!=typeof e||"[object Function]"!==o.call(e))throw new TypeError(n+e);for(var r,s=i.call(arguments,1),a=function(){if(this instanceof r){var n=e.apply(this,s.concat(i.call(arguments)));return Object(n)===n?n:this}return e.apply(t,s.concat(i.call(arguments)))},u=Math.max(0,e.length-s.length),c=[],l=0;l<u;l++)c.push("$"+l);if(r=Function("binder","return function ("+c.join(",")+"){ return binder.apply(this,arguments); }")(a),e.prototype){var f=function(){};f.prototype=e.prototype,r.prototype=new f,f.prototype=null}return r}},function(t,e,r){"use strict";var n=r(45);t.exports=n.call(Function.call,Object.prototype.hasOwnProperty)},function(t,e,r){"use strict";var n=r(44),i=r(146),o=i(n("String.prototype.indexOf"));t.exports=function(t,e){var r=n(t,!!e);return"function"==typeof r&&o(t,".prototype.")>-1?i(r):r}},function(t,e,r){"use strict";var n=r(45),i=r(44),o=i("%Function.prototype.apply%"),s=i("%Function.prototype.call%"),a=i("%Reflect.apply%",!0)||n.call(s,o),u=i("%Object.getOwnPropertyDescriptor%",!0),c=i("%Object.defineProperty%",!0),l=i("%Math.max%");if(c)try{c({},"a",{value:1})}catch(t){c=null}t.exports=function(t){var e=a(n,s,arguments);if(u&&c){var r=u(e,"length");r.configurable&&c(e,"length",{value:1+l(0,t.length-(arguments.length-1))})}return e};var f=function(){return a(n,o,arguments)};c?c(t.exports,"apply",{value:f}):t.exports.apply=f},function(t,e,r){var n="function"==typeof Map&&Map.prototype,i=Object.getOwnPropertyDescriptor&&n?Object.getOwnPropertyDescriptor(Map.prototype,"size"):null,o=n&&i&&"function"==typeof i.get?i.get:null,s=n&&Map.prototype.forEach,a="function"==typeof Set&&Set.prototype,u=Object.getOwnPropertyDescriptor&&a?Object.getOwnPropertyDescriptor(Set.prototype,"size"):null,c=a&&u&&"function"==typeof u.get?u.get:null,l=a&&Set.prototype.forEach,f="function"==typeof WeakMap&&WeakMap.prototype?WeakMap.prototype.has:null,h="function"==typeof WeakSet&&WeakSet.prototype?WeakSet.prototype.has:null,d="function"==typeof WeakRef&&WeakRef.prototype?WeakRef.prototype.deref:null,p=Boolean.prototype.valueOf,y=Object.prototype.toString,g=Function.prototype.toString,m=String.prototype.match,b=String.prototype.slice,v=String.prototype.replace,w=String.prototype.toUpperCase,x=String.prototype.toLowerCase,_=RegExp.prototype.test,S=Array.prototype.concat,A=Array.prototype.join,E=Array.prototype.slice,k=Math.floor,T="function"==typeof BigInt?BigInt.prototype.valueOf:null,C=Object.getOwnPropertySymbols,O="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?Symbol.prototype.toString:null,I="function"==typeof Symbol&&"object"==typeof Symbol.iterator,P="function"==typeof Symbol&&Symbol.toStringTag&&(typeof Symbol.toStringTag===I||"symbol")?Symbol.toStringTag:null,R=Object.prototype.propertyIsEnumerable,j=("function"==typeof Reflect?Reflect.getPrototypeOf:Object.getPrototypeOf)||([].__proto__===Array.prototype?function(t){return t.__proto__}:null);function M(t,e){if(t===1/0||t===-1/0||t!=t||t&&t>-1e3&&t<1e3||_.call(/e/,e))return e;var r=/[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;if("number"==typeof t){var n=t<0?-k(-t):k(t);if(n!==t){var i=String(n),o=b.call(e,i.length+1);return v.call(i,r,"$&_")+"."+v.call(v.call(o,/([0-9]{3})/g,"$&_"),/_$/,"")}}return v.call(e,r,"$&_")}var L=r(148),F=L.custom,N=q(F)?F:null;function D(t,e,r){var n="double"===(r.quoteStyle||e)?\'"\':"\'";return n+t+n}function U(t){return v.call(String(t),/"/g,"&quot;")}function B(t){return!("[object Array]"!==W(t)||P&&"object"==typeof t&&P in t)}function G(t){return!("[object RegExp]"!==W(t)||P&&"object"==typeof t&&P in t)}function q(t){if(I)return t&&"object"==typeof t&&t instanceof Symbol;if("symbol"==typeof t)return!0;if(!t||"object"!=typeof t||!O)return!1;try{return O.call(t),!0}catch(t){}return!1}t.exports=function t(e,r,n,i){var a=r||{};if(H(a,"quoteStyle")&&"single"!==a.quoteStyle&&"double"!==a.quoteStyle)throw new TypeError(\'option "quoteStyle" must be "single" or "double"\');if(H(a,"maxStringLength")&&("number"==typeof a.maxStringLength?a.maxStringLength<0&&a.maxStringLength!==1/0:null!==a.maxStringLength))throw new TypeError(\'option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`\');var u=!H(a,"customInspect")||a.customInspect;if("boolean"!=typeof u&&"symbol"!==u)throw new TypeError("option \\"customInspect\\", if provided, must be `true`, `false`, or `\'symbol\'`");if(H(a,"indent")&&null!==a.indent&&"\\t"!==a.indent&&!(parseInt(a.indent,10)===a.indent&&a.indent>0))throw new TypeError(\'option "indent" must be "\\\\t", an integer > 0, or `null`\');if(H(a,"numericSeparator")&&"boolean"!=typeof a.numericSeparator)throw new TypeError(\'option "numericSeparator", if provided, must be `true` or `false`\');var y=a.numericSeparator;if(void 0===e)return"undefined";if(null===e)return"null";if("boolean"==typeof e)return e?"true":"false";if("string"==typeof e)return function t(e,r){if(e.length>r.maxStringLength){var n=e.length-r.maxStringLength,i="... "+n+" more character"+(n>1?"s":"");return t(b.call(e,0,r.maxStringLength),r)+i}return D(v.call(v.call(e,/([\'\\\\])/g,"\\\\$1"),/[\\x00-\\x1f]/g,K),"single",r)}(e,a);if("number"==typeof e){if(0===e)return 1/0/e>0?"0":"-0";var w=String(e);return y?M(e,w):w}if("bigint"==typeof e){var _=String(e)+"n";return y?M(e,_):_}var k=void 0===a.depth?5:a.depth;if(void 0===n&&(n=0),n>=k&&k>0&&"object"==typeof e)return B(e)?"[Array]":"[Object]";var C=function(t,e){var r;if("\\t"===t.indent)r="\\t";else{if(!("number"==typeof t.indent&&t.indent>0))return null;r=A.call(Array(t.indent+1)," ")}return{base:r,prev:A.call(Array(e+1),r)}}(a,n);if(void 0===i)i=[];else if(V(i,e)>=0)return"[Circular]";function F(e,r,o){if(r&&(i=E.call(i)).push(r),o){var s={depth:a.depth};return H(a,"quoteStyle")&&(s.quoteStyle=a.quoteStyle),t(e,s,n+1,i)}return t(e,a,n+1,i)}if("function"==typeof e&&!G(e)){var z=function(t){if(t.name)return t.name;var e=m.call(g.call(t),/^function\\s*([\\w$]+)/);if(e)return e[1];return null}(e),J=Q(e,F);return"[Function"+(z?": "+z:" (anonymous)")+"]"+(J.length>0?" { "+A.call(J,", ")+" }":"")}if(q(e)){var tt=I?v.call(String(e),/^(Symbol\\(.*\\))_[^)]*$/,"$1"):O.call(e);return"object"!=typeof e||I?tt:$(tt)}if(function(t){if(!t||"object"!=typeof t)return!1;if("undefined"!=typeof HTMLElement&&t instanceof HTMLElement)return!0;return"string"==typeof t.nodeName&&"function"==typeof t.getAttribute}(e)){for(var et="<"+x.call(String(e.nodeName)),rt=e.attributes||[],nt=0;nt<rt.length;nt++)et+=" "+rt[nt].name+"="+D(U(rt[nt].value),"double",a);return et+=">",e.childNodes&&e.childNodes.length&&(et+="..."),et+="</"+x.call(String(e.nodeName))+">"}if(B(e)){if(0===e.length)return"[]";var it=Q(e,F);return C&&!function(t){for(var e=0;e<t.length;e++)if(V(t[e],"\\n")>=0)return!1;return!0}(it)?"["+X(it,C)+"]":"[ "+A.call(it,", ")+" ]"}if(function(t){return!("[object Error]"!==W(t)||P&&"object"==typeof t&&P in t)}(e)){var ot=Q(e,F);return"cause"in Error.prototype||!("cause"in e)||R.call(e,"cause")?0===ot.length?"["+String(e)+"]":"{ ["+String(e)+"] "+A.call(ot,", ")+" }":"{ ["+String(e)+"] "+A.call(S.call("[cause]: "+F(e.cause),ot),", ")+" }"}if("object"==typeof e&&u){if(N&&"function"==typeof e[N]&&L)return L(e,{depth:k-n});if("symbol"!==u&&"function"==typeof e.inspect)return e.inspect()}if(function(t){if(!o||!t||"object"!=typeof t)return!1;try{o.call(t);try{c.call(t)}catch(t){return!0}return t instanceof Map}catch(t){}return!1}(e)){var st=[];return s&&s.call(e,(function(t,r){st.push(F(r,e,!0)+" => "+F(t,e))})),Z("Map",o.call(e),st,C)}if(function(t){if(!c||!t||"object"!=typeof t)return!1;try{c.call(t);try{o.call(t)}catch(t){return!0}return t instanceof Set}catch(t){}return!1}(e)){var at=[];return l&&l.call(e,(function(t){at.push(F(t,e))})),Z("Set",c.call(e),at,C)}if(function(t){if(!f||!t||"object"!=typeof t)return!1;try{f.call(t,f);try{h.call(t,h)}catch(t){return!0}return t instanceof WeakMap}catch(t){}return!1}(e))return Y("WeakMap");if(function(t){if(!h||!t||"object"!=typeof t)return!1;try{h.call(t,h);try{f.call(t,f)}catch(t){return!0}return t instanceof WeakSet}catch(t){}return!1}(e))return Y("WeakSet");if(function(t){if(!d||!t||"object"!=typeof t)return!1;try{return d.call(t),!0}catch(t){}return!1}(e))return Y("WeakRef");if(function(t){return!("[object Number]"!==W(t)||P&&"object"==typeof t&&P in t)}(e))return $(F(Number(e)));if(function(t){if(!t||"object"!=typeof t||!T)return!1;try{return T.call(t),!0}catch(t){}return!1}(e))return $(F(T.call(e)));if(function(t){return!("[object Boolean]"!==W(t)||P&&"object"==typeof t&&P in t)}(e))return $(p.call(e));if(function(t){return!("[object String]"!==W(t)||P&&"object"==typeof t&&P in t)}(e))return $(F(String(e)));if(!function(t){return!("[object Date]"!==W(t)||P&&"object"==typeof t&&P in t)}(e)&&!G(e)){var ut=Q(e,F),ct=j?j(e)===Object.prototype:e instanceof Object||e.constructor===Object,lt=e instanceof Object?"":"null prototype",ft=!ct&&P&&Object(e)===e&&P in e?b.call(W(e),8,-1):lt?"Object":"",ht=(ct||"function"!=typeof e.constructor?"":e.constructor.name?e.constructor.name+" ":"")+(ft||lt?"["+A.call(S.call([],ft||[],lt||[]),": ")+"] ":"");return 0===ut.length?ht+"{}":C?ht+"{"+X(ut,C)+"}":ht+"{ "+A.call(ut,", ")+" }"}return String(e)};var z=Object.prototype.hasOwnProperty||function(t){return t in this};function H(t,e){return z.call(t,e)}function W(t){return y.call(t)}function V(t,e){if(t.indexOf)return t.indexOf(e);for(var r=0,n=t.length;r<n;r++)if(t[r]===e)return r;return-1}function K(t){var e=t.charCodeAt(0),r={8:"b",9:"t",10:"n",12:"f",13:"r"}[e];return r?"\\\\"+r:"\\\\x"+(e<16?"0":"")+w.call(e.toString(16))}function $(t){return"Object("+t+")"}function Y(t){return t+" { ? }"}function Z(t,e,r,n){return t+" ("+e+") {"+(n?X(r,n):A.call(r,", "))+"}"}function X(t,e){if(0===t.length)return"";var r="\\n"+e.prev+e.base;return r+A.call(t,","+r)+"\\n"+e.prev}function Q(t,e){var r=B(t),n=[];if(r){n.length=t.length;for(var i=0;i<t.length;i++)n[i]=H(t,i)?e(t[i],t):""}var o,s="function"==typeof C?C(t):[];if(I){o={};for(var a=0;a<s.length;a++)o["$"+s[a]]=s[a]}for(var u in t)H(t,u)&&(r&&String(Number(u))===u&&u<t.length||I&&o["$"+u]instanceof Symbol||(_.call(/[^\\w$]/,u)?n.push(e(u,t)+": "+e(t[u],t)):n.push(u+": "+e(t[u],t))));if("function"==typeof C)for(var c=0;c<s.length;c++)R.call(t,s[c])&&n.push("["+e(s[c])+"]: "+e(t[s[c]],t));return n}},function(t,e){},function(t,e,r){"use strict";var n=r(71),i=Object.prototype.hasOwnProperty,o=Array.isArray,s={allowDots:!1,allowPrototypes:!1,allowSparse:!1,arrayLimit:20,charset:"utf-8",charsetSentinel:!1,comma:!1,decoder:n.decode,delimiter:"&",depth:5,ignoreQueryPrefix:!1,interpretNumericEntities:!1,parameterLimit:1e3,parseArrays:!0,plainObjects:!1,strictNullHandling:!1},a=function(t){return t.replace(/&#(\\d+);/g,(function(t,e){return String.fromCharCode(parseInt(e,10))}))},u=function(t,e){return t&&"string"==typeof t&&e.comma&&t.indexOf(",")>-1?t.split(","):t},c=function(t,e,r,n){if(t){var o=r.allowDots?t.replace(/\\.([^.[]+)/g,"[$1]"):t,s=/(\\[[^[\\]]*])/g,a=r.depth>0&&/(\\[[^[\\]]*])/.exec(o),c=a?o.slice(0,a.index):o,l=[];if(c){if(!r.plainObjects&&i.call(Object.prototype,c)&&!r.allowPrototypes)return;l.push(c)}for(var f=0;r.depth>0&&null!==(a=s.exec(o))&&f<r.depth;){if(f+=1,!r.plainObjects&&i.call(Object.prototype,a[1].slice(1,-1))&&!r.allowPrototypes)return;l.push(a[1])}return a&&l.push("["+o.slice(a.index)+"]"),function(t,e,r,n){for(var i=n?e:u(e,r),o=t.length-1;o>=0;--o){var s,a=t[o];if("[]"===a&&r.parseArrays)s=[].concat(i);else{s=r.plainObjects?Object.create(null):{};var c="["===a.charAt(0)&&"]"===a.charAt(a.length-1)?a.slice(1,-1):a,l=parseInt(c,10);r.parseArrays||""!==c?!isNaN(l)&&a!==c&&String(l)===c&&l>=0&&r.parseArrays&&l<=r.arrayLimit?(s=[])[l]=i:"__proto__"!==c&&(s[c]=i):s={0:i}}i=s}return i}(l,e,r,n)}};t.exports=function(t,e){var r=function(t){if(!t)return s;if(null!==t.decoder&&void 0!==t.decoder&&"function"!=typeof t.decoder)throw new TypeError("Decoder has to be a function.");if(void 0!==t.charset&&"utf-8"!==t.charset&&"iso-8859-1"!==t.charset)throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");var e=void 0===t.charset?s.charset:t.charset;return{allowDots:void 0===t.allowDots?s.allowDots:!!t.allowDots,allowPrototypes:"boolean"==typeof t.allowPrototypes?t.allowPrototypes:s.allowPrototypes,allowSparse:"boolean"==typeof t.allowSparse?t.allowSparse:s.allowSparse,arrayLimit:"number"==typeof t.arrayLimit?t.arrayLimit:s.arrayLimit,charset:e,charsetSentinel:"boolean"==typeof t.charsetSentinel?t.charsetSentinel:s.charsetSentinel,comma:"boolean"==typeof t.comma?t.comma:s.comma,decoder:"function"==typeof t.decoder?t.decoder:s.decoder,delimiter:"string"==typeof t.delimiter||n.isRegExp(t.delimiter)?t.delimiter:s.delimiter,depth:"number"==typeof t.depth||!1===t.depth?+t.depth:s.depth,ignoreQueryPrefix:!0===t.ignoreQueryPrefix,interpretNumericEntities:"boolean"==typeof t.interpretNumericEntities?t.interpretNumericEntities:s.interpretNumericEntities,parameterLimit:"number"==typeof t.parameterLimit?t.parameterLimit:s.parameterLimit,parseArrays:!1!==t.parseArrays,plainObjects:"boolean"==typeof t.plainObjects?t.plainObjects:s.plainObjects,strictNullHandling:"boolean"==typeof t.strictNullHandling?t.strictNullHandling:s.strictNullHandling}}(e);if(""===t||null==t)return r.plainObjects?Object.create(null):{};for(var l="string"==typeof t?function(t,e){var r,c={__proto__:null},l=e.ignoreQueryPrefix?t.replace(/^\\?/,""):t,f=e.parameterLimit===1/0?void 0:e.parameterLimit,h=l.split(e.delimiter,f),d=-1,p=e.charset;if(e.charsetSentinel)for(r=0;r<h.length;++r)0===h[r].indexOf("utf8=")&&("utf8=%E2%9C%93"===h[r]?p="utf-8":"utf8=%26%2310003%3B"===h[r]&&(p="iso-8859-1"),d=r,r=h.length);for(r=0;r<h.length;++r)if(r!==d){var y,g,m=h[r],b=m.indexOf("]="),v=-1===b?m.indexOf("="):b+1;-1===v?(y=e.decoder(m,s.decoder,p,"key"),g=e.strictNullHandling?null:""):(y=e.decoder(m.slice(0,v),s.decoder,p,"key"),g=n.maybeMap(u(m.slice(v+1),e),(function(t){return e.decoder(t,s.decoder,p,"value")}))),g&&e.interpretNumericEntities&&"iso-8859-1"===p&&(g=a(g)),m.indexOf("[]=")>-1&&(g=o(g)?[g]:g),i.call(c,y)?c[y]=n.combine(c[y],g):c[y]=g}return c}(t,r):t,f=r.plainObjects?Object.create(null):{},h=Object.keys(l),d=0;d<h.length;++d){var p=h[d],y=c(p,l[p],r,"string"==typeof t);f=n.merge(f,y,r)}return!0===r.allowSparse?f:n.compact(f)}},function(t,e){t.exports={getPalette:(t,{debug:e=!1}={debug:!1})=>{e&&console.log("starting getPalette with image",t);const{fileDirectory:r}=t,{BitsPerSample:n,ColorMap:i,ImageLength:o,ImageWidth:s,PhotometricInterpretation:a,SampleFormat:u,SamplesPerPixel:c}=r;if(!i)throw new Error("[geotiff-palette]: the image does not contain a color map, so we can\'t make a palette.");const l=Math.pow(2,n);e&&console.log("[geotiff-palette]: count:",l);const f=i.length/3;if(e&&console.log("[geotiff-palette]: bandSize:",f),f!==l)throw new Error("[geotiff-palette]: can\'t handle situations where the color map has more or less values than the number of possible values in a raster");const h=f,d=h+f,p=[];for(let t=0;t<l;t++)p.push([Math.floor(i[t]/256),Math.floor(i[h+t]/256),Math.floor(i[d+t]/256),255]);return e&&console.log("[geotiff-palette]: result is ",p),p}}},function(t,e,r){var n,i=Object.defineProperty,o=Object.getOwnPropertySymbols,s=Object.prototype.hasOwnProperty,a=Object.prototype.propertyIsEnumerable,u=(t,e,r)=>e in t?i(t,e,{enumerable:!0,configurable:!0,writable:!0,value:r}):t[e]=r,c=(t,e)=>i(t,"name",{value:e,configurable:!0});const l=r(152),f=r(187),h=r(189),d=c(t=>new Array(t).fill(0).map((t,e)=>e),"range");function p(t,e={}){var r=e,{bands:n,height:i,precise:c=!1,stats:p,width:y,layout:g}=r,m=((t,e)=>{var r={};for(var n in t)s.call(t,n)&&e.indexOf(n)<0&&(r[n]=t[n]);if(null!=t&&o)for(var n of o(t))e.indexOf(n)<0&&a.call(t,n)&&(r[n]=t[n]);return r})(r,["bands","height","precise","stats","width","layout"]);if("function"==typeof t.then)throw new Error("[calc-image-stats] you passed in a promise as the data values.  please resolve the promise first before calling calcImageStats");const b=f({bands:n,data:t,height:i,layout:g,width:y});null!=n||(n=b.bands),null!=i||(i=b.height),null!=g||(g=b.layout),null!=y||(y=b.width);const v=d(n).map(e=>{let r;const f=((t,e)=>{for(var r in e||(e={}))s.call(e,r)&&u(t,r,e[r]);if(o)for(var r of o(e))a.call(e,r)&&u(t,r,e[r]);return t})({precise:c,stats:p},m);if(["[band][row,column]","[band][column,row]"].includes(g))r=t[e];else if(["[band][row][column]","[band][column][row]"].includes(g))r=t[e],f.chunked=!0;else if(1===n&&["[band,row,column]","[row,column,band]","[column,band,row]","[column,row,band]"].includes(g))r=t;else{const o={band:[e,e]},s={band:n,column:y,row:i};r=h.iterClip({data:t,layout:g,rect:o,sizes:s})}return l(r,f)});return{depth:n,height:i,width:y,bands:v}}c(p,"calcImageStats"),void 0!==(n=function(){return p}.call(e,r,e,t))&&(t.exports=n),t.exports=p,t.exports.default=p,t.exports.calcImageStats=p,"object"==typeof self&&(self.calcImageStats=p),"object"==typeof window&&(self.calcImageStats=p)},function(t,e,r){var n;const{getOrCreateIterator:i}=r(72),{add:o,compare:s,divide:a,mean:u,multiply:c,pow:l,sort:f,subtract:h,sum:d}=r(153),p=r(176);function y(t,{async:e=!1,chunked:r=!1,noData:n,filter:d,calcCount:y=!0,calcHistogram:g=!0,calcInvalid:m=!0,calcMax:b=!0,calcMean:v=!0,calcMedian:w=!0,calcMin:x=!0,calcMode:_=!0,calcModes:S=!0,calcProduct:A=!0,calcRange:E=!0,calcStd:k=!0,calcSum:T=!0,calcValid:C=!0,calcVariance:O=!0,calcUniques:I=!0,precise:P=!1,precise_max_decimal_digits:R=100,stats:j}={debugLevel:0}){j&&(j.forEach(t=>{["count","histogram","invalid","max","mean","median","min","mode","modes","product","range","sum","std","valid","variance","uniques"].includes(t)||console.warn(`[calc-stats] skipping unknown stat "${t}"`)}),y=j.includes("count"),g=j.includes("histogram"),m=j.includes("invalid"),b=j.includes("max"),v=j.includes("mean"),w=j.includes("median"),x=j.includes("min"),_=j.includes("mode"),S=j.includes("modes"),A=j.includes("product"),E=j.includes("range"),k=j.includes("std"),T=j.includes("sum"),C=j.includes("valid"),O=j.includes("variance"),I=j.includes("uniques"));const M=i(t);let L,F,N,D=g||w||_||S||O||k||I,U=y||v||w||A||C||O||k||"function"==typeof d,B=y||m||"function"==typeof d,G=T||v||O||k,q=x||E,z=b||E,H=A,W=0,V=0,K=0,$=P?"0":0;const Y={};let Z,X;Z=P?t=>{t=t.toString(),U&&W++,!q||void 0!==L&&"<"!==s(t,L)||(L=t),!z||void 0!==F&&">"!==s(t,F)||(F=t),H&&(N=1===W?t:c(N,t)),G&&($=o($,t)),D&&(t in Y?Y[t].ct++:Y[t]={n:t.toString(),ct:1})}:t=>{U&&W++,q&&(void 0===L||t<L)&&(L=t),z&&(void 0===F||t>F)&&(F=t),H&&(N=1===W?t:N*t),G&&($+=t),D&&(t in Y?Y[t].ct++:Y[t]={n:t,ct:1})},X="number"==typeof n&&"function"==typeof d?t=>{K++,"number"!=typeof t||isNaN(t)||t===n||!0!==d({valid:W,index:K,value:t})?B&&V++:Z(t)}:"number"==typeof n?t=>{"number"!=typeof t||isNaN(t)||t===n?B&&V++:Z(t)}:"function"==typeof d?t=>{K++,"number"!=typeof t||isNaN(t)||!0!==d({valid:W,index:K,value:t})?B&&V++:Z(t)}:t=>{"number"!=typeof t||isNaN(t)?B&&V++:Z(t)};const Q=()=>{const t={};if(y&&(t.count=P?o(V.toString(),W.toString()):V+W),C&&(t.valid=P?W.toString():W),m&&(t.invalid=P?V.toString():V),w&&(t.median=p.calculate({counts:Y,precise:P,total:W})),x&&(t.min=L),b&&(t.max=F),A&&(t.product=N),T&&(t.sum=$),E&&(t.range=P?h(F.toString(),L.toString()):F-L),v||O||k){const e=P?a($,W.toString(),{max_decimal_digits:R}):$/W;if(v&&(t.mean=e),O||k){const r=(({count:t,histogram:e,mean_value:r,precise:n=!1})=>{if(n){r=r.toString();const n=Object.values(e).reduce((t,{n:e,ct:n})=>{const i=h(e.toString(),r);return o(t,c(n.toString(),l(i,"2")))},"0");return a(n,t.toString())}return Object.values(e).reduce((t,{n:e,ct:n})=>t+n*Math.pow(e-r,2),0)/t})({count:W,histogram:Y,mean_value:e,precise:P});O&&(t.variance=r),k&&(t.std=P?Math.sqrt(Number(r)).toString():Math.sqrt(r))}}if(g&&(P&&Object.values(Y).forEach(t=>{t.ct=t.ct.toString()}),t.histogram=Y),_||S){let e=0,r=[];for(let t in Y){const{n:n,ct:i}=Y[t];i===e?r.push(P?n.toString():n):i>e&&(e=i,r=[P?n.toString():n])}S&&(t.modes=r),_&&(t.mode=P?u(r):r.reduce((t,e)=>t+e,0)/r.length)}return I&&(t.uniques=P?f(Object.keys(Y)):Object.values(Y).map(({n:t})=>t).sort((t,e)=>t-e)),t};if(r){if(e)return(async()=>{for await(let t of M)for(let e of t)X(e);return Q()})();for(let t of M)for(let e of t)X(e);return Q()}if(e)return(async()=>{for await(let t of M)X(t);return Q()})();for(let t of M)X(t);return Q()}void 0===(n=function(){return y}.call(e,r,e,t))||(t.exports=n),t.exports=y,t.exports.default=y,t.exports.calcStats=y,"object"==typeof self&&(self.calcStats=y),"object"==typeof window&&(window.calcStats=y)},function(t,e,r){"use strict";var n;const i=r(4),o=r(6),s=r(154),a=r(76),u=r(0),c=r(34),l=r(5),f=r(156),h=r(158),d=r(51),p=r(84),y=r(162),g=r(163),m=r(1),b=r(88),v=r(89),w=r(73),x=r(75),_=r(164),S=r(165),A=r(77),E=r(166),k=r(167),T=r(15),C=r(16),O=r(90),I=r(91),P=r(11),R=r(8),j=r(32),M=r(48),L=r(31),F=r(168),N={absolute:i,add:o,binomial_coefficient:s,ceil:a,clean:u,compare:c,compare_positive:l,constants:f,cosine_radians:h,count_decimal_digits:d,count_integer_digits:p,cube:y,cube_root:g,divide:m,eulers_number:b,exp:v,expand:w,factorial:x,flip_sign:_,floor:S,fraction:A,hypotenuse:E,is_infinity:T,is_integer:C,is_factorial:k,is_negative_infinity:O,is_positive_infinity:I,is_zero:P,long_addition:R,long_division:j,long_multiplication:M,long_subtraction:L,mean:r(169),max:F,min:r(86),multiply:r(53),multiply_array:r(79),multiply_range:r(47),nilakantha:r(170),ols:r(171),pow:r(35),pow_positive:r(54),primes:r(87),reciprocal:r(81),remainder:r(172),root:r(37),root_integer_digits:r(83),round:r(36),round_last_decimal:r(49),sign:r(22),sign_nonzero:r(50),simplify_fraction:r(85),sine_radians:r(173),softmax:r(174),sort:r(175),square:r(23),square_root:r(92),subtract:r(33),sum:r(55),truncate:r(93)};void 0===(n=function(){return N}.call(e,r,e,t))||(t.exports=n),t.exports=N,t.exports.default=N,"object"==typeof window&&(window.preciso=N),"object"==typeof self&&(self.preciso=N)},function(t,e,r){"use strict";const n=r(0),i=r(5),o=r(75),s=r(8),a=r(31),u=r(32),c=r(47);function l(t,e){switch(t=n(t),e=n(e),i(t,e)){case"=":return"1";case">":{const r=a(t,e),n=c(s(e,"1"),t),i=o(r);return u(n,i)}case"<":throw new Error("[binominal_coefficient] unsupported")}}t.exports=l,t.exports.default=l},function(t,e,r){"use strict";function n(t){return t.substring(0,t.indexOf("."))}t.exports=n,t.exports.default=n},function(t,e,r){"use strict";const{MAX_SAFE_INTEGER:n}=r(74),{MAX_SAFE_INTEGER_LENGTH:i}=r(30),{PI:o}=r(157);t.exports={MAX_SAFE_INTEGER:n,MAX_SAFE_INTEGER_LENGTH:i,PI:o}},function(t,e){t.exports={PI_100:"3.1415926535897932384626433832795028841971693993751058209749445923078164062862089986280348253421170679"}},function(t,e,r){"use strict";const n=r(6),i=r(11),o=r(23),s=r(17),a=r(1);function u(t,{steps:e=100,max_decimal_digits:r=100}={}){if(i(t))return"0";let u,c="-",l="1",f=e,h=o(t),d="1",p="1",y="0";for(let t=0;t<f;t++){u=n(y,"1"),y=n(u,"1"),d=s([d,h],{max_decimal_digits:r}),p=s([p,u,y],{max_decimal_digits:r});const t=a(d,p,{max_decimal_digits:r});l=n(l,c+t),c="-"===c?"+":"-"}return l}t.exports=u,t.exports.default=u},function(t,e,r){"use strict";const n=r(0),i=r(51),o=r(4),s=r(80),a=r(49),u=["5","6","7","8","9"];function c(t,{digits:e=0}={digits:0}){const r=t=n(t),c=s(t)?"-":"",l=(t=o(t)).indexOf(".");if(-1===l)return r;if(i(t)<=e)return r;const f=t[l+e+1];if(u.includes(f)){const r=t.substring(0,l+e+2);return c+a(r)}if(0===e)return c+t.substring(0,l);return c+t.substring(0,l+e+1)}t.exports=c,t.exports.default=c},function(t,e,r){"use strict";function n(t){return t.includes("/")}t.exports=n,t.exports.default=n},function(t,e,r){"use strict";function n(t){return t.split("/")}t.exports=n,t.exports.default=n},function(t,e,r){"use strict";const n=r(35);function i(t,e){return n(t,"3",e)}t.exports=i,t.exports.default=i},function(t,e,r){"use strict";const n=r(37);function i(t,e){return n(t,"3",e)}t.exports=i,t.exports.default=i},function(t,e,r){"use strict";const n=r(4),i=r(0),o=r(22);function s(t){t=i(t);const e=o(t);return""===e?t:"-"===e?n(t):"+"===e?"-"+t:sum}t.exports=s,t.exports.default=s},function(t,e,r){"use strict";const n=r(4),i=r(0),o=r(8),s=r(22);function a(t){if(-1===(t=i(t)).indexOf("."))return t;const e=s(t);return t=n(t).split(".")[0],"+"===e?t:"-"===e?"0"===t||""===t?"-1":"-"+o(t,"1"):void 0}t.exports=a,t.exports.default=a},function(t,e,r){"use strict";const n=r(23),i=r(92),o=r(55);function s(){const t=Array.from(arguments),e="object"==typeof t[t.length-1]?t[t.length-1]:void 0,r=Array.isArray(t[0])?t[0]:e?t.slice(0,t.length-1):t,s=r.map(t=>n(t));return i(o(s),e)}t.exports=s,t.exports.default=s},function(t,e,r){"use strict";function n(t){return!!t.match(/^\\d+!$/i)}t.exports=n,t.exports.default=n},function(t,e,r){"use strict";const n=r(0),i=r(34);function o(t){"string"==typeof t&&(t=Array.prototype.slice.call(arguments));let e=n(t[0]);const r=t.length;for(let n=1;n<r;n++){const r=t[n];">"===i(r,e)&&(e=r)}return e}t.exports=o,t.exports.default=o},function(t,e,r){"use strict";const n=r(6),i=r(1);function o(t,e){let r=0,o="0";for(let e of t)r++,o=n(o,e);return i(o,r.toString(),e)}t.exports=o,t.exports.default=o},function(t,e,r){"use strict";const n=r(6),i=r(8),o=r(1),s=r(17);function a(t=100,{divide_options:e}={}){let r="+",a="3",u="2",c="3",l="4";for(let f=1;f<t;f++){const t=s([u,c,l]),f=r+o("4",t,e);a=n(a,f),r="-"===r?"+":"-",u=l,c=i(l,"1"),l=i(c,"1")}return a}t.exports=a,t.exports.default=a},function(t,e,r){"use strict";const n=r(6),i=r(1),o=r(17),s=r(36),a=r(33),u=r(23);function c(t,e){const r=t.length;let c="0",l="0",f="0",h="0";if(0===r)throw Error("[preciso] zero points passed to linear_regression");for(let e=0;e<r;e++){const[r,i]=t[e];c=n(c,r),l=n(l,u(r)),f=n(f,i),h=n(h,u(i))}const d=r.toString(),p=i(c,d),y=i(f,d);let g="0",m="0";for(let e=0;e<r;e++){const[r,i]=t[e],s=a(r,p),c=a(i,y),l=o([s,c]);g=n(g,l);const f=u(s);m=n(m,f)}let b=i(g,m),v=a(y,o(b,p));return e&&"number"==typeof e.max_decimal_digits&&(b=s(b,{digits:e.max_decimal_digits}),v=s(v,{digits:e.max_decimal_digits})),{m:b,b:v}}t.exports=c,t.exports.default=c},function(t,e,r){"use strict";const n=r(4),i=r(0),o=r(5),s=r(32),a=r(53),u=r(33),c=r(93);function l(t,e){t=i(t),e=i(e);const r="-"===t[0]?"-":"";t=n(t),e=n(e);const l=o(t,e);if("="===l)return"0";if("<"===l)return"."===t[0]&&(t="0"+t),r+t;const f=s(t,e,{max_decimal_places:0}),h=c(f),d=a(e,h);return r+u(t,d)}t.exports=l,t.exports.default=l},function(t,e,r){"use strict";const n=r(6),i=r(11),o=r(23),s=r(17),a=r(1);function u(t,{steps:e=100,max_decimal_digits:r=100}={}){if(i(t))return"0";let u,c="-",l=t,f=e,h=o(t),d=t,p="1",y="1";for(let t=0;t<f;t++){u=n(y,"1"),y=n(u,"1"),d=s([d,h],{max_decimal_digits:r}),p=s([p,u,y],{max_decimal_digits:r});const t=a(d,p,{max_decimal_digits:r});l=n(l,c+t),c="-"===c?"+":"-"}return l}t.exports=u,t.exports.default=u},function(t,e,r){"use strict";const n=r(1),i=r(89),o=r(55);function s(t,{max_decimal_digits:e}){t=t.map(t=>i(t,{max_decimal_digits:e}));const r=o(t);return t.map(t=>n(t,r,{max_decimal_digits:e,ellipsis:!1}))}t.exports=s,t.exports.default=s},function(t,e,r){"use strict";const n=r(34);function i(t,{direction:e="ascending"}={direction:"ascending"}){const r="desc"===e||"descending"===e?"<":">";return t.sort((t,e)=>n(t,e)===r?1:-1)}t.exports=i,t.exports.default=i},function(t,e,r){var n;const i=r(177),o=r(186);function s({counts:t,nums:e,no_data:r,precise:n,threshold:s=50,total:a}){return void 0!==t||void 0!==a||e.length>s?i({counts:t,no_data:r,nums:e,precise:n,total:a}):o({no_data:r,nums:e,precise:n})}const a={calculate:s};void 0===(n=function(){return a}.call(e,r,e,t))||(t.exports=n),t.exports=a,t.exports.default={calculate:s},"object"==typeof window&&(window.mediana=a),"object"==typeof self&&(self.mediana=a)},function(t,e,r){const n=r(178),i=r(94);function o({counts:t,nums:e,no_data:r,precise:o=!1,total:s}){void 0!==t&&void 0!==s||({counts:t,total:s}=n({nums:e,no_data:r}));const a=Object.values(t).sort((t,e)=>t.n-e.n),u=s/2,c=a.length;if(0!==c){if(1===c)return o?a[0].n.toString():a[0].n;{let t=0;if(s%2==0)for(let e=0;e<c;e++){const{n:r,ct:n}=a[e];if(t+=n,t>u)return t-n===u?i(a[e-1].n,r,{precise:o}):o?r.toString():r}else for(let e=0;e<c;e++){const{n:r,ct:n}=a[e];if(t+=n,t>u)return o?r.toString():r}}}}t.exports=o,t.exports.default=o},function(t,e){function r({nums:t,no_data:e}){let r=t.length;const n={};let i=0;if(void 0!==e)for(let o=0;o<r;o++){const r=t[o];r!==e&&(i++,r in n?n[r].ct++:n[r]={n:r,ct:1})}else for(let e=0;e<r;e++){const r=t[e];i++,r in n?n[r].ct++:n[r]={n:r,ct:1}}return{counts:n,total:i}}t.exports=r,t.exports.default=r},function(t,e){function r(t){"+"===t[0]&&(t=t.substring(1));const e="-"===t[0]?"-":"";"-"===e&&(t=t.substring(1));const r=t.indexOf("e");if(-1===r)return e+t;let n=t.indexOf(".");-1===n&&(n=r);const i=Number(t.substring(r+1)),o=t.substring(0,r).replace(".",""),s=n+i,a=o.length;if(s>=a){const t=s-a;let r=o;for(let e=0;e<t;e++)r+="0";return e+r}if(s<0){result="0.";for(let t=0;t>s;t--)result+="0";return result+=o,e+result}return e+o.substring(0,s)+"."+o.substring(s)}t.exports=r,t.exports.default=r},function(t,e,r){const n=r(98),i=r(18),o=r(181);function s(t,e,r){if(t=i(t),"0"===(e=i(e)))throw new Error("[preciso] division by zero");if(""===t||"0"===t)return"0";const s="-"!==t[0],a="-"!==e[0],u=s!==a?"-":"";return s||(t=n(t)),a||(e=n(e)),u+o(t,e,r)}t.exports=s,t.exports.default=s},function(t,e,r){const n=r(38),i=r(95),o=(r(182),r(184)),s=r(185);t.exports=function(t,e,{max_decimal_digits:r=100,ellipsis:a=!1}={}){"0"===t[0]&&(t=t.substring(1)),"0"===e[0]&&(e=e.substring(1));const u=t.indexOf("."),c=e.indexOf("."),l=-1===u?t.length:u,f=-1===c?0:e.length-1-c;let h=!1;t=t.replace(/\\./,""),e=e.replace(/\\./,"");const d=t.length;let p,y="",g="",m=-1*f,b=0;for(let r=0;r<d;r++){if(y+=t[r],p=n(y,e),">"===p){let t=1,r=i(e,e),s=e;for(;">"!==n(r,y);)t++,s=r,r=i(r,e);if(t=t.toString(),""!==g)for(let e=t.length;e<=b;e++)g+="0";g+=t,y=o(y,s),b=0}else{if("<"===p){""===g&&m++,b++;continue}if("="===p){if(""!==g)for(let t=0;t<b;t++)g+="0";g+="1",y="0",b=0}}}if(y.match(/^0+$/g))"<"===p&&(g+=y.substring(0,y.length-1));else{const t={},s=l-m-g.length+r+1;""===g&&(b=0);for(let r=0;r<s;r++){if(y+="0",a)if(y in t){if(t[y]++,t[y]>3){g+="...",h=!0;break}}else t[y]=1;const r=n(y,e);if(">"===r){let t=1,r=i(e,e),s=e;for(;">"!==n(r,y);)t++,s=r,r=i(r,e);t=t.toString();for(let e=t.length;e<=b;e++)g+="0";if(g+=t,y=o(y,s),"0"===y)break;b=0}else{if("<"===r){b++;continue}if("="===r){for(let t=0;t<b;t++)g+="0";g+="1",b=0;break}}}}const v=l-m,w=g.length;let x;if(v===w)x=0;else if(v<0)g="0."+"0".repeat(Math.abs(v))+g,x=w-v;else if(v>w){for(let t=w;t<v;t++)g+="0";x=0}else v<w?(g=g.substring(0,v)+"."+g.substring(v),x=w-v):0===v&&(g="0."+g,x=w);if(g=g.replace(/^0+/,""),g=g.replace(/\\.\\d+0+$/,""),!h){const t=x-r;t>0&&(g=s(g.substring(0,g.length-t+1)))}return"."===g[0]&&(g="0"+g),g}},function(t,e,r){const n=r(98),i=r(18),o=r(38),s=r(183);function a(t,e){t=i(t),e=i(e);const r="-"!==t[0]!==("-"!==e[0])?"-":"";t=n(t),e=n(e);if("<"===o(t,e)){const r=t;t=e,e=r}return r+s(t,e)}t.exports=a,t.exports.default=a},function(t,e,r){const{MAX_SAFE_INTEGER_LENGTH:n}=r(56);t.exports=function(t,e){if("0"===t||"0"===e)return"0";const r=t.indexOf("."),i=e.indexOf("."),o=(-1===r?t.length:r)+(-1===i?e.length:i),s=(-1===r?0:t.length-1-r)+(-1===i?0:e.length-1-i);if(0===s&&o<n)return(Number(t)*Number(e)).toFixed(0);const a=t.replace(".",""),u=e.replace(".",""),c=a.length,l=u.length,f=[];let h=c;for(;h>=0;){const t=h,e=h-=15,r=a.substring(e,t);f.push([Number(r),r.length])}const d=[],p=[];for(let t=0,e=l-1;e>=0;e--,t++){const r=u[e],n=Number(r);let i=0,o="";const s=f.length-1;f.forEach(([t,e],r)=>{let a=(i+n*t).toString();const u=a.length;if(u>e&&r!==s){const t=-1*e;o=a.slice(t)+o,i=Number(a.slice(0,t))}else{const t=e-u;for(let e=0;e<t;e++)a="0"+a;i=0,o=a+o}}),o+="0".repeat(t),d.push(o),p.push([Array.from(o).map(t=>Number(t)),o.length])}const y=d.length,g=p[p.length-1][1]+y;let m="",b=0;for(let t=0;t<g;t++){let e=b;const r=Math.min(t,y-1);for(let n=0;n<=r;n++){const[r,i]=p[n],o=i-1-t;o>=0&&(e+=r[o])}e>=10?(e=e.toString(),m=e[e.length-1]+m,b=Number(e.slice(0,-1))):(m=e+m,b=0)}if(0===s)m=m.replace(/^0+/,"");else{const t=m.length-s;m=m.substring(0,t)+"."+m.substring(t),m=m.replace(/^0+/,""),m=m.replace(/\\.?0+$/,""),"."===m[0]&&(m="0"+m)}return m}},function(t,e,r){const n=r(18),i=r(38),o=r(96),s=r(97);function a(t,e){t=n(t),e=n(e);const r="-"!==t[0],a="-"!==e[0];if(r){if(a){const r=i(t,e);return">"===r?s(t,e):"<"===r?"-"+s(e,t):"0"}return o(t,e.substring(1))}if(a)return"-"+o(t.substring(1),e);{t=t.substring(1),e=e.substring(1);const r=i(t,e);return">"===r?"-"+s(t,e):"<"===r?s(e,t):"0"}}t.exports=a,t.exports.default=a},function(t,e){const r=["5","6","7","8","9"];t.exports=function(t){"+"===t[0]&&(t=t.substring(1));const e=t.length;let n="";const i=t[t.length-1];if(r.includes(i)){let r;for(r=e-2;r>=0;r--){const e=t[r];if("."===e||"-"===e)continue;const i=Number(e)+1;if(10!==i){n=i+n;break}n="0"+n}r>0&&(n=t.substring(0,r)+n)}else n=t.substring(0,e-1);return"."===n[n.length-1]&&(n=n.substring(0,n.length-1)),n.indexOf(".")>-1&&(n=n.replace(/0+$/,"")),n}},function(t,e,r){const n=r(94);function i({nums:t,no_data:e,precise:r=!1}){switch((t=t.filter(t=>t!==e).sort((t,e)=>t-e)).length){case 0:return;case 1:return r?t[0].toString():t[0];default:const e=t.length/2;if(t.length%2==0)return n(t[e-1],t[e],{precise:r});{const n=Math.floor(e);return r?t[n].toString():t[n]}}}t.exports=i,t.exports.default=i},function(t,e,r){var n;const i=r(188);function o({bands:t,data:e,height:r,layout:n,width:o}){const s=i(e);if("[row,column,band]"===n||1===s)return{layout:"[row,column,band]",bands:t||(r&&o?e.length/(r*o):void 0),height:r||(t&&o?e.length/(t*o):void 0),width:o||(t&&r?e.length/(t*r):void 0)};if(2===s){if(!r||!o)return e.length<e[0].length?{bands:e.length,layout:"[band][row,column]",height:r||(o?e[0].length/o:void 0),width:o||(r?e[0].length/r:void 0)}:{bands:e[0].length,layout:"[row,column][band]",height:r||(o?e.length/o:void 0),width:o||(r?e.length/r:void 0)};if(e[0].length===r*o)return{layout:"[band][row,column]",bands:e.length,height:r,width:o};if(e.length===r*o)return{layout:"[row,column][band]",bands:e[0].length,height:r,width:o}}else if(3===s){const t=e.length,n=e[0].length,i=e[0][0].length;if(r&&o){if(t===r&&n===o)return{layout:"[row][column][band]",bands:i,height:r,width:o};if(n===r&&i===o)return{layout:"[band][row][column]",bands:t,height:r,width:o}}else{if(t<n&&t<i)return{layout:"[band][row][column]",bands:t,height:n,width:i};if(i<t&&i<n)return{layout:"[row][column][band]",bands:i,height:t,width:n}}}}void 0===(n=function(){return o}.call(e,r,e,t))||(t.exports=n),t.exports=o,t.exports.default=o,t.exports.guessImageLayout=o,"object"==typeof window&&(window.guessImageLayout=o),"object"==typeof self&&(self.guessImageLayout=o)},function(t,e){t.exports=function(t){const e=t=>Array.isArray(t)||t instanceof Int8Array||t instanceof Uint8Array||t instanceof Uint8ClampedArray||t instanceof Int16Array||t instanceof Uint16Array||t instanceof Int32Array||t instanceof Uint32Array||t instanceof Float32Array||t instanceof Float64Array||t instanceof BigInt64Array||t instanceof BigUint64Array;let r=0,n=t;for(;e(n);)r++,n=n[0];return r}},function(t,e,r){const n={},{wrapNextFunction:i}=r(72),o=r(190),s=r(191),a={Array:Array,Int8Array:Int8Array,Uint8Array:Uint8Array,Uint8ClampedArray:Uint8ClampedArray,Int16Array:Int16Array,Uint16Array:Uint16Array,Float32Array:Float32Array,Float64Array:Float64Array};try{a.BigInt64Array=BigInt64Array,a.BigUint64Array=BigUint64Array}catch(t){}const u=t=>t.match(/\\[[^\\]]+\\]/g),c=t=>t.startsWith("[")&&t.endsWith("]")?t.substring(1,t.length-1):t,l=t=>t.startsWith("(")&&t.endsWith(")")?t.substring(1,t.length-1):t,f=t=>t.match(/(\\(.*?\\)|[^\\(,\\s]+)(?=\\s*,|\\s*$)/g),h=t=>{t=c(t),t=l(t);const e=f(t);return 1===e.length?{type:"Vector",dim:e[0]}:{type:"Matrix",parts:e.map(h)}};function d(t){const e=t.match(/[^ A-Za-z,\\[\\]]/g);if(e)throw new Error("The following invalid characters were used: "+e.map(t=>`"${t}"`).join(", "));return!0}function p(t,{useLayoutCache:e=!0}={useLayoutCache:!0}){if(e&&t in n)return n[t];d(t);const r=u(t).map(h),i={type:"Layout",summary:r.map(t=>"Matrix"===t.type?t.parts.length:1),dims:r};return e&&(n[t]=i),i}function y({useLayoutCache:t=!0,data:e,layout:r,sizes:n={}}){"string"==typeof r&&(r=p(r,{useLayoutCache:t}));const{dims:i}=r,o=i.length,a=m({useLayoutCache:t,layout:r,sizes:n}),u=o-1,c=r.summary.toString();if(c in s){const t={data:e};return r.dims.map((e,r)=>{"Vector"===e.type?t[`d${r}v0`]=e.dim:"Matrix"===e.type&&e.parts.forEach((e,n)=>{t[`d${r}v${n}`]=e.dim,t[`m${r}v${n}`]=a[e.dim]})}),s[c].bind(t)}return({point:t,value:r})=>{let n=e;for(let e=0;e<o;e++){const o=e===u,s=i[e];let c;c="Vector"===s.type?t[s.dim]:s.parts.reduce((e,{dim:r})=>e+a[r]*t[r],0),o?n[c]=r:n=n[c]}}}function g({rect:t={}}){if(t)for(let e in t){const r=t[e];if(2!==r.length)throw new Error("[xdim] uh oh. invalid hyper-rectangle");const[n,i]=r;if(n>i)throw new Error(`[xdim] uh oh. invalid range for "${e}".  Start of ${n} can\'t be greater than end of ${i}.`);if(n<0)throw new Error("[xdim] uh oh. invalid hyper-rectangle with start "+n)}}function m({useLayoutCache:t=!0,layout:e,sizes:r}){"string"==typeof e&&(e=p(e,{useLayoutCache:t}));const{dims:n}=e,i=n.length;let o={};for(let t=0;t<i;t++){const e=n[t];if("Vector"===e.type)o[e.dim]=1;else{const{parts:t}=e;let n=1;for(let e=t.length-1;e>=0;e--){const{dim:i}=t[e];o[i]=n,n*=r[t[e].dim]}}}return o}function b({useLayoutCache:t=!0,data:e,layout:r,point:n,sizes:i={}}){let o,s;"string"==typeof r&&(r=p(r,{useLayoutCache:t}));let a=e;const{dims:u}=r,c=u.length;for(let t=0;t<c;t++){const e=u[t];if("Vector"===e.type){const t=n[e.dim];o=a,s=t,a=a[t]}else{const{parts:t}=e;let r=0,u=1;for(let e=t.length-1;e>=0;e--){const o=t[e];if("Vector"===o.type){const{dim:t}=o;if(r+=u*n[t],e>0){if(!(t in i))throw new Error(`you cannot calculate the location without knowing the size of the "${t}" dimension.`);u*=i[t]}}}o=a,s=r,a=a[r]}}return{index:s,value:a,parent:o}}function v({arr:t,fill:e,lens:r,arrayTypes:n}){if(0===r.length)return t;const i=r[0];if(1===r.length){const r=n?n[n.length-1]:"Array";for(let n=0;n<t.length;n++)t[n]=new a[r](i).fill(e)}else for(let o=0;o<t.length;o++){const s=new Array(i).fill(e);t[o]=s,v({arr:s,fill:e,lens:r.slice(1),arrayTypes:n})}return t}function w({fill:t,shape:e,arrayTypes:r}){const n=e[0];if(1===e.length){if(Array.isArray(r)&&1!==r.length)throw new Error("[xdim] shape and arrayTypes have different lengths");const e=Array.isArray(r)?r[0]:"Array";return new a[e](n).fill(t)}return v({arr:new Array(n).fill(t),fill:t,lens:e.slice(1),arrayTypes:r})}function x({fill:t,layout:e,useLayoutCache:r=!0,sizes:n,arrayTypes:i}){"string"==typeof e&&(e=p(e,{useLayoutCache:r}));const o=e.dims.map(t=>"Vector"===t.type?n[t.dim]:"Matrix"===t.type?t.parts.reduce((t,e)=>{if(!(e.dim in n))throw new Error(`[xdim] could not find "${e.dim}" in sizes: { ${Object.keys(n).join(", ")} }`);return t*n[e.dim]},1):void 0);return{data:w({fill:t,shape:o,arrayTypes:i}),shape:o,arrayTypes:i}}function _({start:t=0,end:e=100}){let r=t-1;return e+=1,i((function(){return r++,r===e?{done:!0}:{done:!1,value:r}}))}function S({order:t,sizes:e,rect:r={}}){const n=Array.isArray(t)?t:Object.keys(e).sort((t,r)=>e[t]-e[r]),o=new Array(n.length),s={};for(let t=0;t<n.length-1;t++){const i=n[t],[a,u]=r[i]||[0,e[i]-1];o[t]=_({start:a+1,end:u}),s[i]=a}const a=n[n.length-1],[u,c]=r[a]||[0,e[a]-1];return o[o.length-1]=_({start:u,end:c}),s[a]=u-1,i((function(){for(let t=o.length-1;t>=0;t--){const{value:i,done:a}=o[t].next();if(!a){for(let i=t+1;i<o.length;i++){const t=n[i],[a,u]=r[t]||[0,e[t]-1];o[i]=_({start:a+1,end:u}),s[t]=a}return s[n[t]]=i,{value:s,done:!1}}if(0===t)return{done:!0}}}))}t.exports={addDims:v,checkValidity:d,createMatrix:w,iterClip:function({data:t,layout:e,order:r,rect:n={},sizes:o={},useLayoutCache:s=!0}){if(!t)throw new Error("[xdim] must specify data");if(!e)throw new Error("[xdim] must specify layout");const a=S({order:r,sizes:o,rect:n});return i((function(){const{value:r,done:n}=a.next();if(n)return{done:!0};{const{value:n}=b({data:t,layout:e,point:r,sizes:o,useLayoutCache:s});return{done:!1,value:n}}}))},iterRange:_,iterPoints:S,matchSequences:f,parse:p,parseDimensions:function(t){const e={},r=/[A-Za-z]+/g;let n;for(;null!==(n=r.exec(t));){const[t]=n;e[t]={name:t}}return e},parseSequences:h,parseVectors:u,prepareData:x,prepareSelect:function({useLayoutCache:t=!0,data:e,layout:r,sizes:n={}}){"string"==typeof r&&(r=p(r,{useLayoutCache:t}));const{dims:i}=r,s=i.length,a=m({useLayoutCache:t,layout:r,sizes:n}),u=s-1,c=r.summary.toString();if(c in o){const t={data:e};return r.dims.map((e,r)=>{"Vector"===e.type?t[`d${r}v0`]=e.dim:"Matrix"===e.type&&e.parts.forEach((e,n)=>{t[`d${r}v${n}`]=e.dim,t[`m${r}v${n}`]=a[e.dim]})}),o[c].bind(t)}return({point:t})=>{let r=e;for(let e=0;e<s;e++){const n=e===u,o=i[e];let s;if(s="Vector"===o.type?t[o.dim]:o.parts.reduce((e,{dim:r})=>e+a[r]*t[r],0),n)return{index:s,parent:r,value:r[s]};r=r[s]}}},prepareUpdate:y,removeBraces:c,removeParentheses:l,select:b,transform:function({data:t,fill:e,from:r,to:n,sizes:i,useLayoutCache:o=!0}){"string"==typeof r&&(r=p(r,{useLayoutCache:o})),"string"==typeof n&&(n=p(n,{useLayoutCache:o}));const{data:s}=x({fill:e,layout:n,sizes:i}),a=y({useLayoutCache:o,data:s,layout:n,sizes:i}),u=S({sizes:i});for(point of u){const{value:e}=b({data:t,layout:r,point:point,sizes:i});a({point:point,value:e})}return{data:s}},update:function({useLayoutCache:t=!0,data:e,layout:r,point:n,sizes:i={},value:o}){"string"==typeof r&&(r=p(r,{useLayoutCache:t}));const{dims:s}=r;for(let t=0;t<s.length;t++){const r=t===s.length-1,a=s[t];let u;if("Vector"===a.type)u=n[a.dim];else{const{parts:t}=a;u=0;let e=1;for(let r=t.length-1;r>=0;r--){const o=t[r],{dim:s}=o;if(u+=e*n[s],r>0){if(!(s in i))throw new Error(`you cannot calculate the location without knowing the size of the "${s}" dimension.`);e*=i[s]}}}r?e[u]=o:e=e[u]}},clip:function({useLayoutCache:t=!0,data:e,layout:r,rect:n,sizes:i={},flat:o=!1,validate:s=!0}){s&&g({rect:n}),"string"==typeof r&&(r=p(r,{useLayoutCache:t}));let a=[e];if(r.dims.forEach(t=>{let e=[];a.forEach(r=>{if("Vector"===t.type){const[i,o]=n[t.dim];e=e.concat(r.slice(i,o+1))}else{const{parts:o}=t;let s=[0],a=1;for(let t=o.length-1;t>=0;t--){const e=o[t],{dim:r}=e,[u,c]=n[r],l=[];for(let t=u;t<=c;t++)s.forEach(e=>{l.push(e+a*t)});s=l,a*=i[r]}s.forEach(t=>{e.push(r[t])})}}),a=e}),o)return{data:a};const u=Object.fromEntries(Object.entries(n).map(([t,[e,r]])=>[t,r-e+1])),{data:c}=x({layout:r,sizes:u}),l=r.dims.length,f=(t,e)=>{if(e===l)for(let e=0;e<t.length;e++)t[e]=a.shift();else t.forEach(t=>f(t,e+1))};return f(c,1),{data:c}},validateRect:g}},function(t,e){t.exports={1:function({point:t}){const e=this.data,r=t[this.d0v0];return{parent:e,index:r,value:e[r]}},2:function({point:t}){const e=this.data,r=this.m0v0*t[this.d0v0]+this.m0v1*t[this.d0v1];return{parent:e,index:r,value:e[r]}},3:function({point:t}){const e=this.data,r=this.m0v0*t[this.d0v0]+this.m0v1*t[this.d0v1]+this.m0v2*t[this.d0v2];return{parent:e,index:r,value:e[r]}},4:function({point:t}){const e=this.data,r=this.m0v0*t[this.d0v0]+this.m0v1*t[this.d0v1]+this.m0v2*t[this.d0v2]+this.m0v3*t[this.d0v3];return{parent:e,index:r,value:e[r]}},5:function({point:t}){const e=this.data,r=this.m0v0*t[this.d0v0]+this.m0v1*t[this.d0v1]+this.m0v2*t[this.d0v2]+this.m0v3*t[this.d0v3]+this.m0v4*t[this.d0v4];return{parent:e,index:r,value:e[r]}},"1,1":function({point:t}){const e=this.data[t[this.d0v0]],r=t[this.d1v0];return{parent:e,index:r,value:e[r]}},"1,2":function({point:t}){const e=this.data[t[this.d0v0]],r=this.m1v0*t[this.d1v0]+this.m1v1*t[this.d1v1];return{parent:e,index:r,value:e[r]}},"1,3":function({point:t}){const e=this.data[t[this.d0v0]],r=this.m1v0*t[this.d1v0]+this.m1v1*t[this.d1v1]+this.m1v2*t[this.d1v2];return{parent:e,index:r,value:e[r]}},"1,4":function({point:t}){const e=this.data[t[this.d0v0]],r=this.m1v0*t[this.d1v0]+this.m1v1*t[this.d1v1]+this.m1v2*t[this.d1v2]+this.m1v3*t[this.d1v3];return{parent:e,index:r,value:e[r]}},"1,5":function({point:t}){const e=this.data[t[this.d0v0]],r=this.m1v0*t[this.d1v0]+this.m1v1*t[this.d1v1]+this.m1v2*t[this.d1v2]+this.m1v3*t[this.d1v3]+this.m1v4*t[this.d1v4];return{parent:e,index:r,value:e[r]}},"1,1,1":function({point:t}){const e=this.data[t[this.d0v0]][t[this.d1v0]],r=t[this.d2v0];return{parent:e,index:r,value:e[r]}},"1,1,2":function({point:t}){const e=this.data[t[this.d0v0]][t[this.d1v0]],r=this.m2v0*t[this.d2v0]+this.m2v1*t[this.d2v1];return{parent:e,index:r,value:e[r]}},"1,1,3":function({point:t}){const e=this.data[t[this.d0v0]][t[this.d1v0]],r=this.m2v0*t[this.d2v0]+this.m2v1*t[this.d2v1]+this.m2v2*t[this.d2v2];return{parent:e,index:r,value:e[r]}},"1,1,4":function({point:t}){const e=this.data[t[this.d0v0]][t[this.d1v0]],r=this.m2v0*t[this.d2v0]+this.m2v1*t[this.d2v1]+this.m2v2*t[this.d2v2]+this.m2v3*t[this.d2v3];return{parent:e,index:r,value:e[r]}},"1,1,5":function({point:t}){const e=this.data[t[this.d0v0]][t[this.d1v0]],r=this.m2v0*t[this.d2v0]+this.m2v1*t[this.d2v1]+this.m2v2*t[this.d2v2]+this.m2v3*t[this.d2v3]+this.m2v4*t[this.d2v4];return{parent:e,index:r,value:e[r]}},"1,1,1,1":function({point:t}){const e=this.data[t[this.d0v0]][t[this.d1v0]][t[this.d2v0]],r=t[this.d3v0];return{parent:e,index:r,value:e[r]}},"1,1,1,2":function({point:t}){const e=this.data[t[this.d0v0]][t[this.d1v0]][t[this.d2v0]],r=this.m3v0*t[this.d3v0]+this.m3v1*t[this.d3v1];return{parent:e,index:r,value:e[r]}},"1,1,1,3":function({point:t}){const e=this.data[t[this.d0v0]][t[this.d1v0]][t[this.d2v0]],r=this.m3v0*t[this.d3v0]+this.m3v1*t[this.d3v1]+this.m3v2*t[this.d3v2];return{parent:e,index:r,value:e[r]}},"1,1,1,4":function({point:t}){const e=this.data[t[this.d0v0]][t[this.d1v0]][t[this.d2v0]],r=this.m3v0*t[this.d3v0]+this.m3v1*t[this.d3v1]+this.m3v2*t[this.d3v2]+this.m3v3*t[this.d3v3];return{parent:e,index:r,value:e[r]}},"1,1,1,5":function({point:t}){const e=this.data[t[this.d0v0]][t[this.d1v0]][t[this.d2v0]],r=this.m3v0*t[this.d3v0]+this.m3v1*t[this.d3v1]+this.m3v2*t[this.d3v2]+this.m3v3*t[this.d3v3]+this.m3v4*t[this.d3v4];return{parent:e,index:r,value:e[r]}},"1,1,1,1,1":function({point:t}){const e=this.data[t[this.d0v0]][t[this.d1v0]][t[this.d2v0]][t[this.d3v0]],r=t[this.d4v0];return{parent:e,index:r,value:e[r]}},"1,1,1,1,2":function({point:t}){const e=this.data[t[this.d0v0]][t[this.d1v0]][t[this.d2v0]][t[this.d3v0]],r=this.m4v0*t[this.d4v0]+this.m4v1*t[this.d4v1];return{parent:e,index:r,value:e[r]}},"1,1,1,1,3":function({point:t}){const e=this.data[t[this.d0v0]][t[this.d1v0]][t[this.d2v0]][t[this.d3v0]],r=this.m4v0*t[this.d4v0]+this.m4v1*t[this.d4v1]+this.m4v2*t[this.d4v2];return{parent:e,index:r,value:e[r]}},"1,1,1,1,4":function({point:t}){const e=this.data[t[this.d0v0]][t[this.d1v0]][t[this.d2v0]][t[this.d3v0]],r=this.m4v0*t[this.d4v0]+this.m4v1*t[this.d4v1]+this.m4v2*t[this.d4v2]+this.m4v3*t[this.d4v3];return{parent:e,index:r,value:e[r]}},"1,1,1,1,5":function({point:t}){const e=this.data[t[this.d0v0]][t[this.d1v0]][t[this.d2v0]][t[this.d3v0]],r=this.m4v0*t[this.d4v0]+this.m4v1*t[this.d4v1]+this.m4v2*t[this.d4v2]+this.m4v3*t[this.d4v3]+this.m4v4*t[this.d4v4];return{parent:e,index:r,value:e[r]}}}},function(t,e){t.exports={1:function({point:t,value:e}){this.data[t[this.d0v0]]=e},2:function({point:t,value:e}){this.data[this.m0v0*t[this.d0v0]+this.m0v1*t[this.d0v1]]=e},3:function({point:t,value:e}){this.data[this.m0v0*t[this.d0v0]+this.m0v1*t[this.d0v1]+this.m0v2*t[this.d0v2]]=e},4:function({point:t,value:e}){this.data[this.m0v0*t[this.d0v0]+this.m0v1*t[this.d0v1]+this.m0v2*t[this.d0v2]+this.m0v3*t[this.d0v3]]=e},5:function({point:t,value:e}){this.data[this.m0v0*t[this.d0v0]+this.m0v1*t[this.d0v1]+this.m0v2*t[this.d0v2]+this.m0v3*t[this.d0v3]+this.m0v4*t[this.d0v4]]=e},"1,1":function({point:t,value:e}){this.data[t[this.d0v0]][t[this.d1v0]]=e},"1,2":function({point:t,value:e}){this.data[t[this.d0v0]][this.m1v0*t[this.d1v0]+this.m1v1*t[this.d1v1]]=e},"1,3":function({point:t,value:e}){this.data[t[this.d0v0]][this.m1v0*t[this.d1v0]+this.m1v1*t[this.d1v1]+this.m1v2*t[this.d1v2]]=e},"1,4":function({point:t,value:e}){this.data[t[this.d0v0]][this.m1v0*t[this.d1v0]+this.m1v1*t[this.d1v1]+this.m1v2*t[this.d1v2]+this.m1v3*t[this.d1v3]]=e},"1,5":function({point:t,value:e}){this.data[t[this.d0v0]][this.m1v0*t[this.d1v0]+this.m1v1*t[this.d1v1]+this.m1v2*t[this.d1v2]+this.m1v3*t[this.d1v3]+this.m1v4*t[this.d1v4]]=e},"1,1,1":function({point:t,value:e}){this.data[t[this.d0v0]][t[this.d1v0]][t[this.d2v0]]=e},"1,1,2":function({point:t,value:e}){this.data[t[this.d0v0]][t[this.d1v0]][this.m2v0*t[this.d2v0]+this.m2v1*t[this.d2v1]]=e},"1,1,3":function({point:t,value:e}){this.data[t[this.d0v0]][t[this.d1v0]][this.m2v0*t[this.d2v0]+this.m2v1*t[this.d2v1]+this.m2v2*t[this.d2v2]]=e},"1,1,4":function({point:t,value:e}){this.data[t[this.d0v0]][t[this.d1v0]][this.m2v0*t[this.d2v0]+this.m2v1*t[this.d2v1]+this.m2v2*t[this.d2v2]+this.m2v3*t[this.d2v3]]=e},"1,1,5":function({point:t,value:e}){this.data[t[this.d0v0]][t[this.d1v0]][this.m2v0*t[this.d2v0]+this.m2v1*t[this.d2v1]+this.m2v2*t[this.d2v2]+this.m2v3*t[this.d2v3]+this.m2v4*t[this.d2v4]]=e},"1,1,1,1":function({point:t,value:e}){this.data[t[this.d0v0]][t[this.d1v0]][t[this.d2v0]][t[this.d3v0]]=e},"1,1,1,2":function({point:t,value:e}){this.data[t[this.d0v0]][t[this.d1v0]][t[this.d2v0]][this.m3v0*t[this.d3v0]+this.m3v1*t[this.d3v1]]=e},"1,1,1,3":function({point:t,value:e}){this.data[t[this.d0v0]][t[this.d1v0]][t[this.d2v0]][this.m3v0*t[this.d3v0]+this.m3v1*t[this.d3v1]+this.m3v2*t[this.d3v2]]=e},"1,1,1,4":function({point:t,value:e}){this.data[t[this.d0v0]][t[this.d1v0]][t[this.d2v0]][this.m3v0*t[this.d3v0]+this.m3v1*t[this.d3v1]+this.m3v2*t[this.d3v2]+this.m3v3*t[this.d3v3]]=e},"1,1,1,5":function({point:t,value:e}){this.data[t[this.d0v0]][t[this.d1v0]][t[this.d2v0]][this.m3v0*t[this.d3v0]+this.m3v1*t[this.d3v1]+this.m3v2*t[this.d3v2]+this.m3v3*t[this.d3v3]+this.m3v4*t[this.d3v4]]=e},"1,1,1,1,1":function({point:t,value:e}){this.data[t[this.d0v0]][t[this.d1v0]][t[this.d2v0]][t[this.d3v0]][t[this.d4v0]]=e},"1,1,1,1,2":function({point:t,value:e}){this.data[t[this.d0v0]][t[this.d1v0]][t[this.d2v0]][t[this.d3v0]][this.m4v0*t[this.d4v0]+this.m4v1*t[this.d4v1]]=e},"1,1,1,1,3":function({point:t,value:e}){this.data[t[this.d0v0]][t[this.d1v0]][t[this.d2v0]][t[this.d3v0]][this.m4v0*t[this.d4v0]+this.m4v1*t[this.d4v1]+this.m4v2*t[this.d4v2]]=e},"1,1,1,1,4":function({point:t,value:e}){this.data[t[this.d0v0]][t[this.d1v0]][t[this.d2v0]][t[this.d3v0]][this.m4v0*t[this.d4v0]+this.m4v1*t[this.d4v1]+this.m4v2*t[this.d4v2]+this.m4v3*t[this.d4v3]]=e},"1,1,1,1,5":function({point:t,value:e}){this.data[t[this.d0v0]][t[this.d1v0]][t[this.d2v0]][t[this.d3v0]][this.m4v0*t[this.d4v0]+this.m4v1*t[this.d4v1]+this.m4v2*t[this.d4v2]+this.m4v3*t[this.d4v3]+this.m4v4*t[this.d4v4]]=e}}},function(t,e,r){"use strict";t.exports={countIn1D:function(t){return t.reduce((function(t,e){return void 0===t[e]?t[e]=1:t[e]++,t}),{})},countIn2D:function(t){return t.reduce((function(t,e){return e.forEach((function(e){void 0===t[e]?t[e]=1:t[e]++})),t}),{})},unflatten:function(t,e){for(var r=e.height,n=e.width,i=[],o=0;o<r;o++){var s=o*n,a=s+n;i.push(t.subarray(s,a))}return i}}},function(t,e,r){"use strict";r.r(e),r.d(e,"globals",(function(){return n})),r.d(e,"rgb",(function(){return i})),r.d(e,"getDecoder",(function(){return U})),r.d(e,"setLogger",(function(){return xt})),r.d(e,"GeoTIFF",(function(){return Tt})),r.d(e,"MultiGeoTIFF",(function(){return Ct})),r.d(e,"fromUrl",(function(){return Ot})),r.d(e,"fromArrayBuffer",(function(){return It})),r.d(e,"fromFile",(function(){return Pt})),r.d(e,"fromBlob",(function(){return Rt})),r.d(e,"fromUrls",(function(){return jt})),r.d(e,"writeArrayBuffer",(function(){return Mt})),r.d(e,"Pool",(function(){return Y.a}));var n={};r.r(n),r.d(n,"fieldTagNames",(function(){return a})),r.d(n,"fieldTags",(function(){return u})),r.d(n,"fieldTagTypes",(function(){return c})),r.d(n,"arrayFields",(function(){return l})),r.d(n,"fieldTypeNames",(function(){return f})),r.d(n,"fieldTypes",(function(){return h})),r.d(n,"photometricInterpretations",(function(){return d})),r.d(n,"ExtraSamplesValues",(function(){return p})),r.d(n,"geoKeyNames",(function(){return y})),r.d(n,"geoKeys",(function(){return g}));var i={};r.r(i),r.d(i,"fromWhiteIsZero",(function(){return m})),r.d(i,"fromBlackIsZero",(function(){return b})),r.d(i,"fromPalette",(function(){return v})),r.d(i,"fromCMYK",(function(){return w})),r.d(i,"fromYCbCr",(function(){return x})),r.d(i,"fromCIELab",(function(){return _}));var o=r(100),s=r.n(o);const a={315:"Artist",258:"BitsPerSample",265:"CellLength",264:"CellWidth",320:"ColorMap",259:"Compression",33432:"Copyright",306:"DateTime",338:"ExtraSamples",266:"FillOrder",289:"FreeByteCounts",288:"FreeOffsets",291:"GrayResponseCurve",290:"GrayResponseUnit",316:"HostComputer",270:"ImageDescription",257:"ImageLength",256:"ImageWidth",271:"Make",281:"MaxSampleValue",280:"MinSampleValue",272:"Model",254:"NewSubfileType",274:"Orientation",262:"PhotometricInterpretation",284:"PlanarConfiguration",296:"ResolutionUnit",278:"RowsPerStrip",277:"SamplesPerPixel",305:"Software",279:"StripByteCounts",273:"StripOffsets",255:"SubfileType",263:"Threshholding",282:"XResolution",283:"YResolution",326:"BadFaxLines",327:"CleanFaxData",343:"ClipPath",328:"ConsecutiveBadFaxLines",433:"Decode",434:"DefaultImageColor",269:"DocumentName",336:"DotRange",321:"HalftoneHints",346:"Indexed",347:"JPEGTables",285:"PageName",297:"PageNumber",317:"Predictor",319:"PrimaryChromaticities",532:"ReferenceBlackWhite",339:"SampleFormat",340:"SMinSampleValue",341:"SMaxSampleValue",559:"StripRowCounts",330:"SubIFDs",292:"T4Options",293:"T6Options",325:"TileByteCounts",323:"TileLength",324:"TileOffsets",322:"TileWidth",301:"TransferFunction",318:"WhitePoint",344:"XClipPathUnits",286:"XPosition",529:"YCbCrCoefficients",531:"YCbCrPositioning",530:"YCbCrSubSampling",345:"YClipPathUnits",287:"YPosition",37378:"ApertureValue",40961:"ColorSpace",36868:"DateTimeDigitized",36867:"DateTimeOriginal",34665:"Exif IFD",36864:"ExifVersion",33434:"ExposureTime",41728:"FileSource",37385:"Flash",40960:"FlashpixVersion",33437:"FNumber",42016:"ImageUniqueID",37384:"LightSource",37500:"MakerNote",37377:"ShutterSpeedValue",37510:"UserComment",33723:"IPTC",34675:"ICC Profile",700:"XMP",42112:"GDAL_METADATA",42113:"GDAL_NODATA",34377:"Photoshop",33550:"ModelPixelScale",33922:"ModelTiepoint",34264:"ModelTransformation",34735:"GeoKeyDirectory",34736:"GeoDoubleParams",34737:"GeoAsciiParams"},u={};for(const t in a)a.hasOwnProperty(t)&&(u[a[t]]=parseInt(t,10));const c={256:"SHORT",257:"SHORT",258:"SHORT",259:"SHORT",262:"SHORT",273:"LONG",274:"SHORT",277:"SHORT",278:"LONG",279:"LONG",282:"RATIONAL",283:"RATIONAL",284:"SHORT",286:"SHORT",287:"RATIONAL",296:"SHORT",305:"ASCII",306:"ASCII",338:"SHORT",339:"SHORT",513:"LONG",514:"LONG",1024:"SHORT",1025:"SHORT",2048:"SHORT",2049:"ASCII",33550:"DOUBLE",33922:"DOUBLE",34665:"LONG",34735:"SHORT",34737:"ASCII",42113:"ASCII"},l=[u.BitsPerSample,u.ExtraSamples,u.SampleFormat,u.StripByteCounts,u.StripOffsets,u.StripRowCounts,u.TileByteCounts,u.TileOffsets],f={1:"BYTE",2:"ASCII",3:"SHORT",4:"LONG",5:"RATIONAL",6:"SBYTE",7:"UNDEFINED",8:"SSHORT",9:"SLONG",10:"SRATIONAL",11:"FLOAT",12:"DOUBLE",13:"IFD",16:"LONG8",17:"SLONG8",18:"IFD8"},h={};for(const t in f)f.hasOwnProperty(t)&&(h[f[t]]=parseInt(t,10));const d={WhiteIsZero:0,BlackIsZero:1,RGB:2,Palette:3,TransparencyMask:4,CMYK:5,YCbCr:6,CIELab:8,ICCLab:9},p={Unspecified:0,Assocalpha:1,Unassalpha:2},y={1024:"GTModelTypeGeoKey",1025:"GTRasterTypeGeoKey",1026:"GTCitationGeoKey",2048:"GeographicTypeGeoKey",2049:"GeogCitationGeoKey",2050:"GeogGeodeticDatumGeoKey",2051:"GeogPrimeMeridianGeoKey",2052:"GeogLinearUnitsGeoKey",2053:"GeogLinearUnitSizeGeoKey",2054:"GeogAngularUnitsGeoKey",2055:"GeogAngularUnitSizeGeoKey",2056:"GeogEllipsoidGeoKey",2057:"GeogSemiMajorAxisGeoKey",2058:"GeogSemiMinorAxisGeoKey",2059:"GeogInvFlatteningGeoKey",2060:"GeogAzimuthUnitsGeoKey",2061:"GeogPrimeMeridianLongGeoKey",2062:"GeogTOWGS84GeoKey",3072:"ProjectedCSTypeGeoKey",3073:"PCSCitationGeoKey",3074:"ProjectionGeoKey",3075:"ProjCoordTransGeoKey",3076:"ProjLinearUnitsGeoKey",3077:"ProjLinearUnitSizeGeoKey",3078:"ProjStdParallel1GeoKey",3079:"ProjStdParallel2GeoKey",3080:"ProjNatOriginLongGeoKey",3081:"ProjNatOriginLatGeoKey",3082:"ProjFalseEastingGeoKey",3083:"ProjFalseNorthingGeoKey",3084:"ProjFalseOriginLongGeoKey",3085:"ProjFalseOriginLatGeoKey",3086:"ProjFalseOriginEastingGeoKey",3087:"ProjFalseOriginNorthingGeoKey",3088:"ProjCenterLongGeoKey",3089:"ProjCenterLatGeoKey",3090:"ProjCenterEastingGeoKey",3091:"ProjCenterNorthingGeoKey",3092:"ProjScaleAtNatOriginGeoKey",3093:"ProjScaleAtCenterGeoKey",3094:"ProjAzimuthAngleGeoKey",3095:"ProjStraightVertPoleLongGeoKey",3096:"ProjRectifiedGridAngleGeoKey",4096:"VerticalCSTypeGeoKey",4097:"VerticalCitationGeoKey",4098:"VerticalDatumGeoKey",4099:"VerticalUnitsGeoKey"},g={};for(const t in y)y.hasOwnProperty(t)&&(g[y[t]]=parseInt(t,10));function m(t,e){const{width:r,height:n}=t,i=new Uint8Array(r*n*3);let o;for(let r=0,n=0;r<t.length;++r,n+=3)o=256-t[r]/e*256,i[n]=o,i[n+1]=o,i[n+2]=o;return i}function b(t,e){const{width:r,height:n}=t,i=new Uint8Array(r*n*3);let o;for(let r=0,n=0;r<t.length;++r,n+=3)o=t[r]/e*256,i[n]=o,i[n+1]=o,i[n+2]=o;return i}function v(t,e){const{width:r,height:n}=t,i=new Uint8Array(r*n*3),o=e.length/3,s=e.length/3*2;for(let r=0,n=0;r<t.length;++r,n+=3){const a=t[r];i[n]=e[a]/65536*256,i[n+1]=e[a+o]/65536*256,i[n+2]=e[a+s]/65536*256}return i}function w(t){const{width:e,height:r}=t,n=new Uint8Array(e*r*3);for(let e=0,r=0;e<t.length;e+=4,r+=3){const i=t[e],o=t[e+1],s=t[e+2],a=t[e+3];n[r]=(255-i)/256*255*((255-a)/256),n[r+1]=(255-o)/256*255*((255-a)/256),n[r+2]=(255-s)/256*255*((255-a)/256)}return n}function x(t){const{width:e,height:r}=t,n=new Uint8ClampedArray(e*r*3);for(let e=0,r=0;e<t.length;e+=3,r+=3){const i=t[e],o=t[e+1],s=t[e+2];n[r]=i+1.402*(s-128),n[r+1]=i-.34414*(o-128)-.71414*(s-128),n[r+2]=i+1.772*(o-128)}return n}function _(t){const{width:e,height:r}=t,n=new Uint8Array(e*r*3);for(let e=0,r=0;e<t.length;e+=3,r+=3){let i,o,s,a=(t[e+0]+16)/116,u=(t[e+1]<<24>>24)/500+a,c=a-(t[e+2]<<24>>24)/200;u=.95047*(u*u*u>.008856?u*u*u:(u-16/116)/7.787),a=1*(a*a*a>.008856?a*a*a:(a-16/116)/7.787),c=1.08883*(c*c*c>.008856?c*c*c:(c-16/116)/7.787),i=3.2406*u+-1.5372*a+-.4986*c,o=-.9689*u+1.8758*a+.0415*c,s=.0557*u+-.204*a+1.057*c,i=i>.0031308?1.055*i**(1/2.4)-.055:12.92*i,o=o>.0031308?1.055*o**(1/2.4)-.055:12.92*o,s=s>.0031308?1.055*s**(1/2.4)-.055:12.92*s,n[r]=255*Math.max(0,Math.min(1,i)),n[r+1]=255*Math.max(0,Math.min(1,o)),n[r+2]=255*Math.max(0,Math.min(1,s))}return n}function S(t,e){let r=t.length-e,n=0;do{for(let r=e;r>0;r--)t[n+e]+=t[n],n++;r-=e}while(r>0)}function A(t,e,r){let n=0,i=t.length;const o=i/r;for(;i>e;){for(let r=e;r>0;--r)t[n+e]+=t[n],++n;i-=e}const s=t.slice();for(let e=0;e<o;++e)for(let n=0;n<r;++n)t[r*e+n]=s[(r-n-1)*o+e]}class E{decode(t,e){const r=this.decodeBlock(e),n=t.Predictor||1;if(1!==n){const e=!t.StripOffsets;return function(t,e,r,n,i,o){if(!e||1===e)return t;for(let t=0;t<i.length;++t){if(i[t]%8!=0)throw new Error("When decoding with predictor, only multiple of 8 bits are supported.");if(i[t]!==i[0])throw new Error("When decoding with predictor, all samples must have the same size.")}const s=i[0]/8,a=2===o?1:i.length;for(let o=0;o<n&&!(o*a*r*s>=t.byteLength);++o){let n;if(2===e){switch(i[0]){case 8:n=new Uint8Array(t,o*a*r*s,a*r*s);break;case 16:n=new Uint16Array(t,o*a*r*s,a*r*s/2);break;case 32:n=new Uint32Array(t,o*a*r*s,a*r*s/4);break;default:throw new Error(`Predictor 2 not allowed with ${i[0]} bits per sample.`)}S(n,a)}else 3===e&&(n=new Uint8Array(t,o*a*r*s,a*r*s),A(n,a,s))}return t}(r,n,e?t.TileWidth:t.ImageWidth,e?t.TileLength:t.RowsPerStrip||t.ImageLength,t.BitsPerSample,t.PlanarConfiguration)}return r}}class k extends E{decodeBlock(t){return t}}function T(t,e){for(let r=e.length-1;r>=0;r--)t.push(e[r]);return t}function C(t){const e=new Uint16Array(4093),r=new Uint8Array(4093);for(let t=0;t<=257;t++)e[t]=4096,r[t]=t;let n=258,i=9,o=0;function s(){n=258,i=9}function a(t){const e=function(t,e,r){const n=e%8,i=Math.floor(e/8),o=8-n,s=e+r-8*(i+1);let a=8*(i+2)-(e+r);const u=8*(i+2)-e;if(a=Math.max(0,a),i>=t.length)return console.warn("ran off the end of the buffer before finding EOI_CODE (end on input code)"),257;let c=t[i]&2**(8-n)-1;c<<=r-o;let l=c;if(i+1<t.length){let e=t[i+1]>>>a;e<<=Math.max(0,r-u),l+=e}if(s>8&&i+2<t.length){const n=8*(i+3)-(e+r);l+=t[i+2]>>>n}return l}(t,o,i);return o+=i,e}function u(t,i){return r[n]=i,e[n]=t,n++,n-1}function c(t){const n=[];for(let i=t;4096!==i;i=e[i])n.push(r[i]);return n}const l=[];s();const f=new Uint8Array(t);let h,d=a(f);for(;257!==d;){if(256===d){for(s(),d=a(f);256===d;)d=a(f);if(257===d)break;if(d>256)throw new Error("corrupted code at scanline "+d);T(l,c(d)),h=d}else if(d<n){const t=c(d);T(l,t),u(h,t[t.length-1]),h=d}else{const t=c(h);if(!t)throw new Error(`Bogus entry. Not in dictionary, ${h} / ${n}, position: ${o}`);T(l,t),l.push(t[t.length-1]),u(h,t[t.length-1]),h=d}n+1>=2**i&&(12===i?h=void 0:i++),d=a(f)}return new Uint8Array(l)}class O extends E{decodeBlock(t){return C(t).buffer}}const I=new Int32Array([0,1,8,16,9,2,3,10,17,24,32,25,18,11,4,5,12,19,26,33,40,48,41,34,27,20,13,6,7,14,21,28,35,42,49,56,57,50,43,36,29,22,15,23,30,37,44,51,58,59,52,45,38,31,39,46,53,60,61,54,47,55,62,63]);function P(t,e){let r=0;const n=[];let i=16;for(;i>0&&!t[i-1];)--i;n.push({children:[],index:0});let o,s=n[0];for(let a=0;a<i;a++){for(let i=0;i<t[a];i++){for(s=n.pop(),s.children[s.index]=e[r];s.index>0;)s=n.pop();for(s.index++,n.push(s);n.length<=a;)n.push(o={children:[],index:0}),s.children[s.index]=o.children,s=o;r++}a+1<i&&(n.push(o={children:[],index:0}),s.children[s.index]=o.children,s=o)}return n[0].children}function R(t,e,r,n,i,o,s,a,u){const{mcusPerLine:c,progressive:l}=r,f=e;let h=e,d=0,p=0;function y(){if(p>0)return p--,d>>p&1;if(d=t[h++],255===d){const e=t[h++];if(e)throw new Error("unexpected marker: "+(d<<8|e).toString(16))}return p=7,d>>>7}function g(t){let e,r=t;for(;null!==(e=y());){if(r=r[e],"number"==typeof r)return r;if("object"!=typeof r)throw new Error("invalid huffman sequence")}return null}function m(t){let e=t,r=0;for(;e>0;){const t=y();if(null===t)return;r=r<<1|t,--e}return r}function b(t){const e=m(t);return e>=1<<t-1?e:e+(-1<<t)+1}let v=0;let w,x=0;function _(t,e,r,n,i){const o=r%c,s=(r/c|0)*t.v+n,a=o*t.h+i;e(t,t.blocks[s][a])}function S(t,e,r){const n=r/t.blocksPerLine|0,i=r%t.blocksPerLine;e(t,t.blocks[n][i])}const A=n.length;let E,k,T,C,O,P;P=l?0===o?0===a?function(t,e){const r=g(t.huffmanTableDC),n=0===r?0:b(r)<<u;t.pred+=n,e[0]=t.pred}:function(t,e){e[0]|=y()<<u}:0===a?function(t,e){if(v>0)return void v--;let r=o;const n=s;for(;r<=n;){const n=g(t.huffmanTableAC),i=15&n,o=n>>4;if(0===i){if(o<15){v=m(o)+(1<<o)-1;break}r+=16}else{r+=o;e[I[r]]=b(i)*(1<<u),r++}}}:function(t,e){let r=o;const n=s;let i=0;for(;r<=n;){const n=I[r],o=e[n]<0?-1:1;switch(x){case 0:{const e=g(t.huffmanTableAC),r=15&e;if(i=e>>4,0===r)i<15?(v=m(i)+(1<<i),x=4):(i=16,x=1);else{if(1!==r)throw new Error("invalid ACn encoding");w=b(r),x=i?2:3}continue}case 1:case 2:e[n]?e[n]+=(y()<<u)*o:(i--,0===i&&(x=2===x?3:0));break;case 3:e[n]?e[n]+=(y()<<u)*o:(e[n]=w<<u,x=0);break;case 4:e[n]&&(e[n]+=(y()<<u)*o)}r++}4===x&&(v--,0===v&&(x=0))}:function(t,e){const r=g(t.huffmanTableDC),n=0===r?0:b(r);t.pred+=n,e[0]=t.pred;let i=1;for(;i<64;){const r=g(t.huffmanTableAC),n=15&r,o=r>>4;if(0===n){if(o<15)break;i+=16}else{i+=o;e[I[i]]=b(n),i++}}};let R,j,M=0;j=1===A?n[0].blocksPerLine*n[0].blocksPerColumn:c*r.mcusPerColumn;const L=i||j;for(;M<j;){for(k=0;k<A;k++)n[k].pred=0;if(v=0,1===A)for(E=n[0],O=0;O<L;O++)S(E,P,M),M++;else for(O=0;O<L;O++){for(k=0;k<A;k++){E=n[k];const{h:t,v:e}=E;for(T=0;T<e;T++)for(C=0;C<t;C++)_(E,P,M,T,C)}if(M++,M===j)break}if(p=0,R=t[h]<<8|t[h+1],R<65280)throw new Error("marker was not found");if(!(R>=65488&&R<=65495))break;h+=2}return h-f}function j(t,e){const r=[],{blocksPerLine:n,blocksPerColumn:i}=e,o=n<<3,s=new Int32Array(64),a=new Uint8Array(64);function u(t,r,n){const i=e.quantizationTable;let o,s,a,u,c,l,f,h,d;const p=n;let y;for(y=0;y<64;y++)p[y]=t[y]*i[y];for(y=0;y<8;++y){const t=8*y;0!==p[1+t]||0!==p[2+t]||0!==p[3+t]||0!==p[4+t]||0!==p[5+t]||0!==p[6+t]||0!==p[7+t]?(o=5793*p[0+t]+128>>8,s=5793*p[4+t]+128>>8,a=p[2+t],u=p[6+t],c=2896*(p[1+t]-p[7+t])+128>>8,h=2896*(p[1+t]+p[7+t])+128>>8,l=p[3+t]<<4,f=p[5+t]<<4,d=o-s+1>>1,o=o+s+1>>1,s=d,d=3784*a+1567*u+128>>8,a=1567*a-3784*u+128>>8,u=d,d=c-f+1>>1,c=c+f+1>>1,f=d,d=h+l+1>>1,l=h-l+1>>1,h=d,d=o-u+1>>1,o=o+u+1>>1,u=d,d=s-a+1>>1,s=s+a+1>>1,a=d,d=2276*c+3406*h+2048>>12,c=3406*c-2276*h+2048>>12,h=d,d=799*l+4017*f+2048>>12,l=4017*l-799*f+2048>>12,f=d,p[0+t]=o+h,p[7+t]=o-h,p[1+t]=s+f,p[6+t]=s-f,p[2+t]=a+l,p[5+t]=a-l,p[3+t]=u+c,p[4+t]=u-c):(d=5793*p[0+t]+512>>10,p[0+t]=d,p[1+t]=d,p[2+t]=d,p[3+t]=d,p[4+t]=d,p[5+t]=d,p[6+t]=d,p[7+t]=d)}for(y=0;y<8;++y){const t=y;0!==p[8+t]||0!==p[16+t]||0!==p[24+t]||0!==p[32+t]||0!==p[40+t]||0!==p[48+t]||0!==p[56+t]?(o=5793*p[0+t]+2048>>12,s=5793*p[32+t]+2048>>12,a=p[16+t],u=p[48+t],c=2896*(p[8+t]-p[56+t])+2048>>12,h=2896*(p[8+t]+p[56+t])+2048>>12,l=p[24+t],f=p[40+t],d=o-s+1>>1,o=o+s+1>>1,s=d,d=3784*a+1567*u+2048>>12,a=1567*a-3784*u+2048>>12,u=d,d=c-f+1>>1,c=c+f+1>>1,f=d,d=h+l+1>>1,l=h-l+1>>1,h=d,d=o-u+1>>1,o=o+u+1>>1,u=d,d=s-a+1>>1,s=s+a+1>>1,a=d,d=2276*c+3406*h+2048>>12,c=3406*c-2276*h+2048>>12,h=d,d=799*l+4017*f+2048>>12,l=4017*l-799*f+2048>>12,f=d,p[0+t]=o+h,p[56+t]=o-h,p[8+t]=s+f,p[48+t]=s-f,p[16+t]=a+l,p[40+t]=a-l,p[24+t]=u+c,p[32+t]=u-c):(d=5793*n[y+0]+8192>>14,p[0+t]=d,p[8+t]=d,p[16+t]=d,p[24+t]=d,p[32+t]=d,p[40+t]=d,p[48+t]=d,p[56+t]=d)}for(y=0;y<64;++y){const t=128+(p[y]+8>>4);r[y]=t<0?0:t>255?255:t}}for(let t=0;t<i;t++){const i=t<<3;for(let t=0;t<8;t++)r.push(new Uint8Array(o));for(let o=0;o<n;o++){u(e.blocks[t][o],a,s);let n=0;const c=o<<3;for(let t=0;t<8;t++){const e=r[i+t];for(let t=0;t<8;t++)e[c+t]=a[n++]}}}return r}class M{constructor(){this.jfif=null,this.adobe=null,this.quantizationTables=[],this.huffmanTablesAC=[],this.huffmanTablesDC=[],this.resetFrames()}resetFrames(){this.frames=[]}parse(t){let e=0;function r(){const r=t[e]<<8|t[e+1];return e+=2,r}function n(){const n=r(),i=t.subarray(e,e+n-2);return e+=i.length,i}function i(t){let e,r,n=0,i=0;for(r in t.components)t.components.hasOwnProperty(r)&&(e=t.components[r],n<e.h&&(n=e.h),i<e.v&&(i=e.v));const o=Math.ceil(t.samplesPerLine/8/n),s=Math.ceil(t.scanLines/8/i);for(r in t.components)if(t.components.hasOwnProperty(r)){e=t.components[r];const a=Math.ceil(Math.ceil(t.samplesPerLine/8)*e.h/n),u=Math.ceil(Math.ceil(t.scanLines/8)*e.v/i),c=o*e.h,l=s*e.v,f=[];for(let t=0;t<l;t++){const t=[];for(let e=0;e<c;e++)t.push(new Int32Array(64));f.push(t)}e.blocksPerLine=a,e.blocksPerColumn=u,e.blocks=f}t.maxH=n,t.maxV=i,t.mcusPerLine=o,t.mcusPerColumn=s}let o=r();if(65496!==o)throw new Error("SOI not found");for(o=r();65497!==o;){switch(o){case 65280:break;case 65504:case 65505:case 65506:case 65507:case 65508:case 65509:case 65510:case 65511:case 65512:case 65513:case 65514:case 65515:case 65516:case 65517:case 65518:case 65519:case 65534:{const t=n();65504===o&&74===t[0]&&70===t[1]&&73===t[2]&&70===t[3]&&0===t[4]&&(this.jfif={version:{major:t[5],minor:t[6]},densityUnits:t[7],xDensity:t[8]<<8|t[9],yDensity:t[10]<<8|t[11],thumbWidth:t[12],thumbHeight:t[13],thumbData:t.subarray(14,14+3*t[12]*t[13])}),65518===o&&65===t[0]&&100===t[1]&&111===t[2]&&98===t[3]&&101===t[4]&&0===t[5]&&(this.adobe={version:t[6],flags0:t[7]<<8|t[8],flags1:t[9]<<8|t[10],transformCode:t[11]});break}case 65499:{const n=r()+e-2;for(;e<n;){const n=t[e++],i=new Int32Array(64);if(n>>4==0)for(let r=0;r<64;r++){i[I[r]]=t[e++]}else{if(n>>4!=1)throw new Error("DQT: invalid table spec");for(let t=0;t<64;t++){i[I[t]]=r()}}this.quantizationTables[15&n]=i}break}case 65472:case 65473:case 65474:{r();const n={extended:65473===o,progressive:65474===o,precision:t[e++],scanLines:r(),samplesPerLine:r(),components:{},componentsOrder:[]},s=t[e++];let a;for(let r=0;r<s;r++){a=t[e];const r=t[e+1]>>4,i=15&t[e+1],o=t[e+2];n.componentsOrder.push(a),n.components[a]={h:r,v:i,quantizationIdx:o},e+=3}i(n),this.frames.push(n);break}case 65476:{const n=r();for(let r=2;r<n;){const n=t[e++],i=new Uint8Array(16);let o=0;for(let r=0;r<16;r++,e++)i[r]=t[e],o+=i[r];const s=new Uint8Array(o);for(let r=0;r<o;r++,e++)s[r]=t[e];r+=17+o,n>>4==0?this.huffmanTablesDC[15&n]=P(i,s):this.huffmanTablesAC[15&n]=P(i,s)}break}case 65501:r(),this.resetInterval=r();break;case 65498:{r();const n=t[e++],i=[],o=this.frames[0];for(let r=0;r<n;r++){const r=o.components[t[e++]],n=t[e++];r.huffmanTableDC=this.huffmanTablesDC[n>>4],r.huffmanTableAC=this.huffmanTablesAC[15&n],i.push(r)}const s=t[e++],a=t[e++],u=t[e++],c=R(t,e,o,i,this.resetInterval,s,a,u>>4,15&u);e+=c;break}case 65535:255!==t[e]&&e--;break;default:if(255===t[e-3]&&t[e-2]>=192&&t[e-2]<=254){e-=3;break}throw new Error("unknown JPEG marker "+o.toString(16))}o=r()}}getResult(){const{frames:t}=this;if(0===this.frames.length)throw new Error("no frames were decoded");this.frames.length>1&&console.warn("more than one frame is not supported");for(let t=0;t<this.frames.length;t++){const e=this.frames[t].components;for(const t of Object.keys(e))e[t].quantizationTable=this.quantizationTables[e[t].quantizationIdx],delete e[t].quantizationIdx}const e=t[0],{components:r,componentsOrder:n}=e,i=[],o=e.samplesPerLine,s=e.scanLines;for(let t=0;t<n.length;t++){const o=r[n[t]];i.push({lines:j(0,o),scaleX:o.h/e.maxH,scaleY:o.v/e.maxV})}const a=new Uint8Array(o*s*i.length);let u=0;for(let t=0;t<s;++t)for(let e=0;e<o;++e)for(let r=0;r<i.length;++r){const n=i[r];a[u]=n.lines[0|t*n.scaleY][0|e*n.scaleX],++u}return a}}class L extends E{constructor(t){super(),this.reader=new M,t.JPEGTables&&this.reader.parse(t.JPEGTables)}decodeBlock(t){return this.reader.resetFrames(),this.reader.parse(new Uint8Array(t)),this.reader.getResult().buffer}}var F=r(101);class N extends E{decodeBlock(t){return Object(F.inflate)(new Uint8Array(t)).buffer}}class D extends E{decodeBlock(t){const e=new DataView(t),r=[];for(let n=0;n<t.byteLength;++n){let t=e.getInt8(n);if(t<0){const i=e.getUint8(n+1);t=-t;for(let e=0;e<=t;++e)r.push(i);n+=1}else{for(let i=0;i<=t;++i)r.push(e.getUint8(n+i+1));n+=t+1}}return new Uint8Array(r).buffer}}function U(t){switch(t.Compression){case void 0:case 1:return new k;case 5:return new O;case 6:throw new Error("old style JPEG compression is not supported.");case 7:return new L(t);case 8:case 32946:return new N;case 32773:return new D;default:throw new Error("Unknown compression method identifier: "+t.Compression)}}function B(t,e,r,n=1){return new(Object.getPrototypeOf(t).constructor)(e*r*n)}function G(t,e,r){return(1-r)*t+r*e}function q(t,e,r,n,i,o="nearest"){switch(o.toLowerCase()){case"nearest":return function(t,e,r,n,i){const o=e/n,s=r/i;return t.map(t=>{const a=B(t,n,i);for(let u=0;u<i;++u){const i=Math.min(Math.round(s*u),r-1);for(let r=0;r<n;++r){const s=Math.min(Math.round(o*r),e-1),c=t[i*e+s];a[u*n+r]=c}}return a})}(t,e,r,n,i);case"bilinear":case"linear":return function(t,e,r,n,i){const o=e/n,s=r/i;return t.map(t=>{const a=B(t,n,i);for(let u=0;u<i;++u){const i=s*u,c=Math.floor(i),l=Math.min(Math.ceil(i),r-1);for(let r=0;r<n;++r){const s=o*r,f=s%1,h=Math.floor(s),d=Math.min(Math.ceil(s),e-1),p=t[c*e+h],y=t[c*e+d],g=t[l*e+h],m=t[l*e+d],b=G(G(p,y,f),G(g,m,f),i%1);a[u*n+r]=b}}return a})}(t,e,r,n,i);default:throw new Error(`Unsupported resampling method: \'${o}\'`)}}function z(t,e,r,n,i,o,s="nearest"){switch(s.toLowerCase()){case"nearest":return function(t,e,r,n,i,o){const s=e/n,a=r/i,u=B(t,n,i,o);for(let c=0;c<i;++c){const i=Math.min(Math.round(a*c),r-1);for(let r=0;r<n;++r){const a=Math.min(Math.round(s*r),e-1);for(let s=0;s<o;++s){const l=t[i*e*o+a*o+s];u[c*n*o+r*o+s]=l}}}return u}(t,e,r,n,i,o);case"bilinear":case"linear":return function(t,e,r,n,i,o){const s=e/n,a=r/i,u=B(t,n,i,o);for(let c=0;c<i;++c){const i=a*c,l=Math.floor(i),f=Math.min(Math.ceil(i),r-1);for(let r=0;r<n;++r){const a=s*r,h=a%1,d=Math.floor(a),p=Math.min(Math.ceil(a),e-1);for(let s=0;s<o;++s){const a=t[l*e*o+d*o+s],y=t[l*e*o+p*o+s],g=t[f*e*o+d*o+s],m=t[f*e*o+p*o+s],b=G(G(a,y,h),G(g,m,h),i%1);u[c*n*o+r*o+s]=b}}}return u}(t,e,r,n,i,o);default:throw new Error(`Unsupported resampling method: \'${s}\'`)}}function H(t,e,r){let n=0;for(let i=e;i<r;++i)n+=t[i];return n}function W(t,e,r){switch(t){case 1:switch(e){case 8:return new Uint8Array(r);case 16:return new Uint16Array(r);case 32:return new Uint32Array(r)}break;case 2:switch(e){case 8:return new Int8Array(r);case 16:return new Int16Array(r);case 32:return new Int32Array(r)}break;case 3:switch(e){case 32:return new Float32Array(r);case 64:return new Float64Array(r)}}throw Error("Unsupported data format/bitsPerSample")}var V=class{constructor(t,e,r,n,i,o){this.fileDirectory=t,this.geoKeys=e,this.dataView=r,this.littleEndian=n,this.tiles=i?{}:null,this.isTiled=!t.StripOffsets;const s=t.PlanarConfiguration;if(this.planarConfiguration=void 0===s?1:s,1!==this.planarConfiguration&&2!==this.planarConfiguration)throw new Error("Invalid planar configuration.");this.source=o}getFileDirectory(){return this.fileDirectory}getGeoKeys(){return this.geoKeys}getWidth(){return this.fileDirectory.ImageWidth}getHeight(){return this.fileDirectory.ImageLength}getSamplesPerPixel(){return this.fileDirectory.SamplesPerPixel}getTileWidth(){return this.isTiled?this.fileDirectory.TileWidth:this.getWidth()}getTileHeight(){return this.isTiled?this.fileDirectory.TileLength:void 0!==this.fileDirectory.RowsPerStrip?Math.min(this.fileDirectory.RowsPerStrip,this.getHeight()):this.getHeight()}getBytesPerPixel(){let t=0;for(let e=0;e<this.fileDirectory.BitsPerSample.length;++e){const r=this.fileDirectory.BitsPerSample[e];if(r%8!=0)throw new Error(`Sample bit-width of ${r} is not supported.`);if(r!==this.fileDirectory.BitsPerSample[0])throw new Error("Differing size of samples in a pixel are not supported.");t+=r}return t/8}getSampleByteSize(t){if(t>=this.fileDirectory.BitsPerSample.length)throw new RangeError(`Sample index ${t} is out of range.`);const e=this.fileDirectory.BitsPerSample[t];if(e%8!=0)throw new Error(`Sample bit-width of ${e} is not supported.`);return e/8}getReaderForSample(t){const e=this.fileDirectory.SampleFormat?this.fileDirectory.SampleFormat[t]:1,r=this.fileDirectory.BitsPerSample[t];switch(e){case 1:switch(r){case 8:return DataView.prototype.getUint8;case 16:return DataView.prototype.getUint16;case 32:return DataView.prototype.getUint32}break;case 2:switch(r){case 8:return DataView.prototype.getInt8;case 16:return DataView.prototype.getInt16;case 32:return DataView.prototype.getInt32}break;case 3:switch(r){case 32:return DataView.prototype.getFloat32;case 64:return DataView.prototype.getFloat64}}throw Error("Unsupported data format/bitsPerSample")}getArrayForSample(t,e){return W(this.fileDirectory.SampleFormat?this.fileDirectory.SampleFormat[t]:1,this.fileDirectory.BitsPerSample[t],e)}async getTileOrStrip(t,e,r,n){const i=Math.ceil(this.getWidth()/this.getTileWidth()),o=Math.ceil(this.getHeight()/this.getTileHeight());let s;const{tiles:a}=this;let u,c;1===this.planarConfiguration?s=e*i+t:2===this.planarConfiguration&&(s=r*i*o+e*i+t),this.isTiled?(u=this.fileDirectory.TileOffsets[s],c=this.fileDirectory.TileByteCounts[s]):(u=this.fileDirectory.StripOffsets[s],c=this.fileDirectory.StripByteCounts[s]);const l=await this.source.fetch(u,c);let f;return null===a?f=n.decode(this.fileDirectory,l):a[s]||(f=n.decode(this.fileDirectory,l),a[s]=f),{x:t,y:e,sample:r,data:await f}}async _readRaster(t,e,r,n,i,o,s,a){const u=this.getTileWidth(),c=this.getTileHeight(),l=Math.max(Math.floor(t[0]/u),0),f=Math.min(Math.ceil(t[2]/u),Math.ceil(this.getWidth()/this.getTileWidth())),h=Math.max(Math.floor(t[1]/c),0),d=Math.min(Math.ceil(t[3]/c),Math.ceil(this.getHeight()/this.getTileHeight())),p=t[2]-t[0];let y=this.getBytesPerPixel();const g=[],m=[];for(let t=0;t<e.length;++t)1===this.planarConfiguration?g.push(H(this.fileDirectory.BitsPerSample,0,e[t])/8):g.push(0),m.push(this.getReaderForSample(e[t]));const b=[],{littleEndian:v}=this;for(let o=h;o<d;++o)for(let s=l;s<f;++s)for(let a=0;a<e.length;++a){const l=a,f=e[a];2===this.planarConfiguration&&(y=this.getSampleByteSize(f));const h=this.getTileOrStrip(s,o,f,i);b.push(h),h.then(i=>{const o=i.data,s=new DataView(o),a=i.y*c,f=i.x*u,h=(i.y+1)*c,d=(i.x+1)*u,b=m[l],w=Math.min(c,c-(h-t[3])),x=Math.min(u,u-(d-t[2]));for(let i=Math.max(0,t[1]-a);i<w;++i)for(let o=Math.max(0,t[0]-f);o<x;++o){const c=(i*u+o)*y,h=b.call(s,c+g[l],v);let d;n?(d=(i+a-t[1])*p*e.length+(o+f-t[0])*e.length+l,r[d]=h):(d=(i+a-t[1])*p+o+f-t[0],r[l][d]=h)}})}if(await Promise.all(b),o&&t[2]-t[0]!==o||s&&t[3]-t[1]!==s){let i;return i=n?z(r,t[2]-t[0],t[3]-t[1],o,s,e.length,a):q(r,t[2]-t[0],t[3]-t[1],o,s,a),i.width=o,i.height=s,i}return r.width=o||t[2]-t[0],r.height=s||t[3]-t[1],r}async readRasters({window:t,samples:e=[],interleave:r,pool:n=null,width:i,height:o,resampleMethod:s,fillValue:a}={}){const u=t||[0,0,this.getWidth(),this.getHeight()];if(u[0]>u[2]||u[1]>u[3])throw new Error("Invalid subsets");const c=(u[2]-u[0])*(u[3]-u[1]);if(e&&e.length){for(let t=0;t<e.length;++t)if(e[t]>=this.fileDirectory.SamplesPerPixel)return Promise.reject(new RangeError(`Invalid sample index \'${e[t]}\'.`))}else for(let t=0;t<this.fileDirectory.SamplesPerPixel;++t)e.push(t);let l;if(r){l=W(this.fileDirectory.SampleFormat?Math.max.apply(null,this.fileDirectory.SampleFormat):1,Math.max.apply(null,this.fileDirectory.BitsPerSample),c*e.length),a&&l.fill(a)}else{l=[];for(let t=0;t<e.length;++t){const r=this.getArrayForSample(e[t],c);Array.isArray(a)&&t<a.length?r.fill(a[t]):a&&!Array.isArray(a)&&r.fill(a),l.push(r)}}const f=n||U(this.fileDirectory);return await this._readRaster(u,e,l,r,f,i,o,s)}async readRGB({window:t,pool:e=null,width:r,height:n,resampleMethod:i,enableAlpha:o=!1}={}){const s=t||[0,0,this.getWidth(),this.getHeight()];if(s[0]>s[2]||s[1]>s[3])throw new Error("Invalid subsets");const a=this.fileDirectory.PhotometricInterpretation;if(a===d.RGB){let i=[0,1,2];if(this.fileDirectory.ExtraSamples!==p.Unspecified&&o){i=[];for(let t=0;t<this.fileDirectory.BitsPerSample.length;t+=1)i.push(t)}return this.readRasters({window:t,interleave:!0,samples:i,pool:e,width:r,height:n})}let u;switch(a){case d.WhiteIsZero:case d.BlackIsZero:case d.Palette:u=[0];break;case d.CMYK:u=[0,1,2,3];break;case d.YCbCr:case d.CIELab:u=[0,1,2];break;default:throw new Error("Invalid or unsupported photometric interpretation.")}const c={window:s,interleave:!0,samples:u,pool:e,width:r,height:n,resampleMethod:i},{fileDirectory:l}=this,f=await this.readRasters(c),h=2**this.fileDirectory.BitsPerSample[0];let y;switch(a){case d.WhiteIsZero:y=m(f,h);break;case d.BlackIsZero:y=b(f,h);break;case d.Palette:y=v(f,l.ColorMap);break;case d.CMYK:y=w(f);break;case d.YCbCr:y=x(f);break;case d.CIELab:y=_(f);break;default:throw new Error("Unsupported photometric interpretation.")}return y.width=f.width,y.height=f.height,y}getTiePoints(){if(!this.fileDirectory.ModelTiepoint)return[];const t=[];for(let e=0;e<this.fileDirectory.ModelTiepoint.length;e+=6)t.push({i:this.fileDirectory.ModelTiepoint[e],j:this.fileDirectory.ModelTiepoint[e+1],k:this.fileDirectory.ModelTiepoint[e+2],x:this.fileDirectory.ModelTiepoint[e+3],y:this.fileDirectory.ModelTiepoint[e+4],z:this.fileDirectory.ModelTiepoint[e+5]});return t}getGDALMetadata(t=null){const e={};if(!this.fileDirectory.GDAL_METADATA)return null;const r=this.fileDirectory.GDAL_METADATA,n=s()(r.substring(0,r.length-1));if(!n[0].tagName)throw new Error("Failed to parse GDAL metadata XML.");const i=n[0];if("GDALMetadata"!==i.tagName)throw new Error("Unexpected GDAL metadata XML tag.");let o=i.children.filter(t=>"Item"===t.tagName);t&&(o=o.filter(e=>Number(e.attributes.sample)===t));for(let t=0;t<o.length;++t){const r=o[t];e[r.attributes.name]=r.children[0]}return e}getGDALNoData(){if(!this.fileDirectory.GDAL_NODATA)return null;const t=this.fileDirectory.GDAL_NODATA;return Number(t.substring(0,t.length-1))}getOrigin(){const t=this.fileDirectory.ModelTiepoint,e=this.fileDirectory.ModelTransformation;if(t&&6===t.length)return[t[3],t[4],t[5]];if(e)return[e[3],e[7],e[11]];throw new Error("The image does not have an affine transformation.")}getResolution(t=null){const e=this.fileDirectory.ModelPixelScale,r=this.fileDirectory.ModelTransformation;if(e)return[e[0],-e[1],e[2]];if(r)return[r[0],r[5],r[10]];if(t){const[e,r,n]=t.getResolution();return[e*t.getWidth()/this.getWidth(),r*t.getHeight()/this.getHeight(),n*t.getWidth()/this.getWidth()]}throw new Error("The image does not have an affine transformation.")}pixelIsArea(){return 1===this.geoKeys.GTRasterTypeGeoKey}getBoundingBox(){const t=this.getOrigin(),e=this.getResolution(),r=t[0],n=t[1],i=r+e[0]*this.getWidth(),o=n+e[1]*this.getHeight();return[Math.min(r,i),Math.min(n,o),Math.max(r,i),Math.max(n,o)]}};class K{constructor(t){this._dataView=new DataView(t)}get buffer(){return this._dataView.buffer}getUint64(t,e){const r=this.getUint32(t,e),n=this.getUint32(t+4,e);let i;if(e){if(i=r+2**32*n,!Number.isSafeInteger(i))throw new Error(i+" exceeds MAX_SAFE_INTEGER. Precision may be lost. Please report if you get this message to https://github.com/geotiffjs/geotiff.js/issues");return i}if(i=2**32*r+n,!Number.isSafeInteger(i))throw new Error(i+" exceeds MAX_SAFE_INTEGER. Precision may be lost. Please report if you get this message to https://github.com/geotiffjs/geotiff.js/issues");return i}getInt64(t,e){let r=0;const n=(128&this._dataView.getUint8(t+(e?7:0)))>0;let i=!0;for(let o=0;o<8;o++){let s=this._dataView.getUint8(t+(e?o:7-o));n&&(i?0!==s&&(s=255&~(s-1),i=!1):s=255&~s),r+=s*256**o}return n&&(r=-r),r}getUint8(t,e){return this._dataView.getUint8(t,e)}getInt8(t,e){return this._dataView.getInt8(t,e)}getUint16(t,e){return this._dataView.getUint16(t,e)}getInt16(t,e){return this._dataView.getInt16(t,e)}getUint32(t,e){return this._dataView.getUint32(t,e)}getInt32(t,e){return this._dataView.getInt32(t,e)}getFloat32(t,e){return this._dataView.getFloat32(t,e)}getFloat64(t,e){return this._dataView.getFloat64(t,e)}}class ${constructor(t,e,r,n){this._dataView=new DataView(t),this._sliceOffset=e,this._littleEndian=r,this._bigTiff=n}get sliceOffset(){return this._sliceOffset}get sliceTop(){return this._sliceOffset+this.buffer.byteLength}get littleEndian(){return this._littleEndian}get bigTiff(){return this._bigTiff}get buffer(){return this._dataView.buffer}covers(t,e){return this.sliceOffset<=t&&this.sliceTop>=t+e}readUint8(t){return this._dataView.getUint8(t-this._sliceOffset,this._littleEndian)}readInt8(t){return this._dataView.getInt8(t-this._sliceOffset,this._littleEndian)}readUint16(t){return this._dataView.getUint16(t-this._sliceOffset,this._littleEndian)}readInt16(t){return this._dataView.getInt16(t-this._sliceOffset,this._littleEndian)}readUint32(t){return this._dataView.getUint32(t-this._sliceOffset,this._littleEndian)}readInt32(t){return this._dataView.getInt32(t-this._sliceOffset,this._littleEndian)}readFloat32(t){return this._dataView.getFloat32(t-this._sliceOffset,this._littleEndian)}readFloat64(t){return this._dataView.getFloat64(t-this._sliceOffset,this._littleEndian)}readUint64(t){const e=this.readUint32(t),r=this.readUint32(t+4);let n;if(this._littleEndian){if(n=e+2**32*r,!Number.isSafeInteger(n))throw new Error(n+" exceeds MAX_SAFE_INTEGER. Precision may be lost. Please report if you get this message to https://github.com/geotiffjs/geotiff.js/issues");return n}if(n=2**32*e+r,!Number.isSafeInteger(n))throw new Error(n+" exceeds MAX_SAFE_INTEGER. Precision may be lost. Please report if you get this message to https://github.com/geotiffjs/geotiff.js/issues");return n}readInt64(t){let e=0;const r=(128&this._dataView.getUint8(t+(this._littleEndian?7:0)))>0;let n=!0;for(let i=0;i<8;i++){let o=this._dataView.getUint8(t+(this._littleEndian?i:7-i));r&&(n?0!==o&&(o=255&~(o-1),n=!1):o=255&~o),e+=o*256**i}return r&&(e=-e),e}readOffset(t){return this._bigTiff?this.readUint64(t):this.readUint32(t)}}var Y=r(68),Z=r(9),X=r(25),Q=r(40),J=r.n(Q),tt=r(105),et=r.n(tt),rt=r(39),nt=r.n(rt);class it{constructor(t,{blockSize:e=65536}={}){this.retrievalFunction=t,this.blockSize=e,this.blockRequests=new Map,this.blocks=new Map,this.blockIdsAwaitingRequest=null}async fetch(t,e,r=!1){const n=t+e,i=[],o=[],s=[];for(let e=Math.floor(t/this.blockSize)*this.blockSize;e<n;e+=this.blockSize){const t=Math.floor(e/this.blockSize);this.blocks.has(t)||this.blockRequests.has(t)||o.push(t),this.blockRequests.has(t)&&s.push(this.blockRequests.get(t)),i.push(t)}if(this.blockIdsAwaitingRequest)for(let t=0;t<o.length;++t){const e=o[t];this.blockIdsAwaitingRequest.add(e)}else this.blockIdsAwaitingRequest=new Set(o);if(r||await async function(t){return new Promise(e=>setTimeout(e,t))}(),this.blockIdsAwaitingRequest){const t=function(t){if(0===t.length)return[];const e=[];let r=[];e.push(r);for(let n=0;n<t.length;++n)0===n||t[n]===t[n-1]+1?r.push(t[n]):(r=[t[n]],e.push(r));return e}(Array.from(this.blockIdsAwaitingRequest).sort());for(const e of t){const t=this.requestData(e[0]*this.blockSize,e.length*this.blockSize);for(let r=0;r<e.length;++r){const n=e[r];this.blockRequests.set(n,(async()=>{const e=await t,i=r*this.blockSize,o=Math.min(i+this.blockSize,e.data.byteLength),s=e.data.slice(i,o);this.blockRequests.delete(n),this.blocks.set(n,{data:s,offset:e.offset+i,length:s.byteLength,top:e.offset+o})})())}}this.blockIdsAwaitingRequest=null}const a=[];for(const t of o)this.blockRequests.has(t)&&a.push(this.blockRequests.get(t));await Promise.all(a),await Promise.all(s);return function(t,e,r){const n=e+r,i=new ArrayBuffer(r),o=new Uint8Array(i);for(const r of t){const t=r.offset-e,i=r.top-n;let s,a=0,u=0;t<0?a=-t:t>0&&(u=t),s=i<0?r.length-a:n-r.offset-a;const c=new Uint8Array(r.data,a,s);o.set(c,u)}return i}(i.map(t=>this.blocks.get(t)),t,e)}async requestData(t,e){const r=await this.retrievalFunction(t,e);return r.length?r.length!==r.data.byteLength&&(r.data=r.data.slice(0,r.length)):r.length=r.data.byteLength,r.top=r.offset+r.length,r}}function ot(t,e){const{forceXHR:r}=e;if("function"==typeof fetch&&!r)return function(t,{headers:e={},blockSize:r}={}){return new it(async(r,n)=>{const i=await fetch(t,{headers:{...e,Range:`bytes=${r}-${r+n-1}`}});if(i.ok){if(206===i.status){return{data:i.arrayBuffer?await i.arrayBuffer():(await i.buffer()).buffer,offset:r,length:n}}{const t=i.arrayBuffer?await i.arrayBuffer():(await i.buffer()).buffer;return{data:t,offset:0,length:t.byteLength}}}throw new Error("Error fetching data.")},{blockSize:r})}(t,e);if("undefined"!=typeof XMLHttpRequest)return function(t,{headers:e={},blockSize:r}={}){return new it(async(r,n)=>new Promise((i,o)=>{const s=new XMLHttpRequest;s.open("GET",t),s.responseType="arraybuffer";const a={...e,Range:`bytes=${r}-${r+n-1}`};for(const[t,e]of Object.entries(a))s.setRequestHeader(t,e);s.onload=()=>{const t=s.response;206===s.status?i({data:t,offset:r,length:n}):i({data:t,offset:0,length:t.byteLength})},s.onerror=o,s.send()}),{blockSize:r})}(t,e);if(J.a.get)return function(t,{headers:e={},blockSize:r}={}){return new it(async(r,n)=>new Promise((i,o)=>{const s=nt.a.parse(t);("http:"===s.protocol?J.a:et.a).get({...s,headers:{...e,Range:`bytes=${r}-${r+n-1}`}},t=>{const e=[];t.on("data",t=>{e.push(t)}),t.on("end",()=>{const t=Z.Buffer.concat(e).buffer;i({data:t,offset:r,length:t.byteLength})})}).on("error",o)}),{blockSize:r})}(t,e);throw new Error("No remote source available")}function st(t){const e=function(t,e,r){return new Promise((n,i)=>{Object(X.open)(t,e,r,(t,e)=>{t?i(t):n(e)})})}(t,"r");return{async fetch(t,r){const n=await e,{buffer:i}=await function(...t){return new Promise((e,r)=>{Object(X.read)(...t,(t,n,i)=>{t?r(t):e({bytesRead:n,buffer:i})})})}(n,Z.Buffer.alloc(r),0,r,t);return i.buffer},async close(){const t=await e;return await function(t){return new Promise((e,r)=>{Object(X.close)(t,t=>{t?r(t):e()})})}(t)}}}function at(t,e){for(const r in e)e.hasOwnProperty(r)&&(t[r]=e[r])}function ut(t,e){if(t.length<e.length)return!1;return t.substr(t.length-e.length)===e}function ct(t){const e={};for(const r in t)if(t.hasOwnProperty(r)){e[t[r]]=r}return e}function lt(t,e){const r=[];for(let n=0;n<t;n++)r.push(e(n));return r}const ft=ct(a),ht=ct(y),dt={};at(dt,ft),at(dt,ht);const pt=ct(f),yt={nextZero:(t,e)=>{let r=e;for(;0!==t[r];)r++;return r},readUshort:(t,e)=>t[e]<<8|t[e+1],readShort:(t,e)=>{const r=yt.ui8;return r[0]=t[e+1],r[1]=t[e+0],yt.i16[0]},readInt:(t,e)=>{const r=yt.ui8;return r[0]=t[e+3],r[1]=t[e+2],r[2]=t[e+1],r[3]=t[e+0],yt.i32[0]},readUint:(t,e)=>{const r=yt.ui8;return r[0]=t[e+3],r[1]=t[e+2],r[2]=t[e+1],r[3]=t[e+0],yt.ui32[0]},readASCII:(t,e,r)=>r.map(r=>String.fromCharCode(t[e+r])).join(""),readFloat:(t,e)=>{const r=yt.ui8;return lt(4,n=>{r[n]=t[e+3-n]}),yt.fl32[0]},readDouble:(t,e)=>{const r=yt.ui8;return lt(8,n=>{r[n]=t[e+7-n]}),yt.fl64[0]},writeUshort:(t,e,r)=>{t[e]=r>>8&255,t[e+1]=255&r},writeUint:(t,e,r)=>{t[e]=r>>24&255,t[e+1]=r>>16&255,t[e+2]=r>>8&255,t[e+3]=r>>0&255},writeASCII:(t,e,r)=>{lt(r.length,n=>{t[e+n]=r.charCodeAt(n)})},ui8:new Uint8Array(8)};yt.fl64=new Float64Array(yt.ui8.buffer),yt.writeDouble=(t,e,r)=>{yt.fl64[0]=r,lt(8,r=>{t[e+r]=yt.ui8[7-r]})};const gt=t=>{const e=new Uint8Array(1e3);let r=4;const n=yt;e[0]=77,e[1]=77,e[3]=42;let i=8;if(n.writeUint(e,r,i),r+=4,t.forEach((r,o)=>{const s=((t,e,r,n)=>{let i=r;const o=Object.keys(n).filter(t=>null!=t&&"undefined"!==t);t.writeUshort(e,i,o.length),i+=2;let s=i+12*o.length+4;for(const r of o){let o=null;"number"==typeof r?o=r:"string"==typeof r&&(o=parseInt(r,10));const a=c[o],u=pt[a];if(null==a||void 0===a||void 0===a)throw new Error("unknown type of tag: "+o);let l=n[r];if(void 0===l)throw new Error("failed to get value for key "+r);"ASCII"===a&&"string"==typeof l&&!1===ut(l,"\\0")&&(l+="\\0");const f=l.length;t.writeUshort(e,i,o),i+=2,t.writeUshort(e,i,u),i+=2,t.writeUint(e,i,f),i+=4;let h=[-1,1,1,2,4,8,0,0,0,0,0,0,8][u]*f,d=i;h>4&&(t.writeUint(e,i,s),d=s),"ASCII"===a?t.writeASCII(e,d,l):"SHORT"===a?lt(f,r=>{t.writeUshort(e,d+2*r,l[r])}):"LONG"===a?lt(f,r=>{t.writeUint(e,d+4*r,l[r])}):"RATIONAL"===a?lt(f,r=>{t.writeUint(e,d+8*r,Math.round(1e4*l[r])),t.writeUint(e,d+8*r+4,1e4)}):"DOUBLE"===a&&lt(f,r=>{t.writeDouble(e,d+8*r,l[r])}),h>4&&(h+=1&h,s+=h),i+=4}return[i,s]})(n,e,i,r);i=s[1],o<t.length-1&&n.writeUint(e,s[0],i)}),e.slice)return e.slice(0,i).buffer;const o=new Uint8Array(i);for(let t=0;t<i;t++)o[t]=e[t];return o.buffer},mt=[["Compression",1],["PlanarConfiguration",1],["XPosition",0],["YPosition",0],["ResolutionUnit",1],["ExtraSamples",0],["GeoAsciiParams","WGS 84\\0"],["ModelTiepoint",[0,0,0,-180,90,0]],["GTModelTypeGeoKey",2],["GTRasterTypeGeoKey",1],["GeographicTypeGeoKey",4326],["GeogCitationGeoKey","WGS 84"]];function bt(t,e){let r,n,i,o;"number"==typeof t[0]?(r=e.height||e.ImageLength,i=e.width||e.ImageWidth,n=t.length/(r*i),o=t):(n=t.length,r=t[0].length,i=t[0][0].length,o=[],lt(r,e=>{lt(i,r=>{lt(n,n=>{o.push(t[n][e][r])})})})),e.ImageLength=r,delete e.height,e.ImageWidth=i,delete e.width,e.BitsPerSample||(e.BitsPerSample=lt(n,()=>8)),mt.forEach(t=>{const r=t[0];if(!e[r]){const n=t[1];e[r]=n}}),e.PhotometricInterpretation||(e.PhotometricInterpretation=3===e.BitsPerSample.length?2:1),e.SamplesPerPixel||(e.SamplesPerPixel=[n]),e.StripByteCounts||(e.StripByteCounts=[n*r*i]),e.ModelPixelScale||(e.ModelPixelScale=[360/i,180/r,0]),e.SampleFormat||(e.SampleFormat=lt(n,()=>1));const s=Object.keys(e).filter(t=>ut(t,"GeoKey")).sort((t,e)=>dt[t]-dt[e]);if(!e.GeoKeyDirectory){const t=[1,1,0,s.length];s.forEach(r=>{const n=Number(dt[r]);let i,o,s;t.push(n),"SHORT"===c[n]?(i=1,o=0,s=e[r]):"GeogCitationGeoKey"===r?(i=e.GeoAsciiParams.length,o=Number(dt.GeoAsciiParams),s=0):console.log("[geotiff.js] couldn\'t get TIFFTagLocation for "+r),t.push(o),t.push(i),t.push(s)}),e.GeoKeyDirectory=t}for(const t in s)s.hasOwnProperty(t)&&delete e[t];["Compression","ExtraSamples","GeographicTypeGeoKey","GTModelTypeGeoKey","GTRasterTypeGeoKey","ImageLength","ImageWidth","PhotometricInterpretation","PlanarConfiguration","ResolutionUnit","SamplesPerPixel","XPosition","YPosition"].forEach(t=>{var r;e[t]&&(e[t]=(r=e[t],Array.isArray(r)?r:[r]))});const a=(t=>{const e={};for(const r in t)"StripOffsets"!==r&&(dt[r]||console.error(r,"not in name2code:",Object.keys(dt)),e[dt[r]]=t[r]);return e})(e);return((t,e,r,n)=>{if(null==r)throw new Error("you passed into encodeImage a width of type "+r);if(null==e)throw new Error("you passed into encodeImage a width of type "+e);const i={256:[e],257:[r],273:[1e3],278:[r],305:"geotiff.js"};if(n)for(const t in n)n.hasOwnProperty(t)&&(i[t]=n[t]);const o=new Uint8Array(gt([i])),s=new Uint8Array(t),a=i[277],u=new Uint8Array(1e3+e*r*a);return lt(o.length,t=>{u[t]=o[t]}),function(t,e){const{length:r}=t;for(let n=0;n<r;n++)e(t[n],n)}(s,(t,e)=>{u[1e3+e]=t}),u.buffer})(o,i,r,a)}class vt{log(){}info(){}warn(){}error(){}time(){}timeEnd(){}}let wt=new vt;function xt(t=new vt){wt=t}function _t(t){switch(t){case h.BYTE:case h.ASCII:case h.SBYTE:case h.UNDEFINED:return 1;case h.SHORT:case h.SSHORT:return 2;case h.LONG:case h.SLONG:case h.FLOAT:case h.IFD:return 4;case h.RATIONAL:case h.SRATIONAL:case h.DOUBLE:case h.LONG8:case h.SLONG8:case h.IFD8:return 8;default:throw new RangeError("Invalid field type: "+t)}}function St(t,e,r,n){let i=null,o=null;const s=_t(e);switch(e){case h.BYTE:case h.ASCII:case h.UNDEFINED:i=new Uint8Array(r),o=t.readUint8;break;case h.SBYTE:i=new Int8Array(r),o=t.readInt8;break;case h.SHORT:i=new Uint16Array(r),o=t.readUint16;break;case h.SSHORT:i=new Int16Array(r),o=t.readInt16;break;case h.LONG:case h.IFD:i=new Uint32Array(r),o=t.readUint32;break;case h.SLONG:i=new Int32Array(r),o=t.readInt32;break;case h.LONG8:case h.IFD8:i=new Array(r),o=t.readUint64;break;case h.SLONG8:i=new Array(r),o=t.readInt64;break;case h.RATIONAL:i=new Uint32Array(2*r),o=t.readUint32;break;case h.SRATIONAL:i=new Int32Array(2*r),o=t.readInt32;break;case h.FLOAT:i=new Float32Array(r),o=t.readFloat32;break;case h.DOUBLE:i=new Float64Array(r),o=t.readFloat64;break;default:throw new RangeError("Invalid field type: "+e)}if(e!==h.RATIONAL&&e!==h.SRATIONAL)for(let e=0;e<r;++e)i[e]=o.call(t,n+e*s);else for(let e=0;e<r;e+=2)i[e]=o.call(t,n+e*s),i[e+1]=o.call(t,n+(e*s+4));return e===h.ASCII?String.fromCharCode.apply(null,i):i}class At{constructor(t,e,r){this.fileDirectory=t,this.geoKeyDirectory=e,this.nextIFDByteOffset=r}}class Et extends Error{constructor(t){super("No image at index "+t),this.index=t}}class kt{async readRasters(t={}){const{window:e,width:r,height:n}=t;let{resX:i,resY:o,bbox:s}=t;const a=await this.getImage();let u=a;const c=await this.getImageCount(),l=a.getBoundingBox();if(e&&s)throw new Error(\'Both "bbox" and "window" passed.\');if(r||n){if(e){const[t,r]=a.getOrigin(),[n,i]=a.getResolution();s=[t+e[0]*n,r+e[1]*i,t+e[2]*n,r+e[3]*i]}const t=s||l;if(r){if(i)throw new Error("Both width and resX passed");i=(t[2]-t[0])/r}if(n){if(o)throw new Error("Both width and resY passed");o=(t[3]-t[1])/n}}if(i||o){const t=[];for(let e=0;e<c;++e){const r=await this.getImage(e),{SubfileType:n,NewSubfileType:i}=r.fileDirectory;(0===e||2===n||1&i)&&t.push(r)}t.sort((t,e)=>t.getWidth()-e.getWidth());for(let e=0;e<t.length;++e){const r=t[e],n=(l[2]-l[0])/r.getWidth(),s=(l[3]-l[1])/r.getHeight();if(u=r,i&&i>n||o&&o>s)break}}let f=e;if(s){const[t,e]=a.getOrigin(),[r,n]=u.getResolution(a);f=[Math.round((s[0]-t)/r),Math.round((s[1]-e)/n),Math.round((s[2]-t)/r),Math.round((s[3]-e)/n)],f=[Math.min(f[0],f[2]),Math.min(f[1],f[3]),Math.max(f[0],f[2]),Math.max(f[1],f[3])]}return u.readRasters({...t,window:f})}}class Tt extends kt{constructor(t,e,r,n,i={}){super(),this.source=t,this.littleEndian=e,this.bigTiff=r,this.firstIFDOffset=n,this.cache=i.cache||!1,this.ifdRequests=[],this.ghostValues=null}async getSlice(t,e){const r=this.bigTiff?4048:1024;return new $(await this.source.fetch(t,void 0!==e?e:r),t,this.littleEndian,this.bigTiff)}async parseFileDirectoryAt(t){const e=this.bigTiff?20:12,r=this.bigTiff?8:2;let n=await this.getSlice(t);const i=this.bigTiff?n.readUint64(t):n.readUint16(t),o=i*e+(this.bigTiff?16:6);n.covers(t,o)||(n=await this.getSlice(t,o));const s={};let u=t+(this.bigTiff?8:2);for(let t=0;t<i;u+=e,++t){const t=n.readUint16(u),e=n.readUint16(u+2),r=this.bigTiff?n.readUint64(u+4):n.readUint32(u+4);let i,o;const c=_t(e),f=u+(this.bigTiff?12:8);if(c*r<=(this.bigTiff?8:4))i=St(n,e,r,f);else{const t=n.readOffset(f),o=_t(e)*r;if(n.covers(t,o))i=St(n,e,r,t);else{i=St(await this.getSlice(t,o),e,r,t)}}o=1===r&&-1===l.indexOf(t)&&e!==h.RATIONAL&&e!==h.SRATIONAL?i[0]:i,s[a[t]]=o}const c=function(t){const e=t.GeoKeyDirectory;if(!e)return null;const r={};for(let n=4;n<=4*e[3];n+=4){const i=y[e[n]],o=e[n+1]?a[e[n+1]]:null,s=e[n+2],u=e[n+3];let c=null;if(o){if(c=t[o],null==c)throw new Error(`Could not get value of geoKey \'${i}\'.`);"string"==typeof c?c=c.substring(u,u+s-1):c.subarray&&(c=c.subarray(u,u+s),1===s&&(c=c[0]))}else c=u;r[i]=c}return r}(s),f=n.readOffset(t+r+e*i);return new At(s,c,f)}async requestIFD(t){if(this.ifdRequests[t])return this.ifdRequests[t];if(0===t)return this.ifdRequests[t]=this.parseFileDirectoryAt(this.firstIFDOffset),this.ifdRequests[t];if(!this.ifdRequests[t-1])try{this.ifdRequests[t-1]=this.requestIFD(t-1)}catch(e){if(e instanceof Et)throw new Et(t);throw e}return this.ifdRequests[t]=(async()=>{const e=await this.ifdRequests[t-1];if(0===e.nextIFDByteOffset)throw new Et(t);return this.parseFileDirectoryAt(e.nextIFDByteOffset)})(),this.ifdRequests[t]}async getImage(t=0){const e=await this.requestIFD(t);return new V(e.fileDirectory,e.geoKeyDirectory,this.dataView,this.littleEndian,this.cache,this.source)}async getImageCount(){let t=0,e=!0;for(;e;)try{await this.requestIFD(t),++t}catch(t){if(!(t instanceof Et))throw t;e=!1}return t}async getGhostValues(){const t=this.bigTiff?16:8;if(this.ghostValues)return this.ghostValues;const e="GDAL_STRUCTURAL_METADATA_SIZE=",r=e.length+100;let n=await this.getSlice(t,r);if(e===St(n,h.ASCII,e.length,t)){const e=St(n,h.ASCII,r,t).split("\\n")[0],i=Number(e.split("=")[1].split(" ")[0])+e.length;i>r&&(n=await this.getSlice(t,i));const o=St(n,h.ASCII,i,t);this.ghostValues={},o.split("\\n").filter(t=>t.length>0).map(t=>t.split("=")).forEach(([t,e])=>{this.ghostValues[t]=e})}return this.ghostValues}static async fromSource(t,e){const r=await t.fetch(0,1024),n=new K(r),i=n.getUint16(0,0);let o;if(18761===i)o=!0;else{if(19789!==i)throw new TypeError("Invalid byte order value.");o=!1}const s=n.getUint16(2,o);let a;if(42===s)a=!1;else{if(43!==s)throw new TypeError("Invalid magic number.");a=!0;if(8!==n.getUint16(4,o))throw new Error("Unsupported offset byte-size.")}const u=a?n.getUint64(8,o):n.getUint32(4,o);return new Tt(t,o,a,u,e)}close(){return"function"==typeof this.source.close&&this.source.close()}}e.default=Tt;class Ct extends kt{constructor(t,e){super(),this.mainFile=t,this.overviewFiles=e,this.imageFiles=[t].concat(e),this.fileDirectoriesPerFile=null,this.fileDirectoriesPerFileParsing=null,this.imageCount=null}async parseFileDirectoriesPerFile(){const t=[this.mainFile.parseFileDirectoryAt(this.mainFile.firstIFDOffset)].concat(this.overviewFiles.map(t=>t.parseFileDirectoryAt(t.firstIFDOffset)));return this.fileDirectoriesPerFile=await Promise.all(t),this.fileDirectoriesPerFile}async getImage(t=0){await this.getImageCount(),await this.parseFileDirectoriesPerFile();let e=0,r=0;for(let n=0;n<this.imageFiles.length;n++){const i=this.imageFiles[n];for(let o=0;o<this.imageCounts[n];o++){if(t===e){const t=await i.requestIFD(r);return new V(t.fileDirectory,i.geoKeyDirectory,i.dataView,i.littleEndian,i.cache,i.source)}e++,r++}r=0}throw new RangeError("Invalid image index")}async getImageCount(){if(null!==this.imageCount)return this.imageCount;const t=[this.mainFile.getImageCount()].concat(this.overviewFiles.map(t=>t.getImageCount()));return this.imageCounts=await Promise.all(t),this.imageCount=this.imageCounts.reduce((t,e)=>t+e,0),this.imageCount}}async function Ot(t,e={}){return Tt.fromSource(ot(t,e))}async function It(t){return Tt.fromSource(function(t){return{fetch:async(e,r)=>t.slice(e,e+r)}}(t))}async function Pt(t){return Tt.fromSource(st(t))}async function Rt(t){return Tt.fromSource((e=t,{fetch:async(t,r)=>new Promise((n,i)=>{const o=e.slice(t,t+r),s=new FileReader;s.onload=t=>n(t.target.result),s.onerror=i,s.readAsArrayBuffer(o)})}));var e}async function jt(t,e=[],r={}){const n=await Tt.fromSource(ot(t,r)),i=await Promise.all(e.map(t=>Tt.fromSource(ot(t,r))));return new Ct(n,i)}async function Mt(t,e){return bt(t,e)}},function(t,e,r){"use strict";r.d(e,"a",(function(){return i}));var n=r(19);Object(n.b)().blob;const i=Object(n.b)().default},,,function(t,e,r){"use strict";var n=r(26),i=r(102);var o=function(t){"function"==typeof t?t():t&&"function"==typeof t.unsubscribe&&t.unsubscribe()};e.a=function(t){const e=new i.a;let r,s=0;return new n.a(n=>{r||(r=t.subscribe(e));const i=e.subscribe(n);return s++,()=>{s--,i.unsubscribe(),0===s&&(o(r),r=void 0)}})}}]);', null);
                    };
                },
                function(t, e, r) {
                    "use strict";
                    var n = window.URL || window.webkitURL;
                    t.exports = function(t, e) {
                        try {
                            try {
                                var r;
                                try {
                                    (r = new (window.BlobBuilder || window.WebKitBlobBuilder || window.MozBlobBuilder || window.MSBlobBuilder)).append(t), r = r.getBlob();
                                } catch (e) {
                                    r = new Blob([
                                        t
                                    ]);
                                }
                                return new Worker(n.createObjectURL(r));
                            } catch (e) {
                                return new Worker("data:application/javascript," + encodeURIComponent(t));
                            }
                        } catch (t) {
                            if (!e) throw Error("Inline worker is not supported");
                            return new Worker(e);
                        }
                    };
                },
                function(t, e, r) {
                    "use strict";
                    Object.defineProperty(e, "__esModule", {
                        value: !0
                    });
                    var n = function(t, e) {
                        if (Array.isArray(t)) return t;
                        if (Symbol.iterator in Object(t)) return function(t, e) {
                            var r = [], n = !0, i = !1, o = void 0;
                            try {
                                for(var a, s = t[Symbol.iterator](); !(n = (a = s.next()).done) && (r.push(a.value), !e || r.length !== e); n = !0);
                            } catch (t) {
                                i = !0, o = t;
                            } finally{
                                try {
                                    !n && s.return && s.return();
                                } finally{
                                    if (i) throw o;
                                }
                            }
                            return r;
                        }(t, e);
                        throw new TypeError("Invalid attempt to destructure non-iterable instance");
                    }, i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                        return typeof t;
                    } : function(t) {
                        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                    };
                    e.default = function(t, e) {
                        return new Promise(function(r, o) {
                            try {
                                e && console.log("starting parseData with", t), e && console.log("	GeoTIFF:", "undefined" == typeof GeoTIFF ? "undefined" : i(GeoTIFF));
                                var u = {}, f = void 0, h = void 0;
                                if ("object" === t.rasterType) u.values = t.data, u.height = f = t.metadata.height || u.values[0].length, u.width = h = t.metadata.width || u.values[0][0].length, u.pixelHeight = t.metadata.pixelHeight, u.pixelWidth = t.metadata.pixelWidth, u.projection = t.metadata.projection, u.xmin = t.metadata.xmin, u.ymax = t.metadata.ymax, u.noDataValue = t.metadata.noDataValue, u.numberOfRasters = u.values.length, u.xmax = u.xmin + u.width * u.pixelWidth, u.ymin = u.ymax - u.height * u.pixelHeight, u._data = null, r(c(u));
                                else if ("geotiff" === t.rasterType) {
                                    u._data = t.data;
                                    var p = a.fromArrayBuffer;
                                    "url" === t.sourceType ? p = a.fromUrl : "Blob" === t.sourceType && (p = a.fromBlob), e && console.log("data.rasterType is geotiff"), r(p(t.data).then(function(r) {
                                        return e && console.log("geotiff:", r), r.getImage().then(function(r) {
                                            try {
                                                e && console.log("image:", r);
                                                var i = r.fileDirectory, a = r.getGeoKeys() || {}, p = a.GeographicTypeGeoKey, d = a.ProjectedCSTypeGeoKey;
                                                u.projection = d || p || t.metadata.projection, e && console.log("projection:", u.projection), u.height = f = r.getHeight(), e && console.log("result.height:", u.height), u.width = h = r.getWidth(), e && console.log("result.width:", u.width);
                                                var m = r.getResolution(), y = n(m, 2), g = y[0], v = y[1];
                                                u.pixelHeight = Math.abs(v), u.pixelWidth = Math.abs(g);
                                                var b = r.getOrigin(), x = n(b, 2), w = x[0], _ = x[1];
                                                return u.xmin = w, u.xmax = u.xmin + h * u.pixelWidth, u.ymax = _, u.ymin = u.ymax - f * u.pixelHeight, u.noDataValue = i.GDAL_NODATA ? parseFloat(i.GDAL_NODATA) : null, u.numberOfRasters = i.SamplesPerPixel, i.ColorMap && (u.palette = (0, s.getPalette)(r)), "url" !== t.sourceType ? r.readRasters().then(function(t) {
                                                    return u.values = t.map(function(t) {
                                                        return (0, l.unflatten)(t, {
                                                            height: f,
                                                            width: h
                                                        });
                                                    }), c(u);
                                                }) : u;
                                            } catch (t) {
                                                o(t), console.error("[georaster] error parsing georaster:", t);
                                            }
                                        });
                                    }));
                                }
                            } catch (t) {
                                o(t), console.error("[georaster] error parsing georaster:", t);
                            }
                        });
                    };
                    var o, a = r(100), s = r(155), u = (o = r(156)) && o.__esModule ? o : {
                        default: o
                    }, l = r(99);
                    function c(t) {
                        var e = (0, u.default)(t.values, {
                            height: t.height,
                            layout: "[band][row][column]",
                            noData: t.noDataValue,
                            precise: !1,
                            stats: [
                                "max",
                                "min",
                                "range"
                            ],
                            width: t.width
                        });
                        return t.maxs = e.bands.map(function(t) {
                            return t.max;
                        }), t.mins = e.bands.map(function(t) {
                            return t.min;
                        }), t.ranges = e.bands.map(function(t) {
                            return t.range;
                        }), t;
                    }
                },
                function(t, e, r) {
                    (function(e) {
                        var n = r(42).Transform, i = r(10);
                        function o(t) {
                            n.call(this, t), this._destroyed = !1;
                        }
                        function a(t, e, r) {
                            r(null, t);
                        }
                        function s(t) {
                            return function(e, r, n) {
                                return "function" == typeof e && (n = r, r = e, e = {}), "function" != typeof r && (r = a), "function" != typeof n && (n = null), t(e, r, n);
                            };
                        }
                        i(o, n), o.prototype.destroy = function(t) {
                            if (!this._destroyed) {
                                this._destroyed = !0;
                                var r = this;
                                e.nextTick(function() {
                                    t && r.emit("error", t), r.emit("close");
                                });
                            }
                        }, t.exports = s(function(t, e, r) {
                            var n = new o(t);
                            return n._transform = e, r && (n._flush = r), n;
                        }), t.exports.ctor = s(function(t, e, r) {
                            function n(e) {
                                if (!(this instanceof n)) return new n(e);
                                this.options = Object.assign({}, t, e), o.call(this, this.options);
                            }
                            return i(n, o), n.prototype._transform = e, r && (n.prototype._flush = r), n;
                        }), t.exports.obj = s(function(t, e, r) {
                            var n = new o(Object.assign({
                                objectMode: !0,
                                highWaterMark: 16
                            }, t));
                            return n._transform = e, r && (n._flush = r), n;
                        });
                    }).call(this, r(8));
                },
                function(t, e) {},
                function(t, e, r) {
                    "use strict";
                    var n = r(43).Buffer, i = r(117);
                    t.exports = function() {
                        function t() {
                            !function(t, e) {
                                if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                            }(this, t), this.head = null, this.tail = null, this.length = 0;
                        }
                        return t.prototype.push = function(t) {
                            var e = {
                                data: t,
                                next: null
                            };
                            this.length > 0 ? this.tail.next = e : this.head = e, this.tail = e, ++this.length;
                        }, t.prototype.unshift = function(t) {
                            var e = {
                                data: t,
                                next: this.head
                            };
                            0 === this.length && (this.tail = e), this.head = e, ++this.length;
                        }, t.prototype.shift = function() {
                            if (0 !== this.length) {
                                var t = this.head.data;
                                return 1 === this.length ? this.head = this.tail = null : this.head = this.head.next, --this.length, t;
                            }
                        }, t.prototype.clear = function() {
                            this.head = this.tail = null, this.length = 0;
                        }, t.prototype.join = function(t) {
                            if (0 === this.length) return "";
                            for(var e = this.head, r = "" + e.data; e = e.next;)r += t + e.data;
                            return r;
                        }, t.prototype.concat = function(t) {
                            if (0 === this.length) return n.alloc(0);
                            for(var e, r, i = n.allocUnsafe(t >>> 0), o = this.head, a = 0; o;)e = i, r = a, o.data.copy(e, r), a += o.data.length, o = o.next;
                            return i;
                        }, t;
                    }(), i && i.inspect && i.inspect.custom && (t.exports.prototype[i.inspect.custom] = function() {
                        var t = i.inspect({
                            length: this.length
                        });
                        return this.constructor.name + " " + t;
                    });
                },
                function(t, e) {},
                function(t, e, r) {
                    (function(t) {
                        var n = void 0 !== t && t || "undefined" != typeof self && self || window, i = Function.prototype.apply;
                        function o(t, e) {
                            this._id = t, this._clearFn = e;
                        }
                        e.setTimeout = function() {
                            return new o(i.call(setTimeout, n, arguments), clearTimeout);
                        }, e.setInterval = function() {
                            return new o(i.call(setInterval, n, arguments), clearInterval);
                        }, e.clearTimeout = e.clearInterval = function(t) {
                            t && t.close();
                        }, o.prototype.unref = o.prototype.ref = function() {}, o.prototype.close = function() {
                            this._clearFn.call(n, this._id);
                        }, e.enroll = function(t, e) {
                            clearTimeout(t._idleTimeoutId), t._idleTimeout = e;
                        }, e.unenroll = function(t) {
                            clearTimeout(t._idleTimeoutId), t._idleTimeout = -1;
                        }, e._unrefActive = e.active = function(t) {
                            clearTimeout(t._idleTimeoutId);
                            var e = t._idleTimeout;
                            e >= 0 && (t._idleTimeoutId = setTimeout(function() {
                                t._onTimeout && t._onTimeout();
                            }, e));
                        }, r(119), e.setImmediate = "undefined" != typeof self && self.setImmediate || void 0 !== t && t.setImmediate || this && this.setImmediate, e.clearImmediate = "undefined" != typeof self && self.clearImmediate || void 0 !== t && t.clearImmediate || this && this.clearImmediate;
                    }).call(this, r(3));
                },
                function(t, e, r) {
                    (function(t, e) {
                        !function(t, r) {
                            "use strict";
                            if (!t.setImmediate) {
                                var n, i, o, a, s, u = 1, l = {}, c = !1, f = t.document, h = Object.getPrototypeOf && Object.getPrototypeOf(t);
                                h = h && h.setTimeout ? h : t, "[object process]" === ({}).toString.call(t.process) ? n = function(t) {
                                    e.nextTick(function() {
                                        d(t);
                                    });
                                } : function() {
                                    if (t.postMessage && !t.importScripts) {
                                        var e = !0, r = t.onmessage;
                                        return t.onmessage = function() {
                                            e = !1;
                                        }, t.postMessage("", "*"), t.onmessage = r, e;
                                    }
                                }() ? (a = "setImmediate$" + Math.random() + "$", s = function(e) {
                                    e.source === t && "string" == typeof e.data && 0 === e.data.indexOf(a) && d(+e.data.slice(a.length));
                                }, t.addEventListener ? t.addEventListener("message", s, !1) : t.attachEvent("onmessage", s), n = function(e) {
                                    t.postMessage(a + e, "*");
                                }) : t.MessageChannel ? ((o = new MessageChannel).port1.onmessage = function(t) {
                                    d(t.data);
                                }, n = function(t) {
                                    o.port2.postMessage(t);
                                }) : f && "onreadystatechange" in f.createElement("script") ? (i = f.documentElement, n = function(t) {
                                    var e = f.createElement("script");
                                    e.onreadystatechange = function() {
                                        d(t), e.onreadystatechange = null, i.removeChild(e), e = null;
                                    }, i.appendChild(e);
                                }) : n = function(t) {
                                    setTimeout(d, 0, t);
                                }, h.setImmediate = function(t) {
                                    "function" != typeof t && (t = new Function("" + t));
                                    for(var e = new Array(arguments.length - 1), r = 0; r < e.length; r++)e[r] = arguments[r + 1];
                                    var i = {
                                        callback: t,
                                        args: e
                                    };
                                    return l[u] = i, n(u), u++;
                                }, h.clearImmediate = p;
                            }
                            function p(t) {
                                delete l[t];
                            }
                            function d(t) {
                                if (c) setTimeout(d, 0, t);
                                else {
                                    var e = l[t];
                                    if (e) {
                                        c = !0;
                                        try {
                                            !function(t) {
                                                var e = t.callback, r = t.args;
                                                switch(r.length){
                                                    case 0:
                                                        e();
                                                        break;
                                                    case 1:
                                                        e(r[0]);
                                                        break;
                                                    case 2:
                                                        e(r[0], r[1]);
                                                        break;
                                                    case 3:
                                                        e(r[0], r[1], r[2]);
                                                        break;
                                                    default:
                                                        e.apply(void 0, r);
                                                }
                                            }(e);
                                        } finally{
                                            p(t), c = !1;
                                        }
                                    }
                                }
                            }
                        }("undefined" == typeof self ? void 0 === t ? this : t : self);
                    }).call(this, r(3), r(8));
                },
                function(t, e, r) {
                    (function(e) {
                        function r(t) {
                            try {
                                if (!e.localStorage) return !1;
                            } catch (t) {
                                return !1;
                            }
                            var r = e.localStorage[t];
                            return null != r && "true" === String(r).toLowerCase();
                        }
                        t.exports = function(t, e) {
                            if (r("noDeprecation")) return t;
                            var n = !1;
                            return function() {
                                if (!n) {
                                    if (r("throwDeprecation")) throw new Error(e);
                                    r("traceDeprecation") ? console.trace(e) : console.warn(e), n = !0;
                                }
                                return t.apply(this, arguments);
                            };
                        };
                    }).call(this, r(3));
                },
                function(t, e, r) {
                    var n = r(7), i = n.Buffer;
                    function o(t, e) {
                        for(var r in t)e[r] = t[r];
                    }
                    function a(t, e, r) {
                        return i(t, e, r);
                    }
                    i.from && i.alloc && i.allocUnsafe && i.allocUnsafeSlow ? t.exports = n : (o(n, e), e.Buffer = a), o(i, a), a.from = function(t, e, r) {
                        if ("number" == typeof t) throw new TypeError("Argument must not be a number");
                        return i(t, e, r);
                    }, a.alloc = function(t, e, r) {
                        if ("number" != typeof t) throw new TypeError("Argument must be a number");
                        var n = i(t);
                        return void 0 !== e ? "string" == typeof r ? n.fill(e, r) : n.fill(e) : n.fill(0), n;
                    }, a.allocUnsafe = function(t) {
                        if ("number" != typeof t) throw new TypeError("Argument must be a number");
                        return i(t);
                    }, a.allocUnsafeSlow = function(t) {
                        if ("number" != typeof t) throw new TypeError("Argument must be a number");
                        return n.SlowBuffer(t);
                    };
                },
                function(t, e, r) {
                    "use strict";
                    t.exports = o;
                    var n = r(67), i = Object.create(r(21));
                    function o(t) {
                        if (!(this instanceof o)) return new o(t);
                        n.call(this, t);
                    }
                    i.inherits = r(10), i.inherits(o, n), o.prototype._transform = function(t, e, r) {
                        r(null, t);
                    };
                },
                function(t, e, r) {
                    "use strict";
                    var n = r(29), i = r(124), o = r(125), a = r(126), s = r(127);
                    function u(t) {
                        return (t >>> 24 & 255) + (t >>> 8 & 65280) + ((65280 & t) << 8) + ((255 & t) << 24);
                    }
                    function l() {
                        this.mode = 0, this.last = !1, this.wrap = 0, this.havedict = !1, this.flags = 0, this.dmax = 0, this.check = 0, this.total = 0, this.head = null, this.wbits = 0, this.wsize = 0, this.whave = 0, this.wnext = 0, this.window = null, this.hold = 0, this.bits = 0, this.length = 0, this.offset = 0, this.extra = 0, this.lencode = null, this.distcode = null, this.lenbits = 0, this.distbits = 0, this.ncode = 0, this.nlen = 0, this.ndist = 0, this.have = 0, this.next = null, this.lens = new n.Buf16(320), this.work = new n.Buf16(288), this.lendyn = null, this.distdyn = null, this.sane = 0, this.back = 0, this.was = 0;
                    }
                    function c(t) {
                        var e;
                        return t && t.state ? (e = t.state, t.total_in = t.total_out = e.total = 0, t.msg = "", e.wrap && (t.adler = 1 & e.wrap), e.mode = 1, e.last = 0, e.havedict = 0, e.dmax = 32768, e.head = null, e.hold = 0, e.bits = 0, e.lencode = e.lendyn = new n.Buf32(852), e.distcode = e.distdyn = new n.Buf32(592), e.sane = 1, e.back = -1, 0) : -2;
                    }
                    function f(t) {
                        var e;
                        return t && t.state ? ((e = t.state).wsize = 0, e.whave = 0, e.wnext = 0, c(t)) : -2;
                    }
                    function h(t, e) {
                        var r, n;
                        return t && t.state ? (n = t.state, e < 0 ? (r = 0, e = -e) : (r = 1 + (e >> 4), e < 48 && (e &= 15)), e && (e < 8 || e > 15) ? -2 : (null !== n.window && n.wbits !== e && (n.window = null), n.wrap = r, n.wbits = e, f(t))) : -2;
                    }
                    function p(t, e) {
                        var r, n;
                        return t ? (n = new l, t.state = n, n.window = null, 0 !== (r = h(t, e)) && (t.state = null), r) : -2;
                    }
                    var d, m, y = !0;
                    function g(t) {
                        if (y) {
                            var e;
                            for(d = new n.Buf32(512), m = new n.Buf32(32), e = 0; e < 144;)t.lens[e++] = 8;
                            for(; e < 256;)t.lens[e++] = 9;
                            for(; e < 280;)t.lens[e++] = 7;
                            for(; e < 288;)t.lens[e++] = 8;
                            for(s(1, t.lens, 0, 288, d, 0, t.work, {
                                bits: 9
                            }), e = 0; e < 32;)t.lens[e++] = 5;
                            s(2, t.lens, 0, 32, m, 0, t.work, {
                                bits: 5
                            }), y = !1;
                        }
                        t.lencode = d, t.lenbits = 9, t.distcode = m, t.distbits = 5;
                    }
                    function v(t, e, r, i) {
                        var o, a = t.state;
                        return null === a.window && (a.wsize = 1 << a.wbits, a.wnext = 0, a.whave = 0, a.window = new n.Buf8(a.wsize)), i >= a.wsize ? (n.arraySet(a.window, e, r - a.wsize, a.wsize, 0), a.wnext = 0, a.whave = a.wsize) : ((o = a.wsize - a.wnext) > i && (o = i), n.arraySet(a.window, e, r - i, o, a.wnext), (i -= o) ? (n.arraySet(a.window, e, r - i, i, 0), a.wnext = i, a.whave = a.wsize) : (a.wnext += o, a.wnext === a.wsize && (a.wnext = 0), a.whave < a.wsize && (a.whave += o))), 0;
                    }
                    e.inflateReset = f, e.inflateReset2 = h, e.inflateResetKeep = c, e.inflateInit = function(t) {
                        return p(t, 15);
                    }, e.inflateInit2 = p, e.inflate = function(t, e) {
                        var r, l, c, f, h, p, d, m, y, b, x, w, _, A, E, S, M, k, N, C, D, O, T, F, P = 0, I = new n.Buf8(4), B = [
                            16,
                            17,
                            18,
                            0,
                            8,
                            7,
                            9,
                            6,
                            10,
                            5,
                            11,
                            4,
                            12,
                            3,
                            13,
                            2,
                            14,
                            1,
                            15
                        ];
                        if (!t || !t.state || !t.output || !t.input && 0 !== t.avail_in) return -2;
                        12 === (r = t.state).mode && (r.mode = 13), h = t.next_out, c = t.output, d = t.avail_out, f = t.next_in, l = t.input, p = t.avail_in, m = r.hold, y = r.bits, b = p, x = d, O = 0;
                        t: for(;;)switch(r.mode){
                            case 1:
                                if (0 === r.wrap) {
                                    r.mode = 13;
                                    break;
                                }
                                for(; y < 16;){
                                    if (0 === p) break t;
                                    p--, m += l[f++] << y, y += 8;
                                }
                                if (2 & r.wrap && 35615 === m) {
                                    r.check = 0, I[0] = 255 & m, I[1] = m >>> 8 & 255, r.check = o(r.check, I, 2, 0), m = 0, y = 0, r.mode = 2;
                                    break;
                                }
                                if (r.flags = 0, r.head && (r.head.done = !1), !(1 & r.wrap) || (((255 & m) << 8) + (m >> 8)) % 31) {
                                    t.msg = "incorrect header check", r.mode = 30;
                                    break;
                                }
                                if (8 != (15 & m)) {
                                    t.msg = "unknown compression method", r.mode = 30;
                                    break;
                                }
                                if (y -= 4, D = 8 + (15 & (m >>>= 4)), 0 === r.wbits) r.wbits = D;
                                else if (D > r.wbits) {
                                    t.msg = "invalid window size", r.mode = 30;
                                    break;
                                }
                                r.dmax = 1 << D, t.adler = r.check = 1, r.mode = 512 & m ? 10 : 12, m = 0, y = 0;
                                break;
                            case 2:
                                for(; y < 16;){
                                    if (0 === p) break t;
                                    p--, m += l[f++] << y, y += 8;
                                }
                                if (r.flags = m, 8 != (255 & r.flags)) {
                                    t.msg = "unknown compression method", r.mode = 30;
                                    break;
                                }
                                if (57344 & r.flags) {
                                    t.msg = "unknown header flags set", r.mode = 30;
                                    break;
                                }
                                r.head && (r.head.text = m >> 8 & 1), 512 & r.flags && (I[0] = 255 & m, I[1] = m >>> 8 & 255, r.check = o(r.check, I, 2, 0)), m = 0, y = 0, r.mode = 3;
                            case 3:
                                for(; y < 32;){
                                    if (0 === p) break t;
                                    p--, m += l[f++] << y, y += 8;
                                }
                                r.head && (r.head.time = m), 512 & r.flags && (I[0] = 255 & m, I[1] = m >>> 8 & 255, I[2] = m >>> 16 & 255, I[3] = m >>> 24 & 255, r.check = o(r.check, I, 4, 0)), m = 0, y = 0, r.mode = 4;
                            case 4:
                                for(; y < 16;){
                                    if (0 === p) break t;
                                    p--, m += l[f++] << y, y += 8;
                                }
                                r.head && (r.head.xflags = 255 & m, r.head.os = m >> 8), 512 & r.flags && (I[0] = 255 & m, I[1] = m >>> 8 & 255, r.check = o(r.check, I, 2, 0)), m = 0, y = 0, r.mode = 5;
                            case 5:
                                if (1024 & r.flags) {
                                    for(; y < 16;){
                                        if (0 === p) break t;
                                        p--, m += l[f++] << y, y += 8;
                                    }
                                    r.length = m, r.head && (r.head.extra_len = m), 512 & r.flags && (I[0] = 255 & m, I[1] = m >>> 8 & 255, r.check = o(r.check, I, 2, 0)), m = 0, y = 0;
                                } else r.head && (r.head.extra = null);
                                r.mode = 6;
                            case 6:
                                if (1024 & r.flags && ((w = r.length) > p && (w = p), w && (r.head && (D = r.head.extra_len - r.length, r.head.extra || (r.head.extra = new Array(r.head.extra_len)), n.arraySet(r.head.extra, l, f, w, D)), 512 & r.flags && (r.check = o(r.check, l, w, f)), p -= w, f += w, r.length -= w), r.length)) break t;
                                r.length = 0, r.mode = 7;
                            case 7:
                                if (2048 & r.flags) {
                                    if (0 === p) break t;
                                    w = 0;
                                    do D = l[f + w++], r.head && D && r.length < 65536 && (r.head.name += String.fromCharCode(D));
                                    while (D && w < p);
                                    if (512 & r.flags && (r.check = o(r.check, l, w, f)), p -= w, f += w, D) break t;
                                } else r.head && (r.head.name = null);
                                r.length = 0, r.mode = 8;
                            case 8:
                                if (4096 & r.flags) {
                                    if (0 === p) break t;
                                    w = 0;
                                    do D = l[f + w++], r.head && D && r.length < 65536 && (r.head.comment += String.fromCharCode(D));
                                    while (D && w < p);
                                    if (512 & r.flags && (r.check = o(r.check, l, w, f)), p -= w, f += w, D) break t;
                                } else r.head && (r.head.comment = null);
                                r.mode = 9;
                            case 9:
                                if (512 & r.flags) {
                                    for(; y < 16;){
                                        if (0 === p) break t;
                                        p--, m += l[f++] << y, y += 8;
                                    }
                                    if (m !== (65535 & r.check)) {
                                        t.msg = "header crc mismatch", r.mode = 30;
                                        break;
                                    }
                                    m = 0, y = 0;
                                }
                                r.head && (r.head.hcrc = r.flags >> 9 & 1, r.head.done = !0), t.adler = r.check = 0, r.mode = 12;
                                break;
                            case 10:
                                for(; y < 32;){
                                    if (0 === p) break t;
                                    p--, m += l[f++] << y, y += 8;
                                }
                                t.adler = r.check = u(m), m = 0, y = 0, r.mode = 11;
                            case 11:
                                if (0 === r.havedict) return t.next_out = h, t.avail_out = d, t.next_in = f, t.avail_in = p, r.hold = m, r.bits = y, 2;
                                t.adler = r.check = 1, r.mode = 12;
                            case 12:
                                if (5 === e || 6 === e) break t;
                            case 13:
                                if (r.last) {
                                    m >>>= 7 & y, y -= 7 & y, r.mode = 27;
                                    break;
                                }
                                for(; y < 3;){
                                    if (0 === p) break t;
                                    p--, m += l[f++] << y, y += 8;
                                }
                                switch(r.last = 1 & m, y -= 1, 3 & (m >>>= 1)){
                                    case 0:
                                        r.mode = 14;
                                        break;
                                    case 1:
                                        if (g(r), r.mode = 20, 6 === e) {
                                            m >>>= 2, y -= 2;
                                            break t;
                                        }
                                        break;
                                    case 2:
                                        r.mode = 17;
                                        break;
                                    case 3:
                                        t.msg = "invalid block type", r.mode = 30;
                                }
                                m >>>= 2, y -= 2;
                                break;
                            case 14:
                                for(m >>>= 7 & y, y -= 7 & y; y < 32;){
                                    if (0 === p) break t;
                                    p--, m += l[f++] << y, y += 8;
                                }
                                if ((65535 & m) != (m >>> 16 ^ 65535)) {
                                    t.msg = "invalid stored block lengths", r.mode = 30;
                                    break;
                                }
                                if (r.length = 65535 & m, m = 0, y = 0, r.mode = 15, 6 === e) break t;
                            case 15:
                                r.mode = 16;
                            case 16:
                                if (w = r.length) {
                                    if (w > p && (w = p), w > d && (w = d), 0 === w) break t;
                                    n.arraySet(c, l, f, w, h), p -= w, f += w, d -= w, h += w, r.length -= w;
                                    break;
                                }
                                r.mode = 12;
                                break;
                            case 17:
                                for(; y < 14;){
                                    if (0 === p) break t;
                                    p--, m += l[f++] << y, y += 8;
                                }
                                if (r.nlen = 257 + (31 & m), m >>>= 5, y -= 5, r.ndist = 1 + (31 & m), m >>>= 5, y -= 5, r.ncode = 4 + (15 & m), m >>>= 4, y -= 4, r.nlen > 286 || r.ndist > 30) {
                                    t.msg = "too many length or distance symbols", r.mode = 30;
                                    break;
                                }
                                r.have = 0, r.mode = 18;
                            case 18:
                                for(; r.have < r.ncode;){
                                    for(; y < 3;){
                                        if (0 === p) break t;
                                        p--, m += l[f++] << y, y += 8;
                                    }
                                    r.lens[B[r.have++]] = 7 & m, m >>>= 3, y -= 3;
                                }
                                for(; r.have < 19;)r.lens[B[r.have++]] = 0;
                                if (r.lencode = r.lendyn, r.lenbits = 7, T = {
                                    bits: r.lenbits
                                }, O = s(0, r.lens, 0, 19, r.lencode, 0, r.work, T), r.lenbits = T.bits, O) {
                                    t.msg = "invalid code lengths set", r.mode = 30;
                                    break;
                                }
                                r.have = 0, r.mode = 19;
                            case 19:
                                for(; r.have < r.nlen + r.ndist;){
                                    for(; S = (P = r.lencode[m & (1 << r.lenbits) - 1]) >>> 16 & 255, M = 65535 & P, !((E = P >>> 24) <= y);){
                                        if (0 === p) break t;
                                        p--, m += l[f++] << y, y += 8;
                                    }
                                    if (M < 16) m >>>= E, y -= E, r.lens[r.have++] = M;
                                    else {
                                        if (16 === M) {
                                            for(F = E + 2; y < F;){
                                                if (0 === p) break t;
                                                p--, m += l[f++] << y, y += 8;
                                            }
                                            if (m >>>= E, y -= E, 0 === r.have) {
                                                t.msg = "invalid bit length repeat", r.mode = 30;
                                                break;
                                            }
                                            D = r.lens[r.have - 1], w = 3 + (3 & m), m >>>= 2, y -= 2;
                                        } else if (17 === M) {
                                            for(F = E + 3; y < F;){
                                                if (0 === p) break t;
                                                p--, m += l[f++] << y, y += 8;
                                            }
                                            y -= E, D = 0, w = 3 + (7 & (m >>>= E)), m >>>= 3, y -= 3;
                                        } else {
                                            for(F = E + 7; y < F;){
                                                if (0 === p) break t;
                                                p--, m += l[f++] << y, y += 8;
                                            }
                                            y -= E, D = 0, w = 11 + (127 & (m >>>= E)), m >>>= 7, y -= 7;
                                        }
                                        if (r.have + w > r.nlen + r.ndist) {
                                            t.msg = "invalid bit length repeat", r.mode = 30;
                                            break;
                                        }
                                        for(; w--;)r.lens[r.have++] = D;
                                    }
                                }
                                if (30 === r.mode) break;
                                if (0 === r.lens[256]) {
                                    t.msg = "invalid code -- missing end-of-block", r.mode = 30;
                                    break;
                                }
                                if (r.lenbits = 9, T = {
                                    bits: r.lenbits
                                }, O = s(1, r.lens, 0, r.nlen, r.lencode, 0, r.work, T), r.lenbits = T.bits, O) {
                                    t.msg = "invalid literal/lengths set", r.mode = 30;
                                    break;
                                }
                                if (r.distbits = 6, r.distcode = r.distdyn, T = {
                                    bits: r.distbits
                                }, O = s(2, r.lens, r.nlen, r.ndist, r.distcode, 0, r.work, T), r.distbits = T.bits, O) {
                                    t.msg = "invalid distances set", r.mode = 30;
                                    break;
                                }
                                if (r.mode = 20, 6 === e) break t;
                            case 20:
                                r.mode = 21;
                            case 21:
                                if (p >= 6 && d >= 258) {
                                    t.next_out = h, t.avail_out = d, t.next_in = f, t.avail_in = p, r.hold = m, r.bits = y, a(t, x), h = t.next_out, c = t.output, d = t.avail_out, f = t.next_in, l = t.input, p = t.avail_in, m = r.hold, y = r.bits, 12 === r.mode && (r.back = -1);
                                    break;
                                }
                                for(r.back = 0; S = (P = r.lencode[m & (1 << r.lenbits) - 1]) >>> 16 & 255, M = 65535 & P, !((E = P >>> 24) <= y);){
                                    if (0 === p) break t;
                                    p--, m += l[f++] << y, y += 8;
                                }
                                if (S && 0 == (240 & S)) {
                                    for(k = E, N = S, C = M; S = (P = r.lencode[C + ((m & (1 << k + N) - 1) >> k)]) >>> 16 & 255, M = 65535 & P, !(k + (E = P >>> 24) <= y);){
                                        if (0 === p) break t;
                                        p--, m += l[f++] << y, y += 8;
                                    }
                                    m >>>= k, y -= k, r.back += k;
                                }
                                if (m >>>= E, y -= E, r.back += E, r.length = M, 0 === S) {
                                    r.mode = 26;
                                    break;
                                }
                                if (32 & S) {
                                    r.back = -1, r.mode = 12;
                                    break;
                                }
                                if (64 & S) {
                                    t.msg = "invalid literal/length code", r.mode = 30;
                                    break;
                                }
                                r.extra = 15 & S, r.mode = 22;
                            case 22:
                                if (r.extra) {
                                    for(F = r.extra; y < F;){
                                        if (0 === p) break t;
                                        p--, m += l[f++] << y, y += 8;
                                    }
                                    r.length += m & (1 << r.extra) - 1, m >>>= r.extra, y -= r.extra, r.back += r.extra;
                                }
                                r.was = r.length, r.mode = 23;
                            case 23:
                                for(; S = (P = r.distcode[m & (1 << r.distbits) - 1]) >>> 16 & 255, M = 65535 & P, !((E = P >>> 24) <= y);){
                                    if (0 === p) break t;
                                    p--, m += l[f++] << y, y += 8;
                                }
                                if (0 == (240 & S)) {
                                    for(k = E, N = S, C = M; S = (P = r.distcode[C + ((m & (1 << k + N) - 1) >> k)]) >>> 16 & 255, M = 65535 & P, !(k + (E = P >>> 24) <= y);){
                                        if (0 === p) break t;
                                        p--, m += l[f++] << y, y += 8;
                                    }
                                    m >>>= k, y -= k, r.back += k;
                                }
                                if (m >>>= E, y -= E, r.back += E, 64 & S) {
                                    t.msg = "invalid distance code", r.mode = 30;
                                    break;
                                }
                                r.offset = M, r.extra = 15 & S, r.mode = 24;
                            case 24:
                                if (r.extra) {
                                    for(F = r.extra; y < F;){
                                        if (0 === p) break t;
                                        p--, m += l[f++] << y, y += 8;
                                    }
                                    r.offset += m & (1 << r.extra) - 1, m >>>= r.extra, y -= r.extra, r.back += r.extra;
                                }
                                if (r.offset > r.dmax) {
                                    t.msg = "invalid distance too far back", r.mode = 30;
                                    break;
                                }
                                r.mode = 25;
                            case 25:
                                if (0 === d) break t;
                                if (w = x - d, r.offset > w) {
                                    if ((w = r.offset - w) > r.whave && r.sane) {
                                        t.msg = "invalid distance too far back", r.mode = 30;
                                        break;
                                    }
                                    w > r.wnext ? (w -= r.wnext, _ = r.wsize - w) : _ = r.wnext - w, w > r.length && (w = r.length), A = r.window;
                                } else A = c, _ = h - r.offset, w = r.length;
                                w > d && (w = d), d -= w, r.length -= w;
                                do c[h++] = A[_++];
                                while (--w);
                                0 === r.length && (r.mode = 21);
                                break;
                            case 26:
                                if (0 === d) break t;
                                c[h++] = r.length, d--, r.mode = 21;
                                break;
                            case 27:
                                if (r.wrap) {
                                    for(; y < 32;){
                                        if (0 === p) break t;
                                        p--, m |= l[f++] << y, y += 8;
                                    }
                                    if (x -= d, t.total_out += x, r.total += x, x && (t.adler = r.check = r.flags ? o(r.check, c, x, h - x) : i(r.check, c, x, h - x)), x = d, (r.flags ? m : u(m)) !== r.check) {
                                        t.msg = "incorrect data check", r.mode = 30;
                                        break;
                                    }
                                    m = 0, y = 0;
                                }
                                r.mode = 28;
                            case 28:
                                if (r.wrap && r.flags) {
                                    for(; y < 32;){
                                        if (0 === p) break t;
                                        p--, m += l[f++] << y, y += 8;
                                    }
                                    if (m !== (4294967295 & r.total)) {
                                        t.msg = "incorrect length check", r.mode = 30;
                                        break;
                                    }
                                    m = 0, y = 0;
                                }
                                r.mode = 29;
                            case 29:
                                O = 1;
                                break t;
                            case 30:
                                O = -3;
                                break t;
                            case 31:
                                return -4;
                            case 32:
                            default:
                                return -2;
                        }
                        return t.next_out = h, t.avail_out = d, t.next_in = f, t.avail_in = p, r.hold = m, r.bits = y, (r.wsize || x !== t.avail_out && r.mode < 30 && (r.mode < 27 || 4 !== e)) && v(t, t.output, t.next_out, x - t.avail_out) ? (r.mode = 31, -4) : (b -= t.avail_in, x -= t.avail_out, t.total_in += b, t.total_out += x, r.total += x, r.wrap && x && (t.adler = r.check = r.flags ? o(r.check, c, x, t.next_out - x) : i(r.check, c, x, t.next_out - x)), t.data_type = r.bits + (r.last ? 64 : 0) + (12 === r.mode ? 128 : 0) + (20 === r.mode || 15 === r.mode ? 256 : 0), (0 === b && 0 === x || 4 === e) && 0 === O && (O = -5), O);
                    }, e.inflateEnd = function(t) {
                        if (!t || !t.state) return -2;
                        var e = t.state;
                        return e.window && (e.window = null), t.state = null, 0;
                    }, e.inflateGetHeader = function(t, e) {
                        var r;
                        return t && t.state ? 0 == (2 & (r = t.state).wrap) ? -2 : (r.head = e, e.done = !1, 0) : -2;
                    }, e.inflateSetDictionary = function(t, e) {
                        var r, n = e.length;
                        return t && t.state ? 0 !== (r = t.state).wrap && 11 !== r.mode ? -2 : 11 === r.mode && i(1, e, n, 0) !== r.check ? -3 : v(t, e, n, n) ? (r.mode = 31, -4) : (r.havedict = 1, 0) : -2;
                    }, e.inflateInfo = "pako inflate (from Nodeca project)";
                },
                function(t, e, r) {
                    "use strict";
                    t.exports = function(t, e, r, n) {
                        for(var i = 65535 & t | 0, o = t >>> 16 & 65535 | 0, a = 0; 0 !== r;){
                            r -= a = r > 2e3 ? 2e3 : r;
                            do o = o + (i = i + e[n++] | 0) | 0;
                            while (--a);
                            i %= 65521, o %= 65521;
                        }
                        return i | o << 16 | 0;
                    };
                },
                function(t, e, r) {
                    "use strict";
                    var n = function() {
                        for(var t, e = [], r = 0; r < 256; r++){
                            t = r;
                            for(var n = 0; n < 8; n++)t = 1 & t ? 3988292384 ^ t >>> 1 : t >>> 1;
                            e[r] = t;
                        }
                        return e;
                    }();
                    t.exports = function(t, e, r, i) {
                        var o = n, a = i + r;
                        t ^= -1;
                        for(var s = i; s < a; s++)t = t >>> 8 ^ o[255 & (t ^ e[s])];
                        return -1 ^ t;
                    };
                },
                function(t, e, r) {
                    "use strict";
                    t.exports = function(t, e) {
                        var r, n, i, o, a, s, u, l, c, f, h, p, d, m, y, g, v, b, x, w, _, A, E, S, M;
                        r = t.state, n = t.next_in, S = t.input, i = n + (t.avail_in - 5), o = t.next_out, M = t.output, a = o - (e - t.avail_out), s = o + (t.avail_out - 257), u = r.dmax, l = r.wsize, c = r.whave, f = r.wnext, h = r.window, p = r.hold, d = r.bits, m = r.lencode, y = r.distcode, g = (1 << r.lenbits) - 1, v = (1 << r.distbits) - 1;
                        t: do {
                            d < 15 && (p += S[n++] << d, d += 8, p += S[n++] << d, d += 8), b = m[p & g];
                            e: for(;;){
                                if (p >>>= x = b >>> 24, d -= x, 0 == (x = b >>> 16 & 255)) M[o++] = 65535 & b;
                                else {
                                    if (!(16 & x)) {
                                        if (0 == (64 & x)) {
                                            b = m[(65535 & b) + (p & (1 << x) - 1)];
                                            continue e;
                                        }
                                        if (32 & x) {
                                            r.mode = 12;
                                            break t;
                                        }
                                        t.msg = "invalid literal/length code", r.mode = 30;
                                        break t;
                                    }
                                    w = 65535 & b, (x &= 15) && (d < x && (p += S[n++] << d, d += 8), w += p & (1 << x) - 1, p >>>= x, d -= x), d < 15 && (p += S[n++] << d, d += 8, p += S[n++] << d, d += 8), b = y[p & v];
                                    r: for(;;){
                                        if (p >>>= x = b >>> 24, d -= x, !(16 & (x = b >>> 16 & 255))) {
                                            if (0 == (64 & x)) {
                                                b = y[(65535 & b) + (p & (1 << x) - 1)];
                                                continue r;
                                            }
                                            t.msg = "invalid distance code", r.mode = 30;
                                            break t;
                                        }
                                        if (_ = 65535 & b, d < (x &= 15) && (p += S[n++] << d, (d += 8) < x && (p += S[n++] << d, d += 8)), (_ += p & (1 << x) - 1) > u) {
                                            t.msg = "invalid distance too far back", r.mode = 30;
                                            break t;
                                        }
                                        if (p >>>= x, d -= x, _ > (x = o - a)) {
                                            if ((x = _ - x) > c && r.sane) {
                                                t.msg = "invalid distance too far back", r.mode = 30;
                                                break t;
                                            }
                                            if (A = 0, E = h, 0 === f) {
                                                if (A += l - x, x < w) {
                                                    w -= x;
                                                    do M[o++] = h[A++];
                                                    while (--x);
                                                    A = o - _, E = M;
                                                }
                                            } else if (f < x) {
                                                if (A += l + f - x, (x -= f) < w) {
                                                    w -= x;
                                                    do M[o++] = h[A++];
                                                    while (--x);
                                                    if (A = 0, f < w) {
                                                        w -= x = f;
                                                        do M[o++] = h[A++];
                                                        while (--x);
                                                        A = o - _, E = M;
                                                    }
                                                }
                                            } else if (A += f - x, x < w) {
                                                w -= x;
                                                do M[o++] = h[A++];
                                                while (--x);
                                                A = o - _, E = M;
                                            }
                                            for(; w > 2;)M[o++] = E[A++], M[o++] = E[A++], M[o++] = E[A++], w -= 3;
                                            w && (M[o++] = E[A++], w > 1 && (M[o++] = E[A++]));
                                        } else {
                                            A = o - _;
                                            do M[o++] = M[A++], M[o++] = M[A++], M[o++] = M[A++], w -= 3;
                                            while (w > 2);
                                            w && (M[o++] = M[A++], w > 1 && (M[o++] = M[A++]));
                                        }
                                        break;
                                    }
                                }
                                break;
                            }
                        }while (n < i && o < s);
                        n -= w = d >> 3, p &= (1 << (d -= w << 3)) - 1, t.next_in = n, t.next_out = o, t.avail_in = n < i ? i - n + 5 : 5 - (n - i), t.avail_out = o < s ? s - o + 257 : 257 - (o - s), r.hold = p, r.bits = d;
                    };
                },
                function(t, e, r) {
                    "use strict";
                    var n = r(29), i = [
                        3,
                        4,
                        5,
                        6,
                        7,
                        8,
                        9,
                        10,
                        11,
                        13,
                        15,
                        17,
                        19,
                        23,
                        27,
                        31,
                        35,
                        43,
                        51,
                        59,
                        67,
                        83,
                        99,
                        115,
                        131,
                        163,
                        195,
                        227,
                        258,
                        0,
                        0
                    ], o = [
                        16,
                        16,
                        16,
                        16,
                        16,
                        16,
                        16,
                        16,
                        17,
                        17,
                        17,
                        17,
                        18,
                        18,
                        18,
                        18,
                        19,
                        19,
                        19,
                        19,
                        20,
                        20,
                        20,
                        20,
                        21,
                        21,
                        21,
                        21,
                        16,
                        72,
                        78
                    ], a = [
                        1,
                        2,
                        3,
                        4,
                        5,
                        7,
                        9,
                        13,
                        17,
                        25,
                        33,
                        49,
                        65,
                        97,
                        129,
                        193,
                        257,
                        385,
                        513,
                        769,
                        1025,
                        1537,
                        2049,
                        3073,
                        4097,
                        6145,
                        8193,
                        12289,
                        16385,
                        24577,
                        0,
                        0
                    ], s = [
                        16,
                        16,
                        16,
                        16,
                        17,
                        17,
                        18,
                        18,
                        19,
                        19,
                        20,
                        20,
                        21,
                        21,
                        22,
                        22,
                        23,
                        23,
                        24,
                        24,
                        25,
                        25,
                        26,
                        26,
                        27,
                        27,
                        28,
                        28,
                        29,
                        29,
                        64,
                        64
                    ];
                    t.exports = function(t, e, r, u, l, c, f, h) {
                        var p, d, m, y, g, v, b, x, w, _ = h.bits, A = 0, E = 0, S = 0, M = 0, k = 0, N = 0, C = 0, D = 0, O = 0, T = 0, F = null, P = 0, I = new n.Buf16(16), B = new n.Buf16(16), j = null, R = 0;
                        for(A = 0; A <= 15; A++)I[A] = 0;
                        for(E = 0; E < u; E++)I[e[r + E]]++;
                        for(k = _, M = 15; M >= 1 && 0 === I[M]; M--);
                        if (k > M && (k = M), 0 === M) return l[c++] = 20971520, l[c++] = 20971520, h.bits = 1, 0;
                        for(S = 1; S < M && 0 === I[S]; S++);
                        for(k < S && (k = S), D = 1, A = 1; A <= 15; A++)if (D <<= 1, (D -= I[A]) < 0) return -1;
                        if (D > 0 && (0 === t || 1 !== M)) return -1;
                        for(B[1] = 0, A = 1; A < 15; A++)B[A + 1] = B[A] + I[A];
                        for(E = 0; E < u; E++)0 !== e[r + E] && (f[B[e[r + E]]++] = E);
                        if (0 === t ? (F = j = f, v = 19) : 1 === t ? (F = i, P -= 257, j = o, R -= 257, v = 256) : (F = a, j = s, v = -1), T = 0, E = 0, A = S, g = c, N = k, C = 0, m = -1, y = (O = 1 << k) - 1, 1 === t && O > 852 || 2 === t && O > 592) return 1;
                        for(;;){
                            b = A - C, f[E] < v ? (x = 0, w = f[E]) : f[E] > v ? (x = j[R + f[E]], w = F[P + f[E]]) : (x = 96, w = 0), p = 1 << A - C, S = d = 1 << N;
                            do l[g + (T >> C) + (d -= p)] = b << 24 | x << 16 | w | 0;
                            while (0 !== d);
                            for(p = 1 << A - 1; T & p;)p >>= 1;
                            if (0 !== p ? (T &= p - 1, T += p) : T = 0, E++, 0 == --I[A]) {
                                if (A === M) break;
                                A = e[r + f[E]];
                            }
                            if (A > k && (T & y) !== m) {
                                for(0 === C && (C = k), g += S, D = 1 << (N = A - C); N + C < M && !((D -= I[N + C]) <= 0);)N++, D <<= 1;
                                if (O += 1 << N, 1 === t && O > 852 || 2 === t && O > 592) return 1;
                                l[m = T & y] = k << 24 | N << 16 | g - c | 0;
                            }
                        }
                        return 0 !== T && (l[g + T] = A - C << 24 | 4194304), h.bits = k, 0;
                    };
                },
                function(t, e, r) {
                    "use strict";
                    var n = r(29), i = !0, o = !0;
                    try {
                        String.fromCharCode.apply(null, [
                            0
                        ]);
                    } catch (t) {
                        i = !1;
                    }
                    try {
                        String.fromCharCode.apply(null, new Uint8Array(1));
                    } catch (t) {
                        o = !1;
                    }
                    for(var a = new n.Buf8(256), s = 0; s < 256; s++)a[s] = s >= 252 ? 6 : s >= 248 ? 5 : s >= 240 ? 4 : s >= 224 ? 3 : s >= 192 ? 2 : 1;
                    function u(t, e) {
                        if (e < 65534 && (t.subarray && o || !t.subarray && i)) return String.fromCharCode.apply(null, n.shrinkBuf(t, e));
                        for(var r = "", a = 0; a < e; a++)r += String.fromCharCode(t[a]);
                        return r;
                    }
                    a[254] = a[254] = 1, e.string2buf = function(t) {
                        var e, r, i, o, a, s = t.length, u = 0;
                        for(o = 0; o < s; o++)55296 == (64512 & (r = t.charCodeAt(o))) && o + 1 < s && 56320 == (64512 & (i = t.charCodeAt(o + 1))) && (r = 65536 + (r - 55296 << 10) + (i - 56320), o++), u += r < 128 ? 1 : r < 2048 ? 2 : r < 65536 ? 3 : 4;
                        for(e = new n.Buf8(u), a = 0, o = 0; a < u; o++)55296 == (64512 & (r = t.charCodeAt(o))) && o + 1 < s && 56320 == (64512 & (i = t.charCodeAt(o + 1))) && (r = 65536 + (r - 55296 << 10) + (i - 56320), o++), r < 128 ? e[a++] = r : r < 2048 ? (e[a++] = 192 | r >>> 6, e[a++] = 128 | 63 & r) : r < 65536 ? (e[a++] = 224 | r >>> 12, e[a++] = 128 | r >>> 6 & 63, e[a++] = 128 | 63 & r) : (e[a++] = 240 | r >>> 18, e[a++] = 128 | r >>> 12 & 63, e[a++] = 128 | r >>> 6 & 63, e[a++] = 128 | 63 & r);
                        return e;
                    }, e.buf2binstring = function(t) {
                        return u(t, t.length);
                    }, e.binstring2buf = function(t) {
                        for(var e = new n.Buf8(t.length), r = 0, i = e.length; r < i; r++)e[r] = t.charCodeAt(r);
                        return e;
                    }, e.buf2string = function(t, e) {
                        var r, n, i, o, s = e || t.length, l = new Array(2 * s);
                        for(n = 0, r = 0; r < s;)if ((i = t[r++]) < 128) l[n++] = i;
                        else if ((o = a[i]) > 4) l[n++] = 65533, r += o - 1;
                        else {
                            for(i &= 2 === o ? 31 : 3 === o ? 15 : 7; o > 1 && r < s;)i = i << 6 | 63 & t[r++], o--;
                            o > 1 ? l[n++] = 65533 : i < 65536 ? l[n++] = i : (i -= 65536, l[n++] = 55296 | i >> 10 & 1023, l[n++] = 56320 | 1023 & i);
                        }
                        return u(l, n);
                    }, e.utf8border = function(t, e) {
                        var r;
                        for((e = e || t.length) > t.length && (e = t.length), r = e - 1; r >= 0 && 128 == (192 & t[r]);)r--;
                        return r < 0 || 0 === r ? e : r + a[t[r]] > e ? r : e;
                    };
                },
                function(t, e, r) {
                    "use strict";
                    t.exports = {
                        Z_NO_FLUSH: 0,
                        Z_PARTIAL_FLUSH: 1,
                        Z_SYNC_FLUSH: 2,
                        Z_FULL_FLUSH: 3,
                        Z_FINISH: 4,
                        Z_BLOCK: 5,
                        Z_TREES: 6,
                        Z_OK: 0,
                        Z_STREAM_END: 1,
                        Z_NEED_DICT: 2,
                        Z_ERRNO: -1,
                        Z_STREAM_ERROR: -2,
                        Z_DATA_ERROR: -3,
                        Z_BUF_ERROR: -5,
                        Z_NO_COMPRESSION: 0,
                        Z_BEST_SPEED: 1,
                        Z_BEST_COMPRESSION: 9,
                        Z_DEFAULT_COMPRESSION: -1,
                        Z_FILTERED: 1,
                        Z_HUFFMAN_ONLY: 2,
                        Z_RLE: 3,
                        Z_FIXED: 4,
                        Z_DEFAULT_STRATEGY: 0,
                        Z_BINARY: 0,
                        Z_TEXT: 1,
                        Z_UNKNOWN: 2,
                        Z_DEFLATED: 8
                    };
                },
                function(t, e, r) {
                    "use strict";
                    t.exports = {
                        2: "need dictionary",
                        1: "stream end",
                        0: "",
                        "-1": "file error",
                        "-2": "stream error",
                        "-3": "data error",
                        "-4": "insufficient memory",
                        "-5": "buffer error",
                        "-6": "incompatible version"
                    };
                },
                function(t, e, r) {
                    "use strict";
                    t.exports = function() {
                        this.input = null, this.next_in = 0, this.avail_in = 0, this.total_in = 0, this.output = null, this.next_out = 0, this.avail_out = 0, this.total_out = 0, this.msg = "", this.state = null, this.data_type = 2, this.adler = 0;
                    };
                },
                function(t, e, r) {
                    "use strict";
                    t.exports = function() {
                        this.text = 0, this.time = 0, this.xflags = 0, this.os = 0, this.extra = null, this.extra_len = 0, this.name = "", this.comment = "", this.hcrc = 0, this.done = !1;
                    };
                },
                function(t, e, r) {
                    t.exports = r.p + "0.georaster.browser.bundle.min.worker.js";
                },
                function(t, e, r) {
                    t.exports = function(t) {
                        function e(t) {
                            let r, i, o, a = null;
                            function s(...t) {
                                if (!s.enabled) return;
                                const n = s, i = Number(new Date), o = i - (r || i);
                                n.diff = o, n.prev = r, n.curr = i, r = i, t[0] = e.coerce(t[0]), "string" != typeof t[0] && t.unshift("%O");
                                let a = 0;
                                t[0] = t[0].replace(/%([a-zA-Z%])/g, (r, i)=>{
                                    if ("%%" === r) return "%";
                                    a++;
                                    const o = e.formatters[i];
                                    if ("function" == typeof o) {
                                        const e = t[a];
                                        r = o.call(n, e), t.splice(a, 1), a--;
                                    }
                                    return r;
                                }), e.formatArgs.call(n, t), (n.log || e.log).apply(n, t);
                            }
                            return s.namespace = t, s.useColors = e.useColors(), s.color = e.selectColor(t), s.extend = n, s.destroy = e.destroy, Object.defineProperty(s, "enabled", {
                                enumerable: !0,
                                configurable: !1,
                                get: ()=>null !== a ? a : (i !== e.namespaces && (i = e.namespaces, o = e.enabled(t)), o),
                                set: (t)=>{
                                    a = t;
                                }
                            }), "function" == typeof e.init && e.init(s), s;
                        }
                        function n(t, r) {
                            const n = e(this.namespace + (void 0 === r ? ":" : r) + t);
                            return n.log = this.log, n;
                        }
                        function i(t) {
                            return t.toString().substring(2, t.toString().length - 2).replace(/\.\*\?$/, "*");
                        }
                        return e.debug = e, e.default = e, e.coerce = function(t) {
                            return t instanceof Error ? t.stack || t.message : t;
                        }, e.disable = function() {
                            const t = [
                                ...e.names.map(i),
                                ...e.skips.map(i).map((t)=>"-" + t)
                            ].join(",");
                            return e.enable(""), t;
                        }, e.enable = function(t) {
                            let r;
                            e.save(t), e.namespaces = t, e.names = [], e.skips = [];
                            const n = ("string" == typeof t ? t : "").split(/[\s,]+/), i = n.length;
                            for(r = 0; r < i; r++)n[r] && ("-" === (t = n[r].replace(/\*/g, ".*?"))[0] ? e.skips.push(new RegExp("^" + t.slice(1) + "$")) : e.names.push(new RegExp("^" + t + "$")));
                        }, e.enabled = function(t) {
                            if ("*" === t[t.length - 1]) return !0;
                            let r, n;
                            for(r = 0, n = e.skips.length; r < n; r++)if (e.skips[r].test(t)) return !1;
                            for(r = 0, n = e.names.length; r < n; r++)if (e.names[r].test(t)) return !0;
                            return !1;
                        }, e.humanize = r(135), e.destroy = function() {
                            console.warn("Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.");
                        }, Object.keys(t).forEach((r)=>{
                            e[r] = t[r];
                        }), e.names = [], e.skips = [], e.formatters = {}, e.selectColor = function(t) {
                            let r = 0;
                            for(let e = 0; e < t.length; e++)r = (r << 5) - r + t.charCodeAt(e), r |= 0;
                            return e.colors[Math.abs(r) % e.colors.length];
                        }, e.enable(e.load()), e;
                    };
                },
                function(t, e) {
                    var r = 1e3, n = 6e4, i = 60 * n, o = 24 * i;
                    function a(t, e, r, n) {
                        var i = e >= 1.5 * r;
                        return Math.round(t / r) + " " + n + (i ? "s" : "");
                    }
                    t.exports = function(t, e) {
                        e = e || {};
                        var s = typeof t;
                        if ("string" === s && t.length > 0) return function(t) {
                            if (!((t = String(t)).length > 100)) {
                                var e = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(t);
                                if (e) {
                                    var a = parseFloat(e[1]);
                                    switch((e[2] || "ms").toLowerCase()){
                                        case "years":
                                        case "year":
                                        case "yrs":
                                        case "yr":
                                        case "y":
                                            return 315576e5 * a;
                                        case "weeks":
                                        case "week":
                                        case "w":
                                            return 6048e5 * a;
                                        case "days":
                                        case "day":
                                        case "d":
                                            return a * o;
                                        case "hours":
                                        case "hour":
                                        case "hrs":
                                        case "hr":
                                        case "h":
                                            return a * i;
                                        case "minutes":
                                        case "minute":
                                        case "mins":
                                        case "min":
                                        case "m":
                                            return a * n;
                                        case "seconds":
                                        case "second":
                                        case "secs":
                                        case "sec":
                                        case "s":
                                            return a * r;
                                        case "milliseconds":
                                        case "millisecond":
                                        case "msecs":
                                        case "msec":
                                        case "ms":
                                            return a;
                                        default:
                                            return;
                                    }
                                }
                            }
                        }(t);
                        if ("number" === s && isFinite(t)) return e.long ? function(t) {
                            var e = Math.abs(t);
                            return e >= o ? a(t, e, o, "day") : e >= i ? a(t, e, i, "hour") : e >= n ? a(t, e, n, "minute") : e >= r ? a(t, e, r, "second") : t + " ms";
                        }(t) : function(t) {
                            var e = Math.abs(t);
                            return e >= o ? Math.round(t / o) + "d" : e >= i ? Math.round(t / i) + "h" : e >= n ? Math.round(t / n) + "m" : e >= r ? Math.round(t / r) + "s" : t + "ms";
                        }(t);
                        throw new Error("val is not a non-empty string or a valid number. val=" + JSON.stringify(t));
                    };
                },
                function(t, e, r) {
                    (function(e, n, i) {
                        var o = r(69), a = r(10), s = r(70), u = r(42), l = r(137), c = s.IncomingMessage, f = s.readyStates, h = t.exports = function(t) {
                            var r, n = this;
                            u.Writable.call(n), n._opts = t, n._body = [], n._headers = {}, t.auth && n.setHeader("Authorization", "Basic " + new e(t.auth).toString("base64")), Object.keys(t.headers).forEach(function(e) {
                                n.setHeader(e, t.headers[e]);
                            });
                            var i = !0;
                            if ("disable-fetch" === t.mode || "requestTimeout" in t && !o.abortController) i = !1, r = !0;
                            else if ("prefer-streaming" === t.mode) r = !1;
                            else if ("allow-wrong-content-type" === t.mode) r = !o.overrideMimeType;
                            else {
                                if (t.mode && "default" !== t.mode && "prefer-fast" !== t.mode) throw new Error("Invalid value for opts.mode");
                                r = !0;
                            }
                            n._mode = function(t, e) {
                                return o.fetch && e ? "fetch" : o.mozchunkedarraybuffer ? "moz-chunked-arraybuffer" : o.msstream ? "ms-stream" : o.arraybuffer && t ? "arraybuffer" : o.vbArray && t ? "text:vbarray" : "text";
                            }(r, i), n._fetchTimer = null, n.on("finish", function() {
                                n._onFinish();
                            });
                        };
                        a(h, u.Writable), h.prototype.setHeader = function(t, e) {
                            var r = t.toLowerCase();
                            -1 === p.indexOf(r) && (this._headers[r] = {
                                name: t,
                                value: e
                            });
                        }, h.prototype.getHeader = function(t) {
                            var e = this._headers[t.toLowerCase()];
                            return e ? e.value : null;
                        }, h.prototype.removeHeader = function(t) {
                            delete this._headers[t.toLowerCase()];
                        }, h.prototype._onFinish = function() {
                            var t = this;
                            if (!t._destroyed) {
                                var r = t._opts, a = t._headers, s = null;
                                "GET" !== r.method && "HEAD" !== r.method && (s = o.arraybuffer ? l(e.concat(t._body)) : o.blobConstructor ? new n.Blob(t._body.map(function(t) {
                                    return l(t);
                                }), {
                                    type: (a["content-type"] || {}).value || ""
                                }) : e.concat(t._body).toString());
                                var u = [];
                                if (Object.keys(a).forEach(function(t) {
                                    var e = a[t].name, r = a[t].value;
                                    Array.isArray(r) ? r.forEach(function(t) {
                                        u.push([
                                            e,
                                            t
                                        ]);
                                    }) : u.push([
                                        e,
                                        r
                                    ]);
                                }), "fetch" === t._mode) {
                                    var c = null;
                                    if (o.abortController) {
                                        var h = new AbortController;
                                        c = h.signal, t._fetchAbortController = h, "requestTimeout" in r && 0 !== r.requestTimeout && (t._fetchTimer = n.setTimeout(function() {
                                            t.emit("requestTimeout"), t._fetchAbortController && t._fetchAbortController.abort();
                                        }, r.requestTimeout));
                                    }
                                    n.fetch(t._opts.url, {
                                        method: t._opts.method,
                                        headers: u,
                                        body: s || void 0,
                                        mode: "cors",
                                        credentials: r.withCredentials ? "include" : "same-origin",
                                        signal: c
                                    }).then(function(e) {
                                        t._fetchResponse = e, t._connect();
                                    }, function(e) {
                                        n.clearTimeout(t._fetchTimer), t._destroyed || t.emit("error", e);
                                    });
                                } else {
                                    var p = t._xhr = new n.XMLHttpRequest;
                                    try {
                                        p.open(t._opts.method, t._opts.url, !0);
                                    } catch (e) {
                                        return void i.nextTick(function() {
                                            t.emit("error", e);
                                        });
                                    }
                                    "responseType" in p && (p.responseType = t._mode.split(":")[0]), "withCredentials" in p && (p.withCredentials = !!r.withCredentials), "text" === t._mode && "overrideMimeType" in p && p.overrideMimeType("text/plain; charset=x-user-defined"), "requestTimeout" in r && (p.timeout = r.requestTimeout, p.ontimeout = function() {
                                        t.emit("requestTimeout");
                                    }), u.forEach(function(t) {
                                        p.setRequestHeader(t[0], t[1]);
                                    }), t._response = null, p.onreadystatechange = function() {
                                        switch(p.readyState){
                                            case f.LOADING:
                                            case f.DONE:
                                                t._onXHRProgress();
                                        }
                                    }, "moz-chunked-arraybuffer" === t._mode && (p.onprogress = function() {
                                        t._onXHRProgress();
                                    }), p.onerror = function() {
                                        t._destroyed || t.emit("error", new Error("XHR error"));
                                    };
                                    try {
                                        p.send(s);
                                    } catch (e) {
                                        return void i.nextTick(function() {
                                            t.emit("error", e);
                                        });
                                    }
                                }
                            }
                        }, h.prototype._onXHRProgress = function() {
                            (function(t) {
                                try {
                                    var e = t.status;
                                    return null !== e && 0 !== e;
                                } catch (t) {
                                    return !1;
                                }
                            })(this._xhr) && !this._destroyed && (this._response || this._connect(), this._response._onXHRProgress());
                        }, h.prototype._connect = function() {
                            var t = this;
                            t._destroyed || (t._response = new c(t._xhr, t._fetchResponse, t._mode, t._fetchTimer), t._response.on("error", function(e) {
                                t.emit("error", e);
                            }), t.emit("response", t._response));
                        }, h.prototype._write = function(t, e, r) {
                            this._body.push(t), r();
                        }, h.prototype.abort = h.prototype.destroy = function() {
                            this._destroyed = !0, n.clearTimeout(this._fetchTimer), this._response && (this._response._destroyed = !0), this._xhr ? this._xhr.abort() : this._fetchAbortController && this._fetchAbortController.abort();
                        }, h.prototype.end = function(t, e, r) {
                            "function" == typeof t && (r = t, t = void 0), u.Writable.prototype.end.call(this, t, e, r);
                        }, h.prototype.flushHeaders = function() {}, h.prototype.setTimeout = function() {}, h.prototype.setNoDelay = function() {}, h.prototype.setSocketKeepAlive = function() {};
                        var p = [
                            "accept-charset",
                            "accept-encoding",
                            "access-control-request-headers",
                            "access-control-request-method",
                            "connection",
                            "content-length",
                            "cookie",
                            "cookie2",
                            "date",
                            "dnt",
                            "expect",
                            "host",
                            "keep-alive",
                            "origin",
                            "referer",
                            "te",
                            "trailer",
                            "transfer-encoding",
                            "upgrade",
                            "via"
                        ];
                    }).call(this, r(7).Buffer, r(3), r(8));
                },
                function(t, e, r) {
                    var n = r(7).Buffer;
                    t.exports = function(t) {
                        if (t instanceof Uint8Array) {
                            if (0 === t.byteOffset && t.byteLength === t.buffer.byteLength) return t.buffer;
                            if ("function" == typeof t.buffer.slice) return t.buffer.slice(t.byteOffset, t.byteOffset + t.byteLength);
                        }
                        if (n.isBuffer(t)) {
                            for(var e = new Uint8Array(t.length), r = t.length, i = 0; i < r; i++)e[i] = t[i];
                            return e.buffer;
                        }
                        throw new Error("Argument must be a Buffer");
                    };
                },
                function(t, e) {
                    t.exports = function() {
                        for(var t = {}, e = 0; e < arguments.length; e++){
                            var n = arguments[e];
                            for(var i in n)r.call(n, i) && (t[i] = n[i]);
                        }
                        return t;
                    };
                    var r = Object.prototype.hasOwnProperty;
                },
                function(t, e) {
                    t.exports = {
                        100: "Continue",
                        101: "Switching Protocols",
                        102: "Processing",
                        200: "OK",
                        201: "Created",
                        202: "Accepted",
                        203: "Non-Authoritative Information",
                        204: "No Content",
                        205: "Reset Content",
                        206: "Partial Content",
                        207: "Multi-Status",
                        208: "Already Reported",
                        226: "IM Used",
                        300: "Multiple Choices",
                        301: "Moved Permanently",
                        302: "Found",
                        303: "See Other",
                        304: "Not Modified",
                        305: "Use Proxy",
                        307: "Temporary Redirect",
                        308: "Permanent Redirect",
                        400: "Bad Request",
                        401: "Unauthorized",
                        402: "Payment Required",
                        403: "Forbidden",
                        404: "Not Found",
                        405: "Method Not Allowed",
                        406: "Not Acceptable",
                        407: "Proxy Authentication Required",
                        408: "Request Timeout",
                        409: "Conflict",
                        410: "Gone",
                        411: "Length Required",
                        412: "Precondition Failed",
                        413: "Payload Too Large",
                        414: "URI Too Long",
                        415: "Unsupported Media Type",
                        416: "Range Not Satisfiable",
                        417: "Expectation Failed",
                        418: "I'm a teapot",
                        421: "Misdirected Request",
                        422: "Unprocessable Entity",
                        423: "Locked",
                        424: "Failed Dependency",
                        425: "Unordered Collection",
                        426: "Upgrade Required",
                        428: "Precondition Required",
                        429: "Too Many Requests",
                        431: "Request Header Fields Too Large",
                        451: "Unavailable For Legal Reasons",
                        500: "Internal Server Error",
                        501: "Not Implemented",
                        502: "Bad Gateway",
                        503: "Service Unavailable",
                        504: "Gateway Timeout",
                        505: "HTTP Version Not Supported",
                        506: "Variant Also Negotiates",
                        507: "Insufficient Storage",
                        508: "Loop Detected",
                        509: "Bandwidth Limit Exceeded",
                        510: "Not Extended",
                        511: "Network Authentication Required"
                    };
                },
                function(t, e, r) {
                    (function(t, n) {
                        var i; /*! https://mths.be/punycode v1.4.1 by @mathias */ 
                        !function(o) {
                            e && e.nodeType, t && t.nodeType;
                            var a = "object" == typeof n && n;
                            a.global !== a && a.window !== a && a.self;
                            var s, u = 2147483647, l = /^xn--/, c = /[^\x20-\x7E]/, f = /[\x2E\u3002\uFF0E\uFF61]/g, h = {
                                overflow: "Overflow: input needs wider integers to process",
                                "not-basic": "Illegal input >= 0x80 (not a basic code point)",
                                "invalid-input": "Invalid input"
                            }, p = Math.floor, d = String.fromCharCode;
                            function m(t) {
                                throw new RangeError(h[t]);
                            }
                            function y(t, e) {
                                for(var r = t.length, n = []; r--;)n[r] = e(t[r]);
                                return n;
                            }
                            function g(t, e) {
                                var r = t.split("@"), n = "";
                                return r.length > 1 && (n = r[0] + "@", t = r[1]), n + y((t = t.replace(f, ".")).split("."), e).join(".");
                            }
                            function v(t) {
                                for(var e, r, n = [], i = 0, o = t.length; i < o;)(e = t.charCodeAt(i++)) >= 55296 && e <= 56319 && i < o ? 56320 == (64512 & (r = t.charCodeAt(i++))) ? n.push(((1023 & e) << 10) + (1023 & r) + 65536) : (n.push(e), i--) : n.push(e);
                                return n;
                            }
                            function b(t) {
                                return y(t, function(t) {
                                    var e = "";
                                    return t > 65535 && (e += d((t -= 65536) >>> 10 & 1023 | 55296), t = 56320 | 1023 & t), e + d(t);
                                }).join("");
                            }
                            function x(t, e) {
                                return t + 22 + 75 * (t < 26) - ((0 != e) << 5);
                            }
                            function w(t, e, r) {
                                var n = 0;
                                for(t = r ? p(t / 700) : t >> 1, t += p(t / e); t > 455; n += 36)t = p(t / 35);
                                return p(n + 36 * t / (t + 38));
                            }
                            function _(t) {
                                var e, r, n, i, o, a, s, l, c, f, h, d = [], y = t.length, g = 0, v = 128, x = 72;
                                for((r = t.lastIndexOf("-")) < 0 && (r = 0), n = 0; n < r; ++n)t.charCodeAt(n) >= 128 && m("not-basic"), d.push(t.charCodeAt(n));
                                for(i = r > 0 ? r + 1 : 0; i < y;){
                                    for(o = g, a = 1, s = 36; i >= y && m("invalid-input"), ((l = (h = t.charCodeAt(i++)) - 48 < 10 ? h - 22 : h - 65 < 26 ? h - 65 : h - 97 < 26 ? h - 97 : 36) >= 36 || l > p((u - g) / a)) && m("overflow"), g += l * a, !(l < (c = s <= x ? 1 : s >= x + 26 ? 26 : s - x)); s += 36)a > p(u / (f = 36 - c)) && m("overflow"), a *= f;
                                    x = w(g - o, e = d.length + 1, 0 == o), p(g / e) > u - v && m("overflow"), v += p(g / e), g %= e, d.splice(g++, 0, v);
                                }
                                return b(d);
                            }
                            function A(t) {
                                var e, r, n, i, o, a, s, l, c, f, h, y, g, b, _, A = [];
                                for(y = (t = v(t)).length, e = 128, r = 0, o = 72, a = 0; a < y; ++a)(h = t[a]) < 128 && A.push(d(h));
                                for(n = i = A.length, i && A.push("-"); n < y;){
                                    for(s = u, a = 0; a < y; ++a)(h = t[a]) >= e && h < s && (s = h);
                                    for(s - e > p((u - r) / (g = n + 1)) && m("overflow"), r += (s - e) * g, e = s, a = 0; a < y; ++a)if ((h = t[a]) < e && ++r > u && m("overflow"), h == e) {
                                        for(l = r, c = 36; !(l < (f = c <= o ? 1 : c >= o + 26 ? 26 : c - o)); c += 36)_ = l - f, b = 36 - f, A.push(d(x(f + _ % b, 0))), l = p(_ / b);
                                        A.push(d(x(l, 0))), o = w(r, g, n == i), r = 0, ++n;
                                    }
                                    ++r, ++e;
                                }
                                return A.join("");
                            }
                            s = {
                                version: "1.4.1",
                                ucs2: {
                                    decode: v,
                                    encode: b
                                },
                                decode: _,
                                encode: A,
                                toASCII: function(t) {
                                    return g(t, function(t) {
                                        return c.test(t) ? "xn--" + A(t) : t;
                                    });
                                },
                                toUnicode: function(t) {
                                    return g(t, function(t) {
                                        return l.test(t) ? _(t.slice(4).toLowerCase()) : t;
                                    });
                                }
                            }, void 0 === (i = (function() {
                                return s;
                            }).call(e, r, e, t)) || (t.exports = i);
                        }();
                    }).call(this, r(141)(t), r(3));
                },
                function(t, e) {
                    t.exports = function(t) {
                        return t.webpackPolyfill || (t.deprecate = function() {}, t.paths = [], t.children || (t.children = []), Object.defineProperty(t, "loaded", {
                            enumerable: !0,
                            get: function() {
                                return t.l;
                            }
                        }), Object.defineProperty(t, "id", {
                            enumerable: !0,
                            get: function() {
                                return t.i;
                            }
                        }), t.webpackPolyfill = 1), t;
                    };
                },
                function(t, e, r) {
                    "use strict";
                    var n = r(143), i = r(154), o = r(46);
                    t.exports = {
                        formats: o,
                        parse: i,
                        stringify: n
                    };
                },
                function(t, e, r) {
                    "use strict";
                    var n = r(144), i = r(71), o = r(46), a = Object.prototype.hasOwnProperty, s = {
                        brackets: function(t) {
                            return t + "[]";
                        },
                        comma: "comma",
                        indices: function(t, e) {
                            return t + "[" + e + "]";
                        },
                        repeat: function(t) {
                            return t;
                        }
                    }, u = Array.isArray, l = Array.prototype.push, c = function(t, e) {
                        l.apply(t, u(e) ? e : [
                            e
                        ]);
                    }, f = Date.prototype.toISOString, h = o.default, p = {
                        addQueryPrefix: !1,
                        allowDots: !1,
                        charset: "utf-8",
                        charsetSentinel: !1,
                        delimiter: "&",
                        encode: !0,
                        encoder: i.encode,
                        encodeValuesOnly: !1,
                        format: h,
                        formatter: o.formatters[h],
                        indices: !1,
                        serializeDate: function(t) {
                            return f.call(t);
                        },
                        skipNulls: !1,
                        strictNullHandling: !1
                    }, d = {}, m = function t(e, r, o, a, s, l, f, h, m, y, g, v, b, x, w, _) {
                        for(var A, E = e, S = _, M = 0, k = !1; void 0 !== (S = S.get(d)) && !k;){
                            var N = S.get(e);
                            if (M += 1, void 0 !== N) {
                                if (N === M) throw new RangeError("Cyclic object value");
                                k = !0;
                            }
                            void 0 === S.get(d) && (M = 0);
                        }
                        if ("function" == typeof h ? E = h(r, E) : E instanceof Date ? E = g(E) : "comma" === o && u(E) && (E = i.maybeMap(E, function(t) {
                            return t instanceof Date ? g(t) : t;
                        })), null === E) {
                            if (s) return f && !x ? f(r, p.encoder, w, "key", v) : r;
                            E = "";
                        }
                        if ("string" == typeof (A = E) || "number" == typeof A || "boolean" == typeof A || "symbol" == typeof A || "bigint" == typeof A || i.isBuffer(E)) return f ? [
                            b(x ? r : f(r, p.encoder, w, "key", v)) + "=" + b(f(E, p.encoder, w, "value", v))
                        ] : [
                            b(r) + "=" + b(String(E))
                        ];
                        var C, D = [];
                        if (void 0 === E) return D;
                        if ("comma" === o && u(E)) x && f && (E = i.maybeMap(E, f)), C = [
                            {
                                value: E.length > 0 ? E.join(",") || null : void 0
                            }
                        ];
                        else if (u(h)) C = h;
                        else {
                            var O = Object.keys(E);
                            C = m ? O.sort(m) : O;
                        }
                        for(var T = a && u(E) && 1 === E.length ? r + "[]" : r, F = 0; F < C.length; ++F){
                            var P = C[F], I = "object" == typeof P && void 0 !== P.value ? P.value : E[P];
                            if (!l || null !== I) {
                                var B = u(E) ? "function" == typeof o ? o(T, P) : T : T + (y ? "." + P : "[" + P + "]");
                                _.set(e, M);
                                var j = n();
                                j.set(d, _), c(D, t(I, B, o, a, s, l, "comma" === o && x && u(E) ? null : f, h, m, y, g, v, b, x, w, j));
                            }
                        }
                        return D;
                    };
                    t.exports = function(t, e) {
                        var r, i = t, l = function(t) {
                            if (!t) return p;
                            if (null !== t.encoder && void 0 !== t.encoder && "function" != typeof t.encoder) throw new TypeError("Encoder has to be a function.");
                            var e = t.charset || p.charset;
                            if (void 0 !== t.charset && "utf-8" !== t.charset && "iso-8859-1" !== t.charset) throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
                            var r = o.default;
                            if (void 0 !== t.format) {
                                if (!a.call(o.formatters, t.format)) throw new TypeError("Unknown format option provided.");
                                r = t.format;
                            }
                            var n = o.formatters[r], i = p.filter;
                            return ("function" == typeof t.filter || u(t.filter)) && (i = t.filter), {
                                addQueryPrefix: "boolean" == typeof t.addQueryPrefix ? t.addQueryPrefix : p.addQueryPrefix,
                                allowDots: void 0 === t.allowDots ? p.allowDots : !!t.allowDots,
                                charset: e,
                                charsetSentinel: "boolean" == typeof t.charsetSentinel ? t.charsetSentinel : p.charsetSentinel,
                                delimiter: void 0 === t.delimiter ? p.delimiter : t.delimiter,
                                encode: "boolean" == typeof t.encode ? t.encode : p.encode,
                                encoder: "function" == typeof t.encoder ? t.encoder : p.encoder,
                                encodeValuesOnly: "boolean" == typeof t.encodeValuesOnly ? t.encodeValuesOnly : p.encodeValuesOnly,
                                filter: i,
                                format: r,
                                formatter: n,
                                serializeDate: "function" == typeof t.serializeDate ? t.serializeDate : p.serializeDate,
                                skipNulls: "boolean" == typeof t.skipNulls ? t.skipNulls : p.skipNulls,
                                sort: "function" == typeof t.sort ? t.sort : null,
                                strictNullHandling: "boolean" == typeof t.strictNullHandling ? t.strictNullHandling : p.strictNullHandling
                            };
                        }(e);
                        "function" == typeof l.filter ? i = (0, l.filter)("", i) : u(l.filter) && (r = l.filter);
                        var f, h = [];
                        if ("object" != typeof i || null === i) return "";
                        f = e && e.arrayFormat in s ? e.arrayFormat : e && "indices" in e ? e.indices ? "indices" : "repeat" : "indices";
                        var d = s[f];
                        if (e && "commaRoundTrip" in e && "boolean" != typeof e.commaRoundTrip) throw new TypeError("`commaRoundTrip` must be a boolean, or absent");
                        var y = "comma" === d && e && e.commaRoundTrip;
                        r || (r = Object.keys(i)), l.sort && r.sort(l.sort);
                        for(var g = n(), v = 0; v < r.length; ++v){
                            var b = r[v];
                            l.skipNulls && null === i[b] || c(h, m(i[b], b, d, y, l.strictNullHandling, l.skipNulls, l.encode ? l.encoder : null, l.filter, l.sort, l.allowDots, l.serializeDate, l.format, l.formatter, l.encodeValuesOnly, l.charset, g));
                        }
                        var x = h.join(l.delimiter), w = !0 === l.addQueryPrefix ? "?" : "";
                        return l.charsetSentinel && ("iso-8859-1" === l.charset ? w += "utf8=%26%2310003%3B&" : w += "utf8=%E2%9C%93&"), x.length > 0 ? w + x : "";
                    };
                },
                function(t, e, r) {
                    "use strict";
                    var n = r(44), i = r(150), o = r(152), a = n("%TypeError%"), s = n("%WeakMap%", !0), u = n("%Map%", !0), l = i("WeakMap.prototype.get", !0), c = i("WeakMap.prototype.set", !0), f = i("WeakMap.prototype.has", !0), h = i("Map.prototype.get", !0), p = i("Map.prototype.set", !0), d = i("Map.prototype.has", !0), m = function(t, e) {
                        for(var r, n = t; null !== (r = n.next); n = r)if (r.key === e) return n.next = r.next, r.next = t.next, t.next = r, r;
                    };
                    t.exports = function() {
                        var t, e, r, n = {
                            assert: function(t) {
                                if (!n.has(t)) throw new a("Side channel does not contain " + o(t));
                            },
                            get: function(n) {
                                if (s && n && ("object" == typeof n || "function" == typeof n)) {
                                    if (t) return l(t, n);
                                } else if (u) {
                                    if (e) return h(e, n);
                                } else if (r) return function(t, e) {
                                    var r = m(t, e);
                                    return r && r.value;
                                }(r, n);
                            },
                            has: function(n) {
                                if (s && n && ("object" == typeof n || "function" == typeof n)) {
                                    if (t) return f(t, n);
                                } else if (u) {
                                    if (e) return d(e, n);
                                } else if (r) return function(t, e) {
                                    return !!m(t, e);
                                }(r, n);
                                return !1;
                            },
                            set: function(n, i) {
                                s && n && ("object" == typeof n || "function" == typeof n) ? (t || (t = new s), c(t, n, i)) : u ? (e || (e = new u), p(e, n, i)) : (r || (r = {
                                    key: {},
                                    next: null
                                }), function(t, e, r) {
                                    var n = m(t, e);
                                    n ? n.value = r : t.next = {
                                        key: e,
                                        next: t.next,
                                        value: r
                                    };
                                }(r, n, i));
                            }
                        };
                        return n;
                    };
                },
                function(t, e, r) {
                    "use strict";
                    var n = "undefined" != typeof Symbol && Symbol, i = r(146);
                    t.exports = function() {
                        return "function" == typeof n && "function" == typeof Symbol && "symbol" == typeof n("foo") && "symbol" == typeof Symbol("bar") && i();
                    };
                },
                function(t, e, r) {
                    "use strict";
                    t.exports = function() {
                        if ("function" != typeof Symbol || "function" != typeof Object.getOwnPropertySymbols) return !1;
                        if ("symbol" == typeof Symbol.iterator) return !0;
                        var t = {}, e = Symbol("test"), r = Object(e);
                        if ("string" == typeof e) return !1;
                        if ("[object Symbol]" !== Object.prototype.toString.call(e)) return !1;
                        if ("[object Symbol]" !== Object.prototype.toString.call(r)) return !1;
                        for(e in t[e] = 42, t)return !1;
                        if ("function" == typeof Object.keys && 0 !== Object.keys(t).length) return !1;
                        if ("function" == typeof Object.getOwnPropertyNames && 0 !== Object.getOwnPropertyNames(t).length) return !1;
                        var n = Object.getOwnPropertySymbols(t);
                        if (1 !== n.length || n[0] !== e) return !1;
                        if (!Object.prototype.propertyIsEnumerable.call(t, e)) return !1;
                        if ("function" == typeof Object.getOwnPropertyDescriptor) {
                            var i = Object.getOwnPropertyDescriptor(t, e);
                            if (42 !== i.value || !0 !== i.enumerable) return !1;
                        }
                        return !0;
                    };
                },
                function(t, e, r) {
                    "use strict";
                    var n = {
                        foo: {}
                    }, i = Object;
                    t.exports = function() {
                        return ({
                            __proto__: n
                        }).foo === n.foo && !(({
                            __proto__: null
                        }) instanceof i);
                    };
                },
                function(t, e, r) {
                    "use strict";
                    var n = "Function.prototype.bind called on incompatible ", i = Array.prototype.slice, o = Object.prototype.toString;
                    t.exports = function(t) {
                        var e = this;
                        if ("function" != typeof e || "[object Function]" !== o.call(e)) throw new TypeError(n + e);
                        for(var r, a = i.call(arguments, 1), s = function() {
                            if (this instanceof r) {
                                var n = e.apply(this, a.concat(i.call(arguments)));
                                return Object(n) === n ? n : this;
                            }
                            return e.apply(t, a.concat(i.call(arguments)));
                        }, u = Math.max(0, e.length - a.length), l = [], c = 0; c < u; c++)l.push("$" + c);
                        if (r = Function("binder", "return function (" + l.join(",") + "){ return binder.apply(this,arguments); }")(s), e.prototype) {
                            var f = function() {};
                            f.prototype = e.prototype, r.prototype = new f, f.prototype = null;
                        }
                        return r;
                    };
                },
                function(t, e, r) {
                    "use strict";
                    var n = r(45);
                    t.exports = n.call(Function.call, Object.prototype.hasOwnProperty);
                },
                function(t, e, r) {
                    "use strict";
                    var n = r(44), i = r(151), o = i(n("String.prototype.indexOf"));
                    t.exports = function(t, e) {
                        var r = n(t, !!e);
                        return "function" == typeof r && o(t, ".prototype.") > -1 ? i(r) : r;
                    };
                },
                function(t, e, r) {
                    "use strict";
                    var n = r(45), i = r(44), o = i("%Function.prototype.apply%"), a = i("%Function.prototype.call%"), s = i("%Reflect.apply%", !0) || n.call(a, o), u = i("%Object.getOwnPropertyDescriptor%", !0), l = i("%Object.defineProperty%", !0), c = i("%Math.max%");
                    if (l) try {
                        l({}, "a", {
                            value: 1
                        });
                    } catch (t) {
                        l = null;
                    }
                    t.exports = function(t) {
                        var e = s(n, a, arguments);
                        if (u && l) {
                            var r = u(e, "length");
                            r.configurable && l(e, "length", {
                                value: 1 + c(0, t.length - (arguments.length - 1))
                            });
                        }
                        return e;
                    };
                    var f = function() {
                        return s(n, o, arguments);
                    };
                    l ? l(t.exports, "apply", {
                        value: f
                    }) : t.exports.apply = f;
                },
                function(t, e, r) {
                    var n = "function" == typeof Map && Map.prototype, i = Object.getOwnPropertyDescriptor && n ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null, o = n && i && "function" == typeof i.get ? i.get : null, a = n && Map.prototype.forEach, s = "function" == typeof Set && Set.prototype, u = Object.getOwnPropertyDescriptor && s ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null, l = s && u && "function" == typeof u.get ? u.get : null, c = s && Set.prototype.forEach, f = "function" == typeof WeakMap && WeakMap.prototype ? WeakMap.prototype.has : null, h = "function" == typeof WeakSet && WeakSet.prototype ? WeakSet.prototype.has : null, p = "function" == typeof WeakRef && WeakRef.prototype ? WeakRef.prototype.deref : null, d = Boolean.prototype.valueOf, m = Object.prototype.toString, y = Function.prototype.toString, g = String.prototype.match, v = String.prototype.slice, b = String.prototype.replace, x = String.prototype.toUpperCase, w = String.prototype.toLowerCase, _ = RegExp.prototype.test, A = Array.prototype.concat, E = Array.prototype.join, S = Array.prototype.slice, M = Math.floor, k = "function" == typeof BigInt ? BigInt.prototype.valueOf : null, N = Object.getOwnPropertySymbols, C = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? Symbol.prototype.toString : null, D = "function" == typeof Symbol && "object" == typeof Symbol.iterator, O = "function" == typeof Symbol && Symbol.toStringTag && (Symbol.toStringTag, 1) ? Symbol.toStringTag : null, T = Object.prototype.propertyIsEnumerable, F = ("function" == typeof Reflect ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype ? function(t) {
                        return t.__proto__;
                    } : null);
                    function P(t, e) {
                        if (t === 1 / 0 || t === -1 / 0 || t != t || t && t > -1000 && t < 1e3 || _.call(/e/, e)) return e;
                        var r = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
                        if ("number" == typeof t) {
                            var n = t < 0 ? -M(-t) : M(t);
                            if (n !== t) {
                                var i = String(n), o = v.call(e, i.length + 1);
                                return b.call(i, r, "$&_") + "." + b.call(b.call(o, /([0-9]{3})/g, "$&_"), /_$/, "");
                            }
                        }
                        return b.call(e, r, "$&_");
                    }
                    var I = r(153), B = I.custom, j = z(B) ? B : null;
                    function R(t, e, r) {
                        var n = "double" === (r.quoteStyle || e) ? '"' : "'";
                        return n + t + n;
                    }
                    function L(t) {
                        return b.call(String(t), /"/g, "&quot;");
                    }
                    function q(t) {
                        return !("[object Array]" !== W(t) || O && "object" == typeof t && O in t);
                    }
                    function U(t) {
                        return !("[object RegExp]" !== W(t) || O && "object" == typeof t && O in t);
                    }
                    function z(t) {
                        if (D) return t && "object" == typeof t && t instanceof Symbol;
                        if ("symbol" == typeof t) return !0;
                        if (!t || "object" != typeof t || !C) return !1;
                        try {
                            return C.call(t), !0;
                        } catch (t) {}
                        return !1;
                    }
                    t.exports = function t(e, r, n, i) {
                        var s = r || {};
                        if (H(s, "quoteStyle") && "single" !== s.quoteStyle && "double" !== s.quoteStyle) throw new TypeError('option "quoteStyle" must be "single" or "double"');
                        if (H(s, "maxStringLength") && ("number" == typeof s.maxStringLength ? s.maxStringLength < 0 && s.maxStringLength !== 1 / 0 : null !== s.maxStringLength)) throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
                        var u = !H(s, "customInspect") || s.customInspect;
                        if ("boolean" != typeof u && "symbol" !== u) throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
                        if (H(s, "indent") && null !== s.indent && "	" !== s.indent && !(parseInt(s.indent, 10) === s.indent && s.indent > 0)) throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
                        if (H(s, "numericSeparator") && "boolean" != typeof s.numericSeparator) throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
                        var m = s.numericSeparator;
                        if (void 0 === e) return "undefined";
                        if (null === e) return "null";
                        if ("boolean" == typeof e) return e ? "true" : "false";
                        if ("string" == typeof e) return function t(e, r) {
                            if (e.length > r.maxStringLength) {
                                var n = e.length - r.maxStringLength, i = "... " + n + " more character" + (n > 1 ? "s" : "");
                                return t(v.call(e, 0, r.maxStringLength), r) + i;
                            }
                            return R(b.call(b.call(e, /(['\\])/g, "\\$1"), /[\x00-\x1f]/g, V), "single", r);
                        }(e, s);
                        if ("number" == typeof e) {
                            if (0 === e) return 1 / 0 / e > 0 ? "0" : "-0";
                            var x = String(e);
                            return m ? P(e, x) : x;
                        }
                        if ("bigint" == typeof e) {
                            var _ = String(e) + "n";
                            return m ? P(e, _) : _;
                        }
                        var M = void 0 === s.depth ? 5 : s.depth;
                        if (void 0 === n && (n = 0), n >= M && M > 0 && "object" == typeof e) return q(e) ? "[Array]" : "[Object]";
                        var N = function(t, e) {
                            var r;
                            if ("	" === t.indent) r = "	";
                            else {
                                if (!("number" == typeof t.indent && t.indent > 0)) return null;
                                r = E.call(Array(t.indent + 1), " ");
                            }
                            return {
                                base: r,
                                prev: E.call(Array(e + 1), r)
                            };
                        }(s, n);
                        if (void 0 === i) i = [];
                        else if ($(i, e) >= 0) return "[Circular]";
                        function B(e, r, o) {
                            if (r && (i = S.call(i)).push(r), o) {
                                var a = {
                                    depth: s.depth
                                };
                                return H(s, "quoteStyle") && (a.quoteStyle = s.quoteStyle), t(e, a, n + 1, i);
                            }
                            return t(e, s, n + 1, i);
                        }
                        if ("function" == typeof e && !U(e)) {
                            var G = function(t) {
                                if (t.name) return t.name;
                                var e = g.call(y.call(t), /^function\s*([\w$]+)/);
                                return e ? e[1] : null;
                            }(e), Q = J(e, B);
                            return "[Function" + (G ? ": " + G : " (anonymous)") + "]" + (Q.length > 0 ? " { " + E.call(Q, ", ") + " }" : "");
                        }
                        if (z(e)) {
                            var tt = D ? b.call(String(e), /^(Symbol\(.*\))_[^)]*$/, "$1") : C.call(e);
                            return "object" != typeof e || D ? tt : Z(tt);
                        }
                        if (function(t) {
                            return !(!t || "object" != typeof t) && ("undefined" != typeof HTMLElement && t instanceof HTMLElement || "string" == typeof t.nodeName && "function" == typeof t.getAttribute);
                        }(e)) {
                            for(var et = "<" + w.call(String(e.nodeName)), rt = e.attributes || [], nt = 0; nt < rt.length; nt++)et += " " + rt[nt].name + "=" + R(L(rt[nt].value), "double", s);
                            return et += ">", e.childNodes && e.childNodes.length && (et += "..."), et + "</" + w.call(String(e.nodeName)) + ">";
                        }
                        if (q(e)) {
                            if (0 === e.length) return "[]";
                            var it = J(e, B);
                            return N && !function(t) {
                                for(var e = 0; e < t.length; e++)if ($(t[e], "\n") >= 0) return !1;
                                return !0;
                            }(it) ? "[" + X(it, N) + "]" : "[ " + E.call(it, ", ") + " ]";
                        }
                        if (function(t) {
                            return !("[object Error]" !== W(t) || O && "object" == typeof t && O in t);
                        }(e)) {
                            var ot = J(e, B);
                            return "cause" in Error.prototype || !("cause" in e) || T.call(e, "cause") ? 0 === ot.length ? "[" + String(e) + "]" : "{ [" + String(e) + "] " + E.call(ot, ", ") + " }" : "{ [" + String(e) + "] " + E.call(A.call("[cause]: " + B(e.cause), ot), ", ") + " }";
                        }
                        if ("object" == typeof e && u) {
                            if (j && "function" == typeof e[j] && I) return I(e, {
                                depth: M - n
                            });
                            if ("symbol" !== u && "function" == typeof e.inspect) return e.inspect();
                        }
                        if (function(t) {
                            if (!o || !t || "object" != typeof t) return !1;
                            try {
                                o.call(t);
                                try {
                                    l.call(t);
                                } catch (t) {
                                    return !0;
                                }
                                return t instanceof Map;
                            } catch (t) {}
                            return !1;
                        }(e)) {
                            var at = [];
                            return a && a.call(e, function(t, r) {
                                at.push(B(r, e, !0) + " => " + B(t, e));
                            }), K("Map", o.call(e), at, N);
                        }
                        if (function(t) {
                            if (!l || !t || "object" != typeof t) return !1;
                            try {
                                l.call(t);
                                try {
                                    o.call(t);
                                } catch (t) {
                                    return !0;
                                }
                                return t instanceof Set;
                            } catch (t) {}
                            return !1;
                        }(e)) {
                            var st = [];
                            return c && c.call(e, function(t) {
                                st.push(B(t, e));
                            }), K("Set", l.call(e), st, N);
                        }
                        if (function(t) {
                            if (!f || !t || "object" != typeof t) return !1;
                            try {
                                f.call(t, f);
                                try {
                                    h.call(t, h);
                                } catch (t) {
                                    return !0;
                                }
                                return t instanceof WeakMap;
                            } catch (t) {}
                            return !1;
                        }(e)) return Y("WeakMap");
                        if (function(t) {
                            if (!h || !t || "object" != typeof t) return !1;
                            try {
                                h.call(t, h);
                                try {
                                    f.call(t, f);
                                } catch (t) {
                                    return !0;
                                }
                                return t instanceof WeakSet;
                            } catch (t) {}
                            return !1;
                        }(e)) return Y("WeakSet");
                        if (function(t) {
                            if (!p || !t || "object" != typeof t) return !1;
                            try {
                                return p.call(t), !0;
                            } catch (t) {}
                            return !1;
                        }(e)) return Y("WeakRef");
                        if (function(t) {
                            return !("[object Number]" !== W(t) || O && "object" == typeof t && O in t);
                        }(e)) return Z(B(Number(e)));
                        if (function(t) {
                            if (!t || "object" != typeof t || !k) return !1;
                            try {
                                return k.call(t), !0;
                            } catch (t) {}
                            return !1;
                        }(e)) return Z(B(k.call(e)));
                        if (function(t) {
                            return !("[object Boolean]" !== W(t) || O && "object" == typeof t && O in t);
                        }(e)) return Z(d.call(e));
                        if (function(t) {
                            return !("[object String]" !== W(t) || O && "object" == typeof t && O in t);
                        }(e)) return Z(B(String(e)));
                        if (!function(t) {
                            return !("[object Date]" !== W(t) || O && "object" == typeof t && O in t);
                        }(e) && !U(e)) {
                            var ut = J(e, B), lt = F ? F(e) === Object.prototype : e instanceof Object || e.constructor === Object, ct = e instanceof Object ? "" : "null prototype", ft = !lt && O && Object(e) === e && O in e ? v.call(W(e), 8, -1) : ct ? "Object" : "", ht = (lt || "function" != typeof e.constructor ? "" : e.constructor.name ? e.constructor.name + " " : "") + (ft || ct ? "[" + E.call(A.call([], ft || [], ct || []), ": ") + "] " : "");
                            return 0 === ut.length ? ht + "{}" : N ? ht + "{" + X(ut, N) + "}" : ht + "{ " + E.call(ut, ", ") + " }";
                        }
                        return String(e);
                    };
                    var G = Object.prototype.hasOwnProperty || function(t) {
                        return t in this;
                    };
                    function H(t, e) {
                        return G.call(t, e);
                    }
                    function W(t) {
                        return m.call(t);
                    }
                    function $(t, e) {
                        if (t.indexOf) return t.indexOf(e);
                        for(var r = 0, n = t.length; r < n; r++)if (t[r] === e) return r;
                        return -1;
                    }
                    function V(t) {
                        var e = t.charCodeAt(0), r = {
                            8: "b",
                            9: "t",
                            10: "n",
                            12: "f",
                            13: "r"
                        }[e];
                        return r ? "\\" + r : "\\x" + (e < 16 ? "0" : "") + x.call(e.toString(16));
                    }
                    function Z(t) {
                        return "Object(" + t + ")";
                    }
                    function Y(t) {
                        return t + " { ? }";
                    }
                    function K(t, e, r, n) {
                        return t + " (" + e + ") {" + (n ? X(r, n) : E.call(r, ", ")) + "}";
                    }
                    function X(t, e) {
                        if (0 === t.length) return "";
                        var r = "\n" + e.prev + e.base;
                        return r + E.call(t, "," + r) + "\n" + e.prev;
                    }
                    function J(t, e) {
                        var r = q(t), n = [];
                        if (r) {
                            n.length = t.length;
                            for(var i = 0; i < t.length; i++)n[i] = H(t, i) ? e(t[i], t) : "";
                        }
                        var o, a = "function" == typeof N ? N(t) : [];
                        if (D) {
                            o = {};
                            for(var s = 0; s < a.length; s++)o["$" + a[s]] = a[s];
                        }
                        for(var u in t)H(t, u) && (r && String(Number(u)) === u && u < t.length || D && o["$" + u] instanceof Symbol || (_.call(/[^\w$]/, u) ? n.push(e(u, t) + ": " + e(t[u], t)) : n.push(u + ": " + e(t[u], t))));
                        if ("function" == typeof N) for(var l = 0; l < a.length; l++)T.call(t, a[l]) && n.push("[" + e(a[l]) + "]: " + e(t[a[l]], t));
                        return n;
                    }
                },
                function(t, e) {},
                function(t, e, r) {
                    "use strict";
                    var n = r(71), i = Object.prototype.hasOwnProperty, o = Array.isArray, a = {
                        allowDots: !1,
                        allowPrototypes: !1,
                        allowSparse: !1,
                        arrayLimit: 20,
                        charset: "utf-8",
                        charsetSentinel: !1,
                        comma: !1,
                        decoder: n.decode,
                        delimiter: "&",
                        depth: 5,
                        ignoreQueryPrefix: !1,
                        interpretNumericEntities: !1,
                        parameterLimit: 1e3,
                        parseArrays: !0,
                        plainObjects: !1,
                        strictNullHandling: !1
                    }, s = function(t) {
                        return t.replace(/&#(\d+);/g, function(t, e) {
                            return String.fromCharCode(parseInt(e, 10));
                        });
                    }, u = function(t, e) {
                        return t && "string" == typeof t && e.comma && t.indexOf(",") > -1 ? t.split(",") : t;
                    }, l = function(t, e, r, n) {
                        if (t) {
                            var o = r.allowDots ? t.replace(/\.([^.[]+)/g, "[$1]") : t, a = /(\[[^[\]]*])/g, s = r.depth > 0 && /(\[[^[\]]*])/.exec(o), l = s ? o.slice(0, s.index) : o, c = [];
                            if (l) {
                                if (!r.plainObjects && i.call(Object.prototype, l) && !r.allowPrototypes) return;
                                c.push(l);
                            }
                            for(var f = 0; r.depth > 0 && null !== (s = a.exec(o)) && f < r.depth;){
                                if (f += 1, !r.plainObjects && i.call(Object.prototype, s[1].slice(1, -1)) && !r.allowPrototypes) return;
                                c.push(s[1]);
                            }
                            return s && c.push("[" + o.slice(s.index) + "]"), function(t, e, r, n) {
                                for(var i = n ? e : u(e, r), o = t.length - 1; o >= 0; --o){
                                    var a, s = t[o];
                                    if ("[]" === s && r.parseArrays) a = [].concat(i);
                                    else {
                                        a = r.plainObjects ? Object.create(null) : {};
                                        var l = "[" === s.charAt(0) && "]" === s.charAt(s.length - 1) ? s.slice(1, -1) : s, c = parseInt(l, 10);
                                        r.parseArrays || "" !== l ? !isNaN(c) && s !== l && String(c) === l && c >= 0 && r.parseArrays && c <= r.arrayLimit ? (a = [])[c] = i : "__proto__" !== l && (a[l] = i) : a = {
                                            0: i
                                        };
                                    }
                                    i = a;
                                }
                                return i;
                            }(c, e, r, n);
                        }
                    };
                    t.exports = function(t, e) {
                        var r = function(t) {
                            if (!t) return a;
                            if (null !== t.decoder && void 0 !== t.decoder && "function" != typeof t.decoder) throw new TypeError("Decoder has to be a function.");
                            if (void 0 !== t.charset && "utf-8" !== t.charset && "iso-8859-1" !== t.charset) throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
                            var e = void 0 === t.charset ? a.charset : t.charset;
                            return {
                                allowDots: void 0 === t.allowDots ? a.allowDots : !!t.allowDots,
                                allowPrototypes: "boolean" == typeof t.allowPrototypes ? t.allowPrototypes : a.allowPrototypes,
                                allowSparse: "boolean" == typeof t.allowSparse ? t.allowSparse : a.allowSparse,
                                arrayLimit: "number" == typeof t.arrayLimit ? t.arrayLimit : a.arrayLimit,
                                charset: e,
                                charsetSentinel: "boolean" == typeof t.charsetSentinel ? t.charsetSentinel : a.charsetSentinel,
                                comma: "boolean" == typeof t.comma ? t.comma : a.comma,
                                decoder: "function" == typeof t.decoder ? t.decoder : a.decoder,
                                delimiter: "string" == typeof t.delimiter || n.isRegExp(t.delimiter) ? t.delimiter : a.delimiter,
                                depth: "number" == typeof t.depth || !1 === t.depth ? +t.depth : a.depth,
                                ignoreQueryPrefix: !0 === t.ignoreQueryPrefix,
                                interpretNumericEntities: "boolean" == typeof t.interpretNumericEntities ? t.interpretNumericEntities : a.interpretNumericEntities,
                                parameterLimit: "number" == typeof t.parameterLimit ? t.parameterLimit : a.parameterLimit,
                                parseArrays: !1 !== t.parseArrays,
                                plainObjects: "boolean" == typeof t.plainObjects ? t.plainObjects : a.plainObjects,
                                strictNullHandling: "boolean" == typeof t.strictNullHandling ? t.strictNullHandling : a.strictNullHandling
                            };
                        }(e);
                        if ("" === t || null == t) return r.plainObjects ? Object.create(null) : {};
                        for(var c = "string" == typeof t ? function(t, e) {
                            var r, l = {
                                __proto__: null
                            }, c = e.ignoreQueryPrefix ? t.replace(/^\?/, "") : t, f = e.parameterLimit === 1 / 0 ? void 0 : e.parameterLimit, h = c.split(e.delimiter, f), p = -1, d = e.charset;
                            if (e.charsetSentinel) for(r = 0; r < h.length; ++r)0 === h[r].indexOf("utf8=") && ("utf8=%E2%9C%93" === h[r] ? d = "utf-8" : "utf8=%26%2310003%3B" === h[r] && (d = "iso-8859-1"), p = r, r = h.length);
                            for(r = 0; r < h.length; ++r)if (r !== p) {
                                var m, y, g = h[r], v = g.indexOf("]="), b = -1 === v ? g.indexOf("=") : v + 1;
                                -1 === b ? (m = e.decoder(g, a.decoder, d, "key"), y = e.strictNullHandling ? null : "") : (m = e.decoder(g.slice(0, b), a.decoder, d, "key"), y = n.maybeMap(u(g.slice(b + 1), e), function(t) {
                                    return e.decoder(t, a.decoder, d, "value");
                                })), y && e.interpretNumericEntities && "iso-8859-1" === d && (y = s(y)), g.indexOf("[]=") > -1 && (y = o(y) ? [
                                    y
                                ] : y), i.call(l, m) ? l[m] = n.combine(l[m], y) : l[m] = y;
                            }
                            return l;
                        }(t, r) : t, f = r.plainObjects ? Object.create(null) : {}, h = Object.keys(c), p = 0; p < h.length; ++p){
                            var d = h[p], m = l(d, c[d], r, "string" == typeof t);
                            f = n.merge(f, m, r);
                        }
                        return !0 === r.allowSparse ? f : n.compact(f);
                    };
                },
                function(t, e) {
                    t.exports = {
                        getPalette: (t, { debug: e = !1 } = {
                            debug: !1
                        })=>{
                            e && console.log("starting getPalette with image", t);
                            const { fileDirectory: r } = t, { BitsPerSample: n, ColorMap: i, ImageLength: o, ImageWidth: a, PhotometricInterpretation: s, SampleFormat: u, SamplesPerPixel: l } = r;
                            if (!i) throw new Error("[geotiff-palette]: the image does not contain a color map, so we can't make a palette.");
                            const c = Math.pow(2, n);
                            e && console.log("[geotiff-palette]: count:", c);
                            const f = i.length / 3;
                            if (e && console.log("[geotiff-palette]: bandSize:", f), f !== c) throw new Error("[geotiff-palette]: can't handle situations where the color map has more or less values than the number of possible values in a raster");
                            const h = f, p = h + f, d = [];
                            for(let t = 0; t < c; t++)d.push([
                                Math.floor(i[t] / 256),
                                Math.floor(i[h + t] / 256),
                                Math.floor(i[p + t] / 256),
                                255
                            ]);
                            return e && console.log("[geotiff-palette]: result is ", d), d;
                        }
                    };
                },
                function(t, e, r) {
                    var n, i = Object.defineProperty, o = Object.getOwnPropertySymbols, a = Object.prototype.hasOwnProperty, s = Object.prototype.propertyIsEnumerable, u = (t, e, r)=>e in t ? i(t, e, {
                            enumerable: !0,
                            configurable: !0,
                            writable: !0,
                            value: r
                        }) : t[e] = r, l = (t, e)=>i(t, "name", {
                            value: e,
                            configurable: !0
                        });
                    const c = r(157), f = r(192), h = r(194), p = l((t)=>new Array(t).fill(0).map((t, e)=>e), "range");
                    function d(t, e = {}) {
                        var r = e, { bands: n, height: i, precise: l = !1, stats: d, width: m, layout: y } = r, g = ((t, e)=>{
                            var r = {};
                            for(var n in t)a.call(t, n) && e.indexOf(n) < 0 && (r[n] = t[n]);
                            if (null != t && o) for (var n of o(t))e.indexOf(n) < 0 && s.call(t, n) && (r[n] = t[n]);
                            return r;
                        })(r, [
                            "bands",
                            "height",
                            "precise",
                            "stats",
                            "width",
                            "layout"
                        ]);
                        if ("function" == typeof t.then) throw new Error("[calc-image-stats] you passed in a promise as the data values.  please resolve the promise first before calling calcImageStats");
                        const v = f({
                            bands: n,
                            data: t,
                            height: i,
                            layout: y,
                            width: m
                        });
                        null != n || (n = v.bands), null != i || (i = v.height), null != y || (y = v.layout), null != m || (m = v.width);
                        const b = p(n).map((e)=>{
                            let r;
                            const f = ((t, e)=>{
                                for(var r in e || (e = {}))a.call(e, r) && u(t, r, e[r]);
                                if (o) for (var r of o(e))s.call(e, r) && u(t, r, e[r]);
                                return t;
                            })({
                                precise: l,
                                stats: d
                            }, g);
                            if ([
                                "[band][row,column]",
                                "[band][column,row]"
                            ].includes(y)) r = t[e];
                            else if ([
                                "[band][row][column]",
                                "[band][column][row]"
                            ].includes(y)) r = t[e], f.chunked = !0;
                            else if (1 === n && [
                                "[band,row,column]",
                                "[row,column,band]",
                                "[column,band,row]",
                                "[column,row,band]"
                            ].includes(y)) r = t;
                            else {
                                const o = {
                                    band: [
                                        e,
                                        e
                                    ]
                                }, a = {
                                    band: n,
                                    column: m,
                                    row: i
                                };
                                r = h.iterClip({
                                    data: t,
                                    layout: y,
                                    rect: o,
                                    sizes: a
                                });
                            }
                            return c(r, f);
                        });
                        return {
                            depth: n,
                            height: i,
                            width: m,
                            bands: b
                        };
                    }
                    l(d, "calcImageStats"), void 0 !== (n = (function() {
                        return d;
                    }).call(e, r, e, t)) && (t.exports = n), t.exports = d, t.exports.default = d, t.exports.calcImageStats = d, "object" == typeof self && (self.calcImageStats = d), "object" == typeof window && (self.calcImageStats = d);
                },
                function(t, e, r) {
                    var n;
                    const { getOrCreateIterator: i } = r(72), { add: o, compare: a, divide: s, mean: u, multiply: l, pow: c, sort: f, subtract: h, sum: p } = r(158), d = r(181);
                    function m(t, { async: e = !1, chunked: r = !1, noData: n, filter: p, calcCount: m = !0, calcHistogram: y = !0, calcInvalid: g = !0, calcMax: v = !0, calcMean: b = !0, calcMedian: x = !0, calcMin: w = !0, calcMode: _ = !0, calcModes: A = !0, calcProduct: E = !0, calcRange: S = !0, calcStd: M = !0, calcSum: k = !0, calcValid: N = !0, calcVariance: C = !0, calcUniques: D = !0, precise: O = !1, precise_max_decimal_digits: T = 100, stats: F } = {
                        debugLevel: 0
                    }) {
                        F && (F.forEach((t)=>{
                            [
                                "count",
                                "histogram",
                                "invalid",
                                "max",
                                "mean",
                                "median",
                                "min",
                                "mode",
                                "modes",
                                "product",
                                "range",
                                "sum",
                                "std",
                                "valid",
                                "variance",
                                "uniques"
                            ].includes(t) || console.warn(`[calc-stats] skipping unknown stat "${t}"`);
                        }), m = F.includes("count"), y = F.includes("histogram"), g = F.includes("invalid"), v = F.includes("max"), b = F.includes("mean"), x = F.includes("median"), w = F.includes("min"), _ = F.includes("mode"), A = F.includes("modes"), E = F.includes("product"), S = F.includes("range"), M = F.includes("std"), k = F.includes("sum"), N = F.includes("valid"), C = F.includes("variance"), D = F.includes("uniques"));
                        const P = i(t);
                        let I, B, j, R = y || x || _ || A || C || M || D, L = m || b || x || E || N || C || M || "function" == typeof p, q = m || g || "function" == typeof p, U = k || b || C || M, z = w || S, G = v || S, H = E, W = 0, $ = 0, V = 0, Z = O ? "0" : 0;
                        const Y = {};
                        let K, X;
                        K = O ? (t)=>{
                            t = t.toString(), L && W++, !z || void 0 !== I && "<" !== a(t, I) || (I = t), !G || void 0 !== B && ">" !== a(t, B) || (B = t), H && (j = 1 === W ? t : l(j, t)), U && (Z = o(Z, t)), R && (t in Y ? Y[t].ct++ : Y[t] = {
                                n: t.toString(),
                                ct: 1
                            });
                        } : (t)=>{
                            L && W++, z && (void 0 === I || t < I) && (I = t), G && (void 0 === B || t > B) && (B = t), H && (j = 1 === W ? t : j * t), U && (Z += t), R && (t in Y ? Y[t].ct++ : Y[t] = {
                                n: t,
                                ct: 1
                            });
                        }, X = "number" == typeof n && "function" == typeof p ? (t)=>{
                            V++, "number" != typeof t || isNaN(t) || t === n || !0 !== p({
                                valid: W,
                                index: V,
                                value: t
                            }) ? q && $++ : K(t);
                        } : "number" == typeof n ? (t)=>{
                            "number" != typeof t || isNaN(t) || t === n ? q && $++ : K(t);
                        } : "function" == typeof p ? (t)=>{
                            V++, "number" != typeof t || isNaN(t) || !0 !== p({
                                valid: W,
                                index: V,
                                value: t
                            }) ? q && $++ : K(t);
                        } : (t)=>{
                            "number" != typeof t || isNaN(t) ? q && $++ : K(t);
                        };
                        const J = ()=>{
                            const t = {};
                            if (m && (t.count = O ? o($.toString(), W.toString()) : $ + W), N && (t.valid = O ? W.toString() : W), g && (t.invalid = O ? $.toString() : $), x && (t.median = d.calculate({
                                counts: Y,
                                precise: O,
                                total: W
                            })), w && (t.min = I), v && (t.max = B), E && (t.product = j), k && (t.sum = Z), S && (t.range = O ? h(B.toString(), I.toString()) : B - I), b || C || M) {
                                const e = O ? s(Z, W.toString(), {
                                    max_decimal_digits: T
                                }) : Z / W;
                                if (b && (t.mean = e), C || M) {
                                    const r = (({ count: t, histogram: e, mean_value: r, precise: n = !1 })=>{
                                        if (n) {
                                            r = r.toString();
                                            const n = Object.values(e).reduce((t, { n: e, ct: n })=>{
                                                const i = h(e.toString(), r);
                                                return o(t, l(n.toString(), c(i, "2")));
                                            }, "0");
                                            return s(n, t.toString());
                                        }
                                        return Object.values(e).reduce((t, { n: e, ct: n })=>t + n * Math.pow(e - r, 2), 0) / t;
                                    })({
                                        count: W,
                                        histogram: Y,
                                        mean_value: e,
                                        precise: O
                                    });
                                    C && (t.variance = r), M && (t.std = O ? Math.sqrt(Number(r)).toString() : Math.sqrt(r));
                                }
                            }
                            if (y && (O && Object.values(Y).forEach((t)=>{
                                t.ct = t.ct.toString();
                            }), t.histogram = Y), _ || A) {
                                let e = 0, r = [];
                                for(let t in Y){
                                    const { n: n, ct: i } = Y[t];
                                    i === e ? r.push(O ? n.toString() : n) : i > e && (e = i, r = [
                                        O ? n.toString() : n
                                    ]);
                                }
                                A && (t.modes = r), _ && (t.mode = O ? u(r) : r.reduce((t, e)=>t + e, 0) / r.length);
                            }
                            return D && (t.uniques = O ? f(Object.keys(Y)) : Object.values(Y).map(({ n: t })=>t).sort((t, e)=>t - e)), t;
                        };
                        if (r) {
                            if (e) return (async ()=>{
                                for await (let t of P)for (let e of t)X(e);
                                return J();
                            })();
                            for (let t of P)for (let e of t)X(e);
                            return J();
                        }
                        if (e) return (async ()=>{
                            for await (let t of P)X(t);
                            return J();
                        })();
                        for (let t of P)X(t);
                        return J();
                    }
                    void 0 === (n = (function() {
                        return m;
                    }).call(e, r, e, t)) || (t.exports = n), t.exports = m, t.exports.default = m, t.exports.calcStats = m, "object" == typeof self && (self.calcStats = m), "object" == typeof window && (window.calcStats = m);
                },
                function(t, e, r) {
                    "use strict";
                    var n;
                    const i = r(4), o = r(6), a = r(159), s = r(76), u = r(0), l = r(34), c = r(5), f = r(161), h = r(163), p = r(51), d = r(84), m = r(167), y = r(168), g = r(1), v = r(88), b = r(89), x = r(73), w = r(75), _ = r(169), A = r(170), E = r(77), S = r(171), M = r(172), k = r(15), N = r(16), C = r(90), D = r(91), O = r(11), T = r(9), F = r(32), P = r(48), I = r(31), B = r(173), j = {
                        absolute: i,
                        add: o,
                        binomial_coefficient: a,
                        ceil: s,
                        clean: u,
                        compare: l,
                        compare_positive: c,
                        constants: f,
                        cosine_radians: h,
                        count_decimal_digits: p,
                        count_integer_digits: d,
                        cube: m,
                        cube_root: y,
                        divide: g,
                        eulers_number: v,
                        exp: b,
                        expand: x,
                        factorial: w,
                        flip_sign: _,
                        floor: A,
                        fraction: E,
                        hypotenuse: S,
                        is_infinity: k,
                        is_integer: N,
                        is_factorial: M,
                        is_negative_infinity: C,
                        is_positive_infinity: D,
                        is_zero: O,
                        long_addition: T,
                        long_division: F,
                        long_multiplication: P,
                        long_subtraction: I,
                        mean: r(174),
                        max: B,
                        min: r(86),
                        multiply: r(53),
                        multiply_array: r(79),
                        multiply_range: r(47),
                        nilakantha: r(175),
                        ols: r(176),
                        pow: r(35),
                        pow_positive: r(54),
                        primes: r(87),
                        reciprocal: r(81),
                        remainder: r(177),
                        root: r(37),
                        root_integer_digits: r(83),
                        round: r(36),
                        round_last_decimal: r(49),
                        sign: r(22),
                        sign_nonzero: r(50),
                        simplify_fraction: r(85),
                        sine_radians: r(178),
                        softmax: r(179),
                        sort: r(180),
                        square: r(23),
                        square_root: r(92),
                        subtract: r(33),
                        sum: r(55),
                        truncate: r(93)
                    };
                    void 0 === (n = (function() {
                        return j;
                    }).call(e, r, e, t)) || (t.exports = n), t.exports = j, t.exports.default = j, "object" == typeof window && (window.preciso = j), "object" == typeof self && (self.preciso = j);
                },
                function(t, e, r) {
                    "use strict";
                    const n = r(0), i = r(5), o = r(75), a = r(9), s = r(31), u = r(32), l = r(47);
                    function c(t, e) {
                        switch(t = n(t), e = n(e), i(t, e)){
                            case "=":
                                return "1";
                            case ">":
                                {
                                    const r = s(t, e), n = l(a(e, "1"), t), i = o(r);
                                    return u(n, i);
                                }
                            case "<":
                                throw new Error("[binominal_coefficient] unsupported");
                        }
                    }
                    t.exports = c, t.exports.default = c;
                },
                function(t, e, r) {
                    "use strict";
                    function n(t) {
                        return t.substring(0, t.indexOf("."));
                    }
                    t.exports = n, t.exports.default = n;
                },
                function(t, e, r) {
                    "use strict";
                    const { MAX_SAFE_INTEGER: n } = r(74), { MAX_SAFE_INTEGER_LENGTH: i } = r(30), { PI: o } = r(162);
                    t.exports = {
                        MAX_SAFE_INTEGER: n,
                        MAX_SAFE_INTEGER_LENGTH: i,
                        PI: o
                    };
                },
                function(t, e) {
                    t.exports = {
                        PI_100: "3.1415926535897932384626433832795028841971693993751058209749445923078164062862089986280348253421170679"
                    };
                },
                function(t, e, r) {
                    "use strict";
                    const n = r(6), i = r(11), o = r(23), a = r(17), s = r(1);
                    function u(t, { steps: e = 100, max_decimal_digits: r = 100 } = {}) {
                        if (i(t)) return "0";
                        let u, l = "-", c = "1", f = e, h = o(t), p = "1", d = "1", m = "0";
                        for(let t = 0; t < f; t++){
                            u = n(m, "1"), m = n(u, "1"), p = a([
                                p,
                                h
                            ], {
                                max_decimal_digits: r
                            }), d = a([
                                d,
                                u,
                                m
                            ], {
                                max_decimal_digits: r
                            });
                            const t = s(p, d, {
                                max_decimal_digits: r
                            });
                            c = n(c, l + t), l = "-" === l ? "+" : "-";
                        }
                        return c;
                    }
                    t.exports = u, t.exports.default = u;
                },
                function(t, e, r) {
                    "use strict";
                    const n = r(0), i = r(51), o = r(4), a = r(80), s = r(49), u = [
                        "5",
                        "6",
                        "7",
                        "8",
                        "9"
                    ];
                    function l(t, { digits: e = 0 } = {
                        digits: 0
                    }) {
                        const r = t = n(t), l = a(t) ? "-" : "", c = (t = o(t)).indexOf(".");
                        if (-1 === c) return r;
                        if (i(t) <= e) return r;
                        const f = t[c + e + 1];
                        if (u.includes(f)) {
                            const r = t.substring(0, c + e + 2);
                            return l + s(r);
                        }
                        return 0 === e ? l + t.substring(0, c) : l + t.substring(0, c + e + 1);
                    }
                    t.exports = l, t.exports.default = l;
                },
                function(t, e, r) {
                    "use strict";
                    function n(t) {
                        return t.includes("/");
                    }
                    t.exports = n, t.exports.default = n;
                },
                function(t, e, r) {
                    "use strict";
                    function n(t) {
                        return t.split("/");
                    }
                    t.exports = n, t.exports.default = n;
                },
                function(t, e, r) {
                    "use strict";
                    const n = r(35);
                    function i(t, e) {
                        return n(t, "3", e);
                    }
                    t.exports = i, t.exports.default = i;
                },
                function(t, e, r) {
                    "use strict";
                    const n = r(37);
                    function i(t, e) {
                        return n(t, "3", e);
                    }
                    t.exports = i, t.exports.default = i;
                },
                function(t, e, r) {
                    "use strict";
                    const n = r(4), i = r(0), o = r(22);
                    function a(t) {
                        t = i(t);
                        const e = o(t);
                        return "" === e ? t : "-" === e ? n(t) : "+" === e ? "-" + t : sum;
                    }
                    t.exports = a, t.exports.default = a;
                },
                function(t, e, r) {
                    "use strict";
                    const n = r(4), i = r(0), o = r(9), a = r(22);
                    function s(t) {
                        if (-1 === (t = i(t)).indexOf(".")) return t;
                        const e = a(t);
                        return t = n(t).split(".")[0], "+" === e ? t : "-" === e ? "0" === t || "" === t ? "-1" : "-" + o(t, "1") : void 0;
                    }
                    t.exports = s, t.exports.default = s;
                },
                function(t, e, r) {
                    "use strict";
                    const n = r(23), i = r(92), o = r(55);
                    function a() {
                        const t = Array.from(arguments), e = "object" == typeof t[t.length - 1] ? t[t.length - 1] : void 0, r = Array.isArray(t[0]) ? t[0] : e ? t.slice(0, t.length - 1) : t, a = r.map((t)=>n(t));
                        return i(o(a), e);
                    }
                    t.exports = a, t.exports.default = a;
                },
                function(t, e, r) {
                    "use strict";
                    function n(t) {
                        return !!t.match(/^\d+!$/i);
                    }
                    t.exports = n, t.exports.default = n;
                },
                function(t, e, r) {
                    "use strict";
                    const n = r(0), i = r(34);
                    function o(t) {
                        "string" == typeof t && (t = Array.prototype.slice.call(arguments));
                        let e = n(t[0]);
                        const r = t.length;
                        for(let n = 1; n < r; n++){
                            const r = t[n];
                            ">" === i(r, e) && (e = r);
                        }
                        return e;
                    }
                    t.exports = o, t.exports.default = o;
                },
                function(t, e, r) {
                    "use strict";
                    const n = r(6), i = r(1);
                    function o(t, e) {
                        let r = 0, o = "0";
                        for (let e of t)r++, o = n(o, e);
                        return i(o, r.toString(), e);
                    }
                    t.exports = o, t.exports.default = o;
                },
                function(t, e, r) {
                    "use strict";
                    const n = r(6), i = r(9), o = r(1), a = r(17);
                    function s(t = 100, { divide_options: e } = {}) {
                        let r = "+", s = "3", u = "2", l = "3", c = "4";
                        for(let f = 1; f < t; f++){
                            const t = a([
                                u,
                                l,
                                c
                            ]), f = r + o("4", t, e);
                            s = n(s, f), r = "-" === r ? "+" : "-", u = c, l = i(c, "1"), c = i(l, "1");
                        }
                        return s;
                    }
                    t.exports = s, t.exports.default = s;
                },
                function(t, e, r) {
                    "use strict";
                    const n = r(6), i = r(1), o = r(17), a = r(36), s = r(33), u = r(23);
                    function l(t, e) {
                        const r = t.length;
                        let l = "0", c = "0", f = "0", h = "0";
                        if (0 === r) throw Error("[preciso] zero points passed to linear_regression");
                        for(let e = 0; e < r; e++){
                            const [r, i] = t[e];
                            l = n(l, r), c = n(c, u(r)), f = n(f, i), h = n(h, u(i));
                        }
                        const p = r.toString(), d = i(l, p), m = i(f, p);
                        let y = "0", g = "0";
                        for(let e = 0; e < r; e++){
                            const [r, i] = t[e], a = s(r, d), l = s(i, m), c = o([
                                a,
                                l
                            ]);
                            y = n(y, c);
                            const f = u(a);
                            g = n(g, f);
                        }
                        let v = i(y, g), b = s(m, o(v, d));
                        return e && "number" == typeof e.max_decimal_digits && (v = a(v, {
                            digits: e.max_decimal_digits
                        }), b = a(b, {
                            digits: e.max_decimal_digits
                        })), {
                            m: v,
                            b: b
                        };
                    }
                    t.exports = l, t.exports.default = l;
                },
                function(t, e, r) {
                    "use strict";
                    const n = r(4), i = r(0), o = r(5), a = r(32), s = r(53), u = r(33), l = r(93);
                    function c(t, e) {
                        t = i(t), e = i(e);
                        const r = "-" === t[0] ? "-" : "";
                        t = n(t), e = n(e);
                        const c = o(t, e);
                        if ("=" === c) return "0";
                        if ("<" === c) return "." === t[0] && (t = "0" + t), r + t;
                        const f = a(t, e, {
                            max_decimal_places: 0
                        }), h = l(f), p = s(e, h);
                        return r + u(t, p);
                    }
                    t.exports = c, t.exports.default = c;
                },
                function(t, e, r) {
                    "use strict";
                    const n = r(6), i = r(11), o = r(23), a = r(17), s = r(1);
                    function u(t, { steps: e = 100, max_decimal_digits: r = 100 } = {}) {
                        if (i(t)) return "0";
                        let u, l = "-", c = t, f = e, h = o(t), p = t, d = "1", m = "1";
                        for(let t = 0; t < f; t++){
                            u = n(m, "1"), m = n(u, "1"), p = a([
                                p,
                                h
                            ], {
                                max_decimal_digits: r
                            }), d = a([
                                d,
                                u,
                                m
                            ], {
                                max_decimal_digits: r
                            });
                            const t = s(p, d, {
                                max_decimal_digits: r
                            });
                            c = n(c, l + t), l = "-" === l ? "+" : "-";
                        }
                        return c;
                    }
                    t.exports = u, t.exports.default = u;
                },
                function(t, e, r) {
                    "use strict";
                    const n = r(1), i = r(89), o = r(55);
                    function a(t, { max_decimal_digits: e }) {
                        t = t.map((t)=>i(t, {
                                max_decimal_digits: e
                            }));
                        const r = o(t);
                        return t.map((t)=>n(t, r, {
                                max_decimal_digits: e,
                                ellipsis: !1
                            }));
                    }
                    t.exports = a, t.exports.default = a;
                },
                function(t, e, r) {
                    "use strict";
                    const n = r(34);
                    function i(t, { direction: e = "ascending" } = {
                        direction: "ascending"
                    }) {
                        const r = "desc" === e || "descending" === e ? "<" : ">";
                        return t.sort((t, e)=>n(t, e) === r ? 1 : -1);
                    }
                    t.exports = i, t.exports.default = i;
                },
                function(t, e, r) {
                    var n;
                    const i = r(182), o = r(191);
                    function a({ counts: t, nums: e, no_data: r, precise: n, threshold: a = 50, total: s }) {
                        return void 0 !== t || void 0 !== s || e.length > a ? i({
                            counts: t,
                            no_data: r,
                            nums: e,
                            precise: n,
                            total: s
                        }) : o({
                            no_data: r,
                            nums: e,
                            precise: n
                        });
                    }
                    const s = {
                        calculate: a
                    };
                    void 0 === (n = (function() {
                        return s;
                    }).call(e, r, e, t)) || (t.exports = n), t.exports = s, t.exports.default = {
                        calculate: a
                    }, "object" == typeof window && (window.mediana = s), "object" == typeof self && (self.mediana = s);
                },
                function(t, e, r) {
                    const n = r(183), i = r(94);
                    function o({ counts: t, nums: e, no_data: r, precise: o = !1, total: a }) {
                        void 0 !== t && void 0 !== a || ({ counts: t, total: a } = n({
                            nums: e,
                            no_data: r
                        }));
                        const s = Object.values(t).sort((t, e)=>t.n - e.n), u = a / 2, l = s.length;
                        if (0 !== l) {
                            if (1 === l) return o ? s[0].n.toString() : s[0].n;
                            {
                                let t = 0;
                                if (a % 2 == 0) for(let e = 0; e < l; e++){
                                    const { n: r, ct: n } = s[e];
                                    if (t += n, t > u) return t - n === u ? i(s[e - 1].n, r, {
                                        precise: o
                                    }) : o ? r.toString() : r;
                                }
                                else for(let e = 0; e < l; e++){
                                    const { n: r, ct: n } = s[e];
                                    if (t += n, t > u) return o ? r.toString() : r;
                                }
                            }
                        }
                    }
                    t.exports = o, t.exports.default = o;
                },
                function(t, e) {
                    function r({ nums: t, no_data: e }) {
                        let r = t.length;
                        const n = {};
                        let i = 0;
                        if (void 0 !== e) for(let o = 0; o < r; o++){
                            const r = t[o];
                            r !== e && (i++, r in n ? n[r].ct++ : n[r] = {
                                n: r,
                                ct: 1
                            });
                        }
                        else for(let e = 0; e < r; e++){
                            const r = t[e];
                            i++, r in n ? n[r].ct++ : n[r] = {
                                n: r,
                                ct: 1
                            };
                        }
                        return {
                            counts: n,
                            total: i
                        };
                    }
                    t.exports = r, t.exports.default = r;
                },
                function(t, e) {
                    function r(t) {
                        "+" === t[0] && (t = t.substring(1));
                        const e = "-" === t[0] ? "-" : "";
                        "-" === e && (t = t.substring(1));
                        const r = t.indexOf("e");
                        if (-1 === r) return e + t;
                        let n = t.indexOf(".");
                        -1 === n && (n = r);
                        const i = Number(t.substring(r + 1)), o = t.substring(0, r).replace(".", ""), a = n + i, s = o.length;
                        if (a >= s) {
                            const t = a - s;
                            let r = o;
                            for(let e = 0; e < t; e++)r += "0";
                            return e + r;
                        }
                        if (a < 0) {
                            result = "0.";
                            for(let t = 0; t > a; t--)result += "0";
                            return result += o, e + result;
                        }
                        return e + o.substring(0, a) + "." + o.substring(a);
                    }
                    t.exports = r, t.exports.default = r;
                },
                function(t, e, r) {
                    const n = r(98), i = r(18), o = r(186);
                    function a(t, e, r) {
                        if (t = i(t), "0" === (e = i(e))) throw new Error("[preciso] division by zero");
                        if ("" === t || "0" === t) return "0";
                        const a = "-" !== t[0], s = "-" !== e[0], u = a !== s ? "-" : "";
                        return a || (t = n(t)), s || (e = n(e)), u + o(t, e, r);
                    }
                    t.exports = a, t.exports.default = a;
                },
                function(t, e, r) {
                    const n = r(38), i = r(95), o = (r(187), r(189)), a = r(190);
                    t.exports = function(t, e, { max_decimal_digits: r = 100, ellipsis: s = !1 } = {}) {
                        "0" === t[0] && (t = t.substring(1)), "0" === e[0] && (e = e.substring(1));
                        const u = t.indexOf("."), l = e.indexOf("."), c = -1 === u ? t.length : u, f = -1 === l ? 0 : e.length - 1 - l;
                        let h = !1;
                        t = t.replace(/\./, ""), e = e.replace(/\./, "");
                        const p = t.length;
                        let d, m = "", y = "", g = -1 * f, v = 0;
                        for(let r = 0; r < p; r++)if (m += t[r], d = n(m, e), ">" === d) {
                            let t = 1, r = i(e, e), a = e;
                            for(; ">" !== n(r, m);)t++, a = r, r = i(r, e);
                            if (t = t.toString(), "" !== y) for(let e = t.length; e <= v; e++)y += "0";
                            y += t, m = o(m, a), v = 0;
                        } else {
                            if ("<" === d) {
                                "" === y && g++, v++;
                                continue;
                            }
                            if ("=" === d) {
                                if ("" !== y) for(let t = 0; t < v; t++)y += "0";
                                y += "1", m = "0", v = 0;
                            }
                        }
                        if (m.match(/^0+$/g)) "<" === d && (y += m.substring(0, m.length - 1));
                        else {
                            const t = {}, a = c - g - y.length + r + 1;
                            "" === y && (v = 0);
                            for(let r = 0; r < a; r++){
                                if (m += "0", s) {
                                    if (m in t) {
                                        if (t[m]++, t[m] > 3) {
                                            y += "...", h = !0;
                                            break;
                                        }
                                    } else t[m] = 1;
                                }
                                const r = n(m, e);
                                if (">" === r) {
                                    let t = 1, r = i(e, e), a = e;
                                    for(; ">" !== n(r, m);)t++, a = r, r = i(r, e);
                                    t = t.toString();
                                    for(let e = t.length; e <= v; e++)y += "0";
                                    if (y += t, m = o(m, a), "0" === m) break;
                                    v = 0;
                                } else {
                                    if ("<" === r) {
                                        v++;
                                        continue;
                                    }
                                    if ("=" === r) {
                                        for(let t = 0; t < v; t++)y += "0";
                                        y += "1", v = 0;
                                        break;
                                    }
                                }
                            }
                        }
                        const b = c - g, x = y.length;
                        let w;
                        if (b === x) w = 0;
                        else if (b < 0) y = "0." + "0".repeat(Math.abs(b)) + y, w = x - b;
                        else if (b > x) {
                            for(let t = x; t < b; t++)y += "0";
                            w = 0;
                        } else b < x ? (y = y.substring(0, b) + "." + y.substring(b), w = x - b) : 0 === b && (y = "0." + y, w = x);
                        if (y = y.replace(/^0+/, ""), y = y.replace(/\.\d+0+$/, ""), !h) {
                            const t = w - r;
                            t > 0 && (y = a(y.substring(0, y.length - t + 1)));
                        }
                        return "." === y[0] && (y = "0" + y), y;
                    };
                },
                function(t, e, r) {
                    const n = r(98), i = r(18), o = r(38), a = r(188);
                    function s(t, e) {
                        t = i(t), e = i(e);
                        const r = "-" !== t[0] != ("-" !== e[0]) ? "-" : "";
                        if (t = n(t), e = n(e), "<" === o(t, e)) {
                            const r = t;
                            t = e, e = r;
                        }
                        return r + a(t, e);
                    }
                    t.exports = s, t.exports.default = s;
                },
                function(t, e, r) {
                    const { MAX_SAFE_INTEGER_LENGTH: n } = r(56);
                    t.exports = function(t, e) {
                        if ("0" === t || "0" === e) return "0";
                        const r = t.indexOf("."), i = e.indexOf("."), o = (-1 === r ? t.length : r) + (-1 === i ? e.length : i), a = (-1 === r ? 0 : t.length - 1 - r) + (-1 === i ? 0 : e.length - 1 - i);
                        if (0 === a && o < n) return (Number(t) * Number(e)).toFixed(0);
                        const s = t.replace(".", ""), u = e.replace(".", ""), l = s.length, c = u.length, f = [];
                        let h = l;
                        for(; h >= 0;){
                            const t = h, e = h -= 15, r = s.substring(e, t);
                            f.push([
                                Number(r),
                                r.length
                            ]);
                        }
                        const p = [], d = [];
                        for(let t = 0, e = c - 1; e >= 0; e--, t++){
                            const r = u[e], n = Number(r);
                            let i = 0, o = "";
                            const a = f.length - 1;
                            f.forEach(([t, e], r)=>{
                                let s = (i + n * t).toString();
                                const u = s.length;
                                if (u > e && r !== a) {
                                    const t = -1 * e;
                                    o = s.slice(t) + o, i = Number(s.slice(0, t));
                                } else {
                                    const t = e - u;
                                    for(let e = 0; e < t; e++)s = "0" + s;
                                    i = 0, o = s + o;
                                }
                            }), o += "0".repeat(t), p.push(o), d.push([
                                Array.from(o).map((t)=>Number(t)),
                                o.length
                            ]);
                        }
                        const m = p.length, y = d[d.length - 1][1] + m;
                        let g = "", v = 0;
                        for(let t = 0; t < y; t++){
                            let e = v;
                            const r = Math.min(t, m - 1);
                            for(let n = 0; n <= r; n++){
                                const [r, i] = d[n], o = i - 1 - t;
                                o >= 0 && (e += r[o]);
                            }
                            e >= 10 ? (e = e.toString(), g = e[e.length - 1] + g, v = Number(e.slice(0, -1))) : (g = e + g, v = 0);
                        }
                        if (0 === a) g = g.replace(/^0+/, "");
                        else {
                            const t = g.length - a;
                            g = g.substring(0, t) + "." + g.substring(t), g = g.replace(/^0+/, ""), g = g.replace(/\.?0+$/, ""), "." === g[0] && (g = "0" + g);
                        }
                        return g;
                    };
                },
                function(t, e, r) {
                    const n = r(18), i = r(38), o = r(96), a = r(97);
                    function s(t, e) {
                        t = n(t), e = n(e);
                        const r = "-" !== t[0], s = "-" !== e[0];
                        if (r) {
                            if (s) {
                                const r = i(t, e);
                                return ">" === r ? a(t, e) : "<" === r ? "-" + a(e, t) : "0";
                            }
                            return o(t, e.substring(1));
                        }
                        if (s) return "-" + o(t.substring(1), e);
                        {
                            t = t.substring(1), e = e.substring(1);
                            const r = i(t, e);
                            return ">" === r ? "-" + a(t, e) : "<" === r ? a(e, t) : "0";
                        }
                    }
                    t.exports = s, t.exports.default = s;
                },
                function(t, e) {
                    const r = [
                        "5",
                        "6",
                        "7",
                        "8",
                        "9"
                    ];
                    t.exports = function(t) {
                        "+" === t[0] && (t = t.substring(1));
                        const e = t.length;
                        let n = "";
                        const i = t[t.length - 1];
                        if (r.includes(i)) {
                            let r;
                            for(r = e - 2; r >= 0; r--){
                                const e = t[r];
                                if ("." === e || "-" === e) continue;
                                const i = Number(e) + 1;
                                if (10 !== i) {
                                    n = i + n;
                                    break;
                                }
                                n = "0" + n;
                            }
                            r > 0 && (n = t.substring(0, r) + n);
                        } else n = t.substring(0, e - 1);
                        return "." === n[n.length - 1] && (n = n.substring(0, n.length - 1)), n.indexOf(".") > -1 && (n = n.replace(/0+$/, "")), n;
                    };
                },
                function(t, e, r) {
                    const n = r(94);
                    function i({ nums: t, no_data: e, precise: r = !1 }) {
                        switch((t = t.filter((t)=>t !== e).sort((t, e)=>t - e)).length){
                            case 0:
                                return;
                            case 1:
                                return r ? t[0].toString() : t[0];
                            default:
                                const e1 = t.length / 2;
                                if (t.length % 2 == 0) return n(t[e1 - 1], t[e1], {
                                    precise: r
                                });
                                {
                                    const n = Math.floor(e1);
                                    return r ? t[n].toString() : t[n];
                                }
                        }
                    }
                    t.exports = i, t.exports.default = i;
                },
                function(t, e, r) {
                    var n;
                    const i = r(193);
                    function o({ bands: t, data: e, height: r, layout: n, width: o }) {
                        const a = i(e);
                        if ("[row,column,band]" === n || 1 === a) return {
                            layout: "[row,column,band]",
                            bands: t || (r && o ? e.length / (r * o) : void 0),
                            height: r || (t && o ? e.length / (t * o) : void 0),
                            width: o || (t && r ? e.length / (t * r) : void 0)
                        };
                        if (2 === a) {
                            if (!r || !o) return e.length < e[0].length ? {
                                bands: e.length,
                                layout: "[band][row,column]",
                                height: r || (o ? e[0].length / o : void 0),
                                width: o || (r ? e[0].length / r : void 0)
                            } : {
                                bands: e[0].length,
                                layout: "[row,column][band]",
                                height: r || (o ? e.length / o : void 0),
                                width: o || (r ? e.length / r : void 0)
                            };
                            if (e[0].length === r * o) return {
                                layout: "[band][row,column]",
                                bands: e.length,
                                height: r,
                                width: o
                            };
                            if (e.length === r * o) return {
                                layout: "[row,column][band]",
                                bands: e[0].length,
                                height: r,
                                width: o
                            };
                        } else if (3 === a) {
                            const t = e.length, n = e[0].length, i = e[0][0].length;
                            if (r && o) {
                                if (t === r && n === o) return {
                                    layout: "[row][column][band]",
                                    bands: i,
                                    height: r,
                                    width: o
                                };
                                if (n === r && i === o) return {
                                    layout: "[band][row][column]",
                                    bands: t,
                                    height: r,
                                    width: o
                                };
                            } else {
                                if (t < n && t < i) return {
                                    layout: "[band][row][column]",
                                    bands: t,
                                    height: n,
                                    width: i
                                };
                                if (i < t && i < n) return {
                                    layout: "[row][column][band]",
                                    bands: i,
                                    height: t,
                                    width: n
                                };
                            }
                        }
                    }
                    void 0 === (n = (function() {
                        return o;
                    }).call(e, r, e, t)) || (t.exports = n), t.exports = o, t.exports.default = o, t.exports.guessImageLayout = o, "object" == typeof window && (window.guessImageLayout = o), "object" == typeof self && (self.guessImageLayout = o);
                },
                function(t, e) {
                    t.exports = function(t) {
                        const e = (t)=>Array.isArray(t) || t instanceof Int8Array || t instanceof Uint8Array || t instanceof Uint8ClampedArray || t instanceof Int16Array || t instanceof Uint16Array || t instanceof Int32Array || t instanceof Uint32Array || t instanceof Float32Array || t instanceof Float64Array || t instanceof BigInt64Array || t instanceof BigUint64Array;
                        let r = 0, n = t;
                        for(; e(n);)r++, n = n[0];
                        return r;
                    };
                },
                function(t, e, r) {
                    const n = {}, { wrapNextFunction: i } = r(72), o = r(195), a = r(196), s = {
                        Array: Array,
                        Int8Array: Int8Array,
                        Uint8Array: Uint8Array,
                        Uint8ClampedArray: Uint8ClampedArray,
                        Int16Array: Int16Array,
                        Uint16Array: Uint16Array,
                        Float32Array: Float32Array,
                        Float64Array: Float64Array
                    };
                    try {
                        s.BigInt64Array = BigInt64Array, s.BigUint64Array = BigUint64Array;
                    } catch (t) {}
                    const u = (t)=>t.match(/\[[^\]]+\]/g), l = (t)=>t.startsWith("[") && t.endsWith("]") ? t.substring(1, t.length - 1) : t, c = (t)=>t.startsWith("(") && t.endsWith(")") ? t.substring(1, t.length - 1) : t, f = (t)=>t.match(/(\(.*?\)|[^\(,\s]+)(?=\s*,|\s*$)/g), h = (t)=>{
                        t = l(t), t = c(t);
                        const e = f(t);
                        return 1 === e.length ? {
                            type: "Vector",
                            dim: e[0]
                        } : {
                            type: "Matrix",
                            parts: e.map(h)
                        };
                    };
                    function p(t) {
                        const e = t.match(/[^ A-Za-z,\[\]]/g);
                        if (e) throw new Error("The following invalid characters were used: " + e.map((t)=>`"${t}"`).join(", "));
                        return !0;
                    }
                    function d(t, { useLayoutCache: e = !0 } = {
                        useLayoutCache: !0
                    }) {
                        if (e && t in n) return n[t];
                        p(t);
                        const r = u(t).map(h), i = {
                            type: "Layout",
                            summary: r.map((t)=>"Matrix" === t.type ? t.parts.length : 1),
                            dims: r
                        };
                        return e && (n[t] = i), i;
                    }
                    function m({ useLayoutCache: t = !0, data: e, layout: r, sizes: n = {} }) {
                        "string" == typeof r && (r = d(r, {
                            useLayoutCache: t
                        }));
                        const { dims: i } = r, o = i.length, s = g({
                            useLayoutCache: t,
                            layout: r,
                            sizes: n
                        }), u = o - 1, l = r.summary.toString();
                        if (l in a) {
                            const t = {
                                data: e
                            };
                            return r.dims.map((e, r)=>{
                                "Vector" === e.type ? t[`d${r}v0`] = e.dim : "Matrix" === e.type && e.parts.forEach((e, n)=>{
                                    t[`d${r}v${n}`] = e.dim, t[`m${r}v${n}`] = s[e.dim];
                                });
                            }), a[l].bind(t);
                        }
                        return ({ point: t, value: r })=>{
                            let n = e;
                            for(let e = 0; e < o; e++){
                                const o = e === u, a = i[e];
                                let l;
                                l = "Vector" === a.type ? t[a.dim] : a.parts.reduce((e, { dim: r })=>e + s[r] * t[r], 0), o ? n[l] = r : n = n[l];
                            }
                        };
                    }
                    function y({ rect: t = {} }) {
                        if (t) for(let e in t){
                            const r = t[e];
                            if (2 !== r.length) throw new Error("[xdim] uh oh. invalid hyper-rectangle");
                            const [n, i] = r;
                            if (n > i) throw new Error(`[xdim] uh oh. invalid range for "${e}".  Start of ${n} can't be greater than end of ${i}.`);
                            if (n < 0) throw new Error("[xdim] uh oh. invalid hyper-rectangle with start " + n);
                        }
                    }
                    function g({ useLayoutCache: t = !0, layout: e, sizes: r }) {
                        "string" == typeof e && (e = d(e, {
                            useLayoutCache: t
                        }));
                        const { dims: n } = e, i = n.length;
                        let o = {};
                        for(let t = 0; t < i; t++){
                            const e = n[t];
                            if ("Vector" === e.type) o[e.dim] = 1;
                            else {
                                const { parts: t } = e;
                                let n = 1;
                                for(let e = t.length - 1; e >= 0; e--){
                                    const { dim: i } = t[e];
                                    o[i] = n, n *= r[t[e].dim];
                                }
                            }
                        }
                        return o;
                    }
                    function v({ useLayoutCache: t = !0, data: e, layout: r, point: n, sizes: i = {} }) {
                        let o, a;
                        "string" == typeof r && (r = d(r, {
                            useLayoutCache: t
                        }));
                        let s = e;
                        const { dims: u } = r, l = u.length;
                        for(let t = 0; t < l; t++){
                            const e = u[t];
                            if ("Vector" === e.type) {
                                const t = n[e.dim];
                                o = s, a = t, s = s[t];
                            } else {
                                const { parts: t } = e;
                                let r = 0, u = 1;
                                for(let e = t.length - 1; e >= 0; e--){
                                    const o = t[e];
                                    if ("Vector" === o.type) {
                                        const { dim: t } = o;
                                        if (r += u * n[t], e > 0) {
                                            if (!(t in i)) throw new Error(`you cannot calculate the location without knowing the size of the "${t}" dimension.`);
                                            u *= i[t];
                                        }
                                    }
                                }
                                o = s, a = r, s = s[r];
                            }
                        }
                        return {
                            index: a,
                            value: s,
                            parent: o
                        };
                    }
                    function b({ arr: t, fill: e, lens: r, arrayTypes: n }) {
                        if (0 === r.length) return t;
                        const i = r[0];
                        if (1 === r.length) {
                            const r = n ? n[n.length - 1] : "Array";
                            for(let n = 0; n < t.length; n++)t[n] = new s[r](i).fill(e);
                        } else for(let o = 0; o < t.length; o++){
                            const a = new Array(i).fill(e);
                            t[o] = a, b({
                                arr: a,
                                fill: e,
                                lens: r.slice(1),
                                arrayTypes: n
                            });
                        }
                        return t;
                    }
                    function x({ fill: t, shape: e, arrayTypes: r }) {
                        const n = e[0];
                        if (1 === e.length) {
                            if (Array.isArray(r) && 1 !== r.length) throw new Error("[xdim] shape and arrayTypes have different lengths");
                            const e = Array.isArray(r) ? r[0] : "Array";
                            return new s[e](n).fill(t);
                        }
                        return b({
                            arr: new Array(n).fill(t),
                            fill: t,
                            lens: e.slice(1),
                            arrayTypes: r
                        });
                    }
                    function w({ fill: t, layout: e, useLayoutCache: r = !0, sizes: n, arrayTypes: i }) {
                        "string" == typeof e && (e = d(e, {
                            useLayoutCache: r
                        }));
                        const o = e.dims.map((t)=>"Vector" === t.type ? n[t.dim] : "Matrix" === t.type ? t.parts.reduce((t, e)=>{
                                if (!(e.dim in n)) throw new Error(`[xdim] could not find "${e.dim}" in sizes: { ${Object.keys(n).join(", ")} }`);
                                return t * n[e.dim];
                            }, 1) : void 0);
                        return {
                            data: x({
                                fill: t,
                                shape: o,
                                arrayTypes: i
                            }),
                            shape: o,
                            arrayTypes: i
                        };
                    }
                    function _({ start: t = 0, end: e = 100 }) {
                        let r = t - 1;
                        return e += 1, i(function() {
                            return r++, r === e ? {
                                done: !0
                            } : {
                                done: !1,
                                value: r
                            };
                        });
                    }
                    function A({ order: t, sizes: e, rect: r = {} }) {
                        const n = Array.isArray(t) ? t : Object.keys(e).sort((t, r)=>e[t] - e[r]), o = new Array(n.length), a = {};
                        for(let t = 0; t < n.length - 1; t++){
                            const i = n[t], [s, u] = r[i] || [
                                0,
                                e[i] - 1
                            ];
                            o[t] = _({
                                start: s + 1,
                                end: u
                            }), a[i] = s;
                        }
                        const s = n[n.length - 1], [u, l] = r[s] || [
                            0,
                            e[s] - 1
                        ];
                        return o[o.length - 1] = _({
                            start: u,
                            end: l
                        }), a[s] = u - 1, i(function() {
                            for(let t = o.length - 1; t >= 0; t--){
                                const { value: i, done: s } = o[t].next();
                                if (!s) {
                                    for(let i = t + 1; i < o.length; i++){
                                        const t = n[i], [s, u] = r[t] || [
                                            0,
                                            e[t] - 1
                                        ];
                                        o[i] = _({
                                            start: s + 1,
                                            end: u
                                        }), a[t] = s;
                                    }
                                    return a[n[t]] = i, {
                                        value: a,
                                        done: !1
                                    };
                                }
                                if (0 === t) return {
                                    done: !0
                                };
                            }
                        });
                    }
                    t.exports = {
                        addDims: b,
                        checkValidity: p,
                        createMatrix: x,
                        iterClip: function({ data: t, layout: e, order: r, rect: n = {}, sizes: o = {}, useLayoutCache: a = !0 }) {
                            if (!t) throw new Error("[xdim] must specify data");
                            if (!e) throw new Error("[xdim] must specify layout");
                            const s = A({
                                order: r,
                                sizes: o,
                                rect: n
                            });
                            return i(function() {
                                const { value: r, done: n } = s.next();
                                if (n) return {
                                    done: !0
                                };
                                {
                                    const { value: n } = v({
                                        data: t,
                                        layout: e,
                                        point: r,
                                        sizes: o,
                                        useLayoutCache: a
                                    });
                                    return {
                                        done: !1,
                                        value: n
                                    };
                                }
                            });
                        },
                        iterRange: _,
                        iterPoints: A,
                        matchSequences: f,
                        parse: d,
                        parseDimensions: function(t) {
                            const e = {}, r = /[A-Za-z]+/g;
                            let n;
                            for(; null !== (n = r.exec(t));){
                                const [t] = n;
                                e[t] = {
                                    name: t
                                };
                            }
                            return e;
                        },
                        parseSequences: h,
                        parseVectors: u,
                        prepareData: w,
                        prepareSelect: function({ useLayoutCache: t = !0, data: e, layout: r, sizes: n = {} }) {
                            "string" == typeof r && (r = d(r, {
                                useLayoutCache: t
                            }));
                            const { dims: i } = r, a = i.length, s = g({
                                useLayoutCache: t,
                                layout: r,
                                sizes: n
                            }), u = a - 1, l = r.summary.toString();
                            if (l in o) {
                                const t = {
                                    data: e
                                };
                                return r.dims.map((e, r)=>{
                                    "Vector" === e.type ? t[`d${r}v0`] = e.dim : "Matrix" === e.type && e.parts.forEach((e, n)=>{
                                        t[`d${r}v${n}`] = e.dim, t[`m${r}v${n}`] = s[e.dim];
                                    });
                                }), o[l].bind(t);
                            }
                            return ({ point: t })=>{
                                let r = e;
                                for(let e = 0; e < a; e++){
                                    const n = e === u, o = i[e];
                                    let a;
                                    if (a = "Vector" === o.type ? t[o.dim] : o.parts.reduce((e, { dim: r })=>e + s[r] * t[r], 0), n) return {
                                        index: a,
                                        parent: r,
                                        value: r[a]
                                    };
                                    r = r[a];
                                }
                            };
                        },
                        prepareUpdate: m,
                        removeBraces: l,
                        removeParentheses: c,
                        select: v,
                        transform: function({ data: t, fill: e, from: r, to: n, sizes: i, useLayoutCache: o = !0 }) {
                            "string" == typeof r && (r = d(r, {
                                useLayoutCache: o
                            })), "string" == typeof n && (n = d(n, {
                                useLayoutCache: o
                            }));
                            const { data: a } = w({
                                fill: e,
                                layout: n,
                                sizes: i
                            }), s = m({
                                useLayoutCache: o,
                                data: a,
                                layout: n,
                                sizes: i
                            }), u = A({
                                sizes: i
                            });
                            for (point of u){
                                const { value: e } = v({
                                    data: t,
                                    layout: r,
                                    point: point,
                                    sizes: i
                                });
                                s({
                                    point: point,
                                    value: e
                                });
                            }
                            return {
                                data: a
                            };
                        },
                        update: function({ useLayoutCache: t = !0, data: e, layout: r, point: n, sizes: i = {}, value: o }) {
                            "string" == typeof r && (r = d(r, {
                                useLayoutCache: t
                            }));
                            const { dims: a } = r;
                            for(let t = 0; t < a.length; t++){
                                const r = t === a.length - 1, s = a[t];
                                let u;
                                if ("Vector" === s.type) u = n[s.dim];
                                else {
                                    const { parts: t } = s;
                                    u = 0;
                                    let e = 1;
                                    for(let r = t.length - 1; r >= 0; r--){
                                        const o = t[r], { dim: a } = o;
                                        if (u += e * n[a], r > 0) {
                                            if (!(a in i)) throw new Error(`you cannot calculate the location without knowing the size of the "${a}" dimension.`);
                                            e *= i[a];
                                        }
                                    }
                                }
                                r ? e[u] = o : e = e[u];
                            }
                        },
                        clip: function({ useLayoutCache: t = !0, data: e, layout: r, rect: n, sizes: i = {}, flat: o = !1, validate: a = !0 }) {
                            a && y({
                                rect: n
                            }), "string" == typeof r && (r = d(r, {
                                useLayoutCache: t
                            }));
                            let s = [
                                e
                            ];
                            if (r.dims.forEach((t)=>{
                                let e = [];
                                s.forEach((r)=>{
                                    if ("Vector" === t.type) {
                                        const [i, o] = n[t.dim];
                                        e = e.concat(r.slice(i, o + 1));
                                    } else {
                                        const { parts: o } = t;
                                        let a = [
                                            0
                                        ], s = 1;
                                        for(let t = o.length - 1; t >= 0; t--){
                                            const e = o[t], { dim: r } = e, [u, l] = n[r], c = [];
                                            for(let t = u; t <= l; t++)a.forEach((e)=>{
                                                c.push(e + s * t);
                                            });
                                            a = c, s *= i[r];
                                        }
                                        a.forEach((t)=>{
                                            e.push(r[t]);
                                        });
                                    }
                                }), s = e;
                            }), o) return {
                                data: s
                            };
                            const u = Object.fromEntries(Object.entries(n).map(([t, [e, r]])=>[
                                    t,
                                    r - e + 1
                                ])), { data: l } = w({
                                layout: r,
                                sizes: u
                            }), c = r.dims.length, f = (t, e)=>{
                                if (e === c) for(let e = 0; e < t.length; e++)t[e] = s.shift();
                                else t.forEach((t)=>f(t, e + 1));
                            };
                            return f(l, 1), {
                                data: l
                            };
                        },
                        validateRect: y
                    };
                },
                function(t, e) {
                    t.exports = {
                        1: function({ point: t }) {
                            const e = this.data, r = t[this.d0v0];
                            return {
                                parent: e,
                                index: r,
                                value: e[r]
                            };
                        },
                        2: function({ point: t }) {
                            const e = this.data, r = this.m0v0 * t[this.d0v0] + this.m0v1 * t[this.d0v1];
                            return {
                                parent: e,
                                index: r,
                                value: e[r]
                            };
                        },
                        3: function({ point: t }) {
                            const e = this.data, r = this.m0v0 * t[this.d0v0] + this.m0v1 * t[this.d0v1] + this.m0v2 * t[this.d0v2];
                            return {
                                parent: e,
                                index: r,
                                value: e[r]
                            };
                        },
                        4: function({ point: t }) {
                            const e = this.data, r = this.m0v0 * t[this.d0v0] + this.m0v1 * t[this.d0v1] + this.m0v2 * t[this.d0v2] + this.m0v3 * t[this.d0v3];
                            return {
                                parent: e,
                                index: r,
                                value: e[r]
                            };
                        },
                        5: function({ point: t }) {
                            const e = this.data, r = this.m0v0 * t[this.d0v0] + this.m0v1 * t[this.d0v1] + this.m0v2 * t[this.d0v2] + this.m0v3 * t[this.d0v3] + this.m0v4 * t[this.d0v4];
                            return {
                                parent: e,
                                index: r,
                                value: e[r]
                            };
                        },
                        "1,1": function({ point: t }) {
                            const e = this.data[t[this.d0v0]], r = t[this.d1v0];
                            return {
                                parent: e,
                                index: r,
                                value: e[r]
                            };
                        },
                        "1,2": function({ point: t }) {
                            const e = this.data[t[this.d0v0]], r = this.m1v0 * t[this.d1v0] + this.m1v1 * t[this.d1v1];
                            return {
                                parent: e,
                                index: r,
                                value: e[r]
                            };
                        },
                        "1,3": function({ point: t }) {
                            const e = this.data[t[this.d0v0]], r = this.m1v0 * t[this.d1v0] + this.m1v1 * t[this.d1v1] + this.m1v2 * t[this.d1v2];
                            return {
                                parent: e,
                                index: r,
                                value: e[r]
                            };
                        },
                        "1,4": function({ point: t }) {
                            const e = this.data[t[this.d0v0]], r = this.m1v0 * t[this.d1v0] + this.m1v1 * t[this.d1v1] + this.m1v2 * t[this.d1v2] + this.m1v3 * t[this.d1v3];
                            return {
                                parent: e,
                                index: r,
                                value: e[r]
                            };
                        },
                        "1,5": function({ point: t }) {
                            const e = this.data[t[this.d0v0]], r = this.m1v0 * t[this.d1v0] + this.m1v1 * t[this.d1v1] + this.m1v2 * t[this.d1v2] + this.m1v3 * t[this.d1v3] + this.m1v4 * t[this.d1v4];
                            return {
                                parent: e,
                                index: r,
                                value: e[r]
                            };
                        },
                        "1,1,1": function({ point: t }) {
                            const e = this.data[t[this.d0v0]][t[this.d1v0]], r = t[this.d2v0];
                            return {
                                parent: e,
                                index: r,
                                value: e[r]
                            };
                        },
                        "1,1,2": function({ point: t }) {
                            const e = this.data[t[this.d0v0]][t[this.d1v0]], r = this.m2v0 * t[this.d2v0] + this.m2v1 * t[this.d2v1];
                            return {
                                parent: e,
                                index: r,
                                value: e[r]
                            };
                        },
                        "1,1,3": function({ point: t }) {
                            const e = this.data[t[this.d0v0]][t[this.d1v0]], r = this.m2v0 * t[this.d2v0] + this.m2v1 * t[this.d2v1] + this.m2v2 * t[this.d2v2];
                            return {
                                parent: e,
                                index: r,
                                value: e[r]
                            };
                        },
                        "1,1,4": function({ point: t }) {
                            const e = this.data[t[this.d0v0]][t[this.d1v0]], r = this.m2v0 * t[this.d2v0] + this.m2v1 * t[this.d2v1] + this.m2v2 * t[this.d2v2] + this.m2v3 * t[this.d2v3];
                            return {
                                parent: e,
                                index: r,
                                value: e[r]
                            };
                        },
                        "1,1,5": function({ point: t }) {
                            const e = this.data[t[this.d0v0]][t[this.d1v0]], r = this.m2v0 * t[this.d2v0] + this.m2v1 * t[this.d2v1] + this.m2v2 * t[this.d2v2] + this.m2v3 * t[this.d2v3] + this.m2v4 * t[this.d2v4];
                            return {
                                parent: e,
                                index: r,
                                value: e[r]
                            };
                        },
                        "1,1,1,1": function({ point: t }) {
                            const e = this.data[t[this.d0v0]][t[this.d1v0]][t[this.d2v0]], r = t[this.d3v0];
                            return {
                                parent: e,
                                index: r,
                                value: e[r]
                            };
                        },
                        "1,1,1,2": function({ point: t }) {
                            const e = this.data[t[this.d0v0]][t[this.d1v0]][t[this.d2v0]], r = this.m3v0 * t[this.d3v0] + this.m3v1 * t[this.d3v1];
                            return {
                                parent: e,
                                index: r,
                                value: e[r]
                            };
                        },
                        "1,1,1,3": function({ point: t }) {
                            const e = this.data[t[this.d0v0]][t[this.d1v0]][t[this.d2v0]], r = this.m3v0 * t[this.d3v0] + this.m3v1 * t[this.d3v1] + this.m3v2 * t[this.d3v2];
                            return {
                                parent: e,
                                index: r,
                                value: e[r]
                            };
                        },
                        "1,1,1,4": function({ point: t }) {
                            const e = this.data[t[this.d0v0]][t[this.d1v0]][t[this.d2v0]], r = this.m3v0 * t[this.d3v0] + this.m3v1 * t[this.d3v1] + this.m3v2 * t[this.d3v2] + this.m3v3 * t[this.d3v3];
                            return {
                                parent: e,
                                index: r,
                                value: e[r]
                            };
                        },
                        "1,1,1,5": function({ point: t }) {
                            const e = this.data[t[this.d0v0]][t[this.d1v0]][t[this.d2v0]], r = this.m3v0 * t[this.d3v0] + this.m3v1 * t[this.d3v1] + this.m3v2 * t[this.d3v2] + this.m3v3 * t[this.d3v3] + this.m3v4 * t[this.d3v4];
                            return {
                                parent: e,
                                index: r,
                                value: e[r]
                            };
                        },
                        "1,1,1,1,1": function({ point: t }) {
                            const e = this.data[t[this.d0v0]][t[this.d1v0]][t[this.d2v0]][t[this.d3v0]], r = t[this.d4v0];
                            return {
                                parent: e,
                                index: r,
                                value: e[r]
                            };
                        },
                        "1,1,1,1,2": function({ point: t }) {
                            const e = this.data[t[this.d0v0]][t[this.d1v0]][t[this.d2v0]][t[this.d3v0]], r = this.m4v0 * t[this.d4v0] + this.m4v1 * t[this.d4v1];
                            return {
                                parent: e,
                                index: r,
                                value: e[r]
                            };
                        },
                        "1,1,1,1,3": function({ point: t }) {
                            const e = this.data[t[this.d0v0]][t[this.d1v0]][t[this.d2v0]][t[this.d3v0]], r = this.m4v0 * t[this.d4v0] + this.m4v1 * t[this.d4v1] + this.m4v2 * t[this.d4v2];
                            return {
                                parent: e,
                                index: r,
                                value: e[r]
                            };
                        },
                        "1,1,1,1,4": function({ point: t }) {
                            const e = this.data[t[this.d0v0]][t[this.d1v0]][t[this.d2v0]][t[this.d3v0]], r = this.m4v0 * t[this.d4v0] + this.m4v1 * t[this.d4v1] + this.m4v2 * t[this.d4v2] + this.m4v3 * t[this.d4v3];
                            return {
                                parent: e,
                                index: r,
                                value: e[r]
                            };
                        },
                        "1,1,1,1,5": function({ point: t }) {
                            const e = this.data[t[this.d0v0]][t[this.d1v0]][t[this.d2v0]][t[this.d3v0]], r = this.m4v0 * t[this.d4v0] + this.m4v1 * t[this.d4v1] + this.m4v2 * t[this.d4v2] + this.m4v3 * t[this.d4v3] + this.m4v4 * t[this.d4v4];
                            return {
                                parent: e,
                                index: r,
                                value: e[r]
                            };
                        }
                    };
                },
                function(t, e) {
                    t.exports = {
                        1: function({ point: t, value: e }) {
                            this.data[t[this.d0v0]] = e;
                        },
                        2: function({ point: t, value: e }) {
                            this.data[this.m0v0 * t[this.d0v0] + this.m0v1 * t[this.d0v1]] = e;
                        },
                        3: function({ point: t, value: e }) {
                            this.data[this.m0v0 * t[this.d0v0] + this.m0v1 * t[this.d0v1] + this.m0v2 * t[this.d0v2]] = e;
                        },
                        4: function({ point: t, value: e }) {
                            this.data[this.m0v0 * t[this.d0v0] + this.m0v1 * t[this.d0v1] + this.m0v2 * t[this.d0v2] + this.m0v3 * t[this.d0v3]] = e;
                        },
                        5: function({ point: t, value: e }) {
                            this.data[this.m0v0 * t[this.d0v0] + this.m0v1 * t[this.d0v1] + this.m0v2 * t[this.d0v2] + this.m0v3 * t[this.d0v3] + this.m0v4 * t[this.d0v4]] = e;
                        },
                        "1,1": function({ point: t, value: e }) {
                            this.data[t[this.d0v0]][t[this.d1v0]] = e;
                        },
                        "1,2": function({ point: t, value: e }) {
                            this.data[t[this.d0v0]][this.m1v0 * t[this.d1v0] + this.m1v1 * t[this.d1v1]] = e;
                        },
                        "1,3": function({ point: t, value: e }) {
                            this.data[t[this.d0v0]][this.m1v0 * t[this.d1v0] + this.m1v1 * t[this.d1v1] + this.m1v2 * t[this.d1v2]] = e;
                        },
                        "1,4": function({ point: t, value: e }) {
                            this.data[t[this.d0v0]][this.m1v0 * t[this.d1v0] + this.m1v1 * t[this.d1v1] + this.m1v2 * t[this.d1v2] + this.m1v3 * t[this.d1v3]] = e;
                        },
                        "1,5": function({ point: t, value: e }) {
                            this.data[t[this.d0v0]][this.m1v0 * t[this.d1v0] + this.m1v1 * t[this.d1v1] + this.m1v2 * t[this.d1v2] + this.m1v3 * t[this.d1v3] + this.m1v4 * t[this.d1v4]] = e;
                        },
                        "1,1,1": function({ point: t, value: e }) {
                            this.data[t[this.d0v0]][t[this.d1v0]][t[this.d2v0]] = e;
                        },
                        "1,1,2": function({ point: t, value: e }) {
                            this.data[t[this.d0v0]][t[this.d1v0]][this.m2v0 * t[this.d2v0] + this.m2v1 * t[this.d2v1]] = e;
                        },
                        "1,1,3": function({ point: t, value: e }) {
                            this.data[t[this.d0v0]][t[this.d1v0]][this.m2v0 * t[this.d2v0] + this.m2v1 * t[this.d2v1] + this.m2v2 * t[this.d2v2]] = e;
                        },
                        "1,1,4": function({ point: t, value: e }) {
                            this.data[t[this.d0v0]][t[this.d1v0]][this.m2v0 * t[this.d2v0] + this.m2v1 * t[this.d2v1] + this.m2v2 * t[this.d2v2] + this.m2v3 * t[this.d2v3]] = e;
                        },
                        "1,1,5": function({ point: t, value: e }) {
                            this.data[t[this.d0v0]][t[this.d1v0]][this.m2v0 * t[this.d2v0] + this.m2v1 * t[this.d2v1] + this.m2v2 * t[this.d2v2] + this.m2v3 * t[this.d2v3] + this.m2v4 * t[this.d2v4]] = e;
                        },
                        "1,1,1,1": function({ point: t, value: e }) {
                            this.data[t[this.d0v0]][t[this.d1v0]][t[this.d2v0]][t[this.d3v0]] = e;
                        },
                        "1,1,1,2": function({ point: t, value: e }) {
                            this.data[t[this.d0v0]][t[this.d1v0]][t[this.d2v0]][this.m3v0 * t[this.d3v0] + this.m3v1 * t[this.d3v1]] = e;
                        },
                        "1,1,1,3": function({ point: t, value: e }) {
                            this.data[t[this.d0v0]][t[this.d1v0]][t[this.d2v0]][this.m3v0 * t[this.d3v0] + this.m3v1 * t[this.d3v1] + this.m3v2 * t[this.d3v2]] = e;
                        },
                        "1,1,1,4": function({ point: t, value: e }) {
                            this.data[t[this.d0v0]][t[this.d1v0]][t[this.d2v0]][this.m3v0 * t[this.d3v0] + this.m3v1 * t[this.d3v1] + this.m3v2 * t[this.d3v2] + this.m3v3 * t[this.d3v3]] = e;
                        },
                        "1,1,1,5": function({ point: t, value: e }) {
                            this.data[t[this.d0v0]][t[this.d1v0]][t[this.d2v0]][this.m3v0 * t[this.d3v0] + this.m3v1 * t[this.d3v1] + this.m3v2 * t[this.d3v2] + this.m3v3 * t[this.d3v3] + this.m3v4 * t[this.d3v4]] = e;
                        },
                        "1,1,1,1,1": function({ point: t, value: e }) {
                            this.data[t[this.d0v0]][t[this.d1v0]][t[this.d2v0]][t[this.d3v0]][t[this.d4v0]] = e;
                        },
                        "1,1,1,1,2": function({ point: t, value: e }) {
                            this.data[t[this.d0v0]][t[this.d1v0]][t[this.d2v0]][t[this.d3v0]][this.m4v0 * t[this.d4v0] + this.m4v1 * t[this.d4v1]] = e;
                        },
                        "1,1,1,1,3": function({ point: t, value: e }) {
                            this.data[t[this.d0v0]][t[this.d1v0]][t[this.d2v0]][t[this.d3v0]][this.m4v0 * t[this.d4v0] + this.m4v1 * t[this.d4v1] + this.m4v2 * t[this.d4v2]] = e;
                        },
                        "1,1,1,1,4": function({ point: t, value: e }) {
                            this.data[t[this.d0v0]][t[this.d1v0]][t[this.d2v0]][t[this.d3v0]][this.m4v0 * t[this.d4v0] + this.m4v1 * t[this.d4v1] + this.m4v2 * t[this.d4v2] + this.m4v3 * t[this.d4v3]] = e;
                        },
                        "1,1,1,1,5": function({ point: t, value: e }) {
                            this.data[t[this.d0v0]][t[this.d1v0]][t[this.d2v0]][t[this.d3v0]][this.m4v0 * t[this.d4v0] + this.m4v1 * t[this.d4v1] + this.m4v2 * t[this.d4v2] + this.m4v3 * t[this.d4v3] + this.m4v4 * t[this.d4v4]] = e;
                        }
                    };
                },
                function(t, e, r) {
                    "use strict";
                    function n(t, e) {
                        if ("undefined" == typeof ImageData) throw "toCanvas is not supported in your environment";
                        {
                            const r = document.createElement("CANVAS"), n = e && e.height ? Math.min(t.height, e.height) : Math.min(t.height, 100), i = e && e.width ? Math.min(t.width, e.width) : Math.min(t.width, 100);
                            r.height = n, r.width = i, r.style.minHeight = "200px", r.style.minWidth = "400px", r.style.maxWidth = "100%";
                            const o = r.getContext("2d"), a = function(t, e, r) {
                                if (t.values) {
                                    const { noDataValue: n, mins: i, ranges: o, values: a } = t, s = a.length, u = t.width / e, l = t.height / r, c = new Uint8ClampedArray(e * r * 4);
                                    for(let f = 0; f < r; f++)for(let r = 0; r < e; r++){
                                        const h = Math.round(f * l), p = Math.round(r * u), d = a.map((t)=>{
                                            try {
                                                return t[h][p];
                                            } catch (t) {
                                                console.error(t);
                                            }
                                        });
                                        if (d.every((t)=>void 0 !== t && t !== n)) {
                                            const n = f * (4 * e) + 4 * r;
                                            if (1 === s) {
                                                const t = Math.round(d[0]), e = Math.round((t - i[0]) / o[0] * 255);
                                                c[n] = e, c[n + 1] = e, c[n + 2] = e, c[n + 3] = 255;
                                            } else if (3 === s) try {
                                                const [t, e, r] = d;
                                                c[n] = t, c[n + 1] = e, c[n + 2] = r, c[n + 3] = 255;
                                            } catch (t) {
                                                console.error(t);
                                            }
                                            else if (4 === s) try {
                                                const [t, e, r, i] = d;
                                                c[n] = t, c[n + 1] = e, c[n + 2] = r, c[n + 3] = i;
                                            } catch (t) {
                                                console.error(t);
                                            }
                                        }
                                    }
                                    return new ImageData(c, e, r);
                                }
                            }(t, i, n);
                            return o.putImageData(a, 0, 0), r;
                        }
                    }
                    r.r(e), r.d(e, "default", function() {
                        return n;
                    });
                },
                function(t, e, r) {
                    "use strict";
                    r.d(e, "a", function() {
                        return i;
                    });
                    var n = r(19);
                    Object(n.b)().blob;
                    const i = Object(n.b)().default;
                },
                ,
                ,
                function(t, e, r) {
                    "use strict";
                    var n = r(26), i = r(103);
                    e.a = function(t) {
                        const e = new i.a;
                        let r, o = 0;
                        return new n.a((n)=>{
                            r || (r = t.subscribe(e));
                            const i = e.subscribe(n);
                            return o++, ()=>{
                                o--, i.unsubscribe(), 0 === o && (function(t) {
                                    "function" == typeof t ? t() : t && "function" == typeof t.unsubscribe && t.unsubscribe();
                                }(r), r = void 0);
                            };
                        });
                    };
                }
            ]);
        },
        function(t, e, r) {
            t.exports = function() {
                "use strict";
                function t() {
                    return !0;
                }
                function e() {
                    return !1;
                }
                function r() {}
                return function n() {
                    function i(t) {
                        return "object" == typeof t && null !== t && t.constructor === Object;
                    }
                    const o = [
                        {
                            name: "number",
                            test: function(t) {
                                return "number" == typeof t;
                            }
                        },
                        {
                            name: "string",
                            test: function(t) {
                                return "string" == typeof t;
                            }
                        },
                        {
                            name: "boolean",
                            test: function(t) {
                                return "boolean" == typeof t;
                            }
                        },
                        {
                            name: "Function",
                            test: function(t) {
                                return "function" == typeof t;
                            }
                        },
                        {
                            name: "Array",
                            test: Array.isArray
                        },
                        {
                            name: "Date",
                            test: function(t) {
                                return t instanceof Date;
                            }
                        },
                        {
                            name: "RegExp",
                            test: function(t) {
                                return t instanceof RegExp;
                            }
                        },
                        {
                            name: "Object",
                            test: i
                        },
                        {
                            name: "null",
                            test: function(t) {
                                return null === t;
                            }
                        },
                        {
                            name: "undefined",
                            test: function(t) {
                                return void 0 === t;
                            }
                        }
                    ], a = {
                        name: "any",
                        test: t,
                        isAny: !0
                    };
                    let s, u, l = 0, c = {
                        createCount: 0
                    };
                    function f(t) {
                        const e = s.get(t);
                        if (e) return e;
                        let r = 'Unknown type "' + t + '"';
                        const n = t.toLowerCase();
                        let i;
                        for (i of u)if (i.toLowerCase() === n) {
                            r += '. Did you mean "' + i + '" ?';
                            break;
                        }
                        throw new TypeError(r);
                    }
                    function h(t) {
                        let e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "any";
                        const r = e ? f(e).index : u.length, n = [];
                        for(let e = 0; e < t.length; ++e){
                            if (!t[e] || "string" != typeof t[e].name || "function" != typeof t[e].test) throw new TypeError("Object with properties {name: string, test: function} expected");
                            const i = t[e].name;
                            if (s.has(i)) throw new TypeError('Duplicate type name "' + i + '"');
                            n.push(i), s.set(i, {
                                name: i,
                                test: t[e].test,
                                isAny: t[e].isAny,
                                index: r + e,
                                conversionsTo: []
                            });
                        }
                        const i = u.slice(r);
                        u = u.slice(0, r).concat(n).concat(i);
                        for(let t = r + n.length; t < u.length; ++t)s.get(u[t]).index = t;
                    }
                    function p() {
                        s = new Map, u = [], l = 0, h([
                            a
                        ], !1);
                    }
                    function d(t) {
                        const e = u.filter((e)=>{
                            const r = s.get(e);
                            return !r.isAny && r.test(t);
                        });
                        return e.length ? e : [
                            "any"
                        ];
                    }
                    function m(t) {
                        return t && "function" == typeof t && "_typedFunctionData" in t;
                    }
                    function y(t, e, r) {
                        if (!m(t)) throw new TypeError("Argument is not a typed-function.");
                        const n = r && r.exact, i = w(Array.isArray(e) ? e.join(",") : e), o = g(i);
                        if (!n || o in t.signatures) {
                            const e = t._typedFunctionData.signatureMap.get(o);
                            if (e) return e;
                        }
                        const a = i.length;
                        let s, u;
                        if (n) {
                            let e;
                            for(e in s = [], t.signatures)s.push(t._typedFunctionData.signatureMap.get(e));
                        } else s = t._typedFunctionData.signatures;
                        for(let t = 0; t < a; ++t){
                            const e = i[t], r = [];
                            let n;
                            for (n of s){
                                const i = S(n.params, t);
                                if (i && (!e.restParam || i.restParam)) {
                                    if (!i.hasAny) {
                                        const t = x(i);
                                        if (e.types.some((e)=>!t.has(e.name))) continue;
                                    }
                                    r.push(n);
                                }
                            }
                            if (s = r, 0 === s.length) break;
                        }
                        for (u of s)if (u.params.length <= a) return u;
                        throw new TypeError("Signature not found (signature: " + (t.name || "unnamed") + "(" + g(i, ", ") + "))");
                    }
                    function g(t) {
                        let e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : ",";
                        return t.map((t)=>t.name).join(e);
                    }
                    function v(t) {
                        const e = 0 === t.indexOf("..."), r = (e ? t.length > 3 ? t.slice(3) : "any" : t).split("|").map((t)=>f(t.trim()));
                        let n = !1, i = e ? "..." : "";
                        return {
                            types: r.map(function(t) {
                                return n = t.isAny || n, i += t.name + "|", {
                                    name: t.name,
                                    typeIndex: t.index,
                                    test: t.test,
                                    isAny: t.isAny,
                                    conversion: null,
                                    conversionIndex: -1
                                };
                            }),
                            name: i.slice(0, -1),
                            hasAny: n,
                            hasConversion: !1,
                            restParam: e
                        };
                    }
                    function b(t) {
                        const e = function(t) {
                            if (0 === t.length) return [];
                            const e = t.map(f);
                            t.length > 1 && e.sort((t, e)=>t.index - e.index);
                            let r = e[0].conversionsTo;
                            if (1 === t.length) return r;
                            r = r.concat([]);
                            const n = new Set(t);
                            for(let t = 1; t < e.length; ++t){
                                let i;
                                for (i of e[t].conversionsTo)n.has(i.from) || (r.push(i), n.add(i.from));
                            }
                            return r;
                        }(t.types.map((t)=>t.name));
                        let r = t.hasAny, n = t.name;
                        const i = e.map(function(t) {
                            const e = f(t.from);
                            return r = e.isAny || r, n += "|" + t.from, {
                                name: t.from,
                                typeIndex: e.index,
                                test: e.test,
                                isAny: e.isAny,
                                conversion: t,
                                conversionIndex: t.index
                            };
                        });
                        return {
                            types: t.types.concat(i),
                            name: n,
                            hasAny: r,
                            hasConversion: i.length > 0,
                            restParam: t.restParam
                        };
                    }
                    function x(t) {
                        return t.typeSet || (t.typeSet = new Set, t.types.forEach((e)=>t.typeSet.add(e.name))), t.typeSet;
                    }
                    function w(t) {
                        const e = [];
                        if ("string" != typeof t) throw new TypeError("Signatures must be strings");
                        const r = t.trim();
                        if ("" === r) return e;
                        const n = r.split(",");
                        for(let t = 0; t < n.length; ++t){
                            const r = v(n[t].trim());
                            if (r.restParam && t !== n.length - 1) throw new SyntaxError('Unexpected rest parameter "' + n[t] + '": only allowed for the last parameter');
                            if (0 === r.types.length) return null;
                            e.push(r);
                        }
                        return e;
                    }
                    function _(t) {
                        const e = G(t);
                        return !!e && e.restParam;
                    }
                    function A(e) {
                        if (e && 0 !== e.types.length) {
                            if (1 === e.types.length) return f(e.types[0].name).test;
                            if (2 === e.types.length) {
                                const t = f(e.types[0].name).test, r = f(e.types[1].name).test;
                                return function(e) {
                                    return t(e) || r(e);
                                };
                            }
                            {
                                const t = e.types.map(function(t) {
                                    return f(t.name).test;
                                });
                                return function(e) {
                                    for(let r = 0; r < t.length; r++)if (t[r](e)) return !0;
                                    return !1;
                                };
                            }
                        }
                        return t;
                    }
                    function E(t) {
                        let e, r, n;
                        if (_(t)) {
                            e = z(t).map(A);
                            const r = e.length, n = A(G(t)), i = function(t) {
                                for(let e = r; e < t.length; e++)if (!n(t[e])) return !1;
                                return !0;
                            };
                            return function(t) {
                                for(let r = 0; r < e.length; r++)if (!e[r](t[r])) return !1;
                                return i(t) && t.length >= r + 1;
                            };
                        }
                        return 0 === t.length ? function(t) {
                            return 0 === t.length;
                        } : 1 === t.length ? (r = A(t[0]), function(t) {
                            return r(t[0]) && 1 === t.length;
                        }) : 2 === t.length ? (r = A(t[0]), n = A(t[1]), function(t) {
                            return r(t[0]) && n(t[1]) && 2 === t.length;
                        }) : (e = t.map(A), function(t) {
                            for(let r = 0; r < e.length; r++)if (!e[r](t[r])) return !1;
                            return t.length === e.length;
                        });
                    }
                    function S(t, e) {
                        return e < t.length ? t[e] : _(t) ? G(t) : null;
                    }
                    function M(t, e) {
                        const r = S(t, e);
                        return r ? x(r) : new Set;
                    }
                    function k(t) {
                        return null === t.conversion || void 0 === t.conversion;
                    }
                    function N(t, e) {
                        const r = new Set;
                        return t.forEach((t)=>{
                            const n = M(t.params, e);
                            let i;
                            for (i of n)r.add(i);
                        }), r.has("any") ? [
                            "any"
                        ] : Array.from(r);
                    }
                    function C(t, e, r) {
                        let n, i;
                        const o = t || "unnamed";
                        let a, s = r;
                        for(a = 0; a < e.length; a++){
                            const t = [];
                            if (s.forEach((r)=>{
                                const n = A(S(r.params, a));
                                (a < r.params.length || _(r.params)) && n(e[a]) && t.push(r);
                            }), 0 === t.length) {
                                if (i = N(s, a), i.length > 0) {
                                    const t = d(e[a]);
                                    return n = new TypeError("Unexpected type of argument in function " + o + " (expected: " + i.join(" or ") + ", actual: " + t.join(" | ") + ", index: " + a + ")"), n.data = {
                                        category: "wrongType",
                                        fn: o,
                                        index: a,
                                        actual: t,
                                        expected: i
                                    }, n;
                                }
                            } else s = t;
                        }
                        const u = s.map(function(t) {
                            return _(t.params) ? 1 / 0 : t.params.length;
                        });
                        if (e.length < Math.min.apply(null, u)) return i = N(s, a), n = new TypeError("Too few arguments in function " + o + " (expected: " + i.join(" or ") + ", index: " + e.length + ")"), n.data = {
                            category: "tooFewArgs",
                            fn: o,
                            index: e.length,
                            expected: i
                        }, n;
                        const l = Math.max.apply(null, u);
                        if (e.length > l) return n = new TypeError("Too many arguments in function " + o + " (expected: " + l + ", actual: " + e.length + ")"), n.data = {
                            category: "tooManyArgs",
                            fn: o,
                            index: e.length,
                            expectedLength: l
                        }, n;
                        const c = [];
                        for(let t = 0; t < e.length; ++t)c.push(d(e[t]).join("|"));
                        return n = new TypeError('Arguments of type "' + c.join(", ") + '" do not match any of the defined signatures of function ' + o + "."), n.data = {
                            category: "mismatch",
                            actual: c
                        }, n;
                    }
                    function D(t) {
                        let e = u.length + 1;
                        for(let r = 0; r < t.types.length; r++)k(t.types[r]) && (e = Math.min(e, t.types[r].typeIndex));
                        return e;
                    }
                    function O(t) {
                        let e = l + 1;
                        for(let r = 0; r < t.types.length; r++)k(t.types[r]) || (e = Math.min(e, t.types[r].conversionIndex));
                        return e;
                    }
                    function T(t, e) {
                        if (t.hasAny) {
                            if (!e.hasAny) return 1;
                        } else if (e.hasAny) return -1;
                        if (t.restParam) {
                            if (!e.restParam) return 1;
                        } else if (e.restParam) return -1;
                        if (t.hasConversion) {
                            if (!e.hasConversion) return 1;
                        } else if (e.hasConversion) return -1;
                        const r = D(t) - D(e);
                        if (r < 0) return -1;
                        if (r > 0) return 1;
                        const n = O(t) - O(e);
                        return n < 0 ? -1 : n > 0 ? 1 : 0;
                    }
                    function F(t, e) {
                        const r = t.params, n = e.params, i = G(r), o = G(n), a = _(r), s = _(n);
                        if (a && i.hasAny) {
                            if (!s || !o.hasAny) return 1;
                        } else if (s && o.hasAny) return -1;
                        let u, l = 0, c = 0;
                        for (u of r)u.hasAny && ++l, u.hasConversion && ++c;
                        let f = 0, h = 0;
                        for (u of n)u.hasAny && ++f, u.hasConversion && ++h;
                        if (l !== f) return l - f;
                        if (a && i.hasConversion) {
                            if (!s || !o.hasConversion) return 1;
                        } else if (s && o.hasConversion) return -1;
                        if (c !== h) return c - h;
                        if (a) {
                            if (!s) return 1;
                        } else if (s) return -1;
                        const p = (r.length - n.length) * (a ? -1 : 1);
                        if (0 !== p) return p;
                        const d = [];
                        let m, y = 0;
                        for(let t = 0; t < r.length; ++t){
                            const e = T(r[t], n[t]);
                            d.push(e), y += e;
                        }
                        if (0 !== y) return y;
                        for (m of d)if (0 !== m) return m;
                        return 0;
                    }
                    function P(t, e) {
                        let r = e;
                        if (t.some((t)=>t.hasConversion)) {
                            const n = _(t), i = t.map(I);
                            r = function() {
                                const t = [], r = n ? arguments.length - 1 : arguments.length;
                                for(let e = 0; e < r; e++)t[e] = i[e](arguments[e]);
                                return n && (t[r] = arguments[r].map(i[r])), e.apply(this, t);
                            };
                        }
                        let n = r;
                        if (_(t)) {
                            const e = t.length - 1;
                            n = function() {
                                return r.apply(this, H(arguments, 0, e).concat([
                                    H(arguments, e)
                                ]));
                            };
                        }
                        return n;
                    }
                    function I(t) {
                        let e, r, n, i;
                        const o = [], a = [];
                        switch(t.types.forEach(function(t) {
                            t.conversion && (o.push(f(t.conversion.from).test), a.push(t.conversion.convert));
                        }), a.length){
                            case 0:
                                return function(t) {
                                    return t;
                                };
                            case 1:
                                return e = o[0], n = a[0], function(t) {
                                    return e(t) ? n(t) : t;
                                };
                            case 2:
                                return e = o[0], r = o[1], n = a[0], i = a[1], function(t) {
                                    return e(t) ? n(t) : r(t) ? i(t) : t;
                                };
                            default:
                                return function(t) {
                                    for(let e = 0; e < a.length; e++)if (o[e](t)) return a[e](t);
                                    return t;
                                };
                        }
                    }
                    function B(t) {
                        return function t(e, r, n) {
                            if (r < e.length) {
                                const a = e[r];
                                let s = [];
                                if (a.restParam) {
                                    const t = a.types.filter(k);
                                    t.length < a.types.length && s.push({
                                        types: t,
                                        name: "..." + t.map((t)=>t.name).join("|"),
                                        hasAny: t.some((t)=>t.isAny),
                                        hasConversion: !1,
                                        restParam: !0
                                    }), s.push(a);
                                } else s = a.types.map(function(t) {
                                    return {
                                        types: [
                                            t
                                        ],
                                        name: t.name,
                                        hasAny: t.isAny,
                                        hasConversion: t.conversion,
                                        restParam: !1
                                    };
                                });
                                return i = s, o = function(i) {
                                    return t(e, r + 1, n.concat([
                                        i
                                    ]));
                                }, Array.prototype.concat.apply([], i.map(o));
                            }
                            var i, o;
                            return [
                                n
                            ];
                        }(t, 0, []);
                    }
                    function j(t, e) {
                        const r = Math.max(t.length, e.length);
                        for(let n = 0; n < r; n++){
                            const r = M(t, n), i = M(e, n);
                            let o, a = !1;
                            for (o of i)if (r.has(o)) {
                                a = !0;
                                break;
                            }
                            if (!a) return !1;
                        }
                        const n = t.length, i = e.length, o = _(t), a = _(e);
                        return o ? a ? n === i : i >= n : a ? n >= i : n === i;
                    }
                    function R(t, e, r) {
                        const n = [];
                        let i;
                        for (i of t){
                            let t = r[i];
                            if ("number" != typeof t) throw new TypeError('No definition for referenced signature "' + i + '"');
                            if (t = e[t], "function" != typeof t) return !1;
                            n.push(t);
                        }
                        return n;
                    }
                    function L(t, e, r) {
                        const n = function(t) {
                            return t.map((t)=>Z(t) ? $(t.referToSelf.callback) : V(t) ? W(t.referTo.references, t.referTo.callback) : t);
                        }(t), i = new Array(n.length).fill(!1);
                        let o = !0;
                        for(; o;){
                            o = !1;
                            let t = !0;
                            for(let a = 0; a < n.length; ++a){
                                if (i[a]) continue;
                                const s = n[a];
                                if (Z(s)) n[a] = s.referToSelf.callback(r), n[a].referToSelf = s.referToSelf, i[a] = !0, t = !1;
                                else if (V(s)) {
                                    const r = R(s.referTo.references, n, e);
                                    r ? (n[a] = s.referTo.callback.apply(this, r), n[a].referTo = s.referTo, i[a] = !0, t = !1) : o = !0;
                                }
                            }
                            if (t && o) throw new SyntaxError("Circular reference detected in resolving typed.referTo");
                        }
                        return n;
                    }
                    function q(t, n) {
                        if (c.createCount++, 0 === Object.keys(n).length) throw new SyntaxError("No signatures provided");
                        c.warnAgainstDeprecatedThis && function(t) {
                            const e = /\bthis(\(|\.signatures\b)/;
                            Object.keys(t).forEach((r)=>{
                                const n = t[r];
                                if (e.test(n.toString())) throw new SyntaxError("Using `this` to self-reference a function is deprecated since typed-function@3. Use typed.referTo and typed.referToSelf instead.");
                            });
                        }(n);
                        const i = [], o = [], a = {}, s = [];
                        let u;
                        for(u in n){
                            if (!Object.prototype.hasOwnProperty.call(n, u)) continue;
                            const t = w(u);
                            if (!t) continue;
                            i.forEach(function(e) {
                                if (j(e, t)) throw new TypeError('Conflicting signatures "' + g(e) + '" and "' + g(t) + '".');
                            }), i.push(t);
                            const e = o.length;
                            o.push(n[u]);
                            const r = t.map(b);
                            let l;
                            for (l of B(r)){
                                const t = g(l);
                                s.push({
                                    params: l,
                                    name: t,
                                    fn: e
                                }), l.every((t)=>!t.hasConversion) && (a[t] = e);
                            }
                        }
                        s.sort(F);
                        const l = L(o, a, st);
                        let f;
                        for(f in a)Object.prototype.hasOwnProperty.call(a, f) && (a[f] = l[a[f]]);
                        const h = [], p = new Map;
                        for (f of s)p.has(f.name) || (f.fn = l[f.fn], h.push(f), p.set(f.name, f));
                        const d = h[0] && h[0].params.length <= 2 && !_(h[0].params), m = h[1] && h[1].params.length <= 2 && !_(h[1].params), y = h[2] && h[2].params.length <= 2 && !_(h[2].params), v = h[3] && h[3].params.length <= 2 && !_(h[3].params), x = h[4] && h[4].params.length <= 2 && !_(h[4].params), S = h[5] && h[5].params.length <= 2 && !_(h[5].params), M = d && m && y && v && x && S;
                        for(let t = 0; t < h.length; ++t)h[t].test = E(h[t].params);
                        const k = d ? A(h[0].params[0]) : e, N = m ? A(h[1].params[0]) : e, C = y ? A(h[2].params[0]) : e, D = v ? A(h[3].params[0]) : e, O = x ? A(h[4].params[0]) : e, T = S ? A(h[5].params[0]) : e, I = d ? A(h[0].params[1]) : e, R = m ? A(h[1].params[1]) : e, q = y ? A(h[2].params[1]) : e, U = v ? A(h[3].params[1]) : e, z = x ? A(h[4].params[1]) : e, G = S ? A(h[5].params[1]) : e;
                        for(let t = 0; t < h.length; ++t)h[t].implementation = P(h[t].params, h[t].fn);
                        const H = d ? h[0].implementation : r, W = m ? h[1].implementation : r, $ = y ? h[2].implementation : r, V = v ? h[3].implementation : r, Z = x ? h[4].implementation : r, Y = S ? h[5].implementation : r, K = d ? h[0].params.length : -1, X = m ? h[1].params.length : -1, J = y ? h[2].params.length : -1, Q = v ? h[3].params.length : -1, tt = x ? h[4].params.length : -1, et = S ? h[5].params.length : -1, rt = M ? 6 : 0, nt = h.length, it = h.map((t)=>t.test), ot = h.map((t)=>t.implementation), at = function() {
                            for(let t = rt; t < nt; t++)if (it[t](arguments)) return ot[t].apply(this, arguments);
                            return c.onMismatch(t, arguments, h);
                        };
                        function st(t, e) {
                            return arguments.length === K && k(t) && I(e) ? H.apply(this, arguments) : arguments.length === X && N(t) && R(e) ? W.apply(this, arguments) : arguments.length === J && C(t) && q(e) ? $.apply(this, arguments) : arguments.length === Q && D(t) && U(e) ? V.apply(this, arguments) : arguments.length === tt && O(t) && z(e) ? Z.apply(this, arguments) : arguments.length === et && T(t) && G(e) ? Y.apply(this, arguments) : at.apply(this, arguments);
                        }
                        try {
                            Object.defineProperty(st, "name", {
                                value: t
                            });
                        } catch (t) {}
                        return st.signatures = a, st._typedFunctionData = {
                            signatures: h,
                            signatureMap: p
                        }, st;
                    }
                    function U(t, e, r) {
                        throw C(t, e, r);
                    }
                    function z(t) {
                        return H(t, 0, t.length - 1);
                    }
                    function G(t) {
                        return t[t.length - 1];
                    }
                    function H(t, e, r) {
                        return Array.prototype.slice.call(t, e, r);
                    }
                    function W(t, e) {
                        return {
                            referTo: {
                                references: t,
                                callback: e
                            }
                        };
                    }
                    function $(t) {
                        if ("function" != typeof t) throw new TypeError("Callback function expected as first argument");
                        return {
                            referToSelf: {
                                callback: t
                            }
                        };
                    }
                    function V(t) {
                        return t && "object" == typeof t.referTo && Array.isArray(t.referTo.references) && "function" == typeof t.referTo.callback;
                    }
                    function Z(t) {
                        return t && "object" == typeof t.referToSelf && "function" == typeof t.referToSelf.callback;
                    }
                    function Y(t, e) {
                        if (!t) return e;
                        if (e && e !== t) {
                            const r = new Error("Function names do not match (expected: " + t + ", actual: " + e + ")");
                            throw r.data = {
                                actual: e,
                                expected: t
                            }, r;
                        }
                        return t;
                    }
                    function K(t) {
                        let e;
                        for(const r in t)Object.prototype.hasOwnProperty.call(t, r) && (m(t[r]) || "string" == typeof t[r].signature) && (e = Y(e, t[r].name));
                        return e;
                    }
                    function X(t, e) {
                        let r;
                        for(r in e)if (Object.prototype.hasOwnProperty.call(e, r)) {
                            if (r in t && e[r] !== t[r]) {
                                const n = new Error('Signature "' + r + '" is defined twice');
                                throw n.data = {
                                    signature: r,
                                    sourceFunction: e[r],
                                    destFunction: t[r]
                                }, n;
                            }
                            t[r] = e[r];
                        }
                    }
                    p(), h(o);
                    const J = c;
                    function Q(t) {
                        if (!t || "string" != typeof t.from || "string" != typeof t.to || "function" != typeof t.convert) throw new TypeError("Object with properties {from: string, to: string, convert: function} expected");
                        if (t.to === t.from) throw new SyntaxError('Illegal to define conversion from "' + t.from + '" to itself.');
                    }
                    return c = function(t) {
                        const e = "string" == typeof t, r = e ? 1 : 0;
                        let n = e ? t : "";
                        const o = {};
                        for(let t = r; t < arguments.length; ++t){
                            const r = arguments[t];
                            let a, s = {};
                            if ("function" == typeof r ? (a = r.name, "string" == typeof r.signature ? s[r.signature] = r : m(r) && (s = r.signatures)) : i(r) && (s = r, e || (a = K(r))), 0 === Object.keys(s).length) {
                                const e = new TypeError("Argument to 'typed' at index " + t + " is not a (typed) function, nor an object with signatures as keys and functions as values.");
                                throw e.data = {
                                    index: t,
                                    argument: r
                                }, e;
                            }
                            e || (n = Y(n, a)), X(o, s);
                        }
                        return q(n || "", o);
                    }, c.create = n, c.createCount = J.createCount, c.onMismatch = U, c.throwMismatchError = U, c.createError = C, c.clear = p, c.clearConversions = function() {
                        let t;
                        for (t of u)s.get(t).conversionsTo = [];
                        l = 0;
                    }, c.addTypes = h, c._findType = f, c.referTo = function() {
                        const t = z(arguments).map((t)=>g(w(t))), e = G(arguments);
                        if ("function" != typeof e) throw new TypeError("Callback function expected as last argument");
                        return W(t, e);
                    }, c.referToSelf = $, c.convert = function(t, e) {
                        const r = f(e);
                        if (r.test(t)) return t;
                        const n = r.conversionsTo;
                        if (0 === n.length) throw new Error("There are no conversions to " + e + " defined.");
                        for(let e = 0; e < n.length; e++)if (f(n[e].from).test(t)) return n[e].convert(t);
                        throw new Error("Cannot convert " + t + " to " + e);
                    }, c.findSignature = y, c.find = function(t, e, r) {
                        return y(t, e, r).implementation;
                    }, c.isTypedFunction = m, c.warnAgainstDeprecatedThis = !0, c.addType = function(t, e) {
                        let r = "any";
                        !1 !== e && s.has("Object") && (r = "Object"), c.addTypes([
                            t
                        ], r);
                    }, c.addConversion = function(t) {
                        let e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {
                            override: !1
                        };
                        Q(t);
                        const r = f(t.to), n = r.conversionsTo.find((e)=>e.from === t.from);
                        if (n) {
                            if (!e || !e.override) throw new Error('There is already a conversion from "' + t.from + '" to "' + r.name + '"');
                            c.removeConversion({
                                from: n.from,
                                to: t.to,
                                convert: n.convert
                            });
                        }
                        r.conversionsTo.push({
                            from: t.from,
                            convert: t.convert,
                            index: l++
                        });
                    }, c.addConversions = function(t, e) {
                        t.forEach((t)=>c.addConversion(t, e));
                    }, c.removeConversion = function(t) {
                        Q(t);
                        const e = f(t.to), r = function(t, e) {
                            for(let r = 0; r < t.length; r++)if (e(t[r])) return t[r];
                        }(e.conversionsTo, (e)=>e.from === t.from);
                        if (!r) throw new Error("Attempt to remove nonexistent conversion from " + t.from + " to " + t.to);
                        if (r.convert !== t.convert) throw new Error("Conversion to remove does not match existing conversion");
                        const n = e.conversionsTo.indexOf(r);
                        e.conversionsTo.splice(n, 1);
                    }, c.resolve = function(t, e) {
                        if (!m(t)) throw new TypeError("Argument is not a typed-function.");
                        const r = t._typedFunctionData.signatures;
                        for(let t = 0; t < r.length; ++t)if (r[t].test(e)) return r[t];
                        return null;
                    }, c;
                }();
            }();
        },
        function(t, e) {
            t.exports = function(t) {
                return t.webpackPolyfill || (t.deprecate = function() {}, t.paths = [], t.children || (t.children = []), Object.defineProperty(t, "loaded", {
                    enumerable: !0,
                    get: function() {
                        return t.l;
                    }
                }), Object.defineProperty(t, "id", {
                    enumerable: !0,
                    get: function() {
                        return t.i;
                    }
                }), t.webpackPolyfill = 1), t;
            };
        },
        function(t, e) {
            (function(e) {
                t.exports = e;
            }).call(this, {});
        },
        function(t, e, r) {
            var n;
            !function(i) {
                "use strict";
                /*!
   *  decimal.js v10.4.3
   *  An arbitrary-precision Decimal type for JavaScript.
   *  https://github.com/MikeMcl/decimal.js
   *  Copyright (c) 2022 Michael Mclaughlin <M8ch88l@gmail.com>
   *  MIT Licence
   */ var o, a, s, u = 9e15, l = "0123456789abcdef", c = "2.3025850929940456840179914546843642076011014886287729760333279009675726096773524802359972050895982983419677840422862486334095254650828067566662873690987816894829072083255546808437998948262331985283935053089653777326288461633662222876982198867465436674744042432743651550489343149393914796194044002221051017141748003688084012647080685567743216228355220114804663715659121373450747856947683463616792101806445070648000277502684916746550586856935673420670581136429224554405758925724208241314695689016758940256776311356919292033376587141660230105703089634572075440370847469940168269282808481184289314848524948644871927809676271275775397027668605952496716674183485704422507197965004714951050492214776567636938662976979522110718264549734772662425709429322582798502585509785265383207606726317164309505995087807523710333101197857547331541421808427543863591778117054309827482385045648019095610299291824318237525357709750539565187697510374970888692180205189339507238539205144634197265287286965110862571492198849978748873771345686209167058", f = "3.1415926535897932384626433832795028841971693993751058209749445923078164062862089986280348253421170679821480865132823066470938446095505822317253594081284811174502841027019385211055596446229489549303819644288109756659334461284756482337867831652712019091456485669234603486104543266482133936072602491412737245870066063155881748815209209628292540917153643678925903600113305305488204665213841469519415116094330572703657595919530921861173819326117931051185480744623799627495673518857527248912279381830119491298336733624406566430860213949463952247371907021798609437027705392171762931767523846748184676694051320005681271452635608277857713427577896091736371787214684409012249534301465495853710507922796892589235420199561121290219608640344181598136297747713099605187072113499999983729780499510597317328160963185950244594553469083026425223082533446850352619311881710100031378387528865875332083814206171776691473035982534904287554687311595628638823537875937519577818577805321712268066130019278766111959092164201989380952572010654858632789", h = {
                    precision: 20,
                    rounding: 4,
                    modulo: 1,
                    toExpNeg: -7,
                    toExpPos: 21,
                    minE: -u,
                    maxE: u,
                    crypto: !1
                }, p = !0, d = "[DecimalError] Invalid argument: ", m = "[object Decimal]", y = Math.floor, g = Math.pow, v = /^0b([01]+(\.[01]*)?|\.[01]+)(p[+-]?\d+)?$/i, b = /^0x([0-9a-f]+(\.[0-9a-f]*)?|\.[0-9a-f]+)(p[+-]?\d+)?$/i, x = /^0o([0-7]+(\.[0-7]*)?|\.[0-7]+)(p[+-]?\d+)?$/i, w = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i, _ = 1e7, A = c.length - 1, E = f.length - 1, S = {
                    toStringTag: m
                };
                function M(t) {
                    var e, r, n, i = t.length - 1, o = "", a = t[0];
                    if (i > 0) {
                        for(o += a, e = 1; e < i; e++)(r = 7 - (n = t[e] + "").length) && (o += j(r)), o += n;
                        (r = 7 - (n = (a = t[e]) + "").length) && (o += j(r));
                    } else if (0 === a) return "0";
                    for(; a % 10 == 0;)a /= 10;
                    return o + a;
                }
                function k(t, e, r) {
                    if (t !== ~~t || t < e || t > r) throw Error(d + t);
                }
                function N(t, e, r, n) {
                    var i, o, a, s;
                    for(o = t[0]; o >= 10; o /= 10)--e;
                    return --e < 0 ? (e += 7, i = 0) : (i = Math.ceil((e + 1) / 7), e %= 7), o = g(10, 7 - e), s = t[i] % o | 0, null == n ? e < 3 ? (0 == e ? s = s / 100 | 0 : 1 == e && (s = s / 10 | 0), a = r < 4 && 99999 == s || r > 3 && 49999 == s || 5e4 == s || 0 == s) : a = (r < 4 && s + 1 == o || r > 3 && s + 1 == o / 2) && (t[i + 1] / o / 100 | 0) == g(10, e - 2) - 1 || (s == o / 2 || 0 == s) && 0 == (t[i + 1] / o / 100 | 0) : e < 4 ? (0 == e ? s = s / 1e3 | 0 : 1 == e ? s = s / 100 | 0 : 2 == e && (s = s / 10 | 0), a = (n || r < 4) && 9999 == s || !n && r > 3 && 4999 == s) : a = ((n || r < 4) && s + 1 == o || !n && r > 3 && s + 1 == o / 2) && (t[i + 1] / o / 1e3 | 0) == g(10, e - 3) - 1, a;
                }
                function C(t, e, r) {
                    for(var n, i, o = [
                        0
                    ], a = 0, s = t.length; a < s;){
                        for(i = o.length; i--;)o[i] *= e;
                        for(o[0] += l.indexOf(t.charAt(a++)), n = 0; n < o.length; n++)o[n] > r - 1 && (void 0 === o[n + 1] && (o[n + 1] = 0), o[n + 1] += o[n] / r | 0, o[n] %= r);
                    }
                    return o.reverse();
                }
                S.absoluteValue = S.abs = function() {
                    var t = new this.constructor(this);
                    return t.s < 0 && (t.s = 1), O(t);
                }, S.ceil = function() {
                    return O(new this.constructor(this), this.e + 1, 2);
                }, S.clampedTo = S.clamp = function(t, e) {
                    var r = this, n = r.constructor;
                    if (t = new n(t), e = new n(e), !t.s || !e.s) return new n(NaN);
                    if (t.gt(e)) throw Error(d + e);
                    return r.cmp(t) < 0 ? t : r.cmp(e) > 0 ? e : new n(r);
                }, S.comparedTo = S.cmp = function(t) {
                    var e, r, n, i, o = this, a = o.d, s = (t = new o.constructor(t)).d, u = o.s, l = t.s;
                    if (!a || !s) return u && l ? u !== l ? u : a === s ? 0 : !a ^ u < 0 ? 1 : -1 : NaN;
                    if (!a[0] || !s[0]) return a[0] ? u : s[0] ? -l : 0;
                    if (u !== l) return u;
                    if (o.e !== t.e) return o.e > t.e ^ u < 0 ? 1 : -1;
                    for(e = 0, r = (n = a.length) < (i = s.length) ? n : i; e < r; ++e)if (a[e] !== s[e]) return a[e] > s[e] ^ u < 0 ? 1 : -1;
                    return n === i ? 0 : n > i ^ u < 0 ? 1 : -1;
                }, S.cosine = S.cos = function() {
                    var t, e, r = this, n = r.constructor;
                    return r.d ? r.d[0] ? (t = n.precision, e = n.rounding, n.precision = t + Math.max(r.e, r.sd()) + 7, n.rounding = 1, r = function(t, e) {
                        var r, n, i;
                        if (e.isZero()) return e;
                        (n = e.d.length) < 32 ? (r = Math.ceil(n / 3), i = (1 / V(4, r)).toString()) : (r = 16, i = "2.3283064365386962890625e-10");
                        t.precision += r, e = $(t, 1, e.times(i), new t(1));
                        for(var o = r; o--;){
                            var a = e.times(e);
                            e = a.times(a).minus(a).times(8).plus(1);
                        }
                        return t.precision -= r, e;
                    }(n, Z(n, r)), n.precision = t, n.rounding = e, O(2 == s || 3 == s ? r.neg() : r, t, e, !0)) : new n(1) : new n(NaN);
                }, S.cubeRoot = S.cbrt = function() {
                    var t, e, r, n, i, o, a, s, u, l, c = this, f = c.constructor;
                    if (!c.isFinite() || c.isZero()) return new f(c);
                    for(p = !1, (o = c.s * g(c.s * c, 1 / 3)) && Math.abs(o) != 1 / 0 ? n = new f(o.toString()) : (r = M(c.d), (o = ((t = c.e) - r.length + 1) % 3) && (r += 1 == o || -2 == o ? "0" : "00"), o = g(r, 1 / 3), t = y((t + 1) / 3) - (t % 3 == (t < 0 ? -1 : 2)), (n = new f(r = o == 1 / 0 ? "5e" + t : (r = o.toExponential()).slice(0, r.indexOf("e") + 1) + t)).s = c.s), a = (t = f.precision) + 3;;)if (l = (u = (s = n).times(s).times(s)).plus(c), n = D(l.plus(c).times(s), l.plus(u), a + 2, 1), M(s.d).slice(0, a) === (r = M(n.d)).slice(0, a)) {
                        if ("9999" != (r = r.slice(a - 3, a + 1)) && (i || "4999" != r)) {
                            +r && (+r.slice(1) || "5" != r.charAt(0)) || (O(n, t + 1, 1), e = !n.times(n).times(n).eq(c));
                            break;
                        }
                        if (!i && (O(s, t + 1, 0), s.times(s).times(s).eq(c))) {
                            n = s;
                            break;
                        }
                        a += 4, i = 1;
                    }
                    return p = !0, O(n, t, f.rounding, e);
                }, S.decimalPlaces = S.dp = function() {
                    var t, e = this.d, r = NaN;
                    if (e) {
                        if (r = 7 * ((t = e.length - 1) - y(this.e / 7)), t = e[t]) for(; t % 10 == 0; t /= 10)r--;
                        r < 0 && (r = 0);
                    }
                    return r;
                }, S.dividedBy = S.div = function(t) {
                    return D(this, new this.constructor(t));
                }, S.dividedToIntegerBy = S.divToInt = function(t) {
                    var e = this.constructor;
                    return O(D(this, new e(t), 0, 1, 1), e.precision, e.rounding);
                }, S.equals = S.eq = function(t) {
                    return 0 === this.cmp(t);
                }, S.floor = function() {
                    return O(new this.constructor(this), this.e + 1, 3);
                }, S.greaterThan = S.gt = function(t) {
                    return this.cmp(t) > 0;
                }, S.greaterThanOrEqualTo = S.gte = function(t) {
                    var e = this.cmp(t);
                    return 1 == e || 0 === e;
                }, S.hyperbolicCosine = S.cosh = function() {
                    var t, e, r, n, i, o = this, a = o.constructor, s = new a(1);
                    if (!o.isFinite()) return new a(o.s ? 1 / 0 : NaN);
                    if (o.isZero()) return s;
                    r = a.precision, n = a.rounding, a.precision = r + Math.max(o.e, o.sd()) + 4, a.rounding = 1, (i = o.d.length) < 32 ? e = (1 / V(4, t = Math.ceil(i / 3))).toString() : (t = 16, e = "2.3283064365386962890625e-10"), o = $(a, 1, o.times(e), new a(1), !0);
                    for(var u, l = t, c = new a(8); l--;)u = o.times(o), o = s.minus(u.times(c.minus(u.times(c))));
                    return O(o, a.precision = r, a.rounding = n, !0);
                }, S.hyperbolicSine = S.sinh = function() {
                    var t, e, r, n, i = this, o = i.constructor;
                    if (!i.isFinite() || i.isZero()) return new o(i);
                    if (e = o.precision, r = o.rounding, o.precision = e + Math.max(i.e, i.sd()) + 4, o.rounding = 1, (n = i.d.length) < 3) i = $(o, 2, i, i, !0);
                    else {
                        t = (t = 1.4 * Math.sqrt(n)) > 16 ? 16 : 0 | t, i = $(o, 2, i = i.times(1 / V(5, t)), i, !0);
                        for(var a, s = new o(5), u = new o(16), l = new o(20); t--;)a = i.times(i), i = i.times(s.plus(a.times(u.times(a).plus(l))));
                    }
                    return o.precision = e, o.rounding = r, O(i, e, r, !0);
                }, S.hyperbolicTangent = S.tanh = function() {
                    var t, e, r = this, n = r.constructor;
                    return r.isFinite() ? r.isZero() ? new n(r) : (t = n.precision, e = n.rounding, n.precision = t + 7, n.rounding = 1, D(r.sinh(), r.cosh(), n.precision = t, n.rounding = e)) : new n(r.s);
                }, S.inverseCosine = S.acos = function() {
                    var t, e = this, r = e.constructor, n = e.abs().cmp(1), i = r.precision, o = r.rounding;
                    return -1 !== n ? 0 === n ? e.isNeg() ? I(r, i, o) : new r(0) : new r(NaN) : e.isZero() ? I(r, i + 4, o).times(.5) : (r.precision = i + 6, r.rounding = 1, e = e.asin(), t = I(r, i + 4, o).times(.5), r.precision = i, r.rounding = o, t.minus(e));
                }, S.inverseHyperbolicCosine = S.acosh = function() {
                    var t, e, r = this, n = r.constructor;
                    return r.lte(1) ? new n(r.eq(1) ? 0 : NaN) : r.isFinite() ? (t = n.precision, e = n.rounding, n.precision = t + Math.max(Math.abs(r.e), r.sd()) + 4, n.rounding = 1, p = !1, r = r.times(r).minus(1).sqrt().plus(r), p = !0, n.precision = t, n.rounding = e, r.ln()) : new n(r);
                }, S.inverseHyperbolicSine = S.asinh = function() {
                    var t, e, r = this, n = r.constructor;
                    return !r.isFinite() || r.isZero() ? new n(r) : (t = n.precision, e = n.rounding, n.precision = t + 2 * Math.max(Math.abs(r.e), r.sd()) + 6, n.rounding = 1, p = !1, r = r.times(r).plus(1).sqrt().plus(r), p = !0, n.precision = t, n.rounding = e, r.ln());
                }, S.inverseHyperbolicTangent = S.atanh = function() {
                    var t, e, r, n, i = this, o = i.constructor;
                    return i.isFinite() ? i.e >= 0 ? new o(i.abs().eq(1) ? i.s / 0 : i.isZero() ? i : NaN) : (t = o.precision, e = o.rounding, n = i.sd(), Math.max(n, t) < 2 * -i.e - 1 ? O(new o(i), t, e, !0) : (o.precision = r = n - i.e, i = D(i.plus(1), new o(1).minus(i), r + t, 1), o.precision = t + 4, o.rounding = 1, i = i.ln(), o.precision = t, o.rounding = e, i.times(.5))) : new o(NaN);
                }, S.inverseSine = S.asin = function() {
                    var t, e, r, n, i = this, o = i.constructor;
                    return i.isZero() ? new o(i) : (e = i.abs().cmp(1), r = o.precision, n = o.rounding, -1 !== e ? 0 === e ? ((t = I(o, r + 4, n).times(.5)).s = i.s, t) : new o(NaN) : (o.precision = r + 6, o.rounding = 1, i = i.div(new o(1).minus(i.times(i)).sqrt().plus(1)).atan(), o.precision = r, o.rounding = n, i.times(2)));
                }, S.inverseTangent = S.atan = function() {
                    var t, e, r, n, i, o, a, s, u, l = this, c = l.constructor, f = c.precision, h = c.rounding;
                    if (l.isFinite()) {
                        if (l.isZero()) return new c(l);
                        if (l.abs().eq(1) && f + 4 <= E) return (a = I(c, f + 4, h).times(.25)).s = l.s, a;
                    } else {
                        if (!l.s) return new c(NaN);
                        if (f + 4 <= E) return (a = I(c, f + 4, h).times(.5)).s = l.s, a;
                    }
                    for(c.precision = s = f + 10, c.rounding = 1, t = r = Math.min(28, s / 7 + 2 | 0); t; --t)l = l.div(l.times(l).plus(1).sqrt().plus(1));
                    for(p = !1, e = Math.ceil(s / 7), n = 1, u = l.times(l), a = new c(l), i = l; -1 !== t;)if (i = i.times(u), o = a.minus(i.div(n += 2)), i = i.times(u), void 0 !== (a = o.plus(i.div(n += 2))).d[e]) for(t = e; a.d[t] === o.d[t] && t--;);
                    return r && (a = a.times(2 << r - 1)), p = !0, O(a, c.precision = f, c.rounding = h, !0);
                }, S.isFinite = function() {
                    return !!this.d;
                }, S.isInteger = S.isInt = function() {
                    return !!this.d && y(this.e / 7) > this.d.length - 2;
                }, S.isNaN = function() {
                    return !this.s;
                }, S.isNegative = S.isNeg = function() {
                    return this.s < 0;
                }, S.isPositive = S.isPos = function() {
                    return this.s > 0;
                }, S.isZero = function() {
                    return !!this.d && 0 === this.d[0];
                }, S.lessThan = S.lt = function(t) {
                    return this.cmp(t) < 0;
                }, S.lessThanOrEqualTo = S.lte = function(t) {
                    return this.cmp(t) < 1;
                }, S.logarithm = S.log = function(t) {
                    var e, r, n, i, o, a, s, u, l = this.constructor, c = l.precision, f = l.rounding;
                    if (null == t) t = new l(10), e = !0;
                    else {
                        if (r = (t = new l(t)).d, t.s < 0 || !r || !r[0] || t.eq(1)) return new l(NaN);
                        e = t.eq(10);
                    }
                    if (r = this.d, this.s < 0 || !r || !r[0] || this.eq(1)) return new l(r && !r[0] ? -1 / 0 : 1 != this.s ? NaN : r ? 0 : 1 / 0);
                    if (e) {
                        if (r.length > 1) o = !0;
                        else {
                            for(i = r[0]; i % 10 == 0;)i /= 10;
                            o = 1 !== i;
                        }
                    }
                    if (p = !1, a = z(this, s = c + 5), n = e ? P(l, s + 10) : z(t, s), N((u = D(a, n, s, 1)).d, i = c, f)) do if (a = z(this, s += 10), n = e ? P(l, s + 10) : z(t, s), u = D(a, n, s, 1), !o) {
                        +M(u.d).slice(i + 1, i + 15) + 1 == 1e14 && (u = O(u, c + 1, 0));
                        break;
                    }
                    while (N(u.d, i += 10, f));
                    return p = !0, O(u, c, f);
                }, S.minus = S.sub = function(t) {
                    var e, r, n, i, o, a, s, u, l, c, f, h, d = this, m = d.constructor;
                    if (t = new m(t), !d.d || !t.d) return d.s && t.s ? d.d ? t.s = -t.s : t = new m(t.d || d.s !== t.s ? d : NaN) : t = new m(NaN), t;
                    if (d.s != t.s) return t.s = -t.s, d.plus(t);
                    if (l = d.d, h = t.d, s = m.precision, u = m.rounding, !l[0] || !h[0]) {
                        if (h[0]) t.s = -t.s;
                        else {
                            if (!l[0]) return new m(3 === u ? -0 : 0);
                            t = new m(d);
                        }
                        return p ? O(t, s, u) : t;
                    }
                    if (r = y(t.e / 7), c = y(d.e / 7), l = l.slice(), o = c - r) {
                        for((f = o < 0) ? (e = l, o = -o, a = h.length) : (e = h, r = c, a = l.length), o > (n = Math.max(Math.ceil(s / 7), a) + 2) && (o = n, e.length = 1), e.reverse(), n = o; n--;)e.push(0);
                        e.reverse();
                    } else {
                        for((f = (n = l.length) < (a = h.length)) && (a = n), n = 0; n < a; n++)if (l[n] != h[n]) {
                            f = l[n] < h[n];
                            break;
                        }
                        o = 0;
                    }
                    for(f && (e = l, l = h, h = e, t.s = -t.s), a = l.length, n = h.length - a; n > 0; --n)l[a++] = 0;
                    for(n = h.length; n > o;){
                        if (l[--n] < h[n]) {
                            for(i = n; i && 0 === l[--i];)l[i] = _ - 1;
                            --l[i], l[n] += _;
                        }
                        l[n] -= h[n];
                    }
                    for(; 0 === l[--a];)l.pop();
                    for(; 0 === l[0]; l.shift())--r;
                    return l[0] ? (t.d = l, t.e = F(l, r), p ? O(t, s, u) : t) : new m(3 === u ? -0 : 0);
                }, S.modulo = S.mod = function(t) {
                    var e, r = this, n = r.constructor;
                    return t = new n(t), !r.d || !t.s || t.d && !t.d[0] ? new n(NaN) : !t.d || r.d && !r.d[0] ? O(new n(r), n.precision, n.rounding) : (p = !1, 9 == n.modulo ? (e = D(r, t.abs(), 0, 3, 1)).s *= t.s : e = D(r, t, 0, n.modulo, 1), e = e.times(t), p = !0, r.minus(e));
                }, S.naturalExponential = S.exp = function() {
                    return U(this);
                }, S.naturalLogarithm = S.ln = function() {
                    return z(this);
                }, S.negated = S.neg = function() {
                    var t = new this.constructor(this);
                    return t.s = -t.s, O(t);
                }, S.plus = S.add = function(t) {
                    var e, r, n, i, o, a, s, u, l, c, f = this, h = f.constructor;
                    if (t = new h(t), !f.d || !t.d) return f.s && t.s ? f.d || (t = new h(t.d || f.s === t.s ? f : NaN)) : t = new h(NaN), t;
                    if (f.s != t.s) return t.s = -t.s, f.minus(t);
                    if (l = f.d, c = t.d, s = h.precision, u = h.rounding, !l[0] || !c[0]) return c[0] || (t = new h(f)), p ? O(t, s, u) : t;
                    if (o = y(f.e / 7), n = y(t.e / 7), l = l.slice(), i = o - n) {
                        for(i < 0 ? (r = l, i = -i, a = c.length) : (r = c, n = o, a = l.length), i > (a = (o = Math.ceil(s / 7)) > a ? o + 1 : a + 1) && (i = a, r.length = 1), r.reverse(); i--;)r.push(0);
                        r.reverse();
                    }
                    for((a = l.length) - (i = c.length) < 0 && (i = a, r = c, c = l, l = r), e = 0; i;)e = (l[--i] = l[i] + c[i] + e) / _ | 0, l[i] %= _;
                    for(e && (l.unshift(e), ++n), a = l.length; 0 == l[--a];)l.pop();
                    return t.d = l, t.e = F(l, n), p ? O(t, s, u) : t;
                }, S.precision = S.sd = function(t) {
                    var e, r = this;
                    if (void 0 !== t && t !== !!t && 1 !== t && 0 !== t) throw Error(d + t);
                    return r.d ? (e = B(r.d), t && r.e + 1 > e && (e = r.e + 1)) : e = NaN, e;
                }, S.round = function() {
                    var t = this, e = t.constructor;
                    return O(new e(t), t.e + 1, e.rounding);
                }, S.sine = S.sin = function() {
                    var t, e, r = this, n = r.constructor;
                    return r.isFinite() ? r.isZero() ? new n(r) : (t = n.precision, e = n.rounding, n.precision = t + Math.max(r.e, r.sd()) + 7, n.rounding = 1, r = function(t, e) {
                        var r, n = e.d.length;
                        if (n < 3) return e.isZero() ? e : $(t, 2, e, e);
                        r = (r = 1.4 * Math.sqrt(n)) > 16 ? 16 : 0 | r, e = e.times(1 / V(5, r)), e = $(t, 2, e, e);
                        for(var i, o = new t(5), a = new t(16), s = new t(20); r--;)i = e.times(e), e = e.times(o.plus(i.times(a.times(i).minus(s))));
                        return e;
                    }(n, Z(n, r)), n.precision = t, n.rounding = e, O(s > 2 ? r.neg() : r, t, e, !0)) : new n(NaN);
                }, S.squareRoot = S.sqrt = function() {
                    var t, e, r, n, i, o, a = this, s = a.d, u = a.e, l = a.s, c = a.constructor;
                    if (1 !== l || !s || !s[0]) return new c(!l || l < 0 && (!s || s[0]) ? NaN : s ? a : 1 / 0);
                    for(p = !1, 0 == (l = Math.sqrt(+a)) || l == 1 / 0 ? (((e = M(s)).length + u) % 2 == 0 && (e += "0"), l = Math.sqrt(e), u = y((u + 1) / 2) - (u < 0 || u % 2), n = new c(e = l == 1 / 0 ? "5e" + u : (e = l.toExponential()).slice(0, e.indexOf("e") + 1) + u)) : n = new c(l.toString()), r = (u = c.precision) + 3;;)if (n = (o = n).plus(D(a, o, r + 2, 1)).times(.5), M(o.d).slice(0, r) === (e = M(n.d)).slice(0, r)) {
                        if ("9999" != (e = e.slice(r - 3, r + 1)) && (i || "4999" != e)) {
                            +e && (+e.slice(1) || "5" != e.charAt(0)) || (O(n, u + 1, 1), t = !n.times(n).eq(a));
                            break;
                        }
                        if (!i && (O(o, u + 1, 0), o.times(o).eq(a))) {
                            n = o;
                            break;
                        }
                        r += 4, i = 1;
                    }
                    return p = !0, O(n, u, c.rounding, t);
                }, S.tangent = S.tan = function() {
                    var t, e, r = this, n = r.constructor;
                    return r.isFinite() ? r.isZero() ? new n(r) : (t = n.precision, e = n.rounding, n.precision = t + 10, n.rounding = 1, (r = r.sin()).s = 1, r = D(r, new n(1).minus(r.times(r)).sqrt(), t + 10, 0), n.precision = t, n.rounding = e, O(2 == s || 4 == s ? r.neg() : r, t, e, !0)) : new n(NaN);
                }, S.times = S.mul = function(t) {
                    var e, r, n, i, o, a, s, u, l, c = this, f = c.constructor, h = c.d, d = (t = new f(t)).d;
                    if (t.s *= c.s, !(h && h[0] && d && d[0])) return new f(!t.s || h && !h[0] && !d || d && !d[0] && !h ? NaN : h && d ? 0 * t.s : t.s / 0);
                    for(r = y(c.e / 7) + y(t.e / 7), (u = h.length) < (l = d.length) && (o = h, h = d, d = o, a = u, u = l, l = a), o = [], n = a = u + l; n--;)o.push(0);
                    for(n = l; --n >= 0;){
                        for(e = 0, i = u + n; i > n;)s = o[i] + d[n] * h[i - n - 1] + e, o[i--] = s % _ | 0, e = s / _ | 0;
                        o[i] = (o[i] + e) % _ | 0;
                    }
                    for(; !o[--a];)o.pop();
                    return e ? ++r : o.shift(), t.d = o, t.e = F(o, r), p ? O(t, f.precision, f.rounding) : t;
                }, S.toBinary = function(t, e) {
                    return Y(this, 2, t, e);
                }, S.toDecimalPlaces = S.toDP = function(t, e) {
                    var r = this, n = r.constructor;
                    return r = new n(r), void 0 === t ? r : (k(t, 0, 1e9), void 0 === e ? e = n.rounding : k(e, 0, 8), O(r, t + r.e + 1, e));
                }, S.toExponential = function(t, e) {
                    var r, n = this, i = n.constructor;
                    return void 0 === t ? r = T(n, !0) : (k(t, 0, 1e9), void 0 === e ? e = i.rounding : k(e, 0, 8), r = T(n = O(new i(n), t + 1, e), !0, t + 1)), n.isNeg() && !n.isZero() ? "-" + r : r;
                }, S.toFixed = function(t, e) {
                    var r, n, i = this, o = i.constructor;
                    return void 0 === t ? r = T(i) : (k(t, 0, 1e9), void 0 === e ? e = o.rounding : k(e, 0, 8), r = T(n = O(new o(i), t + i.e + 1, e), !1, t + n.e + 1)), i.isNeg() && !i.isZero() ? "-" + r : r;
                }, S.toFraction = function(t) {
                    var e, r, n, i, o, a, s, u, l, c, f, h, m = this, y = m.d, v = m.constructor;
                    if (!y) return new v(m);
                    if (l = r = new v(1), n = u = new v(0), a = (o = (e = new v(n)).e = B(y) - m.e - 1) % 7, e.d[0] = g(10, a < 0 ? 7 + a : a), null == t) t = o > 0 ? e : l;
                    else {
                        if (!(s = new v(t)).isInt() || s.lt(l)) throw Error(d + s);
                        t = s.gt(e) ? o > 0 ? e : l : s;
                    }
                    for(p = !1, s = new v(M(y)), c = v.precision, v.precision = o = 7 * y.length * 2; f = D(s, e, 0, 1, 1), 1 != (i = r.plus(f.times(n))).cmp(t);)r = n, n = i, i = l, l = u.plus(f.times(i)), u = i, i = e, e = s.minus(f.times(i)), s = i;
                    return i = D(t.minus(r), n, 0, 1, 1), u = u.plus(i.times(l)), r = r.plus(i.times(n)), u.s = l.s = m.s, h = D(l, n, o, 1).minus(m).abs().cmp(D(u, r, o, 1).minus(m).abs()) < 1 ? [
                        l,
                        n
                    ] : [
                        u,
                        r
                    ], v.precision = c, p = !0, h;
                }, S.toHexadecimal = S.toHex = function(t, e) {
                    return Y(this, 16, t, e);
                }, S.toNearest = function(t, e) {
                    var r = this, n = r.constructor;
                    if (r = new n(r), null == t) {
                        if (!r.d) return r;
                        t = new n(1), e = n.rounding;
                    } else {
                        if (t = new n(t), void 0 === e ? e = n.rounding : k(e, 0, 8), !r.d) return t.s ? r : t;
                        if (!t.d) return t.s && (t.s = r.s), t;
                    }
                    return t.d[0] ? (p = !1, r = D(r, t, 0, e, 1).times(t), p = !0, O(r)) : (t.s = r.s, r = t), r;
                }, S.toNumber = function() {
                    return +this;
                }, S.toOctal = function(t, e) {
                    return Y(this, 8, t, e);
                }, S.toPower = S.pow = function(t) {
                    var e, r, n, i, o, a, s = this, u = s.constructor, l = +(t = new u(t));
                    if (!(s.d && t.d && s.d[0] && t.d[0])) return new u(g(+s, l));
                    if ((s = new u(s)).eq(1)) return s;
                    if (n = u.precision, o = u.rounding, t.eq(1)) return O(s, n, o);
                    if ((e = y(t.e / 7)) >= t.d.length - 1 && (r = l < 0 ? -l : l) <= 9007199254740991) return i = R(u, s, r, n), t.s < 0 ? new u(1).div(i) : O(i, n, o);
                    if ((a = s.s) < 0) {
                        if (e < t.d.length - 1) return new u(NaN);
                        if (0 == (1 & t.d[e]) && (a = 1), 0 == s.e && 1 == s.d[0] && 1 == s.d.length) return s.s = a, s;
                    }
                    return (e = 0 != (r = g(+s, l)) && isFinite(r) ? new u(r + "").e : y(l * (Math.log("0." + M(s.d)) / Math.LN10 + s.e + 1))) > u.maxE + 1 || e < u.minE - 1 ? new u(e > 0 ? a / 0 : 0) : (p = !1, u.rounding = s.s = 1, r = Math.min(12, (e + "").length), (i = U(t.times(z(s, n + r)), n)).d && N((i = O(i, n + 5, 1)).d, n, o) && (e = n + 10, +M((i = O(U(t.times(z(s, e + r)), e), e + 5, 1)).d).slice(n + 1, n + 15) + 1 == 1e14 && (i = O(i, n + 1, 0))), i.s = a, p = !0, u.rounding = o, O(i, n, o));
                }, S.toPrecision = function(t, e) {
                    var r, n = this, i = n.constructor;
                    return void 0 === t ? r = T(n, n.e <= i.toExpNeg || n.e >= i.toExpPos) : (k(t, 1, 1e9), void 0 === e ? e = i.rounding : k(e, 0, 8), r = T(n = O(new i(n), t, e), t <= n.e || n.e <= i.toExpNeg, t)), n.isNeg() && !n.isZero() ? "-" + r : r;
                }, S.toSignificantDigits = S.toSD = function(t, e) {
                    var r = this.constructor;
                    return void 0 === t ? (t = r.precision, e = r.rounding) : (k(t, 1, 1e9), void 0 === e ? e = r.rounding : k(e, 0, 8)), O(new r(this), t, e);
                }, S.toString = function() {
                    var t = this, e = t.constructor, r = T(t, t.e <= e.toExpNeg || t.e >= e.toExpPos);
                    return t.isNeg() && !t.isZero() ? "-" + r : r;
                }, S.truncated = S.trunc = function() {
                    return O(new this.constructor(this), this.e + 1, 1);
                }, S.valueOf = S.toJSON = function() {
                    var t = this, e = t.constructor, r = T(t, t.e <= e.toExpNeg || t.e >= e.toExpPos);
                    return t.isNeg() ? "-" + r : r;
                };
                var D = function() {
                    function t(t, e, r) {
                        var n, i = 0, o = t.length;
                        for(t = t.slice(); o--;)n = t[o] * e + i, t[o] = n % r | 0, i = n / r | 0;
                        return i && t.unshift(i), t;
                    }
                    function e(t, e, r, n) {
                        var i, o;
                        if (r != n) o = r > n ? 1 : -1;
                        else for(i = o = 0; i < r; i++)if (t[i] != e[i]) {
                            o = t[i] > e[i] ? 1 : -1;
                            break;
                        }
                        return o;
                    }
                    function r(t, e, r, n) {
                        for(var i = 0; r--;)t[r] -= i, i = t[r] < e[r] ? 1 : 0, t[r] = i * n + t[r] - e[r];
                        for(; !t[0] && t.length > 1;)t.shift();
                    }
                    return function(n, i, o, s, u, l) {
                        var c, f, h, p, d, m, g, v, b, x, w, A, E, S, M, k, N, C, D, T, F = n.constructor, P = n.s == i.s ? 1 : -1, I = n.d, B = i.d;
                        if (!(I && I[0] && B && B[0])) return new F(n.s && i.s && (I ? !B || I[0] != B[0] : B) ? I && 0 == I[0] || !B ? 0 * P : P / 0 : NaN);
                        for(l ? (d = 1, f = n.e - i.e) : (l = _, d = 7, f = y(n.e / d) - y(i.e / d)), D = B.length, N = I.length, x = (b = new F(P)).d = [], h = 0; B[h] == (I[h] || 0); h++);
                        if (B[h] > (I[h] || 0) && f--, null == o ? (S = o = F.precision, s = F.rounding) : S = u ? o + (n.e - i.e) + 1 : o, S < 0) x.push(1), m = !0;
                        else {
                            if (S = S / d + 2 | 0, h = 0, 1 == D) {
                                for(p = 0, B = B[0], S++; (h < N || p) && S--; h++)M = p * l + (I[h] || 0), x[h] = M / B | 0, p = M % B | 0;
                                m = p || h < N;
                            } else {
                                for((p = l / (B[0] + 1) | 0) > 1 && (B = t(B, p, l), I = t(I, p, l), D = B.length, N = I.length), k = D, A = (w = I.slice(0, D)).length; A < D;)w[A++] = 0;
                                (T = B.slice()).unshift(0), C = B[0], B[1] >= l / 2 && ++C;
                                do p = 0, (c = e(B, w, D, A)) < 0 ? (E = w[0], D != A && (E = E * l + (w[1] || 0)), (p = E / C | 0) > 1 ? (p >= l && (p = l - 1), 1 == (c = e(g = t(B, p, l), w, v = g.length, A = w.length)) && (p--, r(g, D < v ? T : B, v, l))) : (0 == p && (c = p = 1), g = B.slice()), (v = g.length) < A && g.unshift(0), r(w, g, A, l), -1 == c && (c = e(B, w, D, A = w.length)) < 1 && (p++, r(w, D < A ? T : B, A, l)), A = w.length) : 0 === c && (p++, w = [
                                    0
                                ]), x[h++] = p, c && w[0] ? w[A++] = I[k] || 0 : (w = [
                                    I[k]
                                ], A = 1);
                                while ((k++ < N || void 0 !== w[0]) && S--);
                                m = void 0 !== w[0];
                            }
                            x[0] || x.shift();
                        }
                        if (1 == d) b.e = f, a = m;
                        else {
                            for(h = 1, p = x[0]; p >= 10; p /= 10)h++;
                            b.e = h + f * d - 1, O(b, u ? o + b.e + 1 : o, s, m);
                        }
                        return b;
                    };
                }();
                function O(t, e, r, n) {
                    var i, o, a, s, u, l, c, f, h, d = t.constructor;
                    t: if (null != e) {
                        if (!(f = t.d)) return t;
                        for(i = 1, s = f[0]; s >= 10; s /= 10)i++;
                        if ((o = e - i) < 0) o += 7, a = e, u = (c = f[h = 0]) / g(10, i - a - 1) % 10 | 0;
                        else if ((h = Math.ceil((o + 1) / 7)) >= (s = f.length)) {
                            if (!n) break t;
                            for(; s++ <= h;)f.push(0);
                            c = u = 0, i = 1, a = (o %= 7) - 7 + 1;
                        } else {
                            for(c = s = f[h], i = 1; s >= 10; s /= 10)i++;
                            u = (a = (o %= 7) - 7 + i) < 0 ? 0 : c / g(10, i - a - 1) % 10 | 0;
                        }
                        if (n = n || e < 0 || void 0 !== f[h + 1] || (a < 0 ? c : c % g(10, i - a - 1)), l = r < 4 ? (u || n) && (0 == r || r == (t.s < 0 ? 3 : 2)) : u > 5 || 5 == u && (4 == r || n || 6 == r && (o > 0 ? a > 0 ? c / g(10, i - a) : 0 : f[h - 1]) % 10 & 1 || r == (t.s < 0 ? 8 : 7)), e < 1 || !f[0]) return f.length = 0, l ? (e -= t.e + 1, f[0] = g(10, (7 - e % 7) % 7), t.e = -e || 0) : f[0] = t.e = 0, t;
                        if (0 == o ? (f.length = h, s = 1, h--) : (f.length = h + 1, s = g(10, 7 - o), f[h] = a > 0 ? (c / g(10, i - a) % g(10, a) | 0) * s : 0), l) for(;;){
                            if (0 == h) {
                                for(o = 1, a = f[0]; a >= 10; a /= 10)o++;
                                for(a = f[0] += s, s = 1; a >= 10; a /= 10)s++;
                                o != s && (t.e++, f[0] == _ && (f[0] = 1));
                                break;
                            }
                            if (f[h] += s, f[h] != _) break;
                            f[h--] = 0, s = 1;
                        }
                        for(o = f.length; 0 === f[--o];)f.pop();
                    }
                    return p && (t.e > d.maxE ? (t.d = null, t.e = NaN) : t.e < d.minE && (t.e = 0, t.d = [
                        0
                    ])), t;
                }
                function T(t, e, r) {
                    if (!t.isFinite()) return G(t);
                    var n, i = t.e, o = M(t.d), a = o.length;
                    return e ? (r && (n = r - a) > 0 ? o = o.charAt(0) + "." + o.slice(1) + j(n) : a > 1 && (o = o.charAt(0) + "." + o.slice(1)), o = o + (t.e < 0 ? "e" : "e+") + t.e) : i < 0 ? (o = "0." + j(-i - 1) + o, r && (n = r - a) > 0 && (o += j(n))) : i >= a ? (o += j(i + 1 - a), r && (n = r - i - 1) > 0 && (o = o + "." + j(n))) : ((n = i + 1) < a && (o = o.slice(0, n) + "." + o.slice(n)), r && (n = r - a) > 0 && (i + 1 === a && (o += "."), o += j(n))), o;
                }
                function F(t, e) {
                    var r = t[0];
                    for(e *= 7; r >= 10; r /= 10)e++;
                    return e;
                }
                function P(t, e, r) {
                    if (e > A) throw p = !0, r && (t.precision = r), Error("[DecimalError] Precision limit exceeded");
                    return O(new t(c), e, 1, !0);
                }
                function I(t, e, r) {
                    if (e > E) throw Error("[DecimalError] Precision limit exceeded");
                    return O(new t(f), e, r, !0);
                }
                function B(t) {
                    var e = t.length - 1, r = 7 * e + 1;
                    if (e = t[e]) {
                        for(; e % 10 == 0; e /= 10)r--;
                        for(e = t[0]; e >= 10; e /= 10)r++;
                    }
                    return r;
                }
                function j(t) {
                    for(var e = ""; t--;)e += "0";
                    return e;
                }
                function R(t, e, r, n) {
                    var i, o = new t(1), a = Math.ceil(n / 7 + 4);
                    for(p = !1;;){
                        if (r % 2 && K((o = o.times(e)).d, a) && (i = !0), 0 === (r = y(r / 2))) {
                            r = o.d.length - 1, i && 0 === o.d[r] && ++o.d[r];
                            break;
                        }
                        K((e = e.times(e)).d, a);
                    }
                    return p = !0, o;
                }
                function L(t) {
                    return 1 & t.d[t.d.length - 1];
                }
                function q(t, e, r) {
                    for(var n, i = new t(e[0]), o = 0; ++o < e.length;){
                        if (!(n = new t(e[o])).s) {
                            i = n;
                            break;
                        }
                        i[r](n) && (i = n);
                    }
                    return i;
                }
                function U(t, e) {
                    var r, n, i, o, a, s, u, l = 0, c = 0, f = 0, h = t.constructor, d = h.rounding, m = h.precision;
                    if (!t.d || !t.d[0] || t.e > 17) return new h(t.d ? t.d[0] ? t.s < 0 ? 0 : 1 / 0 : 1 : t.s ? t.s < 0 ? 0 : t : NaN);
                    for(null == e ? (p = !1, u = m) : u = e, s = new h(.03125); t.e > -2;)t = t.times(s), f += 5;
                    for(u += n = Math.log(g(2, f)) / Math.LN10 * 2 + 5 | 0, r = o = a = new h(1), h.precision = u;;){
                        if (o = O(o.times(t), u, 1), r = r.times(++c), M((s = a.plus(D(o, r, u, 1))).d).slice(0, u) === M(a.d).slice(0, u)) {
                            for(i = f; i--;)a = O(a.times(a), u, 1);
                            if (null != e) return h.precision = m, a;
                            if (!(l < 3 && N(a.d, u - n, d, l))) return O(a, h.precision = m, d, p = !0);
                            h.precision = u += 10, r = o = s = new h(1), c = 0, l++;
                        }
                        a = s;
                    }
                }
                function z(t, e) {
                    var r, n, i, o, a, s, u, l, c, f, h, d = 1, m = t, y = m.d, g = m.constructor, v = g.rounding, b = g.precision;
                    if (m.s < 0 || !y || !y[0] || !m.e && 1 == y[0] && 1 == y.length) return new g(y && !y[0] ? -1 / 0 : 1 != m.s ? NaN : y ? 0 : m);
                    if (null == e ? (p = !1, c = b) : c = e, g.precision = c += 10, n = (r = M(y)).charAt(0), !(Math.abs(o = m.e) < 15e14)) return l = P(g, c + 2, b).times(o + ""), m = z(new g(n + "." + r.slice(1)), c - 10).plus(l), g.precision = b, null == e ? O(m, b, v, p = !0) : m;
                    for(; n < 7 && 1 != n || 1 == n && r.charAt(1) > 3;)n = (r = M((m = m.times(t)).d)).charAt(0), d++;
                    for(o = m.e, n > 1 ? (m = new g("0." + r), o++) : m = new g(n + "." + r.slice(1)), f = m, u = a = m = D(m.minus(1), m.plus(1), c, 1), h = O(m.times(m), c, 1), i = 3;;){
                        if (a = O(a.times(h), c, 1), M((l = u.plus(D(a, new g(i), c, 1))).d).slice(0, c) === M(u.d).slice(0, c)) {
                            if (u = u.times(2), 0 !== o && (u = u.plus(P(g, c + 2, b).times(o + ""))), u = D(u, new g(d), c, 1), null != e) return g.precision = b, u;
                            if (!N(u.d, c - 10, v, s)) return O(u, g.precision = b, v, p = !0);
                            g.precision = c += 10, l = a = m = D(f.minus(1), f.plus(1), c, 1), h = O(m.times(m), c, 1), i = s = 1;
                        }
                        u = l, i += 2;
                    }
                }
                function G(t) {
                    return String(t.s * t.s / 0);
                }
                function H(t, e) {
                    var r, n, i;
                    for((r = e.indexOf(".")) > -1 && (e = e.replace(".", "")), (n = e.search(/e/i)) > 0 ? (r < 0 && (r = n), r += +e.slice(n + 1), e = e.substring(0, n)) : r < 0 && (r = e.length), n = 0; 48 === e.charCodeAt(n); n++);
                    for(i = e.length; 48 === e.charCodeAt(i - 1); --i);
                    if (e = e.slice(n, i)) {
                        if (i -= n, t.e = r = r - n - 1, t.d = [], n = (r + 1) % 7, r < 0 && (n += 7), n < i) {
                            for(n && t.d.push(+e.slice(0, n)), i -= 7; n < i;)t.d.push(+e.slice(n, n += 7));
                            n = 7 - (e = e.slice(n)).length;
                        } else n -= i;
                        for(; n--;)e += "0";
                        t.d.push(+e), p && (t.e > t.constructor.maxE ? (t.d = null, t.e = NaN) : t.e < t.constructor.minE && (t.e = 0, t.d = [
                            0
                        ]));
                    } else t.e = 0, t.d = [
                        0
                    ];
                    return t;
                }
                function W(t, e) {
                    var r, n, i, a, s, u, l, c, f;
                    if (e.indexOf("_") > -1) {
                        if (e = e.replace(/(\d)_(?=\d)/g, "$1"), w.test(e)) return H(t, e);
                    } else if ("Infinity" === e || "NaN" === e) return +e || (t.s = NaN), t.e = NaN, t.d = null, t;
                    if (b.test(e)) r = 16, e = e.toLowerCase();
                    else if (v.test(e)) r = 2;
                    else {
                        if (!x.test(e)) throw Error(d + e);
                        r = 8;
                    }
                    for((a = e.search(/p/i)) > 0 ? (l = +e.slice(a + 1), e = e.substring(2, a)) : e = e.slice(2), s = (a = e.indexOf(".")) >= 0, n = t.constructor, s && (a = (u = (e = e.replace(".", "")).length) - a, i = R(n, new n(r), a, 2 * a)), a = f = (c = C(e, r, _)).length - 1; 0 === c[a]; --a)c.pop();
                    return a < 0 ? new n(0 * t.s) : (t.e = F(c, f), t.d = c, p = !1, s && (t = D(t, i, 4 * u)), l && (t = t.times(Math.abs(l) < 54 ? g(2, l) : o.pow(2, l))), p = !0, t);
                }
                function $(t, e, r, n, i) {
                    var o, a, s, u, l = t.precision, c = Math.ceil(l / 7);
                    for(p = !1, u = r.times(r), s = new t(n);;){
                        if (a = D(s.times(u), new t(e++ * e++), l, 1), s = i ? n.plus(a) : n.minus(a), n = D(a.times(u), new t(e++ * e++), l, 1), void 0 !== (a = s.plus(n)).d[c]) {
                            for(o = c; a.d[o] === s.d[o] && o--;);
                            if (-1 == o) break;
                        }
                        o = s, s = n, n = a, a = o;
                    }
                    return p = !0, a.d.length = c + 1, a;
                }
                function V(t, e) {
                    for(var r = t; --e;)r *= t;
                    return r;
                }
                function Z(t, e) {
                    var r, n = e.s < 0, i = I(t, t.precision, 1), o = i.times(.5);
                    if ((e = e.abs()).lte(o)) return s = n ? 4 : 1, e;
                    if ((r = e.divToInt(i)).isZero()) s = n ? 3 : 2;
                    else {
                        if ((e = e.minus(r.times(i))).lte(o)) return s = L(r) ? n ? 2 : 3 : n ? 4 : 1, e;
                        s = L(r) ? n ? 1 : 4 : n ? 3 : 2;
                    }
                    return e.minus(i).abs();
                }
                function Y(t, e, r, n) {
                    var i, o, s, u, c, f, h, p, d, m = t.constructor, y = void 0 !== r;
                    if (y ? (k(r, 1, 1e9), void 0 === n ? n = m.rounding : k(n, 0, 8)) : (r = m.precision, n = m.rounding), t.isFinite()) {
                        for(y ? (i = 2, 16 == e ? r = 4 * r - 3 : 8 == e && (r = 3 * r - 2)) : i = e, (s = (h = T(t)).indexOf(".")) >= 0 && (h = h.replace(".", ""), (d = new m(1)).e = h.length - s, d.d = C(T(d), 10, i), d.e = d.d.length), o = c = (p = C(h, 10, i)).length; 0 == p[--c];)p.pop();
                        if (p[0]) {
                            if (s < 0 ? o-- : ((t = new m(t)).d = p, t.e = o, p = (t = D(t, d, r, n, 0, i)).d, o = t.e, f = a), s = p[r], u = i / 2, f = f || void 0 !== p[r + 1], f = n < 4 ? (void 0 !== s || f) && (0 === n || n === (t.s < 0 ? 3 : 2)) : s > u || s === u && (4 === n || f || 6 === n && 1 & p[r - 1] || n === (t.s < 0 ? 8 : 7)), p.length = r, f) for(; ++p[--r] > i - 1;)p[r] = 0, r || (++o, p.unshift(1));
                            for(c = p.length; !p[c - 1]; --c);
                            for(s = 0, h = ""; s < c; s++)h += l.charAt(p[s]);
                            if (y) {
                                if (c > 1) {
                                    if (16 == e || 8 == e) {
                                        for(s = 16 == e ? 4 : 3, --c; c % s; c++)h += "0";
                                        for(c = (p = C(h, i, e)).length; !p[c - 1]; --c);
                                        for(s = 1, h = "1."; s < c; s++)h += l.charAt(p[s]);
                                    } else h = h.charAt(0) + "." + h.slice(1);
                                }
                                h = h + (o < 0 ? "p" : "p+") + o;
                            } else if (o < 0) {
                                for(; ++o;)h = "0" + h;
                                h = "0." + h;
                            } else if (++o > c) for(o -= c; o--;)h += "0";
                            else o < c && (h = h.slice(0, o) + "." + h.slice(o));
                        } else h = y ? "0p+0" : "0";
                        h = (16 == e ? "0x" : 2 == e ? "0b" : 8 == e ? "0o" : "") + h;
                    } else h = G(t);
                    return t.s < 0 ? "-" + h : h;
                }
                function K(t, e) {
                    if (t.length > e) return t.length = e, !0;
                }
                function X(t) {
                    return new this(t).abs();
                }
                function J(t) {
                    return new this(t).acos();
                }
                function Q(t) {
                    return new this(t).acosh();
                }
                function tt(t, e) {
                    return new this(t).plus(e);
                }
                function et(t) {
                    return new this(t).asin();
                }
                function rt(t) {
                    return new this(t).asinh();
                }
                function nt(t) {
                    return new this(t).atan();
                }
                function it(t) {
                    return new this(t).atanh();
                }
                function ot(t, e) {
                    t = new this(t), e = new this(e);
                    var r, n = this.precision, i = this.rounding, o = n + 4;
                    return t.s && e.s ? t.d || e.d ? !e.d || t.isZero() ? (r = e.s < 0 ? I(this, n, i) : new this(0)).s = t.s : !t.d || e.isZero() ? (r = I(this, o, 1).times(.5)).s = t.s : e.s < 0 ? (this.precision = o, this.rounding = 1, r = this.atan(D(t, e, o, 1)), e = I(this, o, 1), this.precision = n, this.rounding = i, r = t.s < 0 ? r.minus(e) : r.plus(e)) : r = this.atan(D(t, e, o, 1)) : (r = I(this, o, 1).times(e.s > 0 ? .25 : .75)).s = t.s : r = new this(NaN), r;
                }
                function at(t) {
                    return new this(t).cbrt();
                }
                function st(t) {
                    return O(t = new this(t), t.e + 1, 2);
                }
                function ut(t, e, r) {
                    return new this(t).clamp(e, r);
                }
                function lt(t) {
                    if (!t || "object" != typeof t) throw Error("[DecimalError] Object expected");
                    var e, r, n, i = !0 === t.defaults, o = [
                        "precision",
                        1,
                        1e9,
                        "rounding",
                        0,
                        8,
                        "toExpNeg",
                        -u,
                        0,
                        "toExpPos",
                        0,
                        u,
                        "maxE",
                        0,
                        u,
                        "minE",
                        -u,
                        0,
                        "modulo",
                        0,
                        9
                    ];
                    for(e = 0; e < o.length; e += 3)if (r = o[e], i && (this[r] = h[r]), void 0 !== (n = t[r])) {
                        if (!(y(n) === n && n >= o[e + 1] && n <= o[e + 2])) throw Error(d + r + ": " + n);
                        this[r] = n;
                    }
                    if (r = "crypto", i && (this[r] = h[r]), void 0 !== (n = t[r])) {
                        if (!0 !== n && !1 !== n && 0 !== n && 1 !== n) throw Error(d + r + ": " + n);
                        if (n) {
                            if ("undefined" == typeof crypto || !crypto || !crypto.getRandomValues && !crypto.randomBytes) throw Error("[DecimalError] crypto unavailable");
                            this[r] = !0;
                        } else this[r] = !1;
                    }
                    return this;
                }
                function ct(t) {
                    return new this(t).cos();
                }
                function ft(t) {
                    return new this(t).cosh();
                }
                function ht(t, e) {
                    return new this(t).div(e);
                }
                function pt(t) {
                    return new this(t).exp();
                }
                function dt(t) {
                    return O(t = new this(t), t.e + 1, 3);
                }
                function mt() {
                    var t, e, r = new this(0);
                    for(p = !1, t = 0; t < arguments.length;)if ((e = new this(arguments[t++])).d) r.d && (r = r.plus(e.times(e)));
                    else {
                        if (e.s) return p = !0, new this(1 / 0);
                        r = e;
                    }
                    return p = !0, r.sqrt();
                }
                function yt(t) {
                    return t instanceof o || t && t.toStringTag === m || !1;
                }
                function gt(t) {
                    return new this(t).ln();
                }
                function vt(t, e) {
                    return new this(t).log(e);
                }
                function bt(t) {
                    return new this(t).log(2);
                }
                function xt(t) {
                    return new this(t).log(10);
                }
                function wt() {
                    return q(this, arguments, "lt");
                }
                function _t() {
                    return q(this, arguments, "gt");
                }
                function At(t, e) {
                    return new this(t).mod(e);
                }
                function Et(t, e) {
                    return new this(t).mul(e);
                }
                function St(t, e) {
                    return new this(t).pow(e);
                }
                function Mt(t) {
                    var e, r, n, i, o = 0, a = new this(1), s = [];
                    if (void 0 === t ? t = this.precision : k(t, 1, 1e9), n = Math.ceil(t / 7), this.crypto) {
                        if (crypto.getRandomValues) for(e = crypto.getRandomValues(new Uint32Array(n)); o < n;)(i = e[o]) >= 429e7 ? e[o] = crypto.getRandomValues(new Uint32Array(1))[0] : s[o++] = i % 1e7;
                        else {
                            if (!crypto.randomBytes) throw Error("[DecimalError] crypto unavailable");
                            for(e = crypto.randomBytes(n *= 4); o < n;)(i = e[o] + (e[o + 1] << 8) + (e[o + 2] << 16) + ((127 & e[o + 3]) << 24)) >= 214e7 ? crypto.randomBytes(4).copy(e, o) : (s.push(i % 1e7), o += 4);
                            o = n / 4;
                        }
                    } else for(; o < n;)s[o++] = 1e7 * Math.random() | 0;
                    for(t %= 7, (n = s[--o]) && t && (i = g(10, 7 - t), s[o] = (n / i | 0) * i); 0 === s[o]; o--)s.pop();
                    if (o < 0) r = 0, s = [
                        0
                    ];
                    else {
                        for(r = -1; 0 === s[0]; r -= 7)s.shift();
                        for(n = 1, i = s[0]; i >= 10; i /= 10)n++;
                        n < 7 && (r -= 7 - n);
                    }
                    return a.e = r, a.d = s, a;
                }
                function kt(t) {
                    return O(t = new this(t), t.e + 1, this.rounding);
                }
                function Nt(t) {
                    return (t = new this(t)).d ? t.d[0] ? t.s : 0 * t.s : t.s || NaN;
                }
                function Ct(t) {
                    return new this(t).sin();
                }
                function Dt(t) {
                    return new this(t).sinh();
                }
                function Ot(t) {
                    return new this(t).sqrt();
                }
                function Tt(t, e) {
                    return new this(t).sub(e);
                }
                function Ft() {
                    var t = 0, e = arguments, r = new this(e[t]);
                    for(p = !1; r.s && ++t < e.length;)r = r.plus(e[t]);
                    return p = !0, O(r, this.precision, this.rounding);
                }
                function Pt(t) {
                    return new this(t).tan();
                }
                function It(t) {
                    return new this(t).tanh();
                }
                function Bt(t) {
                    return O(t = new this(t), t.e + 1, 1);
                }
                (o = function t(e) {
                    var r, n, i;
                    function o(t) {
                        var e, r, n, i = this;
                        if (!(i instanceof o)) return new o(t);
                        if (i.constructor = o, yt(t)) return i.s = t.s, void (p ? !t.d || t.e > o.maxE ? (i.e = NaN, i.d = null) : t.e < o.minE ? (i.e = 0, i.d = [
                            0
                        ]) : (i.e = t.e, i.d = t.d.slice()) : (i.e = t.e, i.d = t.d ? t.d.slice() : t.d));
                        if ("number" === (n = typeof t)) {
                            if (0 === t) return i.s = 1 / t < 0 ? -1 : 1, i.e = 0, void (i.d = [
                                0
                            ]);
                            if (t < 0 ? (t = -t, i.s = -1) : i.s = 1, t === ~~t && t < 1e7) {
                                for(e = 0, r = t; r >= 10; r /= 10)e++;
                                return void (p ? e > o.maxE ? (i.e = NaN, i.d = null) : e < o.minE ? (i.e = 0, i.d = [
                                    0
                                ]) : (i.e = e, i.d = [
                                    t
                                ]) : (i.e = e, i.d = [
                                    t
                                ]));
                            }
                            return 0 * t != 0 ? (t || (i.s = NaN), i.e = NaN, void (i.d = null)) : H(i, t.toString());
                        }
                        if ("string" !== n) throw Error(d + t);
                        return 45 === (r = t.charCodeAt(0)) ? (t = t.slice(1), i.s = -1) : (43 === r && (t = t.slice(1)), i.s = 1), w.test(t) ? H(i, t) : W(i, t);
                    }
                    if (o.prototype = S, o.ROUND_UP = 0, o.ROUND_DOWN = 1, o.ROUND_CEIL = 2, o.ROUND_FLOOR = 3, o.ROUND_HALF_UP = 4, o.ROUND_HALF_DOWN = 5, o.ROUND_HALF_EVEN = 6, o.ROUND_HALF_CEIL = 7, o.ROUND_HALF_FLOOR = 8, o.EUCLID = 9, o.config = o.set = lt, o.clone = t, o.isDecimal = yt, o.abs = X, o.acos = J, o.acosh = Q, o.add = tt, o.asin = et, o.asinh = rt, o.atan = nt, o.atanh = it, o.atan2 = ot, o.cbrt = at, o.ceil = st, o.clamp = ut, o.cos = ct, o.cosh = ft, o.div = ht, o.exp = pt, o.floor = dt, o.hypot = mt, o.ln = gt, o.log = vt, o.log10 = xt, o.log2 = bt, o.max = wt, o.min = _t, o.mod = At, o.mul = Et, o.pow = St, o.random = Mt, o.round = kt, o.sign = Nt, o.sin = Ct, o.sinh = Dt, o.sqrt = Ot, o.sub = Tt, o.sum = Ft, o.tan = Pt, o.tanh = It, o.trunc = Bt, void 0 === e && (e = {}), e && !0 !== e.defaults) for(i = [
                        "precision",
                        "rounding",
                        "toExpNeg",
                        "toExpPos",
                        "maxE",
                        "minE",
                        "modulo",
                        "crypto"
                    ], r = 0; r < i.length;)e.hasOwnProperty(n = i[r++]) || (e[n] = this[n]);
                    return o.config(e), o;
                }(h)).prototype.constructor = o, o.default = o.Decimal = o, c = new o(c), f = new o(f), void 0 === (n = (function() {
                    return o;
                }).call(e, r, e, t)) || (t.exports = n);
            }();
        },
        function(t, e, r) {
            "use strict";
            r.d(e, "b", function() {
                return n;
            }), r.d(e, "a", function() {
                return i;
            }), r.d(e, "c", function() {
                return o;
            });
            var n = "Direct raster loading is currently not supported outside of the browser due to dependency limitations. Please use either a url or run the code in the browser.", i = "GeoBlaze could not load the file. This is usually because the url is incorrect or the website's security prevents cross domain requests. Try again or download the file and load it manually.", o = "GeoBlaze had a problem parsing this file. Please make sure that you are sending a proper GeoTIFF file and try again.";
        },
        function(t, e) {
            t.exports = function t(e, r) {
                "use strict";
                var n, i, o = /(^([+\-]?(?:0|[1-9]\d*)(?:\.\d*)?(?:[eE][+\-]?\d+)?)?$|^0x[0-9a-f]+$|\d+)/gi, a = /(^[ ]*|[ ]*$)/g, s = /(^([\w ]+,?[\w ]+)?[\w ]+,?[\w ]+\d+:\d+(:\d+)?[\w ]?|^\d{1,4}[\/\-]\d{1,4}[\/\-]\d{1,4}|^\w+, \w+ \d+, \d{4})/, u = /^0x[0-9a-f]+$/i, l = /^0/, c = function(e) {
                    return t.insensitive && ("" + e).toLowerCase() || "" + e;
                }, f = c(e).replace(a, "") || "", h = c(r).replace(a, "") || "", p = f.replace(o, "\0$1\0").replace(/\0$/, "").replace(/^\0/, "").split("\0"), d = h.replace(o, "\0$1\0").replace(/\0$/, "").replace(/^\0/, "").split("\0"), m = parseInt(f.match(u), 16) || 1 !== p.length && f.match(s) && Date.parse(f), y = parseInt(h.match(u), 16) || m && h.match(s) && Date.parse(h) || null;
                if (y) {
                    if (m < y) return -1;
                    if (m > y) return 1;
                }
                for(var g = 0, v = Math.max(p.length, d.length); g < v; g++){
                    if (n = !(p[g] || "").match(l) && parseFloat(p[g]) || p[g] || 0, i = !(d[g] || "").match(l) && parseFloat(d[g]) || d[g] || 0, isNaN(n) !== isNaN(i)) return isNaN(n) ? 1 : -1;
                    if (typeof n != typeof i && (n += "", i += ""), n < i) return -1;
                    if (n > i) return 1;
                }
                return 0;
            };
        },
        function(t, e, r) {
            "use strict";
            var n = r(194), i = r(195), o = r(196), a = r(197), s = r(111), u = r(47), l = r(198), c = Function, f = function(t) {
                try {
                    return c('"use strict"; return (' + t + ").constructor;")();
                } catch (t) {}
            }, h = Object.getOwnPropertyDescriptor;
            if (h) try {
                h({}, "");
            } catch (t) {
                h = null;
            }
            var p = function() {
                throw new u;
            }, d = h ? function() {
                try {
                    return p;
                } catch (t) {
                    try {
                        return h(arguments, "callee").get;
                    } catch (t) {
                        return p;
                    }
                }
            }() : p, m = r(199)(), y = r(201)(), g = Object.getPrototypeOf || (y ? function(t) {
                return t.__proto__;
            } : null), v = {}, b = "undefined" != typeof Uint8Array && g ? g(Uint8Array) : void 0, x = {
                __proto__: null,
                "%AggregateError%": "undefined" == typeof AggregateError ? void 0 : AggregateError,
                "%Array%": Array,
                "%ArrayBuffer%": "undefined" == typeof ArrayBuffer ? void 0 : ArrayBuffer,
                "%ArrayIteratorPrototype%": m && g ? g([][Symbol.iterator]()) : void 0,
                "%AsyncFromSyncIteratorPrototype%": void 0,
                "%AsyncFunction%": v,
                "%AsyncGenerator%": v,
                "%AsyncGeneratorFunction%": v,
                "%AsyncIteratorPrototype%": v,
                "%Atomics%": "undefined" == typeof Atomics ? void 0 : Atomics,
                "%BigInt%": "undefined" == typeof BigInt ? void 0 : BigInt,
                "%BigInt64Array%": "undefined" == typeof BigInt64Array ? void 0 : BigInt64Array,
                "%BigUint64Array%": "undefined" == typeof BigUint64Array ? void 0 : BigUint64Array,
                "%Boolean%": Boolean,
                "%DataView%": "undefined" == typeof DataView ? void 0 : DataView,
                "%Date%": Date,
                "%decodeURI%": decodeURI,
                "%decodeURIComponent%": decodeURIComponent,
                "%encodeURI%": encodeURI,
                "%encodeURIComponent%": encodeURIComponent,
                "%Error%": n,
                "%eval%": eval,
                "%EvalError%": i,
                "%Float32Array%": "undefined" == typeof Float32Array ? void 0 : Float32Array,
                "%Float64Array%": "undefined" == typeof Float64Array ? void 0 : Float64Array,
                "%FinalizationRegistry%": "undefined" == typeof FinalizationRegistry ? void 0 : FinalizationRegistry,
                "%Function%": c,
                "%GeneratorFunction%": v,
                "%Int8Array%": "undefined" == typeof Int8Array ? void 0 : Int8Array,
                "%Int16Array%": "undefined" == typeof Int16Array ? void 0 : Int16Array,
                "%Int32Array%": "undefined" == typeof Int32Array ? void 0 : Int32Array,
                "%isFinite%": isFinite,
                "%isNaN%": isNaN,
                "%IteratorPrototype%": m && g ? g(g([][Symbol.iterator]())) : void 0,
                "%JSON%": "object" == typeof JSON ? JSON : void 0,
                "%Map%": "undefined" == typeof Map ? void 0 : Map,
                "%MapIteratorPrototype%": "undefined" != typeof Map && m && g ? g((new Map)[Symbol.iterator]()) : void 0,
                "%Math%": Math,
                "%Number%": Number,
                "%Object%": Object,
                "%parseFloat%": parseFloat,
                "%parseInt%": parseInt,
                "%Promise%": "undefined" == typeof Promise ? void 0 : Promise,
                "%Proxy%": "undefined" == typeof Proxy ? void 0 : Proxy,
                "%RangeError%": o,
                "%ReferenceError%": a,
                "%Reflect%": "undefined" == typeof Reflect ? void 0 : Reflect,
                "%RegExp%": RegExp,
                "%Set%": "undefined" == typeof Set ? void 0 : Set,
                "%SetIteratorPrototype%": "undefined" != typeof Set && m && g ? g((new Set)[Symbol.iterator]()) : void 0,
                "%SharedArrayBuffer%": "undefined" == typeof SharedArrayBuffer ? void 0 : SharedArrayBuffer,
                "%String%": String,
                "%StringIteratorPrototype%": m && g ? g(""[Symbol.iterator]()) : void 0,
                "%Symbol%": m ? Symbol : void 0,
                "%SyntaxError%": s,
                "%ThrowTypeError%": d,
                "%TypedArray%": b,
                "%TypeError%": u,
                "%Uint8Array%": "undefined" == typeof Uint8Array ? void 0 : Uint8Array,
                "%Uint8ClampedArray%": "undefined" == typeof Uint8ClampedArray ? void 0 : Uint8ClampedArray,
                "%Uint16Array%": "undefined" == typeof Uint16Array ? void 0 : Uint16Array,
                "%Uint32Array%": "undefined" == typeof Uint32Array ? void 0 : Uint32Array,
                "%URIError%": l,
                "%WeakMap%": "undefined" == typeof WeakMap ? void 0 : WeakMap,
                "%WeakRef%": "undefined" == typeof WeakRef ? void 0 : WeakRef,
                "%WeakSet%": "undefined" == typeof WeakSet ? void 0 : WeakSet
            };
            if (g) try {
                null.error;
            } catch (t) {
                var w = g(g(t));
                x["%Error.prototype%"] = w;
            }
            var _ = {
                __proto__: null,
                "%ArrayBufferPrototype%": [
                    "ArrayBuffer",
                    "prototype"
                ],
                "%ArrayPrototype%": [
                    "Array",
                    "prototype"
                ],
                "%ArrayProto_entries%": [
                    "Array",
                    "prototype",
                    "entries"
                ],
                "%ArrayProto_forEach%": [
                    "Array",
                    "prototype",
                    "forEach"
                ],
                "%ArrayProto_keys%": [
                    "Array",
                    "prototype",
                    "keys"
                ],
                "%ArrayProto_values%": [
                    "Array",
                    "prototype",
                    "values"
                ],
                "%AsyncFunctionPrototype%": [
                    "AsyncFunction",
                    "prototype"
                ],
                "%AsyncGenerator%": [
                    "AsyncGeneratorFunction",
                    "prototype"
                ],
                "%AsyncGeneratorPrototype%": [
                    "AsyncGeneratorFunction",
                    "prototype",
                    "prototype"
                ],
                "%BooleanPrototype%": [
                    "Boolean",
                    "prototype"
                ],
                "%DataViewPrototype%": [
                    "DataView",
                    "prototype"
                ],
                "%DatePrototype%": [
                    "Date",
                    "prototype"
                ],
                "%ErrorPrototype%": [
                    "Error",
                    "prototype"
                ],
                "%EvalErrorPrototype%": [
                    "EvalError",
                    "prototype"
                ],
                "%Float32ArrayPrototype%": [
                    "Float32Array",
                    "prototype"
                ],
                "%Float64ArrayPrototype%": [
                    "Float64Array",
                    "prototype"
                ],
                "%FunctionPrototype%": [
                    "Function",
                    "prototype"
                ],
                "%Generator%": [
                    "GeneratorFunction",
                    "prototype"
                ],
                "%GeneratorPrototype%": [
                    "GeneratorFunction",
                    "prototype",
                    "prototype"
                ],
                "%Int8ArrayPrototype%": [
                    "Int8Array",
                    "prototype"
                ],
                "%Int16ArrayPrototype%": [
                    "Int16Array",
                    "prototype"
                ],
                "%Int32ArrayPrototype%": [
                    "Int32Array",
                    "prototype"
                ],
                "%JSONParse%": [
                    "JSON",
                    "parse"
                ],
                "%JSONStringify%": [
                    "JSON",
                    "stringify"
                ],
                "%MapPrototype%": [
                    "Map",
                    "prototype"
                ],
                "%NumberPrototype%": [
                    "Number",
                    "prototype"
                ],
                "%ObjectPrototype%": [
                    "Object",
                    "prototype"
                ],
                "%ObjProto_toString%": [
                    "Object",
                    "prototype",
                    "toString"
                ],
                "%ObjProto_valueOf%": [
                    "Object",
                    "prototype",
                    "valueOf"
                ],
                "%PromisePrototype%": [
                    "Promise",
                    "prototype"
                ],
                "%PromiseProto_then%": [
                    "Promise",
                    "prototype",
                    "then"
                ],
                "%Promise_all%": [
                    "Promise",
                    "all"
                ],
                "%Promise_reject%": [
                    "Promise",
                    "reject"
                ],
                "%Promise_resolve%": [
                    "Promise",
                    "resolve"
                ],
                "%RangeErrorPrototype%": [
                    "RangeError",
                    "prototype"
                ],
                "%ReferenceErrorPrototype%": [
                    "ReferenceError",
                    "prototype"
                ],
                "%RegExpPrototype%": [
                    "RegExp",
                    "prototype"
                ],
                "%SetPrototype%": [
                    "Set",
                    "prototype"
                ],
                "%SharedArrayBufferPrototype%": [
                    "SharedArrayBuffer",
                    "prototype"
                ],
                "%StringPrototype%": [
                    "String",
                    "prototype"
                ],
                "%SymbolPrototype%": [
                    "Symbol",
                    "prototype"
                ],
                "%SyntaxErrorPrototype%": [
                    "SyntaxError",
                    "prototype"
                ],
                "%TypedArrayPrototype%": [
                    "TypedArray",
                    "prototype"
                ],
                "%TypeErrorPrototype%": [
                    "TypeError",
                    "prototype"
                ],
                "%Uint8ArrayPrototype%": [
                    "Uint8Array",
                    "prototype"
                ],
                "%Uint8ClampedArrayPrototype%": [
                    "Uint8ClampedArray",
                    "prototype"
                ],
                "%Uint16ArrayPrototype%": [
                    "Uint16Array",
                    "prototype"
                ],
                "%Uint32ArrayPrototype%": [
                    "Uint32Array",
                    "prototype"
                ],
                "%URIErrorPrototype%": [
                    "URIError",
                    "prototype"
                ],
                "%WeakMapPrototype%": [
                    "WeakMap",
                    "prototype"
                ],
                "%WeakSetPrototype%": [
                    "WeakSet",
                    "prototype"
                ]
            }, A = r(72), E = r(203), S = A.call(Function.call, Array.prototype.concat), M = A.call(Function.apply, Array.prototype.splice), k = A.call(Function.call, String.prototype.replace), N = A.call(Function.call, String.prototype.slice), C = A.call(Function.call, RegExp.prototype.exec), D = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g, O = /\\(\\)?/g, T = function(t) {
                var e = N(t, 0, 1), r = N(t, -1);
                if ("%" === e && "%" !== r) throw new s("invalid intrinsic syntax, expected closing `%`");
                if ("%" === r && "%" !== e) throw new s("invalid intrinsic syntax, expected opening `%`");
                var n = [];
                return k(t, D, function(t, e, r, i) {
                    n[n.length] = r ? k(i, O, "$1") : e || t;
                }), n;
            }, F = function(t, e) {
                var r, n = t;
                if (E(_, n) && (n = "%" + (r = _[n])[0] + "%"), E(x, n)) {
                    var i = x[n];
                    if (i === v && (i = function t(e) {
                        var r;
                        if ("%AsyncFunction%" === e) r = f("async function () {}");
                        else if ("%GeneratorFunction%" === e) r = f("function* () {}");
                        else if ("%AsyncGeneratorFunction%" === e) r = f("async function* () {}");
                        else if ("%AsyncGenerator%" === e) {
                            var n = t("%AsyncGeneratorFunction%");
                            n && (r = n.prototype);
                        } else if ("%AsyncIteratorPrototype%" === e) {
                            var i = t("%AsyncGenerator%");
                            i && g && (r = g(i.prototype));
                        }
                        return x[e] = r, r;
                    }(n)), void 0 === i && !e) throw new u("intrinsic " + t + " exists, but is not available. Please file an issue!");
                    return {
                        alias: r,
                        name: n,
                        value: i
                    };
                }
                throw new s("intrinsic " + t + " does not exist!");
            };
            t.exports = function(t, e) {
                if ("string" != typeof t || 0 === t.length) throw new u("intrinsic name must be a non-empty string");
                if (arguments.length > 1 && "boolean" != typeof e) throw new u('"allowMissing" argument must be a boolean');
                if (null === C(/^%?[^%]*%?$/, t)) throw new s("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
                var r = T(t), n = r.length > 0 ? r[0] : "", i = F("%" + n + "%", e), o = i.name, a = i.value, l = !1, c = i.alias;
                c && (n = c[0], M(r, S([
                    0,
                    1
                ], c)));
                for(var f = 1, p = !0; f < r.length; f += 1){
                    var d = r[f], m = N(d, 0, 1), y = N(d, -1);
                    if (('"' === m || "'" === m || "`" === m || '"' === y || "'" === y || "`" === y) && m !== y) throw new s("property names with quotes must have matching quotes");
                    if ("constructor" !== d && p || (l = !0), E(x, o = "%" + (n += "." + d) + "%")) a = x[o];
                    else if (null != a) {
                        if (!(d in a)) {
                            if (!e) throw new u("base intrinsic for " + t + " exists, but the property is not available.");
                            return;
                        }
                        if (h && f + 1 >= r.length) {
                            var g = h(a, d);
                            a = (p = !!g) && "get" in g && !("originalValue" in g.get) ? g.get : a[d];
                        } else p = E(a, d), a = a[d];
                        p && !l && (x[o] = a);
                    }
                }
                return a;
            };
        },
        function(t, e, r) {
            "use strict";
            const n = r(3), i = r(20);
            function o(t, e) {
                t = n(t), e = n(e);
                const r = "-" !== t[0], o = "-" !== e[0];
                return r ? o ? i(t, e) : ">" : o ? "<" : i(e.substring(1), t.substring(1));
            }
            t.exports = o, t.exports.default = o;
        },
        function(t, e, r) {
            "use strict";
            function n(t) {
                return !!t.match(/^(|-|\+)inf(inity)?$/i);
            }
            t.exports = n, t.exports.default = n;
        },
        function(t, e, r) {
            "use strict";
            const n = r(3), i = r(20), o = r(38), a = r(26), s = r(57);
            function u(t, e, { infinity_minus_infinity: r = "NaN" } = {}) {
                t = n(t), e = n(e);
                const u = !("-" === t[0]), l = !("-" === e[0]), c = o(t), f = o(e);
                if (c && f) {
                    if (u === l) return r;
                    if (u) return "Infinity";
                    if (l) return "-Infinity";
                } else {
                    if (c) return t;
                    if (f) return l ? "-Infinity" : "Infinity";
                }
                if (u) {
                    if (l) {
                        const r = i(t, e);
                        return ">" === r ? s(t, e) : "<" === r ? "-" + s(e, t) : "0";
                    }
                    return a(t, e.substring(1));
                }
                if (l) return "-" + a(t.substring(1), e);
                {
                    t = t.substring(1), e = e.substring(1);
                    const r = i(t, e);
                    return ">" === r ? "-" + s(t, e) : "<" === r ? s(e, t) : "0";
                }
            }
            t.exports = u, t.exports.default = u;
        },
        function(t, e, r) {
            "use strict";
            const n = r(3), i = r(38);
            function o(t) {
                return !i(t) && !(t = n(t)).includes(".") && !t.includes("/");
            }
            t.exports = o, t.exports.default = o;
        },
        function(t, e, r) {
            "use strict";
            const n = r(21), i = r(3), o = r(20), a = r(79), s = r(59);
            function u(t, { max_decimal_digits: e } = {}) {
                let r = i(t[0]), u = n(r), l = "-" === r[0] ? "-" : "";
                const c = t.length;
                for(let e = 1; e < c; e++){
                    const s = i(t[e]), c = "-" === s[0] ? "-" : "", f = n(s);
                    l = l !== c ? "-" : "";
                    u = "<" === o(u, f) ? a(f, u) : a(u, f), r = l + u;
                }
                return "number" == typeof e && (r = s(r, {
                    digits: e
                })), r;
            }
            t.exports = u, t.exports.default = u;
        },
        function(t, e, r) {
            "use strict";
            const n = r(28), i = r(81);
            function o(t) {
                return n(t) ? "" : i(t);
            }
            t.exports = o, t.exports.default = o;
        },
        function(t, e, r) {
            const n = r(291);
            t.exports = function(t) {
                return "+" === t[0] && (t = t.substring(1)), (t = (t = n(t)).replace(/^0+(?=\d)/, "")).includes(".") && (t = t.replace(/\.?0+$/, "")), "" === t && (t = "0"), t;
            };
        },
        function(t, e, r) {
            "use strict";
            function n(t) {
                if (!Array.isArray(t)) return !1;
                if (4 !== t.length) return !1;
                if (t.some((t)=>"number" != typeof t)) return !1;
                const [e, r, n, i] = t;
                return !(e > n) && !(r > i);
            }
            t.exports = n, t.exports.default = n;
        },
        function(t, e, r) {
            "use strict";
            r.d(e, "a", function() {
                return l;
            });
            var n = r(7), i = r.n(n), o = r(168), a = r.n(o), s = r(169), u = r.n(s);
            function l(t) {
                return function(e, r) {
                    if (!Array.isArray(r) && null !== r && "object" === i()(r) && "srs" in r && "geometry" in r) {
                        if (r.srs !== e.projection) {
                            var n = r, o = n.geometry, s = n.srs;
                            r = Array.isArray(o) && 4 === o.length && o.every(function(t) {
                                return "number" == typeof t;
                            }) ? a()({
                                bbox: o,
                                density: 10,
                                from: s,
                                to: e.projection
                            }) : u()(o, {
                                densify: "number" == typeof r.densify ? Math.round(r.densify) : 3,
                                from: s,
                                to: e.projection
                            });
                        } else r = r.geometry;
                    }
                    for(var l = arguments.length, c = new Array(l > 2 ? l - 2 : 0), f = 2; f < l; f++)c[f - 2] = arguments[f];
                    return t.apply(void 0, [
                        e,
                        r
                    ].concat(c));
                };
            }
        },
        function(t, e) {
            var r;
            r = function() {
                return this;
            }();
            try {
                r = r || new Function("return this")();
            } catch (t) {
                "object" == typeof window && (r = window);
            }
            t.exports = r;
        },
        function(t, e, r) {
            "use strict";
            t.exports = TypeError;
        },
        function(t, e, r) {
            "use strict";
            const n = r(132);
            function i() {
                const t = Array.from(arguments), e = "object" == typeof t[t.length - 1] ? t[t.length - 1] : void 0, r = Array.isArray(t[0]) ? t[0] : e ? t.slice(0, t.length - 1) : t;
                return n(r, e);
            }
            t.exports = i, t.exports.default = i;
        },
        function(t, e, r) {
            "use strict";
            const n = r(15);
            function i(t) {
                return "-" === (t = n(t))[0] ? t.substring(1) : t;
            }
            t.exports = i, t.exports.default = i;
        },
        function(t, e, r) {
            "use strict";
            const n = r(61);
            function i(t, e) {
                return n(t, "2", e);
            }
            t.exports = i, t.exports.default = i;
        },
        function(t, e, r) {
            "use strict";
            r.d(e, "a", function() {
                return S;
            });
            var n = r(45), i = r(13), o = r(22), a = r.n(o), s = r(2), u = r.n(s), l = r(108), c = r.n(l), f = r(14), h = r.n(f), p = r(70), d = r.n(p), m = r(44), y = r.n(m), g = r(16), v = r(9), b = r(24), x = r(69);
            function w(t, e) {
                var r = Object.keys(t);
                if (Object.getOwnPropertySymbols) {
                    var n = Object.getOwnPropertySymbols(t);
                    e && (n = n.filter(function(e) {
                        return Object.getOwnPropertyDescriptor(t, e).enumerable;
                    })), r.push.apply(r, n);
                }
                return r;
            }
            function _(t) {
                for(var e = 1; e < arguments.length; e++){
                    var r = null != arguments[e] ? arguments[e] : {};
                    e % 2 ? w(Object(r), !0).forEach(function(e) {
                        u()(t, e, r[e]);
                    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : w(Object(r)).forEach(function(e) {
                        Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
                    });
                }
                return t;
            }
            var A = [
                1,
                1
            ], E = Object(i.a)(function(t, e, r, n) {
                var i = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : {}, o = i.debug_level, s = void 0 === o ? 0 : o, u = i.include_meta, l = void 0 !== u && u, f = i.rescale, p = void 0 !== f && f, m = i.vrm, w = void 0 === m ? A : m;
                try {
                    r = _({}, r);
                    var E = t.noDataValue;
                    if (void 0 !== E && void 0 === r.noData && (r.noData = E), "number" == typeof w) {
                        if (w <= 0 || w !== Math.round(w)) throw new Error("[geoblaze] vrm can only be defined as a positive integer");
                        w = [
                            w,
                            w
                        ];
                    }
                    if (n) {
                        if (r && r.filter) {
                            var S = r.filter;
                            r.filter = function(t) {
                                var e = t.index, r = t.value;
                                return S({
                                    index: e,
                                    value: r
                                }) && n(r);
                            };
                        } else r.filter = function(t) {
                            t.index;
                            var e = t.value;
                            return n(e);
                        };
                    }
                    var M = !0, k = function(t) {
                        return t.map(function(t) {
                            return c()(t, r);
                        });
                    }, N = "minimal" === w || Array.isArray(w) && (1 !== w[0] || 1 !== w[1]), C = null == e;
                    if (!0 === N && (C ? e = d()([
                        t.xmin,
                        t.ymin,
                        t.xmax,
                        t.ymax
                    ]) : y()(e) ? e = d()(e) : v.a.isBboxObj(e) && (e = d()([
                        e.xmin,
                        e.ymin,
                        e.xmax,
                        e.ymax
                    ]))), C && !1 === N) {
                        s >= 2 && console.log("[geoblaze] geometry is nullish");
                        var D = Object(g.a)(t, void 0, M);
                        return h.a.resolve(D).then(k);
                    }
                    if (v.a.isBbox(e) && !1 === N) {
                        s >= 2 && console.log("[geoblaze] geometry is a rectangle"), e = Object(b.a)(e);
                        var O = Object(g.a)(t, e, M);
                        return h.a.resolve(O).then(k);
                    }
                    if (v.a.isPolygonal(e)) {
                        s >= 2 && console.log("[geoblaze] geometry is polygonal"), e = Object(b.b)(e);
                        var T = new Array(100).fill(0).map(function() {
                            return [];
                        }), F = Object(x.a)(t, e, function(t, e) {
                            T[e] ? T[e].push(t) : T[e] = [
                                t
                            ];
                        }, {
                            debug_level: s,
                            vrm: w
                        });
                        return h.a.resolve(F).then(function(e) {
                            var n = e.vrm, i = r.stats ? r.stats.includes("valid") : !1 !== r.calcValid, o = 1 !== n[0] && 1 !== n[1], u = T.filter(function(t) {
                                return 0 !== t.length;
                            });
                            if (u.length > 0) {
                                o && (r.stats ? r.stats.includes("product") && !1 === r.stats.includes("valid") && (r.stats = [].concat(a()(r.stats), [
                                    "valid"
                                ]), s >= 2 && console.log('[geoblaze] added "valid" to stats')) : !0 === r.calcProduct && !1 === r.calcValid && (r.calcValid = !0, s >= 2 && console.log('[geoblaze] set "calcValid" to true')));
                                var f = u.map(function(t) {
                                    return c()(t, r);
                                });
                                if (s >= 2 && console.log("[geoblaze] stats (before rescaling):", f), o && p) {
                                    s >= 2 && console.log("[geoblaze] rescaling results based on relative size of virtual pixels");
                                    var h = n[0] * n[1];
                                    s >= 2 && console.log("[geoblaze] area_multiplier:", h), f.forEach(function(t) {
                                        var e = t.valid;
                                        if ("number" == typeof t.count && (t.count /= h), "number" == typeof t.invalid && (t.invalid /= h), "number" == typeof t.sum && (t.sum /= h), "number" == typeof t.valid && (t.valid /= h), t.histogram) for(var r in t.histogram)t.histogram[r].ct /= h;
                                        "number" == typeof t.product && (t.product /= Math.pow(h, e));
                                    });
                                }
                                return !1 === i && f.forEach(function(t) {
                                    return delete t.valid;
                                }), l && f.forEach(function(e) {
                                    e._meta = {
                                        vph: t.pixelHeight / n[1],
                                        vpw: t.pixelWidth / n[0],
                                        vrm: [
                                            n[0],
                                            n[1]
                                        ]
                                    };
                                }), f;
                            }
                            throw "No Values were found in the given geometry";
                        });
                    }
                    throw "Geometry Type is Not Supported";
                } catch (t) {
                    throw console.error(t), t;
                }
            });
            function S() {
                return Object(i.a)(Object(n.a)(E)).apply(void 0, arguments);
            }
        },
        function(t, e, r) {
            "use strict";
            r.d(e, "a", function() {
                return b;
            });
            var n = r(17), i = r.n(n), o = r(7), a = r.n(o), s = r(5), u = r.n(s), l = r(29), c = r.n(l), f = r(67), h = r.n(f), p = r(34), d = r(23), m = r(9), y = "object" === ("undefined" == typeof window ? "undefined" : a()(window)) ? window.URL : h.a.parse;
            function g(t) {
                return v.apply(this, arguments);
            }
            function v() {
                return (v = i()(u.a.mark(function t(e) {
                    var r, n, i, o = arguments;
                    return u.a.wrap(function(t) {
                        for(;;)switch(t.prev = t.next){
                            case 0:
                                return r = o.length > 1 && void 0 !== o[1] ? o[1] : {
                                    logErrors: !0
                                }, n = r.logErrors, i = void 0 === n || n, t.prev = 1, t.next = 4, c()(e);
                            case 4:
                                return t.abrupt("return", t.sent);
                            case 7:
                                throw t.prev = 7, t.t0 = t.catch(1), i && console.error(t.t0), new Error(p.c);
                            case 11:
                            case "end":
                                return t.stop();
                        }
                    }, t, null, [
                        [
                            1,
                            7
                        ]
                    ]);
                }))).apply(this, arguments);
            }
            function b(t) {
                return x.apply(this, arguments);
            }
            function x() {
                return (x = i()(u.a.mark(function t(e) {
                    var r, n, i, o, a, s = arguments;
                    return u.a.wrap(function(t) {
                        for(;;)switch(t.prev = t.next){
                            case 0:
                                if (r = s.length > 1 && void 0 !== s[1] ? s[1] : {
                                    logErrors: !0,
                                    useCache: !0
                                }, n = r.logErrors, i = void 0 === n || n, o = r.useCache, a = void 0 === o || o, [
                                    "Blob",
                                    "File"
                                ].includes(m.a.getConstructorName(e)) && (e = y.createObjectURL(e)), !a || "string" != typeof e) {
                                    t.next = 9;
                                    break;
                                }
                                return d.a[e] || (d.a[e] = g(e, {
                                    logErrors: i
                                })), t.next = 6, d.a[e];
                            case 6:
                                return t.abrupt("return", t.sent);
                            case 9:
                                return t.next = 11, g(e);
                            case 11:
                                return t.abrupt("return", t.sent);
                            case 12:
                            case "end":
                                return t.stop();
                        }
                    }, t);
                }))).apply(this, arguments);
            }
        },
        function(t, e, r) {
            "use strict";
            r.d(e, "a", function() {
                return M;
            });
            var n = r(17), i = r.n(n), o = r(7), a = r.n(o), s = r(5), u = r.n(s), l = r(29), c = r.n(l), f = r(66), h = r.n(f), p = r(67), d = r.n(p), m = r(34), y = r(23), g = "object" === ("undefined" == typeof window ? "undefined" : a()(window)), v = g ? window.URL : d.a.parse;
            function b(t) {
                return x.apply(this, arguments);
            }
            function x() {
                return (x = i()(u.a.mark(function t(e) {
                    var r;
                    return u.a.wrap(function(t) {
                        for(;;)switch(t.prev = t.next){
                            case 0:
                                if (t.prev = 0, !e.arrayBuffer) {
                                    t.next = 5;
                                    break;
                                }
                                return t.abrupt("return", e.arrayBuffer());
                            case 5:
                                if (!e.buffer) {
                                    t.next = 10;
                                    break;
                                }
                                return t.next = 8, e.buffer();
                            case 8:
                                return r = t.sent, t.abrupt("return", r.buffer.slice(r.byteOffset, r.byteOffset + r.byteLength));
                            case 10:
                                t.next = 16;
                                break;
                            case 12:
                                throw t.prev = 12, t.t0 = t.catch(0), console.error("[geoblaze] toArrayBuffer failed because of the following error", t.t0), t.t0;
                            case 16:
                            case "end":
                                return t.stop();
                        }
                    }, t, null, [
                        [
                            0,
                            12
                        ]
                    ]);
                }))).apply(this, arguments);
            }
            function w(t) {
                return _.apply(this, arguments);
            }
            function _() {
                return (_ = i()(u.a.mark(function t(e) {
                    var r;
                    return u.a.wrap(function(t) {
                        for(;;)switch(t.prev = t.next){
                            case 0:
                                return t.prev = 0, t.next = 3, h()(e);
                            case 3:
                                if ((r = t.sent).ok) {
                                    t.next = 6;
                                    break;
                                }
                                throw new Error(m.a);
                            case 6:
                                return t.abrupt("return", r);
                            case 9:
                                throw t.prev = 9, t.t0 = t.catch(0), console.error(t.t0), new Error(m.a);
                            case 13:
                            case "end":
                                return t.stop();
                        }
                    }, t, null, [
                        [
                            0,
                            9
                        ]
                    ]);
                }))).apply(this, arguments);
            }
            function A(t) {
                return E.apply(this, arguments);
            }
            function E() {
                return (E = i()(u.a.mark(function t(e) {
                    return u.a.wrap(function(t) {
                        for(;;)switch(t.prev = t.next){
                            case 0:
                                return t.prev = 0, t.next = 3, c()(e);
                            case 3:
                                return t.abrupt("return", t.sent);
                            case 6:
                                throw t.prev = 6, t.t0 = t.catch(0), new Error(m.c);
                            case 9:
                            case "end":
                                return t.stop();
                        }
                    }, t, null, [
                        [
                            0,
                            6
                        ]
                    ]);
                }))).apply(this, arguments);
            }
            function S() {
                return (S = i()(u.a.mark(function t(e) {
                    var r, n, o, s, l, c = arguments;
                    return u.a.wrap(function(t) {
                        for(;;)switch(t.prev = t.next){
                            case 0:
                                if (r = c.length > 1 && void 0 !== c[1] ? c[1] : {
                                    useCache: !0
                                }, n = r.useCache, o = void 0 === n || n, g || "object" !== a()(e)) {
                                    t.next = 3;
                                    break;
                                }
                                throw new Error(m.b);
                            case 3:
                                if (s = "object" === a()(e) ? v.createObjectURL(e) : e, l = function() {
                                    var t = i()(u.a.mark(function t() {
                                        var e, r, n;
                                        return u.a.wrap(function(t) {
                                            for(;;)switch(t.prev = t.next){
                                                case 0:
                                                    return t.next = 2, w(s);
                                                case 2:
                                                    return e = t.sent, t.next = 5, b(e);
                                                case 5:
                                                    return r = t.sent, t.next = 8, A(r);
                                                case 8:
                                                    return n = t.sent, t.abrupt("return", n);
                                                case 10:
                                                case "end":
                                                    return t.stop();
                                            }
                                        }, t);
                                    }));
                                    return function() {
                                        return t.apply(this, arguments);
                                    };
                                }(), !o) {
                                    t.next = 10;
                                    break;
                                }
                                return y.a[s] || (y.a[s] = l()), t.abrupt("return", y.a[s]);
                            case 10:
                                return t.abrupt("return", l());
                            case 11:
                            case "end":
                                return t.stop();
                        }
                    }, t);
                }))).apply(this, arguments);
            }
            var M = function(t) {
                return S.apply(this, arguments);
            };
        },
        function(t, e, r) {
            var n = r(71), i = r(188), o = r(300).default;
            function a(t, e) {
                var r, a, s, u, l, c, f;
                if ("string" == typeof t && (t = JSON.parse(t)), Array.isArray(null === (r = t) || void 0 === r || null === (a = r.geometry) || void 0 === a ? void 0 : a.rings) || Array.isArray(null === (s = t) || void 0 === s ? void 0 : s.rings)) ((null === (u = t) || void 0 === u || null === (l = u.geometry) || void 0 === l ? void 0 : l.rings) || (null === (c = t) || void 0 === c ? void 0 : c.rings)).forEach(function(t) {
                    o(t) ? (f && e(f), f = [
                        t
                    ]) : f.push(t);
                }), e(f);
                else if ("type" in t) !function t(e, r) {
                    Array.isArray(e.features) ? e.features.forEach(function(e) {
                        t(e, r);
                    }) : r(e);
                }(t, function(t) {
                    i.geomEach(t, function(t) {
                        "Polygon" === t.type ? e(t.coordinates) : "MultiPolygon" === t.type && t.coordinates.forEach(function(t) {
                            e(t);
                        });
                    });
                });
                else if (Array.isArray(t)) {
                    var h = n(t);
                    4 === h ? t.forEach(function(t) {
                        e(t);
                    }) : 3 === h ? e(t) : 2 === h && e([
                        t
                    ]);
                }
            }
            t.exports = {
                each: a,
                get: function(t) {
                    var e = [];
                    return a(t, function(t) {
                        return e.push(t);
                    }), e;
                }
            };
        },
        function(t, e, r) {
            var n;
            const i = r(230);
            function o(t, { debug: e = !1, no_data: r, theoretical_max: n } = {
                debug: !1,
                no_data: void 0,
                theoretical_max: void 0
            }) {
                if (e && console.log("[fast-max] starting with numbers:", t.slice(0, 10)), !t.length) throw e && console.error("[fast-max] Instead of an array of numbers, you passed in", t), new Error("[fast-max] You didn't pass in an array of numbers");
                if (0 === t.length) throw new Error("[fast-max] You passed in an empty array");
                let o;
                const a = t.length;
                if (e && console.log("[fast-max] constructor:", t.constructor.name), void 0 === n && (n = i(t.constructor.name)), e && console.log("[fast-max] theoretical maximunm is", n), n) {
                    if (void 0 !== r) {
                        o = -1 / 0;
                        for(let i = 1; i < a; i++){
                            const s = t[i];
                            if (s > o && s !== r && (o = s, s >= n)) {
                                e && console.log("[fast-max] found maximum value of " + s + " at index " + i + " of " + a);
                                break;
                            }
                        }
                        o === -1 / 0 && (o = void 0);
                    } else {
                        o = t[0];
                        for(let r = 1; r < a; r++){
                            const i = t[r];
                            if (i > o && (o = i, i >= n)) {
                                e && console.log("[fast-max] found maximum value of " + i + " at index " + r + " of " + a);
                                break;
                            }
                        }
                    }
                } else if (void 0 !== r) {
                    o = -1 / 0;
                    for(let e = 0; e < a; e++){
                        const n = t[e];
                        n > o && n !== r && (o = n);
                    }
                    o === -1 / 0 && (o = void 0);
                } else {
                    o = t[0];
                    for(let e = 1; e < a; e++){
                        const r = t[e];
                        r > o && (o = r);
                    }
                }
                return e && console.log("[fast-max] returning", o), o;
            }
            void 0 === (n = (function() {
                return o;
            }).call(e, r, e, t)) || (t.exports = n), t.exports = o, t.exports.default = o, "object" == typeof self && (self.fastMax = o), "object" == typeof window && (window.fastMax = o);
        },
        function(t, e, r) {
            "use strict";
            const { MAX_SAFE_INTEGER: n } = r(131), i = n.toString().length - 1;
            t.exports = {
                MAX_SAFE_INTEGER_LENGTH: i
            };
        },
        function(t, e, r) {
            "use strict";
            const { MAX_SAFE_INTEGER_LENGTH: n } = r(56);
            function i(t, e) {
                const r = t.length, i = e.length, o = t.indexOf("."), a = e.indexOf("."), s = -1 === o ? r : o, u = -1 === a ? i : a;
                if (-1 === o && -1 === a && r < n && i < n) return (Number(t) - Number(e)).toFixed();
                const l = s - u;
                let c = Math.max(s, u), f = Math.max(r - s - 1, i - u - 1), h = l < 0 ? -1 * l : 0, p = l <= 0 ? 0 : l, d = c + 1 + f - 1, m = "", y = 0, g = d;
                if (f > 0) {
                    for(; g > d - f;){
                        let r = t[g - h] || "0", n = e[g - p] || "0";
                        r -= y, y = 0;
                        let i = r - n;
                        if (i < 0) for(; i < 0;)y++, i += 10;
                        else y && y--;
                        "" === m && 0 === i || (m = i + m), g--;
                    }
                    "" !== m && (m = "." + m), g--;
                }
                if (c > 0) {
                    for(; g > 0;){
                        let r = t[g - h] || "0", n = e[g - p] || "0";
                        r -= y, y = 0;
                        let i = r - n;
                        if (i < 0) for(; i < 0;)y++, i += 10;
                        else y && y--;
                        m = i + m, g--;
                    }
                    const r = t[0 - h] || "0", n = e[0 - p] || "0";
                    let i = Number(r) - (y > 0 ? 1 : 0) - Number(n);
                    0 !== i && (m = i + m), m = m.replace(/^0+/, "");
                }
                return "." === m[0] && (m = "0" + m), m;
            }
            t.exports = i, t.exports.default = i;
        },
        function(t, e, r) {
            "use strict";
            const n = r(20), i = r(19), o = r(39), a = r(77);
            function s(t, e, { format: r = "string", max_decimal_digits: s = 100, ellipsis: u = !1 } = {}) {
                "0" === t[0] && (t = t.substring(1)), "0" === e[0] && (e = e.substring(1));
                const l = t.indexOf("."), c = e.indexOf("."), f = -1 === l ? t.length : l, h = -1 === c ? 0 : e.length - 1 - c;
                let p = !1;
                t = t.replace(/\./, ""), e = e.replace(/\./, "");
                const d = t.length;
                let m, y = "", g = "", v = -1 * h, b = 0;
                for(let r = 0; r < d; r++)if (y += t[r], m = n(y, e), ">" === m) {
                    let t = 1, r = i(e, e), a = e;
                    for(; ">" !== n(r, y);)t++, a = r, r = i(r, e);
                    if (t = t.toString(), "" !== g) for(let e = t.length; e <= b; e++)g += "0";
                    g += t, y = o(y, a), b = 0;
                } else {
                    if ("<" === m) {
                        "" === g && v++, b++;
                        continue;
                    }
                    if ("=" === m) {
                        if ("" !== g) for(let t = 0; t < b; t++)g += "0";
                        g += "1", y = "0", b = 0;
                    }
                }
                if (y.match(/^0+$/g)) "<" === m && (g += y.substring(0, y.length - 1));
                else {
                    const t = {}, r = f - v - g.length + s + 1;
                    "" === g && (b = 0);
                    for(let a = 0; a < r; a++){
                        if (y += "0", u) {
                            if (y in t) {
                                if (t[y]++, t[y] > 3) {
                                    g += "...", p = !0;
                                    break;
                                }
                            } else t[y] = 1;
                        }
                        const r = n(y, e);
                        if (">" === r) {
                            let t = 1, r = i(e, e), a = e;
                            for(; ">" !== n(r, y);)t++, a = r, r = i(r, e);
                            t = t.toString();
                            for(let e = t.length; e <= b; e++)g += "0";
                            if (g += t, y = o(y, a), "0" === y) break;
                            b = 0;
                        } else {
                            if ("<" === r) {
                                b++;
                                continue;
                            }
                            if ("=" === r) {
                                for(let t = 0; t < b; t++)g += "0";
                                g += "1", b = 0;
                                break;
                            }
                        }
                    }
                }
                const x = f - v, w = g.length;
                let _;
                if (x === w) _ = 0;
                else if (x < 0) g = "0." + "0".repeat(Math.abs(x)) + g, _ = w - x;
                else if (x > w) {
                    for(let t = w; t < x; t++)g += "0";
                    _ = 0;
                } else x < w ? (g = g.substring(0, x) + "." + g.substring(x), _ = w - x) : 0 === x && (g = "0." + g, _ = w);
                g = g.replace(/^0+/, ""), g = g.replace(/\.\d+0+$/, "");
                const A = _ - s;
                return p || A > 0 && (g = a(g.substring(0, g.length - A + 1))), "." === g[0] && (g = "0" + g), "object" === r ? {
                    quotient: g,
                    extra_decimals: A
                } : g;
            }
            t.exports = s, t.exports.default = s;
        },
        function(t, e, r) {
            "use strict";
            const n = r(78), i = r(242);
            function o(t, { digits: e = 0 } = {}) {
                return e = Number(e), n(t) ? i(t.substring(0, t.length - 1), {
                    digits: e
                }) + "i" : i(t, {
                    digits: e
                });
            }
            t.exports = o, t.exports.default = o;
        },
        function(t, e, r) {
            "use strict";
            function n(t, e) {
                const r = t.length, n = e.length, i = t.indexOf("."), o = e.indexOf("."), a = -1 === i ? r : i, s = -1 === o ? n : o, u = a - s;
                let l = u < 0 ? -1 * u : 0, c = u <= 0 ? 0 : u, f = Math.max(a, s) + 1 + Math.max(r - a, n - s) - 1, h = 0;
                for(; h < f;){
                    const r = h - l, n = r === a ? "." : t[r] || "0", i = h - c, o = i === s ? "." : e[i] || "0";
                    if (n !== o) {
                        if (n > o) return ">";
                        if (n < o) return "<";
                    }
                    h++;
                }
                return "=";
            }
            t.exports = n, t.exports.default = n;
        },
        function(t, e, r) {
            "use strict";
            const n = r(21), i = r(3), o = r(12), a = r(147), s = r(40), u = r(78), l = r(133), c = r(28), f = r(48), h = r(89), p = r(148), d = r(62), m = r(59), y = r(42), g = r(152);
            function v(t, e, { zero_to_the_power_of_zero: r = "1", ellipsis: v = !1, imaginary: b = !0, max_decimal_digits: x = 100, fraction: w = !1 } = {}) {
                t = i(t), e = i(e);
                const _ = b && u(t);
                _ && (t = t.replace(/i$/, ""));
                const A = c(t), E = c(e);
                if (A && E) return r;
                if (E) return "1";
                const S = y(e);
                if (A) {
                    if ("+" === S) return "0";
                    if ("-" === S) return "Infinity";
                }
                const M = s(e);
                if ("+" === S && M) {
                    let r = h(t, e);
                    return "number" == typeof x && (r = m(r, {
                        digits: x
                    })), _ && l(e) && (r += "i"), r;
                }
                if ("-" === S && M) {
                    const r = "1", i = h(t, n(e));
                    return o(r, i, {
                        ellipsis: v,
                        max_decimal_digits: x
                    });
                }
                if (!M) {
                    e = n(e);
                    let [r, i] = e.includes("/") ? e.split("/") : a(e);
                    [r, i] = g(r, i);
                    let o = d(t, i, {
                        imaginary: b
                    }), s = f(r, o);
                    return "number" == typeof x && (s = m(s, {
                        digits: x
                    })), "-" === S && (s = p(s, {
                        fraction: w,
                        max_decimal_digits: x
                    })), s;
                }
            }
            t.exports = v, t.exports.default = v;
        },
        function(t, e, r) {
            "use strict";
            const n = r(21), i = r(3), o = r(20), a = r(149), s = r(40), u = r(134), l = r(89), c = r(150);
            function f(t, e, { imaginary: r = !0, max_decimal_digits: f = 100 } = {}) {
                if (t = i(t), "1" === (e = i(e))) return t;
                if ("1" === t) return "1";
                if (!s(e)) throw new Error("[preciso] can't find fractional roots");
                if (u(e)) throw new Error("[preciso] can't find root of negative indexes");
                const h = n(t), p = u(t), d = a(e), m = p && d;
                if (m && !r) throw new Error("[preciso] root has an imaginary number");
                const y = p && !d ? "-" : "", g = c(h, e), v = [
                    "9",
                    "8",
                    "7",
                    "6",
                    "5",
                    "4",
                    "3",
                    "2",
                    "1",
                    "0"
                ];
                let b = "";
                for(let t = 0; t < g; t++)for(let r = 0; r < v.length; r++){
                    const n = b + v[r];
                    let i = n + "0".repeat(g - t - 1);
                    const a = l(i, e), s = o(a, h);
                    if ("=" === s) return m && (i += "i"), y + i;
                    if ("<" === s) {
                        b = n;
                        break;
                    }
                }
                let x = b + ".";
                for(let t = 0; t < f; t++){
                    let t = !1;
                    for(let r = 0; r < v.length; r++){
                        let n = x + v[r];
                        const i = l(n, e), a = o(i, h);
                        if ("=" === a) return m && (n += "i"), y + n;
                        if ("<" === a) {
                            x = n, t = !0;
                            break;
                        }
                    }
                    if (!t) break;
                }
                return m && (x += "i"), y + x;
            }
            t.exports = f, t.exports.default = f;
        },
        function(t, e, r) {
            r(43);
            function n(t, e) {
                const r = t.length, n = e.length, i = t.indexOf("."), o = e.indexOf("."), a = -1 === i ? r : i, s = -1 === o ? n : o, u = a - s;
                let l = u < 0 ? -1 * u : 0, c = u <= 0 ? 0 : u, f = Math.max(a, s) + 1 + Math.max(r - a, n - s) - 1, h = 0;
                for(; h < f;){
                    const r = h - l, n = r === a ? "." : t[r] || "0", i = h - c, o = i === s ? "." : e[i] || "0";
                    if (n !== o) {
                        if (n > o) return ">";
                        if (n < o) return "<";
                    }
                    h++;
                }
                return "=";
            }
            t.exports = n, t.exports.default = n;
        },
        function(t, e, r) {
            "use strict";
            function n(t) {
                if (0 === t.length) return;
                if (1 === t.length) return t[0];
                let [e, r, n, i] = t[0];
                for(let o = 1; o < t.length; o++){
                    const a = t[o];
                    a[0] < e && (e = a[0]), a[1] < r && (r = a[1]), a[2] > n && (n = a[2]), a[3] > i && (i = a[3]);
                }
                return [
                    e,
                    r,
                    n,
                    i
                ];
            }
            t.exports = n, t.exports.default = n;
        },
        function(t, e, r) {
            var n = r(179), i = r(180);
            t.exports = function(t, e, r) {
                if (n()) return Reflect.construct.apply(null, arguments);
                var o = [
                    null
                ];
                o.push.apply(o, e);
                var a = new (t.bind.apply(t, o));
                return r && i(a, r.prototype), a;
            }, t.exports.__esModule = !0, t.exports.default = t.exports;
        },
        function(t, e, r) {
            (function(r) {
                var n = "undefined" != typeof globalThis && globalThis || "undefined" != typeof self && self || void 0 !== r && r, i = function() {
                    function t() {
                        this.fetch = !1, this.DOMException = n.DOMException;
                    }
                    return t.prototype = n, new t;
                }();
                !function(t) {
                    !function(e) {
                        var r = void 0 !== t && t || "undefined" != typeof self && self || void 0 !== r && r, n = "URLSearchParams" in r, i = "Symbol" in r && "iterator" in Symbol, o = "FileReader" in r && "Blob" in r && function() {
                            try {
                                return new Blob, !0;
                            } catch (t) {
                                return !1;
                            }
                        }(), a = "FormData" in r, s = "ArrayBuffer" in r;
                        if (s) var u = [
                            "[object Int8Array]",
                            "[object Uint8Array]",
                            "[object Uint8ClampedArray]",
                            "[object Int16Array]",
                            "[object Uint16Array]",
                            "[object Int32Array]",
                            "[object Uint32Array]",
                            "[object Float32Array]",
                            "[object Float64Array]"
                        ], l = ArrayBuffer.isView || function(t) {
                            return t && u.indexOf(Object.prototype.toString.call(t)) > -1;
                        };
                        function c(t) {
                            if ("string" != typeof t && (t = String(t)), /[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(t) || "" === t) throw new TypeError('Invalid character in header field name: "' + t + '"');
                            return t.toLowerCase();
                        }
                        function f(t) {
                            return "string" != typeof t && (t = String(t)), t;
                        }
                        function h(t) {
                            var e = {
                                next: function() {
                                    var e = t.shift();
                                    return {
                                        done: void 0 === e,
                                        value: e
                                    };
                                }
                            };
                            return i && (e[Symbol.iterator] = function() {
                                return e;
                            }), e;
                        }
                        function p(t) {
                            this.map = {}, t instanceof p ? t.forEach(function(t, e) {
                                this.append(e, t);
                            }, this) : Array.isArray(t) ? t.forEach(function(t) {
                                this.append(t[0], t[1]);
                            }, this) : t && Object.getOwnPropertyNames(t).forEach(function(e) {
                                this.append(e, t[e]);
                            }, this);
                        }
                        function d(t) {
                            if (t.bodyUsed) return Promise.reject(new TypeError("Already read"));
                            t.bodyUsed = !0;
                        }
                        function m(t) {
                            return new Promise(function(e, r) {
                                t.onload = function() {
                                    e(t.result);
                                }, t.onerror = function() {
                                    r(t.error);
                                };
                            });
                        }
                        function y(t) {
                            var e = new FileReader, r = m(e);
                            return e.readAsArrayBuffer(t), r;
                        }
                        function g(t) {
                            if (t.slice) return t.slice(0);
                            var e = new Uint8Array(t.byteLength);
                            return e.set(new Uint8Array(t)), e.buffer;
                        }
                        function v() {
                            return this.bodyUsed = !1, this._initBody = function(t) {
                                var e;
                                this.bodyUsed = this.bodyUsed, this._bodyInit = t, t ? "string" == typeof t ? this._bodyText = t : o && Blob.prototype.isPrototypeOf(t) ? this._bodyBlob = t : a && FormData.prototype.isPrototypeOf(t) ? this._bodyFormData = t : n && URLSearchParams.prototype.isPrototypeOf(t) ? this._bodyText = t.toString() : s && o && (e = t) && DataView.prototype.isPrototypeOf(e) ? (this._bodyArrayBuffer = g(t.buffer), this._bodyInit = new Blob([
                                    this._bodyArrayBuffer
                                ])) : s && (ArrayBuffer.prototype.isPrototypeOf(t) || l(t)) ? this._bodyArrayBuffer = g(t) : this._bodyText = t = Object.prototype.toString.call(t) : this._bodyText = "", this.headers.get("content-type") || ("string" == typeof t ? this.headers.set("content-type", "text/plain;charset=UTF-8") : this._bodyBlob && this._bodyBlob.type ? this.headers.set("content-type", this._bodyBlob.type) : n && URLSearchParams.prototype.isPrototypeOf(t) && this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8"));
                            }, o && (this.blob = function() {
                                var t = d(this);
                                if (t) return t;
                                if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
                                if (this._bodyArrayBuffer) return Promise.resolve(new Blob([
                                    this._bodyArrayBuffer
                                ]));
                                if (this._bodyFormData) throw new Error("could not read FormData body as blob");
                                return Promise.resolve(new Blob([
                                    this._bodyText
                                ]));
                            }, this.arrayBuffer = function() {
                                if (this._bodyArrayBuffer) {
                                    var t = d(this);
                                    return t || (ArrayBuffer.isView(this._bodyArrayBuffer) ? Promise.resolve(this._bodyArrayBuffer.buffer.slice(this._bodyArrayBuffer.byteOffset, this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength)) : Promise.resolve(this._bodyArrayBuffer));
                                }
                                return this.blob().then(y);
                            }), this.text = function() {
                                var t, e, r, n = d(this);
                                if (n) return n;
                                if (this._bodyBlob) return t = this._bodyBlob, e = new FileReader, r = m(e), e.readAsText(t), r;
                                if (this._bodyArrayBuffer) return Promise.resolve(function(t) {
                                    for(var e = new Uint8Array(t), r = new Array(e.length), n = 0; n < e.length; n++)r[n] = String.fromCharCode(e[n]);
                                    return r.join("");
                                }(this._bodyArrayBuffer));
                                if (this._bodyFormData) throw new Error("could not read FormData body as text");
                                return Promise.resolve(this._bodyText);
                            }, a && (this.formData = function() {
                                return this.text().then(w);
                            }), this.json = function() {
                                return this.text().then(JSON.parse);
                            }, this;
                        }
                        p.prototype.append = function(t, e) {
                            t = c(t), e = f(e);
                            var r = this.map[t];
                            this.map[t] = r ? r + ", " + e : e;
                        }, p.prototype.delete = function(t) {
                            delete this.map[c(t)];
                        }, p.prototype.get = function(t) {
                            return t = c(t), this.has(t) ? this.map[t] : null;
                        }, p.prototype.has = function(t) {
                            return this.map.hasOwnProperty(c(t));
                        }, p.prototype.set = function(t, e) {
                            this.map[c(t)] = f(e);
                        }, p.prototype.forEach = function(t, e) {
                            for(var r in this.map)this.map.hasOwnProperty(r) && t.call(e, this.map[r], r, this);
                        }, p.prototype.keys = function() {
                            var t = [];
                            return this.forEach(function(e, r) {
                                t.push(r);
                            }), h(t);
                        }, p.prototype.values = function() {
                            var t = [];
                            return this.forEach(function(e) {
                                t.push(e);
                            }), h(t);
                        }, p.prototype.entries = function() {
                            var t = [];
                            return this.forEach(function(e, r) {
                                t.push([
                                    r,
                                    e
                                ]);
                            }), h(t);
                        }, i && (p.prototype[Symbol.iterator] = p.prototype.entries);
                        var b = [
                            "DELETE",
                            "GET",
                            "HEAD",
                            "OPTIONS",
                            "POST",
                            "PUT"
                        ];
                        function x(t, e) {
                            if (!(this instanceof x)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
                            var r, n, i = (e = e || {}).body;
                            if (t instanceof x) {
                                if (t.bodyUsed) throw new TypeError("Already read");
                                this.url = t.url, this.credentials = t.credentials, e.headers || (this.headers = new p(t.headers)), this.method = t.method, this.mode = t.mode, this.signal = t.signal, i || null == t._bodyInit || (i = t._bodyInit, t.bodyUsed = !0);
                            } else this.url = String(t);
                            if (this.credentials = e.credentials || this.credentials || "same-origin", !e.headers && this.headers || (this.headers = new p(e.headers)), this.method = (r = e.method || this.method || "GET", n = r.toUpperCase(), b.indexOf(n) > -1 ? n : r), this.mode = e.mode || this.mode || null, this.signal = e.signal || this.signal, this.referrer = null, ("GET" === this.method || "HEAD" === this.method) && i) throw new TypeError("Body not allowed for GET or HEAD requests");
                            if (this._initBody(i), !("GET" !== this.method && "HEAD" !== this.method || "no-store" !== e.cache && "no-cache" !== e.cache)) {
                                var o = /([?&])_=[^&]*/;
                                if (o.test(this.url)) this.url = this.url.replace(o, "$1_=" + (new Date).getTime());
                                else this.url += (/\?/.test(this.url) ? "&" : "?") + "_=" + (new Date).getTime();
                            }
                        }
                        function w(t) {
                            var e = new FormData;
                            return t.trim().split("&").forEach(function(t) {
                                if (t) {
                                    var r = t.split("="), n = r.shift().replace(/\+/g, " "), i = r.join("=").replace(/\+/g, " ");
                                    e.append(decodeURIComponent(n), decodeURIComponent(i));
                                }
                            }), e;
                        }
                        function _(t, e) {
                            if (!(this instanceof _)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
                            e || (e = {}), this.type = "default", this.status = void 0 === e.status ? 200 : e.status, this.ok = this.status >= 200 && this.status < 300, this.statusText = void 0 === e.statusText ? "" : "" + e.statusText, this.headers = new p(e.headers), this.url = e.url || "", this._initBody(t);
                        }
                        x.prototype.clone = function() {
                            return new x(this, {
                                body: this._bodyInit
                            });
                        }, v.call(x.prototype), v.call(_.prototype), _.prototype.clone = function() {
                            return new _(this._bodyInit, {
                                status: this.status,
                                statusText: this.statusText,
                                headers: new p(this.headers),
                                url: this.url
                            });
                        }, _.error = function() {
                            var t = new _(null, {
                                status: 0,
                                statusText: ""
                            });
                            return t.type = "error", t;
                        };
                        var A = [
                            301,
                            302,
                            303,
                            307,
                            308
                        ];
                        _.redirect = function(t, e) {
                            if (-1 === A.indexOf(e)) throw new RangeError("Invalid status code");
                            return new _(null, {
                                status: e,
                                headers: {
                                    location: t
                                }
                            });
                        }, e.DOMException = r.DOMException;
                        try {
                            new e.DOMException;
                        } catch (t) {
                            e.DOMException = function(t, e) {
                                this.message = t, this.name = e;
                                var r = Error(t);
                                this.stack = r.stack;
                            }, e.DOMException.prototype = Object.create(Error.prototype), e.DOMException.prototype.constructor = e.DOMException;
                        }
                        function E(t, n) {
                            return new Promise(function(i, a) {
                                var u = new x(t, n);
                                if (u.signal && u.signal.aborted) return a(new e.DOMException("Aborted", "AbortError"));
                                var l = new XMLHttpRequest;
                                function c() {
                                    l.abort();
                                }
                                l.onload = function() {
                                    var t, e, r = {
                                        status: l.status,
                                        statusText: l.statusText,
                                        headers: (t = l.getAllResponseHeaders() || "", e = new p, t.replace(/\r?\n[\t ]+/g, " ").split("\r").map(function(t) {
                                            return 0 === t.indexOf("\n") ? t.substr(1, t.length) : t;
                                        }).forEach(function(t) {
                                            var r = t.split(":"), n = r.shift().trim();
                                            if (n) {
                                                var i = r.join(":").trim();
                                                e.append(n, i);
                                            }
                                        }), e)
                                    };
                                    r.url = "responseURL" in l ? l.responseURL : r.headers.get("X-Request-URL");
                                    var n = "response" in l ? l.response : l.responseText;
                                    setTimeout(function() {
                                        i(new _(n, r));
                                    }, 0);
                                }, l.onerror = function() {
                                    setTimeout(function() {
                                        a(new TypeError("Network request failed"));
                                    }, 0);
                                }, l.ontimeout = function() {
                                    setTimeout(function() {
                                        a(new TypeError("Network request failed"));
                                    }, 0);
                                }, l.onabort = function() {
                                    setTimeout(function() {
                                        a(new e.DOMException("Aborted", "AbortError"));
                                    }, 0);
                                }, l.open(u.method, function(t) {
                                    try {
                                        return "" === t && r.location.href ? r.location.href : t;
                                    } catch (e) {
                                        return t;
                                    }
                                }(u.url), !0), "include" === u.credentials ? l.withCredentials = !0 : "omit" === u.credentials && (l.withCredentials = !1), "responseType" in l && (o ? l.responseType = "blob" : s && u.headers.get("Content-Type") && -1 !== u.headers.get("Content-Type").indexOf("application/octet-stream") && (l.responseType = "arraybuffer")), !n || "object" != typeof n.headers || n.headers instanceof p ? u.headers.forEach(function(t, e) {
                                    l.setRequestHeader(e, t);
                                }) : Object.getOwnPropertyNames(n.headers).forEach(function(t) {
                                    l.setRequestHeader(t, f(n.headers[t]));
                                }), u.signal && (u.signal.addEventListener("abort", c), l.onreadystatechange = function() {
                                    4 === l.readyState && u.signal.removeEventListener("abort", c);
                                }), l.send(void 0 === u._bodyInit ? null : u._bodyInit);
                            });
                        }
                        E.polyfill = !0, r.fetch || (r.fetch = E, r.Headers = p, r.Request = x, r.Response = _), e.Headers = p, e.Request = x, e.Response = _, e.fetch = E;
                    }({});
                }(i), i.fetch.ponyfill = !0, delete i.fetch.polyfill;
                var o = n.fetch ? n : i;
                (e = o.fetch).default = o.fetch, e.fetch = o.fetch, e.Headers = o.Headers, e.Request = o.Request, e.Response = o.Response, t.exports = e;
            }).call(this, r(46));
        },
        function(t, e, r) {
            "use strict";
            var n = r(190);
            function i() {
                this.protocol = null, this.slashes = null, this.auth = null, this.host = null, this.port = null, this.hostname = null, this.hash = null, this.search = null, this.query = null, this.pathname = null, this.path = null, this.href = null;
            }
            var o = /^([a-z0-9.+-]+:)/i, a = /:[0-9]*$/, s = /^(\/\/?(?!\/)[^?\s]*)(\?[^\s]*)?$/, u = [
                "{",
                "}",
                "|",
                "\\",
                "^",
                "`"
            ].concat([
                "<",
                ">",
                '"',
                "`",
                " ",
                "\r",
                "\n",
                "	"
            ]), l = [
                "'"
            ].concat(u), c = [
                "%",
                "/",
                "?",
                ";",
                "#"
            ].concat(l), f = [
                "/",
                "?",
                "#"
            ], h = /^[+a-z0-9A-Z_-]{0,63}$/, p = /^([+a-z0-9A-Z_-]{0,63})(.*)$/, d = {
                javascript: !0,
                "javascript:": !0
            }, m = {
                javascript: !0,
                "javascript:": !0
            }, y = {
                http: !0,
                https: !0,
                ftp: !0,
                gopher: !0,
                file: !0,
                "http:": !0,
                "https:": !0,
                "ftp:": !0,
                "gopher:": !0,
                "file:": !0
            }, g = r(191);
            function v(t, e, r) {
                if (t && "object" == typeof t && t instanceof i) return t;
                var n = new i;
                return n.parse(t, e, r), n;
            }
            i.prototype.parse = function(t, e, r) {
                if ("string" != typeof t) throw new TypeError("Parameter 'url' must be a string, not " + typeof t);
                var i = t.indexOf("?"), a = -1 !== i && i < t.indexOf("#") ? "?" : "#", u = t.split(a);
                u[0] = u[0].replace(/\\/g, "/");
                var v = t = u.join(a);
                if (v = v.trim(), !r && 1 === t.split("#").length) {
                    var b = s.exec(v);
                    if (b) return this.path = v, this.href = v, this.pathname = b[1], b[2] ? (this.search = b[2], this.query = e ? g.parse(this.search.substr(1)) : this.search.substr(1)) : e && (this.search = "", this.query = {}), this;
                }
                var x = o.exec(v);
                if (x) {
                    var w = (x = x[0]).toLowerCase();
                    this.protocol = w, v = v.substr(x.length);
                }
                if (r || x || v.match(/^\/\/[^@/]+@[^@/]+/)) {
                    var _ = "//" === v.substr(0, 2);
                    !_ || x && m[x] || (v = v.substr(2), this.slashes = !0);
                }
                if (!m[x] && (_ || x && !y[x])) {
                    for(var A, E, S = -1, M = 0; M < f.length; M++)-1 !== (k = v.indexOf(f[M])) && (-1 === S || k < S) && (S = k);
                    -1 !== (E = -1 === S ? v.lastIndexOf("@") : v.lastIndexOf("@", S)) && (A = v.slice(0, E), v = v.slice(E + 1), this.auth = decodeURIComponent(A)), S = -1;
                    for(M = 0; M < c.length; M++){
                        var k;
                        -1 !== (k = v.indexOf(c[M])) && (-1 === S || k < S) && (S = k);
                    }
                    -1 === S && (S = v.length), this.host = v.slice(0, S), v = v.slice(S), this.parseHost(), this.hostname = this.hostname || "";
                    var N = "[" === this.hostname[0] && "]" === this.hostname[this.hostname.length - 1];
                    if (!N) for(var C = this.hostname.split(/\./), D = (M = 0, C.length); M < D; M++){
                        var O = C[M];
                        if (O && !O.match(h)) {
                            for(var T = "", F = 0, P = O.length; F < P; F++)O.charCodeAt(F) > 127 ? T += "x" : T += O[F];
                            if (!T.match(h)) {
                                var I = C.slice(0, M), B = C.slice(M + 1), j = O.match(p);
                                j && (I.push(j[1]), B.unshift(j[2])), B.length && (v = "/" + B.join(".") + v), this.hostname = I.join(".");
                                break;
                            }
                        }
                    }
                    this.hostname.length > 255 ? this.hostname = "" : this.hostname = this.hostname.toLowerCase(), N || (this.hostname = n.toASCII(this.hostname));
                    var R = this.port ? ":" + this.port : "", L = this.hostname || "";
                    this.host = L + R, this.href += this.host, N && (this.hostname = this.hostname.substr(1, this.hostname.length - 2), "/" !== v[0] && (v = "/" + v));
                }
                if (!d[w]) for(M = 0, D = l.length; M < D; M++){
                    var q = l[M];
                    if (-1 !== v.indexOf(q)) {
                        var U = encodeURIComponent(q);
                        U === q && (U = escape(q)), v = v.split(q).join(U);
                    }
                }
                var z = v.indexOf("#");
                -1 !== z && (this.hash = v.substr(z), v = v.slice(0, z));
                var G = v.indexOf("?");
                if (-1 !== G ? (this.search = v.substr(G), this.query = v.substr(G + 1), e && (this.query = g.parse(this.query)), v = v.slice(0, G)) : e && (this.search = "", this.query = {}), v && (this.pathname = v), y[w] && this.hostname && !this.pathname && (this.pathname = "/"), this.pathname || this.search) {
                    R = this.pathname || "";
                    var H = this.search || "";
                    this.path = R + H;
                }
                return this.href = this.format(), this;
            }, i.prototype.format = function() {
                var t = this.auth || "";
                t && (t = (t = encodeURIComponent(t)).replace(/%3A/i, ":"), t += "@");
                var e = this.protocol || "", r = this.pathname || "", n = this.hash || "", i = !1, o = "";
                this.host ? i = t + this.host : this.hostname && (i = t + (-1 === this.hostname.indexOf(":") ? this.hostname : "[" + this.hostname + "]"), this.port && (i += ":" + this.port)), this.query && "object" == typeof this.query && Object.keys(this.query).length && (o = g.stringify(this.query, {
                    arrayFormat: "repeat",
                    addQueryPrefix: !1
                }));
                var a = this.search || o && "?" + o || "";
                return e && ":" !== e.substr(-1) && (e += ":"), this.slashes || (!e || y[e]) && !1 !== i ? (i = "//" + (i || ""), r && "/" !== r.charAt(0) && (r = "/" + r)) : i || (i = ""), n && "#" !== n.charAt(0) && (n = "#" + n), a && "?" !== a.charAt(0) && (a = "?" + a), e + i + (r = r.replace(/[?#]/g, function(t) {
                    return encodeURIComponent(t);
                })) + (a = a.replace("#", "%23")) + n;
            }, i.prototype.resolve = function(t) {
                return this.resolveObject(v(t, !1, !0)).format();
            }, i.prototype.resolveObject = function(t) {
                if ("string" == typeof t) {
                    var e = new i;
                    e.parse(t, !1, !0), t = e;
                }
                for(var r = new i, n = Object.keys(this), o = 0; o < n.length; o++){
                    var a = n[o];
                    r[a] = this[a];
                }
                if (r.hash = t.hash, "" === t.href) return r.href = r.format(), r;
                if (t.slashes && !t.protocol) {
                    for(var s = Object.keys(t), u = 0; u < s.length; u++){
                        var l = s[u];
                        "protocol" !== l && (r[l] = t[l]);
                    }
                    return y[r.protocol] && r.hostname && !r.pathname && (r.pathname = "/", r.path = r.pathname), r.href = r.format(), r;
                }
                if (t.protocol && t.protocol !== r.protocol) {
                    if (!y[t.protocol]) {
                        for(var c = Object.keys(t), f = 0; f < c.length; f++){
                            var h = c[f];
                            r[h] = t[h];
                        }
                        return r.href = r.format(), r;
                    }
                    if (r.protocol = t.protocol, t.host || m[t.protocol]) r.pathname = t.pathname;
                    else {
                        for(var p = (t.pathname || "").split("/"); p.length && !(t.host = p.shift()););
                        t.host || (t.host = ""), t.hostname || (t.hostname = ""), "" !== p[0] && p.unshift(""), p.length < 2 && p.unshift(""), r.pathname = p.join("/");
                    }
                    if (r.search = t.search, r.query = t.query, r.host = t.host || "", r.auth = t.auth, r.hostname = t.hostname || t.host, r.port = t.port, r.pathname || r.search) {
                        var d = r.pathname || "", g = r.search || "";
                        r.path = d + g;
                    }
                    return r.slashes = r.slashes || t.slashes, r.href = r.format(), r;
                }
                var v = r.pathname && "/" === r.pathname.charAt(0), b = t.host || t.pathname && "/" === t.pathname.charAt(0), x = b || v || r.host && t.pathname, w = x, _ = r.pathname && r.pathname.split("/") || [], A = (p = t.pathname && t.pathname.split("/") || [], r.protocol && !y[r.protocol]);
                if (A && (r.hostname = "", r.port = null, r.host && ("" === _[0] ? _[0] = r.host : _.unshift(r.host)), r.host = "", t.protocol && (t.hostname = null, t.port = null, t.host && ("" === p[0] ? p[0] = t.host : p.unshift(t.host)), t.host = null), x = x && ("" === p[0] || "" === _[0])), b) r.host = t.host || "" === t.host ? t.host : r.host, r.hostname = t.hostname || "" === t.hostname ? t.hostname : r.hostname, r.search = t.search, r.query = t.query, _ = p;
                else if (p.length) _ || (_ = []), _.pop(), _ = _.concat(p), r.search = t.search, r.query = t.query;
                else if (null != t.search) {
                    if (A) r.host = _.shift(), r.hostname = r.host, (N = !!(r.host && r.host.indexOf("@") > 0) && r.host.split("@")) && (r.auth = N.shift(), r.hostname = N.shift(), r.host = r.hostname);
                    return r.search = t.search, r.query = t.query, null === r.pathname && null === r.search || (r.path = (r.pathname ? r.pathname : "") + (r.search ? r.search : "")), r.href = r.format(), r;
                }
                if (!_.length) return r.pathname = null, r.search ? r.path = "/" + r.search : r.path = null, r.href = r.format(), r;
                for(var E = _.slice(-1)[0], S = (r.host || t.host || _.length > 1) && ("." === E || ".." === E) || "" === E, M = 0, k = _.length; k >= 0; k--)"." === (E = _[k]) ? _.splice(k, 1) : ".." === E ? (_.splice(k, 1), M++) : M && (_.splice(k, 1), M--);
                if (!x && !w) for(; M--; M)_.unshift("..");
                !x || "" === _[0] || _[0] && "/" === _[0].charAt(0) || _.unshift(""), S && "/" !== _.join("/").substr(-1) && _.push("");
                var N, C = "" === _[0] || _[0] && "/" === _[0].charAt(0);
                A && (r.hostname = C ? "" : _.length ? _.shift() : "", r.host = r.hostname, (N = !!(r.host && r.host.indexOf("@") > 0) && r.host.split("@")) && (r.auth = N.shift(), r.hostname = N.shift(), r.host = r.hostname));
                return (x = x || r.host && _.length) && !C && _.unshift(""), _.length > 0 ? r.pathname = _.join("/") : (r.pathname = null, r.path = null), null === r.pathname && null === r.search || (r.path = (r.pathname ? r.pathname : "") + (r.search ? r.search : "")), r.auth = t.auth || r.auth, r.slashes = r.slashes || t.slashes, r.href = r.format(), r;
            }, i.prototype.parseHost = function() {
                var t = this.host, e = a.exec(t);
                e && (":" !== (e = e[0]) && (this.port = e.substr(1)), t = t.substr(0, t.length - e.length)), t && (this.hostname = t);
            }, e.parse = v, e.resolve = function(t, e) {
                return v(t, !1, !0).resolve(e);
            }, e.resolveObject = function(t, e) {
                return t ? v(t, !1, !0).resolveObject(e) : e;
            }, e.format = function(t) {
                return "string" == typeof t && (t = v(t)), t instanceof i ? t.format() : i.prototype.format.call(t);
            }, e.Url = i;
        },
        function(t, e, r) {
            "use strict";
            r.d(e, "a", function() {
                return i;
            });
            var n = r(53);
            function i(t) {
                return function(e) {
                    for(var r = arguments.length, i = new Array(r > 1 ? r - 1 : 0), o = 1; o < r; o++)i[o - 1] = arguments[o];
                    return "string" == typeof e ? Object(n.a)(e).then(function(e) {
                        return t.apply(void 0, [
                            e
                        ].concat(i));
                    }) : t.apply(void 0, [
                        e
                    ].concat(i));
                };
            }
        },
        function(t, e, r) {
            "use strict";
            r.d(e, "a", function() {
                return D;
            });
            var n = r(8), i = r.n(n), o = r(105), a = r.n(o), s = r(171), u = r.n(s), l = r(92), c = r.n(l), f = r(172), h = r.n(f), p = r(106), d = r.n(p), m = r(55), y = r.n(m), g = r(64), v = r.n(g), b = r(107), x = r.n(b), w = r(173), _ = r.n(w), A = r(174), E = r(14), S = r.n(E), M = r(175), k = r.n(M), N = r(13), C = [
                1,
                1
            ], D = Object(N.a)(function(t, e, r) {
                var n = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {}, o = n.debug_level, s = void 0 === o ? 0 : o, l = n.vrm, f = void 0 === l ? C : l, p = [
                    t.xmin,
                    t.ymin,
                    t.xmax,
                    t.ymax
                ], m = t.pixelHeight.toString(), g = t.pixelWidth.toString();
                if ("number" == typeof f) {
                    if (f <= 0 || f !== Math.round(f)) throw new Error("[geoblaze] vrm can only be defined as a positive integer");
                    f = [
                        f,
                        f
                    ];
                }
                var b = x()(h()(e));
                if (s >= 2 && console.log("[geoblaze] geometry_bboxes:", b), b = b.filter(function(t) {
                    return c()(t, p);
                }), s >= 2 && console.log("[geoblaze] intersecting geometry bboxes:", b), 0 !== b.length) {
                    var w = b.map(function(t) {
                        return u()(t);
                    });
                    s >= 2 && console.log("[geoblaze] size of geometry bboxes:", w);
                    var E = w.map(function(e) {
                        var r = i()(e, 2), n = r[0], o = r[1];
                        return [
                            n / t.pixelWidth,
                            o / t.pixelHeight
                        ];
                    });
                    if (s >= 2 && console.log("[geoblaze] geometry_bbox_size_ratios:", E), "minimal" === f) {
                        if (E.some(function(t) {
                            var e = i()(t, 2), r = e[0], n = e[1];
                            return r <= 1 || n <= 1;
                        })) {
                            var M = E.map(function(t) {
                                var e = i()(t, 2);
                                return [
                                    2 / e[0],
                                    2 / e[1]
                                ];
                            });
                            f = [
                                Math.min(1e4, Math.ceil(y()(M.map(function(t) {
                                    var e = i()(t, 2), r = e[0];
                                    e[1];
                                    return r;
                                })))),
                                Math.min(1e4, Math.ceil(y()(M.map(function(t) {
                                    var e = i()(t, 2);
                                    e[0];
                                    return e[1];
                                }))))
                            ];
                        } else f = C;
                    }
                    s >= 2 && console.log("[geoblaze] vrm:", f);
                    var N, D = f, O = i()(D, 2), T = O[0], F = O[1];
                    if (t.values) {
                        s >= 2 && console.log("[geoblaze] georaster already has all values loaded into memory");
                        var P = t.values, I = d.a.calculate({
                            debug: !1,
                            raster_bbox: p,
                            raster_height: t.height * F,
                            raster_width: t.width * T,
                            pixel_height: t.pixelHeight / F,
                            pixel_width: t.pixelWidth / T,
                            geometry: e
                        });
                        N = [
                            {
                                intersections: I,
                                sample: P,
                                offset: [
                                    0,
                                    0
                                ]
                            }
                        ];
                    } else if (t.getValues) {
                        var B = Object(A.PreciseGeotransform)([
                            t.xmin.toString(),
                            g,
                            "0",
                            t.ymax.toString(),
                            "0",
                            "-" + m
                        ]);
                        s >= 2 && console.log("[geoblaze] geotransfrom:", B);
                        var j = v()(b);
                        s >= 2 && console.log("[geoblaze] combined_geometry_bbox:", j);
                        var R = b.reduce(function(t, e) {
                            return t + a()(e);
                        }, 0), L = a()(j), q = R / L;
                        s >= 2 && console.log("[geoblaze] percentage of sample area used:", q);
                        var U = q > .01 ? [
                            j
                        ] : b, z = U.map(function(e) {
                            var r = i()(e, 4), n = r[0], o = r[1], a = r[2], u = r[3], l = {
                                bbox: [
                                    n.toString(),
                                    o.toString(),
                                    a.toString(),
                                    u.toString()
                                ],
                                debug: !1,
                                origin: [
                                    t.xmin.toString(),
                                    t.ymax.toString()
                                ],
                                overflow: !1,
                                padding: [
                                    "1",
                                    "1"
                                ],
                                scale: [
                                    g,
                                    "-" + m
                                ],
                                size: [
                                    t.width.toString(),
                                    t.height.toString()
                                ],
                                precise: !0
                            };
                            s >= 2 && console.log("[geoblaze] snapping:", l);
                            var c = k()(l);
                            s >= 2 && console.log("[geoblaze] snap_result:", c);
                            var f = c.bbox_in_grid_cells.map(function(t) {
                                return Number(t);
                            });
                            return s >= 2 && console.log("[geoblaze] image_bbox:", f), f;
                        }), G = x()(z);
                        N = G.map(function(r) {
                            var n = i()(r, 4), o = n[0], a = n[1], u = n[2], l = n[3], c = a - l, f = u - o, h = t.getValues({
                                left: o,
                                bottom: a,
                                right: u,
                                top: l,
                                width: f,
                                height: c,
                                resampleMethod: "near"
                            }), p = {
                                debug: !0,
                                raster_bbox: _()(r, B.forward, {
                                    async: !1,
                                    density: 0
                                }).map(function(t) {
                                    return Number(t);
                                }),
                                raster_height: c * F,
                                raster_width: f * T,
                                pixel_height: t.pixelHeight / F,
                                pixel_width: t.pixelWidth / T,
                                geometry: e
                            };
                            s >= 3 && console.log("[geoblaze] intersect_params:", p);
                            var m = d.a.calculate(p);
                            return s >= 3 && console.log("[geoblaze] intersections:", JSON.stringify(m, void 0, 2)), S.a.resolve(h).then(function(t) {
                                return s >= 3 && console.log("[geoblaze] got sample:", t), {
                                    intersections: m,
                                    sample: t,
                                    offset: [
                                        o,
                                        l
                                    ]
                                };
                            });
                        });
                    }
                    return s >= 3 && console.log("[geoblaze] samples:", N), S.a.all(N).then(function(t) {
                        return t.forEach(function(t) {
                            S.a.resolve(t).then(function(t) {
                                var e = t.intersections, n = t.sample, o = i()(t.offset, 2), a = o[0], s = o[1];
                                e.rows.forEach(function(t, e) {
                                    t.forEach(function(t, o) {
                                        for(var u = i()(t, 2), l = u[0], c = u[1], f = function(t) {
                                            n.forEach(function(n, i) {
                                                var o = n[Math.floor(e / F)];
                                                if (o) {
                                                    var u = o[Math.floor(t / T)];
                                                    r(u, i, s + e, a + t);
                                                }
                                            });
                                        }, h = l; h <= c; h++)f(h);
                                    });
                                });
                            });
                        }), {
                            vrm: f
                        };
                    });
                }
            });
        },
        function(t, e) {
            function r([t, e, r, n]) {
                return [
                    [
                        [
                            t,
                            n
                        ],
                        [
                            t,
                            e
                        ],
                        [
                            r,
                            e
                        ],
                        [
                            r,
                            n
                        ],
                        [
                            t,
                            n
                        ]
                    ]
                ];
            }
            t.exports = r, t.exports.default = r;
        },
        function(t, e) {
            t.exports = function(t) {
                const e = (t)=>Array.isArray(t) || t instanceof Int8Array || t instanceof Uint8Array || t instanceof Uint8ClampedArray || t instanceof Int16Array || t instanceof Uint16Array || t instanceof Int32Array || t instanceof Uint32Array || t instanceof Float32Array || t instanceof Float64Array || t instanceof BigInt64Array || t instanceof BigUint64Array;
                let r = 0, n = t;
                for(; e(n);)r++, n = n[0];
                return r;
            };
        },
        function(t, e, r) {
            "use strict";
            var n = r(202);
            t.exports = Function.prototype.bind || n;
        },
        function(t, e, r) {
            "use strict";
            var n = r(36)("%Object.defineProperty%", !0) || !1;
            if (n) try {
                n({}, "a", {
                    value: 1
                });
            } catch (t) {
                n = !1;
            }
            t.exports = n;
        },
        function(t, e, r) {
            "use strict";
            var n = String.prototype.replace, i = /%20/g, o = "RFC1738", a = "RFC3986";
            t.exports = {
                default: a,
                formatters: {
                    RFC1738: function(t) {
                        return n.call(t, i, "+");
                    },
                    RFC3986: function(t) {
                        return String(t);
                    }
                },
                RFC1738: o,
                RFC3986: a
            };
        },
        function(t, e) {
            t.exports = function(t) {
                const e = t.length;
                if (0 === e) return [];
                const r = t[0];
                let n = r[1];
                const i = [
                    r
                ];
                for(let r = 1; r < e; r++){
                    const e = t[r], [o, a] = e;
                    o <= n + 1 ? i[i.length - 1][1] = Math.max(n, a) : i.push(e), n = a;
                }
                return i;
            };
        },
        function(t, e, r) {
            const n = r(234);
            t.exports = function(t) {
                return t.sort(n);
            };
        },
        function(t, e, r) {
            "use strict";
            const n = r(19), i = r(241), o = [
                "5",
                "6",
                "7",
                "8",
                "9"
            ];
            function a(t) {
                if (t.match(/\.9+$/)) return n(i(t), "1");
                "+" === t[0] && (t = t.substring(1));
                const e = t.length;
                let r = "";
                const a = t[t.length - 1];
                if (o.includes(a)) {
                    let n;
                    for(n = e - 2; n >= 0; n--){
                        const e = t[n];
                        if ("." === e || "-" === e) continue;
                        const i = Number(e) + 1;
                        if (10 !== i) {
                            r = i + r;
                            break;
                        }
                        r = "0" + r;
                    }
                    n > 0 && (r = t.substring(0, n) + r);
                } else r = t.substring(0, e - 1);
                return "." === r[r.length - 1] && (r = r.substring(0, r.length - 1)), r.indexOf(".") > -1 && (r = r.replace(/0+$/, "")), r;
            }
            t.exports = a, t.exports.default = a;
        },
        function(t, e, r) {
            "use strict";
            function n(t) {
                return t.includes("i");
            }
            t.exports = n, t.exports.default = n;
        },
        function(t, e, r) {
            "use strict";
            const { MAX_SAFE_INTEGER_LENGTH: n } = r(56);
            function i(t, e) {
                if ("0" === t || "0" === e) return "0";
                const r = t.indexOf("."), i = e.indexOf("."), o = (-1 === r ? t.length : r) + (-1 === i ? e.length : i), a = (-1 === r ? 0 : t.length - 1 - r) + (-1 === i ? 0 : e.length - 1 - i);
                if (0 === a && o < n) return (Number(t) * Number(e)).toFixed(0);
                const s = t.replace(".", ""), u = e.replace(".", ""), l = s.length, c = u.length, f = [];
                let h = l;
                for(; h >= 0;){
                    const t = h, e = h -= 15, r = s.substring(e, t);
                    f.push([
                        Number(r),
                        r.length
                    ]);
                }
                const p = [], d = [];
                for(let t = 0, e = c - 1; e >= 0; e--, t++){
                    const r = u[e], n = Number(r);
                    let i = 0, o = "";
                    const a = f.length - 1;
                    f.forEach(([t, e], r)=>{
                        let s = (i + n * t).toString();
                        const u = s.length;
                        if (u > e && r !== a) {
                            const t = -1 * e;
                            o = s.slice(t) + o, i = Number(s.slice(0, t));
                        } else {
                            const t = e - u;
                            for(let e = 0; e < t; e++)s = "0" + s;
                            i = 0, o = s + o;
                        }
                    }), o += "0".repeat(t), p.push(o), d.push([
                        Array.from(o).map((t)=>Number(t)),
                        o.length
                    ]);
                }
                const m = p.length, y = d[d.length - 1][1] + m;
                let g = "", v = 0;
                for(let t = 0; t < y; t++){
                    let e = v;
                    const r = Math.min(t, m - 1);
                    for(let n = 0; n <= r; n++){
                        const [r, i] = d[n], o = i - 1 - t;
                        o >= 0 && (e += r[o]);
                    }
                    e >= 10 ? (e = e.toString(), g = e[e.length - 1] + g, v = Number(e.slice(0, -1))) : (g = e + g, v = 0);
                }
                if (0 === a) g = g.replace(/^0+/, "");
                else {
                    const t = g.length - a;
                    g = g.substring(0, t) + "." + g.substring(t), g = g.replace(/^0+/, ""), g = g.replace(/\.?0+$/, ""), "." === g[0] && (g = "0" + g);
                }
                return g;
            }
            t.exports = i, t.exports.default = i;
        },
        function(t, e, r) {
            "use strict";
            const n = r(3);
            function i(t) {
                const e = (t = n(t)).indexOf(".");
                return -1 === e ? "0" : (t.length - e - 1).toString();
            }
            t.exports = i, t.exports.default = i;
        },
        function(t, e, r) {
            "use strict";
            function n(t) {
                return "-" === t[0] ? "-" : "+";
            }
            t.exports = n, t.exports.default = n;
        },
        function(t, e, r) {
            "use strict";
            const n = r(60), i = r(15), o = r(83), a = r(137);
            function s(t, e) {
                t = i(t), e = i(e);
                const r = "-" !== t[0], s = "-" !== e[0];
                if (r && s) return o(t, e);
                if (!r && !s) return "-" + o(t.substring(1), e.substring(1));
                if (!r && s) switch(t = t.substring(1), n(t, e)){
                    case "=":
                        return "0";
                    case "<":
                        return a(e, t);
                    case ">":
                        return "-" + a(t, e);
                }
                else if (r && !s) switch(e = e.substring(1), n(t, e)){
                    case "=":
                        return "0";
                    case "<":
                        return "-" + a(e, t);
                    case ">":
                        return a(t, e);
                }
            }
            t.exports = s, t.exports.default = s;
        },
        function(t, e, r) {
            "use strict";
            const { MAX_SAFE_INTEGER_LENGTH: n } = r(84);
            function i(t, e) {
                const r = t.length, i = e.length, o = t.indexOf("."), a = e.indexOf("."), s = -1 === o ? r : o, u = -1 === a ? i : a;
                if (-1 === o && -1 === a && r < n && i < n) return (Number(t) + Number(e)).toFixed();
                const l = s - u;
                let c = Math.max(s, u), f = Math.max(r - s - 1, i - u - 1), h = l < 0 ? -1 * l : 0, p = l <= 0 ? 0 : l, d = c + 1 + f - 1, m = "", y = 0, g = d;
                if (f > 0) {
                    for(; g > d - f;){
                        const r = t[g - h] || "0", n = e[g - p] || "0";
                        let i = Number(r) + Number(n) + y;
                        i >= 10 ? (i -= 10, y = 1) : y = 0, "" === m && 0 === i || (m = i + m), g--;
                    }
                    m && (m = "." + m), g--;
                }
                if (c > 0) for(; g >= 0;){
                    const r = t[g - h] || "0", n = e[g - p] || "0";
                    let i = Number(r) + Number(n) + y;
                    i >= 10 ? (i -= 10, y = 1) : y = 0, m = i + m, g--;
                }
                return 1 === y && (m = y + m), "." === m[0] && (m = "0" + m), m;
            }
            t.exports = i, t.exports.default = i;
        },
        function(t, e, r) {
            "use strict";
            const { MAX_SAFE_INTEGER: n } = r(249), i = n.toString().length - 1;
            t.exports = {
                MAX_SAFE_INTEGER_LENGTH: i
            };
        },
        function(t, e, r) {
            "use strict";
            const n = r(142), i = r(261);
            function o(t) {
                return n(t) ? "" : i(t);
            }
            t.exports = o, t.exports.default = o;
        },
        function(t, e, r) {
            "use strict";
            const n = r(21), i = r(3), o = r(26), a = r(42);
            function s(t) {
                if (-1 === (t = i(t)).indexOf(".")) return t;
                const e = a(t);
                return t = n(t).split(".")[0], "+" === e ? o(t, "1") : "-" === e ? "0" === t || "" === t ? "0" : "-" + t : void 0;
            }
            t.exports = s, t.exports.default = s;
        },
        function(t, e, r) {
            "use strict";
            const n = r(3), i = r(37);
            function o(t) {
                "string" == typeof t && (t = Array.prototype.slice.call(arguments));
                let e = n(t[0]);
                const r = t.length;
                for(let n = 1; n < r; n++){
                    const r = t[n];
                    "<" === i(r, e) && (e = r);
                }
                return e;
            }
            t.exports = o, t.exports.default = o;
        },
        function(t, e, r) {
            "use strict";
            const n = r(20), i = r(28), o = r(79), a = r(26);
            function s(t, e, r = "1") {
                if (i(t)) return "0";
                let s = t, u = t;
                for(; "<" === n(u, e);)u = a(u, r), s = o(s, u);
                return s;
            }
            t.exports = s, t.exports.default = s;
        },
        function(t, e, r) {
            "use strict";
            const n = r(41);
            function i(t, e) {
                const r = Number(e);
                let i = t;
                for(let e = 1; e < r; e++)i = n([
                    i,
                    t
                ]);
                return i;
            }
            t.exports = i, t.exports.default = i;
        },
        function(t, e, r) {
            "use strict";
            const n = r(19);
            function i(t) {
                let e = "0";
                for (let r of t)e = n(e, r);
                return e;
            }
            t.exports = i, t.exports.default = i;
        },
        function(t, e) {
            const r = 9007199254740991..toString().length - 1;
            t.exports = {
                MAX_SAFE_INTEGER: 9007199254740991,
                MAX_SAFE_INTEGER_LENGTH: r
            };
        },
        function(t, e) {
            function r([t, e, r, n], [i, o, a, s]) {
                return i <= r && a >= t && o <= n && s >= e;
            }
            t.exports = r, t.exports.default = r;
        },
        function(t, e, r) {
            "use strict";
            r.d(e, "a", function() {
                return i;
            });
            var n = r(11);
            function i(t, e, r) {
                return Object(n.a)(t, e, "max", r, {
                    vrm: "minimal"
                });
            }
        },
        function(t, e, r) {
            "use strict";
            r.d(e, "a", function() {
                return i;
            });
            var n = r(11);
            function i(t, e, r) {
                return Object(n.a)(t, e, "mean", r, {
                    vrm: "minimal"
                });
            }
        },
        function(t, e, r) {
            "use strict";
            r.d(e, "a", function() {
                return i;
            });
            var n = r(11);
            function i(t, e, r) {
                return Object(n.a)(t, e, "median", r, {
                    vrm: "minimal"
                });
            }
        },
        function(t, e, r) {
            "use strict";
            r.d(e, "a", function() {
                return i;
            });
            var n = r(11);
            function i(t, e, r) {
                return Object(n.a)(t, e, "min", r, {
                    vrm: "minimal"
                });
            }
        },
        function(t, e, r) {
            "use strict";
            r.d(e, "a", function() {
                return i;
            });
            var n = r(11);
            function i(t, e, r) {
                return Object(n.a)(t, e, "mode", r, {
                    vrm: "minimal"
                });
            }
        },
        function(t, e, r) {
            "use strict";
            r.d(e, "a", function() {
                return i;
            });
            var n = r(11);
            function i(t, e, r) {
                var i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {}, o = i.rescale, a = i.vrm;
                return Object(n.a)(t, e, "sum", r, {
                    rescale: o,
                    vrm: a
                });
            }
        },
        function(t, e, r) {
            "use strict";
            r.d(e, "a", function() {
                return ob;
            });
            var n = r(17), i = r.n(n), o = r(65), a = r.n(o), s = r(22), u = r.n(s), l = r(5), c = r.n(l), f = r(27), h = r(29), p = r.n(h), d = r(4), m = r.n(d), y = {
                epsilon: 1e-12,
                matrix: "Matrix",
                number: "number",
                precision: 64,
                predictable: !1,
                randomSeed: null
            };
            function g(t) {
                return "number" == typeof t;
            }
            function v(t) {
                return !(!t || "object" != typeof t || "function" != typeof t.constructor) && (!0 === t.isBigNumber && "object" == typeof t.constructor.prototype && !0 === t.constructor.prototype.isBigNumber || "function" == typeof t.constructor.isDecimal && !0 === t.constructor.isDecimal(t));
            }
            function b(t) {
                return t && "object" == typeof t && !0 === Object.getPrototypeOf(t).isComplex || !1;
            }
            function x(t) {
                return t && "object" == typeof t && !0 === Object.getPrototypeOf(t).isFraction || !1;
            }
            function w(t) {
                return t && !0 === t.constructor.prototype.isUnit || !1;
            }
            function _(t) {
                return "string" == typeof t;
            }
            var A = Array.isArray;
            function E(t) {
                return t && !0 === t.constructor.prototype.isMatrix || !1;
            }
            function S(t) {
                return Array.isArray(t) || E(t);
            }
            function M(t) {
                return t && t.isDenseMatrix && !0 === t.constructor.prototype.isMatrix || !1;
            }
            function k(t) {
                return t && t.isSparseMatrix && !0 === t.constructor.prototype.isMatrix || !1;
            }
            function N(t) {
                return t && !0 === t.constructor.prototype.isRange || !1;
            }
            function C(t) {
                return t && !0 === t.constructor.prototype.isIndex || !1;
            }
            function D(t) {
                return "boolean" == typeof t;
            }
            function O(t) {
                return t && !0 === t.constructor.prototype.isResultSet || !1;
            }
            function T(t) {
                return t && !0 === t.constructor.prototype.isHelp || !1;
            }
            function F(t) {
                return "function" == typeof t;
            }
            function P(t) {
                return t instanceof Date;
            }
            function I(t) {
                return t instanceof RegExp;
            }
            function B(t) {
                return !(!t || "object" != typeof t || t.constructor !== Object || b(t) || x(t));
            }
            function j(t) {
                return null === t;
            }
            function R(t) {
                return void 0 === t;
            }
            function L(t) {
                return t && !0 === t.isAccessorNode && !0 === t.constructor.prototype.isNode || !1;
            }
            function q(t) {
                return t && !0 === t.isArrayNode && !0 === t.constructor.prototype.isNode || !1;
            }
            function U(t) {
                return t && !0 === t.isAssignmentNode && !0 === t.constructor.prototype.isNode || !1;
            }
            function z(t) {
                return t && !0 === t.isBlockNode && !0 === t.constructor.prototype.isNode || !1;
            }
            function G(t) {
                return t && !0 === t.isConditionalNode && !0 === t.constructor.prototype.isNode || !1;
            }
            function H(t) {
                return t && !0 === t.isConstantNode && !0 === t.constructor.prototype.isNode || !1;
            }
            function W(t) {
                return H(t) || X(t) && 1 === t.args.length && H(t.args[0]) && "-+~".includes(t.op);
            }
            function $(t) {
                return t && !0 === t.isFunctionAssignmentNode && !0 === t.constructor.prototype.isNode || !1;
            }
            function V(t) {
                return t && !0 === t.isFunctionNode && !0 === t.constructor.prototype.isNode || !1;
            }
            function Z(t) {
                return t && !0 === t.isIndexNode && !0 === t.constructor.prototype.isNode || !1;
            }
            function Y(t) {
                return t && !0 === t.isNode && !0 === t.constructor.prototype.isNode || !1;
            }
            function K(t) {
                return t && !0 === t.isObjectNode && !0 === t.constructor.prototype.isNode || !1;
            }
            function X(t) {
                return t && !0 === t.isOperatorNode && !0 === t.constructor.prototype.isNode || !1;
            }
            function J(t) {
                return t && !0 === t.isParenthesisNode && !0 === t.constructor.prototype.isNode || !1;
            }
            function Q(t) {
                return t && !0 === t.isRangeNode && !0 === t.constructor.prototype.isNode || !1;
            }
            function tt(t) {
                return t && !0 === t.isRelationalNode && !0 === t.constructor.prototype.isNode || !1;
            }
            function et(t) {
                return t && !0 === t.isSymbolNode && !0 === t.constructor.prototype.isNode || !1;
            }
            function rt(t) {
                return t && !0 === t.constructor.prototype.isChain || !1;
            }
            function nt(t) {
                var e = typeof t;
                return "object" === e ? null === t ? "null" : v(t) ? "BigNumber" : t.constructor && t.constructor.name ? t.constructor.name : "Object" : e;
            }
            function it(t) {
                var e = typeof t;
                if ("number" === e || "string" === e || "boolean" === e || null == t) return t;
                if ("function" == typeof t.clone) return t.clone();
                if (Array.isArray(t)) return t.map(function(t) {
                    return it(t);
                });
                if (t instanceof Date) return new Date(t.valueOf());
                if (v(t)) return t;
                if (B(t)) return ot(t, it);
                throw new TypeError("Cannot clone: unknown type of value (value: ".concat(t, ")"));
            }
            function ot(t, e) {
                var r = {};
                for(var n in t)ut(t, n) && (r[n] = e(t[n]));
                return r;
            }
            function at(t, e) {
                for(var r in e)ut(e, r) && (t[r] = e[r]);
                return t;
            }
            function st(t, e) {
                var r, n, i;
                if (Array.isArray(t)) {
                    if (!Array.isArray(e)) return !1;
                    if (t.length !== e.length) return !1;
                    for(n = 0, i = t.length; n < i; n++)if (!st(t[n], e[n])) return !1;
                    return !0;
                }
                if ("function" == typeof t) return t === e;
                if (t instanceof Object) {
                    if (Array.isArray(e) || !(e instanceof Object)) return !1;
                    for(r in t)if (!(r in e) || !st(t[r], e[r])) return !1;
                    for(r in e)if (!(r in t)) return !1;
                    return !0;
                }
                return t === e;
            }
            function ut(t, e) {
                return t && Object.hasOwnProperty.call(t, e);
            }
            var lt = [
                "Matrix",
                "Array"
            ], ct = [
                "number",
                "BigNumber",
                "Fraction"
            ];
            var ft = function(t) {
                if (t) throw new Error("The global config is readonly. \nPlease create a mathjs instance if you want to change the default configuration. \nExample:\n\n  import { create, all } from 'mathjs';\n  const mathjs = create(all);\n  mathjs.config({ number: 'BigNumber' });\n");
                return Object.freeze(y);
            };
            m()(ft, y, {
                MATRIX_OPTIONS: lt,
                NUMBER_OPTIONS: ct
            });
            var ht = new Set([
                "end"
            ]);
            function pt(t) {
                return "boolean" == typeof t || !!isFinite(t) && t === Math.round(t);
            }
            var dt = Math.sign || function(t) {
                return t > 0 ? 1 : t < 0 ? -1 : 0;
            }, mt = Math.log2 || function(t) {
                return Math.log(t) / Math.LN2;
            }, yt = Math.log10 || function(t) {
                return Math.log(t) / Math.LN10;
            }, gt = Math.log1p || function(t) {
                return Math.log(t + 1);
            }, vt = Math.cbrt || function(t) {
                if (0 === t) return t;
                var e, r = t < 0;
                return r && (t = -t), e = isFinite(t) ? (t / ((e = Math.exp(Math.log(t) / 3)) * e) + 2 * e) / 3 : t, r ? -e : e;
            }, bt = Math.expm1 || function(t) {
                return t >= 2e-4 || t <= -0.0002 ? Math.exp(t) - 1 : t + t * t / 2 + t * t * t / 6;
            };
            function xt(t, e, r) {
                var n = {
                    2: "0b",
                    8: "0o",
                    16: "0x"
                }[e], i = "";
                if (r) {
                    if (r < 1) throw new Error("size must be in greater than 0");
                    if (!pt(r)) throw new Error("size must be an integer");
                    if (t > 2 ** (r - 1) - 1 || t < -(2 ** (r - 1))) throw new Error("Value must be in range [-2^".concat(r - 1, ", 2^").concat(r - 1, "-1]"));
                    if (!pt(t)) throw new Error("Value must be an integer");
                    t < 0 && (t += 2 ** r), i = "i".concat(r);
                }
                var o = "";
                return t < 0 && (t = -t, o = "-"), "".concat(o).concat(n).concat(t.toString(e)).concat(i);
            }
            function wt(t, e) {
                if ("function" == typeof e) return e(t);
                if (t === 1 / 0) return "Infinity";
                if (t === -1 / 0) return "-Infinity";
                if (isNaN(t)) return "NaN";
                var r, n, i = "auto";
                if (e && (e.notation && (i = e.notation), g(e) ? r = e : g(e.precision) && (r = e.precision), e.wordSize && "number" != typeof (n = e.wordSize))) throw new Error('Option "wordSize" must be a number');
                switch(i){
                    case "fixed":
                        return At(t, r);
                    case "exponential":
                        return Et(t, r);
                    case "engineering":
                        return function(t, e) {
                            if (isNaN(t) || !isFinite(t)) return String(t);
                            var r = St(_t(t), e), n = r.exponent, i = r.coefficients, o = n % 3 == 0 ? n : n < 0 ? n - 3 - n % 3 : n - n % 3;
                            if (g(e)) for(; e > i.length || n - o + 1 > i.length;)i.push(0);
                            else for(var a = Math.abs(n - o) - (i.length - 1), s = 0; s < a; s++)i.push(0);
                            var u = Math.abs(n - o), l = 1;
                            for(; u > 0;)l++, u--;
                            var c = i.slice(l).join(""), f = g(e) && c.length || c.match(/[1-9]/) ? "." + c : "", h = i.slice(0, l).join("") + f + "e" + (n >= 0 ? "+" : "") + o.toString();
                            return r.sign + h;
                        }(t, r);
                    case "bin":
                        return xt(t, 2, n);
                    case "oct":
                        return xt(t, 8, n);
                    case "hex":
                        return xt(t, 16, n);
                    case "auto":
                        return (function(t, e, r) {
                            if (isNaN(t) || !isFinite(t)) return String(t);
                            var n = r && void 0 !== r.lowerExp ? r.lowerExp : -3, i = r && void 0 !== r.upperExp ? r.upperExp : 5, o = _t(t), a = e ? St(o, e) : o;
                            if (a.exponent < n || a.exponent >= i) return Et(t, e);
                            var s = a.coefficients, u = a.exponent;
                            s.length < e && (s = s.concat(Mt(e - s.length))), s = s.concat(Mt(u - s.length + 1 + (s.length < e ? e - s.length : 0))), s = Mt(-u).concat(s);
                            var l = u > 0 ? u : 0;
                            return l < s.length - 1 && s.splice(l + 1, 0, "."), a.sign + s.join("");
                        })(t, r, e && e).replace(/((\.\d*?)(0+))($|e)/, function() {
                            var t = arguments[2], e = arguments[4];
                            return "." !== t ? t + e : e;
                        });
                    default:
                        throw new Error('Unknown notation "' + i + '". Choose "auto", "exponential", "fixed", "bin", "oct", or "hex.');
                }
            }
            function _t(t) {
                var e = String(t).toLowerCase().match(/^(-?)(\d+\.?\d*)(e([+-]?\d+))?$/);
                if (!e) throw new SyntaxError("Invalid number " + t);
                var r = e[1], n = e[2], i = parseFloat(e[4] || "0"), o = n.indexOf(".");
                i += -1 !== o ? o - 1 : n.length - 1;
                var a = n.replace(".", "").replace(/^0*/, function(t) {
                    return i -= t.length, "";
                }).replace(/0*$/, "").split("").map(function(t) {
                    return parseInt(t);
                });
                return 0 === a.length && (a.push(0), i++), {
                    sign: r,
                    coefficients: a,
                    exponent: i
                };
            }
            function At(t, e) {
                if (isNaN(t) || !isFinite(t)) return String(t);
                var r = _t(t), n = "number" == typeof e ? St(r, r.exponent + 1 + e) : r, i = n.coefficients, o = n.exponent + 1, a = o + (e || 0);
                return i.length < a && (i = i.concat(Mt(a - i.length))), o < 0 && (i = Mt(1 - o).concat(i), o = 1), o < i.length && i.splice(o, 0, 0 === o ? "0." : "."), n.sign + i.join("");
            }
            function Et(t, e) {
                if (isNaN(t) || !isFinite(t)) return String(t);
                var r = _t(t), n = e ? St(r, e) : r, i = n.coefficients, o = n.exponent;
                i.length < e && (i = i.concat(Mt(e - i.length)));
                var a = i.shift();
                return n.sign + a + (i.length > 0 ? "." + i.join("") : "") + "e" + (o >= 0 ? "+" : "") + o;
            }
            function St(t, e) {
                for(var r = {
                    sign: t.sign,
                    coefficients: t.coefficients,
                    exponent: t.exponent
                }, n = r.coefficients; e <= 0;)n.unshift(0), r.exponent++, e++;
                if (n.length > e && n.splice(e, n.length - e)[0] >= 5) {
                    var i = e - 1;
                    for(n[i]++; 10 === n[i];)n.pop(), 0 === i && (n.unshift(0), r.exponent++, i++), n[--i]++;
                }
                return r;
            }
            function Mt(t) {
                for(var e = [], r = 0; r < t; r++)e.push(0);
                return e;
            }
            var kt = Number.EPSILON || 2220446049250313e-31;
            function Nt(t, e, r) {
                if (null == r) return t === e;
                if (t === e) return !0;
                if (isNaN(t) || isNaN(e)) return !1;
                if (isFinite(t) && isFinite(e)) {
                    var n = Math.abs(t - e);
                    return n < kt || n <= Math.max(Math.abs(t), Math.abs(e)) * r;
                }
                return !1;
            }
            var Ct = Math.acosh || function(t) {
                return Math.log(Math.sqrt(t * t - 1) + t);
            }, Dt = Math.asinh || function(t) {
                return Math.log(Math.sqrt(t * t + 1) + t);
            }, Ot = Math.atanh || function(t) {
                return Math.log((1 + t) / (1 - t)) / 2;
            }, Tt = Math.cosh || function(t) {
                return (Math.exp(t) + Math.exp(-t)) / 2;
            }, Ft = Math.sinh || function(t) {
                return (Math.exp(t) - Math.exp(-t)) / 2;
            }, Pt = Math.tanh || function(t) {
                var e = Math.exp(2 * t);
                return (e - 1) / (e + 1);
            };
            function It(t, e, r) {
                var n = new t.constructor(2), i = "";
                if (r) {
                    if (r < 1) throw new Error("size must be in greater than 0");
                    if (!pt(r)) throw new Error("size must be an integer");
                    if (t.greaterThan(n.pow(r - 1).sub(1)) || t.lessThan(n.pow(r - 1).mul(-1))) throw new Error("Value must be in range [-2^".concat(r - 1, ", 2^").concat(r - 1, "-1]"));
                    if (!t.isInteger()) throw new Error("Value must be an integer");
                    t.lessThan(0) && (t = t.add(n.pow(r))), i = "i".concat(r);
                }
                switch(e){
                    case 2:
                        return "".concat(t.toBinary()).concat(i);
                    case 8:
                        return "".concat(t.toOctal()).concat(i);
                    case 16:
                        return "".concat(t.toHexadecimal()).concat(i);
                    default:
                        throw new Error("Base ".concat(e, " not supported "));
                }
            }
            function Bt(t, e) {
                if ("function" == typeof e) return e(t);
                if (!t.isFinite()) return t.isNaN() ? "NaN" : t.gt(0) ? "Infinity" : "-Infinity";
                var r, n, i = "auto";
                if (void 0 !== e && (e.notation && (i = e.notation), "number" == typeof e ? r = e : void 0 !== e.precision && (r = e.precision), e.wordSize && "number" != typeof (n = e.wordSize))) throw new Error('Option "wordSize" must be a number');
                switch(i){
                    case "fixed":
                        return function(t, e) {
                            return t.toFixed(e);
                        }(t, r);
                    case "exponential":
                        return jt(t, r);
                    case "engineering":
                        return function(t, e) {
                            var r = t.e, n = r % 3 == 0 ? r : r < 0 ? r - 3 - r % 3 : r - r % 3, i = t.mul(Math.pow(10, -n)).toPrecision(e);
                            if (-1 !== i.indexOf("e")) {
                                var o = t.constructor;
                                i = new o(i).toFixed();
                            }
                            return i + "e" + (r >= 0 ? "+" : "") + n.toString();
                        }(t, r);
                    case "bin":
                        return It(t, 2, n);
                    case "oct":
                        return It(t, 8, n);
                    case "hex":
                        return It(t, 16, n);
                    case "auto":
                        var o = e && void 0 !== e.lowerExp ? e.lowerExp : -3, a = e && void 0 !== e.upperExp ? e.upperExp : 5;
                        if (t.isZero()) return "0";
                        var s = t.toSignificantDigits(r), u = s.e;
                        return (u >= o && u < a ? s.toFixed() : jt(t, r)).replace(/((\.\d*?)(0+))($|e)/, function() {
                            var t = arguments[2], e = arguments[4];
                            return "." !== t ? t + e : e;
                        });
                    default:
                        throw new Error('Unknown notation "' + i + '". Choose "auto", "exponential", "fixed", "bin", "oct", or "hex.');
                }
            }
            function jt(t, e) {
                return void 0 !== e ? t.toExponential(e - 1) : t.toExponential();
            }
            function Rt(t, e) {
                var r = t.length - e.length, n = t.length;
                return t.substring(r, n) === e;
            }
            function Lt(t, e) {
                var r = function(t, e) {
                    if ("number" == typeof t) return wt(t, e);
                    if (v(t)) return Bt(t, e);
                    if (function(t) {
                        return t && "object" == typeof t && "number" == typeof t.s && "number" == typeof t.n && "number" == typeof t.d || !1;
                    }(t)) return e && "decimal" === e.fraction ? t.toString() : t.s * t.n + "/" + t.d;
                    if (Array.isArray(t)) return function t(e, r) {
                        if (Array.isArray(e)) {
                            for(var n = "[", i = e.length, o = 0; o < i; o++)0 !== o && (n += ", "), n += t(e[o], r);
                            return n += "]";
                        }
                        return Lt(e, r);
                    }(t, e);
                    if (_(t)) return qt(t);
                    if ("function" == typeof t) return t.syntax ? String(t.syntax) : "function";
                    if (t && "object" == typeof t) return "function" == typeof t.format ? t.format(e) : t && t.toString(e) !== ({}).toString() ? t.toString(e) : "{" + Object.keys(t).map((r)=>qt(r) + ": " + Lt(t[r], e)).join(", ") + "}";
                    return String(t);
                }(t, e);
                return e && "object" == typeof e && "truncate" in e && r.length > e.truncate ? r.substring(0, e.truncate - 3) + "..." : r;
            }
            function qt(t) {
                for(var e = String(t), r = "", n = 0; n < e.length;){
                    var i = e.charAt(n);
                    r += i in Ut ? Ut[i] : i, n++;
                }
                return '"' + r + '"';
            }
            var Ut = {
                '"': '\\"',
                "\\": "\\\\",
                "\b": "\\b",
                "\f": "\\f",
                "\n": "\\n",
                "\r": "\\r",
                "	": "\\t"
            };
            function zt(t) {
                var e = String(t);
                return e = e.replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#39;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
            }
            function Gt(t, e) {
                if (!_(t)) throw new TypeError("Unexpected type of argument in function compareText (expected: string or Array or Matrix, actual: " + nt(t) + ", index: 0)");
                if (!_(e)) throw new TypeError("Unexpected type of argument in function compareText (expected: string or Array or Matrix, actual: " + nt(e) + ", index: 1)");
                return t === e ? 0 : t > e ? 1 : -1;
            }
            function Ht(t, e, r) {
                if (!(this instanceof Ht)) throw new SyntaxError("Constructor must be called with the new operator");
                this.actual = t, this.expected = e, this.relation = r, this.message = "Dimension mismatch (" + (Array.isArray(t) ? "[" + t.join(", ") + "]" : t) + " " + (this.relation || "!=") + " " + (Array.isArray(e) ? "[" + e.join(", ") + "]" : e) + ")", this.stack = (new Error).stack;
            }
            function Wt(t, e, r) {
                if (!(this instanceof Wt)) throw new SyntaxError("Constructor must be called with the new operator");
                this.index = t, arguments.length < 3 ? (this.min = 0, this.max = e) : (this.min = e, this.max = r), void 0 !== this.min && this.index < this.min ? this.message = "Index out of range (" + this.index + " < " + this.min + ")" : void 0 !== this.max && this.index >= this.max ? this.message = "Index out of range (" + this.index + " > " + (this.max - 1) + ")" : this.message = "Index out of range (" + this.index + ")", this.stack = (new Error).stack;
            }
            function $t(t) {
                for(var e = []; Array.isArray(t);)e.push(t.length), t = t[0];
                return e;
            }
            function Vt(t, e) {
                if (0 === e.length) {
                    if (Array.isArray(t)) throw new Ht(t.length, 0);
                } else !function t(e, r, n) {
                    var i, o = e.length;
                    if (o !== r[n]) throw new Ht(o, r[n]);
                    if (n < r.length - 1) {
                        var a = n + 1;
                        for(i = 0; i < o; i++){
                            var s = e[i];
                            if (!Array.isArray(s)) throw new Ht(r.length - 1, r.length, "<");
                            t(e[i], r, a);
                        }
                    } else for(i = 0; i < o; i++)if (Array.isArray(e[i])) throw new Ht(r.length + 1, r.length, ">");
                }(t, e, 0);
            }
            function Zt(t, e) {
                var r = t.isMatrix ? t._size : $t(t);
                e._sourceSize.forEach((t, e)=>{
                    if (null !== t && t !== r[e]) throw new Ht(t, r[e]);
                });
            }
            function Yt(t, e) {
                if (void 0 !== t) {
                    if (!g(t) || !pt(t)) throw new TypeError("Index must be an integer (value: " + t + ")");
                    if (t < 0 || "number" == typeof e && t >= e) throw new Wt(t, e);
                }
            }
            function Kt(t) {
                for(var e = 0; e < t._dimensions.length; ++e){
                    var r = t._dimensions[e];
                    if (r._data && A(r._data)) {
                        if (0 === r._size[0]) return !0;
                    } else if (r.isRange) {
                        if (r.start === r.end) return !0;
                    } else if (_(r) && 0 === r.length) return !0;
                }
                return !1;
            }
            function Xt(t, e, r) {
                if (!Array.isArray(e)) throw new TypeError("Array expected");
                if (0 === e.length) throw new Error("Resizing to scalar is not supported");
                return e.forEach(function(t) {
                    if (!g(t) || !pt(t) || t < 0) throw new TypeError("Invalid size, must contain positive integers (size: " + Lt(e) + ")");
                }), (g(t) || v(t)) && (t = [
                    t
                ]), function t(e, r, n, i) {
                    var o, a, s = e.length, u = r[n], l = Math.min(s, u);
                    if (e.length = u, n < r.length - 1) {
                        var c = n + 1;
                        for(o = 0; o < l; o++)a = e[o], Array.isArray(a) || (a = [
                            a
                        ], e[o] = a), t(a, r, c, i);
                        for(o = l; o < u; o++)a = [], e[o] = a, t(a, r, c, i);
                    } else {
                        for(o = 0; o < l; o++)for(; Array.isArray(e[o]);)e[o] = e[o][0];
                        for(o = l; o < u; o++)e[o] = i;
                    }
                }(t, e, 0, void 0 !== r ? r : 0), t;
            }
            function Jt(t, e) {
                var r = ne(t), n = r.length;
                if (!Array.isArray(t) || !Array.isArray(e)) throw new TypeError("Array expected");
                if (0 === e.length) throw new Ht(0, n, "!=");
                var i = te(e = Qt(e, n));
                if (n !== i) throw new Ht(i, n, "!=");
                try {
                    return function(t, e) {
                        for(var r, n = t, i = e.length - 1; i > 0; i--){
                            var o = e[i];
                            r = [];
                            for(var a = n.length / o, s = 0; s < a; s++)r.push(n.slice(s * o, (s + 1) * o));
                            n = r;
                        }
                        return n;
                    }(r, e);
                } catch (t) {
                    if (t instanceof Ht) throw new Ht(i, n, "!=");
                    throw t;
                }
            }
            function Qt(t, e) {
                var r = te(t), n = t.slice(), i = t.indexOf(-1);
                if (t.indexOf(-1, i + 1) >= 0) throw new Error("More than one wildcard in sizes");
                if (i >= 0) {
                    if (!(e % r == 0)) throw new Error("Could not replace wildcard, since " + e + " is no multiple of " + -r);
                    n[i] = -e / r;
                }
                return n;
            }
            function te(t) {
                return t.reduce((t, e)=>t * e, 1);
            }
            function ee(t, e) {
                for(var r = e || $t(t); Array.isArray(t) && 1 === t.length;)t = t[0], r.shift();
                for(var n = r.length; 1 === r[n - 1];)n--;
                return n < r.length && (t = function t(e, r, n) {
                    var i, o;
                    if (n < r) {
                        var a = n + 1;
                        for(i = 0, o = e.length; i < o; i++)e[i] = t(e[i], r, a);
                    } else for(; Array.isArray(e);)e = e[0];
                    return e;
                }(t, n, 0), r.length = n), t;
            }
            function re(t, e, r, n) {
                var i = n || $t(t);
                if (r) for(var o = 0; o < r; o++)t = [
                    t
                ], i.unshift(1);
                for(t = function t(e, r, n) {
                    var i, o;
                    if (Array.isArray(e)) {
                        var a = n + 1;
                        for(i = 0, o = e.length; i < o; i++)e[i] = t(e[i], r, a);
                    } else for(var s = n; s < r; s++)e = [
                        e
                    ];
                    return e;
                }(t, e, 0); i.length < e;)i.push(1);
                return t;
            }
            function ne(t) {
                if (!Array.isArray(t)) return t;
                var e = [];
                return t.forEach(function t(r) {
                    Array.isArray(r) ? r.forEach(t) : e.push(r);
                }), e;
            }
            function ie(t, e) {
                return Array.prototype.map.call(t, e);
            }
            function oe(t, e) {
                Array.prototype.forEach.call(t, e);
            }
            function ae(t, e) {
                if (1 !== $t(t).length) throw new Error("Only one dimensional matrices supported");
                return Array.prototype.filter.call(t, e);
            }
            function se(t, e) {
                if (1 !== $t(t).length) throw new Error("Only one dimensional matrices supported");
                return Array.prototype.filter.call(t, (t)=>e.test(t));
            }
            function ue(t, e) {
                return Array.prototype.join.call(t, e);
            }
            function le(t) {
                if (!Array.isArray(t)) throw new TypeError("Array input expected");
                if (0 === t.length) return t;
                var e = [], r = 0;
                e[0] = {
                    value: t[0],
                    identifier: 0
                };
                for(var n = 1; n < t.length; n++)t[n] === t[n - 1] ? r++ : r = 0, e.push({
                    value: t[n],
                    identifier: r
                });
                return e;
            }
            function ce(t) {
                if (!Array.isArray(t)) throw new TypeError("Array input expected");
                if (0 === t.length) return t;
                for(var e = [], r = 0; r < t.length; r++)e.push(t[r].value);
                return e;
            }
            function fe(t, e) {
                for(var r, n = 0, i = 0; i < t.length; i++){
                    var o = t[i], a = Array.isArray(o);
                    if (0 === i && a && (n = o.length), a && o.length !== n) return;
                    var s = a ? fe(o, e) : e(o);
                    if (void 0 === r) r = s;
                    else if (r !== s) return "mixed";
                }
                return r;
            }
            function he(t, e, r, n) {
                if (n < r) {
                    if (t.length !== e.length) throw new Ht(t.length, e.length);
                    for(var i = [], o = 0; o < t.length; o++)i[o] = he(t[o], e[o], r, n + 1);
                    return i;
                }
                return t.concat(e);
            }
            function pe() {
                var t = Array.prototype.slice.call(arguments, 0, -1), e = Array.prototype.slice.call(arguments, -1);
                if (1 === t.length) return t[0];
                if (t.length > 1) return t.slice(1).reduce(function(t, r) {
                    return he(t, r, e, 0);
                }, t[0]);
                throw new Error("Wrong number of arguments in function concat");
            }
            function de() {
                for(var t = arguments.length, e = new Array(t), r = 0; r < t; r++)e[r] = arguments[r];
                for(var n = e.map((t)=>t.length), i = Math.max(...n), o = new Array(i).fill(null), a = 0; a < e.length; a++)for(var s = e[a], u = n[a], l = 0; l < u; l++){
                    var c = i - u + l;
                    s[l] > o[c] && (o[c] = s[l]);
                }
                for(var f = 0; f < e.length; f++)me(e[f], o);
                return o;
            }
            function me(t, e) {
                for(var r = e.length, n = t.length, i = 0; i < n; i++){
                    var o = r - n + i;
                    if (t[i] < e[o] && t[i] > 1 || t[i] > e[o]) throw new Error("shape missmatch: missmatch is found in arg with shape (".concat(t, ") not possible to broadcast dimension ").concat(n, " with size ").concat(t[i], " to size ").concat(e[o]));
                }
            }
            function ye(t, e) {
                var r = $t(t);
                if (st(r, e)) return t;
                me(r, e);
                var n, i, o, a = de(r, e), s = a.length, u = [
                    ...Array(s - r.length).fill(1),
                    ...r
                ], l = function(t) {
                    return m()([], t);
                }(t);
                r.length < s && (r = $t(l = Jt(l, u)));
                for(var c = 0; c < s; c++)r[c] < a[c] && (n = l, i = a[c], o = c, r = $t(l = pe(...Array(i).fill(n), o)));
                return l;
            }
            function ge(t, e, r, n) {
                function i(n) {
                    var i = function(t, e) {
                        for(var r = {}, n = 0; n < e.length; n++){
                            var i = e[n], o = t[i];
                            void 0 !== o && (r[i] = o);
                        }
                        return r;
                    }(n, e.map(ve));
                    return function(t, e, r) {
                        if (!e.filter((t)=>!function(t) {
                                return t && "?" === t[0];
                            }(t)).every((t)=>void 0 !== r[t])) {
                            var n = e.filter((t)=>void 0 === r[t]);
                            throw new Error('Cannot create function "'.concat(t, '", ') + "some dependencies are missing: ".concat(n.map((t)=>'"'.concat(t, '"')).join(", "), "."));
                        }
                    }(t, e, n), r(i);
                }
                return i.isFactory = !0, i.fn = t, i.dependencies = e.slice().sort(), n && (i.meta = n), i;
            }
            function ve(t) {
                return t && "?" === t[0] ? t.slice(1) : t;
            }
            function be(t, e) {
                if (Ae(t) && we(t, e)) return t[e];
                if ("function" == typeof t[e] && _e(t, e)) throw new Error('Cannot access method "' + e + '" as a property');
                throw new Error('No access to property "' + e + '"');
            }
            function xe(t, e, r) {
                if (Ae(t) && we(t, e)) return t[e] = r, r;
                throw new Error('No access to property "' + e + '"');
            }
            function we(t, e) {
                return !(!t || "object" != typeof t) && (!!ut(Ee, e) || !(e in Object.prototype) && !(e in Function.prototype));
            }
            function _e(t, e) {
                return null != t && "function" == typeof t[e] && !(ut(t, e) && Object.getPrototypeOf && e in Object.getPrototypeOf(t)) && (!!ut(Se, e) || !(e in Object.prototype) && !(e in Function.prototype));
            }
            function Ae(t) {
                return "object" == typeof t && t && t.constructor === Object;
            }
            Ht.prototype = new RangeError, Ht.prototype.constructor = RangeError, Ht.prototype.name = "DimensionError", Ht.prototype.isDimensionError = !0, Wt.prototype = new RangeError, Wt.prototype.constructor = RangeError, Wt.prototype.name = "IndexError", Wt.prototype.isIndexError = !0;
            var Ee = {
                length: !0,
                name: !0
            }, Se = {
                toString: !0,
                valueOf: !0,
                toLocaleString: !0
            };
            class Me {
                constructor(t){
                    this.wrappedObject = t;
                }
                keys() {
                    return Object.keys(this.wrappedObject);
                }
                get(t) {
                    return be(this.wrappedObject, t);
                }
                set(t, e) {
                    return xe(this.wrappedObject, t, e), this;
                }
                has(t) {
                    var e;
                    return e = this.wrappedObject, t in e;
                }
            }
            function ke() {
                return new Map;
            }
            function Ne(t) {
                if (!t) return ke();
                if (Ce(t)) return t;
                if (B(t)) return new Me(t);
                throw new Error("createMap can create maps from objects or Maps");
            }
            function Ce(t) {
                return !!t && (t instanceof Map || t instanceof Me || "function" == typeof t.set && "function" == typeof t.get && "function" == typeof t.keys && "function" == typeof t.has);
            }
            function De(t) {
                for(var e = arguments.length, r = new Array(e > 1 ? e - 1 : 0), n = 1; n < e; n++)r[n - 1] = arguments[n];
                for (var i of r)if (i) {
                    if (Ce(i)) for (var o of i.keys())t.set(o, i.get(o));
                    else if (B(i)) for (var a of Object.keys(i))t.set(a, i[a]);
                }
                return t;
            }
            var Oe = ge("Node", [
                "mathWithTransform"
            ], (t)=>{
                var { mathWithTransform: e } = t;
                return class {
                    get type() {
                        return "Node";
                    }
                    get isNode() {
                        return !0;
                    }
                    evaluate(t) {
                        return this.compile().evaluate(t);
                    }
                    compile() {
                        var t = this._compile(e, {}), r = {};
                        return {
                            evaluate: function(e) {
                                var n = Ne(e);
                                return function(t) {
                                    for (var e of [
                                        ...ht
                                    ])if (t.has(e)) throw new Error('Scope contains an illegal symbol, "' + e + '" is a reserved keyword');
                                }(n), t(n, r, null);
                            }
                        };
                    }
                    _compile(t, e) {
                        throw new Error("Method _compile must be implemented by type " + this.type);
                    }
                    forEach(t) {
                        throw new Error("Cannot run forEach on a Node interface");
                    }
                    map(t) {
                        throw new Error("Cannot run map on a Node interface");
                    }
                    _ifNode(t) {
                        if (!Y(t)) throw new TypeError("Callback function must return a Node");
                        return t;
                    }
                    traverse(t) {
                        t(this, null, null), function t(e, r) {
                            e.forEach(function(e, n, i) {
                                r(e, n, i), t(e, r);
                            });
                        }(this, t);
                    }
                    transform(t) {
                        return function e(r, n, i) {
                            var o = t(r, n, i);
                            return o !== r ? o : r.map(e);
                        }(this, null, null);
                    }
                    filter(t) {
                        var e = [];
                        return this.traverse(function(r, n, i) {
                            t(r, n, i) && e.push(r);
                        }), e;
                    }
                    clone() {
                        throw new Error("Cannot clone a Node interface");
                    }
                    cloneDeep() {
                        return this.map(function(t) {
                            return t.cloneDeep();
                        });
                    }
                    equals(t) {
                        return !!t && this.type === t.type && st(this, t);
                    }
                    toString(t) {
                        var e = this._getCustomString(t);
                        return void 0 !== e ? e : this._toString(t);
                    }
                    toJSON() {
                        throw new Error("Cannot serialize object: toJSON not implemented by " + this.type);
                    }
                    toHTML(t) {
                        var e = this._getCustomString(t);
                        return void 0 !== e ? e : this.toHTML(t);
                    }
                    _toString() {
                        throw new Error("_toString not implemented for " + this.type);
                    }
                    toTex(t) {
                        var e = this._getCustomString(t);
                        return void 0 !== e ? e : this._toTex(t);
                    }
                    _toTex(t) {
                        throw new Error("_toTex not implemented for " + this.type);
                    }
                    _getCustomString(t) {
                        if (t && "object" == typeof t) switch(typeof t.handler){
                            case "object":
                            case "undefined":
                                return;
                            case "function":
                                return t.handler(this, t);
                            default:
                                throw new TypeError("Object or function expected as callback");
                        }
                    }
                    getIdentifier() {
                        return this.type;
                    }
                    getContent() {
                        return this;
                    }
                };
            }, {
                isClass: !0,
                isNode: !0
            }), Te = r(2), Fe = r.n(Te), Pe = ge("ObjectNode", [
                "Node"
            ], (t)=>{
                var { Node: e } = t;
                class r extends e {
                    constructor(t){
                        if (super(), this.properties = t || {}, t && ("object" != typeof t || !Object.keys(t).every(function(e) {
                            return Y(t[e]);
                        }))) throw new TypeError("Object containing Nodes expected");
                    }
                    get type() {
                        return "ObjectNode";
                    }
                    get isObjectNode() {
                        return !0;
                    }
                    _compile(t, e) {
                        var r = {};
                        for(var n in this.properties)if (ut(this.properties, n)) {
                            var i = qt(n), o = JSON.parse(i), a = be(this.properties, n);
                            r[o] = a._compile(t, e);
                        }
                        return function(t, e, n) {
                            var i = {};
                            for(var o in r)ut(r, o) && (i[o] = r[o](t, e, n));
                            return i;
                        };
                    }
                    forEach(t) {
                        for(var e in this.properties)ut(this.properties, e) && t(this.properties[e], "properties[" + qt(e) + "]", this);
                    }
                    map(t) {
                        var e = {};
                        for(var n in this.properties)ut(this.properties, n) && (e[n] = this._ifNode(t(this.properties[n], "properties[" + qt(n) + "]", this)));
                        return new r(e);
                    }
                    clone() {
                        var t = {};
                        for(var e in this.properties)ut(this.properties, e) && (t[e] = this.properties[e]);
                        return new r(t);
                    }
                    _toString(t) {
                        var e = [];
                        for(var r in this.properties)ut(this.properties, r) && e.push(qt(r) + ": " + this.properties[r].toString(t));
                        return "{" + e.join(", ") + "}";
                    }
                    toJSON() {
                        return {
                            mathjs: "ObjectNode",
                            properties: this.properties
                        };
                    }
                    static fromJSON(t) {
                        return new r(t.properties);
                    }
                    toHTML(t) {
                        var e = [];
                        for(var r in this.properties)ut(this.properties, r) && e.push('<span class="math-symbol math-property">' + zt(r) + '</span><span class="math-operator math-assignment-operator math-property-assignment-operator math-binary-operator">:</span>' + this.properties[r].toHTML(t));
                        return '<span class="math-parenthesis math-curly-parenthesis">{</span>' + e.join('<span class="math-separator">,</span>') + '<span class="math-parenthesis math-curly-parenthesis">}</span>';
                    }
                    _toTex(t) {
                        var e = [];
                        for(var r in this.properties)ut(this.properties, r) && e.push("\\mathbf{" + r + ":} & " + this.properties[r].toTex(t) + "\\\\");
                        return "\\left\\{\\begin{array}{ll}" + e.join("\n") + "\\end{array}\\right\\}";
                    }
                }
                return Fe()(r, "name", "ObjectNode"), r;
            }, {
                isClass: !0,
                isNode: !0
            }), Ie = [
                {
                    AssignmentNode: {},
                    FunctionAssignmentNode: {}
                },
                {
                    ConditionalNode: {
                        latexLeftParens: !1,
                        latexRightParens: !1,
                        latexParens: !1
                    }
                },
                {
                    "OperatorNode:or": {
                        op: "or",
                        associativity: "left",
                        associativeWith: []
                    }
                },
                {
                    "OperatorNode:xor": {
                        op: "xor",
                        associativity: "left",
                        associativeWith: []
                    }
                },
                {
                    "OperatorNode:and": {
                        op: "and",
                        associativity: "left",
                        associativeWith: []
                    }
                },
                {
                    "OperatorNode:bitOr": {
                        op: "|",
                        associativity: "left",
                        associativeWith: []
                    }
                },
                {
                    "OperatorNode:bitXor": {
                        op: "^|",
                        associativity: "left",
                        associativeWith: []
                    }
                },
                {
                    "OperatorNode:bitAnd": {
                        op: "&",
                        associativity: "left",
                        associativeWith: []
                    }
                },
                {
                    "OperatorNode:equal": {
                        op: "==",
                        associativity: "left",
                        associativeWith: []
                    },
                    "OperatorNode:unequal": {
                        op: "!=",
                        associativity: "left",
                        associativeWith: []
                    },
                    "OperatorNode:smaller": {
                        op: "<",
                        associativity: "left",
                        associativeWith: []
                    },
                    "OperatorNode:larger": {
                        op: ">",
                        associativity: "left",
                        associativeWith: []
                    },
                    "OperatorNode:smallerEq": {
                        op: "<=",
                        associativity: "left",
                        associativeWith: []
                    },
                    "OperatorNode:largerEq": {
                        op: ">=",
                        associativity: "left",
                        associativeWith: []
                    },
                    RelationalNode: {
                        associativity: "left",
                        associativeWith: []
                    }
                },
                {
                    "OperatorNode:leftShift": {
                        op: "<<",
                        associativity: "left",
                        associativeWith: []
                    },
                    "OperatorNode:rightArithShift": {
                        op: ">>",
                        associativity: "left",
                        associativeWith: []
                    },
                    "OperatorNode:rightLogShift": {
                        op: ">>>",
                        associativity: "left",
                        associativeWith: []
                    }
                },
                {
                    "OperatorNode:to": {
                        op: "to",
                        associativity: "left",
                        associativeWith: []
                    }
                },
                {
                    RangeNode: {}
                },
                {
                    "OperatorNode:add": {
                        op: "+",
                        associativity: "left",
                        associativeWith: [
                            "OperatorNode:add",
                            "OperatorNode:subtract"
                        ]
                    },
                    "OperatorNode:subtract": {
                        op: "-",
                        associativity: "left",
                        associativeWith: []
                    }
                },
                {
                    "OperatorNode:multiply": {
                        op: "*",
                        associativity: "left",
                        associativeWith: [
                            "OperatorNode:multiply",
                            "OperatorNode:divide",
                            "Operator:dotMultiply",
                            "Operator:dotDivide"
                        ]
                    },
                    "OperatorNode:divide": {
                        op: "/",
                        associativity: "left",
                        associativeWith: [],
                        latexLeftParens: !1,
                        latexRightParens: !1,
                        latexParens: !1
                    },
                    "OperatorNode:dotMultiply": {
                        op: ".*",
                        associativity: "left",
                        associativeWith: [
                            "OperatorNode:multiply",
                            "OperatorNode:divide",
                            "OperatorNode:dotMultiply",
                            "OperatorNode:doDivide"
                        ]
                    },
                    "OperatorNode:dotDivide": {
                        op: "./",
                        associativity: "left",
                        associativeWith: []
                    },
                    "OperatorNode:mod": {
                        op: "mod",
                        associativity: "left",
                        associativeWith: []
                    }
                },
                {
                    "OperatorNode:multiply": {
                        associativity: "left",
                        associativeWith: [
                            "OperatorNode:multiply",
                            "OperatorNode:divide",
                            "Operator:dotMultiply",
                            "Operator:dotDivide"
                        ]
                    }
                },
                {
                    "OperatorNode:unaryPlus": {
                        op: "+",
                        associativity: "right"
                    },
                    "OperatorNode:unaryMinus": {
                        op: "-",
                        associativity: "right"
                    },
                    "OperatorNode:bitNot": {
                        op: "~",
                        associativity: "right"
                    },
                    "OperatorNode:not": {
                        op: "not",
                        associativity: "right"
                    }
                },
                {
                    "OperatorNode:pow": {
                        op: "^",
                        associativity: "right",
                        associativeWith: [],
                        latexRightParens: !1
                    },
                    "OperatorNode:dotPow": {
                        op: ".^",
                        associativity: "right",
                        associativeWith: []
                    }
                },
                {
                    "OperatorNode:factorial": {
                        op: "!",
                        associativity: "left"
                    }
                },
                {
                    "OperatorNode:ctranspose": {
                        op: "'",
                        associativity: "left"
                    }
                }
            ];
            function Be(t, e) {
                if (!e || "auto" !== e) return t;
                for(var r = t; J(r);)r = r.content;
                return r;
            }
            function je(t, e, r, n) {
                var i = t;
                "keep" !== e && (i = t.getContent());
                for(var o = i.getIdentifier(), a = null, s = 0; s < Ie.length; s++)if (o in Ie[s]) {
                    a = s;
                    break;
                }
                if ("OperatorNode:multiply" === o && i.implicit && "show" !== r) {
                    var u = Be(i.args[0], e);
                    H(u) && n && "OperatorNode:divide" === n.getIdentifier() && W(Be(n.args[0], e)) || "OperatorNode:divide" === u.getIdentifier() && W(Be(u.args[0], e)) && H(Be(u.args[1])) || (a += 1);
                }
                return a;
            }
            function Re(t, e) {
                var r = t;
                "keep" !== e && (r = t.getContent());
                var n = r.getIdentifier(), i = je(r, e);
                if (null === i) return null;
                var o = Ie[i][n];
                if (ut(o, "associativity")) {
                    if ("left" === o.associativity) return "left";
                    if ("right" === o.associativity) return "right";
                    throw Error("'" + n + "' has the invalid associativity '" + o.associativity + "'.");
                }
                return null;
            }
            function Le(t, e, r) {
                var n = "keep" !== r ? t.getContent() : t, i = "keep" !== r ? t.getContent() : e, o = n.getIdentifier(), a = i.getIdentifier(), s = je(n, r);
                if (null === s) return null;
                var u = Ie[s][o];
                if (ut(u, "associativeWith") && u.associativeWith instanceof Array) {
                    for(var l = 0; l < u.associativeWith.length; l++)if (u.associativeWith[l] === a) return !0;
                    return !1;
                }
                return null;
            }
            function qe(t) {
                var e = "OperatorNode:" + t;
                for (var r of Ie)if (e in r) return r[e].op;
                return null;
            }
            var Ue = r(167), ze = r.n(Ue), Ge = {
                Alpha: "A",
                alpha: "\\alpha",
                Beta: "B",
                beta: "\\beta",
                Gamma: "\\Gamma",
                gamma: "\\gamma",
                Delta: "\\Delta",
                delta: "\\delta",
                Epsilon: "E",
                epsilon: "\\epsilon",
                varepsilon: "\\varepsilon",
                Zeta: "Z",
                zeta: "\\zeta",
                Eta: "H",
                eta: "\\eta",
                Theta: "\\Theta",
                theta: "\\theta",
                vartheta: "\\vartheta",
                Iota: "I",
                iota: "\\iota",
                Kappa: "K",
                kappa: "\\kappa",
                varkappa: "\\varkappa",
                Lambda: "\\Lambda",
                lambda: "\\lambda",
                Mu: "M",
                mu: "\\mu",
                Nu: "N",
                nu: "\\nu",
                Xi: "\\Xi",
                xi: "\\xi",
                Omicron: "O",
                omicron: "o",
                Pi: "\\Pi",
                pi: "\\pi",
                varpi: "\\varpi",
                Rho: "P",
                rho: "\\rho",
                varrho: "\\varrho",
                Sigma: "\\Sigma",
                sigma: "\\sigma",
                varsigma: "\\varsigma",
                Tau: "T",
                tau: "\\tau",
                Upsilon: "\\Upsilon",
                upsilon: "\\upsilon",
                Phi: "\\Phi",
                phi: "\\phi",
                varphi: "\\varphi",
                Chi: "X",
                chi: "\\chi",
                Psi: "\\Psi",
                psi: "\\psi",
                Omega: "\\Omega",
                omega: "\\omega",
                true: "\\mathrm{True}",
                false: "\\mathrm{False}",
                i: "i",
                inf: "\\infty",
                Inf: "\\infty",
                infinity: "\\infty",
                Infinity: "\\infty",
                oo: "\\infty",
                lim: "\\lim",
                undefined: "\\mathbf{?}"
            }, He = {
                transpose: "^\\top",
                ctranspose: "^H",
                factorial: "!",
                pow: "^",
                dotPow: ".^\\wedge",
                unaryPlus: "+",
                unaryMinus: "-",
                bitNot: "\\~",
                not: "\\neg",
                multiply: "\\cdot",
                divide: "\\frac",
                dotMultiply: ".\\cdot",
                dotDivide: ".:",
                mod: "\\mod",
                add: "+",
                subtract: "-",
                to: "\\rightarrow",
                leftShift: "<<",
                rightArithShift: ">>",
                rightLogShift: ">>>",
                equal: "=",
                unequal: "\\neq",
                smaller: "<",
                larger: ">",
                smallerEq: "\\leq",
                largerEq: "\\geq",
                bitAnd: "\\&",
                bitXor: "\\underline{|}",
                bitOr: "|",
                and: "\\wedge",
                xor: "\\veebar",
                or: "\\vee"
            }, We = {
                abs: {
                    1: "\\left|${args[0]}\\right|"
                },
                add: {
                    2: "\\left(${args[0]}".concat(He.add, "${args[1]}\\right)")
                },
                cbrt: {
                    1: "\\sqrt[3]{${args[0]}}"
                },
                ceil: {
                    1: "\\left\\lceil${args[0]}\\right\\rceil"
                },
                cube: {
                    1: "\\left(${args[0]}\\right)^3"
                },
                divide: {
                    2: "\\frac{${args[0]}}{${args[1]}}"
                },
                dotDivide: {
                    2: "\\left(${args[0]}".concat(He.dotDivide, "${args[1]}\\right)")
                },
                dotMultiply: {
                    2: "\\left(${args[0]}".concat(He.dotMultiply, "${args[1]}\\right)")
                },
                dotPow: {
                    2: "\\left(${args[0]}".concat(He.dotPow, "${args[1]}\\right)")
                },
                exp: {
                    1: "\\exp\\left(${args[0]}\\right)"
                },
                expm1: "\\left(e".concat(He.pow, "{${args[0]}}-1\\right)"),
                fix: {
                    1: "\\mathrm{${name}}\\left(${args[0]}\\right)"
                },
                floor: {
                    1: "\\left\\lfloor${args[0]}\\right\\rfloor"
                },
                gcd: "\\gcd\\left(${args}\\right)",
                hypot: "\\hypot\\left(${args}\\right)",
                log: {
                    1: "\\ln\\left(${args[0]}\\right)",
                    2: "\\log_{${args[1]}}\\left(${args[0]}\\right)"
                },
                log10: {
                    1: "\\log_{10}\\left(${args[0]}\\right)"
                },
                log1p: {
                    1: "\\ln\\left(${args[0]}+1\\right)",
                    2: "\\log_{${args[1]}}\\left(${args[0]}+1\\right)"
                },
                log2: "\\log_{2}\\left(${args[0]}\\right)",
                mod: {
                    2: "\\left(${args[0]}".concat(He.mod, "${args[1]}\\right)")
                },
                multiply: {
                    2: "\\left(${args[0]}".concat(He.multiply, "${args[1]}\\right)")
                },
                norm: {
                    1: "\\left\\|${args[0]}\\right\\|",
                    2: void 0
                },
                nthRoot: {
                    2: "\\sqrt[${args[1]}]{${args[0]}}"
                },
                nthRoots: {
                    2: "\\{y : $y^{args[1]} = {${args[0]}}\\}"
                },
                pow: {
                    2: "\\left(${args[0]}\\right)".concat(He.pow, "{${args[1]}}")
                },
                round: {
                    1: "\\left\\lfloor${args[0]}\\right\\rceil",
                    2: void 0
                },
                sign: {
                    1: "\\mathrm{${name}}\\left(${args[0]}\\right)"
                },
                sqrt: {
                    1: "\\sqrt{${args[0]}}"
                },
                square: {
                    1: "\\left(${args[0]}\\right)^2"
                },
                subtract: {
                    2: "\\left(${args[0]}".concat(He.subtract, "${args[1]}\\right)")
                },
                unaryMinus: {
                    1: "".concat(He.unaryMinus, "\\left(${args[0]}\\right)")
                },
                unaryPlus: {
                    1: "".concat(He.unaryPlus, "\\left(${args[0]}\\right)")
                },
                bitAnd: {
                    2: "\\left(${args[0]}".concat(He.bitAnd, "${args[1]}\\right)")
                },
                bitNot: {
                    1: He.bitNot + "\\left(${args[0]}\\right)"
                },
                bitOr: {
                    2: "\\left(${args[0]}".concat(He.bitOr, "${args[1]}\\right)")
                },
                bitXor: {
                    2: "\\left(${args[0]}".concat(He.bitXor, "${args[1]}\\right)")
                },
                leftShift: {
                    2: "\\left(${args[0]}".concat(He.leftShift, "${args[1]}\\right)")
                },
                rightArithShift: {
                    2: "\\left(${args[0]}".concat(He.rightArithShift, "${args[1]}\\right)")
                },
                rightLogShift: {
                    2: "\\left(${args[0]}".concat(He.rightLogShift, "${args[1]}\\right)")
                },
                bellNumbers: {
                    1: "\\mathrm{B}_{${args[0]}}"
                },
                catalan: {
                    1: "\\mathrm{C}_{${args[0]}}"
                },
                stirlingS2: {
                    2: "\\mathrm{S}\\left(${args}\\right)"
                },
                arg: {
                    1: "\\arg\\left(${args[0]}\\right)"
                },
                conj: {
                    1: "\\left(${args[0]}\\right)^*"
                },
                im: {
                    1: "\\Im\\left\\lbrace${args[0]}\\right\\rbrace"
                },
                re: {
                    1: "\\Re\\left\\lbrace${args[0]}\\right\\rbrace"
                },
                and: {
                    2: "\\left(${args[0]}".concat(He.and, "${args[1]}\\right)")
                },
                not: {
                    1: He.not + "\\left(${args[0]}\\right)"
                },
                or: {
                    2: "\\left(${args[0]}".concat(He.or, "${args[1]}\\right)")
                },
                xor: {
                    2: "\\left(${args[0]}".concat(He.xor, "${args[1]}\\right)")
                },
                cross: {
                    2: "\\left(${args[0]}\\right)\\times\\left(${args[1]}\\right)"
                },
                ctranspose: {
                    1: "\\left(${args[0]}\\right)".concat(He.ctranspose)
                },
                det: {
                    1: "\\det\\left(${args[0]}\\right)"
                },
                dot: {
                    2: "\\left(${args[0]}\\cdot${args[1]}\\right)"
                },
                expm: {
                    1: "\\exp\\left(${args[0]}\\right)"
                },
                inv: {
                    1: "\\left(${args[0]}\\right)^{-1}"
                },
                pinv: {
                    1: "\\left(${args[0]}\\right)^{+}"
                },
                sqrtm: {
                    1: "{${args[0]}}".concat(He.pow, "{\\frac{1}{2}}")
                },
                trace: {
                    1: "\\mathrm{tr}\\left(${args[0]}\\right)"
                },
                transpose: {
                    1: "\\left(${args[0]}\\right)".concat(He.transpose)
                },
                combinations: {
                    2: "\\binom{${args[0]}}{${args[1]}}"
                },
                combinationsWithRep: {
                    2: "\\left(\\!\\!{\\binom{${args[0]}}{${args[1]}}}\\!\\!\\right)"
                },
                factorial: {
                    1: "\\left(${args[0]}\\right)".concat(He.factorial)
                },
                gamma: {
                    1: "\\Gamma\\left(${args[0]}\\right)"
                },
                lgamma: {
                    1: "\\ln\\Gamma\\left(${args[0]}\\right)"
                },
                equal: {
                    2: "\\left(${args[0]}".concat(He.equal, "${args[1]}\\right)")
                },
                larger: {
                    2: "\\left(${args[0]}".concat(He.larger, "${args[1]}\\right)")
                },
                largerEq: {
                    2: "\\left(${args[0]}".concat(He.largerEq, "${args[1]}\\right)")
                },
                smaller: {
                    2: "\\left(${args[0]}".concat(He.smaller, "${args[1]}\\right)")
                },
                smallerEq: {
                    2: "\\left(${args[0]}".concat(He.smallerEq, "${args[1]}\\right)")
                },
                unequal: {
                    2: "\\left(${args[0]}".concat(He.unequal, "${args[1]}\\right)")
                },
                erf: {
                    1: "erf\\left(${args[0]}\\right)"
                },
                max: "\\max\\left(${args}\\right)",
                min: "\\min\\left(${args}\\right)",
                variance: "\\mathrm{Var}\\left(${args}\\right)",
                acos: {
                    1: "\\cos^{-1}\\left(${args[0]}\\right)"
                },
                acosh: {
                    1: "\\cosh^{-1}\\left(${args[0]}\\right)"
                },
                acot: {
                    1: "\\cot^{-1}\\left(${args[0]}\\right)"
                },
                acoth: {
                    1: "\\coth^{-1}\\left(${args[0]}\\right)"
                },
                acsc: {
                    1: "\\csc^{-1}\\left(${args[0]}\\right)"
                },
                acsch: {
                    1: "\\mathrm{csch}^{-1}\\left(${args[0]}\\right)"
                },
                asec: {
                    1: "\\sec^{-1}\\left(${args[0]}\\right)"
                },
                asech: {
                    1: "\\mathrm{sech}^{-1}\\left(${args[0]}\\right)"
                },
                asin: {
                    1: "\\sin^{-1}\\left(${args[0]}\\right)"
                },
                asinh: {
                    1: "\\sinh^{-1}\\left(${args[0]}\\right)"
                },
                atan: {
                    1: "\\tan^{-1}\\left(${args[0]}\\right)"
                },
                atan2: {
                    2: "\\mathrm{atan2}\\left(${args}\\right)"
                },
                atanh: {
                    1: "\\tanh^{-1}\\left(${args[0]}\\right)"
                },
                cos: {
                    1: "\\cos\\left(${args[0]}\\right)"
                },
                cosh: {
                    1: "\\cosh\\left(${args[0]}\\right)"
                },
                cot: {
                    1: "\\cot\\left(${args[0]}\\right)"
                },
                coth: {
                    1: "\\coth\\left(${args[0]}\\right)"
                },
                csc: {
                    1: "\\csc\\left(${args[0]}\\right)"
                },
                csch: {
                    1: "\\mathrm{csch}\\left(${args[0]}\\right)"
                },
                sec: {
                    1: "\\sec\\left(${args[0]}\\right)"
                },
                sech: {
                    1: "\\mathrm{sech}\\left(${args[0]}\\right)"
                },
                sin: {
                    1: "\\sin\\left(${args[0]}\\right)"
                },
                sinh: {
                    1: "\\sinh\\left(${args[0]}\\right)"
                },
                tan: {
                    1: "\\tan\\left(${args[0]}\\right)"
                },
                tanh: {
                    1: "\\tanh\\left(${args[0]}\\right)"
                },
                to: {
                    2: "\\left(${args[0]}".concat(He.to, "${args[1]}\\right)")
                },
                numeric: function(t, e) {
                    return t.args[0].toTex();
                },
                number: {
                    0: "0",
                    1: "\\left(${args[0]}\\right)",
                    2: "\\left(\\left(${args[0]}\\right)${args[1]}\\right)"
                },
                string: {
                    0: '\\mathtt{""}',
                    1: "\\mathrm{string}\\left(${args[0]}\\right)"
                },
                bignumber: {
                    0: "0",
                    1: "\\left(${args[0]}\\right)"
                },
                complex: {
                    0: "0",
                    1: "\\left(${args[0]}\\right)",
                    2: "\\left(\\left(${args[0]}\\right)+".concat(Ge.i, "\\cdot\\left(${args[1]}\\right)\\right)")
                },
                matrix: {
                    0: "\\begin{bmatrix}\\end{bmatrix}",
                    1: "\\left(${args[0]}\\right)",
                    2: "\\left(${args[0]}\\right)"
                },
                sparse: {
                    0: "\\begin{bsparse}\\end{bsparse}",
                    1: "\\left(${args[0]}\\right)"
                },
                unit: {
                    1: "\\left(${args[0]}\\right)",
                    2: "\\left(\\left(${args[0]}\\right)${args[1]}\\right)"
                }
            }, $e = {
                deg: "^\\circ"
            };
            function Ve(t) {
                return ze()(t, {
                    preserveFormatting: !0
                });
            }
            function Ze(t, e) {
                return (e = void 0 !== e && e) ? ut($e, t) ? $e[t] : "\\mathrm{" + Ve(t) + "}" : ut(Ge, t) ? Ge[t] : Ve(t);
            }
            var Ye = ge("OperatorNode", [
                "Node"
            ], (t)=>{
                var { Node: e } = t;
                function r(t, e) {
                    var n = t;
                    if ("auto" === e) for(; J(n);)n = n.content;
                    return !!H(n) || !!X(n) && r(n.args[0], e);
                }
                function n(t, e, n, i, o) {
                    var a, s = je(t, e, n), u = Re(t, e);
                    if ("all" === e || i.length > 2 && "OperatorNode:add" !== t.getIdentifier() && "OperatorNode:multiply" !== t.getIdentifier()) return i.map(function(t) {
                        switch(t.getContent().type){
                            case "ArrayNode":
                            case "ConstantNode":
                            case "SymbolNode":
                            case "ParenthesisNode":
                                return !1;
                            default:
                                return !0;
                        }
                    });
                    switch(i.length){
                        case 0:
                            a = [];
                            break;
                        case 1:
                            var l = je(i[0], e, n, t);
                            if (o && null !== l) {
                                var c, f;
                                if ("keep" === e ? (c = i[0].getIdentifier(), f = t.getIdentifier()) : (c = i[0].getContent().getIdentifier(), f = t.getContent().getIdentifier()), !1 === Ie[s][f].latexLeftParens) {
                                    a = [
                                        !1
                                    ];
                                    break;
                                }
                                if (!1 === Ie[l][c].latexParens) {
                                    a = [
                                        !1
                                    ];
                                    break;
                                }
                            }
                            if (null === l) {
                                a = [
                                    !1
                                ];
                                break;
                            }
                            if (l <= s) {
                                a = [
                                    !0
                                ];
                                break;
                            }
                            a = [
                                !1
                            ];
                            break;
                        case 2:
                            var h, p, d = je(i[0], e, n, t), m = Le(t, i[0], e);
                            h = null !== d && (d === s && "right" === u && !m || d < s);
                            var y, g, v, b = je(i[1], e, n, t), x = Le(t, i[1], e);
                            if (p = null !== b && (b === s && "left" === u && !x || b < s), o) "keep" === e ? (y = t.getIdentifier(), g = t.args[0].getIdentifier(), v = t.args[1].getIdentifier()) : (y = t.getContent().getIdentifier(), g = t.args[0].getContent().getIdentifier(), v = t.args[1].getContent().getIdentifier()), null !== d && (!1 === Ie[s][y].latexLeftParens && (h = !1), !1 === Ie[d][g].latexParens && (h = !1)), null !== b && (!1 === Ie[s][y].latexRightParens && (p = !1), !1 === Ie[b][v].latexParens && (p = !1));
                            a = [
                                h,
                                p
                            ];
                            break;
                        default:
                            "OperatorNode:add" !== t.getIdentifier() && "OperatorNode:multiply" !== t.getIdentifier() || (a = i.map(function(r) {
                                var i = je(r, e, n, t), o = Le(t, r, e), a = Re(r, e);
                                return null !== i && (s === i && u === a && !o || i < s);
                            }));
                    }
                    if (i.length >= 2 && "OperatorNode:multiply" === t.getIdentifier() && t.implicit && "all" !== e && "hide" === n) for(var w = 1; w < a.length; ++w)!r(i[w], e) || a[w - 1] || "keep" === e && J(i[w - 1]) || (a[w] = !0);
                    return a;
                }
                class i extends e {
                    constructor(t, e, r, n, i){
                        if (super(), "string" != typeof t) throw new TypeError('string expected for parameter "op"');
                        if ("string" != typeof e) throw new TypeError('string expected for parameter "fn"');
                        if (!Array.isArray(r) || !r.every(Y)) throw new TypeError('Array containing Nodes expected for parameter "args"');
                        this.implicit = !0 === n, this.isPercentage = !0 === i, this.op = t, this.fn = e, this.args = r || [];
                    }
                    get type() {
                        return "OperatorNode";
                    }
                    get isOperatorNode() {
                        return !0;
                    }
                    _compile(t, e) {
                        if ("string" != typeof this.fn || !_e(t, this.fn)) throw t[this.fn] ? new Error('No access to function "' + this.fn + '"') : new Error("Function " + this.fn + ' missing in provided namespace "math"');
                        var r = be(t, this.fn), n = ie(this.args, function(r) {
                            return r._compile(t, e);
                        });
                        if (1 === n.length) {
                            var i = n[0];
                            return function(t, e, n) {
                                return r(i(t, e, n));
                            };
                        }
                        if (2 === n.length) {
                            var o = n[0], a = n[1];
                            return function(t, e, n) {
                                return r(o(t, e, n), a(t, e, n));
                            };
                        }
                        return function(t, e, i) {
                            return r.apply(null, ie(n, function(r) {
                                return r(t, e, i);
                            }));
                        };
                    }
                    forEach(t) {
                        for(var e = 0; e < this.args.length; e++)t(this.args[e], "args[" + e + "]", this);
                    }
                    map(t) {
                        for(var e = [], r = 0; r < this.args.length; r++)e[r] = this._ifNode(t(this.args[r], "args[" + r + "]", this));
                        return new i(this.op, this.fn, e, this.implicit, this.isPercentage);
                    }
                    clone() {
                        return new i(this.op, this.fn, this.args.slice(0), this.implicit, this.isPercentage);
                    }
                    isUnary() {
                        return 1 === this.args.length;
                    }
                    isBinary() {
                        return 2 === this.args.length;
                    }
                    _toString(t) {
                        var e = t && t.parenthesis ? t.parenthesis : "keep", r = t && t.implicit ? t.implicit : "hide", i = this.args, o = n(this, e, r, i, !1);
                        if (1 === i.length) {
                            var a = Re(this, e), s = i[0].toString(t);
                            o[0] && (s = "(" + s + ")");
                            var u = /[a-zA-Z]+/.test(this.op);
                            return "right" === a ? this.op + (u ? " " : "") + s : "left" === a ? s + (u ? " " : "") + this.op : s + this.op;
                        }
                        if (2 === i.length) {
                            var l = i[0].toString(t), c = i[1].toString(t);
                            return o[0] && (l = "(" + l + ")"), o[1] && (c = "(" + c + ")"), this.implicit && "OperatorNode:multiply" === this.getIdentifier() && "hide" === r ? l + " " + c : l + " " + this.op + " " + c;
                        }
                        if (i.length > 2 && ("OperatorNode:add" === this.getIdentifier() || "OperatorNode:multiply" === this.getIdentifier())) {
                            var f = i.map(function(e, r) {
                                return e = e.toString(t), o[r] && (e = "(" + e + ")"), e;
                            });
                            return this.implicit && "OperatorNode:multiply" === this.getIdentifier() && "hide" === r ? f.join(" ") : f.join(" " + this.op + " ");
                        }
                        return this.fn + "(" + this.args.join(", ") + ")";
                    }
                    toJSON() {
                        return {
                            mathjs: "OperatorNode",
                            op: this.op,
                            fn: this.fn,
                            args: this.args,
                            implicit: this.implicit,
                            isPercentage: this.isPercentage
                        };
                    }
                    static fromJSON(t) {
                        return new i(t.op, t.fn, t.args, t.implicit, t.isPercentage);
                    }
                    toHTML(t) {
                        var e = t && t.parenthesis ? t.parenthesis : "keep", r = t && t.implicit ? t.implicit : "hide", i = this.args, o = n(this, e, r, i, !1);
                        if (1 === i.length) {
                            var a = Re(this, e), s = i[0].toHTML(t);
                            return o[0] && (s = '<span class="math-parenthesis math-round-parenthesis">(</span>' + s + '<span class="math-parenthesis math-round-parenthesis">)</span>'), "right" === a ? '<span class="math-operator math-unary-operator math-lefthand-unary-operator">' + zt(this.op) + "</span>" + s : s + '<span class="math-operator math-unary-operator math-righthand-unary-operator">' + zt(this.op) + "</span>";
                        }
                        if (2 === i.length) {
                            var u = i[0].toHTML(t), l = i[1].toHTML(t);
                            return o[0] && (u = '<span class="math-parenthesis math-round-parenthesis">(</span>' + u + '<span class="math-parenthesis math-round-parenthesis">)</span>'), o[1] && (l = '<span class="math-parenthesis math-round-parenthesis">(</span>' + l + '<span class="math-parenthesis math-round-parenthesis">)</span>'), this.implicit && "OperatorNode:multiply" === this.getIdentifier() && "hide" === r ? u + '<span class="math-operator math-binary-operator math-implicit-binary-operator"></span>' + l : u + '<span class="math-operator math-binary-operator math-explicit-binary-operator">' + zt(this.op) + "</span>" + l;
                        }
                        var c = i.map(function(e, r) {
                            return e = e.toHTML(t), o[r] && (e = '<span class="math-parenthesis math-round-parenthesis">(</span>' + e + '<span class="math-parenthesis math-round-parenthesis">)</span>'), e;
                        });
                        return i.length > 2 && ("OperatorNode:add" === this.getIdentifier() || "OperatorNode:multiply" === this.getIdentifier()) ? this.implicit && "OperatorNode:multiply" === this.getIdentifier() && "hide" === r ? c.join('<span class="math-operator math-binary-operator math-implicit-binary-operator"></span>') : c.join('<span class="math-operator math-binary-operator math-explicit-binary-operator">' + zt(this.op) + "</span>") : '<span class="math-function">' + zt(this.fn) + '</span><span class="math-paranthesis math-round-parenthesis">(</span>' + c.join('<span class="math-separator">,</span>') + '<span class="math-paranthesis math-round-parenthesis">)</span>';
                    }
                    _toTex(t) {
                        var e = t && t.parenthesis ? t.parenthesis : "keep", r = t && t.implicit ? t.implicit : "hide", i = this.args, o = n(this, e, r, i, !0), a = He[this.fn];
                        if (a = void 0 === a ? this.op : a, 1 === i.length) {
                            var s = Re(this, e), u = i[0].toTex(t);
                            return o[0] && (u = "\\left(".concat(u, "\\right)")), "right" === s ? a + u : u + a;
                        }
                        if (2 === i.length) {
                            var l = i[0], c = l.toTex(t);
                            o[0] && (c = "\\left(".concat(c, "\\right)"));
                            var f, h = i[1].toTex(t);
                            switch(o[1] && (h = "\\left(".concat(h, "\\right)")), f = "keep" === e ? l.getIdentifier() : l.getContent().getIdentifier(), this.getIdentifier()){
                                case "OperatorNode:divide":
                                    return a + "{" + c + "}{" + h + "}";
                                case "OperatorNode:pow":
                                    switch(c = "{" + c + "}", h = "{" + h + "}", f){
                                        case "ConditionalNode":
                                        case "OperatorNode:divide":
                                            c = "\\left(".concat(c, "\\right)");
                                    }
                                    break;
                                case "OperatorNode:multiply":
                                    if (this.implicit && "hide" === r) return c + "~" + h;
                            }
                            return c + a + h;
                        }
                        if (i.length > 2 && ("OperatorNode:add" === this.getIdentifier() || "OperatorNode:multiply" === this.getIdentifier())) {
                            var p = i.map(function(e, r) {
                                return e = e.toTex(t), o[r] && (e = "\\left(".concat(e, "\\right)")), e;
                            });
                            return "OperatorNode:multiply" === this.getIdentifier() && this.implicit && "hide" === r ? p.join("~") : p.join(a);
                        }
                        return "\\mathrm{" + this.fn + "}\\left(" + i.map(function(e) {
                            return e.toTex(t);
                        }).join(",") + "\\right)";
                    }
                    getIdentifier() {
                        return this.type + ":" + this.fn;
                    }
                }
                return Fe()(i, "name", "OperatorNode"), i;
            }, {
                isClass: !0,
                isNode: !0
            }), Ke = ge("ParenthesisNode", [
                "Node"
            ], (t)=>{
                var { Node: e } = t;
                class r extends e {
                    constructor(t){
                        if (super(), !Y(t)) throw new TypeError('Node expected for parameter "content"');
                        this.content = t;
                    }
                    get type() {
                        return "ParenthesisNode";
                    }
                    get isParenthesisNode() {
                        return !0;
                    }
                    _compile(t, e) {
                        return this.content._compile(t, e);
                    }
                    getContent() {
                        return this.content.getContent();
                    }
                    forEach(t) {
                        t(this.content, "content", this);
                    }
                    map(t) {
                        var e = t(this.content, "content", this);
                        return new r(e);
                    }
                    clone() {
                        return new r(this.content);
                    }
                    _toString(t) {
                        return !t || t && !t.parenthesis || t && "keep" === t.parenthesis ? "(" + this.content.toString(t) + ")" : this.content.toString(t);
                    }
                    toJSON() {
                        return {
                            mathjs: "ParenthesisNode",
                            content: this.content
                        };
                    }
                    static fromJSON(t) {
                        return new r(t.content);
                    }
                    toHTML(t) {
                        return !t || t && !t.parenthesis || t && "keep" === t.parenthesis ? '<span class="math-parenthesis math-round-parenthesis">(</span>' + this.content.toHTML(t) + '<span class="math-parenthesis math-round-parenthesis">)</span>' : this.content.toHTML(t);
                    }
                    _toTex(t) {
                        return !t || t && !t.parenthesis || t && "keep" === t.parenthesis ? "\\left(".concat(this.content.toTex(t), "\\right)") : this.content.toTex(t);
                    }
                }
                return Fe()(r, "name", "ParenthesisNode"), r;
            }, {
                isClass: !0,
                isNode: !0
            }), Xe = ge("RelationalNode", [
                "Node"
            ], (t)=>{
                var { Node: e } = t, r = {
                    equal: "==",
                    unequal: "!=",
                    smaller: "<",
                    larger: ">",
                    smallerEq: "<=",
                    largerEq: ">="
                };
                class n extends e {
                    constructor(t, e){
                        if (super(), !Array.isArray(t)) throw new TypeError("Parameter conditionals must be an array");
                        if (!Array.isArray(e)) throw new TypeError("Parameter params must be an array");
                        if (t.length !== e.length - 1) throw new TypeError("Parameter params must contain exactly one more element than parameter conditionals");
                        this.conditionals = t, this.params = e;
                    }
                    get type() {
                        return "RelationalNode";
                    }
                    get isRelationalNode() {
                        return !0;
                    }
                    _compile(t, e) {
                        var r = this, n = this.params.map((r)=>r._compile(t, e));
                        return function(e, i, o) {
                            for(var a, s = n[0](e, i, o), u = 0; u < r.conditionals.length; u++){
                                if (a = s, s = n[u + 1](e, i, o), !be(t, r.conditionals[u])(a, s)) return !1;
                            }
                            return !0;
                        };
                    }
                    forEach(t) {
                        this.params.forEach((e, r)=>t(e, "params[" + r + "]", this), this);
                    }
                    map(t) {
                        return new n(this.conditionals.slice(), this.params.map((e, r)=>this._ifNode(t(e, "params[" + r + "]", this)), this));
                    }
                    clone() {
                        return new n(this.conditionals, this.params);
                    }
                    _toString(t) {
                        for(var e = t && t.parenthesis ? t.parenthesis : "keep", n = je(this, e, t && t.implicit), i = this.params.map(function(r, i) {
                            var o = je(r, e, t && t.implicit);
                            return "all" === e || null !== o && o <= n ? "(" + r.toString(t) + ")" : r.toString(t);
                        }), o = i[0], a = 0; a < this.conditionals.length; a++)o += " " + r[this.conditionals[a]], o += " " + i[a + 1];
                        return o;
                    }
                    toJSON() {
                        return {
                            mathjs: "RelationalNode",
                            conditionals: this.conditionals,
                            params: this.params
                        };
                    }
                    static fromJSON(t) {
                        return new n(t.conditionals, t.params);
                    }
                    toHTML(t) {
                        for(var e = t && t.parenthesis ? t.parenthesis : "keep", n = je(this, e, t && t.implicit), i = this.params.map(function(r, i) {
                            var o = je(r, e, t && t.implicit);
                            return "all" === e || null !== o && o <= n ? '<span class="math-parenthesis math-round-parenthesis">(</span>' + r.toHTML(t) + '<span class="math-parenthesis math-round-parenthesis">)</span>' : r.toHTML(t);
                        }), o = i[0], a = 0; a < this.conditionals.length; a++)o += '<span class="math-operator math-binary-operator math-explicit-binary-operator">' + zt(r[this.conditionals[a]]) + "</span>" + i[a + 1];
                        return o;
                    }
                    _toTex(t) {
                        for(var e = t && t.parenthesis ? t.parenthesis : "keep", r = je(this, e, t && t.implicit), n = this.params.map(function(n, i) {
                            var o = je(n, e, t && t.implicit);
                            return "all" === e || null !== o && o <= r ? "\\left(" + n.toTex(t) + "\right)" : n.toTex(t);
                        }), i = n[0], o = 0; o < this.conditionals.length; o++)i += He[this.conditionals[o]] + n[o + 1];
                        return i;
                    }
                }
                return Fe()(n, "name", "RelationalNode"), n;
            }, {
                isClass: !0,
                isNode: !0
            }), Je = ge("ArrayNode", [
                "Node"
            ], (t)=>{
                var { Node: e } = t;
                class r extends e {
                    constructor(t){
                        if (super(), this.items = t || [], !Array.isArray(this.items) || !this.items.every(Y)) throw new TypeError("Array containing Nodes expected");
                    }
                    get type() {
                        return "ArrayNode";
                    }
                    get isArrayNode() {
                        return !0;
                    }
                    _compile(t, e) {
                        var r = ie(this.items, function(r) {
                            return r._compile(t, e);
                        });
                        if ("Array" !== t.config.matrix) {
                            var n = t.matrix;
                            return function(t, e, i) {
                                return n(ie(r, function(r) {
                                    return r(t, e, i);
                                }));
                            };
                        }
                        return function(t, e, n) {
                            return ie(r, function(r) {
                                return r(t, e, n);
                            });
                        };
                    }
                    forEach(t) {
                        for(var e = 0; e < this.items.length; e++)t(this.items[e], "items[" + e + "]", this);
                    }
                    map(t) {
                        for(var e = [], n = 0; n < this.items.length; n++)e[n] = this._ifNode(t(this.items[n], "items[" + n + "]", this));
                        return new r(e);
                    }
                    clone() {
                        return new r(this.items.slice(0));
                    }
                    _toString(t) {
                        return "[" + this.items.map(function(e) {
                            return e.toString(t);
                        }).join(", ") + "]";
                    }
                    toJSON() {
                        return {
                            mathjs: "ArrayNode",
                            items: this.items
                        };
                    }
                    static fromJSON(t) {
                        return new r(t.items);
                    }
                    toHTML(t) {
                        return '<span class="math-parenthesis math-square-parenthesis">[</span>' + this.items.map(function(e) {
                            return e.toHTML(t);
                        }).join('<span class="math-separator">,</span>') + '<span class="math-parenthesis math-square-parenthesis">]</span>';
                    }
                    _toTex(t) {
                        return function e(r, n) {
                            var i = r.some(q) && !r.every(q), o = n || i, a = o ? "&" : "\\\\", s = r.map(function(r) {
                                return r.items ? e(r.items, !n) : r.toTex(t);
                            }).join(a);
                            return i || !o || o && !n ? "\\begin{bmatrix}" + s + "\\end{bmatrix}" : s;
                        }(this.items, !1);
                    }
                }
                return Fe()(r, "name", "ArrayNode"), r;
            }, {
                isClass: !0,
                isNode: !0
            }), Qe = ge("BlockNode", [
                "ResultSet",
                "Node"
            ], (t)=>{
                var { ResultSet: e, Node: r } = t;
                class n extends r {
                    constructor(t){
                        if (super(), !Array.isArray(t)) throw new Error("Array expected");
                        this.blocks = t.map(function(t) {
                            var e = t && t.node, r = !t || void 0 === t.visible || t.visible;
                            if (!Y(e)) throw new TypeError('Property "node" must be a Node');
                            if ("boolean" != typeof r) throw new TypeError('Property "visible" must be a boolean');
                            return {
                                node: e,
                                visible: r
                            };
                        });
                    }
                    get type() {
                        return "BlockNode";
                    }
                    get isBlockNode() {
                        return !0;
                    }
                    _compile(t, r) {
                        var n = ie(this.blocks, function(e) {
                            return {
                                evaluate: e.node._compile(t, r),
                                visible: e.visible
                            };
                        });
                        return function(t, r, i) {
                            var o = [];
                            return oe(n, function(e) {
                                var n = e.evaluate(t, r, i);
                                e.visible && o.push(n);
                            }), new e(o);
                        };
                    }
                    forEach(t) {
                        for(var e = 0; e < this.blocks.length; e++)t(this.blocks[e].node, "blocks[" + e + "].node", this);
                    }
                    map(t) {
                        for(var e = [], r = 0; r < this.blocks.length; r++){
                            var i = this.blocks[r], o = this._ifNode(t(i.node, "blocks[" + r + "].node", this));
                            e[r] = {
                                node: o,
                                visible: i.visible
                            };
                        }
                        return new n(e);
                    }
                    clone() {
                        var t = this.blocks.map(function(t) {
                            return {
                                node: t.node,
                                visible: t.visible
                            };
                        });
                        return new n(t);
                    }
                    _toString(t) {
                        return this.blocks.map(function(e) {
                            return e.node.toString(t) + (e.visible ? "" : ";");
                        }).join("\n");
                    }
                    toJSON() {
                        return {
                            mathjs: "BlockNode",
                            blocks: this.blocks
                        };
                    }
                    static fromJSON(t) {
                        return new n(t.blocks);
                    }
                    toHTML(t) {
                        return this.blocks.map(function(e) {
                            return e.node.toHTML(t) + (e.visible ? "" : '<span class="math-separator">;</span>');
                        }).join('<span class="math-separator"><br /></span>');
                    }
                    _toTex(t) {
                        return this.blocks.map(function(e) {
                            return e.node.toTex(t) + (e.visible ? "" : ";");
                        }).join("\\;\\;\n");
                    }
                }
                return Fe()(n, "name", "BlockNode"), n;
            }, {
                isClass: !0,
                isNode: !0
            }), tr = ge("ConditionalNode", [
                "Node"
            ], (t)=>{
                var { Node: e } = t;
                class r extends e {
                    constructor(t, e, r){
                        if (super(), !Y(t)) throw new TypeError("Parameter condition must be a Node");
                        if (!Y(e)) throw new TypeError("Parameter trueExpr must be a Node");
                        if (!Y(r)) throw new TypeError("Parameter falseExpr must be a Node");
                        this.condition = t, this.trueExpr = e, this.falseExpr = r;
                    }
                    get type() {
                        return "ConditionalNode";
                    }
                    get isConditionalNode() {
                        return !0;
                    }
                    _compile(t, e) {
                        var r = this.condition._compile(t, e), n = this.trueExpr._compile(t, e), i = this.falseExpr._compile(t, e);
                        return function(t, e, o) {
                            return function(t) {
                                if ("number" == typeof t || "boolean" == typeof t || "string" == typeof t) return !!t;
                                if (t) {
                                    if (v(t)) return !t.isZero();
                                    if (b(t)) return !(!t.re && !t.im);
                                    if (w(t)) return !!t.value;
                                }
                                if (null == t) return !1;
                                throw new TypeError('Unsupported type of condition "' + nt(t) + '"');
                            }(r(t, e, o)) ? n(t, e, o) : i(t, e, o);
                        };
                    }
                    forEach(t) {
                        t(this.condition, "condition", this), t(this.trueExpr, "trueExpr", this), t(this.falseExpr, "falseExpr", this);
                    }
                    map(t) {
                        return new r(this._ifNode(t(this.condition, "condition", this)), this._ifNode(t(this.trueExpr, "trueExpr", this)), this._ifNode(t(this.falseExpr, "falseExpr", this)));
                    }
                    clone() {
                        return new r(this.condition, this.trueExpr, this.falseExpr);
                    }
                    _toString(t) {
                        var e = t && t.parenthesis ? t.parenthesis : "keep", r = je(this, e, t && t.implicit), n = this.condition.toString(t), i = je(this.condition, e, t && t.implicit);
                        ("all" === e || "OperatorNode" === this.condition.type || null !== i && i <= r) && (n = "(" + n + ")");
                        var o = this.trueExpr.toString(t), a = je(this.trueExpr, e, t && t.implicit);
                        ("all" === e || "OperatorNode" === this.trueExpr.type || null !== a && a <= r) && (o = "(" + o + ")");
                        var s = this.falseExpr.toString(t), u = je(this.falseExpr, e, t && t.implicit);
                        return ("all" === e || "OperatorNode" === this.falseExpr.type || null !== u && u <= r) && (s = "(" + s + ")"), n + " ? " + o + " : " + s;
                    }
                    toJSON() {
                        return {
                            mathjs: "ConditionalNode",
                            condition: this.condition,
                            trueExpr: this.trueExpr,
                            falseExpr: this.falseExpr
                        };
                    }
                    static fromJSON(t) {
                        return new r(t.condition, t.trueExpr, t.falseExpr);
                    }
                    toHTML(t) {
                        var e = t && t.parenthesis ? t.parenthesis : "keep", r = je(this, e, t && t.implicit), n = this.condition.toHTML(t), i = je(this.condition, e, t && t.implicit);
                        ("all" === e || "OperatorNode" === this.condition.type || null !== i && i <= r) && (n = '<span class="math-parenthesis math-round-parenthesis">(</span>' + n + '<span class="math-parenthesis math-round-parenthesis">)</span>');
                        var o = this.trueExpr.toHTML(t), a = je(this.trueExpr, e, t && t.implicit);
                        ("all" === e || "OperatorNode" === this.trueExpr.type || null !== a && a <= r) && (o = '<span class="math-parenthesis math-round-parenthesis">(</span>' + o + '<span class="math-parenthesis math-round-parenthesis">)</span>');
                        var s = this.falseExpr.toHTML(t), u = je(this.falseExpr, e, t && t.implicit);
                        return ("all" === e || "OperatorNode" === this.falseExpr.type || null !== u && u <= r) && (s = '<span class="math-parenthesis math-round-parenthesis">(</span>' + s + '<span class="math-parenthesis math-round-parenthesis">)</span>'), n + '<span class="math-operator math-conditional-operator">?</span>' + o + '<span class="math-operator math-conditional-operator">:</span>' + s;
                    }
                    _toTex(t) {
                        return "\\begin{cases} {" + this.trueExpr.toTex(t) + "}, &\\quad{\\text{if }\\;" + this.condition.toTex(t) + "}\\\\{" + this.falseExpr.toTex(t) + "}, &\\quad{\\text{otherwise}}\\end{cases}";
                    }
                }
                return Fe()(r, "name", "ConditionalNode"), r;
            }, {
                isClass: !0,
                isNode: !0
            }), er = ge("ConstantNode", [
                "Node"
            ], (t)=>{
                var { Node: e } = t;
                class r extends e {
                    constructor(t){
                        super(), this.value = t;
                    }
                    get type() {
                        return "ConstantNode";
                    }
                    get isConstantNode() {
                        return !0;
                    }
                    _compile(t, e) {
                        var r = this.value;
                        return function() {
                            return r;
                        };
                    }
                    forEach(t) {}
                    map(t) {
                        return this.clone();
                    }
                    clone() {
                        return new r(this.value);
                    }
                    _toString(t) {
                        return Lt(this.value, t);
                    }
                    toHTML(t) {
                        var e = this._toString(t);
                        switch(nt(this.value)){
                            case "number":
                            case "BigNumber":
                            case "Fraction":
                                return '<span class="math-number">' + e + "</span>";
                            case "string":
                                return '<span class="math-string">' + e + "</span>";
                            case "boolean":
                                return '<span class="math-boolean">' + e + "</span>";
                            case "null":
                                return '<span class="math-null-symbol">' + e + "</span>";
                            case "undefined":
                                return '<span class="math-undefined">' + e + "</span>";
                            default:
                                return '<span class="math-symbol">' + e + "</span>";
                        }
                    }
                    toJSON() {
                        return {
                            mathjs: "ConstantNode",
                            value: this.value
                        };
                    }
                    static fromJSON(t) {
                        return new r(t.value);
                    }
                    _toTex(t) {
                        var e = this._toString(t);
                        switch(nt(this.value)){
                            case "string":
                                return "\\mathtt{" + Ve(e) + "}";
                            case "number":
                            case "BigNumber":
                                if (!isFinite(this.value)) return this.value.valueOf() < 0 ? "-\\infty" : "\\infty";
                                var r = e.toLowerCase().indexOf("e");
                                return -1 !== r ? e.substring(0, r) + "\\cdot10^{" + e.substring(r + 1) + "}" : e;
                            case "Fraction":
                                return this.value.toLatex();
                            default:
                                return e;
                        }
                    }
                }
                return Fe()(r, "name", "ConstantNode"), r;
            }, {
                isClass: !0,
                isNode: !0
            }), rr = ge("RangeNode", [
                "Node"
            ], (t)=>{
                var { Node: e } = t;
                function r(t, e, r) {
                    var n = je(t, e, r), i = {}, o = je(t.start, e, r);
                    if (i.start = null !== o && o <= n || "all" === e, t.step) {
                        var a = je(t.step, e, r);
                        i.step = null !== a && a <= n || "all" === e;
                    }
                    var s = je(t.end, e, r);
                    return i.end = null !== s && s <= n || "all" === e, i;
                }
                class n extends e {
                    constructor(t, e, r){
                        if (super(), !Y(t)) throw new TypeError("Node expected");
                        if (!Y(e)) throw new TypeError("Node expected");
                        if (r && !Y(r)) throw new TypeError("Node expected");
                        if (arguments.length > 3) throw new Error("Too many arguments");
                        this.start = t, this.end = e, this.step = r || null;
                    }
                    get type() {
                        return "RangeNode";
                    }
                    get isRangeNode() {
                        return !0;
                    }
                    needsEnd() {
                        return this.filter(function(t) {
                            return et(t) && "end" === t.name;
                        }).length > 0;
                    }
                    _compile(t, e) {
                        var r = t.range, n = this.start._compile(t, e), i = this.end._compile(t, e);
                        if (this.step) {
                            var o = this.step._compile(t, e);
                            return function(t, e, a) {
                                return r(n(t, e, a), i(t, e, a), o(t, e, a));
                            };
                        }
                        return function(t, e, o) {
                            return r(n(t, e, o), i(t, e, o));
                        };
                    }
                    forEach(t) {
                        t(this.start, "start", this), t(this.end, "end", this), this.step && t(this.step, "step", this);
                    }
                    map(t) {
                        return new n(this._ifNode(t(this.start, "start", this)), this._ifNode(t(this.end, "end", this)), this.step && this._ifNode(t(this.step, "step", this)));
                    }
                    clone() {
                        return new n(this.start, this.end, this.step && this.step);
                    }
                    _toString(t) {
                        var e, n = r(this, t && t.parenthesis ? t.parenthesis : "keep", t && t.implicit), i = this.start.toString(t);
                        if (n.start && (i = "(" + i + ")"), e = i, this.step) {
                            var o = this.step.toString(t);
                            n.step && (o = "(" + o + ")"), e += ":" + o;
                        }
                        var a = this.end.toString(t);
                        return n.end && (a = "(" + a + ")"), e += ":" + a;
                    }
                    toJSON() {
                        return {
                            mathjs: "RangeNode",
                            start: this.start,
                            end: this.end,
                            step: this.step
                        };
                    }
                    static fromJSON(t) {
                        return new n(t.start, t.end, t.step);
                    }
                    toHTML(t) {
                        var e, n = r(this, t && t.parenthesis ? t.parenthesis : "keep", t && t.implicit), i = this.start.toHTML(t);
                        if (n.start && (i = '<span class="math-parenthesis math-round-parenthesis">(</span>' + i + '<span class="math-parenthesis math-round-parenthesis">)</span>'), e = i, this.step) {
                            var o = this.step.toHTML(t);
                            n.step && (o = '<span class="math-parenthesis math-round-parenthesis">(</span>' + o + '<span class="math-parenthesis math-round-parenthesis">)</span>'), e += '<span class="math-operator math-range-operator">:</span>' + o;
                        }
                        var a = this.end.toHTML(t);
                        return n.end && (a = '<span class="math-parenthesis math-round-parenthesis">(</span>' + a + '<span class="math-parenthesis math-round-parenthesis">)</span>'), e += '<span class="math-operator math-range-operator">:</span>' + a;
                    }
                    _toTex(t) {
                        var e = r(this, t && t.parenthesis ? t.parenthesis : "keep", t && t.implicit), n = this.start.toTex(t);
                        if (e.start && (n = "\\left(".concat(n, "\\right)")), this.step) {
                            var i = this.step.toTex(t);
                            e.step && (i = "\\left(".concat(i, "\\right)")), n += ":" + i;
                        }
                        var o = this.end.toTex(t);
                        return e.end && (o = "\\left(".concat(o, "\\right)")), n += ":" + o;
                    }
                }
                return Fe()(n, "name", "RangeNode"), n;
            }, {
                isClass: !0,
                isNode: !0
            }), nr = ge("reviver", [
                "classes"
            ], (t)=>{
                var { classes: e } = t;
                return function(t, r) {
                    var n = e[r && r.mathjs];
                    return n && "function" == typeof n.fromJSON ? n.fromJSON(r) : r;
                };
            }), ir = ge("Chain", [
                "?on",
                "math",
                "typed"
            ], (t)=>{
                var { on: e, math: r, typed: n } = t;
                function i(t) {
                    if (!(this instanceof i)) throw new SyntaxError("Constructor must be called with the new operator");
                    rt(t) ? this.value = t.value : this.value = t;
                }
                function o(t, e) {
                    var r, n, o, s, u;
                    r = i.prototype, n = t, o = function() {
                        var t = e();
                        if ("function" == typeof t) return a(t);
                    }, u = !0, Object.defineProperty(r, n, {
                        get: function() {
                            return u && (s = o(), u = !1), s;
                        },
                        set: function(t) {
                            s = t, u = !1;
                        },
                        configurable: !0,
                        enumerable: !0
                    });
                }
                function a(t) {
                    return function() {
                        if (0 === arguments.length) return new i(t(this.value));
                        for(var e = [
                            this.value
                        ], r = 0; r < arguments.length; r++)e[r + 1] = arguments[r];
                        if (n.isTypedFunction(t)) {
                            var o = n.resolve(t, e);
                            if (1 === o.params.length) throw new Error("chain function " + t.name + " cannot match rest parameter between chain value and additional arguments.");
                            return new i(o.implementation.apply(t, e));
                        }
                        return new i(t.apply(t, e));
                    };
                }
                i.prototype.type = "Chain", i.prototype.isChain = !0, i.prototype.done = function() {
                    return this.value;
                }, i.prototype.valueOf = function() {
                    return this.value;
                }, i.prototype.toString = function() {
                    return Lt(this.value);
                }, i.prototype.toJSON = function() {
                    return {
                        mathjs: "Chain",
                        value: this.value
                    };
                }, i.fromJSON = function(t) {
                    return new i(t.value);
                }, i.createProxy = function(t, e) {
                    if ("string" == typeof t) u = t, "function" == typeof (l = e) && (i.prototype[u] = a(l));
                    else {
                        var r = function(e) {
                            ut(t, e) && void 0 === s[e] && o(e, ()=>t[e]);
                        };
                        for(var n in t)r(n);
                    }
                    var u, l;
                };
                var s = {
                    expression: !0,
                    docs: !0,
                    type: !0,
                    classes: !0,
                    json: !0,
                    error: !0,
                    isChain: !0
                };
                return i.createProxy(r), e && e("import", function(t, e, r) {
                    r || o(t, e);
                }), i;
            }, {
                isClass: !0
            }), or = ge("FunctionAssignmentNode", [
                "typed",
                "Node"
            ], (t)=>{
                var { typed: e, Node: r } = t;
                function n(t, e, r) {
                    var n = je(t, e, r), i = je(t.expr, e, r);
                    return "all" === e || null !== i && i <= n;
                }
                class i extends r {
                    constructor(t, e, r){
                        if (super(), "string" != typeof t) throw new TypeError('String expected for parameter "name"');
                        if (!Array.isArray(e)) throw new TypeError('Array containing strings or objects expected for parameter "params"');
                        if (!Y(r)) throw new TypeError('Node expected for parameter "expr"');
                        if (ht.has(t)) throw new Error('Illegal function name, "' + t + '" is a reserved keyword');
                        var n = new Set;
                        for (var i of e){
                            var o = "string" == typeof i ? i : i.name;
                            if (n.has(o)) throw new Error('Duplicate parameter name "'.concat(o, '"'));
                            n.add(o);
                        }
                        this.name = t, this.params = e.map(function(t) {
                            return t && t.name || t;
                        }), this.types = e.map(function(t) {
                            return t && t.type || "any";
                        }), this.expr = r;
                    }
                    get type() {
                        return "FunctionAssignmentNode";
                    }
                    get isFunctionAssignmentNode() {
                        return !0;
                    }
                    _compile(t, r) {
                        var n = Object.create(r);
                        oe(this.params, function(t) {
                            n[t] = !0;
                        });
                        var i = this.expr._compile(t, n), o = this.name, a = this.params, s = ue(this.types, ","), u = o + "(" + ue(this.params, ", ") + ")";
                        return function(t, r, n) {
                            var l = {};
                            l[s] = function() {
                                for(var e = Object.create(r), o = 0; o < a.length; o++)e[a[o]] = arguments[o];
                                return i(t, e, n);
                            };
                            var c = e(o, l);
                            return c.syntax = u, t.set(o, c), c;
                        };
                    }
                    forEach(t) {
                        t(this.expr, "expr", this);
                    }
                    map(t) {
                        var e = this._ifNode(t(this.expr, "expr", this));
                        return new i(this.name, this.params.slice(0), e);
                    }
                    clone() {
                        return new i(this.name, this.params.slice(0), this.expr);
                    }
                    _toString(t) {
                        var e = t && t.parenthesis ? t.parenthesis : "keep", r = this.expr.toString(t);
                        return n(this, e, t && t.implicit) && (r = "(" + r + ")"), this.name + "(" + this.params.join(", ") + ") = " + r;
                    }
                    toJSON() {
                        var t = this.types;
                        return {
                            mathjs: "FunctionAssignmentNode",
                            name: this.name,
                            params: this.params.map(function(e, r) {
                                return {
                                    name: e,
                                    type: t[r]
                                };
                            }),
                            expr: this.expr
                        };
                    }
                    static fromJSON(t) {
                        return new i(t.name, t.params, t.expr);
                    }
                    toHTML(t) {
                        for(var e = t && t.parenthesis ? t.parenthesis : "keep", r = [], i = 0; i < this.params.length; i++)r.push('<span class="math-symbol math-parameter">' + zt(this.params[i]) + "</span>");
                        var o = this.expr.toHTML(t);
                        return n(this, e, t && t.implicit) && (o = '<span class="math-parenthesis math-round-parenthesis">(</span>' + o + '<span class="math-parenthesis math-round-parenthesis">)</span>'), '<span class="math-function">' + zt(this.name) + '</span><span class="math-parenthesis math-round-parenthesis">(</span>' + r.join('<span class="math-separator">,</span>') + '<span class="math-parenthesis math-round-parenthesis">)</span><span class="math-operator math-assignment-operator math-variable-assignment-operator math-binary-operator">=</span>' + o;
                    }
                    _toTex(t) {
                        var e = t && t.parenthesis ? t.parenthesis : "keep", r = this.expr.toTex(t);
                        return n(this, e, t && t.implicit) && (r = "\\left(".concat(r, "\\right)")), "\\mathrm{" + this.name + "}\\left(" + this.params.map(Ze).join(",") + "\\right):=" + r;
                    }
                }
                return Fe()(i, "name", "FunctionAssignmentNode"), i;
            }, {
                isClass: !0,
                isNode: !0
            }), ar = ge("chain", [
                "typed",
                "Chain"
            ], (t)=>{
                var { typed: e, Chain: r } = t;
                return e("chain", {
                    "": function() {
                        return new r;
                    },
                    any: function(t) {
                        return new r(t);
                    }
                });
            }), sr = ge("IndexNode", [
                "Node",
                "size"
            ], (t)=>{
                var { Node: e, size: r } = t;
                class n extends e {
                    constructor(t, e){
                        if (super(), this.dimensions = t, this.dotNotation = e || !1, !Array.isArray(t) || !t.every(Y)) throw new TypeError('Array containing Nodes expected for parameter "dimensions"');
                        if (this.dotNotation && !this.isObjectProperty()) throw new Error("dotNotation only applicable for object properties");
                    }
                    get type() {
                        return "IndexNode";
                    }
                    get isIndexNode() {
                        return !0;
                    }
                    _compile(t, e) {
                        var n = ie(this.dimensions, function(n, i) {
                            if (n.filter((t)=>t.isSymbolNode && "end" === t.name).length > 0) {
                                var o = Object.create(e);
                                o.end = !0;
                                var a = n._compile(t, o);
                                return function(t, e, n) {
                                    if (!E(n) && !A(n) && !_(n)) throw new TypeError('Cannot resolve "end": context must be a Matrix, Array, or string but is ' + nt(n));
                                    var o = r(n).valueOf(), s = Object.create(e);
                                    return s.end = o[i], a(t, s, n);
                                };
                            }
                            return n._compile(t, e);
                        }), i = be(t, "index");
                        return function(t, e, r) {
                            var o = ie(n, function(n) {
                                return n(t, e, r);
                            });
                            return i(...o);
                        };
                    }
                    forEach(t) {
                        for(var e = 0; e < this.dimensions.length; e++)t(this.dimensions[e], "dimensions[" + e + "]", this);
                    }
                    map(t) {
                        for(var e = [], r = 0; r < this.dimensions.length; r++)e[r] = this._ifNode(t(this.dimensions[r], "dimensions[" + r + "]", this));
                        return new n(e, this.dotNotation);
                    }
                    clone() {
                        return new n(this.dimensions.slice(0), this.dotNotation);
                    }
                    isObjectProperty() {
                        return 1 === this.dimensions.length && H(this.dimensions[0]) && "string" == typeof this.dimensions[0].value;
                    }
                    getObjectProperty() {
                        return this.isObjectProperty() ? this.dimensions[0].value : null;
                    }
                    _toString(t) {
                        return this.dotNotation ? "." + this.getObjectProperty() : "[" + this.dimensions.join(", ") + "]";
                    }
                    toJSON() {
                        return {
                            mathjs: "IndexNode",
                            dimensions: this.dimensions,
                            dotNotation: this.dotNotation
                        };
                    }
                    static fromJSON(t) {
                        return new n(t.dimensions, t.dotNotation);
                    }
                    toHTML(t) {
                        for(var e = [], r = 0; r < this.dimensions.length; r++)e[r] = this.dimensions[r].toHTML();
                        return this.dotNotation ? '<span class="math-operator math-accessor-operator">.</span><span class="math-symbol math-property">' + zt(this.getObjectProperty()) + "</span>" : '<span class="math-parenthesis math-square-parenthesis">[</span>' + e.join('<span class="math-separator">,</span>') + '<span class="math-parenthesis math-square-parenthesis">]</span>';
                    }
                    _toTex(t) {
                        var e = this.dimensions.map(function(e) {
                            return e.toTex(t);
                        });
                        return this.dotNotation ? "." + this.getObjectProperty() : "_{" + e.join(",") + "}";
                    }
                }
                return Fe()(n, "name", "IndexNode"), n;
            }, {
                isClass: !0,
                isNode: !0
            });
            function ur(t) {
                return t && t.isIndexError ? new Wt(t.index + 1, t.min + 1, void 0 !== t.max ? t.max + 1 : void 0) : t;
            }
            function lr(t) {
                var { subset: e } = t;
                return function(t, r) {
                    try {
                        if (Array.isArray(t)) return e(t, r);
                        if (t && "function" == typeof t.subset) return t.subset(r);
                        if ("string" == typeof t) return e(t, r);
                        if ("object" == typeof t) {
                            if (!r.isObjectProperty()) throw new TypeError("Cannot apply a numeric index as object property");
                            return be(t, r.getObjectProperty());
                        }
                        throw new TypeError("Cannot apply index: unsupported type of object");
                    } catch (t) {
                        throw ur(t);
                    }
                };
            }
            var cr = ge("AccessorNode", [
                "subset",
                "Node"
            ], (t)=>{
                var { subset: e, Node: r } = t, n = lr({
                    subset: e
                });
                function i(t) {
                    return !(L(t) || q(t) || H(t) || V(t) || K(t) || J(t) || et(t));
                }
                class o extends r {
                    constructor(t, e){
                        if (super(), !Y(t)) throw new TypeError('Node expected for parameter "object"');
                        if (!Z(e)) throw new TypeError('IndexNode expected for parameter "index"');
                        this.object = t, this.index = e;
                    }
                    get name() {
                        return this.index ? this.index.isObjectProperty() ? this.index.getObjectProperty() : "" : this.object.name || "";
                    }
                    get type() {
                        return "AccessorNode";
                    }
                    get isAccessorNode() {
                        return !0;
                    }
                    _compile(t, e) {
                        var r = this.object._compile(t, e), i = this.index._compile(t, e);
                        if (this.index.isObjectProperty()) {
                            var o = this.index.getObjectProperty();
                            return function(t, e, n) {
                                return be(r(t, e, n), o);
                            };
                        }
                        return function(t, e, o) {
                            var a = r(t, e, o), s = i(t, e, a);
                            return n(a, s);
                        };
                    }
                    forEach(t) {
                        t(this.object, "object", this), t(this.index, "index", this);
                    }
                    map(t) {
                        return new o(this._ifNode(t(this.object, "object", this)), this._ifNode(t(this.index, "index", this)));
                    }
                    clone() {
                        return new o(this.object, this.index);
                    }
                    _toString(t) {
                        var e = this.object.toString(t);
                        return i(this.object) && (e = "(" + e + ")"), e + this.index.toString(t);
                    }
                    toHTML(t) {
                        var e = this.object.toHTML(t);
                        return i(this.object) && (e = '<span class="math-parenthesis math-round-parenthesis">(</span>' + e + '<span class="math-parenthesis math-round-parenthesis">)</span>'), e + this.index.toHTML(t);
                    }
                    _toTex(t) {
                        var e = this.object.toTex(t);
                        return i(this.object) && (e = "\\left(' + object + '\\right)"), e + this.index.toTex(t);
                    }
                    toJSON() {
                        return {
                            mathjs: "AccessorNode",
                            object: this.object,
                            index: this.index
                        };
                    }
                    static fromJSON(t) {
                        return new o(t.object, t.index);
                    }
                }
                return Fe()(o, "name", "AccessorNode"), o;
            }, {
                isClass: !0,
                isNode: !0
            });
            var fr = ge("AssignmentNode", [
                "subset",
                "?matrix",
                "Node"
            ], (t)=>{
                var { subset: e, matrix: r, Node: n } = t, i = lr({
                    subset: e
                }), o = function(t) {
                    var { subset: e, matrix: r } = t;
                    return function(t, n, i) {
                        try {
                            if (Array.isArray(t)) return r(t).subset(n, i).valueOf().forEach((e, r)=>{
                                t[r] = e;
                            }), t;
                            if (t && "function" == typeof t.subset) return t.subset(n, i);
                            if ("string" == typeof t) return e(t, n, i);
                            if ("object" == typeof t) {
                                if (!n.isObjectProperty()) throw TypeError("Cannot apply a numeric index as object property");
                                return xe(t, n.getObjectProperty(), i), t;
                            }
                            throw new TypeError("Cannot apply index: unsupported type of object");
                        } catch (t) {
                            throw ur(t);
                        }
                    };
                }({
                    subset: e,
                    matrix: r
                });
                function a(t, e, r) {
                    e || (e = "keep");
                    var n = je(t, e, r), i = je(t.value, e, r);
                    return "all" === e || null !== i && i <= n;
                }
                class s extends n {
                    constructor(t, e, r){
                        if (super(), this.object = t, this.index = r ? e : null, this.value = r || e, !et(t) && !L(t)) throw new TypeError('SymbolNode or AccessorNode expected as "object"');
                        if (et(t) && "end" === t.name) throw new Error('Cannot assign to symbol "end"');
                        if (this.index && !Z(this.index)) throw new TypeError('IndexNode expected as "index"');
                        if (!Y(this.value)) throw new TypeError('Node expected as "value"');
                    }
                    get name() {
                        return this.index ? this.index.isObjectProperty() ? this.index.getObjectProperty() : "" : this.object.name || "";
                    }
                    get type() {
                        return "AssignmentNode";
                    }
                    get isAssignmentNode() {
                        return !0;
                    }
                    _compile(t, e) {
                        var r = this.object._compile(t, e), n = this.index ? this.index._compile(t, e) : null, a = this.value._compile(t, e), s = this.object.name;
                        if (this.index) {
                            if (this.index.isObjectProperty()) {
                                var u = this.index.getObjectProperty();
                                return function(t, e, n) {
                                    var i = r(t, e, n), o = a(t, e, n);
                                    return xe(i, u, o), o;
                                };
                            }
                            if (et(this.object)) return function(t, e, i) {
                                var u = r(t, e, i), l = a(t, e, i), c = n(t, e, u);
                                return t.set(s, o(u, c, l)), l;
                            };
                            var l = this.object.object._compile(t, e);
                            if (this.object.index.isObjectProperty()) {
                                var c = this.object.index.getObjectProperty();
                                return function(t, e, r) {
                                    var i = l(t, e, r), s = be(i, c), u = n(t, e, s), f = a(t, e, r);
                                    return xe(i, c, o(s, u, f)), f;
                                };
                            }
                            var f = this.object.index._compile(t, e);
                            return function(t, e, r) {
                                var s = l(t, e, r), u = f(t, e, s), c = i(s, u), h = n(t, e, c), p = a(t, e, r);
                                return o(s, u, o(c, h, p)), p;
                            };
                        }
                        if (!et(this.object)) throw new TypeError("SymbolNode expected as object");
                        return function(t, e, r) {
                            var n = a(t, e, r);
                            return t.set(s, n), n;
                        };
                    }
                    forEach(t) {
                        t(this.object, "object", this), this.index && t(this.index, "index", this), t(this.value, "value", this);
                    }
                    map(t) {
                        var e = this._ifNode(t(this.object, "object", this)), r = this.index ? this._ifNode(t(this.index, "index", this)) : null, n = this._ifNode(t(this.value, "value", this));
                        return new s(e, r, n);
                    }
                    clone() {
                        return new s(this.object, this.index, this.value);
                    }
                    _toString(t) {
                        var e = this.object.toString(t), r = this.index ? this.index.toString(t) : "", n = this.value.toString(t);
                        return a(this, t && t.parenthesis, t && t.implicit) && (n = "(" + n + ")"), e + r + " = " + n;
                    }
                    toJSON() {
                        return {
                            mathjs: "AssignmentNode",
                            object: this.object,
                            index: this.index,
                            value: this.value
                        };
                    }
                    static fromJSON(t) {
                        return new s(t.object, t.index, t.value);
                    }
                    toHTML(t) {
                        var e = this.object.toHTML(t), r = this.index ? this.index.toHTML(t) : "", n = this.value.toHTML(t);
                        return a(this, t && t.parenthesis, t && t.implicit) && (n = '<span class="math-paranthesis math-round-parenthesis">(</span>' + n + '<span class="math-paranthesis math-round-parenthesis">)</span>'), e + r + '<span class="math-operator math-assignment-operator math-variable-assignment-operator math-binary-operator">=</span>' + n;
                    }
                    _toTex(t) {
                        var e = this.object.toTex(t), r = this.index ? this.index.toTex(t) : "", n = this.value.toTex(t);
                        return a(this, t && t.parenthesis, t && t.implicit) && (n = "\\left(".concat(n, "\\right)")), e + r + ":=" + n;
                    }
                }
                return Fe()(s, "name", "AssignmentNode"), s;
            }, {
                isClass: !0,
                isNode: !0
            }), hr = ge("SymbolNode", [
                "math",
                "?Unit",
                "Node"
            ], (t)=>{
                var { math: e, Unit: r, Node: n } = t;
                function i(t) {
                    return !!r && r.isValuelessUnit(t);
                }
                class o extends n {
                    constructor(t){
                        if (super(), "string" != typeof t) throw new TypeError('String expected for parameter "name"');
                        this.name = t;
                    }
                    get type() {
                        return "SymbolNode";
                    }
                    get isSymbolNode() {
                        return !0;
                    }
                    _compile(t, e) {
                        var n = this.name;
                        if (!0 === e[n]) return function(t, e, r) {
                            return be(e, n);
                        };
                        if (n in t) return function(e, r, i) {
                            return e.has(n) ? e.get(n) : be(t, n);
                        };
                        var a = i(n);
                        return function(t, e, i) {
                            return t.has(n) ? t.get(n) : a ? new r(null, n) : o.onUndefinedSymbol(n);
                        };
                    }
                    forEach(t) {}
                    map(t) {
                        return this.clone();
                    }
                    static onUndefinedSymbol(t) {
                        throw new Error("Undefined symbol " + t);
                    }
                    clone() {
                        return new o(this.name);
                    }
                    _toString(t) {
                        return this.name;
                    }
                    toHTML(t) {
                        var e = zt(this.name);
                        return "true" === e || "false" === e ? '<span class="math-symbol math-boolean">' + e + "</span>" : "i" === e ? '<span class="math-symbol math-imaginary-symbol">' + e + "</span>" : "Infinity" === e ? '<span class="math-symbol math-infinity-symbol">' + e + "</span>" : "NaN" === e ? '<span class="math-symbol math-nan-symbol">' + e + "</span>" : "null" === e ? '<span class="math-symbol math-null-symbol">' + e + "</span>" : "undefined" === e ? '<span class="math-symbol math-undefined-symbol">' + e + "</span>" : '<span class="math-symbol">' + e + "</span>";
                    }
                    toJSON() {
                        return {
                            mathjs: "SymbolNode",
                            name: this.name
                        };
                    }
                    static fromJSON(t) {
                        return new o(t.name);
                    }
                    _toTex(t) {
                        var r = !1;
                        void 0 === e[this.name] && i(this.name) && (r = !0);
                        var n = Ze(this.name, r);
                        return "\\" === n[0] ? n : " " + n;
                    }
                }
                return o;
            }, {
                isClass: !0,
                isNode: !0
            });
            function pr(t) {
                for(var e = arguments.length, r = new Array(e > 1 ? e - 1 : 0), n = 1; n < e; n++)r[n - 1] = arguments[n];
                return "function" == typeof t.createSubScope ? De(t.createSubScope(), ...r) : De(ke(), t, ...r);
            }
            var dr = ge("FunctionNode", [
                "math",
                "Node",
                "SymbolNode"
            ], (t)=>{
                var e, { math: r, Node: n, SymbolNode: i } = t, o = (t)=>Lt(t, {
                        truncate: 78
                    });
                function a(t, e, r) {
                    for(var n, i = "", o = /\$(?:\{([a-z_][a-z_0-9]*)(?:\[([0-9]+)\])?\}|\$)/gi, a = 0; null !== (n = o.exec(t));)if (i += t.substring(a, n.index), a = n.index, "$$" === n[0]) i += "$", a++;
                    else {
                        a += n[0].length;
                        var s = e[n[1]];
                        if (!s) throw new ReferenceError("Template: Property " + n[1] + " does not exist.");
                        if (void 0 === n[2]) switch(typeof s){
                            case "string":
                                i += s;
                                break;
                            case "object":
                                if (Y(s)) i += s.toTex(r);
                                else {
                                    if (!Array.isArray(s)) throw new TypeError("Template: " + n[1] + " has to be a Node, String or array of Nodes");
                                    i += s.map(function(t, e) {
                                        if (Y(t)) return t.toTex(r);
                                        throw new TypeError("Template: " + n[1] + "[" + e + "] is not a Node.");
                                    }).join(",");
                                }
                                break;
                            default:
                                throw new TypeError("Template: " + n[1] + " has to be a Node, String or array of Nodes");
                        }
                        else {
                            if (!Y(s[n[2]] && s[n[2]])) throw new TypeError("Template: " + n[1] + "[" + n[2] + "] is not a Node.");
                            i += s[n[2]].toTex(r);
                        }
                    }
                    return i += t.slice(a);
                }
                class s extends n {
                    constructor(t, e){
                        if (super(), "string" == typeof t && (t = new i(t)), !Y(t)) throw new TypeError('Node expected as parameter "fn"');
                        if (!Array.isArray(e) || !e.every(Y)) throw new TypeError('Array containing Nodes expected for parameter "args"');
                        this.fn = t, this.args = e || [];
                    }
                    get name() {
                        return this.fn.name || "";
                    }
                    get type() {
                        return "FunctionNode";
                    }
                    get isFunctionNode() {
                        return !0;
                    }
                    _compile(t, e) {
                        var r = this.args.map((r)=>r._compile(t, e));
                        if (!et(this.fn)) {
                            if (L(this.fn) && Z(this.fn.index) && this.fn.index.isObjectProperty()) {
                                var n = this.fn.object._compile(t, e), i = this.fn.index.getObjectProperty(), a = this.args;
                                return function(e, o, s) {
                                    var u = n(e, o, s), l = function(t, e) {
                                        if (!_e(t, e)) throw new Error('No access to method "' + e + '"');
                                        return t[e];
                                    }(u, i);
                                    if (null != l && l.rawArgs) return l(a, t, pr(e, o), e);
                                    var c = r.map((t)=>t(e, o, s));
                                    return l.apply(u, c);
                                };
                            }
                            var u = this.fn.toString(), l = this.fn._compile(t, e), c = this.args;
                            return function(e, n, i) {
                                var a = l(e, n, i);
                                if ("function" != typeof a) throw new TypeError("Expression '".concat(u, "' did not evaluate to a function; value is:") + "\n  ".concat(o(a)));
                                if (a.rawArgs) return a(c, t, pr(e, n), e);
                                var s = r.map((t)=>t(e, n, i));
                                return a.apply(a, s);
                            };
                        }
                        var f = this.fn.name;
                        if (e[f]) {
                            var h = this.args;
                            return function(e, n, i) {
                                var a = be(n, f);
                                if ("function" != typeof a) throw new TypeError("Argument '".concat(f, "' was not a function; received: ").concat(o(a)));
                                if (a.rawArgs) return a(h, t, pr(e, n), e);
                                var s = r.map((t)=>t(e, n, i));
                                return a.apply(a, s);
                            };
                        }
                        var p = f in t ? be(t, f) : void 0, d = "function" == typeof p && !0 === p.rawArgs, m = (e)=>{
                            var r;
                            if (e.has(f)) r = e.get(f);
                            else {
                                if (!(f in t)) return s.onUndefinedFunction(f);
                                r = be(t, f);
                            }
                            if ("function" == typeof r) return r;
                            throw new TypeError("'".concat(f, "' is not a function; its value is:\n  ").concat(o(r)));
                        };
                        if (d) {
                            var y = this.args;
                            return function(e, r, n) {
                                return m(e)(y, t, pr(e, r), e);
                            };
                        }
                        switch(r.length){
                            case 0:
                                return function(t, e, r) {
                                    return m(t)();
                                };
                            case 1:
                                return function(t, e, n) {
                                    return m(t)((0, r[0])(t, e, n));
                                };
                            case 2:
                                return function(t, e, n) {
                                    var i = m(t), o = r[0], a = r[1];
                                    return i(o(t, e, n), a(t, e, n));
                                };
                            default:
                                return function(t, e, n) {
                                    return m(t)(...r.map((r)=>r(t, e, n)));
                                };
                        }
                    }
                    forEach(t) {
                        t(this.fn, "fn", this);
                        for(var e = 0; e < this.args.length; e++)t(this.args[e], "args[" + e + "]", this);
                    }
                    map(t) {
                        for(var e = this._ifNode(t(this.fn, "fn", this)), r = [], n = 0; n < this.args.length; n++)r[n] = this._ifNode(t(this.args[n], "args[" + n + "]", this));
                        return new s(e, r);
                    }
                    clone() {
                        return new s(this.fn, this.args.slice(0));
                    }
                    toString(t) {
                        var e, r = this.fn.toString(t);
                        return t && "object" == typeof t.handler && ut(t.handler, r) && (e = t.handler[r](this, t)), void 0 !== e ? e : super.toString(t);
                    }
                    _toString(t) {
                        var e = this.args.map(function(e) {
                            return e.toString(t);
                        });
                        return ($(this.fn) ? "(" + this.fn.toString(t) + ")" : this.fn.toString(t)) + "(" + e.join(", ") + ")";
                    }
                    toJSON() {
                        return {
                            mathjs: "FunctionNode",
                            fn: this.fn,
                            args: this.args
                        };
                    }
                    toHTML(t) {
                        var e = this.args.map(function(e) {
                            return e.toHTML(t);
                        });
                        return '<span class="math-function">' + zt(this.fn) + '</span><span class="math-paranthesis math-round-parenthesis">(</span>' + e.join('<span class="math-separator">,</span>') + '<span class="math-paranthesis math-round-parenthesis">)</span>';
                    }
                    toTex(t) {
                        var e;
                        return t && "object" == typeof t.handler && ut(t.handler, this.name) && (e = t.handler[this.name](this, t)), void 0 !== e ? e : super.toTex(t);
                    }
                    _toTex(t) {
                        var e, n, i = this.args.map(function(e) {
                            return e.toTex(t);
                        });
                        switch(We[this.name] && (e = We[this.name]), !r[this.name] || "function" != typeof r[this.name].toTex && "object" != typeof r[this.name].toTex && "string" != typeof r[this.name].toTex || (e = r[this.name].toTex), typeof e){
                            case "function":
                                n = e(this, t);
                                break;
                            case "string":
                                n = a(e, this, t);
                                break;
                            case "object":
                                switch(typeof e[i.length]){
                                    case "function":
                                        n = e[i.length](this, t);
                                        break;
                                    case "string":
                                        n = a(e[i.length], this, t);
                                }
                        }
                        return void 0 !== n ? n : a("\\mathrm{${name}}\\left(${args}\\right)", this, t);
                    }
                    getIdentifier() {
                        return this.type + ":" + this.name;
                    }
                }
                return e = s, Fe()(s, "name", "FunctionNode"), Fe()(s, "onUndefinedFunction", function(t) {
                    throw new Error("Undefined function " + t);
                }), Fe()(s, "fromJSON", function(t) {
                    return new e(t.fn, t.args);
                }), s;
            }, {
                isClass: !0,
                isNode: !0
            });
            function mr(t) {
                var e, r, n = t.length, i = t[0].length, o = [];
                for(r = 0; r < i; r++){
                    var a = [];
                    for(e = 0; e < n; e++)a.push(t[e][r]);
                    o.push(a);
                }
                return o;
            }
            function yr(t) {
                for(var e = 0; e < t.length; e++)if (S(t[e])) return !0;
                return !1;
            }
            function gr(t, e) {
                E(t) && (t = t.valueOf());
                for(var r = 0, n = t.length; r < n; r++){
                    var i = t[r];
                    Array.isArray(i) ? gr(i, e) : e(i);
                }
            }
            function vr(t, e, r) {
                return t && "function" == typeof t.map ? t.map(function(t) {
                    return vr(t, e, r);
                }) : e(t);
            }
            function br(t, e, r) {
                var n = Array.isArray(t) ? $t(t) : t.size();
                if (e < 0 || e >= n.length) throw new Wt(e, n.length);
                return E(t) ? t.create(xr(t.valueOf(), e, r)) : xr(t, e, r);
            }
            function xr(t, e, r) {
                var n, i, o, a;
                if (e <= 0) {
                    if (Array.isArray(t[0])) {
                        for(a = mr(t), i = [], n = 0; n < a.length; n++)i[n] = xr(a[n], e - 1, r);
                        return i;
                    }
                    for(o = t[0], n = 1; n < t.length; n++)o = r(o, t[n]);
                    return o;
                }
                for(i = [], n = 0; n < t.length; n++)i[n] = xr(t[n], e - 1, r);
                return i;
            }
            function wr(t, e, r, n, i, o, a, s, u, l, c) {
                var f, h, p, d, m = t._values, y = t._index, g = t._ptr;
                if (n) for(h = g[e], p = g[e + 1], f = h; f < p; f++)r[d = y[f]] !== o ? (r[d] = o, a.push(d), l ? (n[d] = u ? s(m[f], c) : s(c, m[f]), i[d] = o) : n[d] = m[f]) : (n[d] = u ? s(m[f], n[d]) : s(n[d], m[f]), i[d] = o);
                else for(h = g[e], p = g[e + 1], f = h; f < p; f++)r[d = y[f]] !== o ? (r[d] = o, a.push(d)) : i[d] = o;
            }
            var _r = ge("parse", [
                "typed",
                "numeric",
                "config",
                "AccessorNode",
                "ArrayNode",
                "AssignmentNode",
                "BlockNode",
                "ConditionalNode",
                "ConstantNode",
                "FunctionAssignmentNode",
                "FunctionNode",
                "IndexNode",
                "ObjectNode",
                "OperatorNode",
                "ParenthesisNode",
                "RangeNode",
                "RelationalNode",
                "SymbolNode"
            ], (t)=>{
                var { typed: e, numeric: r, config: n, AccessorNode: i, ArrayNode: o, AssignmentNode: a, BlockNode: s, ConditionalNode: u, ConstantNode: l, FunctionAssignmentNode: c, FunctionNode: f, IndexNode: h, ObjectNode: p, OperatorNode: d, ParenthesisNode: y, RangeNode: g, RelationalNode: v, SymbolNode: b } = t, x = e("parse", {
                    string: function(t) {
                        return z(t, {});
                    },
                    "Array | Matrix": function(t) {
                        return w(t, {});
                    },
                    "string, Object": function(t, e) {
                        return z(t, void 0 !== e.nodes ? e.nodes : {});
                    },
                    "Array | Matrix, Object": w
                });
                function w(t) {
                    var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = void 0 !== e.nodes ? e.nodes : {};
                    return vr(t, function(t) {
                        if ("string" != typeof t) throw new TypeError("String expected");
                        return z(t, r);
                    });
                }
                var _ = 0, A = 1, E = 2, S = 3, M = 4, k = {
                    ",": !0,
                    "(": !0,
                    ")": !0,
                    "[": !0,
                    "]": !0,
                    "{": !0,
                    "}": !0,
                    '"': !0,
                    "'": !0,
                    ";": !0,
                    "+": !0,
                    "-": !0,
                    "*": !0,
                    ".*": !0,
                    "/": !0,
                    "./": !0,
                    "%": !0,
                    "^": !0,
                    ".^": !0,
                    "~": !0,
                    "!": !0,
                    "&": !0,
                    "|": !0,
                    "^|": !0,
                    "=": !0,
                    ":": !0,
                    "?": !0,
                    "==": !0,
                    "!=": !0,
                    "<": !0,
                    ">": !0,
                    "<=": !0,
                    ">=": !0,
                    "<<": !0,
                    ">>": !0,
                    ">>>": !0
                }, N = {
                    mod: !0,
                    to: !0,
                    in: !0,
                    and: !0,
                    xor: !0,
                    or: !0,
                    not: !0
                }, C = {
                    true: !0,
                    false: !1,
                    null: null,
                    undefined: void 0
                }, D = [
                    "NaN",
                    "Infinity"
                ], O = {
                    '"': '"',
                    "'": "'",
                    "\\": "\\",
                    "/": "/",
                    b: "\b",
                    f: "\f",
                    n: "\n",
                    r: "\r",
                    t: "	"
                };
                function T(t, e) {
                    return t.expression.substr(t.index, e);
                }
                function F(t) {
                    return T(t, 1);
                }
                function P(t) {
                    t.index++;
                }
                function I(t) {
                    return t.expression.charAt(t.index - 1);
                }
                function B(t) {
                    return t.expression.charAt(t.index + 1);
                }
                function j(t) {
                    for(t.tokenType = _, t.token = "", t.comment = "";;){
                        if ("#" === F(t)) for(; "\n" !== F(t) && "" !== F(t);)t.comment += F(t), P(t);
                        if (!x.isWhitespace(F(t), t.nestingLevel)) break;
                        P(t);
                    }
                    if ("" !== F(t)) {
                        if ("\n" === F(t) && !t.nestingLevel) return t.tokenType = A, t.token = F(t), void P(t);
                        var e = F(t), r = T(t, 2), n = T(t, 3);
                        if (3 === n.length && k[n]) return t.tokenType = A, t.token = n, P(t), P(t), void P(t);
                        if (2 === r.length && k[r]) return t.tokenType = A, t.token = r, P(t), void P(t);
                        if (k[e]) return t.tokenType = A, t.token = e, void P(t);
                        if (x.isDigitDot(e)) {
                            t.tokenType = E;
                            var i = T(t, 2);
                            if ("0b" === i || "0o" === i || "0x" === i) {
                                for(t.token += F(t), P(t), t.token += F(t), P(t); x.isHexDigit(F(t));)t.token += F(t), P(t);
                                if ("." === F(t)) for(t.token += ".", P(t); x.isHexDigit(F(t));)t.token += F(t), P(t);
                                else if ("i" === F(t)) for(t.token += "i", P(t); x.isDigit(F(t));)t.token += F(t), P(t);
                                return;
                            }
                            if ("." === F(t)) {
                                if (t.token += F(t), P(t), !x.isDigit(F(t))) return void (t.tokenType = A);
                            } else {
                                for(; x.isDigit(F(t));)t.token += F(t), P(t);
                                x.isDecimalMark(F(t), B(t)) && (t.token += F(t), P(t));
                            }
                            for(; x.isDigit(F(t));)t.token += F(t), P(t);
                            if ("E" === F(t) || "e" === F(t)) {
                                if (x.isDigit(B(t)) || "-" === B(t) || "+" === B(t)) {
                                    if (t.token += F(t), P(t), "+" !== F(t) && "-" !== F(t) || (t.token += F(t), P(t)), !x.isDigit(F(t))) throw mt(t, 'Digit expected, got "' + F(t) + '"');
                                    for(; x.isDigit(F(t));)t.token += F(t), P(t);
                                    if (x.isDecimalMark(F(t), B(t))) throw mt(t, 'Digit expected, got "' + F(t) + '"');
                                } else if ("." === B(t)) throw P(t), mt(t, 'Digit expected, got "' + F(t) + '"');
                            }
                        } else {
                            if (!x.isAlpha(F(t), I(t), B(t))) {
                                for(t.tokenType = M; "" !== F(t);)t.token += F(t), P(t);
                                throw mt(t, 'Syntax error in part "' + t.token + '"');
                            }
                            for(; x.isAlpha(F(t), I(t), B(t)) || x.isDigit(F(t));)t.token += F(t), P(t);
                            ut(N, t.token) ? t.tokenType = A : t.tokenType = S;
                        }
                    } else t.tokenType = A;
                }
                function R(t) {
                    do j(t);
                    while ("\n" === t.token);
                }
                function q(t) {
                    t.nestingLevel++;
                }
                function U(t) {
                    t.nestingLevel--;
                }
                function z(t, e) {
                    var r = {
                        extraNodes: {},
                        expression: "",
                        comment: "",
                        index: 0,
                        token: "",
                        tokenType: _,
                        nestingLevel: 0,
                        conditionalLevel: null
                    };
                    m()(r, {
                        expression: t,
                        extraNodes: e
                    }), j(r);
                    var n = function(t) {
                        var e, r, n = [];
                        "" !== t.token && "\n" !== t.token && ";" !== t.token && (e = G(t), t.comment && (e.comment = t.comment));
                        for(; "\n" === t.token || ";" === t.token;)0 === n.length && e && (r = ";" !== t.token, n.push({
                            node: e,
                            visible: r
                        })), j(t), "\n" !== t.token && ";" !== t.token && "" !== t.token && (e = G(t), t.comment && (e.comment = t.comment), r = ";" !== t.token, n.push({
                            node: e,
                            visible: r
                        }));
                        return n.length > 0 ? new s(n) : (e || (e = new l(void 0), t.comment && (e.comment = t.comment)), e);
                    }(r);
                    if ("" !== r.token) throw r.tokenType === A ? yt(r, "Unexpected operator " + r.token) : mt(r, 'Unexpected part "' + r.token + '"');
                    return n;
                }
                function G(t) {
                    var e, r, n, i, o = function(t) {
                        var e = function(t) {
                            var e = $(t);
                            for(; "or" === t.token;)R(t), e = new d("or", "or", [
                                e,
                                $(t)
                            ]);
                            return e;
                        }(t);
                        for(; "?" === t.token;){
                            var r = t.conditionalLevel;
                            t.conditionalLevel = t.nestingLevel, R(t);
                            var n = e, i = G(t);
                            if (":" !== t.token) throw mt(t, "False part of conditional expression expected");
                            t.conditionalLevel = null, R(t);
                            var o = G(t);
                            e = new u(n, i, o), t.conditionalLevel = r;
                        }
                        return e;
                    }(t);
                    if ("=" === t.token) {
                        if (et(o)) return e = o.name, R(t), n = G(t), new a(new b(e), n);
                        if (L(o)) return R(t), n = G(t), new a(o.object, o.index, n);
                        if (V(o) && et(o.fn) && (i = !0, r = [], e = o.name, o.args.forEach(function(t, e) {
                            et(t) ? r[e] = t.name : i = !1;
                        }), i)) return R(t), n = G(t), new c(e, r, n);
                        throw mt(t, "Invalid left hand side of assignment operator =");
                    }
                    return o;
                }
                function $(t) {
                    for(var e = Z(t); "xor" === t.token;)R(t), e = new d("xor", "xor", [
                        e,
                        Z(t)
                    ]);
                    return e;
                }
                function Z(t) {
                    for(var e = Y(t); "and" === t.token;)R(t), e = new d("and", "and", [
                        e,
                        Y(t)
                    ]);
                    return e;
                }
                function Y(t) {
                    for(var e = K(t); "|" === t.token;)R(t), e = new d("|", "bitOr", [
                        e,
                        K(t)
                    ]);
                    return e;
                }
                function K(t) {
                    for(var e = J(t); "^|" === t.token;)R(t), e = new d("^|", "bitXor", [
                        e,
                        J(t)
                    ]);
                    return e;
                }
                function J(t) {
                    for(var e = Q(t); "&" === t.token;)R(t), e = new d("&", "bitAnd", [
                        e,
                        Q(t)
                    ]);
                    return e;
                }
                function Q(t) {
                    for(var e = [
                        tt(t)
                    ], r = [], n = {
                        "==": "equal",
                        "!=": "unequal",
                        "<": "smaller",
                        ">": "larger",
                        "<=": "smallerEq",
                        ">=": "largerEq"
                    }; ut(n, t.token);){
                        var i = {
                            name: t.token,
                            fn: n[t.token]
                        };
                        r.push(i), R(t), e.push(tt(t));
                    }
                    return 1 === e.length ? e[0] : 2 === e.length ? new d(r[0].name, r[0].fn, e) : new v(r.map((t)=>t.fn), e);
                }
                function tt(t) {
                    var e, r, n, i;
                    e = rt(t);
                    for(var o = {
                        "<<": "leftShift",
                        ">>": "rightArithShift",
                        ">>>": "rightLogShift"
                    }; ut(o, t.token);)n = o[r = t.token], R(t), i = [
                        e,
                        rt(t)
                    ], e = new d(r, n, i);
                    return e;
                }
                function rt(t) {
                    var e, r, n, i;
                    e = nt(t);
                    for(var o = {
                        to: "to",
                        in: "to"
                    }; ut(o, t.token);)n = o[r = t.token], R(t), "in" === r && "" === t.token ? e = new d("*", "multiply", [
                        e,
                        new b("in")
                    ], !0) : (i = [
                        e,
                        nt(t)
                    ], e = new d(r, n, i));
                    return e;
                }
                function nt(t) {
                    var e, r = [];
                    if (e = ":" === t.token ? new l(1) : it(t), ":" === t.token && t.conditionalLevel !== t.nestingLevel) {
                        for(r.push(e); ":" === t.token && r.length < 3;)R(t), ")" === t.token || "]" === t.token || "," === t.token || "" === t.token ? r.push(new b("end")) : r.push(it(t));
                        e = 3 === r.length ? new g(r[0], r[2], r[1]) : new g(r[0], r[1]);
                    }
                    return e;
                }
                function it(t) {
                    var e, r, n, i;
                    e = ot(t);
                    for(var o = {
                        "+": "add",
                        "-": "subtract"
                    }; ut(o, t.token);){
                        n = o[r = t.token], R(t);
                        var a = ot(t);
                        i = a.isPercentage ? [
                            e,
                            new d("*", "multiply", [
                                e,
                                a
                            ])
                        ] : [
                            e,
                            a
                        ], e = new d(r, n, i);
                    }
                    return e;
                }
                function ot(t) {
                    var e, r, n, i;
                    r = e = at(t);
                    for(var o = {
                        "*": "multiply",
                        ".*": "dotMultiply",
                        "/": "divide",
                        "./": "dotDivide"
                    }; ut(o, t.token);)i = o[n = t.token], R(t), r = at(t), e = new d(n, i, [
                        e,
                        r
                    ]);
                    return e;
                }
                function at(t) {
                    var e, r;
                    for(r = e = st(t); t.tokenType === S || "in" === t.token && H(e) || !(t.tokenType !== E || H(r) || X(r) && "!" !== r.op) || "(" === t.token;)r = st(t), e = new d("*", "multiply", [
                        e,
                        r
                    ], !0);
                    return e;
                }
                function st(t) {
                    for(var e = lt(t), r = e, n = []; "/" === t.token && W(r);){
                        if (n.push(m()({}, t)), R(t), t.tokenType !== E) {
                            m()(t, n.pop());
                            break;
                        }
                        if (n.push(m()({}, t)), R(t), t.tokenType !== S && "(" !== t.token) {
                            n.pop(), m()(t, n.pop());
                            break;
                        }
                        m()(t, n.pop()), n.pop(), r = lt(t), e = new d("/", "divide", [
                            e,
                            r
                        ]);
                    }
                    return e;
                }
                function lt(t) {
                    var e, r, n, i;
                    e = ct(t);
                    for(var o = {
                        "%": "mod",
                        mod: "mod"
                    }; ut(o, t.token);)n = o[r = t.token], R(t), "%" === r && t.tokenType === A && "(" !== t.token ? e = new d("/", "divide", [
                        e,
                        new l(100)
                    ], !1, !0) : (i = [
                        e,
                        ct(t)
                    ], e = new d(r, n, i));
                    return e;
                }
                function ct(t) {
                    var e, i, a, s = {
                        "-": "unaryMinus",
                        "+": "unaryPlus",
                        "~": "bitNot",
                        not: "not"
                    };
                    return ut(s, t.token) ? (a = s[t.token], e = t.token, R(t), i = [
                        ct(t)
                    ], new d(e, a, i)) : function(t) {
                        var e, i, a, s;
                        e = function(t) {
                            var e, i, a;
                            e = function(t) {
                                var e = [];
                                if (t.tokenType === S && ut(t.extraNodes, t.token)) {
                                    var i = t.extraNodes[t.token];
                                    if (j(t), "(" === t.token) {
                                        if (e = [], q(t), j(t), ")" !== t.token) for(e.push(G(t)); "," === t.token;)j(t), e.push(G(t));
                                        if (")" !== t.token) throw mt(t, "Parenthesis ) expected");
                                        U(t), j(t);
                                    }
                                    return new i(e);
                                }
                                return function(t) {
                                    var e, i;
                                    if (t.tokenType === S || t.tokenType === A && t.token in N) return i = t.token, j(t), e = ut(C, i) ? new l(C[i]) : -1 !== D.indexOf(i) ? new l(r(i, "number")) : new b(i), e = ft(t, e);
                                    return function(t) {
                                        var e, i;
                                        if ('"' === t.token || "'" === t.token) return i = ht(t, t.token), e = new l(i), e = ft(t, e);
                                        return function(t) {
                                            var e, i, a, s;
                                            if ("[" === t.token) {
                                                if (q(t), j(t), "]" !== t.token) {
                                                    var u = pt(t);
                                                    if (";" === t.token) {
                                                        for(a = 1, i = [
                                                            u
                                                        ]; ";" === t.token;)j(t), i[a] = pt(t), a++;
                                                        if ("]" !== t.token) throw mt(t, "End of matrix ] expected");
                                                        U(t), j(t), s = i[0].items.length;
                                                        for(var c = 1; c < a; c++)if (i[c].items.length !== s) throw yt(t, "Column dimensions mismatch (" + i[c].items.length + " !== " + s + ")");
                                                        e = new o(i);
                                                    } else {
                                                        if ("]" !== t.token) throw mt(t, "End of matrix ] expected");
                                                        U(t), j(t), e = u;
                                                    }
                                                } else U(t), j(t), e = new o([]);
                                                return ft(t, e);
                                            }
                                            return function(t) {
                                                if ("{" === t.token) {
                                                    var e;
                                                    q(t);
                                                    var i = {};
                                                    do if (j(t), "}" !== t.token) {
                                                        if ('"' === t.token || "'" === t.token) e = ht(t, t.token);
                                                        else {
                                                            if (!(t.tokenType === S || t.tokenType === A && t.token in N)) throw mt(t, "Symbol or string expected as object key");
                                                            e = t.token, j(t);
                                                        }
                                                        if (":" !== t.token) throw mt(t, "Colon : expected after object key");
                                                        j(t), i[e] = G(t);
                                                    }
                                                    while ("," === t.token);
                                                    if ("}" !== t.token) throw mt(t, "Comma , or bracket } expected after object value");
                                                    U(t), j(t);
                                                    var o = new p(i);
                                                    return o = ft(t, o);
                                                }
                                                return function(t) {
                                                    var e;
                                                    if (t.tokenType === E) return e = t.token, j(t), new l(r(e, n.number));
                                                    return function(t) {
                                                        var e;
                                                        if ("(" === t.token) {
                                                            if (q(t), j(t), e = G(t), ")" !== t.token) throw mt(t, "Parenthesis ) expected");
                                                            return U(t), j(t), e = new y(e), e = ft(t, e);
                                                        }
                                                        return function(t) {
                                                            throw "" === t.token ? mt(t, "Unexpected end of expression") : mt(t, "Value expected");
                                                        }(t);
                                                    }(t);
                                                }(t);
                                            }(t);
                                        }(t);
                                    }(t);
                                }(t);
                            }(t);
                            var s = {
                                "!": "factorial",
                                "'": "ctranspose"
                            };
                            for(; ut(s, t.token);)i = t.token, a = s[i], j(t), e = new d(i, a, [
                                e
                            ]), e = ft(t, e);
                            return e;
                        }(t), ("^" === t.token || ".^" === t.token) && (i = t.token, a = "^" === i ? "pow" : "dotPow", R(t), s = [
                            e,
                            ct(t)
                        ], e = new d(i, a, s));
                        return e;
                    }(t);
                }
                function ft(t, e, r) {
                    for(var n; !("(" !== t.token && "[" !== t.token && "." !== t.token || r && -1 === r.indexOf(t.token));)if (n = [], "(" === t.token) {
                        if (!et(e) && !L(e)) return e;
                        if (q(t), j(t), ")" !== t.token) for(n.push(G(t)); "," === t.token;)j(t), n.push(G(t));
                        if (")" !== t.token) throw mt(t, "Parenthesis ) expected");
                        U(t), j(t), e = new f(e, n);
                    } else if ("[" === t.token) {
                        if (q(t), j(t), "]" !== t.token) for(n.push(G(t)); "," === t.token;)j(t), n.push(G(t));
                        if ("]" !== t.token) throw mt(t, "Parenthesis ] expected");
                        U(t), j(t), e = new i(e, new h(n));
                    } else {
                        if (j(t), !(t.tokenType === S || t.tokenType === A && t.token in N)) throw mt(t, "Property name expected after dot");
                        n.push(new l(t.token)), j(t);
                        e = new i(e, new h(n, !0));
                    }
                    return e;
                }
                function ht(t, e) {
                    for(var r = ""; "" !== F(t) && F(t) !== e;)if ("\\" === F(t)) {
                        P(t);
                        var n = F(t), i = O[n];
                        if (void 0 !== i) r += i, t.index += 1;
                        else {
                            if ("u" !== n) throw mt(t, "Bad escape character \\".concat(n));
                            var o = t.expression.slice(t.index + 1, t.index + 5);
                            if (!/^[0-9A-Fa-f]{4}$/.test(o)) throw mt(t, "Invalid unicode character \\u".concat(o));
                            r += String.fromCharCode(parseInt(o, 16)), t.index += 5;
                        }
                    } else r += F(t), P(t);
                    if (j(t), t.token !== e) throw mt(t, "End of string ".concat(e, " expected"));
                    return j(t), r;
                }
                function pt(t) {
                    for(var e = [
                        G(t)
                    ], r = 1; "," === t.token;)j(t), e[r] = G(t), r++;
                    return new o(e);
                }
                function dt(t) {
                    return t.index - t.token.length + 1;
                }
                function mt(t, e) {
                    var r = dt(t), n = new SyntaxError(e + " (char " + r + ")");
                    return n.char = r, n;
                }
                function yt(t, e) {
                    var r = dt(t), n = new SyntaxError(e + " (char " + r + ")");
                    return n.char = r, n;
                }
                return x.isAlpha = function(t, e, r) {
                    return x.isValidLatinOrGreek(t) || x.isValidMathSymbol(t, r) || x.isValidMathSymbol(e, t);
                }, x.isValidLatinOrGreek = function(t) {
                    return /^[a-zA-Z_$\u00C0-\u02AF\u0370-\u03FF\u2100-\u214F]$/.test(t);
                }, x.isValidMathSymbol = function(t, e) {
                    return /^[\uD835]$/.test(t) && /^[\uDC00-\uDFFF]$/.test(e) && /^[^\uDC55\uDC9D\uDCA0\uDCA1\uDCA3\uDCA4\uDCA7\uDCA8\uDCAD\uDCBA\uDCBC\uDCC4\uDD06\uDD0B\uDD0C\uDD15\uDD1D\uDD3A\uDD3F\uDD45\uDD47-\uDD49\uDD51\uDEA6\uDEA7\uDFCC\uDFCD]$/.test(e);
                }, x.isWhitespace = function(t, e) {
                    return " " === t || "	" === t || "\n" === t && e > 0;
                }, x.isDecimalMark = function(t, e) {
                    return "." === t && "/" !== e && "*" !== e && "^" !== e;
                }, x.isDigitDot = function(t) {
                    return t >= "0" && t <= "9" || "." === t;
                }, x.isDigit = function(t) {
                    return t >= "0" && t <= "9";
                }, x.isHexDigit = function(t) {
                    return t >= "0" && t <= "9" || t >= "a" && t <= "f" || t >= "A" && t <= "F";
                }, e.addConversion({
                    from: "string",
                    to: "Node",
                    convert: x
                }), x;
            }), Ar = ge("resolve", [
                "typed",
                "parse",
                "ConstantNode",
                "FunctionNode",
                "OperatorNode",
                "ParenthesisNode"
            ], (t)=>{
                var { typed: e, parse: r, ConstantNode: n, FunctionNode: i, OperatorNode: o, ParenthesisNode: a } = t;
                function s(t, e) {
                    var u = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : new Set;
                    if (!e) return t;
                    if (et(t)) {
                        if (u.has(t.name)) {
                            var l = Array.from(u).join(", ");
                            throw new ReferenceError("recursive loop of variable definitions among {".concat(l, "}"));
                        }
                        var c = e.get(t.name);
                        if (Y(c)) {
                            var f = new Set(u);
                            return f.add(t.name), s(c, e, f);
                        }
                        return "number" == typeof c ? r(String(c)) : void 0 !== c ? new n(c) : t;
                    }
                    if (X(t)) {
                        var h = t.args.map(function(t) {
                            return s(t, e, u);
                        });
                        return new o(t.op, t.fn, h, t.implicit);
                    }
                    if (J(t)) return new a(s(t.content, e, u));
                    if (V(t)) {
                        var p = t.args.map(function(t) {
                            return s(t, e, u);
                        });
                        return new i(t.name, p);
                    }
                    return t.map((t)=>s(t, e, u));
                }
                return e("resolve", {
                    Node: s,
                    "Node, Map | null | undefined": s,
                    "Node, Object": (t, e)=>s(t, Ne(e)),
                    "Array | Matrix": e.referToSelf((t)=>(e)=>e.map((e)=>t(e))),
                    "Array | Matrix, null | undefined": e.referToSelf((t)=>(e)=>e.map((e)=>t(e))),
                    "Array, Object": e.referTo("Array,Map", (t)=>(e, r)=>t(e, Ne(r))),
                    "Matrix, Object": e.referTo("Matrix,Map", (t)=>(e, r)=>t(e, Ne(r))),
                    "Array | Matrix, Map": e.referToSelf((t)=>(e, r)=>e.map((e)=>t(e, r)))
                });
            });
            function Er(t, e) {
                var r = Object.keys(t);
                if (Object.getOwnPropertySymbols) {
                    var n = Object.getOwnPropertySymbols(t);
                    e && (n = n.filter(function(e) {
                        return Object.getOwnPropertyDescriptor(t, e).enumerable;
                    })), r.push.apply(r, n);
                }
                return r;
            }
            function Sr(t) {
                for(var e = 1; e < arguments.length; e++){
                    var r = null != arguments[e] ? arguments[e] : {};
                    e % 2 ? Er(Object(r), !0).forEach(function(e) {
                        Fe()(t, e, r[e]);
                    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Er(Object(r)).forEach(function(e) {
                        Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
                    });
                }
                return t;
            }
            var Mr = ge("simplifyUtil", [
                "FunctionNode",
                "OperatorNode",
                "SymbolNode"
            ], (t)=>{
                var { FunctionNode: e, OperatorNode: r, SymbolNode: n } = t, i = !0, o = !1, a = {
                    add: {
                        trivial: i,
                        total: i,
                        commutative: i,
                        associative: i
                    },
                    unaryPlus: {
                        trivial: i,
                        total: i,
                        commutative: i,
                        associative: i
                    },
                    subtract: {
                        trivial: o,
                        total: i,
                        commutative: o,
                        associative: o
                    },
                    multiply: {
                        trivial: i,
                        total: i,
                        commutative: i,
                        associative: i
                    },
                    divide: {
                        trivial: o,
                        total: i,
                        commutative: o,
                        associative: o
                    },
                    paren: {
                        trivial: i,
                        total: i,
                        commutative: i,
                        associative: o
                    },
                    defaultF: {
                        trivial: o,
                        total: i,
                        commutative: o,
                        associative: o
                    }
                };
                function s(t, e) {
                    var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : a, n = "defaultF";
                    if ("string" == typeof t ? n = t : X(t) ? n = t.fn.toString() : V(t) ? n = t.name : J(t) && (n = "paren"), ut(r, n)) {
                        var i = r[n];
                        if (ut(i, e)) return i[e];
                        if (ut(a, n)) return a[n][e];
                    }
                    if (ut(r, "defaultF")) {
                        var o = r.defaultF;
                        return ut(o, e) ? o[e] : a.defaultF[e];
                    }
                    if (ut(a, n)) {
                        var s = a[n];
                        if (ut(s, e)) return s[e];
                    }
                    return a.defaultF[e];
                }
                function u(t) {
                    var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : a;
                    return s(t, "associative", e);
                }
                function l(t, e) {
                    var r, n = [];
                    return u(t, e) ? (r = t.op, function t(e) {
                        for(var i = 0; i < e.args.length; i++){
                            var o = e.args[i];
                            X(o) && r === o.op ? t(o) : n.push(o);
                        }
                    }(t), n) : t.args;
                }
                function c(t) {
                    return X(t) ? function(e) {
                        try {
                            return new r(t.op, t.fn, e, t.implicit);
                        } catch (t) {
                            return console.error(t), [];
                        }
                    } : function(r) {
                        return new e(new n(t.name), r);
                    };
                }
                return {
                    createMakeNodeFunction: c,
                    hasProperty: s,
                    isCommutative: function(t) {
                        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : a;
                        return s(t, "commutative", e);
                    },
                    isAssociative: u,
                    mergeContext: function(t, e) {
                        var r = Sr({}, t);
                        for(var n in e)ut(t, n) ? r[n] = Sr(Sr({}, e[n]), t[n]) : r[n] = e[n];
                        return r;
                    },
                    flatten: function t(e, r) {
                        if (!e.args || 0 === e.args.length) return e;
                        e.args = l(e, r);
                        for(var n = 0; n < e.args.length; n++)t(e.args[n], r);
                    },
                    allChildren: l,
                    unflattenr: function t(e, r) {
                        if (e.args && 0 !== e.args.length) {
                            for(var n = c(e), i = e.args.length, o = 0; o < i; o++)t(e.args[o], r);
                            if (i > 2 && u(e, r)) {
                                for(var a = e.args.pop(); e.args.length > 0;)a = n([
                                    e.args.pop(),
                                    a
                                ]);
                                e.args = a.args;
                            }
                        }
                    },
                    unflattenl: function t(e, r) {
                        if (e.args && 0 !== e.args.length) {
                            for(var n = c(e), i = e.args.length, o = 0; o < i; o++)t(e.args[o], r);
                            if (i > 2 && u(e, r)) {
                                for(var a = e.args.shift(); e.args.length > 0;)a = n([
                                    a,
                                    e.args.shift()
                                ]);
                                e.args = a.args;
                            }
                        }
                    },
                    defaultContext: a,
                    realContext: {
                        divide: {
                            total: o
                        },
                        log: {
                            total: o
                        }
                    },
                    positiveContext: {
                        subtract: {
                            total: o
                        },
                        abs: {
                            trivial: i
                        },
                        log: {
                            total: i
                        }
                    }
                };
            });
            function kr() {
                throw new Error('No "bignumber" implementation available');
            }
            function Nr() {
                throw new Error('No "fraction" implementation available');
            }
            function Cr() {
                throw new Error('No "matrix" implementation available');
            }
            var Dr = [
                "typed",
                "config",
                "mathWithTransform",
                "matrix",
                "?fraction",
                "?bignumber",
                "AccessorNode",
                "ArrayNode",
                "ConstantNode",
                "FunctionNode",
                "IndexNode",
                "ObjectNode",
                "OperatorNode",
                "SymbolNode"
            ], Or = ge("simplifyConstant", Dr, (t)=>{
                var { typed: e, config: r, mathWithTransform: n, matrix: i, fraction: o, bignumber: a, AccessorNode: s, ArrayNode: u, ConstantNode: l, FunctionNode: c, IndexNode: f, ObjectNode: h, OperatorNode: p, SymbolNode: d } = t, { isCommutative: m, isAssociative: y, allChildren: g, createMakeNodeFunction: v } = Mr({
                    FunctionNode: c,
                    OperatorNode: p,
                    SymbolNode: d
                }), b = e("simplifyConstant", {
                    Node: (t)=>S(D(t, {})),
                    "Node, Object": function(t, e) {
                        return S(D(t, e));
                    }
                });
                function w(t) {
                    return x(t) ? t.valueOf() : t instanceof Array ? t.map(w) : E(t) ? i(w(t.valueOf())) : t;
                }
                function _(t, e, r) {
                    try {
                        return n[t].apply(null, e);
                    } catch (i) {
                        return e = e.map(w), k(n[t].apply(null, e), r);
                    }
                }
                var A = e({
                    Fraction: function(t) {
                        var e, r = t.s * t.n;
                        e = r < 0 ? new p("-", "unaryMinus", [
                            new l(-r)
                        ]) : new l(r);
                        if (1 === t.d) return e;
                        return new p("/", "divide", [
                            e,
                            new l(t.d)
                        ]);
                    },
                    number: function(t) {
                        return t < 0 ? N(new l(-t)) : new l(t);
                    },
                    BigNumber: function(t) {
                        return t < 0 ? N(new l(-t)) : new l(t);
                    },
                    Complex: function(t) {
                        throw new Error("Cannot convert Complex number to Node");
                    },
                    string: function(t) {
                        return new l(t);
                    },
                    Matrix: function(t) {
                        return new u(t.valueOf().map((t)=>A(t)));
                    }
                });
                function S(t) {
                    return Y(t) ? t : A(t);
                }
                function M(t, e) {
                    if (e && !1 !== e.exactFractions && isFinite(t) && o) {
                        var r = o(t), n = e && "number" == typeof e.fractionsLimit ? e.fractionsLimit : 1 / 0;
                        if (r.valueOf() === t && r.n < n && r.d < n) return r;
                    }
                    return t;
                }
                var k = e({
                    "string, Object": function(t, e) {
                        return "BigNumber" === r.number ? (void 0 === a && kr(), a(t)) : "Fraction" === r.number ? (void 0 === o && Nr(), o(t)) : M(parseFloat(t), e);
                    },
                    "Fraction, Object": function(t, e) {
                        return t;
                    },
                    "BigNumber, Object": function(t, e) {
                        return t;
                    },
                    "number, Object": function(t, e) {
                        return M(t, e);
                    },
                    "Complex, Object": function(t, e) {
                        return 0 !== t.im ? t : M(t.re, e);
                    },
                    "Matrix, Object": function(t, e) {
                        return i(M(t.valueOf()));
                    },
                    "Array, Object": function(t, e) {
                        return t.map(M);
                    }
                });
                function N(t) {
                    return new p("-", "unaryMinus", [
                        t
                    ]);
                }
                function C(t, e, r, n) {
                    var i = e.shift(), o = e.reduce((e, i)=>{
                        if (!Y(i)) {
                            var o = e.pop();
                            if (Y(o)) return [
                                o,
                                i
                            ];
                            try {
                                return e.push(_(t, [
                                    o,
                                    i
                                ], n)), e;
                            } catch (t) {
                                e.push(o);
                            }
                        }
                        e.push(S(e.pop()));
                        var a = 1 === e.length ? e[0] : r(e);
                        return [
                            r([
                                a,
                                S(i)
                            ])
                        ];
                    }, [
                        i
                    ]);
                    return 1 === o.length ? o[0] : r([
                        o[0],
                        A(o[1])
                    ]);
                }
                function D(t, e) {
                    switch(t.type){
                        case "SymbolNode":
                            return t;
                        case "ConstantNode":
                            switch(typeof t.value){
                                case "number":
                                    return k(t.value, e);
                                case "string":
                                    return t.value;
                                default:
                                    if (!isNaN(t.value)) return k(t.value, e);
                            }
                            return t;
                        case "FunctionNode":
                            if (n[t.name] && n[t.name].rawArgs) return t;
                            if (-1 === [
                                "add",
                                "multiply"
                            ].indexOf(t.name)) {
                                var r = t.args.map((t)=>D(t, e));
                                if (!r.some(Y)) try {
                                    return _(t.name, r, e);
                                } catch (t) {}
                                if ("size" === t.name && 1 === r.length && q(r[0])) {
                                    for(var o = [], a = r[0]; q(a);)o.push(a.items.length), a = a.items[0];
                                    return i(o);
                                }
                                return new c(t.name, r.map(S));
                            }
                        case "OperatorNode":
                            var p, d, x = t.fn.toString(), w = v(t);
                            if (X(t) && t.isUnary()) d = Y((p = [
                                D(t.args[0], e)
                            ])[0]) ? w(p) : _(x, p, e);
                            else if (y(t, e.context)) {
                                if (p = (p = g(t, e.context)).map((t)=>D(t, e)), m(x, e.context)) {
                                    for(var A = [], M = [], N = 0; N < p.length; N++)Y(p[N]) ? M.push(p[N]) : A.push(p[N]);
                                    A.length > 1 ? (d = C(x, A, w, e), M.unshift(d), d = C(x, M, w, e)) : d = C(x, p, w, e);
                                } else d = C(x, p, w, e);
                            } else d = C(x, p = t.args.map((t)=>D(t, e)), w, e);
                            return d;
                        case "ParenthesisNode":
                            return D(t.content, e);
                        case "AccessorNode":
                            return function(t, e, r) {
                                if (!Z(e)) return new s(S(t), S(e));
                                if (q(t) || E(t)) {
                                    for(var n = Array.from(e.dimensions); n.length > 0;)if (H(n[0]) && "string" != typeof n[0].value) {
                                        var o = k(n.shift().value, r);
                                        q(t) ? t = t.items[o - 1] : (t = t.valueOf()[o - 1]) instanceof Array && (t = i(t));
                                    } else {
                                        if (!(n.length > 1 && H(n[1]) && "string" != typeof n[1].value)) break;
                                        var a = k(n[1].value, r), c = [], h = q(t) ? t.items : t.valueOf();
                                        for (var p of h)if (q(p)) c.push(p.items[a - 1]);
                                        else {
                                            if (!E(t)) break;
                                            c.push(p[a - 1]);
                                        }
                                        if (c.length !== h.length) break;
                                        t = q(t) ? new u(c) : i(c), n.splice(1, 1);
                                    }
                                    return n.length === e.dimensions.length ? new s(S(t), e) : n.length > 0 ? (e = new f(n), new s(S(t), e)) : t;
                                }
                                if (K(t) && 1 === e.dimensions.length && H(e.dimensions[0])) {
                                    var d = e.dimensions[0].value;
                                    return d in t.properties ? t.properties[d] : new l;
                                }
                                return new s(S(t), e);
                            }(D(t.object, e), D(t.index, e), e);
                        case "ArrayNode":
                            var O = t.items.map((t)=>D(t, e));
                            return O.some(Y) ? new u(O.map(S)) : i(O);
                        case "IndexNode":
                            return new f(t.dimensions.map((t)=>b(t, e)));
                        case "ObjectNode":
                            var T = {};
                            for(var F in t.properties)T[F] = b(t.properties[F], e);
                            return new h(T);
                        case "AssignmentNode":
                        case "BlockNode":
                        case "FunctionAssignmentNode":
                        case "RangeNode":
                        case "ConditionalNode":
                        default:
                            throw new Error("Unimplemented node type in simplifyConstant: ".concat(t.type));
                    }
                }
                return b;
            }), Tr = [
                "typed",
                "parse"
            ], Fr = ge("compile", Tr, (t)=>{
                var { typed: e, parse: r } = t;
                return e("compile", {
                    string: function(t) {
                        return r(t).compile();
                    },
                    "Array | Matrix": function(t) {
                        return vr(t, function(t) {
                            return r(t).compile();
                        });
                    }
                });
            }), Pr = [
                "parse"
            ], Ir = ge("Help", Pr, (t)=>{
                var { parse: e } = t;
                function r(t) {
                    if (!(this instanceof r)) throw new SyntaxError("Constructor must be called with the new operator");
                    if (!t) throw new Error('Argument "doc" missing');
                    this.doc = t;
                }
                return r.prototype.type = "Help", r.prototype.isHelp = !0, r.prototype.toString = function() {
                    var t = this.doc || {}, r = "\n";
                    if (t.name && (r += "Name: " + t.name + "\n\n"), t.category && (r += "Category: " + t.category + "\n\n"), t.description && (r += "Description:\n    " + t.description + "\n\n"), t.syntax && (r += "Syntax:\n    " + t.syntax.join("\n    ") + "\n\n"), t.examples) {
                        r += "Examples:\n";
                        for(var n = {}, i = 0; i < t.examples.length; i++){
                            var o = t.examples[i];
                            r += "    " + o + "\n";
                            var a = void 0;
                            try {
                                a = e(o).compile().evaluate(n);
                            } catch (t) {
                                a = t;
                            }
                            void 0 === a || T(a) || (r += "        " + Lt(a, {
                                precision: 14
                            }) + "\n");
                        }
                        r += "\n";
                    }
                    return t.mayThrow && t.mayThrow.length && (r += "Throws: " + t.mayThrow.join(", ") + "\n\n"), t.seealso && t.seealso.length && (r += "See also: " + t.seealso.join(", ") + "\n"), r;
                }, r.prototype.toJSON = function() {
                    var t = it(this.doc);
                    return t.mathjs = "Help", t;
                }, r.fromJSON = function(t) {
                    var e = {};
                    return Object.keys(t).filter((t)=>"mathjs" !== t).forEach((r)=>{
                        e[r] = t[r];
                    }), new r(e);
                }, r.prototype.valueOf = r.prototype.toString, r;
            }, {
                isClass: !0
            }), Br = [
                "parse",
                "typed"
            ], jr = ge("leafCount", Br, (t)=>{
                var { parse: e, typed: r } = t;
                return r("leafCount", {
                    Node: function(t) {
                        return function t(e) {
                            var r = 0;
                            return e.forEach((e)=>{
                                r += t(e);
                            }), r || 1;
                        }(t);
                    }
                });
            }), Rr = [
                "typed",
                "parse",
                "equal",
                "isZero",
                "add",
                "subtract",
                "multiply",
                "divide",
                "pow",
                "AccessorNode",
                "ArrayNode",
                "ConstantNode",
                "FunctionNode",
                "IndexNode",
                "ObjectNode",
                "OperatorNode",
                "ParenthesisNode",
                "SymbolNode"
            ], Lr = ge("simplifyCore", Rr, (t)=>{
                var { typed: e, parse: r, equal: n, isZero: i, add: o, subtract: a, multiply: s, divide: u, pow: l, AccessorNode: c, ArrayNode: f, ConstantNode: h, FunctionNode: p, IndexNode: d, ObjectNode: m, OperatorNode: y, ParenthesisNode: g, SymbolNode: v } = t, b = new h(0), x = new h(1), w = new h(!0), _ = new h(!1);
                function A(t) {
                    return X(t) && [
                        "and",
                        "not",
                        "or"
                    ].includes(t.op);
                }
                var { hasProperty: E, isCommutative: S } = Mr({
                    FunctionNode: p,
                    OperatorNode: y,
                    SymbolNode: v
                });
                function M(t) {
                    var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = e ? e.context : void 0;
                    if (E(t, "trivial", r)) {
                        if (V(t) && 1 === t.args.length) return M(t.args[0], e);
                        var o = !1, a = 0;
                        if (t.forEach((t)=>{
                            1 === ++a && (o = M(t, e));
                        }), 1 === a) return o;
                    }
                    var s = t;
                    if (V(s)) {
                        var u = qe(s.name);
                        if (!u) return new p(M(s.fn), s.args.map((t)=>M(t, e)));
                        if (s.args.length > 2 && E(s, "associative", r)) for(; s.args.length > 2;){
                            var l = s.args.pop(), h = s.args.pop();
                            s.args.push(new y(u, s.name, [
                                l,
                                h
                            ]));
                        }
                        s = new y(u, s.name, s.args);
                    }
                    if (X(s) && s.isUnary()) {
                        var g = M(s.args[0], e);
                        if ("~" === s.op && X(g) && g.isUnary() && "~" === g.op) return g.args[0];
                        if ("not" === s.op && X(g) && g.isUnary() && "not" === g.op && A(g.args[0])) return g.args[0];
                        var v = !0;
                        if ("-" === s.op && X(g) && (g.isBinary() && "subtract" === g.fn && (s = new y("-", "subtract", [
                            g.args[1],
                            g.args[0]
                        ]), v = !1), g.isUnary() && "-" === g.op)) return g.args[0];
                        if (v) return new y(s.op, s.fn, [
                            g
                        ]);
                    }
                    if (X(s) && s.isBinary()) {
                        var k = M(s.args[0], e), N = M(s.args[1], e);
                        if ("+" === s.op) {
                            if (H(k) && i(k.value)) return N;
                            if (H(N) && i(N.value)) return k;
                            X(N) && N.isUnary() && "-" === N.op && (N = N.args[0], s = new y("-", "subtract", [
                                k,
                                N
                            ]));
                        }
                        if ("-" === s.op) return X(N) && N.isUnary() && "-" === N.op ? M(new y("+", "add", [
                            k,
                            N.args[0]
                        ]), e) : H(k) && i(k.value) ? M(new y("-", "unaryMinus", [
                            N
                        ])) : H(N) && i(N.value) ? k : new y(s.op, s.fn, [
                            k,
                            N
                        ]);
                        if ("*" === s.op) {
                            if (H(k)) {
                                if (i(k.value)) return b;
                                if (n(k.value, 1)) return N;
                            }
                            if (H(N)) {
                                if (i(N.value)) return b;
                                if (n(N.value, 1)) return k;
                                if (S(s, r)) return new y(s.op, s.fn, [
                                    N,
                                    k
                                ], s.implicit);
                            }
                            return new y(s.op, s.fn, [
                                k,
                                N
                            ], s.implicit);
                        }
                        if ("/" === s.op) return H(k) && i(k.value) ? b : H(N) && n(N.value, 1) ? k : new y(s.op, s.fn, [
                            k,
                            N
                        ]);
                        if ("^" === s.op && H(N)) {
                            if (i(N.value)) return x;
                            if (n(N.value, 1)) return k;
                        }
                        if ("and" === s.op) {
                            if (H(k)) {
                                if (!k.value) return _;
                                if (A(N)) return N;
                            }
                            if (H(N)) {
                                if (!N.value) return _;
                                if (A(k)) return k;
                            }
                        }
                        if ("or" === s.op) {
                            if (H(k)) {
                                if (k.value) return w;
                                if (A(N)) return N;
                            }
                            if (H(N)) {
                                if (N.value) return w;
                                if (A(k)) return k;
                            }
                        }
                        return new y(s.op, s.fn, [
                            k,
                            N
                        ]);
                    }
                    if (X(s)) return new y(s.op, s.fn, s.args.map((t)=>M(t, e)));
                    if (q(s)) return new f(s.items.map((t)=>M(t, e)));
                    if (L(s)) return new c(M(s.object, e), M(s.index, e));
                    if (Z(s)) return new d(s.dimensions.map((t)=>M(t, e)));
                    if (K(s)) {
                        var C = {};
                        for(var D in s.properties)C[D] = M(s.properties[D], e);
                        return new m(C);
                    }
                    return s;
                }
                return e("simplifyCore", {
                    Node: M,
                    "Node,Object": M
                });
            }), qr = [
                "typed",
                "parse"
            ], Ur = ge("evaluate", qr, (t)=>{
                var { typed: e, parse: r } = t;
                return e("evaluate", {
                    string: function(t) {
                        var e = ke();
                        return r(t).compile().evaluate(e);
                    },
                    "string, Map | Object": function(t, e) {
                        return r(t).compile().evaluate(e);
                    },
                    "Array | Matrix": function(t) {
                        var e = ke();
                        return vr(t, function(t) {
                            return r(t).compile().evaluate(e);
                        });
                    },
                    "Array | Matrix, Map | Object": function(t, e) {
                        return vr(t, function(t) {
                            return r(t).compile().evaluate(e);
                        });
                    }
                });
            }), zr = {
                name: "e",
                category: "Constants",
                syntax: [
                    "e"
                ],
                description: "Euler's number, the base of the natural logarithm. Approximately equal to 2.71828",
                examples: [
                    "e",
                    "e ^ 2",
                    "exp(2)",
                    "log(e)"
                ],
                seealso: [
                    "exp"
                ]
            }, Gr = {
                name: "pi",
                category: "Constants",
                syntax: [
                    "pi"
                ],
                description: "The number pi is a mathematical constant that is the ratio of a circle's circumference to its diameter, and is approximately equal to 3.14159",
                examples: [
                    "pi",
                    "sin(pi/2)"
                ],
                seealso: [
                    "tau"
                ]
            }, Hr = {
                bignumber: {
                    name: "bignumber",
                    category: "Construction",
                    syntax: [
                        "bignumber(x)"
                    ],
                    description: "Create a big number from a number or string.",
                    examples: [
                        "0.1 + 0.2",
                        "bignumber(0.1) + bignumber(0.2)",
                        'bignumber("7.2")',
                        'bignumber("7.2e500")',
                        "bignumber([0.1, 0.2, 0.3])"
                    ],
                    seealso: [
                        "boolean",
                        "complex",
                        "fraction",
                        "index",
                        "matrix",
                        "string",
                        "unit"
                    ]
                },
                boolean: {
                    name: "boolean",
                    category: "Construction",
                    syntax: [
                        "x",
                        "boolean(x)"
                    ],
                    description: "Convert a string or number into a boolean.",
                    examples: [
                        "boolean(0)",
                        "boolean(1)",
                        "boolean(3)",
                        'boolean("true")',
                        'boolean("false")',
                        "boolean([1, 0, 1, 1])"
                    ],
                    seealso: [
                        "bignumber",
                        "complex",
                        "index",
                        "matrix",
                        "number",
                        "string",
                        "unit"
                    ]
                },
                complex: {
                    name: "complex",
                    category: "Construction",
                    syntax: [
                        "complex()",
                        "complex(re, im)",
                        "complex(string)"
                    ],
                    description: "Create a complex number.",
                    examples: [
                        "complex()",
                        "complex(2, 3)",
                        'complex("7 - 2i")'
                    ],
                    seealso: [
                        "bignumber",
                        "boolean",
                        "index",
                        "matrix",
                        "number",
                        "string",
                        "unit"
                    ]
                },
                createUnit: {
                    name: "createUnit",
                    category: "Construction",
                    syntax: [
                        "createUnit(definitions)",
                        "createUnit(name, definition)"
                    ],
                    description: "Create a user-defined unit and register it with the Unit type.",
                    examples: [
                        'createUnit("foo")',
                        'createUnit("knot", {definition: "0.514444444 m/s", aliases: ["knots", "kt", "kts"]})',
                        'createUnit("mph", "1 mile/hour")'
                    ],
                    seealso: [
                        "unit",
                        "splitUnit"
                    ]
                },
                fraction: {
                    name: "fraction",
                    category: "Construction",
                    syntax: [
                        "fraction(num)",
                        "fraction(matrix)",
                        "fraction(num,den)",
                        "fraction({n: num, d: den})"
                    ],
                    description: "Create a fraction from a number or from integer numerator and denominator.",
                    examples: [
                        "fraction(0.125)",
                        "fraction(1, 3) + fraction(2, 5)",
                        "fraction({n: 333, d: 53})",
                        "fraction([sqrt(9), sqrt(10), sqrt(11)])"
                    ],
                    seealso: [
                        "bignumber",
                        "boolean",
                        "complex",
                        "index",
                        "matrix",
                        "string",
                        "unit"
                    ]
                },
                index: {
                    name: "index",
                    category: "Construction",
                    syntax: [
                        "[start]",
                        "[start:end]",
                        "[start:step:end]",
                        "[start1, start 2, ...]",
                        "[start1:end1, start2:end2, ...]",
                        "[start1:step1:end1, start2:step2:end2, ...]"
                    ],
                    description: "Create an index to get or replace a subset of a matrix",
                    examples: [
                        "A = [1, 2, 3; 4, 5, 6]",
                        "A[1, :]",
                        "A[1, 2] = 50",
                        "A[1:2, 1:2] = 1",
                        "B = [1, 2, 3]",
                        "B[B>1 and B<3]"
                    ],
                    seealso: [
                        "bignumber",
                        "boolean",
                        "complex",
                        "matrix,",
                        "number",
                        "range",
                        "string",
                        "unit"
                    ]
                },
                matrix: {
                    name: "matrix",
                    category: "Construction",
                    syntax: [
                        "[]",
                        "[a1, b1, ...; a2, b2, ...]",
                        "matrix()",
                        'matrix("dense")',
                        "matrix([...])"
                    ],
                    description: "Create a matrix.",
                    examples: [
                        "[]",
                        "[1, 2, 3]",
                        "[1, 2, 3; 4, 5, 6]",
                        "matrix()",
                        "matrix([3, 4])",
                        'matrix([3, 4; 5, 6], "sparse")',
                        'matrix([3, 4; 5, 6], "sparse", "number")'
                    ],
                    seealso: [
                        "bignumber",
                        "boolean",
                        "complex",
                        "index",
                        "number",
                        "string",
                        "unit",
                        "sparse"
                    ]
                },
                number: {
                    name: "number",
                    category: "Construction",
                    syntax: [
                        "x",
                        "number(x)",
                        "number(unit, valuelessUnit)"
                    ],
                    description: "Create a number or convert a string or boolean into a number.",
                    examples: [
                        "2",
                        "2e3",
                        "4.05",
                        "number(2)",
                        'number("7.2")',
                        "number(true)",
                        "number([true, false, true, true])",
                        'number(unit("52cm"), "m")'
                    ],
                    seealso: [
                        "bignumber",
                        "boolean",
                        "complex",
                        "fraction",
                        "index",
                        "matrix",
                        "string",
                        "unit"
                    ]
                },
                sparse: {
                    name: "sparse",
                    category: "Construction",
                    syntax: [
                        "sparse()",
                        "sparse([a1, b1, ...; a1, b2, ...])",
                        'sparse([a1, b1, ...; a1, b2, ...], "number")'
                    ],
                    description: "Create a sparse matrix.",
                    examples: [
                        "sparse()",
                        "sparse([3, 4; 5, 6])",
                        'sparse([3, 0; 5, 0], "number")'
                    ],
                    seealso: [
                        "bignumber",
                        "boolean",
                        "complex",
                        "index",
                        "number",
                        "string",
                        "unit",
                        "matrix"
                    ]
                },
                splitUnit: {
                    name: "splitUnit",
                    category: "Construction",
                    syntax: [
                        "splitUnit(unit: Unit, parts: Unit[])"
                    ],
                    description: "Split a unit in an array of units whose sum is equal to the original unit.",
                    examples: [
                        'splitUnit(1 m, ["feet", "inch"])'
                    ],
                    seealso: [
                        "unit",
                        "createUnit"
                    ]
                },
                string: {
                    name: "string",
                    category: "Construction",
                    syntax: [
                        '"text"',
                        "string(x)"
                    ],
                    description: "Create a string or convert a value to a string",
                    examples: [
                        '"Hello World!"',
                        "string(4.2)",
                        "string(3 + 2i)"
                    ],
                    seealso: [
                        "bignumber",
                        "boolean",
                        "complex",
                        "index",
                        "matrix",
                        "number",
                        "unit"
                    ]
                },
                unit: {
                    name: "unit",
                    category: "Construction",
                    syntax: [
                        "value unit",
                        "unit(value, unit)",
                        "unit(string)"
                    ],
                    description: "Create a unit.",
                    examples: [
                        "5.5 mm",
                        "3 inch",
                        'unit(7.1, "kilogram")',
                        'unit("23 deg")'
                    ],
                    seealso: [
                        "bignumber",
                        "boolean",
                        "complex",
                        "index",
                        "matrix",
                        "number",
                        "string"
                    ]
                },
                e: zr,
                E: zr,
                false: {
                    name: "false",
                    category: "Constants",
                    syntax: [
                        "false"
                    ],
                    description: "Boolean value false",
                    examples: [
                        "false"
                    ],
                    seealso: [
                        "true"
                    ]
                },
                i: {
                    name: "i",
                    category: "Constants",
                    syntax: [
                        "i"
                    ],
                    description: "Imaginary unit, defined as i*i=-1. A complex number is described as a + b*i, where a is the real part, and b is the imaginary part.",
                    examples: [
                        "i",
                        "i * i",
                        "sqrt(-1)"
                    ],
                    seealso: []
                },
                Infinity: {
                    name: "Infinity",
                    category: "Constants",
                    syntax: [
                        "Infinity"
                    ],
                    description: "Infinity, a number which is larger than the maximum number that can be handled by a floating point number.",
                    examples: [
                        "Infinity",
                        "1 / 0"
                    ],
                    seealso: []
                },
                LN2: {
                    name: "LN2",
                    category: "Constants",
                    syntax: [
                        "LN2"
                    ],
                    description: "Returns the natural logarithm of 2, approximately equal to 0.693",
                    examples: [
                        "LN2",
                        "log(2)"
                    ],
                    seealso: []
                },
                LN10: {
                    name: "LN10",
                    category: "Constants",
                    syntax: [
                        "LN10"
                    ],
                    description: "Returns the natural logarithm of 10, approximately equal to 2.302",
                    examples: [
                        "LN10",
                        "log(10)"
                    ],
                    seealso: []
                },
                LOG2E: {
                    name: "LOG2E",
                    category: "Constants",
                    syntax: [
                        "LOG2E"
                    ],
                    description: "Returns the base-2 logarithm of E, approximately equal to 1.442",
                    examples: [
                        "LOG2E",
                        "log(e, 2)"
                    ],
                    seealso: []
                },
                LOG10E: {
                    name: "LOG10E",
                    category: "Constants",
                    syntax: [
                        "LOG10E"
                    ],
                    description: "Returns the base-10 logarithm of E, approximately equal to 0.434",
                    examples: [
                        "LOG10E",
                        "log(e, 10)"
                    ],
                    seealso: []
                },
                NaN: {
                    name: "NaN",
                    category: "Constants",
                    syntax: [
                        "NaN"
                    ],
                    description: "Not a number",
                    examples: [
                        "NaN",
                        "0 / 0"
                    ],
                    seealso: []
                },
                null: {
                    name: "null",
                    category: "Constants",
                    syntax: [
                        "null"
                    ],
                    description: "Value null",
                    examples: [
                        "null"
                    ],
                    seealso: [
                        "true",
                        "false"
                    ]
                },
                pi: Gr,
                PI: Gr,
                phi: {
                    name: "phi",
                    category: "Constants",
                    syntax: [
                        "phi"
                    ],
                    description: "Phi is the golden ratio. Two quantities are in the golden ratio if their ratio is the same as the ratio of their sum to the larger of the two quantities. Phi is defined as `(1 + sqrt(5)) / 2` and is approximately 1.618034...",
                    examples: [
                        "phi"
                    ],
                    seealso: []
                },
                SQRT1_2: {
                    name: "SQRT1_2",
                    category: "Constants",
                    syntax: [
                        "SQRT1_2"
                    ],
                    description: "Returns the square root of 1/2, approximately equal to 0.707",
                    examples: [
                        "SQRT1_2",
                        "sqrt(1/2)"
                    ],
                    seealso: []
                },
                SQRT2: {
                    name: "SQRT2",
                    category: "Constants",
                    syntax: [
                        "SQRT2"
                    ],
                    description: "Returns the square root of 2, approximately equal to 1.414",
                    examples: [
                        "SQRT2",
                        "sqrt(2)"
                    ],
                    seealso: []
                },
                tau: {
                    name: "tau",
                    category: "Constants",
                    syntax: [
                        "tau"
                    ],
                    description: "Tau is the ratio constant of a circle's circumference to radius, equal to 2 * pi, approximately 6.2832.",
                    examples: [
                        "tau",
                        "2 * pi"
                    ],
                    seealso: [
                        "pi"
                    ]
                },
                true: {
                    name: "true",
                    category: "Constants",
                    syntax: [
                        "true"
                    ],
                    description: "Boolean value true",
                    examples: [
                        "true"
                    ],
                    seealso: [
                        "false"
                    ]
                },
                version: {
                    name: "version",
                    category: "Constants",
                    syntax: [
                        "version"
                    ],
                    description: "A string with the version number of math.js",
                    examples: [
                        "version"
                    ],
                    seealso: []
                },
                speedOfLight: {
                    description: "Speed of light in vacuum",
                    examples: [
                        "speedOfLight"
                    ]
                },
                gravitationConstant: {
                    description: "Newtonian constant of gravitation",
                    examples: [
                        "gravitationConstant"
                    ]
                },
                planckConstant: {
                    description: "Planck constant",
                    examples: [
                        "planckConstant"
                    ]
                },
                reducedPlanckConstant: {
                    description: "Reduced Planck constant",
                    examples: [
                        "reducedPlanckConstant"
                    ]
                },
                magneticConstant: {
                    description: "Magnetic constant (vacuum permeability)",
                    examples: [
                        "magneticConstant"
                    ]
                },
                electricConstant: {
                    description: "Electric constant (vacuum permeability)",
                    examples: [
                        "electricConstant"
                    ]
                },
                vacuumImpedance: {
                    description: "Characteristic impedance of vacuum",
                    examples: [
                        "vacuumImpedance"
                    ]
                },
                coulomb: {
                    description: "Coulomb's constant",
                    examples: [
                        "coulomb"
                    ]
                },
                elementaryCharge: {
                    description: "Elementary charge",
                    examples: [
                        "elementaryCharge"
                    ]
                },
                bohrMagneton: {
                    description: "Borh magneton",
                    examples: [
                        "bohrMagneton"
                    ]
                },
                conductanceQuantum: {
                    description: "Conductance quantum",
                    examples: [
                        "conductanceQuantum"
                    ]
                },
                inverseConductanceQuantum: {
                    description: "Inverse conductance quantum",
                    examples: [
                        "inverseConductanceQuantum"
                    ]
                },
                magneticFluxQuantum: {
                    description: "Magnetic flux quantum",
                    examples: [
                        "magneticFluxQuantum"
                    ]
                },
                nuclearMagneton: {
                    description: "Nuclear magneton",
                    examples: [
                        "nuclearMagneton"
                    ]
                },
                klitzing: {
                    description: "Von Klitzing constant",
                    examples: [
                        "klitzing"
                    ]
                },
                bohrRadius: {
                    description: "Borh radius",
                    examples: [
                        "bohrRadius"
                    ]
                },
                classicalElectronRadius: {
                    description: "Classical electron radius",
                    examples: [
                        "classicalElectronRadius"
                    ]
                },
                electronMass: {
                    description: "Electron mass",
                    examples: [
                        "electronMass"
                    ]
                },
                fermiCoupling: {
                    description: "Fermi coupling constant",
                    examples: [
                        "fermiCoupling"
                    ]
                },
                fineStructure: {
                    description: "Fine-structure constant",
                    examples: [
                        "fineStructure"
                    ]
                },
                hartreeEnergy: {
                    description: "Hartree energy",
                    examples: [
                        "hartreeEnergy"
                    ]
                },
                protonMass: {
                    description: "Proton mass",
                    examples: [
                        "protonMass"
                    ]
                },
                deuteronMass: {
                    description: "Deuteron Mass",
                    examples: [
                        "deuteronMass"
                    ]
                },
                neutronMass: {
                    description: "Neutron mass",
                    examples: [
                        "neutronMass"
                    ]
                },
                quantumOfCirculation: {
                    description: "Quantum of circulation",
                    examples: [
                        "quantumOfCirculation"
                    ]
                },
                rydberg: {
                    description: "Rydberg constant",
                    examples: [
                        "rydberg"
                    ]
                },
                thomsonCrossSection: {
                    description: "Thomson cross section",
                    examples: [
                        "thomsonCrossSection"
                    ]
                },
                weakMixingAngle: {
                    description: "Weak mixing angle",
                    examples: [
                        "weakMixingAngle"
                    ]
                },
                efimovFactor: {
                    description: "Efimov factor",
                    examples: [
                        "efimovFactor"
                    ]
                },
                atomicMass: {
                    description: "Atomic mass constant",
                    examples: [
                        "atomicMass"
                    ]
                },
                avogadro: {
                    description: "Avogadro's number",
                    examples: [
                        "avogadro"
                    ]
                },
                boltzmann: {
                    description: "Boltzmann constant",
                    examples: [
                        "boltzmann"
                    ]
                },
                faraday: {
                    description: "Faraday constant",
                    examples: [
                        "faraday"
                    ]
                },
                firstRadiation: {
                    description: "First radiation constant",
                    examples: [
                        "firstRadiation"
                    ]
                },
                loschmidt: {
                    description: "Loschmidt constant at T=273.15 K and p=101.325 kPa",
                    examples: [
                        "loschmidt"
                    ]
                },
                gasConstant: {
                    description: "Gas constant",
                    examples: [
                        "gasConstant"
                    ]
                },
                molarPlanckConstant: {
                    description: "Molar Planck constant",
                    examples: [
                        "molarPlanckConstant"
                    ]
                },
                molarVolume: {
                    description: "Molar volume of an ideal gas at T=273.15 K and p=101.325 kPa",
                    examples: [
                        "molarVolume"
                    ]
                },
                sackurTetrode: {
                    description: "Sackur-Tetrode constant at T=1 K and p=101.325 kPa",
                    examples: [
                        "sackurTetrode"
                    ]
                },
                secondRadiation: {
                    description: "Second radiation constant",
                    examples: [
                        "secondRadiation"
                    ]
                },
                stefanBoltzmann: {
                    description: "Stefan-Boltzmann constant",
                    examples: [
                        "stefanBoltzmann"
                    ]
                },
                wienDisplacement: {
                    description: "Wien displacement law constant",
                    examples: [
                        "wienDisplacement"
                    ]
                },
                molarMass: {
                    description: "Molar mass constant",
                    examples: [
                        "molarMass"
                    ]
                },
                molarMassC12: {
                    description: "Molar mass constant of carbon-12",
                    examples: [
                        "molarMassC12"
                    ]
                },
                gravity: {
                    description: "Standard acceleration of gravity (standard acceleration of free-fall on Earth)",
                    examples: [
                        "gravity"
                    ]
                },
                planckLength: {
                    description: "Planck length",
                    examples: [
                        "planckLength"
                    ]
                },
                planckMass: {
                    description: "Planck mass",
                    examples: [
                        "planckMass"
                    ]
                },
                planckTime: {
                    description: "Planck time",
                    examples: [
                        "planckTime"
                    ]
                },
                planckCharge: {
                    description: "Planck charge",
                    examples: [
                        "planckCharge"
                    ]
                },
                planckTemperature: {
                    description: "Planck temperature",
                    examples: [
                        "planckTemperature"
                    ]
                },
                derivative: {
                    name: "derivative",
                    category: "Algebra",
                    syntax: [
                        "derivative(expr, variable)",
                        "derivative(expr, variable, {simplify: boolean})"
                    ],
                    description: "Takes the derivative of an expression expressed in parser Nodes. The derivative will be taken over the supplied variable in the second parameter. If there are multiple variables in the expression, it will return a partial derivative.",
                    examples: [
                        'derivative("2x^3", "x")',
                        'derivative("2x^3", "x", {simplify: false})',
                        'derivative("2x^2 + 3x + 4", "x")',
                        'derivative("sin(2x)", "x")',
                        'f = parse("x^2 + x")',
                        'x = parse("x")',
                        "df = derivative(f, x)",
                        "df.evaluate({x: 3})"
                    ],
                    seealso: [
                        "simplify",
                        "parse",
                        "evaluate"
                    ]
                },
                lsolve: {
                    name: "lsolve",
                    category: "Algebra",
                    syntax: [
                        "x=lsolve(L, b)"
                    ],
                    description: "Finds one solution of the linear system L * x = b where L is an [n x n] lower triangular matrix and b is a [n] column vector.",
                    examples: [
                        "a = [-2, 3; 2, 1]",
                        "b = [11, 9]",
                        "x = lsolve(a, b)"
                    ],
                    seealso: [
                        "lsolveAll",
                        "lup",
                        "lusolve",
                        "usolve",
                        "matrix",
                        "sparse"
                    ]
                },
                lsolveAll: {
                    name: "lsolveAll",
                    category: "Algebra",
                    syntax: [
                        "x=lsolveAll(L, b)"
                    ],
                    description: "Finds all solutions of the linear system L * x = b where L is an [n x n] lower triangular matrix and b is a [n] column vector.",
                    examples: [
                        "a = [-2, 3; 2, 1]",
                        "b = [11, 9]",
                        "x = lsolve(a, b)"
                    ],
                    seealso: [
                        "lsolve",
                        "lup",
                        "lusolve",
                        "usolve",
                        "matrix",
                        "sparse"
                    ]
                },
                lup: {
                    name: "lup",
                    category: "Algebra",
                    syntax: [
                        "lup(m)"
                    ],
                    description: "Calculate the Matrix LU decomposition with partial pivoting. Matrix A is decomposed in three matrices (L, U, P) where P * A = L * U",
                    examples: [
                        "lup([[2, 1], [1, 4]])",
                        "lup(matrix([[2, 1], [1, 4]]))",
                        "lup(sparse([[2, 1], [1, 4]]))"
                    ],
                    seealso: [
                        "lusolve",
                        "lsolve",
                        "usolve",
                        "matrix",
                        "sparse",
                        "slu",
                        "qr"
                    ]
                },
                lusolve: {
                    name: "lusolve",
                    category: "Algebra",
                    syntax: [
                        "x=lusolve(A, b)",
                        "x=lusolve(lu, b)"
                    ],
                    description: "Solves the linear system A * x = b where A is an [n x n] matrix and b is a [n] column vector.",
                    examples: [
                        "a = [-2, 3; 2, 1]",
                        "b = [11, 9]",
                        "x = lusolve(a, b)"
                    ],
                    seealso: [
                        "lup",
                        "slu",
                        "lsolve",
                        "usolve",
                        "matrix",
                        "sparse"
                    ]
                },
                leafCount: {
                    name: "leafCount",
                    category: "Algebra",
                    syntax: [
                        "leafCount(expr)"
                    ],
                    description: "Computes the number of leaves in the parse tree of the given expression",
                    examples: [
                        'leafCount("e^(i*pi)-1")',
                        'leafCount(parse("{a: 22/7, b: 10^(1/2)}"))'
                    ],
                    seealso: [
                        "simplify"
                    ]
                },
                polynomialRoot: {
                    name: "polynomialRoot",
                    category: "Algebra",
                    syntax: [
                        "x=polynomialRoot(-6, 3)",
                        "x=polynomialRoot(4, -4, 1)",
                        "x=polynomialRoot(-8, 12, -6, 1)"
                    ],
                    description: "Finds the roots of a univariate polynomial given by its coefficients starting from constant, linear, and so on, increasing in degree.",
                    examples: [
                        "a = polynomialRoot(-6, 11, -6, 1)"
                    ],
                    seealso: [
                        "cbrt",
                        "sqrt"
                    ]
                },
                resolve: {
                    name: "resolve",
                    category: "Algebra",
                    syntax: [
                        "resolve(node, scope)"
                    ],
                    description: "Recursively substitute variables in an expression tree.",
                    examples: [
                        'resolve(parse("1 + x"), { x: 7 })',
                        'resolve(parse("size(text)"), { text: "Hello World" })',
                        'resolve(parse("x + y"), { x: parse("3z") })',
                        'resolve(parse("3x"), { x: parse("y+z"), z: parse("w^y") })'
                    ],
                    seealso: [
                        "simplify",
                        "evaluate"
                    ],
                    mayThrow: [
                        "ReferenceError"
                    ]
                },
                simplify: {
                    name: "simplify",
                    category: "Algebra",
                    syntax: [
                        "simplify(expr)",
                        "simplify(expr, rules)"
                    ],
                    description: "Simplify an expression tree.",
                    examples: [
                        'simplify("3 + 2 / 4")',
                        'simplify("2x + x")',
                        'f = parse("x * (x + 2 + x)")',
                        "simplified = simplify(f)",
                        "simplified.evaluate({x: 2})"
                    ],
                    seealso: [
                        "simplifyCore",
                        "derivative",
                        "evaluate",
                        "parse",
                        "rationalize",
                        "resolve"
                    ]
                },
                simplifyConstant: {
                    name: "simplifyConstant",
                    category: "Algebra",
                    syntax: [
                        "simplifyConstant(expr)",
                        "simplifyConstant(expr, options)"
                    ],
                    description: "Replace constant subexpressions of node with their values.",
                    examples: [
                        'simplifyConstant("(3-3)*x")',
                        'simplifyConstant(parse("z-cos(tau/8)"))'
                    ],
                    seealso: [
                        "simplify",
                        "simplifyCore",
                        "evaluate"
                    ]
                },
                simplifyCore: {
                    name: "simplifyCore",
                    category: "Algebra",
                    syntax: [
                        "simplifyCore(node)"
                    ],
                    description: "Perform simple one-pass simplifications on an expression tree.",
                    examples: [
                        'simplifyCore(parse("0*x"))',
                        'simplifyCore(parse("(x+0)*2"))'
                    ],
                    seealso: [
                        "simplify",
                        "simplifyConstant",
                        "evaluate"
                    ]
                },
                symbolicEqual: {
                    name: "symbolicEqual",
                    category: "Algebra",
                    syntax: [
                        "symbolicEqual(expr1, expr2)",
                        "symbolicEqual(expr1, expr2, options)"
                    ],
                    description: "Returns true if the difference of the expressions simplifies to 0",
                    examples: [
                        'symbolicEqual("x*y","y*x")',
                        'symbolicEqual("abs(x^2)", "x^2")',
                        'symbolicEqual("abs(x)", "x", {context: {abs: {trivial: true}}})'
                    ],
                    seealso: [
                        "simplify",
                        "evaluate"
                    ]
                },
                rationalize: {
                    name: "rationalize",
                    category: "Algebra",
                    syntax: [
                        "rationalize(expr)",
                        "rationalize(expr, scope)",
                        "rationalize(expr, scope, detailed)"
                    ],
                    description: "Transform a rationalizable expression in a rational fraction. If rational fraction is one variable polynomial then converts the numerator and denominator in canonical form, with decreasing exponents, returning the coefficients of numerator.",
                    examples: [
                        'rationalize("2x/y - y/(x+1)")',
                        'rationalize("2x/y - y/(x+1)", true)'
                    ],
                    seealso: [
                        "simplify"
                    ]
                },
                slu: {
                    name: "slu",
                    category: "Algebra",
                    syntax: [
                        "slu(A, order, threshold)"
                    ],
                    description: "Calculate the Matrix LU decomposition with full pivoting. Matrix A is decomposed in two matrices (L, U) and two permutation vectors (pinv, q) where P * A * Q = L * U",
                    examples: [
                        "slu(sparse([4.5, 0, 3.2, 0; 3.1, 2.9, 0, 0.9; 0, 1.7, 3, 0; 3.5, 0.4, 0, 1]), 1, 0.001)"
                    ],
                    seealso: [
                        "lusolve",
                        "lsolve",
                        "usolve",
                        "matrix",
                        "sparse",
                        "lup",
                        "qr"
                    ]
                },
                usolve: {
                    name: "usolve",
                    category: "Algebra",
                    syntax: [
                        "x=usolve(U, b)"
                    ],
                    description: "Finds one solution of the linear system U * x = b where U is an [n x n] upper triangular matrix and b is a [n] column vector.",
                    examples: [
                        "x=usolve(sparse([1, 1, 1, 1; 0, 1, 1, 1; 0, 0, 1, 1; 0, 0, 0, 1]), [1; 2; 3; 4])"
                    ],
                    seealso: [
                        "usolveAll",
                        "lup",
                        "lusolve",
                        "lsolve",
                        "matrix",
                        "sparse"
                    ]
                },
                usolveAll: {
                    name: "usolveAll",
                    category: "Algebra",
                    syntax: [
                        "x=usolve(U, b)"
                    ],
                    description: "Finds all solutions of the linear system U * x = b where U is an [n x n] upper triangular matrix and b is a [n] column vector.",
                    examples: [
                        "x=usolve(sparse([1, 1, 1, 1; 0, 1, 1, 1; 0, 0, 1, 1; 0, 0, 0, 1]), [1; 2; 3; 4])"
                    ],
                    seealso: [
                        "usolve",
                        "lup",
                        "lusolve",
                        "lsolve",
                        "matrix",
                        "sparse"
                    ]
                },
                qr: {
                    name: "qr",
                    category: "Algebra",
                    syntax: [
                        "qr(A)"
                    ],
                    description: "Calculates the Matrix QR decomposition. Matrix `A` is decomposed in two matrices (`Q`, `R`) where `Q` is an orthogonal matrix and `R` is an upper triangular matrix.",
                    examples: [
                        "qr([[1, -1,  4], [1,  4, -2], [1,  4,  2], [1,  -1, 0]])"
                    ],
                    seealso: [
                        "lup",
                        "slu",
                        "matrix"
                    ]
                },
                abs: {
                    name: "abs",
                    category: "Arithmetic",
                    syntax: [
                        "abs(x)"
                    ],
                    description: "Compute the absolute value.",
                    examples: [
                        "abs(3.5)",
                        "abs(-4.2)"
                    ],
                    seealso: [
                        "sign"
                    ]
                },
                add: {
                    name: "add",
                    category: "Operators",
                    syntax: [
                        "x + y",
                        "add(x, y)"
                    ],
                    description: "Add two values.",
                    examples: [
                        "a = 2.1 + 3.6",
                        "a - 3.6",
                        "3 + 2i",
                        "3 cm + 2 inch",
                        '"2.3" + "4"'
                    ],
                    seealso: [
                        "subtract"
                    ]
                },
                cbrt: {
                    name: "cbrt",
                    category: "Arithmetic",
                    syntax: [
                        "cbrt(x)",
                        "cbrt(x, allRoots)"
                    ],
                    description: "Compute the cubic root value. If x = y * y * y, then y is the cubic root of x. When `x` is a number or complex number, an optional second argument `allRoots` can be provided to return all three cubic roots. If not provided, the principal root is returned",
                    examples: [
                        "cbrt(64)",
                        "cube(4)",
                        "cbrt(-8)",
                        "cbrt(2 + 3i)",
                        "cbrt(8i)",
                        "cbrt(8i, true)",
                        "cbrt(27 m^3)"
                    ],
                    seealso: [
                        "square",
                        "sqrt",
                        "cube",
                        "multiply"
                    ]
                },
                ceil: {
                    name: "ceil",
                    category: "Arithmetic",
                    syntax: [
                        "ceil(x)"
                    ],
                    description: "Round a value towards plus infinity. If x is complex, both real and imaginary part are rounded towards plus infinity.",
                    examples: [
                        "ceil(3.2)",
                        "ceil(3.8)",
                        "ceil(-4.2)"
                    ],
                    seealso: [
                        "floor",
                        "fix",
                        "round"
                    ]
                },
                cube: {
                    name: "cube",
                    category: "Arithmetic",
                    syntax: [
                        "cube(x)"
                    ],
                    description: "Compute the cube of a value. The cube of x is x * x * x.",
                    examples: [
                        "cube(2)",
                        "2^3",
                        "2 * 2 * 2"
                    ],
                    seealso: [
                        "multiply",
                        "square",
                        "pow"
                    ]
                },
                divide: {
                    name: "divide",
                    category: "Operators",
                    syntax: [
                        "x / y",
                        "divide(x, y)"
                    ],
                    description: "Divide two values.",
                    examples: [
                        "a = 2 / 3",
                        "a * 3",
                        "4.5 / 2",
                        "3 + 4 / 2",
                        "(3 + 4) / 2",
                        "18 km / 4.5"
                    ],
                    seealso: [
                        "multiply"
                    ]
                },
                dotDivide: {
                    name: "dotDivide",
                    category: "Operators",
                    syntax: [
                        "x ./ y",
                        "dotDivide(x, y)"
                    ],
                    description: "Divide two values element wise.",
                    examples: [
                        "a = [1, 2, 3; 4, 5, 6]",
                        "b = [2, 1, 1; 3, 2, 5]",
                        "a ./ b"
                    ],
                    seealso: [
                        "multiply",
                        "dotMultiply",
                        "divide"
                    ]
                },
                dotMultiply: {
                    name: "dotMultiply",
                    category: "Operators",
                    syntax: [
                        "x .* y",
                        "dotMultiply(x, y)"
                    ],
                    description: "Multiply two values element wise.",
                    examples: [
                        "a = [1, 2, 3; 4, 5, 6]",
                        "b = [2, 1, 1; 3, 2, 5]",
                        "a .* b"
                    ],
                    seealso: [
                        "multiply",
                        "divide",
                        "dotDivide"
                    ]
                },
                dotPow: {
                    name: "dotPow",
                    category: "Operators",
                    syntax: [
                        "x .^ y",
                        "dotPow(x, y)"
                    ],
                    description: "Calculates the power of x to y element wise.",
                    examples: [
                        "a = [1, 2, 3; 4, 5, 6]",
                        "a .^ 2"
                    ],
                    seealso: [
                        "pow"
                    ]
                },
                exp: {
                    name: "exp",
                    category: "Arithmetic",
                    syntax: [
                        "exp(x)"
                    ],
                    description: "Calculate the exponent of a value.",
                    examples: [
                        "exp(1.3)",
                        "e ^ 1.3",
                        "log(exp(1.3))",
                        "x = 2.4",
                        "(exp(i*x) == cos(x) + i*sin(x))   # Euler's formula"
                    ],
                    seealso: [
                        "expm",
                        "expm1",
                        "pow",
                        "log"
                    ]
                },
                expm: {
                    name: "expm",
                    category: "Arithmetic",
                    syntax: [
                        "exp(x)"
                    ],
                    description: "Compute the matrix exponential, expm(A) = e^A. The matrix must be square. Not to be confused with exp(a), which performs element-wise exponentiation.",
                    examples: [
                        "expm([[0,2],[0,0]])"
                    ],
                    seealso: [
                        "exp"
                    ]
                },
                expm1: {
                    name: "expm1",
                    category: "Arithmetic",
                    syntax: [
                        "expm1(x)"
                    ],
                    description: "Calculate the value of subtracting 1 from the exponential value.",
                    examples: [
                        "expm1(2)",
                        "pow(e, 2) - 1",
                        "log(expm1(2) + 1)"
                    ],
                    seealso: [
                        "exp",
                        "pow",
                        "log"
                    ]
                },
                fix: {
                    name: "fix",
                    category: "Arithmetic",
                    syntax: [
                        "fix(x)"
                    ],
                    description: "Round a value towards zero. If x is complex, both real and imaginary part are rounded towards zero.",
                    examples: [
                        "fix(3.2)",
                        "fix(3.8)",
                        "fix(-4.2)",
                        "fix(-4.8)"
                    ],
                    seealso: [
                        "ceil",
                        "floor",
                        "round"
                    ]
                },
                floor: {
                    name: "floor",
                    category: "Arithmetic",
                    syntax: [
                        "floor(x)"
                    ],
                    description: "Round a value towards minus infinity.If x is complex, both real and imaginary part are rounded towards minus infinity.",
                    examples: [
                        "floor(3.2)",
                        "floor(3.8)",
                        "floor(-4.2)"
                    ],
                    seealso: [
                        "ceil",
                        "fix",
                        "round"
                    ]
                },
                gcd: {
                    name: "gcd",
                    category: "Arithmetic",
                    syntax: [
                        "gcd(a, b)",
                        "gcd(a, b, c, ...)"
                    ],
                    description: "Compute the greatest common divisor.",
                    examples: [
                        "gcd(8, 12)",
                        "gcd(-4, 6)",
                        "gcd(25, 15, -10)"
                    ],
                    seealso: [
                        "lcm",
                        "xgcd"
                    ]
                },
                hypot: {
                    name: "hypot",
                    category: "Arithmetic",
                    syntax: [
                        "hypot(a, b, c, ...)",
                        "hypot([a, b, c, ...])"
                    ],
                    description: "Calculate the hypotenusa of a list with values. ",
                    examples: [
                        "hypot(3, 4)",
                        "sqrt(3^2 + 4^2)",
                        "hypot(-2)",
                        "hypot([3, 4, 5])"
                    ],
                    seealso: [
                        "abs",
                        "norm"
                    ]
                },
                lcm: {
                    name: "lcm",
                    category: "Arithmetic",
                    syntax: [
                        "lcm(x, y)"
                    ],
                    description: "Compute the least common multiple.",
                    examples: [
                        "lcm(4, 6)",
                        "lcm(6, 21)",
                        "lcm(6, 21, 5)"
                    ],
                    seealso: [
                        "gcd"
                    ]
                },
                log: {
                    name: "log",
                    category: "Arithmetic",
                    syntax: [
                        "log(x)",
                        "log(x, base)"
                    ],
                    description: "Compute the logarithm of a value. If no base is provided, the natural logarithm of x is calculated. If base if provided, the logarithm is calculated for the specified base. log(x, base) is defined as log(x) / log(base).",
                    examples: [
                        "log(3.5)",
                        "a = log(2.4)",
                        "exp(a)",
                        "10 ^ 4",
                        "log(10000, 10)",
                        "log(10000) / log(10)",
                        "b = log(1024, 2)",
                        "2 ^ b"
                    ],
                    seealso: [
                        "exp",
                        "log1p",
                        "log2",
                        "log10"
                    ]
                },
                log2: {
                    name: "log2",
                    category: "Arithmetic",
                    syntax: [
                        "log2(x)"
                    ],
                    description: "Calculate the 2-base of a value. This is the same as calculating `log(x, 2)`.",
                    examples: [
                        "log2(0.03125)",
                        "log2(16)",
                        "log2(16) / log2(2)",
                        "pow(2, 4)"
                    ],
                    seealso: [
                        "exp",
                        "log1p",
                        "log",
                        "log10"
                    ]
                },
                log1p: {
                    name: "log1p",
                    category: "Arithmetic",
                    syntax: [
                        "log1p(x)",
                        "log1p(x, base)"
                    ],
                    description: "Calculate the logarithm of a `value+1`",
                    examples: [
                        "log1p(2.5)",
                        "exp(log1p(1.4))",
                        "pow(10, 4)",
                        "log1p(9999, 10)",
                        "log1p(9999) / log(10)"
                    ],
                    seealso: [
                        "exp",
                        "log",
                        "log2",
                        "log10"
                    ]
                },
                log10: {
                    name: "log10",
                    category: "Arithmetic",
                    syntax: [
                        "log10(x)"
                    ],
                    description: "Compute the 10-base logarithm of a value.",
                    examples: [
                        "log10(0.00001)",
                        "log10(10000)",
                        "10 ^ 4",
                        "log(10000) / log(10)",
                        "log(10000, 10)"
                    ],
                    seealso: [
                        "exp",
                        "log"
                    ]
                },
                mod: {
                    name: "mod",
                    category: "Operators",
                    syntax: [
                        "x % y",
                        "x mod y",
                        "mod(x, y)"
                    ],
                    description: "Calculates the modulus, the remainder of an integer division.",
                    examples: [
                        "7 % 3",
                        "11 % 2",
                        "10 mod 4",
                        "isOdd(x) = x % 2",
                        "isOdd(2)",
                        "isOdd(3)"
                    ],
                    seealso: [
                        "divide"
                    ]
                },
                multiply: {
                    name: "multiply",
                    category: "Operators",
                    syntax: [
                        "x * y",
                        "multiply(x, y)"
                    ],
                    description: "multiply two values.",
                    examples: [
                        "a = 2.1 * 3.4",
                        "a / 3.4",
                        "2 * 3 + 4",
                        "2 * (3 + 4)",
                        "3 * 2.1 km"
                    ],
                    seealso: [
                        "divide"
                    ]
                },
                norm: {
                    name: "norm",
                    category: "Arithmetic",
                    syntax: [
                        "norm(x)",
                        "norm(x, p)"
                    ],
                    description: "Calculate the norm of a number, vector or matrix.",
                    examples: [
                        "abs(-3.5)",
                        "norm(-3.5)",
                        "norm(3 - 4i)",
                        "norm([1, 2, -3], Infinity)",
                        "norm([1, 2, -3], -Infinity)",
                        "norm([3, 4], 2)",
                        "norm([[1, 2], [3, 4]], 1)",
                        'norm([[1, 2], [3, 4]], "inf")',
                        'norm([[1, 2], [3, 4]], "fro")'
                    ]
                },
                nthRoot: {
                    name: "nthRoot",
                    category: "Arithmetic",
                    syntax: [
                        "nthRoot(a)",
                        "nthRoot(a, root)"
                    ],
                    description: 'Calculate the nth root of a value. The principal nth root of a positive real number A, is the positive real solution of the equation "x^root = A".',
                    examples: [
                        "4 ^ 3",
                        "nthRoot(64, 3)",
                        "nthRoot(9, 2)",
                        "sqrt(9)"
                    ],
                    seealso: [
                        "nthRoots",
                        "pow",
                        "sqrt"
                    ]
                },
                nthRoots: {
                    name: "nthRoots",
                    category: "Arithmetic",
                    syntax: [
                        "nthRoots(A)",
                        "nthRoots(A, root)"
                    ],
                    description: 'Calculate the nth roots of a value. An nth root of a positive real number A, is a positive real solution of the equation "x^root = A". This function returns an array of complex values.',
                    examples: [
                        "nthRoots(1)",
                        "nthRoots(1, 3)"
                    ],
                    seealso: [
                        "sqrt",
                        "pow",
                        "nthRoot"
                    ]
                },
                pow: {
                    name: "pow",
                    category: "Operators",
                    syntax: [
                        "x ^ y",
                        "pow(x, y)"
                    ],
                    description: "Calculates the power of x to y, x^y.",
                    examples: [
                        "2^3",
                        "2*2*2",
                        "1 + e ^ (pi * i)",
                        "pow([[1, 2], [4, 3]], 2)",
                        "pow([[1, 2], [4, 3]], -1)"
                    ],
                    seealso: [
                        "multiply",
                        "nthRoot",
                        "nthRoots",
                        "sqrt"
                    ]
                },
                round: {
                    name: "round",
                    category: "Arithmetic",
                    syntax: [
                        "round(x)",
                        "round(x, n)"
                    ],
                    description: "round a value towards the nearest integer.If x is complex, both real and imaginary part are rounded towards the nearest integer. When n is specified, the value is rounded to n decimals.",
                    examples: [
                        "round(3.2)",
                        "round(3.8)",
                        "round(-4.2)",
                        "round(-4.8)",
                        "round(pi, 3)",
                        "round(123.45678, 2)"
                    ],
                    seealso: [
                        "ceil",
                        "floor",
                        "fix"
                    ]
                },
                sign: {
                    name: "sign",
                    category: "Arithmetic",
                    syntax: [
                        "sign(x)"
                    ],
                    description: "Compute the sign of a value. The sign of a value x is 1 when x>1, -1 when x<0, and 0 when x=0.",
                    examples: [
                        "sign(3.5)",
                        "sign(-4.2)",
                        "sign(0)"
                    ],
                    seealso: [
                        "abs"
                    ]
                },
                sqrt: {
                    name: "sqrt",
                    category: "Arithmetic",
                    syntax: [
                        "sqrt(x)"
                    ],
                    description: "Compute the square root value. If x = y * y, then y is the square root of x.",
                    examples: [
                        "sqrt(25)",
                        "5 * 5",
                        "sqrt(-1)"
                    ],
                    seealso: [
                        "square",
                        "sqrtm",
                        "multiply",
                        "nthRoot",
                        "nthRoots",
                        "pow"
                    ]
                },
                sqrtm: {
                    name: "sqrtm",
                    category: "Arithmetic",
                    syntax: [
                        "sqrtm(x)"
                    ],
                    description: "Calculate the principal square root of a square matrix. The principal square root matrix `X` of another matrix `A` is such that `X * X = A`.",
                    examples: [
                        "sqrtm([[33, 24], [48, 57]])"
                    ],
                    seealso: [
                        "sqrt",
                        "abs",
                        "square",
                        "multiply"
                    ]
                },
                square: {
                    name: "square",
                    category: "Arithmetic",
                    syntax: [
                        "square(x)"
                    ],
                    description: "Compute the square of a value. The square of x is x * x.",
                    examples: [
                        "square(3)",
                        "sqrt(9)",
                        "3^2",
                        "3 * 3"
                    ],
                    seealso: [
                        "multiply",
                        "pow",
                        "sqrt",
                        "cube"
                    ]
                },
                subtract: {
                    name: "subtract",
                    category: "Operators",
                    syntax: [
                        "x - y",
                        "subtract(x, y)"
                    ],
                    description: "subtract two values.",
                    examples: [
                        "a = 5.3 - 2",
                        "a + 2",
                        "2/3 - 1/6",
                        "2 * 3 - 3",
                        "2.1 km - 500m"
                    ],
                    seealso: [
                        "add"
                    ]
                },
                unaryMinus: {
                    name: "unaryMinus",
                    category: "Operators",
                    syntax: [
                        "-x",
                        "unaryMinus(x)"
                    ],
                    description: "Inverse the sign of a value. Converts booleans and strings to numbers.",
                    examples: [
                        "-4.5",
                        "-(-5.6)",
                        '-"22"'
                    ],
                    seealso: [
                        "add",
                        "subtract",
                        "unaryPlus"
                    ]
                },
                unaryPlus: {
                    name: "unaryPlus",
                    category: "Operators",
                    syntax: [
                        "+x",
                        "unaryPlus(x)"
                    ],
                    description: "Converts booleans and strings to numbers.",
                    examples: [
                        "+true",
                        '+"2"'
                    ],
                    seealso: [
                        "add",
                        "subtract",
                        "unaryMinus"
                    ]
                },
                xgcd: {
                    name: "xgcd",
                    category: "Arithmetic",
                    syntax: [
                        "xgcd(a, b)"
                    ],
                    description: "Calculate the extended greatest common divisor for two values. The result is an array [d, x, y] with 3 entries, where d is the greatest common divisor, and d = x * a + y * b.",
                    examples: [
                        "xgcd(8, 12)",
                        "gcd(8, 12)",
                        "xgcd(36163, 21199)"
                    ],
                    seealso: [
                        "gcd",
                        "lcm"
                    ]
                },
                invmod: {
                    name: "invmod",
                    category: "Arithmetic",
                    syntax: [
                        "invmod(a, b)"
                    ],
                    description: "Calculate the (modular) multiplicative inverse of a modulo b. Solution to the equation ax \u2263 1 (mod b)",
                    examples: [
                        "invmod(8, 12)",
                        "invmod(7, 13)",
                        "invmod(15151, 15122)"
                    ],
                    seealso: [
                        "gcd",
                        "xgcd"
                    ]
                },
                bitAnd: {
                    name: "bitAnd",
                    category: "Bitwise",
                    syntax: [
                        "x & y",
                        "bitAnd(x, y)"
                    ],
                    description: "Bitwise AND operation. Performs the logical AND operation on each pair of the corresponding bits of the two given values by multiplying them. If both bits in the compared position are 1, the bit in the resulting binary representation is 1, otherwise, the result is 0",
                    examples: [
                        "5 & 3",
                        "bitAnd(53, 131)",
                        "[1, 12, 31] & 42"
                    ],
                    seealso: [
                        "bitNot",
                        "bitOr",
                        "bitXor",
                        "leftShift",
                        "rightArithShift",
                        "rightLogShift"
                    ]
                },
                bitNot: {
                    name: "bitNot",
                    category: "Bitwise",
                    syntax: [
                        "~x",
                        "bitNot(x)"
                    ],
                    description: "Bitwise NOT operation. Performs a logical negation on each bit of the given value. Bits that are 0 become 1, and those that are 1 become 0.",
                    examples: [
                        "~1",
                        "~2",
                        "bitNot([2, -3, 4])"
                    ],
                    seealso: [
                        "bitAnd",
                        "bitOr",
                        "bitXor",
                        "leftShift",
                        "rightArithShift",
                        "rightLogShift"
                    ]
                },
                bitOr: {
                    name: "bitOr",
                    category: "Bitwise",
                    syntax: [
                        "x | y",
                        "bitOr(x, y)"
                    ],
                    description: "Bitwise OR operation. Performs the logical inclusive OR operation on each pair of corresponding bits of the two given values. The result in each position is 1 if the first bit is 1 or the second bit is 1 or both bits are 1, otherwise, the result is 0.",
                    examples: [
                        "5 | 3",
                        "bitOr([1, 2, 3], 4)"
                    ],
                    seealso: [
                        "bitAnd",
                        "bitNot",
                        "bitXor",
                        "leftShift",
                        "rightArithShift",
                        "rightLogShift"
                    ]
                },
                bitXor: {
                    name: "bitXor",
                    category: "Bitwise",
                    syntax: [
                        "bitXor(x, y)"
                    ],
                    description: "Bitwise XOR operation, exclusive OR. Performs the logical exclusive OR operation on each pair of corresponding bits of the two given values. The result in each position is 1 if only the first bit is 1 or only the second bit is 1, but will be 0 if both are 0 or both are 1.",
                    examples: [
                        "bitOr(1, 2)",
                        "bitXor([2, 3, 4], 4)"
                    ],
                    seealso: [
                        "bitAnd",
                        "bitNot",
                        "bitOr",
                        "leftShift",
                        "rightArithShift",
                        "rightLogShift"
                    ]
                },
                leftShift: {
                    name: "leftShift",
                    category: "Bitwise",
                    syntax: [
                        "x << y",
                        "leftShift(x, y)"
                    ],
                    description: "Bitwise left logical shift of a value x by y number of bits.",
                    examples: [
                        "4 << 1",
                        "8 >> 1"
                    ],
                    seealso: [
                        "bitAnd",
                        "bitNot",
                        "bitOr",
                        "bitXor",
                        "rightArithShift",
                        "rightLogShift"
                    ]
                },
                rightArithShift: {
                    name: "rightArithShift",
                    category: "Bitwise",
                    syntax: [
                        "x >> y",
                        "rightArithShift(x, y)"
                    ],
                    description: "Bitwise right arithmetic shift of a value x by y number of bits.",
                    examples: [
                        "8 >> 1",
                        "4 << 1",
                        "-12 >> 2"
                    ],
                    seealso: [
                        "bitAnd",
                        "bitNot",
                        "bitOr",
                        "bitXor",
                        "leftShift",
                        "rightLogShift"
                    ]
                },
                rightLogShift: {
                    name: "rightLogShift",
                    category: "Bitwise",
                    syntax: [
                        "x >>> y",
                        "rightLogShift(x, y)"
                    ],
                    description: "Bitwise right logical shift of a value x by y number of bits.",
                    examples: [
                        "8 >>> 1",
                        "4 << 1",
                        "-12 >>> 2"
                    ],
                    seealso: [
                        "bitAnd",
                        "bitNot",
                        "bitOr",
                        "bitXor",
                        "leftShift",
                        "rightArithShift"
                    ]
                },
                bellNumbers: {
                    name: "bellNumbers",
                    category: "Combinatorics",
                    syntax: [
                        "bellNumbers(n)"
                    ],
                    description: "The Bell Numbers count the number of partitions of a set. A partition is a pairwise disjoint subset of S whose union is S. `bellNumbers` only takes integer arguments. The following condition must be enforced: n >= 0.",
                    examples: [
                        "bellNumbers(3)",
                        "bellNumbers(8)"
                    ],
                    seealso: [
                        "stirlingS2"
                    ]
                },
                catalan: {
                    name: "catalan",
                    category: "Combinatorics",
                    syntax: [
                        "catalan(n)"
                    ],
                    description: "The Catalan Numbers enumerate combinatorial structures of many different types. catalan only takes integer arguments. The following condition must be enforced: n >= 0.",
                    examples: [
                        "catalan(3)",
                        "catalan(8)"
                    ],
                    seealso: [
                        "bellNumbers"
                    ]
                },
                composition: {
                    name: "composition",
                    category: "Combinatorics",
                    syntax: [
                        "composition(n, k)"
                    ],
                    description: "The composition counts of n into k parts. composition only takes integer arguments. The following condition must be enforced: k <= n.",
                    examples: [
                        "composition(5, 3)"
                    ],
                    seealso: [
                        "combinations"
                    ]
                },
                stirlingS2: {
                    name: "stirlingS2",
                    category: "Combinatorics",
                    syntax: [
                        "stirlingS2(n, k)"
                    ],
                    description: "he Stirling numbers of the second kind, counts the number of ways to partition a set of n labelled objects into k nonempty unlabelled subsets. `stirlingS2` only takes integer arguments. The following condition must be enforced: k <= n. If n = k or k = 1, then s(n,k) = 1.",
                    examples: [
                        "stirlingS2(5, 3)"
                    ],
                    seealso: [
                        "bellNumbers"
                    ]
                },
                config: {
                    name: "config",
                    category: "Core",
                    syntax: [
                        "config()",
                        "config(options)"
                    ],
                    description: "Get configuration or change configuration.",
                    examples: [
                        "config()",
                        "1/3 + 1/4",
                        'config({number: "Fraction"})',
                        "1/3 + 1/4"
                    ],
                    seealso: []
                },
                import: {
                    name: "import",
                    category: "Core",
                    syntax: [
                        "import(functions)",
                        "import(functions, options)"
                    ],
                    description: "Import functions or constants from an object.",
                    examples: [
                        "import({myFn: f(x)=x^2, myConstant: 32 })",
                        "myFn(2)",
                        "myConstant"
                    ],
                    seealso: []
                },
                typed: {
                    name: "typed",
                    category: "Core",
                    syntax: [
                        "typed(signatures)",
                        "typed(name, signatures)"
                    ],
                    description: "Create a typed function.",
                    examples: [
                        'double = typed({ "number": f(x)=x+x, "string": f(x)=concat(x,x) })',
                        "double(2)",
                        'double("hello")'
                    ],
                    seealso: []
                },
                arg: {
                    name: "arg",
                    category: "Complex",
                    syntax: [
                        "arg(x)"
                    ],
                    description: "Compute the argument of a complex value. If x = a+bi, the argument is computed as atan2(b, a).",
                    examples: [
                        "arg(2 + 2i)",
                        "atan2(3, 2)",
                        "arg(2 + 3i)"
                    ],
                    seealso: [
                        "re",
                        "im",
                        "conj",
                        "abs"
                    ]
                },
                conj: {
                    name: "conj",
                    category: "Complex",
                    syntax: [
                        "conj(x)"
                    ],
                    description: "Compute the complex conjugate of a complex value. If x = a+bi, the complex conjugate is a-bi.",
                    examples: [
                        "conj(2 + 3i)",
                        "conj(2 - 3i)",
                        "conj(-5.2i)"
                    ],
                    seealso: [
                        "re",
                        "im",
                        "abs",
                        "arg"
                    ]
                },
                re: {
                    name: "re",
                    category: "Complex",
                    syntax: [
                        "re(x)"
                    ],
                    description: "Get the real part of a complex number.",
                    examples: [
                        "re(2 + 3i)",
                        "im(2 + 3i)",
                        "re(-5.2i)",
                        "re(2.4)"
                    ],
                    seealso: [
                        "im",
                        "conj",
                        "abs",
                        "arg"
                    ]
                },
                im: {
                    name: "im",
                    category: "Complex",
                    syntax: [
                        "im(x)"
                    ],
                    description: "Get the imaginary part of a complex number.",
                    examples: [
                        "im(2 + 3i)",
                        "re(2 + 3i)",
                        "im(-5.2i)",
                        "im(2.4)"
                    ],
                    seealso: [
                        "re",
                        "conj",
                        "abs",
                        "arg"
                    ]
                },
                evaluate: {
                    name: "evaluate",
                    category: "Expression",
                    syntax: [
                        "evaluate(expression)",
                        "evaluate(expression, scope)",
                        "evaluate([expr1, expr2, expr3, ...])",
                        "evaluate([expr1, expr2, expr3, ...], scope)"
                    ],
                    description: "Evaluate an expression or an array with expressions.",
                    examples: [
                        'evaluate("2 + 3")',
                        'evaluate("sqrt(16)")',
                        'evaluate("2 inch to cm")',
                        'evaluate("sin(x * pi)", { "x": 1/2 })',
                        'evaluate(["width=2", "height=4","width*height"])'
                    ],
                    seealso: []
                },
                help: {
                    name: "help",
                    category: "Expression",
                    syntax: [
                        "help(object)",
                        "help(string)"
                    ],
                    description: "Display documentation on a function or data type.",
                    examples: [
                        "help(sqrt)",
                        'help("complex")'
                    ],
                    seealso: []
                },
                distance: {
                    name: "distance",
                    category: "Geometry",
                    syntax: [
                        "distance([x1, y1], [x2, y2])",
                        "distance([[x1, y1], [x2, y2]])"
                    ],
                    description: "Calculates the Euclidean distance between two points.",
                    examples: [
                        "distance([0,0], [4,4])",
                        "distance([[0,0], [4,4]])"
                    ],
                    seealso: []
                },
                intersect: {
                    name: "intersect",
                    category: "Geometry",
                    syntax: [
                        "intersect(expr1, expr2, expr3, expr4)",
                        "intersect(expr1, expr2, expr3)"
                    ],
                    description: "Computes the intersection point of lines and/or planes.",
                    examples: [
                        "intersect([0, 0], [10, 10], [10, 0], [0, 10])",
                        "intersect([1, 0, 1],  [4, -2, 2], [1, 1, 1, 6])"
                    ],
                    seealso: []
                },
                and: {
                    name: "and",
                    category: "Logical",
                    syntax: [
                        "x and y",
                        "and(x, y)"
                    ],
                    description: "Logical and. Test whether two values are both defined with a nonzero/nonempty value.",
                    examples: [
                        "true and false",
                        "true and true",
                        "2 and 4"
                    ],
                    seealso: [
                        "not",
                        "or",
                        "xor"
                    ]
                },
                not: {
                    name: "not",
                    category: "Logical",
                    syntax: [
                        "not x",
                        "not(x)"
                    ],
                    description: "Logical not. Flips the boolean value of given argument.",
                    examples: [
                        "not true",
                        "not false",
                        "not 2",
                        "not 0"
                    ],
                    seealso: [
                        "and",
                        "or",
                        "xor"
                    ]
                },
                or: {
                    name: "or",
                    category: "Logical",
                    syntax: [
                        "x or y",
                        "or(x, y)"
                    ],
                    description: "Logical or. Test if at least one value is defined with a nonzero/nonempty value.",
                    examples: [
                        "true or false",
                        "false or false",
                        "0 or 4"
                    ],
                    seealso: [
                        "not",
                        "and",
                        "xor"
                    ]
                },
                xor: {
                    name: "xor",
                    category: "Logical",
                    syntax: [
                        "x xor y",
                        "xor(x, y)"
                    ],
                    description: "Logical exclusive or, xor. Test whether one and only one value is defined with a nonzero/nonempty value.",
                    examples: [
                        "true xor false",
                        "false xor false",
                        "true xor true",
                        "0 xor 4"
                    ],
                    seealso: [
                        "not",
                        "and",
                        "or"
                    ]
                },
                concat: {
                    name: "concat",
                    category: "Matrix",
                    syntax: [
                        "concat(A, B, C, ...)",
                        "concat(A, B, C, ..., dim)"
                    ],
                    description: "Concatenate matrices. By default, the matrices are concatenated by the last dimension. The dimension on which to concatenate can be provided as last argument.",
                    examples: [
                        "A = [1, 2; 5, 6]",
                        "B = [3, 4; 7, 8]",
                        "concat(A, B)",
                        "concat(A, B, 1)",
                        "concat(A, B, 2)"
                    ],
                    seealso: [
                        "det",
                        "diag",
                        "identity",
                        "inv",
                        "ones",
                        "range",
                        "size",
                        "squeeze",
                        "subset",
                        "trace",
                        "transpose",
                        "zeros"
                    ]
                },
                count: {
                    name: "count",
                    category: "Matrix",
                    syntax: [
                        "count(x)"
                    ],
                    description: "Count the number of elements of a matrix, array or string.",
                    examples: [
                        "a = [1, 2; 3, 4; 5, 6]",
                        "count(a)",
                        "size(a)",
                        'count("hello world")'
                    ],
                    seealso: [
                        "size"
                    ]
                },
                cross: {
                    name: "cross",
                    category: "Matrix",
                    syntax: [
                        "cross(A, B)"
                    ],
                    description: "Calculate the cross product for two vectors in three dimensional space.",
                    examples: [
                        "cross([1, 1, 0],  [0, 1, 1])",
                        "cross([3, -3, 1], [4, 9, 2])",
                        "cross([2, 3, 4],  [5, 6, 7])"
                    ],
                    seealso: [
                        "multiply",
                        "dot"
                    ]
                },
                column: {
                    name: "column",
                    category: "Matrix",
                    syntax: [
                        "column(x, index)"
                    ],
                    description: "Return a column from a matrix or array.",
                    examples: [
                        "A = [[1, 2], [3, 4]]",
                        "column(A, 1)",
                        "column(A, 2)"
                    ],
                    seealso: [
                        "row",
                        "matrixFromColumns"
                    ]
                },
                ctranspose: {
                    name: "ctranspose",
                    category: "Matrix",
                    syntax: [
                        "x'",
                        "ctranspose(x)"
                    ],
                    description: "Complex Conjugate and Transpose a matrix",
                    examples: [
                        "a = [1, 2, 3; 4, 5, 6]",
                        "a'",
                        "ctranspose(a)"
                    ],
                    seealso: [
                        "concat",
                        "det",
                        "diag",
                        "identity",
                        "inv",
                        "ones",
                        "range",
                        "size",
                        "squeeze",
                        "subset",
                        "trace",
                        "zeros"
                    ]
                },
                det: {
                    name: "det",
                    category: "Matrix",
                    syntax: [
                        "det(x)"
                    ],
                    description: "Calculate the determinant of a matrix",
                    examples: [
                        "det([1, 2; 3, 4])",
                        "det([-2, 2, 3; -1, 1, 3; 2, 0, -1])"
                    ],
                    seealso: [
                        "concat",
                        "diag",
                        "identity",
                        "inv",
                        "ones",
                        "range",
                        "size",
                        "squeeze",
                        "subset",
                        "trace",
                        "transpose",
                        "zeros"
                    ]
                },
                diag: {
                    name: "diag",
                    category: "Matrix",
                    syntax: [
                        "diag(x)",
                        "diag(x, k)"
                    ],
                    description: "Create a diagonal matrix or retrieve the diagonal of a matrix. When x is a vector, a matrix with the vector values on the diagonal will be returned. When x is a matrix, a vector with the diagonal values of the matrix is returned. When k is provided, the k-th diagonal will be filled in or retrieved, if k is positive, the values are placed on the super diagonal. When k is negative, the values are placed on the sub diagonal.",
                    examples: [
                        "diag(1:3)",
                        "diag(1:3, 1)",
                        "a = [1, 2, 3; 4, 5, 6; 7, 8, 9]",
                        "diag(a)"
                    ],
                    seealso: [
                        "concat",
                        "det",
                        "identity",
                        "inv",
                        "ones",
                        "range",
                        "size",
                        "squeeze",
                        "subset",
                        "trace",
                        "transpose",
                        "zeros"
                    ]
                },
                diff: {
                    name: "diff",
                    category: "Matrix",
                    syntax: [
                        "diff(arr)",
                        "diff(arr, dim)"
                    ],
                    description: [
                        "Create a new matrix or array with the difference of the passed matrix or array.",
                        "Dim parameter is optional and used to indicant the dimension of the array/matrix to apply the difference",
                        "If no dimension parameter is passed it is assumed as dimension 0",
                        "Dimension is zero-based in javascript and one-based in the parser",
                        "Arrays must be 'rectangular' meaning arrays like [1, 2]",
                        "If something is passed as a matrix it will be returned as a matrix but other than that all matrices are converted to arrays"
                    ],
                    examples: [
                        "A = [1, 2, 4, 7, 0]",
                        "diff(A)",
                        "diff(A, 1)",
                        "B = [[1, 2], [3, 4]]",
                        "diff(B)",
                        "diff(B, 1)",
                        "diff(B, 2)",
                        "diff(B, bignumber(2))",
                        "diff([[1, 2], matrix([3, 4])], 2)"
                    ],
                    seealso: [
                        "subtract",
                        "partitionSelect"
                    ]
                },
                dot: {
                    name: "dot",
                    category: "Matrix",
                    syntax: [
                        "dot(A, B)",
                        "A * B"
                    ],
                    description: "Calculate the dot product of two vectors. The dot product of A = [a1, a2, a3, ..., an] and B = [b1, b2, b3, ..., bn] is defined as dot(A, B) = a1 * b1 + a2 * b2 + a3 * b3 + ... + an * bn",
                    examples: [
                        "dot([2, 4, 1], [2, 2, 3])",
                        "[2, 4, 1] * [2, 2, 3]"
                    ],
                    seealso: [
                        "multiply",
                        "cross"
                    ]
                },
                getMatrixDataType: {
                    name: "getMatrixDataType",
                    category: "Matrix",
                    syntax: [
                        "getMatrixDataType(x)"
                    ],
                    description: 'Find the data type of all elements in a matrix or array, for example "number" if all items are a number and "Complex" if all values are complex numbers. If a matrix contains more than one data type, it will return "mixed".',
                    examples: [
                        "getMatrixDataType([1, 2, 3])",
                        "getMatrixDataType([[5 cm], [2 inch]])",
                        'getMatrixDataType([1, "text"])',
                        "getMatrixDataType([1, bignumber(4)])"
                    ],
                    seealso: [
                        "matrix",
                        "sparse",
                        "typeOf"
                    ]
                },
                identity: {
                    name: "identity",
                    category: "Matrix",
                    syntax: [
                        "identity(n)",
                        "identity(m, n)",
                        "identity([m, n])"
                    ],
                    description: "Returns the identity matrix with size m-by-n. The matrix has ones on the diagonal and zeros elsewhere.",
                    examples: [
                        "identity(3)",
                        "identity(3, 5)",
                        "a = [1, 2, 3; 4, 5, 6]",
                        "identity(size(a))"
                    ],
                    seealso: [
                        "concat",
                        "det",
                        "diag",
                        "inv",
                        "ones",
                        "range",
                        "size",
                        "squeeze",
                        "subset",
                        "trace",
                        "transpose",
                        "zeros"
                    ]
                },
                filter: {
                    name: "filter",
                    category: "Matrix",
                    syntax: [
                        "filter(x, test)"
                    ],
                    description: "Filter items in a matrix.",
                    examples: [
                        "isPositive(x) = x > 0",
                        "filter([6, -2, -1, 4, 3], isPositive)",
                        "filter([6, -2, 0, 1, 0], x != 0)"
                    ],
                    seealso: [
                        "sort",
                        "map",
                        "forEach"
                    ]
                },
                flatten: {
                    name: "flatten",
                    category: "Matrix",
                    syntax: [
                        "flatten(x)"
                    ],
                    description: "Flatten a multi dimensional matrix into a single dimensional matrix.",
                    examples: [
                        "a = [1, 2, 3; 4, 5, 6]",
                        "size(a)",
                        "b = flatten(a)",
                        "size(b)"
                    ],
                    seealso: [
                        "concat",
                        "resize",
                        "size",
                        "squeeze"
                    ]
                },
                forEach: {
                    name: "forEach",
                    category: "Matrix",
                    syntax: [
                        "forEach(x, callback)"
                    ],
                    description: "Iterates over all elements of a matrix/array, and executes the given callback function.",
                    examples: [
                        "numberOfPets = {}",
                        "addPet(n) = numberOfPets[n] = (numberOfPets[n] ? numberOfPets[n]:0 ) + 1;",
                        'forEach(["Dog","Cat","Cat"], addPet)',
                        "numberOfPets"
                    ],
                    seealso: [
                        "map",
                        "sort",
                        "filter"
                    ]
                },
                inv: {
                    name: "inv",
                    category: "Matrix",
                    syntax: [
                        "inv(x)"
                    ],
                    description: "Calculate the inverse of a matrix",
                    examples: [
                        "inv([1, 2; 3, 4])",
                        "inv(4)",
                        "1 / 4"
                    ],
                    seealso: [
                        "concat",
                        "det",
                        "diag",
                        "identity",
                        "ones",
                        "range",
                        "size",
                        "squeeze",
                        "subset",
                        "trace",
                        "transpose",
                        "zeros"
                    ]
                },
                pinv: {
                    name: "pinv",
                    category: "Matrix",
                    syntax: [
                        "pinv(x)"
                    ],
                    description: "Calculate the Moore\u2013Penrose inverse of a matrix",
                    examples: [
                        "pinv([1, 2; 3, 4])",
                        "pinv([[1, 0], [0, 1], [0, 1]])",
                        "pinv(4)"
                    ],
                    seealso: [
                        "inv"
                    ]
                },
                eigs: {
                    name: "eigs",
                    category: "Matrix",
                    syntax: [
                        "eigs(x)"
                    ],
                    description: "Calculate the eigenvalues and eigenvectors of a real symmetric matrix",
                    examples: [
                        "eigs([[5, 2.3], [2.3, 1]])"
                    ],
                    seealso: [
                        "inv"
                    ]
                },
                kron: {
                    name: "kron",
                    category: "Matrix",
                    syntax: [
                        "kron(x, y)"
                    ],
                    description: "Calculates the kronecker product of 2 matrices or vectors.",
                    examples: [
                        "kron([[1, 0], [0, 1]], [[1, 2], [3, 4]])",
                        "kron([1,1], [2,3,4])"
                    ],
                    seealso: [
                        "multiply",
                        "dot",
                        "cross"
                    ]
                },
                matrixFromFunction: {
                    name: "matrixFromFunction",
                    category: "Matrix",
                    syntax: [
                        "matrixFromFunction(size, fn)",
                        "matrixFromFunction(size, fn, format)",
                        "matrixFromFunction(size, fn, format, datatype)",
                        "matrixFromFunction(size, format, fn)",
                        "matrixFromFunction(size, format, datatype, fn)"
                    ],
                    description: "Create a matrix by evaluating a generating function at each index.",
                    examples: [
                        "f(I) = I[1] - I[2]",
                        "matrixFromFunction([3,3], f)",
                        "g(I) = I[1] - I[2] == 1 ? 4 : 0",
                        'matrixFromFunction([100, 100], "sparse", g)',
                        "matrixFromFunction([5], random)"
                    ],
                    seealso: [
                        "matrix",
                        "matrixFromRows",
                        "matrixFromColumns",
                        "zeros"
                    ]
                },
                matrixFromRows: {
                    name: "matrixFromRows",
                    category: "Matrix",
                    syntax: [
                        "matrixFromRows(...arr)",
                        "matrixFromRows(row1, row2)",
                        "matrixFromRows(row1, row2, row3)"
                    ],
                    description: "Create a dense matrix from vectors as individual rows.",
                    examples: [
                        "matrixFromRows([1, 2, 3], [[4],[5],[6]])"
                    ],
                    seealso: [
                        "matrix",
                        "matrixFromColumns",
                        "matrixFromFunction",
                        "zeros"
                    ]
                },
                matrixFromColumns: {
                    name: "matrixFromColumns",
                    category: "Matrix",
                    syntax: [
                        "matrixFromColumns(...arr)",
                        "matrixFromColumns(row1, row2)",
                        "matrixFromColumns(row1, row2, row3)"
                    ],
                    description: "Create a dense matrix from vectors as individual columns.",
                    examples: [
                        "matrixFromColumns([1, 2, 3], [[4],[5],[6]])"
                    ],
                    seealso: [
                        "matrix",
                        "matrixFromRows",
                        "matrixFromFunction",
                        "zeros"
                    ]
                },
                map: {
                    name: "map",
                    category: "Matrix",
                    syntax: [
                        "map(x, callback)"
                    ],
                    description: "Create a new matrix or array with the results of the callback function executed on each entry of the matrix/array.",
                    examples: [
                        "map([1, 2, 3], square)"
                    ],
                    seealso: [
                        "filter",
                        "forEach"
                    ]
                },
                ones: {
                    name: "ones",
                    category: "Matrix",
                    syntax: [
                        "ones(m)",
                        "ones(m, n)",
                        "ones(m, n, p, ...)",
                        "ones([m])",
                        "ones([m, n])",
                        "ones([m, n, p, ...])"
                    ],
                    description: "Create a matrix containing ones.",
                    examples: [
                        "ones(3)",
                        "ones(3, 5)",
                        "ones([2,3]) * 4.5",
                        "a = [1, 2, 3; 4, 5, 6]",
                        "ones(size(a))"
                    ],
                    seealso: [
                        "concat",
                        "det",
                        "diag",
                        "identity",
                        "inv",
                        "range",
                        "size",
                        "squeeze",
                        "subset",
                        "trace",
                        "transpose",
                        "zeros"
                    ]
                },
                partitionSelect: {
                    name: "partitionSelect",
                    category: "Matrix",
                    syntax: [
                        "partitionSelect(x, k)",
                        "partitionSelect(x, k, compare)"
                    ],
                    description: "Partition-based selection of an array or 1D matrix. Will find the kth smallest value, and mutates the input array. Uses Quickselect.",
                    examples: [
                        "partitionSelect([5, 10, 1], 2)",
                        'partitionSelect(["C", "B", "A", "D"], 1, compareText)',
                        "arr = [5, 2, 1]",
                        "partitionSelect(arr, 0) # returns 1, arr is now: [1, 2, 5]",
                        "arr",
                        "partitionSelect(arr, 1, 'desc') # returns 2, arr is now: [5, 2, 1]",
                        "arr"
                    ],
                    seealso: [
                        "sort"
                    ]
                },
                range: {
                    name: "range",
                    category: "Type",
                    syntax: [
                        "start:end",
                        "start:step:end",
                        "range(start, end)",
                        "range(start, end, step)",
                        "range(string)"
                    ],
                    description: "Create a range. Lower bound of the range is included, upper bound is excluded.",
                    examples: [
                        "1:5",
                        "3:-1:-3",
                        "range(3, 7)",
                        "range(0, 12, 2)",
                        'range("4:10")',
                        "range(1m, 1m, 3m)",
                        "a = [1, 2, 3, 4; 5, 6, 7, 8]",
                        "a[1:2, 1:2]"
                    ],
                    seealso: [
                        "concat",
                        "det",
                        "diag",
                        "identity",
                        "inv",
                        "ones",
                        "size",
                        "squeeze",
                        "subset",
                        "trace",
                        "transpose",
                        "zeros"
                    ]
                },
                resize: {
                    name: "resize",
                    category: "Matrix",
                    syntax: [
                        "resize(x, size)",
                        "resize(x, size, defaultValue)"
                    ],
                    description: "Resize a matrix.",
                    examples: [
                        "resize([1,2,3,4,5], [3])",
                        "resize([1,2,3], [5])",
                        "resize([1,2,3], [5], -1)",
                        "resize(2, [2, 3])",
                        'resize("hello", [8], "!")'
                    ],
                    seealso: [
                        "size",
                        "subset",
                        "squeeze",
                        "reshape"
                    ]
                },
                reshape: {
                    name: "reshape",
                    category: "Matrix",
                    syntax: [
                        "reshape(x, sizes)"
                    ],
                    description: "Reshape a multi dimensional array to fit the specified dimensions.",
                    examples: [
                        "reshape([1, 2, 3, 4, 5, 6], [2, 3])",
                        "reshape([[1, 2], [3, 4]], [1, 4])",
                        "reshape([[1, 2], [3, 4]], [4])",
                        "reshape([1, 2, 3, 4], [-1, 2])"
                    ],
                    seealso: [
                        "size",
                        "squeeze",
                        "resize"
                    ]
                },
                rotate: {
                    name: "rotate",
                    category: "Matrix",
                    syntax: [
                        "rotate(w, theta)",
                        "rotate(w, theta, v)"
                    ],
                    description: "Returns a 2-D rotation matrix (2x2) for a given angle (in radians). Returns a 2-D rotation matrix (3x3) of a given angle (in radians) around given axis.",
                    examples: [
                        "rotate([1, 0], pi / 2)",
                        'rotate(matrix([1, 0]), unit("35deg"))',
                        'rotate([1, 0, 0], unit("90deg"), [0, 0, 1])',
                        'rotate(matrix([1, 0, 0]), unit("90deg"), matrix([0, 0, 1]))'
                    ],
                    seealso: [
                        "matrix",
                        "rotationMatrix"
                    ]
                },
                rotationMatrix: {
                    name: "rotationMatrix",
                    category: "Matrix",
                    syntax: [
                        "rotationMatrix(theta)",
                        "rotationMatrix(theta, v)",
                        "rotationMatrix(theta, v, format)"
                    ],
                    description: "Returns a 2-D rotation matrix (2x2) for a given angle (in radians). Returns a 2-D rotation matrix (3x3) of a given angle (in radians) around given axis.",
                    examples: [
                        "rotationMatrix(pi / 2)",
                        'rotationMatrix(unit("45deg"), [0, 0, 1])',
                        'rotationMatrix(1, matrix([0, 0, 1]), "sparse")'
                    ],
                    seealso: [
                        "cos",
                        "sin"
                    ]
                },
                row: {
                    name: "row",
                    category: "Matrix",
                    syntax: [
                        "row(x, index)"
                    ],
                    description: "Return a row from a matrix or array.",
                    examples: [
                        "A = [[1, 2], [3, 4]]",
                        "row(A, 1)",
                        "row(A, 2)"
                    ],
                    seealso: [
                        "column",
                        "matrixFromRows"
                    ]
                },
                size: {
                    name: "size",
                    category: "Matrix",
                    syntax: [
                        "size(x)"
                    ],
                    description: "Calculate the size of a matrix.",
                    examples: [
                        "size(2.3)",
                        'size("hello world")',
                        "a = [1, 2; 3, 4; 5, 6]",
                        "size(a)",
                        "size(1:6)"
                    ],
                    seealso: [
                        "concat",
                        "count",
                        "det",
                        "diag",
                        "identity",
                        "inv",
                        "ones",
                        "range",
                        "squeeze",
                        "subset",
                        "trace",
                        "transpose",
                        "zeros"
                    ]
                },
                sort: {
                    name: "sort",
                    category: "Matrix",
                    syntax: [
                        "sort(x)",
                        "sort(x, compare)"
                    ],
                    description: 'Sort the items in a matrix. Compare can be a string "asc", "desc", "natural", or a custom sort function.',
                    examples: [
                        "sort([5, 10, 1])",
                        'sort(["C", "B", "A", "D"], "natural")',
                        "sortByLength(a, b) = size(a)[1] - size(b)[1]",
                        'sort(["Langdon", "Tom", "Sara"], sortByLength)',
                        'sort(["10", "1", "2"], "natural")'
                    ],
                    seealso: [
                        "map",
                        "filter",
                        "forEach"
                    ]
                },
                squeeze: {
                    name: "squeeze",
                    category: "Matrix",
                    syntax: [
                        "squeeze(x)"
                    ],
                    description: "Remove inner and outer singleton dimensions from a matrix.",
                    examples: [
                        "a = zeros(3,2,1)",
                        "size(squeeze(a))",
                        "b = zeros(1,1,3)",
                        "size(squeeze(b))"
                    ],
                    seealso: [
                        "concat",
                        "det",
                        "diag",
                        "identity",
                        "inv",
                        "ones",
                        "range",
                        "size",
                        "subset",
                        "trace",
                        "transpose",
                        "zeros"
                    ]
                },
                subset: {
                    name: "subset",
                    category: "Matrix",
                    syntax: [
                        "value(index)",
                        "value(index) = replacement",
                        "subset(value, [index])",
                        "subset(value, [index], replacement)"
                    ],
                    description: "Get or set a subset of the entries of a matrix or characters of a string. Indexes are one-based. There should be one index specification for each dimension of the target. Each specification can be a single index, a list of indices, or a range in colon notation `l:u`. In a range, both the lower bound l and upper bound u are included; and if a bound is omitted it defaults to the most extreme valid value. The cartesian product of the indices specified in each dimension determines the target of the operation.",
                    examples: [
                        "d = [1, 2; 3, 4]",
                        "e = []",
                        "e[1, 1:2] = [5, 6]",
                        "e[2, :] = [7, 8]",
                        "f = d * e",
                        "f[2, 1]",
                        "f[:, 1]",
                        "f[[1,2], [1,3]] = [9, 10; 11, 12]",
                        "f"
                    ],
                    seealso: [
                        "concat",
                        "det",
                        "diag",
                        "identity",
                        "inv",
                        "ones",
                        "range",
                        "size",
                        "squeeze",
                        "trace",
                        "transpose",
                        "zeros"
                    ]
                },
                trace: {
                    name: "trace",
                    category: "Matrix",
                    syntax: [
                        "trace(A)"
                    ],
                    description: "Calculate the trace of a matrix: the sum of the elements on the main diagonal of a square matrix.",
                    examples: [
                        "A = [1, 2, 3; -1, 2, 3; 2, 0, 3]",
                        "trace(A)"
                    ],
                    seealso: [
                        "concat",
                        "det",
                        "diag",
                        "identity",
                        "inv",
                        "ones",
                        "range",
                        "size",
                        "squeeze",
                        "subset",
                        "transpose",
                        "zeros"
                    ]
                },
                transpose: {
                    name: "transpose",
                    category: "Matrix",
                    syntax: [
                        "x'",
                        "transpose(x)"
                    ],
                    description: "Transpose a matrix",
                    examples: [
                        "a = [1, 2, 3; 4, 5, 6]",
                        "a'",
                        "transpose(a)"
                    ],
                    seealso: [
                        "concat",
                        "det",
                        "diag",
                        "identity",
                        "inv",
                        "ones",
                        "range",
                        "size",
                        "squeeze",
                        "subset",
                        "trace",
                        "zeros"
                    ]
                },
                zeros: {
                    name: "zeros",
                    category: "Matrix",
                    syntax: [
                        "zeros(m)",
                        "zeros(m, n)",
                        "zeros(m, n, p, ...)",
                        "zeros([m])",
                        "zeros([m, n])",
                        "zeros([m, n, p, ...])"
                    ],
                    description: "Create a matrix containing zeros.",
                    examples: [
                        "zeros(3)",
                        "zeros(3, 5)",
                        "a = [1, 2, 3; 4, 5, 6]",
                        "zeros(size(a))"
                    ],
                    seealso: [
                        "concat",
                        "det",
                        "diag",
                        "identity",
                        "inv",
                        "ones",
                        "range",
                        "size",
                        "squeeze",
                        "subset",
                        "trace",
                        "transpose"
                    ]
                },
                fft: {
                    name: "fft",
                    category: "Matrix",
                    syntax: [
                        "fft(x)"
                    ],
                    description: "Calculate N-dimensional fourier transform",
                    examples: [
                        "fft([[1, 0], [1, 0]])"
                    ],
                    seealso: [
                        "ifft"
                    ]
                },
                ifft: {
                    name: "ifft",
                    category: "Matrix",
                    syntax: [
                        "ifft(x)"
                    ],
                    description: "Calculate N-dimensional inverse fourier transform",
                    examples: [
                        "ifft([[2, 2], [0, 0]])"
                    ],
                    seealso: [
                        "fft"
                    ]
                },
                sylvester: {
                    name: "sylvester",
                    category: "Algebra",
                    syntax: [
                        "sylvester(A,B,C)"
                    ],
                    description: "Solves the real-valued Sylvester equation AX+XB=C for X",
                    examples: [
                        "sylvester([[-1, -2], [1, 1]], [[-2, 1], [-1, 2]], [[-3, 2], [3, 0]])",
                        "A = [[-1, -2], [1, 1]]; B = [[2, -1], [1, -2]]; C = [[-3, 2], [3, 0]]",
                        "sylvester(A, B, C)"
                    ],
                    seealso: [
                        "schur",
                        "lyap"
                    ]
                },
                schur: {
                    name: "schur",
                    category: "Algebra",
                    syntax: [
                        "schur(A)"
                    ],
                    description: "Performs a real Schur decomposition of the real matrix A = UTU'",
                    examples: [
                        "schur([[1, 0], [-4, 3]])",
                        "A = [[1, 0], [-4, 3]]",
                        "schur(A)"
                    ],
                    seealso: [
                        "lyap",
                        "sylvester"
                    ]
                },
                lyap: {
                    name: "lyap",
                    category: "Algebra",
                    syntax: [
                        "lyap(A,Q)"
                    ],
                    description: "Solves the Continuous-time Lyapunov equation AP+PA'+Q=0 for P",
                    examples: [
                        "lyap([[-2, 0], [1, -4]], [[3, 1], [1, 3]])",
                        "A = [[-2, 0], [1, -4]]",
                        "Q = [[3, 1], [1, 3]]",
                        "lyap(A,Q)"
                    ],
                    seealso: [
                        "schur",
                        "sylvester"
                    ]
                },
                solveODE: {
                    name: "solveODE",
                    category: "Numeric",
                    syntax: [
                        "solveODE(func, tspan, y0)",
                        "solveODE(func, tspan, y0, options)"
                    ],
                    description: "Numerical Integration of Ordinary Differential Equations.",
                    examples: [
                        "f(t,y) = y",
                        "tspan = [0, 4]",
                        "solveODE(f, tspan, 1)",
                        "solveODE(f, tspan, [1, 2])",
                        'solveODE(f, tspan, 1, { method:"RK23", maxStep:0.1 })'
                    ],
                    seealso: [
                        "derivative",
                        "simplifyCore"
                    ]
                },
                combinations: {
                    name: "combinations",
                    category: "Probability",
                    syntax: [
                        "combinations(n, k)"
                    ],
                    description: "Compute the number of combinations of n items taken k at a time",
                    examples: [
                        "combinations(7, 5)"
                    ],
                    seealso: [
                        "combinationsWithRep",
                        "permutations",
                        "factorial"
                    ]
                },
                combinationsWithRep: {
                    name: "combinationsWithRep",
                    category: "Probability",
                    syntax: [
                        "combinationsWithRep(n, k)"
                    ],
                    description: "Compute the number of combinations of n items taken k at a time with replacements.",
                    examples: [
                        "combinationsWithRep(7, 5)"
                    ],
                    seealso: [
                        "combinations",
                        "permutations",
                        "factorial"
                    ]
                },
                factorial: {
                    name: "factorial",
                    category: "Probability",
                    syntax: [
                        "n!",
                        "factorial(n)"
                    ],
                    description: "Compute the factorial of a value",
                    examples: [
                        "5!",
                        "5 * 4 * 3 * 2 * 1",
                        "3!"
                    ],
                    seealso: [
                        "combinations",
                        "combinationsWithRep",
                        "permutations",
                        "gamma"
                    ]
                },
                gamma: {
                    name: "gamma",
                    category: "Probability",
                    syntax: [
                        "gamma(n)"
                    ],
                    description: "Compute the gamma function. For small values, the Lanczos approximation is used, and for large values the extended Stirling approximation.",
                    examples: [
                        "gamma(4)",
                        "3!",
                        "gamma(1/2)",
                        "sqrt(pi)"
                    ],
                    seealso: [
                        "factorial"
                    ]
                },
                kldivergence: {
                    name: "kldivergence",
                    category: "Probability",
                    syntax: [
                        "kldivergence(x, y)"
                    ],
                    description: "Calculate the Kullback-Leibler (KL) divergence  between two distributions.",
                    examples: [
                        "kldivergence([0.7,0.5,0.4], [0.2,0.9,0.5])"
                    ],
                    seealso: []
                },
                lgamma: {
                    name: "lgamma",
                    category: "Probability",
                    syntax: [
                        "lgamma(n)"
                    ],
                    description: "Logarithm of the gamma function for real, positive numbers and complex numbers, using Lanczos approximation for numbers and Stirling series for complex numbers.",
                    examples: [
                        "lgamma(4)",
                        "lgamma(1/2)",
                        "lgamma(i)",
                        "lgamma(complex(1.1, 2))"
                    ],
                    seealso: [
                        "gamma"
                    ]
                },
                multinomial: {
                    name: "multinomial",
                    category: "Probability",
                    syntax: [
                        "multinomial(A)"
                    ],
                    description: "Multinomial Coefficients compute the number of ways of picking a1, a2, ..., ai unordered outcomes from `n` possibilities. multinomial takes one array of integers as an argument. The following condition must be enforced: every ai > 0.",
                    examples: [
                        "multinomial([1, 2, 1])"
                    ],
                    seealso: [
                        "combinations",
                        "factorial"
                    ]
                },
                permutations: {
                    name: "permutations",
                    category: "Probability",
                    syntax: [
                        "permutations(n)",
                        "permutations(n, k)"
                    ],
                    description: "Compute the number of permutations of n items taken k at a time",
                    examples: [
                        "permutations(5)",
                        "permutations(5, 3)"
                    ],
                    seealso: [
                        "combinations",
                        "combinationsWithRep",
                        "factorial"
                    ]
                },
                pickRandom: {
                    name: "pickRandom",
                    category: "Probability",
                    syntax: [
                        "pickRandom(array)",
                        "pickRandom(array, number)",
                        "pickRandom(array, weights)",
                        "pickRandom(array, number, weights)",
                        "pickRandom(array, weights, number)"
                    ],
                    description: "Pick a random entry from a given array.",
                    examples: [
                        "pickRandom(0:10)",
                        "pickRandom([1, 3, 1, 6])",
                        "pickRandom([1, 3, 1, 6], 2)",
                        "pickRandom([1, 3, 1, 6], [2, 3, 2, 1])",
                        "pickRandom([1, 3, 1, 6], 2, [2, 3, 2, 1])",
                        "pickRandom([1, 3, 1, 6], [2, 3, 2, 1], 2)"
                    ],
                    seealso: [
                        "random",
                        "randomInt"
                    ]
                },
                random: {
                    name: "random",
                    category: "Probability",
                    syntax: [
                        "random()",
                        "random(max)",
                        "random(min, max)",
                        "random(size)",
                        "random(size, max)",
                        "random(size, min, max)"
                    ],
                    description: "Return a random number.",
                    examples: [
                        "random()",
                        "random(10, 20)",
                        "random([2, 3])"
                    ],
                    seealso: [
                        "pickRandom",
                        "randomInt"
                    ]
                },
                randomInt: {
                    name: "randomInt",
                    category: "Probability",
                    syntax: [
                        "randomInt(max)",
                        "randomInt(min, max)",
                        "randomInt(size)",
                        "randomInt(size, max)",
                        "randomInt(size, min, max)"
                    ],
                    description: "Return a random integer number",
                    examples: [
                        "randomInt(10, 20)",
                        "randomInt([2, 3], 10)"
                    ],
                    seealso: [
                        "pickRandom",
                        "random"
                    ]
                },
                compare: {
                    name: "compare",
                    category: "Relational",
                    syntax: [
                        "compare(x, y)"
                    ],
                    description: "Compare two values. Returns 1 when x > y, -1 when x < y, and 0 when x == y.",
                    examples: [
                        "compare(2, 3)",
                        "compare(3, 2)",
                        "compare(2, 2)",
                        "compare(5cm, 40mm)",
                        "compare(2, [1, 2, 3])"
                    ],
                    seealso: [
                        "equal",
                        "unequal",
                        "smaller",
                        "smallerEq",
                        "largerEq",
                        "compareNatural",
                        "compareText"
                    ]
                },
                compareNatural: {
                    name: "compareNatural",
                    category: "Relational",
                    syntax: [
                        "compareNatural(x, y)"
                    ],
                    description: "Compare two values of any type in a deterministic, natural way. Returns 1 when x > y, -1 when x < y, and 0 when x == y.",
                    examples: [
                        "compareNatural(2, 3)",
                        "compareNatural(3, 2)",
                        "compareNatural(2, 2)",
                        "compareNatural(5cm, 40mm)",
                        'compareNatural("2", "10")',
                        "compareNatural(2 + 3i, 2 + 4i)",
                        "compareNatural([1, 2, 4], [1, 2, 3])",
                        "compareNatural([1, 5], [1, 2, 3])",
                        "compareNatural([1, 2], [1, 2])",
                        "compareNatural({a: 2}, {a: 4})"
                    ],
                    seealso: [
                        "equal",
                        "unequal",
                        "smaller",
                        "smallerEq",
                        "largerEq",
                        "compare",
                        "compareText"
                    ]
                },
                compareText: {
                    name: "compareText",
                    category: "Relational",
                    syntax: [
                        "compareText(x, y)"
                    ],
                    description: "Compare two strings lexically. Comparison is case sensitive. Returns 1 when x > y, -1 when x < y, and 0 when x == y.",
                    examples: [
                        'compareText("B", "A")',
                        'compareText("A", "B")',
                        'compareText("A", "A")',
                        'compareText("2", "10")',
                        'compare("2", "10")',
                        "compare(2, 10)",
                        'compareNatural("2", "10")',
                        'compareText("B", ["A", "B", "C"])'
                    ],
                    seealso: [
                        "compare",
                        "compareNatural"
                    ]
                },
                deepEqual: {
                    name: "deepEqual",
                    category: "Relational",
                    syntax: [
                        "deepEqual(x, y)"
                    ],
                    description: "Check equality of two matrices element wise. Returns true if the size of both matrices is equal and when and each of the elements are equal.",
                    examples: [
                        "deepEqual([1,3,4], [1,3,4])",
                        "deepEqual([1,3,4], [1,3])"
                    ],
                    seealso: [
                        "equal",
                        "unequal",
                        "smaller",
                        "larger",
                        "smallerEq",
                        "largerEq",
                        "compare"
                    ]
                },
                equal: {
                    name: "equal",
                    category: "Relational",
                    syntax: [
                        "x == y",
                        "equal(x, y)"
                    ],
                    description: "Check equality of two values. Returns true if the values are equal, and false if not.",
                    examples: [
                        "2+2 == 3",
                        "2+2 == 4",
                        "a = 3.2",
                        "b = 6-2.8",
                        "a == b",
                        "50cm == 0.5m"
                    ],
                    seealso: [
                        "unequal",
                        "smaller",
                        "larger",
                        "smallerEq",
                        "largerEq",
                        "compare",
                        "deepEqual",
                        "equalText"
                    ]
                },
                equalText: {
                    name: "equalText",
                    category: "Relational",
                    syntax: [
                        "equalText(x, y)"
                    ],
                    description: "Check equality of two strings. Comparison is case sensitive. Returns true if the values are equal, and false if not.",
                    examples: [
                        'equalText("Hello", "Hello")',
                        'equalText("a", "A")',
                        'equal("2e3", "2000")',
                        'equalText("2e3", "2000")',
                        'equalText("B", ["A", "B", "C"])'
                    ],
                    seealso: [
                        "compare",
                        "compareNatural",
                        "compareText",
                        "equal"
                    ]
                },
                larger: {
                    name: "larger",
                    category: "Relational",
                    syntax: [
                        "x > y",
                        "larger(x, y)"
                    ],
                    description: "Check if value x is larger than y. Returns true if x is larger than y, and false if not.",
                    examples: [
                        "2 > 3",
                        "5 > 2*2",
                        "a = 3.3",
                        "b = 6-2.8",
                        "(a > b)",
                        "(b < a)",
                        "5 cm > 2 inch"
                    ],
                    seealso: [
                        "equal",
                        "unequal",
                        "smaller",
                        "smallerEq",
                        "largerEq",
                        "compare"
                    ]
                },
                largerEq: {
                    name: "largerEq",
                    category: "Relational",
                    syntax: [
                        "x >= y",
                        "largerEq(x, y)"
                    ],
                    description: "Check if value x is larger or equal to y. Returns true if x is larger or equal to y, and false if not.",
                    examples: [
                        "2 >= 1+1",
                        "2 > 1+1",
                        "a = 3.2",
                        "b = 6-2.8",
                        "(a >= b)"
                    ],
                    seealso: [
                        "equal",
                        "unequal",
                        "smallerEq",
                        "smaller",
                        "compare"
                    ]
                },
                smaller: {
                    name: "smaller",
                    category: "Relational",
                    syntax: [
                        "x < y",
                        "smaller(x, y)"
                    ],
                    description: "Check if value x is smaller than value y. Returns true if x is smaller than y, and false if not.",
                    examples: [
                        "2 < 3",
                        "5 < 2*2",
                        "a = 3.3",
                        "b = 6-2.8",
                        "(a < b)",
                        "5 cm < 2 inch"
                    ],
                    seealso: [
                        "equal",
                        "unequal",
                        "larger",
                        "smallerEq",
                        "largerEq",
                        "compare"
                    ]
                },
                smallerEq: {
                    name: "smallerEq",
                    category: "Relational",
                    syntax: [
                        "x <= y",
                        "smallerEq(x, y)"
                    ],
                    description: "Check if value x is smaller or equal to value y. Returns true if x is smaller than y, and false if not.",
                    examples: [
                        "2 <= 1+1",
                        "2 < 1+1",
                        "a = 3.2",
                        "b = 6-2.8",
                        "(a <= b)"
                    ],
                    seealso: [
                        "equal",
                        "unequal",
                        "larger",
                        "smaller",
                        "largerEq",
                        "compare"
                    ]
                },
                unequal: {
                    name: "unequal",
                    category: "Relational",
                    syntax: [
                        "x != y",
                        "unequal(x, y)"
                    ],
                    description: "Check unequality of two values. Returns true if the values are unequal, and false if they are equal.",
                    examples: [
                        "2+2 != 3",
                        "2+2 != 4",
                        "a = 3.2",
                        "b = 6-2.8",
                        "a != b",
                        "50cm != 0.5m",
                        "5 cm != 2 inch"
                    ],
                    seealso: [
                        "equal",
                        "smaller",
                        "larger",
                        "smallerEq",
                        "largerEq",
                        "compare",
                        "deepEqual"
                    ]
                },
                setCartesian: {
                    name: "setCartesian",
                    category: "Set",
                    syntax: [
                        "setCartesian(set1, set2)"
                    ],
                    description: "Create the cartesian product of two (multi)sets. Multi-dimension arrays will be converted to single-dimension arrays and the values will be sorted in ascending order before the operation.",
                    examples: [
                        "setCartesian([1, 2], [3, 4])"
                    ],
                    seealso: [
                        "setUnion",
                        "setIntersect",
                        "setDifference",
                        "setPowerset"
                    ]
                },
                setDifference: {
                    name: "setDifference",
                    category: "Set",
                    syntax: [
                        "setDifference(set1, set2)"
                    ],
                    description: "Create the difference of two (multi)sets: every element of set1, that is not the element of set2. Multi-dimension arrays will be converted to single-dimension arrays before the operation.",
                    examples: [
                        "setDifference([1, 2, 3, 4], [3, 4, 5, 6])",
                        "setDifference([[1, 2], [3, 4]], [[3, 4], [5, 6]])"
                    ],
                    seealso: [
                        "setUnion",
                        "setIntersect",
                        "setSymDifference"
                    ]
                },
                setDistinct: {
                    name: "setDistinct",
                    category: "Set",
                    syntax: [
                        "setDistinct(set)"
                    ],
                    description: "Collect the distinct elements of a multiset. A multi-dimension array will be converted to a single-dimension array before the operation.",
                    examples: [
                        "setDistinct([1, 1, 1, 2, 2, 3])"
                    ],
                    seealso: [
                        "setMultiplicity"
                    ]
                },
                setIntersect: {
                    name: "setIntersect",
                    category: "Set",
                    syntax: [
                        "setIntersect(set1, set2)"
                    ],
                    description: "Create the intersection of two (multi)sets. Multi-dimension arrays will be converted to single-dimension arrays before the operation.",
                    examples: [
                        "setIntersect([1, 2, 3, 4], [3, 4, 5, 6])",
                        "setIntersect([[1, 2], [3, 4]], [[3, 4], [5, 6]])"
                    ],
                    seealso: [
                        "setUnion",
                        "setDifference"
                    ]
                },
                setIsSubset: {
                    name: "setIsSubset",
                    category: "Set",
                    syntax: [
                        "setIsSubset(set1, set2)"
                    ],
                    description: "Check whether a (multi)set is a subset of another (multi)set: every element of set1 is the element of set2. Multi-dimension arrays will be converted to single-dimension arrays before the operation.",
                    examples: [
                        "setIsSubset([1, 2], [3, 4, 5, 6])",
                        "setIsSubset([3, 4], [3, 4, 5, 6])"
                    ],
                    seealso: [
                        "setUnion",
                        "setIntersect",
                        "setDifference"
                    ]
                },
                setMultiplicity: {
                    name: "setMultiplicity",
                    category: "Set",
                    syntax: [
                        "setMultiplicity(element, set)"
                    ],
                    description: "Count the multiplicity of an element in a multiset. A multi-dimension array will be converted to a single-dimension array before the operation.",
                    examples: [
                        "setMultiplicity(1, [1, 2, 2, 4])",
                        "setMultiplicity(2, [1, 2, 2, 4])"
                    ],
                    seealso: [
                        "setDistinct",
                        "setSize"
                    ]
                },
                setPowerset: {
                    name: "setPowerset",
                    category: "Set",
                    syntax: [
                        "setPowerset(set)"
                    ],
                    description: "Create the powerset of a (multi)set: the powerset contains very possible subsets of a (multi)set. A multi-dimension array will be converted to a single-dimension array before the operation.",
                    examples: [
                        "setPowerset([1, 2, 3])"
                    ],
                    seealso: [
                        "setCartesian"
                    ]
                },
                setSize: {
                    name: "setSize",
                    category: "Set",
                    syntax: [
                        "setSize(set)",
                        "setSize(set, unique)"
                    ],
                    description: 'Count the number of elements of a (multi)set. When the second parameter "unique" is true, count only the unique values. A multi-dimension array will be converted to a single-dimension array before the operation.',
                    examples: [
                        "setSize([1, 2, 2, 4])",
                        "setSize([1, 2, 2, 4], true)"
                    ],
                    seealso: [
                        "setUnion",
                        "setIntersect",
                        "setDifference"
                    ]
                },
                setSymDifference: {
                    name: "setSymDifference",
                    category: "Set",
                    syntax: [
                        "setSymDifference(set1, set2)"
                    ],
                    description: "Create the symmetric difference of two (multi)sets. Multi-dimension arrays will be converted to single-dimension arrays before the operation.",
                    examples: [
                        "setSymDifference([1, 2, 3, 4], [3, 4, 5, 6])",
                        "setSymDifference([[1, 2], [3, 4]], [[3, 4], [5, 6]])"
                    ],
                    seealso: [
                        "setUnion",
                        "setIntersect",
                        "setDifference"
                    ]
                },
                setUnion: {
                    name: "setUnion",
                    category: "Set",
                    syntax: [
                        "setUnion(set1, set2)"
                    ],
                    description: "Create the union of two (multi)sets. Multi-dimension arrays will be converted to single-dimension arrays before the operation.",
                    examples: [
                        "setUnion([1, 2, 3, 4], [3, 4, 5, 6])",
                        "setUnion([[1, 2], [3, 4]], [[3, 4], [5, 6]])"
                    ],
                    seealso: [
                        "setIntersect",
                        "setDifference"
                    ]
                },
                zpk2tf: {
                    name: "zpk2tf",
                    category: "Signal",
                    syntax: [
                        "zpk2tf(z, p, k)"
                    ],
                    description: "Compute the transfer function of a zero-pole-gain model.",
                    examples: [
                        "zpk2tf([1, 2], [-1, -2], 1)",
                        "zpk2tf([1, 2], [-1, -2])",
                        "zpk2tf([1 - 3i, 2 + 2i], [-1, -2])"
                    ],
                    seealso: []
                },
                freqz: {
                    name: "freqz",
                    category: "Signal",
                    syntax: [
                        "freqz(b, a)",
                        "freqz(b, a, w)"
                    ],
                    description: "Calculates the frequency response of a filter given its numerator and denominator coefficients.",
                    examples: [
                        "freqz([1, 2], [1, 2, 3])",
                        "freqz([1, 2], [1, 2, 3], [0, 1])",
                        "freqz([1, 2], [1, 2, 3], 512)"
                    ],
                    seealso: []
                },
                erf: {
                    name: "erf",
                    category: "Special",
                    syntax: [
                        "erf(x)"
                    ],
                    description: "Compute the erf function of a value using a rational Chebyshev approximations for different intervals of x",
                    examples: [
                        "erf(0.2)",
                        "erf(-0.5)",
                        "erf(4)"
                    ],
                    seealso: []
                },
                zeta: {
                    name: "zeta",
                    category: "Special",
                    syntax: [
                        "zeta(s)"
                    ],
                    description: "Compute the Riemann Zeta Function using an infinite series and Riemanns Functional Equation for the entire complex plane",
                    examples: [
                        "zeta(0.2)",
                        "zeta(-0.5)",
                        "zeta(4)"
                    ],
                    seealso: []
                },
                cumsum: {
                    name: "cumsum",
                    category: "Statistics",
                    syntax: [
                        "cumsum(a, b, c, ...)",
                        "cumsum(A)"
                    ],
                    description: "Compute the cumulative sum of all values.",
                    examples: [
                        "cumsum(2, 3, 4, 1)",
                        "cumsum([2, 3, 4, 1])",
                        "cumsum([1, 2; 3, 4])",
                        "cumsum([1, 2; 3, 4], 1)",
                        "cumsum([1, 2; 3, 4], 2)"
                    ],
                    seealso: [
                        "max",
                        "mean",
                        "median",
                        "min",
                        "prod",
                        "std",
                        "sum",
                        "variance"
                    ]
                },
                mad: {
                    name: "mad",
                    category: "Statistics",
                    syntax: [
                        "mad(a, b, c, ...)",
                        "mad(A)"
                    ],
                    description: "Compute the median absolute deviation of a matrix or a list with values. The median absolute deviation is defined as the median of the absolute deviations from the median.",
                    examples: [
                        "mad(10, 20, 30)",
                        "mad([1, 2, 3])"
                    ],
                    seealso: [
                        "mean",
                        "median",
                        "std",
                        "abs"
                    ]
                },
                max: {
                    name: "max",
                    category: "Statistics",
                    syntax: [
                        "max(a, b, c, ...)",
                        "max(A)",
                        "max(A, dimension)"
                    ],
                    description: "Compute the maximum value of a list of values.",
                    examples: [
                        "max(2, 3, 4, 1)",
                        "max([2, 3, 4, 1])",
                        "max([2, 5; 4, 3])",
                        "max([2, 5; 4, 3], 1)",
                        "max([2, 5; 4, 3], 2)",
                        "max(2.7, 7.1, -4.5, 2.0, 4.1)",
                        "min(2.7, 7.1, -4.5, 2.0, 4.1)"
                    ],
                    seealso: [
                        "mean",
                        "median",
                        "min",
                        "prod",
                        "std",
                        "sum",
                        "variance"
                    ]
                },
                mean: {
                    name: "mean",
                    category: "Statistics",
                    syntax: [
                        "mean(a, b, c, ...)",
                        "mean(A)",
                        "mean(A, dimension)"
                    ],
                    description: "Compute the arithmetic mean of a list of values.",
                    examples: [
                        "mean(2, 3, 4, 1)",
                        "mean([2, 3, 4, 1])",
                        "mean([2, 5; 4, 3])",
                        "mean([2, 5; 4, 3], 1)",
                        "mean([2, 5; 4, 3], 2)",
                        "mean([1.0, 2.7, 3.2, 4.0])"
                    ],
                    seealso: [
                        "max",
                        "median",
                        "min",
                        "prod",
                        "std",
                        "sum",
                        "variance"
                    ]
                },
                median: {
                    name: "median",
                    category: "Statistics",
                    syntax: [
                        "median(a, b, c, ...)",
                        "median(A)"
                    ],
                    description: "Compute the median of all values. The values are sorted and the middle value is returned. In case of an even number of values, the average of the two middle values is returned.",
                    examples: [
                        "median(5, 2, 7)",
                        "median([3, -1, 5, 7])"
                    ],
                    seealso: [
                        "max",
                        "mean",
                        "min",
                        "prod",
                        "std",
                        "sum",
                        "variance",
                        "quantileSeq"
                    ]
                },
                min: {
                    name: "min",
                    category: "Statistics",
                    syntax: [
                        "min(a, b, c, ...)",
                        "min(A)",
                        "min(A, dimension)"
                    ],
                    description: "Compute the minimum value of a list of values.",
                    examples: [
                        "min(2, 3, 4, 1)",
                        "min([2, 3, 4, 1])",
                        "min([2, 5; 4, 3])",
                        "min([2, 5; 4, 3], 1)",
                        "min([2, 5; 4, 3], 2)",
                        "min(2.7, 7.1, -4.5, 2.0, 4.1)",
                        "max(2.7, 7.1, -4.5, 2.0, 4.1)"
                    ],
                    seealso: [
                        "max",
                        "mean",
                        "median",
                        "prod",
                        "std",
                        "sum",
                        "variance"
                    ]
                },
                mode: {
                    name: "mode",
                    category: "Statistics",
                    syntax: [
                        "mode(a, b, c, ...)",
                        "mode(A)",
                        "mode(A, a, b, B, c, ...)"
                    ],
                    description: "Computes the mode of all values as an array. In case mode being more than one, multiple values are returned in an array.",
                    examples: [
                        "mode(2, 1, 4, 3, 1)",
                        "mode([1, 2.7, 3.2, 4, 2.7])",
                        "mode(1, 4, 6, 1, 6)"
                    ],
                    seealso: [
                        "max",
                        "mean",
                        "min",
                        "median",
                        "prod",
                        "std",
                        "sum",
                        "variance"
                    ]
                },
                prod: {
                    name: "prod",
                    category: "Statistics",
                    syntax: [
                        "prod(a, b, c, ...)",
                        "prod(A)"
                    ],
                    description: "Compute the product of all values.",
                    examples: [
                        "prod(2, 3, 4)",
                        "prod([2, 3, 4])",
                        "prod([2, 5; 4, 3])"
                    ],
                    seealso: [
                        "max",
                        "mean",
                        "min",
                        "median",
                        "min",
                        "std",
                        "sum",
                        "variance"
                    ]
                },
                quantileSeq: {
                    name: "quantileSeq",
                    category: "Statistics",
                    syntax: [
                        "quantileSeq(A, prob[, sorted])",
                        "quantileSeq(A, [prob1, prob2, ...][, sorted])",
                        "quantileSeq(A, N[, sorted])"
                    ],
                    description: "Compute the prob order quantile of a matrix or a list with values. The sequence is sorted and the middle value is returned. Supported types of sequence values are: Number, BigNumber, Unit Supported types of probablity are: Number, BigNumber. \n\nIn case of a (multi dimensional) array or matrix, the prob order quantile of all elements will be calculated.",
                    examples: [
                        "quantileSeq([3, -1, 5, 7], 0.5)",
                        "quantileSeq([3, -1, 5, 7], [1/3, 2/3])",
                        "quantileSeq([3, -1, 5, 7], 2)",
                        "quantileSeq([-1, 3, 5, 7], 0.5, true)"
                    ],
                    seealso: [
                        "mean",
                        "median",
                        "min",
                        "max",
                        "prod",
                        "std",
                        "sum",
                        "variance"
                    ]
                },
                std: {
                    name: "std",
                    category: "Statistics",
                    syntax: [
                        "std(a, b, c, ...)",
                        "std(A)",
                        "std(A, dimension)",
                        "std(A, normalization)",
                        "std(A, dimension, normalization)"
                    ],
                    description: 'Compute the standard deviation of all values, defined as std(A) = sqrt(variance(A)). Optional parameter normalization can be "unbiased" (default), "uncorrected", or "biased".',
                    examples: [
                        "std(2, 4, 6)",
                        "std([2, 4, 6, 8])",
                        'std([2, 4, 6, 8], "uncorrected")',
                        'std([2, 4, 6, 8], "biased")',
                        "std([1, 2, 3; 4, 5, 6])"
                    ],
                    seealso: [
                        "max",
                        "mean",
                        "min",
                        "median",
                        "prod",
                        "sum",
                        "variance"
                    ]
                },
                sum: {
                    name: "sum",
                    category: "Statistics",
                    syntax: [
                        "sum(a, b, c, ...)",
                        "sum(A)",
                        "sum(A, dimension)"
                    ],
                    description: "Compute the sum of all values.",
                    examples: [
                        "sum(2, 3, 4, 1)",
                        "sum([2, 3, 4, 1])",
                        "sum([2, 5; 4, 3])"
                    ],
                    seealso: [
                        "max",
                        "mean",
                        "median",
                        "min",
                        "prod",
                        "std",
                        "sum",
                        "variance"
                    ]
                },
                variance: {
                    name: "variance",
                    category: "Statistics",
                    syntax: [
                        "variance(a, b, c, ...)",
                        "variance(A)",
                        "variance(A, dimension)",
                        "variance(A, normalization)",
                        "variance(A, dimension, normalization)"
                    ],
                    description: 'Compute the variance of all values. Optional parameter normalization can be "unbiased" (default), "uncorrected", or "biased".',
                    examples: [
                        "variance(2, 4, 6)",
                        "variance([2, 4, 6, 8])",
                        'variance([2, 4, 6, 8], "uncorrected")',
                        'variance([2, 4, 6, 8], "biased")',
                        "variance([1, 2, 3; 4, 5, 6])"
                    ],
                    seealso: [
                        "max",
                        "mean",
                        "min",
                        "median",
                        "min",
                        "prod",
                        "std",
                        "sum"
                    ]
                },
                corr: {
                    name: "corr",
                    category: "Statistics",
                    syntax: [
                        "corr(A,B)"
                    ],
                    description: "Compute the correlation coefficient of a two list with values, For matrices, the matrix correlation coefficient is calculated.",
                    examples: [
                        "corr([2, 4, 6, 8],[1, 2, 3, 6])",
                        "corr(matrix([[1, 2.2, 3, 4.8, 5], [1, 2, 3, 4, 5]]), matrix([[4, 5.3, 6.6, 7, 8], [1, 2, 3, 4, 5]]))"
                    ],
                    seealso: [
                        "max",
                        "mean",
                        "min",
                        "median",
                        "min",
                        "prod",
                        "std",
                        "sum"
                    ]
                },
                acos: {
                    name: "acos",
                    category: "Trigonometry",
                    syntax: [
                        "acos(x)"
                    ],
                    description: "Compute the inverse cosine of a value in radians.",
                    examples: [
                        "acos(0.5)",
                        "acos(cos(2.3))"
                    ],
                    seealso: [
                        "cos",
                        "atan",
                        "asin"
                    ]
                },
                acosh: {
                    name: "acosh",
                    category: "Trigonometry",
                    syntax: [
                        "acosh(x)"
                    ],
                    description: "Calculate the hyperbolic arccos of a value, defined as `acosh(x) = ln(sqrt(x^2 - 1) + x)`.",
                    examples: [
                        "acosh(1.5)"
                    ],
                    seealso: [
                        "cosh",
                        "asinh",
                        "atanh"
                    ]
                },
                acot: {
                    name: "acot",
                    category: "Trigonometry",
                    syntax: [
                        "acot(x)"
                    ],
                    description: "Calculate the inverse cotangent of a value.",
                    examples: [
                        "acot(0.5)",
                        "acot(cot(0.5))",
                        "acot(2)"
                    ],
                    seealso: [
                        "cot",
                        "atan"
                    ]
                },
                acoth: {
                    name: "acoth",
                    category: "Trigonometry",
                    syntax: [
                        "acoth(x)"
                    ],
                    description: "Calculate the hyperbolic arccotangent of a value, defined as `acoth(x) = (ln((x+1)/x) + ln(x/(x-1))) / 2`.",
                    examples: [
                        "acoth(2)",
                        "acoth(0.5)"
                    ],
                    seealso: [
                        "acsch",
                        "asech"
                    ]
                },
                acsc: {
                    name: "acsc",
                    category: "Trigonometry",
                    syntax: [
                        "acsc(x)"
                    ],
                    description: "Calculate the inverse cotangent of a value.",
                    examples: [
                        "acsc(2)",
                        "acsc(csc(0.5))",
                        "acsc(0.5)"
                    ],
                    seealso: [
                        "csc",
                        "asin",
                        "asec"
                    ]
                },
                acsch: {
                    name: "acsch",
                    category: "Trigonometry",
                    syntax: [
                        "acsch(x)"
                    ],
                    description: "Calculate the hyperbolic arccosecant of a value, defined as `acsch(x) = ln(1/x + sqrt(1/x^2 + 1))`.",
                    examples: [
                        "acsch(0.5)"
                    ],
                    seealso: [
                        "asech",
                        "acoth"
                    ]
                },
                asec: {
                    name: "asec",
                    category: "Trigonometry",
                    syntax: [
                        "asec(x)"
                    ],
                    description: "Calculate the inverse secant of a value.",
                    examples: [
                        "asec(0.5)",
                        "asec(sec(0.5))",
                        "asec(2)"
                    ],
                    seealso: [
                        "acos",
                        "acot",
                        "acsc"
                    ]
                },
                asech: {
                    name: "asech",
                    category: "Trigonometry",
                    syntax: [
                        "asech(x)"
                    ],
                    description: "Calculate the inverse secant of a value.",
                    examples: [
                        "asech(0.5)"
                    ],
                    seealso: [
                        "acsch",
                        "acoth"
                    ]
                },
                asin: {
                    name: "asin",
                    category: "Trigonometry",
                    syntax: [
                        "asin(x)"
                    ],
                    description: "Compute the inverse sine of a value in radians.",
                    examples: [
                        "asin(0.5)",
                        "asin(sin(0.5))"
                    ],
                    seealso: [
                        "sin",
                        "acos",
                        "atan"
                    ]
                },
                asinh: {
                    name: "asinh",
                    category: "Trigonometry",
                    syntax: [
                        "asinh(x)"
                    ],
                    description: "Calculate the hyperbolic arcsine of a value, defined as `asinh(x) = ln(x + sqrt(x^2 + 1))`.",
                    examples: [
                        "asinh(0.5)"
                    ],
                    seealso: [
                        "acosh",
                        "atanh"
                    ]
                },
                atan: {
                    name: "atan",
                    category: "Trigonometry",
                    syntax: [
                        "atan(x)"
                    ],
                    description: "Compute the inverse tangent of a value in radians.",
                    examples: [
                        "atan(0.5)",
                        "atan(tan(0.5))"
                    ],
                    seealso: [
                        "tan",
                        "acos",
                        "asin"
                    ]
                },
                atanh: {
                    name: "atanh",
                    category: "Trigonometry",
                    syntax: [
                        "atanh(x)"
                    ],
                    description: "Calculate the hyperbolic arctangent of a value, defined as `atanh(x) = ln((1 + x)/(1 - x)) / 2`.",
                    examples: [
                        "atanh(0.5)"
                    ],
                    seealso: [
                        "acosh",
                        "asinh"
                    ]
                },
                atan2: {
                    name: "atan2",
                    category: "Trigonometry",
                    syntax: [
                        "atan2(y, x)"
                    ],
                    description: "Computes the principal value of the arc tangent of y/x in radians.",
                    examples: [
                        "atan2(2, 2) / pi",
                        "angle = 60 deg in rad",
                        "x = cos(angle)",
                        "y = sin(angle)",
                        "atan2(y, x)"
                    ],
                    seealso: [
                        "sin",
                        "cos",
                        "tan"
                    ]
                },
                cos: {
                    name: "cos",
                    category: "Trigonometry",
                    syntax: [
                        "cos(x)"
                    ],
                    description: "Compute the cosine of x in radians.",
                    examples: [
                        "cos(2)",
                        "cos(pi / 4) ^ 2",
                        "cos(180 deg)",
                        "cos(60 deg)",
                        "sin(0.2)^2 + cos(0.2)^2"
                    ],
                    seealso: [
                        "acos",
                        "sin",
                        "tan"
                    ]
                },
                cosh: {
                    name: "cosh",
                    category: "Trigonometry",
                    syntax: [
                        "cosh(x)"
                    ],
                    description: "Compute the hyperbolic cosine of x in radians.",
                    examples: [
                        "cosh(0.5)"
                    ],
                    seealso: [
                        "sinh",
                        "tanh",
                        "coth"
                    ]
                },
                cot: {
                    name: "cot",
                    category: "Trigonometry",
                    syntax: [
                        "cot(x)"
                    ],
                    description: "Compute the cotangent of x in radians. Defined as 1/tan(x)",
                    examples: [
                        "cot(2)",
                        "1 / tan(2)"
                    ],
                    seealso: [
                        "sec",
                        "csc",
                        "tan"
                    ]
                },
                coth: {
                    name: "coth",
                    category: "Trigonometry",
                    syntax: [
                        "coth(x)"
                    ],
                    description: "Compute the hyperbolic cotangent of x in radians.",
                    examples: [
                        "coth(2)",
                        "1 / tanh(2)"
                    ],
                    seealso: [
                        "sech",
                        "csch",
                        "tanh"
                    ]
                },
                csc: {
                    name: "csc",
                    category: "Trigonometry",
                    syntax: [
                        "csc(x)"
                    ],
                    description: "Compute the cosecant of x in radians. Defined as 1/sin(x)",
                    examples: [
                        "csc(2)",
                        "1 / sin(2)"
                    ],
                    seealso: [
                        "sec",
                        "cot",
                        "sin"
                    ]
                },
                csch: {
                    name: "csch",
                    category: "Trigonometry",
                    syntax: [
                        "csch(x)"
                    ],
                    description: "Compute the hyperbolic cosecant of x in radians. Defined as 1/sinh(x)",
                    examples: [
                        "csch(2)",
                        "1 / sinh(2)"
                    ],
                    seealso: [
                        "sech",
                        "coth",
                        "sinh"
                    ]
                },
                sec: {
                    name: "sec",
                    category: "Trigonometry",
                    syntax: [
                        "sec(x)"
                    ],
                    description: "Compute the secant of x in radians. Defined as 1/cos(x)",
                    examples: [
                        "sec(2)",
                        "1 / cos(2)"
                    ],
                    seealso: [
                        "cot",
                        "csc",
                        "cos"
                    ]
                },
                sech: {
                    name: "sech",
                    category: "Trigonometry",
                    syntax: [
                        "sech(x)"
                    ],
                    description: "Compute the hyperbolic secant of x in radians. Defined as 1/cosh(x)",
                    examples: [
                        "sech(2)",
                        "1 / cosh(2)"
                    ],
                    seealso: [
                        "coth",
                        "csch",
                        "cosh"
                    ]
                },
                sin: {
                    name: "sin",
                    category: "Trigonometry",
                    syntax: [
                        "sin(x)"
                    ],
                    description: "Compute the sine of x in radians.",
                    examples: [
                        "sin(2)",
                        "sin(pi / 4) ^ 2",
                        "sin(90 deg)",
                        "sin(30 deg)",
                        "sin(0.2)^2 + cos(0.2)^2"
                    ],
                    seealso: [
                        "asin",
                        "cos",
                        "tan"
                    ]
                },
                sinh: {
                    name: "sinh",
                    category: "Trigonometry",
                    syntax: [
                        "sinh(x)"
                    ],
                    description: "Compute the hyperbolic sine of x in radians.",
                    examples: [
                        "sinh(0.5)"
                    ],
                    seealso: [
                        "cosh",
                        "tanh"
                    ]
                },
                tan: {
                    name: "tan",
                    category: "Trigonometry",
                    syntax: [
                        "tan(x)"
                    ],
                    description: "Compute the tangent of x in radians.",
                    examples: [
                        "tan(0.5)",
                        "sin(0.5) / cos(0.5)",
                        "tan(pi / 4)",
                        "tan(45 deg)"
                    ],
                    seealso: [
                        "atan",
                        "sin",
                        "cos"
                    ]
                },
                tanh: {
                    name: "tanh",
                    category: "Trigonometry",
                    syntax: [
                        "tanh(x)"
                    ],
                    description: "Compute the hyperbolic tangent of x in radians.",
                    examples: [
                        "tanh(0.5)",
                        "sinh(0.5) / cosh(0.5)"
                    ],
                    seealso: [
                        "sinh",
                        "cosh"
                    ]
                },
                to: {
                    name: "to",
                    category: "Units",
                    syntax: [
                        "x to unit",
                        "to(x, unit)"
                    ],
                    description: "Change the unit of a value.",
                    examples: [
                        "5 inch to cm",
                        "3.2kg to g",
                        "16 bytes in bits"
                    ],
                    seealso: []
                },
                clone: {
                    name: "clone",
                    category: "Utils",
                    syntax: [
                        "clone(x)"
                    ],
                    description: "Clone a variable. Creates a copy of primitive variables,and a deep copy of matrices",
                    examples: [
                        "clone(3.5)",
                        "clone(2 - 4i)",
                        "clone(45 deg)",
                        "clone([1, 2; 3, 4])",
                        'clone("hello world")'
                    ],
                    seealso: []
                },
                format: {
                    name: "format",
                    category: "Utils",
                    syntax: [
                        "format(value)",
                        "format(value, precision)"
                    ],
                    description: "Format a value of any type as string.",
                    examples: [
                        "format(2.3)",
                        "format(3 - 4i)",
                        "format([])",
                        "format(pi, 3)"
                    ],
                    seealso: [
                        "print"
                    ]
                },
                bin: {
                    name: "bin",
                    category: "Utils",
                    syntax: [
                        "bin(value)"
                    ],
                    description: "Format a number as binary",
                    examples: [
                        "bin(2)"
                    ],
                    seealso: [
                        "oct",
                        "hex"
                    ]
                },
                oct: {
                    name: "oct",
                    category: "Utils",
                    syntax: [
                        "oct(value)"
                    ],
                    description: "Format a number as octal",
                    examples: [
                        "oct(56)"
                    ],
                    seealso: [
                        "bin",
                        "hex"
                    ]
                },
                hex: {
                    name: "hex",
                    category: "Utils",
                    syntax: [
                        "hex(value)"
                    ],
                    description: "Format a number as hexadecimal",
                    examples: [
                        "hex(240)"
                    ],
                    seealso: [
                        "bin",
                        "oct"
                    ]
                },
                isNaN: {
                    name: "isNaN",
                    category: "Utils",
                    syntax: [
                        "isNaN(x)"
                    ],
                    description: "Test whether a value is NaN (not a number)",
                    examples: [
                        "isNaN(2)",
                        "isNaN(0 / 0)",
                        "isNaN(NaN)",
                        "isNaN(Infinity)"
                    ],
                    seealso: [
                        "isNegative",
                        "isNumeric",
                        "isPositive",
                        "isZero"
                    ]
                },
                isInteger: {
                    name: "isInteger",
                    category: "Utils",
                    syntax: [
                        "isInteger(x)"
                    ],
                    description: "Test whether a value is an integer number.",
                    examples: [
                        "isInteger(2)",
                        "isInteger(3.5)",
                        "isInteger([3, 0.5, -2])"
                    ],
                    seealso: [
                        "isNegative",
                        "isNumeric",
                        "isPositive",
                        "isZero"
                    ]
                },
                isNegative: {
                    name: "isNegative",
                    category: "Utils",
                    syntax: [
                        "isNegative(x)"
                    ],
                    description: "Test whether a value is negative: smaller than zero.",
                    examples: [
                        "isNegative(2)",
                        "isNegative(0)",
                        "isNegative(-4)",
                        "isNegative([3, 0.5, -2])"
                    ],
                    seealso: [
                        "isInteger",
                        "isNumeric",
                        "isPositive",
                        "isZero"
                    ]
                },
                isNumeric: {
                    name: "isNumeric",
                    category: "Utils",
                    syntax: [
                        "isNumeric(x)"
                    ],
                    description: "Test whether a value is a numeric value. Returns true when the input is a number, BigNumber, Fraction, or boolean.",
                    examples: [
                        "isNumeric(2)",
                        'isNumeric("2")',
                        'hasNumericValue("2")',
                        "isNumeric(0)",
                        "isNumeric(bignumber(500))",
                        "isNumeric(fraction(0.125))",
                        "isNumeric(2 + 3i)",
                        'isNumeric([2.3, "foo", false])'
                    ],
                    seealso: [
                        "isInteger",
                        "isZero",
                        "isNegative",
                        "isPositive",
                        "isNaN",
                        "hasNumericValue"
                    ]
                },
                hasNumericValue: {
                    name: "hasNumericValue",
                    category: "Utils",
                    syntax: [
                        "hasNumericValue(x)"
                    ],
                    description: "Test whether a value is an numeric value. In case of a string, true is returned if the string contains a numeric value.",
                    examples: [
                        "hasNumericValue(2)",
                        'hasNumericValue("2")',
                        'isNumeric("2")',
                        "hasNumericValue(0)",
                        "hasNumericValue(bignumber(500))",
                        "hasNumericValue(fraction(0.125))",
                        "hasNumericValue(2 + 3i)",
                        'hasNumericValue([2.3, "foo", false])'
                    ],
                    seealso: [
                        "isInteger",
                        "isZero",
                        "isNegative",
                        "isPositive",
                        "isNaN",
                        "isNumeric"
                    ]
                },
                isPositive: {
                    name: "isPositive",
                    category: "Utils",
                    syntax: [
                        "isPositive(x)"
                    ],
                    description: "Test whether a value is positive: larger than zero.",
                    examples: [
                        "isPositive(2)",
                        "isPositive(0)",
                        "isPositive(-4)",
                        "isPositive([3, 0.5, -2])"
                    ],
                    seealso: [
                        "isInteger",
                        "isNumeric",
                        "isNegative",
                        "isZero"
                    ]
                },
                isPrime: {
                    name: "isPrime",
                    category: "Utils",
                    syntax: [
                        "isPrime(x)"
                    ],
                    description: "Test whether a value is prime: has no divisors other than itself and one.",
                    examples: [
                        "isPrime(3)",
                        "isPrime(-2)",
                        "isPrime([2, 17, 100])"
                    ],
                    seealso: [
                        "isInteger",
                        "isNumeric",
                        "isNegative",
                        "isZero"
                    ]
                },
                isZero: {
                    name: "isZero",
                    category: "Utils",
                    syntax: [
                        "isZero(x)"
                    ],
                    description: "Test whether a value is zero.",
                    examples: [
                        "isZero(2)",
                        "isZero(0)",
                        "isZero(-4)",
                        "isZero([3, 0, -2, 0])"
                    ],
                    seealso: [
                        "isInteger",
                        "isNumeric",
                        "isNegative",
                        "isPositive"
                    ]
                },
                print: {
                    name: "print",
                    category: "Utils",
                    syntax: [
                        "print(template, values)",
                        "print(template, values, precision)"
                    ],
                    description: "Interpolate values into a string template.",
                    examples: [
                        'print("Lucy is $age years old", {age: 5})',
                        'print("The value of pi is $pi", {pi: pi}, 3)',
                        'print("Hello, $user.name!", {user: {name: "John"}})',
                        'print("Values: $1, $2, $3", [6, 9, 4])'
                    ],
                    seealso: [
                        "format"
                    ]
                },
                typeOf: {
                    name: "typeOf",
                    category: "Utils",
                    syntax: [
                        "typeOf(x)"
                    ],
                    description: "Get the type of a variable.",
                    examples: [
                        "typeOf(3.5)",
                        "typeOf(2 - 4i)",
                        "typeOf(45 deg)",
                        'typeOf("hello world")'
                    ],
                    seealso: [
                        "getMatrixDataType"
                    ]
                },
                numeric: {
                    name: "numeric",
                    category: "Utils",
                    syntax: [
                        "numeric(x)"
                    ],
                    description: "Convert a numeric input to a specific numeric type: number, BigNumber, or Fraction.",
                    examples: [
                        'numeric("4")',
                        'numeric("4", "number")',
                        'numeric("4", "BigNumber")',
                        'numeric("4", "Fraction")',
                        'numeric(4, "Fraction")',
                        'numeric(fraction(2, 5), "number")'
                    ],
                    seealso: [
                        "number",
                        "fraction",
                        "bignumber",
                        "string",
                        "format"
                    ]
                }
            }, Wr = ge("help", [
                "typed",
                "mathWithTransform",
                "Help"
            ], (t)=>{
                var { typed: e, mathWithTransform: r, Help: n } = t;
                return e("help", {
                    any: function(t) {
                        var e, i = t;
                        if ("string" != typeof t) {
                            for(e in r)if (ut(r, e) && t === r[e]) {
                                i = e;
                                break;
                            }
                        }
                        var o = be(Hr, i);
                        if (!o) {
                            var a = "function" == typeof i ? i.name : i;
                            throw new Error('No documentation found on "' + a + '"');
                        }
                        return new n(o);
                    }
                });
            }), $r = ge("Parser", [
                "evaluate"
            ], (t)=>{
                var { evaluate: e } = t;
                function r() {
                    if (!(this instanceof r)) throw new SyntaxError("Constructor must be called with the new operator");
                    Object.defineProperty(this, "scope", {
                        value: ke(),
                        writable: !1
                    });
                }
                return r.prototype.type = "Parser", r.prototype.isParser = !0, r.prototype.evaluate = function(t) {
                    return e(t, this.scope);
                }, r.prototype.get = function(t) {
                    if (this.scope.has(t)) return this.scope.get(t);
                }, r.prototype.getAll = function() {
                    return function(t) {
                        if (t instanceof Me) return t.wrappedObject;
                        var e = {};
                        for (var r of t.keys())xe(e, r, t.get(r));
                        return e;
                    }(this.scope);
                }, r.prototype.getAllAsMap = function() {
                    return this.scope;
                }, r.prototype.set = function(t, e) {
                    return this.scope.set(t, e), e;
                }, r.prototype.remove = function(t) {
                    this.scope.delete(t);
                }, r.prototype.clear = function() {
                    this.scope.clear();
                }, r;
            }, {
                isClass: !0
            });
            function Vr(t) {
                return H(t) || X(t) && t.isUnary() && H(t.args[0]);
            }
            function Zr(t) {
                return !!H(t) || !(!V(t) && !X(t) || !t.args.every(Zr)) || !(!J(t) || !Zr(t.content));
            }
            var Yr = ge("simplify", [
                "config",
                "typed",
                "parse",
                "add",
                "subtract",
                "multiply",
                "divide",
                "pow",
                "isZero",
                "equal",
                "resolve",
                "simplifyConstant",
                "simplifyCore",
                "?fraction",
                "?bignumber",
                "mathWithTransform",
                "matrix",
                "AccessorNode",
                "ArrayNode",
                "ConstantNode",
                "FunctionNode",
                "IndexNode",
                "ObjectNode",
                "OperatorNode",
                "ParenthesisNode",
                "SymbolNode"
            ], (t)=>{
                var { config: e, typed: r, parse: n, add: i, subtract: o, multiply: a, divide: s, pow: u, isZero: l, equal: c, resolve: f, simplifyConstant: h, simplifyCore: p, fraction: d, bignumber: m, mathWithTransform: y, matrix: g, AccessorNode: v, ArrayNode: b, ConstantNode: x, FunctionNode: w, IndexNode: _, ObjectNode: A, OperatorNode: E, ParenthesisNode: S, SymbolNode: M } = t, { hasProperty: k, isCommutative: N, isAssociative: C, mergeContext: D, flatten: O, unflattenr: T, unflattenl: F, createMakeNodeFunction: P, defaultContext: I, realContext: B, positiveContext: j } = Mr({
                    FunctionNode: w,
                    OperatorNode: E,
                    SymbolNode: M
                });
                r.addConversion({
                    from: "Object",
                    to: "Map",
                    convert: Ne
                });
                var R = r("simplify", {
                    Node: $,
                    "Node, Map": (t, e)=>$(t, !1, e),
                    "Node, Map, Object": (t, e, r)=>$(t, !1, e, r),
                    "Node, Array": $,
                    "Node, Array, Map": $,
                    "Node, Array, Map, Object": $
                });
                function L(t) {
                    return t.transform(function(t, e, r) {
                        return J(t) ? L(t.content) : t;
                    });
                }
                r.removeConversion({
                    from: "Object",
                    to: "Map",
                    convert: Ne
                }), R.defaultContext = I, R.realContext = B, R.positiveContext = j;
                var q = {
                    true: !0,
                    false: !0,
                    e: !0,
                    i: !0,
                    Infinity: !0,
                    LN2: !0,
                    LN10: !0,
                    LOG2E: !0,
                    LOG10E: !0,
                    NaN: !0,
                    phi: !0,
                    pi: !0,
                    SQRT1_2: !0,
                    SQRT2: !0,
                    tau: !0
                };
                function U(t, e) {
                    var r = {};
                    if (t.s) {
                        var i = t.s.split("->");
                        if (2 !== i.length) throw SyntaxError("Could not parse rule: " + t.s);
                        r.l = i[0], r.r = i[1];
                    } else r.l = t.l, r.r = t.r;
                    for (var o of (r.l = L(n(r.l)), r.r = L(n(r.r)), [
                        "imposeContext",
                        "repeat",
                        "assuming"
                    ]))o in t && (r[o] = t[o]);
                    if (t.evaluate && (r.evaluate = n(t.evaluate)), C(r.l, e)) {
                        var a, s = !N(r.l, e);
                        s && (a = W());
                        var u = P(r.l), l = W();
                        r.expanded = {}, r.expanded.l = u([
                            r.l,
                            l
                        ]), O(r.expanded.l, e), T(r.expanded.l, e), r.expanded.r = u([
                            r.r,
                            l
                        ]), s && (r.expandedNC1 = {}, r.expandedNC1.l = u([
                            a,
                            r.l
                        ]), r.expandedNC1.r = u([
                            a,
                            r.r
                        ]), r.expandedNC2 = {}, r.expandedNC2.l = u([
                            a,
                            r.expanded.l
                        ]), r.expandedNC2.r = u([
                            a,
                            r.expanded.r
                        ]));
                    }
                    return r;
                }
                function z(t, e) {
                    for(var r = [], n = 0; n < t.length; n++){
                        var i = t[n], o = void 0, a = typeof i;
                        switch(a){
                            case "string":
                                i = {
                                    s: i
                                };
                            case "object":
                                o = U(i, e);
                                break;
                            case "function":
                                o = i;
                                break;
                            default:
                                throw TypeError("Unsupported type of rule: " + a);
                        }
                        r.push(o);
                    }
                    return r;
                }
                R.rules = [
                    p,
                    {
                        l: "log(e)",
                        r: "1"
                    },
                    {
                        s: "n-n1 -> n+-n1",
                        assuming: {
                            subtract: {
                                total: !0
                            }
                        }
                    },
                    {
                        s: "n-n -> 0",
                        assuming: {
                            subtract: {
                                total: !1
                            }
                        }
                    },
                    {
                        s: "-(cl*v) -> v * (-cl)",
                        assuming: {
                            multiply: {
                                commutative: !0
                            },
                            subtract: {
                                total: !0
                            }
                        }
                    },
                    {
                        s: "-(cl*v) -> (-cl) * v",
                        assuming: {
                            multiply: {
                                commutative: !1
                            },
                            subtract: {
                                total: !0
                            }
                        }
                    },
                    {
                        s: "-(v*cl) -> v * (-cl)",
                        assuming: {
                            multiply: {
                                commutative: !1
                            },
                            subtract: {
                                total: !0
                            }
                        }
                    },
                    {
                        l: "-(n1/n2)",
                        r: "-n1/n2"
                    },
                    {
                        l: "-v",
                        r: "v * (-1)"
                    },
                    {
                        l: "(n1 + n2)*(-1)",
                        r: "n1*(-1) + n2*(-1)",
                        repeat: !0
                    },
                    {
                        l: "n/n1^n2",
                        r: "n*n1^-n2"
                    },
                    {
                        l: "n/n1",
                        r: "n*n1^-1"
                    },
                    {
                        s: "(n1*n2)^n3 -> n1^n3 * n2^n3",
                        assuming: {
                            multiply: {
                                commutative: !0
                            }
                        }
                    },
                    {
                        s: "(n1*n2)^(-1) -> n2^(-1) * n1^(-1)",
                        assuming: {
                            multiply: {
                                commutative: !1
                            }
                        }
                    },
                    {
                        s: "(n ^ n1) ^ n2 -> n ^ (n1 * n2)",
                        assuming: {
                            divide: {
                                total: !0
                            }
                        }
                    },
                    {
                        l: " vd   * ( vd   * n1 + n2)",
                        r: "vd^2       * n1 +  vd   * n2"
                    },
                    {
                        s: " vd   * (vd^n4 * n1 + n2)   ->  vd^(1+n4)  * n1 +  vd   * n2",
                        assuming: {
                            divide: {
                                total: !0
                            }
                        }
                    },
                    {
                        s: "vd^n3 * ( vd   * n1 + n2)   ->  vd^(n3+1)  * n1 + vd^n3 * n2",
                        assuming: {
                            divide: {
                                total: !0
                            }
                        }
                    },
                    {
                        s: "vd^n3 * (vd^n4 * n1 + n2)   ->  vd^(n3+n4) * n1 + vd^n3 * n2",
                        assuming: {
                            divide: {
                                total: !0
                            }
                        }
                    },
                    {
                        l: "n*n",
                        r: "n^2"
                    },
                    {
                        s: "n * n^n1 -> n^(n1+1)",
                        assuming: {
                            divide: {
                                total: !0
                            }
                        }
                    },
                    {
                        s: "n^n1 * n^n2 -> n^(n1+n2)",
                        assuming: {
                            divide: {
                                total: !0
                            }
                        }
                    },
                    h,
                    {
                        s: "n+n -> 2*n",
                        assuming: {
                            add: {
                                total: !0
                            }
                        }
                    },
                    {
                        l: "n+-n",
                        r: "0"
                    },
                    {
                        l: "vd*n + vd",
                        r: "vd*(n+1)"
                    },
                    {
                        l: "n3*n1 + n3*n2",
                        r: "n3*(n1+n2)"
                    },
                    {
                        l: "n3^(-n4)*n1 +   n3  * n2",
                        r: "n3^(-n4)*(n1 + n3^(n4+1) *n2)"
                    },
                    {
                        l: "n3^(-n4)*n1 + n3^n5 * n2",
                        r: "n3^(-n4)*(n1 + n3^(n4+n5)*n2)"
                    },
                    {
                        s: "n*vd + vd -> (n+1)*vd",
                        assuming: {
                            multiply: {
                                commutative: !1
                            }
                        }
                    },
                    {
                        s: "vd + n*vd -> (1+n)*vd",
                        assuming: {
                            multiply: {
                                commutative: !1
                            }
                        }
                    },
                    {
                        s: "n1*n3 + n2*n3 -> (n1+n2)*n3",
                        assuming: {
                            multiply: {
                                commutative: !1
                            }
                        }
                    },
                    {
                        s: "n^n1 * n -> n^(n1+1)",
                        assuming: {
                            divide: {
                                total: !0
                            },
                            multiply: {
                                commutative: !1
                            }
                        }
                    },
                    {
                        s: "n1*n3^(-n4) + n2 * n3    -> (n1 + n2*n3^(n4 +  1))*n3^(-n4)",
                        assuming: {
                            multiply: {
                                commutative: !1
                            }
                        }
                    },
                    {
                        s: "n1*n3^(-n4) + n2 * n3^n5 -> (n1 + n2*n3^(n4 + n5))*n3^(-n4)",
                        assuming: {
                            multiply: {
                                commutative: !1
                            }
                        }
                    },
                    {
                        l: "n*cd + cd",
                        r: "(n+1)*cd"
                    },
                    {
                        s: "cd*n + cd -> cd*(n+1)",
                        assuming: {
                            multiply: {
                                commutative: !1
                            }
                        }
                    },
                    {
                        s: "cd + cd*n -> cd*(1+n)",
                        assuming: {
                            multiply: {
                                commutative: !1
                            }
                        }
                    },
                    h,
                    {
                        s: "(-n)*n1 -> -(n*n1)",
                        assuming: {
                            subtract: {
                                total: !0
                            }
                        }
                    },
                    {
                        s: "n1*(-n) -> -(n1*n)",
                        assuming: {
                            subtract: {
                                total: !0
                            },
                            multiply: {
                                commutative: !1
                            }
                        }
                    },
                    {
                        s: "ce+ve -> ve+ce",
                        assuming: {
                            add: {
                                commutative: !0
                            }
                        },
                        imposeContext: {
                            add: {
                                commutative: !1
                            }
                        }
                    },
                    {
                        s: "vd*cd -> cd*vd",
                        assuming: {
                            multiply: {
                                commutative: !0
                            }
                        },
                        imposeContext: {
                            multiply: {
                                commutative: !1
                            }
                        }
                    },
                    {
                        l: "n+-n1",
                        r: "n-n1"
                    },
                    {
                        l: "n+-(n1)",
                        r: "n-(n1)"
                    },
                    {
                        s: "n*(n1^-1) -> n/n1",
                        assuming: {
                            multiply: {
                                commutative: !0
                            }
                        }
                    },
                    {
                        s: "n*n1^-n2 -> n/n1^n2",
                        assuming: {
                            multiply: {
                                commutative: !0
                            }
                        }
                    },
                    {
                        s: "n^-1 -> 1/n",
                        assuming: {
                            multiply: {
                                commutative: !0
                            }
                        }
                    },
                    {
                        l: "n^1",
                        r: "n"
                    },
                    {
                        s: "n*(n1/n2) -> (n*n1)/n2",
                        assuming: {
                            multiply: {
                                associative: !0
                            }
                        }
                    },
                    {
                        s: "n-(n1+n2) -> n-n1-n2",
                        assuming: {
                            addition: {
                                associative: !0,
                                commutative: !0
                            }
                        }
                    },
                    {
                        l: "1*n",
                        r: "n",
                        imposeContext: {
                            multiply: {
                                commutative: !0
                            }
                        }
                    },
                    {
                        s: "n1/(n2/n3) -> (n1*n3)/n2",
                        assuming: {
                            multiply: {
                                associative: !0
                            }
                        }
                    },
                    {
                        l: "n1/(-n2)",
                        r: "-n1/n2"
                    }
                ];
                var G = 0;
                function W() {
                    return new M("_p" + G++);
                }
                function $(t, e) {
                    var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : ke(), n = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {}, i = n.consoleDebug;
                    e = z(e || R.rules, n.context);
                    for(var o = f(t, r), a = {}, s = (o = L(o)).toString({
                        parenthesis: "all"
                    }); !a[s];){
                        a[s] = !0, G = 0;
                        var u = s;
                        i && console.log("Working on: ", s);
                        for(var l = 0; l < e.length; l++){
                            var c = "";
                            if ("function" == typeof e[l] ? (o = e[l](o, n), i && (c = e[l].name)) : (O(o, n.context), o = Z(o, e[l], n.context), i && (c = "".concat(e[l].l.toString(), " -> ").concat(e[l].r.toString()))), i) {
                                var h = o.toString({
                                    parenthesis: "all"
                                });
                                h !== u && (console.log("Applying", c, "produced", h), u = h);
                            }
                            F(o, n.context);
                        }
                        s = o.toString({
                            parenthesis: "all"
                        });
                    }
                    return o;
                }
                function V(t, e, r) {
                    var n = t;
                    if (t) for(var i = 0; i < t.length; ++i){
                        var o = Z(t[i], e, r);
                        o !== t[i] && (n === t && (n = t.slice()), n[i] = o);
                    }
                    return n;
                }
                function Z(t, e, r) {
                    if (e.assuming) {
                        for(var n in e.assuming)for(var i in e.assuming[n])if (k(n, i, r) !== e.assuming[n][i]) return t;
                    }
                    var o = D(e.imposeContext, r), a = t;
                    if (a instanceof E || a instanceof w) {
                        var s = V(a.args, e, r);
                        s !== a.args && ((a = a.clone()).args = s);
                    } else if (a instanceof S) {
                        if (a.content) {
                            var u = Z(a.content, e, r);
                            u !== a.content && (a = new S(u));
                        }
                    } else if (a instanceof b) {
                        var l = V(a.items, e, r);
                        l !== a.items && (a = new b(l));
                    } else if (a instanceof v) {
                        var c = a.object;
                        a.object && (c = Z(a.object, e, r));
                        var f = a.index;
                        a.index && (f = Z(a.index, e, r)), c === a.object && f === a.index || (a = new v(c, f));
                    } else if (a instanceof _) {
                        var h = V(a.dimensions, e, r);
                        h !== a.dimensions && (a = new _(h));
                    } else if (a instanceof A) {
                        var p = !1, d = {};
                        for(var m in a.properties)d[m] = Z(a.properties[m], e, r), d[m] !== a.properties[m] && (p = !0);
                        p && (a = new A(d));
                    }
                    var y = e.r, g = X(e.l, a, o)[0];
                    if (!g && e.expanded && (y = e.expanded.r, g = X(e.expanded.l, a, o)[0]), !g && e.expandedNC1 && (y = e.expandedNC1.r, (g = X(e.expandedNC1.l, a, o)[0]) || (y = e.expandedNC2.r, g = X(e.expandedNC2.l, a, o)[0])), g) {
                        var x = a.implicit;
                        a = y.clone(), x && "implicit" in y && (a.implicit = !0), a = a.transform(function(t) {
                            return t.isSymbolNode && ut(g.placeholders, t.name) ? g.placeholders[t.name].clone() : t;
                        });
                    }
                    return e.repeat && a !== t && (a = Z(a, e, r)), a;
                }
                function Y(t, e) {
                    var r = {
                        placeholders: {}
                    };
                    if (!t.placeholders && !e.placeholders) return r;
                    if (!t.placeholders) return e;
                    if (!e.placeholders) return t;
                    for(var n in t.placeholders)if (ut(t.placeholders, n) && (r.placeholders[n] = t.placeholders[n], ut(e.placeholders, n) && !Q(t.placeholders[n], e.placeholders[n]))) return null;
                    for(var i in e.placeholders)ut(e.placeholders, i) && (r.placeholders[i] = e.placeholders[i]);
                    return r;
                }
                function K(t, e) {
                    var r, n = [];
                    if (0 === t.length || 0 === e.length) return n;
                    for(var i = 0; i < t.length; i++)for(var o = 0; o < e.length; o++)(r = Y(t[i], e[o])) && n.push(r);
                    return n;
                }
                function X(t, e, r, n) {
                    var i = [
                        {
                            placeholders: {}
                        }
                    ];
                    if (t instanceof E && e instanceof E || t instanceof w && e instanceof w) {
                        if (t instanceof E) {
                            if (t.op !== e.op || t.fn !== e.fn) return [];
                        } else if (t instanceof w && t.name !== e.name) return [];
                        if (!(1 === e.args.length && 1 === t.args.length || !C(e, r) && e.args.length === t.args.length || n)) {
                            if (e.args.length >= 2 && 2 === t.args.length) {
                                for(var o = function(t, e) {
                                    var r, n, i = [], o = P(t);
                                    if (N(t, e)) for(var a = 0; a < t.args.length; a++)(n = t.args.slice(0)).splice(a, 1), r = 1 === n.length ? n[0] : o(n), i.push(o([
                                        t.args[a],
                                        r
                                    ]));
                                    else for(var s = 1; s < t.args.length; s++){
                                        var u = t.args[0];
                                        s > 1 && (u = o(t.args.slice(0, s))), r = 1 === (n = t.args.slice(s)).length ? n[0] : o(n), i.push(o([
                                            u,
                                            r
                                        ]));
                                    }
                                    return i;
                                }(e, r), a = [], s = 0; s < o.length; s++){
                                    var u = X(t, o[s], r, !0);
                                    a = a.concat(u);
                                }
                                return a;
                            }
                            if (t.args.length > 2) throw Error("Unexpected non-binary associative function: " + t.toString());
                            return [];
                        }
                        for(var l = [], f = 0; f < t.args.length; f++){
                            var h = X(t.args[f], e.args[f], r);
                            if (0 === h.length) break;
                            l.push(h);
                        }
                        if (l.length !== t.args.length) {
                            if (!N(e, r) || 1 === t.args.length) return [];
                            if (t.args.length > 2) throw new Error("permuting >2 commutative non-associative rule arguments not yet implemented");
                            var p = X(t.args[0], e.args[1], r);
                            if (0 === p.length) return [];
                            var d = X(t.args[1], e.args[0], r);
                            if (0 === d.length) return [];
                            l = [
                                p,
                                d
                            ];
                        }
                        i = function(t) {
                            if (0 === t.length) return t;
                            for(var e = t.reduce(K), r = [], n = {}, i = 0; i < e.length; i++){
                                var o = JSON.stringify(e[i]);
                                n[o] || (n[o] = !0, r.push(e[i]));
                            }
                            return r;
                        }(l);
                    } else if (t instanceof M) {
                        if (0 === t.name.length) throw new Error("Symbol in rule has 0 length...!?");
                        if (q[t.name]) {
                            if (t.name !== e.name) return [];
                        } else switch(t.name[1] >= "a" && t.name[1] <= "z" ? t.name.substring(0, 2) : t.name[0]){
                            case "n":
                            case "_p":
                                i[0].placeholders[t.name] = e;
                                break;
                            case "c":
                            case "cl":
                                if (!H(e)) return [];
                                i[0].placeholders[t.name] = e;
                                break;
                            case "v":
                                if (H(e)) return [];
                                i[0].placeholders[t.name] = e;
                                break;
                            case "vl":
                                if (!et(e)) return [];
                                i[0].placeholders[t.name] = e;
                                break;
                            case "cd":
                                if (!Vr(e)) return [];
                                i[0].placeholders[t.name] = e;
                                break;
                            case "vd":
                                if (Vr(e)) return [];
                                i[0].placeholders[t.name] = e;
                                break;
                            case "ce":
                                if (!Zr(e)) return [];
                                i[0].placeholders[t.name] = e;
                                break;
                            case "ve":
                                if (Zr(e)) return [];
                                i[0].placeholders[t.name] = e;
                                break;
                            default:
                                throw new Error("Invalid symbol in rule: " + t.name);
                        }
                    } else {
                        if (!(t instanceof x)) return [];
                        if (!c(t.value, e.value)) return [];
                    }
                    return i;
                }
                function Q(t, e) {
                    if (t instanceof x && e instanceof x) {
                        if (!c(t.value, e.value)) return !1;
                    } else if (t instanceof M && e instanceof M) {
                        if (t.name !== e.name) return !1;
                    } else {
                        if (!(t instanceof E && e instanceof E || t instanceof w && e instanceof w)) return !1;
                        if (t instanceof E) {
                            if (t.op !== e.op || t.fn !== e.fn) return !1;
                        } else if (t instanceof w && t.name !== e.name) return !1;
                        if (t.args.length !== e.args.length) return !1;
                        for(var r = 0; r < t.args.length; r++)if (!Q(t.args[r], e.args[r])) return !1;
                    }
                    return !0;
                }
                return R;
            }), Kr = ge("symbolicEqual", [
                "parse",
                "simplify",
                "typed",
                "OperatorNode"
            ], (t)=>{
                var { parse: e, simplify: r, typed: n, OperatorNode: i } = t;
                function o(t, e) {
                    var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}, o = new i("-", "subtract", [
                        t,
                        e
                    ]), a = r(o, {}, n);
                    return H(a) && !a.value;
                }
                return n("symbolicEqual", {
                    "Node, Node": o,
                    "Node, Node, Object": o
                });
            }), Xr = ge("parser", [
                "typed",
                "Parser"
            ], (t)=>{
                var { typed: e, Parser: r } = t;
                return e("parser", {
                    "": function() {
                        return new r;
                    }
                });
            }), Jr = ge("rationalize", [
                "config",
                "typed",
                "equal",
                "isZero",
                "add",
                "subtract",
                "multiply",
                "divide",
                "pow",
                "parse",
                "simplifyConstant",
                "simplifyCore",
                "simplify",
                "?bignumber",
                "?fraction",
                "mathWithTransform",
                "matrix",
                "AccessorNode",
                "ArrayNode",
                "ConstantNode",
                "FunctionNode",
                "IndexNode",
                "ObjectNode",
                "OperatorNode",
                "SymbolNode",
                "ParenthesisNode"
            ], (t)=>{
                var { config: e, typed: r, equal: n, isZero: i, add: o, subtract: a, multiply: s, divide: u, pow: l, parse: c, simplifyConstant: f, simplifyCore: h, simplify: p, fraction: d, bignumber: m, mathWithTransform: y, matrix: g, AccessorNode: v, ArrayNode: b, ConstantNode: x, FunctionNode: w, IndexNode: _, ObjectNode: A, OperatorNode: E, SymbolNode: S, ParenthesisNode: M } = t;
                function k(t) {
                    var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = arguments.length > 2 && void 0 !== arguments[2] && arguments[2], n = C(), i = N(t, e, !0, n.firstRules), o = i.variables.length, a = {
                        exactFractions: !1
                    }, s = {
                        exactFractions: !0
                    };
                    if (t = i.expression, o >= 1) {
                        var u, l;
                        t = D(t);
                        var c, f = !0, h = !1;
                        for(t = p(t, n.firstRules, {}, a); l = f ? n.distrDivRules : n.sucDivRules, f = !f, (c = (t = p(t, l, {}, s)).toString()) !== u;)h = !0, u = c;
                        h && (t = p(t, n.firstRulesAgain, {}, a)), t = p(t, n.finalRules, {}, a);
                    }
                    var d = [], m = {};
                    return "OperatorNode" === t.type && t.isBinary() && "/" === t.op ? (1 === o && (t.args[0] = O(t.args[0], d), t.args[1] = O(t.args[1])), r && (m.numerator = t.args[0], m.denominator = t.args[1])) : (1 === o && (t = O(t, d)), r && (m.numerator = t, m.denominator = null)), r ? (m.coefficients = d, m.variables = i.variables, m.expression = t, m) : t;
                }
                return r("rationalize", {
                    Node: k,
                    "Node, boolean": (t, e)=>k(t, {}, e),
                    "Node, Object": k,
                    "Node, Object, boolean": k
                });
                function N(t, e, r, n) {
                    var i = [], o = p(t, n, e, {
                        exactFractions: !1
                    }), a = "+-*" + ((r = !!r) ? "/" : "");
                    !function t(e) {
                        var r = e.type;
                        if ("FunctionNode" === r) throw new Error("There is an unsolved function call");
                        if ("OperatorNode" === r) {
                            if ("^" === e.op) {
                                if ("ConstantNode" !== e.args[1].type || !pt(parseFloat(e.args[1].value))) throw new Error("There is a non-integer exponent");
                                t(e.args[0]);
                            } else {
                                if (-1 === a.indexOf(e.op)) throw new Error("Operator " + e.op + " invalid in polynomial expression");
                                for(var n = 0; n < e.args.length; n++)t(e.args[n]);
                            }
                        } else if ("SymbolNode" === r) {
                            var o = e.name;
                            -1 === i.indexOf(o) && i.push(o);
                        } else if ("ParenthesisNode" === r) t(e.content);
                        else if ("ConstantNode" !== r) throw new Error("type " + r + " is not allowed in polynomial expression");
                    }(o);
                    var s = {};
                    return s.expression = o, s.variables = i, s;
                }
                function C() {
                    var t = [
                        h,
                        {
                            l: "n+n",
                            r: "2*n"
                        },
                        {
                            l: "n+-n",
                            r: "0"
                        },
                        f,
                        {
                            l: "n*(n1^-1)",
                            r: "n/n1"
                        },
                        {
                            l: "n*n1^-n2",
                            r: "n/n1^n2"
                        },
                        {
                            l: "n1^-1",
                            r: "1/n1"
                        },
                        {
                            l: "n*(n1/n2)",
                            r: "(n*n1)/n2"
                        },
                        {
                            l: "1*n",
                            r: "n"
                        }
                    ], e = [
                        {
                            l: "(-n1)/(-n2)",
                            r: "n1/n2"
                        },
                        {
                            l: "(-n1)*(-n2)",
                            r: "n1*n2"
                        },
                        {
                            l: "n1--n2",
                            r: "n1+n2"
                        },
                        {
                            l: "n1-n2",
                            r: "n1+(-n2)"
                        },
                        {
                            l: "(n1+n2)*n3",
                            r: "(n1*n3 + n2*n3)"
                        },
                        {
                            l: "n1*(n2+n3)",
                            r: "(n1*n2+n1*n3)"
                        },
                        {
                            l: "c1*n + c2*n",
                            r: "(c1+c2)*n"
                        },
                        {
                            l: "c1*n + n",
                            r: "(c1+1)*n"
                        },
                        {
                            l: "c1*n - c2*n",
                            r: "(c1-c2)*n"
                        },
                        {
                            l: "c1*n - n",
                            r: "(c1-1)*n"
                        },
                        {
                            l: "v/c",
                            r: "(1/c)*v"
                        },
                        {
                            l: "v/-c",
                            r: "-(1/c)*v"
                        },
                        {
                            l: "-v*-c",
                            r: "c*v"
                        },
                        {
                            l: "-v*c",
                            r: "-c*v"
                        },
                        {
                            l: "v*-c",
                            r: "-c*v"
                        },
                        {
                            l: "v*c",
                            r: "c*v"
                        },
                        {
                            l: "-(-n1*n2)",
                            r: "(n1*n2)"
                        },
                        {
                            l: "-(n1*n2)",
                            r: "(-n1*n2)"
                        },
                        {
                            l: "-(-n1+n2)",
                            r: "(n1-n2)"
                        },
                        {
                            l: "-(n1+n2)",
                            r: "(-n1-n2)"
                        },
                        {
                            l: "(n1^n2)^n3",
                            r: "(n1^(n2*n3))"
                        },
                        {
                            l: "-(-n1/n2)",
                            r: "(n1/n2)"
                        },
                        {
                            l: "-(n1/n2)",
                            r: "(-n1/n2)"
                        }
                    ], r = [
                        {
                            l: "(n1/(n2/n3))",
                            r: "((n1*n3)/n2)"
                        },
                        {
                            l: "(n1/n2/n3)",
                            r: "(n1/(n2*n3))"
                        }
                    ], n = {};
                    return n.firstRules = t.concat(e, r), n.distrDivRules = [
                        {
                            l: "(n1/n2 + n3/n4)",
                            r: "((n1*n4 + n3*n2)/(n2*n4))"
                        },
                        {
                            l: "(n1/n2 + n3)",
                            r: "((n1 + n3*n2)/n2)"
                        },
                        {
                            l: "(n1 + n2/n3)",
                            r: "((n1*n3 + n2)/n3)"
                        }
                    ], n.sucDivRules = r, n.firstRulesAgain = t.concat(e), n.finalRules = [
                        h,
                        {
                            l: "n*-n",
                            r: "-n^2"
                        },
                        {
                            l: "n*n",
                            r: "n^2"
                        },
                        f,
                        {
                            l: "n*-n^n1",
                            r: "-n^(n1+1)"
                        },
                        {
                            l: "n*n^n1",
                            r: "n^(n1+1)"
                        },
                        {
                            l: "n^n1*-n^n2",
                            r: "-n^(n1+n2)"
                        },
                        {
                            l: "n^n1*n^n2",
                            r: "n^(n1+n2)"
                        },
                        {
                            l: "n^n1*-n",
                            r: "-n^(n1+1)"
                        },
                        {
                            l: "n^n1*n",
                            r: "n^(n1+1)"
                        },
                        {
                            l: "n^n1/-n",
                            r: "-n^(n1-1)"
                        },
                        {
                            l: "n^n1/n",
                            r: "n^(n1-1)"
                        },
                        {
                            l: "n/-n^n1",
                            r: "-n^(1-n1)"
                        },
                        {
                            l: "n/n^n1",
                            r: "n^(1-n1)"
                        },
                        {
                            l: "n^n1/-n^n2",
                            r: "n^(n1-n2)"
                        },
                        {
                            l: "n^n1/n^n2",
                            r: "n^(n1-n2)"
                        },
                        {
                            l: "n1+(-n2*n3)",
                            r: "n1-n2*n3"
                        },
                        {
                            l: "v*(-c)",
                            r: "-c*v"
                        },
                        {
                            l: "n1+-n2",
                            r: "n1-n2"
                        },
                        {
                            l: "v*c",
                            r: "c*v"
                        },
                        {
                            l: "(n1^n2)^n3",
                            r: "(n1^(n2*n3))"
                        }
                    ], n;
                }
                function D(t, e, r) {
                    var n = t.type, i = arguments.length > 1;
                    if ("OperatorNode" === n && t.isBinary()) {
                        var o, a = !1;
                        if ("^" === t.op && ("ParenthesisNode" !== t.args[0].type && "OperatorNode" !== t.args[0].type || "ConstantNode" !== t.args[1].type || (a = (o = parseFloat(t.args[1].value)) >= 2 && pt(o))), a) {
                            if (o > 2) {
                                var s = t.args[0], u = new E("^", "pow", [
                                    t.args[0].cloneDeep(),
                                    new x(o - 1)
                                ]);
                                t = new E("*", "multiply", [
                                    s,
                                    u
                                ]);
                            } else t = new E("*", "multiply", [
                                t.args[0],
                                t.args[0].cloneDeep()
                            ]);
                            i && ("content" === r ? e.content = t : e.args[r] = t);
                        }
                    }
                    if ("ParenthesisNode" === n) D(t.content, t, "content");
                    else if ("ConstantNode" !== n && "SymbolNode" !== n) for(var l = 0; l < t.args.length; l++)D(t.args[l], t, l);
                    if (!i) return t;
                }
                function O(t, e) {
                    void 0 === e && (e = []), e[0] = 0;
                    var r = {
                        cte: 1,
                        oper: "+",
                        fire: ""
                    }, n = 0, i = "";
                    !function t(r, o, a) {
                        var s = r.type;
                        if ("FunctionNode" === s) throw new Error("There is an unsolved function call");
                        if ("OperatorNode" === s) {
                            if (-1 === "+-*^".indexOf(r.op)) throw new Error("Operator " + r.op + " invalid");
                            if (null !== o) {
                                if (("unaryMinus" === r.fn || "pow" === r.fn) && "add" !== o.fn && "subtract" !== o.fn && "multiply" !== o.fn) throw new Error("Invalid " + r.op + " placing");
                                if (("subtract" === r.fn || "add" === r.fn || "multiply" === r.fn) && "add" !== o.fn && "subtract" !== o.fn) throw new Error("Invalid " + r.op + " placing");
                                if (("subtract" === r.fn || "add" === r.fn || "unaryMinus" === r.fn) && 0 !== a.noFil) throw new Error("Invalid " + r.op + " placing");
                            }
                            "^" !== r.op && "*" !== r.op || (a.fire = r.op);
                            for(var u = 0; u < r.args.length; u++)"unaryMinus" === r.fn && (a.oper = "-"), "+" !== r.op && "subtract" !== r.fn || (a.fire = "", a.cte = 1, a.oper = 0 === u ? "+" : r.op), a.noFil = u, t(r.args[u], r, a);
                        } else if ("SymbolNode" === s) {
                            if (r.name !== i && "" !== i) throw new Error("There is more than one variable");
                            if (i = r.name, null === o) return void (e[1] = 1);
                            if ("^" === o.op && 0 !== a.noFil) throw new Error("In power the variable should be the first parameter");
                            if ("*" === o.op && 1 !== a.noFil) throw new Error("In multiply the variable should be the second parameter");
                            "" !== a.fire && "*" !== a.fire || (n < 1 && (e[1] = 0), e[1] += a.cte * ("+" === a.oper ? 1 : -1), n = Math.max(1, n));
                        } else {
                            if ("ConstantNode" !== s) throw new Error("Type " + s + " is not allowed");
                            var l = parseFloat(r.value);
                            if (null === o) return void (e[0] = l);
                            if ("^" === o.op) {
                                if (1 !== a.noFil) throw new Error("Constant cannot be powered");
                                if (!pt(l) || l <= 0) throw new Error("Non-integer exponent is not allowed");
                                for(var c = n + 1; c < l; c++)e[c] = 0;
                                return l > n && (e[l] = 0), e[l] += a.cte * ("+" === a.oper ? 1 : -1), void (n = Math.max(l, n));
                            }
                            a.cte = l, "" === a.fire && (e[0] += a.cte * ("+" === a.oper ? 1 : -1));
                        }
                    }(t, null, r);
                    for(var o, a = !0, s = n = e.length - 1; s >= 0; s--)if (0 !== e[s]) {
                        var u = new x(a ? e[s] : Math.abs(e[s])), l = e[s] < 0 ? "-" : "+";
                        if (s > 0) {
                            var c = new S(i);
                            if (s > 1) {
                                var f = new x(s);
                                c = new E("^", "pow", [
                                    c,
                                    f
                                ]);
                            }
                            u = -1 === e[s] && a ? new E("-", "unaryMinus", [
                                c
                            ]) : 1 === Math.abs(e[s]) ? c : new E("*", "multiply", [
                                u,
                                c
                            ]);
                        }
                        o = a ? u : "+" === l ? new E("+", "add", [
                            o,
                            u
                        ]) : new E("-", "subtract", [
                            o,
                            u
                        ]), a = !1;
                    }
                    return a ? new x(0) : o;
                }
            }), Qr = ge("derivative", [
                "typed",
                "config",
                "parse",
                "simplify",
                "equal",
                "isZero",
                "numeric",
                "ConstantNode",
                "FunctionNode",
                "OperatorNode",
                "ParenthesisNode",
                "SymbolNode"
            ], (t)=>{
                var { typed: e, config: r, parse: n, simplify: i, equal: o, isZero: a, numeric: s, ConstantNode: u, FunctionNode: l, OperatorNode: c, ParenthesisNode: f, SymbolNode: h } = t;
                function p(t, e) {
                    var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {
                        simplify: !0
                    }, n = {};
                    y(n, t, e.name);
                    var o = g(t, n);
                    return r.simplify ? i(o) : o;
                }
                e.addConversion({
                    from: "identifier",
                    to: "SymbolNode",
                    convert: n
                });
                var d = e("derivative", {
                    "Node, SymbolNode": p,
                    "Node, SymbolNode, Object": p
                });
                e.removeConversion({
                    from: "identifier",
                    to: "SymbolNode",
                    convert: n
                }), d._simplify = !0, d.toTex = function(t) {
                    return m.apply(null, t.args);
                };
                var m = e("_derivTex", {
                    "Node, SymbolNode": function(t, e) {
                        return H(t) && "string" === nt(t.value) ? m(n(t.value).toString(), e.toString(), 1) : m(t.toTex(), e.toString(), 1);
                    },
                    "Node, ConstantNode": function(t, e) {
                        if ("string" === nt(e.value)) return m(t, n(e.value));
                        throw new Error("The second parameter to 'derivative' is a non-string constant");
                    },
                    "Node, SymbolNode, ConstantNode": function(t, e, r) {
                        return m(t.toString(), e.name, r.value);
                    },
                    "string, string, number": function(t, e, r) {
                        return (1 === r ? "{d\\over d" + e + "}" : "{d^{" + r + "}\\over d" + e + "^{" + r + "}}") + "\\left[".concat(t, "\\right]");
                    }
                }), y = e("constTag", {
                    "Object, ConstantNode, string": function(t, e) {
                        return t[e] = !0, !0;
                    },
                    "Object, SymbolNode, string": function(t, e, r) {
                        return e.name !== r && (t[e] = !0, !0);
                    },
                    "Object, ParenthesisNode, string": function(t, e, r) {
                        return y(t, e.content, r);
                    },
                    "Object, FunctionAssignmentNode, string": function(t, e, r) {
                        return -1 === e.params.indexOf(r) ? (t[e] = !0, !0) : y(t, e.expr, r);
                    },
                    "Object, FunctionNode | OperatorNode, string": function(t, e, r) {
                        if (e.args.length > 0) {
                            for(var n = y(t, e.args[0], r), i = 1; i < e.args.length; ++i)n = y(t, e.args[i], r) && n;
                            if (n) return t[e] = !0, !0;
                        }
                        return !1;
                    }
                }), g = e("_derivative", {
                    "ConstantNode, Object": function(t) {
                        return v(0);
                    },
                    "SymbolNode, Object": function(t, e) {
                        return void 0 !== e[t] ? v(0) : v(1);
                    },
                    "ParenthesisNode, Object": function(t, e) {
                        return new f(g(t.content, e));
                    },
                    "FunctionAssignmentNode, Object": function(t, e) {
                        return void 0 !== e[t] ? v(0) : g(t.expr, e);
                    },
                    "FunctionNode, Object": function(t, e) {
                        if (1 !== t.args.length && function(t) {
                            if (("log" === t.name || "nthRoot" === t.name || "pow" === t.name) && 2 === t.args.length) return;
                            for(var e = 0; e < t.args.length; ++e)t.args[e] = v(0);
                            throw t.compile().evaluate(), new Error('Function "' + t.name + '" is not supported by derivative, or a wrong number of arguments is passed');
                        }(t), void 0 !== e[t]) return v(0);
                        var r, n, i, o, a = t.args[0], s = !1, u = !1;
                        switch(t.name){
                            case "cbrt":
                                s = !0, n = new c("*", "multiply", [
                                    v(3),
                                    new c("^", "pow", [
                                        a,
                                        new c("/", "divide", [
                                            v(2),
                                            v(3)
                                        ])
                                    ])
                                ]);
                                break;
                            case "sqrt":
                            case "nthRoot":
                                if (1 === t.args.length) s = !0, n = new c("*", "multiply", [
                                    v(2),
                                    new l("sqrt", [
                                        a
                                    ])
                                ]);
                                else if (2 === t.args.length) return e[r = new c("/", "divide", [
                                    v(1),
                                    t.args[1]
                                ])] = e[t.args[1]], g(new c("^", "pow", [
                                    a,
                                    r
                                ]), e);
                                break;
                            case "log10":
                                r = v(10);
                            case "log":
                                if (r || 1 !== t.args.length) {
                                    if (1 === t.args.length && r || 2 === t.args.length && void 0 !== e[t.args[1]]) n = new c("*", "multiply", [
                                        a.clone(),
                                        new l("log", [
                                            r || t.args[1]
                                        ])
                                    ]), s = !0;
                                    else if (2 === t.args.length) return g(new c("/", "divide", [
                                        new l("log", [
                                            a
                                        ]),
                                        new l("log", [
                                            t.args[1]
                                        ])
                                    ]), e);
                                } else n = a.clone(), s = !0;
                                break;
                            case "pow":
                                return e[r] = e[t.args[1]], g(new c("^", "pow", [
                                    a,
                                    t.args[1]
                                ]), e);
                            case "exp":
                                n = new l("exp", [
                                    a.clone()
                                ]);
                                break;
                            case "sin":
                                n = new l("cos", [
                                    a.clone()
                                ]);
                                break;
                            case "cos":
                                n = new c("-", "unaryMinus", [
                                    new l("sin", [
                                        a.clone()
                                    ])
                                ]);
                                break;
                            case "tan":
                                n = new c("^", "pow", [
                                    new l("sec", [
                                        a.clone()
                                    ]),
                                    v(2)
                                ]);
                                break;
                            case "sec":
                                n = new c("*", "multiply", [
                                    t,
                                    new l("tan", [
                                        a.clone()
                                    ])
                                ]);
                                break;
                            case "csc":
                                u = !0, n = new c("*", "multiply", [
                                    t,
                                    new l("cot", [
                                        a.clone()
                                    ])
                                ]);
                                break;
                            case "cot":
                                u = !0, n = new c("^", "pow", [
                                    new l("csc", [
                                        a.clone()
                                    ]),
                                    v(2)
                                ]);
                                break;
                            case "asin":
                                s = !0, n = new l("sqrt", [
                                    new c("-", "subtract", [
                                        v(1),
                                        new c("^", "pow", [
                                            a.clone(),
                                            v(2)
                                        ])
                                    ])
                                ]);
                                break;
                            case "acos":
                                s = !0, u = !0, n = new l("sqrt", [
                                    new c("-", "subtract", [
                                        v(1),
                                        new c("^", "pow", [
                                            a.clone(),
                                            v(2)
                                        ])
                                    ])
                                ]);
                                break;
                            case "atan":
                                s = !0, n = new c("+", "add", [
                                    new c("^", "pow", [
                                        a.clone(),
                                        v(2)
                                    ]),
                                    v(1)
                                ]);
                                break;
                            case "asec":
                                s = !0, n = new c("*", "multiply", [
                                    new l("abs", [
                                        a.clone()
                                    ]),
                                    new l("sqrt", [
                                        new c("-", "subtract", [
                                            new c("^", "pow", [
                                                a.clone(),
                                                v(2)
                                            ]),
                                            v(1)
                                        ])
                                    ])
                                ]);
                                break;
                            case "acsc":
                                s = !0, u = !0, n = new c("*", "multiply", [
                                    new l("abs", [
                                        a.clone()
                                    ]),
                                    new l("sqrt", [
                                        new c("-", "subtract", [
                                            new c("^", "pow", [
                                                a.clone(),
                                                v(2)
                                            ]),
                                            v(1)
                                        ])
                                    ])
                                ]);
                                break;
                            case "acot":
                                s = !0, u = !0, n = new c("+", "add", [
                                    new c("^", "pow", [
                                        a.clone(),
                                        v(2)
                                    ]),
                                    v(1)
                                ]);
                                break;
                            case "sinh":
                                n = new l("cosh", [
                                    a.clone()
                                ]);
                                break;
                            case "cosh":
                                n = new l("sinh", [
                                    a.clone()
                                ]);
                                break;
                            case "tanh":
                                n = new c("^", "pow", [
                                    new l("sech", [
                                        a.clone()
                                    ]),
                                    v(2)
                                ]);
                                break;
                            case "sech":
                                u = !0, n = new c("*", "multiply", [
                                    t,
                                    new l("tanh", [
                                        a.clone()
                                    ])
                                ]);
                                break;
                            case "csch":
                                u = !0, n = new c("*", "multiply", [
                                    t,
                                    new l("coth", [
                                        a.clone()
                                    ])
                                ]);
                                break;
                            case "coth":
                                u = !0, n = new c("^", "pow", [
                                    new l("csch", [
                                        a.clone()
                                    ]),
                                    v(2)
                                ]);
                                break;
                            case "asinh":
                                s = !0, n = new l("sqrt", [
                                    new c("+", "add", [
                                        new c("^", "pow", [
                                            a.clone(),
                                            v(2)
                                        ]),
                                        v(1)
                                    ])
                                ]);
                                break;
                            case "acosh":
                                s = !0, n = new l("sqrt", [
                                    new c("-", "subtract", [
                                        new c("^", "pow", [
                                            a.clone(),
                                            v(2)
                                        ]),
                                        v(1)
                                    ])
                                ]);
                                break;
                            case "atanh":
                                s = !0, n = new c("-", "subtract", [
                                    v(1),
                                    new c("^", "pow", [
                                        a.clone(),
                                        v(2)
                                    ])
                                ]);
                                break;
                            case "asech":
                                s = !0, u = !0, n = new c("*", "multiply", [
                                    a.clone(),
                                    new l("sqrt", [
                                        new c("-", "subtract", [
                                            v(1),
                                            new c("^", "pow", [
                                                a.clone(),
                                                v(2)
                                            ])
                                        ])
                                    ])
                                ]);
                                break;
                            case "acsch":
                                s = !0, u = !0, n = new c("*", "multiply", [
                                    new l("abs", [
                                        a.clone()
                                    ]),
                                    new l("sqrt", [
                                        new c("+", "add", [
                                            new c("^", "pow", [
                                                a.clone(),
                                                v(2)
                                            ]),
                                            v(1)
                                        ])
                                    ])
                                ]);
                                break;
                            case "acoth":
                                s = !0, u = !0, n = new c("-", "subtract", [
                                    v(1),
                                    new c("^", "pow", [
                                        a.clone(),
                                        v(2)
                                    ])
                                ]);
                                break;
                            case "abs":
                                n = new c("/", "divide", [
                                    new l(new h("abs"), [
                                        a.clone()
                                    ]),
                                    a.clone()
                                ]);
                                break;
                            case "gamma":
                            default:
                                throw new Error('Function "' + t.name + '" is not supported by derivative, or a wrong number of arguments is passed');
                        }
                        s ? (i = "/", o = "divide") : (i = "*", o = "multiply");
                        var f = g(a, e);
                        return u && (f = new c("-", "unaryMinus", [
                            f
                        ])), new c(i, o, [
                            f,
                            n
                        ]);
                    },
                    "OperatorNode, Object": function(t, e) {
                        if (void 0 !== e[t]) return v(0);
                        if ("+" === t.op) return new c(t.op, t.fn, t.args.map(function(t) {
                            return g(t, e);
                        }));
                        if ("-" === t.op) {
                            if (t.isUnary()) return new c(t.op, t.fn, [
                                g(t.args[0], e)
                            ]);
                            if (t.isBinary()) return new c(t.op, t.fn, [
                                g(t.args[0], e),
                                g(t.args[1], e)
                            ]);
                        }
                        if ("*" === t.op) {
                            var r = t.args.filter(function(t) {
                                return void 0 !== e[t];
                            });
                            if (r.length > 0) {
                                var n = t.args.filter(function(t) {
                                    return void 0 === e[t];
                                }), i = 1 === n.length ? n[0] : new c("*", "multiply", n), s = r.concat(g(i, e));
                                return new c("*", "multiply", s);
                            }
                            return new c("+", "add", t.args.map(function(r) {
                                return new c("*", "multiply", t.args.map(function(t) {
                                    return t === r ? g(t, e) : t.clone();
                                }));
                            }));
                        }
                        if ("/" === t.op && t.isBinary()) {
                            var u = t.args[0], f = t.args[1];
                            return void 0 !== e[f] ? new c("/", "divide", [
                                g(u, e),
                                f
                            ]) : void 0 !== e[u] ? new c("*", "multiply", [
                                new c("-", "unaryMinus", [
                                    u
                                ]),
                                new c("/", "divide", [
                                    g(f, e),
                                    new c("^", "pow", [
                                        f.clone(),
                                        v(2)
                                    ])
                                ])
                            ]) : new c("/", "divide", [
                                new c("-", "subtract", [
                                    new c("*", "multiply", [
                                        g(u, e),
                                        f.clone()
                                    ]),
                                    new c("*", "multiply", [
                                        u.clone(),
                                        g(f, e)
                                    ])
                                ]),
                                new c("^", "pow", [
                                    f.clone(),
                                    v(2)
                                ])
                            ]);
                        }
                        if ("^" === t.op && t.isBinary()) {
                            var h = t.args[0], p = t.args[1];
                            if (void 0 !== e[h]) return H(h) && (a(h.value) || o(h.value, 1)) ? v(0) : new c("*", "multiply", [
                                t,
                                new c("*", "multiply", [
                                    new l("log", [
                                        h.clone()
                                    ]),
                                    g(p.clone(), e)
                                ])
                            ]);
                            if (void 0 !== e[p]) {
                                if (H(p)) {
                                    if (a(p.value)) return v(0);
                                    if (o(p.value, 1)) return g(h, e);
                                }
                                var d = new c("^", "pow", [
                                    h.clone(),
                                    new c("-", "subtract", [
                                        p,
                                        v(1)
                                    ])
                                ]);
                                return new c("*", "multiply", [
                                    p.clone(),
                                    new c("*", "multiply", [
                                        g(h, e),
                                        d
                                    ])
                                ]);
                            }
                            return new c("*", "multiply", [
                                new c("^", "pow", [
                                    h.clone(),
                                    p.clone()
                                ]),
                                new c("+", "add", [
                                    new c("*", "multiply", [
                                        g(h, e),
                                        new c("/", "divide", [
                                            p.clone(),
                                            h.clone()
                                        ])
                                    ]),
                                    new c("*", "multiply", [
                                        g(p, e),
                                        new l("log", [
                                            h.clone()
                                        ])
                                    ])
                                ])
                            ]);
                        }
                        throw new Error('Operator "' + t.op + '" is not supported by derivative, or a wrong number of arguments is passed');
                    }
                });
                function v(t, e) {
                    return new u(s(t, e || r.number));
                }
                return d;
            }), tn = r(30), en = r.n(tn);
            function rn(t, e, r, n, i) {
                if (en.a.isTypedFunction(t)) {
                    var o = [
                        e,
                        r,
                        n
                    ], a = en.a.resolve(t, o);
                    if (a) return f(a.implementation, o);
                    var s = [
                        e,
                        r
                    ], u = en.a.resolve(t, s);
                    if (u) return f(u.implementation, s);
                    var l = [
                        e
                    ], c = en.a.resolve(t, l);
                    return c ? f(c.implementation, l) : f(t, o);
                }
                return t(e, r, n);
                function f(o, a) {
                    try {
                        return o.apply(o, a);
                    } catch (o) {
                        var s;
                        if (o instanceof TypeError && "wrongType" === (null === (s = o.data) || void 0 === s ? void 0 : s.category)) {
                            var u = [];
                            throw u.push("value: ".concat(nt(e))), a.length >= 2 && u.push("index: ".concat(nt(r))), a.length >= 3 && u.push("array: ".concat(nt(n))), new TypeError("Function ".concat(i, " cannot apply callback arguments ") + "".concat(t.name, "(").concat(u.join(", "), ") at index ").concat(JSON.stringify(r)));
                        }
                        throw new TypeError("Function ".concat(i, " cannot apply callback arguments ") + "to function ".concat(t.name, ": ").concat(o.message));
                    }
                }
            }
            function nn(t, e, r) {
                var n = t.filter(function(t) {
                    return et(t) && !(t.name in e) && !r.has(t.name);
                })[0];
                if (!n) throw new Error('No undefined variable found in inline expression "' + t + '"');
                var i = n.name, o = pr(r), a = t.compile();
                return function(t) {
                    return o.set(i, t), a.evaluate(o);
                };
            }
            var on = ge("filter", [
                "typed"
            ], (t)=>{
                var { typed: e } = t;
                function r(t, e, r) {
                    var i, o;
                    return t[0] && (i = t[0].compile().evaluate(r)), t[1] && (o = et(t[1]) || $(t[1]) ? t[1].compile().evaluate(r) : nn(t[1], e, r)), n(i, o);
                }
                r.rawArgs = !0;
                var n = e("filter", {
                    "Array, function": an,
                    "Matrix, function": function(t, e) {
                        return t.create(an(t.toArray(), e));
                    },
                    "Array, RegExp": se,
                    "Matrix, RegExp": function(t, e) {
                        return t.create(se(t.toArray(), e));
                    }
                });
                return r;
            }, {
                isTransformFunction: !0
            });
            function an(t, e) {
                return ae(t, function(t, r, n) {
                    return rn(e, t, [
                        r + 1
                    ], n, "filter");
                });
            }
            var sn = ge("forEach", [
                "typed"
            ], (t)=>{
                var { typed: e } = t;
                function r(t, e, r) {
                    var i, o;
                    return t[0] && (i = t[0].compile().evaluate(r)), t[1] && (o = et(t[1]) || $(t[1]) ? t[1].compile().evaluate(r) : nn(t[1], e, r)), n(i, o);
                }
                r.rawArgs = !0;
                var n = e("forEach", {
                    "Array | Matrix, function": function(t, e) {
                        !function r(n, i) {
                            if (!Array.isArray(n)) return rn(e, n, i, t, "forEach");
                            oe(n, function(t, e) {
                                r(t, i.concat(e + 1));
                            });
                        }(t.valueOf(), []);
                    }
                });
                return r;
            }, {
                isTransformFunction: !0
            }), un = ge("map", [
                "typed"
            ], (t)=>{
                var { typed: e } = t;
                function r(t, e, r) {
                    var i, o;
                    return t[0] && (i = t[0].compile().evaluate(r)), t[1] && (o = et(t[1]) || $(t[1]) ? t[1].compile().evaluate(r) : nn(t[1], e, r)), n(i, o);
                }
                r.rawArgs = !0;
                var n = e("map", {
                    "Array, function": function(t, e) {
                        return ln(t, e, t);
                    },
                    "Matrix, function": function(t, e) {
                        return t.create(ln(t.valueOf(), e, t));
                    }
                });
                return r;
            }, {
                isTransformFunction: !0
            });
            function ln(t, e, r) {
                return function t(n, i) {
                    return Array.isArray(n) ? ie(n, function(e, r) {
                        return t(e, i.concat(r + 1));
                    }) : rn(e, n, i, r, "map");
                }(t, []);
            }
            var cn = ge("apply", [
                "typed",
                "isInteger"
            ], (t)=>{
                var { typed: e, isInteger: r } = t;
                return e("apply", {
                    "Array | Matrix, number | BigNumber, function": function(t, e, n) {
                        if (!r(e)) throw new TypeError("Integer number expected for dimension");
                        var i = Array.isArray(t) ? $t(t) : t.size();
                        if (e < 0 || e >= i.length) throw new Wt(e, i.length);
                        return E(t) ? t.create(fn(t.valueOf(), e, n)) : fn(t, e, n);
                    }
                });
            });
            function fn(t, e, r) {
                var n, i, o;
                if (e <= 0) {
                    if (Array.isArray(t[0])) {
                        for(o = function(t) {
                            var e, r, n = t.length, i = t[0].length, o = [];
                            for(r = 0; r < i; r++){
                                var a = [];
                                for(e = 0; e < n; e++)a.push(t[e][r]);
                                o.push(a);
                            }
                            return o;
                        }(t), i = [], n = 0; n < o.length; n++)i[n] = fn(o[n], e - 1, r);
                        return i;
                    }
                    return r(t);
                }
                for(i = [], n = 0; n < t.length; n++)i[n] = fn(t[n], e - 1, r);
                return i;
            }
            var hn = ge("apply", [
                "typed",
                "isInteger"
            ], (t)=>{
                var { typed: e, isInteger: r } = t, n = cn({
                    typed: e,
                    isInteger: r
                });
                return e("apply", {
                    "...any": function(t) {
                        var e = t[1];
                        g(e) ? t[1] = e - 1 : v(e) && (t[1] = e.minus(1));
                        try {
                            return n.apply(null, t);
                        } catch (t) {
                            throw ur(t);
                        }
                    }
                });
            }, {
                isTransformFunction: !0
            }), pn = ge("concat", [
                "typed",
                "matrix",
                "isInteger"
            ], (t)=>{
                var { typed: e, matrix: r, isInteger: n } = t;
                return e("concat", {
                    "...Array | Matrix | number | BigNumber": function(t) {
                        var e, i, o = t.length, a = -1, s = !1, u = [];
                        for(e = 0; e < o; e++){
                            var l = t[e];
                            if (E(l) && (s = !0), g(l) || v(l)) {
                                if (e !== o - 1) throw new Error("Dimension must be specified as last argument");
                                if (i = a, a = l.valueOf(), !n(a)) throw new TypeError("Integer number expected for dimension");
                                if (a < 0 || e > 0 && a > i) throw new Wt(a, i + 1);
                            } else {
                                var c = it(l).valueOf(), f = $t(c);
                                if (u[e] = c, i = a, a = f.length - 1, e > 0 && a !== i) throw new Ht(i + 1, a + 1);
                            }
                        }
                        if (0 === u.length) throw new SyntaxError("At least one matrix expected");
                        for(var h = u.shift(); u.length;)h = pe(h, u.shift(), a);
                        return s ? r(h) : h;
                    },
                    "...string": function(t) {
                        return t.join("");
                    }
                });
            }), dn = ge("concat", [
                "typed",
                "matrix",
                "isInteger"
            ], (t)=>{
                var { typed: e, matrix: r, isInteger: n } = t, i = pn({
                    typed: e,
                    matrix: r,
                    isInteger: n
                });
                return e("concat", {
                    "...any": function(t) {
                        var e = t.length - 1, r = t[e];
                        g(r) ? t[e] = r - 1 : v(r) && (t[e] = r.minus(1));
                        try {
                            return i.apply(null, t);
                        } catch (t) {
                            throw ur(t);
                        }
                    }
                });
            }, {
                isTransformFunction: !0
            });
            function mn(t, e, r) {
                var n;
                return -1 !== String(t).indexOf("Unexpected type") ? (n = arguments.length > 2 ? " (type: " + nt(r) + ", value: " + JSON.stringify(r) + ")" : " (type: " + t.data.actual + ")", new TypeError("Cannot calculate " + e + ", unexpected type of argument" + n)) : -1 !== String(t).indexOf("complex numbers") ? (n = arguments.length > 2 ? " (type: " + nt(r) + ", value: " + JSON.stringify(r) + ")" : "", new TypeError("Cannot calculate " + e + ", no ordering relation is defined for complex numbers" + n)) : t;
            }
            var yn = ge("max", [
                "typed",
                "config",
                "numeric",
                "larger"
            ], (t)=>{
                var { typed: e, config: r, numeric: n, larger: i } = t;
                return e("max", {
                    "Array | Matrix": a,
                    "Array | Matrix, number | BigNumber": function(t, e) {
                        return br(t, e.valueOf(), o);
                    },
                    "...": function(t) {
                        if (yr(t)) throw new TypeError("Scalar values expected in function max");
                        return a(t);
                    }
                });
                function o(t, e) {
                    try {
                        return i(t, e) ? t : e;
                    } catch (t) {
                        throw mn(t, "max", e);
                    }
                }
                function a(t) {
                    var e;
                    if (gr(t, function(t) {
                        try {
                            isNaN(t) && "number" == typeof t ? e = NaN : (void 0 === e || i(t, e)) && (e = t);
                        } catch (e) {
                            throw mn(e, "max", t);
                        }
                    }), void 0 === e) throw new Error("Cannot calculate max of an empty array");
                    return "string" == typeof e && (e = n(e, r.number)), e;
                }
            });
            function gn(t) {
                if (2 === t.length && S(t[0])) {
                    var e = (t = t.slice())[1];
                    g(e) ? t[1] = e - 1 : v(e) && (t[1] = e.minus(1));
                }
                return t;
            }
            var vn = ge("max", [
                "typed",
                "config",
                "numeric",
                "larger"
            ], (t)=>{
                var { typed: e, config: r, numeric: n, larger: i } = t, o = yn({
                    typed: e,
                    config: r,
                    numeric: n,
                    larger: i
                });
                return e("max", {
                    "...any": function(t) {
                        t = gn(t);
                        try {
                            return o.apply(null, t);
                        } catch (t) {
                            throw ur(t);
                        }
                    }
                });
            }, {
                isTransformFunction: !0
            }), bn = /\$([\w.]+)/g, xn = ge("print", [
                "typed"
            ], (t)=>{
                var { typed: e } = t;
                return e("print", {
                    "string, Object | Array": wn,
                    "string, Object | Array, number | Object": wn
                });
            });
            function wn(t, e, r) {
                return t.replace(bn, function(t, n) {
                    var i = n.split("."), o = e[i.shift()];
                    for(void 0 !== o && o.isMatrix && (o = o.toArray()); i.length && void 0 !== o;){
                        var a = i.shift();
                        o = a ? o[a] : o + ".";
                    }
                    return void 0 !== o ? _(o) ? o : Lt(o, r) : t;
                });
            }
            var _n = ge("print", [
                "typed",
                "matrix",
                "zeros",
                "add"
            ], (t)=>{
                var { typed: e, matrix: r, zeros: n, add: i } = t, o = xn({
                    typed: e,
                    matrix: r,
                    zeros: n,
                    add: i
                });
                return e("print", {
                    "string, Object | Array": function(t, e) {
                        return o(a(t), e);
                    },
                    "string, Object | Array, number | Object": function(t, e, r) {
                        return o(a(t), e, r);
                    }
                });
                function a(t) {
                    return t.replace(bn, (t)=>"$" + t.slice(1).split(".").map(function(t) {
                            return !isNaN(t) && t.length > 0 ? parseInt(t) - 1 : t;
                        }).join("."));
                }
            }, {
                isTransformFunction: !0
            }), An = ge("diff", [
                "typed",
                "matrix",
                "subtract",
                "number"
            ], (t)=>{
                var { typed: e, matrix: r, subtract: n, number: i } = t;
                return e("diff", {
                    "Array | Matrix": function(t) {
                        return E(t) ? r(a(t.toArray())) : a(t);
                    },
                    "Array | Matrix, number": function(t, e) {
                        if (!pt(e)) throw new RangeError("Dimension must be a whole number");
                        return E(t) ? r(o(t.toArray(), e)) : o(t, e);
                    },
                    "Array, BigNumber": e.referTo("Array,number", (t)=>(e, r)=>t(e, i(r))),
                    "Matrix, BigNumber": e.referTo("Matrix,number", (t)=>(e, r)=>t(e, i(r)))
                });
                function o(t, e) {
                    if (E(t) && (t = t.toArray()), !Array.isArray(t)) throw RangeError("Array/Matrix does not have that many dimensions");
                    if (e > 0) {
                        var r = [];
                        return t.forEach((t)=>{
                            r.push(o(t, e - 1));
                        }), r;
                    }
                    if (0 === e) return a(t);
                    throw RangeError("Cannot have negative dimension");
                }
                function a(t) {
                    for(var e = [], r = t.length, n = 1; n < r; n++)e.push(s(t[n - 1], t[n]));
                    return e;
                }
                function s(t, e) {
                    E(t) && (t = t.toArray()), E(e) && (e = e.toArray());
                    var r = Array.isArray(t), i = Array.isArray(e);
                    if (r && i) return function(t, e) {
                        if (t.length !== e.length) throw RangeError("Not all sub-arrays have the same length");
                        for(var r = [], n = t.length, i = 0; i < n; i++)r.push(s(t[i], e[i]));
                        return r;
                    }(t, e);
                    if (!r && !i) return n(e, t);
                    throw TypeError("Cannot calculate difference between 1 array and 1 non-array");
                }
            }), En = ge("diff", [
                "typed",
                "matrix",
                "subtract",
                "number",
                "bignumber"
            ], (t)=>{
                var { typed: e, matrix: r, subtract: n, number: i, bignumber: o } = t, a = An({
                    typed: e,
                    matrix: r,
                    subtract: n,
                    number: i,
                    bignumber: o
                });
                return e("diff", {
                    "...any": function(t) {
                        t = gn(t);
                        try {
                            return a.apply(null, t);
                        } catch (t) {
                            throw ur(t);
                        }
                    }
                });
            }, {
                isTransformFunction: !0
            }), Sn = ge("min", [
                "typed",
                "config",
                "numeric",
                "smaller"
            ], (t)=>{
                var { typed: e, config: r, numeric: n, smaller: i } = t;
                return e("min", {
                    "Array | Matrix": a,
                    "Array | Matrix, number | BigNumber": function(t, e) {
                        return br(t, e.valueOf(), o);
                    },
                    "...": function(t) {
                        if (yr(t)) throw new TypeError("Scalar values expected in function min");
                        return a(t);
                    }
                });
                function o(t, e) {
                    try {
                        return i(t, e) ? t : e;
                    } catch (t) {
                        throw mn(t, "min", e);
                    }
                }
                function a(t) {
                    var e;
                    if (gr(t, function(t) {
                        try {
                            isNaN(t) && "number" == typeof t ? e = NaN : (void 0 === e || i(t, e)) && (e = t);
                        } catch (e) {
                            throw mn(e, "min", t);
                        }
                    }), void 0 === e) throw new Error("Cannot calculate min of an empty array");
                    return "string" == typeof e && (e = n(e, r.number)), e;
                }
            }), Mn = ge("min", [
                "typed",
                "config",
                "numeric",
                "smaller"
            ], (t)=>{
                var { typed: e, config: r, numeric: n, smaller: i } = t, o = Sn({
                    typed: e,
                    config: r,
                    numeric: n,
                    smaller: i
                });
                return e("min", {
                    "...any": function(t) {
                        t = gn(t);
                        try {
                            return o.apply(null, t);
                        } catch (t) {
                            throw ur(t);
                        }
                    }
                });
            }, {
                isTransformFunction: !0
            }), kn = ge("subset", [
                "typed",
                "matrix",
                "zeros",
                "add"
            ], (t)=>{
                var { typed: e, matrix: r, zeros: n, add: i } = t;
                return e("subset", {
                    "Matrix, Index": function(t, e) {
                        return Kt(e) ? r() : (Zt(t, e), t.subset(e));
                    },
                    "Array, Index": e.referTo("Matrix, Index", function(t) {
                        return function(e, n) {
                            var i = t(r(e), n);
                            return n.isScalar() ? i : i.valueOf();
                        };
                    }),
                    "Object, Index": Dn,
                    "string, Index": Nn,
                    "Matrix, Index, any, any": function(t, e, r, o) {
                        return Kt(e) ? t : (Zt(t, e), t.clone().subset(e, function(t, e) {
                            if ("string" == typeof t) throw new Error("can't boradcast a string");
                            if (e._isScalar) return t;
                            var r = e.size();
                            if (!r.every((t)=>t > 0)) return t;
                            try {
                                return i(t, n(r));
                            } catch (e) {
                                return t;
                            }
                        }(r, e), o));
                    },
                    "Array, Index, any, any": e.referTo("Matrix, Index, any, any", function(t) {
                        return function(e, n, i, o) {
                            var a = t(r(e), n, i, o);
                            return a.isMatrix ? a.valueOf() : a;
                        };
                    }),
                    "Array, Index, any": e.referTo("Matrix, Index, any, any", function(t) {
                        return function(e, n, i) {
                            return t(r(e), n, i, void 0).valueOf();
                        };
                    }),
                    "Matrix, Index, any": e.referTo("Matrix, Index, any, any", function(t) {
                        return function(e, r, n) {
                            return t(e, r, n, void 0);
                        };
                    }),
                    "string, Index, string": Cn,
                    "string, Index, string, string": Cn,
                    "Object, Index, any": On
                });
            });
            function Nn(t, e) {
                if (!C(e)) throw new TypeError("Index expected");
                if (Kt(e)) return "";
                if (Zt(Array.from(t), e), 1 !== e.size().length) throw new Ht(e.size().length, 1);
                var r = t.length;
                Yt(e.min()[0], r), Yt(e.max()[0], r);
                var n = e.dimension(0), i = "";
                return n.forEach(function(e) {
                    i += t.charAt(e);
                }), i;
            }
            function Cn(t, e, r, n) {
                if (!e || !0 !== e.isIndex) throw new TypeError("Index expected");
                if (Kt(e)) return t;
                if (Zt(Array.from(t), e), 1 !== e.size().length) throw new Ht(e.size().length, 1);
                if (void 0 !== n) {
                    if ("string" != typeof n || 1 !== n.length) throw new TypeError("Single character expected as defaultValue");
                } else n = " ";
                var i = e.dimension(0);
                if (i.size()[0] !== r.length) throw new Ht(i.size()[0], r.length);
                var o = t.length;
                Yt(e.min()[0]), Yt(e.max()[0]);
                for(var a = [], s = 0; s < o; s++)a[s] = t.charAt(s);
                if (i.forEach(function(t, e) {
                    a[t] = r.charAt(e[0]);
                }), a.length > o) for(var u = o - 1, l = a.length; u < l; u++)a[u] || (a[u] = n);
                return a.join("");
            }
            function Dn(t, e) {
                if (!Kt(e)) {
                    if (1 !== e.size().length) throw new Ht(e.size(), 1);
                    var r = e.dimension(0);
                    if ("string" != typeof r) throw new TypeError("String expected as index to retrieve an object property");
                    return be(t, r);
                }
            }
            function On(t, e, r) {
                if (Kt(e)) return t;
                if (1 !== e.size().length) throw new Ht(e.size(), 1);
                var n = e.dimension(0);
                if ("string" != typeof n) throw new TypeError("String expected as index to retrieve an object property");
                var i = it(t);
                return xe(i, n, r), i;
            }
            var Tn = ge("subset", [
                "typed",
                "matrix",
                "zeros",
                "add"
            ], (t)=>{
                var { typed: e, matrix: r, zeros: n, add: i } = t, o = kn({
                    typed: e,
                    matrix: r,
                    zeros: n,
                    add: i
                });
                return e("subset", {
                    "...any": function(t) {
                        try {
                            return o.apply(null, t);
                        } catch (t) {
                            throw ur(t);
                        }
                    }
                });
            }, {
                isTransformFunction: !0
            }), Fn = ge("cumsum", [
                "typed",
                "add",
                "unaryPlus"
            ], (t)=>{
                var { typed: e, add: r, unaryPlus: n } = t;
                return e("cumsum", {
                    Array: i,
                    Matrix: function(t) {
                        return t.create(i(t.valueOf()));
                    },
                    "Array, number | BigNumber": a,
                    "Matrix, number | BigNumber": function(t, e) {
                        return t.create(a(t.valueOf(), e));
                    },
                    "...": function(t) {
                        if (yr(t)) throw new TypeError("All values expected to be scalar in function cumsum");
                        return i(t);
                    }
                });
                function i(t) {
                    try {
                        return o(t);
                    } catch (t) {
                        throw mn(t, "cumsum");
                    }
                }
                function o(t) {
                    if (0 === t.length) return [];
                    for(var e = [
                        n(t[0])
                    ], i = 1; i < t.length; ++i)e.push(r(e[i - 1], t[i]));
                    return e;
                }
                function a(t, e) {
                    var r = $t(t);
                    if (e < 0 || e >= r.length) throw new Wt(e, r.length);
                    try {
                        return function t(e, r) {
                            var n, i, a;
                            if (r <= 0) {
                                var s = e[0][0];
                                if (Array.isArray(s)) {
                                    for(a = mr(e), i = [], n = 0; n < a.length; n++)i[n] = t(a[n], r - 1);
                                    return i;
                                }
                                return o(e);
                            }
                            for(i = [], n = 0; n < e.length; n++)i[n] = t(e[n], r - 1);
                            return i;
                        }(t, e);
                    } catch (t) {
                        throw mn(t, "cumsum");
                    }
                }
            }), Pn = ge("cumsum", [
                "typed",
                "add",
                "unaryPlus"
            ], (t)=>{
                var { typed: e, add: r, unaryPlus: n } = t, i = Fn({
                    typed: e,
                    add: r,
                    unaryPlus: n
                });
                return e("cumsum", {
                    "...any": function(t) {
                        if (2 === t.length && S(t[0])) {
                            var e = t[1];
                            g(e) ? t[1] = e - 1 : v(e) && (t[1] = e.minus(1));
                        }
                        try {
                            return i.apply(null, t);
                        } catch (t) {
                            throw ur(t);
                        }
                    }
                });
            }, {
                isTransformFunction: !0
            }), In = ge("index", [
                "Index",
                "getMatrixDataType"
            ], (t)=>{
                var { Index: e, getMatrixDataType: r } = t;
                return function() {
                    for(var t = [], n = 0, i = arguments.length; n < i; n++){
                        var o = arguments[n];
                        if (N(o)) o.start--, o.end -= o.step > 0 ? 0 : 2;
                        else if (o && !0 === o.isSet) o = o.map(function(t) {
                            return t - 1;
                        });
                        else if (A(o) || E(o)) "boolean" !== r(o) && (o = o.map(function(t) {
                            return t - 1;
                        }));
                        else if (g(o)) o--;
                        else if (v(o)) o = o.toNumber() - 1;
                        else if ("string" != typeof o) throw new TypeError("Dimension must be an Array, Matrix, number, string, or Range");
                        t[n] = o;
                    }
                    var a = new e;
                    return e.apply(a, t), a;
                };
            }, {
                isTransformFunction: !0
            }), Bn = ge("sum", [
                "typed",
                "config",
                "add",
                "numeric"
            ], (t)=>{
                var { typed: e, config: r, add: n, numeric: i } = t;
                return e("sum", {
                    "Array | Matrix": o,
                    "Array | Matrix, number | BigNumber": function(t, e) {
                        try {
                            return br(t, e, n);
                        } catch (t) {
                            throw mn(t, "sum");
                        }
                    },
                    "...": function(t) {
                        if (yr(t)) throw new TypeError("Scalar values expected in function sum");
                        return o(t);
                    }
                });
                function o(t) {
                    var e;
                    return gr(t, function(t) {
                        try {
                            e = void 0 === e ? t : n(e, t);
                        } catch (e) {
                            throw mn(e, "sum", t);
                        }
                    }), void 0 === e && (e = i(0, r.number)), "string" == typeof e && (e = i(e, r.number)), e;
                }
            }), jn = ge("sum", [
                "typed",
                "config",
                "add",
                "numeric"
            ], (t)=>{
                var { typed: e, config: r, add: n, numeric: i } = t, o = Bn({
                    typed: e,
                    config: r,
                    add: n,
                    numeric: i
                });
                return e("sum", {
                    "...any": function(t) {
                        t = gn(t);
                        try {
                            return o.apply(null, t);
                        } catch (t) {
                            throw ur(t);
                        }
                    }
                });
            }, {
                isTransformFunction: !0
            }), Rn = ge("range", [
                "typed",
                "config",
                "?matrix",
                "?bignumber",
                "smaller",
                "smallerEq",
                "larger",
                "largerEq",
                "add",
                "isPositive"
            ], (t)=>{
                var { typed: e, config: r, matrix: n, bignumber: i, smaller: o, smallerEq: a, larger: s, largerEq: u, add: l, isPositive: c } = t;
                return e("range", {
                    string: h,
                    "string, boolean": h,
                    "number, number": function(t, e) {
                        return f(p(t, e, 1, !1));
                    },
                    "number, number, number": function(t, e, r) {
                        return f(p(t, e, r, !1));
                    },
                    "number, number, boolean": function(t, e, r) {
                        return f(p(t, e, 1, r));
                    },
                    "number, number, number, boolean": function(t, e, r, n) {
                        return f(p(t, e, r, n));
                    },
                    "BigNumber, BigNumber": function(t, e) {
                        return f(p(t, e, new t.constructor(1), !1));
                    },
                    "BigNumber, BigNumber, BigNumber": function(t, e, r) {
                        return f(p(t, e, r, !1));
                    },
                    "BigNumber, BigNumber, boolean": function(t, e, r) {
                        return f(p(t, e, new t.constructor(1), r));
                    },
                    "BigNumber, BigNumber, BigNumber, boolean": function(t, e, r, n) {
                        return f(p(t, e, r, n));
                    },
                    "Unit, Unit, Unit": function(t, e, r) {
                        return f(p(t, e, r, !1));
                    },
                    "Unit, Unit, Unit, boolean": function(t, e, r, n) {
                        return f(p(t, e, r, n));
                    }
                });
                function f(t) {
                    return "Matrix" === r.matrix ? n ? n(t) : Cr() : t;
                }
                function h(t, e) {
                    var n = function(t) {
                        var e = t.split(":").map(function(t) {
                            return Number(t);
                        });
                        if (e.some(function(t) {
                            return isNaN(t);
                        })) return null;
                        switch(e.length){
                            case 2:
                                return {
                                    start: e[0],
                                    end: e[1],
                                    step: 1
                                };
                            case 3:
                                return {
                                    start: e[0],
                                    end: e[2],
                                    step: e[1]
                                };
                            default:
                                return null;
                        }
                    }(t);
                    if (!n) throw new SyntaxError('String "' + t + '" is no valid range');
                    return "BigNumber" === r.number ? (void 0 === i && kr(), f(p(i(n.start), i(n.end), i(n.step)))) : f(p(n.start, n.end, n.step, e));
                }
                function p(t, e, r, n) {
                    for(var i = [], f = c(r) ? n ? a : o : n ? u : s, h = t; f(h, e);)i.push(h), h = l(h, r);
                    return i;
                }
            }), Ln = ge("range", [
                "typed",
                "config",
                "?matrix",
                "?bignumber",
                "smaller",
                "smallerEq",
                "larger",
                "largerEq",
                "add",
                "isPositive"
            ], (t)=>{
                var { typed: e, config: r, matrix: n, bignumber: i, smaller: o, smallerEq: a, larger: s, largerEq: u, add: l, isPositive: c } = t, f = Rn({
                    typed: e,
                    config: r,
                    matrix: n,
                    bignumber: i,
                    smaller: o,
                    smallerEq: a,
                    larger: s,
                    largerEq: u,
                    add: l,
                    isPositive: c
                });
                return e("range", {
                    "...any": function(t) {
                        return "boolean" != typeof t[t.length - 1] && t.push(!0), f.apply(null, t);
                    }
                });
            }, {
                isTransformFunction: !0
            }), qn = ge("row", [
                "typed",
                "Index",
                "matrix",
                "range"
            ], (t)=>{
                var { typed: e, Index: r, matrix: n, range: i } = t;
                return e("row", {
                    "Matrix, number": o,
                    "Array, number": function(t, e) {
                        return o(n(it(t)), e).valueOf();
                    }
                });
                function o(t, e) {
                    if (2 !== t.size().length) throw new Error("Only two dimensional matrix is supported");
                    Yt(e, t.size()[0]);
                    var o = i(0, t.size()[1]), a = new r(e, o), s = t.subset(a);
                    return E(s) ? s : n([
                        [
                            s
                        ]
                    ]);
                }
            }), Un = ge("row", [
                "typed",
                "Index",
                "matrix",
                "range"
            ], (t)=>{
                var { typed: e, Index: r, matrix: n, range: i } = t, o = qn({
                    typed: e,
                    Index: r,
                    matrix: n,
                    range: i
                });
                return e("row", {
                    "...any": function(t) {
                        var e = t.length - 1, r = t[e];
                        g(r) && (t[e] = r - 1);
                        try {
                            return o.apply(null, t);
                        } catch (t) {
                            throw ur(t);
                        }
                    }
                });
            }, {
                isTransformFunction: !0
            }), zn = ge("column", [
                "typed",
                "Index",
                "matrix",
                "range"
            ], (t)=>{
                var { typed: e, Index: r, matrix: n, range: i } = t;
                return e("column", {
                    "Matrix, number": o,
                    "Array, number": function(t, e) {
                        return o(n(it(t)), e).valueOf();
                    }
                });
                function o(t, e) {
                    if (2 !== t.size().length) throw new Error("Only two dimensional matrix is supported");
                    Yt(e, t.size()[1]);
                    var o = i(0, t.size()[0]), a = new r(o, e), s = t.subset(a);
                    return E(s) ? s : n([
                        [
                            s
                        ]
                    ]);
                }
            }), Gn = ge("column", [
                "typed",
                "Index",
                "matrix",
                "range"
            ], (t)=>{
                var { typed: e, Index: r, matrix: n, range: i } = t, o = zn({
                    typed: e,
                    Index: r,
                    matrix: n,
                    range: i
                });
                return e("column", {
                    "...any": function(t) {
                        var e = t.length - 1, r = t[e];
                        g(r) && (t[e] = r - 1);
                        try {
                            return o.apply(null, t);
                        } catch (t) {
                            throw ur(t);
                        }
                    }
                });
            }, {
                isTransformFunction: !0
            }), Hn = ge("mean", [
                "typed",
                "add",
                "divide"
            ], (t)=>{
                var { typed: e, add: r, divide: n } = t;
                return e("mean", {
                    "Array | Matrix": i,
                    "Array | Matrix, number | BigNumber": function(t, e) {
                        try {
                            var i = br(t, e, r), o = Array.isArray(t) ? $t(t) : t.size();
                            return n(i, o[e]);
                        } catch (t) {
                            throw mn(t, "mean");
                        }
                    },
                    "...": function(t) {
                        if (yr(t)) throw new TypeError("Scalar values expected in function mean");
                        return i(t);
                    }
                });
                function i(t) {
                    var e, i = 0;
                    if (gr(t, function(t) {
                        try {
                            e = void 0 === e ? t : r(e, t), i++;
                        } catch (e) {
                            throw mn(e, "mean", t);
                        }
                    }), 0 === i) throw new Error("Cannot calculate the mean of an empty array");
                    return n(e, i);
                }
            }), Wn = ge("mean", [
                "typed",
                "add",
                "divide"
            ], (t)=>{
                var { typed: e, add: r, divide: n } = t, i = Hn({
                    typed: e,
                    add: r,
                    divide: n
                });
                return e("mean", {
                    "...any": function(t) {
                        t = gn(t);
                        try {
                            return i.apply(null, t);
                        } catch (t) {
                            throw ur(t);
                        }
                    }
                });
            }, {
                isTransformFunction: !0
            }), $n = ge("quantileSeq", [
                "typed",
                "?bignumber",
                "add",
                "subtract",
                "divide",
                "multiply",
                "partitionSelect",
                "compare",
                "isInteger",
                "smaller",
                "smallerEq",
                "larger"
            ], (t)=>{
                var { typed: e, bignumber: r, add: n, subtract: i, divide: o, multiply: a, partitionSelect: s, compare: u, isInteger: l, smaller: c, smallerEq: f, larger: h } = t, p = cn({
                    typed: e,
                    isInteger: l
                });
                return e("quantileSeq", {
                    "Array | Matrix, number | BigNumber": (t, e)=>m(t, e, !1),
                    "Array | Matrix, number | BigNumber, number": (t, e, r)=>d(t, e, !1, r, m),
                    "Array | Matrix, number | BigNumber, boolean": m,
                    "Array | Matrix, number | BigNumber, boolean, number": (t, e, r, n)=>d(t, e, r, n, m),
                    "Array | Matrix, Array | Matrix": (t, e)=>y(t, e, !1),
                    "Array | Matrix, Array | Matrix, number": (t, e, r)=>d(t, e, !1, r, y),
                    "Array | Matrix, Array | Matrix, boolean": y,
                    "Array | Matrix, Array | Matrix, boolean, number": (t, e, r, n)=>d(t, e, r, n, y)
                });
                function d(t, e, r, n, i) {
                    return p(t, n, (t)=>i(t, e, r));
                }
                function m(t, e, i) {
                    var a, s = t.valueOf();
                    if (c(e, 0)) throw new Error("N/prob must be non-negative");
                    if (f(e, 1)) return g(e) ? v(s, e, i) : r(v(s, e, i));
                    if (h(e, 1)) {
                        if (!l(e)) throw new Error("N must be a positive integer");
                        if (h(e, 4294967295)) throw new Error("N must be less than or equal to 2^32-1, as that is the maximum length of an Array");
                        var u = n(e, 1);
                        a = [];
                        for(var p = 0; c(p, e); p++){
                            var d = o(p + 1, u);
                            a.push(v(s, d, i));
                        }
                        return g(e) ? a : r(a);
                    }
                }
                function y(t, e, r) {
                    for(var n = t.valueOf(), i = e.valueOf(), o = [], a = 0; a < i.length; ++a)o.push(v(n, i[a], r));
                    return o;
                }
                function v(t, e, r) {
                    var o = ne(t), c = o.length;
                    if (0 === c) throw new Error("Cannot calculate quantile of an empty sequence");
                    var f, h, p = g(e) ? e * (c - 1) : e.times(c - 1), d = g(e) ? Math.floor(p) : p.floor().toNumber(), m = g(e) ? p % 1 : p.minus(d);
                    if (l(p)) return r ? o[p] : s(o, g(e) ? p : p.valueOf());
                    if (r) f = o[d], h = o[d + 1];
                    else {
                        h = s(o, d + 1), f = o[d];
                        for(var y = 0; y < d; ++y)u(o[y], f) > 0 && (f = o[y]);
                    }
                    return n(a(f, i(1, m)), a(h, m));
                }
            }), Vn = ge("quantileSeq", [
                "typed",
                "bignumber",
                "add",
                "subtract",
                "divide",
                "multiply",
                "partitionSelect",
                "compare",
                "isInteger",
                "smaller",
                "smallerEq",
                "larger"
            ], (t)=>{
                var { typed: e, bignumber: r, add: n, subtract: i, divide: o, multiply: a, partitionSelect: s, compare: u, isInteger: l, smaller: c, smallerEq: f, larger: h } = t, p = $n({
                    typed: e,
                    bignumber: r,
                    add: n,
                    subtract: i,
                    divide: o,
                    multiply: a,
                    partitionSelect: s,
                    compare: u,
                    isInteger: l,
                    smaller: c,
                    smallerEq: f,
                    larger: h
                });
                return e("quantileSeq", {
                    "Array | Matrix, number | BigNumber": p,
                    "Array | Matrix, number | BigNumber, number": (t, e, r)=>p(t, e, d(r)),
                    "Array | Matrix, number | BigNumber, boolean": p,
                    "Array | Matrix, number | BigNumber, boolean, number": (t, e, r, n)=>p(t, e, r, d(n)),
                    "Array | Matrix, Array | Matrix": p,
                    "Array | Matrix, Array | Matrix, number": (t, e, r)=>p(t, e, d(r)),
                    "Array | Matrix, Array | Matrix, boolean": p,
                    "Array | Matrix, Array | Matrix, boolean, number": (t, e, r, n)=>p(t, e, r, d(n))
                });
                function d(t) {
                    return gn([
                        [],
                        t
                    ])[1];
                }
            }, {
                isTransformFunction: !0
            }), Zn = ge("variance", [
                "typed",
                "add",
                "subtract",
                "multiply",
                "divide",
                "apply",
                "isNaN"
            ], (t)=>{
                var { typed: e, add: r, subtract: n, multiply: i, divide: o, apply: a, isNaN: s } = t;
                return e("variance", {
                    "Array | Matrix": function(t) {
                        return u(t, "unbiased");
                    },
                    "Array | Matrix, string": u,
                    "Array | Matrix, number | BigNumber": function(t, e) {
                        return l(t, e, "unbiased");
                    },
                    "Array | Matrix, number | BigNumber, string": l,
                    "...": function(t) {
                        return u(t, "unbiased");
                    }
                });
                function u(t, e) {
                    var a, u = 0;
                    if (0 === t.length) throw new SyntaxError("Function variance requires one or more parameters (0 provided)");
                    if (gr(t, function(t) {
                        try {
                            a = void 0 === a ? t : r(a, t), u++;
                        } catch (e) {
                            throw mn(e, "variance", t);
                        }
                    }), 0 === u) throw new Error("Cannot calculate variance of an empty array");
                    var l = o(a, u);
                    if (a = void 0, gr(t, function(t) {
                        var e = n(t, l);
                        a = void 0 === a ? i(e, e) : r(a, i(e, e));
                    }), s(a)) return a;
                    switch(e){
                        case "uncorrected":
                            return o(a, u);
                        case "biased":
                            return o(a, u + 1);
                        case "unbiased":
                            var c = v(a) ? a.mul(0) : 0;
                            return 1 === u ? c : o(a, u - 1);
                        default:
                            throw new Error('Unknown normalization "' + e + '". Choose "unbiased" (default), "uncorrected", or "biased".');
                    }
                }
                function l(t, e, r) {
                    try {
                        if (0 === t.length) throw new SyntaxError("Function variance requires one or more parameters (0 provided)");
                        return a(t, e, (t)=>u(t, r));
                    } catch (t) {
                        throw mn(t, "variance");
                    }
                }
            }), Yn = ge("variance", [
                "typed",
                "add",
                "subtract",
                "multiply",
                "divide",
                "apply",
                "isNaN"
            ], (t)=>{
                var { typed: e, add: r, subtract: n, multiply: i, divide: o, apply: a, isNaN: s } = t, u = Zn({
                    typed: e,
                    add: r,
                    subtract: n,
                    multiply: i,
                    divide: o,
                    apply: a,
                    isNaN: s
                });
                return e("variance", {
                    "...any": function(t) {
                        t = gn(t);
                        try {
                            return u.apply(null, t);
                        } catch (t) {
                            throw ur(t);
                        }
                    }
                });
            }, {
                isTransformFunction: !0
            }), Kn = ge("std", [
                "typed",
                "map",
                "sqrt",
                "variance"
            ], (t)=>{
                var { typed: e, map: r, sqrt: n, variance: i } = t;
                return e("std", {
                    "Array | Matrix": o,
                    "Array | Matrix, string": o,
                    "Array | Matrix, number | BigNumber": o,
                    "Array | Matrix, number | BigNumber, string": o,
                    "...": function(t) {
                        return o(t);
                    }
                });
                function o(t, e) {
                    if (0 === t.length) throw new SyntaxError("Function std requires one or more parameters (0 provided)");
                    try {
                        var o = i.apply(null, arguments);
                        return S(o) ? r(o, n) : n(o);
                    } catch (t) {
                        throw t instanceof TypeError && -1 !== t.message.indexOf(" variance") ? new TypeError(t.message.replace(" variance", " std")) : t;
                    }
                }
            }), Xn = ge("std", [
                "typed",
                "map",
                "sqrt",
                "variance"
            ], (t)=>{
                var { typed: e, map: r, sqrt: n, variance: i } = t, o = Kn({
                    typed: e,
                    map: r,
                    sqrt: n,
                    variance: i
                });
                return e("std", {
                    "...any": function(t) {
                        t = gn(t);
                        try {
                            return o.apply(null, t);
                        } catch (t) {
                            throw ur(t);
                        }
                    }
                });
            }, {
                isTransformFunction: !0
            }), Jn = r(33), Qn = r.n(Jn), ti = ge("BigNumber", [
                "?on",
                "config"
            ], (t)=>{
                var { on: e, config: r } = t, n = Qn.a.clone({
                    precision: r.precision,
                    modulo: Qn.a.EUCLID
                });
                return n.prototype = Object.create(n.prototype), n.prototype.type = "BigNumber", n.prototype.isBigNumber = !0, n.prototype.toJSON = function() {
                    return {
                        mathjs: "BigNumber",
                        value: this.toString()
                    };
                }, n.fromJSON = function(t) {
                    return new n(t.value);
                }, e && e("config", function(t, e) {
                    t.precision !== e.precision && n.config({
                        precision: t.precision
                    });
                }), n;
            }, {
                isClass: !0
            }), ei = r(10), ri = r.n(ei), ni = ge("Complex", [], ()=>(Object.defineProperty(ri.a, "name", {
                    value: "Complex"
                }), ri.a.prototype.constructor = ri.a, ri.a.prototype.type = "Complex", ri.a.prototype.isComplex = !0, ri.a.prototype.toJSON = function() {
                    return {
                        mathjs: "Complex",
                        re: this.re,
                        im: this.im
                    };
                }, ri.a.prototype.toPolar = function() {
                    return {
                        r: this.abs(),
                        phi: this.arg()
                    };
                }, ri.a.prototype.format = function(t) {
                    var e = this.im, r = this.re, n = wt(this.re, t), i = wt(this.im, t), o = g(t) ? t : t ? t.precision : null;
                    if (null !== o) {
                        var a = Math.pow(10, -o);
                        Math.abs(r / e) < a && (r = 0), Math.abs(e / r) < a && (e = 0);
                    }
                    return 0 === e ? n : 0 === r ? 1 === e ? "i" : -1 === e ? "-i" : i + "i" : e < 0 ? -1 === e ? n + " - i" : n + " - " + i.substring(1) + "i" : 1 === e ? n + " + i" : n + " + " + i + "i";
                }, ri.a.fromPolar = function(t) {
                    switch(arguments.length){
                        case 1:
                            var e = arguments[0];
                            if ("object" == typeof e) return ri()(e);
                            throw new TypeError("Input has to be an object with r and phi keys.");
                        case 2:
                            var r = arguments[0], n = arguments[1];
                            if (g(r)) {
                                if (w(n) && n.hasBase("ANGLE") && (n = n.toNumber("rad")), g(n)) return new ri.a({
                                    r: r,
                                    phi: n
                                });
                                throw new TypeError("Phi is not a number nor an angle unit.");
                            }
                            throw new TypeError("Radius r is not a number.");
                        default:
                            throw new SyntaxError("Wrong number of arguments in function fromPolar");
                    }
                }, ri.a.prototype.valueOf = ri.a.prototype.toString, ri.a.fromJSON = function(t) {
                    return new ri.a(t);
                }, ri.a.compare = function(t, e) {
                    return t.re > e.re ? 1 : t.re < e.re ? -1 : t.im > e.im ? 1 : t.im < e.im ? -1 : 0;
                }, ri.a), {
                isClass: !0
            });
            function ii(t) {
                var e = 0, r = 1, n = Object.create(null), i = Object.create(null), o = 0, a = function(t) {
                    var a = i[t];
                    if (a && (delete n[a], delete i[t], --e, r === a)) {
                        if (!e) return o = 0, void (r = 1);
                        for(; !Object.prototype.hasOwnProperty.call(n, ++r););
                    }
                };
                return t = Math.abs(t), {
                    hit: function(s) {
                        var u = i[s], l = ++o;
                        if (n[l] = s, i[s] = l, !u) {
                            if (++e <= t) return;
                            return s = n[r], a(s), s;
                        }
                        if (delete n[u], r === u) for(; !Object.prototype.hasOwnProperty.call(n, ++r););
                    },
                    delete: a,
                    clear: function() {
                        e = o = 0, r = 1, n = Object.create(null), i = Object.create(null);
                    }
                };
            }
            function oi(t) {
                var { hasher: e, limit: r } = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                return r = null == r ? Number.POSITIVE_INFINITY : r, e = null == e ? JSON.stringify : e, function n() {
                    "object" != typeof n.cache && (n.cache = {
                        values: new Map,
                        lru: ii(r || Number.POSITIVE_INFINITY)
                    });
                    for(var i = [], o = 0; o < arguments.length; o++)i[o] = arguments[o];
                    var a = e(i);
                    if (n.cache.values.has(a)) return n.cache.lru.hit(a), n.cache.values.get(a);
                    var s = t.apply(t, i);
                    return n.cache.values.set(a, s), n.cache.values.delete(n.cache.lru.hit(a)), s;
                };
            }
            function ai(t) {
                return Object.keys(t.signatures || {}).reduce(function(t, e) {
                    var r = (e.match(/,/g) || []).length + 1;
                    return Math.max(t, r);
                }, -1);
            }
            var si = oi(function(t) {
                return new t(1).exp();
            }, {
                hasher: fi
            }), ui = oi(function(t) {
                return new t(1).plus(new t(5).sqrt()).div(2);
            }, {
                hasher: fi
            }), li = oi(function(t) {
                return t.acos(-1);
            }, {
                hasher: fi
            }), ci = oi(function(t) {
                return li(t).times(2);
            }, {
                hasher: fi
            });
            function fi(t) {
                return t[0].precision;
            }
            var hi = Math.PI, pi = 2 * Math.PI, di = Math.E, mi = ge("true", [], ()=>!0), yi = ge("false", [], ()=>!1), gi = ge("null", [], ()=>null), vi = Ti("Infinity", [
                "config",
                "?BigNumber"
            ], (t)=>{
                var { config: e, BigNumber: r } = t;
                return "BigNumber" === e.number ? new r(1 / 0) : 1 / 0;
            }), bi = Ti("NaN", [
                "config",
                "?BigNumber"
            ], (t)=>{
                var { config: e, BigNumber: r } = t;
                return "BigNumber" === e.number ? new r(NaN) : NaN;
            }), xi = Ti("pi", [
                "config",
                "?BigNumber"
            ], (t)=>{
                var { config: e, BigNumber: r } = t;
                return "BigNumber" === e.number ? li(r) : hi;
            }), wi = Ti("tau", [
                "config",
                "?BigNumber"
            ], (t)=>{
                var { config: e, BigNumber: r } = t;
                return "BigNumber" === e.number ? ci(r) : pi;
            }), _i = Ti("e", [
                "config",
                "?BigNumber"
            ], (t)=>{
                var { config: e, BigNumber: r } = t;
                return "BigNumber" === e.number ? si(r) : di;
            }), Ai = Ti("phi", [
                "config",
                "?BigNumber"
            ], (t)=>{
                var { config: e, BigNumber: r } = t;
                return "BigNumber" === e.number ? ui(r) : 1.618033988749895;
            }), Ei = Ti("LN2", [
                "config",
                "?BigNumber"
            ], (t)=>{
                var { config: e, BigNumber: r } = t;
                return "BigNumber" === e.number ? new r(2).ln() : Math.LN2;
            }), Si = Ti("LN10", [
                "config",
                "?BigNumber"
            ], (t)=>{
                var { config: e, BigNumber: r } = t;
                return "BigNumber" === e.number ? new r(10).ln() : Math.LN10;
            }), Mi = Ti("LOG2E", [
                "config",
                "?BigNumber"
            ], (t)=>{
                var { config: e, BigNumber: r } = t;
                return "BigNumber" === e.number ? new r(1).div(new r(2).ln()) : Math.LOG2E;
            }), ki = Ti("LOG10E", [
                "config",
                "?BigNumber"
            ], (t)=>{
                var { config: e, BigNumber: r } = t;
                return "BigNumber" === e.number ? new r(1).div(new r(10).ln()) : Math.LOG10E;
            }), Ni = Ti("SQRT1_2", [
                "config",
                "?BigNumber"
            ], (t)=>{
                var { config: e, BigNumber: r } = t;
                return "BigNumber" === e.number ? new r("0.5").sqrt() : Math.SQRT1_2;
            }), Ci = Ti("SQRT2", [
                "config",
                "?BigNumber"
            ], (t)=>{
                var { config: e, BigNumber: r } = t;
                return "BigNumber" === e.number ? new r(2).sqrt() : Math.SQRT2;
            }), Di = Ti("i", [
                "Complex"
            ], (t)=>{
                var { Complex: e } = t;
                return e.I;
            }), Oi = ge("version", [], ()=>"11.12.0");
            function Ti(t, e, r) {
                return ge(t, e, r, {
                    recreateOnConfigChange: !0
                });
            }
            var Fi = Do("speedOfLight", "299792458", "m s^-1"), Pi = Do("gravitationConstant", "6.67430e-11", "m^3 kg^-1 s^-2"), Ii = Do("planckConstant", "6.62607015e-34", "J s"), Bi = Do("reducedPlanckConstant", "1.0545718176461565e-34", "J s"), ji = Do("magneticConstant", "1.25663706212e-6", "N A^-2"), Ri = Do("electricConstant", "8.8541878128e-12", "F m^-1"), Li = Do("vacuumImpedance", "376.730313667", "ohm"), qi = Do("coulomb", "8.987551792261171e9", "N m^2 C^-2"), Ui = Do("elementaryCharge", "1.602176634e-19", "C"), zi = Do("bohrMagneton", "9.2740100783e-24", "J T^-1"), Gi = Do("conductanceQuantum", "7.748091729863649e-5", "S"), Hi = Do("inverseConductanceQuantum", "12906.403729652257", "ohm"), Wi = Do("magneticFluxQuantum", "2.0678338484619295e-15", "Wb"), $i = Do("nuclearMagneton", "5.0507837461e-27", "J T^-1"), Vi = Do("klitzing", "25812.807459304513", "ohm"), Zi = Do("bohrRadius", "5.29177210903e-11", "m"), Yi = Do("classicalElectronRadius", "2.8179403262e-15", "m"), Ki = Do("electronMass", "9.1093837015e-31", "kg"), Xi = Do("fermiCoupling", "1.1663787e-5", "GeV^-2"), Ji = Oo("fineStructure", .0072973525693), Qi = Do("hartreeEnergy", "4.3597447222071e-18", "J"), to = Do("protonMass", "1.67262192369e-27", "kg"), eo = Do("deuteronMass", "3.3435830926e-27", "kg"), ro = Do("neutronMass", "1.6749271613e-27", "kg"), no = Do("quantumOfCirculation", "3.6369475516e-4", "m^2 s^-1"), io = Do("rydberg", "10973731.568160", "m^-1"), oo = Do("thomsonCrossSection", "6.6524587321e-29", "m^2"), ao = Oo("weakMixingAngle", .2229), so = Oo("efimovFactor", 22.7), uo = Do("atomicMass", "1.66053906660e-27", "kg"), lo = Do("avogadro", "6.02214076e23", "mol^-1"), co = Do("boltzmann", "1.380649e-23", "J K^-1"), fo = Do("faraday", "96485.33212331001", "C mol^-1"), ho = Do("firstRadiation", "3.7417718521927573e-16", "W m^2"), po = Do("loschmidt", "2.686780111798444e25", "m^-3"), mo = Do("gasConstant", "8.31446261815324", "J K^-1 mol^-1"), yo = Do("molarPlanckConstant", "3.990312712893431e-10", "J s mol^-1"), go = Do("molarVolume", "0.022413969545014137", "m^3 mol^-1"), vo = Oo("sackurTetrode", -1.16487052358), bo = Do("secondRadiation", "0.014387768775039337", "m K"), xo = Do("stefanBoltzmann", "5.67037441918443e-8", "W m^-2 K^-4"), wo = Do("wienDisplacement", "2.897771955e-3", "m K"), _o = Do("molarMass", "0.99999999965e-3", "kg mol^-1"), Ao = Do("molarMassC12", "11.9999999958e-3", "kg mol^-1"), Eo = Do("gravity", "9.80665", "m s^-2"), So = Do("planckLength", "1.616255e-35", "m"), Mo = Do("planckMass", "2.176435e-8", "kg"), ko = Do("planckTime", "5.391245e-44", "s"), No = Do("planckCharge", "1.87554603778e-18", "C"), Co = Do("planckTemperature", "1.416785e+32", "K");
            function Do(t, e, r) {
                return ge(t, [
                    "config",
                    "Unit",
                    "BigNumber"
                ], (t)=>{
                    var { config: n, Unit: i, BigNumber: o } = t, a = new i("BigNumber" === n.number ? new o(e) : parseFloat(e), r);
                    return a.fixPrefix = !0, a;
                });
            }
            function Oo(t, e) {
                return ge(t, [
                    "config",
                    "BigNumber"
                ], (t)=>{
                    var { config: r, BigNumber: n } = t;
                    return "BigNumber" === r.number ? new n(e) : e;
                });
            }
            var To = r(25), Fo = r.n(To), Po = ge("Fraction", [], ()=>(Object.defineProperty(Fo.a, "name", {
                    value: "Fraction"
                }), Fo.a.prototype.constructor = Fo.a, Fo.a.prototype.type = "Fraction", Fo.a.prototype.isFraction = !0, Fo.a.prototype.toJSON = function() {
                    return {
                        mathjs: "Fraction",
                        n: this.s * this.n,
                        d: this.d
                    };
                }, Fo.a.fromJSON = function(t) {
                    return new Fo.a(t);
                }, Fo.a), {
                isClass: !0
            }), Io = ge("Matrix", [], ()=>{
                function t() {
                    if (!(this instanceof t)) throw new SyntaxError("Constructor must be called with the new operator");
                }
                return t.prototype.type = "Matrix", t.prototype.isMatrix = !0, t.prototype.storage = function() {
                    throw new Error("Cannot invoke storage on a Matrix interface");
                }, t.prototype.datatype = function() {
                    throw new Error("Cannot invoke datatype on a Matrix interface");
                }, t.prototype.create = function(t, e) {
                    throw new Error("Cannot invoke create on a Matrix interface");
                }, t.prototype.subset = function(t, e, r) {
                    throw new Error("Cannot invoke subset on a Matrix interface");
                }, t.prototype.get = function(t) {
                    throw new Error("Cannot invoke get on a Matrix interface");
                }, t.prototype.set = function(t, e, r) {
                    throw new Error("Cannot invoke set on a Matrix interface");
                }, t.prototype.resize = function(t, e) {
                    throw new Error("Cannot invoke resize on a Matrix interface");
                }, t.prototype.reshape = function(t, e) {
                    throw new Error("Cannot invoke reshape on a Matrix interface");
                }, t.prototype.clone = function() {
                    throw new Error("Cannot invoke clone on a Matrix interface");
                }, t.prototype.size = function() {
                    throw new Error("Cannot invoke size on a Matrix interface");
                }, t.prototype.map = function(t, e) {
                    throw new Error("Cannot invoke map on a Matrix interface");
                }, t.prototype.forEach = function(t) {
                    throw new Error("Cannot invoke forEach on a Matrix interface");
                }, t.prototype[Symbol.iterator] = function() {
                    throw new Error("Cannot iterate a Matrix interface");
                }, t.prototype.toArray = function() {
                    throw new Error("Cannot invoke toArray on a Matrix interface");
                }, t.prototype.valueOf = function() {
                    throw new Error("Cannot invoke valueOf on a Matrix interface");
                }, t.prototype.format = function(t) {
                    throw new Error("Cannot invoke format on a Matrix interface");
                }, t.prototype.toString = function() {
                    throw new Error("Cannot invoke toString on a Matrix interface");
                }, t;
            }, {
                isClass: !0
            }), Bo = ge("Range", [], ()=>{
                function t(e, r, n) {
                    if (!(this instanceof t)) throw new SyntaxError("Constructor must be called with the new operator");
                    var i = null != e, o = null != r, a = null != n;
                    if (i) {
                        if (v(e)) e = e.toNumber();
                        else if ("number" != typeof e) throw new TypeError("Parameter start must be a number");
                    }
                    if (o) {
                        if (v(r)) r = r.toNumber();
                        else if ("number" != typeof r) throw new TypeError("Parameter end must be a number");
                    }
                    if (a) {
                        if (v(n)) n = n.toNumber();
                        else if ("number" != typeof n) throw new TypeError("Parameter step must be a number");
                    }
                    this.start = i ? parseFloat(e) : 0, this.end = o ? parseFloat(r) : 0, this.step = a ? parseFloat(n) : 1;
                }
                return t.prototype.type = "Range", t.prototype.isRange = !0, t.parse = function(e) {
                    if ("string" != typeof e) return null;
                    var r = e.split(":").map(function(t) {
                        return parseFloat(t);
                    });
                    if (r.some(function(t) {
                        return isNaN(t);
                    })) return null;
                    switch(r.length){
                        case 2:
                            return new t(r[0], r[1]);
                        case 3:
                            return new t(r[0], r[2], r[1]);
                        default:
                            return null;
                    }
                }, t.prototype.clone = function() {
                    return new t(this.start, this.end, this.step);
                }, t.prototype.size = function() {
                    var t = 0, e = this.start, r = this.step, n = this.end - e;
                    return dt(r) === dt(n) ? t = Math.ceil(n / r) : 0 === n && (t = 0), isNaN(t) && (t = 0), [
                        t
                    ];
                }, t.prototype.min = function() {
                    var t = this.size()[0];
                    return t > 0 ? this.step > 0 ? this.start : this.start + (t - 1) * this.step : void 0;
                }, t.prototype.max = function() {
                    var t = this.size()[0];
                    return t > 0 ? this.step > 0 ? this.start + (t - 1) * this.step : this.start : void 0;
                }, t.prototype.forEach = function(t) {
                    var e = this.start, r = this.step, n = this.end, i = 0;
                    if (r > 0) for(; e < n;)t(e, [
                        i
                    ], this), e += r, i++;
                    else if (r < 0) for(; e > n;)t(e, [
                        i
                    ], this), e += r, i++;
                }, t.prototype.map = function(t) {
                    var e = [];
                    return this.forEach(function(r, n, i) {
                        e[n[0]] = t(r, n, i);
                    }), e;
                }, t.prototype.toArray = function() {
                    var t = [];
                    return this.forEach(function(e, r) {
                        t[r[0]] = e;
                    }), t;
                }, t.prototype.valueOf = function() {
                    return this.toArray();
                }, t.prototype.format = function(t) {
                    var e = wt(this.start, t);
                    return 1 !== this.step && (e += ":" + wt(this.step, t)), e += ":" + wt(this.end, t);
                }, t.prototype.toString = function() {
                    return this.format();
                }, t.prototype.toJSON = function() {
                    return {
                        mathjs: "Range",
                        start: this.start,
                        end: this.end,
                        step: this.step
                    };
                }, t.fromJSON = function(e) {
                    return new t(e.start, e.end, e.step);
                }, t;
            }, {
                isClass: !0
            }), jo = ge("ResultSet", [], ()=>{
                function t(e) {
                    if (!(this instanceof t)) throw new SyntaxError("Constructor must be called with the new operator");
                    this.entries = e || [];
                }
                return t.prototype.type = "ResultSet", t.prototype.isResultSet = !0, t.prototype.valueOf = function() {
                    return this.entries;
                }, t.prototype.toString = function() {
                    return "[" + this.entries.join(", ") + "]";
                }, t.prototype.toJSON = function() {
                    return {
                        mathjs: "ResultSet",
                        entries: this.entries
                    };
                }, t.fromJSON = function(e) {
                    return new t(e.entries);
                }, t;
            }, {
                isClass: !0
            }), Ro = ge("DenseMatrix", [
                "Matrix"
            ], (t)=>{
                var { Matrix: e } = t;
                function r(t, e) {
                    if (!(this instanceof r)) throw new SyntaxError("Constructor must be called with the new operator");
                    if (e && !_(e)) throw new Error("Invalid datatype: " + e);
                    if (E(t)) "DenseMatrix" === t.type ? (this._data = it(t._data), this._size = it(t._size), this._datatype = e || t._datatype) : (this._data = t.toArray(), this._size = t.size(), this._datatype = e || t._datatype);
                    else if (t && A(t.data) && A(t.size)) this._data = t.data, this._size = t.size, Vt(this._data, this._size), this._datatype = e || t.datatype;
                    else if (A(t)) this._data = s(t), this._size = $t(this._data), Vt(this._data, this._size), this._datatype = e;
                    else {
                        if (t) throw new TypeError("Unsupported type of data (" + nt(t) + ")");
                        this._data = [], this._size = [
                            0
                        ], this._datatype = e;
                    }
                }
                function n(t, e) {
                    if (!C(e)) throw new TypeError("Invalid index");
                    if (e.isScalar()) return t.get(e.min());
                    var n = e.size();
                    if (n.length !== t._size.length) throw new Ht(n.length, t._size.length);
                    for(var i = e.min(), o = e.max(), a = 0, s = t._size.length; a < s; a++)Yt(i[a], t._size[a]), Yt(o[a], t._size[a]);
                    return new r(function t(e, r, n, i) {
                        var o = i === n - 1, a = r.dimension(i);
                        return o ? a.map(function(t) {
                            return Yt(t, e.length), e[t];
                        }).valueOf() : a.map(function(o) {
                            Yt(o, e.length);
                            var a = e[o];
                            return t(a, r, n, i + 1);
                        }).valueOf();
                    }(t._data, e, n.length, 0), t._datatype);
                }
                function i(t, e, r, n) {
                    if (!e || !0 !== e.isIndex) throw new TypeError("Invalid index");
                    var i, o = e.size(), s = e.isScalar();
                    if (E(r) ? (i = r.size(), r = r.valueOf()) : i = $t(r), s) {
                        if (0 !== i.length) throw new TypeError("Scalar expected");
                        t.set(e.min(), r, n);
                    } else {
                        if (!st(i, o)) try {
                            i = $t(r = 0 === i.length ? ye([
                                r
                            ], o) : ye(r, o));
                        } catch (t) {}
                        if (o.length < t._size.length) throw new Ht(o.length, t._size.length, "<");
                        if (i.length < o.length) {
                            for(var u = 0, l = 0; 1 === o[u] && 1 === i[u];)u++;
                            for(; 1 === o[u];)l++, u++;
                            r = re(r, o.length, l, i);
                        }
                        if (!st(o, i)) throw new Ht(o, i, ">");
                        a(t, e.max().map(function(t) {
                            return t + 1;
                        }), n);
                        var c = o.length;
                        !function t(e, r, n, i, o) {
                            var a = o === i - 1, s = r.dimension(o);
                            a ? s.forEach(function(t, r) {
                                Yt(t), e[t] = n[r[0]];
                            }) : s.forEach(function(a, s) {
                                Yt(a), t(e[a], r, n[s[0]], i, o + 1);
                            });
                        }(t._data, e, r, c, 0);
                    }
                    return t;
                }
                function o(t, e, r) {
                    if (0 === e.length) {
                        for(var n = t._data; A(n);)n = n[0];
                        return n;
                    }
                    return t._size = e.slice(0), t._data = Xt(t._data, t._size, r), t;
                }
                function a(t, e, r) {
                    for(var n = t._size.slice(0), i = !1; n.length < e.length;)n.push(0), i = !0;
                    for(var a = 0, s = e.length; a < s; a++)e[a] > n[a] && (n[a] = e[a], i = !0);
                    i && o(t, n, r);
                }
                function s(t) {
                    return E(t) ? s(t.valueOf()) : A(t) ? t.map(s) : t;
                }
                return r.prototype = new e, r.prototype.createDenseMatrix = function(t, e) {
                    return new r(t, e);
                }, Object.defineProperty(r, "name", {
                    value: "DenseMatrix"
                }), r.prototype.constructor = r, r.prototype.type = "DenseMatrix", r.prototype.isDenseMatrix = !0, r.prototype.getDataType = function() {
                    return fe(this._data, nt);
                }, r.prototype.storage = function() {
                    return "dense";
                }, r.prototype.datatype = function() {
                    return this._datatype;
                }, r.prototype.create = function(t, e) {
                    return new r(t, e);
                }, r.prototype.subset = function(t, e, r) {
                    switch(arguments.length){
                        case 1:
                            return n(this, t);
                        case 2:
                        case 3:
                            return i(this, t, e, r);
                        default:
                            throw new SyntaxError("Wrong number of arguments");
                    }
                }, r.prototype.get = function(t) {
                    if (!A(t)) throw new TypeError("Array expected");
                    if (t.length !== this._size.length) throw new Ht(t.length, this._size.length);
                    for(var e = 0; e < t.length; e++)Yt(t[e], this._size[e]);
                    for(var r = this._data, n = 0, i = t.length; n < i; n++){
                        var o = t[n];
                        Yt(o, r.length), r = r[o];
                    }
                    return r;
                }, r.prototype.set = function(t, e, r) {
                    if (!A(t)) throw new TypeError("Array expected");
                    if (t.length < this._size.length) throw new Ht(t.length, this._size.length, "<");
                    var n, i, o;
                    a(this, t.map(function(t) {
                        return t + 1;
                    }), r);
                    var s = this._data;
                    for(n = 0, i = t.length - 1; n < i; n++)Yt(o = t[n], s.length), s = s[o];
                    return Yt(o = t[t.length - 1], s.length), s[o] = e, this;
                }, r.prototype.resize = function(t, e, r) {
                    if (!S(t)) throw new TypeError("Array or Matrix expected");
                    var n = t.valueOf().map((t)=>Array.isArray(t) && 1 === t.length ? t[0] : t);
                    return o(r ? this.clone() : this, n, e);
                }, r.prototype.reshape = function(t, e) {
                    var r = e ? this.clone() : this;
                    r._data = Jt(r._data, t);
                    var n = r._size.reduce((t, e)=>t * e);
                    return r._size = Qt(t, n), r;
                }, r.prototype.clone = function() {
                    return new r({
                        data: it(this._data),
                        size: it(this._size),
                        datatype: this._datatype
                    });
                }, r.prototype.size = function() {
                    return this._size.slice(0);
                }, r.prototype.map = function(t) {
                    var e = this, n = ai(t), i = function r(i, o) {
                        return A(i) ? i.map(function(t, e) {
                            return r(t, o.concat(e));
                        }) : 1 === n ? t(i) : 2 === n ? t(i, o) : t(i, o, e);
                    }(this._data, []);
                    return new r(i, void 0 !== this._datatype ? fe(i, nt) : void 0);
                }, r.prototype.forEach = function(t) {
                    var e = this;
                    !function r(n, i) {
                        A(n) ? n.forEach(function(t, e) {
                            r(t, i.concat(e));
                        }) : t(n, i, e);
                    }(this._data, []);
                }, r.prototype[Symbol.iterator] = function*() {
                    yield* function* t(e, r) {
                        if (A(e)) for(var n = 0; n < e.length; n++)yield* t(e[n], r.concat(n));
                        else yield {
                            value: e,
                            index: r
                        };
                    }(this._data, []);
                }, r.prototype.rows = function() {
                    var t = [];
                    if (2 !== this.size().length) throw new TypeError("Rows can only be returned for a 2D matrix.");
                    var e = this._data;
                    for (var n of e)t.push(new r([
                        n
                    ], this._datatype));
                    return t;
                }, r.prototype.columns = function() {
                    var t = this, e = [], n = this.size();
                    if (2 !== n.length) throw new TypeError("Rows can only be returned for a 2D matrix.");
                    for(var i = this._data, o = function(n) {
                        var o = i.map((t)=>[
                                t[n]
                            ]);
                        e.push(new r(o, t._datatype));
                    }, a = 0; a < n[1]; a++)o(a);
                    return e;
                }, r.prototype.toArray = function() {
                    return it(this._data);
                }, r.prototype.valueOf = function() {
                    return this._data;
                }, r.prototype.format = function(t) {
                    return Lt(this._data, t);
                }, r.prototype.toString = function() {
                    return Lt(this._data);
                }, r.prototype.toJSON = function() {
                    return {
                        mathjs: "DenseMatrix",
                        data: this._data,
                        size: this._size,
                        datatype: this._datatype
                    };
                }, r.prototype.diagonal = function(t) {
                    if (t) {
                        if (v(t) && (t = t.toNumber()), !g(t) || !pt(t)) throw new TypeError("The parameter k must be an integer number");
                    } else t = 0;
                    for(var e = t > 0 ? t : 0, n = t < 0 ? -t : 0, i = this._size[0], o = this._size[1], a = Math.min(i - n, o - e), s = [], u = 0; u < a; u++)s[u] = this._data[u + n][u + e];
                    return new r({
                        data: s,
                        size: [
                            a
                        ],
                        datatype: this._datatype
                    });
                }, r.diagonal = function(t, e, n, i) {
                    if (!A(t)) throw new TypeError("Array expected, size parameter");
                    if (2 !== t.length) throw new Error("Only two dimensions matrix are supported");
                    if (t = t.map(function(t) {
                        if (v(t) && (t = t.toNumber()), !g(t) || !pt(t) || t < 1) throw new Error("Size values must be positive integers");
                        return t;
                    }), n) {
                        if (v(n) && (n = n.toNumber()), !g(n) || !pt(n)) throw new TypeError("The parameter k must be an integer number");
                    } else n = 0;
                    var o, a = n > 0 ? n : 0, s = n < 0 ? -n : 0, u = t[0], l = t[1], c = Math.min(u - s, l - a);
                    if (A(e)) {
                        if (e.length !== c) throw new Error("Invalid value array length");
                        o = function(t) {
                            return e[t];
                        };
                    } else if (E(e)) {
                        var f = e.size();
                        if (1 !== f.length || f[0] !== c) throw new Error("Invalid matrix length");
                        o = function(t) {
                            return e.get([
                                t
                            ]);
                        };
                    } else o = function() {
                        return e;
                    };
                    i || (i = v(o(0)) ? o(0).mul(0) : 0);
                    var h = [];
                    if (t.length > 0) {
                        h = Xt(h, t, i);
                        for(var p = 0; p < c; p++)h[p + s][p + a] = o(p);
                    }
                    return new r({
                        data: h,
                        size: [
                            u,
                            l
                        ]
                    });
                }, r.fromJSON = function(t) {
                    return new r(t);
                }, r.prototype.swapRows = function(t, e) {
                    if (!(g(t) && pt(t) && g(e) && pt(e))) throw new Error("Row index must be positive integers");
                    if (2 !== this._size.length) throw new Error("Only two dimensional matrix is supported");
                    return Yt(t, this._size[0]), Yt(e, this._size[0]), r._swapRows(t, e, this._data), this;
                }, r._swapRows = function(t, e, r) {
                    var n = r[t];
                    r[t] = r[e], r[e] = n;
                }, r;
            }, {
                isClass: !0
            }), Lo = ge("replacer", [], ()=>function(t, e) {
                    return "number" != typeof e || isFinite(e) && !isNaN(e) ? e : {
                        mathjs: "number",
                        value: String(e)
                    };
                }), qo = function() {
                return qo = en.a.create, en.a;
            }, Uo = ge("typed", [
                "?BigNumber",
                "?Complex",
                "?DenseMatrix",
                "?Fraction"
            ], function(t) {
                var { BigNumber: e, Complex: r, DenseMatrix: n, Fraction: i } = t, o = qo();
                return o.clear(), o.addTypes([
                    {
                        name: "number",
                        test: g
                    },
                    {
                        name: "Complex",
                        test: b
                    },
                    {
                        name: "BigNumber",
                        test: v
                    },
                    {
                        name: "Fraction",
                        test: x
                    },
                    {
                        name: "Unit",
                        test: w
                    },
                    {
                        name: "identifier",
                        test: (t)=>_ && /^(?:[A-Za-z\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u0870-\u0887\u0889-\u088E\u08A0-\u08C9\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C5D\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D04-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E86-\u0E8A\u0E8C-\u0EA3\u0EA5\u0EA7-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u1711\u171F-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1878\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4C\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF3\u1CF5\u1CF6\u1CFA\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u31BF\u31F0-\u31FF\u3400-\u4DBF\u4E00-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7CA\uA7D0\uA7D1\uA7D3\uA7D5-\uA7D9\uA7F2-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB69\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF2D-\uDF40\uDF42-\uDF49\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF]|\uD801[\uDC00-\uDC9D\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDD70-\uDD7A\uDD7C-\uDD8A\uDD8C-\uDD92\uDD94\uDD95\uDD97-\uDDA1\uDDA3-\uDDB1\uDDB3-\uDDB9\uDDBB\uDDBC\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67\uDF80-\uDF85\uDF87-\uDFB0\uDFB2-\uDFBA]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE35\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2\uDD00-\uDD23\uDE80-\uDEA9\uDEB0\uDEB1\uDF00-\uDF1C\uDF27\uDF30-\uDF45\uDF70-\uDF81\uDFB0-\uDFC4\uDFE0-\uDFF6]|\uD804[\uDC03-\uDC37\uDC71\uDC72\uDC75\uDC83-\uDCAF\uDCD0-\uDCE8\uDD03-\uDD26\uDD44\uDD47\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE2B\uDE3F\uDE40\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61]|\uD805[\uDC00-\uDC34\uDC47-\uDC4A\uDC5F-\uDC61\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE80-\uDEAA\uDEB8\uDF00-\uDF1A\uDF40-\uDF46]|\uD806[\uDC00-\uDC2B\uDCA0-\uDCDF\uDCFF-\uDD06\uDD09\uDD0C-\uDD13\uDD15\uDD16\uDD18-\uDD2F\uDD3F\uDD41\uDDA0-\uDDA7\uDDAA-\uDDD0\uDDE1\uDDE3\uDE00\uDE0B-\uDE32\uDE3A\uDE50\uDE5C-\uDE89\uDE9D\uDEB0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC72-\uDC8F\uDD00-\uDD06\uDD08\uDD09\uDD0B-\uDD30\uDD46\uDD60-\uDD65\uDD67\uDD68\uDD6A-\uDD89\uDD98\uDEE0-\uDEF2\uDF02\uDF04-\uDF10\uDF12-\uDF33\uDFB0]|\uD808[\uDC00-\uDF99]|\uD809[\uDC80-\uDD43]|\uD80B[\uDF90-\uDFF0]|[\uD80C\uD81C-\uD820\uD822\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872\uD874-\uD879\uD880-\uD883\uD885-\uD887][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2F\uDC41-\uDC46]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDE70-\uDEBE\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDE40-\uDE7F\uDF00-\uDF4A\uDF50\uDF93-\uDF9F\uDFE0\uDFE1\uDFE3]|\uD821[\uDC00-\uDFF7]|\uD823[\uDC00-\uDCD5\uDD00-\uDD08]|\uD82B[\uDFF0-\uDFF3\uDFF5-\uDFFB\uDFFD\uDFFE]|\uD82C[\uDC00-\uDD22\uDD32\uDD50-\uDD52\uDD55\uDD64-\uDD67\uDD70-\uDEFB]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB]|\uD837[\uDF00-\uDF1E\uDF25-\uDF2A]|\uD838[\uDC30-\uDC6D\uDD00-\uDD2C\uDD37-\uDD3D\uDD4E\uDE90-\uDEAD\uDEC0-\uDEEB]|\uD839[\uDCD0-\uDCEB\uDFE0-\uDFE6\uDFE8-\uDFEB\uDFED\uDFEE\uDFF0-\uDFFE]|\uD83A[\uDC00-\uDCC4\uDD00-\uDD43\uDD4B]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDEDF\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF39\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0]|\uD87E[\uDC00-\uDE1D]|\uD884[\uDC00-\uDF4A\uDF50-\uDFFF]|\uD888[\uDC00-\uDFAF])(?:[0-9A-Za-z\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u0870-\u0887\u0889-\u088E\u08A0-\u08C9\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C5D\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D04-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E86-\u0E8A\u0E8C-\u0EA3\u0EA5\u0EA7-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u1711\u171F-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1878\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4C\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF3\u1CF5\u1CF6\u1CFA\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u31BF\u31F0-\u31FF\u3400-\u4DBF\u4E00-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7CA\uA7D0\uA7D1\uA7D3\uA7D5-\uA7D9\uA7F2-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB69\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF2D-\uDF40\uDF42-\uDF49\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF]|\uD801[\uDC00-\uDC9D\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDD70-\uDD7A\uDD7C-\uDD8A\uDD8C-\uDD92\uDD94\uDD95\uDD97-\uDDA1\uDDA3-\uDDB1\uDDB3-\uDDB9\uDDBB\uDDBC\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67\uDF80-\uDF85\uDF87-\uDFB0\uDFB2-\uDFBA]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE35\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2\uDD00-\uDD23\uDE80-\uDEA9\uDEB0\uDEB1\uDF00-\uDF1C\uDF27\uDF30-\uDF45\uDF70-\uDF81\uDFB0-\uDFC4\uDFE0-\uDFF6]|\uD804[\uDC03-\uDC37\uDC71\uDC72\uDC75\uDC83-\uDCAF\uDCD0-\uDCE8\uDD03-\uDD26\uDD44\uDD47\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE2B\uDE3F\uDE40\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61]|\uD805[\uDC00-\uDC34\uDC47-\uDC4A\uDC5F-\uDC61\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE80-\uDEAA\uDEB8\uDF00-\uDF1A\uDF40-\uDF46]|\uD806[\uDC00-\uDC2B\uDCA0-\uDCDF\uDCFF-\uDD06\uDD09\uDD0C-\uDD13\uDD15\uDD16\uDD18-\uDD2F\uDD3F\uDD41\uDDA0-\uDDA7\uDDAA-\uDDD0\uDDE1\uDDE3\uDE00\uDE0B-\uDE32\uDE3A\uDE50\uDE5C-\uDE89\uDE9D\uDEB0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC72-\uDC8F\uDD00-\uDD06\uDD08\uDD09\uDD0B-\uDD30\uDD46\uDD60-\uDD65\uDD67\uDD68\uDD6A-\uDD89\uDD98\uDEE0-\uDEF2\uDF02\uDF04-\uDF10\uDF12-\uDF33\uDFB0]|\uD808[\uDC00-\uDF99]|\uD809[\uDC80-\uDD43]|\uD80B[\uDF90-\uDFF0]|[\uD80C\uD81C-\uD820\uD822\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872\uD874-\uD879\uD880-\uD883\uD885-\uD887][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2F\uDC41-\uDC46]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDE70-\uDEBE\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDE40-\uDE7F\uDF00-\uDF4A\uDF50\uDF93-\uDF9F\uDFE0\uDFE1\uDFE3]|\uD821[\uDC00-\uDFF7]|\uD823[\uDC00-\uDCD5\uDD00-\uDD08]|\uD82B[\uDFF0-\uDFF3\uDFF5-\uDFFB\uDFFD\uDFFE]|\uD82C[\uDC00-\uDD22\uDD32\uDD50-\uDD52\uDD55\uDD64-\uDD67\uDD70-\uDEFB]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB]|\uD837[\uDF00-\uDF1E\uDF25-\uDF2A]|\uD838[\uDC30-\uDC6D\uDD00-\uDD2C\uDD37-\uDD3D\uDD4E\uDE90-\uDEAD\uDEC0-\uDEEB]|\uD839[\uDCD0-\uDCEB\uDFE0-\uDFE6\uDFE8-\uDFEB\uDFED\uDFEE\uDFF0-\uDFFE]|\uD83A[\uDC00-\uDCC4\uDD00-\uDD43\uDD4B]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDEDF\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF39\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0]|\uD87E[\uDC00-\uDE1D]|\uD884[\uDC00-\uDF4A\uDF50-\uDFFF]|\uD888[\uDC00-\uDFAF])*$/.test(t)
                    },
                    {
                        name: "string",
                        test: _
                    },
                    {
                        name: "Chain",
                        test: rt
                    },
                    {
                        name: "Array",
                        test: A
                    },
                    {
                        name: "Matrix",
                        test: E
                    },
                    {
                        name: "DenseMatrix",
                        test: M
                    },
                    {
                        name: "SparseMatrix",
                        test: k
                    },
                    {
                        name: "Range",
                        test: N
                    },
                    {
                        name: "Index",
                        test: C
                    },
                    {
                        name: "boolean",
                        test: D
                    },
                    {
                        name: "ResultSet",
                        test: O
                    },
                    {
                        name: "Help",
                        test: T
                    },
                    {
                        name: "function",
                        test: F
                    },
                    {
                        name: "Date",
                        test: P
                    },
                    {
                        name: "RegExp",
                        test: I
                    },
                    {
                        name: "null",
                        test: j
                    },
                    {
                        name: "undefined",
                        test: R
                    },
                    {
                        name: "AccessorNode",
                        test: L
                    },
                    {
                        name: "ArrayNode",
                        test: q
                    },
                    {
                        name: "AssignmentNode",
                        test: U
                    },
                    {
                        name: "BlockNode",
                        test: z
                    },
                    {
                        name: "ConditionalNode",
                        test: G
                    },
                    {
                        name: "ConstantNode",
                        test: H
                    },
                    {
                        name: "FunctionNode",
                        test: V
                    },
                    {
                        name: "FunctionAssignmentNode",
                        test: $
                    },
                    {
                        name: "IndexNode",
                        test: Z
                    },
                    {
                        name: "Node",
                        test: Y
                    },
                    {
                        name: "ObjectNode",
                        test: K
                    },
                    {
                        name: "OperatorNode",
                        test: X
                    },
                    {
                        name: "ParenthesisNode",
                        test: J
                    },
                    {
                        name: "RangeNode",
                        test: Q
                    },
                    {
                        name: "RelationalNode",
                        test: tt
                    },
                    {
                        name: "SymbolNode",
                        test: et
                    },
                    {
                        name: "Map",
                        test: Ce
                    },
                    {
                        name: "Object",
                        test: B
                    }
                ]), o.addConversions([
                    {
                        from: "number",
                        to: "BigNumber",
                        convert: function(t) {
                            if (e || zo(t), t.toExponential().replace(/e.*$/, "").replace(/^0\.?0*|\./, "").length > 15) throw new TypeError("Cannot implicitly convert a number with >15 significant digits to BigNumber (value: " + t + "). Use function bignumber(x) to convert to BigNumber.");
                            return new e(t);
                        }
                    },
                    {
                        from: "number",
                        to: "Complex",
                        convert: function(t) {
                            return r || Go(t), new r(t, 0);
                        }
                    },
                    {
                        from: "BigNumber",
                        to: "Complex",
                        convert: function(t) {
                            return r || Go(t), new r(t.toNumber(), 0);
                        }
                    },
                    {
                        from: "Fraction",
                        to: "BigNumber",
                        convert: function(t) {
                            throw new TypeError("Cannot implicitly convert a Fraction to BigNumber or vice versa. Use function bignumber(x) to convert to BigNumber or fraction(x) to convert to Fraction.");
                        }
                    },
                    {
                        from: "Fraction",
                        to: "Complex",
                        convert: function(t) {
                            return r || Go(t), new r(t.valueOf(), 0);
                        }
                    },
                    {
                        from: "number",
                        to: "Fraction",
                        convert: function(t) {
                            i || Ho(t);
                            var e = new i(t);
                            if (e.valueOf() !== t) throw new TypeError("Cannot implicitly convert a number to a Fraction when there will be a loss of precision (value: " + t + "). Use function fraction(x) to convert to Fraction.");
                            return e;
                        }
                    },
                    {
                        from: "string",
                        to: "number",
                        convert: function(t) {
                            var e = Number(t);
                            if (isNaN(e)) throw new Error('Cannot convert "' + t + '" to a number');
                            return e;
                        }
                    },
                    {
                        from: "string",
                        to: "BigNumber",
                        convert: function(t) {
                            e || zo(t);
                            try {
                                return new e(t);
                            } catch (e) {
                                throw new Error('Cannot convert "' + t + '" to BigNumber');
                            }
                        }
                    },
                    {
                        from: "string",
                        to: "Fraction",
                        convert: function(t) {
                            i || Ho(t);
                            try {
                                return new i(t);
                            } catch (e) {
                                throw new Error('Cannot convert "' + t + '" to Fraction');
                            }
                        }
                    },
                    {
                        from: "string",
                        to: "Complex",
                        convert: function(t) {
                            r || Go(t);
                            try {
                                return new r(t);
                            } catch (e) {
                                throw new Error('Cannot convert "' + t + '" to Complex');
                            }
                        }
                    },
                    {
                        from: "boolean",
                        to: "number",
                        convert: function(t) {
                            return +t;
                        }
                    },
                    {
                        from: "boolean",
                        to: "BigNumber",
                        convert: function(t) {
                            return e || zo(t), new e(+t);
                        }
                    },
                    {
                        from: "boolean",
                        to: "Fraction",
                        convert: function(t) {
                            return i || Ho(t), new i(+t);
                        }
                    },
                    {
                        from: "boolean",
                        to: "string",
                        convert: function(t) {
                            return String(t);
                        }
                    },
                    {
                        from: "Array",
                        to: "Matrix",
                        convert: function(t) {
                            return n || function() {
                                throw new Error("Cannot convert array into a Matrix: no class 'DenseMatrix' provided");
                            }(), new n(t);
                        }
                    },
                    {
                        from: "Matrix",
                        to: "Array",
                        convert: function(t) {
                            return t.valueOf();
                        }
                    }
                ]), o.onMismatch = (t, e, r)=>{
                    var n = o.createError(t, e, r);
                    if ([
                        "wrongType",
                        "mismatch"
                    ].includes(n.data.category) && 1 === e.length && S(e[0]) && r.some((t)=>!t.params.includes(","))) {
                        var i = new TypeError("Function '".concat(t, "' doesn't apply to matrices. To call it ") + "elementwise on a matrix 'M', try 'map(M, ".concat(t, ")'."));
                        throw i.data = n.data, i;
                    }
                    throw n;
                }, o.onMismatch = (t, e, r)=>{
                    var n = o.createError(t, e, r);
                    if ([
                        "wrongType",
                        "mismatch"
                    ].includes(n.data.category) && 1 === e.length && S(e[0]) && r.some((t)=>!t.params.includes(","))) {
                        var i = new TypeError("Function '".concat(t, "' doesn't apply to matrices. To call it ") + "elementwise on a matrix 'M', try 'map(M, ".concat(t, ")'."));
                        throw i.data = n.data, i;
                    }
                    throw n;
                }, o;
            });
            function zo(t) {
                throw new Error("Cannot convert value ".concat(t, " into a BigNumber: no class 'BigNumber' provided"));
            }
            function Go(t) {
                throw new Error("Cannot convert value ".concat(t, " into a Complex number: no class 'Complex' provided"));
            }
            function Ho(t) {
                throw new Error("Cannot convert value ".concat(t, " into a Fraction, no class 'Fraction' provided."));
            }
            function Wo(t) {
                return Math.abs(t);
            }
            function $o(t, e) {
                return t + e;
            }
            function Vo(t, e) {
                return t - e;
            }
            function Zo(t, e) {
                return t * e;
            }
            function Yo(t) {
                return -t;
            }
            function Ko(t) {
                return t;
            }
            function Xo(t) {
                return vt(t);
            }
            function Jo(t) {
                return t * t * t;
            }
            function Qo(t) {
                return Math.exp(t);
            }
            function ta(t) {
                return bt(t);
            }
            function ea(t, e) {
                if (!pt(t) || !pt(e)) throw new Error("Parameters in function lcm must be integer numbers");
                if (0 === t || 0 === e) return 0;
                for(var r, n = t * e; 0 !== e;)e = t % (r = e), t = r;
                return Math.abs(n / t);
            }
            function ra(t) {
                return yt(t);
            }
            function na(t) {
                return mt(t);
            }
            function ia(t) {
                var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 2, r = e < 0;
                if (r && (e = -e), 0 === e) throw new Error("Root must be non-zero");
                if (t < 0 && Math.abs(e) % 2 != 1) throw new Error("Root must be odd when a is negative.");
                if (0 === t) return r ? 1 / 0 : 0;
                if (!isFinite(t)) return r ? 0 : t;
                var n = Math.pow(Math.abs(t), 1 / e);
                return n = t < 0 ? -n : n, r ? 1 / n : n;
            }
            function oa(t) {
                return dt(t);
            }
            function aa(t) {
                return t * t;
            }
            function sa(t, e) {
                var r, n, i, o = 0, a = 1, s = 1, u = 0;
                if (!pt(t) || !pt(e)) throw new Error("Parameters in function xgcd must be integer numbers");
                for(; e;)i = t - (n = Math.floor(t / e)) * e, r = o, o = a - n * o, a = r, r = s, s = u - n * s, u = r, t = e, e = i;
                return t < 0 ? [
                    -t,
                    -a,
                    -u
                ] : [
                    t,
                    t ? a : 0,
                    u
                ];
            }
            function ua(t, e) {
                return t * t < 1 && e === 1 / 0 || t * t > 1 && e === -1 / 0 ? 0 : Math.pow(t, e);
            }
            function la(t) {
                var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
                if (!pt(e) || e < 0 || e > 15) throw new Error("Number of decimals in function round must be an integer from 0 to 15 inclusive");
                return parseFloat(At(t, e));
            }
            Wo.signature = "number", $o.signature = "number, number", Vo.signature = "number, number", Zo.signature = "number, number", Yo.signature = "number", Ko.signature = "number", Xo.signature = "number", Jo.signature = "number", Qo.signature = "number", ta.signature = "number", ea.signature = "number, number", ra.signature = "number", na.signature = "number", oa.signature = "number", aa.signature = "number", sa.signature = "number, number", ua.signature = "number, number";
            var ca = ge("unaryPlus", [
                "typed",
                "config",
                "BigNumber"
            ], (t)=>{
                var { typed: e, config: r, BigNumber: n } = t;
                return e("unaryPlus", {
                    number: Ko,
                    Complex: function(t) {
                        return t;
                    },
                    BigNumber: function(t) {
                        return t;
                    },
                    Fraction: function(t) {
                        return t;
                    },
                    Unit: function(t) {
                        return t.clone();
                    },
                    "Array | Matrix": e.referToSelf((t)=>(e)=>vr(e, t, !0)),
                    "boolean | string": function(t) {
                        return "BigNumber" === r.number ? new n(+t) : +t;
                    }
                });
            }), fa = ge("abs", [
                "typed"
            ], (t)=>{
                var { typed: e } = t;
                return e("abs", {
                    number: Wo,
                    "Complex | BigNumber | Fraction | Unit": (t)=>t.abs(),
                    "Array | Matrix": e.referToSelf((t)=>(e)=>vr(e, t, !0))
                });
            }), ha = ge("acos", [
                "typed",
                "config",
                "Complex"
            ], (t)=>{
                var { typed: e, config: r, Complex: n } = t;
                return e("acos", {
                    number: function(t) {
                        return t >= -1 && t <= 1 || r.predictable ? Math.acos(t) : new n(t, 0).acos();
                    },
                    Complex: function(t) {
                        return t.acos();
                    },
                    BigNumber: function(t) {
                        return t.acos();
                    }
                });
            });
            function pa(t) {
                return Ct(t);
            }
            function da(t) {
                return Math.atan(1 / t);
            }
            function ma(t) {
                return isFinite(t) ? (Math.log((t + 1) / t) + Math.log(t / (t - 1))) / 2 : 0;
            }
            function ya(t) {
                return Math.asin(1 / t);
            }
            function ga(t) {
                var e = 1 / t;
                return Math.log(e + Math.sqrt(e * e + 1));
            }
            function va(t) {
                return Math.acos(1 / t);
            }
            function ba(t) {
                var e = 1 / t, r = Math.sqrt(e * e - 1);
                return Math.log(r + e);
            }
            function xa(t) {
                return Dt(t);
            }
            function wa(t) {
                return Ot(t);
            }
            function _a(t) {
                return 1 / Math.tan(t);
            }
            function Aa(t) {
                var e = Math.exp(2 * t);
                return (e + 1) / (e - 1);
            }
            function Ea(t) {
                return 1 / Math.sin(t);
            }
            function Sa(t) {
                return 0 === t ? Number.POSITIVE_INFINITY : Math.abs(2 / (Math.exp(t) - Math.exp(-t))) * dt(t);
            }
            function Ma(t) {
                return 1 / Math.cos(t);
            }
            function ka(t) {
                return 2 / (Math.exp(t) + Math.exp(-t));
            }
            function Na(t) {
                return Ft(t);
            }
            pa.signature = "number", da.signature = "number", ma.signature = "number", ya.signature = "number", ga.signature = "number", va.signature = "number", ba.signature = "number", xa.signature = "number", wa.signature = "number", _a.signature = "number", Aa.signature = "number", Ea.signature = "number", Sa.signature = "number", Ma.signature = "number", ka.signature = "number", Na.signature = "number";
            var Ca = ge("acot", [
                "typed",
                "BigNumber"
            ], (t)=>{
                var { typed: e, BigNumber: r } = t;
                return e("acot", {
                    number: da,
                    Complex: function(t) {
                        return t.acot();
                    },
                    BigNumber: function(t) {
                        return new r(1).div(t).atan();
                    }
                });
            }), Da = ge("acsc", [
                "typed",
                "config",
                "Complex",
                "BigNumber"
            ], (t)=>{
                var { typed: e, config: r, Complex: n, BigNumber: i } = t;
                return e("acsc", {
                    number: function(t) {
                        return t <= -1 || t >= 1 || r.predictable ? ya(t) : new n(t, 0).acsc();
                    },
                    Complex: function(t) {
                        return t.acsc();
                    },
                    BigNumber: function(t) {
                        return new i(1).div(t).asin();
                    }
                });
            }), Oa = ge("addScalar", [
                "typed"
            ], (t)=>{
                var { typed: e } = t;
                return e("addScalar", {
                    "number, number": $o,
                    "Complex, Complex": function(t, e) {
                        return t.add(e);
                    },
                    "BigNumber, BigNumber": function(t, e) {
                        return t.plus(e);
                    },
                    "Fraction, Fraction": function(t, e) {
                        return t.add(e);
                    },
                    "Unit, Unit": e.referToSelf((t)=>(r, n)=>{
                            if (null === r.value || void 0 === r.value) throw new Error("Parameter x contains a unit with undefined value");
                            if (null === n.value || void 0 === n.value) throw new Error("Parameter y contains a unit with undefined value");
                            if (!r.equalBase(n)) throw new Error("Units do not match");
                            var i = r.clone();
                            return i.value = e.find(t, [
                                i.valueType(),
                                n.valueType()
                            ])(i.value, n.value), i.fixPrefix = !1, i;
                        })
                });
            }), Ta = ge("arg", [
                "typed"
            ], (t)=>{
                var { typed: e } = t;
                return e("arg", {
                    number: function(t) {
                        return Math.atan2(0, t);
                    },
                    BigNumber: function(t) {
                        return t.constructor.atan2(0, t);
                    },
                    Complex: function(t) {
                        return t.arg();
                    },
                    "Array | Matrix": e.referToSelf((t)=>(e)=>vr(e, t))
                });
            }), Fa = ge("asech", [
                "typed",
                "config",
                "Complex",
                "BigNumber"
            ], (t)=>{
                var { typed: e, config: r, Complex: n, BigNumber: i } = t;
                return e("asech", {
                    number: function(t) {
                        if (t <= 1 && t >= -1 || r.predictable) {
                            var e = 1 / t;
                            if (e > 0 || r.predictable) return ba(t);
                            var i = Math.sqrt(e * e - 1);
                            return new n(Math.log(i - e), Math.PI);
                        }
                        return new n(t, 0).asech();
                    },
                    Complex: function(t) {
                        return t.asech();
                    },
                    BigNumber: function(t) {
                        return new i(1).div(t).acosh();
                    }
                });
            }), Pa = ge("asinh", [
                "typed"
            ], (t)=>{
                var { typed: e } = t;
                return e("asinh", {
                    number: xa,
                    Complex: function(t) {
                        return t.asinh();
                    },
                    BigNumber: function(t) {
                        return t.asinh();
                    }
                });
            }), Ia = ge("atan", [
                "typed"
            ], (t)=>{
                var { typed: e } = t;
                return e("atan", {
                    number: function(t) {
                        return Math.atan(t);
                    },
                    Complex: function(t) {
                        return t.atan();
                    },
                    BigNumber: function(t) {
                        return t.atan();
                    }
                });
            }), Ba = ge("atanh", [
                "typed",
                "config",
                "Complex"
            ], (t)=>{
                var { typed: e, config: r, Complex: n } = t;
                return e("atanh", {
                    number: function(t) {
                        return t <= 1 && t >= -1 || r.predictable ? wa(t) : new n(t, 0).atanh();
                    },
                    Complex: function(t) {
                        return t.atanh();
                    },
                    BigNumber: function(t) {
                        return t.atanh();
                    }
                });
            }), ja = ge("bignumber", [
                "typed",
                "BigNumber"
            ], (t)=>{
                var { typed: e, BigNumber: r } = t;
                return e("bignumber", {
                    "": function() {
                        return new r(0);
                    },
                    number: function(t) {
                        return new r(t + "");
                    },
                    string: function(t) {
                        var e = t.match(/(0[box][0-9a-fA-F]*)i([0-9]*)/);
                        if (e) {
                            var n = e[2], i = r(e[1]), o = new r(2).pow(Number(n));
                            if (i.gt(o.sub(1))) throw new SyntaxError('String "'.concat(t, '" is out of range'));
                            var a = new r(2).pow(Number(n) - 1);
                            return i.gte(a) ? i.sub(o) : i;
                        }
                        return new r(t);
                    },
                    BigNumber: function(t) {
                        return t;
                    },
                    Unit: e.referToSelf((t)=>(e)=>{
                            var r = e.clone();
                            return r.value = t(e.value), r;
                        }),
                    Fraction: function(t) {
                        return new r(t.n).div(t.d).times(t.s);
                    },
                    null: function(t) {
                        return new r(0);
                    },
                    "Array | Matrix": e.referToSelf((t)=>(e)=>vr(e, t))
                });
            });
            function Ra(t, e) {
                if (t.isFinite() && !t.isInteger() || e.isFinite() && !e.isInteger()) throw new Error("Integers expected in function bitAnd");
                var r = t.constructor;
                if (t.isNaN() || e.isNaN()) return new r(NaN);
                if (t.isZero() || e.eq(-1) || t.eq(e)) return t;
                if (e.isZero() || t.eq(-1)) return e;
                if (!t.isFinite() || !e.isFinite()) {
                    if (!t.isFinite() && !e.isFinite()) return t.isNegative() === e.isNegative() ? t : new r(0);
                    if (!t.isFinite()) return e.isNegative() ? t : t.isNegative() ? new r(0) : e;
                    if (!e.isFinite()) return t.isNegative() ? e : e.isNegative() ? new r(0) : t;
                }
                return Ua(t, e, function(t, e) {
                    return t & e;
                });
            }
            function La(t) {
                if (t.isFinite() && !t.isInteger()) throw new Error("Integer expected in function bitNot");
                var e = t.constructor, r = e.precision;
                e.config({
                    precision: 1e9
                });
                var n = t.plus(new e(1));
                return n.s = -n.s || null, e.config({
                    precision: r
                }), n;
            }
            function qa(t, e) {
                if (t.isFinite() && !t.isInteger() || e.isFinite() && !e.isInteger()) throw new Error("Integers expected in function bitOr");
                var r = t.constructor;
                if (t.isNaN() || e.isNaN()) return new r(NaN);
                var n = new r(-1);
                return t.isZero() || e.eq(n) || t.eq(e) ? e : e.isZero() || t.eq(n) ? t : t.isFinite() && e.isFinite() ? Ua(t, e, function(t, e) {
                    return t | e;
                }) : !t.isFinite() && !t.isNegative() && e.isNegative() || t.isNegative() && !e.isNegative() && !e.isFinite() ? n : t.isNegative() && e.isNegative() ? t.isFinite() ? t : e : t.isFinite() ? e : t;
            }
            function Ua(t, e, r) {
                var n, i, o, a, s, u = t.constructor, l = +(t.s < 0), c = +(e.s < 0);
                if (l) {
                    n = za(La(t));
                    for(var f = 0; f < n.length; ++f)n[f] ^= 1;
                } else n = za(t);
                if (c) {
                    i = za(La(e));
                    for(var h = 0; h < i.length; ++h)i[h] ^= 1;
                } else i = za(e);
                n.length <= i.length ? (o = n, a = i, s = l) : (o = i, a = n, s = c);
                var p = o.length, d = a.length, m = 1 ^ r(l, c), y = new u(1 ^ m), g = new u(1), v = new u(2), b = u.precision;
                for(u.config({
                    precision: 1e9
                }); p > 0;)r(o[--p], a[--d]) === m && (y = y.plus(g)), g = g.times(v);
                for(; d > 0;)r(s, a[--d]) === m && (y = y.plus(g)), g = g.times(v);
                return u.config({
                    precision: b
                }), 0 === m && (y.s = -y.s), y;
            }
            function za(t) {
                for(var e = t.d, r = e[0] + "", n = 1; n < e.length; ++n){
                    for(var i = e[n] + "", o = 7 - i.length; o--;)i = "0" + i;
                    r += i;
                }
                for(var a = r.length; "0" === r.charAt(a);)a--;
                var s = t.e, u = r.slice(0, a + 1 || 1), l = u.length;
                if (s > 0) {
                    if (++s > l) for(s -= l; s--;)u += "0";
                    else s < l && (u = u.slice(0, s) + "." + u.slice(s));
                }
                for(var c = [
                    0
                ], f = 0; f < u.length;){
                    for(var h = c.length; h--;)c[h] *= 10;
                    c[0] += parseInt(u.charAt(f++));
                    for(var p = 0; p < c.length; ++p)c[p] > 1 && (null !== c[p + 1] && void 0 !== c[p + 1] || (c[p + 1] = 0), c[p + 1] += c[p] >> 1, c[p] &= 1);
                }
                return c.reverse();
            }
            function Ga(t, e) {
                if (t.isFinite() && !t.isInteger() || e.isFinite() && !e.isInteger()) throw new Error("Integers expected in function bitXor");
                var r = t.constructor;
                if (t.isNaN() || e.isNaN()) return new r(NaN);
                if (t.isZero()) return e;
                if (e.isZero()) return t;
                if (t.eq(e)) return new r(0);
                var n = new r(-1);
                return t.eq(n) ? La(e) : e.eq(n) ? La(t) : t.isFinite() && e.isFinite() ? Ua(t, e, function(t, e) {
                    return t ^ e;
                }) : t.isFinite() || e.isFinite() ? new r(t.isNegative() === e.isNegative() ? 1 / 0 : -1 / 0) : n;
            }
            function Ha(t, e) {
                if (t.isFinite() && !t.isInteger() || e.isFinite() && !e.isInteger()) throw new Error("Integers expected in function leftShift");
                var r = t.constructor;
                return t.isNaN() || e.isNaN() || e.isNegative() && !e.isZero() ? new r(NaN) : t.isZero() || e.isZero() ? t : t.isFinite() || e.isFinite() ? e.lt(55) ? t.times(Math.pow(2, e.toNumber()) + "") : t.times(new r(2).pow(e)) : new r(NaN);
            }
            function Wa(t, e) {
                if (t.isFinite() && !t.isInteger() || e.isFinite() && !e.isInteger()) throw new Error("Integers expected in function rightArithShift");
                var r = t.constructor;
                return t.isNaN() || e.isNaN() || e.isNegative() && !e.isZero() ? new r(NaN) : t.isZero() || e.isZero() ? t : e.isFinite() ? e.lt(55) ? t.div(Math.pow(2, e.toNumber()) + "").floor() : t.div(new r(2).pow(e)).floor() : t.isNegative() ? new r(-1) : t.isFinite() ? new r(0) : new r(NaN);
            }
            var $a = "number, number";
            function Va(t, e) {
                if (!pt(t) || !pt(e)) throw new Error("Integers expected in function bitAnd");
                return t & e;
            }
            function Za(t) {
                if (!pt(t)) throw new Error("Integer expected in function bitNot");
                return ~t;
            }
            function Ya(t, e) {
                if (!pt(t) || !pt(e)) throw new Error("Integers expected in function bitOr");
                return t | e;
            }
            function Ka(t, e) {
                if (!pt(t) || !pt(e)) throw new Error("Integers expected in function bitXor");
                return t ^ e;
            }
            function Xa(t, e) {
                if (!pt(t) || !pt(e)) throw new Error("Integers expected in function leftShift");
                return t << e;
            }
            function Ja(t, e) {
                if (!pt(t) || !pt(e)) throw new Error("Integers expected in function rightArithShift");
                return t >> e;
            }
            function Qa(t, e) {
                if (!pt(t) || !pt(e)) throw new Error("Integers expected in function rightLogShift");
                return t >>> e;
            }
            Va.signature = $a, Za.signature = "number", Ya.signature = $a, Ka.signature = $a, Xa.signature = $a, Ja.signature = $a, Qa.signature = $a;
            var ts = ge("bitNot", [
                "typed"
            ], (t)=>{
                var { typed: e } = t;
                return e("bitNot", {
                    number: Za,
                    BigNumber: La,
                    "Array | Matrix": e.referToSelf((t)=>(e)=>vr(e, t))
                });
            }), es = ge("boolean", [
                "typed"
            ], (t)=>{
                var { typed: e } = t;
                return e("boolean", {
                    "": function() {
                        return !1;
                    },
                    boolean: function(t) {
                        return t;
                    },
                    number: function(t) {
                        return !!t;
                    },
                    null: function(t) {
                        return !1;
                    },
                    BigNumber: function(t) {
                        return !t.isZero();
                    },
                    string: function(t) {
                        var e = t.toLowerCase();
                        if ("true" === e) return !0;
                        if ("false" === e) return !1;
                        var r = Number(t);
                        if ("" !== t && !isNaN(r)) return !!r;
                        throw new Error('Cannot convert "' + t + '" to a boolean');
                    },
                    "Array | Matrix": e.referToSelf((t)=>(e)=>vr(e, t))
                });
            }), rs = ge("clone", [
                "typed"
            ], (t)=>{
                var { typed: e } = t;
                return e("clone", {
                    any: it
                });
            });
            function ns(t, e) {
                if (e < t) return 1;
                if (e === t) return e;
                var r = e + t >> 1;
                return ns(t, r) * ns(r + 1, e);
            }
            function is(t, e) {
                if (!pt(t) || t < 0) throw new TypeError("Positive integer value expected in function combinations");
                if (!pt(e) || e < 0) throw new TypeError("Positive integer value expected in function combinations");
                if (e > t) throw new TypeError("k must be less than or equal to n");
                for(var r = t - e, n = 1, i = 2, o = e < r ? e : r, a = e < r ? r + 1 : e + 1; a <= t; ++a)for(n *= a; i <= o && n % i == 0;)n /= i, ++i;
                return i <= o && (n /= ns(i, o)), n;
            }
            is.signature = "number, number";
            var os = ge("combinations", [
                "typed"
            ], (t)=>{
                var { typed: e } = t;
                return e("combinations", {
                    "number, number": is,
                    "BigNumber, BigNumber": function(t, e) {
                        var r, n, i = t.constructor, o = t.minus(e), a = new i(1);
                        if (!as(t) || !as(e)) throw new TypeError("Positive integer value expected in function combinations");
                        if (e.gt(t)) throw new TypeError("k must be less than n in function combinations");
                        if (r = a, e.lt(o)) for(n = a; n.lte(o); n = n.plus(a))r = r.times(e.plus(n)).dividedBy(n);
                        else for(n = a; n.lte(e); n = n.plus(a))r = r.times(o.plus(n)).dividedBy(n);
                        return r;
                    }
                });
            });
            function as(t) {
                return t.isInteger() && t.gte(0);
            }
            var ss = ge("complex", [
                "typed",
                "Complex"
            ], (t)=>{
                var { typed: e, Complex: r } = t;
                return e("complex", {
                    "": function() {
                        return r.ZERO;
                    },
                    number: function(t) {
                        return new r(t, 0);
                    },
                    "number, number": function(t, e) {
                        return new r(t, e);
                    },
                    "BigNumber, BigNumber": function(t, e) {
                        return new r(t.toNumber(), e.toNumber());
                    },
                    Fraction: function(t) {
                        return new r(t.valueOf(), 0);
                    },
                    Complex: function(t) {
                        return t.clone();
                    },
                    string: function(t) {
                        return r(t);
                    },
                    null: function(t) {
                        return r(0);
                    },
                    Object: function(t) {
                        if ("re" in t && "im" in t) return new r(t.re, t.im);
                        if ("r" in t && "phi" in t || "abs" in t && "arg" in t) return new r(t);
                        throw new Error("Expected object with properties (re and im) or (r and phi) or (abs and arg)");
                    },
                    "Array | Matrix": e.referToSelf((t)=>(e)=>vr(e, t))
                });
            }), us = ge("conj", [
                "typed"
            ], (t)=>{
                var { typed: e } = t;
                return e("conj", {
                    "number | BigNumber | Fraction": (t)=>t,
                    Complex: (t)=>t.conjugate(),
                    "Array | Matrix": e.referToSelf((t)=>(e)=>vr(e, t))
                });
            }), ls = ge("trigUnit", [
                "typed"
            ], (t)=>{
                var { typed: e } = t;
                return {
                    Unit: e.referToSelf((t)=>(r)=>{
                            if (!r.hasBase(r.constructor.BASE_UNITS.ANGLE)) throw new TypeError("Unit in function cot is no angle");
                            return e.find(t, r.valueType())(r.value);
                        })
                };
            }), cs = ge("cos", [
                "typed"
            ], (t)=>{
                var { typed: e } = t, r = ls({
                    typed: e
                });
                return e("cos", {
                    number: Math.cos,
                    "Complex | BigNumber": (t)=>t.cos()
                }, r);
            }), fs = ge("cot", [
                "typed",
                "BigNumber"
            ], (t)=>{
                var { typed: e, BigNumber: r } = t;
                return e("cot", {
                    number: _a,
                    Complex: (t)=>t.cot(),
                    BigNumber: (t)=>new r(1).div(t.tan())
                }, ls({
                    typed: e
                }));
            }), hs = ge("csc", [
                "typed",
                "BigNumber"
            ], (t)=>{
                var { typed: e, BigNumber: r } = t;
                return e("csc", {
                    number: Ea,
                    Complex: (t)=>t.csc(),
                    BigNumber: (t)=>new r(1).div(t.sin())
                }, ls({
                    typed: e
                }));
            }), ps = ge("cube", [
                "typed"
            ], (t)=>{
                var { typed: e } = t;
                return e("cube", {
                    number: Jo,
                    Complex: function(t) {
                        return t.mul(t).mul(t);
                    },
                    BigNumber: function(t) {
                        return t.times(t).times(t);
                    },
                    Fraction: function(t) {
                        return t.pow(3);
                    },
                    Unit: function(t) {
                        return t.pow(3);
                    }
                });
            });
            function ds(t, e, r) {
                if (null == r) return t.eq(e);
                if (t.eq(e)) return !0;
                if (t.isNaN() || e.isNaN()) return !1;
                if (t.isFinite() && e.isFinite()) {
                    var n = t.minus(e).abs();
                    if (n.isZero()) return !0;
                    var i = t.constructor.max(t.abs(), e.abs());
                    return n.lte(i.times(r));
                }
                return !1;
            }
            var ms = ge("compareUnits", [
                "typed"
            ], (t)=>{
                var { typed: e } = t;
                return {
                    "Unit, Unit": e.referToSelf((t)=>(r, n)=>{
                            if (!r.equalBase(n)) throw new Error("Cannot compare units with different base");
                            return e.find(t, [
                                r.valueType(),
                                n.valueType()
                            ])(r.value, n.value);
                        })
                };
            }), ys = ge("equalScalar", [
                "typed",
                "config"
            ], (t)=>{
                var { typed: e, config: r } = t;
                return e("equalScalar", {
                    "boolean, boolean": function(t, e) {
                        return t === e;
                    },
                    "number, number": function(t, e) {
                        return Nt(t, e, r.epsilon);
                    },
                    "BigNumber, BigNumber": function(t, e) {
                        return t.eq(e) || ds(t, e, r.epsilon);
                    },
                    "Fraction, Fraction": function(t, e) {
                        return t.equals(e);
                    },
                    "Complex, Complex": function(t, e) {
                        return function(t, e, r) {
                            return Nt(t.re, e.re, r) && Nt(t.im, e.im, r);
                        }(t, e, r.epsilon);
                    }
                }, ms({
                    typed: e
                }));
            }), gs = (ge("equalScalar", [
                "typed",
                "config"
            ], (t)=>{
                var { typed: e, config: r } = t;
                return e("equalScalar", {
                    "number, number": function(t, e) {
                        return Nt(t, e, r.epsilon);
                    }
                });
            }), ge("erf", [
                "typed"
            ], (t)=>{
                var { typed: e } = t;
                return e("name", {
                    number: function(t) {
                        var e = Math.abs(t);
                        return e >= _s ? dt(t) : e <= vs ? dt(t) * function(t) {
                            var e, r = t * t, n = xs[0][4] * r, i = r;
                            for(e = 0; e < 3; e += 1)n = (n + xs[0][e]) * r, i = (i + ws[0][e]) * r;
                            return t * (n + xs[0][3]) / (i + ws[0][3]);
                        }(e) : e <= 4 ? dt(t) * (1 - function(t) {
                            var e, r = xs[1][8] * t, n = t;
                            for(e = 0; e < 7; e += 1)r = (r + xs[1][e]) * t, n = (n + ws[1][e]) * t;
                            var i = (r + xs[1][7]) / (n + ws[1][7]), o = parseInt(16 * t) / 16, a = (t - o) * (t + o);
                            return Math.exp(-o * o) * Math.exp(-a) * i;
                        }(e)) : dt(t) * (1 - function(t) {
                            var e, r = 1 / (t * t), n = xs[2][5] * r, i = r;
                            for(e = 0; e < 4; e += 1)n = (n + xs[2][e]) * r, i = (i + ws[2][e]) * r;
                            var o = r * (n + xs[2][4]) / (i + ws[2][4]);
                            o = (bs - o) / t, r = parseInt(16 * t) / 16;
                            var a = (t - r) * (t + r);
                            return Math.exp(-r * r) * Math.exp(-a) * o;
                        }(e));
                    },
                    "Array | Matrix": e.referToSelf((t)=>(e)=>vr(e, t))
                });
            })), vs = .46875, bs = .5641895835477563, xs = [
                [
                    3.1611237438705655,
                    113.86415415105016,
                    377.485237685302,
                    3209.3775891384694,
                    .18577770618460315
                ],
                [
                    .5641884969886701,
                    8.883149794388377,
                    66.11919063714163,
                    298.6351381974001,
                    881.952221241769,
                    1712.0476126340707,
                    2051.0783778260716,
                    1230.3393547979972,
                    2.1531153547440383e-8
                ],
                [
                    .30532663496123236,
                    .36034489994980445,
                    .12578172611122926,
                    .016083785148742275,
                    .0006587491615298378,
                    .016315387137302097
                ]
            ], ws = [
                [
                    23.601290952344122,
                    244.02463793444417,
                    1282.6165260773723,
                    2844.236833439171
                ],
                [
                    15.744926110709835,
                    117.6939508913125,
                    537.1811018620099,
                    1621.3895745666903,
                    3290.7992357334597,
                    4362.619090143247,
                    3439.3676741437216,
                    1230.3393548037495
                ],
                [
                    2.568520192289822,
                    1.8729528499234604,
                    .5279051029514285,
                    .06051834131244132,
                    .0023352049762686918
                ]
            ], _s = Math.pow(2, 53), As = ge("exp", [
                "typed"
            ], (t)=>{
                var { typed: e } = t;
                return e("exp", {
                    number: Qo,
                    Complex: function(t) {
                        return t.exp();
                    },
                    BigNumber: function(t) {
                        return t.exp();
                    }
                });
            }), Es = ge("expm1", [
                "typed",
                "Complex"
            ], (t)=>{
                var { typed: e, Complex: r } = t;
                return e("expm1", {
                    number: ta,
                    Complex: function(t) {
                        var e = Math.exp(t.re);
                        return new r(e * Math.cos(t.im) - 1, e * Math.sin(t.im));
                    },
                    BigNumber: function(t) {
                        return t.exp().minus(1);
                    }
                });
            }), Ss = ge("filter", [
                "typed"
            ], (t)=>{
                var { typed: e } = t;
                return e("filter", {
                    "Array, function": Ms,
                    "Matrix, function": function(t, e) {
                        return t.create(Ms(t.toArray(), e));
                    },
                    "Array, RegExp": se,
                    "Matrix, RegExp": function(t, e) {
                        return t.create(se(t.toArray(), e));
                    }
                });
            });
            function Ms(t, e) {
                return ae(t, function(t, r, n) {
                    return rn(e, t, [
                        r
                    ], n, "filter");
                });
            }
            var ks = ge("forEach", [
                "typed"
            ], (t)=>{
                var { typed: e } = t;
                return e("forEach", {
                    "Array, function": Ns,
                    "Matrix, function": function(t, e) {
                        t.forEach(e);
                    }
                });
            });
            function Ns(t, e) {
                !function r(n, i) {
                    if (!Array.isArray(n)) return rn(e, n, i, t, "forEach");
                    oe(n, function(t, e) {
                        r(t, i.concat(e));
                    });
                }(t, []);
            }
            var Cs = ge("format", [
                "typed"
            ], (t)=>{
                var { typed: e } = t;
                return e("format", {
                    any: Lt,
                    "any, Object | function | number": Lt
                });
            }), Ds = ge("getMatrixDataType", [
                "typed"
            ], (t)=>{
                var { typed: e } = t;
                return e("getMatrixDataType", {
                    Array: function(t) {
                        return fe(t, nt);
                    },
                    Matrix: function(t) {
                        return t.getDataType();
                    }
                });
            }), Os = ge("hex", [
                "typed",
                "format"
            ], (t)=>{
                var { typed: e, format: r } = t;
                return e("hex", {
                    "number | BigNumber": function(t) {
                        return r(t, {
                            notation: "hex"
                        });
                    },
                    "number | BigNumber, number": function(t, e) {
                        return r(t, {
                            notation: "hex",
                            wordSize: e
                        });
                    }
                });
            }), Ts = ge("im", [
                "typed"
            ], (t)=>{
                var { typed: e } = t;
                return e("im", {
                    number: ()=>0,
                    "BigNumber | Fraction": (t)=>t.mul(0),
                    Complex: (t)=>t.im,
                    "Array | Matrix": e.referToSelf((t)=>(e)=>vr(e, t))
                });
            }), Fs = ge("isInteger", [
                "typed"
            ], (t)=>{
                var { typed: e } = t;
                return e("isInteger", {
                    number: pt,
                    BigNumber: function(t) {
                        return t.isInt();
                    },
                    Fraction: function(t) {
                        return 1 === t.d && isFinite(t.n);
                    },
                    "Array | Matrix": e.referToSelf((t)=>(e)=>vr(e, t))
                });
            });
            function Ps(t) {
                return t < 0;
            }
            function Is(t) {
                return t > 0;
            }
            function Bs(t) {
                return 0 === t;
            }
            function js(t) {
                return Number.isNaN(t);
            }
            Ps.signature = "number", Is.signature = "number", Bs.signature = "number", js.signature = "number";
            var Rs = ge("isNegative", [
                "typed"
            ], (t)=>{
                var { typed: e } = t;
                return e("isNegative", {
                    number: Ps,
                    BigNumber: function(t) {
                        return t.isNeg() && !t.isZero() && !t.isNaN();
                    },
                    Fraction: function(t) {
                        return t.s < 0;
                    },
                    Unit: e.referToSelf((t)=>(r)=>e.find(t, r.valueType())(r.value)),
                    "Array | Matrix": e.referToSelf((t)=>(e)=>vr(e, t))
                });
            }), Ls = ge("isPositive", [
                "typed"
            ], (t)=>{
                var { typed: e } = t;
                return e("isPositive", {
                    number: Is,
                    BigNumber: function(t) {
                        return !t.isNeg() && !t.isZero() && !t.isNaN();
                    },
                    Fraction: function(t) {
                        return t.s > 0 && t.n > 0;
                    },
                    Unit: e.referToSelf((t)=>(r)=>e.find(t, r.valueType())(r.value)),
                    "Array | Matrix": e.referToSelf((t)=>(e)=>vr(e, t))
                });
            }), qs = ge("isZero", [
                "typed"
            ], (t)=>{
                var { typed: e } = t;
                return e("isZero", {
                    number: Bs,
                    BigNumber: function(t) {
                        return t.isZero();
                    },
                    Complex: function(t) {
                        return 0 === t.re && 0 === t.im;
                    },
                    Fraction: function(t) {
                        return 1 === t.d && 0 === t.n;
                    },
                    Unit: e.referToSelf((t)=>(r)=>e.find(t, r.valueType())(r.value)),
                    "Array | Matrix": e.referToSelf((t)=>(e)=>vr(e, t))
                });
            });
            function Us(t) {
                var e;
                if (pt(t)) return t <= 0 ? isFinite(t) ? 1 / 0 : NaN : t > 171 ? 1 / 0 : ns(1, t - 1);
                if (t < .5) return Math.PI / (Math.sin(Math.PI * t) * Us(1 - t));
                if (t >= 171.35) return 1 / 0;
                if (t > 85) {
                    var r = t * t, n = r * t, i = n * t, o = i * t;
                    return Math.sqrt(2 * Math.PI / t) * Math.pow(t / Math.E, t) * (1 + 1 / (12 * t) + 1 / (288 * r) - 139 / (51840 * n) - 571 / (2488320 * i) + 163879 / (209018880 * o) + 5246819 / (75246796800 * o * t));
                }
                --t, e = Gs[0];
                for(var a = 1; a < Gs.length; ++a)e += Gs[a] / (t + a);
                var s = t + zs + .5;
                return Math.sqrt(2 * Math.PI) * Math.pow(s, t + .5) * Math.exp(-s) * e;
            }
            Us.signature = "number";
            var zs = 4.7421875, Gs = [
                .9999999999999971,
                57.15623566586292,
                -59.59796035547549,
                14.136097974741746,
                -0.4919138160976202,
                3399464998481189e-20,
                4652362892704858e-20,
                -0.00009837447530487956,
                .0001580887032249125,
                -0.00021026444172410488,
                .00021743961811521265,
                -0.0001643181065367639,
                8441822398385275e-20,
                -0.000026190838401581408,
                36899182659531625e-22
            ], Hs = [
                1.000000000190015,
                76.18009172947146,
                -86.50532032941678,
                24.01409824083091,
                -1.231739572450155,
                .001208650973866179,
                -0.000005395239384953
            ];
            function Ws(t) {
                if (t < 0) return NaN;
                if (0 === t) return 1 / 0;
                if (!isFinite(t)) return t;
                if (t < .5) return Math.log(Math.PI / Math.sin(Math.PI * t)) - Ws(1 - t);
                for(var e = (t -= 1) + 5 + .5, r = Hs[0], n = 6; n >= 1; n--)r += Hs[n] / (t + n);
                return .9189385332046728 + (t + .5) * Math.log(e) - e + Math.log(r);
            }
            Ws.signature = "number";
            var $s = ge("lgamma", [
                "Complex",
                "typed"
            ], (t)=>{
                var { Complex: e, typed: r } = t, n = [
                    -0.029550653594771242,
                    .00641025641025641,
                    -0.0019175269175269176,
                    .0008417508417508417,
                    -0.0005952380952380953,
                    .0007936507936507937,
                    -0.002777777777777778,
                    .08333333333333333
                ];
                return r("lgamma", {
                    number: Ws,
                    Complex: function t(r) {
                        if (r.isNaN()) return new e(NaN, NaN);
                        if (0 === r.im) return new e(Ws(r.re), 0);
                        if (r.re >= 7 || Math.abs(r.im) >= 7) return i(r);
                        if (r.re <= .1) {
                            var n = (u = 6.283185307179586, l = r.im, ((u > 0 || !(u < 0) && 1 / u == 1 / 0) ^ (l > 0 || !(l < 0) && 1 / l == 1 / 0) ? -u : u) * Math.floor(.5 * r.re + .25)), a = r.mul(Math.PI).sin().log(), s = t(new e(1 - r.re, -r.im));
                            return new e(1.1447298858494002, n).sub(a).sub(s);
                        }
                        var u, l;
                        return r.im >= 0 ? o(r) : o(r.conjugate()).conjugate();
                    },
                    BigNumber: function() {
                        throw new Error("mathjs doesn't yet provide an implementation of the algorithm lgamma for BigNumber");
                    }
                });
                function i(t) {
                    for(var r = t.sub(.5).mul(t.log()).sub(t).add(.9189385332046728), i = new e(1, 0).div(t), o = i.div(t), a = n[0], s = n[1], u = 2 * o.re, l = o.re * o.re + o.im * o.im, c = 2; c < 8; c++){
                        var f = s;
                        s = -l * a + n[c], a = u * a + f;
                    }
                    var h = i.mul(o.mul(a).add(s));
                    return r.add(h);
                }
                function o(t) {
                    var r = 0, n = 0, o = t;
                    for(t = t.add(1); t.re <= 7;){
                        var a = (o = o.mul(t)).im < 0 ? 1 : 0;
                        0 !== a && 0 === n && r++, n = a, t = t.add(1);
                    }
                    return i(t).sub(o.log()).sub(new e(0, 2 * r * Math.PI * 1));
                }
            }), Vs = ge("log10", [
                "typed",
                "config",
                "Complex"
            ], (t)=>{
                var { typed: e, config: r, Complex: n } = t;
                return e("log10", {
                    number: function(t) {
                        return t >= 0 || r.predictable ? ra(t) : new n(t, 0).log().div(Math.LN10);
                    },
                    Complex: function(t) {
                        return new n(t).log().div(Math.LN10);
                    },
                    BigNumber: function(t) {
                        return !t.isNegative() || r.predictable ? t.log() : new n(t.toNumber(), 0).log().div(Math.LN10);
                    },
                    "Array | Matrix": e.referToSelf((t)=>(e)=>vr(e, t))
                });
            }), Zs = ge("log2", [
                "typed",
                "config",
                "Complex"
            ], (t)=>{
                var { typed: e, config: r, Complex: n } = t;
                return e("log2", {
                    number: function(t) {
                        return t >= 0 || r.predictable ? na(t) : i(new n(t, 0));
                    },
                    Complex: i,
                    BigNumber: function(t) {
                        return !t.isNegative() || r.predictable ? t.log(2) : i(new n(t.toNumber(), 0));
                    },
                    "Array | Matrix": e.referToSelf((t)=>(e)=>vr(e, t))
                });
                function i(t) {
                    var e = Math.sqrt(t.re * t.re + t.im * t.im);
                    return new n(Math.log2 ? Math.log2(e) : Math.log(e) / Math.LN2, Math.atan2(t.im, t.re) / Math.LN2);
                }
            }), Ys = ge("map", [
                "typed"
            ], (t)=>{
                var { typed: e } = t;
                return e("map", {
                    "Array, function": Ks,
                    "Matrix, function": function(t, e) {
                        return t.map(e);
                    }
                });
            });
            function Ks(t, e) {
                return function r(n, i) {
                    return Array.isArray(n) ? n.map(function(t, e) {
                        return r(t, i.concat(e));
                    }) : rn(e, n, i, t, "map");
                }(t, []);
            }
            var Xs = ge("multiplyScalar", [
                "typed"
            ], (t)=>{
                var { typed: e } = t;
                return e("multiplyScalar", {
                    "number, number": Zo,
                    "Complex, Complex": function(t, e) {
                        return t.mul(e);
                    },
                    "BigNumber, BigNumber": function(t, e) {
                        return t.times(e);
                    },
                    "Fraction, Fraction": function(t, e) {
                        return t.mul(e);
                    },
                    "number | Fraction | BigNumber | Complex, Unit": (t, e)=>e.multiply(t),
                    "Unit, number | Fraction | BigNumber | Complex | Unit": (t, e)=>t.multiply(e)
                });
            });
            function Js(t) {
                return !t;
            }
            function Qs(t, e) {
                return !(!t && !e);
            }
            function tu(t, e) {
                return !!t != !!e;
            }
            function eu(t, e) {
                return !(!t || !e);
            }
            Js.signature = "number", Qs.signature = "number, number", tu.signature = "number, number", eu.signature = "number, number";
            var ru = ge("not", [
                "typed"
            ], (t)=>{
                var { typed: e } = t;
                return e("not", {
                    "null | undefined": ()=>!0,
                    number: Js,
                    Complex: function(t) {
                        return 0 === t.re && 0 === t.im;
                    },
                    BigNumber: function(t) {
                        return t.isZero() || t.isNaN();
                    },
                    Unit: e.referToSelf((t)=>(r)=>e.find(t, r.valueType())(r.value)),
                    "Array | Matrix": e.referToSelf((t)=>(e)=>vr(e, t))
                });
            });
            var nu = ge("number", [
                "typed"
            ], (t)=>{
                var { typed: e } = t, r = e("number", {
                    "": function() {
                        return 0;
                    },
                    number: function(t) {
                        return t;
                    },
                    string: function(t) {
                        if ("NaN" === t) return NaN;
                        var e, r, n = (r = (e = t).match(/(0[box])([0-9a-fA-F]*)\.([0-9a-fA-F]*)/)) ? {
                            input: e,
                            radix: ({
                                "0b": 2,
                                "0o": 8,
                                "0x": 16
                            })[r[1]],
                            integerPart: r[2],
                            fractionalPart: r[3]
                        } : null;
                        if (n) return function(t) {
                            for(var e = parseInt(t.integerPart, t.radix), r = 0, n = 0; n < t.fractionalPart.length; n++)r += parseInt(t.fractionalPart[n], t.radix) / Math.pow(t.radix, n + 1);
                            var i = e + r;
                            if (isNaN(i)) throw new SyntaxError('String "' + t.input + '" is no valid number');
                            return i;
                        }(n);
                        var i = 0, o = t.match(/(0[box][0-9a-fA-F]*)i([0-9]*)/);
                        o && (i = Number(o[2]), t = o[1]);
                        var a = Number(t);
                        if (isNaN(a)) throw new SyntaxError('String "' + t + '" is no valid number');
                        if (o) {
                            if (a > 2 ** i - 1) throw new SyntaxError('String "'.concat(t, '" is out of range'));
                            a >= 2 ** (i - 1) && (a -= 2 ** i);
                        }
                        return a;
                    },
                    BigNumber: function(t) {
                        return t.toNumber();
                    },
                    Fraction: function(t) {
                        return t.valueOf();
                    },
                    Unit: e.referToSelf((t)=>(e)=>{
                            var r = e.clone();
                            return r.value = t(e.value), r;
                        }),
                    null: function(t) {
                        return 0;
                    },
                    "Unit, string | Unit": function(t, e) {
                        return t.toNumber(e);
                    },
                    "Array | Matrix": e.referToSelf((t)=>(e)=>vr(e, t))
                });
                return r.fromJSON = function(t) {
                    return parseFloat(t.value);
                }, r;
            }), iu = ge("oct", [
                "typed",
                "format"
            ], (t)=>{
                var { typed: e, format: r } = t;
                return e("oct", {
                    "number | BigNumber": function(t) {
                        return r(t, {
                            notation: "oct"
                        });
                    },
                    "number | BigNumber, number": function(t, e) {
                        return r(t, {
                            notation: "oct",
                            wordSize: e
                        });
                    }
                });
            }), ou = r(104), au = r.n(ou), su = au()(Date.now());
            function uu(t) {
                var e, r;
                return e = null === (r = t) ? su : au()(String(r)), function() {
                    return e();
                };
            }
            var lu = ge("pickRandom", [
                "typed",
                "config",
                "?on"
            ], (t)=>{
                var { typed: e, config: r, on: n } = t, i = uu(r.randomSeed);
                return n && n("config", function(t, e) {
                    t.randomSeed !== e.randomSeed && (i = uu(t.randomSeed));
                }), e("pickRandom", {
                    "Array | Matrix": function(t) {
                        return o(t, {});
                    },
                    "Array | Matrix, Object": function(t, e) {
                        return o(t, e);
                    },
                    "Array | Matrix, number": function(t, e) {
                        return o(t, {
                            number: e
                        });
                    },
                    "Array | Matrix, Array | Matrix": function(t, e) {
                        return o(t, {
                            weights: e
                        });
                    },
                    "Array | Matrix, Array | Matrix, number": function(t, e, r) {
                        return o(t, {
                            number: r,
                            weights: e
                        });
                    },
                    "Array | Matrix, number, Array | Matrix": function(t, e, r) {
                        return o(t, {
                            number: e,
                            weights: r
                        });
                    }
                });
                function o(t, e) {
                    var { number: r, weights: n, elementWise: o = !0 } = e, a = void 0 === r;
                    a && (r = 1);
                    var s = E(t) ? t.create : E(n) ? n.create : null;
                    t = t.valueOf(), n && (n = n.valueOf()), !0 === o && (t = ne(t), n = ne(n));
                    var u = 0;
                    if (void 0 !== n) {
                        if (n.length !== t.length) throw new Error("Weights must have the same length as possibles");
                        for(var l = 0, c = n.length; l < c; l++){
                            if (!g(n[l]) || n[l] < 0) throw new Error("Weights must be an array of positive numbers");
                            u += n[l];
                        }
                    }
                    for(var f, h = t.length, p = []; p.length < r;){
                        if (void 0 === n) f = t[Math.floor(i() * h)];
                        else for(var d = i() * u, m = 0, y = t.length; m < y; m++)if ((d -= n[m]) < 0) {
                            f = t[m];
                            break;
                        }
                        p.push(f);
                    }
                    return a ? p[0] : s ? s(p) : p;
                }
            });
            function cu(t, e) {
                var r = [];
                if ((t = t.slice(0)).length > 1) for(var n = 0, i = t.shift(); n < i; n++)r.push(cu(t, e));
                else for(var o = 0, a = t.shift(); o < a; o++)r.push(e());
                return r;
            }
            var fu = ge("random", [
                "typed",
                "config",
                "?on"
            ], (t)=>{
                var { typed: e, config: r, on: n } = t, i = uu(r.randomSeed);
                return n && n("config", function(t, e) {
                    t.randomSeed !== e.randomSeed && (i = uu(t.randomSeed));
                }), e("random", {
                    "": ()=>a(0, 1),
                    number: (t)=>a(0, t),
                    "number, number": (t, e)=>a(t, e),
                    "Array | Matrix": (t)=>o(t, 0, 1),
                    "Array | Matrix, number": (t, e)=>o(t, 0, e),
                    "Array | Matrix, number, number": (t, e, r)=>o(t, e, r)
                });
                function o(t, e, r) {
                    var n = cu(t.valueOf(), ()=>a(e, r));
                    return E(t) ? t.create(n) : n;
                }
                function a(t, e) {
                    return t + i() * (e - t);
                }
            }), hu = ge("re", [
                "typed"
            ], (t)=>{
                var { typed: e } = t;
                return e("re", {
                    "number | BigNumber | Fraction": (t)=>t,
                    Complex: (t)=>t.re,
                    "Array | Matrix": e.referToSelf((t)=>(e)=>vr(e, t))
                });
            }), pu = ge("sec", [
                "typed",
                "BigNumber"
            ], (t)=>{
                var { typed: e, BigNumber: r } = t;
                return e("sec", {
                    number: Ma,
                    Complex: (t)=>t.sec(),
                    BigNumber: (t)=>new r(1).div(t.cos())
                }, ls({
                    typed: e
                }));
            }), du = ge("sign", [
                "typed",
                "BigNumber",
                "Fraction",
                "complex"
            ], (t)=>{
                var { typed: e, BigNumber: r, complex: n, Fraction: i } = t;
                return e("sign", {
                    number: oa,
                    Complex: function(t) {
                        return 0 === t.im ? n(oa(t.re)) : t.sign();
                    },
                    BigNumber: function(t) {
                        return new r(t.cmp(0));
                    },
                    Fraction: function(t) {
                        return new i(t.s, 1);
                    },
                    "Array | Matrix": e.referToSelf((t)=>(e)=>vr(e, t, !0)),
                    Unit: e.referToSelf((t)=>(r)=>{
                            if (!r._isDerived() && 0 !== r.units[0].unit.offset) throw new TypeError("sign is ambiguous for units with offset");
                            return e.find(t, r.valueType())(r.value);
                        })
                });
            }), mu = ge("sin", [
                "typed"
            ], (t)=>{
                var { typed: e } = t, r = ls({
                    typed: e
                });
                return e("sin", {
                    number: Math.sin,
                    "Complex | BigNumber": (t)=>t.sin()
                }, r);
            }), yu = ge("SparseMatrix", [
                "typed",
                "equalScalar",
                "Matrix"
            ], (t)=>{
                var { typed: e, equalScalar: r, Matrix: n } = t;
                function i(t, e) {
                    if (!(this instanceof i)) throw new SyntaxError("Constructor must be called with the new operator");
                    if (e && !_(e)) throw new Error("Invalid datatype: " + e);
                    if (E(t)) !function(t, e, r) {
                        "SparseMatrix" === e.type ? (t._values = e._values ? it(e._values) : void 0, t._index = it(e._index), t._ptr = it(e._ptr), t._size = it(e._size), t._datatype = r || e._datatype) : o(t, e.valueOf(), r || e._datatype);
                    }(this, t, e);
                    else if (t && A(t.index) && A(t.ptr) && A(t.size)) this._values = t.values, this._index = t.index, this._ptr = t.ptr, this._size = t.size, this._datatype = e || t.datatype;
                    else if (A(t)) o(this, t, e);
                    else {
                        if (t) throw new TypeError("Unsupported type of data (" + nt(t) + ")");
                        this._values = [], this._index = [], this._ptr = [
                            0
                        ], this._size = [
                            0,
                            0
                        ], this._datatype = e;
                    }
                }
                function o(t, n, i) {
                    t._values = [], t._index = [], t._ptr = [], t._datatype = i;
                    var o = n.length, a = 0, s = r, u = 0;
                    if (_(i) && (s = e.find(r, [
                        i,
                        i
                    ]) || r, u = e.convert(0, i)), o > 0) {
                        var l = 0;
                        do {
                            t._ptr.push(t._index.length);
                            for(var c = 0; c < o; c++){
                                var f = n[c];
                                if (A(f)) {
                                    if (0 === l && a < f.length && (a = f.length), l < f.length) {
                                        var h = f[l];
                                        s(h, u) || (t._values.push(h), t._index.push(c));
                                    }
                                } else 0 === l && a < 1 && (a = 1), s(f, u) || (t._values.push(f), t._index.push(c));
                            }
                            l++;
                        }while (l < a);
                    }
                    t._ptr.push(t._index.length), t._size = [
                        o,
                        a
                    ];
                }
                function a(t, e) {
                    if (!C(e)) throw new TypeError("Invalid index");
                    if (e.isScalar()) return t.get(e.min());
                    var r, n, o, a, s = e.size();
                    if (s.length !== t._size.length) throw new Ht(s.length, t._size.length);
                    var u = e.min(), l = e.max();
                    for(r = 0, n = t._size.length; r < n; r++)Yt(u[r], t._size[r]), Yt(l[r], t._size[r]);
                    var c = t._values, f = t._index, h = t._ptr, p = e.dimension(0), d = e.dimension(1), m = [], y = [];
                    p.forEach(function(t, e) {
                        y[t] = e[0], m[t] = !0;
                    });
                    var g = c ? [] : void 0, v = [], b = [];
                    return d.forEach(function(t) {
                        for(b.push(v.length), o = h[t], a = h[t + 1]; o < a; o++)r = f[o], !0 === m[r] && (v.push(y[r]), g && g.push(c[o]));
                    }), b.push(v.length), new i({
                        values: g,
                        index: v,
                        ptr: b,
                        size: s,
                        datatype: t._datatype
                    });
                }
                function s(t, e, r, n) {
                    if (!e || !0 !== e.isIndex) throw new TypeError("Invalid index");
                    var i, o = e.size(), a = e.isScalar();
                    if (E(r) ? (i = r.size(), r = r.toArray()) : i = $t(r), a) {
                        if (0 !== i.length) throw new TypeError("Scalar expected");
                        t.set(e.min(), r, n);
                    } else {
                        if (1 !== o.length && 2 !== o.length) throw new Ht(o.length, t._size.length, "<");
                        if (i.length < o.length) {
                            for(var s = 0, u = 0; 1 === o[s] && 1 === i[s];)s++;
                            for(; 1 === o[s];)u++, s++;
                            r = re(r, o.length, u, i);
                        }
                        if (!st(o, i)) throw new Ht(o, i, ">");
                        if (1 === o.length) e.dimension(0).forEach(function(e, i) {
                            Yt(e), t.set([
                                e,
                                0
                            ], r[i[0]], n);
                        });
                        else {
                            var l = e.dimension(0), c = e.dimension(1);
                            l.forEach(function(e, i) {
                                Yt(e), c.forEach(function(o, a) {
                                    Yt(o), t.set([
                                        e,
                                        o
                                    ], r[i[0]][a[0]], n);
                                });
                            });
                        }
                    }
                    return t;
                }
                function u(t, e, r, n) {
                    if (r - e == 0) return r;
                    for(var i = e; i < r; i++)if (n[i] === t) return i;
                    return e;
                }
                function l(t, e, r, n, i, o, a) {
                    i.splice(t, 0, n), o.splice(t, 0, e);
                    for(var s = r + 1; s < a.length; s++)a[s]++;
                }
                function c(t, n, i, o) {
                    var a = o || 0, s = r, u = 0;
                    _(t._datatype) && (s = e.find(r, [
                        t._datatype,
                        t._datatype
                    ]) || r, u = e.convert(0, t._datatype), a = e.convert(a, t._datatype));
                    var l, c, f, h = !s(a, u), p = t._size[0], d = t._size[1];
                    if (i > d) {
                        for(c = d; c < i; c++)if (t._ptr[c] = t._values.length, h) for(l = 0; l < p; l++)t._values.push(a), t._index.push(l);
                        t._ptr[i] = t._values.length;
                    } else i < d && (t._ptr.splice(i + 1, d - i), t._values.splice(t._ptr[i], t._values.length), t._index.splice(t._ptr[i], t._index.length));
                    if (d = i, n > p) {
                        if (h) {
                            var m = 0;
                            for(c = 0; c < d; c++){
                                t._ptr[c] = t._ptr[c] + m, f = t._ptr[c + 1] + m;
                                var y = 0;
                                for(l = p; l < n; l++, y++)t._values.splice(f + y, 0, a), t._index.splice(f + y, 0, l), m++;
                            }
                            t._ptr[d] = t._values.length;
                        }
                    } else if (n < p) {
                        var g = 0;
                        for(c = 0; c < d; c++){
                            t._ptr[c] = t._ptr[c] - g;
                            var v = t._ptr[c], b = t._ptr[c + 1] - g;
                            for(f = v; f < b; f++)(l = t._index[f]) > n - 1 && (t._values.splice(f, 1), t._index.splice(f, 1), g++);
                        }
                        t._ptr[c] = t._values.length;
                    }
                    return t._size[0] = n, t._size[1] = i, t;
                }
                function f(t, e, r, n, i) {
                    var o, a, s = n[0], u = n[1], l = [];
                    for(o = 0; o < s; o++)for(l[o] = [], a = 0; a < u; a++)l[o][a] = 0;
                    for(a = 0; a < u; a++)for(var c = r[a], f = r[a + 1], h = c; h < f; h++)l[o = e[h]][a] = t ? i ? it(t[h]) : t[h] : 1;
                    return l;
                }
                return i.prototype = new n, i.prototype.createSparseMatrix = function(t, e) {
                    return new i(t, e);
                }, Object.defineProperty(i, "name", {
                    value: "SparseMatrix"
                }), i.prototype.constructor = i, i.prototype.type = "SparseMatrix", i.prototype.isSparseMatrix = !0, i.prototype.getDataType = function() {
                    return fe(this._values, nt);
                }, i.prototype.storage = function() {
                    return "sparse";
                }, i.prototype.datatype = function() {
                    return this._datatype;
                }, i.prototype.create = function(t, e) {
                    return new i(t, e);
                }, i.prototype.density = function() {
                    var t = this._size[0], e = this._size[1];
                    return 0 !== t && 0 !== e ? this._index.length / (t * e) : 0;
                }, i.prototype.subset = function(t, e, r) {
                    if (!this._values) throw new Error("Cannot invoke subset on a Pattern only matrix");
                    switch(arguments.length){
                        case 1:
                            return a(this, t);
                        case 2:
                        case 3:
                            return s(this, t, e, r);
                        default:
                            throw new SyntaxError("Wrong number of arguments");
                    }
                }, i.prototype.get = function(t) {
                    if (!A(t)) throw new TypeError("Array expected");
                    if (t.length !== this._size.length) throw new Ht(t.length, this._size.length);
                    if (!this._values) throw new Error("Cannot invoke get on a Pattern only matrix");
                    var e = t[0], r = t[1];
                    Yt(e, this._size[0]), Yt(r, this._size[1]);
                    var n = u(e, this._ptr[r], this._ptr[r + 1], this._index);
                    return n < this._ptr[r + 1] && this._index[n] === e ? this._values[n] : 0;
                }, i.prototype.set = function(t, n, i) {
                    if (!A(t)) throw new TypeError("Array expected");
                    if (t.length !== this._size.length) throw new Ht(t.length, this._size.length);
                    if (!this._values) throw new Error("Cannot invoke set on a Pattern only matrix");
                    var o = t[0], a = t[1], s = this._size[0], f = this._size[1], h = r, p = 0;
                    _(this._datatype) && (h = e.find(r, [
                        this._datatype,
                        this._datatype
                    ]) || r, p = e.convert(0, this._datatype)), (o > s - 1 || a > f - 1) && (c(this, Math.max(o + 1, s), Math.max(a + 1, f), i), s = this._size[0], f = this._size[1]), Yt(o, s), Yt(a, f);
                    var d = u(o, this._ptr[a], this._ptr[a + 1], this._index);
                    return d < this._ptr[a + 1] && this._index[d] === o ? h(n, p) ? function(t, e, r, n, i) {
                        r.splice(t, 1), n.splice(t, 1);
                        for(var o = e + 1; o < i.length; o++)i[o]--;
                    }(d, a, this._values, this._index, this._ptr) : this._values[d] = n : h(n, p) || l(d, o, a, n, this._values, this._index, this._ptr), this;
                }, i.prototype.resize = function(t, e, r) {
                    if (!S(t)) throw new TypeError("Array or Matrix expected");
                    var n = t.valueOf().map((t)=>Array.isArray(t) && 1 === t.length ? t[0] : t);
                    if (2 !== n.length) throw new Error("Only two dimensions matrix are supported");
                    return n.forEach(function(t) {
                        if (!g(t) || !pt(t) || t < 0) throw new TypeError("Invalid size, must contain positive integers (size: " + Lt(n) + ")");
                    }), c(r ? this.clone() : this, n[0], n[1], e);
                }, i.prototype.reshape = function(t, e) {
                    if (!A(t)) throw new TypeError("Array expected");
                    if (2 !== t.length) throw new Error("Sparse matrices can only be reshaped in two dimensions");
                    t.forEach(function(e) {
                        if (!g(e) || !pt(e) || e <= -2 || 0 === e) throw new TypeError("Invalid size, must contain positive integers or -1 (size: " + Lt(t) + ")");
                    });
                    var r = this._size[0] * this._size[1];
                    if (r !== (t = Qt(t, r))[0] * t[1]) throw new Error("Reshaping sparse matrix will result in the wrong number of elements");
                    var n = e ? this.clone() : this;
                    if (this._size[0] === t[0] && this._size[1] === t[1]) return n;
                    for(var i = [], o = 0; o < n._ptr.length; o++)for(var a = 0; a < n._ptr[o + 1] - n._ptr[o]; a++)i.push(o);
                    for(var s = n._values.slice(), c = n._index.slice(), f = 0; f < n._index.length; f++){
                        var h = c[f], p = i[f], d = h * n._size[1] + p;
                        i[f] = d % t[1], c[f] = Math.floor(d / t[1]);
                    }
                    n._values.length = 0, n._index.length = 0, n._ptr.length = t[1] + 1, n._size = t.slice();
                    for(var m = 0; m < n._ptr.length; m++)n._ptr[m] = 0;
                    for(var y = 0; y < s.length; y++){
                        var v = c[y], b = i[y], x = s[y];
                        l(u(v, n._ptr[b], n._ptr[b + 1], n._index), v, b, x, n._values, n._index, n._ptr);
                    }
                    return n;
                }, i.prototype.clone = function() {
                    return new i({
                        values: this._values ? it(this._values) : void 0,
                        index: it(this._index),
                        ptr: it(this._ptr),
                        size: it(this._size),
                        datatype: this._datatype
                    });
                }, i.prototype.size = function() {
                    return this._size.slice(0);
                }, i.prototype.map = function(t, n) {
                    if (!this._values) throw new Error("Cannot invoke map on a Pattern only matrix");
                    var o = this, a = this._size[0], s = this._size[1], u = ai(t);
                    return function(t, n, o, a, s, u, l) {
                        var c = [], f = [], h = [], p = r, d = 0;
                        _(t._datatype) && (p = e.find(r, [
                            t._datatype,
                            t._datatype
                        ]) || r, d = e.convert(0, t._datatype));
                        for(var m = function(t, e, r) {
                            t = u(t, e, r), p(t, d) || (c.push(t), f.push(e));
                        }, y = a; y <= s; y++){
                            h.push(c.length);
                            var g = t._ptr[y], v = t._ptr[y + 1];
                            if (l) for(var b = g; b < v; b++){
                                var x = t._index[b];
                                x >= n && x <= o && m(t._values[b], x - n, y - a);
                            }
                            else {
                                for(var w = {}, A = g; A < v; A++){
                                    var E = t._index[A];
                                    w[E] = t._values[A];
                                }
                                for(var S = n; S <= o; S++){
                                    var M = S in w ? w[S] : 0;
                                    m(M, S - n, y - a);
                                }
                            }
                        }
                        return h.push(c.length), new i({
                            values: c,
                            index: f,
                            ptr: h,
                            size: [
                                o - n + 1,
                                s - a + 1
                            ]
                        });
                    }(this, 0, a - 1, 0, s - 1, function(e, r, n) {
                        return 1 === u ? t(e) : 2 === u ? t(e, [
                            r,
                            n
                        ]) : t(e, [
                            r,
                            n
                        ], o);
                    }, n);
                }, i.prototype.forEach = function(t, e) {
                    if (!this._values) throw new Error("Cannot invoke forEach on a Pattern only matrix");
                    for(var r = this._size[0], n = this._size[1], i = 0; i < n; i++){
                        var o = this._ptr[i], a = this._ptr[i + 1];
                        if (e) for(var s = o; s < a; s++){
                            var u = this._index[s];
                            t(this._values[s], [
                                u,
                                i
                            ], this);
                        }
                        else {
                            for(var l = {}, c = o; c < a; c++)l[this._index[c]] = this._values[c];
                            for(var f = 0; f < r; f++)t(f in l ? l[f] : 0, [
                                f,
                                i
                            ], this);
                        }
                    }
                }, i.prototype[Symbol.iterator] = function*() {
                    if (!this._values) throw new Error("Cannot iterate a Pattern only matrix");
                    for(var t = this._size[1], e = 0; e < t; e++)for(var r = this._ptr[e], n = this._ptr[e + 1], i = r; i < n; i++){
                        var o = this._index[i];
                        yield {
                            value: this._values[i],
                            index: [
                                o,
                                e
                            ]
                        };
                    }
                }, i.prototype.toArray = function() {
                    return f(this._values, this._index, this._ptr, this._size, !0);
                }, i.prototype.valueOf = function() {
                    return f(this._values, this._index, this._ptr, this._size, !1);
                }, i.prototype.format = function(t) {
                    for(var e = this._size[0], r = this._size[1], n = this.density(), i = "Sparse Matrix [" + Lt(e, t) + " x " + Lt(r, t) + "] density: " + Lt(n, t) + "\n", o = 0; o < r; o++)for(var a = this._ptr[o], s = this._ptr[o + 1], u = a; u < s; u++)i += "\n    (" + Lt(this._index[u], t) + ", " + Lt(o, t) + ") ==> " + (this._values ? Lt(this._values[u], t) : "X");
                    return i;
                }, i.prototype.toString = function() {
                    return Lt(this.toArray());
                }, i.prototype.toJSON = function() {
                    return {
                        mathjs: "SparseMatrix",
                        values: this._values,
                        index: this._index,
                        ptr: this._ptr,
                        size: this._size,
                        datatype: this._datatype
                    };
                }, i.prototype.diagonal = function(t) {
                    if (t) {
                        if (v(t) && (t = t.toNumber()), !g(t) || !pt(t)) throw new TypeError("The parameter k must be an integer number");
                    } else t = 0;
                    var e = t > 0 ? t : 0, r = t < 0 ? -t : 0, n = this._size[0], o = this._size[1], a = Math.min(n - r, o - e), s = [], u = [], l = [];
                    l[0] = 0;
                    for(var c = e; c < o && s.length < a; c++)for(var f = this._ptr[c], h = this._ptr[c + 1], p = f; p < h; p++){
                        var d = this._index[p];
                        if (d === c - e + r) {
                            s.push(this._values[p]), u[s.length - 1] = d - r;
                            break;
                        }
                    }
                    return l.push(s.length), new i({
                        values: s,
                        index: u,
                        ptr: l,
                        size: [
                            a,
                            1
                        ]
                    });
                }, i.fromJSON = function(t) {
                    return new i(t);
                }, i.diagonal = function(t, n, o, a, s) {
                    if (!A(t)) throw new TypeError("Array expected, size parameter");
                    if (2 !== t.length) throw new Error("Only two dimensions matrix are supported");
                    if (t = t.map(function(t) {
                        if (v(t) && (t = t.toNumber()), !g(t) || !pt(t) || t < 1) throw new Error("Size values must be positive integers");
                        return t;
                    }), o) {
                        if (v(o) && (o = o.toNumber()), !g(o) || !pt(o)) throw new TypeError("The parameter k must be an integer number");
                    } else o = 0;
                    var u = r, l = 0;
                    _(s) && (u = e.find(r, [
                        s,
                        s
                    ]) || r, l = e.convert(0, s));
                    var c, f = o > 0 ? o : 0, h = o < 0 ? -o : 0, p = t[0], d = t[1], m = Math.min(p - h, d - f);
                    if (A(n)) {
                        if (n.length !== m) throw new Error("Invalid value array length");
                        c = function(t) {
                            return n[t];
                        };
                    } else if (E(n)) {
                        var y = n.size();
                        if (1 !== y.length || y[0] !== m) throw new Error("Invalid matrix length");
                        c = function(t) {
                            return n.get([
                                t
                            ]);
                        };
                    } else c = function() {
                        return n;
                    };
                    for(var b = [], x = [], w = [], S = 0; S < d; S++){
                        w.push(b.length);
                        var M = S - f;
                        if (M >= 0 && M < m) {
                            var k = c(M);
                            u(k, l) || (x.push(M + h), b.push(k));
                        }
                    }
                    return w.push(b.length), new i({
                        values: b,
                        index: x,
                        ptr: w,
                        size: [
                            p,
                            d
                        ]
                    });
                }, i.prototype.swapRows = function(t, e) {
                    if (!(g(t) && pt(t) && g(e) && pt(e))) throw new Error("Row index must be positive integers");
                    if (2 !== this._size.length) throw new Error("Only two dimensional matrix is supported");
                    return Yt(t, this._size[0]), Yt(e, this._size[0]), i._swapRows(t, e, this._size[1], this._values, this._index, this._ptr), this;
                }, i._forEachRow = function(t, e, r, n, i) {
                    for(var o = n[t], a = n[t + 1], s = o; s < a; s++)i(r[s], e[s]);
                }, i._swapRows = function(t, e, r, n, i, o) {
                    for(var a = 0; a < r; a++){
                        var s = o[a], l = o[a + 1], c = u(t, s, l, i), f = u(e, s, l, i);
                        if (c < l && f < l && i[c] === t && i[f] === e) {
                            if (n) {
                                var h = n[c];
                                n[c] = n[f], n[f] = h;
                            }
                        } else if (c < l && i[c] === t && (f >= l || i[f] !== e)) {
                            var p = n ? n[c] : void 0;
                            i.splice(f, 0, e), n && n.splice(f, 0, p), i.splice(f <= c ? c + 1 : c, 1), n && n.splice(f <= c ? c + 1 : c, 1);
                        } else if (f < l && i[f] === e && (c >= l || i[c] !== t)) {
                            var d = n ? n[f] : void 0;
                            i.splice(c, 0, t), n && n.splice(c, 0, d), i.splice(c <= f ? f + 1 : f, 1), n && n.splice(c <= f ? f + 1 : f, 1);
                        }
                    }
                }, i;
            }, {
                isClass: !0
            }), gu = ge("splitUnit", [
                "typed"
            ], (t)=>{
                var { typed: e } = t;
                return e("splitUnit", {
                    "Unit, Array": function(t, e) {
                        return t.splitUnit(e);
                    }
                });
            }), vu = ge("square", [
                "typed"
            ], (t)=>{
                var { typed: e } = t;
                return e("square", {
                    number: aa,
                    Complex: function(t) {
                        return t.mul(t);
                    },
                    BigNumber: function(t) {
                        return t.times(t);
                    },
                    Fraction: function(t) {
                        return t.mul(t);
                    },
                    Unit: function(t) {
                        return t.pow(2);
                    }
                });
            }), bu = ge("string", [
                "typed"
            ], (t)=>{
                var { typed: e } = t;
                return e("string", {
                    "": function() {
                        return "";
                    },
                    number: wt,
                    null: function(t) {
                        return "null";
                    },
                    boolean: function(t) {
                        return t + "";
                    },
                    string: function(t) {
                        return t;
                    },
                    "Array | Matrix": e.referToSelf((t)=>(e)=>vr(e, t)),
                    any: function(t) {
                        return String(t);
                    }
                });
            }), xu = ge("subtractScalar", [
                "typed"
            ], (t)=>{
                var { typed: e } = t;
                return e("subtractScalar", {
                    "number, number": Vo,
                    "Complex, Complex": function(t, e) {
                        return t.sub(e);
                    },
                    "BigNumber, BigNumber": function(t, e) {
                        return t.minus(e);
                    },
                    "Fraction, Fraction": function(t, e) {
                        return t.sub(e);
                    },
                    "Unit, Unit": e.referToSelf((t)=>(r, n)=>{
                            if (null === r.value || void 0 === r.value) throw new Error("Parameter x contains a unit with undefined value");
                            if (null === n.value || void 0 === n.value) throw new Error("Parameter y contains a unit with undefined value");
                            if (!r.equalBase(n)) throw new Error("Units do not match");
                            var i = r.clone();
                            return i.value = e.find(t, [
                                i.valueType(),
                                n.valueType()
                            ])(i.value, n.value), i.fixPrefix = !1, i;
                        })
                });
            }), wu = ge("tan", [
                "typed"
            ], (t)=>{
                var { typed: e } = t, r = ls({
                    typed: e
                });
                return e("tan", {
                    number: Math.tan,
                    "Complex | BigNumber": (t)=>t.tan()
                }, r);
            }), _u = ge("typeOf", [
                "typed"
            ], (t)=>{
                var { typed: e } = t;
                return e("typeOf", {
                    any: nt
                });
            }), Au = ge("acosh", [
                "typed",
                "config",
                "Complex"
            ], (t)=>{
                var { typed: e, config: r, Complex: n } = t;
                return e("acosh", {
                    number: function(t) {
                        return t >= 1 || r.predictable ? pa(t) : t <= -1 ? new n(Math.log(Math.sqrt(t * t - 1) - t), Math.PI) : new n(t, 0).acosh();
                    },
                    Complex: function(t) {
                        return t.acosh();
                    },
                    BigNumber: function(t) {
                        return t.acosh();
                    }
                });
            }), Eu = ge("acsch", [
                "typed",
                "BigNumber"
            ], (t)=>{
                var { typed: e, BigNumber: r } = t;
                return e("acsch", {
                    number: ga,
                    Complex: function(t) {
                        return t.acsch();
                    },
                    BigNumber: function(t) {
                        return new r(1).div(t).asinh();
                    }
                });
            }), Su = ge("asec", [
                "typed",
                "config",
                "Complex",
                "BigNumber"
            ], (t)=>{
                var { typed: e, config: r, Complex: n, BigNumber: i } = t;
                return e("asec", {
                    number: function(t) {
                        return t <= -1 || t >= 1 || r.predictable ? va(t) : new n(t, 0).asec();
                    },
                    Complex: function(t) {
                        return t.asec();
                    },
                    BigNumber: function(t) {
                        return new i(1).div(t).acos();
                    }
                });
            }), Mu = ge("bin", [
                "typed",
                "format"
            ], (t)=>{
                var { typed: e, format: r } = t;
                return e("bin", {
                    "number | BigNumber": function(t) {
                        return r(t, {
                            notation: "bin"
                        });
                    },
                    "number | BigNumber, number": function(t, e) {
                        return r(t, {
                            notation: "bin",
                            wordSize: e
                        });
                    }
                });
            }), ku = ge("combinationsWithRep", [
                "typed"
            ], (t)=>{
                var { typed: e } = t;
                return e("combinationsWithRep", {
                    "number, number": function(t, e) {
                        if (!pt(t) || t < 0) throw new TypeError("Positive integer value expected in function combinationsWithRep");
                        if (!pt(e) || e < 0) throw new TypeError("Positive integer value expected in function combinationsWithRep");
                        if (t < 1) throw new TypeError("k must be less than or equal to n + k - 1");
                        return e < t - 1 ? ns(t, t + e - 1) / ns(1, e) : ns(e + 1, t + e - 1) / ns(1, t - 1);
                    },
                    "BigNumber, BigNumber": function(t, e) {
                        var r, n, i = new t.constructor(1), o = t.minus(i);
                        if (!Nu(t) || !Nu(e)) throw new TypeError("Positive integer value expected in function combinationsWithRep");
                        if (t.lt(i)) throw new TypeError("k must be less than or equal to n + k - 1 in function combinationsWithRep");
                        if (r = i, e.lt(o)) for(n = i; n.lte(o); n = n.plus(i))r = r.times(e.plus(n)).dividedBy(n);
                        else for(n = i; n.lte(e); n = n.plus(i))r = r.times(o.plus(n)).dividedBy(n);
                        return r;
                    }
                });
            });
            function Nu(t) {
                return t.isInteger() && t.gte(0);
            }
            var Cu = ge("cosh", [
                "typed"
            ], (t)=>{
                var { typed: e } = t;
                return e("cosh", {
                    number: Tt,
                    "Complex | BigNumber": (t)=>t.cosh()
                });
            }), Du = ge("csch", [
                "typed",
                "BigNumber"
            ], (t)=>{
                var { typed: e, BigNumber: r } = t;
                return e("csch", {
                    number: Sa,
                    Complex: (t)=>t.csch(),
                    BigNumber: (t)=>new r(1).div(t.sinh())
                });
            }), Ou = ge("isNaN", [
                "typed"
            ], (t)=>{
                var { typed: e } = t;
                return e("isNaN", {
                    number: js,
                    BigNumber: function(t) {
                        return t.isNaN();
                    },
                    Fraction: function(t) {
                        return !1;
                    },
                    Complex: function(t) {
                        return t.isNaN();
                    },
                    Unit: function(t) {
                        return Number.isNaN(t.value);
                    },
                    "Array | Matrix": function(t) {
                        return vr(t, Number.isNaN);
                    }
                });
            }), Tu = ge("isPrime", [
                "typed"
            ], (t)=>{
                var { typed: e } = t;
                return e("isPrime", {
                    number: function(t) {
                        if (0 * t != 0) return !1;
                        if (t <= 3) return t > 1;
                        if (t % 2 == 0 || t % 3 == 0) return !1;
                        for(var e = 5; e * e <= t; e += 6)if (t % e == 0 || t % (e + 2) == 0) return !1;
                        return !0;
                    },
                    BigNumber: function(t) {
                        if (0 * t.toNumber() != 0) return !1;
                        if (t.lte(3)) return t.gt(1);
                        if (t.mod(2).eq(0) || t.mod(3).eq(0)) return !1;
                        if (t.lt(Math.pow(2, 32))) {
                            for(var e = t.toNumber(), r = 5; r * r <= e; r += 6)if (e % r == 0 || e % (r + 2) == 0) return !1;
                            return !0;
                        }
                        function n(t, e, r) {
                            for(var n = 1; !e.eq(0);)e.mod(2).eq(0) ? (e = e.div(2), t = t.mul(t).mod(r)) : (e = e.sub(1), n = t.mul(n).mod(r));
                            return n;
                        }
                        for(var i = t.constructor.clone({
                            precision: 2 * t.toFixed(0).length
                        }), o = 0, a = (t = new i(t)).sub(1); a.mod(2).eq(0);)a = a.div(2), o += 1;
                        var s = null;
                        if (t.lt("3317044064679887385961981")) s = [
                            2,
                            3,
                            5,
                            7,
                            11,
                            13,
                            17,
                            19,
                            23,
                            29,
                            31,
                            37,
                            41
                        ].filter((e)=>e < t);
                        else {
                            var u = Math.min(t.toNumber() - 2, Math.floor(2 * Math.pow(t.toFixed(0).length * Math.log(10), 2)));
                            s = [];
                            for(var l = 2; l <= u; l += 1)s.push(u);
                        }
                        for(var c = 0; c < s.length; c += 1){
                            var f = s[c], h = n(t.sub(t).add(f), a, t);
                            if (!h.eq(1)) {
                                for(var p = 0, d = h; !d.eq(t.sub(1)); p += 1, d = d.mul(d).mod(t))if (p === o - 1) return !1;
                            }
                        }
                        return !0;
                    },
                    "Array | Matrix": e.referToSelf((t)=>(e)=>vr(e, t))
                });
            }), Fu = ge("randomInt", [
                "typed",
                "config",
                "?on"
            ], (t)=>{
                var { typed: e, config: r, on: n } = t, i = uu(r.randomSeed);
                return n && n("config", function(t, e) {
                    t.randomSeed !== e.randomSeed && (i = uu(t.randomSeed));
                }), e("randomInt", {
                    "": ()=>a(0, 1),
                    number: (t)=>a(0, t),
                    "number, number": (t, e)=>a(t, e),
                    "Array | Matrix": (t)=>o(t, 0, 1),
                    "Array | Matrix, number": (t, e)=>o(t, 0, e),
                    "Array | Matrix, number, number": (t, e, r)=>o(t, e, r)
                });
                function o(t, e, r) {
                    var n = cu(t.valueOf(), ()=>a(e, r));
                    return E(t) ? t.create(n) : n;
                }
                function a(t, e) {
                    return Math.floor(t + i() * (e - t));
                }
            }), Pu = ge("sech", [
                "typed",
                "BigNumber"
            ], (t)=>{
                var { typed: e, BigNumber: r } = t;
                return e("sech", {
                    number: ka,
                    Complex: (t)=>t.sech(),
                    BigNumber: (t)=>new r(1).div(t.cosh())
                });
            }), Iu = ge("sinh", [
                "typed"
            ], (t)=>{
                var { typed: e } = t;
                return e("sinh", {
                    number: Na,
                    "Complex | BigNumber": (t)=>t.sinh()
                });
            }), Bu = ge("sparse", [
                "typed",
                "SparseMatrix"
            ], (t)=>{
                var { typed: e, SparseMatrix: r } = t;
                return e("sparse", {
                    "": function() {
                        return new r([]);
                    },
                    string: function(t) {
                        return new r([], t);
                    },
                    "Array | Matrix": function(t) {
                        return new r(t);
                    },
                    "Array | Matrix, string": function(t, e) {
                        return new r(t, e);
                    }
                });
            }), ju = ge("sqrt", [
                "config",
                "typed",
                "Complex"
            ], (t)=>{
                var { config: e, typed: r, Complex: n } = t;
                return r("sqrt", {
                    number: i,
                    Complex: function(t) {
                        return t.sqrt();
                    },
                    BigNumber: function(t) {
                        return !t.isNegative() || e.predictable ? t.sqrt() : i(t.toNumber());
                    },
                    Unit: function(t) {
                        return t.pow(.5);
                    }
                });
                function i(t) {
                    return isNaN(t) ? NaN : t >= 0 || e.predictable ? Math.sqrt(t) : new n(t, 0).sqrt();
                }
            }), Ru = ge("tanh", [
                "typed"
            ], (t)=>{
                var { typed: e } = t;
                return e("tanh", {
                    number: Pt,
                    "Complex | BigNumber": (t)=>t.tanh()
                });
            }), Lu = ge("unaryMinus", [
                "typed"
            ], (t)=>{
                var { typed: e } = t;
                return e("unaryMinus", {
                    number: Yo,
                    "Complex | BigNumber | Fraction": (t)=>t.neg(),
                    Unit: e.referToSelf((t)=>(r)=>{
                            var n = r.clone();
                            return n.value = e.find(t, n.valueType())(r.value), n;
                        }),
                    "Array | Matrix": e.referToSelf((t)=>(e)=>vr(e, t, !0))
                });
            }), qu = ge("acoth", [
                "typed",
                "config",
                "Complex",
                "BigNumber"
            ], (t)=>{
                var { typed: e, config: r, Complex: n, BigNumber: i } = t;
                return e("acoth", {
                    number: function(t) {
                        return t >= 1 || t <= -1 || r.predictable ? ma(t) : new n(t, 0).acoth();
                    },
                    Complex: function(t) {
                        return t.acoth();
                    },
                    BigNumber: function(t) {
                        return new i(1).div(t).atanh();
                    }
                });
            }), Uu = ge("coth", [
                "typed",
                "BigNumber"
            ], (t)=>{
                var { typed: e, BigNumber: r } = t;
                return e("coth", {
                    number: Aa,
                    Complex: (t)=>t.coth(),
                    BigNumber: (t)=>new r(1).div(t.tanh())
                });
            }), zu = ge("fraction", [
                "typed",
                "Fraction"
            ], (t)=>{
                var { typed: e, Fraction: r } = t;
                return e("fraction", {
                    number: function(t) {
                        if (!isFinite(t) || isNaN(t)) throw new Error(t + " cannot be represented as a fraction");
                        return new r(t);
                    },
                    string: function(t) {
                        return new r(t);
                    },
                    "number, number": function(t, e) {
                        return new r(t, e);
                    },
                    null: function(t) {
                        return new r(0);
                    },
                    BigNumber: function(t) {
                        return new r(t.toString());
                    },
                    Fraction: function(t) {
                        return t;
                    },
                    Unit: e.referToSelf((t)=>(e)=>{
                            var r = e.clone();
                            return r.value = t(e.value), r;
                        }),
                    Object: function(t) {
                        return new r(t);
                    },
                    "Array | Matrix": e.referToSelf((t)=>(e)=>vr(e, t))
                });
            }), Gu = ge("isNumeric", [
                "typed"
            ], (t)=>{
                var { typed: e } = t;
                return e("isNumeric", {
                    "number | BigNumber | Fraction | boolean": ()=>!0,
                    "Complex | Unit | string | null | undefined | Node": ()=>!1,
                    "Array | Matrix": e.referToSelf((t)=>(e)=>vr(e, t))
                });
            }), Hu = ge("matrix", [
                "typed",
                "Matrix",
                "DenseMatrix",
                "SparseMatrix"
            ], (t)=>{
                var { typed: e, Matrix: r, DenseMatrix: n, SparseMatrix: i } = t;
                return e("matrix", {
                    "": function() {
                        return o([]);
                    },
                    string: function(t) {
                        return o([], t);
                    },
                    "string, string": function(t, e) {
                        return o([], t, e);
                    },
                    Array: function(t) {
                        return o(t);
                    },
                    Matrix: function(t) {
                        return o(t, t.storage());
                    },
                    "Array | Matrix, string": o,
                    "Array | Matrix, string, string": o
                });
                function o(t, e, r) {
                    if ("dense" === e || "default" === e || void 0 === e) return new n(t, r);
                    if ("sparse" === e) return new i(t, r);
                    throw new TypeError("Unknown matrix type " + JSON.stringify(e) + ".");
                }
            }), Wu = ge("matrixFromFunction", [
                "typed",
                "matrix",
                "isZero"
            ], (t)=>{
                var { typed: e, matrix: r, isZero: n } = t;
                return e("matrixFromFunction", {
                    "Array | Matrix, function, string, string": function(t, e, r, n) {
                        return i(t, e, r, n);
                    },
                    "Array | Matrix, function, string": function(t, e, r) {
                        return i(t, e, r);
                    },
                    "Matrix, function": function(t, e) {
                        return i(t, e, "dense");
                    },
                    "Array, function": function(t, e) {
                        return i(t, e, "dense").toArray();
                    },
                    "Array | Matrix, string, function": function(t, e, r) {
                        return i(t, r, e);
                    },
                    "Array | Matrix, string, string, function": function(t, e, r, n) {
                        return i(t, n, e, r);
                    }
                });
                function i(t, e, i, o) {
                    var a;
                    return (a = void 0 !== o ? r(i, o) : r(i)).resize(t), a.forEach(function(t, r) {
                        var i = e(r);
                        n(i) || a.set(r, i);
                    }), a;
                }
            }), $u = ge("mode", [
                "typed",
                "isNaN",
                "isNumeric"
            ], (t)=>{
                var { typed: e, isNaN: r, isNumeric: n } = t;
                return e("mode", {
                    "Array | Matrix": i,
                    "...": function(t) {
                        return i(t);
                    }
                });
                function i(t) {
                    if (0 === (t = ne(t.valueOf())).length) throw new Error("Cannot calculate mode of an empty array");
                    for(var e = {}, i = [], o = 0, a = 0; a < t.length; a++){
                        var s = t[a];
                        if (n(s) && r(s)) throw new Error("Cannot calculate mode of an array containing NaN values");
                        s in e || (e[s] = 0), e[s]++, e[s] === o ? i.push(s) : e[s] > o && (o = e[s], i = [
                            s
                        ]);
                    }
                    return i;
                }
            }), Vu = ge("numeric", [
                "number",
                "?bignumber",
                "?fraction"
            ], (t)=>{
                var { number: e, bignumber: r, fraction: n } = t, i = {
                    string: !0,
                    number: !0,
                    BigNumber: !0,
                    Fraction: !0
                }, o = {
                    number: (t)=>e(t),
                    BigNumber: r ? (t)=>r(t) : kr,
                    Fraction: n ? (t)=>n(t) : Nr
                };
                return function(t) {
                    var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "number", r = arguments.length > 2 ? arguments[2] : void 0;
                    if (void 0 !== r) throw new SyntaxError("numeric() takes one or two arguments");
                    var n = nt(t);
                    if (!(n in i)) throw new TypeError("Cannot convert " + t + ' of type "' + n + '"; valid input types are ' + Object.keys(i).join(", "));
                    if (!(e in o)) throw new TypeError("Cannot convert " + t + ' to type "' + e + '"; valid output types are ' + Object.keys(o).join(", "));
                    return e === n ? t : o[e](t);
                };
            }), Zu = ge("prod", [
                "typed",
                "config",
                "multiplyScalar",
                "numeric"
            ], (t)=>{
                var { typed: e, config: r, multiplyScalar: n, numeric: i } = t;
                return e("prod", {
                    "Array | Matrix": o,
                    "Array | Matrix, number | BigNumber": function(t, e) {
                        throw new Error("prod(A, dim) is not yet supported");
                    },
                    "...": function(t) {
                        return o(t);
                    }
                });
                function o(t) {
                    var e;
                    if (gr(t, function(t) {
                        try {
                            e = void 0 === e ? t : n(e, t);
                        } catch (e) {
                            throw mn(e, "prod", t);
                        }
                    }), "string" == typeof e && (e = i(e, r.number)), void 0 === e) throw new Error("Cannot calculate prod of an empty array");
                    return e;
                }
            }), Yu = ge("reshape", [
                "typed",
                "isInteger",
                "matrix"
            ], (t)=>{
                var { typed: e, isInteger: r } = t;
                return e("reshape", {
                    "Matrix, Array": function(t, e) {
                        return t.reshape(e, !0);
                    },
                    "Array, Array": function(t, e) {
                        return e.forEach(function(t) {
                            if (!r(t)) throw new TypeError("Invalid size for dimension: " + t);
                        }), Jt(t, e);
                    }
                });
            }), Ku = ge("size", [
                "typed",
                "config",
                "?matrix"
            ], (t)=>{
                var { typed: e, config: r, matrix: n } = t;
                return e("size", {
                    Matrix: function(t) {
                        return t.create(t.size());
                    },
                    Array: $t,
                    string: function(t) {
                        return "Array" === r.matrix ? [
                            t.length
                        ] : n([
                            t.length
                        ]);
                    },
                    "number | Complex | BigNumber | Unit | boolean | null": function(t) {
                        return "Array" === r.matrix ? [] : n ? n([]) : Cr();
                    }
                });
            }), Xu = ge("squeeze", [
                "typed",
                "matrix"
            ], (t)=>{
                var { typed: e, matrix: r } = t;
                return e("squeeze", {
                    Array: function(t) {
                        return ee(it(t));
                    },
                    Matrix: function(t) {
                        var e = ee(t.toArray());
                        return Array.isArray(e) ? r(e) : e;
                    },
                    any: function(t) {
                        return it(t);
                    }
                });
            }), Ju = ge("transpose", [
                "typed",
                "matrix"
            ], (t)=>{
                var { typed: e, matrix: r } = t;
                return e("transpose", {
                    Array: (t)=>n(r(t)).valueOf(),
                    Matrix: n,
                    any: it
                });
                function n(t) {
                    var e, r = t.size();
                    switch(r.length){
                        case 1:
                            e = t.clone();
                            break;
                        case 2:
                            var n = r[0], i = r[1];
                            if (0 === i) throw new RangeError("Cannot transpose a 2D matrix with no columns (size: " + Lt(r) + ")");
                            switch(t.storage()){
                                case "dense":
                                    e = function(t, e, r) {
                                        for(var n, i = t._data, o = [], a = 0; a < r; a++){
                                            n = o[a] = [];
                                            for(var s = 0; s < e; s++)n[s] = it(i[s][a]);
                                        }
                                        return t.createDenseMatrix({
                                            data: o,
                                            size: [
                                                r,
                                                e
                                            ],
                                            datatype: t._datatype
                                        });
                                    }(t, n, i);
                                    break;
                                case "sparse":
                                    e = function(t, e, r) {
                                        for(var n, i, o, a = t._values, s = t._index, u = t._ptr, l = a ? [] : void 0, c = [], f = [], h = [], p = 0; p < e; p++)h[p] = 0;
                                        for(n = 0, i = s.length; n < i; n++)h[s[n]]++;
                                        for(var d = 0, m = 0; m < e; m++)f.push(d), d += h[m], h[m] = f[m];
                                        for(f.push(d), o = 0; o < r; o++)for(var y = u[o], g = u[o + 1], v = y; v < g; v++){
                                            var b = h[s[v]]++;
                                            c[b] = o, a && (l[b] = it(a[v]));
                                        }
                                        return t.createSparseMatrix({
                                            values: l,
                                            index: c,
                                            ptr: f,
                                            size: [
                                                r,
                                                e
                                            ],
                                            datatype: t._datatype
                                        });
                                    }(t, n, i);
                            }
                            break;
                        default:
                            throw new RangeError("Matrix must be a vector or two dimensional (size: " + Lt(r) + ")");
                    }
                    return e;
                }
            }), Qu = ge("xgcd", [
                "typed",
                "config",
                "matrix",
                "BigNumber"
            ], (t)=>{
                var { typed: e, config: r, matrix: n, BigNumber: i } = t;
                return e("xgcd", {
                    "number, number": function(t, e) {
                        var i = sa(t, e);
                        return "Array" === r.matrix ? i : n(i);
                    },
                    "BigNumber, BigNumber": function(t, e) {
                        var o, a, s, u, l = new i(0), c = new i(1), f = l, h = c, p = c, d = l;
                        if (!t.isInt() || !e.isInt()) throw new Error("Parameters in function xgcd must be integer numbers");
                        for(; !e.isZero();)a = t.div(e).floor(), s = t.mod(e), o = f, f = h.minus(a.times(f)), h = o, o = p, p = d.minus(a.times(p)), d = o, t = e, e = s;
                        u = t.lt(l) ? [
                            t.neg(),
                            h.neg(),
                            d.neg()
                        ] : [
                            t,
                            t.isZero() ? 0 : h,
                            d
                        ];
                        return "Array" === r.matrix ? u : n(u);
                    }
                });
            }), tl = ge("zeros", [
                "typed",
                "config",
                "matrix",
                "BigNumber"
            ], (t)=>{
                var { typed: e, config: r, matrix: n, BigNumber: i } = t;
                return e("zeros", {
                    "": function() {
                        return "Array" === r.matrix ? o([]) : o([], "default");
                    },
                    "...number | BigNumber | string": function(t) {
                        if ("string" == typeof t[t.length - 1]) {
                            var e = t.pop();
                            return o(t, e);
                        }
                        return "Array" === r.matrix ? o(t) : o(t, "default");
                    },
                    Array: o,
                    Matrix: function(t) {
                        var e = t.storage();
                        return o(t.valueOf(), e);
                    },
                    "Array | Matrix, string": function(t, e) {
                        return o(t.valueOf(), e);
                    }
                });
                function o(t, e) {
                    var r = function(t) {
                        var e = !1;
                        return t.forEach(function(t, r, n) {
                            v(t) && (e = !0, n[r] = t.toNumber());
                        }), e;
                    }(t) ? new i(0) : 0;
                    if (function(t) {
                        t.forEach(function(t) {
                            if ("number" != typeof t || !pt(t) || t < 0) throw new Error("Parameters in function zeros must be positive integers");
                        });
                    }(t), e) {
                        var o = n(e);
                        return t.length > 0 ? o.resize(t, r) : o;
                    }
                    var a = [];
                    return t.length > 0 ? Xt(a, t, r) : a;
                }
            }), el = ge("asin", [
                "typed",
                "config",
                "Complex"
            ], (t)=>{
                var { typed: e, config: r, Complex: n } = t;
                return e("asin", {
                    number: function(t) {
                        return t >= -1 && t <= 1 || r.predictable ? Math.asin(t) : new n(t, 0).asin();
                    },
                    Complex: function(t) {
                        return t.asin();
                    },
                    BigNumber: function(t) {
                        return t.asin();
                    }
                });
            }), rl = ge("cbrt", [
                "config",
                "typed",
                "isNegative",
                "unaryMinus",
                "matrix",
                "Complex",
                "BigNumber",
                "Fraction"
            ], (t)=>{
                var { config: e, typed: r, isNegative: n, unaryMinus: i, matrix: o, Complex: a, BigNumber: s, Fraction: u } = t;
                return r("cbrt", {
                    number: Xo,
                    Complex: l,
                    "Complex, boolean": l,
                    BigNumber: function(t) {
                        return t.cbrt();
                    },
                    Unit: function(t) {
                        if (t.value && b(t.value)) {
                            var e = t.clone();
                            return e.value = 1, (e = e.pow(1 / 3)).value = l(t.value), e;
                        }
                        var r, o = n(t.value);
                        o && (t.value = i(t.value)), r = v(t.value) ? new s(1).div(3) : x(t.value) ? new u(1, 3) : 1 / 3;
                        var a = t.pow(r);
                        return o && (a.value = i(a.value)), a;
                    }
                });
                function l(t, r) {
                    var n = t.arg() / 3, i = t.abs(), s = new a(Xo(i), 0).mul(new a(0, n).exp());
                    if (r) {
                        var u = [
                            s,
                            new a(Xo(i), 0).mul(new a(0, n + 2 * Math.PI / 3).exp()),
                            new a(Xo(i), 0).mul(new a(0, n - 2 * Math.PI / 3).exp())
                        ];
                        return "Array" === e.matrix ? u : o(u);
                    }
                    return s;
                }
            }), nl = ge("count", [
                "typed",
                "size",
                "prod"
            ], (t)=>{
                var { typed: e, size: r, prod: n } = t;
                return e("count", {
                    string: function(t) {
                        return t.length;
                    },
                    "Matrix | Array": function(t) {
                        return n(r(t));
                    }
                });
            }), il = ge("ctranspose", [
                "typed",
                "transpose",
                "conj"
            ], (t)=>{
                var { typed: e, transpose: r, conj: n } = t;
                return e("ctranspose", {
                    any: function(t) {
                        return n(r(t));
                    }
                });
            }), ol = ge("diag", [
                "typed",
                "matrix",
                "DenseMatrix",
                "SparseMatrix"
            ], (t)=>{
                var { typed: e, matrix: r, DenseMatrix: n, SparseMatrix: i } = t;
                return e("diag", {
                    Array: function(t) {
                        return o(t, 0, $t(t), null);
                    },
                    "Array, number": function(t, e) {
                        return o(t, e, $t(t), null);
                    },
                    "Array, BigNumber": function(t, e) {
                        return o(t, e.toNumber(), $t(t), null);
                    },
                    "Array, string": function(t, e) {
                        return o(t, 0, $t(t), e);
                    },
                    "Array, number, string": function(t, e, r) {
                        return o(t, e, $t(t), r);
                    },
                    "Array, BigNumber, string": function(t, e, r) {
                        return o(t, e.toNumber(), $t(t), r);
                    },
                    Matrix: function(t) {
                        return o(t, 0, t.size(), t.storage());
                    },
                    "Matrix, number": function(t, e) {
                        return o(t, e, t.size(), t.storage());
                    },
                    "Matrix, BigNumber": function(t, e) {
                        return o(t, e.toNumber(), t.size(), t.storage());
                    },
                    "Matrix, string": function(t, e) {
                        return o(t, 0, t.size(), e);
                    },
                    "Matrix, number, string": function(t, e, r) {
                        return o(t, e, t.size(), r);
                    },
                    "Matrix, BigNumber, string": function(t, e, r) {
                        return o(t, e.toNumber(), t.size(), r);
                    }
                });
                function o(t, e, o, a) {
                    if (!pt(e)) throw new TypeError("Second parameter in function diag must be an integer");
                    var s = e > 0 ? e : 0, u = e < 0 ? -e : 0;
                    switch(o.length){
                        case 1:
                            return function(t, e, r, o, a, s) {
                                var u = [
                                    o + a,
                                    o + s
                                ];
                                if (r && "sparse" !== r && "dense" !== r) throw new TypeError("Unknown matrix type ".concat(r, '"'));
                                var l = "sparse" === r ? i.diagonal(u, t, e) : n.diagonal(u, t, e);
                                return null !== r ? l : l.valueOf();
                            }(t, e, a, o[0], u, s);
                        case 2:
                            return function(t, e, n, i, o, a) {
                                if (E(t)) {
                                    var s = t.diagonal(e);
                                    return null !== n ? n !== s.storage() ? r(s, n) : s : s.valueOf();
                                }
                                for(var u = Math.min(i[0] - o, i[1] - a), l = [], c = 0; c < u; c++)l[c] = t[c + o][c + a];
                                return null !== n ? r(l) : l;
                            }(t, e, a, o, u, s);
                    }
                    throw new RangeError("Matrix for function diag must be 2 dimensional");
                }
            }), al = ge("divideScalar", [
                "typed",
                "numeric"
            ], (t)=>{
                var { typed: e, numeric: r } = t;
                return e("divideScalar", {
                    "number, number": function(t, e) {
                        return t / e;
                    },
                    "Complex, Complex": function(t, e) {
                        return t.div(e);
                    },
                    "BigNumber, BigNumber": function(t, e) {
                        return t.div(e);
                    },
                    "Fraction, Fraction": function(t, e) {
                        return t.div(e);
                    },
                    "Unit, number | Complex | Fraction | BigNumber | Unit": (t, e)=>t.divide(e),
                    "number | Fraction | Complex | BigNumber, Unit": (t, e)=>e.divideInto(t)
                });
            }), sl = ge("matAlgo02xDS0", [
                "typed",
                "equalScalar"
            ], (t)=>{
                var { typed: e, equalScalar: r } = t;
                return function(t, n, i, o) {
                    var a = t._data, s = t._size, u = t._datatype, l = n._values, c = n._index, f = n._ptr, h = n._size, p = n._datatype;
                    if (s.length !== h.length) throw new Ht(s.length, h.length);
                    if (s[0] !== h[0] || s[1] !== h[1]) throw new RangeError("Dimension mismatch. Matrix A (" + s + ") must match Matrix B (" + h + ")");
                    if (!l) throw new Error("Cannot perform operation on Dense Matrix and Pattern Sparse Matrix");
                    var d, m = s[0], y = s[1], g = r, v = 0, b = i;
                    "string" == typeof u && u === p && (d = u, g = e.find(r, [
                        d,
                        d
                    ]), v = e.convert(0, d), b = e.find(i, [
                        d,
                        d
                    ]));
                    for(var x = [], w = [], _ = [], A = 0; A < y; A++){
                        _[A] = w.length;
                        for(var E = f[A], S = f[A + 1], M = E; M < S; M++){
                            var k = c[M], N = o ? b(l[M], a[k][A]) : b(a[k][A], l[M]);
                            g(N, v) || (w.push(k), x.push(N));
                        }
                    }
                    return _[y] = w.length, n.createSparseMatrix({
                        values: x,
                        index: w,
                        ptr: _,
                        size: [
                            m,
                            y
                        ],
                        datatype: d
                    });
                };
            }), ul = ge("matAlgo03xDSf", [
                "typed"
            ], (t)=>{
                var { typed: e } = t;
                return function(t, r, n, i) {
                    var o = t._data, a = t._size, s = t._datatype, u = r._values, l = r._index, c = r._ptr, f = r._size, h = r._datatype;
                    if (a.length !== f.length) throw new Ht(a.length, f.length);
                    if (a[0] !== f[0] || a[1] !== f[1]) throw new RangeError("Dimension mismatch. Matrix A (" + a + ") must match Matrix B (" + f + ")");
                    if (!u) throw new Error("Cannot perform operation on Dense Matrix and Pattern Sparse Matrix");
                    var p, d = a[0], m = a[1], y = 0, g = n;
                    "string" == typeof s && s === h && (p = s, y = e.convert(0, p), g = e.find(n, [
                        p,
                        p
                    ]));
                    for(var v = [], b = 0; b < d; b++)v[b] = [];
                    for(var x = [], w = [], _ = 0; _ < m; _++){
                        for(var A = _ + 1, E = c[_], S = c[_ + 1], M = E; M < S; M++){
                            var k = l[M];
                            x[k] = i ? g(u[M], o[k][_]) : g(o[k][_], u[M]), w[k] = A;
                        }
                        for(var N = 0; N < d; N++)w[N] === A ? v[N][_] = x[N] : v[N][_] = i ? g(y, o[N][_]) : g(o[N][_], y);
                    }
                    return t.createDenseMatrix({
                        data: v,
                        size: [
                            d,
                            m
                        ],
                        datatype: p
                    });
                };
            }), ll = ge("matAlgo07xSSf", [
                "typed",
                "DenseMatrix"
            ], (t)=>{
                var { typed: e, DenseMatrix: r } = t;
                return function(t, i, o) {
                    var a = t._size, s = t._datatype, u = i._size, l = i._datatype;
                    if (a.length !== u.length) throw new Ht(a.length, u.length);
                    if (a[0] !== u[0] || a[1] !== u[1]) throw new RangeError("Dimension mismatch. Matrix A (" + a + ") must match Matrix B (" + u + ")");
                    var c, f, h, p = a[0], d = a[1], m = 0, y = o;
                    "string" == typeof s && s === l && (c = s, m = e.convert(0, c), y = e.find(o, [
                        c,
                        c
                    ]));
                    var g = [];
                    for(f = 0; f < p; f++)g[f] = [];
                    var v = [], b = [], x = [], w = [];
                    for(h = 0; h < d; h++){
                        var _ = h + 1;
                        for(n(t, h, x, v, _), n(i, h, w, b, _), f = 0; f < p; f++){
                            var A = x[f] === _ ? v[f] : m, E = w[f] === _ ? b[f] : m;
                            g[f][h] = y(A, E);
                        }
                    }
                    return new r({
                        data: g,
                        size: [
                            p,
                            d
                        ],
                        datatype: c
                    });
                };
                function n(t, e, r, n, i) {
                    for(var o = t._values, a = t._index, s = t._ptr, u = s[e], l = s[e + 1]; u < l; u++){
                        var c = a[u];
                        r[c] = i, n[c] = o[u];
                    }
                }
            }), cl = ge("matAlgo11xS0s", [
                "typed",
                "equalScalar"
            ], (t)=>{
                var { typed: e, equalScalar: r } = t;
                return function(t, n, i, o) {
                    var a = t._values, s = t._index, u = t._ptr, l = t._size, c = t._datatype;
                    if (!a) throw new Error("Cannot perform operation on Pattern Sparse Matrix and Scalar value");
                    var f, h = l[0], p = l[1], d = r, m = 0, y = i;
                    "string" == typeof c && (f = c, d = e.find(r, [
                        f,
                        f
                    ]), m = e.convert(0, f), n = e.convert(n, f), y = e.find(i, [
                        f,
                        f
                    ]));
                    for(var g = [], v = [], b = [], x = 0; x < p; x++){
                        b[x] = v.length;
                        for(var w = u[x], _ = u[x + 1], A = w; A < _; A++){
                            var E = s[A], S = o ? y(n, a[A]) : y(a[A], n);
                            d(S, m) || (v.push(E), g.push(S));
                        }
                    }
                    return b[p] = v.length, t.createSparseMatrix({
                        values: g,
                        index: v,
                        ptr: b,
                        size: [
                            h,
                            p
                        ],
                        datatype: f
                    });
                };
            }), fl = ge("matAlgo12xSfs", [
                "typed",
                "DenseMatrix"
            ], (t)=>{
                var { typed: e, DenseMatrix: r } = t;
                return function(t, n, i, o) {
                    var a = t._values, s = t._index, u = t._ptr, l = t._size, c = t._datatype;
                    if (!a) throw new Error("Cannot perform operation on Pattern Sparse Matrix and Scalar value");
                    var f, h = l[0], p = l[1], d = i;
                    "string" == typeof c && (f = c, n = e.convert(n, f), d = e.find(i, [
                        f,
                        f
                    ]));
                    for(var m = [], y = [], g = [], v = 0; v < p; v++){
                        for(var b = v + 1, x = u[v], w = u[v + 1], _ = x; _ < w; _++){
                            var A = s[_];
                            y[A] = a[_], g[A] = b;
                        }
                        for(var E = 0; E < h; E++)0 === v && (m[E] = []), g[E] === b ? m[E][v] = o ? d(n, y[E]) : d(y[E], n) : m[E][v] = o ? d(n, 0) : d(0, n);
                    }
                    return new r({
                        data: m,
                        size: [
                            h,
                            p
                        ],
                        datatype: f
                    });
                };
            }), hl = ge("matAlgo13xDD", [
                "typed"
            ], (t)=>{
                var { typed: e } = t;
                return function(t, r, n) {
                    var i, o = t._data, a = t._size, s = t._datatype, u = r._data, l = r._size, c = r._datatype, f = [];
                    if (a.length !== l.length) throw new Ht(a.length, l.length);
                    for(var h = 0; h < a.length; h++){
                        if (a[h] !== l[h]) throw new RangeError("Dimension mismatch. Matrix A (" + a + ") must match Matrix B (" + l + ")");
                        f[h] = a[h];
                    }
                    var p = n;
                    "string" == typeof s && s === c && (i = s, p = e.find(n, [
                        i,
                        i
                    ]));
                    var d = f.length > 0 ? function t(e, r, n, i, o, a) {
                        var s = [];
                        if (r === n.length - 1) for(var u = 0; u < i; u++)s[u] = e(o[u], a[u]);
                        else for(var l = 0; l < i; l++)s[l] = t(e, r + 1, n, n[r + 1], o[l], a[l]);
                        return s;
                    }(p, 0, f, f[0], o, u) : [];
                    return t.createDenseMatrix({
                        data: d,
                        size: f,
                        datatype: i
                    });
                };
            }), pl = ge("matAlgo14xDs", [
                "typed"
            ], (t)=>{
                var { typed: e } = t;
                return function(t, r, n, i) {
                    var o, a = t._data, s = t._size, u = t._datatype, l = n;
                    "string" == typeof u && (o = u, r = e.convert(r, o), l = e.find(n, [
                        o,
                        o
                    ]));
                    var c = s.length > 0 ? function t(e, r, n, i, o, a, s) {
                        var u = [];
                        if (r === n.length - 1) for(var l = 0; l < i; l++)u[l] = s ? e(a, o[l]) : e(o[l], a);
                        else for(var c = 0; c < i; c++)u[c] = t(e, r + 1, n, n[r + 1], o[c], a, s);
                        return u;
                    }(l, 0, s, s[0], a, r, i) : [];
                    return t.createDenseMatrix({
                        data: c,
                        size: it(s),
                        datatype: o
                    });
                };
            }), dl = ge("broadcast", [
                "concat"
            ], (t)=>{
                var { concat: e } = t;
                return function(t, e) {
                    var i = Math.max(t._size.length, e._size.length);
                    if (t._size.length === e._size.length && t._size.every((t, r)=>t === e._size[r])) return [
                        t,
                        e
                    ];
                    for(var o = r(t._size, i, 0), a = r(e._size, i, 0), s = [], u = 0; u < i; u++)s[u] = Math.max(o[u], a[u]);
                    me(o, s), me(a, s);
                    var l = t.clone(), c = e.clone();
                    l._size.length < i ? l.reshape(r(l._size, i, 1)) : c._size.length < i && c.reshape(r(c._size, i, 1));
                    for(var f = 0; f < i; f++)l._size[f] < s[f] && (l = n(l, s[f], f)), c._size[f] < s[f] && (c = n(c, s[f], f));
                    return [
                        l,
                        c
                    ];
                };
                function r(t, e, r) {
                    return [
                        ...Array(e - t.length).fill(r),
                        ...t
                    ];
                }
                function n(t, r, n) {
                    return e(...Array(r).fill(t), n);
                }
            }), ml = ge("matrixAlgorithmSuite", [
                "typed",
                "matrix",
                "concat"
            ], (t)=>{
                var { typed: e, matrix: r, concat: n } = t, i = hl({
                    typed: e
                }), o = pl({
                    typed: e
                }), a = dl({
                    concat: n
                });
                return function(t) {
                    var n, s = t.elop, u = t.SD || t.DS;
                    s ? (n = {
                        "DenseMatrix, DenseMatrix": (t, e)=>i(...a(t, e), s),
                        "Array, Array": (t, e)=>i(...a(r(t), r(e)), s).valueOf(),
                        "Array, DenseMatrix": (t, e)=>i(...a(r(t), e), s),
                        "DenseMatrix, Array": (t, e)=>i(...a(t, r(e)), s)
                    }, t.SS && (n["SparseMatrix, SparseMatrix"] = (e, r)=>t.SS(...a(e, r), s, !1)), t.DS && (n["DenseMatrix, SparseMatrix"] = (e, r)=>t.DS(...a(e, r), s, !1), n["Array, SparseMatrix"] = (e, n)=>t.DS(...a(r(e), n), s, !1)), u && (n["SparseMatrix, DenseMatrix"] = (t, e)=>u(...a(e, t), s, !0), n["SparseMatrix, Array"] = (t, e)=>u(...a(r(e), t), s, !0))) : (n = {
                        "DenseMatrix, DenseMatrix": e.referToSelf((t)=>(e, r)=>i(...a(e, r), t)),
                        "Array, Array": e.referToSelf((t)=>(e, n)=>i(...a(r(e), r(n)), t).valueOf()),
                        "Array, DenseMatrix": e.referToSelf((t)=>(e, n)=>i(...a(r(e), n), t)),
                        "DenseMatrix, Array": e.referToSelf((t)=>(e, n)=>i(...a(e, r(n)), t))
                    }, t.SS && (n["SparseMatrix, SparseMatrix"] = e.referToSelf((e)=>(r, n)=>t.SS(...a(r, n), e, !1))), t.DS && (n["DenseMatrix, SparseMatrix"] = e.referToSelf((e)=>(r, n)=>t.DS(...a(r, n), e, !1)), n["Array, SparseMatrix"] = e.referToSelf((e)=>(n, i)=>t.DS(...a(r(n), i), e, !1))), u && (n["SparseMatrix, DenseMatrix"] = e.referToSelf((t)=>(e, r)=>u(...a(r, e), t, !0)), n["SparseMatrix, Array"] = e.referToSelf((t)=>(e, n)=>u(...a(r(n), e), t, !0))));
                    var l = t.scalar || "any";
                    (t.Ds || t.Ss) && (s ? (n["DenseMatrix," + l] = (t, e)=>o(t, e, s, !1), n[l + ", DenseMatrix"] = (t, e)=>o(e, t, s, !0), n["Array," + l] = (t, e)=>o(r(t), e, s, !1).valueOf(), n[l + ", Array"] = (t, e)=>o(r(e), t, s, !0).valueOf()) : (n["DenseMatrix," + l] = e.referToSelf((t)=>(e, r)=>o(e, r, t, !1)), n[l + ", DenseMatrix"] = e.referToSelf((t)=>(e, r)=>o(r, e, t, !0)), n["Array," + l] = e.referToSelf((t)=>(e, n)=>o(r(e), n, t, !1).valueOf()), n[l + ", Array"] = e.referToSelf((t)=>(e, n)=>o(r(n), e, t, !0).valueOf())));
                    var c = void 0 !== t.sS ? t.sS : t.Ss;
                    return s ? (t.Ss && (n["SparseMatrix," + l] = (e, r)=>t.Ss(e, r, s, !1)), c && (n[l + ", SparseMatrix"] = (t, e)=>c(e, t, s, !0))) : (t.Ss && (n["SparseMatrix," + l] = e.referToSelf((e)=>(r, n)=>t.Ss(r, n, e, !1))), c && (n[l + ", SparseMatrix"] = e.referToSelf((t)=>(e, r)=>c(r, e, t, !0)))), s && s.signatures && at(n, s.signatures), n;
                };
            }), yl = ge("dotDivide", [
                "typed",
                "matrix",
                "equalScalar",
                "divideScalar",
                "DenseMatrix",
                "concat"
            ], (t)=>{
                var { typed: e, matrix: r, equalScalar: n, divideScalar: i, DenseMatrix: o, concat: a } = t, s = sl({
                    typed: e,
                    equalScalar: n
                }), u = ul({
                    typed: e
                }), l = ll({
                    typed: e,
                    DenseMatrix: o
                }), c = cl({
                    typed: e,
                    equalScalar: n
                }), f = fl({
                    typed: e,
                    DenseMatrix: o
                });
                return e("dotDivide", ml({
                    typed: e,
                    matrix: r,
                    concat: a
                })({
                    elop: i,
                    SS: l,
                    DS: u,
                    SD: s,
                    Ss: c,
                    sS: f
                }));
            }), gl = ge("equal", [
                "typed",
                "matrix",
                "equalScalar",
                "DenseMatrix",
                "concat"
            ], (t)=>{
                var { typed: e, matrix: r, equalScalar: n, DenseMatrix: i, concat: o } = t, a = ul({
                    typed: e
                }), s = ll({
                    typed: e,
                    DenseMatrix: i
                }), u = fl({
                    typed: e,
                    DenseMatrix: i
                }), l = ml({
                    typed: e,
                    matrix: r,
                    concat: o
                });
                return e("equal", vl({
                    typed: e,
                    equalScalar: n
                }), l({
                    elop: n,
                    SS: s,
                    DS: a,
                    Ss: u
                }));
            }), vl = ge("equal", [
                "typed",
                "equalScalar"
            ], (t)=>{
                var { typed: e, equalScalar: r } = t;
                return e("equal", {
                    "any, any": function(t, e) {
                        return null === t ? null === e : null === e ? null === t : void 0 === t ? void 0 === e : void 0 === e ? void 0 === t : r(t, e);
                    }
                });
            }), bl = ge("flatten", [
                "typed",
                "matrix"
            ], (t)=>{
                var { typed: e, matrix: r } = t;
                return e("flatten", {
                    Array: function(t) {
                        return ne(t);
                    },
                    Matrix: function(t) {
                        var e = ne(t.toArray());
                        return r(e);
                    }
                });
            }), xl = ge("hasNumericValue", [
                "typed",
                "isNumeric"
            ], (t)=>{
                var { typed: e, isNumeric: r } = t;
                return e("hasNumericValue", {
                    boolean: ()=>!0,
                    string: function(t) {
                        return t.trim().length > 0 && !isNaN(Number(t));
                    },
                    any: function(t) {
                        return r(t);
                    }
                });
            }), wl = ge("identity", [
                "typed",
                "config",
                "matrix",
                "BigNumber",
                "DenseMatrix",
                "SparseMatrix"
            ], (t)=>{
                var { typed: e, config: r, matrix: n, BigNumber: i, DenseMatrix: o, SparseMatrix: a } = t;
                return e("identity", {
                    "": function() {
                        return "Matrix" === r.matrix ? n([]) : [];
                    },
                    string: function(t) {
                        return n(t);
                    },
                    "number | BigNumber": function(t) {
                        return u(t, t, "Matrix" === r.matrix ? "dense" : void 0);
                    },
                    "number | BigNumber, string": function(t, e) {
                        return u(t, t, e);
                    },
                    "number | BigNumber, number | BigNumber": function(t, e) {
                        return u(t, e, "Matrix" === r.matrix ? "dense" : void 0);
                    },
                    "number | BigNumber, number | BigNumber, string": function(t, e, r) {
                        return u(t, e, r);
                    },
                    Array: function(t) {
                        return s(t);
                    },
                    "Array, string": function(t, e) {
                        return s(t, e);
                    },
                    Matrix: function(t) {
                        return s(t.valueOf(), t.storage());
                    },
                    "Matrix, string": function(t, e) {
                        return s(t.valueOf(), e);
                    }
                });
                function s(t, e) {
                    switch(t.length){
                        case 0:
                            return e ? n(e) : [];
                        case 1:
                            return u(t[0], t[0], e);
                        case 2:
                            return u(t[0], t[1], e);
                        default:
                            throw new Error("Vector containing two values expected");
                    }
                }
                function u(t, e, r) {
                    var n = v(t) || v(e) ? i : null;
                    if (v(t) && (t = t.toNumber()), v(e) && (e = e.toNumber()), !pt(t) || t < 1) throw new Error("Parameters in function identity must be positive integers");
                    if (!pt(e) || e < 1) throw new Error("Parameters in function identity must be positive integers");
                    var s = n ? new i(1) : 1, u = n ? new n(0) : 0, l = [
                        t,
                        e
                    ];
                    if (r) {
                        if ("sparse" === r) return a.diagonal(l, s, 0, u);
                        if ("dense" === r) return o.diagonal(l, s, 0, u);
                        throw new TypeError('Unknown matrix type "'.concat(r, '"'));
                    }
                    for(var c = Xt([], l, u), f = t < e ? t : e, h = 0; h < f; h++)c[h][h] = s;
                    return c;
                }
            }), _l = ge("kron", [
                "typed",
                "matrix",
                "multiplyScalar"
            ], (t)=>{
                var { typed: e, matrix: r, multiplyScalar: n } = t;
                return e("kron", {
                    "Matrix, Matrix": function(t, e) {
                        return r(i(t.toArray(), e.toArray()));
                    },
                    "Matrix, Array": function(t, e) {
                        return r(i(t.toArray(), e));
                    },
                    "Array, Matrix": function(t, e) {
                        return r(i(t, e.toArray()));
                    },
                    "Array, Array": i
                });
                function i(t, e) {
                    if (1 === $t(t).length && (t = [
                        t
                    ]), 1 === $t(e).length && (e = [
                        e
                    ]), $t(t).length > 2 || $t(e).length > 2) throw new RangeError("Vectors with dimensions greater then 2 are not supported expected (Size x = " + JSON.stringify(t.length) + ", y = " + JSON.stringify(e.length) + ")");
                    var r = [], i = [];
                    return t.map(function(t) {
                        return e.map(function(e) {
                            return i = [], r.push(i), t.map(function(t) {
                                return e.map(function(e) {
                                    return i.push(n(t, e));
                                });
                            });
                        });
                    }) && r;
                }
            }), Al = ge("largerEq", [
                "typed",
                "config",
                "matrix",
                "DenseMatrix",
                "concat"
            ], (t)=>{
                var { typed: e, config: r, matrix: n, DenseMatrix: i, concat: o } = t, a = ul({
                    typed: e
                }), s = ll({
                    typed: e,
                    DenseMatrix: i
                }), u = fl({
                    typed: e,
                    DenseMatrix: i
                }), l = ml({
                    typed: e,
                    matrix: n,
                    concat: o
                }), c = ms({
                    typed: e
                });
                return e("largerEq", El({
                    typed: e,
                    config: r
                }), {
                    "boolean, boolean": (t, e)=>t >= e,
                    "BigNumber, BigNumber": function(t, e) {
                        return t.gte(e) || ds(t, e, r.epsilon);
                    },
                    "Fraction, Fraction": (t, e)=>-1 !== t.compare(e),
                    "Complex, Complex": function() {
                        throw new TypeError("No ordering relation is defined for complex numbers");
                    }
                }, c, l({
                    SS: s,
                    DS: a,
                    Ss: u
                }));
            }), El = ge("largerEq", [
                "typed",
                "config"
            ], (t)=>{
                var { typed: e, config: r } = t;
                return e("largerEq", {
                    "number, number": function(t, e) {
                        return t >= e || Nt(t, e, r.epsilon);
                    }
                });
            }), Sl = ge("matAlgo01xDSid", [
                "typed"
            ], (t)=>{
                var { typed: e } = t;
                return function(t, r, n, i) {
                    var o = t._data, a = t._size, s = t._datatype, u = r._values, l = r._index, c = r._ptr, f = r._size, h = r._datatype;
                    if (a.length !== f.length) throw new Ht(a.length, f.length);
                    if (a[0] !== f[0] || a[1] !== f[1]) throw new RangeError("Dimension mismatch. Matrix A (" + a + ") must match Matrix B (" + f + ")");
                    if (!u) throw new Error("Cannot perform operation on Dense Matrix and Pattern Sparse Matrix");
                    var p, d, m = a[0], y = a[1], g = "string" == typeof s && s === h ? s : void 0, v = g ? e.find(n, [
                        g,
                        g
                    ]) : n, b = [];
                    for(p = 0; p < m; p++)b[p] = [];
                    var x = [], w = [];
                    for(d = 0; d < y; d++){
                        for(var _ = d + 1, A = c[d], E = c[d + 1], S = A; S < E; S++)x[p = l[S]] = i ? v(u[S], o[p][d]) : v(o[p][d], u[S]), w[p] = _;
                        for(p = 0; p < m; p++)w[p] === _ ? b[p][d] = x[p] : b[p][d] = o[p][d];
                    }
                    return t.createDenseMatrix({
                        data: b,
                        size: [
                            m,
                            y
                        ],
                        datatype: g
                    });
                };
            }), Ml = ge("matAlgo10xSids", [
                "typed",
                "DenseMatrix"
            ], (t)=>{
                var { typed: e, DenseMatrix: r } = t;
                return function(t, n, i, o) {
                    var a = t._values, s = t._index, u = t._ptr, l = t._size, c = t._datatype;
                    if (!a) throw new Error("Cannot perform operation on Pattern Sparse Matrix and Scalar value");
                    var f, h = l[0], p = l[1], d = i;
                    "string" == typeof c && (f = c, n = e.convert(n, f), d = e.find(i, [
                        f,
                        f
                    ]));
                    for(var m = [], y = [], g = [], v = 0; v < p; v++){
                        for(var b = v + 1, x = u[v], w = u[v + 1], _ = x; _ < w; _++){
                            var A = s[_];
                            y[A] = a[_], g[A] = b;
                        }
                        for(var E = 0; E < h; E++)0 === v && (m[E] = []), g[E] === b ? m[E][v] = o ? d(n, y[E]) : d(y[E], n) : m[E][v] = n;
                    }
                    return new r({
                        data: m,
                        size: [
                            h,
                            p
                        ],
                        datatype: f
                    });
                };
            }), kl = ge("matAlgo08xS0Sid", [
                "typed",
                "equalScalar"
            ], (t)=>{
                var { typed: e, equalScalar: r } = t;
                return function(t, n, i) {
                    var o = t._values, a = t._index, s = t._ptr, u = t._size, l = t._datatype, c = n._values, f = n._index, h = n._ptr, p = n._size, d = n._datatype;
                    if (u.length !== p.length) throw new Ht(u.length, p.length);
                    if (u[0] !== p[0] || u[1] !== p[1]) throw new RangeError("Dimension mismatch. Matrix A (" + u + ") must match Matrix B (" + p + ")");
                    if (!o || !c) throw new Error("Cannot perform operation on Pattern Sparse Matrices");
                    var m, y = u[0], g = u[1], v = r, b = 0, x = i;
                    "string" == typeof l && l === d && (m = l, v = e.find(r, [
                        m,
                        m
                    ]), b = e.convert(0, m), x = e.find(i, [
                        m,
                        m
                    ]));
                    for(var w, _, A, E, S = [], M = [], k = [], N = [], C = [], D = 0; D < g; D++){
                        k[D] = M.length;
                        var O = D + 1;
                        for(_ = s[D], A = s[D + 1], w = _; w < A; w++)C[E = a[w]] = O, N[E] = o[w], M.push(E);
                        for(_ = h[D], A = h[D + 1], w = _; w < A; w++)C[E = f[w]] === O && (N[E] = x(N[E], c[w]));
                        for(w = k[D]; w < M.length;){
                            var T = N[E = M[w]];
                            v(T, b) ? M.splice(w, 1) : (S.push(T), w++);
                        }
                    }
                    return k[g] = M.length, t.createSparseMatrix({
                        values: S,
                        index: M,
                        ptr: k,
                        size: [
                            y,
                            g
                        ],
                        datatype: m
                    });
                };
            }), Nl = ge("useMatrixForArrayScalar", [
                "typed",
                "matrix"
            ], (t)=>{
                var { typed: e, matrix: r } = t;
                return {
                    "Array, number": e.referTo("DenseMatrix, number", (t)=>(e, n)=>t(r(e), n).valueOf()),
                    "Array, BigNumber": e.referTo("DenseMatrix, BigNumber", (t)=>(e, n)=>t(r(e), n).valueOf()),
                    "number, Array": e.referTo("number, DenseMatrix", (t)=>(e, n)=>t(e, r(n)).valueOf()),
                    "BigNumber, Array": e.referTo("BigNumber, DenseMatrix", (t)=>(e, n)=>t(e, r(n)).valueOf())
                };
            }), Cl = ge("leftShift", [
                "typed",
                "matrix",
                "equalScalar",
                "zeros",
                "DenseMatrix",
                "concat"
            ], (t)=>{
                var { typed: e, matrix: r, equalScalar: n, zeros: i, DenseMatrix: o, concat: a } = t, s = Sl({
                    typed: e
                }), u = sl({
                    typed: e,
                    equalScalar: n
                }), l = kl({
                    typed: e,
                    equalScalar: n
                }), c = Ml({
                    typed: e,
                    DenseMatrix: o
                }), f = cl({
                    typed: e,
                    equalScalar: n
                }), h = pl({
                    typed: e
                }), p = ml({
                    typed: e,
                    matrix: r,
                    concat: a
                }), d = Nl({
                    typed: e,
                    matrix: r
                });
                return e("leftShift", {
                    "number, number": Xa,
                    "BigNumber, BigNumber": Ha,
                    "SparseMatrix, number | BigNumber": e.referToSelf((t)=>(e, r)=>n(r, 0) ? e.clone() : f(e, r, t, !1)),
                    "DenseMatrix, number | BigNumber": e.referToSelf((t)=>(e, r)=>n(r, 0) ? e.clone() : h(e, r, t, !1)),
                    "number | BigNumber, SparseMatrix": e.referToSelf((t)=>(e, r)=>n(e, 0) ? i(r.size(), r.storage()) : c(r, e, t, !0)),
                    "number | BigNumber, DenseMatrix": e.referToSelf((t)=>(e, r)=>n(e, 0) ? i(r.size(), r.storage()) : h(r, e, t, !0))
                }, d, p({
                    SS: l,
                    DS: s,
                    SD: u
                }));
            });
            function Dl(t) {
                var { DenseMatrix: e } = t;
                return function(t, r, n) {
                    var i = t.size();
                    if (2 !== i.length) throw new RangeError("Matrix must be two dimensional (size: " + Lt(i) + ")");
                    var o = i[0];
                    if (o !== i[1]) throw new RangeError("Matrix must be square (size: " + Lt(i) + ")");
                    var a = [];
                    if (E(r)) {
                        var s = r.size(), u = r._data;
                        if (1 === s.length) {
                            if (s[0] !== o) throw new RangeError("Dimension mismatch. Matrix columns must match vector length.");
                            for(var l = 0; l < o; l++)a[l] = [
                                u[l]
                            ];
                            return new e({
                                data: a,
                                size: [
                                    o,
                                    1
                                ],
                                datatype: r._datatype
                            });
                        }
                        if (2 === s.length) {
                            if (s[0] !== o || 1 !== s[1]) throw new RangeError("Dimension mismatch. Matrix columns must match vector length.");
                            if (M(r)) {
                                if (n) {
                                    a = [];
                                    for(var c = 0; c < o; c++)a[c] = [
                                        u[c][0]
                                    ];
                                    return new e({
                                        data: a,
                                        size: [
                                            o,
                                            1
                                        ],
                                        datatype: r._datatype
                                    });
                                }
                                return r;
                            }
                            if (k(r)) {
                                for(var f = 0; f < o; f++)a[f] = [
                                    0
                                ];
                                for(var h = r._values, p = r._index, d = r._ptr, m = d[1], y = d[0]; y < m; y++)a[p[y]][0] = h[y];
                                return new e({
                                    data: a,
                                    size: [
                                        o,
                                        1
                                    ],
                                    datatype: r._datatype
                                });
                            }
                        }
                        throw new RangeError("Dimension mismatch. The right side has to be either 1- or 2-dimensional vector.");
                    }
                    if (A(r)) {
                        var g = $t(r);
                        if (1 === g.length) {
                            if (g[0] !== o) throw new RangeError("Dimension mismatch. Matrix columns must match vector length.");
                            for(var v = 0; v < o; v++)a[v] = [
                                r[v]
                            ];
                            return new e({
                                data: a,
                                size: [
                                    o,
                                    1
                                ]
                            });
                        }
                        if (2 === g.length) {
                            if (g[0] !== o || 1 !== g[1]) throw new RangeError("Dimension mismatch. Matrix columns must match vector length.");
                            for(var b = 0; b < o; b++)a[b] = [
                                r[b][0]
                            ];
                            return new e({
                                data: a,
                                size: [
                                    o,
                                    1
                                ]
                            });
                        }
                        throw new RangeError("Dimension mismatch. The right side has to be either 1- or 2-dimensional vector.");
                    }
                };
            }
            var Ol = ge("lsolve", [
                "typed",
                "matrix",
                "divideScalar",
                "multiplyScalar",
                "subtractScalar",
                "equalScalar",
                "DenseMatrix"
            ], (t)=>{
                var { typed: e, matrix: r, divideScalar: n, multiplyScalar: i, subtractScalar: o, equalScalar: a, DenseMatrix: s } = t, u = Dl({
                    DenseMatrix: s
                });
                return e("lsolve", {
                    "SparseMatrix, Array | Matrix": function(t, e) {
                        return function(t, e) {
                            for(var r = (e = u(t, e, !0))._data, l = t._size[0], c = t._size[1], f = t._values, h = t._index, p = t._ptr, d = [], m = 0; m < c; m++){
                                var y = r[m][0] || 0;
                                if (a(y, 0)) d[m] = [
                                    0
                                ];
                                else {
                                    for(var g = 0, v = [], b = [], x = p[m], w = p[m + 1], _ = x; _ < w; _++){
                                        var A = h[_];
                                        A === m ? g = f[_] : A > m && (v.push(f[_]), b.push(A));
                                    }
                                    if (a(g, 0)) throw new Error("Linear system cannot be solved since matrix is singular");
                                    for(var E = n(y, g), S = 0, M = b.length; S < M; S++){
                                        var k = b[S];
                                        r[k] = [
                                            o(r[k][0] || 0, i(E, v[S]))
                                        ];
                                    }
                                    d[m] = [
                                        E
                                    ];
                                }
                            }
                            return new s({
                                data: d,
                                size: [
                                    l,
                                    1
                                ]
                            });
                        }(t, e);
                    },
                    "DenseMatrix, Array | Matrix": function(t, e) {
                        return l(t, e);
                    },
                    "Array, Array | Matrix": function(t, e) {
                        return l(r(t), e).valueOf();
                    }
                });
                function l(t, e) {
                    for(var r = (e = u(t, e, !0))._data, l = t._size[0], c = t._size[1], f = [], h = t._data, p = 0; p < c; p++){
                        var d = r[p][0] || 0, m = void 0;
                        if (a(d, 0)) m = 0;
                        else {
                            var y = h[p][p];
                            if (a(y, 0)) throw new Error("Linear system cannot be solved since matrix is singular");
                            m = n(d, y);
                            for(var g = p + 1; g < l; g++)r[g] = [
                                o(r[g][0] || 0, i(m, h[g][p]))
                            ];
                        }
                        f[p] = [
                            m
                        ];
                    }
                    return new s({
                        data: f,
                        size: [
                            l,
                            1
                        ]
                    });
                }
            }), Tl = ge("matrixFromColumns", [
                "typed",
                "matrix",
                "flatten",
                "size"
            ], (t)=>{
                var { typed: e, matrix: r, flatten: n, size: i } = t;
                return e("matrixFromColumns", {
                    "...Array": function(t) {
                        return o(t);
                    },
                    "...Matrix": function(t) {
                        return r(o(t.map((t)=>t.toArray())));
                    }
                });
                function o(t) {
                    if (0 === t.length) throw new TypeError("At least one column is needed to construct a matrix.");
                    for(var e = a(t[0]), r = [], i = 0; i < e; i++)r[i] = [];
                    for (var o of t){
                        var s = a(o);
                        if (s !== e) throw new TypeError("The vectors had different length: " + (0 | e) + " \u2260 " + (0 | s));
                        for(var u = n(o), l = 0; l < e; l++)r[l].push(u[l]);
                    }
                    return r;
                }
                function a(t) {
                    var e = i(t);
                    if (1 === e.length) return e[0];
                    if (2 === e.length) {
                        if (1 === e[0]) return e[1];
                        if (1 === e[1]) return e[0];
                        throw new TypeError("At least one of the arguments is not a vector.");
                    }
                    throw new TypeError("Only one- or two-dimensional vectors are supported.");
                }
            }), Fl = ge("matAlgo06xS0S0", [
                "typed",
                "equalScalar"
            ], (t)=>{
                var { typed: e, equalScalar: r } = t;
                return function(t, n, i) {
                    var o = t._values, a = t._size, s = t._datatype, u = n._values, l = n._size, c = n._datatype;
                    if (a.length !== l.length) throw new Ht(a.length, l.length);
                    if (a[0] !== l[0] || a[1] !== l[1]) throw new RangeError("Dimension mismatch. Matrix A (" + a + ") must match Matrix B (" + l + ")");
                    var f, h = a[0], p = a[1], d = r, m = 0, y = i;
                    "string" == typeof s && s === c && (f = s, d = e.find(r, [
                        f,
                        f
                    ]), m = e.convert(0, f), y = e.find(i, [
                        f,
                        f
                    ]));
                    for(var g = o && u ? [] : void 0, v = [], b = [], x = g ? [] : void 0, w = [], _ = [], A = 0; A < p; A++){
                        b[A] = v.length;
                        var E = A + 1;
                        if (wr(t, A, w, x, _, E, v, y), wr(n, A, w, x, _, E, v, y), x) for(var S = b[A]; S < v.length;){
                            var M = v[S];
                            if (_[M] === E) {
                                var k = x[M];
                                d(k, m) ? v.splice(S, 1) : (g.push(k), S++);
                            } else v.splice(S, 1);
                        }
                        else for(var N = b[A]; N < v.length;)_[v[N]] !== E ? v.splice(N, 1) : N++;
                    }
                    return b[p] = v.length, t.createSparseMatrix({
                        values: g,
                        index: v,
                        ptr: b,
                        size: [
                            h,
                            p
                        ],
                        datatype: f
                    });
                };
            }), Pl = ge("nthRoot", [
                "typed",
                "matrix",
                "equalScalar",
                "BigNumber",
                "concat"
            ], (t)=>{
                var { typed: e, matrix: r, equalScalar: n, BigNumber: i, concat: o } = t, a = Sl({
                    typed: e
                }), s = sl({
                    typed: e,
                    equalScalar: n
                }), u = Fl({
                    typed: e,
                    equalScalar: n
                }), l = cl({
                    typed: e,
                    equalScalar: n
                }), c = ml({
                    typed: e,
                    matrix: r,
                    concat: o
                });
                function f() {
                    throw new Error("Complex number not supported in function nthRoot. Use nthRoots instead.");
                }
                return e("nthRoot", {
                    number: ia,
                    "number, number": ia,
                    BigNumber: (t)=>h(t, new i(2)),
                    "BigNumber, BigNumber": h,
                    Complex: f,
                    "Complex, number": f,
                    Array: e.referTo("DenseMatrix,number", (t)=>(e)=>t(r(e), 2).valueOf()),
                    DenseMatrix: e.referTo("DenseMatrix,number", (t)=>(e)=>t(e, 2)),
                    SparseMatrix: e.referTo("SparseMatrix,number", (t)=>(e)=>t(e, 2)),
                    "SparseMatrix, SparseMatrix": e.referToSelf((t)=>(e, r)=>{
                            if (1 === r.density()) return u(e, r, t);
                            throw new Error("Root must be non-zero");
                        }),
                    "DenseMatrix, SparseMatrix": e.referToSelf((t)=>(e, r)=>{
                            if (1 === r.density()) return a(e, r, t, !1);
                            throw new Error("Root must be non-zero");
                        }),
                    "Array, SparseMatrix": e.referTo("DenseMatrix,SparseMatrix", (t)=>(e, n)=>t(r(e), n)),
                    "number | BigNumber, SparseMatrix": e.referToSelf((t)=>(e, r)=>{
                            if (1 === r.density()) return l(r, e, t, !0);
                            throw new Error("Root must be non-zero");
                        })
                }, c({
                    scalar: "number | BigNumber",
                    SD: s,
                    Ss: l,
                    sS: !1
                }));
                function h(t, e) {
                    var r = i.precision, n = i.clone({
                        precision: r + 2
                    }), o = new i(0), a = new n(1), s = e.isNegative();
                    if (s && (e = e.neg()), e.isZero()) throw new Error("Root must be non-zero");
                    if (t.isNegative() && !e.abs().mod(2).equals(1)) throw new Error("Root must be odd when a is negative.");
                    if (t.isZero()) return s ? new n(1 / 0) : 0;
                    if (!t.isFinite()) return s ? o : t;
                    var u = t.abs().pow(a.div(e));
                    return u = t.isNeg() ? u.neg() : u, new i((s ? a.div(u) : u).toPrecision(r));
                }
            }), Il = ge("ones", [
                "typed",
                "config",
                "matrix",
                "BigNumber"
            ], (t)=>{
                var { typed: e, config: r, matrix: n, BigNumber: i } = t;
                return e("ones", {
                    "": function() {
                        return "Array" === r.matrix ? o([]) : o([], "default");
                    },
                    "...number | BigNumber | string": function(t) {
                        if ("string" == typeof t[t.length - 1]) {
                            var e = t.pop();
                            return o(t, e);
                        }
                        return "Array" === r.matrix ? o(t) : o(t, "default");
                    },
                    Array: o,
                    Matrix: function(t) {
                        var e = t.storage();
                        return o(t.valueOf(), e);
                    },
                    "Array | Matrix, string": function(t, e) {
                        return o(t.valueOf(), e);
                    }
                });
                function o(t, e) {
                    var r = function(t) {
                        var e = !1;
                        return t.forEach(function(t, r, n) {
                            v(t) && (e = !0, n[r] = t.toNumber());
                        }), e;
                    }(t) ? new i(1) : 1;
                    if (function(t) {
                        t.forEach(function(t) {
                            if ("number" != typeof t || !pt(t) || t < 0) throw new Error("Parameters in function ones must be positive integers");
                        });
                    }(t), e) {
                        var o = n(e);
                        return t.length > 0 ? o.resize(t, r) : o;
                    }
                    var a = [];
                    return t.length > 0 ? Xt(a, t, r) : a;
                }
            }), Bl = ge("qr", [
                "typed",
                "matrix",
                "zeros",
                "identity",
                "isZero",
                "equal",
                "sign",
                "sqrt",
                "conj",
                "unaryMinus",
                "addScalar",
                "divideScalar",
                "multiplyScalar",
                "subtractScalar",
                "complex"
            ], (t)=>{
                var { typed: e, matrix: r, zeros: n, identity: i, isZero: o, equal: a, sign: s, sqrt: u, conj: l, unaryMinus: c, addScalar: f, divideScalar: h, multiplyScalar: p, subtractScalar: d, complex: y } = t;
                return m()(e("qr", {
                    DenseMatrix: function(t) {
                        return v(t);
                    },
                    SparseMatrix: function(t) {
                        return function(t) {
                            throw new Error("qr not implemented for sparse matrices yet");
                        }();
                    },
                    Array: function(t) {
                        var e = v(r(t));
                        return {
                            Q: e.Q.valueOf(),
                            R: e.R.valueOf()
                        };
                    }
                }), {
                    _denseQRimpl: g
                });
                function g(t) {
                    var e, r, m, y = t._size[0], g = t._size[1], v = i([
                        y
                    ], "dense"), b = v._data, x = t.clone(), w = x._data, _ = n([
                        y
                    ], "");
                    for(m = 0; m < Math.min(g, y); ++m){
                        var A = w[m][m], E = c(a(A, 0) ? 1 : s(A)), S = l(E), M = 0;
                        for(e = m; e < y; e++)M = f(M, p(w[e][m], l(w[e][m])));
                        var k = p(E, u(M));
                        if (!o(k)) {
                            var N = d(A, k);
                            for(_[m] = 1, e = m + 1; e < y; e++)_[e] = h(w[e][m], N);
                            var C = c(l(h(N, k))), D = void 0;
                            for(r = m; r < g; r++){
                                for(D = 0, e = m; e < y; e++)D = f(D, p(l(_[e]), w[e][r]));
                                for(D = p(D, C), e = m; e < y; e++)w[e][r] = p(d(w[e][r], p(_[e], D)), S);
                            }
                            for(e = 0; e < y; e++){
                                for(D = 0, r = m; r < y; r++)D = f(D, p(b[e][r], _[r]));
                                for(D = p(D, C), r = m; r < y; ++r)b[e][r] = h(d(b[e][r], p(D, l(_[r]))), S);
                            }
                        }
                    }
                    return {
                        Q: v,
                        R: x,
                        toString: function() {
                            return "Q: " + this.Q.toString() + "\nR: " + this.R.toString();
                        }
                    };
                }
                function v(t) {
                    var e = g(t), r = e.R._data;
                    if (t._data.length > 0) for(var n = "Complex" === r[0][0].type ? y(0) : 0, i = 0; i < r.length; ++i)for(var o = 0; o < i && o < (r[0] || []).length; ++o)r[i][o] = n;
                    return e;
                }
            });
            function jl(t, e, r, n) {
                if (!(this instanceof jl)) throw new SyntaxError("Constructor must be called with the new operator");
                this.fn = t, this.count = e, this.min = r, this.max = n, this.message = "Wrong number of arguments in function " + t + " (" + e + " provided, " + r + (null != n ? "-" + n : "") + " expected)", this.stack = (new Error).stack;
            }
            jl.prototype = new Error, jl.prototype.constructor = Error, jl.prototype.name = "ArgumentsError", jl.prototype.isArgumentsError = !0;
            var Rl = ge("resize", [
                "config",
                "matrix"
            ], (t)=>{
                var { config: e, matrix: r } = t;
                return function(t, i, o) {
                    if (2 !== arguments.length && 3 !== arguments.length) throw new jl("resize", arguments.length, 2, 3);
                    if (E(i) && (i = i.valueOf()), v(i[0]) && (i = i.map(function(t) {
                        return v(t) ? t.toNumber() : t;
                    })), E(t)) return t.resize(i, o, !0);
                    if ("string" == typeof t) return n(t, i, o);
                    var a = !Array.isArray(t) && "Array" !== e.matrix;
                    if (0 === i.length) {
                        for(; Array.isArray(t);)t = t[0];
                        return it(t);
                    }
                    Array.isArray(t) || (t = [
                        t
                    ]);
                    var s = Xt(t = it(t), i, o);
                    return a ? r(s) : s;
                };
                function n(t, e, r) {
                    if (void 0 !== r) {
                        if ("string" != typeof r || 1 !== r.length) throw new TypeError("Single character expected as defaultValue");
                    } else r = " ";
                    if (1 !== e.length) throw new Ht(e.length, 1);
                    var n = e[0];
                    if ("number" != typeof n || !pt(n)) throw new TypeError("Invalid size, must contain positive integers (size: " + Lt(e) + ")");
                    if (t.length > n) return t.substring(0, n);
                    if (t.length < n) {
                        for(var i = t, o = 0, a = n - t.length; o < a; o++)i += r;
                        return i;
                    }
                    return t;
                }
            }), Ll = ge("rightArithShift", [
                "typed",
                "matrix",
                "equalScalar",
                "zeros",
                "DenseMatrix",
                "concat"
            ], (t)=>{
                var { typed: e, matrix: r, equalScalar: n, zeros: i, DenseMatrix: o, concat: a } = t, s = Sl({
                    typed: e
                }), u = sl({
                    typed: e,
                    equalScalar: n
                }), l = kl({
                    typed: e,
                    equalScalar: n
                }), c = Ml({
                    typed: e,
                    DenseMatrix: o
                }), f = cl({
                    typed: e,
                    equalScalar: n
                }), h = pl({
                    typed: e
                }), p = ml({
                    typed: e,
                    matrix: r,
                    concat: a
                }), d = Nl({
                    typed: e,
                    matrix: r
                });
                return e("rightArithShift", {
                    "number, number": Ja,
                    "BigNumber, BigNumber": Wa,
                    "SparseMatrix, number | BigNumber": e.referToSelf((t)=>(e, r)=>n(r, 0) ? e.clone() : f(e, r, t, !1)),
                    "DenseMatrix, number | BigNumber": e.referToSelf((t)=>(e, r)=>n(r, 0) ? e.clone() : h(e, r, t, !1)),
                    "number | BigNumber, SparseMatrix": e.referToSelf((t)=>(e, r)=>n(e, 0) ? i(r.size(), r.storage()) : c(r, e, t, !0)),
                    "number | BigNumber, DenseMatrix": e.referToSelf((t)=>(e, r)=>n(e, 0) ? i(r.size(), r.storage()) : h(r, e, t, !0))
                }, d, p({
                    SS: l,
                    DS: s,
                    SD: u
                }));
            }), ql = "Number of decimals in function round must be an integer", Ul = ge("round", [
                "typed",
                "matrix",
                "equalScalar",
                "zeros",
                "BigNumber",
                "DenseMatrix"
            ], (t)=>{
                var { typed: e, matrix: r, equalScalar: n, zeros: i, BigNumber: o, DenseMatrix: a } = t, s = cl({
                    typed: e,
                    equalScalar: n
                }), u = fl({
                    typed: e,
                    DenseMatrix: a
                }), l = pl({
                    typed: e
                });
                return e("round", {
                    number: la,
                    "number, number": la,
                    "number, BigNumber": function(t, e) {
                        if (!e.isInteger()) throw new TypeError(ql);
                        return new o(t).toDecimalPlaces(e.toNumber());
                    },
                    Complex: function(t) {
                        return t.round();
                    },
                    "Complex, number": function(t, e) {
                        if (e % 1) throw new TypeError(ql);
                        return t.round(e);
                    },
                    "Complex, BigNumber": function(t, e) {
                        if (!e.isInteger()) throw new TypeError(ql);
                        var r = e.toNumber();
                        return t.round(r);
                    },
                    BigNumber: function(t) {
                        return t.toDecimalPlaces(0);
                    },
                    "BigNumber, BigNumber": function(t, e) {
                        if (!e.isInteger()) throw new TypeError(ql);
                        return t.toDecimalPlaces(e.toNumber());
                    },
                    Fraction: function(t) {
                        return t.round();
                    },
                    "Fraction, number": function(t, e) {
                        if (e % 1) throw new TypeError(ql);
                        return t.round(e);
                    },
                    "Fraction, BigNumber": function(t, e) {
                        if (!e.isInteger()) throw new TypeError(ql);
                        return t.round(e.toNumber());
                    },
                    "Array | Matrix": e.referToSelf((t)=>(e)=>vr(e, t, !0)),
                    "SparseMatrix, number | BigNumber": e.referToSelf((t)=>(e, r)=>s(e, r, t, !1)),
                    "DenseMatrix, number | BigNumber": e.referToSelf((t)=>(e, r)=>l(e, r, t, !1)),
                    "Array, number | BigNumber": e.referToSelf((t)=>(e, n)=>l(r(e), n, t, !1).valueOf()),
                    "number | Complex | BigNumber | Fraction, SparseMatrix": e.referToSelf((t)=>(e, r)=>n(e, 0) ? i(r.size(), r.storage()) : u(r, e, t, !0)),
                    "number | Complex | BigNumber | Fraction, DenseMatrix": e.referToSelf((t)=>(e, r)=>n(e, 0) ? i(r.size(), r.storage()) : l(r, e, t, !0)),
                    "number | Complex | BigNumber | Fraction, Array": e.referToSelf((t)=>(e, n)=>l(r(n), e, t, !0).valueOf())
                });
            }), zl = ge("smaller", [
                "typed",
                "config",
                "matrix",
                "DenseMatrix",
                "concat"
            ], (t)=>{
                var { typed: e, config: r, matrix: n, DenseMatrix: i, concat: o } = t, a = ul({
                    typed: e
                }), s = ll({
                    typed: e,
                    DenseMatrix: i
                }), u = fl({
                    typed: e,
                    DenseMatrix: i
                }), l = ml({
                    typed: e,
                    matrix: n,
                    concat: o
                }), c = ms({
                    typed: e
                });
                return e("smaller", Gl({
                    typed: e,
                    config: r
                }), {
                    "boolean, boolean": (t, e)=>t < e,
                    "BigNumber, BigNumber": function(t, e) {
                        return t.lt(e) && !ds(t, e, r.epsilon);
                    },
                    "Fraction, Fraction": (t, e)=>-1 === t.compare(e),
                    "Complex, Complex": function(t, e) {
                        throw new TypeError("No ordering relation is defined for complex numbers");
                    }
                }, c, l({
                    SS: s,
                    DS: a,
                    Ss: u
                }));
            }), Gl = ge("smaller", [
                "typed",
                "config"
            ], (t)=>{
                var { typed: e, config: r } = t;
                return e("smaller", {
                    "number, number": function(t, e) {
                        return t < e && !Nt(t, e, r.epsilon);
                    }
                });
            }), Hl = ge("matAlgo05xSfSf", [
                "typed",
                "equalScalar"
            ], (t)=>{
                var { typed: e, equalScalar: r } = t;
                return function(t, n, i) {
                    var o = t._values, a = t._index, s = t._ptr, u = t._size, l = t._datatype, c = n._values, f = n._index, h = n._ptr, p = n._size, d = n._datatype;
                    if (u.length !== p.length) throw new Ht(u.length, p.length);
                    if (u[0] !== p[0] || u[1] !== p[1]) throw new RangeError("Dimension mismatch. Matrix A (" + u + ") must match Matrix B (" + p + ")");
                    var m, y = u[0], g = u[1], v = r, b = 0, x = i;
                    "string" == typeof l && l === d && (m = l, v = e.find(r, [
                        m,
                        m
                    ]), b = e.convert(0, m), x = e.find(i, [
                        m,
                        m
                    ]));
                    var w, _, A, E, S = o && c ? [] : void 0, M = [], k = [], N = S ? [] : void 0, C = S ? [] : void 0, D = [], O = [];
                    for(_ = 0; _ < g; _++){
                        k[_] = M.length;
                        var T = _ + 1;
                        for(A = s[_], E = s[_ + 1]; A < E; A++)w = a[A], M.push(w), D[w] = T, N && (N[w] = o[A]);
                        for(A = h[_], E = h[_ + 1]; A < E; A++)D[w = f[A]] !== T && M.push(w), O[w] = T, C && (C[w] = c[A]);
                        if (S) for(A = k[_]; A < M.length;){
                            var F = D[w = M[A]], P = O[w];
                            if (F === T || P === T) {
                                var I = x(F === T ? N[w] : b, P === T ? C[w] : b);
                                v(I, b) ? M.splice(A, 1) : (S.push(I), A++);
                            }
                        }
                    }
                    return k[g] = M.length, t.createSparseMatrix({
                        values: S,
                        index: M,
                        ptr: k,
                        size: [
                            y,
                            g
                        ],
                        datatype: m
                    });
                };
            }), Wl = ge("subtract", [
                "typed",
                "matrix",
                "equalScalar",
                "subtractScalar",
                "unaryMinus",
                "DenseMatrix",
                "concat"
            ], (t)=>{
                var { typed: e, matrix: r, equalScalar: n, subtractScalar: i, unaryMinus: o, DenseMatrix: a, concat: s } = t, u = Sl({
                    typed: e
                }), l = ul({
                    typed: e
                }), c = Hl({
                    typed: e,
                    equalScalar: n
                }), f = Ml({
                    typed: e,
                    DenseMatrix: a
                }), h = fl({
                    typed: e,
                    DenseMatrix: a
                });
                return e("subtract", {
                    "any, any": i
                }, ml({
                    typed: e,
                    matrix: r,
                    concat: s
                })({
                    elop: i,
                    SS: c,
                    DS: u,
                    SD: l,
                    Ss: h,
                    sS: f
                }));
            }), $l = ge("to", [
                "typed",
                "matrix",
                "concat"
            ], (t)=>{
                var { typed: e, matrix: r, concat: n } = t;
                return e("to", {
                    "Unit, Unit | string": (t, e)=>t.to(e)
                }, ml({
                    typed: e,
                    matrix: r,
                    concat: n
                })({
                    Ds: !0
                }));
            }), Vl = ge("unequal", [
                "typed",
                "config",
                "equalScalar",
                "matrix",
                "DenseMatrix",
                "concat"
            ], (t)=>{
                var { typed: e, config: r, equalScalar: n, matrix: i, DenseMatrix: o, concat: a } = t, s = ul({
                    typed: e
                }), u = ll({
                    typed: e,
                    DenseMatrix: o
                }), l = fl({
                    typed: e,
                    DenseMatrix: o
                }), c = ml({
                    typed: e,
                    matrix: i,
                    concat: a
                });
                return e("unequal", Zl({
                    typed: e,
                    equalScalar: n
                }), c({
                    elop: function(t, e) {
                        return !n(t, e);
                    },
                    SS: u,
                    DS: s,
                    Ss: l
                }));
            }), Zl = ge("unequal", [
                "typed",
                "equalScalar"
            ], (t)=>{
                var { typed: e, equalScalar: r } = t;
                return e("unequal", {
                    "any, any": function(t, e) {
                        return null === t ? null !== e : null === e ? null !== t : void 0 === t ? void 0 !== e : void 0 === e ? void 0 !== t : !r(t, e);
                    }
                });
            }), Yl = ge("usolve", [
                "typed",
                "matrix",
                "divideScalar",
                "multiplyScalar",
                "subtractScalar",
                "equalScalar",
                "DenseMatrix"
            ], (t)=>{
                var { typed: e, matrix: r, divideScalar: n, multiplyScalar: i, subtractScalar: o, equalScalar: a, DenseMatrix: s } = t, u = Dl({
                    DenseMatrix: s
                });
                return e("usolve", {
                    "SparseMatrix, Array | Matrix": function(t, e) {
                        return function(t, e) {
                            for(var r = (e = u(t, e, !0))._data, l = t._size[0], c = t._size[1], f = t._values, h = t._index, p = t._ptr, d = [], m = c - 1; m >= 0; m--){
                                var y = r[m][0] || 0;
                                if (a(y, 0)) d[m] = [
                                    0
                                ];
                                else {
                                    for(var g = 0, v = [], b = [], x = p[m], w = p[m + 1] - 1; w >= x; w--){
                                        var _ = h[w];
                                        _ === m ? g = f[w] : _ < m && (v.push(f[w]), b.push(_));
                                    }
                                    if (a(g, 0)) throw new Error("Linear system cannot be solved since matrix is singular");
                                    for(var A = n(y, g), E = 0, S = b.length; E < S; E++){
                                        var M = b[E];
                                        r[M] = [
                                            o(r[M][0], i(A, v[E]))
                                        ];
                                    }
                                    d[m] = [
                                        A
                                    ];
                                }
                            }
                            return new s({
                                data: d,
                                size: [
                                    l,
                                    1
                                ]
                            });
                        }(t, e);
                    },
                    "DenseMatrix, Array | Matrix": function(t, e) {
                        return l(t, e);
                    },
                    "Array, Array | Matrix": function(t, e) {
                        return l(r(t), e).valueOf();
                    }
                });
                function l(t, e) {
                    for(var r = (e = u(t, e, !0))._data, l = t._size[0], c = t._size[1], f = [], h = t._data, p = c - 1; p >= 0; p--){
                        var d = r[p][0] || 0, m = void 0;
                        if (a(d, 0)) m = 0;
                        else {
                            var y = h[p][p];
                            if (a(y, 0)) throw new Error("Linear system cannot be solved since matrix is singular");
                            m = n(d, y);
                            for(var g = p - 1; g >= 0; g--)r[g] = [
                                o(r[g][0] || 0, i(m, h[g][p]))
                            ];
                        }
                        f[p] = [
                            m
                        ];
                    }
                    return new s({
                        data: f,
                        size: [
                            l,
                            1
                        ]
                    });
                }
            }), Kl = ge("xor", [
                "typed",
                "matrix",
                "DenseMatrix",
                "concat"
            ], (t)=>{
                var { typed: e, matrix: r, DenseMatrix: n, concat: i } = t, o = ul({
                    typed: e
                }), a = ll({
                    typed: e,
                    DenseMatrix: n
                }), s = fl({
                    typed: e,
                    DenseMatrix: n
                }), u = ml({
                    typed: e,
                    matrix: r,
                    concat: i
                });
                return e("xor", {
                    "number, number": tu,
                    "Complex, Complex": function(t, e) {
                        return (0 !== t.re || 0 !== t.im) != (0 !== e.re || 0 !== e.im);
                    },
                    "BigNumber, BigNumber": function(t, e) {
                        return (!t.isZero() && !t.isNaN()) != (!e.isZero() && !e.isNaN());
                    },
                    "Unit, Unit": e.referToSelf((t)=>(e, r)=>t(e.value || 0, r.value || 0))
                }, u({
                    SS: a,
                    DS: o,
                    Ss: s
                }));
            }), Xl = ge("matAlgo04xSidSid", [
                "typed",
                "equalScalar"
            ], (t)=>{
                var { typed: e, equalScalar: r } = t;
                return function(t, n, i) {
                    var o = t._values, a = t._index, s = t._ptr, u = t._size, l = t._datatype, c = n._values, f = n._index, h = n._ptr, p = n._size, d = n._datatype;
                    if (u.length !== p.length) throw new Ht(u.length, p.length);
                    if (u[0] !== p[0] || u[1] !== p[1]) throw new RangeError("Dimension mismatch. Matrix A (" + u + ") must match Matrix B (" + p + ")");
                    var m, y = u[0], g = u[1], v = r, b = 0, x = i;
                    "string" == typeof l && l === d && (m = l, v = e.find(r, [
                        m,
                        m
                    ]), b = e.convert(0, m), x = e.find(i, [
                        m,
                        m
                    ]));
                    var w, _, A, E, S, M = o && c ? [] : void 0, k = [], N = [], C = o && c ? [] : void 0, D = o && c ? [] : void 0, O = [], T = [];
                    for(_ = 0; _ < g; _++){
                        N[_] = k.length;
                        var F = _ + 1;
                        for(E = s[_], S = s[_ + 1], A = E; A < S; A++)w = a[A], k.push(w), O[w] = F, C && (C[w] = o[A]);
                        for(E = h[_], S = h[_ + 1], A = E; A < S; A++)if (O[w = f[A]] === F) {
                            if (C) {
                                var P = x(C[w], c[A]);
                                v(P, b) ? O[w] = null : C[w] = P;
                            }
                        } else k.push(w), T[w] = F, D && (D[w] = c[A]);
                        if (C && D) for(A = N[_]; A < k.length;)O[w = k[A]] === F ? (M[A] = C[w], A++) : T[w] === F ? (M[A] = D[w], A++) : k.splice(A, 1);
                    }
                    return N[g] = k.length, t.createSparseMatrix({
                        values: M,
                        index: k,
                        ptr: N,
                        size: [
                            y,
                            g
                        ],
                        datatype: m
                    });
                };
            }), Jl = ge("add", [
                "typed",
                "matrix",
                "addScalar",
                "equalScalar",
                "DenseMatrix",
                "SparseMatrix",
                "concat"
            ], (t)=>{
                var { typed: e, matrix: r, addScalar: n, equalScalar: i, DenseMatrix: o, SparseMatrix: a, concat: s } = t, u = Sl({
                    typed: e
                }), l = Xl({
                    typed: e,
                    equalScalar: i
                }), c = Ml({
                    typed: e,
                    DenseMatrix: o
                }), f = ml({
                    typed: e,
                    matrix: r,
                    concat: s
                });
                return e("add", {
                    "any, any": n,
                    "any, any, ...any": e.referToSelf((t)=>(e, r, n)=>{
                            for(var i = t(e, r), o = 0; o < n.length; o++)i = t(i, n[o]);
                            return i;
                        })
                }, f({
                    elop: n,
                    DS: u,
                    SS: l,
                    Ss: c
                }));
            }), Ql = ge("matAlgo09xS0Sf", [
                "typed",
                "equalScalar"
            ], (t)=>{
                var { typed: e, equalScalar: r } = t;
                return function(t, n, i) {
                    var o = t._values, a = t._index, s = t._ptr, u = t._size, l = t._datatype, c = n._values, f = n._index, h = n._ptr, p = n._size, d = n._datatype;
                    if (u.length !== p.length) throw new Ht(u.length, p.length);
                    if (u[0] !== p[0] || u[1] !== p[1]) throw new RangeError("Dimension mismatch. Matrix A (" + u + ") must match Matrix B (" + p + ")");
                    var m, y = u[0], g = u[1], v = r, b = 0, x = i;
                    "string" == typeof l && l === d && (m = l, v = e.find(r, [
                        m,
                        m
                    ]), b = e.convert(0, m), x = e.find(i, [
                        m,
                        m
                    ]));
                    var w, _, A, E, S, M = o && c ? [] : void 0, k = [], N = [], C = M ? [] : void 0, D = [];
                    for(_ = 0; _ < g; _++){
                        N[_] = k.length;
                        var O = _ + 1;
                        if (C) for(E = h[_], S = h[_ + 1], A = E; A < S; A++)D[w = f[A]] = O, C[w] = c[A];
                        for(E = s[_], S = s[_ + 1], A = E; A < S; A++)if (w = a[A], C) {
                            var T = D[w] === O ? C[w] : b, F = x(o[A], T);
                            v(F, b) || (k.push(w), M.push(F));
                        } else k.push(w);
                    }
                    return N[g] = k.length, t.createSparseMatrix({
                        values: M,
                        index: k,
                        ptr: N,
                        size: [
                            y,
                            g
                        ],
                        datatype: m
                    });
                };
            }), tc = ge("atan2", [
                "typed",
                "matrix",
                "equalScalar",
                "BigNumber",
                "DenseMatrix",
                "concat"
            ], (t)=>{
                var { typed: e, matrix: r, equalScalar: n, BigNumber: i, DenseMatrix: o, concat: a } = t, s = sl({
                    typed: e,
                    equalScalar: n
                }), u = ul({
                    typed: e
                }), l = Ql({
                    typed: e,
                    equalScalar: n
                }), c = cl({
                    typed: e,
                    equalScalar: n
                }), f = fl({
                    typed: e,
                    DenseMatrix: o
                }), h = ml({
                    typed: e,
                    matrix: r,
                    concat: a
                });
                return e("atan2", {
                    "number, number": Math.atan2,
                    "BigNumber, BigNumber": (t, e)=>i.atan2(t, e)
                }, h({
                    scalar: "number | BigNumber",
                    SS: l,
                    DS: u,
                    SD: s,
                    Ss: c,
                    sS: f
                }));
            }), ec = ge("bitAnd", [
                "typed",
                "matrix",
                "equalScalar",
                "concat"
            ], (t)=>{
                var { typed: e, matrix: r, equalScalar: n, concat: i } = t, o = sl({
                    typed: e,
                    equalScalar: n
                }), a = Fl({
                    typed: e,
                    equalScalar: n
                }), s = cl({
                    typed: e,
                    equalScalar: n
                });
                return e("bitAnd", {
                    "number, number": Va,
                    "BigNumber, BigNumber": Ra
                }, ml({
                    typed: e,
                    matrix: r,
                    concat: i
                })({
                    SS: a,
                    DS: o,
                    Ss: s
                }));
            }), rc = ge("bitXor", [
                "typed",
                "matrix",
                "DenseMatrix",
                "concat"
            ], (t)=>{
                var { typed: e, matrix: r, DenseMatrix: n, concat: i } = t, o = ul({
                    typed: e
                }), a = ll({
                    typed: e,
                    DenseMatrix: n
                }), s = fl({
                    typed: e,
                    DenseMatrix: n
                });
                return e("bitXor", {
                    "number, number": Ka,
                    "BigNumber, BigNumber": Ga
                }, ml({
                    typed: e,
                    matrix: r,
                    concat: i
                })({
                    SS: a,
                    DS: o,
                    Ss: s
                }));
            }), nc = ge("catalan", [
                "typed",
                "addScalar",
                "divideScalar",
                "multiplyScalar",
                "combinations",
                "isNegative",
                "isInteger"
            ], (t)=>{
                var { typed: e, addScalar: r, divideScalar: n, multiplyScalar: i, combinations: o, isNegative: a, isInteger: s } = t;
                return e("catalan", {
                    "number | BigNumber": function(t) {
                        if (!s(t) || a(t)) throw new TypeError("Non-negative integer value expected in function catalan");
                        return n(o(i(t, 2), t), r(t, 1));
                    }
                });
            }), ic = ge("compare", [
                "typed",
                "config",
                "matrix",
                "equalScalar",
                "BigNumber",
                "Fraction",
                "DenseMatrix",
                "concat"
            ], (t)=>{
                var { typed: e, config: r, equalScalar: n, matrix: i, BigNumber: o, Fraction: a, DenseMatrix: s, concat: u } = t, l = ul({
                    typed: e
                }), c = Hl({
                    typed: e,
                    equalScalar: n
                }), f = fl({
                    typed: e,
                    DenseMatrix: s
                }), h = ml({
                    typed: e,
                    matrix: i,
                    concat: u
                }), p = ms({
                    typed: e
                });
                return e("compare", oc({
                    typed: e,
                    config: r
                }), {
                    "boolean, boolean": function(t, e) {
                        return t === e ? 0 : t > e ? 1 : -1;
                    },
                    "BigNumber, BigNumber": function(t, e) {
                        return ds(t, e, r.epsilon) ? new o(0) : new o(t.cmp(e));
                    },
                    "Fraction, Fraction": function(t, e) {
                        return new a(t.compare(e));
                    },
                    "Complex, Complex": function() {
                        throw new TypeError("No ordering relation is defined for complex numbers");
                    }
                }, p, h({
                    SS: c,
                    DS: l,
                    Ss: f
                }));
            }), oc = ge("compare", [
                "typed",
                "config"
            ], (t)=>{
                var { typed: e, config: r } = t;
                return e("compare", {
                    "number, number": function(t, e) {
                        return Nt(t, e, r.epsilon) ? 0 : t > e ? 1 : -1;
                    }
                });
            }), ac = [
                "typed",
                "matrix",
                "concat"
            ];
            Gt.signature = "any, any";
            var sc = ge("compareText", ac, (t)=>{
                var { typed: e, matrix: r, concat: n } = t;
                return e("compareText", Gt, ml({
                    typed: e,
                    matrix: r,
                    concat: n
                })({
                    elop: Gt,
                    Ds: !0
                }));
            }), uc = ge("deepEqual", [
                "typed",
                "equal"
            ], (t)=>{
                var { typed: e, equal: r } = t;
                return e("deepEqual", {
                    "any, any": function(t, e) {
                        return function t(e, n) {
                            if (Array.isArray(e)) {
                                if (Array.isArray(n)) {
                                    var i = e.length;
                                    if (i !== n.length) return !1;
                                    for(var o = 0; o < i; o++)if (!t(e[o], n[o])) return !1;
                                    return !0;
                                }
                                return !1;
                            }
                            return !Array.isArray(n) && r(e, n);
                        }(t.valueOf(), e.valueOf());
                    }
                });
            }), lc = ge("distance", [
                "typed",
                "addScalar",
                "subtractScalar",
                "divideScalar",
                "multiplyScalar",
                "deepEqual",
                "sqrt",
                "abs"
            ], (t)=>{
                var { typed: e, addScalar: r, subtractScalar: n, multiplyScalar: i, divideScalar: o, deepEqual: a, sqrt: s, abs: u } = t;
                return e("distance", {
                    "Array, Array, Array": function(t, e, r) {
                        if (2 === t.length && 2 === e.length && 2 === r.length) {
                            if (!c(t)) throw new TypeError("Array with 2 numbers or BigNumbers expected for first argument");
                            if (!c(e)) throw new TypeError("Array with 2 numbers or BigNumbers expected for second argument");
                            if (!c(r)) throw new TypeError("Array with 2 numbers or BigNumbers expected for third argument");
                            if (a(e, r)) throw new TypeError("LinePoint1 should not be same with LinePoint2");
                            var o = n(r[1], e[1]), s = n(e[0], r[0]), u = n(i(r[0], e[1]), i(e[0], r[1]));
                            return m(t[0], t[1], o, s, u);
                        }
                        throw new TypeError("Invalid Arguments: Try again");
                    },
                    "Object, Object, Object": function(t, e, r) {
                        if (2 === Object.keys(t).length && 2 === Object.keys(e).length && 2 === Object.keys(r).length) {
                            if (!c(t)) throw new TypeError("Values of pointX and pointY should be numbers or BigNumbers");
                            if (!c(e)) throw new TypeError("Values of lineOnePtX and lineOnePtY should be numbers or BigNumbers");
                            if (!c(r)) throw new TypeError("Values of lineTwoPtX and lineTwoPtY should be numbers or BigNumbers");
                            if (a(d(e), d(r))) throw new TypeError("LinePoint1 should not be same with LinePoint2");
                            if ("pointX" in t && "pointY" in t && "lineOnePtX" in e && "lineOnePtY" in e && "lineTwoPtX" in r && "lineTwoPtY" in r) {
                                var o = n(r.lineTwoPtY, e.lineOnePtY), s = n(e.lineOnePtX, r.lineTwoPtX), u = n(i(r.lineTwoPtX, e.lineOnePtY), i(e.lineOnePtX, r.lineTwoPtY));
                                return m(t.pointX, t.pointY, o, s, u);
                            }
                            throw new TypeError("Key names do not match");
                        }
                        throw new TypeError("Invalid Arguments: Try again");
                    },
                    "Array, Array": function(t, e) {
                        if (2 === t.length && 3 === e.length) {
                            if (!c(t)) throw new TypeError("Array with 2 numbers or BigNumbers expected for first argument");
                            if (!f(e)) throw new TypeError("Array with 3 numbers or BigNumbers expected for second argument");
                            return m(t[0], t[1], e[0], e[1], e[2]);
                        }
                        if (3 === t.length && 6 === e.length) {
                            if (!f(t)) throw new TypeError("Array with 3 numbers or BigNumbers expected for first argument");
                            if (!p(e)) throw new TypeError("Array with 6 numbers or BigNumbers expected for second argument");
                            return y(t[0], t[1], t[2], e[0], e[1], e[2], e[3], e[4], e[5]);
                        }
                        if (t.length === e.length && t.length > 0) {
                            if (!h(t)) throw new TypeError("All values of an array should be numbers or BigNumbers");
                            if (!h(e)) throw new TypeError("All values of an array should be numbers or BigNumbers");
                            return g(t, e);
                        }
                        throw new TypeError("Invalid Arguments: Try again");
                    },
                    "Object, Object": function(t, e) {
                        if (2 === Object.keys(t).length && 3 === Object.keys(e).length) {
                            if (!c(t)) throw new TypeError("Values of pointX and pointY should be numbers or BigNumbers");
                            if (!f(e)) throw new TypeError("Values of xCoeffLine, yCoeffLine and constant should be numbers or BigNumbers");
                            if ("pointX" in t && "pointY" in t && "xCoeffLine" in e && "yCoeffLine" in e && "constant" in e) return m(t.pointX, t.pointY, e.xCoeffLine, e.yCoeffLine, e.constant);
                            throw new TypeError("Key names do not match");
                        }
                        if (3 === Object.keys(t).length && 6 === Object.keys(e).length) {
                            if (!f(t)) throw new TypeError("Values of pointX, pointY and pointZ should be numbers or BigNumbers");
                            if (!p(e)) throw new TypeError("Values of x0, y0, z0, a, b and c should be numbers or BigNumbers");
                            if ("pointX" in t && "pointY" in t && "x0" in e && "y0" in e && "z0" in e && "a" in e && "b" in e && "c" in e) return y(t.pointX, t.pointY, t.pointZ, e.x0, e.y0, e.z0, e.a, e.b, e.c);
                            throw new TypeError("Key names do not match");
                        }
                        if (2 === Object.keys(t).length && 2 === Object.keys(e).length) {
                            if (!c(t)) throw new TypeError("Values of pointOneX and pointOneY should be numbers or BigNumbers");
                            if (!c(e)) throw new TypeError("Values of pointTwoX and pointTwoY should be numbers or BigNumbers");
                            if ("pointOneX" in t && "pointOneY" in t && "pointTwoX" in e && "pointTwoY" in e) return g([
                                t.pointOneX,
                                t.pointOneY
                            ], [
                                e.pointTwoX,
                                e.pointTwoY
                            ]);
                            throw new TypeError("Key names do not match");
                        }
                        if (3 === Object.keys(t).length && 3 === Object.keys(e).length) {
                            if (!f(t)) throw new TypeError("Values of pointOneX, pointOneY and pointOneZ should be numbers or BigNumbers");
                            if (!f(e)) throw new TypeError("Values of pointTwoX, pointTwoY and pointTwoZ should be numbers or BigNumbers");
                            if ("pointOneX" in t && "pointOneY" in t && "pointOneZ" in t && "pointTwoX" in e && "pointTwoY" in e && "pointTwoZ" in e) return g([
                                t.pointOneX,
                                t.pointOneY,
                                t.pointOneZ
                            ], [
                                e.pointTwoX,
                                e.pointTwoY,
                                e.pointTwoZ
                            ]);
                            throw new TypeError("Key names do not match");
                        }
                        throw new TypeError("Invalid Arguments: Try again");
                    },
                    Array: function(t) {
                        if (!function(t) {
                            if (2 === t[0].length && l(t[0][0]) && l(t[0][1])) {
                                if (t.some((t)=>2 !== t.length || !l(t[0]) || !l(t[1]))) return !1;
                            } else {
                                if (!(3 === t[0].length && l(t[0][0]) && l(t[0][1]) && l(t[0][2]))) return !1;
                                if (t.some((t)=>3 !== t.length || !l(t[0]) || !l(t[1]) || !l(t[2]))) return !1;
                            }
                            return !0;
                        }(t)) throw new TypeError("Incorrect array format entered for pairwise distance calculation");
                        return function(t) {
                            for(var e = [], r = [], n = [], i = 0; i < t.length - 1; i++)for(var o = i + 1; o < t.length; o++)2 === t[0].length ? (r = [
                                t[i][0],
                                t[i][1]
                            ], n = [
                                t[o][0],
                                t[o][1]
                            ]) : 3 === t[0].length && (r = [
                                t[i][0],
                                t[i][1],
                                t[i][2]
                            ], n = [
                                t[o][0],
                                t[o][1],
                                t[o][2]
                            ]), e.push(g(r, n));
                            return e;
                        }(t);
                    }
                });
                function l(t) {
                    return "number" == typeof t || v(t);
                }
                function c(t) {
                    return t.constructor !== Array && (t = d(t)), l(t[0]) && l(t[1]);
                }
                function f(t) {
                    return t.constructor !== Array && (t = d(t)), l(t[0]) && l(t[1]) && l(t[2]);
                }
                function h(t) {
                    return Array.isArray(t) || (t = d(t)), t.every(l);
                }
                function p(t) {
                    return t.constructor !== Array && (t = d(t)), l(t[0]) && l(t[1]) && l(t[2]) && l(t[3]) && l(t[4]) && l(t[5]);
                }
                function d(t) {
                    for(var e = Object.keys(t), r = [], n = 0; n < e.length; n++)r.push(t[e[n]]);
                    return r;
                }
                function m(t, e, n, a, l) {
                    var c = u(r(r(i(n, t), i(a, e)), l)), f = s(r(i(n, n), i(a, a)));
                    return o(c, f);
                }
                function y(t, e, a, u, l, c, f, h, p) {
                    var d = [
                        n(i(n(l, e), p), i(n(c, a), h)),
                        n(i(n(c, a), f), i(n(u, t), p)),
                        n(i(n(u, t), h), i(n(l, e), f))
                    ];
                    d = s(r(r(i(d[0], d[0]), i(d[1], d[1])), i(d[2], d[2])));
                    var m = s(r(r(i(f, f), i(h, h)), i(p, p)));
                    return o(d, m);
                }
                function g(t, e) {
                    for(var o = t.length, a = 0, u = 0, l = 0; l < o; l++)u = n(t[l], e[l]), a = r(i(u, u), a);
                    return s(a);
                }
            }), cc = ge("dot", [
                "typed",
                "addScalar",
                "multiplyScalar",
                "conj",
                "size"
            ], (t)=>{
                var { typed: e, addScalar: r, multiplyScalar: n, conj: i, size: o } = t;
                return e("dot", {
                    "Array | DenseMatrix, Array | DenseMatrix": function(t, o) {
                        var u = a(t, o), l = E(t) ? t._data : t, c = E(t) ? t._datatype : void 0, f = E(o) ? o._data : o, h = E(o) ? o._datatype : void 0, p = 2 === s(t).length, d = 2 === s(o).length, m = r, y = n;
                        if (c && h && c === h && "string" == typeof c) {
                            var g = c;
                            m = e.find(r, [
                                g,
                                g
                            ]), y = e.find(n, [
                                g,
                                g
                            ]);
                        }
                        if (!p && !d) {
                            for(var v = y(i(l[0]), f[0]), b = 1; b < u; b++)v = m(v, y(i(l[b]), f[b]));
                            return v;
                        }
                        if (!p && d) {
                            for(var x = y(i(l[0]), f[0][0]), w = 1; w < u; w++)x = m(x, y(i(l[w]), f[w][0]));
                            return x;
                        }
                        if (p && !d) {
                            for(var _ = y(i(l[0][0]), f[0]), A = 1; A < u; A++)_ = m(_, y(i(l[A][0]), f[A]));
                            return _;
                        }
                        if (p && d) {
                            for(var S = y(i(l[0][0]), f[0][0]), M = 1; M < u; M++)S = m(S, y(i(l[M][0]), f[M][0]));
                            return S;
                        }
                    },
                    "SparseMatrix, SparseMatrix": function(t, e) {
                        a(t, e);
                        var i = t._index, o = t._values, s = e._index, u = e._values, l = 0, c = r, f = n, h = 0, p = 0;
                        for(; h < i.length && p < s.length;){
                            var d = i[h], m = s[p];
                            d < m ? h++ : d > m ? p++ : d === m && (l = c(l, f(o[h], u[p])), h++, p++);
                        }
                        return l;
                    }
                });
                function a(t, e) {
                    var r, n, i = s(t), o = s(e);
                    if (1 === i.length) r = i[0];
                    else {
                        if (2 !== i.length || 1 !== i[1]) throw new RangeError("Expected a column vector, instead got a matrix of size (" + i.join(", ") + ")");
                        r = i[0];
                    }
                    if (1 === o.length) n = o[0];
                    else {
                        if (2 !== o.length || 1 !== o[1]) throw new RangeError("Expected a column vector, instead got a matrix of size (" + o.join(", ") + ")");
                        n = o[0];
                    }
                    if (r !== n) throw new RangeError("Vectors must have equal length (" + r + " != " + n + ")");
                    if (0 === r) throw new RangeError("Cannot calculate the dot product of empty vectors");
                    return r;
                }
                function s(t) {
                    return E(t) ? t.size() : o(t);
                }
            }), fc = ge("equalText", [
                "typed",
                "compareText",
                "isZero"
            ], (t)=>{
                var { typed: e, compareText: r, isZero: n } = t;
                return e("equalText", {
                    "any, any": function(t, e) {
                        return n(r(t, e));
                    }
                });
            }), hc = [
                "typed",
                "config",
                "round",
                "matrix",
                "equalScalar",
                "zeros",
                "DenseMatrix"
            ], pc = ge("floor", [
                "typed",
                "config",
                "round"
            ], (t)=>{
                var { typed: e, config: r, round: n } = t;
                return e("floor", {
                    number: function(t) {
                        return Nt(t, n(t), r.epsilon) ? n(t) : Math.floor(t);
                    },
                    "number, number": function(t, e) {
                        if (Nt(t, n(t, e), r.epsilon)) return n(t, e);
                        var [i, o] = "".concat(t, "e").split("e"), a = Math.floor(Number("".concat(i, "e").concat(Number(o) + e)));
                        return [i, o] = "".concat(a, "e").split("e"), Number("".concat(i, "e").concat(Number(o) - e));
                    }
                });
            }), dc = ge("floor", hc, (t)=>{
                var { typed: e, config: r, round: n, matrix: i, equalScalar: o, zeros: a, DenseMatrix: s } = t, u = cl({
                    typed: e,
                    equalScalar: o
                }), l = fl({
                    typed: e,
                    DenseMatrix: s
                }), c = pl({
                    typed: e
                }), f = pc({
                    typed: e,
                    config: r,
                    round: n
                });
                return e("floor", {
                    number: f.signatures.number,
                    "number,number": f.signatures["number,number"],
                    Complex: function(t) {
                        return t.floor();
                    },
                    "Complex, number": function(t, e) {
                        return t.floor(e);
                    },
                    "Complex, BigNumber": function(t, e) {
                        return t.floor(e.toNumber());
                    },
                    BigNumber: function(t) {
                        return ds(t, n(t), r.epsilon) ? n(t) : t.floor();
                    },
                    "BigNumber, BigNumber": function(t, e) {
                        return ds(t, n(t, e), r.epsilon) ? n(t, e) : t.toDecimalPlaces(e.toNumber(), Qn.a.ROUND_FLOOR);
                    },
                    Fraction: function(t) {
                        return t.floor();
                    },
                    "Fraction, number": function(t, e) {
                        return t.floor(e);
                    },
                    "Fraction, BigNumber": function(t, e) {
                        return t.floor(e.toNumber());
                    },
                    "Array | Matrix": e.referToSelf((t)=>(e)=>vr(e, t, !0)),
                    "Array, number | BigNumber": e.referToSelf((t)=>(e, r)=>vr(e, (e)=>t(e, r), !0)),
                    "SparseMatrix, number | BigNumber": e.referToSelf((t)=>(e, r)=>u(e, r, t, !1)),
                    "DenseMatrix, number | BigNumber": e.referToSelf((t)=>(e, r)=>c(e, r, t, !1)),
                    "number | Complex | Fraction | BigNumber, Array": e.referToSelf((t)=>(e, r)=>c(i(r), e, t, !0).valueOf()),
                    "number | Complex | Fraction | BigNumber, Matrix": e.referToSelf((t)=>(e, r)=>o(e, 0) ? a(r.size(), r.storage()) : "dense" === r.storage() ? c(r, e, t, !0) : l(r, e, t, !0))
                });
            }), mc = ge("mod", [
                "typed",
                "config",
                "round",
                "matrix",
                "equalScalar",
                "zeros",
                "DenseMatrix",
                "concat"
            ], (t)=>{
                var { typed: e, config: r, round: n, matrix: i, equalScalar: o, zeros: a, DenseMatrix: s, concat: u } = t, l = dc({
                    typed: e,
                    config: r,
                    round: n,
                    matrix: i,
                    equalScalar: o,
                    zeros: a,
                    DenseMatrix: s
                }), c = sl({
                    typed: e,
                    equalScalar: o
                }), f = ul({
                    typed: e
                }), h = Hl({
                    typed: e,
                    equalScalar: o
                }), p = cl({
                    typed: e,
                    equalScalar: o
                }), d = fl({
                    typed: e,
                    DenseMatrix: s
                });
                return e("mod", {
                    "number, number": function(t, e) {
                        return 0 === e ? t : t - e * l(t / e);
                    },
                    "BigNumber, BigNumber": function(t, e) {
                        if (e.isNeg()) throw new Error("Cannot calculate mod for a negative divisor");
                        return e.isZero() ? t : t.mod(e);
                    },
                    "Fraction, Fraction": function(t, e) {
                        if (e.compare(0) < 0) throw new Error("Cannot calculate mod for a negative divisor");
                        return t.compare(0) >= 0 ? t.mod(e) : t.mod(e).add(e).mod(e);
                    }
                }, ml({
                    typed: e,
                    matrix: i,
                    concat: u
                })({
                    SS: h,
                    DS: f,
                    SD: c,
                    Ss: p,
                    sS: d
                }));
            }), yc = [
                "typed",
                "config",
                "round",
                "matrix",
                "equalScalar",
                "zeros",
                "BigNumber",
                "DenseMatrix",
                "concat"
            ], gc = "number | BigNumber | Fraction | Matrix | Array", vc = "".concat(gc, ", ").concat(gc, ", ...").concat(gc);
            function bc(t) {
                return !t.some((t)=>Array.isArray(t));
            }
            var xc = ge("gcd", yc, (t)=>{
                var { typed: e, matrix: r, config: n, round: i, equalScalar: o, zeros: a, BigNumber: s, DenseMatrix: u, concat: l } = t, c = mc({
                    typed: e,
                    config: n,
                    round: i,
                    matrix: r,
                    equalScalar: o,
                    zeros: a,
                    DenseMatrix: u,
                    concat: l
                }), f = Sl({
                    typed: e
                }), h = Xl({
                    typed: e,
                    equalScalar: o
                }), p = Ml({
                    typed: e,
                    DenseMatrix: u
                });
                return e("gcd", {
                    "number, number": function(t, e) {
                        if (!pt(t) || !pt(e)) throw new Error("Parameters in function gcd must be integer numbers");
                        var r;
                        for(; 0 !== e;)r = c(t, e), t = e, e = r;
                        return t < 0 ? -t : t;
                    },
                    "BigNumber, BigNumber": function(t, e) {
                        if (!t.isInt() || !e.isInt()) throw new Error("Parameters in function gcd must be integer numbers");
                        var r = new s(0);
                        for(; !e.isZero();){
                            var n = c(t, e);
                            t = e, e = n;
                        }
                        return t.lt(r) ? t.neg() : t;
                    },
                    "Fraction, Fraction": (t, e)=>t.gcd(e)
                }, ml({
                    typed: e,
                    matrix: r,
                    concat: l
                })({
                    SS: h,
                    DS: f,
                    Ss: p
                }), {
                    [vc]: e.referToSelf((t)=>(e, r, n)=>{
                            for(var i = t(e, r), o = 0; o < n.length; o++)i = t(i, n[o]);
                            return i;
                        }),
                    Array: e.referToSelf((t)=>(e)=>{
                            if (1 === e.length && Array.isArray(e[0]) && bc(e[0])) return t(...e[0]);
                            if (bc(e)) return t(...e);
                            throw new jl("gcd() supports only 1d matrices!");
                        }),
                    Matrix: e.referToSelf((t)=>(e)=>t(e.toArray()))
                });
            }), wc = ge("hypot", [
                "typed",
                "abs",
                "addScalar",
                "divideScalar",
                "multiplyScalar",
                "sqrt",
                "smaller",
                "isPositive"
            ], (t)=>{
                var { typed: e, abs: r, addScalar: n, divideScalar: i, multiplyScalar: o, sqrt: a, smaller: s, isPositive: u } = t;
                return e("hypot", {
                    "... number | BigNumber": l,
                    Array: l,
                    Matrix: (t)=>l(ne(t.toArray()))
                });
                function l(t) {
                    for(var e = 0, l = 0, c = 0; c < t.length; c++){
                        if (b(t[c])) throw new TypeError("Unexpected type of argument to hypot");
                        var f = r(t[c]);
                        s(l, f) ? (e = o(e, o(i(l, f), i(l, f))), e = n(e, 1), l = f) : e = n(e, u(f) ? o(i(f, l), i(f, l)) : f);
                    }
                    return o(l, a(e));
                }
            }), _c = ge("ImmutableDenseMatrix", [
                "smaller",
                "DenseMatrix"
            ], (t)=>{
                var { smaller: e, DenseMatrix: r } = t;
                function n(t, e) {
                    if (!(this instanceof n)) throw new SyntaxError("Constructor must be called with the new operator");
                    if (e && !_(e)) throw new Error("Invalid datatype: " + e);
                    if (E(t) || A(t)) {
                        var i = new r(t, e);
                        this._data = i._data, this._size = i._size, this._datatype = i._datatype, this._min = null, this._max = null;
                    } else if (t && A(t.data) && A(t.size)) this._data = t.data, this._size = t.size, this._datatype = t.datatype, this._min = void 0 !== t.min ? t.min : null, this._max = void 0 !== t.max ? t.max : null;
                    else {
                        if (t) throw new TypeError("Unsupported type of data (" + nt(t) + ")");
                        this._data = [], this._size = [
                            0
                        ], this._datatype = e, this._min = null, this._max = null;
                    }
                }
                return n.prototype = new r, n.prototype.type = "ImmutableDenseMatrix", n.prototype.isImmutableDenseMatrix = !0, n.prototype.subset = function(t) {
                    switch(arguments.length){
                        case 1:
                            var e = r.prototype.subset.call(this, t);
                            return E(e) ? new n({
                                data: e._data,
                                size: e._size,
                                datatype: e._datatype
                            }) : e;
                        case 2:
                        case 3:
                            throw new Error("Cannot invoke set subset on an Immutable Matrix instance");
                        default:
                            throw new SyntaxError("Wrong number of arguments");
                    }
                }, n.prototype.set = function() {
                    throw new Error("Cannot invoke set on an Immutable Matrix instance");
                }, n.prototype.resize = function() {
                    throw new Error("Cannot invoke resize on an Immutable Matrix instance");
                }, n.prototype.reshape = function() {
                    throw new Error("Cannot invoke reshape on an Immutable Matrix instance");
                }, n.prototype.clone = function() {
                    return new n({
                        data: it(this._data),
                        size: it(this._size),
                        datatype: this._datatype
                    });
                }, n.prototype.toJSON = function() {
                    return {
                        mathjs: "ImmutableDenseMatrix",
                        data: this._data,
                        size: this._size,
                        datatype: this._datatype
                    };
                }, n.fromJSON = function(t) {
                    return new n(t);
                }, n.prototype.swapRows = function() {
                    throw new Error("Cannot invoke swapRows on an Immutable Matrix instance");
                }, n.prototype.min = function() {
                    if (null === this._min) {
                        var t = null;
                        this.forEach(function(r) {
                            (null === t || e(r, t)) && (t = r);
                        }), this._min = null !== t ? t : void 0;
                    }
                    return this._min;
                }, n.prototype.max = function() {
                    if (null === this._max) {
                        var t = null;
                        this.forEach(function(r) {
                            (null === t || e(t, r)) && (t = r);
                        }), this._max = null !== t ? t : void 0;
                    }
                    return this._max;
                }, n;
            }, {
                isClass: !0
            }), Ac = ge("Index", [
                "ImmutableDenseMatrix",
                "getMatrixDataType"
            ], (t)=>{
                var { ImmutableDenseMatrix: e, getMatrixDataType: r } = t;
                function n(t) {
                    if (!(this instanceof n)) throw new SyntaxError("Constructor must be called with the new operator");
                    this._dimensions = [], this._sourceSize = [], this._isScalar = !0;
                    for(var e = 0, o = arguments.length; e < o; e++){
                        var a = arguments[e], s = A(a), u = E(a), l = null;
                        if (N(a)) this._dimensions.push(a), this._isScalar = !1;
                        else if (s || u) {
                            var c = void 0;
                            "boolean" === r(a) ? (s && (c = i(Ec(a).valueOf())), u && (c = i(Ec(a._data).valueOf())), l = a.valueOf().length) : c = i(a.valueOf()), this._dimensions.push(c);
                            var f = c.size();
                            1 === f.length && 1 === f[0] && null === l || (this._isScalar = !1);
                        } else if ("number" == typeof a) this._dimensions.push(i([
                            a
                        ]));
                        else {
                            if ("string" != typeof a) throw new TypeError("Dimension must be an Array, Matrix, number, string, or Range");
                            this._dimensions.push(a);
                        }
                        this._sourceSize.push(l);
                    }
                }
                function i(t) {
                    for(var r = 0, n = t.length; r < n; r++)if ("number" != typeof t[r] || !pt(t[r])) throw new TypeError("Index parameters must be positive integer numbers");
                    return new e(t);
                }
                return n.prototype.type = "Index", n.prototype.isIndex = !0, n.prototype.clone = function() {
                    var t = new n;
                    return t._dimensions = it(this._dimensions), t._isScalar = this._isScalar, t._sourceSize = this._sourceSize, t;
                }, n.create = function(t) {
                    var e = new n;
                    return n.apply(e, t), e;
                }, n.prototype.size = function() {
                    for(var t = [], e = 0, r = this._dimensions.length; e < r; e++){
                        var n = this._dimensions[e];
                        t[e] = "string" == typeof n ? 1 : n.size()[0];
                    }
                    return t;
                }, n.prototype.max = function() {
                    for(var t = [], e = 0, r = this._dimensions.length; e < r; e++){
                        var n = this._dimensions[e];
                        t[e] = "string" == typeof n ? n : n.max();
                    }
                    return t;
                }, n.prototype.min = function() {
                    for(var t = [], e = 0, r = this._dimensions.length; e < r; e++){
                        var n = this._dimensions[e];
                        t[e] = "string" == typeof n ? n : n.min();
                    }
                    return t;
                }, n.prototype.forEach = function(t) {
                    for(var e = 0, r = this._dimensions.length; e < r; e++)t(this._dimensions[e], e, this);
                }, n.prototype.dimension = function(t) {
                    return this._dimensions[t] || null;
                }, n.prototype.isObjectProperty = function() {
                    return 1 === this._dimensions.length && "string" == typeof this._dimensions[0];
                }, n.prototype.getObjectProperty = function() {
                    return this.isObjectProperty() ? this._dimensions[0] : null;
                }, n.prototype.isScalar = function() {
                    return this._isScalar;
                }, n.prototype.toArray = function() {
                    for(var t = [], e = 0, r = this._dimensions.length; e < r; e++){
                        var n = this._dimensions[e];
                        t.push("string" == typeof n ? n : n.toArray());
                    }
                    return t;
                }, n.prototype.valueOf = n.prototype.toArray, n.prototype.toString = function() {
                    for(var t = [], e = 0, r = this._dimensions.length; e < r; e++){
                        var n = this._dimensions[e];
                        "string" == typeof n ? t.push(JSON.stringify(n)) : t.push(n.toString());
                    }
                    return "[" + t.join(", ") + "]";
                }, n.prototype.toJSON = function() {
                    return {
                        mathjs: "Index",
                        dimensions: this._dimensions
                    };
                }, n.fromJSON = function(t) {
                    return n.create(t.dimensions);
                }, n;
            }, {
                isClass: !0
            });
            function Ec(t) {
                var e = [];
                return t.forEach((t, r)=>{
                    t && e.push(r);
                }), e;
            }
            var Sc = ge("larger", [
                "typed",
                "config",
                "matrix",
                "DenseMatrix",
                "concat"
            ], (t)=>{
                var { typed: e, config: r, matrix: n, DenseMatrix: i, concat: o } = t, a = ul({
                    typed: e
                }), s = ll({
                    typed: e,
                    DenseMatrix: i
                }), u = fl({
                    typed: e,
                    DenseMatrix: i
                }), l = ml({
                    typed: e,
                    matrix: n,
                    concat: o
                }), c = ms({
                    typed: e
                });
                return e("larger", Mc({
                    typed: e,
                    config: r
                }), {
                    "boolean, boolean": (t, e)=>t > e,
                    "BigNumber, BigNumber": function(t, e) {
                        return t.gt(e) && !ds(t, e, r.epsilon);
                    },
                    "Fraction, Fraction": (t, e)=>1 === t.compare(e),
                    "Complex, Complex": function() {
                        throw new TypeError("No ordering relation is defined for complex numbers");
                    }
                }, c, l({
                    SS: s,
                    DS: a,
                    Ss: u
                }));
            }), Mc = ge("larger", [
                "typed",
                "config"
            ], (t)=>{
                var { typed: e, config: r } = t;
                return e("larger", {
                    "number, number": function(t, e) {
                        return t > e && !Nt(t, e, r.epsilon);
                    }
                });
            }), kc = ge("log", [
                "config",
                "typed",
                "divideScalar",
                "Complex"
            ], (t)=>{
                var { typed: e, config: r, divideScalar: n, Complex: i } = t;
                return e("log", {
                    number: function(t) {
                        return t >= 0 || r.predictable ? function(t, e) {
                            return e ? Math.log(t) / Math.log(e) : Math.log(t);
                        }(t) : new i(t, 0).log();
                    },
                    Complex: function(t) {
                        return t.log();
                    },
                    BigNumber: function(t) {
                        return !t.isNegative() || r.predictable ? t.ln() : new i(t.toNumber(), 0).log();
                    },
                    "any, any": e.referToSelf((t)=>(e, r)=>n(t(e), t(r)))
                });
            }), Nc = ge("lsolveAll", [
                "typed",
                "matrix",
                "divideScalar",
                "multiplyScalar",
                "subtractScalar",
                "equalScalar",
                "DenseMatrix"
            ], (t)=>{
                var { typed: e, matrix: r, divideScalar: n, multiplyScalar: i, subtractScalar: o, equalScalar: a, DenseMatrix: s } = t, u = Dl({
                    DenseMatrix: s
                });
                return e("lsolveAll", {
                    "SparseMatrix, Array | Matrix": function(t, e) {
                        return function(t, e) {
                            for(var r = [
                                u(t, e, !0)._data.map((t)=>t[0])
                            ], l = t._size[0], c = t._size[1], f = t._values, h = t._index, p = t._ptr, d = 0; d < c; d++)for(var m = r.length, y = 0; y < m; y++){
                                for(var g = r[y], v = [], b = [], x = p[d], w = p[d + 1], _ = 0, A = x; A < w; A++){
                                    var E = h[A];
                                    E === d ? _ = f[A] : E > d && (v.push(f[A]), b.push(E));
                                }
                                if (a(_, 0)) {
                                    if (a(g[d], 0)) {
                                        if (0 === y) {
                                            var S = [
                                                ...g
                                            ];
                                            S[d] = 1;
                                            for(var M = 0, k = b.length; M < k; M++){
                                                var N = b[M];
                                                S[N] = o(S[N], v[M]);
                                            }
                                            r.push(S);
                                        }
                                    } else {
                                        if (0 === y) return [];
                                        r.splice(y, 1), y -= 1, m -= 1;
                                    }
                                } else {
                                    g[d] = n(g[d], _);
                                    for(var C = 0, D = b.length; C < D; C++){
                                        var O = b[C];
                                        g[O] = o(g[O], i(g[d], v[C]));
                                    }
                                }
                            }
                            return r.map((t)=>new s({
                                    data: t.map((t)=>[
                                            t
                                        ]),
                                    size: [
                                        l,
                                        1
                                    ]
                                }));
                        }(t, e);
                    },
                    "DenseMatrix, Array | Matrix": function(t, e) {
                        return l(t, e);
                    },
                    "Array, Array | Matrix": function(t, e) {
                        return l(r(t), e).map((t)=>t.valueOf());
                    }
                });
                function l(t, e) {
                    for(var r = [
                        u(t, e, !0)._data.map((t)=>t[0])
                    ], l = t._data, c = t._size[0], f = t._size[1], h = 0; h < f; h++)for(var p = r.length, d = 0; d < p; d++){
                        var m = r[d];
                        if (a(l[h][h], 0)) {
                            if (a(m[h], 0)) {
                                if (0 === d) {
                                    var y = [
                                        ...m
                                    ];
                                    y[h] = 1;
                                    for(var g = h + 1; g < f; g++)y[g] = o(y[g], l[g][h]);
                                    r.push(y);
                                }
                            } else {
                                if (0 === d) return [];
                                r.splice(d, 1), d -= 1, p -= 1;
                            }
                        } else {
                            m[h] = n(m[h], l[h][h]);
                            for(var v = h + 1; v < f; v++)m[v] = o(m[v], i(m[h], l[v][h]));
                        }
                    }
                    return r.map((t)=>new s({
                            data: t.map((t)=>[
                                    t
                                ]),
                            size: [
                                c,
                                1
                            ]
                        }));
                }
            }), Cc = ge("matrixFromRows", [
                "typed",
                "matrix",
                "flatten",
                "size"
            ], (t)=>{
                var { typed: e, matrix: r, flatten: n, size: i } = t;
                return e("matrixFromRows", {
                    "...Array": function(t) {
                        return o(t);
                    },
                    "...Matrix": function(t) {
                        return r(o(t.map((t)=>t.toArray())));
                    }
                });
                function o(t) {
                    if (0 === t.length) throw new TypeError("At least one row is needed to construct a matrix.");
                    var e = a(t[0]), r = [];
                    for (var i of t){
                        var o = a(i);
                        if (o !== e) throw new TypeError("The vectors had different length: " + (0 | e) + " \u2260 " + (0 | o));
                        r.push(n(i));
                    }
                    return r;
                }
                function a(t) {
                    var e = i(t);
                    if (1 === e.length) return e[0];
                    if (2 === e.length) {
                        if (1 === e[0]) return e[1];
                        if (1 === e[1]) return e[0];
                        throw new TypeError("At least one of the arguments is not a vector.");
                    }
                    throw new TypeError("Only one- or two-dimensional vectors are supported.");
                }
            }), Dc = ge("multiply", [
                "typed",
                "matrix",
                "addScalar",
                "multiplyScalar",
                "equalScalar",
                "dot"
            ], (t)=>{
                var { typed: e, matrix: r, addScalar: n, multiplyScalar: i, equalScalar: o, dot: a } = t, s = cl({
                    typed: e,
                    equalScalar: o
                }), u = pl({
                    typed: e
                });
                function l(t, e) {
                    switch(t.length){
                        case 1:
                            switch(e.length){
                                case 1:
                                    if (t[0] !== e[0]) throw new RangeError("Dimension mismatch in multiplication. Vectors must have the same length");
                                    break;
                                case 2:
                                    if (t[0] !== e[0]) throw new RangeError("Dimension mismatch in multiplication. Vector length (" + t[0] + ") must match Matrix rows (" + e[0] + ")");
                                    break;
                                default:
                                    throw new Error("Can only multiply a 1 or 2 dimensional matrix (Matrix B has " + e.length + " dimensions)");
                            }
                            break;
                        case 2:
                            switch(e.length){
                                case 1:
                                    if (t[1] !== e[0]) throw new RangeError("Dimension mismatch in multiplication. Matrix columns (" + t[1] + ") must match Vector length (" + e[0] + ")");
                                    break;
                                case 2:
                                    if (t[1] !== e[0]) throw new RangeError("Dimension mismatch in multiplication. Matrix A columns (" + t[1] + ") must match Matrix B rows (" + e[0] + ")");
                                    break;
                                default:
                                    throw new Error("Can only multiply a 1 or 2 dimensional matrix (Matrix B has " + e.length + " dimensions)");
                            }
                            break;
                        default:
                            throw new Error("Can only multiply a 1 or 2 dimensional matrix (Matrix A has " + t.length + " dimensions)");
                    }
                }
                function c(t, r) {
                    if ("dense" !== r.storage()) throw new Error("Support for SparseMatrix not implemented");
                    return function(t, r) {
                        var o, a = t._data, s = t._size, u = t._datatype, l = r._data, c = r._size, f = r._datatype, h = s[0], p = c[1], d = n, m = i;
                        u && f && u === f && "string" == typeof u && (o = u, d = e.find(n, [
                            o,
                            o
                        ]), m = e.find(i, [
                            o,
                            o
                        ]));
                        for(var y = [], g = 0; g < p; g++){
                            for(var v = m(a[0], l[0][g]), b = 1; b < h; b++)v = d(v, m(a[b], l[b][g]));
                            y[g] = v;
                        }
                        return t.createDenseMatrix({
                            data: y,
                            size: [
                                p
                            ],
                            datatype: o
                        });
                    }(t, r);
                }
                var f = e("_multiplyMatrixVector", {
                    "DenseMatrix, any": function(t, r) {
                        var o, a = t._data, s = t._size, u = t._datatype, l = r._data, c = r._datatype, f = s[0], h = s[1], p = n, d = i;
                        u && c && u === c && "string" == typeof u && (o = u, p = e.find(n, [
                            o,
                            o
                        ]), d = e.find(i, [
                            o,
                            o
                        ]));
                        for(var m = [], y = 0; y < f; y++){
                            for(var g = a[y], v = d(g[0], l[0]), b = 1; b < h; b++)v = p(v, d(g[b], l[b]));
                            m[y] = v;
                        }
                        return t.createDenseMatrix({
                            data: m,
                            size: [
                                f
                            ],
                            datatype: o
                        });
                    },
                    "SparseMatrix, any": function(t, r) {
                        var a = t._values, s = t._index, u = t._ptr, l = t._datatype;
                        if (!a) throw new Error("Cannot multiply Pattern only Matrix times Dense Matrix");
                        var c, f = r._data, h = r._datatype, p = t._size[0], d = r._size[0], m = [], y = [], g = [], v = n, b = i, x = o, w = 0;
                        l && h && l === h && "string" == typeof l && (c = l, v = e.find(n, [
                            c,
                            c
                        ]), b = e.find(i, [
                            c,
                            c
                        ]), x = e.find(o, [
                            c,
                            c
                        ]), w = e.convert(0, c));
                        var _ = [], A = [];
                        g[0] = 0;
                        for(var E = 0; E < d; E++){
                            var S = f[E];
                            if (!x(S, w)) for(var M = u[E], k = u[E + 1], N = M; N < k; N++){
                                var C = s[N];
                                A[C] ? _[C] = v(_[C], b(S, a[N])) : (A[C] = !0, y.push(C), _[C] = b(S, a[N]));
                            }
                        }
                        for(var D = y.length, O = 0; O < D; O++){
                            var T = y[O];
                            m[O] = _[T];
                        }
                        return g[1] = y.length, t.createSparseMatrix({
                            values: m,
                            index: y,
                            ptr: g,
                            size: [
                                p,
                                1
                            ],
                            datatype: c
                        });
                    }
                }), h = e("_multiplyMatrixMatrix", {
                    "DenseMatrix, DenseMatrix": function(t, r) {
                        var o, a = t._data, s = t._size, u = t._datatype, l = r._data, c = r._size, f = r._datatype, h = s[0], p = s[1], d = c[1], m = n, y = i;
                        u && f && u === f && "string" == typeof u && (o = u, m = e.find(n, [
                            o,
                            o
                        ]), y = e.find(i, [
                            o,
                            o
                        ]));
                        for(var g = [], v = 0; v < h; v++){
                            var b = a[v];
                            g[v] = [];
                            for(var x = 0; x < d; x++){
                                for(var w = y(b[0], l[0][x]), _ = 1; _ < p; _++)w = m(w, y(b[_], l[_][x]));
                                g[v][x] = w;
                            }
                        }
                        return t.createDenseMatrix({
                            data: g,
                            size: [
                                h,
                                d
                            ],
                            datatype: o
                        });
                    },
                    "DenseMatrix, SparseMatrix": function(t, r) {
                        var a = t._data, s = t._size, u = t._datatype, l = r._values, c = r._index, f = r._ptr, h = r._size, p = r._datatype;
                        if (!l) throw new Error("Cannot multiply Dense Matrix times Pattern only Matrix");
                        var d, m = s[0], y = h[1], g = n, v = i, b = o, x = 0;
                        u && p && u === p && "string" == typeof u && (d = u, g = e.find(n, [
                            d,
                            d
                        ]), v = e.find(i, [
                            d,
                            d
                        ]), b = e.find(o, [
                            d,
                            d
                        ]), x = e.convert(0, d));
                        for(var w = [], _ = [], A = [], E = r.createSparseMatrix({
                            values: w,
                            index: _,
                            ptr: A,
                            size: [
                                m,
                                y
                            ],
                            datatype: d
                        }), S = 0; S < y; S++){
                            A[S] = _.length;
                            var M = f[S], k = f[S + 1];
                            if (k > M) for(var N = 0, C = 0; C < m; C++){
                                for(var D = C + 1, O = void 0, T = M; T < k; T++){
                                    var F = c[T];
                                    N !== D ? (O = v(a[C][F], l[T]), N = D) : O = g(O, v(a[C][F], l[T]));
                                }
                                N !== D || b(O, x) || (_.push(C), w.push(O));
                            }
                        }
                        return A[y] = _.length, E;
                    },
                    "SparseMatrix, DenseMatrix": function(t, r) {
                        var a = t._values, s = t._index, u = t._ptr, l = t._datatype;
                        if (!a) throw new Error("Cannot multiply Pattern only Matrix times Dense Matrix");
                        var c, f = r._data, h = r._datatype, p = t._size[0], d = r._size[0], m = r._size[1], y = n, g = i, v = o, b = 0;
                        l && h && l === h && "string" == typeof l && (c = l, y = e.find(n, [
                            c,
                            c
                        ]), g = e.find(i, [
                            c,
                            c
                        ]), v = e.find(o, [
                            c,
                            c
                        ]), b = e.convert(0, c));
                        for(var x = [], w = [], _ = [], A = t.createSparseMatrix({
                            values: x,
                            index: w,
                            ptr: _,
                            size: [
                                p,
                                m
                            ],
                            datatype: c
                        }), E = [], S = [], M = 0; M < m; M++){
                            _[M] = w.length;
                            for(var k = M + 1, N = 0; N < d; N++){
                                var C = f[N][M];
                                if (!v(C, b)) for(var D = u[N], O = u[N + 1], T = D; T < O; T++){
                                    var F = s[T];
                                    S[F] !== k ? (S[F] = k, w.push(F), E[F] = g(C, a[T])) : E[F] = y(E[F], g(C, a[T]));
                                }
                            }
                            for(var P = _[M], I = w.length, B = P; B < I; B++){
                                var j = w[B];
                                x[B] = E[j];
                            }
                        }
                        return _[m] = w.length, A;
                    },
                    "SparseMatrix, SparseMatrix": function(t, r) {
                        var o, a = t._values, s = t._index, u = t._ptr, l = t._datatype, c = r._values, f = r._index, h = r._ptr, p = r._datatype, d = t._size[0], m = r._size[1], y = a && c, g = n, v = i;
                        l && p && l === p && "string" == typeof l && (o = l, g = e.find(n, [
                            o,
                            o
                        ]), v = e.find(i, [
                            o,
                            o
                        ]));
                        for(var b, x, w, _, A, E, S, M, k = y ? [] : void 0, N = [], C = [], D = t.createSparseMatrix({
                            values: k,
                            index: N,
                            ptr: C,
                            size: [
                                d,
                                m
                            ],
                            datatype: o
                        }), O = y ? [] : void 0, T = [], F = 0; F < m; F++){
                            C[F] = N.length;
                            var P = F + 1;
                            for(A = h[F], E = h[F + 1], _ = A; _ < E; _++)if (M = f[_], y) for(x = u[M], w = u[M + 1], b = x; b < w; b++)S = s[b], T[S] !== P ? (T[S] = P, N.push(S), O[S] = v(c[_], a[b])) : O[S] = g(O[S], v(c[_], a[b]));
                            else for(x = u[M], w = u[M + 1], b = x; b < w; b++)S = s[b], T[S] !== P && (T[S] = P, N.push(S));
                            if (y) for(var I = C[F], B = N.length, j = I; j < B; j++){
                                var R = N[j];
                                k[j] = O[R];
                            }
                        }
                        return C[m] = N.length, D;
                    }
                });
                return e("multiply", i, {
                    "Array, Array": e.referTo("Matrix, Matrix", (t)=>(e, n)=>{
                            l($t(e), $t(n));
                            var i = t(r(e), r(n));
                            return E(i) ? i.valueOf() : i;
                        }),
                    "Matrix, Matrix": function(t, e) {
                        var r = t.size(), n = e.size();
                        return l(r, n), 1 === r.length ? 1 === n.length ? function(t, e, r) {
                            if (0 === r) throw new Error("Cannot multiply two empty vectors");
                            return a(t, e);
                        }(t, e, r[0]) : c(t, e) : 1 === n.length ? f(t, e) : h(t, e);
                    },
                    "Matrix, Array": e.referTo("Matrix,Matrix", (t)=>(e, n)=>t(e, r(n))),
                    "Array, Matrix": e.referToSelf((t)=>(e, n)=>t(r(e, n.storage()), n)),
                    "SparseMatrix, any": function(t, e) {
                        return s(t, e, i, !1);
                    },
                    "DenseMatrix, any": function(t, e) {
                        return u(t, e, i, !1);
                    },
                    "any, SparseMatrix": function(t, e) {
                        return s(e, t, i, !0);
                    },
                    "any, DenseMatrix": function(t, e) {
                        return u(e, t, i, !0);
                    },
                    "Array, any": function(t, e) {
                        return u(r(t), e, i, !1).valueOf();
                    },
                    "any, Array": function(t, e) {
                        return u(r(e), t, i, !0).valueOf();
                    },
                    "any, any": i,
                    "any, any, ...any": e.referToSelf((t)=>(e, r, n)=>{
                            for(var i = t(e, r), o = 0; o < n.length; o++)i = t(i, n[o]);
                            return i;
                        })
                });
            }), Oc = ge("nthRoots", [
                "config",
                "typed",
                "divideScalar",
                "Complex"
            ], (t)=>{
                var { typed: e, config: r, divideScalar: n, Complex: i } = t, o = [
                    function(t) {
                        return new i(t, 0);
                    },
                    function(t) {
                        return new i(0, t);
                    },
                    function(t) {
                        return new i(-t, 0);
                    },
                    function(t) {
                        return new i(0, -t);
                    }
                ];
                function a(t, e) {
                    if (e < 0) throw new Error("Root must be greater than zero");
                    if (0 === e) throw new Error("Root must be non-zero");
                    if (e % 1 != 0) throw new Error("Root must be an integer");
                    if (0 === t || 0 === t.abs()) return [
                        new i(0, 0)
                    ];
                    var r, n = "number" == typeof t;
                    (n || 0 === t.re || 0 === t.im) && (r = n ? 2 * +(t < 0) : 0 === t.im ? 2 * +(t.re < 0) : 2 * +(t.im < 0) + 1);
                    for(var a = t.arg(), s = t.abs(), u = [], l = Math.pow(s, 1 / e), c = 0; c < e; c++){
                        var f = (r + 4 * c) / e;
                        f !== Math.round(f) ? u.push(new i({
                            r: l,
                            phi: (a + 2 * Math.PI * c) / e
                        })) : u.push(o[f % 4](l));
                    }
                    return u;
                }
                return e("nthRoots", {
                    Complex: function(t) {
                        return a(t, 2);
                    },
                    "Complex, number": a
                });
            }), Tc = ge("or", [
                "typed",
                "matrix",
                "equalScalar",
                "DenseMatrix",
                "concat"
            ], (t)=>{
                var { typed: e, matrix: r, equalScalar: n, DenseMatrix: i, concat: o } = t, a = ul({
                    typed: e
                }), s = Hl({
                    typed: e,
                    equalScalar: n
                }), u = fl({
                    typed: e,
                    DenseMatrix: i
                }), l = ml({
                    typed: e,
                    matrix: r,
                    concat: o
                });
                return e("or", {
                    "number, number": Qs,
                    "Complex, Complex": function(t, e) {
                        return 0 !== t.re || 0 !== t.im || 0 !== e.re || 0 !== e.im;
                    },
                    "BigNumber, BigNumber": function(t, e) {
                        return !t.isZero() && !t.isNaN() || !e.isZero() && !e.isNaN();
                    },
                    "Unit, Unit": e.referToSelf((t)=>(e, r)=>t(e.value || 0, r.value || 0))
                }, l({
                    SS: s,
                    DS: a,
                    Ss: u
                }));
            }), Fc = ge("partitionSelect", [
                "typed",
                "isNumeric",
                "isNaN",
                "compare"
            ], (t)=>{
                var { typed: e, isNumeric: r, isNaN: n, compare: i } = t, o = i, a = (t, e)=>-i(t, e);
                return e("partitionSelect", {
                    "Array | Matrix, number": function(t, e) {
                        return s(t, e, o);
                    },
                    "Array | Matrix, number, string": function(t, e, r) {
                        if ("asc" === r) return s(t, e, o);
                        if ("desc" === r) return s(t, e, a);
                        throw new Error('Compare string must be "asc" or "desc"');
                    },
                    "Array | Matrix, number, function": s
                });
                function s(t, e, r) {
                    if (!pt(e) || e < 0) throw new Error("k must be a non-negative integer");
                    if (E(t)) {
                        if (t.size().length > 1) throw new Error("Only one dimensional matrices supported");
                        return u(t.valueOf(), e, r);
                    }
                    if (Array.isArray(t)) return u(t, e, r);
                }
                function u(t, e, i) {
                    if (e >= t.length) throw new Error("k out of bounds");
                    for(var o = 0; o < t.length; o++)if (r(t[o]) && n(t[o])) return t[o];
                    for(var a = 0, s = t.length - 1; a < s;){
                        for(var u = a, l = s, c = t[Math.floor(Math.random() * (s - a + 1)) + a]; u < l;)if (i(t[u], c) >= 0) {
                            var f = t[l];
                            t[l] = t[u], t[u] = f, --l;
                        } else ++u;
                        i(t[u], c) > 0 && --u, e <= u ? s = u : a = u + 1;
                    }
                    return t[e];
                }
            }), Pc = ge("rightLogShift", [
                "typed",
                "matrix",
                "equalScalar",
                "zeros",
                "DenseMatrix",
                "concat"
            ], (t)=>{
                var { typed: e, matrix: r, equalScalar: n, zeros: i, DenseMatrix: o, concat: a } = t, s = Sl({
                    typed: e
                }), u = sl({
                    typed: e,
                    equalScalar: n
                }), l = kl({
                    typed: e,
                    equalScalar: n
                }), c = Ml({
                    typed: e,
                    DenseMatrix: o
                }), f = cl({
                    typed: e,
                    equalScalar: n
                }), h = pl({
                    typed: e
                }), p = ml({
                    typed: e,
                    matrix: r,
                    concat: a
                }), d = Nl({
                    typed: e,
                    matrix: r
                });
                return e("rightLogShift", {
                    "number, number": Qa,
                    "SparseMatrix, number | BigNumber": e.referToSelf((t)=>(e, r)=>n(r, 0) ? e.clone() : f(e, r, t, !1)),
                    "DenseMatrix, number | BigNumber": e.referToSelf((t)=>(e, r)=>n(r, 0) ? e.clone() : h(e, r, t, !1)),
                    "number | BigNumber, SparseMatrix": e.referToSelf((t)=>(e, r)=>n(e, 0) ? i(r.size(), r.storage()) : c(r, e, t, !0)),
                    "number | BigNumber, DenseMatrix": e.referToSelf((t)=>(e, r)=>n(e, 0) ? i(r.size(), r.storage()) : h(r, e, t, !0))
                }, d, p({
                    SS: l,
                    DS: s,
                    SD: u
                }));
            });
            function Ic(t, e, r, n, i, o, a) {
                var s = 0;
                for(r[a] = t; s >= 0;){
                    var u = r[a + s], l = r[n + u];
                    -1 === l ? (s--, o[e++] = u) : (r[n + u] = r[i + l], r[a + ++s] = l);
                }
                return e;
            }
            function Bc(t) {
                return -t - 2;
            }
            var jc = ge("csAmd", [
                "add",
                "multiply",
                "transpose"
            ], (t)=>{
                var { add: e, multiply: r, transpose: n } = t;
                return function(t, a) {
                    if (!a || t <= 0 || t > 3) return null;
                    var s = a._size, u = s[0], l = s[1], c = 0, f = Math.max(16, 10 * Math.sqrt(l)), h = function(t, i, o, a, s) {
                        var u = n(i);
                        if (1 === t && a === o) return e(i, u);
                        if (2 === t) {
                            for(var l = u._index, c = u._ptr, f = 0, h = 0; h < o; h++){
                                var p = c[h];
                                if (c[h] = f, !(c[h + 1] - p > s)) for(var d = c[h + 1]; p < d; p++)l[f++] = l[p];
                            }
                            return c[o] = f, i = n(u), r(u, i);
                        }
                        return r(u, i);
                    }(t, a, u, l, f = Math.min(l - 2, f));
                    !function(t, e, r) {
                        for(var n = t._values, i = t._index, o = t._ptr, a = t._size[1], s = 0, u = 0; u < a; u++){
                            var l = o[u];
                            for(o[u] = s; l < o[u + 1]; l++)e(i[l], u, n ? n[l] : 1, r) && (i[s] = i[l], n && (n[s] = n[l]), s++);
                        }
                        o[a] = s, i.splice(s, i.length - s), n && n.splice(s, n.length - s);
                    }(h, o, null);
                    for(var p, d, m, y, g, v, b, x, w, _, A, E, S, M, k, N, C = h._index, D = h._ptr, O = D[l], T = [], F = [], P = l + 1, I = 2 * (l + 1), B = 3 * (l + 1), j = 4 * (l + 1), R = 5 * (l + 1), L = 6 * (l + 1), q = 7 * (l + 1), U = T, z = function(t, e, r, n, o, a, s, u, l, c, f, h) {
                        for(var p = 0; p < t; p++)r[n + p] = e[p + 1] - e[p];
                        r[n + t] = 0;
                        for(var d = 0; d <= t; d++)r[o + d] = -1, a[d] = -1, r[s + d] = -1, r[u + d] = -1, r[l + d] = 1, r[c + d] = 1, r[f + d] = 0, r[h + d] = r[n + d];
                        var m = i(0, 0, r, c, t);
                        return r[f + t] = -2, e[t] = -1, r[c + t] = 0, m;
                    }(l, D, F, 0, B, U, I, q, P, L, j, R), G = function(t, e, r, n, i, o, a, s, u, l, c) {
                        for(var f = 0, h = 0; h < t; h++){
                            var p = r[n + h];
                            if (0 === p) r[i + h] = -2, f++, e[h] = -1, r[o + h] = 0;
                            else if (p > a) r[s + h] = 0, r[i + h] = -1, f++, e[h] = Bc(t), r[s + t]++;
                            else {
                                var d = r[u + p];
                                -1 !== d && (l[d] = h), r[c + h] = r[u + p], r[u + p] = h;
                            }
                        }
                        return f;
                    }(l, D, F, R, j, L, f, P, B, U, I), H = 0; G < l;){
                        for(m = -1; H < l && -1 === (m = F[B + H]); H++);
                        -1 !== F[I + m] && (U[F[I + m]] = -1), F[B + H] = F[I + m];
                        var W = F[j + m], $ = F[P + m];
                        G += $;
                        var V = 0;
                        F[P + m] = -$;
                        var Z = D[m], Y = 0 === W ? Z : O, K = Y;
                        for(y = 1; y <= W + 1; y++){
                            for(y > W ? (v = m, b = Z, x = F[0 + m] - W) : (b = D[v = C[Z++]], x = F[0 + v]), g = 1; g <= x; g++)(w = F[P + (p = C[b++])]) <= 0 || (V += w, F[P + p] = -w, C[K++] = p, -1 !== F[I + p] && (U[F[I + p]] = U[p]), -1 !== U[p] ? F[I + U[p]] = F[I + p] : F[B + F[R + p]] = F[I + p]);
                            v !== m && (D[v] = Bc(m), F[L + v] = 0);
                        }
                        for(0 !== W && (O = K), F[R + m] = V, D[m] = Y, F[0 + m] = K - Y, F[j + m] = -2, z = i(z, c, F, L, l), _ = Y; _ < K; _++)if (!((A = F[j + (p = C[_])]) <= 0)) {
                            var X = z - (w = -F[P + p]);
                            for(Z = D[p], E = D[p] + A - 1; Z <= E; Z++)F[L + (v = C[Z])] >= z ? F[L + v] -= w : 0 !== F[L + v] && (F[L + v] = F[R + v] + X);
                        }
                        for(_ = Y; _ < K; _++){
                            for(S = (E = D[p = C[_]]) + F[j + p] - 1, M = E, k = 0, N = 0, Z = E; Z <= S; Z++)if (0 !== F[L + (v = C[Z])]) {
                                var J = F[L + v] - z;
                                J > 0 ? (N += J, C[M++] = v, k += v) : (D[v] = Bc(m), F[L + v] = 0);
                            }
                            F[j + p] = M - E + 1;
                            var Q = M, tt = E + F[0 + p];
                            for(Z = S + 1; Z < tt; Z++){
                                var et = F[P + (d = C[Z])];
                                et <= 0 || (N += et, C[M++] = d, k += d);
                            }
                            0 === N ? (D[p] = Bc(m), V -= w = -F[P + p], $ += w, G += w, F[P + p] = 0, F[j + p] = -1) : (F[R + p] = Math.min(F[R + p], N), C[M] = C[Q], C[Q] = C[E], C[E] = m, F[0 + p] = M - E + 1, k = (k < 0 ? -k : k) % l, F[I + p] = F[q + k], F[q + k] = p, U[p] = k);
                        }
                        for(F[R + m] = V, z = i(z + (c = Math.max(c, V)), c, F, L, l), _ = Y; _ < K; _++)if (!(F[P + (p = C[_])] >= 0)) for(p = F[q + (k = U[p])], F[q + k] = -1; -1 !== p && -1 !== F[I + p]; p = F[I + p], z++){
                            for(x = F[0 + p], A = F[j + p], Z = D[p] + 1; Z <= D[p] + x - 1; Z++)F[L + C[Z]] = z;
                            var rt = p;
                            for(d = F[I + p]; -1 !== d;){
                                var nt = F[0 + d] === x && F[j + d] === A;
                                for(Z = D[d] + 1; nt && Z <= D[d] + x - 1; Z++)F[L + C[Z]] !== z && (nt = 0);
                                nt ? (D[d] = Bc(p), F[P + p] += F[P + d], F[P + d] = 0, F[j + d] = -1, d = F[I + d], F[I + rt] = d) : (rt = d, d = F[I + d]);
                            }
                        }
                        for(Z = Y, _ = Y; _ < K; _++)(w = -F[P + (p = C[_])]) <= 0 || (F[P + p] = w, N = F[R + p] + V - w, -1 !== F[B + (N = Math.min(N, l - G - w))] && (U[F[B + N]] = p), F[I + p] = F[B + N], U[p] = -1, F[B + N] = p, H = Math.min(H, N), F[R + p] = N, C[Z++] = p);
                        F[P + m] = $, 0 == (F[0 + m] = Z - Y) && (D[m] = -1, F[L + m] = 0), 0 !== W && (O = Z);
                    }
                    for(p = 0; p < l; p++)D[p] = Bc(D[p]);
                    for(d = 0; d <= l; d++)F[B + d] = -1;
                    for(d = l; d >= 0; d--)F[P + d] > 0 || (F[I + d] = F[B + D[d]], F[B + D[d]] = d);
                    for(v = l; v >= 0; v--)F[P + v] <= 0 || -1 !== D[v] && (F[I + v] = F[B + D[v]], F[B + D[v]] = v);
                    for(m = 0, p = 0; p <= l; p++)-1 === D[p] && (m = Ic(p, m, F, B, I, T, L));
                    return T.splice(T.length - 1, 1), T;
                };
                function i(t, e, r, n, i) {
                    if (t < 2 || t + e < 0) {
                        for(var o = 0; o < i; o++)0 !== r[n + o] && (r[n + o] = 1);
                        t = 2;
                    }
                    return t;
                }
                function o(t, e) {
                    return t !== e;
                }
            });
            function Rc(t, e, r, n, i, o, a) {
                var s, u, l, c = 0;
                if (t <= e || r[n + e] <= r[i + t]) return -1;
                r[i + t] = r[n + e];
                var f = r[o + t];
                if (r[o + t] = e, -1 === f) c = 1, l = t;
                else {
                    for(c = 2, l = f; l !== r[a + l]; l = r[a + l]);
                    for(s = f; s !== l; s = u)u = r[a + s], r[a + s] = l;
                }
                return {
                    jleaf: c,
                    q: l
                };
            }
            var Lc = ge("csCounts", [
                "transpose"
            ], (t)=>{
                var { transpose: e } = t;
                return function(t, r, n, i) {
                    if (!t || !r || !n) return null;
                    var o, a, s, u, l, c, f, h = t._size, p = h[0], d = h[1], m = 4 * d + (i ? d + p + 1 : 0), y = [], g = d, v = 2 * d, b = 3 * d, x = 4 * d, w = 5 * d + 1;
                    for(s = 0; s < m; s++)y[s] = -1;
                    var _ = [], A = e(t), E = A._index, S = A._ptr;
                    for(s = 0; s < d; s++)for(_[a = n[s]] = -1 === y[b + a] ? 1 : 0; -1 !== a && -1 === y[b + a]; a = r[a])y[b + a] = s;
                    if (i) {
                        for(s = 0; s < d; s++)y[n[s]] = s;
                        for(o = 0; o < p; o++){
                            for(s = d, c = S[o], f = S[o + 1], l = c; l < f; l++)s = Math.min(s, y[E[l]]);
                            y[w + o] = y[x + s], y[x + s] = o;
                        }
                    }
                    for(o = 0; o < d; o++)y[0 + o] = o;
                    for(s = 0; s < d; s++){
                        for(-1 !== r[a = n[s]] && _[r[a]]--, u = i ? y[x + s] : a; -1 !== u; u = i ? y[w + u] : -1)for(l = S[u]; l < S[u + 1]; l++){
                            var M = Rc(o = E[l], a, y, b, g, v, 0);
                            M.jleaf >= 1 && _[a]++, 2 === M.jleaf && _[M.q]--;
                        }
                        -1 !== r[a] && (y[0 + a] = r[a]);
                    }
                    for(a = 0; a < d; a++)-1 !== r[a] && (_[r[a]] += _[a]);
                    return _;
                };
            }), qc = ge("csSqr", [
                "add",
                "multiply",
                "transpose"
            ], (t)=>{
                var { add: e, multiply: r, transpose: n } = t, i = jc({
                    add: e,
                    multiply: r,
                    transpose: n
                }), o = Lc({
                    transpose: n
                });
                return function(t, e, r) {
                    var n, a = e._ptr, s = e._size[1], u = {};
                    if (u.q = i(t, e), t && !u.q) return null;
                    if (r) {
                        var l = t ? function(t, e, r, n) {
                            for(var i = t._values, o = t._index, a = t._ptr, s = t._size, u = t._datatype, l = s[0], c = s[1], f = n && t._values ? [] : null, h = [], p = [], d = 0, m = 0; m < c; m++){
                                p[m] = d;
                                for(var y = r ? r[m] : m, g = a[y], v = a[y + 1], b = g; b < v; b++){
                                    var x = e ? e[o[b]] : o[b];
                                    h[d] = x, f && (f[d] = i[b]), d++;
                                }
                            }
                            return p[c] = d, t.createSparseMatrix({
                                values: f,
                                index: h,
                                ptr: p,
                                size: [
                                    l,
                                    c
                                ],
                                datatype: u
                            });
                        }(e, null, u.q, 0) : e;
                        u.parent = function(t, e) {
                            if (!t) return null;
                            var r, n, i = t._index, o = t._ptr, a = t._size, s = a[0], u = a[1], l = [], c = [], f = u;
                            if (e) for(r = 0; r < s; r++)c[f + r] = -1;
                            for(var h = 0; h < u; h++){
                                l[h] = -1, c[0 + h] = -1;
                                for(var p = o[h], d = o[h + 1], m = p; m < d; m++){
                                    var y = i[m];
                                    for(r = e ? c[f + y] : y; -1 !== r && r < h; r = n)n = c[0 + r], c[0 + r] = h, -1 === n && (l[r] = h);
                                    e && (c[f + y] = h);
                                }
                            }
                            return l;
                        }(l, 1);
                        var c = function(t, e) {
                            if (!t) return null;
                            var r, n = 0, i = [], o = [], a = e, s = 2 * e;
                            for(r = 0; r < e; r++)o[0 + r] = -1;
                            for(r = e - 1; r >= 0; r--)-1 !== t[r] && (o[a + r] = o[0 + t[r]], o[0 + t[r]] = r);
                            for(r = 0; r < e; r++)-1 === t[r] && (n = Ic(r, n, o, 0, a, i, s));
                            return i;
                        }(u.parent, s);
                        if (u.cp = o(l, u.parent, c, 1), l && u.parent && u.cp && function(t, e) {
                            var r = t._ptr, n = t._index, i = t._size, o = i[0], a = i[1];
                            e.pinv = [], e.leftmost = [];
                            var s, u, l, c, f, h = e.parent, p = e.pinv, d = e.leftmost, m = [], y = o, g = o + a, v = o + 2 * a;
                            for(u = 0; u < a; u++)m[y + u] = -1, m[g + u] = -1, m[v + u] = 0;
                            for(s = 0; s < o; s++)d[s] = -1;
                            for(u = a - 1; u >= 0; u--)for(c = r[u], f = r[u + 1], l = c; l < f; l++)d[n[l]] = u;
                            for(s = o - 1; s >= 0; s--)p[s] = -1, -1 !== (u = d[s]) && (0 == m[v + u]++ && (m[g + u] = s), m[0 + s] = m[y + u], m[y + u] = s);
                            for(e.lnz = 0, e.m2 = o, u = 0; u < a; u++)if (s = m[y + u], e.lnz++, s < 0 && (s = e.m2++), p[s] = u, !(--v[u] <= 0)) {
                                e.lnz += m[v + u];
                                var b = h[u];
                                -1 !== b && (0 === m[v + b] && (m[g + b] = m[g + u]), m[0 + m[g + u]] = m[y + b], m[y + b] = m[0 + s], m[v + b] += m[v + u]);
                            }
                            for(s = 0; s < o; s++)p[s] < 0 && (p[s] = u++);
                            return !0;
                        }(l, u)) for(u.unz = 0, n = 0; n < s; n++)u.unz += u.cp[n];
                    } else u.unz = 4 * a[s] + s, u.lnz = u.unz;
                    return u;
                };
            });
            function Uc(t, e) {
                return t[e] < 0;
            }
            function zc(t, e) {
                t[e] = Bc(t[e]);
            }
            function Gc(t) {
                return t < 0 ? Bc(t) : t;
            }
            function Hc(t, e, r, n, i) {
                var o, a, s, u = e._index, l = e._ptr, c = e._size[1], f = 0;
                for(n[0] = t; f >= 0;){
                    t = n[f];
                    var h = i ? i[t] : t;
                    Uc(l, t) || (zc(l, t), n[c + f] = h < 0 ? 0 : Gc(l[h]));
                    var p = 1;
                    for(a = n[c + f], s = h < 0 ? 0 : Gc(l[h + 1]); a < s; a++)if (!Uc(l, o = u[a])) {
                        n[c + f] = a, n[++f] = o, p = 0;
                        break;
                    }
                    p && (f--, n[--r] = t);
                }
                return r;
            }
            var Wc = ge("csSpsolve", [
                "divideScalar",
                "multiply",
                "subtract"
            ], (t)=>{
                var { divideScalar: e, multiply: r, subtract: n } = t;
                return function(t, i, o, a, s, u, l) {
                    var c, f, h, p, d = t._values, m = t._index, y = t._ptr, g = t._size[1], v = i._values, b = i._index, x = i._ptr, w = function(t, e, r, n, i) {
                        var o, a, s, u = t._ptr, l = t._size, c = e._index, f = e._ptr, h = l[1], p = h;
                        for(a = f[r], s = f[r + 1], o = a; o < s; o++){
                            var d = c[o];
                            Uc(u, d) || (p = Hc(d, t, p, n, i));
                        }
                        for(o = p; o < h; o++)zc(u, n[o]);
                        return p;
                    }(t, i, o, a, u);
                    for(c = w; c < g; c++)s[a[c]] = 0;
                    for(f = x[o], h = x[o + 1], c = f; c < h; c++)s[b[c]] = v[c];
                    for(var _ = w; _ < g; _++){
                        var A = a[_], E = u ? u[A] : A;
                        if (!(E < 0)) for(f = y[E], h = y[E + 1], s[A] = e(s[A], d[l ? f : h - 1]), c = l ? f + 1 : f, p = l ? h : h - 1; c < p; c++){
                            var S = m[c];
                            s[S] = n(s[S], r(d[c], s[A]));
                        }
                    }
                    return w;
                };
            }), $c = ge("csLu", [
                "abs",
                "divideScalar",
                "multiply",
                "subtract",
                "larger",
                "largerEq",
                "SparseMatrix"
            ], (t)=>{
                var { abs: e, divideScalar: r, multiply: n, subtract: i, larger: o, largerEq: a, SparseMatrix: s } = t, u = Wc({
                    divideScalar: r,
                    multiply: n,
                    subtract: i
                });
                return function(t, i, l) {
                    if (!t) return null;
                    var c, f = t._size[1], h = 100, p = 100;
                    i && (c = i.q, h = i.lnz || h, p = i.unz || p);
                    var d, m, y = [], g = [], v = [], b = new s({
                        values: y,
                        index: g,
                        ptr: v,
                        size: [
                            f,
                            f
                        ]
                    }), x = [], w = [], _ = [], A = new s({
                        values: x,
                        index: w,
                        ptr: _,
                        size: [
                            f,
                            f
                        ]
                    }), E = [], S = [], M = [];
                    for(d = 0; d < f; d++)S[d] = 0, E[d] = -1, v[d + 1] = 0;
                    h = 0, p = 0;
                    for(var k = 0; k < f; k++){
                        v[k] = h, _[k] = p;
                        var N = c ? c[k] : k, C = u(b, t, N, M, S, E, 1), D = -1, O = -1;
                        for(m = C; m < f; m++)if (E[d = M[m]] < 0) {
                            var T = e(S[d]);
                            o(T, O) && (O = T, D = d);
                        } else w[p] = E[d], x[p++] = S[d];
                        if (-1 === D || O <= 0) return null;
                        E[N] < 0 && a(e(S[N]), n(O, l)) && (D = N);
                        var F = S[D];
                        for(w[p] = k, x[p++] = F, E[D] = k, g[h] = D, y[h++] = 1, m = C; m < f; m++)E[d = M[m]] < 0 && (g[h] = d, y[h++] = r(S[d], F)), S[d] = 0;
                    }
                    for(v[f] = h, _[f] = p, m = 0; m < h; m++)g[m] = E[g[m]];
                    return y.splice(h, y.length - h), g.splice(h, g.length - h), x.splice(p, x.length - p), w.splice(p, w.length - p), {
                        L: b,
                        U: A,
                        pinv: E
                    };
                };
            }), Vc = ge("slu", [
                "typed",
                "abs",
                "add",
                "multiply",
                "transpose",
                "divideScalar",
                "subtract",
                "larger",
                "largerEq",
                "SparseMatrix"
            ], (t)=>{
                var { typed: e, abs: r, add: n, multiply: i, transpose: o, divideScalar: a, subtract: s, larger: u, largerEq: l, SparseMatrix: c } = t, f = qc({
                    add: n,
                    multiply: i,
                    transpose: o
                }), h = $c({
                    abs: r,
                    divideScalar: a,
                    multiply: i,
                    subtract: s,
                    larger: u,
                    largerEq: l,
                    SparseMatrix: c
                });
                return e("slu", {
                    "SparseMatrix, number, number": function(t, e, r) {
                        if (!pt(e) || e < 0 || e > 3) throw new Error("Symbolic Ordering and Analysis order must be an integer number in the interval [0, 3]");
                        if (r < 0 || r > 1) throw new Error("Partial pivoting threshold must be a number from 0 to 1");
                        var n = f(e, t, !1), i = h(t, n, r);
                        return {
                            L: i.L,
                            U: i.U,
                            p: i.pinv,
                            q: n.q,
                            toString: function() {
                                return "L: " + this.L.toString() + "\nU: " + this.U.toString() + "\np: " + this.p.toString() + (this.q ? "\nq: " + this.q.toString() : "") + "\n";
                            }
                        };
                    }
                });
            }), Zc = ge("trace", [
                "typed",
                "matrix",
                "add"
            ], (t)=>{
                var { typed: e, matrix: r, add: n } = t;
                return e("trace", {
                    Array: function(t) {
                        return i(r(t));
                    },
                    SparseMatrix: function(t) {
                        var e = t._values, r = t._index, i = t._ptr, o = t._size, a = o[0], s = o[1];
                        if (a === s) {
                            var u = 0;
                            if (e.length > 0) for(var l = 0; l < s; l++)for(var c = i[l], f = i[l + 1], h = c; h < f; h++){
                                var p = r[h];
                                if (p === l) {
                                    u = n(u, e[h]);
                                    break;
                                }
                                if (p > l) break;
                            }
                            return u;
                        }
                        throw new RangeError("Matrix must be square (size: " + Lt(o) + ")");
                    },
                    DenseMatrix: i,
                    any: it
                });
                function i(t) {
                    var e = t._size, r = t._data;
                    switch(e.length){
                        case 1:
                            if (1 === e[0]) return it(r[0]);
                            throw new RangeError("Matrix must be square (size: " + Lt(e) + ")");
                        case 2:
                            var i = e[0];
                            if (i === e[1]) {
                                for(var o = 0, a = 0; a < i; a++)o = n(o, r[a][a]);
                                return o;
                            }
                            throw new RangeError("Matrix must be square (size: " + Lt(e) + ")");
                        default:
                            throw new RangeError("Matrix must be two dimensional (size: " + Lt(e) + ")");
                    }
                }
            }), Yc = ge("usolveAll", [
                "typed",
                "matrix",
                "divideScalar",
                "multiplyScalar",
                "subtractScalar",
                "equalScalar",
                "DenseMatrix"
            ], (t)=>{
                var { typed: e, matrix: r, divideScalar: n, multiplyScalar: i, subtractScalar: o, equalScalar: a, DenseMatrix: s } = t, u = Dl({
                    DenseMatrix: s
                });
                return e("usolveAll", {
                    "SparseMatrix, Array | Matrix": function(t, e) {
                        return function(t, e) {
                            for(var r = [
                                u(t, e, !0)._data.map((t)=>t[0])
                            ], l = t._size[0], c = t._size[1], f = t._values, h = t._index, p = t._ptr, d = c - 1; d >= 0; d--)for(var m = r.length, y = 0; y < m; y++){
                                for(var g = r[y], v = [], b = [], x = p[d], w = p[d + 1], _ = 0, A = w - 1; A >= x; A--){
                                    var E = h[A];
                                    E === d ? _ = f[A] : E < d && (v.push(f[A]), b.push(E));
                                }
                                if (a(_, 0)) {
                                    if (a(g[d], 0)) {
                                        if (0 === y) {
                                            var S = [
                                                ...g
                                            ];
                                            S[d] = 1;
                                            for(var M = 0, k = b.length; M < k; M++){
                                                var N = b[M];
                                                S[N] = o(S[N], v[M]);
                                            }
                                            r.push(S);
                                        }
                                    } else {
                                        if (0 === y) return [];
                                        r.splice(y, 1), y -= 1, m -= 1;
                                    }
                                } else {
                                    g[d] = n(g[d], _);
                                    for(var C = 0, D = b.length; C < D; C++){
                                        var O = b[C];
                                        g[O] = o(g[O], i(g[d], v[C]));
                                    }
                                }
                            }
                            return r.map((t)=>new s({
                                    data: t.map((t)=>[
                                            t
                                        ]),
                                    size: [
                                        l,
                                        1
                                    ]
                                }));
                        }(t, e);
                    },
                    "DenseMatrix, Array | Matrix": function(t, e) {
                        return l(t, e);
                    },
                    "Array, Array | Matrix": function(t, e) {
                        return l(r(t), e).map((t)=>t.valueOf());
                    }
                });
                function l(t, e) {
                    for(var r = [
                        u(t, e, !0)._data.map((t)=>t[0])
                    ], l = t._data, c = t._size[0], f = t._size[1] - 1; f >= 0; f--)for(var h = r.length, p = 0; p < h; p++){
                        var d = r[p];
                        if (a(l[f][f], 0)) {
                            if (a(d[f], 0)) {
                                if (0 === p) {
                                    var m = [
                                        ...d
                                    ];
                                    m[f] = 1;
                                    for(var y = f - 1; y >= 0; y--)m[y] = o(m[y], l[y][f]);
                                    r.push(m);
                                }
                            } else {
                                if (0 === p) return [];
                                r.splice(p, 1), p -= 1, h -= 1;
                            }
                        } else {
                            d[f] = n(d[f], l[f][f]);
                            for(var g = f - 1; g >= 0; g--)d[g] = o(d[g], i(d[f], l[g][f]));
                        }
                    }
                    return r.map((t)=>new s({
                            data: t.map((t)=>[
                                    t
                                ]),
                            size: [
                                c,
                                1
                            ]
                        }));
                }
            }), Kc = ge("zpk2tf", [
                "typed",
                "add",
                "multiply",
                "Complex",
                "number"
            ], (t)=>{
                var { typed: e, add: r, multiply: n, Complex: i, number: o } = t;
                return e("zpk2tf", {
                    "Array,Array,number": function(t, e, r) {
                        return a(t, e, r);
                    },
                    "Array,Array": function(t, e) {
                        return a(t, e, 1);
                    },
                    "Matrix,Matrix,number": function(t, e, r) {
                        return a(t.valueOf(), e.valueOf(), r);
                    },
                    "Matrix,Matrix": function(t, e) {
                        return a(t.valueOf(), e.valueOf(), 1);
                    }
                });
                function a(t, e, r) {
                    t.some((t)=>"BigNumber" === t.type) && (t = t.map((t)=>o(t))), e.some((t)=>"BigNumber" === t.type) && (e = e.map((t)=>o(t)));
                    for(var a = [
                        i(1, 0)
                    ], u = [
                        i(1, 0)
                    ], l = 0; l < t.length; l++){
                        var c = t[l];
                        "number" == typeof c && (c = i(c, 0)), a = s(a, [
                            i(1, 0),
                            i(-c.re, -c.im)
                        ]);
                    }
                    for(var f = 0; f < e.length; f++){
                        var h = e[f];
                        "number" == typeof h && (h = i(h, 0)), u = s(u, [
                            i(1, 0),
                            i(-h.re, -h.im)
                        ]);
                    }
                    for(var p = 0; p < a.length; p++)a[p] = n(a[p], r);
                    return [
                        a,
                        u
                    ];
                }
                function s(t, e) {
                    for(var o = [], a = 0; a < t.length + e.length - 1; a++){
                        o[a] = i(0, 0);
                        for(var s = 0; s < t.length; s++)a - s >= 0 && a - s < e.length && (o[a] = r(o[a], n(t[s], e[a - s])));
                    }
                    return o;
                }
            }), Xc = ge("bitOr", [
                "typed",
                "matrix",
                "equalScalar",
                "DenseMatrix",
                "concat"
            ], (t)=>{
                var { typed: e, matrix: r, equalScalar: n, DenseMatrix: i, concat: o } = t, a = Sl({
                    typed: e
                }), s = Xl({
                    typed: e,
                    equalScalar: n
                }), u = Ml({
                    typed: e,
                    DenseMatrix: i
                });
                return e("bitOr", {
                    "number, number": Ya,
                    "BigNumber, BigNumber": qa
                }, ml({
                    typed: e,
                    matrix: r,
                    concat: o
                })({
                    SS: s,
                    DS: a,
                    Ss: u
                }));
            }), Jc = [
                "typed",
                "config",
                "round",
                "matrix",
                "equalScalar",
                "zeros",
                "DenseMatrix"
            ], Qc = ge("ceil", [
                "typed",
                "config",
                "round"
            ], (t)=>{
                var { typed: e, config: r, round: n } = t;
                return e("ceil", {
                    number: function(t) {
                        return Nt(t, n(t), r.epsilon) ? n(t) : Math.ceil(t);
                    },
                    "number, number": function(t, e) {
                        if (Nt(t, n(t, e), r.epsilon)) return n(t, e);
                        var [i, o] = "".concat(t, "e").split("e"), a = Math.ceil(Number("".concat(i, "e").concat(Number(o) + e)));
                        return [i, o] = "".concat(a, "e").split("e"), Number("".concat(i, "e").concat(Number(o) - e));
                    }
                });
            }), tf = ge("ceil", Jc, (t)=>{
                var { typed: e, config: r, round: n, matrix: i, equalScalar: o, zeros: a, DenseMatrix: s } = t, u = cl({
                    typed: e,
                    equalScalar: o
                }), l = fl({
                    typed: e,
                    DenseMatrix: s
                }), c = pl({
                    typed: e
                }), f = Qc({
                    typed: e,
                    config: r,
                    round: n
                });
                return e("ceil", {
                    number: f.signatures.number,
                    "number,number": f.signatures["number,number"],
                    Complex: function(t) {
                        return t.ceil();
                    },
                    "Complex, number": function(t, e) {
                        return t.ceil(e);
                    },
                    "Complex, BigNumber": function(t, e) {
                        return t.ceil(e.toNumber());
                    },
                    BigNumber: function(t) {
                        return ds(t, n(t), r.epsilon) ? n(t) : t.ceil();
                    },
                    "BigNumber, BigNumber": function(t, e) {
                        return ds(t, n(t, e), r.epsilon) ? n(t, e) : t.toDecimalPlaces(e.toNumber(), Qn.a.ROUND_CEIL);
                    },
                    Fraction: function(t) {
                        return t.ceil();
                    },
                    "Fraction, number": function(t, e) {
                        return t.ceil(e);
                    },
                    "Fraction, BigNumber": function(t, e) {
                        return t.ceil(e.toNumber());
                    },
                    "Array | Matrix": e.referToSelf((t)=>(e)=>vr(e, t, !0)),
                    "Array, number | BigNumber": e.referToSelf((t)=>(e, r)=>vr(e, (e)=>t(e, r), !0)),
                    "SparseMatrix, number | BigNumber": e.referToSelf((t)=>(e, r)=>u(e, r, t, !1)),
                    "DenseMatrix, number | BigNumber": e.referToSelf((t)=>(e, r)=>c(e, r, t, !1)),
                    "number | Complex | Fraction | BigNumber, Array": e.referToSelf((t)=>(e, r)=>c(i(r), e, t, !0).valueOf()),
                    "number | Complex | Fraction | BigNumber, Matrix": e.referToSelf((t)=>(e, r)=>o(e, 0) ? a(r.size(), r.storage()) : "dense" === r.storage() ? c(r, e, t, !0) : l(r, e, t, !0))
                });
            }), ef = r(35), rf = r.n(ef), nf = ge("compareNatural", [
                "typed",
                "compare"
            ], (t)=>{
                var { typed: e, compare: r } = t, n = r.signatures["boolean,boolean"];
                return e("compareNatural", {
                    "any, any": function t(e, o) {
                        var a, s = nt(e), u = nt(o);
                        if (!("number" !== s && "BigNumber" !== s && "Fraction" !== s || "number" !== u && "BigNumber" !== u && "Fraction" !== u)) return "0" !== (a = r(e, o)).toString() ? a > 0 ? 1 : -1 : rf()(s, u);
                        var l = [
                            "Array",
                            "DenseMatrix",
                            "SparseMatrix"
                        ];
                        if (l.includes(s) || l.includes(u)) return 0 !== (a = function t(e, r, n) {
                            if (k(r) && k(n)) return i(e, r.toJSON().values, n.toJSON().values);
                            if (k(r)) return t(e, r.toArray(), n);
                            if (k(n)) return t(e, r, n.toArray());
                            if (M(r)) return t(e, r.toJSON().data, n);
                            if (M(n)) return t(e, r, n.toJSON().data);
                            if (!Array.isArray(r)) return t(e, [
                                r
                            ], n);
                            if (!Array.isArray(n)) return t(e, r, [
                                n
                            ]);
                            return i(e, r, n);
                        }(t, e, o)) ? a : rf()(s, u);
                        if (s !== u) return rf()(s, u);
                        if ("Complex" === s) return function(t, e) {
                            if (t.re > e.re) return 1;
                            if (t.re < e.re) return -1;
                            if (t.im > e.im) return 1;
                            if (t.im < e.im) return -1;
                            return 0;
                        }(e, o);
                        if ("Unit" === s) return e.equalBase(o) ? t(e.value, o.value) : i(t, e.formatUnits(), o.formatUnits());
                        if ("boolean" === s) return n(e, o);
                        if ("string" === s) return rf()(e, o);
                        if ("Object" === s) return function(t, e, r) {
                            var n = Object.keys(e), o = Object.keys(r);
                            n.sort(rf.a), o.sort(rf.a);
                            var a = i(t, n, o);
                            if (0 !== a) return a;
                            for(var s = 0; s < n.length; s++){
                                var u = t(e[n[s]], r[o[s]]);
                                if (0 !== u) return u;
                            }
                            return 0;
                        }(t, e, o);
                        if ("null" === s) return 0;
                        if ("undefined" === s) return 0;
                        throw new TypeError('Unsupported type of value "' + s + '"');
                    }
                });
                function i(t, e, r) {
                    for(var n = 0, i = Math.min(e.length, r.length); n < i; n++){
                        var o = t(e[n], r[n]);
                        if (0 !== o) return o;
                    }
                    return e.length > r.length ? 1 : e.length < r.length ? -1 : 0;
                }
            });
            var of = ge("composition", [
                "typed",
                "addScalar",
                "combinations",
                "isNegative",
                "isPositive",
                "isInteger",
                "larger"
            ], (t)=>{
                var { typed: e, addScalar: r, combinations: n, isPositive: i, isNegative: o, isInteger: a, larger: s } = t;
                return e("composition", {
                    "number | BigNumber, number | BigNumber": function(t, e) {
                        if (!(a(t) && i(t) && a(e) && i(e))) throw new TypeError("Positive integer value expected in function composition");
                        if (s(e, t)) throw new TypeError("k must be less than or equal to n in function composition");
                        return n(r(t, -1), r(e, -1));
                    }
                });
            }), af = ge("cross", [
                "typed",
                "matrix",
                "subtract",
                "multiply"
            ], (t)=>{
                var { typed: e, matrix: r, subtract: n, multiply: i } = t;
                return e("cross", {
                    "Matrix, Matrix": function(t, e) {
                        return r(o(t.toArray(), e.toArray()));
                    },
                    "Matrix, Array": function(t, e) {
                        return r(o(t.toArray(), e));
                    },
                    "Array, Matrix": function(t, e) {
                        return r(o(t, e.toArray()));
                    },
                    "Array, Array": o
                });
                function o(t, e) {
                    var r = Math.max($t(t).length, $t(e).length);
                    t = ee(t), e = ee(e);
                    var o = $t(t), a = $t(e);
                    if (1 !== o.length || 1 !== a.length || 3 !== o[0] || 3 !== a[0]) throw new RangeError("Vectors with length 3 expected (Size A = [" + o.join(", ") + "], B = [" + a.join(", ") + "])");
                    var s = [
                        n(i(t[1], e[2]), i(t[2], e[1])),
                        n(i(t[2], e[0]), i(t[0], e[2])),
                        n(i(t[0], e[1]), i(t[1], e[0]))
                    ];
                    return r > 1 ? [
                        s
                    ] : s;
                }
            }), sf = ge("det", [
                "typed",
                "matrix",
                "subtractScalar",
                "multiply",
                "divideScalar",
                "isZero",
                "unaryMinus"
            ], (t)=>{
                var { typed: e, matrix: r, subtractScalar: n, multiply: i, divideScalar: o, isZero: a, unaryMinus: s } = t;
                return e("det", {
                    any: function(t) {
                        return it(t);
                    },
                    "Array | Matrix": function(t) {
                        var e;
                        switch((e = E(t) ? t.size() : Array.isArray(t) ? (t = r(t)).size() : []).length){
                            case 0:
                                return it(t);
                            case 1:
                                if (1 === e[0]) return it(t.valueOf()[0]);
                                if (0 === e[0]) return 1;
                                throw new RangeError("Matrix must be square (size: " + Lt(e) + ")");
                            case 2:
                                var u = e[0], l = e[1];
                                if (u === l) return function(t, e, r) {
                                    if (1 === e) return it(t[0][0]);
                                    if (2 === e) return n(i(t[0][0], t[1][1]), i(t[1][0], t[0][1]));
                                    for(var u = !1, l = new Array(e).fill(0).map((t, e)=>e), c = 0; c < e; c++){
                                        var f = l[c];
                                        if (a(t[f][c])) {
                                            var h = void 0;
                                            for(h = c + 1; h < e; h++)if (!a(t[l[h]][c])) {
                                                f = l[h], l[h] = l[c], l[c] = f, u = !u;
                                                break;
                                            }
                                            if (h === e) return t[f][c];
                                        }
                                        for(var p = t[f][c], d = 0 === c ? 1 : t[l[c - 1]][c - 1], m = c + 1; m < e; m++)for(var y = l[m], g = c + 1; g < e; g++)t[y][g] = o(n(i(t[y][g], p), i(t[y][c], t[f][g])), d);
                                    }
                                    var v = t[l[e - 1]][e - 1];
                                    return u ? s(v) : v;
                                }(t.clone().valueOf(), u);
                                if (0 === l) return 1;
                                throw new RangeError("Matrix must be square (size: " + Lt(e) + ")");
                            default:
                                throw new RangeError("Matrix must be two dimensional (size: " + Lt(e) + ")");
                        }
                    }
                });
            }), uf = ge("dotMultiply", [
                "typed",
                "matrix",
                "equalScalar",
                "multiplyScalar",
                "concat"
            ], (t)=>{
                var { typed: e, matrix: r, equalScalar: n, multiplyScalar: i, concat: o } = t, a = sl({
                    typed: e,
                    equalScalar: n
                }), s = Ql({
                    typed: e,
                    equalScalar: n
                }), u = cl({
                    typed: e,
                    equalScalar: n
                });
                return e("dotMultiply", ml({
                    typed: e,
                    matrix: r,
                    concat: o
                })({
                    elop: i,
                    SS: s,
                    DS: a,
                    Ss: u
                }));
            }), lf = ge("FibonacciHeap", [
                "smaller",
                "larger"
            ], (t)=>{
                var { smaller: e, larger: r } = t, n = 1 / Math.log((1 + Math.sqrt(5)) / 2);
                function i() {
                    if (!(this instanceof i)) throw new SyntaxError("Constructor must be called with the new operator");
                    this._minimum = null, this._size = 0;
                }
                function o(t, e, r) {
                    e.left.right = e.right, e.right.left = e.left, r.degree--, r.child === e && (r.child = e.right), 0 === r.degree && (r.child = null), e.left = t, e.right = t.right, t.right = e, e.right.left = e, e.parent = null, e.mark = !1;
                }
                i.prototype.type = "FibonacciHeap", i.prototype.isFibonacciHeap = !0, i.prototype.insert = function(t, r) {
                    var n = {
                        key: t,
                        value: r,
                        degree: 0
                    };
                    if (this._minimum) {
                        var i = this._minimum;
                        n.left = i, n.right = i.right, i.right = n, n.right.left = n, e(t, i.key) && (this._minimum = n);
                    } else n.left = n, n.right = n, this._minimum = n;
                    return this._size++, n;
                }, i.prototype.size = function() {
                    return this._size;
                }, i.prototype.clear = function() {
                    this._minimum = null, this._size = 0;
                }, i.prototype.isEmpty = function() {
                    return 0 === this._size;
                }, i.prototype.extractMinimum = function() {
                    var t = this._minimum;
                    if (null === t) return t;
                    for(var i = this._minimum, o = t.degree, s = t.child; o > 0;){
                        var u = s.right;
                        s.left.right = s.right, s.right.left = s.left, s.left = i, s.right = i.right, i.right = s, s.right.left = s, s.parent = null, s = u, o--;
                    }
                    return t.left.right = t.right, t.right.left = t.left, i = t === t.right ? null : function(t, i) {
                        var o, s = Math.floor(Math.log(i) * n) + 1, u = new Array(s), l = 0, c = t;
                        if (c) for(l++, c = c.right; c !== t;)l++, c = c.right;
                        for(; l > 0;){
                            for(var f = c.degree, h = c.right; o = u[f];){
                                if (r(c.key, o.key)) {
                                    var p = o;
                                    o = c, c = p;
                                }
                                a(o, c), u[f] = null, f++;
                            }
                            u[f] = c, c = h, l--;
                        }
                        t = null;
                        for(var d = 0; d < s; d++)(o = u[d]) && (t ? (o.left.right = o.right, o.right.left = o.left, o.left = t, o.right = t.right, t.right = o, o.right.left = o, e(o.key, t.key) && (t = o)) : t = o);
                        return t;
                    }(i = t.right, this._size), this._size--, this._minimum = i, t;
                }, i.prototype.remove = function(t) {
                    this._minimum = function(t, r, n) {
                        r.key = n;
                        var i = r.parent;
                        i && e(r.key, i.key) && (o(t, r, i), function t(e, r) {
                            var n = r.parent;
                            if (!n) return;
                            r.mark ? (o(e, r, n), t(n)) : r.mark = !0;
                        }(t, i));
                        e(r.key, t.key) && (t = r);
                        return t;
                    }(this._minimum, t, -1), this.extractMinimum();
                };
                var a = function(t, e) {
                    t.left.right = t.right, t.right.left = t.left, t.parent = e, e.child ? (t.left = e.child, t.right = e.child.right, e.child.right = t, t.right.left = t) : (e.child = t, t.right = t, t.left = t), e.degree++, t.mark = !1;
                };
                return i;
            }, {
                isClass: !0
            }), cf = [
                "typed",
                "Complex",
                "matrix",
                "ceil",
                "floor",
                "equalScalar",
                "zeros",
                "DenseMatrix"
            ], ff = ge("fix", [
                "typed",
                "ceil",
                "floor"
            ], (t)=>{
                var { typed: e, ceil: r, floor: n } = t;
                return e("fix", {
                    number: function(t) {
                        return t > 0 ? n(t) : r(t);
                    },
                    "number, number": function(t, e) {
                        return t > 0 ? n(t, e) : r(t, e);
                    }
                });
            }), hf = ge("fix", cf, (t)=>{
                var { typed: e, Complex: r, matrix: n, ceil: i, floor: o, equalScalar: a, zeros: s, DenseMatrix: u } = t, l = fl({
                    typed: e,
                    DenseMatrix: u
                }), c = pl({
                    typed: e
                }), f = ff({
                    typed: e,
                    ceil: i,
                    floor: o
                });
                return e("fix", {
                    number: f.signatures.number,
                    "number, number | BigNumber": f.signatures["number,number"],
                    Complex: function(t) {
                        return new r(t.re > 0 ? Math.floor(t.re) : Math.ceil(t.re), t.im > 0 ? Math.floor(t.im) : Math.ceil(t.im));
                    },
                    "Complex, number": function(t, e) {
                        return new r(t.re > 0 ? o(t.re, e) : i(t.re, e), t.im > 0 ? o(t.im, e) : i(t.im, e));
                    },
                    "Complex, BigNumber": function(t, e) {
                        var n = e.toNumber();
                        return new r(t.re > 0 ? o(t.re, n) : i(t.re, n), t.im > 0 ? o(t.im, n) : i(t.im, n));
                    },
                    BigNumber: function(t) {
                        return t.isNegative() ? i(t) : o(t);
                    },
                    "BigNumber, number | BigNumber": function(t, e) {
                        return t.isNegative() ? i(t, e) : o(t, e);
                    },
                    Fraction: function(t) {
                        return t.s < 0 ? t.ceil() : t.floor();
                    },
                    "Fraction, number | BigNumber": function(t, e) {
                        return t.s < 0 ? i(t, e) : o(t, e);
                    },
                    "Array | Matrix": e.referToSelf((t)=>(e)=>vr(e, t, !0)),
                    "Array | Matrix, number | BigNumber": e.referToSelf((t)=>(e, r)=>vr(e, (e)=>t(e, r), !0)),
                    "number | Complex | Fraction | BigNumber, Array": e.referToSelf((t)=>(e, r)=>c(n(r), e, t, !0).valueOf()),
                    "number | Complex | Fraction | BigNumber, Matrix": e.referToSelf((t)=>(e, r)=>a(e, 0) ? s(r.size(), r.storage()) : "dense" === r.storage() ? c(r, e, t, !0) : l(r, e, t, !0))
                });
            }), pf = ge("index", [
                "typed",
                "Index"
            ], (t)=>{
                var { typed: e, Index: r } = t;
                return e("index", {
                    "...number | string | BigNumber | Range | Array | Matrix": function(t) {
                        var e = t.map(function(t) {
                            return v(t) ? t.toNumber() : A(t) || E(t) ? t.map(function(t) {
                                return v(t) ? t.toNumber() : t;
                            }) : t;
                        }), n = new r;
                        return r.apply(n, e), n;
                    }
                });
            }), df = ge("intersect", [
                "typed",
                "config",
                "abs",
                "add",
                "addScalar",
                "matrix",
                "multiply",
                "multiplyScalar",
                "divideScalar",
                "subtract",
                "smaller",
                "equalScalar",
                "flatten",
                "isZero",
                "isNumeric"
            ], (t)=>{
                var { typed: e, config: r, abs: n, add: i, addScalar: o, matrix: a, multiply: s, multiplyScalar: u, divideScalar: l, subtract: c, smaller: f, equalScalar: h, flatten: p, isZero: d, isNumeric: m } = t;
                return e("intersect", {
                    "Array, Array, Array": y,
                    "Array, Array, Array, Array": g,
                    "Matrix, Matrix, Matrix": function(t, e, r) {
                        var n = y(t.valueOf(), e.valueOf(), r.valueOf());
                        return null === n ? null : a(n);
                    },
                    "Matrix, Matrix, Matrix, Matrix": function(t, e, r, n) {
                        var i = g(t.valueOf(), e.valueOf(), r.valueOf(), n.valueOf());
                        return null === i ? null : a(i);
                    }
                });
                function y(t, e, r) {
                    if (t = v(t), e = v(e), r = v(r), !x(t)) throw new TypeError("Array with 3 numbers or BigNumbers expected for first argument");
                    if (!x(e)) throw new TypeError("Array with 3 numbers or BigNumbers expected for second argument");
                    if (!function(t) {
                        return 4 === t.length && m(t[0]) && m(t[1]) && m(t[2]) && m(t[3]);
                    }(r)) throw new TypeError("Array with 4 numbers expected as third argument");
                    return function(t, e, r, n, i, a, s, f, h, p) {
                        var d = u(t, s), m = u(n, s), y = u(e, f), g = u(i, f), v = u(r, h), b = u(a, h), x = c(c(c(p, d), y), v), w = c(c(c(o(o(m, g), b), d), y), v), _ = l(x, w), A = o(t, u(_, c(n, t))), E = o(e, u(_, c(i, e))), S = o(r, u(_, c(a, r)));
                        return [
                            A,
                            E,
                            S
                        ];
                    }(t[0], t[1], t[2], e[0], e[1], e[2], r[0], r[1], r[2], r[3]);
                }
                function g(t, e, a, p) {
                    if (t = v(t), e = v(e), a = v(a), p = v(p), 2 === t.length) {
                        if (!b(t)) throw new TypeError("Array with 2 numbers or BigNumbers expected for first argument");
                        if (!b(e)) throw new TypeError("Array with 2 numbers or BigNumbers expected for second argument");
                        if (!b(a)) throw new TypeError("Array with 2 numbers or BigNumbers expected for third argument");
                        if (!b(p)) throw new TypeError("Array with 2 numbers or BigNumbers expected for fourth argument");
                        return function(t, e, a, h) {
                            var p = t, m = a, y = c(p, e), g = c(m, h), v = c(u(y[0], g[1]), u(g[0], y[1]));
                            if (d(v)) return null;
                            if (f(n(v), r.epsilon)) return null;
                            var b = u(g[0], p[1]), x = u(g[1], p[0]), w = u(g[0], m[1]), _ = u(g[1], m[0]), A = l(o(c(c(b, x), w), _), v);
                            return i(s(y, A), p);
                        }(t, e, a, p);
                    }
                    if (3 === t.length) {
                        if (!x(t)) throw new TypeError("Array with 3 numbers or BigNumbers expected for first argument");
                        if (!x(e)) throw new TypeError("Array with 3 numbers or BigNumbers expected for second argument");
                        if (!x(a)) throw new TypeError("Array with 3 numbers or BigNumbers expected for third argument");
                        if (!x(p)) throw new TypeError("Array with 3 numbers or BigNumbers expected for fourth argument");
                        return function(t, e, r, n, i, a, s, f, p, m, y, g) {
                            var v = w(t, s, m, s, e, f, y, f, r, p, g, p), b = w(m, s, n, t, y, f, i, e, g, p, a, r), x = w(t, s, n, t, e, f, i, e, r, p, a, r), _ = w(m, s, m, s, y, f, y, f, g, p, g, p), A = w(n, t, n, t, i, e, i, e, a, r, a, r), E = c(u(v, b), u(x, _)), S = c(u(A, _), u(b, b));
                            if (d(S)) return null;
                            var M = l(E, S), k = l(o(v, u(M, b)), _), N = o(t, u(M, c(n, t))), C = o(e, u(M, c(i, e))), D = o(r, u(M, c(a, r))), O = o(s, u(k, c(m, s))), T = o(f, u(k, c(y, f))), F = o(p, u(k, c(g, p)));
                            return h(N, O) && h(C, T) && h(D, F) ? [
                                N,
                                C,
                                D
                            ] : null;
                        }(t[0], t[1], t[2], e[0], e[1], e[2], a[0], a[1], a[2], p[0], p[1], p[2]);
                    }
                    throw new TypeError("Arrays with two or thee dimensional points expected");
                }
                function v(t) {
                    return 1 === t.length ? t[0] : t.length > 1 && Array.isArray(t[0]) && t.every((t)=>Array.isArray(t) && 1 === t.length) ? p(t) : t;
                }
                function b(t) {
                    return 2 === t.length && m(t[0]) && m(t[1]);
                }
                function x(t) {
                    return 3 === t.length && m(t[0]) && m(t[1]) && m(t[2]);
                }
                function w(t, e, r, n, i, a, s, l, f, h, p, d) {
                    var m = u(c(t, e), c(r, n)), y = u(c(i, a), c(s, l)), g = u(c(f, h), c(p, d));
                    return o(o(m, y), g);
                }
            }), mf = ge("invmod", [
                "typed",
                "config",
                "BigNumber",
                "xgcd",
                "equal",
                "smaller",
                "mod",
                "add",
                "isInteger"
            ], (t)=>{
                var { typed: e, config: r, BigNumber: n, xgcd: i, equal: o, smaller: a, mod: s, add: u, isInteger: l } = t;
                return e("invmod", {
                    "number, number": c,
                    "BigNumber, BigNumber": c
                });
                function c(t, e) {
                    if (!l(t) || !l(e)) throw new Error("Parameters in function invmod must be integer numbers");
                    if (t = s(t, e), o(e, 0)) throw new Error("Divisor must be non zero");
                    var r = i(t, e);
                    r = r.valueOf();
                    var [c, f] = r;
                    return o(c, n(1)) ? (f = s(f, e), a(f, n(0)) && (f = u(f, e)), f) : NaN;
                }
            }), yf = ge("lcm", [
                "typed",
                "matrix",
                "equalScalar",
                "concat"
            ], (t)=>{
                var { typed: e, matrix: r, equalScalar: n, concat: i } = t, o = sl({
                    typed: e,
                    equalScalar: n
                }), a = Fl({
                    typed: e,
                    equalScalar: n
                }), s = cl({
                    typed: e,
                    equalScalar: n
                }), u = ml({
                    typed: e,
                    matrix: r,
                    concat: i
                }), l = "number | BigNumber | Fraction | Matrix | Array", c = {};
                return c["".concat(l, ", ").concat(l, ", ...").concat(l)] = e.referToSelf((t)=>(e, r, n)=>{
                        for(var i = t(e, r), o = 0; o < n.length; o++)i = t(i, n[o]);
                        return i;
                    }), e("lcm", {
                    "number, number": ea,
                    "BigNumber, BigNumber": function(t, e) {
                        if (!t.isInt() || !e.isInt()) throw new Error("Parameters in function lcm must be integer numbers");
                        if (t.isZero()) return t;
                        if (e.isZero()) return e;
                        var r = t.times(e);
                        for(; !e.isZero();){
                            var n = e;
                            e = t.mod(n), t = n;
                        }
                        return r.div(t).abs();
                    },
                    "Fraction, Fraction": (t, e)=>t.lcm(e)
                }, u({
                    SS: a,
                    DS: o,
                    Ss: s
                }), c);
            }), gf = ge("log1p", [
                "typed",
                "config",
                "divideScalar",
                "log",
                "Complex"
            ], (t)=>{
                var { typed: e, config: r, divideScalar: n, log: i, Complex: o } = t;
                return e("log1p", {
                    number: function(t) {
                        return t >= -1 || r.predictable ? gt(t) : a(new o(t, 0));
                    },
                    Complex: a,
                    BigNumber: function(t) {
                        var e = t.plus(1);
                        return !e.isNegative() || r.predictable ? e.ln() : a(new o(t.toNumber(), 0));
                    },
                    "Array | Matrix": e.referToSelf((t)=>(e)=>vr(e, t)),
                    "any, any": e.referToSelf((t)=>(e, r)=>n(t(e), i(r)))
                });
                function a(t) {
                    var e = t.re + 1;
                    return new o(Math.log(Math.sqrt(e * e + t.im * t.im)), Math.atan2(t.im, e));
                }
            }), vf = ge("setCartesian", [
                "typed",
                "size",
                "subset",
                "compareNatural",
                "Index",
                "DenseMatrix"
            ], (t)=>{
                var { typed: e, size: r, subset: n, compareNatural: i, Index: o, DenseMatrix: a } = t;
                return e("setCartesian", {
                    "Array | Matrix, Array | Matrix": function(t, e) {
                        var s = [];
                        if (0 !== n(r(t), new o(0)) && 0 !== n(r(e), new o(0))) {
                            var u = ne(Array.isArray(t) ? t : t.toArray()).sort(i), l = ne(Array.isArray(e) ? e : e.toArray()).sort(i);
                            s = [];
                            for(var c = 0; c < u.length; c++)for(var f = 0; f < l.length; f++)s.push([
                                u[c],
                                l[f]
                            ]);
                        }
                        return Array.isArray(t) && Array.isArray(e) ? s : new a(s);
                    }
                });
            }), bf = ge("setDistinct", [
                "typed",
                "size",
                "subset",
                "compareNatural",
                "Index",
                "DenseMatrix"
            ], (t)=>{
                var { typed: e, size: r, subset: n, compareNatural: i, Index: o, DenseMatrix: a } = t;
                return e("setDistinct", {
                    "Array | Matrix": function(t) {
                        var e;
                        if (0 === n(r(t), new o(0))) e = [];
                        else {
                            var s = ne(Array.isArray(t) ? t : t.toArray()).sort(i);
                            (e = []).push(s[0]);
                            for(var u = 1; u < s.length; u++)0 !== i(s[u], s[u - 1]) && e.push(s[u]);
                        }
                        return Array.isArray(t) ? e : new a(e);
                    }
                });
            }), xf = ge("setIsSubset", [
                "typed",
                "size",
                "subset",
                "compareNatural",
                "Index"
            ], (t)=>{
                var { typed: e, size: r, subset: n, compareNatural: i, Index: o } = t;
                return e("setIsSubset", {
                    "Array | Matrix, Array | Matrix": function(t, e) {
                        if (0 === n(r(t), new o(0))) return !0;
                        if (0 === n(r(e), new o(0))) return !1;
                        for(var a, s = le(ne(Array.isArray(t) ? t : t.toArray()).sort(i)), u = le(ne(Array.isArray(e) ? e : e.toArray()).sort(i)), l = 0; l < s.length; l++){
                            a = !1;
                            for(var c = 0; c < u.length; c++)if (0 === i(s[l].value, u[c].value) && s[l].identifier === u[c].identifier) {
                                a = !0;
                                break;
                            }
                            if (!1 === a) return !1;
                        }
                        return !0;
                    }
                });
            }), wf = ge("setPowerset", [
                "typed",
                "size",
                "subset",
                "compareNatural",
                "Index"
            ], (t)=>{
                var { typed: e, size: r, subset: n, compareNatural: i, Index: o } = t;
                return e("setPowerset", {
                    "Array | Matrix": function(t) {
                        if (0 === n(r(t), new o(0))) return [];
                        for(var e = ne(Array.isArray(t) ? t : t.toArray()).sort(i), s = [], u = 0; u.toString(2).length <= e.length;)s.push(a(e, u.toString(2).split("").reverse())), u++;
                        return function(t) {
                            for(var e = [], r = t.length - 1; r > 0; r--)for(var n = 0; n < r; n++)t[n].length > t[n + 1].length && (e = t[n], t[n] = t[n + 1], t[n + 1] = e);
                            return t;
                        }(s);
                    }
                });
                function a(t, e) {
                    for(var r = [], n = 0; n < e.length; n++)"1" === e[n] && r.push(t[n]);
                    return r;
                }
            }), _f = ge("smallerEq", [
                "typed",
                "config",
                "matrix",
                "DenseMatrix",
                "concat"
            ], (t)=>{
                var { typed: e, config: r, matrix: n, DenseMatrix: i, concat: o } = t, a = ul({
                    typed: e
                }), s = ll({
                    typed: e,
                    DenseMatrix: i
                }), u = fl({
                    typed: e,
                    DenseMatrix: i
                }), l = ml({
                    typed: e,
                    matrix: n,
                    concat: o
                }), c = ms({
                    typed: e
                });
                return e("smallerEq", Af({
                    typed: e,
                    config: r
                }), {
                    "boolean, boolean": (t, e)=>t <= e,
                    "BigNumber, BigNumber": function(t, e) {
                        return t.lte(e) || ds(t, e, r.epsilon);
                    },
                    "Fraction, Fraction": (t, e)=>1 !== t.compare(e),
                    "Complex, Complex": function() {
                        throw new TypeError("No ordering relation is defined for complex numbers");
                    }
                }, c, l({
                    SS: s,
                    DS: a,
                    Ss: u
                }));
            }), Af = ge("smallerEq", [
                "typed",
                "config"
            ], (t)=>{
                var { typed: e, config: r } = t;
                return e("smallerEq", {
                    "number, number": function(t, e) {
                        return t <= e || Nt(t, e, r.epsilon);
                    }
                });
            }), Ef = ge("sort", [
                "typed",
                "matrix",
                "compare",
                "compareNatural"
            ], (t)=>{
                var { typed: e, matrix: r, compare: n, compareNatural: i } = t, o = n, a = (t, e)=>-n(t, e);
                return e("sort", {
                    Array: function(t) {
                        return u(t), t.sort(o);
                    },
                    Matrix: function(t) {
                        return l(t), r(t.toArray().sort(o), t.storage());
                    },
                    "Array, function": function(t, e) {
                        return u(t), t.sort(e);
                    },
                    "Matrix, function": function(t, e) {
                        return l(t), r(t.toArray().sort(e), t.storage());
                    },
                    "Array, string": function(t, e) {
                        return u(t), t.sort(s(e));
                    },
                    "Matrix, string": function(t, e) {
                        return l(t), r(t.toArray().sort(s(e)), t.storage());
                    }
                });
                function s(t) {
                    if ("asc" === t) return o;
                    if ("desc" === t) return a;
                    if ("natural" === t) return i;
                    throw new Error('String "asc", "desc", or "natural" expected');
                }
                function u(t) {
                    if (1 !== $t(t).length) throw new Error("One dimensional array expected");
                }
                function l(t) {
                    if (1 !== t.size().length) throw new Error("One dimensional matrix expected");
                }
            }), Sf = ge("and", [
                "typed",
                "matrix",
                "equalScalar",
                "zeros",
                "not",
                "concat"
            ], (t)=>{
                var { typed: e, matrix: r, equalScalar: n, zeros: i, not: o, concat: a } = t, s = sl({
                    typed: e,
                    equalScalar: n
                }), u = Fl({
                    typed: e,
                    equalScalar: n
                }), l = cl({
                    typed: e,
                    equalScalar: n
                }), c = pl({
                    typed: e
                }), f = ml({
                    typed: e,
                    matrix: r,
                    concat: a
                });
                return e("and", {
                    "number, number": eu,
                    "Complex, Complex": function(t, e) {
                        return !(0 === t.re && 0 === t.im || 0 === e.re && 0 === e.im);
                    },
                    "BigNumber, BigNumber": function(t, e) {
                        return !(t.isZero() || e.isZero() || t.isNaN() || e.isNaN());
                    },
                    "Unit, Unit": e.referToSelf((t)=>(e, r)=>t(e.value || 0, r.value || 0)),
                    "SparseMatrix, any": e.referToSelf((t)=>(e, r)=>o(r) ? i(e.size(), e.storage()) : l(e, r, t, !1)),
                    "DenseMatrix, any": e.referToSelf((t)=>(e, r)=>o(r) ? i(e.size(), e.storage()) : c(e, r, t, !1)),
                    "any, SparseMatrix": e.referToSelf((t)=>(e, r)=>o(e) ? i(e.size(), e.storage()) : l(r, e, t, !0)),
                    "any, DenseMatrix": e.referToSelf((t)=>(e, r)=>o(e) ? i(e.size(), e.storage()) : c(r, e, t, !0)),
                    "Array, any": e.referToSelf((t)=>(e, n)=>t(r(e), n).valueOf()),
                    "any, Array": e.referToSelf((t)=>(e, n)=>t(e, r(n)).valueOf())
                }, f({
                    SS: u,
                    DS: s
                }));
            }), Mf = ge("setDifference", [
                "typed",
                "size",
                "subset",
                "compareNatural",
                "Index",
                "DenseMatrix"
            ], (t)=>{
                var { typed: e, size: r, subset: n, compareNatural: i, Index: o, DenseMatrix: a } = t;
                return e("setDifference", {
                    "Array | Matrix, Array | Matrix": function(t, e) {
                        var s;
                        if (0 === n(r(t), new o(0))) s = [];
                        else {
                            if (0 === n(r(e), new o(0))) return ne(t.toArray());
                            var u, l = le(ne(Array.isArray(t) ? t : t.toArray()).sort(i)), c = le(ne(Array.isArray(e) ? e : e.toArray()).sort(i));
                            s = [];
                            for(var f = 0; f < l.length; f++){
                                u = !1;
                                for(var h = 0; h < c.length; h++)if (0 === i(l[f].value, c[h].value) && l[f].identifier === c[h].identifier) {
                                    u = !0;
                                    break;
                                }
                                u || s.push(l[f]);
                            }
                        }
                        return Array.isArray(t) && Array.isArray(e) ? ce(s) : new a(ce(s));
                    }
                });
            }), kf = ge("setMultiplicity", [
                "typed",
                "size",
                "subset",
                "compareNatural",
                "Index"
            ], (t)=>{
                var { typed: e, size: r, subset: n, compareNatural: i, Index: o } = t;
                return e("setMultiplicity", {
                    "number | BigNumber | Fraction | Complex, Array | Matrix": function(t, e) {
                        if (0 === n(r(e), new o(0))) return 0;
                        for(var a = ne(Array.isArray(e) ? e : e.toArray()), s = 0, u = 0; u < a.length; u++)0 === i(a[u], t) && s++;
                        return s;
                    }
                });
            }), Nf = ge("setSymDifference", [
                "typed",
                "size",
                "concat",
                "subset",
                "setDifference",
                "Index"
            ], (t)=>{
                var { typed: e, size: r, concat: n, subset: i, setDifference: o, Index: a } = t;
                return e("setSymDifference", {
                    "Array | Matrix, Array | Matrix": function(t, e) {
                        if (0 === i(r(t), new a(0))) return ne(e);
                        if (0 === i(r(e), new a(0))) return ne(t);
                        var s = ne(t), u = ne(e);
                        return n(o(s, u), o(u, s));
                    }
                });
            }), Cf = ge("Spa", [
                "addScalar",
                "equalScalar",
                "FibonacciHeap"
            ], (t)=>{
                var { addScalar: e, equalScalar: r, FibonacciHeap: n } = t;
                function i() {
                    if (!(this instanceof i)) throw new SyntaxError("Constructor must be called with the new operator");
                    this._values = [], this._heap = new n;
                }
                return i.prototype.type = "Spa", i.prototype.isSpa = !0, i.prototype.set = function(t, e) {
                    if (this._values[t]) this._values[t].value = e;
                    else {
                        var r = this._heap.insert(t, e);
                        this._values[t] = r;
                    }
                }, i.prototype.get = function(t) {
                    var e = this._values[t];
                    return e ? e.value : 0;
                }, i.prototype.accumulate = function(t, r) {
                    var n = this._values[t];
                    n ? n.value = e(n.value, r) : (n = this._heap.insert(t, r), this._values[t] = n);
                }, i.prototype.forEach = function(t, e, n) {
                    var i = this._heap, o = this._values, a = [], s = i.extractMinimum();
                    for(s && a.push(s); s && s.key <= e;)s.key >= t && (r(s.value, 0) || n(s.key, s.value, this)), (s = i.extractMinimum()) && a.push(s);
                    for(var u = 0; u < a.length; u++){
                        var l = a[u];
                        o[(s = i.insert(l.key, l.value)).key] = s;
                    }
                }, i.prototype.swap = function(t, e) {
                    var r = this._values[t], n = this._values[e];
                    if (!r && n) r = this._heap.insert(t, n.value), this._heap.remove(n), this._values[t] = r, this._values[e] = void 0;
                    else if (r && !n) n = this._heap.insert(e, r.value), this._heap.remove(r), this._values[e] = n, this._values[t] = void 0;
                    else if (r && n) {
                        var i = r.value;
                        r.value = n.value, n.value = i;
                    }
                }, i;
            }, {
                isClass: !0
            }), Df = ge("inv", [
                "typed",
                "matrix",
                "divideScalar",
                "addScalar",
                "multiply",
                "unaryMinus",
                "det",
                "identity",
                "abs"
            ], (t)=>{
                var { typed: e, matrix: r, divideScalar: n, addScalar: i, multiply: o, unaryMinus: a, det: s, identity: u, abs: l } = t;
                return e("inv", {
                    "Array | Matrix": function(t) {
                        var e = E(t) ? t.size() : $t(t);
                        switch(e.length){
                            case 1:
                                if (1 === e[0]) return E(t) ? r([
                                    n(1, t.valueOf()[0])
                                ]) : [
                                    n(1, t[0])
                                ];
                                throw new RangeError("Matrix must be square (size: " + Lt(e) + ")");
                            case 2:
                                var i = e[0], o = e[1];
                                if (i === o) return E(t) ? r(c(t.valueOf(), i, o), t.storage()) : c(t, i, o);
                                throw new RangeError("Matrix must be square (size: " + Lt(e) + ")");
                            default:
                                throw new RangeError("Matrix must be two dimensional (size: " + Lt(e) + ")");
                        }
                    },
                    any: function(t) {
                        return n(1, t);
                    }
                });
                function c(t, e, r) {
                    var c, f, h, p, d;
                    if (1 === e) {
                        if (0 === (p = t[0][0])) throw Error("Cannot calculate inverse, determinant is zero");
                        return [
                            [
                                n(1, p)
                            ]
                        ];
                    }
                    if (2 === e) {
                        var m = s(t);
                        if (0 === m) throw Error("Cannot calculate inverse, determinant is zero");
                        return [
                            [
                                n(t[1][1], m),
                                n(a(t[0][1]), m)
                            ],
                            [
                                n(a(t[1][0]), m),
                                n(t[0][0], m)
                            ]
                        ];
                    }
                    var y = t.concat();
                    for(c = 0; c < e; c++)y[c] = y[c].concat();
                    for(var g = u(e).valueOf(), v = 0; v < r; v++){
                        var b = l(y[v][v]), x = v;
                        for(c = v + 1; c < e;)l(y[c][v]) > b && (b = l(y[c][v]), x = c), c++;
                        if (0 === b) throw Error("Cannot calculate inverse, determinant is zero");
                        (c = x) !== v && (d = y[v], y[v] = y[c], y[c] = d, d = g[v], g[v] = g[c], g[c] = d);
                        var w = y[v], _ = g[v];
                        for(c = 0; c < e; c++){
                            var A = y[c], E = g[c];
                            if (c !== v) {
                                if (0 !== A[v]) {
                                    for(h = n(a(A[v]), w[v]), f = v; f < r; f++)A[f] = i(A[f], o(h, w[f]));
                                    for(f = 0; f < r; f++)E[f] = i(E[f], o(h, _[f]));
                                }
                            } else {
                                for(h = w[v], f = v; f < r; f++)A[f] = n(A[f], h);
                                for(f = 0; f < r; f++)E[f] = n(E[f], h);
                            }
                        }
                    }
                    return g;
                }
            }), Of = ge("lup", [
                "typed",
                "matrix",
                "abs",
                "addScalar",
                "divideScalar",
                "multiplyScalar",
                "subtractScalar",
                "larger",
                "equalScalar",
                "unaryMinus",
                "DenseMatrix",
                "SparseMatrix",
                "Spa"
            ], (t)=>{
                var { typed: e, matrix: r, abs: n, addScalar: i, divideScalar: o, multiplyScalar: a, subtractScalar: s, larger: u, equalScalar: l, unaryMinus: c, DenseMatrix: f, SparseMatrix: h, Spa: p } = t;
                return e("lup", {
                    DenseMatrix: function(t) {
                        return d(t);
                    },
                    SparseMatrix: function(t) {
                        return m(t);
                    },
                    Array: function(t) {
                        var e = d(r(t));
                        return {
                            L: e.L.valueOf(),
                            U: e.U.valueOf(),
                            p: e.p
                        };
                    }
                });
                function d(t) {
                    var e, r, c, h = t._size[0], p = t._size[1], d = Math.min(h, p), m = it(t._data), y = [], g = [
                        h,
                        d
                    ], v = [], b = [
                        d,
                        p
                    ], x = [];
                    for(e = 0; e < h; e++)x[e] = e;
                    for(r = 0; r < p; r++){
                        if (r > 0) for(e = 0; e < h; e++){
                            var w = Math.min(e, r), _ = 0;
                            for(c = 0; c < w; c++)_ = i(_, a(m[e][c], m[c][r]));
                            m[e][r] = s(m[e][r], _);
                        }
                        var A = r, E = 0, S = 0;
                        for(e = r; e < h; e++){
                            var M = m[e][r], k = n(M);
                            u(k, E) && (A = e, E = k, S = M);
                        }
                        if (r !== A && (x[r] = [
                            x[A],
                            x[A] = x[r]
                        ][0], f._swapRows(r, A, m)), r < h) for(e = r + 1; e < h; e++){
                            var N = m[e][r];
                            l(N, 0) || (m[e][r] = o(m[e][r], S));
                        }
                    }
                    for(r = 0; r < p; r++)for(e = 0; e < h; e++)0 === r && (e < p && (v[e] = []), y[e] = []), e < r ? (e < p && (v[e][r] = m[e][r]), r < h && (y[e][r] = 0)) : e !== r ? (e < p && (v[e][r] = 0), r < h && (y[e][r] = m[e][r])) : (e < p && (v[e][r] = m[e][r]), r < h && (y[e][r] = 1));
                    var C = new f({
                        data: y,
                        size: g
                    }), D = new f({
                        data: v,
                        size: b
                    }), O = [];
                    for(e = 0, d = x.length; e < d; e++)O[x[e]] = e;
                    return {
                        L: C,
                        U: D,
                        p: O,
                        toString: function() {
                            return "L: " + this.L.toString() + "\nU: " + this.U.toString() + "\nP: " + this.p;
                        }
                    };
                }
                function m(t) {
                    var e, r, i, s = t._size[0], f = t._size[1], d = Math.min(s, f), m = t._values, y = t._index, g = t._ptr, v = [], b = [], x = [], w = [
                        s,
                        d
                    ], _ = [], A = [], E = [], S = [
                        d,
                        f
                    ], M = [], k = [];
                    for(e = 0; e < s; e++)M[e] = e, k[e] = e;
                    var N = function() {
                        var t = new p;
                        r < s && (x.push(v.length), v.push(1), b.push(r)), E.push(_.length);
                        var f = g[r], d = g[r + 1];
                        for(i = f; i < d; i++)e = y[i], t.set(M[e], m[i]);
                        r > 0 && t.forEach(0, r - 1, function(e, r) {
                            h._forEachRow(e, v, b, x, function(n, i) {
                                n > e && t.accumulate(n, c(a(i, r)));
                            });
                        });
                        var N, C, D, O, T = r, F = t.get(r), P = n(F);
                        t.forEach(r + 1, s - 1, function(t, e) {
                            var r = n(e);
                            u(r, P) && (T = t, P = r, F = e);
                        }), r !== T && (h._swapRows(r, T, w[1], v, b, x), h._swapRows(r, T, S[1], _, A, E), t.swap(r, T), C = T, D = k[N = r], O = k[C], M[D] = C, M[O] = N, k[N] = O, k[C] = D), t.forEach(0, s - 1, function(t, e) {
                            t <= r ? (_.push(e), A.push(t)) : (e = o(e, F), l(e, 0) || (v.push(e), b.push(t)));
                        });
                    };
                    for(r = 0; r < f; r++)N();
                    return E.push(_.length), x.push(v.length), {
                        L: new h({
                            values: v,
                            index: b,
                            ptr: x,
                            size: w
                        }),
                        U: new h({
                            values: _,
                            index: A,
                            ptr: E,
                            size: S
                        }),
                        p: M,
                        toString: function() {
                            return "L: " + this.L.toString() + "\nU: " + this.U.toString() + "\nP: " + this.p;
                        }
                    };
                }
            }), Tf = ge("pinv", [
                "typed",
                "matrix",
                "inv",
                "deepEqual",
                "equal",
                "dotDivide",
                "dot",
                "ctranspose",
                "divideScalar",
                "multiply",
                "add",
                "Complex"
            ], (t)=>{
                var { typed: e, matrix: r, inv: n, deepEqual: i, equal: o, dotDivide: a, dot: s, ctranspose: u, divideScalar: l, multiply: c, add: f, Complex: h } = t;
                return e("pinv", {
                    "Array | Matrix": function(t) {
                        var e = E(t) ? t.size() : $t(t);
                        switch(e.length){
                            case 1:
                                return m(t) ? u(t) : 1 === e[0] ? n(t) : a(u(t), s(t, t));
                            case 2:
                                if (m(t)) return u(t);
                                var i = e[0], o = e[1];
                                if (i === o) try {
                                    return n(t);
                                } catch (t) {
                                    if (!(t instanceof Error && t.message.match(/Cannot calculate inverse, determinant is zero/))) throw t;
                                }
                                return E(t) ? r(p(t.valueOf(), i, o), t.storage()) : p(t, i, o);
                            default:
                                throw new RangeError("Matrix must be two dimensional (size: " + Lt(e) + ")");
                        }
                    },
                    any: function(t) {
                        return o(t, 0) ? it(t) : l(1, t);
                    }
                });
                function p(t, e, r) {
                    var { C: i, F: o } = function(t, e, r) {
                        var n = function(t, e, r) {
                            for(var n = it(t), i = 0, o = 0; o < e; o++){
                                if (r <= i) return n;
                                for(var s = o; d(n[s][i]);)if (s++, e === s && (s = o, i++, r === i)) return n;
                                [n[s], n[o]] = [
                                    n[o],
                                    n[s]
                                ];
                                for(var u = n[o][i], l = 0; l < r; l++)n[o][l] = a(n[o][l], u);
                                for(var h = 0; h < e; h++)if (h !== o) {
                                    u = n[h][i];
                                    for(var p = 0; p < r; p++)n[h][p] = f(n[h][p], c(-1, c(u, n[o][p])));
                                }
                                i++;
                            }
                            return n;
                        }(t, e, r), i = t.map((t, r)=>t.filter((t, r)=>r < e && !d(s(n[r], n[r])))), o = n.filter((t, e)=>!d(s(n[e], n[e])));
                        return {
                            C: i,
                            F: o
                        };
                    }(t, e, r), l = c(n(c(u(i), i)), u(i)), h = c(u(o), n(c(o, u(o))));
                    return c(h, l);
                }
                function d(t) {
                    return o(f(t, h(1, 1)), f(0, h(1, 1)));
                }
                function m(t) {
                    return i(f(t, h(1, 1)), f(c(t, 0), h(1, 1)));
                }
            }), Ff = ge("pow", [
                "typed",
                "config",
                "identity",
                "multiply",
                "matrix",
                "inv",
                "fraction",
                "number",
                "Complex"
            ], (t)=>{
                var { typed: e, config: r, identity: n, multiply: i, matrix: o, inv: a, number: s, fraction: u, Complex: l } = t;
                return e("pow", {
                    "number, number": c,
                    "Complex, Complex": function(t, e) {
                        return t.pow(e);
                    },
                    "BigNumber, BigNumber": function(t, e) {
                        return e.isInteger() || t >= 0 || r.predictable ? t.pow(e) : new l(t.toNumber(), 0).pow(e.toNumber(), 0);
                    },
                    "Fraction, Fraction": function(t, e) {
                        var n = t.pow(e);
                        if (null != n) return n;
                        if (r.predictable) throw new Error("Result of pow is non-rational and cannot be expressed as a fraction");
                        return c(t.valueOf(), e.valueOf());
                    },
                    "Array, number": f,
                    "Array, BigNumber": function(t, e) {
                        return f(t, e.toNumber());
                    },
                    "Matrix, number": h,
                    "Matrix, BigNumber": function(t, e) {
                        return h(t, e.toNumber());
                    },
                    "Unit, number | BigNumber": function(t, e) {
                        return t.pow(e);
                    }
                });
                function c(t, e) {
                    if (r.predictable && !pt(e) && t < 0) try {
                        var n = u(e), i = s(n);
                        if ((e === i || Math.abs((e - i) / e) < 1e-14) && n.d % 2 == 1) return (n.n % 2 == 0 ? 1 : -1) * Math.pow(-t, e);
                    } catch (t) {}
                    return r.predictable && (t < -1 && e === 1 / 0 || t > -1 && t < 0 && e === -1 / 0) ? NaN : pt(e) || t >= 0 || r.predictable ? ua(t, e) : t * t < 1 && e === 1 / 0 || t * t > 1 && e === -1 / 0 ? 0 : new l(t, 0).pow(e, 0);
                }
                function f(t, e) {
                    if (!pt(e)) throw new TypeError("For A^b, b must be an integer (value is " + e + ")");
                    var r = $t(t);
                    if (2 !== r.length) throw new Error("For A^b, A must be 2 dimensional (A has " + r.length + " dimensions)");
                    if (r[0] !== r[1]) throw new Error("For A^b, A must be square (size is " + r[0] + "x" + r[1] + ")");
                    if (e < 0) try {
                        return f(a(t), -e);
                    } catch (t) {
                        if ("Cannot calculate inverse, determinant is zero" === t.message) throw new TypeError("For A^b, when A is not invertible, b must be a positive integer (value is " + e + ")");
                        throw t;
                    }
                    for(var o = n(r[0]).valueOf(), s = t; e >= 1;)1 == (1 & e) && (o = i(s, o)), e >>= 1, s = i(s, s);
                    return o;
                }
                function h(t, e) {
                    return o(f(t.valueOf(), e));
                }
            }), Pf = ge("setIntersect", [
                "typed",
                "size",
                "subset",
                "compareNatural",
                "Index",
                "DenseMatrix"
            ], (t)=>{
                var { typed: e, size: r, subset: n, compareNatural: i, Index: o, DenseMatrix: a } = t;
                return e("setIntersect", {
                    "Array | Matrix, Array | Matrix": function(t, e) {
                        var s;
                        if (0 === n(r(t), new o(0)) || 0 === n(r(e), new o(0))) s = [];
                        else {
                            var u = le(ne(Array.isArray(t) ? t : t.toArray()).sort(i)), l = le(ne(Array.isArray(e) ? e : e.toArray()).sort(i));
                            s = [];
                            for(var c = 0; c < u.length; c++)for(var f = 0; f < l.length; f++)if (0 === i(u[c].value, l[f].value) && u[c].identifier === l[f].identifier) {
                                s.push(u[c]);
                                break;
                            }
                        }
                        return Array.isArray(t) && Array.isArray(e) ? ce(s) : new a(ce(s));
                    }
                });
            }), If = ge("setUnion", [
                "typed",
                "size",
                "concat",
                "subset",
                "setIntersect",
                "setSymDifference",
                "Index"
            ], (t)=>{
                var { typed: e, size: r, concat: n, subset: i, setIntersect: o, setSymDifference: a, Index: s } = t;
                return e("setUnion", {
                    "Array | Matrix, Array | Matrix": function(t, e) {
                        if (0 === i(r(t), new s(0))) return ne(e);
                        if (0 === i(r(e), new s(0))) return ne(t);
                        var u = ne(t), l = ne(e);
                        return n(a(u, l), o(u, l));
                    }
                });
            }), Bf = ge("sqrtm", [
                "typed",
                "abs",
                "add",
                "multiply",
                "map",
                "sqrt",
                "subtract",
                "inv",
                "size",
                "max",
                "identity"
            ], (t)=>{
                var { typed: e, abs: r, add: n, multiply: i, map: o, sqrt: a, subtract: s, inv: u, size: l, max: c, identity: f } = t;
                function h(t) {
                    var e, o = 0, a = t, h = f(l(t));
                    do {
                        var p = a;
                        if (a = i(.5, n(p, u(h))), h = i(.5, n(h, u(p))), (e = c(r(s(a, p)))) > 1e-6 && ++o > 1e3) throw new Error("computing square root of matrix: iterative method could not converge");
                    }while (e > 1e-6);
                    return a;
                }
                return e("sqrtm", {
                    "Array | Matrix": function(t) {
                        var e = E(t) ? t.size() : $t(t);
                        switch(e.length){
                            case 1:
                                if (1 === e[0]) return o(t, a);
                                throw new RangeError("Matrix must be square (size: " + Lt(e) + ")");
                            case 2:
                                if (e[0] === e[1]) return h(t);
                                throw new RangeError("Matrix must be square (size: " + Lt(e) + ")");
                            default:
                                throw new RangeError("Matrix must be at most two dimensional (size: " + Lt(e) + ")");
                        }
                    }
                });
            });
            function jf(t, e) {
                var r = Object.keys(t);
                if (Object.getOwnPropertySymbols) {
                    var n = Object.getOwnPropertySymbols(t);
                    e && (n = n.filter(function(e) {
                        return Object.getOwnPropertyDescriptor(t, e).enumerable;
                    })), r.push.apply(r, n);
                }
                return r;
            }
            function Rf(t) {
                for(var e = 1; e < arguments.length; e++){
                    var r = null != arguments[e] ? arguments[e] : {};
                    e % 2 ? jf(Object(r), !0).forEach(function(e) {
                        Fe()(t, e, r[e]);
                    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : jf(Object(r)).forEach(function(e) {
                        Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
                    });
                }
                return t;
            }
            var Lf = ge("Unit", [
                "?on",
                "config",
                "addScalar",
                "subtractScalar",
                "multiplyScalar",
                "divideScalar",
                "pow",
                "abs",
                "fix",
                "round",
                "equal",
                "isNumeric",
                "format",
                "number",
                "Complex",
                "BigNumber",
                "Fraction"
            ], (t)=>{
                var e, r, n, { on: i, config: o, addScalar: a, subtractScalar: s, multiplyScalar: u, divideScalar: l, pow: c, abs: f, fix: h, round: p, equal: d, isNumeric: y, format: g, number: v, Complex: x, BigNumber: _, Fraction: A } = t, E = v;
                function S(t, e) {
                    if (!(this instanceof S)) throw new Error("Constructor must be called with the new operator");
                    if (null != t && !y(t) && !b(t)) throw new TypeError("First parameter in Unit constructor must be number, BigNumber, Fraction, Complex, or undefined");
                    if (this.fixPrefix = !1, this.skipAutomaticSimplification = !0, void 0 === e) this.units = [], this.dimensions = B.map((t)=>0);
                    else if ("string" == typeof e) {
                        var r = S.parse(e);
                        this.units = r.units, this.dimensions = r.dimensions;
                    } else {
                        if (!w(e) || null !== e.value) throw new TypeError("Second parameter in Unit constructor must be a string or valueless Unit");
                        this.fixPrefix = e.fixPrefix, this.skipAutomaticSimplification = e.skipAutomaticSimplification, this.dimensions = e.dimensions.slice(0), this.units = e.units.map((t)=>m()({}, t));
                    }
                    this.value = this._normalize(t);
                }
                function M() {
                    for(; " " === n || "	" === n;)N();
                }
                function k(t) {
                    return t >= "0" && t <= "9";
                }
                function N() {
                    r++, n = e.charAt(r);
                }
                function C(t) {
                    r = t, n = e.charAt(r);
                }
                function D() {
                    var t = "", e = r;
                    if ("+" === n ? N() : "-" === n && (t += n, N()), !function(t) {
                        return t >= "0" && t <= "9" || "." === t;
                    }(n)) return C(e), null;
                    if ("." === n) {
                        if (t += n, N(), !k(n)) return C(e), null;
                    } else {
                        for(; k(n);)t += n, N();
                        "." === n && (t += n, N());
                    }
                    for(; k(n);)t += n, N();
                    if ("E" === n || "e" === n) {
                        var i = "", o = r;
                        if (i += n, N(), "+" !== n && "-" !== n || (i += n, N()), !k(n)) return C(o), t;
                        for(t += i; k(n);)t += n, N();
                    }
                    return t;
                }
                function O() {
                    for(var t = ""; k(n) || S.isValidAlpha(n);)t += n, N();
                    var e = t.charAt(0);
                    return S.isValidAlpha(e) ? t : null;
                }
                function T(t) {
                    return n === t ? (N(), t) : null;
                }
                Object.defineProperty(S, "name", {
                    value: "Unit"
                }), S.prototype.constructor = S, S.prototype.type = "Unit", S.prototype.isUnit = !0, S.parse = function(t, i) {
                    if (i = i || {}, r = -1, n = "", "string" != typeof (e = t)) throw new TypeError("Invalid argument in Unit.parse, string expected");
                    var a = new S;
                    a.units = [];
                    var s = 1, u = !1;
                    N(), M();
                    var l = D(), c = null;
                    if (l) {
                        if ("BigNumber" === o.number) c = new _(l);
                        else if ("Fraction" === o.number) try {
                            c = new A(l);
                        } catch (t) {
                            c = parseFloat(l);
                        }
                        else c = parseFloat(l);
                        M(), T("*") ? (s = 1, u = !0) : T("/") && (s = -1, u = !0);
                    }
                    for(var f = [], h = 1;;){
                        for(M(); "(" === n;)f.push(s), h *= s, s = 1, N(), M();
                        var p = void 0;
                        if (!n) break;
                        var d = n;
                        if (null === (p = O())) throw new SyntaxError('Unexpected "' + d + '" in "' + e + '" at index ' + r.toString());
                        var m = F(p);
                        if (null === m) throw new SyntaxError('Unit "' + p + '" not found.');
                        var y = s * h;
                        if (M(), T("^")) {
                            M();
                            var g = D();
                            if (null === g) throw new SyntaxError('In "' + t + '", "^" must be followed by a floating-point number');
                            y *= g;
                        }
                        a.units.push({
                            unit: m.unit,
                            prefix: m.prefix,
                            power: y
                        });
                        for(var v = 0; v < B.length; v++)a.dimensions[v] += (m.unit.dimensions[v] || 0) * y;
                        for(M(); ")" === n;){
                            if (0 === f.length) throw new SyntaxError('Unmatched ")" in "' + e + '" at index ' + r.toString());
                            h /= f.pop(), N(), M();
                        }
                        if (u = !1, T("*") ? (s = 1, u = !0) : T("/") ? (s = -1, u = !0) : s = 1, m.unit.base) {
                            var b = m.unit.base.key;
                            G.auto[b] = {
                                unit: m.unit,
                                prefix: m.prefix
                            };
                        }
                    }
                    if (M(), n) throw new SyntaxError('Could not parse: "' + t + '"');
                    if (u) throw new SyntaxError('Trailing characters: "' + t + '"');
                    if (0 !== f.length) throw new SyntaxError('Unmatched "(" in "' + e + '"');
                    if (0 === a.units.length && !i.allowNoUnits) throw new SyntaxError('"' + t + '" contains no units');
                    return a.value = void 0 !== c ? a._normalize(c) : null, a;
                }, S.prototype.clone = function() {
                    var t = new S;
                    t.fixPrefix = this.fixPrefix, t.skipAutomaticSimplification = this.skipAutomaticSimplification, t.value = it(this.value), t.dimensions = this.dimensions.slice(0), t.units = [];
                    for(var e = 0; e < this.units.length; e++)for(var r in t.units[e] = {}, this.units[e])ut(this.units[e], r) && (t.units[e][r] = this.units[e][r]);
                    return t;
                }, S.prototype.valueType = function() {
                    return nt(this.value);
                }, S.prototype._isDerived = function() {
                    return 0 !== this.units.length && (this.units.length > 1 || Math.abs(this.units[0].power - 1) > 1e-15);
                }, S.prototype._normalize = function(t) {
                    if (null == t || 0 === this.units.length) return t;
                    for(var e = t, r = S._getNumberConverter(nt(t)), n = 0; n < this.units.length; n++){
                        var i = r(this.units[n].unit.value), o = r(this.units[n].prefix.value), a = r(this.units[n].power);
                        e = u(e, c(u(i, o), a));
                    }
                    return e;
                }, S.prototype._denormalize = function(t, e) {
                    if (null == t || 0 === this.units.length) return t;
                    for(var r = t, n = S._getNumberConverter(nt(t)), i = 0; i < this.units.length; i++){
                        var o = n(this.units[i].unit.value), a = n(this.units[i].prefix.value), s = n(this.units[i].power);
                        r = l(r, c(u(o, a), s));
                    }
                    return r;
                };
                var F = oi((t)=>{
                    if (ut(q, t)) {
                        var e = q[t];
                        return {
                            unit: e,
                            prefix: e.prefixes[""]
                        };
                    }
                    for(var r in q)if (ut(q, r) && Rt(t, r)) {
                        var n = q[r], i = t.length - r.length, o = t.substring(0, i), a = ut(n.prefixes, o) ? n.prefixes[o] : void 0;
                        if (void 0 !== a) return {
                            unit: n,
                            prefix: a
                        };
                    }
                    return null;
                }, {
                    hasher: (t)=>t[0],
                    limit: 100
                });
                function P(t) {
                    return t.equalBase(j.NONE) && null !== t.value && !o.predictable ? t.value : t;
                }
                S.isValuelessUnit = function(t) {
                    return null !== F(t);
                }, S.prototype.hasBase = function(t) {
                    if ("string" == typeof t && (t = j[t]), !t) return !1;
                    for(var e = 0; e < B.length; e++)if (Math.abs((this.dimensions[e] || 0) - (t.dimensions[e] || 0)) > 1e-12) return !1;
                    return !0;
                }, S.prototype.equalBase = function(t) {
                    for(var e = 0; e < B.length; e++)if (Math.abs((this.dimensions[e] || 0) - (t.dimensions[e] || 0)) > 1e-12) return !1;
                    return !0;
                }, S.prototype.equals = function(t) {
                    return this.equalBase(t) && d(this.value, t.value);
                }, S.prototype.multiply = function(t) {
                    for(var e = this.clone(), r = w(t) ? t : new S(t), n = 0; n < B.length; n++)e.dimensions[n] = (this.dimensions[n] || 0) + (r.dimensions[n] || 0);
                    for(var i = 0; i < r.units.length; i++){
                        var o = Rf({}, r.units[i]);
                        e.units.push(o);
                    }
                    if (null !== this.value || null !== r.value) {
                        var a = null === this.value ? this._normalize(1) : this.value, s = null === r.value ? r._normalize(1) : r.value;
                        e.value = u(a, s);
                    } else e.value = null;
                    return w(t) && (e.skipAutomaticSimplification = !1), P(e);
                }, S.prototype.divideInto = function(t) {
                    return new S(t).divide(this);
                }, S.prototype.divide = function(t) {
                    for(var e = this.clone(), r = w(t) ? t : new S(t), n = 0; n < B.length; n++)e.dimensions[n] = (this.dimensions[n] || 0) - (r.dimensions[n] || 0);
                    for(var i = 0; i < r.units.length; i++){
                        var o = Rf(Rf({}, r.units[i]), {}, {
                            power: -r.units[i].power
                        });
                        e.units.push(o);
                    }
                    if (null !== this.value || null !== r.value) {
                        var a = null === this.value ? this._normalize(1) : this.value, s = null === r.value ? r._normalize(1) : r.value;
                        e.value = l(a, s);
                    } else e.value = null;
                    return w(t) && (e.skipAutomaticSimplification = !1), P(e);
                }, S.prototype.pow = function(t) {
                    for(var e = this.clone(), r = 0; r < B.length; r++)e.dimensions[r] = (this.dimensions[r] || 0) * t;
                    for(var n = 0; n < e.units.length; n++)e.units[n].power *= t;
                    return null !== e.value ? e.value = c(e.value, t) : e.value = null, e.skipAutomaticSimplification = !1, P(e);
                }, S.prototype.abs = function() {
                    var t = this.clone();
                    if (null !== t.value) {
                        if (t._isDerived() || 0 === t.units[0].unit.offset) t.value = f(t.value);
                        else {
                            var e = t._numberConverter(), r = e(t.units[0].unit.value), n = e(t.units[0].unit.offset), i = u(r, n);
                            t.value = s(f(a(t.value, i)), i);
                        }
                    }
                    for(var o in t.units)"VA" !== t.units[o].unit.name && "VAR" !== t.units[o].unit.name || (t.units[o].unit = q.W);
                    return t;
                }, S.prototype.to = function(t) {
                    var e, r = null === this.value ? this._normalize(1) : this.value;
                    if ("string" == typeof t) e = S.parse(t);
                    else {
                        if (!w(t)) throw new Error("String or Unit expected as parameter");
                        e = t.clone();
                    }
                    if (!this.equalBase(e)) throw new Error("Units do not match ('".concat(e.toString(), "' != '").concat(this.toString(), "')"));
                    if (null !== e.value) throw new Error("Cannot convert to a unit with a value");
                    if (null === this.value || this._isDerived() || this.units[0].unit.offset === e.units[0].unit.offset) e.value = it(r);
                    else {
                        var n = S._getNumberConverter(nt(r)), i = this.units[0].unit.value, o = this.units[0].unit.offset, l = u(i, o), c = e.units[0].unit.value, f = e.units[0].unit.offset, h = u(c, f);
                        e.value = a(r, n(s(l, h)));
                    }
                    return e.fixPrefix = !0, e.skipAutomaticSimplification = !0, e;
                }, S.prototype.toNumber = function(t) {
                    return E(this.toNumeric(t));
                }, S.prototype.toNumeric = function(t) {
                    var e;
                    return (e = t ? this.to(t) : this.clone())._isDerived() || 0 === e.units.length ? e._denormalize(e.value) : e._denormalize(e.value, e.units[0].prefix.value);
                }, S.prototype.toString = function() {
                    return this.format();
                }, S.prototype.toJSON = function() {
                    return {
                        mathjs: "Unit",
                        value: this._denormalize(this.value),
                        unit: this.formatUnits(),
                        fixPrefix: this.fixPrefix
                    };
                }, S.fromJSON = function(t) {
                    var e = new S(t.value, t.unit);
                    return e.fixPrefix = t.fixPrefix || !1, e;
                }, S.prototype.valueOf = S.prototype.toString, S.prototype.simplify = function() {
                    var t, e, r = this.clone(), n = [];
                    for(var i in H)if (ut(H, i) && r.hasBase(j[i])) {
                        t = i;
                        break;
                    }
                    if ("NONE" === t) r.units = [];
                    else if (t && ut(H, t) && (e = H[t]), e) r.units = [
                        {
                            unit: e.unit,
                            prefix: e.prefix,
                            power: 1
                        }
                    ];
                    else {
                        for(var o = !1, a = 0; a < B.length; a++){
                            var s = B[a];
                            Math.abs(r.dimensions[a] || 0) > 1e-12 && (ut(H, s) ? n.push({
                                unit: H[s].unit,
                                prefix: H[s].prefix,
                                power: r.dimensions[a] || 0
                            }) : o = !0);
                        }
                        n.length < r.units.length && !o && (r.units = n);
                    }
                    return r;
                }, S.prototype.toSI = function() {
                    for(var t = this.clone(), e = [], r = 0; r < B.length; r++){
                        var n = B[r];
                        if (Math.abs(t.dimensions[r] || 0) > 1e-12) {
                            if (!ut(G.si, n)) throw new Error("Cannot express custom unit " + n + " in SI units");
                            e.push({
                                unit: G.si[n].unit,
                                prefix: G.si[n].prefix,
                                power: t.dimensions[r] || 0
                            });
                        }
                    }
                    return t.units = e, t.fixPrefix = !0, t.skipAutomaticSimplification = !0, t;
                }, S.prototype.formatUnits = function() {
                    for(var t = "", e = "", r = 0, n = 0, i = 0; i < this.units.length; i++)this.units[i].power > 0 ? (r++, t += " " + this.units[i].prefix.name + this.units[i].unit.name, Math.abs(this.units[i].power - 1) > 1e-15 && (t += "^" + this.units[i].power)) : this.units[i].power < 0 && n++;
                    if (n > 0) for(var o = 0; o < this.units.length; o++)this.units[o].power < 0 && (r > 0 ? (e += " " + this.units[o].prefix.name + this.units[o].unit.name, Math.abs(this.units[o].power + 1) > 1e-15 && (e += "^" + -this.units[o].power)) : (e += " " + this.units[o].prefix.name + this.units[o].unit.name, e += "^" + this.units[o].power));
                    t = t.substr(1), e = e.substr(1), r > 1 && n > 0 && (t = "(" + t + ")"), n > 1 && r > 0 && (e = "(" + e + ")");
                    var a = t;
                    return r > 0 && n > 0 && (a += " / "), a += e;
                }, S.prototype.format = function(t) {
                    var e = this.skipAutomaticSimplification || null === this.value ? this.clone() : this.simplify(), r = !1;
                    for(var n in void 0 !== e.value && null !== e.value && b(e.value) && (r = Math.abs(e.value.re) < 1e-14), e.units)ut(e.units, n) && e.units[n].unit && ("VA" === e.units[n].unit.name && r ? e.units[n].unit = q.VAR : "VAR" !== e.units[n].unit.name || r || (e.units[n].unit = q.VA));
                    1 !== e.units.length || e.fixPrefix || Math.abs(e.units[0].power - Math.round(e.units[0].power)) < 1e-14 && (e.units[0].prefix = e._bestPrefix());
                    var i = e._denormalize(e.value), o = null !== e.value ? g(i, t || {}) : "", a = e.formatUnits();
                    return e.value && b(e.value) && (o = "(" + o + ")"), a.length > 0 && o.length > 0 && (o += " "), o += a;
                }, S.prototype._bestPrefix = function() {
                    if (1 !== this.units.length) throw new Error("Can only compute the best prefix for single units with integer powers, like kg, s^2, N^-1, and so forth!");
                    if (Math.abs(this.units[0].power - Math.round(this.units[0].power)) >= 1e-14) throw new Error("Can only compute the best prefix for single units with integer powers, like kg, s^2, N^-1, and so forth!");
                    var t = null !== this.value ? f(this.value) : 0, e = f(this.units[0].unit.value), r = this.units[0].prefix;
                    if (0 === t) return r;
                    var n = this.units[0].power, i = Math.log(t / Math.pow(r.value * e, n)) / Math.LN10 - 1.2;
                    if (i > -2.200001 && i < 1.800001) return r;
                    i = Math.abs(i);
                    var o = this.units[0].unit.prefixes;
                    for(var a in o)if (ut(o, a)) {
                        var s = o[a];
                        if (s.scientific) {
                            var u = Math.abs(Math.log(t / Math.pow(s.value * e, n)) / Math.LN10 - 1.2);
                            (u < i || u === i && s.name.length < r.name.length) && (r = s, i = u);
                        }
                    }
                    return r;
                }, S.prototype.splitUnit = function(t) {
                    for(var e = this.clone(), r = [], n = 0; n < t.length && (e = e.to(t[n]), n !== t.length - 1); n++){
                        var i = e.toNumeric(), o = p(i), u = new S(d(o, i) ? o : h(e.toNumeric()), t[n].toString());
                        r.push(u), e = s(e, u);
                    }
                    for(var l = 0, c = 0; c < r.length; c++)l = a(l, r[c].value);
                    return d(l, this.value) && (e.value = 0), r.push(e), r;
                };
                var I = {
                    NONE: {
                        "": {
                            name: "",
                            value: 1,
                            scientific: !0
                        }
                    },
                    SHORT: {
                        "": {
                            name: "",
                            value: 1,
                            scientific: !0
                        },
                        da: {
                            name: "da",
                            value: 10,
                            scientific: !1
                        },
                        h: {
                            name: "h",
                            value: 100,
                            scientific: !1
                        },
                        k: {
                            name: "k",
                            value: 1e3,
                            scientific: !0
                        },
                        M: {
                            name: "M",
                            value: 1e6,
                            scientific: !0
                        },
                        G: {
                            name: "G",
                            value: 1e9,
                            scientific: !0
                        },
                        T: {
                            name: "T",
                            value: 1e12,
                            scientific: !0
                        },
                        P: {
                            name: "P",
                            value: 1e15,
                            scientific: !0
                        },
                        E: {
                            name: "E",
                            value: 1e18,
                            scientific: !0
                        },
                        Z: {
                            name: "Z",
                            value: 1e21,
                            scientific: !0
                        },
                        Y: {
                            name: "Y",
                            value: 1e24,
                            scientific: !0
                        },
                        d: {
                            name: "d",
                            value: .1,
                            scientific: !1
                        },
                        c: {
                            name: "c",
                            value: .01,
                            scientific: !1
                        },
                        m: {
                            name: "m",
                            value: .001,
                            scientific: !0
                        },
                        u: {
                            name: "u",
                            value: 1e-6,
                            scientific: !0
                        },
                        n: {
                            name: "n",
                            value: 1e-9,
                            scientific: !0
                        },
                        p: {
                            name: "p",
                            value: 1e-12,
                            scientific: !0
                        },
                        f: {
                            name: "f",
                            value: 1e-15,
                            scientific: !0
                        },
                        a: {
                            name: "a",
                            value: 1e-18,
                            scientific: !0
                        },
                        z: {
                            name: "z",
                            value: 1e-21,
                            scientific: !0
                        },
                        y: {
                            name: "y",
                            value: 1e-24,
                            scientific: !0
                        }
                    },
                    LONG: {
                        "": {
                            name: "",
                            value: 1,
                            scientific: !0
                        },
                        deca: {
                            name: "deca",
                            value: 10,
                            scientific: !1
                        },
                        hecto: {
                            name: "hecto",
                            value: 100,
                            scientific: !1
                        },
                        kilo: {
                            name: "kilo",
                            value: 1e3,
                            scientific: !0
                        },
                        mega: {
                            name: "mega",
                            value: 1e6,
                            scientific: !0
                        },
                        giga: {
                            name: "giga",
                            value: 1e9,
                            scientific: !0
                        },
                        tera: {
                            name: "tera",
                            value: 1e12,
                            scientific: !0
                        },
                        peta: {
                            name: "peta",
                            value: 1e15,
                            scientific: !0
                        },
                        exa: {
                            name: "exa",
                            value: 1e18,
                            scientific: !0
                        },
                        zetta: {
                            name: "zetta",
                            value: 1e21,
                            scientific: !0
                        },
                        yotta: {
                            name: "yotta",
                            value: 1e24,
                            scientific: !0
                        },
                        deci: {
                            name: "deci",
                            value: .1,
                            scientific: !1
                        },
                        centi: {
                            name: "centi",
                            value: .01,
                            scientific: !1
                        },
                        milli: {
                            name: "milli",
                            value: .001,
                            scientific: !0
                        },
                        micro: {
                            name: "micro",
                            value: 1e-6,
                            scientific: !0
                        },
                        nano: {
                            name: "nano",
                            value: 1e-9,
                            scientific: !0
                        },
                        pico: {
                            name: "pico",
                            value: 1e-12,
                            scientific: !0
                        },
                        femto: {
                            name: "femto",
                            value: 1e-15,
                            scientific: !0
                        },
                        atto: {
                            name: "atto",
                            value: 1e-18,
                            scientific: !0
                        },
                        zepto: {
                            name: "zepto",
                            value: 1e-21,
                            scientific: !0
                        },
                        yocto: {
                            name: "yocto",
                            value: 1e-24,
                            scientific: !0
                        }
                    },
                    SQUARED: {
                        "": {
                            name: "",
                            value: 1,
                            scientific: !0
                        },
                        da: {
                            name: "da",
                            value: 100,
                            scientific: !1
                        },
                        h: {
                            name: "h",
                            value: 1e4,
                            scientific: !1
                        },
                        k: {
                            name: "k",
                            value: 1e6,
                            scientific: !0
                        },
                        M: {
                            name: "M",
                            value: 1e12,
                            scientific: !0
                        },
                        G: {
                            name: "G",
                            value: 1e18,
                            scientific: !0
                        },
                        T: {
                            name: "T",
                            value: 1e24,
                            scientific: !0
                        },
                        P: {
                            name: "P",
                            value: 1e30,
                            scientific: !0
                        },
                        E: {
                            name: "E",
                            value: 1e36,
                            scientific: !0
                        },
                        Z: {
                            name: "Z",
                            value: 1e42,
                            scientific: !0
                        },
                        Y: {
                            name: "Y",
                            value: 1e48,
                            scientific: !0
                        },
                        d: {
                            name: "d",
                            value: .01,
                            scientific: !1
                        },
                        c: {
                            name: "c",
                            value: 1e-4,
                            scientific: !1
                        },
                        m: {
                            name: "m",
                            value: 1e-6,
                            scientific: !0
                        },
                        u: {
                            name: "u",
                            value: 1e-12,
                            scientific: !0
                        },
                        n: {
                            name: "n",
                            value: 1e-18,
                            scientific: !0
                        },
                        p: {
                            name: "p",
                            value: 1e-24,
                            scientific: !0
                        },
                        f: {
                            name: "f",
                            value: 1e-30,
                            scientific: !0
                        },
                        a: {
                            name: "a",
                            value: 1e-36,
                            scientific: !0
                        },
                        z: {
                            name: "z",
                            value: 1e-42,
                            scientific: !0
                        },
                        y: {
                            name: "y",
                            value: 1e-48,
                            scientific: !0
                        }
                    },
                    CUBIC: {
                        "": {
                            name: "",
                            value: 1,
                            scientific: !0
                        },
                        da: {
                            name: "da",
                            value: 1e3,
                            scientific: !1
                        },
                        h: {
                            name: "h",
                            value: 1e6,
                            scientific: !1
                        },
                        k: {
                            name: "k",
                            value: 1e9,
                            scientific: !0
                        },
                        M: {
                            name: "M",
                            value: 1e18,
                            scientific: !0
                        },
                        G: {
                            name: "G",
                            value: 1e27,
                            scientific: !0
                        },
                        T: {
                            name: "T",
                            value: 1e36,
                            scientific: !0
                        },
                        P: {
                            name: "P",
                            value: 1e45,
                            scientific: !0
                        },
                        E: {
                            name: "E",
                            value: 1e54,
                            scientific: !0
                        },
                        Z: {
                            name: "Z",
                            value: 1e63,
                            scientific: !0
                        },
                        Y: {
                            name: "Y",
                            value: 1e72,
                            scientific: !0
                        },
                        d: {
                            name: "d",
                            value: .001,
                            scientific: !1
                        },
                        c: {
                            name: "c",
                            value: 1e-6,
                            scientific: !1
                        },
                        m: {
                            name: "m",
                            value: 1e-9,
                            scientific: !0
                        },
                        u: {
                            name: "u",
                            value: 1e-18,
                            scientific: !0
                        },
                        n: {
                            name: "n",
                            value: 1e-27,
                            scientific: !0
                        },
                        p: {
                            name: "p",
                            value: 1e-36,
                            scientific: !0
                        },
                        f: {
                            name: "f",
                            value: 1e-45,
                            scientific: !0
                        },
                        a: {
                            name: "a",
                            value: 1e-54,
                            scientific: !0
                        },
                        z: {
                            name: "z",
                            value: 1e-63,
                            scientific: !0
                        },
                        y: {
                            name: "y",
                            value: 1e-72,
                            scientific: !0
                        }
                    },
                    BINARY_SHORT_SI: {
                        "": {
                            name: "",
                            value: 1,
                            scientific: !0
                        },
                        k: {
                            name: "k",
                            value: 1e3,
                            scientific: !0
                        },
                        M: {
                            name: "M",
                            value: 1e6,
                            scientific: !0
                        },
                        G: {
                            name: "G",
                            value: 1e9,
                            scientific: !0
                        },
                        T: {
                            name: "T",
                            value: 1e12,
                            scientific: !0
                        },
                        P: {
                            name: "P",
                            value: 1e15,
                            scientific: !0
                        },
                        E: {
                            name: "E",
                            value: 1e18,
                            scientific: !0
                        },
                        Z: {
                            name: "Z",
                            value: 1e21,
                            scientific: !0
                        },
                        Y: {
                            name: "Y",
                            value: 1e24,
                            scientific: !0
                        }
                    },
                    BINARY_SHORT_IEC: {
                        "": {
                            name: "",
                            value: 1,
                            scientific: !0
                        },
                        Ki: {
                            name: "Ki",
                            value: 1024,
                            scientific: !0
                        },
                        Mi: {
                            name: "Mi",
                            value: Math.pow(1024, 2),
                            scientific: !0
                        },
                        Gi: {
                            name: "Gi",
                            value: Math.pow(1024, 3),
                            scientific: !0
                        },
                        Ti: {
                            name: "Ti",
                            value: Math.pow(1024, 4),
                            scientific: !0
                        },
                        Pi: {
                            name: "Pi",
                            value: Math.pow(1024, 5),
                            scientific: !0
                        },
                        Ei: {
                            name: "Ei",
                            value: Math.pow(1024, 6),
                            scientific: !0
                        },
                        Zi: {
                            name: "Zi",
                            value: Math.pow(1024, 7),
                            scientific: !0
                        },
                        Yi: {
                            name: "Yi",
                            value: Math.pow(1024, 8),
                            scientific: !0
                        }
                    },
                    BINARY_LONG_SI: {
                        "": {
                            name: "",
                            value: 1,
                            scientific: !0
                        },
                        kilo: {
                            name: "kilo",
                            value: 1e3,
                            scientific: !0
                        },
                        mega: {
                            name: "mega",
                            value: 1e6,
                            scientific: !0
                        },
                        giga: {
                            name: "giga",
                            value: 1e9,
                            scientific: !0
                        },
                        tera: {
                            name: "tera",
                            value: 1e12,
                            scientific: !0
                        },
                        peta: {
                            name: "peta",
                            value: 1e15,
                            scientific: !0
                        },
                        exa: {
                            name: "exa",
                            value: 1e18,
                            scientific: !0
                        },
                        zetta: {
                            name: "zetta",
                            value: 1e21,
                            scientific: !0
                        },
                        yotta: {
                            name: "yotta",
                            value: 1e24,
                            scientific: !0
                        }
                    },
                    BINARY_LONG_IEC: {
                        "": {
                            name: "",
                            value: 1,
                            scientific: !0
                        },
                        kibi: {
                            name: "kibi",
                            value: 1024,
                            scientific: !0
                        },
                        mebi: {
                            name: "mebi",
                            value: Math.pow(1024, 2),
                            scientific: !0
                        },
                        gibi: {
                            name: "gibi",
                            value: Math.pow(1024, 3),
                            scientific: !0
                        },
                        tebi: {
                            name: "tebi",
                            value: Math.pow(1024, 4),
                            scientific: !0
                        },
                        pebi: {
                            name: "pebi",
                            value: Math.pow(1024, 5),
                            scientific: !0
                        },
                        exi: {
                            name: "exi",
                            value: Math.pow(1024, 6),
                            scientific: !0
                        },
                        zebi: {
                            name: "zebi",
                            value: Math.pow(1024, 7),
                            scientific: !0
                        },
                        yobi: {
                            name: "yobi",
                            value: Math.pow(1024, 8),
                            scientific: !0
                        }
                    },
                    BTU: {
                        "": {
                            name: "",
                            value: 1,
                            scientific: !0
                        },
                        MM: {
                            name: "MM",
                            value: 1e6,
                            scientific: !0
                        }
                    }
                };
                I.SHORTLONG = m()({}, I.SHORT, I.LONG), I.BINARY_SHORT = m()({}, I.BINARY_SHORT_SI, I.BINARY_SHORT_IEC), I.BINARY_LONG = m()({}, I.BINARY_LONG_SI, I.BINARY_LONG_IEC);
                var B = [
                    "MASS",
                    "LENGTH",
                    "TIME",
                    "CURRENT",
                    "TEMPERATURE",
                    "LUMINOUS_INTENSITY",
                    "AMOUNT_OF_SUBSTANCE",
                    "ANGLE",
                    "BIT"
                ], j = {
                    NONE: {
                        dimensions: [
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0
                        ]
                    },
                    MASS: {
                        dimensions: [
                            1,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0
                        ]
                    },
                    LENGTH: {
                        dimensions: [
                            0,
                            1,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0
                        ]
                    },
                    TIME: {
                        dimensions: [
                            0,
                            0,
                            1,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0
                        ]
                    },
                    CURRENT: {
                        dimensions: [
                            0,
                            0,
                            0,
                            1,
                            0,
                            0,
                            0,
                            0,
                            0
                        ]
                    },
                    TEMPERATURE: {
                        dimensions: [
                            0,
                            0,
                            0,
                            0,
                            1,
                            0,
                            0,
                            0,
                            0
                        ]
                    },
                    LUMINOUS_INTENSITY: {
                        dimensions: [
                            0,
                            0,
                            0,
                            0,
                            0,
                            1,
                            0,
                            0,
                            0
                        ]
                    },
                    AMOUNT_OF_SUBSTANCE: {
                        dimensions: [
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            1,
                            0,
                            0
                        ]
                    },
                    FORCE: {
                        dimensions: [
                            1,
                            1,
                            -2,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0
                        ]
                    },
                    SURFACE: {
                        dimensions: [
                            0,
                            2,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0
                        ]
                    },
                    VOLUME: {
                        dimensions: [
                            0,
                            3,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0
                        ]
                    },
                    ENERGY: {
                        dimensions: [
                            1,
                            2,
                            -2,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0
                        ]
                    },
                    POWER: {
                        dimensions: [
                            1,
                            2,
                            -3,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0
                        ]
                    },
                    PRESSURE: {
                        dimensions: [
                            1,
                            -1,
                            -2,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0
                        ]
                    },
                    ELECTRIC_CHARGE: {
                        dimensions: [
                            0,
                            0,
                            1,
                            1,
                            0,
                            0,
                            0,
                            0,
                            0
                        ]
                    },
                    ELECTRIC_CAPACITANCE: {
                        dimensions: [
                            -1,
                            -2,
                            4,
                            2,
                            0,
                            0,
                            0,
                            0,
                            0
                        ]
                    },
                    ELECTRIC_POTENTIAL: {
                        dimensions: [
                            1,
                            2,
                            -3,
                            -1,
                            0,
                            0,
                            0,
                            0,
                            0
                        ]
                    },
                    ELECTRIC_RESISTANCE: {
                        dimensions: [
                            1,
                            2,
                            -3,
                            -2,
                            0,
                            0,
                            0,
                            0,
                            0
                        ]
                    },
                    ELECTRIC_INDUCTANCE: {
                        dimensions: [
                            1,
                            2,
                            -2,
                            -2,
                            0,
                            0,
                            0,
                            0,
                            0
                        ]
                    },
                    ELECTRIC_CONDUCTANCE: {
                        dimensions: [
                            -1,
                            -2,
                            3,
                            2,
                            0,
                            0,
                            0,
                            0,
                            0
                        ]
                    },
                    MAGNETIC_FLUX: {
                        dimensions: [
                            1,
                            2,
                            -2,
                            -1,
                            0,
                            0,
                            0,
                            0,
                            0
                        ]
                    },
                    MAGNETIC_FLUX_DENSITY: {
                        dimensions: [
                            1,
                            0,
                            -2,
                            -1,
                            0,
                            0,
                            0,
                            0,
                            0
                        ]
                    },
                    FREQUENCY: {
                        dimensions: [
                            0,
                            0,
                            -1,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0
                        ]
                    },
                    ANGLE: {
                        dimensions: [
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            1,
                            0
                        ]
                    },
                    BIT: {
                        dimensions: [
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            1
                        ]
                    }
                };
                for(var R in j)ut(j, R) && (j[R].key = R);
                var L = {
                    name: "",
                    base: {},
                    value: 1,
                    offset: 0,
                    dimensions: B.map((t)=>0)
                }, q = {
                    meter: {
                        name: "meter",
                        base: j.LENGTH,
                        prefixes: I.LONG,
                        value: 1,
                        offset: 0
                    },
                    inch: {
                        name: "inch",
                        base: j.LENGTH,
                        prefixes: I.NONE,
                        value: .0254,
                        offset: 0
                    },
                    foot: {
                        name: "foot",
                        base: j.LENGTH,
                        prefixes: I.NONE,
                        value: .3048,
                        offset: 0
                    },
                    yard: {
                        name: "yard",
                        base: j.LENGTH,
                        prefixes: I.NONE,
                        value: .9144,
                        offset: 0
                    },
                    mile: {
                        name: "mile",
                        base: j.LENGTH,
                        prefixes: I.NONE,
                        value: 1609.344,
                        offset: 0
                    },
                    link: {
                        name: "link",
                        base: j.LENGTH,
                        prefixes: I.NONE,
                        value: .201168,
                        offset: 0
                    },
                    rod: {
                        name: "rod",
                        base: j.LENGTH,
                        prefixes: I.NONE,
                        value: 5.0292,
                        offset: 0
                    },
                    chain: {
                        name: "chain",
                        base: j.LENGTH,
                        prefixes: I.NONE,
                        value: 20.1168,
                        offset: 0
                    },
                    angstrom: {
                        name: "angstrom",
                        base: j.LENGTH,
                        prefixes: I.NONE,
                        value: 1e-10,
                        offset: 0
                    },
                    m: {
                        name: "m",
                        base: j.LENGTH,
                        prefixes: I.SHORT,
                        value: 1,
                        offset: 0
                    },
                    in: {
                        name: "in",
                        base: j.LENGTH,
                        prefixes: I.NONE,
                        value: .0254,
                        offset: 0
                    },
                    ft: {
                        name: "ft",
                        base: j.LENGTH,
                        prefixes: I.NONE,
                        value: .3048,
                        offset: 0
                    },
                    yd: {
                        name: "yd",
                        base: j.LENGTH,
                        prefixes: I.NONE,
                        value: .9144,
                        offset: 0
                    },
                    mi: {
                        name: "mi",
                        base: j.LENGTH,
                        prefixes: I.NONE,
                        value: 1609.344,
                        offset: 0
                    },
                    li: {
                        name: "li",
                        base: j.LENGTH,
                        prefixes: I.NONE,
                        value: .201168,
                        offset: 0
                    },
                    rd: {
                        name: "rd",
                        base: j.LENGTH,
                        prefixes: I.NONE,
                        value: 5.02921,
                        offset: 0
                    },
                    ch: {
                        name: "ch",
                        base: j.LENGTH,
                        prefixes: I.NONE,
                        value: 20.1168,
                        offset: 0
                    },
                    mil: {
                        name: "mil",
                        base: j.LENGTH,
                        prefixes: I.NONE,
                        value: 254e-7,
                        offset: 0
                    },
                    m2: {
                        name: "m2",
                        base: j.SURFACE,
                        prefixes: I.SQUARED,
                        value: 1,
                        offset: 0
                    },
                    sqin: {
                        name: "sqin",
                        base: j.SURFACE,
                        prefixes: I.NONE,
                        value: 64516e-8,
                        offset: 0
                    },
                    sqft: {
                        name: "sqft",
                        base: j.SURFACE,
                        prefixes: I.NONE,
                        value: .09290304,
                        offset: 0
                    },
                    sqyd: {
                        name: "sqyd",
                        base: j.SURFACE,
                        prefixes: I.NONE,
                        value: .83612736,
                        offset: 0
                    },
                    sqmi: {
                        name: "sqmi",
                        base: j.SURFACE,
                        prefixes: I.NONE,
                        value: 2589988.110336,
                        offset: 0
                    },
                    sqrd: {
                        name: "sqrd",
                        base: j.SURFACE,
                        prefixes: I.NONE,
                        value: 25.29295,
                        offset: 0
                    },
                    sqch: {
                        name: "sqch",
                        base: j.SURFACE,
                        prefixes: I.NONE,
                        value: 404.6873,
                        offset: 0
                    },
                    sqmil: {
                        name: "sqmil",
                        base: j.SURFACE,
                        prefixes: I.NONE,
                        value: 6.4516e-10,
                        offset: 0
                    },
                    acre: {
                        name: "acre",
                        base: j.SURFACE,
                        prefixes: I.NONE,
                        value: 4046.86,
                        offset: 0
                    },
                    hectare: {
                        name: "hectare",
                        base: j.SURFACE,
                        prefixes: I.NONE,
                        value: 1e4,
                        offset: 0
                    },
                    m3: {
                        name: "m3",
                        base: j.VOLUME,
                        prefixes: I.CUBIC,
                        value: 1,
                        offset: 0
                    },
                    L: {
                        name: "L",
                        base: j.VOLUME,
                        prefixes: I.SHORT,
                        value: .001,
                        offset: 0
                    },
                    l: {
                        name: "l",
                        base: j.VOLUME,
                        prefixes: I.SHORT,
                        value: .001,
                        offset: 0
                    },
                    litre: {
                        name: "litre",
                        base: j.VOLUME,
                        prefixes: I.LONG,
                        value: .001,
                        offset: 0
                    },
                    cuin: {
                        name: "cuin",
                        base: j.VOLUME,
                        prefixes: I.NONE,
                        value: 16387064e-12,
                        offset: 0
                    },
                    cuft: {
                        name: "cuft",
                        base: j.VOLUME,
                        prefixes: I.NONE,
                        value: .028316846592,
                        offset: 0
                    },
                    cuyd: {
                        name: "cuyd",
                        base: j.VOLUME,
                        prefixes: I.NONE,
                        value: .764554857984,
                        offset: 0
                    },
                    teaspoon: {
                        name: "teaspoon",
                        base: j.VOLUME,
                        prefixes: I.NONE,
                        value: 5e-6,
                        offset: 0
                    },
                    tablespoon: {
                        name: "tablespoon",
                        base: j.VOLUME,
                        prefixes: I.NONE,
                        value: 15e-6,
                        offset: 0
                    },
                    drop: {
                        name: "drop",
                        base: j.VOLUME,
                        prefixes: I.NONE,
                        value: 5e-8,
                        offset: 0
                    },
                    gtt: {
                        name: "gtt",
                        base: j.VOLUME,
                        prefixes: I.NONE,
                        value: 5e-8,
                        offset: 0
                    },
                    minim: {
                        name: "minim",
                        base: j.VOLUME,
                        prefixes: I.NONE,
                        value: 6.161152e-8,
                        offset: 0
                    },
                    fluiddram: {
                        name: "fluiddram",
                        base: j.VOLUME,
                        prefixes: I.NONE,
                        value: 36966911e-13,
                        offset: 0
                    },
                    fluidounce: {
                        name: "fluidounce",
                        base: j.VOLUME,
                        prefixes: I.NONE,
                        value: 2957353e-11,
                        offset: 0
                    },
                    gill: {
                        name: "gill",
                        base: j.VOLUME,
                        prefixes: I.NONE,
                        value: .0001182941,
                        offset: 0
                    },
                    cc: {
                        name: "cc",
                        base: j.VOLUME,
                        prefixes: I.NONE,
                        value: 1e-6,
                        offset: 0
                    },
                    cup: {
                        name: "cup",
                        base: j.VOLUME,
                        prefixes: I.NONE,
                        value: .0002365882,
                        offset: 0
                    },
                    pint: {
                        name: "pint",
                        base: j.VOLUME,
                        prefixes: I.NONE,
                        value: .0004731765,
                        offset: 0
                    },
                    quart: {
                        name: "quart",
                        base: j.VOLUME,
                        prefixes: I.NONE,
                        value: .0009463529,
                        offset: 0
                    },
                    gallon: {
                        name: "gallon",
                        base: j.VOLUME,
                        prefixes: I.NONE,
                        value: .003785412,
                        offset: 0
                    },
                    beerbarrel: {
                        name: "beerbarrel",
                        base: j.VOLUME,
                        prefixes: I.NONE,
                        value: .1173478,
                        offset: 0
                    },
                    oilbarrel: {
                        name: "oilbarrel",
                        base: j.VOLUME,
                        prefixes: I.NONE,
                        value: .1589873,
                        offset: 0
                    },
                    hogshead: {
                        name: "hogshead",
                        base: j.VOLUME,
                        prefixes: I.NONE,
                        value: .238481,
                        offset: 0
                    },
                    fldr: {
                        name: "fldr",
                        base: j.VOLUME,
                        prefixes: I.NONE,
                        value: 36966911e-13,
                        offset: 0
                    },
                    floz: {
                        name: "floz",
                        base: j.VOLUME,
                        prefixes: I.NONE,
                        value: 2957353e-11,
                        offset: 0
                    },
                    gi: {
                        name: "gi",
                        base: j.VOLUME,
                        prefixes: I.NONE,
                        value: .0001182941,
                        offset: 0
                    },
                    cp: {
                        name: "cp",
                        base: j.VOLUME,
                        prefixes: I.NONE,
                        value: .0002365882,
                        offset: 0
                    },
                    pt: {
                        name: "pt",
                        base: j.VOLUME,
                        prefixes: I.NONE,
                        value: .0004731765,
                        offset: 0
                    },
                    qt: {
                        name: "qt",
                        base: j.VOLUME,
                        prefixes: I.NONE,
                        value: .0009463529,
                        offset: 0
                    },
                    gal: {
                        name: "gal",
                        base: j.VOLUME,
                        prefixes: I.NONE,
                        value: .003785412,
                        offset: 0
                    },
                    bbl: {
                        name: "bbl",
                        base: j.VOLUME,
                        prefixes: I.NONE,
                        value: .1173478,
                        offset: 0
                    },
                    obl: {
                        name: "obl",
                        base: j.VOLUME,
                        prefixes: I.NONE,
                        value: .1589873,
                        offset: 0
                    },
                    g: {
                        name: "g",
                        base: j.MASS,
                        prefixes: I.SHORT,
                        value: .001,
                        offset: 0
                    },
                    gram: {
                        name: "gram",
                        base: j.MASS,
                        prefixes: I.LONG,
                        value: .001,
                        offset: 0
                    },
                    ton: {
                        name: "ton",
                        base: j.MASS,
                        prefixes: I.SHORT,
                        value: 907.18474,
                        offset: 0
                    },
                    t: {
                        name: "t",
                        base: j.MASS,
                        prefixes: I.SHORT,
                        value: 1e3,
                        offset: 0
                    },
                    tonne: {
                        name: "tonne",
                        base: j.MASS,
                        prefixes: I.LONG,
                        value: 1e3,
                        offset: 0
                    },
                    grain: {
                        name: "grain",
                        base: j.MASS,
                        prefixes: I.NONE,
                        value: 6479891e-11,
                        offset: 0
                    },
                    dram: {
                        name: "dram",
                        base: j.MASS,
                        prefixes: I.NONE,
                        value: .0017718451953125,
                        offset: 0
                    },
                    ounce: {
                        name: "ounce",
                        base: j.MASS,
                        prefixes: I.NONE,
                        value: .028349523125,
                        offset: 0
                    },
                    poundmass: {
                        name: "poundmass",
                        base: j.MASS,
                        prefixes: I.NONE,
                        value: .45359237,
                        offset: 0
                    },
                    hundredweight: {
                        name: "hundredweight",
                        base: j.MASS,
                        prefixes: I.NONE,
                        value: 45.359237,
                        offset: 0
                    },
                    stick: {
                        name: "stick",
                        base: j.MASS,
                        prefixes: I.NONE,
                        value: .115,
                        offset: 0
                    },
                    stone: {
                        name: "stone",
                        base: j.MASS,
                        prefixes: I.NONE,
                        value: 6.35029318,
                        offset: 0
                    },
                    gr: {
                        name: "gr",
                        base: j.MASS,
                        prefixes: I.NONE,
                        value: 6479891e-11,
                        offset: 0
                    },
                    dr: {
                        name: "dr",
                        base: j.MASS,
                        prefixes: I.NONE,
                        value: .0017718451953125,
                        offset: 0
                    },
                    oz: {
                        name: "oz",
                        base: j.MASS,
                        prefixes: I.NONE,
                        value: .028349523125,
                        offset: 0
                    },
                    lbm: {
                        name: "lbm",
                        base: j.MASS,
                        prefixes: I.NONE,
                        value: .45359237,
                        offset: 0
                    },
                    cwt: {
                        name: "cwt",
                        base: j.MASS,
                        prefixes: I.NONE,
                        value: 45.359237,
                        offset: 0
                    },
                    s: {
                        name: "s",
                        base: j.TIME,
                        prefixes: I.SHORT,
                        value: 1,
                        offset: 0
                    },
                    min: {
                        name: "min",
                        base: j.TIME,
                        prefixes: I.NONE,
                        value: 60,
                        offset: 0
                    },
                    h: {
                        name: "h",
                        base: j.TIME,
                        prefixes: I.NONE,
                        value: 3600,
                        offset: 0
                    },
                    second: {
                        name: "second",
                        base: j.TIME,
                        prefixes: I.LONG,
                        value: 1,
                        offset: 0
                    },
                    sec: {
                        name: "sec",
                        base: j.TIME,
                        prefixes: I.LONG,
                        value: 1,
                        offset: 0
                    },
                    minute: {
                        name: "minute",
                        base: j.TIME,
                        prefixes: I.NONE,
                        value: 60,
                        offset: 0
                    },
                    hour: {
                        name: "hour",
                        base: j.TIME,
                        prefixes: I.NONE,
                        value: 3600,
                        offset: 0
                    },
                    day: {
                        name: "day",
                        base: j.TIME,
                        prefixes: I.NONE,
                        value: 86400,
                        offset: 0
                    },
                    week: {
                        name: "week",
                        base: j.TIME,
                        prefixes: I.NONE,
                        value: 604800,
                        offset: 0
                    },
                    month: {
                        name: "month",
                        base: j.TIME,
                        prefixes: I.NONE,
                        value: 2629800,
                        offset: 0
                    },
                    year: {
                        name: "year",
                        base: j.TIME,
                        prefixes: I.NONE,
                        value: 31557600,
                        offset: 0
                    },
                    decade: {
                        name: "decade",
                        base: j.TIME,
                        prefixes: I.NONE,
                        value: 315576e3,
                        offset: 0
                    },
                    century: {
                        name: "century",
                        base: j.TIME,
                        prefixes: I.NONE,
                        value: 315576e4,
                        offset: 0
                    },
                    millennium: {
                        name: "millennium",
                        base: j.TIME,
                        prefixes: I.NONE,
                        value: 315576e5,
                        offset: 0
                    },
                    hertz: {
                        name: "Hertz",
                        base: j.FREQUENCY,
                        prefixes: I.LONG,
                        value: 1,
                        offset: 0,
                        reciprocal: !0
                    },
                    Hz: {
                        name: "Hz",
                        base: j.FREQUENCY,
                        prefixes: I.SHORT,
                        value: 1,
                        offset: 0,
                        reciprocal: !0
                    },
                    rad: {
                        name: "rad",
                        base: j.ANGLE,
                        prefixes: I.SHORT,
                        value: 1,
                        offset: 0
                    },
                    radian: {
                        name: "radian",
                        base: j.ANGLE,
                        prefixes: I.LONG,
                        value: 1,
                        offset: 0
                    },
                    deg: {
                        name: "deg",
                        base: j.ANGLE,
                        prefixes: I.SHORT,
                        value: null,
                        offset: 0
                    },
                    degree: {
                        name: "degree",
                        base: j.ANGLE,
                        prefixes: I.LONG,
                        value: null,
                        offset: 0
                    },
                    grad: {
                        name: "grad",
                        base: j.ANGLE,
                        prefixes: I.SHORT,
                        value: null,
                        offset: 0
                    },
                    gradian: {
                        name: "gradian",
                        base: j.ANGLE,
                        prefixes: I.LONG,
                        value: null,
                        offset: 0
                    },
                    cycle: {
                        name: "cycle",
                        base: j.ANGLE,
                        prefixes: I.NONE,
                        value: null,
                        offset: 0
                    },
                    arcsec: {
                        name: "arcsec",
                        base: j.ANGLE,
                        prefixes: I.NONE,
                        value: null,
                        offset: 0
                    },
                    arcmin: {
                        name: "arcmin",
                        base: j.ANGLE,
                        prefixes: I.NONE,
                        value: null,
                        offset: 0
                    },
                    A: {
                        name: "A",
                        base: j.CURRENT,
                        prefixes: I.SHORT,
                        value: 1,
                        offset: 0
                    },
                    ampere: {
                        name: "ampere",
                        base: j.CURRENT,
                        prefixes: I.LONG,
                        value: 1,
                        offset: 0
                    },
                    K: {
                        name: "K",
                        base: j.TEMPERATURE,
                        prefixes: I.SHORT,
                        value: 1,
                        offset: 0
                    },
                    degC: {
                        name: "degC",
                        base: j.TEMPERATURE,
                        prefixes: I.SHORT,
                        value: 1,
                        offset: 273.15
                    },
                    degF: {
                        name: "degF",
                        base: j.TEMPERATURE,
                        prefixes: I.SHORT,
                        value: new A(5, 9),
                        offset: 459.67
                    },
                    degR: {
                        name: "degR",
                        base: j.TEMPERATURE,
                        prefixes: I.SHORT,
                        value: new A(5, 9),
                        offset: 0
                    },
                    kelvin: {
                        name: "kelvin",
                        base: j.TEMPERATURE,
                        prefixes: I.LONG,
                        value: 1,
                        offset: 0
                    },
                    celsius: {
                        name: "celsius",
                        base: j.TEMPERATURE,
                        prefixes: I.LONG,
                        value: 1,
                        offset: 273.15
                    },
                    fahrenheit: {
                        name: "fahrenheit",
                        base: j.TEMPERATURE,
                        prefixes: I.LONG,
                        value: new A(5, 9),
                        offset: 459.67
                    },
                    rankine: {
                        name: "rankine",
                        base: j.TEMPERATURE,
                        prefixes: I.LONG,
                        value: new A(5, 9),
                        offset: 0
                    },
                    mol: {
                        name: "mol",
                        base: j.AMOUNT_OF_SUBSTANCE,
                        prefixes: I.SHORT,
                        value: 1,
                        offset: 0
                    },
                    mole: {
                        name: "mole",
                        base: j.AMOUNT_OF_SUBSTANCE,
                        prefixes: I.LONG,
                        value: 1,
                        offset: 0
                    },
                    cd: {
                        name: "cd",
                        base: j.LUMINOUS_INTENSITY,
                        prefixes: I.SHORT,
                        value: 1,
                        offset: 0
                    },
                    candela: {
                        name: "candela",
                        base: j.LUMINOUS_INTENSITY,
                        prefixes: I.LONG,
                        value: 1,
                        offset: 0
                    },
                    N: {
                        name: "N",
                        base: j.FORCE,
                        prefixes: I.SHORT,
                        value: 1,
                        offset: 0
                    },
                    newton: {
                        name: "newton",
                        base: j.FORCE,
                        prefixes: I.LONG,
                        value: 1,
                        offset: 0
                    },
                    dyn: {
                        name: "dyn",
                        base: j.FORCE,
                        prefixes: I.SHORT,
                        value: 1e-5,
                        offset: 0
                    },
                    dyne: {
                        name: "dyne",
                        base: j.FORCE,
                        prefixes: I.LONG,
                        value: 1e-5,
                        offset: 0
                    },
                    lbf: {
                        name: "lbf",
                        base: j.FORCE,
                        prefixes: I.NONE,
                        value: 4.4482216152605,
                        offset: 0
                    },
                    poundforce: {
                        name: "poundforce",
                        base: j.FORCE,
                        prefixes: I.NONE,
                        value: 4.4482216152605,
                        offset: 0
                    },
                    kip: {
                        name: "kip",
                        base: j.FORCE,
                        prefixes: I.LONG,
                        value: 4448.2216,
                        offset: 0
                    },
                    kilogramforce: {
                        name: "kilogramforce",
                        base: j.FORCE,
                        prefixes: I.NONE,
                        value: 9.80665,
                        offset: 0
                    },
                    J: {
                        name: "J",
                        base: j.ENERGY,
                        prefixes: I.SHORT,
                        value: 1,
                        offset: 0
                    },
                    joule: {
                        name: "joule",
                        base: j.ENERGY,
                        prefixes: I.LONG,
                        value: 1,
                        offset: 0
                    },
                    erg: {
                        name: "erg",
                        base: j.ENERGY,
                        prefixes: I.SHORTLONG,
                        value: 1e-7,
                        offset: 0
                    },
                    Wh: {
                        name: "Wh",
                        base: j.ENERGY,
                        prefixes: I.SHORT,
                        value: 3600,
                        offset: 0
                    },
                    BTU: {
                        name: "BTU",
                        base: j.ENERGY,
                        prefixes: I.BTU,
                        value: 1055.05585262,
                        offset: 0
                    },
                    eV: {
                        name: "eV",
                        base: j.ENERGY,
                        prefixes: I.SHORT,
                        value: 1602176565e-28,
                        offset: 0
                    },
                    electronvolt: {
                        name: "electronvolt",
                        base: j.ENERGY,
                        prefixes: I.LONG,
                        value: 1602176565e-28,
                        offset: 0
                    },
                    W: {
                        name: "W",
                        base: j.POWER,
                        prefixes: I.SHORT,
                        value: 1,
                        offset: 0
                    },
                    watt: {
                        name: "watt",
                        base: j.POWER,
                        prefixes: I.LONG,
                        value: 1,
                        offset: 0
                    },
                    hp: {
                        name: "hp",
                        base: j.POWER,
                        prefixes: I.NONE,
                        value: 745.6998715386,
                        offset: 0
                    },
                    VAR: {
                        name: "VAR",
                        base: j.POWER,
                        prefixes: I.SHORT,
                        value: x.I,
                        offset: 0
                    },
                    VA: {
                        name: "VA",
                        base: j.POWER,
                        prefixes: I.SHORT,
                        value: 1,
                        offset: 0
                    },
                    Pa: {
                        name: "Pa",
                        base: j.PRESSURE,
                        prefixes: I.SHORT,
                        value: 1,
                        offset: 0
                    },
                    psi: {
                        name: "psi",
                        base: j.PRESSURE,
                        prefixes: I.NONE,
                        value: 6894.75729276459,
                        offset: 0
                    },
                    atm: {
                        name: "atm",
                        base: j.PRESSURE,
                        prefixes: I.NONE,
                        value: 101325,
                        offset: 0
                    },
                    bar: {
                        name: "bar",
                        base: j.PRESSURE,
                        prefixes: I.SHORTLONG,
                        value: 1e5,
                        offset: 0
                    },
                    torr: {
                        name: "torr",
                        base: j.PRESSURE,
                        prefixes: I.NONE,
                        value: 133.322,
                        offset: 0
                    },
                    mmHg: {
                        name: "mmHg",
                        base: j.PRESSURE,
                        prefixes: I.NONE,
                        value: 133.322,
                        offset: 0
                    },
                    mmH2O: {
                        name: "mmH2O",
                        base: j.PRESSURE,
                        prefixes: I.NONE,
                        value: 9.80665,
                        offset: 0
                    },
                    cmH2O: {
                        name: "cmH2O",
                        base: j.PRESSURE,
                        prefixes: I.NONE,
                        value: 98.0665,
                        offset: 0
                    },
                    coulomb: {
                        name: "coulomb",
                        base: j.ELECTRIC_CHARGE,
                        prefixes: I.LONG,
                        value: 1,
                        offset: 0
                    },
                    C: {
                        name: "C",
                        base: j.ELECTRIC_CHARGE,
                        prefixes: I.SHORT,
                        value: 1,
                        offset: 0
                    },
                    farad: {
                        name: "farad",
                        base: j.ELECTRIC_CAPACITANCE,
                        prefixes: I.LONG,
                        value: 1,
                        offset: 0
                    },
                    F: {
                        name: "F",
                        base: j.ELECTRIC_CAPACITANCE,
                        prefixes: I.SHORT,
                        value: 1,
                        offset: 0
                    },
                    volt: {
                        name: "volt",
                        base: j.ELECTRIC_POTENTIAL,
                        prefixes: I.LONG,
                        value: 1,
                        offset: 0
                    },
                    V: {
                        name: "V",
                        base: j.ELECTRIC_POTENTIAL,
                        prefixes: I.SHORT,
                        value: 1,
                        offset: 0
                    },
                    ohm: {
                        name: "ohm",
                        base: j.ELECTRIC_RESISTANCE,
                        prefixes: I.SHORTLONG,
                        value: 1,
                        offset: 0
                    },
                    henry: {
                        name: "henry",
                        base: j.ELECTRIC_INDUCTANCE,
                        prefixes: I.LONG,
                        value: 1,
                        offset: 0
                    },
                    H: {
                        name: "H",
                        base: j.ELECTRIC_INDUCTANCE,
                        prefixes: I.SHORT,
                        value: 1,
                        offset: 0
                    },
                    siemens: {
                        name: "siemens",
                        base: j.ELECTRIC_CONDUCTANCE,
                        prefixes: I.LONG,
                        value: 1,
                        offset: 0
                    },
                    S: {
                        name: "S",
                        base: j.ELECTRIC_CONDUCTANCE,
                        prefixes: I.SHORT,
                        value: 1,
                        offset: 0
                    },
                    weber: {
                        name: "weber",
                        base: j.MAGNETIC_FLUX,
                        prefixes: I.LONG,
                        value: 1,
                        offset: 0
                    },
                    Wb: {
                        name: "Wb",
                        base: j.MAGNETIC_FLUX,
                        prefixes: I.SHORT,
                        value: 1,
                        offset: 0
                    },
                    tesla: {
                        name: "tesla",
                        base: j.MAGNETIC_FLUX_DENSITY,
                        prefixes: I.LONG,
                        value: 1,
                        offset: 0
                    },
                    T: {
                        name: "T",
                        base: j.MAGNETIC_FLUX_DENSITY,
                        prefixes: I.SHORT,
                        value: 1,
                        offset: 0
                    },
                    b: {
                        name: "b",
                        base: j.BIT,
                        prefixes: I.BINARY_SHORT,
                        value: 1,
                        offset: 0
                    },
                    bits: {
                        name: "bits",
                        base: j.BIT,
                        prefixes: I.BINARY_LONG,
                        value: 1,
                        offset: 0
                    },
                    B: {
                        name: "B",
                        base: j.BIT,
                        prefixes: I.BINARY_SHORT,
                        value: 8,
                        offset: 0
                    },
                    bytes: {
                        name: "bytes",
                        base: j.BIT,
                        prefixes: I.BINARY_LONG,
                        value: 8,
                        offset: 0
                    }
                }, U = {
                    meters: "meter",
                    inches: "inch",
                    feet: "foot",
                    yards: "yard",
                    miles: "mile",
                    links: "link",
                    rods: "rod",
                    chains: "chain",
                    angstroms: "angstrom",
                    lt: "l",
                    litres: "litre",
                    liter: "litre",
                    liters: "litre",
                    teaspoons: "teaspoon",
                    tablespoons: "tablespoon",
                    minims: "minim",
                    fluiddrams: "fluiddram",
                    fluidounces: "fluidounce",
                    gills: "gill",
                    cups: "cup",
                    pints: "pint",
                    quarts: "quart",
                    gallons: "gallon",
                    beerbarrels: "beerbarrel",
                    oilbarrels: "oilbarrel",
                    hogsheads: "hogshead",
                    gtts: "gtt",
                    grams: "gram",
                    tons: "ton",
                    tonnes: "tonne",
                    grains: "grain",
                    drams: "dram",
                    ounces: "ounce",
                    poundmasses: "poundmass",
                    hundredweights: "hundredweight",
                    sticks: "stick",
                    lb: "lbm",
                    lbs: "lbm",
                    kips: "kip",
                    kgf: "kilogramforce",
                    acres: "acre",
                    hectares: "hectare",
                    sqfeet: "sqft",
                    sqyard: "sqyd",
                    sqmile: "sqmi",
                    sqmiles: "sqmi",
                    mmhg: "mmHg",
                    mmh2o: "mmH2O",
                    cmh2o: "cmH2O",
                    seconds: "second",
                    secs: "second",
                    minutes: "minute",
                    mins: "minute",
                    hours: "hour",
                    hr: "hour",
                    hrs: "hour",
                    days: "day",
                    weeks: "week",
                    months: "month",
                    years: "year",
                    decades: "decade",
                    centuries: "century",
                    millennia: "millennium",
                    hertz: "hertz",
                    radians: "radian",
                    degrees: "degree",
                    gradians: "gradian",
                    cycles: "cycle",
                    arcsecond: "arcsec",
                    arcseconds: "arcsec",
                    arcminute: "arcmin",
                    arcminutes: "arcmin",
                    BTUs: "BTU",
                    watts: "watt",
                    joules: "joule",
                    amperes: "ampere",
                    amps: "ampere",
                    amp: "ampere",
                    coulombs: "coulomb",
                    volts: "volt",
                    ohms: "ohm",
                    farads: "farad",
                    webers: "weber",
                    teslas: "tesla",
                    electronvolts: "electronvolt",
                    moles: "mole",
                    bit: "bits",
                    byte: "bytes"
                };
                function z(t) {
                    if ("BigNumber" === t.number) {
                        var e = li(_);
                        q.rad.value = new _(1), q.deg.value = e.div(180), q.grad.value = e.div(200), q.cycle.value = e.times(2), q.arcsec.value = e.div(648e3), q.arcmin.value = e.div(10800);
                    } else q.rad.value = 1, q.deg.value = Math.PI / 180, q.grad.value = Math.PI / 200, q.cycle.value = 2 * Math.PI, q.arcsec.value = Math.PI / 648e3, q.arcmin.value = Math.PI / 10800;
                    q.radian.value = q.rad.value, q.degree.value = q.deg.value, q.gradian.value = q.grad.value;
                }
                z(o), i && i("config", function(t, e) {
                    t.number !== e.number && z(t);
                });
                var G = {
                    si: {
                        NONE: {
                            unit: L,
                            prefix: I.NONE[""]
                        },
                        LENGTH: {
                            unit: q.m,
                            prefix: I.SHORT[""]
                        },
                        MASS: {
                            unit: q.g,
                            prefix: I.SHORT.k
                        },
                        TIME: {
                            unit: q.s,
                            prefix: I.SHORT[""]
                        },
                        CURRENT: {
                            unit: q.A,
                            prefix: I.SHORT[""]
                        },
                        TEMPERATURE: {
                            unit: q.K,
                            prefix: I.SHORT[""]
                        },
                        LUMINOUS_INTENSITY: {
                            unit: q.cd,
                            prefix: I.SHORT[""]
                        },
                        AMOUNT_OF_SUBSTANCE: {
                            unit: q.mol,
                            prefix: I.SHORT[""]
                        },
                        ANGLE: {
                            unit: q.rad,
                            prefix: I.SHORT[""]
                        },
                        BIT: {
                            unit: q.bits,
                            prefix: I.SHORT[""]
                        },
                        FORCE: {
                            unit: q.N,
                            prefix: I.SHORT[""]
                        },
                        ENERGY: {
                            unit: q.J,
                            prefix: I.SHORT[""]
                        },
                        POWER: {
                            unit: q.W,
                            prefix: I.SHORT[""]
                        },
                        PRESSURE: {
                            unit: q.Pa,
                            prefix: I.SHORT[""]
                        },
                        ELECTRIC_CHARGE: {
                            unit: q.C,
                            prefix: I.SHORT[""]
                        },
                        ELECTRIC_CAPACITANCE: {
                            unit: q.F,
                            prefix: I.SHORT[""]
                        },
                        ELECTRIC_POTENTIAL: {
                            unit: q.V,
                            prefix: I.SHORT[""]
                        },
                        ELECTRIC_RESISTANCE: {
                            unit: q.ohm,
                            prefix: I.SHORT[""]
                        },
                        ELECTRIC_INDUCTANCE: {
                            unit: q.H,
                            prefix: I.SHORT[""]
                        },
                        ELECTRIC_CONDUCTANCE: {
                            unit: q.S,
                            prefix: I.SHORT[""]
                        },
                        MAGNETIC_FLUX: {
                            unit: q.Wb,
                            prefix: I.SHORT[""]
                        },
                        MAGNETIC_FLUX_DENSITY: {
                            unit: q.T,
                            prefix: I.SHORT[""]
                        },
                        FREQUENCY: {
                            unit: q.Hz,
                            prefix: I.SHORT[""]
                        }
                    }
                };
                G.cgs = JSON.parse(JSON.stringify(G.si)), G.cgs.LENGTH = {
                    unit: q.m,
                    prefix: I.SHORT.c
                }, G.cgs.MASS = {
                    unit: q.g,
                    prefix: I.SHORT[""]
                }, G.cgs.FORCE = {
                    unit: q.dyn,
                    prefix: I.SHORT[""]
                }, G.cgs.ENERGY = {
                    unit: q.erg,
                    prefix: I.NONE[""]
                }, G.us = JSON.parse(JSON.stringify(G.si)), G.us.LENGTH = {
                    unit: q.ft,
                    prefix: I.NONE[""]
                }, G.us.MASS = {
                    unit: q.lbm,
                    prefix: I.NONE[""]
                }, G.us.TEMPERATURE = {
                    unit: q.degF,
                    prefix: I.NONE[""]
                }, G.us.FORCE = {
                    unit: q.lbf,
                    prefix: I.NONE[""]
                }, G.us.ENERGY = {
                    unit: q.BTU,
                    prefix: I.BTU[""]
                }, G.us.POWER = {
                    unit: q.hp,
                    prefix: I.NONE[""]
                }, G.us.PRESSURE = {
                    unit: q.psi,
                    prefix: I.NONE[""]
                }, G.auto = JSON.parse(JSON.stringify(G.si));
                var H = G.auto;
                for(var W in S.setUnitSystem = function(t) {
                    if (!ut(G, t)) throw new Error("Unit system " + t + " does not exist. Choices are: " + Object.keys(G).join(", "));
                    H = G[t];
                }, S.getUnitSystem = function() {
                    for(var t in G)if (ut(G, t) && G[t] === H) return t;
                }, S.typeConverters = {
                    BigNumber: function(t) {
                        return null != t && t.isFraction ? new _(t.n).div(t.d).times(t.s) : new _(t + "");
                    },
                    Fraction: function(t) {
                        return new A(t);
                    },
                    Complex: function(t) {
                        return t;
                    },
                    number: function(t) {
                        return null != t && t.isFraction ? v(t) : t;
                    }
                }, S.prototype._numberConverter = function() {
                    var t = S.typeConverters[this.valueType()];
                    if (t) return t;
                    throw new TypeError('Unsupported Unit value type "' + this.valueType() + '"');
                }, S._getNumberConverter = function(t) {
                    if (!S.typeConverters[t]) throw new TypeError('Unsupported type "' + t + '"');
                    return S.typeConverters[t];
                }, q)if (ut(q, W)) {
                    var $ = q[W];
                    $.dimensions = $.base.dimensions;
                }
                for(var V in U)if (ut(U, V)) {
                    var Z = q[U[V]], Y = {};
                    for(var K in Z)ut(Z, K) && (Y[K] = Z[K]);
                    Y.name = V, q[V] = Y;
                }
                return S.isValidAlpha = function(t) {
                    return /^[a-zA-Z]$/.test(t);
                }, S.createUnit = function(t, e) {
                    if ("object" != typeof t) throw new TypeError("createUnit expects first parameter to be of type 'Object'");
                    if (e && e.override) {
                        for(var r in t)if (ut(t, r) && S.deleteUnit(r), t[r].aliases) for(var n = 0; n < t[r].aliases.length; n++)S.deleteUnit(t[r].aliases[n]);
                    }
                    var i;
                    for(var o in t)ut(t, o) && (i = S.createUnitSingle(o, t[o]));
                    return i;
                }, S.createUnitSingle = function(t, e) {
                    if (null == e && (e = {}), "string" != typeof t) throw new TypeError("createUnitSingle expects first parameter to be of type 'string'");
                    if (ut(q, t)) throw new Error('Cannot create unit "' + t + '": a unit with that name already exists');
                    !function(t) {
                        for(var e = 0; e < t.length; e++){
                            if (n = t.charAt(e), 0 === e && !S.isValidAlpha(n)) throw new Error('Invalid unit name (must begin with alpha character): "' + t + '"');
                            if (e > 0 && !S.isValidAlpha(n) && !k(n)) throw new Error('Invalid unit name (only alphanumeric characters are allowed): "' + t + '"');
                        }
                    }(t);
                    var r, i, o, a = null, s = [], u = 0;
                    if (e && "Unit" === e.type) a = e.clone();
                    else if ("string" == typeof e) "" !== e && (r = e);
                    else {
                        if ("object" != typeof e) throw new TypeError('Cannot create unit "' + t + '" from "' + e.toString() + '": expecting "string" or "Unit" or "Object"');
                        r = e.definition, i = e.prefixes, u = e.offset, o = e.baseName, e.aliases && (s = e.aliases.valueOf());
                    }
                    if (s) {
                        for(var l = 0; l < s.length; l++)if (ut(q, s[l])) throw new Error('Cannot create alias "' + s[l] + '": a unit with that name already exists');
                    }
                    if (r && "string" == typeof r && !a) try {
                        a = S.parse(r, {
                            allowNoUnits: !0
                        });
                    } catch (e) {
                        throw e.message = 'Could not create unit "' + t + '" from "' + r + '": ' + e.message, e;
                    }
                    else r && "Unit" === r.type && (a = r.clone());
                    s = s || [], u = u || 0, i = i && i.toUpperCase && I[i.toUpperCase()] || I.NONE;
                    var c = {};
                    if (a) {
                        c = {
                            name: t,
                            value: a.value,
                            dimensions: a.dimensions.slice(0),
                            prefixes: i,
                            offset: u
                        };
                        var f = !1;
                        for(var h in j)if (ut(j, h)) {
                            for(var p = !0, d = 0; d < B.length; d++)if (Math.abs((c.dimensions[d] || 0) - (j[h].dimensions[d] || 0)) > 1e-12) {
                                p = !1;
                                break;
                            }
                            if (p) {
                                f = !0, c.base = j[h];
                                break;
                            }
                        }
                        if (!f) {
                            o = o || t + "_STUFF";
                            var m = {
                                dimensions: a.dimensions.slice(0)
                            };
                            m.key = o, j[o] = m, H[o] = {
                                unit: c,
                                prefix: I.NONE[""]
                            }, c.base = j[o];
                        }
                    } else {
                        if (o = o || t + "_STUFF", B.indexOf(o) >= 0) throw new Error('Cannot create new base unit "' + t + '": a base unit with that name already exists (and cannot be overridden)');
                        for(var y in B.push(o), j)ut(j, y) && (j[y].dimensions[B.length - 1] = 0);
                        for(var g = {
                            dimensions: []
                        }, v = 0; v < B.length; v++)g.dimensions[v] = 0;
                        g.dimensions[B.length - 1] = 1, g.key = o, j[o] = g, c = {
                            name: t,
                            value: 1,
                            dimensions: j[o].dimensions.slice(0),
                            prefixes: i,
                            offset: u,
                            base: j[o]
                        }, H[o] = {
                            unit: c,
                            prefix: I.NONE[""]
                        };
                    }
                    S.UNITS[t] = c;
                    for(var b = 0; b < s.length; b++){
                        var x = s[b], w = {};
                        for(var _ in c)ut(c, _) && (w[_] = c[_]);
                        w.name = x, S.UNITS[x] = w;
                    }
                    return delete F.cache, new S(null, t);
                }, S.deleteUnit = function(t) {
                    delete S.UNITS[t];
                }, S.PREFIXES = I, S.BASE_DIMENSIONS = B, S.BASE_UNITS = j, S.UNIT_SYSTEMS = G, S.UNITS = q, S;
            }, {
                isClass: !0
            }), qf = ge("dotPow", [
                "typed",
                "equalScalar",
                "matrix",
                "pow",
                "DenseMatrix",
                "concat"
            ], (t)=>{
                var { typed: e, equalScalar: r, matrix: n, pow: i, DenseMatrix: o, concat: a } = t, s = ul({
                    typed: e
                }), u = ll({
                    typed: e,
                    DenseMatrix: o
                }), l = cl({
                    typed: e,
                    equalScalar: r
                }), c = fl({
                    typed: e,
                    DenseMatrix: o
                }), f = ml({
                    typed: e,
                    matrix: n,
                    concat: a
                }), h = {};
                for(var p in i.signatures)Object.prototype.hasOwnProperty.call(i.signatures, p) && (p.includes("Matrix") || p.includes("Array") || (h[p] = i.signatures[p]));
                var d = e(h);
                return e("dotPow", f({
                    elop: d,
                    SS: u,
                    DS: s,
                    Ss: l,
                    sS: c
                }));
            }), Uf = ge("expm", [
                "typed",
                "abs",
                "add",
                "identity",
                "inv",
                "multiply"
            ], (t)=>{
                var { typed: e, abs: r, add: n, identity: i, inv: o, multiply: a } = t;
                return e("expm", {
                    Matrix: function(t) {
                        var e = t.size();
                        if (2 !== e.length || e[0] !== e[1]) throw new RangeError("Matrix must be square (size: " + Lt(e) + ")");
                        for(var u = e[0], l = function(t, e) {
                            for(var r = 0; r < 30; r++)for(var n = 0; n <= r; n++){
                                var i = r - n;
                                if (s(t, n, i) < e) return {
                                    q: n,
                                    j: i
                                };
                            }
                            throw new Error("Could not find acceptable parameters to compute the matrix exponential (try increasing maxSearchSize in expm.js)");
                        }(function(t) {
                            for(var e = t.size()[0], n = 0, i = 0; i < e; i++){
                                for(var o = 0, a = 0; a < e; a++)o += r(t.get([
                                    i,
                                    a
                                ]));
                                n = Math.max(o, n);
                            }
                            return n;
                        }(t), 1e-15), c = l.q, f = l.j, h = a(t, Math.pow(2, -f)), p = i(u), d = i(u), m = 1, y = h, g = -1, v = 1; v <= c; v++)v > 1 && (y = a(y, h), g = -g), p = n(p, a(m = m * (c - v + 1) / ((2 * c - v + 1) * v), y)), d = n(d, a(m * g, y));
                        for(var b = a(o(d), p), x = 0; x < f; x++)b = a(b, b);
                        return k(t) ? t.createSparseMatrix(b) : b;
                    }
                });
                function s(t, e, r) {
                    for(var n = 1, i = 2; i <= e; i++)n *= i;
                    for(var o = n, a = e + 1; a <= 2 * e; a++)o *= a;
                    var s = o * (2 * e + 1);
                    return 8 * Math.pow(t / Math.pow(2, r), 2 * e) * n * n / (o * s);
                }
            }), zf = ge("fft", [
                "typed",
                "matrix",
                "addScalar",
                "multiplyScalar",
                "divideScalar",
                "exp",
                "tau",
                "i",
                "dotDivide",
                "conj",
                "pow",
                "ceil",
                "log2"
            ], (t)=>{
                var { typed: e, matrix: r, addScalar: n, multiplyScalar: i, divideScalar: o, exp: a, tau: s, i: u, dotDivide: l, conj: c, pow: f, ceil: h, log2: p } = t;
                return e("fft", {
                    Array: d,
                    Matrix: function(t) {
                        return t.create(d(t.toArray()));
                    }
                });
                function d(t) {
                    var e = $t(t);
                    return 1 === e.length ? m(t, e[0]) : function t(e, r) {
                        var n = $t(e);
                        if (0 !== r) return new Array(n[0]).fill(0).map((n, i)=>t(e[i], r - 1));
                        if (1 === n.length) return m(e);
                        function i(t) {
                            var e = $t(t);
                            return new Array(e[1]).fill(0).map((r, n)=>new Array(e[0]).fill(0).map((e, r)=>t[r][n]));
                        }
                        return i(t(i(e), 1));
                    }(t.map((t)=>d(t, e.slice(1))), 0);
                }
                function m(t) {
                    var e = t.length;
                    if (1 === e) return [
                        t[0]
                    ];
                    if (e % 2 == 0) {
                        for(var r = [
                            ...m(t.filter((t, e)=>e % 2 == 0)),
                            ...m(t.filter((t, e)=>e % 2 == 1))
                        ], y = 0; y < e / 2; y++){
                            var g = r[y], v = i(r[y + e / 2], a(i(i(s, u), o(-y, e))));
                            r[y] = n(g, v), r[y + e / 2] = n(g, i(-1, v));
                        }
                        return r;
                    }
                    return function(t) {
                        for(var e = t.length, r = a(o(i(-1, i(u, s)), e)), n = [], y = 1 - e; y < e; y++)n.push(f(r, o(f(y, 2), 2)));
                        for(var g = f(2, h(p(e + e - 1))), v = [
                            ...new Array(e).fill(0).map((r, o)=>i(t[o], n[e - 1 + o])),
                            ...new Array(g - e).fill(0)
                        ], b = [
                            ...new Array(e + e - 1).fill(0).map((t, e)=>o(1, n[e])),
                            ...new Array(g - (e + e - 1)).fill(0)
                        ], x = m(v), w = m(b), _ = new Array(g).fill(0).map((t, e)=>i(x[e], w[e])), A = l(c(d(c(_))), g), E = [], S = e - 1; S < e + e - 1; S++)E.push(i(A[S], n[S]));
                        return E;
                    }(t);
                }
            }), Gf = ge("gamma", [
                "typed",
                "config",
                "multiplyScalar",
                "pow",
                "BigNumber",
                "Complex"
            ], (t)=>{
                var { typed: e, config: r, multiplyScalar: n, pow: i, BigNumber: o, Complex: a } = t;
                return e("gamma", {
                    number: Us,
                    Complex: function t(e) {
                        if (0 === e.im) return Us(e.re);
                        if (e.re < .5) {
                            var r = new a(1 - e.re, -e.im), n = new a(Math.PI * e.re, Math.PI * e.im);
                            return new a(Math.PI).div(n.sin()).div(t(r));
                        }
                        e = new a(e.re - 1, e.im);
                        for(var i = new a(Gs[0], 0), o = 1; o < Gs.length; ++o){
                            var s = new a(Gs[o], 0);
                            i = i.add(s.div(e.add(o)));
                        }
                        var u = new a(e.re + zs + .5, e.im), l = Math.sqrt(2 * Math.PI), c = u.pow(e.add(.5)), f = u.neg().exp();
                        return i.mul(l).mul(c).mul(f);
                    },
                    BigNumber: function(t) {
                        if (t.isInteger()) return t.isNegative() || t.isZero() ? new o(1 / 0) : function t(e) {
                            if (e < 8) return new o([
                                1,
                                1,
                                2,
                                6,
                                24,
                                120,
                                720,
                                5040
                            ][e]);
                            var n = r.precision + (0 | Math.log(e.toNumber())), i = o.clone({
                                precision: n
                            });
                            if (e % 2 == 1) return e.times(t(new o(e - 1)));
                            var a = e, s = new i(e), u = e.toNumber();
                            for(; a > 2;)u += a -= 2, s = s.times(u);
                            return new o(s.toPrecision(o.precision));
                        }(t.minus(1));
                        if (!t.isFinite()) return new o(t.isNegative() ? NaN : 1 / 0);
                        throw new Error("Integer BigNumber expected");
                    }
                });
            }), Hf = ge("ifft", [
                "typed",
                "fft",
                "dotDivide",
                "conj"
            ], (t)=>{
                var { typed: e, fft: r, dotDivide: n, conj: i } = t;
                return e("ifft", {
                    "Array | Matrix": function(t) {
                        var e = E(t) ? t.size() : $t(t);
                        return n(i(r(i(t))), e.reduce((t, e)=>t * e, 1));
                    }
                });
            }), Wf = ge("createUnit", [
                "typed",
                "Unit"
            ], (t)=>{
                var { typed: e, Unit: r } = t;
                return e("createUnit", {
                    "Object, Object": function(t, e) {
                        return r.createUnit(t, e);
                    },
                    Object: function(t) {
                        return r.createUnit(t, {});
                    },
                    "string, Unit | string | Object, Object": function(t, e, n) {
                        var i = {};
                        return i[t] = e, r.createUnit(i, n);
                    },
                    "string, Unit | string | Object": function(t, e) {
                        var n = {};
                        return n[t] = e, r.createUnit(n, {});
                    },
                    string: function(t) {
                        var e = {};
                        return e[t] = {}, r.createUnit(e, {});
                    }
                });
            }), $f = ge("divide", [
                "typed",
                "matrix",
                "multiply",
                "equalScalar",
                "divideScalar",
                "inv"
            ], (t)=>{
                var { typed: e, matrix: r, multiply: n, equalScalar: i, divideScalar: o, inv: a } = t, s = cl({
                    typed: e,
                    equalScalar: i
                }), u = pl({
                    typed: e
                });
                return e("divide", at({
                    "Array | Matrix, Array | Matrix": function(t, e) {
                        return n(t, a(e));
                    },
                    "DenseMatrix, any": function(t, e) {
                        return u(t, e, o, !1);
                    },
                    "SparseMatrix, any": function(t, e) {
                        return s(t, e, o, !1);
                    },
                    "Array, any": function(t, e) {
                        return u(r(t), e, o, !1).valueOf();
                    },
                    "any, Array | Matrix": function(t, e) {
                        return n(t, a(e));
                    }
                }, o.signatures));
            }), Vf = ge("factorial", [
                "typed",
                "gamma"
            ], (t)=>{
                var { typed: e, gamma: r } = t;
                return e("factorial", {
                    number: function(t) {
                        if (t < 0) throw new Error("Value must be non-negative");
                        return r(t + 1);
                    },
                    BigNumber: function(t) {
                        if (t.isNegative()) throw new Error("Value must be non-negative");
                        return r(t.plus(1));
                    },
                    "Array | Matrix": e.referToSelf((t)=>(e)=>vr(e, t))
                });
            });
            function Zf(t, e) {
                var r, n = e.length, i = [];
                if (t) for(r = 0; r < n; r++)i[t[r]] = e[r];
                else for(r = 0; r < n; r++)i[r] = e[r];
                return i;
            }
            var Yf = ge("lusolve", [
                "typed",
                "matrix",
                "lup",
                "slu",
                "usolve",
                "lsolve",
                "DenseMatrix"
            ], (t)=>{
                var { typed: e, matrix: r, lup: n, slu: i, usolve: o, lsolve: a, DenseMatrix: s } = t, u = Dl({
                    DenseMatrix: s
                });
                return e("lusolve", {
                    "Array, Array | Matrix": function(t, e) {
                        t = r(t);
                        var i = n(t);
                        return c(i.L, i.U, i.p, null, e).valueOf();
                    },
                    "DenseMatrix, Array | Matrix": function(t, e) {
                        var r = n(t);
                        return c(r.L, r.U, r.p, null, e);
                    },
                    "SparseMatrix, Array | Matrix": function(t, e) {
                        var r = n(t);
                        return c(r.L, r.U, r.p, null, e);
                    },
                    "SparseMatrix, Array | Matrix, number, number": function(t, e, r, n) {
                        var o = i(t, r, n);
                        return c(o.L, o.U, o.p, o.q, e);
                    },
                    "Object, Array | Matrix": function(t, e) {
                        return c(t.L, t.U, t.p, t.q, e);
                    }
                });
                function l(t) {
                    if (E(t)) return t;
                    if (A(t)) return r(t);
                    throw new TypeError("Invalid Matrix LU decomposition");
                }
                function c(t, e, r, n, i) {
                    t = l(t), e = l(e), r && ((i = u(t, i, !0))._data = Zf(r, i._data));
                    var s = a(t, i), c = o(e, s);
                    return n && (c._data = Zf(n, c._data)), c;
                }
            }), Kf = ge("multinomial", [
                "typed",
                "add",
                "divide",
                "multiply",
                "factorial",
                "isInteger",
                "isPositive"
            ], (t)=>{
                var { typed: e, add: r, divide: n, multiply: i, factorial: o, isInteger: a, isPositive: s } = t;
                return e("multinomial", {
                    "Array | Matrix": function(t) {
                        var e = 0, u = 1;
                        return gr(t, function(t) {
                            if (!a(t) || !s(t)) throw new TypeError("Positive integer value expected in function multinomial");
                            e = r(e, t), u = i(u, o(t));
                        }), n(o(e), u);
                    }
                });
            }), Xf = ge("permutations", [
                "typed",
                "factorial"
            ], (t)=>{
                var { typed: e, factorial: r } = t;
                return e("permutations", {
                    "number | BigNumber": r,
                    "number, number": function(t, e) {
                        if (!pt(t) || t < 0) throw new TypeError("Positive integer value expected in function permutations");
                        if (!pt(e) || e < 0) throw new TypeError("Positive integer value expected in function permutations");
                        if (e > t) throw new TypeError("second argument k must be less than or equal to first argument n");
                        return ns(t - e + 1, t);
                    },
                    "BigNumber, BigNumber": function(t, e) {
                        var r, n;
                        if (!Jf(t) || !Jf(e)) throw new TypeError("Positive integer value expected in function permutations");
                        if (e.gt(t)) throw new TypeError("second argument k must be less than or equal to first argument n");
                        for(r = t.mul(0).add(1), n = t.minus(e).plus(1); n.lte(t); n = n.plus(1))r = r.times(n);
                        return r;
                    }
                });
            });
            function Jf(t) {
                return t.isInteger() && t.gte(0);
            }
            var Qf = ge("polynomialRoot", [
                "typed",
                "isZero",
                "equalScalar",
                "add",
                "subtract",
                "multiply",
                "divide",
                "sqrt",
                "unaryMinus",
                "cbrt",
                "typeOf",
                "im",
                "re"
            ], (t)=>{
                var { typed: e, isZero: r, equalScalar: n, add: i, subtract: o, multiply: a, divide: s, sqrt: u, unaryMinus: l, cbrt: c, typeOf: f, im: h, re: p } = t;
                return e("polynomialRoot", {
                    "number|Complex, ...number|Complex": (t, e)=>{
                        for(var d = [
                            t,
                            ...e
                        ]; d.length > 0 && r(d[d.length - 1]);)d.pop();
                        if (d.length < 2) throw new RangeError("Polynomial [".concat(t, ", ").concat(e, "] must have a non-zero non-constant coefficient"));
                        switch(d.length){
                            case 2:
                                return [
                                    l(s(d[0], d[1]))
                                ];
                            case 3:
                                var [m, y, g] = d, v = a(2, g), b = a(y, y), x = a(4, g, m);
                                if (n(b, x)) return [
                                    s(l(y), v)
                                ];
                                var w = u(o(b, x));
                                return [
                                    s(o(w, y), v),
                                    s(o(l(w), y), v)
                                ];
                            case 4:
                                var [_, A, E, S] = d, M = l(a(3, S)), k = a(E, E), N = a(3, S, A), C = i(a(2, E, E, E), a(27, S, S, _)), D = a(9, S, E, A);
                                if (n(k, N) && n(C, D)) return [
                                    s(E, M)
                                ];
                                var O, T = o(k, N), F = o(C, D), P = i(a(18, S, E, A, _), a(E, E, A, A)), I = i(a(4, E, E, E, _), a(4, S, A, A, A), a(27, S, S, _, _));
                                if (n(P, I)) return [
                                    s(o(a(4, S, E, A), i(a(9, S, S, _), a(E, E, E))), a(S, T)),
                                    s(o(a(9, S, _), a(E, A)), a(2, T))
                                ];
                                O = n(k, N) ? F : s(i(F, u(o(a(F, F), a(4, T, T, T)))), 2);
                                return c(O, !0).toArray().map((t)=>s(i(E, t, s(T, t)), M)).map((t)=>"Complex" === f(t) && n(p(t), p(t) + h(t)) ? p(t) : t);
                            default:
                                throw new RangeError("only implemented for cubic or lower-order polynomials, not ".concat(d));
                        }
                    }
                });
            }), th = ge("setSize", [
                "typed",
                "compareNatural"
            ], (t)=>{
                var { typed: e, compareNatural: r } = t;
                return e("setSize", {
                    "Array | Matrix": function(t) {
                        return Array.isArray(t) ? ne(t).length : ne(t.toArray()).length;
                    },
                    "Array | Matrix, boolean": function(t, e) {
                        if (!1 === e || 0 === t.length) return Array.isArray(t) ? ne(t).length : ne(t.toArray()).length;
                        for(var n = ne(Array.isArray(t) ? t : t.toArray()).sort(r), i = 1, o = 1; o < n.length; o++)0 !== r(n[o], n[o - 1]) && i++;
                        return i;
                    }
                });
            });
            function eh(t, e) {
                var r = Object.keys(t);
                if (Object.getOwnPropertySymbols) {
                    var n = Object.getOwnPropertySymbols(t);
                    e && (n = n.filter(function(e) {
                        return Object.getOwnPropertyDescriptor(t, e).enumerable;
                    })), r.push.apply(r, n);
                }
                return r;
            }
            var rh = ge("solveODE", [
                "typed",
                "add",
                "subtract",
                "multiply",
                "divide",
                "max",
                "map",
                "abs",
                "isPositive",
                "isNegative",
                "larger",
                "smaller",
                "matrix",
                "bignumber",
                "unaryMinus"
            ], (t)=>{
                var { typed: e, add: r, subtract: n, multiply: i, divide: o, max: a, map: s, abs: u, isPositive: l, isNegative: c, larger: f, smaller: h, matrix: p, bignumber: d, unaryMinus: m } = t;
                function y(t) {
                    return function(e, p, y, g) {
                        if (!(2 === p.length && (p.every(A) || p.every(w)))) throw new Error('"tspan" must be an Array of two numeric values or two units [tStart, tEnd]');
                        var b = p[0], x = p[1], _ = f(x, b), E = g.firstStep;
                        if (void 0 !== E && !l(E)) throw new Error('"firstStep" must be positive');
                        var S = g.maxStep;
                        if (void 0 !== S && !l(S)) throw new Error('"maxStep" must be positive');
                        var M = g.minStep;
                        if (M && c(M)) throw new Error('"minStep" must be positive or zero');
                        var k = [
                            b,
                            x,
                            E,
                            M,
                            S
                        ].filter((t)=>void 0 !== t);
                        if (!k.every(A) && !k.every(w)) throw new Error('Inconsistent type of "t" dependant variables');
                        for(var N = g.tol ? g.tol : 1e-4, C = g.minDelta ? g.minDelta : .2, D = g.maxDelta ? g.maxDelta : 5, O = g.maxIter ? g.maxIter : 1e4, T = [
                            b,
                            x,
                            ...y,
                            S,
                            M
                        ].some(v), [F, P, I, B] = T ? [
                            d(t.a),
                            d(t.c),
                            d(t.b),
                            d(t.bp)
                        ] : [
                            t.a,
                            t.c,
                            t.b,
                            t.bp
                        ], j = E ? _ ? E : m(E) : o(n(x, b), 1), R = [
                            b
                        ], L = [
                            y
                        ], q = n(I, B), U = 0, z = 0, G = function(t) {
                            return t ? h : f;
                        }(_), H = function(t) {
                            var e = t ? f : h;
                            return function(t, i, o) {
                                var a = r(t, o);
                                return e(a, i) ? n(i, t) : o;
                            };
                        }(_); G(R[U], x);){
                            var W = [];
                            j = H(R[U], x, j), W.push(e(R[U], L[U]));
                            for(var $ = 1; $ < P.length; ++$)W.push(e(r(R[U], i(P[$], j)), r(L[U], i(j, F[$], W))));
                            var V = a(u(s(i(q, W), (t)=>w(t) ? t.value : t)));
                            V < N && N / V > 1 / 4 && (R.push(r(R[U], j)), L.push(r(L[U], i(j, I, W))), U++);
                            var Z = .84 * (N / V) ** .2;
                            if (h(Z, C) ? Z = C : f(Z, D) && (Z = D), Z = T ? d(Z) : Z, j = i(j, Z), S && f(u(j), S) ? j = _ ? S : m(S) : M && h(u(j), M) && (j = _ ? M : m(M)), ++z > O) throw new Error("Maximum number of iterations reached, try changing options");
                        }
                        return {
                            t: R,
                            y: L
                        };
                    };
                }
                function b(t, e, r, n) {
                    return y({
                        a: [
                            [],
                            [
                                .5
                            ],
                            [
                                0,
                                3 / 4
                            ],
                            [
                                2 / 9,
                                1 / 3,
                                4 / 9
                            ]
                        ],
                        c: [
                            null,
                            .5,
                            3 / 4,
                            1
                        ],
                        b: [
                            2 / 9,
                            1 / 3,
                            4 / 9,
                            0
                        ],
                        bp: [
                            7 / 24,
                            1 / 4,
                            1 / 3,
                            1 / 8
                        ]
                    })(t, e, r, n);
                }
                function x(t, e, r, n) {
                    return y({
                        a: [
                            [],
                            [
                                .2
                            ],
                            [
                                3 / 40,
                                9 / 40
                            ],
                            [
                                44 / 45,
                                -56 / 15,
                                32 / 9
                            ],
                            [
                                19372 / 6561,
                                -25360 / 2187,
                                64448 / 6561,
                                -212 / 729
                            ],
                            [
                                9017 / 3168,
                                -355 / 33,
                                46732 / 5247,
                                49 / 176,
                                -5103 / 18656
                            ],
                            [
                                35 / 384,
                                0,
                                500 / 1113,
                                125 / 192,
                                -2187 / 6784,
                                11 / 84
                            ]
                        ],
                        c: [
                            null,
                            .2,
                            .3,
                            .8,
                            8 / 9,
                            1,
                            1
                        ],
                        b: [
                            35 / 384,
                            0,
                            500 / 1113,
                            125 / 192,
                            -2187 / 6784,
                            11 / 84,
                            0
                        ],
                        bp: [
                            5179 / 57600,
                            0,
                            7571 / 16695,
                            393 / 640,
                            -92097 / 339200,
                            187 / 2100,
                            1 / 40
                        ]
                    })(t, e, r, n);
                }
                function _(t, e, r, n) {
                    var i = n.method ? n.method : "RK45", o = {
                        RK23: b,
                        RK45: x
                    };
                    if (i.toUpperCase() in o) {
                        var a = function(t) {
                            for(var e = 1; e < arguments.length; e++){
                                var r = null != arguments[e] ? arguments[e] : {};
                                e % 2 ? eh(Object(r), !0).forEach(function(e) {
                                    Fe()(t, e, r[e]);
                                }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : eh(Object(r)).forEach(function(e) {
                                    Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
                                });
                            }
                            return t;
                        }({}, n);
                        return delete a.method, o[i.toUpperCase()](t, e, r, a);
                    }
                    var s = Object.keys(o).map((t)=>'"'.concat(t, '"')), u = "".concat(s.slice(0, -1).join(", "), " and ").concat(s.slice(-1));
                    throw new Error('Unavailable method "'.concat(i, '". Available methods are ').concat(u));
                }
                function A(t) {
                    return v(t) || g(t);
                }
                function E(t, e, r, n) {
                    var i = _(t, e.toArray(), r.toArray(), n);
                    return {
                        t: p(i.t),
                        y: p(i.y)
                    };
                }
                return e("solveODE", {
                    "function, Array, Array, Object": _,
                    "function, Matrix, Matrix, Object": E,
                    "function, Array, Array": (t, e, r)=>_(t, e, r, {}),
                    "function, Matrix, Matrix": (t, e, r)=>E(t, e, r, {}),
                    "function, Array, number | BigNumber | Unit": (t, e, r)=>{
                        var n = _(t, e, [
                            r
                        ], {});
                        return {
                            t: n.t,
                            y: n.y.map((t)=>t[0])
                        };
                    },
                    "function, Matrix, number | BigNumber | Unit": (t, e, r)=>{
                        var n = _(t, e.toArray(), [
                            r
                        ], {});
                        return {
                            t: p(n.t),
                            y: p(n.y.map((t)=>t[0]))
                        };
                    },
                    "function, Array, number | BigNumber | Unit, Object": (t, e, r, n)=>{
                        var i = _(t, e, [
                            r
                        ], n);
                        return {
                            t: i.t,
                            y: i.y.map((t)=>t[0])
                        };
                    },
                    "function, Matrix, number | BigNumber | Unit, Object": (t, e, r, n)=>{
                        var i = _(t, e.toArray(), [
                            r
                        ], n);
                        return {
                            t: p(i.t),
                            y: p(i.y.map((t)=>t[0]))
                        };
                    }
                });
            }), nh = ge("stirlingS2", [
                "typed",
                "addScalar",
                "subtractScalar",
                "multiplyScalar",
                "divideScalar",
                "pow",
                "factorial",
                "combinations",
                "isNegative",
                "isInteger",
                "number",
                "?bignumber",
                "larger"
            ], (t)=>{
                var { typed: e, addScalar: r, subtractScalar: n, multiplyScalar: i, divideScalar: o, pow: a, factorial: s, combinations: u, isNegative: l, isInteger: c, number: f, bignumber: h, larger: p } = t, d = [], m = [];
                return e("stirlingS2", {
                    "number | BigNumber, number | BigNumber": function(t, e) {
                        if (!c(t) || l(t) || !c(e) || l(e)) throw new TypeError("Non-negative integer value expected in function stirlingS2");
                        if (p(e, t)) throw new TypeError("k must be less than or equal to n in function stirlingS2");
                        var n = !(g(t) && g(e)), o = n ? m : d, a = n ? h : f, s = f(t), u = f(e);
                        if (o[s] && o[s].length > u) return o[s][u];
                        for(var y = 0; y <= s; ++y)if (o[y] || (o[y] = [
                            a(0 === y ? 1 : 0)
                        ]), 0 !== y) for(var v = o[y], b = o[y - 1], x = v.length; x <= y && x <= u; ++x)v[x] = x === y ? 1 : r(i(a(x), b[x]), b[x - 1]);
                        return o[s][u];
                    }
                });
            }), ih = ge("unit", [
                "typed",
                "Unit"
            ], (t)=>{
                var { typed: e, Unit: r } = t;
                return e("unit", {
                    Unit: function(t) {
                        return t.clone();
                    },
                    string: function(t) {
                        return r.isValuelessUnit(t) ? new r(null, t) : r.parse(t, {
                            allowNoUnits: !0
                        });
                    },
                    "number | BigNumber | Fraction | Complex, string | Unit": function(t, e) {
                        return new r(t, e);
                    },
                    "number | BigNumber | Fraction": function(t) {
                        return new r(t);
                    },
                    "Array | Matrix": e.referToSelf((t)=>(e)=>vr(e, t))
                });
            }), oh = ge("bellNumbers", [
                "typed",
                "addScalar",
                "isNegative",
                "isInteger",
                "stirlingS2"
            ], (t)=>{
                var { typed: e, addScalar: r, isNegative: n, isInteger: i, stirlingS2: o } = t;
                return e("bellNumbers", {
                    "number | BigNumber": function(t) {
                        if (!i(t) || n(t)) throw new TypeError("Non-negative integer value expected in function bellNumbers");
                        for(var e = 0, a = 0; a <= t; a++)e = r(e, o(t, a));
                        return e;
                    }
                });
            });
            function ah(t) {
                var { addScalar: e, subtract: r, flatten: n, multiply: i, multiplyScalar: o, divideScalar: a, sqrt: s, abs: u, bignumber: l, diag: c, inv: f, qr: h, usolve: p, usolveAll: d, equal: m, complex: y, larger: g, smaller: v, matrixFromColumns: b, dot: x } = t;
                function w(t, e, n, i, o, a, s, c) {
                    var f = "BigNumber" === c, h = "Complex" === c, p = f ? l(0) : h ? y(0) : 0, d = f ? l(1) : h ? y(1) : 1;
                    if (v(u(n), s)) return [
                        [
                            d,
                            p
                        ],
                        [
                            p,
                            d
                        ]
                    ];
                    if (g(u(r(o, a)), s)) return [
                        [
                            r(o, i),
                            r(a, i)
                        ],
                        [
                            n,
                            n
                        ]
                    ];
                    var m = r(t, o), b = r(e, o), x = r(n, o), w = r(i, o);
                    return v(u(b), s) ? [
                        [
                            m,
                            d
                        ],
                        [
                            x,
                            p
                        ]
                    ] : [
                        [
                            b,
                            p
                        ],
                        [
                            w,
                            d
                        ]
                    ];
                }
                function _(t, e) {
                    for(var r = 0; r < t.length; r++)t[r].push(...Array(e - t[r].length).fill(0));
                    for(var n = t.length; n < e; n++)t.push(Array(e).fill(0)), t[n][n] = 1;
                    return t;
                }
                function A(t, e, r) {
                    for(var n = 0; n < t.length; n++)if (r(t[n], e)) return n;
                    return -1;
                }
                function E(t, e, r, n, i) {
                    for(var o, a = "BigNumber" === i ? l(1e3) : 1e3, s = 0; o = S(e, r, i), o = p(t, o), !g(k(o), a);)if (++s >= 5) return null;
                    for(s = 0;;){
                        var u = p(t, o);
                        if (v(k(M(o, [
                            u
                        ])), n)) break;
                        if (++s >= 10) return null;
                        o = N(u);
                    }
                    return o;
                }
                function S(t, e, r) {
                    var n = "BigNumber" === r, i = "Complex" === r, o = Array(t).fill(0).map((t)=>2 * Math.random() - 1);
                    return n && (o = o.map((t)=>l(t))), i && (o = o.map((t)=>y(t))), N(o = M(o, e), r);
                }
                function M(t, e) {
                    for (var n of e)t = r(t, i(a(x(n, t), x(n, n)), n));
                    return t;
                }
                function k(t) {
                    return u(s(x(t, t)));
                }
                function N(t, e) {
                    var r = "Complex" === e, n = "BigNumber" === e ? l(1) : r ? y(1) : 1;
                    return i(a(n, k(t)), t);
                }
                return function(t, p, x, S, M) {
                    void 0 === M && (M = !0);
                    var k = function(t, r, n, i, s) {
                        var f, h = "BigNumber" === i, p = "Complex" === i, d = h ? l(0) : 0, b = h ? l(1) : p ? y(1) : 1, x = h ? l(1) : 1, w = h ? l(10) : 2, _ = o(w, w);
                        s && (f = Array(r).fill(b));
                        var A = !1;
                        for(; !A;){
                            A = !0;
                            for(var E = 0; E < r; E++){
                                for(var S = d, M = d, k = 0; k < r; k++)if (E !== k) {
                                    var N = u(t[E][k]);
                                    S = e(S, N), M = e(M, N);
                                }
                                if (!m(S, 0) && !m(M, 0)) {
                                    for(var C = x, D = S, O = a(M, w), T = o(M, w); v(D, O);)D = o(D, _), C = o(C, w);
                                    for(; g(D, T);)D = a(D, _), C = a(C, w);
                                    if (v(a(e(D, M), C), o(e(S, M), .95))) {
                                        A = !1;
                                        for(var F = a(1, C), P = 0; P < r; P++)E !== P && (t[E][P] = o(t[E][P], C), t[P][E] = o(t[P][E], F));
                                        s && (f[E] = o(f[E], C));
                                    }
                                }
                            }
                        }
                        return c(f);
                    }(t, p, 0, S, M);
                    !function(t, n, i, s, c, f) {
                        var h = "BigNumber" === s, p = "Complex" === s, d = h ? l(0) : p ? y(0) : 0;
                        h && (i = l(i));
                        for(var m = 0; m < n - 2; m++){
                            for(var g = 0, b = d, x = m + 1; x < n; x++){
                                var w = t[x][m];
                                v(u(b), u(w)) && (b = w, g = x);
                            }
                            if (!v(u(b), i)) {
                                if (g !== m + 1) {
                                    var _ = t[g];
                                    t[g] = t[m + 1], t[m + 1] = _;
                                    for(var A = 0; A < n; A++){
                                        var E = t[A][g];
                                        t[A][g] = t[A][m + 1], t[A][m + 1] = E;
                                    }
                                    if (c) {
                                        var S = f[g];
                                        f[g] = f[m + 1], f[m + 1] = S;
                                    }
                                }
                                for(var M = m + 2; M < n; M++){
                                    var k = a(t[M][m], b);
                                    if (0 !== k) {
                                        for(var N = 0; N < n; N++)t[M][N] = r(t[M][N], o(k, t[m + 1][N]));
                                        for(var C = 0; C < n; C++)t[C][m + 1] = e(t[C][m + 1], o(k, t[C][M]));
                                        if (c) for(var D = 0; D < n; D++)f[M][D] = r(f[M][D], o(k, f[m + 1][D]));
                                    }
                                }
                            }
                        }
                    }(t, p, x, S, M, k);
                    var N, { values: C, C: D } = function(t, n, a, f, p) {
                        var d = "BigNumber" === f, m = "Complex" === f, g = d ? l(1) : m ? y(1) : 1;
                        d && (a = l(a));
                        var b = it(t), x = [], A = n, E = [], S = p ? c(Array(n).fill(g)) : void 0, M = p ? c(Array(A).fill(g)) : void 0, k = 0;
                        for(; k <= 100;){
                            k += 1;
                            for(var N = 0; N < A; N++)b[N][N] = r(b[N][N], 0);
                            var { Q: C, R: D } = h(b);
                            b = i(D, C);
                            for(var O = 0; O < A; O++)b[O][O] = e(b[O][O], 0);
                            if (p && (M = i(M, C)), 1 === A || v(u(b[A - 1][A - 2]), a)) {
                                k = 0, x.push(b[A - 1][A - 1]), p && (E.unshift([
                                    [
                                        1
                                    ]
                                ]), _(M, n), S = i(S, M), A > 1 && (M = c(Array(A - 1).fill(g)))), A -= 1, b.pop();
                                for(var T = 0; T < A; T++)b[T].pop();
                            } else if (2 === A || v(u(b[A - 2][A - 3]), a)) {
                                k = 0;
                                var F = (I = b[A - 2][A - 2], B = b[A - 2][A - 1], j = b[A - 1][A - 2], R = b[A - 1][A - 1], L = void 0, q = void 0, U = void 0, z = void 0, L = e(I, R), q = r(o(I, R), o(B, j)), U = o(L, .5), z = o(s(r(o(L, L), o(4, q))), .5), [
                                    e(U, z),
                                    r(U, z)
                                ]);
                                x.push(...F), p && (E.unshift(w(b[A - 2][A - 2], b[A - 2][A - 1], b[A - 1][A - 2], b[A - 1][A - 1], F[0], F[1], a, f)), _(M, n), S = i(S, M), A > 2 && (M = c(Array(A - 2).fill(g)))), A -= 2, b.pop(), b.pop();
                                for(var P = 0; P < A; P++)b[P].pop(), b[P].pop();
                            }
                            if (0 === A) break;
                        }
                        var I, B, j, R, L, q, U, z;
                        if (x.sort((t, e)=>+r(u(t), u(e))), k > 100) {
                            var G = Error("The eigenvalues failed to converge. Only found these eigenvalues: " + x.join(", "));
                            throw G.values = x, G.vectors = [], G;
                        }
                        var H = p ? i(S, function(t, e) {
                            for(var r = [], n = 0; n < e; n++)r[n] = Array(e).fill(0);
                            var i = 0;
                            for (var o of t){
                                for(var a = o.length, s = 0; s < a; s++)for(var u = 0; u < a; u++)r[i + s][i + u] = o[s][u];
                                i += a;
                            }
                            return r;
                        }(E, n)) : void 0;
                        return {
                            values: x,
                            C: H
                        };
                    }(t, p, x, S, M);
                    return M && (N = function(t, e, o, a, s, u, h) {
                        var p = f(o), g = i(p, t, o), v = "BigNumber" === h, b = "Complex" === h, x = v ? l(0) : b ? y(0) : 0, w = v ? l(1) : b ? y(1) : 1, _ = [], S = [];
                        for (var M of s){
                            var k = A(_, M, m);
                            -1 === k ? (_.push(M), S.push(1)) : S[k] += 1;
                        }
                        for(var N = [], C = _.length, D = Array(e).fill(x), O = c(Array(e).fill(w)), T = [], F = function() {
                            var t = _[P], s = r(g, i(t, O)), l = d(s, D);
                            for(l.shift(); l.length < S[P];){
                                var c = E(s, e, l, u, h);
                                if (null == c) {
                                    T.push(t);
                                    break;
                                }
                                l.push(c);
                            }
                            var p = i(f(a), o);
                            l = l.map((t)=>i(p, t)), N.push(...l.map((t)=>n(t)));
                        }, P = 0; P < C; P++)F();
                        if (0 !== T.length) {
                            var I = new Error("Failed to find eigenvectors for the following eigenvalues: " + T.join(", "));
                            throw I.values = s, I.vectors = N, I;
                        }
                        return N;
                    }(t, p, D, k, C, x, S), N = b(...N)), {
                        values: C,
                        vectors: N
                    };
                };
            }
            var sh = [
                "config",
                "typed",
                "matrix",
                "addScalar",
                "equal",
                "subtract",
                "abs",
                "atan",
                "cos",
                "sin",
                "multiplyScalar",
                "divideScalar",
                "inv",
                "bignumber",
                "multiply",
                "add",
                "larger",
                "column",
                "flatten",
                "number",
                "complex",
                "sqrt",
                "diag",
                "qr",
                "usolve",
                "usolveAll",
                "im",
                "re",
                "smaller",
                "matrixFromColumns",
                "dot"
            ], uh = ge("eigs", sh, (t)=>{
                var { config: e, typed: r, matrix: n, addScalar: i, subtract: o, equal: a, abs: s, atan: u, cos: l, sin: c, multiplyScalar: f, divideScalar: h, inv: p, bignumber: d, multiply: m, add: y, larger: w, column: _, flatten: A, number: E, complex: S, sqrt: M, diag: k, qr: N, usolve: C, usolveAll: D, im: O, re: T, smaller: F, matrixFromColumns: P, dot: I } = t, B = function(t) {
                    var { config: e, addScalar: r, subtract: n, abs: i, atan: o, cos: a, sin: s, multiplyScalar: u, inv: l, bignumber: c, multiply: f, add: h } = t;
                    function p(t, e) {
                        for(var r, n = t.length, i = Math.abs(e / n), o = new Array(n), a = 0; a < n; a++)o[a] = E(n, 0), o[a][a] = 1;
                        for(var s = w(t); Math.abs(s[1]) >= Math.abs(i);){
                            var u = s[0][0], l = s[0][1];
                            t = x(t, r = m(t[u][u], t[l][l], t[u][l]), u, l), o = g(o, r, u, l), s = w(t);
                        }
                        for(var c = E(n, 0), f = 0; f < n; f++)c[f] = t[f][f];
                        return A(it(c), it(o));
                    }
                    function d(t, e) {
                        for(var r, n = t.length, o = i(e / n), a = new Array(n), s = 0; s < n; s++)a[s] = E(n, 0), a[s][s] = 1;
                        for(var u = _(t); i(u[1]) >= i(o);){
                            var l = u[0][0], c = u[0][1];
                            t = b(t, r = y(t[l][l], t[c][c], t[l][c]), l, c), a = v(a, r, l, c), u = _(t);
                        }
                        for(var f = E(n, 0), h = 0; h < n; h++)f[h] = t[h][h];
                        return A(it(f), it(a));
                    }
                    function m(t, r, n) {
                        var i = r - t;
                        return Math.abs(i) <= e.epsilon ? Math.PI / 4 : .5 * Math.atan(2 * n / (r - t));
                    }
                    function y(t, r, a) {
                        var s = n(r, t);
                        return i(s) <= e.epsilon ? c(-1).acos().div(4) : u(.5, o(f(2, a, l(s))));
                    }
                    function g(t, e, r, n) {
                        for(var i = t.length, o = Math.cos(e), a = Math.sin(e), s = E(i, 0), u = E(i, 0), l = 0; l < i; l++)s[l] = o * t[l][r] - a * t[l][n], u[l] = a * t[l][r] + o * t[l][n];
                        for(var c = 0; c < i; c++)t[c][r] = s[c], t[c][n] = u[c];
                        return t;
                    }
                    function v(t, e, i, o) {
                        for(var l = t.length, f = a(e), h = s(e), p = E(l, c(0)), d = E(l, c(0)), m = 0; m < l; m++)p[m] = n(u(f, t[m][i]), u(h, t[m][o])), d[m] = r(u(h, t[m][i]), u(f, t[m][o]));
                        for(var y = 0; y < l; y++)t[y][i] = p[y], t[y][o] = d[y];
                        return t;
                    }
                    function b(t, e, i, o) {
                        for(var l = t.length, p = c(a(e)), d = c(s(e)), m = u(p, p), y = u(d, d), g = E(l, c(0)), v = E(l, c(0)), b = f(c(2), p, d, t[i][o]), x = r(n(u(m, t[i][i]), b), u(y, t[o][o])), w = h(u(y, t[i][i]), b, u(m, t[o][o])), _ = 0; _ < l; _++)g[_] = n(u(p, t[i][_]), u(d, t[o][_])), v[_] = r(u(d, t[i][_]), u(p, t[o][_]));
                        t[i][i] = x, t[o][o] = w, t[i][o] = c(0), t[o][i] = c(0);
                        for(var A = 0; A < l; A++)A !== i && A !== o && (t[i][A] = g[A], t[A][i] = g[A], t[o][A] = v[A], t[A][o] = v[A]);
                        return t;
                    }
                    function x(t, e, r, n) {
                        for(var i = t.length, o = Math.cos(e), a = Math.sin(e), s = o * o, u = a * a, l = E(i, 0), c = E(i, 0), f = s * t[r][r] - 2 * o * a * t[r][n] + u * t[n][n], h = u * t[r][r] + 2 * o * a * t[r][n] + s * t[n][n], p = 0; p < i; p++)l[p] = o * t[r][p] - a * t[n][p], c[p] = a * t[r][p] + o * t[n][p];
                        t[r][r] = f, t[n][n] = h, t[r][n] = 0, t[n][r] = 0;
                        for(var d = 0; d < i; d++)d !== r && d !== n && (t[r][d] = l[d], t[d][r] = l[d], t[n][d] = c[d], t[d][n] = c[d]);
                        return t;
                    }
                    function w(t) {
                        for(var e = t.length, r = 0, n = [
                            0,
                            1
                        ], i = 0; i < e; i++)for(var o = i + 1; o < e; o++)Math.abs(r) < Math.abs(t[i][o]) && (r = Math.abs(t[i][o]), n = [
                            i,
                            o
                        ]);
                        return [
                            n,
                            r
                        ];
                    }
                    function _(t) {
                        for(var e = t.length, r = 0, n = [
                            0,
                            1
                        ], o = 0; o < e; o++)for(var a = o + 1; a < e; a++)i(r) < i(t[o][a]) && (r = i(t[o][a]), n = [
                            o,
                            a
                        ]);
                        return [
                            n,
                            r
                        ];
                    }
                    function A(t, e) {
                        for(var r = t.length, n = Array(r), o = Array(r), a = 0; a < r; a++)o[a] = Array(r);
                        for(var s = 0; s < r; s++){
                            for(var u = 0, l = t[0], c = 0; c < t.length; c++)i(t[c]) < i(l) && (l = t[u = c]);
                            n[s] = t.splice(u, 1)[0];
                            for(var f = 0; f < r; f++)o[f][s] = e[f][u], e[f].splice(u, 1);
                        }
                        return {
                            values: n,
                            vectors: o
                        };
                    }
                    function E(t, e) {
                        for(var r = new Array(t), n = 0; n < t; n++)r[n] = e;
                        return r;
                    }
                    return function(t, r) {
                        var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : e.epsilon, i = arguments.length > 3 ? arguments[3] : void 0;
                        if ("number" === i) return p(t, n);
                        if ("BigNumber" === i) return d(t, n);
                        throw TypeError("Unsupported data type: " + i);
                    };
                }({
                    config: e,
                    addScalar: i,
                    subtract: o,
                    column: _,
                    flatten: A,
                    equal: a,
                    abs: s,
                    atan: u,
                    cos: l,
                    sin: c,
                    multiplyScalar: f,
                    inv: p,
                    bignumber: d,
                    complex: S,
                    multiply: m,
                    add: y
                }), j = ah({
                    config: e,
                    addScalar: i,
                    subtract: o,
                    multiply: m,
                    multiplyScalar: f,
                    flatten: A,
                    divideScalar: h,
                    sqrt: M,
                    abs: s,
                    bignumber: d,
                    diag: k,
                    qr: N,
                    inv: p,
                    usolve: C,
                    usolveAll: D,
                    equal: a,
                    complex: S,
                    larger: w,
                    smaller: F,
                    matrixFromColumns: P,
                    dot: I
                });
                return r("eigs", {
                    Array: function(t) {
                        return R(n(t));
                    },
                    "Array, number|BigNumber": function(t, e) {
                        return R(n(t), e);
                    },
                    Matrix: function(t) {
                        var { values: e, vectors: r } = R(t);
                        return {
                            values: n(e),
                            vectors: n(r)
                        };
                    },
                    "Matrix, number|BigNumber": function(t, e) {
                        var { values: r, vectors: i } = R(t, e);
                        return {
                            values: n(r),
                            vectors: n(i)
                        };
                    }
                });
                function R(t, r) {
                    void 0 === r && (r = e.epsilon);
                    var n = t.size();
                    if (2 !== n.length || n[0] !== n[1]) throw new RangeError("Matrix must be square (size: " + Lt(n) + ")");
                    var i = t.toArray(), a = n[0];
                    if (function(t, e, r) {
                        for(var n = 0; n < e; n++)for(var i = 0; i < e; i++)if (w(d(s(O(t[n][i]))), r)) return !1;
                        return !0;
                    }(i, a, r) && (function(t, e) {
                        for(var r = 0; r < e; r++)for(var n = 0; n < e; n++)t[r][n] = T(t[r][n]);
                    }(i, a), function(t, e, r) {
                        for(var n = 0; n < e; n++)for(var i = n; i < e; i++)if (w(d(s(o(t[n][i], t[i][n]))), r)) return !1;
                        return !0;
                    }(i, a, r))) {
                        var u = L(t, i, a);
                        return B(i, a, r, u);
                    }
                    var l = L(t, i, a);
                    return j(i, a, r, l);
                }
                function L(t, e, r) {
                    var n = t.datatype();
                    if ("number" === n || "BigNumber" === n || "Complex" === n) return n;
                    for(var i = !1, o = !1, a = !1, s = 0; s < r; s++)for(var u = 0; u < r; u++){
                        var l = e[s][u];
                        if (g(l) || x(l)) i = !0;
                        else if (v(l)) o = !0;
                        else {
                            if (!b(l)) throw TypeError("Unsupported type in Matrix: " + nt(l));
                            a = !0;
                        }
                    }
                    if (o && a && console.warn("Complex BigNumbers not supported, this operation will lose precission."), a) {
                        for(var c = 0; c < r; c++)for(var f = 0; f < r; f++)e[c][f] = S(e[c][f]);
                        return "Complex";
                    }
                    if (o) {
                        for(var h = 0; h < r; h++)for(var p = 0; p < r; p++)e[h][p] = d(e[h][p]);
                        return "BigNumber";
                    }
                    if (i) {
                        for(var m = 0; m < r; m++)for(var y = 0; y < r; y++)e[m][y] = E(e[m][y]);
                        return "number";
                    }
                    throw TypeError("Matrix contains unsupported types only.");
                }
            }), lh = [
                "typed",
                "add",
                "divide",
                "compare",
                "partitionSelect"
            ], ch = ge("median", lh, (t)=>{
                var { typed: e, add: r, divide: n, compare: i, partitionSelect: o } = t;
                function a(t) {
                    try {
                        var e = (t = ne(t.valueOf())).length;
                        if (0 === e) throw new Error("Cannot calculate median of an empty array");
                        if (e % 2 == 0) {
                            for(var r = e / 2 - 1, n = o(t, r + 1), a = t[r], l = 0; l < r; ++l)i(t[l], a) > 0 && (a = t[l]);
                            return u(a, n);
                        }
                        var c = o(t, (e - 1) / 2);
                        return s(c);
                    } catch (t) {
                        throw mn(t, "median");
                    }
                }
                var s = e({
                    "number | BigNumber | Complex | Unit": function(t) {
                        return t;
                    }
                }), u = e({
                    "number | BigNumber | Complex | Unit, number | BigNumber | Complex | Unit": function(t, e) {
                        return n(r(t, e), 2);
                    }
                });
                return e("median", {
                    "Array | Matrix": a,
                    "Array | Matrix, number | BigNumber": function(t, e) {
                        throw new Error("median(A, dim) is not yet supported");
                    },
                    "...": function(t) {
                        if (yr(t)) throw new TypeError("Scalar values expected in function median");
                        return a(t);
                    }
                });
            }), fh = [
                "typed",
                "matrix",
                "mean",
                "sqrt",
                "sum",
                "add",
                "subtract",
                "multiply",
                "pow",
                "divide"
            ], hh = ge("corr", fh, (t)=>{
                var { typed: e, matrix: r, sqrt: n, sum: i, add: o, subtract: a, multiply: s, pow: u, divide: l } = t;
                return e("corr", {
                    "Array, Array": function(t, e) {
                        return c(t, e);
                    },
                    "Matrix, Matrix": function(t, e) {
                        var n = c(t.toArray(), e.toArray());
                        return Array.isArray(n) ? r(n) : n;
                    }
                });
                function c(t, e) {
                    var r = [];
                    if (Array.isArray(t[0]) && Array.isArray(e[0])) {
                        if (t.length !== e.length) throw new SyntaxError("Dimension mismatch. Array A and B must have the same length.");
                        for(var n = 0; n < t.length; n++){
                            if (t[n].length !== e[n].length) throw new SyntaxError("Dimension mismatch. Array A and B must have the same number of elements.");
                            r.push(f(t[n], e[n]));
                        }
                        return r;
                    }
                    if (t.length !== e.length) throw new SyntaxError("Dimension mismatch. Array A and B must have the same number of elements.");
                    return f(t, e);
                }
                function f(t, e) {
                    var r = t.length, c = i(t), f = i(e), h = t.reduce((t, r, n)=>o(t, s(r, e[n])), 0), p = i(t.map((t)=>u(t, 2))), d = i(e.map((t)=>u(t, 2))), m = a(s(r, h), s(c, f)), y = n(s(a(s(r, p), u(c, 2)), a(s(r, d), u(f, 2))));
                    return l(m, y);
                }
            }), ph = [
                "typed",
                "add",
                "multiply",
                "Complex",
                "divide",
                "matrix"
            ], dh = ge("freqz", ph, (t)=>{
                var { typed: e, add: r, multiply: n, Complex: i, divide: o, matrix: a } = t;
                return e("freqz", {
                    "Array, Array": function(t, e) {
                        return s(t, e, u(512));
                    },
                    "Array, Array, Array": function(t, e, r) {
                        return s(t, e, r);
                    },
                    "Array, Array, number": function(t, e, r) {
                        if (r < 0) throw new Error("w must be a positive number");
                        return s(t, e, u(r));
                    },
                    "Matrix, Matrix": function(t, e) {
                        var r = u(512), { w: n, h: i } = s(t.valueOf(), e.valueOf(), r);
                        return {
                            w: a(n),
                            h: a(i)
                        };
                    },
                    "Matrix, Matrix, Matrix": function(t, e, r) {
                        var { h: n } = s(t.valueOf(), e.valueOf(), r.valueOf());
                        return {
                            h: a(n),
                            w: a(r)
                        };
                    },
                    "Matrix, Matrix, number": function(t, e, r) {
                        if (r < 0) throw new Error("w must be a positive number");
                        var n = u(r), { h: i } = s(t.valueOf(), e.valueOf(), n);
                        return {
                            h: a(i),
                            w: a(n)
                        };
                    }
                });
                function s(t, e, a) {
                    for(var s = [], u = [], l = 0; l < a.length; l++){
                        for(var c = i(0, 0), f = i(0, 0), h = 0; h < t.length; h++)c = r(c, n(t[h], i(Math.cos(-h * a[l]), Math.sin(-h * a[l]))));
                        for(var p = 0; p < e.length; p++)f = r(f, n(e[p], i(Math.cos(-p * a[l]), Math.sin(-p * a[l]))));
                        s.push(c), u.push(f);
                    }
                    for(var d = [], m = 0; m < s.length; m++)d.push(o(s[m], u[m]));
                    return {
                        h: d,
                        w: a
                    };
                }
                function u(t) {
                    for(var e = [], r = 0; r < t; r++)e.push(r / t * Math.PI);
                    return e;
                }
            }), mh = [
                "typed",
                "abs",
                "map",
                "median",
                "subtract"
            ], yh = ge("mad", mh, (t)=>{
                var { typed: e, abs: r, map: n, median: i, subtract: o } = t;
                return e("mad", {
                    "Array | Matrix": a,
                    "...": function(t) {
                        return a(t);
                    }
                });
                function a(t) {
                    if (0 === (t = ne(t.valueOf())).length) throw new Error("Cannot calculate median absolute deviation (mad) of an empty array");
                    try {
                        var e = i(t);
                        return i(n(t, function(t) {
                            return r(o(t, e));
                        }));
                    } catch (t) {
                        throw t instanceof TypeError && -1 !== t.message.indexOf("median") ? new TypeError(t.message.replace("median", "mad")) : mn(t, "mad");
                    }
                }
            }), gh = [
                "typed",
                "config",
                "multiply",
                "pow",
                "divide",
                "factorial",
                "equal",
                "smallerEq",
                "isNegative",
                "gamma",
                "sin",
                "subtract",
                "add",
                "?Complex",
                "?BigNumber",
                "pi"
            ], vh = ge("zeta", gh, (t)=>{
                var { typed: e, config: r, multiply: n, pow: i, divide: o, factorial: a, equal: s, smallerEq: u, isNegative: l, gamma: c, sin: f, subtract: h, add: p, Complex: d, BigNumber: m, pi: y } = t;
                return e("zeta", {
                    number: (t)=>g(t, (t)=>t, ()=>20),
                    BigNumber: (t)=>g(t, (t)=>new m(t), ()=>Math.abs(Math.log10(r.epsilon))),
                    Complex: function(t) {
                        if (0 === t.re && 0 === t.im) return new d(-0.5);
                        if (1 === t.re) return new d(NaN, NaN);
                        if (t.re === 1 / 0 && 0 === t.im) return new d(1);
                        if (t.im === 1 / 0 || t.re === -1 / 0) return new d(NaN, NaN);
                        return v(t, (t)=>t, (t)=>Math.round(19.5 + .9 * Math.abs(t.im)), (t)=>t.re);
                    }
                });
                function g(t, e, r) {
                    return s(t, 0) ? e(-0.5) : s(t, 1) ? e(NaN) : isFinite(t) ? v(t, e, r, (t)=>t) : l(t) ? e(NaN) : e(1);
                }
                function v(t, e, r, a) {
                    var s = r(t);
                    if (a(t) > -(s - 1) / 2) return function(t, e, r) {
                        for(var a = o(1, n(b(r(0), e), h(1, i(2, h(1, t))))), s = r(0), l = r(1); u(l, e); l = p(l, 1))s = p(s, o(n((-1) ** (l - 1), b(l, e)), i(l, t)));
                        return n(a, s);
                    }(t, e(s), e);
                    var l = n(i(2, t), i(e(y), h(t, 1)));
                    return l = n(l, f(n(o(e(y), 2), t))), l = n(l, c(h(1, t))), n(l, v(h(1, t), e, r, a));
                }
                function b(t, e) {
                    for(var r = t, s = t; u(s, e); s = p(s, 1)){
                        var l = o(n(a(p(e, h(s, 1))), i(4, s)), n(a(h(e, s)), a(n(2, s))));
                        r = p(r, l);
                    }
                    return n(e, r);
                }
            }), bh = [
                "typed",
                "abs",
                "add",
                "pow",
                "conj",
                "sqrt",
                "multiply",
                "equalScalar",
                "larger",
                "smaller",
                "matrix",
                "ctranspose",
                "eigs"
            ], xh = ge("norm", bh, (t)=>{
                var { typed: e, abs: r, add: n, pow: i, conj: o, sqrt: a, multiply: s, equalScalar: u, larger: l, smaller: c, matrix: f, ctranspose: h, eigs: p } = t;
                return e("norm", {
                    number: Math.abs,
                    Complex: function(t) {
                        return t.abs();
                    },
                    BigNumber: function(t) {
                        return t.abs();
                    },
                    boolean: function(t) {
                        return Math.abs(t);
                    },
                    Array: function(t) {
                        return y(f(t), 2);
                    },
                    Matrix: function(t) {
                        return y(t, 2);
                    },
                    "Array, number | BigNumber | string": function(t, e) {
                        return y(f(t), e);
                    },
                    "Matrix, number | BigNumber | string": function(t, e) {
                        return y(t, e);
                    }
                });
                function d(t, e) {
                    if (e === Number.POSITIVE_INFINITY || "inf" === e) return function(t) {
                        var e = 0;
                        return t.forEach(function(t) {
                            var n = r(t);
                            l(n, e) && (e = n);
                        }, !0), e;
                    }(t);
                    if (e === Number.NEGATIVE_INFINITY || "-inf" === e) return function(t) {
                        var e;
                        return t.forEach(function(t) {
                            var n = r(t);
                            e && !c(n, e) || (e = n);
                        }, !0), e || 0;
                    }(t);
                    if ("fro" === e) return y(t, 2);
                    if ("number" == typeof e && !isNaN(e)) {
                        if (!u(e, 0)) {
                            var o = 0;
                            return t.forEach(function(t) {
                                o = n(i(r(t), e), o);
                            }, !0), i(o, 1 / e);
                        }
                        return Number.POSITIVE_INFINITY;
                    }
                    throw new Error("Unsupported parameter value");
                }
                function m(t, e) {
                    if (1 === e) return function(t) {
                        var e = [], i = 0;
                        return t.forEach(function(t, o) {
                            var a = o[1], s = n(e[a] || 0, r(t));
                            l(s, i) && (i = s), e[a] = s;
                        }, !0), i;
                    }(t);
                    if (e === Number.POSITIVE_INFINITY || "inf" === e) return function(t) {
                        var e = [], i = 0;
                        return t.forEach(function(t, o) {
                            var a = o[0], s = n(e[a] || 0, r(t));
                            l(s, i) && (i = s), e[a] = s;
                        }, !0), i;
                    }(t);
                    if ("fro" === e) return function(t) {
                        var e = 0;
                        return t.forEach(function(t, r) {
                            e = n(e, s(t, o(t)));
                        }), r(a(e));
                    }(t);
                    if (2 === e) return function(t) {
                        var e = t.size();
                        if (e[0] !== e[1]) throw new RangeError("Invalid matrix dimensions");
                        var n = h(t), i = s(n, t), o = p(i).values.toArray(), u = o[o.length - 1];
                        return r(a(u));
                    }(t);
                    throw new Error("Unsupported parameter value " + e);
                }
                function y(t, e) {
                    var r = t.size();
                    if (1 === r.length) return d(t, e);
                    if (2 === r.length) {
                        if (r[0] && r[1]) return m(t, e);
                        throw new RangeError("Invalid matrix dimensions");
                    }
                }
            }), wh = [
                "typed",
                "config",
                "multiplyScalar",
                "addScalar",
                "unaryMinus",
                "norm",
                "matrix",
                "BigNumber",
                "DenseMatrix",
                "SparseMatrix",
                "cos",
                "sin"
            ], _h = ge("rotationMatrix", wh, (t)=>{
                var { typed: e, config: r, multiplyScalar: n, addScalar: i, unaryMinus: o, norm: a, BigNumber: s, matrix: u, DenseMatrix: l, SparseMatrix: c, cos: f, sin: h } = t;
                return e("rotationMatrix", {
                    "": function() {
                        return "Matrix" === r.matrix ? u([]) : [];
                    },
                    string: function(t) {
                        return u(t);
                    },
                    "number | BigNumber | Complex | Unit": function(t) {
                        return p(t, "Matrix" === r.matrix ? "dense" : void 0);
                    },
                    "number | BigNumber | Complex | Unit, string": function(t, e) {
                        return p(t, e);
                    },
                    "number | BigNumber | Complex | Unit, Array": function(t, e) {
                        var r = u(e);
                        return d(r), g(t, r, void 0);
                    },
                    "number | BigNumber | Complex | Unit, Matrix": function(t, e) {
                        d(e);
                        var n = e.storage() || ("Matrix" === r.matrix ? "dense" : void 0);
                        return g(t, e, n);
                    },
                    "number | BigNumber | Complex | Unit, Array, string": function(t, e, r) {
                        var n = u(e);
                        return d(n), g(t, n, r);
                    },
                    "number | BigNumber | Complex | Unit, Matrix, string": function(t, e, r) {
                        return d(e), g(t, e, r);
                    }
                });
                function p(t, e) {
                    var r = v(t) ? new s(-1) : -1, i = f(t), o = h(t);
                    return y([
                        [
                            i,
                            n(r, o)
                        ],
                        [
                            o,
                            i
                        ]
                    ], e);
                }
                function d(t) {
                    var e = t.size();
                    if (e.length < 1 || 3 !== e[0]) throw new RangeError("Vector must be of dimensions 1x3");
                }
                function m(t) {
                    return t.reduce((t, e)=>n(t, e));
                }
                function y(t, e) {
                    if (e) {
                        if ("sparse" === e) return new c(t);
                        if ("dense" === e) return new l(t);
                        throw new TypeError('Unknown matrix type "'.concat(e, '"'));
                    }
                    return t;
                }
                function g(t, e, r) {
                    var n = a(e);
                    if (0 === n) throw new RangeError("Rotation around zero vector");
                    var u = v(t) ? s : null, l = u ? new u(1) : 1, c = u ? new u(-1) : -1, p = u ? new u(e.get([
                        0
                    ]) / n) : e.get([
                        0
                    ]) / n, d = u ? new u(e.get([
                        1
                    ]) / n) : e.get([
                        1
                    ]) / n, g = u ? new u(e.get([
                        2
                    ]) / n) : e.get([
                        2
                    ]) / n, b = f(t), x = i(l, o(b)), w = h(t);
                    return y([
                        [
                            i(b, m([
                                p,
                                p,
                                x
                            ])),
                            i(m([
                                p,
                                d,
                                x
                            ]), m([
                                c,
                                g,
                                w
                            ])),
                            i(m([
                                p,
                                g,
                                x
                            ]), m([
                                d,
                                w
                            ]))
                        ],
                        [
                            i(m([
                                p,
                                d,
                                x
                            ]), m([
                                g,
                                w
                            ])),
                            i(b, m([
                                d,
                                d,
                                x
                            ])),
                            i(m([
                                d,
                                g,
                                x
                            ]), m([
                                c,
                                p,
                                w
                            ]))
                        ],
                        [
                            i(m([
                                p,
                                g,
                                x
                            ]), m([
                                c,
                                d,
                                w
                            ])),
                            i(m([
                                d,
                                g,
                                x
                            ]), m([
                                p,
                                w
                            ])),
                            i(b, m([
                                g,
                                g,
                                x
                            ]))
                        ]
                    ], r);
                }
            }), Ah = [
                "typed",
                "matrix",
                "divide",
                "sum",
                "multiply",
                "map",
                "dotDivide",
                "log",
                "isNumeric"
            ], Eh = ge("kldivergence", Ah, (t)=>{
                var { typed: e, matrix: r, divide: n, sum: i, multiply: o, map: a, dotDivide: s, log: u, isNumeric: l } = t;
                return e("kldivergence", {
                    "Array, Array": function(t, e) {
                        return c(r(t), r(e));
                    },
                    "Matrix, Array": function(t, e) {
                        return c(t, r(e));
                    },
                    "Array, Matrix": function(t, e) {
                        return c(r(t), e);
                    },
                    "Matrix, Matrix": function(t, e) {
                        return c(t, e);
                    }
                });
                function c(t, e) {
                    var r = e.size().length, c = t.size().length;
                    if (r > 1) throw new Error("first object must be one dimensional");
                    if (c > 1) throw new Error("second object must be one dimensional");
                    if (r !== c) throw new Error("Length of two vectors must be equal");
                    if (0 === i(t)) throw new Error("Sum of elements in first object must be non zero");
                    if (0 === i(e)) throw new Error("Sum of elements in second object must be non zero");
                    var f = n(t, i(t)), h = n(e, i(e)), p = i(o(f, a(s(f, h), (t)=>u(t))));
                    return l(p) ? p : Number.NaN;
                }
            }), Sh = [
                "typed",
                "matrix",
                "identity",
                "multiply",
                "qr",
                "norm",
                "subtract"
            ], Mh = ge("schur", Sh, (t)=>{
                var { typed: e, matrix: r, identity: n, multiply: i, qr: o, norm: a, subtract: s } = t;
                return e("schur", {
                    Array: function(t) {
                        var e = u(r(t));
                        return {
                            U: e.U.valueOf(),
                            T: e.T.valueOf()
                        };
                    },
                    Matrix: function(t) {
                        return u(t);
                    }
                });
                function u(t) {
                    var e, r = t.size()[0], u = t, l = n(r), c = 0;
                    do {
                        e = u;
                        var f = o(u), h = f.Q, p = f.R;
                        if (u = i(p, h), l = i(l, h), c++ > 100) break;
                    }while (a(s(u, e)) > 1e-4);
                    return {
                        U: l,
                        T: u
                    };
                }
            }), kh = [
                "typed",
                "multiply",
                "rotationMatrix"
            ], Nh = ge("rotate", kh, (t)=>{
                var { typed: e, multiply: r, rotationMatrix: n } = t;
                return e("rotate", {
                    "Array , number | BigNumber | Complex | Unit": function(t, e) {
                        return i(t, 2), r(n(e), t).toArray();
                    },
                    "Matrix , number | BigNumber | Complex | Unit": function(t, e) {
                        return i(t, 2), r(n(e), t);
                    },
                    "Array, number | BigNumber | Complex | Unit, Array | Matrix": function(t, e, o) {
                        return i(t, 3), r(n(e, o), t);
                    },
                    "Matrix, number | BigNumber | Complex | Unit, Array | Matrix": function(t, e, o) {
                        return i(t, 3), r(n(e, o), t);
                    }
                });
                function i(t, e) {
                    var r = Array.isArray(t) ? $t(t) : t.size();
                    if (r.length > 2) throw new RangeError("Vector must be of dimensions 1x".concat(e));
                    if (2 === r.length && 1 !== r[1]) throw new RangeError("Vector must be of dimensions 1x".concat(e));
                    if (r[0] !== e) throw new RangeError("Vector must be of dimensions 1x".concat(e));
                }
            }), Ch = [
                "typed",
                "schur",
                "matrixFromColumns",
                "matrix",
                "multiply",
                "range",
                "concat",
                "transpose",
                "index",
                "subset",
                "add",
                "subtract",
                "identity",
                "lusolve",
                "abs"
            ], Dh = ge("sylvester", Ch, (t)=>{
                var { typed: e, schur: r, matrixFromColumns: n, matrix: i, multiply: o, range: a, concat: s, transpose: u, index: l, subset: c, add: f, subtract: h, identity: p, lusolve: d, abs: m } = t;
                return e("sylvester", {
                    "Matrix, Matrix, Matrix": y,
                    "Array, Matrix, Matrix": function(t, e, r) {
                        return y(i(t), e, r);
                    },
                    "Array, Array, Matrix": function(t, e, r) {
                        return y(i(t), i(e), r);
                    },
                    "Array, Matrix, Array": function(t, e, r) {
                        return y(i(t), e, i(r));
                    },
                    "Matrix, Array, Matrix": function(t, e, r) {
                        return y(t, i(e), r);
                    },
                    "Matrix, Array, Array": function(t, e, r) {
                        return y(t, i(e), i(r));
                    },
                    "Matrix, Matrix, Array": function(t, e, r) {
                        return y(t, e, i(r));
                    },
                    "Array, Array, Array": function(t, e, r) {
                        return y(i(t), i(e), i(r)).toArray();
                    }
                });
                function y(t, e, y) {
                    for(var g = e.size()[0], v = t.size()[0], b = r(t), x = b.T, w = b.U, _ = r(o(-1, e)), A = _.T, E = _.U, S = o(o(u(w), y), E), M = a(0, v), k = [], N = (t, e)=>s(t, e, 1), C = (t, e)=>s(t, e, 0), D = 0; D < g; D++)if (D < g - 1 && m(c(A, l(D + 1, D))) > 1e-5) {
                        for(var O = C(c(S, l(M, D)), c(S, l(M, D + 1))), T = 0; T < D; T++)O = f(O, C(o(k[T], c(A, l(T, D))), o(k[T], c(A, l(T, D + 1)))));
                        var F = o(p(v), o(-1, c(A, l(D, D)))), P = o(p(v), o(-1, c(A, l(D + 1, D)))), I = o(p(v), o(-1, c(A, l(D, D + 1)))), B = o(p(v), o(-1, c(A, l(D + 1, D + 1)))), j = C(N(f(x, F), P), N(I, f(x, B))), R = d(j, O);
                        k[D] = R.subset(l(a(0, v), 0)), k[D + 1] = R.subset(l(a(v, 2 * v), 0)), D++;
                    } else {
                        for(var L = c(S, l(M, D)), q = 0; q < D; q++)L = f(L, o(k[q], c(A, l(q, D))));
                        var U = c(A, l(D, D)), z = h(x, o(U, p(v)));
                        k[D] = d(z, L);
                    }
                    var G = i(n(...k));
                    return o(w, o(G, u(E)));
                }
            }), Oh = [
                "typed",
                "matrix",
                "sylvester",
                "multiply",
                "transpose"
            ], Th = ge("lyap", Oh, (t)=>{
                var { typed: e, matrix: r, sylvester: n, multiply: i, transpose: o } = t;
                return e("lyap", {
                    "Matrix, Matrix": function(t, e) {
                        return n(t, o(t), i(-1, e));
                    },
                    "Array, Matrix": function(t, e) {
                        return n(r(t), o(r(t)), i(-1, e));
                    },
                    "Matrix, Array": function(t, e) {
                        return n(t, o(r(t)), r(i(-1, e)));
                    },
                    "Array, Array": function(t, e) {
                        return n(r(t), o(r(t)), r(i(-1, e))).toArray();
                    }
                });
            }), Fh = ti({
                config: ft
            }), Ph = ni({}), Ih = _i({
                BigNumber: Fh,
                config: ft
            }), Bh = yi({}), jh = Ji({
                BigNumber: Fh,
                config: ft
            }), Rh = Po({}), Lh = Di({
                Complex: Ph
            }), qh = vi({
                BigNumber: Fh,
                config: ft
            }), Uh = Si({
                BigNumber: Fh,
                config: ft
            }), zh = ki({
                BigNumber: Fh,
                config: ft
            }), Gh = Io({}), Hh = bi({
                BigNumber: Fh,
                config: ft
            }), Wh = gi({}), $h = Ai({
                BigNumber: Fh,
                config: ft
            }), Vh = Bo({}), Zh = jo({}), Yh = Ni({
                BigNumber: Fh,
                config: ft
            }), Kh = vo({
                BigNumber: Fh,
                config: ft
            }), Xh = wi({
                BigNumber: Fh,
                config: ft
            }), Jh = mi({}), Qh = Oi({}), tp = Ro({
                Matrix: Gh
            }), ep = so({
                BigNumber: Fh,
                config: ft
            }), rp = Ei({
                BigNumber: Fh,
                config: ft
            }), np = xi({
                BigNumber: Fh,
                config: ft
            }), ip = Lo({}), op = Ci({
                BigNumber: Fh,
                config: ft
            }), ap = Uo({
                BigNumber: Fh,
                Complex: Ph,
                DenseMatrix: tp,
                Fraction: Rh
            }), sp = ca({
                BigNumber: Fh,
                config: ft,
                typed: ap
            }), up = ao({
                BigNumber: Fh,
                config: ft
            }), lp = fa({
                typed: ap
            }), cp = ha({
                Complex: Ph,
                config: ft,
                typed: ap
            }), fp = Ca({
                BigNumber: Fh,
                typed: ap
            }), hp = Da({
                BigNumber: Fh,
                Complex: Ph,
                config: ft,
                typed: ap
            }), pp = Oa({
                typed: ap
            }), dp = Ta({
                typed: ap
            }), mp = Fa({
                BigNumber: Fh,
                Complex: Ph,
                config: ft,
                typed: ap
            }), yp = Pa({
                typed: ap
            }), gp = Ia({
                typed: ap
            }), vp = Ba({
                Complex: Ph,
                config: ft,
                typed: ap
            }), bp = ja({
                BigNumber: Fh,
                typed: ap
            }), xp = ts({
                typed: ap
            }), wp = es({
                typed: ap
            }), _p = rs({
                typed: ap
            }), Ap = os({
                typed: ap
            }), Ep = ss({
                Complex: Ph,
                typed: ap
            }), Sp = us({
                typed: ap
            }), Mp = cs({
                typed: ap
            }), kp = fs({
                BigNumber: Fh,
                typed: ap
            }), Np = hs({
                BigNumber: Fh,
                typed: ap
            }), Cp = ps({
                typed: ap
            }), Dp = ys({
                config: ft,
                typed: ap
            }), Op = gs({
                typed: ap
            }), Tp = As({
                typed: ap
            }), Fp = Es({
                Complex: Ph,
                typed: ap
            }), Pp = Ss({
                typed: ap
            }), Ip = ks({
                typed: ap
            }), Bp = Cs({
                typed: ap
            }), jp = Ds({
                typed: ap
            }), Rp = Os({
                format: Bp,
                typed: ap
            }), Lp = Ts({
                typed: ap
            }), qp = Fs({
                typed: ap
            }), Up = Rs({
                typed: ap
            }), zp = Ls({
                typed: ap
            }), Gp = qs({
                typed: ap
            }), Hp = Mi({
                BigNumber: Fh,
                config: ft
            }), Wp = $s({
                Complex: Ph,
                typed: ap
            }), $p = Vs({
                Complex: Ph,
                config: ft,
                typed: ap
            }), Vp = Zs({
                Complex: Ph,
                config: ft,
                typed: ap
            }), Zp = Ys({
                typed: ap
            }), Yp = Xs({
                typed: ap
            }), Kp = ru({
                typed: ap
            }), Xp = nu({
                typed: ap
            }), Jp = iu({
                format: Bp,
                typed: ap
            }), Qp = lu({
                config: ft,
                typed: ap
            }), td = xn({
                typed: ap
            }), ed = fu({
                config: ft,
                typed: ap
            }), rd = hu({
                typed: ap
            }), nd = pu({
                BigNumber: Fh,
                typed: ap
            }), id = du({
                BigNumber: Fh,
                Fraction: Rh,
                complex: Ep,
                typed: ap
            }), od = mu({
                typed: ap
            }), ad = yu({
                Matrix: Gh,
                equalScalar: Dp,
                typed: ap
            }), sd = gu({
                typed: ap
            }), ud = vu({
                typed: ap
            }), ld = bu({
                typed: ap
            }), cd = xu({
                typed: ap
            }), fd = wu({
                typed: ap
            }), hd = _u({
                typed: ap
            }), pd = Au({
                Complex: Ph,
                config: ft,
                typed: ap
            }), dd = Eu({
                BigNumber: Fh,
                typed: ap
            }), md = cn({
                isInteger: qp,
                typed: ap
            }), yd = Su({
                BigNumber: Fh,
                Complex: Ph,
                config: ft,
                typed: ap
            }), gd = Mu({
                format: Bp,
                typed: ap
            }), vd = ku({
                typed: ap
            }), bd = Cu({
                typed: ap
            }), xd = Du({
                BigNumber: Fh,
                typed: ap
            }), wd = Ou({
                typed: ap
            }), _d = Tu({
                typed: ap
            }), Ad = Fu({
                config: ft,
                typed: ap
            }), Ed = Pu({
                BigNumber: Fh,
                typed: ap
            }), Sd = Iu({
                typed: ap
            }), Md = Bu({
                SparseMatrix: ad,
                typed: ap
            }), kd = ju({
                Complex: Ph,
                config: ft,
                typed: ap
            }), Nd = Ru({
                typed: ap
            }), Cd = Lu({
                typed: ap
            }), Dd = qu({
                BigNumber: Fh,
                Complex: Ph,
                config: ft,
                typed: ap
            }), Od = Uu({
                BigNumber: Fh,
                typed: ap
            }), Td = zu({
                Fraction: Rh,
                typed: ap
            }), Fd = Gu({
                typed: ap
            }), Pd = Hu({
                DenseMatrix: tp,
                Matrix: Gh,
                SparseMatrix: ad,
                typed: ap
            }), Id = Wu({
                isZero: Gp,
                matrix: Pd,
                typed: ap
            }), Bd = $u({
                isNaN: wd,
                isNumeric: Fd,
                typed: ap
            }), jd = Vu({
                bignumber: bp,
                fraction: Td,
                number: Xp
            }), Rd = Zu({
                config: ft,
                multiplyScalar: Yp,
                numeric: jd,
                typed: ap
            }), Ld = Yu({
                isInteger: qp,
                matrix: Pd,
                typed: ap
            }), qd = Ku({
                matrix: Pd,
                config: ft,
                typed: ap
            }), Ud = Xu({
                matrix: Pd,
                typed: ap
            }), zd = Ju({
                matrix: Pd,
                typed: ap
            }), Gd = Qu({
                BigNumber: Fh,
                config: ft,
                matrix: Pd,
                typed: ap
            }), Hd = tl({
                BigNumber: Fh,
                config: ft,
                matrix: Pd,
                typed: ap
            }), Wd = el({
                Complex: Ph,
                config: ft,
                typed: ap
            }), $d = rl({
                BigNumber: Fh,
                Complex: Ph,
                Fraction: Rh,
                config: ft,
                isNegative: Up,
                matrix: Pd,
                typed: ap,
                unaryMinus: Cd
            }), Vd = pn({
                isInteger: qp,
                matrix: Pd,
                typed: ap
            }), Zd = nl({
                prod: Rd,
                size: qd,
                typed: ap
            }), Yd = il({
                conj: Sp,
                transpose: zd,
                typed: ap
            }), Kd = ol({
                DenseMatrix: tp,
                SparseMatrix: ad,
                matrix: Pd,
                typed: ap
            }), Xd = al({
                numeric: jd,
                typed: ap
            }), Jd = yl({
                DenseMatrix: tp,
                concat: Vd,
                divideScalar: Xd,
                equalScalar: Dp,
                matrix: Pd,
                typed: ap
            }), Qd = gl({
                DenseMatrix: tp,
                concat: Vd,
                equalScalar: Dp,
                matrix: Pd,
                typed: ap
            }), tm = bl({
                matrix: Pd,
                typed: ap
            }), em = xl({
                isNumeric: Fd,
                typed: ap
            }), rm = wl({
                BigNumber: Fh,
                DenseMatrix: tp,
                SparseMatrix: ad,
                config: ft,
                matrix: Pd,
                typed: ap
            }), nm = _l({
                matrix: Pd,
                multiplyScalar: Yp,
                typed: ap
            }), im = Al({
                DenseMatrix: tp,
                concat: Vd,
                config: ft,
                matrix: Pd,
                typed: ap
            }), om = Cl({
                DenseMatrix: tp,
                concat: Vd,
                equalScalar: Dp,
                matrix: Pd,
                typed: ap,
                zeros: Hd
            }), am = Ol({
                DenseMatrix: tp,
                divideScalar: Xd,
                equalScalar: Dp,
                matrix: Pd,
                multiplyScalar: Yp,
                subtractScalar: cd,
                typed: ap
            }), sm = Tl({
                flatten: tm,
                matrix: Pd,
                size: qd,
                typed: ap
            }), um = Pl({
                BigNumber: Fh,
                concat: Vd,
                equalScalar: Dp,
                matrix: Pd,
                typed: ap
            }), lm = Il({
                BigNumber: Fh,
                config: ft,
                matrix: Pd,
                typed: ap
            }), cm = Bl({
                addScalar: pp,
                complex: Ep,
                conj: Sp,
                divideScalar: Xd,
                equal: Qd,
                identity: rm,
                isZero: Gp,
                matrix: Pd,
                multiplyScalar: Yp,
                sign: id,
                sqrt: kd,
                subtractScalar: cd,
                typed: ap,
                unaryMinus: Cd,
                zeros: Hd
            }), fm = Rl({
                config: ft,
                matrix: Pd
            }), hm = Ll({
                DenseMatrix: tp,
                concat: Vd,
                equalScalar: Dp,
                matrix: Pd,
                typed: ap,
                zeros: Hd
            }), pm = Ul({
                BigNumber: Fh,
                DenseMatrix: tp,
                equalScalar: Dp,
                matrix: Pd,
                typed: ap,
                zeros: Hd
            }), dm = zl({
                DenseMatrix: tp,
                concat: Vd,
                config: ft,
                matrix: Pd,
                typed: ap
            }), mm = Wl({
                DenseMatrix: tp,
                concat: Vd,
                equalScalar: Dp,
                matrix: Pd,
                subtractScalar: cd,
                typed: ap,
                unaryMinus: Cd
            }), ym = $l({
                concat: Vd,
                matrix: Pd,
                typed: ap
            }), gm = Vl({
                DenseMatrix: tp,
                concat: Vd,
                config: ft,
                equalScalar: Dp,
                matrix: Pd,
                typed: ap
            }), vm = Yl({
                DenseMatrix: tp,
                divideScalar: Xd,
                equalScalar: Dp,
                matrix: Pd,
                multiplyScalar: Yp,
                subtractScalar: cd,
                typed: ap
            }), bm = Kl({
                DenseMatrix: tp,
                concat: Vd,
                matrix: Pd,
                typed: ap
            }), xm = Jl({
                DenseMatrix: tp,
                SparseMatrix: ad,
                addScalar: pp,
                concat: Vd,
                equalScalar: Dp,
                matrix: Pd,
                typed: ap
            }), wm = tc({
                BigNumber: Fh,
                DenseMatrix: tp,
                concat: Vd,
                equalScalar: Dp,
                matrix: Pd,
                typed: ap
            }), _m = ec({
                concat: Vd,
                equalScalar: Dp,
                matrix: Pd,
                typed: ap
            }), Am = rc({
                DenseMatrix: tp,
                concat: Vd,
                matrix: Pd,
                typed: ap
            }), Em = nc({
                addScalar: pp,
                combinations: Ap,
                divideScalar: Xd,
                isInteger: qp,
                isNegative: Up,
                multiplyScalar: Yp,
                typed: ap
            }), Sm = ic({
                BigNumber: Fh,
                DenseMatrix: tp,
                Fraction: Rh,
                concat: Vd,
                config: ft,
                equalScalar: Dp,
                matrix: Pd,
                typed: ap
            }), Mm = sc({
                concat: Vd,
                matrix: Pd,
                typed: ap
            }), km = Fn({
                add: xm,
                typed: ap,
                unaryPlus: sp
            }), Nm = uc({
                equal: Qd,
                typed: ap
            }), Cm = An({
                matrix: Pd,
                number: Xp,
                subtract: mm,
                typed: ap
            }), Dm = lc({
                abs: lp,
                addScalar: pp,
                deepEqual: Nm,
                divideScalar: Xd,
                multiplyScalar: Yp,
                sqrt: kd,
                subtractScalar: cd,
                typed: ap
            }), Om = cc({
                addScalar: pp,
                conj: Sp,
                multiplyScalar: Yp,
                size: qd,
                typed: ap
            }), Tm = fc({
                compareText: Mm,
                isZero: Gp,
                typed: ap
            }), Fm = dc({
                DenseMatrix: tp,
                config: ft,
                equalScalar: Dp,
                matrix: Pd,
                round: pm,
                typed: ap,
                zeros: Hd
            }), Pm = xc({
                BigNumber: Fh,
                DenseMatrix: tp,
                concat: Vd,
                config: ft,
                equalScalar: Dp,
                matrix: Pd,
                round: pm,
                typed: ap,
                zeros: Hd
            }), Im = wc({
                abs: lp,
                addScalar: pp,
                divideScalar: Xd,
                isPositive: zp,
                multiplyScalar: Yp,
                smaller: dm,
                sqrt: kd,
                typed: ap
            }), Bm = _c({
                DenseMatrix: tp,
                smaller: dm
            }), jm = Ac({
                ImmutableDenseMatrix: Bm,
                getMatrixDataType: jp
            }), Rm = Sc({
                DenseMatrix: tp,
                concat: Vd,
                config: ft,
                matrix: Pd,
                typed: ap
            }), Lm = kc({
                Complex: Ph,
                config: ft,
                divideScalar: Xd,
                typed: ap
            }), qm = Nc({
                DenseMatrix: tp,
                divideScalar: Xd,
                equalScalar: Dp,
                matrix: Pd,
                multiplyScalar: Yp,
                subtractScalar: cd,
                typed: ap
            }), Um = Cc({
                flatten: tm,
                matrix: Pd,
                size: qd,
                typed: ap
            }), zm = Sn({
                config: ft,
                numeric: jd,
                smaller: dm,
                typed: ap
            }), Gm = mc({
                DenseMatrix: tp,
                concat: Vd,
                config: ft,
                equalScalar: Dp,
                matrix: Pd,
                round: pm,
                typed: ap,
                zeros: Hd
            }), Hm = Dc({
                addScalar: pp,
                dot: Om,
                equalScalar: Dp,
                matrix: Pd,
                multiplyScalar: Yp,
                typed: ap
            }), Wm = Oc({
                Complex: Ph,
                config: ft,
                divideScalar: Xd,
                typed: ap
            }), $m = Tc({
                DenseMatrix: tp,
                concat: Vd,
                equalScalar: Dp,
                matrix: Pd,
                typed: ap
            }), Vm = Fc({
                compare: Sm,
                isNaN: wd,
                isNumeric: Fd,
                typed: ap
            }), Zm = Pc({
                DenseMatrix: tp,
                concat: Vd,
                equalScalar: Dp,
                matrix: Pd,
                typed: ap,
                zeros: Hd
            }), Ym = Vc({
                SparseMatrix: ad,
                abs: lp,
                add: xm,
                divideScalar: Xd,
                larger: Rm,
                largerEq: im,
                multiply: Hm,
                subtract: mm,
                transpose: zd,
                typed: ap
            }), Km = kn({
                add: xm,
                matrix: Pd,
                typed: ap,
                zeros: Hd
            }), Xm = Bn({
                add: xm,
                config: ft,
                numeric: jd,
                typed: ap
            }), Jm = Zc({
                add: xm,
                matrix: Pd,
                typed: ap
            }), Qm = Yc({
                DenseMatrix: tp,
                divideScalar: Xd,
                equalScalar: Dp,
                matrix: Pd,
                multiplyScalar: Yp,
                subtractScalar: cd,
                typed: ap
            }), ty = Kc({
                Complex: Ph,
                add: xm,
                multiply: Hm,
                number: Xp,
                typed: ap
            }), ey = Xc({
                DenseMatrix: tp,
                concat: Vd,
                equalScalar: Dp,
                matrix: Pd,
                typed: ap
            }), ry = tf({
                DenseMatrix: tp,
                config: ft,
                equalScalar: Dp,
                matrix: Pd,
                round: pm,
                typed: ap,
                zeros: Hd
            }), ny = nf({
                compare: Sm,
                typed: ap
            }), iy = of({
                addScalar: pp,
                combinations: Ap,
                isInteger: qp,
                isNegative: Up,
                isPositive: zp,
                larger: Rm,
                typed: ap
            }), oy = af({
                matrix: Pd,
                multiply: Hm,
                subtract: mm,
                typed: ap
            }), ay = sf({
                divideScalar: Xd,
                isZero: Gp,
                matrix: Pd,
                multiply: Hm,
                subtractScalar: cd,
                typed: ap,
                unaryMinus: Cd
            }), sy = uf({
                concat: Vd,
                equalScalar: Dp,
                matrix: Pd,
                multiplyScalar: Yp,
                typed: ap
            }), uy = lf({
                larger: Rm,
                smaller: dm
            }), ly = hf({
                Complex: Ph,
                DenseMatrix: tp,
                ceil: ry,
                equalScalar: Dp,
                floor: Fm,
                matrix: Pd,
                typed: ap,
                zeros: Hd
            }), cy = pf({
                Index: jm,
                typed: ap
            }), fy = df({
                abs: lp,
                add: xm,
                addScalar: pp,
                config: ft,
                divideScalar: Xd,
                equalScalar: Dp,
                flatten: tm,
                isNumeric: Fd,
                isZero: Gp,
                matrix: Pd,
                multiply: Hm,
                multiplyScalar: Yp,
                smaller: dm,
                subtract: mm,
                typed: ap
            }), hy = mf({
                BigNumber: Fh,
                add: xm,
                config: ft,
                equal: Qd,
                isInteger: qp,
                mod: Gm,
                smaller: dm,
                typed: ap,
                xgcd: Gd
            }), py = yf({
                concat: Vd,
                equalScalar: Dp,
                matrix: Pd,
                typed: ap
            }), dy = gf({
                Complex: Ph,
                config: ft,
                divideScalar: Xd,
                log: Lm,
                typed: ap
            }), my = yn({
                config: ft,
                larger: Rm,
                numeric: jd,
                typed: ap
            }), yy = vf({
                DenseMatrix: tp,
                Index: jm,
                compareNatural: ny,
                size: qd,
                subset: Km,
                typed: ap
            }), gy = bf({
                DenseMatrix: tp,
                Index: jm,
                compareNatural: ny,
                size: qd,
                subset: Km,
                typed: ap
            }), vy = xf({
                Index: jm,
                compareNatural: ny,
                size: qd,
                subset: Km,
                typed: ap
            }), by = wf({
                Index: jm,
                compareNatural: ny,
                size: qd,
                subset: Km,
                typed: ap
            }), xy = _f({
                DenseMatrix: tp,
                concat: Vd,
                config: ft,
                matrix: Pd,
                typed: ap
            }), wy = Ef({
                compare: Sm,
                compareNatural: ny,
                matrix: Pd,
                typed: ap
            }), _y = Sf({
                concat: Vd,
                equalScalar: Dp,
                matrix: Pd,
                not: Kp,
                typed: ap,
                zeros: Hd
            }), Ay = Rn({
                bignumber: bp,
                matrix: Pd,
                add: xm,
                config: ft,
                isPositive: zp,
                larger: Rm,
                largerEq: im,
                smaller: dm,
                smallerEq: xy,
                typed: ap
            }), Ey = qn({
                Index: jm,
                matrix: Pd,
                range: Ay,
                typed: ap
            }), Sy = Mf({
                DenseMatrix: tp,
                Index: jm,
                compareNatural: ny,
                size: qd,
                subset: Km,
                typed: ap
            }), My = kf({
                Index: jm,
                compareNatural: ny,
                size: qd,
                subset: Km,
                typed: ap
            }), ky = Nf({
                Index: jm,
                concat: Vd,
                setDifference: Sy,
                size: qd,
                subset: Km,
                typed: ap
            }), Ny = Cf({
                FibonacciHeap: uy,
                addScalar: pp,
                equalScalar: Dp
            }), Cy = zn({
                Index: jm,
                matrix: Pd,
                range: Ay,
                typed: ap
            }), Dy = Df({
                abs: lp,
                addScalar: pp,
                det: ay,
                divideScalar: Xd,
                identity: rm,
                matrix: Pd,
                multiply: Hm,
                typed: ap,
                unaryMinus: Cd
            }), Oy = Of({
                DenseMatrix: tp,
                Spa: Ny,
                SparseMatrix: ad,
                abs: lp,
                addScalar: pp,
                divideScalar: Xd,
                equalScalar: Dp,
                larger: Rm,
                matrix: Pd,
                multiplyScalar: Yp,
                subtractScalar: cd,
                typed: ap,
                unaryMinus: Cd
            }), Ty = Tf({
                Complex: Ph,
                add: xm,
                ctranspose: Yd,
                deepEqual: Nm,
                divideScalar: Xd,
                dot: Om,
                dotDivide: Jd,
                equal: Qd,
                inv: Dy,
                matrix: Pd,
                multiply: Hm,
                typed: ap
            }), Fy = Ff({
                Complex: Ph,
                config: ft,
                fraction: Td,
                identity: rm,
                inv: Dy,
                matrix: Pd,
                multiply: Hm,
                number: Xp,
                typed: ap
            }), Py = Pf({
                DenseMatrix: tp,
                Index: jm,
                compareNatural: ny,
                size: qd,
                subset: Km,
                typed: ap
            }), Iy = If({
                Index: jm,
                concat: Vd,
                setIntersect: Py,
                setSymDifference: ky,
                size: qd,
                subset: Km,
                typed: ap
            }), By = Bf({
                abs: lp,
                add: xm,
                identity: rm,
                inv: Dy,
                map: Zp,
                max: my,
                multiply: Hm,
                size: qd,
                sqrt: kd,
                subtract: mm,
                typed: ap
            }), jy = Lf({
                BigNumber: Fh,
                Complex: Ph,
                Fraction: Rh,
                abs: lp,
                addScalar: pp,
                config: ft,
                divideScalar: Xd,
                equal: Qd,
                fix: ly,
                format: Bp,
                isNumeric: Fd,
                multiplyScalar: Yp,
                number: Xp,
                pow: Fy,
                round: pm,
                subtractScalar: cd
            }), Ry = Li({
                BigNumber: Fh,
                Unit: jy,
                config: ft
            }), Ly = wo({
                BigNumber: Fh,
                Unit: jy,
                config: ft
            }), qy = uo({
                BigNumber: Fh,
                Unit: jy,
                config: ft
            }), Uy = zi({
                BigNumber: Fh,
                Unit: jy,
                config: ft
            }), zy = co({
                BigNumber: Fh,
                Unit: jy,
                config: ft
            }), Gy = Gi({
                BigNumber: Fh,
                Unit: jy,
                config: ft
            }), Hy = qi({
                BigNumber: Fh,
                Unit: jy,
                config: ft
            }), Wy = eo({
                BigNumber: Fh,
                Unit: jy,
                config: ft
            }), $y = qf({
                DenseMatrix: tp,
                concat: Vd,
                equalScalar: Dp,
                matrix: Pd,
                pow: Fy,
                typed: ap
            }), Vy = Ri({
                BigNumber: Fh,
                Unit: jy,
                config: ft
            }), Zy = Ui({
                BigNumber: Fh,
                Unit: jy,
                config: ft
            }), Yy = Uf({
                abs: lp,
                add: xm,
                identity: rm,
                inv: Dy,
                multiply: Hm,
                typed: ap
            }), Ky = fo({
                BigNumber: Fh,
                Unit: jy,
                config: ft
            }), Xy = zf({
                addScalar: pp,
                ceil: ry,
                conj: Sp,
                divideScalar: Xd,
                dotDivide: Jd,
                exp: Tp,
                i: Lh,
                log2: Vp,
                matrix: Pd,
                multiplyScalar: Yp,
                pow: Fy,
                tau: Xh,
                typed: ap
            }), Jy = Gf({
                BigNumber: Fh,
                Complex: Ph,
                config: ft,
                multiplyScalar: Yp,
                pow: Fy,
                typed: ap
            }), Qy = Pi({
                BigNumber: Fh,
                Unit: jy,
                config: ft
            }), tg = Qi({
                BigNumber: Fh,
                Unit: jy,
                config: ft
            }), eg = Hf({
                conj: Sp,
                dotDivide: Jd,
                fft: Xy,
                typed: ap
            }), rg = Vi({
                BigNumber: Fh,
                Unit: jy,
                config: ft
            }), ng = po({
                BigNumber: Fh,
                Unit: jy,
                config: ft
            }), ig = ji({
                BigNumber: Fh,
                Unit: jy,
                config: ft
            }), og = _o({
                BigNumber: Fh,
                Unit: jy,
                config: ft
            }), ag = yo({
                BigNumber: Fh,
                Unit: jy,
                config: ft
            }), sg = ro({
                BigNumber: Fh,
                Unit: jy,
                config: ft
            }), ug = $i({
                BigNumber: Fh,
                Unit: jy,
                config: ft
            }), lg = No({
                BigNumber: Fh,
                Unit: jy,
                config: ft
            }), cg = So({
                BigNumber: Fh,
                Unit: jy,
                config: ft
            }), fg = Co({
                BigNumber: Fh,
                Unit: jy,
                config: ft
            }), hg = to({
                BigNumber: Fh,
                Unit: jy,
                config: ft
            }), pg = no({
                BigNumber: Fh,
                Unit: jy,
                config: ft
            }), dg = Bi({
                BigNumber: Fh,
                Unit: jy,
                config: ft
            }), mg = io({
                BigNumber: Fh,
                Unit: jy,
                config: ft
            }), yg = bo({
                BigNumber: Fh,
                Unit: jy,
                config: ft
            }), gg = Fi({
                BigNumber: Fh,
                Unit: jy,
                config: ft
            }), vg = xo({
                BigNumber: Fh,
                Unit: jy,
                config: ft
            }), bg = oo({
                BigNumber: Fh,
                Unit: jy,
                config: ft
            }), xg = lo({
                BigNumber: Fh,
                Unit: jy,
                config: ft
            }), wg = Zi({
                BigNumber: Fh,
                Unit: jy,
                config: ft
            }), _g = Wf({
                Unit: jy,
                typed: ap
            }), Ag = $f({
                divideScalar: Xd,
                equalScalar: Dp,
                inv: Dy,
                matrix: Pd,
                multiply: Hm,
                typed: ap
            }), Eg = Ki({
                BigNumber: Fh,
                Unit: jy,
                config: ft
            }), Sg = Vf({
                gamma: Jy,
                typed: ap
            }), Mg = ho({
                BigNumber: Fh,
                Unit: jy,
                config: ft
            }), kg = Eo({
                BigNumber: Fh,
                Unit: jy,
                config: ft
            }), Ng = Hi({
                BigNumber: Fh,
                Unit: jy,
                config: ft
            }), Cg = Yf({
                DenseMatrix: tp,
                lsolve: am,
                lup: Oy,
                matrix: Pd,
                slu: Ym,
                typed: ap,
                usolve: vm
            }), Dg = Wi({
                BigNumber: Fh,
                Unit: jy,
                config: ft
            }), Og = Ao({
                BigNumber: Fh,
                Unit: jy,
                config: ft
            }), Tg = Kf({
                add: xm,
                divide: Ag,
                factorial: Sg,
                isInteger: qp,
                isPositive: zp,
                multiply: Hm,
                typed: ap
            }), Fg = Xf({
                factorial: Sg,
                typed: ap
            }), Pg = Mo({
                BigNumber: Fh,
                Unit: jy,
                config: ft
            }), Ig = Qf({
                add: xm,
                cbrt: $d,
                divide: Ag,
                equalScalar: Dp,
                im: Lp,
                isZero: Gp,
                multiply: Hm,
                re: rd,
                sqrt: kd,
                subtract: mm,
                typeOf: hd,
                typed: ap,
                unaryMinus: Cd
            }), Bg = th({
                compareNatural: ny,
                typed: ap
            }), jg = rh({
                abs: lp,
                add: xm,
                bignumber: bp,
                divide: Ag,
                isNegative: Up,
                isPositive: zp,
                larger: Rm,
                map: Zp,
                matrix: Pd,
                max: my,
                multiply: Hm,
                smaller: dm,
                subtract: mm,
                typed: ap,
                unaryMinus: Cd
            }), Rg = nh({
                bignumber: bp,
                addScalar: pp,
                combinations: Ap,
                divideScalar: Xd,
                factorial: Sg,
                isInteger: qp,
                isNegative: Up,
                larger: Rm,
                multiplyScalar: Yp,
                number: Xp,
                pow: Fy,
                subtractScalar: cd,
                typed: ap
            }), Lg = ih({
                Unit: jy,
                typed: ap
            }), qg = oh({
                addScalar: pp,
                isInteger: qp,
                isNegative: Up,
                stirlingS2: Rg,
                typed: ap
            }), Ug = uh({
                abs: lp,
                add: xm,
                addScalar: pp,
                atan: gp,
                bignumber: bp,
                column: Cy,
                complex: Ep,
                config: ft,
                cos: Mp,
                diag: Kd,
                divideScalar: Xd,
                dot: Om,
                equal: Qd,
                flatten: tm,
                im: Lp,
                inv: Dy,
                larger: Rm,
                matrix: Pd,
                matrixFromColumns: sm,
                multiply: Hm,
                multiplyScalar: Yp,
                number: Xp,
                qr: cm,
                re: rd,
                sin: od,
                smaller: dm,
                sqrt: kd,
                subtract: mm,
                typed: ap,
                usolve: vm,
                usolveAll: Qm
            }), zg = Xi({
                BigNumber: Fh,
                Unit: jy,
                config: ft
            }), Gg = mo({
                BigNumber: Fh,
                Unit: jy,
                config: ft
            }), Hg = Hn({
                add: xm,
                divide: Ag,
                typed: ap
            }), Wg = go({
                BigNumber: Fh,
                Unit: jy,
                config: ft
            }), $g = Ii({
                BigNumber: Fh,
                Unit: jy,
                config: ft
            }), Vg = $n({
                bignumber: bp,
                add: xm,
                compare: Sm,
                divide: Ag,
                isInteger: qp,
                larger: Rm,
                multiply: Hm,
                partitionSelect: Vm,
                smaller: dm,
                smallerEq: xy,
                subtract: mm,
                typed: ap
            }), Zg = Zn({
                add: xm,
                apply: md,
                divide: Ag,
                isNaN: wd,
                multiply: Hm,
                subtract: mm,
                typed: ap
            }), Yg = Yi({
                BigNumber: Fh,
                Unit: jy,
                config: ft
            }), Kg = ch({
                add: xm,
                compare: Sm,
                divide: Ag,
                partitionSelect: Vm,
                typed: ap
            }), Xg = hh({
                add: xm,
                divide: Ag,
                matrix: Pd,
                mean: Hg,
                multiply: Hm,
                pow: Fy,
                sqrt: kd,
                subtract: mm,
                sum: Xm,
                typed: ap
            }), Jg = dh({
                Complex: Ph,
                add: xm,
                divide: Ag,
                matrix: Pd,
                multiply: Hm,
                typed: ap
            }), Qg = yh({
                abs: lp,
                map: Zp,
                median: Kg,
                subtract: mm,
                typed: ap
            }), tv = Kn({
                map: Zp,
                sqrt: kd,
                typed: ap,
                variance: Zg
            }), ev = vh({
                BigNumber: Fh,
                Complex: Ph,
                add: xm,
                config: ft,
                divide: Ag,
                equal: Qd,
                factorial: Sg,
                gamma: Jy,
                isNegative: Up,
                multiply: Hm,
                pi: np,
                pow: Fy,
                sin: od,
                smallerEq: xy,
                subtract: mm,
                typed: ap
            }), rv = xh({
                abs: lp,
                add: xm,
                conj: Sp,
                ctranspose: Yd,
                eigs: Ug,
                equalScalar: Dp,
                larger: Rm,
                matrix: Pd,
                multiply: Hm,
                pow: Fy,
                smaller: dm,
                sqrt: kd,
                typed: ap
            }), nv = _h({
                BigNumber: Fh,
                DenseMatrix: tp,
                SparseMatrix: ad,
                addScalar: pp,
                config: ft,
                cos: Mp,
                matrix: Pd,
                multiplyScalar: Yp,
                norm: rv,
                sin: od,
                typed: ap,
                unaryMinus: Cd
            }), iv = Eh({
                divide: Ag,
                dotDivide: Jd,
                isNumeric: Fd,
                log: Lm,
                map: Zp,
                matrix: Pd,
                multiply: Hm,
                sum: Xm,
                typed: ap
            }), ov = ko({
                BigNumber: Fh,
                Unit: jy,
                config: ft
            }), av = Mh({
                identity: rm,
                matrix: Pd,
                multiply: Hm,
                norm: rv,
                qr: cm,
                subtract: mm,
                typed: ap
            }), sv = Nh({
                multiply: Hm,
                rotationMatrix: nv,
                typed: ap
            }), uv = Dh({
                abs: lp,
                add: xm,
                concat: Vd,
                identity: rm,
                index: cy,
                lusolve: Cg,
                matrix: Pd,
                matrixFromColumns: sm,
                multiply: Hm,
                range: Ay,
                schur: av,
                subset: Km,
                subtract: mm,
                transpose: zd,
                typed: ap
            }), lv = Th({
                matrix: Pd,
                multiply: Hm,
                sylvester: uv,
                transpose: zd,
                typed: ap
            }), cv = {}, fv = {}, hv = {}, pv = Oe({
                mathWithTransform: fv
            }), dv = Pe({
                Node: pv
            }), mv = Ye({
                Node: pv
            }), yv = Ke({
                Node: pv
            }), gv = Xe({
                Node: pv
            }), vv = Je({
                Node: pv
            }), bv = Qe({
                Node: pv,
                ResultSet: Zh
            }), xv = tr({
                Node: pv
            }), wv = er({
                Node: pv
            }), _v = rr({
                Node: pv
            }), Av = nr({
                classes: hv
            }), Ev = ir({
                math: cv,
                typed: ap
            }), Sv = or({
                Node: pv,
                typed: ap
            }), Mv = ar({
                Chain: Ev,
                typed: ap
            }), kv = sr({
                Node: pv,
                size: qd
            }), Nv = cr({
                Node: pv,
                subset: Km
            }), Cv = fr({
                matrix: Pd,
                Node: pv,
                subset: Km
            }), Dv = hr({
                Unit: jy,
                Node: pv,
                math: cv
            }), Ov = dr({
                Node: pv,
                SymbolNode: Dv,
                math: cv
            }), Tv = _r({
                AccessorNode: Nv,
                ArrayNode: vv,
                AssignmentNode: Cv,
                BlockNode: bv,
                ConditionalNode: xv,
                ConstantNode: wv,
                FunctionAssignmentNode: Sv,
                FunctionNode: Ov,
                IndexNode: kv,
                ObjectNode: dv,
                OperatorNode: mv,
                ParenthesisNode: yv,
                RangeNode: _v,
                RelationalNode: gv,
                SymbolNode: Dv,
                config: ft,
                numeric: jd,
                typed: ap
            }), Fv = Ar({
                ConstantNode: wv,
                FunctionNode: Ov,
                OperatorNode: mv,
                ParenthesisNode: yv,
                parse: Tv,
                typed: ap
            }), Pv = Or({
                bignumber: bp,
                fraction: Td,
                AccessorNode: Nv,
                ArrayNode: vv,
                ConstantNode: wv,
                FunctionNode: Ov,
                IndexNode: kv,
                ObjectNode: dv,
                OperatorNode: mv,
                SymbolNode: Dv,
                config: ft,
                mathWithTransform: fv,
                matrix: Pd,
                typed: ap
            }), Iv = Fr({
                parse: Tv,
                typed: ap
            }), Bv = Ir({
                parse: Tv
            }), jv = jr({
                parse: Tv,
                typed: ap
            }), Rv = Lr({
                AccessorNode: Nv,
                ArrayNode: vv,
                ConstantNode: wv,
                FunctionNode: Ov,
                IndexNode: kv,
                ObjectNode: dv,
                OperatorNode: mv,
                ParenthesisNode: yv,
                SymbolNode: Dv,
                add: xm,
                divide: Ag,
                equal: Qd,
                isZero: Gp,
                multiply: Hm,
                parse: Tv,
                pow: Fy,
                subtract: mm,
                typed: ap
            }), Lv = Ur({
                parse: Tv,
                typed: ap
            }), qv = Wr({
                Help: Bv,
                mathWithTransform: fv,
                typed: ap
            }), Uv = $r({
                evaluate: Lv
            }), zv = Yr({
                bignumber: bp,
                fraction: Td,
                AccessorNode: Nv,
                ArrayNode: vv,
                ConstantNode: wv,
                FunctionNode: Ov,
                IndexNode: kv,
                ObjectNode: dv,
                OperatorNode: mv,
                ParenthesisNode: yv,
                SymbolNode: Dv,
                add: xm,
                config: ft,
                divide: Ag,
                equal: Qd,
                isZero: Gp,
                mathWithTransform: fv,
                matrix: Pd,
                multiply: Hm,
                parse: Tv,
                pow: Fy,
                resolve: Fv,
                simplifyConstant: Pv,
                simplifyCore: Rv,
                subtract: mm,
                typed: ap
            }), Gv = Kr({
                OperatorNode: mv,
                parse: Tv,
                simplify: zv,
                typed: ap
            }), Hv = Xr({
                Parser: Uv,
                typed: ap
            }), Wv = Jr({
                bignumber: bp,
                fraction: Td,
                AccessorNode: Nv,
                ArrayNode: vv,
                ConstantNode: wv,
                FunctionNode: Ov,
                IndexNode: kv,
                ObjectNode: dv,
                OperatorNode: mv,
                ParenthesisNode: yv,
                SymbolNode: Dv,
                add: xm,
                config: ft,
                divide: Ag,
                equal: Qd,
                isZero: Gp,
                mathWithTransform: fv,
                matrix: Pd,
                multiply: Hm,
                parse: Tv,
                pow: Fy,
                simplify: zv,
                simplifyConstant: Pv,
                simplifyCore: Rv,
                subtract: mm,
                typed: ap
            }), $v = Qr({
                ConstantNode: wv,
                FunctionNode: Ov,
                OperatorNode: mv,
                ParenthesisNode: yv,
                SymbolNode: Dv,
                config: ft,
                equal: Qd,
                isZero: Gp,
                numeric: jd,
                parse: Tv,
                simplify: zv,
                typed: ap
            });
            m()(cv, {
                e: Ih,
                false: Bh,
                fineStructure: jh,
                i: Lh,
                Infinity: qh,
                LN10: Uh,
                LOG10E: zh,
                NaN: Hh,
                null: Wh,
                phi: $h,
                SQRT1_2: Yh,
                sackurTetrode: Kh,
                tau: Xh,
                true: Jh,
                E: Ih,
                version: Qh,
                efimovFactor: ep,
                LN2: rp,
                pi: np,
                replacer: ip,
                reviver: Av,
                SQRT2: op,
                typed: ap,
                unaryPlus: sp,
                PI: np,
                weakMixingAngle: up,
                abs: lp,
                acos: cp,
                acot: fp,
                acsc: hp,
                addScalar: pp,
                arg: dp,
                asech: mp,
                asinh: yp,
                atan: gp,
                atanh: vp,
                bignumber: bp,
                bitNot: xp,
                boolean: wp,
                clone: _p,
                combinations: Ap,
                complex: Ep,
                conj: Sp,
                cos: Mp,
                cot: kp,
                csc: Np,
                cube: Cp,
                equalScalar: Dp,
                erf: Op,
                exp: Tp,
                expm1: Fp,
                filter: Pp,
                forEach: Ip,
                format: Bp,
                getMatrixDataType: jp,
                hex: Rp,
                im: Lp,
                isInteger: qp,
                isNegative: Up,
                isPositive: zp,
                isZero: Gp,
                LOG2E: Hp,
                lgamma: Wp,
                log10: $p,
                log2: Vp,
                map: Zp,
                multiplyScalar: Yp,
                not: Kp,
                number: Xp,
                oct: Jp,
                pickRandom: Qp,
                print: td,
                random: ed,
                re: rd,
                sec: nd,
                sign: id,
                sin: od,
                splitUnit: sd,
                square: ud,
                string: ld,
                subtractScalar: cd,
                tan: fd,
                typeOf: hd,
                acosh: pd,
                acsch: dd,
                apply: md,
                asec: yd,
                bin: gd,
                chain: Mv,
                combinationsWithRep: vd,
                cosh: bd,
                csch: xd,
                isNaN: wd,
                isPrime: _d,
                randomInt: Ad,
                sech: Ed,
                sinh: Sd,
                sparse: Md,
                sqrt: kd,
                tanh: Nd,
                unaryMinus: Cd,
                acoth: Dd,
                coth: Od,
                fraction: Td,
                isNumeric: Fd,
                matrix: Pd,
                matrixFromFunction: Id,
                mode: Bd,
                numeric: jd,
                prod: Rd,
                reshape: Ld,
                size: qd,
                squeeze: Ud,
                transpose: zd,
                xgcd: Gd,
                zeros: Hd,
                asin: Wd,
                cbrt: $d,
                concat: Vd,
                count: Zd,
                ctranspose: Yd,
                diag: Kd,
                divideScalar: Xd,
                dotDivide: Jd,
                equal: Qd,
                flatten: tm,
                hasNumericValue: em,
                identity: rm,
                kron: nm,
                largerEq: im,
                leftShift: om,
                lsolve: am,
                matrixFromColumns: sm,
                nthRoot: um,
                ones: lm,
                qr: cm,
                resize: fm,
                rightArithShift: hm,
                round: pm,
                smaller: dm,
                subtract: mm,
                to: ym,
                unequal: gm,
                usolve: vm,
                xor: bm,
                add: xm,
                atan2: wm,
                bitAnd: _m,
                bitXor: Am,
                catalan: Em,
                compare: Sm,
                compareText: Mm,
                cumsum: km,
                deepEqual: Nm,
                diff: Cm,
                distance: Dm,
                dot: Om,
                equalText: Tm,
                floor: Fm,
                gcd: Pm,
                hypot: Im,
                larger: Rm,
                log: Lm,
                lsolveAll: qm,
                matrixFromRows: Um,
                min: zm,
                mod: Gm,
                multiply: Hm,
                nthRoots: Wm,
                or: $m,
                partitionSelect: Vm,
                rightLogShift: Zm,
                slu: Ym,
                subset: Km,
                sum: Xm,
                trace: Jm,
                usolveAll: Qm,
                zpk2tf: ty,
                bitOr: ey,
                ceil: ry,
                compareNatural: ny,
                composition: iy,
                cross: oy,
                det: ay,
                dotMultiply: sy,
                fix: ly,
                index: cy,
                intersect: fy,
                invmod: hy,
                lcm: py,
                log1p: dy,
                max: my,
                setCartesian: yy,
                setDistinct: gy,
                setIsSubset: vy,
                setPowerset: by,
                smallerEq: xy,
                sort: wy,
                and: _y,
                range: Ay,
                row: Ey,
                setDifference: Sy,
                setMultiplicity: My,
                setSymDifference: ky,
                column: Cy,
                inv: Dy,
                lup: Oy,
                pinv: Ty,
                pow: Fy,
                setIntersect: Py,
                setUnion: Iy,
                sqrtm: By,
                vacuumImpedance: Ry,
                wienDisplacement: Ly,
                atomicMass: qy,
                bohrMagneton: Uy,
                boltzmann: zy,
                conductanceQuantum: Gy,
                coulomb: Hy,
                deuteronMass: Wy,
                dotPow: $y,
                electricConstant: Vy,
                elementaryCharge: Zy,
                expm: Yy,
                faraday: Ky,
                fft: Xy,
                gamma: Jy,
                gravitationConstant: Qy,
                hartreeEnergy: tg,
                ifft: eg,
                klitzing: rg,
                loschmidt: ng,
                magneticConstant: ig,
                molarMass: og,
                molarPlanckConstant: ag,
                neutronMass: sg,
                nuclearMagneton: ug,
                planckCharge: lg,
                planckLength: cg,
                planckTemperature: fg,
                protonMass: hg,
                quantumOfCirculation: pg,
                reducedPlanckConstant: dg,
                rydberg: mg,
                secondRadiation: yg,
                speedOfLight: gg,
                stefanBoltzmann: vg,
                thomsonCrossSection: bg,
                avogadro: xg,
                bohrRadius: wg,
                createUnit: _g,
                divide: Ag,
                electronMass: Eg,
                factorial: Sg,
                firstRadiation: Mg,
                gravity: kg,
                inverseConductanceQuantum: Ng,
                lusolve: Cg,
                magneticFluxQuantum: Dg,
                molarMassC12: Og,
                multinomial: Tg,
                parse: Tv,
                permutations: Fg,
                planckMass: Pg,
                polynomialRoot: Ig,
                resolve: Fv,
                setSize: Bg,
                simplifyConstant: Pv,
                solveODE: jg,
                stirlingS2: Rg,
                unit: Lg,
                bellNumbers: qg,
                compile: Iv,
                eigs: Ug,
                fermiCoupling: zg,
                gasConstant: Gg,
                leafCount: jv,
                mean: Hg,
                molarVolume: Wg,
                planckConstant: $g,
                quantileSeq: Vg,
                simplifyCore: Rv,
                variance: Zg,
                classicalElectronRadius: Yg,
                evaluate: Lv,
                help: qv,
                median: Kg,
                simplify: zv,
                symbolicEqual: Gv,
                corr: Xg,
                freqz: Jg,
                mad: Qg,
                parser: Hv,
                rationalize: Wv,
                std: tv,
                zeta: ev,
                derivative: $v,
                norm: rv,
                rotationMatrix: nv,
                kldivergence: iv,
                planckTime: ov,
                schur: av,
                rotate: sv,
                sylvester: uv,
                lyap: lv,
                config: ft
            }), m()(fv, cv, {
                filter: on({
                    typed: ap
                }),
                forEach: sn({
                    typed: ap
                }),
                map: un({
                    typed: ap
                }),
                apply: hn({
                    isInteger: qp,
                    typed: ap
                }),
                concat: dn({
                    isInteger: qp,
                    matrix: Pd,
                    typed: ap
                }),
                max: vn({
                    config: ft,
                    larger: Rm,
                    numeric: jd,
                    typed: ap
                }),
                print: _n({
                    add: xm,
                    matrix: Pd,
                    typed: ap,
                    zeros: Hd
                }),
                diff: En({
                    bignumber: bp,
                    matrix: Pd,
                    number: Xp,
                    subtract: mm,
                    typed: ap
                }),
                min: Mn({
                    config: ft,
                    numeric: jd,
                    smaller: dm,
                    typed: ap
                }),
                subset: Tn({
                    add: xm,
                    matrix: Pd,
                    typed: ap,
                    zeros: Hd
                }),
                cumsum: Pn({
                    add: xm,
                    typed: ap,
                    unaryPlus: sp
                }),
                index: In({
                    Index: jm,
                    getMatrixDataType: jp
                }),
                sum: jn({
                    add: xm,
                    config: ft,
                    numeric: jd,
                    typed: ap
                }),
                range: Ln({
                    bignumber: bp,
                    matrix: Pd,
                    add: xm,
                    config: ft,
                    isPositive: zp,
                    larger: Rm,
                    largerEq: im,
                    smaller: dm,
                    smallerEq: xy,
                    typed: ap
                }),
                row: Un({
                    Index: jm,
                    matrix: Pd,
                    range: Ay,
                    typed: ap
                }),
                column: Gn({
                    Index: jm,
                    matrix: Pd,
                    range: Ay,
                    typed: ap
                }),
                mean: Wn({
                    add: xm,
                    divide: Ag,
                    typed: ap
                }),
                quantileSeq: Vn({
                    add: xm,
                    bignumber: bp,
                    compare: Sm,
                    divide: Ag,
                    isInteger: qp,
                    larger: Rm,
                    multiply: Hm,
                    partitionSelect: Vm,
                    smaller: dm,
                    smallerEq: xy,
                    subtract: mm,
                    typed: ap
                }),
                variance: Yn({
                    add: xm,
                    apply: md,
                    divide: Ag,
                    isNaN: wd,
                    multiply: Hm,
                    subtract: mm,
                    typed: ap
                }),
                std: Xn({
                    map: Zp,
                    sqrt: kd,
                    typed: ap,
                    variance: Zg
                })
            }), m()(hv, {
                BigNumber: Fh,
                Complex: Ph,
                Fraction: Rh,
                Matrix: Gh,
                Node: pv,
                ObjectNode: dv,
                OperatorNode: mv,
                ParenthesisNode: yv,
                Range: Vh,
                RelationalNode: gv,
                ResultSet: Zh,
                ArrayNode: vv,
                BlockNode: bv,
                ConditionalNode: xv,
                ConstantNode: wv,
                DenseMatrix: tp,
                RangeNode: _v,
                Chain: Ev,
                FunctionAssignmentNode: Sv,
                SparseMatrix: ad,
                IndexNode: kv,
                ImmutableDenseMatrix: Bm,
                Index: jm,
                AccessorNode: Nv,
                AssignmentNode: Cv,
                FibonacciHeap: uy,
                Spa: Ny,
                Unit: jy,
                SymbolNode: Dv,
                FunctionNode: Ov,
                Help: Bv,
                Parser: Uv
            }), Ev.createProxy(cv);
            var Vv = r(16), Zv = r(68), Yv = r(9), Kv = /[A-z]{2}/g, Xv = function(t, e) {
                for(var r = t.length, n = 0; n < r; n++)if (t[n] === e) return !0;
                return !1;
            }, Jv = function(t) {
                return !t.op;
            }, Qv = function(t, e) {
                return a()(Function, u()(Yv.a.listVariables(e)).concat([
                    "return ".concat(tb(t))
                ]));
            }, tb = function t(e) {
                var r, n, i = e.args[0], o = e.args[1], a = e.op;
                return r = i.content ? "(".concat(t(i.content)) : Jv(i) ? "(".concat(i.value || i.name) : "(".concat(t(i)), n = o.content ? "".concat(t(o.content), ")") : Jv(o) ? "".concat(o.value || o.name, ")") : "".concat(t(o), ")"), "".concat(r, " ").concat(a, " ").concat(n);
            }, eb = function(t, e) {
                for(var r = [], n = 0; n < t.length; n++)r.push(t[n][e]);
                return r;
            }, rb = function(t, e) {
                for(var r = [], n = 0; n < t.length; n++)r.push(t[n][e]);
                return r;
            }, nb = function(t) {
                if (t.match(Kv)) return "Geoblaze does not currently support implicit multiplication between variables. Please use the multiplication (*) symbol for these operations.";
            }, ib = function() {
                var t = i()(c.a.mark(function t(e, r) {
                    var n, i, o, a, s, l, h, d, m, y, g, v, b, x, w, _;
                    return c.a.wrap(function(t) {
                        for(;;)switch(t.prev = t.next){
                            case 0:
                                return n = e.noDataValue, t.next = 3, Object(Vv.a)(e, void 0, !1);
                            case 3:
                                if (!((i = t.sent).length < 2)) {
                                    t.next = 6;
                                    break;
                                }
                                throw new Error("Band arithmetic is not available for this raster. Please make sure you are using a multi-band raster.");
                            case 6:
                                if (!(o = nb(r))) {
                                    t.next = 9;
                                    break;
                                }
                                throw new Error(o);
                            case 9:
                                for(a = [], s = i[0].length, l = Tv(r.toLowerCase()), h = Qv(l, i.length), d = 0; d < s; d++){
                                    for(m = eb(i, d), y = [], g = m[0].length, v = 0; v < g; v++)b = rb(m, v), Xv(b, n) || (x = h.apply(void 0, u()(b))) === 1 / 0 || x === -1 / 0 || isNaN(x) ? y.push(n) : y.push(x);
                                    a.push(y);
                                }
                                return w = f.a.pick.apply(f.a, [
                                    e
                                ].concat([
                                    "noDataValue",
                                    "projection",
                                    "xmin",
                                    "ymax",
                                    "pixelWidth",
                                    "pixelHeight"
                                ])), t.next = 17, p()([
                                    a
                                ], w);
                            case 17:
                                return _ = t.sent, t.abrupt("return", _);
                            case 19:
                            case "end":
                                return t.stop();
                        }
                    }, t);
                }));
                return function(e, r) {
                    return t.apply(this, arguments);
                };
            }(), ob = Object(Zv.a)(ib);
        },
        function(t, e, r) {
            "use strict";
            r.d(e, "a", function() {
                return x;
            });
            var n = r(45), i = r(27), o = r(170), a = r.n(o), s = r(55), u = r.n(s), l = r(14), c = r.n(l), f = r(16), h = r(9), p = r(13), d = r(24), m = r(69), y = function(t, e) {
                for(var r = a()(t), n = (u()(t) - r) / e, o = i.a.range(e).map(function(t, e) {
                    return [
                        Number((r + t * n).toFixed(2)),
                        Number((r + (t + 1) * n).toFixed(2))
                    ];
                }), s = {}, l = 0, c = o[l], f = "".concat(c[0], " - ").concat(c[1]), h = t[0]; h > c[1];)l += 1, c = o[f], f = ">".concat(c[0], " - ").concat(c[1]);
                s[f] = 1;
                for(var p = 1; p < t.length; p++){
                    var d = t[p];
                    if (d <= c[1]) s[f] += 1;
                    else {
                        for(; d > c[1];)c = o[l += 1], s[f = ">".concat(c[0], " - ").concat(c[1])] = 0;
                        s[f] = 1;
                    }
                }
                return s;
            }, g = function(t, e) {
                for(var r = t.length / e, n = {}, o = t[0], a = 1, s = 1; s < t.length; s++)if (a + 1 < r) a += 1;
                else {
                    var u = t[s], l = u;
                    a += 1, i.a.keys(n).length > 0 && (o = ">".concat(o)), n["".concat(o, " - ").concat(l)] = a, a = 0, o = u;
                }
                var c = t[t.length - 1];
                return a += 1, o = ">".concat(o), n["".concat(o, " - ").concat(c)] = a, n;
            }, v = function(t) {
                var e, r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, n = r.scaleType, i = r.numClasses, o = r.classType;
                if (!n) throw 'Insufficient options were provided, need a value for "scaleType." Possible values include "nominal" and "ratio".';
                if ("nominal" === n) {
                    e = {};
                    for(var a = 0; a < t.length; a++){
                        var s = t[a];
                        e[s] ? e[s] += 1 : e[s] = 1;
                    }
                } else if ("ratio" === n) {
                    if (e = {}, !i) throw 'Insufficient options were provided, need a value for "numClasses".';
                    if (!o) throw 'Insufficient options were provided, need a value for "classType". Possible values include "equal-interval" and "quantile"';
                    if (t = t.sort(function(t, e) {
                        return t - e;
                    }), "equal-interval" === o) e = y(t, i);
                    else {
                        if ("quantile" !== o) throw "The classType provided is either not supported or incorrectly specified.";
                        e = g(t, i);
                    }
                }
                if (e) return e;
                throw "An unexpected error occurred while running the getHistogram function.";
            }, b = Object(p.a)(function(t, e, r) {
                var n = t.noDataValue;
                try {
                    var i = function(t) {
                        return t.map(function(t) {
                            return t.filter(function(t) {
                                return t !== n;
                            });
                        }).map(function(t) {
                            return v(t, r);
                        });
                    };
                    if (null == e) {
                        var o = Object(f.a)(t, null, !0);
                        return c.a.resolve(o).then(i);
                    }
                    if (h.a.isBbox(e)) {
                        e = Object(d.a)(e);
                        var a = Object(f.a)(t, e, !0);
                        return c.a.resolve(a).then(i);
                    }
                    if (h.a.isPolygonal(e)) {
                        e = Object(d.b)(e);
                        var s = t.noDataValue, u = [], l = Object(m.a)(t, e, function(t, e) {
                            u[e] ? u[e].push(t) : u[e] = [
                                t
                            ];
                        });
                        return c.a.resolve(l).then(function() {
                            return u.map(function(t) {
                                return t.filter(function(t) {
                                    return t !== s;
                                });
                            }).map(function(t) {
                                return v(t, r);
                            });
                        });
                    }
                    throw "Only Bounding Box and Polygon geometries are currently supported.";
                } catch (t) {
                    throw console.error(t), t;
                }
            });
            function x() {
                return Object(n.a)(b).apply(void 0, arguments);
            }
        },
        function(t, e, r) {
            "use strict";
            r.d(e, "a", function() {
                return l;
            });
            var n = r(13), i = r(45), o = r(8), a = r.n(o), s = r(24), u = Object(n.a)(function(t, e) {
                var r = Object(s.c)(e), n = a()(r, 2), i = n[0], o = n[1], u = Math.floor((i - t.xmin) / t.pixelWidth), l = Math.floor((t.ymax - o) / t.pixelHeight);
                try {
                    return u > 0 && u < t.width && l > 0 && l < t.height ? t.values ? t.values.map(function(t) {
                        return t[l][u];
                    }) : t.getValues({
                        height: 1,
                        width: 1,
                        left: u,
                        top: l,
                        right: u + 1,
                        bottom: l + 1
                    }).then(function(t) {
                        return t.map(function(t) {
                            return t[0][0];
                        });
                    }) : null;
                } catch (t) {
                    throw console.error(t), t;
                }
            });
            function l() {
                return Object(n.a)(Object(i.a)(u)).apply(void 0, arguments);
            }
        },
        function(t, e, r) {
            "use strict";
            r.d(e, "a", function() {
                return _;
            });
            var n = r(17), i = r.n(n), o = r(65), a = r.n(o), s = r(22), u = r.n(s), l = r(5), c = r.n(l), f = r(27), h = r(29), p = r.n(h), d = r(16), m = r(68), y = r(9), g = function(t, e) {
                for(var r = t.length, n = 0; n < r; n++)if (t[n] === e) return !0;
                return !1;
            }, v = function(t, e) {
                return a()(Function, u()(y.a.listVariables(e)).concat([
                    t
                ]));
            }, b = function(t, e) {
                for(var r = [], n = 0; n < t.length; n++)r.push(t[n][e]);
                return r;
            }, x = function(t, e) {
                for(var r = [], n = 0; n < t.length; n++)r.push(t[n][e]);
                return r;
            }, w = function() {
                var t = i()(c.a.mark(function t(e, r) {
                    var n, i, o, a, s, l, h, m, y, w, _, A, E;
                    return c.a.wrap(function(t) {
                        for(;;)switch(t.prev = t.next){
                            case 0:
                                return t.next = 2, Object(d.a)(e);
                            case 2:
                                if (n = t.sent, i = n.length, "string" == typeof r && (r = v(r.toLowerCase(), i)), "function" == typeof r) {
                                    t.next = 7;
                                    break;
                                }
                                throw new Error("Function is invalid. Please provide a valid function as the second argument.");
                            case 7:
                                for(o = e.noDataValue, a = [], s = n[0].length, l = 0; l < s; l++){
                                    for(h = b(n, l), m = [], y = h[0].length, w = 0; w < y; w++)_ = x(h, w), g(_, o) || (A = r.apply(void 0, u()(_))) === 1 / 0 || A === -1 / 0 || isNaN(A) ? m.push(o) : m.push(A);
                                    a.push(m);
                                }
                                return E = f.a.pick.apply(f.a, [
                                    e
                                ].concat([
                                    "noDataValue",
                                    "projection",
                                    "xmin",
                                    "ymax",
                                    "pixelWidth",
                                    "pixelHeight"
                                ])), t.next = 14, p()([
                                    a
                                ], E);
                            case 14:
                                return t.abrupt("return", t.sent);
                            case 15:
                            case "end":
                                return t.stop();
                        }
                    }, t);
                }));
                return function(e, r) {
                    return t.apply(this, arguments);
                };
            }(), _ = Object(m.a)(w);
        },
        function(t, e, r) {
            !function(e, n) {
                if ("object" == typeof t.exports && (t.exports = n(r(189))), "object" == typeof e.navigator) {
                    if (!e.Terraformer) throw new Error("Terraformer.ArcGIS requires the core Terraformer library. https://github.com/esri/Terraformer");
                    e.Terraformer.ArcGIS = n(e.Terraformer);
                }
            }(this, function(t) {
                var e = {};
                function r(t) {
                    var e, r, n, i, o = 0, a = 0, s = [];
                    n = t.match(/((\+|\-)[^\+\-]+)/g), i = parseInt(n[0], 32);
                    for(var u = 1; u < n.length; u += 2)o = e = parseInt(n[u], 32) + o, a = r = parseInt(n[u + 1], 32) + a, s.push([
                        e / i,
                        r / i
                    ]);
                    return s;
                }
                function n(t) {
                    return function(t, e) {
                        for(var r = 0; r < t.length; r++)if (t[r] !== e[r]) return !1;
                        return !0;
                    }(t[0], t[t.length - 1]) || t.push(t[0]), t;
                }
                function i(t) {
                    var e = {};
                    for(var r in t)t.hasOwnProperty(r) && (e[r] = t[r]);
                    return e;
                }
                function o(t) {
                    for(var e, r = 0, n = 0, i = t.length, o = t[n]; n < i - 1; n++)r += ((e = t[n + 1])[0] - o[0]) * (e[1] + o[1]), o = e;
                    return r >= 0;
                }
                function a(t) {
                    var e = [], r = t.slice(0), i = n(r.shift().slice(0));
                    if (i.length >= 4) {
                        o(i) || i.reverse(), e.push(i);
                        for(var a = 0; a < r.length; a++){
                            var s = n(r[a].slice(0));
                            s.length >= 4 && (o(s) && s.reverse(), e.push(s));
                        }
                    }
                    return e;
                }
                function s(e, r) {
                    var n = t.Tools.arraysIntersectArrays(e, r), i = t.Tools.coordinatesContainPoint(e, r[0]);
                    return !(n || !i);
                }
                function u(e, a) {
                    var l = {};
                    return (a = a || {}).idAttribute = a.idAttribute || void 0, !e.spatialReference || 3857 !== e.spatialReference.wkid && 102100 !== e.spatialReference.wkid || (l.crs = t.MercatorCRS), "number" == typeof e.x && "number" == typeof e.y && (l.type = "Point", l.coordinates = [
                        e.x,
                        e.y
                    ], (e.z || e.m) && l.coordinates.push(e.z), e.m && l.coordinates.push(e.m)), e.points && (l.type = "MultiPoint", l.coordinates = e.points.slice(0)), e.paths && (1 === e.paths.length ? (l.type = "LineString", l.coordinates = e.paths[0].slice(0)) : (l.type = "MultiLineString", l.coordinates = e.paths.slice(0))), e.rings && (l = function(e) {
                        for(var r, i, a, u = [], l = [], c = 0; c < e.length; c++){
                            var f = n(e[c].slice(0));
                            if (!(f.length < 4)) {
                                if (o(f)) {
                                    var h = [
                                        f.slice().reverse()
                                    ];
                                    u.push(h);
                                } else l.push(f.slice().reverse());
                            }
                        }
                        for(var p = []; l.length;){
                            a = l.pop();
                            var d = !1;
                            for(r = u.length - 1; r >= 0; r--)if (s(i = u[r][0], a)) {
                                u[r].push(a), d = !0;
                                break;
                            }
                            d || p.push(a);
                        }
                        for(; p.length;){
                            a = p.pop();
                            var m = !1;
                            for(r = u.length - 1; r >= 0; r--)if (i = u[r][0], t.Tools.arraysIntersectArrays(i, a)) {
                                u[r].push(a), m = !0;
                                break;
                            }
                            m || u.push([
                                a.reverse()
                            ]);
                        }
                        return 1 === u.length ? {
                            type: "Polygon",
                            coordinates: u[0]
                        } : {
                            type: "MultiPolygon",
                            coordinates: u
                        };
                    }(e.rings.slice(0))), "number" == typeof e.xmin && "number" == typeof e.ymin && "number" == typeof e.xmax && "number" == typeof e.ymax && (l.type = "Polygon", l.coordinates = [
                        [
                            [
                                e.xmax,
                                e.ymax
                            ],
                            [
                                e.xmin,
                                e.ymax
                            ],
                            [
                                e.xmin,
                                e.ymin
                            ],
                            [
                                e.xmax,
                                e.ymin
                            ],
                            [
                                e.xmax,
                                e.ymax
                            ]
                        ]
                    ]), (e.compressedGeometry || e.geometry || e.attributes) && (l.type = "Feature", e.compressedGeometry && (e.geometry = {
                        paths: [
                            r(e.compressedGeometry)
                        ]
                    }), l.geometry = e.geometry ? u(e.geometry) : null, l.properties = e.attributes ? i(e.attributes) : null, e.attributes && (l.id = e.attributes[a.idAttribute] || e.attributes.OBJECTID || e.attributes.FID)), new t.Primitive(l);
                }
                function l(t, e) {
                    var r, n = (e = e || {}).idAttribute || "OBJECTID";
                    r = e.sr ? {
                        wkid: e.sr
                    } : t && t.crs && "urn:ogc:def:crs:OGC:1.3:CRS84" != t.crs.properties.name ? null : {
                        wkid: 4326
                    };
                    var o, s = {};
                    switch(t.type){
                        case "Point":
                            s.x = t.coordinates[0], s.y = t.coordinates[1], t.coordinates[2] && (s.z = t.coordinates[2]), t.coordinates[3] && (s.m = t.coordinates[3]), s.spatialReference = r;
                            break;
                        case "MultiPoint":
                            s.points = t.coordinates.slice(0), s.spatialReference = r;
                            break;
                        case "LineString":
                            s.paths = [
                                t.coordinates.slice(0)
                            ], s.spatialReference = r;
                            break;
                        case "MultiLineString":
                            s.paths = t.coordinates.slice(0), s.spatialReference = r;
                            break;
                        case "Polygon":
                            s.rings = a(t.coordinates.slice(0)), s.spatialReference = r;
                            break;
                        case "MultiPolygon":
                            s.rings = function(t) {
                                for(var e = [], r = 0; r < t.length; r++)for(var n = a(t[r]), i = n.length - 1; i >= 0; i--){
                                    var o = n[i].slice(0);
                                    e.push(o);
                                }
                                return e;
                            }(t.coordinates.slice(0)), s.spatialReference = r;
                            break;
                        case "Feature":
                            t.geometry && (s.geometry = l(t.geometry, e)), s.attributes = t.properties ? i(t.properties) : {}, t.id && (s.attributes[n] = t.id);
                            break;
                        case "FeatureCollection":
                            for(s = [], o = 0; o < t.features.length; o++)s.push(l(t.features[o], e));
                            break;
                        case "GeometryCollection":
                            for(s = [], o = 0; o < t.geometries.length; o++)s.push(l(t.geometries[o], e));
                    }
                    return s;
                }
                return e.parse = u, e.convert = l, e.toGeoJSON = u, e.fromGeoJSON = l, e.parseCompressedGeometry = function(e) {
                    return new t.LineString(r(e));
                }, e;
            });
        },
        function(t, e, r) {
            var n = r(214), i = r(215), o = r(216), a = r(217), s = r(218), u = r(219), l = r(220);
            l.alea = n, l.xor128 = i, l.xorwow = o, l.xorshift7 = a, l.xor4096 = s, l.tychei = u, t.exports = l;
        },
        function(t, e, r) {
            "use strict";
            function n([t, e, r, n]) {
                return (r - t) * (n - e);
            }
            t.exports = n, t.exports.default = n;
        },
        function(t, e, r) {
            "use strict";
            var n;
            const i = r(115), o = r(116), a = r(117), s = r(118), u = r(232), l = r(123), c = r(124), f = r(125), h = r(119), p = r(126), d = r(75), m = r(127), y = r(128), g = r(238), v = r(121), b = r(120), x = r(122), w = r(129), _ = {
                calculate: u,
                calculateCore: l,
                carveHoles: b,
                categorizeIntersection: i,
                clamp: o,
                cluster: a,
                clusterLineSegments: s,
                couple: c,
                eachPair: f,
                eachPolygon: h,
                mergeRanges: p,
                mergeConsecutiveRanges: d,
                partition: m,
                prepareSnap: y,
                rangeContains: g,
                rangeCut: v,
                rangeOverlap: x,
                rangeSort: r(76),
                roundDown: w
            };
            void 0 === (n = (()=>_).call(e, r, e, t)) || (t.exports = n), t.exports = _, "object" == typeof self && (self.dufour_peyton_intersection = _), "object" == typeof window && (window.dufour_peyton_intersection = _);
        },
        function(t, e, r) {
            "use strict";
            const n = r(92), i = r(64);
            function o(t) {
                if (0 === t.length) return [];
                if (1 === t.length) return [
                    t[0]
                ];
                let e = [
                    t[0]
                ];
                for(let r = 1; r < t.length; r++){
                    const o = t[r], a = e.filter((t)=>n(o, t)), s = i(a.concat([
                        o
                    ])), u = e.filter((t)=>!a.includes(t));
                    e = [
                        s
                    ].concat(u);
                }
                return e;
            }
            t.exports = o, t.exports.default = o;
        },
        function(t, e, r) {
            var n;
            const { getOrCreateIterator: i } = r(268), { add: o, compare: a, divide: s, mean: u, multiply: l, pow: c, round: f, sort: h, subtract: p, sum: d } = r(269), m = r(288), y = (t)=>"number" == typeof t && t == t;
            function g(t, { async: e = !1, chunked: r = !1, noData: n, filter: d, map: g, calcCount: v = !0, calcFrequency: b = !0, calcHistogram: x = !0, calcInvalid: w = !0, calcMax: _ = !0, calcMean: A = !0, calcMedian: E = !0, calcMin: S = !0, calcMode: M = !0, calcModes: k = !0, calcProduct: N = !0, calcRange: C = !0, calcStd: D = !0, calcSum: O = !0, calcValid: T = !0, calcVariance: F = !0, calcUniques: P = !0, precise: I = !1, precise_max_decimal_digits: B = 100, stats: j, timed: R = !1 } = {
                debugLevel: 0
            }) {
                const L = R ? performance.now() : 0;
                if (j && (j.forEach((t)=>{
                    [
                        "count",
                        "frequency",
                        "histogram",
                        "invalid",
                        "max",
                        "mean",
                        "median",
                        "min",
                        "mode",
                        "modes",
                        "product",
                        "range",
                        "sum",
                        "std",
                        "valid",
                        "variance",
                        "uniques"
                    ].includes(t) || console.warn(`[calc-stats] skipping unknown stat "${t}"`);
                }), v = j.includes("count"), b = j.includes("frequency"), x = j.includes("histogram"), w = j.includes("invalid"), _ = j.includes("max"), A = j.includes("mean"), E = j.includes("median"), S = j.includes("min"), M = j.includes("mode"), k = j.includes("modes"), N = j.includes("product"), C = j.includes("range"), D = j.includes("std"), O = j.includes("sum"), T = j.includes("valid"), F = j.includes("variance"), P = j.includes("uniques")), "string" == typeof g) {
                    const t = g;
                    g = (e)=>e[t];
                }
                const q = i(t);
                let U, z, G, H = b || x || E || M || k || F || D || P, W = v || b || A || E || N || T || F || D || "function" == typeof d, $ = v || w || "function" == typeof d, V = O || A || F || D, Z = S || C, Y = _ || C, K = N, X = 0, J = 0, Q = 0, tt = I ? "0" : 0;
                const et = {};
                let rt;
                const nt = (t)=>{
                    W && (X = 1), Z && (U = t), Y && (z = t), K && (G = t), V && (tt = t), H && (et[t] = {
                        n: t,
                        ct: 1
                    }), rt = it;
                }, it = (t)=>{
                    W && X++, Z && t < U && (U = t), Y && t > z && (z = t), K && (G *= t), V && (tt += t), H && (t in et ? et[t].ct++ : et[t] = {
                        n: t,
                        ct: 1
                    });
                };
                let ot;
                rt = I ? (t)=>{
                    t = t.toString(), W && X++, !Z || void 0 !== U && "<" !== a(t, U) || (U = t), !Y || void 0 !== z && ">" !== a(t, z) || (z = t), K && (G = 1 === X ? t : l(G, t, {
                        max_decimal_digits: B
                    })), V && (tt = o(tt, t)), H && (t in et ? et[t].ct++ : et[t] = {
                        n: t.toString(),
                        ct: 1
                    });
                } : nt, ot = "number" == typeof n && "function" == typeof d ? (t)=>{
                    Q++, y(t) && t !== n && !0 === d({
                        valid: X,
                        index: Q,
                        value: t
                    }) ? rt(t) : $ && J++;
                } : "number" == typeof n ? (t)=>{
                    y(t) && t !== n ? rt(t) : $ && J++;
                } : Array.isArray(n) && n.length > 0 && "function" == typeof d ? (t)=>{
                    Q++, y(t) && !n.includes(t) && !0 === d({
                        valid: X,
                        index: Q,
                        value: t
                    }) ? rt(t) : $ && J++;
                } : Array.isArray(n) && n.length > 0 ? (t)=>{
                    y(t) && !n.includes(t) ? rt(t) : $ && J++;
                } : "function" == typeof d ? (t)=>{
                    Q++, y(t) && !0 === d({
                        valid: X,
                        index: Q,
                        value: t
                    }) ? rt(t) : $ && J++;
                } : (t)=>{
                    y(t) ? rt(t) : $ && J++;
                };
                const at = ()=>{
                    const t = {};
                    if (v && (t.count = I ? o(J.toString(), X.toString()) : J + X), T && (t.valid = I ? X.toString() : X), w && (t.invalid = I ? J.toString() : J), E && (t.median = m.calculate({
                        counts: et,
                        precise: I,
                        total: X
                    })), S && (t.min = U), _ && (t.max = z), N && (t.product = G), O && (t.sum = tt), C && (t.range = I ? p(z.toString(), U.toString()) : z - U), A || F || D) {
                        const e = I ? s(tt, X.toString(), {
                            max_decimal_digits: B
                        }) : tt / X;
                        if (A && (t.mean = e), F || D) {
                            let r = (({ count: t, histogram: e, mean_value: r, precise: n = !1 })=>{
                                if (n) {
                                    r = r.toString();
                                    const n = Object.values(e).reduce((t, { n: e, ct: n })=>{
                                        const i = p(e.toString(), r);
                                        return o(t, l(n.toString(), c(i, "2")));
                                    }, "0");
                                    return s(n, t.toString());
                                }
                                return Object.values(e).reduce((t, { n: e, ct: n })=>t + n * Math.pow(e - r, 2), 0) / t;
                            })({
                                count: X,
                                histogram: et,
                                max_decimal_digits: "number" == typeof B && B < 20 ? 20 : B,
                                mean_value: e,
                                precise: I
                            });
                            F && (t.variance = I && "number" == typeof B ? f(r, {
                                digits: B
                            }) : r), D && (t.std = I ? Math.sqrt(Number(r)).toString() : Math.sqrt(r));
                        }
                    }
                    if (x && (I && Object.values(et).forEach((t)=>{
                        t.ct = t.ct.toString();
                    }), t.histogram = et), b) {
                        const e = {};
                        if (I) {
                            const t = X.toString();
                            for(let r in et){
                                const n = et[r];
                                e[r] = {
                                    n: n.n.toString(),
                                    freq: s(n.ct, t, {
                                        max_decimal_digits: B
                                    })
                                };
                            }
                        } else for(let t in et){
                            const r = et[t];
                            e[t] = {
                                n: r.n,
                                freq: r.ct / X
                            };
                        }
                        t.frequency = e;
                    }
                    if (M || k) {
                        let e = 0, r = [];
                        for(let t in et){
                            const { n: n, ct: i } = et[t];
                            i === e ? r.push(I ? n.toString() : n) : i > e && (e = i, r = [
                                I ? n.toString() : n
                            ]);
                        }
                        k && (t.modes = r), M && (t.mode = I ? u(r) : r.reduce((t, e)=>t + e, 0) / r.length);
                    }
                    if (P && (t.uniques = I ? h(Object.keys(et)) : Object.values(et).map(({ n: t })=>t).sort((t, e)=>t - e)), R) {
                        const t = Math.round(performance.now() - L);
                        t > 2e3 ? console.log("[calc-stats] took " + Math.round(t / 1e3).toLocaleString() + " seconds") : console.log("[calc-stats] took " + t.toLocaleString() + " milliseconds");
                    }
                    return t;
                };
                if (r) {
                    if (e) return (async ()=>{
                        for await (let t of q)for (let e of t)g && (e = g(e)), ot(e);
                        return at();
                    })();
                    if (Array.isArray(t) && t[0].length) for(let e = 0; e < t.length; e++){
                        const r = t[e];
                        for(let t = 0; t < r.length; t++){
                            let e = r[t];
                            g && (e = g(e)), ot(e);
                        }
                    }
                    else for (let t of q)for (let e of t)g && (e = g(e)), ot(e);
                    return at();
                }
                if (e) return (async ()=>{
                    for await (let t of q)g && (t = g(t)), ot(t);
                    return at();
                })();
                for (let t of q)g && (t = g(t)), ot(t);
                return at();
            }
            void 0 === (n = (function() {
                return g;
            }).call(e, r, e, t)) || (t.exports = n), t.exports = g, t.exports.default = g, t.exports.calcStats = g, "object" == typeof self && (self.calcStats = g), "object" == typeof window && (window.calcStats = g);
        },
        function(t, e) {
            t.exports = function(t, e) {
                (null == e || e > t.length) && (e = t.length);
                for(var r = 0, n = Array(e); r < e; r++)n[r] = t[r];
                return n;
            }, t.exports.__esModule = !0, t.exports.default = t.exports;
        },
        function(t, e, r) {
            var n = r(109);
            t.exports = function(t, e) {
                if (t) {
                    if ("string" == typeof t) return n(t, e);
                    var r = ({}).toString.call(t).slice(8, -1);
                    return "Object" === r && t.constructor && (r = t.constructor.name), "Map" === r || "Set" === r ? Array.from(t) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? n(t, e) : void 0;
                }
            }, t.exports.__esModule = !0, t.exports.default = t.exports;
        },
        function(t, e, r) {
            "use strict";
            t.exports = SyntaxError;
        },
        function(t, e, r) {
            "use strict";
            var n = r(36)("%Object.getOwnPropertyDescriptor%", !0);
            if (n) try {
                n([], "length");
            } catch (t) {
                n = null;
            }
            t.exports = n;
        },
        function(t, e, r) {
            "use strict";
            var n = r(74), i = Object.prototype.hasOwnProperty, o = Array.isArray, a = function() {
                for(var t = [], e = 0; e < 256; ++e)t.push("%" + ((e < 16 ? "0" : "") + e.toString(16)).toUpperCase());
                return t;
            }(), s = function(t, e) {
                for(var r = e && e.plainObjects ? Object.create(null) : {}, n = 0; n < t.length; ++n)void 0 !== t[n] && (r[n] = t[n]);
                return r;
            };
            t.exports = {
                arrayToObject: s,
                assign: function(t, e) {
                    return Object.keys(e).reduce(function(t, r) {
                        return t[r] = e[r], t;
                    }, t);
                },
                combine: function(t, e) {
                    return [].concat(t, e);
                },
                compact: function(t) {
                    for(var e = [
                        {
                            obj: {
                                o: t
                            },
                            prop: "o"
                        }
                    ], r = [], n = 0; n < e.length; ++n)for(var i = e[n], a = i.obj[i.prop], s = Object.keys(a), u = 0; u < s.length; ++u){
                        var l = s[u], c = a[l];
                        "object" == typeof c && null !== c && -1 === r.indexOf(c) && (e.push({
                            obj: a,
                            prop: l
                        }), r.push(c));
                    }
                    return function(t) {
                        for(; t.length > 1;){
                            var e = t.pop(), r = e.obj[e.prop];
                            if (o(r)) {
                                for(var n = [], i = 0; i < r.length; ++i)void 0 !== r[i] && n.push(r[i]);
                                e.obj[e.prop] = n;
                            }
                        }
                    }(e), t;
                },
                decode: function(t, e, r) {
                    var n = t.replace(/\+/g, " ");
                    if ("iso-8859-1" === r) return n.replace(/%[0-9a-f]{2}/gi, unescape);
                    try {
                        return decodeURIComponent(n);
                    } catch (t) {
                        return n;
                    }
                },
                encode: function(t, e, r, i, o) {
                    if (0 === t.length) return t;
                    var s = t;
                    if ("symbol" == typeof t ? s = Symbol.prototype.toString.call(t) : "string" != typeof t && (s = String(t)), "iso-8859-1" === r) return escape(s).replace(/%u[0-9a-f]{4}/gi, function(t) {
                        return "%26%23" + parseInt(t.slice(2), 16) + "%3B";
                    });
                    for(var u = "", l = 0; l < s.length; l += 1024){
                        for(var c = s.length >= 1024 ? s.slice(l, l + 1024) : s, f = [], h = 0; h < c.length; ++h){
                            var p = c.charCodeAt(h);
                            45 === p || 46 === p || 95 === p || 126 === p || p >= 48 && p <= 57 || p >= 65 && p <= 90 || p >= 97 && p <= 122 || o === n.RFC1738 && (40 === p || 41 === p) ? f[f.length] = c.charAt(h) : p < 128 ? f[f.length] = a[p] : p < 2048 ? f[f.length] = a[192 | p >> 6] + a[128 | 63 & p] : p < 55296 || p >= 57344 ? f[f.length] = a[224 | p >> 12] + a[128 | p >> 6 & 63] + a[128 | 63 & p] : (h += 1, p = 65536 + ((1023 & p) << 10 | 1023 & c.charCodeAt(h)), f[f.length] = a[240 | p >> 18] + a[128 | p >> 12 & 63] + a[128 | p >> 6 & 63] + a[128 | 63 & p]);
                        }
                        u += f.join("");
                    }
                    return u;
                },
                isBuffer: function(t) {
                    return !(!t || "object" != typeof t) && !!(t.constructor && t.constructor.isBuffer && t.constructor.isBuffer(t));
                },
                isRegExp: function(t) {
                    return "[object RegExp]" === Object.prototype.toString.call(t);
                },
                maybeMap: function(t, e) {
                    if (o(t)) {
                        for(var r = [], n = 0; n < t.length; n += 1)r.push(e(t[n]));
                        return r;
                    }
                    return e(t);
                },
                merge: function t(e, r, n) {
                    if (!r) return e;
                    if ("object" != typeof r) {
                        if (o(e)) e.push(r);
                        else {
                            if (!e || "object" != typeof e) return [
                                e,
                                r
                            ];
                            (n && (n.plainObjects || n.allowPrototypes) || !i.call(Object.prototype, r)) && (e[r] = !0);
                        }
                        return e;
                    }
                    if (!e || "object" != typeof e) return [
                        e
                    ].concat(r);
                    var a = e;
                    return o(e) && !o(r) && (a = s(e, n)), o(e) && o(r) ? (r.forEach(function(r, o) {
                        if (i.call(e, o)) {
                            var a = e[o];
                            a && "object" == typeof a && r && "object" == typeof r ? e[o] = t(a, r, n) : e.push(r);
                        } else e[o] = r;
                    }), e) : Object.keys(r).reduce(function(e, o) {
                        var a = r[o];
                        return i.call(e, o) ? e[o] = t(e[o], a, n) : e[o] = a, e;
                    }, a);
                }
            };
        },
        function(t, e, r) {
            var n;
            let i = r(299);
            const o = r(223);
            "object" != typeof i && "function" != typeof i || "function" == typeof i.defs || "function" != typeof i.default || "function" != typeof i.default.defs || (i = i.default), i.defs(o), void 0 === (n = (function() {
                return i;
            }).call(e, r, e, t)) || (t.exports = n), t.exports = i, t.exports.default = i;
        },
        function(t, e, r) {
            "use strict";
            t.exports = function(t) {
                try {
                    let e, r, n;
                    const i = t.length, o = t[0];
                    if (1 === i) e = !0, r = o.xmin, n = o.xmax;
                    else {
                        const a = t[i - 1];
                        e = o.direction === a.direction, r = Math.min(o.xmin, a.xmin), n = Math.max(o.xmax, a.xmax);
                    }
                    if (void 0 === r || void 0 === n || void 0 === e || isNaN(r) || isNaN(n)) throw Error("categorizeIntersection failed with xmin", r, "and xmax", n);
                    return {
                        xmin: r,
                        xmax: n,
                        through: e
                    };
                } catch (e) {
                    throw console.error("[categorizeIntersection] segments:", t), console.error("[categorizeIntersection]", e), e;
                }
            };
        },
        function(t, e, r) {
            "use strict";
            t.exports = function(t, e, r) {
                return t < e ? e : t > r ? r : t;
            };
        },
        function(t, e, r) {
            "use strict";
            t.exports = function(t, e) {
                try {
                    const r = t.length, n = [];
                    let i = [];
                    for(let o = 0; o < r; o++){
                        const r = t[o];
                        i.push(r), e(r) && (n.push(i), i = []);
                    }
                    return i.length > 0 && n.push(i), n;
                } catch (t) {
                    console.error("[cluster]:", t);
                }
            };
        },
        function(t, e, r) {
            "use strict";
            const n = r(117);
            t.exports = function(t, e, r = !1) {
                try {
                    const e = n(t, (t)=>t.endsOffLine);
                    if (e.length >= 2) {
                        const t = e[0], r = t[0], n = e[e.length - 1], i = n[n.length - 1];
                        i.last_edge_in_ring && 0 === r.index && i.endsOnLine && (e[0] = e.pop().concat(t));
                    }
                    return e;
                } catch (t) {
                    console.error("[clusterLineSegments]", t);
                }
            };
        },
        function(t, e, r) {
            "use strict";
            const n = r(71);
            t.exports = function t(e, r) {
                if ("FeatureCollection" === e.type) e.features.forEach((e)=>t(e, r));
                else if ("GeometryCollection" === e.type) e.geometries.forEach((e)=>t(e, r));
                else if ("Feature" === e.type) t(e.geometry, r);
                else if ("Polygon" === e.type) t(e.coordinates, r);
                else if ("MultiPolygon" === e.type) e.coordinates.forEach((t)=>{
                    r(t);
                });
                else if (Array.isArray(e)) {
                    const t = n(e);
                    4 === t ? e.forEach((t)=>{
                        r(t);
                    }) : 3 === t ? r(e) : 2 === t && r([
                        e
                    ]);
                }
            };
        },
        function(t, e, r) {
            const n = r(121);
            t.exports = function(t, e) {
                let r = t;
                return e.forEach((t)=>{
                    r = r.map((e)=>n(e, t)).flat();
                }), r;
            };
        },
        function(t, e, r) {
            const n = r(122);
            t.exports = function(t, e) {
                if (!Array.isArray(t)) throw new Error("[cut] range is not an array: " + JSON.stringify(t));
                if (void 0 === e) return [
                    t
                ];
                if (!Array.isArray(e)) throw new Error("[cut] hole is not an array:" + JSON.stringify(e));
                if (!n(t, e)) return [
                    t
                ];
                const r = [];
                return t[0] < e[0] && r.push([
                    t[0],
                    e[0] - 1
                ]), t[1] > e[1] && r.push([
                    e[1] + 1,
                    t[1]
                ]), r;
            };
        },
        function(t, e) {
            t.exports = function(t, e) {
                if (!Array.isArray(t)) throw new Error("[overlaps] a is not an array");
                if (!Array.isArray(e)) throw new Error("[overlaps] b is not an array");
                return t[0] <= e[1] && e[0] <= t[1];
            };
        },
        function(t, e, r) {
            "use strict";
            const n = r(115), i = r(116), o = r(124), a = r(118), s = r(125), u = r(126), l = r(127), c = r(128);
            t.exports = function({ debug_level: t = 0, raster_bbox: e, raster_height: r, raster_width: f, pixel_height: h, pixel_width: p, ring: d, per_pixel: m, per_row_segment: y }) {
                const [g, v, b, x] = e, w = [];
                for(let t = 0; t < r; t++)w.push([]);
                s(d, (t, n)=>{
                    const [o, a] = t, [s, u] = o, [l, c] = a, f = Math.sign(c - u), p = u === c, m = s === l, y = (c - u) / (l - s), g = u, v = Math.min(u, c), b = Math.max(u, c);
                    let _, A, E, S;
                    if (s < l ? ([_, A] = o, [S, E] = a) : ([_, A] = a, [S, E] = o), void 0 === _) throw Error("startLng is " + _);
                    const M = Math.round((e[3] - .5 * h - A) / h), k = Math.round((e[3] - .5 * h - E) / h);
                    let N, C;
                    M < k ? (N = M, C = k) : (N = k, C = M), N = i(N, 0, r - 1), C = i(C, 0, r - 1);
                    for(let e = N; e < C + 1; e++){
                        const r = x - h * e - h / 2, i = u === r, o = c === r, a = !o;
                        let A, E;
                        if (p) {
                            if (g !== r) continue;
                            A = _, E = S;
                        } else if (m) r >= v && r <= b && (A = _, E = S);
                        else if (i) A = E = s;
                        else if (o) A = E = l;
                        else try {
                            A = E = s + (r - u) / y;
                        } catch (t) {
                            throw t;
                        }
                        void 0 !== A && void 0 !== E && (p || A >= _ && E <= S && r <= b && r >= v) && w[e].push({
                            direction: f,
                            index: n,
                            edge: t,
                            last_edge_in_ring: n === d.length - 2,
                            endsOnLine: o,
                            endsOffLine: a,
                            horizontal: p,
                            startsOnLine: i,
                            vertical: m,
                            xmin: A,
                            xmax: E,
                            imageLineY: r
                        });
                    }
                });
                const _ = p / 2, A = c(g, p);
                t >= 1 && console.log("[dufour-peyton-intersection] intersectionsByRow:", w), w.forEach((e, r)=>{
                    if (e.length > 0) {
                        const i = a(e).map(n), [s, c] = l(i, (t)=>t.through);
                        if (s.length % 2 == 1) throw t >= 1 && console.error("[dufour-peyton-intersection] throughs:", JSON.stringify(s)), Error("throughs.length for " + r + " is odd with " + s.length);
                        let h = c.map((t)=>[
                                t.xmin,
                                t.xmax
                            ]);
                        s.sort((t, e)=>t.xmin - e.xmin);
                        const p = o(s).map((t)=>{
                            const [e, r] = t;
                            return [
                                e.xmin,
                                r.xmax
                            ];
                        });
                        h = h.concat(p), h = u(h), h.forEach((t)=>{
                            const [e, n] = t;
                            if (n - e < _) return;
                            const [i, o] = A(t);
                            if (i === o) return;
                            if (i > f) return;
                            if (o <= 0) return;
                            const a = Math.max(i, 0), s = Math.min(o - 1, f - 1);
                            if (y && y({
                                row: r,
                                columns: [
                                    a,
                                    s
                                ]
                            }), m) for(let t = a; t <= s; t++)m({
                                row: r,
                                column: t
                            });
                        });
                    }
                });
            };
        },
        function(t, e, r) {
            "use strict";
            t.exports = function(t) {
                const e = [], r = t.length;
                for(let n = 0; n < r; n += 2)e.push([
                    t[n],
                    t[n + 1]
                ]);
                return e;
            };
        },
        function(t, e, r) {
            "use strict";
            t.exports = function(t, e) {
                for(let r = 1; r < t.length; r++)e([
                    t[r - 1],
                    t[r]
                ], r - 1);
            };
        },
        function(t, e) {
            t.exports = function(t) {
                const e = t.length;
                if (e > 0) {
                    const r = t[0];
                    let n = r[1];
                    const i = [
                        r
                    ];
                    for(let r = 1; r < e; r++){
                        const e = t[r], [o, a] = e;
                        o <= n ? i[i.length - 1][1] = a : i.push(e), n = a;
                    }
                    return i;
                }
            };
        },
        function(t, e, r) {
            "use strict";
            t.exports = function(t, e) {
                const r = [], n = [], i = t.length;
                for(let o = 0; o < i; o++){
                    const i = t[o];
                    e(i) ? r.push(i) : n.push(i);
                }
                return [
                    r,
                    n
                ];
            };
        },
        function(t, e, r) {
            "use strict";
            const n = r(129);
            t.exports = function(t, e) {
                return ([r, i])=>(-0 === (r = n((r - t) / e)) && (r = 0), -0 === (i = Math.round((i - t) / e)) && (i = 0), [
                        r,
                        i
                    ]);
            };
        },
        function(t, e, r) {
            "use strict";
            t.exports = function(t) {
                return -1 * Math.round(-1 * t);
            };
        },
        function(t, e, r) {
            "use strict";
            function n(t) {
                "+" === t[0] && (t = t.substring(1));
                const e = "-" === t[0] ? "-" : "";
                "-" === e && (t = t.substring(1));
                const r = t.indexOf("e");
                if (-1 === r) return e + t;
                let n = t.indexOf(".");
                -1 === n && (n = r);
                const i = Number(t.substring(r + 1)), o = t.substring(0, r).replace(".", ""), a = n + i, s = o.length;
                if (a >= s) {
                    const t = a - s;
                    let r = o;
                    for(let e = 0; e < t; e++)r += "0";
                    return e + r;
                }
                if (a < 0) {
                    let t = "0.";
                    for(let e = 0; e > a; e--)t += "0";
                    return t += o, e + t;
                }
                return e + o.substring(0, a) + "." + o.substring(a);
            }
            t.exports = n, t.exports.default = n;
        },
        function(t, e, r) {
            "use strict";
            t.exports = {
                MAX_SAFE_INTEGER: 9007199254740991
            };
        },
        function(t, e, r) {
            "use strict";
            const n = r(78), i = r(38), o = r(133), a = r(28), s = r(41), u = r(81);
            function l(t, { max_decimal_digits: e, infinity_times_zero: r = "NaN" } = {}) {
                const l = t.some((t)=>i(t)), c = t.some((t)=>a(t));
                if (l && c) return r;
                if (l) return t.filter((t)=>"-" === u(t)).length % 2 == 0 ? "Infinity" : "-Infinity";
                if (c) return "0";
                const f = o(t.filter((t)=>n(t)).length.toString());
                let h = s(t.map((t)=>t.replace(/i$/, "")), {
                    max_decimal_digits: e
                });
                return f && (h += "i"), h;
            }
            t.exports = l, t.exports.default = l;
        },
        function(t, e, r) {
            const n = r(3), i = r(40);
            function o(t) {
                if (t = n(t), !i(t)) throw new Error("can't call is_odd on decimal");
                return [
                    "1",
                    "3",
                    "5",
                    "7",
                    "9"
                ].includes(t.charAt(t.length - 1));
            }
            t.exports = o, t.exports.default = o;
        },
        function(t, e, r) {
            "use strict";
            const n = r(3);
            function i(t) {
                return "-" === (t = n(t))[0];
            }
            t.exports = i, t.exports.default = i;
        },
        function(t, e, r) {
            var n;
            const i = r(243), o = r(244);
            function a(t) {
                const e = o(t);
                return {
                    forward: function(e) {
                        return i(t, e);
                    },
                    inverse: function(t, { floor: r = !1, round: n = !1 } = {
                        floor: !1,
                        round: !1
                    }) {
                        let o = i(e, t);
                        return n && (o = o.map((t)=>Math.round(t))), r && (o = o.map((t)=>Math.floor(t))), o;
                    }
                };
            }
            void 0 === (n = (function() {
                return a;
            }).call(e, r, e, t)) || (t.exports = n), t.exports = a, t.exports.default = a;
        },
        function(t, e, r) {
            var n;
            const i = r(15), o = r(247), a = r(140), s = r(260), u = r(143), l = (r(85), r(262)), c = r(263);
            function f(t) {
                t = t.map((t)=>t.toString());
                const [e, r, n, f, h, p] = t, d = c(t), [m, y, g, v, b, x] = d, w = ([t, i])=>l([
                        e,
                        a(r, t.toString()),
                        a(n, i.toString())
                    ]), _ = ([t, e])=>l([
                        f,
                        a(h, t.toString()),
                        a(p, e.toString())
                    ]);
                return {
                    forwardX: w,
                    forwardY: _,
                    forward: function(t) {
                        return [
                            w(t),
                            _(t)
                        ];
                    },
                    inverse: function([t, e], { digits: r = 100, floor: n = !1 } = {}) {
                        t = t.toString(), e = e.toString(), n && (r = 1);
                        const c = {
                            max_decimal_digits: r + 5
                        }, f = l([
                            o(...m, c),
                            o(a(y[0], t), y[1], c),
                            o(a(g[0], e), g[1], c)
                        ]), h = l([
                            o(...v, c),
                            o(a(b[0], t), b[1], c),
                            o(a(x[0], e), x[1], c)
                        ]);
                        return n ? [
                            i(s(f)),
                            i(s(h))
                        ] : [
                            i(u(f, {
                                digits: r
                            })),
                            i(u(h, {
                                digits: r
                            }))
                        ];
                    }
                };
            }
            void 0 === (n = (function() {
                return f;
            }).call(e, r, e, t)) || (t.exports = n), t.exports = f, t.exports.default = f;
        },
        function(t, e, r) {
            "use strict";
            const { MAX_SAFE_INTEGER_LENGTH: n } = r(84);
            function i(t, e) {
                const r = t.length, i = e.length, o = t.indexOf("."), a = e.indexOf("."), s = -1 === o ? r : o, u = -1 === a ? i : a;
                if (-1 === o && -1 === a && r < n && i < n) return (Number(t) - Number(e)).toFixed();
                const l = s - u;
                let c = Math.max(s, u), f = Math.max(r - s - 1, i - u - 1), h = l < 0 ? -1 * l : 0, p = l <= 0 ? 0 : l, d = c + 1 + f - 1, m = "", y = 0, g = d;
                if (f > 0) {
                    for(; g > d - f;){
                        let r = t[g - h] || "0", n = e[g - p] || "0";
                        r -= y, y = 0;
                        let i = r - n;
                        if (i < 0) for(; i < 0;)y++, i += 10;
                        else y && y--;
                        "" === m && 0 === i || (m = i + m), g--;
                    }
                    "" !== m && (m = "." + m), g--;
                }
                if (c > 0) {
                    for(; g > 0;){
                        let r = t[g - h] || "0", n = e[g - p] || "0";
                        r -= y, y = 0;
                        let i = r - n;
                        if (i < 0) for(; i < 0;)y++, i += 10;
                        else y && y--;
                        m = i + m, g--;
                    }
                    const r = t[0 - h] || "0", n = e[0 - p] || "0";
                    let i = Number(r) - (y > 0 ? 1 : 0) - Number(n);
                    0 !== i && (m = i + m), m = m.replace(/^0+/, "");
                }
                return "." === m[0] && (m = "0" + m), m;
            }
            t.exports = i, t.exports.default = i;
        },
        function(t, e, r) {
            "use strict";
            const n = r(15), i = r(60), o = r(83), a = r(137);
            function s(t, e) {
                t = n(t), e = n(e);
                const r = "-" !== t[0], s = "-" !== e[0];
                if (r) {
                    if (s) {
                        const r = i(t, e);
                        return ">" === r ? a(t, e) : "<" === r ? "-" + a(e, t) : "0";
                    }
                    return o(t, e.substring(1));
                }
                if (s) return "-" + o(t.substring(1), e);
                {
                    t = t.substring(1), e = e.substring(1);
                    const r = i(t, e);
                    return ">" === r ? "-" + a(t, e) : "<" === r ? a(e, t) : "0";
                }
            }
            t.exports = s, t.exports.default = s;
        },
        function(t, e, r) {
            "use strict";
            const n = r(82), i = r(250), o = [
                "5",
                "6",
                "7",
                "8",
                "9"
            ];
            function a(t) {
                if (t.match(/\.9+$/)) return n(i(t), "1");
                "+" === t[0] && (t = t.substring(1));
                const e = t.length;
                let r = "";
                const a = t[t.length - 1];
                if (o.includes(a)) {
                    let n;
                    for(n = e - 2; n >= 0; n--){
                        const e = t[n];
                        if ("." === e || "-" === e) continue;
                        const i = Number(e) + 1;
                        if (10 !== i) {
                            r = i + r;
                            break;
                        }
                        r = "0" + r;
                    }
                    n > 0 && (r = t.substring(0, n) + r);
                } else r = t.substring(0, e - 1);
                return "." === r[r.length - 1] && (r = r.substring(0, r.length - 1)), r.indexOf(".") > -1 && (r = r.replace(/0+$/, "")), r;
            }
            t.exports = a, t.exports.default = a;
        },
        function(t, e, r) {
            "use strict";
            const n = r(251);
            function i() {
                const t = Array.from(arguments), e = "object" == typeof t[t.length - 1] ? t[t.length - 1] : void 0, r = Array.isArray(t[0]) ? t[0] : e ? t.slice(0, t.length - 1) : t;
                return n(r, e);
            }
            t.exports = i, t.exports.default = i;
        },
        function(t, e, r) {
            "use strict";
            function n(t) {
                return t.includes("i");
            }
            t.exports = n, t.exports.default = n;
        },
        function(t, e, r) {
            "use strict";
            function n(t) {
                return /^[-+]?0(\.0+)?(e[\.\d]+)?$/.test(t);
            }
            t.exports = n, t.exports.default = n;
        },
        function(t, e, r) {
            "use strict";
            const n = r(141), i = r(257);
            function o(t, { digits: e = 0 } = {}) {
                return n(t) ? i(t.substring(0, t.length - 1), {
                    digits: e
                }) + "i" : i(t, {
                    digits: e
                });
            }
            t.exports = o, t.exports.default = o;
        },
        function(t, e, r) {
            "use strict";
            const n = r(21), i = r(3), o = r(26), a = r(42);
            function s(t) {
                if (-1 === (t = i(t)).indexOf(".")) return t;
                const e = a(t);
                return t = n(t).split(".")[0], "+" === e ? t : "-" === e ? "0" === t || "" === t ? "-1" : "-" + o(t, "1") : void 0;
            }
            t.exports = s, t.exports.default = s;
        },
        function(t, e, r) {
            "use strict";
            const n = r(3), i = r(37);
            function o(t) {
                "string" == typeof t && (t = Array.prototype.slice.call(arguments));
                let e = n(t[0]);
                const r = t.length;
                for(let n = 1; n < r; n++){
                    const r = t[n];
                    ">" === i(r, e) && (e = r);
                }
                return e;
            }
            t.exports = o, t.exports.default = o;
        },
        function(t, e, r) {
            "use strict";
            const n = r(88);
            function i(t) {
                return "0" === t ? "1" : n("1", t);
            }
            t.exports = i, t.exports.default = i;
        },
        function(t, e, r) {
            "use strict";
            const n = r(80);
            function i(t) {
                const e = n(t);
                return [
                    t.replace(/\./g, "").replace(/^0/, ""),
                    1 + "0".repeat(e)
                ];
            }
            t.exports = i, t.exports.default = i;
        },
        function(t, e, r) {
            "use strict";
            const n = r(12), i = r(274), o = r(275);
            function a(t, { max_decimal_digits: e = 100, fraction: r = !1 } = {}) {
                if (i(t)) {
                    const [i, a] = o(t);
                    return r ? a + "/" + i : n(a, i, {
                        max_decimal_digits: e
                    });
                }
                return r ? "1/" + t : n("1", t, {
                    max_decimal_digits: e
                });
            }
            t.exports = a, t.exports.default = a;
        },
        function(t, e, r) {
            "use strict";
            const n = r(3), i = r(40);
            function o(t) {
                if (t = n(t), !i(t)) throw new Error("can't call is_even on decimal");
                return [
                    "0",
                    "2",
                    "4",
                    "6",
                    "8"
                ].includes(t.charAt(t.length - 1));
            }
            t.exports = o, t.exports.default = o;
        },
        function(t, e, r) {
            "use strict";
            const n = r(86), i = r(151), o = r(12);
            function a(t, e) {
                const r = i(t);
                return "0" === r ? "0" : n(o(r, e, {
                    max_decimal_digits: 1
                }));
            }
            t.exports = a, t.exports.default = a;
        },
        function(t, e, r) {
            "use strict";
            const n = r(21), i = r(3);
            function o(t) {
                const e = (t = n(i(t))).indexOf(".");
                return (-1 === e ? t.length : e).toString();
            }
            t.exports = o, t.exports.default = o;
        },
        function(t, e, r) {
            "use strict";
            const n = r(12), i = r(149), o = r(87), a = r(153);
            function s(t, e) {
                const r = a("2", o([
                    "1000",
                    e,
                    e
                ]));
                for(; t.endsWith("0") && e.endsWith("0");)t = t.substring(0, t.length - 1), e = e.substring(0, e.length - 1);
                for(; i(t) && i(e);)t = n(t, "2"), e = n(e, "2");
                let s = !0;
                for(; s;){
                    s = !1;
                    for(let i = 0; i < r.length; i++){
                        const o = r[i], a = o.length + 1, u = n(t, o, {
                            ellipsis: !0,
                            max_decimal_digits: a
                        });
                        if (-1 === u.indexOf(".")) {
                            const r = n(e, o, {
                                ellipsis: !0,
                                max_decimal_digits: a
                            });
                            if (-1 === r.indexOf(".")) {
                                t = u, e = r, s = !0;
                                break;
                            }
                        }
                    }
                }
                return [
                    t,
                    e
                ];
            }
            t.exports = s, t.exports.default = s;
        },
        function(t, e, r) {
            "use strict";
            const n = r(20), i = r(12), o = r(40), a = r(26);
            function s(t = "0", e = "100") {
                const r = [
                    "2",
                    "3",
                    "5",
                    "7",
                    "11"
                ].filter((r)=>"<" !== n(r, t) && ">" !== n(r, e));
                let s = "13";
                for(; ">" !== n(s, e);)/^\d+5/.test(s) || /^(\d)\1+/.test(s) || [
                    "9",
                    "7",
                    "3"
                ].every((t)=>!o(i(s, t))) && r.push(s), s = a(s, "2");
                return r;
            }
            t.exports = s, t.exports.default = s;
        },
        function(t, e, r) {
            "use strict";
            const n = r(19), i = r(12);
            function o({ max_decimal_digits: t = 100, steps: e = 100 } = {}) {
                let r = "1", o = "1";
                for(let a = 1; a < e; a++)o = i(o, a.toString(), {
                    max_decimal_digits: t
                }), r = n(r, o);
                return r;
            }
            t.exports = o, t.exports.default = o;
        },
        function(t, e, r) {
            "use strict";
            const n = r(3), i = r(156), o = r(157), a = r(28), s = r(154), u = r(61);
            function l(t, { max_decimal_digits: e = 100 } = {}) {
                const r = s({
                    max_decimal_digits: 2 * e
                });
                return i(t) ? "0" : o(t) ? "Infinity" : a(t) ? "1" : (t = n(t), u(r, t, {
                    max_decimal_digits: e
                }));
            }
            t.exports = l, t.exports.default = l;
        },
        function(t, e, r) {
            "use strict";
            function n(t) {
                return !!t.match(/^-inf(inity)?$/i);
            }
            t.exports = n, t.exports.default = n;
        },
        function(t, e, r) {
            "use strict";
            function n(t) {
                return !!t.match(/^\+?inf(inity)?$/i);
            }
            t.exports = n, t.exports.default = n;
        },
        function(t, e, r) {
            "use strict";
            const n = r(62);
            function i(t, e) {
                return n(t, "2", e);
            }
            t.exports = i, t.exports.default = i;
        },
        function(t, e, r) {
            "use strict";
            function n(t) {
                const e = t.indexOf(".");
                return -1 === e ? t : t.substring(0, e);
            }
            t.exports = n, t.exports.default = n;
        },
        function(t, e, r) {
            const n = r(161), i = r(292);
            function o(t, e, { precise: r = !1 } = {
                precise: !1
            }) {
                return r ? i(n(t.toString(), e.toString()), "2") : (t + e) / 2;
            }
            t.exports = o, t.exports.default = o;
        },
        function(t, e, r) {
            const n = r(63), i = r(43), o = r(162), a = r(163);
            function s(t, e) {
                t = i(t), e = i(e);
                const r = "-" !== t[0], s = "-" !== e[0];
                if (r && s) return o(t, e);
                if (!r && !s) return "-" + o(t.substring(1), e.substring(1));
                if (!r && s) switch(t = t.substring(1), n(t, e)){
                    case "=":
                        return "0";
                    case "<":
                        return a(e, t);
                    case ">":
                        return "-" + a(t, e);
                }
                else if (r && !s) switch(e = e.substring(1), n(t, e)){
                    case "=":
                        return "0";
                    case "<":
                        return "-" + a(e, t);
                    case ">":
                        return a(t, e);
                }
            }
            t.exports = s, t.exports.default = s;
        },
        function(t, e, r) {
            const { MAX_SAFE_INTEGER_LENGTH: n } = r(91);
            t.exports = function(t, e) {
                const r = t.length, i = e.length, o = t.indexOf("."), a = e.indexOf("."), s = -1 === o ? r : o, u = -1 === a ? i : a;
                if (-1 === o && -1 === a && r < n && i < n) return (Number(t) + Number(e)).toFixed();
                const l = s - u;
                let c = Math.max(s, u), f = Math.max(r - s - 1, i - u - 1), h = l < 0 ? -1 * l : 0, p = l <= 0 ? 0 : l, d = c + 1 + f - 1, m = "", y = 0, g = d;
                if (f > 0) {
                    for(; g > d - f;){
                        const r = t[g - h] || "0", n = e[g - p] || "0";
                        let i = Number(r) + Number(n) + y;
                        i >= 10 ? (i -= 10, y = 1) : y = 0, "" === m && 0 === i || (m = i + m), g--;
                    }
                    m && (m = "." + m), g--;
                }
                if (c > 0) for(; g >= 0;){
                    const r = t[g - h] || "0", n = e[g - p] || "0";
                    let i = Number(r) + Number(n) + y;
                    i >= 10 ? (i -= 10, y = 1) : y = 0, m = i + m, g--;
                }
                return 1 === y && (m = y + m), "." === m[0] && (m = "0" + m), m;
            };
        },
        function(t, e, r) {
            const { MAX_SAFE_INTEGER_LENGTH: n } = r(91);
            t.exports = function(t, e) {
                const r = t.length, i = e.length, o = t.indexOf("."), a = e.indexOf("."), s = -1 === o ? r : o, u = -1 === a ? i : a;
                if (-1 === o && -1 === a && r < n && i < n) return (Number(t) - Number(e)).toFixed();
                const l = s - u;
                let c = Math.max(s, u), f = Math.max(r - s - 1, i - u - 1), h = l < 0 ? -1 * l : 0, p = l <= 0 ? 0 : l, d = c + 1 + f - 1, m = "", y = 0, g = d;
                if (f > 0) {
                    for(; g > d - f;){
                        let r = t[g - h] || "0", n = e[g - p] || "0";
                        r -= y, y = 0;
                        let i = r - n;
                        if (i < 0) for(; i < 0;)y++, i += 10;
                        else y && y--;
                        "" === m && 0 === i || (m = i + m), g--;
                    }
                    "" !== m && (m = "." + m), g--;
                }
                if (c > 0) {
                    for(; g > 0;){
                        let r = t[g - h] || "0", n = e[g - p] || "0";
                        r -= y, y = 0;
                        let i = r - n;
                        if (i < 0) for(; i < 0;)y++, i += 10;
                        else y && y--;
                        m = i + m, g--;
                    }
                    const r = t[0 - h] || "0", n = e[0 - p] || "0";
                    let i = Number(r) - (y > 0 ? 1 : 0) - Number(n);
                    0 !== i && (m = i + m), m = m.replace(/^0+/, "");
                }
                return "." === m[0] && (m = "0" + m), m;
            };
        },
        function(t, e, r) {
            const n = r(43);
            function i(t) {
                return "-" === (t = n(t))[0] ? t.substring(1) : t;
            }
            t.exports = i, t.exports.default = i;
        },
        function(t, e) {
            const r = [
                "right -> down -> left -> up",
                "down -> left -> up -> right",
                "left -> up -> right -> down",
                "up -> right -> down -> left",
                "down -> right -> up -> left",
                "right -> up -> left -> down",
                "up -> left -> down -> right",
                "left -> down -> right -> up"
            ];
            function n(t, { debug: e = 0 } = {
                debug: 0
            }) {
                if (!Array.isArray(t)) return e && console.log("[bbox-fns/booleanRectangle] coords is not an array"), !1;
                if (1 === t.length && (t = t[0]), 1 === t.length && (t = t[0]), !t.every((t)=>Array.isArray(t) && t.every((t)=>"number" == typeof t))) return e && console.log("[bbox-fns/booleanRectangle] invalid points"), !1;
                if (JSON.stringify(t[0]) !== JSON.stringify(t[t.length - 1])) return e && console.log("[bbox-fns/booleanRectangle] first and last coordinates not equal"), !1;
                let n = [];
                for(let r = 1; r < t.length; r++){
                    const [i, o] = t[r - 1], [a, s] = t[r], u = i === a, l = o === s;
                    if (u === l) return e && console.log("[bbox-fns/booleanRectangle] invalid angle"), !1;
                    let c;
                    if (u ? c = s > o ? "up" : "down" : l && (c = a > i ? "right" : "left"), c !== n[n.length - 1]) {
                        if (4 === n.length) return e && console.log("[bbox-fns/booleanRectangle] more than 4 turns"), !1;
                        n.push(c);
                    }
                }
                return n = n.join(" -> "), e && console.log("[bbox-fns/booleanRectangle] order: " + n), -1 !== r.indexOf(n) || (e && console.log("[bbox-fns/booleanRectangle] invalid order"), !1);
            }
            t.exports = n, t.exports.default = n;
        },
        function(t, e, r) {
            const n = r(64);
            function i(t) {
                if (t.geometry && (t = t.geometry), t.coordinates && (t = t.coordinates), t.paths && (t = t.paths), t.points && (t = t.points), t.rings && (t = t.rings), Array.isArray(t.features)) return n(t.features.map(i));
                if (Array.isArray(t.geometries)) return n(t.geometries.map(i));
                if (Array.isArray(t) && Array.isArray(t[0]) && Array.isArray(t[0][0])) return n(t.map(i));
                if (Array.isArray(t) && Array.isArray(t[0]) && "number" == typeof t[0][0]) {
                    const [e, r] = t[0];
                    let n = e, i = r, o = e, a = r;
                    return t.forEach(([t, e])=>{
                        t < n && (n = t), t > o && (o = t), e < i && (i = e), e > a && (a = e);
                    }), [
                        n,
                        i,
                        o,
                        a
                    ];
                }
                if (Array.isArray(t) && (2 === t.length || 3 === t.length) && "number" == typeof t[0]) {
                    const [e, r] = t;
                    return [
                        e,
                        r,
                        e,
                        r
                    ];
                }
                if ("number" == typeof t.x && "number" == typeof t.y) {
                    const { x: e, y: r } = t;
                    return [
                        e,
                        r,
                        e,
                        r
                    ];
                }
                return [
                    "xmin",
                    "xmax",
                    "ymin",
                    "ymax"
                ].every((e)=>"number" == typeof t[e]) ? [
                    t.xmin,
                    t.ymin,
                    t.xmax,
                    t.ymax
                ] : void 0;
            }
            t.exports = i, t.exports.default = i;
        },
        function(t, e, r) {
            "use strict";
            var n = Object.assign || function(t) {
                for(var e = 1; e < arguments.length; e++){
                    var r = arguments[e];
                    for(var n in r)Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
                }
                return t;
            }, i = {
                "{": "\\{",
                "}": "\\}",
                "\\": "\\textbackslash{}",
                "#": "\\#",
                $: "\\$",
                "%": "\\%",
                "&": "\\&",
                "^": "\\textasciicircum{}",
                _: "\\_",
                "~": "\\textasciitilde{}"
            }, o = {
                "\u2013": "\\--",
                "\u2014": "\\---",
                " ": "~",
                "	": "\\qquad{}",
                "\r\n": "\\newline{}",
                "\n": "\\newline{}"
            }, a = function(t, e) {
                return n({}, t, e);
            };
            t.exports = function(t) {
                for(var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = e.preserveFormatting, s = void 0 !== r && r, u = e.escapeMapFn, l = void 0 === u ? a : u, c = String(t), f = "", h = l(n({}, i), s ? n({}, o) : {}), p = Object.keys(h), d = function() {
                    var t = !1;
                    p.forEach(function(e, r) {
                        t || c.length >= e.length && c.slice(0, e.length) === e && (f += h[p[r]], c = c.slice(e.length, c.length), t = !0);
                    }), t || (f += c.slice(0, 1), c = c.slice(1, c.length));
                }; c;)d();
                return f;
            };
        },
        function(t, e, r) {
            var n;
            const i = r(222), o = r(114), a = r(224);
            "function" != typeof i && console.warn("[reproject-bbox] failed to import proj4-merge");
            const s = "[reproject-bbox] You passed in a value of 32767 for {{%s}}, which means a custom non-standard projection.  Please pass in a Well-Known Text or PROJ4JS String instead.";
            function u({ bbox: t, density: e, from: r, proj4: n, to: u }) {
                if (32767 === r) throw new Error(s.replace("{{%s}}", "from"));
                if (32767 === u) throw new Error(s.replace("{{%s}}", "to"));
                "number" == typeof r && (r = "EPSG:" + r), "number" == typeof u && (u = "EPSG:" + u);
                const l = [
                    n,
                    o
                ];
                "object" == typeof window && window.proj4 && l.push(window.proj4), "object" == typeof self && self.proj4 && l.push(self.proj4);
                const c = i(l)(r, u).forward;
                return a(t, c, {
                    density: e
                });
            }
            void 0 === (n = (function() {
                return u;
            }).call(e, r, e, t)) || (t.exports = n), t.exports = u, t.exports.default = u, "object" == typeof window && (window.reprojectBoundingBox = u), "object" == typeof self && (self.reprojectBoundingBox = u);
        },
        function(t, e, r) {
            var n;
            const i = r(114), o = r(227);
            function a(t, { densify: e, from: r = "EPSG:4326", to: n = "EPSG:4326" }) {
                return ("number" == typeof r || r.match(/^\d+$/)) && (r = "EPSG:" + r), ("number" == typeof n || n.match(/^\d+$/)) && (n = "EPSG:" + n), o(t, {
                    densify: e,
                    reproject: i(r, n).forward
                });
            }
            void 0 === (n = (function() {
                return a;
            }).call(e, r, e, t)) || (t.exports = n), t.exports = a, "object" == typeof window && (window.reprojectGeoJSON = a), "object" == typeof self && (self.reprojectGeoJSON = a);
        },
        function(t, e, r) {
            const n = r(229);
            function i(t, { debug: e = !1, no_data: r, theoretical_min: i } = {
                debug: !1,
                no_data: void 0,
                theoretical_min: void 0
            }) {
                if (e && console.log("[fast-min] starting with numbers:", t.slice(0, 10)), !t.length) throw e && console.error("[fast-min] Instead of an array of numbers, you passed in", t), new Error("[fast-min] You didn't pass in an array of numbers");
                if (0 === t.length) throw new Error("[fast-min] You passed in an empty array");
                let o;
                const a = t.length;
                if (e && console.log("[fast-min] constructor:", t.constructor.name), void 0 === i && (i = n(t.constructor.name)), e && console.log("[fast-min] theoretical minimunm is", i), i) {
                    if (void 0 !== r) {
                        o = 1 / 0;
                        for(let n = 0; n < a; n++){
                            const s = t[n];
                            if (s < o && s !== r && (o = s, s === i)) {
                                e && console.log("[fast-min] found minimum value of " + s + " at index " + n + " of " + a);
                                break;
                            }
                        }
                        o === 1 / 0 && (o = void 0);
                    } else {
                        o = t[0];
                        for(let r = 1; r < a; r++){
                            const n = t[r];
                            if (n < o && (o = n, n === i)) {
                                e && console.log("[fast-min] found minimum value of " + n + " at index " + r + " of " + a);
                                break;
                            }
                        }
                    }
                } else if (void 0 !== r) {
                    o = 1 / 0;
                    for(let e = 1; e < a; e++){
                        const n = t[e];
                        n < o && n !== r && (o = n);
                    }
                    o === 1 / 0 && (o = void 0);
                } else {
                    o = t[0];
                    for(let e = 1; e < a; e++){
                        const r = t[e];
                        r < o && (o = r);
                    }
                }
                return e && console.log("[fast-min] returning", o), o;
            }
            t.exports = i, t.exports.default = i, "object" == typeof self && (self.fastMin = i), "object" == typeof window && (window.fastMin = i);
        },
        function(t, e, r) {
            "use strict";
            function n([t, e, r, n]) {
                return [
                    r - t,
                    n - e
                ];
            }
            t.exports = n, t.exports.default = n;
        },
        function(t, e, r) {
            const n = r(231);
            function i(t) {
                const e = [];
                for(let r = 0; r < t.length; r++){
                    const n = t[r];
                    for(let t = 0; t < n.length; t++)e.push(n[t]);
                }
                return e;
            }
            function o(t) {
                if (t.geometry && (t = t.geometry), t.coordinates && (t = t.coordinates), t.paths && (t = t.paths), t.points && (t = t.points), t.rings && (t = t.rings), Array.isArray(t.features)) return n(i(t.features.map(o)));
                if (Array.isArray(t.geometries)) return n(i(t.geometries.map(o)));
                if (Array.isArray(t) && Array.isArray(t[0]) && Array.isArray(t[0][0])) return n(i(t.map(o)));
                if (Array.isArray(t) && Array.isArray(t[0]) && "number" == typeof t[0][0]) {
                    const [e, r] = t[0];
                    let n = e, i = r, o = e, a = r;
                    return t.forEach(([t, e])=>{
                        t < n && (n = t), t > o && (o = t), e < i && (i = e), e > a && (a = e);
                    }), [
                        [
                            n,
                            i,
                            o,
                            a
                        ]
                    ];
                }
                if (Array.isArray(t) && (2 === t.length || 3 === t.length) && "number" == typeof t[0]) {
                    const [e, r] = t;
                    return [
                        [
                            e,
                            r,
                            e,
                            r
                        ]
                    ];
                }
                if ("number" == typeof t.x && "number" == typeof t.y) {
                    const { x: e, y: r } = t;
                    return [
                        [
                            e,
                            r,
                            e,
                            r
                        ]
                    ];
                }
                return [
                    "xmin",
                    "xmax",
                    "ymin",
                    "ymax"
                ].every((e)=>"number" == typeof t[e]) ? [
                    [
                        t.xmin,
                        t.ymin,
                        t.xmax,
                        t.ymax
                    ]
                ] : void 0;
            }
            t.exports = o, t.exports.default = o;
        },
        function(t, e, r) {
            const n = r(239), i = r(240);
            function o(t, e, { async: r = !1, density: o } = {}) {
                const a = i(t, {
                    density: o
                })[0].map((t)=>e(t));
                return r ? Promise.all(a).then((t)=>n(t)) : n(a);
            }
            t.exports = o, t.exports.default = o;
        },
        function(t, e, r) {
            const n = r(135), i = r(245), o = r(136), a = r(265);
            t.exports = {
                Geotransform: n,
                ModelTransform: i,
                PreciseGeotransform: o,
                PreciseModelTransform: a
            };
        },
        function(t, e, r) {
            var n;
            const i = r(266), o = r(267);
            function a({ precise: t = !1, ...e }) {
                return t ? o(e) : i(e);
            }
            void 0 === (n = (function() {
                return a;
            }).call(e, r, e, t)) || (t.exports = n), t.exports = a;
        },
        function(t, e, r) {
            "use strict";
            r.d(e, "a", function() {
                return i;
            });
            var n = r(11);
            function i(t, e, r) {
                return Object(n.a)(t, e, "range", r, {
                    vrm: "minimal"
                });
            }
        },
        function(t, e, r) {
            "use strict";
            r.r(e), (function(t) {
                var n = r(99);
                r.d(e, "bandArithmetic", function() {
                    return n.a;
                });
                var i = r(23);
                r.d(e, "cache", function() {
                    return i.a;
                });
                var o = r(16);
                r.d(e, "get", function() {
                    return o.a;
                });
                var a = r(100);
                r.d(e, "histogram", function() {
                    return a.a;
                });
                var s = r(101);
                r.d(e, "identify", function() {
                    return s.a;
                });
                var u = r(53);
                r.d(e, "load", function() {
                    return u.a;
                });
                var l = r(93);
                r.d(e, "max", function() {
                    return l.a;
                });
                var c = r(94);
                r.d(e, "mean", function() {
                    return c.a;
                });
                var f = r(95);
                r.d(e, "median", function() {
                    return f.a;
                });
                var h = r(96);
                r.d(e, "min", function() {
                    return h.a;
                });
                var p = r(97);
                r.d(e, "mode", function() {
                    return p.a;
                });
                var d = r(52);
                r.d(e, "parse", function() {
                    return d.a;
                });
                var m = r(176), y = r(102);
                r.d(e, "rasterCalculator", function() {
                    return y.a;
                });
                var g = r(98);
                r.d(e, "sum", function() {
                    return g.a;
                });
                var v = r(11), b = r(51);
                r.d(e, "stats", function() {
                    return b.a;
                });
                var x = {
                    cache: i.a,
                    bandArithmetic: n.a,
                    get: o.a,
                    histogram: a.a,
                    identify: s.a,
                    load: u.a,
                    max: l.a,
                    mean: c.a,
                    median: f.a,
                    min: h.a,
                    mode: p.a,
                    parse: d.a,
                    range: m.a,
                    rasterCalculator: y.a,
                    stat: v.a,
                    stats: b.a,
                    sum: g.a
                };
                e.default = x, "function" == typeof define && r(32) && define(function() {
                    return x;
                }), "undefined" != typeof window && (window.geoblaze = x), "undefined" != typeof self && (self.geoblaze = x), void 0 !== t && (t.geoblaze = x);
            }).call(this, r(46));
        },
        ,
        function(t, e) {
            function r() {
                try {
                    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
                } catch (e) {}
                return (t.exports = r = function() {
                    return !!e;
                }, t.exports.__esModule = !0, t.exports.default = t.exports)();
            }
            t.exports = r, t.exports.__esModule = !0, t.exports.default = t.exports;
        },
        function(t, e) {
            function r(e, n) {
                return t.exports = r = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
                    return t.__proto__ = e, t;
                }, t.exports.__esModule = !0, t.exports.default = t.exports, r(e, n);
            }
            t.exports = r, t.exports.__esModule = !0, t.exports.default = t.exports;
        },
        function(t, e, r) {
            var n = r(109);
            t.exports = function(t) {
                if (Array.isArray(t)) return n(t);
            }, t.exports.__esModule = !0, t.exports.default = t.exports;
        },
        function(t, e) {
            t.exports = function(t) {
                if ("undefined" != typeof Symbol && null != t[Symbol.iterator] || null != t["@@iterator"]) return Array.from(t);
            }, t.exports.__esModule = !0, t.exports.default = t.exports;
        },
        function(t, e) {
            t.exports = function() {
                throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }, t.exports.__esModule = !0, t.exports.default = t.exports;
        },
        function(t, e, r) {
            var n = r(7).default;
            function i() {
                "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
                t.exports = i = function() {
                    return r;
                }, t.exports.__esModule = !0, t.exports.default = t.exports;
                var e, r = {}, o = Object.prototype, a = o.hasOwnProperty, s = Object.defineProperty || function(t, e, r) {
                    t[e] = r.value;
                }, u = "function" == typeof Symbol ? Symbol : {}, l = u.iterator || "@@iterator", c = u.asyncIterator || "@@asyncIterator", f = u.toStringTag || "@@toStringTag";
                function h(t, e, r) {
                    return Object.defineProperty(t, e, {
                        value: r,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }), t[e];
                }
                try {
                    h({}, "");
                } catch (e) {
                    h = function(t, e, r) {
                        return t[e] = r;
                    };
                }
                function p(t, e, r, n) {
                    var i = e && e.prototype instanceof b ? e : b, o = Object.create(i.prototype), a = new T(n || []);
                    return s(o, "_invoke", {
                        value: N(t, r, a)
                    }), o;
                }
                function d(t, e, r) {
                    try {
                        return {
                            type: "normal",
                            arg: t.call(e, r)
                        };
                    } catch (t) {
                        return {
                            type: "throw",
                            arg: t
                        };
                    }
                }
                r.wrap = p;
                var m = "suspendedStart", y = "executing", g = "completed", v = {};
                function b() {}
                function x() {}
                function w() {}
                var _ = {};
                h(_, l, function() {
                    return this;
                });
                var A = Object.getPrototypeOf, E = A && A(A(F([])));
                E && E !== o && a.call(E, l) && (_ = E);
                var S = w.prototype = b.prototype = Object.create(_);
                function M(t) {
                    [
                        "next",
                        "throw",
                        "return"
                    ].forEach(function(e) {
                        h(t, e, function(t) {
                            return this._invoke(e, t);
                        });
                    });
                }
                function k(t, e) {
                    function r(i, o, s, u) {
                        var l = d(t[i], t, o);
                        if ("throw" !== l.type) {
                            var c = l.arg, f = c.value;
                            return f && "object" == n(f) && a.call(f, "__await") ? e.resolve(f.__await).then(function(t) {
                                r("next", t, s, u);
                            }, function(t) {
                                r("throw", t, s, u);
                            }) : e.resolve(f).then(function(t) {
                                c.value = t, s(c);
                            }, function(t) {
                                return r("throw", t, s, u);
                            });
                        }
                        u(l.arg);
                    }
                    var i;
                    s(this, "_invoke", {
                        value: function(t, n) {
                            function o() {
                                return new e(function(e, i) {
                                    r(t, n, e, i);
                                });
                            }
                            return i = i ? i.then(o, o) : o();
                        }
                    });
                }
                function N(t, r, n) {
                    var i = m;
                    return function(o, a) {
                        if (i === y) throw Error("Generator is already running");
                        if (i === g) {
                            if ("throw" === o) throw a;
                            return {
                                value: e,
                                done: !0
                            };
                        }
                        for(n.method = o, n.arg = a;;){
                            var s = n.delegate;
                            if (s) {
                                var u = C(s, n);
                                if (u) {
                                    if (u === v) continue;
                                    return u;
                                }
                            }
                            if ("next" === n.method) n.sent = n._sent = n.arg;
                            else if ("throw" === n.method) {
                                if (i === m) throw i = g, n.arg;
                                n.dispatchException(n.arg);
                            } else "return" === n.method && n.abrupt("return", n.arg);
                            i = y;
                            var l = d(t, r, n);
                            if ("normal" === l.type) {
                                if (i = n.done ? g : "suspendedYield", l.arg === v) continue;
                                return {
                                    value: l.arg,
                                    done: n.done
                                };
                            }
                            "throw" === l.type && (i = g, n.method = "throw", n.arg = l.arg);
                        }
                    };
                }
                function C(t, r) {
                    var n = r.method, i = t.iterator[n];
                    if (i === e) return r.delegate = null, "throw" === n && t.iterator.return && (r.method = "return", r.arg = e, C(t, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), v;
                    var o = d(i, t.iterator, r.arg);
                    if ("throw" === o.type) return r.method = "throw", r.arg = o.arg, r.delegate = null, v;
                    var a = o.arg;
                    return a ? a.done ? (r[t.resultName] = a.value, r.next = t.nextLoc, "return" !== r.method && (r.method = "next", r.arg = e), r.delegate = null, v) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, v);
                }
                function D(t) {
                    var e = {
                        tryLoc: t[0]
                    };
                    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
                }
                function O(t) {
                    var e = t.completion || {};
                    e.type = "normal", delete e.arg, t.completion = e;
                }
                function T(t) {
                    this.tryEntries = [
                        {
                            tryLoc: "root"
                        }
                    ], t.forEach(D, this), this.reset(!0);
                }
                function F(t) {
                    if (t || "" === t) {
                        var r = t[l];
                        if (r) return r.call(t);
                        if ("function" == typeof t.next) return t;
                        if (!isNaN(t.length)) {
                            var i = -1, o = function r() {
                                for(; ++i < t.length;)if (a.call(t, i)) return r.value = t[i], r.done = !1, r;
                                return r.value = e, r.done = !0, r;
                            };
                            return o.next = o;
                        }
                    }
                    throw new TypeError(n(t) + " is not iterable");
                }
                return x.prototype = w, s(S, "constructor", {
                    value: w,
                    configurable: !0
                }), s(w, "constructor", {
                    value: x,
                    configurable: !0
                }), x.displayName = h(w, f, "GeneratorFunction"), r.isGeneratorFunction = function(t) {
                    var e = "function" == typeof t && t.constructor;
                    return !!e && (e === x || "GeneratorFunction" === (e.displayName || e.name));
                }, r.mark = function(t) {
                    return Object.setPrototypeOf ? Object.setPrototypeOf(t, w) : (t.__proto__ = w, h(t, f, "GeneratorFunction")), t.prototype = Object.create(S), t;
                }, r.awrap = function(t) {
                    return {
                        __await: t
                    };
                }, M(k.prototype), h(k.prototype, c, function() {
                    return this;
                }), r.AsyncIterator = k, r.async = function(t, e, n, i, o) {
                    void 0 === o && (o = Promise);
                    var a = new k(p(t, e, n, i), o);
                    return r.isGeneratorFunction(e) ? a : a.next().then(function(t) {
                        return t.done ? t.value : a.next();
                    });
                }, M(S), h(S, f, "Generator"), h(S, l, function() {
                    return this;
                }), h(S, "toString", function() {
                    return "[object Generator]";
                }), r.keys = function(t) {
                    var e = Object(t), r = [];
                    for(var n in e)r.push(n);
                    return r.reverse(), function t() {
                        for(; r.length;){
                            var n = r.pop();
                            if (n in e) return t.value = n, t.done = !1, t;
                        }
                        return t.done = !0, t;
                    };
                }, r.values = F, T.prototype = {
                    constructor: T,
                    reset: function(t) {
                        if (this.prev = 0, this.next = 0, this.sent = this._sent = e, this.done = !1, this.delegate = null, this.method = "next", this.arg = e, this.tryEntries.forEach(O), !t) for(var r in this)"t" === r.charAt(0) && a.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = e);
                    },
                    stop: function() {
                        this.done = !0;
                        var t = this.tryEntries[0].completion;
                        if ("throw" === t.type) throw t.arg;
                        return this.rval;
                    },
                    dispatchException: function(t) {
                        if (this.done) throw t;
                        var r = this;
                        function n(n, i) {
                            return s.type = "throw", s.arg = t, r.next = n, i && (r.method = "next", r.arg = e), !!i;
                        }
                        for(var i = this.tryEntries.length - 1; i >= 0; --i){
                            var o = this.tryEntries[i], s = o.completion;
                            if ("root" === o.tryLoc) return n("end");
                            if (o.tryLoc <= this.prev) {
                                var u = a.call(o, "catchLoc"), l = a.call(o, "finallyLoc");
                                if (u && l) {
                                    if (this.prev < o.catchLoc) return n(o.catchLoc, !0);
                                    if (this.prev < o.finallyLoc) return n(o.finallyLoc);
                                } else if (u) {
                                    if (this.prev < o.catchLoc) return n(o.catchLoc, !0);
                                } else {
                                    if (!l) throw Error("try statement without catch or finally");
                                    if (this.prev < o.finallyLoc) return n(o.finallyLoc);
                                }
                            }
                        }
                    },
                    abrupt: function(t, e) {
                        for(var r = this.tryEntries.length - 1; r >= 0; --r){
                            var n = this.tryEntries[r];
                            if (n.tryLoc <= this.prev && a.call(n, "finallyLoc") && this.prev < n.finallyLoc) {
                                var i = n;
                                break;
                            }
                        }
                        i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
                        var o = i ? i.completion : {};
                        return o.type = t, o.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, v) : this.complete(o);
                    },
                    complete: function(t, e) {
                        if ("throw" === t.type) throw t.arg;
                        return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), v;
                    },
                    finish: function(t) {
                        for(var e = this.tryEntries.length - 1; e >= 0; --e){
                            var r = this.tryEntries[e];
                            if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), O(r), v;
                        }
                    },
                    catch: function(t) {
                        for(var e = this.tryEntries.length - 1; e >= 0; --e){
                            var r = this.tryEntries[e];
                            if (r.tryLoc === t) {
                                var n = r.completion;
                                if ("throw" === n.type) {
                                    var i = n.arg;
                                    O(r);
                                }
                                return i;
                            }
                        }
                        throw Error("illegal catch attempt");
                    },
                    delegateYield: function(t, r, n) {
                        return this.delegate = {
                            iterator: F(t),
                            resultName: r,
                            nextLoc: n
                        }, "next" === this.method && (this.arg = e), v;
                    }
                }, r;
            }
            t.exports = i, t.exports.__esModule = !0, t.exports.default = t.exports;
        },
        function(t, e) {
            t.exports = function(t) {
                if (Array.isArray(t)) return t;
            }, t.exports.__esModule = !0, t.exports.default = t.exports;
        },
        function(t, e) {
            t.exports = function(t, e) {
                var r = null == t ? null : "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
                if (null != r) {
                    var n, i, o, a, s = [], u = !0, l = !1;
                    try {
                        if (o = (r = r.call(t)).next, 0 === e) {
                            if (Object(r) !== r) return;
                            u = !1;
                        } else for(; !(u = (n = o.call(r)).done) && (s.push(n.value), s.length !== e); u = !0);
                    } catch (t) {
                        l = !0, i = t;
                    } finally{
                        try {
                            if (!u && null != r.return && (a = r.return(), Object(a) !== a)) return;
                        } finally{
                            if (l) throw i;
                        }
                    }
                    return s;
                }
            }, t.exports.__esModule = !0, t.exports.default = t.exports;
        },
        function(t, e) {
            t.exports = function() {
                throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }, t.exports.__esModule = !0, t.exports.default = t.exports;
        },
        function(t, e, r) {
            "use strict";
            r.r(e), r.d(e, "coordAll", function() {
                return c;
            }), r.d(e, "coordEach", function() {
                return i;
            }), r.d(e, "coordReduce", function() {
                return o;
            }), r.d(e, "featureEach", function() {
                return u;
            }), r.d(e, "featureReduce", function() {
                return l;
            }), r.d(e, "findPoint", function() {
                return x;
            }), r.d(e, "findSegment", function() {
                return b;
            }), r.d(e, "flattenEach", function() {
                return p;
            }), r.d(e, "flattenReduce", function() {
                return d;
            }), r.d(e, "geomEach", function() {
                return f;
            }), r.d(e, "geomReduce", function() {
                return h;
            }), r.d(e, "lineEach", function() {
                return g;
            }), r.d(e, "lineReduce", function() {
                return v;
            }), r.d(e, "propEach", function() {
                return a;
            }), r.d(e, "propReduce", function() {
                return s;
            }), r.d(e, "segmentEach", function() {
                return m;
            }), r.d(e, "segmentReduce", function() {
                return y;
            });
            var n = r(6);
            function i(t, e, r) {
                if (null !== t) for(var n, o, a, s, u, l, c, f, h = 0, p = 0, d = t.type, m = "FeatureCollection" === d, y = "Feature" === d, g = m ? t.features.length : 1, v = 0; v < g; v++){
                    u = (f = !!(c = m ? t.features[v].geometry : y ? t.geometry : t) && "GeometryCollection" === c.type) ? c.geometries.length : 1;
                    for(var b = 0; b < u; b++){
                        var x = 0, w = 0;
                        if (null !== (s = f ? c.geometries[b] : c)) {
                            l = s.coordinates;
                            var _ = s.type;
                            switch(h = !r || "Polygon" !== _ && "MultiPolygon" !== _ ? 0 : 1, _){
                                case null:
                                    break;
                                case "Point":
                                    if (!1 === e(l, p, v, x, w)) return !1;
                                    p++, x++;
                                    break;
                                case "LineString":
                                case "MultiPoint":
                                    for(n = 0; n < l.length; n++){
                                        if (!1 === e(l[n], p, v, x, w)) return !1;
                                        p++, "MultiPoint" === _ && x++;
                                    }
                                    "LineString" === _ && x++;
                                    break;
                                case "Polygon":
                                case "MultiLineString":
                                    for(n = 0; n < l.length; n++){
                                        for(o = 0; o < l[n].length - h; o++){
                                            if (!1 === e(l[n][o], p, v, x, w)) return !1;
                                            p++;
                                        }
                                        "MultiLineString" === _ && x++, "Polygon" === _ && w++;
                                    }
                                    "Polygon" === _ && x++;
                                    break;
                                case "MultiPolygon":
                                    for(n = 0; n < l.length; n++){
                                        for(w = 0, o = 0; o < l[n].length; o++){
                                            for(a = 0; a < l[n][o].length - h; a++){
                                                if (!1 === e(l[n][o][a], p, v, x, w)) return !1;
                                                p++;
                                            }
                                            w++;
                                        }
                                        x++;
                                    }
                                    break;
                                case "GeometryCollection":
                                    for(n = 0; n < s.geometries.length; n++)if (!1 === i(s.geometries[n], e, r)) return !1;
                                    break;
                                default:
                                    throw new Error("Unknown Geometry Type");
                            }
                        }
                    }
                }
            }
            function o(t, e, r, n) {
                var o = r;
                return i(t, function(t, n, i, a, s) {
                    o = 0 === n && void 0 === r ? t : e(o, t, n, i, a, s);
                }, n), o;
            }
            function a(t, e) {
                var r;
                switch(t.type){
                    case "FeatureCollection":
                        for(r = 0; r < t.features.length && !1 !== e(t.features[r].properties, r); r++);
                        break;
                    case "Feature":
                        e(t.properties, 0);
                }
            }
            function s(t, e, r) {
                var n = r;
                return a(t, function(t, i) {
                    n = 0 === i && void 0 === r ? t : e(n, t, i);
                }), n;
            }
            function u(t, e) {
                if ("Feature" === t.type) e(t, 0);
                else if ("FeatureCollection" === t.type) for(var r = 0; r < t.features.length && !1 !== e(t.features[r], r); r++);
            }
            function l(t, e, r) {
                var n = r;
                return u(t, function(t, i) {
                    n = 0 === i && void 0 === r ? t : e(n, t, i);
                }), n;
            }
            function c(t) {
                var e = [];
                return i(t, function(t) {
                    e.push(t);
                }), e;
            }
            function f(t, e) {
                var r, n, i, o, a, s, u, l, c, f, h = 0, p = "FeatureCollection" === t.type, d = "Feature" === t.type, m = p ? t.features.length : 1;
                for(r = 0; r < m; r++){
                    for(s = p ? t.features[r].geometry : d ? t.geometry : t, l = p ? t.features[r].properties : d ? t.properties : {}, c = p ? t.features[r].bbox : d ? t.bbox : void 0, f = p ? t.features[r].id : d ? t.id : void 0, a = (u = !!s && "GeometryCollection" === s.type) ? s.geometries.length : 1, i = 0; i < a; i++)if (null !== (o = u ? s.geometries[i] : s)) switch(o.type){
                        case "Point":
                        case "LineString":
                        case "MultiPoint":
                        case "Polygon":
                        case "MultiLineString":
                        case "MultiPolygon":
                            if (!1 === e(o, h, l, c, f)) return !1;
                            break;
                        case "GeometryCollection":
                            for(n = 0; n < o.geometries.length; n++)if (!1 === e(o.geometries[n], h, l, c, f)) return !1;
                            break;
                        default:
                            throw new Error("Unknown Geometry Type");
                    }
                    else if (!1 === e(null, h, l, c, f)) return !1;
                    h++;
                }
            }
            function h(t, e, r) {
                var n = r;
                return f(t, function(t, i, o, a, s) {
                    n = 0 === i && void 0 === r ? t : e(n, t, i, o, a, s);
                }), n;
            }
            function p(t, e) {
                f(t, function(t, r, i, o, a) {
                    var s, u = null === t ? null : t.type;
                    switch(u){
                        case null:
                        case "Point":
                        case "LineString":
                        case "Polygon":
                            return !1 !== e(Object(n.a)(t, i, {
                                bbox: o,
                                id: a
                            }), r, 0) && void 0;
                    }
                    switch(u){
                        case "MultiPoint":
                            s = "Point";
                            break;
                        case "MultiLineString":
                            s = "LineString";
                            break;
                        case "MultiPolygon":
                            s = "Polygon";
                    }
                    for(var l = 0; l < t.coordinates.length; l++){
                        var c = {
                            type: s,
                            coordinates: t.coordinates[l]
                        };
                        if (!1 === e(Object(n.a)(c, i), r, l)) return !1;
                    }
                });
            }
            function d(t, e, r) {
                var n = r;
                return p(t, function(t, i, o) {
                    n = 0 === i && 0 === o && void 0 === r ? t : e(n, t, i, o);
                }), n;
            }
            function m(t, e) {
                p(t, function(t, r, o) {
                    var a = 0;
                    if (t.geometry) {
                        var s = t.geometry.type;
                        if ("Point" !== s && "MultiPoint" !== s) {
                            var u, l = 0, c = 0, f = 0;
                            return !1 !== i(t, function(i, s, h, p, d) {
                                if (void 0 === u || r > l || p > c || d > f) return u = i, l = r, c = p, f = d, void (a = 0);
                                var m = Object(n.d)([
                                    u,
                                    i
                                ], t.properties);
                                if (!1 === e(m, r, o, d, a)) return !1;
                                a++, u = i;
                            }) && void 0;
                        }
                    }
                });
            }
            function y(t, e, r) {
                var n = r, i = !1;
                return m(t, function(t, o, a, s, u) {
                    n = !1 === i && void 0 === r ? t : e(n, t, o, a, s, u), i = !0;
                }), n;
            }
            function g(t, e) {
                if (!t) throw new Error("geojson is required");
                p(t, function(t, r, i) {
                    if (null !== t.geometry) {
                        var o = t.geometry.type, a = t.geometry.coordinates;
                        switch(o){
                            case "LineString":
                                if (!1 === e(t, r, i, 0, 0)) return !1;
                                break;
                            case "Polygon":
                                for(var s = 0; s < a.length; s++)if (!1 === e(Object(n.d)(a[s], t.properties), r, i, s)) return !1;
                        }
                    }
                });
            }
            function v(t, e, r) {
                var n = r;
                return g(t, function(t, i, o, a) {
                    n = 0 === i && void 0 === r ? t : e(n, t, i, o, a);
                }), n;
            }
            function b(t, e) {
                if (e = e || {}, !Object(n.c)(e)) throw new Error("options is invalid");
                var r, i = e.featureIndex || 0, o = e.multiFeatureIndex || 0, a = e.geometryIndex || 0, s = e.segmentIndex || 0, u = e.properties;
                switch(t.type){
                    case "FeatureCollection":
                        i < 0 && (i = t.features.length + i), u = u || t.features[i].properties, r = t.features[i].geometry;
                        break;
                    case "Feature":
                        u = u || t.properties, r = t.geometry;
                        break;
                    case "Point":
                    case "MultiPoint":
                        return null;
                    case "LineString":
                    case "Polygon":
                    case "MultiLineString":
                    case "MultiPolygon":
                        r = t;
                        break;
                    default:
                        throw new Error("geojson is invalid");
                }
                if (null === r) return null;
                var l = r.coordinates;
                switch(r.type){
                    case "Point":
                    case "MultiPoint":
                        return null;
                    case "LineString":
                        return s < 0 && (s = l.length + s - 1), Object(n.d)([
                            l[s],
                            l[s + 1]
                        ], u, e);
                    case "Polygon":
                        return a < 0 && (a = l.length + a), s < 0 && (s = l[a].length + s - 1), Object(n.d)([
                            l[a][s],
                            l[a][s + 1]
                        ], u, e);
                    case "MultiLineString":
                        return o < 0 && (o = l.length + o), s < 0 && (s = l[o].length + s - 1), Object(n.d)([
                            l[o][s],
                            l[o][s + 1]
                        ], u, e);
                    case "MultiPolygon":
                        return o < 0 && (o = l.length + o), a < 0 && (a = l[o].length + a), s < 0 && (s = l[o][a].length - s - 1), Object(n.d)([
                            l[o][a][s],
                            l[o][a][s + 1]
                        ], u, e);
                }
                throw new Error("geojson is invalid");
            }
            function x(t, e) {
                if (e = e || {}, !Object(n.c)(e)) throw new Error("options is invalid");
                var r, i = e.featureIndex || 0, o = e.multiFeatureIndex || 0, a = e.geometryIndex || 0, s = e.coordIndex || 0, u = e.properties;
                switch(t.type){
                    case "FeatureCollection":
                        i < 0 && (i = t.features.length + i), u = u || t.features[i].properties, r = t.features[i].geometry;
                        break;
                    case "Feature":
                        u = u || t.properties, r = t.geometry;
                        break;
                    case "Point":
                    case "MultiPoint":
                        return null;
                    case "LineString":
                    case "Polygon":
                    case "MultiLineString":
                    case "MultiPolygon":
                        r = t;
                        break;
                    default:
                        throw new Error("geojson is invalid");
                }
                if (null === r) return null;
                var l = r.coordinates;
                switch(r.type){
                    case "Point":
                        return Object(n.e)(l, u, e);
                    case "MultiPoint":
                        return o < 0 && (o = l.length + o), Object(n.e)(l[o], u, e);
                    case "LineString":
                        return s < 0 && (s = l.length + s), Object(n.e)(l[s], u, e);
                    case "Polygon":
                        return a < 0 && (a = l.length + a), s < 0 && (s = l[a].length + s), Object(n.e)(l[a][s], u, e);
                    case "MultiLineString":
                        return o < 0 && (o = l.length + o), s < 0 && (s = l[o].length + s), Object(n.e)(l[o][s], u, e);
                    case "MultiPolygon":
                        return o < 0 && (o = l.length + o), a < 0 && (a = l[o].length + a), s < 0 && (s = l[o][a].length - s), Object(n.e)(l[o][a][s], u, e);
                }
                throw new Error("geojson is invalid");
            }
        },
        function(t, e, r) {
            var n, i;
            n = this, i = function() {
                "use strict";
                var t = {}, e = {
                    type: "link",
                    properties: {
                        href: "http://spatialreference.org/ref/sr-org/6928/ogcwkt/",
                        type: "ogcwkt"
                    }
                };
                function r(t) {
                    return "[object Array]" === Object.prototype.toString.call(t);
                }
                function n(t, e) {
                    for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
                    return t;
                }
                function i(t) {
                    if (t.type) switch(t.type){
                        case "Point":
                            return [
                                t.coordinates[0],
                                t.coordinates[1],
                                t.coordinates[0],
                                t.coordinates[1]
                            ];
                        case "MultiPoint":
                        case "LineString":
                            return a(t.coordinates);
                        case "MultiLineString":
                        case "Polygon":
                            return o(t.coordinates);
                        case "MultiPolygon":
                            return function(t) {
                                for(var e = null, r = null, n = null, i = null, o = 0; o < t.length; o++)for(var a = t[o], s = 0; s < a.length; s++)for(var u = a[s], l = 0; l < u.length; l++){
                                    var c = u[l], f = c[0], h = c[1];
                                    (null === e || f < e) && (e = f), (null === r || f > r) && (r = f), (null === n || h < n) && (n = h), (null === i || h > i) && (i = h);
                                }
                                return [
                                    e,
                                    n,
                                    r,
                                    i
                                ];
                            }(t.coordinates);
                        case "Feature":
                            return t.geometry ? i(t.geometry) : null;
                        case "FeatureCollection":
                            return function(t) {
                                for(var e, r = [], n = t.features.length - 1; n >= 0; n--)e = i(t.features[n].geometry), r.push([
                                    e[0],
                                    e[1]
                                ]), r.push([
                                    e[2],
                                    e[3]
                                ]);
                                return a(r);
                            }(t);
                        case "GeometryCollection":
                            return function(t) {
                                for(var e, r = [], n = t.geometries.length - 1; n >= 0; n--)e = i(t.geometries[n]), r.push([
                                    e[0],
                                    e[1]
                                ]), r.push([
                                    e[2],
                                    e[3]
                                ]);
                                return a(r);
                            }(t);
                        default:
                            throw new Error("Unknown type: " + t.type);
                    }
                    return null;
                }
                function o(t) {
                    for(var e = null, r = null, n = null, i = null, o = 0; o < t.length; o++)for(var a = t[o], s = 0; s < a.length; s++){
                        var u = a[s], l = u[0], c = u[1];
                        (null === e || l < e) && (e = l), (null === r || l > r) && (r = l), (null === n || c < n) && (n = c), (null === i || c > i) && (i = c);
                    }
                    return [
                        e,
                        n,
                        r,
                        i
                    ];
                }
                function a(t) {
                    for(var e = null, r = null, n = null, i = null, o = 0; o < t.length; o++){
                        var a = t[o], s = a[0], u = a[1];
                        (null === e || s < e) && (e = s), (null === r || s > r) && (r = s), (null === n || u < n) && (n = u), (null === i || u > i) && (i = u);
                    }
                    return [
                        e,
                        n,
                        r,
                        i
                    ];
                }
                function s(t) {
                    var e = i(t);
                    return {
                        x: e[0],
                        y: e[1],
                        w: Math.abs(e[0] - e[2]),
                        h: Math.abs(e[1] - e[3])
                    };
                }
                function u(t) {
                    return 57.29577951308232 * t;
                }
                function l(t) {
                    return .017453292519943 * t;
                }
                function c(t) {
                    var e = t[0], r = t[1];
                    return [
                        u(e / 6378137) - 360 * Math.floor((u(e / 6378137) + 180) / 360),
                        u(Math.PI / 2 - 2 * Math.atan(Math.exp(-1 * r / 6378137)))
                    ];
                }
                function f(t) {
                    var e = t[0], r = Math.max(Math.min(t[1], 89.99999), -89.99999);
                    return [
                        6378137 * l(e),
                        3189068.5 * Math.log((1 + Math.sin(l(r))) / (1 - Math.sin(l(r))))
                    ];
                }
                function h(t, r, n) {
                    if ("Point" === t.type) t.coordinates = r(t.coordinates);
                    else if ("Feature" === t.type) t.geometry = h(t.geometry, r, !0);
                    else if ("FeatureCollection" === t.type) for(var i = 0; i < t.features.length; i++)t.features[i] = h(t.features[i], r, !0);
                    else if ("GeometryCollection" === t.type) for(var o = 0; o < t.geometries.length; o++)t.geometries[o] = h(t.geometries[o], r, !0);
                    else t.coordinates = function t(e, r) {
                        for(var n = 0; n < e.length; n++)"number" == typeof e[n][0] && (e[n] = r(e[n])), "object" == typeof e[n] && (e[n] = t(e[n], r));
                        return e;
                    }(t.coordinates, r);
                    return n || r === f && (t.crs = e), r === c && delete t.crs, t;
                }
                function p(t) {
                    return h(t, f);
                }
                function d(t) {
                    return h(t, c);
                }
                function m(t, e) {
                    return t[0] > e[0] ? -1 : t[0] < e[0] ? 1 : t[1] > e[1] ? -1 : t[1] < e[1] ? 1 : 0;
                }
                function y(t, e, r) {
                    var n, i;
                    return (n = (e[0] - t[0]) * (r[1] - t[1]) - (r[0] - t[0]) * (e[1] - t[1])) < (i = 0) ? -1 : n > i ? 1 : 0;
                }
                function g(t, e) {
                    var r = e[0] - t[0], n = e[1] - t[1];
                    return r * r + n * n;
                }
                function v(t, e) {
                    var r = e;
                    for(var n in t){
                        var i = y(e, r, t[n]);
                        (-1 === i || 0 === i && g(e, t[n]) > g(e, r)) && (r = t[n]);
                    }
                    return r;
                }
                function b(t) {
                    if (0 === t.length) return [];
                    if (1 === t.length) return t;
                    for(var e = [
                        t.sort(m)[0]
                    ], r = 0; r < e.length; r++){
                        var n = v(t, e[r]);
                        n !== e[0] && e.push(n);
                    }
                    return e;
                }
                function x(t, e) {
                    for(var r = !1, n = -1, i = t.length, o = i - 1; ++n < i; o = n)(t[n][1] <= e[1] && e[1] < t[o][1] || t[o][1] <= e[1] && e[1] < t[n][1]) && e[0] < (t[o][0] - t[n][0]) * (e[1] - t[n][1]) / (t[o][1] - t[n][1]) + t[n][0] && (r = !r);
                    return r;
                }
                function w(t, e) {
                    if (t && t.length) {
                        if (1 === t.length) return x(t[0], e);
                        if (x(t[0], e)) {
                            for(var r = 1; r < t.length; r++)if (x(t[r], e)) return !1;
                            return !0;
                        }
                        return !1;
                    }
                    return !1;
                }
                function _(t, e, r, n) {
                    var i = (n[0] - r[0]) * (t[1] - r[1]) - (n[1] - r[1]) * (t[0] - r[0]), o = (e[0] - t[0]) * (t[1] - r[1]) - (e[1] - t[1]) * (t[0] - r[0]), a = (n[1] - r[1]) * (e[0] - t[0]) - (n[0] - r[0]) * (e[1] - t[1]);
                    if (0 !== a) {
                        var s = i / a, u = o / a;
                        if (0 <= s && s <= 1 && 0 <= u && u <= 1) return !0;
                    }
                    return !1;
                }
                function A(t) {
                    return !isNaN(parseFloat(t)) && isFinite(t);
                }
                function E(t, e) {
                    if (A(t[0][0])) {
                        if (A(e[0][0])) {
                            for(var r = 0; r < t.length - 1; r++)for(var n = 0; n < e.length - 1; n++)if (_(t[r], t[r + 1], e[n], e[n + 1])) return !0;
                        } else for(var i = 0; i < e.length; i++)if (E(t, e[i])) return !0;
                    } else for(var o = 0; o < t.length; o++)if (E(t[o], e)) return !0;
                    return !1;
                }
                function S(t) {
                    for(var e = [], r = 0; r < t.length; r++){
                        var n = t[r].slice();
                        !1 === M(n[0], n[n.length - 1]) && n.push(n[0]), e.push(n);
                    }
                    return e;
                }
                function M(t, e) {
                    for(var r = 0; r < t.length; r++)if (t[r] !== e[r]) return !1;
                    return !0;
                }
                function k(t, e) {
                    if (t.length !== e.length) return !1;
                    for(var r = t.slice().sort(m), n = e.slice().sort(m), i = 0; i < r.length; i++){
                        if (r[i].length !== n[i].length) return !1;
                        for(var o = 0; o < r.length; o++)if (r[i][o] !== n[i][o]) return !1;
                    }
                    return !0;
                }
                var N = [
                    "length"
                ];
                function C(t) {
                    if (t) switch(t.type){
                        case "Point":
                            return new D(t);
                        case "MultiPoint":
                            return new O(t);
                        case "LineString":
                            return new T(t);
                        case "MultiLineString":
                            return new F(t);
                        case "Polygon":
                            return new P(t);
                        case "MultiPolygon":
                            return new I(t);
                        case "Feature":
                            return new B(t);
                        case "FeatureCollection":
                            return new j(t);
                        case "GeometryCollection":
                            return new R(t);
                        default:
                            throw new Error("Unknown type: " + t.type);
                    }
                }
                function D(t) {
                    var e = Array.prototype.slice.call(arguments);
                    if (t && "Point" === t.type && t.coordinates) n(this, t);
                    else if (t && r(t)) this.coordinates = t;
                    else {
                        if (!(e.length >= 2)) throw "Terraformer: invalid input for Terraformer.Point";
                        this.coordinates = e;
                    }
                    this.type = "Point";
                }
                function O(t) {
                    if (t && "MultiPoint" === t.type && t.coordinates) n(this, t);
                    else {
                        if (!r(t)) throw "Terraformer: invalid input for Terraformer.MultiPoint";
                        this.coordinates = t;
                    }
                    this.type = "MultiPoint";
                }
                function T(t) {
                    if (t && "LineString" === t.type && t.coordinates) n(this, t);
                    else {
                        if (!r(t)) throw "Terraformer: invalid input for Terraformer.LineString";
                        this.coordinates = t;
                    }
                    this.type = "LineString";
                }
                function F(t) {
                    if (t && "MultiLineString" === t.type && t.coordinates) n(this, t);
                    else {
                        if (!r(t)) throw "Terraformer: invalid input for Terraformer.MultiLineString";
                        this.coordinates = t;
                    }
                    this.type = "MultiLineString";
                }
                function P(t) {
                    if (t && "Polygon" === t.type && t.coordinates) n(this, t);
                    else {
                        if (!r(t)) throw "Terraformer: invalid input for Terraformer.Polygon";
                        this.coordinates = t;
                    }
                    this.type = "Polygon";
                }
                function I(t) {
                    if (t && "MultiPolygon" === t.type && t.coordinates) n(this, t);
                    else {
                        if (!r(t)) throw "Terraformer: invalid input for Terraformer.MultiPolygon";
                        this.coordinates = t;
                    }
                    this.type = "MultiPolygon";
                }
                function B(t) {
                    if (t && "Feature" === t.type) n(this, t);
                    else {
                        if (!(t && t.type && t.coordinates)) throw "Terraformer: invalid input for Terraformer.Feature";
                        this.geometry = t;
                    }
                    this.type = "Feature";
                }
                function j(t) {
                    if (t && "FeatureCollection" === t.type && t.features) n(this, t);
                    else {
                        if (!r(t)) throw "Terraformer: invalid input for Terraformer.FeatureCollection";
                        this.features = t;
                    }
                    this.type = "FeatureCollection";
                }
                function R(t) {
                    if (t && "GeometryCollection" === t.type && t.geometries) n(this, t);
                    else if (r(t)) this.geometries = t;
                    else {
                        if (!t.coordinates || !t.type) throw "Terraformer: invalid input for Terraformer.GeometryCollection";
                        this.type = "GeometryCollection", this.geometries = [
                            t
                        ];
                    }
                    this.type = "GeometryCollection";
                }
                function L(t, e, r) {
                    for(var n = f(t), i = r || 64, o = {
                        type: "Polygon",
                        coordinates: [
                            []
                        ]
                    }, a = 1; a <= i; a++){
                        var s = a * (360 / i) * Math.PI / 180;
                        o.coordinates[0].push([
                            n[0] + e * Math.cos(s),
                            n[1] + e * Math.sin(s)
                        ]);
                    }
                    return o.coordinates = S(o.coordinates), d(o);
                }
                function q(t, e, r) {
                    var i = r || 64, o = e || 250;
                    if (!t || t.length < 2 || !o || !i) throw new Error("Terraformer: missing parameter for Terraformer.Circle");
                    n(this, new B({
                        type: "Feature",
                        geometry: L(t, o, i),
                        properties: {
                            radius: o,
                            center: t,
                            steps: i
                        }
                    }));
                }
                return C.prototype.toMercator = function() {
                    return p(this);
                }, C.prototype.toGeographic = function() {
                    return d(this);
                }, C.prototype.envelope = function() {
                    return s(this);
                }, C.prototype.bbox = function() {
                    return i(this);
                }, C.prototype.convexHull = function() {
                    var t, e, r = [];
                    if ("Point" === this.type) return null;
                    if ("LineString" === this.type || "MultiPoint" === this.type) {
                        if (!(this.coordinates && this.coordinates.length >= 3)) return null;
                        r = this.coordinates;
                    } else if ("Polygon" === this.type || "MultiLineString" === this.type) {
                        if (!(this.coordinates && this.coordinates.length > 0)) return null;
                        for(t = 0; t < this.coordinates.length; t++)r = r.concat(this.coordinates[t]);
                        if (r.length < 3) return null;
                    } else if ("MultiPolygon" === this.type) {
                        if (!(this.coordinates && this.coordinates.length > 0)) return null;
                        for(t = 0; t < this.coordinates.length; t++)for(e = 0; e < this.coordinates[t].length; e++)r = r.concat(this.coordinates[t][e]);
                        if (r.length < 3) return null;
                    } else if ("Feature" === this.type) return new C(this.geometry).convexHull();
                    return new P({
                        type: "Polygon",
                        coordinates: S([
                            b(r)
                        ])
                    });
                }, C.prototype.toJSON = function() {
                    var t = {};
                    for(var e in this)this.hasOwnProperty(e) && -1 === N.indexOf(e) && (t[e] = this[e]);
                    return t.bbox = i(this), t;
                }, C.prototype.contains = function(t) {
                    return new C(t).within(this);
                }, C.prototype.within = function(t) {
                    var e, r, n;
                    if ("Feature" === t.type && (t = t.geometry), "Point" === t.type && "Point" === this.type) return M(this.coordinates, t.coordinates);
                    if ("MultiLineString" === t.type && "Point" === this.type) for(e = 0; e < t.coordinates.length; e++){
                        var i = {
                            type: "LineString",
                            coordinates: t.coordinates[e]
                        };
                        if (this.within(i)) return !0;
                    }
                    if (("LineString" === t.type || "MultiPoint" === t.type) && "Point" === this.type) for(e = 0; e < t.coordinates.length; e++){
                        if (this.coordinates.length !== t.coordinates[e].length) return !1;
                        if (M(this.coordinates, t.coordinates[e])) return !0;
                    }
                    if ("Polygon" === t.type) {
                        if ("Polygon" === this.type) {
                            if (t.coordinates.length === this.coordinates.length) {
                                for(e = 0; e < this.coordinates.length; e++)if (k(this.coordinates[e], t.coordinates[e])) return !0;
                            }
                            return !(!this.coordinates.length || !w(t.coordinates, this.coordinates[0][0]) || E(S(this.coordinates), S(t.coordinates)));
                        }
                        if ("Point" === this.type) return w(t.coordinates, this.coordinates);
                        if ("LineString" === this.type || "MultiPoint" === this.type) {
                            if (!this.coordinates || 0 === this.coordinates.length) return !1;
                            for(e = 0; e < this.coordinates.length; e++)if (!1 === w(t.coordinates, this.coordinates[e])) return !1;
                            return !0;
                        }
                        if ("MultiLineString" === this.type) {
                            for(e = 0; e < this.coordinates.length; e++)if (!1 === new T(this.coordinates[e]).within(t)) return n++, !1;
                            return !0;
                        }
                        if ("MultiPolygon" === this.type) {
                            for(e = 0; e < this.coordinates.length; e++)if (!1 === new C({
                                type: "Polygon",
                                coordinates: this.coordinates[e]
                            }).within(t)) return !1;
                            return !0;
                        }
                    }
                    if ("MultiPolygon" === t.type) {
                        if ("Point" === this.type) {
                            if (t.coordinates.length) {
                                for(e = 0; e < t.coordinates.length; e++)if (w(t.coordinates[e], this.coordinates) && !1 === E([
                                    this.coordinates
                                ], t.coordinates)) return !0;
                            }
                            return !1;
                        }
                        if ("Polygon" === this.type) {
                            for(e = 0; e < this.coordinates.length; e++)if (t.coordinates[e].length === this.coordinates.length) {
                                for(r = 0; r < this.coordinates.length; r++)if (k(this.coordinates[r], t.coordinates[e][r])) return !0;
                            }
                            if (!1 === E(this.coordinates, t.coordinates) && t.coordinates.length) {
                                for(e = 0; e < t.coordinates.length; e++)n = !1 !== w(t.coordinates[e], this.coordinates[0][0]);
                                return n;
                            }
                        } else if ("LineString" === this.type || "MultiPoint" === this.type) for(e = 0; e < t.coordinates.length; e++){
                            var o = {
                                type: "Polygon",
                                coordinates: t.coordinates[e]
                            };
                            return !!this.within(o);
                        }
                        else {
                            if ("MultiLineString" === this.type) {
                                for(e = 0; e < this.coordinates.length; e++)if (!1 === new T(this.coordinates[e]).within(t)) return !1;
                                return !0;
                            }
                            if ("MultiPolygon" === this.type) {
                                for(e = 0; e < t.coordinates.length; e++){
                                    var a = {
                                        type: "Polygon",
                                        coordinates: t.coordinates[e]
                                    };
                                    if (!1 === this.within(a)) return !1;
                                }
                                return !0;
                            }
                        }
                    }
                    return !1;
                }, C.prototype.intersects = function(t) {
                    "Feature" === t.type && (t = t.geometry);
                    var e = new C(t);
                    return !(!this.within(t) && !e.within(this)) || ("Point" !== this.type && "MultiPoint" !== this.type && "Point" !== t.type && "MultiPoint" !== t.type ? E(this.coordinates, t.coordinates) : "Feature" === this.type ? new C(this.geometry).intersects(t) : (function() {
                        var t = Array.prototype.slice.apply(arguments);
                        (0, console.warn) && console.warn.apply(console, t);
                    }("Type " + this.type + " to " + t.type + " intersection is not supported by intersects"), !1));
                }, D.prototype = new C, D.prototype.constructor = D, O.prototype = new C, O.prototype.constructor = O, O.prototype.forEach = function(t) {
                    for(var e = 0; e < this.coordinates.length; e++)t.apply(this, [
                        this.coordinates[e],
                        e,
                        this.coordinates
                    ]);
                    return this;
                }, O.prototype.addPoint = function(t) {
                    return this.coordinates.push(t), this;
                }, O.prototype.insertPoint = function(t, e) {
                    return this.coordinates.splice(e, 0, t), this;
                }, O.prototype.removePoint = function(t) {
                    return "number" == typeof t ? this.coordinates.splice(t, 1) : this.coordinates.splice(this.coordinates.indexOf(t), 1), this;
                }, O.prototype.get = function(t) {
                    return new D(this.coordinates[t]);
                }, T.prototype = new C, T.prototype.constructor = T, T.prototype.addVertex = function(t) {
                    return this.coordinates.push(t), this;
                }, T.prototype.insertVertex = function(t, e) {
                    return this.coordinates.splice(e, 0, t), this;
                }, T.prototype.removeVertex = function(t) {
                    return this.coordinates.splice(t, 1), this;
                }, F.prototype = new C, F.prototype.constructor = F, F.prototype.forEach = function(t) {
                    for(var e = 0; e < this.coordinates.length; e++)t.apply(this, [
                        this.coordinates[e],
                        e,
                        this.coordinates
                    ]);
                }, F.prototype.get = function(t) {
                    return new T(this.coordinates[t]);
                }, P.prototype = new C, P.prototype.constructor = P, P.prototype.addVertex = function(t) {
                    return this.insertVertex(t, this.coordinates[0].length - 1), this;
                }, P.prototype.insertVertex = function(t, e) {
                    return this.coordinates[0].splice(e, 0, t), this;
                }, P.prototype.removeVertex = function(t) {
                    return this.coordinates[0].splice(t, 1), this;
                }, P.prototype.close = function() {
                    this.coordinates = S(this.coordinates);
                }, P.prototype.hasHoles = function() {
                    return this.coordinates.length > 1;
                }, P.prototype.holes = function() {
                    var t = [];
                    if (this.hasHoles()) for(var e = 1; e < this.coordinates.length; e++)t.push(new P([
                        this.coordinates[e]
                    ]));
                    return t;
                }, I.prototype = new C, I.prototype.constructor = I, I.prototype.forEach = function(t) {
                    for(var e = 0; e < this.coordinates.length; e++)t.apply(this, [
                        this.coordinates[e],
                        e,
                        this.coordinates
                    ]);
                }, I.prototype.get = function(t) {
                    return new P(this.coordinates[t]);
                }, I.prototype.close = function() {
                    var t = [];
                    return this.forEach(function(e) {
                        t.push(S(e));
                    }), this.coordinates = t, this;
                }, B.prototype = new C, B.prototype.constructor = B, j.prototype = new C, j.prototype.constructor = j, j.prototype.forEach = function(t) {
                    for(var e = 0; e < this.features.length; e++)t.apply(this, [
                        this.features[e],
                        e,
                        this.features
                    ]);
                }, j.prototype.get = function(t) {
                    var e;
                    return this.forEach(function(r) {
                        r.id === t && (e = r);
                    }), new B(e);
                }, R.prototype = new C, R.prototype.constructor = R, R.prototype.forEach = function(t) {
                    for(var e = 0; e < this.geometries.length; e++)t.apply(this, [
                        this.geometries[e],
                        e,
                        this.geometries
                    ]);
                }, R.prototype.get = function(t) {
                    return new C(this.geometries[t]);
                }, q.prototype = new C, q.prototype.constructor = q, q.prototype.recalculate = function() {
                    return this.geometry = L(this.properties.center, this.properties.radius, this.properties.steps), this;
                }, q.prototype.center = function(t) {
                    return t && (this.properties.center = t, this.recalculate()), this.properties.center;
                }, q.prototype.radius = function(t) {
                    return t && (this.properties.radius = t, this.recalculate()), this.properties.radius;
                }, q.prototype.steps = function(t) {
                    return t && (this.properties.steps = t, this.recalculate()), this.properties.steps;
                }, q.prototype.toJSON = function() {
                    return C.prototype.toJSON.call(this);
                }, t.Primitive = C, t.Point = D, t.MultiPoint = O, t.LineString = T, t.MultiLineString = F, t.Polygon = P, t.MultiPolygon = I, t.Feature = B, t.FeatureCollection = j, t.GeometryCollection = R, t.Circle = q, t.toMercator = p, t.toGeographic = d, t.Tools = {}, t.Tools.positionToMercator = f, t.Tools.positionToGeographic = c, t.Tools.applyConverter = h, t.Tools.toMercator = p, t.Tools.toGeographic = d, t.Tools.createCircle = L, t.Tools.calculateBounds = i, t.Tools.calculateEnvelope = s, t.Tools.coordinatesContainPoint = x, t.Tools.polygonContainsPoint = w, t.Tools.arraysIntersectArrays = E, t.Tools.coordinatesContainPoint = x, t.Tools.coordinatesEqual = k, t.Tools.convexHull = b, t.Tools.isConvex = function(t) {
                    for(var e, r = 0; r < t.length - 3; r++){
                        var n = t[r], i = t[r + 1], o = t[r + 2], a = [
                            i[0] - n[0],
                            i[1] - n[1]
                        ], s = o[0] * a[1] - o[1] * a[0] + a[0] * n[1] - a[1] * n[0];
                        if (0 === r) e = s < 0;
                        else if (e && s > 0 || !e && s < 0) return !1;
                    }
                    return !0;
                }, t.MercatorCRS = e, t.GeographicCRS = {
                    type: "link",
                    properties: {
                        href: "http://spatialreference.org/ref/epsg/4326/ogcwkt/",
                        type: "ogcwkt"
                    }
                }, t;
            }, "object" == typeof t.exports && (t.exports = i()), "object" == typeof window && (n.Terraformer = i());
        },
        function(t, e, r) {
            (function(t, n) {
                var i; /*! https://mths.be/punycode v1.4.1 by @mathias */ 
                !function(o) {
                    e && e.nodeType, t && t.nodeType;
                    var a = "object" == typeof n && n;
                    a.global !== a && a.window !== a && a.self;
                    var s, u = 2147483647, l = /^xn--/, c = /[^\x20-\x7E]/, f = /[\x2E\u3002\uFF0E\uFF61]/g, h = {
                        overflow: "Overflow: input needs wider integers to process",
                        "not-basic": "Illegal input >= 0x80 (not a basic code point)",
                        "invalid-input": "Invalid input"
                    }, p = Math.floor, d = String.fromCharCode;
                    function m(t) {
                        throw new RangeError(h[t]);
                    }
                    function y(t, e) {
                        for(var r = t.length, n = []; r--;)n[r] = e(t[r]);
                        return n;
                    }
                    function g(t, e) {
                        var r = t.split("@"), n = "";
                        return r.length > 1 && (n = r[0] + "@", t = r[1]), n + y((t = t.replace(f, ".")).split("."), e).join(".");
                    }
                    function v(t) {
                        for(var e, r, n = [], i = 0, o = t.length; i < o;)(e = t.charCodeAt(i++)) >= 55296 && e <= 56319 && i < o ? 56320 == (64512 & (r = t.charCodeAt(i++))) ? n.push(((1023 & e) << 10) + (1023 & r) + 65536) : (n.push(e), i--) : n.push(e);
                        return n;
                    }
                    function b(t) {
                        return y(t, function(t) {
                            var e = "";
                            return t > 65535 && (e += d((t -= 65536) >>> 10 & 1023 | 55296), t = 56320 | 1023 & t), e += d(t);
                        }).join("");
                    }
                    function x(t, e) {
                        return t + 22 + 75 * (t < 26) - ((0 != e) << 5);
                    }
                    function w(t, e, r) {
                        var n = 0;
                        for(t = r ? p(t / 700) : t >> 1, t += p(t / e); t > 455; n += 36)t = p(t / 35);
                        return p(n + 36 * t / (t + 38));
                    }
                    function _(t) {
                        var e, r, n, i, o, a, s, l, c, f, h, d = [], y = t.length, g = 0, v = 128, x = 72;
                        for((r = t.lastIndexOf("-")) < 0 && (r = 0), n = 0; n < r; ++n)t.charCodeAt(n) >= 128 && m("not-basic"), d.push(t.charCodeAt(n));
                        for(i = r > 0 ? r + 1 : 0; i < y;){
                            for(o = g, a = 1, s = 36; i >= y && m("invalid-input"), ((l = (h = t.charCodeAt(i++)) - 48 < 10 ? h - 22 : h - 65 < 26 ? h - 65 : h - 97 < 26 ? h - 97 : 36) >= 36 || l > p((u - g) / a)) && m("overflow"), g += l * a, !(l < (c = s <= x ? 1 : s >= x + 26 ? 26 : s - x)); s += 36)a > p(u / (f = 36 - c)) && m("overflow"), a *= f;
                            x = w(g - o, e = d.length + 1, 0 == o), p(g / e) > u - v && m("overflow"), v += p(g / e), g %= e, d.splice(g++, 0, v);
                        }
                        return b(d);
                    }
                    function A(t) {
                        var e, r, n, i, o, a, s, l, c, f, h, y, g, b, _, A = [];
                        for(y = (t = v(t)).length, e = 128, r = 0, o = 72, a = 0; a < y; ++a)(h = t[a]) < 128 && A.push(d(h));
                        for(n = i = A.length, i && A.push("-"); n < y;){
                            for(s = u, a = 0; a < y; ++a)(h = t[a]) >= e && h < s && (s = h);
                            for(s - e > p((u - r) / (g = n + 1)) && m("overflow"), r += (s - e) * g, e = s, a = 0; a < y; ++a)if ((h = t[a]) < e && ++r > u && m("overflow"), h == e) {
                                for(l = r, c = 36; !(l < (f = c <= o ? 1 : c >= o + 26 ? 26 : c - o)); c += 36)_ = l - f, b = 36 - f, A.push(d(x(f + _ % b, 0))), l = p(_ / b);
                                A.push(d(x(l, 0))), o = w(r, g, n == i), r = 0, ++n;
                            }
                            ++r, ++e;
                        }
                        return A.join("");
                    }
                    s = {
                        version: "1.4.1",
                        ucs2: {
                            decode: v,
                            encode: b
                        },
                        decode: _,
                        encode: A,
                        toASCII: function(t) {
                            return g(t, function(t) {
                                return c.test(t) ? "xn--" + A(t) : t;
                            });
                        },
                        toUnicode: function(t) {
                            return g(t, function(t) {
                                return l.test(t) ? _(t.slice(4).toLowerCase()) : t;
                            });
                        }
                    }, void 0 === (i = (function() {
                        return s;
                    }).call(e, r, e, t)) || (t.exports = i);
                }();
            }).call(this, r(31)(t), r(46));
        },
        function(t, e, r) {
            "use strict";
            var n = r(192), i = r(211), o = r(74);
            t.exports = {
                formats: o,
                parse: i,
                stringify: n
            };
        },
        function(t, e, r) {
            "use strict";
            var n = r(193), i = r(113), o = r(74), a = Object.prototype.hasOwnProperty, s = {
                brackets: function(t) {
                    return t + "[]";
                },
                comma: "comma",
                indices: function(t, e) {
                    return t + "[" + e + "]";
                },
                repeat: function(t) {
                    return t;
                }
            }, u = Array.isArray, l = Array.prototype.push, c = function(t, e) {
                l.apply(t, u(e) ? e : [
                    e
                ]);
            }, f = Date.prototype.toISOString, h = o.default, p = {
                addQueryPrefix: !1,
                allowDots: !1,
                allowEmptyArrays: !1,
                arrayFormat: "indices",
                charset: "utf-8",
                charsetSentinel: !1,
                delimiter: "&",
                encode: !0,
                encodeDotInKeys: !1,
                encoder: i.encode,
                encodeValuesOnly: !1,
                format: h,
                formatter: o.formatters[h],
                indices: !1,
                serializeDate: function(t) {
                    return f.call(t);
                },
                skipNulls: !1,
                strictNullHandling: !1
            }, d = {}, m = function t(e, r, o, a, s, l, f, h, m, y, g, v, b, x, w, _, A, E) {
                for(var S, M = e, k = E, N = 0, C = !1; void 0 !== (k = k.get(d)) && !C;){
                    var D = k.get(e);
                    if (N += 1, void 0 !== D) {
                        if (D === N) throw new RangeError("Cyclic object value");
                        C = !0;
                    }
                    void 0 === k.get(d) && (N = 0);
                }
                if ("function" == typeof y ? M = y(r, M) : M instanceof Date ? M = b(M) : "comma" === o && u(M) && (M = i.maybeMap(M, function(t) {
                    return t instanceof Date ? b(t) : t;
                })), null === M) {
                    if (l) return m && !_ ? m(r, p.encoder, A, "key", x) : r;
                    M = "";
                }
                if ("string" == typeof (S = M) || "number" == typeof S || "boolean" == typeof S || "symbol" == typeof S || "bigint" == typeof S || i.isBuffer(M)) return m ? [
                    w(_ ? r : m(r, p.encoder, A, "key", x)) + "=" + w(m(M, p.encoder, A, "value", x))
                ] : [
                    w(r) + "=" + w(String(M))
                ];
                var O, T = [];
                if (void 0 === M) return T;
                if ("comma" === o && u(M)) _ && m && (M = i.maybeMap(M, m)), O = [
                    {
                        value: M.length > 0 ? M.join(",") || null : void 0
                    }
                ];
                else if (u(y)) O = y;
                else {
                    var F = Object.keys(M);
                    O = g ? F.sort(g) : F;
                }
                var P = h ? r.replace(/\./g, "%2E") : r, I = a && u(M) && 1 === M.length ? P + "[]" : P;
                if (s && u(M) && 0 === M.length) return I + "[]";
                for(var B = 0; B < O.length; ++B){
                    var j = O[B], R = "object" == typeof j && void 0 !== j.value ? j.value : M[j];
                    if (!f || null !== R) {
                        var L = v && h ? j.replace(/\./g, "%2E") : j, q = u(M) ? "function" == typeof o ? o(I, L) : I : I + (v ? "." + L : "[" + L + "]");
                        E.set(e, N);
                        var U = n();
                        U.set(d, E), c(T, t(R, q, o, a, s, l, f, h, "comma" === o && _ && u(M) ? null : m, y, g, v, b, x, w, _, A, U));
                    }
                }
                return T;
            };
            t.exports = function(t, e) {
                var r, i = t, l = function(t) {
                    if (!t) return p;
                    if (void 0 !== t.allowEmptyArrays && "boolean" != typeof t.allowEmptyArrays) throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
                    if (void 0 !== t.encodeDotInKeys && "boolean" != typeof t.encodeDotInKeys) throw new TypeError("`encodeDotInKeys` option can only be `true` or `false`, when provided");
                    if (null !== t.encoder && void 0 !== t.encoder && "function" != typeof t.encoder) throw new TypeError("Encoder has to be a function.");
                    var e = t.charset || p.charset;
                    if (void 0 !== t.charset && "utf-8" !== t.charset && "iso-8859-1" !== t.charset) throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
                    var r = o.default;
                    if (void 0 !== t.format) {
                        if (!a.call(o.formatters, t.format)) throw new TypeError("Unknown format option provided.");
                        r = t.format;
                    }
                    var n, i = o.formatters[r], l = p.filter;
                    if (("function" == typeof t.filter || u(t.filter)) && (l = t.filter), n = t.arrayFormat in s ? t.arrayFormat : "indices" in t ? t.indices ? "indices" : "repeat" : p.arrayFormat, "commaRoundTrip" in t && "boolean" != typeof t.commaRoundTrip) throw new TypeError("`commaRoundTrip` must be a boolean, or absent");
                    var c = void 0 === t.allowDots ? !0 === t.encodeDotInKeys || p.allowDots : !!t.allowDots;
                    return {
                        addQueryPrefix: "boolean" == typeof t.addQueryPrefix ? t.addQueryPrefix : p.addQueryPrefix,
                        allowDots: c,
                        allowEmptyArrays: "boolean" == typeof t.allowEmptyArrays ? !!t.allowEmptyArrays : p.allowEmptyArrays,
                        arrayFormat: n,
                        charset: e,
                        charsetSentinel: "boolean" == typeof t.charsetSentinel ? t.charsetSentinel : p.charsetSentinel,
                        commaRoundTrip: t.commaRoundTrip,
                        delimiter: void 0 === t.delimiter ? p.delimiter : t.delimiter,
                        encode: "boolean" == typeof t.encode ? t.encode : p.encode,
                        encodeDotInKeys: "boolean" == typeof t.encodeDotInKeys ? t.encodeDotInKeys : p.encodeDotInKeys,
                        encoder: "function" == typeof t.encoder ? t.encoder : p.encoder,
                        encodeValuesOnly: "boolean" == typeof t.encodeValuesOnly ? t.encodeValuesOnly : p.encodeValuesOnly,
                        filter: l,
                        format: r,
                        formatter: i,
                        serializeDate: "function" == typeof t.serializeDate ? t.serializeDate : p.serializeDate,
                        skipNulls: "boolean" == typeof t.skipNulls ? t.skipNulls : p.skipNulls,
                        sort: "function" == typeof t.sort ? t.sort : null,
                        strictNullHandling: "boolean" == typeof t.strictNullHandling ? t.strictNullHandling : p.strictNullHandling
                    };
                }(e);
                "function" == typeof l.filter ? i = (0, l.filter)("", i) : u(l.filter) && (r = l.filter);
                var f = [];
                if ("object" != typeof i || null === i) return "";
                var h = s[l.arrayFormat], d = "comma" === h && l.commaRoundTrip;
                r || (r = Object.keys(i)), l.sort && r.sort(l.sort);
                for(var y = n(), g = 0; g < r.length; ++g){
                    var v = r[g];
                    l.skipNulls && null === i[v] || c(f, m(i[v], v, h, d, l.allowEmptyArrays, l.strictNullHandling, l.skipNulls, l.encodeDotInKeys, l.encode ? l.encoder : null, l.filter, l.sort, l.allowDots, l.serializeDate, l.format, l.formatter, l.encodeValuesOnly, l.charset, y));
                }
                var b = f.join(l.delimiter), x = !0 === l.addQueryPrefix ? "?" : "";
                return l.charsetSentinel && ("iso-8859-1" === l.charset ? x += "utf8=%26%2310003%3B&" : x += "utf8=%E2%9C%93&"), b.length > 0 ? x + b : "";
            };
        },
        function(t, e, r) {
            "use strict";
            var n = r(36), i = r(204), o = r(209), a = r(47), s = n("%WeakMap%", !0), u = n("%Map%", !0), l = i("WeakMap.prototype.get", !0), c = i("WeakMap.prototype.set", !0), f = i("WeakMap.prototype.has", !0), h = i("Map.prototype.get", !0), p = i("Map.prototype.set", !0), d = i("Map.prototype.has", !0), m = function(t, e) {
                for(var r, n = t; null !== (r = n.next); n = r)if (r.key === e) return n.next = r.next, r.next = t.next, t.next = r, r;
            };
            t.exports = function() {
                var t, e, r, n = {
                    assert: function(t) {
                        if (!n.has(t)) throw new a("Side channel does not contain " + o(t));
                    },
                    get: function(n) {
                        if (s && n && ("object" == typeof n || "function" == typeof n)) {
                            if (t) return l(t, n);
                        } else if (u) {
                            if (e) return h(e, n);
                        } else if (r) return function(t, e) {
                            var r = m(t, e);
                            return r && r.value;
                        }(r, n);
                    },
                    has: function(n) {
                        if (s && n && ("object" == typeof n || "function" == typeof n)) {
                            if (t) return f(t, n);
                        } else if (u) {
                            if (e) return d(e, n);
                        } else if (r) return function(t, e) {
                            return !!m(t, e);
                        }(r, n);
                        return !1;
                    },
                    set: function(n, i) {
                        s && n && ("object" == typeof n || "function" == typeof n) ? (t || (t = new s), c(t, n, i)) : u ? (e || (e = new u), p(e, n, i)) : (r || (r = {
                            key: {},
                            next: null
                        }), function(t, e, r) {
                            var n = m(t, e);
                            n ? n.value = r : t.next = {
                                key: e,
                                next: t.next,
                                value: r
                            };
                        }(r, n, i));
                    }
                };
                return n;
            };
        },
        function(t, e, r) {
            "use strict";
            t.exports = Error;
        },
        function(t, e, r) {
            "use strict";
            t.exports = EvalError;
        },
        function(t, e, r) {
            "use strict";
            t.exports = RangeError;
        },
        function(t, e, r) {
            "use strict";
            t.exports = ReferenceError;
        },
        function(t, e, r) {
            "use strict";
            t.exports = URIError;
        },
        function(t, e, r) {
            "use strict";
            var n = "undefined" != typeof Symbol && Symbol, i = r(200);
            t.exports = function() {
                return "function" == typeof n && "function" == typeof Symbol && "symbol" == typeof n("foo") && "symbol" == typeof Symbol("bar") && i();
            };
        },
        function(t, e, r) {
            "use strict";
            t.exports = function() {
                if ("function" != typeof Symbol || "function" != typeof Object.getOwnPropertySymbols) return !1;
                if ("symbol" == typeof Symbol.iterator) return !0;
                var t = {}, e = Symbol("test"), r = Object(e);
                if ("string" == typeof e) return !1;
                if ("[object Symbol]" !== Object.prototype.toString.call(e)) return !1;
                if ("[object Symbol]" !== Object.prototype.toString.call(r)) return !1;
                for(e in t[e] = 42, t)return !1;
                if ("function" == typeof Object.keys && 0 !== Object.keys(t).length) return !1;
                if ("function" == typeof Object.getOwnPropertyNames && 0 !== Object.getOwnPropertyNames(t).length) return !1;
                var n = Object.getOwnPropertySymbols(t);
                if (1 !== n.length || n[0] !== e) return !1;
                if (!Object.prototype.propertyIsEnumerable.call(t, e)) return !1;
                if ("function" == typeof Object.getOwnPropertyDescriptor) {
                    var i = Object.getOwnPropertyDescriptor(t, e);
                    if (42 !== i.value || !0 !== i.enumerable) return !1;
                }
                return !0;
            };
        },
        function(t, e, r) {
            "use strict";
            var n = {
                __proto__: null,
                foo: {}
            }, i = Object;
            t.exports = function() {
                return ({
                    __proto__: n
                }).foo === n.foo && !(n instanceof i);
            };
        },
        function(t, e, r) {
            "use strict";
            var n = "Function.prototype.bind called on incompatible ", i = Object.prototype.toString, o = Math.max, a = function(t, e) {
                for(var r = [], n = 0; n < t.length; n += 1)r[n] = t[n];
                for(var i = 0; i < e.length; i += 1)r[i + t.length] = e[i];
                return r;
            }, s = function(t, e) {
                for(var r = [], n = e || 0, i = 0; n < t.length; n += 1, i += 1)r[i] = t[n];
                return r;
            }, u = function(t, e) {
                for(var r = "", n = 0; n < t.length; n += 1)r += t[n], n + 1 < t.length && (r += e);
                return r;
            };
            t.exports = function(t) {
                var e = this;
                if ("function" != typeof e || "[object Function]" !== i.apply(e)) throw new TypeError(n + e);
                for(var r, l = s(arguments, 1), c = function() {
                    if (this instanceof r) {
                        var n = e.apply(this, a(l, arguments));
                        return Object(n) === n ? n : this;
                    }
                    return e.apply(t, a(l, arguments));
                }, f = o(0, e.length - l.length), h = [], p = 0; p < f; p++)h[p] = "$" + p;
                if (r = Function("binder", "return function (" + u(h, ",") + "){ return binder.apply(this,arguments); }")(c), e.prototype) {
                    var d = function() {};
                    d.prototype = e.prototype, r.prototype = new d, d.prototype = null;
                }
                return r;
            };
        },
        function(t, e, r) {
            "use strict";
            var n = Function.prototype.call, i = Object.prototype.hasOwnProperty, o = r(72);
            t.exports = o.call(n, i);
        },
        function(t, e, r) {
            "use strict";
            var n = r(36), i = r(205), o = i(n("String.prototype.indexOf"));
            t.exports = function(t, e) {
                var r = n(t, !!e);
                return "function" == typeof r && o(t, ".prototype.") > -1 ? i(r) : r;
            };
        },
        function(t, e, r) {
            "use strict";
            var n = r(72), i = r(36), o = r(206), a = r(47), s = i("%Function.prototype.apply%"), u = i("%Function.prototype.call%"), l = i("%Reflect.apply%", !0) || n.call(u, s), c = r(73), f = i("%Math.max%");
            t.exports = function(t) {
                if ("function" != typeof t) throw new a("a function is required");
                var e = l(n, u, arguments);
                return o(e, 1 + f(0, t.length - (arguments.length - 1)), !0);
            };
            var h = function() {
                return l(n, s, arguments);
            };
            c ? c(t.exports, "apply", {
                value: h
            }) : t.exports.apply = h;
        },
        function(t, e, r) {
            "use strict";
            var n = r(36), i = r(207), o = r(208)(), a = r(112), s = r(47), u = n("%Math.floor%");
            t.exports = function(t, e) {
                if ("function" != typeof t) throw new s("`fn` is not a function");
                if ("number" != typeof e || e < 0 || e > 4294967295 || u(e) !== e) throw new s("`length` must be a positive 32-bit integer");
                var r = arguments.length > 2 && !!arguments[2], n = !0, l = !0;
                if ("length" in t && a) {
                    var c = a(t, "length");
                    c && !c.configurable && (n = !1), c && !c.writable && (l = !1);
                }
                return (n || l || !r) && (o ? i(t, "length", e, !0, !0) : i(t, "length", e)), t;
            };
        },
        function(t, e, r) {
            "use strict";
            var n = r(73), i = r(111), o = r(47), a = r(112);
            t.exports = function(t, e, r) {
                if (!t || "object" != typeof t && "function" != typeof t) throw new o("`obj` must be an object or a function`");
                if ("string" != typeof e && "symbol" != typeof e) throw new o("`property` must be a string or a symbol`");
                if (arguments.length > 3 && "boolean" != typeof arguments[3] && null !== arguments[3]) throw new o("`nonEnumerable`, if provided, must be a boolean or null");
                if (arguments.length > 4 && "boolean" != typeof arguments[4] && null !== arguments[4]) throw new o("`nonWritable`, if provided, must be a boolean or null");
                if (arguments.length > 5 && "boolean" != typeof arguments[5] && null !== arguments[5]) throw new o("`nonConfigurable`, if provided, must be a boolean or null");
                if (arguments.length > 6 && "boolean" != typeof arguments[6]) throw new o("`loose`, if provided, must be a boolean");
                var s = arguments.length > 3 ? arguments[3] : null, u = arguments.length > 4 ? arguments[4] : null, l = arguments.length > 5 ? arguments[5] : null, c = arguments.length > 6 && arguments[6], f = !!a && a(t, e);
                if (n) n(t, e, {
                    configurable: null === l && f ? f.configurable : !l,
                    enumerable: null === s && f ? f.enumerable : !s,
                    value: r,
                    writable: null === u && f ? f.writable : !u
                });
                else {
                    if (!c && (s || u || l)) throw new i("This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.");
                    t[e] = r;
                }
            };
        },
        function(t, e, r) {
            "use strict";
            var n = r(73), i = function() {
                return !!n;
            };
            i.hasArrayLengthDefineBug = function() {
                if (!n) return null;
                try {
                    return 1 !== n([], "length", {
                        value: 1
                    }).length;
                } catch (t) {
                    return !0;
                }
            }, t.exports = i;
        },
        function(t, e, r) {
            (function(e) {
                var n = "function" == typeof Map && Map.prototype, i = Object.getOwnPropertyDescriptor && n ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null, o = n && i && "function" == typeof i.get ? i.get : null, a = n && Map.prototype.forEach, s = "function" == typeof Set && Set.prototype, u = Object.getOwnPropertyDescriptor && s ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null, l = s && u && "function" == typeof u.get ? u.get : null, c = s && Set.prototype.forEach, f = "function" == typeof WeakMap && WeakMap.prototype ? WeakMap.prototype.has : null, h = "function" == typeof WeakSet && WeakSet.prototype ? WeakSet.prototype.has : null, p = "function" == typeof WeakRef && WeakRef.prototype ? WeakRef.prototype.deref : null, d = Boolean.prototype.valueOf, m = Object.prototype.toString, y = Function.prototype.toString, g = String.prototype.match, v = String.prototype.slice, b = String.prototype.replace, x = String.prototype.toUpperCase, w = String.prototype.toLowerCase, _ = RegExp.prototype.test, A = Array.prototype.concat, E = Array.prototype.join, S = Array.prototype.slice, M = Math.floor, k = "function" == typeof BigInt ? BigInt.prototype.valueOf : null, N = Object.getOwnPropertySymbols, C = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? Symbol.prototype.toString : null, D = "function" == typeof Symbol && "object" == typeof Symbol.iterator, O = "function" == typeof Symbol && Symbol.toStringTag && (typeof Symbol.toStringTag === D || "symbol") ? Symbol.toStringTag : null, T = Object.prototype.propertyIsEnumerable, F = ("function" == typeof Reflect ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype ? function(t) {
                    return t.__proto__;
                } : null);
                function P(t, e) {
                    if (t === 1 / 0 || t === -1 / 0 || t != t || t && t > -1000 && t < 1e3 || _.call(/e/, e)) return e;
                    var r = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
                    if ("number" == typeof t) {
                        var n = t < 0 ? -M(-t) : M(t);
                        if (n !== t) {
                            var i = String(n), o = v.call(e, i.length + 1);
                            return b.call(i, r, "$&_") + "." + b.call(b.call(o, /([0-9]{3})/g, "$&_"), /_$/, "");
                        }
                    }
                    return b.call(e, r, "$&_");
                }
                var I = r(210), B = I.custom, j = z(B) ? B : null;
                function R(t, e, r) {
                    var n = "double" === (r.quoteStyle || e) ? '"' : "'";
                    return n + t + n;
                }
                function L(t) {
                    return b.call(String(t), /"/g, "&quot;");
                }
                function q(t) {
                    return !("[object Array]" !== W(t) || O && "object" == typeof t && O in t);
                }
                function U(t) {
                    return !("[object RegExp]" !== W(t) || O && "object" == typeof t && O in t);
                }
                function z(t) {
                    if (D) return t && "object" == typeof t && t instanceof Symbol;
                    if ("symbol" == typeof t) return !0;
                    if (!t || "object" != typeof t || !C) return !1;
                    try {
                        return C.call(t), !0;
                    } catch (t) {}
                    return !1;
                }
                t.exports = function t(r, n, i, s) {
                    var u = n || {};
                    if (H(u, "quoteStyle") && "single" !== u.quoteStyle && "double" !== u.quoteStyle) throw new TypeError('option "quoteStyle" must be "single" or "double"');
                    if (H(u, "maxStringLength") && ("number" == typeof u.maxStringLength ? u.maxStringLength < 0 && u.maxStringLength !== 1 / 0 : null !== u.maxStringLength)) throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
                    var m = !H(u, "customInspect") || u.customInspect;
                    if ("boolean" != typeof m && "symbol" !== m) throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
                    if (H(u, "indent") && null !== u.indent && "	" !== u.indent && !(parseInt(u.indent, 10) === u.indent && u.indent > 0)) throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
                    if (H(u, "numericSeparator") && "boolean" != typeof u.numericSeparator) throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
                    var x = u.numericSeparator;
                    if (void 0 === r) return "undefined";
                    if (null === r) return "null";
                    if ("boolean" == typeof r) return r ? "true" : "false";
                    if ("string" == typeof r) return function t(e, r) {
                        if (e.length > r.maxStringLength) {
                            var n = e.length - r.maxStringLength, i = "... " + n + " more character" + (n > 1 ? "s" : "");
                            return t(v.call(e, 0, r.maxStringLength), r) + i;
                        }
                        return R(b.call(b.call(e, /(['\\])/g, "\\$1"), /[\x00-\x1f]/g, V), "single", r);
                    }(r, u);
                    if ("number" == typeof r) {
                        if (0 === r) return 1 / 0 / r > 0 ? "0" : "-0";
                        var _ = String(r);
                        return x ? P(r, _) : _;
                    }
                    if ("bigint" == typeof r) {
                        var M = String(r) + "n";
                        return x ? P(r, M) : M;
                    }
                    var N = void 0 === u.depth ? 5 : u.depth;
                    if (void 0 === i && (i = 0), i >= N && N > 0 && "object" == typeof r) return q(r) ? "[Array]" : "[Object]";
                    var B = function(t, e) {
                        var r;
                        if ("	" === t.indent) r = "	";
                        else {
                            if (!("number" == typeof t.indent && t.indent > 0)) return null;
                            r = E.call(Array(t.indent + 1), " ");
                        }
                        return {
                            base: r,
                            prev: E.call(Array(e + 1), r)
                        };
                    }(u, i);
                    if (void 0 === s) s = [];
                    else if ($(s, r) >= 0) return "[Circular]";
                    function G(e, r, n) {
                        if (r && (s = S.call(s)).push(r), n) {
                            var o = {
                                depth: u.depth
                            };
                            return H(u, "quoteStyle") && (o.quoteStyle = u.quoteStyle), t(e, o, i + 1, s);
                        }
                        return t(e, u, i + 1, s);
                    }
                    if ("function" == typeof r && !U(r)) {
                        var Q = function(t) {
                            if (t.name) return t.name;
                            var e = g.call(y.call(t), /^function\s*([\w$]+)/);
                            if (e) return e[1];
                            return null;
                        }(r), tt = J(r, G);
                        return "[Function" + (Q ? ": " + Q : " (anonymous)") + "]" + (tt.length > 0 ? " { " + E.call(tt, ", ") + " }" : "");
                    }
                    if (z(r)) {
                        var et = D ? b.call(String(r), /^(Symbol\(.*\))_[^)]*$/, "$1") : C.call(r);
                        return "object" != typeof r || D ? et : Z(et);
                    }
                    if (function(t) {
                        if (!t || "object" != typeof t) return !1;
                        if ("undefined" != typeof HTMLElement && t instanceof HTMLElement) return !0;
                        return "string" == typeof t.nodeName && "function" == typeof t.getAttribute;
                    }(r)) {
                        for(var rt = "<" + w.call(String(r.nodeName)), nt = r.attributes || [], it = 0; it < nt.length; it++)rt += " " + nt[it].name + "=" + R(L(nt[it].value), "double", u);
                        return rt += ">", r.childNodes && r.childNodes.length && (rt += "..."), rt += "</" + w.call(String(r.nodeName)) + ">";
                    }
                    if (q(r)) {
                        if (0 === r.length) return "[]";
                        var ot = J(r, G);
                        return B && !function(t) {
                            for(var e = 0; e < t.length; e++)if ($(t[e], "\n") >= 0) return !1;
                            return !0;
                        }(ot) ? "[" + X(ot, B) + "]" : "[ " + E.call(ot, ", ") + " ]";
                    }
                    if (function(t) {
                        return !("[object Error]" !== W(t) || O && "object" == typeof t && O in t);
                    }(r)) {
                        var at = J(r, G);
                        return "cause" in Error.prototype || !("cause" in r) || T.call(r, "cause") ? 0 === at.length ? "[" + String(r) + "]" : "{ [" + String(r) + "] " + E.call(at, ", ") + " }" : "{ [" + String(r) + "] " + E.call(A.call("[cause]: " + G(r.cause), at), ", ") + " }";
                    }
                    if ("object" == typeof r && m) {
                        if (j && "function" == typeof r[j] && I) return I(r, {
                            depth: N - i
                        });
                        if ("symbol" !== m && "function" == typeof r.inspect) return r.inspect();
                    }
                    if (function(t) {
                        if (!o || !t || "object" != typeof t) return !1;
                        try {
                            o.call(t);
                            try {
                                l.call(t);
                            } catch (t) {
                                return !0;
                            }
                            return t instanceof Map;
                        } catch (t) {}
                        return !1;
                    }(r)) {
                        var st = [];
                        return a && a.call(r, function(t, e) {
                            st.push(G(e, r, !0) + " => " + G(t, r));
                        }), K("Map", o.call(r), st, B);
                    }
                    if (function(t) {
                        if (!l || !t || "object" != typeof t) return !1;
                        try {
                            l.call(t);
                            try {
                                o.call(t);
                            } catch (t) {
                                return !0;
                            }
                            return t instanceof Set;
                        } catch (t) {}
                        return !1;
                    }(r)) {
                        var ut = [];
                        return c && c.call(r, function(t) {
                            ut.push(G(t, r));
                        }), K("Set", l.call(r), ut, B);
                    }
                    if (function(t) {
                        if (!f || !t || "object" != typeof t) return !1;
                        try {
                            f.call(t, f);
                            try {
                                h.call(t, h);
                            } catch (t) {
                                return !0;
                            }
                            return t instanceof WeakMap;
                        } catch (t) {}
                        return !1;
                    }(r)) return Y("WeakMap");
                    if (function(t) {
                        if (!h || !t || "object" != typeof t) return !1;
                        try {
                            h.call(t, h);
                            try {
                                f.call(t, f);
                            } catch (t) {
                                return !0;
                            }
                            return t instanceof WeakSet;
                        } catch (t) {}
                        return !1;
                    }(r)) return Y("WeakSet");
                    if (function(t) {
                        if (!p || !t || "object" != typeof t) return !1;
                        try {
                            return p.call(t), !0;
                        } catch (t) {}
                        return !1;
                    }(r)) return Y("WeakRef");
                    if (function(t) {
                        return !("[object Number]" !== W(t) || O && "object" == typeof t && O in t);
                    }(r)) return Z(G(Number(r)));
                    if (function(t) {
                        if (!t || "object" != typeof t || !k) return !1;
                        try {
                            return k.call(t), !0;
                        } catch (t) {}
                        return !1;
                    }(r)) return Z(G(k.call(r)));
                    if (function(t) {
                        return !("[object Boolean]" !== W(t) || O && "object" == typeof t && O in t);
                    }(r)) return Z(d.call(r));
                    if (function(t) {
                        return !("[object String]" !== W(t) || O && "object" == typeof t && O in t);
                    }(r)) return Z(G(String(r)));
                    if ("undefined" != typeof window && r === window) return "{ [object Window] }";
                    if ("undefined" != typeof globalThis && r === globalThis || void 0 !== e && r === e) return "{ [object globalThis] }";
                    if (!function(t) {
                        return !("[object Date]" !== W(t) || O && "object" == typeof t && O in t);
                    }(r) && !U(r)) {
                        var lt = J(r, G), ct = F ? F(r) === Object.prototype : r instanceof Object || r.constructor === Object, ft = r instanceof Object ? "" : "null prototype", ht = !ct && O && Object(r) === r && O in r ? v.call(W(r), 8, -1) : ft ? "Object" : "", pt = (ct || "function" != typeof r.constructor ? "" : r.constructor.name ? r.constructor.name + " " : "") + (ht || ft ? "[" + E.call(A.call([], ht || [], ft || []), ": ") + "] " : "");
                        return 0 === lt.length ? pt + "{}" : B ? pt + "{" + X(lt, B) + "}" : pt + "{ " + E.call(lt, ", ") + " }";
                    }
                    return String(r);
                };
                var G = Object.prototype.hasOwnProperty || function(t) {
                    return t in this;
                };
                function H(t, e) {
                    return G.call(t, e);
                }
                function W(t) {
                    return m.call(t);
                }
                function $(t, e) {
                    if (t.indexOf) return t.indexOf(e);
                    for(var r = 0, n = t.length; r < n; r++)if (t[r] === e) return r;
                    return -1;
                }
                function V(t) {
                    var e = t.charCodeAt(0), r = {
                        8: "b",
                        9: "t",
                        10: "n",
                        12: "f",
                        13: "r"
                    }[e];
                    return r ? "\\" + r : "\\x" + (e < 16 ? "0" : "") + x.call(e.toString(16));
                }
                function Z(t) {
                    return "Object(" + t + ")";
                }
                function Y(t) {
                    return t + " { ? }";
                }
                function K(t, e, r, n) {
                    return t + " (" + e + ") {" + (n ? X(r, n) : E.call(r, ", ")) + "}";
                }
                function X(t, e) {
                    if (0 === t.length) return "";
                    var r = "\n" + e.prev + e.base;
                    return r + E.call(t, "," + r) + "\n" + e.prev;
                }
                function J(t, e) {
                    var r = q(t), n = [];
                    if (r) {
                        n.length = t.length;
                        for(var i = 0; i < t.length; i++)n[i] = H(t, i) ? e(t[i], t) : "";
                    }
                    var o, a = "function" == typeof N ? N(t) : [];
                    if (D) {
                        o = {};
                        for(var s = 0; s < a.length; s++)o["$" + a[s]] = a[s];
                    }
                    for(var u in t)H(t, u) && (r && String(Number(u)) === u && u < t.length || D && o["$" + u] instanceof Symbol || (_.call(/[^\w$]/, u) ? n.push(e(u, t) + ": " + e(t[u], t)) : n.push(u + ": " + e(t[u], t))));
                    if ("function" == typeof N) for(var l = 0; l < a.length; l++)T.call(t, a[l]) && n.push("[" + e(a[l]) + "]: " + e(t[a[l]], t));
                    return n;
                }
            }).call(this, r(46));
        },
        function(t, e) {},
        function(t, e, r) {
            "use strict";
            var n = r(113), i = Object.prototype.hasOwnProperty, o = Array.isArray, a = {
                allowDots: !1,
                allowEmptyArrays: !1,
                allowPrototypes: !1,
                allowSparse: !1,
                arrayLimit: 20,
                charset: "utf-8",
                charsetSentinel: !1,
                comma: !1,
                decodeDotInKeys: !1,
                decoder: n.decode,
                delimiter: "&",
                depth: 5,
                duplicates: "combine",
                ignoreQueryPrefix: !1,
                interpretNumericEntities: !1,
                parameterLimit: 1e3,
                parseArrays: !0,
                plainObjects: !1,
                strictNullHandling: !1
            }, s = function(t) {
                return t.replace(/&#(\d+);/g, function(t, e) {
                    return String.fromCharCode(parseInt(e, 10));
                });
            }, u = function(t, e) {
                return t && "string" == typeof t && e.comma && t.indexOf(",") > -1 ? t.split(",") : t;
            }, l = function(t, e, r, n) {
                if (t) {
                    var o = r.allowDots ? t.replace(/\.([^.[]+)/g, "[$1]") : t, a = /(\[[^[\]]*])/g, s = r.depth > 0 && /(\[[^[\]]*])/.exec(o), l = s ? o.slice(0, s.index) : o, c = [];
                    if (l) {
                        if (!r.plainObjects && i.call(Object.prototype, l) && !r.allowPrototypes) return;
                        c.push(l);
                    }
                    for(var f = 0; r.depth > 0 && null !== (s = a.exec(o)) && f < r.depth;){
                        if (f += 1, !r.plainObjects && i.call(Object.prototype, s[1].slice(1, -1)) && !r.allowPrototypes) return;
                        c.push(s[1]);
                    }
                    return s && c.push("[" + o.slice(s.index) + "]"), function(t, e, r, n) {
                        for(var i = n ? e : u(e, r), o = t.length - 1; o >= 0; --o){
                            var a, s = t[o];
                            if ("[]" === s && r.parseArrays) a = r.allowEmptyArrays && "" === i ? [] : [].concat(i);
                            else {
                                a = r.plainObjects ? Object.create(null) : {};
                                var l = "[" === s.charAt(0) && "]" === s.charAt(s.length - 1) ? s.slice(1, -1) : s, c = r.decodeDotInKeys ? l.replace(/%2E/g, ".") : l, f = parseInt(c, 10);
                                r.parseArrays || "" !== c ? !isNaN(f) && s !== c && String(f) === c && f >= 0 && r.parseArrays && f <= r.arrayLimit ? (a = [])[f] = i : "__proto__" !== c && (a[c] = i) : a = {
                                    0: i
                                };
                            }
                            i = a;
                        }
                        return i;
                    }(c, e, r, n);
                }
            };
            t.exports = function(t, e) {
                var r = function(t) {
                    if (!t) return a;
                    if (void 0 !== t.allowEmptyArrays && "boolean" != typeof t.allowEmptyArrays) throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
                    if (void 0 !== t.decodeDotInKeys && "boolean" != typeof t.decodeDotInKeys) throw new TypeError("`decodeDotInKeys` option can only be `true` or `false`, when provided");
                    if (null !== t.decoder && void 0 !== t.decoder && "function" != typeof t.decoder) throw new TypeError("Decoder has to be a function.");
                    if (void 0 !== t.charset && "utf-8" !== t.charset && "iso-8859-1" !== t.charset) throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
                    var e = void 0 === t.charset ? a.charset : t.charset, r = void 0 === t.duplicates ? a.duplicates : t.duplicates;
                    if ("combine" !== r && "first" !== r && "last" !== r) throw new TypeError("The duplicates option must be either combine, first, or last");
                    return {
                        allowDots: void 0 === t.allowDots ? !0 === t.decodeDotInKeys || a.allowDots : !!t.allowDots,
                        allowEmptyArrays: "boolean" == typeof t.allowEmptyArrays ? !!t.allowEmptyArrays : a.allowEmptyArrays,
                        allowPrototypes: "boolean" == typeof t.allowPrototypes ? t.allowPrototypes : a.allowPrototypes,
                        allowSparse: "boolean" == typeof t.allowSparse ? t.allowSparse : a.allowSparse,
                        arrayLimit: "number" == typeof t.arrayLimit ? t.arrayLimit : a.arrayLimit,
                        charset: e,
                        charsetSentinel: "boolean" == typeof t.charsetSentinel ? t.charsetSentinel : a.charsetSentinel,
                        comma: "boolean" == typeof t.comma ? t.comma : a.comma,
                        decodeDotInKeys: "boolean" == typeof t.decodeDotInKeys ? t.decodeDotInKeys : a.decodeDotInKeys,
                        decoder: "function" == typeof t.decoder ? t.decoder : a.decoder,
                        delimiter: "string" == typeof t.delimiter || n.isRegExp(t.delimiter) ? t.delimiter : a.delimiter,
                        depth: "number" == typeof t.depth || !1 === t.depth ? +t.depth : a.depth,
                        duplicates: r,
                        ignoreQueryPrefix: !0 === t.ignoreQueryPrefix,
                        interpretNumericEntities: "boolean" == typeof t.interpretNumericEntities ? t.interpretNumericEntities : a.interpretNumericEntities,
                        parameterLimit: "number" == typeof t.parameterLimit ? t.parameterLimit : a.parameterLimit,
                        parseArrays: !1 !== t.parseArrays,
                        plainObjects: "boolean" == typeof t.plainObjects ? t.plainObjects : a.plainObjects,
                        strictNullHandling: "boolean" == typeof t.strictNullHandling ? t.strictNullHandling : a.strictNullHandling
                    };
                }(e);
                if ("" === t || null == t) return r.plainObjects ? Object.create(null) : {};
                for(var c = "string" == typeof t ? function(t, e) {
                    var r, l = {
                        __proto__: null
                    }, c = e.ignoreQueryPrefix ? t.replace(/^\?/, "") : t, f = e.parameterLimit === 1 / 0 ? void 0 : e.parameterLimit, h = c.split(e.delimiter, f), p = -1, d = e.charset;
                    if (e.charsetSentinel) for(r = 0; r < h.length; ++r)0 === h[r].indexOf("utf8=") && ("utf8=%E2%9C%93" === h[r] ? d = "utf-8" : "utf8=%26%2310003%3B" === h[r] && (d = "iso-8859-1"), p = r, r = h.length);
                    for(r = 0; r < h.length; ++r)if (r !== p) {
                        var m, y, g = h[r], v = g.indexOf("]="), b = -1 === v ? g.indexOf("=") : v + 1;
                        -1 === b ? (m = e.decoder(g, a.decoder, d, "key"), y = e.strictNullHandling ? null : "") : (m = e.decoder(g.slice(0, b), a.decoder, d, "key"), y = n.maybeMap(u(g.slice(b + 1), e), function(t) {
                            return e.decoder(t, a.decoder, d, "value");
                        })), y && e.interpretNumericEntities && "iso-8859-1" === d && (y = s(y)), g.indexOf("[]=") > -1 && (y = o(y) ? [
                            y
                        ] : y);
                        var x = i.call(l, m);
                        x && "combine" === e.duplicates ? l[m] = n.combine(l[m], y) : x && "last" !== e.duplicates || (l[m] = y);
                    }
                    return l;
                }(t, r) : t, f = r.plainObjects ? Object.create(null) : {}, h = Object.keys(c), p = 0; p < h.length; ++p){
                    var d = h[p], m = l(d, c[d], r, "string" == typeof t);
                    f = n.merge(f, m, r);
                }
                return !0 === r.allowSparse ? f : n.compact(f);
            };
        },
        function(t, e, r) {
            var n = r(7).default, i = r(213);
            t.exports = function(t) {
                var e = i(t, "string");
                return "symbol" == n(e) ? e : e + "";
            }, t.exports.__esModule = !0, t.exports.default = t.exports;
        },
        function(t, e, r) {
            var n = r(7).default;
            t.exports = function(t, e) {
                if ("object" != n(t) || !t) return t;
                var r = t[Symbol.toPrimitive];
                if (void 0 !== r) {
                    var i = r.call(t, e || "default");
                    if ("object" != n(i)) return i;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return ("string" === e ? String : Number)(t);
            }, t.exports.__esModule = !0, t.exports.default = t.exports;
        },
        function(t, e, r) {
            (function(t) {
                var n;
                !function(t, i, o) {
                    function a(t) {
                        var e, r = this, n = (e = 4022871197, function(t) {
                            t = String(t);
                            for(var r = 0; r < t.length; r++){
                                var n = .02519603282416938 * (e += t.charCodeAt(r));
                                n -= e = n >>> 0, e = (n *= e) >>> 0, e += 4294967296 * (n -= e);
                            }
                            return 2.3283064365386963e-10 * (e >>> 0);
                        });
                        r.next = function() {
                            var t = 2091639 * r.s0 + 2.3283064365386963e-10 * r.c;
                            return r.s0 = r.s1, r.s1 = r.s2, r.s2 = t - (r.c = 0 | t);
                        }, r.c = 1, r.s0 = n(" "), r.s1 = n(" "), r.s2 = n(" "), r.s0 -= n(t), r.s0 < 0 && (r.s0 += 1), r.s1 -= n(t), r.s1 < 0 && (r.s1 += 1), r.s2 -= n(t), r.s2 < 0 && (r.s2 += 1), n = null;
                    }
                    function s(t, e) {
                        return e.c = t.c, e.s0 = t.s0, e.s1 = t.s1, e.s2 = t.s2, e;
                    }
                    function u(t, e) {
                        var r = new a(t), n = e && e.state, i = r.next;
                        return i.int32 = function() {
                            return 4294967296 * r.next() | 0;
                        }, i.double = function() {
                            return i() + 11102230246251565e-32 * (2097152 * i() | 0);
                        }, i.quick = i, n && ("object" == typeof n && s(n, r), i.state = function() {
                            return s(r, {});
                        }), i;
                    }
                    i && i.exports ? i.exports = u : r(18) && r(32) ? void 0 === (n = (function() {
                        return u;
                    }).call(e, r, e, i)) || (i.exports = n) : this.alea = u;
                }(0, t, r(18));
            }).call(this, r(31)(t));
        },
        function(t, e, r) {
            (function(t) {
                var n;
                !function(t, i, o) {
                    function a(t) {
                        var e = this, r = "";
                        e.x = 0, e.y = 0, e.z = 0, e.w = 0, e.next = function() {
                            var t = e.x ^ e.x << 11;
                            return e.x = e.y, e.y = e.z, e.z = e.w, e.w ^= e.w >>> 19 ^ t ^ t >>> 8;
                        }, t === (0 | t) ? e.x = t : r += t;
                        for(var n = 0; n < r.length + 64; n++)e.x ^= 0 | r.charCodeAt(n), e.next();
                    }
                    function s(t, e) {
                        return e.x = t.x, e.y = t.y, e.z = t.z, e.w = t.w, e;
                    }
                    function u(t, e) {
                        var r = new a(t), n = e && e.state, i = function() {
                            return (r.next() >>> 0) / 4294967296;
                        };
                        return i.double = function() {
                            do var t = ((r.next() >>> 11) + (r.next() >>> 0) / 4294967296) / 2097152;
                            while (0 === t);
                            return t;
                        }, i.int32 = r.next, i.quick = i, n && ("object" == typeof n && s(n, r), i.state = function() {
                            return s(r, {});
                        }), i;
                    }
                    i && i.exports ? i.exports = u : r(18) && r(32) ? void 0 === (n = (function() {
                        return u;
                    }).call(e, r, e, i)) || (i.exports = n) : this.xor128 = u;
                }(0, t, r(18));
            }).call(this, r(31)(t));
        },
        function(t, e, r) {
            (function(t) {
                var n;
                !function(t, i, o) {
                    function a(t) {
                        var e = this, r = "";
                        e.next = function() {
                            var t = e.x ^ e.x >>> 2;
                            return e.x = e.y, e.y = e.z, e.z = e.w, e.w = e.v, (e.d = e.d + 362437 | 0) + (e.v = e.v ^ e.v << 4 ^ t ^ t << 1) | 0;
                        }, e.x = 0, e.y = 0, e.z = 0, e.w = 0, e.v = 0, t === (0 | t) ? e.x = t : r += t;
                        for(var n = 0; n < r.length + 64; n++)e.x ^= 0 | r.charCodeAt(n), n == r.length && (e.d = e.x << 10 ^ e.x >>> 4), e.next();
                    }
                    function s(t, e) {
                        return e.x = t.x, e.y = t.y, e.z = t.z, e.w = t.w, e.v = t.v, e.d = t.d, e;
                    }
                    function u(t, e) {
                        var r = new a(t), n = e && e.state, i = function() {
                            return (r.next() >>> 0) / 4294967296;
                        };
                        return i.double = function() {
                            do var t = ((r.next() >>> 11) + (r.next() >>> 0) / 4294967296) / 2097152;
                            while (0 === t);
                            return t;
                        }, i.int32 = r.next, i.quick = i, n && ("object" == typeof n && s(n, r), i.state = function() {
                            return s(r, {});
                        }), i;
                    }
                    i && i.exports ? i.exports = u : r(18) && r(32) ? void 0 === (n = (function() {
                        return u;
                    }).call(e, r, e, i)) || (i.exports = n) : this.xorwow = u;
                }(0, t, r(18));
            }).call(this, r(31)(t));
        },
        function(t, e, r) {
            (function(t) {
                var n;
                !function(t, i, o) {
                    function a(t) {
                        var e = this;
                        e.next = function() {
                            var t, r, n = e.x, i = e.i;
                            return t = n[i], r = (t ^= t >>> 7) ^ t << 24, r ^= (t = n[i + 1 & 7]) ^ t >>> 10, r ^= (t = n[i + 3 & 7]) ^ t >>> 3, r ^= (t = n[i + 4 & 7]) ^ t << 7, t = n[i + 7 & 7], r ^= (t ^= t << 13) ^ t << 9, n[i] = r, e.i = i + 1 & 7, r;
                        }, function(t, e) {
                            var r, n = [];
                            if (e === (0 | e)) n[0] = e;
                            else for(e = "" + e, r = 0; r < e.length; ++r)n[7 & r] = n[7 & r] << 15 ^ e.charCodeAt(r) + n[r + 1 & 7] << 13;
                            for(; n.length < 8;)n.push(0);
                            for(r = 0; r < 8 && 0 === n[r]; ++r);
                            for(8 == r ? n[7] = -1 : n[r], t.x = n, t.i = 0, r = 256; r > 0; --r)t.next();
                        }(e, t);
                    }
                    function s(t, e) {
                        return e.x = t.x.slice(), e.i = t.i, e;
                    }
                    function u(t, e) {
                        null == t && (t = +new Date);
                        var r = new a(t), n = e && e.state, i = function() {
                            return (r.next() >>> 0) / 4294967296;
                        };
                        return i.double = function() {
                            do var t = ((r.next() >>> 11) + (r.next() >>> 0) / 4294967296) / 2097152;
                            while (0 === t);
                            return t;
                        }, i.int32 = r.next, i.quick = i, n && (n.x && s(n, r), i.state = function() {
                            return s(r, {});
                        }), i;
                    }
                    i && i.exports ? i.exports = u : r(18) && r(32) ? void 0 === (n = (function() {
                        return u;
                    }).call(e, r, e, i)) || (i.exports = n) : this.xorshift7 = u;
                }(0, t, r(18));
            }).call(this, r(31)(t));
        },
        function(t, e, r) {
            (function(t) {
                var n;
                !function(t, i, o) {
                    function a(t) {
                        var e = this;
                        e.next = function() {
                            var t, r, n = e.w, i = e.X, o = e.i;
                            return e.w = n = n + 1640531527 | 0, r = i[o + 34 & 127], t = i[o = o + 1 & 127], r ^= r << 13, t ^= t << 17, r ^= r >>> 15, t ^= t >>> 12, r = i[o] = r ^ t, e.i = o, r + (n ^ n >>> 16) | 0;
                        }, function(t, e) {
                            var r, n, i, o, a, s = [], u = 128;
                            for(e === (0 | e) ? (n = e, e = null) : (e += "\0", n = 0, u = Math.max(u, e.length)), i = 0, o = -32; o < u; ++o)e && (n ^= e.charCodeAt((o + 32) % e.length)), 0 === o && (a = n), n ^= n << 10, n ^= n >>> 15, n ^= n << 4, n ^= n >>> 13, o >= 0 && (a = a + 1640531527 | 0, i = 0 == (r = s[127 & o] ^= n + a) ? i + 1 : 0);
                            for(i >= 128 && (s[127 & (e && e.length || 0)] = -1), i = 127, o = 512; o > 0; --o)n = s[i + 34 & 127], r = s[i = i + 1 & 127], n ^= n << 13, r ^= r << 17, n ^= n >>> 15, r ^= r >>> 12, s[i] = n ^ r;
                            t.w = a, t.X = s, t.i = i;
                        }(e, t);
                    }
                    function s(t, e) {
                        return e.i = t.i, e.w = t.w, e.X = t.X.slice(), e;
                    }
                    function u(t, e) {
                        null == t && (t = +new Date);
                        var r = new a(t), n = e && e.state, i = function() {
                            return (r.next() >>> 0) / 4294967296;
                        };
                        return i.double = function() {
                            do var t = ((r.next() >>> 11) + (r.next() >>> 0) / 4294967296) / 2097152;
                            while (0 === t);
                            return t;
                        }, i.int32 = r.next, i.quick = i, n && (n.X && s(n, r), i.state = function() {
                            return s(r, {});
                        }), i;
                    }
                    i && i.exports ? i.exports = u : r(18) && r(32) ? void 0 === (n = (function() {
                        return u;
                    }).call(e, r, e, i)) || (i.exports = n) : this.xor4096 = u;
                }(0, t, r(18));
            }).call(this, r(31)(t));
        },
        function(t, e, r) {
            (function(t) {
                var n;
                !function(t, i, o) {
                    function a(t) {
                        var e = this, r = "";
                        e.next = function() {
                            var t = e.b, r = e.c, n = e.d, i = e.a;
                            return t = t << 25 ^ t >>> 7 ^ r, r = r - n | 0, n = n << 24 ^ n >>> 8 ^ i, i = i - t | 0, e.b = t = t << 20 ^ t >>> 12 ^ r, e.c = r = r - n | 0, e.d = n << 16 ^ r >>> 16 ^ i, e.a = i - t | 0;
                        }, e.a = 0, e.b = 0, e.c = -1640531527, e.d = 1367130551, t === Math.floor(t) ? (e.a = t / 4294967296 | 0, e.b = 0 | t) : r += t;
                        for(var n = 0; n < r.length + 20; n++)e.b ^= 0 | r.charCodeAt(n), e.next();
                    }
                    function s(t, e) {
                        return e.a = t.a, e.b = t.b, e.c = t.c, e.d = t.d, e;
                    }
                    function u(t, e) {
                        var r = new a(t), n = e && e.state, i = function() {
                            return (r.next() >>> 0) / 4294967296;
                        };
                        return i.double = function() {
                            do var t = ((r.next() >>> 11) + (r.next() >>> 0) / 4294967296) / 2097152;
                            while (0 === t);
                            return t;
                        }, i.int32 = r.next, i.quick = i, n && ("object" == typeof n && s(n, r), i.state = function() {
                            return s(r, {});
                        }), i;
                    }
                    i && i.exports ? i.exports = u : r(18) && r(32) ? void 0 === (n = (function() {
                        return u;
                    }).call(e, r, e, i)) || (i.exports = n) : this.tychei = u;
                }(0, t, r(18));
            }).call(this, r(31)(t));
        },
        function(t, e, r) {
            var n;
            !function(i, o, a) {
                var s, u = a.pow(256, 6), l = a.pow(2, 52), c = 2 * l;
                function f(t, e, r) {
                    var n = [], f = d(function t(e, r) {
                        var n, i = [], o = typeof e;
                        if (r && "object" == o) for(n in e)try {
                            i.push(t(e[n], r - 1));
                        } catch (t) {}
                        return i.length ? i : "string" == o ? e : e + "\0";
                    }((e = 1 == e ? {
                        entropy: !0
                    } : e || {}).entropy ? [
                        t,
                        m(o)
                    ] : null == t ? function() {
                        try {
                            var t;
                            return s && (t = s.randomBytes) ? t = t(256) : (t = new Uint8Array(256), (i.crypto || i.msCrypto).getRandomValues(t)), m(t);
                        } catch (t) {
                            var e = i.navigator, r = e && e.plugins;
                            return [
                                +new Date,
                                i,
                                r,
                                i.screen,
                                m(o)
                            ];
                        }
                    }() : t, 3), n), y = new h(n), g = function() {
                        for(var t = y.g(6), e = u, r = 0; t < l;)t = 256 * (t + r), e *= 256, r = y.g(1);
                        for(; t >= c;)t /= 2, e /= 2, r >>>= 1;
                        return (t + r) / e;
                    };
                    return g.int32 = function() {
                        return 0 | y.g(4);
                    }, g.quick = function() {
                        return y.g(4) / 4294967296;
                    }, g.double = g, d(m(y.S), o), (e.pass || r || function(t, e, r, n) {
                        return n && (n.S && p(n, y), t.state = function() {
                            return p(y, {});
                        }), r ? (a.random = t, e) : t;
                    })(g, f, "global" in e ? e.global : this == a, e.state);
                }
                function h(t) {
                    var e, r = t.length, n = this, i = 0, o = n.i = n.j = 0, a = n.S = [];
                    for(r || (t = [
                        r++
                    ]); i < 256;)a[i] = i++;
                    for(i = 0; i < 256; i++)a[i] = a[o = 255 & o + t[i % r] + (e = a[i])], a[o] = e;
                    (n.g = function(t) {
                        for(var e, r = 0, i = n.i, o = n.j, a = n.S; t--;)e = a[i = 255 & i + 1], r = 256 * r + a[255 & (a[i] = a[o = 255 & o + e]) + (a[o] = e)];
                        return n.i = i, n.j = o, r;
                    })(256);
                }
                function p(t, e) {
                    return e.i = t.i, e.j = t.j, e.S = t.S.slice(), e;
                }
                function d(t, e) {
                    for(var r, n = t + "", i = 0; i < n.length;)e[255 & i] = 255 & (r ^= 19 * e[255 & i]) + n.charCodeAt(i++);
                    return m(e);
                }
                function m(t) {
                    return String.fromCharCode.apply(0, t);
                }
                if (d(a.random(), o), t.exports) {
                    t.exports = f;
                    try {
                        s = r(221);
                    } catch (t) {}
                } else void 0 === (n = (function() {
                    return f;
                }).call(e, r, e, t)) || (t.exports = n);
            }("undefined" != typeof self ? self : this, [], Math);
        },
        function(t, e) {},
        function(t, e, r) {
            var n;
            function i() {
                const t = [], e = (t)=>"object" == typeof t && 0 === Object.keys(t).length && "{}" === JSON.stringify(t), r = (n)=>{
                    if (n) {
                        if (Array.isArray(n)) return n.forEach(r);
                        n.default && (n = n.default), e(n) || t.push(n);
                    }
                };
                if (Array.from(arguments).forEach(r), 0 === t.length) throw Error("[proj4-merge] merge called with zero instances of proj4");
                const [n, ...i] = t;
                return i.forEach((t)=>{
                    n.defs(Object.entries(t.defs));
                }), n;
            }
            void 0 === (n = (function() {
                return i;
            }).call(e, r, e, t)) || (t.exports = n), t.exports = i, t.exports.default = i;
        },
        function(t, e) {
            const r = " +no_defs", n = " +towgs84=0,0,0,0,0,0,0", i = " +ellps=GRS80", o = "+proj=tmerc", a = " +units=m", s = " +towgs84=23.92,-141.27,-80.9,-0,0.35,0.82,-0.12", u = " +towgs84=24.47,-130.89,-81.56,-0,-0,0.13,-0.22", l = "+proj=lcc", c = "+proj=utm", f = " +units=us-ft", h = "+proj=longlat", p = " +lat_0=0", d = " +ellps=krass", m = " +y_0=0", y = " +x_0=500000", g = " +towgs84=0,0,4.5,0,0,0.554,0.2263", v = " +towgs84=0,0,1.9,0,0,0.814,-0.38", b = " +ellps=intl", x = " +datum=WGS84", w = " +ellps=WGS72", _ = " +towgs84=15.8,-154.4,-82.3,0,0,0,0", A = " +k=0.9999", E = " +towgs84=59.47,-5.04,187.44,0.47,-0.1,1.024,-4.5993", S = " +datum=NAD27", M = " +ellps=bessel", k = " +x_0=609601.2192024384", N = " +x_0=600000", C = " +towgs84=33.4,-146.6,-76.3,-0.359,-0.053,0.844,-0.84", D = " +ellps=clrk80", O = " +b=6356755.288157528", T = " +x_0=152400.3048006096", F = " +lat_0=36.66666666666666", P = " +towgs84=-146.414,507.337,680.507,0,0,0,0", I = " +x_0=200000", B = " +ellps=clrk66", j = " +ellps=WGS84", R = " +x_0=500000.001016002", L = " +x_0=240000", q = " +lat_0=-90", U = " +towgs84=-87,-98,-121,0,0,0,0", z = " +south", G = " +lat_0=41.66666666666666", H = " +y_0=36000", W = " +towgs84=-117.808,-51.536,137.784,0.303,0.446,0.234,-0.29", $ = " +x_0=0", V = " +units=ft", Z = " +x_0=400000", Y = " +towgs84=-115.854,-99.0583,-152.462,0,0,0,0", K = " +towgs84=-208.406,-109.878,-2.5764,0,0,0,0", X = " +ellps=aust_SA", J = " +lat_0=39.33333333333334", Q = " +towgs84=577.326,90.129,463.919,5.137,1.474,5.297,2.4232", tt = " +lat_0=37.66666666666666", et = " +lat_0=36.33333333333334", rt = " +towgs84=598.1,73.7,418.2,0.202,0.045,-2.455,6.7", nt = " +y_0=500000.0001016001", it = " +x_0=200000.0001016002", ot = " +x_0=500000.0001016001", at = " +x_0=500000.00001016", st = " +y_0=1000000", ut = " +x_0=300000", lt = " +lon_0=-120.5", ct = " +lat_0=43.66666666666666", ft = " +lat_0=43.83333333333334", ht = " +lat_1=-68.66666666666667", pt = " +lat_2=-71.33333333333333", dt = " +k=0.999966667", mt = " +k=0.9996", yt = " +lat_0=38.33333333333334", gt = " +lat_1=73.66666666666667", vt = " +lat_2=70.33333333333333", bt = " +lat_0=72.02500919444445", xt = " +a=6378249.2", wt = " +x_0=1500000", _t = " +lat_ts=-80.23861111111111", At = " +towgs84=-288,175,-376,0,0,0,0", Et = " +lat_1=41.78333333333333", St = " +lat_2=-75.33333333333333", Mt = " +towgs84=278.3,93,474.5,7.889,0.05,-6.61,6.21", kt = " +x_0=304800", Nt = " +x_0=2000000.0001016", Ct = " +k=0.9999375", Dt = " +y_0=500000", Ot = " +towgs84=-209.362,-87.8162,404.62,0.0046,3.4784,0.5805,-1.4547", Tt = " +lon_0=-100.3333333333333", Ft = " +lat_1=-72.66666666666667", Pt = " +lat_1=-76.66666666666667", It = " +lat_2=-79.33333333333333", Bt = " +y_0=10000000", jt = " +towgs84=-57,1,-41,0,0,0,0", Rt = " +k=0.999941177", Lt = " +x_0=800000.0000101599", qt = " +y_0=99999.99998983997", Ut = " +lat_1=38.43333333333333", zt = " +lat_0=24.33333333333333", Gt = " +towgs84=26,-121,-78,0,0,0,0", Ht = " +a=6378140", Wt = " +towgs84=-96.062,-82.428,-121.753,4.801,0.345,-1.376,1.496", $t = " +x_0=399999.99998984", Vt = " +towgs84=-24,-15,5,0,0,0,0", Zt = " +towgs84=682,-203,480,0,0,0,0", Yt = " +towgs84=-136,-108,-292,0,0,0,0", Kt = " +b=6356075.41314024", Xt = " +lat_1=37.96666666666667", Jt = " +lat_0=38.83333333333334", Qt = " +lat_0=40.16666666666666", te = " +lat_0=34.33333333333334", ee = " +lat_0=42.83333333333334", re = " +lon_0=-84.36666666666666", ne = " +x_0=300000.0000000001", ie = " +k=0.999933333", oe = " +lat_1=48.73333333333333", ae = " +lon_0=-111.5", se = " +k=0.9999473679999999", ue = " +towgs84=-67.35,3.88,-38.22,0,0,0,0", le = " +lat_2=73.66666666666667", ce = " +lat_0=75.36440330555556", fe = " +b=6356515", he = " +towgs84=25,-141,-78.5,-0,0.35,0.736,0", pe = "+proj=stere", de = " +lat_1=-64.66666666666667", me = " +lat_2=-67.33333333333333", ye = " +b=6356514.966398753", ge = " +towgs84=295,736,257,0,0,0,0", ve = " +x_0=100000", be = " +towgs84=-11,851,5,0,0,0,0", xe = " +towgs84=414.1,41.3,603.1,-0.855,2.141,-7.023,0", we = " +towgs84=-127.62,-67.24,-47.04,-3.068,4.903,1.578,-1.06", _e = " +lat_0=39.66666666666666", Ae = " +x_0=1000000", Ee = " +lon_0=-105.5", Se = " +towgs84=482.5,-130.6,564.6,-1.042,-0.214,-0.631,8.15", Me = " +a=6378249.145", ke = " +x_0=2000000", Ne = " +lat_0=45.66666666666666", Ce = " +lat_1=80.33333333333333", De = " +lat_0=78.70733752777778", Oe = " +b=6356774.50408554", Te = " +lon_0=-91.33333333333333", Fe = " +lon_0=-123.3333333333333", Pe = " +towgs84=-168,-60,320,0,0,0,0", Ie = " +lat_0=31", Be = " +towgs84=0.072,-0.507,-0.245,-0.0183,0.0003,-0.007,-0.0093", je = " +x_0=150000", Re = " +x_0=3500000", Le = " +towgs84=213.11,9.37,-74.95,0,0,0,0", qe = " +lat_1=43.66666666666666", Ue = " +lat_0=40.33333333333334", ze = " +towgs84=-148,136,90,0,0,0,0", Ge = " +towgs84=616,97,-251,0,0,0,0", He = " +lon_0=-90", We = " +x_0=250000", $e = " +x_0=914401.8288036576", Ve = " +lon_0=-90.33333333333333", Ze = " +a=6377276.345", Ye = " +b=6356103.038993155", Ke = " +lat_0=40.5", Xe = " +towgs84=-134,-48,149,0,0,0,0", Je = " +towgs84=25,-141,-78.5,0,0.35,0.736,0", Qe = " +lat_1=27.83333333333333", tr = " +lat_2=26.16666666666667", er = " +lat_2=40.71666666666667", rr = " +lat_2=39.01666666666667", nr = " +lat_2=37.21666666666667", ir = " +lat_1=70.33333333333333", or = " +lat_0=68.68747555555557", ar = " +towgs84=-104.1,-49.1,-9.9,0.971,-2.917,0.714,-11.68", sr = " +y_0=304800.6096012192", ur = " +x_0=699999.9998983998", lr = " +y_0=999999.9998983998", cr = " +y_0=800000", fr = " +k=0.99995", hr = " +lat_0=34.75", pr = " +lon_0=-81", dr = " +lon_0=-100", mr = " +b=6356098.145120132", yr = "+proj=omerc", gr = " +lon_0=-98.5", vr = " +towgs84=-103.746,-9.614,-255.95,0,0,0,0", br = " +x_0=800000", xr = " +lat_0=37.83333333333334", wr = " +lat_2=44.33333333333334", _r = " +lat_2=42.33333333333334", Ar = " +lat_0=29.66666666666667", Er = " +lat_0=25.66666666666667", Sr = " +lat_0=35.83333333333334", Mr = " +lat_1=83.66666666666667", kr = " +lat_2=80.33333333333333", Nr = " +lat_0=82.05842488888888", Cr = " +lat_0=38", Dr = " +x_0=2500000", Or = " +towgs84=-377,681,-50,0,0,0,0", Tr = "+proj=cass", Fr = " +y_0=2000000", Pr = " +towgs84=-143,-236,7,0,0,0,0", Ir = " +lon_0=-110.1666666666667", Br = " +lon_0=-111.9166666666667", jr = " +lon_0=-75.41666666666667", Rr = " +lon_0=-82.16666666666667", Lr = " +lon_0=-84.16666666666667", qr = " +lon_0=-112.1666666666667", Ur = " +lon_0=-88.83333333333333", zr = " +lon_0=-104.3333333333333", Gr = " +lon_0=-107.8333333333333", Hr = " +lon_0=-76.58333333333333", Wr = " +lon_0=-78.58333333333333", $r = " +lon_0=-120.8333333333333", Vr = " +lon_0=-88.33333333333333", Zr = " +lon_0=-90.16666666666667", Yr = " +lon_0=-85.66666666666667", Kr = " +lon_0=-87.08333333333333", Xr = " +lon_0=-70.16666666666667", Jr = " +lon_0=-93.09999999999999", Qr = " +lon_0=-115.5833333333333", tn = " +lon_0=-116.6666666666667", en = " +lon_0=-118.5833333333333", rn = " +lon_0=-71.66666666666667", nn = " +lon_0=-105.1666666666667", on = " +lon_0=-107.3333333333333", an = " +lon_0=-110.0833333333333", sn = " +lat_0=37.5", un = " +y_0=700000", ln = " +towgs84=-242.2,-144.9,370.3,0,0,0,0", cn = " +x_0=4500000", fn = " +y_0=1500000", hn = " +x_0=599999.9999976", pn = " +towgs84=-275.722,94.7824,340.894,-8.001,-4.42,-11.821,1", dn = "+proj=aea", mn = " +y_0=-2500000", yn = " +lat_2=38.96666666666667", gn = " +lat_1=41.66666666666666", vn = " +lat_1=39.83333333333334", bn = " +lat_2=38.33333333333334", xn = " +lat_2=37.06666666666667", wn = " +lat_0=35.33333333333334", _n = " +lat_1=35.46666666666667", An = " +lat_2=34.03333333333333", En = " +lat_1=33.88333333333333", Sn = " +lat_2=32.78333333333333", Mn = " +lat_0=32.16666666666666", kn = " +lat_2=37.23333333333333", Nn = " +lat_1=41.86666666666667", Cn = " +lat_0=40.83333333333334", Dn = " +lat_2=29.58333333333333", On = " +lat_2=41.71666666666667", Tn = " +lat_1=41.03333333333333", Fn = " +lat_2=40.66666666666666", Pn = " +lat_1=36.76666666666667", In = " +lat_0=33.33333333333334", Bn = " +lat_1=40.96666666666667", jn = " +lat_2=39.93333333333333", Rn = " +lat_0=31.83333333333333", Ln = " +lat_0=31.66666666666667", qn = " +lat_0=27.83333333333333", Un = " +lat_2=36.76666666666667", zn = " +lat_0=45.33333333333334", Gn = " +lat_0=45.16666666666666", Hn = " +lat_1=36.23333333333333", Wn = " +lat_2=34.93333333333333", $n = " +lat_1=34.76666666666667", Vn = " +lat_0=32.66666666666666", Zn = " +lat_1=43.26666666666667", Yn = " +lat_2=42.06666666666667", Kn = " +lat_2=40.61666666666667", Xn = " +lat_1=39.78333333333333", Jn = " +lat_2=38.71666666666667", Qn = " +lat_1=38.56666666666667", ti = " +lat_2=37.26666666666667", ei = " +lat_0=41.08333333333334", ri = " +lat_0=42.33333333333334", ni = " +y_0=100000", ii = " +b=6356173.508712696", oi = " +y_0=5500000", ai = " +lon_0=105", si = " +y_0=-5000000", ui = " +k=0.9995000000000001", li = " +k=0.9999749999999999", ci = " +towgs84=-160,-6,-302,0,0,0,0", fi = " +towgs84=307,304,-318,0,0,0,0", hi = " +lon_0=-82.5", pi = " +towgs84=70.995,-335.916,262.898,0,0,0,0", di = " +towgs84=-304.046,-60.576,103.64,0,0,0,0", mi = " +x_0=700000", yi = " +x_0=213360", gi = " +lon_0=-85.75", vi = " +lon_0=-100.5", bi = " +lon_0=-77.75", xi = " +x_0=999999.9999898402", wi = " +towgs84=-151.99,287.04,-147.45,0,0,0,0", _i = " +lon_0=129", Ai = " +a=6378293.645208759", Ei = " +b=6356617.987679838", Si = " +x_0=5500000", Mi = " +lat_1=40.78333333333333", ki = " +lat_2=39.71666666666667", Ni = " +lat_1=37.93333333333333", Ci = " +lat_2=36.73333333333333", Di = " +lat_1=42.68333333333333", Oi = " +lat_1=41.48333333333333", Ti = " +lat_2=41.28333333333333", Fi = " +lat_1=47.08333333333334", Pi = " +lat_2=45.48333333333333", Ii = " +lat_0=44.78333333333333", Bi = " +lat_2=44.18333333333333", ji = " +lat_0=43.31666666666667", Ri = " +lat_1=36.16666666666666", Li = " +lat_2=34.33333333333334", qi = " +lat_2=47.43333333333333", Ui = " +lat_1=47.48333333333333", zi = " +lat_2=46.18333333333333", Gi = " +lat_2=35.56666666666667", Hi = " +lat_1=35.23333333333333", Wi = " +lat_2=33.93333333333333", $i = " +lat_2=40.88333333333333", Vi = " +lat_1=34.83333333333334", Zi = " +lat_1=36.41666666666666", Yi = " +lat_1=36.18333333333333", Ki = " +lat_1=33.96666666666667", Xi = " +lat_2=32.13333333333333", Ji = " +lat_1=31.88333333333333", Qi = " +lat_2=30.11666666666667", to = " +lat_1=30.28333333333333", eo = " +lat_2=28.38333333333333", ro = " +lat_2=38.03333333333333", no = " +lat_1=47.33333333333334", io = " +lat_2=45.83333333333334", oo = " +lat_1=46.76666666666667", ao = " +lat_2=45.56666666666667", so = " +lat_1=44.06666666666667", uo = " +lat_2=42.73333333333333", lo = " +lat_1=32.66666666666666", co = " +lat_2=31.16666666666667", fo = " +lat_1=48.63333333333333", ho = " +lat_2=47.03333333333333", po = " +lat_2=45.61666666666667", mo = " +lat_1=45.21666666666667", yo = " +lat_2=43.78333333333333", go = " +lat_0=39.83333333333334", vo = " +lat_2=40.43333333333333", bo = " +lat_1=40.03333333333333", xo = " +lat_2=38.73333333333333", wo = " +lat_1=45.68333333333333", _o = " +lat_2=44.41666666666666", Ao = " +lat_2=42.83333333333334", Eo = " +lat_1=38.88333333333333", So = " +lat_2=37.48333333333333", Mo = " +lat_1=37.08333333333334", ko = " +lat_2=38.66666666666666", No = " +lat_0=58", Co = " +lon_0=-98", Do = " +lon_0=117", Oo = " +lon_0=135", To = " +lat_0=41.5", Fo = " +lat_0=42.5", Po = " +y_0=3000000", Io = " +lon_0=123", Bo = " +lat_0=40", jo = " +lat_0=54", Ro = " +towgs84=-192.873,-39.382,-111.202,-0.00205,-0.0005,0.00335,0.0188", Lo = " +towgs84=565.417,50.3319,465.552,-0.398957,0.343988,-1.8774,4.0725", qo = " +x_0=914401.8289", Uo = " +y_0=304800.6096", zo = " +lon_0=111", Go = " +k_0=0.99878641", Ho = " +lon_0=-66.43333333333334", Wo = " +towgs84=61,-285,-181,0,0,0,0", $o = " +towgs84=-133,-77,-51,0,0,0,0", Vo = " +towgs84=-679,669,-48,0,0,0,0", Zo = " +lon_0=-71.5", Yo = " +lon_0=-78.5", Ko = " +lon_0=-93.5", Xo = " +lat_0=41.75", Jo = " +y_0=249999.9998983998", Qo = " +y_0=999999.9999898402", ta = " +to_meter=1.0000135965", ea = " +a=6377304.063", ra = " +lat_0=36", na = " +towgs84=-79.9,-158,-168.9,0,0,0,0", ia = " +towgs84=-50.9,-347.6,-231,0,0,0,0", oa = " +towgs84=-106.869,52.2978,-103.724,0.3366,-0.457,1.8422,-1.2747", aa = " +towgs84=283,682,231,0,0,0,0", sa = " +towgs84=-206,172,-6,0,0,0,0", ua = " +towgs84=-92,-93,122,0,0,0,0", la = " +to_meter=0.9143985307444408", ca = "+proj=sterea", fa = " +lat_0=21.16666666666667", ha = " +lat_1=18.43333333333333", pa = " +lat_2=18.03333333333333", da = " +lat_0=17.83333333333333", ma = " +gamma=323.1301023611111", ya = " +lon_0=-79.5", ga = " +y_0=4500000", va = " +x_0=31500000", ba = " +x_0=500000.0001504", xa = " +b=6356514.96582849", wa = " +towgs84=674.4,15.1,405.3,0,0,0,0", _a = " +towgs84=-180.624,-225.516,173.919,-0.81,-1.898,8.336,16.7101", Aa = " +towgs84=589,76,480,0,0,0,0", Ea = " +towgs84=-263,6,431,0,0,0,0", Sa = " +lon_0=15", Ma = " +axis=wsu", ka = " +lon_0=21", Na = " +lat_0=30", Ca = " +ellps=helmert", Da = " +a=6377299.151", Oa = " +lon_0=-74.5", Ta = " +b=6356750.304921594", Fa = " +y_0=2000000.0001016", Pa = " +x_0=3500000.0001016", Ia = " +y_0=399999.99998984", Ba = " +x_0=200000.00001016", ja = " +b=6356098.359005156", Ra = " +x_0=14500000", La = " +x_0=29500000", qa = " +towgs84=-117,-132,-164,0,0,0,0", Ua = " +zone=20", za = " +lon_0=-122", Ga = " +ellps=bess_nam", Ha = " +lon_0=-86.15000000000001", Wa = " +towgs84=-189,-242,-91,0,0,0,0", $a = " +towgs84=-265,120,-358,0,0,0,0", Va = " +towgs84=-73.472,-51.66,-112.482,0.953,4.6,-2.368,0.586", Za = " +towgs84=-17.51,-108.32,-62.39,0,0,0,0", Ya = " +towgs84=-10.18,-350.43,291.37,0,0,0,0", Ka = " +towgs84=-190.421,8.532,238.69,0,0,0,0", Xa = " +lon_0=-68.5", Ja = " +a=6377299.36559538", Qa = " +x_0=79999.99999968", ts = " +x_0=50000.00001504", es = " +lon_0=0", rs = " +lon_0=27", ns = " +lon_0=75", is = " +lon_0=81", os = " +lon_0=93", as = " +lon_0=99", ss = " +x_0=900000", us = " +x_0=13500000", ls = " +x_0=20500000", cs = " +x_0=22500000", fs = " +towgs84=-166,-15,204,0,0,0,0", hs = " +towgs84=-130,110,-13,0,0,0,0", ps = " +towgs84=-587.8,519.75,145.76,0,0,0,0", ds = " +lat_2=83.66666666666667", ms = " +lat_0=85.43711833333333", ys = " +towgs84=-273.5,110.6,-357.9,0,0,0,0", gs = " +lon_0=87", vs = "+proj=laea", bs = " +towgs84=-403,684,41,0,0,0,0", xs = " +lon_0=-92.5", ws = " +y_0=6000000", _s = " +zone=19", As = " +lat_0=29.5", Es = " +y_0=300000", Ss = " +lat_2=45.5", Ms = " +k=0.999909091", ks = " +a=6377492.018", Ns = " +b=6356751.689189189", Cs = " +b=6356100.230165384", Ds = " +lon_0=90", Os = " +lat_0=90", Ts = " +x_0=18500000", Fs = " +x_0=19500000", Ps = " +x_0=15500000", Is = " +x_0=16500000", Bs = " +x_0=21500000", js = " +x_0=23500000", Rs = " +x_0=25500000", Ls = " +x_0=26500000", qs = " +x_0=27500000", Us = " +x_0=28500000", zs = " +zone=18", Gs = " +zone=21", Hs = " +towgs84=-124.76,53,466.79,0,0,0,0", Ws = " +lon_0=-92", $s = " +lon_0=33", Vs = " +lon_0=12", Zs = " +lon_0=24", Ys = " +lat_2=77", Ks = " +y_0=200000", Xs = " +lon_0=-70.5", Js = " +x_0=7500000", Qs = " +y_0=3500000", tu = " +towgs84=31,146,47,0,0,0,0", eu = " +lat_0=45", ru = " +lat_0=26", nu = " +a=6378160", iu = " +lon_0=-109.5", ou = " +x_0=30500000", au = " +x_0=32500000", su = " +lon_0=-85.83333333333333", uu = " +lon_0=-118.3333333333333", lu = " +y_0=0.003048006096012192", cu = " +lat_0=30.5", fu = " +lat_0=44", hu = " +lon_0=30", pu = " +lat_0=47", du = " +lat_1=77", mu = " +lat_0=36.16666666666666", yu = " +lat_0=4.596200416666666", gu = " +gamma=53.13010236111111", vu = " +lon_0=13.33333333333333", bu = " +lat_0=81.31722600000001", xu = " +lat_0=73.15574086111111", wu = " +lat_0=65.10127088888888", _u = " +zone=17", Au = " +lon_0=132", Eu = " +lon_0=114", Su = " +towgs84=-143,-90,-294,0,0,0,0", Mu = " +zone=22", ku = " +lat_0=41", Nu = " +lat_0=46.5", Cu = " +lon_0=-118", Du = " +y_0=400000", Ou = " +x_0=17500000", Tu = " +x_0=33500000", Fu = " +lon_0=-113.75", Pu = " +lon_0=-116.25", Iu = " +lon_0=-115.75", Bu = " +lon_0=-106.25", ju = " +k=0.999916667", Ru = " +k=0.999964286", Lu = " +lon_0=-108.75", qu = " +towgs84=-73,-247,227,0,0,0,0", Uu = " +towgs84=265.025,384.929,-194.046,0,0,0,0", zu = " +k=0.99998", Gu = " +lat_1=40.65", Hu = " +lat_1=38.35", Wu = " +y_0=2500000", $u = " +y_0=6500000", Vu = " +x_0=39999.99999984", Zu = " +towgs84=-61.702,284.488,472.052,0,0,0,0", Yu = " +towgs84=-223.237,110.193,36.649,0,0,0,0", Ku = " +zone=39", Xu = " +zone=32", Ju = " +towgs84=-125,53,467,0,0,0,0", Qu = " +towgs84=198,881,317,0,0,0,0", tl = " +towgs84=214,804,268,0,0,0,0", el = " +towgs84=217,823,299,0,0,0,0", rl = " +lon_0=45", nl = " +lat_1=43", il = "+proj=merc", ol = " +x_0=99999.99998983997", al = " +x_0=99999.99999960001", sl = " +x_0=2743195.592233322", ul = " +y_0=914398.5307444407", ll = " +zone=38", cl = " +zone=28", fl = " +lon_0=-114", hl = " +lat_1=45.5", pl = " +towgs84=-73,46,-86,0,0,0,0", dl = " +towgs84=11,72,-101,0,0,0,0", ml = " +towgs84=287.58,177.78,-135.41,0,0,0,0", yl = " +towgs84=-162.619,-276.959,-161.764,0.067753,-2.24365,-1.15883,-1.09425", gl = " +lon_0=-87", vl = " +lon_0=-99", bl = " +lon_0=102", xl = " +lon_0=126", wl = " +k=0.99999", _l = " +x_0=50000", Al = " +lat_2=40", El = " +lon_0=-84.25", Sl = " +x_0=11500000", Ml = " +lon_0=-72.75", kl = " +lon_0=-101.5", Nl = " +lon_0=-94.25", Cl = " +x_0=6500000", Dl = " +y_0=5000000", Ol = " +x_0=1700000", Tl = " +towgs84=31.95,300.99,419.19,0,0,0,0", Fl = " +towgs84=-189.681,18.3463,-42.7695,-0.33746,-3.09264,2.53861,0.4598", Pl = " +towgs84=-119.425,-303.659,-11.0006,1.1643,0.174458,1.09626,3.65706", Il = " +towgs84=982.609,552.753,-540.873,6.68163,-31.6115,-19.8482,16.805", Bl = " +zone=29", jl = " +lon_0=9", Rl = " +zone=33", Ll = " +zone=37", ql = " +no_uoff", Ul = " +lon_0=120", zl = " +lon_0=177", Gl = " +lon_0=-177", Hl = " +lon_0=-158", Wl = " +y_0=250000", $l = " +lon_0=-111", Vl = " +x_0=2500000.0001424", Zl = " +x_0=1500000.0001464", Yl = " +lon_0=-71.60561777777777", Kl = " +lon_0=-156.6666666666667", Xl = " +lon_0=-160.1666666666667", Jl = " +lat_0=0.1166666666666667", Ql = " +towgs84=0,0,0,-0,-0,-0,0", tc = " +lon_0=-117.8333333333333", ec = " +lon_0=-123.1666666666667", rc = " +lon_0=-122.3333333333333", nc = " +lon_0=-119.1666666666667", ic = " +lon_0=-123.0833333333333", oc = " +lon_0=-85.84999999999999", ac = " +lon_0=-87.09999999999999", sc = " +lon_0=-86.90000000000001", uc = " +lon_0=-89.24166666666667", lc = " +lon_0=-92.63333333333334", cc = " +towgs84=347.103,1078.12,2623.92,-33.8875,70.6773,-9.3943,186.074", fc = " +towgs84=8.846,-4.394,-1.122,-0.00237,-0.146528,0.130428,0.783926", hc = " +towgs84=-480.26,-438.32,-643.429,16.3119,20.1721,-4.0349,-111.7", pc = " +towgs84=-0.293,766.95,87.713,0.195704,1.69507,3.47302,-0.039338", dc = " +towgs84=221.525,152.948,176.768,-2.3847,-1.3896,-0.877,11.4741", mc = " +towgs84=215.525,149.593,176.229,-3.2624,-1.692,-1.1571,10.4773", yc = " +zone=35", gc = " +lat_0=46.95240555555556", vc = " +alpha=30.28813972222222", bc = " +lat_1=10.16666666666667", xc = " +lat_0=10.16666666666667", wc = " +lat_0=18.83333333333333", _c = " +lat_0=20.33333333333333", Ac = " +lat_0=21.83333333333333", Ec = " +lat_0=21.66666666666667", Sc = " +lat_0=45.30916666666666", Mc = " +lat_1=49.83333333333334", kc = " +lat_2=51.16666666666666", Nc = " +lonc=-133.6666666666667", Cc = " +alpha=323.1301023611111", Dc = " +lat_1=53.83333333333334", Oc = " +lat_2=51.83333333333334", Tc = " +lat_1=44.66666666666666", Fc = " +lat_0=44.66666666666666", Pc = " +lat_1=45.66666666666666", Ic = " +lat_0=45.91666666666666", Bc = " +lat_0=45.08333333333334", jc = " +lat_0=44.33333333333334", Rc = " +lat_0=44.08333333333334", Lc = " +lat_1=48.33333333333334", qc = " +lat_0=48.33333333333334", Uc = " +lat_0=31.73409694444445", zc = " +lon_0=35.21208055555556", Gc = " +lat_0=44.03611111111111", Hc = " +lat_0=4.599047222222222", Wc = " +lat_0=40.66666666666666", $c = " +lat_1=49", Vc = " +lon_0=39", Zc = " +lat_1=37.25", Yc = " +lat_1=39.75", Kc = " +lat_2=38.45", Xc = " +lat_1=30.75", Jc = " +lon_0=-84.5", Qc = " +lat_0=33.75", tf = " +x_0=4000000", ef = " +y_0=4000000", rf = " +lon_0=-72.5", nf = " +x_0=5000000", of = " +x_0=10500000", af = " +x_0=12500000", sf = " +x_0=24500000", uf = " +k=0.99999375", lf = " +x_0=399999.9999984", cf = " +lon_0=-77", ff = " +lon_0=108", hf = " +lon_0=171", pf = " +towgs84=-179.483,-69.379,-27.584,-7.862,8.163,6.042,-13.925", df = " +lon_0=-171", mf = " +lat_0=32.5", yf = " +lon_0=-117", gf = " +k=1.000015", vf = " +k=1.000034", bf = " +k=1.000031", xf = " +k=1.000026", wf = " +ellps=evrstSS", _f = " +a=6377301.243", Af = " +towgs84=410.721,55.049,80.746,2.5779,2.3514,0.6664,17.3311", Ef = " +towgs84=72.438,345.918,79.486,1.6045,0.8823,0.5565,1.3746", Sf = " +pm=ferro", Mf = " +lon_0=78", kf = " +lon_0=10", Nf = " +pm=paris", Cf = " +towgs84=0.055,-0.541,-0.185,0.0183,-0.0003,-0.007,-0.014", Df = " +towgs84=446.448,-125.157,542.06,0.15,0.247,0.842,-20.489", Of = " +towgs84=8.853,-52.644,180.304,-0.393,-2.323,2.96,-24.081", Tf = " +towgs84=572.213,85.334,461.94,4.9732,1.529,5.2484,3.5378", Ff = " +zone=58", Pf = " +zone=23", If = " +x_0=304800.6096012192", Bf = " +y_0=152400.3048006096", jf = " +x_0=800000.0001016001", Rf = " +x_0=399999.9998983998", Lf = " +x_0=7999999.999968001", qf = " +x_0=5999999.999976001", Uf = " +x_0=830000.0001016001", zf = " +x_0=249999.9998983998", Gf = " +x_0=350000.0001016001", Hf = " +to_meter=0.3047972654", Wf = " +x_0=99999.99989839978", $f = " +y_0=8000000.000010163", Vf = " +x_0=699999.9999898402", Zf = " +lon_0=-69", Yf = " +lon_0=-86", Kf = " +towgs84=-3.2,-5.7,2.8,0,0,0,0", Xf = " +x_0=8500000", Jf = " +x_0=9500000", Qf = " +lat_1=39.45", th = " +lat_0=44.25", eh = " +lat_1=41.95", rh = " +lat_2=35.25", nh = " +lat_2=34.65", ih = " +lat_2=44.25", oh = " +lat_1=47.05", ah = " +lat_1=40.25", sh = " +k_0=1.00012", uh = " +lat_0=40.25", lh = " +zone=40", ch = " +zone=36", fh = " +zone=51", hh = " +zone=48", ph = " +zone=49", dh = " +lon_0=96", mh = " +y_0=750000", yh = " +lat_0=36.5", gh = " +lon_0=-119", vh = " +lat_0=33.5", bh = " +lat_2=41.2", xh = " +k=0.999995", wh = " +lat_2=33.3", _h = " +lat_0=38.5", Ah = " +lon_0=-154", Eh = " +lon_0=-120", Sh = " +x_0=34500000", Mh = " +x_0=35500000", kh = " +x_0=36500000", Nh = " +x_0=37500000", Ch = " +x_0=38500000", Dh = " +x_0=39500000", Oh = " +x_0=40500000", Th = " +x_0=41500000", Fh = " +x_0=43500000", Ph = " +x_0=45500000", Ih = " +y_0=3999999.99998984", Bh = " +y_0=2000000.00001016", jh = " +towgs84=164,138,-189,0,0,0,0", Rh = " +towgs84=-186,230,110,0,0,0,0", Lh = " +towgs84=-199,32,322,0,0,0,0", qh = " +to_meter=0.3047997101815088", Uh = " +towgs84=-76,-138,67,0,0,0,0", zh = " +towgs84=-43,-163,45,0,0,0,0", Gh = " +towgs84=-346,-1,224,0,0,0,0", Hh = " +towgs84=210,814,289,0,0,0,0", Wh = " +towgs84=-74,-130,42,0,0,0,0", $h = " +zone=15", Vh = " +zone=16", Zh = " +zone=34", Yh = " +zone=50", Kh = " +zone=52", Xh = " +lon_0=-62", Jh = " +lon_0=-84", Qh = " +lon_0=-79", tp = " +lon_0=131", ep = " +lon_0=153", rp = " +lon_0=165", np = " +lon_0=-94", ip = " +lon_0=-54", op = " +a=6378300.789", ap = " +b=6356566.435", sp = " +y_0=3999999.9998984", up = " +y_0=5000000.0001016", lp = " +x_0=150000.00001464", cp = " +lat_2=46", fp = " +lon_0=84", hp = " +lat_0=43", pp = " +k_0=0.999625769", dp = " +towgs84=51,391,-36,0,0,0,0", mp = " +towgs84=-83,37,124,0,0,0,0", yp = " +towgs84=-355,21,72,0,0,0,0", gp = " +towgs84=-23,259,-9,0,0,0,0", vp = " +towgs84=174.05,-25.49,112.57,-0,-0,0.554,0.2263", bp = " +zone=59", xp = " +zone=25", wp = " +zone=11", _p = " +zone=12", Ap = " +zone=13", Ep = " +zone=54", Sp = " +zone=14", Mp = " +zone=24", kp = " +zone=47", Np = " +lat_2=38.3", Cp = " +lat_1=45.7", Dp = " +lat_2=42.1", Op = " +x_0=165000", Tp = " +lat_2=32.5", Fp = " +x_0=609600", Pp = " +lat_1=39.2", Ip = " +lat_2=47.5", Bp = " +lat_1=30.7", jp = " +lat_2=29.3", Rp = " +lat_0=28.5", Lp = " +lat_1=41.7", qp = " +lat_1=44.4", Up = " +lat_1=27.5", zp = " +lon_0=-150", Gp = " +lat_0=44.5", Hp = " +k=1.000027", Wp = " +k=1.000038", $p = " +k=1.000036", Vp = " +lon_0=-87.5", Zp = " +x_0=3999999.999984", Yp = " +x_0=199999.9999992", Kp = " +towgs84=16,196,93,0,0,0,0", Xp = " +towgs84=-88,4,101,0,0,0,0", Jp = " +lat_0=18", Qp = " +lat_2=67", td = " +lon_0=-96", ed = " +x_0=80000", rd = " +lon_0=-82", nd = " +lon_0=-74", id = " +lon_0=147", od = " +lon_0=150", ad = " +x_0=40000", sd = " +k=1.00002", ud = " +x_0=42500000", ld = " +x_0=44500000", cd = " +lon_0=-85.05", fd = " +ellps=mod_airy", hd = " +lat_0=0.1333333333333333", pd = " +lat_1=-60.66666666666666", dd = " +lat_2=-63.33333333333334", md = " +lon_0=-91.91666666666667", yd = " +y_0=0.003352806705613411", gd = " +zone=30", vd = " +lon_0=3", bd = " +zone=26", xd = " +zone=53", wd = " +lat_0=31.73439361111111", _d = " +lon_0=35.20451694444445", Ad = " +lon_0=7.439583333333333", Ed = " +lon_0=132.1666666666667", Sd = " +lon_0=134.3333333333333", Md = " +lon_0=137.1666666666667", kd = " +lon_0=139.8333333333333", Nd = " +lon_0=140.8333333333333", Cd = " +lon_0=3.192280555555556", Dd = " +lat_1=49.50000000000001", Od = " +lat_0=49.50000000000001", Td = " +alpha=53.31582047222222", Fd = " +lon_0=10.33333333333333", Pd = " +lon_0=16.33333333333333", Id = " +towgs84=-502.862,-247.438,312.724,0,0,0,0", Bd = " +towgs84=-381.788,-57.501,-256.673,0,0,0,0", jd = " +towgs84=-43.685,-179.785,-267.721,0,0,0,0", Rd = " +zone=60", Ld = " +zone=55", qd = " +lon_0=36", Ud = " +lon_0=42", zd = " +lat_1=46", Gd = " +lat_1=44", Hd = " +lat_0=42", Wd = " +lon_0=51", $d = " +lat_0=33", Vd = " +lat_0=52", Zd = " +ellps=airy", Yd = " +pm=jakarta", Kd = " +x_0=2743195.5", Xd = " +y_0=-4354009.816", Jd = " +k_0=0.9987864078000001", Qd = " +towgs84=-106.226,166.366,-37.893,0,0,0,0", tm = " +towgs84=508.088,-191.042,565.223,0,0,0,0", em = " +k=0.99996", rm = " +a=6378135", nm = " +lon_0=-66", im = " +lon_0=141", om = " +lon_0=159", am = " +k=0.99984", sm = " +lat_0=-22", um = " +lon_0=127.5", lm = " +x_0=6000000", cm = " +x_0=3900000", fm = " +y_0=1300000", hm = " +lat_0=44.75", pm = " +lat_0=37.75", dm = " +lat_0=40.55", mm = " +lon_0=-87.3", ym = " +lon_0=-86.5", gm = " +towgs84=195.671,332.517,274.607,0,0,0,0", vm = " +towgs84=-204.619,140.176,55.226,0,0,0,0", bm = "+proj=somerc", xm = " +y_0=30480.06096012192", wm = " +y_0=999999.9999960001", _m = " +x_0=182880.3657607315", Am = " +towgs84=674.374,15.056,405.346,0,0,0,0", Em = " +towgs84=-133.63,-157.5,-158.62,0,0,0,0", Sm = " +towgs84=-0.465,372.095,171.736,0,0,0,0", Mm = " +towgs84=-56.263,16.136,-22.856,0,0,0,0", km = " +towgs84=-241.54,-163.64,396.06,0,0,0,0", Nm = " +zone=31", Cm = " +zone=10", Dm = " +zone=46", Om = " +x_0=304800.6096", Tm = " +y_0=152400.3048", Fm = " +alpha=337.25556", Pm = " +x_0=2546731.496", Im = " +gamma=337.25556", Bm = " +k_0=0.999625544", jm = " +towgs84=335.47,222.58,-230.94,0,0,0,0", Rm = " +towgs84=217.037,86.959,23.956,0,0,0,0", Lm = " +towgs84=-128.16,-282.42,21.93,0,0,0,0", qm = " +towgs84=103.25,-100.4,-307.19,0,0,0,0", Um = " +lon_0=31", zm = " +lon_0=18", Gm = " +lat_2=36", Hm = " +lat_0=29", Wm = " +lat_0=35", $m = " +lat_0=34", Vm = " +lon_0=63", Zm = " +lat_0=37", Ym = " +lat_2=65", Km = " +y_0=-4000000", Xm = " +y_0=914398.5", Jm = " +towgs84=-199.87,74.79,246.62,0,0,0,0", Qm = " +towgs84=-11.64,-348.6,291.98,0,0,0,0", ty = " +towgs84=-254.1,-5.36,-100.29,0,0,0,0", ey = " +towgs84=-206.1,-174.7,-87.7,0,0,0,0", ry = " +towgs84=-770.1,158.4,-498.2,0,0,0,0", ny = " +towgs84=-146.21,112.63,4.05,0,0,0,0", iy = " +towgs84=-294.7,-200.1,525.5,0,0,0,0", oy = " +lat_0=4", ay = " +a=6378300", sy = " +lon_0=-63", uy = " +lon_0=162", ly = " +lat_ts=90", cy = " +y_0=600000", fy = " +x_0=350000", hy = " +y_0=900000", py = " +lat_1=32.5", dy = " +lon_0=-147", my = " +k=1.000043", yy = " +lat_0=48.5", gy = " +lat_0=40.9", vy = " +k=1.000028", by = " +k=1.000025", xy = " +x_0=170251.555", wy = " +b=6356657.142669561", _y = " +b=6356094.667915204", Ay = " +b=6355862.933255573", Ey = " +a=6378249.144808011", Sy = " +b=6356514.966204134", My = " +towgs84=-70.9,-151.8,-41.4,0,0,0,0", ky = " +towgs84=52.17,-71.82,-14.9,0,0,0,0", Ny = " +towgs84=283.7,735.9,261.1,0,0,0,0", Cy = " +zone=5", Dy = " +zone=7", Oy = " +lon_0=19", Ty = " +lon_0=25", Fy = " +lat_2=45", Py = " +lon_0=57", Iy = " +lon_0=69", By = " +lat_2=39", jy = " +lat_2=35", Ry = " +lon_0=28", Ly = " +lon_0=-61.5", qy = " +lon_0=-64.5", Uy = " +lon_0=-90.5", zy = " +lon_0=-94.5", Gy = " +y_0=2800000", Hy = " +x_0=4321000", Wy = " +y_0=3210000", $y = " +y_0=14743.5", Vy = " +y_0=1999999.999992", Zy = " +y_0=2999999.999988", Yy = " +y_0=50000.00001504", Ky = " +zone=41", Xy = " +zone=42", Jy = " +k=0.994", Qy = " +zone=56", tg = " +lon_0=-67.875", eg = " +lon_0=-70.375", rg = " +x_0=609601.22", ng = " +b=6356889.449", ig = " +lon_0=-69.125", og = " +lon_0=-121.75", ag = " +lon_0=-121.25", sg = " +lon_0=-119.75", ug = " +lon_0=-122.75", lg = " +zone=6", cg = "+proj=krovak", fg = " +towgs84=-637,-549,-203,0,0,0,0", hg = " +towgs84=-20.8,11.3,2.4,0,0,0,0", pg = " +lon_0=-93", dg = " +lon_0=127", mg = " +lon_0=125", yg = " +k=0.99975", gg = " +lon_0=136", vg = " +lon_0=138", bg = " +lon_0=180", xg = " +y_0=50000", wg = " +lon_0=-85", _g = " +k=1.00016", Ag = " +lon_0=2.7", Eg = " +towgs84=27.5,14,186.4,0,0,0,0", Sg = " +towgs84=-499,-249,314,0,0,0,0", Mg = " +towgs84=-467,-16,-300,0,0,0,0", kg = " +towgs84=-382,-59,-262,0,0,0,0", Ng = " +towgs84=253,-132,-127,0,0,0,0", Cg = " +towgs84=-963,510,-359,0,0,0,0", Dg = " +towgs84=94,-948,-1262,0,0,0,0", Og = " +zone=1", Tg = " +zone=27", Fg = " +zone=57", Pg = " +pm=oslo", Ig = " +zone=43", Bg = " +lon_0=23", jg = " +lon_0=48", Rg = " +lon_0=54", Lg = " +lat_0=49.5", qg = " +k=0.999912", Ug = " +lon_0=-174", zg = " +lon_0=-168", Gg = " +lon_0=-170", Hg = " +lon_0=-165", Wg = " +lat_2=40.5", $g = " +lon_0=-115", Vg = " +lat_1=29.5", Zg = " +k=1.000045", Yg = " +lat_1=39.5", Kg = " +lat_1=33.3", Xg = " +lat_0=33.3", Jg = " +lon_0=-155.5", Qg = " +lon_0=-159.5", tv = " +y_0=-4480000", ev = " +lon_0=-176.5", rv = " +lon_0=-89.75", nv = " +k_0=1.000008", iv = " +lonc=-124.05", ov = " +k_0=1.000002", av = " +lon_0=-122.5", sv = " +lon_0=-98.25", uv = " +lon_0=-112.5", lv = " +lon_0=-84.95", cv = " +lon_0=-86.95", fv = " +lon_0=-85.45", hv = " +lon_0=-87.45", pv = " +lon_0=-87.55", dv = " +towgs84=-149,128,296,0,0,0,0", mv = " +towgs84=-425,-169,81,0,0,0,0", yv = " +towgs84=-104,167,-38,0,0,0,0", gv = " +towgs84=-106,-87,188,0,0,0,0", vv = " +towgs84=-289,-124,60,0,0,0,0", bv = " +towgs84=137,248,-430,0,0,0,0", xv = " +towgs84=-13,-348,292,0,0,0,0", wv = " +towgs84=-115,118,426,0,0,0,0", _v = " +towgs84=0,-0.15,0.68,0,0,0,0", Av = " +towgs84=145,-187,103,0,0,0,0", Ev = " +towgs84=-134,229,-29,0,0,0,0", Sv = " +towgs84=70,207,389.5,0,0,0,0", Mv = " +towgs84=-148,51,-291,0,0,0,0", kv = " +towgs84=-255,-15,71,0,0,0,0", Nv = " +towgs84=725,685,536,0,0,0,0", Cv = " +towgs84=72,213.7,93,0,0,0,0", Dv = " +towgs84=174,359,365,0,0,0,0", Ov = " +towgs84=-173,253,27,0,0,0,0", Tv = " +towgs84=-203,141,53,0,0,0,0", Fv = " +towgs84=186,482,151,0,0,0,0", Pv = " +towgs84=162,117,154,0,0,0,0", Iv = " +towgs84=-73,213,296,0,0,0,0", Bv = " +towgs84=-130,29,364,0,0,0,0", jv = " +towgs84=-10,375,165,0,0,0,0", Rv = " +towgs84=175,-38,113,0,0,0,0", Lv = " +to_meter=0.9143984146160287", qv = " +zone=2", Uv = " +zone=8", zv = " +zone=9", Gv = " +zone=4", Hv = " +towgs84=30,430,368,0,0,0,0", Wv = " +towgs84=185,165,42,0,0,0,0", $v = " +towgs84=-97,787,86,0,0,0,0", Vv = " +towgs84=639,405,60,0,0,0,0", Zv = " +zone=44", Yv = " +zone=45", Kv = " +lon_0=-58.5", Xv = " +lon_0=-67.5", Jv = " +lon_0=-73.5", Qv = " +lon_0=-76.5", tb = " +y_0=1200000", eb = " +lon_0=133.5", rb = " +x_0=8000000", nb = " +y_0=8000000", ib = " +k=0.9998335", ob = " +lon_0=-85.5", ab = " +x_0=7000000", sb = " +lat_0=43.75", ub = " +lat_0=43.25", lb = " +lat_0=45.25", cb = " +lon_0=-86.3", fb = " +lat_0=38.15", hb = " +lat_0=39.15", pb = " +lat_0=41.25", db = " +lat_0=40.65", mb = " +lat_0=39.25", yb = " +lat_0=40.35", gb = " +lon_0=-85.8", vb = " +towgs84=9,183,236,0,0,0,0", bb = " +towgs84=-48,55,52,0,0,0,0", xb = " +towgs84=84,274,65,0,0,0,0", wb = " +lon_0=17", _b = " +lat_1=60", Ab = " +k=0.9998", Eb = " +lon_0=66", Sb = " +lon_0=20", Mb = " +lon_0=26", kb = " +lat_0=51", Nb = " +lat_1=87", Cb = " +lat_1=26", Db = " +lon_0=144", Ob = " +lon_0=168", Tb = " +lon_0=174", Fb = " +lon_0=-72", Pb = " +lon_0=-75", Ib = " +lon_0=-60", Bb = " +lon_0=-39", jb = "+proj=poly", Rb = " +x_0=219529.584", Lb = " +a=6378306.3696", qb = " +lon_0=-61.33333333333334", Ub = " +lon_0=-91.86666666666666", zb = " +lon_0=-8.131906111111112", Gb = " +lon_0=-83.66666666666667", Hb = " +lon_0=-108.4166666666667", Wb = " +lon_0=-108.3333333333333", $b = " +lon_0=-85.40000000000001", Vb = " +lon_0=-86.65000000000001", Zb = " +lon_0=-86.40000000000001", Yb = " +lon_0=-85.59999999999999", Kb = " +lon_0=-87.15000000000001", Xb = " +lon_0=-86.59999999999999", Jb = " +lon_0=-84.90000000000001", Qb = " +lon_0=-85.65000000000001", tx = " +lon_0=-87.65000000000001", ex = " +lon_0=-85.34999999999999", rx = " +lon_0=-87.40000000000001", nx = " +lon_0=-87.34999999999999", ix = " +lon_0=-85.90000000000001", ox = " +lon_0=-90.62222222222222", ax = " +lon_0=-91.84999999999999", sx = " +lon_0=-91.15277777777779", ux = " +lon_0=-91.79722222222222", lx = " +lon_0=-92.45777777777778", cx = " +lon_0=-91.29444444444444", fx = " +lon_0=-90.70833333333334", hx = " +lon_0=-89.39444444444445", px = " +lon_0=-89.42222222222223", dx = " +lon_0=-88.77500000000001", mx = " +lon_0=-87.27222222222223", yx = " +lon_0=-91.89444444444445", gx = " +lon_0=-91.28888888888889", vx = " +lon_0=-88.14166666666668", bx = " +lon_0=-88.63333333333334", xx = " +lon_0=-89.83888888888889", wx = " +lon_0=-90.16111111111111", _x = " +lon_0=-90.25555555555556", Ax = " +lon_0=-90.84429651944444", Ex = " +lon_0=-87.89444444444445", Sx = " +lon_0=-91.31666666666666", Mx = " +lon_0=-89.03333333333333", kx = " +lon_0=-89.73333333333333", Nx = " +lon_0=-87.71111111111111", Cx = " +lon_0=-88.41666666666667", Dx = " +lon_0=-90.64166666666668", Ox = " +lon_0=-87.90833333333335", Tx = " +lon_0=-89.54444444444444", Fx = " +lon_0=-92.22777777777777", Px = " +lon_0=-90.48888888888889", Ix = " +lon_0=-90.43055555555556", Bx = " +lon_0=-89.07222222222222", jx = " +lon_0=-91.06666666666666", Rx = " +lon_0=-89.90000000000001", Lx = " +lon_0=-91.11666666666666", qx = " +lon_0=-88.60555555555555", Ux = " +lon_0=-90.48333333333333", zx = " +lon_0=-91.36666666666666", Gx = " +lon_0=-90.78333333333333", Hx = " +lon_0=-89.48888888888889", Wx = " +lon_0=-88.54166666666667", $x = " +lon_0=-91.78333333333333", Vx = " +lon_0=-88.06388888888888", Zx = " +lon_0=-88.22499999999999", Yx = " +lon_0=-88.81666666666666", Kx = " +y_0=0.004876809753619507", Xx = " +y_0=0.008534417068834137", Jx = " +y_0=0.003962407924815849", Qx = " +y_0=0.005791211582423164", tw = " +lon_0=-55.68333333333333", ew = " +to_meter=0.201166195164", rw = " +lat_0=4.666666666666667", nw = " +lat_0=6.666666666666667", iw = " +lon_0=6.166666666666667", ow = " +lat_0=10.44166666666667", aw = " +lat_0=22.31213333333334", sw = " +lon_0=114.1785555555556", uw = " +lon_0=51.21666666666667", lw = " +lon_0=11.30827777777778", cw = " +lon_0=13.55827777777778", fw = " +lon_0=15.80827777777778", hw = " +lon_0=18.05827777777778", pw = " +lon_0=20.30827777777778", dw = " +lon_0=22.55827777777778", mw = " +lat_1=27.41666666666667", yw = " +lat_2=34.91666666666666", gw = " +lat_0=31.16666666666667", vw = " +lat_1=59.33333333333334", bw = " +lat_0=57.51755393055556", xw = " +lon_0=4.359215833333333", ww = " +lat_1=61.66666666666666", _w = " +lat_0=29.02626833333333", Aw = " +lat_1=48.66666666666666", Ew = " +lat_2=53.66666666666666", Sw = " +lon_0=127.0028902777778", Mw = " +lon_0=89.84999999999999", kw = " +lon_0=91.56666666666666", Nw = " +lon_0=24.83333333333333", Cw = " +lat_2=63.66666666666666", Dw = " +lat_0=65.35103930555555", Ow = " +lat_1=63.66666666666666", Tw = " +lat_2=60.33333333333334", Fw = " +lat_0=62.01530688888889", Pw = " +lat_1=45.78333333333333", Iw = " +lat_0=45.78333333333333", Bw = " +lat_0=42.66666666666666", jw = " +lat_0=43.36666666666667", Rw = " +lat_0=45.70611111111111", Lw = " +lat_0=45.13333333333333", qw = " +lat_1=46.66964837722222", Uw = " +lat_0=46.66964837722222", zw = " +lat_0=43.48138888888889", Gw = " +lat_1=45.89871486583333", Hw = " +lat_0=45.89871486583333", Ww = " +lat_0=42.71944444444445", $w = " +lat_1=44.97785689861112", Vw = " +lat_0=44.97785689861112", Zw = " +lat_1=43.46254664583333", Yw = " +lat_0=43.46254664583333", Kw = " +lon_0=-90.9388888888889", Xw = " +lat_0=41.47222222222222", Jw = " +lat_0=45.88333333333333", Qw = " +lat_0=44.40833333333333", t_ = " +lat_1=44.87228112638889", e_ = " +lat_0=44.87228112638889", r_ = " +lat_0=45.43888888888888", n_ = " +lat_0=44.00555555555555", i_ = " +lat_0=41.41111111111111", o_ = " +lat_1=42.63756227694444", a_ = " +lat_0=42.63756227694444", s_ = " +lat_1=43.80700011777778", u_ = " +lat_0=43.80700011777778", l_ = " +lat_0=42.53888888888888", c_ = " +lat_0=45.43333333333333", f_ = " +lat_0=44.25333512777778", h_ = " +lat_0=42.21666666666667", p_ = " +lat_0=43.26666666666667", d_ = " +lat_0=43.45111111111111", m_ = " +lat_1=45.15423710527778", y_ = " +lat_0=45.15423710527778", g_ = " +lat_0=44.84444444444445", v_ = " +lat_1=44.90090442361111", b_ = " +lat_0=44.90090442361111", x_ = " +lat_0=44.69166666666666", w_ = " +lat_0=44.71666666666667", __ = " +lat_1=44.00007392861111", A_ = " +lat_0=44.00007392861111", E_ = " +lat_0=44.39722222222222", S_ = " +lat_1=45.70422377027778", M_ = " +lat_0=45.70422377027778", k_ = " +lat_1=44.63614887194444", N_ = " +lat_0=44.63614887194444", C_ = " +lat_0=44.66111111111111", D_ = " +lat_1=44.41682397527777", O_ = " +lat_0=44.41682397527777", T_ = " +lat_0=44.55555555555555", F_ = " +lat_0=41.94444444444444", P_ = " +lat_0=43.91944444444444", I_ = " +lat_0=42.81944444444445", B_ = " +lat_1=45.90009913138888", j_ = " +lat_0=45.90009913138888", R_ = " +lat_1=45.17782208583333", L_ = " +lat_0=45.17782208583333", q_ = " +lat_0=43.16111111111111", U_ = " +lat_1=43.57503293972223", z_ = " +lat_0=43.57503293972223", G_ = " +lat_1=46.07784409055556", H_ = " +lat_0=46.07784409055556", W_ = " +lat_1=42.66946209694444", $_ = " +lat_0=42.66946209694444", V_ = " +lat_1=45.96121983333334", Z_ = " +lat_0=45.96121983333334", Y_ = " +lat_0=42.91805555555555", K_ = " +lat_0=42.56944444444445", X_ = " +lat_0=43.42027777777778", J_ = " +lat_1=44.11394404583334", Q_ = " +lat_0=44.11394404583334", tA = " +lat_1=44.36259546944444", eA = " +lat_0=44.36259546944444", rA = " +lat_1=44.10000000000001", nA = " +lat_0=44.10000000000001", iA = " +lat_1=42.16500000000001", oA = " +lat_0=42.16500000000001", aA = " +lat_0=52.15616055555555", sA = " +lat_2=48.73333333333333", uA = " +zone=3", lA = " +lat_0=53.5", cA = " +k=0.999923", fA = " +x_0=850000", hA = " +x_0=830000", pA = " +lon_0=16.5", dA = " +x_0=520000", mA = " +lat_2=31.5", yA = " +lon_0=10.5", gA = " +lat_1=44.5", vA = " +lon_0=-153", bA = " +lon_0=-135", xA = " +x_0=750000", wA = " +lat_0=43.5", _A = " +lon_0=-142", AA = " +lon_0=-146", EA = " +lon_0=-162", SA = " +lon_0=-166", MA = " +lon_0=-176", kA = " +lat_2=39.5", NA = " +lon_0=-129", CA = " +k_0=1.0002", DA = " +k=1.000023", OA = " +lon_0=-121", TA = " +k=1.000175", FA = " +lat_0=45.5", PA = " +k=1.000155", IA = " +lat_2=37.5", BA = " +lat_1=48.5", jA = " +k=1.000029", RA = " +lat_0=39.6", LA = " +k=1.000013", qA = " +k=1.000022", UA = " +lat_0=40.7", zA = " +lat_0=39.3", GA = " +lat_0=37.8", HA = " +lat_0=38.9", WA = " +lon_0=-5.4", $A = " +y_0=626907.39", VA = " +b=6356571.996", ZA = " +a=6377295.664", YA = " +lon_0=5.38763888888889", KA = " +y_0=-4600000.00001208", XA = " +y_0=1889763.779527559", JA = " +y_0=99999.99999960001", QA = " +x_0=120091.4401828804", tE = " +lon_0=72", eE = " +lat_0=50", rE = " +lat_1=50", nE = " +lat_1=35", iE = " +lon_0=22", oE = " +lat_1=34", aE = " +lonc=115", sE = " +lat_0=-9", uE = " +lat_0=23", lE = " +lat_1=85", cE = " +lat_2=69", fE = " +lat_1=69", hE = " +lat_2=61", pE = " +lon_0=34", dE = " +lon_0=140.25", mE = " +lon_0=142.25", yE = " +lon_0=144.25", gE = " +x_0=47500000", vE = " +y_0=-3000000", bE = " +pm=2.337208333333333", xE = " +x_0=7000000.00000248", wE = " +lon_0=6", _E = " +k=0.997", AE = " +lon_0=106", EE = " +lon_0=154", SE = " +lon_0=156", ME = " +lat_2=-36", kE = " +lon_0=119", NE = " +lon_0=121", CE = " +lon_0=166", DE = " +a=6371228", OE = " +b=6371228", TE = " +a=6378273", FE = " +lat_0=-44", PE = " +pm=lisbon", IE = " +lon_0=-57", BE = " +lon_0=-56", jE = " +k=1.00007", RE = " +lonc=-123", LE = " +alpha=295", qE = " +gamma=295", UE = " +k=1.00011", zE = " +k=1.00005", GE = " +k=1.00013", HE = " +x_0=30000", WE = " +k=1.00001", $E = " +k=1.00003", VE = " +y_0=130000.00001472", ZE = " +x_0=119999.99999952", YE = " +y_0=-2999999.999988", KE = " +x_0=-299999.9999988", XE = " +lat_1=43.0695160375", JE = " +lat_0=43.0695160375", QE = " +lat_1=43.3223129275", tS = " +lat_0=43.3223129275", eS = " +k=1.0000067", rS = " +a=6378298.3", nS = " +lon_0=-66.5", iS = " +lon_0=129.5", oS = " +lon_0=138.5", aS = " +x_0=2300000", sS = " +x_0=3300000", uS = " +x_0=4300000", lS = " +y_0=7500000", cS = " +lonc=102.25", fS = " +y_0=1166200", hS = " +x_0=3000000", pS = " +lat_1=46.25", dS = " +ellps=WGS66", mS = " +ellps=GRS67", yS = " +lat_1=34.65", gS = " +y_0=59999.99999976", vS = " +y_0=30000.00001512", bS = " +x_0=59999.99999976", xS = " +x_0=30000.00001512", wS = " +lat_1=43.200055605", _S = " +lat_0=43.200055605", AS = " +y_0=65379.0134283", ES = " +alpha=323.0257905", SS = " +alpha=53.31580995", MS = " +x_0=10000.0000152";
            t.exports = [
                2e3,
                o + p + Xh + ui + Z + m + D + a + r,
                1,
                o + p + Xh + ui + Z + m + D + kv + a + r,
                1,
                o + p + Xh + ui + Z + m + D + Nv + a + r,
                1,
                o + p + Xh + ui + Z + m + D + Cv + a + r,
                1,
                o + p + Xh + ui + Z + m + D + Dv + a + r,
                1,
                o + p + Xh + ui + Z + m + D + vb + a + r,
                1,
                o + p + Xh + ui + Z + m + D + dv + a + r,
                1,
                o + p + Xh + ui + Z + m + D + gm + a + r,
                2,
                o + p + Kv + A + kt + m + B + a + r,
                1,
                o + p + Ly + A + kt + m + B + a + r,
                1,
                o + p + qy + A + kt + m + B + a + r,
                1,
                o + p + Xv + A + kt + m + B + a + r,
                1,
                o + p + Xs + A + kt + m + B + a + r,
                1,
                o + p + Jv + A + kt + m + B + a + r,
                1,
                o + p + Qv + A + kt + m + B + a + r,
                1,
                o + p + ya + A + kt + m + B + a + r,
                1,
                o + p + Jv + A + kt + m + B + a + r,
                1,
                o + p + Qv + A + kt + m + B + a + r,
                1,
                o + p + ya + A + kt + m + B + a + r,
                1,
                o + p + hi + A + kt + m + B + a + r,
                1,
                o + p + pr + A + kt + m + B + a + r,
                1,
                o + p + Jh + A + kt + m + B + a + r,
                1,
                o + p + gl + A + kt + m + B + a + r,
                1,
                o + p + He + A + kt + m + B + a + r,
                1,
                o + p + pg + A + kt + m + B + a + r,
                1,
                o + p + td + A + kt + m + B + a + r,
                1,
                c + $h + B + a + r,
                1,
                c + Vh + B + a + r,
                1,
                c + _u + B + a + r,
                1,
                c + zs + B + a + r,
                1,
                c + _u + B + a + r,
                1,
                c + zs + B + a + r,
                1,
                c + _s + B + a + r,
                1,
                c + Ua + B + a + r,
                1,
                c + Gs + B + a + r,
                4,
                o + wd + _d + eS + Rb + $A + i + bb + a + r,
                1,
                c + gd + D + Ju + a + r,
                1,
                c + gd + D + Hs + a + r,
                1,
                c + Bl + D + Ju + a + r,
                1,
                c + Bl + D + Hs + a + r,
                1,
                o + p + ai + " +k=1" + Ts + m + d + Za + a + r,
                1,
                o + p + zo + " +k=1" + Fs + m + d + Za + a + r,
                1,
                o + p + Sa + " +k=1" + $ + m + Ma + j + n + a + r,
                1,
                o + p + wb + " +k=1" + $ + m + Ma + j + n + a + r,
                1,
                o + p + Oy + " +k=1" + $ + m + Ma + j + n + a + r,
                1,
                o + p + ka + " +k=1" + $ + m + Ma + j + n + a + r,
                1,
                o + p + Bg + " +k=1" + $ + m + Ma + j + n + a + r,
                1,
                o + p + Ty + " +k=1" + $ + m + Ma + j + n + a + r,
                1,
                o + p + rs + " +k=1" + $ + m + Ma + j + n + a + r,
                1,
                o + p + " +lon_0=29 +k=1" + $ + m + Ma + j + n + a + r,
                1,
                o + p + Um + " +k=1" + $ + m + Ma + j + n + a + r,
                1,
                o + p + $s + " +k=1" + $ + m + Ma + j + n + a + r,
                1,
                bm + gc + Ad + " +k_0=1 +x_0=2600000" + tb + M + Am + a + r,
                1,
                yr + " +lat_0=27.51882880555555 +lonc=52.60353916666667 +alpha=0.5716611944444444 +k=0.999895934 +x_0=658377.437 +y_0=3044969.194 +gamma=0.5716611944444444" + b + Em + a + r,
                1,
                c + ll + b + qa + a + r,
                1,
                c + Ku + b + qa + a + r,
                1,
                c + lh + b + qa + a + r,
                1,
                c + Ky + b + qa + a + r,
                1,
                l + " +lat_1=40" + Bo + es + " +k_0=0.9988085293" + N + cy + rS + wy + " +pm=madrid" + a + r,
                3,
                cg + Lg + " +lon_0=42.5" + vc + A + $ + m + M + Aa + Sf + a + r,
                1,
                Tr + " +lat_0=11.25217861111111 +lon_0=-60.68600888888889 +x_0=37718.66159325 +y_0=36209.91512952" + Ai + Ei + ew + r,
                1,
                c + Ua + b + Sm + a + r,
                1,
                o + p + jl + A + I + m + b + Y + a + r,
                1,
                o + p + " +lon_0=11" + A + I + m + b + Y + a + r,
                1,
                o + p + " +lon_0=13" + A + I + m + b + Y + a + r,
                1,
                o + p + Sa + A + I + m + b + Y + a + r,
                1,
                o + p + wb + A + I + m + b + Y + a + r,
                1,
                o + p + Oy + A + I + m + b + Y + a + r,
                1,
                o + p + ka + A + I + m + b + Y + a + r,
                1,
                o + p + Bg + A + I + m + b + Y + a + r,
                1,
                o + p + Ty + A + I + m + b + Y + a + r,
                1,
                c + Xu + b + Y + a + r,
                1,
                c + Rl + b + Y + a + r,
                1,
                c + Zh + b + Y + a + r,
                1,
                c + yc + b + Y + a + r,
                1,
                o + q + Zf + " +k=1" + Dr + m + b + a + r,
                1,
                o + q + Zf + " +k=1" + Dr + m + b + Eg + a + r,
                1,
                o + q + Zf + " +k=1" + Dr + m + b + Kp + a + r,
                1,
                c + _s + z + b + Kp + a + r,
                3,
                o + p + Vs + mt + y + m + b + Y + a + r,
                1,
                o + p + " +lon_0=11" + mt + y + m + xt + fe + Ea + a + r,
                1,
                c + ll + j + n + a + r,
                1,
                c + Ku + j + n + a + r,
                3,
                o + p + AE + " +k=1" + y + m + d + Za + a + r,
                1,
                o + p + AE + mt + y + m + w + v + a + r,
                1,
                c + cl + b + Ov + a + r,
                1,
                o + Cr + _i + " +k=1" + I + Dt + M + a + r,
                1,
                o + Cr + dg + " +k=1" + I + Dt + M + a + r,
                1,
                o + Cr + mg + " +k=1" + I + Dt + M + a + r,
                1,
                Tr + " +lat_0=25.38236111111111 +lon_0=50.76138888888889" + ve + ni + Ca + a + r,
                1,
                o + p + Zs + mt + y + m + i + Jm + a + r,
                1,
                l + bc + xc + Yl + " +k_0=1" + $ + " +y_0=-52684.972" + b + a + r,
                1,
                l + bc + xc + Yl + " +k_0=1" + I + " +y_0=147315.028" + b + a + r,
                1,
                l + bc + xc + Yl + " +k_0=1" + y + " +y_0=447315.028" + b + a + r,
                1,
                l + bc + xc + Yl + " +k_0=1 +x_0=-17044 +y_0=-23139.97" + b + a + r,
                1,
                o + " +lat_0=-36.87972222222222 +lon_0=174.7641666666667" + A + Z + cr + i + n + a + r,
                1,
                o + " +lat_0=-37.76111111111111 +lon_0=176.4661111111111 +k=1" + Z + cr + i + n + a + r,
                1,
                o + " +lat_0=-38.62444444444444 +lon_0=177.8855555555556 +k=1" + Z + cr + i + n + a + r,
                1,
                o + " +lat_0=-39.65083333333333 +lon_0=176.6736111111111 +k=1" + Z + cr + i + n + a + r,
                1,
                o + " +lat_0=-39.13555555555556 +lon_0=174.2277777777778 +k=1" + Z + cr + i + n + a + r,
                1,
                o + " +lat_0=-39.51222222222222 +lon_0=175.64 +k=1" + Z + cr + i + n + a + r,
                1,
                o + " +lat_0=-40.24194444444444 +lon_0=175.4880555555555 +k=1" + Z + cr + i + n + a + r,
                1,
                o + " +lat_0=-40.92527777777777 +lon_0=175.6472222222222 +k=1" + Z + cr + i + n + a + r,
                1,
                o + " +lat_0=-41.3011111111111 +lon_0=174.7763888888889 +k=1" + Z + cr + i + n + a + r,
                1,
                o + " +lat_0=-40.71472222222223 +lon_0=172.6719444444444 +k=1" + Z + cr + i + n + a + r,
                1,
                o + " +lat_0=-41.27444444444444 +lon_0=173.2991666666667 +k=1" + Z + cr + i + n + a + r,
                1,
                o + " +lat_0=-41.28972222222222 +lon_0=172.1088888888889 +k=1" + Z + cr + i + n + a + r,
                1,
                o + " +lat_0=-41.81055555555555 +lon_0=171.5811111111111 +k=1" + Z + cr + i + n + a + r,
                1,
                o + " +lat_0=-42.33361111111111 +lon_0=171.5497222222222 +k=1" + Z + cr + i + n + a + r,
                1,
                o + " +lat_0=-42.68888888888888 +lon_0=173.01 +k=1" + Z + cr + i + n + a + r,
                1,
                o + " +lat_0=-41.54444444444444 +lon_0=173.8019444444444 +k=1" + Z + cr + i + n + a + r,
                1,
                o + " +lat_0=-42.88611111111111 +lon_0=170.9797222222222 +k=1" + Z + cr + i + n + a + r,
                1,
                o + " +lat_0=-43.11 +lon_0=170.2608333333333 +k=1" + Z + cr + i + n + a + r,
                1,
                o + " +lat_0=-43.97777777777778 +lon_0=168.6061111111111 +k=1" + Z + cr + i + n + a + r,
                1,
                o + " +lat_0=-43.59055555555556 +lon_0=172.7269444444445 +k=1" + Z + cr + i + n + a + r,
                1,
                o + " +lat_0=-43.74861111111111 +lon_0=171.3605555555555 +k=1" + Z + cr + i + n + a + r,
                1,
                o + " +lat_0=-44.40194444444445 +lon_0=171.0572222222222 +k=1" + Z + cr + i + n + a + r,
                1,
                o + " +lat_0=-44.735 +lon_0=169.4675 +k=1" + Z + cr + i + n + a + r,
                1,
                o + " +lat_0=-45.13277777777778 +lon_0=168.3986111111111 +k=1" + Z + cr + i + n + a + r,
                1,
                o + " +lat_0=-45.56361111111111 +lon_0=167.7386111111111 +k=1" + Z + cr + i + n + a + r,
                1,
                o + " +lat_0=-45.81611111111111 +lon_0=170.6283333333333 +k=1" + Z + cr + i + n + a + r,
                1,
                o + " +lat_0=-45.86138888888889 +lon_0=170.2825" + em + Z + cr + i + n + a + r,
                1,
                o + " +lat_0=-46.6 +lon_0=168.3427777777778 +k=1" + Z + cr + i + n + a + r,
                1,
                c + Ff + z + i + n + a + r,
                1,
                c + bp + z + i + n + a + r,
                1,
                c + Rd + z + i + n + a + r,
                1,
                o + rw + " +lon_0=-1" + yg + " +x_0=274319.7391633579" + m + ay + Ns + Lh + qh + r,
                1,
                o + p + " +lon_0=-1" + mt + y + m + ay + Ns + Lh + a + r,
                1,
                l + _b + cp + fu + Xa + $ + m + B + a + r,
                16,
                l + $c + " +lat_2=44" + Nu + vd + mi + " +y_0=6600000" + i + n + a + r,
                3,
                o + lA + " +lon_0=-8 +k=0.99982" + N + mh + i + n + a + r,
                1,
                c + Bl + i + n + a + r,
                1,
                o + nw + " +lon_0=-12 +k=1 +x_0=152399.8550907544" + m + ay + Ns + qh + r,
                1,
                o + nw + " +lon_0=-12 +k=1 +x_0=243839.7681452071 +y_0=182879.8261089053" + ay + Ns + qh + r,
                1,
                c + cl + D + Xp + a + r,
                1,
                c + Bl + D + Xp + a + r,
                1,
                vs + eu + dr + $ + m + " +a=6370997 +b=6370997" + a + r,
                1,
                o + p + " +lon_0=-5" + mt + y + m + D + Ju + a + r,
                1,
                o + p + " +lon_0=-5" + mt + y + m + D + Hs + a + r,
                4,
                o + " +lat_0=49.83333333333334" + iw + " +k=1" + ed + ni + b + Fl + a + r,
                3,
                ca + " +lat_0=53.00194444444445 +lon_0=21.50277777777778" + Ab + " +x_0=4603000 +y_0=5806000" + d + C + a + r,
                1,
                ca + " +lat_0=53.58333333333334 +lon_0=17.00833333333333" + Ab + " +x_0=3501000 +y_0=5999000" + d + C + a + r,
                1,
                ca + " +lat_0=51.67083333333333 +lon_0=16.67222222222222" + Ab + " +x_0=3703000 +y_0=5627000" + d + C + a + r,
                1,
                o + p + " +lon_0=18.95833333333333 +k=0.999983 +x_0=237000 +y_0=-4700000" + d + C + a + r,
                1,
                o + p + Sa + cA + Si + m + i + n + a + r,
                1,
                o + p + zm + cA + Cl + m + i + n + a + r,
                1,
                o + p + ka + cA + Js + m + i + n + a + r,
                1,
                o + p + Zs + cA + Xf + m + i + n + a + r,
                1,
                o + p + Oy + " +k=0.9993" + y + " +y_0=-5300000" + i + n + a + r,
                8,
                c + xp + b + mv + a + r,
                1,
                c + bd + b + yv + a + r,
                1,
                c + bd + b + Tv + a + r,
                3,
                o + p + " +lon_0=173" + mt + " +x_0=1600000" + Bt + i + n + a + r,
                2,
                c + qv + z + i + n + a + r,
                1,
                o + p + " +lon_0=9.5" + fr + I + m + i + n + a + r,
                1,
                o + p + Vs + fr + y + m + i + n + a + r,
                1,
                o + p + Sa + " +k=1" + ss + m + i + n + a + r,
                2,
                ca + Nu + nS + qg + ut + cr + rm + Ta + a + r,
                1,
                c + zs + i + n + a + r,
                1,
                c + _s + i + n + a + r,
                1,
                c + Ua + i + n + a + r,
                1,
                l + " +lat_1=35.25 +lat_2=36.41666666666666 +lat_0=34.66666666666666" + Yf + k + xm + S + f + r,
                1,
                l + Xt + yn + sn + El + y + m + i + n + a + r,
                1,
                o + p + rs + " +k=1" + Jf + m + b + U + a + r,
                1,
                o + p + hu + " +k=1" + of + m + b + U + a + r,
                1,
                o + p + $s + " +k=1" + Sl + m + b + U + a + r,
                1,
                o + p + qd + " +k=1" + af + m + b + U + a + r,
                1,
                o + p + Vc + " +k=1" + us + m + b + U + a + r,
                1,
                o + p + Ud + " +k=1" + Ra + m + b + U + a + r,
                1,
                o + p + rl + " +k=1" + Ps + m + b + U + a + r,
                1,
                o + p + hu + mt + y + m + i + n + a + r,
                2,
                c + Xu + xt + fe + My + a + r,
                1,
                c + Mu + b + jh + a + r,
                1,
                c + Pf + b + jh + a + r,
                2,
                c + _s + rm + Ta + a + r,
                1,
                c + Ua + rm + Ta + a + r,
                2,
                o + Ie + Ir + A + yi + m + i + n + V + r,
                1,
                o + Ie + Br + A + yi + m + i + n + V + r,
                1,
                o + Ie + Fu + ie + yi + m + i + n + V + r,
                1,
                l + gn + Al + J + za + Nt + nt + i + n + f + r,
                1,
                l + vn + bn + tt + za + Nt + nt + i + n + f + r,
                1,
                l + Ut + xn + yh + lt + Nt + nt + i + n + f + r,
                1,
                l + Zc + Gm + wn + gh + Nt + nt + i + n + f + r,
                1,
                l + _n + An + vh + Cu + Nt + nt + i + n + f + r,
                1,
                l + En + Sn + Mn + Pu + Nt + nt + i + n + f + r,
                1,
                l + Mi + ki + J + Ee + $e + sr + i + n + f + r,
                1,
                l + Yc + Kc + xr + Ee + $e + sr + i + n + f + r,
                1,
                l + Ut + kn + F + Ee + $e + sr + i + n + f + r,
                1,
                l + Nn + bh + Cn + Ml + If + Bf + i + n + f + r,
                1,
                o + Cr + jr + xh + it + m + i + n + f + r,
                1,
                o + zt + pr + Rt + it + m + i + n + f + r,
                1,
                o + zt + rd + Rt + it + m + i + n + f + r,
                1,
                l + Xc + Dn + Hm + Jc + N + m + i + n + f + r,
                1,
                o + Na + Rr + A + it + m + i + n + f + r,
                1,
                o + Na + Lr + A + ur + m + i + n + f + r,
                1,
                o + G + qr + se + it + m + i + n + f + r,
                1,
                o + G + fl + se + ot + m + i + n + f + r,
                1,
                o + G + Iu + ie + jf + m + i + n + f + r,
                3,
                l + Xt + yn + sn + El + ot + m + i + n + f + r,
                1,
                l + Ni + Ci + et + gi + ot + nt + i + n + f + r,
                1,
                l + Qf + Np + tt + cf + Rf + m + i + n + f + r,
                1,
                l + Di + On + ku + Zo + it + mh + i + n + f + r,
                1,
                l + Oi + Ti + ku + Xs + ot + m + i + n + f + r,
                1,
                l + Fi + Pi + Ii + gl + Lf + m + i + n + V + r,
                1,
                l + Cp + Bi + ji + re + qf + m + i + n + V + r,
                1,
                l + qe + Dp + To + re + Zp + m + i + n + V + r,
                1,
                o + As + Ur + fr + ne + m + i + n + f + r,
                1,
                o + As + Ve + fr + ur + m + i + n + f + r,
                1,
                l + $c + Fy + th + iu + hn + m + i + n + V + r,
                1,
                o + Ie + zr + Ms + Op + m + i + n + f + r,
                1,
                o + Ie + Bu + A + ot + m + i + n + f + r,
                1,
                o + Ie + Gr + ju + Uf + m + i + n + f + r,
                1,
                o + Jt + Oa + A + je + m + i + n + f + r,
                1,
                o + Bo + Hr + Ct + zf + m + i + n + f + r,
                1,
                o + Bo + Wr + Ct + Gf + m + i + n + f + r,
                1,
                l + Tn + Fn + Qt + nd + ne + m + i + n + f + r,
                1,
                l + Ri + Li + Qc + Qh + k + m + i + n + f + r,
                1,
                l + oe + qi + pu + vi + hn + m + i + n + V + r,
                1,
                l + Ui + zi + Ne + vi + hn + m + i + n + V + r,
                1,
                l + Pn + Gi + Wm + Co + N + m + i + n + f + r,
                1,
                l + Hi + Wi + In + Co + N + m + i + n + f + r,
                1,
                l + zd + wr + ct + lt + Vl + m + i + n + V + r,
                1,
                l + Gd + _r + G + lt + Zl + m + i + n + V + r,
                1,
                l + eh + $i + Qt + bi + N + m + i + n + f + r,
                1,
                l + Bn + jn + J + bi + N + m + i + n + f + r,
                1,
                l + Vi + Tp + Rn + pr + Fp + m + i + n + V + r,
                1,
                l + Zi + rh + te + Yf + N + m + i + n + f + r,
                1,
                l + Yi + nh + $m + kl + it + lr + i + n + f + r,
                1,
                l + Ki + Xi + Ln + gr + N + Fa + i + n + f + r,
                1,
                l + Ji + Qi + Ar + Tt + ur + Po + i + n + f + r,
                1,
                l + to + eo + qn + vl + N + sp + i + n + f + r,
                1,
                l + Qe + tr + Er + gr + ne + up + i + n + f + r,
                1,
                l + Et + er + Ue + ae + ba + wm + i + n + V + r,
                1,
                l + Gu + rr + yt + ae + ba + Vy + i + n + V + r,
                1,
                l + Hu + nr + F + ae + ba + Zy + i + n + V + r,
                1,
                l + Pp + ro + tt + Yo + Pa + Fa + i + n + f + r,
                1,
                l + Xt + Un + et + Yo + Pa + lr + i + n + f + r,
                1,
                l + oe + Ip + pu + $r + ot + m + i + n + f + r,
                1,
                l + no + io + zn + lt + ot + m + i + n + f + r,
                1,
                l + oo + ao + Gn + He + N + m + i + n + f + r,
                1,
                l + hl + ih + ft + He + N + m + i + n + f + r,
                1,
                l + so + uo + Hd + He + N + m + i + n + f + r,
                1,
                ca + " +lat_0=47.25" + sy + qg + mi + Du + rm + Ta + a + r,
                4,
                o + p + Ly + A + cn + m + rm + Ta + a + r,
                1,
                o + p + qy + A + Si + m + rm + Ta + a + r,
                13,
                o + p + " +lon_0=109" + mt + y + Bt + M + Or + a + r,
                1,
                o + p + " +lon_0=116" + mt + y + Bt + x + a + r,
                1,
                o + p + Au + mt + y + Bt + x + a + r,
                1,
                o + p + wE + mt + y + m + x + a + r,
                1,
                c + Rl + D + a + r,
                1,
                c + Rl + D + a + r,
                1,
                Tr + ow + qb + " +x_0=86501.46392052001" + AS + Ai + Ei + Zu + Hf + r,
                1,
                c + _s + z + b + ze + a + r,
                1,
                c + Ua + z + b + ze + a + r,
                1,
                l + " +lat_1=9 +lat_2=3 +lat_0=6" + nm + Ae + st + b + At + a + r,
                1,
                l + " +lat_1=17 +lat_2=33 +lat_0=25.08951" + jg + $ + m + b + Pr + a + r,
                1,
                o + p + rs + " +k=1" + y + m + b + U + a + r,
                1,
                o + p + hu + " +k=1" + y + m + b + U + a + r,
                1,
                o + p + $s + " +k=1" + y + m + b + U + a + r,
                1,
                o + p + qd + " +k=1" + y + m + b + U + a + r,
                1,
                o + p + Vc + " +k=1" + y + m + b + U + a + r,
                1,
                o + p + Ud + " +k=1" + y + m + b + U + a + r,
                1,
                o + p + rl + " +k=1" + y + m + b + U + a + r,
                1,
                o + aw + sw + " +k=1 +x_0=836694.05 +y_0=819069.8" + b + yl + a + r,
                1,
                o + p + ns + " +k=1" + us + m + Ht + O + a + r,
                1,
                o + p + is + " +k=1" + Ra + m + Ht + O + a + r,
                1,
                o + p + gs + " +k=1" + Ps + m + Ht + O + a + r,
                1,
                o + p + os + " +k=1" + Is + m + Ht + O + a + r,
                1,
                o + p + as + " +k=1" + Ou + m + Ht + O + a + r,
                1,
                o + p + ai + " +k=1" + Ts + m + Ht + O + a + r,
                1,
                o + p + zo + " +k=1" + Fs + m + Ht + O + a + r,
                1,
                o + p + Do + " +k=1" + ls + m + Ht + O + a + r,
                1,
                o + p + Io + " +k=1" + Bs + m + Ht + O + a + r,
                1,
                o + p + _i + " +k=1" + cs + m + Ht + O + a + r,
                1,
                o + p + Oo + " +k=1" + js + m + Ht + O + a + r,
                1,
                o + p + ns + " +k=1" + y + m + Ht + O + a + r,
                1,
                o + p + is + " +k=1" + y + m + Ht + O + a + r,
                1,
                o + p + gs + " +k=1" + y + m + Ht + O + a + r,
                1,
                o + p + os + " +k=1" + y + m + Ht + O + a + r,
                1,
                o + p + as + " +k=1" + y + m + Ht + O + a + r,
                1,
                o + p + ai + " +k=1" + y + m + Ht + O + a + r,
                1,
                o + p + zo + " +k=1" + y + m + Ht + O + a + r,
                1,
                o + p + Do + " +k=1" + y + m + Ht + O + a + r,
                1,
                o + p + Io + " +k=1" + y + m + Ht + O + a + r,
                1,
                o + p + _i + " +k=1" + y + m + Ht + O + a + r,
                1,
                o + p + Oo + " +k=1" + y + m + Ht + O + a + r,
                1,
                o + p + ns + " +k=1" + Rs + m + Ht + O + a + r,
                1,
                o + p + Mf + " +k=1" + Ls + m + Ht + O + a + r,
                1,
                o + p + is + " +k=1" + qs + m + Ht + O + a + r,
                1,
                o + p + fp + " +k=1" + Us + m + Ht + O + a + r,
                1,
                o + p + gs + " +k=1" + La + m + Ht + O + a + r,
                1,
                o + p + Ds + " +k=1" + ou + m + Ht + O + a + r,
                1,
                o + p + os + " +k=1" + va + m + Ht + O + a + r,
                1,
                o + p + dh + " +k=1" + au + m + Ht + O + a + r,
                1,
                o + p + as + " +k=1" + Tu + m + Ht + O + a + r,
                1,
                o + p + bl + " +k=1" + Sh + m + Ht + O + a + r,
                1,
                o + p + ai + " +k=1" + Mh + m + Ht + O + a + r,
                1,
                o + p + ff + " +k=1" + kh + m + Ht + O + a + r,
                1,
                o + p + zo + " +k=1" + Nh + m + Ht + O + a + r,
                1,
                o + p + Eu + " +k=1" + Ch + m + Ht + O + a + r,
                1,
                o + p + Do + " +k=1" + Dh + m + Ht + O + a + r,
                1,
                o + p + Ul + " +k=1" + Oh + m + Ht + O + a + r,
                1,
                o + p + Io + " +k=1" + Th + m + Ht + O + a + r,
                1,
                o + p + xl + " +k=1" + ud + m + Ht + O + a + r,
                1,
                o + p + _i + " +k=1" + Fh + m + Ht + O + a + r,
                1,
                o + p + Au + " +k=1" + ld + m + Ht + O + a + r,
                1,
                o + p + Oo + " +k=1" + Ph + m + Ht + O + a + r,
                1,
                o + p + ns + " +k=1" + y + m + Ht + O + a + r,
                1,
                o + p + Mf + " +k=1" + y + m + Ht + O + a + r,
                1,
                o + p + is + " +k=1" + y + m + Ht + O + a + r,
                1,
                o + p + fp + " +k=1" + y + m + Ht + O + a + r,
                1,
                o + p + gs + " +k=1" + y + m + Ht + O + a + r,
                1,
                o + p + Ds + " +k=1" + y + m + Ht + O + a + r,
                1,
                o + p + os + " +k=1" + y + m + Ht + O + a + r,
                1,
                o + p + dh + " +k=1" + y + m + Ht + O + a + r,
                1,
                o + p + as + " +k=1" + y + m + Ht + O + a + r,
                1,
                o + p + bl + " +k=1" + y + m + Ht + O + a + r,
                1,
                o + p + ai + " +k=1" + y + m + Ht + O + a + r,
                1,
                o + p + ff + " +k=1" + y + m + Ht + O + a + r,
                1,
                o + p + zo + " +k=1" + y + m + Ht + O + a + r,
                1,
                o + p + Eu + " +k=1" + y + m + Ht + O + a + r,
                1,
                o + p + Do + " +k=1" + y + m + Ht + O + a + r,
                1,
                o + p + Ul + " +k=1" + y + m + Ht + O + a + r,
                1,
                o + p + Io + " +k=1" + y + m + Ht + O + a + r,
                1,
                o + p + xl + " +k=1" + y + m + Ht + O + a + r,
                1,
                o + p + _i + " +k=1" + y + m + Ht + O + a + r,
                1,
                o + p + Au + " +k=1" + y + m + Ht + O + a + r,
                1,
                o + p + Oo + " +k=1" + y + m + Ht + O + a + r,
                1,
                o + p + ka + " +k=1" + wt + m + b + Wt + a + r,
                1,
                o + p + Zs + " +k=1" + Dr + m + b + Wt + a + r,
                1,
                o + p + rs + " +k=1" + Re + m + b + Wt + a + r,
                1,
                o + p + hu + " +k=1" + cn + m + b + Wt + a + r,
                1,
                o + p + rl + " +k=1" + Xf + m + d + Uh + a + r,
                1,
                o + p + Wd + " +k=1" + Jf + m + d + Uh + a + r,
                1,
                o + p + jl + " +k=1" + Re + m + d + Gt + a + r,
                1,
                o + p + Vs + " +k=1" + cn + m + d + Gt + a + r,
                1,
                o + p + Sa + " +k=1" + Si + m + d + Gt + a + r,
                2,
                o + p + ns + " +k=1" + Rs + m + d + _ + a + r,
                1,
                o + p + Mf + " +k=1" + Ls + m + d + _ + a + r,
                1,
                o + p + is + " +k=1" + qs + m + d + _ + a + r,
                1,
                o + p + fp + " +k=1" + Us + m + d + _ + a + r,
                1,
                o + p + gs + " +k=1" + La + m + d + _ + a + r,
                1,
                o + p + Ds + " +k=1" + ou + m + d + _ + a + r,
                1,
                o + p + os + " +k=1" + va + m + d + _ + a + r,
                1,
                o + p + dh + " +k=1" + au + m + d + _ + a + r,
                1,
                o + p + as + " +k=1" + Tu + m + d + _ + a + r,
                1,
                o + p + bl + " +k=1" + Sh + m + d + _ + a + r,
                1,
                o + p + ai + " +k=1" + Mh + m + d + _ + a + r,
                1,
                o + p + ff + " +k=1" + kh + m + d + _ + a + r,
                1,
                o + p + zo + " +k=1" + Nh + m + d + _ + a + r,
                1,
                o + p + Eu + " +k=1" + Ch + m + d + _ + a + r,
                1,
                o + p + Do + " +k=1" + Dh + m + d + _ + a + r,
                1,
                o + p + Ul + " +k=1" + Oh + m + d + _ + a + r,
                1,
                o + p + Io + " +k=1" + Th + m + d + _ + a + r,
                1,
                o + p + xl + " +k=1" + ud + m + d + _ + a + r,
                1,
                o + p + _i + " +k=1" + Fh + m + d + _ + a + r,
                1,
                o + p + Au + " +k=1" + ld + m + d + _ + a + r,
                1,
                o + p + Oo + " +k=1" + Ph + m + d + _ + a + r,
                1,
                o + p + ns + " +k=1" + y + m + d + _ + a + r,
                1,
                o + p + Mf + " +k=1" + y + m + d + _ + a + r,
                1,
                o + p + is + " +k=1" + y + m + d + _ + a + r,
                1,
                o + p + fp + " +k=1" + y + m + d + _ + a + r,
                1,
                o + p + gs + " +k=1" + y + m + d + _ + a + r,
                1,
                o + p + Ds + " +k=1" + y + m + d + _ + a + r,
                1,
                o + p + os + " +k=1" + y + m + d + _ + a + r,
                1,
                o + p + dh + " +k=1" + y + m + d + _ + a + r,
                1,
                o + p + as + " +k=1" + y + m + d + _ + a + r,
                1,
                o + p + bl + " +k=1" + y + m + d + _ + a + r,
                1,
                o + p + ai + " +k=1" + y + m + d + _ + a + r,
                1,
                o + p + ff + " +k=1" + y + m + d + _ + a + r,
                1,
                o + p + zo + " +k=1" + y + m + d + _ + a + r,
                1,
                o + p + Eu + " +k=1" + y + m + d + _ + a + r,
                1,
                o + p + Do + " +k=1" + y + m + d + _ + a + r,
                1,
                o + p + Ul + " +k=1" + y + m + d + _ + a + r,
                1,
                o + p + Io + " +k=1" + y + m + d + _ + a + r,
                1,
                o + p + xl + " +k=1" + y + m + d + _ + a + r,
                1,
                o + p + _i + " +k=1" + y + m + d + _ + a + r,
                1,
                o + p + Au + " +k=1" + y + m + d + _ + a + r,
                1,
                o + p + Oo + " +k=1" + y + m + d + _ + a + r,
                1,
                o + $d + iS + A + $ + m + i + n + a + r,
                1,
                o + $d + tp + A + $ + m + i + n + a + r,
                1,
                o + ra + Ed + A + $ + m + i + n + a + r,
                1,
                o + $d + eb + A + $ + m + i + n + a + r,
                1,
                o + ra + Sd + A + $ + m + i + n + a + r,
                1,
                o + ra + gg + A + $ + m + i + n + a + r,
                1,
                o + ra + Md + A + $ + m + i + n + a + r,
                1,
                o + ra + oS + A + $ + m + i + n + a + r,
                1,
                o + ra + kd + A + $ + m + i + n + a + r,
                1,
                o + Bo + Nd + A + $ + m + i + n + a + r,
                1,
                o + fu + dE + A + $ + m + i + n + a + r,
                1,
                o + fu + mE + A + $ + m + i + n + a + r,
                1,
                o + fu + yE + A + $ + m + i + n + a + r,
                1,
                o + ru + " +lon_0=142" + A + $ + m + i + n + a + r,
                1,
                o + ru + um + A + $ + m + i + n + a + r,
                1,
                o + ru + " +lon_0=124" + A + $ + m + i + n + a + r,
                1,
                o + ru + tp + A + $ + m + i + n + a + r,
                1,
                o + " +lat_0=20" + gg + A + $ + m + i + n + a + r,
                1,
                o + ru + EE + A + $ + m + i + n + a + r,
                1,
                o + p + ka + " +k=1" + cn + m + d + a + r,
                1,
                o + p + ka + " +k=1" + y + m + d + u + a + r,
                1,
                o + p + rs + " +k=1" + y + m + d + u + a + r,
                1,
                o + p + $s + " +k=1" + y + m + d + u + a + r,
                1,
                o + p + Vc + " +k=1" + y + m + d + u + a + r,
                1,
                o + p + rl + " +k=1" + y + m + d + u + a + r,
                1,
                o + p + Wd + " +k=1" + y + m + d + u + a + r,
                1,
                o + p + Py + " +k=1" + y + m + d + u + a + r,
                1,
                o + p + Vm + " +k=1" + y + m + d + u + a + r,
                1,
                o + p + Iy + " +k=1" + y + m + d + u + a + r,
                1,
                o + p + ns + " +k=1" + y + m + d + u + a + r,
                1,
                o + p + is + " +k=1" + y + m + d + u + a + r,
                1,
                o + p + gs + " +k=1" + y + m + d + u + a + r,
                1,
                o + p + os + " +k=1" + y + m + d + u + a + r,
                1,
                o + p + as + " +k=1" + y + m + d + u + a + r,
                1,
                o + p + ai + " +k=1" + y + m + d + u + a + r,
                1,
                o + p + zo + " +k=1" + y + m + d + u + a + r,
                1,
                o + p + Do + " +k=1" + y + m + d + u + a + r,
                1,
                o + p + Io + " +k=1" + y + m + d + u + a + r,
                1,
                o + p + _i + " +k=1" + y + m + d + u + a + r,
                1,
                o + p + Oo + " +k=1" + y + m + d + u + a + r,
                1,
                o + p + im + " +k=1" + y + m + d + u + a + r,
                1,
                o + p + id + " +k=1" + y + m + d + u + a + r,
                1,
                o + p + ep + " +k=1" + y + m + d + u + a + r,
                1,
                o + p + om + " +k=1" + y + m + d + u + a + r,
                1,
                o + p + rp + " +k=1" + y + m + d + u + a + r,
                1,
                o + p + hf + " +k=1" + y + m + d + u + a + r,
                1,
                o + p + zl + " +k=1" + y + m + d + u + a + r,
                1,
                o + p + Gl + " +k=1" + y + m + d + u + a + r,
                1,
                o + p + df + " +k=1" + y + m + d + u + a + r,
                3,
                o + p + ka + " +k=1" + y + m + d + s + a + r,
                1,
                o + p + rs + " +k=1" + y + m + d + s + a + r,
                1,
                o + p + $s + " +k=1" + y + m + d + s + a + r,
                1,
                o + p + Vc + " +k=1" + y + m + d + s + a + r,
                1,
                o + p + rl + " +k=1" + y + m + d + s + a + r,
                1,
                o + p + Wd + " +k=1" + y + m + d + s + a + r,
                1,
                o + p + Py + " +k=1" + y + m + d + s + a + r,
                1,
                o + p + Vm + " +k=1" + y + m + d + s + a + r,
                1,
                o + p + Iy + " +k=1" + y + m + d + s + a + r,
                1,
                o + p + ns + " +k=1" + y + m + d + s + a + r,
                1,
                o + p + is + " +k=1" + y + m + d + s + a + r,
                1,
                o + p + gs + " +k=1" + y + m + d + s + a + r,
                1,
                o + p + os + " +k=1" + y + m + d + s + a + r,
                1,
                o + p + as + " +k=1" + y + m + d + s + a + r,
                1,
                o + p + ai + " +k=1" + y + m + d + s + a + r,
                1,
                o + p + zo + " +k=1" + y + m + d + s + a + r,
                1,
                o + p + Do + " +k=1" + y + m + d + s + a + r,
                1,
                o + p + Io + " +k=1" + y + m + d + s + a + r,
                1,
                o + p + _i + " +k=1" + y + m + d + s + a + r,
                1,
                o + p + Oo + " +k=1" + y + m + d + s + a + r,
                1,
                o + p + im + " +k=1" + y + m + d + s + a + r,
                1,
                o + p + id + " +k=1" + y + m + d + s + a + r,
                1,
                o + p + ep + " +k=1" + y + m + d + s + a + r,
                1,
                o + p + om + " +k=1" + y + m + d + s + a + r,
                1,
                o + p + rp + " +k=1" + y + m + d + s + a + r,
                1,
                o + p + hf + " +k=1" + y + m + d + s + a + r,
                1,
                o + p + zl + " +k=1" + y + m + d + s + a + r,
                1,
                o + p + Gl + " +k=1" + y + m + d + s + a + r,
                1,
                o + p + df + " +k=1" + y + m + d + s + a + r,
                1,
                o + p + ka + " +k=1" + Js + m + d + s + a + r,
                1,
                o + p + Zs + " +k=1" + Xf + m + d + s + a + r,
                1,
                o + p + rs + " +k=1" + Jf + m + d + s + a + r,
                1,
                o + p + hu + " +k=1" + of + m + d + s + a + r,
                1,
                o + p + $s + " +k=1" + Sl + m + d + s + a + r,
                1,
                o + p + qd + " +k=1" + af + m + d + s + a + r,
                1,
                o + p + Vc + " +k=1" + us + m + d + s + a + r,
                1,
                o + p + Ud + " +k=1" + Ra + m + d + s + a + r,
                1,
                o + p + rl + " +k=1" + Ps + m + d + s + a + r,
                1,
                o + p + jg + " +k=1" + Is + m + d + s + a + r,
                1,
                o + p + Wd + " +k=1" + Ou + m + d + s + a + r,
                1,
                o + p + Rg + " +k=1" + Ts + m + d + s + a + r,
                1,
                o + p + Py + " +k=1" + Fs + m + d + s + a + r,
                1,
                o + p + " +lon_0=60 +k=1" + ls + m + d + s + a + r,
                1,
                o + p + Vm + " +k=1" + Bs + m + d + s + a + r,
                1,
                o + p + Eb + " +k=1" + cs + m + d + s + a + r,
                1,
                o + p + Iy + " +k=1" + js + m + d + s + a + r,
                1,
                o + p + tE + " +k=1" + sf + m + d + s + a + r,
                1,
                o + p + ns + " +k=1" + Rs + m + d + s + a + r,
                1,
                o + p + Mf + " +k=1" + Ls + m + d + s + a + r,
                1,
                o + p + is + " +k=1" + qs + m + d + s + a + r,
                1,
                o + p + fp + " +k=1" + Us + m + d + s + a + r,
                1,
                o + p + gs + " +k=1" + La + m + d + s + a + r,
                1,
                o + p + Ds + " +k=1" + ou + m + d + s + a + r,
                1,
                o + p + os + " +k=1" + va + m + d + s + a + r,
                1,
                o + p + dh + " +k=1" + au + m + d + s + a + r,
                1,
                o + p + as + " +k=1" + Tu + m + d + s + a + r,
                2,
                o + p + bl + " +k=1" + Sh + m + d + s + a + r,
                1,
                o + p + ai + " +k=1" + Mh + m + d + s + a + r,
                1,
                o + p + ff + " +k=1" + kh + m + d + s + a + r,
                1,
                o + p + zo + " +k=1" + Nh + m + d + s + a + r,
                1,
                o + p + Eu + " +k=1" + Ch + m + d + s + a + r,
                1,
                o + p + Do + " +k=1" + Dh + m + d + s + a + r,
                1,
                o + p + Ul + " +k=1" + Oh + m + d + s + a + r,
                1,
                o + p + Io + " +k=1" + Th + m + d + s + a + r,
                1,
                o + p + xl + " +k=1" + ud + m + d + s + a + r,
                1,
                o + p + _i + " +k=1" + Fh + m + d + s + a + r,
                1,
                o + p + Au + " +k=1" + ld + m + d + s + a + r,
                1,
                o + p + Oo + " +k=1" + Ph + m + d + s + a + r,
                1,
                o + p + vg + " +k=1 +x_0=46500000" + m + d + s + a + r,
                1,
                o + p + im + " +k=1" + gE + m + d + s + a + r,
                1,
                o + p + Db + " +k=1 +x_0=48500000" + m + d + s + a + r,
                1,
                o + p + id + " +k=1 +x_0=49500000" + m + d + s + a + r,
                1,
                o + p + od + " +k=1 +x_0=50500000" + m + d + s + a + r,
                1,
                o + p + ep + " +k=1 +x_0=51500000" + m + d + s + a + r,
                1,
                o + p + SE + " +k=1 +x_0=52500000" + m + d + s + a + r,
                1,
                o + p + om + " +k=1 +x_0=53500000" + m + d + s + a + r,
                1,
                o + p + uy + " +k=1 +x_0=54500000" + m + d + s + a + r,
                1,
                o + p + rp + " +k=1 +x_0=55500000" + m + d + s + a + r,
                1,
                o + p + Ob + " +k=1 +x_0=56500000" + m + d + s + a + r,
                1,
                o + p + hf + " +k=1 +x_0=57500000" + m + d + s + a + r,
                1,
                o + p + Tb + " +k=1 +x_0=58500000" + m + d + s + a + r,
                1,
                o + p + zl + " +k=1 +x_0=59500000" + m + d + s + a + r,
                2,
                o + p + Gl + " +k=1 +x_0=61500000" + m + d + s + a + r,
                1,
                o + p + Ug + " +k=1 +x_0=62500000" + m + d + s + a + r,
                1,
                o + p + df + " +k=1 +x_0=63500000" + m + d + s + a + r,
                1,
                o + p + zg + " +k=1 +x_0=64500000" + m + d + s + a + r,
                1,
                o + p + ka + " +k=1" + y + m + d + s + a + r,
                1,
                o + p + Zs + " +k=1" + y + m + d + s + a + r,
                1,
                o + p + rs + " +k=1" + y + m + d + s + a + r,
                1,
                o + p + hu + " +k=1" + y + m + d + s + a + r,
                1,
                o + p + $s + " +k=1" + y + m + d + s + a + r,
                1,
                o + p + qd + " +k=1" + y + m + d + s + a + r,
                1,
                o + p + Vc + " +k=1" + y + m + d + s + a + r,
                1,
                o + p + Ud + " +k=1" + y + m + d + s + a + r,
                1,
                o + p + rl + " +k=1" + y + m + d + s + a + r,
                1,
                o + p + jg + " +k=1" + y + m + d + s + a + r,
                1,
                o + p + Wd + " +k=1" + y + m + d + s + a + r,
                1,
                o + p + Rg + " +k=1" + y + m + d + s + a + r,
                1,
                o + p + Py + " +k=1" + y + m + d + s + a + r,
                1,
                o + p + " +lon_0=60 +k=1" + y + m + d + s + a + r,
                1,
                o + p + Vm + " +k=1" + y + m + d + s + a + r,
                1,
                o + p + Eb + " +k=1" + y + m + d + s + a + r,
                1,
                o + p + Iy + " +k=1" + y + m + d + s + a + r,
                1,
                o + p + tE + " +k=1" + y + m + d + s + a + r,
                2,
                o + p + ns + " +k=1" + y + m + d + s + a + r,
                1,
                o + p + Mf + " +k=1" + y + m + d + s + a + r,
                1,
                o + p + is + " +k=1" + y + m + d + s + a + r,
                1,
                o + p + fp + " +k=1" + y + m + d + s + a + r,
                1,
                o + p + gs + " +k=1" + y + m + d + s + a + r,
                1,
                o + p + Ds + " +k=1" + y + m + d + s + a + r,
                1,
                o + p + os + " +k=1" + y + m + d + s + a + r,
                1,
                o + p + dh + " +k=1" + y + m + d + s + a + r,
                1,
                o + p + as + " +k=1" + y + m + d + s + a + r,
                1,
                o + p + bl + " +k=1" + y + m + d + s + a + r,
                1,
                o + p + ai + " +k=1" + y + m + d + s + a + r,
                1,
                o + p + ff + " +k=1" + y + m + d + s + a + r,
                1,
                o + p + zo + " +k=1" + y + m + d + s + a + r,
                1,
                o + p + Eu + " +k=1" + y + m + d + s + a + r,
                1,
                o + p + Do + " +k=1" + y + m + d + s + a + r,
                1,
                o + p + Ul + " +k=1" + y + m + d + s + a + r,
                1,
                o + p + Io + " +k=1" + y + m + d + s + a + r,
                1,
                o + p + xl + " +k=1" + y + m + d + s + a + r,
                1,
                o + p + _i + " +k=1" + y + m + d + s + a + r,
                1,
                o + p + Au + " +k=1" + y + m + d + s + a + r,
                1,
                o + p + Oo + " +k=1" + y + m + d + s + a + r,
                1,
                o + p + vg + " +k=1" + y + m + d + s + a + r,
                1,
                o + p + im + " +k=1" + y + m + d + s + a + r,
                1,
                o + p + Db + " +k=1" + y + m + d + s + a + r,
                1,
                o + p + id + " +k=1" + y + m + d + s + a + r,
                1,
                o + p + od + " +k=1" + y + m + d + s + a + r,
                1,
                o + p + ep + " +k=1" + y + m + d + s + a + r,
                1,
                o + p + SE + " +k=1" + y + m + d + s + a + r,
                1,
                o + p + om + " +k=1" + y + m + d + s + a + r,
                1,
                o + p + uy + " +k=1" + y + m + d + s + a + r,
                1,
                o + p + rp + " +k=1" + y + m + d + s + a + r,
                1,
                o + p + Ob + " +k=1" + y + m + d + s + a + r,
                1,
                o + p + hf + " +k=1" + y + m + d + s + a + r,
                1,
                o + p + Tb + " +k=1" + y + m + d + s + a + r,
                1,
                o + p + zl + " +k=1" + y + m + d + s + a + r,
                1,
                o + p + bg + " +k=1" + y + m + d + s + a + r,
                1,
                o + p + Gl + " +k=1" + y + m + d + s + a + r,
                1,
                o + p + Ug + " +k=1" + y + m + d + s + a + r,
                1,
                o + p + df + " +k=1" + y + m + d + s + a + r,
                1,
                o + p + zg + " +k=1" + y + m + d + s + a + r,
                1,
                o + p + ka + " +k=1" + Js + m + d + u + a + r,
                1,
                o + p + Zs + " +k=1" + Xf + m + d + u + a + r,
                1,
                o + p + rs + " +k=1" + Jf + m + d + u + a + r,
                1,
                o + p + hu + " +k=1" + of + m + d + u + a + r,
                1,
                o + p + $s + " +k=1" + Sl + m + d + u + a + r,
                1,
                o + p + qd + " +k=1" + af + m + d + u + a + r,
                1,
                o + p + Vc + " +k=1" + us + m + d + u + a + r,
                1,
                o + p + Ud + " +k=1" + Ra + m + d + u + a + r,
                1,
                o + p + rl + " +k=1" + Ps + m + d + u + a + r,
                1,
                o + p + jg + " +k=1" + Is + m + d + u + a + r,
                1,
                o + p + Wd + " +k=1" + Ou + m + d + u + a + r,
                1,
                o + p + Rg + " +k=1" + Ts + m + d + u + a + r,
                1,
                o + p + Py + " +k=1" + Fs + m + d + u + a + r,
                1,
                o + p + " +lon_0=60 +k=1" + ls + m + d + u + a + r,
                1,
                o + p + Vm + " +k=1" + Bs + m + d + u + a + r,
                1,
                o + p + Eb + " +k=1" + cs + m + d + u + a + r,
                1,
                o + p + Iy + " +k=1" + js + m + d + u + a + r,
                1,
                o + p + tE + " +k=1" + sf + m + d + u + a + r,
                1,
                o + p + ns + " +k=1" + Rs + m + d + u + a + r,
                1,
                o + p + Mf + " +k=1" + Ls + m + d + u + a + r,
                1,
                o + p + is + " +k=1" + qs + m + d + u + a + r,
                1,
                o + p + fp + " +k=1" + Us + m + d + u + a + r,
                1,
                o + p + gs + " +k=1" + La + m + d + u + a + r,
                1,
                o + p + Ds + " +k=1" + ou + m + d + u + a + r,
                1,
                o + p + os + " +k=1" + va + m + d + u + a + r,
                1,
                o + p + dh + " +k=1" + au + m + d + u + a + r,
                1,
                o + p + as + " +k=1" + Tu + m + d + u + a + r,
                1,
                o + p + bl + " +k=1" + Sh + m + d + u + a + r,
                1,
                o + p + ai + " +k=1" + Mh + m + d + u + a + r,
                1,
                o + p + ff + " +k=1" + kh + m + d + u + a + r,
                1,
                o + p + zo + " +k=1" + Nh + m + d + u + a + r,
                1,
                o + p + Eu + " +k=1" + Ch + m + d + u + a + r,
                1,
                o + p + Do + " +k=1" + Dh + m + d + u + a + r,
                1,
                o + p + Ul + " +k=1" + Oh + m + d + u + a + r,
                1,
                o + p + Io + " +k=1" + Th + m + d + u + a + r,
                1,
                o + p + xl + " +k=1" + ud + m + d + u + a + r,
                1,
                o + p + _i + " +k=1" + Fh + m + d + u + a + r,
                1,
                o + p + Au + " +k=1" + ld + m + d + u + a + r,
                1,
                o + p + Oo + " +k=1" + Ph + m + d + u + a + r,
                1,
                o + p + vg + " +k=1 +x_0=46500000" + m + d + u + a + r,
                1,
                o + p + im + " +k=1" + gE + m + d + u + a + r,
                1,
                o + p + Db + " +k=1 +x_0=48500000" + m + d + u + a + r,
                1,
                o + p + id + " +k=1 +x_0=49500000" + m + d + u + a + r,
                1,
                o + p + od + " +k=1 +x_0=50500000" + m + d + u + a + r,
                1,
                o + p + ep + " +k=1 +x_0=51500000" + m + d + u + a + r,
                1,
                o + p + SE + " +k=1 +x_0=52500000" + m + d + u + a + r,
                1,
                o + p + om + " +k=1 +x_0=53500000" + m + d + u + a + r,
                1,
                o + p + uy + " +k=1 +x_0=54500000" + m + d + u + a + r,
                1,
                o + p + rp + " +k=1 +x_0=55500000" + m + d + u + a + r,
                1,
                o + p + Ob + " +k=1 +x_0=56500000" + m + d + u + a + r,
                1,
                o + p + hf + " +k=1 +x_0=57500000" + m + d + u + a + r,
                1,
                o + p + Tb + " +k=1 +x_0=58500000" + m + d + u + a + r,
                1,
                o + p + zl + " +k=1 +x_0=59500000" + m + d + u + a + r,
                2,
                o + p + Gl + " +k=1 +x_0=61500000" + m + d + u + a + r,
                1,
                o + p + Ug + " +k=1 +x_0=62500000" + m + d + u + a + r,
                1,
                o + p + df + " +k=1 +x_0=63500000" + m + d + u + a + r,
                1,
                o + p + zg + " +k=1 +x_0=64500000" + m + d + u + a + r,
                1,
                o + p + ka + " +k=1" + y + m + d + u + a + r,
                1,
                o + p + Zs + " +k=1" + y + m + d + u + a + r,
                1,
                o + p + rs + " +k=1" + y + m + d + u + a + r,
                1,
                o + p + hu + " +k=1" + y + m + d + u + a + r,
                1,
                o + p + $s + " +k=1" + y + m + d + u + a + r,
                1,
                o + p + qd + " +k=1" + y + m + d + u + a + r,
                1,
                o + p + Vc + " +k=1" + y + m + d + u + a + r,
                1,
                o + p + Ud + " +k=1" + y + m + d + u + a + r,
                1,
                o + p + rl + " +k=1" + y + m + d + u + a + r,
                1,
                o + p + jg + " +k=1" + y + m + d + u + a + r,
                1,
                o + p + Wd + " +k=1" + y + m + d + u + a + r,
                1,
                o + p + Rg + " +k=1" + y + m + d + u + a + r,
                1,
                o + p + Py + " +k=1" + y + m + d + u + a + r,
                1,
                o + p + " +lon_0=60 +k=1" + y + m + d + u + a + r,
                1,
                o + p + Vm + " +k=1" + y + m + d + u + a + r,
                1,
                o + p + Eb + " +k=1" + y + m + d + u + a + r,
                1,
                o + p + Iy + " +k=1" + y + m + d + u + a + r,
                1,
                o + p + tE + " +k=1" + y + m + d + u + a + r,
                1,
                o + p + ns + " +k=1" + y + m + d + u + a + r,
                1,
                o + p + Mf + " +k=1" + y + m + d + u + a + r,
                1,
                o + p + is + " +k=1" + y + m + d + u + a + r,
                1,
                o + p + fp + " +k=1" + y + m + d + u + a + r,
                1,
                o + p + gs + " +k=1" + y + m + d + u + a + r,
                1,
                o + p + Ds + " +k=1" + y + m + d + u + a + r,
                1,
                o + p + os + " +k=1" + y + m + d + u + a + r,
                1,
                o + p + dh + " +k=1" + y + m + d + u + a + r,
                1,
                o + p + as + " +k=1" + y + m + d + u + a + r,
                1,
                o + p + bl + " +k=1" + y + m + d + u + a + r,
                1,
                o + p + ai + " +k=1" + y + m + d + u + a + r,
                1,
                o + p + ff + " +k=1" + y + m + d + u + a + r,
                1,
                o + p + zo + " +k=1" + y + m + d + u + a + r,
                1,
                o + p + Eu + " +k=1" + y + m + d + u + a + r,
                1,
                o + p + Do + " +k=1" + y + m + d + u + a + r,
                1,
                o + p + Ul + " +k=1" + y + m + d + u + a + r,
                1,
                o + p + Io + " +k=1" + y + m + d + u + a + r,
                1,
                o + p + xl + " +k=1" + y + m + d + u + a + r,
                1,
                o + p + _i + " +k=1" + y + m + d + u + a + r,
                1,
                c + ch + z + B + Va + a + r,
                1,
                c + Ll + z + B + Va + a + r,
                1,
                o + p + Au + " +k=1" + y + m + d + u + a + r,
                1,
                o + p + Oo + " +k=1" + y + m + d + u + a + r,
                1,
                o + p + vg + " +k=1" + y + m + d + u + a + r,
                1,
                o + p + im + " +k=1" + y + m + d + u + a + r,
                1,
                o + p + Db + " +k=1" + y + m + d + u + a + r,
                1,
                o + p + id + " +k=1" + y + m + d + u + a + r,
                1,
                o + p + od + " +k=1" + y + m + d + u + a + r,
                1,
                o + p + ep + " +k=1" + y + m + d + u + a + r,
                1,
                o + p + SE + " +k=1" + y + m + d + u + a + r,
                1,
                o + p + om + " +k=1" + y + m + d + u + a + r,
                1,
                o + p + uy + " +k=1" + y + m + d + u + a + r,
                1,
                o + p + rp + " +k=1" + y + m + d + u + a + r,
                1,
                o + p + Ob + " +k=1" + y + m + d + u + a + r,
                1,
                o + p + hf + " +k=1" + y + m + d + u + a + r,
                1,
                o + p + Tb + " +k=1" + y + m + d + u + a + r,
                1,
                o + p + zl + " +k=1" + y + m + d + u + a + r,
                1,
                o + p + bg + " +k=1" + y + m + d + u + a + r,
                1,
                o + p + Gl + " +k=1" + y + m + d + u + a + r,
                1,
                o + p + Ug + " +k=1" + y + m + d + u + a + r,
                1,
                o + p + df + " +k=1" + y + m + d + u + a + r,
                1,
                o + p + zg + " +k=1" + y + m + d + u + a + r,
                1,
                o + cu + su + em + I + m + i + n + a + r,
                1,
                o + Na + Vp + ie + N + m + i + n + a + r,
                1,
                o + Ie + Ir + A + yi + m + i + n + a + r,
                1,
                o + Ie + Br + A + yi + m + i + n + a + r,
                1,
                o + Ie + Fu + ie + yi + m + i + n + a + r,
                1,
                l + Hn + Wn + te + Ws + Z + m + i + n + a + r,
                1,
                l + $n + wh + Vn + Ws + Z + Du + i + n + a + r,
                1,
                l + gn + Al + J + za + ke + Dt + i + n + a + r,
                1,
                l + vn + bn + tt + za + ke + Dt + i + n + a + r,
                1,
                l + Ut + xn + yh + lt + ke + Dt + i + n + a + r,
                1,
                l + Zc + Gm + wn + gh + ke + Dt + i + n + a + r,
                1,
                l + _n + An + vh + Cu + ke + Dt + i + n + a + r,
                1,
                l + En + Sn + Mn + Pu + ke + Dt + i + n + a + r,
                1,
                l + Mi + ki + J + Ee + qo + Uo + i + n + a + r,
                1,
                l + Yc + Kc + xr + Ee + qo + Uo + i + n + a + r,
                1,
                l + Ut + kn + F + Ee + qo + Uo + i + n + a + r,
                1,
                l + Nn + bh + Cn + Ml + Om + Tm + i + n + a + r,
                1,
                o + Cr + jr + xh + I + m + i + n + a + r,
                1,
                o + zt + pr + Rt + I + m + i + n + a + r,
                1,
                o + zt + rd + Rt + I + m + i + n + a + r,
                1,
                l + Xc + Dn + Hm + Jc + N + m + i + n + a + r,
                1,
                o + Na + Rr + A + I + m + i + n + a + r,
                1,
                o + Na + Lr + A + mi + m + i + n + a + r,
                1,
                o + wc + Jg + dt + y + m + i + n + a + r,
                1,
                o + _c + Kl + dt + y + m + i + n + a + r,
                1,
                o + fa + Hl + wl + y + m + i + n + a + r,
                1,
                o + Ac + Qg + wl + y + m + i + n + a + r,
                1,
                o + Ec + Xl + " +k=1" + y + m + i + n + a + r,
                1,
                o + G + qr + se + I + m + i + n + a + r,
                1,
                o + G + fl + se + y + m + i + n + a + r,
                1,
                o + G + Iu + ie + br + m + i + n + a + r,
                1,
                o + F + Vr + li + ut + m + i + n + a + r,
                1,
                o + F + Zr + Rt + mi + m + i + n + a + r,
                1,
                o + sn + Yr + dt + ve + Wl + i + n + a + r,
                1,
                o + sn + Kr + dt + ss + Wl + i + n + a + r,
                1,
                l + Zn + Yn + To + Ko + wt + st + i + n + a + r,
                1,
                l + Et + Kn + Bo + Ko + y + m + i + n + a + r,
                1,
                l + Xn + Jn + yt + Co + Z + m + i + n + a + r,
                1,
                l + Qn + ti + F + gr + Z + Du + i + n + a + r,
                1,
                l + Xt + yn + sn + El + y + m + i + n + a + r,
                1,
                l + Ni + Ci + et + gi + y + Dt + i + n + a + r,
                1,
                l + lo + co + cu + xs + Ae + m + i + n + a + r,
                1,
                l + Bp + jp + Rp + Te + Ae + m + i + n + a + r,
                1,
                o + ct + Xa + A + ut + m + i + n + a + r,
                1,
                o + ee + Xr + dt + ss + m + i + n + a + r,
                1,
                l + Qf + Np + tt + cf + Z + m + i + n + a + r,
                1,
                l + Di + On + ku + Zo + I + mh + i + n + a + r,
                1,
                l + Oi + Ti + ku + Xs + y + m + i + n + a + r,
                1,
                l + Fi + Pi + Ii + gl + rb + m + i + n + a + r,
                1,
                l + Cp + Bi + ji + re + lm + m + i + n + a + r,
                1,
                l + qe + Dp + To + re + tf + m + i + n + a + r,
                1,
                l + fo + ho + Nu + Jr + br + ni + i + n + a + r,
                1,
                l + oh + po + eu + Nl + br + ni + i + n + a + r,
                1,
                l + mo + yo + hp + np + br + ni + i + n + a + r,
                1,
                o + As + Ur + fr + ut + m + i + n + a + r,
                1,
                o + As + Ve + fr + mi + m + i + n + a + r,
                1,
                o + Sr + Uy + ie + We + m + i + n + a + r,
                1,
                o + Sr + xs + ie + y + m + i + n + a + r,
                1,
                o + mu + zy + Rt + fA + m + i + n + a + r,
                1,
                l + $c + Fy + th + iu + N + m + i + n + a + r,
                1,
                l + nl + Al + go + dr + y + m + i + n + a + r,
                1,
                o + hr + Qr + A + I + nb + i + n + a + r,
                1,
                o + hr + tn + A + y + ws + i + n + a + r,
                1,
                o + hr + en + A + br + ef + i + n + a + r,
                1,
                o + Fo + rn + dt + ut + m + i + n + a + r,
                1,
                o + Jt + Oa + A + je + m + i + n + a + r,
                1,
                o + Ie + zr + Ms + Op + m + i + n + a + r,
                1,
                o + Ie + Bu + A + y + m + i + n + a + r,
                1,
                o + Ie + Gr + ju + hA + m + i + n + a + r,
                1,
                o + Jt + Oa + A + je + m + i + n + a + r,
                1,
                o + Bo + Hr + Ct + We + m + i + n + a + r,
                1,
                o + Bo + Wr + Ct + fy + m + i + n + a + r,
                1,
                l + Tn + Fn + Qt + nd + ut + m + i + n + a + r,
                1,
                l + oe + qi + pu + vi + N + m + i + n + a + r,
                1,
                l + Ui + zi + Ne + vi + N + m + i + n + a + r,
                1,
                l + Lp + vo + _e + hi + N + m + i + n + a + r,
                1,
                l + bo + xo + Cr + hi + N + m + i + n + a + r,
                1,
                l + Pn + Gi + Wm + Co + N + m + i + n + a + r,
                1,
                l + Hi + Wi + In + Co + N + m + i + n + a + r,
                1,
                l + zd + wr + ct + lt + Dr + m + i + n + a + r,
                1,
                l + Gd + _r + G + lt + wt + m + i + n + a + r,
                1,
                o + ei + Zo + uf + ve + m + i + n + a + r,
                1,
                l + wo + _o + ft + dr + N + m + i + n + a + r,
                1,
                l + qp + Ao + ri + Tt + N + m + i + n + a + r,
                1,
                l + Zi + rh + te + Yf + N + m + i + n + a + r,
                1,
                l + Yi + nh + $m + kl + I + st + i + n + a + r,
                1,
                l + Ki + Xi + Ln + gr + N + Fr + i + n + a + r,
                1,
                l + Ji + Qi + Ar + Tt + mi + Po + i + n + a + r,
                1,
                l + to + eo + qn + vl + N + ef + i + n + a + r,
                1,
                l + Qe + tr + Er + gr + ut + Dl + i + n + a + r,
                1,
                l + Et + er + Ue + ae + y + st + i + n + a + r,
                1,
                l + Gu + rr + yt + ae + y + Fr + i + n + a + r,
                1,
                l + Hu + nr + F + ae + y + Po + i + n + a + r,
                1,
                o + Fo + rf + Ru + y + m + i + n + a + r,
                1,
                l + Pp + ro + tt + Yo + Re + Fr + i + n + a + r,
                1,
                l + Xt + Un + et + Yo + Re + st + i + n + a + r,
                1,
                l + oe + Ip + pu + $r + y + m + i + n + a + r,
                1,
                l + no + io + zn + lt + y + m + i + n + a + r,
                1,
                l + ah + By + _h + ya + N + m + i + n + a + r,
                1,
                l + Eo + So + Zm + pr + N + m + i + n + a + r,
                1,
                l + oo + ao + Gn + He + N + m + i + n + a + r,
                1,
                l + hl + ih + ft + He + N + m + i + n + a + r,
                1,
                l + so + uo + Hd + He + N + m + i + n + a + r,
                1,
                o + Ke + nn + Ct + I + m + i + n + a + r,
                1,
                o + Ke + on + Ct + Z + ni + i + n + a + r,
                1,
                o + Ke + Lu + Ct + N + m + i + n + a + r,
                1,
                o + Ke + an + Ct + br + ni + i + n + a + r,
                1,
                l + ha + pa + da + Ho + I + Ks + i + n + a + r,
                1,
                o + Ie + Ir + A + yi + m + i + n + V + r,
                1,
                o + Ie + Br + A + yi + m + i + n + V + r,
                1,
                o + Ie + Fu + ie + yi + m + i + n + V + r,
                1,
                l + gn + Al + J + za + Nt + nt + i + n + f + r,
                1,
                l + vn + bn + tt + za + Nt + nt + i + n + f + r,
                1,
                l + Ut + xn + yh + lt + Nt + nt + i + n + f + r,
                1,
                l + Zc + Gm + wn + gh + Nt + nt + i + n + f + r,
                1,
                l + _n + An + vh + Cu + Nt + nt + i + n + f + r,
                1,
                l + En + Sn + Mn + Pu + Nt + nt + i + n + f + r,
                1,
                l + Mi + ki + J + Ee + $e + sr + i + n + f + r,
                1,
                l + Yc + Kc + xr + Ee + $e + sr + i + n + f + r,
                1,
                l + Ut + kn + F + Ee + $e + sr + i + n + f + r,
                1,
                l + Nn + bh + Cn + Ml + If + Bf + i + n + f + r,
                1,
                o + Cr + jr + xh + it + m + i + n + f + r,
                1,
                o + zt + pr + Rt + it + m + i + n + f + r,
                1,
                o + zt + rd + Rt + it + m + i + n + f + r,
                1,
                l + Xc + Dn + Hm + Jc + N + m + i + n + f + r,
                1,
                o + Na + Rr + A + it + m + i + n + f + r,
                1,
                o + Na + Lr + A + ur + m + i + n + f + r,
                1,
                o + G + qr + se + it + m + i + n + f + r,
                1,
                o + G + fl + se + ot + m + i + n + f + r,
                1,
                o + G + Iu + ie + jf + m + i + n + f + r,
                3,
                l + Xt + yn + sn + El + ot + m + i + n + f + r,
                1,
                l + Ni + Ci + et + gi + ot + nt + i + n + f + r,
                1,
                l + Qf + Np + tt + cf + Rf + m + i + n + f + r,
                1,
                l + Di + On + ku + Zo + it + mh + i + n + f + r,
                1,
                l + Oi + Ti + ku + Xs + ot + m + i + n + f + r,
                1,
                l + Fi + Pi + Ii + gl + Lf + m + i + n + V + r,
                1,
                l + Cp + Bi + ji + re + qf + m + i + n + V + r,
                1,
                l + qe + Dp + To + re + Zp + m + i + n + V + r,
                1,
                o + As + Ur + fr + ne + m + i + n + f + r,
                1,
                o + As + Ve + fr + ur + m + i + n + f + r,
                1,
                l + $c + Fy + th + iu + hn + m + i + n + V + r,
                1,
                o + Ie + zr + Ms + Op + m + i + n + f + r,
                1,
                o + Ie + Bu + A + ot + m + i + n + f + r,
                1,
                o + Ie + Gr + ju + Uf + m + i + n + f + r,
                1,
                o + Jt + Oa + A + je + m + i + n + f + r,
                1,
                o + Bo + Hr + Ct + zf + m + i + n + f + r,
                1,
                o + Bo + Wr + Ct + Gf + m + i + n + f + r,
                1,
                l + Tn + Fn + Qt + nd + ne + m + i + n + f + r,
                1,
                l + oe + qi + pu + vi + hn + m + i + n + V + r,
                1,
                l + Ui + zi + Ne + vi + hn + m + i + n + V + r,
                1,
                l + Pn + Gi + Wm + Co + N + m + i + n + f + r,
                1,
                l + Hi + Wi + In + Co + N + m + i + n + f + r,
                1,
                l + zd + wr + ct + lt + Vl + m + i + n + V + r,
                1,
                l + Gd + _r + G + lt + Zl + m + i + n + V + r,
                1,
                l + Zi + rh + te + Yf + N + m + i + n + f + r,
                1,
                l + Yi + nh + $m + kl + it + lr + i + n + f + r,
                1,
                l + Ki + Xi + Ln + gr + N + Fa + i + n + f + r,
                1,
                l + Ji + Qi + Ar + Tt + ur + Po + i + n + f + r,
                1,
                l + to + eo + qn + vl + N + sp + i + n + f + r,
                1,
                l + Qe + tr + Er + gr + ne + up + i + n + f + r,
                1,
                l + Et + er + Ue + ae + ba + wm + i + n + V + r,
                1,
                l + Gu + rr + yt + ae + ba + Vy + i + n + V + r,
                1,
                l + Hu + nr + F + ae + ba + Zy + i + n + V + r,
                1,
                l + Pp + ro + tt + Yo + Pa + Fa + i + n + f + r,
                1,
                l + Xt + Un + et + Yo + Pa + lr + i + n + f + r,
                1,
                l + oe + Ip + pu + $r + ot + m + i + n + f + r,
                1,
                l + no + io + zn + lt + ot + m + i + n + f + r,
                1,
                l + oo + ao + Gn + He + N + m + i + n + f + r,
                1,
                l + hl + ih + ft + He + N + m + i + n + f + r,
                1,
                l + so + uo + Hd + He + N + m + i + n + f + r,
                1,
                o + p + " +lon_0=13" + mt + y + m + xt + fe + gv + a + r,
                1,
                o + " +lat_0=24.45" + uw + wl + I + Es + b + Pl + a + r,
                1,
                c + Yh + z + M + bs + a + r,
                2,
                o + Jl + " +lon_0=41.53333333333333 +k=1 +x_0=1300000" + m + d + s + a + r,
                1,
                o + Jl + " +lon_0=44.53333333333333 +k=1" + aS + m + d + s + a + r,
                1,
                o + Jl + " +lon_0=47.53333333333333 +k=1" + sS + m + d + s + a + r,
                1,
                o + Jl + " +lon_0=50.53333333333333 +k=1" + uS + m + d + s + a + r,
                1,
                o + hd + " +lon_0=50.76666666666667 +k=1" + aS + m + d + s + a + r,
                1,
                o + hd + " +lon_0=53.76666666666667 +k=1" + sS + m + d + s + a + r,
                1,
                o + hd + " +lon_0=56.76666666666667 +k=1" + uS + m + d + s + a + r,
                1,
                c + cl + b + Sg + a + r,
                1,
                c + cl + b + vv + a + r,
                2,
                o + p + Kv + A + kt + m + i + n + a + r,
                1,
                o + p + Ly + A + kt + m + i + n + a + r,
                1,
                o + p + qy + A + kt + m + i + n + a + r,
                1,
                o + p + Xv + A + kt + m + i + n + a + r,
                1,
                o + p + Xs + A + kt + m + i + n + a + r,
                1,
                o + p + Jv + A + kt + m + i + n + a + r,
                1,
                o + p + Qv + A + kt + m + i + n + a + r,
                1,
                o + p + ya + A + kt + m + i + n + a + r,
                1,
                ca + Nu + nS + qg + Dr + lS + i + n + a + r,
                1,
                ca + " +lat_0=47.25" + sy + qg + Z + cr + i + n + a + r,
                1,
                c + wp + i + n + a + r,
                1,
                c + _p + i + n + a + r,
                1,
                c + Ap + i + n + a + r,
                1,
                c + _u + i + n + a + r,
                1,
                c + zs + i + n + a + r,
                1,
                c + _s + i + n + a + r,
                1,
                c + Ua + i + n + a + r,
                1,
                c + Gs + i + n + a + r,
                2,
                dn + " +lat_1=55" + Ym + eE + Ah + $ + m + S + f + r,
                1,
                o + sn + Yr + dt + Wf + Jo + i + n + f + r,
                1,
                o + sn + Kr + dt + ss + Jo + i + n + f + r,
                1,
                o + sn + Yr + dt + Wf + Jo + i + n + f + r,
                1,
                o + sn + Kr + dt + ss + Jo + i + n + f + r,
                1,
                c + Ua + b + bv + a + r,
                1,
                c + Ua + b + Mg + a + r,
                1,
                c + Mu + b + Rh + a + r,
                1,
                c + Mu + i + n + a + r,
                1,
                c + Ua + b + Fv + a + r,
                2,
                c + lh + z + i + n + a + r,
                1,
                c + lg + z + b + Pv + a + r,
                1,
                c + Cy + z + b + Ef + a + r,
                1,
                c + Dy + z + b + xb + a + r,
                2,
                c + ll + z + b + kg + a + r,
                1,
                c + Ff + z + b + jm + a + r,
                6,
                c + Gs + B + Hv + a + r,
                1,
                c + Og + z + b + Ng + a + r,
                3,
                l + nl + Ss + Xo + lt + Z + m + i + n + a + r,
                1,
                l + nl + Ss + Xo + lt + lf + m + i + n + V + r,
                1,
                l + nl + Ss + Xo + lt + Z + m + i + n + a + r,
                1,
                l + nl + Ss + Xo + lt + lf + m + i + n + V + r,
                1,
                c + Ff + z + b + ml + a + r,
                1,
                c + Ff + z + b + xv + a + r,
                1,
                c + Ff + z + b + hc + a + r,
                1,
                c + Ff + z + b + Ya + a + r,
                1,
                c + ll + z + b + Cg + a + r,
                1,
                il + " +lon_0=110" + _E + cm + hy + M + bs + a + r,
                1,
                il + " +lon_0=110" + _E + cm + hy + M + Or + a + r,
                1,
                il + " +lon_0=110" + _E + cm + hy + M + ps + a + r,
                1,
                o + p + jl + mt + wt + m + b + ar + a + r,
                1,
                o + p + Sa + mt + " +x_0=2520000" + m + b + ar + a + r,
                1,
                dn + rE + " +lat_2=58.5" + eu + " +lon_0=-126" + Ae + m + i + n + a + r,
                1,
                c + Rl + i + n + a + r,
                1,
                o + p + Vs + " +k=1" + je + m + i + n + a + r,
                1,
                o + p + " +lon_0=13.5 +k=1" + je + m + i + n + a + r,
                1,
                o + p + Sa + " +k=1" + je + m + i + n + a + r,
                1,
                o + p + pA + " +k=1" + je + m + i + n + a + r,
                1,
                o + p + zm + " +k=1" + je + m + i + n + a + r,
                1,
                o + p + " +lon_0=14.25 +k=1" + je + m + i + n + a + r,
                1,
                o + p + " +lon_0=15.75 +k=1" + je + m + i + n + a + r,
                1,
                o + p + " +lon_0=17.25 +k=1" + je + m + i + n + a + r,
                1,
                o + p + " +lon_0=18.75 +k=1" + je + m + i + n + a + r,
                1,
                o + p + " +lon_0=20.25 +k=1" + je + m + i + n + a + r,
                1,
                o + p + " +lon_0=21.75 +k=1" + je + m + i + n + a + r,
                1,
                o + p + " +lon_0=23.25 +k=1" + je + m + i + n + a + r,
                1,
                o + p + lw + " +k=1" + wt + m + M + xe + a + r,
                1,
                o + p + cw + " +k=1" + wt + m + M + xe + a + r,
                1,
                o + p + fw + " +k=1" + wt + m + M + xe + a + r,
                1,
                o + p + hw + " +k=1" + wt + m + M + xe + a + r,
                1,
                o + p + pw + " +k=1" + wt + m + M + xe + a + r,
                1,
                o + p + dw + " +k=1" + wt + m + M + xe + a + r,
                1,
                o + p + lw + " +k=1" + wt + m + M + a + r,
                1,
                o + p + cw + " +k=1" + wt + m + M + a + r,
                1,
                o + p + fw + " +k=1" + wt + m + M + a + r,
                1,
                o + p + hw + " +k=1" + wt + m + M + a + r,
                1,
                o + p + pw + " +k=1" + wt + m + M + a + r,
                1,
                o + p + dw + " +k=1" + wt + m + M + a + r,
                1,
                pe + q + " +lat_ts=-71" + es + " +k=1" + $ + m + x + a + r,
                1,
                pe + q + " +lat_ts=-71 +lon_0=70 +k=1" + lm + ws + x + a + r,
                1,
                l + " +lat_1=-68.5 +lat_2=-74.5 +lat_0=-50 +lon_0=70" + lm + ws + x + a + r,
                1,
                l + nE + Ym + Vd + kf + tf + Gy + i + n + a + r,
                1,
                vs + Vd + kf + Hy + Wy + i + n + a + r,
                1,
                c + ch + z + j + Ql + a + r,
                1,
                c + Ll + z + j + Ql + a + r,
                3,
                c + cl + i + n + a + r,
                1,
                c + Bl + i + n + a + r,
                1,
                c + gd + i + n + a + r,
                1,
                c + Nm + i + n + a + r,
                1,
                c + Xu + i + n + a + r,
                1,
                c + Rl + i + n + a + r,
                1,
                c + Zh + i + n + a + r,
                1,
                c + yc + i + n + a + r,
                1,
                c + ch + i + n + a + r,
                1,
                c + Ll + i + n + a + r,
                5,
                c + bd + b + pl + a + r,
                1,
                c + Tg + b + pl + a + r,
                1,
                c + cl + b + pl + a + r,
                1,
                l + " +lat_1=64.25 +lat_2=65.75 +lat_0=65 +lon_0=-19" + y + Dt + i + n + a + r,
                1,
                o + p + " +lon_0=-8.5 +k=1" + _l + " +y_0=-7800000" + b + Il + a + r,
                1,
                o + p + Zs + mt + y + " +y_0=-6000000" + i + n + a + r,
                1,
                c + Ff + z + b + Qm + a + r,
                1,
                c + cl + b + Id + a + r,
                1,
                c + bd + b + vm + a + r,
                1,
                c + bd + b + Qd + a + r,
                1,
                c + Xu + j + n + a + r,
                1,
                c + Rl + j + n + a + r,
                1,
                o + p + " +lon_0=37" + Ab + y + vE + b + U + a + r,
                1,
                c + yc + i + n + a + r,
                1,
                Tr + " +lat_0=52.41864827777778 +lon_0=13.62720366666667" + ad + " +y_0=10000" + M + rt + a + r,
                1,
                o + p + He + mt + y + " +y_0=-4500000" + S + a + r,
                1,
                o + p + He + mt + dA + tv + i + n + a + r,
                1,
                o + p + He + mt + dA + tv + i + n + a + r,
                1,
                o + ft + tg + zu + mi + m + i + n + a + r,
                2,
                o + ee + eg + zu + ut + m + i + n + a + r,
                1,
                o + ft + tg + zu + mi + m + i + n + a + r,
                2,
                o + ee + eg + zu + ut + m + i + n + a + r,
                1,
                yr + Sc + " +lonc=-86" + Fm + mt + Pm + Xd + ql + Im + i + n + a + r,
                1,
                yr + Sc + " +lonc=-86" + Fm + mt + Pm + Xd + ql + Im + i + n + a + r,
                1,
                l + mw + yw + gw + dr + " +x_0=914400 +y_0=914400" + S + V + r,
                1,
                l + mw + yw + gw + dr + Ae + st + i + n + a + r,
                1,
                l + Up + jy + Jp + dr + wt + Dl + i + n + a + r,
                1,
                dn + Up + jy + Jp + dr + wt + ws + i + n + a + r,
                1,
                l + Up + jy + Jp + dr + wt + Dl + i + n + a + r,
                1,
                dn + Up + jy + Jp + dr + wt + ws + i + n + a + r,
                1,
                dn + " +lat_1=24" + mA + " +lat_0=24" + Jh + Z + m + i + n + a + r,
                1,
                dn + " +lat_1=24" + mA + " +lat_0=24" + Jh + Z + m + i + n + a + r,
                1,
                l + Mo + ko + et + gi + wt + st + i + n + a + r,
                1,
                l + Mo + ko + et + gi + wt + lr + i + n + f + r,
                1,
                l + Mo + ko + et + gi + wt + st + i + n + a + r,
                1,
                l + Mo + ko + et + gi + wt + lr + i + n + f + r,
                1,
                c + fh + M + P + a + r,
                1,
                c + Kh + M + P + a + r,
                1,
                c + xd + M + P + a + r,
                1,
                c + Ep + M + P + a + r,
                1,
                c + Ld + M + P + a + r,
                1,
                c + fh + i + n + a + r,
                1,
                c + Kh + i + n + a + r,
                1,
                c + xd + i + n + a + r,
                1,
                c + Ep + i + n + a + r,
                1,
                c + Ld + i + n + a + r,
                1,
                l + " +lat_1=-14.26666666666667 +lat_0=-14.26666666666667" + Gg + " +k_0=1" + T + " +y_0=95169.31165862332" + B + wv + f + r,
                4,
                o + p + Ds + mt + y + m + Ze + Kt + Ny + a + r,
                1,
                l + " +lat_1=-28" + ME + " +lat_0=-32" + Oo + Ae + Fr + i + n + a + r,
                1,
                o + Lg + " +lon_0=-2.416666666666667 +k=0.999997 +x_0=47000" + xg + i + n + a + r,
                1,
                o + " +lat_0=49.225 +lon_0=-2.135 +k=0.9999999000000001" + ad + " +y_0=70000" + i + n + a + r,
                1,
                l + " +lat_1=-36 +lat_2=-38 +lat_0=-37 +lon_0=145" + Dr + ga + X + W + a + r,
                1,
                l + " +lat_1=-36 +lat_2=-38 +lat_0=-37 +lon_0=145" + Dr + Wu + i + n + a + r,
                1,
                l + " +lat_1=-18" + ME + p + " +lon_0=134" + $ + m + i + n + a + r,
                1,
                o + " +lat_0=-28" + ep + wl + _l + ni + i + n + a + r,
                1,
                o + yu + " +lon_0=-80.07750791666666 +k=1" + Ae + st + i + n + a + r,
                1,
                o + yu + " +lon_0=-77.07750791666666 +k=1" + Ae + st + i + n + a + r,
                1,
                o + yu + " +lon_0=-74.07750791666666 +k=1" + Ae + st + i + n + a + r,
                1,
                o + yu + " +lon_0=-71.07750791666666 +k=1" + Ae + st + i + n + a + r,
                1,
                o + yu + " +lon_0=-68.07750791666666 +k=1" + Ae + st + i + n + a + r,
                1,
                o + p + yA + " +k=0.999" + Ae + st + b + ey + a + r,
                1,
                ca + " +lat_0=50.625 +lon_0=21.08333333333333" + Ab + " +x_0=4637000 +y_0=5467000" + d + C + a + r,
                1,
                o + p + Do + fr + y + m + B + we + a + r,
                1,
                o + p + kE + fr + y + m + B + we + a + r,
                1,
                o + p + NE + fr + y + m + B + we + a + r,
                1,
                o + p + Io + fr + y + m + B + we + a + r,
                1,
                o + p + mg + fr + y + m + B + we + a + r,
                1,
                o + p + Oy + " +k=1" + y + m + i + n + a + r,
                1,
                o + p + Sb + " +k=1" + y + m + i + n + a + r,
                1,
                o + p + ka + " +k=1" + y + m + i + n + a + r,
                1,
                o + p + iE + " +k=1" + y + m + i + n + a + r,
                1,
                o + p + Bg + " +k=1" + y + m + i + n + a + r,
                1,
                o + p + Zs + " +k=1" + y + m + i + n + a + r,
                1,
                o + p + Ty + " +k=1" + y + m + i + n + a + r,
                1,
                o + p + Mb + " +k=1" + y + m + i + n + a + r,
                1,
                o + p + rs + " +k=1" + y + m + i + n + a + r,
                1,
                o + p + Ry + " +k=1" + y + m + i + n + a + r,
                1,
                o + p + " +lon_0=29 +k=1" + y + m + i + n + a + r,
                1,
                o + p + hu + " +k=1" + y + m + i + n + a + r,
                1,
                o + p + Um + " +k=1" + y + m + i + n + a + r,
                2,
                Tr + " +lat_0=-18 +lon_0=178 +x_0=109435.392 +y_0=141622.272" + Lb + VA + dp + " +to_meter=0.201168" + r,
                1,
                c + Rd + z + b + Uu + a + r,
                1,
                c + Og + z + b + Uu + a + r,
                6,
                c + hh + Ze + Kt + Qu + a + r,
                1,
                c + ph + Ze + Kt + Qu + a + r,
                3,
                o + p + " +lon_0=18.05779 +k=0.99999425 +x_0=100178.1808 +y_0=-6500614.7836" + i + n + a + r,
                1,
                dn + rE + " +lat_2=58.5" + eu + " +lon_0=-126" + Ae + m + i + n + a + r,
                1,
                c + Dy + i + n + a + r,
                1,
                c + Uv + i + n + a + r,
                1,
                c + zv + i + n + a + r,
                1,
                c + Cm + i + n + a + r,
                1,
                c + Sp + i + n + a + r,
                1,
                c + $h + i + n + a + r,
                1,
                c + Vh + i + n + a + r,
                1,
                l + gA + " +lat_2=53.5" + p + wg + " +x_0=930000 +y_0=6430000" + i + n + a + r,
                1,
                l + gA + " +lat_2=53.5" + p + wg + " +x_0=930000 +y_0=6430000" + i + n + a + r,
                1,
                l + " +lat_1=-20.66666666666667 +lat_2=-22.33333333333333 +lat_0=-21.5" + CE + Z + Es + i + n + a + r,
                1,
                c + Ff + z + j + Mm + a + r,
                1,
                l + " +lat_1=-22.24469175 +lat_2=-22.29469175 +lat_0=-22.26969175 +lon_0=166.44242575 +x_0=0.66 +y_0=1.02" + b + Ya + a + r,
                1,
                l + " +lat_1=-22.24472222222222 +lat_2=-22.29472222222222 +lat_0=-22.26972222222222 +lon_0=166.4425 +x_0=8.313000000000001 +y_0=-2.354" + b + Ya + a + r,
                1,
                yr + oy + cS + ES + am + ad + m + ql + ma + ZA + _y + " +to_meter=20.116756" + r,
                1,
                yr + oy + cS + ES + am + " +x_0=804670.24" + m + ql + ma + ZA + _y + a + r,
                1,
                c + Fg + z + i + n + a + r,
                1,
                c + Ff + z + i + n + a + r,
                1,
                c + bp + z + i + n + a + r,
                1,
                c + bp + z + b + ml + a + r,
                2,
                dn + " +lat_1=42.122774 +lat_2=49.01518 +lat_0=45.568977 +lon_0=-84.455955" + Ae + st + i + n + a + r,
                1,
                dn + " +lat_1=42.122774 +lat_2=49.01518 +lat_0=45.568977 +lon_0=-83.248627" + Ae + st + i + n + a + r,
                1,
                o + p + AE + mt + y + m + Ze + Kt + Qu + a + r,
                1,
                o + p + wb + " +k=0.9965000000000001" + Ae + m + b + K + a + r,
                1,
                c + zs + i + n + a + r,
                1,
                c + _s + i + n + a + r,
                1,
                c + Ua + i + n + a + r,
                1,
                c + Gs + i + n + a + r,
                1,
                c + Mu + i + n + a + r,
                1,
                c + Pf + i + n + a + r,
                1,
                c + Mp + i + n + a + r,
                1,
                c + xp + i + n + a + r,
                1,
                c + bd + i + n + a + r,
                1,
                c + Tg + i + n + a + r,
                1,
                c + cl + i + n + a + r,
                1,
                c + Bl + i + n + a + r,
                1,
                o + p + jl + fr + I + m + b + K + a + r,
                1,
                o + p + " +lon_0=11" + fr + I + m + b + K + a + r,
                1,
                o + p + " +lon_0=13" + fr + I + m + b + K + a + r,
                1,
                o + p + Sa + fr + I + m + b + K + a + r,
                1,
                o + p + wb + fr + I + m + b + K + a + r,
                1,
                o + p + Oy + fr + I + m + b + K + a + r,
                1,
                o + p + ka + fr + I + m + b + K + a + r,
                1,
                o + p + Bg + fr + I + m + b + K + a + r,
                1,
                o + p + Ty + fr + I + m + b + K + a + r,
                1,
                c + Xu + b + K + a + r,
                1,
                l + py + mf + rl + Jd + wt + fS + D + km + a + r,
                1,
                c + Rl + b + K + a + r,
                1,
                c + Zh + b + K + a + r,
                1,
                c + yc + b + K + a + r,
                1,
                l + pd + dd + q + nm + $ + m + x + a + r,
                1,
                l + pd + dd + q + ip + $ + m + x + a + r,
                1,
                l + pd + dd + q + " +lon_0=-42" + $ + m + x + a + r,
                1,
                l + de + me + q + Ug + $ + m + x + a + r,
                1,
                l + de + me + q + nm + $ + m + x + a + r,
                1,
                l + de + me + q + ip + $ + m + x + a + r,
                1,
                l + de + me + q + Ud + $ + m + x + a + r,
                1,
                l + de + me + q + Rg + $ + m + x + a + r,
                1,
                l + de + me + q + Eb + $ + m + x + a + r,
                1,
                l + de + me + q + Mf + $ + m + x + a + r,
                1,
                l + de + me + q + Ds + $ + m + x + a + r,
                1,
                l + de + me + q + bl + $ + m + x + a + r,
                1,
                l + de + me + q + Eu + $ + m + x + a + r,
                1,
                l + de + me + q + xl + $ + m + x + a + r,
                1,
                l + de + me + q + vg + $ + m + x + a + r,
                1,
                l + de + me + q + od + $ + m + x + a + r,
                1,
                l + de + me + q + uy + $ + m + x + a + r,
                1,
                l + ht + pt + q + " +lon_0=-102" + $ + m + x + a + r,
                1,
                l + ht + pt + q + He + $ + m + x + a + r,
                1,
                l + ht + pt + q + " +lon_0=-78" + $ + m + x + a + r,
                1,
                l + ht + pt + q + nm + $ + m + x + a + r,
                1,
                l + ht + pt + q + " +lon_0=-18" + $ + m + x + a + r,
                1,
                l + ht + pt + q + " +lon_0=-6" + $ + m + x + a + r,
                1,
                l + ht + pt + q + wE + $ + m + x + a + r,
                1,
                l + ht + pt + q + zm + $ + m + x + a + r,
                1,
                l + ht + pt + q + hu + $ + m + x + a + r,
                1,
                l + ht + pt + q + Ud + $ + m + x + a + r,
                1,
                l + ht + pt + q + Rg + $ + m + x + a + r,
                1,
                l + ht + pt + q + Eb + $ + m + x + a + r,
                1,
                l + ht + pt + q + Mf + $ + m + x + a + r,
                1,
                l + ht + pt + q + Ds + $ + m + x + a + r,
                1,
                l + ht + pt + q + bl + $ + m + x + a + r,
                1,
                l + ht + pt + q + Eu + $ + m + x + a + r,
                1,
                l + ht + pt + q + xl + $ + m + x + a + r,
                1,
                l + ht + pt + q + vg + $ + m + x + a + r,
                1,
                l + ht + pt + q + od + $ + m + x + a + r,
                1,
                l + ht + pt + q + uy + $ + m + x + a + r,
                1,
                l + ht + pt + q + Tb + $ + m + x + a + r,
                1,
                l + Ft + St + q + vA + $ + m + x + a + r,
                1,
                l + Ft + St + q + bA + $ + m + x + a + r,
                1,
                l + Ft + St + q + yf + $ + m + x + a + r,
                1,
                l + Ft + St + q + vl + $ + m + x + a + r,
                1,
                l + Ft + St + q + pr + $ + m + x + a + r,
                1,
                l + Ft + St + q + sy + $ + m + x + a + r,
                1,
                l + Ft + St + q + " +lon_0=-27" + $ + m + x + a + r,
                1,
                l + Ft + St + q + " +lon_0=-9" + $ + m + x + a + r,
                1,
                l + Ft + St + q + jl + $ + m + x + a + r,
                1,
                l + Ft + St + q + rs + $ + m + x + a + r,
                1,
                l + Ft + St + q + rl + $ + m + x + a + r,
                1,
                l + Ft + St + q + Vm + $ + m + x + a + r,
                1,
                l + Ft + St + q + is + $ + m + x + a + r,
                1,
                l + Ft + St + q + as + $ + m + x + a + r,
                1,
                l + Ft + St + q + Do + $ + m + x + a + r,
                1,
                l + Ft + St + q + Oo + $ + m + x + a + r,
                1,
                l + Ft + St + q + ep + $ + m + x + a + r,
                1,
                l + Ft + St + q + hf + $ + m + x + a + r,
                1,
                l + Pt + It + q + zg + $ + m + x + a + r,
                1,
                l + Pt + It + q + " +lon_0=-144" + $ + m + x + a + r,
                1,
                l + Pt + It + q + Eh + $ + m + x + a + r,
                1,
                l + Pt + It + q + td + $ + m + x + a + r,
                1,
                l + Pt + It + q + Fb + $ + m + x + a + r,
                1,
                l + Pt + It + q + " +lon_0=-48" + $ + m + x + a + r,
                1,
                l + Pt + It + q + " +lon_0=-24" + $ + m + x + a + r,
                1,
                l + Pt + It + q + es + $ + m + x + a + r,
                1,
                l + Pt + It + q + Zs + $ + m + x + a + r,
                1,
                l + Pt + It + q + jg + $ + m + x + a + r,
                1,
                l + Pt + It + q + tE + $ + m + x + a + r,
                1,
                l + Pt + It + q + dh + $ + m + x + a + r,
                1,
                l + Pt + It + q + Ul + $ + m + x + a + r,
                1,
                l + Pt + It + q + Db + $ + m + x + a + r,
                1,
                l + Pt + It + q + Ob + $ + m + x + a + r,
                1,
                pe + q + _t + Hg + " +k=1" + $ + m + x + a + r,
                1,
                pe + q + _t + bA + " +k=1" + $ + m + x + a + r,
                1,
                pe + q + _t + " +lon_0=-105 +k=1" + $ + m + x + a + r,
                1,
                pe + q + _t + Pb + " +k=1" + $ + m + x + a + r,
                1,
                pe + q + _t + " +lon_0=-45 +k=1" + $ + m + x + a + r,
                1,
                pe + q + _t + " +lon_0=-15 +k=1" + $ + m + x + a + r,
                1,
                pe + q + _t + Sa + " +k=1" + $ + m + x + a + r,
                1,
                pe + q + _t + rl + " +k=1" + $ + m + x + a + r,
                1,
                pe + q + _t + ns + " +k=1" + $ + m + x + a + r,
                1,
                pe + q + _t + ai + " +k=1" + $ + m + x + a + r,
                1,
                pe + q + _t + Oo + " +k=1" + $ + m + x + a + r,
                1,
                pe + q + _t + rp + " +k=1" + $ + m + x + a + r,
                1,
                pe + q + _t + zp + " +k=1" + $ + m + x + a + r,
                1,
                pe + q + _t + He + " +k=1" + $ + m + x + a + r,
                1,
                pe + q + _t + " +lon_0=-30 +k=1" + $ + m + x + a + r,
                1,
                pe + q + _t + hu + " +k=1" + $ + m + x + a + r,
                1,
                pe + q + _t + Ds + " +k=1" + $ + m + x + a + r,
                1,
                pe + q + _t + od + " +k=1" + $ + m + x + a + r,
                1,
                pe + q + _t + es + " +k=1" + $ + m + x + a + r,
                1,
                l + Pt + It + " +lat_0=-78" + uy + $ + m + x + a + r,
                2,
                c + Cy + z + i + Be + a + r,
                1,
                c + lg + z + i + Be + a + r,
                1,
                c + Dy + z + i + Be + a + r,
                1,
                c + Uv + z + i + Be + a + r,
                1,
                l + vw + " +lat_2=58" + bw + Zs + y + " +y_0=6375000" + i + Cf + a + r,
                1,
                l + vw + " +lat_2=58" + bw + Zs + y + " +y_0=6375000" + i + n + a + r,
                1,
                c + Dy + z + b + Af + a + r,
                1,
                c + Dy + z + b + cc + a + r,
                1,
                c + lg + z + b + dc + a + r,
                1,
                c + lg + z + b + mc + a + r,
                1,
                c + Cy + z + b + Rm + a + r,
                1,
                c + Ku + j + _v + a + r,
                1,
                l + " +lat_1=-30.75 +lat_2=-35.75 +lat_0=-33.25" + id + " +x_0=9300000" + ga + i + n + a + r,
                1,
                dn + oE + Wg + p + Eh + $ + Km + S + a + r,
                1,
                dn + oE + Wg + p + Eh + $ + Km + i + n + a + r,
                1,
                dn + oE + Wg + p + Eh + $ + Km + i + n + a + r,
                1,
                c + Gs + b + Rh + a + r,
                1,
                c + Gs + i + n + a + r,
                3,
                o + p + iE + A + y + Bt + D + a + r,
                1,
                o + p + Zs + A + y + Bt + D + a + r,
                1,
                o + p + Vs + A + y + Bt + D + a + r,
                1,
                o + p + " +lon_0=14" + A + y + Bt + D + a + r,
                1,
                o + p + " +lon_0=16" + A + y + Bt + D + a + r,
                1,
                o + p + zm + A + y + Bt + D + a + r,
                1,
                o + p + Sb + A + y + Bt + D + a + r,
                1,
                o + p + iE + A + y + Bt + D + a + r,
                1,
                o + p + Zs + A + y + Bt + D + a + r,
                1,
                o + p + Mb + A + y + Bt + D + a + r,
                1,
                o + p + Ry + A + y + Bt + D + a + r,
                1,
                o + p + hu + A + y + Bt + D + a + r,
                1,
                ca + " +lat_0=52.16666666666666 +lon_0=19.16666666666667 +k=0.999714" + y + Dt + d + C + a + r,
                1,
                o + p + Sa + " +k=1" + Si + m + d + C + a + r,
                1,
                o + p + zm + " +k=1" + Cl + m + d + C + a + r,
                1,
                o + p + ka + " +k=1" + Js + m + d + C + a + r,
                1,
                o + p + Zs + " +k=1" + Xf + m + d + C + a + r,
                1,
                o + p + Sa + " +k=1" + Re + m + d + C + a + r,
                1,
                o + p + ka + " +k=1" + cn + m + d + C + a + r,
                1,
                o + p + rs + " +k=1" + Si + m + d + C + a + r,
                1,
                c + Xy + z + b + Av + a + r,
                1,
                l + " +lat_1=-20.19506944444445 +lat_0=-20.19506944444445 +lon_0=57.52182777777778 +k_0=1" + Ae + st + D + ry + a + r,
                1,
                dn + " +lat_1=55" + Ym + eE + Ah + $ + m + i + n + a + r,
                1,
                o + p + Vs + A + y + Bt + D + na + a + r,
                1,
                o + p + " +lon_0=14" + A + y + Bt + D + na + a + r,
                1,
                o + p + " +lon_0=16" + A + y + Bt + D + na + a + r,
                1,
                c + Rl + z + D + na + a + r,
                1,
                c + cl + i + n + a + r,
                1,
                c + Bl + i + n + a + r,
                1,
                c + gd + i + n + a + r,
                1,
                o + p + Zs + Ab + y + m + i + n + a + r,
                1,
                l + $c + Ys + " +lat_0=63.390675" + Ub + " +x_0=6200000" + Po + i + n + a + r,
                1,
                l + $c + Ys + " +lat_0=63.390675" + Ub + " +x_0=6200000" + Po + i + n + a + r,
                2,
                o + " +lat_0=0.1 +lon_0=21.95 +k=1" + We + m + d + s + a + r,
                1,
                o + " +lat_0=0.1 +lon_0=24.95 +k=1 +x_0=1250000" + m + d + s + a + r,
                1,
                o + " +lat_0=0.1 +lon_0=27.95 +k=1 +x_0=2250000" + m + d + s + a + r,
                1,
                c + Xu + z + b + a + r,
                1,
                c + Xu + z + b + a + r,
                1,
                o + Na + Um + " +k=1 +x_0=615000 +y_0=810000" + Ca + ny + a + r,
                3,
                l + Ri + Li + Qc + Qh + rg + m + i + n + a + r,
                2,
                l + Vi + Tp + Rn + pr + Fp + m + i + n + a + r,
                1,
                l + Vi + Tp + Rn + pr + Fp + m + i + n + V + r,
                1,
                l + eh + $i + Qt + bi + N + m + i + n + a + r,
                1,
                l + eh + $i + Qt + bi + N + m + i + n + f + r,
                1,
                l + Bn + jn + J + bi + N + m + i + n + a + r,
                1,
                l + Bn + jn + J + bi + N + m + i + n + f + r,
                2,
                c + cl + D + a + r,
                1,
                c + Bl + D + a + r,
                1,
                c + gd + D + a + r,
                1,
                c + bp + S + a + r,
                1,
                c + Rd + S + a + r,
                1,
                c + bp + i + n + a + r,
                1,
                c + Rd + i + n + a + r,
                1,
                c + Bl + b + a + r,
                1,
                yr + oy + cS + " +alpha=323.0257964666666" + am + " +x_0=804671" + m + ql + ma + i + a + r,
                1,
                yr + oy + aE + SS + am + $ + m + ql + gu + i + a + r,
                1,
                Tr + " +lat_0=2.121679744444445 +lon_0=103.4279362361111 +x_0=-14810.562 +y_0=8758.32" + i + a + r,
                1,
                Tr + " +lat_0=2.682347636111111 +lon_0=101.9749050416667 +x_0=3673.785 +y_0=-4240.573" + i + a + r,
                1,
                Tr + " +lat_0=3.769388088888889 +lon_0=102.3682989833333 +x_0=-7368.228 +y_0=6485.858" + i + a + r,
                1,
                Tr + " +lat_0=3.68464905 +lon_0=101.3891079138889 +x_0=-34836.161 +y_0=56464.049" + i + a + r,
                1,
                Tr + " +lat_0=4.9762852 +lon_0=103.070275625 +x_0=19594.245 +y_0=3371.895" + i + a + r,
                1,
                Tr + " +lat_0=5.421517541666667 +lon_0=100.3443769638889 +x_0=-23.414 +y_0=62.283" + i + a + r,
                1,
                Tr + " +lat_0=5.964672713888889 +lon_0=100.6363711111111" + $ + m + i + a + r,
                1,
                Tr + " +lat_0=4.859063022222222 +lon_0=100.8154105861111 +x_0=-1.769 +y_0=133454.779" + i + a + r,
                1,
                Tr + " +lat_0=5.972543658333334 +lon_0=102.2952416694444 +x_0=13227.851 +y_0=8739.894" + i + a + r,
                1,
                o + p + zm + " +k=1" + y + m + b + Wt + a + r,
                1,
                o + p + $s + " +k=1" + Si + m + b + Wt + a + r,
                1,
                il + Wd + " +lat_ts=42" + $ + m + d + s + a + r,
                1,
                o + p + bg + " +k=1 +x_0=60500000" + m + d + s + a + r,
                1,
                o + p + bg + " +k=1 +x_0=60500000" + m + d + u + a + r,
                1,
                c + Ll + D + pi + a + r,
                1,
                c + ll + D + pi + a + r,
                1,
                c + Ku + D + pi + a + r,
                1,
                l + py + mf + rl + Jd + wt + fS + D + a + r,
                1,
                il + es + " +k=1" + $ + m + x + a + r,
                1,
                o + p + jl + " +k=1" + Re + m + M + a + r,
                1,
                o + p + Vs + " +k=1" + cn + m + M + a + r,
                1,
                o + p + Vs + " +k=1" + cn + m + M + a + r,
                1,
                o + p + Sa + " +k=1" + Si + m + M + a + r,
                1,
                o + p + $g + " +k=0.9992" + y + m + i + n + a + r,
                1,
                o + p + $g + " +k=0.9992" + $ + m + i + n + a + r,
                1,
                o + p + $g + " +k=0.9992" + y + m + i + n + a + r,
                1,
                o + p + $g + " +k=0.9992" + $ + m + i + n + a + r,
                1,
                l + Ri + Li + Qc + Qh + k + m + i + n + f + r,
                1,
                c + hh + j + Ro + a + r,
                1,
                c + ph + j + Ro + a + r,
                1,
                Tr + aw + sw + " +x_0=40243.57775604237 +y_0=19069.93351512578" + Ai + Ei + Hf + r,
                1,
                vs + Os + es + $ + m + DE + OE + a + r,
                1,
                vs + q + es + $ + m + DE + OE + a + r,
                1,
                "+proj=cea" + es + " +lat_ts=30" + $ + m + DE + OE + a + r,
                1,
                pe + Os + " +lat_ts=70 +lon_0=-45 +k=1" + $ + m + TE + ng + a + r,
                1,
                pe + q + " +lat_ts=-70" + es + " +k=1" + $ + m + TE + ng + a + r,
                1,
                pe + Os + " +lat_ts=70 +lon_0=-45 +k=1" + $ + m + x + a + r,
                1,
                o + " +lat_0=1.366666666666667 +lon_0=103.8333333333333 +k=1 +x_0=28001.642 +y_0=38744.572" + j + a + r,
                1,
                l + " +lat_1=18 +lat_2=24 +lat_0=21" + Eu + y + Dt + w + v + a + r,
                1,
                l + $c + cp + " +lat_0=47.5" + vu + Z + Du + i + n + a + r,
                1,
                l + Zn + Yn + To + Ko + wt + Qo + i + n + f + r,
                1,
                l + Et + Kn + Bo + Ko + at + m + i + n + f + r,
                1,
                l + Xn + Jn + yt + Co + $t + m + i + n + f + r,
                1,
                l + Qn + ti + F + gr + $t + Ia + i + n + f + r,
                1,
                o + hr + Qr + A + Ba + $f + i + n + f + r,
                1,
                o + hr + tn + A + at + ws + i + n + f + r,
                1,
                o + hr + en + A + Lt + Ih + i + n + f + r,
                1,
                o + Jt + Oa + A + je + m + i + n + f + r,
                1,
                l + Zn + Yn + To + Ko + wt + Qo + i + n + f + r,
                1,
                l + Et + Kn + Bo + Ko + at + m + i + n + f + r,
                1,
                l + Xn + Jn + yt + Co + $t + m + i + n + f + r,
                1,
                l + Qn + ti + F + gr + $t + Ia + i + n + f + r,
                1,
                o + hr + Qr + A + Ba + $f + i + n + f + r,
                1,
                o + hr + tn + A + at + ws + i + n + f + r,
                1,
                o + hr + en + A + Lt + Ih + i + n + f + r,
                1,
                o + Jt + Oa + A + je + m + i + n + f + r,
                1,
                l + Hn + Wn + te + Ws + $t + m + i + n + f + r,
                1,
                l + $n + wh + Vn + Ws + $t + Ia + i + n + f + r,
                1,
                o + F + Vr + li + ne + m + i + n + f + r,
                1,
                o + F + Zr + Rt + Vf + m + i + n + f + r,
                1,
                o + Fo + rn + dt + ne + m + i + n + f + r,
                1,
                o + ei + Zo + uf + ol + m + i + n + f + r,
                1,
                c + Ku + D + _a + a + r,
                1,
                c + lh + D + _a + a + r,
                1,
                l + Hn + Wn + te + Ws + $t + m + i + n + f + r,
                1,
                l + $n + wh + Vn + Ws + $t + Ia + i + n + f + r,
                1,
                o + F + Vr + li + ne + m + i + n + f + r,
                1,
                o + F + Zr + Rt + Vf + m + i + n + f + r,
                1,
                o + Fo + rn + dt + ne + m + i + n + f + r,
                1,
                o + ei + Zo + uf + ol + m + i + n + f + r,
                1,
                l + Mc + kc + " +lat_0=50.797815" + xw + " +x_0=150328 +y_0=166262" + i + n + a + r,
                1,
                l + " +lat_1=18" + Jp + cf + " +k_0=1" + xA + " +y_0=650000" + j + n + a + r,
                1,
                c + _u + j + n + a + r,
                1,
                c + zs + j + n + a + r,
                1,
                l + lo + co + cu + xs + xi + m + i + n + f + r,
                1,
                l + Bp + jp + Rp + Te + xi + m + i + n + f + r,
                1,
                l + Qe + tr + " +lat_0=25.5" + Te + xi + m + i + n + f + r,
                2,
                l + qp + Ao + ri + Tt + N + m + i + n + f + r,
                1,
                l + lo + co + cu + xs + xi + m + i + n + f + r,
                1,
                l + Bp + jp + Rp + Te + xi + m + i + n + f + r,
                1,
                l + wo + _o + ft + dr + N + m + i + n + f + r,
                1,
                l + qp + Ao + ri + Tt + N + m + i + n + f + r,
                1,
                o + " +lat_0=-17 +lon_0=178.75 +k=0.99985" + ke + ef + w + g + a + r,
                1,
                c + cl + xt + fe + mp + a + r,
                1,
                c + Bl + xt + fe + mp + a + r,
                1,
                o + wA + ig + zu + y + m + i + n + a + r,
                1,
                o + wA + ig + zu + y + m + i + n + a + r,
                1,
                o + cu + su + em + I + m + i + n + a + r,
                1,
                o + Na + Vp + ie + N + m + i + n + a + r,
                1,
                dn + " +lat_1=55" + Ym + eE + Ah + $ + m + i + n + a + r,
                1,
                yr + " +lat_0=57" + Nc + Cc + A + nf + si + ql + ma + i + n + a + r,
                1,
                o + jo + _A + A + y + m + i + n + a + r,
                1,
                o + jo + AA + A + y + m + i + n + a + r,
                1,
                o + jo + zp + A + y + m + i + n + a + r,
                1,
                o + jo + Ah + A + y + m + i + n + a + r,
                1,
                o + jo + Hl + A + y + m + i + n + a + r,
                1,
                o + jo + EA + A + y + m + i + n + a + r,
                1,
                o + jo + SA + A + y + m + i + n + a + r,
                1,
                o + jo + Gg + A + y + m + i + n + a + r,
                1,
                l + Dc + Oc + kb + MA + Ae + m + i + n + a + r,
                1,
                o + Ie + Br + A + yi + m + i + n + a + r,
                1,
                o + Ie + Br + A + yi + m + i + n + V + r,
                1,
                o + Ie + Ir + A + yi + m + i + n + a + r,
                1,
                o + Ie + Ir + A + yi + m + i + n + V + r,
                1,
                o + Ie + Fu + ie + yi + m + i + n + a + r,
                1,
                o + Ie + Fu + ie + yi + m + i + n + V + r,
                1,
                l + Hn + Wn + te + Ws + Z + m + i + n + a + r,
                1,
                l + Hn + Wn + te + Ws + $t + m + i + n + f + r,
                1,
                l + $n + wh + Vn + Ws + Z + Du + i + n + a + r,
                1,
                l + $n + wh + Vn + Ws + $t + Ia + i + n + f + r,
                1,
                dn + oE + Wg + p + Eh + $ + Km + i + n + a + r,
                1,
                l + gn + Al + J + za + ke + Dt + i + n + a + r,
                1,
                l + gn + Al + J + za + Nt + nt + i + n + f + r,
                1,
                l + vn + bn + tt + za + ke + Dt + i + n + a + r,
                1,
                l + vn + bn + tt + za + Nt + nt + i + n + f + r,
                1,
                l + Ut + xn + yh + lt + ke + Dt + i + n + a + r,
                1,
                l + Ut + xn + yh + lt + Nt + nt + i + n + f + r,
                1,
                l + Zc + Gm + wn + gh + ke + Dt + i + n + a + r,
                1,
                l + Zc + Gm + wn + gh + Nt + nt + i + n + f + r,
                1,
                l + _n + An + vh + Cu + ke + Dt + i + n + a + r,
                1,
                l + _n + An + vh + Cu + Nt + nt + i + n + f + r,
                1,
                l + En + Sn + Mn + Pu + ke + Dt + i + n + a + r,
                1,
                l + En + Sn + Mn + Pu + Nt + nt + i + n + f + r,
                1,
                l + Yc + Kc + xr + Ee + qo + Uo + i + n + a + r,
                1,
                l + Yc + Kc + xr + Ee + $e + sr + i + n + f + r,
                1,
                l + Mi + ki + J + Ee + qo + Uo + i + n + a + r,
                1,
                l + Mi + ki + J + Ee + $e + sr + i + n + f + r,
                1,
                l + Ut + kn + F + Ee + qo + Uo + i + n + a + r,
                1,
                l + Ut + kn + F + Ee + $e + sr + i + n + f + r,
                1,
                l + Nn + bh + Cn + Ml + Om + Tm + i + n + a + r,
                1,
                l + Nn + bh + Cn + Ml + If + Bf + i + n + f + r,
                1,
                o + Cr + jr + xh + I + m + i + n + a + r,
                1,
                o + Cr + jr + xh + it + m + i + n + f + r,
                1,
                o + zt + pr + Rt + I + m + i + n + a + r,
                1,
                o + zt + pr + Rt + it + m + i + n + f + r,
                1,
                dn + " +lat_1=24" + mA + " +lat_0=24" + Jh + Z + m + i + n + a + r,
                1,
                l + Xc + Dn + Hm + Jc + N + m + i + n + a + r,
                1,
                l + Xc + Dn + Hm + Jc + N + m + i + n + f + r,
                1,
                o + zt + rd + Rt + I + m + i + n + a + r,
                1,
                o + zt + rd + Rt + it + m + i + n + f + r,
                1,
                o + Na + Rr + A + I + m + i + n + a + r,
                1,
                o + Na + Rr + A + it + m + i + n + f + r,
                1,
                o + Na + Lr + A + mi + m + i + n + a + r,
                1,
                o + Na + Lr + A + ur + m + i + n + f + r,
                1,
                o + G + fl + se + y + m + i + n + a + r,
                1,
                o + G + fl + se + ot + m + i + n + f + r,
                1,
                o + G + qr + se + I + m + i + n + a + r,
                1,
                o + G + qr + se + it + m + i + n + f + r,
                1,
                o + G + Iu + ie + br + m + i + n + a + r,
                1,
                o + G + Iu + ie + jf + m + i + n + f + r,
                1,
                o + F + Vr + li + ut + m + i + n + a + r,
                1,
                o + F + Vr + li + ne + m + i + n + f + r,
                1,
                o + F + Zr + Rt + mi + m + i + n + a + r,
                1,
                o + F + Zr + Rt + Vf + m + i + n + f + r,
                1,
                o + sn + Yr + dt + ve + Wl + i + n + a + r,
                1,
                o + sn + Yr + dt + Wf + Jo + i + n + f + r,
                1,
                o + sn + Kr + dt + ss + Wl + i + n + a + r,
                1,
                o + sn + Kr + dt + ss + Jo + i + n + f + r,
                1,
                l + Zn + Yn + To + Ko + wt + st + i + n + a + r,
                1,
                l + Zn + Yn + To + Ko + wt + Qo + i + n + f + r,
                1,
                l + Et + Kn + Bo + Ko + y + m + i + n + a + r,
                1,
                l + Et + Kn + Bo + Ko + at + m + i + n + f + r,
                1,
                l + Xn + Jn + yt + Co + Z + m + i + n + a + r,
                1,
                l + Xn + Jn + yt + Co + $t + m + i + n + f + r,
                1,
                l + Qn + ti + F + gr + Z + Du + i + n + a + r,
                1,
                l + Qn + ti + F + gr + $t + Ia + i + n + f + r,
                1,
                l + Xt + yn + sn + El + y + m + i + n + a + r,
                1,
                l + Xt + yn + sn + El + ot + m + i + n + f + r,
                1,
                l + Mo + ko + et + gi + wt + st + i + n + a + r,
                1,
                l + Mo + ko + et + gi + wt + lr + i + n + f + r,
                1,
                l + Ni + Ci + et + gi + y + Dt + i + n + a + r,
                1,
                l + Ni + Ci + et + gi + ot + nt + i + n + f + r,
                1,
                l + lo + co + cu + xs + Ae + m + i + n + a + r,
                1,
                l + lo + co + cu + xs + xi + m + i + n + f + r,
                1,
                l + Bp + jp + Rp + Te + Ae + m + i + n + a + r,
                1,
                l + Bp + jp + Rp + Te + xi + m + i + n + f + r,
                1,
                o + wA + ig + zu + y + m + i + n + a + r,
                1,
                o + ft + tg + zu + mi + m + i + n + a + r,
                1,
                o + ee + eg + zu + ut + m + i + n + a + r,
                1,
                o + ct + Xa + A + ut + m + i + n + a + r,
                1,
                o + ee + Xr + dt + ss + m + i + n + a + r,
                1,
                l + Qf + Np + tt + cf + Z + m + i + n + a + r,
                1,
                l + Et + er + Ue + ae + at + Qo + i + n + f + r,
                1,
                o + wc + Jg + dt + T + m + B + Wo + f + r,
                1,
                o + _c + Kl + dt + T + m + B + Wo + f + r,
                1,
                o + fa + Hl + wl + T + m + B + Wo + f + r,
                1,
                o + Ac + Qg + wl + T + m + B + Wo + f + r,
                1,
                o + Ec + Xl + " +k=1" + T + m + B + Wo + f + r,
                1,
                l + Gu + rr + yt + ae + at + Bh + i + n + f + r,
                1,
                l + Hu + nr + F + ae + at + Po + i + n + f + r,
                1,
                l + Et + er + Ue + ae + at + Qo + i + n + f + r,
                1,
                l + Gu + rr + yt + ae + at + Bh + i + n + f + r,
                1,
                l + Hu + nr + F + ae + at + Po + i + n + f + r,
                1,
                vs + Os + bg + $ + m + x + a + r,
                1,
                vs + Os + zp + $ + m + x + a + r,
                1,
                vs + Os + dr + $ + m + x + a + r,
                1,
                vs + Os + " +lon_0=-40" + $ + m + x + a + r,
                1,
                vs + Os + kf + $ + m + x + a + r,
                1,
                vs + Os + Ds + $ + m + x + a + r,
                1,
                dn + " +lat_1=-18" + ME + p + Au + $ + m + i + n + a + r,
                1,
                dn + ww + " +lat_2=68 +lat_0=59 +lon_0=-132.5" + y + Dt + i + n + a + r,
                1,
                dn + ww + " +lat_2=68 +lat_0=59 +lon_0=-132.5" + y + Dt + i + n + a + r,
                1,
                l + " +lat_1=62 +lat_2=70" + p + " +lon_0=-112" + $ + m + i + n + a + r,
                1,
                l + " +lat_1=62 +lat_2=70" + p + " +lon_0=-112" + $ + m + i + n + a + r,
                1,
                l + Qf + Np + tt + cf + Rf + m + i + n + f + r,
                1,
                l + Oi + Ti + ku + Xs + y + m + i + n + a + r,
                1,
                l + Oi + Ti + ku + Xs + ot + m + i + n + f + r,
                1,
                l + Di + On + ku + Zo + I + mh + i + n + a + r,
                1,
                l + Di + On + ku + Zo + it + mh + i + n + f + r,
                1,
                l + Cp + Bi + ji + re + lm + m + i + n + a + r,
                1,
                l + Cp + Bi + ji + re + qf + m + i + n + V + r,
                1,
                l + Fi + Pi + Ii + gl + rb + m + i + n + a + r,
                1,
                l + Fi + Pi + Ii + gl + Lf + m + i + n + V + r,
                1,
                yr + Sc + " +lonc=-86" + Fm + mt + Pm + Xd + ql + Im + i + n + a + r,
                1,
                l + qe + Dp + To + re + tf + m + i + n + a + r,
                1,
                l + qe + Dp + To + re + Zp + m + i + n + V + r,
                1,
                l + oh + po + eu + Nl + br + ni + i + n + a + r,
                1,
                l + fo + ho + Nu + Jr + br + ni + i + n + a + r,
                1,
                l + mo + yo + hp + np + br + ni + i + n + a + r,
                1,
                o + As + Ur + fr + ut + m + i + n + a + r,
                1,
                o + As + Ur + fr + ne + m + i + n + f + r,
                1,
                o + As + Ve + fr + mi + m + i + n + a + r,
                1,
                o + As + Ve + fr + ur + m + i + n + f + r,
                1,
                o + Sr + xs + ie + y + m + i + n + a + r,
                1,
                o + Sr + Uy + ie + We + m + i + n + a + r,
                1,
                o + mu + zy + Rt + fA + m + i + n + a + r,
                1,
                l + $c + Fy + th + iu + N + m + i + n + a + r,
                1,
                l + $c + Fy + th + iu + hn + m + i + n + V + r,
                1,
                l + nl + Al + go + dr + y + m + i + n + a + r,
                1,
                o + hr + tn + A + y + ws + i + n + a + r,
                1,
                o + hr + tn + A + at + ws + i + n + f + r,
                1,
                o + hr + Qr + A + I + nb + i + n + a + r,
                1,
                o + hr + Qr + A + Ba + $f + i + n + f + r,
                1,
                o + hr + en + A + br + ef + i + n + a + r,
                1,
                o + hr + en + A + Lt + Ih + i + n + f + r,
                1,
                o + Fo + rn + dt + ut + m + i + n + a + r,
                1,
                o + Fo + rn + dt + ne + m + i + n + f + r,
                1,
                o + Jt + Oa + A + je + m + i + n + a + r,
                1,
                o + Jt + Oa + A + je + m + i + n + f + r,
                1,
                o + Ie + Bu + A + y + m + i + n + a + r,
                1,
                o + Ie + Bu + A + ot + m + i + n + f + r,
                1,
                o + Ie + zr + Ms + Op + m + i + n + a + r,
                1,
                o + Ie + zr + Ms + Op + m + i + n + f + r,
                1,
                o + Ie + Gr + ju + hA + m + i + n + a + r,
                1,
                o + Ie + Gr + ju + Uf + m + i + n + f + r,
                1,
                o + Bo + Hr + Ct + We + m + i + n + a + r,
                1,
                o + Bo + Hr + Ct + zf + m + i + n + f + r,
                1,
                o + Jt + Oa + A + je + m + i + n + a + r,
                1,
                o + Jt + Oa + A + je + m + i + n + f + r,
                1,
                l + Tn + Fn + Qt + nd + ut + m + i + n + a + r,
                1,
                l + Tn + Fn + Qt + nd + ne + m + i + n + f + r,
                1,
                o + Bo + Wr + Ct + fy + m + i + n + a + r,
                1,
                o + Bo + Wr + Ct + Gf + m + i + n + f + r,
                1,
                l + Ri + Li + Qc + Qh + rg + m + i + n + a + r,
                1,
                l + Ri + Li + Qc + Qh + k + m + i + n + f + r,
                1,
                l + oe + qi + pu + vi + N + m + i + n + a + r,
                1,
                l + oe + qi + pu + vi + hn + m + i + n + V + r,
                1,
                l + Ui + zi + Ne + vi + N + m + i + n + a + r,
                1,
                l + Ui + zi + Ne + vi + hn + m + i + n + V + r,
                1,
                l + Lp + vo + _e + hi + N + m + i + n + a + r,
                1,
                l + bo + xo + Cr + hi + N + m + i + n + a + r,
                1,
                l + Pn + Gi + Wm + Co + N + m + i + n + a + r,
                1,
                l + Pn + Gi + Wm + Co + N + m + i + n + f + r,
                1,
                l + Hi + Wi + In + Co + N + m + i + n + a + r,
                1,
                l + Hi + Wi + In + Co + N + m + i + n + f + r,
                1,
                l + nl + Ss + Xo + lt + Z + m + i + n + a + r,
                1,
                l + nl + Ss + Xo + lt + lf + m + i + n + V + r,
                1,
                l + zd + wr + ct + lt + Dr + m + i + n + a + r,
                1,
                l + zd + wr + ct + lt + Vl + m + i + n + V + r,
                1,
                l + Gd + _r + G + lt + wt + m + i + n + a + r,
                1,
                l + Gd + _r + G + lt + Zl + m + i + n + V + r,
                1,
                l + eh + $i + Qt + bi + N + m + i + n + a + r,
                1,
                l + eh + $i + Qt + bi + N + m + i + n + f + r,
                1,
                l + Bn + jn + J + bi + N + m + i + n + a + r,
                1,
                l + Bn + jn + J + bi + N + m + i + n + f + r,
                1,
                o + ei + Zo + uf + ve + m + i + n + a + r,
                1,
                o + ei + Zo + uf + ol + m + i + n + f + r,
                1,
                l + Vi + Tp + Rn + pr + Fp + m + i + n + a + r,
                1,
                l + Vi + Tp + Rn + pr + Fp + m + i + n + V + r,
                1,
                l + wo + _o + ft + dr + N + m + i + n + a + r,
                1,
                l + wo + _o + ft + dr + N + m + i + n + f + r,
                1,
                l + qp + Ao + ri + Tt + N + m + i + n + a + r,
                1,
                l + qp + Ao + ri + Tt + N + m + i + n + f + r,
                1,
                l + Zi + rh + te + Yf + N + m + i + n + a + r,
                1,
                l + Zi + rh + te + Yf + N + m + i + n + f + r,
                1,
                l + Ji + Qi + Ar + Tt + mi + Po + i + n + a + r,
                1,
                l + Ji + Qi + Ar + Tt + ur + Po + i + n + f + r,
                1,
                dn + Up + jy + Jp + dr + wt + ws + i + n + a + r,
                1,
                l + Up + jy + Jp + dr + wt + Dl + i + n + a + r,
                1,
                l + Yi + nh + $m + kl + I + st + i + n + a + r,
                1,
                l + Yi + nh + $m + kl + it + lr + i + n + f + r,
                1,
                l + Ki + Xi + Ln + gr + N + Fr + i + n + a + r,
                1,
                l + Ki + Xi + Ln + gr + N + Fa + i + n + f + r,
                1,
                l + Qe + tr + Er + gr + ut + Dl + i + n + a + r,
                1,
                l + Qe + tr + Er + gr + ne + up + i + n + f + r,
                1,
                l + to + eo + qn + vl + N + ef + i + n + a + r,
                1,
                l + to + eo + qn + vl + N + sp + i + n + f + r,
                1,
                l + Gu + rr + yt + ae + y + Fr + i + n + a + r,
                1,
                l + Gu + rr + yt + ae + ba + Vy + i + n + V + r,
                1,
                l + Gu + rr + yt + ae + at + Bh + i + n + f + r,
                1,
                l + Et + er + Ue + ae + y + st + i + n + a + r,
                1,
                l + Et + er + Ue + ae + ba + wm + i + n + V + r,
                1,
                l + Et + er + Ue + ae + at + Qo + i + n + f + r,
                1,
                l + Hu + nr + F + ae + y + Po + i + n + a + r,
                1,
                l + Hu + nr + F + ae + ba + Zy + i + n + V + r,
                1,
                l + Hu + nr + F + ae + at + Po + i + n + f + r,
                1,
                o + Fo + rf + Ru + y + m + i + n + a + r,
                1,
                l + Pp + ro + tt + Yo + Re + Fr + i + n + a + r,
                1,
                l + Pp + ro + tt + Yo + Pa + Fa + i + n + f + r,
                1,
                l + Xt + Un + et + Yo + Re + st + i + n + a + r,
                1,
                l + Xt + Un + et + Yo + Pa + lr + i + n + f + r,
                1,
                l + oe + Ip + pu + $r + y + m + i + n + a + r,
                1,
                l + oe + Ip + pu + $r + ot + m + i + n + f + r,
                1,
                l + no + io + zn + lt + y + m + i + n + a + r,
                1,
                l + no + io + zn + lt + ot + m + i + n + f + r,
                1,
                l + ah + By + _h + ya + N + m + i + n + a + r,
                1,
                l + Eo + So + Zm + pr + N + m + i + n + a + r,
                1,
                l + hl + ih + ft + He + N + m + i + n + a + r,
                1,
                l + hl + ih + ft + He + N + m + i + n + f + r,
                1,
                l + oo + ao + Gn + He + N + m + i + n + a + r,
                1,
                l + oo + ao + Gn + He + N + m + i + n + f + r,
                1,
                l + so + uo + Hd + He + N + m + i + n + a + r,
                1,
                l + so + uo + Hd + He + N + m + i + n + f + r,
                1,
                o + p + He + mt + dA + tv + i + n + a + r,
                1,
                o + Ke + nn + Ct + I + m + i + n + a + r,
                1,
                o + Ke + on + Ct + Z + ni + i + n + a + r,
                1,
                o + Ke + Lu + Ct + N + m + i + n + a + r,
                1,
                o + Ke + an + Ct + br + ni + i + n + a + r,
                1,
                c + bp + i + n + a + r,
                1,
                c + Rd + i + n + a + r,
                1,
                c + Og + i + n + a + r,
                1,
                c + qv + i + n + a + r,
                1,
                c + uA + i + n + a + r,
                1,
                c + Gv + i + n + a + r,
                1,
                c + Cy + i + n + a + r,
                1,
                c + lg + i + n + a + r,
                1,
                c + Dy + i + n + a + r,
                1,
                c + Uv + i + n + a + r,
                1,
                c + zv + i + n + a + r,
                1,
                c + Cm + i + n + a + r,
                1,
                c + wp + i + n + a + r,
                1,
                c + _p + i + n + a + r,
                1,
                c + Ap + i + n + a + r,
                1,
                c + Sp + i + n + a + r,
                1,
                c + $h + i + n + a + r,
                1,
                c + Vh + i + n + a + r,
                1,
                c + _u + i + n + a + r,
                1,
                c + zs + i + n + a + r,
                1,
                c + _s + i + n + a + r,
                1,
                o + " +lat_0=-21.11666666666667 +lon_0=55.53333333333333 +k=1 +x_0=160000" + xg + b + Dg + a + r,
                1,
                l + Lp + vo + _e + hi + N + m + i + n + f + r,
                1,
                l + bo + xo + Cr + hi + N + m + i + n + f + r,
                1,
                o + Ke + nn + Ct + Ba + m + i + n + f + r,
                1,
                o + Ke + on + Ct + $t + qt + i + n + f + r,
                1,
                o + Ke + Lu + Ct + N + m + i + n + f + r,
                1,
                o + Ke + an + Ct + Lt + qt + i + n + f + r,
                1,
                l + Lp + vo + _e + hi + N + m + i + n + f + r,
                1,
                l + bo + xo + Cr + hi + N + m + i + n + f + r,
                1,
                o + Ke + nn + Ct + Ba + m + i + n + f + r,
                1,
                o + Ke + on + Ct + $t + qt + i + n + f + r,
                1,
                o + Ke + Lu + Ct + N + m + i + n + f + r,
                1,
                o + Ke + an + Ct + Lt + qt + i + n + f + r,
                1,
                c + Cm + i + n + a + r,
                1,
                c + wp + i + n + a + r,
                1,
                c + _p + i + n + a + r,
                1,
                c + Ap + i + n + a + r,
                1,
                c + Sp + i + n + a + r,
                1,
                c + $h + i + n + a + r,
                1,
                c + Vh + i + n + a + r,
                1,
                c + _u + i + n + a + r,
                1,
                c + zs + i + n + a + r,
                1,
                c + _s + i + n + a + r,
                1,
                c + Gv + i + n + a + r,
                1,
                c + Cy + i + n + a + r,
                2,
                l + Lp + vo + _e + hi + N + m + i + n + f + r,
                1,
                l + bo + xo + Cr + hi + N + m + i + n + f + r,
                1,
                o + Ke + nn + Ct + Ba + m + i + n + f + r,
                1,
                o + Ke + on + Ct + $t + qt + i + n + f + r,
                1,
                o + Ke + Lu + Ct + N + m + i + n + f + r,
                1,
                o + Ke + an + Ct + Lt + qt + i + n + f + r,
                1,
                o + fa + Hl + wl + at + m + i + n + f + r,
                1,
                o + fa + Hl + wl + at + m + i + n + f + r,
                1,
                c + Mu + i + n + a + r,
                1,
                l + " +lat_1=-54 +lat_2=-54.75 +lat_0=-55 +lon_0=-37" + $ + m + x + a + r,
                1,
                o + " +lat_0=39.66825833333333 +lon_0=-8.133108333333334 +k=1" + $ + m + i + n + a + r,
                1,
                o + FE + ev + " +k=1" + Z + cr + i + n + a + r,
                1,
                o + p + pA + A + y + m + i + n + a + r,
                1,
                l + " +lat_1=45.91666666666666 +lat_2=43.08333333333334" + p + pA + $ + m + i + n + a + r,
                1,
                c + Rl + i + n + a + r,
                1,
                c + Zh + i + n + a + r,
                1,
                c + Ua + B + Iv + a + r,
                1,
                o + " +lat_0=32 +lon_0=-64.75 +k=1 +x_0=550000" + ni + j + n + a + r,
                1,
                o + p + $l + A + $ + m + S + a + r,
                1,
                o + p + fl + A + $ + m + S + a + r,
                1,
                o + p + yf + A + $ + m + S + a + r,
                2,
                o + p + $l + A + $ + m + i + n + a + r,
                1,
                o + p + fl + A + $ + m + i + n + a + r,
                1,
                o + p + yf + A + $ + m + i + n + a + r,
                2,
                o + p + $l + A + $ + m + i + n + a + r,
                1,
                o + p + fl + A + $ + m + i + n + a + r,
                1,
                o + p + yf + A + $ + m + i + n + a + r,
                2,
                o + " +lat_0=-25.06855261111111 +lon_0=-130.1129671111111 +k=1 +x_0=14200 +y_0=15500" + j + n + a + r,
                1,
                c + zv + z + b + Wv + a + r,
                4,
                o + p + CE + " +k=1" + Re + Bt + i + n + a + r,
                1,
                o + p + " +lon_0=169 +k=1" + Re + Bt + i + n + a + r,
                1,
                o + p + " +lon_0=179 +k=1" + Re + Bt + i + n + a + r,
                1,
                o + p + " +lon_0=-178 +k=1" + Re + Bt + i + n + a + r,
                2,
                o + p + ev + " +k=1" + Re + Bt + i + n + a + r,
                1,
                o + p + Sa + A + y + si + i + n + a + r,
                1,
                l + " +lat_1=23 +lat_2=21.7 +lat_0=22.35" + pr + y + " +y_0=280296.016" + S + a + r,
                1,
                l + " +lat_1=21.3 +lat_2=20.13333333333333 +lat_0=20.71666666666667 +lon_0=-76.83333333333333" + y + " +y_0=229126.939" + S + a + r,
                1,
                l + rE + cp + fu + " +lon_0=-70" + br + m + S + a + r,
                1,
                l + rE + cp + fu + " +lon_0=-70" + br + m + i + n + a + r,
                1,
                l + rE + cp + fu + " +lon_0=-70" + br + m + i + n + a + r,
                1,
                o + p + Eh + A + $ + m + S + a + r,
                1,
                o + p + Eh + A + $ + m + i + n + a + r,
                1,
                o + p + Eh + A + $ + m + i + n + a + r,
                10,
                l + Mc + kc + " +lat_0=50.797815" + xw + " +x_0=649328 +y_0=665262" + i + n + a + r,
                2,
                o + mf + rv + ib + y + fm + i + n + a + r,
                1,
                o + mf + rv + ib + y + fm + i + n + a + r,
                1,
                o + mf + rv + ib + y + fm + i + n + a + r,
                3,
                h + M + " +towgs84=595.48,121.69,515.35,4.115,-2.9383,0.853,-3.408" + r,
                2,
                h + X + r,
                3,
                h + i + n + r,
                1,
                o + p + kE + A + We + m + i + n + a + r,
                1,
                o + p + NE + A + We + m + i + n + a + r,
                1,
                o + p + kE + A + We + m + X + a + r,
                1,
                o + p + NE + A + We + m + X + a + r,
                1,
                c + fh + b + fg + a + r,
                3,
                il + od + " +k=1" + $ + m + x + a + r,
                1,
                o + p + jl + " +k=1" + Dr + m + d + C + a + r,
                1,
                o + p + jl + " +k=1" + Dr + m + d + Gt + a + r,
                1,
                o + p + Sa + " +k=1" + Re + m + d + Gt + a + r,
                1,
                o + p + ka + " +k=1" + cn + m + d + Gt + a + r,
                1,
                o + p + jl + " +k=1" + Re + m + d + C + a + r,
                1,
                o + p + Vs + " +k=1" + cn + m + d + C + a + r,
                1,
                o + p + rs + " +k=1" + Jf + m + d + C + a + r,
                1,
                o + p + hu + " +k=1" + of + m + d + C + a + r,
                1,
                o + p + zm + " +k=1" + Cl + m + d + Gt + a + r,
                3,
                ca + " +lat_0=46" + Ty + yg + y + Dt + d + C + a + r,
                1,
                o + p + " +lon_0=11.30625 +k=1.000006 +x_0=1500025.141 +y_0=-667.282" + i + n + a + r,
                1,
                o + p + " +lon_0=13.55626666666667 +k=1.0000058 +x_0=1500044.695 +y_0=-667.13" + i + n + a + r,
                1,
                o + p + " +lon_0=15.80628452944445 +k=1.00000561024 +x_0=1500064.274 +y_0=-667.711" + i + n + a + r,
                1,
                o + p + " +lon_0=18.0563 +k=1.0000054 +x_0=1500083.521 +y_0=-668.8440000000001" + i + n + a + r,
                1,
                o + p + " +lon_0=20.30631666666667 +k=1.0000052 +x_0=1500102.765 +y_0=-670.706" + i + n + a + r,
                1,
                o + p + " +lon_0=22.55633333333333 +k=1.0000049 +x_0=1500121.846 +y_0=-672.557" + i + n + a + r,
                1,
                l + " +lat_1=-37.5 +lat_2=-44.5 +lat_0=-41 +lon_0=173" + hS + " +y_0=7000000" + i + n + a + r,
                1,
                l + Pt + It + q + " +lon_0=157" + y + m + i + n + a + r,
                2,
                o + p + " +lon_0=18.05787 +k=0.99999506 +x_0=100182.7406 +y_0=-6500620.1207" + i + n + a + r,
                3,
                il + " +a=6378137 +b=6378137 +lat_ts=0.0 +lon_0=0.0 +x_0=0.0" + m + " +k=1.0" + a + " +nadgrids=@null +wktext " + r,
                16,
                o + p + Oy + " +k=1" + Fs + m + i + n + a + r,
                1,
                o + p + Sb + " +k=1" + ls + m + i + n + a + r,
                1,
                o + p + ka + " +k=1" + Bs + m + i + n + a + r,
                1,
                o + p + iE + " +k=1" + cs + m + i + n + a + r,
                1,
                o + p + Bg + " +k=1" + js + m + i + n + a + r,
                1,
                o + p + Zs + " +k=1" + sf + m + i + n + a + r,
                1,
                o + p + Ty + " +k=1" + Rs + m + i + n + a + r,
                1,
                o + p + Mb + " +k=1" + Ls + m + i + n + a + r,
                1,
                o + p + rs + " +k=1" + qs + m + i + n + a + r,
                1,
                o + p + Ry + " +k=1" + Us + m + i + n + a + r,
                1,
                o + p + " +lon_0=29 +k=1" + La + m + i + n + a + r,
                1,
                o + p + hu + " +k=1" + ou + m + i + n + a + r,
                1,
                o + p + Um + " +k=1" + va + m + i + n + a + r,
                4,
                h + i + n + r,
                1,
                c + Ll + i + n + a + r,
                1,
                c + ll + i + n + a + r,
                1,
                c + Ku + i + n + a + r,
                1,
                o + _w + " +lon_0=46.5 +k=0.9994" + br + m + b + U + a + r,
                13,
                h + M + Zt + r,
                6,
                o + p + Sa + A + y + si + M + Zt + a + r,
                8,
                c + Ua + B + dl + a + r,
                22,
                l + " +lat_1=41.25 +lat_2=42.75" + Hd + vd + Ol + tb + i + n + a + r,
                1,
                l + " +lat_1=42.25 +lat_2=43.75" + hp + vd + Ol + " +y_0=2200000" + i + n + a + r,
                1,
                l + " +lat_1=43.25 +lat_2=44.75" + fu + vd + Ol + " +y_0=3200000" + i + n + a + r,
                1,
                l + " +lat_1=44.25 +lat_2=45.75" + eu + vd + Ol + " +y_0=4200000" + i + n + a + r,
                1,
                l + " +lat_1=45.25 +lat_2=46.75 +lat_0=46" + vd + Ol + " +y_0=5200000" + i + n + a + r,
                1,
                l + pS + " +lat_2=47.75" + pu + vd + Ol + " +y_0=6200000" + i + n + a + r,
                1,
                l + " +lat_1=47.25 +lat_2=48.75 +lat_0=48" + vd + Ol + " +y_0=7200000" + i + n + a + r,
                1,
                l + " +lat_1=48.25 +lat_2=49.75 +lat_0=49" + vd + Ol + " +y_0=8200000" + i + n + a + r,
                1,
                l + " +lat_1=49.25 +lat_2=50.75" + eE + vd + Ol + " +y_0=9200000" + i + n + a + r,
                18,
                l + " +lat_1=37" + kA + ra + ya + $ + m + i + n + a + r,
                1,
                l + " +lat_1=37" + kA + ra + ya + $ + m + i + n + a + r,
                1,
                l + " +lat_1=37" + kA + ra + ya + $ + m + i + n + a + r,
                6,
                pe + q + " +lat_ts=-70" + es + " +k=1" + $ + m + x + a + r,
                2,
                l + $c + Ys + " +lat_0=49 +lon_0=-95" + $ + m + i + n + a + r,
                1,
                l + $c + Ys + " +lat_0=49 +lon_0=-95" + $ + m + i + n + a + r,
                7,
                o + sE + hu + " +k=1" + I + Dt + B + vr + a + r,
                1,
                o + sE + Ry + " +k=1" + I + Dt + B + vr + a + r,
                1,
                o + sE + Mb + " +k=1" + I + Dt + B + vr + a + r,
                1,
                o + sE + Zs + " +k=1" + I + Dt + B + vr + a + r,
                2,
                l + ha + pa + da + Ho + T + m + B + dl + f + r,
                1,
                l + ha + pa + da + Ho + T + xm + B + dl + f + r,
                2,
                il + " +lon_0=100 +lat_ts=-41" + $ + m + x + a + r,
                1,
                pe + Os + " +lat_ts=71" + es + " +k=1" + $ + m + x + a + r,
                1,
                pe + Os + " +lat_ts=75" + es + " +k=1" + $ + m + x + a + r,
                1,
                o + p + " +lon_0=55.33333333333334 +k=1" + y + m + x + a + r,
                4,
                h + Zd + r,
                1,
                h + fd + r,
                1,
                h + X + r,
                1,
                h + M + r,
                1,
                h + ks + ii + r,
                1,
                h + Ga + r,
                1,
                h + Ai + Ei + r,
                1,
                h + B + r,
                2,
                h + op + ap + r,
                1,
                h + xt + fe + r,
                1,
                h + D + r,
                1,
                h + Me + ye + r,
                1,
                h + xt + " +b=6356514.996941779" + r,
                1,
                h + Ze + Kt + r,
                1,
                h + wf + r,
                2,
                h + ea + Ye + r,
                1,
                h + i + r,
                1,
                h + Ca + r,
                1,
                h + nu + Oe + r,
                1,
                h + b + r,
                1,
                h + i + n + r,
                0,
                h + i + n + r,
                1,
                h + d + r,
                1,
                h + dS + r,
                1,
                o + p + " +lon_0=28.4 +k=0.9999400000000001" + I + si + i + n + a + r,
                1,
                h + " +a=6376523" + Ay + r,
                1,
                h + rS + wy + r,
                1,
                h + ay + Ns + r,
                1,
                h + j + r,
                1,
                h + j + r,
                1,
                h + " +a=6378136.2 +b=6356751.516927429" + r,
                1,
                h + " +a=6378136.3 +b=6356751.616592146" + r,
                1,
                h + Ey + Sy + r,
                2,
                h + mS + r,
                1,
                c + yc + x + a + r,
                1,
                c + ch + x + a + r,
                3,
                h + rm + Ta + r,
                1,
                h + Ja + ja + r,
                1,
                h + w + r,
                1,
                h + _f + Cs + r,
                1,
                h + Da + mr + r,
                1,
                h + i + n + r,
                1,
                h + " +a=6371007 +b=6371007" + r,
                1,
                o + p + Vs + A + y + Bt + i + n + a + r,
                1,
                o + p + " +lon_0=14" + A + y + Bt + i + n + a + r,
                1,
                o + p + " +lon_0=16" + A + y + Bt + i + n + a + r,
                1,
                o + p + zm + A + y + Bt + i + n + a + r,
                1,
                h + " +a=6370997 +b=6370997" + r,
                1,
                h + DE + OE + r,
                1,
                h + TE + ng + r,
                2,
                o + p + Sb + A + y + Bt + i + n + a + r,
                1,
                o + p + iE + A + y + Bt + i + n + a + r,
                1,
                o + p + Zs + A + y + Bt + i + n + a + r,
                1,
                o + p + Mb + A + y + Bt + i + n + a + r,
                1,
                o + p + Ry + A + y + Bt + i + n + a + r,
                1,
                c + Rl + z + i + n + a + r,
                1,
                c + Zh + z + i + n + a + r,
                1,
                c + yc + z + i + n + a + r,
                8,
                c + Pf + z + b + Ev + a + r,
                4,
                h + i + n + r,
                6,
                h + i + n + r,
                1,
                c + Tg + i + n + a + r,
                1,
                c + cl + i + n + a + r,
                4,
                "+proj=eqc +lat_ts=0" + p + es + $ + m + x + a + r,
                1,
                "+proj=eqc +lat_ts=0" + p + es + $ + m + " +a=6371007 +b=6371007" + a + r,
                5,
                o + p + jl + zu + I + si + i + n + a + r,
                1,
                o + p + kf + zu + Z + si + i + n + a + r,
                1,
                o + p + " +lon_0=11.75" + zu + N + si + i + n + a + r,
                1,
                o + p + Sa + " +k=1" + br + si + i + n + a + r,
                24,
                h + M + r,
                1,
                h + i + Jm + r,
                1,
                h + rm + Ta + r,
                1,
                h + b + Wt + r,
                1,
                h + M + xe + r,
                3,
                h + B + Va + r,
                1,
                h + B + r,
                1,
                h + B + r,
                1,
                h + j + Ql + r,
                1,
                h + Ze + Kt + Qu + r,
                1,
                h + D + km + r,
                1,
                h + i + Cf + r,
                1,
                h + D + _a + r,
                1,
                h + B + Wo + r,
                1,
                h + B + r,
                1,
                h + B + r,
                1,
                h + B + r,
                1,
                h + B + dl + r,
                2,
                h + i + bb + r,
                1,
                h + D + Ju + r,
                1,
                h + D + Hs + r,
                1,
                h + Ze + Kt + tl + r,
                1,
                h + _f + Cs + aa + r,
                1,
                h + Da + mr + ge + r,
                1,
                h + d + Za + r,
                1,
                h + j + n + r,
                1,
                h + M + wa + r,
                1,
                h + M + Am + r,
                1,
                h + i + n + r,
                1,
                h + i + n + r,
                1,
                h + b + Em + r,
                1,
                h + b + qa + r,
                1,
                h + xt + fe + mp + r,
                1,
                h + M + Aa + r,
                1,
                h + Ai + Ei + r,
                1,
                h + b + Sm + r,
                1,
                h + b + Y + r,
                1,
                h + b + r,
                1,
                h + b + Eg + r,
                1,
                h + M + r,
                1,
                h + j + n + r,
                1,
                h + d + Uh + r,
                1,
                h + b + Ov + r,
                1,
                h + j + n + r,
                1,
                h + i + n + r,
                1,
                h + ay + Ns + Lh + r,
                1,
                h + B + wv + r,
                1,
                h + i + n + r,
                1,
                h + i + n + r,
                2,
                h + i + n + r,
                1,
                h + ay + Ns + r,
                1,
                h + D + Xp + r,
                1,
                h + i + n + r,
                2,
                h + d + Gt + r,
                1,
                h + d + C + r,
                1,
                h + i + n + r,
                1,
                h + b + Fl + r,
                1,
                h + b + mv + r,
                1,
                h + b + yv + r,
                1,
                h + b + Tv + r,
                4,
                h + Zd + Se + r,
                1,
                h + i + n + r,
                1,
                h + i + n + r,
                1,
                h + d + r,
                1,
                h + b + ey + r,
                1,
                h + xt + fe + My + r,
                1,
                h + b + jh + r,
                1,
                h + b + " +towgs84=105,326,-102.5,0,0,0.814,-0.6" + r,
                1,
                h + b + " +towgs84=-45,417,-3.5,0,0,0.814,-0.6" + r,
                1,
                h + D + r,
                1,
                h + D + r,
                1,
                h + b + r,
                1,
                h + d + u + r,
                1,
                h + D + fs + r,
                1,
                h + X + W + r,
                1,
                h + X + Xe + r,
                1,
                h + b + Pr + r,
                1,
                h + d + zh + r,
                1,
                h + xt + fe + r,
                1,
                h + b + di + r,
                1,
                h + b + wi + r,
                1,
                h + Me + ye + Su + r,
                1,
                h + D + ci + r,
                1,
                h + M + Or + r,
                1,
                h + D + Tl + r,
                1,
                h + xt + fe + gv + r,
                1,
                h + d + _ + r,
                1,
                h + b + r,
                1,
                h + B + Iv + r,
                1,
                o + p + hf + mt + R + m + i + n + f + r,
                0,
                o + p + hf + mt + R + m + i + n + f + r,
                1,
                h + b + fi + r,
                1,
                h + M + " +towgs84=-384,664,-48,0,0,0,0" + r,
                1,
                h + D + ia + r,
                1,
                h + b + ze + r,
                1,
                h + Me + ye + Yt + r,
                1,
                h + xt + fe + Ea + r,
                1,
                h + b + Ev + r,
                1,
                h + b + sa + r,
                2,
                h + xt + fe + Ka + r,
                2,
                h + Ca + hs + r,
                1,
                h + b + U + r,
                1,
                h + b + " +towgs84=-83.11,-97.38,-117.22,0.00569291,-0.0446976,0.0442851,0.1218" + r,
                1,
                h + D + Gh + r,
                4,
                h + b + fg + r,
                1,
                h + mS + ky + r,
                1,
                h + nu + Oe + Vt + r,
                1,
                h + Ze + Kt + el + r,
                1,
                h + Ze + Kt + Hh + r,
                1,
                h + Ey + Sy + r,
                1,
                h + B + Sv + r,
                1,
                h + Ja + ja + r,
                1,
                h + Ze + Kt + $v + r,
                1,
                h + ea + Ye + be + r,
                1,
                h + D + iy + r,
                1,
                h + b + ys + r,
                1,
                h + b + At + r,
                1,
                h + b + r,
                1,
                h + D + Bv + r,
                1,
                h + D + " +towgs84=-90,40,88,0,0,0,0" + r,
                1,
                h + xt + fe + r,
                1,
                h + B + $o + r,
                1,
                h + b + Kp + r,
                1,
                h + b + " +towgs84=-333,-222,114,0,0,0,0" + r,
                1,
                h + D + " +towgs84=41,-220,-134,0,0,0,0" + r,
                1,
                h + M + ps + r,
                1,
                h + i + n + r,
                1,
                h + b + ty + r,
                2,
                h + xt + fe + tu + r,
                1,
                h + M + Vv + r,
                1,
                h + D + ua + r,
                2,
                h + b + ar + r,
                1,
                h + xt + fe + Wh + r,
                1,
                h + S + r,
                2,
                h + i + n + r,
                1,
                h + D + ln + r,
                1,
                h + b + jv + r,
                1,
                h + b + E + r,
                1,
                h + ks + ii + Mt + r,
                1,
                h + b + Yu + r,
                1,
                h + xt + fe + Pe + r,
                1,
                h + dS + r,
                1,
                h + Zd + Df + r,
                1,
                h + Zd + r,
                1,
                h + Zd + r,
                1,
                h + M + r,
                1,
                h + op + ap + pn + r,
                1,
                h + xt + fe + Mv + r,
                1,
                h + i + n + r,
                1,
                h + d + s + r,
                1,
                h + b + Lm + r,
                1,
                h + Ca + r,
                2,
                h + b + r,
                1,
                h + M + Lo + r,
                3,
                h + b + yp + r,
                1,
                h + Ga + Ge + r,
                2,
                h + M + r,
                2,
                h + b + Wa + r,
                1,
                h + wf + Vo + r,
                1,
                h + fd + Se + r,
                1,
                h + fd + Se + r,
                1,
                h + M + P + r,
                1,
                h + Ai + Ei + Zu + r,
                1,
                h + Ca + r,
                1,
                h + xt + fe + qu + r,
                2,
                h + M + r,
                1,
                h + D + Ot + r,
                1,
                h + M + r,
                1,
                h + b + " +towgs84=-155,171,37,0,0,0,0" + r,
                1,
                h + xt + fe + r,
                1,
                h + b + $a + r,
                1,
                h + M + Q + r,
                1,
                h + b + oa + r,
                1,
                h + M + rt + r,
                1,
                h + xt + fe + gp + r,
                1,
                h + b + qm + r,
                2,
                h + j + Kf + r,
                1,
                h + i + hg + r,
                3,
                h + w + g + r,
                2,
                h + w + v + r,
                2,
                h + x + r,
                64,
                Tr + " +lat_0=2.042583333333333 +lon_0=103.5627583333333" + $ + m + ea + Ye + be + a + r,
                1,
                Tr + " +lat_0=2.712283333333334 +lon_0=101.9411666666667 +x_0=-242.005 +y_0=-948.547" + ea + Ye + be + a + r,
                1,
                Tr + " +lat_0=3.710972222222222 +lon_0=102.4361777777778" + $ + m + ea + Ye + be + a + r,
                1,
                Tr + " +lat_0=3.680344444444444 +lon_0=101.5082444444444 +x_0=-21759.438 +y_0=55960.906" + ea + Ye + be + a + r,
                1,
                Tr + " +lat_0=4.946141666666667 +lon_0=102.8952083333333" + $ + m + ea + Ye + be + a + r,
                1,
                Tr + " +lat_0=5.421325 +lon_0=100.3458694444444" + $ + m + ea + Ye + be + a + r,
                1,
                Tr + " +lat_0=5.965147222222223 +lon_0=100.6375944444444" + $ + m + ea + Ye + be + a + r,
                1,
                Tr + " +lat_0=4.859380555555555 +lon_0=100.8167666666667" + $ + " +y_0=133453.669" + ea + Ye + be + a + r,
                1,
                Tr + " +lat_0=5.893922222222222 +lon_0=102.1772916666667" + $ + m + ea + Ye + be + a + r,
                1,
                o + p + hf + mt + R + m + S + f + r,
                1,
                o + p + zl + mt + R + m + S + f + r,
                1,
                o + p + Gl + mt + R + m + S + f + r,
                1,
                o + p + df + mt + R + m + S + f + r,
                1,
                o + p + Hg + mt + R + m + S + f + r,
                1,
                o + p + " +lon_0=-159" + mt + R + m + S + f + r,
                0,
                o + p + " +lon_0=-159" + mt + R + m + S + f + r,
                1,
                o + p + vA + mt + R + m + S + f + r,
                1,
                o + p + dy + mt + R + m + S + f + r,
                1,
                o + p + " +lon_0=-141" + mt + R + m + S + f + r,
                1,
                o + p + bA + mt + R + m + S + f + r,
                1,
                o + p + NA + mt + R + m + S + f + r,
                1,
                o + p + " +lon_0=-123" + mt + R + m + S + f + r,
                1,
                o + p + yf + mt + R + m + S + f + r,
                1,
                o + p + $l + mt + R + m + S + f + r,
                1,
                o + p + " +lon_0=-105" + mt + R + m + S + f + r,
                1,
                o + " +lat_0=13.5 +lon_0=144.75 +k=1" + ve + Ks + i + n + a + r,
                1,
                l + " +lat_1=-6.5 +lat_2=-11.5" + sE + Mb + y + Dt + B + vr + a + r,
                2,
                o + p + ka + " +k=1" + Js + m + d + Gt + a + r,
                1,
                o + p + Pb + mt + R + m + S + f + r,
                1,
                o + p + Zf + mt + R + m + S + f + r,
                1,
                o + p + zl + mt + R + m + i + n + f + r,
                1,
                o + p + Gl + mt + R + m + i + n + f + r,
                1,
                o + p + df + mt + R + m + i + n + f + r,
                1,
                o + p + Hg + mt + R + m + i + n + f + r,
                1,
                o + p + " +lon_0=-159" + mt + R + m + i + n + f + r,
                1,
                o + p + vA + mt + R + m + i + n + f + r,
                1,
                o + p + dy + mt + R + m + i + n + f + r,
                1,
                o + p + " +lon_0=-141" + mt + R + m + i + n + f + r,
                1,
                o + p + bA + mt + R + m + i + n + f + r,
                1,
                o + p + NA + mt + R + m + i + n + f + r,
                1,
                o + p + " +lon_0=-123" + mt + R + m + i + n + f + r,
                1,
                o + p + yf + mt + R + m + i + n + f + r,
                1,
                o + p + $l + mt + R + m + i + n + f + r,
                1,
                o + p + " +lon_0=-105" + mt + R + m + i + n + f + r,
                1,
                o + p + Zs + " +k=1" + Xf + m + d + Gt + a + r,
                3,
                l + ha + pa + da + Ho + I + Ks + i + n + a + r,
                1,
                o + p + Pb + mt + R + m + i + n + f + r,
                1,
                o + p + Zf + mt + R + m + i + n + f + r,
                16,
                l + Bn + jn + J + bi + k + m + S + f + r,
                1,
                l + Tn + Fn + Ke + nd + k + xm + S + f + r,
                1,
                l + wo + _o + ft + dr + N + m + i + n + f + r,
                5,
                l + " +lat_1=-18" + ME + " +lat_0=-27" + Au + $ + m + x + a + r,
                1,
                h + i + n + r,
                4,
                c + Gs + i + n + a + r,
                3,
                h + i + n + r,
                1,
                c + ll + z + i + n + a + r,
                4,
                h + b + Bd + r,
                8,
                h + i + n + r,
                1,
                c + wp + i + n + a + r,
                1,
                c + _p + i + n + a + r,
                1,
                c + Ap + i + n + a + r,
                1,
                c + Sp + i + n + a + r,
                1,
                c + $h + i + n + a + r,
                1,
                c + Vh + i + n + a + r,
                1,
                h + i + r,
                1,
                o + p + ns + " +k=1" + us + m + i + a + r,
                1,
                o + p + is + " +k=1" + Ra + m + i + a + r,
                1,
                o + p + gs + " +k=1" + Ps + m + i + a + r,
                1,
                o + p + os + " +k=1" + Is + m + i + a + r,
                1,
                o + p + as + " +k=1" + Ou + m + i + a + r,
                1,
                o + p + ai + " +k=1" + Ts + m + i + a + r,
                1,
                o + p + zo + " +k=1" + Fs + m + i + a + r,
                1,
                o + p + Do + " +k=1" + ls + m + i + a + r,
                1,
                o + p + Io + " +k=1" + Bs + m + i + a + r,
                1,
                o + p + _i + " +k=1" + cs + m + i + a + r,
                1,
                o + p + Oo + " +k=1" + js + m + i + a + r,
                1,
                o + p + ns + " +k=1" + y + m + i + a + r,
                1,
                o + p + is + " +k=1" + y + m + i + a + r,
                1,
                o + p + gs + " +k=1" + y + m + i + a + r,
                1,
                o + p + os + " +k=1" + y + m + i + a + r,
                1,
                o + p + as + " +k=1" + y + m + i + a + r,
                1,
                o + p + ai + " +k=1" + y + m + i + a + r,
                1,
                o + p + zo + " +k=1" + y + m + i + a + r,
                1,
                o + p + Do + " +k=1" + y + m + i + a + r,
                1,
                o + p + Io + " +k=1" + y + m + i + a + r,
                1,
                o + p + _i + " +k=1" + y + m + i + a + r,
                1,
                o + p + Oo + " +k=1" + y + m + i + a + r,
                1,
                o + p + ns + " +k=1" + Rs + m + i + a + r,
                1,
                o + p + Mf + " +k=1" + Ls + m + i + a + r,
                1,
                o + p + is + " +k=1" + qs + m + i + a + r,
                1,
                o + p + fp + " +k=1" + Us + m + i + a + r,
                1,
                o + p + gs + " +k=1" + La + m + i + a + r,
                1,
                o + p + Ds + " +k=1" + ou + m + i + a + r,
                1,
                o + p + os + " +k=1" + va + m + i + a + r,
                1,
                o + p + dh + " +k=1" + au + m + i + a + r,
                1,
                o + p + as + " +k=1" + Tu + m + i + a + r,
                1,
                o + p + bl + " +k=1" + Sh + m + i + a + r,
                1,
                o + p + ai + " +k=1" + Mh + m + i + a + r,
                1,
                o + p + ff + " +k=1" + kh + m + i + a + r,
                1,
                o + p + zo + " +k=1" + Nh + m + i + a + r,
                1,
                o + p + Eu + " +k=1" + Ch + m + i + a + r,
                1,
                o + p + Do + " +k=1" + Dh + m + i + a + r,
                1,
                o + p + Ul + " +k=1" + Oh + m + i + a + r,
                1,
                o + p + Io + " +k=1" + Th + m + i + a + r,
                1,
                o + p + xl + " +k=1" + ud + m + i + a + r,
                1,
                o + p + _i + " +k=1" + Fh + m + i + a + r,
                1,
                o + p + Au + " +k=1" + ld + m + i + a + r,
                1,
                o + p + Oo + " +k=1" + Ph + m + i + a + r,
                1,
                o + p + ns + " +k=1" + y + m + i + a + r,
                1,
                o + p + Mf + " +k=1" + y + m + i + a + r,
                1,
                o + p + is + " +k=1" + y + m + i + a + r,
                1,
                o + p + fp + " +k=1" + y + m + i + a + r,
                1,
                o + p + gs + " +k=1" + y + m + i + a + r,
                1,
                o + p + Ds + " +k=1" + y + m + i + a + r,
                1,
                o + p + os + " +k=1" + y + m + i + a + r,
                1,
                o + p + dh + " +k=1" + y + m + i + a + r,
                1,
                o + p + as + " +k=1" + y + m + i + a + r,
                1,
                o + p + bl + " +k=1" + y + m + i + a + r,
                1,
                o + p + ai + " +k=1" + y + m + i + a + r,
                1,
                o + p + ff + " +k=1" + y + m + i + a + r,
                1,
                o + p + zo + " +k=1" + y + m + i + a + r,
                1,
                o + p + Eu + " +k=1" + y + m + i + a + r,
                1,
                o + p + Do + " +k=1" + y + m + i + a + r,
                1,
                o + p + Ul + " +k=1" + y + m + i + a + r,
                1,
                o + p + Io + " +k=1" + y + m + i + a + r,
                1,
                o + p + xl + " +k=1" + y + m + i + a + r,
                1,
                o + p + _i + " +k=1" + y + m + i + a + r,
                1,
                o + p + Au + " +k=1" + y + m + i + a + r,
                1,
                o + p + Oo + " +k=1" + y + m + i + a + r,
                1,
                h + d + r,
                3,
                h + i + n + r,
                1,
                c + Ua + i + n + a + r,
                9,
                o + p + ns + " +k=1" + us + m + d + a + r,
                1,
                o + p + is + " +k=1" + Ra + m + d + a + r,
                1,
                o + p + gs + " +k=1" + Ps + m + d + a + r,
                1,
                o + p + os + " +k=1" + Is + m + d + a + r,
                1,
                o + p + as + " +k=1" + Ou + m + d + a + r,
                1,
                o + p + ai + " +k=1" + Ts + m + d + a + r,
                1,
                o + p + zo + " +k=1" + Fs + m + d + a + r,
                1,
                o + p + Do + " +k=1" + ls + m + d + a + r,
                1,
                o + p + Io + " +k=1" + Bs + m + d + a + r,
                1,
                o + p + _i + " +k=1" + cs + m + d + a + r,
                1,
                o + p + Oo + " +k=1" + js + m + d + a + r,
                1,
                o + p + ns + " +k=1" + y + m + d + a + r,
                1,
                o + p + is + " +k=1" + y + m + d + a + r,
                1,
                o + p + gs + " +k=1" + y + m + d + a + r,
                1,
                o + p + os + " +k=1" + y + m + d + a + r,
                1,
                o + p + as + " +k=1" + y + m + d + a + r,
                1,
                o + p + ai + " +k=1" + y + m + d + a + r,
                1,
                o + p + zo + " +k=1" + y + m + d + a + r,
                1,
                o + p + Do + " +k=1" + y + m + d + a + r,
                1,
                o + p + Io + " +k=1" + y + m + d + a + r,
                1,
                o + p + _i + " +k=1" + y + m + d + a + r,
                1,
                o + p + Oo + " +k=1" + y + m + d + a + r,
                11,
                h + D + r,
                1,
                h + D + kv + r,
                1,
                h + D + Nv + r,
                1,
                h + D + Cv + r,
                1,
                h + D + Dv + r,
                1,
                h + D + vb + r,
                1,
                h + D + dv + r,
                1,
                h + D + gm + r,
                1,
                h + B + r,
                1,
                h + B + r,
                1,
                h + Ht + O + r,
                1,
                h + b + yl + r,
                1,
                h + i + n + r,
                1,
                h + M + bs + r,
                1,
                h + b + Pl + r,
                1,
                h + b + Sg + r,
                1,
                h + b + vv + r,
                1,
                h + i + n + r,
                1,
                h + X + jt + r,
                1,
                h + i + n + r,
                1,
                h + D + " +towgs84=-106,-129,165,0,0,0,0" + r,
                1,
                h + b + bv + r,
                1,
                h + b + Mg + r,
                1,
                h + b + Rh + r,
                1,
                h + i + n + r,
                1,
                h + b + Fv + r,
                1,
                h + b + Dg + r,
                1,
                h + i + n + r,
                1,
                h + b + Pv + r,
                1,
                h + b + Ef + r,
                1,
                h + b + xb + r,
                2,
                h + b + kg + r,
                1,
                h + b + jm + r,
                3,
                h + b + " +towgs84=365,194,166,0,0,0,0" + r,
                1,
                h + b + " +towgs84=325,154,172,0,0,0,0" + r,
                1,
                h + B + Hv + r,
                1,
                h + b + Ng + r,
                2,
                h + b + ml + r,
                1,
                h + b + xv + r,
                1,
                h + b + hc + r,
                1,
                h + b + Ya + r,
                2,
                h + b + Cg + r,
                1,
                o + p + jl + mt + au + m + i + n + a + r,
                5,
                o + p + ns + " +k=1" + Rs + m + d + a + r,
                1,
                o + p + Mf + " +k=1" + Ls + m + d + a + r,
                1,
                o + p + is + " +k=1" + qs + m + d + a + r,
                1,
                o + p + fp + " +k=1" + Us + m + d + a + r,
                1,
                o + p + gs + " +k=1" + La + m + d + a + r,
                1,
                h + " +a=6377019.27 +b=6355762.5391 +towgs84=-28,199,5,0,0,0,0" + r,
                1,
                h + b + pl + r,
                1,
                h + i + n + r,
                1,
                h + b + Il + r,
                1,
                h + i + n + r,
                1,
                h + b + Qm + r,
                1,
                h + b + Id + r,
                1,
                h + b + vm + r,
                1,
                h + b + Qd + r,
                1,
                h + M + tm + r,
                1,
                h + j + n + r,
                1,
                h + b + " +towgs84=-86,-98,-119,0,0,0,0" + r,
                1,
                h + i + n + r,
                1,
                h + j + n + r,
                1,
                h + xt + fe + r,
                1,
                h + b + Rv + r,
                1,
                h + b + vp + r,
                1,
                h + i + n + r,
                1,
                h + B + " +towgs84=-100,-248,259,0,0,0,0" + r,
                1,
                h + d + r,
                1,
                h + d + r,
                1,
                h + d + " +towgs84=44.585,-131.212,-39.544,0,0,0,0" + r,
                1,
                h + D + " +towgs84=-80.01,253.26,291.19,0,0,0,0" + r,
                1,
                h + D + " +towgs84=124.5,-63.5,-281,0,0,0,0" + r,
                2,
                h + Ze + Kt + Ny + r,
                1,
                h + B + we + r,
                1,
                h + b + " +towgs84=-133,-321,50,0,0,0,0" + r,
                2,
                h + i + n + r,
                1,
                h + i + Be + r,
                1,
                h + b + cc + r,
                1,
                h + b + Af + r,
                1,
                h + b + dc + r,
                1,
                h + b + mc + r,
                1,
                h + b + Rm + r,
                1,
                h + j + _v + r,
                1,
                h + j + n + r,
                1,
                h + B + vr + r,
                1,
                h + D + r,
                1,
                h + D + r,
                1,
                h + b + Av + r,
                1,
                h + D + ry + r,
                1,
                h + D + r,
                1,
                h + D + na + r,
                1,
                h + i + n + r,
                1,
                h + D + r,
                1,
                h + b + r,
                1,
                h + b + r,
                1,
                h + Ca + ny + r,
                1,
                h + b + " +towgs84=114,-116,-333,0,0,0,0" + r,
                1,
                h + X + " +towgs84=-491,-22,435,0,0,0,0" + r,
                1,
                h + b + " +towgs84=145,75,-272,0,0,0,0" + r,
                1,
                h + b + " +towgs84=-320,550,-494,0,0,0,0" + r,
                1,
                h + b + " +towgs84=124,-234,-25,0,0,0,0" + r,
                1,
                h + b + " +towgs84=-205,107,53,0,0,0,0" + r,
                1,
                h + D + " +towgs84=-79,-129,145,0,0,0,0" + r,
                1,
                h + b + " +towgs84=-127,-769,472,0,0,0,0" + r,
                1,
                h + b + " +towgs84=-104,-129,239,0,0,0,0" + r,
                1,
                h + b + " +towgs84=298,-304,-375,0,0,0,0" + r,
                1,
                h + B + " +towgs84=-2,151,181,0,0,0,0" + r,
                1,
                h + b + " +towgs84=230,-199,-752,0,0,0,0" + r,
                1,
                h + b + " +towgs84=211,147,111,0,0,0,0" + r,
                1,
                h + w + g + r,
                1,
                h + b + Uu + r,
                1,
                h + b + " +towgs84=-794,119,-298,0,0,0,0" + r,
                1,
                h + B + pf + r,
                1,
                h + b + " +towgs84=208,-435,-229,0,0,0,0" + r,
                1,
                h + b + " +towgs84=189,-79,-202,0,0,0,0" + r,
                1,
                h + B + Of + r,
                1,
                h + b + " +towgs84=403,-81,277,0,0,0,0" + r,
                1,
                h + b + " +towgs84=-307,-92,127,0,0,0,0" + r,
                1,
                h + b + Wv + r,
                1,
                h + b + " +towgs84=170,42,84,0,0,0,0" + r,
                2,
                h + " +a=6378270 +b=6356794.343434343 +towgs84=102,52,-38,0,0,0,0" + r,
                1,
                h + b + " +towgs84=276,-57,149,0,0,0,0" + r,
                1,
                h + b + " +towgs84=-632,438,-609,0,0,0,0" + r,
                1,
                h + b + " +towgs84=647,1777,-1124,0,0,0,0" + r,
                1,
                h + D + " +towgs84=260,12,-147,0,0,0,0" + r,
                1,
                h + i + n + r,
                1,
                h + Ai + Ei + r,
                1,
                h + b + " +towgs84=-156,-271,-189,0,0,0,0" + r,
                1,
                h + " +a=6378136 +b=6356751.361745712 +towgs84=0,0,1.5,-0,-0,0.076,0" + r,
                1,
                h + b + r,
                1,
                h + i + r,
                1,
                h + D + pi + r,
                1,
                h + D + r,
                1,
                h + M + r,
                1,
                h + M + r,
                1,
                h + i + n + r,
                1,
                h + Lb + VA + dp + r,
                1,
                h + i + n + r,
                1,
                h + j + Mm + r,
                1,
                h + ZA + _y + r,
                1,
                h + Lb + VA + dp + r,
                1,
                h + b + r,
                1,
                h + b + K + r,
                1,
                h + j + n + r,
                1,
                h + j + Ro + r,
                1,
                h + j + r,
                1,
                h + j + n + r,
                1,
                h + i + n + r,
                1,
                h + dS + r,
                1,
                h + i + n + r,
                1,
                h + j + n + r,
                1,
                h + j + n + r,
                1,
                h + i + n + r,
                1,
                h + i + n + r,
                1,
                o + p + Ds + " +k=1" + ou + m + d + a + r,
                1,
                o + p + os + " +k=1" + va + m + d + a + r,
                1,
                o + p + dh + " +k=1" + au + m + d + a + r,
                1,
                o + p + as + " +k=1" + Tu + m + d + a + r,
                1,
                o + p + bl + " +k=1" + Sh + m + d + a + r,
                1,
                o + p + ai + " +k=1" + Mh + m + d + a + r,
                1,
                o + p + ff + " +k=1" + kh + m + d + a + r,
                1,
                o + p + zo + " +k=1" + Nh + m + d + a + r,
                1,
                o + p + Eu + " +k=1" + Ch + m + d + a + r,
                1,
                o + p + Do + " +k=1" + Dh + m + d + a + r,
                1,
                o + p + Ul + " +k=1" + Oh + m + d + a + r,
                1,
                o + p + Io + " +k=1" + Th + m + d + a + r,
                1,
                o + p + xl + " +k=1" + ud + m + d + a + r,
                1,
                o + p + _i + " +k=1" + Fh + m + d + a + r,
                1,
                o + p + Au + " +k=1" + ld + m + d + a + r,
                1,
                o + p + Oo + " +k=1" + Ph + m + d + a + r,
                1,
                o + p + ns + " +k=1" + y + m + d + a + r,
                1,
                o + p + Mf + " +k=1" + y + m + d + a + r,
                1,
                o + p + is + " +k=1" + y + m + d + a + r,
                1,
                o + p + fp + " +k=1" + y + m + d + a + r,
                1,
                o + p + gs + " +k=1" + y + m + d + a + r,
                1,
                o + p + Ds + " +k=1" + y + m + d + a + r,
                1,
                o + p + os + " +k=1" + y + m + d + a + r,
                1,
                o + p + dh + " +k=1" + y + m + d + a + r,
                1,
                o + p + as + " +k=1" + y + m + d + a + r,
                1,
                o + p + bl + " +k=1" + y + m + d + a + r,
                1,
                o + p + ai + " +k=1" + y + m + d + a + r,
                1,
                o + p + ff + " +k=1" + y + m + d + a + r,
                1,
                o + p + zo + " +k=1" + y + m + d + a + r,
                1,
                o + p + Eu + " +k=1" + y + m + d + a + r,
                1,
                o + p + Do + " +k=1" + y + m + d + a + r,
                1,
                o + p + Ul + " +k=1" + y + m + d + a + r,
                1,
                o + p + Io + " +k=1" + y + m + d + a + r,
                1,
                o + p + xl + " +k=1" + y + m + d + a + r,
                1,
                o + p + _i + " +k=1" + y + m + d + a + r,
                1,
                h + M + wa + " +pm=bern" + r,
                1,
                h + b + fi + " +pm=bogota" + r,
                1,
                h + b + di + PE + r,
                1,
                h + M + ps + Yd + r,
                1,
                h + M + Zt + Sf + r,
                1,
                h + b + ar + " +pm=rome" + r,
                1,
                h + xt + fe + Pe + Nf + r,
                1,
                h + M + Yd + r,
                1,
                h + b + " +pm=brussels" + r,
                1,
                h + b + Wa + Nf + r,
                1,
                h + xt + fe + qu + Nf + r,
                1,
                o + p + Au + " +k=1" + y + m + d + a + r,
                0,
                o + p + Au + " +k=1" + y + m + d + a + r,
                1,
                h + M + Or + Yd + r,
                1,
                h + M + " +pm=stockholm" + r,
                1,
                h + M + " +pm=athens" + r,
                1,
                h + xt + fe + Ea + Nf + r,
                1,
                h + ks + ii + Mt + Pg + r,
                1,
                h + M + Aa + Sf + r,
                2,
                h + M + bs + Yd + r,
                1,
                h + xt + fe + Nf + r,
                1,
                o + p + Oo + " +k=1" + y + m + d + a + r,
                1,
                h + b + r,
                1,
                h + b + r,
                2,
                l + " +lat_1=15 +lat_2=16.66666666666667 +lat_0=15.83333333333333 +lon_0=-24 +x_0=161587.83 +y_0=128511.202" + x + a + r,
                13,
                l + Aw + Ew + kb + yA + $ + m + i + n + a + r,
                62,
                h + " +a=6376523" + Ay + bE + r,
                2,
                h + rS + wy + " +pm=madrid" + r,
                1,
                h + M + tm + PE + r,
                109,
                h + i + n + r,
                1,
                c + xp + i + n + a + r,
                1,
                c + bd + i + n + a + r,
                1,
                c + cl + i + n + a + r,
                2,
                o + _e + zb + " +k=1" + $ + m + b + di + a + r,
                23,
                pe + Os + ly + es + Jy + ke + Fr + x + a + r,
                1,
                pe + q + " +lat_ts=-90" + es + Jy + ke + Fr + x + a + r,
                6,
                c + yc + i + n + a + r,
                21,
                dn + Vg + Ss + uE + td + $ + m + S + a + r,
                1,
                dn + Vg + Ss + uE + td + $ + m + i + n + a + r,
                1,
                dn + Vg + Ss + uE + td + $ + m + i + n + a + r,
                1,
                dn + Vg + Ss + uE + td + $ + m + i + n + a + r,
                33,
                o + No + " +lon_0=5.5 +k=1" + ve + st + i + n + a + r,
                1,
                o + No + " +lon_0=6.5 +k=1" + ve + st + i + n + a + r,
                1,
                o + No + " +lon_0=7.5 +k=1" + ve + st + i + n + a + r,
                1,
                o + No + " +lon_0=8.5 +k=1" + ve + st + i + n + a + r,
                1,
                o + No + " +lon_0=9.5 +k=1" + ve + st + i + n + a + r,
                1,
                o + No + yA + " +k=1" + ve + st + i + n + a + r,
                1,
                o + No + " +lon_0=11.5 +k=1" + ve + st + i + n + a + r,
                1,
                o + No + " +lon_0=12.5 +k=1" + ve + st + i + n + a + r,
                1,
                o + No + " +lon_0=13.5 +k=1" + ve + st + i + n + a + r,
                1,
                o + No + " +lon_0=14.5 +k=1" + ve + st + i + n + a + r,
                1,
                o + No + " +lon_0=15.5 +k=1" + ve + st + i + n + a + r,
                1,
                o + No + pA + " +k=1" + ve + st + i + n + a + r,
                1,
                o + No + " +lon_0=17.5 +k=1" + ve + st + i + n + a + r,
                1,
                o + No + " +lon_0=18.5 +k=1" + ve + st + i + n + a + r,
                1,
                o + No + " +lon_0=19.5 +k=1" + ve + st + i + n + a + r,
                1,
                o + No + " +lon_0=20.5 +k=1" + ve + st + i + n + a + r,
                1,
                o + No + " +lon_0=21.5 +k=1" + ve + st + i + n + a + r,
                1,
                o + No + " +lon_0=22.5 +k=1" + ve + st + i + n + a + r,
                1,
                o + No + " +lon_0=23.5 +k=1" + ve + st + i + n + a + r,
                1,
                o + No + " +lon_0=24.5 +k=1" + ve + st + i + n + a + r,
                1,
                o + No + " +lon_0=25.5 +k=1" + ve + st + i + n + a + r,
                1,
                o + No + " +lon_0=26.5 +k=1" + ve + st + i + n + a + r,
                1,
                o + No + " +lon_0=27.5 +k=1" + ve + st + i + n + a + r,
                1,
                o + No + " +lon_0=28.5 +k=1" + ve + st + i + n + a + r,
                1,
                o + No + " +lon_0=29.5 +k=1" + ve + st + i + n + a + r,
                1,
                o + No + " +lon_0=30.5 +k=1" + ve + st + i + n + a + r,
                2,
                h + M + r,
                35,
                o + Cr + tp + " +k=1" + I + Dt + M + a + r,
                1,
                o + Cr + dg + " +k=1" + I + " +y_0=550000" + M + a + r,
                1,
                o + Cr + mg + " +k=1" + I + Dt + M + a + r,
                1,
                o + Cr + dg + " +k=1" + I + Dt + M + a + r,
                1,
                o + Cr + _i + " +k=1" + I + Dt + M + a + r,
                1,
                o + Cr + tp + " +k=1" + I + Dt + M + a + r,
                1,
                o + Cr + " +lon_0=125.0028902777778 +k=1" + I + Dt + M + a + r,
                1,
                o + Cr + Sw + " +k=1" + I + Dt + M + a + r,
                1,
                o + Cr + Sw + " +k=1" + I + " +y_0=550000" + M + a + r,
                1,
                o + Cr + " +lon_0=129.0028902777778 +k=1" + I + Dt + M + a + r,
                1,
                o + Cr + " +lon_0=131.0028902777778 +k=1" + I + Dt + M + a + r,
                1,
                o + Cr + um + mt + Ae + Fr + M + a + r,
                1,
                o + Cr + um + mt + Ae + Fr + i + n + a + r,
                1,
                o + Cr + mg + " +k=1" + I + Dt + i + n + a + r,
                1,
                o + Cr + dg + " +k=1" + I + Dt + i + n + a + r,
                1,
                o + Cr + dg + " +k=1" + I + " +y_0=550000" + i + n + a + r,
                1,
                o + Cr + _i + " +k=1" + I + Dt + i + n + a + r,
                1,
                o + Cr + tp + " +k=1" + I + Dt + i + n + a + r,
                1,
                o + Cr + mg + " +k=1" + I + cy + i + n + a + r,
                1,
                o + Cr + dg + " +k=1" + I + cy + i + n + a + r,
                1,
                o + Cr + _i + " +k=1" + I + cy + i + n + a + r,
                1,
                o + Cr + tp + " +k=1" + I + cy + i + n + a + r,
                33,
                cg + Lg + " +lon_0=42.5" + vc + A + $ + m + M + Aa + Sf + a + r,
                2,
                o + p + Vs + mt + y + Dt + x + a + r,
                5,
                h + M + Tf + r,
                1,
                h + M + Tf + Sf + r,
                4,
                h + Ze + Kt + pc + r,
                1,
                o + " +lat_0=7.000480277777778 +lon_0=80.77171111111112 +k=0.9999238418" + I + Ks + Ze + Kt + $v + a + r,
                1,
                o + " +lat_0=7.000471527777778 +lon_0=80.77171308333334 +k=0.9999238418" + y + Dt + Ze + Kt + pc + a + r,
                8,
                l + Aw + Ew + kb + yA + $ + m + i + n + a + r,
                3,
                h + i + r,
                1,
                yr + oy + aE + SS + am + $ + m + ql + gu + i + a + r,
                5,
                h + i + n + r,
                1,
                o + p + rs + " +k=1" + y + m + i + n + a + r,
                1,
                o + p + hu + " +k=1" + y + m + i + n + a + r,
                1,
                o + p + $s + " +k=1" + y + m + i + n + a + r,
                1,
                o + p + qd + " +k=1" + y + m + i + n + a + r,
                1,
                o + p + Vc + " +k=1" + y + m + i + n + a + r,
                1,
                o + p + Ud + " +k=1" + y + m + i + n + a + r,
                1,
                o + p + rl + " +k=1" + y + m + i + n + a + r,
                5,
                h + i + n + r,
                2,
                o + p + Ds + " +k=1" + We + m + i + n + a + r,
                3,
                o + p + rs + " +k=1" + Jf + m + i + n + a + r,
                1,
                o + p + hu + " +k=1" + of + m + i + n + a + r,
                1,
                o + p + $s + " +k=1" + Sl + m + i + n + a + r,
                1,
                o + p + qd + " +k=1" + af + m + i + n + a + r,
                1,
                o + p + Vc + " +k=1" + us + m + i + n + a + r,
                1,
                o + p + Ud + " +k=1" + Ra + m + i + n + a + r,
                1,
                o + p + rl + " +k=1" + Ps + m + i + n + a + r,
                17,
                o + p + " +lon_0=90.73333333333333 +k=1" + We + mn + i + n + a + r,
                1,
                o + p + " +lon_0=89.55 +k=1" + We + mn + i + n + a + r,
                1,
                o + p + Mw + " +k=1" + We + mn + i + n + a + r,
                1,
                o + p + " +lon_0=90.03333333333333 +k=1" + We + mn + i + n + a + r,
                1,
                o + p + " +lon_0=90.15000000000001 +k=1" + We + mn + i + n + a + r,
                1,
                o + p + " +lon_0=91.13333333333334 +k=1" + We + mn + i + n + a + r,
                1,
                o + p + " +lon_0=91.23333333333333 +k=1" + We + mn + i + n + a + r,
                1,
                o + p + " +lon_0=89.34999999999999 +k=1" + We + mn + i + n + a + r,
                1,
                o + p + " +lon_0=91.34999999999999 +k=1" + We + mn + i + n + a + r,
                1,
                o + p + Mw + " +k=1" + We + mn + i + n + a + r,
                1,
                o + p + kw + " +k=1" + We + mn + i + n + a + r,
                1,
                o + p + " +lon_0=89.06666666666666 +k=1" + We + mn + i + n + a + r,
                1,
                o + p + " +lon_0=90.26666666666667 +k=1" + We + mn + i + n + a + r,
                1,
                o + p + " +lon_0=89.55 +k=1" + We + mn + i + n + a + r,
                1,
                o + p + " +lon_0=91.75 +k=1" + We + mn + i + n + a + r,
                1,
                o + p + " +lon_0=90.5 +k=1" + We + mn + i + n + a + r,
                1,
                o + p + " +lon_0=90.16666666666667 +k=1" + We + mn + i + n + a + r,
                1,
                o + p + " +lon_0=90.11666666666666 +k=1" + We + mn + i + n + a + r,
                1,
                o + p + kw + " +k=1" + We + mn + i + n + a + r,
                1,
                o + p + " +lon_0=90.86666666666666 +k=1" + We + mn + i + n + a + r,
                5,
                o + p + " +lon_0=-7 +k=0.999997" + I + " +y_0=-6000000" + i + n + a + r,
                4,
                l + gA + " +lat_2=54.5" + p + Jh + Ae + m + i + n + a + r,
                1,
                l + gA + " +lat_2=54.5" + p + Jh + Ae + m + i + n + a + r,
                3,
                h + i + n + r,
                1,
                l + " +lat_1=64.25 +lat_2=65.75 +lat_0=65 +lon_0=-19" + Ol + Es + i + n + a + r,
                4,
                il + Cd + _E + cm + hy + M + bs + Yd + a + r,
                1,
                il + Cd + _E + cm + hy + M + Or + Yd + a + r,
                1,
                il + Cd + _E + cm + hy + M + ps + Yd + a + r,
                6,
                c + xp + z + b + wi + a + r,
                3,
                h + i + n + r,
                3,
                o + q + Fb + " +k=1" + wt + m + i + n + a + r,
                1,
                o + q + Zf + " +k=1" + Dr + m + i + n + a + r,
                1,
                o + q + nm + " +k=1" + Re + m + i + n + a + r,
                1,
                o + q + sy + " +k=1" + cn + m + i + n + a + r,
                1,
                o + q + Ib + " +k=1" + Si + m + i + n + a + r,
                1,
                o + q + IE + " +k=1" + Cl + m + i + n + a + r,
                1,
                o + q + ip + " +k=1" + Js + m + i + n + a + r,
                5,
                h + i + n + r,
                1,
                c + Ua + z + i + n + a + r,
                1,
                c + _s + z + i + n + a + r,
                1,
                c + Gs + z + i + n + a + r,
                3,
                h + i + n + r,
                1,
                c + _s + z + i + n + a + r,
                1,
                c + zs + z + i + n + a + r,
                3,
                h + j + n + r,
                2,
                o + p + Jh + A + y + m + j + n + a + r,
                4,
                h + i + n + r,
                2,
                h + i + n + r,
                8,
                h + j + n + r,
                1,
                c + Gs + z + j + n + a + r,
                1,
                c + Mu + z + j + n + a + r,
                4,
                c + zs + z + i + n + a + r,
                2,
                c + _s + z + i + n + a + r,
                4,
                h + i + n + r,
                3,
                c + bd + z + i + n + a + r,
                55,
                h + B + Le + r,
                5,
                l + " +lat_1=10.46666666666667 +lat_0=10.46666666666667 +lon_0=-84.33333333333333 +k_0=0.99995696" + y + " +y_0=271820.522" + B + Le + a + r,
                1,
                l + " +lat_1=9 +lat_0=9" + Gb + " +k_0=0.99995696" + y + " +y_0=327987.436" + B + Le + a + r,
                2,
                l + " +lat_1=14.9 +lat_0=14.9" + Ve + " +k_0=0.99989906" + y + " +y_0=325992.681" + B + Le + a + r,
                1,
                l + " +lat_1=13.78333333333333 +lat_0=13.78333333333333 +lon_0=-89 +k_0=0.99996704" + y + " +y_0=295809.184" + B + Le + a + r,
                1,
                l + " +lat_1=13.86666666666667 +lat_0=13.86666666666667" + ob + " +k_0=0.99990314" + y + " +y_0=359891.816" + B + Le + a + r,
                1,
                l + " +lat_1=11.73333333333333 +lat_0=11.73333333333333" + ob + " +k_0=0.9999222800000001" + y + " +y_0=288876.327" + B + Le + a + r,
                1,
                c + _u + X + jt + a + r,
                1,
                h + Ai + Ei + r,
                3,
                h + B + r,
                2,
                l + " +lat_1=8.416666666666666 +lat_0=8.416666666666666 +lon_0=-80 +k_0=0.99989909" + y + " +y_0=294865.303" + B + a + r,
                3,
                jb + " +lat_0=8.25" + pr + " +x_0=914391.7962 +y_0=999404.7217154861" + B + " +to_meter=0.9143917962" + r,
                7,
                l + Pt + It + " +lat_0=-78 +lon_0=163" + ab + Dl + i + n + a + r,
                1,
                l + " +lat_1=-73.66666666666667" + St + " +lat_0=-74.5" + rp + nf + Po + i + n + a + r,
                1,
                l + " +lat_1=-70.66666666666667 +lat_2=-72.33333333333333 +lat_0=-71.5" + CE + hS + st + i + n + a + r,
                1,
                pe + q + " +lat_ts=-90" + bg + Jy + nf + st + i + n + a + r,
                7,
                h + i + n + r,
                1,
                c + Ua + i + n + a + r,
                23,
                cg + Lg + Nw + vc + A + $ + m + M + Aa + a + r,
                1,
                cg + Lg + Nw + vc + A + $ + m + M + Aa + a + r,
                4,
                o + FE + ev + " +k=1" + fy + " +y_0=650000" + b + Rv + a + r,
                1,
                o + FE + ev + " +k=1" + fy + " +y_0=650000" + b + vp + a + r,
                1,
                o + p + vd + " +k=1" + wt + m + M + rt + a + r,
                3,
                o + p + " +lon_0=11.5" + mt + wt + oi + x + a + r,
                1,
                h + b + r,
                3,
                h + X + ue + r,
                3,
                jb + p + ip + nf + Bt + X + ue + a + r,
                1,
                c + Gs + z + X + ue + a + r,
                2,
                c + Pf + z + X + ue + a + r,
                1,
                c + Mp + z + X + ue + a + r,
                1,
                c + xp + z + X + ue + a + r,
                1,
                c + Gs + z + b + a + r,
                1,
                c + Mu + z + b + a + r,
                1,
                c + Pf + z + b + a + r,
                1,
                c + Mp + z + b + a + r,
                7,
                h + i + n + r,
                4,
                c + Ep + z + i + n + a + r,
                1,
                c + Ld + z + i + n + a + r,
                1,
                c + Qy + z + i + n + a + r,
                7,
                l + " +lat_1=16.81666666666667 +lat_0=16.81666666666667" + Ve + " +k_0=0.99992226" + y + " +y_0=292209.579" + B + Le + a + r,
                2,
                h + d + he + r,
                1,
                o + p + ka + " +k=1" + cn + m + d + he + a + r,
                1,
                o + p + rs + " +k=1" + Si + m + d + he + a + r,
                1,
                o + p + $s + " +k=1" + Cl + m + d + he + a + r,
                1,
                o + p + Vc + " +k=1" + Js + m + d + he + a + r,
                1,
                o + p + ka + " +k=1" + y + m + d + he + a + r,
                1,
                o + p + rs + " +k=1" + y + m + d + he + a + r,
                1,
                o + p + $s + " +k=1" + y + m + d + he + a + r,
                1,
                o + p + Vc + " +k=1" + y + m + d + he + a + r,
                19,
                ca + Nu + nS + qg + kt + " +y_0=304800" + S + V + r,
                1,
                o + " +lat_0=17.06124194444444 +lon_0=-88.6318575 +k=1 +x_0=66220.02833082761 +y_0=135779.5099885299" + Ai + Ei + Hf + r,
                4,
                h + i + n + r,
                3,
                o + p + " +lon_0=11.33333333333333 +k=1" + Ae + m + i + n + a + r,
                27,
                o + To + Gb + " +k=0.999942857" + T + m + S + f + r,
                1,
                o + To + gi + Ms + T + m + S + f + r,
                1,
                o + To + " +lon_0=-88.75" + Ms + T + m + S + f + r,
                2,
                o + p + wE + mt + y + m + b + U + a + r,
                2,
                c + ll + z + j + Ql + a + r,
                2,
                o + p + jl + " +k=1" + Dr + m + d + C + a + r,
                1,
                l + nE + Ym + Vd + kf + tf + Gy + i + n + a + r,
                1,
                vs + Vd + kf + Hy + Wy + i + n + a + r,
                1,
                l + nE + Ym + Vd + kf + tf + Gy + i + n + a + r,
                1,
                vs + Vd + kf + Hy + Wy + i + n + a + r,
                1,
                vs + Vd + kf + Hy + Wy + i + n + a + r,
                1,
                l + nE + Ym + Vd + kf + tf + Gy + i + n + a + r,
                1,
                vs + Vd + kf + Hy + Wy + i + n + a + r,
                1,
                l + nE + Ym + Vd + kf + tf + Gy + i + n + a + r,
                2,
                il + " +lon_0=-43 +lat_ts=-2" + nf + Bt + i + n + a + r,
                2,
                l + " +lat_1=52.66666666666666 +lat_2=54.33333333333334 +lat_0=48" + kf + " +x_0=815000" + m + b + U + a + r,
                1,
                c + Ku + z + i + n + a + r,
                2,
                o + Fo + rf + Ru + at + m + i + n + f + r,
                3,
                o + p + vd + mt + va + m + i + n + a + r,
                1,
                o + p + Sa + mt + Tu + m + i + n + a + r,
                1,
                o + p + vd + mt + va + m + i + n + a + r,
                1,
                o + p + jl + mt + au + m + i + n + a + r,
                1,
                o + p + Sa + mt + Tu + m + i + n + a + r,
                1,
                o + Fo + rf + Ru + at + m + i + n + f + r,
                1,
                o + Fo + rf + Ru + at + m + i + n + f + r,
                4,
                o + p + jl + mt + " +x_0=500053 +y_0=-3999820" + b + ar + a + r,
                4,
                o + p + Sa + " +k=1" + Re + m + d + C + a + r,
                1,
                o + p + jl + " +k=1" + Dr + m + d + Gt + a + r,
                1,
                o + p + Sa + " +k=1" + Re + m + d + Gt + a + r,
                1,
                o + p + jl + " +k=1" + Re + m + M + a + r,
                1,
                o + p + Vs + " +k=1" + cn + m + M + a + r,
                1,
                o + p + Vs + " +k=1" + cn + m + M + a + r,
                1,
                o + p + Sa + " +k=1" + Si + m + M + a + r,
                1,
                o + p + jl + " +k=1" + Re + m + d + C + a + r,
                1,
                o + p + Vs + " +k=1" + cn + m + d + C + a + r,
                1,
                o + p + Sa + " +k=1" + Si + m + d + C + a + r,
                1,
                o + p + jl + " +k=1" + Re + m + d + Gt + a + r,
                1,
                o + p + Vs + " +k=1" + cn + m + d + Gt + a + r,
                1,
                o + p + Sa + " +k=1" + Si + m + d + Gt + a + r,
                1,
                o + p + wE + " +k=1" + Dr + m + M + rt + a + r,
                1,
                o + p + jl + " +k=1" + Re + m + M + rt + a + r,
                1,
                o + p + Vs + " +k=1" + cn + m + M + rt + a + r,
                1,
                o + p + Sa + " +k=1" + Si + m + M + rt + a + r,
                1,
                o + p + vd + " +k=1" + wt + m + M + rt + a + r,
                1,
                h + M + r,
                1,
                o + p + wE + " +k=1" + Dr + m + M + a + r,
                1,
                o + p + jl + " +k=1" + Re + m + M + a + r,
                1,
                o + p + Vs + " +k=1" + cn + m + M + a + r,
                1,
                o + p + Sa + " +k=1" + Si + m + M + a + r,
                15,
                c + Og + z + i + n + a + r,
                125,
                o + " +lat_0=-35.31773627777778 +lon_0=149.0092948305555 +k=1.000086" + I + cy + X + W + a + r,
                11,
                c + Ll + j + n + a + r,
                1,
                c + lh + j + n + a + r,
                2,
                c + _u + z + i + n + a + r,
                3,
                o + p + Vs + mt + y + Bt + x + a + r,
                2,
                o + p + hu + A + y + Bt + i + n + a + r,
                14,
                c + Mu + z + X + ue + a + r,
                17,
                c + zs + z + X + ue + a + r,
                1,
                c + _s + z + X + ue + a + r,
                1,
                c + Ua + z + X + ue + a + r,
                2,
                c + ll + z + b + Bd + a + r,
                1,
                jb + p + ip + nf + Bt + i + n + a + r,
                6,
                h + i + r,
                1,
                o + p + Gl + mt + wt + Dl + i + a + r,
                3,
                pe + Os + " +lat_ts=70" + Ds + " +k=1" + $ + m + TE + ng + a + r,
                31,
                l + lE + Ys + bu + $l + $ + m + x + a + r,
                1,
                l + lE + Ys + bu + Bb + $ + m + x + a + r,
                1,
                l + lE + Ys + bu + $s + $ + m + x + a + r,
                1,
                l + lE + Ys + bu + ai + $ + m + x + a + r,
                1,
                l + lE + Ys + bu + zl + $ + m + x + a + r,
                1,
                l + du + cE + xu + $l + $ + m + x + a + r,
                1,
                l + du + cE + xu + Bb + $ + m + x + a + r,
                1,
                l + du + cE + xu + $s + $ + m + x + a + r,
                1,
                l + du + cE + xu + ai + $ + m + x + a + r,
                1,
                l + du + cE + xu + zl + $ + m + x + a + r,
                1,
                l + fE + hE + wu + $l + $ + m + x + a + r,
                1,
                l + fE + hE + wu + Bb + $ + m + x + a + r,
                1,
                l + fE + hE + wu + $s + $ + m + x + a + r,
                1,
                l + fE + hE + wu + ai + $ + m + x + a + r,
                1,
                l + fE + hE + wu + zl + $ + m + x + a + r,
                1,
                pe + Os + ly + zp + Jy + ke + Fr + x + a + r,
                1,
                pe + Os + ly + dr + Jy + ke + Fr + x + a + r,
                1,
                pe + Os + ly + " +lon_0=-33" + Jy + ke + Fr + x + a + r,
                1,
                pe + Os + ly + zm + Jy + ke + Fr + x + a + r,
                1,
                pe + Os + ly + ai + Jy + ke + Fr + x + a + r,
                110,
                l + Nb + ds + ms + " +lon_0=-30" + Rs + fn + i + n + a + r,
                1,
                l + Mr + kr + Nr + " +lon_0=-52" + Ts + Wu + i + n + a + r,
                1,
                l + Mr + kr + Nr + " +lon_0=-12" + ls + Wu + i + n + a + r,
                1,
                l + Ce + Ys + De + Zf + La + Qs + i + n + a + r,
                1,
                l + Ce + Ys + De + Bb + va + Qs + i + n + a + r,
                1,
                l + Ce + Ys + De + " +lon_0=-10" + Tu + Qs + i + n + a + r,
                1,
                l + du + le + ce + " +lon_0=-64" + ls + ga + i + n + a + r,
                1,
                l + du + le + ce + Bb + cs + ga + i + n + a + r,
                1,
                l + du + le + ce + " +lon_0=-14" + sf + ga + i + n + a + r,
                1,
                l + gt + vt + bt + Xh + Th + oi + i + n + a + r,
                1,
                l + gt + vt + bt + " +lon_0=-42" + Fh + oi + i + n + a + r,
                1,
                l + gt + vt + bt + " +lon_0=-22" + Ph + oi + i + n + a + r,
                1,
                l + ir + Qp + or + BE + Ls + $u + i + n + a + r,
                1,
                l + ir + Qp + or + " +lon_0=-38" + Us + $u + i + n + a + r,
                1,
                l + ir + Qp + or + " +lon_0=-20" + ou + $u + i + n + a + r,
                1,
                l + " +lat_1=67" + Cw + Dw + " +lon_0=-51" + Sl + lS + i + n + a + r,
                1,
                l + " +lat_1=67" + Cw + Dw + " +lon_0=-34" + us + lS + i + n + a + r,
                1,
                l + Ow + Tw + Fw + " +lon_0=-52" + ls + " +y_0=8500000" + i + n + a + r,
                1,
                l + Ow + Tw + Fw + " +lon_0=-37" + cs + " +y_0=8500000" + i + n + a + r,
                1,
                l + Mr + kr + Nr + " +lon_0=16" + cs + Wu + i + n + a + r,
                1,
                l + Ce + Ys + De + ka + Sl + Qs + i + n + a + r,
                1,
                l + du + le + ce + kf + Ls + ga + i + n + a + r,
                1,
                l + du + le + ce + pE + Us + ga + i + n + a + r,
                1,
                l + gt + vt + bt + " +lon_0=14" + Sl + oi + i + n + a + r,
                1,
                l + gt + vt + bt + pE + us + oi + i + n + a + r,
                1,
                l + Mr + kr + Nr + " +lon_0=53" + sf + Wu + x + a + r,
                1,
                l + Mr + kr + Nr + os + Ls + Wu + x + a + r,
                1,
                l + Ce + Ys + De + " +lon_0=52" + us + Qs + x + a + r,
                1,
                l + Ce + Ys + De + " +lon_0=83" + Ps + Qs + x + a + r,
                1,
                l + Ce + Ys + De + Eu + Ou + Qs + x + a + r,
                1,
                l + Ce + Ys + De + " +lon_0=145" + Fs + Qs + x + a + r,
                1,
                l + du + le + ce + " +lon_0=58" + ou + ga + x + a + r,
                1,
                l + du + le + ce + " +lon_0=82" + au + ga + x + a + r,
                1,
                l + du + le + ce + AE + Sh + ga + x + a + r,
                1,
                l + du + le + ce + " +lon_0=130" + kh + ga + x + a + r,
                1,
                l + du + le + ce + EE + Ch + ga + x + a + r,
                1,
                l + du + le + ce + " +lon_0=179" + Oh + ga + x + a + r,
                1,
                l + gt + vt + bt + Rg + Ps + oi + x + a + r,
                1,
                l + gt + vt + bt + " +lon_0=74" + Ou + oi + x + a + r,
                1,
                l + gt + vt + bt + " +lon_0=95" + Fs + oi + x + a + r,
                1,
                l + gt + vt + bt + " +lon_0=116" + Bs + oi + x + a + r,
                1,
                l + gt + vt + bt + " +lon_0=137" + js + oi + x + a + r,
                1,
                l + gt + vt + bt + " +lon_0=158" + Rs + oi + x + a + r,
                1,
                l + gt + vt + bt + " +lon_0=179" + qs + oi + x + a + r,
                1,
                l + gt + vt + bt + " +lon_0=-163" + La + oi + i + n + a + r,
                1,
                l + gt + vt + bt + dy + va + oi + i + n + a + r,
                1,
                l + ir + Qp + or + Hg + Ra + $u + i + n + a + r,
                1,
                l + ir + Qp + or + dy + Is + $u + i + n + a + r,
                1,
                l + Nb + ds + ms + He + js + fn + i + n + a + r,
                1,
                l + Mr + kr + Nr + $g + Ra + Wu + i + n + a + r,
                1,
                l + Mr + kr + Nr + Pb + Is + Wu + i + n + a + r,
                1,
                l + Ce + Ys + De + NA + Rs + Qs + i + n + a + r,
                1,
                l + Ce + Ys + De + vl + qs + Qs + i + n + a + r,
                1,
                l + Ce + Ys + De + Zf + La + Qs + i + n + a + r,
                1,
                l + du + le + ce + NA + Ra + ga + i + n + a + r,
                1,
                l + du + le + ce + " +lon_0=-104" + Is + ga + i + n + a + r,
                1,
                l + du + le + ce + Qh + Ts + ga + i + n + a + r,
                1,
                l + gt + vt + bt + " +lon_0=-131" + Tu + oi + i + n + a + r,
                1,
                l + gt + vt + bt + $l + Mh + oi + i + n + a + r,
                1,
                l + gt + vt + bt + " +lon_0=-91" + Nh + oi + i + n + a + r,
                1,
                l + gt + vt + bt + " +lon_0=-71" + Dh + oi + i + n + a + r,
                1,
                l + ir + Qp + or + " +lon_0=-132" + Ts + $u + i + n + a + r,
                1,
                l + ir + Qp + or + " +lon_0=-113" + ls + $u + i + n + a + r,
                1,
                l + ir + Qp + or + np + cs + $u + i + n + a + r,
                1,
                l + ir + Qp + or + Pb + sf + $u + i + n + a + r,
                1,
                l + Nb + ds + ms + hu + qs + fn + x + a + r,
                1,
                l + Nb + ds + ms + Ds + La + fn + x + a + r,
                1,
                l + Nb + ds + ms + od + va + fn + x + a + r,
                1,
                l + Nb + ds + ms + zp + Bs + fn + x + a + r,
                1,
                l + Mr + kr + Nr + " +lon_0=133" + Us + Wu + x + a + r,
                1,
                l + Mr + kr + Nr + CE + of + Wu + x + a + r,
                1,
                l + Mr + kr + Nr + Ah + af + Wu + x + a + r,
                1,
                l + Ce + Ys + De + " +lon_0=176" + Bs + Qs + x + a + r,
                1,
                l + Ce + Ys + De + vA + js + Qs + x + a + r,
                1,
                l + du + le + ce + " +lon_0=-155" + af + ga + x + a + r,
                1,
                l + gt + vt + bt + " +lon_0=-5" + gE + oi + i + n + a + r,
                3,
                c + _u + B + pf + V + r,
                1,
                c + _u + B + Of + V + r,
                6,
                h + i + n + r,
                69,
                o + p + ka + A + y + m + M + Zt + a + r,
                3,
                h + Ze + Kt + " +towgs84=293.17,726.18,245.36,0,0,0,0" + r,
                3,
                c + Pf + i + n + a + r,
                1,
                c + Mp + i + n + a + r,
                96,
                l + ha + pa + da + Ho + I + Ks + i + a + r,
                4,
                h + j + fc + r,
                1,
                o + p + $s + fr + I + " +y_0=-3500000" + j + fc + a + r,
                4,
                o + p + ka + A + Js + m + M + Zt + a + r,
                2,
                h + i + r,
                4,
                h + i + r,
                3,
                h + i + r,
                3,
                c + bp + i + a + r,
                1,
                c + Rd + i + a + r,
                1,
                c + Og + i + a + r,
                1,
                c + qv + i + a + r,
                1,
                c + uA + i + a + r,
                1,
                c + Gv + i + a + r,
                1,
                c + Cy + i + a + r,
                1,
                c + lg + i + a + r,
                1,
                c + Dy + i + a + r,
                1,
                c + Uv + i + a + r,
                1,
                c + zv + i + a + r,
                1,
                c + Cm + i + a + r,
                1,
                c + wp + i + a + r,
                1,
                c + _p + i + a + r,
                1,
                c + Ap + i + a + r,
                1,
                c + Sp + i + a + r,
                1,
                c + $h + i + a + r,
                1,
                c + Vh + i + a + r,
                1,
                c + _u + i + a + r,
                1,
                c + zs + i + a + r,
                1,
                c + _s + i + a + r,
                2,
                dn + Vg + Ss + uE + td + $ + m + i + a + r,
                1,
                l + gt + vt + bt + " +lon_0=-163" + La + oi + i + a + r,
                1,
                l + gt + vt + bt + dy + va + oi + i + a + r,
                1,
                l + ir + Qp + or + Hg + Ra + $u + i + a + r,
                1,
                l + ir + Qp + or + dy + Is + $u + i + a + r,
                1,
                o + cu + su + em + I + m + i + a + r,
                1,
                o + Na + Vp + ie + N + m + i + a + r,
                6,
                l + " +lat_1=17.5 +lat_2=29.5 +lat_0=12 +lon_0=-102" + Dr + m + i + n + a + r,
                3,
                h + i + n + r,
                1,
                c + wp + i + n + a + r,
                1,
                c + _p + i + n + a + r,
                1,
                c + Ap + i + n + a + r,
                1,
                c + Sp + i + n + a + r,
                1,
                c + $h + i + n + a + r,
                1,
                c + Vh + i + n + a + r,
                1,
                l + " +lat_1=17.5 +lat_2=29.5 +lat_0=12 +lon_0=-102" + Dr + m + i + n + a + r,
                9,
                o + p + ka + " +k=1" + ut + m + d + Je + a + r,
                1,
                o + p + Zs + " +k=1" + ut + m + d + Je + a + r,
                1,
                o + p + rs + " +k=1" + ut + m + d + Je + a + r,
                1,
                o + p + hu + " +k=1" + ut + m + d + Je + a + r,
                1,
                o + p + $s + " +k=1" + ut + m + d + Je + a + r,
                1,
                o + p + qd + " +k=1" + ut + m + d + Je + a + r,
                1,
                o + p + Vc + " +k=1" + ut + m + d + Je + a + r,
                4,
                l + " +lat_1=19.33333333333333 +lat_2=19.7 +lat_0=19.33333333333333 +lon_0=-80.56666666666666 +x_0=899160 +y_0=579120" + i + n + V + r,
                2,
                dn + " +lat_1=55" + Ym + eE + Ah + $ + m + i + a + r,
                1,
                yr + " +lat_0=57" + Nc + Cc + A + nf + si + ql + ma + i + a + r,
                1,
                o + jo + _A + A + y + m + i + a + r,
                1,
                o + jo + AA + A + y + m + i + a + r,
                1,
                o + jo + zp + A + y + m + i + a + r,
                1,
                o + jo + Ah + A + y + m + i + a + r,
                1,
                o + jo + Hl + A + y + m + i + a + r,
                1,
                o + jo + EA + A + y + m + i + a + r,
                1,
                o + jo + SA + A + y + m + i + a + r,
                1,
                o + jo + Gg + A + y + m + i + a + r,
                1,
                l + Dc + Oc + kb + MA + Ae + m + i + a + r,
                1,
                o + Ie + Br + A + yi + m + i + a + r,
                1,
                o + Ie + Br + A + yi + m + i + V + r,
                1,
                o + Ie + Ir + A + yi + m + i + a + r,
                1,
                o + Ie + Ir + A + yi + m + i + V + r,
                1,
                o + Ie + Fu + ie + yi + m + i + a + r,
                1,
                o + Ie + Fu + ie + yi + m + i + V + r,
                1,
                l + Hn + Wn + te + Ws + Z + m + i + a + r,
                1,
                l + Hn + Wn + te + Ws + $t + m + i + f + r,
                1,
                l + $n + wh + Vn + Ws + Z + Du + i + a + r,
                1,
                l + $n + wh + Vn + Ws + $t + Ia + i + f + r,
                1,
                dn + oE + Wg + p + Eh + $ + Km + i + a + r,
                1,
                l + gn + Al + J + za + ke + Dt + i + a + r,
                1,
                l + gn + Al + J + za + Nt + nt + i + f + r,
                1,
                l + vn + bn + tt + za + ke + Dt + i + a + r,
                1,
                l + vn + bn + tt + za + Nt + nt + i + f + r,
                1,
                l + Ut + xn + yh + lt + ke + Dt + i + a + r,
                1,
                l + Ut + xn + yh + lt + Nt + nt + i + f + r,
                1,
                l + Zc + Gm + wn + gh + ke + Dt + i + a + r,
                1,
                l + Zc + Gm + wn + gh + Nt + nt + i + f + r,
                1,
                l + _n + An + vh + Cu + ke + Dt + i + a + r,
                1,
                l + _n + An + vh + Cu + Nt + nt + i + f + r,
                1,
                l + En + Sn + Mn + Pu + ke + Dt + i + a + r,
                1,
                l + En + Sn + Mn + Pu + Nt + nt + i + f + r,
                1,
                l + Yc + Kc + xr + Ee + qo + Uo + i + a + r,
                1,
                l + Yc + Kc + xr + Ee + $e + sr + i + f + r,
                1,
                l + Mi + ki + J + Ee + qo + Uo + i + a + r,
                1,
                l + Mi + ki + J + Ee + $e + sr + i + f + r,
                1,
                l + Ut + kn + F + Ee + qo + Uo + i + a + r,
                1,
                l + Ut + kn + F + Ee + $e + sr + i + f + r,
                1,
                l + Nn + bh + Cn + Ml + Om + Tm + i + a + r,
                1,
                l + Nn + bh + Cn + Ml + If + Bf + i + f + r,
                1,
                o + Cr + jr + xh + I + m + i + a + r,
                1,
                o + Cr + jr + xh + it + m + i + f + r,
                1,
                o + zt + pr + Rt + I + m + i + a + r,
                1,
                o + zt + pr + Rt + it + m + i + f + r,
                1,
                dn + " +lat_1=24" + mA + " +lat_0=24" + Jh + Z + m + i + a + r,
                1,
                l + Xc + Dn + Hm + Jc + N + m + i + a + r,
                1,
                l + Xc + Dn + Hm + Jc + N + m + i + f + r,
                1,
                o + zt + rd + Rt + I + m + i + a + r,
                1,
                o + zt + rd + Rt + it + m + i + f + r,
                1,
                o + Na + Rr + A + I + m + i + a + r,
                1,
                o + Na + Rr + A + it + m + i + f + r,
                1,
                o + Na + Lr + A + mi + m + i + a + r,
                1,
                o + Na + Lr + A + ur + m + i + f + r,
                1,
                o + G + fl + se + y + m + i + a + r,
                1,
                o + G + fl + se + ot + m + i + f + r,
                1,
                o + G + qr + se + I + m + i + a + r,
                1,
                o + G + qr + se + it + m + i + f + r,
                1,
                o + G + Iu + ie + br + m + i + a + r,
                1,
                o + G + Iu + ie + jf + m + i + f + r,
                1,
                o + F + Vr + li + ut + m + i + a + r,
                1,
                o + F + Vr + li + ut + m + i + f + r,
                1,
                o + F + Zr + Rt + mi + m + i + a + r,
                1,
                o + F + Zr + Rt + Vf + m + i + f + r,
                1,
                o + sn + Yr + dt + ve + Wl + i + a + r,
                1,
                o + sn + Yr + dt + Wf + Jo + i + f + r,
                1,
                o + sn + Kr + dt + ss + Wl + i + a + r,
                1,
                o + sn + Kr + dt + ss + Jo + i + f + r,
                1,
                l + Zn + Yn + To + Ko + wt + st + i + a + r,
                1,
                l + Zn + Yn + To + Ko + wt + Qo + i + f + r,
                1,
                l + Et + Kn + Bo + Ko + y + m + i + a + r,
                1,
                l + Et + Kn + Bo + Ko + at + m + i + f + r,
                1,
                l + Xn + Jn + yt + Co + Z + m + i + a + r,
                1,
                l + Xn + Jn + yt + Co + $t + m + i + f + r,
                1,
                l + Qn + ti + F + gr + Z + Du + i + a + r,
                1,
                l + Qn + ti + F + gr + $t + Ia + i + f + r,
                1,
                l + Xt + yn + sn + El + y + m + i + a + r,
                1,
                l + Xt + yn + sn + El + ot + m + i + f + r,
                1,
                l + Mo + ko + et + gi + wt + st + i + a + r,
                1,
                l + Mo + ko + et + gi + wt + lr + i + f + r,
                1,
                l + Ni + Ci + et + gi + y + Dt + i + a + r,
                1,
                l + Ni + Ci + et + gi + ot + nt + i + f + r,
                1,
                l + lo + co + cu + xs + Ae + m + i + a + r,
                1,
                l + lo + co + cu + xs + xi + m + i + f + r,
                1,
                l + Bp + jp + Rp + Te + Ae + m + i + a + r,
                1,
                l + Bp + jp + Rp + Te + xi + m + i + f + r,
                1,
                o + wA + ig + zu + y + m + i + a + r,
                1,
                o + ft + tg + zu + mi + m + i + a + r,
                1,
                o + ee + eg + zu + ut + m + i + a + r,
                1,
                o + ct + Xa + A + ut + m + i + a + r,
                1,
                o + ct + Xa + A + ut + m + i + f + r,
                1,
                o + ee + Xr + dt + ss + m + i + a + r,
                1,
                o + ee + Xr + dt + ss + m + i + f + r,
                1,
                l + Qf + Np + tt + cf + Z + m + i + a + r,
                1,
                l + Qf + Np + tt + cf + Rf + m + i + f + r,
                1,
                l + Oi + Ti + ku + Xs + y + m + i + a + r,
                1,
                l + Oi + Ti + ku + Xs + ot + m + i + f + r,
                1,
                l + Di + On + ku + Zo + I + mh + i + a + r,
                1,
                l + Di + On + ku + Zo + it + mh + i + f + r,
                1,
                l + Cp + Bi + ji + re + lm + m + i + a + r,
                1,
                l + Cp + Bi + ji + re + qf + m + i + V + r,
                1,
                l + Fi + Pi + Ii + gl + rb + m + i + a + r,
                1,
                l + Fi + Pi + Ii + gl + Lf + m + i + V + r,
                1,
                yr + Sc + " +lonc=-86" + Fm + mt + Pm + Xd + ql + Im + i + a + r,
                1,
                l + qe + Dp + To + re + tf + m + i + a + r,
                1,
                l + qe + Dp + To + re + Zp + m + i + V + r,
                1,
                l + oh + po + eu + Nl + br + ni + i + a + r,
                1,
                l + oh + po + eu + Nl + Lt + qt + i + f + r,
                1,
                l + fo + ho + Nu + Jr + br + ni + i + a + r,
                1,
                l + fo + ho + Nu + Jr + Lt + qt + i + f + r,
                1,
                l + mo + yo + hp + np + br + ni + i + a + r,
                1,
                l + mo + yo + hp + np + Lt + qt + i + f + r,
                1,
                o + As + Ur + fr + ut + m + i + a + r,
                1,
                o + As + Ur + fr + ut + m + i + f + r,
                1,
                o + mf + rv + ib + y + fm + i + a + r,
                1,
                o + As + Ve + fr + mi + m + i + a + r,
                1,
                o + As + Ve + fr + ur + m + i + f + r,
                1,
                o + Sr + xs + ie + y + m + i + a + r,
                1,
                o + Sr + Uy + ie + We + m + i + a + r,
                1,
                o + mu + zy + Rt + fA + m + i + a + r,
                1,
                l + $c + Fy + th + iu + N + m + i + a + r,
                1,
                l + $c + Fy + th + iu + hn + m + i + V + r,
                1,
                l + nl + Al + go + dr + y + m + i + a + r,
                2,
                o + hr + tn + A + y + ws + i + a + r,
                1,
                o + hr + tn + A + at + ws + i + f + r,
                1,
                o + hr + Qr + A + I + nb + i + a + r,
                1,
                o + hr + Qr + A + Ba + $f + i + f + r,
                1,
                o + hr + en + A + br + ef + i + a + r,
                1,
                o + hr + en + A + Lt + Ih + i + f + r,
                1,
                o + Fo + rn + dt + ut + m + i + a + r,
                1,
                o + Fo + rn + dt + ut + m + i + f + r,
                1,
                o + Jt + Oa + A + je + m + i + a + r,
                1,
                o + Jt + Oa + A + je + m + i + f + r,
                1,
                o + Ie + Bu + A + y + m + i + a + r,
                1,
                o + Ie + Bu + A + ot + m + i + f + r,
                1,
                o + Ie + zr + Ms + Op + m + i + a + r,
                1,
                o + Ie + zr + Ms + Op + m + i + f + r,
                1,
                o + Ie + Gr + ju + hA + m + i + a + r,
                1,
                o + Ie + Gr + ju + Uf + m + i + f + r,
                1,
                o + Bo + Hr + Ct + We + m + i + a + r,
                1,
                o + Bo + Hr + Ct + zf + m + i + f + r,
                1,
                o + Jt + Oa + A + je + m + i + a + r,
                1,
                o + Jt + Oa + A + je + m + i + f + r,
                1,
                l + Tn + Fn + Qt + nd + ut + m + i + a + r,
                1,
                l + Tn + Fn + Qt + nd + ut + m + i + f + r,
                1,
                o + Bo + Wr + Ct + fy + m + i + a + r,
                1,
                o + Bo + Wr + Ct + Gf + m + i + f + r,
                1,
                l + Ri + Li + Qc + Qh + rg + m + i + a + r,
                1,
                l + Ri + Li + Qc + Qh + k + m + i + f + r,
                1,
                l + oe + qi + pu + vi + N + m + i + a + r,
                1,
                l + oe + qi + pu + vi + hn + m + i + V + r,
                1,
                l + Ui + zi + Ne + vi + N + m + i + a + r,
                1,
                l + Ui + zi + Ne + vi + hn + m + i + V + r,
                1,
                l + Lp + vo + _e + hi + N + m + i + a + r,
                1,
                l + Lp + vo + _e + hi + N + m + i + f + r,
                1,
                l + bo + xo + Cr + hi + N + m + i + a + r,
                1,
                l + bo + xo + Cr + hi + N + m + i + f + r,
                1,
                l + Pn + Gi + Wm + Co + N + m + i + a + r,
                1,
                l + Pn + Gi + Wm + Co + N + m + i + f + r,
                1,
                l + Hi + Wi + In + Co + N + m + i + a + r,
                1,
                l + Hi + Wi + In + Co + N + m + i + f + r,
                1,
                l + nl + Ss + Xo + lt + Z + m + i + a + r,
                1,
                l + nl + Ss + Xo + lt + lf + m + i + V + r,
                1,
                l + zd + wr + ct + lt + Dr + m + i + a + r,
                1,
                l + zd + wr + ct + lt + Vl + m + i + V + r,
                1,
                l + Gd + _r + G + lt + wt + m + i + a + r,
                1,
                l + Gd + _r + G + lt + Zl + m + i + V + r,
                1,
                l + eh + $i + Qt + bi + N + m + i + a + r,
                1,
                l + eh + $i + Qt + bi + N + m + i + f + r,
                1,
                l + Bn + jn + J + bi + N + m + i + a + r,
                1,
                l + Bn + jn + J + bi + N + m + i + f + r,
                1,
                l + ha + pa + da + Ho + I + Ks + i + a + r,
                1,
                o + ei + Zo + uf + ve + m + i + a + r,
                1,
                o + ei + Zo + uf + ol + m + i + f + r,
                1,
                l + Vi + Tp + Rn + pr + Fp + m + i + a + r,
                1,
                l + Vi + Tp + Rn + pr + Fp + m + i + V + r,
                1,
                l + wo + _o + ft + dr + N + m + i + a + r,
                1,
                l + wo + _o + ft + dr + N + m + i + f + r,
                1,
                l + qp + Ao + ri + Tt + N + m + i + a + r,
                1,
                l + qp + Ao + ri + Tt + N + m + i + f + r,
                1,
                l + Zi + rh + te + Yf + N + m + i + a + r,
                1,
                l + Zi + rh + te + Yf + N + m + i + f + r,
                1,
                l + Ji + Qi + Ar + Tt + mi + Po + i + a + r,
                1,
                l + Ji + Qi + Ar + Tt + ur + Po + i + f + r,
                1,
                dn + Up + jy + Jp + dr + wt + ws + i + a + r,
                1,
                l + Up + jy + Jp + dr + wt + Dl + i + a + r,
                1,
                l + Yi + nh + $m + kl + I + st + i + a + r,
                1,
                l + Yi + nh + $m + kl + it + lr + i + f + r,
                1,
                l + Ki + Xi + Ln + gr + N + Fr + i + a + r,
                1,
                l + Ki + Xi + Ln + gr + N + Fa + i + f + r,
                1,
                l + Qe + tr + Er + gr + ut + Dl + i + a + r,
                1,
                l + Qe + tr + Er + gr + ut + up + i + f + r,
                1,
                l + to + eo + qn + vl + N + ef + i + a + r,
                1,
                l + to + eo + qn + vl + N + sp + i + f + r,
                1,
                o + Fo + rf + Ru + y + m + i + a + r,
                1,
                o + Fo + rf + Ru + at + m + i + f + r,
                1,
                l + " +lat_1=37" + kA + ra + ya + $ + m + i + a + r,
                1,
                l + Pp + ro + tt + Yo + Re + Fr + i + a + r,
                1,
                l + Pp + ro + tt + Yo + Pa + Fa + i + f + r,
                1,
                l + Xt + Un + et + Yo + Re + st + i + a + r,
                1,
                l + Xt + Un + et + Yo + Pa + lr + i + f + r,
                1,
                l + oe + Ip + pu + $r + y + m + i + a + r,
                1,
                l + oe + Ip + pu + $r + ot + m + i + f + r,
                1,
                l + no + io + zn + lt + y + m + i + a + r,
                1,
                l + no + io + zn + lt + ot + m + i + f + r,
                1,
                l + ah + By + _h + ya + N + m + i + a + r,
                1,
                l + ah + By + _h + ya + N + m + i + f + r,
                1,
                l + Eo + So + Zm + pr + N + m + i + a + r,
                1,
                l + Eo + So + Zm + pr + N + m + i + f + r,
                2,
                l + hl + ih + ft + He + N + m + i + f + r,
                1,
                l + oo + ao + Gn + He + N + m + i + a + r,
                1,
                l + oo + ao + Gn + He + N + m + i + f + r,
                1,
                l + so + uo + Hd + He + N + m + i + a + r,
                1,
                l + so + uo + Hd + He + N + m + i + f + r,
                1,
                o + p + He + mt + dA + tv + i + a + r,
                1,
                o + Ke + nn + Ct + I + m + i + a + r,
                1,
                o + Ke + nn + Ct + Ba + m + i + f + r,
                1,
                o + Ke + on + Ct + Z + ni + i + a + r,
                1,
                o + Ke + on + Ct + $t + qt + i + f + r,
                1,
                o + Ke + an + Ct + br + ni + i + a + r,
                1,
                o + Ke + an + Ct + Lt + qt + i + f + r,
                1,
                o + Ke + Lu + Ct + N + m + i + a + r,
                1,
                o + Ke + Lu + Ct + N + m + i + f + r,
                1,
                l + Gu + rr + yt + ae + y + Fr + i + a + r,
                1,
                l + Et + er + Ue + ae + y + st + i + a + r,
                1,
                l + Hu + nr + F + ae + y + Po + i + a + r,
                1,
                l + _b + cp + fu + Xa + $ + m + i + n + a + r,
                1,
                dn + _b + cp + fu + Xa + $ + m + i + n + a + r,
                1,
                dn + _b + cp + fu + Xa + $ + m + i + n + a + r,
                1,
                l + Gu + rr + yt + ae + at + Bh + i + f + r,
                1,
                l + Et + er + Ue + ae + at + Qo + i + f + r,
                1,
                l + Hu + nr + F + ae + at + Po + i + f + r,
                1,
                o + wc + Jg + dt + y + m + i + a + r,
                1,
                o + _c + Kl + dt + y + m + i + a + r,
                1,
                o + fa + Hl + wl + y + m + i + a + r,
                1,
                o + Ac + Qg + wl + y + m + i + a + r,
                1,
                o + Ec + Xl + " +k=1" + y + m + i + a + r,
                1,
                o + fa + Hl + wl + at + m + i + f + r,
                1,
                c + Gv + i + a + r,
                1,
                c + Cy + i + a + r,
                1,
                c + qv + z + i + a + r,
                1,
                o + " +lat_0=13.5 +lon_0=144.75 +k=1" + ve + Ks + i + a + r,
                9,
                o + _w + " +lon_0=46.5 +k=0.9994" + br + m + Me + xa + pi + a + r,
                22,
                h + i + r,
                1,
                o + $d + iS + A + $ + m + i + a + r,
                1,
                o + $d + tp + A + $ + m + i + a + r,
                1,
                o + ra + Ed + A + $ + m + i + a + r,
                1,
                o + $d + eb + A + $ + m + i + a + r,
                1,
                o + ra + Sd + A + $ + m + i + a + r,
                1,
                o + ra + gg + A + $ + m + i + a + r,
                1,
                o + ra + Md + A + $ + m + i + a + r,
                1,
                o + ra + oS + A + $ + m + i + a + r,
                1,
                o + ra + kd + A + $ + m + i + a + r,
                1,
                o + Bo + Nd + A + $ + m + i + a + r,
                1,
                o + fu + dE + A + $ + m + i + a + r,
                1,
                o + fu + mE + A + $ + m + i + a + r,
                1,
                o + fu + yE + A + $ + m + i + a + r,
                1,
                o + ru + " +lon_0=142" + A + $ + m + i + a + r,
                1,
                o + ru + um + A + $ + m + i + a + r,
                1,
                o + ru + " +lon_0=124" + A + $ + m + i + a + r,
                1,
                o + ru + tp + A + $ + m + i + a + r,
                1,
                o + " +lat_0=20" + gg + A + $ + m + i + a + r,
                1,
                o + ru + EE + A + $ + m + i + a + r,
                1,
                c + fh + i + a + r,
                1,
                c + Kh + i + a + r,
                1,
                c + xd + i + a + r,
                1,
                c + Ep + i + a + r,
                1,
                c + Ld + i + a + r,
                11,
                o + p + Ib + mt + y + Bt + j + n + a + r,
                3,
                h + i + n + r,
                1,
                c + Xu + i + n + a + r,
                1,
                c + Rl + i + n + a + r,
                1,
                c + Zh + i + n + a + r,
                11,
                o + p + " +lon_0=105.625 +k=1.000024" + _l + fm + j + n + a + r,
                1,
                o + p + " +lon_0=105.625 +k=1.00002514" + _l + fm + i + n + a + r,
                1,
                o + p + " +lon_0=96.875 +k=1" + _l + " +y_0=1400000" + j + n + a + r,
                1,
                o + p + " +lon_0=96.875 +k=0.99999387" + _l + fn + i + n + a + r,
                13,
                c + Dm + z + i + n + a + r,
                1,
                c + kp + z + i + n + a + r,
                1,
                c + bp + z + i + n + a + r,
                45,
                h + i + r,
                1,
                o + Gp + tc + _g + ad + m + i + a + r,
                1,
                o + Gp + tc + _g + Vu + m + i + V + r,
                1,
                o + Gp + tc + _g + ad + m + i + a + r,
                1,
                o + Gp + tc + _g + Vu + m + i + V + r,
                1,
                o + Xo + og + " +k=1.0002" + ed + m + i + a + r,
                1,
                o + Xo + og + " +k=1.0002" + Qa + m + i + V + r,
                1,
                o + Xo + og + " +k=1.0002" + ed + m + i + a + r,
                1,
                o + Xo + og + " +k=1.0002" + Qa + m + i + V + r,
                1,
                l + Tc + Fc + ag + sh + ed + " +y_0=130000" + i + a + r,
                1,
                l + Tc + Fc + ag + sh + Qa + VE + i + V + r,
                1,
                l + Tc + Fc + ag + sh + ed + " +y_0=130000" + i + a + r,
                1,
                l + Tc + Fc + ag + sh + Qa + VE + i + V + r,
                1,
                l + qe + ct + sg + CA + " +x_0=120000 +y_0=60000" + i + a + r,
                1,
                l + qe + ct + sg + CA + ZE + gS + i + V + r,
                1,
                l + qe + ct + sg + CA + " +x_0=120000 +y_0=60000" + i + a + r,
                1,
                l + qe + ct + sg + CA + ZE + gS + i + V + r,
                1,
                o + Fo + Fe + jE + ad + m + i + a + r,
                1,
                o + Fo + Fe + jE + Vu + m + i + V + r,
                1,
                o + Fo + Fe + jE + ad + m + i + a + r,
                1,
                o + Fo + Fe + jE + Vu + m + i + V + r,
                1,
                l + Pc + Ne + lt + nv + je + " +y_0=30000" + i + a + r,
                1,
                l + Pc + Ne + lt + nv + lp + vS + i + V + r,
                1,
                l + Pc + Ne + lt + nv + je + " +y_0=30000" + i + a + r,
                1,
                l + Pc + Ne + lt + nv + lp + vS + i + V + r,
                1,
                yr + Ic + RE + LE + " +k=1" + ab + vE + ql + qE + i + a + r,
                1,
                yr + Ic + RE + LE + " +k=1" + xE + YE + ql + qE + i + V + r,
                1,
                yr + Ic + RE + LE + " +k=1" + ab + vE + ql + qE + i + a + r,
                1,
                yr + Ic + RE + LE + " +k=1" + xE + YE + ql + qE + i + V + r,
                1,
                o + ee + Fe + DA + _l + m + i + a + r,
                1,
                o + ee + Fe + DA + ts + m + i + V + r,
                1,
                o + ee + Fe + DA + _l + m + i + a + r,
                1,
                o + ee + Fe + DA + ts + m + i + V + r,
                1,
                o + Gp + OA + UE + ed + m + i + a + r,
                1,
                o + Gp + OA + UE + Qa + m + i + V + r,
                1,
                o + Gp + OA + UE + ed + m + i + a + r,
                1,
                o + Gp + OA + UE + Qa + m + i + V + r,
                1,
                o + sb + ec + gf + _l + m + i + a + r,
                1,
                o + sb + ec + gf + ts + m + i + V + r,
                1,
                o + sb + ec + gf + _l + m + i + a + r,
                1,
                o + sb + ec + gf + ts + m + i + V + r,
                1,
                o + Xo + Fe + my + _l + m + i + a + r,
                1,
                o + Xo + Fe + my + ts + m + i + V + r,
                1,
                o + Xo + Fe + my + _l + m + i + a + r,
                1,
                o + Xo + Fe + my + ts + m + i + V + r,
                1,
                o + eu + rc + zE + " +x_0=10000" + m + i + a + r,
                1,
                o + eu + rc + zE + MS + m + i + V + r,
                1,
                o + eu + rc + zE + " +x_0=10000" + m + i + a + r,
                1,
                o + eu + rc + zE + MS + m + i + V + r,
                1,
                o + eu + Cu + GE + ad + m + i + a + r,
                1,
                o + eu + Cu + GE + Vu + m + i + V + r,
                1,
                o + eu + Cu + GE + ad + m + i + a + r,
                1,
                o + eu + Cu + GE + Vu + m + i + V + r,
                1,
                o + ub + yf + " +k=1.0001" + ed + m + i + a + r,
                1,
                o + ub + yf + " +k=1.0001" + Qa + m + i + V + r,
                1,
                o + ub + yf + " +k=1.0001" + ed + m + i + a + r,
                1,
                o + ub + yf + " +k=1.0001" + Qa + m + i + V + r,
                1,
                yr + hm + iv + " +alpha=5 +k=1 +x_0=-300000 +y_0=-4600000" + ql + " +gamma=5" + i + a + r,
                1,
                yr + hm + iv + " +alpha=5 +k=1" + KE + KA + ql + " +gamma=5" + i + V + r,
                1,
                yr + hm + iv + " +alpha=5 +k=1 +x_0=-300000 +y_0=-4600000" + ql + " +gamma=5" + i + a + r,
                1,
                yr + hm + iv + " +alpha=5 +k=1" + KE + KA + ql + " +gamma=5" + i + V + r,
                1,
                o + lb + nc + Zg + " +x_0=60000" + m + i + a + r,
                1,
                o + lb + nc + Zg + bS + m + i + V + r,
                1,
                o + lb + nc + Zg + " +x_0=60000" + m + i + a + r,
                1,
                o + lb + nc + Zg + bS + m + i + V + r,
                1,
                o + Bc + uu + TA + HE + m + i + a + r,
                1,
                o + Bc + uu + TA + xS + m + i + V + r,
                1,
                o + Bc + uu + TA + HE + m + i + a + r,
                1,
                o + Bc + uu + TA + xS + m + i + V + r,
                1,
                l + hl + FA + ug + ov + ve + xg + i + a + r,
                1,
                l + hl + FA + ug + ov + al + Yy + i + V + r,
                1,
                l + hl + FA + ug + ov + ve + xg + i + a + r,
                1,
                l + hl + FA + ug + ov + al + Yy + i + V + r,
                1,
                o + jc + ic + WE + _l + m + i + a + r,
                1,
                o + jc + ic + WE + ts + m + i + V + r,
                1,
                o + jc + ic + WE + _l + m + i + a + r,
                1,
                o + jc + ic + WE + ts + m + i + V + r,
                1,
                o + Rc + av + PA + $ + m + i + a + r,
                1,
                o + Rc + av + PA + $ + m + i + V + r,
                1,
                o + Rc + av + PA + $ + m + i + a + r,
                1,
                o + Rc + av + PA + $ + m + i + V + r,
                4,
                l + nl + Ss + Xo + lt + Z + m + i + a + r,
                1,
                l + nl + Ss + Xo + lt + lf + m + i + V + r,
                2,
                o + p + Sb + " +k=1" + y + m + i + n + a + r,
                5,
                o + p + Vs + " +k=0.9985000000000001" + ab + m + i + n + a + r,
                1,
                o + p + Vs + " +k=1" + hS + m + i + n + a + r,
                3,
                l + hl + ih + ft + He + N + m + i + a + r,
                1,
                l + nl + Al + go + dr + at + m + i + f + r,
                1,
                h + Me + xa + " +towgs84=-24,-203,268,0,0,0,0" + r,
                1,
                h + Me + xa + " +towgs84=-183,-15,273,0,0,0,0" + r,
                1,
                h + b + " +towgs84=-235,-110,393,0,0,0,0" + r,
                1,
                l + zd + wr + ct + lt + Dr + m + i + a + r,
                1,
                l + zd + wr + ct + lt + Vl + m + i + V + r,
                1,
                l + Gd + _r + G + lt + wt + m + i + a + r,
                1,
                l + Gd + _r + G + lt + Zl + m + i + V + r,
                5,
                h + Me + xa + jd + r,
                2,
                h + Me + xa + " +towgs84=-63,176,185,0,0,0,0" + r,
                21,
                c + lh + Me + xa + jd + a + r,
                7,
                l + Yg + IA + ra + sv + Z + m + i + n + a + r,
                1,
                l + Yg + IA + ra + sv + $t + m + i + n + f + r,
                1,
                l + Yg + IA + ra + sv + Z + m + i + a + r,
                1,
                l + Yg + IA + ra + sv + $t + m + i + f + r,
                6,
                vs + Os + es + $ + m + j + n + a + r,
                1,
                vs + q + es + $ + m + j + n + a + r,
                1,
                "+proj=cea" + es + " +lat_ts=30" + $ + m + j + n + a + r,
                29,
                l + " +lat_1=39 +lat_2=43" + ku + Sb + $ + m + i + n + a + r,
                21,
                h + i + r,
                1,
                o + wd + _d + eS + Rb + $A + i + a + r,
                6,
                h + i + r,
                1,
                o + wd + _d + eS + Rb + $A + i + a + r,
                14,
                c + Ll + Me + xa + ln + a + r,
                1,
                c + ll + Me + xa + ln + a + r,
                1,
                c + Ku + Me + xa + ln + a + r,
                28,
                h + i + r,
                2,
                h + i + r,
                2,
                h + i + r,
                2,
                h + i + r,
                16,
                l + " +lat_1=43.2 +lat_0=43.2 +lon_0=-95.25 +k_0=1.000052 +x_0=3505207.010414021 +y_0=2926085.852171705" + i + f + r,
                1,
                l + " +lat_1=43.16666666666666 +lat_0=43.16666666666666 +lon_0=-92.75 +k_0=1.000043 +x_0=3810007.62001524 +y_0=2987045.974091948" + i + f + r,
                1,
                o + uh + " +lon_0=-91.2 +k=1.000035 +x_0=4114808.229616459 +y_0=2529845.05969012" + i + f + r,
                1,
                l + " +lat_1=42.53333333333333 +lat_0=42.53333333333333 +lon_0=-94.83333333333333 +k_0=1.000045 +x_0=4419608.839217679 +y_0=2621285.242570485" + i + f + r,
                1,
                l + " +lat_1=42.65 +lat_0=42.65 +lon_0=-92.25 +k_0=1.000032 +x_0=4724409.448818898 +y_0=2712725.425450851" + i + f + r,
                1,
                o + uh + " +lon_0=-95.73333333333333 +k=1.000039 +x_0=5029210.058420117 +y_0=2011684.023368047" + i + f + r,
                1,
                o + uh + " +lon_0=-94.63333333333334" + Zg + " +x_0=5334010.668021336 +y_0=2072644.145288291" + i + f + r,
                1,
                o + uh + " +lon_0=-93.71666666666667 +k=1.000033 +x_0=5638811.277622555 +y_0=2133604.267208535" + i + f + r,
                1,
                o + uh + " +lon_0=-92.81666666666666" + Hp + " +x_0=5943611.887223775 +y_0=2194564.389128779" + i + f + r,
                1,
                l + " +lat_1=41.83333333333334 +lat_0=41.83333333333334 +lon_0=-91.66666666666667 +k_0=1.00002 +x_0=6248412.496824994 +y_0=2438404.876809754" + i + f + r,
                1,
                o + uh + " +lon_0=-90.53333333333333" + Hp + " +x_0=6553213.106426213 +y_0=2316484.632969266" + i + f + r,
                1,
                l + " +lat_1=40.91666666666666 +lat_0=40.91666666666666 +lon_0=-93.75 +k_0=1.000037 +x_0=6858013.716027432" + XA + i + f + r,
                1,
                o + uh + md + sd + " +x_0=7162814.325628651 +y_0=1950723.901447803" + i + f + r,
                1,
                o + uh + " +lon_0=-91.25 +k=1.000018 +x_0=7467614.93522987" + XA + i + f + r,
                3,
                h + i + r,
                1,
                c + Ll + z + i + a + r,
                1,
                c + ll + z + i + a + r,
                1,
                c + Ku + z + i + a + r,
                1,
                c + lh + z + i + a + r,
                1,
                c + Ky + z + i + a + r,
                1,
                c + Xy + z + i + a + r,
                1,
                c + Ig + z + i + a + r,
                1,
                c + Zv + z + i + a + r,
                3,
                h + i + r,
                2,
                h + i + r,
                23,
                o + yy + uv + _g + je + m + i + a + r,
                1,
                o + " +lat_0=48" + uv + " +k=1.00019" + ve + m + i + a + r,
                1,
                l + BA + yy + $l + " +k_0=1.000145" + je + Ks + i + a + r,
                1,
                l + BA + yy + " +lon_0=-108.5" + sh + I + " +y_0=150000" + i + a + r,
                1,
                l + Lc + qc + Ee + sh + I + ni + i + a + r,
                1,
                l + Lc + qc + Ee + " +k_0=1.00009" + ve + xg + i + a + r,
                1,
                o + hm + " +lon_0=-107.75 +k=1.000148" + I + m + i + a + r,
                1,
                l + pS + " +lat_0=46.25 +lon_0=-111.25 +k_0=1.000185" + ve + ni + i + a + r,
                1,
                l + Pw + Iw + Hb + " +k_0=1.0001515" + I + xg + i + a + r,
                1,
                o + Bw + Wb + " +k=1.00024" + ve + m + i + a + r,
                1,
                o + yy + uv + _g + lp + m + i + V + r,
                1,
                o + " +lat_0=48" + uv + " +k=1.00019" + al + m + i + V + r,
                1,
                l + BA + yy + $l + " +k_0=1.000145" + lp + " +y_0=199999.9999992" + i + V + r,
                1,
                l + BA + yy + " +lon_0=-108.5" + sh + Yp + " +y_0=150000.00001464" + i + V + r,
                1,
                l + Lc + qc + Ee + sh + Yp + JA + i + V + r,
                1,
                l + Lc + qc + Ee + " +k_0=1.00009" + al + " +y_0=49999.99971024" + i + V + r,
                1,
                o + hm + " +lon_0=-107.75 +k=1.000148" + Yp + m + i + V + r,
                1,
                l + pS + " +lat_0=46.25 +lon_0=-111.25 +k_0=1.000185" + al + JA + i + V + r,
                1,
                l + Pw + Iw + Hb + " +k_0=1.0001515" + Yp + Yy + i + V + r,
                1,
                o + Bw + Wb + " +k=1.00024" + ol + m + i + f + r,
                3,
                o + pm + " +lon_0=-122.45 +k=1.000007 +x_0=48000 +y_0=24000" + i + a + r,
                1,
                o + pm + " +lon_0=-122.45 +k=1.000007 +x_0=48000 +y_0=24000" + i + f + r,
                1,
                h + i + r,
                3,
                h + j + r,
                3,
                h + j + r,
                3,
                o + Uc + zc + " +k=1" + xy + " +y_0=126867.909" + op + ap + " +towgs84=-275.7224,94.7824,340.8944,-8.001,-4.42,-11.821,1" + a + r,
                115,
                o + dm + lv + vf + L + H + i + a + r,
                1,
                o + dm + lv + vf + L + H + i + f + r,
                1,
                o + gy + cd + bf + L + H + i + a + r,
                1,
                o + gy + cd + bf + L + H + i + f + r,
                1,
                o + " +lat_0=39" + oc + xf + L + H + i + a + r,
                1,
                o + " +lat_0=39" + oc + xf + L + H + i + f + r,
                1,
                o + " +lat_0=40.45" + mm + jA + L + H + i + a + r,
                1,
                o + " +lat_0=40.45" + mm + jA + L + H + i + f + r,
                1,
                o + " +lat_0=40.05" + $b + Wp + L + H + i + a + r,
                1,
                o + " +lat_0=40.05" + $b + Wp + L + H + i + f + r,
                1,
                o + RA + ym + $p + L + H + i + a + r,
                1,
                o + RA + ym + $p + L + H + i + f + r,
                1,
                o + " +lat_0=39" + cb + $E + L + H + i + a + r,
                1,
                o + " +lat_0=39" + cb + $E + L + H + i + f + r,
                1,
                o + " +lat_0=40.4" + Vb + xf + L + H + i + a + r,
                1,
                o + " +lat_0=40.4" + Vb + xf + L + H + i + f + r,
                1,
                o + dm + Zb + vy + L + H + i + a + r,
                1,
                o + dm + Zb + vy + L + H + i + f + r,
                1,
                o + fb + Yb + " +k=1.000021" + L + H + i + a + r,
                1,
                o + fb + Yb + " +k=1.000021" + L + H + i + f + r,
                1,
                o + hb + Kb + " +k=1.000024" + L + H + i + a + r,
                1,
                o + hb + Kb + " +k=1.000024" + L + H + i + f + r,
                1,
                o + " +lat_0=40.15" + Xb + " +k=1.000032" + L + H + i + a + r,
                1,
                o + " +lat_0=40.15" + Xb + " +k=1.000032" + L + H + i + f + r,
                1,
                o + " +lat_0=38.1" + ym + by + L + H + i + a + r,
                1,
                o + " +lat_0=38.1" + ym + by + L + H + i + f + r,
                1,
                o + " +lat_0=38.45" + ac + " +k=1.000018" + L + H + i + a + r,
                1,
                o + " +lat_0=38.45" + ac + " +k=1.000018" + L + H + i + f + r,
                1,
                o + " +lat_0=38.65" + Jb + jA + L + H + i + a + r,
                1,
                o + " +lat_0=38.65" + Jb + jA + L + H + i + f + r,
                1,
                o + " +lat_0=39.1" + Qb + $p + L + H + i + a + r,
                1,
                o + " +lat_0=39.1" + Qb + $p + L + H + i + f + r,
                1,
                o + pb + lv + $p + L + H + i + a + r,
                1,
                o + pb + lv + $p + L + H + i + f + r,
                1,
                o + " +lat_0=38.2" + cv + sd + L + H + i + a + r,
                1,
                o + " +lat_0=38.2" + cv + sd + L + H + i + f + r,
                1,
                o + db + oc + " +k=1.000033" + L + H + i + a + r,
                1,
                o + db + oc + " +k=1.000033" + L + H + i + f + r,
                1,
                o + mb + cd + Wp + L + H + i + a + r,
                1,
                o + mb + cd + Wp + L + H + i + f + r,
                1,
                o + " +lat_0=39.95" + mm + by + L + H + i + a + r,
                1,
                o + " +lat_0=39.95" + mm + by + L + H + i + f + r,
                1,
                o + gy + cb + bf + L + H + i + a + r,
                1,
                o + gy + cb + bf + L + H + i + f + r,
                1,
                o + fb + tx + LA + L + H + i + a + r,
                1,
                o + fb + tx + LA + L + H + i + f + r,
                1,
                o + yb + " +lon_0=-85.7" + vf + L + H + i + a + r,
                1,
                o + yb + " +lon_0=-85.7" + vf + L + H + i + f + r,
                1,
                o + " +lat_0=39.9" + Yf + vf + L + H + i + a + r,
                1,
                o + " +lat_0=39.9" + Yf + vf + L + H + i + f + r,
                1,
                o + " +lat_0=39.65" + gb + $p + L + H + i + a + r,
                1,
                o + " +lat_0=39.65" + gb + $p + L + H + i + f + r,
                1,
                o + " +lat_0=37.95" + Ha + Hp + L + H + i + a + r,
                1,
                o + " +lat_0=37.95" + Ha + Hp + L + H + i + f + r,
                1,
                o + " +lat_0=39.75" + fv + my + L + H + i + a + r,
                1,
                o + " +lat_0=39.75" + fv + my + L + H + i + f + r,
                1,
                o + yb + Ha + bf + L + H + i + a + r,
                1,
                o + yb + Ha + bf + L + H + i + f + r,
                1,
                o + db + ob + vf + L + H + i + a + r,
                1,
                o + db + ob + vf + L + H + i + f + r,
                1,
                o + " +lat_0=38.7 +lon_0=-85.95" + qA + L + H + i + a + r,
                1,
                o + " +lat_0=38.7 +lon_0=-85.95" + qA + L + H + i + f + r,
                1,
                o + UA + ac + Hp + L + H + i + a + r,
                1,
                o + UA + ac + Hp + L + H + i + f + r,
                1,
                o + " +lat_0=40.3" + wg + Wp + L + H + i + a + r,
                1,
                o + " +lat_0=40.3" + wg + Wp + L + H + i + f + r,
                1,
                o + " +lat_0=38.55" + ex + vy + L + H + i + a + r,
                1,
                o + " +lat_0=38.55" + ex + vy + L + H + i + f + r,
                1,
                o + " +lat_0=38.8" + gb + by + L + H + i + a + r,
                1,
                o + " +lat_0=38.8" + gb + by + L + H + i + f + r,
                1,
                o + zA + Ha + bf + L + H + i + a + r,
                1,
                o + zA + Ha + bf + L + H + i + f + r,
                1,
                o + " +lat_0=38.4" + hv + gf + L + H + i + a + r,
                1,
                o + " +lat_0=38.4" + hv + gf + L + H + i + f + r,
                1,
                o + pb + fv + " +k=1.000037" + L + H + i + a + r,
                1,
                o + pb + fv + " +k=1.000037" + L + H + i + f + r,
                1,
                o + UA + rx + xf + L + H + i + a + r,
                1,
                o + UA + rx + xf + L + H + i + f + r,
                1,
                o + gy + " +lon_0=-86.75" + Hp + L + H + i + a + r,
                1,
                o + gy + " +lon_0=-86.75" + Hp + L + H + i + f + r,
                1,
                o + " +lat_0=38.95" + ym + vy + L + H + i + a + r,
                1,
                o + " +lat_0=38.95" + ym + vy + L + H + i + f + r,
                1,
                o + " +lat_0=39.45" + cv + bf + L + H + i + a + r,
                1,
                o + " +lat_0=39.45" + cv + bf + L + H + i + f + r,
                1,
                o + hb + sc + xf + L + H + i + a + r,
                1,
                o + hb + sc + xf + L + H + i + f + r,
                1,
                o + RA + nx + qA + L + H + i + a + r,
                1,
                o + RA + nx + qA + L + H + i + f + r,
                1,
                o + GA + " +lon_0=-86.7" + sd + L + H + i + a + r,
                1,
                o + GA + " +lon_0=-86.7" + sd + L + H + i + f + r,
                1,
                o + " +lat_0=37.85" + mm + gf + L + H + i + a + r,
                1,
                o + " +lat_0=37.85" + mm + gf + L + H + i + f + r,
                1,
                o + pm + " +lon_0=-87.95" + LA + L + H + i + a + r,
                1,
                o + pm + " +lon_0=-87.95" + LA + L + H + i + f + r,
                1,
                o + " +lat_0=39.7" + cd + " +k=1.000044" + L + H + i + a + r,
                1,
                o + " +lat_0=39.7" + cd + " +k=1.000044" + L + H + i + f + r,
                1,
                o + HA + " +lon_0=-85.3" + Wp + L + H + i + a + r,
                1,
                o + HA + " +lon_0=-85.3" + Wp + L + H + i + f + r,
                1,
                o + zA + ix + $E + L + H + i + a + r,
                1,
                o + zA + ix + $E + L + H + i + f + r,
                1,
                o + pm + " +lon_0=-87.05 +k=1.000014" + L + H + i + a + r,
                1,
                o + pm + " +lon_0=-87.05 +k=1.000014" + L + H + i + f + r,
                1,
                o + To + wg + " +k=1.000041" + L + H + i + a + r,
                1,
                o + To + wg + " +k=1.000041" + L + H + i + f + r,
                1,
                o + HA + Vp + " +k=1.000017" + L + H + i + a + r,
                1,
                o + HA + Vp + " +k=1.000017" + L + H + i + f + r,
                1,
                o + " +lat_0=40.2" + sc + xf + L + H + i + a + r,
                1,
                o + " +lat_0=40.2" + sc + xf + L + H + i + f + r,
                1,
                o + GA + pv + gf + L + H + i + a + r,
                1,
                o + GA + pv + gf + L + H + i + f + r,
                1,
                o + mb + hv + sd + L + H + i + a + r,
                1,
                o + mb + hv + sd + L + H + i + f + r,
                1,
                o + dm + " +lon_0=-85.25" + vf + L + H + i + a + r,
                1,
                o + dm + " +lon_0=-85.25" + vf + L + H + i + f + r,
                3,
                h + i + n + r,
                1,
                c + Ku + i + n + a + r,
                1,
                c + lh + i + n + a + r,
                1,
                c + Ky + i + n + a + r,
                152,
                o + jw + He + " +k=1.0000365285 +x_0=147218.6942 +y_0=0.0037" + i + a + r,
                1,
                o + Rw + ox + " +k=1.0000495683 +x_0=172821.9461 +y_0=0.0017" + i + a + r,
                1,
                o + Lw + ax + " +k=1.0000486665 +x_0=93150 +y_0=0.0029" + i + a + r,
                1,
                l + qw + Uw + sx + " +k_0=1.0000331195 +x_0=228600.4575 +y_0=148551.4837" + i + a + r,
                1,
                o + hp + " +lon_0=-88" + sd + " +x_0=31600 +y_0=4600" + i + a + r,
                1,
                o + zw + ux + " +k=1.0000382778 +x_0=175260.3502 +y_0=0.0048" + i + a + r,
                1,
                l + Gw + Hw + lx + " +k_0=1.0000383841 +x_0=64008.1276 +y_0=59445.9043" + i + a + r,
                1,
                o + Ww + " +lon_0=-88.5 +k=1.0000286569 +x_0=244754.8893 +y_0=0.0049" + i + a + r,
                1,
                l + $w + Vw + cx + " +k_0=1.0000391127 +x_0=60045.72 +y_0=44091.4346" + i + a + r,
                1,
                o + " +lat_0=43.6" + fx + " +k=1.0000463003 +x_0=199949.1989 +y_0=0.0086" + i + a + r,
                1,
                l + Zw + Yw + hx + " +k_0=1.00003498 +x_0=169164.3381 +y_0=111569.6134" + i + a + r,
                1,
                l + wS + _S + Kw + " +k_0=1.0000349151 +x_0=113690.6274 +y_0=53703.1201" + i + a + r,
                1,
                l + XE + JE + px + " +k_0=1.0000384786 +x_0=247193.2944 +y_0=146591.9896" + i + a + r,
                1,
                o + Xw + dx + " +k=1.0000346418 +x_0=263347.7263 +y_0=0.0076" + i + a + r,
                1,
                o + " +lat_0=44.4" + mx + " +k=1.0000187521 +x_0=158801.1176 +y_0=0.0023" + i + a + r,
                1,
                o + Jw + md + " +k=1.0000385418 +x_0=59131.3183 +y_0=0.0041" + i + a + r,
                1,
                o + Qw + yx + " +k=1.0000410324 +x_0=51816.104 +y_0=0.003" + i + a + r,
                1,
                l + t_ + e_ + gx + " +k_0=1.000035079 +x_0=120091.4402 +y_0=91687.92389999999" + i + a + r,
                1,
                o + r_ + vx + " +k=1.0000552095 +x_0=133502.6683 +y_0=0.0063" + i + a + r,
                1,
                o + n_ + bx + " +k=1.0000673004 +x_0=275844.5533 +y_0=0.0157" + i + a + r,
                1,
                o + i_ + " +lon_0=-90.8 +k=1.0000349452 +x_0=242316.4841 +y_0=0.01" + i + a + r,
                1,
                l + o_ + a_ + xx + " +k_0=1.0000390487 +x_0=170078.7403 +y_0=45830.2947" + i + a + r,
                1,
                l + s_ + u_ + uc + " +k_0=1.0000344057 +x_0=150876.3018 +y_0=79170.7795" + i + a + r,
                1,
                o + l_ + wx + " +k=1.0000394961 +x_0=113081.0261 +y_0=0.0045" + i + a + r,
                1,
                o + c_ + _x + " +k=1.0000677153 +x_0=220980.4419 +y_0=0.008500000000000001" + i + a + r,
                1,
                o + f_ + Ax + " +k=1.0000353 +x_0=27000 +y_0=25000" + i + a + r,
                1,
                o + h_ + Ex + " +k=1.0000260649 +x_0=185928.3728 +y_0=0.0009" + i + a + r,
                1,
                o + p_ + pv + " +k=1.0000233704 +x_0=79857.7614 +y_0=0.0012" + i + a + r,
                1,
                o + d_ + Sx + " +k=1.0000319985 +x_0=130454.6598 +y_0=0.0033" + i + a + r,
                1,
                l + m_ + y_ + Mx + " +k_0=1.0000627024 +x_0=198425.197 +y_0=105279.7829" + i + a + r,
                1,
                o + g_ + kx + " +k=1.0000599003 +x_0=116129.0323 +y_0=0.0058" + i + a + r,
                1,
                l + v_ + b_ + " +lon_0=-89.77 +k_0=1.000053289 +x_0=74676.1493 +y_0=55049.2669" + i + a + r,
                1,
                o + x_ + Nx + " +k=1.0000234982 +x_0=238658.8794 +y_0=0.0032" + i + a + r,
                1,
                o + w_ + Cx + " +k=1.0000362499 +x_0=105461.0121 +y_0=0.0029" + i + a + r,
                1,
                l + __ + A_ + Dx + " +k_0=1.0000434122 +x_0=204521.209 +y_0=121923.9861" + i + a + r,
                1,
                o + E_ + Ox + " +k=1.0000236869 +x_0=182880.3676 +y_0=0.0033" + i + a + r,
                1,
                l + S_ + M_ + Tx + " +k_0=1.0000686968 +x_0=70104.1401 +y_0=57588.0346" + i + a + r,
                1,
                l + k_ + N_ + Fx + " +k_0=1.0000362977 +x_0=167640.3354 +y_0=86033.0876" + i + a + r,
                1,
                o + C_ + lc + " +k=1.0000433849 +x_0=141732.2823 +y_0=0.0059" + i + a + r,
                1,
                l + D_ + O_ + " +lon_0=-89.5 +k_0=1.000039936 +x_0=56388.1128 +y_0=50022.1874" + i + a + r,
                1,
                o + T_ + Px + " +k=1.0000649554 +x_0=227990.8546 +y_0=0.0109" + i + a + r,
                1,
                l + QE + tS + Ix + " +k_0=1.0000375653 +x_0=202387.6048 +y_0=134255.4253" + i + a + r,
                1,
                o + F_ + Bx + " +k=1.0000337311 +x_0=146304.2926 +y_0=0.0068" + i + a + r,
                1,
                o + P_ + jx + " +k=1.0000495976 +x_0=250546.1013 +y_0=0.0234" + i + a + r,
                1,
                o + I_ + Rx + " +k=1.0000373868 +x_0=185623.5716 +y_0=0.0051" + i + a + r,
                1,
                l + B_ + j_ + Lx + " +k_0=1.0000573461 +x_0=216713.2336 +y_0=120734.1631" + i + a + r,
                1,
                o + Gc + qx + " +k=1.000032144 +x_0=262433.3253 +y_0=0.009599999999999999" + i + a + r,
                1,
                o + Gc + lc + " +k=1.0000381803 +x_0=165506.7302 +y_0=0.0103" + i + a + r,
                1,
                l + R_ + L_ + Ux + " +k_0=1.0000597566 +x_0=187147.5744 +y_0=107746.7522" + i + a + r,
                1,
                o + q_ + zx + " +k=1.0000361538 +x_0=256946.9138 +y_0=0.0041" + i + a + r,
                1,
                l + U_ + z_ + Gx + " +k_0=1.0000408158 +x_0=222504.4451 +y_0=47532.0602" + i + a + r,
                1,
                l + G_ + H_ + Hx + " +k_0=1.0000730142 +x_0=134417.0689 +y_0=50337.1092" + i + a + r,
                1,
                l + W_ + $_ + Wx + " +k_0=1.0000367192 +x_0=232562.8651 +y_0=111088.2224" + i + a + r,
                1,
                l + V_ + Z_ + $x + " +k_0=1.0000475376 +x_0=234086.8682 +y_0=188358.6058" + i + a + r,
                1,
                o + Y_ + Vx + " +k=1.00003738 +x_0=120091.4415 +y_0=0.003" + i + a + r,
                1,
                o + K_ + Zx + " +k=1.0000346179 +x_0=208788.418 +y_0=0.0034" + i + a + r,
                1,
                o + X_ + Yx + " +k=1.0000333645 +x_0=185013.9709 +y_0=0.007" + i + a + r,
                1,
                l + J_ + Q_ + uc + " +k_0=1.0000392096 +x_0=120091.4402 +y_0=45069.7587" + i + a + r,
                1,
                l + tA + eA + He + " +k_0=1.0000421209 +x_0=208483.6173 +y_0=134589.754" + i + a + r,
                1,
                o + jw + He + " +k=1.0000365285 +x_0=147218.6941325883 +y_0=0.00365760731521463" + i + f + r,
                1,
                o + Rw + ox + " +k=1.0000495683 +x_0=172821.945948692 +y_0=0.001828803657607315" + i + f + r,
                1,
                o + Lw + ax + " +k=1.0000486665 +x_0=93150" + lu + i + f + r,
                1,
                l + qw + Uw + sx + " +k_0=1.0000331195 +x_0=228600.4575057151 +y_0=148551.4835661671" + i + f + r,
                1,
                o + hp + " +lon_0=-88" + sd + " +x_0=31599.99989839979 +y_0=4599.999898399797" + i + f + r,
                1,
                o + zw + ux + " +k=1.0000382778 +x_0=175260.3502159004" + Kx + i + f + r,
                1,
                l + Gw + Hw + lx + " +k_0=1.0000383841 +x_0=64008.12771145543 +y_0=59445.90419100838" + i + f + r,
                1,
                o + Ww + " +lon_0=-88.5 +k=1.0000286569 +x_0=244754.8892049784" + Kx + i + f + r,
                1,
                l + $w + Vw + cx + " +k_0=1.0000391127 +x_0=60045.72009144018 +y_0=44091.43449326898" + i + f + r,
                1,
                o + " +lat_0=43.6" + fx + " +k=1.0000463003 +x_0=199949.198983998" + Xx + i + f + r,
                1,
                l + Zw + Yw + hx + " +k_0=1.00003498 +x_0=169164.338023876 +y_0=111569.613512827" + i + f + r,
                1,
                l + wS + _S + Kw + " +k_0=1.0000349151 +x_0=113690.6273812548 +y_0=53703.12024384048" + i + f + r,
                1,
                l + XE + JE + px + " +k_0=1.0000384786 +x_0=247193.2943865888 +y_0=146591.9896367793" + i + f + r,
                1,
                o + Xw + dx + " +k=1.0000346418 +x_0=263347.7263906528 +y_0=0.00762001524003048" + i + f + r,
                1,
                o + " +lat_0=44.4" + mx + " +k=1.0000187521 +x_0=158801.1176022352 +y_0=0.002438404876809754" + i + f + r,
                1,
                o + Jw + md + " +k=1.0000385418 +x_0=59131.31826263652" + Jx + i + f + r,
                1,
                o + Qw + yx + " +k=1.0000410324 +x_0=51816.10393700787" + lu + i + f + r,
                1,
                l + t_ + e_ + gx + " +k_0=1.000035079" + QA + " +y_0=91687.92390144781" + i + f + r,
                1,
                o + r_ + vx + " +k=1.0000552095 +x_0=133502.6682245364 +y_0=0.006400812801625603" + i + f + r,
                1,
                o + n_ + bx + " +k=1.0000673004 +x_0=275844.5532131065 +y_0=0.0158496316992634" + i + f + r,
                1,
                o + i_ + " +lon_0=-90.8 +k=1.0000349452 +x_0=242316.484023368 +y_0=0.01005842011684023" + i + f + r,
                1,
                l + o_ + a_ + xx + " +k_0=1.0000390487 +x_0=170078.7401574803 +y_0=45830.29484378968" + i + f + r,
                1,
                l + s_ + u_ + uc + " +k_0=1.0000344057 +x_0=150876.3017526035 +y_0=79170.77937515875" + i + f + r,
                1,
                o + l_ + wx + " +k=1.0000394961 +x_0=113081.0261620523 +y_0=0.004572009144018288" + i + f + r,
                1,
                o + c_ + _x + " +k=1.0000677153 +x_0=220980.4419608839" + Xx + i + f + r,
                1,
                o + f_ + Ax + " +k=1.0000353 +x_0=27000 +y_0=24999.99989839979" + i + f + r,
                1,
                o + h_ + Ex + " +k=1.0000260649 +x_0=185928.3727711455 +y_0=0.0009144018288036576" + i + f + r,
                1,
                o + p_ + pv + " +k=1.0000233704 +x_0=79857.76154432308 +y_0=0.001219202438404877" + i + f + r,
                1,
                o + d_ + Sx + " +k=1.0000319985 +x_0=130454.6596901194" + yd + i + f + r,
                1,
                l + m_ + y_ + Mx + " +k_0=1.0000627024 +x_0=198425.1968503937 +y_0=105279.7828803657" + i + f + r,
                1,
                o + g_ + kx + " +k=1.0000599003 +x_0=116129.0322580645" + Qx + i + f + r,
                1,
                l + v_ + b_ + " +lon_0=-89.77 +k_0=1.000053289 +x_0=74676.1493522987 +y_0=55049.26695453391" + i + f + r,
                1,
                o + x_ + Nx + " +k=1.0000234982 +x_0=238658.8794513589" + lu + i + f + r,
                1,
                o + w_ + Cx + " +k=1.0000362499 +x_0=105461.0121412243" + lu + i + f + r,
                1,
                l + __ + A_ + Dx + " +k_0=1.0000434122 +x_0=204521.2090424181 +y_0=121923.9861823724" + i + f + r,
                1,
                o + E_ + Ox + " +k=1.0000236869 +x_0=182880.3675895352" + yd + i + f + r,
                1,
                l + S_ + M_ + Tx + " +k_0=1.0000686968 +x_0=70104.14020828041 +y_0=57588.03474726949" + i + f + r,
                1,
                l + k_ + N_ + Fx + " +k_0=1.0000362977 +x_0=167640.3352806706 +y_0=86033.08773177546" + i + f + r,
                1,
                o + C_ + lc + " +k=1.0000433849 +x_0=141732.2822453645" + Qx + i + f + r,
                1,
                l + D_ + O_ + " +lon_0=-89.5 +k_0=1.000039936 +x_0=56388.11277622555 +y_0=50022.1874523749" + i + f + r,
                1,
                o + T_ + Px + " +k=1.0000649554 +x_0=227990.8544577089 +y_0=0.01097282194564389" + i + f + r,
                1,
                l + QE + tS + Ix + " +k_0=1.0000375653 +x_0=202387.6047752095 +y_0=134255.4254508509" + i + f + r,
                1,
                o + F_ + Bx + " +k=1.0000337311 +x_0=146304.2926085852 +y_0=0.006705613411226822" + i + f + r,
                1,
                o + P_ + jx + " +k=1.0000495976 +x_0=250546.1013970028 +y_0=0.02346964693929388" + i + f + r,
                1,
                o + I_ + Rx + " +k=1.0000373868 +x_0=185623.5715519431 +y_0=0.005181610363220727" + i + f + r,
                1,
                l + B_ + j_ + Lx + " +k_0=1.0000573461 +x_0=216713.2337312675 +y_0=120734.1631699263" + i + f + r,
                1,
                o + Gc + qx + " +k=1.000032144 +x_0=262433.3251714504 +y_0=0.009448818897637795" + i + f + r,
                1,
                o + Gc + lc + " +k=1.0000381803 +x_0=165506.7300990602 +y_0=0.01036322072644145" + i + f + r,
                1,
                l + R_ + L_ + Ux + " +k_0=1.0000597566 +x_0=187147.5742951486 +y_0=107746.7521463043" + i + f + r,
                1,
                o + q_ + zx + " +k=1.0000361538 +x_0=256946.9138938278" + Jx + i + f + r,
                1,
                l + U_ + z_ + Gx + " +k_0=1.0000408158 +x_0=222504.44500889 +y_0=47532.0603505207" + i + f + r,
                1,
                l + G_ + H_ + Hx + " +k_0=1.0000730142 +x_0=134417.0688341377 +y_0=50337.10927101854" + i + f + r,
                1,
                l + W_ + $_ + Wx + " +k_0=1.0000367192 +x_0=232562.8651257302 +y_0=111088.2224028448" + i + f + r,
                1,
                l + V_ + Z_ + $x + " +k_0=1.0000475376 +x_0=234086.8681737363 +y_0=188358.6059436119" + i + f + r,
                1,
                o + Y_ + Vx + " +k=1.00003738 +x_0=120091.4414020828" + lu + i + f + r,
                1,
                o + K_ + Zx + " +k=1.0000346179 +x_0=208788.4178816358" + yd + i + f + r,
                1,
                o + X_ + Yx + " +k=1.0000333645 +x_0=185013.9709423419 +y_0=0.007010414020828041" + i + f + r,
                1,
                l + J_ + Q_ + uc + " +k_0=1.0000392096" + QA + " +y_0=45069.7588011176" + i + f + r,
                1,
                l + tA + eA + He + " +k_0=1.0000421209 +x_0=208483.6172720346 +y_0=134589.7539243078" + i + f + r,
                41,
                h + i + r,
                6,
                o + p + " +lon_0=68.51666666666667 +k=1 +x_0=1300000" + $y + i + a + r,
                1,
                o + p + " +lon_0=71.51666666666667 +k=1" + aS + $y + i + a + r,
                1,
                o + p + " +lon_0=74.51666666666667 +k=1" + sS + $y + i + a + r,
                1,
                o + p + " +lon_0=77.51666666666667 +k=1" + uS + $y + i + a + r,
                1,
                o + p + " +lon_0=80.51666666666667 +k=1 +x_0=5300000" + $y + i + a + r,
                12308,
                o + p + ka + " +k=1" + cn + m + d + u + a + r,
                1,
                o + p + rs + " +k=1" + Si + m + d + u + a + r,
                1,
                o + p + $s + " +k=1" + Cl + m + d + u + a + r,
                1,
                o + p + Vc + " +k=1" + Js + m + d + u + a + r,
                1,
                o + p + rl + " +k=1" + Xf + m + d + u + a + r,
                1,
                o + p + Wd + " +k=1" + Jf + m + d + u + a + r,
                1,
                o + p + Py + " +k=1" + of + m + d + u + a + r,
                1,
                o + p + Vm + " +k=1" + Sl + m + d + u + a + r,
                1,
                o + p + Iy + " +k=1" + af + m + d + u + a + r,
                1,
                o + p + ns + " +k=1" + us + m + d + u + a + r,
                1,
                o + p + is + " +k=1" + Ra + m + d + u + a + r,
                1,
                o + p + gs + " +k=1" + Ps + m + d + u + a + r,
                1,
                o + p + os + " +k=1" + Is + m + d + u + a + r,
                1,
                o + p + as + " +k=1" + Ou + m + d + u + a + r,
                1,
                o + p + ai + " +k=1" + Ts + m + d + u + a + r,
                1,
                o + p + zo + " +k=1" + Fs + m + d + u + a + r,
                1,
                o + p + Do + " +k=1" + ls + m + d + u + a + r,
                1,
                o + p + Io + " +k=1" + Bs + m + d + u + a + r,
                1,
                o + p + _i + " +k=1" + cs + m + d + u + a + r,
                1,
                o + p + Oo + " +k=1" + js + m + d + u + a + r,
                1,
                o + p + im + " +k=1" + sf + m + d + u + a + r,
                1,
                o + p + id + " +k=1" + Rs + m + d + u + a + r,
                1,
                o + p + ep + " +k=1" + Ls + m + d + u + a + r,
                1,
                o + p + om + " +k=1" + qs + m + d + u + a + r,
                1,
                o + p + rp + " +k=1" + Us + m + d + u + a + r,
                1,
                o + p + hf + " +k=1" + La + m + d + u + a + r,
                1,
                o + p + zl + " +k=1" + ou + m + d + u + a + r,
                1,
                o + p + Gl + " +k=1" + va + m + d + u + a + r,
                1,
                o + p + df + " +k=1" + au + m + d + u + a + r,
                103,
                c + yc + D + fs + a + r,
                1,
                c + ch + D + fs + a + r,
                1,
                c + Ll + D + fs + a + r,
                1,
                c + ll + D + fs + a + r,
                111,
                c + ph + z + X + W + a + r,
                1,
                c + Yh + z + X + W + a + r,
                1,
                c + fh + z + X + W + a + r,
                1,
                c + Kh + z + X + W + a + r,
                1,
                c + xd + z + X + W + a + r,
                1,
                c + Ep + z + X + W + a + r,
                1,
                c + Ld + z + X + W + a + r,
                1,
                c + Qy + z + X + W + a + r,
                1,
                c + Fg + z + X + W + a + r,
                1,
                c + Ff + z + X + W + a + r,
                91,
                c + ph + z + X + Xe + a + r,
                1,
                c + Yh + z + X + Xe + a + r,
                1,
                c + fh + z + X + Xe + a + r,
                1,
                c + Kh + z + X + Xe + a + r,
                1,
                c + xd + z + X + Xe + a + r,
                1,
                c + Ep + z + X + Xe + a + r,
                1,
                c + Ld + z + X + Xe + a + r,
                1,
                c + Qy + z + X + Xe + a + r,
                80,
                c + ch + b + Pr + a + r,
                1,
                c + Ll + b + Pr + a + r,
                1,
                c + ll + b + Pr + a + r,
                1,
                c + Ku + b + Pr + a + r,
                1,
                c + lh + b + Pr + a + r,
                59,
                c + Ku + b + Pr + a + r,
                39,
                c + ll + d + zh + a + r,
                1,
                c + Ku + d + zh + a + r,
                251,
                o + _e + " +lon_0=1 +k=1" + I + Es + b + di + PE + a + r,
                1,
                o + _e + " +lon_0=1 +k=1" + $ + m + b + di + PE + a + r,
                31,
                c + Mu + z + b + wi + a + r,
                1,
                c + Pf + z + b + wi + a + r,
                1,
                c + Mp + z + b + wi + a + r,
                110,
                c + Zh + z + Me + ye + Su + a + r,
                1,
                c + yc + z + Me + ye + Su + a + r,
                1,
                c + ch + z + Me + ye + Su + a + r,
                99,
                c + yc + z + D + ci + a + r,
                1,
                c + ch + z + D + ci + a + r,
                1,
                c + Ll + z + D + ci + a + r,
                58,
                c + yc + D + ci + a + r,
                1,
                c + ch + D + ci + a + r,
                1,
                c + Ll + D + ci + a + r,
                51,
                c + hh + z + M + Or + a + r,
                1,
                c + ph + z + M + Or + a + r,
                1,
                c + Yh + z + M + Or + a + r,
                141,
                o + p + Xh + ui + Z + m + D + Tl + a + r,
                1,
                o + " +lat_0=13.17638888888889 +lon_0=-59.55972222222222 +k=0.9999986" + HE + " +y_0=75000" + D + Tl + a + r,
                121,
                o + p + ns + " +k=1" + us + m + d + _ + a + r,
                1,
                o + p + is + " +k=1" + Ra + m + d + _ + a + r,
                1,
                o + p + gs + " +k=1" + Ps + m + d + _ + a + r,
                1,
                o + p + os + " +k=1" + Is + m + d + _ + a + r,
                1,
                o + p + as + " +k=1" + Ou + m + d + _ + a + r,
                1,
                o + p + ai + " +k=1" + Ts + m + d + _ + a + r,
                1,
                o + p + zo + " +k=1" + Fs + m + d + _ + a + r,
                1,
                o + p + Do + " +k=1" + ls + m + d + _ + a + r,
                1,
                o + p + Io + " +k=1" + Bs + m + d + _ + a + r,
                1,
                o + p + _i + " +k=1" + cs + m + d + _ + a + r,
                1,
                o + p + Oo + " +k=1" + js + m + d + _ + a + r,
                30,
                o + p + ns + " +k=1" + y + m + d + _ + a + r,
                1,
                o + p + is + " +k=1" + y + m + d + _ + a + r,
                1,
                o + p + gs + " +k=1" + y + m + d + _ + a + r,
                1,
                o + p + os + " +k=1" + y + m + d + _ + a + r,
                1,
                o + p + as + " +k=1" + y + m + d + _ + a + r,
                1,
                o + p + ai + " +k=1" + y + m + d + _ + a + r,
                1,
                o + p + zo + " +k=1" + y + m + d + _ + a + r,
                1,
                o + p + Do + " +k=1" + y + m + d + _ + a + r,
                1,
                o + p + Io + " +k=1" + y + m + d + _ + a + r,
                1,
                o + p + _i + " +k=1" + y + m + d + _ + a + r,
                1,
                o + p + Oo + " +k=1" + y + m + d + _ + a + r,
                37,
                l + Mc + kc + Os + es + je + " +y_0=5400000" + b + " +pm=brussels" + a + r,
                280,
                bm + gc + es + " +k_0=1" + $ + m + M + wa + " +pm=bern" + a + r,
                1,
                bm + gc + Ad + " +k_0=1" + N + Ks + M + wa + a + r,
                1,
                bm + gc + Ad + " +k_0=1" + $ + m + M + wa + a + r,
                36,
                c + zs + b + fi + a + r,
                78,
                o + Hc + " +lon_0=-77.08091666666667 +k=1" + Ae + st + b + fi + a + r,
                1,
                o + Hc + " +lon_0=-74.08091666666667 +k=1" + Ae + st + b + fi + a + r,
                1,
                o + Hc + " +lon_0=-71.08091666666667 +k=1" + Ae + st + b + fi + a + r,
                1,
                o + Hc + " +lon_0=-68.08091666666667 +k=1" + Ae + st + b + fi + a + r,
                133,
                c + Xu + z + D + ia + a + r,
                1,
                c + Rl + z + D + ia + a + r,
                58,
                o + p + " +lon_0=11.5" + mt + y + Bt + D + ia + a + r,
                1,
                o + p + Vs + mt + y + Bt + D + ia + a + r,
                79,
                o + q + Fb + " +k=1" + wt + m + i + n + a + r,
                1,
                o + q + Zf + " +k=1" + Dr + m + i + n + a + r,
                1,
                o + q + nm + " +k=1" + Re + m + i + n + a + r,
                1,
                o + q + sy + " +k=1" + cn + m + i + n + a + r,
                1,
                o + q + Ib + " +k=1" + Si + m + i + n + a + r,
                1,
                o + q + IE + " +k=1" + Cl + m + i + n + a + r,
                1,
                o + q + ip + " +k=1" + Js + m + i + n + a + r,
                4,
                o + q + Fb + " +k=1" + wt + m + j + n + a + r,
                1,
                o + q + Zf + " +k=1" + Dr + m + j + n + a + r,
                1,
                o + q + nm + " +k=1" + Re + m + j + n + a + r,
                1,
                o + q + sy + " +k=1" + cn + m + j + n + a + r,
                1,
                o + q + Ib + " +k=1" + Si + m + j + n + a + r,
                1,
                o + q + IE + " +k=1" + Cl + m + j + n + a + r,
                1,
                o + q + ip + " +k=1" + Js + m + j + n + a + r,
                4,
                o + q + Fb + " +k=1" + wt + m + b + ze + a + r,
                1,
                o + q + Zf + " +k=1" + Dr + m + b + ze + a + r,
                1,
                o + q + nm + " +k=1" + Re + m + b + ze + a + r,
                1,
                o + q + sy + " +k=1" + cn + m + b + ze + a + r,
                1,
                o + q + Ib + " +k=1" + Si + m + b + ze + a + r,
                1,
                o + q + IE + " +k=1" + Cl + m + b + ze + a + r,
                1,
                o + q + ip + " +k=1" + Js + m + b + ze + a + r,
                37,
                c + Zh + z + Me + ye + Yt + a + r,
                1,
                c + yc + z + Me + ye + Yt + a + r,
                40,
                o + p + Sa + " +k=1" + $ + m + Ma + Me + ye + Yt + a + r,
                2,
                o + p + wb + " +k=1" + $ + m + Ma + Me + ye + Yt + a + r,
                2,
                o + p + Oy + " +k=1" + $ + m + Ma + Me + ye + Yt + a + r,
                2,
                o + p + ka + " +k=1" + $ + m + Ma + Me + ye + Yt + a + r,
                2,
                o + p + Bg + " +k=1" + $ + m + Ma + Me + ye + Yt + a + r,
                2,
                o + p + Ty + " +k=1" + $ + m + Ma + Me + ye + Yt + a + r,
                2,
                o + p + rs + " +k=1" + $ + m + Ma + Me + ye + Yt + a + r,
                2,
                o + p + " +lon_0=29 +k=1" + $ + m + Ma + Me + ye + Yt + a + r,
                2,
                o + p + Um + " +k=1" + $ + m + Ma + Me + ye + Yt + a + r,
                2,
                o + p + $s + " +k=1" + $ + m + Ma + Me + ye + Yt + a + r,
                39,
                c + Xu + xt + fe + Ea + a + r,
                59,
                l + " +lat_1=36" + ra + " +lon_0=9.9" + Bm + y + Es + xt + fe + Ea + a + r,
                1,
                l + Kg + Xg + " +lon_0=9.9" + pp + y + Es + xt + fe + Ea + a + r,
                129,
                c + Gs + z + b + sa + a + r,
                1,
                c + Mu + z + b + sa + a + r,
                1,
                c + Pf + z + b + sa + a + r,
                1,
                c + Mp + z + b + sa + a + r,
                1,
                c + xp + z + b + sa + a + r,
                175,
                l + yS + " +lat_0=34.65 +lon_0=37.35 +k_0=0.9996256" + ut + Es + xt + fe + Ka + a + r,
                70,
                l + yS + " +lat_0=34.65 +lon_0=37.35 +k_0=0.9996256" + ut + Es + xt + fe + Ka + a + r,
                10,
                ca + " +lat_0=34.2 +lon_0=39.15 +k=0.9995341" + $ + m + xt + fe + Ka + a + r,
                211,
                o + Na + " +lon_0=35 +k=1" + ut + " +y_0=1100000" + Ca + hs + a + r,
                1,
                o + Na + Um + " +k=1 +x_0=615000 +y_0=810000" + Ca + hs + a + r,
                1,
                o + Na + rs + " +k=1" + mi + Ks + Ca + hs + a + r,
                1,
                o + Na + rs + " +k=1" + mi + tb + Ca + hs + a + r,
                34,
                c + cl + b + U + a + r,
                1,
                c + Bl + b + U + a + r,
                1,
                c + gd + b + U + a + r,
                1,
                c + Nm + b + U + a + r,
                1,
                c + Xu + b + U + a + r,
                1,
                c + Rl + b + U + a + r,
                1,
                c + Zh + b + U + a + r,
                1,
                c + yc + b + U + a + r,
                1,
                c + ch + b + U + a + r,
                1,
                c + Ll + b + U + a + r,
                1,
                c + ll + b + U + a + r,
                52,
                o + p + es + mt + y + m + b + U + a + r,
                5,
                o + p + " +lon_0=5" + mt + y + m + b + U + a + r,
                144,
                c + Ku + D + Gh + a + r,
                1,
                c + lh + D + Gh + a + r,
                460,
                bm + " +lat_0=47.14439372222222 +lon_0=19.04857177777778 +k_0=0.99993 +x_0=650000" + Ks + mS + ky + a + r,
                130,
                o + p + " +lon_0=94.5" + A + I + fn + j + n + a + r,
                1,
                o + p + " +lon_0=97.5" + A + I + fn + j + n + a + r,
                1,
                o + p + " +lon_0=100.5" + A + I + fn + j + n + a + r,
                1,
                o + p + " +lon_0=103.5" + A + I + fn + j + n + a + r,
                1,
                o + p + " +lon_0=106.5" + A + I + fn + j + n + a + r,
                1,
                o + p + " +lon_0=109.5" + A + I + fn + j + n + a + r,
                1,
                o + p + " +lon_0=112.5" + A + I + fn + j + n + a + r,
                1,
                o + p + " +lon_0=115.5" + A + I + fn + j + n + a + r,
                1,
                o + p + " +lon_0=118.5" + A + I + fn + j + n + a + r,
                1,
                o + p + " +lon_0=121.5" + A + I + fn + j + n + a + r,
                1,
                o + p + " +lon_0=124.5" + A + I + fn + j + n + a + r,
                1,
                o + p + um + A + I + fn + j + n + a + r,
                1,
                o + p + " +lon_0=130.5" + A + I + fn + j + n + a + r,
                1,
                o + p + eb + A + I + fn + j + n + a + r,
                1,
                o + p + " +lon_0=136.5" + A + I + fn + j + n + a + r,
                1,
                o + p + " +lon_0=139.5" + A + I + fn + j + n + a + r,
                1,
                c + Dm + nu + Oe + Vt + a + r,
                1,
                c + kp + nu + Oe + Vt + a + r,
                1,
                c + hh + nu + Oe + Vt + a + r,
                1,
                c + ph + nu + Oe + Vt + a + r,
                1,
                c + Yh + nu + Oe + Vt + a + r,
                1,
                c + fh + nu + Oe + Vt + a + r,
                1,
                c + Kh + nu + Oe + Vt + a + r,
                14,
                c + Dm + j + n + a + r,
                1,
                c + kp + j + n + a + r,
                1,
                c + hh + j + n + a + r,
                1,
                c + ph + j + n + a + r,
                1,
                c + Yh + j + n + a + r,
                1,
                c + fh + j + n + a + r,
                1,
                c + Kh + j + n + a + r,
                5,
                c + kp + z + j + n + a + r,
                1,
                c + hh + z + j + n + a + r,
                1,
                c + ph + z + j + n + a + r,
                1,
                c + Yh + z + j + n + a + r,
                1,
                c + fh + z + j + n + a + r,
                1,
                c + Kh + z + j + n + a + r,
                1,
                c + xd + z + j + n + a + r,
                1,
                c + Ep + z + j + n + a + r,
                3,
                c + kp + z + nu + Oe + Vt + a + r,
                1,
                c + hh + z + nu + Oe + Vt + a + r,
                1,
                c + ph + z + nu + Oe + Vt + a + r,
                1,
                c + Yh + z + nu + Oe + Vt + a + r,
                1,
                c + fh + z + nu + Oe + Vt + a + r,
                1,
                c + Kh + z + nu + Oe + Vt + a + r,
                1,
                c + xd + z + nu + Oe + Vt + a + r,
                1,
                c + Ep + z + nu + Oe + Vt + a + r,
                52,
                c + Dm + Ze + Kt + el + a + r,
                1,
                c + kp + Ze + Kt + el + a + r,
                1,
                c + hh + Ze + Kt + el + a + r,
                99,
                c + kp + Ze + Kt + Hh + a + r,
                1,
                c + hh + Ze + Kt + Hh + a + r,
                52,
                l + " +lat_1=18" + Jp + cf + " +k_0=1 +x_0=167638.49597 +y_0=121918.90616" + Ey + Sy + Hf + r,
                100,
                l + " +lat_1=18" + Jp + cf + " +k_0=1" + We + " +y_0=150000" + B + Sv + a + r,
                105,
                c + Yv + Ze + Kt + tl + a + r,
                1,
                c + Dm + Ze + Kt + tl + a + r,
                5,
                c + Ky + _f + Cs + aa + a + r,
                1,
                c + Xy + _f + Cs + aa + a + r,
                1,
                c + Ig + _f + Cs + aa + a + r,
                29,
                c + Xy + Da + mr + ge + a + r,
                1,
                c + Ig + Da + mr + ge + a + r,
                1,
                c + Zv + Da + mr + ge + a + r,
                1,
                c + Yv + Da + mr + ge + a + r,
                1,
                c + Dm + Da + mr + ge + a + r,
                1,
                c + kp + Da + mr + ge + a + r,
                23,
                l + Yg + " +lat_0=39.5 +lon_0=68 +k_0=0.99846154 +x_0=2153865.73916853 +y_0=2368292.194628102" + Ja + ja + la + r,
                1,
                l + py + mf + " +lon_0=68" + Go + sl + ul + Ja + ja + la + r,
                1,
                l + Cb + ru + " +lon_0=74" + Go + sl + ul + Ja + ja + la + r,
                1,
                l + " +lat_1=19 +lat_0=19 +lon_0=80" + Go + sl + ul + Ja + ja + la + r,
                1,
                l + " +lat_1=12 +lat_0=12 +lon_0=80" + Go + sl + ul + Ja + ja + la + r,
                1,
                l + Cb + ru + Ds + Go + " +x_0=2743185.69 +y_0=914395.23" + Ze + Kt + tl + a + r,
                1,
                l + py + mf + " +lon_0=68" + Go + " +x_0=2743196.4 +y_0=914398.8" + _f + Cs + aa + a + r,
                1,
                l + Cb + ru + " +lon_0=74" + Go + " +x_0=2743196.4 +y_0=914398.8" + _f + Cs + aa + a + r,
                1,
                l + py + mf + " +lon_0=68" + Go + Kd + Xm + Da + mr + ge + a + r,
                1,
                l + Cb + ru + " +lon_0=74" + Go + Kd + Xm + Da + mr + ge + a + r,
                1,
                l + Cb + ru + Ds + Go + Kd + Xm + Da + mr + ge + a + r,
                1,
                l + " +lat_1=19 +lat_0=19 +lon_0=80" + Go + Kd + Xm + Da + mr + ge + a + r,
                1,
                l + Cb + ru + Ds + Go + sl + ul + Ja + ja + la + r,
                1,
                l + " +lat_1=12 +lat_0=12 +lon_0=80" + Go + Kd + Xm + Da + mr + ge + a + r,
                117,
                Tr + " +lat_0=1.287646666666667 +lon_0=103.8530022222222" + HE + " +y_0=30000" + ea + Ye + be + a + r,
                47,
                c + kp + ea + Ye + be + a + r,
                1,
                c + hh + ea + Ye + be + a + r,
                52,
                l + py + mf + rl + Jd + wt + fS + D + iy + a + r,
                118,
                c + zs + b + ys + a + r,
                1,
                c + _s + b + ys + a + r,
                1,
                c + Ua + b + ys + a + r,
                97,
                c + _u + b + At + a + r,
                1,
                c + zs + b + At + a + r,
                1,
                c + _s + b + At + a + r,
                1,
                c + Ua + b + At + a + r,
                1,
                c + Gs + b + At + a + r,
                56,
                c + _u + z + b + At + a + r,
                1,
                c + zs + z + b + At + a + r,
                1,
                c + _s + z + b + At + a + r,
                1,
                c + Ua + z + b + At + a + r,
                1,
                c + Gs + z + b + At + a + r,
                1,
                c + Mu + z + b + At + a + r,
                9,
                o + " +lat_0=-6 +lon_0=-80.5 +k=0.99983008 +x_0=222000 +y_0=1426834.743" + b + At + a + r,
                1,
                o + " +lat_0=-9.5 +lon_0=-76 +k=0.99932994 +x_0=720000 +y_0=1039979.159" + b + At + a + r,
                1,
                o + " +lat_0=-9.5" + Xs + " +k=0.99952992 +x_0=1324000 +y_0=1040084.558" + b + At + a + r,
                107,
                o + rw + " +lon_0=-1" + yg + " +x_0=274319.51" + m + D + Bv + a + r,
                231,
                c + Nm + xt + fe + a + r,
                160,
                o + p + Do + fr + y + m + B + $o + a + r,
                1,
                o + p + kE + fr + y + m + B + $o + a + r,
                1,
                o + p + NE + fr + y + m + B + $o + a + r,
                1,
                o + p + Io + fr + y + m + B + $o + a + r,
                1,
                o + p + mg + fr + y + m + B + $o + a + r,
                433,
                c + cl + i + n + a + r,
                1,
                c + Bl + i + n + a + r,
                1,
                c + gd + i + n + a + r,
                1,
                c + Nm + i + n + a + r,
                1,
                c + Xu + i + n + a + r,
                1,
                c + Rl + i + n + a + r,
                1,
                c + Zh + i + n + a + r,
                1,
                c + yc + i + n + a + r,
                1,
                c + ch + i + n + a + r,
                1,
                c + Ll + i + n + a + r,
                47,
                o + p + Zs + mt + y + m + i + n + a + r,
                48,
                c + Xu + z + b + ty + a + r,
                259,
                l + Kg + Xg + WA + pp + y + Es + xt + fe + tu + a + r,
                1,
                l + " +lat_1=29.7 +lat_0=29.7" + WA + " +k_0=0.9996155960000001" + y + Es + xt + fe + tu + a + r,
                2,
                l + " +lat_1=26.1 +lat_0=26.1" + WA + " +k_0=0.999616304 +x_0=1200000" + Du + xt + fe + tu + a + r,
                1,
                l + " +lat_1=22.5 +lat_0=22.5" + WA + " +k_0=0.999616437" + wt + Du + xt + fe + tu + a + r,
                42,
                c + Ll + M + Vv + a + r,
                94,
                c + Nm + D + ua + a + r,
                1,
                c + Xu + D + ua + a + r,
                59,
                o + oy + " +lon_0=4.5" + yg + " +x_0=230738.26" + m + D + ua + a + r,
                1,
                o + oy + " +lon_0=8.5" + yg + " +x_0=670553.98" + m + D + ua + a + r,
                1,
                o + oy + " +lon_0=12.5" + yg + " +x_0=1110369.7" + m + D + ua + a + r,
                239,
                c + Xu + xt + fe + Wh + a + r,
                60,
                c + Xu + z + xt + fe + Wh + a + r,
                9,
                c + Og + S + a + r,
                1,
                c + qv + S + a + r,
                1,
                c + uA + S + a + r,
                1,
                c + Gv + S + a + r,
                1,
                c + Cy + S + a + r,
                1,
                c + lg + S + a + r,
                1,
                c + Dy + S + a + r,
                1,
                c + Uv + S + a + r,
                1,
                c + zv + S + a + r,
                1,
                c + Cm + S + a + r,
                1,
                c + wp + S + a + r,
                1,
                c + _p + S + a + r,
                1,
                c + Ap + S + a + r,
                1,
                c + Sp + S + a + r,
                1,
                c + $h + S + a + r,
                1,
                c + Vh + S + a + r,
                1,
                c + _u + S + a + r,
                1,
                c + zs + S + a + r,
                1,
                c + _s + S + a + r,
                1,
                c + Ua + S + a + r,
                1,
                c + Gs + S + a + r,
                1,
                c + Mu + S + a + r,
                7,
                o + cu + su + em + T + m + S + f + r,
                1,
                o + Na + Vp + ie + T + m + S + f + r,
                1,
                yr + " +lat_0=57" + Nc + Cc + A + " +x_0=5000000.001016002 +y_0=-5000000.001016002" + ql + ma + S + f + r,
                1,
                o + jo + _A + A + T + m + S + f + r,
                1,
                o + jo + AA + A + T + m + S + f + r,
                1,
                o + jo + zp + A + T + m + S + f + r,
                1,
                o + jo + Ah + A + T + m + S + f + r,
                1,
                o + jo + Hl + A + T + m + S + f + r,
                1,
                o + jo + EA + A + " +x_0=213360.4267208534" + m + S + f + r,
                1,
                o + jo + SA + A + T + m + S + f + r,
                1,
                o + jo + Gg + A + _m + m + S + f + r,
                1,
                l + Dc + Oc + kb + MA + $e + m + S + f + r,
                1,
                l + gn + Al + J + za + k + m + S + f + r,
                1,
                l + vn + bn + tt + za + k + m + S + f + r,
                1,
                l + Ut + xn + yh + lt + k + m + S + f + r,
                1,
                l + Zc + Gm + wn + gh + k + m + S + f + r,
                1,
                l + _n + An + vh + Cu + k + m + S + f + r,
                1,
                l + En + Sn + Mn + Pu + k + m + S + f + r,
                2,
                o + Ie + Ir + A + T + m + S + f + r,
                1,
                o + Ie + Br + A + T + m + S + f + r,
                1,
                o + Ie + Fu + ie + T + m + S + f + r,
                1,
                l + Hn + Wn + te + Ws + k + m + S + f + r,
                1,
                l + $n + wh + Vn + Ws + k + m + S + f + r,
                1,
                l + " +lat_1=39.71666666666667 +lat_2=40.78333333333333" + J + Ee + k + m + S + f + r,
                1,
                l + Yc + Kc + xr + Ee + k + m + S + f + r,
                1,
                l + Ut + kn + F + Ee + k + m + S + f + r,
                1,
                l + Nn + bh + Cn + Ml + _m + m + S + f + r,
                1,
                o + Cr + jr + xh + T + m + S + f + r,
                1,
                o + zt + pr + Rt + T + m + S + f + r,
                1,
                o + zt + rd + Rt + T + m + S + f + r,
                1,
                l + Xc + Dn + Hm + Jc + k + m + S + f + r,
                6,
                o + Na + Rr + A + T + m + S + f + r,
                1,
                o + Na + Lr + A + T + m + S + f + r,
                1,
                o + G + qr + se + T + m + S + f + r,
                1,
                o + G + fl + se + T + m + S + f + r,
                1,
                o + G + Iu + ie + T + m + S + f + r,
                1,
                o + F + Vr + li + T + m + S + f + r,
                1,
                o + F + Zr + Rt + T + m + S + f + r,
                1,
                o + sn + Yr + dt + T + m + S + f + r,
                1,
                o + sn + Kr + dt + T + m + S + f + r,
                1,
                l + Zn + Yn + To + Ko + k + m + S + f + r,
                1,
                l + Et + Kn + Bo + Ko + k + m + S + f + r,
                1,
                l + Xn + Jn + yt + Co + k + m + S + f + r,
                1,
                l + Qn + ti + F + gr + k + m + S + f + r,
                1,
                l + Xt + yn + sn + El + k + m + S + f + r,
                1,
                l + " +lat_1=36.73333333333333 +lat_2=37.93333333333333" + et + gi + k + m + S + f + r,
                1,
                l + " +lat_1=31.16666666666667 +lat_2=32.66666666666666 +lat_0=30.66666666666667" + xs + k + m + S + f + r,
                1,
                l + " +lat_1=29.3 +lat_2=30.7 +lat_0=28.66666666666667" + Te + k + m + S + f + r,
                1,
                o + ft + Xa + A + T + m + S + f + r,
                1,
                o + ee + Xr + dt + T + m + S + f + r,
                1,
                l + " +lat_1=38.3 +lat_2=39.45" + xr + cf + " +x_0=243840.4876809754" + m + S + f + r,
                1,
                l + " +lat_1=41.71666666666667 +lat_2=42.68333333333333" + ku + Zo + _m + m + S + f + r,
                1,
                l + " +lat_1=41.28333333333333 +lat_2=41.48333333333333" + ku + Xs + " +x_0=60960.12192024384" + m + S + f + r,
                4,
                l + " +lat_1=47.03333333333333 +lat_2=48.63333333333333" + Nu + Jr + k + m + S + f + r,
                1,
                l + " +lat_1=45.61666666666667 +lat_2=47.05" + eu + Nl + k + m + S + f + r,
                1,
                l + " +lat_1=43.78333333333333 +lat_2=45.21666666666667" + hp + np + k + m + S + f + r,
                1,
                o + Ar + Ur + em + T + m + S + f + r,
                1,
                o + cu + Ve + Rt + T + m + S + f + r,
                1,
                o + Sr + Uy + ie + T + m + S + f + r,
                1,
                o + Sr + xs + ie + T + m + S + f + r,
                1,
                o + mu + zy + Rt + T + m + S + f + r,
                1,
                l + " +lat_1=34.41666666666666 +lat_2=33.86666666666667 +lat_0=34.13333333333333" + uu + " +x_0=1276106.450596901 +y_0=1268253.006858014" + S + f + r,
                48,
                o + ct + Xa + A + ne + m + i + n + f + r,
                1,
                o + ee + Xr + dt + ss + m + i + n + f + r,
                1,
                l + fo + ho + Nu + Jr + Lt + qt + i + n + f + r,
                1,
                l + oh + po + eu + Nl + Lt + qt + i + n + f + r,
                1,
                l + mo + yo + hp + np + Lt + qt + i + n + f + r,
                1,
                l + nl + Al + go + dr + at + m + i + n + f + r,
                1,
                l + ah + By + _h + ya + N + m + i + n + f + r,
                1,
                l + Eo + So + Zm + pr + N + m + i + n + f + r,
                1,
                o + ct + Xa + A + ne + m + i + n + f + r,
                1,
                o + ee + Xr + dt + ss + m + i + n + f + r,
                1,
                l + fo + ho + Nu + Jr + Lt + qt + i + n + f + r,
                1,
                l + oh + po + eu + Nl + Lt + qt + i + n + f + r,
                1,
                l + mo + yo + hp + np + Lt + qt + i + n + f + r,
                1,
                l + nl + Al + go + dr + at + m + i + n + f + r,
                1,
                l + ah + By + _h + ya + N + m + i + n + f + r,
                1,
                l + Eo + So + Zm + pr + N + m + i + n + f + r,
                1,
                o + ct + Xa + A + ne + m + i + n + f + r,
                1,
                o + ee + Xr + dt + ss + m + i + n + f + r,
                1,
                l + fo + ho + Nu + Jr + Lt + qt + i + n + f + r,
                1,
                l + oh + po + eu + Nl + Lt + qt + i + n + f + r,
                1,
                l + mo + yo + hp + np + Lt + qt + i + n + f + r,
                1,
                l + nl + Al + go + dr + at + m + i + n + f + r,
                1,
                l + ah + By + _h + ya + N + m + i + n + f + r,
                1,
                l + Eo + So + Zm + pr + N + m + i + n + f + r,
                21,
                o + p + hi + A + kt + m + i + n + a + r,
                1,
                o + p + pr + A + kt + m + i + n + a + r,
                1,
                o + p + Jh + A + kt + m + i + n + a + r,
                1,
                o + p + gl + A + kt + m + i + n + a + r,
                1,
                o + p + He + A + kt + m + i + n + a + r,
                1,
                o + p + pg + A + kt + m + i + n + a + r,
                1,
                o + p + td + A + kt + m + i + n + a + r,
                1,
                o + p + " +lon_0=-53" + A + kt + m + i + n + a + r,
                1,
                o + p + BE + A + kt + m + i + n + a + r,
                2,
                c + Og + i + n + a + r,
                1,
                c + qv + i + n + a + r,
                1,
                c + uA + i + n + a + r,
                1,
                c + Gv + i + n + a + r,
                1,
                c + Cy + i + n + a + r,
                1,
                c + lg + i + n + a + r,
                1,
                c + Dy + i + n + a + r,
                1,
                c + Uv + i + n + a + r,
                1,
                c + zv + i + n + a + r,
                1,
                c + Cm + i + n + a + r,
                1,
                c + wp + i + n + a + r,
                1,
                c + _p + i + n + a + r,
                1,
                c + Ap + i + n + a + r,
                1,
                c + Sp + i + n + a + r,
                1,
                c + $h + i + n + a + r,
                1,
                c + Vh + i + n + a + r,
                1,
                c + _u + i + n + a + r,
                1,
                c + zs + i + n + a + r,
                1,
                c + _s + i + n + a + r,
                1,
                c + Ua + i + n + a + r,
                1,
                c + Gs + i + n + a + r,
                1,
                c + Mu + i + n + a + r,
                1,
                c + Pf + i + n + a + r,
                6,
                o + cu + su + em + I + m + i + n + a + r,
                1,
                o + Na + Vp + ie + N + m + i + n + a + r,
                1,
                yr + " +lat_0=57" + Nc + Cc + A + nf + si + ql + ma + i + n + a + r,
                1,
                o + jo + _A + A + y + m + i + n + a + r,
                1,
                o + jo + AA + A + y + m + i + n + a + r,
                1,
                o + jo + zp + A + y + m + i + n + a + r,
                1,
                o + jo + Ah + A + y + m + i + n + a + r,
                1,
                o + jo + Hl + A + y + m + i + n + a + r,
                1,
                o + jo + EA + A + y + m + i + n + a + r,
                1,
                o + jo + SA + A + y + m + i + n + a + r,
                1,
                o + jo + Gg + A + y + m + i + n + a + r,
                1,
                l + Dc + Oc + kb + MA + Ae + m + i + n + a + r,
                1,
                l + gn + Al + J + za + ke + Dt + i + n + a + r,
                1,
                l + vn + bn + tt + za + ke + Dt + i + n + a + r,
                1,
                l + Ut + xn + yh + lt + ke + Dt + i + n + a + r,
                1,
                l + Zc + Gm + wn + gh + ke + Dt + i + n + a + r,
                1,
                l + _n + An + vh + Cu + ke + Dt + i + n + a + r,
                1,
                l + En + Sn + Mn + Pu + ke + Dt + i + n + a + r,
                2,
                o + Ie + Ir + A + yi + m + i + n + a + r,
                1,
                o + Ie + Br + A + yi + m + i + n + a + r,
                1,
                o + Ie + Fu + ie + yi + m + i + n + a + r,
                1,
                l + Hn + Wn + te + Ws + Z + m + i + n + a + r,
                1,
                l + $n + wh + Vn + Ws + Z + Du + i + n + a + r,
                1,
                l + Mi + ki + J + Ee + qo + Uo + i + n + a + r,
                1,
                l + Yc + Kc + xr + Ee + qo + Uo + i + n + a + r,
                1,
                l + Ut + kn + F + Ee + qo + Uo + i + n + a + r,
                1,
                l + Nn + bh + Cn + Ml + Om + Tm + i + n + a + r,
                1,
                o + Cr + jr + xh + I + m + i + n + a + r,
                1,
                o + zt + pr + Rt + I + m + i + n + a + r,
                1,
                o + zt + rd + Rt + I + m + i + n + a + r,
                1,
                l + Xc + Dn + Hm + Jc + N + m + i + n + a + r,
                1,
                o + wc + Jg + dt + y + m + i + n + a + r,
                1,
                o + _c + Kl + dt + y + m + i + n + a + r,
                1,
                o + fa + Hl + wl + y + m + i + n + a + r,
                1,
                o + Ac + Qg + wl + y + m + i + n + a + r,
                1,
                o + Ec + Xl + " +k=1" + y + m + i + n + a + r,
                1,
                o + Na + Rr + A + I + m + i + n + a + r,
                1,
                o + Na + Lr + A + mi + m + i + n + a + r,
                1,
                o + G + qr + se + I + m + i + n + a + r,
                1,
                o + G + fl + se + y + m + i + n + a + r,
                1,
                o + G + Iu + ie + br + m + i + n + a + r,
                1,
                o + F + Vr + li + ut + m + i + n + a + r,
                1,
                o + F + Zr + Rt + mi + m + i + n + a + r,
                1,
                o + sn + Yr + dt + ve + Wl + i + n + a + r,
                1,
                o + sn + Kr + dt + ss + Wl + i + n + a + r,
                1,
                l + Zn + Yn + To + Ko + wt + st + i + n + a + r,
                1,
                l + Et + Kn + Bo + Ko + y + m + i + n + a + r,
                1,
                l + Xn + Jn + yt + Co + Z + m + i + n + a + r,
                1,
                l + Qn + ti + F + gr + Z + Du + i + n + a + r,
                2,
                l + Ni + Ci + et + gi + y + Dt + i + n + a + r,
                1,
                l + lo + co + cu + xs + Ae + m + i + n + a + r,
                1,
                l + Bp + jp + Rp + Te + Ae + m + i + n + a + r,
                1,
                o + ct + Xa + A + ut + m + i + n + a + r,
                1,
                o + ee + Xr + dt + ss + m + i + n + a + r,
                1,
                l + Qf + Np + tt + cf + Z + m + i + n + a + r,
                1,
                l + Di + On + ku + Zo + I + mh + i + n + a + r,
                1,
                l + Oi + Ti + ku + Xs + y + m + i + n + a + r,
                1,
                l + Fi + Pi + Ii + gl + rb + m + i + n + a + r,
                1,
                l + Cp + Bi + ji + re + lm + m + i + n + a + r,
                1,
                l + qe + Dp + To + re + tf + m + i + n + a + r,
                1,
                l + fo + ho + Nu + Jr + br + ni + i + n + a + r,
                1,
                l + oh + po + eu + Nl + br + ni + i + n + a + r,
                1,
                l + mo + yo + hp + np + br + ni + i + n + a + r,
                1,
                o + As + Ur + fr + ut + m + i + n + a + r,
                1,
                o + As + Ve + fr + mi + m + i + n + a + r,
                1,
                o + Sr + Uy + ie + We + m + i + n + a + r,
                1,
                o + Sr + xs + ie + y + m + i + n + a + r,
                1,
                o + mu + zy + Rt + fA + m + i + n + a + r,
                41,
                c + Ku + D + ln + a + r,
                1,
                c + lh + D + ln + a + r,
                80,
                c + Ua + b + jv + a + r,
                80,
                "+proj=nzmg +lat_0=-41 +lon_0=173 +x_0=2510000 +y_0=6023150" + b + E + a + r,
                5,
                o + " +lat_0=-36.87986527777778 +lon_0=174.7643393611111" + A + ut + un + b + E + a + r,
                1,
                o + " +lat_0=-37.76124980555556 +lon_0=176.46619725 +k=1" + ut + un + b + E + a + r,
                1,
                o + " +lat_0=-38.62470277777778 +lon_0=177.8856362777778 +k=1" + ut + un + b + E + a + r,
                1,
                o + " +lat_0=-39.65092930555556 +lon_0=176.6736805277778 +k=1" + ut + un + b + E + a + r,
                1,
                o + " +lat_0=-39.13575830555556 +lon_0=174.22801175 +k=1" + ut + un + b + E + a + r,
                1,
                o + " +lat_0=-39.51247038888889 +lon_0=175.6400368055556 +k=1" + ut + un + b + E + a + r,
                1,
                o + " +lat_0=-40.24194713888889 +lon_0=175.4880996111111 +k=1" + ut + un + b + E + a + r,
                1,
                o + " +lat_0=-40.92553263888889 +lon_0=175.6473496666667 +k=1" + ut + un + b + E + a + r,
                1,
                o + " +lat_0=-41.30131963888888 +lon_0=174.7766231111111 +k=1" + ut + un + b + E + a + r,
                1,
                o + " +lat_0=-40.71475905555556 +lon_0=172.6720465 +k=1" + ut + un + b + E + a + r,
                1,
                o + " +lat_0=-41.27454472222222 +lon_0=173.2993168055555 +k=1" + ut + un + b + E + a + r,
                1,
                o + " +lat_0=-41.28991152777778 +lon_0=172.1090281944444 +k=1" + ut + un + b + E + a + r,
                1,
                o + " +lat_0=-41.81080286111111 +lon_0=171.5812600555556 +k=1" + ut + un + b + E + a + r,
                1,
                o + " +lat_0=-42.33369427777778 +lon_0=171.5497713055556 +k=1" + ut + un + b + E + a + r,
                1,
                o + " +lat_0=-42.68911658333333 +lon_0=173.0101333888889 +k=1" + ut + un + b + E + a + r,
                1,
                o + " +lat_0=-41.54448666666666 +lon_0=173.8020741111111 +k=1" + ut + un + b + E + a + r,
                1,
                o + " +lat_0=-42.88632236111111 +lon_0=170.9799935 +k=1" + ut + un + b + E + a + r,
                1,
                o + " +lat_0=-43.11012813888889 +lon_0=170.2609258333333 +k=1" + ut + un + b + E + a + r,
                1,
                o + " +lat_0=-43.97780288888889 +lon_0=168.606267 +k=1" + ut + un + b + E + a + r,
                1,
                o + " +lat_0=-43.59063758333333 +lon_0=172.7271935833333 +k=1" + ut + un + b + E + a + r,
                1,
                o + " +lat_0=-43.74871155555556 +lon_0=171.3607484722222 +k=1" + ut + un + b + E + a + r,
                1,
                o + " +lat_0=-44.40222036111111 +lon_0=171.0572508333333 +k=1" + ut + un + b + E + a + r,
                1,
                o + " +lat_0=-44.73526797222222 +lon_0=169.4677550833333 +k=1" + ut + un + b + E + a + r,
                1,
                o + " +lat_0=-45.13290258333333 +lon_0=168.3986411944444 +k=1" + ut + un + b + E + a + r,
                1,
                o + " +lat_0=-45.56372616666666 +lon_0=167.7388617777778 +k=1" + ut + un + b + E + a + r,
                1,
                o + " +lat_0=-45.81619661111111 +lon_0=170.6285951666667 +k=1" + ut + un + b + E + a + r,
                1,
                o + " +lat_0=-45.86151336111111 +lon_0=170.2825891111111" + em + ut + un + b + E + a + r,
                1,
                o + " +lat_0=-46.60000961111111 +lon_0=168.342872 +k=1 +x_0=300002.66 +y_0=699999.58" + b + E + a + r,
                26,
                c + Ff + z + b + E + a + r,
                1,
                c + bp + z + b + E + a + r,
                1,
                c + Rd + z + b + E + a + r,
                31,
                o + " +lat_0=-39 +lon_0=175.5 +k=1 +x_0=274319.5243848086 +y_0=365759.3658464114" + b + E + Lv + r,
                1,
                o + FE + " +lon_0=171.5 +k=1 +x_0=457199.2073080143 +y_0=457199.2073080143" + b + E + Lv + r,
                99,
                o + No + " +lon_0=-4.666666666666667 +k=1" + $ + m + ks + ii + Mt + Pg + a + r,
                1,
                o + No + " +lon_0=-2.333333333333333 +k=1" + $ + m + ks + ii + Mt + Pg + a + r,
                1,
                o + No + es + " +k=1" + $ + m + ks + ii + Mt + Pg + a + r,
                1,
                o + No + " +lon_0=2.5 +k=1" + $ + m + ks + ii + Mt + Pg + a + r,
                1,
                o + No + iw + " +k=1" + $ + m + ks + ii + Mt + Pg + a + r,
                1,
                o + No + " +lon_0=10.16666666666667 +k=1" + $ + m + ks + ii + Mt + Pg + a + r,
                1,
                o + No + " +lon_0=14.16666666666667 +k=1" + $ + m + ks + ii + Mt + Pg + a + r,
                1,
                o + No + " +lon_0=18.33333333333333 +k=1" + $ + m + ks + ii + Mt + Pg + a + r,
                31,
                c + Bl + b + Yu + a + r,
                64,
                o + _e + zb + " +k=1 +x_0=180.598 +y_0=-86.98999999999999" + b + Yu + a + r,
                7,
                l + Dd + Od + " +lon_0=5.399999999999999 +k_0=0.99950908" + y + Es + " +a=6376523" + Ay + bE + a + r,
                61,
                l + Dd + Od + es + " +k_0=0.999877341" + N + Ks + xt + fe + Pe + Nf + a + r,
                1,
                l + " +lat_1=46.8 +lat_0=46.8" + es + " +k_0=0.99987742" + N + Ks + xt + fe + Pe + Nf + a + r,
                1,
                l + rA + nA + es + " +k_0=0.999877499" + N + Ks + xt + fe + Pe + Nf + a + r,
                1,
                l + iA + oA + es + " +k_0=0.99994471 +x_0=234.358 +y_0=185861.369" + xt + fe + Pe + Nf + a + r,
                7,
                l + Dd + Od + es + " +k_0=0.999877341" + N + tb + xt + fe + Pe + Nf + a + r,
                1,
                l + " +lat_1=46.8 +lat_0=46.8" + es + " +k_0=0.99987742" + N + " +y_0=2200000" + xt + fe + Pe + Nf + a + r,
                1,
                l + rA + nA + es + " +k_0=0.999877499" + N + " +y_0=3200000" + xt + fe + Pe + Nf + a + r,
                1,
                l + iA + oA + es + " +k_0=0.99994471 +x_0=234.358 +y_0=4185861.369" + xt + fe + Pe + Nf + a + r,
                126,
                o + " +lat_0=49 +lon_0=-2 +k=0.9996012717" + Z + " +y_0=-100000" + Zd + Df + a + r,
                491,
                Tr + Uc + zc + xy + " +y_0=126867.909" + op + ap + pn + a + r,
                1,
                o + Uc + zc + " +k=1" + xy + " +y_0=1126867.909" + op + ap + pn + a + r,
                1,
                Tr + Uc + zc + xy + " +y_0=1126867.909" + op + ap + pn + a + r,
                39,
                c + Xu + z + xt + fe + Mv + a + r,
                116,
                c + hh + z + i + n + a + r,
                1,
                c + ph + z + i + n + a + r,
                1,
                c + Yh + z + i + n + a + r,
                1,
                c + fh + z + i + n + a + r,
                1,
                c + Kh + z + i + n + a + r,
                1,
                c + xd + z + i + n + a + r,
                1,
                c + Ep + z + i + n + a + r,
                1,
                c + Ld + z + i + n + a + r,
                1,
                c + Qy + z + i + n + a + r,
                1,
                c + Fg + z + i + n + a + r,
                1,
                c + Ff + z + i + n + a + r,
                46,
                o + p + ka + " +k=1" + cn + m + d + s + a + r,
                1,
                o + p + rs + " +k=1" + Si + m + d + s + a + r,
                1,
                o + p + $s + " +k=1" + Cl + m + d + s + a + r,
                1,
                o + p + Vc + " +k=1" + Js + m + d + s + a + r,
                1,
                o + p + rl + " +k=1" + Xf + m + d + s + a + r,
                1,
                o + p + Wd + " +k=1" + Jf + m + d + s + a + r,
                1,
                o + p + Py + " +k=1" + of + m + d + s + a + r,
                1,
                o + p + Vm + " +k=1" + Sl + m + d + s + a + r,
                1,
                o + p + Iy + " +k=1" + af + m + d + s + a + r,
                1,
                o + p + ns + " +k=1" + us + m + d + s + a + r,
                1,
                o + p + is + " +k=1" + Ra + m + d + s + a + r,
                1,
                o + p + gs + " +k=1" + Ps + m + d + s + a + r,
                1,
                o + p + os + " +k=1" + Is + m + d + s + a + r,
                1,
                o + p + as + " +k=1" + Ou + m + d + s + a + r,
                1,
                o + p + ai + " +k=1" + Ts + m + d + s + a + r,
                1,
                o + p + zo + " +k=1" + Fs + m + d + s + a + r,
                1,
                o + p + Do + " +k=1" + ls + m + d + s + a + r,
                1,
                o + p + Io + " +k=1" + Bs + m + d + s + a + r,
                1,
                o + p + _i + " +k=1" + cs + m + d + s + a + r,
                1,
                o + p + Oo + " +k=1" + js + m + d + s + a + r,
                1,
                o + p + im + " +k=1" + sf + m + d + s + a + r,
                1,
                o + p + id + " +k=1" + Rs + m + d + s + a + r,
                1,
                o + p + ep + " +k=1" + Ls + m + d + s + a + r,
                1,
                o + p + om + " +k=1" + qs + m + d + s + a + r,
                1,
                o + p + rp + " +k=1" + Us + m + d + s + a + r,
                1,
                o + p + hf + " +k=1" + La + m + d + s + a + r,
                1,
                o + p + zl + " +k=1" + ou + m + d + s + a + r,
                1,
                o + p + Gl + " +k=1" + va + m + d + s + a + r,
                1,
                o + p + df + " +k=1" + au + m + d + s + a + r,
                168,
                o + " +lat_0=24.45" + uw + wl + I + Es + b + Lm + a + r,
                391,
                ca + aA + YA + " +k=0.9999079" + $ + m + M + Lo + a + r,
                1,
                ca + aA + YA + " +k=0.9999079 +x_0=155000 +y_0=463000" + M + Lo + a + r,
                109,
                jb + p + ip + nf + Bt + X + jt + a + r,
                67,
                c + zs + X + jt + a + r,
                1,
                c + _s + X + jt + a + r,
                1,
                c + Ua + X + jt + a + r,
                1,
                c + Gs + X + jt + a + r,
                1,
                c + Mu + X + jt + a + r,
                15,
                c + _u + z + X + jt + a + r,
                1,
                c + zs + z + X + jt + a + r,
                1,
                c + _s + z + X + jt + a + r,
                1,
                c + Ua + z + X + jt + a + r,
                1,
                c + Gs + z + X + jt + a + r,
                1,
                c + Mu + z + X + jt + a + r,
                1,
                c + Pf + z + X + jt + a + r,
                1,
                c + Mp + z + X + jt + a + r,
                1,
                c + xp + z + X + jt + a + r,
                25,
                c + Ua + z + b + yp + a + r,
                1,
                c + Gs + z + b + yp + a + r,
                112,
                c + Rl + z + Ga + Ge + a + r,
                38,
                o + sm + " +lon_0=11 +k=1" + $ + m + Ma + Ga + Ge + ta + r,
                2,
                o + sm + " +lon_0=13 +k=1" + $ + m + Ma + Ga + Ge + ta + r,
                2,
                o + sm + Sa + " +k=1" + $ + m + Ma + Ga + Ge + ta + r,
                2,
                o + sm + wb + " +k=1" + $ + m + Ma + Ga + Ge + ta + r,
                2,
                o + sm + Oy + " +k=1" + $ + m + Ma + Ga + Ge + ta + r,
                2,
                o + sm + ka + " +k=1" + $ + m + Ma + Ga + Ge + ta + r,
                2,
                o + sm + Bg + " +k=1" + $ + m + Ma + Ga + Ge + ta + r,
                2,
                o + sm + Ty + " +k=1" + $ + m + Ma + Ga + Ge + ta + r,
                317,
                yr + " +lat_0=-18.9 +lonc=44.10000000000001 +alpha=18.9" + ui + Z + cr + " +gamma=18.9" + b + Wa + Nf + a + r,
                36,
                c + ll + z + b + Wa + a + r,
                1,
                c + Ku + z + b + Wa + a + r,
                110,
                c + ph + wf + Vo + a + r,
                1,
                c + Yh + wf + Vo + a + r,
                21,
                yr + oy + aE + Td + am + " +x_0=590476.8714630401 +y_0=442857.653094361" + gu + wf + Vo + " +to_meter=20.11676512155263" + r,
                1,
                yr + oy + aE + Td + am + " +x_0=590476.8727431979 +y_0=442857.6545573985" + gu + wf + Vo + " +to_meter=0.3047994715386762" + r,
                1,
                yr + oy + aE + Td + am + " +x_0=590476.87 +y_0=442857.65" + gu + wf + Vo + a + r,
                28,
                o + lA + " +lon_0=-8 +k=1" + I + Wl + Zd + Se + a + r,
                1,
                o + lA + " +lon_0=-8 +k=1.000035" + I + Wl + fd + Se + a + r,
                1,
                o + lA + " +lon_0=-8 +k=1.000035" + I + Wl + fd + Se + a + r,
                258,
                o + $d + iS + A + $ + m + M + P + a + r,
                1,
                o + $d + tp + A + $ + m + M + P + a + r,
                1,
                o + ra + Ed + A + $ + m + M + P + a + r,
                1,
                o + $d + eb + A + $ + m + M + P + a + r,
                1,
                o + ra + Sd + A + $ + m + M + P + a + r,
                1,
                o + ra + gg + A + $ + m + M + P + a + r,
                1,
                o + ra + Md + A + $ + m + M + P + a + r,
                1,
                o + ra + oS + A + $ + m + M + P + a + r,
                1,
                o + ra + kd + A + $ + m + M + P + a + r,
                1,
                o + Bo + Nd + A + $ + m + M + P + a + r,
                1,
                o + fu + dE + A + $ + m + M + P + a + r,
                1,
                o + fu + mE + A + $ + m + M + P + a + r,
                1,
                o + fu + yE + A + $ + m + M + P + a + r,
                1,
                o + ru + " +lon_0=142" + A + $ + m + M + P + a + r,
                1,
                o + ru + um + A + $ + m + M + P + a + r,
                1,
                o + ru + " +lon_0=124" + A + $ + m + M + P + a + r,
                1,
                o + ru + tp + A + $ + m + M + P + a + r,
                1,
                o + " +lat_0=20" + gg + A + $ + m + M + P + a + r,
                1,
                o + ru + EE + A + $ + m + M + P + a + r,
                21,
                Tr + ow + qb + " +x_0=86501.46392051999" + AS + Ai + Ei + Zu + ew + r,
                139,
                c + Ku + Ca + a + r,
                1,
                c + lh + Ca + a + r,
                151,
                l + " +lat_1=36" + ra + Ag + Bm + y + Es + xt + fe + qu + a + r,
                1,
                l + Kg + Xg + Ag + pp + y + Es + xt + fe + qu + a + r,
                1,
                l + " +lat_1=36" + ra + Ag + Bm + y + Es + xt + fe + a + r,
                1,
                l + Kg + Xg + Ag + pp + y + Es + xt + fe + a + r,
                235,
                c + Bl + D + Ot + a + r,
                1,
                c + gd + D + Ot + a + r,
                1,
                c + Nm + D + Ot + a + r,
                1,
                c + Xu + D + Ot + a + r,
                59,
                l + " +lat_1=36" + ra + Ag + Bm + " +x_0=500135 +y_0=300090" + D + Ot + a + r,
                1,
                l + Kg + Xg + Ag + pp + " +x_0=500135 +y_0=300090" + D + Ot + a + r,
                236,
                c + cl + xt + fe + a + r,
                93,
                c + Gs + b + $a + a + r,
                33,
                o + p + ip + mt + y + m + b + $a + a + r,
                16,
                o + p + tw + mt + y + m + b + $a + a + r,
                1,
                o + p + tw + A + y + m + b + $a + a + r,
                80,
                o + p + Ry + " +k=1" + $ + si + M + Zt + Sf + a + r,
                1,
                o + p + Um + " +k=1" + $ + si + M + Zt + Sf + a + r,
                1,
                o + p + pE + " +k=1" + $ + si + M + Zt + Sf + a + r,
                1,
                o + p + Fd + " +k=1" + $ + si + M + Q + a + r,
                1,
                o + p + vu + " +k=1" + $ + si + M + Q + a + r,
                1,
                o + p + Pd + " +k=1" + $ + si + M + Q + a + r,
                1,
                o + p + Fd + " +k=1" + je + si + M + Q + a + r,
                1,
                o + p + vu + " +k=1 +x_0=450000" + si + M + Q + a + r,
                1,
                o + p + Pd + " +k=1" + xA + si + M + Q + a + r,
                22,
                o + p + Ry + " +k=1" + $ + m + M + Zt + Sf + a + r,
                1,
                o + p + Um + " +k=1" + $ + m + M + Zt + Sf + a + r,
                1,
                o + p + pE + " +k=1" + $ + m + M + Zt + Sf + a + r,
                1,
                o + p + Fd + " +k=1" + je + m + M + Q + a + r,
                1,
                o + p + vu + " +k=1 +x_0=450000" + m + M + Q + a + r,
                1,
                o + p + Pd + " +k=1" + xA + m + M + Q + a + r,
                1,
                l + $c + cp + " +lat_0=47.5" + vu + Z + Du + M + Q + a + r,
                1,
                o + p + Ry + " +k=1" + je + m + M + Zt + Sf + a + r,
                1,
                o + p + Um + " +k=1 +x_0=450000" + m + M + Zt + Sf + a + r,
                1,
                o + p + pE + " +k=1" + xA + m + M + Zt + Sf + a + r,
                10,
                l + Mc + kc + Os + " +lon_0=4.356939722222222 +x_0=150000.01256 +y_0=5400088.4378" + b + oa + a + r,
                70,
                l + " +lat_1=51.16666723333333 +lat_2=49.8333339" + Os + " +lon_0=4.367486666666666 +x_0=150000.013 +y_0=5400088.438" + b + oa + a + r,
                96,
                o + p + wE + " +k=1" + Dr + m + M + rt + a + r,
                1,
                o + p + jl + " +k=1" + Re + m + M + rt + a + r,
                1,
                o + p + Vs + " +k=1" + cn + m + M + rt + a + r,
                1,
                o + p + Sa + " +k=1" + Si + m + M + rt + a + r,
                59,
                c + cl + xt + fe + gp + a + r,
                1,
                c + Bl + xt + fe + gp + a + r,
                71,
                ca + " +lat_0=45.9 +lon_0=25.39246588888889 +k=0.9996667" + y + Dt + b + qm + a + r,
                238,
                c + ll + j + Kf + a + r,
                1,
                c + Ku + j + Kf + a + r,
                62,
                o + p + jg + " +k=1" + y + m + i + hg + a + r,
                64,
                c + wp + i + n + a + r,
                1,
                c + _p + i + n + a + r,
                1,
                c + Ap + i + n + a + r,
                1,
                c + Sp + i + n + a + r,
                1,
                c + $h + i + n + a + r,
                1,
                c + Vh + i + n + a + r,
                1,
                c + _u + i + n + a + r,
                1,
                c + zs + i + n + a + r,
                1,
                c + _s + i + n + a + r,
                1,
                c + Ua + i + n + a + r,
                1,
                c + Gs + i + n + a + r,
                1,
                c + Mu + i + n + a + r,
                1,
                c + _u + z + i + n + a + r,
                1,
                c + zs + z + i + n + a + r,
                1,
                c + _s + z + i + n + a + r,
                1,
                c + Ua + z + i + n + a + r,
                1,
                c + Gs + z + i + n + a + r,
                1,
                c + Mu + z + i + n + a + r,
                1,
                c + Pf + z + i + n + a + r,
                1,
                c + Mp + z + i + n + a + r,
                1,
                c + xp + z + i + n + a + r,
                1,
                c + _u + i + n + a + r,
                1,
                c + zs + i + n + a + r,
                1,
                c + _s + i + n + a + r,
                1,
                c + Ua + i + n + a + r,
                1,
                c + Gs + i + n + a + r,
                1,
                c + Mu + i + n + a + r,
                1,
                c + _u + z + i + n + a + r,
                1,
                c + zs + z + i + n + a + r,
                1,
                c + _s + z + i + n + a + r,
                1,
                c + Ua + z + i + n + a + r,
                1,
                c + Gs + z + i + n + a + r,
                1,
                c + Mu + z + i + n + a + r,
                1,
                c + Pf + z + i + n + a + r,
                1,
                c + Mp + z + i + n + a + r,
                1,
                c + xp + z + i + n + a + r,
                1,
                l + " +lat_1=48.71666666666667 +lat_2=47.85" + pu + iu + k + m + S + f + r,
                1,
                l + " +lat_1=47.88333333333333 +lat_2=46.45 +lat_0=45.83333333333334" + iu + k + m + S + f + r,
                1,
                l + " +lat_1=46.4 +lat_2=44.86666666666667" + fu + iu + k + m + S + f + r,
                2,
                l + " +lat_1=41.85 +lat_2=42.81666666666667 +lat_0=41.33333333333334" + dr + k + m + S + f + r,
                1,
                l + " +lat_1=40.28333333333333" + On + _e + " +lon_0=-99.5" + k + m + S + f + r,
                1,
                o + hr + Qr + A + T + m + S + f + r,
                1,
                o + hr + tn + A + T + m + S + f + r,
                1,
                o + hr + en + A + T + m + S + f + r,
                1,
                o + Fo + rn + dt + T + m + S + f + r,
                1,
                o + Jt + " +lon_0=-74.66666666666667" + li + k + m + S + f + r,
                1,
                o + Ie + zr + Ms + T + m + S + f + r,
                1,
                o + Ie + Bu + A + T + m + S + f + r,
                1,
                o + Ie + Gr + ju + T + m + S + f + r,
                1,
                o + Bo + " +lon_0=-74.33333333333333" + dt + T + m + S + f + r,
                1,
                o + Bo + Hr + Ct + T + m + S + f + r,
                1,
                o + Bo + Wr + Ct + T + m + S + f + r,
                2,
                l + " +lat_1=34.33333333333334 +lat_2=36.16666666666666" + Qc + Qh + k + m + S + f + r,
                1,
                l + " +lat_1=47.43333333333333" + sA + pu + vi + k + m + S + f + r,
                1,
                l + " +lat_1=46.18333333333333 +lat_2=47.48333333333333" + Ne + vi + k + m + S + f + r,
                1,
                l + " +lat_1=40.43333333333333 +lat_2=41.7" + _e + hi + k + m + S + f + r,
                1,
                l + " +lat_1=38.73333333333333 +lat_2=40.03333333333333" + Cr + hi + k + m + S + f + r,
                1,
                l + " +lat_1=35.56666666666667" + Un + Wm + Co + k + m + S + f + r,
                1,
                l + " +lat_1=33.93333333333333 +lat_2=35.23333333333333" + In + Co + k + m + S + f + r,
                1,
                l + " +lat_1=44.33333333333334" + cp + ct + lt + k + m + S + f + r,
                1,
                l + " +lat_1=42.33333333333334 +lat_2=44" + G + lt + k + m + S + f + r,
                1,
                l + " +lat_1=40.88333333333333 +lat_2=41.95" + Qt + bi + k + m + S + f + r,
                2,
                o + ei + Zo + " +k=0.9999938" + T + m + S + f + r,
                1,
                l + " +lat_1=33.76666666666667 +lat_2=34.96666666666667" + $d + pr + k + m + S + f + r,
                2,
                l + " +lat_1=32.33333333333334 +lat_2=33.66666666666666" + Rn + pr + k + m + S + f + r,
                1,
                l + " +lat_1=44.41666666666666 +lat_2=45.68333333333333" + ft + dr + k + m + S + f + r,
                1,
                l + " +lat_1=42.83333333333334 +lat_2=44.4" + ri + Tt + k + m + S + f + r,
                2,
                l + yS + " +lat_2=36.18333333333333" + $m + kl + k + m + S + f + r,
                1,
                l + " +lat_1=32.13333333333333 +lat_2=33.96666666666667" + Ln + " +lon_0=-97.5" + k + m + S + f + r,
                1,
                l + " +lat_1=30.11666666666667 +lat_2=31.88333333333333" + Ar + Tt + k + m + S + f + r,
                1,
                l + " +lat_1=28.38333333333333 +lat_2=30.28333333333333" + qn + vl + k + m + S + f + r,
                1,
                l + " +lat_1=26.16666666666667 +lat_2=27.83333333333333" + Er + gr + k + m + S + f + r,
                1,
                l + " +lat_1=40.71666666666667 +lat_2=41.78333333333333" + Ue + ae + k + m + S + f + r,
                1,
                l + " +lat_1=39.01666666666667 +lat_2=40.65" + yt + ae + k + m + S + f + r,
                1,
                l + " +lat_1=37.21666666666667 +lat_2=38.35" + F + ae + k + m + S + f + r,
                1,
                o + Fo + rf + Ru + T + m + S + f + r,
                1,
                l + " +lat_1=38.03333333333333 +lat_2=39.2" + tt + Yo + k + m + S + f + r,
                1,
                l + Pn + " +lat_2=37.96666666666667" + et + Yo + k + m + S + f + r,
                1,
                l + " +lat_1=47.5" + sA + pu + $r + k + m + S + f + r,
                1,
                l + " +lat_1=45.83333333333334 +lat_2=47.33333333333334" + zn + lt + k + m + S + f + r,
                1,
                l + " +lat_1=39 +lat_2=40.25" + _h + ya + k + m + S + f + r,
                1,
                l + " +lat_1=37.48333333333333 +lat_2=38.88333333333333" + Zm + pr + k + m + S + f + r,
                1,
                l + " +lat_1=45.56666666666667 +lat_2=46.76666666666667" + Gn + He + k + m + S + f + r,
                1,
                l + " +lat_1=44.25" + Ss + ft + He + k + m + S + f + r,
                1,
                l + " +lat_1=42.73333333333333 +lat_2=44.06666666666667" + Hd + He + k + m + S + f + r,
                1,
                o + Wc + nn + Rt + T + m + S + f + r,
                1,
                o + Wc + on + Rt + T + m + S + f + r,
                1,
                o + Wc + Lu + Rt + T + m + S + f + r,
                1,
                o + Wc + an + Rt + T + m + S + f + r,
                6,
                o + p + vl + mt + R + m + S + f + r,
                1,
                o + p + pg + mt + R + m + S + f + r,
                1,
                o + p + gl + mt + R + m + S + f + r,
                1,
                o + p + pr + mt + R + m + S + f + r,
                14,
                o + p + " +lon_0=-53" + A + kt + m + S + a + r,
                1,
                o + p + BE + A + kt + m + S + a + r,
                1,
                o + p + Kv + A + kt + m + S + a + r,
                1,
                o + p + Ly + A + kt + m + S + a + r,
                1,
                o + p + qy + A + kt + m + S + a + r,
                1,
                o + p + Xv + A + kt + m + S + a + r,
                12,
                l + _b + cp + fu + Xa + $ + m + S + a + r,
                1,
                l + Qe + tr + Er + Te + k + m + S + f + r,
                1,
                l + $c + Fy + th + iu + N + m + i + n + a + r,
                4,
                l + nl + Al + go + dr + y + m + i + n + a + r,
                3,
                o + hr + Qr + A + I + nb + i + n + a + r,
                1,
                o + hr + tn + A + y + ws + i + n + a + r,
                1,
                o + hr + en + A + br + ef + i + n + a + r,
                1,
                o + Fo + rn + dt + ut + m + i + n + a + r,
                1,
                o + Jt + Oa + A + je + m + i + n + a + r,
                1,
                o + Ie + zr + Ms + Op + m + i + n + a + r,
                1,
                o + Ie + Bu + A + y + m + i + n + a + r,
                1,
                o + Ie + Gr + ju + hA + m + i + n + a + r,
                1,
                o + Jt + Oa + A + je + m + i + n + a + r,
                1,
                o + Bo + Hr + Ct + We + m + i + n + a + r,
                1,
                o + Bo + Wr + Ct + fy + m + i + n + a + r,
                1,
                l + Tn + Fn + Qt + nd + ut + m + i + n + a + r,
                1,
                l + Ri + Li + Qc + Qh + rg + m + i + n + a + r,
                1,
                l + oe + qi + pu + vi + N + m + i + n + a + r,
                1,
                l + Ui + zi + Ne + vi + N + m + i + n + a + r,
                1,
                l + Lp + vo + _e + hi + N + m + i + n + a + r,
                1,
                l + bo + xo + Cr + hi + N + m + i + n + a + r,
                1,
                l + Pn + Gi + Wm + Co + N + m + i + n + a + r,
                1,
                l + Hi + Wi + In + Co + N + m + i + n + a + r,
                1,
                l + zd + wr + ct + lt + Dr + m + i + n + a + r,
                1,
                l + Gd + _r + G + lt + wt + m + i + n + a + r,
                1,
                l + eh + $i + Qt + bi + N + m + i + n + a + r,
                1,
                l + Bn + jn + J + bi + N + m + i + n + a + r,
                1,
                o + ei + Zo + uf + ve + m + i + n + a + r,
                3,
                l + Vi + Tp + Rn + pr + Fp + m + i + n + a + r,
                1,
                l + wo + _o + ft + dr + N + m + i + n + a + r,
                1,
                l + qp + Ao + ri + Tt + N + m + i + n + a + r,
                1,
                l + Zi + rh + te + Yf + N + m + i + n + a + r,
                1,
                l + Yi + nh + $m + kl + I + st + i + n + a + r,
                1,
                l + Ki + Xi + Ln + gr + N + Fr + i + n + a + r,
                1,
                l + Ji + Qi + Ar + Tt + mi + Po + i + n + a + r,
                1,
                l + to + eo + qn + vl + N + ef + i + n + a + r,
                1,
                l + Qe + tr + Er + gr + ut + Dl + i + n + a + r,
                1,
                l + Et + er + Ue + ae + y + st + i + n + a + r,
                1,
                l + Gu + rr + yt + ae + y + Fr + i + n + a + r,
                1,
                l + Hu + nr + F + ae + y + Po + i + n + a + r,
                1,
                o + Fo + rf + Ru + y + m + i + n + a + r,
                1,
                l + Pp + ro + tt + Yo + Re + Fr + i + n + a + r,
                1,
                l + Xt + Un + et + Yo + Re + st + i + n + a + r,
                1,
                l + oe + Ip + pu + $r + y + m + i + n + a + r,
                1,
                l + no + io + zn + lt + y + m + i + n + a + r,
                1,
                l + ah + By + _h + ya + N + m + i + n + a + r,
                1,
                l + Eo + So + Zm + pr + N + m + i + n + a + r,
                1,
                l + oo + ao + Gn + He + N + m + i + n + a + r,
                1,
                l + hl + ih + ft + He + N + m + i + n + a + r,
                1,
                l + so + uo + Hd + He + N + m + i + n + a + r,
                1,
                o + Ke + nn + Ct + I + m + i + n + a + r,
                1,
                o + Ke + on + Ct + Z + ni + i + n + a + r,
                1,
                o + Ke + Lu + Ct + N + m + i + n + a + r,
                1,
                o + Ke + an + Ct + br + ni + i + n + a + r,
                3,
                l + ha + pa + da + Ho + I + Ks + i + n + a + r,
                3,
                o + p + vl + mt + R + m + i + n + f + r,
                1,
                o + p + pg + mt + R + m + i + n + f + r,
                1,
                o + p + gl + mt + R + m + i + n + f + r,
                1,
                o + p + pr + mt + R + m + i + n + f + r,
                14,
                o + p + " +lon_0=-53" + A + kt + m + i + n + a + r,
                1,
                o + p + BE + A + kt + m + i + n + a + r,
                1,
                o + p + Kv + A + kt + m + i + n + a + r,
                1,
                o + p + Ly + A + kt + m + i + n + a + r,
                1,
                o + p + qy + A + kt + m + i + n + a + r,
                1,
                o + p + Xv + A + kt + m + i + n + a + r,
                1,
                o + p + Xs + A + kt + m + i + n + a + r,
                1,
                o + p + Jv + A + kt + m + i + n + a + r,
                1,
                o + p + Qv + A + kt + m + i + n + a + r,
                1,
                o + p + ya + A + kt + m + i + n + a + r,
                1,
                o + p + hi + A + kt + m + i + n + a + r,
                1,
                o + p + pr + A + kt + m + i + n + a + r,
                1,
                o + p + Jh + A + kt + m + i + n + a + r,
                1,
                o + p + gl + A + kt + m + i + n + a + r,
                1,
                o + p + He + A + kt + m + i + n + a + r,
                1,
                o + p + pg + A + kt + m + i + n + a + r,
                1,
                o + p + td + A + kt + m + i + n + a + r,
                1,
                l + _b + cp + fu + Xa + $ + m + i + n + a + r,
                1,
                l + Qe + tr + " +lat_0=25.5" + Te + Ae + m + i + n + a + r,
                2,
                c + Og + w + g + a + r,
                1,
                c + qv + w + g + a + r,
                1,
                c + uA + w + g + a + r,
                1,
                c + Gv + w + g + a + r,
                1,
                c + Cy + w + g + a + r,
                1,
                c + lg + w + g + a + r,
                1,
                c + Dy + w + g + a + r,
                1,
                c + Uv + w + g + a + r,
                1,
                c + zv + w + g + a + r,
                1,
                c + Cm + w + g + a + r,
                1,
                c + wp + w + g + a + r,
                1,
                c + _p + w + g + a + r,
                1,
                c + Ap + w + g + a + r,
                1,
                c + Sp + w + g + a + r,
                1,
                c + $h + w + g + a + r,
                1,
                c + Vh + w + g + a + r,
                1,
                c + _u + w + g + a + r,
                1,
                c + zs + w + g + a + r,
                1,
                c + _s + w + g + a + r,
                1,
                c + Ua + w + g + a + r,
                1,
                c + Gs + w + g + a + r,
                1,
                c + Mu + w + g + a + r,
                1,
                c + Pf + w + g + a + r,
                1,
                c + Mp + w + g + a + r,
                1,
                c + xp + w + g + a + r,
                1,
                c + bd + w + g + a + r,
                1,
                c + Tg + w + g + a + r,
                1,
                c + cl + w + g + a + r,
                1,
                c + Bl + w + g + a + r,
                1,
                c + gd + w + g + a + r,
                1,
                c + Nm + w + g + a + r,
                1,
                c + Xu + w + g + a + r,
                1,
                c + Rl + w + g + a + r,
                1,
                c + Zh + w + g + a + r,
                1,
                c + yc + w + g + a + r,
                1,
                c + ch + w + g + a + r,
                1,
                c + Ll + w + g + a + r,
                1,
                c + ll + w + g + a + r,
                1,
                c + Ku + w + g + a + r,
                1,
                c + lh + w + g + a + r,
                1,
                c + Ky + w + g + a + r,
                1,
                c + Xy + w + g + a + r,
                1,
                c + Ig + w + g + a + r,
                1,
                c + Zv + w + g + a + r,
                1,
                c + Yv + w + g + a + r,
                1,
                c + Dm + w + g + a + r,
                1,
                c + kp + w + g + a + r,
                1,
                c + hh + w + g + a + r,
                1,
                c + ph + w + g + a + r,
                1,
                c + Yh + w + g + a + r,
                1,
                c + fh + w + g + a + r,
                1,
                c + Kh + w + g + a + r,
                1,
                c + xd + w + g + a + r,
                1,
                c + Ep + w + g + a + r,
                1,
                c + Ld + w + g + a + r,
                1,
                c + Qy + w + g + a + r,
                1,
                c + Fg + w + g + a + r,
                1,
                c + Ff + w + g + a + r,
                1,
                c + bp + w + g + a + r,
                1,
                c + Rd + w + g + a + r,
                41,
                c + Og + z + w + g + a + r,
                1,
                c + qv + z + w + g + a + r,
                1,
                c + uA + z + w + g + a + r,
                1,
                c + Gv + z + w + g + a + r,
                1,
                c + Cy + z + w + g + a + r,
                1,
                c + lg + z + w + g + a + r,
                1,
                c + Dy + z + w + g + a + r,
                1,
                c + Uv + z + w + g + a + r,
                1,
                c + zv + z + w + g + a + r,
                1,
                c + Cm + z + w + g + a + r,
                1,
                c + wp + z + w + g + a + r,
                1,
                c + _p + z + w + g + a + r,
                1,
                c + Ap + z + w + g + a + r,
                1,
                c + Sp + z + w + g + a + r,
                1,
                c + $h + z + w + g + a + r,
                1,
                c + Vh + z + w + g + a + r,
                1,
                c + _u + z + w + g + a + r,
                1,
                c + zs + z + w + g + a + r,
                1,
                c + _s + z + w + g + a + r,
                1,
                c + Ua + z + w + g + a + r,
                1,
                c + Gs + z + w + g + a + r,
                1,
                c + Mu + z + w + g + a + r,
                1,
                c + Pf + z + w + g + a + r,
                1,
                c + Mp + z + w + g + a + r,
                1,
                c + xp + z + w + g + a + r,
                1,
                c + bd + z + w + g + a + r,
                1,
                c + Tg + z + w + g + a + r,
                1,
                c + cl + z + w + g + a + r,
                1,
                c + Bl + z + w + g + a + r,
                1,
                c + gd + z + w + g + a + r,
                1,
                c + Nm + z + w + g + a + r,
                1,
                c + Xu + z + w + g + a + r,
                1,
                c + Rl + z + w + g + a + r,
                1,
                c + Zh + z + w + g + a + r,
                1,
                c + yc + z + w + g + a + r,
                1,
                c + ch + z + w + g + a + r,
                1,
                c + Ll + z + w + g + a + r,
                1,
                c + ll + z + w + g + a + r,
                1,
                c + Ku + z + w + g + a + r,
                1,
                c + lh + z + w + g + a + r,
                1,
                c + Ky + z + w + g + a + r,
                1,
                c + Xy + z + w + g + a + r,
                1,
                c + Ig + z + w + g + a + r,
                1,
                c + Zv + z + w + g + a + r,
                1,
                c + Yv + z + w + g + a + r,
                1,
                c + Dm + z + w + g + a + r,
                1,
                c + kp + z + w + g + a + r,
                1,
                c + hh + z + w + g + a + r,
                1,
                c + ph + z + w + g + a + r,
                1,
                c + Yh + z + w + g + a + r,
                1,
                c + fh + z + w + g + a + r,
                1,
                c + Kh + z + w + g + a + r,
                1,
                c + xd + z + w + g + a + r,
                1,
                c + Ep + z + w + g + a + r,
                1,
                c + Ld + z + w + g + a + r,
                1,
                c + Qy + z + w + g + a + r,
                1,
                c + Fg + z + w + g + a + r,
                1,
                c + Ff + z + w + g + a + r,
                1,
                c + bp + z + w + g + a + r,
                1,
                c + Rd + z + w + g + a + r,
                41,
                c + Og + w + v + a + r,
                1,
                c + qv + w + v + a + r,
                1,
                c + uA + w + v + a + r,
                1,
                c + Gv + w + v + a + r,
                1,
                c + Cy + w + v + a + r,
                1,
                c + lg + w + v + a + r,
                1,
                c + Dy + w + v + a + r,
                1,
                c + Uv + w + v + a + r,
                1,
                c + zv + w + v + a + r,
                1,
                c + Cm + w + v + a + r,
                1,
                c + wp + w + v + a + r,
                1,
                c + _p + w + v + a + r,
                1,
                c + Ap + w + v + a + r,
                1,
                c + Sp + w + v + a + r,
                1,
                c + $h + w + v + a + r,
                1,
                c + Vh + w + v + a + r,
                1,
                c + _u + w + v + a + r,
                1,
                c + zs + w + v + a + r,
                1,
                c + _s + w + v + a + r,
                1,
                c + Ua + w + v + a + r,
                1,
                c + Gs + w + v + a + r,
                1,
                c + Mu + w + v + a + r,
                1,
                c + Pf + w + v + a + r,
                1,
                c + Mp + w + v + a + r,
                1,
                c + xp + w + v + a + r,
                1,
                c + bd + w + v + a + r,
                1,
                c + Tg + w + v + a + r,
                1,
                c + cl + w + v + a + r,
                1,
                c + Bl + w + v + a + r,
                1,
                c + gd + w + v + a + r,
                1,
                c + Nm + w + v + a + r,
                1,
                c + Xu + w + v + a + r,
                1,
                c + Rl + w + v + a + r,
                1,
                c + Zh + w + v + a + r,
                1,
                c + yc + w + v + a + r,
                1,
                c + ch + w + v + a + r,
                1,
                c + Ll + w + v + a + r,
                1,
                c + ll + w + v + a + r,
                1,
                c + Ku + w + v + a + r,
                1,
                c + lh + w + v + a + r,
                1,
                c + Ky + w + v + a + r,
                1,
                c + Xy + w + v + a + r,
                1,
                c + Ig + w + v + a + r,
                1,
                c + Zv + w + v + a + r,
                1,
                c + Yv + w + v + a + r,
                1,
                c + Dm + w + v + a + r,
                1,
                c + kp + w + v + a + r,
                1,
                c + hh + w + v + a + r,
                1,
                c + ph + w + v + a + r,
                1,
                c + Yh + w + v + a + r,
                1,
                c + fh + w + v + a + r,
                1,
                c + Kh + w + v + a + r,
                1,
                c + xd + w + v + a + r,
                1,
                c + Ep + w + v + a + r,
                1,
                c + Ld + w + v + a + r,
                1,
                c + Qy + w + v + a + r,
                1,
                c + Fg + w + v + a + r,
                1,
                c + Ff + w + v + a + r,
                1,
                c + bp + w + v + a + r,
                1,
                c + Rd + w + v + a + r,
                41,
                c + Og + z + w + v + a + r,
                1,
                c + qv + z + w + v + a + r,
                1,
                c + uA + z + w + v + a + r,
                1,
                c + Gv + z + w + v + a + r,
                1,
                c + Cy + z + w + v + a + r,
                1,
                c + lg + z + w + v + a + r,
                1,
                c + Dy + z + w + v + a + r,
                1,
                c + Uv + z + w + v + a + r,
                1,
                c + zv + z + w + v + a + r,
                1,
                c + Cm + z + w + v + a + r,
                1,
                c + wp + z + w + v + a + r,
                1,
                c + _p + z + w + v + a + r,
                1,
                c + Ap + z + w + v + a + r,
                1,
                c + Sp + z + w + v + a + r,
                1,
                c + $h + z + w + v + a + r,
                1,
                c + Vh + z + w + v + a + r,
                1,
                c + _u + z + w + v + a + r,
                1,
                c + zs + z + w + v + a + r,
                1,
                c + _s + z + w + v + a + r,
                1,
                c + Ua + z + w + v + a + r,
                1,
                c + Gs + z + w + v + a + r,
                1,
                c + Mu + z + w + v + a + r,
                1,
                c + Pf + z + w + v + a + r,
                1,
                c + Mp + z + w + v + a + r,
                1,
                c + xp + z + w + v + a + r,
                1,
                c + bd + z + w + v + a + r,
                1,
                c + Tg + z + w + v + a + r,
                1,
                c + cl + z + w + v + a + r,
                1,
                c + Bl + z + w + v + a + r,
                1,
                c + gd + z + w + v + a + r,
                1,
                c + Nm + z + w + v + a + r,
                1,
                c + Xu + z + w + v + a + r,
                1,
                c + Rl + z + w + v + a + r,
                1,
                c + Zh + z + w + v + a + r,
                1,
                c + yc + z + w + v + a + r,
                1,
                c + ch + z + w + v + a + r,
                1,
                c + Ll + z + w + v + a + r,
                1,
                c + ll + z + w + v + a + r,
                1,
                c + Ku + z + w + v + a + r,
                1,
                c + lh + z + w + v + a + r,
                1,
                c + Ky + z + w + v + a + r,
                1,
                c + Xy + z + w + v + a + r,
                1,
                c + Ig + z + w + v + a + r,
                1,
                c + Zv + z + w + v + a + r,
                1,
                c + Yv + z + w + v + a + r,
                1,
                c + Dm + z + w + v + a + r,
                1,
                c + kp + z + w + v + a + r,
                1,
                c + hh + z + w + v + a + r,
                1,
                c + ph + z + w + v + a + r,
                1,
                c + Yh + z + w + v + a + r,
                1,
                c + fh + z + w + v + a + r,
                1,
                c + Kh + z + w + v + a + r,
                1,
                c + xd + z + w + v + a + r,
                1,
                c + Ep + z + w + v + a + r,
                1,
                c + Ld + z + w + v + a + r,
                1,
                c + Qy + z + w + v + a + r,
                1,
                c + Fg + z + w + v + a + r,
                1,
                c + Ff + z + w + v + a + r,
                1,
                c + bp + z + w + v + a + r,
                1,
                c + Rd + z + w + v + a + r,
                41,
                c + Og + x + a + r,
                1,
                c + qv + x + a + r,
                1,
                c + uA + x + a + r,
                1,
                c + Gv + x + a + r,
                1,
                c + Cy + x + a + r,
                1,
                c + lg + x + a + r,
                1,
                c + Dy + x + a + r,
                1,
                c + Uv + x + a + r,
                1,
                c + zv + x + a + r,
                1,
                c + Cm + x + a + r,
                1,
                c + wp + x + a + r,
                1,
                c + _p + x + a + r,
                1,
                c + Ap + x + a + r,
                1,
                c + Sp + x + a + r,
                1,
                c + $h + x + a + r,
                1,
                c + Vh + x + a + r,
                1,
                c + _u + x + a + r,
                1,
                c + zs + x + a + r,
                1,
                c + _s + x + a + r,
                1,
                c + Ua + x + a + r,
                1,
                c + Gs + x + a + r,
                1,
                c + Mu + x + a + r,
                1,
                c + Pf + x + a + r,
                1,
                c + Mp + x + a + r,
                1,
                c + xp + x + a + r,
                1,
                c + bd + x + a + r,
                1,
                c + Tg + x + a + r,
                1,
                c + cl + x + a + r,
                1,
                c + Bl + x + a + r,
                1,
                c + gd + x + a + r,
                1,
                c + Nm + x + a + r,
                1,
                c + Xu + x + a + r,
                1,
                c + Rl + x + a + r,
                1,
                c + Zh + x + a + r,
                1,
                c + yc + x + a + r,
                1,
                c + ch + x + a + r,
                1,
                c + Ll + x + a + r,
                1,
                c + ll + x + a + r,
                1,
                c + Ku + x + a + r,
                1,
                c + lh + x + a + r,
                1,
                c + Ky + x + a + r,
                1,
                c + Xy + x + a + r,
                1,
                c + Ig + x + a + r,
                1,
                c + Zv + x + a + r,
                1,
                c + Yv + x + a + r,
                1,
                c + Dm + x + a + r,
                1,
                c + kp + x + a + r,
                1,
                c + hh + x + a + r,
                1,
                c + ph + x + a + r,
                1,
                c + Yh + x + a + r,
                1,
                c + fh + x + a + r,
                1,
                c + Kh + x + a + r,
                1,
                c + xd + x + a + r,
                1,
                c + Ep + x + a + r,
                1,
                c + Ld + x + a + r,
                1,
                c + Qy + x + a + r,
                1,
                c + Fg + x + a + r,
                1,
                c + Ff + x + a + r,
                1,
                c + bp + x + a + r,
                1,
                c + Rd + x + a + r,
                1,
                pe + Os + ly + es + Jy + ke + Fr + x + a + r,
                3,
                o + p + vl + mt + R + m + x + f + r,
                1,
                o + p + pg + mt + R + m + x + f + r,
                1,
                o + p + gl + mt + R + m + x + f + r,
                1,
                o + p + pr + mt + R + m + x + f + r,
                34,
                c + Og + z + x + a + r,
                1,
                c + qv + z + x + a + r,
                1,
                c + uA + z + x + a + r,
                1,
                c + Gv + z + x + a + r,
                1,
                c + Cy + z + x + a + r,
                1,
                c + lg + z + x + a + r,
                1,
                c + Dy + z + x + a + r,
                1,
                c + Uv + z + x + a + r,
                1,
                c + zv + z + x + a + r,
                1,
                c + Cm + z + x + a + r,
                1,
                c + wp + z + x + a + r,
                1,
                c + _p + z + x + a + r,
                1,
                c + Ap + z + x + a + r,
                1,
                c + Sp + z + x + a + r,
                1,
                c + $h + z + x + a + r,
                1,
                c + Vh + z + x + a + r,
                1,
                c + _u + z + x + a + r,
                1,
                c + zs + z + x + a + r,
                1,
                c + _s + z + x + a + r,
                1,
                c + Ua + z + x + a + r,
                1,
                c + Gs + z + x + a + r,
                1,
                c + Mu + z + x + a + r,
                1,
                c + Pf + z + x + a + r,
                1,
                c + Mp + z + x + a + r,
                1,
                c + xp + z + x + a + r,
                1,
                c + bd + z + x + a + r,
                1,
                c + Tg + z + x + a + r,
                1,
                c + cl + z + x + a + r,
                1,
                c + Bl + z + x + a + r,
                1,
                c + gd + z + x + a + r,
                1,
                c + Nm + z + x + a + r,
                1,
                c + Xu + z + x + a + r,
                1,
                c + Rl + z + x + a + r,
                1,
                c + Zh + z + x + a + r,
                1,
                c + yc + z + x + a + r,
                1,
                c + ch + z + x + a + r,
                1,
                c + Ll + z + x + a + r,
                1,
                c + ll + z + x + a + r,
                1,
                c + Ku + z + x + a + r,
                1,
                c + lh + z + x + a + r,
                1,
                c + Ky + z + x + a + r,
                1,
                c + Xy + z + x + a + r,
                1,
                c + Ig + z + x + a + r,
                1,
                c + Zv + z + x + a + r,
                1,
                c + Yv + z + x + a + r,
                1,
                c + Dm + z + x + a + r,
                1,
                c + kp + z + x + a + r,
                1,
                c + hh + z + x + a + r,
                1,
                c + ph + z + x + a + r,
                1,
                c + Yh + z + x + a + r,
                1,
                c + fh + z + x + a + r,
                1,
                c + Kh + z + x + a + r,
                1,
                c + xd + z + x + a + r,
                1,
                c + Ep + z + x + a + r,
                1,
                c + Ld + z + x + a + r,
                1,
                c + Qy + z + x + a + r,
                1,
                c + Fg + z + x + a + r,
                1,
                c + Ff + z + x + a + r,
                1,
                c + bp + z + x + a + r,
                1,
                c + Rd + z + x + a + r,
                1,
                pe + q + " +lat_ts=-90" + es + Jy + ke + Fr + x + a + r,
                5,
                o + p + qd + mt + y + Bt + x + a + r
            ].reduce((t, e, r)=>{
                if (r % 2 == 0) {
                    const r = t.prev + e, n = "EPSG:" + r;
                    t.defs.push([
                        n
                    ]), t.prev = r;
                } else t.defs[t.defs.length - 1].push(e);
                return t;
            }, {
                defs: [],
                prev: 0
            }).defs;
        },
        function(t, e, r) {
            const n = r(225), i = r(226);
            function o(t, e, { async: r = !1, density: o } = {}) {
                const a = i(t, {
                    density: o
                })[0].map((t)=>e(t));
                return r ? Promise.all(a).then((t)=>n(t)) : n(a);
            }
            t.exports = o, t.exports.default = o;
        },
        function(t, e, r) {
            "use strict";
            function n(t) {
                const e = t.length, [r, n] = t[0];
                let i = r, o = r, a = n, s = n;
                for(let r = 1; r < e; r++){
                    const [e, n] = t[r];
                    e < i ? i = e : e > o && (o = e), n < a ? a = n : n > s && (s = n);
                }
                return [
                    i,
                    a,
                    o,
                    s
                ];
            }
            t.exports = n, t.exports.default = n;
        },
        function(t, e) {
            function r([t, e, r, n], { density: i = 0 } = {
                density: 0
            }) {
                "number" == typeof i && (i = [
                    i,
                    i
                ]);
                const [o, a] = i, s = [], u = (r - t) / (o + 1), l = (n - e) / (a + 1);
                s.push([
                    t,
                    n
                ]);
                for(let e = 1; e <= a; e++)s.push([
                    t,
                    n - e * l
                ]);
                s.push([
                    t,
                    e
                ]);
                for(let r = 1; r <= o; r++)s.push([
                    t + r * u,
                    e
                ]);
                s.push([
                    r,
                    e
                ]);
                for(let t = 1; t <= a; t++)s.push([
                    r,
                    e + t * l
                ]);
                s.push([
                    r,
                    n
                ]);
                for(let t = 1; t <= o; t++)s.push([
                    r - t * u,
                    n
                ]);
                return s.push([
                    t,
                    n
                ]), [
                    s
                ];
            }
            t.exports = r, t.exports.default = r;
        },
        function(t, e, r) {
            var n;
            const i = r(71), o = r(228);
            function a(t, { densify: e, reproject: r }) {
                if ("function" != typeof r) throw new Error("[reproject-geojson] you must specify a reproject function");
                if ("FeatureCollection" === t.type) return {
                    ...t,
                    features: t.features.map((t)=>a(t, {
                            densify: e,
                            reproject: r
                        }))
                };
                if ("Feature" === t.type) return {
                    ...t,
                    geometry: a(t.geometry, {
                        densify: e,
                        reproject: r
                    })
                };
                if ("LineString" === t.type) return {
                    ...t,
                    coordinates: o(t.coordinates, r, {
                        densify: e
                    })
                };
                if ("MultiLineString" === t.type) return {
                    ...t,
                    coordinates: t.coordinates.map((t)=>o(t, r, {
                            densify: e
                        }))
                };
                if ("MultiPoint" === t.type) return {
                    ...t,
                    coordinates: t.coordinates.map((t)=>r(t))
                };
                if ("MultiPolygon" === t.type) return {
                    ...t,
                    coordinates: t.coordinates.map((t)=>t.map((t)=>o(t, r, {
                                densify: e
                            })))
                };
                if ("Point" === t.type) return {
                    ...t,
                    coordinates: r(t.coordinates)
                };
                if ("Polygon" === t.type) return {
                    ...t,
                    coordinates: t.coordinates.map((t)=>o(t, r, {
                            densify: e
                        }))
                };
                if (Array.isArray(t)) {
                    const n = i(t);
                    if (1 === n) return r(t);
                    if (2 === n) return t.map((t)=>r(t));
                    if (3 === n) return t.map((t)=>o(t, r, {
                            densify: e
                        }));
                    if (4 === n) return t.map((t)=>t.map((t)=>o(t, r, {
                                densify: e
                            })));
                }
                return t;
            }
            void 0 === (n = (function() {
                return a;
            }).call(e, r, e, t)) || (t.exports = n), t.exports = a, "object" == typeof window && (window.reprojectGeoJSONPluggable = a), "object" == typeof self && (self.reprojectGeoJSONPluggable = a);
        },
        function(t, e, r) {
            var n;
            function i(t, e, r) {
                const n = "object" == typeof r && "number" == typeof r.debug_level ? r.debug_level : 0;
                let i = "object" == typeof r && "number" == typeof r.densify ? r.densify : 0;
                const o = "object" == typeof r && "string" == typeof r.strategy ? r.strategy : "auto";
                i = Math.round(i), n >= 1 && (console.log("[reproject-line] debug_level:", n), console.log("[reproject-line] densify:", i), console.log("[reproject-line] strategy:", o));
                const a = [];
                let [s, u] = e(t[0]), l = null, c = null;
                for(let r = 1; r < t.length; r++){
                    const [n, f] = t[r - 1], [h, p] = t[r], d = (h - n) / (i + 1), m = (p - f) / (i + 1);
                    for(let t = 1; t <= i; t++){
                        const [r, i] = e([
                            n + t * d,
                            f + t * m
                        ]);
                        c = (i - u) / (r - s), "always" !== o && c === l || (a.push([
                            s,
                            u
                        ]), l = c), s = r, u = i;
                    }
                    const [y, g] = e([
                        h,
                        p
                    ]);
                    c = (g - u) / (y - s), "always" !== o && c === l || (a.push([
                        s,
                        u
                    ]), l = c), s = y, u = g;
                }
                return a.push([
                    s,
                    u
                ]), n >= 3 && console.log("[reproject-line] returning", a), a;
            }
            void 0 === (n = (function() {
                return i;
            }).call(e, r, e, t)) || (t.exports = n), t.exports = i, t.exports.default = i;
        },
        function(t, e) {
            const r = {
                Int8Array: -128,
                Uint8Array: 0,
                Uint8ClampedArray: 0,
                Int16Array: -32768,
                Uint16Array: 0,
                Int32Array: -2147483648,
                Uint32Array: 0,
                BigInt64Array: -9223372036854776000,
                BigUint64Array: 0
            };
            t.exports = (t)=>("string" != typeof t && t.constructor && (t = t.constructor.name), r[t]);
        },
        function(t, e) {
            const r = {
                Int8Array: 127,
                Uint8Array: 255,
                Uint8ClampedArray: 255,
                Int16Array: 32767,
                Uint16Array: 65535,
                Int32Array: 2147483647,
                Uint32Array: 4294967295,
                Float32Array: 34e37,
                Float64Array: 1.8 * Math.pow(10, 308) == 1 / 0 ? void 0 : 1.8 * Math.pow(10, 308),
                BigInt64Array: 0x8000000000000000,
                BigUint64Array: 0x10000000000000000
            };
            t.exports = (t)=>("string" != typeof t && t.constructor && (t = t.constructor.name), r[t]);
        },
        function(t, e) {
            function r(t) {
                const e = [];
                for(let r = 0; r < t.length; r++){
                    const n = t[r], i = JSON.stringify(n);
                    -1 === e.indexOf(i) && e.push(i);
                }
                return e.map((t)=>JSON.parse(t));
            }
            t.exports = r, t.exports.default = r;
        },
        function(t, e, r) {
            "use strict";
            const n = r(233), i = r(75), o = r(76), a = r(235);
            t.exports = function({ geometry: t, raster_height: e, per_pixel: r, per_row_segment: s, debug_level: u = 0, ...l }) {
                const c = n(t).map((t)=>a({
                        polygon: t,
                        raster_height: e,
                        debug_level: u,
                        ...l
                    }));
                u >= 1 && console.log("[dufour-peyton-intersection] inside_rows_by_polygon:", c);
                const f = new Array(e);
                for(let t = 0; t < e; t++){
                    const e = c.map((e)=>e[t]).filter((t)=>void 0 !== t && t.length > 0).flat();
                    if (e.length > 0) {
                        const r = o(e), n = i(r);
                        f[t] = n;
                    }
                }
                return (s || r) && f.forEach((t, e)=>{
                    t && t.forEach((t, n)=>{
                        if (s && s({
                            row: e,
                            columns: t
                        }), r) {
                            const [n, i] = t;
                            for(let t = n; t <= i; t++)r({
                                row: e,
                                column: t
                            });
                        }
                    });
                }), {
                    rows: f
                };
            };
        },
        function(t, e, r) {
            "use strict";
            const n = r(119);
            t.exports = function(t) {
                const e = [];
                return n(t, (t)=>e.push(t)), e;
            };
        },
        function(t, e) {
            t.exports = function(t, e) {
                return Math.sign(t[0] - e[0]) || Math.sign(t[1] - e[1]);
            };
        },
        function(t, e, r) {
            "use strict";
            const n = r(120), i = r(236);
            t.exports = function({ polygon: t, ...e }) {
                const { debug_level: r = 0 } = e, [o, ...a] = t.map((t)=>i({
                        ring: t,
                        ...e
                    }));
                r >= 2 && console.log("[dufour-peyton-intersection] exterior:", o);
                return o.map((t, e)=>{
                    const r = a.map((t)=>t[e]).flat();
                    return n(t, r);
                });
            };
        },
        function(t, e, r) {
            "use strict";
            const n = r(123), i = r(237), o = r(75), a = r(76);
            t.exports = function({ debug_level: t = 0, raster_bbox: e, raster_height: r, raster_width: s, pixel_height: u, pixel_width: l, ring: c }) {
                const [f, h, p, d] = e;
                if (e.every((t)=>"string" == typeof t)) throw new Error("[dufour-peyton-intersection] raster_bbox should be all numbers, not strings");
                null == u && (u = (d - h) / r), null == l && (l = (p - f) / s);
                const m = [];
                for(let t = 0; t < r; t++)m.push([]);
                n({
                    debug_level: t,
                    raster_bbox: e,
                    raster_height: r,
                    raster_width: s,
                    pixel_height: u,
                    pixel_width: l,
                    ring: c,
                    per_row_segment: ({ row: t, columns: e })=>{
                        m[t].push(e);
                    }
                });
                for(let t = 0; t < m.length; t++){
                    const e = m[t];
                    e && (a(e), m[t] = o(e));
                }
                return t >= 2 && i(m), m;
            };
        },
        function(t, e, r) {
            "use strict";
            t.exports = function(t) {
                t.forEach((t, e)=>{
                    for(let r = 0; r < t.length; r++){
                        const n = t[r], [i, o] = n;
                        i > o && console.warn("[dufour-peyton-intersection] uh oh, encountered invalid range", n, "at row index", e, "with ranges", t);
                        for(let n = r + 1; n < t.length; n++)n[0] <= o && console.warn("[dufour-peyton-intersection] encountered range problem on row index", e, ":", t);
                    }
                });
            };
        },
        function(t, e) {
            t.exports = function(t, e) {
                return e[0] >= t[0] && e[1] <= t[1];
            };
        },
        function(t, e, r) {
            "use strict";
            const n = r(37);
            function i(t) {
                const e = t.length, [r, i] = t[0];
                let o = r, a = r, s = i, u = i;
                for(let r = 1; r < e; r++){
                    const [e, i] = t[r];
                    "<" === n(e, o) ? o = e : ">" === n(e, a) && (a = e), "<" === n(i, s) ? s = i : ">" === n(i, u) && (u = i);
                }
                return [
                    o,
                    s,
                    a,
                    u
                ];
            }
            t.exports = i, t.exports.default = i;
        },
        function(t, e, r) {
            const n = r(19), i = r(12), o = r(48), a = r(39);
            function s(t, { density: e = 0 } = {
                density: 0
            }) {
                t = t.map((t)=>t.toString());
                let [r, s, u, l] = t;
                "number" != typeof e && "string" != typeof e || (e = [
                    e,
                    e
                ]), e = e.map((t)=>t.toString());
                const [c, f] = e, h = a(l, s), p = a(u, r), d = [], m = i(p, n(c, "1")), y = i(h, n(f, "1"));
                d.push([
                    r,
                    l
                ]);
                for(let t = 1; t <= f; t++)d.push([
                    r,
                    a(l, o(t.toString(), y))
                ]);
                d.push([
                    r,
                    s
                ]);
                for(let t = 1; t <= c; t++)d.push([
                    n(r, o(t.toString(), m)),
                    s
                ]);
                d.push([
                    u,
                    s
                ]);
                for(let t = 1; t <= f; t++)d.push([
                    u,
                    n(s, o(t.toString(), y))
                ]);
                d.push([
                    u,
                    l
                ]);
                for(let t = 1; t <= c; t++)d.push([
                    a(u, o(t.toString(), m)),
                    l
                ]);
                return d.push([
                    r,
                    l
                ]), [
                    d
                ];
            }
            t.exports = s, t.exports.default = s;
        },
        function(t, e, r) {
            "use strict";
            function n(t) {
                return t.substring(0, t.indexOf("."));
            }
            t.exports = n, t.exports.default = n;
        },
        function(t, e, r) {
            "use strict";
            const n = r(3), i = r(80), o = r(21), a = r(134), s = r(77), u = [
                "5",
                "6",
                "7",
                "8",
                "9"
            ];
            function l(t, { digits: e = 0 } = {
                digits: 0
            }) {
                const r = t = n(t), l = a(t) ? "-" : "", c = (t = o(t)).indexOf(".");
                if (-1 === c) return r;
                if (i(t) <= e) return r;
                const f = t[c + e + 1];
                if (u.includes(f)) {
                    const r = t.substring(0, c + e + 2);
                    return l + s(r);
                }
                if (0 === e) return l + t.substring(0, c);
                return l + t.substring(0, c + e + 1);
            }
            t.exports = l, t.exports.default = l;
        },
        function(t, e, r) {
            var n;
            function i(t, e) {
                const [r, n, i, o, a, s] = t, [u, l] = e;
                return [
                    r + n * u + i * l,
                    o + a * u + s * l
                ];
            }
            void 0 === (n = (function() {
                return i;
            }).call(e, r, e, t)) || (t.exports = n), t.exports = i, t.exports.default = i;
        },
        function(t, e, r) {
            var n;
            function i(t) {
                const [e, r, n, i, o, a] = t, s = r * a - n * o, u = -1 * s;
                return [
                    (n * i - e * a) / s,
                    a / s,
                    n / u,
                    (r * i - e * o) / u,
                    o / u,
                    r / s
                ];
            }
            void 0 === (n = (function() {
                return i;
            }).call(e, r, e, t)) || (t.exports = n), t.exports = i, t.exports.default = i;
        },
        function(t, e, r) {
            var n;
            const i = r(135);
            function o(t) {
                t.length;
                const [e, r, n, o, a, s, u, l, c, f, h, p, d, m, y, g] = t;
                return i([
                    o,
                    e,
                    r,
                    l,
                    a,
                    s
                ]);
            }
            void 0 === (n = (function() {
                return o;
            }).call(e, r, e, t)) || (t.exports = n), t.exports = o, t.exports.default = o;
        },
        function(t, e, r) {
            "use strict";
            function n(t) {
                "+" === t[0] && (t = t.substring(1));
                const e = "-" === t[0] ? "-" : "";
                "-" === e && (t = t.substring(1));
                const r = t.indexOf("e");
                if (-1 === r) return e + t;
                let n = t.indexOf(".");
                -1 === n && (n = r);
                const i = Number(t.substring(r + 1)), o = t.substring(0, r).replace(".", ""), a = n + i, s = o.length;
                if (a >= s) {
                    const t = a - s;
                    let r = o;
                    for(let e = 0; e < t; e++)r += "0";
                    return e + r;
                }
                if (a < 0) {
                    let t = "0.";
                    for(let e = 0; e > a; e--)t += "0";
                    return t += o, e + t;
                }
                return e + o.substring(0, a) + "." + o.substring(a);
            }
            t.exports = n, t.exports.default = n;
        },
        function(t, e, r) {
            "use strict";
            const n = r(49), i = r(15), o = r(248);
            function a(t, e, r) {
                if (t = i(t), "0" === (e = i(e))) throw new Error("[preciso] division by zero");
                if ("" === t || "0" === t) return "0";
                const a = "-" !== t[0], s = "-" !== e[0], u = a !== s ? "-" : "";
                return a || (t = n(t)), s || (e = n(e)), u + o(t, e, r);
            }
            t.exports = a, t.exports.default = a;
        },
        function(t, e, r) {
            "use strict";
            const n = r(60), i = r(82), o = r(138), a = r(139);
            function s(t, e, { format: r = "string", max_decimal_digits: s = 100, ellipsis: u = !1 } = {}) {
                "0" === t[0] && (t = t.substring(1)), "0" === e[0] && (e = e.substring(1));
                const l = t.indexOf("."), c = e.indexOf("."), f = -1 === l ? t.length : l, h = -1 === c ? 0 : e.length - 1 - c;
                let p = !1;
                t = t.replace(/\./, ""), e = e.replace(/\./, "");
                const d = t.length;
                let m, y = "", g = "", v = -1 * h, b = 0;
                for(let r = 0; r < d; r++)if (y += t[r], m = n(y, e), ">" === m) {
                    let t = 1, r = i(e, e), a = e;
                    for(; ">" !== n(r, y);)t++, a = r, r = i(r, e);
                    if (t = t.toString(), "" !== g) for(let e = t.length; e <= b; e++)g += "0";
                    g += t, y = o(y, a), b = 0;
                } else {
                    if ("<" === m) {
                        "" === g && v++, b++;
                        continue;
                    }
                    if ("=" === m) {
                        if ("" !== g) for(let t = 0; t < b; t++)g += "0";
                        g += "1", y = "0", b = 0;
                    }
                }
                if (y.match(/^0+$/g)) "<" === m && (g += y.substring(0, y.length - 1));
                else {
                    const t = {}, r = f - v - g.length + s + 1;
                    "" === g && (b = 0);
                    for(let a = 0; a < r; a++){
                        if (y += "0", u) {
                            if (y in t) {
                                if (t[y]++, t[y] > 3) {
                                    g += "...", p = !0;
                                    break;
                                }
                            } else t[y] = 1;
                        }
                        const r = n(y, e);
                        if (">" === r) {
                            let t = 1, r = i(e, e), a = e;
                            for(; ">" !== n(r, y);)t++, a = r, r = i(r, e);
                            t = t.toString();
                            for(let e = t.length; e <= b; e++)g += "0";
                            if (g += t, y = o(y, a), "0" === y) break;
                            b = 0;
                        } else {
                            if ("<" === r) {
                                b++;
                                continue;
                            }
                            if ("=" === r) {
                                for(let t = 0; t < b; t++)g += "0";
                                g += "1", b = 0;
                                break;
                            }
                        }
                    }
                }
                const x = f - v, w = g.length;
                let _;
                if (x === w) _ = 0;
                else if (x < 0) g = "0." + "0".repeat(Math.abs(x)) + g, _ = w - x;
                else if (x > w) {
                    for(let t = w; t < x; t++)g += "0";
                    _ = 0;
                } else x < w ? (g = g.substring(0, x) + "." + g.substring(x), _ = w - x) : 0 === x && (g = "0." + g, _ = w);
                g = g.replace(/^0+/, ""), g = g.replace(/\.\d+0+$/, "");
                const A = _ - s;
                return p || A > 0 && (g = a(g.substring(0, g.length - A + 1))), "." === g[0] && (g = "0" + g), "object" === r ? {
                    quotient: g,
                    extra_decimals: A
                } : g;
            }
            t.exports = s, t.exports.default = s;
        },
        function(t, e, r) {
            "use strict";
            t.exports = {
                MAX_SAFE_INTEGER: 9007199254740991
            };
        },
        function(t, e, r) {
            "use strict";
            function n(t) {
                return t.substring(0, t.indexOf("."));
            }
            t.exports = n, t.exports.default = n;
        },
        function(t, e, r) {
            "use strict";
            const n = r(141), i = r(252), o = r(142), a = r(255);
            function s(t, { max_decimal_digits: e } = {}) {
                if (t.some((t)=>o(t))) return "0";
                const r = i(t.filter((t)=>n(t)).length.toString());
                let s = a(t.map((t)=>t.replace(/i$/, "")), {
                    max_decimal_digits: e
                });
                return r && (s += "i"), s;
            }
            t.exports = s, t.exports.default = s;
        },
        function(t, e, r) {
            const n = r(15), i = r(253);
            function o(t) {
                if (t = n(t), !i(t)) throw new Error("can't call is_odd on decimal");
                return [
                    "1",
                    "3",
                    "5",
                    "7",
                    "9"
                ].includes(t.charAt(t.length - 1));
            }
            t.exports = o, t.exports.default = o;
        },
        function(t, e, r) {
            "use strict";
            const n = r(15), i = r(254);
            function o(t) {
                return !i(t) && !(t = n(t)).includes(".") && !t.includes("/");
            }
            t.exports = o, t.exports.default = o;
        },
        function(t, e, r) {
            "use strict";
            function n(t) {
                return !!t.match(/^(|-|\+)inf(inity)?$/i);
            }
            t.exports = n, t.exports.default = n;
        },
        function(t, e, r) {
            "use strict";
            const n = r(49), i = r(15), o = r(60), a = r(256), s = r(143);
            function u(t, { max_decimal_digits: e } = {}) {
                let r = i(t[0]), u = n(r), l = "-" === r[0] ? "-" : "";
                const c = t.length;
                for(let e = 1; e < c; e++){
                    const s = i(t[e]), c = "-" === s[0] ? "-" : "", f = n(s);
                    l = l !== c ? "-" : "";
                    u = "<" === o(u, f) ? a(f, u) : a(u, f), r = l + u;
                }
                return "number" == typeof e && (r = s(r, {
                    digits: e
                })), r;
            }
            t.exports = u, t.exports.default = u;
        },
        function(t, e, r) {
            "use strict";
            const { MAX_SAFE_INTEGER_LENGTH: n } = r(84);
            function i(t, e) {
                if ("0" === t || "0" === e) return "0";
                const r = t.indexOf("."), i = e.indexOf("."), o = (-1 === r ? t.length : r) + (-1 === i ? e.length : i), a = (-1 === r ? 0 : t.length - 1 - r) + (-1 === i ? 0 : e.length - 1 - i);
                if (0 === a && o < n) return (Number(t) * Number(e)).toFixed(0);
                const s = t.replace(".", ""), u = e.replace(".", ""), l = s.length, c = u.length, f = [];
                let h = l;
                for(; h >= 0;){
                    const t = h, e = h -= 15, r = s.substring(e, t);
                    f.push([
                        Number(r),
                        r.length
                    ]);
                }
                const p = [], d = [];
                for(let t = 0, e = c - 1; e >= 0; e--, t++){
                    const r = u[e], n = Number(r);
                    let i = 0, o = "";
                    const a = f.length - 1;
                    f.forEach(([t, e], r)=>{
                        let s = (i + n * t).toString();
                        const u = s.length;
                        if (u > e && r !== a) {
                            const t = -1 * e;
                            o = s.slice(t) + o, i = Number(s.slice(0, t));
                        } else {
                            const t = e - u;
                            for(let e = 0; e < t; e++)s = "0" + s;
                            i = 0, o = s + o;
                        }
                    }), o += "0".repeat(t), p.push(o), d.push([
                        Array.from(o).map((t)=>Number(t)),
                        o.length
                    ]);
                }
                const m = p.length, y = d[d.length - 1][1] + m;
                let g = "", v = 0;
                for(let t = 0; t < y; t++){
                    let e = v;
                    const r = Math.min(t, m - 1);
                    for(let n = 0; n <= r; n++){
                        const [r, i] = d[n], o = i - 1 - t;
                        o >= 0 && (e += r[o]);
                    }
                    e >= 10 ? (e = e.toString(), g = e[e.length - 1] + g, v = Number(e.slice(0, -1))) : (g = e + g, v = 0);
                }
                if (0 === a) g = g.replace(/^0+/, "");
                else {
                    const t = g.length - a;
                    g = g.substring(0, t) + "." + g.substring(t), g = g.replace(/^0+/, ""), g = g.replace(/\.?0+$/, ""), "." === g[0] && (g = "0" + g);
                }
                return g;
            }
            t.exports = i, t.exports.default = i;
        },
        function(t, e, r) {
            "use strict";
            const n = r(15), i = r(258), o = r(49), a = r(259), s = r(139), u = [
                "5",
                "6",
                "7",
                "8",
                "9"
            ];
            function l(t, { digits: e = 0 } = {
                digits: 0
            }) {
                const r = t = n(t), l = a(t) ? "-" : "", c = (t = o(t)).indexOf(".");
                if (-1 === c) return r;
                if (i(t) <= e) return r;
                const f = t[c + e + 1];
                if (u.includes(f)) {
                    const r = t.substring(0, c + e + 2);
                    return l + s(r);
                }
                if (0 === e) return l + t.substring(0, c);
                return l + t.substring(0, c + e + 1);
            }
            t.exports = l, t.exports.default = l;
        },
        function(t, e, r) {
            "use strict";
            const n = r(15);
            function i(t) {
                const e = (t = n(t)).indexOf(".");
                return -1 === e ? "0" : (t.length - e - 1).toString();
            }
            t.exports = i, t.exports.default = i;
        },
        function(t, e, r) {
            "use strict";
            const n = r(15);
            function i(t) {
                return "-" === (t = n(t))[0];
            }
            t.exports = i, t.exports.default = i;
        },
        function(t, e, r) {
            "use strict";
            const n = r(49), i = r(15), o = r(83), a = r(85);
            function s(t) {
                if (-1 === (t = i(t)).indexOf(".")) return t;
                const e = a(t);
                return t = n(t).split(".")[0], "+" === e ? t : "-" === e ? "0" === t || "" === t ? "-1" : "-" + o(t, "1") : void 0;
            }
            t.exports = s, t.exports.default = s;
        },
        function(t, e, r) {
            "use strict";
            function n(t) {
                return "-" === t[0] ? "-" : "+";
            }
            t.exports = n, t.exports.default = n;
        },
        function(t, e, r) {
            "use strict";
            const n = r(82);
            function i(t) {
                let e = "0";
                for (let r of t)e = n(e, r);
                return e;
            }
            t.exports = i, t.exports.default = i;
        },
        function(t, e, r) {
            var n;
            const i = r(264), o = r(140), a = r(138);
            function s(t) {
                const [e, r, n, s, u, l] = t, c = o(e, u), f = o(e, l), h = o(r, s), p = o(r, l), d = o(n, s), m = o(n, u), y = a(p, m), g = i(y);
                return [
                    [
                        a(d, f),
                        y
                    ],
                    [
                        l,
                        y
                    ],
                    [
                        n,
                        g
                    ],
                    [
                        a(h, c),
                        g
                    ],
                    [
                        u,
                        g
                    ],
                    [
                        r,
                        y
                    ]
                ];
            }
            void 0 === (n = (function() {
                return s;
            }).call(e, r, e, t)) || (t.exports = n), t.exports = s, t.exports.default = s;
        },
        function(t, e, r) {
            "use strict";
            const n = r(49), i = r(15), o = r(85);
            function a(t) {
                t = i(t);
                const e = o(t);
                return "" === e ? t : "-" === e ? n(t) : "+" === e ? "-" + t : sum;
            }
            t.exports = a, t.exports.default = a;
        },
        function(t, e, r) {
            var n;
            const i = r(136);
            function o(t) {
                t.length;
                t = Array.prototype.slice.call(t).map((t)=>t.toString());
                const [e, r, n, o, a, s, u, l, c, f, h, p, d, m, y, g] = t;
                return i([
                    o,
                    e,
                    r,
                    l,
                    a,
                    s
                ]);
            }
            void 0 === (n = (function() {
                return o;
            }).call(e, r, e, t)) || (t.exports = n), t.exports = o, t.exports.default = o;
        },
        function(t, e, r) {
            var n;
            function i({ bbox: t, container: e, debug: r, origin: n, overflow: i, padding: o, scale: a, size: s }) {
                function u(t) {
                    return 0 === t ? 0 : t;
                }
                r && console.log("[snap-bbox] starting"), r && console.log("[snap-bbox] bbox:", t), r && console.log("[snap-bbox] debug:", r), r && console.log("[snap-bbox] origin:", n), r && console.log("[snap-bbox] overflow:", i), r && console.log("[snap-bbox] padding:", o), r && console.log("[snap-bbox] scale:", a), r && console.log("[snap-bbox] size:", s);
                const [l, c] = n;
                r && console.log("[snap-bbox] originX:", l), r && console.log("[snap-bbox] originY:", c);
                const [f, h] = o || [
                    0,
                    0
                ];
                r && console.log("[snap-bbox] padX:", f), r && console.log("[snap-bbox] padY:", h);
                const [p, d] = a;
                r && console.log("[snap-bbox] scale_x:", p), r && console.log("[snap-bbox] scale_y:", d);
                const m = Math.sign(p), y = Math.sign(d);
                r && console.log("[snap-bbox] sign_scale_x:", m), r && console.log("[snap-bbox] sign_scale_y:", y);
                const [g, v, b, x] = t;
                r && console.log("[snap-bbox] xmin:", g), r && console.log("[snap-bbox] ymin:", v), r && console.log("[snap-bbox] xmax:", b), r && console.log("[snap-bbox] ymax:", x);
                const w = (g - l) / p, _ = (b - l) / p, A = (x - c) / d, E = (v - c) / d;
                r && console.log("[snap-bbox] left:", w), r && console.log("[snap-bbox] right:", _), r && console.log("[snap-bbox] top:", A), r && console.log("[snap-bbox] bottom:", E);
                let S = Math.floor(w) - f, M = Math.ceil(_) + f, k = Math.floor(A) - h, N = Math.ceil(E) + h;
                if (r && console.log("[snap-bbox] left_int:", S), r && console.log("[snap-bbox] right_int:", M), r && console.log("[snap-bbox] top_int:", k), r && console.log("[snap-bbox] bottom_int:", N), e) {
                    r && console.log("[snap-bbox] container:", e);
                    const t = (e[0] - l) / p, n = (e[2] - l) / p, i = (e[3] - c) / d, o = (e[1] - c) / d;
                    r && console.log("[snap-bbox] min_left:", t), r && console.log("[snap-bbox] max_right:", n), r && console.log("[snap-bbox] min_top:", i), r && console.log("[snap-bbox] max_bottom:", o);
                    const a = Math.ceil(t), s = Math.floor(n), u = Math.ceil(i), f = Math.floor(o);
                    r && console.log("[snap-bbox] min_left_int:", a), r && console.log("[snap-bbox] max_right_int:", s), r && console.log("[snap-bbox] min_top_int:", u), r && console.log("[snap-bbox] max_bottom_int:", f), S = Math.max(S, a), M = Math.min(M, s), k = Math.max(k, u), N = Math.min(N, f), r && console.log("[snap-bbox] after containment, left_int:", S), r && console.log("[snap-bbox] after containment, right_int:", M), r && console.log("[snap-bbox] after containment, top_int:", k), r && console.log("[snap-bbox] after containment, bottom_int:", N);
                }
                if (s && !1 === i) {
                    r && console.log("[snap-bbox] size:", s);
                    const [t, e] = s;
                    if (r && console.log("[snap-bbox] width:", t), r && console.log("[snap-bbox] height:", e), S > t || M < 0 || N < 0 || k > e) throw new Error("[snap-bbox] bbox doesn't intersect the grid");
                    S = Math.max(S, 0), M = Math.min(M, t), k = Math.max(k, 0), N = Math.min(N, e);
                }
                const C = [
                    u(S),
                    u(N),
                    u(M),
                    u(k)
                ];
                r && console.log("[snap-bbox] bbox_in_grid_cells:", C);
                return {
                    bbox_in_coordinate_system: [
                        u(l + S * p),
                        u(c + N * d),
                        u(l + M * p),
                        u(c + k * d)
                    ],
                    bbox_in_grid_cells: C
                };
            }
            void 0 === (n = (function() {
                return i;
            }).call(e, r, e, t)) || (t.exports = n), t.exports = i;
        },
        function(t, e, r) {
            var n;
            const i = r(19), o = r(86), a = r(37), s = r(12), u = r(144), l = r(145), c = r(87), f = r(48), h = r(42), p = r(39);
            function d({ bbox: t, container: e, debug: r, origin: n, overflow: d, padding: m, scale: y, size: g }) {
                r && console.log("[snap-bbox] starting"), r && console.log("[snap-bbox] bbox:", t), r && console.log("[snap-bbox] debug:", r), r && console.log("[snap-bbox] origin:", n), r && console.log("[snap-bbox] overflow:", d), r && console.log("[snap-bbox] padding:", m), r && console.log("[snap-bbox] scale:", y);
                const [v, b] = n;
                r && console.log("[snap-bbox] originX:", v), r && console.log("[snap-bbox] originY:", b);
                const [x, w] = m || [
                    "0",
                    "0"
                ];
                r && console.log("[snap-bbox] padX:", x), r && console.log("[snap-bbox] padY:", w);
                const [_, A] = y;
                r && console.log("[snap-bbox] scale_x:", _), r && console.log("[snap-bbox] scale_y:", A);
                const E = h(_), S = h(A);
                r && console.log("[snap-bbox] sign_scale_x:", E), r && console.log("[snap-bbox] sign_scale_y:", S);
                const [M, k, N, C] = t;
                r && console.log("[snap-bbox] xmin:", M), r && console.log("[snap-bbox] ymin:", k), r && console.log("[snap-bbox] xmax:", N), r && console.log("[snap-bbox] ymax:", C);
                const D = s(p(M, v), _), O = s(p(N, v), _), T = s(p(C, b), A), F = s(p(k, b), A);
                r && console.log("[snap-bbox] left:", D), r && console.log("[snap-bbox] right:", O), r && console.log("[snap-bbox] top:", T), r && console.log("[snap-bbox] bottom:", F);
                let P = p(u(D), x), I = i(o(O), x), B = p(u(T), w), j = i(o(F), w);
                if (r && console.log("[snap-bbox] left_int:", P), r && console.log("[snap-bbox] right_int:", I), r && console.log("[snap-bbox] top_int:", B), r && console.log("[snap-bbox] bottom_int:", j), e) {
                    r && console.log("[snap-bbox] container:", e);
                    const t = s(p(e[0], v), _), n = s(p(e[2], v), _), i = s(p(e[3], b), A), a = s(p(e[1], b), A);
                    r && console.log("[snap-bbox] min_left:", t), r && console.log("[snap-bbox] max_right:", n), r && console.log("[snap-bbox] min_top:", i), r && console.log("[snap-bbox] max_bottom:", a);
                    const f = o(t), h = u(n), d = o(i), m = u(a);
                    r && console.log("[snap-bbox] min_left_int:", f), r && console.log("[snap-bbox] max_right_int:", h), r && console.log("[snap-bbox] min_top_int:", d), r && console.log("[snap-bbox] max_bottom_int:", m), P = l(P, f), I = c(I, h), B = l(B, d), j = c(j, m), r && console.log("[snap-bbox] after containment, left_int:", P), r && console.log("[snap-bbox] after containment, right_int:", I), r && console.log("[snap-bbox] after containment, top_int:", B), r && console.log("[snap-bbox] after containment, bottom_int:", j);
                }
                if (g && !1 === d) {
                    r && console.log("[snap-bbox] size:", g);
                    const [t, e] = g;
                    if (r && console.log("[snap-bbox] width:", t), r && console.log("[snap-bbox] height:", e), ">" === a(P, t) || "<" === a(I, "0") || "<" === a(j, "0") || ">" === a(B, e)) throw new Error("[snap-bbox] bbox doesn't intersect the grid");
                    P = l(P, "0"), I = c(I, t), B = l(B, "0"), j = c(j, e);
                }
                const R = [
                    P,
                    j,
                    I,
                    B
                ];
                r && console.log("[snap-bbox] bbox_in_grid_cells:", R);
                return {
                    bbox_in_coordinate_system: [
                        i(v, f(P, _)),
                        i(b, f(j, A)),
                        i(v, f(I, _)),
                        i(b, f(B, A))
                    ],
                    bbox_in_grid_cells: R
                };
            }
            void 0 === (n = (function() {
                return d;
            }).call(e, r, e, t)) || (t.exports = n), t.exports = d;
        },
        function(t, e, r) {
            function n(t) {
                try {
                    t[Symbol.iterator] = function() {
                        return this;
                    };
                } catch (t) {}
            }
            function i(t) {
                t["@@iterator"] = function() {
                    return this;
                };
            }
            function o(t) {
                const e = {
                    next: t
                };
                return n(e), i(e), e;
            }
            function a(t) {
                try {
                    return t.constructor.name.endsWith("Array");
                } catch  {
                    return !1;
                }
            }
            function s(t) {
                try {
                    return "function" == typeof t.next;
                } catch  {
                    return !1;
                }
            }
            function u(t) {
                try {
                    return "@@iterator" in t;
                } catch  {
                    return !1;
                }
            }
            function l(t) {
                try {
                    return Symbol.iterator in t.constructor.prototype;
                } catch  {
                    return !1;
                }
            }
            function c(t) {
                try {
                    return Symbol.iterator in t && "function" == typeof t.next && !1 === t.propertyIsEnumerable("next");
                } catch  {
                    return !1;
                }
            }
            function f(t) {
                const e = t["@@iterator"];
                return s(e) ? e : "function" == typeof e ? e() : void 0;
            }
            function h(t) {
                let e = 0, r = t.length;
                return o(()=>e++ < r ? {
                        value: t[e],
                        done: !1
                    } : {
                        done: !0
                    });
            }
            function p(t) {
                if (c(t)) return t;
                if (l(t)) return t[Symbol.iterator]();
                if (s(t)) return o(t.next);
                if (u(t)) return f(t);
                if ("string" == typeof t || a(t)) return h(t);
                throw "[iter-fun] unable to determine iterator";
            }
            t.exports = {
                addSymbolIterator: n,
                addSymbolIteratorFallback: i,
                isIterator: c,
                isArray: a,
                hasNext: s,
                hasSymbolIterator: l,
                hasIterator: u,
                getIterator: f,
                createIterator: h,
                getOrCreateIterator: p,
                wrapNextFunction: o,
                zip: function(t) {
                    return t = t.map(p), o(function() {
                        const e = t.map((t)=>t.next());
                        return e.every(({ done: t })=>t) ? {
                            done: !0
                        } : {
                            done: !1,
                            value: e.map(({ value: t })=>t)
                        };
                    });
                }
            };
        },
        function(t, e, r) {
            "use strict";
            var n;
            const i = r(21), o = r(19), a = r(270), s = r(86), u = r(3), l = r(37), c = r(20), f = r(271), h = r(273), p = r(80), d = r(151), m = r(276), y = r(277), g = r(12), v = r(154), b = r(155), x = r(130), w = r(146), _ = r(278), A = r(144), E = r(147), S = r(279), M = r(280), k = r(38), N = r(40), C = r(156), D = r(157), O = r(28), T = r(26), F = r(58), P = r(79), I = r(57), B = r(145), j = {
                absolute: i,
                add: o,
                binomial_coefficient: a,
                ceil: s,
                clean: u,
                compare: l,
                compare_positive: c,
                constants: f,
                cosine_radians: h,
                count_decimal_digits: p,
                count_integer_digits: d,
                cube: m,
                cube_root: y,
                divide: g,
                eulers_number: v,
                exp: b,
                expand: x,
                factorial: w,
                flip_sign: _,
                floor: A,
                fraction: E,
                hypotenuse: S,
                is_infinity: k,
                is_integer: N,
                is_factorial: M,
                is_negative_infinity: C,
                is_positive_infinity: D,
                is_zero: O,
                long_addition: T,
                long_division: F,
                long_multiplication: P,
                long_subtraction: I,
                mean: r(281),
                max: B,
                min: r(87),
                multiply: r(48),
                multiply_array: r(132),
                multiply_range: r(88),
                nilakantha: r(282),
                ols: r(283),
                pow: r(61),
                pow_positive: r(89),
                primes: r(153),
                reciprocal: r(148),
                remainder: r(284),
                root: r(62),
                root_integer_digits: r(150),
                round: r(59),
                round_last_decimal: r(77),
                sign: r(42),
                sign_nonzero: r(81),
                simplify_fraction: r(152),
                sine_radians: r(285),
                softmax: r(286),
                sort: r(287),
                square: r(50),
                square_root: r(158),
                subtract: r(39),
                sum: r(90),
                truncate: r(159)
            };
            void 0 === (n = (function() {
                return j;
            }).call(e, r, e, t)) || (t.exports = n), t.exports = j, t.exports.default = j, "object" == typeof window && (window.preciso = j), "object" == typeof self && (self.preciso = j);
        },
        function(t, e, r) {
            "use strict";
            const n = r(3), i = r(20), o = r(146), a = r(26), s = r(57), u = r(58), l = r(88);
            function c(t, e) {
                switch(t = n(t), e = n(e), i(t, e)){
                    case "=":
                        return "1";
                    case ">":
                        {
                            const r = s(t, e), n = l(a(e, "1"), t), i = o(r);
                            return u(n, i);
                        }
                    case "<":
                        throw new Error("[binominal_coefficient] unsupported");
                }
            }
            t.exports = c, t.exports.default = c;
        },
        function(t, e, r) {
            "use strict";
            const { MAX_SAFE_INTEGER: n } = r(131), { MAX_SAFE_INTEGER_LENGTH: i } = r(56), { PI: o } = r(272);
            t.exports = {
                MAX_SAFE_INTEGER: n,
                MAX_SAFE_INTEGER_LENGTH: i,
                PI: o
            };
        },
        function(t, e) {
            t.exports = {
                PI_100: "3.1415926535897932384626433832795028841971693993751058209749445923078164062862089986280348253421170679"
            };
        },
        function(t, e, r) {
            "use strict";
            const n = r(19), i = r(28), o = r(50), a = r(41), s = r(12);
            function u(t, { steps: e = 100, max_decimal_digits: r = 100 } = {}) {
                if (i(t)) return "0";
                let u, l = "-", c = "1", f = e, h = o(t), p = "1", d = "1", m = "0";
                for(let t = 0; t < f; t++){
                    u = n(m, "1"), m = n(u, "1"), p = a([
                        p,
                        h
                    ], {
                        max_decimal_digits: r
                    }), d = a([
                        d,
                        u,
                        m
                    ], {
                        max_decimal_digits: r
                    });
                    const t = s(p, d, {
                        max_decimal_digits: r
                    });
                    c = n(c, l + t), l = "-" === l ? "+" : "-";
                }
                return c;
            }
            t.exports = u, t.exports.default = u;
        },
        function(t, e, r) {
            "use strict";
            function n(t) {
                return t.includes("/");
            }
            t.exports = n, t.exports.default = n;
        },
        function(t, e, r) {
            "use strict";
            function n(t) {
                return t.split("/");
            }
            t.exports = n, t.exports.default = n;
        },
        function(t, e, r) {
            "use strict";
            const n = r(61);
            function i(t, e) {
                return n(t, "3", e);
            }
            t.exports = i, t.exports.default = i;
        },
        function(t, e, r) {
            "use strict";
            const n = r(62);
            function i(t, e) {
                return n(t, "3", e);
            }
            t.exports = i, t.exports.default = i;
        },
        function(t, e, r) {
            "use strict";
            const n = r(21), i = r(3), o = r(42);
            function a(t) {
                t = i(t);
                const e = o(t);
                return "" === e ? t : "-" === e ? n(t) : "+" === e ? "-" + t : void 0;
            }
            t.exports = a, t.exports.default = a;
        },
        function(t, e, r) {
            "use strict";
            const n = r(50), i = r(158), o = r(90);
            function a() {
                const t = Array.from(arguments), e = "object" == typeof t[t.length - 1] ? t[t.length - 1] : void 0, r = Array.isArray(t[0]) ? t[0] : e ? t.slice(0, t.length - 1) : t, a = r.map((t)=>n(t));
                return i(o(a), e);
            }
            t.exports = a, t.exports.default = a;
        },
        function(t, e, r) {
            "use strict";
            function n(t) {
                return !!t.match(/^\d+!$/i);
            }
            t.exports = n, t.exports.default = n;
        },
        function(t, e, r) {
            "use strict";
            const n = r(19), i = r(12);
            function o(t, e) {
                let r = 0, o = "0";
                for (let e of t)r++, o = n(o, e);
                return i(o, r.toString(), e);
            }
            t.exports = o, t.exports.default = o;
        },
        function(t, e, r) {
            "use strict";
            const n = r(19), i = r(26), o = r(12), a = r(41);
            function s(t = 100, { divide_options: e } = {}) {
                let r = "+", s = "3", u = "2", l = "3", c = "4";
                for(let f = 1; f < t; f++){
                    const t = a([
                        u,
                        l,
                        c
                    ]), f = r + o("4", t, e);
                    s = n(s, f), r = "-" === r ? "+" : "-", u = c, l = i(c, "1"), c = i(l, "1");
                }
                return s;
            }
            t.exports = s, t.exports.default = s;
        },
        function(t, e, r) {
            "use strict";
            const n = r(19), i = r(12), o = r(41), a = r(59), s = r(39), u = r(50);
            function l(t, e) {
                const r = t.length;
                let l = "0", c = "0", f = "0", h = "0";
                if (0 === r) throw Error("[preciso] zero points passed to linear_regression");
                for(let e = 0; e < r; e++){
                    const [r, i] = t[e];
                    l = n(l, r), c = n(c, u(r)), f = n(f, i), h = n(h, u(i));
                }
                const p = r.toString(), d = i(l, p), m = i(f, p);
                let y = "0", g = "0";
                for(let e = 0; e < r; e++){
                    const [r, i] = t[e], a = s(r, d), l = s(i, m), c = o([
                        a,
                        l
                    ]);
                    y = n(y, c);
                    const f = u(a);
                    g = n(g, f);
                }
                let v = i(y, g), b = s(m, o(v, d));
                return e && "number" == typeof e.max_decimal_digits && (v = a(v, {
                    digits: e.max_decimal_digits
                }), b = a(b, {
                    digits: e.max_decimal_digits
                })), {
                    m: v,
                    b: b
                };
            }
            t.exports = l, t.exports.default = l;
        },
        function(t, e, r) {
            "use strict";
            const n = r(21), i = r(3), o = r(20), a = r(58), s = r(48), u = r(39), l = r(159);
            function c(t, e) {
                t = i(t), e = i(e);
                const r = "-" === t[0] ? "-" : "";
                t = n(t), e = n(e);
                const c = o(t, e);
                if ("=" === c) return "0";
                if ("<" === c) return "." === t[0] && (t = "0" + t), r + t;
                const f = a(t, e, {
                    max_decimal_places: 0
                }), h = l(f), p = s(e, h);
                return r + u(t, p);
            }
            t.exports = c, t.exports.default = c;
        },
        function(t, e, r) {
            "use strict";
            const n = r(19), i = r(28), o = r(50), a = r(41), s = r(12);
            function u(t, { steps: e = 100, max_decimal_digits: r = 100 } = {}) {
                if (i(t)) return "0";
                let u, l = "-", c = t, f = e, h = o(t), p = t, d = "1", m = "1";
                for(let t = 0; t < f; t++){
                    u = n(m, "1"), m = n(u, "1"), p = a([
                        p,
                        h
                    ], {
                        max_decimal_digits: r
                    }), d = a([
                        d,
                        u,
                        m
                    ], {
                        max_decimal_digits: r
                    });
                    const t = s(p, d, {
                        max_decimal_digits: r
                    });
                    c = n(c, l + t), l = "-" === l ? "+" : "-";
                }
                return c;
            }
            t.exports = u, t.exports.default = u;
        },
        function(t, e, r) {
            "use strict";
            const n = r(12), i = r(155), o = r(90);
            function a(t, { max_decimal_digits: e }) {
                t = t.map((t)=>i(t, {
                        max_decimal_digits: e
                    }));
                const r = o(t);
                return t.map((t)=>n(t, r, {
                        max_decimal_digits: e,
                        ellipsis: !1
                    }));
            }
            t.exports = a, t.exports.default = a;
        },
        function(t, e, r) {
            "use strict";
            const n = r(37);
            function i(t, { direction: e = "ascending" } = {
                direction: "ascending"
            }) {
                const r = "desc" === e || "descending" === e ? "<" : ">";
                return t.sort((t, e)=>n(t, e) === r ? 1 : -1);
            }
            t.exports = i, t.exports.default = i;
        },
        function(t, e, r) {
            var n;
            const i = r(289), o = r(298);
            function a({ counts: t, nums: e, no_data: r, precise: n, threshold: a = 50, total: s }) {
                return void 0 !== t || void 0 !== s || e.length > a ? i({
                    counts: t,
                    no_data: r,
                    nums: e,
                    precise: n,
                    total: s
                }) : o({
                    no_data: r,
                    nums: e,
                    precise: n
                });
            }
            const s = {
                calculate: a
            };
            void 0 === (n = (function() {
                return s;
            }).call(e, r, e, t)) || (t.exports = n), t.exports = s, t.exports.default = {
                calculate: a
            }, "object" == typeof window && (window.mediana = s), "object" == typeof self && (self.mediana = s);
        },
        function(t, e, r) {
            const n = r(290), i = r(160);
            function o({ counts: t, nums: e, no_data: r, precise: o = !1, total: a }) {
                void 0 !== t && void 0 !== a || ({ counts: t, total: a } = n({
                    nums: e,
                    no_data: r
                }));
                const s = Object.values(t).sort((t, e)=>t.n - e.n), u = a / 2, l = s.length;
                if (0 !== l) {
                    if (1 === l) return o ? s[0].n.toString() : s[0].n;
                    {
                        let t = 0;
                        if (a % 2 == 0) for(let e = 0; e < l; e++){
                            const { n: r, ct: n } = s[e];
                            if (t += n, t > u) return t - n === u ? i(s[e - 1].n, r, {
                                precise: o
                            }) : o ? r.toString() : r;
                        }
                        else for(let e = 0; e < l; e++){
                            const { n: r, ct: n } = s[e];
                            if (t += n, t > u) return o ? r.toString() : r;
                        }
                    }
                }
            }
            t.exports = o, t.exports.default = o;
        },
        function(t, e) {
            function r({ nums: t, no_data: e }) {
                let r = t.length;
                const n = {};
                let i = 0;
                if (void 0 !== e) for(let o = 0; o < r; o++){
                    const r = t[o];
                    r !== e && (i++, r in n ? n[r].ct++ : n[r] = {
                        n: r,
                        ct: 1
                    });
                }
                else for(let e = 0; e < r; e++){
                    const r = t[e];
                    i++, r in n ? n[r].ct++ : n[r] = {
                        n: r,
                        ct: 1
                    };
                }
                return {
                    counts: n,
                    total: i
                };
            }
            t.exports = r, t.exports.default = r;
        },
        function(t, e) {
            function r(t) {
                "+" === t[0] && (t = t.substring(1));
                const e = "-" === t[0] ? "-" : "";
                "-" === e && (t = t.substring(1));
                const r = t.indexOf("e");
                if (-1 === r) return e + t;
                let n = t.indexOf(".");
                -1 === n && (n = r);
                const i = Number(t.substring(r + 1)), o = t.substring(0, r).replace(".", ""), a = n + i, s = o.length;
                if (a >= s) {
                    const t = a - s;
                    let r = o;
                    for(let e = 0; e < t; e++)r += "0";
                    return e + r;
                }
                if (a < 0) {
                    result = "0.";
                    for(let t = 0; t > a; t--)result += "0";
                    return result += o, e + result;
                }
                return e + o.substring(0, a) + "." + o.substring(a);
            }
            t.exports = r, t.exports.default = r;
        },
        function(t, e, r) {
            const n = r(164), i = r(43), o = r(293);
            function a(t, e, r) {
                if (t = i(t), "0" === (e = i(e))) throw new Error("[preciso] division by zero");
                if ("" === t || "0" === t) return "0";
                const a = "-" !== t[0], s = "-" !== e[0], u = a !== s ? "-" : "";
                return a || (t = n(t)), s || (e = n(e)), u + o(t, e, r);
            }
            t.exports = a, t.exports.default = a;
        },
        function(t, e, r) {
            const n = r(63), i = r(161), o = (r(294), r(296)), a = r(297);
            t.exports = function(t, e, { max_decimal_digits: r = 100, ellipsis: s = !1 } = {}) {
                "0" === t[0] && (t = t.substring(1)), "0" === e[0] && (e = e.substring(1));
                const u = t.indexOf("."), l = e.indexOf("."), c = -1 === u ? t.length : u, f = -1 === l ? 0 : e.length - 1 - l;
                let h = !1;
                t = t.replace(/\./, ""), e = e.replace(/\./, "");
                const p = t.length;
                let d, m = "", y = "", g = -1 * f, v = 0;
                for(let r = 0; r < p; r++)if (m += t[r], d = n(m, e), ">" === d) {
                    let t = 1, r = i(e, e), a = e;
                    for(; ">" !== n(r, m);)t++, a = r, r = i(r, e);
                    if (t = t.toString(), "" !== y) for(let e = t.length; e <= v; e++)y += "0";
                    y += t, m = o(m, a), v = 0;
                } else {
                    if ("<" === d) {
                        "" === y && g++, v++;
                        continue;
                    }
                    if ("=" === d) {
                        if ("" !== y) for(let t = 0; t < v; t++)y += "0";
                        y += "1", m = "0", v = 0;
                    }
                }
                if (m.match(/^0+$/g)) "<" === d && (y += m.substring(0, m.length - 1));
                else {
                    const t = {}, a = c - g - y.length + r + 1;
                    "" === y && (v = 0);
                    for(let r = 0; r < a; r++){
                        if (m += "0", s) {
                            if (m in t) {
                                if (t[m]++, t[m] > 3) {
                                    y += "...", h = !0;
                                    break;
                                }
                            } else t[m] = 1;
                        }
                        const r = n(m, e);
                        if (">" === r) {
                            let t = 1, r = i(e, e), a = e;
                            for(; ">" !== n(r, m);)t++, a = r, r = i(r, e);
                            t = t.toString();
                            for(let e = t.length; e <= v; e++)y += "0";
                            if (y += t, m = o(m, a), "0" === m) break;
                            v = 0;
                        } else {
                            if ("<" === r) {
                                v++;
                                continue;
                            }
                            if ("=" === r) {
                                for(let t = 0; t < v; t++)y += "0";
                                y += "1", v = 0;
                                break;
                            }
                        }
                    }
                }
                const b = c - g, x = y.length;
                let w;
                if (b === x) w = 0;
                else if (b < 0) y = "0." + "0".repeat(Math.abs(b)) + y, w = x - b;
                else if (b > x) {
                    for(let t = x; t < b; t++)y += "0";
                    w = 0;
                } else b < x ? (y = y.substring(0, b) + "." + y.substring(b), w = x - b) : 0 === b && (y = "0." + y, w = x);
                if (y = y.replace(/^0+/, ""), y = y.replace(/\.\d+0+$/, ""), !h) {
                    const t = w - r;
                    t > 0 && (y = a(y.substring(0, y.length - t + 1)));
                }
                return "." === y[0] && (y = "0" + y), y;
            };
        },
        function(t, e, r) {
            const n = r(164), i = r(43), o = r(63), a = r(295);
            function s(t, e) {
                t = i(t), e = i(e);
                const r = "-" !== t[0] !== ("-" !== e[0]) ? "-" : "";
                t = n(t), e = n(e);
                if ("<" === o(t, e)) {
                    const r = t;
                    t = e, e = r;
                }
                return r + a(t, e);
            }
            t.exports = s, t.exports.default = s;
        },
        function(t, e, r) {
            const { MAX_SAFE_INTEGER_LENGTH: n } = r(91);
            t.exports = function(t, e) {
                if ("0" === t || "0" === e) return "0";
                const r = t.indexOf("."), i = e.indexOf("."), o = (-1 === r ? t.length : r) + (-1 === i ? e.length : i), a = (-1 === r ? 0 : t.length - 1 - r) + (-1 === i ? 0 : e.length - 1 - i);
                if (0 === a && o < n) return (Number(t) * Number(e)).toFixed(0);
                const s = t.replace(".", ""), u = e.replace(".", ""), l = s.length, c = u.length, f = [];
                let h = l;
                for(; h >= 0;){
                    const t = h, e = h -= 15, r = s.substring(e, t);
                    f.push([
                        Number(r),
                        r.length
                    ]);
                }
                const p = [], d = [];
                for(let t = 0, e = c - 1; e >= 0; e--, t++){
                    const r = u[e], n = Number(r);
                    let i = 0, o = "";
                    const a = f.length - 1;
                    f.forEach(([t, e], r)=>{
                        let s = (i + n * t).toString();
                        const u = s.length;
                        if (u > e && r !== a) {
                            const t = -1 * e;
                            o = s.slice(t) + o, i = Number(s.slice(0, t));
                        } else {
                            const t = e - u;
                            for(let e = 0; e < t; e++)s = "0" + s;
                            i = 0, o = s + o;
                        }
                    }), o += "0".repeat(t), p.push(o), d.push([
                        Array.from(o).map((t)=>Number(t)),
                        o.length
                    ]);
                }
                const m = p.length, y = d[d.length - 1][1] + m;
                let g = "", v = 0;
                for(let t = 0; t < y; t++){
                    let e = v;
                    const r = Math.min(t, m - 1);
                    for(let n = 0; n <= r; n++){
                        const [r, i] = d[n], o = i - 1 - t;
                        o >= 0 && (e += r[o]);
                    }
                    e >= 10 ? (e = e.toString(), g = e[e.length - 1] + g, v = Number(e.slice(0, -1))) : (g = e + g, v = 0);
                }
                if (0 === a) g = g.replace(/^0+/, "");
                else {
                    const t = g.length - a;
                    g = g.substring(0, t) + "." + g.substring(t), g = g.replace(/^0+/, ""), g = g.replace(/\.?0+$/, ""), "." === g[0] && (g = "0" + g);
                }
                return g;
            };
        },
        function(t, e, r) {
            const n = r(43), i = r(63), o = r(162), a = r(163);
            function s(t, e) {
                t = n(t), e = n(e);
                const r = "-" !== t[0], s = "-" !== e[0];
                if (r) {
                    if (s) {
                        const r = i(t, e);
                        return ">" === r ? a(t, e) : "<" === r ? "-" + a(e, t) : "0";
                    }
                    return o(t, e.substring(1));
                }
                if (s) return "-" + o(t.substring(1), e);
                {
                    t = t.substring(1), e = e.substring(1);
                    const r = i(t, e);
                    return ">" === r ? "-" + a(t, e) : "<" === r ? a(e, t) : "0";
                }
            }
            t.exports = s, t.exports.default = s;
        },
        function(t, e) {
            const r = [
                "5",
                "6",
                "7",
                "8",
                "9"
            ];
            t.exports = function(t) {
                "+" === t[0] && (t = t.substring(1));
                const e = t.length;
                let n = "";
                const i = t[t.length - 1];
                if (r.includes(i)) {
                    let r;
                    for(r = e - 2; r >= 0; r--){
                        const e = t[r];
                        if ("." === e || "-" === e) continue;
                        const i = Number(e) + 1;
                        if (10 !== i) {
                            n = i + n;
                            break;
                        }
                        n = "0" + n;
                    }
                    r > 0 && (n = t.substring(0, r) + n);
                } else n = t.substring(0, e - 1);
                return "." === n[n.length - 1] && (n = n.substring(0, n.length - 1)), n.indexOf(".") > -1 && (n = n.replace(/0+$/, "")), n;
            };
        },
        function(t, e, r) {
            const n = r(160);
            function i({ nums: t, no_data: e, precise: r = !1 }) {
                switch((t = t.filter((t)=>t !== e).sort((t, e)=>t - e)).length){
                    case 0:
                        return;
                    case 1:
                        return r ? t[0].toString() : t[0];
                    default:
                        const e1 = t.length / 2;
                        if (t.length % 2 == 0) return n(t[e1 - 1], t[e1], {
                            precise: r
                        });
                        {
                            const n = Math.floor(e1);
                            return r ? t[n].toString() : t[n];
                        }
                }
            }
            t.exports = i, t.exports.default = i;
        },
        function(t, e, r) {
            "use strict";
            r.r(e);
            var n = 484813681109536e-20, i = Math.PI / 2, o = .017453292519943295, a = 57.29577951308232, s = Math.PI / 4, u = 2 * Math.PI, l = 3.14159265359, c = {
                greenwich: 0,
                lisbon: -9.131906111111,
                paris: 2.337229166667,
                bogota: -74.080916666667,
                madrid: -3.687938888889,
                rome: 12.452333333333,
                bern: 7.439583333333,
                jakarta: 106.807719444444,
                ferro: -17.666666666667,
                brussels: 4.367975,
                stockholm: 18.058277777778,
                athens: 23.7163375,
                oslo: 10.722916666667
            }, f = {
                ft: {
                    to_meter: .3048
                },
                "us-ft": {
                    to_meter: 1200 / 3937
                }
            }, h = /[\s_\-\/\(\)]/g;
            function p(t, e) {
                if (t[e]) return t[e];
                for(var r, n = Object.keys(t), i = e.toLowerCase().replace(h, ""), o = -1; ++o < n.length;)if ((r = n[o]).toLowerCase().replace(h, "") === i) return t[r];
            }
            var d = function(t) {
                var e, r, n, i = {}, a = t.split("+").map(function(t) {
                    return t.trim();
                }).filter(function(t) {
                    return t;
                }).reduce(function(t, e) {
                    var r = e.split("=");
                    return r.push(!0), t[r[0].toLowerCase()] = r[1], t;
                }, {}), s = {
                    proj: "projName",
                    datum: "datumCode",
                    rf: function(t) {
                        i.rf = parseFloat(t);
                    },
                    lat_0: function(t) {
                        i.lat0 = t * o;
                    },
                    lat_1: function(t) {
                        i.lat1 = t * o;
                    },
                    lat_2: function(t) {
                        i.lat2 = t * o;
                    },
                    lat_ts: function(t) {
                        i.lat_ts = t * o;
                    },
                    lon_0: function(t) {
                        i.long0 = t * o;
                    },
                    lon_1: function(t) {
                        i.long1 = t * o;
                    },
                    lon_2: function(t) {
                        i.long2 = t * o;
                    },
                    alpha: function(t) {
                        i.alpha = parseFloat(t) * o;
                    },
                    gamma: function(t) {
                        i.rectified_grid_angle = parseFloat(t);
                    },
                    lonc: function(t) {
                        i.longc = t * o;
                    },
                    x_0: function(t) {
                        i.x0 = parseFloat(t);
                    },
                    y_0: function(t) {
                        i.y0 = parseFloat(t);
                    },
                    k_0: function(t) {
                        i.k0 = parseFloat(t);
                    },
                    k: function(t) {
                        i.k0 = parseFloat(t);
                    },
                    a: function(t) {
                        i.a = parseFloat(t);
                    },
                    b: function(t) {
                        i.b = parseFloat(t);
                    },
                    r: function(t) {
                        i.a = i.b = parseFloat(t);
                    },
                    r_a: function() {
                        i.R_A = !0;
                    },
                    zone: function(t) {
                        i.zone = parseInt(t, 10);
                    },
                    south: function() {
                        i.utmSouth = !0;
                    },
                    towgs84: function(t) {
                        i.datum_params = t.split(",").map(function(t) {
                            return parseFloat(t);
                        });
                    },
                    to_meter: function(t) {
                        i.to_meter = parseFloat(t);
                    },
                    units: function(t) {
                        i.units = t;
                        var e = p(f, t);
                        e && (i.to_meter = e.to_meter);
                    },
                    from_greenwich: function(t) {
                        i.from_greenwich = t * o;
                    },
                    pm: function(t) {
                        var e = p(c, t);
                        i.from_greenwich = (e || parseFloat(t)) * o;
                    },
                    nadgrids: function(t) {
                        "@null" === t ? i.datumCode = "none" : i.nadgrids = t;
                    },
                    axis: function(t) {
                        3 === t.length && -1 !== "ewnsud".indexOf(t.substr(0, 1)) && -1 !== "ewnsud".indexOf(t.substr(1, 1)) && -1 !== "ewnsud".indexOf(t.substr(2, 1)) && (i.axis = t);
                    },
                    approx: function() {
                        i.approx = !0;
                    }
                };
                for(e in a)r = a[e], e in s ? "function" == typeof (n = s[e]) ? n(r) : i[n] = r : i[e] = r;
                return "string" == typeof i.datumCode && "WGS84" !== i.datumCode && (i.datumCode = i.datumCode.toLowerCase()), i;
            }, m = function(t) {
                return new w(t).output();
            }, y = /\s/, g = /[A-Za-z]/, v = /[A-Za-z84_]/, b = /[,\]]/, x = /[\d\.E\-\+]/;
            function w(t) {
                if ("string" != typeof t) throw new Error("not a string");
                this.text = t.trim(), this.level = 0, this.place = 0, this.root = null, this.stack = [], this.currentObject = null, this.state = 1;
            }
            function _(t, e, r) {
                Array.isArray(e) && (r.unshift(e), e = null);
                var n = e ? {} : t, i = r.reduce(function(t, e) {
                    return A(e, t), t;
                }, n);
                e && (t[e] = i);
            }
            function A(t, e) {
                if (Array.isArray(t)) {
                    var r = t.shift();
                    if ("PARAMETER" === r && (r = t.shift()), 1 === t.length) return Array.isArray(t[0]) ? (e[r] = {}, void A(t[0], e[r])) : void (e[r] = t[0]);
                    if (t.length) {
                        if ("TOWGS84" !== r) {
                            if ("AXIS" === r) return r in e || (e[r] = []), void e[r].push(t);
                            var n;
                            switch(Array.isArray(r) || (e[r] = {}), r){
                                case "UNIT":
                                case "PRIMEM":
                                case "VERT_DATUM":
                                    return e[r] = {
                                        name: t[0].toLowerCase(),
                                        convert: t[1]
                                    }, void (3 === t.length && A(t[2], e[r]));
                                case "SPHEROID":
                                case "ELLIPSOID":
                                    return e[r] = {
                                        name: t[0],
                                        a: t[1],
                                        rf: t[2]
                                    }, void (4 === t.length && A(t[3], e[r]));
                                case "PROJECTEDCRS":
                                case "PROJCRS":
                                case "GEOGCS":
                                case "GEOCCS":
                                case "PROJCS":
                                case "LOCAL_CS":
                                case "GEODCRS":
                                case "GEODETICCRS":
                                case "GEODETICDATUM":
                                case "EDATUM":
                                case "ENGINEERINGDATUM":
                                case "VERT_CS":
                                case "VERTCRS":
                                case "VERTICALCRS":
                                case "COMPD_CS":
                                case "COMPOUNDCRS":
                                case "ENGINEERINGCRS":
                                case "ENGCRS":
                                case "FITTED_CS":
                                case "LOCAL_DATUM":
                                case "DATUM":
                                    return t[0] = [
                                        "name",
                                        t[0]
                                    ], void _(e, r, t);
                                default:
                                    for(n = -1; ++n < t.length;)if (!Array.isArray(t[n])) return A(t, e[r]);
                                    return _(e, r, t);
                            }
                        } else e[r] = t;
                    } else e[r] = !0;
                } else e[t] = !0;
            }
            w.prototype.readCharicter = function() {
                var t = this.text[this.place++];
                if (4 !== this.state) for(; y.test(t);){
                    if (this.place >= this.text.length) return;
                    t = this.text[this.place++];
                }
                switch(this.state){
                    case 1:
                        return this.neutral(t);
                    case 2:
                        return this.keyword(t);
                    case 4:
                        return this.quoted(t);
                    case 5:
                        return this.afterquote(t);
                    case 3:
                        return this.number(t);
                    case -1:
                        return;
                }
            }, w.prototype.afterquote = function(t) {
                if ('"' === t) return this.word += '"', void (this.state = 4);
                if (b.test(t)) return this.word = this.word.trim(), void this.afterItem(t);
                throw new Error("havn't handled \"" + t + '" in afterquote yet, index ' + this.place);
            }, w.prototype.afterItem = function(t) {
                return "," === t ? (null !== this.word && this.currentObject.push(this.word), this.word = null, void (this.state = 1)) : "]" === t ? (this.level--, null !== this.word && (this.currentObject.push(this.word), this.word = null), this.state = 1, this.currentObject = this.stack.pop(), void (this.currentObject || (this.state = -1))) : void 0;
            }, w.prototype.number = function(t) {
                if (!x.test(t)) {
                    if (b.test(t)) return this.word = parseFloat(this.word), void this.afterItem(t);
                    throw new Error("havn't handled \"" + t + '" in number yet, index ' + this.place);
                }
                this.word += t;
            }, w.prototype.quoted = function(t) {
                '"' !== t ? this.word += t : this.state = 5;
            }, w.prototype.keyword = function(t) {
                if (v.test(t)) this.word += t;
                else {
                    if ("[" === t) {
                        var e = [];
                        return e.push(this.word), this.level++, null === this.root ? this.root = e : this.currentObject.push(e), this.stack.push(this.currentObject), this.currentObject = e, void (this.state = 1);
                    }
                    if (!b.test(t)) throw new Error("havn't handled \"" + t + '" in keyword yet, index ' + this.place);
                    this.afterItem(t);
                }
            }, w.prototype.neutral = function(t) {
                if (g.test(t)) return this.word = t, void (this.state = 2);
                if ('"' === t) return this.word = "", void (this.state = 4);
                if (x.test(t)) return this.word = t, void (this.state = 3);
                if (!b.test(t)) throw new Error("havn't handled \"" + t + '" in neutral yet, index ' + this.place);
                this.afterItem(t);
            }, w.prototype.output = function() {
                for(; this.place < this.text.length;)this.readCharicter();
                if (-1 === this.state) return this.root;
                throw new Error('unable to parse string "' + this.text + '". State is ' + this.state);
            };
            function E(t) {
                return .017453292519943295 * t;
            }
            var S = function(t) {
                var e = m(t), r = e.shift(), n = e.shift();
                e.unshift([
                    "name",
                    n
                ]), e.unshift([
                    "type",
                    r
                ]);
                var i = {};
                return A(e, i), function(t) {
                    if ("GEOGCS" === t.type ? t.projName = "longlat" : "LOCAL_CS" === t.type ? (t.projName = "identity", t.local = !0) : "object" == typeof t.PROJECTION ? t.projName = Object.keys(t.PROJECTION)[0] : t.projName = t.PROJECTION, t.AXIS) {
                        for(var e = "", r = 0, n = t.AXIS.length; r < n; ++r){
                            var i = [
                                t.AXIS[r][0].toLowerCase(),
                                t.AXIS[r][1].toLowerCase()
                            ];
                            -1 !== i[0].indexOf("north") || ("y" === i[0] || "lat" === i[0]) && "north" === i[1] ? e += "n" : -1 !== i[0].indexOf("south") || ("y" === i[0] || "lat" === i[0]) && "south" === i[1] ? e += "s" : -1 !== i[0].indexOf("east") || ("x" === i[0] || "lon" === i[0]) && "east" === i[1] ? e += "e" : -1 === i[0].indexOf("west") && ("x" !== i[0] && "lon" !== i[0] || "west" !== i[1]) || (e += "w");
                        }
                        2 === e.length && (e += "u"), 3 === e.length && (t.axis = e);
                    }
                    t.UNIT && (t.units = t.UNIT.name.toLowerCase(), "metre" === t.units && (t.units = "meter"), t.UNIT.convert && ("GEOGCS" === t.type ? t.DATUM && t.DATUM.SPHEROID && (t.to_meter = t.UNIT.convert * t.DATUM.SPHEROID.a) : t.to_meter = t.UNIT.convert));
                    var o = t.GEOGCS;
                    function a(e) {
                        return e * (t.to_meter || 1);
                    }
                    "GEOGCS" === t.type && (o = t), o && (o.DATUM ? t.datumCode = o.DATUM.name.toLowerCase() : t.datumCode = o.name.toLowerCase(), "d_" === t.datumCode.slice(0, 2) && (t.datumCode = t.datumCode.slice(2)), "new_zealand_geodetic_datum_1949" !== t.datumCode && "new_zealand_1949" !== t.datumCode || (t.datumCode = "nzgd49"), "wgs_1984" !== t.datumCode && "world_geodetic_system_1984" !== t.datumCode || ("Mercator_Auxiliary_Sphere" === t.PROJECTION && (t.sphere = !0), t.datumCode = "wgs84"), "_ferro" === t.datumCode.slice(-6) && (t.datumCode = t.datumCode.slice(0, -6)), "_jakarta" === t.datumCode.slice(-8) && (t.datumCode = t.datumCode.slice(0, -8)), ~t.datumCode.indexOf("belge") && (t.datumCode = "rnb72"), o.DATUM && o.DATUM.SPHEROID && (t.ellps = o.DATUM.SPHEROID.name.replace("_19", "").replace(/[Cc]larke\_18/, "clrk"), "international" === t.ellps.toLowerCase().slice(0, 13) && (t.ellps = "intl"), t.a = o.DATUM.SPHEROID.a, t.rf = parseFloat(o.DATUM.SPHEROID.rf, 10)), o.DATUM && o.DATUM.TOWGS84 && (t.datum_params = o.DATUM.TOWGS84), ~t.datumCode.indexOf("osgb_1936") && (t.datumCode = "osgb36"), ~t.datumCode.indexOf("osni_1952") && (t.datumCode = "osni52"), (~t.datumCode.indexOf("tm65") || ~t.datumCode.indexOf("geodetic_datum_of_1965")) && (t.datumCode = "ire65"), "ch1903+" === t.datumCode && (t.datumCode = "ch1903"), ~t.datumCode.indexOf("israel") && (t.datumCode = "isr93")), t.b && !isFinite(t.b) && (t.b = t.a), [
                        [
                            "standard_parallel_1",
                            "Standard_Parallel_1"
                        ],
                        [
                            "standard_parallel_1",
                            "Latitude of 1st standard parallel"
                        ],
                        [
                            "standard_parallel_2",
                            "Standard_Parallel_2"
                        ],
                        [
                            "standard_parallel_2",
                            "Latitude of 2nd standard parallel"
                        ],
                        [
                            "false_easting",
                            "False_Easting"
                        ],
                        [
                            "false_easting",
                            "False easting"
                        ],
                        [
                            "false-easting",
                            "Easting at false origin"
                        ],
                        [
                            "false_northing",
                            "False_Northing"
                        ],
                        [
                            "false_northing",
                            "False northing"
                        ],
                        [
                            "false_northing",
                            "Northing at false origin"
                        ],
                        [
                            "central_meridian",
                            "Central_Meridian"
                        ],
                        [
                            "central_meridian",
                            "Longitude of natural origin"
                        ],
                        [
                            "central_meridian",
                            "Longitude of false origin"
                        ],
                        [
                            "latitude_of_origin",
                            "Latitude_Of_Origin"
                        ],
                        [
                            "latitude_of_origin",
                            "Central_Parallel"
                        ],
                        [
                            "latitude_of_origin",
                            "Latitude of natural origin"
                        ],
                        [
                            "latitude_of_origin",
                            "Latitude of false origin"
                        ],
                        [
                            "scale_factor",
                            "Scale_Factor"
                        ],
                        [
                            "k0",
                            "scale_factor"
                        ],
                        [
                            "latitude_of_center",
                            "Latitude_Of_Center"
                        ],
                        [
                            "latitude_of_center",
                            "Latitude_of_center"
                        ],
                        [
                            "lat0",
                            "latitude_of_center",
                            E
                        ],
                        [
                            "longitude_of_center",
                            "Longitude_Of_Center"
                        ],
                        [
                            "longitude_of_center",
                            "Longitude_of_center"
                        ],
                        [
                            "longc",
                            "longitude_of_center",
                            E
                        ],
                        [
                            "x0",
                            "false_easting",
                            a
                        ],
                        [
                            "y0",
                            "false_northing",
                            a
                        ],
                        [
                            "long0",
                            "central_meridian",
                            E
                        ],
                        [
                            "lat0",
                            "latitude_of_origin",
                            E
                        ],
                        [
                            "lat0",
                            "standard_parallel_1",
                            E
                        ],
                        [
                            "lat1",
                            "standard_parallel_1",
                            E
                        ],
                        [
                            "lat2",
                            "standard_parallel_2",
                            E
                        ],
                        [
                            "azimuth",
                            "Azimuth"
                        ],
                        [
                            "alpha",
                            "azimuth",
                            E
                        ],
                        [
                            "srsCode",
                            "name"
                        ]
                    ].forEach(function(e) {
                        var r, n, i, o;
                        return r = t, i = (n = e)[0], o = n[1], void (!(i in r) && o in r && (r[i] = r[o], 3 === n.length && (r[i] = n[2](r[i]))));
                    }), t.long0 || !t.longc || "Albers_Conic_Equal_Area" !== t.projName && "Lambert_Azimuthal_Equal_Area" !== t.projName || (t.long0 = t.longc), t.lat_ts || !t.lat1 || "Stereographic_South_Pole" !== t.projName && "Polar Stereographic (variant B)" !== t.projName ? !t.lat_ts && t.lat0 && "Polar_Stereographic" === t.projName && (t.lat_ts = t.lat0, t.lat0 = E(t.lat0 > 0 ? 90 : -90)) : (t.lat0 = E(t.lat1 > 0 ? 90 : -90), t.lat_ts = t.lat1);
                }(i), i;
            };
            function M(t) {
                var e = this;
                if (2 === arguments.length) {
                    var r = arguments[1];
                    "string" == typeof r ? "+" === r.charAt(0) ? M[t] = d(arguments[1]) : M[t] = S(arguments[1]) : M[t] = r;
                } else if (1 === arguments.length) {
                    if (Array.isArray(t)) return t.map(function(t) {
                        Array.isArray(t) ? M.apply(e, t) : M(t);
                    });
                    if ("string" == typeof t) {
                        if (t in M) return M[t];
                    } else "EPSG" in t ? M["EPSG:" + t.EPSG] = t : "ESRI" in t ? M["ESRI:" + t.ESRI] = t : "IAU2000" in t ? M["IAU2000:" + t.IAU2000] = t : console.log(t);
                    return;
                }
            }
            !function(t) {
                t("EPSG:4326", "+title=WGS 84 (long/lat) +proj=longlat +ellps=WGS84 +datum=WGS84 +units=degrees"), t("EPSG:4269", "+title=NAD83 (long/lat) +proj=longlat +a=6378137.0 +b=6356752.31414036 +ellps=GRS80 +datum=NAD83 +units=degrees"), t("EPSG:3857", "+title=WGS 84 / Pseudo-Mercator +proj=merc +a=6378137 +b=6378137 +lat_ts=0.0 +lon_0=0.0 +x_0=0.0 +y_0=0 +k=1.0 +units=m +nadgrids=@null +no_defs"), t.WGS84 = t["EPSG:4326"], t["EPSG:3785"] = t["EPSG:3857"], t.GOOGLE = t["EPSG:3857"], t["EPSG:900913"] = t["EPSG:3857"], t["EPSG:102113"] = t["EPSG:3857"];
            }(M);
            var k = M;
            var N = [
                "PROJECTEDCRS",
                "PROJCRS",
                "GEOGCS",
                "GEOCCS",
                "PROJCS",
                "LOCAL_CS",
                "GEODCRS",
                "GEODETICCRS",
                "GEODETICDATUM",
                "ENGCRS",
                "ENGINEERINGCRS"
            ];
            var C = [
                "3857",
                "900913",
                "3785",
                "102113"
            ];
            var D = function(t) {
                if (!function(t) {
                    return "string" == typeof t;
                }(t)) return t;
                if (function(t) {
                    return t in k;
                }(t)) return k[t];
                if (function(t) {
                    return N.some(function(e) {
                        return t.indexOf(e) > -1;
                    });
                }(t)) {
                    var e = S(t);
                    if (function(t) {
                        var e = p(t, "authority");
                        if (e) {
                            var r = p(e, "epsg");
                            return r && C.indexOf(r) > -1;
                        }
                    }(e)) return k["EPSG:3857"];
                    var r = function(t) {
                        var e = p(t, "extension");
                        if (e) return p(e, "proj4");
                    }(e);
                    return r ? d(r) : e;
                }
                return function(t) {
                    return "+" === t[0];
                }(t) ? d(t) : void 0;
            }, O = function(t, e) {
                var r, n;
                if (t = t || {}, !e) return t;
                for(n in e)void 0 !== (r = e[n]) && (t[n] = r);
                return t;
            }, T = function(t, e, r) {
                var n = t * e;
                return r / Math.sqrt(1 - n * n);
            }, F = function(t) {
                return t < 0 ? -1 : 1;
            }, P = function(t) {
                return Math.abs(t) <= l ? t : t - F(t) * u;
            }, I = function(t, e, r) {
                var n = t * r, o = .5 * t;
                return n = Math.pow((1 - n) / (1 + n), o), Math.tan(.5 * (i - e)) / n;
            }, B = function(t, e) {
                for(var r, n, o = .5 * t, a = i - 2 * Math.atan(e), s = 0; s <= 15; s++)if (r = t * Math.sin(a), a += n = i - 2 * Math.atan(e * Math.pow((1 - r) / (1 + r), o)) - a, Math.abs(n) <= 1e-10) return a;
                return -9999;
            };
            function j(t) {
                return t;
            }
            var R = [
                {
                    init: function() {
                        var t = this.b / this.a;
                        this.es = 1 - t * t, "x0" in this || (this.x0 = 0), "y0" in this || (this.y0 = 0), this.e = Math.sqrt(this.es), this.lat_ts ? this.sphere ? this.k0 = Math.cos(this.lat_ts) : this.k0 = T(this.e, Math.sin(this.lat_ts), Math.cos(this.lat_ts)) : this.k0 || (this.k ? this.k0 = this.k : this.k0 = 1);
                    },
                    forward: function(t) {
                        var e, r, n = t.x, o = t.y;
                        if (o * a > 90 && o * a < -90 && n * a > 180 && n * a < -180) return null;
                        if (Math.abs(Math.abs(o) - i) <= 1e-10) return null;
                        if (this.sphere) e = this.x0 + this.a * this.k0 * P(n - this.long0), r = this.y0 + this.a * this.k0 * Math.log(Math.tan(s + .5 * o));
                        else {
                            var u = Math.sin(o), l = I(this.e, o, u);
                            e = this.x0 + this.a * this.k0 * P(n - this.long0), r = this.y0 - this.a * this.k0 * Math.log(l);
                        }
                        return t.x = e, t.y = r, t;
                    },
                    inverse: function(t) {
                        var e, r, n = t.x - this.x0, o = t.y - this.y0;
                        if (this.sphere) r = i - 2 * Math.atan(Math.exp(-o / (this.a * this.k0)));
                        else {
                            var a = Math.exp(-o / (this.a * this.k0));
                            if (-9999 === (r = B(this.e, a))) return null;
                        }
                        return e = P(this.long0 + n / (this.a * this.k0)), t.x = e, t.y = r, t;
                    },
                    names: [
                        "Mercator",
                        "Popular Visualisation Pseudo Mercator",
                        "Mercator_1SP",
                        "Mercator_Auxiliary_Sphere",
                        "merc"
                    ]
                },
                {
                    init: function() {},
                    forward: j,
                    inverse: j,
                    names: [
                        "longlat",
                        "identity"
                    ]
                }
            ], L = {}, q = [];
            function U(t, e) {
                var r = q.length;
                return t.names ? (q[r] = t, t.names.forEach(function(t) {
                    L[t.toLowerCase()] = r;
                }), this) : (console.log(e), !0);
            }
            var z = {
                start: function() {
                    R.forEach(U);
                },
                add: U,
                get: function(t) {
                    if (!t) return !1;
                    var e = t.toLowerCase();
                    return void 0 !== L[e] && q[L[e]] ? q[L[e]] : void 0;
                }
            }, G = {
                MERIT: {
                    a: 6378137,
                    rf: 298.257,
                    ellipseName: "MERIT 1983"
                },
                SGS85: {
                    a: 6378136,
                    rf: 298.257,
                    ellipseName: "Soviet Geodetic System 85"
                },
                GRS80: {
                    a: 6378137,
                    rf: 298.257222101,
                    ellipseName: "GRS 1980(IUGG, 1980)"
                },
                IAU76: {
                    a: 6378140,
                    rf: 298.257,
                    ellipseName: "IAU 1976"
                },
                airy: {
                    a: 6377563.396,
                    b: 6356256.91,
                    ellipseName: "Airy 1830"
                },
                APL4: {
                    a: 6378137,
                    rf: 298.25,
                    ellipseName: "Appl. Physics. 1965"
                },
                NWL9D: {
                    a: 6378145,
                    rf: 298.25,
                    ellipseName: "Naval Weapons Lab., 1965"
                },
                mod_airy: {
                    a: 6377340.189,
                    b: 6356034.446,
                    ellipseName: "Modified Airy"
                },
                andrae: {
                    a: 6377104.43,
                    rf: 300,
                    ellipseName: "Andrae 1876 (Den., Iclnd.)"
                },
                aust_SA: {
                    a: 6378160,
                    rf: 298.25,
                    ellipseName: "Australian Natl & S. Amer. 1969"
                },
                GRS67: {
                    a: 6378160,
                    rf: 298.247167427,
                    ellipseName: "GRS 67(IUGG 1967)"
                },
                bessel: {
                    a: 6377397.155,
                    rf: 299.1528128,
                    ellipseName: "Bessel 1841"
                },
                bess_nam: {
                    a: 6377483.865,
                    rf: 299.1528128,
                    ellipseName: "Bessel 1841 (Namibia)"
                },
                clrk66: {
                    a: 6378206.4,
                    b: 6356583.8,
                    ellipseName: "Clarke 1866"
                },
                clrk80: {
                    a: 6378249.145,
                    rf: 293.4663,
                    ellipseName: "Clarke 1880 mod."
                },
                clrk80ign: {
                    a: 6378249.2,
                    b: 6356515,
                    rf: 293.4660213,
                    ellipseName: "Clarke 1880 (IGN)"
                },
                clrk58: {
                    a: 6378293.645208759,
                    rf: 294.2606763692654,
                    ellipseName: "Clarke 1858"
                },
                CPM: {
                    a: 6375738.7,
                    rf: 334.29,
                    ellipseName: "Comm. des Poids et Mesures 1799"
                },
                delmbr: {
                    a: 6376428,
                    rf: 311.5,
                    ellipseName: "Delambre 1810 (Belgium)"
                },
                engelis: {
                    a: 6378136.05,
                    rf: 298.2566,
                    ellipseName: "Engelis 1985"
                },
                evrst30: {
                    a: 6377276.345,
                    rf: 300.8017,
                    ellipseName: "Everest 1830"
                },
                evrst48: {
                    a: 6377304.063,
                    rf: 300.8017,
                    ellipseName: "Everest 1948"
                },
                evrst56: {
                    a: 6377301.243,
                    rf: 300.8017,
                    ellipseName: "Everest 1956"
                },
                evrst69: {
                    a: 6377295.664,
                    rf: 300.8017,
                    ellipseName: "Everest 1969"
                },
                evrstSS: {
                    a: 6377298.556,
                    rf: 300.8017,
                    ellipseName: "Everest (Sabah & Sarawak)"
                },
                fschr60: {
                    a: 6378166,
                    rf: 298.3,
                    ellipseName: "Fischer (Mercury Datum) 1960"
                },
                fschr60m: {
                    a: 6378155,
                    rf: 298.3,
                    ellipseName: "Fischer 1960"
                },
                fschr68: {
                    a: 6378150,
                    rf: 298.3,
                    ellipseName: "Fischer 1968"
                },
                helmert: {
                    a: 6378200,
                    rf: 298.3,
                    ellipseName: "Helmert 1906"
                },
                hough: {
                    a: 6378270,
                    rf: 297,
                    ellipseName: "Hough"
                },
                intl: {
                    a: 6378388,
                    rf: 297,
                    ellipseName: "International 1909 (Hayford)"
                },
                kaula: {
                    a: 6378163,
                    rf: 298.24,
                    ellipseName: "Kaula 1961"
                },
                lerch: {
                    a: 6378139,
                    rf: 298.257,
                    ellipseName: "Lerch 1979"
                },
                mprts: {
                    a: 6397300,
                    rf: 191,
                    ellipseName: "Maupertius 1738"
                },
                new_intl: {
                    a: 6378157.5,
                    b: 6356772.2,
                    ellipseName: "New International 1967"
                },
                plessis: {
                    a: 6376523,
                    rf: 6355863,
                    ellipseName: "Plessis 1817 (France)"
                },
                krass: {
                    a: 6378245,
                    rf: 298.3,
                    ellipseName: "Krassovsky, 1942"
                },
                SEasia: {
                    a: 6378155,
                    b: 6356773.3205,
                    ellipseName: "Southeast Asia"
                },
                walbeck: {
                    a: 6376896,
                    b: 6355834.8467,
                    ellipseName: "Walbeck"
                },
                WGS60: {
                    a: 6378165,
                    rf: 298.3,
                    ellipseName: "WGS 60"
                },
                WGS66: {
                    a: 6378145,
                    rf: 298.25,
                    ellipseName: "WGS 66"
                },
                WGS7: {
                    a: 6378135,
                    rf: 298.26,
                    ellipseName: "WGS 72"
                }
            }, H = G.WGS84 = {
                a: 6378137,
                rf: 298.257223563,
                ellipseName: "WGS 84"
            };
            G.sphere = {
                a: 6370997,
                b: 6370997,
                ellipseName: "Normal Sphere (r=6370997)"
            };
            var W = {};
            W.wgs84 = {
                towgs84: "0,0,0",
                ellipse: "WGS84",
                datumName: "WGS84"
            }, W.ch1903 = {
                towgs84: "674.374,15.056,405.346",
                ellipse: "bessel",
                datumName: "swiss"
            }, W.ggrs87 = {
                towgs84: "-199.87,74.79,246.62",
                ellipse: "GRS80",
                datumName: "Greek_Geodetic_Reference_System_1987"
            }, W.nad83 = {
                towgs84: "0,0,0",
                ellipse: "GRS80",
                datumName: "North_American_Datum_1983"
            }, W.nad27 = {
                nadgrids: "@conus,@alaska,@ntv2_0.gsb,@ntv1_can.dat",
                ellipse: "clrk66",
                datumName: "North_American_Datum_1927"
            }, W.potsdam = {
                towgs84: "598.1,73.7,418.2,0.202,0.045,-2.455,6.7",
                ellipse: "bessel",
                datumName: "Potsdam Rauenberg 1950 DHDN"
            }, W.carthage = {
                towgs84: "-263.0,6.0,431.0",
                ellipse: "clark80",
                datumName: "Carthage 1934 Tunisia"
            }, W.hermannskogel = {
                towgs84: "577.326,90.129,463.919,5.137,1.474,5.297,2.4232",
                ellipse: "bessel",
                datumName: "Hermannskogel"
            }, W.militargeographische_institut = {
                towgs84: "577.326,90.129,463.919,5.137,1.474,5.297,2.4232",
                ellipse: "bessel",
                datumName: "Militar-Geographische Institut"
            }, W.osni52 = {
                towgs84: "482.530,-130.596,564.557,-1.042,-0.214,-0.631,8.15",
                ellipse: "airy",
                datumName: "Irish National"
            }, W.ire65 = {
                towgs84: "482.530,-130.596,564.557,-1.042,-0.214,-0.631,8.15",
                ellipse: "mod_airy",
                datumName: "Ireland 1965"
            }, W.rassadiran = {
                towgs84: "-133.63,-157.5,-158.62",
                ellipse: "intl",
                datumName: "Rassadiran"
            }, W.nzgd49 = {
                towgs84: "59.47,-5.04,187.44,0.47,-0.1,1.024,-4.5993",
                ellipse: "intl",
                datumName: "New Zealand Geodetic Datum 1949"
            }, W.osgb36 = {
                towgs84: "446.448,-125.157,542.060,0.1502,0.2470,0.8421,-20.4894",
                ellipse: "airy",
                datumName: "Airy 1830"
            }, W.s_jtsk = {
                towgs84: "589,76,480",
                ellipse: "bessel",
                datumName: "S-JTSK (Ferro)"
            }, W.beduaram = {
                towgs84: "-106,-87,188",
                ellipse: "clrk80",
                datumName: "Beduaram"
            }, W.gunung_segara = {
                towgs84: "-403,684,41",
                ellipse: "bessel",
                datumName: "Gunung Segara Jakarta"
            }, W.rnb72 = {
                towgs84: "106.869,-52.2978,103.724,-0.33657,0.456955,-1.84218,1",
                ellipse: "intl",
                datumName: "Reseau National Belge 1972"
            };
            var $ = function(t, e, r, i, o, a, s) {
                var u = {};
                return u.datum_type = void 0 === t || "none" === t ? 5 : 4, e && (u.datum_params = e.map(parseFloat), 0 === u.datum_params[0] && 0 === u.datum_params[1] && 0 === u.datum_params[2] || (u.datum_type = 1), u.datum_params.length > 3 && (0 === u.datum_params[3] && 0 === u.datum_params[4] && 0 === u.datum_params[5] && 0 === u.datum_params[6] || (u.datum_type = 2, u.datum_params[3] *= n, u.datum_params[4] *= n, u.datum_params[5] *= n, u.datum_params[6] = u.datum_params[6] / 1e6 + 1))), s && (u.datum_type = 3, u.grids = s), u.a = r, u.b = i, u.es = o, u.ep2 = a, u;
            }, V = {};
            function Z(t) {
                if (0 === t.length) return null;
                var e = "@" === t[0];
                return e && (t = t.slice(1)), "null" === t ? {
                    name: "null",
                    mandatory: !e,
                    grid: null,
                    isNull: !0
                } : {
                    name: t,
                    mandatory: !e,
                    grid: V[t] || null,
                    isNull: !1
                };
            }
            function Y(t) {
                return t / 3600 * Math.PI / 180;
            }
            function K(t, e, r) {
                return String.fromCharCode.apply(null, new Uint8Array(t.buffer.slice(e, r)));
            }
            function X(t) {
                return t.map(function(t) {
                    return [
                        Y(t.longitudeShift),
                        Y(t.latitudeShift)
                    ];
                });
            }
            function J(t, e, r) {
                return {
                    name: K(t, e + 8, e + 16).trim(),
                    parent: K(t, e + 24, e + 24 + 8).trim(),
                    lowerLatitude: t.getFloat64(e + 72, r),
                    upperLatitude: t.getFloat64(e + 88, r),
                    lowerLongitude: t.getFloat64(e + 104, r),
                    upperLongitude: t.getFloat64(e + 120, r),
                    latitudeInterval: t.getFloat64(e + 136, r),
                    longitudeInterval: t.getFloat64(e + 152, r),
                    gridNodeCount: t.getInt32(e + 168, r)
                };
            }
            function Q(t, e, r, n) {
                for(var i = e + 176, o = [], a = 0; a < r.gridNodeCount; a++){
                    var s = {
                        latitudeShift: t.getFloat32(i + 16 * a, n),
                        longitudeShift: t.getFloat32(i + 16 * a + 4, n),
                        latitudeAccuracy: t.getFloat32(i + 16 * a + 8, n),
                        longitudeAccuracy: t.getFloat32(i + 16 * a + 12, n)
                    };
                    o.push(s);
                }
                return o;
            }
            function tt(t, e) {
                if (!(this instanceof tt)) return new tt(t);
                e = e || function(t) {
                    if (t) throw t;
                };
                var r = D(t);
                if ("object" == typeof r) {
                    var n = tt.projections.get(r.projName);
                    if (n) {
                        if (r.datumCode && "none" !== r.datumCode) {
                            var i = p(W, r.datumCode);
                            i && (r.datum_params = r.datum_params || (i.towgs84 ? i.towgs84.split(",") : null), r.ellps = i.ellipse, r.datumName = i.datumName ? i.datumName : r.datumCode);
                        }
                        r.k0 = r.k0 || 1, r.axis = r.axis || "enu", r.ellps = r.ellps || "wgs84", r.lat1 = r.lat1 || r.lat0;
                        var o, a, s, u, l, c, f, h = function(t, e, r, n, i) {
                            if (!t) {
                                var o = p(G, n);
                                o || (o = H), t = o.a, e = o.b, r = o.rf;
                            }
                            return r && !e && (e = (1 - 1 / r) * t), (0 === r || Math.abs(t - e) < 1e-10) && (i = !0, e = t), {
                                a: t,
                                b: e,
                                rf: r,
                                sphere: i
                            };
                        }(r.a, r.b, r.rf, r.ellps, r.sphere), d = (o = h.a, a = h.b, h.rf, s = r.R_A, c = ((u = o * o) - (l = a * a)) / u, f = 0, s ? (u = (o *= 1 - c * (.16666666666666666 + c * (.04722222222222222 + .022156084656084655 * c))) * o, c = 0) : f = Math.sqrt(c), {
                            es: c,
                            e: f,
                            ep2: (u - l) / l
                        }), m = function(t) {
                            return void 0 === t ? null : t.split(",").map(Z);
                        }(r.nadgrids), y = r.datum || $(r.datumCode, r.datum_params, h.a, h.b, d.es, d.ep2, m);
                        O(this, r), O(this, n), this.a = h.a, this.b = h.b, this.rf = h.rf, this.sphere = h.sphere, this.es = d.es, this.e = d.e, this.ep2 = d.ep2, this.datum = y, this.init(), e(null, this);
                    } else e(t);
                } else e(t);
            }
            tt.projections = z, tt.projections.start();
            var et = tt;
            function rt(t, e, r) {
                var n, o, a, s, u = t.x, l = t.y, c = t.z ? t.z : 0;
                if (l < -i && l > -1.001 * i) l = -i;
                else if (l > i && l < 1.001 * i) l = i;
                else {
                    if (l < -i) return {
                        x: -1 / 0,
                        y: -1 / 0,
                        z: t.z
                    };
                    if (l > i) return {
                        x: 1 / 0,
                        y: 1 / 0,
                        z: t.z
                    };
                }
                return u > Math.PI && (u -= 2 * Math.PI), o = Math.sin(l), s = Math.cos(l), a = o * o, {
                    x: ((n = r / Math.sqrt(1 - e * a)) + c) * s * Math.cos(u),
                    y: (n + c) * s * Math.sin(u),
                    z: (n * (1 - e) + c) * o
                };
            }
            function nt(t, e, r, n) {
                var o, a, s, u, l, c, f, h, p, d, m, y, g, v, b, x = t.x, w = t.y, _ = t.z ? t.z : 0;
                if (o = Math.sqrt(x * x + w * w), a = Math.sqrt(x * x + w * w + _ * _), o / r < 1e-12) {
                    if (v = 0, a / r < 1e-12) return i, b = -n, {
                        x: t.x,
                        y: t.y,
                        z: t.z
                    };
                } else v = Math.atan2(w, x);
                s = _ / a, h = (u = o / a) * (1 - e) * (l = 1 / Math.sqrt(1 - e * (2 - e) * u * u)), p = s * l, g = 0;
                do g++, c = e * (f = r / Math.sqrt(1 - e * p * p)) / (f + (b = o * h + _ * p - f * (1 - e * p * p))), y = (m = s * (l = 1 / Math.sqrt(1 - c * (2 - c) * u * u))) * h - (d = u * (1 - c) * l) * p, h = d, p = m;
                while (y * y > 1e-24 && g < 30);
                return {
                    x: v,
                    y: Math.atan(m / Math.abs(d)),
                    z: b
                };
            }
            function it(t) {
                return 1 === t || 2 === t;
            }
            var ot = function(t, e, r) {
                if (function(t, e) {
                    return t.datum_type === e.datum_type && !(t.a !== e.a || Math.abs(t.es - e.es) > 5e-11) && (1 === t.datum_type ? t.datum_params[0] === e.datum_params[0] && t.datum_params[1] === e.datum_params[1] && t.datum_params[2] === e.datum_params[2] : 2 !== t.datum_type || t.datum_params[0] === e.datum_params[0] && t.datum_params[1] === e.datum_params[1] && t.datum_params[2] === e.datum_params[2] && t.datum_params[3] === e.datum_params[3] && t.datum_params[4] === e.datum_params[4] && t.datum_params[5] === e.datum_params[5] && t.datum_params[6] === e.datum_params[6]);
                }(t, e)) return r;
                if (5 === t.datum_type || 5 === e.datum_type) return r;
                var n = t.a, i = t.es;
                if (3 === t.datum_type) {
                    if (0 !== at(t, !1, r)) return;
                    n = 6378137, i = .0066943799901413165;
                }
                var o = e.a, a = e.b, s = e.es;
                if (3 === e.datum_type && (o = 6378137, a = 6356752.314, s = .0066943799901413165), i === s && n === o && !it(t.datum_type) && !it(e.datum_type)) return r;
                if ((r = rt(r, i, n), it(t.datum_type) && (r = function(t, e, r) {
                    if (1 === e) return {
                        x: t.x + r[0],
                        y: t.y + r[1],
                        z: t.z + r[2]
                    };
                    if (2 === e) {
                        var n = r[0], i = r[1], o = r[2], a = r[3], s = r[4], u = r[5], l = r[6];
                        return {
                            x: l * (t.x - u * t.y + s * t.z) + n,
                            y: l * (u * t.x + t.y - a * t.z) + i,
                            z: l * (-s * t.x + a * t.y + t.z) + o
                        };
                    }
                }(r, t.datum_type, t.datum_params)), it(e.datum_type) && (r = function(t, e, r) {
                    if (1 === e) return {
                        x: t.x - r[0],
                        y: t.y - r[1],
                        z: t.z - r[2]
                    };
                    if (2 === e) {
                        var n = r[0], i = r[1], o = r[2], a = r[3], s = r[4], u = r[5], l = r[6], c = (t.x - n) / l, f = (t.y - i) / l, h = (t.z - o) / l;
                        return {
                            x: c + u * f - s * h,
                            y: -u * c + f + a * h,
                            z: s * c - a * f + h
                        };
                    }
                }(r, e.datum_type, e.datum_params)), r = nt(r, s, o, a), 3 === e.datum_type) && 0 !== at(e, !0, r)) return;
                return r;
            };
            function at(t, e, r) {
                if (null === t.grids || 0 === t.grids.length) return console.log("Grid shift grids not found"), -1;
                var n = {
                    x: -r.x,
                    y: r.y
                }, i = {
                    x: Number.NaN,
                    y: Number.NaN
                }, o = [];
                t: for(var s = 0; s < t.grids.length; s++){
                    var u = t.grids[s];
                    if (o.push(u.name), u.isNull) {
                        i = n;
                        break;
                    }
                    if (u.mandatory, null !== u.grid) for(var l = u.grid.subgrids, c = 0, f = l.length; c < f; c++){
                        var h = l[c], p = (Math.abs(h.del[1]) + Math.abs(h.del[0])) / 1e4, d = h.ll[0] - p, m = h.ll[1] - p, y = h.ll[0] + (h.lim[0] - 1) * h.del[0] + p, g = h.ll[1] + (h.lim[1] - 1) * h.del[1] + p;
                        if (!(m > n.y || d > n.x || g < n.y || y < n.x) && (i = st(n, e, h), !isNaN(i.x))) break t;
                    }
                    else if (u.mandatory) return console.log("Unable to find mandatory grid '" + u.name + "'"), -1;
                }
                return isNaN(i.x) ? (console.log("Failed to find a grid shift table for location '" + -n.x * a + " " + n.y * a + " tried: '" + o + "'"), -1) : (r.x = -i.x, r.y = i.y, 0);
            }
            function st(t, e, r) {
                var n = {
                    x: Number.NaN,
                    y: Number.NaN
                };
                if (isNaN(t.x)) return n;
                var i = {
                    x: t.x,
                    y: t.y
                };
                i.x -= r.ll[0], i.y -= r.ll[1], i.x = P(i.x - Math.PI) + Math.PI;
                var o = ut(i, r);
                if (e) {
                    if (isNaN(o.x)) return n;
                    o.x = i.x - o.x, o.y = i.y - o.y;
                    var a, s, u = 9;
                    do {
                        if (s = ut(o, r), isNaN(s.x)) {
                            console.log("Inverse grid shift iteration failed, presumably at grid edge.  Using first approximation.");
                            break;
                        }
                        a = {
                            x: i.x - (s.x + o.x),
                            y: i.y - (s.y + o.y)
                        }, o.x += a.x, o.y += a.y;
                    }while (u-- && Math.abs(a.x) > 1e-12 && Math.abs(a.y) > 1e-12);
                    if (u < 0) return console.log("Inverse grid shift iterator failed to converge."), n;
                    n.x = P(o.x + r.ll[0]), n.y = o.y + r.ll[1];
                } else isNaN(o.x) || (n.x = t.x + o.x, n.y = t.y + o.y);
                return n;
            }
            function ut(t, e) {
                var r, n = {
                    x: t.x / e.del[0],
                    y: t.y / e.del[1]
                }, i = Math.floor(n.x), o = Math.floor(n.y), a = n.x - 1 * i, s = n.y - 1 * o, u = {
                    x: Number.NaN,
                    y: Number.NaN
                };
                if (i < 0 || i >= e.lim[0]) return u;
                if (o < 0 || o >= e.lim[1]) return u;
                r = o * e.lim[0] + i;
                var l = e.cvs[r][0], c = e.cvs[r][1];
                r++;
                var f = e.cvs[r][0], h = e.cvs[r][1];
                r += e.lim[0];
                var p = e.cvs[r][0], d = e.cvs[r][1];
                r--;
                var m = e.cvs[r][0], y = e.cvs[r][1], g = a * s, v = a * (1 - s), b = (1 - a) * (1 - s), x = (1 - a) * s;
                return u.x = b * l + v * f + x * m + g * p, u.y = b * c + v * h + x * y + g * d, u;
            }
            var lt = function(t, e, r) {
                var n, i, o, a = r.x, s = r.y, u = r.z || 0, l = {};
                for(o = 0; o < 3; o++)if (!e || 2 !== o || void 0 !== r.z) switch(0 === o ? (n = a, i = -1 !== "ew".indexOf(t.axis[o]) ? "x" : "y") : 1 === o ? (n = s, i = -1 !== "ns".indexOf(t.axis[o]) ? "y" : "x") : (n = u, i = "z"), t.axis[o]){
                    case "e":
                        l[i] = n;
                        break;
                    case "w":
                        l[i] = -n;
                        break;
                    case "n":
                        l[i] = n;
                        break;
                    case "s":
                        l[i] = -n;
                        break;
                    case "u":
                        void 0 !== r[i] && (l.z = n);
                        break;
                    case "d":
                        void 0 !== r[i] && (l.z = -n);
                        break;
                    default:
                        return null;
                }
                return l;
            }, ct = function(t) {
                var e = {
                    x: t[0],
                    y: t[1]
                };
                return t.length > 2 && (e.z = t[2]), t.length > 3 && (e.m = t[3]), e;
            };
            function ft(t) {
                if ("function" == typeof Number.isFinite) {
                    if (Number.isFinite(t)) return;
                    throw new TypeError("coordinates must be finite numbers");
                }
                if ("number" != typeof t || t != t || !isFinite(t)) throw new TypeError("coordinates must be finite numbers");
            }
            function ht(t, e, r, n) {
                var i, s = void 0 !== (r = Array.isArray(r) ? ct(r) : {
                    x: r.x,
                    y: r.y,
                    z: r.z,
                    m: r.m
                }).z;
                if (function(t) {
                    ft(t.x), ft(t.y);
                }(r), t.datum && e.datum && function(t, e) {
                    return (1 === t.datum.datum_type || 2 === t.datum.datum_type || 3 === t.datum.datum_type) && "WGS84" !== e.datumCode || (1 === e.datum.datum_type || 2 === e.datum.datum_type || 3 === e.datum.datum_type) && "WGS84" !== t.datumCode;
                }(t, e) && (r = ht(t, i = new et("WGS84"), r, n), t = i), n && "enu" !== t.axis && (r = lt(t, !1, r)), "longlat" === t.projName) r = {
                    x: r.x * o,
                    y: r.y * o,
                    z: r.z || 0
                };
                else if (t.to_meter && (r = {
                    x: r.x * t.to_meter,
                    y: r.y * t.to_meter,
                    z: r.z || 0
                }), !(r = t.inverse(r))) return;
                if (t.from_greenwich && (r.x += t.from_greenwich), r = ot(t.datum, e.datum, r)) return e.from_greenwich && (r = {
                    x: r.x - e.from_greenwich,
                    y: r.y,
                    z: r.z || 0
                }), "longlat" === e.projName ? r = {
                    x: r.x * a,
                    y: r.y * a,
                    z: r.z || 0
                } : (r = e.forward(r), e.to_meter && (r = {
                    x: r.x / e.to_meter,
                    y: r.y / e.to_meter,
                    z: r.z || 0
                })), n && "enu" !== e.axis ? lt(e, !0, r) : (r && !s && delete r.z, r);
            }
            var pt = et("WGS84");
            function dt(t, e, r, n) {
                var i, o, a;
                return Array.isArray(r) ? (i = ht(t, e, r, n) || {
                    x: NaN,
                    y: NaN
                }, r.length > 2 ? void 0 !== t.name && "geocent" === t.name || void 0 !== e.name && "geocent" === e.name ? "number" == typeof i.z ? [
                    i.x,
                    i.y,
                    i.z
                ].concat(r.splice(3)) : [
                    i.x,
                    i.y,
                    r[2]
                ].concat(r.splice(3)) : [
                    i.x,
                    i.y
                ].concat(r.splice(2)) : [
                    i.x,
                    i.y
                ]) : (o = ht(t, e, r, n), 2 === (a = Object.keys(r)).length || a.forEach(function(n) {
                    if (void 0 !== t.name && "geocent" === t.name || void 0 !== e.name && "geocent" === e.name) {
                        if ("x" === n || "y" === n || "z" === n) return;
                    } else if ("x" === n || "y" === n) return;
                    o[n] = r[n];
                }), o);
            }
            function mt(t) {
                return t instanceof et ? t : t.oProj ? t.oProj : et(t);
            }
            var yt = function(t, e, r) {
                t = mt(t);
                var n, i = !1;
                return void 0 === e ? (e = t, t = pt, i = !0) : (void 0 !== e.x || Array.isArray(e)) && (r = e, e = t, t = pt, i = !0), e = mt(e), r ? dt(t, e, r) : (n = {
                    forward: function(r, n) {
                        return dt(t, e, r, n);
                    },
                    inverse: function(r, n) {
                        return dt(e, t, r, n);
                    }
                }, i && (n.oProj = e), n);
            }, gt = 73, vt = 79, bt = {
                forward: xt,
                inverse: function(t) {
                    var e = Et(kt(t.toUpperCase()));
                    if (e.lat && e.lon) return [
                        e.lon,
                        e.lat,
                        e.lon,
                        e.lat
                    ];
                    return [
                        e.left,
                        e.bottom,
                        e.right,
                        e.top
                    ];
                },
                toPoint: wt
            };
            function xt(t, e) {
                return e = e || 5, function(t, e) {
                    var r = "00000" + t.easting, n = "00000" + t.northing;
                    var i, o, a, s, u, l, c, f, h, p, d, m, y, g, v;
                    return t.zoneNumber + t.zoneLetter + (p = t.easting, d = t.northing, m = t.zoneNumber, y = Mt(m), g = Math.floor(p / 1e5), v = Math.floor(d / 1e5) % 20, i = g, o = v, a = y, s = a - 1, u = "AJSAJS".charCodeAt(s), l = "AFAFAF".charCodeAt(s), c = u + i - 1, f = l + o, h = !1, c > 90 && (c = c - 90 + 65 - 1, h = !0), (c === gt || u < gt && c > gt || (c > gt || u < gt) && h) && c++, (c === vt || u < vt && c > vt || (c > vt || u < vt) && h) && ++c === gt && c++, c > 90 && (c = c - 90 + 65 - 1), f > 86 ? (f = f - 86 + 65 - 1, h = !0) : h = !1, (f === gt || l < gt && f > gt || (f > gt || l < gt) && h) && f++, (f === vt || l < vt && f > vt || (f > vt || l < vt) && h) && ++f === gt && f++, f > 86 && (f = f - 86 + 65 - 1), String.fromCharCode(c) + String.fromCharCode(f)) + r.substr(r.length - 5, e) + n.substr(n.length - 5, e);
                }(function(t) {
                    var e, r, n, i, o, a, s, u = t.lat, l = t.lon, c = 6378137, f = _t(u), h = _t(l);
                    s = Math.floor((l + 180) / 6) + 1, 180 === l && (s = 60);
                    u >= 56 && u < 64 && l >= 3 && l < 12 && (s = 32);
                    u >= 72 && u < 84 && (l >= 0 && l < 9 ? s = 31 : l >= 9 && l < 21 ? s = 33 : l >= 21 && l < 33 ? s = 35 : l >= 33 && l < 42 && (s = 37));
                    a = _t(6 * (s - 1) - 180 + 3), e = c / Math.sqrt(1 - .00669438 * Math.sin(f) * Math.sin(f)), r = Math.tan(f) * Math.tan(f), n = .006739496752268451 * Math.cos(f) * Math.cos(f), i = Math.cos(f) * (h - a), o = c * (.9983242984503243 * f - .002514607064228144 * Math.sin(2 * f) + 2639046602129982e-21 * Math.sin(4 * f) - 3.418046101696858e-9 * Math.sin(6 * f));
                    var p = .9996 * e * (i + (1 - r + n) * i * i * i / 6 + (5 - 18 * r + r * r + 72 * n - .39089081163157013) * i * i * i * i * i / 120) + 5e5, d = .9996 * (o + e * Math.tan(f) * (i * i / 2 + (5 - r + 9 * n + 4 * n * n) * i * i * i * i / 24 + (61 - 58 * r + r * r + 600 * n - 2.2240339282485886) * i * i * i * i * i * i / 720));
                    u < 0 && (d += 1e7);
                    return {
                        northing: Math.round(d),
                        easting: Math.round(p),
                        zoneNumber: s,
                        zoneLetter: St(u)
                    };
                }({
                    lat: t[1],
                    lon: t[0]
                }), e);
            }
            function wt(t) {
                var e = Et(kt(t.toUpperCase()));
                return e.lat && e.lon ? [
                    e.lon,
                    e.lat
                ] : [
                    (e.left + e.right) / 2,
                    (e.top + e.bottom) / 2
                ];
            }
            function _t(t) {
                return t * (Math.PI / 180);
            }
            function At(t) {
                return t / Math.PI * 180;
            }
            function Et(t) {
                var e = t.northing, r = t.easting, n = t.zoneLetter, i = t.zoneNumber;
                if (i < 0 || i > 60) return null;
                var o, a, s, u, l, c, f, h, p = 6378137, d = (1 - Math.sqrt(.99330562)) / (1 + Math.sqrt(.99330562)), m = r - 5e5, y = e;
                n < "N" && (y -= 1e7), c = 6 * (i - 1) - 180 + 3, h = (f = y / .9996 / 6367449.145945056) + (3 * d / 2 - 27 * d * d * d / 32) * Math.sin(2 * f) + (21 * d * d / 16 - 55 * d * d * d * d / 32) * Math.sin(4 * f) + 151 * d * d * d / 96 * Math.sin(6 * f), o = p / Math.sqrt(1 - .00669438 * Math.sin(h) * Math.sin(h)), a = Math.tan(h) * Math.tan(h), s = .006739496752268451 * Math.cos(h) * Math.cos(h), u = .99330562 * p / Math.pow(1 - .00669438 * Math.sin(h) * Math.sin(h), 1.5), l = m / (.9996 * o);
                var g = h - o * Math.tan(h) / u * (l * l / 2 - (5 + 3 * a + 10 * s - 4 * s * s - .06065547077041606) * l * l * l * l / 24 + (61 + 90 * a + 298 * s + 45 * a * a - 1.6983531815716497 - 3 * s * s) * l * l * l * l * l * l / 720);
                g = At(g);
                var v, b = (l - (1 + 2 * a + s) * l * l * l / 6 + (5 - 2 * s + 28 * a - 3 * s * s + .05391597401814761 + 24 * a * a) * l * l * l * l * l / 120) / Math.cos(h);
                if (b = c + At(b), t.accuracy) {
                    var x = Et({
                        northing: t.northing + t.accuracy,
                        easting: t.easting + t.accuracy,
                        zoneLetter: t.zoneLetter,
                        zoneNumber: t.zoneNumber
                    });
                    v = {
                        top: x.lat,
                        right: x.lon,
                        bottom: g,
                        left: b
                    };
                } else v = {
                    lat: g,
                    lon: b
                };
                return v;
            }
            function St(t) {
                var e = "Z";
                return 84 >= t && t >= 72 ? e = "X" : 72 > t && t >= 64 ? e = "W" : 64 > t && t >= 56 ? e = "V" : 56 > t && t >= 48 ? e = "U" : 48 > t && t >= 40 ? e = "T" : 40 > t && t >= 32 ? e = "S" : 32 > t && t >= 24 ? e = "R" : 24 > t && t >= 16 ? e = "Q" : 16 > t && t >= 8 ? e = "P" : 8 > t && t >= 0 ? e = "N" : 0 > t && t >= -8 ? e = "M" : -8 > t && t >= -16 ? e = "L" : -16 > t && t >= -24 ? e = "K" : -24 > t && t >= -32 ? e = "J" : -32 > t && t >= -40 ? e = "H" : -40 > t && t >= -48 ? e = "G" : -48 > t && t >= -56 ? e = "F" : -56 > t && t >= -64 ? e = "E" : -64 > t && t >= -72 ? e = "D" : -72 > t && t >= -80 && (e = "C"), e;
            }
            function Mt(t) {
                var e = t % 6;
                return 0 === e && (e = 6), e;
            }
            function kt(t) {
                if (t && 0 === t.length) throw "MGRSPoint coverting from nothing";
                for(var e, r = t.length, n = null, i = "", o = 0; !/[A-Z]/.test(e = t.charAt(o));){
                    if (o >= 2) throw "MGRSPoint bad conversion from: " + t;
                    i += e, o++;
                }
                var a = parseInt(i, 10);
                if (0 === o || o + 3 > r) throw "MGRSPoint bad conversion from: " + t;
                var s = t.charAt(o++);
                if (s <= "A" || "B" === s || "Y" === s || s >= "Z" || "I" === s || "O" === s) throw "MGRSPoint zone letter " + s + " not handled: " + t;
                n = t.substring(o, o += 2);
                for(var u = Mt(a), l = function(t, e) {
                    var r = "AJSAJS".charCodeAt(e - 1), n = 1e5, i = !1;
                    for(; r !== t.charCodeAt(0);){
                        if (++r === gt && r++, r === vt && r++, r > 90) {
                            if (i) throw "Bad character: " + t;
                            r = 65, i = !0;
                        }
                        n += 1e5;
                    }
                    return n;
                }(n.charAt(0), u), c = function(t, e) {
                    if (t > "V") throw "MGRSPoint given invalid Northing " + t;
                    var r = "AFAFAF".charCodeAt(e - 1), n = 0, i = !1;
                    for(; r !== t.charCodeAt(0);){
                        if (++r === gt && r++, r === vt && r++, r > 86) {
                            if (i) throw "Bad character: " + t;
                            r = 65, i = !0;
                        }
                        n += 1e5;
                    }
                    return n;
                }(n.charAt(1), u); c < Nt(s);)c += 2e6;
                var f = r - o;
                if (f % 2 != 0) throw "MGRSPoint has to have an even number \nof digits after the zone letter and two 100km letters - front \nhalf for easting meters, second half for \nnorthing meters" + t;
                var h, p, d, m = f / 2, y = 0, g = 0;
                return m > 0 && (h = 1e5 / Math.pow(10, m), p = t.substring(o, o + m), y = parseFloat(p) * h, d = t.substring(o + m), g = parseFloat(d) * h), {
                    easting: y + l,
                    northing: g + c,
                    zoneLetter: s,
                    zoneNumber: a,
                    accuracy: h
                };
            }
            function Nt(t) {
                var e;
                switch(t){
                    case "C":
                        e = 11e5;
                        break;
                    case "D":
                        e = 2e6;
                        break;
                    case "E":
                        e = 28e5;
                        break;
                    case "F":
                        e = 37e5;
                        break;
                    case "G":
                        e = 46e5;
                        break;
                    case "H":
                        e = 55e5;
                        break;
                    case "J":
                        e = 64e5;
                        break;
                    case "K":
                        e = 73e5;
                        break;
                    case "L":
                        e = 82e5;
                        break;
                    case "M":
                        e = 91e5;
                        break;
                    case "N":
                        e = 0;
                        break;
                    case "P":
                        e = 8e5;
                        break;
                    case "Q":
                        e = 17e5;
                        break;
                    case "R":
                        e = 26e5;
                        break;
                    case "S":
                        e = 35e5;
                        break;
                    case "T":
                        e = 44e5;
                        break;
                    case "U":
                        e = 53e5;
                        break;
                    case "V":
                        e = 62e5;
                        break;
                    case "W":
                        e = 7e6;
                        break;
                    case "X":
                        e = 79e5;
                        break;
                    default:
                        e = -1;
                }
                if (e >= 0) return e;
                throw "Invalid zone letter: " + t;
            }
            function Ct(t, e, r) {
                if (!(this instanceof Ct)) return new Ct(t, e, r);
                if (Array.isArray(t)) this.x = t[0], this.y = t[1], this.z = t[2] || 0;
                else if ("object" == typeof t) this.x = t.x, this.y = t.y, this.z = t.z || 0;
                else if ("string" == typeof t && void 0 === e) {
                    var n = t.split(",");
                    this.x = parseFloat(n[0], 10), this.y = parseFloat(n[1], 10), this.z = parseFloat(n[2], 10) || 0;
                } else this.x = t, this.y = e, this.z = r || 0;
                console.warn("proj4.Point will be removed in version 3, use proj4.toPoint");
            }
            Ct.fromMGRS = function(t) {
                return new Ct(wt(t));
            }, Ct.prototype.toMGRS = function(t) {
                return xt([
                    this.x,
                    this.y
                ], t);
            };
            var Dt = Ct, Ot = .01068115234375, Tt = function(t) {
                var e = [];
                e[0] = 1 - t * (.25 + t * (.046875 + t * (.01953125 + t * Ot))), e[1] = t * (.75 - t * (.046875 + t * (.01953125 + t * Ot)));
                var r = t * t;
                return e[2] = r * (.46875 - t * (.013020833333333334 + .007120768229166667 * t)), r *= t, e[3] = r * (.3645833333333333 - .005696614583333333 * t), e[4] = r * t * .3076171875, e;
            }, Ft = function(t, e, r, n) {
                return r *= e, e *= e, n[0] * t - r * (n[1] + e * (n[2] + e * (n[3] + e * n[4])));
            }, Pt = function(t, e, r) {
                for(var n = 1 / (1 - e), i = t, o = 20; o; --o){
                    var a = Math.sin(i), s = 1 - e * a * a;
                    if (i -= s = (Ft(i, a, Math.cos(i), r) - t) * (s * Math.sqrt(s)) * n, Math.abs(s) < 1e-10) return i;
                }
                return i;
            };
            var It = {
                init: function() {
                    this.x0 = void 0 !== this.x0 ? this.x0 : 0, this.y0 = void 0 !== this.y0 ? this.y0 : 0, this.long0 = void 0 !== this.long0 ? this.long0 : 0, this.lat0 = void 0 !== this.lat0 ? this.lat0 : 0, this.es && (this.en = Tt(this.es), this.ml0 = Ft(this.lat0, Math.sin(this.lat0), Math.cos(this.lat0), this.en));
                },
                forward: function(t) {
                    var e, r, n, i = t.x, o = t.y, a = P(i - this.long0), s = Math.sin(o), u = Math.cos(o);
                    if (this.es) {
                        var l = u * a, c = Math.pow(l, 2), f = this.ep2 * Math.pow(u, 2), h = Math.pow(f, 2), p = Math.abs(u) > 1e-10 ? Math.tan(o) : 0, d = Math.pow(p, 2), m = Math.pow(d, 2);
                        e = 1 - this.es * Math.pow(s, 2), l /= Math.sqrt(e);
                        var y = Ft(o, s, u, this.en);
                        r = this.a * (this.k0 * l * (1 + c / 6 * (1 - d + f + c / 20 * (5 - 18 * d + m + 14 * f - 58 * d * f + c / 42 * (61 + 179 * m - m * d - 479 * d))))) + this.x0, n = this.a * (this.k0 * (y - this.ml0 + s * a * l / 2 * (1 + c / 12 * (5 - d + 9 * f + 4 * h + c / 30 * (61 + m - 58 * d + 270 * f - 330 * d * f + c / 56 * (1385 + 543 * m - m * d - 3111 * d)))))) + this.y0;
                    } else {
                        var g = u * Math.sin(a);
                        if (Math.abs(Math.abs(g) - 1) < 1e-10) return 93;
                        if (r = .5 * this.a * this.k0 * Math.log((1 + g) / (1 - g)) + this.x0, n = u * Math.cos(a) / Math.sqrt(1 - Math.pow(g, 2)), (g = Math.abs(n)) >= 1) {
                            if (g - 1 > 1e-10) return 93;
                            n = 0;
                        } else n = Math.acos(n);
                        o < 0 && (n = -n), n = this.a * this.k0 * (n - this.lat0) + this.y0;
                    }
                    return t.x = r, t.y = n, t;
                },
                inverse: function(t) {
                    var e, r, n, o, a = (t.x - this.x0) * (1 / this.a), s = (t.y - this.y0) * (1 / this.a);
                    if (this.es) {
                        if (e = this.ml0 + s / this.k0, r = Pt(e, this.es, this.en), Math.abs(r) < i) {
                            var u = Math.sin(r), l = Math.cos(r), c = Math.abs(l) > 1e-10 ? Math.tan(r) : 0, f = this.ep2 * Math.pow(l, 2), h = Math.pow(f, 2), p = Math.pow(c, 2), d = Math.pow(p, 2);
                            e = 1 - this.es * Math.pow(u, 2);
                            var m = a * Math.sqrt(e) / this.k0, y = Math.pow(m, 2);
                            n = r - (e *= c) * y / (1 - this.es) * .5 * (1 - y / 12 * (5 + 3 * p - 9 * f * p + f - 4 * h - y / 30 * (61 + 90 * p - 252 * f * p + 45 * d + 46 * f - y / 56 * (1385 + 3633 * p + 4095 * d + 1574 * d * p)))), o = P(this.long0 + m * (1 - y / 6 * (1 + 2 * p + f - y / 20 * (5 + 28 * p + 24 * d + 8 * f * p + 6 * f - y / 42 * (61 + 662 * p + 1320 * d + 720 * d * p)))) / l);
                        } else n = i * F(s), o = 0;
                    } else {
                        var g = Math.exp(a / this.k0), v = .5 * (g - 1 / g), b = this.lat0 + s / this.k0, x = Math.cos(b);
                        e = Math.sqrt((1 - Math.pow(x, 2)) / (1 + Math.pow(v, 2))), n = Math.asin(e), s < 0 && (n = -n), o = 0 === v && 0 === x ? 0 : P(Math.atan2(v, x) + this.long0);
                    }
                    return t.x = o, t.y = n, t;
                },
                names: [
                    "Fast_Transverse_Mercator",
                    "Fast Transverse Mercator"
                ]
            }, Bt = function(t) {
                var e = Math.exp(t);
                return e = (e - 1 / e) / 2;
            }, jt = function(t, e) {
                t = Math.abs(t), e = Math.abs(e);
                var r = Math.max(t, e), n = Math.min(t, e) / (r || 1);
                return r * Math.sqrt(1 + Math.pow(n, 2));
            }, Rt = function(t) {
                var e = Math.abs(t);
                return e = function(t) {
                    var e = 1 + t, r = e - 1;
                    return 0 === r ? t : t * Math.log(e) / r;
                }(e * (1 + e / (jt(1, e) + 1))), t < 0 ? -e : e;
            }, Lt = function(t, e) {
                for(var r, n = 2 * Math.cos(2 * e), i = t.length - 1, o = t[i], a = 0; --i >= 0;)r = n * o - a + t[i], a = o, o = r;
                return e + r * Math.sin(2 * e);
            }, qt = function(t, e, r) {
                for(var n, i, o = Math.sin(e), a = Math.cos(e), s = Bt(r), u = function(t) {
                    var e = Math.exp(t);
                    return e = (e + 1 / e) / 2;
                }(r), l = 2 * a * u, c = -2 * o * s, f = t.length - 1, h = t[f], p = 0, d = 0, m = 0; --f >= 0;)n = d, i = p, h = l * (d = h) - n - c * (p = m) + t[f], m = c * d - i + l * p;
                return [
                    (l = o * u) * h - (c = a * s) * m,
                    l * m + c * h
                ];
            };
            var Ut = {
                init: function() {
                    if (!this.approx && (isNaN(this.es) || this.es <= 0)) throw new Error('Incorrect elliptical usage. Try using the +approx option in the proj string, or PROJECTION["Fast_Transverse_Mercator"] in the WKT.');
                    this.approx && (It.init.apply(this), this.forward = It.forward, this.inverse = It.inverse), this.x0 = void 0 !== this.x0 ? this.x0 : 0, this.y0 = void 0 !== this.y0 ? this.y0 : 0, this.long0 = void 0 !== this.long0 ? this.long0 : 0, this.lat0 = void 0 !== this.lat0 ? this.lat0 : 0, this.cgb = [], this.cbg = [], this.utg = [], this.gtu = [];
                    var t = this.es / (1 + Math.sqrt(1 - this.es)), e = t / (2 - t), r = e;
                    this.cgb[0] = e * (2 + e * (-2 / 3 + e * (e * (116 / 45 + e * (26 / 45 + e * (-2854 / 675))) - 2))), this.cbg[0] = e * (e * (2 / 3 + e * (4 / 3 + e * (-82 / 45 + e * (32 / 45 + e * (4642 / 4725))))) - 2), r *= e, this.cgb[1] = r * (7 / 3 + e * (e * (-227 / 45 + e * (2704 / 315 + e * (2323 / 945))) - 1.6)), this.cbg[1] = r * (5 / 3 + e * (-16 / 15 + e * (-13 / 9 + e * (904 / 315 + e * (-1522 / 945))))), r *= e, this.cgb[2] = r * (56 / 15 + e * (-136 / 35 + e * (-1262 / 105 + e * (73814 / 2835)))), this.cbg[2] = r * (-26 / 15 + e * (34 / 21 + e * (1.6 + e * (-12686 / 2835)))), r *= e, this.cgb[3] = r * (4279 / 630 + e * (-332 / 35 + e * (-399572 / 14175))), this.cbg[3] = r * (1237 / 630 + e * (e * (-24832 / 14175) - 2.4)), r *= e, this.cgb[4] = r * (4174 / 315 + e * (-144838 / 6237)), this.cbg[4] = r * (-734 / 315 + e * (109598 / 31185)), r *= e, this.cgb[5] = r * (601676 / 22275), this.cbg[5] = r * (444337 / 155925), r = Math.pow(e, 2), this.Qn = this.k0 / (1 + e) * (1 + r * (1 / 4 + r * (1 / 64 + r / 256))), this.utg[0] = e * (e * (2 / 3 + e * (-37 / 96 + e * (1 / 360 + e * (81 / 512 + e * (-96199 / 604800))))) - .5), this.gtu[0] = e * (.5 + e * (-2 / 3 + e * (5 / 16 + e * (41 / 180 + e * (-127 / 288 + e * (7891 / 37800)))))), this.utg[1] = r * (-1 / 48 + e * (-1 / 15 + e * (437 / 1440 + e * (-46 / 105 + e * (1118711 / 3870720))))), this.gtu[1] = r * (13 / 48 + e * (e * (557 / 1440 + e * (281 / 630 + e * (-1983433 / 1935360))) - .6)), r *= e, this.utg[2] = r * (-17 / 480 + e * (37 / 840 + e * (209 / 4480 + e * (-5569 / 90720)))), this.gtu[2] = r * (61 / 240 + e * (-103 / 140 + e * (15061 / 26880 + e * (167603 / 181440)))), r *= e, this.utg[3] = r * (-4397 / 161280 + e * (11 / 504 + e * (830251 / 7257600))), this.gtu[3] = r * (49561 / 161280 + e * (-179 / 168 + e * (6601661 / 7257600))), r *= e, this.utg[4] = r * (-4583 / 161280 + e * (108847 / 3991680)), this.gtu[4] = r * (34729 / 80640 + e * (-3418889 / 1995840)), r *= e, this.utg[5] = r * (-20648693 / 638668800), this.gtu[5] = .6650675310896665 * r;
                    var n = Lt(this.cbg, this.lat0);
                    this.Zb = -this.Qn * (n + function(t, e) {
                        for(var r, n = 2 * Math.cos(e), i = t.length - 1, o = t[i], a = 0; --i >= 0;)r = n * o - a + t[i], a = o, o = r;
                        return Math.sin(e) * r;
                    }(this.gtu, 2 * n));
                },
                forward: function(t) {
                    var e = P(t.x - this.long0), r = t.y;
                    r = Lt(this.cbg, r);
                    var n = Math.sin(r), i = Math.cos(r), o = Math.sin(e), a = Math.cos(e);
                    r = Math.atan2(n, a * i), e = Math.atan2(o * i, jt(n, i * a)), e = Rt(Math.tan(e));
                    var s, u, l = qt(this.gtu, 2 * r, 2 * e);
                    return r += l[0], e += l[1], Math.abs(e) <= 2.623395162778 ? (s = this.a * (this.Qn * e) + this.x0, u = this.a * (this.Qn * r + this.Zb) + this.y0) : (s = 1 / 0, u = 1 / 0), t.x = s, t.y = u, t;
                },
                inverse: function(t) {
                    var e, r, n = (t.x - this.x0) * (1 / this.a), i = (t.y - this.y0) * (1 / this.a);
                    if (i = (i - this.Zb) / this.Qn, n /= this.Qn, Math.abs(n) <= 2.623395162778) {
                        var o = qt(this.utg, 2 * i, 2 * n);
                        i += o[0], n += o[1], n = Math.atan(Bt(n));
                        var a = Math.sin(i), s = Math.cos(i), u = Math.sin(n), l = Math.cos(n);
                        i = Math.atan2(a * l, jt(u, l * s)), n = Math.atan2(u, l * s), e = P(n + this.long0), r = Lt(this.cgb, i);
                    } else e = 1 / 0, r = 1 / 0;
                    return t.x = e, t.y = r, t;
                },
                names: [
                    "Extended_Transverse_Mercator",
                    "Extended Transverse Mercator",
                    "etmerc",
                    "Transverse_Mercator",
                    "Transverse Mercator",
                    "Gauss Kruger",
                    "Gauss_Kruger",
                    "tmerc"
                ]
            };
            var zt = {
                init: function() {
                    var t = function(t, e) {
                        if (void 0 === t) {
                            if ((t = Math.floor(30 * (P(e) + Math.PI) / Math.PI) + 1) < 0) return 0;
                            if (t > 60) return 60;
                        }
                        return t;
                    }(this.zone, this.long0);
                    if (void 0 === t) throw new Error("unknown utm zone");
                    this.lat0 = 0, this.long0 = (6 * Math.abs(t) - 183) * o, this.x0 = 5e5, this.y0 = this.utmSouth ? 1e7 : 0, this.k0 = .9996, Ut.init.apply(this), this.forward = Ut.forward, this.inverse = Ut.inverse;
                },
                names: [
                    "Universal Transverse Mercator System",
                    "utm"
                ],
                dependsOn: "etmerc"
            }, Gt = function(t, e) {
                return Math.pow((1 - t) / (1 + t), e);
            };
            var Ht = {
                init: function() {
                    var t = Math.sin(this.lat0), e = Math.cos(this.lat0);
                    e *= e, this.rc = Math.sqrt(1 - this.es) / (1 - this.es * t * t), this.C = Math.sqrt(1 + this.es * e * e / (1 - this.es)), this.phic0 = Math.asin(t / this.C), this.ratexp = .5 * this.C * this.e, this.K = Math.tan(.5 * this.phic0 + s) / (Math.pow(Math.tan(.5 * this.lat0 + s), this.C) * Gt(this.e * t, this.ratexp));
                },
                forward: function(t) {
                    var e = t.x, r = t.y;
                    return t.y = 2 * Math.atan(this.K * Math.pow(Math.tan(.5 * r + s), this.C) * Gt(this.e * Math.sin(r), this.ratexp)) - i, t.x = this.C * e, t;
                },
                inverse: function(t) {
                    for(var e = t.x / this.C, r = t.y, n = Math.pow(Math.tan(.5 * r + s) / this.K, 1 / this.C), o = 20; o > 0 && (r = 2 * Math.atan(n * Gt(this.e * Math.sin(t.y), -0.5 * this.e)) - i, !(Math.abs(r - t.y) < 1e-14)); --o)t.y = r;
                    return o ? (t.x = e, t.y = r, t) : null;
                },
                names: [
                    "gauss"
                ]
            };
            var Wt = {
                init: function() {
                    Ht.init.apply(this), this.rc && (this.sinc0 = Math.sin(this.phic0), this.cosc0 = Math.cos(this.phic0), this.R2 = 2 * this.rc, this.title || (this.title = "Oblique Stereographic Alternative"));
                },
                forward: function(t) {
                    var e, r, n, i;
                    return t.x = P(t.x - this.long0), Ht.forward.apply(this, [
                        t
                    ]), e = Math.sin(t.y), r = Math.cos(t.y), n = Math.cos(t.x), i = this.k0 * this.R2 / (1 + this.sinc0 * e + this.cosc0 * r * n), t.x = i * r * Math.sin(t.x), t.y = i * (this.cosc0 * e - this.sinc0 * r * n), t.x = this.a * t.x + this.x0, t.y = this.a * t.y + this.y0, t;
                },
                inverse: function(t) {
                    var e, r, n, i, o;
                    if (t.x = (t.x - this.x0) / this.a, t.y = (t.y - this.y0) / this.a, t.x /= this.k0, t.y /= this.k0, o = jt(t.x, t.y)) {
                        var a = 2 * Math.atan2(o, this.R2);
                        e = Math.sin(a), r = Math.cos(a), i = Math.asin(r * this.sinc0 + t.y * e * this.cosc0 / o), n = Math.atan2(t.x * e, o * this.cosc0 * r - t.y * this.sinc0 * e);
                    } else i = this.phic0, n = 0;
                    return t.x = n, t.y = i, Ht.inverse.apply(this, [
                        t
                    ]), t.x = P(t.x + this.long0), t;
                },
                names: [
                    "Stereographic_North_Pole",
                    "Oblique_Stereographic",
                    "sterea",
                    "Oblique Stereographic Alternative",
                    "Double_Stereographic"
                ]
            };
            var $t = {
                init: function() {
                    this.x0 = this.x0 || 0, this.y0 = this.y0 || 0, this.lat0 = this.lat0 || 0, this.long0 = this.long0 || 0, this.coslat0 = Math.cos(this.lat0), this.sinlat0 = Math.sin(this.lat0), this.sphere ? 1 === this.k0 && !isNaN(this.lat_ts) && Math.abs(this.coslat0) <= 1e-10 && (this.k0 = .5 * (1 + F(this.lat0) * Math.sin(this.lat_ts))) : (Math.abs(this.coslat0) <= 1e-10 && (this.lat0 > 0 ? this.con = 1 : this.con = -1), this.cons = Math.sqrt(Math.pow(1 + this.e, 1 + this.e) * Math.pow(1 - this.e, 1 - this.e)), 1 === this.k0 && !isNaN(this.lat_ts) && Math.abs(this.coslat0) <= 1e-10 && Math.abs(Math.cos(this.lat_ts)) > 1e-10 && (this.k0 = .5 * this.cons * T(this.e, Math.sin(this.lat_ts), Math.cos(this.lat_ts)) / I(this.e, this.con * this.lat_ts, this.con * Math.sin(this.lat_ts))), this.ms1 = T(this.e, this.sinlat0, this.coslat0), this.X0 = 2 * Math.atan(this.ssfn_(this.lat0, this.sinlat0, this.e)) - i, this.cosX0 = Math.cos(this.X0), this.sinX0 = Math.sin(this.X0));
                },
                forward: function(t) {
                    var e, r, n, o, a, s, u = t.x, l = t.y, c = Math.sin(l), f = Math.cos(l), h = P(u - this.long0);
                    return Math.abs(Math.abs(u - this.long0) - Math.PI) <= 1e-10 && Math.abs(l + this.lat0) <= 1e-10 ? (t.x = NaN, t.y = NaN, t) : this.sphere ? (e = 2 * this.k0 / (1 + this.sinlat0 * c + this.coslat0 * f * Math.cos(h)), t.x = this.a * e * f * Math.sin(h) + this.x0, t.y = this.a * e * (this.coslat0 * c - this.sinlat0 * f * Math.cos(h)) + this.y0, t) : (r = 2 * Math.atan(this.ssfn_(l, c, this.e)) - i, o = Math.cos(r), n = Math.sin(r), Math.abs(this.coslat0) <= 1e-10 ? (a = I(this.e, l * this.con, this.con * c), s = 2 * this.a * this.k0 * a / this.cons, t.x = this.x0 + s * Math.sin(u - this.long0), t.y = this.y0 - this.con * s * Math.cos(u - this.long0), t) : (Math.abs(this.sinlat0) < 1e-10 ? (e = 2 * this.a * this.k0 / (1 + o * Math.cos(h)), t.y = e * n) : (e = 2 * this.a * this.k0 * this.ms1 / (this.cosX0 * (1 + this.sinX0 * n + this.cosX0 * o * Math.cos(h))), t.y = e * (this.cosX0 * n - this.sinX0 * o * Math.cos(h)) + this.y0), t.x = e * o * Math.sin(h) + this.x0, t));
                },
                inverse: function(t) {
                    var e, r, n, o, a;
                    t.x -= this.x0, t.y -= this.y0;
                    var s = Math.sqrt(t.x * t.x + t.y * t.y);
                    if (this.sphere) {
                        var u = 2 * Math.atan(s / (2 * this.a * this.k0));
                        return e = this.long0, r = this.lat0, s <= 1e-10 ? (t.x = e, t.y = r, t) : (r = Math.asin(Math.cos(u) * this.sinlat0 + t.y * Math.sin(u) * this.coslat0 / s), e = Math.abs(this.coslat0) < 1e-10 ? this.lat0 > 0 ? P(this.long0 + Math.atan2(t.x, -1 * t.y)) : P(this.long0 + Math.atan2(t.x, t.y)) : P(this.long0 + Math.atan2(t.x * Math.sin(u), s * this.coslat0 * Math.cos(u) - t.y * this.sinlat0 * Math.sin(u))), t.x = e, t.y = r, t);
                    }
                    if (Math.abs(this.coslat0) <= 1e-10) {
                        if (s <= 1e-10) return r = this.lat0, e = this.long0, t.x = e, t.y = r, t;
                        t.x *= this.con, t.y *= this.con, n = s * this.cons / (2 * this.a * this.k0), r = this.con * B(this.e, n), e = this.con * P(this.con * this.long0 + Math.atan2(t.x, -1 * t.y));
                    } else o = 2 * Math.atan(s * this.cosX0 / (2 * this.a * this.k0 * this.ms1)), e = this.long0, s <= 1e-10 ? a = this.X0 : (a = Math.asin(Math.cos(o) * this.sinX0 + t.y * Math.sin(o) * this.cosX0 / s), e = P(this.long0 + Math.atan2(t.x * Math.sin(o), s * this.cosX0 * Math.cos(o) - t.y * this.sinX0 * Math.sin(o)))), r = -1 * B(this.e, Math.tan(.5 * (i + a)));
                    return t.x = e, t.y = r, t;
                },
                names: [
                    "stere",
                    "Stereographic_South_Pole",
                    "Polar Stereographic (variant B)",
                    "Polar_Stereographic"
                ],
                ssfn_: function(t, e, r) {
                    return e *= r, Math.tan(.5 * (i + t)) * Math.pow((1 - e) / (1 + e), .5 * r);
                }
            };
            var Vt = {
                init: function() {
                    var t = this.lat0;
                    this.lambda0 = this.long0;
                    var e = Math.sin(t), r = this.a, n = 1 / this.rf, i = 2 * n - Math.pow(n, 2), o = this.e = Math.sqrt(i);
                    this.R = this.k0 * r * Math.sqrt(1 - i) / (1 - i * Math.pow(e, 2)), this.alpha = Math.sqrt(1 + i / (1 - i) * Math.pow(Math.cos(t), 4)), this.b0 = Math.asin(e / this.alpha);
                    var a = Math.log(Math.tan(Math.PI / 4 + this.b0 / 2)), s = Math.log(Math.tan(Math.PI / 4 + t / 2)), u = Math.log((1 + o * e) / (1 - o * e));
                    this.K = a - this.alpha * s + this.alpha * o / 2 * u;
                },
                forward: function(t) {
                    var e = Math.log(Math.tan(Math.PI / 4 - t.y / 2)), r = this.e / 2 * Math.log((1 + this.e * Math.sin(t.y)) / (1 - this.e * Math.sin(t.y))), n = -this.alpha * (e + r) + this.K, i = 2 * (Math.atan(Math.exp(n)) - Math.PI / 4), o = this.alpha * (t.x - this.lambda0), a = Math.atan(Math.sin(o) / (Math.sin(this.b0) * Math.tan(i) + Math.cos(this.b0) * Math.cos(o))), s = Math.asin(Math.cos(this.b0) * Math.sin(i) - Math.sin(this.b0) * Math.cos(i) * Math.cos(o));
                    return t.y = this.R / 2 * Math.log((1 + Math.sin(s)) / (1 - Math.sin(s))) + this.y0, t.x = this.R * a + this.x0, t;
                },
                inverse: function(t) {
                    for(var e = t.x - this.x0, r = t.y - this.y0, n = e / this.R, i = 2 * (Math.atan(Math.exp(r / this.R)) - Math.PI / 4), o = Math.asin(Math.cos(this.b0) * Math.sin(i) + Math.sin(this.b0) * Math.cos(i) * Math.cos(n)), a = Math.atan(Math.sin(n) / (Math.cos(this.b0) * Math.cos(n) - Math.sin(this.b0) * Math.tan(i))), s = this.lambda0 + a / this.alpha, u = 0, l = o, c = -1000, f = 0; Math.abs(l - c) > 1e-7;){
                        if (++f > 20) return;
                        u = 1 / this.alpha * (Math.log(Math.tan(Math.PI / 4 + o / 2)) - this.K) + this.e * Math.log(Math.tan(Math.PI / 4 + Math.asin(this.e * Math.sin(l)) / 2)), c = l, l = 2 * Math.atan(Math.exp(u)) - Math.PI / 2;
                    }
                    return t.x = s, t.y = l, t;
                },
                names: [
                    "somerc"
                ]
            };
            var Zt = {
                init: function() {
                    var t, e, r, n, a, l, c, f, h, p, d, m, y, g = 0, v = 0, b = 0, x = 0, w = 0, _ = 0, A = 0;
                    this.no_off = (y = "object" == typeof (m = this).PROJECTION ? Object.keys(m.PROJECTION)[0] : m.PROJECTION, "no_uoff" in m || "no_off" in m || -1 !== [
                        "Hotine_Oblique_Mercator",
                        "Hotine_Oblique_Mercator_Azimuth_Natural_Origin"
                    ].indexOf(y)), this.no_rot = "no_rot" in this;
                    var E = !1;
                    "alpha" in this && (E = !0);
                    var S = !1;
                    if ("rectified_grid_angle" in this && (S = !0), E && (A = this.alpha), S && (g = this.rectified_grid_angle * o), E || S) v = this.longc;
                    else if (b = this.long1, w = this.lat1, x = this.long2, _ = this.lat2, Math.abs(w - _) <= 1e-7 || (t = Math.abs(w)) <= 1e-7 || Math.abs(t - i) <= 1e-7 || Math.abs(Math.abs(this.lat0) - i) <= 1e-7 || Math.abs(Math.abs(_) - i) <= 1e-7) throw new Error;
                    var M = 1 - this.es;
                    e = Math.sqrt(M), Math.abs(this.lat0) > 1e-10 ? (f = Math.sin(this.lat0), r = Math.cos(this.lat0), t = 1 - this.es * f * f, this.B = r * r, this.B = Math.sqrt(1 + this.es * this.B * this.B / M), this.A = this.B * this.k0 * e / t, (a = (n = this.B * e / (r * Math.sqrt(t))) * n - 1) <= 0 ? a = 0 : (a = Math.sqrt(a), this.lat0 < 0 && (a = -a)), this.E = a += n, this.E *= Math.pow(I(this.e, this.lat0, f), this.B)) : (this.B = 1 / e, this.A = this.k0, this.E = n = a = 1), E || S ? (E ? (d = Math.asin(Math.sin(A) / n), S || (g = A)) : (d = g, A = Math.asin(n * Math.sin(d))), this.lam0 = v - Math.asin(.5 * (a - 1 / a) * Math.tan(d)) / this.B) : (l = Math.pow(I(this.e, w, Math.sin(w)), this.B), c = Math.pow(I(this.e, _, Math.sin(_)), this.B), a = this.E / l, h = (c - l) / (c + l), p = ((p = this.E * this.E) - c * l) / (p + c * l), (t = b - x) < -Math.pi ? x -= u : t > Math.pi && (x += u), this.lam0 = P(.5 * (b + x) - Math.atan(p * Math.tan(.5 * this.B * (b - x)) / h) / this.B), d = Math.atan(2 * Math.sin(this.B * P(b - this.lam0)) / (a - 1 / a)), g = A = Math.asin(n * Math.sin(d))), this.singam = Math.sin(d), this.cosgam = Math.cos(d), this.sinrot = Math.sin(g), this.cosrot = Math.cos(g), this.rB = 1 / this.B, this.ArB = this.A * this.rB, this.BrA = 1 / this.ArB, this.A, this.B, this.no_off ? this.u_0 = 0 : (this.u_0 = Math.abs(this.ArB * Math.atan(Math.sqrt(n * n - 1) / Math.cos(A))), this.lat0 < 0 && (this.u_0 = -this.u_0)), a = .5 * d, this.v_pole_n = this.ArB * Math.log(Math.tan(s - a)), this.v_pole_s = this.ArB * Math.log(Math.tan(s + a));
                },
                forward: function(t) {
                    var e, r, n, o, a, s, u, l, c = {};
                    if (t.x = t.x - this.lam0, Math.abs(Math.abs(t.y) - i) > 1e-10) {
                        if (e = .5 * ((a = this.E / Math.pow(I(this.e, t.y, Math.sin(t.y)), this.B)) - (s = 1 / a)), r = .5 * (a + s), o = Math.sin(this.B * t.x), n = (e * this.singam - o * this.cosgam) / r, Math.abs(Math.abs(n) - 1) < 1e-10) throw new Error;
                        l = .5 * this.ArB * Math.log((1 - n) / (1 + n)), s = Math.cos(this.B * t.x), u = Math.abs(s) < 1e-7 ? this.A * t.x : this.ArB * Math.atan2(e * this.cosgam + o * this.singam, s);
                    } else l = t.y > 0 ? this.v_pole_n : this.v_pole_s, u = this.ArB * t.y;
                    return this.no_rot ? (c.x = u, c.y = l) : (u -= this.u_0, c.x = l * this.cosrot + u * this.sinrot, c.y = u * this.cosrot - l * this.sinrot), c.x = this.a * c.x + this.x0, c.y = this.a * c.y + this.y0, c;
                },
                inverse: function(t) {
                    var e, r, n, o, a, s, u, l = {};
                    if (t.x = (t.x - this.x0) * (1 / this.a), t.y = (t.y - this.y0) * (1 / this.a), this.no_rot ? (r = t.y, e = t.x) : (r = t.x * this.cosrot - t.y * this.sinrot, e = t.y * this.cosrot + t.x * this.sinrot + this.u_0), o = .5 * ((n = Math.exp(-this.BrA * r)) - 1 / n), a = .5 * (n + 1 / n), u = ((s = Math.sin(this.BrA * e)) * this.cosgam + o * this.singam) / a, Math.abs(Math.abs(u) - 1) < 1e-10) l.x = 0, l.y = u < 0 ? -i : i;
                    else {
                        if (l.y = this.E / Math.sqrt((1 + u) / (1 - u)), l.y = B(this.e, Math.pow(l.y, 1 / this.B)), l.y === 1 / 0) throw new Error;
                        l.x = -this.rB * Math.atan2(o * this.cosgam - s * this.singam, Math.cos(this.BrA * e));
                    }
                    return l.x += this.lam0, l;
                },
                names: [
                    "Hotine_Oblique_Mercator",
                    "Hotine Oblique Mercator",
                    "Hotine_Oblique_Mercator_Azimuth_Natural_Origin",
                    "Hotine_Oblique_Mercator_Two_Point_Natural_Origin",
                    "Hotine_Oblique_Mercator_Azimuth_Center",
                    "Oblique_Mercator",
                    "omerc"
                ]
            };
            var Yt = {
                init: function() {
                    if (this.lat2 || (this.lat2 = this.lat1), this.k0 || (this.k0 = 1), this.x0 = this.x0 || 0, this.y0 = this.y0 || 0, !(Math.abs(this.lat1 + this.lat2) < 1e-10)) {
                        var t = this.b / this.a;
                        this.e = Math.sqrt(1 - t * t);
                        var e = Math.sin(this.lat1), r = Math.cos(this.lat1), n = T(this.e, e, r), i = I(this.e, this.lat1, e), o = Math.sin(this.lat2), a = Math.cos(this.lat2), s = T(this.e, o, a), u = I(this.e, this.lat2, o), l = I(this.e, this.lat0, Math.sin(this.lat0));
                        Math.abs(this.lat1 - this.lat2) > 1e-10 ? this.ns = Math.log(n / s) / Math.log(i / u) : this.ns = e, isNaN(this.ns) && (this.ns = e), this.f0 = n / (this.ns * Math.pow(i, this.ns)), this.rh = this.a * this.f0 * Math.pow(l, this.ns), this.title || (this.title = "Lambert Conformal Conic");
                    }
                },
                forward: function(t) {
                    var e = t.x, r = t.y;
                    Math.abs(2 * Math.abs(r) - Math.PI) <= 1e-10 && (r = F(r) * (i - 2e-10));
                    var n, o, a = Math.abs(Math.abs(r) - i);
                    if (a > 1e-10) n = I(this.e, r, Math.sin(r)), o = this.a * this.f0 * Math.pow(n, this.ns);
                    else {
                        if ((a = r * this.ns) <= 0) return null;
                        o = 0;
                    }
                    var s = this.ns * P(e - this.long0);
                    return t.x = this.k0 * (o * Math.sin(s)) + this.x0, t.y = this.k0 * (this.rh - o * Math.cos(s)) + this.y0, t;
                },
                inverse: function(t) {
                    var e, r, n, o, a, s = (t.x - this.x0) / this.k0, u = this.rh - (t.y - this.y0) / this.k0;
                    this.ns > 0 ? (e = Math.sqrt(s * s + u * u), r = 1) : (e = -Math.sqrt(s * s + u * u), r = -1);
                    var l = 0;
                    if (0 !== e && (l = Math.atan2(r * s, r * u)), 0 !== e || this.ns > 0) {
                        if (r = 1 / this.ns, n = Math.pow(e / (this.a * this.f0), r), -9999 === (o = B(this.e, n))) return null;
                    } else o = -i;
                    return a = P(l / this.ns + this.long0), t.x = a, t.y = o, t;
                },
                names: [
                    "Lambert Tangential Conformal Conic Projection",
                    "Lambert_Conformal_Conic",
                    "Lambert_Conformal_Conic_1SP",
                    "Lambert_Conformal_Conic_2SP",
                    "lcc",
                    "Lambert Conic Conformal (1SP)",
                    "Lambert Conic Conformal (2SP)"
                ]
            };
            var Kt = {
                init: function() {
                    this.a = 6377397.155, this.es = .006674372230614, this.e = Math.sqrt(this.es), this.lat0 || (this.lat0 = .863937979737193), this.long0 || (this.long0 = .4334234309119251), this.k0 || (this.k0 = .9999), this.s45 = .785398163397448, this.s90 = 2 * this.s45, this.fi0 = this.lat0, this.e2 = this.es, this.e = Math.sqrt(this.e2), this.alfa = Math.sqrt(1 + this.e2 * Math.pow(Math.cos(this.fi0), 4) / (1 - this.e2)), this.uq = 1.04216856380474, this.u0 = Math.asin(Math.sin(this.fi0) / this.alfa), this.g = Math.pow((1 + this.e * Math.sin(this.fi0)) / (1 - this.e * Math.sin(this.fi0)), this.alfa * this.e / 2), this.k = Math.tan(this.u0 / 2 + this.s45) / Math.pow(Math.tan(this.fi0 / 2 + this.s45), this.alfa) * this.g, this.k1 = this.k0, this.n0 = this.a * Math.sqrt(1 - this.e2) / (1 - this.e2 * Math.pow(Math.sin(this.fi0), 2)), this.s0 = 1.37008346281555, this.n = Math.sin(this.s0), this.ro0 = this.k1 * this.n0 / Math.tan(this.s0), this.ad = this.s90 - this.uq;
                },
                forward: function(t) {
                    var e, r, n, i, o, a, s, u = t.x, l = t.y, c = P(u - this.long0);
                    return e = Math.pow((1 + this.e * Math.sin(l)) / (1 - this.e * Math.sin(l)), this.alfa * this.e / 2), r = 2 * (Math.atan(this.k * Math.pow(Math.tan(l / 2 + this.s45), this.alfa) / e) - this.s45), n = -c * this.alfa, i = Math.asin(Math.cos(this.ad) * Math.sin(r) + Math.sin(this.ad) * Math.cos(r) * Math.cos(n)), o = Math.asin(Math.cos(r) * Math.sin(n) / Math.cos(i)), a = this.n * o, s = this.ro0 * Math.pow(Math.tan(this.s0 / 2 + this.s45), this.n) / Math.pow(Math.tan(i / 2 + this.s45), this.n), t.y = s * Math.cos(a) / 1, t.x = s * Math.sin(a) / 1, this.czech || (t.y *= -1, t.x *= -1), t;
                },
                inverse: function(t) {
                    var e, r, n, i, o, a, s, u = t.x;
                    t.x = t.y, t.y = u, this.czech || (t.y *= -1, t.x *= -1), o = Math.sqrt(t.x * t.x + t.y * t.y), i = Math.atan2(t.y, t.x) / Math.sin(this.s0), n = 2 * (Math.atan(Math.pow(this.ro0 / o, 1 / this.n) * Math.tan(this.s0 / 2 + this.s45)) - this.s45), e = Math.asin(Math.cos(this.ad) * Math.sin(n) - Math.sin(this.ad) * Math.cos(n) * Math.cos(i)), r = Math.asin(Math.cos(n) * Math.sin(i) / Math.cos(e)), t.x = this.long0 - r / this.alfa, a = e, s = 0;
                    var l = 0;
                    do t.y = 2 * (Math.atan(Math.pow(this.k, -1 / this.alfa) * Math.pow(Math.tan(e / 2 + this.s45), 1 / this.alfa) * Math.pow((1 + this.e * Math.sin(a)) / (1 - this.e * Math.sin(a)), this.e / 2)) - this.s45), Math.abs(a - t.y) < 1e-10 && (s = 1), a = t.y, l += 1;
                    while (0 === s && l < 15);
                    return l >= 15 ? null : t;
                },
                names: [
                    "Krovak",
                    "krovak"
                ]
            }, Xt = function(t, e, r, n, i) {
                return t * i - e * Math.sin(2 * i) + r * Math.sin(4 * i) - n * Math.sin(6 * i);
            }, Jt = function(t) {
                return 1 - .25 * t * (1 + t / 16 * (3 + 1.25 * t));
            }, Qt = function(t) {
                return .375 * t * (1 + .25 * t * (1 + .46875 * t));
            }, te = function(t) {
                return .05859375 * t * t * (1 + .75 * t);
            }, ee = function(t) {
                return t * t * t * (35 / 3072);
            }, re = function(t, e, r) {
                var n = e * r;
                return t / Math.sqrt(1 - n * n);
            }, ne = function(t) {
                return Math.abs(t) < i ? t : t - F(t) * Math.PI;
            }, ie = function(t, e, r, n, i) {
                var o, a;
                o = t / e;
                for(var s = 0; s < 15; s++)if (o += a = (t - (e * o - r * Math.sin(2 * o) + n * Math.sin(4 * o) - i * Math.sin(6 * o))) / (e - 2 * r * Math.cos(2 * o) + 4 * n * Math.cos(4 * o) - 6 * i * Math.cos(6 * o)), Math.abs(a) <= 1e-10) return o;
                return NaN;
            };
            var oe = {
                init: function() {
                    this.sphere || (this.e0 = Jt(this.es), this.e1 = Qt(this.es), this.e2 = te(this.es), this.e3 = ee(this.es), this.ml0 = this.a * Xt(this.e0, this.e1, this.e2, this.e3, this.lat0));
                },
                forward: function(t) {
                    var e, r, n = t.x, i = t.y;
                    if (n = P(n - this.long0), this.sphere) e = this.a * Math.asin(Math.cos(i) * Math.sin(n)), r = this.a * (Math.atan2(Math.tan(i), Math.cos(n)) - this.lat0);
                    else {
                        var o = Math.sin(i), a = Math.cos(i), s = re(this.a, this.e, o), u = Math.tan(i) * Math.tan(i), l = n * Math.cos(i), c = l * l, f = this.es * a * a / (1 - this.es);
                        e = s * l * (1 - c * u * (1 / 6 - (8 - u + 8 * f) * c / 120)), r = this.a * Xt(this.e0, this.e1, this.e2, this.e3, i) - this.ml0 + s * o / a * c * (.5 + (5 - u + 6 * f) * c / 24);
                    }
                    return t.x = e + this.x0, t.y = r + this.y0, t;
                },
                inverse: function(t) {
                    t.x -= this.x0, t.y -= this.y0;
                    var e, r, n = t.x / this.a, o = t.y / this.a;
                    if (this.sphere) {
                        var a = o + this.lat0;
                        e = Math.asin(Math.sin(a) * Math.cos(n)), r = Math.atan2(Math.tan(n), Math.cos(a));
                    } else {
                        var s = this.ml0 / this.a + o, u = ie(s, this.e0, this.e1, this.e2, this.e3);
                        if (Math.abs(Math.abs(u) - i) <= 1e-10) return t.x = this.long0, t.y = i, o < 0 && (t.y *= -1), t;
                        var l = re(this.a, this.e, Math.sin(u)), c = l * l * l / this.a / this.a * (1 - this.es), f = Math.pow(Math.tan(u), 2), h = n * this.a / l, p = h * h;
                        e = u - l * Math.tan(u) / c * h * h * (.5 - (1 + 3 * f) * h * h / 24), r = h * (1 - p * (f / 3 + (1 + 3 * f) * f * p / 15)) / Math.cos(u);
                    }
                    return t.x = P(r + this.long0), t.y = ne(e), t;
                },
                names: [
                    "Cassini",
                    "Cassini_Soldner",
                    "cass"
                ]
            }, ae = function(t, e) {
                var r;
                return t > 1e-7 ? (1 - t * t) * (e / (1 - (r = t * e) * r) - .5 / t * Math.log((1 - r) / (1 + r))) : 2 * e;
            };
            var se = {
                init: function() {
                    var t, e = Math.abs(this.lat0);
                    if (Math.abs(e - i) < 1e-10 ? this.mode = this.lat0 < 0 ? this.S_POLE : this.N_POLE : Math.abs(e) < 1e-10 ? this.mode = this.EQUIT : this.mode = this.OBLIQ, this.es > 0) switch(this.qp = ae(this.e, 1), this.mmf = .5 / (1 - this.es), this.apa = function(t) {
                        var e, r = [];
                        return r[0] = .3333333333333333 * t, e = t * t, r[0] += .17222222222222222 * e, r[1] = .06388888888888888 * e, e *= t, r[0] += .10257936507936508 * e, r[1] += .0664021164021164 * e, r[2] = .016415012942191543 * e, r;
                    }(this.es), this.mode){
                        case this.N_POLE:
                        case this.S_POLE:
                            this.dd = 1;
                            break;
                        case this.EQUIT:
                            this.rq = Math.sqrt(.5 * this.qp), this.dd = 1 / this.rq, this.xmf = 1, this.ymf = .5 * this.qp;
                            break;
                        case this.OBLIQ:
                            this.rq = Math.sqrt(.5 * this.qp), t = Math.sin(this.lat0), this.sinb1 = ae(this.e, t) / this.qp, this.cosb1 = Math.sqrt(1 - this.sinb1 * this.sinb1), this.dd = Math.cos(this.lat0) / (Math.sqrt(1 - this.es * t * t) * this.rq * this.cosb1), this.ymf = (this.xmf = this.rq) / this.dd, this.xmf *= this.dd;
                    }
                    else this.mode === this.OBLIQ && (this.sinph0 = Math.sin(this.lat0), this.cosph0 = Math.cos(this.lat0));
                },
                forward: function(t) {
                    var e, r, n, o, a, u, l, c, f, h, p = t.x, d = t.y;
                    if (p = P(p - this.long0), this.sphere) {
                        if (a = Math.sin(d), h = Math.cos(d), n = Math.cos(p), this.mode === this.OBLIQ || this.mode === this.EQUIT) {
                            if ((r = this.mode === this.EQUIT ? 1 + h * n : 1 + this.sinph0 * a + this.cosph0 * h * n) <= 1e-10) return null;
                            e = (r = Math.sqrt(2 / r)) * h * Math.sin(p), r *= this.mode === this.EQUIT ? a : this.cosph0 * a - this.sinph0 * h * n;
                        } else if (this.mode === this.N_POLE || this.mode === this.S_POLE) {
                            if (this.mode === this.N_POLE && (n = -n), Math.abs(d + this.lat0) < 1e-10) return null;
                            r = s - .5 * d, e = (r = 2 * (this.mode === this.S_POLE ? Math.cos(r) : Math.sin(r))) * Math.sin(p), r *= n;
                        }
                    } else {
                        switch(l = 0, c = 0, f = 0, n = Math.cos(p), o = Math.sin(p), a = Math.sin(d), u = ae(this.e, a), this.mode !== this.OBLIQ && this.mode !== this.EQUIT || (l = u / this.qp, c = Math.sqrt(1 - l * l)), this.mode){
                            case this.OBLIQ:
                                f = 1 + this.sinb1 * l + this.cosb1 * c * n;
                                break;
                            case this.EQUIT:
                                f = 1 + c * n;
                                break;
                            case this.N_POLE:
                                f = i + d, u = this.qp - u;
                                break;
                            case this.S_POLE:
                                f = d - i, u = this.qp + u;
                        }
                        if (Math.abs(f) < 1e-10) return null;
                        switch(this.mode){
                            case this.OBLIQ:
                            case this.EQUIT:
                                f = Math.sqrt(2 / f), r = this.mode === this.OBLIQ ? this.ymf * f * (this.cosb1 * l - this.sinb1 * c * n) : (f = Math.sqrt(2 / (1 + c * n))) * l * this.ymf, e = this.xmf * f * c * o;
                                break;
                            case this.N_POLE:
                            case this.S_POLE:
                                u >= 0 ? (e = (f = Math.sqrt(u)) * o, r = n * (this.mode === this.S_POLE ? f : -f)) : e = r = 0;
                        }
                    }
                    return t.x = this.a * e + this.x0, t.y = this.a * r + this.y0, t;
                },
                inverse: function(t) {
                    t.x -= this.x0, t.y -= this.y0;
                    var e, r, n, o, a, s, u, l, c, f, h = t.x / this.a, p = t.y / this.a;
                    if (this.sphere) {
                        var d, m = 0, y = 0;
                        if ((r = .5 * (d = Math.sqrt(h * h + p * p))) > 1) return null;
                        switch(r = 2 * Math.asin(r), this.mode !== this.OBLIQ && this.mode !== this.EQUIT || (y = Math.sin(r), m = Math.cos(r)), this.mode){
                            case this.EQUIT:
                                r = Math.abs(d) <= 1e-10 ? 0 : Math.asin(p * y / d), h *= y, p = m * d;
                                break;
                            case this.OBLIQ:
                                r = Math.abs(d) <= 1e-10 ? this.lat0 : Math.asin(m * this.sinph0 + p * y * this.cosph0 / d), h *= y * this.cosph0, p = (m - Math.sin(r) * this.sinph0) * d;
                                break;
                            case this.N_POLE:
                                p = -p, r = i - r;
                                break;
                            case this.S_POLE:
                                r -= i;
                        }
                        e = 0 !== p || this.mode !== this.EQUIT && this.mode !== this.OBLIQ ? Math.atan2(h, p) : 0;
                    } else {
                        if (u = 0, this.mode === this.OBLIQ || this.mode === this.EQUIT) {
                            if (h /= this.dd, p *= this.dd, (s = Math.sqrt(h * h + p * p)) < 1e-10) return t.x = this.long0, t.y = this.lat0, t;
                            o = 2 * Math.asin(.5 * s / this.rq), n = Math.cos(o), h *= o = Math.sin(o), this.mode === this.OBLIQ ? (u = n * this.sinb1 + p * o * this.cosb1 / s, a = this.qp * u, p = s * this.cosb1 * n - p * this.sinb1 * o) : (u = p * o / s, a = this.qp * u, p = s * n);
                        } else if (this.mode === this.N_POLE || this.mode === this.S_POLE) {
                            if (this.mode === this.N_POLE && (p = -p), !(a = h * h + p * p)) return t.x = this.long0, t.y = this.lat0, t;
                            u = 1 - a / this.qp, this.mode === this.S_POLE && (u = -u);
                        }
                        e = Math.atan2(h, p), l = Math.asin(u), c = this.apa, f = l + l, r = l + c[0] * Math.sin(f) + c[1] * Math.sin(f + f) + c[2] * Math.sin(f + f + f);
                    }
                    return t.x = P(this.long0 + e), t.y = r, t;
                },
                names: [
                    "Lambert Azimuthal Equal Area",
                    "Lambert_Azimuthal_Equal_Area",
                    "laea"
                ],
                S_POLE: 1,
                N_POLE: 2,
                EQUIT: 3,
                OBLIQ: 4
            }, ue = function(t) {
                return Math.abs(t) > 1 && (t = t > 1 ? 1 : -1), Math.asin(t);
            };
            var le = {
                init: function() {
                    Math.abs(this.lat1 + this.lat2) < 1e-10 || (this.temp = this.b / this.a, this.es = 1 - Math.pow(this.temp, 2), this.e3 = Math.sqrt(this.es), this.sin_po = Math.sin(this.lat1), this.cos_po = Math.cos(this.lat1), this.t1 = this.sin_po, this.con = this.sin_po, this.ms1 = T(this.e3, this.sin_po, this.cos_po), this.qs1 = ae(this.e3, this.sin_po), this.sin_po = Math.sin(this.lat2), this.cos_po = Math.cos(this.lat2), this.t2 = this.sin_po, this.ms2 = T(this.e3, this.sin_po, this.cos_po), this.qs2 = ae(this.e3, this.sin_po), this.sin_po = Math.sin(this.lat0), this.cos_po = Math.cos(this.lat0), this.t3 = this.sin_po, this.qs0 = ae(this.e3, this.sin_po), Math.abs(this.lat1 - this.lat2) > 1e-10 ? this.ns0 = (this.ms1 * this.ms1 - this.ms2 * this.ms2) / (this.qs2 - this.qs1) : this.ns0 = this.con, this.c = this.ms1 * this.ms1 + this.ns0 * this.qs1, this.rh = this.a * Math.sqrt(this.c - this.ns0 * this.qs0) / this.ns0);
                },
                forward: function(t) {
                    var e = t.x, r = t.y;
                    this.sin_phi = Math.sin(r), this.cos_phi = Math.cos(r);
                    var n = ae(this.e3, this.sin_phi), i = this.a * Math.sqrt(this.c - this.ns0 * n) / this.ns0, o = this.ns0 * P(e - this.long0), a = i * Math.sin(o) + this.x0, s = this.rh - i * Math.cos(o) + this.y0;
                    return t.x = a, t.y = s, t;
                },
                inverse: function(t) {
                    var e, r, n, i, o, a;
                    return t.x -= this.x0, t.y = this.rh - t.y + this.y0, this.ns0 >= 0 ? (e = Math.sqrt(t.x * t.x + t.y * t.y), n = 1) : (e = -Math.sqrt(t.x * t.x + t.y * t.y), n = -1), i = 0, 0 !== e && (i = Math.atan2(n * t.x, n * t.y)), n = e * this.ns0 / this.a, this.sphere ? a = Math.asin((this.c - n * n) / (2 * this.ns0)) : (r = (this.c - n * n) / this.ns0, a = this.phi1z(this.e3, r)), o = P(i / this.ns0 + this.long0), t.x = o, t.y = a, t;
                },
                names: [
                    "Albers_Conic_Equal_Area",
                    "Albers",
                    "aea"
                ],
                phi1z: function(t, e) {
                    var r, n, i, o, a = ue(.5 * e);
                    if (t < 1e-10) return a;
                    for(var s = t * t, u = 1; u <= 25; u++)if (a += o = .5 * (i = 1 - (n = t * (r = Math.sin(a))) * n) * i / Math.cos(a) * (e / (1 - s) - r / i + .5 / t * Math.log((1 - n) / (1 + n))), Math.abs(o) <= 1e-7) return a;
                    return null;
                }
            };
            var ce = {
                init: function() {
                    this.sin_p14 = Math.sin(this.lat0), this.cos_p14 = Math.cos(this.lat0), this.infinity_dist = 1e3 * this.a, this.rc = 1;
                },
                forward: function(t) {
                    var e, r, n, i, o, a, s, u = t.x, l = t.y;
                    return n = P(u - this.long0), e = Math.sin(l), r = Math.cos(l), i = Math.cos(n), (o = this.sin_p14 * e + this.cos_p14 * r * i) > 0 || Math.abs(o) <= 1e-10 ? (a = this.x0 + 1 * this.a * r * Math.sin(n) / o, s = this.y0 + 1 * this.a * (this.cos_p14 * e - this.sin_p14 * r * i) / o) : (a = this.x0 + this.infinity_dist * r * Math.sin(n), s = this.y0 + this.infinity_dist * (this.cos_p14 * e - this.sin_p14 * r * i)), t.x = a, t.y = s, t;
                },
                inverse: function(t) {
                    var e, r, n, i, o, a;
                    return t.x = (t.x - this.x0) / this.a, t.y = (t.y - this.y0) / this.a, t.x /= this.k0, t.y /= this.k0, (e = Math.sqrt(t.x * t.x + t.y * t.y)) ? (i = Math.atan2(e, this.rc), r = Math.sin(i), n = Math.cos(i), a = ue(n * this.sin_p14 + t.y * r * this.cos_p14 / e), o = Math.atan2(t.x * r, e * this.cos_p14 * n - t.y * this.sin_p14 * r), o = P(this.long0 + o)) : (a = this.phic0, o = 0), t.x = o, t.y = a, t;
                },
                names: [
                    "gnom"
                ]
            };
            var fe = {
                init: function() {
                    this.sphere || (this.k0 = T(this.e, Math.sin(this.lat_ts), Math.cos(this.lat_ts)));
                },
                forward: function(t) {
                    var e, r, n = t.x, i = t.y, o = P(n - this.long0);
                    if (this.sphere) e = this.x0 + this.a * o * Math.cos(this.lat_ts), r = this.y0 + this.a * Math.sin(i) / Math.cos(this.lat_ts);
                    else {
                        var a = ae(this.e, Math.sin(i));
                        e = this.x0 + this.a * this.k0 * o, r = this.y0 + this.a * a * .5 / this.k0;
                    }
                    return t.x = e, t.y = r, t;
                },
                inverse: function(t) {
                    var e, r;
                    return t.x -= this.x0, t.y -= this.y0, this.sphere ? (e = P(this.long0 + t.x / this.a / Math.cos(this.lat_ts)), r = Math.asin(t.y / this.a * Math.cos(this.lat_ts))) : (r = function(t, e) {
                        var r = 1 - (1 - t * t) / (2 * t) * Math.log((1 - t) / (1 + t));
                        if (Math.abs(Math.abs(e) - r) < 1e-6) return e < 0 ? -1 * i : i;
                        for(var n, o, a, s, u = Math.asin(.5 * e), l = 0; l < 30; l++)if (o = Math.sin(u), a = Math.cos(u), s = t * o, u += n = Math.pow(1 - s * s, 2) / (2 * a) * (e / (1 - t * t) - o / (1 - s * s) + .5 / t * Math.log((1 - s) / (1 + s))), Math.abs(n) <= 1e-10) return u;
                        return NaN;
                    }(this.e, 2 * t.y * this.k0 / this.a), e = P(this.long0 + t.x / (this.a * this.k0))), t.x = e, t.y = r, t;
                },
                names: [
                    "cea"
                ]
            };
            var he = {
                init: function() {
                    this.x0 = this.x0 || 0, this.y0 = this.y0 || 0, this.lat0 = this.lat0 || 0, this.long0 = this.long0 || 0, this.lat_ts = this.lat_ts || 0, this.title = this.title || "Equidistant Cylindrical (Plate Carre)", this.rc = Math.cos(this.lat_ts);
                },
                forward: function(t) {
                    var e = t.x, r = t.y, n = P(e - this.long0), i = ne(r - this.lat0);
                    return t.x = this.x0 + this.a * n * this.rc, t.y = this.y0 + this.a * i, t;
                },
                inverse: function(t) {
                    var e = t.x, r = t.y;
                    return t.x = P(this.long0 + (e - this.x0) / (this.a * this.rc)), t.y = ne(this.lat0 + (r - this.y0) / this.a), t;
                },
                names: [
                    "Equirectangular",
                    "Equidistant_Cylindrical",
                    "eqc"
                ]
            };
            var pe = {
                init: function() {
                    this.temp = this.b / this.a, this.es = 1 - Math.pow(this.temp, 2), this.e = Math.sqrt(this.es), this.e0 = Jt(this.es), this.e1 = Qt(this.es), this.e2 = te(this.es), this.e3 = ee(this.es), this.ml0 = this.a * Xt(this.e0, this.e1, this.e2, this.e3, this.lat0);
                },
                forward: function(t) {
                    var e, r, n, i = t.x, o = t.y, a = P(i - this.long0);
                    if (n = a * Math.sin(o), this.sphere) Math.abs(o) <= 1e-10 ? (e = this.a * a, r = -1 * this.a * this.lat0) : (e = this.a * Math.sin(n) / Math.tan(o), r = this.a * (ne(o - this.lat0) + (1 - Math.cos(n)) / Math.tan(o)));
                    else if (Math.abs(o) <= 1e-10) e = this.a * a, r = -1 * this.ml0;
                    else {
                        var s = re(this.a, this.e, Math.sin(o)) / Math.tan(o);
                        e = s * Math.sin(n), r = this.a * Xt(this.e0, this.e1, this.e2, this.e3, o) - this.ml0 + s * (1 - Math.cos(n));
                    }
                    return t.x = e + this.x0, t.y = r + this.y0, t;
                },
                inverse: function(t) {
                    var e, r, n, i, o, a, s, u, l;
                    if (n = t.x - this.x0, i = t.y - this.y0, this.sphere) {
                        if (Math.abs(i + this.a * this.lat0) <= 1e-10) e = P(n / this.a + this.long0), r = 0;
                        else {
                            var c;
                            for(a = this.lat0 + i / this.a, s = n * n / this.a / this.a + a * a, u = a, o = 20; o; --o)if (u += l = -1 * (a * (u * (c = Math.tan(u)) + 1) - u - .5 * (u * u + s) * c) / ((u - a) / c - 1), Math.abs(l) <= 1e-10) {
                                r = u;
                                break;
                            }
                            e = P(this.long0 + Math.asin(n * Math.tan(u) / this.a) / Math.sin(r));
                        }
                    } else if (Math.abs(i + this.ml0) <= 1e-10) r = 0, e = P(this.long0 + n / this.a);
                    else {
                        var f, h, p, d, m;
                        for(a = (this.ml0 + i) / this.a, s = n * n / this.a / this.a + a * a, u = a, o = 20; o; --o)if (m = this.e * Math.sin(u), f = Math.sqrt(1 - m * m) * Math.tan(u), h = this.a * Xt(this.e0, this.e1, this.e2, this.e3, u), p = this.e0 - 2 * this.e1 * Math.cos(2 * u) + 4 * this.e2 * Math.cos(4 * u) - 6 * this.e3 * Math.cos(6 * u), u -= l = (a * (f * (d = h / this.a) + 1) - d - .5 * f * (d * d + s)) / (this.es * Math.sin(2 * u) * (d * d + s - 2 * a * d) / (4 * f) + (a - d) * (f * p - 2 / Math.sin(2 * u)) - p), Math.abs(l) <= 1e-10) {
                            r = u;
                            break;
                        }
                        f = Math.sqrt(1 - this.es * Math.pow(Math.sin(r), 2)) * Math.tan(r), e = P(this.long0 + Math.asin(n * f / this.a) / Math.sin(r));
                    }
                    return t.x = e, t.y = r, t;
                },
                names: [
                    "Polyconic",
                    "poly"
                ]
            };
            var de = {
                init: function() {
                    this.A = [], this.A[1] = .6399175073, this.A[2] = -0.1358797613, this.A[3] = .063294409, this.A[4] = -0.02526853, this.A[5] = .0117879, this.A[6] = -0.0055161, this.A[7] = .0026906, this.A[8] = -0.001333, this.A[9] = 67e-5, this.A[10] = -0.00034, this.B_re = [], this.B_im = [], this.B_re[1] = .7557853228, this.B_im[1] = 0, this.B_re[2] = .249204646, this.B_im[2] = .003371507, this.B_re[3] = -0.001541739, this.B_im[3] = .04105856, this.B_re[4] = -0.10162907, this.B_im[4] = .01727609, this.B_re[5] = -0.26623489, this.B_im[5] = -0.36249218, this.B_re[6] = -0.6870983, this.B_im[6] = -1.1651967, this.C_re = [], this.C_im = [], this.C_re[1] = 1.3231270439, this.C_im[1] = 0, this.C_re[2] = -0.577245789, this.C_im[2] = -0.007809598, this.C_re[3] = .508307513, this.C_im[3] = -0.112208952, this.C_re[4] = -0.15094762, this.C_im[4] = .18200602, this.C_re[5] = 1.01418179, this.C_im[5] = 1.64497696, this.C_re[6] = 1.9660549, this.C_im[6] = 2.5127645, this.D = [], this.D[1] = 1.5627014243, this.D[2] = .5185406398, this.D[3] = -0.03333098, this.D[4] = -0.1052906, this.D[5] = -0.0368594, this.D[6] = .007317, this.D[7] = .0122, this.D[8] = .00394, this.D[9] = -0.0013;
                },
                forward: function(t) {
                    var e, r = t.x, i = t.y - this.lat0, o = r - this.long0, a = i / n * 1e-5, s = o, u = 1, l = 0;
                    for(e = 1; e <= 10; e++)u *= a, l += this.A[e] * u;
                    var c, f = l, h = s, p = 1, d = 0, m = 0, y = 0;
                    for(e = 1; e <= 6; e++)c = d * f + p * h, p = p * f - d * h, d = c, m = m + this.B_re[e] * p - this.B_im[e] * d, y = y + this.B_im[e] * p + this.B_re[e] * d;
                    return t.x = y * this.a + this.x0, t.y = m * this.a + this.y0, t;
                },
                inverse: function(t) {
                    var e, r, i = t.x, o = t.y, a = i - this.x0, s = (o - this.y0) / this.a, u = a / this.a, l = 1, c = 0, f = 0, h = 0;
                    for(e = 1; e <= 6; e++)r = c * s + l * u, l = l * s - c * u, c = r, f = f + this.C_re[e] * l - this.C_im[e] * c, h = h + this.C_im[e] * l + this.C_re[e] * c;
                    for(var p = 0; p < this.iterations; p++){
                        var d, m = f, y = h, g = s, v = u;
                        for(e = 2; e <= 6; e++)d = y * f + m * h, m = m * f - y * h, y = d, g += (e - 1) * (this.B_re[e] * m - this.B_im[e] * y), v += (e - 1) * (this.B_im[e] * m + this.B_re[e] * y);
                        m = 1, y = 0;
                        var b = this.B_re[1], x = this.B_im[1];
                        for(e = 2; e <= 6; e++)d = y * f + m * h, m = m * f - y * h, y = d, b += e * (this.B_re[e] * m - this.B_im[e] * y), x += e * (this.B_im[e] * m + this.B_re[e] * y);
                        var w = b * b + x * x;
                        f = (g * b + v * x) / w, h = (v * b - g * x) / w;
                    }
                    var _ = f, A = h, E = 1, S = 0;
                    for(e = 1; e <= 9; e++)E *= _, S += this.D[e] * E;
                    var M = this.lat0 + S * n * 1e5, k = this.long0 + A;
                    return t.x = k, t.y = M, t;
                },
                names: [
                    "New_Zealand_Map_Grid",
                    "nzmg"
                ]
            };
            var me = {
                init: function() {},
                forward: function(t) {
                    var e = t.x, r = t.y, n = P(e - this.long0), i = this.x0 + this.a * n, o = this.y0 + this.a * Math.log(Math.tan(Math.PI / 4 + r / 2.5)) * 1.25;
                    return t.x = i, t.y = o, t;
                },
                inverse: function(t) {
                    t.x -= this.x0, t.y -= this.y0;
                    var e = P(this.long0 + t.x / this.a), r = 2.5 * (Math.atan(Math.exp(.8 * t.y / this.a)) - Math.PI / 4);
                    return t.x = e, t.y = r, t;
                },
                names: [
                    "Miller_Cylindrical",
                    "mill"
                ]
            };
            var ye = {
                init: function() {
                    this.sphere ? (this.n = 1, this.m = 0, this.es = 0, this.C_y = Math.sqrt((this.m + 1) / this.n), this.C_x = this.C_y / (this.m + 1)) : this.en = Tt(this.es);
                },
                forward: function(t) {
                    var e, r, n = t.x, i = t.y;
                    if (n = P(n - this.long0), this.sphere) {
                        if (this.m) for(var o = this.n * Math.sin(i), a = 20; a; --a){
                            var s = (this.m * i + Math.sin(i) - o) / (this.m + Math.cos(i));
                            if (i -= s, Math.abs(s) < 1e-10) break;
                        }
                        else i = 1 !== this.n ? Math.asin(this.n * Math.sin(i)) : i;
                        e = this.a * this.C_x * n * (this.m + Math.cos(i)), r = this.a * this.C_y * i;
                    } else {
                        var u = Math.sin(i), l = Math.cos(i);
                        r = this.a * Ft(i, u, l, this.en), e = this.a * n * l / Math.sqrt(1 - this.es * u * u);
                    }
                    return t.x = e, t.y = r, t;
                },
                inverse: function(t) {
                    var e, r, n, o;
                    return t.x -= this.x0, n = t.x / this.a, t.y -= this.y0, e = t.y / this.a, this.sphere ? (e /= this.C_y, n /= this.C_x * (this.m + Math.cos(e)), this.m ? e = ue((this.m * e + Math.sin(e)) / this.n) : 1 !== this.n && (e = ue(Math.sin(e) / this.n)), n = P(n + this.long0), e = ne(e)) : (e = Pt(t.y / this.a, this.es, this.en), (o = Math.abs(e)) < i ? (o = Math.sin(e), r = this.long0 + t.x * Math.sqrt(1 - this.es * o * o) / (this.a * Math.cos(e)), n = P(r)) : o - 1e-10 < i && (n = this.long0)), t.x = n, t.y = e, t;
                },
                names: [
                    "Sinusoidal",
                    "sinu"
                ]
            };
            var ge = {
                init: function() {},
                forward: function(t) {
                    for(var e = t.x, r = t.y, n = P(e - this.long0), i = r, o = Math.PI * Math.sin(r);;){
                        var a = -(i + Math.sin(i) - o) / (1 + Math.cos(i));
                        if (i += a, Math.abs(a) < 1e-10) break;
                    }
                    i /= 2, Math.PI / 2 - Math.abs(r) < 1e-10 && (n = 0);
                    var s = .900316316158 * this.a * n * Math.cos(i) + this.x0, u = 1.4142135623731 * this.a * Math.sin(i) + this.y0;
                    return t.x = s, t.y = u, t;
                },
                inverse: function(t) {
                    var e, r;
                    t.x -= this.x0, t.y -= this.y0, r = t.y / (1.4142135623731 * this.a), Math.abs(r) > .999999999999 && (r = .999999999999), e = Math.asin(r);
                    var n = P(this.long0 + t.x / (.900316316158 * this.a * Math.cos(e)));
                    n < -Math.PI && (n = -Math.PI), n > Math.PI && (n = Math.PI), r = (2 * e + Math.sin(2 * e)) / Math.PI, Math.abs(r) > 1 && (r = 1);
                    var i = Math.asin(r);
                    return t.x = n, t.y = i, t;
                },
                names: [
                    "Mollweide",
                    "moll"
                ]
            };
            var ve = {
                init: function() {
                    Math.abs(this.lat1 + this.lat2) < 1e-10 || (this.lat2 = this.lat2 || this.lat1, this.temp = this.b / this.a, this.es = 1 - Math.pow(this.temp, 2), this.e = Math.sqrt(this.es), this.e0 = Jt(this.es), this.e1 = Qt(this.es), this.e2 = te(this.es), this.e3 = ee(this.es), this.sinphi = Math.sin(this.lat1), this.cosphi = Math.cos(this.lat1), this.ms1 = T(this.e, this.sinphi, this.cosphi), this.ml1 = Xt(this.e0, this.e1, this.e2, this.e3, this.lat1), Math.abs(this.lat1 - this.lat2) < 1e-10 ? this.ns = this.sinphi : (this.sinphi = Math.sin(this.lat2), this.cosphi = Math.cos(this.lat2), this.ms2 = T(this.e, this.sinphi, this.cosphi), this.ml2 = Xt(this.e0, this.e1, this.e2, this.e3, this.lat2), this.ns = (this.ms1 - this.ms2) / (this.ml2 - this.ml1)), this.g = this.ml1 + this.ms1 / this.ns, this.ml0 = Xt(this.e0, this.e1, this.e2, this.e3, this.lat0), this.rh = this.a * (this.g - this.ml0));
                },
                forward: function(t) {
                    var e, r = t.x, n = t.y;
                    if (this.sphere) e = this.a * (this.g - n);
                    else {
                        var i = Xt(this.e0, this.e1, this.e2, this.e3, n);
                        e = this.a * (this.g - i);
                    }
                    var o = this.ns * P(r - this.long0), a = this.x0 + e * Math.sin(o), s = this.y0 + this.rh - e * Math.cos(o);
                    return t.x = a, t.y = s, t;
                },
                inverse: function(t) {
                    var e, r, n, i;
                    t.x -= this.x0, t.y = this.rh - t.y + this.y0, this.ns >= 0 ? (r = Math.sqrt(t.x * t.x + t.y * t.y), e = 1) : (r = -Math.sqrt(t.x * t.x + t.y * t.y), e = -1);
                    var o = 0;
                    if (0 !== r && (o = Math.atan2(e * t.x, e * t.y)), this.sphere) return i = P(this.long0 + o / this.ns), n = ne(this.g - r / this.a), t.x = i, t.y = n, t;
                    var a = this.g - r / this.a;
                    return n = ie(a, this.e0, this.e1, this.e2, this.e3), i = P(this.long0 + o / this.ns), t.x = i, t.y = n, t;
                },
                names: [
                    "Equidistant_Conic",
                    "eqdc"
                ]
            };
            var be = {
                init: function() {
                    this.R = this.a;
                },
                forward: function(t) {
                    var e, r, n = t.x, o = t.y, a = P(n - this.long0);
                    Math.abs(o) <= 1e-10 && (e = this.x0 + this.R * a, r = this.y0);
                    var s = ue(2 * Math.abs(o / Math.PI));
                    (Math.abs(a) <= 1e-10 || Math.abs(Math.abs(o) - i) <= 1e-10) && (e = this.x0, r = o >= 0 ? this.y0 + Math.PI * this.R * Math.tan(.5 * s) : this.y0 + Math.PI * this.R * -Math.tan(.5 * s));
                    var u = .5 * Math.abs(Math.PI / a - a / Math.PI), l = u * u, c = Math.sin(s), f = Math.cos(s), h = f / (c + f - 1), p = h * h, d = h * (2 / c - 1), m = d * d, y = Math.PI * this.R * (u * (h - m) + Math.sqrt(l * (h - m) * (h - m) - (m + l) * (p - m))) / (m + l);
                    a < 0 && (y = -y), e = this.x0 + y;
                    var g = l + h;
                    return y = Math.PI * this.R * (d * g - u * Math.sqrt((m + l) * (l + 1) - g * g)) / (m + l), r = o >= 0 ? this.y0 + y : this.y0 - y, t.x = e, t.y = r, t;
                },
                inverse: function(t) {
                    var e, r, n, i, o, a, s, u, l, c, f, h;
                    return t.x -= this.x0, t.y -= this.y0, f = Math.PI * this.R, o = (n = t.x / f) * n + (i = t.y / f) * i, f = 3 * (i * i / (u = -2 * (a = -Math.abs(i) * (1 + o)) + 1 + 2 * i * i + o * o) + (2 * (s = a - 2 * i * i + n * n) * s * s / u / u / u - 9 * a * s / u / u) / 27) / (l = (a - s * s / 3 / u) / u) / (c = 2 * Math.sqrt(-l / 3)), Math.abs(f) > 1 && (f = f >= 0 ? 1 : -1), h = Math.acos(f) / 3, r = t.y >= 0 ? (-c * Math.cos(h + Math.PI / 3) - s / 3 / u) * Math.PI : -(-c * Math.cos(h + Math.PI / 3) - s / 3 / u) * Math.PI, e = Math.abs(n) < 1e-10 ? this.long0 : P(this.long0 + Math.PI * (o - 1 + Math.sqrt(1 + 2 * (n * n - i * i) + o * o)) / 2 / n), t.x = e, t.y = r, t;
                },
                names: [
                    "Van_der_Grinten_I",
                    "VanDerGrinten",
                    "vandg"
                ]
            };
            var xe = {
                init: function() {
                    this.sin_p12 = Math.sin(this.lat0), this.cos_p12 = Math.cos(this.lat0);
                },
                forward: function(t) {
                    var e, r, n, o, a, s, u, l, c, f, h, p, d, m, y, g, v, b, x, w, _, A, E = t.x, S = t.y, M = Math.sin(t.y), k = Math.cos(t.y), N = P(E - this.long0);
                    return this.sphere ? Math.abs(this.sin_p12 - 1) <= 1e-10 ? (t.x = this.x0 + this.a * (i - S) * Math.sin(N), t.y = this.y0 - this.a * (i - S) * Math.cos(N), t) : Math.abs(this.sin_p12 + 1) <= 1e-10 ? (t.x = this.x0 + this.a * (i + S) * Math.sin(N), t.y = this.y0 + this.a * (i + S) * Math.cos(N), t) : (b = this.sin_p12 * M + this.cos_p12 * k * Math.cos(N), v = (g = Math.acos(b)) ? g / Math.sin(g) : 1, t.x = this.x0 + this.a * v * k * Math.sin(N), t.y = this.y0 + this.a * v * (this.cos_p12 * M - this.sin_p12 * k * Math.cos(N)), t) : (e = Jt(this.es), r = Qt(this.es), n = te(this.es), o = ee(this.es), Math.abs(this.sin_p12 - 1) <= 1e-10 ? (a = this.a * Xt(e, r, n, o, i), s = this.a * Xt(e, r, n, o, S), t.x = this.x0 + (a - s) * Math.sin(N), t.y = this.y0 - (a - s) * Math.cos(N), t) : Math.abs(this.sin_p12 + 1) <= 1e-10 ? (a = this.a * Xt(e, r, n, o, i), s = this.a * Xt(e, r, n, o, S), t.x = this.x0 + (a + s) * Math.sin(N), t.y = this.y0 + (a + s) * Math.cos(N), t) : (u = M / k, l = re(this.a, this.e, this.sin_p12), c = re(this.a, this.e, M), f = Math.atan((1 - this.es) * u + this.es * l * this.sin_p12 / (c * k)), x = 0 === (h = Math.atan2(Math.sin(N), this.cos_p12 * Math.tan(f) - this.sin_p12 * Math.cos(N))) ? Math.asin(this.cos_p12 * Math.sin(f) - this.sin_p12 * Math.cos(f)) : Math.abs(Math.abs(h) - Math.PI) <= 1e-10 ? -Math.asin(this.cos_p12 * Math.sin(f) - this.sin_p12 * Math.cos(f)) : Math.asin(Math.sin(N) * Math.cos(f) / Math.sin(h)), p = this.e * this.sin_p12 / Math.sqrt(1 - this.es), g = l * x * (1 - (w = x * x) * (y = (d = this.e * this.cos_p12 * Math.cos(h) / Math.sqrt(1 - this.es)) * d) * (1 - y) / 6 + (_ = w * x) / 8 * (m = p * d) * (1 - 2 * y) + (A = _ * x) / 120 * (y * (4 - 7 * y) - 3 * p * p * (1 - 7 * y)) - A * x / 48 * m), t.x = this.x0 + g * Math.sin(h), t.y = this.y0 + g * Math.cos(h), t));
                },
                inverse: function(t) {
                    var e, r, n, o, a, s, u, l, c, f, h, p, d, m, y, g, v, b, x, w, _, A, E;
                    if (t.x -= this.x0, t.y -= this.y0, this.sphere) {
                        if ((e = Math.sqrt(t.x * t.x + t.y * t.y)) > 2 * i * this.a) return;
                        return r = e / this.a, n = Math.sin(r), o = Math.cos(r), a = this.long0, Math.abs(e) <= 1e-10 ? s = this.lat0 : (s = ue(o * this.sin_p12 + t.y * n * this.cos_p12 / e), u = Math.abs(this.lat0) - i, a = Math.abs(u) <= 1e-10 ? this.lat0 >= 0 ? P(this.long0 + Math.atan2(t.x, -t.y)) : P(this.long0 - Math.atan2(-t.x, t.y)) : P(this.long0 + Math.atan2(t.x * n, e * this.cos_p12 * o - t.y * this.sin_p12 * n))), t.x = a, t.y = s, t;
                    }
                    return l = Jt(this.es), c = Qt(this.es), f = te(this.es), h = ee(this.es), Math.abs(this.sin_p12 - 1) <= 1e-10 ? (p = this.a * Xt(l, c, f, h, i), e = Math.sqrt(t.x * t.x + t.y * t.y), s = ie((p - e) / this.a, l, c, f, h), a = P(this.long0 + Math.atan2(t.x, -1 * t.y)), t.x = a, t.y = s, t) : Math.abs(this.sin_p12 + 1) <= 1e-10 ? (p = this.a * Xt(l, c, f, h, i), e = Math.sqrt(t.x * t.x + t.y * t.y), s = ie((e - p) / this.a, l, c, f, h), a = P(this.long0 + Math.atan2(t.x, t.y)), t.x = a, t.y = s, t) : (e = Math.sqrt(t.x * t.x + t.y * t.y), y = Math.atan2(t.x, t.y), d = re(this.a, this.e, this.sin_p12), g = Math.cos(y), b = -(v = this.e * this.cos_p12 * g) * v / (1 - this.es), x = 3 * this.es * (1 - b) * this.sin_p12 * this.cos_p12 * g / (1 - this.es), A = 1 - b * (_ = (w = e / d) - b * (1 + b) * Math.pow(w, 3) / 6 - x * (1 + 3 * b) * Math.pow(w, 4) / 24) * _ / 2 - w * _ * _ * _ / 6, m = Math.asin(this.sin_p12 * Math.cos(_) + this.cos_p12 * Math.sin(_) * g), a = P(this.long0 + Math.asin(Math.sin(y) * Math.sin(_) / Math.cos(m))), E = Math.sin(m), s = Math.atan2((E - this.es * A * this.sin_p12) * Math.tan(m), E * (1 - this.es)), t.x = a, t.y = s, t);
                },
                names: [
                    "Azimuthal_Equidistant",
                    "aeqd"
                ]
            };
            var we = {
                init: function() {
                    this.sin_p14 = Math.sin(this.lat0), this.cos_p14 = Math.cos(this.lat0);
                },
                forward: function(t) {
                    var e, r, n, i, o, a, s, u = t.x, l = t.y;
                    return n = P(u - this.long0), e = Math.sin(l), r = Math.cos(l), i = Math.cos(n), ((o = this.sin_p14 * e + this.cos_p14 * r * i) > 0 || Math.abs(o) <= 1e-10) && (a = 1 * this.a * r * Math.sin(n), s = this.y0 + 1 * this.a * (this.cos_p14 * e - this.sin_p14 * r * i)), t.x = a, t.y = s, t;
                },
                inverse: function(t) {
                    var e, r, n, o, a, s, u;
                    return t.x -= this.x0, t.y -= this.y0, e = Math.sqrt(t.x * t.x + t.y * t.y), r = ue(e / this.a), n = Math.sin(r), o = Math.cos(r), s = this.long0, Math.abs(e) <= 1e-10 ? (u = this.lat0, t.x = s, t.y = u, t) : (u = ue(o * this.sin_p14 + t.y * n * this.cos_p14 / e), a = Math.abs(this.lat0) - i, Math.abs(a) <= 1e-10 ? (s = this.lat0 >= 0 ? P(this.long0 + Math.atan2(t.x, -t.y)) : P(this.long0 - Math.atan2(-t.x, t.y)), t.x = s, t.y = u, t) : (s = P(this.long0 + Math.atan2(t.x * n, e * this.cos_p14 * o - t.y * this.sin_p14 * n)), t.x = s, t.y = u, t));
                },
                names: [
                    "ortho"
                ]
            }, _e = 1, Ae = 2, Ee = 3, Se = 4, Me = 5, ke = 6, Ne = 1, Ce = 2, De = 3, Oe = 4;
            function Te(t, e, r, n) {
                var o;
                return t < 1e-10 ? (n.value = Ne, o = 0) : (o = Math.atan2(e, r), Math.abs(o) <= s ? n.value = Ne : o > s && o <= i + s ? (n.value = Ce, o -= i) : o > i + s || o <= -(i + s) ? (n.value = De, o = o >= 0 ? o - l : o + l) : (n.value = Oe, o += i)), o;
            }
            function Fe(t, e) {
                var r = t + e;
                return r < -l ? r += u : r > +l && (r -= u), r;
            }
            var Pe = {
                init: function() {
                    this.x0 = this.x0 || 0, this.y0 = this.y0 || 0, this.lat0 = this.lat0 || 0, this.long0 = this.long0 || 0, this.lat_ts = this.lat_ts || 0, this.title = this.title || "Quadrilateralized Spherical Cube", this.lat0 >= i - s / 2 ? this.face = Me : this.lat0 <= -(i - s / 2) ? this.face = ke : Math.abs(this.long0) <= s ? this.face = _e : Math.abs(this.long0) <= i + s ? this.face = this.long0 > 0 ? Ae : Se : this.face = Ee, 0 !== this.es && (this.one_minus_f = 1 - (this.a - this.b) / this.a, this.one_minus_f_squared = this.one_minus_f * this.one_minus_f);
                },
                forward: function(t) {
                    var e, r, n, o, a, u, c = {
                        x: 0,
                        y: 0
                    }, f = {
                        value: 0
                    };
                    if (t.x -= this.long0, e = 0 !== this.es ? Math.atan(this.one_minus_f_squared * Math.tan(t.y)) : t.y, r = t.x, this.face === Me) o = i - e, r >= s && r <= i + s ? (f.value = Ne, n = r - i) : r > i + s || r <= -(i + s) ? (f.value = Ce, n = r > 0 ? r - l : r + l) : r > -(i + s) && r <= -s ? (f.value = De, n = r + i) : (f.value = Oe, n = r);
                    else if (this.face === ke) o = i + e, r >= s && r <= i + s ? (f.value = Ne, n = -r + i) : r < s && r >= -s ? (f.value = Ce, n = -r) : r < -s && r >= -(i + s) ? (f.value = De, n = -r - i) : (f.value = Oe, n = r > 0 ? -r + l : -r - l);
                    else {
                        var h, p, d, m, y, g;
                        this.face === Ae ? r = Fe(r, +i) : this.face === Ee ? r = Fe(r, +l) : this.face === Se && (r = Fe(r, -i)), m = Math.sin(e), y = Math.cos(e), g = Math.sin(r), h = y * Math.cos(r), p = y * g, d = m, this.face === _e ? n = Te(o = Math.acos(h), d, p, f) : this.face === Ae ? n = Te(o = Math.acos(p), d, -h, f) : this.face === Ee ? n = Te(o = Math.acos(-h), d, -p, f) : this.face === Se ? n = Te(o = Math.acos(-p), d, h, f) : (o = n = 0, f.value = Ne);
                    }
                    return u = Math.atan(12 / l * (n + Math.acos(Math.sin(n) * Math.cos(s)) - i)), a = Math.sqrt((1 - Math.cos(o)) / (Math.cos(u) * Math.cos(u)) / (1 - Math.cos(Math.atan(1 / Math.cos(n))))), f.value === Ce ? u += i : f.value === De ? u += l : f.value === Oe && (u += 1.5 * l), c.x = a * Math.cos(u), c.y = a * Math.sin(u), c.x = c.x * this.a + this.x0, c.y = c.y * this.a + this.y0, t.x = c.x, t.y = c.y, t;
                },
                inverse: function(t) {
                    var e, r, n, o, a, s, u, c, f, h, p, d, m = {
                        lam: 0,
                        phi: 0
                    }, y = {
                        value: 0
                    };
                    if (t.x = (t.x - this.x0) / this.a, t.y = (t.y - this.y0) / this.a, r = Math.atan(Math.sqrt(t.x * t.x + t.y * t.y)), e = Math.atan2(t.y, t.x), t.x >= 0 && t.x >= Math.abs(t.y) ? y.value = Ne : t.y >= 0 && t.y >= Math.abs(t.x) ? (y.value = Ce, e -= i) : t.x < 0 && -t.x >= Math.abs(t.y) ? (y.value = De, e = e < 0 ? e + l : e - l) : (y.value = Oe, e += i), f = l / 12 * Math.tan(e), a = Math.sin(f) / (Math.cos(f) - 1 / Math.sqrt(2)), s = Math.atan(a), (u = 1 - (n = Math.cos(e)) * n * (o = Math.tan(r)) * o * (1 - Math.cos(Math.atan(1 / Math.cos(s))))) < -1 ? u = -1 : u > 1 && (u = 1), this.face === Me) c = Math.acos(u), m.phi = i - c, y.value === Ne ? m.lam = s + i : y.value === Ce ? m.lam = s < 0 ? s + l : s - l : y.value === De ? m.lam = s - i : m.lam = s;
                    else if (this.face === ke) c = Math.acos(u), m.phi = c - i, y.value === Ne ? m.lam = -s + i : y.value === Ce ? m.lam = -s : y.value === De ? m.lam = -s - i : m.lam = s < 0 ? -s - l : -s + l;
                    else {
                        var g, v, b;
                        f = (g = u) * g, v = (f += (b = f >= 1 ? 0 : Math.sqrt(1 - f) * Math.sin(s)) * b) >= 1 ? 0 : Math.sqrt(1 - f), y.value === Ce ? (f = v, v = -b, b = f) : y.value === De ? (v = -v, b = -b) : y.value === Oe && (f = v, v = b, b = -f), this.face === Ae ? (f = g, g = -v, v = f) : this.face === Ee ? (g = -g, v = -v) : this.face === Se && (f = g, g = v, v = -f), m.phi = Math.acos(-b) - i, m.lam = Math.atan2(v, g), this.face === Ae ? m.lam = Fe(m.lam, -i) : this.face === Ee ? m.lam = Fe(m.lam, -l) : this.face === Se && (m.lam = Fe(m.lam, +i));
                    }
                    return 0 !== this.es && (h = m.phi < 0 ? 1 : 0, p = Math.tan(m.phi), d = this.b / Math.sqrt(p * p + this.one_minus_f_squared), m.phi = Math.atan(Math.sqrt(this.a * this.a - d * d) / (this.one_minus_f * d)), h && (m.phi = -m.phi)), m.lam += this.long0, t.x = m.lam, t.y = m.phi, t;
                },
                names: [
                    "Quadrilateralized Spherical Cube",
                    "Quadrilateralized_Spherical_Cube",
                    "qsc"
                ]
            }, Ie = [
                [
                    1,
                    22199e-21,
                    -0.0000715515,
                    31103e-10
                ],
                [
                    .9986,
                    -0.000482243,
                    -0.000024897,
                    -0.0000013309
                ],
                [
                    .9954,
                    -0.00083103,
                    -0.0000448605,
                    -0.000000986701
                ],
                [
                    .99,
                    -0.00135364,
                    -0.000059661,
                    36777e-10
                ],
                [
                    .9822,
                    -0.00167442,
                    -0.00000449547,
                    -0.00000572411
                ],
                [
                    .973,
                    -0.00214868,
                    -0.0000903571,
                    1.8736e-8
                ],
                [
                    .96,
                    -0.00305085,
                    -0.0000900761,
                    164917e-11
                ],
                [
                    .9427,
                    -0.00382792,
                    -0.0000653386,
                    -0.0000026154
                ],
                [
                    .9216,
                    -0.00467746,
                    -0.00010457,
                    481243e-11
                ],
                [
                    .8962,
                    -0.00536223,
                    -0.0000323831,
                    -0.00000543432
                ],
                [
                    .8679,
                    -0.00609363,
                    -0.000113898,
                    332484e-11
                ],
                [
                    .835,
                    -0.00698325,
                    -0.0000640253,
                    9.34959e-7
                ],
                [
                    .7986,
                    -0.00755338,
                    -0.0000500009,
                    9.35324e-7
                ],
                [
                    .7597,
                    -0.00798324,
                    -0.000035971,
                    -0.00000227626
                ],
                [
                    .7186,
                    -0.00851367,
                    -0.0000701149,
                    -0.0000086303
                ],
                [
                    .6732,
                    -0.00986209,
                    -0.000199569,
                    191974e-10
                ],
                [
                    .6213,
                    -0.010418,
                    883923e-10,
                    624051e-11
                ],
                [
                    .5722,
                    -0.00906601,
                    182e-6,
                    624051e-11
                ],
                [
                    .5322,
                    -0.00677797,
                    275608e-9,
                    624051e-11
                ]
            ], Be = [
                [
                    -0.00000000000000000520417,
                    .0124,
                    121431e-23,
                    -0.0000000000845284
                ],
                [
                    .062,
                    .0124,
                    -0.00000000126793,
                    4.22642e-10
                ],
                [
                    .124,
                    .0124,
                    5.07171e-9,
                    -0.00000000160604
                ],
                [
                    .186,
                    .0123999,
                    -0.0000000190189,
                    6.00152e-9
                ],
                [
                    .248,
                    .0124002,
                    7.10039e-8,
                    -0.0000000224
                ],
                [
                    .31,
                    .0123992,
                    -0.000000264997,
                    8.35986e-8
                ],
                [
                    .372,
                    .0124029,
                    9.88983e-7,
                    -0.000000311994
                ],
                [
                    .434,
                    .0123893,
                    -0.00000369093,
                    -0.000000435621
                ],
                [
                    .4958,
                    .0123198,
                    -0.0000102252,
                    -0.000000345523
                ],
                [
                    .5571,
                    .0121916,
                    -0.0000154081,
                    -0.000000582288
                ],
                [
                    .6176,
                    .0119938,
                    -0.0000241424,
                    -0.000000525327
                ],
                [
                    .6769,
                    .011713,
                    -0.0000320223,
                    -0.000000516405
                ],
                [
                    .7346,
                    .0113541,
                    -0.0000397684,
                    -0.000000609052
                ],
                [
                    .7903,
                    .0109107,
                    -0.0000489042,
                    -0.00000104739
                ],
                [
                    .8435,
                    .0103431,
                    -0.000064615,
                    -0.00000000140374
                ],
                [
                    .8936,
                    .00969686,
                    -0.000064636,
                    -0.000008547
                ],
                [
                    .9394,
                    .00840947,
                    -0.000192841,
                    -0.0000042106
                ],
                [
                    .9761,
                    .00616527,
                    -0.000256,
                    -0.0000042106
                ],
                [
                    1,
                    .00328947,
                    -0.000319159,
                    -0.0000042106
                ]
            ], je = a / 5, Re = function(t, e) {
                return t[0] + e * (t[1] + e * (t[2] + e * t[3]));
            };
            var Le = {
                init: function() {
                    this.x0 = this.x0 || 0, this.y0 = this.y0 || 0, this.long0 = this.long0 || 0, this.es = 0, this.title = this.title || "Robinson";
                },
                forward: function(t) {
                    var e = P(t.x - this.long0), r = Math.abs(t.y), n = Math.floor(r * je);
                    n < 0 ? n = 0 : n >= 18 && (n = 17);
                    var i = {
                        x: Re(Ie[n], r = a * (r - .08726646259971647 * n)) * e,
                        y: Re(Be[n], r)
                    };
                    return t.y < 0 && (i.y = -i.y), i.x = i.x * this.a * .8487 + this.x0, i.y = i.y * this.a * 1.3523 + this.y0, i;
                },
                inverse: function(t) {
                    var e = {
                        x: (t.x - this.x0) / (.8487 * this.a),
                        y: Math.abs(t.y - this.y0) / (1.3523 * this.a)
                    };
                    if (e.y >= 1) e.x /= Ie[18][0], e.y = t.y < 0 ? -i : i;
                    else {
                        var r = Math.floor(18 * e.y);
                        for(r < 0 ? r = 0 : r >= 18 && (r = 17);;)if (Be[r][0] > e.y) --r;
                        else {
                            if (!(Be[r + 1][0] <= e.y)) break;
                            ++r;
                        }
                        var n = Be[r], a = 5 * (e.y - n[0]) / (Be[r + 1][0] - n[0]);
                        a = function(t, e, r, n) {
                            for(var i = e; n; --n){
                                var o = t(i);
                                if (i -= o, Math.abs(o) < r) break;
                            }
                            return i;
                        }(function(t) {
                            return (Re(n, t) - e.y) / function(t, e) {
                                return t[1] + e * (2 * t[2] + 3 * e * t[3]);
                            }(n, t);
                        }, a, 1e-10, 100), e.x /= Re(Ie[r], a), e.y = (5 * r + a) * o, t.y < 0 && (e.y = -e.y);
                    }
                    return e.x = P(e.x + this.long0), e;
                },
                names: [
                    "Robinson",
                    "robin"
                ]
            };
            var qe = {
                init: function() {
                    this.name = "geocent";
                },
                forward: function(t) {
                    return rt(t, this.es, this.a);
                },
                inverse: function(t) {
                    return nt(t, this.es, this.a, this.b);
                },
                names: [
                    "Geocentric",
                    "geocentric",
                    "geocent",
                    "Geocent"
                ]
            }, Ue = 0, ze = 1, Ge = 2, He = 3, We = {
                h: {
                    def: 1e5,
                    num: !0
                },
                azi: {
                    def: 0,
                    num: !0,
                    degrees: !0
                },
                tilt: {
                    def: 0,
                    num: !0,
                    degrees: !0
                },
                long0: {
                    def: 0,
                    num: !0
                },
                lat0: {
                    def: 0,
                    num: !0
                }
            };
            var $e = {
                init: function() {
                    if (Object.keys(We).forEach((function(t) {
                        if (void 0 === this[t]) this[t] = We[t].def;
                        else {
                            if (We[t].num && isNaN(this[t])) throw new Error("Invalid parameter value, must be numeric " + t + " = " + this[t]);
                            We[t].num && (this[t] = parseFloat(this[t]));
                        }
                        We[t].degrees && (this[t] = this[t] * o);
                    }).bind(this)), Math.abs(Math.abs(this.lat0) - i) < 1e-10 ? this.mode = this.lat0 < 0 ? ze : Ue : Math.abs(this.lat0) < 1e-10 ? this.mode = Ge : (this.mode = He, this.sinph0 = Math.sin(this.lat0), this.cosph0 = Math.cos(this.lat0)), this.pn1 = this.h / this.a, this.pn1 <= 0 || this.pn1 > 1e10) throw new Error("Invalid height");
                    this.p = 1 + this.pn1, this.rp = 1 / this.p, this.h1 = 1 / this.pn1, this.pfact = (this.p + 1) * this.h1, this.es = 0;
                    var t = this.tilt, e = this.azi;
                    this.cg = Math.cos(e), this.sg = Math.sin(e), this.cw = Math.cos(t), this.sw = Math.sin(t);
                },
                forward: function(t) {
                    t.x -= this.long0;
                    var e, r, n, i, o = Math.sin(t.y), a = Math.cos(t.y), s = Math.cos(t.x);
                    switch(this.mode){
                        case He:
                            r = this.sinph0 * o + this.cosph0 * a * s;
                            break;
                        case Ge:
                            r = a * s;
                            break;
                        case ze:
                            r = -o;
                            break;
                        case Ue:
                            r = o;
                    }
                    switch(e = (r = this.pn1 / (this.p - r)) * a * Math.sin(t.x), this.mode){
                        case He:
                            r *= this.cosph0 * o - this.sinph0 * a * s;
                            break;
                        case Ge:
                            r *= o;
                            break;
                        case Ue:
                            r *= -a * s;
                            break;
                        case ze:
                            r *= a * s;
                    }
                    return i = 1 / ((n = r * this.cg + e * this.sg) * this.sw * this.h1 + this.cw), e = (e * this.cg - r * this.sg) * this.cw * i, r = n * i, t.x = e * this.a, t.y = r * this.a, t;
                },
                inverse: function(t) {
                    t.x /= this.a, t.y /= this.a;
                    var e, r, n, i = {
                        x: t.x,
                        y: t.y
                    };
                    n = 1 / (this.pn1 - t.y * this.sw), e = this.pn1 * t.x * n, r = this.pn1 * t.y * this.cw * n, t.x = e * this.cg + r * this.sg, t.y = r * this.cg - e * this.sg;
                    var o = jt(t.x, t.y);
                    if (Math.abs(o) < 1e-10) i.x = 0, i.y = t.y;
                    else {
                        var a, s;
                        switch(s = 1 - o * o * this.pfact, s = (this.p - Math.sqrt(s)) / (this.pn1 / o + o / this.pn1), a = Math.sqrt(1 - s * s), this.mode){
                            case He:
                                i.y = Math.asin(a * this.sinph0 + t.y * s * this.cosph0 / o), t.y = (a - this.sinph0 * Math.sin(i.y)) * o, t.x *= s * this.cosph0;
                                break;
                            case Ge:
                                i.y = Math.asin(t.y * s / o), t.y = a * o, t.x *= s;
                                break;
                            case Ue:
                                i.y = Math.asin(a), t.y = -t.y;
                                break;
                            case ze:
                                i.y = -Math.asin(a);
                        }
                        i.x = Math.atan2(t.x, t.y);
                    }
                    return t.x = i.x + this.long0, t.y = i.y, t;
                },
                names: [
                    "Tilted_Perspective",
                    "tpers"
                ]
            };
            var Ve = {
                init: function() {
                    if (this.flip_axis = "x" === this.sweep ? 1 : 0, this.h = Number(this.h), this.radius_g_1 = this.h / this.a, this.radius_g_1 <= 0 || this.radius_g_1 > 1e10) throw new Error;
                    if (this.radius_g = 1 + this.radius_g_1, this.C = this.radius_g * this.radius_g - 1, 0 !== this.es) {
                        var t = 1 - this.es, e = 1 / t;
                        this.radius_p = Math.sqrt(t), this.radius_p2 = t, this.radius_p_inv2 = e, this.shape = "ellipse";
                    } else this.radius_p = 1, this.radius_p2 = 1, this.radius_p_inv2 = 1, this.shape = "sphere";
                    this.title || (this.title = "Geostationary Satellite View");
                },
                forward: function(t) {
                    var e, r, n, i, o = t.x, a = t.y;
                    if (o -= this.long0, "ellipse" === this.shape) {
                        a = Math.atan(this.radius_p2 * Math.tan(a));
                        var s = this.radius_p / jt(this.radius_p * Math.cos(a), Math.sin(a));
                        if (r = s * Math.cos(o) * Math.cos(a), n = s * Math.sin(o) * Math.cos(a), i = s * Math.sin(a), (this.radius_g - r) * r - n * n - i * i * this.radius_p_inv2 < 0) return t.x = Number.NaN, t.y = Number.NaN, t;
                        e = this.radius_g - r, this.flip_axis ? (t.x = this.radius_g_1 * Math.atan(n / jt(i, e)), t.y = this.radius_g_1 * Math.atan(i / e)) : (t.x = this.radius_g_1 * Math.atan(n / e), t.y = this.radius_g_1 * Math.atan(i / jt(n, e)));
                    } else "sphere" === this.shape && (e = Math.cos(a), r = Math.cos(o) * e, n = Math.sin(o) * e, i = Math.sin(a), e = this.radius_g - r, this.flip_axis ? (t.x = this.radius_g_1 * Math.atan(n / jt(i, e)), t.y = this.radius_g_1 * Math.atan(i / e)) : (t.x = this.radius_g_1 * Math.atan(n / e), t.y = this.radius_g_1 * Math.atan(i / jt(n, e))));
                    return t.x = t.x * this.a, t.y = t.y * this.a, t;
                },
                inverse: function(t) {
                    var e, r, n, i, o = -1, a = 0, s = 0;
                    if (t.x = t.x / this.a, t.y = t.y / this.a, "ellipse" === this.shape) {
                        this.flip_axis ? (s = Math.tan(t.y / this.radius_g_1), a = Math.tan(t.x / this.radius_g_1) * jt(1, s)) : (a = Math.tan(t.x / this.radius_g_1), s = Math.tan(t.y / this.radius_g_1) * jt(1, a));
                        var u = s / this.radius_p;
                        if (e = a * a + u * u + o * o, (n = (r = 2 * this.radius_g * o) * r - 4 * e * this.C) < 0) return t.x = Number.NaN, t.y = Number.NaN, t;
                        i = (-r - Math.sqrt(n)) / (2 * e), o = this.radius_g + i * o, a *= i, s *= i, t.x = Math.atan2(a, o), t.y = Math.atan(s * Math.cos(t.x) / o), t.y = Math.atan(this.radius_p_inv2 * Math.tan(t.y));
                    } else if ("sphere" === this.shape) {
                        if (this.flip_axis ? (s = Math.tan(t.y / this.radius_g_1), a = Math.tan(t.x / this.radius_g_1) * Math.sqrt(1 + s * s)) : (a = Math.tan(t.x / this.radius_g_1), s = Math.tan(t.y / this.radius_g_1) * Math.sqrt(1 + a * a)), e = a * a + s * s + o * o, (n = (r = 2 * this.radius_g * o) * r - 4 * e * this.C) < 0) return t.x = Number.NaN, t.y = Number.NaN, t;
                        i = (-r - Math.sqrt(n)) / (2 * e), o = this.radius_g + i * o, a *= i, s *= i, t.x = Math.atan2(a, o), t.y = Math.atan(s * Math.cos(t.x) / o);
                    }
                    return t.x = t.x + this.long0, t;
                },
                names: [
                    "Geostationary Satellite View",
                    "Geostationary_Satellite",
                    "geos"
                ]
            }, Ze = 1.340264, Ye = -0.081106, Ke = 893e-6, Xe = .003796, Je = Math.sqrt(3) / 2;
            var Qe, tr = {
                init: function() {
                    this.es = 0, this.long0 = void 0 !== this.long0 ? this.long0 : 0;
                },
                forward: function(t) {
                    var e = P(t.x - this.long0), r = t.y, n = Math.asin(Je * Math.sin(r)), i = n * n, o = i * i * i;
                    return t.x = e * Math.cos(n) / (Je * (Ze + 3 * Ye * i + o * (7 * Ke + 9 * Xe * i))), t.y = n * (Ze + Ye * i + o * (Ke + Xe * i)), t.x = this.a * t.x + this.x0, t.y = this.a * t.y + this.y0, t;
                },
                inverse: function(t) {
                    t.x = (t.x - this.x0) / this.a, t.y = (t.y - this.y0) / this.a;
                    var e, r, n, i, o = t.y;
                    for(i = 0; i < 12 && (o -= n = (o * (Ze + Ye * (e = o * o) + (r = e * e * e) * (Ke + Xe * e)) - t.y) / (Ze + 3 * Ye * e + r * (7 * Ke + 9 * Xe * e)), !(Math.abs(n) < 1e-9)); ++i);
                    return r = (e = o * o) * e * e, t.x = Je * t.x * (Ze + 3 * Ye * e + r * (7 * Ke + 9 * Xe * e)) / Math.cos(o), t.y = Math.asin(Math.sin(o) / Je), t.x = P(t.x + this.long0), t;
                },
                names: [
                    "eqearth",
                    "Equal Earth",
                    "Equal_Earth"
                ]
            };
            yt.defaultDatum = "WGS84", yt.Proj = et, yt.WGS84 = new yt.Proj("WGS84"), yt.Point = Dt, yt.toPoint = ct, yt.defs = k, yt.nadgrid = function(t, e) {
                var r = new DataView(e), n = function(t) {
                    var e = t.getInt32(8, !1);
                    if (11 === e) return !1;
                    11 !== (e = t.getInt32(8, !0)) && console.warn("Failed to detect nadgrid endian-ness, defaulting to little-endian");
                    return !0;
                }(r), i = function(t, e) {
                    return {
                        nFields: t.getInt32(8, e),
                        nSubgridFields: t.getInt32(24, e),
                        nSubgrids: t.getInt32(40, e),
                        shiftType: K(t, 56, 64).trim(),
                        fromSemiMajorAxis: t.getFloat64(120, e),
                        fromSemiMinorAxis: t.getFloat64(136, e),
                        toSemiMajorAxis: t.getFloat64(152, e),
                        toSemiMinorAxis: t.getFloat64(168, e)
                    };
                }(r, n), o = {
                    header: i,
                    subgrids: function(t, e, r) {
                        for(var n = 176, i = [], o = 0; o < e.nSubgrids; o++){
                            var a = J(t, n, r), s = Q(t, n, a, r), u = Math.round(1 + (a.upperLongitude - a.lowerLongitude) / a.longitudeInterval), l = Math.round(1 + (a.upperLatitude - a.lowerLatitude) / a.latitudeInterval);
                            i.push({
                                ll: [
                                    Y(a.lowerLongitude),
                                    Y(a.lowerLatitude)
                                ],
                                del: [
                                    Y(a.longitudeInterval),
                                    Y(a.latitudeInterval)
                                ],
                                lim: [
                                    u,
                                    l
                                ],
                                count: a.gridNodeCount,
                                cvs: X(s)
                            }), n += 176 + 16 * a.gridNodeCount;
                        }
                        return i;
                    }(r, i, n)
                };
                return V[t] = o, o;
            }, yt.transform = ht, yt.mgrs = bt, yt.version = "__VERSION__", (Qe = yt).Proj.projections.add(It), Qe.Proj.projections.add(Ut), Qe.Proj.projections.add(zt), Qe.Proj.projections.add(Wt), Qe.Proj.projections.add($t), Qe.Proj.projections.add(Vt), Qe.Proj.projections.add(Zt), Qe.Proj.projections.add(Yt), Qe.Proj.projections.add(Kt), Qe.Proj.projections.add(oe), Qe.Proj.projections.add(se), Qe.Proj.projections.add(le), Qe.Proj.projections.add(ce), Qe.Proj.projections.add(fe), Qe.Proj.projections.add(he), Qe.Proj.projections.add(pe), Qe.Proj.projections.add(de), Qe.Proj.projections.add(me), Qe.Proj.projections.add(ye), Qe.Proj.projections.add(ge), Qe.Proj.projections.add(ve), Qe.Proj.projections.add(be), Qe.Proj.projections.add(xe), Qe.Proj.projections.add(we), Qe.Proj.projections.add(Pe), Qe.Proj.projections.add(Le), Qe.Proj.projections.add(qe), Qe.Proj.projections.add($e), Qe.Proj.projections.add(Ve), Qe.Proj.projections.add(tr);
            e.default = yt;
        },
        function(t, e, r) {
            "use strict";
            r.r(e), r.d(e, "default", function() {
                return n;
            });
            r(6);
            function n(t) {
                for(var e, r, n = function(t) {
                    if (Array.isArray(t)) return t;
                    if ("Feature" === t.type) {
                        if (null !== t.geometry) return t.geometry.coordinates;
                    } else if (t.coordinates) return t.coordinates;
                    throw new Error("coords must be GeoJSON Feature, Geometry Object or an Array");
                }(t), i = 0, o = 1; o < n.length;)e = r || n[0], i += ((r = n[o])[0] - e[0]) * (r[1] + e[1]), o++;
                return i > 0;
            }
        }
    ]);
});



function $b51085ee695c0fdd$export$f80b4067547ee73(timelineOnly = false) {
    // console.log('refreshWindSensorsData');
    // if (!timeline.timelineActiveStep || timeline.timelineActiveStep === defaultActiveStep()) {
    (0, $5ewvA.getAsync)("https://private2.windmorbihan.com/mesures/getlastalljson.json", function(dt) {
        if ((0, $gYLTL.layers).dataLayers.indexOf("wind") !== -1 && !timelineOnly) $b51085ee695c0fdd$export$e72c2db76561db73(dt);
        if ((0, $gYLTL.timeline).timelineSteps) {
            (0, $fb487846a357c1c2$export$2b262526dbd61afc)(dt);
            (0, $fb487846a357c1c2$export$9fd5139c95413d5f)(true);
        }
    });
// }
}
function $b51085ee695c0fdd$var$loadWindSensorsData(latest = false) {
    if (latest) (0, $5ewvA.getAsync)("https://private2.windmorbihan.com/mesures/getlastalljson.json", function(dt) {
        $b51085ee695c0fdd$export$e72c2db76561db73(dt);
    });
    else {
        const currentTs = parseInt((0, $gYLTL.timeline).timelineActiveStep.getAttribute("data-ts"));
        $b51085ee695c0fdd$export$e72c2db76561db73(Object.values((0, $gYLTL.data).timelineData[currentTs] || {}));
    }
}
function $b51085ee695c0fdd$export$9d5a23401ec8f7d() {
    // if (!timeline.timelineActiveStep || timeline.timelineActiveStep === defaultActiveStep()) {
    (0, $5ewvA.getAsync)("https://private2.windmorbihan.com/mesures/latest-waves.json", function(dt) {
        if ((0, $gYLTL.layers).dataLayers.indexOf("waves") !== -1) $b51085ee695c0fdd$export$7c21e768f6379ae(dt);
    });
// }
}
function $b51085ee695c0fdd$var$loadWaveSensorsData(latest = false) {
    if (latest) (0, $5ewvA.getAsync)("https://private2.windmorbihan.com/mesures/latest-waves.json", function(dt) {
        $b51085ee695c0fdd$export$7c21e768f6379ae(dt);
    });
    else {
        const currentTs = parseInt((0, $gYLTL.timeline).timelineActiveStep.getAttribute("data-ts"));
        if ((0, $gYLTL.layers).dataLayers.indexOf("waves") !== -1) $b51085ee695c0fdd$export$7c21e768f6379ae(Object.values((0, $gYLTL.data).timelineData[currentTs] || {}));
    }
}
function $b51085ee695c0fdd$export$d24539e194e73733() {
    // if (!timeline.timelineActiveStep || timeline.timelineActiveStep === defaultActiveStep()) {
    (0, $5ewvA.getAsync)("https://private2.windmorbihan.com/mesures/latest-temps.json", function(dt) {
        if ((0, $gYLTL.layers).dataLayers.indexOf("temp") !== -1) $b51085ee695c0fdd$export$6cb00ed872355909(dt);
    });
// }
}
function $b51085ee695c0fdd$var$loadTempSensorsData(latest = false) {
    if (latest) (0, $5ewvA.getAsync)("https://private2.windmorbihan.com/mesures/latest-temps.json", function(dt) {
        $b51085ee695c0fdd$export$6cb00ed872355909(dt);
    });
    else {
        const currentTs = parseInt((0, $gYLTL.timeline).timelineActiveStep.getAttribute("data-ts"));
        $b51085ee695c0fdd$export$6cb00ed872355909(Object.values((0, $gYLTL.data).timelineData[currentTs] || {}));
    }
}
function $b51085ee695c0fdd$export$9b75862e7acdcaad(timestamp) {
    let emptyForecastData = false;
    if ((0, $gYLTL.map).activeMap === "wm") (0, $cb3e0081c099494f$export$382d1aca2389ca8b)();
    return fetch((0, $j5Ozl.config).backEndUrl + "/live_forecasts/raster.json?metric=speed" + (timestamp ? "&timestamp=" + timestamp : "")).then(function(resp) {
        return resp.json();
    }).then(function(rasterData) {
        if (rasterData.width) {
            $b51085ee695c0fdd$var$renderForecastInfo(rasterData.source, rasterData.grid, rasterData.run_timestamp);
            if ((0, $gYLTL.map).activeMap === "wm" || (0, $gYLTL.map).activeMap === "elevation") return (0, $cb3e0081c099494f$export$f0c5438bd76c55d8)((0, $gYLTL.layers).dataLayers.indexOf("waves_fc") !== -1).then(function() {
                if ((0, $gYLTL.layers).forecastsLayer && (0, $gYLTL.layers).forecastsLayer.overlay && (0, $gYLTL.layers).dataLayers.indexOf("waves_fc") === -1 && (0, $gYLTL.layers).dataLayers.indexOf("wind_fc") !== -1) (0, $gYLTL.map).instance.removeLayer((0, $gYLTL.layers).forecastsLayer.overlay);
                if ((0, $gYLTL.layers).dataLayers.indexOf("waves_fc") === -1 && (0, $gYLTL.layers).dataLayers.indexOf("wind_fc") !== -1) // Note : bounds adjusted to compensate img distortion
                (0, $gYLTL.layers).forecastsLayer = {
                    forecastId: rasterData.id,
                    forecastTimestamp: timestamp,
                    overlay: new (0, $46bce056a5f1f2c2$export$4e7a29849e6c05f6)(rasterData.raster, (0, $j5Ozl.config).forecastsBounds, {
                        className: "fc_colors",
                        pane: "tilePane"
                    }).addTo((0, $gYLTL.map).instance)
                };
                document.querySelector("#map_container").classList.add("rendered");
            });
            else if ((0, $gYLTL.map).activeMap === "satellite") {
                if ((0, $gYLTL.layers).forecastsLayer && (0, $gYLTL.layers).forecastsLayer.overlay && (0, $gYLTL.layers).dataLayers.indexOf("waves_fc") === -1 && (0, $gYLTL.layers).dataLayers.indexOf("wind_fc") !== -1) (0, $gYLTL.map).instance.removeLayer((0, $gYLTL.layers).forecastsLayer.overlay);
                (0, $gYLTL.layers).forecastsLayer = {
                    forecastId: rasterData.id,
                    forecastTimestamp: timestamp
                };
                document.querySelector("#map_container").classList.add("rendered");
            } else return Promise.resolve();
        } else {
            emptyForecastData = true;
            $b51085ee695c0fdd$var$renderForecastInfo(null);
            if ((0, $gYLTL.layers).forecastsLayer && (0, $gYLTL.layers).forecastsLayer.overlay) (0, $gYLTL.map).instance.removeLayer((0, $gYLTL.layers).forecastsLayer.overlay);
            document.querySelector("#map_container").classList.remove("rendered");
            return (0, $cb3e0081c099494f$export$7936340adedaf8bc)((0, $gYLTL.map).activeMap, emptyForecastData);
        }
    }).then(function() {
        if (!emptyForecastData) {
            $b51085ee695c0fdd$var$initWindParticles();
            return fetch((0, $j5Ozl.config).backEndUrl + "/live_forecasts/raster.json?metric=direction" + (timestamp ? "&timestamp=" + timestamp : "")).then(function(resp) {
                return resp.json();
            }).then(function(rasterData) {
                if (rasterData.width) {
                    (0, $gYLTL.map).rasterWidth = rasterData.width;
                    (0, $gYLTL.map).rasterHeight = rasterData.height;
                    (0, $gYLTL.map).windLayer.start();
                    if ((0, $gYLTL.map).activeMap === "satellite") (0, $gYLTL.map).windLayer.loadColorGradient((0, $j5Ozl.windColorsGradient)(rasterData));
                    else (0, $gYLTL.map).windLayer.loadColorGradient((0, $j5Ozl.singleColorGradient)("#FFFFFF"));
                    (0, $gYLTL.map).windLayer.setWindData({
                        uMin: rasterData.u_min,
                        uMax: rasterData.u_max,
                        vMin: rasterData.v_min,
                        vMax: rasterData.v_max,
                        width: rasterData.width,
                        height: rasterData.height,
                        image: rasterData.path
                    });
                    $b51085ee695c0fdd$export$392d57327b439f08();
                }
            });
        }
    });
}
function $b51085ee695c0fdd$export$392d57327b439f08() {
    console.debug("updateParticlesBBox");
    try {
        let scale = (0, $gYLTL.map).instance.getZoomScale((0, $gYLTL.map).instance.getZoom(), (0, $gYLTL.map).refZoom), bottomLeft = (0, $gYLTL.map).instance.project((0, $gYLTL.map).instance.getBounds().getSouthWest(), (0, $gYLTL.map).refZoom);
        // console.log('scale : ' + scale + ' - bottomLeft : ' + bottomLeft);
        let mSize = (0, $gYLTL.map).instance.getSize();
        let nWidth = mSize.x / (0, $gYLTL.map).windWidth / scale;
        let nHeight = mSize.y / (0, $gYLTL.map).windHeight / scale;
        let x, y, rect;
        // console.log('relative rect : ' + JSON.stringify(rect));
        // console.log('actual rect : ' + JSON.stringify({
        //   width: Math.round(rect.width * map.rasterWidth), height: Math.round(rect.height * map.rasterHeight),
        //   x: Math.round(rect.x * map.rasterWidth), y: Math.round(rect.y * map.rasterHeight)
        // }));
        if ((0, $gYLTL.map).windLayer && (0, $gYLTL.layers).dataLayers.indexOf("wind_fc") !== -1) {
            x = Math.abs(bottomLeft.x - (0, $gYLTL.map).windBox[0].x) / (0, $gYLTL.map).windWidth;
            y = Math.abs(bottomLeft.y - (0, $gYLTL.map).windBox[1].y) / (0, $gYLTL.map).windHeight;
            rect = {
                width: nWidth,
                height: nHeight,
                x: x,
                y: y
            };
            (0, $gYLTL.map).windLayer.setWindMapRect(rect.x, rect.y, rect.width, rect.height);
            (0, $gYLTL.map).windLayer.start();
        }
        if ((0, $gYLTL.map).wavesLayer && (0, $gYLTL.layers).dataLayers.indexOf("waves_fc") !== -1) {
            x = Math.abs(bottomLeft.x - (0, $gYLTL.map).wavesBox[0].x) / (0, $gYLTL.map).wavesWidth;
            y = Math.abs(bottomLeft.y - (0, $gYLTL.map).wavesBox[1].y) / (0, $gYLTL.map).wavesHeight;
            rect = {
                width: nWidth,
                height: nHeight,
                x: x,
                y: y
            };
            (0, $gYLTL.map).wavesLayer.setWindMapRect(rect.x, rect.y, rect.width, rect.height);
            (0, $gYLTL.map).wavesLayer.start();
        }
    } catch (e) {
        console.error("updateParticlesBBox error: " + e);
    }
}
function $b51085ee695c0fdd$var$onWebGLFailure() {
    console.error("WebGL Context lost");
}
function $b51085ee695c0fdd$var$initWindParticles() {
    if (!(0, $gYLTL.map).windLayer) {
        let params = {
            container: document.getElementById("particles_wrapper"),
            webGLFailureCallback: $b51085ee695c0fdd$var$onWebGLFailure
        };
        (0, $gYLTL.map).windLayer = new WindMap(params);
        (0, $gYLTL.map).windLayer.opacity = 1;
        (0, $gYLTL.map).windLayer.fadeOut = 0.88;
        (0, $gYLTL.map).windLayer.thickness = 1.5;
        (0, $gYLTL.map).windLayer.speedFactor = 1.5;
        (0, $gYLTL.map).windLayer.particlesNumber = 650;
        (0, $gYLTL.map).windLayer.dropRate = 0.05;
    }
}
function $b51085ee695c0fdd$var$initWavesParticles() {
    if (!(0, $gYLTL.map).wavesLayer) {
        let params = {
            container: document.getElementById("waves_wrapper"),
            webGLFailureCallback: $b51085ee695c0fdd$var$onWebGLFailure
        };
        (0, $gYLTL.map).wavesLayer = new WindMap(params);
        (0, $gYLTL.map).wavesLayer.opacity = 0.8;
        (0, $gYLTL.map).wavesLayer.fadeOut = 0.999;
        (0, $gYLTL.map).wavesLayer.thickness = 2;
        (0, $gYLTL.map).wavesLayer.speedFactor = 0.5;
        (0, $gYLTL.map).wavesLayer.particlesNumber = 2000;
        (0, $gYLTL.map).wavesLayer.dropRate = 0.2;
    }
}
function $b51085ee695c0fdd$var$renderForecastInfo(source, grid, runTs) {
    let dataInfo = document.querySelector("#data_info"), fcInfo = dataInfo.querySelector("#fc_info");
    if (source) {
        let sourceDetail = "", runTimestamp = /^\d+$/.test(runTs) ? (0, $89c314bed017fff5$export$2e2bcd8739ae039).unix(runTs) : (0, $89c314bed017fff5$export$2e2bcd8739ae039)(runTs);
        let runTsLabel = runTimestamp.format("DD/MM \xe0 H[h]");
        if (source === "arome" || source === "arpege") sourceDetail = "M\xe9t\xe9o-France (" + source.toUpperCase() + " " + grid + ")";
        else if (source === "piaf") {
            sourceDetail = "M\xe9t\xe9o-France (PIAF)";
            runTsLabel = runTimestamp.format("DD/MM \xe0 H[h]mm");
        } else sourceDetail = source.toUpperCase();
        if (sourceDetail === "WW3") sourceDetail = "WW3 M\xe9t\xe9o-France (haute r\xe9solution)";
        let fcContent = "<p>Pr\xe9vis. du " + runTsLabel + "<br/><em>" + sourceDetail + "</em></p>";
        if (fcInfo) fcInfo.innerHTML = fcContent;
        else {
            console.log("sourceDetail: " + fcContent);
            dataInfo.insertAdjacentHTML("beforeend", '<div id="fc_info">' + fcContent + "</div>");
        }
    } else {
        let emptyContent = "<p>Donn\xe9es indisponibles</p>";
        if (fcInfo) fcInfo.innerHTML = emptyContent;
        else dataInfo.insertAdjacentHTML("beforeend", emptyContent);
    }
}
function $b51085ee695c0fdd$var$renderWindInfo() {
    let dataInfo = document.querySelector("#data_info"), windInfo = dataInfo.querySelector("#wind_info"), windContent = "<p>Vents r\xe9els (et rafales) en n\u0153uds</p>";
    if (!windInfo) dataInfo.insertAdjacentHTML("beforeend", '<div id="wind_info">' + windContent + "</div>");
}
function $b51085ee695c0fdd$var$renderAmpInfo() {
    let dataInfo = document.querySelector("#data_info"), ampInfo = dataInfo.querySelector("#amp_info"), ampContent = "<p>Donn\xe9es Office fran\xe7ais de la biodiversit\xe9</p>";
    if (!ampInfo) dataInfo.insertAdjacentHTML("beforeend", '<div id="amp_info">' + ampContent + "</div>");
}
function $b51085ee695c0fdd$export$9e1f78c1c35aeca4() {
    if ((0, $gYLTL.layers).forecastsLayer && (0, $gYLTL.layers).forecastsLayer.overlay) (0, $gYLTL.map).instance.removeLayer((0, $gYLTL.layers).forecastsLayer.overlay);
    (0, $gYLTL.layers).forecastsLayer = null;
    if ((0, $gYLTL.map).windLayer) (0, $gYLTL.map).windLayer.stop();
    if (document.querySelector("#fc_info")) document.querySelector("#fc_info").innerHTML = "";
}
function $b51085ee695c0fdd$export$ec577891f2365dde(timestamp) {
    let emptyForecastData = false;
    if ((0, $gYLTL.map).activeMap === "wm") (0, $cb3e0081c099494f$export$382d1aca2389ca8b)();
    return fetch((0, $j5Ozl.config).backEndUrl + "/live_forecasts/raster.json?source=ww3&metric=wave" + (timestamp ? "&timestamp=" + timestamp : "")).then(function(resp) {
        if (resp.ok) return resp.json();
        else throw new Error("Forecast data not found");
    }).then(function(rasterData) {
        // console.log("rasterData: " + JSON.stringify(rasterData));
        if (rasterData.width) {
            $b51085ee695c0fdd$var$renderForecastInfo(rasterData.source, rasterData.grid, rasterData.run_timestamp);
            // var wmLayerBtn = document.querySelector("#styled_bg");
            // if (!wmLayerBtn.classList.contains("active") && map.activeMap !== 'elevation') {
            //   toggleMap(wmLayerBtn, "wm");
            // }
            return (0, $cb3e0081c099494f$export$f0c5438bd76c55d8)(true, true).then(function() {
                if ((0, $gYLTL.layers).forecastsLayer && (0, $gYLTL.layers).forecastsLayer.overlay) (0, $gYLTL.map).instance.removeLayer((0, $gYLTL.layers).forecastsLayer.overlay);
                // Note : bounds adjusted to compensate img distortion
                // Improvement : reproject properly to avoid distortion in the whole area
                (0, $gYLTL.layers).forecastsLayer = {
                    forecastId: rasterData.id,
                    forecastTimestamp: timestamp,
                    overlay: new (0, $46bce056a5f1f2c2$export$4e7a29849e6c05f6)(rasterData.raster, (0, $j5Ozl.config).forecastsBounds, {
                        className: "fc_colors",
                        pane: "tilePane"
                    }).addTo((0, $gYLTL.map).instance)
                };
                document.querySelector("#map_container").classList.add("rendered");
            });
        } else {
            emptyForecastData = true;
            $b51085ee695c0fdd$var$renderForecastInfo(null);
            if ((0, $gYLTL.layers).forecastsLayer && (0, $gYLTL.layers).forecastsLayer.overlay) (0, $gYLTL.map).instance.removeLayer((0, $gYLTL.layers).forecastsLayer.overlay);
            document.querySelector("#map_container").classList.remove("rendered");
            return (0, $cb3e0081c099494f$export$7936340adedaf8bc)((0, $gYLTL.map).activeMap);
        }
    }).then(function() {
        if (!emptyForecastData) {
            $b51085ee695c0fdd$var$initWavesParticles();
            return fetch((0, $j5Ozl.config).backEndUrl + "/live_forecasts/raster.json?metric=wave_direction&source=ww3" + (timestamp ? "&timestamp=" + timestamp : "")).then(function(resp) {
                return resp.json();
            }).then(function(rasterData) {
                if (rasterData.width) {
                    (0, $gYLTL.map).rasterWidth = rasterData.width;
                    (0, $gYLTL.map).rasterHeight = rasterData.height;
                    (0, $gYLTL.map).wavesLayer.start();
                    (0, $gYLTL.map).wavesLayer.loadColorGradient((0, $j5Ozl.singleColorGradient)("#02ACF1"));
                    (0, $gYLTL.map).wavesLayer.setWindData({
                        uMin: rasterData.u_min,
                        uMax: rasterData.u_max,
                        vMin: rasterData.v_min,
                        vMax: rasterData.v_max,
                        width: rasterData.width,
                        height: rasterData.height,
                        image: rasterData.path
                    });
                    // if (layers.dataLayers.indexOf('wind_fc') === -1) {
                    $b51085ee695c0fdd$export$392d57327b439f08();
                // }
                }
            });
        }
    }).catch(function(err) {
        console.warn("Could not retrieve waves forecast data for provided timestamp");
        $b51085ee695c0fdd$export$b6340bfc991ad04();
        (0, $cb3e0081c099494f$export$7936340adedaf8bc)((0, $gYLTL.map).activeMap, true);
    });
}
function $b51085ee695c0fdd$export$b6340bfc991ad04() {
    console.log("hideWavesForecasts");
    if ((0, $gYLTL.layers).forecastsLayer) (0, $gYLTL.map).instance.removeLayer((0, $gYLTL.layers).forecastsLayer.overlay);
    (0, $gYLTL.layers).forecastsLayer = null;
    if ((0, $gYLTL.map).wavesLayer) (0, $gYLTL.map).wavesLayer.stop();
    if (document.querySelector("#fc_info")) document.querySelector("#fc_info").innerHTML = "";
}
function $b51085ee695c0fdd$export$c3627125dd65970c() {
    (0, $gYLTL.layers).overlay.node().innerHTML = '<symbol id="arrow" viewBox="0 0 43.4 47.4" width="24px" height="26px"><path stroke-width="2" d="M3.3,3.6C3.7,3.2,4.4,3,5.1,3.2l16.7,5.4l16.6-5.5c0.7-0.2,1.4,0,1.8,0.5c0.5,0.5,0.6,1.3,0.3,1.9L23.5,43.4c-0.2,0.6-0.9,1-1.6,1c-0.7,0-1.3-0.4-1.6-1L2.9,5.6C2.7,5,2.8,4.2,3.3,3.6C3.2,3.7,3.2,3.7,3.3,3.6z"/></symbol><symbol id="alt_arrow" width="22px" height="24px" viewBox="0 0 22 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="group" transform="rotate(180) translate(-23, -24)"><g id="Subtract"><mask id="path-1-outside-1_31_8077" maskUnits="userSpaceOnUse" x="1.5" y="0" width="21" height="23" fill="black"><rect fill="white" x="1.5" width="21" height="23"/><path fill-rule="evenodd" clip-rule="evenodd" d="M20.3476 21.9103C20.6989 22.0119 21.0501 21.9103 21.2508 21.7073C21.5017 21.4028 21.5519 20.9968 21.4515 20.6923L18.7075 14.6627L11.9791 12.0841L5.25738 14.7161L2.58468 20.743C2.43414 21.0475 2.48432 21.4536 2.73521 21.7073C2.93592 21.9611 3.28716 22.0626 3.63841 21.9611L11.9679 19.1697L20.3476 21.9103ZM6.41003 12.1169L11.6106 10.0806L11.9713 9.93931L12.333 10.0779L17.5268 12.0684L12.7206 1.50753C12.5701 1.20301 12.269 1 11.9177 1C11.5665 1 11.2153 1.20301 11.1149 1.50753L6.41003 12.1169Z"/></mask><path fill-rule="evenodd" clip-rule="evenodd" d="M20.3476 21.9103C20.6989 22.0119 21.0501 21.9103 21.2508 21.7073C21.5017 21.4028 21.5519 20.9968 21.4515 20.6923L18.7075 14.6627L11.9791 12.0841L5.25738 14.7161L2.58468 20.743C2.43414 21.0475 2.48432 21.4536 2.73521 21.7073C2.93592 21.9611 3.28716 22.0626 3.63841 21.9611L11.9679 19.1697L20.3476 21.9103ZM6.41003 12.1169L11.6106 10.0806L11.9713 9.93931L12.333 10.0779L17.5268 12.0684L12.7206 1.50753C12.5701 1.20301 12.269 1 11.9177 1C11.5665 1 11.2153 1.20301 11.1149 1.50753L6.41003 12.1169Z" fill="white"/></g></g></symbol><symbol id="wave_arrow" viewBox="0 0 100 100" width="24px" height="26px"><g transform="translate(0,-952.36218)"><path d="m 49.999995,1037.3622 27.00001,-38.00002 -17,3.00002 4,-35.00002 -28.00001,0 4,35.00002 -17,-3.00002 z" stroke-width="2"/></g></symbol><symbol id="wave_sensor_icon" viewBox="0 0 576 512" width="24px" height="26px"><path d="M0 336c0-17.7 14.3-32 32-32c35.3 0 64-28.7 64-64C96 125.1 189.1 32 304 32c84.7 0 157.6 50.7 190 123.2c4.7 10.5 1.3 22.8-8.1 29.4s-22.2 5.6-30.4-2.3C441 168.5 421.5 160 400 160c-44.2 0-80 35.8-80 80c0 35.3 28.7 64 64 64c0 0 0 0 0 0c26.9 0 55.4-10.8 77.4-26.1c0 0 0 0 0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c15 3.5 25.1 17.1 24.7 31.9l0 41.9c-28.7 0-55.1-8.9-73.8-17.4c-5.5-2.5-10.3-5-14.5-7.2c-4.8-2.6-10.5-2.6-15.3 0c-4.2 2.3-9.1 4.8-14.5 7.2c-18.7 8.5-45.1 17.4-73.8 17.4s-55.1-8.9-73.8-17.4c-5.5-2.5-10.3-5-14.5-7.2c-4.8-2.6-10.5-2.6-15.3 0c-4.2 2.3-9.1 4.8-14.5 7.2c-18.7 8.5-45.1 17.4-73.8 17.4s-55.1-8.9-73.8-17.4c-5.5-2.5-10.3-5-14.5-7.2c-4.8-2.6-10.5-2.6-15.3 0c-4.2 2.3-9.1 4.8-14.5 7.2C55.1 369.7 28.7 378.6 0 378.6L0 336zm0 74.6c35 0 66.1-10.8 87.1-20.3c3.2-1.4 6.1-2.9 8.9-4.3c2.8 1.4 5.8 2.8 8.9 4.3c20.9 9.5 52 20.3 87.1 20.3s66.1-10.8 87.1-20.3c3.2-1.4 6.1-2.9 8.9-4.3c2.8 1.4 5.8 2.8 8.9 4.3c20.9 9.5 52 20.3 87.1 20.3s66.1-10.8 87.1-20.3c3.2-1.4 6.1-2.9 8.9-4.3c2.8 1.4 5.8 2.8 8.9 4.3c21 9.5 52 20.3 87.1 20.3l0 36.6c.1 2.7-.2 5.4-.8 8.1c-4 17.2-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 469.7 417 480 384 480c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9c-.6-2.4-.8-4.9-.8-7.3c0 0 0 0 0 0s0 0 0 0l0-37.4z"/></symbol><g class="zoom_wrapper"></g>';
}
function $b51085ee695c0fdd$export$99d351c03c5dffc6() {
    (0, $gYLTL.layers).forecastsLayer.node().innerHTML = '<symbol id="wave_arrow" viewBox="0 0 100 100" width="16px"><g transform="translate(0,-952.36218)"><path d="m 49.999995,1037.3622 27.00001,-38.00002 -17,3.00002 4,-35.00002 -28.00001,0 4,35.00002 -17,-3.00002 z" fill="none" stroke="#0c4da2"/></g></symbol><g class="zoom_wrapper"></g>';
}
function $b51085ee695c0fdd$export$f45e13584efe3e9() {
    if (!(0, $gYLTL.data).sensorsPolling) (0, $gYLTL.data).sensorsPolling = setInterval(()=>{
        if (!(0, $gYLTL.timeline).timelineActiveStep || (0, $gYLTL.timeline).timelineActiveStep === (0, $fb487846a357c1c2$export$83a9ef028b771fd4)()) {
            $b51085ee695c0fdd$export$f80b4067547ee73();
            if ((0, $gYLTL.layers).dataLayers.indexOf("waves") !== -1) $b51085ee695c0fdd$export$9d5a23401ec8f7d();
            if ((0, $gYLTL.layers).dataLayers.indexOf("temp") !== -1) $b51085ee695c0fdd$export$d24539e194e73733();
        }
    }, 30000);
}
function $b51085ee695c0fdd$export$2eeb97286c6ecc12() {
    const latest = !(0, $gYLTL.timeline).timelineActiveStep || (0, $gYLTL.timeline).timelineActiveStep === (0, $fb487846a357c1c2$export$83a9ef028b771fd4)();
    $b51085ee695c0fdd$var$loadWindSensorsData(latest);
}
function $b51085ee695c0fdd$export$73503ae067c61ef7() {
    const latest = !(0, $gYLTL.timeline).timelineActiveStep || (0, $gYLTL.timeline).timelineActiveStep === (0, $fb487846a357c1c2$export$83a9ef028b771fd4)();
    $b51085ee695c0fdd$var$loadWaveSensorsData(latest);
}
function $b51085ee695c0fdd$export$29c237bcbb68a918() {
    (0, $gYLTL.layers).overlay.selectAll(".wind_sensor").remove();
}
function $b51085ee695c0fdd$export$8bc70383dd83dd6b() {
    (0, $gYLTL.layers).overlay.selectAll(".wave_sensor").remove();
}
function $b51085ee695c0fdd$export$cb0d41d287166a75(timestamp) {
    const spotPois = (0, $gYLTL.layers).activeSpot?.pois || [];
    console.debug("activeSpot: " + (0, $gYLTL.layers).activeSpot?.ref + " - spotPois: " + JSON.stringify(spotPois));
    (0, $5ewvA.getAsync)((0, $j5Ozl.config).backEndUrl + "/live_forecasts/weather.json" + (timestamp ? "?timestamp=" + timestamp : ""), function(poisData) {
        (0, $gYLTL.layers).overlay.select(".zoom_wrapper").selectAll(".weather_poi").remove();
        const activePois = poisData.pois.filter((d)=>!spotPois.length || spotPois.indexOf(d.slug) !== -1);
        const poisTs = parseInt(poisData.timestamp);
        let pois = (0, $gYLTL.layers).overlay.select(".zoom_wrapper").selectAll(".weather_poi").data(activePois, function(d) {
            return d.name;
        }).join("g").attr("class", function(d) {
            return `weather_poi ${d.slug === (0, $gYLTL.layers).activePoi?.slug ? "poi-active" : ""}`;
        }).attr("id", function(d) {
            return "poi_" + d.slug;
        }).attr("transform", function(d) {
            return "translate(" + (0, $cb3e0081c099494f$export$33d1addef09845d7)(d.lng, d.lat) + ")";
        });
        if ((0, $gYLTL.layers).activeSpot || (0, $gYLTL.layout).edit) pois.on("click", weatherDetails);
        $b51085ee695c0fdd$var$renderForecastInfo(activePois[0].source, activePois[0].grid, activePois[0].run_ts);
        pois.append("foreignObject").attr("width", 80).attr("height", 64).attr("transform", "translate(-40, -36)").append("xhtml:body").html(function(d, j) {
            let poiData = Object.values(activePois)[j];
            if (poiData) {
                let currentRain = poiData.tw || poiData.tp || 0, prevRain = poiData.prev_tw || poiData.prev_tp || 0;
                let icon = (0, $145480a03a16151b$export$a815945e7f6f673b)(poiData.hc, poiData.mc, poiData.lc, poisTs, currentRain - prevRain);
                if ((0, $gYLTL.layers).activeSpot || (0, $gYLTL.layout).edit) return "<div class='poi_icon'><img src='" + (0, (/*@__PURE__*/$parcel$interopDefault($7636ed459e8205ef$exports)))[icon] + "' alt='" + d.name + "'/>" + "<span style='color: " + (0, $j5Ozl.tempColor)(poiData.temp) + ";'>" + poiData.temp + "\xb0</span>" + "<img class='active_icon' src='" + (0, (/*@__PURE__*/$parcel$interopDefault($7636ed459e8205ef$exports))).active_poi_icon + "' alt='" + d.name + "'/>" + "</div>" + "<p class='poi_name'>" + d.name + "</p>";
                else return "<a href='/previsions/" + d.slug + "' class='poi_icon' data-navigo><img src='" + (0, (/*@__PURE__*/$parcel$interopDefault($7636ed459e8205ef$exports)))[icon] + "' alt='" + d.name + "'/><span style='color: " + (0, $j5Ozl.tempColor)(poiData.temp) + ";'>" + poiData.temp + "\xb0</span></a>" + "<p class='poi_name'>" + d.name + "</p>";
            }
        });
        (0, $a512f8659cf98537$export$2e2bcd8739ae039).updatePageLinks();
    });
}
function $b51085ee695c0fdd$export$8cec9de7786b83d1() {
    (0, $gYLTL.layers).overlay.selectAll(".weather_poi").remove();
}
function $b51085ee695c0fdd$export$58ee9c5364baca8b() {
    (0, $gYLTL.layers).overlay.selectAll(".water_temp_sensor").remove();
}
function $b51085ee695c0fdd$export$55801adb6166106a() {
    const spotWebcams = (0, $gYLTL.layers).activeSpot?.webcams || [];
    console.debug("activeSpot: " + (0, $gYLTL.layers).activeSpot?.ref + " - spotWebcams: " + JSON.stringify(spotWebcams));
    (0, $j5Ozl.loadWebcams)(function() {
        let activeWebcams = (0, $j5Ozl.webcamsRefs).filter((d)=>!spotWebcams.length || spotWebcams.indexOf(`/webcam/${d.slug}`) !== -1);
        let webcams = (0, $gYLTL.layers).overlay.select(".zoom_wrapper").selectAll(".webcam_spot").data(activeWebcams).join("g").attr("class", "webcam_spot").attr("transform", function(d) {
            return "translate(" + (0, $cb3e0081c099494f$export$33d1addef09845d7)(d.lng, d.lat) + ")";
        });
        if ((0, $gYLTL.layers).activeSpot) webcams.on("click", $b51085ee695c0fdd$export$3d0a3aba327d4829);
        webcams.append("foreignObject").attr("width", 32).attr("height", 32).attr("transform", "translate(-16, -16)").append("xhtml:body").html(function(d) {
            const webcamIcon = `<img src="${(0, (/*@__PURE__*/$parcel$interopDefault($39cbcd9072da7ec9$exports)))["webcam-map"]}" alt="${d.label}">`;
            if ((0, $gYLTL.layers).activeSpot) return `<div>${webcamIcon}</div>`;
            else return `<a href="/webcam/${d.slug}" title="${d.label}" data-navigo>${webcamIcon}</a>`;
        });
        (0, $a512f8659cf98537$export$2e2bcd8739ae039).updatePageLinks();
    });
}
function $b51085ee695c0fdd$export$d90e5afe47f108e7() {
    (0, $gYLTL.layers).overlay.selectAll(".webcam_spot").remove();
}
function $b51085ee695c0fdd$export$d2af805eac6d6eea() {
    const latest = !(0, $gYLTL.timeline).timelineActiveStep || (0, $gYLTL.timeline).timelineActiveStep === (0, $fb487846a357c1c2$export$83a9ef028b771fd4)();
    $b51085ee695c0fdd$var$loadTempSensorsData(latest);
}
function $b51085ee695c0fdd$export$5aa43213bed9fb5b() {
    (0, $gYLTL.layers).overlay.selectAll(".temp_sensor .temp_details").remove();
}
function $b51085ee695c0fdd$export$4b28a1d7df585529() {
    const spotTideGauges = (0, $gYLTL.layers).activeSpot?.tideGauges || [];
    console.debug("activeSpot: " + (0, $gYLTL.layers).activeSpot?.ref + " - spotTideGauges: " + JSON.stringify(spotTideGauges));
    (0, $j5Ozl.loadHarbors)(function() {
        const activeTideGauges = (0, $j5Ozl.harborsRefs).filter((d)=>!spotTideGauges.length || spotTideGauges.indexOf(`/port/${d.slug}`) !== -1);
        let harbors = (0, $gYLTL.layers).overlay.select(".zoom_wrapper").selectAll(".tide_spot").data(activeTideGauges).join("g").attr("class", "tide_spot").attr("transform", function(d) {
            return "translate(" + (0, $cb3e0081c099494f$export$33d1addef09845d7)(d.lng, d.lat) + ")";
        });
        if ((0, $gYLTL.layers).activeSpot) harbors.on("click", $b51085ee695c0fdd$export$a56d4708c86e0d68);
        harbors.append("foreignObject").attr("width", 32).attr("height", 32).attr("transform", "translate(-16, -16)").append("xhtml:body").html(function(d) {
            const tideIcon = `<img src="${(0, (/*@__PURE__*/$parcel$interopDefault($39cbcd9072da7ec9$exports)))["tide-map"]}" alt="${d.label}">`;
            if ((0, $gYLTL.layers).activeSpot) return `<div>${tideIcon}</div>`;
            else return `<a href="/port/${d.slug}" title="${d.label}" data-navigo>${tideIcon}</a>`;
        });
        (0, $a512f8659cf98537$export$2e2bcd8739ae039).updatePageLinks();
    });
}
function $b51085ee695c0fdd$export$d7485b22b743276a() {
    (0, $gYLTL.layers).overlay.selectAll(".tide_spot").remove();
}
function $b51085ee695c0fdd$export$ef1e4522aef11b2c(timestamp) {
    let refTs, refTime;
    if (timestamp) refTs = new Date(timestamp * 1000);
    else {
        const now = new Date().getTime();
        refTs = new Date(now - now % 300000);
    }
    refTime = refTs.toISOString();
    const refDate = refTime.split("T")[0];
    refTime = refTime.replace(/[-:]/g, "").replace("T", "_").replace(".000Z", "");
    const fileUrl = `https://private2.windmorbihan.com/piaf/${refDate}/PIAF_${refTime}_UTC.tiff`;
    console.debug("PIAF fileUrl: " + fileUrl);
    let piafLayer;
    fetch(fileUrl).then((response)=>response.arrayBuffer()).then((arrayBuffer)=>{
        window.parseGeoraster(arrayBuffer).then((georaster)=>{
            // console.log('georaster info: ' + JSON.stringify(georaster));
            // const min = georaster.mins[0];
            // const max = georaster.maxs[0];
            // const range = georaster.ranges[0];
            // console.debug('raster values: ' + JSON.stringify({min, max, range}));
            georaster.projection = 4326;
            piafLayer = new (0, $4243bf518a93e3b4$export$2e2bcd8739ae039)({
                georaster: georaster,
                opacity: (0, $j5Ozl.config).piafLayerOpacity,
                pixelValuesToColorFn: function(pixelValues) {
                    const pixelValue = pixelValues[0];
                    if (pixelValue === 0) return null;
                    return (0, $j5Ozl.piafRainColor)(pixelValue);
                },
                resolution: 256
            });
            piafLayer.on("load", $b51085ee695c0fdd$var$onPiafLayerLoad).addTo((0, $gYLTL.map).instance);
            (0, $gYLTL.layers).bgLayers.push(piafLayer);
            $b51085ee695c0fdd$var$renderForecastInfo("piaf", null, timestamp);
            (0, $fb487846a357c1c2$export$ed92572d6df92f9d)(refTs.getTime() / 1000, (0, $gYLTL.timeline).details);
        });
    });
}
function $b51085ee695c0fdd$var$onPiafLayerLoad(evt) {
    setTimeout(function() {
        $b51085ee695c0fdd$export$fabfd2d23e2cb44d();
        evt.target.off("load", $b51085ee695c0fdd$var$onPiafLayerLoad);
    }, 100);
}
function $b51085ee695c0fdd$export$fabfd2d23e2cb44d(allLayers = false) {
    const currentPiafLayers = (0, $gYLTL.layers).bgLayers.filter((l)=>l.georasters);
    if (allLayers || currentPiafLayers.length > 1) {
        const currentPiafLayerIndex = (0, $gYLTL.layers).bgLayers.findIndex((l)=>l.georasters);
        console.debug("currentPiafLayerIndex: " + currentPiafLayerIndex.toString());
        if (currentPiafLayerIndex !== -1) {
            (0, $gYLTL.map).instance.removeLayer((0, $gYLTL.layers).bgLayers[currentPiafLayerIndex]);
            (0, $gYLTL.layers).bgLayers.splice(currentPiafLayerIndex, 1);
        }
    }
}
function $b51085ee695c0fdd$export$bc7a58d94166ace9() {
    var ampZones = document.querySelectorAll(".amp_zone"), i;
    if (ampZones.length > 0) for(i = 0; i < ampZones.length; i++)ampZones[i].remove();
    if (document.querySelector("#amp_info")) document.querySelector("#amp_info").remove();
}
function $b51085ee695c0fdd$export$374449e81fae6fe1() {
    (0, $gYLTL.layers).overlay.selectAll(".amp_spot").remove();
    if (document.querySelector("#amp_info")) document.querySelector("#amp_info").remove();
}
function $b51085ee695c0fdd$export$aceb2de1ae588630() {
    (0, $68d1f4605b868e5f$export$2e2bcd8739ae039)((0, $j5Ozl.config).backEndUrl + "/features.json?source=amp_poi").then(function(geojsonPois) {
        $b51085ee695c0fdd$var$renderAmpInfo();
        var ampPois = (0, $gYLTL.layers).overlay.select(".zoom_wrapper").selectAll(".amp_spot").data(geojsonPois.features).join("g").attr("class", "amp_spot").attr("transform", function(d) {
            return "translate(" + (0, $cb3e0081c099494f$export$33d1addef09845d7)(d.geometry.coordinates[0], d.geometry.coordinates[1]) + ")";
        }).on("click", $b51085ee695c0fdd$var$ampDetails);
        ampPois.append("foreignObject").attr("width", 32).attr("height", 32).append("xhtml:body").html(function(d) {
            return '<div title="' + d.properties.title + '" ><img src="' + (0, (/*@__PURE__*/$parcel$interopDefault($39cbcd9072da7ec9$exports)))["amp-map"] + '" alt="' + d.properties.title + '"></a>';
        });
    });
}
function $b51085ee695c0fdd$export$4f3be6eabe0c49e5() {
    let zoneStyle = {
        stroke: false,
        fill: true,
        fillColor: "rgb(224,87,247)",
        fillOpacity: 0.7
    };
    return (0, $68d1f4605b868e5f$export$2e2bcd8739ae039)((0, $j5Ozl.config).backEndUrl + "/features.json?source=amp").then(function(geoJsonZone) {
        $b51085ee695c0fdd$var$renderAmpInfo();
        let geoJson = $645b7147683636d0$exports.geoJSON(geoJsonZone.features, {
            className: "amp_zone",
            style: zoneStyle,
            pane: "tilePane",
            filter: function(feature, layer) {
                return true;
            }
        });
        geoJson.addTo((0, $gYLTL.map).instance);
        (0, $gYLTL.layers).bgLayers.push(geoJson);
        return geoJson;
    });
}
function $b51085ee695c0fdd$var$ampDetails(evt, d) {
    document.querySelector("#map_modal").setAttribute("data-modal", "amp");
    document.querySelector("#map_modal_title").innerHTML = d.properties.title;
    document.querySelector("#header_links").innerHTML = '<button class="modal__close" aria-label="Fermer" data-micromodal-close></button>';
    var imgMarkup = "";
    if (d.properties.img) imgMarkup = "<div class='amp_photo'><img src='" + d.properties.img + "'/><p>Credit Photo : " + d.properties.credit_img1 + "</p></div>";
    document.querySelector("#map_modal_content").innerHTML = "<div class='amp_modal'>" + imgMarkup + "<div class='amp_description'>" + "<h2>" + d.properties.title + "</h2>" + "<h3>" + d.properties.header_text + "</h3>" + "<h4>Lieu : " + d.properties.amp_name + "</h4>" + "<p>" + d.properties.description + "</p>" + "</div>" + "</div>";
    (0, $dnPBs.default).show("map_modal", {
        disableScroll: true
    });
}
function $b51085ee695c0fdd$export$3d0a3aba327d4829(evt, d, onClose = null) {
    if (evt) {
        evt.preventDefault();
        evt.stopPropagation();
    }
    document.querySelector("#map_modal").setAttribute("data-modal", "webcam");
    document.querySelector("#map_modal_title").innerHTML = d.label;
    document.querySelector("#header_links").innerHTML = '<button class="modal__close" aria-label="Fermer" data-micromodal-close></button>';
    document.querySelector("#map_modal_content").innerHTML = d.content;
    const opts = onClose ? {
        disableScroll: true,
        onClose: onClose
    } : {
        disableScroll: true
    };
    (0, $dnPBs.default).show("map_modal", opts);
}
function $b51085ee695c0fdd$export$a56d4708c86e0d68(evt, d, onClose = null) {
    if (evt) {
        evt.preventDefault();
        evt.stopPropagation();
    }
    document.querySelector("#map_modal").setAttribute("data-modal", "tide");
    document.querySelector("#map_modal_title").innerHTML = d.label;
    document.querySelector("#header_links").innerHTML = '<button class="modal__close" aria-label="Fermer" data-micromodal-close></button>';
    document.querySelector("#map_modal_content").innerHTML = '<iframe id="shom_wrapper" src="javascript:void(0);"></iframe>';
    const frm = document.querySelector("#map_modal_content #shom_wrapper");
    frm.srcdoc = '<html><body style="margin: 0; padding: 0;"><script src="' + d.shomUrl + '"></script></body></html>';
    const opts = onClose ? {
        disableScroll: true,
        onClose: onClose
    } : {
        disableScroll: true
    };
    (0, $dnPBs.default).show("map_modal", opts);
}
function $b51085ee695c0fdd$export$53d225340945d25c(popup, lat, lng) {
    $b51085ee695c0fdd$var$getForecastPoint((0, $gYLTL.layers).forecastsLayer.forecastId, lat, lng, function(pointData) {
        if (pointData.lat) {
            (0, $gYLTL.map).currentFocus = pointData;
            let color = (0, $gYLTL.map).currentFocus.ws ? (0, $j5Ozl.windColor)((0, $gYLTL.map).currentFocus.ws) : {
                bg: (0, $j5Ozl.waveColor)((0, $gYLTL.map).currentFocus.wah),
                text: "#154194"
            };
            let value = (0, $gYLTL.map).currentFocus.ws ? Math.round((0, $gYLTL.map).currentFocus.ws) + "nds" : (0, $gYLTL.map).currentFocus.wah + "m";
            let windDir = "";
            if ((0, $gYLTL.map).currentFocus.wind_d) {
                let dirVal = (270 - (0, $gYLTL.map).currentFocus.wind_d) % 360;
                dirVal = dirVal < 10 ? "00" + dirVal : dirVal < 100 ? "0" + dirVal : dirVal;
                windDir = " / " + dirVal + "\xb0";
            }
            let waveDir = (0, $gYLTL.map).currentFocus.wad ? '<img src="' + (0, (/*@__PURE__*/$parcel$interopDefault($39cbcd9072da7ec9$exports)))["fleche-vague"] + '" alt="direction" class="pointer_direction" style="transform: rotate(' + ((0, $gYLTL.map).currentFocus.wad - 180) + 'deg); transform-origin: 50% 50% 0px; display: inline;"/>' : "";
            let wavePeriod = (0, $gYLTL.map).currentFocus.ptp ? `  ${Math.round((0, $gYLTL.map).currentFocus.ptp / 1000)}s` : "";
            popup.setContent('<p style="background-color: ' + color.bg + "; color: " + color.text + '" class="pointer_info">' + value + (windDir || waveDir) + wavePeriod + "</p>");
        } else popup.setContent(lat + ", " + lng);
    });
}
function $b51085ee695c0fdd$var$getForecastPoint(forecastId, lat, lng, callback) {
    (0, $5ewvA.getAsync)((0, $j5Ozl.config).backEndUrl + "/live_forecasts/" + forecastId + "/point?lat=" + lat + "&lng=" + lng, function(pointData) {
        callback(pointData);
    });
}
function $b51085ee695c0fdd$export$e7dd361938fddba2(popup, lat, lng) {
    const currentPiafLayer = (0, $gYLTL.layers).bgLayers.find((l)=>l.georasters);
    if (currentPiafLayer) {
        const value = (0, (/*@__PURE__*/$parcel$interopDefault($fff057aebec3dd6f$exports))).identify(currentPiafLayer.georasters[0], [
            lng,
            lat
        ]);
        console.debug("piaf val: " + value);
        if (value) {
            const color = (0, $j5Ozl.piafRainColor)(value), roundedVal = Math.round(value * 10) / 10.0;
            popup.setContent('<p style="background-color: ' + color + '; color: #154194" class="pointer_info">' + roundedVal + "mm/h</p>");
        }
    }
}
function $b51085ee695c0fdd$export$2a22cb1184287a3d() {
    (0, $gYLTL.map).instance.locate();
}
function $b51085ee695c0fdd$export$e72c2db76561db73(data) {
    $b51085ee695c0fdd$var$renderWindInfo();
    const spotSensors = (0, $gYLTL.layers).activeSpot?.windSensors || [];
    console.debug("activeSpot: " + (0, $gYLTL.layers).activeSpot?.ref + " - spotSensors: " + JSON.stringify(spotSensors));
    let availableSensors = data.filter(function(d) {
        return Object.keys((0, $j5Ozl.sensorsRefs)).indexOf(d.nid.toString()) !== -1 && d.wind_pow_knot && (!spotSensors.length || spotSensors.indexOf(d.nid.toString()) !== -1);
    });
    (0, $gYLTL.layers).overlay.select(".zoom_wrapper").selectAll(".wind_sensor").data(availableSensors, function(d) {
        return d.nid;
    }).join(function(enter) {
        var sensors = enter.append("g").attr("class", function(d) {
            return "wind_sensor" + ((0, $j5Ozl.tempSensorsRefs)[d.nid] ? " temp_sensor" : "");
        }).attr("id", function(d) {
            return "sensor_" + d.nid;
        }).attr("transform", function(d) {
            return "translate(" + (0, $cb3e0081c099494f$export$33d1addef09845d7)((0, $j5Ozl.sensorsRefs)[d.nid].lng, (0, $j5Ozl.sensorsRefs)[d.nid].lat) + ")";
        });
        sensors.append("use").attr("xlink:href", "#arrow").attr("x", "-12").attr("y", "-13").attr("width", "24px").attr("height", "26px").attr("class", function(d) {
            return $b51085ee695c0fdd$var$isValidAngle(d.nid, d.wind_dir_true) ? "" : "devent";
        }).attr("transform", function(d) {
            return "rotate(" + d.wind_dir_true + ", 0, 0)";
        });
        sensors.append("g").attr("class", "wind_details").attr("transform", "translate(16, -12)").append("foreignObject").attr("width", 60).attr("height", 30).append("xhtml:body").html(function(d) {
            let color = (0, $j5Ozl.windColor)(d.wind_pow_knot), colorMax = (0, $j5Ozl.windColor)(d.wind_pow_knot_max);
            return "<p><span style='background-color: " + color.bg + "; color: " + color.text + "'>" + d.wind_pow_knot + "</span>" + "<span style='background-color: " + colorMax.bg + "; color: " + colorMax.text + "'>(" + d.wind_pow_knot_max + ")</span>" + "</p>";
        });
        sensors.on("click", function(evt, d) {
            if (!(0, $gYLTL.layout).edit) {
                evt.stopPropagation();
                if ((0, $gYLTL.layers).activeSpot) (0, $418aca01110c9e5e$export$aadaa5940712eda)(evt, d);
                else (0, $a512f8659cf98537$export$2e2bcd8739ae039).navigate("/" + (0, $j5Ozl.sensorsRefs)[d.nid].slug);
            }
        });
        sensors.on("mouseover", function(evt, d) {
            $d78f01d7851d977e$export$2e2bcd8739ae039(this).raise();
            if ($d78f01d7851d977e$export$2e2bcd8739ae039("#sensor_" + d.nid + " .sensor_name").size() === 0) $d78f01d7851d977e$export$2e2bcd8739ae039("#sensor_" + d.nid).append("text").attr("class", "sensor_name").text((0, $j5Ozl.sensorsRefs)[d.nid].label);
        }).on("mouseout", function(evt, d) {
            if (!(0, $gYLTL.layout).edit) $4eee8f3e49a380ba$export$2e2bcd8739ae039(".sensor_name").remove();
        });
        return sensors;
    }, function(update) {
        update.select("use").attr("transform", function(d) {
            return "rotate(" + d.wind_dir_true + ", 0, 0)";
        }).attr("class", function(d) {
            return $b51085ee695c0fdd$var$isValidAngle(d.nid, d.wind_dir_true) ? "" : "devent";
        });
        update.select("g foreignObject body p span:first-child").transition().style("background-color", function(d) {
            return (0, $j5Ozl.windColor)(d.wind_pow_knot).bg;
        }).style("color", function(d) {
            return (0, $j5Ozl.windColor)(d.wind_pow_knot).text;
        }).text(function(d) {
            return d.wind_pow_knot;
        });
        update.select("g foreignObject body p span:last-child").transition().style("background-color", function(d) {
            return (0, $j5Ozl.windColor)(d.wind_pow_knot_max).bg;
        }).style("color", function(d) {
            return (0, $j5Ozl.windColor)(d.wind_pow_knot_max).text;
        }).text(function(d) {
            return "(" + d.wind_pow_knot_max + ")";
        });
        return update;
    });
}
function $b51085ee695c0fdd$export$7c21e768f6379ae(data) {
    const spotSensors = (0, $gYLTL.layers).activeSpot?.wavesSensors || [];
    console.debug("activeSpot: " + (0, $gYLTL.layers).activeSpot?.ref + " - spotSensors: " + JSON.stringify(spotSensors));
    let availableSensors = data.filter(function(d) {
        return Object.keys((0, $j5Ozl.waveSensorsRefs)).indexOf(d.nid.toString()) !== -1 && (!spotSensors.length || spotSensors.indexOf(d.nid.toString()) !== -1);
    });
    (0, $gYLTL.layers).overlay.select(".zoom_wrapper").selectAll(".wave_sensor").data(availableSensors, function(d) {
        return d.nid;
    }).join(function(enter) {
        let sensors = enter.append("g").attr("class", "wave_sensor").attr("id", function(d) {
            return "sensor_" + d.nid;
        }).attr("transform", function(d) {
            return "translate(" + (0, $cb3e0081c099494f$export$33d1addef09845d7)((0, $j5Ozl.waveSensorsRefs)[d.nid].lng, (0, $j5Ozl.waveSensorsRefs)[d.nid].lat) + ")";
        });
        sensors.append("use").attr("xlink:href", function(d) {
            return d.wad ? "#wave_arrow" : "#wave_sensor_icon";
        }).attr("x", function(d) {
            return d.wad ? "-18" : "-10";
        }).attr("y", "-19").attr("width", function(d) {
            return d.wad ? "36px" : "24px";
        }).attr("height", "39px").attr("fill", "#FFFFFF").attr("transform", function(d) {
            return d.wad ? "rotate(" + d.wad + ", 0, 0)" : "";
        });
        sensors.append("g").attr("class", "wave_details").attr("transform", function(d) {
            return d.wat ? "translate(-112, -16)" : "translate(-84, -16)";
        }).append("foreignObject").attr("width", function(d) {
            return d.wat ? 95 : 88;
        }).attr("height", 36).append("xhtml:body").html(function(d) {
            return "<div class='swell_data'><div class='swell_height'><span></span><span>" + d.wah + "m</span></div>" + (d.wap ? "<div class='swell_period'><span></span><span>" + d.wap + "s</span></div>" : "") + (d.wat ? "<div class='swell_temp'><span></span><span>" + d.wat + "\xb0</span></div>" : "") + "</div>";
        });
        sensors.on("click", function(evt, d) {
            if (!(0, $gYLTL.layout).edit) {
                evt.stopPropagation();
                (0, $a512f8659cf98537$export$2e2bcd8739ae039).navigate("/" + (0, $j5Ozl.waveSensorsRefs)[d.nid].slug);
            }
        });
        sensors.on("mouseover", function(evt, d) {
            $d78f01d7851d977e$export$2e2bcd8739ae039(this).raise();
            if ($d78f01d7851d977e$export$2e2bcd8739ae039("#sensor_" + d.nid + " .sensor_name").size() === 0) $d78f01d7851d977e$export$2e2bcd8739ae039("#sensor_" + d.nid).append("text").attr("class", "sensor_name").attr("transform", "translate(-200, -16)").text((0, $j5Ozl.waveSensorsRefs)[d.nid].label);
        }).on("mouseout", function(evt, d) {
            if (!(0, $gYLTL.layout).edit) $4eee8f3e49a380ba$export$2e2bcd8739ae039(".sensor_name").remove();
            $d78f01d7851d977e$export$2e2bcd8739ae039(this).lower();
        });
        sensors.lower();
        return sensors;
    }, function(update) {
        update.select("use").attr("xlink:href", function(d) {
            return d.wad ? "#wave_arrow" : "#wave_sensor_icon";
        }).attr("x", function(d) {
            return d.wad ? "-18" : "-10";
        }).attr("y", "-19").attr("width", function(d) {
            return d.wad ? "36px" : "24px";
        }).attr("height", "39px").attr("fill", "#FFFFFF").attr("transform", function(d) {
            return d.wad ? "rotate(" + d.wad + ", 0, 0)" : "";
        });
        update.select("g foreignObject body .swell_height > span:last-child").text(function(d) {
            return `${d.wah}m`;
        });
        update.select("g foreignObject body .swell_period > span:last-child").text(function(d) {
            return `${d.wap}s`;
        });
        update.select("g foreignObject body .swell_temp > span:last-child").text(function(d) {
            return `${d.wat}\xb0`;
        });
        return update;
    });
}
function $b51085ee695c0fdd$export$6cb00ed872355909(data) {
    const spotSensors = (0, $gYLTL.layers).activeSpot?.tempSensors || [];
    console.debug("activeSpot: " + (0, $gYLTL.layers).activeSpot?.ref + " - spotSensors: " + JSON.stringify(spotSensors));
    const windActive = (0, $gYLTL.layers).dataLayers.indexOf("wind") !== -1;
    let availableSensors = data.filter(function(d) {
        return Object.keys((0, $j5Ozl.tempSensorsRefs)).indexOf(d.nid.toString()) !== -1 && (!spotSensors.length || spotSensors.indexOf(d.nid.toString()) !== -1);
    });
    (0, $gYLTL.layers).overlay.select(".zoom_wrapper").selectAll(".temp_sensor").data(availableSensors, function(d) {
        return d.nid;
    }).join(function(enter) {
        let sensors = enter.append("g").attr("class", "temp_sensor").attr("id", function(d) {
            return "sensor_" + d.nid;
        }).attr("transform", function(d) {
            return "translate(" + (0, $cb3e0081c099494f$export$33d1addef09845d7)((0, $j5Ozl.tempSensorsRefs)[d.nid].lng, (0, $j5Ozl.tempSensorsRefs)[d.nid].lat) + ")";
        });
        sensors.append("g").attr("class", "temp_details").attr("transform", function(d) {
            return windActive && (0, $j5Ozl.sensorsRefs)[d.nid] ? "translate(80, -12)" : "translate(-16, -12)";
        }).append("foreignObject").attr("width", 30).attr("height", 36).append("xhtml:body").html(function(d) {
            return "<p class='" + (d.category === "nke" ? "water_temp" : "air_temp") + "' style='background-color: " + (d.category === "nke" ? "#FFF" : (0, $j5Ozl.tempColor)(d.t)) + ";'>" + d.t + "\xb0</p>";
        });
        sensors.on("click", function(evt, d) {
            evt.stopPropagation();
            if (!(0, $gYLTL.layout).edit) {
                evt.stopPropagation();
                (0, $a512f8659cf98537$export$2e2bcd8739ae039).navigate("/" + ((0, $j5Ozl.sensorsRefs)[d.nid] ? (0, $j5Ozl.sensorsRefs)[d.nid].slug : (0, $j5Ozl.tempSensorsRefs)[d.nid].slug));
            }
        });
        sensors.on("mouseover", function(evt, d) {
            $d78f01d7851d977e$export$2e2bcd8739ae039(this).raise();
            if ($d78f01d7851d977e$export$2e2bcd8739ae039("#sensor_" + d.nid + " .sensor_name").size() === 0) $d78f01d7851d977e$export$2e2bcd8739ae039("#sensor_" + d.nid).append("text").attr("class", "sensor_name").text((0, $j5Ozl.sensorsRefs)[d.nid] ? (0, $j5Ozl.sensorsRefs)[d.nid].label : (0, $j5Ozl.tempSensorsRefs)[d.nid].label).attr("text-anchor", "middle");
        }).on("mouseout", function(evt, d) {
            if (!(0, $gYLTL.layout).edit) $4eee8f3e49a380ba$export$2e2bcd8739ae039(".sensor_name").remove();
            $d78f01d7851d977e$export$2e2bcd8739ae039(this).lower();
        });
        sensors.lower();
        return sensors;
    }, function(update) {
        // update.selectAll(".temp_details").remove();
        update.append("g").attr("class", "temp_details").attr("transform", function(d) {
            return windActive && (0, $j5Ozl.sensorsRefs)[d.nid] ? "translate(80, -12)" : "translate(-16, -12)";
        }).append("foreignObject").attr("width", 30).attr("height", 36).append("xhtml:body").html(function(d) {
            return "<p class='" + (d.category === "nke" ? "water_temp" : "air_temp") + "' style='background-color: " + (d.category === "nke" ? "#FFF" : (0, $j5Ozl.tempColor)(d.t)) + ";'>" + d.t + "\xb0</p>";
        });
        update.select("g foreignObject body .air_temp").attr("style", function(d) {
            return `background-color: ${(0, $j5Ozl.tempColor)(d.t)};`;
        }).text(function(d) {
            return `${d.t}\xb0`;
        });
        return update;
    });
}
function $b51085ee695c0fdd$export$68cdf4e2cb6fc30e() {
    (0, $gYLTL.layers).overlay.selectAll(".wind_sensor").attr("transform", function(d) {
        return "translate(" + (0, $cb3e0081c099494f$export$33d1addef09845d7)((0, $j5Ozl.sensorsRefs)[d.nid].lng, (0, $j5Ozl.sensorsRefs)[d.nid].lat) + ")";
    });
    (0, $gYLTL.layers).overlay.selectAll(".wave_sensor").attr("transform", function(d) {
        return "translate(" + (0, $cb3e0081c099494f$export$33d1addef09845d7)((0, $j5Ozl.waveSensorsRefs)[d.nid].lng, (0, $j5Ozl.waveSensorsRefs)[d.nid].lat) + ")";
    });
    (0, $gYLTL.layers).overlay.selectAll(".temp_sensor:not(.wind_sensor)").attr("transform", function(d) {
        return "translate(" + (0, $cb3e0081c099494f$export$33d1addef09845d7)((0, $j5Ozl.tempSensorsRefs)[d.nid].lng, (0, $j5Ozl.tempSensorsRefs)[d.nid].lat) + ")";
    });
    (0, $gYLTL.layers).overlay.selectAll(".weather_poi").attr("transform", function(d) {
        return "translate(" + (0, $cb3e0081c099494f$export$33d1addef09845d7)(d.lng, d.lat) + ")";
    });
    (0, $gYLTL.layers).overlay.selectAll(".amp_spot").attr("transform", function(d) {
        return "translate(" + (0, $cb3e0081c099494f$export$33d1addef09845d7)(d.geometry.coordinates[0], d.geometry.coordinates[1]) + ")";
    });
    (0, $gYLTL.layers).overlay.selectAll(".webcam_spot, .water_temp_sensor, .tide_spot").attr("transform", function(d) {
        return "translate(" + (0, $cb3e0081c099494f$export$33d1addef09845d7)(d.lng, d.lat) + ")";
    });
}
function $b51085ee695c0fdd$export$886f6367efad2401(btn, layerRef) {
    var mapContainer = document.querySelector("#map_container");
    if ((0, $gYLTL.layers).dataLayers.indexOf(layerRef) !== -1) {
        (0, $gYLTL.layers).dataLayers.splice((0, $gYLTL.layers).dataLayers.indexOf(layerRef), 1);
        $b51085ee695c0fdd$export$b9a19a7bc6beec63(layerRef);
        if (layerRef === "wind") {
            var layerInfoContainer = document.querySelector("#wind_info");
            if (layerInfoContainer) layerInfoContainer.remove();
        }
        if (layerRef === "wave_fc" && (0, $gYLTL.map).activeMap === "wm") (0, $cb3e0081c099494f$export$f0c5438bd76c55d8)(true);
        mapContainer.classList.remove(layerRef);
    } else {
        $b51085ee695c0fdd$export$2f794522d80bee9d(layerRef);
        (0, $gYLTL.layers).dataLayers.push(layerRef);
        mapContainer.classList.add(layerRef);
    }
    let btnElt = btn.classList.contains("layer_preview") ? document.querySelector(`#map_layers #${layerRef}`) : btn;
    const sideBtn = document.querySelector(`#${layerRef}_side`);
    if (layerRef === "legend") btnElt = document.querySelector("#legend");
    if (btnElt) btnElt.classList.toggle("active");
    mapContainer.classList.remove("hide_inactive");
    if (sideBtn) sideBtn.classList.toggle("active");
    (0, $gYLTL.logPageView)((0, $a512f8659cf98537$export$2e2bcd8739ae039).lastResolved(), "/map/" + layerRef, layerRef);
}
function $b51085ee695c0fdd$var$isValidAngle(sensorId, windDir) {
    let validAngle = (0, $j5Ozl.sensorsRefs)[sensorId].validAngle, dir = parseInt(windDir);
    if (validAngle && validAngle.filter((v)=>v).length > 0) {
        let fromAngle, toAngle;
        if (validAngle.length === 3) {
            fromAngle = validAngle[0];
            toAngle = validAngle[2];
        } else {
            fromAngle = validAngle[0];
            toAngle = validAngle[1];
        }
        if (fromAngle > toAngle) return dir >= fromAngle && dir <= 360 || dir >= 0 && dir <= toAngle;
        else return dir >= fromAngle && dir <= toAngle;
    }
    return true;
}
function $b51085ee695c0fdd$export$2f794522d80bee9d(layerRef) {
    console.debug("Adding layer " + layerRef);
    switch(layerRef){
        case "wind_fc":
            $b51085ee695c0fdd$export$9b75862e7acdcaad((0, $gYLTL.timeline).timelineActiveStep ? $d78f01d7851d977e$export$2e2bcd8739ae039((0, $gYLTL.timeline).timelineActiveStep).datum()[0] : null);
            break;
        case "waves_fc":
            $b51085ee695c0fdd$export$ec577891f2365dde((0, $gYLTL.timeline).timelineActiveStep ? $d78f01d7851d977e$export$2e2bcd8739ae039((0, $gYLTL.timeline).timelineActiveStep).datum()[0] : null);
            break;
        case "weather_fc":
            $b51085ee695c0fdd$export$cb0d41d287166a75((0, $gYLTL.timeline).timelineActiveStep ? $d78f01d7851d977e$export$2e2bcd8739ae039((0, $gYLTL.timeline).timelineActiveStep).datum()[0] : null);
            break;
        case "wind":
            $b51085ee695c0fdd$export$2eeb97286c6ecc12();
            break;
        case "waves":
            $b51085ee695c0fdd$export$73503ae067c61ef7();
            break;
        case "webcam":
            $b51085ee695c0fdd$export$55801adb6166106a();
            break;
        case "temp":
            $b51085ee695c0fdd$export$d2af805eac6d6eea();
            break;
        case "tide_fc":
            $b51085ee695c0fdd$export$4b28a1d7df585529();
            break;
        case "amp":
            $b51085ee695c0fdd$export$4f3be6eabe0c49e5();
            break;
        case "amp_poi":
            $b51085ee695c0fdd$export$aceb2de1ae588630();
            break;
        case "rain_fc":
            $b51085ee695c0fdd$export$ef1e4522aef11b2c((0, $gYLTL.timeline).timelineActiveStep ? $d78f01d7851d977e$export$2e2bcd8739ae039((0, $gYLTL.timeline).timelineActiveStep).datum()[0] : null);
            break;
        default:
            console.debug("Unsupported layer ref : " + layerRef);
    }
    if ((0, $gYLTL.layout).edit) setTimeout(function() {
        const layerElements = document.querySelectorAll("g.zoom_wrapper > g");
        console.debug(`adding listener to ${layerElements.length} elements`);
        for (const elt of layerElements)if (!elt.getAttribute("data-edit")) {
            elt.setAttribute("data-edit", "true");
            const nestedLink = elt.querySelector("a");
            if (nestedLink) {
                nestedLink.setAttribute("data-href", nestedLink.getAttribute("href"));
                nestedLink.removeAttribute("href");
            }
            elt.addEventListener("click", function(e) {
                e.preventDefault();
                e.stopPropagation();
                const layerItem = e.target.closest("g[data-edit]");
                if (layerItem) layerItem.classList.toggle("edit_pinned");
                if (layerItem.classList.contains("edit_pinned") && layerItem.classList.contains("weather_poi") && document.querySelectorAll(".weather_poi.edit_pinned").length === 1) layerItem.setAttribute("data-main-poi", "true");
            });
        }
    }, 1000);
}
function $b51085ee695c0fdd$export$b9a19a7bc6beec63(layerRef, displayMap = true) {
    console.debug("Removing layer " + layerRef);
    switch(layerRef){
        case "wind_fc":
            $b51085ee695c0fdd$export$9e1f78c1c35aeca4();
            if (displayMap) (0, $cb3e0081c099494f$export$7936340adedaf8bc)((0, $gYLTL.map).activeMap);
            break;
        case "waves_fc":
            $b51085ee695c0fdd$export$b6340bfc991ad04();
            if (displayMap) (0, $cb3e0081c099494f$export$7936340adedaf8bc)((0, $gYLTL.map).activeMap);
            break;
        case "weather_fc":
            $b51085ee695c0fdd$export$8cec9de7786b83d1();
            break;
        case "wind":
            $b51085ee695c0fdd$export$29c237bcbb68a918();
            break;
        case "waves":
            $b51085ee695c0fdd$export$8bc70383dd83dd6b();
            break;
        case "webcam":
            $b51085ee695c0fdd$export$d90e5afe47f108e7();
            break;
        case "temp":
            $b51085ee695c0fdd$export$5aa43213bed9fb5b();
            break;
        case "tide_fc":
            $b51085ee695c0fdd$export$d7485b22b743276a();
            break;
        case "amp":
            $b51085ee695c0fdd$export$bc7a58d94166ace9();
            break;
        case "amp_poi":
            $b51085ee695c0fdd$export$374449e81fae6fe1();
            break;
        case "rain_fc":
            $b51085ee695c0fdd$export$fabfd2d23e2cb44d(true);
            break;
        default:
            console.debug("Unsupported layer ref : " + layerRef);
    }
}



var $j5Ozl = parcelRequire("j5Ozl");
function $fb487846a357c1c2$export$59153413680588f8(timestamp) {
    // console.time('initTimeline');
    let i;
    (0, $gYLTL.timeline).timelineReference = timestamp - 345600;
    (0, $gYLTL.timeline).timelineSteps = [];
    for(i = 0; i < 1296; i++)(0, $gYLTL.timeline).timelineSteps.push([
        (0, $gYLTL.timeline).timelineReference + i * (0, $gYLTL.timeline).timelineStep,
        (0, $gYLTL.timeline).timelineReference + (i + 1) * (0, $gYLTL.timeline).timelineStep
    ]);
    return fetch(`https://private2.windmorbihan.com/mesures/history.json`).then((resp)=>resp.json()).then((jsonData)=>{
        (0, $gYLTL.data).timelineData = jsonData;
        $fb487846a357c1c2$export$9fd5139c95413d5f();
        if (!(0, $gYLTL.timeline).keyBoardSetUp) $fb487846a357c1c2$var$setUpKeyboardActions();
    // console.timeEnd('initTimeline');
    });
}
function $fb487846a357c1c2$export$9fd5139c95413d5f(skipScale = false) {
    // console.time('renderTimeline');
    $d78f01d7851d977e$export$2e2bcd8739ae039("#timeline_steps").selectAll(".tl_item").data((0, $gYLTL.timeline).timelineSteps).join("div").attr("class", function(step) {
        return "tl_item" + ((0, $gYLTL.timeline).timelineActiveStep && $d78f01d7851d977e$export$2e2bcd8739ae039((0, $gYLTL.timeline).timelineActiveStep).datum()[0] === step[0] ? " active" : "") + ((0, $gYLTL.data).timelineData[step[0]] ? " tl_obs" : "");
    }).attr("data-ts", function(step) {
        return step[0];
    }).attr("data-rt", function(step) {
        return (0, $gYLTL.data).timelineData[step[0]] ? "1" : null;
    }).attr("data-fc", function(step) {
        return step[0] % 3600 === 0 ? (0, $89c314bed017fff5$export$2e2bcd8739ae039).unix(step[0]).format("HH[h]") : null;
    }).attr("data-day", function(step) {
        return new Date(step[0] * 1000).toLocaleString().indexOf("00:00:00") !== -1 ? (0, $89c314bed017fff5$export$2e2bcd8739ae039).unix(step[0]).format("ddd DD/MM") : null;
    }).on("click", function(evt) {
        if (!(0, $gYLTL.timeline).moving) {
            const clickedTs = evt.target.getAttribute("data-ts");
            console.debug("clicked ts: " + new Date(parseInt(clickedTs) * 1000));
            $fb487846a357c1c2$var$updateTimelinePosition(clickedTs);
        }
    });
    const now = new Date().getTime() / 1000;
    $fb487846a357c1c2$export$ed92572d6df92f9d(now, false);
    if (!(0, $gYLTL.timeline).timelineSlider) // console.time('initSlider');
    $fb487846a357c1c2$export$dbad613170e715c9(now);
    if (!skipScale) $fb487846a357c1c2$export$9cc3739d965cbe89((0, $gYLTL.timeline).details, (0, $gYLTL.timeline).details);
// console.timeEnd('renderTimeline');
}
let $fb487846a357c1c2$var$debouncedSelectTimeline = (0, $5ewvA.debounce)(function(ts) {
    $fb487846a357c1c2$var$selectTsTimeline(ts);
}, 100);
function $fb487846a357c1c2$export$9cc3739d965cbe89(updateMetrics, details) {
    // console.time('scaleTimelineSlider');
    (0, $gYLTL.timeline).skipUpdate = true;
    if (updateMetrics) (0, $gYLTL.timeline).timelineSlider.updateMetrics();
    (0, $gYLTL.timeline).timelineActiveStep ||= $fb487846a357c1c2$export$83a9ef028b771fd4();
    const currentTs = parseInt((0, $gYLTL.timeline).timelineActiveStep.getAttribute("data-ts")), currentStep = $fb487846a357c1c2$var$computeStep(currentTs), xAdjustment = details && !(0, $gYLTL.layout).mobile ? 3.5 : 1;
    const xPos = details ? (currentStep + xAdjustment) * (0, $gYLTL.timeline).detailsStepWidth : (currentStep + xAdjustment) * (0, $gYLTL.timeline).stepWidth;
    (0, $gYLTL.timeline).timelineSlider.setPosition({
        x: xPos - (details ? (0, $gYLTL.timeline).detailsCursorOffset : (0, $gYLTL.timeline).cursorOffset),
        y: 0
    });
    $fb487846a357c1c2$export$ed92572d6df92f9d(currentTs, details);
    setTimeout(()=>{
        (0, $gYLTL.timeline).skipUpdate = false;
        (0, $gYLTL.timeline).details = details;
    }, 2000);
// console.timeEnd('scaleTimelineSlider');
}
function $fb487846a357c1c2$export$dbad613170e715c9(now) {
    let ts, timelineElt = document.querySelector("#timeline");
    const stepsCount = 1296.0;
    (0, $gYLTL.timeline).timelineSlider = new (0, $1cf039670900e257$export$2e2bcd8739ae039)({
        viewport: document.querySelector("#timeline_viewport"),
        content: document.querySelector("#timeline_content"),
        scrollMode: "transform",
        direction: "horizontal",
        emulateScroll: true,
        onUpdate: (state)=>{
            (0, $gYLTL.timeline).moving = (0, $gYLTL.timeline).scrolling && state.isMoving || state.dragOffset.x !== 0 && state.isMoving;
            if (!state.isMoving) (0, $gYLTL.timeline).scrolling = false;
            if (!(0, $gYLTL.timeline).skipUpdate) {
                const currentStep = Math.round((state.position.x + (0, $gYLTL.timeline).cursorOffset) / (stepsCount * ((0, $gYLTL.timeline).details ? (0, $gYLTL.timeline).detailsStepWidth : (0, $gYLTL.timeline).stepWidth)) * stepsCount) - 2;
                ts = (0, $gYLTL.timeline).timelineSteps[currentStep][1];
                if (!(0, $gYLTL.layout).edit) timelineElt.classList.remove("no_focus");
                $fb487846a357c1c2$var$debouncedSelectTimeline(ts);
            }
        },
        onWheel: ()=>{
            (0, $gYLTL.timeline).scrolling = true;
        }
    });
    document.querySelector("#weather_details").setAttribute("style", `padding-left: ${($fb487846a357c1c2$var$computeWeatherStep(now - 90000) - 2.5) * (0, $gYLTL.timeline).detailsStepWidth}px`);
}
function $fb487846a357c1c2$var$parseTimelineData(timestamp, rawData) {
    let currentTs;
    for(let nid in rawData)if (rawData.hasOwnProperty(nid)) {
        for(let ts in rawData[nid])if (rawData[nid].hasOwnProperty(ts)) {
            currentTs = timestamp + parseInt(ts);
            for (let s of (0, $gYLTL.timeline).timelineSteps)if (currentTs >= s[0] && currentTs < s[1]) {
                (0, $gYLTL.data).timelineData[s[0]] = (0, $gYLTL.data).timelineData[s[0]] || {};
                (0, $gYLTL.data).timelineData[s[0]][nid] = {
                    nid: nid,
                    ts: currentTs,
                    wind_dir_true: rawData[nid][ts]["wind_dir_true"],
                    wind_pow_knot: rawData[nid][ts]["wind_pow_knot"],
                    wind_pow_knot_max: rawData[nid][ts]["wind_pow_knot_max"]
                };
            }
        }
    }
}
function $fb487846a357c1c2$export$2b262526dbd61afc(newMeasures) {
    let i, createdAt;
    for(i = 0; i < newMeasures.length; i++){
        createdAt = parseInt(Object.keys(newMeasures[i].created)[0]);
        for (let s of (0, $gYLTL.timeline).timelineSteps)if (createdAt >= s[0] && createdAt < s[1]) {
            (0, $gYLTL.data).timelineData[s[0]] = (0, $gYLTL.data).timelineData[s[0]] || {};
            if (!(0, $gYLTL.data).timelineData[s[0]][newMeasures[i].nid]) (0, $gYLTL.data).timelineData[s[0]][newMeasures[i].nid] = {
                nid: newMeasures[i].nid,
                ts: createdAt,
                wind_dir_true: newMeasures[i]["wind_dir_true"],
                wind_pow_knot: newMeasures[i]["wind_pow_knot"],
                wind_pow_knot_max: newMeasures[i]["wind_pow_knot_max"]
            };
        }
    }
}
function $fb487846a357c1c2$var$toggleStepTimeline(elt) {
    let activeItem = document.querySelector("#timeline_steps .tl_item.active");
    if (activeItem) activeItem.classList.remove("active");
    elt.classList.add("active");
    (0, $gYLTL.timeline).timelineActiveStep = elt;
    (0, $gYLTL.timeline).timelineActiveShortStep = null;
}
function $fb487846a357c1c2$export$ed92572d6df92f9d(ts, details) {
    const hourLabel = (0, $89c314bed017fff5$export$2e2bcd8739ae039).unix(ts).format("ddd HH[h]mm").replace(".", ""), hour = parseInt(hourLabel.split("h")[0]);
    let hideDateLabel;
    (0, $gYLTL.timeline).hourLabel.innerHTML = hourLabel;
    if ((0, $gYLTL.layout).mobile) hideDateLabel = hour <= details ? 6 : 3;
    else hideDateLabel = hour <= (details ? (0, $gYLTL.timeline).hoursCountDetails : (0, $gYLTL.timeline).hoursCount);
    if (hideDateLabel) (0, $gYLTL.timeline).dateLabel.innerHTML = "";
    else (0, $gYLTL.timeline).dateLabel.innerHTML = (0, $89c314bed017fff5$export$2e2bcd8739ae039).unix(ts).format("ddd DD/MM").replace(".", "");
}
function $fb487846a357c1c2$export$17badd67dc179611(btn) {
    if (btn.classList.contains("playing") && (0, $gYLTL.timeline).timelineInterval) {
        btn.classList.remove("playing");
        btn.querySelector("i").classList.replace("fa-pause", "fa-play");
        clearInterval((0, $gYLTL.timeline).timelineInterval);
    } else {
        (0, $gYLTL.timeline).timelineActiveStep ||= $fb487846a357c1c2$export$83a9ef028b771fd4();
        (0, $gYLTL.timeline).timelineActiveShortStep = parseInt((0, $gYLTL.timeline).timelineActiveStep.getAttribute("data-ts"));
        btn.classList.add("playing");
        btn.querySelector("i").classList.replace("fa-play", "fa-pause");
        (0, $gYLTL.timeline).timelineInterval = setInterval(function() {
            (0, $gYLTL.timeline).timelineActiveShortStep += (0, $gYLTL.timeline).timelineStep / 2;
            if ((0, $gYLTL.timeline).timelineActiveShortStep % (0, $gYLTL.timeline).timelineStep !== 0 && $fb487846a357c1c2$var$isShortStep((0, $gYLTL.timeline).timelineActiveShortStep)) (0, $b51085ee695c0fdd$export$ef1e4522aef11b2c)((0, $gYLTL.timeline).timelineActiveShortStep);
            else $fb487846a357c1c2$var$updateTimelinePosition($fb487846a357c1c2$var$selectedTs() + (0, $gYLTL.timeline).timelineStep);
        }, 1200);
    }
}
function $fb487846a357c1c2$export$83a9ef028b771fd4() {
    return Array.from(document.querySelectorAll("#timeline_steps .tl_item.tl_obs")).pop() || document.querySelector("#timeline_steps .tl_item:first-child");
}
function $fb487846a357c1c2$export$c1326b26277d8d63() {
    console.debug("nextStepTimeline");
    let offset;
    (0, $gYLTL.timeline).timelineActiveShortStep ||= parseInt((0, $gYLTL.timeline).timelineActiveStep.getAttribute("data-ts"));
    if ((0, $gYLTL.timeline).timelineActiveStep.nextSibling.getAttribute("data-rt")) {
        offset = (0, $gYLTL.timeline).timelineStep;
        $fb487846a357c1c2$var$updateTimelinePosition($fb487846a357c1c2$var$selectedTs() + offset);
    } else {
        const ts = parseInt((0, $gYLTL.timeline).timelineActiveStep.getAttribute("data-ts"));
        if ($fb487846a357c1c2$var$isShortStep(ts)) {
            (0, $gYLTL.timeline).timelineActiveShortStep += (0, $gYLTL.timeline).timelineStep / 2;
            if ((0, $gYLTL.timeline).timelineActiveShortStep % (0, $gYLTL.timeline).timelineStep !== 0) (0, $b51085ee695c0fdd$export$ef1e4522aef11b2c)((0, $gYLTL.timeline).timelineActiveShortStep);
            else $fb487846a357c1c2$var$updateTimelinePosition($fb487846a357c1c2$var$selectedTs() + (0, $gYLTL.timeline).timelineStep);
        } else {
            offset = 3600 - ts % 3600;
            $fb487846a357c1c2$var$updateTimelinePosition($fb487846a357c1c2$var$selectedTs() + offset);
        }
    }
    console.debug("timeline.timelineActiveShortStep: " + new Date((0, $gYLTL.timeline).timelineActiveShortStep * 1000));
    console.debug("timeline.timelineActiveStep: " + new Date((0, $gYLTL.timeline).timelineActiveStep.getAttribute("data-ts") * 1000));
}
function $fb487846a357c1c2$export$a3b381cc74bfefd3() {
    console.debug("prevStepTimeline");
    let offset;
    if ((0, $gYLTL.timeline).timelineActiveStep.previousSibling.getAttribute("data-rt")) offset = (0, $gYLTL.timeline).timelineStep;
    else {
        const now = new Date().getTime() / 1000, ts = parseInt((0, $gYLTL.timeline).timelineActiveStep.getAttribute("data-ts"));
        if ((0, $gYLTL.layers).dataLayers.indexOf("rain_fc") !== -1 && ts - now < 3600) offset = (0, $gYLTL.timeline).timelineStep;
        else offset = 3600 - ts % 3600;
    }
    $fb487846a357c1c2$var$updateTimelinePosition($fb487846a357c1c2$var$selectedTs() - offset);
}
function $fb487846a357c1c2$export$f327a9a0705a3951() {
    const activeTs = parseInt((0, $gYLTL.timeline).timelineActiveStep.getAttribute("data-ts")), nextTs = activeTs + 86400;
    $fb487846a357c1c2$var$updateTimelinePosition(nextTs);
}
function $fb487846a357c1c2$export$3527b2367285a74c() {
    const activeTs = parseInt((0, $gYLTL.timeline).timelineActiveStep.getAttribute("data-ts")), nextTs = activeTs - 86400;
    $fb487846a357c1c2$var$updateTimelinePosition(nextTs);
}
function $fb487846a357c1c2$export$e45bb9041185a27a() {
    $fb487846a357c1c2$export$83a9ef028b771fd4().click();
}
function $fb487846a357c1c2$var$isShortStep(ts) {
    const now = new Date().getTime() / 1000;
    return (0, $gYLTL.layers).dataLayers.indexOf("rain_fc") !== -1 && Math.abs(ts - now) < 3600;
}
function $fb487846a357c1c2$var$selectedTs() {
    return $d78f01d7851d977e$export$2e2bcd8739ae039((0, $gYLTL.timeline).timelineActiveStep).datum()[0];
}
function $fb487846a357c1c2$var$selectTsTimeline(newTs) {
    // console.log('selectTsTimeline: ' + (new Date(newTs * 1000)).toString());
    const now = new Date().getTime() / 1000, newItem = document.querySelector("#timeline_steps .tl_item[data-ts='" + newTs + "']");
    if (newItem) {
        $fb487846a357c1c2$var$toggleStepTimeline(newItem);
        $fb487846a357c1c2$export$ed92572d6df92f9d(newTs, (0, $gYLTL.timeline).details);
        if (now > newTs && now - newTs < 660) {
            if ((0, $gYLTL.layers).dataLayers.indexOf("wind") !== -1) (0, $b51085ee695c0fdd$export$f80b4067547ee73)();
            if ((0, $gYLTL.layers).dataLayers.indexOf("waves") !== -1) (0, $b51085ee695c0fdd$export$9d5a23401ec8f7d)();
            if ((0, $gYLTL.layers).dataLayers.indexOf("temp") !== -1) (0, $b51085ee695c0fdd$export$d24539e194e73733)();
        } else {
            if ((0, $gYLTL.layers).dataLayers.indexOf("wind") !== -1) (0, $b51085ee695c0fdd$export$e72c2db76561db73)(Object.values((0, $gYLTL.data).timelineData[newTs] || {}));
            let lastWavesMeasureTs = newTs - newTs % 1800, now = new Date().getTime() / 1000;
            if (now - lastWavesMeasureTs < 1800) lastWavesMeasureTs = lastWavesMeasureTs - 1800;
            if ((0, $gYLTL.layers).dataLayers.indexOf("waves") !== -1) (0, $b51085ee695c0fdd$export$7c21e768f6379ae)(Object.values((0, $gYLTL.data).timelineData[lastWavesMeasureTs] || {}));
            if ((0, $gYLTL.layers).dataLayers.indexOf("temp") !== -1) (0, $b51085ee695c0fdd$export$6cb00ed872355909)(Object.values((0, $gYLTL.data).timelineData[newTs] || {}));
        }
        $fb487846a357c1c2$export$40548a160ab2d315();
        let isFuture = !newItem.classList.contains("tl_obs");
        if (isFuture && (0, $gYLTL.layers).dataLayers.indexOf("waves_fc") === -1 && (0, $gYLTL.layers).dataLayers.indexOf("rain_fc") === -1) {
            if ((0, $gYLTL.layers).dataLayers.indexOf("wind_fc") === -1) wm.toggleLayer(document.querySelector("#wind_fc"), "wind_fc");
        }
    }
    return newItem;
}
function $fb487846a357c1c2$export$40548a160ab2d315() {
    let ts = null, hourTs = null, rendered = document.querySelector("#map_container").classList.contains("rendered");
    if ((0, $gYLTL.timeline).timelineActiveStep) {
        ts = parseInt((0, $gYLTL.timeline).timelineActiveStep.getAttribute("data-ts"));
        hourTs = (0, $gYLTL.timeline).timelineActiveStep.getAttribute("data-fc") ? ts : ts - ts % 3600;
    }
    if ((0, $gYLTL.layers).dataLayers.indexOf("wind_fc") !== -1) {
        if ((0, $gYLTL.map).windLayer) (0, $gYLTL.map).windLayer.stop();
        (0, $b51085ee695c0fdd$export$9b75862e7acdcaad)(hourTs).then(function() {
            if ((0, $gYLTL.map).currentFocus && (0, $j5Ozl.config).popup) (0, $b51085ee695c0fdd$export$53d225340945d25c)((0, $j5Ozl.config).popup, (0, $gYLTL.map).currentFocus.lat, (0, $gYLTL.map).currentFocus.lng);
        });
    }
    if ((0, $gYLTL.layers).dataLayers.indexOf("waves_fc") !== -1) (0, $b51085ee695c0fdd$export$ec577891f2365dde)(hourTs).then(function() {
        if ((0, $gYLTL.map).currentFocus && (0, $j5Ozl.config).popup) (0, $b51085ee695c0fdd$export$53d225340945d25c)((0, $j5Ozl.config).popup, (0, $gYLTL.map).currentFocus.lat, (0, $gYLTL.map).currentFocus.lng);
    });
    if ((0, $gYLTL.layers).dataLayers.indexOf("weather_fc") !== -1) (0, $b51085ee695c0fdd$export$cb0d41d287166a75)(hourTs);
    if ((0, $gYLTL.layers).dataLayers.indexOf("rain_fc") !== -1) (0, $b51085ee695c0fdd$export$ef1e4522aef11b2c)(ts);
}
function $fb487846a357c1c2$var$setUpKeyboardActions() {
    window.addEventListener("keydown", function(e) {
        const activeModal = document.querySelector(".modal.is-open"), editMode = document.querySelector("#edit_spot_controls:not(.hidden)");
        if (!activeModal && !editMode) switch(e.code){
            case "ArrowLeft":
                e.stopPropagation();
                e.preventDefault();
                $fb487846a357c1c2$export$a3b381cc74bfefd3();
                break;
            case "ArrowRight":
                e.stopPropagation();
                e.preventDefault();
                $fb487846a357c1c2$export$c1326b26277d8d63();
                break;
            case "Escape":
                $fb487846a357c1c2$export$e45bb9041185a27a();
                break;
            case "Space":
                e.stopPropagation();
                e.preventDefault();
                $fb487846a357c1c2$export$17badd67dc179611(document.querySelector("#timeline_commands #tl_play"));
                break;
            default:
        }
    }, true);
    (0, $gYLTL.timeline).keyBoardSetUp = true;
}
function $fb487846a357c1c2$var$updateTimelinePosition(newVal) {
    const newStep = $fb487846a357c1c2$var$computeStep(newVal), xAdjustment = (0, $gYLTL.timeline).details && !(0, $gYLTL.layout).mobile ? 4 : 1;
    const xPos = (0, $gYLTL.timeline).details ? (newStep + xAdjustment) * (0, $gYLTL.timeline).detailsStepWidth : (newStep + xAdjustment) * (0, $gYLTL.timeline).stepWidth;
    // timeline.timelineSlider.scrollTo({x: xPos - (timeline.details ? timeline.detailsCursorOffset : timeline.cursorOffset), y: 0});
    (0, $gYLTL.timeline).timelineSlider.setPosition({
        x: xPos - ((0, $gYLTL.timeline).details ? (0, $gYLTL.timeline).detailsCursorOffset : (0, $gYLTL.timeline).cursorOffset),
        y: 0
    });
}
function $fb487846a357c1c2$var$computeStep(ts) {
    return (0, $gYLTL.timeline).timelineSteps.findIndex((s)=>s[0] <= ts && s[1] > ts);
}
function $fb487846a357c1c2$var$computeWeatherStep(ts) {
    let prevHour = ts - ts % 3600;
    return $fb487846a357c1c2$var$computeStep(prevHour);
}






var $gYLTL = parcelRequire("gYLTL");

var $j5Ozl = parcelRequire("j5Ozl");


var $dnPBs = parcelRequire("dnPBs");



// import * as Sentry from "@sentry/browser";
// import {Integrations} from "@sentry/tracing";
// Sentry.init({
//   dsn: "https://226f2354cdc842db97ac896999739be9@o21346.ingest.sentry.io/5807697",
//   integrations: [new Integrations.BrowserTracing()],
//   tracesSampleRate: 0.5
// });
(0, $89c314bed017fff5$export$2e2bcd8739ae039).locale("fr");
// console.timeLog('trace', 'main.js start');
document.addEventListener("DOMContentLoaded", function(evt) {
    // document.querySelector("#toggle_map_menu").addEventListener("click", function(evt) {
    //   toggleMapNav();
    // });
    // console.time('initSlides');
    (0, $gYLTL.initSlides)(function() {
        // console.timeLog('initSlides', 'p1')
        (0, $gYLTL.createSlides)((0, $j5Ozl.advertisersRefs), "partners");
        // console.timeLog('initSlides', 'p2')
        (0, $gYLTL.sliderDisplay)("partners");
        // console.timeEnd('initSlides');
        $a3e8504aca44d495$var$loadMenuLinks();
    });
    window.wm = {
        toggleLayer: $b51085ee695c0fdd$export$886f6367efad2401,
        toggleMap: $cb3e0081c099494f$export$720449d359f5eb20,
        toggleSideNav: $a3e8504aca44d495$var$toggleSideNav,
        toggleAccountSpots: $904ba957439cb654$export$88a0cf2a781036f4,
        displayWindFranceForm: $gYLTL.displayWindFranceForm,
        showSpot: $904ba957439cb654$export$28a81b7dca2195d2,
        configureSpots: $904ba957439cb654$export$214a8c2dc2483e31,
        configureSpot: $904ba957439cb654$export$fe0f878e056a2558,
        configureDemoSpot: $904ba957439cb654$export$8d0ede5d4e5abc56,
        saveCurrentSpot: $904ba957439cb654$export$9da0aee0111de573,
        cancelEditSpot: $904ba957439cb654$export$9a2e0453dc446366,
        showSpotsTemplates: $904ba957439cb654$export$8a2289091bacd0a2,
        toggleSpotTemplate: $904ba957439cb654$export$a2aa5000ac9238e0,
        applySpotTemplate: $904ba957439cb654$export$43e0afad5800723b,
        createAccount: $904ba957439cb654$export$6f5378aa3397b877,
        createMockAccount: $904ba957439cb654$export$8449a7e210b4502a,
        dismissAccountCreation: $904ba957439cb654$export$4db896465f11c081,
        mockSignIn: $904ba957439cb654$export$e2d809643f42c341,
        createWindSession: $904ba957439cb654$export$9615a332827b5ee,
        resetPassword: $904ba957439cb654$export$dc726c8e334dd814,
        submitPasswordReset: $904ba957439cb654$export$4166b4b285bc9ec4,
        validateUserProfile: $904ba957439cb654$export$dd347fd6d8a2a2d8,
        startSpotsTour: $904ba957439cb654$export$f2461f6207ae9479,
        isSpotContext: $gYLTL.isSpotContext,
        isEditMode: $gYLTL.isEditMode,
        openTab: $a3e8504aca44d495$var$openTab,
        geolocateMe: $b51085ee695c0fdd$export$2a22cb1184287a3d,
        prevTimeline: $fb487846a357c1c2$export$3527b2367285a74c,
        prevStepTimeline: $fb487846a357c1c2$export$a3b381cc74bfefd3,
        nextTimeline: $fb487846a357c1c2$export$f327a9a0705a3951,
        nextStepTimeline: $fb487846a357c1c2$export$c1326b26277d8d63,
        toggleTimeline: $fb487846a357c1c2$export$17badd67dc179611,
        refreshTimeline: $fb487846a357c1c2$export$e45bb9041185a27a,
        toggleLines: $a3e8504aca44d495$var$toggleLines,
        displaySensorCharts: $418aca01110c9e5e$export$af377084b1bb65fd,
        refreshWindSensorsData: $b51085ee695c0fdd$export$f80b4067547ee73,
        setFavorite: $145480a03a16151b$export$1ed640048cefe91a,
        goToFavorite: $a3e8504aca44d495$var$goToFavorite,
        closePoi: $145480a03a16151b$export$b678dbcde018e0b2,
        displayNews: $gYLTL.displayNews,
        toggleMotivations: $a3e8504aca44d495$var$toggleMotivations,
        displaySignInForm: $a3e8504aca44d495$var$displaySignInForm,
        displaySignUpForm: $a3e8504aca44d495$var$displaySignUpForm,
        showModal: $a3e8504aca44d495$var$showModal,
        dismissModal: $a3e8504aca44d495$var$dismissModal,
        webcamDetails: $b51085ee695c0fdd$export$3d0a3aba327d4829,
        dumpCurrentSpot: $a3e8504aca44d495$var$dumpCurrentSpot,
        scrollToElement: $a3e8504aca44d495$var$scrollToElement
    };
});
var $a3e8504aca44d495$var$windowResized = (0, $5ewvA.debounce)(function() {
    window.location.reload();
}, 800);
// window.onresize = windowResized;
function $a3e8504aca44d495$var$toggleSideNav(btn, forceClose) {
    if (forceClose) btn.classList.remove("active");
    else btn.classList.toggle("active");
}
function $a3e8504aca44d495$var$openTab(btn) {
    document.querySelector("#side_tabs .active").classList.remove("active");
    btn.classList.add("active");
    btn.parentElement.setAttribute("data-active", btn.getAttribute("data-tab"));
}
function $a3e8504aca44d495$var$loadMenuLinks() {
    const tld = window.location.hostname.split(".").slice(-2, -1)[0] || "localhost";
    (0, $5ewvA.getAsync)(`${(0, $j5Ozl.config).backEndUrl}/menus/${tld}.json`, function(menus) {
        let menuLinksWrapper, menuHtml, menuContent;
        for(const m in menus){
            menuLinksWrapper = document.querySelector(`#side_menu [data-links='${m}']`);
            menuContent = menus[m];
            if (menuLinksWrapper && menuContent.links_by_section) {
                menuHtml = "<div>";
                for(const s in menuContent.links_by_section){
                    menuHtml += `<h3>${s}</h3>`;
                    for (const l of menuContent.links_by_section[s])menuHtml += `<a href="${l.link_url}" target="_blank"><img alt="${l.title}" class="image-thumbnail" src="${l.image_url}"><span>${l.title}</span></a>`;
                }
                menuHtml += "</div>";
                menuLinksWrapper.innerHTML = menuHtml;
            }
        }
    });
}
function $a3e8504aca44d495$var$toggleLines(btn, ...cls) {
    let c, line;
    for (c of cls){
        let lines = Array.from(document.querySelectorAll("#weather_details_header ." + c + ", #weather_details ." + c));
        for (line of lines)if (line.style.display === "none") line.style.display = "flex";
        else line.style.display = "none";
    }
    btn.classList.toggle("active");
}
function $a3e8504aca44d495$var$favoriteDetails() {
    (0, $145480a03a16151b$export$535890a1dbf69608)();
    document.querySelector("#map_modal").setAttribute("data-modal", "favorite");
    document.querySelector("#map_modal_title").innerHTML = "D\xe9finir son plan d\u2019eau favori";
    document.querySelector("#header_links").innerHTML = '<button class="modal__close" aria-label="Fermer" data-micromodal-close></button>';
    document.querySelector("#map_modal_content").innerHTML = '<div>Cliquez sur le pictogramme m\xe9t\xe9o <img class="img-icon" src="' + (0, (/*@__PURE__*/$parcel$interopDefault($7636ed459e8205ef$exports)))["soleil"] + '" alt="Soleil">  de votre choix. Puis cliquez sur le bouton \xab D\xe9finir comme favori \xbb</div>';
    (0, $dnPBs.default).show("map_modal", {
        disableScroll: true,
        onClose: ()=>{
            console.debug("favoriteDetails");
            (0, $a512f8659cf98537$export$2e2bcd8739ae039).navigate("/");
        }
    });
}
function $a3e8504aca44d495$var$goToFavorite() {
    const path = (0, $j5Ozl.config).favoritePath;
    if (path) (0, $a512f8659cf98537$export$2e2bcd8739ae039).navigate(path);
    else {
        var menuBtn = document.querySelector("#weather_fc");
        if (!menuBtn.classList.contains("active")) wm.toggleLayer(menuBtn, "weather_fc");
        $a3e8504aca44d495$var$favoriteDetails();
    }
    $a3e8504aca44d495$var$toggleSideNav(document.querySelector("#toggle_side_menu"), true);
}
function $a3e8504aca44d495$var$toggleMotivations(elt) {
    elt.parentElement.classList.toggle("expanded");
    $a3e8504aca44d495$var$scrollToElement("#motivation_wrapper");
}
function $a3e8504aca44d495$var$displaySignUpForm(btn) {
    if (btn.parentElement.querySelector("button.active")) btn.parentElement.querySelector("button.active").classList.remove("active");
    btn.classList.add("active");
    document.querySelector("h3.motivation_toggle").classList.remove("expanded");
    document.querySelector("#wm_sign_up_form").classList.remove("hidden");
    document.querySelector("#wm_sign_in_form").classList.add("hidden");
    (0, $904ba957439cb654$export$dd347fd6d8a2a2d8)();
    $a3e8504aca44d495$var$scrollToElement("#wm_sign_up_form");
}
function $a3e8504aca44d495$var$displaySignInForm(btn) {
    if (btn.parentElement.querySelector("button.active")) btn.parentElement.querySelector("button.active").classList.remove("active");
    btn.classList.add("active");
    document.querySelector("h3.motivation_toggle").classList.remove("expanded");
    document.querySelector("#wm_sign_up_form").classList.add("hidden");
    document.querySelector("#wm_sign_in_form").classList.remove("hidden");
    $a3e8504aca44d495$var$scrollToElement("#wm_sign_in_form");
}
function $a3e8504aca44d495$var$showModal(modalId) {
    (0, $dnPBs.default).show(modalId, {
        disableScroll: true
    });
}
function $a3e8504aca44d495$var$dismissModal(modalId) {
    (0, $dnPBs.default).close(modalId);
}
function $a3e8504aca44d495$var$dumpCurrentSpot() {
    console.debug("Spot courant : \n\n" + JSON.stringify((0, $gYLTL.currentActiveSpot)()));
}
function $a3e8504aca44d495$var$scrollToElement(selector) {
    let elt = document.querySelector(selector);
    if (elt) elt.scrollIntoView({
        block: "start",
        inline: "nearest",
        behavior: "smooth"
    });
} // console.timeLog('trace', 'fin main.js');

})();
//# sourceMappingURL=index.f4f8400b.js.map
